function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire90b3"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire90b3"] = parcelRequire;
}
parcelRequire.register("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRequire.register("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRequire.register("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRequire.register("kjyEk", function(module, exports) {
"use strict";

});

parcelRequire.register("jevmL", function(module, exports) {
/* ***** BEGIN LICENSE BLOCK *****
 * Distributed under the BSD license:
 *
 * Copyright (c) 2010, Ajax.org B.V.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *     * Redistributions of source code must retain the above copyright
 *       notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above copyright
 *       notice, this list of conditions and the following disclaimer in the
 *       documentation and/or other materials provided with the distribution.
 *     * Neither the name of Ajax.org B.V. nor the
 *       names of its contributors may be used to endorse or promote products
 *       derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * ***** END LICENSE BLOCK ***** */ /**
 * Define a module along with a payload
 * @param module a name for the payload
 * @param payload a function to call with (require, exports, module) params
 */ (function() {
    var ACE_NAMESPACE = "ace";
    var global = function() {
        return this;
    }();
    if (!global && typeof window != "undefined") global = window; // strict mode
    if (!ACE_NAMESPACE && typeof requirejs !== "undefined") return;
    var define1 = function(module1, deps, payload) {
        if (typeof module1 !== "string") {
            if (define1.original) define1.original.apply(this, arguments);
            else {
                console.error("dropping module because define wasn't a string.");
                console.trace();
            }
            return;
        }
        if (arguments.length == 2) payload = deps;
        if (!define1.modules[module1]) {
            define1.payloads[module1] = payload;
            define1.modules[module1] = null;
        }
    };
    define1.modules = {};
    define1.payloads = {};
    /**
 * Get at functionality define()ed using the function above
 */ var _require = function(parentId, module1, callback) {
        if (typeof module1 === "string") {
            var payload = lookup(parentId, module1);
            if (payload != undefined) {
                callback && callback();
                return payload;
            }
        } else if (Object.prototype.toString.call(module1) === "[object Array]") {
            var params = [];
            for(var i = 0, l = module1.length; i < l; ++i){
                var dep = lookup(parentId, module1[i]);
                if (dep == undefined && require.original) return;
                params.push(dep);
            }
            return callback && callback.apply(null, params) || true;
        }
    };
    var require = function(module1, callback) {
        var packagedModule = _require("", module1, callback);
        if (packagedModule == undefined && require.original) return require.original.apply(this, arguments);
        return packagedModule;
    };
    var normalizeModule = function(parentId, moduleName) {
        // normalize plugin requires
        if (moduleName.indexOf("!") !== -1) {
            var chunks = moduleName.split("!");
            return normalizeModule(parentId, chunks[0]) + "!" + normalizeModule(parentId, chunks[1]);
        }
        // normalize relative requires
        if (moduleName.charAt(0) == ".") {
            var base = parentId.split("/").slice(0, -1).join("/");
            moduleName = base + "/" + moduleName;
            while(moduleName.indexOf(".") !== -1 && previous != moduleName){
                var previous = moduleName;
                moduleName = moduleName.replace(/\/\.\//, "/").replace(/[^\/]+\/\.\.\//, "");
            }
        }
        return moduleName;
    };
    /**
 * Internal function to lookup moduleNames and resolve them by calling the
 * definition function if needed.
 */ var lookup = function(parentId, moduleName) {
        moduleName = normalizeModule(parentId, moduleName);
        var module1 = define1.modules[moduleName];
        if (!module1) {
            module1 = define1.payloads[moduleName];
            if (typeof module1 === "function") {
                var exports = {};
                var mod = {
                    id: moduleName,
                    uri: "",
                    exports: exports,
                    packaged: true
                };
                var req = function(module1, callback) {
                    return _require(moduleName, module1, callback);
                };
                var returnValue = module1(req, exports, mod);
                exports = returnValue || mod.exports;
                define1.modules[moduleName] = exports;
                delete define1.payloads[moduleName];
            }
            module1 = define1.modules[moduleName] = exports || module1;
        }
        return module1;
    };
    function exportAce(ns) {
        var root = global;
        if (ns) {
            if (!global[ns]) global[ns] = {};
            root = global[ns];
        }
        if (!root.define || !root.define.packaged) {
            define1.original = root.define;
            root.define = define1;
            root.define.packaged = true;
        }
        if (!root.require || !root.require.packaged) {
            require.original = root.require;
            root.require = require;
            root.require.packaged = true;
        }
    }
    exportAce(ACE_NAMESPACE);
})();
ace.define("ace/lib/es6-shim", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    function defineProp(obj, name, val) {
        Object.defineProperty(obj, name, {
            value: val,
            enumerable: false,
            writable: true,
            configurable: true
        });
    }
    if (!String.prototype.startsWith) defineProp(String.prototype, "startsWith", function(searchString, position) {
        position = position || 0;
        return this.lastIndexOf(searchString, position) === position;
    });
    if (!String.prototype.endsWith) defineProp(String.prototype, "endsWith", function(searchString, position) {
        var subjectString = this;
        if (position === undefined || position > subjectString.length) position = subjectString.length;
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    });
    if (!String.prototype.repeat) defineProp(String.prototype, "repeat", function(count) {
        var result = "";
        var string = this;
        while(count > 0){
            if (count & 1) result += string;
            if (count >>= 1) string += string;
        }
        return result;
    });
    if (!String.prototype.includes) defineProp(String.prototype, "includes", function(str, position) {
        return this.indexOf(str, position) != -1;
    });
    if (!Object.assign) Object.assign = function(target) {
        if (target === undefined || target === null) throw new TypeError("Cannot convert undefined or null to object");
        var output = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var source = arguments[index];
            if (source !== undefined && source !== null) Object.keys(source).forEach(function(key) {
                output[key] = source[key];
            });
        }
        return output;
    };
    if (!Object.values) Object.values = function(o) {
        return Object.keys(o).map(function(k) {
            return o[k];
        });
    };
    if (!Array.prototype.find) defineProp(Array.prototype, "find", function(predicate) {
        var len = this.length;
        var thisArg = arguments[1];
        for(var k = 0; k < len; k++){
            var kValue = this[k];
            if (predicate.call(thisArg, kValue, k, this)) return kValue;
        }
    });
    if (!Array.prototype.findIndex) defineProp(Array.prototype, "findIndex", function(predicate) {
        var len = this.length;
        var thisArg = arguments[1];
        for(var k = 0; k < len; k++){
            var kValue = this[k];
            if (predicate.call(thisArg, kValue, k, this)) return k;
        }
    });
    if (!Array.prototype.includes) defineProp(Array.prototype, "includes", function(item, position) {
        return this.indexOf(item, position) != -1;
    });
    if (!Array.prototype.fill) defineProp(Array.prototype, "fill", function(value) {
        var O = this;
        var len = O.length >>> 0;
        var start = arguments[1];
        var relativeStart = start >> 0;
        var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);
        var end = arguments[2];
        var relativeEnd = end === undefined ? len : end >> 0;
        var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);
        while(k < final){
            O[k] = value;
            k++;
        }
        return O;
    });
    if (!Array.of) defineProp(Array, "of", function() {
        return Array.prototype.slice.call(arguments);
    });
});
ace.define("ace/lib/fixoldbrowsers", [
    "require",
    "exports",
    "module",
    "ace/lib/es6-shim"
], function(require, exports, module1) {
    "use strict";
    require("./es6-shim");
});
ace.define("ace/lib/lang", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    exports.last = function(a) {
        return a[a.length - 1];
    };
    exports.stringReverse = function(string) {
        return string.split("").reverse().join("");
    };
    exports.stringRepeat = function(string, count) {
        var result = "";
        while(count > 0){
            if (count & 1) result += string;
            if (count >>= 1) string += string;
        }
        return result;
    };
    var trimBeginRegexp = /^\s\s*/;
    var trimEndRegexp = /\s\s*$/;
    exports.stringTrimLeft = function(string) {
        return string.replace(trimBeginRegexp, "");
    };
    exports.stringTrimRight = function(string) {
        return string.replace(trimEndRegexp, "");
    };
    exports.copyObject = function(obj) {
        var copy = {};
        for(var key in obj)copy[key] = obj[key];
        return copy;
    };
    exports.copyArray = function(array) {
        var copy = [];
        for(var i = 0, l = array.length; i < l; i++)if (array[i] && typeof array[i] == "object") copy[i] = this.copyObject(array[i]);
        else copy[i] = array[i];
        return copy;
    };
    exports.deepCopy = function deepCopy(obj) {
        if (typeof obj !== "object" || !obj) return obj;
        var copy;
        if (Array.isArray(obj)) {
            copy = [];
            for(var key = 0; key < obj.length; key++)copy[key] = deepCopy(obj[key]);
            return copy;
        }
        if (Object.prototype.toString.call(obj) !== "[object Object]") return obj;
        copy = {};
        for(var key in obj)copy[key] = deepCopy(obj[key]);
        return copy;
    };
    exports.arrayToMap = function(arr) {
        var map = {};
        for(var i = 0; i < arr.length; i++)map[arr[i]] = 1;
        return map;
    };
    exports.createMap = function(props) {
        var map = Object.create(null);
        for(var i in props)map[i] = props[i];
        return map;
    };
    exports.arrayRemove = function(array, value) {
        for(var i = 0; i <= array.length; i++)if (value === array[i]) array.splice(i, 1);
    };
    exports.escapeRegExp = function(str) {
        return str.replace(/([.*+?^${}()|[\]\/\\])/g, "\\$1");
    };
    exports.escapeHTML = function(str) {
        return ("" + str).replace(/&/g, "&#38;").replace(/"/g, "&#34;").replace(/'/g, "&#39;").replace(/</g, "&#60;");
    };
    exports.getMatchOffsets = function(string, regExp) {
        var matches = [];
        string.replace(regExp, function(str) {
            matches.push({
                offset: arguments[arguments.length - 2],
                length: str.length
            });
        });
        return matches;
    };
    exports.deferredCall = function(fcn) {
        var timer = null;
        var callback = function() {
            timer = null;
            fcn();
        };
        var deferred = function(timeout) {
            deferred.cancel();
            timer = setTimeout(callback, timeout || 0);
            return deferred;
        };
        deferred.schedule = deferred;
        deferred.call = function() {
            this.cancel();
            fcn();
            return deferred;
        };
        deferred.cancel = function() {
            clearTimeout(timer);
            timer = null;
            return deferred;
        };
        deferred.isPending = function() {
            return timer;
        };
        return deferred;
    };
    exports.delayedCall = function(fcn, defaultTimeout) {
        var timer = null;
        var callback = function() {
            timer = null;
            fcn();
        };
        var _self = function(timeout) {
            if (timer == null) timer = setTimeout(callback, timeout || defaultTimeout);
        };
        _self.delay = function(timeout) {
            timer && clearTimeout(timer);
            timer = setTimeout(callback, timeout || defaultTimeout);
        };
        _self.schedule = _self;
        _self.call = function() {
            this.cancel();
            fcn();
        };
        _self.cancel = function() {
            timer && clearTimeout(timer);
            timer = null;
        };
        _self.isPending = function() {
            return timer;
        };
        return _self;
    };
    exports.supportsLookbehind = function() {
        try {
            new RegExp("(?<=.)");
        } catch (e) {
            return false;
        }
        return true;
    };
    exports.supportsUnicodeFlag = function() {
        try {
            new RegExp("^.$", "u");
        } catch (error) {
            return false;
        }
        return true;
    };
});
ace.define("ace/lib/useragent", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    exports.OS = {
        LINUX: "LINUX",
        MAC: "MAC",
        WINDOWS: "WINDOWS"
    };
    exports.getOS = function() {
        if (exports.isMac) return exports.OS.MAC;
        else if (exports.isLinux) return exports.OS.LINUX;
        else return exports.OS.WINDOWS;
    };
    var _navigator = typeof navigator == "object" ? navigator : {};
    var os = (/mac|win|linux/i.exec(_navigator.platform) || [
        "other"
    ])[0].toLowerCase();
    var ua = _navigator.userAgent || "";
    var appName = _navigator.appName || "";
    exports.isWin = os == "win";
    exports.isMac = os == "mac";
    exports.isLinux = os == "linux";
    exports.isIE = appName == "Microsoft Internet Explorer" || appName.indexOf("MSAppHost") >= 0 ? parseFloat((ua.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]) : parseFloat((ua.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/) || [])[1]); // for ie
    exports.isOldIE = exports.isIE && exports.isIE < 9;
    exports.isGecko = exports.isMozilla = ua.match(/ Gecko\/\d+/);
    exports.isOpera = typeof opera == "object" && Object.prototype.toString.call(window.opera) == "[object Opera]";
    exports.isWebKit = parseFloat(ua.split("WebKit/")[1]) || undefined;
    exports.isChrome = parseFloat(ua.split(" Chrome/")[1]) || undefined;
    exports.isEdge = parseFloat(ua.split(" Edge/")[1]) || undefined;
    exports.isAIR = ua.indexOf("AdobeAIR") >= 0;
    exports.isAndroid = ua.indexOf("Android") >= 0;
    exports.isChromeOS = ua.indexOf(" CrOS ") >= 0;
    exports.isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    if (exports.isIOS) exports.isMac = true;
    exports.isMobile = exports.isIOS || exports.isAndroid;
});
ace.define("ace/lib/dom", [
    "require",
    "exports",
    "module",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var useragent = require("./useragent");
    var XHTML_NS = "http://www.w3.org/1999/xhtml";
    exports.buildDom = function buildDom(arr, parent, refs) {
        if (typeof arr == "string" && arr) {
            var txt = document.createTextNode(arr);
            if (parent) parent.appendChild(txt);
            return txt;
        }
        if (!Array.isArray(arr)) {
            if (arr && arr.appendChild && parent) parent.appendChild(arr);
            return arr;
        }
        if (typeof arr[0] != "string" || !arr[0]) {
            var els = [];
            for(var i = 0; i < arr.length; i++){
                var ch = buildDom(arr[i], parent, refs);
                ch && els.push(ch);
            }
            return els;
        }
        var el = document.createElement(arr[0]);
        var options = arr[1];
        var childIndex = 1;
        if (options && typeof options == "object" && !Array.isArray(options)) childIndex = 2;
        for(var i = childIndex; i < arr.length; i++)buildDom(arr[i], el, refs);
        if (childIndex == 2) Object.keys(options).forEach(function(n) {
            var val = options[n];
            if (n === "class") el.className = Array.isArray(val) ? val.join(" ") : val;
            else if (typeof val == "function" || n == "value" || n[0] == "$") el[n] = val;
            else if (n === "ref") {
                if (refs) refs[val] = el;
            } else if (n === "style") {
                if (typeof val == "string") el.style.cssText = val;
            } else if (val != null) el.setAttribute(n, val);
        });
        if (parent) parent.appendChild(el);
        return el;
    };
    exports.getDocumentHead = function(doc) {
        if (!doc) doc = document;
        return doc.head || doc.getElementsByTagName("head")[0] || doc.documentElement;
    };
    exports.createElement = function(tag, ns) {
        return document.createElementNS ? document.createElementNS(ns || XHTML_NS, tag) : document.createElement(tag);
    };
    exports.removeChildren = function(element) {
        element.innerHTML = "";
    };
    exports.createTextNode = function(textContent, element) {
        var doc = element ? element.ownerDocument : document;
        return doc.createTextNode(textContent);
    };
    exports.createFragment = function(element) {
        var doc = element ? element.ownerDocument : document;
        return doc.createDocumentFragment();
    };
    exports.hasCssClass = function(el, name) {
        var classes = (el.className + "").split(/\s+/g);
        return classes.indexOf(name) !== -1;
    };
    exports.addCssClass = function(el, name) {
        if (!exports.hasCssClass(el, name)) el.className += " " + name;
    };
    exports.removeCssClass = function(el, name) {
        var classes = el.className.split(/\s+/g);
        while(true){
            var index = classes.indexOf(name);
            if (index == -1) break;
            classes.splice(index, 1);
        }
        el.className = classes.join(" ");
    };
    exports.toggleCssClass = function(el, name) {
        var classes = el.className.split(/\s+/g), add = true;
        while(true){
            var index = classes.indexOf(name);
            if (index == -1) break;
            add = false;
            classes.splice(index, 1);
        }
        if (add) classes.push(name);
        el.className = classes.join(" ");
        return add;
    };
    exports.setCssClass = function(node, className, include) {
        if (include) exports.addCssClass(node, className);
        else exports.removeCssClass(node, className);
    };
    exports.hasCssString = function(id, doc) {
        var index = 0, sheets;
        doc = doc || document;
        if (sheets = doc.querySelectorAll("style")) while(index < sheets.length){
            if (sheets[index++].id === id) return true;
        }
    };
    exports.removeElementById = function(id, doc) {
        doc = doc || document;
        if (doc.getElementById(id)) doc.getElementById(id).remove();
    };
    var strictCSP;
    var cssCache = [];
    exports.useStrictCSP = function(value) {
        strictCSP = value;
        if (value == false) insertPendingStyles();
        else if (!cssCache) cssCache = [];
    };
    function insertPendingStyles() {
        var cache = cssCache;
        cssCache = null;
        cache && cache.forEach(function(item) {
            importCssString(item[0], item[1]);
        });
    }
    function importCssString(cssText, id, target) {
        if (typeof document == "undefined") return;
        if (cssCache) {
            if (target) insertPendingStyles();
            else if (target === false) return cssCache.push([
                cssText,
                id
            ]);
        }
        if (strictCSP) return;
        var container = target;
        if (!target || !target.getRootNode) container = document;
        else {
            container = target.getRootNode();
            if (!container || container == target) container = document;
        }
        var doc = container.ownerDocument || container;
        if (id && exports.hasCssString(id, container)) return null;
        if (id) cssText += "\n/*# sourceURL=ace/css/" + id + " */";
        var style = exports.createElement("style");
        style.appendChild(doc.createTextNode(cssText));
        if (id) style.id = id;
        if (container == doc) container = exports.getDocumentHead(doc);
        container.insertBefore(style, container.firstChild);
    }
    exports.importCssString = importCssString;
    exports.importCssStylsheet = function(uri, doc) {
        exports.buildDom([
            "link",
            {
                rel: "stylesheet",
                href: uri
            }
        ], exports.getDocumentHead(doc));
    };
    exports.scrollbarWidth = function(doc) {
        var inner = exports.createElement("ace_inner");
        inner.style.width = "100%";
        inner.style.minWidth = "0px";
        inner.style.height = "200px";
        inner.style.display = "block";
        var outer = exports.createElement("ace_outer");
        var style = outer.style;
        style.position = "absolute";
        style.left = "-10000px";
        style.overflow = "hidden";
        style.width = "200px";
        style.minWidth = "0px";
        style.height = "150px";
        style.display = "block";
        outer.appendChild(inner);
        var body = doc && doc.documentElement || document && document.documentElement;
        if (!body) return 0;
        body.appendChild(outer);
        var noScrollbar = inner.offsetWidth;
        style.overflow = "scroll";
        var withScrollbar = inner.offsetWidth;
        if (noScrollbar === withScrollbar) withScrollbar = outer.clientWidth;
        body.removeChild(outer);
        return noScrollbar - withScrollbar;
    };
    exports.computedStyle = function(element, style) {
        return window.getComputedStyle(element, "") || {};
    };
    exports.setStyle = function(styles, property, value) {
        if (styles[property] !== value) styles[property] = value;
    };
    exports.HAS_CSS_ANIMATION = false;
    exports.HAS_CSS_TRANSFORMS = false;
    exports.HI_DPI = useragent.isWin ? typeof window !== "undefined" && window.devicePixelRatio >= 1.5 : true;
    if (useragent.isChromeOS) exports.HI_DPI = false;
    if (typeof document !== "undefined") {
        var div = document.createElement("div");
        if (exports.HI_DPI && div.style.transform !== undefined) exports.HAS_CSS_TRANSFORMS = true;
        if (!useragent.isEdge && typeof div.style.animationName !== "undefined") exports.HAS_CSS_ANIMATION = true;
        div = null;
    }
    if (exports.HAS_CSS_TRANSFORMS) exports.translate = function(element, tx, ty) {
        element.style.transform = "translate(" + Math.round(tx) + "px, " + Math.round(ty) + "px)";
    };
    else exports.translate = function(element, tx, ty) {
        element.style.top = Math.round(ty) + "px";
        element.style.left = Math.round(tx) + "px";
    };
});
ace.define("ace/lib/net", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var dom = require("./dom");
    exports.get = function(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) callback(xhr.responseText);
        };
        xhr.send(null);
    };
    exports.loadScript = function(path, callback) {
        var head = dom.getDocumentHead();
        var s = document.createElement("script");
        s.src = path;
        head.appendChild(s);
        s.onload = s.onreadystatechange = function(_, isAbort) {
            if (isAbort || !s.readyState || s.readyState == "loaded" || s.readyState == "complete") {
                s = s.onload = s.onreadystatechange = null;
                if (!isAbort) callback();
            }
        };
    };
    exports.qualifyURL = function(url) {
        var a = document.createElement("a");
        a.href = url;
        return a.href;
    };
});
ace.define("ace/lib/oop", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    exports.inherits = function(ctor, superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    };
    exports.mixin = function(obj, mixin) {
        for(var key in mixin)obj[key] = mixin[key];
        return obj;
    };
    exports.implement = function(proto, mixin) {
        exports.mixin(proto, mixin);
    };
});
ace.define("ace/lib/event_emitter", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var EventEmitter = {};
    var stopPropagation = function() {
        this.propagationStopped = true;
    };
    var preventDefault = function() {
        this.defaultPrevented = true;
    };
    EventEmitter._emit = EventEmitter._dispatchEvent = function(eventName, e) {
        this._eventRegistry || (this._eventRegistry = {});
        this._defaultHandlers || (this._defaultHandlers = {});
        var listeners = this._eventRegistry[eventName] || [];
        var defaultHandler = this._defaultHandlers[eventName];
        if (!listeners.length && !defaultHandler) return;
        if (typeof e != "object" || !e) e = {};
        if (!e.type) e.type = eventName;
        if (!e.stopPropagation) e.stopPropagation = stopPropagation;
        if (!e.preventDefault) e.preventDefault = preventDefault;
        listeners = listeners.slice();
        for(var i = 0; i < listeners.length; i++){
            listeners[i](e, this);
            if (e.propagationStopped) break;
        }
        if (defaultHandler && !e.defaultPrevented) return defaultHandler(e, this);
    };
    EventEmitter._signal = function(eventName, e) {
        var listeners = (this._eventRegistry || {})[eventName];
        if (!listeners) return;
        listeners = listeners.slice();
        for(var i = 0; i < listeners.length; i++)listeners[i](e, this);
    };
    EventEmitter.once = function(eventName, callback) {
        var _self = this;
        this.on(eventName, function newCallback() {
            _self.off(eventName, newCallback);
            callback.apply(null, arguments);
        });
        if (!callback) return new Promise(function(resolve) {
            callback = resolve;
        });
    };
    EventEmitter.setDefaultHandler = function(eventName, callback) {
        var handlers = this._defaultHandlers;
        if (!handlers) handlers = this._defaultHandlers = {
            _disabled_: {}
        };
        if (handlers[eventName]) {
            var old = handlers[eventName];
            var disabled = handlers._disabled_[eventName];
            if (!disabled) handlers._disabled_[eventName] = disabled = [];
            disabled.push(old);
            var i = disabled.indexOf(callback);
            if (i != -1) disabled.splice(i, 1);
        }
        handlers[eventName] = callback;
    };
    EventEmitter.removeDefaultHandler = function(eventName, callback) {
        var handlers = this._defaultHandlers;
        if (!handlers) return;
        var disabled = handlers._disabled_[eventName];
        if (handlers[eventName] == callback) {
            if (disabled) this.setDefaultHandler(eventName, disabled.pop());
        } else if (disabled) {
            var i = disabled.indexOf(callback);
            if (i != -1) disabled.splice(i, 1);
        }
    };
    EventEmitter.on = EventEmitter.addEventListener = function(eventName, callback, capturing) {
        this._eventRegistry = this._eventRegistry || {};
        var listeners = this._eventRegistry[eventName];
        if (!listeners) listeners = this._eventRegistry[eventName] = [];
        if (listeners.indexOf(callback) == -1) listeners[capturing ? "unshift" : "push"](callback);
        return callback;
    };
    EventEmitter.off = EventEmitter.removeListener = EventEmitter.removeEventListener = function(eventName, callback) {
        this._eventRegistry = this._eventRegistry || {};
        var listeners = this._eventRegistry[eventName];
        if (!listeners) return;
        var index = listeners.indexOf(callback);
        if (index !== -1) listeners.splice(index, 1);
    };
    EventEmitter.removeAllListeners = function(eventName) {
        if (!eventName) this._eventRegistry = this._defaultHandlers = undefined;
        if (this._eventRegistry) this._eventRegistry[eventName] = undefined;
        if (this._defaultHandlers) this._defaultHandlers[eventName] = undefined;
    };
    exports.EventEmitter = EventEmitter;
});
ace.define("ace/lib/app_config", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "no use strict";
    var oop = require("./oop");
    var EventEmitter = require("./event_emitter").EventEmitter;
    var optionsProvider = {
        setOptions: function(optList) {
            Object.keys(optList).forEach(function(key) {
                this.setOption(key, optList[key]);
            }, this);
        },
        getOptions: function(optionNames) {
            var result = {};
            if (!optionNames) {
                var options = this.$options;
                optionNames = Object.keys(options).filter(function(key) {
                    return !options[key].hidden;
                });
            } else if (!Array.isArray(optionNames)) {
                result = optionNames;
                optionNames = Object.keys(result);
            }
            optionNames.forEach(function(key) {
                result[key] = this.getOption(key);
            }, this);
            return result;
        },
        setOption: function(name, value) {
            if (this["$" + name] === value) return;
            var opt = this.$options[name];
            if (!opt) return warn('misspelled option "' + name + '"');
            if (opt.forwardTo) return this[opt.forwardTo] && this[opt.forwardTo].setOption(name, value);
            if (!opt.handlesSet) this["$" + name] = value;
            if (opt && opt.set) opt.set.call(this, value);
        },
        getOption: function(name) {
            var opt = this.$options[name];
            if (!opt) return warn('misspelled option "' + name + '"');
            if (opt.forwardTo) return this[opt.forwardTo] && this[opt.forwardTo].getOption(name);
            return opt && opt.get ? opt.get.call(this) : this["$" + name];
        }
    };
    function warn(message) {
        if (typeof console != "undefined" && console.warn) console.warn.apply(console, arguments);
    }
    function reportError(msg, data) {
        var e = new Error(msg);
        e.data = data;
        if (typeof console == "object" && console.error) console.error(e);
        setTimeout(function() {
            throw e;
        });
    }
    var messages;
    var AppConfig = /** @class */ function() {
        function AppConfig() {
            this.$defaultOptions = {};
        }
        AppConfig.prototype.defineOptions = function(obj, path, options) {
            if (!obj.$options) this.$defaultOptions[path] = obj.$options = {};
            Object.keys(options).forEach(function(key) {
                var opt = options[key];
                if (typeof opt == "string") opt = {
                    forwardTo: opt
                };
                opt.name || (opt.name = key);
                obj.$options[opt.name] = opt;
                if ("initialValue" in opt) obj["$" + opt.name] = opt.initialValue;
            });
            oop.implement(obj, optionsProvider);
            return this;
        };
        AppConfig.prototype.resetOptions = function(obj) {
            Object.keys(obj.$options).forEach(function(key) {
                var opt = obj.$options[key];
                if ("value" in opt) obj.setOption(key, opt.value);
            });
        };
        AppConfig.prototype.setDefaultValue = function(path, name, value) {
            if (!path) {
                for(path in this.$defaultOptions)if (this.$defaultOptions[path][name]) break;
                if (!this.$defaultOptions[path][name]) return false;
            }
            var opts = this.$defaultOptions[path] || (this.$defaultOptions[path] = {});
            if (opts[name]) {
                if (opts.forwardTo) this.setDefaultValue(opts.forwardTo, name, value);
                else opts[name].value = value;
            }
        };
        AppConfig.prototype.setDefaultValues = function(path, optionHash) {
            Object.keys(optionHash).forEach(function(key) {
                this.setDefaultValue(path, key, optionHash[key]);
            }, this);
        };
        AppConfig.prototype.setMessages = function(value) {
            messages = value;
        };
        AppConfig.prototype.nls = function(string, params) {
            if (messages && !messages[string]) warn("No message found for '" + string + "' in the provided messages, falling back to default English message.");
            var translated = messages && messages[string] || string;
            if (params) translated = translated.replace(/\$(\$|[\d]+)/g, function(_, name) {
                if (name == "$") return "$";
                return params[name];
            });
            return translated;
        };
        return AppConfig;
    }();
    AppConfig.prototype.warn = warn;
    AppConfig.prototype.reportError = reportError;
    oop.implement(AppConfig.prototype, EventEmitter);
    exports.AppConfig = AppConfig;
});
ace.define("ace/theme/textmate-css", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    module1.exports = '.ace-tm .ace_gutter {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.ace-tm .ace_print-margin {\n  width: 1px;\n  background: #e8e8e8;\n}\n\n.ace-tm .ace_fold {\n    background-color: #6B72E6;\n}\n\n.ace-tm {\n  background-color: #FFFFFF;\n  color: black;\n}\n\n.ace-tm .ace_cursor {\n  color: black;\n}\n        \n.ace-tm .ace_invisible {\n  color: rgb(191, 191, 191);\n}\n\n.ace-tm .ace_storage,\n.ace-tm .ace_keyword {\n  color: blue;\n}\n\n.ace-tm .ace_constant {\n  color: rgb(197, 6, 11);\n}\n\n.ace-tm .ace_constant.ace_buildin {\n  color: rgb(88, 72, 246);\n}\n\n.ace-tm .ace_constant.ace_language {\n  color: rgb(88, 92, 246);\n}\n\n.ace-tm .ace_constant.ace_library {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_invalid {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: red;\n}\n\n.ace-tm .ace_support.ace_function {\n  color: rgb(60, 76, 114);\n}\n\n.ace-tm .ace_support.ace_constant {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_support.ace_type,\n.ace-tm .ace_support.ace_class {\n  color: rgb(109, 121, 222);\n}\n\n.ace-tm .ace_keyword.ace_operator {\n  color: rgb(104, 118, 135);\n}\n\n.ace-tm .ace_string {\n  color: rgb(3, 106, 7);\n}\n\n.ace-tm .ace_comment {\n  color: rgb(76, 136, 107);\n}\n\n.ace-tm .ace_comment.ace_doc {\n  color: rgb(0, 102, 255);\n}\n\n.ace-tm .ace_comment.ace_doc.ace_tag {\n  color: rgb(128, 159, 191);\n}\n\n.ace-tm .ace_constant.ace_numeric {\n  color: rgb(0, 0, 205);\n}\n\n.ace-tm .ace_variable {\n  color: rgb(49, 132, 149);\n}\n\n.ace-tm .ace_xml-pe {\n  color: rgb(104, 104, 91);\n}\n\n.ace-tm .ace_entity.ace_name.ace_function {\n  color: #0000A2;\n}\n\n\n.ace-tm .ace_heading {\n  color: rgb(12, 7, 255);\n}\n\n.ace-tm .ace_list {\n  color:rgb(185, 6, 144);\n}\n\n.ace-tm .ace_meta.ace_tag {\n  color:rgb(0, 22, 142);\n}\n\n.ace-tm .ace_string.ace_regex {\n  color: rgb(255, 0, 0)\n}\n\n.ace-tm .ace_marker-layer .ace_selection {\n  background: rgb(181, 213, 255);\n}\n.ace-tm.ace_multiselect .ace_selection.ace_start {\n  box-shadow: 0 0 3px 0px white;\n}\n.ace-tm .ace_marker-layer .ace_step {\n  background: rgb(252, 255, 0);\n}\n\n.ace-tm .ace_marker-layer .ace_stack {\n  background: rgb(164, 229, 101);\n}\n\n.ace-tm .ace_marker-layer .ace_bracket {\n  margin: -1px 0 0 -1px;\n  border: 1px solid rgb(192, 192, 192);\n}\n\n.ace-tm .ace_marker-layer .ace_active-line {\n  background: rgba(0, 0, 0, 0.07);\n}\n\n.ace-tm .ace_gutter-active-line {\n    background-color : #dcdcdc;\n}\n\n.ace-tm .ace_marker-layer .ace_selected-word {\n  background: rgb(250, 250, 255);\n  border: 1px solid rgb(200, 200, 250);\n}\n\n.ace-tm .ace_indent-guide {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y;\n}\n\n.ace-tm .ace_indent-guide-active {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAZSURBVHjaYvj///9/hivKyv8BAAAA//8DACLqBhbvk+/eAAAAAElFTkSuQmCC") right repeat-y;\n}\n';
});
ace.define("ace/theme/textmate", [
    "require",
    "exports",
    "module",
    "ace/theme/textmate-css",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    exports.isDark = false;
    exports.cssClass = "ace-tm";
    exports.cssText = require("./textmate-css");
    exports.$id = "ace/theme/textmate";
    var dom = require("../lib/dom");
    dom.importCssString(exports.cssText, exports.cssClass, false);
});
ace.define("ace/config", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/lib/net",
    "ace/lib/dom",
    "ace/lib/app_config",
    "ace/theme/textmate"
], function(require, exports, module1) {
    "no use strict";
    var lang = require("./lib/lang");
    var net = require("./lib/net");
    var dom = require("./lib/dom");
    var AppConfig = require("./lib/app_config").AppConfig;
    module1.exports = exports = new AppConfig();
    var options = {
        packaged: false,
        workerPath: null,
        modePath: null,
        themePath: null,
        basePath: "",
        suffix: ".js",
        $moduleUrls: {},
        loadWorkerFromBlob: true,
        sharedPopups: false,
        useStrictCSP: null
    };
    exports.get = function(key) {
        if (!options.hasOwnProperty(key)) throw new Error("Unknown config key: " + key);
        return options[key];
    };
    exports.set = function(key, value) {
        if (options.hasOwnProperty(key)) options[key] = value;
        else if (this.setDefaultValue("", key, value) == false) throw new Error("Unknown config key: " + key);
        if (key == "useStrictCSP") dom.useStrictCSP(value);
    };
    exports.all = function() {
        return lang.copyObject(options);
    };
    exports.$modes = {};
    exports.moduleUrl = function(name, component) {
        if (options.$moduleUrls[name]) return options.$moduleUrls[name];
        var parts = name.split("/");
        component = component || parts[parts.length - 2] || "";
        var sep = component == "snippets" ? "/" : "-";
        var base = parts[parts.length - 1];
        if (component == "worker" && sep == "-") {
            var re = new RegExp("^" + component + "[\\-_]|[\\-_]" + component + "$", "g");
            base = base.replace(re, "");
        }
        if ((!base || base == component) && parts.length > 1) base = parts[parts.length - 2];
        var path = options[component + "Path"];
        if (path == null) path = options.basePath;
        else if (sep == "/") component = sep = "";
        if (path && path.slice(-1) != "/") path += "/";
        return path + component + sep + base + this.get("suffix");
    };
    exports.setModuleUrl = function(name, subst) {
        return options.$moduleUrls[name] = subst;
    };
    var loader = function(moduleName, cb) {
        if (moduleName === "ace/theme/textmate" || moduleName === "./theme/textmate") return cb(null, require("./theme/textmate"));
        if (customLoader) return customLoader(moduleName, cb);
        console.error("loader is not configured");
    };
    var customLoader;
    exports.setLoader = function(cb) {
        customLoader = cb;
    };
    exports.dynamicModules = Object.create(null);
    exports.$loading = {};
    exports.$loaded = {};
    exports.loadModule = function(moduleName, onLoad) {
        var loadedModule, moduleType;
        if (Array.isArray(moduleName)) {
            moduleType = moduleName[0];
            moduleName = moduleName[1];
        }
        var load = function(module1) {
            if (module1 && !exports.$loading[moduleName]) return onLoad && onLoad(module1);
            if (!exports.$loading[moduleName]) exports.$loading[moduleName] = [];
            exports.$loading[moduleName].push(onLoad);
            if (exports.$loading[moduleName].length > 1) return;
            var afterLoad = function() {
                loader(moduleName, function(err, module1) {
                    if (module1) exports.$loaded[moduleName] = module1;
                    exports._emit("load.module", {
                        name: moduleName,
                        module: module1
                    });
                    var listeners = exports.$loading[moduleName];
                    exports.$loading[moduleName] = null;
                    listeners.forEach(function(onLoad) {
                        onLoad && onLoad(module1);
                    });
                });
            };
            if (!exports.get("packaged")) return afterLoad();
            net.loadScript(exports.moduleUrl(moduleName, moduleType), afterLoad);
            reportErrorIfPathIsNotConfigured();
        };
        if (exports.dynamicModules[moduleName]) exports.dynamicModules[moduleName]().then(function(module1) {
            if (module1.default) load(module1.default);
            else load(module1);
        });
        else {
            try {
                loadedModule = this.$require(moduleName);
            } catch (e) {}
            load(loadedModule || exports.$loaded[moduleName]);
        }
    };
    exports.$require = function(moduleName) {
        if (typeof module1.require == "function") {
            var req = "require";
            return module1[req](moduleName);
        }
    };
    exports.setModuleLoader = function(moduleName, onLoad) {
        exports.dynamicModules[moduleName] = onLoad;
    };
    var reportErrorIfPathIsNotConfigured = function() {
        if (!options.basePath && !options.workerPath && !options.modePath && !options.themePath && !Object.keys(options.$moduleUrls).length) {
            console.error("Unable to infer path to ace from script src,", "use ace.config.set('basePath', 'path') to enable dynamic loading of modes and themes", "or with webpack use ace/webpack-resolver");
            reportErrorIfPathIsNotConfigured = function() {};
        }
    };
    exports.version = "1.24.1";
});
ace.define("ace/loader_build", [
    "require",
    "exports",
    "module",
    "ace/lib/fixoldbrowsers",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    require("./lib/fixoldbrowsers");
    var config = require("./config");
    config.setLoader(function(moduleName, cb) {
        require([
            moduleName
        ], function(module1) {
            cb(null, module1);
        });
    });
    var global = function() {
        return this || typeof window != "undefined" && window;
    }();
    module1.exports = function(ace1) {
        config.init = init;
        config.$require = require;
        ace1.require = require;
        if (typeof define === "function") ace1.define = define;
    };
    init(true);
    function init(packaged) {
        if (!global || !global.document) return;
        config.set("packaged", packaged || require.packaged || module1.packaged || global.define && define.packaged);
        var scriptOptions = {};
        var scriptUrl = "";
        var currentScript = document.currentScript || document._currentScript; // native or polyfill
        var currentDocument = currentScript && currentScript.ownerDocument || document;
        if (currentScript && currentScript.src) scriptUrl = currentScript.src.split(/[?#]/)[0].split("/").slice(0, -1).join("/") || "";
        var scripts = currentDocument.getElementsByTagName("script");
        for(var i = 0; i < scripts.length; i++){
            var script = scripts[i];
            var src = script.src || script.getAttribute("src");
            if (!src) continue;
            var attributes = script.attributes;
            for(var j = 0, l = attributes.length; j < l; j++){
                var attr = attributes[j];
                if (attr.name.indexOf("data-ace-") === 0) scriptOptions[deHyphenate(attr.name.replace(/^data-ace-/, ""))] = attr.value;
            }
            var m = src.match(/^(.*)\/ace([\-.]\w+)?\.js(\?|$)/);
            if (m) scriptUrl = m[1];
        }
        if (scriptUrl) {
            scriptOptions.base = scriptOptions.base || scriptUrl;
            scriptOptions.packaged = true;
        }
        scriptOptions.basePath = scriptOptions.base;
        scriptOptions.workerPath = scriptOptions.workerPath || scriptOptions.base;
        scriptOptions.modePath = scriptOptions.modePath || scriptOptions.base;
        scriptOptions.themePath = scriptOptions.themePath || scriptOptions.base;
        delete scriptOptions.base;
        for(var key in scriptOptions)if (typeof scriptOptions[key] !== "undefined") config.set(key, scriptOptions[key]);
    }
    function deHyphenate(str) {
        return str.replace(/-(.)/g, function(m, m1) {
            return m1.toUpperCase();
        });
    }
});
ace.define("ace/range", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var comparePoints = function(p1, p2) {
        return p1.row - p2.row || p1.column - p2.column;
    };
    var Range = /** @class */ function() {
        function Range(startRow, startColumn, endRow, endColumn) {
            this.start = {
                row: startRow,
                column: startColumn
            };
            this.end = {
                row: endRow,
                column: endColumn
            };
        }
        Range.prototype.isEqual = function(range) {
            return this.start.row === range.start.row && this.end.row === range.end.row && this.start.column === range.start.column && this.end.column === range.end.column;
        };
        Range.prototype.toString = function() {
            return "Range: [" + this.start.row + "/" + this.start.column + "] -> [" + this.end.row + "/" + this.end.column + "]";
        };
        Range.prototype.contains = function(row, column) {
            return this.compare(row, column) == 0;
        };
        Range.prototype.compareRange = function(range) {
            var cmp, end = range.end, start = range.start;
            cmp = this.compare(end.row, end.column);
            if (cmp == 1) {
                cmp = this.compare(start.row, start.column);
                if (cmp == 1) return 2;
                else if (cmp == 0) return 1;
                else return 0;
            } else if (cmp == -1) return -2;
            else {
                cmp = this.compare(start.row, start.column);
                if (cmp == -1) return -1;
                else if (cmp == 1) return 42;
                else return 0;
            }
        };
        Range.prototype.comparePoint = function(p) {
            return this.compare(p.row, p.column);
        };
        Range.prototype.containsRange = function(range) {
            return this.comparePoint(range.start) == 0 && this.comparePoint(range.end) == 0;
        };
        Range.prototype.intersects = function(range) {
            var cmp = this.compareRange(range);
            return cmp == -1 || cmp == 0 || cmp == 1;
        };
        Range.prototype.isEnd = function(row, column) {
            return this.end.row == row && this.end.column == column;
        };
        Range.prototype.isStart = function(row, column) {
            return this.start.row == row && this.start.column == column;
        };
        Range.prototype.setStart = function(row, column) {
            if (typeof row == "object") {
                this.start.column = row.column;
                this.start.row = row.row;
            } else {
                this.start.row = row;
                this.start.column = column;
            }
        };
        Range.prototype.setEnd = function(row, column) {
            if (typeof row == "object") {
                this.end.column = row.column;
                this.end.row = row.row;
            } else {
                this.end.row = row;
                this.end.column = column;
            }
        };
        Range.prototype.inside = function(row, column) {
            if (this.compare(row, column) == 0) {
                if (this.isEnd(row, column) || this.isStart(row, column)) return false;
                else return true;
            }
            return false;
        };
        Range.prototype.insideStart = function(row, column) {
            if (this.compare(row, column) == 0) {
                if (this.isEnd(row, column)) return false;
                else return true;
            }
            return false;
        };
        Range.prototype.insideEnd = function(row, column) {
            if (this.compare(row, column) == 0) {
                if (this.isStart(row, column)) return false;
                else return true;
            }
            return false;
        };
        Range.prototype.compare = function(row, column) {
            if (!this.isMultiLine()) {
                if (row === this.start.row) return column < this.start.column ? -1 : column > this.end.column ? 1 : 0;
            }
            if (row < this.start.row) return -1;
            if (row > this.end.row) return 1;
            if (this.start.row === row) return column >= this.start.column ? 0 : -1;
            if (this.end.row === row) return column <= this.end.column ? 0 : 1;
            return 0;
        };
        Range.prototype.compareStart = function(row, column) {
            if (this.start.row == row && this.start.column == column) return -1;
            else return this.compare(row, column);
        };
        Range.prototype.compareEnd = function(row, column) {
            if (this.end.row == row && this.end.column == column) return 1;
            else return this.compare(row, column);
        };
        Range.prototype.compareInside = function(row, column) {
            if (this.end.row == row && this.end.column == column) return 1;
            else if (this.start.row == row && this.start.column == column) return -1;
            else return this.compare(row, column);
        };
        Range.prototype.clipRows = function(firstRow, lastRow) {
            if (this.end.row > lastRow) var end = {
                row: lastRow + 1,
                column: 0
            };
            else if (this.end.row < firstRow) var end = {
                row: firstRow,
                column: 0
            };
            if (this.start.row > lastRow) var start = {
                row: lastRow + 1,
                column: 0
            };
            else if (this.start.row < firstRow) var start = {
                row: firstRow,
                column: 0
            };
            return Range.fromPoints(start || this.start, end || this.end);
        };
        Range.prototype.extend = function(row, column) {
            var cmp = this.compare(row, column);
            if (cmp == 0) return this;
            else if (cmp == -1) var start = {
                row: row,
                column: column
            };
            else var end = {
                row: row,
                column: column
            };
            return Range.fromPoints(start || this.start, end || this.end);
        };
        Range.prototype.isEmpty = function() {
            return this.start.row === this.end.row && this.start.column === this.end.column;
        };
        Range.prototype.isMultiLine = function() {
            return this.start.row !== this.end.row;
        };
        Range.prototype.clone = function() {
            return Range.fromPoints(this.start, this.end);
        };
        Range.prototype.collapseRows = function() {
            if (this.end.column == 0) return new Range(this.start.row, 0, Math.max(this.start.row, this.end.row - 1), 0);
            else return new Range(this.start.row, 0, this.end.row, 0);
        };
        Range.prototype.toScreenRange = function(session) {
            var screenPosStart = session.documentToScreenPosition(this.start);
            var screenPosEnd = session.documentToScreenPosition(this.end);
            return new Range(screenPosStart.row, screenPosStart.column, screenPosEnd.row, screenPosEnd.column);
        };
        Range.prototype.moveBy = function(row, column) {
            this.start.row += row;
            this.start.column += column;
            this.end.row += row;
            this.end.column += column;
        };
        return Range;
    }();
    Range.fromPoints = function(start, end) {
        return new Range(start.row, start.column, end.row, end.column);
    };
    Range.comparePoints = comparePoints;
    Range.comparePoints = function(p1, p2) {
        return p1.row - p2.row || p1.column - p2.column;
    };
    exports.Range = Range;
});
ace.define("ace/lib/keys", [
    "require",
    "exports",
    "module",
    "ace/lib/oop"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./oop");
    var Keys = function() {
        var ret = {
            MODIFIER_KEYS: {
                16: "Shift",
                17: "Ctrl",
                18: "Alt",
                224: "Meta",
                91: "MetaLeft",
                92: "MetaRight",
                93: "ContextMenu"
            },
            KEY_MODS: {
                "ctrl": 1,
                "alt": 2,
                "option": 2,
                "shift": 4,
                "super": 8,
                "meta": 8,
                "command": 8,
                "cmd": 8,
                "control": 1
            },
            FUNCTION_KEYS: {
                8: "Backspace",
                9: "Tab",
                13: "Return",
                19: "Pause",
                27: "Esc",
                32: "Space",
                33: "PageUp",
                34: "PageDown",
                35: "End",
                36: "Home",
                37: "Left",
                38: "Up",
                39: "Right",
                40: "Down",
                44: "Print",
                45: "Insert",
                46: "Delete",
                96: "Numpad0",
                97: "Numpad1",
                98: "Numpad2",
                99: "Numpad3",
                100: "Numpad4",
                101: "Numpad5",
                102: "Numpad6",
                103: "Numpad7",
                104: "Numpad8",
                105: "Numpad9",
                "-13": "NumpadEnter",
                112: "F1",
                113: "F2",
                114: "F3",
                115: "F4",
                116: "F5",
                117: "F6",
                118: "F7",
                119: "F8",
                120: "F9",
                121: "F10",
                122: "F11",
                123: "F12",
                144: "Numlock",
                145: "Scrolllock"
            },
            PRINTABLE_KEYS: {
                32: " ",
                48: "0",
                49: "1",
                50: "2",
                51: "3",
                52: "4",
                53: "5",
                54: "6",
                55: "7",
                56: "8",
                57: "9",
                59: ";",
                61: "=",
                65: "a",
                66: "b",
                67: "c",
                68: "d",
                69: "e",
                70: "f",
                71: "g",
                72: "h",
                73: "i",
                74: "j",
                75: "k",
                76: "l",
                77: "m",
                78: "n",
                79: "o",
                80: "p",
                81: "q",
                82: "r",
                83: "s",
                84: "t",
                85: "u",
                86: "v",
                87: "w",
                88: "x",
                89: "y",
                90: "z",
                107: "+",
                109: "-",
                110: ".",
                186: ";",
                187: "=",
                188: ",",
                189: "-",
                190: ".",
                191: "/",
                192: "`",
                219: "[",
                220: "\\",
                221: "]",
                222: "'",
                111: "/",
                106: "*"
            }
        };
        ret.PRINTABLE_KEYS[173] = "-";
        var name, i;
        for(i in ret.FUNCTION_KEYS){
            name = ret.FUNCTION_KEYS[i].toLowerCase();
            ret[name] = parseInt(i, 10);
        }
        for(i in ret.PRINTABLE_KEYS){
            name = ret.PRINTABLE_KEYS[i].toLowerCase();
            ret[name] = parseInt(i, 10);
        }
        oop.mixin(ret, ret.MODIFIER_KEYS);
        oop.mixin(ret, ret.PRINTABLE_KEYS);
        oop.mixin(ret, ret.FUNCTION_KEYS);
        ret.enter = ret["return"];
        ret.escape = ret.esc;
        ret.del = ret["delete"];
        (function() {
            var mods = [
                "cmd",
                "ctrl",
                "alt",
                "shift"
            ];
            for(var i = Math.pow(2, mods.length); i--;)ret.KEY_MODS[i] = mods.filter(function(x) {
                return i & ret.KEY_MODS[x];
            }).join("-") + "-";
        })();
        ret.KEY_MODS[0] = "";
        ret.KEY_MODS[-1] = "input-";
        return ret;
    }();
    oop.mixin(exports, Keys);
    exports.default = exports;
    exports.keyCodeToString = function(keyCode) {
        var keyString = Keys[keyCode];
        if (typeof keyString != "string") keyString = String.fromCharCode(keyCode);
        return keyString.toLowerCase();
    };
});
ace.define("ace/lib/event", [
    "require",
    "exports",
    "module",
    "ace/lib/keys",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var keys = require("./keys");
    var useragent = require("./useragent");
    var pressedKeys = null;
    var ts = 0;
    var activeListenerOptions;
    function detectListenerOptionsSupport() {
        activeListenerOptions = false;
        try {
            document.createComment("").addEventListener("test", function() {}, {
                get passive () {
                    activeListenerOptions = {
                        passive: false
                    };
                }
            });
        } catch (e) {}
    }
    function getListenerOptions() {
        if (activeListenerOptions == undefined) detectListenerOptionsSupport();
        return activeListenerOptions;
    }
    function EventListener(elem, type, callback) {
        this.elem = elem;
        this.type = type;
        this.callback = callback;
    }
    EventListener.prototype.destroy = function() {
        removeListener(this.elem, this.type, this.callback);
        this.elem = this.type = this.callback = undefined;
    };
    var addListener = exports.addListener = function(elem, type, callback, destroyer) {
        elem.addEventListener(type, callback, getListenerOptions());
        if (destroyer) destroyer.$toDestroy.push(new EventListener(elem, type, callback));
    };
    var removeListener = exports.removeListener = function(elem, type, callback) {
        elem.removeEventListener(type, callback, getListenerOptions());
    };
    exports.stopEvent = function(e) {
        exports.stopPropagation(e);
        exports.preventDefault(e);
        return false;
    };
    exports.stopPropagation = function(e) {
        if (e.stopPropagation) e.stopPropagation();
    };
    exports.preventDefault = function(e) {
        if (e.preventDefault) e.preventDefault();
    };
    exports.getButton = function(e) {
        if (e.type == "dblclick") return 0;
        if (e.type == "contextmenu" || useragent.isMac && e.ctrlKey && !e.altKey && !e.shiftKey) return 2;
        return e.button;
    };
    exports.capture = function(el, eventHandler, releaseCaptureHandler) {
        var ownerDocument = el && el.ownerDocument || document;
        function onMouseUp(e) {
            eventHandler && eventHandler(e);
            releaseCaptureHandler && releaseCaptureHandler(e);
            removeListener(ownerDocument, "mousemove", eventHandler);
            removeListener(ownerDocument, "mouseup", onMouseUp);
            removeListener(ownerDocument, "dragstart", onMouseUp);
        }
        addListener(ownerDocument, "mousemove", eventHandler);
        addListener(ownerDocument, "mouseup", onMouseUp);
        addListener(ownerDocument, "dragstart", onMouseUp);
        return onMouseUp;
    };
    exports.addMouseWheelListener = function(el, callback, destroyer) {
        addListener(el, "wheel", function(e) {
            var factor = 0.15;
            var deltaX = e.deltaX || 0;
            var deltaY = e.deltaY || 0;
            switch(e.deltaMode){
                case e.DOM_DELTA_PIXEL:
                    e.wheelX = deltaX * factor;
                    e.wheelY = deltaY * factor;
                    break;
                case e.DOM_DELTA_LINE:
                    var linePixels = 15;
                    e.wheelX = deltaX * linePixels;
                    e.wheelY = deltaY * linePixels;
                    break;
                case e.DOM_DELTA_PAGE:
                    var pagePixels = 150;
                    e.wheelX = deltaX * pagePixels;
                    e.wheelY = deltaY * pagePixels;
                    break;
            }
            callback(e);
        }, destroyer);
    };
    exports.addMultiMouseDownListener = function(elements, timeouts, eventHandler, callbackName, destroyer) {
        var clicks = 0;
        var startX, startY, timer;
        var eventNames = {
            2: "dblclick",
            3: "tripleclick",
            4: "quadclick"
        };
        function onMousedown(e) {
            if (exports.getButton(e) !== 0) clicks = 0;
            else if (e.detail > 1) {
                clicks++;
                if (clicks > 4) clicks = 1;
            } else clicks = 1;
            if (useragent.isIE) {
                var isNewClick = Math.abs(e.clientX - startX) > 5 || Math.abs(e.clientY - startY) > 5;
                if (!timer || isNewClick) clicks = 1;
                if (timer) clearTimeout(timer);
                timer = setTimeout(function() {
                    timer = null;
                }, timeouts[clicks - 1] || 600);
                if (clicks == 1) {
                    startX = e.clientX;
                    startY = e.clientY;
                }
            }
            e._clicks = clicks;
            eventHandler[callbackName]("mousedown", e);
            if (clicks > 4) clicks = 0;
            else if (clicks > 1) return eventHandler[callbackName](eventNames[clicks], e);
        }
        if (!Array.isArray(elements)) elements = [
            elements
        ];
        elements.forEach(function(el) {
            addListener(el, "mousedown", onMousedown, destroyer);
        });
    };
    var getModifierHash = function(e) {
        return 0 | (e.ctrlKey ? 1 : 0) | (e.altKey ? 2 : 0) | (e.shiftKey ? 4 : 0) | (e.metaKey ? 8 : 0);
    };
    exports.getModifierString = function(e) {
        return keys.KEY_MODS[getModifierHash(e)];
    };
    function normalizeCommandKeys(callback, e, keyCode) {
        var hashId = getModifierHash(e);
        if (!useragent.isMac && pressedKeys) {
            if (e.getModifierState && (e.getModifierState("OS") || e.getModifierState("Win"))) hashId |= 8;
            if (pressedKeys.altGr) {
                if ((3 & hashId) != 3) pressedKeys.altGr = 0;
                else return;
            }
            if (keyCode === 18 || keyCode === 17) {
                var location = "location" in e ? e.location : e.keyLocation;
                if (keyCode === 17 && location === 1) {
                    if (pressedKeys[keyCode] == 1) ts = e.timeStamp;
                } else if (keyCode === 18 && hashId === 3 && location === 2) {
                    var dt = e.timeStamp - ts;
                    if (dt < 50) pressedKeys.altGr = true;
                }
            }
        }
        if (keyCode in keys.MODIFIER_KEYS) keyCode = -1;
        if (!hashId && keyCode === 13) {
            var location = "location" in e ? e.location : e.keyLocation;
            if (location === 3) {
                callback(e, hashId, -keyCode);
                if (e.defaultPrevented) return;
            }
        }
        if (useragent.isChromeOS && hashId & 8) {
            callback(e, hashId, keyCode);
            if (e.defaultPrevented) return;
            else hashId &= -9;
        }
        if (!hashId && !(keyCode in keys.FUNCTION_KEYS) && !(keyCode in keys.PRINTABLE_KEYS)) return false;
        return callback(e, hashId, keyCode);
    }
    exports.addCommandKeyListener = function(el, callback, destroyer) {
        if (useragent.isOldGecko || useragent.isOpera && !("KeyboardEvent" in window)) {
            var lastKeyDownKeyCode = null;
            addListener(el, "keydown", function(e) {
                lastKeyDownKeyCode = e.keyCode;
            }, destroyer);
            addListener(el, "keypress", function(e) {
                return normalizeCommandKeys(callback, e, lastKeyDownKeyCode);
            }, destroyer);
        } else {
            var lastDefaultPrevented = null;
            addListener(el, "keydown", function(e) {
                pressedKeys[e.keyCode] = (pressedKeys[e.keyCode] || 0) + 1;
                var result = normalizeCommandKeys(callback, e, e.keyCode);
                lastDefaultPrevented = e.defaultPrevented;
                return result;
            }, destroyer);
            addListener(el, "keypress", function(e) {
                if (lastDefaultPrevented && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey)) {
                    exports.stopEvent(e);
                    lastDefaultPrevented = null;
                }
            }, destroyer);
            addListener(el, "keyup", function(e) {
                pressedKeys[e.keyCode] = null;
            }, destroyer);
            if (!pressedKeys) {
                resetPressedKeys();
                addListener(window, "focus", resetPressedKeys);
            }
        }
    };
    function resetPressedKeys() {
        pressedKeys = Object.create(null);
    }
    if (typeof window == "object" && window.postMessage && !useragent.isOldIE) {
        var postMessageId = 1;
        exports.nextTick = function(callback, win) {
            win = win || window;
            var messageName = "zero-timeout-message-" + postMessageId++;
            var listener = function(e) {
                if (e.data == messageName) {
                    exports.stopPropagation(e);
                    removeListener(win, "message", listener);
                    callback();
                }
            };
            addListener(win, "message", listener);
            win.postMessage(messageName, "*");
        };
    }
    exports.$idleBlocked = false;
    exports.onIdle = function(cb, timeout) {
        return setTimeout(function handler() {
            if (!exports.$idleBlocked) cb();
            else setTimeout(handler, 100);
        }, timeout);
    };
    exports.$idleBlockId = null;
    exports.blockIdle = function(delay) {
        if (exports.$idleBlockId) clearTimeout(exports.$idleBlockId);
        exports.$idleBlocked = true;
        exports.$idleBlockId = setTimeout(function() {
            exports.$idleBlocked = false;
        }, delay || 100);
    };
    exports.nextFrame = typeof window == "object" && (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame);
    if (exports.nextFrame) exports.nextFrame = exports.nextFrame.bind(window);
    else exports.nextFrame = function(callback) {
        setTimeout(callback, 17);
    };
});
ace.define("ace/clipboard", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var $cancelT;
    module1.exports = {
        lineMode: false,
        pasteCancelled: function() {
            if ($cancelT && $cancelT > Date.now() - 50) return true;
            return $cancelT = false;
        },
        cancel: function() {
            $cancelT = Date.now();
        }
    };
});
ace.define("ace/keyboard/textinput", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/config",
    "ace/lib/useragent",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/clipboard",
    "ace/lib/keys"
], function(require, exports, module1) {
    "use strict";
    var event = require("../lib/event");
    var nls = require("../config").nls;
    var useragent = require("../lib/useragent");
    var dom = require("../lib/dom");
    var lang = require("../lib/lang");
    var clipboard = require("../clipboard");
    var BROKEN_SETDATA = useragent.isChrome < 18;
    var USE_IE_MIME_TYPE = useragent.isIE;
    var HAS_FOCUS_ARGS = useragent.isChrome > 63;
    var MAX_LINE_LENGTH = 400;
    var KEYS = require("../lib/keys");
    var MODS = KEYS.KEY_MODS;
    var isIOS = useragent.isIOS;
    var valueResetRegex = isIOS ? /\s/ : /\n/;
    var isMobile = useragent.isMobile;
    var TextInput = function(parentNode, host) {
        var text = dom.createElement("textarea");
        text.className = "ace_text-input";
        text.setAttribute("wrap", "off");
        text.setAttribute("autocorrect", "off");
        text.setAttribute("autocapitalize", "off");
        text.setAttribute("spellcheck", false);
        text.style.opacity = "0";
        parentNode.insertBefore(text, parentNode.firstChild);
        var copied = false;
        var pasted = false;
        var inComposition = false;
        var sendingText = false;
        var tempStyle = "";
        if (!isMobile) text.style.fontSize = "1px";
        var commandMode = false;
        var ignoreFocusEvents = false;
        var lastValue = "";
        var lastSelectionStart = 0;
        var lastSelectionEnd = 0;
        var lastRestoreEnd = 0;
        var rowStart = Number.MAX_SAFE_INTEGER;
        var rowEnd = Number.MIN_SAFE_INTEGER;
        var numberOfExtraLines = 0;
        try {
            var isFocused = document.activeElement === text;
        } catch (e) {}
        this.setNumberOfExtraLines = function(number) {
            rowStart = Number.MAX_SAFE_INTEGER;
            rowEnd = Number.MIN_SAFE_INTEGER;
            if (number < 0) {
                numberOfExtraLines = 0;
                return;
            }
            numberOfExtraLines = number;
        };
        this.setAriaOptions = function(options) {
            if (options.activeDescendant) {
                text.setAttribute("aria-haspopup", "true");
                text.setAttribute("aria-autocomplete", options.inline ? "both" : "list");
                text.setAttribute("aria-activedescendant", options.activeDescendant);
            } else {
                text.setAttribute("aria-haspopup", "false");
                text.setAttribute("aria-autocomplete", "both");
                text.removeAttribute("aria-activedescendant");
            }
            if (options.role) text.setAttribute("role", options.role);
            if (options.setLabel) {
                text.setAttribute("aria-roledescription", nls("editor"));
                if (host.session) {
                    var row = host.session.selection.cursor.row;
                    text.setAttribute("aria-label", nls("Cursor at row $0", [
                        row + 1
                    ]));
                }
            }
        };
        this.setAriaOptions({
            role: "textbox"
        });
        event.addListener(text, "blur", function(e) {
            if (ignoreFocusEvents) return;
            host.onBlur(e);
            isFocused = false;
        }, host);
        event.addListener(text, "focus", function(e) {
            if (ignoreFocusEvents) return;
            isFocused = true;
            if (useragent.isEdge) try {
                if (!document.hasFocus()) return;
            } catch (e) {}
            host.onFocus(e);
            if (useragent.isEdge) setTimeout(resetSelection);
            else resetSelection();
        }, host);
        this.$focusScroll = false;
        this.focus = function() {
            this.setAriaOptions({
                setLabel: host.renderer.enableKeyboardAccessibility
            });
            if (tempStyle || HAS_FOCUS_ARGS || this.$focusScroll == "browser") return text.focus({
                preventScroll: true
            });
            var top = text.style.top;
            text.style.position = "fixed";
            text.style.top = "0px";
            try {
                var isTransformed = text.getBoundingClientRect().top != 0;
            } catch (e) {
                return;
            }
            var ancestors = [];
            if (isTransformed) {
                var t = text.parentElement;
                while(t && t.nodeType == 1){
                    ancestors.push(t);
                    t.setAttribute("ace_nocontext", true);
                    if (!t.parentElement && t.getRootNode) t = t.getRootNode().host;
                    else t = t.parentElement;
                }
            }
            text.focus({
                preventScroll: true
            });
            if (isTransformed) ancestors.forEach(function(p) {
                p.removeAttribute("ace_nocontext");
            });
            setTimeout(function() {
                text.style.position = "";
                if (text.style.top == "0px") text.style.top = top;
            }, 0);
        };
        this.blur = function() {
            text.blur();
        };
        this.isFocused = function() {
            return isFocused;
        };
        host.on("beforeEndOperation", function() {
            var curOp = host.curOp;
            var commandName = curOp && curOp.command && curOp.command.name;
            if (commandName == "insertstring") return;
            var isUserAction = commandName && (curOp.docChanged || curOp.selectionChanged);
            if (inComposition && isUserAction) {
                lastValue = text.value = "";
                onCompositionEnd();
            }
            resetSelection();
        });
        var positionToSelection = function(row, column) {
            var selection = column;
            for(var i = 1; i <= row - rowStart && i < 2 * numberOfExtraLines + 1; i++)selection += host.session.getLine(row - i).length + 1;
            return selection;
        };
        var resetSelection = isIOS ? function(value) {
            if (!isFocused || copied && !value || sendingText) return;
            if (!value) value = "";
            var newValue = "\n ab" + value + "cde fg\n";
            if (newValue != text.value) text.value = lastValue = newValue;
            var selectionStart = 4;
            var selectionEnd = 4 + (value.length || (host.selection.isEmpty() ? 0 : 1));
            if (lastSelectionStart != selectionStart || lastSelectionEnd != selectionEnd) text.setSelectionRange(selectionStart, selectionEnd);
            lastSelectionStart = selectionStart;
            lastSelectionEnd = selectionEnd;
        } : function() {
            if (inComposition || sendingText) return;
            if (!isFocused && !afterContextMenu) return;
            inComposition = true;
            var selectionStart = 0;
            var selectionEnd = 0;
            var line = "";
            if (host.session) {
                var selection = host.selection;
                var range = selection.getRange();
                var row = selection.cursor.row;
                if (row === rowEnd + 1) {
                    rowStart = rowEnd + 1;
                    rowEnd = rowStart + 2 * numberOfExtraLines;
                } else if (row === rowStart - 1) {
                    rowEnd = rowStart - 1;
                    rowStart = rowEnd - 2 * numberOfExtraLines;
                } else if (row < rowStart - 1 || row > rowEnd + 1) {
                    rowStart = row > numberOfExtraLines ? row - numberOfExtraLines : 0;
                    rowEnd = row > numberOfExtraLines ? row + numberOfExtraLines : 2 * numberOfExtraLines;
                }
                var lines = [];
                for(var i = rowStart; i <= rowEnd; i++)lines.push(host.session.getLine(i));
                line = lines.join("\n");
                selectionStart = positionToSelection(range.start.row, range.start.column);
                selectionEnd = positionToSelection(range.end.row, range.end.column);
                if (range.start.row < rowStart) {
                    var prevLine = host.session.getLine(rowStart - 1);
                    selectionStart = range.start.row < rowStart - 1 ? 0 : selectionStart;
                    selectionEnd += prevLine.length + 1;
                    line = prevLine + "\n" + line;
                } else if (range.end.row > rowEnd) {
                    var nextLine = host.session.getLine(rowEnd + 1);
                    selectionEnd = range.end.row > rowEnd + 1 ? nextLine.length : range.end.column;
                    selectionEnd += line.length + 1;
                    line = line + "\n" + nextLine;
                } else if (isMobile && row > 0) {
                    line = "\n" + line;
                    selectionEnd += 1;
                    selectionStart += 1;
                }
                if (line.length > MAX_LINE_LENGTH) {
                    if (selectionStart < MAX_LINE_LENGTH && selectionEnd < MAX_LINE_LENGTH) line = line.slice(0, MAX_LINE_LENGTH);
                    else {
                        line = "\n";
                        if (selectionStart == selectionEnd) selectionStart = selectionEnd = 0;
                        else {
                            selectionStart = 0;
                            selectionEnd = 1;
                        }
                    }
                }
                var newValue = line + "\n\n";
                if (newValue != lastValue) {
                    text.value = lastValue = newValue;
                    lastSelectionStart = lastSelectionEnd = newValue.length;
                }
            }
            if (afterContextMenu) {
                lastSelectionStart = text.selectionStart;
                lastSelectionEnd = text.selectionEnd;
            }
            if (lastSelectionEnd != selectionEnd || lastSelectionStart != selectionStart || text.selectionEnd != lastSelectionEnd // on ie edge selectionEnd changes silently after the initialization
            ) try {
                text.setSelectionRange(selectionStart, selectionEnd);
                lastSelectionStart = selectionStart;
                lastSelectionEnd = selectionEnd;
            } catch (e) {}
            inComposition = false;
        };
        this.resetSelection = resetSelection;
        if (isFocused) host.onFocus();
        var isAllSelected = function(text) {
            return text.selectionStart === 0 && text.selectionEnd >= lastValue.length && text.value === lastValue && lastValue && text.selectionEnd !== lastSelectionEnd;
        };
        var onSelect = function(e) {
            if (inComposition) return;
            if (copied) copied = false;
            else if (isAllSelected(text)) {
                host.selectAll();
                resetSelection();
            } else if (isMobile && text.selectionStart != lastSelectionStart) resetSelection();
        };
        var inputHandler = null;
        this.setInputHandler = function(cb) {
            inputHandler = cb;
        };
        this.getInputHandler = function() {
            return inputHandler;
        };
        var afterContextMenu = false;
        var sendText = function(value, fromInput) {
            if (afterContextMenu) afterContextMenu = false;
            if (pasted) {
                resetSelection();
                if (value) host.onPaste(value);
                pasted = false;
                return "";
            } else {
                var selectionStart = text.selectionStart;
                var selectionEnd = text.selectionEnd;
                var extendLeft = lastSelectionStart;
                var extendRight = lastValue.length - lastSelectionEnd;
                var inserted = value;
                var restoreStart = value.length - selectionStart;
                var restoreEnd = value.length - selectionEnd;
                var i = 0;
                while(extendLeft > 0 && lastValue[i] == value[i]){
                    i++;
                    extendLeft--;
                }
                inserted = inserted.slice(i);
                i = 1;
                while(extendRight > 0 && lastValue.length - i > lastSelectionStart - 1 && lastValue[lastValue.length - i] == value[value.length - i]){
                    i++;
                    extendRight--;
                }
                restoreStart -= i - 1;
                restoreEnd -= i - 1;
                var endIndex = inserted.length - i + 1;
                if (endIndex < 0) {
                    extendLeft = -endIndex;
                    endIndex = 0;
                }
                inserted = inserted.slice(0, endIndex);
                if (!fromInput && !inserted && !restoreStart && !extendLeft && !extendRight && !restoreEnd) return "";
                sendingText = true;
                var shouldReset = false;
                if (useragent.isAndroid && inserted == ". ") {
                    inserted = "  ";
                    shouldReset = true;
                }
                if (inserted && !extendLeft && !extendRight && !restoreStart && !restoreEnd || commandMode) host.onTextInput(inserted);
                else host.onTextInput(inserted, {
                    extendLeft: extendLeft,
                    extendRight: extendRight,
                    restoreStart: restoreStart,
                    restoreEnd: restoreEnd
                });
                sendingText = false;
                lastValue = value;
                lastSelectionStart = selectionStart;
                lastSelectionEnd = selectionEnd;
                lastRestoreEnd = restoreEnd;
                return shouldReset ? "\n" : inserted;
            }
        };
        var onInput = function(e) {
            if (inComposition) return onCompositionUpdate();
            if (e && e.inputType) {
                if (e.inputType == "historyUndo") return host.execCommand("undo");
                if (e.inputType == "historyRedo") return host.execCommand("redo");
            }
            var data = text.value;
            var inserted = sendText(data, true);
            if (data.length > MAX_LINE_LENGTH + 100 || valueResetRegex.test(inserted) || isMobile && lastSelectionStart < 1 && lastSelectionStart == lastSelectionEnd) resetSelection();
        };
        var handleClipboardData = function(e, data, forceIEMime) {
            var clipboardData = e.clipboardData || window.clipboardData;
            if (!clipboardData || BROKEN_SETDATA) return;
            var mime = USE_IE_MIME_TYPE || forceIEMime ? "Text" : "text/plain";
            try {
                if (data) return clipboardData.setData(mime, data) !== false;
                else return clipboardData.getData(mime);
            } catch (e) {
                if (!forceIEMime) return handleClipboardData(e, data, true);
            }
        };
        var doCopy = function(e, isCut) {
            var data = host.getCopyText();
            if (!data) return event.preventDefault(e);
            if (handleClipboardData(e, data)) {
                if (isIOS) {
                    resetSelection(data);
                    copied = data;
                    setTimeout(function() {
                        copied = false;
                    }, 10);
                }
                isCut ? host.onCut() : host.onCopy();
                event.preventDefault(e);
            } else {
                copied = true;
                text.value = data;
                text.select();
                setTimeout(function() {
                    copied = false;
                    resetSelection();
                    isCut ? host.onCut() : host.onCopy();
                });
            }
        };
        var onCut = function(e) {
            doCopy(e, true);
        };
        var onCopy = function(e) {
            doCopy(e, false);
        };
        var onPaste = function(e) {
            var data = handleClipboardData(e);
            if (clipboard.pasteCancelled()) return;
            if (typeof data == "string") {
                if (data) host.onPaste(data, e);
                if (useragent.isIE) setTimeout(resetSelection);
                event.preventDefault(e);
            } else {
                text.value = "";
                pasted = true;
            }
        };
        event.addCommandKeyListener(text, host.onCommandKey.bind(host), host);
        event.addListener(text, "select", onSelect, host);
        event.addListener(text, "input", onInput, host);
        event.addListener(text, "cut", onCut, host);
        event.addListener(text, "copy", onCopy, host);
        event.addListener(text, "paste", onPaste, host);
        if (!("oncut" in text) || !("oncopy" in text) || !("onpaste" in text)) event.addListener(parentNode, "keydown", function(e) {
            if (useragent.isMac && !e.metaKey || !e.ctrlKey) return;
            switch(e.keyCode){
                case 67:
                    onCopy(e);
                    break;
                case 86:
                    onPaste(e);
                    break;
                case 88:
                    onCut(e);
                    break;
            }
        }, host);
        var onCompositionStart = function(e) {
            if (inComposition || !host.onCompositionStart || host.$readOnly) return;
            inComposition = {};
            if (commandMode) return;
            if (e.data) inComposition.useTextareaForIME = false;
            setTimeout(onCompositionUpdate, 0);
            host._signal("compositionStart");
            host.on("mousedown", cancelComposition);
            var range = host.getSelectionRange();
            range.end.row = range.start.row;
            range.end.column = range.start.column;
            inComposition.markerRange = range;
            inComposition.selectionStart = lastSelectionStart;
            host.onCompositionStart(inComposition);
            if (inComposition.useTextareaForIME) {
                lastValue = text.value = "";
                lastSelectionStart = 0;
                lastSelectionEnd = 0;
            } else {
                if (text.msGetInputContext) inComposition.context = text.msGetInputContext();
                if (text.getInputContext) inComposition.context = text.getInputContext();
            }
        };
        var onCompositionUpdate = function() {
            if (!inComposition || !host.onCompositionUpdate || host.$readOnly) return;
            if (commandMode) return cancelComposition();
            if (inComposition.useTextareaForIME) host.onCompositionUpdate(text.value);
            else {
                var data = text.value;
                sendText(data);
                if (inComposition.markerRange) {
                    if (inComposition.context) inComposition.markerRange.start.column = inComposition.selectionStart = inComposition.context.compositionStartOffset;
                    inComposition.markerRange.end.column = inComposition.markerRange.start.column + lastSelectionEnd - inComposition.selectionStart + lastRestoreEnd;
                }
            }
        };
        var onCompositionEnd = function(e) {
            if (!host.onCompositionEnd || host.$readOnly) return;
            inComposition = false;
            host.onCompositionEnd();
            host.off("mousedown", cancelComposition);
            if (e) onInput();
        };
        function cancelComposition() {
            ignoreFocusEvents = true;
            text.blur();
            text.focus();
            ignoreFocusEvents = false;
        }
        var syncComposition = lang.delayedCall(onCompositionUpdate, 50).schedule.bind(null, null);
        function onKeyup(e) {
            if (e.keyCode == 27 && text.value.length < text.selectionStart) {
                if (!inComposition) lastValue = text.value;
                lastSelectionStart = lastSelectionEnd = -1;
                resetSelection();
            }
            syncComposition();
        }
        event.addListener(text, "compositionstart", onCompositionStart, host);
        event.addListener(text, "compositionupdate", onCompositionUpdate, host);
        event.addListener(text, "keyup", onKeyup, host);
        event.addListener(text, "keydown", syncComposition, host);
        event.addListener(text, "compositionend", onCompositionEnd, host);
        this.getElement = function() {
            return text;
        };
        this.setCommandMode = function(value) {
            commandMode = value;
            text.readOnly = false;
        };
        this.setReadOnly = function(readOnly) {
            if (!commandMode) text.readOnly = readOnly;
        };
        this.setCopyWithEmptySelection = function(value) {};
        this.onContextMenu = function(e) {
            afterContextMenu = true;
            resetSelection();
            host._emit("nativecontextmenu", {
                target: host,
                domEvent: e
            });
            this.moveToMouse(e, true);
        };
        this.moveToMouse = function(e, bringToFront) {
            if (!tempStyle) tempStyle = text.style.cssText;
            text.style.cssText = (bringToFront ? "z-index:100000;" : "") + (useragent.isIE ? "opacity:0.1;" : "") + "text-indent: -" + (lastSelectionStart + lastSelectionEnd) * host.renderer.characterWidth * 0.5 + "px;";
            var rect = host.container.getBoundingClientRect();
            var style = dom.computedStyle(host.container);
            var top = rect.top + (parseInt(style.borderTopWidth) || 0);
            var left = rect.left + (parseInt(rect.borderLeftWidth) || 0);
            var maxTop = rect.bottom - top - text.clientHeight - 2;
            var move = function(e) {
                dom.translate(text, e.clientX - left - 2, Math.min(e.clientY - top - 2, maxTop));
            };
            move(e);
            if (e.type != "mousedown") return;
            host.renderer.$isMousePressed = true;
            clearTimeout(closeTimeout);
            if (useragent.isWin) event.capture(host.container, move, onContextMenuClose);
        };
        this.onContextMenuClose = onContextMenuClose;
        var closeTimeout;
        function onContextMenuClose() {
            clearTimeout(closeTimeout);
            closeTimeout = setTimeout(function() {
                if (tempStyle) {
                    text.style.cssText = tempStyle;
                    tempStyle = "";
                }
                host.renderer.$isMousePressed = false;
                if (host.renderer.$keepTextAreaAtCursor) host.renderer.$moveTextAreaToCursor();
            }, 0);
        }
        var onContextMenu = function(e) {
            host.textInput.onContextMenu(e);
            onContextMenuClose();
        };
        event.addListener(text, "mouseup", onContextMenu, host);
        event.addListener(text, "mousedown", function(e) {
            e.preventDefault();
            onContextMenuClose();
        }, host);
        event.addListener(host.renderer.scroller, "contextmenu", onContextMenu, host);
        event.addListener(text, "contextmenu", onContextMenu, host);
        if (isIOS) addIosSelectionHandler(parentNode, host, text);
        function addIosSelectionHandler(parentNode, host, text) {
            var typingResetTimeout = null;
            var typing = false;
            text.addEventListener("keydown", function(e) {
                if (typingResetTimeout) clearTimeout(typingResetTimeout);
                typing = true;
            }, true);
            text.addEventListener("keyup", function(e) {
                typingResetTimeout = setTimeout(function() {
                    typing = false;
                }, 100);
            }, true);
            var detectArrowKeys = function(e) {
                if (document.activeElement !== text) return;
                if (typing || inComposition || host.$mouseHandler.isMousePressed) return;
                if (copied) return;
                var selectionStart = text.selectionStart;
                var selectionEnd = text.selectionEnd;
                var key = null;
                var modifier = 0;
                if (selectionStart == 0) key = KEYS.up;
                else if (selectionStart == 1) key = KEYS.home;
                else if (selectionEnd > lastSelectionEnd && lastValue[selectionEnd] == "\n") key = KEYS.end;
                else if (selectionStart < lastSelectionStart && lastValue[selectionStart - 1] == " ") {
                    key = KEYS.left;
                    modifier = MODS.option;
                } else if (selectionStart < lastSelectionStart || selectionStart == lastSelectionStart && lastSelectionEnd != lastSelectionStart && selectionStart == selectionEnd) key = KEYS.left;
                else if (selectionEnd > lastSelectionEnd && lastValue.slice(0, selectionEnd).split("\n").length > 2) key = KEYS.down;
                else if (selectionEnd > lastSelectionEnd && lastValue[selectionEnd - 1] == " ") {
                    key = KEYS.right;
                    modifier = MODS.option;
                } else if (selectionEnd > lastSelectionEnd || selectionEnd == lastSelectionEnd && lastSelectionEnd != lastSelectionStart && selectionStart == selectionEnd) key = KEYS.right;
                if (selectionStart !== selectionEnd) modifier |= MODS.shift;
                if (key) {
                    var result = host.onCommandKey({}, modifier, key);
                    if (!result && host.commands) {
                        key = KEYS.keyCodeToString(key);
                        var command = host.commands.findKeyCommand(modifier, key);
                        if (command) host.execCommand(command);
                    }
                    lastSelectionStart = selectionStart;
                    lastSelectionEnd = selectionEnd;
                    resetSelection("");
                }
            };
            document.addEventListener("selectionchange", detectArrowKeys);
            host.on("destroy", function() {
                document.removeEventListener("selectionchange", detectArrowKeys);
            });
        }
        this.destroy = function() {
            if (text.parentElement) text.parentElement.removeChild(text);
        };
    };
    exports.TextInput = TextInput;
    exports.$setUserAgentForTests = function(_isMobile, _isIOS) {
        isMobile = _isMobile;
        isIOS = _isIOS;
    };
});
ace.define("ace/mouse/default_handlers", [
    "require",
    "exports",
    "module",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var useragent = require("../lib/useragent");
    var DRAG_OFFSET = 0; // pixels
    var SCROLL_COOLDOWN_T = 550; // milliseconds
    var DefaultHandlers = /** @class */ function() {
        function DefaultHandlers(mouseHandler) {
            mouseHandler.$clickSelection = null;
            var editor = mouseHandler.editor;
            editor.setDefaultHandler("mousedown", this.onMouseDown.bind(mouseHandler));
            editor.setDefaultHandler("dblclick", this.onDoubleClick.bind(mouseHandler));
            editor.setDefaultHandler("tripleclick", this.onTripleClick.bind(mouseHandler));
            editor.setDefaultHandler("quadclick", this.onQuadClick.bind(mouseHandler));
            editor.setDefaultHandler("mousewheel", this.onMouseWheel.bind(mouseHandler));
            var exports = [
                "select",
                "startSelect",
                "selectEnd",
                "selectAllEnd",
                "selectByWordsEnd",
                "selectByLinesEnd",
                "dragWait",
                "dragWaitEnd",
                "focusWait"
            ];
            exports.forEach(function(x) {
                mouseHandler[x] = this[x];
            }, this);
            mouseHandler.selectByLines = this.extendSelectionBy.bind(mouseHandler, "getLineRange");
            mouseHandler.selectByWords = this.extendSelectionBy.bind(mouseHandler, "getWordRange");
        }
        DefaultHandlers.prototype.onMouseDown = function(ev) {
            var inSelection = ev.inSelection();
            var pos = ev.getDocumentPosition();
            this.mousedownEvent = ev;
            var editor = this.editor;
            var button = ev.getButton();
            if (button !== 0) {
                var selectionRange = editor.getSelectionRange();
                var selectionEmpty = selectionRange.isEmpty();
                if (selectionEmpty || button == 1) editor.selection.moveToPosition(pos);
                if (button == 2) {
                    editor.textInput.onContextMenu(ev.domEvent);
                    if (!useragent.isMozilla) ev.preventDefault();
                }
                return;
            }
            this.mousedownEvent.time = Date.now();
            if (inSelection && !editor.isFocused()) {
                editor.focus();
                if (this.$focusTimeout && !this.$clickSelection && !editor.inMultiSelectMode) {
                    this.setState("focusWait");
                    this.captureMouse(ev);
                    return;
                }
            }
            this.captureMouse(ev);
            this.startSelect(pos, ev.domEvent._clicks > 1);
            return ev.preventDefault();
        };
        DefaultHandlers.prototype.startSelect = function(pos, waitForClickSelection) {
            pos = pos || this.editor.renderer.screenToTextCoordinates(this.x, this.y);
            var editor = this.editor;
            if (!this.mousedownEvent) return;
            if (this.mousedownEvent.getShiftKey()) editor.selection.selectToPosition(pos);
            else if (!waitForClickSelection) editor.selection.moveToPosition(pos);
            if (!waitForClickSelection) this.select();
            editor.setStyle("ace_selecting");
            this.setState("select");
        };
        DefaultHandlers.prototype.select = function() {
            var anchor, editor = this.editor;
            var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
            if (this.$clickSelection) {
                var cmp = this.$clickSelection.comparePoint(cursor);
                if (cmp == -1) anchor = this.$clickSelection.end;
                else if (cmp == 1) anchor = this.$clickSelection.start;
                else {
                    var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
                    cursor = orientedRange.cursor;
                    anchor = orientedRange.anchor;
                }
                editor.selection.setSelectionAnchor(anchor.row, anchor.column);
            }
            editor.selection.selectToPosition(cursor);
            editor.renderer.scrollCursorIntoView();
        };
        DefaultHandlers.prototype.extendSelectionBy = function(unitName) {
            var anchor, editor = this.editor;
            var cursor = editor.renderer.screenToTextCoordinates(this.x, this.y);
            var range = editor.selection[unitName](cursor.row, cursor.column);
            if (this.$clickSelection) {
                var cmpStart = this.$clickSelection.comparePoint(range.start);
                var cmpEnd = this.$clickSelection.comparePoint(range.end);
                if (cmpStart == -1 && cmpEnd <= 0) {
                    anchor = this.$clickSelection.end;
                    if (range.end.row != cursor.row || range.end.column != cursor.column) cursor = range.start;
                } else if (cmpEnd == 1 && cmpStart >= 0) {
                    anchor = this.$clickSelection.start;
                    if (range.start.row != cursor.row || range.start.column != cursor.column) cursor = range.end;
                } else if (cmpStart == -1 && cmpEnd == 1) {
                    cursor = range.end;
                    anchor = range.start;
                } else {
                    var orientedRange = calcRangeOrientation(this.$clickSelection, cursor);
                    cursor = orientedRange.cursor;
                    anchor = orientedRange.anchor;
                }
                editor.selection.setSelectionAnchor(anchor.row, anchor.column);
            }
            editor.selection.selectToPosition(cursor);
            editor.renderer.scrollCursorIntoView();
        };
        DefaultHandlers.prototype.selectByLinesEnd = function() {
            this.$clickSelection = null;
            this.editor.unsetStyle("ace_selecting");
        };
        DefaultHandlers.prototype.focusWait = function() {
            var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
            var time = Date.now();
            if (distance > DRAG_OFFSET || time - this.mousedownEvent.time > this.$focusTimeout) this.startSelect(this.mousedownEvent.getDocumentPosition());
        };
        DefaultHandlers.prototype.onDoubleClick = function(ev) {
            var pos = ev.getDocumentPosition();
            var editor = this.editor;
            var session = editor.session;
            var range = session.getBracketRange(pos);
            if (range) {
                if (range.isEmpty()) {
                    range.start.column--;
                    range.end.column++;
                }
                this.setState("select");
            } else {
                range = editor.selection.getWordRange(pos.row, pos.column);
                this.setState("selectByWords");
            }
            this.$clickSelection = range;
            this.select();
        };
        DefaultHandlers.prototype.onTripleClick = function(ev) {
            var pos = ev.getDocumentPosition();
            var editor = this.editor;
            this.setState("selectByLines");
            var range = editor.getSelectionRange();
            if (range.isMultiLine() && range.contains(pos.row, pos.column)) {
                this.$clickSelection = editor.selection.getLineRange(range.start.row);
                this.$clickSelection.end = editor.selection.getLineRange(range.end.row).end;
            } else this.$clickSelection = editor.selection.getLineRange(pos.row);
            this.select();
        };
        DefaultHandlers.prototype.onQuadClick = function(ev) {
            var editor = this.editor;
            editor.selectAll();
            this.$clickSelection = editor.getSelectionRange();
            this.setState("selectAll");
        };
        DefaultHandlers.prototype.onMouseWheel = function(ev) {
            if (ev.getAccelKey()) return;
            if (ev.getShiftKey() && ev.wheelY && !ev.wheelX) {
                ev.wheelX = ev.wheelY;
                ev.wheelY = 0;
            }
            var editor = this.editor;
            if (!this.$lastScroll) this.$lastScroll = {
                t: 0,
                vx: 0,
                vy: 0,
                allowed: 0
            };
            var prevScroll = this.$lastScroll;
            var t = ev.domEvent.timeStamp;
            var dt = t - prevScroll.t;
            var vx = dt ? ev.wheelX / dt : prevScroll.vx;
            var vy = dt ? ev.wheelY / dt : prevScroll.vy;
            if (dt < SCROLL_COOLDOWN_T) {
                vx = (vx + prevScroll.vx) / 2;
                vy = (vy + prevScroll.vy) / 2;
            }
            var direction = Math.abs(vx / vy);
            var canScroll = false;
            if (direction >= 1 && editor.renderer.isScrollableBy(ev.wheelX * ev.speed, 0)) canScroll = true;
            if (direction <= 1 && editor.renderer.isScrollableBy(0, ev.wheelY * ev.speed)) canScroll = true;
            if (canScroll) prevScroll.allowed = t;
            else if (t - prevScroll.allowed < SCROLL_COOLDOWN_T) {
                var isSlower = Math.abs(vx) <= 1.5 * Math.abs(prevScroll.vx) && Math.abs(vy) <= 1.5 * Math.abs(prevScroll.vy);
                if (isSlower) {
                    canScroll = true;
                    prevScroll.allowed = t;
                } else prevScroll.allowed = 0;
            }
            prevScroll.t = t;
            prevScroll.vx = vx;
            prevScroll.vy = vy;
            if (canScroll) {
                editor.renderer.scrollBy(ev.wheelX * ev.speed, ev.wheelY * ev.speed);
                return ev.stop();
            }
        };
        return DefaultHandlers;
    }();
    DefaultHandlers.prototype.selectEnd = DefaultHandlers.prototype.selectByLinesEnd;
    DefaultHandlers.prototype.selectAllEnd = DefaultHandlers.prototype.selectByLinesEnd;
    DefaultHandlers.prototype.selectByWordsEnd = DefaultHandlers.prototype.selectByLinesEnd;
    exports.DefaultHandlers = DefaultHandlers;
    function calcDistance(ax, ay, bx, by) {
        return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
    }
    function calcRangeOrientation(range, cursor) {
        if (range.start.row == range.end.row) var cmp = 2 * cursor.column - range.start.column - range.end.column;
        else if (range.start.row == range.end.row - 1 && !range.start.column && !range.end.column) var cmp = cursor.column - 4;
        else var cmp = 2 * cursor.row - range.start.row - range.end.row;
        if (cmp < 0) return {
            cursor: range.start,
            anchor: range.end
        };
        else return {
            cursor: range.end,
            anchor: range.start
        };
    }
});
ace.define("ace/tooltip", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __values = this && this.__values || function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function() {
                if (o && i >= o.length) o = void 0;
                return {
                    value: o && o[i++],
                    done: !o
                };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    var dom = require("./lib/dom");
    var Range = require("./range").Range;
    var CLASSNAME = "ace_tooltip";
    var Tooltip = /** @class */ function() {
        function Tooltip(parentNode) {
            this.isOpen = false;
            this.$element = null;
            this.$parentNode = parentNode;
        }
        Tooltip.prototype.$init = function() {
            this.$element = dom.createElement("div");
            this.$element.className = CLASSNAME;
            this.$element.style.display = "none";
            this.$parentNode.appendChild(this.$element);
            return this.$element;
        };
        Tooltip.prototype.getElement = function() {
            return this.$element || this.$init();
        };
        Tooltip.prototype.setText = function(text) {
            this.getElement().textContent = text;
        };
        Tooltip.prototype.setHtml = function(html) {
            this.getElement().innerHTML = html;
        };
        Tooltip.prototype.setPosition = function(x, y) {
            this.getElement().style.left = x + "px";
            this.getElement().style.top = y + "px";
        };
        Tooltip.prototype.setClassName = function(className) {
            dom.addCssClass(this.getElement(), className);
        };
        Tooltip.prototype.setTheme = function(theme) {
            this.$element.className = CLASSNAME + " " + (theme.isDark ? "ace_dark " : "") + (theme.cssClass || "");
        };
        Tooltip.prototype.show = function(text, x, y) {
            if (text != null) this.setText(text);
            if (x != null && y != null) this.setPosition(x, y);
            if (!this.isOpen) {
                this.getElement().style.display = "block";
                this.isOpen = true;
            }
        };
        Tooltip.prototype.hide = function() {
            if (this.isOpen) {
                this.getElement().style.display = "none";
                this.getElement().className = CLASSNAME;
                this.isOpen = false;
            }
        };
        Tooltip.prototype.getHeight = function() {
            return this.getElement().offsetHeight;
        };
        Tooltip.prototype.getWidth = function() {
            return this.getElement().offsetWidth;
        };
        Tooltip.prototype.destroy = function() {
            this.isOpen = false;
            if (this.$element && this.$element.parentNode) this.$element.parentNode.removeChild(this.$element);
        };
        return Tooltip;
    }();
    var PopupManager = /** @class */ function() {
        function PopupManager() {
            this.popups = [];
        }
        PopupManager.prototype.addPopup = function(popup) {
            this.popups.push(popup);
            this.updatePopups();
        };
        PopupManager.prototype.removePopup = function(popup) {
            var index = this.popups.indexOf(popup);
            if (index !== -1) {
                this.popups.splice(index, 1);
                this.updatePopups();
            }
        };
        PopupManager.prototype.updatePopups = function() {
            var e_1, _a, e_2, _b;
            this.popups.sort(function(a, b) {
                return b.priority - a.priority;
            });
            var visiblepopups = [];
            try {
                for(var _c = __values(this.popups), _d = _c.next(); !_d.done; _d = _c.next()){
                    var popup = _d.value;
                    var shouldDisplay = true;
                    try {
                        for(var visiblepopups_1 = (e_2 = void 0, __values(visiblepopups)), visiblepopups_1_1 = visiblepopups_1.next(); !visiblepopups_1_1.done; visiblepopups_1_1 = visiblepopups_1.next()){
                            var visiblePopup = visiblepopups_1_1.value;
                            if (this.doPopupsOverlap(visiblePopup, popup)) {
                                shouldDisplay = false;
                                break;
                            }
                        }
                    } catch (e_2_1) {
                        e_2 = {
                            error: e_2_1
                        };
                    } finally{
                        try {
                            if (visiblepopups_1_1 && !visiblepopups_1_1.done && (_b = visiblepopups_1.return)) _b.call(visiblepopups_1);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                    }
                    if (shouldDisplay) visiblepopups.push(popup);
                    else popup.hide();
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        };
        PopupManager.prototype.doPopupsOverlap = function(popupA, popupB) {
            var rectA = popupA.getElement().getBoundingClientRect();
            var rectB = popupB.getElement().getBoundingClientRect();
            return rectA.left < rectB.right && rectA.right > rectB.left && rectA.top < rectB.bottom && rectA.bottom > rectB.top;
        };
        return PopupManager;
    }();
    var popupManager = new PopupManager();
    exports.popupManager = popupManager;
    exports.Tooltip = Tooltip;
    var HoverTooltip = /** @class */ function(_super) {
        __extends(HoverTooltip, _super);
        function HoverTooltip(parentNode) {
            if (parentNode === void 0) parentNode = document.body;
            var _this = _super.call(this, parentNode) || this;
            _this.timeout = undefined;
            _this.lastT = 0;
            _this.idleTime = 350;
            _this.lastEvent = undefined;
            _this.onMouseOut = _this.onMouseOut.bind(_this);
            _this.onMouseMove = _this.onMouseMove.bind(_this);
            _this.waitForHover = _this.waitForHover.bind(_this);
            _this.hide = _this.hide.bind(_this);
            var el = _this.getElement();
            el.style.whiteSpace = "pre-wrap";
            el.style.pointerEvents = "auto";
            el.addEventListener("mouseout", _this.onMouseOut);
            el.tabIndex = -1;
            el.addEventListener("blur", (function() {
                if (!el.contains(document.activeElement)) this.hide();
            }).bind(_this));
            return _this;
        }
        HoverTooltip.prototype.addToEditor = function(editor) {
            editor.on("mousemove", this.onMouseMove);
            editor.on("mousedown", this.hide);
            editor.renderer.getMouseEventTarget().addEventListener("mouseout", this.onMouseOut, true);
        };
        HoverTooltip.prototype.removeFromEditor = function(editor) {
            editor.off("mousemove", this.onMouseMove);
            editor.off("mousedown", this.hide);
            editor.renderer.getMouseEventTarget().removeEventListener("mouseout", this.onMouseOut, true);
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
        };
        HoverTooltip.prototype.onMouseMove = function(e, editor) {
            this.lastEvent = e;
            this.lastT = Date.now();
            var isMousePressed = editor.$mouseHandler.isMousePressed;
            if (this.isOpen) {
                var pos = this.lastEvent && this.lastEvent.getDocumentPosition();
                if (!this.range || !this.range.contains(pos.row, pos.column) || isMousePressed || this.isOutsideOfText(this.lastEvent)) this.hide();
            }
            if (this.timeout || isMousePressed) return;
            this.lastEvent = e;
            this.timeout = setTimeout(this.waitForHover, this.idleTime);
        };
        HoverTooltip.prototype.waitForHover = function() {
            if (this.timeout) clearTimeout(this.timeout);
            var dt = Date.now() - this.lastT;
            if (this.idleTime - dt > 10) {
                this.timeout = setTimeout(this.waitForHover, this.idleTime - dt);
                return;
            }
            this.timeout = null;
            if (this.lastEvent && !this.isOutsideOfText(this.lastEvent)) this.$gatherData(this.lastEvent, this.lastEvent.editor);
        };
        HoverTooltip.prototype.isOutsideOfText = function(e) {
            var editor = e.editor;
            var docPos = e.getDocumentPosition();
            var line = editor.session.getLine(docPos.row);
            if (docPos.column == line.length) {
                var screenPos = editor.renderer.pixelToScreenCoordinates(e.clientX, e.clientY);
                var clippedPos = editor.session.documentToScreenPosition(docPos.row, docPos.column);
                if (clippedPos.column != screenPos.column || clippedPos.row != screenPos.row) return true;
            }
            return false;
        };
        HoverTooltip.prototype.setDataProvider = function(value) {
            this.$gatherData = value;
        };
        HoverTooltip.prototype.showForRange = function(editor, range, domNode, startingEvent) {
            if (startingEvent && startingEvent != this.lastEvent) return;
            if (this.isOpen && document.activeElement == this.getElement()) return;
            var renderer = editor.renderer;
            if (!this.isOpen) {
                popupManager.addPopup(this);
                this.$registerCloseEvents();
                this.setTheme(renderer.theme);
            }
            this.isOpen = true;
            this.addMarker(range, editor.session);
            this.range = Range.fromPoints(range.start, range.end);
            var element = this.getElement();
            element.innerHTML = "";
            element.appendChild(domNode);
            element.style.display = "block";
            var position = renderer.textToScreenCoordinates(range.start.row, range.start.column);
            var cursorPos = editor.getCursorPosition();
            var labelHeight = element.clientHeight;
            var rect = renderer.scroller.getBoundingClientRect();
            var isTopdown = true;
            if (this.row > cursorPos.row) isTopdown = true;
            else if (this.row < cursorPos.row) isTopdown = false;
            if (position.pageY - labelHeight + renderer.lineHeight < rect.top) isTopdown = true;
            else if (position.pageY + labelHeight > rect.bottom) isTopdown = false;
            if (!isTopdown) position.pageY -= labelHeight;
            else position.pageY += renderer.lineHeight;
            element.style.maxWidth = rect.width - (position.pageX - rect.left) + "px";
            this.setPosition(position.pageX, position.pageY);
        };
        HoverTooltip.prototype.addMarker = function(range, session) {
            if (this.marker) this.$markerSession.removeMarker(this.marker);
            this.$markerSession = session;
            this.marker = session && session.addMarker(range, "ace_highlight-marker", "text");
        };
        HoverTooltip.prototype.hide = function(e) {
            if (!e && document.activeElement == this.getElement()) return;
            if (e && e.target && (e.type != "keydown" || e.ctrlKey || e.metaKey) && this.$element.contains(e.target)) return;
            this.lastEvent = null;
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = null;
            this.addMarker(null);
            if (this.isOpen) {
                this.$removeCloseEvents();
                this.getElement().style.display = "none";
                this.isOpen = false;
                popupManager.removePopup(this);
            }
        };
        HoverTooltip.prototype.$registerCloseEvents = function() {
            window.addEventListener("keydown", this.hide, true);
            window.addEventListener("mousewheel", this.hide, true);
            window.addEventListener("mousedown", this.hide, true);
        };
        HoverTooltip.prototype.$removeCloseEvents = function() {
            window.removeEventListener("keydown", this.hide, true);
            window.removeEventListener("mousewheel", this.hide, true);
            window.removeEventListener("mousedown", this.hide, true);
        };
        HoverTooltip.prototype.onMouseOut = function(e) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.lastEvent = null;
            if (!this.isOpen) return;
            if (!e.relatedTarget || e.relatedTarget == this.getElement()) return;
            if (e && e.currentTarget.contains(e.relatedTarget)) return;
            if (!e.relatedTarget.classList.contains("ace_content")) this.hide();
        };
        return HoverTooltip;
    }(Tooltip);
    exports.HoverTooltip = HoverTooltip;
});
ace.define("ace/mouse/default_gutter_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/tooltip",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __values = this && this.__values || function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function() {
                if (o && i >= o.length) o = void 0;
                return {
                    value: o && o[i++],
                    done: !o
                };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    var dom = require("../lib/dom");
    var event = require("../lib/event");
    var Tooltip = require("../tooltip").Tooltip;
    var nls = require("../config").nls;
    function GutterHandler(mouseHandler) {
        var editor = mouseHandler.editor;
        var gutter = editor.renderer.$gutterLayer;
        var tooltip = new GutterTooltip(editor);
        mouseHandler.editor.setDefaultHandler("guttermousedown", function(e) {
            if (!editor.isFocused() || e.getButton() != 0) return;
            var gutterRegion = gutter.getRegion(e);
            if (gutterRegion == "foldWidgets") return;
            var row = e.getDocumentPosition().row;
            var selection = editor.session.selection;
            if (e.getShiftKey()) selection.selectTo(row, 0);
            else {
                if (e.domEvent.detail == 2) {
                    editor.selectAll();
                    return e.preventDefault();
                }
                mouseHandler.$clickSelection = editor.selection.getLineRange(row);
            }
            mouseHandler.setState("selectByLines");
            mouseHandler.captureMouse(e);
            return e.preventDefault();
        });
        var tooltipTimeout, mouseEvent;
        function showTooltip() {
            var row = mouseEvent.getDocumentPosition().row;
            var maxRow = editor.session.getLength();
            if (row == maxRow) {
                var screenRow = editor.renderer.pixelToScreenCoordinates(0, mouseEvent.y).row;
                var pos = mouseEvent.$pos;
                if (screenRow > editor.session.documentToScreenRow(pos.row, pos.column)) return hideTooltip();
            }
            tooltip.showTooltip(row);
            if (!tooltip.isOpen) return;
            editor.on("mousewheel", hideTooltip);
            if (mouseHandler.$tooltipFollowsMouse) moveTooltip(mouseEvent);
            else {
                var gutterRow = mouseEvent.getGutterRow();
                var gutterCell = gutter.$lines.get(gutterRow);
                if (gutterCell) {
                    var gutterElement = gutterCell.element.querySelector(".ace_gutter_annotation");
                    var rect = gutterElement.getBoundingClientRect();
                    var style = tooltip.getElement().style;
                    style.left = rect.right + "px";
                    style.top = rect.bottom + "px";
                } else moveTooltip(mouseEvent);
            }
        }
        function hideTooltip() {
            if (tooltipTimeout) tooltipTimeout = clearTimeout(tooltipTimeout);
            if (tooltip.isOpen) {
                tooltip.hideTooltip();
                editor.off("mousewheel", hideTooltip);
            }
        }
        function moveTooltip(e) {
            tooltip.setPosition(e.x, e.y);
        }
        mouseHandler.editor.setDefaultHandler("guttermousemove", function(e) {
            var target = e.domEvent.target || e.domEvent.srcElement;
            if (dom.hasCssClass(target, "ace_fold-widget")) return hideTooltip();
            if (tooltip.isOpen && mouseHandler.$tooltipFollowsMouse) moveTooltip(e);
            mouseEvent = e;
            if (tooltipTimeout) return;
            tooltipTimeout = setTimeout(function() {
                tooltipTimeout = null;
                if (mouseEvent && !mouseHandler.isMousePressed) showTooltip();
                else hideTooltip();
            }, 50);
        });
        event.addListener(editor.renderer.$gutter, "mouseout", function(e) {
            mouseEvent = null;
            if (!tooltip.isOpen || tooltipTimeout) return;
            tooltipTimeout = setTimeout(function() {
                tooltipTimeout = null;
                hideTooltip();
            }, 50);
        }, editor);
        editor.on("changeSession", hideTooltip);
        editor.on("input", hideTooltip);
    }
    exports.GutterHandler = GutterHandler;
    var GutterTooltip = /** @class */ function(_super) {
        __extends(GutterTooltip, _super);
        function GutterTooltip(editor) {
            var _this = _super.call(this, editor.container) || this;
            _this.editor = editor;
            return _this;
        }
        GutterTooltip.prototype.setPosition = function(x, y) {
            var windowWidth = window.innerWidth || document.documentElement.clientWidth;
            var windowHeight = window.innerHeight || document.documentElement.clientHeight;
            var width = this.getWidth();
            var height = this.getHeight();
            x += 15;
            y += 15;
            if (x + width > windowWidth) x -= x + width - windowWidth;
            if (y + height > windowHeight) y -= 20 + height;
            Tooltip.prototype.setPosition.call(this, x, y);
        };
        Object.defineProperty(GutterTooltip, "annotationLabels", {
            get: function() {
                return {
                    error: {
                        singular: nls("error"),
                        plural: nls("errors")
                    },
                    warning: {
                        singular: nls("warning"),
                        plural: nls("warnings")
                    },
                    info: {
                        singular: nls("information message"),
                        plural: nls("information messages")
                    }
                };
            },
            enumerable: false,
            configurable: true
        });
        GutterTooltip.prototype.showTooltip = function(row) {
            var gutter = this.editor.renderer.$gutterLayer;
            var annotationsInRow = gutter.$annotations[row];
            var annotation;
            if (annotationsInRow) annotation = {
                text: Array.from(annotationsInRow.text),
                type: Array.from(annotationsInRow.type)
            };
            else annotation = {
                text: [],
                type: []
            };
            var fold = gutter.session.getFoldLine(row);
            if (fold && gutter.$showFoldedAnnotations) {
                var annotationsInFold = {
                    error: [],
                    warning: [],
                    info: []
                };
                var mostSevereAnnotationInFoldType;
                for(var i = row + 1; i <= fold.end.row; i++){
                    if (!gutter.$annotations[i]) continue;
                    for(var j = 0; j < gutter.$annotations[i].text.length; j++){
                        var annotationType = gutter.$annotations[i].type[j];
                        annotationsInFold[annotationType].push(gutter.$annotations[i].text[j]);
                        if (annotationType === "error") {
                            mostSevereAnnotationInFoldType = "error_fold";
                            continue;
                        }
                        if (annotationType === "warning") {
                            mostSevereAnnotationInFoldType = "warning_fold";
                            continue;
                        }
                    }
                }
                if (mostSevereAnnotationInFoldType === "error_fold" || mostSevereAnnotationInFoldType === "warning_fold") {
                    var summaryFoldedAnnotations = "".concat(GutterTooltip.annotationsToSummaryString(annotationsInFold), " in folded code.");
                    annotation.text.push(summaryFoldedAnnotations);
                    annotation.type.push(mostSevereAnnotationInFoldType);
                }
            }
            if (annotation.text.length === 0) return this.hide();
            var annotationMessages = {
                error: [],
                warning: [],
                info: []
            };
            var iconClassName = gutter.$useSvgGutterIcons ? "ace_icon_svg" : "ace_icon";
            for(var i = 0; i < annotation.text.length; i++){
                var line = "<span class='ace_".concat(annotation.type[i], " ").concat(iconClassName, "' aria-label='").concat(GutterTooltip.annotationLabels[annotation.type[i].replace("_fold", "")].singular, "' role=img> </span> ").concat(annotation.text[i]);
                annotationMessages[annotation.type[i].replace("_fold", "")].push(line);
            }
            var tooltipContent = [].concat(annotationMessages.error, annotationMessages.warning, annotationMessages.info).join("<br>");
            this.setHtml(tooltipContent);
            this.$element.setAttribute("aria-live", "polite");
            if (!this.isOpen) {
                this.setTheme(this.editor.renderer.theme);
                this.setClassName("ace_gutter-tooltip");
            }
            this.show();
            this.editor._signal("showGutterTooltip", this);
        };
        GutterTooltip.prototype.hideTooltip = function() {
            this.$element.removeAttribute("aria-live");
            this.hide();
            this.editor._signal("hideGutterTooltip", this);
        };
        GutterTooltip.annotationsToSummaryString = function(annotations) {
            var e_1, _a;
            var summary = [];
            var annotationTypes = [
                "error",
                "warning",
                "info"
            ];
            try {
                for(var annotationTypes_1 = __values(annotationTypes), annotationTypes_1_1 = annotationTypes_1.next(); !annotationTypes_1_1.done; annotationTypes_1_1 = annotationTypes_1.next()){
                    var annotationType = annotationTypes_1_1.value;
                    if (!annotations[annotationType].length) continue;
                    var label = annotations[annotationType].length === 1 ? GutterTooltip.annotationLabels[annotationType].singular : GutterTooltip.annotationLabels[annotationType].plural;
                    summary.push("".concat(annotations[annotationType].length, " ").concat(label));
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (annotationTypes_1_1 && !annotationTypes_1_1.done && (_a = annotationTypes_1.return)) _a.call(annotationTypes_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return summary.join(", ");
        };
        return GutterTooltip;
    }(Tooltip);
    exports.GutterTooltip = GutterTooltip;
});
ace.define("ace/mouse/mouse_event", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var event = require("../lib/event");
    var useragent = require("../lib/useragent");
    var MouseEvent = /** @class */ function() {
        function MouseEvent(domEvent, editor) {
            this.domEvent = domEvent;
            this.editor = editor;
            this.x = this.clientX = domEvent.clientX;
            this.y = this.clientY = domEvent.clientY;
            this.$pos = null;
            this.$inSelection = null;
            this.propagationStopped = false;
            this.defaultPrevented = false;
        }
        MouseEvent.prototype.stopPropagation = function() {
            event.stopPropagation(this.domEvent);
            this.propagationStopped = true;
        };
        MouseEvent.prototype.preventDefault = function() {
            event.preventDefault(this.domEvent);
            this.defaultPrevented = true;
        };
        MouseEvent.prototype.stop = function() {
            this.stopPropagation();
            this.preventDefault();
        };
        MouseEvent.prototype.getDocumentPosition = function() {
            if (this.$pos) return this.$pos;
            this.$pos = this.editor.renderer.screenToTextCoordinates(this.clientX, this.clientY);
            return this.$pos;
        };
        MouseEvent.prototype.getGutterRow = function() {
            var documentRow = this.getDocumentPosition().row;
            var screenRow = this.editor.session.documentToScreenRow(documentRow, 0);
            var screenTopRow = this.editor.session.documentToScreenRow(this.editor.renderer.$gutterLayer.$lines.get(0).row, 0);
            return screenRow - screenTopRow;
        };
        MouseEvent.prototype.inSelection = function() {
            if (this.$inSelection !== null) return this.$inSelection;
            var editor = this.editor;
            var selectionRange = editor.getSelectionRange();
            if (selectionRange.isEmpty()) this.$inSelection = false;
            else {
                var pos = this.getDocumentPosition();
                this.$inSelection = selectionRange.contains(pos.row, pos.column);
            }
            return this.$inSelection;
        };
        MouseEvent.prototype.getButton = function() {
            return event.getButton(this.domEvent);
        };
        MouseEvent.prototype.getShiftKey = function() {
            return this.domEvent.shiftKey;
        };
        MouseEvent.prototype.getAccelKey = function() {
            return useragent.isMac ? this.domEvent.metaKey : this.domEvent.ctrlKey;
        };
        return MouseEvent;
    }();
    exports.MouseEvent = MouseEvent;
});
ace.define("ace/mouse/dragdrop_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var event = require("../lib/event");
    var useragent = require("../lib/useragent");
    var AUTOSCROLL_DELAY = 200;
    var SCROLL_CURSOR_DELAY = 200;
    var SCROLL_CURSOR_HYSTERESIS = 5;
    function DragdropHandler(mouseHandler) {
        var editor = mouseHandler.editor;
        var dragImage = dom.createElement("div");
        dragImage.style.cssText = "top:-100px;position:absolute;z-index:2147483647;opacity:0.5";
        dragImage.textContent = "\xa0";
        var exports = [
            "dragWait",
            "dragWaitEnd",
            "startDrag",
            "dragReadyEnd",
            "onMouseDrag"
        ];
        exports.forEach(function(x) {
            mouseHandler[x] = this[x];
        }, this);
        editor.on("mousedown", this.onMouseDown.bind(mouseHandler));
        var mouseTarget = editor.container;
        var dragSelectionMarker, x, y;
        var timerId, range;
        var dragCursor, counter = 0;
        var dragOperation;
        var isInternal;
        var autoScrollStartTime;
        var cursorMovedTime;
        var cursorPointOnCaretMoved;
        this.onDragStart = function(e) {
            if (this.cancelDrag || !mouseTarget.draggable) {
                var self1 = this;
                setTimeout(function() {
                    self1.startSelect();
                    self1.captureMouse(e);
                }, 0);
                return e.preventDefault();
            }
            range = editor.getSelectionRange();
            var dataTransfer = e.dataTransfer;
            dataTransfer.effectAllowed = editor.getReadOnly() ? "copy" : "copyMove";
            editor.container.appendChild(dragImage);
            dataTransfer.setDragImage && dataTransfer.setDragImage(dragImage, 0, 0);
            setTimeout(function() {
                editor.container.removeChild(dragImage);
            });
            dataTransfer.clearData();
            dataTransfer.setData("Text", editor.session.getTextRange());
            isInternal = true;
            this.setState("drag");
        };
        this.onDragEnd = function(e) {
            mouseTarget.draggable = false;
            isInternal = false;
            this.setState(null);
            if (!editor.getReadOnly()) {
                var dropEffect = e.dataTransfer.dropEffect;
                if (!dragOperation && dropEffect == "move") editor.session.remove(editor.getSelectionRange());
                editor.$resetCursorStyle();
            }
            this.editor.unsetStyle("ace_dragging");
            this.editor.renderer.setCursorStyle("");
        };
        this.onDragEnter = function(e) {
            if (editor.getReadOnly() || !canAccept(e.dataTransfer)) return;
            x = e.clientX;
            y = e.clientY;
            if (!dragSelectionMarker) addDragMarker();
            counter++;
            e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
            return event.preventDefault(e);
        };
        this.onDragOver = function(e) {
            if (editor.getReadOnly() || !canAccept(e.dataTransfer)) return;
            x = e.clientX;
            y = e.clientY;
            if (!dragSelectionMarker) {
                addDragMarker();
                counter++;
            }
            if (onMouseMoveTimer !== null) onMouseMoveTimer = null;
            e.dataTransfer.dropEffect = dragOperation = getDropEffect(e);
            return event.preventDefault(e);
        };
        this.onDragLeave = function(e) {
            counter--;
            if (counter <= 0 && dragSelectionMarker) {
                clearDragMarker();
                dragOperation = null;
                return event.preventDefault(e);
            }
        };
        this.onDrop = function(e) {
            if (!dragCursor) return;
            var dataTransfer = e.dataTransfer;
            if (isInternal) switch(dragOperation){
                case "move":
                    if (range.contains(dragCursor.row, dragCursor.column)) range = {
                        start: dragCursor,
                        end: dragCursor
                    };
                    else range = editor.moveText(range, dragCursor);
                    break;
                case "copy":
                    range = editor.moveText(range, dragCursor, true);
                    break;
            }
            else {
                var dropData = dataTransfer.getData("Text");
                range = {
                    start: dragCursor,
                    end: editor.session.insert(dragCursor, dropData)
                };
                editor.focus();
                dragOperation = null;
            }
            clearDragMarker();
            return event.preventDefault(e);
        };
        event.addListener(mouseTarget, "dragstart", this.onDragStart.bind(mouseHandler), editor);
        event.addListener(mouseTarget, "dragend", this.onDragEnd.bind(mouseHandler), editor);
        event.addListener(mouseTarget, "dragenter", this.onDragEnter.bind(mouseHandler), editor);
        event.addListener(mouseTarget, "dragover", this.onDragOver.bind(mouseHandler), editor);
        event.addListener(mouseTarget, "dragleave", this.onDragLeave.bind(mouseHandler), editor);
        event.addListener(mouseTarget, "drop", this.onDrop.bind(mouseHandler), editor);
        function scrollCursorIntoView(cursor, prevCursor) {
            var now = Date.now();
            var vMovement = !prevCursor || cursor.row != prevCursor.row;
            var hMovement = !prevCursor || cursor.column != prevCursor.column;
            if (!cursorMovedTime || vMovement || hMovement) {
                editor.moveCursorToPosition(cursor);
                cursorMovedTime = now;
                cursorPointOnCaretMoved = {
                    x: x,
                    y: y
                };
            } else {
                var distance = calcDistance(cursorPointOnCaretMoved.x, cursorPointOnCaretMoved.y, x, y);
                if (distance > SCROLL_CURSOR_HYSTERESIS) cursorMovedTime = null;
                else if (now - cursorMovedTime >= SCROLL_CURSOR_DELAY) {
                    editor.renderer.scrollCursorIntoView();
                    cursorMovedTime = null;
                }
            }
        }
        function autoScroll(cursor, prevCursor) {
            var now = Date.now();
            var lineHeight = editor.renderer.layerConfig.lineHeight;
            var characterWidth = editor.renderer.layerConfig.characterWidth;
            var editorRect = editor.renderer.scroller.getBoundingClientRect();
            var offsets = {
                x: {
                    left: x - editorRect.left,
                    right: editorRect.right - x
                },
                y: {
                    top: y - editorRect.top,
                    bottom: editorRect.bottom - y
                }
            };
            var nearestXOffset = Math.min(offsets.x.left, offsets.x.right);
            var nearestYOffset = Math.min(offsets.y.top, offsets.y.bottom);
            var scrollCursor = {
                row: cursor.row,
                column: cursor.column
            };
            if (nearestXOffset / characterWidth <= 2) scrollCursor.column += offsets.x.left < offsets.x.right ? -3 : 2;
            if (nearestYOffset / lineHeight <= 1) scrollCursor.row += offsets.y.top < offsets.y.bottom ? -1 : 1;
            var vScroll = cursor.row != scrollCursor.row;
            var hScroll = cursor.column != scrollCursor.column;
            var vMovement = !prevCursor || cursor.row != prevCursor.row;
            if (vScroll || hScroll && !vMovement) {
                if (!autoScrollStartTime) autoScrollStartTime = now;
                else if (now - autoScrollStartTime >= AUTOSCROLL_DELAY) editor.renderer.scrollCursorIntoView(scrollCursor);
            } else autoScrollStartTime = null;
        }
        function onDragInterval() {
            var prevCursor = dragCursor;
            dragCursor = editor.renderer.screenToTextCoordinates(x, y);
            scrollCursorIntoView(dragCursor, prevCursor);
            autoScroll(dragCursor, prevCursor);
        }
        function addDragMarker() {
            range = editor.selection.toOrientedRange();
            dragSelectionMarker = editor.session.addMarker(range, "ace_selection", editor.getSelectionStyle());
            editor.clearSelection();
            if (editor.isFocused()) editor.renderer.$cursorLayer.setBlinking(false);
            clearInterval(timerId);
            onDragInterval();
            timerId = setInterval(onDragInterval, 20);
            counter = 0;
            event.addListener(document, "mousemove", onMouseMove);
        }
        function clearDragMarker() {
            clearInterval(timerId);
            editor.session.removeMarker(dragSelectionMarker);
            dragSelectionMarker = null;
            editor.selection.fromOrientedRange(range);
            if (editor.isFocused() && !isInternal) editor.$resetCursorStyle();
            range = null;
            dragCursor = null;
            counter = 0;
            autoScrollStartTime = null;
            cursorMovedTime = null;
            event.removeListener(document, "mousemove", onMouseMove);
        }
        var onMouseMoveTimer = null;
        function onMouseMove() {
            if (onMouseMoveTimer == null) onMouseMoveTimer = setTimeout(function() {
                if (onMouseMoveTimer != null && dragSelectionMarker) clearDragMarker();
            }, 20);
        }
        function canAccept(dataTransfer) {
            var types = dataTransfer.types;
            return !types || Array.prototype.some.call(types, function(type) {
                return type == "text/plain" || type == "Text";
            });
        }
        function getDropEffect(e) {
            var copyAllowed = [
                "copy",
                "copymove",
                "all",
                "uninitialized"
            ];
            var moveAllowed = [
                "move",
                "copymove",
                "linkmove",
                "all",
                "uninitialized"
            ];
            var copyModifierState = useragent.isMac ? e.altKey : e.ctrlKey;
            var effectAllowed = "uninitialized";
            try {
                effectAllowed = e.dataTransfer.effectAllowed.toLowerCase();
            } catch (e) {}
            var dropEffect = "none";
            if (copyModifierState && copyAllowed.indexOf(effectAllowed) >= 0) dropEffect = "copy";
            else if (moveAllowed.indexOf(effectAllowed) >= 0) dropEffect = "move";
            else if (copyAllowed.indexOf(effectAllowed) >= 0) dropEffect = "copy";
            return dropEffect;
        }
    }
    (function() {
        this.dragWait = function() {
            var interval = Date.now() - this.mousedownEvent.time;
            if (interval > this.editor.getDragDelay()) this.startDrag();
        };
        this.dragWaitEnd = function() {
            var target = this.editor.container;
            target.draggable = false;
            this.startSelect(this.mousedownEvent.getDocumentPosition());
            this.selectEnd();
        };
        this.dragReadyEnd = function(e) {
            this.editor.$resetCursorStyle();
            this.editor.unsetStyle("ace_dragging");
            this.editor.renderer.setCursorStyle("");
            this.dragWaitEnd();
        };
        this.startDrag = function() {
            this.cancelDrag = false;
            var editor = this.editor;
            var target = editor.container;
            target.draggable = true;
            editor.renderer.$cursorLayer.setBlinking(false);
            editor.setStyle("ace_dragging");
            var cursorStyle = useragent.isWin ? "default" : "move";
            editor.renderer.setCursorStyle(cursorStyle);
            this.setState("dragReady");
        };
        this.onMouseDrag = function(e) {
            var target = this.editor.container;
            if (useragent.isIE && this.state == "dragReady") {
                var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
                if (distance > 3) target.dragDrop();
            }
            if (this.state === "dragWait") {
                var distance = calcDistance(this.mousedownEvent.x, this.mousedownEvent.y, this.x, this.y);
                if (distance > 0) {
                    target.draggable = false;
                    this.startSelect(this.mousedownEvent.getDocumentPosition());
                }
            }
        };
        this.onMouseDown = function(e) {
            if (!this.$dragEnabled) return;
            this.mousedownEvent = e;
            var editor = this.editor;
            var inSelection = e.inSelection();
            var button = e.getButton();
            var clickCount = e.domEvent.detail || 1;
            if (clickCount === 1 && button === 0 && inSelection) {
                if (e.editor.inMultiSelectMode && (e.getAccelKey() || e.getShiftKey())) return;
                this.mousedownEvent.time = Date.now();
                var eventTarget = e.domEvent.target || e.domEvent.srcElement;
                if ("unselectable" in eventTarget) eventTarget.unselectable = "on";
                if (editor.getDragDelay()) {
                    if (useragent.isWebKit) {
                        this.cancelDrag = true;
                        var mouseTarget = editor.container;
                        mouseTarget.draggable = true;
                    }
                    this.setState("dragWait");
                } else this.startDrag();
                this.captureMouse(e, this.onMouseDrag.bind(this));
                e.defaultPrevented = true;
            }
        };
    }).call(DragdropHandler.prototype);
    function calcDistance(ax, ay, bx, by) {
        return Math.sqrt(Math.pow(bx - ax, 2) + Math.pow(by - ay, 2));
    }
    exports.DragdropHandler = DragdropHandler;
});
ace.define("ace/mouse/touch_handler", [
    "require",
    "exports",
    "module",
    "ace/mouse/mouse_event",
    "ace/lib/event",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var MouseEvent = require("./mouse_event").MouseEvent;
    var event = require("../lib/event");
    var dom = require("../lib/dom");
    exports.addTouchListeners = function(el, editor) {
        var mode = "scroll";
        var startX;
        var startY;
        var touchStartT;
        var lastT;
        var longTouchTimer;
        var animationTimer;
        var animationSteps = 0;
        var pos;
        var clickCount = 0;
        var vX = 0;
        var vY = 0;
        var pressed;
        var contextMenu;
        function createContextMenu() {
            var clipboard = window.navigator && window.navigator.clipboard;
            var isOpen = false;
            var updateMenu = function() {
                var selected = editor.getCopyText();
                var hasUndo = editor.session.getUndoManager().hasUndo();
                contextMenu.replaceChild(dom.buildDom(isOpen ? [
                    "span",
                    !selected && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "selectall"
                        },
                        "Select All"
                    ],
                    selected && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "copy"
                        },
                        "Copy"
                    ],
                    selected && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "cut"
                        },
                        "Cut"
                    ],
                    clipboard && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "paste"
                        },
                        "Paste"
                    ],
                    hasUndo && [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "undo"
                        },
                        "Undo"
                    ],
                    [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "find"
                        },
                        "Find"
                    ],
                    [
                        "span",
                        {
                            class: "ace_mobile-button",
                            action: "openCommandPallete"
                        },
                        "Palette"
                    ]
                ] : [
                    "span"
                ]), contextMenu.firstChild);
            };
            var handleClick = function(e) {
                var action = e.target.getAttribute("action");
                if (action == "more" || !isOpen) {
                    isOpen = !isOpen;
                    return updateMenu();
                }
                if (action == "paste") clipboard.readText().then(function(text) {
                    editor.execCommand(action, text);
                });
                else if (action) {
                    if (action == "cut" || action == "copy") {
                        if (clipboard) clipboard.writeText(editor.getCopyText());
                        else document.execCommand("copy");
                    }
                    editor.execCommand(action);
                }
                contextMenu.firstChild.style.display = "none";
                isOpen = false;
                if (action != "openCommandPallete") editor.focus();
            };
            contextMenu = dom.buildDom([
                "div",
                {
                    class: "ace_mobile-menu",
                    ontouchstart: function(e) {
                        mode = "menu";
                        e.stopPropagation();
                        e.preventDefault();
                        editor.textInput.focus();
                    },
                    ontouchend: function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        handleClick(e);
                    },
                    onclick: handleClick
                },
                [
                    "span"
                ],
                [
                    "span",
                    {
                        class: "ace_mobile-button",
                        action: "more"
                    },
                    "..."
                ]
            ], editor.container);
        }
        function showContextMenu() {
            if (!contextMenu) createContextMenu();
            var cursor = editor.selection.cursor;
            var pagePos = editor.renderer.textToScreenCoordinates(cursor.row, cursor.column);
            var leftOffset = editor.renderer.textToScreenCoordinates(0, 0).pageX;
            var scrollLeft = editor.renderer.scrollLeft;
            var rect = editor.container.getBoundingClientRect();
            contextMenu.style.top = pagePos.pageY - rect.top - 3 + "px";
            if (pagePos.pageX - rect.left < rect.width - 70) {
                contextMenu.style.left = "";
                contextMenu.style.right = "10px";
            } else {
                contextMenu.style.right = "";
                contextMenu.style.left = leftOffset + scrollLeft - rect.left + "px";
            }
            contextMenu.style.display = "";
            contextMenu.firstChild.style.display = "none";
            editor.on("input", hideContextMenu);
        }
        function hideContextMenu(e) {
            if (contextMenu) contextMenu.style.display = "none";
            editor.off("input", hideContextMenu);
        }
        function handleLongTap() {
            longTouchTimer = null;
            clearTimeout(longTouchTimer);
            var range = editor.selection.getRange();
            var inSelection = range.contains(pos.row, pos.column);
            if (range.isEmpty() || !inSelection) {
                editor.selection.moveToPosition(pos);
                editor.selection.selectWord();
            }
            mode = "wait";
            showContextMenu();
        }
        function switchToSelectionMode() {
            longTouchTimer = null;
            clearTimeout(longTouchTimer);
            editor.selection.moveToPosition(pos);
            var range = clickCount >= 2 ? editor.selection.getLineRange(pos.row) : editor.session.getBracketRange(pos);
            if (range && !range.isEmpty()) editor.selection.setRange(range);
            else editor.selection.selectWord();
            mode = "wait";
        }
        event.addListener(el, "contextmenu", function(e) {
            if (!pressed) return;
            var textarea = editor.textInput.getElement();
            textarea.focus();
        }, editor);
        event.addListener(el, "touchstart", function(e) {
            var touches = e.touches;
            if (longTouchTimer || touches.length > 1) {
                clearTimeout(longTouchTimer);
                longTouchTimer = null;
                touchStartT = -1;
                mode = "zoom";
                return;
            }
            pressed = editor.$mouseHandler.isMousePressed = true;
            var h = editor.renderer.layerConfig.lineHeight;
            var w = editor.renderer.layerConfig.lineHeight;
            var t = e.timeStamp;
            lastT = t;
            var touchObj = touches[0];
            var x = touchObj.clientX;
            var y = touchObj.clientY;
            if (Math.abs(startX - x) + Math.abs(startY - y) > h) touchStartT = -1;
            startX = e.clientX = x;
            startY = e.clientY = y;
            vX = vY = 0;
            var ev = new MouseEvent(e, editor);
            pos = ev.getDocumentPosition();
            if (t - touchStartT < 500 && touches.length == 1 && !animationSteps) {
                clickCount++;
                e.preventDefault();
                e.button = 0;
                switchToSelectionMode();
            } else {
                clickCount = 0;
                var cursor = editor.selection.cursor;
                var anchor = editor.selection.isEmpty() ? cursor : editor.selection.anchor;
                var cursorPos = editor.renderer.$cursorLayer.getPixelPosition(cursor, true);
                var anchorPos = editor.renderer.$cursorLayer.getPixelPosition(anchor, true);
                var rect = editor.renderer.scroller.getBoundingClientRect();
                var offsetTop = editor.renderer.layerConfig.offset;
                var offsetLeft = editor.renderer.scrollLeft;
                var weightedDistance = function(x, y) {
                    x = x / w;
                    y = y / h - 0.75;
                    return x * x + y * y;
                };
                if (e.clientX < rect.left) {
                    mode = "zoom";
                    return;
                }
                var diff1 = weightedDistance(e.clientX - rect.left - cursorPos.left + offsetLeft, e.clientY - rect.top - cursorPos.top + offsetTop);
                var diff2 = weightedDistance(e.clientX - rect.left - anchorPos.left + offsetLeft, e.clientY - rect.top - anchorPos.top + offsetTop);
                if (diff1 < 3.5 && diff2 < 3.5) mode = diff1 > diff2 ? "cursor" : "anchor";
                if (diff2 < 3.5) mode = "anchor";
                else if (diff1 < 3.5) mode = "cursor";
                else mode = "scroll";
                longTouchTimer = setTimeout(handleLongTap, 450);
            }
            touchStartT = t;
        }, editor);
        event.addListener(el, "touchend", function(e) {
            pressed = editor.$mouseHandler.isMousePressed = false;
            if (animationTimer) clearInterval(animationTimer);
            if (mode == "zoom") {
                mode = "";
                animationSteps = 0;
            } else if (longTouchTimer) {
                editor.selection.moveToPosition(pos);
                animationSteps = 0;
                showContextMenu();
            } else if (mode == "scroll") {
                animate();
                hideContextMenu();
            } else showContextMenu();
            clearTimeout(longTouchTimer);
            longTouchTimer = null;
        }, editor);
        event.addListener(el, "touchmove", function(e) {
            if (longTouchTimer) {
                clearTimeout(longTouchTimer);
                longTouchTimer = null;
            }
            var touches = e.touches;
            if (touches.length > 1 || mode == "zoom") return;
            var touchObj = touches[0];
            var wheelX = startX - touchObj.clientX;
            var wheelY = startY - touchObj.clientY;
            if (mode == "wait") {
                if (wheelX * wheelX + wheelY * wheelY > 4) mode = "cursor";
                else return e.preventDefault();
            }
            startX = touchObj.clientX;
            startY = touchObj.clientY;
            e.clientX = touchObj.clientX;
            e.clientY = touchObj.clientY;
            var t = e.timeStamp;
            var dt = t - lastT;
            lastT = t;
            if (mode == "scroll") {
                var mouseEvent = new MouseEvent(e, editor);
                mouseEvent.speed = 1;
                mouseEvent.wheelX = wheelX;
                mouseEvent.wheelY = wheelY;
                if (10 * Math.abs(wheelX) < Math.abs(wheelY)) wheelX = 0;
                if (10 * Math.abs(wheelY) < Math.abs(wheelX)) wheelY = 0;
                if (dt != 0) {
                    vX = wheelX / dt;
                    vY = wheelY / dt;
                }
                editor._emit("mousewheel", mouseEvent);
                if (!mouseEvent.propagationStopped) vX = vY = 0;
            } else {
                var ev = new MouseEvent(e, editor);
                var pos = ev.getDocumentPosition();
                if (mode == "cursor") editor.selection.moveCursorToPosition(pos);
                else if (mode == "anchor") editor.selection.setSelectionAnchor(pos.row, pos.column);
                editor.renderer.scrollCursorIntoView(pos);
                e.preventDefault();
            }
        }, editor);
        function animate() {
            animationSteps += 60;
            animationTimer = setInterval(function() {
                if (animationSteps-- <= 0) {
                    clearInterval(animationTimer);
                    animationTimer = null;
                }
                if (Math.abs(vX) < 0.01) vX = 0;
                if (Math.abs(vY) < 0.01) vY = 0;
                if (animationSteps < 20) vX = 0.9 * vX;
                if (animationSteps < 20) vY = 0.9 * vY;
                var oldScrollTop = editor.session.getScrollTop();
                editor.renderer.scrollBy(10 * vX, 10 * vY);
                if (oldScrollTop == editor.session.getScrollTop()) animationSteps = 0;
            }, 10);
        }
    };
});
ace.define("ace/mouse/mouse_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/lib/useragent",
    "ace/mouse/default_handlers",
    "ace/mouse/default_gutter_handler",
    "ace/mouse/mouse_event",
    "ace/mouse/dragdrop_handler",
    "ace/mouse/touch_handler",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    var event = require("../lib/event");
    var useragent = require("../lib/useragent");
    var DefaultHandlers = require("./default_handlers").DefaultHandlers;
    var DefaultGutterHandler = require("./default_gutter_handler").GutterHandler;
    var MouseEvent = require("./mouse_event").MouseEvent;
    var DragdropHandler = require("./dragdrop_handler").DragdropHandler;
    var addTouchListeners = require("./touch_handler").addTouchListeners;
    var config = require("../config");
    var MouseHandler = /** @class */ function() {
        function MouseHandler(editor) {
            var _self = this;
            this.editor = editor;
            new DefaultHandlers(this);
            new DefaultGutterHandler(this);
            new DragdropHandler(this);
            var focusEditor = function(e) {
                var windowBlurred = !document.hasFocus || !document.hasFocus() || !editor.isFocused() && document.activeElement == (editor.textInput && editor.textInput.getElement());
                if (windowBlurred) window.focus();
                editor.focus();
                setTimeout(function() {
                    if (!editor.isFocused()) editor.focus();
                });
            };
            var mouseTarget = editor.renderer.getMouseEventTarget();
            event.addListener(mouseTarget, "click", this.onMouseEvent.bind(this, "click"), editor);
            event.addListener(mouseTarget, "mousemove", this.onMouseMove.bind(this, "mousemove"), editor);
            event.addMultiMouseDownListener([
                mouseTarget,
                editor.renderer.scrollBarV && editor.renderer.scrollBarV.inner,
                editor.renderer.scrollBarH && editor.renderer.scrollBarH.inner,
                editor.textInput && editor.textInput.getElement()
            ].filter(Boolean), [
                400,
                300,
                250
            ], this, "onMouseEvent", editor);
            event.addMouseWheelListener(editor.container, this.onMouseWheel.bind(this, "mousewheel"), editor);
            addTouchListeners(editor.container, editor);
            var gutterEl = editor.renderer.$gutter;
            event.addListener(gutterEl, "mousedown", this.onMouseEvent.bind(this, "guttermousedown"), editor);
            event.addListener(gutterEl, "click", this.onMouseEvent.bind(this, "gutterclick"), editor);
            event.addListener(gutterEl, "dblclick", this.onMouseEvent.bind(this, "gutterdblclick"), editor);
            event.addListener(gutterEl, "mousemove", this.onMouseEvent.bind(this, "guttermousemove"), editor);
            event.addListener(mouseTarget, "mousedown", focusEditor, editor);
            event.addListener(gutterEl, "mousedown", focusEditor, editor);
            if (useragent.isIE && editor.renderer.scrollBarV) {
                event.addListener(editor.renderer.scrollBarV.element, "mousedown", focusEditor, editor);
                event.addListener(editor.renderer.scrollBarH.element, "mousedown", focusEditor, editor);
            }
            editor.on("mousemove", function(e) {
                if (_self.state || _self.$dragDelay || !_self.$dragEnabled) return;
                var character = editor.renderer.screenToTextCoordinates(e.x, e.y);
                var range = editor.session.selection.getRange();
                var renderer = editor.renderer;
                if (!range.isEmpty() && range.insideStart(character.row, character.column)) renderer.setCursorStyle("default");
                else renderer.setCursorStyle("");
            }, editor);
        }
        MouseHandler.prototype.onMouseEvent = function(name, e) {
            if (!this.editor.session) return;
            this.editor._emit(name, new MouseEvent(e, this.editor));
        };
        MouseHandler.prototype.onMouseMove = function(name, e) {
            var listeners = this.editor._eventRegistry && this.editor._eventRegistry.mousemove;
            if (!listeners || !listeners.length) return;
            this.editor._emit(name, new MouseEvent(e, this.editor));
        };
        MouseHandler.prototype.onMouseWheel = function(name, e) {
            var mouseEvent = new MouseEvent(e, this.editor);
            mouseEvent.speed = this.$scrollSpeed * 2;
            mouseEvent.wheelX = e.wheelX;
            mouseEvent.wheelY = e.wheelY;
            this.editor._emit(name, mouseEvent);
        };
        MouseHandler.prototype.setState = function(state) {
            this.state = state;
        };
        MouseHandler.prototype.captureMouse = function(ev, mouseMoveHandler) {
            this.x = ev.x;
            this.y = ev.y;
            this.isMousePressed = true;
            var editor = this.editor;
            var renderer = this.editor.renderer;
            renderer.$isMousePressed = true;
            var self1 = this;
            var onMouseMove = function(e) {
                if (!e) return;
                if (useragent.isWebKit && !e.which && self1.releaseMouse) return self1.releaseMouse();
                self1.x = e.clientX;
                self1.y = e.clientY;
                mouseMoveHandler && mouseMoveHandler(e);
                self1.mouseEvent = new MouseEvent(e, self1.editor);
                self1.$mouseMoved = true;
            };
            var onCaptureEnd = function(e) {
                editor.off("beforeEndOperation", onOperationEnd);
                clearInterval(timerId);
                if (editor.session) onCaptureInterval();
                self1[self1.state + "End"] && self1[self1.state + "End"](e);
                self1.state = "";
                self1.isMousePressed = renderer.$isMousePressed = false;
                if (renderer.$keepTextAreaAtCursor) renderer.$moveTextAreaToCursor();
                self1.$onCaptureMouseMove = self1.releaseMouse = null;
                e && self1.onMouseEvent("mouseup", e);
                editor.endOperation();
            };
            var onCaptureInterval = function() {
                self1[self1.state] && self1[self1.state]();
                self1.$mouseMoved = false;
            };
            if (useragent.isOldIE && ev.domEvent.type == "dblclick") return setTimeout(function() {
                onCaptureEnd(ev);
            });
            var onOperationEnd = function(e) {
                if (!self1.releaseMouse) return;
                if (editor.curOp.command.name && editor.curOp.selectionChanged) {
                    self1[self1.state + "End"] && self1[self1.state + "End"]();
                    self1.state = "";
                    self1.releaseMouse();
                }
            };
            editor.on("beforeEndOperation", onOperationEnd);
            editor.startOperation({
                command: {
                    name: "mouse"
                }
            });
            self1.$onCaptureMouseMove = onMouseMove;
            self1.releaseMouse = event.capture(this.editor.container, onMouseMove, onCaptureEnd);
            var timerId = setInterval(onCaptureInterval, 20);
        };
        MouseHandler.prototype.cancelContextMenu = function() {
            var stop = (function(e) {
                if (e && e.domEvent && e.domEvent.type != "contextmenu") return;
                this.editor.off("nativecontextmenu", stop);
                if (e && e.domEvent) event.stopEvent(e.domEvent);
            }).bind(this);
            setTimeout(stop, 10);
            this.editor.on("nativecontextmenu", stop);
        };
        MouseHandler.prototype.destroy = function() {
            if (this.releaseMouse) this.releaseMouse();
        };
        return MouseHandler;
    }();
    MouseHandler.prototype.releaseMouse = null;
    config.defineOptions(MouseHandler.prototype, "mouseHandler", {
        scrollSpeed: {
            initialValue: 2
        },
        dragDelay: {
            initialValue: useragent.isMac ? 150 : 0
        },
        dragEnabled: {
            initialValue: true
        },
        focusTimeout: {
            initialValue: 0
        },
        tooltipFollowsMouse: {
            initialValue: true
        }
    });
    exports.MouseHandler = MouseHandler;
});
ace.define("ace/mouse/fold_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var FoldHandler = /** @class */ function() {
        function FoldHandler(editor) {
            editor.on("click", function(e) {
                var position = e.getDocumentPosition();
                var session = editor.session;
                var fold = session.getFoldAt(position.row, position.column, 1);
                if (fold) {
                    if (e.getAccelKey()) session.removeFold(fold);
                    else session.expandFold(fold);
                    e.stop();
                }
                var target = e.domEvent && e.domEvent.target;
                if (target && dom.hasCssClass(target, "ace_inline_button")) {
                    if (dom.hasCssClass(target, "ace_toggle_wrap")) {
                        session.setOption("wrap", !session.getUseWrapMode());
                        editor.renderer.scrollCursorIntoView();
                    }
                }
            });
            editor.on("gutterclick", function(e) {
                var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);
                if (gutterRegion == "foldWidgets") {
                    var row = e.getDocumentPosition().row;
                    var session = editor.session;
                    if (session.foldWidgets && session.foldWidgets[row]) editor.session.onFoldWidgetClick(row, e);
                    if (!editor.isFocused()) editor.focus();
                    e.stop();
                }
            });
            editor.on("gutterdblclick", function(e) {
                var gutterRegion = editor.renderer.$gutterLayer.getRegion(e);
                if (gutterRegion == "foldWidgets") {
                    var row = e.getDocumentPosition().row;
                    var session = editor.session;
                    var data = session.getParentFoldRangeData(row, true);
                    var range = data.range || data.firstRange;
                    if (range) {
                        row = range.start.row;
                        var fold = session.getFoldAt(row, session.getLine(row).length, 1);
                        if (fold) session.removeFold(fold);
                        else {
                            session.addFold("...", range);
                            editor.renderer.scrollCursorIntoView({
                                row: range.start.row,
                                column: 0
                            });
                        }
                    }
                    e.stop();
                }
            });
        }
        return FoldHandler;
    }();
    exports.FoldHandler = FoldHandler;
});
ace.define("ace/keyboard/keybinding", [
    "require",
    "exports",
    "module",
    "ace/lib/keys",
    "ace/lib/event"
], function(require, exports, module1) {
    "use strict";
    var keyUtil = require("../lib/keys");
    var event = require("../lib/event");
    var KeyBinding = /** @class */ function() {
        function KeyBinding(editor) {
            this.$editor = editor;
            this.$data = {
                editor: editor
            };
            this.$handlers = [];
            this.setDefaultHandler(editor.commands);
        }
        KeyBinding.prototype.setDefaultHandler = function(kb) {
            this.removeKeyboardHandler(this.$defaultHandler);
            this.$defaultHandler = kb;
            this.addKeyboardHandler(kb, 0);
        };
        KeyBinding.prototype.setKeyboardHandler = function(kb) {
            var h = this.$handlers;
            if (h[h.length - 1] == kb) return;
            while(h[h.length - 1] && h[h.length - 1] != this.$defaultHandler)this.removeKeyboardHandler(h[h.length - 1]);
            this.addKeyboardHandler(kb, 1);
        };
        KeyBinding.prototype.addKeyboardHandler = function(kb, pos) {
            if (!kb) return;
            if (typeof kb == "function" && !kb.handleKeyboard) kb.handleKeyboard = kb;
            var i = this.$handlers.indexOf(kb);
            if (i != -1) this.$handlers.splice(i, 1);
            if (pos == undefined) this.$handlers.push(kb);
            else this.$handlers.splice(pos, 0, kb);
            if (i == -1 && kb.attach) kb.attach(this.$editor);
        };
        KeyBinding.prototype.removeKeyboardHandler = function(kb) {
            var i = this.$handlers.indexOf(kb);
            if (i == -1) return false;
            this.$handlers.splice(i, 1);
            kb.detach && kb.detach(this.$editor);
            return true;
        };
        KeyBinding.prototype.getKeyboardHandler = function() {
            return this.$handlers[this.$handlers.length - 1];
        };
        KeyBinding.prototype.getStatusText = function() {
            var data = this.$data;
            var editor = data.editor;
            return this.$handlers.map(function(h) {
                return h.getStatusText && h.getStatusText(editor, data) || "";
            }).filter(Boolean).join(" ");
        };
        KeyBinding.prototype.$callKeyboardHandlers = function(hashId, keyString, keyCode, e) {
            var toExecute;
            var success = false;
            var commands = this.$editor.commands;
            for(var i = this.$handlers.length; i--;){
                toExecute = this.$handlers[i].handleKeyboard(this.$data, hashId, keyString, keyCode, e);
                if (!toExecute || !toExecute.command) continue;
                if (toExecute.command == "null") success = true;
                else success = commands.exec(toExecute.command, this.$editor, toExecute.args, e);
                if (success && e && hashId != -1 && toExecute.passEvent != true && toExecute.command.passEvent != true) event.stopEvent(e);
                if (success) break;
            }
            if (!success && hashId == -1) {
                toExecute = {
                    command: "insertstring"
                };
                success = commands.exec("insertstring", this.$editor, keyString);
            }
            if (success && this.$editor._signal) this.$editor._signal("keyboardActivity", toExecute);
            return success;
        };
        KeyBinding.prototype.onCommandKey = function(e, hashId, keyCode) {
            var keyString = keyUtil.keyCodeToString(keyCode);
            return this.$callKeyboardHandlers(hashId, keyString, keyCode, e);
        };
        KeyBinding.prototype.onTextInput = function(text) {
            return this.$callKeyboardHandlers(-1, text);
        };
        return KeyBinding;
    }();
    exports.KeyBinding = KeyBinding;
});
ace.define("ace/lib/bidiutil", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var ArabicAlefBetIntervalsBegine = [
        "ء",
        "ف"
    ];
    var ArabicAlefBetIntervalsEnd = [
        "غ",
        "ي"
    ];
    var dir = 0, hiLevel = 0;
    var lastArabic = false, hasUBAT_AL = false, hasUBAT_B = false, hasUBAT_S = false, hasBlockSep = false, hasSegSep = false;
    var impTab_LTR = [
        [
            0,
            3,
            0,
            1,
            0,
            0,
            0
        ],
        [
            0,
            3,
            0,
            1,
            2,
            2,
            0
        ],
        [
            0,
            3,
            0,
            0x11,
            2,
            0,
            1
        ],
        [
            0,
            3,
            5,
            5,
            4,
            1,
            0
        ],
        [
            0,
            3,
            0x15,
            0x15,
            4,
            0,
            1
        ],
        [
            0,
            3,
            5,
            5,
            4,
            2,
            0
        ]
    ];
    var impTab_RTL = [
        [
            2,
            0,
            1,
            1,
            0,
            1,
            0
        ],
        [
            2,
            0,
            1,
            1,
            0,
            2,
            0
        ],
        [
            2,
            0,
            2,
            1,
            3,
            2,
            0
        ],
        [
            2,
            0,
            2,
            0x21,
            3,
            1,
            1
        ]
    ];
    var LTR = 0, RTL = 1;
    var L = 0;
    var R = 1;
    var EN = 2;
    var AN = 3;
    var ON = 4;
    var B = 5;
    var S = 6;
    var AL = 7;
    var WS = 8;
    var CS = 9;
    var ES = 10;
    var ET = 11;
    var NSM = 12;
    var LRE = 13;
    var RLE = 14;
    var PDF = 15;
    var LRO = 16;
    var RLO = 17;
    var BN = 18;
    var UnicodeTBL00 = [
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        S,
        B,
        S,
        WS,
        B,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        B,
        B,
        B,
        S,
        WS,
        ON,
        ON,
        ET,
        ET,
        ET,
        ON,
        ON,
        ON,
        ON,
        ON,
        ES,
        CS,
        ES,
        CS,
        CS,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        EN,
        CS,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        L,
        ON,
        ON,
        ON,
        ON,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        B,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        BN,
        CS,
        ON,
        ET,
        ET,
        ET,
        ET,
        ON,
        ON,
        ON,
        ON,
        L,
        ON,
        ON,
        BN,
        ON,
        ON,
        ET,
        ET,
        EN,
        EN,
        ON,
        L,
        ON,
        ON,
        ON,
        EN,
        L,
        ON,
        ON,
        ON,
        ON,
        ON
    ];
    var UnicodeTBL20 = [
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        WS,
        BN,
        BN,
        BN,
        L,
        R,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        WS,
        B,
        LRE,
        RLE,
        PDF,
        LRO,
        RLO,
        CS,
        ET,
        ET,
        ET,
        ET,
        ET,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        CS,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        ON,
        WS
    ];
    function _computeLevels(chars, levels, len, charTypes) {
        var impTab = dir ? impTab_RTL : impTab_LTR, prevState = null, newClass = null, newLevel = null, newState = 0, action = null, cond = null, condPos = -1, i = null, ix = null, classes = [];
        if (!charTypes) for(i = 0, charTypes = []; i < len; i++)charTypes[i] = _getCharacterType(chars[i]);
        hiLevel = dir;
        lastArabic = false;
        hasUBAT_AL = false;
        hasUBAT_B = false;
        hasUBAT_S = false;
        for(ix = 0; ix < len; ix++){
            prevState = newState;
            classes[ix] = newClass = _getCharClass(chars, charTypes, classes, ix);
            newState = impTab[prevState][newClass];
            action = newState & 0xF0;
            newState &= 0x0F;
            levels[ix] = newLevel = impTab[newState][5];
            if (action > 0) {
                if (action == 0x10) {
                    for(i = condPos; i < ix; i++)levels[i] = 1;
                    condPos = -1;
                } else condPos = -1;
            }
            cond = impTab[newState][6];
            if (cond) {
                if (condPos == -1) condPos = ix;
            } else if (condPos > -1) {
                for(i = condPos; i < ix; i++)levels[i] = newLevel;
                condPos = -1;
            }
            if (charTypes[ix] == B) levels[ix] = 0;
            hiLevel |= newLevel;
        }
        if (hasUBAT_S) {
            for(i = 0; i < len; i++)if (charTypes[i] == S) {
                levels[i] = dir;
                for(var j = i - 1; j >= 0; j--){
                    if (charTypes[j] == WS) levels[j] = dir;
                    else break;
                }
            }
        }
    }
    function _invertLevel(lev, levels, _array) {
        if (hiLevel < lev) return;
        if (lev == 1 && dir == RTL && !hasUBAT_B) {
            _array.reverse();
            return;
        }
        var len = _array.length, start = 0, end, lo, hi, tmp;
        while(start < len){
            if (levels[start] >= lev) {
                end = start + 1;
                while(end < len && levels[end] >= lev)end++;
                for(lo = start, hi = end - 1; lo < hi; lo++, hi--){
                    tmp = _array[lo];
                    _array[lo] = _array[hi];
                    _array[hi] = tmp;
                }
                start = end;
            }
            start++;
        }
    }
    function _getCharClass(chars, types, classes, ix) {
        var cType = types[ix], wType, nType, len, i;
        switch(cType){
            case L:
            case R:
                lastArabic = false;
            case ON:
            case AN:
                return cType;
            case EN:
                return lastArabic ? AN : EN;
            case AL:
                lastArabic = true;
                hasUBAT_AL = true;
                return R;
            case WS:
                return ON;
            case CS:
                if (ix < 1 || ix + 1 >= types.length || (wType = classes[ix - 1]) != EN && wType != AN || (nType = types[ix + 1]) != EN && nType != AN) return ON;
                if (lastArabic) nType = AN;
                return nType == wType ? nType : ON;
            case ES:
                wType = ix > 0 ? classes[ix - 1] : B;
                if (wType == EN && ix + 1 < types.length && types[ix + 1] == EN) return EN;
                return ON;
            case ET:
                if (ix > 0 && classes[ix - 1] == EN) return EN;
                if (lastArabic) return ON;
                i = ix + 1;
                len = types.length;
                while(i < len && types[i] == ET)i++;
                if (i < len && types[i] == EN) return EN;
                return ON;
            case NSM:
                len = types.length;
                i = ix + 1;
                while(i < len && types[i] == NSM)i++;
                if (i < len) {
                    var c = chars[ix], rtlCandidate = c >= 0x0591 && c <= 0x08FF || c == 0xFB1E;
                    wType = types[i];
                    if (rtlCandidate && (wType == R || wType == AL)) return R;
                }
                if (ix < 1 || (wType = types[ix - 1]) == B) return ON;
                return classes[ix - 1];
            case B:
                lastArabic = false;
                hasUBAT_B = true;
                return dir;
            case S:
                hasUBAT_S = true;
                return ON;
            case LRE:
            case RLE:
            case LRO:
            case RLO:
            case PDF:
                lastArabic = false;
            case BN:
                return ON;
        }
    }
    function _getCharacterType(ch) {
        var uc = ch.charCodeAt(0), hi = uc >> 8;
        if (hi == 0) return uc > 0x00BF ? L : UnicodeTBL00[uc];
        else if (hi == 5) return /[\u0591-\u05f4]/.test(ch) ? R : L;
        else if (hi == 6) {
            if (/[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(ch)) return NSM;
            else if (/[\u0660-\u0669\u066b-\u066c]/.test(ch)) return AN;
            else if (uc == 0x066A) return ET;
            else if (/[\u06f0-\u06f9]/.test(ch)) return EN;
            else return AL;
        } else if (hi == 0x20 && uc <= 0x205F) return UnicodeTBL20[uc & 0xFF];
        else if (hi == 0xFE) return uc >= 0xFE70 ? AL : ON;
        return ON;
    }
    function _isArabicDiacritics(ch) {
        return ch >= "ً" && ch <= "ٕ";
    }
    exports.L = L;
    exports.R = R;
    exports.EN = EN;
    exports.ON_R = 3;
    exports.AN = 4;
    exports.R_H = 5;
    exports.B = 6;
    exports.RLE = 7;
    exports.DOT = "\xb7";
    exports.doBidiReorder = function(text, textCharTypes, isRtl) {
        if (text.length < 2) return {};
        var chars = text.split(""), logicalFromVisual = new Array(chars.length), bidiLevels = new Array(chars.length), levels = [];
        dir = isRtl ? RTL : LTR;
        _computeLevels(chars, levels, chars.length, textCharTypes);
        for(var i = 0; i < logicalFromVisual.length; logicalFromVisual[i] = i, i++);
        _invertLevel(2, levels, logicalFromVisual);
        _invertLevel(1, levels, logicalFromVisual);
        for(var i = 0; i < logicalFromVisual.length - 1; i++){
            if (textCharTypes[i] === AN) levels[i] = exports.AN;
            else if (levels[i] === R && (textCharTypes[i] > AL && textCharTypes[i] < LRE || textCharTypes[i] === ON || textCharTypes[i] === BN)) levels[i] = exports.ON_R;
            else if (i > 0 && chars[i - 1] === "ل" && /\u0622|\u0623|\u0625|\u0627/.test(chars[i])) {
                levels[i - 1] = levels[i] = exports.R_H;
                i++;
            }
        }
        if (chars[chars.length - 1] === exports.DOT) levels[chars.length - 1] = exports.B;
        if (chars[0] === "‫") levels[0] = exports.RLE;
        for(var i = 0; i < logicalFromVisual.length; i++)bidiLevels[i] = levels[logicalFromVisual[i]];
        return {
            "logicalFromVisual": logicalFromVisual,
            "bidiLevels": bidiLevels
        };
    };
    exports.hasBidiCharacters = function(text, textCharTypes) {
        var ret = false;
        for(var i = 0; i < text.length; i++){
            textCharTypes[i] = _getCharacterType(text.charAt(i));
            if (!ret && (textCharTypes[i] == R || textCharTypes[i] == AL || textCharTypes[i] == AN)) ret = true;
        }
        return ret;
    };
    exports.getVisualFromLogicalIdx = function(logIdx, rowMap) {
        for(var i = 0; i < rowMap.logicalFromVisual.length; i++){
            if (rowMap.logicalFromVisual[i] == logIdx) return i;
        }
        return 0;
    };
});
ace.define("ace/bidihandler", [
    "require",
    "exports",
    "module",
    "ace/lib/bidiutil",
    "ace/lib/lang"
], function(require, exports, module1) {
    "use strict";
    var bidiUtil = require("./lib/bidiutil");
    var lang = require("./lib/lang");
    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\u202B]/;
    var BidiHandler = /** @class */ function() {
        function BidiHandler(session) {
            this.session = session;
            this.bidiMap = {};
            this.currentRow = null;
            this.bidiUtil = bidiUtil;
            this.charWidths = [];
            this.EOL = "\xac";
            this.showInvisibles = true;
            this.isRtlDir = false;
            this.$isRtl = false;
            this.line = "";
            this.wrapIndent = 0;
            this.EOF = "\xb6";
            this.RLE = "‫";
            this.contentWidth = 0;
            this.fontMetrics = null;
            this.rtlLineOffset = 0;
            this.wrapOffset = 0;
            this.isMoveLeftOperation = false;
            this.seenBidi = bidiRE.test(session.getValue());
        }
        BidiHandler.prototype.isBidiRow = function(screenRow, docRow, splitIndex) {
            if (!this.seenBidi) return false;
            if (screenRow !== this.currentRow) {
                this.currentRow = screenRow;
                this.updateRowLine(docRow, splitIndex);
                this.updateBidiMap();
            }
            return this.bidiMap.bidiLevels;
        };
        BidiHandler.prototype.onChange = function(delta) {
            if (!this.seenBidi) {
                if (delta.action == "insert" && bidiRE.test(delta.lines.join("\n"))) {
                    this.seenBidi = true;
                    this.currentRow = null;
                }
            } else this.currentRow = null;
        };
        BidiHandler.prototype.getDocumentRow = function() {
            var docRow = 0;
            var rowCache = this.session.$screenRowCache;
            if (rowCache.length) {
                var index = this.session.$getRowCacheIndex(rowCache, this.currentRow);
                if (index >= 0) docRow = this.session.$docRowCache[index];
            }
            return docRow;
        };
        BidiHandler.prototype.getSplitIndex = function() {
            var splitIndex = 0;
            var rowCache = this.session.$screenRowCache;
            if (rowCache.length) {
                var currentIndex, prevIndex = this.session.$getRowCacheIndex(rowCache, this.currentRow);
                while(this.currentRow - splitIndex > 0){
                    currentIndex = this.session.$getRowCacheIndex(rowCache, this.currentRow - splitIndex - 1);
                    if (currentIndex !== prevIndex) break;
                    prevIndex = currentIndex;
                    splitIndex++;
                }
            } else splitIndex = this.currentRow;
            return splitIndex;
        };
        BidiHandler.prototype.updateRowLine = function(docRow, splitIndex) {
            if (docRow === undefined) docRow = this.getDocumentRow();
            var isLastRow = docRow === this.session.getLength() - 1, endOfLine = isLastRow ? this.EOF : this.EOL;
            this.wrapIndent = 0;
            this.line = this.session.getLine(docRow);
            this.isRtlDir = this.$isRtl || this.line.charAt(0) === this.RLE;
            if (this.session.$useWrapMode) {
                var splits = this.session.$wrapData[docRow];
                if (splits) {
                    if (splitIndex === undefined) splitIndex = this.getSplitIndex();
                    if (splitIndex > 0 && splits.length) {
                        this.wrapIndent = splits.indent;
                        this.wrapOffset = this.wrapIndent * this.charWidths[bidiUtil.L];
                        this.line = splitIndex < splits.length ? this.line.substring(splits[splitIndex - 1], splits[splitIndex]) : this.line.substring(splits[splits.length - 1]);
                    } else this.line = this.line.substring(0, splits[splitIndex]);
                    if (splitIndex == splits.length) this.line += this.showInvisibles ? endOfLine : bidiUtil.DOT;
                }
            } else this.line += this.showInvisibles ? endOfLine : bidiUtil.DOT;
            var session = this.session, shift = 0, size;
            this.line = this.line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g, function(ch, i) {
                if (ch === "	" || session.isFullWidth(ch.charCodeAt(0))) {
                    size = ch === "	" ? session.getScreenTabSize(i + shift) : 2;
                    shift += size - 1;
                    return lang.stringRepeat(bidiUtil.DOT, size);
                }
                return ch;
            });
            if (this.isRtlDir) {
                this.fontMetrics.$main.textContent = this.line.charAt(this.line.length - 1) == bidiUtil.DOT ? this.line.substr(0, this.line.length - 1) : this.line;
                this.rtlLineOffset = this.contentWidth - this.fontMetrics.$main.getBoundingClientRect().width;
            }
        };
        BidiHandler.prototype.updateBidiMap = function() {
            var textCharTypes = [];
            if (bidiUtil.hasBidiCharacters(this.line, textCharTypes) || this.isRtlDir) this.bidiMap = bidiUtil.doBidiReorder(this.line, textCharTypes, this.isRtlDir);
            else this.bidiMap = {};
        };
        BidiHandler.prototype.markAsDirty = function() {
            this.currentRow = null;
        };
        BidiHandler.prototype.updateCharacterWidths = function(fontMetrics) {
            if (this.characterWidth === fontMetrics.$characterSize.width) return;
            this.fontMetrics = fontMetrics;
            var characterWidth = this.characterWidth = fontMetrics.$characterSize.width;
            var bidiCharWidth = fontMetrics.$measureCharWidth("ה");
            this.charWidths[bidiUtil.L] = this.charWidths[bidiUtil.EN] = this.charWidths[bidiUtil.ON_R] = characterWidth;
            this.charWidths[bidiUtil.R] = this.charWidths[bidiUtil.AN] = bidiCharWidth;
            this.charWidths[bidiUtil.R_H] = bidiCharWidth * 0.45;
            this.charWidths[bidiUtil.B] = this.charWidths[bidiUtil.RLE] = 0;
            this.currentRow = null;
        };
        BidiHandler.prototype.setShowInvisibles = function(showInvisibles) {
            this.showInvisibles = showInvisibles;
            this.currentRow = null;
        };
        BidiHandler.prototype.setEolChar = function(eolChar) {
            this.EOL = eolChar;
        };
        BidiHandler.prototype.setContentWidth = function(width) {
            this.contentWidth = width;
        };
        BidiHandler.prototype.isRtlLine = function(row) {
            if (this.$isRtl) return true;
            if (row != undefined) return this.session.getLine(row).charAt(0) == this.RLE;
            else return this.isRtlDir;
        };
        BidiHandler.prototype.setRtlDirection = function(editor, isRtlDir) {
            var cursor = editor.getCursorPosition();
            for(var row = editor.selection.getSelectionAnchor().row; row <= cursor.row; row++){
                if (!isRtlDir && editor.session.getLine(row).charAt(0) === editor.session.$bidiHandler.RLE) editor.session.doc.removeInLine(row, 0, 1);
                else if (isRtlDir && editor.session.getLine(row).charAt(0) !== editor.session.$bidiHandler.RLE) editor.session.doc.insert({
                    column: 0,
                    row: row
                }, editor.session.$bidiHandler.RLE);
            }
        };
        BidiHandler.prototype.getPosLeft = function(col) {
            col -= this.wrapIndent;
            var leftBoundary = this.line.charAt(0) === this.RLE ? 1 : 0;
            var logicalIdx = col > leftBoundary ? this.session.getOverwrite() ? col : col - 1 : leftBoundary;
            var visualIdx = bidiUtil.getVisualFromLogicalIdx(logicalIdx, this.bidiMap), levels = this.bidiMap.bidiLevels, left = 0;
            if (!this.session.getOverwrite() && col <= leftBoundary && levels[visualIdx] % 2 !== 0) visualIdx++;
            for(var i = 0; i < visualIdx; i++)left += this.charWidths[levels[i]];
            if (!this.session.getOverwrite() && col > leftBoundary && levels[visualIdx] % 2 === 0) left += this.charWidths[levels[visualIdx]];
            if (this.wrapIndent) left += this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset;
            if (this.isRtlDir) left += this.rtlLineOffset;
            return left;
        };
        BidiHandler.prototype.getSelections = function(startCol, endCol) {
            var map = this.bidiMap, levels = map.bidiLevels, level, selections = [], offset = 0, selColMin = Math.min(startCol, endCol) - this.wrapIndent, selColMax = Math.max(startCol, endCol) - this.wrapIndent, isSelected = false, isSelectedPrev = false, selectionStart = 0;
            if (this.wrapIndent) offset += this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset;
            for(var logIdx, visIdx = 0; visIdx < levels.length; visIdx++){
                logIdx = map.logicalFromVisual[visIdx];
                level = levels[visIdx];
                isSelected = logIdx >= selColMin && logIdx < selColMax;
                if (isSelected && !isSelectedPrev) selectionStart = offset;
                else if (!isSelected && isSelectedPrev) selections.push({
                    left: selectionStart,
                    width: offset - selectionStart
                });
                offset += this.charWidths[level];
                isSelectedPrev = isSelected;
            }
            if (isSelected && visIdx === levels.length) selections.push({
                left: selectionStart,
                width: offset - selectionStart
            });
            if (this.isRtlDir) for(var i = 0; i < selections.length; i++)selections[i].left += this.rtlLineOffset;
            return selections;
        };
        BidiHandler.prototype.offsetToCol = function(posX) {
            if (this.isRtlDir) posX -= this.rtlLineOffset;
            var logicalIdx = 0, posX = Math.max(posX, 0), offset = 0, visualIdx = 0, levels = this.bidiMap.bidiLevels, charWidth = this.charWidths[levels[visualIdx]];
            if (this.wrapIndent) posX -= this.isRtlDir ? -1 * this.wrapOffset : this.wrapOffset;
            while(posX > offset + charWidth / 2){
                offset += charWidth;
                if (visualIdx === levels.length - 1) {
                    charWidth = 0;
                    break;
                }
                charWidth = this.charWidths[levels[++visualIdx]];
            }
            if (visualIdx > 0 && levels[visualIdx - 1] % 2 !== 0 && levels[visualIdx] % 2 === 0) {
                if (posX < offset) visualIdx--;
                logicalIdx = this.bidiMap.logicalFromVisual[visualIdx];
            } else if (visualIdx > 0 && levels[visualIdx - 1] % 2 === 0 && levels[visualIdx] % 2 !== 0) logicalIdx = 1 + (posX > offset ? this.bidiMap.logicalFromVisual[visualIdx] : this.bidiMap.logicalFromVisual[visualIdx - 1]);
            else if (this.isRtlDir && visualIdx === levels.length - 1 && charWidth === 0 && levels[visualIdx - 1] % 2 === 0 || !this.isRtlDir && visualIdx === 0 && levels[visualIdx] % 2 !== 0) logicalIdx = 1 + this.bidiMap.logicalFromVisual[visualIdx];
            else {
                if (visualIdx > 0 && levels[visualIdx - 1] % 2 !== 0 && charWidth !== 0) visualIdx--;
                logicalIdx = this.bidiMap.logicalFromVisual[visualIdx];
            }
            if (logicalIdx === 0 && this.isRtlDir) logicalIdx++;
            return logicalIdx + this.wrapIndent;
        };
        return BidiHandler;
    }();
    exports.BidiHandler = BidiHandler;
});
ace.define("ace/selection", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/lib/event_emitter",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var lang = require("./lib/lang");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var Range = require("./range").Range;
    var Selection = function(session) {
        this.session = session;
        this.doc = session.getDocument();
        this.clearSelection();
        this.cursor = this.lead = this.doc.createAnchor(0, 0);
        this.anchor = this.doc.createAnchor(0, 0);
        this.$silent = false;
        var self1 = this;
        this.cursor.on("change", function(e) {
            self1.$cursorChanged = true;
            if (!self1.$silent) self1._emit("changeCursor");
            if (!self1.$isEmpty && !self1.$silent) self1._emit("changeSelection");
            if (!self1.$keepDesiredColumnOnChange && e.old.column != e.value.column) self1.$desiredColumn = null;
        });
        this.anchor.on("change", function() {
            self1.$anchorChanged = true;
            if (!self1.$isEmpty && !self1.$silent) self1._emit("changeSelection");
        });
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.isEmpty = function() {
            return this.$isEmpty || this.anchor.row == this.lead.row && this.anchor.column == this.lead.column;
        };
        this.isMultiLine = function() {
            return !this.$isEmpty && this.anchor.row != this.cursor.row;
        };
        this.getCursor = function() {
            return this.lead.getPosition();
        };
        this.setAnchor = function(row, column) {
            this.$isEmpty = false;
            this.anchor.setPosition(row, column);
        };
        this.setSelectionAnchor = this.setAnchor;
        this.getAnchor = function() {
            if (this.$isEmpty) return this.getSelectionLead();
            return this.anchor.getPosition();
        };
        this.getSelectionAnchor = this.getAnchor;
        this.getSelectionLead = function() {
            return this.lead.getPosition();
        };
        this.isBackwards = function() {
            var anchor = this.anchor;
            var lead = this.lead;
            return anchor.row > lead.row || anchor.row == lead.row && anchor.column > lead.column;
        };
        this.getRange = function() {
            var anchor = this.anchor;
            var lead = this.lead;
            if (this.$isEmpty) return Range.fromPoints(lead, lead);
            return this.isBackwards() ? Range.fromPoints(lead, anchor) : Range.fromPoints(anchor, lead);
        };
        this.clearSelection = function() {
            if (!this.$isEmpty) {
                this.$isEmpty = true;
                this._emit("changeSelection");
            }
        };
        this.selectAll = function() {
            this.$setSelection(0, 0, Number.MAX_VALUE, Number.MAX_VALUE);
        };
        this.setRange = this.setSelectionRange = function(range, reverse) {
            var start = reverse ? range.end : range.start;
            var end = reverse ? range.start : range.end;
            this.$setSelection(start.row, start.column, end.row, end.column);
        };
        this.$setSelection = function(anchorRow, anchorColumn, cursorRow, cursorColumn) {
            if (this.$silent) return;
            var wasEmpty = this.$isEmpty;
            var wasMultiselect = this.inMultiSelectMode;
            this.$silent = true;
            this.$cursorChanged = this.$anchorChanged = false;
            this.anchor.setPosition(anchorRow, anchorColumn);
            this.cursor.setPosition(cursorRow, cursorColumn);
            this.$isEmpty = !Range.comparePoints(this.anchor, this.cursor);
            this.$silent = false;
            if (this.$cursorChanged) this._emit("changeCursor");
            if (this.$cursorChanged || this.$anchorChanged || wasEmpty != this.$isEmpty || wasMultiselect) this._emit("changeSelection");
        };
        this.$moveSelection = function(mover) {
            var lead = this.lead;
            if (this.$isEmpty) this.setSelectionAnchor(lead.row, lead.column);
            mover.call(this);
        };
        this.selectTo = function(row, column) {
            this.$moveSelection(function() {
                this.moveCursorTo(row, column);
            });
        };
        this.selectToPosition = function(pos) {
            this.$moveSelection(function() {
                this.moveCursorToPosition(pos);
            });
        };
        this.moveTo = function(row, column) {
            this.clearSelection();
            this.moveCursorTo(row, column);
        };
        this.moveToPosition = function(pos) {
            this.clearSelection();
            this.moveCursorToPosition(pos);
        };
        this.selectUp = function() {
            this.$moveSelection(this.moveCursorUp);
        };
        this.selectDown = function() {
            this.$moveSelection(this.moveCursorDown);
        };
        this.selectRight = function() {
            this.$moveSelection(this.moveCursorRight);
        };
        this.selectLeft = function() {
            this.$moveSelection(this.moveCursorLeft);
        };
        this.selectLineStart = function() {
            this.$moveSelection(this.moveCursorLineStart);
        };
        this.selectLineEnd = function() {
            this.$moveSelection(this.moveCursorLineEnd);
        };
        this.selectFileEnd = function() {
            this.$moveSelection(this.moveCursorFileEnd);
        };
        this.selectFileStart = function() {
            this.$moveSelection(this.moveCursorFileStart);
        };
        this.selectWordRight = function() {
            this.$moveSelection(this.moveCursorWordRight);
        };
        this.selectWordLeft = function() {
            this.$moveSelection(this.moveCursorWordLeft);
        };
        this.getWordRange = function(row, column) {
            if (typeof column == "undefined") {
                var cursor = row || this.lead;
                row = cursor.row;
                column = cursor.column;
            }
            return this.session.getWordRange(row, column);
        };
        this.selectWord = function() {
            this.setSelectionRange(this.getWordRange());
        };
        this.selectAWord = function() {
            var cursor = this.getCursor();
            var range = this.session.getAWordRange(cursor.row, cursor.column);
            this.setSelectionRange(range);
        };
        this.getLineRange = function(row, excludeLastChar) {
            var rowStart = typeof row == "number" ? row : this.lead.row;
            var rowEnd;
            var foldLine = this.session.getFoldLine(rowStart);
            if (foldLine) {
                rowStart = foldLine.start.row;
                rowEnd = foldLine.end.row;
            } else rowEnd = rowStart;
            if (excludeLastChar === true) return new Range(rowStart, 0, rowEnd, this.session.getLine(rowEnd).length);
            else return new Range(rowStart, 0, rowEnd + 1, 0);
        };
        this.selectLine = function() {
            this.setSelectionRange(this.getLineRange());
        };
        this.moveCursorUp = function() {
            this.moveCursorBy(-1, 0);
        };
        this.moveCursorDown = function() {
            this.moveCursorBy(1, 0);
        };
        this.wouldMoveIntoSoftTab = function(cursor, tabSize, direction) {
            var start = cursor.column;
            var end = cursor.column + tabSize;
            if (direction < 0) {
                start = cursor.column - tabSize;
                end = cursor.column;
            }
            return this.session.isTabStop(cursor) && this.doc.getLine(cursor.row).slice(start, end).split(" ").length - 1 == tabSize;
        };
        this.moveCursorLeft = function() {
            var cursor = this.lead.getPosition(), fold;
            if (fold = this.session.getFoldAt(cursor.row, cursor.column, -1)) this.moveCursorTo(fold.start.row, fold.start.column);
            else if (cursor.column === 0) {
                if (cursor.row > 0) this.moveCursorTo(cursor.row - 1, this.doc.getLine(cursor.row - 1).length);
            } else {
                var tabSize = this.session.getTabSize();
                if (this.wouldMoveIntoSoftTab(cursor, tabSize, -1) && !this.session.getNavigateWithinSoftTabs()) this.moveCursorBy(0, -tabSize);
                else this.moveCursorBy(0, -1);
            }
        };
        this.moveCursorRight = function() {
            var cursor = this.lead.getPosition(), fold;
            if (fold = this.session.getFoldAt(cursor.row, cursor.column, 1)) this.moveCursorTo(fold.end.row, fold.end.column);
            else if (this.lead.column == this.doc.getLine(this.lead.row).length) {
                if (this.lead.row < this.doc.getLength() - 1) this.moveCursorTo(this.lead.row + 1, 0);
            } else {
                var tabSize = this.session.getTabSize();
                var cursor = this.lead;
                if (this.wouldMoveIntoSoftTab(cursor, tabSize, 1) && !this.session.getNavigateWithinSoftTabs()) this.moveCursorBy(0, tabSize);
                else this.moveCursorBy(0, 1);
            }
        };
        this.moveCursorLineStart = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var screenRow = this.session.documentToScreenRow(row, column);
            var firstColumnPosition = this.session.screenToDocumentPosition(screenRow, 0);
            var beforeCursor = this.session.getDisplayLine(row, null, firstColumnPosition.row, firstColumnPosition.column);
            var leadingSpace = beforeCursor.match(/^\s*/);
            if (leadingSpace[0].length != column && !this.session.$useEmacsStyleLineStart) firstColumnPosition.column += leadingSpace[0].length;
            this.moveCursorToPosition(firstColumnPosition);
        };
        this.moveCursorLineEnd = function() {
            var lead = this.lead;
            var lineEnd = this.session.getDocumentLastRowColumnPosition(lead.row, lead.column);
            if (this.lead.column == lineEnd.column) {
                var line = this.session.getLine(lineEnd.row);
                if (lineEnd.column == line.length) {
                    var textEnd = line.search(/\s+$/);
                    if (textEnd > 0) lineEnd.column = textEnd;
                }
            }
            this.moveCursorTo(lineEnd.row, lineEnd.column);
        };
        this.moveCursorFileEnd = function() {
            var row = this.doc.getLength() - 1;
            var column = this.doc.getLine(row).length;
            this.moveCursorTo(row, column);
        };
        this.moveCursorFileStart = function() {
            this.moveCursorTo(0, 0);
        };
        this.moveCursorLongWordRight = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var line = this.doc.getLine(row);
            var rightOfCursor = line.substring(column);
            this.session.nonTokenRe.lastIndex = 0;
            this.session.tokenRe.lastIndex = 0;
            var fold = this.session.getFoldAt(row, column, 1);
            if (fold) {
                this.moveCursorTo(fold.end.row, fold.end.column);
                return;
            }
            if (this.session.nonTokenRe.exec(rightOfCursor)) {
                column += this.session.nonTokenRe.lastIndex;
                this.session.nonTokenRe.lastIndex = 0;
                rightOfCursor = line.substring(column);
            }
            if (column >= line.length) {
                this.moveCursorTo(row, line.length);
                this.moveCursorRight();
                if (row < this.doc.getLength() - 1) this.moveCursorWordRight();
                return;
            }
            if (this.session.tokenRe.exec(rightOfCursor)) {
                column += this.session.tokenRe.lastIndex;
                this.session.tokenRe.lastIndex = 0;
            }
            this.moveCursorTo(row, column);
        };
        this.moveCursorLongWordLeft = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var fold;
            if (fold = this.session.getFoldAt(row, column, -1)) {
                this.moveCursorTo(fold.start.row, fold.start.column);
                return;
            }
            var str = this.session.getFoldStringAt(row, column, -1);
            if (str == null) str = this.doc.getLine(row).substring(0, column);
            var leftOfCursor = lang.stringReverse(str);
            this.session.nonTokenRe.lastIndex = 0;
            this.session.tokenRe.lastIndex = 0;
            if (this.session.nonTokenRe.exec(leftOfCursor)) {
                column -= this.session.nonTokenRe.lastIndex;
                leftOfCursor = leftOfCursor.slice(this.session.nonTokenRe.lastIndex);
                this.session.nonTokenRe.lastIndex = 0;
            }
            if (column <= 0) {
                this.moveCursorTo(row, 0);
                this.moveCursorLeft();
                if (row > 0) this.moveCursorWordLeft();
                return;
            }
            if (this.session.tokenRe.exec(leftOfCursor)) {
                column -= this.session.tokenRe.lastIndex;
                this.session.tokenRe.lastIndex = 0;
            }
            this.moveCursorTo(row, column);
        };
        this.$shortWordEndIndex = function(rightOfCursor) {
            var index = 0, ch;
            var whitespaceRe = /\s/;
            var tokenRe = this.session.tokenRe;
            tokenRe.lastIndex = 0;
            if (this.session.tokenRe.exec(rightOfCursor)) index = this.session.tokenRe.lastIndex;
            else {
                while((ch = rightOfCursor[index]) && whitespaceRe.test(ch))index++;
                if (index < 1) {
                    tokenRe.lastIndex = 0;
                    while((ch = rightOfCursor[index]) && !tokenRe.test(ch)){
                        tokenRe.lastIndex = 0;
                        index++;
                        if (whitespaceRe.test(ch)) {
                            if (index > 2) {
                                index--;
                                break;
                            } else {
                                while((ch = rightOfCursor[index]) && whitespaceRe.test(ch))index++;
                                if (index > 2) break;
                            }
                        }
                    }
                }
            }
            tokenRe.lastIndex = 0;
            return index;
        };
        this.moveCursorShortWordRight = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var line = this.doc.getLine(row);
            var rightOfCursor = line.substring(column);
            var fold = this.session.getFoldAt(row, column, 1);
            if (fold) return this.moveCursorTo(fold.end.row, fold.end.column);
            if (column == line.length) {
                var l = this.doc.getLength();
                do {
                    row++;
                    rightOfCursor = this.doc.getLine(row);
                }while (row < l && /^\s*$/.test(rightOfCursor));
                if (!/^\s+/.test(rightOfCursor)) rightOfCursor = "";
                column = 0;
            }
            var index = this.$shortWordEndIndex(rightOfCursor);
            this.moveCursorTo(row, column + index);
        };
        this.moveCursorShortWordLeft = function() {
            var row = this.lead.row;
            var column = this.lead.column;
            var fold;
            if (fold = this.session.getFoldAt(row, column, -1)) return this.moveCursorTo(fold.start.row, fold.start.column);
            var line = this.session.getLine(row).substring(0, column);
            if (column === 0) {
                do {
                    row--;
                    line = this.doc.getLine(row);
                }while (row > 0 && /^\s*$/.test(line));
                column = line.length;
                if (!/\s+$/.test(line)) line = "";
            }
            var leftOfCursor = lang.stringReverse(line);
            var index = this.$shortWordEndIndex(leftOfCursor);
            return this.moveCursorTo(row, column - index);
        };
        this.moveCursorWordRight = function() {
            if (this.session.$selectLongWords) this.moveCursorLongWordRight();
            else this.moveCursorShortWordRight();
        };
        this.moveCursorWordLeft = function() {
            if (this.session.$selectLongWords) this.moveCursorLongWordLeft();
            else this.moveCursorShortWordLeft();
        };
        this.moveCursorBy = function(rows, chars) {
            var screenPos = this.session.documentToScreenPosition(this.lead.row, this.lead.column);
            var offsetX;
            if (chars === 0) {
                if (rows !== 0) {
                    if (this.session.$bidiHandler.isBidiRow(screenPos.row, this.lead.row)) {
                        offsetX = this.session.$bidiHandler.getPosLeft(screenPos.column);
                        screenPos.column = Math.round(offsetX / this.session.$bidiHandler.charWidths[0]);
                    } else offsetX = screenPos.column * this.session.$bidiHandler.charWidths[0];
                }
                if (this.$desiredColumn) screenPos.column = this.$desiredColumn;
                else this.$desiredColumn = screenPos.column;
            }
            if (rows != 0 && this.session.lineWidgets && this.session.lineWidgets[this.lead.row]) {
                var widget = this.session.lineWidgets[this.lead.row];
                if (rows < 0) rows -= widget.rowsAbove || 0;
                else if (rows > 0) rows += widget.rowCount - (widget.rowsAbove || 0);
            }
            var docPos = this.session.screenToDocumentPosition(screenPos.row + rows, screenPos.column, offsetX);
            rows !== 0 && chars === 0 && docPos.row === this.lead.row && (docPos.column, this.lead.column);
            this.moveCursorTo(docPos.row, docPos.column + chars, chars === 0);
        };
        this.moveCursorToPosition = function(position) {
            this.moveCursorTo(position.row, position.column);
        };
        this.moveCursorTo = function(row, column, keepDesiredColumn) {
            var fold = this.session.getFoldAt(row, column, 1);
            if (fold) {
                row = fold.start.row;
                column = fold.start.column;
            }
            this.$keepDesiredColumnOnChange = true;
            var line = this.session.getLine(row);
            if (/[\uDC00-\uDFFF]/.test(line.charAt(column)) && line.charAt(column - 1)) {
                if (this.lead.row == row && this.lead.column == column + 1) column = column - 1;
                else column = column + 1;
            }
            this.lead.setPosition(row, column);
            this.$keepDesiredColumnOnChange = false;
            if (!keepDesiredColumn) this.$desiredColumn = null;
        };
        this.moveCursorToScreen = function(row, column, keepDesiredColumn) {
            var pos = this.session.screenToDocumentPosition(row, column);
            this.moveCursorTo(pos.row, pos.column, keepDesiredColumn);
        };
        this.detach = function() {
            this.lead.detach();
            this.anchor.detach();
        };
        this.fromOrientedRange = function(range) {
            this.setSelectionRange(range, range.cursor == range.start);
            this.$desiredColumn = range.desiredColumn || this.$desiredColumn;
        };
        this.toOrientedRange = function(range) {
            var r = this.getRange();
            if (range) {
                range.start.column = r.start.column;
                range.start.row = r.start.row;
                range.end.column = r.end.column;
                range.end.row = r.end.row;
            } else range = r;
            range.cursor = this.isBackwards() ? range.start : range.end;
            range.desiredColumn = this.$desiredColumn;
            return range;
        };
        this.getRangeOfMovements = function(func) {
            var start = this.getCursor();
            try {
                func(this);
                var end = this.getCursor();
                return Range.fromPoints(start, end);
            } catch (e) {
                return Range.fromPoints(start, start);
            } finally{
                this.moveCursorToPosition(start);
            }
        };
        this.toJSON = function() {
            if (this.rangeCount) var data = this.ranges.map(function(r) {
                var r1 = r.clone();
                r1.isBackwards = r.cursor == r.start;
                return r1;
            });
            else {
                var data = this.getRange();
                data.isBackwards = this.isBackwards();
            }
            return data;
        };
        this.fromJSON = function(data) {
            if (data.start == undefined) {
                if (this.rangeList && data.length > 1) {
                    this.toSingleRange(data[0]);
                    for(var i = data.length; i--;){
                        var r = Range.fromPoints(data[i].start, data[i].end);
                        if (data[i].isBackwards) r.cursor = r.start;
                        this.addRange(r, true);
                    }
                    return;
                } else data = data[0];
            }
            if (this.rangeList) this.toSingleRange(data);
            this.setSelectionRange(data, data.isBackwards);
        };
        this.isEqual = function(data) {
            if ((data.length || this.rangeCount) && data.length != this.rangeCount) return false;
            if (!data.length || !this.ranges) return this.getRange().isEqual(data);
            for(var i = this.ranges.length; i--;){
                if (!this.ranges[i].isEqual(data[i])) return false;
            }
            return true;
        };
    }).call(Selection.prototype);
    exports.Selection = Selection;
});
ace.define("ace/tokenizer", [
    "require",
    "exports",
    "module",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    var config = require("./config");
    var MAX_TOKEN_COUNT = 2000;
    var Tokenizer = /** @class */ function() {
        function Tokenizer(rules) {
            this.states = rules;
            this.regExps = {};
            this.matchMappings = {};
            for(var key in this.states){
                var state = this.states[key];
                var ruleRegExps = [];
                var matchTotal = 0;
                var mapping = this.matchMappings[key] = {
                    defaultToken: "text"
                };
                var flag = "g";
                var splitterRurles = [];
                for(var i = 0; i < state.length; i++){
                    var rule = state[i];
                    if (rule.defaultToken) mapping.defaultToken = rule.defaultToken;
                    if (rule.caseInsensitive && flag.indexOf("i") === -1) flag += "i";
                    if (rule.unicode && flag.indexOf("u") === -1) flag += "u";
                    if (rule.regex == null) continue;
                    if (rule.regex instanceof RegExp) rule.regex = rule.regex.toString().slice(1, -1);
                    var adjustedregex = rule.regex;
                    var matchcount = new RegExp("(?:(" + adjustedregex + ")|(.))").exec("a").length - 2;
                    if (Array.isArray(rule.token)) {
                        if (rule.token.length == 1 || matchcount == 1) rule.token = rule.token[0];
                        else if (matchcount - 1 != rule.token.length) {
                            this.reportError("number of classes and regexp groups doesn't match", {
                                rule: rule,
                                groupCount: matchcount - 1
                            });
                            rule.token = rule.token[0];
                        } else {
                            rule.tokenArray = rule.token;
                            rule.token = null;
                            rule.onMatch = this.$arrayTokens;
                        }
                    } else if (typeof rule.token == "function" && !rule.onMatch) {
                        if (matchcount > 1) rule.onMatch = this.$applyToken;
                        else rule.onMatch = rule.token;
                    }
                    if (matchcount > 1) {
                        if (/\\\d/.test(rule.regex)) adjustedregex = rule.regex.replace(/\\([0-9]+)/g, function(match, digit) {
                            return "\\" + (parseInt(digit, 10) + matchTotal + 1);
                        });
                        else {
                            matchcount = 1;
                            adjustedregex = this.removeCapturingGroups(rule.regex);
                        }
                        if (!rule.splitRegex && typeof rule.token != "string") splitterRurles.push(rule); // flag will be known only at the very end
                    }
                    mapping[matchTotal] = i;
                    matchTotal += matchcount;
                    ruleRegExps.push(adjustedregex);
                    if (!rule.onMatch) rule.onMatch = null;
                }
                if (!ruleRegExps.length) {
                    mapping[0] = 0;
                    ruleRegExps.push("$");
                }
                splitterRurles.forEach(function(rule) {
                    rule.splitRegex = this.createSplitterRegexp(rule.regex, flag);
                }, this);
                this.regExps[key] = new RegExp("(" + ruleRegExps.join(")|(") + ")|($)", flag);
            }
        }
        Tokenizer.prototype.$setMaxTokenCount = function(m) {
            MAX_TOKEN_COUNT = m | 0;
        };
        Tokenizer.prototype.$applyToken = function(str) {
            var values = this.splitRegex.exec(str).slice(1);
            var types = this.token.apply(this, values);
            if (typeof types === "string") return [
                {
                    type: types,
                    value: str
                }
            ];
            var tokens = [];
            for(var i = 0, l = types.length; i < l; i++)if (values[i]) tokens[tokens.length] = {
                type: types[i],
                value: values[i]
            };
            return tokens;
        };
        Tokenizer.prototype.$arrayTokens = function(str) {
            if (!str) return [];
            var values = this.splitRegex.exec(str);
            if (!values) return "text";
            var tokens = [];
            var types = this.tokenArray;
            for(var i = 0, l = types.length; i < l; i++)if (values[i + 1]) tokens[tokens.length] = {
                type: types[i],
                value: values[i + 1]
            };
            return tokens;
        };
        Tokenizer.prototype.removeCapturingGroups = function(src) {
            var r = src.replace(/\\.|\[(?:\\.|[^\\\]])*|\(\?[:=!<]|(\()/g, function(x, y) {
                return y ? "(?:" : x;
            });
            return r;
        };
        Tokenizer.prototype.createSplitterRegexp = function(src, flag) {
            if (src.indexOf("(?=") != -1) {
                var stack = 0;
                var inChClass = false;
                var lastCapture = {};
                src.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g, function(m, esc, parenOpen, parenClose, square, index) {
                    if (inChClass) inChClass = square != "]";
                    else if (square) inChClass = true;
                    else if (parenClose) {
                        if (stack == lastCapture.stack) {
                            lastCapture.end = index + 1;
                            lastCapture.stack = -1;
                        }
                        stack--;
                    } else if (parenOpen) {
                        stack++;
                        if (parenOpen.length != 1) {
                            lastCapture.stack = stack;
                            lastCapture.start = index;
                        }
                    }
                    return m;
                });
                if (lastCapture.end != null && /^\)*$/.test(src.substr(lastCapture.end))) src = src.substring(0, lastCapture.start) + src.substr(lastCapture.end);
            }
            if (src.charAt(0) != "^") src = "^" + src;
            if (src.charAt(src.length - 1) != "$") src += "$";
            return new RegExp(src, (flag || "").replace("g", ""));
        };
        Tokenizer.prototype.getLineTokens = function(line, startState) {
            if (startState && typeof startState != "string") {
                var stack = startState.slice(0);
                startState = stack[0];
                if (startState === "#tmp") {
                    stack.shift();
                    startState = stack.shift();
                }
            } else var stack = [];
            var currentState = startState || "start";
            var state = this.states[currentState];
            if (!state) {
                currentState = "start";
                state = this.states[currentState];
            }
            var mapping = this.matchMappings[currentState];
            var re = this.regExps[currentState];
            re.lastIndex = 0;
            var match, tokens = [];
            var lastIndex = 0;
            var matchAttempts = 0;
            var token = {
                type: null,
                value: ""
            };
            while(match = re.exec(line)){
                var type = mapping.defaultToken;
                var rule = null;
                var value = match[0];
                var index = re.lastIndex;
                if (index - value.length > lastIndex) {
                    var skipped = line.substring(lastIndex, index - value.length);
                    if (token.type == type) token.value += skipped;
                    else {
                        if (token.type) tokens.push(token);
                        token = {
                            type: type,
                            value: skipped
                        };
                    }
                }
                for(var i = 0; i < match.length - 2; i++){
                    if (match[i + 1] === undefined) continue;
                    rule = state[mapping[i]];
                    if (rule.onMatch) type = rule.onMatch(value, currentState, stack, line);
                    else type = rule.token;
                    if (rule.next) {
                        if (typeof rule.next == "string") currentState = rule.next;
                        else currentState = rule.next(currentState, stack);
                        state = this.states[currentState];
                        if (!state) {
                            this.reportError("state doesn't exist", currentState);
                            currentState = "start";
                            state = this.states[currentState];
                        }
                        mapping = this.matchMappings[currentState];
                        lastIndex = index;
                        re = this.regExps[currentState];
                        re.lastIndex = index;
                    }
                    if (rule.consumeLineEnd) lastIndex = index;
                    break;
                }
                if (value) {
                    if (typeof type === "string") {
                        if ((!rule || rule.merge !== false) && token.type === type) token.value += value;
                        else {
                            if (token.type) tokens.push(token);
                            token = {
                                type: type,
                                value: value
                            };
                        }
                    } else if (type) {
                        if (token.type) tokens.push(token);
                        token = {
                            type: null,
                            value: ""
                        };
                        for(var i = 0; i < type.length; i++)tokens.push(type[i]);
                    }
                }
                if (lastIndex == line.length) break;
                lastIndex = index;
                if (matchAttempts++ > MAX_TOKEN_COUNT) {
                    if (matchAttempts > 2 * line.length) this.reportError("infinite loop with in ace tokenizer", {
                        startState: startState,
                        line: line
                    });
                    while(lastIndex < line.length){
                        if (token.type) tokens.push(token);
                        token = {
                            value: line.substring(lastIndex, lastIndex += 500),
                            type: "overflow"
                        };
                    }
                    currentState = "start";
                    stack = [];
                    break;
                }
            }
            if (token.type) tokens.push(token);
            if (stack.length > 1) {
                if (stack[0] !== currentState) stack.unshift("#tmp", currentState);
            }
            return {
                tokens: tokens,
                state: stack.length ? stack : currentState
            };
        };
        return Tokenizer;
    }();
    Tokenizer.prototype.reportError = config.reportError;
    exports.Tokenizer = Tokenizer;
});
ace.define("ace/mode/text_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/lang"
], function(require, exports, module1) {
    "use strict";
    var lang = require("../lib/lang");
    var TextHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: "empty_line",
                    regex: "^$"
                },
                {
                    defaultToken: "text"
                }
            ]
        };
    };
    (function() {
        this.addRules = function(rules, prefix) {
            if (!prefix) {
                for(var key in rules)this.$rules[key] = rules[key];
                return;
            }
            for(var key in rules){
                var state = rules[key];
                for(var i = 0; i < state.length; i++){
                    var rule = state[i];
                    if (rule.next || rule.onMatch) {
                        if (typeof rule.next == "string") {
                            if (rule.next.indexOf(prefix) !== 0) rule.next = prefix + rule.next;
                        }
                        if (rule.nextState && rule.nextState.indexOf(prefix) !== 0) rule.nextState = prefix + rule.nextState;
                    }
                }
                this.$rules[prefix + key] = state;
            }
        };
        this.getRules = function() {
            return this.$rules;
        };
        this.embedRules = function(HighlightRules, prefix, escapeRules, states, append) {
            var embedRules = typeof HighlightRules == "function" ? new HighlightRules().getRules() : HighlightRules;
            if (states) for(var i = 0; i < states.length; i++)states[i] = prefix + states[i];
            else {
                states = [];
                for(var key in embedRules)states.push(prefix + key);
            }
            this.addRules(embedRules, prefix);
            if (escapeRules) {
                var addRules = Array.prototype[append ? "push" : "unshift"];
                for(var i = 0; i < states.length; i++)addRules.apply(this.$rules[states[i]], lang.deepCopy(escapeRules));
            }
            if (!this.$embeds) this.$embeds = [];
            this.$embeds.push(prefix);
        };
        this.getEmbeds = function() {
            return this.$embeds;
        };
        var pushState = function(currentState, stack) {
            if (currentState != "start" || stack.length) stack.unshift(this.nextState, currentState);
            return this.nextState;
        };
        var popState = function(currentState, stack) {
            stack.shift();
            return stack.shift() || "start";
        };
        this.normalizeRules = function() {
            var id = 0;
            var rules = this.$rules;
            function processState(key) {
                var state = rules[key];
                state.processed = true;
                for(var i = 0; i < state.length; i++){
                    var rule = state[i];
                    var toInsert = null;
                    if (Array.isArray(rule)) {
                        toInsert = rule;
                        rule = {};
                    }
                    if (!rule.regex && rule.start) {
                        rule.regex = rule.start;
                        if (!rule.next) rule.next = [];
                        rule.next.push({
                            defaultToken: rule.token
                        }, {
                            token: rule.token + ".end",
                            regex: rule.end || rule.start,
                            next: "pop"
                        });
                        rule.token = rule.token + ".start";
                        rule.push = true;
                    }
                    var next = rule.next || rule.push;
                    if (next && Array.isArray(next)) {
                        var stateName = rule.stateName;
                        if (!stateName) {
                            stateName = rule.token;
                            if (typeof stateName != "string") stateName = stateName[0] || "";
                            if (rules[stateName]) stateName += id++;
                        }
                        rules[stateName] = next;
                        rule.next = stateName;
                        processState(stateName);
                    } else if (next == "pop") rule.next = popState;
                    if (rule.push) {
                        rule.nextState = rule.next || rule.push;
                        rule.next = pushState;
                        delete rule.push;
                    }
                    if (rule.rules) for(var r in rule.rules){
                        if (rules[r]) {
                            if (rules[r].push) rules[r].push.apply(rules[r], rule.rules[r]);
                        } else rules[r] = rule.rules[r];
                    }
                    var includeName = typeof rule == "string" ? rule : rule.include;
                    if (includeName) {
                        if (includeName === "$self") includeName = "start";
                        if (Array.isArray(includeName)) toInsert = includeName.map(function(x) {
                            return rules[x];
                        });
                        else toInsert = rules[includeName];
                    }
                    if (toInsert) {
                        var args = [
                            i,
                            1
                        ].concat(toInsert);
                        if (rule.noEscape) args = args.filter(function(x) {
                            return !x.next;
                        });
                        state.splice.apply(state, args);
                        i--;
                    }
                    if (rule.keywordMap) {
                        rule.token = this.createKeywordMapper(rule.keywordMap, rule.defaultToken || "text", rule.caseInsensitive);
                        delete rule.defaultToken;
                    }
                }
            }
            Object.keys(rules).forEach(processState, this);
        };
        this.createKeywordMapper = function(map, defaultToken, ignoreCase, splitChar) {
            var keywords = Object.create(null);
            this.$keywordList = [];
            Object.keys(map).forEach(function(className) {
                var a = map[className];
                var list = a.split(splitChar || "|");
                for(var i = list.length; i--;){
                    var word = list[i];
                    this.$keywordList.push(word);
                    if (ignoreCase) word = word.toLowerCase();
                    keywords[word] = className;
                }
            }, this);
            map = null;
            return ignoreCase ? function(value) {
                return keywords[value.toLowerCase()] || defaultToken;
            } : function(value) {
                return keywords[value] || defaultToken;
            };
        };
        this.getKeywords = function() {
            return this.$keywords;
        };
    }).call(TextHighlightRules.prototype);
    exports.TextHighlightRules = TextHighlightRules;
});
ace.define("ace/mode/behaviour", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var Behaviour = function() {
        this.$behaviours = {};
    };
    (function() {
        this.add = function(name, action, callback) {
            switch(undefined){
                case this.$behaviours:
                    this.$behaviours = {};
                case this.$behaviours[name]:
                    this.$behaviours[name] = {};
            }
            this.$behaviours[name][action] = callback;
        };
        this.addBehaviours = function(behaviours) {
            for(var key in behaviours)for(var action in behaviours[key])this.add(key, action, behaviours[key][action]);
        };
        this.remove = function(name) {
            if (this.$behaviours && this.$behaviours[name]) delete this.$behaviours[name];
        };
        this.inherit = function(mode, filter) {
            if (typeof mode === "function") var behaviours = new mode().getBehaviours(filter);
            else var behaviours = mode.getBehaviours(filter);
            this.addBehaviours(behaviours);
        };
        this.getBehaviours = function(filter) {
            if (!filter) return this.$behaviours;
            else {
                var ret = {};
                for(var i = 0; i < filter.length; i++)if (this.$behaviours[filter[i]]) ret[filter[i]] = this.$behaviours[filter[i]];
                return ret;
            }
        };
    }).call(Behaviour.prototype);
    exports.Behaviour = Behaviour;
});
ace.define("ace/token_iterator", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("./range").Range;
    var TokenIterator = /** @class */ function() {
        function TokenIterator(session, initialRow, initialColumn) {
            this.$session = session;
            this.$row = initialRow;
            this.$rowTokens = session.getTokens(initialRow);
            var token = session.getTokenAt(initialRow, initialColumn);
            this.$tokenIndex = token ? token.index : -1;
        }
        TokenIterator.prototype.stepBackward = function() {
            this.$tokenIndex -= 1;
            while(this.$tokenIndex < 0){
                this.$row -= 1;
                if (this.$row < 0) {
                    this.$row = 0;
                    return null;
                }
                this.$rowTokens = this.$session.getTokens(this.$row);
                this.$tokenIndex = this.$rowTokens.length - 1;
            }
            return this.$rowTokens[this.$tokenIndex];
        };
        TokenIterator.prototype.stepForward = function() {
            this.$tokenIndex += 1;
            var rowCount;
            while(this.$tokenIndex >= this.$rowTokens.length){
                this.$row += 1;
                if (!rowCount) rowCount = this.$session.getLength();
                if (this.$row >= rowCount) {
                    this.$row = rowCount - 1;
                    return null;
                }
                this.$rowTokens = this.$session.getTokens(this.$row);
                this.$tokenIndex = 0;
            }
            return this.$rowTokens[this.$tokenIndex];
        };
        TokenIterator.prototype.getCurrentToken = function() {
            return this.$rowTokens[this.$tokenIndex];
        };
        TokenIterator.prototype.getCurrentTokenRow = function() {
            return this.$row;
        };
        TokenIterator.prototype.getCurrentTokenColumn = function() {
            var rowTokens = this.$rowTokens;
            var tokenIndex = this.$tokenIndex;
            var column = rowTokens[tokenIndex].start;
            if (column !== undefined) return column;
            column = 0;
            while(tokenIndex > 0){
                tokenIndex -= 1;
                column += rowTokens[tokenIndex].value.length;
            }
            return column;
        };
        TokenIterator.prototype.getCurrentTokenPosition = function() {
            return {
                row: this.$row,
                column: this.getCurrentTokenColumn()
            };
        };
        TokenIterator.prototype.getCurrentTokenRange = function() {
            var token = this.$rowTokens[this.$tokenIndex];
            var column = this.getCurrentTokenColumn();
            return new Range(this.$row, column, this.$row, column + token.value.length);
        };
        return TokenIterator;
    }();
    exports.TokenIterator = TokenIterator;
});
ace.define("ace/mode/behaviour/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/behaviour",
    "ace/token_iterator",
    "ace/lib/lang"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Behaviour = require("../behaviour").Behaviour;
    var TokenIterator = require("../../token_iterator").TokenIterator;
    var lang = require("../../lib/lang");
    var SAFE_INSERT_IN_TOKENS = [
        "text",
        "paren.rparen",
        "rparen",
        "paren",
        "punctuation.operator"
    ];
    var SAFE_INSERT_BEFORE_TOKENS = [
        "text",
        "paren.rparen",
        "rparen",
        "paren",
        "punctuation.operator",
        "comment"
    ];
    var context;
    var contextCache = {};
    var defaultQuotes = {
        '"': '"',
        "'": "'"
    };
    var initContext = function(editor) {
        var id = -1;
        if (editor.multiSelect) {
            id = editor.selection.index;
            if (contextCache.rangeCount != editor.multiSelect.rangeCount) contextCache = {
                rangeCount: editor.multiSelect.rangeCount
            };
        }
        if (contextCache[id]) return context = contextCache[id];
        context = contextCache[id] = {
            autoInsertedBrackets: 0,
            autoInsertedRow: -1,
            autoInsertedLineEnd: "",
            maybeInsertedBrackets: 0,
            maybeInsertedRow: -1,
            maybeInsertedLineStart: "",
            maybeInsertedLineEnd: ""
        };
    };
    var getWrapped = function(selection, selected, opening, closing) {
        var rowDiff = selection.end.row - selection.start.row;
        return {
            text: opening + selected + closing,
            selection: [
                0,
                selection.start.column + 1,
                rowDiff,
                selection.end.column + (rowDiff ? 0 : 1)
            ]
        };
    };
    var CstyleBehaviour = function(options) {
        options = options || {};
        this.add("braces", "insertion", function(state, action, editor, session, text) {
            var cursor = editor.getCursorPosition();
            var line = session.doc.getLine(cursor.row);
            if (text == "{") {
                initContext(editor);
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                if (selected !== "" && selected !== "{" && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, "{", "}");
                else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                    if (/[\]\}\)]/.test(line[cursor.column]) || editor.inMultiSelectMode || options.braces) {
                        CstyleBehaviour.recordAutoInsert(editor, session, "}");
                        return {
                            text: "{}",
                            selection: [
                                1,
                                1
                            ]
                        };
                    } else {
                        CstyleBehaviour.recordMaybeInsert(editor, session, "{");
                        return {
                            text: "{",
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            } else if (text == "}") {
                initContext(editor);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar == "}") {
                    var matching = session.$findOpeningBracket("}", {
                        column: cursor.column + 1,
                        row: cursor.row
                    });
                    if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                        CstyleBehaviour.popAutoInsertedClosing();
                        return {
                            text: "",
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            } else if (text == "\n" || text == "\r\n") {
                initContext(editor);
                var closing = "";
                if (CstyleBehaviour.isMaybeInsertedClosing(cursor, line)) {
                    closing = lang.stringRepeat("}", context.maybeInsertedBrackets);
                    CstyleBehaviour.clearMaybeInsertedClosing();
                }
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar === "}") {
                    var openBracePos = session.findMatchingBracket({
                        row: cursor.row,
                        column: cursor.column + 1
                    }, "}");
                    if (!openBracePos) return null;
                    var next_indent = this.$getIndent(session.getLine(openBracePos.row));
                } else if (closing) var next_indent = this.$getIndent(line);
                else {
                    CstyleBehaviour.clearMaybeInsertedClosing();
                    return;
                }
                var indent = next_indent + session.getTabString();
                return {
                    text: "\n" + indent + "\n" + next_indent + closing,
                    selection: [
                        1,
                        indent.length,
                        1,
                        indent.length
                    ]
                };
            } else CstyleBehaviour.clearMaybeInsertedClosing();
        });
        this.add("braces", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected == "{") {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.end.column, range.end.column + 1);
                if (rightChar == "}") {
                    range.end.column++;
                    return range;
                } else context.maybeInsertedBrackets--;
            }
        });
        this.add("parens", "insertion", function(state, action, editor, session, text) {
            if (text == "(") {
                initContext(editor);
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                if (selected !== "" && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, "(", ")");
                else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                    CstyleBehaviour.recordAutoInsert(editor, session, ")");
                    return {
                        text: "()",
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            } else if (text == ")") {
                initContext(editor);
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar == ")") {
                    var matching = session.$findOpeningBracket(")", {
                        column: cursor.column + 1,
                        row: cursor.row
                    });
                    if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                        CstyleBehaviour.popAutoInsertedClosing();
                        return {
                            text: "",
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            }
        });
        this.add("parens", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected == "(") {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == ")") {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("brackets", "insertion", function(state, action, editor, session, text) {
            if (text == "[") {
                initContext(editor);
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                if (selected !== "" && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, "[", "]");
                else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
                    CstyleBehaviour.recordAutoInsert(editor, session, "]");
                    return {
                        text: "[]",
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            } else if (text == "]") {
                initContext(editor);
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var rightChar = line.substring(cursor.column, cursor.column + 1);
                if (rightChar == "]") {
                    var matching = session.$findOpeningBracket("]", {
                        column: cursor.column + 1,
                        row: cursor.row
                    });
                    if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
                        CstyleBehaviour.popAutoInsertedClosing();
                        return {
                            text: "",
                            selection: [
                                1,
                                1
                            ]
                        };
                    }
                }
            }
        });
        this.add("brackets", "deletion", function(state, action, editor, session, range) {
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && selected == "[") {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == "]") {
                    range.end.column++;
                    return range;
                }
            }
        });
        this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
            var quotes = session.$mode.$quotes || defaultQuotes;
            if (text.length == 1 && quotes[text]) {
                if (this.lineCommentStart && this.lineCommentStart.indexOf(text) != -1) return;
                initContext(editor);
                var quote = text;
                var selection = editor.getSelectionRange();
                var selected = session.doc.getTextRange(selection);
                if (selected !== "" && (selected.length != 1 || !quotes[selected]) && editor.getWrapBehavioursEnabled()) return getWrapped(selection, selected, quote, quote);
                else if (!selected) {
                    var cursor = editor.getCursorPosition();
                    var line = session.doc.getLine(cursor.row);
                    var leftChar = line.substring(cursor.column - 1, cursor.column);
                    var rightChar = line.substring(cursor.column, cursor.column + 1);
                    var token = session.getTokenAt(cursor.row, cursor.column);
                    var rightToken = session.getTokenAt(cursor.row, cursor.column + 1);
                    if (leftChar == "\\" && token && /escape/.test(token.type)) return null;
                    var stringBefore = token && /string|escape/.test(token.type);
                    var stringAfter = !rightToken || /string|escape/.test(rightToken.type);
                    var pair;
                    if (rightChar == quote) {
                        pair = stringBefore !== stringAfter;
                        if (pair && /string\.end/.test(rightToken.type)) pair = false;
                    } else {
                        if (stringBefore && !stringAfter) return null; // wrap string with different quote
                        if (stringBefore && stringAfter) return null; // do not pair quotes inside strings
                        var wordRe = session.$mode.tokenRe;
                        wordRe.lastIndex = 0;
                        var isWordBefore = wordRe.test(leftChar);
                        wordRe.lastIndex = 0;
                        var isWordAfter = wordRe.test(rightChar);
                        var pairQuotesAfter = session.$mode.$pairQuotesAfter;
                        var shouldPairQuotes = pairQuotesAfter && pairQuotesAfter[quote] && pairQuotesAfter[quote].test(leftChar);
                        if (!shouldPairQuotes && isWordBefore || isWordAfter) return null; // before or after alphanumeric
                        if (rightChar && !/[\s;,.})\]\\]/.test(rightChar)) return null; // there is rightChar and it isn't closing
                        var charBefore = line[cursor.column - 2];
                        if (leftChar == quote && (charBefore == quote || wordRe.test(charBefore))) return null;
                        pair = true;
                    }
                    return {
                        text: pair ? quote + quote : "",
                        selection: [
                            1,
                            1
                        ]
                    };
                }
            }
        });
        this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
            var quotes = session.$mode.$quotes || defaultQuotes;
            var selected = session.doc.getTextRange(range);
            if (!range.isMultiLine() && quotes.hasOwnProperty(selected)) {
                initContext(editor);
                var line = session.doc.getLine(range.start.row);
                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
                if (rightChar == selected) {
                    range.end.column++;
                    return range;
                }
            }
        });
        if (options.closeDocComment !== false) this.add("doc comment end", "insertion", function(state, action, editor, session, text) {
            if (state === "doc-start" && (text === "\n" || text === "\r\n") && editor.selection.isEmpty()) {
                var cursor = editor.getCursorPosition();
                var line = session.doc.getLine(cursor.row);
                var nextLine = session.doc.getLine(cursor.row + 1);
                var indent = this.$getIndent(line);
                if (/\s*\*/.test(nextLine)) {
                    if (/^\s*\*/.test(line)) return {
                        text: text + indent + "* ",
                        selection: [
                            1,
                            3 + indent.length,
                            1,
                            3 + indent.length
                        ]
                    };
                    else return {
                        text: text + indent + " * ",
                        selection: [
                            1,
                            3 + indent.length,
                            1,
                            3 + indent.length
                        ]
                    };
                }
                if (/\/\*\*/.test(line.substring(0, cursor.column))) return {
                    text: text + indent + " * " + text + " " + indent + "*/",
                    selection: [
                        1,
                        4 + indent.length,
                        1,
                        4 + indent.length
                    ]
                };
            }
        });
    };
    CstyleBehaviour.isSaneInsertion = function(editor, session) {
        var cursor = editor.getCursorPosition();
        var iterator = new TokenIterator(session, cursor.row, cursor.column);
        if (!this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) {
            if (/[)}\]]/.test(editor.session.getLine(cursor.row)[cursor.column])) return true;
            var iterator2 = new TokenIterator(session, cursor.row, cursor.column + 1);
            if (!this.$matchTokenType(iterator2.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) return false;
        }
        iterator.stepForward();
        return iterator.getCurrentTokenRow() !== cursor.row || this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_BEFORE_TOKENS);
    };
    CstyleBehaviour.$matchTokenType = function(token, types) {
        return types.indexOf(token.type || token) > -1;
    };
    CstyleBehaviour.recordAutoInsert = function(editor, session, bracket) {
        var cursor = editor.getCursorPosition();
        var line = session.doc.getLine(cursor.row);
        if (!this.isAutoInsertedClosing(cursor, line, context.autoInsertedLineEnd[0])) context.autoInsertedBrackets = 0;
        context.autoInsertedRow = cursor.row;
        context.autoInsertedLineEnd = bracket + line.substr(cursor.column);
        context.autoInsertedBrackets++;
    };
    CstyleBehaviour.recordMaybeInsert = function(editor, session, bracket) {
        var cursor = editor.getCursorPosition();
        var line = session.doc.getLine(cursor.row);
        if (!this.isMaybeInsertedClosing(cursor, line)) context.maybeInsertedBrackets = 0;
        context.maybeInsertedRow = cursor.row;
        context.maybeInsertedLineStart = line.substr(0, cursor.column) + bracket;
        context.maybeInsertedLineEnd = line.substr(cursor.column);
        context.maybeInsertedBrackets++;
    };
    CstyleBehaviour.isAutoInsertedClosing = function(cursor, line, bracket) {
        return context.autoInsertedBrackets > 0 && cursor.row === context.autoInsertedRow && bracket === context.autoInsertedLineEnd[0] && line.substr(cursor.column) === context.autoInsertedLineEnd;
    };
    CstyleBehaviour.isMaybeInsertedClosing = function(cursor, line) {
        return context.maybeInsertedBrackets > 0 && cursor.row === context.maybeInsertedRow && line.substr(cursor.column) === context.maybeInsertedLineEnd && line.substr(0, cursor.column) == context.maybeInsertedLineStart;
    };
    CstyleBehaviour.popAutoInsertedClosing = function() {
        context.autoInsertedLineEnd = context.autoInsertedLineEnd.substr(1);
        context.autoInsertedBrackets--;
    };
    CstyleBehaviour.clearMaybeInsertedClosing = function() {
        if (context) {
            context.maybeInsertedBrackets = 0;
            context.maybeInsertedRow = -1;
        }
    };
    oop.inherits(CstyleBehaviour, Behaviour);
    exports.CstyleBehaviour = CstyleBehaviour;
});
ace.define("ace/unicode", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    var wordChars = [
        48,
        9,
        8,
        25,
        5,
        0,
        2,
        25,
        48,
        0,
        11,
        0,
        5,
        0,
        6,
        22,
        2,
        30,
        2,
        457,
        5,
        11,
        15,
        4,
        8,
        0,
        2,
        0,
        18,
        116,
        2,
        1,
        3,
        3,
        9,
        0,
        2,
        2,
        2,
        0,
        2,
        19,
        2,
        82,
        2,
        138,
        2,
        4,
        3,
        155,
        12,
        37,
        3,
        0,
        8,
        38,
        10,
        44,
        2,
        0,
        2,
        1,
        2,
        1,
        2,
        0,
        9,
        26,
        6,
        2,
        30,
        10,
        7,
        61,
        2,
        9,
        5,
        101,
        2,
        7,
        3,
        9,
        2,
        18,
        3,
        0,
        17,
        58,
        3,
        100,
        15,
        53,
        5,
        0,
        6,
        45,
        211,
        57,
        3,
        18,
        2,
        5,
        3,
        11,
        3,
        9,
        2,
        1,
        7,
        6,
        2,
        2,
        2,
        7,
        3,
        1,
        3,
        21,
        2,
        6,
        2,
        0,
        4,
        3,
        3,
        8,
        3,
        1,
        3,
        3,
        9,
        0,
        5,
        1,
        2,
        4,
        3,
        11,
        16,
        2,
        2,
        5,
        5,
        1,
        3,
        21,
        2,
        6,
        2,
        1,
        2,
        1,
        2,
        1,
        3,
        0,
        2,
        4,
        5,
        1,
        3,
        2,
        4,
        0,
        8,
        3,
        2,
        0,
        8,
        15,
        12,
        2,
        2,
        8,
        2,
        2,
        2,
        21,
        2,
        6,
        2,
        1,
        2,
        4,
        3,
        9,
        2,
        2,
        2,
        2,
        3,
        0,
        16,
        3,
        3,
        9,
        18,
        2,
        2,
        7,
        3,
        1,
        3,
        21,
        2,
        6,
        2,
        1,
        2,
        4,
        3,
        8,
        3,
        1,
        3,
        2,
        9,
        1,
        5,
        1,
        2,
        4,
        3,
        9,
        2,
        0,
        17,
        1,
        2,
        5,
        4,
        2,
        2,
        3,
        4,
        1,
        2,
        0,
        2,
        1,
        4,
        1,
        4,
        2,
        4,
        11,
        5,
        4,
        4,
        2,
        2,
        3,
        3,
        0,
        7,
        0,
        15,
        9,
        18,
        2,
        2,
        7,
        2,
        2,
        2,
        22,
        2,
        9,
        2,
        4,
        4,
        7,
        2,
        2,
        2,
        3,
        8,
        1,
        2,
        1,
        7,
        3,
        3,
        9,
        19,
        1,
        2,
        7,
        2,
        2,
        2,
        22,
        2,
        9,
        2,
        4,
        3,
        8,
        2,
        2,
        2,
        3,
        8,
        1,
        8,
        0,
        2,
        3,
        3,
        9,
        19,
        1,
        2,
        7,
        2,
        2,
        2,
        22,
        2,
        15,
        4,
        7,
        2,
        2,
        2,
        3,
        10,
        0,
        9,
        3,
        3,
        9,
        11,
        5,
        3,
        1,
        2,
        17,
        4,
        23,
        2,
        8,
        2,
        0,
        3,
        6,
        4,
        0,
        5,
        5,
        2,
        0,
        2,
        7,
        19,
        1,
        14,
        57,
        6,
        14,
        2,
        9,
        40,
        1,
        2,
        0,
        3,
        1,
        2,
        0,
        3,
        0,
        7,
        3,
        2,
        6,
        2,
        2,
        2,
        0,
        2,
        0,
        3,
        1,
        2,
        12,
        2,
        2,
        3,
        4,
        2,
        0,
        2,
        5,
        3,
        9,
        3,
        1,
        35,
        0,
        24,
        1,
        7,
        9,
        12,
        0,
        2,
        0,
        2,
        0,
        5,
        9,
        2,
        35,
        5,
        19,
        2,
        5,
        5,
        7,
        2,
        35,
        10,
        0,
        58,
        73,
        7,
        77,
        3,
        37,
        11,
        42,
        2,
        0,
        4,
        328,
        2,
        3,
        3,
        6,
        2,
        0,
        2,
        3,
        3,
        40,
        2,
        3,
        3,
        32,
        2,
        3,
        3,
        6,
        2,
        0,
        2,
        3,
        3,
        14,
        2,
        56,
        2,
        3,
        3,
        66,
        5,
        0,
        33,
        15,
        17,
        84,
        13,
        619,
        3,
        16,
        2,
        25,
        6,
        74,
        22,
        12,
        2,
        6,
        12,
        20,
        12,
        19,
        13,
        12,
        2,
        2,
        2,
        1,
        13,
        51,
        3,
        29,
        4,
        0,
        5,
        1,
        3,
        9,
        34,
        2,
        3,
        9,
        7,
        87,
        9,
        42,
        6,
        69,
        11,
        28,
        4,
        11,
        5,
        11,
        11,
        39,
        3,
        4,
        12,
        43,
        5,
        25,
        7,
        10,
        38,
        27,
        5,
        62,
        2,
        28,
        3,
        10,
        7,
        9,
        14,
        0,
        89,
        75,
        5,
        9,
        18,
        8,
        13,
        42,
        4,
        11,
        71,
        55,
        9,
        9,
        4,
        48,
        83,
        2,
        2,
        30,
        14,
        230,
        23,
        280,
        3,
        5,
        3,
        37,
        3,
        5,
        3,
        7,
        2,
        0,
        2,
        0,
        2,
        0,
        2,
        30,
        3,
        52,
        2,
        6,
        2,
        0,
        4,
        2,
        2,
        6,
        4,
        3,
        3,
        5,
        5,
        12,
        6,
        2,
        2,
        6,
        67,
        1,
        20,
        0,
        29,
        0,
        14,
        0,
        17,
        4,
        60,
        12,
        5,
        0,
        4,
        11,
        18,
        0,
        5,
        0,
        3,
        9,
        2,
        0,
        4,
        4,
        7,
        0,
        2,
        0,
        2,
        0,
        2,
        3,
        2,
        10,
        3,
        3,
        6,
        4,
        5,
        0,
        53,
        1,
        2684,
        46,
        2,
        46,
        2,
        132,
        7,
        6,
        15,
        37,
        11,
        53,
        10,
        0,
        17,
        22,
        10,
        6,
        2,
        6,
        2,
        6,
        2,
        6,
        2,
        6,
        2,
        6,
        2,
        6,
        2,
        6,
        2,
        31,
        48,
        0,
        470,
        1,
        36,
        5,
        2,
        4,
        6,
        1,
        5,
        85,
        3,
        1,
        3,
        2,
        2,
        89,
        2,
        3,
        6,
        40,
        4,
        93,
        18,
        23,
        57,
        15,
        513,
        6581,
        75,
        20939,
        53,
        1164,
        68,
        45,
        3,
        268,
        4,
        27,
        21,
        31,
        3,
        13,
        13,
        1,
        2,
        24,
        9,
        69,
        11,
        1,
        38,
        8,
        3,
        102,
        3,
        1,
        111,
        44,
        25,
        51,
        13,
        68,
        12,
        9,
        7,
        23,
        4,
        0,
        5,
        45,
        3,
        35,
        13,
        28,
        4,
        64,
        15,
        10,
        39,
        54,
        10,
        13,
        3,
        9,
        7,
        22,
        4,
        1,
        5,
        66,
        25,
        2,
        227,
        42,
        2,
        1,
        3,
        9,
        7,
        11171,
        13,
        22,
        5,
        48,
        8453,
        301,
        3,
        61,
        3,
        105,
        39,
        6,
        13,
        4,
        6,
        11,
        2,
        12,
        2,
        4,
        2,
        0,
        2,
        1,
        2,
        1,
        2,
        107,
        34,
        362,
        19,
        63,
        3,
        53,
        41,
        11,
        5,
        15,
        17,
        6,
        13,
        1,
        25,
        2,
        33,
        4,
        2,
        134,
        20,
        9,
        8,
        25,
        5,
        0,
        2,
        25,
        12,
        88,
        4,
        5,
        3,
        5,
        3,
        5,
        3,
        2
    ];
    var code = 0;
    var str = [];
    for(var i = 0; i < wordChars.length; i += 2){
        str.push(code += wordChars[i]);
        if (wordChars[i + 1]) str.push(45, code += wordChars[i + 1]);
    }
    exports.wordChars = String.fromCharCode.apply(null, str);
});
ace.define("ace/mode/text", [
    "require",
    "exports",
    "module",
    "ace/config",
    "ace/tokenizer",
    "ace/mode/text_highlight_rules",
    "ace/mode/behaviour/cstyle",
    "ace/unicode",
    "ace/lib/lang",
    "ace/token_iterator",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var config = require("../config");
    var Tokenizer = require("../tokenizer").Tokenizer;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var CstyleBehaviour = require("./behaviour/cstyle").CstyleBehaviour;
    var unicode = require("../unicode");
    var lang = require("../lib/lang");
    var TokenIterator = require("../token_iterator").TokenIterator;
    var Range = require("../range").Range;
    var Mode = function() {
        this.HighlightRules = TextHighlightRules;
    };
    (function() {
        this.$defaultBehaviour = new CstyleBehaviour();
        this.tokenRe = new RegExp("^[" + unicode.wordChars + "\\$_]+", "g");
        this.nonTokenRe = new RegExp("^(?:[^" + unicode.wordChars + "\\$_]|\\s])+", "g");
        this.getTokenizer = function() {
            if (!this.$tokenizer) {
                this.$highlightRules = this.$highlightRules || new this.HighlightRules(this.$highlightRuleConfig);
                this.$tokenizer = new Tokenizer(this.$highlightRules.getRules());
            }
            return this.$tokenizer;
        };
        this.lineCommentStart = "";
        this.blockComment = "";
        this.toggleCommentLines = function(state, session, startRow, endRow) {
            var doc = session.doc;
            var ignoreBlankLines = true;
            var shouldRemove = true;
            var minIndent = Infinity;
            var tabSize = session.getTabSize();
            var insertAtTabStop = false;
            if (!this.lineCommentStart) {
                if (!this.blockComment) return false;
                var lineCommentStart = this.blockComment.start;
                var lineCommentEnd = this.blockComment.end;
                var regexpStart = new RegExp("^(\\s*)(?:" + lang.escapeRegExp(lineCommentStart) + ")");
                var regexpEnd = new RegExp("(?:" + lang.escapeRegExp(lineCommentEnd) + ")\\s*$");
                var comment = function(line, i) {
                    if (testRemove(line, i)) return;
                    if (!ignoreBlankLines || /\S/.test(line)) {
                        doc.insertInLine({
                            row: i,
                            column: line.length
                        }, lineCommentEnd);
                        doc.insertInLine({
                            row: i,
                            column: minIndent
                        }, lineCommentStart);
                    }
                };
                var uncomment = function(line, i) {
                    var m;
                    if (m = line.match(regexpEnd)) doc.removeInLine(i, line.length - m[0].length, line.length);
                    if (m = line.match(regexpStart)) doc.removeInLine(i, m[1].length, m[0].length);
                };
                var testRemove = function(line, row) {
                    if (regexpStart.test(line)) return true;
                    var tokens = session.getTokens(row);
                    for(var i = 0; i < tokens.length; i++){
                        if (tokens[i].type === "comment") return true;
                    }
                };
            } else {
                if (Array.isArray(this.lineCommentStart)) {
                    var regexpStart = this.lineCommentStart.map(lang.escapeRegExp).join("|");
                    var lineCommentStart = this.lineCommentStart[0];
                } else {
                    var regexpStart = lang.escapeRegExp(this.lineCommentStart);
                    var lineCommentStart = this.lineCommentStart;
                }
                regexpStart = new RegExp("^(\\s*)(?:" + regexpStart + ") ?");
                insertAtTabStop = session.getUseSoftTabs();
                var uncomment = function(line, i) {
                    var m = line.match(regexpStart);
                    if (!m) return;
                    var start = m[1].length, end = m[0].length;
                    if (!shouldInsertSpace(line, start, end) && m[0][end - 1] == " ") end--;
                    doc.removeInLine(i, start, end);
                };
                var commentWithSpace = lineCommentStart + " ";
                var comment = function(line, i) {
                    if (!ignoreBlankLines || /\S/.test(line)) {
                        if (shouldInsertSpace(line, minIndent, minIndent)) doc.insertInLine({
                            row: i,
                            column: minIndent
                        }, commentWithSpace);
                        else doc.insertInLine({
                            row: i,
                            column: minIndent
                        }, lineCommentStart);
                    }
                };
                var testRemove = function(line, i) {
                    return regexpStart.test(line);
                };
                var shouldInsertSpace = function(line, before, after) {
                    var spaces = 0;
                    while(before-- && line.charAt(before) == " ")spaces++;
                    if (spaces % tabSize != 0) return false;
                    var spaces = 0;
                    while(line.charAt(after++) == " ")spaces++;
                    if (tabSize > 2) return spaces % tabSize != tabSize - 1;
                    else return spaces % tabSize == 0;
                };
            }
            function iter(fun) {
                for(var i = startRow; i <= endRow; i++)fun(doc.getLine(i), i);
            }
            var minEmptyLength = Infinity;
            iter(function(line, i) {
                var indent = line.search(/\S/);
                if (indent !== -1) {
                    if (indent < minIndent) minIndent = indent;
                    if (shouldRemove && !testRemove(line, i)) shouldRemove = false;
                } else if (minEmptyLength > line.length) minEmptyLength = line.length;
            });
            if (minIndent == Infinity) {
                minIndent = minEmptyLength;
                ignoreBlankLines = false;
                shouldRemove = false;
            }
            if (insertAtTabStop && minIndent % tabSize != 0) minIndent = Math.floor(minIndent / tabSize) * tabSize;
            iter(shouldRemove ? uncomment : comment);
        };
        this.toggleBlockComment = function(state, session, range, cursor) {
            var comment = this.blockComment;
            if (!comment) return;
            if (!comment.start && comment[0]) comment = comment[0];
            var iterator = new TokenIterator(session, cursor.row, cursor.column);
            var token = iterator.getCurrentToken();
            var sel = session.selection;
            var initialRange = session.selection.toOrientedRange();
            var startRow, colDiff;
            if (token && /comment/.test(token.type)) {
                var startRange, endRange;
                while(token && /comment/.test(token.type)){
                    var i = token.value.indexOf(comment.start);
                    if (i != -1) {
                        var row = iterator.getCurrentTokenRow();
                        var column = iterator.getCurrentTokenColumn() + i;
                        startRange = new Range(row, column, row, column + comment.start.length);
                        break;
                    }
                    token = iterator.stepBackward();
                }
                var iterator = new TokenIterator(session, cursor.row, cursor.column);
                var token = iterator.getCurrentToken();
                while(token && /comment/.test(token.type)){
                    var i = token.value.indexOf(comment.end);
                    if (i != -1) {
                        var row = iterator.getCurrentTokenRow();
                        var column = iterator.getCurrentTokenColumn() + i;
                        endRange = new Range(row, column, row, column + comment.end.length);
                        break;
                    }
                    token = iterator.stepForward();
                }
                if (endRange) session.remove(endRange);
                if (startRange) {
                    session.remove(startRange);
                    startRow = startRange.start.row;
                    colDiff = -comment.start.length;
                }
            } else {
                colDiff = comment.start.length;
                startRow = range.start.row;
                session.insert(range.end, comment.end);
                session.insert(range.start, comment.start);
            }
            if (initialRange.start.row == startRow) initialRange.start.column += colDiff;
            if (initialRange.end.row == startRow) initialRange.end.column += colDiff;
            session.selection.fromOrientedRange(initialRange);
        };
        this.getNextLineIndent = function(state, line, tab) {
            return this.$getIndent(line);
        };
        this.checkOutdent = function(state, line, input) {
            return false;
        };
        this.autoOutdent = function(state, doc, row) {};
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
        this.createWorker = function(session) {
            return null;
        };
        this.createModeDelegates = function(mapping) {
            this.$embeds = [];
            this.$modes = {};
            for(var i in mapping)if (mapping[i]) {
                var Mode = mapping[i];
                var id = Mode.prototype.$id;
                var mode = config.$modes[id];
                if (!mode) config.$modes[id] = mode = new Mode();
                if (!config.$modes[i]) config.$modes[i] = mode;
                this.$embeds.push(i);
                this.$modes[i] = mode;
            }
            var delegations = [
                "toggleBlockComment",
                "toggleCommentLines",
                "getNextLineIndent",
                "checkOutdent",
                "autoOutdent",
                "transformAction",
                "getCompletions"
            ];
            for(var i = 0; i < delegations.length; i++)(function(scope) {
                var functionName = delegations[i];
                var defaultHandler = scope[functionName];
                scope[delegations[i]] = function() {
                    return this.$delegator(functionName, arguments, defaultHandler);
                };
            })(this);
        };
        this.$delegator = function(method, args, defaultHandler) {
            var state = args[0] || "start";
            if (typeof state != "string") {
                if (Array.isArray(state[2])) {
                    var language = state[2][state[2].length - 1];
                    var mode = this.$modes[language];
                    if (mode) return mode[method].apply(mode, [
                        state[1]
                    ].concat([].slice.call(args, 1)));
                }
                state = state[0] || "start";
            }
            for(var i = 0; i < this.$embeds.length; i++){
                if (!this.$modes[this.$embeds[i]]) continue;
                var split = state.split(this.$embeds[i]);
                if (!split[0] && split[1]) {
                    args[0] = split[1];
                    var mode = this.$modes[this.$embeds[i]];
                    return mode[method].apply(mode, args);
                }
            }
            var ret = defaultHandler.apply(this, args);
            return defaultHandler ? ret : undefined;
        };
        this.transformAction = function(state, action, editor, session, param) {
            if (this.$behaviour) {
                var behaviours = this.$behaviour.getBehaviours();
                for(var key in behaviours)if (behaviours[key][action]) {
                    var ret = behaviours[key][action].apply(this, arguments);
                    if (ret) return ret;
                }
            }
        };
        this.getKeywords = function(append) {
            if (!this.completionKeywords) {
                var rules = this.$tokenizer.rules;
                var completionKeywords = [];
                for(var rule in rules){
                    var ruleItr = rules[rule];
                    for(var r = 0, l = ruleItr.length; r < l; r++){
                        if (typeof ruleItr[r].token === "string") {
                            if (/keyword|support|storage/.test(ruleItr[r].token)) completionKeywords.push(ruleItr[r].regex);
                        } else if (typeof ruleItr[r].token === "object") {
                            for(var a = 0, aLength = ruleItr[r].token.length; a < aLength; a++)if (/keyword|support|storage/.test(ruleItr[r].token[a])) {
                                var rule = ruleItr[r].regex.match(/\(.+?\)/g)[a];
                                completionKeywords.push(rule.substr(1, rule.length - 2));
                            }
                        }
                    }
                }
                this.completionKeywords = completionKeywords;
            }
            if (!append) return this.$keywordList;
            return completionKeywords.concat(this.$keywordList || []);
        };
        this.$createKeywordList = function() {
            if (!this.$highlightRules) this.getTokenizer();
            return this.$keywordList = this.$highlightRules.$keywordList || [];
        };
        this.getCompletions = function(state, session, pos, prefix) {
            var keywords = this.$keywordList || this.$createKeywordList();
            return keywords.map(function(word) {
                return {
                    name: word,
                    value: word,
                    score: 0,
                    meta: "keyword"
                };
            });
        };
        this.$id = "ace/mode/text";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/apply_delta", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    "use strict";
    function throwDeltaError(delta, errorText) {
        console.log("Invalid Delta:", delta);
        throw "Invalid Delta: " + errorText;
    }
    function positionInDocument(docLines, position) {
        return position.row >= 0 && position.row < docLines.length && position.column >= 0 && position.column <= docLines[position.row].length;
    }
    function validateDelta(docLines, delta) {
        if (delta.action != "insert" && delta.action != "remove") throwDeltaError(delta, "delta.action must be 'insert' or 'remove'");
        if (!(delta.lines instanceof Array)) throwDeltaError(delta, "delta.lines must be an Array");
        if (!delta.start || !delta.end) throwDeltaError(delta, "delta.start/end must be an present");
        var start = delta.start;
        if (!positionInDocument(docLines, delta.start)) throwDeltaError(delta, "delta.start must be contained in document");
        var end = delta.end;
        if (delta.action == "remove" && !positionInDocument(docLines, end)) throwDeltaError(delta, "delta.end must contained in document for 'remove' actions");
        var numRangeRows = end.row - start.row;
        var numRangeLastLineChars = end.column - (numRangeRows == 0 ? start.column : 0);
        if (numRangeRows != delta.lines.length - 1 || delta.lines[numRangeRows].length != numRangeLastLineChars) throwDeltaError(delta, "delta.range must match delta lines");
    }
    exports.applyDelta = function(docLines, delta, doNotValidate) {
        var row = delta.start.row;
        var startColumn = delta.start.column;
        var line = docLines[row] || "";
        switch(delta.action){
            case "insert":
                var lines = delta.lines;
                if (lines.length === 1) docLines[row] = line.substring(0, startColumn) + delta.lines[0] + line.substring(startColumn);
                else {
                    var args = [
                        row,
                        1
                    ].concat(delta.lines);
                    docLines.splice.apply(docLines, args);
                    docLines[row] = line.substring(0, startColumn) + docLines[row];
                    docLines[row + delta.lines.length - 1] += line.substring(startColumn);
                }
                break;
            case "remove":
                var endColumn = delta.end.column;
                var endRow = delta.end.row;
                if (row === endRow) docLines[row] = line.substring(0, startColumn) + line.substring(endColumn);
                else docLines.splice(row, endRow - row + 1, line.substring(0, startColumn) + docLines[endRow].substring(endColumn));
                break;
        }
    };
});
ace.define("ace/anchor", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var Anchor = /** @class */ function() {
        function Anchor(doc, row, column) {
            this.$onChange = this.onChange.bind(this);
            this.attach(doc);
            if (typeof column == "undefined") this.setPosition(row.row, row.column);
            else this.setPosition(row, column);
        }
        Anchor.prototype.getPosition = function() {
            return this.$clipPositionToDocument(this.row, this.column);
        };
        Anchor.prototype.getDocument = function() {
            return this.document;
        };
        Anchor.prototype.onChange = function(delta) {
            if (delta.start.row == delta.end.row && delta.start.row != this.row) return;
            if (delta.start.row > this.row) return;
            var point = $getTransformedPoint(delta, {
                row: this.row,
                column: this.column
            }, this.$insertRight);
            this.setPosition(point.row, point.column, true);
        };
        Anchor.prototype.setPosition = function(row, column, noClip) {
            var pos;
            if (noClip) pos = {
                row: row,
                column: column
            };
            else pos = this.$clipPositionToDocument(row, column);
            if (this.row == pos.row && this.column == pos.column) return;
            var old = {
                row: this.row,
                column: this.column
            };
            this.row = pos.row;
            this.column = pos.column;
            this._signal("change", {
                old: old,
                value: pos
            });
        };
        Anchor.prototype.detach = function() {
            this.document.off("change", this.$onChange);
        };
        Anchor.prototype.attach = function(doc) {
            this.document = doc || this.document;
            this.document.on("change", this.$onChange);
        };
        Anchor.prototype.$clipPositionToDocument = function(row, column) {
            var pos = {};
            if (row >= this.document.getLength()) {
                pos.row = Math.max(0, this.document.getLength() - 1);
                pos.column = this.document.getLine(pos.row).length;
            } else if (row < 0) {
                pos.row = 0;
                pos.column = 0;
            } else {
                pos.row = row;
                pos.column = Math.min(this.document.getLine(pos.row).length, Math.max(0, column));
            }
            if (column < 0) pos.column = 0;
            return pos;
        };
        return Anchor;
    }();
    Anchor.prototype.$insertRight = false;
    oop.implement(Anchor.prototype, EventEmitter);
    function $pointsInOrder(point1, point2, equalPointsInOrder) {
        var bColIsAfter = equalPointsInOrder ? point1.column <= point2.column : point1.column < point2.column;
        return point1.row < point2.row || point1.row == point2.row && bColIsAfter;
    }
    function $getTransformedPoint(delta, point, moveIfEqual) {
        var deltaIsInsert = delta.action == "insert";
        var deltaRowShift = (deltaIsInsert ? 1 : -1) * (delta.end.row - delta.start.row);
        var deltaColShift = (deltaIsInsert ? 1 : -1) * (delta.end.column - delta.start.column);
        var deltaStart = delta.start;
        var deltaEnd = deltaIsInsert ? deltaStart : delta.end; // Collapse insert range.
        if ($pointsInOrder(point, deltaStart, moveIfEqual)) return {
            row: point.row,
            column: point.column
        };
        if ($pointsInOrder(deltaEnd, point, !moveIfEqual)) return {
            row: point.row + deltaRowShift,
            column: point.column + (point.row == deltaEnd.row ? deltaColShift : 0)
        };
        return {
            row: deltaStart.row,
            column: deltaStart.column
        };
    }
    exports.Anchor = Anchor;
});
ace.define("ace/document", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/apply_delta",
    "ace/lib/event_emitter",
    "ace/range",
    "ace/anchor"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var applyDelta = require("./apply_delta").applyDelta;
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var Range = require("./range").Range;
    var Anchor = require("./anchor").Anchor;
    var Document = /** @class */ function() {
        function Document(textOrLines) {
            this.$lines = [
                ""
            ];
            if (textOrLines.length === 0) this.$lines = [
                ""
            ];
            else if (Array.isArray(textOrLines)) this.insertMergedLines({
                row: 0,
                column: 0
            }, textOrLines);
            else this.insert({
                row: 0,
                column: 0
            }, textOrLines);
        }
        Document.prototype.setValue = function(text) {
            var len = this.getLength() - 1;
            this.remove(new Range(0, 0, len, this.getLine(len).length));
            this.insert({
                row: 0,
                column: 0
            }, text || "");
        };
        Document.prototype.getValue = function() {
            return this.getAllLines().join(this.getNewLineCharacter());
        };
        Document.prototype.createAnchor = function(row, column) {
            return new Anchor(this, row, column);
        };
        Document.prototype.$detectNewLine = function(text) {
            var match = text.match(/^.*?(\r\n|\r|\n)/m);
            this.$autoNewLine = match ? match[1] : "\n";
            this._signal("changeNewLineMode");
        };
        Document.prototype.getNewLineCharacter = function() {
            switch(this.$newLineMode){
                case "windows":
                    return "\r\n";
                case "unix":
                    return "\n";
                default:
                    return this.$autoNewLine || "\n";
            }
        };
        Document.prototype.setNewLineMode = function(newLineMode) {
            if (this.$newLineMode === newLineMode) return;
            this.$newLineMode = newLineMode;
            this._signal("changeNewLineMode");
        };
        Document.prototype.getNewLineMode = function() {
            return this.$newLineMode;
        };
        Document.prototype.isNewLine = function(text) {
            return text == "\r\n" || text == "\r" || text == "\n";
        };
        Document.prototype.getLine = function(row) {
            return this.$lines[row] || "";
        };
        Document.prototype.getLines = function(firstRow, lastRow) {
            return this.$lines.slice(firstRow, lastRow + 1);
        };
        Document.prototype.getAllLines = function() {
            return this.getLines(0, this.getLength());
        };
        Document.prototype.getLength = function() {
            return this.$lines.length;
        };
        Document.prototype.getTextRange = function(range) {
            return this.getLinesForRange(range).join(this.getNewLineCharacter());
        };
        Document.prototype.getLinesForRange = function(range) {
            var lines;
            if (range.start.row === range.end.row) lines = [
                this.getLine(range.start.row).substring(range.start.column, range.end.column)
            ];
            else {
                lines = this.getLines(range.start.row, range.end.row);
                lines[0] = (lines[0] || "").substring(range.start.column);
                var l = lines.length - 1;
                if (range.end.row - range.start.row == l) lines[l] = lines[l].substring(0, range.end.column);
            }
            return lines;
        };
        Document.prototype.insertLines = function(row, lines) {
            console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead.");
            return this.insertFullLines(row, lines);
        };
        Document.prototype.removeLines = function(firstRow, lastRow) {
            console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead.");
            return this.removeFullLines(firstRow, lastRow);
        };
        Document.prototype.insertNewLine = function(position) {
            console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.");
            return this.insertMergedLines(position, [
                "",
                ""
            ]);
        };
        Document.prototype.insert = function(position, text) {
            if (this.getLength() <= 1) this.$detectNewLine(text);
            return this.insertMergedLines(position, this.$split(text));
        };
        Document.prototype.insertInLine = function(position, text) {
            var start = this.clippedPos(position.row, position.column);
            var end = this.pos(position.row, position.column + text.length);
            this.applyDelta({
                start: start,
                end: end,
                action: "insert",
                lines: [
                    text
                ]
            }, true);
            return this.clonePos(end);
        };
        Document.prototype.clippedPos = function(row, column) {
            var length = this.getLength();
            if (row === undefined) row = length;
            else if (row < 0) row = 0;
            else if (row >= length) {
                row = length - 1;
                column = undefined;
            }
            var line = this.getLine(row);
            if (column == undefined) column = line.length;
            column = Math.min(Math.max(column, 0), line.length);
            return {
                row: row,
                column: column
            };
        };
        Document.prototype.clonePos = function(pos) {
            return {
                row: pos.row,
                column: pos.column
            };
        };
        Document.prototype.pos = function(row, column) {
            return {
                row: row,
                column: column
            };
        };
        Document.prototype.$clipPosition = function(position) {
            var length = this.getLength();
            if (position.row >= length) {
                position.row = Math.max(0, length - 1);
                position.column = this.getLine(length - 1).length;
            } else {
                position.row = Math.max(0, position.row);
                position.column = Math.min(Math.max(position.column, 0), this.getLine(position.row).length);
            }
            return position;
        };
        Document.prototype.insertFullLines = function(row, lines) {
            row = Math.min(Math.max(row, 0), this.getLength());
            var column = 0;
            if (row < this.getLength()) {
                lines = lines.concat([
                    ""
                ]);
                column = 0;
            } else {
                lines = [
                    ""
                ].concat(lines);
                row--;
                column = this.$lines[row].length;
            }
            this.insertMergedLines({
                row: row,
                column: column
            }, lines);
        };
        Document.prototype.insertMergedLines = function(position, lines) {
            var start = this.clippedPos(position.row, position.column);
            var end = {
                row: start.row + lines.length - 1,
                column: (lines.length == 1 ? start.column : 0) + lines[lines.length - 1].length
            };
            this.applyDelta({
                start: start,
                end: end,
                action: "insert",
                lines: lines
            });
            return this.clonePos(end);
        };
        Document.prototype.remove = function(range) {
            var start = this.clippedPos(range.start.row, range.start.column);
            var end = this.clippedPos(range.end.row, range.end.column);
            this.applyDelta({
                start: start,
                end: end,
                action: "remove",
                lines: this.getLinesForRange({
                    start: start,
                    end: end
                })
            });
            return this.clonePos(start);
        };
        Document.prototype.removeInLine = function(row, startColumn, endColumn) {
            var start = this.clippedPos(row, startColumn);
            var end = this.clippedPos(row, endColumn);
            this.applyDelta({
                start: start,
                end: end,
                action: "remove",
                lines: this.getLinesForRange({
                    start: start,
                    end: end
                })
            }, true);
            return this.clonePos(start);
        };
        Document.prototype.removeFullLines = function(firstRow, lastRow) {
            firstRow = Math.min(Math.max(0, firstRow), this.getLength() - 1);
            lastRow = Math.min(Math.max(0, lastRow), this.getLength() - 1);
            var deleteFirstNewLine = lastRow == this.getLength() - 1 && firstRow > 0;
            var deleteLastNewLine = lastRow < this.getLength() - 1;
            var startRow = deleteFirstNewLine ? firstRow - 1 : firstRow;
            var startCol = deleteFirstNewLine ? this.getLine(startRow).length : 0;
            var endRow = deleteLastNewLine ? lastRow + 1 : lastRow;
            var endCol = deleteLastNewLine ? 0 : this.getLine(endRow).length;
            var range = new Range(startRow, startCol, endRow, endCol);
            var deletedLines = this.$lines.slice(firstRow, lastRow + 1);
            this.applyDelta({
                start: range.start,
                end: range.end,
                action: "remove",
                lines: this.getLinesForRange(range)
            });
            return deletedLines;
        };
        Document.prototype.removeNewLine = function(row) {
            if (row < this.getLength() - 1 && row >= 0) this.applyDelta({
                start: this.pos(row, this.getLine(row).length),
                end: this.pos(row + 1, 0),
                action: "remove",
                lines: [
                    "",
                    ""
                ]
            });
        };
        Document.prototype.replace = function(range, text) {
            if (!(range instanceof Range)) range = Range.fromPoints(range.start, range.end);
            if (text.length === 0 && range.isEmpty()) return range.start;
            if (text == this.getTextRange(range)) return range.end;
            this.remove(range);
            var end;
            if (text) end = this.insert(range.start, text);
            else end = range.start;
            return end;
        };
        Document.prototype.applyDeltas = function(deltas) {
            for(var i = 0; i < deltas.length; i++)this.applyDelta(deltas[i]);
        };
        Document.prototype.revertDeltas = function(deltas) {
            for(var i = deltas.length - 1; i >= 0; i--)this.revertDelta(deltas[i]);
        };
        Document.prototype.applyDelta = function(delta, doNotValidate) {
            var isInsert = delta.action == "insert";
            if (isInsert ? delta.lines.length <= 1 && !delta.lines[0] : !Range.comparePoints(delta.start, delta.end)) return;
            if (isInsert && delta.lines.length > 20000) this.$splitAndapplyLargeDelta(delta, 20000);
            else {
                applyDelta(this.$lines, delta, doNotValidate);
                this._signal("change", delta);
            }
        };
        Document.prototype.$safeApplyDelta = function(delta) {
            var docLength = this.$lines.length;
            if (delta.action == "remove" && delta.start.row < docLength && delta.end.row < docLength || delta.action == "insert" && delta.start.row <= docLength) this.applyDelta(delta);
        };
        Document.prototype.$splitAndapplyLargeDelta = function(delta, MAX) {
            var lines = delta.lines;
            var l = lines.length - MAX + 1;
            var row = delta.start.row;
            var column = delta.start.column;
            for(var from = 0, to = 0; from < l; from = to){
                to += MAX - 1;
                var chunk = lines.slice(from, to);
                chunk.push("");
                this.applyDelta({
                    start: this.pos(row + from, column),
                    end: this.pos(row + to, column = 0),
                    action: delta.action,
                    lines: chunk
                }, true);
            }
            delta.lines = lines.slice(from);
            delta.start.row = row + from;
            delta.start.column = column;
            this.applyDelta(delta, true);
        };
        Document.prototype.revertDelta = function(delta) {
            this.$safeApplyDelta({
                start: this.clonePos(delta.start),
                end: this.clonePos(delta.end),
                action: delta.action == "insert" ? "remove" : "insert",
                lines: delta.lines.slice()
            });
        };
        Document.prototype.indexToPosition = function(index, startRow) {
            var lines = this.$lines || this.getAllLines();
            var newlineLength = this.getNewLineCharacter().length;
            for(var i = startRow || 0, l = lines.length; i < l; i++){
                index -= lines[i].length + newlineLength;
                if (index < 0) return {
                    row: i,
                    column: index + lines[i].length + newlineLength
                };
            }
            return {
                row: l - 1,
                column: index + lines[l - 1].length + newlineLength
            };
        };
        Document.prototype.positionToIndex = function(pos, startRow) {
            var lines = this.$lines || this.getAllLines();
            var newlineLength = this.getNewLineCharacter().length;
            var index = 0;
            var row = Math.min(pos.row, lines.length);
            for(var i = startRow || 0; i < row; ++i)index += lines[i].length + newlineLength;
            return index + pos.column;
        };
        Document.prototype.$split = function(text) {
            return text.split(/\r\n|\r|\n/);
        };
        return Document;
    }();
    Document.prototype.$autoNewLine = "";
    Document.prototype.$newLineMode = "auto";
    oop.implement(Document.prototype, EventEmitter);
    exports.Document = Document;
});
ace.define("ace/background_tokenizer", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var BackgroundTokenizer = /** @class */ function() {
        function BackgroundTokenizer(tokenizer, editor) {
            this.running = false;
            this.lines = [];
            this.states = [];
            this.currentLine = 0;
            this.tokenizer = tokenizer;
            var self1 = this;
            this.$worker = function() {
                if (!self1.running) return;
                var workerStart = new Date();
                var currentLine = self1.currentLine;
                var endLine = -1;
                var doc = self1.doc;
                var startLine = currentLine;
                while(self1.lines[currentLine])currentLine++;
                var len = doc.getLength();
                var processedLines = 0;
                self1.running = false;
                while(currentLine < len){
                    self1.$tokenizeRow(currentLine);
                    endLine = currentLine;
                    do currentLine++;
                    while (self1.lines[currentLine]);
                    processedLines++;
                    if (processedLines % 5 === 0 && new Date() - workerStart > 20) {
                        self1.running = setTimeout(self1.$worker, 20);
                        break;
                    }
                }
                self1.currentLine = currentLine;
                if (endLine == -1) endLine = currentLine;
                if (startLine <= endLine) self1.fireUpdateEvent(startLine, endLine);
            };
        }
        BackgroundTokenizer.prototype.setTokenizer = function(tokenizer) {
            this.tokenizer = tokenizer;
            this.lines = [];
            this.states = [];
            this.start(0);
        };
        BackgroundTokenizer.prototype.setDocument = function(doc) {
            this.doc = doc;
            this.lines = [];
            this.states = [];
            this.stop();
        };
        BackgroundTokenizer.prototype.fireUpdateEvent = function(firstRow, lastRow) {
            var data = {
                first: firstRow,
                last: lastRow
            };
            this._signal("update", {
                data: data
            });
        };
        BackgroundTokenizer.prototype.start = function(startRow) {
            this.currentLine = Math.min(startRow || 0, this.currentLine, this.doc.getLength());
            this.lines.splice(this.currentLine, this.lines.length);
            this.states.splice(this.currentLine, this.states.length);
            this.stop();
            this.running = setTimeout(this.$worker, 700);
        };
        BackgroundTokenizer.prototype.scheduleStart = function() {
            if (!this.running) this.running = setTimeout(this.$worker, 700);
        };
        BackgroundTokenizer.prototype.$updateOnChange = function(delta) {
            var startRow = delta.start.row;
            var len = delta.end.row - startRow;
            if (len === 0) this.lines[startRow] = null;
            else if (delta.action == "remove") {
                this.lines.splice(startRow, len + 1, null);
                this.states.splice(startRow, len + 1, null);
            } else {
                var args = Array(len + 1);
                args.unshift(startRow, 1);
                this.lines.splice.apply(this.lines, args);
                this.states.splice.apply(this.states, args);
            }
            this.currentLine = Math.min(startRow, this.currentLine, this.doc.getLength());
            this.stop();
        };
        BackgroundTokenizer.prototype.stop = function() {
            if (this.running) clearTimeout(this.running);
            this.running = false;
        };
        BackgroundTokenizer.prototype.getTokens = function(row) {
            return this.lines[row] || this.$tokenizeRow(row);
        };
        BackgroundTokenizer.prototype.getState = function(row) {
            if (this.currentLine == row) this.$tokenizeRow(row);
            return this.states[row] || "start";
        };
        BackgroundTokenizer.prototype.$tokenizeRow = function(row) {
            var line = this.doc.getLine(row);
            var state = this.states[row - 1];
            var data = this.tokenizer.getLineTokens(line, state, row);
            if (this.states[row] + "" !== data.state + "") {
                this.states[row] = data.state;
                this.lines[row + 1] = null;
                if (this.currentLine > row + 1) this.currentLine = row + 1;
            } else if (this.currentLine == row) this.currentLine = row + 1;
            return this.lines[row] = data.tokens;
        };
        BackgroundTokenizer.prototype.cleanup = function() {
            this.running = false;
            this.lines = [];
            this.states = [];
            this.currentLine = 0;
            this.removeAllListeners();
        };
        return BackgroundTokenizer;
    }();
    oop.implement(BackgroundTokenizer.prototype, EventEmitter);
    exports.BackgroundTokenizer = BackgroundTokenizer;
});
ace.define("ace/search_highlight", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var lang = require("./lib/lang");
    var Range = require("./range").Range;
    var SearchHighlight = /** @class */ function() {
        function SearchHighlight(regExp, clazz, type) {
            if (type === void 0) type = "text";
            this.setRegexp(regExp);
            this.clazz = clazz;
            this.type = type;
        }
        SearchHighlight.prototype.setRegexp = function(regExp) {
            if (this.regExp + "" == regExp + "") return;
            this.regExp = regExp;
            this.cache = [];
        };
        SearchHighlight.prototype.update = function(html, markerLayer, session, config) {
            if (!this.regExp) return;
            var start = config.firstRow, end = config.lastRow;
            var renderedMarkerRanges = {};
            for(var i = start; i <= end; i++){
                var ranges = this.cache[i];
                if (ranges == null) {
                    ranges = lang.getMatchOffsets(session.getLine(i), this.regExp);
                    if (ranges.length > this.MAX_RANGES) ranges = ranges.slice(0, this.MAX_RANGES);
                    ranges = ranges.map(function(match) {
                        return new Range(i, match.offset, i, match.offset + match.length);
                    });
                    this.cache[i] = ranges.length ? ranges : "";
                }
                for(var j = ranges.length; j--;){
                    var rangeToAddMarkerTo = ranges[j].toScreenRange(session);
                    var rangeAsString = rangeToAddMarkerTo.toString();
                    if (renderedMarkerRanges[rangeAsString]) continue;
                    renderedMarkerRanges[rangeAsString] = true;
                    markerLayer.drawSingleLineMarker(html, rangeToAddMarkerTo, this.clazz, config);
                }
            }
        };
        return SearchHighlight;
    }();
    SearchHighlight.prototype.MAX_RANGES = 500;
    exports.SearchHighlight = SearchHighlight;
});
ace.define("ace/edit_session/fold_line", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var FoldLine = /** @class */ function() {
        function FoldLine(foldData, folds) {
            this.foldData = foldData;
            if (Array.isArray(folds)) this.folds = folds;
            else folds = this.folds = [
                folds
            ];
            var last = folds[folds.length - 1];
            this.range = new Range(folds[0].start.row, folds[0].start.column, last.end.row, last.end.column);
            this.start = this.range.start;
            this.end = this.range.end;
            this.folds.forEach(function(fold) {
                fold.setFoldLine(this);
            }, this);
        }
        FoldLine.prototype.shiftRow = function(shift) {
            this.start.row += shift;
            this.end.row += shift;
            this.folds.forEach(function(fold) {
                fold.start.row += shift;
                fold.end.row += shift;
            });
        };
        FoldLine.prototype.addFold = function(fold) {
            if (fold.sameRow) {
                if (fold.start.row < this.startRow || fold.endRow > this.endRow) throw new Error("Can't add a fold to this FoldLine as it has no connection");
                this.folds.push(fold);
                this.folds.sort(function(a, b) {
                    return -a.range.compareEnd(b.start.row, b.start.column);
                });
                if (this.range.compareEnd(fold.start.row, fold.start.column) > 0) {
                    this.end.row = fold.end.row;
                    this.end.column = fold.end.column;
                } else if (this.range.compareStart(fold.end.row, fold.end.column) < 0) {
                    this.start.row = fold.start.row;
                    this.start.column = fold.start.column;
                }
            } else if (fold.start.row == this.end.row) {
                this.folds.push(fold);
                this.end.row = fold.end.row;
                this.end.column = fold.end.column;
            } else if (fold.end.row == this.start.row) {
                this.folds.unshift(fold);
                this.start.row = fold.start.row;
                this.start.column = fold.start.column;
            } else throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");
            fold.foldLine = this;
        };
        FoldLine.prototype.containsRow = function(row) {
            return row >= this.start.row && row <= this.end.row;
        };
        FoldLine.prototype.walk = function(callback, endRow, endColumn) {
            var lastEnd = 0, folds = this.folds, fold, cmp, stop, isNewRow = true;
            if (endRow == null) {
                endRow = this.end.row;
                endColumn = this.end.column;
            }
            for(var i = 0; i < folds.length; i++){
                fold = folds[i];
                cmp = fold.range.compareStart(endRow, endColumn);
                if (cmp == -1) {
                    callback(null, endRow, endColumn, lastEnd, isNewRow);
                    return;
                }
                stop = callback(null, fold.start.row, fold.start.column, lastEnd, isNewRow);
                stop = !stop && callback(fold.placeholder, fold.start.row, fold.start.column, lastEnd);
                if (stop || cmp === 0) return;
                isNewRow = !fold.sameRow;
                lastEnd = fold.end.column;
            }
            callback(null, endRow, endColumn, lastEnd, isNewRow);
        };
        FoldLine.prototype.getNextFoldTo = function(row, column) {
            var fold, cmp;
            for(var i = 0; i < this.folds.length; i++){
                fold = this.folds[i];
                cmp = fold.range.compareEnd(row, column);
                if (cmp == -1) return {
                    fold: fold,
                    kind: "after"
                };
                else if (cmp === 0) return {
                    fold: fold,
                    kind: "inside"
                };
            }
            return null;
        };
        FoldLine.prototype.addRemoveChars = function(row, column, len) {
            var ret = this.getNextFoldTo(row, column), fold, folds;
            if (ret) {
                fold = ret.fold;
                if (ret.kind == "inside" && fold.start.column != column && fold.start.row != row) window.console && window.console.log(row, column, fold);
                else if (fold.start.row == row) {
                    folds = this.folds;
                    var i = folds.indexOf(fold);
                    if (i === 0) this.start.column += len;
                    for(i; i < folds.length; i++){
                        fold = folds[i];
                        fold.start.column += len;
                        if (!fold.sameRow) return;
                        fold.end.column += len;
                    }
                    this.end.column += len;
                }
            }
        };
        FoldLine.prototype.split = function(row, column) {
            var pos = this.getNextFoldTo(row, column);
            if (!pos || pos.kind == "inside") return null;
            var fold = pos.fold;
            var folds = this.folds;
            var foldData = this.foldData;
            var i = folds.indexOf(fold);
            var foldBefore = folds[i - 1];
            this.end.row = foldBefore.end.row;
            this.end.column = foldBefore.end.column;
            folds = folds.splice(i, folds.length - i);
            var newFoldLine = new FoldLine(foldData, folds);
            foldData.splice(foldData.indexOf(this) + 1, 0, newFoldLine);
            return newFoldLine;
        };
        FoldLine.prototype.merge = function(foldLineNext) {
            var folds = foldLineNext.folds;
            for(var i = 0; i < folds.length; i++)this.addFold(folds[i]);
            var foldData = this.foldData;
            foldData.splice(foldData.indexOf(foldLineNext), 1);
        };
        FoldLine.prototype.toString = function() {
            var ret = [
                this.range.toString() + ": ["
            ];
            this.folds.forEach(function(fold) {
                ret.push("  " + fold.toString());
            });
            ret.push("]");
            return ret.join("\n");
        };
        FoldLine.prototype.idxToPosition = function(idx) {
            var lastFoldEndColumn = 0;
            for(var i = 0; i < this.folds.length; i++){
                var fold = this.folds[i];
                idx -= fold.start.column - lastFoldEndColumn;
                if (idx < 0) return {
                    row: fold.start.row,
                    column: fold.start.column + idx
                };
                idx -= fold.placeholder.length;
                if (idx < 0) return fold.start;
                lastFoldEndColumn = fold.end.column;
            }
            return {
                row: this.end.row,
                column: this.end.column + idx
            };
        };
        return FoldLine;
    }();
    exports.FoldLine = FoldLine;
});
ace.define("ace/range_list", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("./range").Range;
    var comparePoints = Range.comparePoints;
    var RangeList = /** @class */ function() {
        function RangeList() {
            this.ranges = [];
            this.$bias = 1;
        }
        RangeList.prototype.pointIndex = function(pos, excludeEdges, startIndex) {
            var list = this.ranges;
            for(var i = startIndex || 0; i < list.length; i++){
                var range = list[i];
                var cmpEnd = comparePoints(pos, range.end);
                if (cmpEnd > 0) continue;
                var cmpStart = comparePoints(pos, range.start);
                if (cmpEnd === 0) return excludeEdges && cmpStart !== 0 ? -i - 2 : i;
                if (cmpStart > 0 || cmpStart === 0 && !excludeEdges) return i;
                return -i - 1;
            }
            return -i - 1;
        };
        RangeList.prototype.add = function(range) {
            var excludeEdges = !range.isEmpty();
            var startIndex = this.pointIndex(range.start, excludeEdges);
            if (startIndex < 0) startIndex = -startIndex - 1;
            var endIndex = this.pointIndex(range.end, excludeEdges, startIndex);
            if (endIndex < 0) endIndex = -endIndex - 1;
            else endIndex++;
            return this.ranges.splice(startIndex, endIndex - startIndex, range);
        };
        RangeList.prototype.addList = function(list) {
            var removed = [];
            for(var i = list.length; i--;)removed.push.apply(removed, this.add(list[i]));
            return removed;
        };
        RangeList.prototype.substractPoint = function(pos) {
            var i = this.pointIndex(pos);
            if (i >= 0) return this.ranges.splice(i, 1);
        };
        RangeList.prototype.merge = function() {
            var removed = [];
            var list = this.ranges;
            list = list.sort(function(a, b) {
                return comparePoints(a.start, b.start);
            });
            var next = list[0], range;
            for(var i = 1; i < list.length; i++){
                range = next;
                next = list[i];
                var cmp = comparePoints(range.end, next.start);
                if (cmp < 0) continue;
                if (cmp == 0 && !range.isEmpty() && !next.isEmpty()) continue;
                if (comparePoints(range.end, next.end) < 0) {
                    range.end.row = next.end.row;
                    range.end.column = next.end.column;
                }
                list.splice(i, 1);
                removed.push(next);
                next = range;
                i--;
            }
            this.ranges = list;
            return removed;
        };
        RangeList.prototype.contains = function(row, column) {
            return this.pointIndex({
                row: row,
                column: column
            }) >= 0;
        };
        RangeList.prototype.containsPoint = function(pos) {
            return this.pointIndex(pos) >= 0;
        };
        RangeList.prototype.rangeAtPoint = function(pos) {
            var i = this.pointIndex(pos);
            if (i >= 0) return this.ranges[i];
        };
        RangeList.prototype.clipRows = function(startRow, endRow) {
            var list = this.ranges;
            if (list[0].start.row > endRow || list[list.length - 1].start.row < startRow) return [];
            var startIndex = this.pointIndex({
                row: startRow,
                column: 0
            });
            if (startIndex < 0) startIndex = -startIndex - 1;
            var endIndex = this.pointIndex({
                row: endRow,
                column: 0
            }, startIndex);
            if (endIndex < 0) endIndex = -endIndex - 1;
            var clipped = [];
            for(var i = startIndex; i < endIndex; i++)clipped.push(list[i]);
            return clipped;
        };
        RangeList.prototype.removeAll = function() {
            return this.ranges.splice(0, this.ranges.length);
        };
        RangeList.prototype.attach = function(session) {
            if (this.session) this.detach();
            this.session = session;
            this.onChange = this.$onChange.bind(this);
            this.session.on("change", this.onChange);
        };
        RangeList.prototype.detach = function() {
            if (!this.session) return;
            this.session.removeListener("change", this.onChange);
            this.session = null;
        };
        RangeList.prototype.$onChange = function(delta) {
            var start = delta.start;
            var end = delta.end;
            var startRow = start.row;
            var endRow = end.row;
            var ranges = this.ranges;
            for(var i = 0, n = ranges.length; i < n; i++){
                var r = ranges[i];
                if (r.end.row >= startRow) break;
            }
            if (delta.action == "insert") {
                var lineDif = endRow - startRow;
                var colDiff = -start.column + end.column;
                for(; i < n; i++){
                    var r = ranges[i];
                    if (r.start.row > startRow) break;
                    if (r.start.row == startRow && r.start.column >= start.column) {
                        if (r.start.column == start.column && this.$bias <= 0) ;
                        else {
                            r.start.column += colDiff;
                            r.start.row += lineDif;
                        }
                    }
                    if (r.end.row == startRow && r.end.column >= start.column) {
                        if (r.end.column == start.column && this.$bias < 0) continue;
                        if (r.end.column == start.column && colDiff > 0 && i < n - 1) {
                            if (r.end.column > r.start.column && r.end.column == ranges[i + 1].start.column) r.end.column -= colDiff;
                        }
                        r.end.column += colDiff;
                        r.end.row += lineDif;
                    }
                }
            } else {
                var lineDif = startRow - endRow;
                var colDiff = start.column - end.column;
                for(; i < n; i++){
                    var r = ranges[i];
                    if (r.start.row > endRow) break;
                    if (r.end.row < endRow && (startRow < r.end.row || startRow == r.end.row && start.column < r.end.column)) {
                        r.end.row = startRow;
                        r.end.column = start.column;
                    } else if (r.end.row == endRow) {
                        if (r.end.column <= end.column) {
                            if (lineDif || r.end.column > start.column) {
                                r.end.column = start.column;
                                r.end.row = start.row;
                            }
                        } else {
                            r.end.column += colDiff;
                            r.end.row += lineDif;
                        }
                    } else if (r.end.row > endRow) r.end.row += lineDif;
                    if (r.start.row < endRow && (startRow < r.start.row || startRow == r.start.row && start.column < r.start.column)) {
                        r.start.row = startRow;
                        r.start.column = start.column;
                    } else if (r.start.row == endRow) {
                        if (r.start.column <= end.column) {
                            if (lineDif || r.start.column > start.column) {
                                r.start.column = start.column;
                                r.start.row = start.row;
                            }
                        } else {
                            r.start.column += colDiff;
                            r.start.row += lineDif;
                        }
                    } else if (r.start.row > endRow) r.start.row += lineDif;
                }
            }
            if (lineDif != 0 && i < n) for(; i < n; i++){
                var r = ranges[i];
                r.start.row += lineDif;
                r.end.row += lineDif;
            }
        };
        return RangeList;
    }();
    RangeList.prototype.comparePoints = comparePoints;
    exports.RangeList = RangeList;
});
ace.define("ace/edit_session/fold", [
    "require",
    "exports",
    "module",
    "ace/range_list"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var RangeList = require("../range_list").RangeList;
    var Fold = /** @class */ function(_super) {
        __extends(Fold, _super);
        function Fold(range, placeholder) {
            var _this = _super.call(this) || this;
            _this.foldLine = null;
            _this.placeholder = placeholder;
            _this.range = range;
            _this.start = range.start;
            _this.end = range.end;
            _this.sameRow = range.start.row == range.end.row;
            _this.subFolds = _this.ranges = [];
            return _this;
        }
        Fold.prototype.toString = function() {
            return '"' + this.placeholder + '" ' + this.range.toString();
        };
        Fold.prototype.setFoldLine = function(foldLine) {
            this.foldLine = foldLine;
            this.subFolds.forEach(function(fold) {
                fold.setFoldLine(foldLine);
            });
        };
        Fold.prototype.clone = function() {
            var range = this.range.clone();
            var fold = new Fold(range, this.placeholder);
            this.subFolds.forEach(function(subFold) {
                fold.subFolds.push(subFold.clone());
            });
            fold.collapseChildren = this.collapseChildren;
            return fold;
        };
        Fold.prototype.addSubFold = function(fold) {
            if (this.range.isEqual(fold)) return;
            consumeRange(fold, this.start);
            var row = fold.start.row, column = fold.start.column;
            for(var i = 0, cmp = -1; i < this.subFolds.length; i++){
                cmp = this.subFolds[i].range.compare(row, column);
                if (cmp != 1) break;
            }
            var afterStart = this.subFolds[i];
            var firstConsumed = 0;
            if (cmp == 0) {
                if (afterStart.range.containsRange(fold)) return afterStart.addSubFold(fold);
                else firstConsumed = 1;
            }
            var row = fold.range.end.row, column = fold.range.end.column;
            for(var j = i, cmp = -1; j < this.subFolds.length; j++){
                cmp = this.subFolds[j].range.compare(row, column);
                if (cmp != 1) break;
            }
            if (cmp == 0) j++;
            var consumedFolds = this.subFolds.splice(i, j - i, fold);
            var last = cmp == 0 ? consumedFolds.length - 1 : consumedFolds.length;
            for(var k = firstConsumed; k < last; k++)fold.addSubFold(consumedFolds[k]);
            fold.setFoldLine(this.foldLine);
            return fold;
        };
        Fold.prototype.restoreRange = function(range) {
            return restoreRange(range, this.start);
        };
        return Fold;
    }(RangeList);
    function consumePoint(point, anchor) {
        point.row -= anchor.row;
        if (point.row == 0) point.column -= anchor.column;
    }
    function consumeRange(range, anchor) {
        consumePoint(range.start, anchor);
        consumePoint(range.end, anchor);
    }
    function restorePoint(point, anchor) {
        if (point.row == 0) point.column += anchor.column;
        point.row += anchor.row;
    }
    function restoreRange(range, anchor) {
        restorePoint(range.start, anchor);
        restorePoint(range.end, anchor);
    }
    exports.Fold = Fold;
});
ace.define("ace/edit_session/folding", [
    "require",
    "exports",
    "module",
    "ace/range",
    "ace/edit_session/fold_line",
    "ace/edit_session/fold",
    "ace/token_iterator",
    "ace/mouse/mouse_event"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var FoldLine = require("./fold_line").FoldLine;
    var Fold = require("./fold").Fold;
    var TokenIterator = require("../token_iterator").TokenIterator;
    var MouseEvent = require("../mouse/mouse_event").MouseEvent;
    function Folding() {
        this.getFoldAt = function(row, column, side) {
            var foldLine = this.getFoldLine(row);
            if (!foldLine) return null;
            var folds = foldLine.folds;
            for(var i = 0; i < folds.length; i++){
                var range = folds[i].range;
                if (range.contains(row, column)) {
                    if (side == 1 && range.isEnd(row, column) && !range.isEmpty()) continue;
                    else if (side == -1 && range.isStart(row, column) && !range.isEmpty()) continue;
                    return folds[i];
                }
            }
        };
        this.getFoldsInRange = function(range) {
            var start = range.start;
            var end = range.end;
            var foldLines = this.$foldData;
            var foundFolds = [];
            start.column += 1;
            end.column -= 1;
            for(var i = 0; i < foldLines.length; i++){
                var cmp = foldLines[i].range.compareRange(range);
                if (cmp == 2) continue;
                else if (cmp == -2) break;
                var folds = foldLines[i].folds;
                for(var j = 0; j < folds.length; j++){
                    var fold = folds[j];
                    cmp = fold.range.compareRange(range);
                    if (cmp == -2) break;
                    else if (cmp == 2) continue;
                    else if (cmp == 42) break;
                    foundFolds.push(fold);
                }
            }
            start.column -= 1;
            end.column += 1;
            return foundFolds;
        };
        this.getFoldsInRangeList = function(ranges) {
            if (Array.isArray(ranges)) {
                var folds = [];
                ranges.forEach(function(range) {
                    folds = folds.concat(this.getFoldsInRange(range));
                }, this);
            } else var folds = this.getFoldsInRange(ranges);
            return folds;
        };
        this.getAllFolds = function() {
            var folds = [];
            var foldLines = this.$foldData;
            for(var i = 0; i < foldLines.length; i++)for(var j = 0; j < foldLines[i].folds.length; j++)folds.push(foldLines[i].folds[j]);
            return folds;
        };
        this.getFoldStringAt = function(row, column, trim, foldLine) {
            foldLine = foldLine || this.getFoldLine(row);
            if (!foldLine) return null;
            var lastFold = {
                end: {
                    column: 0
                }
            };
            var str, fold;
            for(var i = 0; i < foldLine.folds.length; i++){
                fold = foldLine.folds[i];
                var cmp = fold.range.compareEnd(row, column);
                if (cmp == -1) {
                    str = this.getLine(fold.start.row).substring(lastFold.end.column, fold.start.column);
                    break;
                } else if (cmp === 0) return null;
                lastFold = fold;
            }
            if (!str) str = this.getLine(fold.start.row).substring(lastFold.end.column);
            if (trim == -1) return str.substring(0, column - lastFold.end.column);
            else if (trim == 1) return str.substring(column - lastFold.end.column);
            else return str;
        };
        this.getFoldLine = function(docRow, startFoldLine) {
            var foldData = this.$foldData;
            var i = 0;
            if (startFoldLine) i = foldData.indexOf(startFoldLine);
            if (i == -1) i = 0;
            for(i; i < foldData.length; i++){
                var foldLine = foldData[i];
                if (foldLine.start.row <= docRow && foldLine.end.row >= docRow) return foldLine;
                else if (foldLine.end.row > docRow) return null;
            }
            return null;
        };
        this.getNextFoldLine = function(docRow, startFoldLine) {
            var foldData = this.$foldData;
            var i = 0;
            if (startFoldLine) i = foldData.indexOf(startFoldLine);
            if (i == -1) i = 0;
            for(i; i < foldData.length; i++){
                var foldLine = foldData[i];
                if (foldLine.end.row >= docRow) return foldLine;
            }
            return null;
        };
        this.getFoldedRowCount = function(first, last) {
            var foldData = this.$foldData, rowCount = last - first + 1;
            for(var i = 0; i < foldData.length; i++){
                var foldLine = foldData[i], end = foldLine.end.row, start = foldLine.start.row;
                if (end >= last) {
                    if (start < last) {
                        if (start >= first) rowCount -= last - start;
                        else rowCount = 0; // in one fold
                    }
                    break;
                } else if (end >= first) {
                    if (start >= first) rowCount -= end - start;
                    else rowCount -= end - first + 1;
                }
            }
            return rowCount;
        };
        this.$addFoldLine = function(foldLine) {
            this.$foldData.push(foldLine);
            this.$foldData.sort(function(a, b) {
                return a.start.row - b.start.row;
            });
            return foldLine;
        };
        this.addFold = function(placeholder, range) {
            var foldData = this.$foldData;
            var added = false;
            var fold;
            if (placeholder instanceof Fold) fold = placeholder;
            else {
                fold = new Fold(range, placeholder);
                fold.collapseChildren = range.collapseChildren;
            }
            this.$clipRangeToDocument(fold.range);
            var startRow = fold.start.row;
            var startColumn = fold.start.column;
            var endRow = fold.end.row;
            var endColumn = fold.end.column;
            var startFold = this.getFoldAt(startRow, startColumn, 1);
            var endFold = this.getFoldAt(endRow, endColumn, -1);
            if (startFold && endFold == startFold) return startFold.addSubFold(fold);
            if (startFold && !startFold.range.isStart(startRow, startColumn)) this.removeFold(startFold);
            if (endFold && !endFold.range.isEnd(endRow, endColumn)) this.removeFold(endFold);
            var folds = this.getFoldsInRange(fold.range);
            if (folds.length > 0) {
                this.removeFolds(folds);
                if (!fold.collapseChildren) folds.forEach(function(subFold) {
                    fold.addSubFold(subFold);
                });
            }
            for(var i = 0; i < foldData.length; i++){
                var foldLine = foldData[i];
                if (endRow == foldLine.start.row) {
                    foldLine.addFold(fold);
                    added = true;
                    break;
                } else if (startRow == foldLine.end.row) {
                    foldLine.addFold(fold);
                    added = true;
                    if (!fold.sameRow) {
                        var foldLineNext = foldData[i + 1];
                        if (foldLineNext && foldLineNext.start.row == endRow) {
                            foldLine.merge(foldLineNext);
                            break;
                        }
                    }
                    break;
                } else if (endRow <= foldLine.start.row) break;
            }
            if (!added) foldLine = this.$addFoldLine(new FoldLine(this.$foldData, fold));
            if (this.$useWrapMode) this.$updateWrapData(foldLine.start.row, foldLine.start.row);
            else this.$updateRowLengthCache(foldLine.start.row, foldLine.start.row);
            this.$modified = true;
            this._signal("changeFold", {
                data: fold,
                action: "add"
            });
            return fold;
        };
        this.addFolds = function(folds) {
            folds.forEach(function(fold) {
                this.addFold(fold);
            }, this);
        };
        this.removeFold = function(fold) {
            var foldLine = fold.foldLine;
            var startRow = foldLine.start.row;
            var endRow = foldLine.end.row;
            var foldLines = this.$foldData;
            var folds = foldLine.folds;
            if (folds.length == 1) foldLines.splice(foldLines.indexOf(foldLine), 1);
            else if (foldLine.range.isEnd(fold.end.row, fold.end.column)) {
                folds.pop();
                foldLine.end.row = folds[folds.length - 1].end.row;
                foldLine.end.column = folds[folds.length - 1].end.column;
            } else if (foldLine.range.isStart(fold.start.row, fold.start.column)) {
                folds.shift();
                foldLine.start.row = folds[0].start.row;
                foldLine.start.column = folds[0].start.column;
            } else if (fold.sameRow) folds.splice(folds.indexOf(fold), 1);
            else {
                var newFoldLine = foldLine.split(fold.start.row, fold.start.column);
                folds = newFoldLine.folds;
                folds.shift();
                newFoldLine.start.row = folds[0].start.row;
                newFoldLine.start.column = folds[0].start.column;
            }
            if (!this.$updating) {
                if (this.$useWrapMode) this.$updateWrapData(startRow, endRow);
                else this.$updateRowLengthCache(startRow, endRow);
            }
            this.$modified = true;
            this._signal("changeFold", {
                data: fold,
                action: "remove"
            });
        };
        this.removeFolds = function(folds) {
            var cloneFolds = [];
            for(var i = 0; i < folds.length; i++)cloneFolds.push(folds[i]);
            cloneFolds.forEach(function(fold) {
                this.removeFold(fold);
            }, this);
            this.$modified = true;
        };
        this.expandFold = function(fold) {
            this.removeFold(fold);
            fold.subFolds.forEach(function(subFold) {
                fold.restoreRange(subFold);
                this.addFold(subFold);
            }, this);
            if (fold.collapseChildren > 0) this.foldAll(fold.start.row + 1, fold.end.row, fold.collapseChildren - 1);
            fold.subFolds = [];
        };
        this.expandFolds = function(folds) {
            folds.forEach(function(fold) {
                this.expandFold(fold);
            }, this);
        };
        this.unfold = function(location, expandInner) {
            var range, folds;
            if (location == null) {
                range = new Range(0, 0, this.getLength(), 0);
                if (expandInner == null) expandInner = true;
            } else if (typeof location == "number") range = new Range(location, 0, location, this.getLine(location).length);
            else if ("row" in location) range = Range.fromPoints(location, location);
            else if (Array.isArray(location)) {
                folds = [];
                location.forEach(function(range) {
                    folds = folds.concat(this.unfold(range));
                }, this);
                return folds;
            } else range = location;
            folds = this.getFoldsInRangeList(range);
            var outermostFolds = folds;
            while(folds.length == 1 && Range.comparePoints(folds[0].start, range.start) < 0 && Range.comparePoints(folds[0].end, range.end) > 0){
                this.expandFolds(folds);
                folds = this.getFoldsInRangeList(range);
            }
            if (expandInner != false) this.removeFolds(folds);
            else this.expandFolds(folds);
            if (outermostFolds.length) return outermostFolds;
        };
        this.isRowFolded = function(docRow, startFoldRow) {
            return !!this.getFoldLine(docRow, startFoldRow);
        };
        this.getRowFoldEnd = function(docRow, startFoldRow) {
            var foldLine = this.getFoldLine(docRow, startFoldRow);
            return foldLine ? foldLine.end.row : docRow;
        };
        this.getRowFoldStart = function(docRow, startFoldRow) {
            var foldLine = this.getFoldLine(docRow, startFoldRow);
            return foldLine ? foldLine.start.row : docRow;
        };
        this.getFoldDisplayLine = function(foldLine, endRow, endColumn, startRow, startColumn) {
            if (startRow == null) startRow = foldLine.start.row;
            if (startColumn == null) startColumn = 0;
            if (endRow == null) endRow = foldLine.end.row;
            if (endColumn == null) endColumn = this.getLine(endRow).length;
            var doc = this.doc;
            var textLine = "";
            foldLine.walk(function(placeholder, row, column, lastColumn) {
                if (row < startRow) return;
                if (row == startRow) {
                    if (column < startColumn) return;
                    lastColumn = Math.max(startColumn, lastColumn);
                }
                if (placeholder != null) textLine += placeholder;
                else textLine += doc.getLine(row).substring(lastColumn, column);
            }, endRow, endColumn);
            return textLine;
        };
        this.getDisplayLine = function(row, endColumn, startRow, startColumn) {
            var foldLine = this.getFoldLine(row);
            if (!foldLine) {
                var line;
                line = this.doc.getLine(row);
                return line.substring(startColumn || 0, endColumn || line.length);
            } else return this.getFoldDisplayLine(foldLine, row, endColumn, startRow, startColumn);
        };
        this.$cloneFoldData = function() {
            var fd = [];
            fd = this.$foldData.map(function(foldLine) {
                var folds = foldLine.folds.map(function(fold) {
                    return fold.clone();
                });
                return new FoldLine(fd, folds);
            });
            return fd;
        };
        this.toggleFold = function(tryToUnfold) {
            var selection = this.selection;
            var range = selection.getRange();
            var fold;
            var bracketPos;
            if (range.isEmpty()) {
                var cursor = range.start;
                fold = this.getFoldAt(cursor.row, cursor.column);
                if (fold) {
                    this.expandFold(fold);
                    return;
                } else if (bracketPos = this.findMatchingBracket(cursor)) {
                    if (range.comparePoint(bracketPos) == 1) range.end = bracketPos;
                    else {
                        range.start = bracketPos;
                        range.start.column++;
                        range.end.column--;
                    }
                } else if (bracketPos = this.findMatchingBracket({
                    row: cursor.row,
                    column: cursor.column + 1
                })) {
                    if (range.comparePoint(bracketPos) == 1) range.end = bracketPos;
                    else range.start = bracketPos;
                    range.start.column++;
                } else range = this.getCommentFoldRange(cursor.row, cursor.column) || range;
            } else {
                var folds = this.getFoldsInRange(range);
                if (tryToUnfold && folds.length) {
                    this.expandFolds(folds);
                    return;
                } else if (folds.length == 1) fold = folds[0];
            }
            if (!fold) fold = this.getFoldAt(range.start.row, range.start.column);
            if (fold && fold.range.toString() == range.toString()) {
                this.expandFold(fold);
                return;
            }
            var placeholder = "...";
            if (!range.isMultiLine()) {
                placeholder = this.getTextRange(range);
                if (placeholder.length < 4) return;
                placeholder = placeholder.trim().substring(0, 2) + "..";
            }
            this.addFold(placeholder, range);
        };
        this.getCommentFoldRange = function(row, column, dir) {
            var iterator = new TokenIterator(this, row, column);
            var token = iterator.getCurrentToken();
            var type = token && token.type;
            if (token && /^comment|string/.test(type)) {
                type = type.match(/comment|string/)[0];
                if (type == "comment") type += "|doc-start|\\.doc";
                var re = new RegExp(type);
                var range = new Range();
                if (dir != 1) {
                    do token = iterator.stepBackward();
                    while (token && re.test(token.type) && !/^comment.end/.test(token.type));
                    token = iterator.stepForward();
                }
                range.start.row = iterator.getCurrentTokenRow();
                range.start.column = iterator.getCurrentTokenColumn() + (/^comment.start/.test(token.type) ? token.value.length : 2);
                iterator = new TokenIterator(this, row, column);
                if (dir != -1) {
                    var lastRow = -1;
                    do {
                        token = iterator.stepForward();
                        if (lastRow == -1) {
                            var state = this.getState(iterator.$row);
                            if (!re.test(state)) lastRow = iterator.$row;
                        } else if (iterator.$row > lastRow) break;
                    }while (token && re.test(token.type) && !/^comment.start/.test(token.type));
                    token = iterator.stepBackward();
                } else token = iterator.getCurrentToken();
                range.end.row = iterator.getCurrentTokenRow();
                range.end.column = iterator.getCurrentTokenColumn();
                if (!/^comment.end/.test(token.type)) range.end.column += token.value.length - 2;
                return range;
            }
        };
        this.foldAll = function(startRow, endRow, depth, test) {
            if (depth == undefined) depth = 100000; // JSON.stringify doesn't hanle Infinity
            var foldWidgets = this.foldWidgets;
            if (!foldWidgets) return; // mode doesn't support folding
            endRow = endRow || this.getLength();
            startRow = startRow || 0;
            for(var row = startRow; row < endRow; row++){
                if (foldWidgets[row] == null) foldWidgets[row] = this.getFoldWidget(row);
                if (foldWidgets[row] != "start") continue;
                if (test && !test(row)) continue;
                var range = this.getFoldWidgetRange(row);
                if (range && range.isMultiLine() && range.end.row <= endRow && range.start.row >= startRow) {
                    row = range.end.row;
                    range.collapseChildren = depth;
                    this.addFold("...", range);
                }
            }
        };
        this.foldToLevel = function(level) {
            this.foldAll();
            while(level-- > 0)this.unfold(null, false);
        };
        this.foldAllComments = function() {
            var session = this;
            this.foldAll(null, null, null, function(row) {
                var tokens = session.getTokens(row);
                for(var i = 0; i < tokens.length; i++){
                    var token = tokens[i];
                    if (token.type == "text" && /^\s+$/.test(token.value)) continue;
                    if (/comment/.test(token.type)) return true;
                    return false;
                }
            });
        };
        this.$foldStyles = {
            "manual": 1,
            "markbegin": 1,
            "markbeginend": 1
        };
        this.$foldStyle = "markbegin";
        this.setFoldStyle = function(style) {
            if (!this.$foldStyles[style]) throw new Error("invalid fold style: " + style + "[" + Object.keys(this.$foldStyles).join(", ") + "]");
            if (this.$foldStyle == style) return;
            this.$foldStyle = style;
            if (style == "manual") this.unfold();
            var mode = this.$foldMode;
            this.$setFolding(null);
            this.$setFolding(mode);
        };
        this.$setFolding = function(foldMode) {
            if (this.$foldMode == foldMode) return;
            this.$foldMode = foldMode;
            this.off("change", this.$updateFoldWidgets);
            this.off("tokenizerUpdate", this.$tokenizerUpdateFoldWidgets);
            this._signal("changeAnnotation");
            if (!foldMode || this.$foldStyle == "manual") {
                this.foldWidgets = null;
                return;
            }
            this.foldWidgets = [];
            this.getFoldWidget = foldMode.getFoldWidget.bind(foldMode, this, this.$foldStyle);
            this.getFoldWidgetRange = foldMode.getFoldWidgetRange.bind(foldMode, this, this.$foldStyle);
            this.$updateFoldWidgets = this.updateFoldWidgets.bind(this);
            this.$tokenizerUpdateFoldWidgets = this.tokenizerUpdateFoldWidgets.bind(this);
            this.on("change", this.$updateFoldWidgets);
            this.on("tokenizerUpdate", this.$tokenizerUpdateFoldWidgets);
        };
        this.getParentFoldRangeData = function(row, ignoreCurrent) {
            var fw = this.foldWidgets;
            if (!fw || ignoreCurrent && fw[row]) return {};
            var i = row - 1, firstRange;
            while(i >= 0){
                var c = fw[i];
                if (c == null) c = fw[i] = this.getFoldWidget(i);
                if (c == "start") {
                    var range = this.getFoldWidgetRange(i);
                    if (!firstRange) firstRange = range;
                    if (range && range.end.row >= row) break;
                }
                i--;
            }
            return {
                range: i !== -1 && range,
                firstRange: firstRange
            };
        };
        this.onFoldWidgetClick = function(row, e) {
            if (e instanceof MouseEvent) e = e.domEvent;
            var options = {
                children: e.shiftKey,
                all: e.ctrlKey || e.metaKey,
                siblings: e.altKey
            };
            var range = this.$toggleFoldWidget(row, options);
            if (!range) {
                var el = e.target || e.srcElement;
                if (el && /ace_fold-widget/.test(el.className)) el.className += " ace_invalid";
            }
        };
        this.$toggleFoldWidget = function(row, options) {
            if (!this.getFoldWidget) return;
            var type = this.getFoldWidget(row);
            var line = this.getLine(row);
            var dir = type === "end" ? -1 : 1;
            var fold = this.getFoldAt(row, dir === -1 ? 0 : line.length, dir);
            if (fold) {
                if (options.children || options.all) this.removeFold(fold);
                else this.expandFold(fold);
                return fold;
            }
            var range = this.getFoldWidgetRange(row, true);
            if (range && !range.isMultiLine()) {
                fold = this.getFoldAt(range.start.row, range.start.column, 1);
                if (fold && range.isEqual(fold.range)) {
                    this.removeFold(fold);
                    return fold;
                }
            }
            if (options.siblings) {
                var data = this.getParentFoldRangeData(row);
                if (data.range) {
                    var startRow = data.range.start.row + 1;
                    var endRow = data.range.end.row;
                }
                this.foldAll(startRow, endRow, options.all ? 10000 : 0);
            } else if (options.children) {
                endRow = range ? range.end.row : this.getLength();
                this.foldAll(row + 1, endRow, options.all ? 10000 : 0);
            } else if (range) {
                if (options.all) range.collapseChildren = 10000;
                this.addFold("...", range);
            }
            return range;
        };
        this.toggleFoldWidget = function(toggleParent) {
            var row = this.selection.getCursor().row;
            row = this.getRowFoldStart(row);
            var range = this.$toggleFoldWidget(row, {});
            if (range) return;
            var data = this.getParentFoldRangeData(row, true);
            range = data.range || data.firstRange;
            if (range) {
                row = range.start.row;
                var fold = this.getFoldAt(row, this.getLine(row).length, 1);
                if (fold) this.removeFold(fold);
                else this.addFold("...", range);
            }
        };
        this.updateFoldWidgets = function(delta) {
            var firstRow = delta.start.row;
            var len = delta.end.row - firstRow;
            if (len === 0) this.foldWidgets[firstRow] = null;
            else if (delta.action == "remove") this.foldWidgets.splice(firstRow, len + 1, null);
            else {
                var args = Array(len + 1);
                args.unshift(firstRow, 1);
                this.foldWidgets.splice.apply(this.foldWidgets, args);
            }
        };
        this.tokenizerUpdateFoldWidgets = function(e) {
            var rows = e.data;
            if (rows.first != rows.last) {
                if (this.foldWidgets.length > rows.first) this.foldWidgets.splice(rows.first, this.foldWidgets.length);
            }
        };
    }
    exports.Folding = Folding;
});
ace.define("ace/edit_session/bracket_match", [
    "require",
    "exports",
    "module",
    "ace/token_iterator",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var TokenIterator = require("../token_iterator").TokenIterator;
    var Range = require("../range").Range;
    function BracketMatch() {
        this.findMatchingBracket = function(position, chr) {
            if (position.column == 0) return null;
            var charBeforeCursor = chr || this.getLine(position.row).charAt(position.column - 1);
            if (charBeforeCursor == "") return null;
            var match = charBeforeCursor.match(/([\(\[\{])|([\)\]\}])/);
            if (!match) return null;
            if (match[1]) return this.$findClosingBracket(match[1], position);
            else return this.$findOpeningBracket(match[2], position);
        };
        this.getBracketRange = function(pos) {
            var line = this.getLine(pos.row);
            var before = true, range;
            var chr = line.charAt(pos.column - 1);
            var match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
            if (!match) {
                chr = line.charAt(pos.column);
                pos = {
                    row: pos.row,
                    column: pos.column + 1
                };
                match = chr && chr.match(/([\(\[\{])|([\)\]\}])/);
                before = false;
            }
            if (!match) return null;
            if (match[1]) {
                var bracketPos = this.$findClosingBracket(match[1], pos);
                if (!bracketPos) return null;
                range = Range.fromPoints(pos, bracketPos);
                if (!before) {
                    range.end.column++;
                    range.start.column--;
                }
                range.cursor = range.end;
            } else {
                var bracketPos = this.$findOpeningBracket(match[2], pos);
                if (!bracketPos) return null;
                range = Range.fromPoints(bracketPos, pos);
                if (!before) {
                    range.start.column++;
                    range.end.column--;
                }
                range.cursor = range.start;
            }
            return range;
        };
        this.getMatchingBracketRanges = function(pos, isBackwards) {
            var line = this.getLine(pos.row);
            var bracketsRegExp = /([\(\[\{])|([\)\]\}])/;
            var chr = !isBackwards && line.charAt(pos.column - 1);
            var match = chr && chr.match(bracketsRegExp);
            if (!match) {
                chr = (isBackwards === undefined || isBackwards) && line.charAt(pos.column);
                pos = {
                    row: pos.row,
                    column: pos.column + 1
                };
                match = chr && chr.match(bracketsRegExp);
            }
            if (!match) return null;
            var startRange = new Range(pos.row, pos.column - 1, pos.row, pos.column);
            var bracketPos = match[1] ? this.$findClosingBracket(match[1], pos) : this.$findOpeningBracket(match[2], pos);
            if (!bracketPos) return [
                startRange
            ];
            var endRange = new Range(bracketPos.row, bracketPos.column, bracketPos.row, bracketPos.column + 1);
            return [
                startRange,
                endRange
            ];
        };
        this.$brackets = {
            ")": "(",
            "(": ")",
            "]": "[",
            "[": "]",
            "{": "}",
            "}": "{",
            "<": ">",
            ">": "<"
        };
        this.$findOpeningBracket = function(bracket, position, typeRe) {
            var openBracket = this.$brackets[bracket];
            var depth = 1;
            var iterator = new TokenIterator(this, position.row, position.column);
            var token = iterator.getCurrentToken();
            if (!token) token = iterator.stepForward();
            if (!token) return;
            if (!typeRe) typeRe = new RegExp("(\\.?" + token.type.replace(".", "\\.").replace("rparen", ".paren").replace(/\b(?:end)\b/, "(?:start|begin|end)").replace(/-close\b/, "-(close|open)") + ")+");
            var valueIndex = position.column - iterator.getCurrentTokenColumn() - 2;
            var value = token.value;
            while(true){
                while(valueIndex >= 0){
                    var chr = value.charAt(valueIndex);
                    if (chr == openBracket) {
                        depth -= 1;
                        if (depth == 0) return {
                            row: iterator.getCurrentTokenRow(),
                            column: valueIndex + iterator.getCurrentTokenColumn()
                        };
                    } else if (chr == bracket) depth += 1;
                    valueIndex -= 1;
                }
                do token = iterator.stepBackward();
                while (token && !typeRe.test(token.type));
                if (token == null) break;
                value = token.value;
                valueIndex = value.length - 1;
            }
            return null;
        };
        this.$findClosingBracket = function(bracket, position, typeRe) {
            var closingBracket = this.$brackets[bracket];
            var depth = 1;
            var iterator = new TokenIterator(this, position.row, position.column);
            var token = iterator.getCurrentToken();
            if (!token) token = iterator.stepForward();
            if (!token) return;
            if (!typeRe) typeRe = new RegExp("(\\.?" + token.type.replace(".", "\\.").replace("lparen", ".paren").replace(/\b(?:start|begin)\b/, "(?:start|begin|end)").replace(/-open\b/, "-(close|open)") + ")+");
            var valueIndex = position.column - iterator.getCurrentTokenColumn();
            while(true){
                var value = token.value;
                var valueLength = value.length;
                while(valueIndex < valueLength){
                    var chr = value.charAt(valueIndex);
                    if (chr == closingBracket) {
                        depth -= 1;
                        if (depth == 0) return {
                            row: iterator.getCurrentTokenRow(),
                            column: valueIndex + iterator.getCurrentTokenColumn()
                        };
                    } else if (chr == bracket) depth += 1;
                    valueIndex += 1;
                }
                do token = iterator.stepForward();
                while (token && !typeRe.test(token.type));
                if (token == null) break;
                valueIndex = 0;
            }
            return null;
        };
        this.getMatchingTags = function(pos) {
            var iterator = new TokenIterator(this, pos.row, pos.column);
            var token = this.$findTagName(iterator);
            if (!token) return;
            var prevToken = iterator.stepBackward();
            if (prevToken.value === "<") return this.$findClosingTag(iterator, token);
            else return this.$findOpeningTag(iterator, token);
        };
        this.$findTagName = function(iterator) {
            var token = iterator.getCurrentToken();
            var found = false;
            var backward = false;
            if (token && token.type.indexOf("tag-name") === -1) do {
                if (backward) token = iterator.stepBackward();
                else token = iterator.stepForward();
                if (token) {
                    if (token.value === "/>") backward = true;
                    else if (token.type.indexOf("tag-name") !== -1) found = true;
                }
            }while (token && !found);
            return token;
        };
        this.$findClosingTag = function(iterator, token) {
            var prevToken;
            var currentTag = token.value;
            var tag = token.value;
            var depth = 0;
            var openTagStart = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1);
            token = iterator.stepForward();
            var openTagName = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + token.value.length);
            var foundOpenTagEnd = false;
            do {
                prevToken = token;
                token = iterator.stepForward();
                if (token) {
                    if (token.value === ">" && !foundOpenTagEnd) {
                        var openTagEnd = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1); //Range for `>`
                        foundOpenTagEnd = true;
                    }
                    if (token.type.indexOf("tag-name") !== -1) {
                        currentTag = token.value;
                        if (tag === currentTag) {
                            if (prevToken.value === "<") depth++;
                            else if (prevToken.value === "</") {
                                depth--;
                                if (depth < 0) {
                                    iterator.stepBackward();
                                    var closeTagStart = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 2); //Range for </
                                    token = iterator.stepForward();
                                    var closeTagName = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + token.value.length);
                                    token = iterator.stepForward();
                                    if (token && token.value === ">") var closeTagEnd = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1); //Range for >
                                    else return;
                                }
                            }
                        }
                    } else if (tag === currentTag && token.value === "/>") {
                        depth--;
                        if (depth < 0) {
                            var closeTagStart = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 2);
                            var closeTagName = closeTagStart;
                            var closeTagEnd = closeTagName;
                            var openTagEnd = new Range(openTagName.end.row, openTagName.end.column, openTagName.end.row, openTagName.end.column + 1);
                        }
                    }
                }
            }while (token && depth >= 0);
            if (openTagStart && openTagEnd && closeTagStart && closeTagEnd && openTagName && closeTagName) return {
                openTag: new Range(openTagStart.start.row, openTagStart.start.column, openTagEnd.end.row, openTagEnd.end.column),
                closeTag: new Range(closeTagStart.start.row, closeTagStart.start.column, closeTagEnd.end.row, closeTagEnd.end.column),
                openTagName: openTagName,
                closeTagName: closeTagName
            };
        };
        this.$findOpeningTag = function(iterator, token) {
            var prevToken = iterator.getCurrentToken();
            var tag = token.value;
            var depth = 0;
            var startRow = iterator.getCurrentTokenRow();
            var startColumn = iterator.getCurrentTokenColumn();
            var endColumn = startColumn + 2;
            var closeTagStart = new Range(startRow, startColumn, startRow, endColumn); //Range for </
            iterator.stepForward();
            var closeTagName = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + token.value.length);
            token = iterator.stepForward();
            if (!token || token.value !== ">") return;
            var closeTagEnd = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1); //Range for >
            iterator.stepBackward();
            iterator.stepBackward();
            do {
                token = prevToken;
                startRow = iterator.getCurrentTokenRow();
                startColumn = iterator.getCurrentTokenColumn();
                endColumn = startColumn + token.value.length;
                prevToken = iterator.stepBackward();
                if (token) {
                    if (token.type.indexOf("tag-name") !== -1) {
                        if (tag === token.value) {
                            if (prevToken.value === "<") {
                                depth++;
                                if (depth > 0) {
                                    var openTagName = new Range(startRow, startColumn, startRow, endColumn);
                                    var openTagStart = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1); //Range for <
                                    do token = iterator.stepForward();
                                    while (token && token.value !== ">");
                                    var openTagEnd = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn(), iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + 1); //Range for >
                                }
                            } else if (prevToken.value === "</") depth--;
                        }
                    } else if (token.value === "/>") {
                        var stepCount = 0;
                        var tmpToken = prevToken;
                        while(tmpToken){
                            if (tmpToken.type.indexOf("tag-name") !== -1 && tmpToken.value === tag) {
                                depth--;
                                break;
                            } else if (tmpToken.value === "<") break;
                            tmpToken = iterator.stepBackward();
                            stepCount++;
                        }
                        for(var i = 0; i < stepCount; i++)iterator.stepForward();
                    }
                }
            }while (prevToken && depth <= 0);
            if (openTagStart && openTagEnd && closeTagStart && closeTagEnd && openTagName && closeTagName) return {
                openTag: new Range(openTagStart.start.row, openTagStart.start.column, openTagEnd.end.row, openTagEnd.end.column),
                closeTag: new Range(closeTagStart.start.row, closeTagStart.start.column, closeTagEnd.end.row, closeTagEnd.end.column),
                openTagName: openTagName,
                closeTagName: closeTagName
            };
        };
    }
    exports.BracketMatch = BracketMatch;
});
ace.define("ace/edit_session", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/bidihandler",
    "ace/config",
    "ace/lib/event_emitter",
    "ace/selection",
    "ace/mode/text",
    "ace/range",
    "ace/document",
    "ace/background_tokenizer",
    "ace/search_highlight",
    "ace/edit_session/folding",
    "ace/edit_session/bracket_match"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var lang = require("./lib/lang");
    var BidiHandler = require("./bidihandler").BidiHandler;
    var config = require("./config");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var Selection = require("./selection").Selection;
    var TextMode = require("./mode/text").Mode;
    var Range = require("./range").Range;
    var Document = require("./document").Document;
    var BackgroundTokenizer = require("./background_tokenizer").BackgroundTokenizer;
    var SearchHighlight = require("./search_highlight").SearchHighlight;
    var EditSession = /** @class */ function() {
        function EditSession(text, mode) {
            this.$breakpoints = [];
            this.$decorations = [];
            this.$frontMarkers = {};
            this.$backMarkers = {};
            this.$markerId = 1;
            this.$undoSelect = true;
            this.$foldData = [];
            this.id = "session" + ++EditSession.$uid;
            this.$foldData.toString = function() {
                return this.join("\n");
            };
            this.bgTokenizer = new BackgroundTokenizer(new TextMode().getTokenizer(), this);
            var _self = this;
            this.bgTokenizer.on("update", function(e) {
                _self._signal("tokenizerUpdate", e);
            });
            this.on("changeFold", this.onChangeFold.bind(this));
            this.$onChange = this.onChange.bind(this);
            if (typeof text != "object" || !text.getLine) text = new Document(text);
            this.setDocument(text);
            this.selection = new Selection(this);
            this.$bidiHandler = new BidiHandler(this);
            config.resetOptions(this);
            this.setMode(mode);
            config._signal("session", this);
            this.destroyed = false;
        }
        EditSession.prototype.setDocument = function(doc) {
            if (this.doc) this.doc.off("change", this.$onChange);
            this.doc = doc;
            doc.on("change", this.$onChange, true);
            this.bgTokenizer.setDocument(this.getDocument());
            this.resetCaches();
        };
        EditSession.prototype.getDocument = function() {
            return this.doc;
        };
        EditSession.prototype.$resetRowCache = function(docRow) {
            if (!docRow) {
                this.$docRowCache = [];
                this.$screenRowCache = [];
                return;
            }
            var l = this.$docRowCache.length;
            var i = this.$getRowCacheIndex(this.$docRowCache, docRow) + 1;
            if (l > i) {
                this.$docRowCache.splice(i, l);
                this.$screenRowCache.splice(i, l);
            }
        };
        EditSession.prototype.$getRowCacheIndex = function(cacheArray, val) {
            var low = 0;
            var hi = cacheArray.length - 1;
            while(low <= hi){
                var mid = low + hi >> 1;
                var c = cacheArray[mid];
                if (val > c) low = mid + 1;
                else if (val < c) hi = mid - 1;
                else return mid;
            }
            return low - 1;
        };
        EditSession.prototype.resetCaches = function() {
            this.$modified = true;
            this.$wrapData = [];
            this.$rowLengthCache = [];
            this.$resetRowCache(0);
            if (!this.destroyed) this.bgTokenizer.start(0);
        };
        EditSession.prototype.onChangeFold = function(e) {
            var fold = e.data;
            this.$resetRowCache(fold.start.row);
        };
        EditSession.prototype.onChange = function(delta) {
            this.$modified = true;
            this.$bidiHandler.onChange(delta);
            this.$resetRowCache(delta.start.row);
            var removedFolds = this.$updateInternalDataOnChange(delta);
            if (!this.$fromUndo && this.$undoManager) {
                if (removedFolds && removedFolds.length) {
                    this.$undoManager.add({
                        action: "removeFolds",
                        folds: removedFolds
                    }, this.mergeUndoDeltas);
                    this.mergeUndoDeltas = true;
                }
                this.$undoManager.add(delta, this.mergeUndoDeltas);
                this.mergeUndoDeltas = true;
                this.$informUndoManager.schedule();
            }
            this.bgTokenizer.$updateOnChange(delta);
            this._signal("change", delta);
        };
        EditSession.prototype.setValue = function(text) {
            this.doc.setValue(text);
            this.selection.moveTo(0, 0);
            this.$resetRowCache(0);
            this.setUndoManager(this.$undoManager);
            this.getUndoManager().reset();
        };
        EditSession.prototype.toString = function() {
            return this.doc.getValue();
        };
        EditSession.prototype.getSelection = function() {
            return this.selection;
        };
        EditSession.prototype.getState = function(row) {
            return this.bgTokenizer.getState(row);
        };
        EditSession.prototype.getTokens = function(row) {
            return this.bgTokenizer.getTokens(row);
        };
        EditSession.prototype.getTokenAt = function(row, column) {
            var tokens = this.bgTokenizer.getTokens(row);
            var token, c = 0;
            if (column == null) {
                var i = tokens.length - 1;
                c = this.getLine(row).length;
            } else for(var i = 0; i < tokens.length; i++){
                c += tokens[i].value.length;
                if (c >= column) break;
            }
            token = tokens[i];
            if (!token) return null;
            token.index = i;
            token.start = c - token.value.length;
            return token;
        };
        EditSession.prototype.setUndoManager = function(undoManager) {
            this.$undoManager = undoManager;
            if (this.$informUndoManager) this.$informUndoManager.cancel();
            if (undoManager) {
                var self1 = this;
                undoManager.addSession(this);
                this.$syncInformUndoManager = function() {
                    self1.$informUndoManager.cancel();
                    self1.mergeUndoDeltas = false;
                };
                this.$informUndoManager = lang.delayedCall(this.$syncInformUndoManager);
            } else this.$syncInformUndoManager = function() {};
        };
        EditSession.prototype.markUndoGroup = function() {
            if (this.$syncInformUndoManager) this.$syncInformUndoManager();
        };
        EditSession.prototype.getUndoManager = function() {
            return this.$undoManager || this.$defaultUndoManager;
        };
        EditSession.prototype.getTabString = function() {
            if (this.getUseSoftTabs()) return lang.stringRepeat(" ", this.getTabSize());
            else return "	";
        };
        EditSession.prototype.setUseSoftTabs = function(val) {
            this.setOption("useSoftTabs", val);
        };
        EditSession.prototype.getUseSoftTabs = function() {
            return this.$useSoftTabs && !this.$mode.$indentWithTabs;
        };
        EditSession.prototype.setTabSize = function(tabSize) {
            this.setOption("tabSize", tabSize);
        };
        EditSession.prototype.getTabSize = function() {
            return this.$tabSize;
        };
        EditSession.prototype.isTabStop = function(position) {
            return this.$useSoftTabs && position.column % this.$tabSize === 0;
        };
        EditSession.prototype.setNavigateWithinSoftTabs = function(navigateWithinSoftTabs) {
            this.setOption("navigateWithinSoftTabs", navigateWithinSoftTabs);
        };
        EditSession.prototype.getNavigateWithinSoftTabs = function() {
            return this.$navigateWithinSoftTabs;
        };
        EditSession.prototype.setOverwrite = function(overwrite) {
            this.setOption("overwrite", overwrite);
        };
        EditSession.prototype.getOverwrite = function() {
            return this.$overwrite;
        };
        EditSession.prototype.toggleOverwrite = function() {
            this.setOverwrite(!this.$overwrite);
        };
        EditSession.prototype.addGutterDecoration = function(row, className) {
            if (!this.$decorations[row]) this.$decorations[row] = "";
            this.$decorations[row] += " " + className;
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.removeGutterDecoration = function(row, className) {
            this.$decorations[row] = (this.$decorations[row] || "").replace(" " + className, "");
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.getBreakpoints = function() {
            return this.$breakpoints;
        };
        EditSession.prototype.setBreakpoints = function(rows) {
            this.$breakpoints = [];
            for(var i = 0; i < rows.length; i++)this.$breakpoints[rows[i]] = "ace_breakpoint";
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.clearBreakpoints = function() {
            this.$breakpoints = [];
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.setBreakpoint = function(row, className) {
            if (className === undefined) className = "ace_breakpoint";
            if (className) this.$breakpoints[row] = className;
            else delete this.$breakpoints[row];
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.clearBreakpoint = function(row) {
            delete this.$breakpoints[row];
            this._signal("changeBreakpoint", {});
        };
        EditSession.prototype.addMarker = function(range, clazz, type, inFront) {
            var id = this.$markerId++;
            var marker = {
                range: range,
                type: type || "line",
                renderer: typeof type == "function" ? type : null,
                clazz: clazz,
                inFront: !!inFront,
                id: id
            };
            if (inFront) {
                this.$frontMarkers[id] = marker;
                this._signal("changeFrontMarker");
            } else {
                this.$backMarkers[id] = marker;
                this._signal("changeBackMarker");
            }
            return id;
        };
        EditSession.prototype.addDynamicMarker = function(marker, inFront) {
            if (!marker.update) return;
            var id = this.$markerId++;
            marker.id = id;
            marker.inFront = !!inFront;
            if (inFront) {
                this.$frontMarkers[id] = marker;
                this._signal("changeFrontMarker");
            } else {
                this.$backMarkers[id] = marker;
                this._signal("changeBackMarker");
            }
            return marker;
        };
        EditSession.prototype.removeMarker = function(markerId) {
            var marker = this.$frontMarkers[markerId] || this.$backMarkers[markerId];
            if (!marker) return;
            var markers = marker.inFront ? this.$frontMarkers : this.$backMarkers;
            delete markers[markerId];
            this._signal(marker.inFront ? "changeFrontMarker" : "changeBackMarker");
        };
        EditSession.prototype.getMarkers = function(inFront) {
            return inFront ? this.$frontMarkers : this.$backMarkers;
        };
        EditSession.prototype.highlight = function(re) {
            if (!this.$searchHighlight) {
                var highlight = new SearchHighlight(null, "ace_selected-word", "text");
                this.$searchHighlight = this.addDynamicMarker(highlight);
            }
            this.$searchHighlight.setRegexp(re);
        };
        EditSession.prototype.highlightLines = function(startRow, endRow, clazz, inFront) {
            if (typeof endRow != "number") {
                clazz = endRow;
                endRow = startRow;
            }
            if (!clazz) clazz = "ace_step";
            var range = new Range(startRow, 0, endRow, Infinity);
            range.id = this.addMarker(range, clazz, "fullLine", inFront);
            return range;
        };
        EditSession.prototype.setAnnotations = function(annotations) {
            this.$annotations = annotations;
            this._signal("changeAnnotation", {});
        };
        EditSession.prototype.getAnnotations = function() {
            return this.$annotations || [];
        };
        EditSession.prototype.clearAnnotations = function() {
            this.setAnnotations([]);
        };
        EditSession.prototype.$detectNewLine = function(text) {
            var match = text.match(/^.*?(\r?\n)/m);
            if (match) this.$autoNewLine = match[1];
            else this.$autoNewLine = "\n";
        };
        EditSession.prototype.getWordRange = function(row, column) {
            var line = this.getLine(row);
            var inToken = false;
            if (column > 0) inToken = !!line.charAt(column - 1).match(this.tokenRe);
            if (!inToken) inToken = !!line.charAt(column).match(this.tokenRe);
            if (inToken) var re = this.tokenRe;
            else if (/^\s+$/.test(line.slice(column - 1, column + 1))) var re = /\s/;
            else var re = this.nonTokenRe;
            var start = column;
            if (start > 0) {
                do start--;
                while (start >= 0 && line.charAt(start).match(re));
                start++;
            }
            var end = column;
            while(end < line.length && line.charAt(end).match(re))end++;
            return new Range(row, start, row, end);
        };
        EditSession.prototype.getAWordRange = function(row, column) {
            var wordRange = this.getWordRange(row, column);
            var line = this.getLine(wordRange.end.row);
            while(line.charAt(wordRange.end.column).match(/[ \t]/))wordRange.end.column += 1;
            return wordRange;
        };
        EditSession.prototype.setNewLineMode = function(newLineMode) {
            this.doc.setNewLineMode(newLineMode);
        };
        EditSession.prototype.getNewLineMode = function() {
            return this.doc.getNewLineMode();
        };
        EditSession.prototype.setUseWorker = function(useWorker) {
            this.setOption("useWorker", useWorker);
        };
        EditSession.prototype.getUseWorker = function() {
            return this.$useWorker;
        };
        EditSession.prototype.onReloadTokenizer = function(e) {
            var rows = e.data;
            this.bgTokenizer.start(rows.first);
            this._signal("tokenizerUpdate", e);
        };
        EditSession.prototype.setMode = function(mode, cb) {
            if (mode && typeof mode === "object") {
                if (mode.getTokenizer) return this.$onChangeMode(mode);
                var options = mode;
                var path = options.path;
            } else path = mode || "ace/mode/text";
            if (!this.$modes["ace/mode/text"]) this.$modes["ace/mode/text"] = new TextMode();
            if (this.$modes[path] && !options) {
                this.$onChangeMode(this.$modes[path]);
                cb && cb();
                return;
            }
            this.$modeId = path;
            config.loadModule([
                "mode",
                path
            ], (function(m) {
                if (this.$modeId !== path) return cb && cb();
                if (this.$modes[path] && !options) this.$onChangeMode(this.$modes[path]);
                else if (m && m.Mode) {
                    m = new m.Mode(options);
                    if (!options) {
                        this.$modes[path] = m;
                        m.$id = path;
                    }
                    this.$onChangeMode(m);
                }
                cb && cb();
            }).bind(this));
            if (!this.$mode) this.$onChangeMode(this.$modes["ace/mode/text"], true);
        };
        EditSession.prototype.$onChangeMode = function(mode, $isPlaceholder) {
            if (!$isPlaceholder) this.$modeId = mode.$id;
            if (this.$mode === mode) return;
            var oldMode = this.$mode;
            this.$mode = mode;
            this.$stopWorker();
            if (this.$useWorker) this.$startWorker();
            var tokenizer = mode.getTokenizer();
            if (tokenizer.on !== undefined) {
                var onReloadTokenizer = this.onReloadTokenizer.bind(this);
                tokenizer.on("update", onReloadTokenizer);
            }
            this.bgTokenizer.setTokenizer(tokenizer);
            this.bgTokenizer.setDocument(this.getDocument());
            this.tokenRe = mode.tokenRe;
            this.nonTokenRe = mode.nonTokenRe;
            if (!$isPlaceholder) {
                if (mode.attachToSession) mode.attachToSession(this);
                this.$options.wrapMethod.set.call(this, this.$wrapMethod);
                this.$setFolding(mode.foldingRules);
                this.bgTokenizer.start(0);
                this._emit("changeMode", {
                    oldMode: oldMode,
                    mode: mode
                });
            }
        };
        EditSession.prototype.$stopWorker = function() {
            if (this.$worker) {
                this.$worker.terminate();
                this.$worker = null;
            }
        };
        EditSession.prototype.$startWorker = function() {
            try {
                this.$worker = this.$mode.createWorker(this);
            } catch (e) {
                config.warn("Could not load worker", e);
                this.$worker = null;
            }
        };
        EditSession.prototype.getMode = function() {
            return this.$mode;
        };
        EditSession.prototype.setScrollTop = function(scrollTop) {
            if (this.$scrollTop === scrollTop || isNaN(scrollTop)) return;
            this.$scrollTop = scrollTop;
            this._signal("changeScrollTop", scrollTop);
        };
        EditSession.prototype.getScrollTop = function() {
            return this.$scrollTop;
        };
        EditSession.prototype.setScrollLeft = function(scrollLeft) {
            if (this.$scrollLeft === scrollLeft || isNaN(scrollLeft)) return;
            this.$scrollLeft = scrollLeft;
            this._signal("changeScrollLeft", scrollLeft);
        };
        EditSession.prototype.getScrollLeft = function() {
            return this.$scrollLeft;
        };
        EditSession.prototype.getScreenWidth = function() {
            this.$computeWidth();
            if (this.lineWidgets) return Math.max(this.getLineWidgetMaxWidth(), this.screenWidth);
            return this.screenWidth;
        };
        EditSession.prototype.getLineWidgetMaxWidth = function() {
            if (this.lineWidgetsWidth != null) return this.lineWidgetsWidth;
            var width = 0;
            this.lineWidgets.forEach(function(w) {
                if (w && w.screenWidth > width) width = w.screenWidth;
            });
            return this.lineWidgetWidth = width;
        };
        EditSession.prototype.$computeWidth = function(force) {
            if (this.$modified || force) {
                this.$modified = false;
                if (this.$useWrapMode) return this.screenWidth = this.$wrapLimit;
                var lines = this.doc.getAllLines();
                var cache = this.$rowLengthCache;
                var longestScreenLine = 0;
                var foldIndex = 0;
                var foldLine = this.$foldData[foldIndex];
                var foldStart = foldLine ? foldLine.start.row : Infinity;
                var len = lines.length;
                for(var i = 0; i < len; i++){
                    if (i > foldStart) {
                        i = foldLine.end.row + 1;
                        if (i >= len) break;
                        foldLine = this.$foldData[foldIndex++];
                        foldStart = foldLine ? foldLine.start.row : Infinity;
                    }
                    if (cache[i] == null) cache[i] = this.$getStringScreenWidth(lines[i])[0];
                    if (cache[i] > longestScreenLine) longestScreenLine = cache[i];
                }
                this.screenWidth = longestScreenLine;
            }
        };
        EditSession.prototype.getLine = function(row) {
            return this.doc.getLine(row);
        };
        EditSession.prototype.getLines = function(firstRow, lastRow) {
            return this.doc.getLines(firstRow, lastRow);
        };
        EditSession.prototype.getLength = function() {
            return this.doc.getLength();
        };
        EditSession.prototype.getTextRange = function(range) {
            return this.doc.getTextRange(range || this.selection.getRange());
        };
        EditSession.prototype.insert = function(position, text) {
            return this.doc.insert(position, text);
        };
        EditSession.prototype.remove = function(range) {
            return this.doc.remove(range);
        };
        EditSession.prototype.removeFullLines = function(firstRow, lastRow) {
            return this.doc.removeFullLines(firstRow, lastRow);
        };
        EditSession.prototype.undoChanges = function(deltas, dontSelect) {
            if (!deltas.length) return;
            this.$fromUndo = true;
            for(var i = deltas.length - 1; i != -1; i--){
                var delta = deltas[i];
                if (delta.action == "insert" || delta.action == "remove") this.doc.revertDelta(delta);
                else if (delta.folds) this.addFolds(delta.folds);
            }
            if (!dontSelect && this.$undoSelect) {
                if (deltas.selectionBefore) this.selection.fromJSON(deltas.selectionBefore);
                else this.selection.setRange(this.$getUndoSelection(deltas, true));
            }
            this.$fromUndo = false;
        };
        EditSession.prototype.redoChanges = function(deltas, dontSelect) {
            if (!deltas.length) return;
            this.$fromUndo = true;
            for(var i = 0; i < deltas.length; i++){
                var delta = deltas[i];
                if (delta.action == "insert" || delta.action == "remove") this.doc.$safeApplyDelta(delta);
            }
            if (!dontSelect && this.$undoSelect) {
                if (deltas.selectionAfter) this.selection.fromJSON(deltas.selectionAfter);
                else this.selection.setRange(this.$getUndoSelection(deltas, false));
            }
            this.$fromUndo = false;
        };
        EditSession.prototype.setUndoSelect = function(enable) {
            this.$undoSelect = enable;
        };
        EditSession.prototype.$getUndoSelection = function(deltas, isUndo) {
            function isInsert(delta) {
                return isUndo ? delta.action !== "insert" : delta.action === "insert";
            }
            var range, point;
            for(var i = 0; i < deltas.length; i++){
                var delta = deltas[i];
                if (!delta.start) continue; // skip folds
                if (!range) {
                    if (isInsert(delta)) range = Range.fromPoints(delta.start, delta.end);
                    else range = Range.fromPoints(delta.start, delta.start);
                    continue;
                }
                if (isInsert(delta)) {
                    point = delta.start;
                    if (range.compare(point.row, point.column) == -1) range.setStart(point);
                    point = delta.end;
                    if (range.compare(point.row, point.column) == 1) range.setEnd(point);
                } else {
                    point = delta.start;
                    if (range.compare(point.row, point.column) == -1) range = Range.fromPoints(delta.start, delta.start);
                }
            }
            return range;
        };
        EditSession.prototype.replace = function(range, text) {
            return this.doc.replace(range, text);
        };
        EditSession.prototype.moveText = function(fromRange, toPosition, copy) {
            var text = this.getTextRange(fromRange);
            var folds = this.getFoldsInRange(fromRange);
            var toRange = Range.fromPoints(toPosition, toPosition);
            if (!copy) {
                this.remove(fromRange);
                var rowDiff = fromRange.start.row - fromRange.end.row;
                var collDiff = rowDiff ? -fromRange.end.column : fromRange.start.column - fromRange.end.column;
                if (collDiff) {
                    if (toRange.start.row == fromRange.end.row && toRange.start.column > fromRange.end.column) toRange.start.column += collDiff;
                    if (toRange.end.row == fromRange.end.row && toRange.end.column > fromRange.end.column) toRange.end.column += collDiff;
                }
                if (rowDiff && toRange.start.row >= fromRange.end.row) {
                    toRange.start.row += rowDiff;
                    toRange.end.row += rowDiff;
                }
            }
            toRange.end = this.insert(toRange.start, text);
            if (folds.length) {
                var oldStart = fromRange.start;
                var newStart = toRange.start;
                var rowDiff = newStart.row - oldStart.row;
                var collDiff = newStart.column - oldStart.column;
                this.addFolds(folds.map(function(x) {
                    x = x.clone();
                    if (x.start.row == oldStart.row) x.start.column += collDiff;
                    if (x.end.row == oldStart.row) x.end.column += collDiff;
                    x.start.row += rowDiff;
                    x.end.row += rowDiff;
                    return x;
                }));
            }
            return toRange;
        };
        EditSession.prototype.indentRows = function(startRow, endRow, indentString) {
            indentString = indentString.replace(/\t/g, this.getTabString());
            for(var row = startRow; row <= endRow; row++)this.doc.insertInLine({
                row: row,
                column: 0
            }, indentString);
        };
        EditSession.prototype.outdentRows = function(range) {
            var rowRange = range.collapseRows();
            var deleteRange = new Range(0, 0, 0, 0);
            var size = this.getTabSize();
            for(var i = rowRange.start.row; i <= rowRange.end.row; ++i){
                var line = this.getLine(i);
                deleteRange.start.row = i;
                deleteRange.end.row = i;
                for(var j = 0; j < size; ++j)if (line.charAt(j) != " ") break;
                if (j < size && line.charAt(j) == "	") {
                    deleteRange.start.column = j;
                    deleteRange.end.column = j + 1;
                } else {
                    deleteRange.start.column = 0;
                    deleteRange.end.column = j;
                }
                this.remove(deleteRange);
            }
        };
        EditSession.prototype.$moveLines = function(firstRow, lastRow, dir) {
            firstRow = this.getRowFoldStart(firstRow);
            lastRow = this.getRowFoldEnd(lastRow);
            if (dir < 0) {
                var row = this.getRowFoldStart(firstRow + dir);
                if (row < 0) return 0;
                var diff = row - firstRow;
            } else if (dir > 0) {
                var row = this.getRowFoldEnd(lastRow + dir);
                if (row > this.doc.getLength() - 1) return 0;
                var diff = row - lastRow;
            } else {
                firstRow = this.$clipRowToDocument(firstRow);
                lastRow = this.$clipRowToDocument(lastRow);
                var diff = lastRow - firstRow + 1;
            }
            var range = new Range(firstRow, 0, lastRow, Number.MAX_VALUE);
            var folds = this.getFoldsInRange(range).map(function(x) {
                x = x.clone();
                x.start.row += diff;
                x.end.row += diff;
                return x;
            });
            var lines = dir == 0 ? this.doc.getLines(firstRow, lastRow) : this.doc.removeFullLines(firstRow, lastRow);
            this.doc.insertFullLines(firstRow + diff, lines);
            folds.length && this.addFolds(folds);
            return diff;
        };
        EditSession.prototype.moveLinesUp = function(firstRow, lastRow) {
            return this.$moveLines(firstRow, lastRow, -1);
        };
        EditSession.prototype.moveLinesDown = function(firstRow, lastRow) {
            return this.$moveLines(firstRow, lastRow, 1);
        };
        EditSession.prototype.duplicateLines = function(firstRow, lastRow) {
            return this.$moveLines(firstRow, lastRow, 0);
        };
        EditSession.prototype.$clipRowToDocument = function(row) {
            return Math.max(0, Math.min(row, this.doc.getLength() - 1));
        };
        EditSession.prototype.$clipColumnToRow = function(row, column) {
            if (column < 0) return 0;
            return Math.min(this.doc.getLine(row).length, column);
        };
        EditSession.prototype.$clipPositionToDocument = function(row, column) {
            column = Math.max(0, column);
            if (row < 0) {
                row = 0;
                column = 0;
            } else {
                var len = this.doc.getLength();
                if (row >= len) {
                    row = len - 1;
                    column = this.doc.getLine(len - 1).length;
                } else column = Math.min(this.doc.getLine(row).length, column);
            }
            return {
                row: row,
                column: column
            };
        };
        EditSession.prototype.$clipRangeToDocument = function(range) {
            if (range.start.row < 0) {
                range.start.row = 0;
                range.start.column = 0;
            } else range.start.column = this.$clipColumnToRow(range.start.row, range.start.column);
            var len = this.doc.getLength() - 1;
            if (range.end.row > len) {
                range.end.row = len;
                range.end.column = this.doc.getLine(len).length;
            } else range.end.column = this.$clipColumnToRow(range.end.row, range.end.column);
            return range;
        };
        EditSession.prototype.setUseWrapMode = function(useWrapMode) {
            if (useWrapMode != this.$useWrapMode) {
                this.$useWrapMode = useWrapMode;
                this.$modified = true;
                this.$resetRowCache(0);
                if (useWrapMode) {
                    var len = this.getLength();
                    this.$wrapData = Array(len);
                    this.$updateWrapData(0, len - 1);
                }
                this._signal("changeWrapMode");
            }
        };
        EditSession.prototype.getUseWrapMode = function() {
            return this.$useWrapMode;
        };
        EditSession.prototype.setWrapLimitRange = function(min, max) {
            if (this.$wrapLimitRange.min !== min || this.$wrapLimitRange.max !== max) {
                this.$wrapLimitRange = {
                    min: min,
                    max: max
                };
                this.$modified = true;
                this.$bidiHandler.markAsDirty();
                if (this.$useWrapMode) this._signal("changeWrapMode");
            }
        };
        EditSession.prototype.adjustWrapLimit = function(desiredLimit, $printMargin) {
            var limits = this.$wrapLimitRange;
            if (limits.max < 0) limits = {
                min: $printMargin,
                max: $printMargin
            };
            var wrapLimit = this.$constrainWrapLimit(desiredLimit, limits.min, limits.max);
            if (wrapLimit != this.$wrapLimit && wrapLimit > 1) {
                this.$wrapLimit = wrapLimit;
                this.$modified = true;
                if (this.$useWrapMode) {
                    this.$updateWrapData(0, this.getLength() - 1);
                    this.$resetRowCache(0);
                    this._signal("changeWrapLimit");
                }
                return true;
            }
            return false;
        };
        EditSession.prototype.$constrainWrapLimit = function(wrapLimit, min, max) {
            if (min) wrapLimit = Math.max(min, wrapLimit);
            if (max) wrapLimit = Math.min(max, wrapLimit);
            return wrapLimit;
        };
        EditSession.prototype.getWrapLimit = function() {
            return this.$wrapLimit;
        };
        EditSession.prototype.setWrapLimit = function(limit) {
            this.setWrapLimitRange(limit, limit);
        };
        EditSession.prototype.getWrapLimitRange = function() {
            return {
                min: this.$wrapLimitRange.min,
                max: this.$wrapLimitRange.max
            };
        };
        EditSession.prototype.$updateInternalDataOnChange = function(delta) {
            var useWrapMode = this.$useWrapMode;
            var action = delta.action;
            var start = delta.start;
            var end = delta.end;
            var firstRow = start.row;
            var lastRow = end.row;
            var len = lastRow - firstRow;
            var removedFolds = null;
            this.$updating = true;
            if (len != 0) {
                if (action === "remove") {
                    this[useWrapMode ? "$wrapData" : "$rowLengthCache"].splice(firstRow, len);
                    var foldLines = this.$foldData;
                    removedFolds = this.getFoldsInRange(delta);
                    this.removeFolds(removedFolds);
                    var foldLine = this.getFoldLine(end.row);
                    var idx = 0;
                    if (foldLine) {
                        foldLine.addRemoveChars(end.row, end.column, start.column - end.column);
                        foldLine.shiftRow(-len);
                        var foldLineBefore = this.getFoldLine(firstRow);
                        if (foldLineBefore && foldLineBefore !== foldLine) {
                            foldLineBefore.merge(foldLine);
                            foldLine = foldLineBefore;
                        }
                        idx = foldLines.indexOf(foldLine) + 1;
                    }
                    for(idx; idx < foldLines.length; idx++){
                        var foldLine = foldLines[idx];
                        if (foldLine.start.row >= end.row) foldLine.shiftRow(-len);
                    }
                    lastRow = firstRow;
                } else {
                    var args = Array(len);
                    args.unshift(firstRow, 0);
                    var arr = useWrapMode ? this.$wrapData : this.$rowLengthCache;
                    arr.splice.apply(arr, args);
                    var foldLines = this.$foldData;
                    var foldLine = this.getFoldLine(firstRow);
                    var idx = 0;
                    if (foldLine) {
                        var cmp = foldLine.range.compareInside(start.row, start.column);
                        if (cmp == 0) {
                            foldLine = foldLine.split(start.row, start.column);
                            if (foldLine) {
                                foldLine.shiftRow(len);
                                foldLine.addRemoveChars(lastRow, 0, end.column - start.column);
                            }
                        } else if (cmp == -1) {
                            foldLine.addRemoveChars(firstRow, 0, end.column - start.column);
                            foldLine.shiftRow(len);
                        }
                        idx = foldLines.indexOf(foldLine) + 1;
                    }
                    for(idx; idx < foldLines.length; idx++){
                        var foldLine = foldLines[idx];
                        if (foldLine.start.row >= firstRow) foldLine.shiftRow(len);
                    }
                }
            } else {
                len = Math.abs(delta.start.column - delta.end.column);
                if (action === "remove") {
                    removedFolds = this.getFoldsInRange(delta);
                    this.removeFolds(removedFolds);
                    len = -len;
                }
                var foldLine = this.getFoldLine(firstRow);
                if (foldLine) foldLine.addRemoveChars(firstRow, start.column, len);
            }
            if (useWrapMode && this.$wrapData.length != this.doc.getLength()) console.error("doc.getLength() and $wrapData.length have to be the same!");
            this.$updating = false;
            if (useWrapMode) this.$updateWrapData(firstRow, lastRow);
            else this.$updateRowLengthCache(firstRow, lastRow);
            return removedFolds;
        };
        EditSession.prototype.$updateRowLengthCache = function(firstRow, lastRow, b) {
            this.$rowLengthCache[firstRow] = null;
            this.$rowLengthCache[lastRow] = null;
        };
        EditSession.prototype.$updateWrapData = function(firstRow, lastRow) {
            var lines = this.doc.getAllLines();
            var tabSize = this.getTabSize();
            var wrapData = this.$wrapData;
            var wrapLimit = this.$wrapLimit;
            var tokens;
            var foldLine;
            var row = firstRow;
            lastRow = Math.min(lastRow, lines.length - 1);
            while(row <= lastRow){
                foldLine = this.getFoldLine(row, foldLine);
                if (!foldLine) {
                    tokens = this.$getDisplayTokens(lines[row]);
                    wrapData[row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
                    row++;
                } else {
                    tokens = [];
                    foldLine.walk((function(placeholder, row, column, lastColumn) {
                        var walkTokens;
                        if (placeholder != null) {
                            walkTokens = this.$getDisplayTokens(placeholder, tokens.length);
                            walkTokens[0] = PLACEHOLDER_START;
                            for(var i = 1; i < walkTokens.length; i++)walkTokens[i] = PLACEHOLDER_BODY;
                        } else walkTokens = this.$getDisplayTokens(lines[row].substring(lastColumn, column), tokens.length);
                        tokens = tokens.concat(walkTokens);
                    }).bind(this), foldLine.end.row, lines[foldLine.end.row].length + 1);
                    wrapData[foldLine.start.row] = this.$computeWrapSplits(tokens, wrapLimit, tabSize);
                    row = foldLine.end.row + 1;
                }
            }
        };
        EditSession.prototype.$computeWrapSplits = function(tokens, wrapLimit, tabSize) {
            if (tokens.length == 0) return [];
            var splits = [];
            var displayLength = tokens.length;
            var lastSplit = 0, lastDocSplit = 0;
            var isCode = this.$wrapAsCode;
            var indentedSoftWrap = this.$indentedSoftWrap;
            var maxIndent = wrapLimit <= Math.max(2 * tabSize, 8) || indentedSoftWrap === false ? 0 : Math.floor(wrapLimit / 2);
            function getWrapIndent() {
                var indentation = 0;
                if (maxIndent === 0) return indentation;
                if (indentedSoftWrap) for(var i = 0; i < tokens.length; i++){
                    var token = tokens[i];
                    if (token == SPACE) indentation += 1;
                    else if (token == TAB) indentation += tabSize;
                    else if (token == TAB_SPACE) continue;
                    else break;
                }
                if (isCode && indentedSoftWrap !== false) indentation += tabSize;
                return Math.min(indentation, maxIndent);
            }
            function addSplit(screenPos) {
                var len = screenPos - lastSplit;
                for(var i = lastSplit; i < screenPos; i++){
                    var ch = tokens[i];
                    if (ch === 12 || ch === 2) len -= 1;
                }
                if (!splits.length) {
                    indent = getWrapIndent();
                    splits.indent = indent;
                }
                lastDocSplit += len;
                splits.push(lastDocSplit);
                lastSplit = screenPos;
            }
            var indent = 0;
            while(displayLength - lastSplit > wrapLimit - indent){
                var split = lastSplit + wrapLimit - indent;
                if (tokens[split - 1] >= SPACE && tokens[split] >= SPACE) {
                    addSplit(split);
                    continue;
                }
                if (tokens[split] == PLACEHOLDER_START || tokens[split] == PLACEHOLDER_BODY) {
                    for(split; split != lastSplit - 1; split--){
                        if (tokens[split] == PLACEHOLDER_START) break;
                    }
                    if (split > lastSplit) {
                        addSplit(split);
                        continue;
                    }
                    split = lastSplit + wrapLimit;
                    for(split; split < tokens.length; split++){
                        if (tokens[split] != PLACEHOLDER_BODY) break;
                    }
                    if (split == tokens.length) break; // Breaks the while-loop.
                    addSplit(split);
                    continue;
                }
                var minSplit = Math.max(split - (wrapLimit - (wrapLimit >> 2)), lastSplit - 1);
                while(split > minSplit && tokens[split] < PLACEHOLDER_START)split--;
                if (isCode) {
                    while(split > minSplit && tokens[split] < PLACEHOLDER_START)split--;
                    while(split > minSplit && tokens[split] == PUNCTUATION)split--;
                } else while(split > minSplit && tokens[split] < SPACE)split--;
                if (split > minSplit) {
                    addSplit(++split);
                    continue;
                }
                split = lastSplit + wrapLimit;
                if (tokens[split] == CHAR_EXT) split--;
                addSplit(split - indent);
            }
            return splits;
        };
        EditSession.prototype.$getDisplayTokens = function(str, offset) {
            var arr = [];
            var tabSize;
            offset = offset || 0;
            for(var i = 0; i < str.length; i++){
                var c = str.charCodeAt(i);
                if (c == 9) {
                    tabSize = this.getScreenTabSize(arr.length + offset);
                    arr.push(TAB);
                    for(var n = 1; n < tabSize; n++)arr.push(TAB_SPACE);
                } else if (c == 32) arr.push(SPACE);
                else if (c > 39 && c < 48 || c > 57 && c < 64) arr.push(PUNCTUATION);
                else if (c >= 0x1100 && isFullWidth(c)) arr.push(CHAR, CHAR_EXT);
                else arr.push(CHAR);
            }
            return arr;
        };
        EditSession.prototype.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
            if (maxScreenColumn == 0) return [
                0,
                0
            ];
            if (maxScreenColumn == null) maxScreenColumn = Infinity;
            screenColumn = screenColumn || 0;
            var c, column;
            for(column = 0; column < str.length; column++){
                c = str.charCodeAt(column);
                if (c == 9) screenColumn += this.getScreenTabSize(screenColumn);
                else if (c >= 0x1100 && isFullWidth(c)) screenColumn += 2;
                else screenColumn += 1;
                if (screenColumn > maxScreenColumn) break;
            }
            return [
                screenColumn,
                column
            ];
        };
        EditSession.prototype.getRowLength = function(row) {
            var h = 1;
            if (this.lineWidgets) h += this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
            if (!this.$useWrapMode || !this.$wrapData[row]) return h;
            else return this.$wrapData[row].length + h;
        };
        EditSession.prototype.getRowLineCount = function(row) {
            if (!this.$useWrapMode || !this.$wrapData[row]) return 1;
            else return this.$wrapData[row].length + 1;
        };
        EditSession.prototype.getRowWrapIndent = function(screenRow) {
            if (this.$useWrapMode) {
                var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
                var splits = this.$wrapData[pos.row];
                return splits.length && splits[0] < pos.column ? splits.indent : 0;
            } else return 0;
        };
        EditSession.prototype.getScreenLastRowColumn = function(screenRow) {
            var pos = this.screenToDocumentPosition(screenRow, Number.MAX_VALUE);
            return this.documentToScreenColumn(pos.row, pos.column);
        };
        EditSession.prototype.getDocumentLastRowColumn = function(docRow, docColumn) {
            var screenRow = this.documentToScreenRow(docRow, docColumn);
            return this.getScreenLastRowColumn(screenRow);
        };
        EditSession.prototype.getDocumentLastRowColumnPosition = function(docRow, docColumn) {
            var screenRow = this.documentToScreenRow(docRow, docColumn);
            return this.screenToDocumentPosition(screenRow, Number.MAX_VALUE / 10);
        };
        EditSession.prototype.getRowSplitData = function(row) {
            if (!this.$useWrapMode) return undefined;
            else return this.$wrapData[row];
        };
        EditSession.prototype.getScreenTabSize = function(screenColumn) {
            return this.$tabSize - (screenColumn % this.$tabSize | 0);
        };
        EditSession.prototype.screenToDocumentRow = function(screenRow, screenColumn) {
            return this.screenToDocumentPosition(screenRow, screenColumn).row;
        };
        EditSession.prototype.screenToDocumentColumn = function(screenRow, screenColumn) {
            return this.screenToDocumentPosition(screenRow, screenColumn).column;
        };
        EditSession.prototype.screenToDocumentPosition = function(screenRow, screenColumn, offsetX) {
            if (screenRow < 0) return {
                row: 0,
                column: 0
            };
            var line;
            var docRow = 0;
            var docColumn = 0;
            var column;
            var row = 0;
            var rowLength = 0;
            var rowCache = this.$screenRowCache;
            var i = this.$getRowCacheIndex(rowCache, screenRow);
            var l = rowCache.length;
            if (l && i >= 0) {
                var row = rowCache[i];
                var docRow = this.$docRowCache[i];
                var doCache = screenRow > rowCache[l - 1];
            } else var doCache = !l;
            var maxRow = this.getLength() - 1;
            var foldLine = this.getNextFoldLine(docRow);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(row <= screenRow){
                rowLength = this.getRowLength(docRow);
                if (row + rowLength > screenRow || docRow >= maxRow) break;
                else {
                    row += rowLength;
                    docRow++;
                    if (docRow > foldStart) {
                        docRow = foldLine.end.row + 1;
                        foldLine = this.getNextFoldLine(docRow, foldLine);
                        foldStart = foldLine ? foldLine.start.row : Infinity;
                    }
                }
                if (doCache) {
                    this.$docRowCache.push(docRow);
                    this.$screenRowCache.push(row);
                }
            }
            if (foldLine && foldLine.start.row <= docRow) {
                line = this.getFoldDisplayLine(foldLine);
                docRow = foldLine.start.row;
            } else if (row + rowLength <= screenRow || docRow > maxRow) return {
                row: maxRow,
                column: this.getLine(maxRow).length
            };
            else {
                line = this.getLine(docRow);
                foldLine = null;
            }
            var wrapIndent = 0, splitIndex = Math.floor(screenRow - row);
            if (this.$useWrapMode) {
                var splits = this.$wrapData[docRow];
                if (splits) {
                    column = splits[splitIndex];
                    if (splitIndex > 0 && splits.length) {
                        wrapIndent = splits.indent;
                        docColumn = splits[splitIndex - 1] || splits[splits.length - 1];
                        line = line.substring(docColumn);
                    }
                }
            }
            if (offsetX !== undefined && this.$bidiHandler.isBidiRow(row + splitIndex, docRow, splitIndex)) screenColumn = this.$bidiHandler.offsetToCol(offsetX);
            docColumn += this.$getStringScreenWidth(line, screenColumn - wrapIndent)[1];
            if (this.$useWrapMode && docColumn >= column) docColumn = column - 1;
            if (foldLine) return foldLine.idxToPosition(docColumn);
            return {
                row: docRow,
                column: docColumn
            };
        };
        EditSession.prototype.documentToScreenPosition = function(docRow, docColumn) {
            if (typeof docColumn === "undefined") var pos = this.$clipPositionToDocument(docRow.row, docRow.column);
            else pos = this.$clipPositionToDocument(docRow, docColumn);
            docRow = pos.row;
            docColumn = pos.column;
            var screenRow = 0;
            var foldStartRow = null;
            var fold = null;
            fold = this.getFoldAt(docRow, docColumn, 1);
            if (fold) {
                docRow = fold.start.row;
                docColumn = fold.start.column;
            }
            var rowEnd, row = 0;
            var rowCache = this.$docRowCache;
            var i = this.$getRowCacheIndex(rowCache, docRow);
            var l = rowCache.length;
            if (l && i >= 0) {
                var row = rowCache[i];
                var screenRow = this.$screenRowCache[i];
                var doCache = docRow > rowCache[l - 1];
            } else var doCache = !l;
            var foldLine = this.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(row < docRow){
                if (row >= foldStart) {
                    rowEnd = foldLine.end.row + 1;
                    if (rowEnd > docRow) break;
                    foldLine = this.getNextFoldLine(rowEnd, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                } else rowEnd = row + 1;
                screenRow += this.getRowLength(row);
                row = rowEnd;
                if (doCache) {
                    this.$docRowCache.push(row);
                    this.$screenRowCache.push(screenRow);
                }
            }
            var textLine = "";
            if (foldLine && row >= foldStart) {
                textLine = this.getFoldDisplayLine(foldLine, docRow, docColumn);
                foldStartRow = foldLine.start.row;
            } else {
                textLine = this.getLine(docRow).substring(0, docColumn);
                foldStartRow = docRow;
            }
            var wrapIndent = 0;
            if (this.$useWrapMode) {
                var wrapRow = this.$wrapData[foldStartRow];
                if (wrapRow) {
                    var screenRowOffset = 0;
                    while(textLine.length >= wrapRow[screenRowOffset]){
                        screenRow++;
                        screenRowOffset++;
                    }
                    textLine = textLine.substring(wrapRow[screenRowOffset - 1] || 0, textLine.length);
                    wrapIndent = screenRowOffset > 0 ? wrapRow.indent : 0;
                }
            }
            if (this.lineWidgets && this.lineWidgets[row] && this.lineWidgets[row].rowsAbove) screenRow += this.lineWidgets[row].rowsAbove;
            return {
                row: screenRow,
                column: wrapIndent + this.$getStringScreenWidth(textLine)[0]
            };
        };
        EditSession.prototype.documentToScreenColumn = function(row, docColumn) {
            return this.documentToScreenPosition(row, docColumn).column;
        };
        EditSession.prototype.documentToScreenRow = function(docRow, docColumn) {
            return this.documentToScreenPosition(docRow, docColumn).row;
        };
        EditSession.prototype.getScreenLength = function() {
            var screenRows = 0;
            var fold = null;
            if (!this.$useWrapMode) {
                screenRows = this.getLength();
                var foldData = this.$foldData;
                for(var i = 0; i < foldData.length; i++){
                    fold = foldData[i];
                    screenRows -= fold.end.row - fold.start.row;
                }
            } else {
                var lastRow = this.$wrapData.length;
                var row = 0, i = 0;
                var fold = this.$foldData[i++];
                var foldStart = fold ? fold.start.row : Infinity;
                while(row < lastRow){
                    var splits = this.$wrapData[row];
                    screenRows += splits ? splits.length + 1 : 1;
                    row++;
                    if (row > foldStart) {
                        row = fold.end.row + 1;
                        fold = this.$foldData[i++];
                        foldStart = fold ? fold.start.row : Infinity;
                    }
                }
            }
            if (this.lineWidgets) screenRows += this.$getWidgetScreenLength();
            return screenRows;
        };
        EditSession.prototype.$setFontMetrics = function(fm) {
            if (!this.$enableVarChar) return;
            this.$getStringScreenWidth = function(str, maxScreenColumn, screenColumn) {
                if (maxScreenColumn === 0) return [
                    0,
                    0
                ];
                if (!maxScreenColumn) maxScreenColumn = Infinity;
                screenColumn = screenColumn || 0;
                var c, column;
                for(column = 0; column < str.length; column++){
                    c = str.charAt(column);
                    if (c === "	") screenColumn += this.getScreenTabSize(screenColumn);
                    else screenColumn += fm.getCharacterWidth(c);
                    if (screenColumn > maxScreenColumn) break;
                }
                return [
                    screenColumn,
                    column
                ];
            };
        };
        EditSession.prototype.destroy = function() {
            if (!this.destroyed) {
                this.bgTokenizer.setDocument(null);
                this.bgTokenizer.cleanup();
                this.destroyed = true;
            }
            this.$stopWorker();
            this.removeAllListeners();
            if (this.doc) this.doc.off("change", this.$onChange);
            this.selection.detach();
        };
        return EditSession;
    }();
    EditSession.$uid = 0;
    EditSession.prototype.$modes = config.$modes;
    EditSession.prototype.getValue = EditSession.prototype.toString;
    EditSession.prototype.$defaultUndoManager = {
        undo: function() {},
        redo: function() {},
        hasUndo: function() {},
        hasRedo: function() {},
        reset: function() {},
        add: function() {},
        addSelection: function() {},
        startNewGroup: function() {},
        addSession: function() {}
    };
    EditSession.prototype.$overwrite = false;
    EditSession.prototype.$mode = null;
    EditSession.prototype.$modeId = null;
    EditSession.prototype.$scrollTop = 0;
    EditSession.prototype.$scrollLeft = 0;
    EditSession.prototype.$wrapLimit = 80;
    EditSession.prototype.$useWrapMode = false;
    EditSession.prototype.$wrapLimitRange = {
        min: null,
        max: null
    };
    EditSession.prototype.lineWidgets = null;
    EditSession.prototype.isFullWidth = isFullWidth;
    oop.implement(EditSession.prototype, EventEmitter);
    var CHAR = 1, CHAR_EXT = 2, PLACEHOLDER_START = 3, PLACEHOLDER_BODY = 4, PUNCTUATION = 9, SPACE = 10, TAB = 11, TAB_SPACE = 12;
    function isFullWidth(c) {
        if (c < 0x1100) return false;
        return c >= 0x1100 && c <= 0x115F || c >= 0x11A3 && c <= 0x11A7 || c >= 0x11FA && c <= 0x11FF || c >= 0x2329 && c <= 0x232A || c >= 0x2E80 && c <= 0x2E99 || c >= 0x2E9B && c <= 0x2EF3 || c >= 0x2F00 && c <= 0x2FD5 || c >= 0x2FF0 && c <= 0x2FFB || c >= 0x3000 && c <= 0x303E || c >= 0x3041 && c <= 0x3096 || c >= 0x3099 && c <= 0x30FF || c >= 0x3105 && c <= 0x312D || c >= 0x3131 && c <= 0x318E || c >= 0x3190 && c <= 0x31BA || c >= 0x31C0 && c <= 0x31E3 || c >= 0x31F0 && c <= 0x321E || c >= 0x3220 && c <= 0x3247 || c >= 0x3250 && c <= 0x32FE || c >= 0x3300 && c <= 0x4DBF || c >= 0x4E00 && c <= 0xA48C || c >= 0xA490 && c <= 0xA4C6 || c >= 0xA960 && c <= 0xA97C || c >= 0xAC00 && c <= 0xD7A3 || c >= 0xD7B0 && c <= 0xD7C6 || c >= 0xD7CB && c <= 0xD7FB || c >= 0xF900 && c <= 0xFAFF || c >= 0xFE10 && c <= 0xFE19 || c >= 0xFE30 && c <= 0xFE52 || c >= 0xFE54 && c <= 0xFE66 || c >= 0xFE68 && c <= 0xFE6B || c >= 0xFF01 && c <= 0xFF60 || c >= 0xFFE0 && c <= 0xFFE6;
    }
    require("./edit_session/folding").Folding.call(EditSession.prototype);
    require("./edit_session/bracket_match").BracketMatch.call(EditSession.prototype);
    config.defineOptions(EditSession.prototype, "session", {
        wrap: {
            set: function(value) {
                if (!value || value == "off") value = false;
                else if (value == "free") value = true;
                else if (value == "printMargin") value = -1;
                else if (typeof value == "string") value = parseInt(value, 10) || false;
                if (this.$wrap == value) return;
                this.$wrap = value;
                if (!value) this.setUseWrapMode(false);
                else {
                    var col = typeof value == "number" ? value : null;
                    this.setWrapLimitRange(col, col);
                    this.setUseWrapMode(true);
                }
            },
            get: function() {
                if (this.getUseWrapMode()) {
                    if (this.$wrap == -1) return "printMargin";
                    if (!this.getWrapLimitRange().min) return "free";
                    return this.$wrap;
                }
                return "off";
            },
            handlesSet: true
        },
        wrapMethod: {
            set: function(val) {
                val = val == "auto" ? this.$mode.type != "text" : val != "text";
                if (val != this.$wrapAsCode) {
                    this.$wrapAsCode = val;
                    if (this.$useWrapMode) {
                        this.$useWrapMode = false;
                        this.setUseWrapMode(true);
                    }
                }
            },
            initialValue: "auto"
        },
        indentedSoftWrap: {
            set: function() {
                if (this.$useWrapMode) {
                    this.$useWrapMode = false;
                    this.setUseWrapMode(true);
                }
            },
            initialValue: true
        },
        firstLineNumber: {
            set: function() {
                this._signal("changeBreakpoint");
            },
            initialValue: 1
        },
        useWorker: {
            set: function(useWorker) {
                this.$useWorker = useWorker;
                this.$stopWorker();
                if (useWorker) this.$startWorker();
            },
            initialValue: true
        },
        useSoftTabs: {
            initialValue: true
        },
        tabSize: {
            set: function(tabSize) {
                tabSize = parseInt(tabSize);
                if (tabSize > 0 && this.$tabSize !== tabSize) {
                    this.$modified = true;
                    this.$rowLengthCache = [];
                    this.$tabSize = tabSize;
                    this._signal("changeTabSize");
                }
            },
            initialValue: 4,
            handlesSet: true
        },
        navigateWithinSoftTabs: {
            initialValue: false
        },
        foldStyle: {
            set: function(val) {
                this.setFoldStyle(val);
            },
            handlesSet: true
        },
        overwrite: {
            set: function(val) {
                this._signal("changeOverwrite");
            },
            initialValue: false
        },
        newLineMode: {
            set: function(val) {
                this.doc.setNewLineMode(val);
            },
            get: function() {
                return this.doc.getNewLineMode();
            },
            handlesSet: true
        },
        mode: {
            set: function(val) {
                this.setMode(val);
            },
            get: function() {
                return this.$modeId;
            },
            handlesSet: true
        }
    });
    exports.EditSession = EditSession;
});
ace.define("ace/search", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/lib/oop",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var lang = require("./lib/lang");
    var oop = require("./lib/oop");
    var Range = require("./range").Range;
    var Search = /** @class */ function() {
        function Search() {
            this.$options = {};
        }
        Search.prototype.set = function(options) {
            oop.mixin(this.$options, options);
            return this;
        };
        Search.prototype.getOptions = function() {
            return lang.copyObject(this.$options);
        };
        Search.prototype.setOptions = function(options) {
            this.$options = options;
        };
        Search.prototype.find = function(session) {
            var options = this.$options;
            var iterator = this.$matchIterator(session, options);
            if (!iterator) return false;
            var firstRange = null;
            iterator.forEach(function(sr, sc, er, ec) {
                firstRange = new Range(sr, sc, er, ec);
                if (sc == ec && options.start && options.start.start && options.skipCurrent != false && firstRange.isEqual(options.start)) {
                    firstRange = null;
                    return false;
                }
                return true;
            });
            return firstRange;
        };
        Search.prototype.findAll = function(session) {
            var options = this.$options;
            if (!options.needle) return [];
            this.$assembleRegExp(options);
            var range = options.range;
            var lines = range ? session.getLines(range.start.row, range.end.row) : session.doc.getAllLines();
            var ranges = [];
            var re = options.re;
            if (options.$isMultiLine) {
                var len = re.length;
                var maxRow = lines.length - len;
                var prevRange;
                outer: for(var row = re.offset || 0; row <= maxRow; row++){
                    for(var j = 0; j < len; j++)if (lines[row + j].search(re[j]) == -1) continue outer;
                    var startLine = lines[row];
                    var line = lines[row + len - 1];
                    var startIndex = startLine.length - startLine.match(re[0])[0].length;
                    var endIndex = line.match(re[len - 1])[0].length;
                    if (prevRange && prevRange.end.row === row && prevRange.end.column > startIndex) continue;
                    ranges.push(prevRange = new Range(row, startIndex, row + len - 1, endIndex));
                    if (len > 2) row = row + len - 2;
                }
            } else for(var i = 0; i < lines.length; i++){
                var matches = lang.getMatchOffsets(lines[i], re);
                for(var j = 0; j < matches.length; j++){
                    var match = matches[j];
                    ranges.push(new Range(i, match.offset, i, match.offset + match.length));
                }
            }
            if (range) {
                var startColumn = range.start.column;
                var endColumn = range.end.column;
                var i = 0, j = ranges.length - 1;
                while(i < j && ranges[i].start.column < startColumn && ranges[i].start.row == 0)i++;
                var endRow = range.end.row - range.start.row;
                while(i < j && ranges[j].end.column > endColumn && ranges[j].end.row == endRow)j--;
                ranges = ranges.slice(i, j + 1);
                for(i = 0, j = ranges.length; i < j; i++){
                    ranges[i].start.row += range.start.row;
                    ranges[i].end.row += range.start.row;
                }
            }
            return ranges;
        };
        Search.prototype.replace = function(input, replacement) {
            var options = this.$options;
            var re = this.$assembleRegExp(options);
            if (options.$isMultiLine) return replacement;
            if (!re) return;
            var match = re.exec(input);
            if (!match || match[0].length != input.length) return null;
            replacement = input.replace(re, replacement);
            if (options.preserveCase) {
                replacement = replacement.split("");
                for(var i = Math.min(input.length, input.length); i--;){
                    var ch = input[i];
                    if (ch && ch.toLowerCase() != ch) replacement[i] = replacement[i].toUpperCase();
                    else replacement[i] = replacement[i].toLowerCase();
                }
                replacement = replacement.join("");
            }
            return replacement;
        };
        Search.prototype.$assembleRegExp = function(options, $disableFakeMultiline) {
            if (options.needle instanceof RegExp) return options.re = options.needle;
            var needle = options.needle;
            if (!options.needle) return options.re = false;
            if (options.$supportsUnicodeFlag === undefined) options.$supportsUnicodeFlag = lang.supportsUnicodeFlag();
            try {
                new RegExp(needle, "u");
            } catch (e) {
                options.$supportsUnicodeFlag = false; //left for backward compatibility with previous versions for cases like /ab\{2}/gu
            }
            if (!options.regExp) needle = lang.escapeRegExp(needle);
            if (options.wholeWord) needle = addWordBoundary(needle, options);
            var modifier = options.caseSensitive ? "gm" : "gmi";
            if (options.$supportsUnicodeFlag) modifier += "u";
            options.$isMultiLine = !$disableFakeMultiline && /[\n\r]/.test(needle);
            if (options.$isMultiLine) return options.re = this.$assembleMultilineRegExp(needle, modifier);
            try {
                var re = new RegExp(needle, modifier);
            } catch (e) {
                re = false;
            }
            return options.re = re;
        };
        Search.prototype.$assembleMultilineRegExp = function(needle, modifier) {
            var parts = needle.replace(/\r\n|\r|\n/g, "$\n^").split("\n");
            var re = [];
            for(var i = 0; i < parts.length; i++)try {
                re.push(new RegExp(parts[i], modifier));
            } catch (e) {
                return false;
            }
            return re;
        };
        Search.prototype.$matchIterator = function(session, options) {
            var re = this.$assembleRegExp(options);
            if (!re) return false;
            var backwards = options.backwards == true;
            var skipCurrent = options.skipCurrent != false;
            var range = options.range;
            var start = options.start;
            if (!start) start = range ? range[backwards ? "end" : "start"] : session.selection.getRange();
            if (start.start) start = start[skipCurrent != backwards ? "end" : "start"];
            var firstRow = range ? range.start.row : 0;
            var lastRow = range ? range.end.row : session.getLength() - 1;
            if (backwards) var forEach = function(callback) {
                var row = start.row;
                if (forEachInLine(row, start.column, callback)) return;
                for(row--; row >= firstRow; row--)if (forEachInLine(row, Number.MAX_VALUE, callback)) return;
                if (options.wrap == false) return;
                for(row = lastRow, firstRow = start.row; row >= firstRow; row--)if (forEachInLine(row, Number.MAX_VALUE, callback)) return;
            };
            else var forEach = function(callback) {
                var row = start.row;
                if (forEachInLine(row, start.column, callback)) return;
                for(row = row + 1; row <= lastRow; row++)if (forEachInLine(row, 0, callback)) return;
                if (options.wrap == false) return;
                for(row = firstRow, lastRow = start.row; row <= lastRow; row++)if (forEachInLine(row, 0, callback)) return;
            };
            if (options.$isMultiLine) {
                var len = re.length;
                var forEachInLine = function(row, offset, callback) {
                    var startRow = backwards ? row - len + 1 : row;
                    if (startRow < 0 || startRow + len > session.getLength()) return;
                    var line = session.getLine(startRow);
                    var startIndex = line.search(re[0]);
                    if (!backwards && startIndex < offset || startIndex === -1) return;
                    for(var i = 1; i < len; i++){
                        line = session.getLine(startRow + i);
                        if (line.search(re[i]) == -1) return;
                    }
                    var endIndex = line.match(re[len - 1])[0].length;
                    if (backwards && endIndex > offset) return;
                    if (callback(startRow, startIndex, startRow + len - 1, endIndex)) return true;
                };
            } else if (backwards) var forEachInLine = function(row, endIndex, callback) {
                var line = session.getLine(row);
                var matches = [];
                var m, last = 0;
                re.lastIndex = 0;
                while(m = re.exec(line)){
                    var length = m[0].length;
                    last = m.index;
                    if (!length) {
                        if (last >= line.length) break;
                        re.lastIndex = last += 1;
                    }
                    if (m.index + length > endIndex) break;
                    matches.push(m.index, length);
                }
                for(var i = matches.length - 1; i >= 0; i -= 2){
                    var column = matches[i - 1];
                    var length = matches[i];
                    if (callback(row, column, row, column + length)) return true;
                }
            };
            else var forEachInLine = function(row, startIndex, callback) {
                var line = session.getLine(row);
                var last;
                var m;
                re.lastIndex = startIndex;
                while(m = re.exec(line)){
                    var length = m[0].length;
                    last = m.index;
                    if (callback(row, last, row, last + length)) return true;
                    if (!length) {
                        re.lastIndex = last += 1;
                        if (last >= line.length) return false;
                    }
                }
            };
            return {
                forEach: forEach
            };
        };
        return Search;
    }();
    function addWordBoundary(needle, options) {
        var supportsLookbehind = lang.supportsLookbehind();
        function wordBoundary(c, firstChar) {
            if (firstChar === void 0) firstChar = true;
            var wordRegExp = supportsLookbehind && options.$supportsUnicodeFlag ? new RegExp("[\\p{L}\\p{N}_]", "u") : new RegExp("\\w");
            if (wordRegExp.test(c) || options.regExp) {
                if (supportsLookbehind && options.$supportsUnicodeFlag) {
                    if (firstChar) return "(?<=^|[^\\p{L}\\p{N}_])";
                    return "(?=[^\\p{L}\\p{N}_]|$)";
                }
                return "\\b";
            }
            return "";
        }
        var needleArray = Array.from(needle);
        var firstChar = needleArray[0];
        var lastChar = needleArray[needleArray.length - 1];
        return wordBoundary(firstChar) + needle + wordBoundary(lastChar, false);
    }
    exports.Search = Search;
});
ace.define("ace/keyboard/hash_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/keys",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var keyUtil = require("../lib/keys");
    var useragent = require("../lib/useragent");
    var KEY_MODS = keyUtil.KEY_MODS;
    var MultiHashHandler = /** @class */ function() {
        function MultiHashHandler(config, platform) {
            this.$init(config, platform, false);
        }
        MultiHashHandler.prototype.$init = function(config, platform, $singleCommand) {
            this.platform = platform || (useragent.isMac ? "mac" : "win");
            this.commands = {};
            this.commandKeyBinding = {};
            this.addCommands(config);
            this.$singleCommand = $singleCommand;
        };
        MultiHashHandler.prototype.addCommand = function(command) {
            if (this.commands[command.name]) this.removeCommand(command);
            this.commands[command.name] = command;
            if (command.bindKey) this._buildKeyHash(command);
        };
        MultiHashHandler.prototype.removeCommand = function(command, keepCommand) {
            var name = command && (typeof command === "string" ? command : command.name);
            command = this.commands[name];
            if (!keepCommand) delete this.commands[name];
            var ckb = this.commandKeyBinding;
            for(var keyId in ckb){
                var cmdGroup = ckb[keyId];
                if (cmdGroup == command) delete ckb[keyId];
                else if (Array.isArray(cmdGroup)) {
                    var i = cmdGroup.indexOf(command);
                    if (i != -1) {
                        cmdGroup.splice(i, 1);
                        if (cmdGroup.length == 1) ckb[keyId] = cmdGroup[0];
                    }
                }
            }
        };
        MultiHashHandler.prototype.bindKey = function(key, command, position) {
            if (typeof key == "object" && key) {
                if (position == undefined) position = key.position;
                key = key[this.platform];
            }
            if (!key) return;
            if (typeof command == "function") return this.addCommand({
                exec: command,
                bindKey: key,
                name: command.name || key
            });
            key.split("|").forEach(function(keyPart) {
                var chain = "";
                if (keyPart.indexOf(" ") != -1) {
                    var parts = keyPart.split(/\s+/);
                    keyPart = parts.pop();
                    parts.forEach(function(keyPart) {
                        var binding = this.parseKeys(keyPart);
                        var id = KEY_MODS[binding.hashId] + binding.key;
                        chain += (chain ? " " : "") + id;
                        this._addCommandToBinding(chain, "chainKeys");
                    }, this);
                    chain += " ";
                }
                var binding = this.parseKeys(keyPart);
                var id = KEY_MODS[binding.hashId] + binding.key;
                this._addCommandToBinding(chain + id, command, position);
            }, this);
        };
        MultiHashHandler.prototype._addCommandToBinding = function(keyId, command, position) {
            var ckb = this.commandKeyBinding, i;
            if (!command) delete ckb[keyId];
            else if (!ckb[keyId] || this.$singleCommand) ckb[keyId] = command;
            else {
                if (!Array.isArray(ckb[keyId])) ckb[keyId] = [
                    ckb[keyId]
                ];
                else if ((i = ckb[keyId].indexOf(command)) != -1) ckb[keyId].splice(i, 1);
                if (typeof position != "number") position = getPosition(command);
                var commands = ckb[keyId];
                for(i = 0; i < commands.length; i++){
                    var other = commands[i];
                    var otherPos = getPosition(other);
                    if (otherPos > position) break;
                }
                commands.splice(i, 0, command);
            }
        };
        MultiHashHandler.prototype.addCommands = function(commands) {
            commands && Object.keys(commands).forEach(function(name) {
                var command = commands[name];
                if (!command) return;
                if (typeof command === "string") return this.bindKey(command, name);
                if (typeof command === "function") command = {
                    exec: command
                };
                if (typeof command !== "object") return;
                if (!command.name) command.name = name;
                this.addCommand(command);
            }, this);
        };
        MultiHashHandler.prototype.removeCommands = function(commands) {
            Object.keys(commands).forEach(function(name) {
                this.removeCommand(commands[name]);
            }, this);
        };
        MultiHashHandler.prototype.bindKeys = function(keyList) {
            Object.keys(keyList).forEach(function(key) {
                this.bindKey(key, keyList[key]);
            }, this);
        };
        MultiHashHandler.prototype._buildKeyHash = function(command) {
            this.bindKey(command.bindKey, command);
        };
        MultiHashHandler.prototype.parseKeys = function(keys) {
            var parts = keys.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(x) {
                return x;
            });
            var key = parts.pop();
            var keyCode = keyUtil[key];
            if (keyUtil.FUNCTION_KEYS[keyCode]) key = keyUtil.FUNCTION_KEYS[keyCode].toLowerCase();
            else if (!parts.length) return {
                key: key,
                hashId: -1
            };
            else if (parts.length == 1 && parts[0] == "shift") return {
                key: key.toUpperCase(),
                hashId: -1
            };
            var hashId = 0;
            for(var i = parts.length; i--;){
                var modifier = keyUtil.KEY_MODS[parts[i]];
                if (modifier == null) {
                    if (typeof console != "undefined") console.error("invalid modifier " + parts[i] + " in " + keys);
                    return false;
                }
                hashId |= modifier;
            }
            return {
                key: key,
                hashId: hashId
            };
        };
        MultiHashHandler.prototype.findKeyCommand = function(hashId, keyString) {
            var key = KEY_MODS[hashId] + keyString;
            return this.commandKeyBinding[key];
        };
        MultiHashHandler.prototype.handleKeyboard = function(data, hashId, keyString, keyCode) {
            if (keyCode < 0) return;
            var key = KEY_MODS[hashId] + keyString;
            var command = this.commandKeyBinding[key];
            if (data.$keyChain) {
                data.$keyChain += " " + key;
                command = this.commandKeyBinding[data.$keyChain] || command;
            }
            if (command) {
                if (command == "chainKeys" || command[command.length - 1] == "chainKeys") {
                    data.$keyChain = data.$keyChain || key;
                    return {
                        command: "null"
                    };
                }
            }
            if (data.$keyChain) {
                if ((!hashId || hashId == 4) && keyString.length == 1) data.$keyChain = data.$keyChain.slice(0, -key.length - 1); // wait for input
                else if (hashId == -1 || keyCode > 0) data.$keyChain = ""; // reset keyChain
            }
            return {
                command: command
            };
        };
        MultiHashHandler.prototype.getStatusText = function(editor, data) {
            return data.$keyChain || "";
        };
        return MultiHashHandler;
    }();
    function getPosition(command) {
        return typeof command == "object" && command.bindKey && command.bindKey.position || (command.isDefault ? -100 : 0);
    }
    var HashHandler = /** @class */ function(_super) {
        __extends(HashHandler, _super);
        function HashHandler(config, platform) {
            var _this = _super.call(this, config, platform) || this;
            _this.$singleCommand = true;
            return _this;
        }
        return HashHandler;
    }(MultiHashHandler);
    HashHandler.call = function(thisArg, config, platform) {
        MultiHashHandler.prototype.$init.call(thisArg, config, platform, true);
    };
    MultiHashHandler.call = function(thisArg, config, platform) {
        MultiHashHandler.prototype.$init.call(thisArg, config, platform, false);
    };
    exports.HashHandler = HashHandler;
    exports.MultiHashHandler = MultiHashHandler;
});
ace.define("ace/commands/command_manager", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/keyboard/hash_handler",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var oop = require("../lib/oop");
    var MultiHashHandler = require("../keyboard/hash_handler").MultiHashHandler;
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var CommandManager = /** @class */ function(_super) {
        __extends(CommandManager, _super);
        function CommandManager(platform, commands) {
            var _this = _super.call(this, commands, platform) || this;
            _this.byName = _this.commands;
            _this.setDefaultHandler("exec", function(e) {
                if (!e.args) return e.command.exec(e.editor, {}, e.event, true);
                return e.command.exec(e.editor, e.args, e.event, false);
            });
            return _this;
        }
        CommandManager.prototype.exec = function(command, editor, args) {
            if (Array.isArray(command)) {
                for(var i = command.length; i--;){
                    if (this.exec(command[i], editor, args)) return true;
                }
                return false;
            }
            if (typeof command === "string") command = this.commands[command];
            if (!command) return false;
            if (editor && editor.$readOnly && !command.readOnly) return false;
            if (this.$checkCommandState != false && command.isAvailable && !command.isAvailable(editor)) return false;
            var e = {
                editor: editor,
                command: command,
                args: args
            };
            e.returnValue = this._emit("exec", e);
            this._signal("afterExec", e);
            return e.returnValue === false ? false : true;
        };
        CommandManager.prototype.toggleRecording = function(editor) {
            if (this.$inReplay) return;
            editor && editor._emit("changeStatus");
            if (this.recording) {
                this.macro.pop();
                this.off("exec", this.$addCommandToMacro);
                if (!this.macro.length) this.macro = this.oldMacro;
                return this.recording = false;
            }
            if (!this.$addCommandToMacro) this.$addCommandToMacro = (function(e) {
                this.macro.push([
                    e.command,
                    e.args
                ]);
            }).bind(this);
            this.oldMacro = this.macro;
            this.macro = [];
            this.on("exec", this.$addCommandToMacro);
            return this.recording = true;
        };
        CommandManager.prototype.replay = function(editor) {
            if (this.$inReplay || !this.macro) return;
            if (this.recording) return this.toggleRecording(editor);
            try {
                this.$inReplay = true;
                this.macro.forEach(function(x) {
                    if (typeof x == "string") this.exec(x, editor);
                    else this.exec(x[0], editor, x[1]);
                }, this);
            } finally{
                this.$inReplay = false;
            }
        };
        CommandManager.prototype.trimMacro = function(m) {
            return m.map(function(x) {
                if (typeof x[0] != "string") x[0] = x[0].name;
                if (!x[1]) x = x[0];
                return x;
            });
        };
        return CommandManager;
    }(MultiHashHandler);
    oop.implement(CommandManager.prototype, EventEmitter);
    exports.CommandManager = CommandManager;
});
ace.define("ace/commands/default_commands", [
    "require",
    "exports",
    "module",
    "ace/lib/lang",
    "ace/config",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var lang = require("../lib/lang");
    var config = require("../config");
    var Range = require("../range").Range;
    function bindKey(win, mac) {
        return {
            win: win,
            mac: mac
        };
    }
    exports.commands = [
        {
            name: "showSettingsMenu",
            description: "Show settings menu",
            bindKey: bindKey("Ctrl-,", "Command-,"),
            exec: function(editor) {
                config.loadModule("ace/ext/settings_menu", function(module1) {
                    module1.init(editor);
                    editor.showSettingsMenu();
                });
            },
            readOnly: true
        },
        {
            name: "goToNextError",
            description: "Go to next error",
            bindKey: bindKey("Alt-E", "F4"),
            exec: function(editor) {
                config.loadModule("ace/ext/error_marker", function(module1) {
                    module1.showErrorMarker(editor, 1);
                });
            },
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "goToPreviousError",
            description: "Go to previous error",
            bindKey: bindKey("Alt-Shift-E", "Shift-F4"),
            exec: function(editor) {
                config.loadModule("ace/ext/error_marker", function(module1) {
                    module1.showErrorMarker(editor, -1);
                });
            },
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "selectall",
            description: "Select all",
            bindKey: bindKey("Ctrl-A", "Command-A"),
            exec: function(editor) {
                editor.selectAll();
            },
            readOnly: true
        },
        {
            name: "centerselection",
            description: "Center selection",
            bindKey: bindKey(null, "Ctrl-L"),
            exec: function(editor) {
                editor.centerSelection();
            },
            readOnly: true
        },
        {
            name: "gotoline",
            description: "Go to line...",
            bindKey: bindKey("Ctrl-L", "Command-L"),
            exec: function(editor, line) {
                if (typeof line === "number" && !isNaN(line)) editor.gotoLine(line);
                editor.prompt({
                    $type: "gotoLine"
                });
            },
            readOnly: true
        },
        {
            name: "fold",
            bindKey: bindKey("Alt-L|Ctrl-F1", "Command-Alt-L|Command-F1"),
            exec: function(editor) {
                editor.session.toggleFold(false);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "unfold",
            bindKey: bindKey("Alt-Shift-L|Ctrl-Shift-F1", "Command-Alt-Shift-L|Command-Shift-F1"),
            exec: function(editor) {
                editor.session.toggleFold(true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "toggleFoldWidget",
            description: "Toggle fold widget",
            bindKey: bindKey("F2", "F2"),
            exec: function(editor) {
                editor.session.toggleFoldWidget();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "toggleParentFoldWidget",
            description: "Toggle parent fold widget",
            bindKey: bindKey("Alt-F2", "Alt-F2"),
            exec: function(editor) {
                editor.session.toggleFoldWidget(true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "foldall",
            description: "Fold all",
            bindKey: bindKey(null, "Ctrl-Command-Option-0"),
            exec: function(editor) {
                editor.session.foldAll();
            },
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "foldAllComments",
            description: "Fold all comments",
            bindKey: bindKey(null, "Ctrl-Command-Option-0"),
            exec: function(editor) {
                editor.session.foldAllComments();
            },
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "foldOther",
            description: "Fold other",
            bindKey: bindKey("Alt-0", "Command-Option-0"),
            exec: function(editor) {
                editor.session.foldAll();
                editor.session.unfold(editor.selection.getAllRanges());
            },
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "unfoldall",
            description: "Unfold all",
            bindKey: bindKey("Alt-Shift-0", "Command-Option-Shift-0"),
            exec: function(editor) {
                editor.session.unfold();
            },
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "findnext",
            description: "Find next",
            bindKey: bindKey("Ctrl-K", "Command-G"),
            exec: function(editor) {
                editor.findNext();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "findprevious",
            description: "Find previous",
            bindKey: bindKey("Ctrl-Shift-K", "Command-Shift-G"),
            exec: function(editor) {
                editor.findPrevious();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "center",
            readOnly: true
        },
        {
            name: "selectOrFindNext",
            description: "Select or find next",
            bindKey: bindKey("Alt-K", "Ctrl-G"),
            exec: function(editor) {
                if (editor.selection.isEmpty()) editor.selection.selectWord();
                else editor.findNext();
            },
            readOnly: true
        },
        {
            name: "selectOrFindPrevious",
            description: "Select or find previous",
            bindKey: bindKey("Alt-Shift-K", "Ctrl-Shift-G"),
            exec: function(editor) {
                if (editor.selection.isEmpty()) editor.selection.selectWord();
                else editor.findPrevious();
            },
            readOnly: true
        },
        {
            name: "find",
            description: "Find",
            bindKey: bindKey("Ctrl-F", "Command-F"),
            exec: function(editor) {
                config.loadModule("ace/ext/searchbox", function(e) {
                    e.Search(editor);
                });
            },
            readOnly: true
        },
        {
            name: "overwrite",
            description: "Overwrite",
            bindKey: "Insert",
            exec: function(editor) {
                editor.toggleOverwrite();
            },
            readOnly: true
        },
        {
            name: "selecttostart",
            description: "Select to start",
            bindKey: bindKey("Ctrl-Shift-Home", "Command-Shift-Home|Command-Shift-Up"),
            exec: function(editor) {
                editor.getSelection().selectFileStart();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "gotostart",
            description: "Go to start",
            bindKey: bindKey("Ctrl-Home", "Command-Home|Command-Up"),
            exec: function(editor) {
                editor.navigateFileStart();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "selectup",
            description: "Select up",
            bindKey: bindKey("Shift-Up", "Shift-Up|Ctrl-Shift-P"),
            exec: function(editor) {
                editor.getSelection().selectUp();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "golineup",
            description: "Go line up",
            bindKey: bindKey("Up", "Up|Ctrl-P"),
            exec: function(editor, args) {
                editor.navigateUp(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selecttoend",
            description: "Select to end",
            bindKey: bindKey("Ctrl-Shift-End", "Command-Shift-End|Command-Shift-Down"),
            exec: function(editor) {
                editor.getSelection().selectFileEnd();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "gotoend",
            description: "Go to end",
            bindKey: bindKey("Ctrl-End", "Command-End|Command-Down"),
            exec: function(editor) {
                editor.navigateFileEnd();
            },
            multiSelectAction: "forEach",
            readOnly: true,
            scrollIntoView: "animate",
            aceCommandGroup: "fileJump"
        },
        {
            name: "selectdown",
            description: "Select down",
            bindKey: bindKey("Shift-Down", "Shift-Down|Ctrl-Shift-N"),
            exec: function(editor) {
                editor.getSelection().selectDown();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "golinedown",
            description: "Go line down",
            bindKey: bindKey("Down", "Down|Ctrl-N"),
            exec: function(editor, args) {
                editor.navigateDown(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectwordleft",
            description: "Select word left",
            bindKey: bindKey("Ctrl-Shift-Left", "Option-Shift-Left"),
            exec: function(editor) {
                editor.getSelection().selectWordLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotowordleft",
            description: "Go to word left",
            bindKey: bindKey("Ctrl-Left", "Option-Left"),
            exec: function(editor) {
                editor.navigateWordLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selecttolinestart",
            description: "Select to line start",
            bindKey: bindKey("Alt-Shift-Left", "Command-Shift-Left|Ctrl-Shift-A"),
            exec: function(editor) {
                editor.getSelection().selectLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotolinestart",
            description: "Go to line start",
            bindKey: bindKey("Alt-Left|Home", "Command-Left|Home|Ctrl-A"),
            exec: function(editor) {
                editor.navigateLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectleft",
            description: "Select left",
            bindKey: bindKey("Shift-Left", "Shift-Left|Ctrl-Shift-B"),
            exec: function(editor) {
                editor.getSelection().selectLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotoleft",
            description: "Go to left",
            bindKey: bindKey("Left", "Left|Ctrl-B"),
            exec: function(editor, args) {
                editor.navigateLeft(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectwordright",
            description: "Select word right",
            bindKey: bindKey("Ctrl-Shift-Right", "Option-Shift-Right"),
            exec: function(editor) {
                editor.getSelection().selectWordRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotowordright",
            description: "Go to word right",
            bindKey: bindKey("Ctrl-Right", "Option-Right"),
            exec: function(editor) {
                editor.navigateWordRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selecttolineend",
            description: "Select to line end",
            bindKey: bindKey("Alt-Shift-Right", "Command-Shift-Right|Shift-End|Ctrl-Shift-E"),
            exec: function(editor) {
                editor.getSelection().selectLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotolineend",
            description: "Go to line end",
            bindKey: bindKey("Alt-Right|End", "Command-Right|End|Ctrl-E"),
            exec: function(editor) {
                editor.navigateLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectright",
            description: "Select right",
            bindKey: bindKey("Shift-Right", "Shift-Right"),
            exec: function(editor) {
                editor.getSelection().selectRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "gotoright",
            description: "Go to right",
            bindKey: bindKey("Right", "Right|Ctrl-F"),
            exec: function(editor, args) {
                editor.navigateRight(args.times);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectpagedown",
            description: "Select page down",
            bindKey: "Shift-PageDown",
            exec: function(editor) {
                editor.selectPageDown();
            },
            readOnly: true
        },
        {
            name: "pagedown",
            description: "Page down",
            bindKey: bindKey(null, "Option-PageDown"),
            exec: function(editor) {
                editor.scrollPageDown();
            },
            readOnly: true
        },
        {
            name: "gotopagedown",
            description: "Go to page down",
            bindKey: bindKey("PageDown", "PageDown|Ctrl-V"),
            exec: function(editor) {
                editor.gotoPageDown();
            },
            readOnly: true
        },
        {
            name: "selectpageup",
            description: "Select page up",
            bindKey: "Shift-PageUp",
            exec: function(editor) {
                editor.selectPageUp();
            },
            readOnly: true
        },
        {
            name: "pageup",
            description: "Page up",
            bindKey: bindKey(null, "Option-PageUp"),
            exec: function(editor) {
                editor.scrollPageUp();
            },
            readOnly: true
        },
        {
            name: "gotopageup",
            description: "Go to page up",
            bindKey: "PageUp",
            exec: function(editor) {
                editor.gotoPageUp();
            },
            readOnly: true
        },
        {
            name: "scrollup",
            description: "Scroll up",
            bindKey: bindKey("Ctrl-Up", null),
            exec: function(e) {
                e.renderer.scrollBy(0, -2 * e.renderer.layerConfig.lineHeight);
            },
            readOnly: true
        },
        {
            name: "scrolldown",
            description: "Scroll down",
            bindKey: bindKey("Ctrl-Down", null),
            exec: function(e) {
                e.renderer.scrollBy(0, 2 * e.renderer.layerConfig.lineHeight);
            },
            readOnly: true
        },
        {
            name: "selectlinestart",
            description: "Select line start",
            bindKey: "Shift-Home",
            exec: function(editor) {
                editor.getSelection().selectLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectlineend",
            description: "Select line end",
            bindKey: "Shift-End",
            exec: function(editor) {
                editor.getSelection().selectLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "togglerecording",
            description: "Toggle recording",
            bindKey: bindKey("Ctrl-Alt-E", "Command-Option-E"),
            exec: function(editor) {
                editor.commands.toggleRecording(editor);
            },
            readOnly: true
        },
        {
            name: "replaymacro",
            description: "Replay macro",
            bindKey: bindKey("Ctrl-Shift-E", "Command-Shift-E"),
            exec: function(editor) {
                editor.commands.replay(editor);
            },
            readOnly: true
        },
        {
            name: "jumptomatching",
            description: "Jump to matching",
            bindKey: bindKey("Ctrl-\\|Ctrl-P", "Command-\\"),
            exec: function(editor) {
                editor.jumpToMatching();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "selecttomatching",
            description: "Select to matching",
            bindKey: bindKey("Ctrl-Shift-\\|Ctrl-Shift-P", "Command-Shift-\\"),
            exec: function(editor) {
                editor.jumpToMatching(true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "expandToMatching",
            description: "Expand to matching",
            bindKey: bindKey("Ctrl-Shift-M", "Ctrl-Shift-M"),
            exec: function(editor) {
                editor.jumpToMatching(true, true);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "animate",
            readOnly: true
        },
        {
            name: "passKeysToBrowser",
            description: "Pass keys to browser",
            bindKey: bindKey(null, null),
            exec: function() {},
            passEvent: true,
            readOnly: true
        },
        {
            name: "copy",
            description: "Copy",
            exec: function(editor) {},
            readOnly: true
        },
        {
            name: "cut",
            description: "Cut",
            exec: function(editor) {
                var cutLine = editor.$copyWithEmptySelection && editor.selection.isEmpty();
                var range = cutLine ? editor.selection.getLineRange() : editor.selection.getRange();
                editor._emit("cut", range);
                if (!range.isEmpty()) editor.session.remove(range);
                editor.clearSelection();
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "paste",
            description: "Paste",
            exec: function(editor, args) {
                editor.$handlePaste(args);
            },
            scrollIntoView: "cursor"
        },
        {
            name: "removeline",
            description: "Remove line",
            bindKey: bindKey("Ctrl-D", "Command-D"),
            exec: function(editor) {
                editor.removeLines();
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEachLine"
        },
        {
            name: "duplicateSelection",
            description: "Duplicate selection",
            bindKey: bindKey("Ctrl-Shift-D", "Command-Shift-D"),
            exec: function(editor) {
                editor.duplicateSelection();
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "sortlines",
            description: "Sort lines",
            bindKey: bindKey("Ctrl-Alt-S", "Command-Alt-S"),
            exec: function(editor) {
                editor.sortLines();
            },
            scrollIntoView: "selection",
            multiSelectAction: "forEachLine"
        },
        {
            name: "togglecomment",
            description: "Toggle comment",
            bindKey: bindKey("Ctrl-/", "Command-/"),
            exec: function(editor) {
                editor.toggleCommentLines();
            },
            multiSelectAction: "forEachLine",
            scrollIntoView: "selectionPart"
        },
        {
            name: "toggleBlockComment",
            description: "Toggle block comment",
            bindKey: bindKey("Ctrl-Shift-/", "Command-Shift-/"),
            exec: function(editor) {
                editor.toggleBlockComment();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "selectionPart"
        },
        {
            name: "modifyNumberUp",
            description: "Modify number up",
            bindKey: bindKey("Ctrl-Shift-Up", "Alt-Shift-Up"),
            exec: function(editor) {
                editor.modifyNumber(1);
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "modifyNumberDown",
            description: "Modify number down",
            bindKey: bindKey("Ctrl-Shift-Down", "Alt-Shift-Down"),
            exec: function(editor) {
                editor.modifyNumber(-1);
            },
            scrollIntoView: "cursor",
            multiSelectAction: "forEach"
        },
        {
            name: "replace",
            description: "Replace",
            bindKey: bindKey("Ctrl-H", "Command-Option-F"),
            exec: function(editor) {
                config.loadModule("ace/ext/searchbox", function(e) {
                    e.Search(editor, true);
                });
            }
        },
        {
            name: "undo",
            description: "Undo",
            bindKey: bindKey("Ctrl-Z", "Command-Z"),
            exec: function(editor) {
                editor.undo();
            }
        },
        {
            name: "redo",
            description: "Redo",
            bindKey: bindKey("Ctrl-Shift-Z|Ctrl-Y", "Command-Shift-Z|Command-Y"),
            exec: function(editor) {
                editor.redo();
            }
        },
        {
            name: "copylinesup",
            description: "Copy lines up",
            bindKey: bindKey("Alt-Shift-Up", "Command-Option-Up"),
            exec: function(editor) {
                editor.copyLinesUp();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "movelinesup",
            description: "Move lines up",
            bindKey: bindKey("Alt-Up", "Option-Up"),
            exec: function(editor) {
                editor.moveLinesUp();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "copylinesdown",
            description: "Copy lines down",
            bindKey: bindKey("Alt-Shift-Down", "Command-Option-Down"),
            exec: function(editor) {
                editor.copyLinesDown();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "movelinesdown",
            description: "Move lines down",
            bindKey: bindKey("Alt-Down", "Option-Down"),
            exec: function(editor) {
                editor.moveLinesDown();
            },
            scrollIntoView: "cursor"
        },
        {
            name: "del",
            description: "Delete",
            bindKey: bindKey("Delete", "Delete|Ctrl-D|Shift-Delete"),
            exec: function(editor) {
                editor.remove("right");
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "backspace",
            description: "Backspace",
            bindKey: bindKey("Shift-Backspace|Backspace", "Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),
            exec: function(editor) {
                editor.remove("left");
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "cut_or_delete",
            description: "Cut or delete",
            bindKey: bindKey("Shift-Delete", null),
            exec: function(editor) {
                if (editor.selection.isEmpty()) editor.remove("left");
                else return false;
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolinestart",
            description: "Remove to line start",
            bindKey: bindKey("Alt-Backspace", "Command-Backspace"),
            exec: function(editor) {
                editor.removeToLineStart();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolineend",
            description: "Remove to line end",
            bindKey: bindKey("Alt-Delete", "Ctrl-K|Command-Delete"),
            exec: function(editor) {
                editor.removeToLineEnd();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolinestarthard",
            description: "Remove to line start hard",
            bindKey: bindKey("Ctrl-Shift-Backspace", null),
            exec: function(editor) {
                var range = editor.selection.getRange();
                range.start.column = 0;
                editor.session.remove(range);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removetolineendhard",
            description: "Remove to line end hard",
            bindKey: bindKey("Ctrl-Shift-Delete", null),
            exec: function(editor) {
                var range = editor.selection.getRange();
                range.end.column = Number.MAX_VALUE;
                editor.session.remove(range);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removewordleft",
            description: "Remove word left",
            bindKey: bindKey("Ctrl-Backspace", "Alt-Backspace|Ctrl-Alt-Backspace"),
            exec: function(editor) {
                editor.removeWordLeft();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "removewordright",
            description: "Remove word right",
            bindKey: bindKey("Ctrl-Delete", "Alt-Delete"),
            exec: function(editor) {
                editor.removeWordRight();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "outdent",
            description: "Outdent",
            bindKey: bindKey("Shift-Tab", "Shift-Tab"),
            exec: function(editor) {
                editor.blockOutdent();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "selectionPart"
        },
        {
            name: "indent",
            description: "Indent",
            bindKey: bindKey("Tab", "Tab"),
            exec: function(editor) {
                editor.indent();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "selectionPart"
        },
        {
            name: "blockoutdent",
            description: "Block outdent",
            bindKey: bindKey("Ctrl-[", "Ctrl-["),
            exec: function(editor) {
                editor.blockOutdent();
            },
            multiSelectAction: "forEachLine",
            scrollIntoView: "selectionPart"
        },
        {
            name: "blockindent",
            description: "Block indent",
            bindKey: bindKey("Ctrl-]", "Ctrl-]"),
            exec: function(editor) {
                editor.blockIndent();
            },
            multiSelectAction: "forEachLine",
            scrollIntoView: "selectionPart"
        },
        {
            name: "insertstring",
            description: "Insert string",
            exec: function(editor, str) {
                editor.insert(str);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "inserttext",
            description: "Insert text",
            exec: function(editor, args) {
                editor.insert(lang.stringRepeat(args.text || "", args.times || 1));
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "splitline",
            description: "Split line",
            bindKey: bindKey(null, "Ctrl-O"),
            exec: function(editor) {
                editor.splitLine();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "transposeletters",
            description: "Transpose letters",
            bindKey: bindKey("Alt-Shift-X", "Ctrl-T"),
            exec: function(editor) {
                editor.transposeLetters();
            },
            multiSelectAction: function(editor) {
                editor.transposeSelections(1);
            },
            scrollIntoView: "cursor"
        },
        {
            name: "touppercase",
            description: "To uppercase",
            bindKey: bindKey("Ctrl-U", "Ctrl-U"),
            exec: function(editor) {
                editor.toUpperCase();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "tolowercase",
            description: "To lowercase",
            bindKey: bindKey("Ctrl-Shift-U", "Ctrl-Shift-U"),
            exec: function(editor) {
                editor.toLowerCase();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "autoindent",
            description: "Auto Indent",
            bindKey: bindKey(null, null),
            exec: function(editor) {
                editor.autoIndent();
            },
            multiSelectAction: "forEachLine",
            scrollIntoView: "animate"
        },
        {
            name: "expandtoline",
            description: "Expand to line",
            bindKey: bindKey("Ctrl-Shift-L", "Command-Shift-L"),
            exec: function(editor) {
                var range = editor.selection.getRange();
                range.start.column = range.end.column = 0;
                range.end.row++;
                editor.selection.setRange(range, false);
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "openlink",
            bindKey: bindKey("Ctrl+F3", "F3"),
            exec: function(editor) {
                editor.openLink();
            }
        },
        {
            name: "joinlines",
            description: "Join lines",
            bindKey: bindKey(null, null),
            exec: function(editor) {
                var isBackwards = editor.selection.isBackwards();
                var selectionStart = isBackwards ? editor.selection.getSelectionLead() : editor.selection.getSelectionAnchor();
                var selectionEnd = isBackwards ? editor.selection.getSelectionAnchor() : editor.selection.getSelectionLead();
                var firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length;
                var selectedText = editor.session.doc.getTextRange(editor.selection.getRange());
                var selectedCount = selectedText.replace(/\n\s*/, " ").length;
                var insertLine = editor.session.doc.getLine(selectionStart.row);
                for(var i = selectionStart.row + 1; i <= selectionEnd.row + 1; i++){
                    var curLine = lang.stringTrimLeft(lang.stringTrimRight(editor.session.doc.getLine(i)));
                    if (curLine.length !== 0) curLine = " " + curLine;
                    insertLine += curLine;
                }
                if (selectionEnd.row + 1 < editor.session.doc.getLength() - 1) insertLine += editor.session.doc.getNewLineCharacter();
                editor.clearSelection();
                editor.session.doc.replace(new Range(selectionStart.row, 0, selectionEnd.row + 2, 0), insertLine);
                if (selectedCount > 0) {
                    editor.selection.moveCursorTo(selectionStart.row, selectionStart.column);
                    editor.selection.selectTo(selectionStart.row, selectionStart.column + selectedCount);
                } else {
                    firstLineEndCol = editor.session.doc.getLine(selectionStart.row).length > firstLineEndCol ? firstLineEndCol + 1 : firstLineEndCol;
                    editor.selection.moveCursorTo(selectionStart.row, firstLineEndCol);
                }
            },
            multiSelectAction: "forEach",
            readOnly: true
        },
        {
            name: "invertSelection",
            description: "Invert selection",
            bindKey: bindKey(null, null),
            exec: function(editor) {
                var endRow = editor.session.doc.getLength() - 1;
                var endCol = editor.session.doc.getLine(endRow).length;
                var ranges = editor.selection.rangeList.ranges;
                var newRanges = [];
                if (ranges.length < 1) ranges = [
                    editor.selection.getRange()
                ];
                for(var i = 0; i < ranges.length; i++){
                    if (i == ranges.length - 1) {
                        if (!(ranges[i].end.row === endRow && ranges[i].end.column === endCol)) newRanges.push(new Range(ranges[i].end.row, ranges[i].end.column, endRow, endCol));
                    }
                    if (i === 0) {
                        if (!(ranges[i].start.row === 0 && ranges[i].start.column === 0)) newRanges.push(new Range(0, 0, ranges[i].start.row, ranges[i].start.column));
                    } else newRanges.push(new Range(ranges[i - 1].end.row, ranges[i - 1].end.column, ranges[i].start.row, ranges[i].start.column));
                }
                editor.exitMultiSelectMode();
                editor.clearSelection();
                for(var i = 0; i < newRanges.length; i++)editor.selection.addRange(newRanges[i], false);
            },
            readOnly: true,
            scrollIntoView: "none"
        },
        {
            name: "addLineAfter",
            description: "Add new line after the current line",
            exec: function(editor) {
                editor.selection.clearSelection();
                editor.navigateLineEnd();
                editor.insert("\n");
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "addLineBefore",
            description: "Add new line before the current line",
            exec: function(editor) {
                editor.selection.clearSelection();
                var cursor = editor.getCursorPosition();
                editor.selection.moveTo(cursor.row - 1, Number.MAX_VALUE);
                editor.insert("\n");
                if (cursor.row === 0) editor.navigateUp();
            },
            multiSelectAction: "forEach",
            scrollIntoView: "cursor"
        },
        {
            name: "openCommandPallete",
            description: "Open command palette",
            bindKey: bindKey("F1", "F1"),
            exec: function(editor) {
                editor.prompt({
                    $type: "commands"
                });
            },
            readOnly: true
        },
        {
            name: "modeSelect",
            description: "Change language mode...",
            bindKey: bindKey(null, null),
            exec: function(editor) {
                editor.prompt({
                    $type: "modes"
                });
            },
            readOnly: true
        }
    ];
    for(var i = 1; i < 9; i++)exports.commands.push({
        name: "foldToLevel" + i,
        description: "Fold To Level " + i,
        level: i,
        exec: function(editor) {
            editor.session.foldToLevel(this.level);
        },
        scrollIntoView: "center",
        readOnly: true
    });
});
ace.define("ace/line_widgets", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var dom = require("./lib/dom");
    var LineWidgets = /** @class */ function() {
        function LineWidgets(session) {
            this.session = session;
            this.session.widgetManager = this;
            this.session.getRowLength = this.getRowLength;
            this.session.$getWidgetScreenLength = this.$getWidgetScreenLength;
            this.updateOnChange = this.updateOnChange.bind(this);
            this.renderWidgets = this.renderWidgets.bind(this);
            this.measureWidgets = this.measureWidgets.bind(this);
            this.session._changedWidgets = [];
            this.$onChangeEditor = this.$onChangeEditor.bind(this);
            this.session.on("change", this.updateOnChange);
            this.session.on("changeFold", this.updateOnFold);
            this.session.on("changeEditor", this.$onChangeEditor);
        }
        LineWidgets.prototype.getRowLength = function(row) {
            var h;
            if (this.lineWidgets) h = this.lineWidgets[row] && this.lineWidgets[row].rowCount || 0;
            else h = 0;
            if (!this.$useWrapMode || !this.$wrapData[row]) return 1 + h;
            else return this.$wrapData[row].length + 1 + h;
        };
        LineWidgets.prototype.$getWidgetScreenLength = function() {
            var screenRows = 0;
            this.lineWidgets.forEach(function(w) {
                if (w && w.rowCount && !w.hidden) screenRows += w.rowCount;
            });
            return screenRows;
        };
        LineWidgets.prototype.$onChangeEditor = function(e) {
            this.attach(e.editor);
        };
        LineWidgets.prototype.attach = function(editor) {
            if (editor && editor.widgetManager && editor.widgetManager != this) editor.widgetManager.detach();
            if (this.editor == editor) return;
            this.detach();
            this.editor = editor;
            if (editor) {
                editor.widgetManager = this;
                editor.renderer.on("beforeRender", this.measureWidgets);
                editor.renderer.on("afterRender", this.renderWidgets);
            }
        };
        LineWidgets.prototype.detach = function(e) {
            var editor = this.editor;
            if (!editor) return;
            this.editor = null;
            editor.widgetManager = null;
            editor.renderer.off("beforeRender", this.measureWidgets);
            editor.renderer.off("afterRender", this.renderWidgets);
            var lineWidgets = this.session.lineWidgets;
            lineWidgets && lineWidgets.forEach(function(w) {
                if (w && w.el && w.el.parentNode) {
                    w._inDocument = false;
                    w.el.parentNode.removeChild(w.el);
                }
            });
        };
        LineWidgets.prototype.updateOnFold = function(e, session) {
            var lineWidgets = session.lineWidgets;
            if (!lineWidgets || !e.action) return;
            var fold = e.data;
            var start = fold.start.row;
            var end = fold.end.row;
            var hide = e.action == "add";
            for(var i = start + 1; i < end; i++)if (lineWidgets[i]) lineWidgets[i].hidden = hide;
            if (lineWidgets[end]) {
                if (hide) {
                    if (!lineWidgets[start]) lineWidgets[start] = lineWidgets[end];
                    else lineWidgets[end].hidden = hide;
                } else {
                    if (lineWidgets[start] == lineWidgets[end]) lineWidgets[start] = undefined;
                    lineWidgets[end].hidden = hide;
                }
            }
        };
        LineWidgets.prototype.updateOnChange = function(delta) {
            var lineWidgets = this.session.lineWidgets;
            if (!lineWidgets) return;
            var startRow = delta.start.row;
            var len = delta.end.row - startRow;
            if (len === 0) ;
            else if (delta.action == "remove") {
                var removed = lineWidgets.splice(startRow + 1, len);
                if (!lineWidgets[startRow] && removed[removed.length - 1]) lineWidgets[startRow] = removed.pop();
                removed.forEach(function(w) {
                    w && this.removeLineWidget(w);
                }, this);
                this.$updateRows();
            } else {
                var args = new Array(len);
                if (lineWidgets[startRow] && lineWidgets[startRow].column != null) {
                    if (delta.start.column > lineWidgets[startRow].column) startRow++;
                }
                args.unshift(startRow, 0);
                lineWidgets.splice.apply(lineWidgets, args);
                this.$updateRows();
            }
        };
        LineWidgets.prototype.$updateRows = function() {
            var lineWidgets = this.session.lineWidgets;
            if (!lineWidgets) return;
            var noWidgets = true;
            lineWidgets.forEach(function(w, i) {
                if (w) {
                    noWidgets = false;
                    w.row = i;
                    while(w.$oldWidget){
                        w.$oldWidget.row = i;
                        w = w.$oldWidget;
                    }
                }
            });
            if (noWidgets) this.session.lineWidgets = null;
        };
        LineWidgets.prototype.$registerLineWidget = function(w) {
            if (!this.session.lineWidgets) this.session.lineWidgets = new Array(this.session.getLength());
            var old = this.session.lineWidgets[w.row];
            if (old) {
                w.$oldWidget = old;
                if (old.el && old.el.parentNode) {
                    old.el.parentNode.removeChild(old.el);
                    old._inDocument = false;
                }
            }
            this.session.lineWidgets[w.row] = w;
            return w;
        };
        LineWidgets.prototype.addLineWidget = function(w) {
            this.$registerLineWidget(w);
            w.session = this.session;
            if (!this.editor) return w;
            var renderer = this.editor.renderer;
            if (w.html && !w.el) {
                w.el = dom.createElement("div");
                w.el.innerHTML = w.html;
            }
            if (w.text && !w.el) {
                w.el = dom.createElement("div");
                w.el.textContent = w.text;
            }
            if (w.el) {
                dom.addCssClass(w.el, "ace_lineWidgetContainer");
                if (w.className) dom.addCssClass(w.el, w.className);
                w.el.style.position = "absolute";
                w.el.style.zIndex = 5;
                renderer.container.appendChild(w.el);
                w._inDocument = true;
                if (!w.coverGutter) w.el.style.zIndex = 3;
                if (w.pixelHeight == null) w.pixelHeight = w.el.offsetHeight;
            }
            if (w.rowCount == null) w.rowCount = w.pixelHeight / renderer.layerConfig.lineHeight;
            var fold = this.session.getFoldAt(w.row, 0);
            w.$fold = fold;
            if (fold) {
                var lineWidgets = this.session.lineWidgets;
                if (w.row == fold.end.row && !lineWidgets[fold.start.row]) lineWidgets[fold.start.row] = w;
                else w.hidden = true;
            }
            this.session._emit("changeFold", {
                data: {
                    start: {
                        row: w.row
                    }
                }
            });
            this.$updateRows();
            this.renderWidgets(null, renderer);
            this.onWidgetChanged(w);
            return w;
        };
        LineWidgets.prototype.removeLineWidget = function(w) {
            w._inDocument = false;
            w.session = null;
            if (w.el && w.el.parentNode) w.el.parentNode.removeChild(w.el);
            if (w.editor && w.editor.destroy) try {
                w.editor.destroy();
            } catch (e) {}
            if (this.session.lineWidgets) {
                var w1 = this.session.lineWidgets[w.row];
                if (w1 == w) {
                    this.session.lineWidgets[w.row] = w.$oldWidget;
                    if (w.$oldWidget) this.onWidgetChanged(w.$oldWidget);
                } else while(w1){
                    if (w1.$oldWidget == w) {
                        w1.$oldWidget = w.$oldWidget;
                        break;
                    }
                    w1 = w1.$oldWidget;
                }
            }
            this.session._emit("changeFold", {
                data: {
                    start: {
                        row: w.row
                    }
                }
            });
            this.$updateRows();
        };
        LineWidgets.prototype.getWidgetsAtRow = function(row) {
            var lineWidgets = this.session.lineWidgets;
            var w = lineWidgets && lineWidgets[row];
            var list = [];
            while(w){
                list.push(w);
                w = w.$oldWidget;
            }
            return list;
        };
        LineWidgets.prototype.onWidgetChanged = function(w) {
            this.session._changedWidgets.push(w);
            this.editor && this.editor.renderer.updateFull();
        };
        LineWidgets.prototype.measureWidgets = function(e, renderer) {
            var changedWidgets = this.session._changedWidgets;
            var config = renderer.layerConfig;
            if (!changedWidgets || !changedWidgets.length) return;
            var min = Infinity;
            for(var i = 0; i < changedWidgets.length; i++){
                var w = changedWidgets[i];
                if (!w || !w.el) continue;
                if (w.session != this.session) continue;
                if (!w._inDocument) {
                    if (this.session.lineWidgets[w.row] != w) continue;
                    w._inDocument = true;
                    renderer.container.appendChild(w.el);
                }
                w.h = w.el.offsetHeight;
                if (!w.fixedWidth) {
                    w.w = w.el.offsetWidth;
                    w.screenWidth = Math.ceil(w.w / config.characterWidth);
                }
                var rowCount = w.h / config.lineHeight;
                if (w.coverLine) {
                    rowCount -= this.session.getRowLineCount(w.row);
                    if (rowCount < 0) rowCount = 0;
                }
                if (w.rowCount != rowCount) {
                    w.rowCount = rowCount;
                    if (w.row < min) min = w.row;
                }
            }
            if (min != Infinity) {
                this.session._emit("changeFold", {
                    data: {
                        start: {
                            row: min
                        }
                    }
                });
                this.session.lineWidgetWidth = null;
            }
            this.session._changedWidgets = [];
        };
        LineWidgets.prototype.renderWidgets = function(e, renderer) {
            var config = renderer.layerConfig;
            var lineWidgets = this.session.lineWidgets;
            if (!lineWidgets) return;
            var first = Math.min(this.firstRow, config.firstRow);
            var last = Math.max(this.lastRow, config.lastRow, lineWidgets.length);
            while(first > 0 && !lineWidgets[first])first--;
            this.firstRow = config.firstRow;
            this.lastRow = config.lastRow;
            renderer.$cursorLayer.config = config;
            for(var i = first; i <= last; i++){
                var w = lineWidgets[i];
                if (!w || !w.el) continue;
                if (w.hidden) {
                    w.el.style.top = -100 - (w.pixelHeight || 0) + "px";
                    continue;
                }
                if (!w._inDocument) {
                    w._inDocument = true;
                    renderer.container.appendChild(w.el);
                }
                var top = renderer.$cursorLayer.getPixelPosition({
                    row: i,
                    column: 0
                }, true).top;
                if (!w.coverLine) top += config.lineHeight * this.session.getRowLineCount(w.row);
                w.el.style.top = top - config.offset + "px";
                var left = w.coverGutter ? 0 : renderer.gutterWidth;
                if (!w.fixedWidth) left -= renderer.scrollLeft;
                w.el.style.left = left + "px";
                if (w.fullWidth && w.screenWidth) w.el.style.minWidth = config.width + 2 * config.padding + "px";
                if (w.fixedWidth) w.el.style.right = renderer.scrollBar.getWidth() + "px";
                else w.el.style.right = "";
            }
        };
        return LineWidgets;
    }();
    exports.LineWidgets = LineWidgets;
});
ace.define("ace/keyboard/gutter_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/keys",
    "ace/mouse/default_gutter_handler"
], function(require, exports, module1) {
    "use strict";
    var keys = require("../lib/keys");
    var GutterTooltip = require("../mouse/default_gutter_handler").GutterTooltip;
    var GutterKeyboardHandler = /** @class */ function() {
        function GutterKeyboardHandler(editor) {
            this.editor = editor;
            this.gutterLayer = editor.renderer.$gutterLayer;
            this.element = editor.renderer.$gutter;
            this.lines = editor.renderer.$gutterLayer.$lines;
            this.activeRowIndex = null;
            this.activeLane = null;
            this.annotationTooltip = new GutterTooltip(this.editor);
        }
        GutterKeyboardHandler.prototype.addListener = function() {
            this.element.addEventListener("keydown", this.$onGutterKeyDown.bind(this));
            this.element.addEventListener("focusout", this.$blurGutter.bind(this));
            this.editor.on("mousewheel", this.$blurGutter.bind(this));
        };
        GutterKeyboardHandler.prototype.removeListener = function() {
            this.element.removeEventListener("keydown", this.$onGutterKeyDown.bind(this));
            this.element.removeEventListener("focusout", this.$blurGutter.bind(this));
            this.editor.off("mousewheel", this.$blurGutter.bind(this));
        };
        GutterKeyboardHandler.prototype.$onGutterKeyDown = function(e) {
            if (this.annotationTooltip.isOpen) {
                e.preventDefault();
                if (e.keyCode === keys["escape"]) this.annotationTooltip.hideTooltip();
                return;
            }
            if (e.target === this.element) {
                if (e.keyCode != keys["enter"]) return;
                e.preventDefault();
                var row = this.editor.getCursorPosition().row;
                if (!this.editor.isRowVisible(row)) this.editor.scrollToLine(row, true, true);
                setTimeout((function() {
                    var index = this.$rowToRowIndex(this.gutterLayer.$cursorCell.row);
                    var nearestFoldIndex = this.$findNearestFoldWidget(index);
                    var nearestAnnotationIndex = this.$findNearestAnnotation(index);
                    if (nearestFoldIndex === null && nearestAnnotationIndex === null) return;
                    if (nearestFoldIndex === null && nearestAnnotationIndex !== null) {
                        this.activeRowIndex = nearestAnnotationIndex;
                        this.activeLane = "annotation";
                        this.$focusAnnotation(this.activeRowIndex);
                        return;
                    }
                    if (nearestFoldIndex !== null && nearestAnnotationIndex === null) {
                        this.activeRowIndex = nearestFoldIndex;
                        this.activeLane = "fold";
                        this.$focusFoldWidget(this.activeRowIndex);
                        return;
                    }
                    if (Math.abs(nearestAnnotationIndex - index) < Math.abs(nearestFoldIndex - index)) {
                        this.activeRowIndex = nearestAnnotationIndex;
                        this.activeLane = "annotation";
                        this.$focusAnnotation(this.activeRowIndex);
                        return;
                    } else {
                        this.activeRowIndex = nearestFoldIndex;
                        this.activeLane = "fold";
                        this.$focusFoldWidget(this.activeRowIndex);
                        return;
                    }
                }).bind(this), 10);
                return;
            }
            this.$handleGutterKeyboardInteraction(e);
            setTimeout((function() {
                this.editor._signal("gutterkeydown", new GutterKeyboardEvent(e, this));
            }).bind(this), 10);
        };
        GutterKeyboardHandler.prototype.$handleGutterKeyboardInteraction = function(e) {
            if (e.keyCode === keys["tab"]) {
                e.preventDefault();
                return;
            }
            if (e.keyCode === keys["escape"]) {
                e.preventDefault();
                this.$blurGutter();
                this.element.focus();
                this.lane = null;
                return;
            }
            if (e.keyCode === keys["up"]) {
                e.preventDefault();
                switch(this.activeLane){
                    case "fold":
                        this.$moveFoldWidgetUp();
                        break;
                    case "annotation":
                        this.$moveAnnotationUp();
                        break;
                }
                return;
            }
            if (e.keyCode === keys["down"]) {
                e.preventDefault();
                switch(this.activeLane){
                    case "fold":
                        this.$moveFoldWidgetDown();
                        break;
                    case "annotation":
                        this.$moveAnnotationDown();
                        break;
                }
                return;
            }
            if (e.keyCode === keys["left"]) {
                e.preventDefault();
                this.$switchLane("annotation");
                return;
            }
            if (e.keyCode === keys["right"]) {
                e.preventDefault();
                this.$switchLane("fold");
                return;
            }
            if (e.keyCode === keys["enter"] || e.keyCode === keys["space"]) {
                e.preventDefault();
                switch(this.activeLane){
                    case "fold":
                        if (this.gutterLayer.session.foldWidgets[this.$rowIndexToRow(this.activeRowIndex)] === "start") {
                            var rowFoldingWidget = this.$rowIndexToRow(this.activeRowIndex);
                            this.editor.session.onFoldWidgetClick(this.$rowIndexToRow(this.activeRowIndex), e);
                            setTimeout((function() {
                                if (this.$rowIndexToRow(this.activeRowIndex) !== rowFoldingWidget) {
                                    this.$blurFoldWidget(this.activeRowIndex);
                                    this.activeRowIndex = this.$rowToRowIndex(rowFoldingWidget);
                                    this.$focusFoldWidget(this.activeRowIndex);
                                }
                            }).bind(this), 10);
                            break;
                        } else if (this.gutterLayer.session.foldWidgets[this.$rowIndexToRow(this.activeRowIndex)] === "end") break;
                        return;
                    case "annotation":
                        var gutterElement = this.lines.cells[this.activeRowIndex].element.childNodes[2];
                        var rect = gutterElement.getBoundingClientRect();
                        var style = this.annotationTooltip.getElement().style;
                        style.left = rect.right + "px";
                        style.top = rect.bottom + "px";
                        this.annotationTooltip.showTooltip(this.$rowIndexToRow(this.activeRowIndex));
                        break;
                }
                return;
            }
        };
        GutterKeyboardHandler.prototype.$blurGutter = function() {
            if (this.activeRowIndex !== null) switch(this.activeLane){
                case "fold":
                    this.$blurFoldWidget(this.activeRowIndex);
                    break;
                case "annotation":
                    this.$blurAnnotation(this.activeRowIndex);
                    break;
            }
            if (this.annotationTooltip.isOpen) this.annotationTooltip.hideTooltip();
            return;
        };
        GutterKeyboardHandler.prototype.$isFoldWidgetVisible = function(index) {
            var isRowFullyVisible = this.editor.isRowFullyVisible(this.$rowIndexToRow(index));
            var isIconVisible = this.$getFoldWidget(index).style.display !== "none";
            return isRowFullyVisible && isIconVisible;
        };
        GutterKeyboardHandler.prototype.$isAnnotationVisible = function(index) {
            var isRowFullyVisible = this.editor.isRowFullyVisible(this.$rowIndexToRow(index));
            var isIconVisible = this.$getAnnotation(index).style.display !== "none";
            return isRowFullyVisible && isIconVisible;
        };
        GutterKeyboardHandler.prototype.$getFoldWidget = function(index) {
            var cell = this.lines.get(index);
            var element = cell.element;
            return element.childNodes[1];
        };
        GutterKeyboardHandler.prototype.$getAnnotation = function(index) {
            var cell = this.lines.get(index);
            var element = cell.element;
            return element.childNodes[2];
        };
        GutterKeyboardHandler.prototype.$findNearestFoldWidget = function(index) {
            if (this.$isFoldWidgetVisible(index)) return index;
            var i = 0;
            while(index - i > 0 || index + i < this.lines.getLength() - 1){
                i++;
                if (index - i >= 0 && this.$isFoldWidgetVisible(index - i)) return index - i;
                if (index + i <= this.lines.getLength() - 1 && this.$isFoldWidgetVisible(index + i)) return index + i;
            }
            return null;
        };
        GutterKeyboardHandler.prototype.$findNearestAnnotation = function(index) {
            if (this.$isAnnotationVisible(index)) return index;
            var i = 0;
            while(index - i > 0 || index + i < this.lines.getLength() - 1){
                i++;
                if (index - i >= 0 && this.$isAnnotationVisible(index - i)) return index - i;
                if (index + i <= this.lines.getLength() - 1 && this.$isAnnotationVisible(index + i)) return index + i;
            }
            return null;
        };
        GutterKeyboardHandler.prototype.$focusFoldWidget = function(index) {
            if (index == null) return;
            var foldWidget = this.$getFoldWidget(index);
            foldWidget.classList.add(this.editor.renderer.keyboardFocusClassName);
            foldWidget.focus();
        };
        GutterKeyboardHandler.prototype.$focusAnnotation = function(index) {
            if (index == null) return;
            var annotation = this.$getAnnotation(index);
            annotation.classList.add(this.editor.renderer.keyboardFocusClassName);
            annotation.focus();
        };
        GutterKeyboardHandler.prototype.$blurFoldWidget = function(index) {
            var foldWidget = this.$getFoldWidget(index);
            foldWidget.classList.remove(this.editor.renderer.keyboardFocusClassName);
            foldWidget.blur();
        };
        GutterKeyboardHandler.prototype.$blurAnnotation = function(index) {
            var annotation = this.$getAnnotation(index);
            annotation.classList.remove(this.editor.renderer.keyboardFocusClassName);
            annotation.blur();
        };
        GutterKeyboardHandler.prototype.$moveFoldWidgetUp = function() {
            var index = this.activeRowIndex;
            while(index > 0){
                index--;
                if (this.$isFoldWidgetVisible(index)) {
                    this.$blurFoldWidget(this.activeRowIndex);
                    this.activeRowIndex = index;
                    this.$focusFoldWidget(this.activeRowIndex);
                    return;
                }
            }
            return;
        };
        GutterKeyboardHandler.prototype.$moveFoldWidgetDown = function() {
            var index = this.activeRowIndex;
            while(index < this.lines.getLength() - 1){
                index++;
                if (this.$isFoldWidgetVisible(index)) {
                    this.$blurFoldWidget(this.activeRowIndex);
                    this.activeRowIndex = index;
                    this.$focusFoldWidget(this.activeRowIndex);
                    return;
                }
            }
            return;
        };
        GutterKeyboardHandler.prototype.$moveAnnotationUp = function() {
            var index = this.activeRowIndex;
            while(index > 0){
                index--;
                if (this.$isAnnotationVisible(index)) {
                    this.$blurAnnotation(this.activeRowIndex);
                    this.activeRowIndex = index;
                    this.$focusAnnotation(this.activeRowIndex);
                    return;
                }
            }
            return;
        };
        GutterKeyboardHandler.prototype.$moveAnnotationDown = function() {
            var index = this.activeRowIndex;
            while(index < this.lines.getLength() - 1){
                index++;
                if (this.$isAnnotationVisible(index)) {
                    this.$blurAnnotation(this.activeRowIndex);
                    this.activeRowIndex = index;
                    this.$focusAnnotation(this.activeRowIndex);
                    return;
                }
            }
            return;
        };
        GutterKeyboardHandler.prototype.$switchLane = function(desinationLane) {
            switch(desinationLane){
                case "annotation":
                    if (this.activeLane === "annotation") break;
                    var annotationIndex = this.$findNearestAnnotation(this.activeRowIndex);
                    if (annotationIndex == null) break;
                    this.activeLane = "annotation";
                    this.$blurFoldWidget(this.activeRowIndex);
                    this.activeRowIndex = annotationIndex;
                    this.$focusAnnotation(this.activeRowIndex);
                    break;
                case "fold":
                    if (this.activeLane === "fold") break;
                    var foldWidgetIndex = this.$findNearestFoldWidget(this.activeRowIndex);
                    if (foldWidgetIndex == null) break;
                    this.activeLane = "fold";
                    this.$blurAnnotation(this.activeRowIndex);
                    this.activeRowIndex = foldWidgetIndex;
                    this.$focusFoldWidget(this.activeRowIndex);
                    break;
            }
            return;
        };
        GutterKeyboardHandler.prototype.$rowIndexToRow = function(index) {
            var cell = this.lines.get(index);
            if (cell) return cell.row;
            return null;
        };
        GutterKeyboardHandler.prototype.$rowToRowIndex = function(row) {
            for(var i = 0; i < this.lines.getLength(); i++){
                var cell = this.lines.get(i);
                if (cell.row == row) return i;
            }
            return null;
        };
        return GutterKeyboardHandler;
    }();
    exports.GutterKeyboardHandler = GutterKeyboardHandler;
    var GutterKeyboardEvent = /** @class */ function() {
        function GutterKeyboardEvent(domEvent, gutterKeyboardHandler) {
            this.gutterKeyboardHandler = gutterKeyboardHandler;
            this.domEvent = domEvent;
        }
        GutterKeyboardEvent.prototype.getKey = function() {
            return keys.keyCodeToString(this.domEvent.keyCode);
        };
        GutterKeyboardEvent.prototype.getRow = function() {
            return this.gutterKeyboardHandler.$rowIndexToRow(this.gutterKeyboardHandler.activeRowIndex);
        };
        GutterKeyboardEvent.prototype.isInAnnotationLane = function() {
            return this.gutterKeyboardHandler.activeLane === "annotation";
        };
        GutterKeyboardEvent.prototype.isInFoldLane = function() {
            return this.gutterKeyboardHandler.activeLane === "fold";
        };
        return GutterKeyboardEvent;
    }();
    exports.GutterKeyboardEvent = GutterKeyboardEvent;
});
ace.define("ace/editor", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/lib/useragent",
    "ace/keyboard/textinput",
    "ace/mouse/mouse_handler",
    "ace/mouse/fold_handler",
    "ace/keyboard/keybinding",
    "ace/edit_session",
    "ace/search",
    "ace/range",
    "ace/lib/event_emitter",
    "ace/commands/command_manager",
    "ace/commands/default_commands",
    "ace/config",
    "ace/token_iterator",
    "ace/line_widgets",
    "ace/keyboard/gutter_handler",
    "ace/config",
    "ace/clipboard",
    "ace/lib/keys"
], function(require, exports, module1) {
    "use strict";
    var __values = this && this.__values || function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function() {
                if (o && i >= o.length) o = void 0;
                return {
                    value: o && o[i++],
                    done: !o
                };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    var oop = require("./lib/oop");
    var dom = require("./lib/dom");
    var lang = require("./lib/lang");
    var useragent = require("./lib/useragent");
    var TextInput = require("./keyboard/textinput").TextInput;
    var MouseHandler = require("./mouse/mouse_handler").MouseHandler;
    var FoldHandler = require("./mouse/fold_handler").FoldHandler;
    var KeyBinding = require("./keyboard/keybinding").KeyBinding;
    var EditSession = require("./edit_session").EditSession;
    var Search = require("./search").Search;
    var Range = require("./range").Range;
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var CommandManager = require("./commands/command_manager").CommandManager;
    var defaultCommands = require("./commands/default_commands").commands;
    var config = require("./config");
    var TokenIterator = require("./token_iterator").TokenIterator;
    var LineWidgets = require("./line_widgets").LineWidgets;
    var GutterKeyboardHandler = require("./keyboard/gutter_handler").GutterKeyboardHandler;
    var nls = require("./config").nls;
    var clipboard = require("./clipboard");
    var keys = require("./lib/keys");
    var Editor = /** @class */ function() {
        function Editor(renderer, session, options) {
            this.$toDestroy = [];
            var container = renderer.getContainerElement();
            this.container = container;
            this.renderer = renderer;
            this.id = "editor" + ++Editor.$uid;
            this.commands = new CommandManager(useragent.isMac ? "mac" : "win", defaultCommands);
            if (typeof document == "object") {
                this.textInput = new TextInput(renderer.getTextAreaContainer(), this);
                this.renderer.textarea = this.textInput.getElement();
                this.$mouseHandler = new MouseHandler(this);
                new FoldHandler(this);
            }
            this.keyBinding = new KeyBinding(this);
            this.$search = new Search().set({
                wrap: true
            });
            this.$historyTracker = this.$historyTracker.bind(this);
            this.commands.on("exec", this.$historyTracker);
            this.$initOperationListeners();
            this._$emitInputEvent = lang.delayedCall((function() {
                this._signal("input", {});
                if (this.session && !this.session.destroyed) this.session.bgTokenizer.scheduleStart();
            }).bind(this));
            this.on("change", function(_, _self) {
                _self._$emitInputEvent.schedule(31);
            });
            this.setSession(session || options && options.session || new EditSession(""));
            config.resetOptions(this);
            if (options) this.setOptions(options);
            config._signal("editor", this);
        }
        Editor.prototype.$initOperationListeners = function() {
            this.commands.on("exec", this.startOperation.bind(this), true);
            this.commands.on("afterExec", this.endOperation.bind(this), true);
            this.$opResetTimer = lang.delayedCall(this.endOperation.bind(this, true));
            this.on("change", (function() {
                if (!this.curOp) {
                    this.startOperation();
                    this.curOp.selectionBefore = this.$lastSel;
                }
                this.curOp.docChanged = true;
            }).bind(this), true);
            this.on("changeSelection", (function() {
                if (!this.curOp) {
                    this.startOperation();
                    this.curOp.selectionBefore = this.$lastSel;
                }
                this.curOp.selectionChanged = true;
            }).bind(this), true);
        };
        Editor.prototype.startOperation = function(commandEvent) {
            if (this.curOp) {
                if (!commandEvent || this.curOp.command) return;
                this.prevOp = this.curOp;
            }
            if (!commandEvent) {
                this.previousCommand = null;
                commandEvent = {};
            }
            this.$opResetTimer.schedule();
            this.curOp = this.session.curOp = {
                command: commandEvent.command || {},
                args: commandEvent.args,
                scrollTop: this.renderer.scrollTop
            };
            this.curOp.selectionBefore = this.selection.toJSON();
        };
        Editor.prototype.endOperation = function(e) {
            if (this.curOp && this.session) {
                if (e && e.returnValue === false || !this.session) return this.curOp = null;
                if (e == true && this.curOp.command && this.curOp.command.name == "mouse") return;
                this._signal("beforeEndOperation");
                if (!this.curOp) return;
                var command = this.curOp.command;
                var scrollIntoView = command && command.scrollIntoView;
                if (scrollIntoView) {
                    switch(scrollIntoView){
                        case "center-animate":
                            scrollIntoView = "animate";
                        case "center":
                            this.renderer.scrollCursorIntoView(null, 0.5);
                            break;
                        case "animate":
                        case "cursor":
                            this.renderer.scrollCursorIntoView();
                            break;
                        case "selectionPart":
                            var range = this.selection.getRange();
                            var config = this.renderer.layerConfig;
                            if (range.start.row >= config.lastRow || range.end.row <= config.firstRow) this.renderer.scrollSelectionIntoView(this.selection.anchor, this.selection.lead);
                            break;
                        default:
                            break;
                    }
                    if (scrollIntoView == "animate") this.renderer.animateScrolling(this.curOp.scrollTop);
                }
                var sel = this.selection.toJSON();
                this.curOp.selectionAfter = sel;
                this.$lastSel = this.selection.toJSON();
                this.session.getUndoManager().addSelection(sel);
                this.prevOp = this.curOp;
                this.curOp = null;
            }
        };
        Editor.prototype.$historyTracker = function(e) {
            if (!this.$mergeUndoDeltas) return;
            var prev = this.prevOp;
            var mergeableCommands = this.$mergeableCommands;
            var shouldMerge = prev.command && e.command.name == prev.command.name;
            if (e.command.name == "insertstring") {
                var text = e.args;
                if (this.mergeNextCommand === undefined) this.mergeNextCommand = true;
                shouldMerge = shouldMerge && this.mergeNextCommand // previous command allows to coalesce with
                 && (!/\s/.test(text) || /\s/.test(prev.args)); // previous insertion was of same type
                this.mergeNextCommand = true;
            } else shouldMerge = shouldMerge && mergeableCommands.indexOf(e.command.name) !== -1; // the command is mergeable
            if (this.$mergeUndoDeltas != "always" && Date.now() - this.sequenceStartTime > 2000) shouldMerge = false; // the sequence is too long
            if (shouldMerge) this.session.mergeUndoDeltas = true;
            else if (mergeableCommands.indexOf(e.command.name) !== -1) this.sequenceStartTime = Date.now();
        };
        Editor.prototype.setKeyboardHandler = function(keyboardHandler, cb) {
            if (keyboardHandler && typeof keyboardHandler === "string" && keyboardHandler != "ace") {
                this.$keybindingId = keyboardHandler;
                var _self = this;
                config.loadModule([
                    "keybinding",
                    keyboardHandler
                ], function(module1) {
                    if (_self.$keybindingId == keyboardHandler) _self.keyBinding.setKeyboardHandler(module1 && module1.handler);
                    cb && cb();
                });
            } else {
                this.$keybindingId = null;
                this.keyBinding.setKeyboardHandler(keyboardHandler);
                cb && cb();
            }
        };
        Editor.prototype.getKeyboardHandler = function() {
            return this.keyBinding.getKeyboardHandler();
        };
        Editor.prototype.setSession = function(session) {
            if (this.session == session) return;
            if (this.curOp) this.endOperation();
            this.curOp = {};
            var oldSession = this.session;
            if (oldSession) {
                this.session.off("change", this.$onDocumentChange);
                this.session.off("changeMode", this.$onChangeMode);
                this.session.off("tokenizerUpdate", this.$onTokenizerUpdate);
                this.session.off("changeTabSize", this.$onChangeTabSize);
                this.session.off("changeWrapLimit", this.$onChangeWrapLimit);
                this.session.off("changeWrapMode", this.$onChangeWrapMode);
                this.session.off("changeFold", this.$onChangeFold);
                this.session.off("changeFrontMarker", this.$onChangeFrontMarker);
                this.session.off("changeBackMarker", this.$onChangeBackMarker);
                this.session.off("changeBreakpoint", this.$onChangeBreakpoint);
                this.session.off("changeAnnotation", this.$onChangeAnnotation);
                this.session.off("changeOverwrite", this.$onCursorChange);
                this.session.off("changeScrollTop", this.$onScrollTopChange);
                this.session.off("changeScrollLeft", this.$onScrollLeftChange);
                var selection = this.session.getSelection();
                selection.off("changeCursor", this.$onCursorChange);
                selection.off("changeSelection", this.$onSelectionChange);
            }
            this.session = session;
            if (session) {
                this.$onDocumentChange = this.onDocumentChange.bind(this);
                session.on("change", this.$onDocumentChange);
                this.renderer.setSession(session);
                this.$onChangeMode = this.onChangeMode.bind(this);
                session.on("changeMode", this.$onChangeMode);
                this.$onTokenizerUpdate = this.onTokenizerUpdate.bind(this);
                session.on("tokenizerUpdate", this.$onTokenizerUpdate);
                this.$onChangeTabSize = this.renderer.onChangeTabSize.bind(this.renderer);
                session.on("changeTabSize", this.$onChangeTabSize);
                this.$onChangeWrapLimit = this.onChangeWrapLimit.bind(this);
                session.on("changeWrapLimit", this.$onChangeWrapLimit);
                this.$onChangeWrapMode = this.onChangeWrapMode.bind(this);
                session.on("changeWrapMode", this.$onChangeWrapMode);
                this.$onChangeFold = this.onChangeFold.bind(this);
                session.on("changeFold", this.$onChangeFold);
                this.$onChangeFrontMarker = this.onChangeFrontMarker.bind(this);
                this.session.on("changeFrontMarker", this.$onChangeFrontMarker);
                this.$onChangeBackMarker = this.onChangeBackMarker.bind(this);
                this.session.on("changeBackMarker", this.$onChangeBackMarker);
                this.$onChangeBreakpoint = this.onChangeBreakpoint.bind(this);
                this.session.on("changeBreakpoint", this.$onChangeBreakpoint);
                this.$onChangeAnnotation = this.onChangeAnnotation.bind(this);
                this.session.on("changeAnnotation", this.$onChangeAnnotation);
                this.$onCursorChange = this.onCursorChange.bind(this);
                this.session.on("changeOverwrite", this.$onCursorChange);
                this.$onScrollTopChange = this.onScrollTopChange.bind(this);
                this.session.on("changeScrollTop", this.$onScrollTopChange);
                this.$onScrollLeftChange = this.onScrollLeftChange.bind(this);
                this.session.on("changeScrollLeft", this.$onScrollLeftChange);
                this.selection = session.getSelection();
                this.selection.on("changeCursor", this.$onCursorChange);
                this.$onSelectionChange = this.onSelectionChange.bind(this);
                this.selection.on("changeSelection", this.$onSelectionChange);
                this.onChangeMode();
                this.onCursorChange();
                this.onScrollTopChange();
                this.onScrollLeftChange();
                this.onSelectionChange();
                this.onChangeFrontMarker();
                this.onChangeBackMarker();
                this.onChangeBreakpoint();
                this.onChangeAnnotation();
                this.session.getUseWrapMode() && this.renderer.adjustWrapLimit();
                this.renderer.updateFull();
            } else {
                this.selection = null;
                this.renderer.setSession(session);
            }
            this._signal("changeSession", {
                session: session,
                oldSession: oldSession
            });
            this.curOp = null;
            oldSession && oldSession._signal("changeEditor", {
                oldEditor: this
            });
            session && session._signal("changeEditor", {
                editor: this
            });
            if (session && !session.destroyed) session.bgTokenizer.scheduleStart();
        };
        Editor.prototype.getSession = function() {
            return this.session;
        };
        Editor.prototype.setValue = function(val, cursorPos) {
            this.session.doc.setValue(val);
            if (!cursorPos) this.selectAll();
            else if (cursorPos == 1) this.navigateFileEnd();
            else if (cursorPos == -1) this.navigateFileStart();
            return val;
        };
        Editor.prototype.getValue = function() {
            return this.session.getValue();
        };
        Editor.prototype.getSelection = function() {
            return this.selection;
        };
        Editor.prototype.resize = function(force) {
            this.renderer.onResize(force);
        };
        Editor.prototype.setTheme = function(theme, cb) {
            this.renderer.setTheme(theme, cb);
        };
        Editor.prototype.getTheme = function() {
            return this.renderer.getTheme();
        };
        Editor.prototype.setStyle = function(style) {
            this.renderer.setStyle(style);
        };
        Editor.prototype.unsetStyle = function(style) {
            this.renderer.unsetStyle(style);
        };
        Editor.prototype.getFontSize = function() {
            return this.getOption("fontSize") || dom.computedStyle(this.container).fontSize;
        };
        Editor.prototype.setFontSize = function(size) {
            this.setOption("fontSize", size);
        };
        Editor.prototype.$highlightBrackets = function() {
            if (this.$highlightPending) return;
            var self1 = this;
            this.$highlightPending = true;
            setTimeout(function() {
                self1.$highlightPending = false;
                var session = self1.session;
                if (!session || session.destroyed) return;
                if (session.$bracketHighlight) {
                    session.$bracketHighlight.markerIds.forEach(function(id) {
                        session.removeMarker(id);
                    });
                    session.$bracketHighlight = null;
                }
                var pos = self1.getCursorPosition();
                var handler = self1.getKeyboardHandler();
                var isBackwards = handler && handler.$getDirectionForHighlight && handler.$getDirectionForHighlight(self1);
                var ranges = session.getMatchingBracketRanges(pos, isBackwards);
                if (!ranges) {
                    var iterator = new TokenIterator(session, pos.row, pos.column);
                    var token = iterator.getCurrentToken();
                    if (token && /\b(?:tag-open|tag-name)/.test(token.type)) {
                        var tagNamesRanges = session.getMatchingTags(pos);
                        if (tagNamesRanges) ranges = [
                            tagNamesRanges.openTagName,
                            tagNamesRanges.closeTagName
                        ];
                    }
                }
                if (!ranges && session.$mode.getMatching) ranges = session.$mode.getMatching(self1.session);
                if (!ranges) {
                    if (self1.getHighlightIndentGuides()) self1.renderer.$textLayer.$highlightIndentGuide();
                    return;
                }
                var markerType = "ace_bracket";
                if (!Array.isArray(ranges)) ranges = [
                    ranges
                ];
                else if (ranges.length == 1) markerType = "ace_error_bracket";
                if (ranges.length == 2) {
                    if (Range.comparePoints(ranges[0].end, ranges[1].start) == 0) ranges = [
                        Range.fromPoints(ranges[0].start, ranges[1].end)
                    ];
                    else if (Range.comparePoints(ranges[0].start, ranges[1].end) == 0) ranges = [
                        Range.fromPoints(ranges[1].start, ranges[0].end)
                    ];
                }
                session.$bracketHighlight = {
                    ranges: ranges,
                    markerIds: ranges.map(function(range) {
                        return session.addMarker(range, markerType, "text");
                    })
                };
                if (self1.getHighlightIndentGuides()) self1.renderer.$textLayer.$highlightIndentGuide();
            }, 50);
        };
        Editor.prototype.focus = function() {
            this.textInput.focus();
        };
        Editor.prototype.isFocused = function() {
            return this.textInput.isFocused();
        };
        Editor.prototype.blur = function() {
            this.textInput.blur();
        };
        Editor.prototype.onFocus = function(e) {
            if (this.$isFocused) return;
            this.$isFocused = true;
            this.renderer.showCursor();
            this.renderer.visualizeFocus();
            this._emit("focus", e);
        };
        Editor.prototype.onBlur = function(e) {
            if (!this.$isFocused) return;
            this.$isFocused = false;
            this.renderer.hideCursor();
            this.renderer.visualizeBlur();
            this._emit("blur", e);
        };
        Editor.prototype.$cursorChange = function() {
            this.renderer.updateCursor();
            this.$highlightBrackets();
            this.$updateHighlightActiveLine();
        };
        Editor.prototype.onDocumentChange = function(delta) {
            var wrap = this.session.$useWrapMode;
            var lastRow = delta.start.row == delta.end.row ? delta.end.row : Infinity;
            this.renderer.updateLines(delta.start.row, lastRow, wrap);
            this._signal("change", delta);
            this.$cursorChange();
        };
        Editor.prototype.onTokenizerUpdate = function(e) {
            var rows = e.data;
            this.renderer.updateLines(rows.first, rows.last);
        };
        Editor.prototype.onScrollTopChange = function() {
            this.renderer.scrollToY(this.session.getScrollTop());
        };
        Editor.prototype.onScrollLeftChange = function() {
            this.renderer.scrollToX(this.session.getScrollLeft());
        };
        Editor.prototype.onCursorChange = function() {
            this.$cursorChange();
            this._signal("changeSelection");
        };
        Editor.prototype.$updateHighlightActiveLine = function() {
            var session = this.getSession();
            var highlight;
            if (this.$highlightActiveLine) {
                if (this.$selectionStyle != "line" || !this.selection.isMultiLine()) highlight = this.getCursorPosition();
                if (this.renderer.theme && this.renderer.theme.$selectionColorConflict && !this.selection.isEmpty()) highlight = false;
                if (this.renderer.$maxLines && this.session.getLength() === 1 && !(this.renderer.$minLines > 1)) highlight = false;
            }
            if (session.$highlightLineMarker && !highlight) {
                session.removeMarker(session.$highlightLineMarker.id);
                session.$highlightLineMarker = null;
            } else if (!session.$highlightLineMarker && highlight) {
                var range = new Range(highlight.row, highlight.column, highlight.row, Infinity);
                range.id = session.addMarker(range, "ace_active-line", "screenLine");
                session.$highlightLineMarker = range;
            } else if (highlight) {
                session.$highlightLineMarker.start.row = highlight.row;
                session.$highlightLineMarker.end.row = highlight.row;
                session.$highlightLineMarker.start.column = highlight.column;
                session._signal("changeBackMarker");
            }
        };
        Editor.prototype.onSelectionChange = function(e) {
            var session = this.session;
            if (session.$selectionMarker) session.removeMarker(session.$selectionMarker);
            session.$selectionMarker = null;
            if (!this.selection.isEmpty()) {
                var range = this.selection.getRange();
                var style = this.getSelectionStyle();
                session.$selectionMarker = session.addMarker(range, "ace_selection", style);
            } else this.$updateHighlightActiveLine();
            var re = this.$highlightSelectedWord && this.$getSelectionHighLightRegexp();
            this.session.highlight(re);
            this._signal("changeSelection");
        };
        Editor.prototype.$getSelectionHighLightRegexp = function() {
            var session = this.session;
            var selection = this.getSelectionRange();
            if (selection.isEmpty() || selection.isMultiLine()) return;
            var startColumn = selection.start.column;
            var endColumn = selection.end.column;
            var line = session.getLine(selection.start.row);
            var needle = line.substring(startColumn, endColumn);
            if (needle.length > 5000 || !/[\w\d]/.test(needle)) return;
            var re = this.$search.$assembleRegExp({
                wholeWord: true,
                caseSensitive: true,
                needle: needle
            });
            var wordWithBoundary = line.substring(startColumn - 1, endColumn + 1);
            if (!re.test(wordWithBoundary)) return;
            return re;
        };
        Editor.prototype.onChangeFrontMarker = function() {
            this.renderer.updateFrontMarkers();
        };
        Editor.prototype.onChangeBackMarker = function() {
            this.renderer.updateBackMarkers();
        };
        Editor.prototype.onChangeBreakpoint = function() {
            this.renderer.updateBreakpoints();
        };
        Editor.prototype.onChangeAnnotation = function() {
            this.renderer.setAnnotations(this.session.getAnnotations());
        };
        Editor.prototype.onChangeMode = function(e) {
            this.renderer.updateText();
            this._emit("changeMode", e);
        };
        Editor.prototype.onChangeWrapLimit = function() {
            this.renderer.updateFull();
        };
        Editor.prototype.onChangeWrapMode = function() {
            this.renderer.onResize(true);
        };
        Editor.prototype.onChangeFold = function() {
            this.$updateHighlightActiveLine();
            this.renderer.updateFull();
        };
        Editor.prototype.getSelectedText = function() {
            return this.session.getTextRange(this.getSelectionRange());
        };
        Editor.prototype.getCopyText = function() {
            var text = this.getSelectedText();
            var nl = this.session.doc.getNewLineCharacter();
            var copyLine = false;
            if (!text && this.$copyWithEmptySelection) {
                copyLine = true;
                var ranges = this.selection.getAllRanges();
                for(var i = 0; i < ranges.length; i++){
                    var range = ranges[i];
                    if (i && ranges[i - 1].start.row == range.start.row) continue;
                    text += this.session.getLine(range.start.row) + nl;
                }
            }
            var e = {
                text: text
            };
            this._signal("copy", e);
            clipboard.lineMode = copyLine ? e.text : false;
            return e.text;
        };
        Editor.prototype.onCopy = function() {
            this.commands.exec("copy", this);
        };
        Editor.prototype.onCut = function() {
            this.commands.exec("cut", this);
        };
        Editor.prototype.onPaste = function(text, event) {
            var e = {
                text: text,
                event: event
            };
            this.commands.exec("paste", this, e);
        };
        Editor.prototype.$handlePaste = function(e) {
            if (typeof e == "string") e = {
                text: e
            };
            this._signal("paste", e);
            var text = e.text;
            var lineMode = text === clipboard.lineMode;
            var session = this.session;
            if (!this.inMultiSelectMode || this.inVirtualSelectionMode) {
                if (lineMode) session.insert({
                    row: this.selection.lead.row,
                    column: 0
                }, text);
                else this.insert(text);
            } else if (lineMode) this.selection.rangeList.ranges.forEach(function(range) {
                session.insert({
                    row: range.start.row,
                    column: 0
                }, text);
            });
            else {
                var lines = text.split(/\r\n|\r|\n/);
                var ranges = this.selection.rangeList.ranges;
                var isFullLine = lines.length == 2 && (!lines[0] || !lines[1]);
                if (lines.length != ranges.length || isFullLine) return this.commands.exec("insertstring", this, text);
                for(var i = ranges.length; i--;){
                    var range = ranges[i];
                    if (!range.isEmpty()) session.remove(range);
                    session.insert(range.start, lines[i]);
                }
            }
        };
        Editor.prototype.execCommand = function(command, args) {
            return this.commands.exec(command, this, args);
        };
        Editor.prototype.insert = function(text, pasted) {
            var session = this.session;
            var mode = session.getMode();
            var cursor = this.getCursorPosition();
            if (this.getBehavioursEnabled() && !pasted) {
                var transform = mode.transformAction(session.getState(cursor.row), "insertion", this, session, text);
                if (transform) {
                    if (text !== transform.text) {
                        if (!this.inVirtualSelectionMode) {
                            this.session.mergeUndoDeltas = false;
                            this.mergeNextCommand = false;
                        }
                    }
                    text = transform.text;
                }
            }
            if (text == "	") text = this.session.getTabString();
            if (!this.selection.isEmpty()) {
                var range = this.getSelectionRange();
                cursor = this.session.remove(range);
                this.clearSelection();
            } else if (this.session.getOverwrite() && text.indexOf("\n") == -1) {
                var range = new Range.fromPoints(cursor, cursor);
                range.end.column += text.length;
                this.session.remove(range);
            }
            if (text == "\n" || text == "\r\n") {
                var line = session.getLine(cursor.row);
                if (cursor.column > line.search(/\S|$/)) {
                    var d = line.substr(cursor.column).search(/\S|$/);
                    session.doc.removeInLine(cursor.row, cursor.column, cursor.column + d);
                }
            }
            this.clearSelection();
            var start = cursor.column;
            var lineState = session.getState(cursor.row);
            var line = session.getLine(cursor.row);
            var shouldOutdent = mode.checkOutdent(lineState, line, text);
            session.insert(cursor, text);
            if (transform && transform.selection) {
                if (transform.selection.length == 2) this.selection.setSelectionRange(new Range(cursor.row, start + transform.selection[0], cursor.row, start + transform.selection[1]));
                else this.selection.setSelectionRange(new Range(cursor.row + transform.selection[0], transform.selection[1], cursor.row + transform.selection[2], transform.selection[3]));
            }
            if (this.$enableAutoIndent) {
                if (session.getDocument().isNewLine(text)) {
                    var lineIndent = mode.getNextLineIndent(lineState, line.slice(0, cursor.column), session.getTabString());
                    session.insert({
                        row: cursor.row + 1,
                        column: 0
                    }, lineIndent);
                }
                if (shouldOutdent) mode.autoOutdent(lineState, session, cursor.row);
            }
        };
        Editor.prototype.autoIndent = function() {
            var session = this.session;
            var mode = session.getMode();
            var startRow, endRow;
            if (this.selection.isEmpty()) {
                startRow = 0;
                endRow = session.doc.getLength() - 1;
            } else {
                var selectedRange = this.getSelectionRange();
                startRow = selectedRange.start.row;
                endRow = selectedRange.end.row;
            }
            var prevLineState = "";
            var prevLine = "";
            var lineIndent = "";
            var line, currIndent, range;
            var tab = session.getTabString();
            for(var row = startRow; row <= endRow; row++){
                if (row > 0) {
                    prevLineState = session.getState(row - 1);
                    prevLine = session.getLine(row - 1);
                    lineIndent = mode.getNextLineIndent(prevLineState, prevLine, tab);
                }
                line = session.getLine(row);
                currIndent = mode.$getIndent(line);
                if (lineIndent !== currIndent) {
                    if (currIndent.length > 0) {
                        range = new Range(row, 0, row, currIndent.length);
                        session.remove(range);
                    }
                    if (lineIndent.length > 0) session.insert({
                        row: row,
                        column: 0
                    }, lineIndent);
                }
                mode.autoOutdent(prevLineState, session, row);
            }
        };
        Editor.prototype.onTextInput = function(text, composition) {
            if (!composition) return this.keyBinding.onTextInput(text);
            this.startOperation({
                command: {
                    name: "insertstring"
                }
            });
            var applyComposition = this.applyComposition.bind(this, text, composition);
            if (this.selection.rangeCount) this.forEachSelection(applyComposition);
            else applyComposition();
            this.endOperation();
        };
        Editor.prototype.applyComposition = function(text, composition) {
            if (composition.extendLeft || composition.extendRight) {
                var r = this.selection.getRange();
                r.start.column -= composition.extendLeft;
                r.end.column += composition.extendRight;
                if (r.start.column < 0) {
                    r.start.row--;
                    r.start.column += this.session.getLine(r.start.row).length + 1;
                }
                this.selection.setRange(r);
                if (!text && !r.isEmpty()) this.remove();
            }
            if (text || !this.selection.isEmpty()) this.insert(text, true);
            if (composition.restoreStart || composition.restoreEnd) {
                var r = this.selection.getRange();
                r.start.column -= composition.restoreStart;
                r.end.column -= composition.restoreEnd;
                this.selection.setRange(r);
            }
        };
        Editor.prototype.onCommandKey = function(e, hashId, keyCode) {
            return this.keyBinding.onCommandKey(e, hashId, keyCode);
        };
        Editor.prototype.setOverwrite = function(overwrite) {
            this.session.setOverwrite(overwrite);
        };
        Editor.prototype.getOverwrite = function() {
            return this.session.getOverwrite();
        };
        Editor.prototype.toggleOverwrite = function() {
            this.session.toggleOverwrite();
        };
        Editor.prototype.setScrollSpeed = function(speed) {
            this.setOption("scrollSpeed", speed);
        };
        Editor.prototype.getScrollSpeed = function() {
            return this.getOption("scrollSpeed");
        };
        Editor.prototype.setDragDelay = function(dragDelay) {
            this.setOption("dragDelay", dragDelay);
        };
        Editor.prototype.getDragDelay = function() {
            return this.getOption("dragDelay");
        };
        Editor.prototype.setSelectionStyle = function(val) {
            this.setOption("selectionStyle", val);
        };
        Editor.prototype.getSelectionStyle = function() {
            return this.getOption("selectionStyle");
        };
        Editor.prototype.setHighlightActiveLine = function(shouldHighlight) {
            this.setOption("highlightActiveLine", shouldHighlight);
        };
        Editor.prototype.getHighlightActiveLine = function() {
            return this.getOption("highlightActiveLine");
        };
        Editor.prototype.setHighlightGutterLine = function(shouldHighlight) {
            this.setOption("highlightGutterLine", shouldHighlight);
        };
        Editor.prototype.getHighlightGutterLine = function() {
            return this.getOption("highlightGutterLine");
        };
        Editor.prototype.setHighlightSelectedWord = function(shouldHighlight) {
            this.setOption("highlightSelectedWord", shouldHighlight);
        };
        Editor.prototype.getHighlightSelectedWord = function() {
            return this.$highlightSelectedWord;
        };
        Editor.prototype.setAnimatedScroll = function(shouldAnimate) {
            this.renderer.setAnimatedScroll(shouldAnimate);
        };
        Editor.prototype.getAnimatedScroll = function() {
            return this.renderer.getAnimatedScroll();
        };
        Editor.prototype.setShowInvisibles = function(showInvisibles) {
            this.renderer.setShowInvisibles(showInvisibles);
        };
        Editor.prototype.getShowInvisibles = function() {
            return this.renderer.getShowInvisibles();
        };
        Editor.prototype.setDisplayIndentGuides = function(display) {
            this.renderer.setDisplayIndentGuides(display);
        };
        Editor.prototype.getDisplayIndentGuides = function() {
            return this.renderer.getDisplayIndentGuides();
        };
        Editor.prototype.setHighlightIndentGuides = function(highlight) {
            this.renderer.setHighlightIndentGuides(highlight);
        };
        Editor.prototype.getHighlightIndentGuides = function() {
            return this.renderer.getHighlightIndentGuides();
        };
        Editor.prototype.setShowPrintMargin = function(showPrintMargin) {
            this.renderer.setShowPrintMargin(showPrintMargin);
        };
        Editor.prototype.getShowPrintMargin = function() {
            return this.renderer.getShowPrintMargin();
        };
        Editor.prototype.setPrintMarginColumn = function(showPrintMargin) {
            this.renderer.setPrintMarginColumn(showPrintMargin);
        };
        Editor.prototype.getPrintMarginColumn = function() {
            return this.renderer.getPrintMarginColumn();
        };
        Editor.prototype.setReadOnly = function(readOnly) {
            this.setOption("readOnly", readOnly);
        };
        Editor.prototype.getReadOnly = function() {
            return this.getOption("readOnly");
        };
        Editor.prototype.setBehavioursEnabled = function(enabled) {
            this.setOption("behavioursEnabled", enabled);
        };
        Editor.prototype.getBehavioursEnabled = function() {
            return this.getOption("behavioursEnabled");
        };
        Editor.prototype.setWrapBehavioursEnabled = function(enabled) {
            this.setOption("wrapBehavioursEnabled", enabled);
        };
        Editor.prototype.getWrapBehavioursEnabled = function() {
            return this.getOption("wrapBehavioursEnabled");
        };
        Editor.prototype.setShowFoldWidgets = function(show) {
            this.setOption("showFoldWidgets", show);
        };
        Editor.prototype.getShowFoldWidgets = function() {
            return this.getOption("showFoldWidgets");
        };
        Editor.prototype.setFadeFoldWidgets = function(fade) {
            this.setOption("fadeFoldWidgets", fade);
        };
        Editor.prototype.getFadeFoldWidgets = function() {
            return this.getOption("fadeFoldWidgets");
        };
        Editor.prototype.remove = function(dir) {
            if (this.selection.isEmpty()) {
                if (dir == "left") this.selection.selectLeft();
                else this.selection.selectRight();
            }
            var range = this.getSelectionRange();
            if (this.getBehavioursEnabled()) {
                var session = this.session;
                var state = session.getState(range.start.row);
                var new_range = session.getMode().transformAction(state, "deletion", this, session, range);
                if (range.end.column === 0) {
                    var text = session.getTextRange(range);
                    if (text[text.length - 1] == "\n") {
                        var line = session.getLine(range.end.row);
                        if (/^\s+$/.test(line)) range.end.column = line.length;
                    }
                }
                if (new_range) range = new_range;
            }
            this.session.remove(range);
            this.clearSelection();
        };
        Editor.prototype.removeWordRight = function() {
            if (this.selection.isEmpty()) this.selection.selectWordRight();
            this.session.remove(this.getSelectionRange());
            this.clearSelection();
        };
        Editor.prototype.removeWordLeft = function() {
            if (this.selection.isEmpty()) this.selection.selectWordLeft();
            this.session.remove(this.getSelectionRange());
            this.clearSelection();
        };
        Editor.prototype.removeToLineStart = function() {
            if (this.selection.isEmpty()) this.selection.selectLineStart();
            if (this.selection.isEmpty()) this.selection.selectLeft();
            this.session.remove(this.getSelectionRange());
            this.clearSelection();
        };
        Editor.prototype.removeToLineEnd = function() {
            if (this.selection.isEmpty()) this.selection.selectLineEnd();
            var range = this.getSelectionRange();
            if (range.start.column == range.end.column && range.start.row == range.end.row) {
                range.end.column = 0;
                range.end.row++;
            }
            this.session.remove(range);
            this.clearSelection();
        };
        Editor.prototype.splitLine = function() {
            if (!this.selection.isEmpty()) {
                this.session.remove(this.getSelectionRange());
                this.clearSelection();
            }
            var cursor = this.getCursorPosition();
            this.insert("\n");
            this.moveCursorToPosition(cursor);
        };
        Editor.prototype.setGhostText = function(text, position) {
            if (!this.session.widgetManager) {
                this.session.widgetManager = new LineWidgets(this.session);
                this.session.widgetManager.attach(this);
            }
            this.renderer.setGhostText(text, position);
        };
        Editor.prototype.removeGhostText = function() {
            if (!this.session.widgetManager) return;
            this.renderer.removeGhostText();
        };
        Editor.prototype.transposeLetters = function() {
            if (!this.selection.isEmpty()) return;
            var cursor = this.getCursorPosition();
            var column = cursor.column;
            if (column === 0) return;
            var line = this.session.getLine(cursor.row);
            var swap, range;
            if (column < line.length) {
                swap = line.charAt(column) + line.charAt(column - 1);
                range = new Range(cursor.row, column - 1, cursor.row, column + 1);
            } else {
                swap = line.charAt(column - 1) + line.charAt(column - 2);
                range = new Range(cursor.row, column - 2, cursor.row, column);
            }
            this.session.replace(range, swap);
            this.session.selection.moveToPosition(range.end);
        };
        Editor.prototype.toLowerCase = function() {
            var originalRange = this.getSelectionRange();
            if (this.selection.isEmpty()) this.selection.selectWord();
            var range = this.getSelectionRange();
            var text = this.session.getTextRange(range);
            this.session.replace(range, text.toLowerCase());
            this.selection.setSelectionRange(originalRange);
        };
        Editor.prototype.toUpperCase = function() {
            var originalRange = this.getSelectionRange();
            if (this.selection.isEmpty()) this.selection.selectWord();
            var range = this.getSelectionRange();
            var text = this.session.getTextRange(range);
            this.session.replace(range, text.toUpperCase());
            this.selection.setSelectionRange(originalRange);
        };
        Editor.prototype.indent = function() {
            var session = this.session;
            var range = this.getSelectionRange();
            if (range.start.row < range.end.row) {
                var rows = this.$getSelectedRows();
                session.indentRows(rows.first, rows.last, "	");
                return;
            } else if (range.start.column < range.end.column) {
                var text = session.getTextRange(range);
                if (!/^\s+$/.test(text)) {
                    var rows = this.$getSelectedRows();
                    session.indentRows(rows.first, rows.last, "	");
                    return;
                }
            }
            var line = session.getLine(range.start.row);
            var position = range.start;
            var size = session.getTabSize();
            var column = session.documentToScreenColumn(position.row, position.column);
            if (this.session.getUseSoftTabs()) {
                var count = size - column % size;
                var indentString = lang.stringRepeat(" ", count);
            } else {
                var count = column % size;
                while(line[range.start.column - 1] == " " && count){
                    range.start.column--;
                    count--;
                }
                this.selection.setSelectionRange(range);
                indentString = "	";
            }
            return this.insert(indentString);
        };
        Editor.prototype.blockIndent = function() {
            var rows = this.$getSelectedRows();
            this.session.indentRows(rows.first, rows.last, "	");
        };
        Editor.prototype.blockOutdent = function() {
            var selection = this.session.getSelection();
            this.session.outdentRows(selection.getRange());
        };
        Editor.prototype.sortLines = function() {
            var rows = this.$getSelectedRows();
            var session = this.session;
            var lines = [];
            for(var i = rows.first; i <= rows.last; i++)lines.push(session.getLine(i));
            lines.sort(function(a, b) {
                if (a.toLowerCase() < b.toLowerCase()) return -1;
                if (a.toLowerCase() > b.toLowerCase()) return 1;
                return 0;
            });
            var deleteRange = new Range(0, 0, 0, 0);
            for(var i = rows.first; i <= rows.last; i++){
                var line = session.getLine(i);
                deleteRange.start.row = i;
                deleteRange.end.row = i;
                deleteRange.end.column = line.length;
                session.replace(deleteRange, lines[i - rows.first]);
            }
        };
        Editor.prototype.toggleCommentLines = function() {
            var state = this.session.getState(this.getCursorPosition().row);
            var rows = this.$getSelectedRows();
            this.session.getMode().toggleCommentLines(state, this.session, rows.first, rows.last);
        };
        Editor.prototype.toggleBlockComment = function() {
            var cursor = this.getCursorPosition();
            var state = this.session.getState(cursor.row);
            var range = this.getSelectionRange();
            this.session.getMode().toggleBlockComment(state, this.session, range, cursor);
        };
        Editor.prototype.getNumberAt = function(row, column) {
            var _numberRx = /[\-]?[0-9]+(?:\.[0-9]+)?/g;
            _numberRx.lastIndex = 0;
            var s = this.session.getLine(row);
            while(_numberRx.lastIndex < column){
                var m = _numberRx.exec(s);
                if (m.index <= column && m.index + m[0].length >= column) {
                    var number = {
                        value: m[0],
                        start: m.index,
                        end: m.index + m[0].length
                    };
                    return number;
                }
            }
            return null;
        };
        Editor.prototype.modifyNumber = function(amount) {
            var row = this.selection.getCursor().row;
            var column = this.selection.getCursor().column;
            var charRange = new Range(row, column - 1, row, column);
            var c = this.session.getTextRange(charRange);
            if (!isNaN(parseFloat(c)) && isFinite(c)) {
                var nr = this.getNumberAt(row, column);
                if (nr) {
                    var fp = nr.value.indexOf(".") >= 0 ? nr.start + nr.value.indexOf(".") + 1 : nr.end;
                    var decimals = nr.start + nr.value.length - fp;
                    var t = parseFloat(nr.value);
                    t *= Math.pow(10, decimals);
                    if (fp !== nr.end && column < fp) amount *= Math.pow(10, nr.end - column - 1);
                    else amount *= Math.pow(10, nr.end - column);
                    t += amount;
                    t /= Math.pow(10, decimals);
                    var nnr = t.toFixed(decimals);
                    var replaceRange = new Range(row, nr.start, row, nr.end);
                    this.session.replace(replaceRange, nnr);
                    this.moveCursorTo(row, Math.max(nr.start + 1, column + nnr.length - nr.value.length));
                }
            } else this.toggleWord();
        };
        Editor.prototype.toggleWord = function() {
            var row = this.selection.getCursor().row;
            var column = this.selection.getCursor().column;
            this.selection.selectWord();
            var currentState = this.getSelectedText();
            var currWordStart = this.selection.getWordRange().start.column;
            var wordParts = currentState.replace(/([a-z]+|[A-Z]+)(?=[A-Z_]|$)/g, "$1 ").split(/\s/);
            var delta = column - currWordStart - 1;
            if (delta < 0) delta = 0;
            var curLength = 0, itLength = 0;
            var that = this;
            if (currentState.match(/[A-Za-z0-9_]+/)) wordParts.forEach(function(item, i) {
                itLength = curLength + item.length;
                if (delta >= curLength && delta <= itLength) {
                    currentState = item;
                    that.selection.clearSelection();
                    that.moveCursorTo(row, curLength + currWordStart);
                    that.selection.selectTo(row, itLength + currWordStart);
                }
                curLength = itLength;
            });
            var wordPairs = this.$toggleWordPairs;
            var reg;
            for(var i = 0; i < wordPairs.length; i++){
                var item = wordPairs[i];
                for(var j = 0; j <= 1; j++){
                    var negate = +!j;
                    var firstCondition = currentState.match(new RegExp("^\\s?_?(" + lang.escapeRegExp(item[j]) + ")\\s?$", "i"));
                    if (firstCondition) {
                        var secondCondition = currentState.match(new RegExp("([_]|^|\\s)(" + lang.escapeRegExp(firstCondition[1]) + ")($|\\s)", "g"));
                        if (secondCondition) {
                            reg = currentState.replace(new RegExp(lang.escapeRegExp(item[j]), "i"), function(result) {
                                var res = item[negate];
                                if (result.toUpperCase() == result) res = res.toUpperCase();
                                else if (result.charAt(0).toUpperCase() == result.charAt(0)) res = res.substr(0, 0) + item[negate].charAt(0).toUpperCase() + res.substr(1);
                                return res;
                            });
                            this.insert(reg);
                            reg = "";
                        }
                    }
                }
            }
        };
        Editor.prototype.findLinkAt = function(row, column) {
            var e_1, _a;
            var line = this.session.getLine(row);
            var wordParts = line.split(/((?:https?|ftp):\/\/[\S]+)/);
            var columnPosition = column;
            if (columnPosition < 0) columnPosition = 0;
            var previousPosition = 0, currentPosition = 0, match;
            try {
                for(var wordParts_1 = __values(wordParts), wordParts_1_1 = wordParts_1.next(); !wordParts_1_1.done; wordParts_1_1 = wordParts_1.next()){
                    var item = wordParts_1_1.value;
                    currentPosition = previousPosition + item.length;
                    if (columnPosition >= previousPosition && columnPosition <= currentPosition) {
                        if (item.match(/((?:https?|ftp):\/\/[\S]+)/)) {
                            match = item.replace(/[\s:.,'";}\]]+$/, "");
                            break;
                        }
                    }
                    previousPosition = currentPosition;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (wordParts_1_1 && !wordParts_1_1.done && (_a = wordParts_1.return)) _a.call(wordParts_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return match;
        };
        Editor.prototype.openLink = function() {
            var cursor = this.selection.getCursor();
            var url = this.findLinkAt(cursor.row, cursor.column);
            if (url) window.open(url, "_blank");
            return url != null;
        };
        Editor.prototype.removeLines = function() {
            var rows = this.$getSelectedRows();
            this.session.removeFullLines(rows.first, rows.last);
            this.clearSelection();
        };
        Editor.prototype.duplicateSelection = function() {
            var sel = this.selection;
            var doc = this.session;
            var range = sel.getRange();
            var reverse = sel.isBackwards();
            if (range.isEmpty()) {
                var row = range.start.row;
                doc.duplicateLines(row, row);
            } else {
                var point = reverse ? range.start : range.end;
                var endPoint = doc.insert(point, doc.getTextRange(range), false);
                range.start = point;
                range.end = endPoint;
                sel.setSelectionRange(range, reverse);
            }
        };
        Editor.prototype.moveLinesDown = function() {
            this.$moveLines(1, false);
        };
        Editor.prototype.moveLinesUp = function() {
            this.$moveLines(-1, false);
        };
        Editor.prototype.moveText = function(range, toPosition, copy) {
            return this.session.moveText(range, toPosition, copy);
        };
        Editor.prototype.copyLinesUp = function() {
            this.$moveLines(-1, true);
        };
        Editor.prototype.copyLinesDown = function() {
            this.$moveLines(1, true);
        };
        Editor.prototype.$moveLines = function(dir, copy) {
            var rows, moved;
            var selection = this.selection;
            if (!selection.inMultiSelectMode || this.inVirtualSelectionMode) {
                var range = selection.toOrientedRange();
                rows = this.$getSelectedRows(range);
                moved = this.session.$moveLines(rows.first, rows.last, copy ? 0 : dir);
                if (copy && dir == -1) moved = 0;
                range.moveBy(moved, 0);
                selection.fromOrientedRange(range);
            } else {
                var ranges = selection.rangeList.ranges;
                selection.rangeList.detach(this.session);
                this.inVirtualSelectionMode = true;
                var diff = 0;
                var totalDiff = 0;
                var l = ranges.length;
                for(var i = 0; i < l; i++){
                    var rangeIndex = i;
                    ranges[i].moveBy(diff, 0);
                    rows = this.$getSelectedRows(ranges[i]);
                    var first = rows.first;
                    var last = rows.last;
                    while(++i < l){
                        if (totalDiff) ranges[i].moveBy(totalDiff, 0);
                        var subRows = this.$getSelectedRows(ranges[i]);
                        if (copy && subRows.first != last) break;
                        else if (!copy && subRows.first > last + 1) break;
                        last = subRows.last;
                    }
                    i--;
                    diff = this.session.$moveLines(first, last, copy ? 0 : dir);
                    if (copy && dir == -1) rangeIndex = i + 1;
                    while(rangeIndex <= i){
                        ranges[rangeIndex].moveBy(diff, 0);
                        rangeIndex++;
                    }
                    if (!copy) diff = 0;
                    totalDiff += diff;
                }
                selection.fromOrientedRange(selection.ranges[0]);
                selection.rangeList.attach(this.session);
                this.inVirtualSelectionMode = false;
            }
        };
        Editor.prototype.$getSelectedRows = function(range) {
            range = (range || this.getSelectionRange()).collapseRows();
            return {
                first: this.session.getRowFoldStart(range.start.row),
                last: this.session.getRowFoldEnd(range.end.row)
            };
        };
        Editor.prototype.onCompositionStart = function(compositionState) {
            this.renderer.showComposition(compositionState);
        };
        Editor.prototype.onCompositionUpdate = function(text) {
            this.renderer.setCompositionText(text);
        };
        Editor.prototype.onCompositionEnd = function() {
            this.renderer.hideComposition();
        };
        Editor.prototype.getFirstVisibleRow = function() {
            return this.renderer.getFirstVisibleRow();
        };
        Editor.prototype.getLastVisibleRow = function() {
            return this.renderer.getLastVisibleRow();
        };
        Editor.prototype.isRowVisible = function(row) {
            return row >= this.getFirstVisibleRow() && row <= this.getLastVisibleRow();
        };
        Editor.prototype.isRowFullyVisible = function(row) {
            return row >= this.renderer.getFirstFullyVisibleRow() && row <= this.renderer.getLastFullyVisibleRow();
        };
        Editor.prototype.$getVisibleRowCount = function() {
            return this.renderer.getScrollBottomRow() - this.renderer.getScrollTopRow() + 1;
        };
        Editor.prototype.$moveByPage = function(dir, select) {
            var renderer = this.renderer;
            var config = this.renderer.layerConfig;
            var rows = dir * Math.floor(config.height / config.lineHeight);
            if (select === true) this.selection.$moveSelection(function() {
                this.moveCursorBy(rows, 0);
            });
            else if (select === false) {
                this.selection.moveCursorBy(rows, 0);
                this.selection.clearSelection();
            }
            var scrollTop = renderer.scrollTop;
            renderer.scrollBy(0, rows * config.lineHeight);
            if (select != null) renderer.scrollCursorIntoView(null, 0.5);
            renderer.animateScrolling(scrollTop);
        };
        Editor.prototype.selectPageDown = function() {
            this.$moveByPage(1, true);
        };
        Editor.prototype.selectPageUp = function() {
            this.$moveByPage(-1, true);
        };
        Editor.prototype.gotoPageDown = function() {
            this.$moveByPage(1, false);
        };
        Editor.prototype.gotoPageUp = function() {
            this.$moveByPage(-1, false);
        };
        Editor.prototype.scrollPageDown = function() {
            this.$moveByPage(1);
        };
        Editor.prototype.scrollPageUp = function() {
            this.$moveByPage(-1);
        };
        Editor.prototype.scrollToRow = function(row) {
            this.renderer.scrollToRow(row);
        };
        Editor.prototype.scrollToLine = function(line, center, animate, callback) {
            this.renderer.scrollToLine(line, center, animate, callback);
        };
        Editor.prototype.centerSelection = function() {
            var range = this.getSelectionRange();
            var pos = {
                row: Math.floor(range.start.row + (range.end.row - range.start.row) / 2),
                column: Math.floor(range.start.column + (range.end.column - range.start.column) / 2)
            };
            this.renderer.alignCursor(pos, 0.5);
        };
        Editor.prototype.getCursorPosition = function() {
            return this.selection.getCursor();
        };
        Editor.prototype.getCursorPositionScreen = function() {
            return this.session.documentToScreenPosition(this.getCursorPosition());
        };
        Editor.prototype.getSelectionRange = function() {
            return this.selection.getRange();
        };
        Editor.prototype.selectAll = function() {
            this.selection.selectAll();
        };
        Editor.prototype.clearSelection = function() {
            this.selection.clearSelection();
        };
        Editor.prototype.moveCursorTo = function(row, column) {
            this.selection.moveCursorTo(row, column);
        };
        Editor.prototype.moveCursorToPosition = function(pos) {
            this.selection.moveCursorToPosition(pos);
        };
        Editor.prototype.jumpToMatching = function(select, expand) {
            var cursor = this.getCursorPosition();
            var iterator = new TokenIterator(this.session, cursor.row, cursor.column);
            var prevToken = iterator.getCurrentToken();
            var tokenCount = 0;
            if (prevToken && prevToken.type.indexOf("tag-name") !== -1) prevToken = iterator.stepBackward();
            var token = prevToken || iterator.stepForward();
            if (!token) return;
            var matchType;
            var found = false;
            var depth = {};
            var i = cursor.column - token.start;
            var bracketType;
            var brackets = {
                ")": "(",
                "(": "(",
                "]": "[",
                "[": "[",
                "{": "{",
                "}": "{"
            };
            do {
                if (token.value.match(/[{}()\[\]]/g)) for(; i < token.value.length && !found; i++){
                    if (!brackets[token.value[i]]) continue;
                    bracketType = brackets[token.value[i]] + "." + token.type.replace("rparen", "lparen");
                    if (isNaN(depth[bracketType])) depth[bracketType] = 0;
                    switch(token.value[i]){
                        case "(":
                        case "[":
                        case "{":
                            depth[bracketType]++;
                            break;
                        case ")":
                        case "]":
                        case "}":
                            depth[bracketType]--;
                            if (depth[bracketType] === -1) {
                                matchType = "bracket";
                                found = true;
                            }
                            break;
                    }
                }
                else if (token.type.indexOf("tag-name") !== -1) {
                    if (isNaN(depth[token.value])) depth[token.value] = 0;
                    if (prevToken.value === "<" && tokenCount > 1) depth[token.value]++;
                    else if (prevToken.value === "</") depth[token.value]--;
                    if (depth[token.value] === -1) {
                        matchType = "tag";
                        found = true;
                    }
                }
                if (!found) {
                    prevToken = token;
                    tokenCount++;
                    token = iterator.stepForward();
                    i = 0;
                }
            }while (token && !found);
            if (!matchType) return;
            var range, pos;
            if (matchType === "bracket") {
                range = this.session.getBracketRange(cursor);
                if (!range) {
                    range = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + i - 1, iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() + i - 1);
                    pos = range.start;
                    if (expand || pos.row === cursor.row && Math.abs(pos.column - cursor.column) < 2) range = this.session.getBracketRange(pos);
                }
            } else if (matchType === "tag") {
                if (!token || token.type.indexOf("tag-name") === -1) return;
                range = new Range(iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() - 2, iterator.getCurrentTokenRow(), iterator.getCurrentTokenColumn() - 2);
                if (range.compare(cursor.row, cursor.column) === 0) {
                    var tagsRanges = this.session.getMatchingTags(cursor);
                    if (tagsRanges) {
                        if (tagsRanges.openTag.contains(cursor.row, cursor.column)) {
                            range = tagsRanges.closeTag;
                            pos = range.start;
                        } else {
                            range = tagsRanges.openTag;
                            if (tagsRanges.closeTag.start.row === cursor.row && tagsRanges.closeTag.start.column === cursor.column) pos = range.end;
                            else pos = range.start;
                        }
                    }
                }
                pos = pos || range.start;
            }
            pos = range && range.cursor || pos;
            if (pos) {
                if (select) {
                    if (range && expand) this.selection.setRange(range);
                    else if (range && range.isEqual(this.getSelectionRange())) this.clearSelection();
                    else this.selection.selectTo(pos.row, pos.column);
                } else this.selection.moveTo(pos.row, pos.column);
            }
        };
        Editor.prototype.gotoLine = function(lineNumber, column, animate) {
            this.selection.clearSelection();
            this.session.unfold({
                row: lineNumber - 1,
                column: column || 0
            });
            this.exitMultiSelectMode && this.exitMultiSelectMode();
            this.moveCursorTo(lineNumber - 1, column || 0);
            if (!this.isRowFullyVisible(lineNumber - 1)) this.scrollToLine(lineNumber - 1, true, animate);
        };
        Editor.prototype.navigateTo = function(row, column) {
            this.selection.moveTo(row, column);
        };
        Editor.prototype.navigateUp = function(times) {
            if (this.selection.isMultiLine() && !this.selection.isBackwards()) {
                var selectionStart = this.selection.anchor.getPosition();
                return this.moveCursorToPosition(selectionStart);
            }
            this.selection.clearSelection();
            this.selection.moveCursorBy(-times || -1, 0);
        };
        Editor.prototype.navigateDown = function(times) {
            if (this.selection.isMultiLine() && this.selection.isBackwards()) {
                var selectionEnd = this.selection.anchor.getPosition();
                return this.moveCursorToPosition(selectionEnd);
            }
            this.selection.clearSelection();
            this.selection.moveCursorBy(times || 1, 0);
        };
        Editor.prototype.navigateLeft = function(times) {
            if (!this.selection.isEmpty()) {
                var selectionStart = this.getSelectionRange().start;
                this.moveCursorToPosition(selectionStart);
            } else {
                times = times || 1;
                while(times--)this.selection.moveCursorLeft();
            }
            this.clearSelection();
        };
        Editor.prototype.navigateRight = function(times) {
            if (!this.selection.isEmpty()) {
                var selectionEnd = this.getSelectionRange().end;
                this.moveCursorToPosition(selectionEnd);
            } else {
                times = times || 1;
                while(times--)this.selection.moveCursorRight();
            }
            this.clearSelection();
        };
        Editor.prototype.navigateLineStart = function() {
            this.selection.moveCursorLineStart();
            this.clearSelection();
        };
        Editor.prototype.navigateLineEnd = function() {
            this.selection.moveCursorLineEnd();
            this.clearSelection();
        };
        Editor.prototype.navigateFileEnd = function() {
            this.selection.moveCursorFileEnd();
            this.clearSelection();
        };
        Editor.prototype.navigateFileStart = function() {
            this.selection.moveCursorFileStart();
            this.clearSelection();
        };
        Editor.prototype.navigateWordRight = function() {
            this.selection.moveCursorWordRight();
            this.clearSelection();
        };
        Editor.prototype.navigateWordLeft = function() {
            this.selection.moveCursorWordLeft();
            this.clearSelection();
        };
        Editor.prototype.replace = function(replacement, options) {
            if (options) this.$search.set(options);
            var range = this.$search.find(this.session);
            var replaced = 0;
            if (!range) return replaced;
            if (this.$tryReplace(range, replacement)) replaced = 1;
            this.selection.setSelectionRange(range);
            this.renderer.scrollSelectionIntoView(range.start, range.end);
            return replaced;
        };
        Editor.prototype.replaceAll = function(replacement, options) {
            if (options) this.$search.set(options);
            var ranges = this.$search.findAll(this.session);
            var replaced = 0;
            if (!ranges.length) return replaced;
            var selection = this.getSelectionRange();
            this.selection.moveTo(0, 0);
            for(var i = ranges.length - 1; i >= 0; --i)if (this.$tryReplace(ranges[i], replacement)) replaced++;
            this.selection.setSelectionRange(selection);
            return replaced;
        };
        Editor.prototype.$tryReplace = function(range, replacement) {
            var input = this.session.getTextRange(range);
            replacement = this.$search.replace(input, replacement);
            if (replacement !== null) {
                range.end = this.session.replace(range, replacement);
                return range;
            } else return null;
        };
        Editor.prototype.getLastSearchOptions = function() {
            return this.$search.getOptions();
        };
        Editor.prototype.find = function(needle, options, animate) {
            if (!options) options = {};
            if (typeof needle == "string" || needle instanceof RegExp) options.needle = needle;
            else if (typeof needle == "object") oop.mixin(options, needle);
            var range = this.selection.getRange();
            if (options.needle == null) {
                needle = this.session.getTextRange(range) || this.$search.$options.needle;
                if (!needle) {
                    range = this.session.getWordRange(range.start.row, range.start.column);
                    needle = this.session.getTextRange(range);
                }
                this.$search.set({
                    needle: needle
                });
            }
            this.$search.set(options);
            if (!options.start) this.$search.set({
                start: range
            });
            var newRange = this.$search.find(this.session);
            if (options.preventScroll) return newRange;
            if (newRange) {
                this.revealRange(newRange, animate);
                return newRange;
            }
            if (options.backwards) range.start = range.end;
            else range.end = range.start;
            this.selection.setRange(range);
        };
        Editor.prototype.findNext = function(options, animate) {
            this.find({
                skipCurrent: true,
                backwards: false
            }, options, animate);
        };
        Editor.prototype.findPrevious = function(options, animate) {
            this.find(options, {
                skipCurrent: true,
                backwards: true
            }, animate);
        };
        Editor.prototype.revealRange = function(range, animate) {
            this.session.unfold(range);
            this.selection.setSelectionRange(range);
            var scrollTop = this.renderer.scrollTop;
            this.renderer.scrollSelectionIntoView(range.start, range.end, 0.5);
            if (animate !== false) this.renderer.animateScrolling(scrollTop);
        };
        Editor.prototype.undo = function() {
            this.session.getUndoManager().undo(this.session);
            this.renderer.scrollCursorIntoView(null, 0.5);
        };
        Editor.prototype.redo = function() {
            this.session.getUndoManager().redo(this.session);
            this.renderer.scrollCursorIntoView(null, 0.5);
        };
        Editor.prototype.destroy = function() {
            if (this.$toDestroy) {
                this.$toDestroy.forEach(function(el) {
                    el.destroy();
                });
                this.$toDestroy = null;
            }
            if (this.$mouseHandler) this.$mouseHandler.destroy();
            this.renderer.destroy();
            this._signal("destroy", this);
            if (this.session) this.session.destroy();
            if (this._$emitInputEvent) this._$emitInputEvent.cancel();
            this.removeAllListeners();
        };
        Editor.prototype.setAutoScrollEditorIntoView = function(enable) {
            if (!enable) return;
            var rect;
            var self1 = this;
            var shouldScroll = false;
            if (!this.$scrollAnchor) this.$scrollAnchor = document.createElement("div");
            var scrollAnchor = this.$scrollAnchor;
            scrollAnchor.style.cssText = "position:absolute";
            this.container.insertBefore(scrollAnchor, this.container.firstChild);
            var onChangeSelection = this.on("changeSelection", function() {
                shouldScroll = true;
            });
            var onBeforeRender = this.renderer.on("beforeRender", function() {
                if (shouldScroll) rect = self1.renderer.container.getBoundingClientRect();
            });
            var onAfterRender = this.renderer.on("afterRender", function() {
                if (shouldScroll && rect && (self1.isFocused() || self1.searchBox && self1.searchBox.isFocused())) {
                    var renderer = self1.renderer;
                    var pos = renderer.$cursorLayer.$pixelPos;
                    var config = renderer.layerConfig;
                    var top = pos.top - config.offset;
                    if (pos.top >= 0 && top + rect.top < 0) shouldScroll = true;
                    else if (pos.top < config.height && pos.top + rect.top + config.lineHeight > window.innerHeight) shouldScroll = false;
                    else shouldScroll = null;
                    if (shouldScroll != null) {
                        scrollAnchor.style.top = top + "px";
                        scrollAnchor.style.left = pos.left + "px";
                        scrollAnchor.style.height = config.lineHeight + "px";
                        scrollAnchor.scrollIntoView(shouldScroll);
                    }
                    shouldScroll = rect = null;
                }
            });
            this.setAutoScrollEditorIntoView = function(enable) {
                if (enable) return;
                delete this.setAutoScrollEditorIntoView;
                this.off("changeSelection", onChangeSelection);
                this.renderer.off("afterRender", onAfterRender);
                this.renderer.off("beforeRender", onBeforeRender);
            };
        };
        Editor.prototype.$resetCursorStyle = function() {
            var style = this.$cursorStyle || "ace";
            var cursorLayer = this.renderer.$cursorLayer;
            if (!cursorLayer) return;
            cursorLayer.setSmoothBlinking(/smooth/.test(style));
            cursorLayer.isBlinking = !this.$readOnly && style != "wide";
            dom.setCssClass(cursorLayer.element, "ace_slim-cursors", /slim/.test(style));
        };
        Editor.prototype.prompt = function(message, options, callback) {
            var editor = this;
            config.loadModule("ace/ext/prompt", function(module1) {
                module1.prompt(editor, message, options, callback);
            });
        };
        return Editor;
    }();
    Editor.$uid = 0;
    Editor.prototype.curOp = null;
    Editor.prototype.prevOp = {};
    Editor.prototype.$mergeableCommands = [
        "backspace",
        "del",
        "insertstring"
    ];
    Editor.prototype.$toggleWordPairs = [
        [
            "first",
            "last"
        ],
        [
            "true",
            "false"
        ],
        [
            "yes",
            "no"
        ],
        [
            "width",
            "height"
        ],
        [
            "top",
            "bottom"
        ],
        [
            "right",
            "left"
        ],
        [
            "on",
            "off"
        ],
        [
            "x",
            "y"
        ],
        [
            "get",
            "set"
        ],
        [
            "max",
            "min"
        ],
        [
            "horizontal",
            "vertical"
        ],
        [
            "show",
            "hide"
        ],
        [
            "add",
            "remove"
        ],
        [
            "up",
            "down"
        ],
        [
            "before",
            "after"
        ],
        [
            "even",
            "odd"
        ],
        [
            "in",
            "out"
        ],
        [
            "inside",
            "outside"
        ],
        [
            "next",
            "previous"
        ],
        [
            "increase",
            "decrease"
        ],
        [
            "attach",
            "detach"
        ],
        [
            "&&",
            "||"
        ],
        [
            "==",
            "!="
        ]
    ];
    oop.implement(Editor.prototype, EventEmitter);
    config.defineOptions(Editor.prototype, "editor", {
        selectionStyle: {
            set: function(style) {
                this.onSelectionChange();
                this._signal("changeSelectionStyle", {
                    data: style
                });
            },
            initialValue: "line"
        },
        highlightActiveLine: {
            set: function() {
                this.$updateHighlightActiveLine();
            },
            initialValue: true
        },
        highlightSelectedWord: {
            set: function(shouldHighlight) {
                this.$onSelectionChange();
            },
            initialValue: true
        },
        readOnly: {
            set: function(readOnly) {
                this.textInput.setReadOnly(readOnly);
                this.$resetCursorStyle();
            },
            initialValue: false
        },
        copyWithEmptySelection: {
            set: function(value) {
                this.textInput.setCopyWithEmptySelection(value);
            },
            initialValue: false
        },
        cursorStyle: {
            set: function(val) {
                this.$resetCursorStyle();
            },
            values: [
                "ace",
                "slim",
                "smooth",
                "wide"
            ],
            initialValue: "ace"
        },
        mergeUndoDeltas: {
            values: [
                false,
                true,
                "always"
            ],
            initialValue: true
        },
        behavioursEnabled: {
            initialValue: true
        },
        wrapBehavioursEnabled: {
            initialValue: true
        },
        enableAutoIndent: {
            initialValue: true
        },
        autoScrollEditorIntoView: {
            set: function(val) {
                this.setAutoScrollEditorIntoView(val);
            }
        },
        keyboardHandler: {
            set: function(val) {
                this.setKeyboardHandler(val);
            },
            get: function() {
                return this.$keybindingId;
            },
            handlesSet: true
        },
        value: {
            set: function(val) {
                this.session.setValue(val);
            },
            get: function() {
                return this.getValue();
            },
            handlesSet: true,
            hidden: true
        },
        session: {
            set: function(val) {
                this.setSession(val);
            },
            get: function() {
                return this.session;
            },
            handlesSet: true,
            hidden: true
        },
        showLineNumbers: {
            set: function(show) {
                this.renderer.$gutterLayer.setShowLineNumbers(show);
                this.renderer.$loop.schedule(this.renderer.CHANGE_GUTTER);
                if (show && this.$relativeLineNumbers) relativeNumberRenderer.attach(this);
                else relativeNumberRenderer.detach(this);
            },
            initialValue: true
        },
        relativeLineNumbers: {
            set: function(value) {
                if (this.$showLineNumbers && value) relativeNumberRenderer.attach(this);
                else relativeNumberRenderer.detach(this);
            }
        },
        placeholder: {
            set: function(message) {
                if (!this.$updatePlaceholder) {
                    this.$updatePlaceholder = (function() {
                        var hasValue = this.session && (this.renderer.$composition || this.session.getLength() > 1 || this.session.getLine(0).length > 0);
                        if (hasValue && this.renderer.placeholderNode) {
                            this.renderer.off("afterRender", this.$updatePlaceholder);
                            dom.removeCssClass(this.container, "ace_hasPlaceholder");
                            this.renderer.placeholderNode.remove();
                            this.renderer.placeholderNode = null;
                        } else if (!hasValue && !this.renderer.placeholderNode) {
                            this.renderer.on("afterRender", this.$updatePlaceholder);
                            dom.addCssClass(this.container, "ace_hasPlaceholder");
                            var el = dom.createElement("div");
                            el.className = "ace_placeholder";
                            el.textContent = this.$placeholder || "";
                            this.renderer.placeholderNode = el;
                            this.renderer.content.appendChild(this.renderer.placeholderNode);
                        } else if (!hasValue && this.renderer.placeholderNode) this.renderer.placeholderNode.textContent = this.$placeholder || "";
                    }).bind(this);
                    this.on("input", this.$updatePlaceholder);
                }
                this.$updatePlaceholder();
            }
        },
        enableKeyboardAccessibility: {
            set: function(value) {
                var blurCommand = {
                    name: "blurTextInput",
                    description: "Set focus to the editor content div to allow tabbing through the page",
                    bindKey: "Esc",
                    exec: function(editor) {
                        editor.blur();
                        editor.renderer.scroller.focus();
                    },
                    readOnly: true
                };
                var focusOnEnterKeyup = function(e) {
                    if (e.target == this.renderer.scroller && e.keyCode === keys["enter"]) {
                        e.preventDefault();
                        var row = this.getCursorPosition().row;
                        if (!this.isRowVisible(row)) this.scrollToLine(row, true, true);
                        this.focus();
                    }
                };
                var gutterKeyboardHandler;
                if (value) {
                    this.renderer.enableKeyboardAccessibility = true;
                    this.renderer.keyboardFocusClassName = "ace_keyboard-focus";
                    this.textInput.getElement().setAttribute("tabindex", -1);
                    this.textInput.setNumberOfExtraLines(useragent.isWin ? 3 : 0);
                    this.renderer.scroller.setAttribute("tabindex", 0);
                    this.renderer.scroller.setAttribute("role", "group");
                    this.renderer.scroller.setAttribute("aria-roledescription", nls("editor"));
                    this.renderer.scroller.classList.add(this.renderer.keyboardFocusClassName);
                    this.renderer.scroller.setAttribute("aria-label", nls("Editor content, press Enter to start editing, press Escape to exit"));
                    this.renderer.scroller.addEventListener("keyup", focusOnEnterKeyup.bind(this));
                    this.commands.addCommand(blurCommand);
                    this.renderer.$gutter.setAttribute("tabindex", 0);
                    this.renderer.$gutter.setAttribute("aria-hidden", false);
                    this.renderer.$gutter.setAttribute("role", "group");
                    this.renderer.$gutter.setAttribute("aria-roledescription", nls("editor"));
                    this.renderer.$gutter.setAttribute("aria-label", nls("Editor gutter, press Enter to interact with controls using arrow keys, press Escape to exit"));
                    this.renderer.$gutter.classList.add(this.renderer.keyboardFocusClassName);
                    this.renderer.content.setAttribute("aria-hidden", true);
                    if (!gutterKeyboardHandler) gutterKeyboardHandler = new GutterKeyboardHandler(this);
                    gutterKeyboardHandler.addListener();
                } else {
                    this.renderer.enableKeyboardAccessibility = false;
                    this.textInput.getElement().setAttribute("tabindex", 0);
                    this.textInput.setNumberOfExtraLines(0);
                    this.renderer.scroller.setAttribute("tabindex", -1);
                    this.renderer.scroller.removeAttribute("role");
                    this.renderer.scroller.removeAttribute("aria-roledescription");
                    this.renderer.scroller.classList.remove(this.renderer.keyboardFocusClassName);
                    this.renderer.scroller.removeAttribute("aria-label");
                    this.renderer.scroller.removeEventListener("keyup", focusOnEnterKeyup.bind(this));
                    this.commands.removeCommand(blurCommand);
                    this.renderer.content.removeAttribute("aria-hidden");
                    this.renderer.$gutter.setAttribute("tabindex", -1);
                    this.renderer.$gutter.setAttribute("aria-hidden", true);
                    this.renderer.$gutter.removeAttribute("role");
                    this.renderer.$gutter.removeAttribute("aria-roledescription");
                    this.renderer.$gutter.removeAttribute("aria-label");
                    this.renderer.$gutter.classList.remove(this.renderer.keyboardFocusClassName);
                    if (gutterKeyboardHandler) gutterKeyboardHandler.removeListener();
                }
            },
            initialValue: false
        },
        customScrollbar: "renderer",
        hScrollBarAlwaysVisible: "renderer",
        vScrollBarAlwaysVisible: "renderer",
        highlightGutterLine: "renderer",
        animatedScroll: "renderer",
        showInvisibles: "renderer",
        showPrintMargin: "renderer",
        printMarginColumn: "renderer",
        printMargin: "renderer",
        fadeFoldWidgets: "renderer",
        showFoldWidgets: "renderer",
        displayIndentGuides: "renderer",
        highlightIndentGuides: "renderer",
        showGutter: "renderer",
        fontSize: "renderer",
        fontFamily: "renderer",
        maxLines: "renderer",
        minLines: "renderer",
        scrollPastEnd: "renderer",
        fixedWidthGutter: "renderer",
        theme: "renderer",
        hasCssTransforms: "renderer",
        maxPixelHeight: "renderer",
        useTextareaForIME: "renderer",
        useResizeObserver: "renderer",
        useSvgGutterIcons: "renderer",
        showFoldedAnnotations: "renderer",
        scrollSpeed: "$mouseHandler",
        dragDelay: "$mouseHandler",
        dragEnabled: "$mouseHandler",
        focusTimeout: "$mouseHandler",
        tooltipFollowsMouse: "$mouseHandler",
        firstLineNumber: "session",
        overwrite: "session",
        newLineMode: "session",
        useWorker: "session",
        useSoftTabs: "session",
        navigateWithinSoftTabs: "session",
        tabSize: "session",
        wrap: "session",
        indentedSoftWrap: "session",
        foldStyle: "session",
        mode: "session"
    });
    var relativeNumberRenderer = {
        getText: function(session, row) {
            return (Math.abs(session.selection.lead.row - row) || row + 1 + (row < 9 ? "\xb7" : "")) + "";
        },
        getWidth: function(session, lastLineNumber, config) {
            return Math.max(lastLineNumber.toString().length, (config.lastRow + 1).toString().length, 2) * config.characterWidth;
        },
        update: function(e, editor) {
            editor.renderer.$loop.schedule(editor.renderer.CHANGE_GUTTER);
        },
        attach: function(editor) {
            editor.renderer.$gutterLayer.$renderer = this;
            editor.on("changeSelection", this.update);
            this.update(null, editor);
        },
        detach: function(editor) {
            if (editor.renderer.$gutterLayer.$renderer == this) editor.renderer.$gutterLayer.$renderer = null;
            editor.off("changeSelection", this.update);
            this.update(null, editor);
        }
    };
    exports.Editor = Editor;
});
ace.define("ace/undomanager", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var UndoManager = /** @class */ function() {
        function UndoManager() {
            this.$maxRev = 0;
            this.$fromUndo = false;
            this.$undoDepth = Infinity;
            this.reset();
        }
        UndoManager.prototype.addSession = function(session) {
            this.$session = session;
        };
        UndoManager.prototype.add = function(delta, allowMerge, session) {
            if (this.$fromUndo) return;
            if (delta == this.$lastDelta) return;
            if (!this.$keepRedoStack) this.$redoStack.length = 0;
            if (allowMerge === false || !this.lastDeltas) {
                this.lastDeltas = [];
                var undoStackLength = this.$undoStack.length;
                if (undoStackLength > this.$undoDepth - 1) this.$undoStack.splice(0, undoStackLength - this.$undoDepth + 1);
                this.$undoStack.push(this.lastDeltas);
                delta.id = this.$rev = ++this.$maxRev;
            }
            if (delta.action == "remove" || delta.action == "insert") this.$lastDelta = delta;
            this.lastDeltas.push(delta);
        };
        UndoManager.prototype.addSelection = function(selection, rev) {
            this.selections.push({
                value: selection,
                rev: rev || this.$rev
            });
        };
        UndoManager.prototype.startNewGroup = function() {
            this.lastDeltas = null;
            return this.$rev;
        };
        UndoManager.prototype.markIgnored = function(from, to) {
            if (to == null) to = this.$rev + 1;
            var stack = this.$undoStack;
            for(var i = stack.length; i--;){
                var delta = stack[i][0];
                if (delta.id <= from) break;
                if (delta.id < to) delta.ignore = true;
            }
            this.lastDeltas = null;
        };
        UndoManager.prototype.getSelection = function(rev, after) {
            var stack = this.selections;
            for(var i = stack.length; i--;){
                var selection = stack[i];
                if (selection.rev < rev) {
                    if (after) selection = stack[i + 1];
                    return selection;
                }
            }
        };
        UndoManager.prototype.getRevision = function() {
            return this.$rev;
        };
        UndoManager.prototype.getDeltas = function(from, to) {
            if (to == null) to = this.$rev + 1;
            var stack = this.$undoStack;
            var end = null, start = 0;
            for(var i = stack.length; i--;){
                var delta = stack[i][0];
                if (delta.id < to && !end) end = i + 1;
                if (delta.id <= from) {
                    start = i + 1;
                    break;
                }
            }
            return stack.slice(start, end);
        };
        UndoManager.prototype.getChangedRanges = function(from, to) {
            if (to == null) to = this.$rev + 1;
        };
        UndoManager.prototype.getChangedLines = function(from, to) {
            if (to == null) to = this.$rev + 1;
        };
        UndoManager.prototype.undo = function(session, dontSelect) {
            this.lastDeltas = null;
            var stack = this.$undoStack;
            if (!rearrangeUndoStack(stack, stack.length)) return;
            if (!session) session = this.$session;
            if (this.$redoStackBaseRev !== this.$rev && this.$redoStack.length) this.$redoStack = [];
            this.$fromUndo = true;
            var deltaSet = stack.pop();
            var undoSelectionRange = null;
            if (deltaSet) {
                undoSelectionRange = session.undoChanges(deltaSet, dontSelect);
                this.$redoStack.push(deltaSet);
                this.$syncRev();
            }
            this.$fromUndo = false;
            return undoSelectionRange;
        };
        UndoManager.prototype.redo = function(session, dontSelect) {
            this.lastDeltas = null;
            if (!session) session = this.$session;
            this.$fromUndo = true;
            if (this.$redoStackBaseRev != this.$rev) {
                var diff = this.getDeltas(this.$redoStackBaseRev, this.$rev + 1);
                rebaseRedoStack(this.$redoStack, diff);
                this.$redoStackBaseRev = this.$rev;
                this.$redoStack.forEach(function(x) {
                    x[0].id = ++this.$maxRev;
                }, this);
            }
            var deltaSet = this.$redoStack.pop();
            var redoSelectionRange = null;
            if (deltaSet) {
                redoSelectionRange = session.redoChanges(deltaSet, dontSelect);
                this.$undoStack.push(deltaSet);
                this.$syncRev();
            }
            this.$fromUndo = false;
            return redoSelectionRange;
        };
        UndoManager.prototype.$syncRev = function() {
            var stack = this.$undoStack;
            var nextDelta = stack[stack.length - 1];
            var id = nextDelta && nextDelta[0].id || 0;
            this.$redoStackBaseRev = id;
            this.$rev = id;
        };
        UndoManager.prototype.reset = function() {
            this.lastDeltas = null;
            this.$lastDelta = null;
            this.$undoStack = [];
            this.$redoStack = [];
            this.$rev = 0;
            this.mark = 0;
            this.$redoStackBaseRev = this.$rev;
            this.selections = [];
        };
        UndoManager.prototype.canUndo = function() {
            return this.$undoStack.length > 0;
        };
        UndoManager.prototype.canRedo = function() {
            return this.$redoStack.length > 0;
        };
        UndoManager.prototype.bookmark = function(rev) {
            if (rev == undefined) rev = this.$rev;
            this.mark = rev;
        };
        UndoManager.prototype.isAtBookmark = function() {
            return this.$rev === this.mark;
        };
        UndoManager.prototype.toJSON = function() {};
        UndoManager.prototype.fromJSON = function() {};
        UndoManager.prototype.$prettyPrint = function(delta) {
            if (delta) return stringifyDelta(delta);
            return stringifyDelta(this.$undoStack) + "\n---\n" + stringifyDelta(this.$redoStack);
        };
        return UndoManager;
    }();
    UndoManager.prototype.hasUndo = UndoManager.prototype.canUndo;
    UndoManager.prototype.hasRedo = UndoManager.prototype.canRedo;
    UndoManager.prototype.isClean = UndoManager.prototype.isAtBookmark;
    UndoManager.prototype.markClean = UndoManager.prototype.bookmark;
    function rearrangeUndoStack(stack, pos) {
        for(var i = pos; i--;){
            var deltaSet = stack[i];
            if (deltaSet && !deltaSet[0].ignore) {
                while(i < pos - 1){
                    var swapped = swapGroups(stack[i], stack[i + 1]);
                    stack[i] = swapped[0];
                    stack[i + 1] = swapped[1];
                    i++;
                }
                return true;
            }
        }
    }
    var Range = require("./range").Range;
    var cmp = Range.comparePoints;
    var comparePoints = Range.comparePoints;
    function $updateMarkers(delta) {
        var isInsert = delta.action == "insert";
        var start = delta.start;
        var end = delta.end;
        var rowShift = (end.row - start.row) * (isInsert ? 1 : -1);
        var colShift = (end.column - start.column) * (isInsert ? 1 : -1);
        if (isInsert) end = start;
        for(var i in this.marks){
            var point = this.marks[i];
            var cmp = comparePoints(point, start);
            if (cmp < 0) continue; // delta starts after the range
            if (cmp === 0) {
                if (isInsert) {
                    if (point.bias == 1) cmp = 1;
                    else {
                        point.bias;
                        continue;
                    }
                }
            }
            var cmp2 = isInsert ? cmp : comparePoints(point, end);
            if (cmp2 > 0) {
                point.row += rowShift;
                point.column += point.row == end.row ? colShift : 0;
                continue;
            }
            if (!isInsert && cmp2 <= 0) {
                point.row = start.row;
                point.column = start.column;
                if (cmp2 === 0) point.bias = 1;
            }
        }
    }
    function clonePos(pos) {
        return {
            row: pos.row,
            column: pos.column
        };
    }
    function cloneDelta(d) {
        return {
            start: clonePos(d.start),
            end: clonePos(d.end),
            action: d.action,
            lines: d.lines.slice()
        };
    }
    function stringifyDelta(d) {
        d = d || this;
        if (Array.isArray(d)) return d.map(stringifyDelta).join("\n");
        var type = "";
        if (d.action) {
            type = d.action == "insert" ? "+" : "-";
            type += "[" + d.lines + "]";
        } else if (d.value) {
            if (Array.isArray(d.value)) type = d.value.map(stringifyRange).join("\n");
            else type = stringifyRange(d.value);
        }
        if (d.start) type += stringifyRange(d);
        if (d.id || d.rev) type += "	(" + (d.id || d.rev) + ")";
        return type;
    }
    function stringifyRange(r) {
        return r.start.row + ":" + r.start.column + "=>" + r.end.row + ":" + r.end.column;
    }
    function swap(d1, d2) {
        var i1 = d1.action == "insert";
        var i2 = d2.action == "insert";
        if (i1 && i2) {
            if (cmp(d2.start, d1.end) >= 0) shift(d2, d1, -1);
            else if (cmp(d2.start, d1.start) <= 0) shift(d1, d2, 1);
            else return null;
        } else if (i1 && !i2) {
            if (cmp(d2.start, d1.end) >= 0) shift(d2, d1, -1);
            else if (cmp(d2.end, d1.start) <= 0) shift(d1, d2, -1);
            else return null;
        } else if (!i1 && i2) {
            if (cmp(d2.start, d1.start) >= 0) shift(d2, d1, 1);
            else if (cmp(d2.start, d1.start) <= 0) shift(d1, d2, 1);
            else return null;
        } else if (!i1 && !i2) {
            if (cmp(d2.start, d1.start) >= 0) shift(d2, d1, 1);
            else if (cmp(d2.end, d1.start) <= 0) shift(d1, d2, -1);
            else return null;
        }
        return [
            d2,
            d1
        ];
    }
    function swapGroups(ds1, ds2) {
        for(var i = ds1.length; i--;){
            for(var j = 0; j < ds2.length; j++)if (!swap(ds1[i], ds2[j])) {
                while(i < ds1.length){
                    while(j--)swap(ds2[j], ds1[i]);
                    j = ds2.length;
                    i++;
                }
                return [
                    ds1,
                    ds2
                ];
            }
        }
        ds1.selectionBefore = ds2.selectionBefore = ds1.selectionAfter = ds2.selectionAfter = null;
        return [
            ds2,
            ds1
        ];
    }
    function xform(d1, c1) {
        var i1 = d1.action == "insert";
        var i2 = c1.action == "insert";
        if (i1 && i2) {
            if (cmp(d1.start, c1.start) < 0) shift(c1, d1, 1);
            else shift(d1, c1, 1);
        } else if (i1 && !i2) {
            if (cmp(d1.start, c1.end) >= 0) shift(d1, c1, -1);
            else if (cmp(d1.start, c1.start) <= 0) shift(c1, d1, 1);
            else {
                shift(d1, Range.fromPoints(c1.start, d1.start), -1);
                shift(c1, d1, 1);
            }
        } else if (!i1 && i2) {
            if (cmp(c1.start, d1.end) >= 0) shift(c1, d1, -1);
            else if (cmp(c1.start, d1.start) <= 0) shift(d1, c1, 1);
            else {
                shift(c1, Range.fromPoints(d1.start, c1.start), -1);
                shift(d1, c1, 1);
            }
        } else if (!i1 && !i2) {
            if (cmp(c1.start, d1.end) >= 0) shift(c1, d1, -1);
            else if (cmp(c1.end, d1.start) <= 0) shift(d1, c1, -1);
            else {
                var before, after;
                if (cmp(d1.start, c1.start) < 0) {
                    before = d1;
                    d1 = splitDelta(d1, c1.start);
                }
                if (cmp(d1.end, c1.end) > 0) after = splitDelta(d1, c1.end);
                shiftPos(c1.end, d1.start, d1.end, -1);
                if (after && !before) {
                    d1.lines = after.lines;
                    d1.start = after.start;
                    d1.end = after.end;
                    after = d1;
                }
                return [
                    c1,
                    before,
                    after
                ].filter(Boolean);
            }
        }
        return [
            c1,
            d1
        ];
    }
    function shift(d1, d2, dir) {
        shiftPos(d1.start, d2.start, d2.end, dir);
        shiftPos(d1.end, d2.start, d2.end, dir);
    }
    function shiftPos(pos, start, end, dir) {
        if (pos.row == (dir == 1 ? start : end).row) pos.column += dir * (end.column - start.column);
        pos.row += dir * (end.row - start.row);
    }
    function splitDelta(c, pos) {
        var lines = c.lines;
        var end = c.end;
        c.end = clonePos(pos);
        var rowsBefore = c.end.row - c.start.row;
        var otherLines = lines.splice(rowsBefore, lines.length);
        var col = rowsBefore ? pos.column : pos.column - c.start.column;
        lines.push(otherLines[0].substring(0, col));
        otherLines[0] = otherLines[0].substr(col);
        var rest = {
            start: clonePos(pos),
            end: end,
            lines: otherLines,
            action: c.action
        };
        return rest;
    }
    function moveDeltasByOne(redoStack, d) {
        d = cloneDelta(d);
        for(var j = redoStack.length; j--;){
            var deltaSet = redoStack[j];
            for(var i = 0; i < deltaSet.length; i++){
                var x = deltaSet[i];
                var xformed = xform(x, d);
                d = xformed[0];
                if (xformed.length != 2) {
                    if (xformed[2]) {
                        deltaSet.splice(i + 1, 1, xformed[1], xformed[2]);
                        i++;
                    } else if (!xformed[1]) {
                        deltaSet.splice(i, 1);
                        i--;
                    }
                }
            }
            if (!deltaSet.length) redoStack.splice(j, 1);
        }
        return redoStack;
    }
    function rebaseRedoStack(redoStack, deltaSets) {
        for(var i = 0; i < deltaSets.length; i++){
            var deltas = deltaSets[i];
            for(var j = 0; j < deltas.length; j++)moveDeltasByOne(redoStack, deltas[j]);
        }
    }
    exports.UndoManager = UndoManager;
});
ace.define("ace/layer/lines", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var Lines = /** @class */ function() {
        function Lines(element, canvasHeight) {
            this.element = element;
            this.canvasHeight = canvasHeight || 500000;
            this.element.style.height = this.canvasHeight * 2 + "px";
            this.cells = [];
            this.cellCache = [];
            this.$offsetCoefficient = 0;
        }
        Lines.prototype.moveContainer = function(config) {
            dom.translate(this.element, 0, -(config.firstRowScreen * config.lineHeight % this.canvasHeight) - config.offset * this.$offsetCoefficient);
        };
        Lines.prototype.pageChanged = function(oldConfig, newConfig) {
            return Math.floor(oldConfig.firstRowScreen * oldConfig.lineHeight / this.canvasHeight) !== Math.floor(newConfig.firstRowScreen * newConfig.lineHeight / this.canvasHeight);
        };
        Lines.prototype.computeLineTop = function(row, config, session) {
            var screenTop = config.firstRowScreen * config.lineHeight;
            var screenPage = Math.floor(screenTop / this.canvasHeight);
            var lineTop = session.documentToScreenRow(row, 0) * config.lineHeight;
            return lineTop - screenPage * this.canvasHeight;
        };
        Lines.prototype.computeLineHeight = function(row, config, session) {
            return config.lineHeight * session.getRowLineCount(row);
        };
        Lines.prototype.getLength = function() {
            return this.cells.length;
        };
        Lines.prototype.get = function(index) {
            return this.cells[index];
        };
        Lines.prototype.shift = function() {
            this.$cacheCell(this.cells.shift());
        };
        Lines.prototype.pop = function() {
            this.$cacheCell(this.cells.pop());
        };
        Lines.prototype.push = function(cell) {
            if (Array.isArray(cell)) {
                this.cells.push.apply(this.cells, cell);
                var fragment = dom.createFragment(this.element);
                for(var i = 0; i < cell.length; i++)fragment.appendChild(cell[i].element);
                this.element.appendChild(fragment);
            } else {
                this.cells.push(cell);
                this.element.appendChild(cell.element);
            }
        };
        Lines.prototype.unshift = function(cell) {
            if (Array.isArray(cell)) {
                this.cells.unshift.apply(this.cells, cell);
                var fragment = dom.createFragment(this.element);
                for(var i = 0; i < cell.length; i++)fragment.appendChild(cell[i].element);
                if (this.element.firstChild) this.element.insertBefore(fragment, this.element.firstChild);
                else this.element.appendChild(fragment);
            } else {
                this.cells.unshift(cell);
                this.element.insertAdjacentElement("afterbegin", cell.element);
            }
        };
        Lines.prototype.last = function() {
            if (this.cells.length) return this.cells[this.cells.length - 1];
            else return null;
        };
        Lines.prototype.$cacheCell = function(cell) {
            if (!cell) return;
            cell.element.remove();
            this.cellCache.push(cell);
        };
        Lines.prototype.createCell = function(row, config, session, initElement) {
            var cell = this.cellCache.pop();
            if (!cell) {
                var element = dom.createElement("div");
                if (initElement) initElement(element);
                this.element.appendChild(element);
                cell = {
                    element: element,
                    text: "",
                    row: row
                };
            }
            cell.row = row;
            return cell;
        };
        return Lines;
    }();
    exports.Lines = Lines;
});
ace.define("ace/layer/gutter", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/lib/event_emitter",
    "ace/layer/lines",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var oop = require("../lib/oop");
    var lang = require("../lib/lang");
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var Lines = require("./lines").Lines;
    var nls = require("../config").nls;
    var Gutter = /** @class */ function() {
        function Gutter(parentEl) {
            this.element = dom.createElement("div");
            this.element.className = "ace_layer ace_gutter-layer";
            parentEl.appendChild(this.element);
            this.setShowFoldWidgets(this.$showFoldWidgets);
            this.gutterWidth = 0;
            this.$annotations = [];
            this.$updateAnnotations = this.$updateAnnotations.bind(this);
            this.$lines = new Lines(this.element);
            this.$lines.$offsetCoefficient = 1;
        }
        Gutter.prototype.setSession = function(session) {
            if (this.session) this.session.off("change", this.$updateAnnotations);
            this.session = session;
            if (session) session.on("change", this.$updateAnnotations);
        };
        Gutter.prototype.addGutterDecoration = function(row, className) {
            if (window.console) console.warn && console.warn("deprecated use session.addGutterDecoration");
            this.session.addGutterDecoration(row, className);
        };
        Gutter.prototype.removeGutterDecoration = function(row, className) {
            if (window.console) console.warn && console.warn("deprecated use session.removeGutterDecoration");
            this.session.removeGutterDecoration(row, className);
        };
        Gutter.prototype.setAnnotations = function(annotations) {
            this.$annotations = [];
            for(var i = 0; i < annotations.length; i++){
                var annotation = annotations[i];
                var row = annotation.row;
                var rowInfo = this.$annotations[row];
                if (!rowInfo) rowInfo = this.$annotations[row] = {
                    text: [],
                    type: []
                };
                var annoText = annotation.text;
                var annoType = annotation.type;
                annoText = annoText ? lang.escapeHTML(annoText) : annotation.html || "";
                if (rowInfo.text.indexOf(annoText) === -1) {
                    rowInfo.text.push(annoText);
                    rowInfo.type.push(annoType);
                }
                var className = annotation.className;
                if (className) rowInfo.className = className;
                else if (annoType == "error") rowInfo.className = " ace_error";
                else if (annoType == "warning" && rowInfo.className != " ace_error") rowInfo.className = " ace_warning";
                else if (annoType == "info" && !rowInfo.className) rowInfo.className = " ace_info";
            }
        };
        Gutter.prototype.$updateAnnotations = function(delta) {
            if (!this.$annotations.length) return;
            var firstRow = delta.start.row;
            var len = delta.end.row - firstRow;
            if (len === 0) ;
            else if (delta.action == "remove") this.$annotations.splice(firstRow, len + 1, null);
            else {
                var args = new Array(len + 1);
                args.unshift(firstRow, 1);
                this.$annotations.splice.apply(this.$annotations, args);
            }
        };
        Gutter.prototype.update = function(config) {
            this.config = config;
            var session = this.session;
            var firstRow = config.firstRow;
            var lastRow = Math.min(config.lastRow + config.gutterOffset, session.getLength() - 1);
            this.oldLastRow = lastRow;
            this.config = config;
            this.$lines.moveContainer(config);
            this.$updateCursorRow();
            var fold = session.getNextFoldLine(firstRow);
            var foldStart = fold ? fold.start.row : Infinity;
            var cell = null;
            var index = -1;
            var row = firstRow;
            while(true){
                if (row > foldStart) {
                    row = fold.end.row + 1;
                    fold = session.getNextFoldLine(row, fold);
                    foldStart = fold ? fold.start.row : Infinity;
                }
                if (row > lastRow) {
                    while(this.$lines.getLength() > index + 1)this.$lines.pop();
                    break;
                }
                cell = this.$lines.get(++index);
                if (cell) cell.row = row;
                else {
                    cell = this.$lines.createCell(row, config, this.session, onCreateCell);
                    this.$lines.push(cell);
                }
                this.$renderCell(cell, config, fold, row);
                row++;
            }
            this._signal("afterRender");
            this.$updateGutterWidth(config);
        };
        Gutter.prototype.$updateGutterWidth = function(config) {
            var session = this.session;
            var gutterRenderer = session.gutterRenderer || this.$renderer;
            var firstLineNumber = session.$firstLineNumber;
            var lastLineText = this.$lines.last() ? this.$lines.last().text : "";
            if (this.$fixedWidth || session.$useWrapMode) lastLineText = session.getLength() + firstLineNumber - 1;
            var gutterWidth = gutterRenderer ? gutterRenderer.getWidth(session, lastLineText, config) : lastLineText.toString().length * config.characterWidth;
            var padding = this.$padding || this.$computePadding();
            gutterWidth += padding.left + padding.right;
            if (gutterWidth !== this.gutterWidth && !isNaN(gutterWidth)) {
                this.gutterWidth = gutterWidth;
                this.element.parentNode.style.width = this.element.style.width = Math.ceil(this.gutterWidth) + "px";
                this._signal("changeGutterWidth", gutterWidth);
            }
        };
        Gutter.prototype.$updateCursorRow = function() {
            if (!this.$highlightGutterLine) return;
            var position = this.session.selection.getCursor();
            if (this.$cursorRow === position.row) return;
            this.$cursorRow = position.row;
        };
        Gutter.prototype.updateLineHighlight = function() {
            if (!this.$highlightGutterLine) return;
            var row = this.session.selection.cursor.row;
            this.$cursorRow = row;
            if (this.$cursorCell && this.$cursorCell.row == row) return;
            if (this.$cursorCell) this.$cursorCell.element.className = this.$cursorCell.element.className.replace("ace_gutter-active-line ", "");
            var cells = this.$lines.cells;
            this.$cursorCell = null;
            for(var i = 0; i < cells.length; i++){
                var cell = cells[i];
                if (cell.row >= this.$cursorRow) {
                    if (cell.row > this.$cursorRow) {
                        var fold = this.session.getFoldLine(this.$cursorRow);
                        if (i > 0 && fold && fold.start.row == cells[i - 1].row) cell = cells[i - 1];
                        else break;
                    }
                    cell.element.className = "ace_gutter-active-line " + cell.element.className;
                    this.$cursorCell = cell;
                    break;
                }
            }
        };
        Gutter.prototype.scrollLines = function(config) {
            var oldConfig = this.config;
            this.config = config;
            this.$updateCursorRow();
            if (this.$lines.pageChanged(oldConfig, config)) return this.update(config);
            this.$lines.moveContainer(config);
            var lastRow = Math.min(config.lastRow + config.gutterOffset, this.session.getLength() - 1);
            var oldLastRow = this.oldLastRow;
            this.oldLastRow = lastRow;
            if (!oldConfig || oldLastRow < config.firstRow) return this.update(config);
            if (lastRow < oldConfig.firstRow) return this.update(config);
            if (oldConfig.firstRow < config.firstRow) for(var row = this.session.getFoldedRowCount(oldConfig.firstRow, config.firstRow - 1); row > 0; row--)this.$lines.shift();
            if (oldLastRow > lastRow) for(var row = this.session.getFoldedRowCount(lastRow + 1, oldLastRow); row > 0; row--)this.$lines.pop();
            if (config.firstRow < oldConfig.firstRow) this.$lines.unshift(this.$renderLines(config, config.firstRow, oldConfig.firstRow - 1));
            if (lastRow > oldLastRow) this.$lines.push(this.$renderLines(config, oldLastRow + 1, lastRow));
            this.updateLineHighlight();
            this._signal("afterRender");
            this.$updateGutterWidth(config);
        };
        Gutter.prototype.$renderLines = function(config, firstRow, lastRow) {
            var fragment = [];
            var row = firstRow;
            var foldLine = this.session.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(true){
                if (row > foldStart) {
                    row = foldLine.end.row + 1;
                    foldLine = this.session.getNextFoldLine(row, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }
                if (row > lastRow) break;
                var cell = this.$lines.createCell(row, config, this.session, onCreateCell);
                this.$renderCell(cell, config, foldLine, row);
                fragment.push(cell);
                row++;
            }
            return fragment;
        };
        Gutter.prototype.$renderCell = function(cell, config, fold, row) {
            var element = cell.element;
            var session = this.session;
            var textNode = element.childNodes[0];
            var foldWidget = element.childNodes[1];
            var annotationNode = element.childNodes[2];
            var annotationIconNode = annotationNode.firstChild;
            var firstLineNumber = session.$firstLineNumber;
            var breakpoints = session.$breakpoints;
            var decorations = session.$decorations;
            var gutterRenderer = session.gutterRenderer || this.$renderer;
            var foldWidgets = this.$showFoldWidgets && session.foldWidgets;
            var foldStart = fold ? fold.start.row : Number.MAX_VALUE;
            var lineHeight = config.lineHeight + "px";
            var className = this.$useSvgGutterIcons ? "ace_gutter-cell_svg-icons " : "ace_gutter-cell ";
            var iconClassName = this.$useSvgGutterIcons ? "ace_icon_svg" : "ace_icon";
            var rowText = (gutterRenderer ? gutterRenderer.getText(session, row) : row + firstLineNumber).toString();
            if (this.$highlightGutterLine) {
                if (row == this.$cursorRow || fold && row < this.$cursorRow && row >= foldStart && this.$cursorRow <= fold.end.row) {
                    className += "ace_gutter-active-line ";
                    if (this.$cursorCell != cell) {
                        if (this.$cursorCell) this.$cursorCell.element.className = this.$cursorCell.element.className.replace("ace_gutter-active-line ", "");
                        this.$cursorCell = cell;
                    }
                }
            }
            if (breakpoints[row]) className += breakpoints[row];
            if (decorations[row]) className += decorations[row];
            if (this.$annotations[row] && row !== foldStart) className += this.$annotations[row].className;
            if (foldWidgets) {
                var c = foldWidgets[row];
                if (c == null) c = foldWidgets[row] = session.getFoldWidget(row);
            }
            if (c) {
                var foldClass = "ace_fold-widget ace_" + c;
                var isClosedFold = c == "start" && row == foldStart && row < fold.end.row;
                if (isClosedFold) {
                    foldClass += " ace_closed";
                    var foldAnnotationClass = "";
                    var annotationInFold = false;
                    for(var i = row + 1; i <= fold.end.row; i++){
                        if (!this.$annotations[i]) continue;
                        if (this.$annotations[i].className === " ace_error") {
                            annotationInFold = true;
                            foldAnnotationClass = " ace_error_fold";
                            break;
                        }
                        if (this.$annotations[i].className === " ace_warning") {
                            annotationInFold = true;
                            foldAnnotationClass = " ace_warning_fold";
                            continue;
                        }
                    }
                    className += foldAnnotationClass;
                } else foldClass += " ace_open";
                if (foldWidget.className != foldClass) foldWidget.className = foldClass;
                dom.setStyle(foldWidget.style, "height", lineHeight);
                dom.setStyle(foldWidget.style, "display", "inline-block");
                foldWidget.setAttribute("role", "button");
                foldWidget.setAttribute("tabindex", "-1");
                var foldRange = session.getFoldWidgetRange(row);
                if (foldRange) foldWidget.setAttribute("aria-label", nls("Toggle code folding, rows $0 through $1", [
                    foldRange.start.row + 1,
                    foldRange.end.row + 1
                ]));
                else if (fold) foldWidget.setAttribute("aria-label", nls("Toggle code folding, rows $0 through $1", [
                    fold.start.row + 1,
                    fold.end.row + 1
                ]));
                else foldWidget.setAttribute("aria-label", nls("Toggle code folding, row $0", [
                    row + 1
                ]));
                if (isClosedFold) {
                    foldWidget.setAttribute("aria-expanded", "false");
                    foldWidget.setAttribute("title", nls("Unfold code"));
                } else {
                    foldWidget.setAttribute("aria-expanded", "true");
                    foldWidget.setAttribute("title", nls("Fold code"));
                }
            } else if (foldWidget) {
                dom.setStyle(foldWidget.style, "display", "none");
                foldWidget.setAttribute("tabindex", "0");
                foldWidget.removeAttribute("role");
                foldWidget.removeAttribute("aria-label");
            }
            if (annotationInFold && this.$showFoldedAnnotations) {
                annotationNode.className = "ace_gutter_annotation";
                annotationIconNode.className = iconClassName;
                annotationIconNode.className += foldAnnotationClass;
                dom.setStyle(annotationIconNode.style, "height", lineHeight);
                dom.setStyle(annotationNode.style, "display", "block");
                dom.setStyle(annotationNode.style, "height", lineHeight);
                annotationNode.setAttribute("aria-label", nls("Read annotations row $0", [
                    rowText
                ]));
                annotationNode.setAttribute("tabindex", "-1");
                annotationNode.setAttribute("role", "button");
            } else if (this.$annotations[row]) {
                annotationNode.className = "ace_gutter_annotation";
                annotationIconNode.className = iconClassName;
                if (this.$useSvgGutterIcons) annotationIconNode.className += this.$annotations[row].className;
                else element.classList.add(this.$annotations[row].className.replace(" ", ""));
                dom.setStyle(annotationIconNode.style, "height", lineHeight);
                dom.setStyle(annotationNode.style, "display", "block");
                dom.setStyle(annotationNode.style, "height", lineHeight);
                annotationNode.setAttribute("aria-label", nls("Read annotations row $0", [
                    rowText
                ]));
                annotationNode.setAttribute("tabindex", "-1");
                annotationNode.setAttribute("role", "button");
            } else {
                dom.setStyle(annotationNode.style, "display", "none");
                annotationNode.removeAttribute("aria-label");
                annotationNode.removeAttribute("role");
                annotationNode.setAttribute("tabindex", "0");
            }
            if (rowText !== textNode.data) textNode.data = rowText;
            if (element.className != className) element.className = className;
            dom.setStyle(cell.element.style, "height", this.$lines.computeLineHeight(row, config, session) + "px");
            dom.setStyle(cell.element.style, "top", this.$lines.computeLineTop(row, config, session) + "px");
            cell.text = rowText;
            if (annotationNode.style.display === "none" && foldWidget.style.display === "none") cell.element.setAttribute("aria-hidden", true);
            else cell.element.setAttribute("aria-hidden", false);
            return cell;
        };
        Gutter.prototype.setHighlightGutterLine = function(highlightGutterLine) {
            this.$highlightGutterLine = highlightGutterLine;
        };
        Gutter.prototype.setShowLineNumbers = function(show) {
            this.$renderer = !show && {
                getWidth: function() {
                    return 0;
                },
                getText: function() {
                    return "";
                }
            };
        };
        Gutter.prototype.getShowLineNumbers = function() {
            return this.$showLineNumbers;
        };
        Gutter.prototype.setShowFoldWidgets = function(show) {
            if (show) dom.addCssClass(this.element, "ace_folding-enabled");
            else dom.removeCssClass(this.element, "ace_folding-enabled");
            this.$showFoldWidgets = show;
            this.$padding = null;
        };
        Gutter.prototype.getShowFoldWidgets = function() {
            return this.$showFoldWidgets;
        };
        Gutter.prototype.$computePadding = function() {
            if (!this.element.firstChild) return {
                left: 0,
                right: 0
            };
            var style = dom.computedStyle(this.element.firstChild);
            this.$padding = {};
            this.$padding.left = (parseInt(style.borderLeftWidth) || 0) + (parseInt(style.paddingLeft) || 0) + 1;
            this.$padding.right = (parseInt(style.borderRightWidth) || 0) + (parseInt(style.paddingRight) || 0);
            return this.$padding;
        };
        Gutter.prototype.getRegion = function(point) {
            var padding = this.$padding || this.$computePadding();
            var rect = this.element.getBoundingClientRect();
            if (point.x < padding.left + rect.left) return "markers";
            if (this.$showFoldWidgets && point.x > rect.right - padding.right) return "foldWidgets";
        };
        return Gutter;
    }();
    Gutter.prototype.$fixedWidth = false;
    Gutter.prototype.$highlightGutterLine = true;
    Gutter.prototype.$renderer = "";
    Gutter.prototype.$showLineNumbers = true;
    Gutter.prototype.$showFoldWidgets = true;
    oop.implement(Gutter.prototype, EventEmitter);
    function onCreateCell(element) {
        var textNode = document.createTextNode("");
        element.appendChild(textNode);
        var foldWidget = dom.createElement("span");
        element.appendChild(foldWidget);
        var annotationNode = dom.createElement("span");
        element.appendChild(annotationNode);
        var annotationIconNode = dom.createElement("span");
        annotationNode.appendChild(annotationIconNode);
        return element;
    }
    exports.Gutter = Gutter;
});
ace.define("ace/layer/marker", [
    "require",
    "exports",
    "module",
    "ace/range",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var dom = require("../lib/dom");
    var Marker = /** @class */ function() {
        function Marker(parentEl) {
            this.element = dom.createElement("div");
            this.element.className = "ace_layer ace_marker-layer";
            parentEl.appendChild(this.element);
        }
        Marker.prototype.setPadding = function(padding) {
            this.$padding = padding;
        };
        Marker.prototype.setSession = function(session) {
            this.session = session;
        };
        Marker.prototype.setMarkers = function(markers) {
            this.markers = markers;
        };
        Marker.prototype.elt = function(className, css) {
            var x = this.i != -1 && this.element.childNodes[this.i];
            if (!x) {
                x = document.createElement("div");
                this.element.appendChild(x);
                this.i = -1;
            } else this.i++;
            x.style.cssText = css;
            x.className = className;
        };
        Marker.prototype.update = function(config) {
            if (!config) return;
            this.config = config;
            this.i = 0;
            var html;
            for(var key in this.markers){
                var marker = this.markers[key];
                if (!marker.range) {
                    marker.update(html, this, this.session, config);
                    continue;
                }
                var range = marker.range.clipRows(config.firstRow, config.lastRow);
                if (range.isEmpty()) continue;
                range = range.toScreenRange(this.session);
                if (marker.renderer) {
                    var top = this.$getTop(range.start.row, config);
                    var left = this.$padding + range.start.column * config.characterWidth;
                    marker.renderer(html, range, left, top, config);
                } else if (marker.type == "fullLine") this.drawFullLineMarker(html, range, marker.clazz, config);
                else if (marker.type == "screenLine") this.drawScreenLineMarker(html, range, marker.clazz, config);
                else if (range.isMultiLine()) {
                    if (marker.type == "text") this.drawTextMarker(html, range, marker.clazz, config);
                    else this.drawMultiLineMarker(html, range, marker.clazz, config);
                } else this.drawSingleLineMarker(html, range, marker.clazz + " ace_start" + " ace_br15", config);
            }
            if (this.i != -1) while(this.i < this.element.childElementCount)this.element.removeChild(this.element.lastChild);
        };
        Marker.prototype.$getTop = function(row, layerConfig) {
            return (row - layerConfig.firstRowScreen) * layerConfig.lineHeight;
        };
        Marker.prototype.drawTextMarker = function(stringBuilder, range, clazz, layerConfig, extraStyle) {
            var session = this.session;
            var start = range.start.row;
            var end = range.end.row;
            var row = start;
            var prev = 0;
            var curr = 0;
            var next = session.getScreenLastRowColumn(row);
            var lineRange = new Range(row, range.start.column, row, curr);
            for(; row <= end; row++){
                lineRange.start.row = lineRange.end.row = row;
                lineRange.start.column = row == start ? range.start.column : session.getRowWrapIndent(row);
                lineRange.end.column = next;
                prev = curr;
                curr = next;
                next = row + 1 < end ? session.getScreenLastRowColumn(row + 1) : row == end ? 0 : range.end.column;
                this.drawSingleLineMarker(stringBuilder, lineRange, clazz + (row == start ? " ace_start" : "") + " ace_br" + getBorderClass(row == start || row == start + 1 && range.start.column, prev < curr, curr > next, row == end), layerConfig, row == end ? 0 : 1, extraStyle);
            }
        };
        Marker.prototype.drawMultiLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
            var padding = this.$padding;
            var height = config.lineHeight;
            var top = this.$getTop(range.start.row, config);
            var left = padding + range.start.column * config.characterWidth;
            extraStyle = extraStyle || "";
            if (this.session.$bidiHandler.isBidiRow(range.start.row)) {
                var range1 = range.clone();
                range1.end.row = range1.start.row;
                range1.end.column = this.session.getLine(range1.start.row).length;
                this.drawBidiSingleLineMarker(stringBuilder, range1, clazz + " ace_br1 ace_start", config, null, extraStyle);
            } else this.elt(clazz + " ace_br1 ace_start", "height:" + height + "px;" + "right:0;" + "top:" + top + "px;left:" + left + "px;" + (extraStyle || ""));
            if (this.session.$bidiHandler.isBidiRow(range.end.row)) {
                var range1 = range.clone();
                range1.start.row = range1.end.row;
                range1.start.column = 0;
                this.drawBidiSingleLineMarker(stringBuilder, range1, clazz + " ace_br12", config, null, extraStyle);
            } else {
                top = this.$getTop(range.end.row, config);
                var width = range.end.column * config.characterWidth;
                this.elt(clazz + " ace_br12", "height:" + height + "px;" + "width:" + width + "px;" + "top:" + top + "px;" + "left:" + padding + "px;" + (extraStyle || ""));
            }
            height = (range.end.row - range.start.row - 1) * config.lineHeight;
            if (height <= 0) return;
            top = this.$getTop(range.start.row + 1, config);
            var radiusClass = (range.start.column ? 1 : 0) | (range.end.column ? 0 : 8);
            this.elt(clazz + (radiusClass ? " ace_br" + radiusClass : ""), "height:" + height + "px;" + "right:0;" + "top:" + top + "px;" + "left:" + padding + "px;" + (extraStyle || ""));
        };
        Marker.prototype.drawSingleLineMarker = function(stringBuilder, range, clazz, config, extraLength, extraStyle) {
            if (this.session.$bidiHandler.isBidiRow(range.start.row)) return this.drawBidiSingleLineMarker(stringBuilder, range, clazz, config, extraLength, extraStyle);
            var height = config.lineHeight;
            var width = (range.end.column + (extraLength || 0) - range.start.column) * config.characterWidth;
            var top = this.$getTop(range.start.row, config);
            var left = this.$padding + range.start.column * config.characterWidth;
            this.elt(clazz, "height:" + height + "px;" + "width:" + width + "px;" + "top:" + top + "px;" + "left:" + left + "px;" + (extraStyle || ""));
        };
        Marker.prototype.drawBidiSingleLineMarker = function(stringBuilder, range, clazz, config, extraLength, extraStyle) {
            var height = config.lineHeight, top = this.$getTop(range.start.row, config), padding = this.$padding;
            var selections = this.session.$bidiHandler.getSelections(range.start.column, range.end.column);
            selections.forEach(function(selection) {
                this.elt(clazz, "height:" + height + "px;" + "width:" + (selection.width + (extraLength || 0)) + "px;" + "top:" + top + "px;" + "left:" + (padding + selection.left) + "px;" + (extraStyle || ""));
            }, this);
        };
        Marker.prototype.drawFullLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
            var top = this.$getTop(range.start.row, config);
            var height = config.lineHeight;
            if (range.start.row != range.end.row) height += this.$getTop(range.end.row, config) - top;
            this.elt(clazz, "height:" + height + "px;" + "top:" + top + "px;" + "left:0;right:0;" + (extraStyle || ""));
        };
        Marker.prototype.drawScreenLineMarker = function(stringBuilder, range, clazz, config, extraStyle) {
            var top = this.$getTop(range.start.row, config);
            var height = config.lineHeight;
            this.elt(clazz, "height:" + height + "px;" + "top:" + top + "px;" + "left:0;right:0;" + (extraStyle || ""));
        };
        return Marker;
    }();
    Marker.prototype.$padding = 0;
    function getBorderClass(tl, tr, br, bl) {
        return (tl ? 1 : 0) | (tr ? 2 : 0) | (br ? 4 : 0) | (bl ? 8 : 0);
    }
    exports.Marker = Marker;
});
ace.define("ace/layer/text", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/layer/lines",
    "ace/lib/event_emitter",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var dom = require("../lib/dom");
    var lang = require("../lib/lang");
    var Lines = require("./lines").Lines;
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var nls = require("../config").nls;
    var Text = /** @class */ function() {
        function Text(parentEl) {
            this.dom = dom;
            this.element = this.dom.createElement("div");
            this.element.className = "ace_layer ace_text-layer";
            parentEl.appendChild(this.element);
            this.$updateEolChar = this.$updateEolChar.bind(this);
            this.$lines = new Lines(this.element);
        }
        Text.prototype.$updateEolChar = function() {
            var doc = this.session.doc;
            var unixMode = doc.getNewLineCharacter() == "\n" && doc.getNewLineMode() != "windows";
            var EOL_CHAR = unixMode ? this.EOL_CHAR_LF : this.EOL_CHAR_CRLF;
            if (this.EOL_CHAR != EOL_CHAR) {
                this.EOL_CHAR = EOL_CHAR;
                return true;
            }
        };
        Text.prototype.setPadding = function(padding) {
            this.$padding = padding;
            this.element.style.margin = "0 " + padding + "px";
        };
        Text.prototype.getLineHeight = function() {
            return this.$fontMetrics.$characterSize.height || 0;
        };
        Text.prototype.getCharacterWidth = function() {
            return this.$fontMetrics.$characterSize.width || 0;
        };
        Text.prototype.$setFontMetrics = function(measure) {
            this.$fontMetrics = measure;
            this.$fontMetrics.on("changeCharacterSize", (function(e) {
                this._signal("changeCharacterSize", e);
            }).bind(this));
            this.$pollSizeChanges();
        };
        Text.prototype.checkForSizeChanges = function() {
            this.$fontMetrics.checkForSizeChanges();
        };
        Text.prototype.$pollSizeChanges = function() {
            return this.$pollSizeChangesTimer = this.$fontMetrics.$pollSizeChanges();
        };
        Text.prototype.setSession = function(session) {
            this.session = session;
            if (session) this.$computeTabString();
        };
        Text.prototype.setShowInvisibles = function(showInvisibles) {
            if (this.showInvisibles == showInvisibles) return false;
            this.showInvisibles = showInvisibles;
            if (typeof showInvisibles == "string") {
                this.showSpaces = /tab/i.test(showInvisibles);
                this.showTabs = /space/i.test(showInvisibles);
                this.showEOL = /eol/i.test(showInvisibles);
            } else this.showSpaces = this.showTabs = this.showEOL = showInvisibles;
            this.$computeTabString();
            return true;
        };
        Text.prototype.setDisplayIndentGuides = function(display) {
            if (this.displayIndentGuides == display) return false;
            this.displayIndentGuides = display;
            this.$computeTabString();
            return true;
        };
        Text.prototype.setHighlightIndentGuides = function(highlight) {
            if (this.$highlightIndentGuides === highlight) return false;
            this.$highlightIndentGuides = highlight;
            return highlight;
        };
        Text.prototype.$computeTabString = function() {
            var tabSize = this.session.getTabSize();
            this.tabSize = tabSize;
            var tabStr = this.$tabStrings = [
                0
            ];
            for(var i = 1; i < tabSize + 1; i++)if (this.showTabs) {
                var span = this.dom.createElement("span");
                span.className = "ace_invisible ace_invisible_tab";
                span.textContent = lang.stringRepeat(this.TAB_CHAR, i);
                tabStr.push(span);
            } else tabStr.push(this.dom.createTextNode(lang.stringRepeat(" ", i), this.element));
            if (this.displayIndentGuides) {
                this.$indentGuideRe = /\s\S| \t|\t |\s$/;
                var className = "ace_indent-guide";
                var spaceClass = this.showSpaces ? " ace_invisible ace_invisible_space" : "";
                var spaceContent = this.showSpaces ? lang.stringRepeat(this.SPACE_CHAR, this.tabSize) : lang.stringRepeat(" ", this.tabSize);
                var tabClass = this.showTabs ? " ace_invisible ace_invisible_tab" : "";
                var tabContent = this.showTabs ? lang.stringRepeat(this.TAB_CHAR, this.tabSize) : spaceContent;
                var span = this.dom.createElement("span");
                span.className = className + spaceClass;
                span.textContent = spaceContent;
                this.$tabStrings[" "] = span;
                var span = this.dom.createElement("span");
                span.className = className + tabClass;
                span.textContent = tabContent;
                this.$tabStrings["	"] = span;
            }
        };
        Text.prototype.updateLines = function(config, firstRow, lastRow) {
            if (this.config.lastRow != config.lastRow || this.config.firstRow != config.firstRow) return this.update(config);
            this.config = config;
            var first = Math.max(firstRow, config.firstRow);
            var last = Math.min(lastRow, config.lastRow);
            var lineElements = this.element.childNodes;
            var lineElementsIdx = 0;
            for(var row = config.firstRow; row < first; row++){
                var foldLine = this.session.getFoldLine(row);
                if (foldLine) {
                    if (foldLine.containsRow(first)) {
                        first = foldLine.start.row;
                        break;
                    } else row = foldLine.end.row;
                }
                lineElementsIdx++;
            }
            var heightChanged = false;
            var row = first;
            var foldLine = this.session.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(true){
                if (row > foldStart) {
                    row = foldLine.end.row + 1;
                    foldLine = this.session.getNextFoldLine(row, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }
                if (row > last) break;
                var lineElement = lineElements[lineElementsIdx++];
                if (lineElement) {
                    this.dom.removeChildren(lineElement);
                    this.$renderLine(lineElement, row, row == foldStart ? foldLine : false);
                    if (heightChanged) lineElement.style.top = this.$lines.computeLineTop(row, config, this.session) + "px";
                    var height = config.lineHeight * this.session.getRowLength(row) + "px";
                    if (lineElement.style.height != height) {
                        heightChanged = true;
                        lineElement.style.height = height;
                    }
                }
                row++;
            }
            if (heightChanged) while(lineElementsIdx < this.$lines.cells.length){
                var cell = this.$lines.cells[lineElementsIdx++];
                cell.element.style.top = this.$lines.computeLineTop(cell.row, config, this.session) + "px";
            }
        };
        Text.prototype.scrollLines = function(config) {
            var oldConfig = this.config;
            this.config = config;
            if (this.$lines.pageChanged(oldConfig, config)) return this.update(config);
            this.$lines.moveContainer(config);
            var lastRow = config.lastRow;
            var oldLastRow = oldConfig ? oldConfig.lastRow : -1;
            if (!oldConfig || oldLastRow < config.firstRow) return this.update(config);
            if (lastRow < oldConfig.firstRow) return this.update(config);
            if (!oldConfig || oldConfig.lastRow < config.firstRow) return this.update(config);
            if (config.lastRow < oldConfig.firstRow) return this.update(config);
            if (oldConfig.firstRow < config.firstRow) for(var row = this.session.getFoldedRowCount(oldConfig.firstRow, config.firstRow - 1); row > 0; row--)this.$lines.shift();
            if (oldConfig.lastRow > config.lastRow) for(var row = this.session.getFoldedRowCount(config.lastRow + 1, oldConfig.lastRow); row > 0; row--)this.$lines.pop();
            if (config.firstRow < oldConfig.firstRow) this.$lines.unshift(this.$renderLinesFragment(config, config.firstRow, oldConfig.firstRow - 1));
            if (config.lastRow > oldConfig.lastRow) this.$lines.push(this.$renderLinesFragment(config, oldConfig.lastRow + 1, config.lastRow));
            this.$highlightIndentGuide();
        };
        Text.prototype.$renderLinesFragment = function(config, firstRow, lastRow) {
            var fragment = [];
            var row = firstRow;
            var foldLine = this.session.getNextFoldLine(row);
            var foldStart = foldLine ? foldLine.start.row : Infinity;
            while(true){
                if (row > foldStart) {
                    row = foldLine.end.row + 1;
                    foldLine = this.session.getNextFoldLine(row, foldLine);
                    foldStart = foldLine ? foldLine.start.row : Infinity;
                }
                if (row > lastRow) break;
                var line = this.$lines.createCell(row, config, this.session);
                var lineEl = line.element;
                this.dom.removeChildren(lineEl);
                dom.setStyle(lineEl.style, "height", this.$lines.computeLineHeight(row, config, this.session) + "px");
                dom.setStyle(lineEl.style, "top", this.$lines.computeLineTop(row, config, this.session) + "px");
                this.$renderLine(lineEl, row, row == foldStart ? foldLine : false);
                if (this.$useLineGroups()) lineEl.className = "ace_line_group";
                else lineEl.className = "ace_line";
                fragment.push(line);
                row++;
            }
            return fragment;
        };
        Text.prototype.update = function(config) {
            this.$lines.moveContainer(config);
            this.config = config;
            var firstRow = config.firstRow;
            var lastRow = config.lastRow;
            var lines = this.$lines;
            while(lines.getLength())lines.pop();
            lines.push(this.$renderLinesFragment(config, firstRow, lastRow));
        };
        Text.prototype.$renderToken = function(parent, screenColumn, token, value) {
            var self1 = this;
            var re = /(\t)|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\uFEFF\uFFF9-\uFFFC\u2066\u2067\u2068\u202A\u202B\u202D\u202E\u202C\u2069]+)|(\u3000)|([\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3001-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF])/g;
            var valueFragment = this.dom.createFragment(this.element);
            var m;
            var i = 0;
            while(m = re.exec(value)){
                var tab = m[1];
                var simpleSpace = m[2];
                var controlCharacter = m[3];
                var cjkSpace = m[4];
                var cjk = m[5];
                if (!self1.showSpaces && simpleSpace) continue;
                var before = i != m.index ? value.slice(i, m.index) : "";
                i = m.index + m[0].length;
                if (before) valueFragment.appendChild(this.dom.createTextNode(before, this.element));
                if (tab) {
                    var tabSize = self1.session.getScreenTabSize(screenColumn + m.index);
                    valueFragment.appendChild(self1.$tabStrings[tabSize].cloneNode(true));
                    screenColumn += tabSize - 1;
                } else if (simpleSpace) {
                    if (self1.showSpaces) {
                        var span = this.dom.createElement("span");
                        span.className = "ace_invisible ace_invisible_space";
                        span.textContent = lang.stringRepeat(self1.SPACE_CHAR, simpleSpace.length);
                        valueFragment.appendChild(span);
                    } else valueFragment.appendChild(this.com.createTextNode(simpleSpace, this.element));
                } else if (controlCharacter) {
                    var span = this.dom.createElement("span");
                    span.className = "ace_invisible ace_invisible_space ace_invalid";
                    span.textContent = lang.stringRepeat(self1.SPACE_CHAR, controlCharacter.length);
                    valueFragment.appendChild(span);
                } else if (cjkSpace) {
                    screenColumn += 1;
                    var span = this.dom.createElement("span");
                    span.style.width = self1.config.characterWidth * 2 + "px";
                    span.className = self1.showSpaces ? "ace_cjk ace_invisible ace_invisible_space" : "ace_cjk";
                    span.textContent = self1.showSpaces ? self1.SPACE_CHAR : cjkSpace;
                    valueFragment.appendChild(span);
                } else if (cjk) {
                    screenColumn += 1;
                    var span = this.dom.createElement("span");
                    span.style.width = self1.config.characterWidth * 2 + "px";
                    span.className = "ace_cjk";
                    span.textContent = cjk;
                    valueFragment.appendChild(span);
                }
            }
            valueFragment.appendChild(this.dom.createTextNode(i ? value.slice(i) : value, this.element));
            if (!this.$textToken[token.type]) {
                var classes = "ace_" + token.type.replace(/\./g, " ace_");
                var span = this.dom.createElement("span");
                if (token.type == "fold") {
                    span.style.width = token.value.length * this.config.characterWidth + "px";
                    span.setAttribute("title", nls("Unfold code"));
                }
                span.className = classes;
                span.appendChild(valueFragment);
                parent.appendChild(span);
            } else parent.appendChild(valueFragment);
            return screenColumn + value.length;
        };
        Text.prototype.renderIndentGuide = function(parent, value, max) {
            var cols = value.search(this.$indentGuideRe);
            if (cols <= 0 || cols >= max) return value;
            if (value[0] == " ") {
                cols -= cols % this.tabSize;
                var count = cols / this.tabSize;
                for(var i = 0; i < count; i++)parent.appendChild(this.$tabStrings[" "].cloneNode(true));
                this.$highlightIndentGuide();
                return value.substr(cols);
            } else if (value[0] == "	") {
                for(var i = 0; i < cols; i++)parent.appendChild(this.$tabStrings["	"].cloneNode(true));
                this.$highlightIndentGuide();
                return value.substr(cols);
            }
            this.$highlightIndentGuide();
            return value;
        };
        Text.prototype.$highlightIndentGuide = function() {
            if (!this.$highlightIndentGuides || !this.displayIndentGuides) return;
            this.$highlightIndentGuideMarker = {
                indentLevel: undefined,
                start: undefined,
                end: undefined,
                dir: undefined
            };
            var lines = this.session.doc.$lines;
            if (!lines) return;
            var cursor = this.session.selection.getCursor();
            var initialIndent = /^\s*/.exec(this.session.doc.getLine(cursor.row))[0].length;
            var elementIndentLevel = Math.floor(initialIndent / this.tabSize);
            this.$highlightIndentGuideMarker = {
                indentLevel: elementIndentLevel,
                start: cursor.row
            };
            var bracketHighlight = this.session.$bracketHighlight;
            if (bracketHighlight) {
                var ranges = this.session.$bracketHighlight.ranges;
                for(var i = 0; i < ranges.length; i++)if (cursor.row !== ranges[i].start.row) {
                    this.$highlightIndentGuideMarker.end = ranges[i].start.row;
                    if (cursor.row > ranges[i].start.row) this.$highlightIndentGuideMarker.dir = -1;
                    else this.$highlightIndentGuideMarker.dir = 1;
                    break;
                }
            }
            if (!this.$highlightIndentGuideMarker.end) {
                if (lines[cursor.row] !== "" && cursor.column === lines[cursor.row].length) {
                    this.$highlightIndentGuideMarker.dir = 1;
                    for(var i = cursor.row + 1; i < lines.length; i++){
                        var line = lines[i];
                        var currentIndent = /^\s*/.exec(line)[0].length;
                        if (line !== "") {
                            this.$highlightIndentGuideMarker.end = i;
                            if (currentIndent <= initialIndent) break;
                        }
                    }
                }
            }
            this.$renderHighlightIndentGuide();
        };
        Text.prototype.$clearActiveIndentGuide = function() {
            var cells = this.$lines.cells;
            for(var i = 0; i < cells.length; i++){
                var cell = cells[i];
                var childNodes = cell.element.childNodes;
                if (childNodes.length > 0) {
                    for(var j = 0; j < childNodes.length; j++)if (childNodes[j].classList && childNodes[j].classList.contains("ace_indent-guide-active")) {
                        childNodes[j].classList.remove("ace_indent-guide-active");
                        break;
                    }
                }
            }
        };
        Text.prototype.$setIndentGuideActive = function(cell, indentLevel) {
            var line = this.session.doc.getLine(cell.row);
            if (line !== "") {
                var childNodes = cell.element.childNodes;
                if (childNodes) {
                    var node = childNodes[indentLevel - 1];
                    if (node && node.classList && node.classList.contains("ace_indent-guide")) node.classList.add("ace_indent-guide-active");
                }
            }
        };
        Text.prototype.$renderHighlightIndentGuide = function() {
            if (!this.$lines) return;
            var cells = this.$lines.cells;
            this.$clearActiveIndentGuide();
            var indentLevel = this.$highlightIndentGuideMarker.indentLevel;
            if (indentLevel !== 0) {
                if (this.$highlightIndentGuideMarker.dir === 1) for(var i = 0; i < cells.length; i++){
                    var cell = cells[i];
                    if (this.$highlightIndentGuideMarker.end && cell.row >= this.$highlightIndentGuideMarker.start + 1) {
                        if (cell.row >= this.$highlightIndentGuideMarker.end) break;
                        this.$setIndentGuideActive(cell, indentLevel);
                    }
                }
                else for(var i = cells.length - 1; i >= 0; i--){
                    var cell = cells[i];
                    if (this.$highlightIndentGuideMarker.end && cell.row < this.$highlightIndentGuideMarker.start) {
                        if (cell.row <= this.$highlightIndentGuideMarker.end) break;
                        this.$setIndentGuideActive(cell, indentLevel);
                    }
                }
            }
        };
        Text.prototype.$createLineElement = function(parent) {
            var lineEl = this.dom.createElement("div");
            lineEl.className = "ace_line";
            lineEl.style.height = this.config.lineHeight + "px";
            return lineEl;
        };
        Text.prototype.$renderWrappedLine = function(parent, tokens, splits) {
            var chars = 0;
            var split = 0;
            var splitChars = splits[0];
            var screenColumn = 0;
            var lineEl = this.$createLineElement();
            parent.appendChild(lineEl);
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var value = token.value;
                if (i == 0 && this.displayIndentGuides) {
                    chars = value.length;
                    value = this.renderIndentGuide(lineEl, value, splitChars);
                    if (!value) continue;
                    chars -= value.length;
                }
                if (chars + value.length < splitChars) {
                    screenColumn = this.$renderToken(lineEl, screenColumn, token, value);
                    chars += value.length;
                } else {
                    while(chars + value.length >= splitChars){
                        screenColumn = this.$renderToken(lineEl, screenColumn, token, value.substring(0, splitChars - chars));
                        value = value.substring(splitChars - chars);
                        chars = splitChars;
                        lineEl = this.$createLineElement();
                        parent.appendChild(lineEl);
                        lineEl.appendChild(this.dom.createTextNode(lang.stringRepeat("\xa0", splits.indent), this.element));
                        split++;
                        screenColumn = 0;
                        splitChars = splits[split] || Number.MAX_VALUE;
                    }
                    if (value.length != 0) {
                        chars += value.length;
                        screenColumn = this.$renderToken(lineEl, screenColumn, token, value);
                    }
                }
            }
            if (splits[splits.length - 1] > this.MAX_LINE_LENGTH) this.$renderOverflowMessage(lineEl, screenColumn, null, "", true);
        };
        Text.prototype.$renderSimpleLine = function(parent, tokens) {
            var screenColumn = 0;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var value = token.value;
                if (i == 0 && this.displayIndentGuides) {
                    value = this.renderIndentGuide(parent, value);
                    if (!value) continue;
                }
                if (screenColumn + value.length > this.MAX_LINE_LENGTH) return this.$renderOverflowMessage(parent, screenColumn, token, value);
                screenColumn = this.$renderToken(parent, screenColumn, token, value);
            }
        };
        Text.prototype.$renderOverflowMessage = function(parent, screenColumn, token, value, hide) {
            token && this.$renderToken(parent, screenColumn, token, value.slice(0, this.MAX_LINE_LENGTH - screenColumn));
            var overflowEl = this.dom.createElement("span");
            overflowEl.className = "ace_inline_button ace_keyword ace_toggle_wrap";
            overflowEl.textContent = hide ? "<hide>" : "<click to see more...>";
            parent.appendChild(overflowEl);
        };
        Text.prototype.$renderLine = function(parent, row, foldLine) {
            if (!foldLine && foldLine != false) foldLine = this.session.getFoldLine(row);
            if (foldLine) var tokens = this.$getFoldLineTokens(row, foldLine);
            else var tokens = this.session.getTokens(row);
            var lastLineEl = parent;
            if (tokens.length) {
                var splits = this.session.getRowSplitData(row);
                if (splits && splits.length) {
                    this.$renderWrappedLine(parent, tokens, splits);
                    var lastLineEl = parent.lastChild;
                } else {
                    var lastLineEl = parent;
                    if (this.$useLineGroups()) {
                        lastLineEl = this.$createLineElement();
                        parent.appendChild(lastLineEl);
                    }
                    this.$renderSimpleLine(lastLineEl, tokens);
                }
            } else if (this.$useLineGroups()) {
                lastLineEl = this.$createLineElement();
                parent.appendChild(lastLineEl);
            }
            if (this.showEOL && lastLineEl) {
                if (foldLine) row = foldLine.end.row;
                var invisibleEl = this.dom.createElement("span");
                invisibleEl.className = "ace_invisible ace_invisible_eol";
                invisibleEl.textContent = row == this.session.getLength() - 1 ? this.EOF_CHAR : this.EOL_CHAR;
                lastLineEl.appendChild(invisibleEl);
            }
        };
        Text.prototype.$getFoldLineTokens = function(row, foldLine) {
            var session = this.session;
            var renderTokens = [];
            function addTokens(tokens, from, to) {
                var idx = 0, col = 0;
                while(col + tokens[idx].value.length < from){
                    col += tokens[idx].value.length;
                    idx++;
                    if (idx == tokens.length) return;
                }
                if (col != from) {
                    var value = tokens[idx].value.substring(from - col);
                    if (value.length > to - from) value = value.substring(0, to - from);
                    renderTokens.push({
                        type: tokens[idx].type,
                        value: value
                    });
                    col = from + value.length;
                    idx += 1;
                }
                while(col < to && idx < tokens.length){
                    var value = tokens[idx].value;
                    if (value.length + col > to) renderTokens.push({
                        type: tokens[idx].type,
                        value: value.substring(0, to - col)
                    });
                    else renderTokens.push(tokens[idx]);
                    col += value.length;
                    idx += 1;
                }
            }
            var tokens = session.getTokens(row);
            foldLine.walk(function(placeholder, row, column, lastColumn, isNewRow) {
                if (placeholder != null) renderTokens.push({
                    type: "fold",
                    value: placeholder
                });
                else {
                    if (isNewRow) tokens = session.getTokens(row);
                    if (tokens.length) addTokens(tokens, lastColumn, column);
                }
            }, foldLine.end.row, this.session.getLine(foldLine.end.row).length);
            return renderTokens;
        };
        Text.prototype.$useLineGroups = function() {
            return this.session.getUseWrapMode();
        };
        return Text;
    }();
    Text.prototype.$textToken = {
        "text": true,
        "rparen": true,
        "lparen": true
    };
    Text.prototype.EOF_CHAR = "\xb6";
    Text.prototype.EOL_CHAR_LF = "\xac";
    Text.prototype.EOL_CHAR_CRLF = "\xa4";
    Text.prototype.EOL_CHAR = Text.prototype.EOL_CHAR_LF;
    Text.prototype.TAB_CHAR = "—"; //"\u21E5";
    Text.prototype.SPACE_CHAR = "\xb7";
    Text.prototype.$padding = 0;
    Text.prototype.MAX_LINE_LENGTH = 10000;
    Text.prototype.showInvisibles = false;
    Text.prototype.showSpaces = false;
    Text.prototype.showTabs = false;
    Text.prototype.showEOL = false;
    Text.prototype.displayIndentGuides = true;
    Text.prototype.$highlightIndentGuides = true;
    Text.prototype.$tabStrings = [];
    Text.prototype.destroy = {};
    Text.prototype.onChangeTabSize = Text.prototype.$computeTabString;
    oop.implement(Text.prototype, EventEmitter);
    exports.Text = Text;
});
ace.define("ace/layer/cursor", [
    "require",
    "exports",
    "module",
    "ace/lib/dom"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var Cursor = /** @class */ function() {
        function Cursor(parentEl) {
            this.element = dom.createElement("div");
            this.element.className = "ace_layer ace_cursor-layer";
            parentEl.appendChild(this.element);
            this.isVisible = false;
            this.isBlinking = true;
            this.blinkInterval = 1000;
            this.smoothBlinking = false;
            this.cursors = [];
            this.cursor = this.addCursor();
            dom.addCssClass(this.element, "ace_hidden-cursors");
            this.$updateCursors = this.$updateOpacity.bind(this);
        }
        Cursor.prototype.$updateOpacity = function(val) {
            var cursors = this.cursors;
            for(var i = cursors.length; i--;)dom.setStyle(cursors[i].style, "opacity", val ? "" : "0");
        };
        Cursor.prototype.$startCssAnimation = function() {
            var cursors = this.cursors;
            for(var i = cursors.length; i--;)cursors[i].style.animationDuration = this.blinkInterval + "ms";
            this.$isAnimating = true;
            setTimeout((function() {
                if (this.$isAnimating) dom.addCssClass(this.element, "ace_animate-blinking");
            }).bind(this));
        };
        Cursor.prototype.$stopCssAnimation = function() {
            this.$isAnimating = false;
            dom.removeCssClass(this.element, "ace_animate-blinking");
        };
        Cursor.prototype.setPadding = function(padding) {
            this.$padding = padding;
        };
        Cursor.prototype.setSession = function(session) {
            this.session = session;
        };
        Cursor.prototype.setBlinking = function(blinking) {
            if (blinking != this.isBlinking) {
                this.isBlinking = blinking;
                this.restartTimer();
            }
        };
        Cursor.prototype.setBlinkInterval = function(blinkInterval) {
            if (blinkInterval != this.blinkInterval) {
                this.blinkInterval = blinkInterval;
                this.restartTimer();
            }
        };
        Cursor.prototype.setSmoothBlinking = function(smoothBlinking) {
            if (smoothBlinking != this.smoothBlinking) {
                this.smoothBlinking = smoothBlinking;
                dom.setCssClass(this.element, "ace_smooth-blinking", smoothBlinking);
                this.$updateCursors(true);
                this.restartTimer();
            }
        };
        Cursor.prototype.addCursor = function() {
            var el = dom.createElement("div");
            el.className = "ace_cursor";
            this.element.appendChild(el);
            this.cursors.push(el);
            return el;
        };
        Cursor.prototype.removeCursor = function() {
            if (this.cursors.length > 1) {
                var el = this.cursors.pop();
                el.parentNode.removeChild(el);
                return el;
            }
        };
        Cursor.prototype.hideCursor = function() {
            this.isVisible = false;
            dom.addCssClass(this.element, "ace_hidden-cursors");
            this.restartTimer();
        };
        Cursor.prototype.showCursor = function() {
            this.isVisible = true;
            dom.removeCssClass(this.element, "ace_hidden-cursors");
            this.restartTimer();
        };
        Cursor.prototype.restartTimer = function() {
            var update = this.$updateCursors;
            clearInterval(this.intervalId);
            clearTimeout(this.timeoutId);
            this.$stopCssAnimation();
            if (this.smoothBlinking) {
                this.$isSmoothBlinking = false;
                dom.removeCssClass(this.element, "ace_smooth-blinking");
            }
            update(true);
            if (!this.isBlinking || !this.blinkInterval || !this.isVisible) {
                this.$stopCssAnimation();
                return;
            }
            if (this.smoothBlinking) {
                this.$isSmoothBlinking = true;
                setTimeout((function() {
                    if (this.$isSmoothBlinking) dom.addCssClass(this.element, "ace_smooth-blinking");
                }).bind(this));
            }
            if (dom.HAS_CSS_ANIMATION) this.$startCssAnimation();
            else {
                var blink = (function() {
                    this.timeoutId = setTimeout(function() {
                        update(false);
                    }, 0.6 * this.blinkInterval);
                }).bind(this);
                this.intervalId = setInterval(function() {
                    update(true);
                    blink();
                }, this.blinkInterval);
                blink();
            }
        };
        Cursor.prototype.getPixelPosition = function(position, onScreen) {
            if (!this.config || !this.session) return {
                left: 0,
                top: 0
            };
            if (!position) position = this.session.selection.getCursor();
            var pos = this.session.documentToScreenPosition(position);
            var cursorLeft = this.$padding + (this.session.$bidiHandler.isBidiRow(pos.row, position.row) ? this.session.$bidiHandler.getPosLeft(pos.column) : pos.column * this.config.characterWidth);
            var cursorTop = (pos.row - (onScreen ? this.config.firstRowScreen : 0)) * this.config.lineHeight;
            return {
                left: cursorLeft,
                top: cursorTop
            };
        };
        Cursor.prototype.isCursorInView = function(pixelPos, config) {
            return pixelPos.top >= 0 && pixelPos.top < config.maxHeight;
        };
        Cursor.prototype.update = function(config) {
            this.config = config;
            var selections = this.session.$selectionMarkers;
            var i = 0, cursorIndex = 0;
            if (selections === undefined || selections.length === 0) selections = [
                {
                    cursor: null
                }
            ];
            for(var i = 0, n = selections.length; i < n; i++){
                var pixelPos = this.getPixelPosition(selections[i].cursor, true);
                if ((pixelPos.top > config.height + config.offset || pixelPos.top < 0) && i > 1) continue;
                var element = this.cursors[cursorIndex++] || this.addCursor();
                var style = element.style;
                if (!this.drawCursor) {
                    if (!this.isCursorInView(pixelPos, config)) dom.setStyle(style, "display", "none");
                    else {
                        dom.setStyle(style, "display", "block");
                        dom.translate(element, pixelPos.left, pixelPos.top);
                        dom.setStyle(style, "width", Math.round(config.characterWidth) + "px");
                        dom.setStyle(style, "height", config.lineHeight + "px");
                    }
                } else this.drawCursor(element, pixelPos, config, selections[i], this.session);
            }
            while(this.cursors.length > cursorIndex)this.removeCursor();
            var overwrite = this.session.getOverwrite();
            this.$setOverwrite(overwrite);
            this.$pixelPos = pixelPos;
            this.restartTimer();
        };
        Cursor.prototype.$setOverwrite = function(overwrite) {
            if (overwrite != this.overwrite) {
                this.overwrite = overwrite;
                if (overwrite) dom.addCssClass(this.element, "ace_overwrite-cursors");
                else dom.removeCssClass(this.element, "ace_overwrite-cursors");
            }
        };
        Cursor.prototype.destroy = function() {
            clearInterval(this.intervalId);
            clearTimeout(this.timeoutId);
        };
        return Cursor;
    }();
    Cursor.prototype.$padding = 0;
    Cursor.prototype.drawCursor = null;
    exports.Cursor = Cursor;
});
ace.define("ace/scrollbar", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var oop = require("./lib/oop");
    var dom = require("./lib/dom");
    var event = require("./lib/event");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var MAX_SCROLL_H = 0x8000;
    var Scrollbar = /** @class */ function() {
        function Scrollbar(parent, classSuffix) {
            this.element = dom.createElement("div");
            this.element.className = "ace_scrollbar ace_scrollbar" + classSuffix;
            this.inner = dom.createElement("div");
            this.inner.className = "ace_scrollbar-inner";
            this.inner.textContent = "\xa0";
            this.element.appendChild(this.inner);
            parent.appendChild(this.element);
            this.setVisible(false);
            this.skipEvent = false;
            event.addListener(this.element, "scroll", this.onScroll.bind(this));
            event.addListener(this.element, "mousedown", event.preventDefault);
        }
        Scrollbar.prototype.setVisible = function(isVisible) {
            this.element.style.display = isVisible ? "" : "none";
            this.isVisible = isVisible;
            this.coeff = 1;
        };
        return Scrollbar;
    }();
    oop.implement(Scrollbar.prototype, EventEmitter);
    var VScrollBar = /** @class */ function(_super) {
        __extends(VScrollBar, _super);
        function VScrollBar(parent, renderer) {
            var _this = _super.call(this, parent, "-v") || this;
            _this.scrollTop = 0;
            _this.scrollHeight = 0;
            renderer.$scrollbarWidth = _this.width = dom.scrollbarWidth(parent.ownerDocument);
            _this.inner.style.width = _this.element.style.width = (_this.width || 15) + 5 + "px";
            _this.$minWidth = 0;
            return _this;
        }
        VScrollBar.prototype.onScroll = function() {
            if (!this.skipEvent) {
                this.scrollTop = this.element.scrollTop;
                if (this.coeff != 1) {
                    var h = this.element.clientHeight / this.scrollHeight;
                    this.scrollTop = this.scrollTop * (1 - h) / (this.coeff - h);
                }
                this._emit("scroll", {
                    data: this.scrollTop
                });
            }
            this.skipEvent = false;
        };
        VScrollBar.prototype.getWidth = function() {
            return Math.max(this.isVisible ? this.width : 0, this.$minWidth || 0);
        };
        VScrollBar.prototype.setHeight = function(height) {
            this.element.style.height = height + "px";
        };
        VScrollBar.prototype.setScrollHeight = function(height) {
            this.scrollHeight = height;
            if (height > MAX_SCROLL_H) {
                this.coeff = MAX_SCROLL_H / height;
                height = MAX_SCROLL_H;
            } else if (this.coeff != 1) this.coeff = 1;
            this.inner.style.height = height + "px";
        };
        VScrollBar.prototype.setScrollTop = function(scrollTop) {
            if (this.scrollTop != scrollTop) {
                this.skipEvent = true;
                this.scrollTop = scrollTop;
                this.element.scrollTop = scrollTop * this.coeff;
            }
        };
        return VScrollBar;
    }(Scrollbar);
    VScrollBar.prototype.setInnerHeight = VScrollBar.prototype.setScrollHeight;
    var HScrollBar = /** @class */ function(_super) {
        __extends(HScrollBar, _super);
        function HScrollBar(parent, renderer) {
            var _this = _super.call(this, parent, "-h") || this;
            _this.scrollLeft = 0;
            _this.height = renderer.$scrollbarWidth;
            _this.inner.style.height = _this.element.style.height = (_this.height || 15) + 5 + "px";
            return _this;
        }
        HScrollBar.prototype.onScroll = function() {
            if (!this.skipEvent) {
                this.scrollLeft = this.element.scrollLeft;
                this._emit("scroll", {
                    data: this.scrollLeft
                });
            }
            this.skipEvent = false;
        };
        HScrollBar.prototype.getHeight = function() {
            return this.isVisible ? this.height : 0;
        };
        HScrollBar.prototype.setWidth = function(width) {
            this.element.style.width = width + "px";
        };
        HScrollBar.prototype.setInnerWidth = function(width) {
            this.inner.style.width = width + "px";
        };
        HScrollBar.prototype.setScrollWidth = function(width) {
            this.inner.style.width = width + "px";
        };
        HScrollBar.prototype.setScrollLeft = function(scrollLeft) {
            if (this.scrollLeft != scrollLeft) {
                this.skipEvent = true;
                this.scrollLeft = this.element.scrollLeft = scrollLeft;
            }
        };
        return HScrollBar;
    }(Scrollbar);
    exports.ScrollBar = VScrollBar; // backward compatibility
    exports.ScrollBarV = VScrollBar; // backward compatibility
    exports.ScrollBarH = HScrollBar; // backward compatibility
    exports.VScrollBar = VScrollBar;
    exports.HScrollBar = HScrollBar;
});
ace.define("ace/scrollbar_custom", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/event",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var __extends = this && this.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var oop = require("./lib/oop");
    var dom = require("./lib/dom");
    var event = require("./lib/event");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    dom.importCssString(".ace_editor>.ace_sb-v div, .ace_editor>.ace_sb-h div{\n  position: absolute;\n  background: rgba(128, 128, 128, 0.6);\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 1px solid #bbb;\n  border-radius: 2px;\n  z-index: 8;\n}\n.ace_editor>.ace_sb-v, .ace_editor>.ace_sb-h {\n  position: absolute;\n  z-index: 6;\n  background: none;\n  overflow: hidden!important;\n}\n.ace_editor>.ace_sb-v {\n  z-index: 6;\n  right: 0;\n  top: 0;\n  width: 12px;\n}\n.ace_editor>.ace_sb-v div {\n  z-index: 8;\n  right: 0;\n  width: 100%;\n}\n.ace_editor>.ace_sb-h {\n  bottom: 0;\n  left: 0;\n  height: 12px;\n}\n.ace_editor>.ace_sb-h div {\n  bottom: 0;\n  height: 100%;\n}\n.ace_editor>.ace_sb_grabbed {\n  z-index: 8;\n  background: #000;\n}", "ace_scrollbar.css", false);
    var ScrollBar = /** @class */ function() {
        function ScrollBar(parent, classSuffix) {
            this.element = dom.createElement("div");
            this.element.className = "ace_sb" + classSuffix;
            this.inner = dom.createElement("div");
            this.inner.className = "";
            this.element.appendChild(this.inner);
            this.VScrollWidth = 12;
            this.HScrollHeight = 12;
            parent.appendChild(this.element);
            this.setVisible(false);
            this.skipEvent = false;
            event.addMultiMouseDownListener(this.element, [
                500,
                300,
                300
            ], this, "onMouseDown");
        }
        ScrollBar.prototype.setVisible = function(isVisible) {
            this.element.style.display = isVisible ? "" : "none";
            this.isVisible = isVisible;
            this.coeff = 1;
        };
        return ScrollBar;
    }();
    oop.implement(ScrollBar.prototype, EventEmitter);
    var VScrollBar = /** @class */ function(_super) {
        __extends(VScrollBar, _super);
        function VScrollBar(parent, renderer) {
            var _this = _super.call(this, parent, "-v") || this;
            _this.scrollTop = 0;
            _this.scrollHeight = 0;
            _this.parent = parent;
            _this.width = _this.VScrollWidth;
            _this.renderer = renderer;
            _this.inner.style.width = _this.element.style.width = (_this.width || 15) + "px";
            _this.$minWidth = 0;
            return _this;
        }
        VScrollBar.prototype.onMouseDown = function(eType, e) {
            if (eType !== "mousedown") return;
            if (event.getButton(e) !== 0 || e.detail === 2) return;
            if (e.target === this.inner) {
                var self1 = this;
                var mousePageY = e.clientY;
                var onMouseMove = function(e) {
                    mousePageY = e.clientY;
                };
                var onMouseUp = function() {
                    clearInterval(timerId);
                };
                var startY = e.clientY;
                var startTop = this.thumbTop;
                var onScrollInterval = function() {
                    if (mousePageY === undefined) return;
                    var scrollTop = self1.scrollTopFromThumbTop(startTop + mousePageY - startY);
                    if (scrollTop === self1.scrollTop) return;
                    self1._emit("scroll", {
                        data: scrollTop
                    });
                };
                event.capture(this.inner, onMouseMove, onMouseUp);
                var timerId = setInterval(onScrollInterval, 20);
                return event.preventDefault(e);
            }
            var top = e.clientY - this.element.getBoundingClientRect().top - this.thumbHeight / 2;
            this._emit("scroll", {
                data: this.scrollTopFromThumbTop(top)
            });
            return event.preventDefault(e);
        };
        VScrollBar.prototype.getHeight = function() {
            return this.height;
        };
        VScrollBar.prototype.scrollTopFromThumbTop = function(thumbTop) {
            var scrollTop = thumbTop * (this.pageHeight - this.viewHeight) / (this.slideHeight - this.thumbHeight);
            scrollTop = scrollTop >> 0;
            if (scrollTop < 0) scrollTop = 0;
            else if (scrollTop > this.pageHeight - this.viewHeight) scrollTop = this.pageHeight - this.viewHeight;
            return scrollTop;
        };
        VScrollBar.prototype.getWidth = function() {
            return Math.max(this.isVisible ? this.width : 0, this.$minWidth || 0);
        };
        VScrollBar.prototype.setHeight = function(height) {
            this.height = Math.max(0, height);
            this.slideHeight = this.height;
            this.viewHeight = this.height;
            this.setScrollHeight(this.pageHeight, true);
        };
        VScrollBar.prototype.setScrollHeight = function(height, force) {
            if (this.pageHeight === height && !force) return;
            this.pageHeight = height;
            this.thumbHeight = this.slideHeight * this.viewHeight / this.pageHeight;
            if (this.thumbHeight > this.slideHeight) this.thumbHeight = this.slideHeight;
            if (this.thumbHeight < 15) this.thumbHeight = 15;
            this.inner.style.height = this.thumbHeight + "px";
            if (this.scrollTop > this.pageHeight - this.viewHeight) {
                this.scrollTop = this.pageHeight - this.viewHeight;
                if (this.scrollTop < 0) this.scrollTop = 0;
                this._emit("scroll", {
                    data: this.scrollTop
                });
            }
        };
        VScrollBar.prototype.setScrollTop = function(scrollTop) {
            this.scrollTop = scrollTop;
            if (scrollTop < 0) scrollTop = 0;
            this.thumbTop = scrollTop * (this.slideHeight - this.thumbHeight) / (this.pageHeight - this.viewHeight);
            this.inner.style.top = this.thumbTop + "px";
        };
        return VScrollBar;
    }(ScrollBar);
    VScrollBar.prototype.setInnerHeight = VScrollBar.prototype.setScrollHeight;
    var HScrollBar = /** @class */ function(_super) {
        __extends(HScrollBar, _super);
        function HScrollBar(parent, renderer) {
            var _this = _super.call(this, parent, "-h") || this;
            _this.scrollLeft = 0;
            _this.scrollWidth = 0;
            _this.height = _this.HScrollHeight;
            _this.inner.style.height = _this.element.style.height = (_this.height || 12) + "px";
            _this.renderer = renderer;
            return _this;
        }
        HScrollBar.prototype.onMouseDown = function(eType, e) {
            if (eType !== "mousedown") return;
            if (event.getButton(e) !== 0 || e.detail === 2) return;
            if (e.target === this.inner) {
                var self1 = this;
                var mousePageX = e.clientX;
                var onMouseMove = function(e) {
                    mousePageX = e.clientX;
                };
                var onMouseUp = function() {
                    clearInterval(timerId);
                };
                var startX = e.clientX;
                var startLeft = this.thumbLeft;
                var onScrollInterval = function() {
                    if (mousePageX === undefined) return;
                    var scrollLeft = self1.scrollLeftFromThumbLeft(startLeft + mousePageX - startX);
                    if (scrollLeft === self1.scrollLeft) return;
                    self1._emit("scroll", {
                        data: scrollLeft
                    });
                };
                event.capture(this.inner, onMouseMove, onMouseUp);
                var timerId = setInterval(onScrollInterval, 20);
                return event.preventDefault(e);
            }
            var left = e.clientX - this.element.getBoundingClientRect().left - this.thumbWidth / 2;
            this._emit("scroll", {
                data: this.scrollLeftFromThumbLeft(left)
            });
            return event.preventDefault(e);
        };
        HScrollBar.prototype.getHeight = function() {
            return this.isVisible ? this.height : 0;
        };
        HScrollBar.prototype.scrollLeftFromThumbLeft = function(thumbLeft) {
            var scrollLeft = thumbLeft * (this.pageWidth - this.viewWidth) / (this.slideWidth - this.thumbWidth);
            scrollLeft = scrollLeft >> 0;
            if (scrollLeft < 0) scrollLeft = 0;
            else if (scrollLeft > this.pageWidth - this.viewWidth) scrollLeft = this.pageWidth - this.viewWidth;
            return scrollLeft;
        };
        HScrollBar.prototype.setWidth = function(width) {
            this.width = Math.max(0, width);
            this.element.style.width = this.width + "px";
            this.slideWidth = this.width;
            this.viewWidth = this.width;
            this.setScrollWidth(this.pageWidth, true);
        };
        HScrollBar.prototype.setScrollWidth = function(width, force) {
            if (this.pageWidth === width && !force) return;
            this.pageWidth = width;
            this.thumbWidth = this.slideWidth * this.viewWidth / this.pageWidth;
            if (this.thumbWidth > this.slideWidth) this.thumbWidth = this.slideWidth;
            if (this.thumbWidth < 15) this.thumbWidth = 15;
            this.inner.style.width = this.thumbWidth + "px";
            if (this.scrollLeft > this.pageWidth - this.viewWidth) {
                this.scrollLeft = this.pageWidth - this.viewWidth;
                if (this.scrollLeft < 0) this.scrollLeft = 0;
                this._emit("scroll", {
                    data: this.scrollLeft
                });
            }
        };
        HScrollBar.prototype.setScrollLeft = function(scrollLeft) {
            this.scrollLeft = scrollLeft;
            if (scrollLeft < 0) scrollLeft = 0;
            this.thumbLeft = scrollLeft * (this.slideWidth - this.thumbWidth) / (this.pageWidth - this.viewWidth);
            this.inner.style.left = this.thumbLeft + "px";
        };
        return HScrollBar;
    }(ScrollBar);
    HScrollBar.prototype.setInnerWidth = HScrollBar.prototype.setScrollWidth;
    exports.ScrollBar = VScrollBar; // backward compatibility
    exports.ScrollBarV = VScrollBar; // backward compatibility
    exports.ScrollBarH = HScrollBar; // backward compatibility
    exports.VScrollBar = VScrollBar;
    exports.HScrollBar = HScrollBar;
});
ace.define("ace/renderloop", [
    "require",
    "exports",
    "module",
    "ace/lib/event"
], function(require, exports, module1) {
    "use strict";
    var event = require("./lib/event");
    var RenderLoop = /** @class */ function() {
        function RenderLoop(onRender, win) {
            this.onRender = onRender;
            this.pending = false;
            this.changes = 0;
            this.$recursionLimit = 2;
            this.window = win || window;
            var _self = this;
            this._flush = function(ts) {
                _self.pending = false;
                var changes = _self.changes;
                if (changes) {
                    event.blockIdle(100);
                    _self.changes = 0;
                    _self.onRender(changes);
                }
                if (_self.changes) {
                    if (_self.$recursionLimit-- < 0) return;
                    _self.schedule();
                } else _self.$recursionLimit = 2;
            };
        }
        RenderLoop.prototype.schedule = function(change) {
            this.changes = this.changes | change;
            if (this.changes && !this.pending) {
                event.nextFrame(this._flush);
                this.pending = true;
            }
        };
        RenderLoop.prototype.clear = function(change) {
            var changes = this.changes;
            this.changes = 0;
            return changes;
        };
        return RenderLoop;
    }();
    exports.RenderLoop = RenderLoop;
});
ace.define("ace/layer/font_metrics", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/lib/event",
    "ace/lib/useragent",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    var oop = require("../lib/oop");
    var dom = require("../lib/dom");
    var lang = require("../lib/lang");
    var event = require("../lib/event");
    var useragent = require("../lib/useragent");
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var CHAR_COUNT = 512;
    var USE_OBSERVER = typeof ResizeObserver == "function";
    var L = 200;
    var FontMetrics = /** @class */ function() {
        function FontMetrics(parentEl) {
            this.el = dom.createElement("div");
            this.$setMeasureNodeStyles(this.el.style, true);
            this.$main = dom.createElement("div");
            this.$setMeasureNodeStyles(this.$main.style);
            this.$measureNode = dom.createElement("div");
            this.$setMeasureNodeStyles(this.$measureNode.style);
            this.el.appendChild(this.$main);
            this.el.appendChild(this.$measureNode);
            parentEl.appendChild(this.el);
            this.$measureNode.textContent = lang.stringRepeat("X", CHAR_COUNT);
            this.$characterSize = {
                width: 0,
                height: 0
            };
            if (USE_OBSERVER) this.$addObserver();
            else this.checkForSizeChanges();
        }
        FontMetrics.prototype.$setMeasureNodeStyles = function(style, isRoot) {
            style.width = style.height = "auto";
            style.left = style.top = "0px";
            style.visibility = "hidden";
            style.position = "absolute";
            style.whiteSpace = "pre";
            if (useragent.isIE < 8) style["font-family"] = "inherit";
            else style.font = "inherit";
            style.overflow = isRoot ? "hidden" : "visible";
        };
        FontMetrics.prototype.checkForSizeChanges = function(size) {
            if (size === undefined) size = this.$measureSizes();
            if (size && (this.$characterSize.width !== size.width || this.$characterSize.height !== size.height)) {
                this.$measureNode.style.fontWeight = "bold";
                var boldSize = this.$measureSizes();
                this.$measureNode.style.fontWeight = "";
                this.$characterSize = size;
                this.charSizes = Object.create(null);
                this.allowBoldFonts = boldSize && boldSize.width === size.width && boldSize.height === size.height;
                this._emit("changeCharacterSize", {
                    data: size
                });
            }
        };
        FontMetrics.prototype.$addObserver = function() {
            var self1 = this;
            this.$observer = new window.ResizeObserver(function(e) {
                self1.checkForSizeChanges();
            });
            this.$observer.observe(this.$measureNode);
        };
        FontMetrics.prototype.$pollSizeChanges = function() {
            if (this.$pollSizeChangesTimer || this.$observer) return this.$pollSizeChangesTimer;
            var self1 = this;
            return this.$pollSizeChangesTimer = event.onIdle(function cb() {
                self1.checkForSizeChanges();
                event.onIdle(cb, 500);
            }, 500);
        };
        FontMetrics.prototype.setPolling = function(val) {
            if (val) this.$pollSizeChanges();
            else if (this.$pollSizeChangesTimer) {
                clearInterval(this.$pollSizeChangesTimer);
                this.$pollSizeChangesTimer = 0;
            }
        };
        FontMetrics.prototype.$measureSizes = function(node) {
            var size = {
                height: (node || this.$measureNode).clientHeight,
                width: (node || this.$measureNode).clientWidth / CHAR_COUNT
            };
            if (size.width === 0 || size.height === 0) return null;
            return size;
        };
        FontMetrics.prototype.$measureCharWidth = function(ch) {
            this.$main.textContent = lang.stringRepeat(ch, CHAR_COUNT);
            var rect = this.$main.getBoundingClientRect();
            return rect.width / CHAR_COUNT;
        };
        FontMetrics.prototype.getCharacterWidth = function(ch) {
            var w = this.charSizes[ch];
            if (w === undefined) w = this.charSizes[ch] = this.$measureCharWidth(ch) / this.$characterSize.width;
            return w;
        };
        FontMetrics.prototype.destroy = function() {
            clearInterval(this.$pollSizeChangesTimer);
            if (this.$observer) this.$observer.disconnect();
            if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
        };
        FontMetrics.prototype.$getZoom = function(element) {
            if (!element || !element.parentElement) return 1;
            return (window.getComputedStyle(element).zoom || 1) * this.$getZoom(element.parentElement);
        };
        FontMetrics.prototype.$initTransformMeasureNodes = function() {
            var t = function(t, l) {
                return [
                    "div",
                    {
                        style: "position: absolute;top:" + t + "px;left:" + l + "px;"
                    }
                ];
            };
            this.els = dom.buildDom([
                t(0, 0),
                t(L, 0),
                t(0, L),
                t(L, L)
            ], this.el);
        };
        FontMetrics.prototype.transformCoordinates = function(clientPos, elPos) {
            if (clientPos) {
                var zoom = this.$getZoom(this.el);
                clientPos = mul(1 / zoom, clientPos);
            }
            function solve(l1, l2, r) {
                var det = l1[1] * l2[0] - l1[0] * l2[1];
                return [
                    (-l2[1] * r[0] + l2[0] * r[1]) / det,
                    (+l1[1] * r[0] - l1[0] * r[1]) / det
                ];
            }
            function sub(a, b) {
                return [
                    a[0] - b[0],
                    a[1] - b[1]
                ];
            }
            function add(a, b) {
                return [
                    a[0] + b[0],
                    a[1] + b[1]
                ];
            }
            function mul(a, b) {
                return [
                    a * b[0],
                    a * b[1]
                ];
            }
            if (!this.els) this.$initTransformMeasureNodes();
            function p(el) {
                var r = el.getBoundingClientRect();
                return [
                    r.left,
                    r.top
                ];
            }
            var a = p(this.els[0]);
            var b = p(this.els[1]);
            var c = p(this.els[2]);
            var d = p(this.els[3]);
            var h = solve(sub(d, b), sub(d, c), sub(add(b, c), add(d, a)));
            var m1 = mul(1 + h[0], sub(b, a));
            var m2 = mul(1 + h[1], sub(c, a));
            if (elPos) {
                var x = elPos;
                var k = h[0] * x[0] / L + h[1] * x[1] / L + 1;
                var ut = add(mul(x[0], m1), mul(x[1], m2));
                return add(mul(1 / k / L, ut), a);
            }
            var u = sub(clientPos, a);
            var f = solve(sub(m1, mul(h[0], u)), sub(m2, mul(h[1], u)), u);
            return mul(L, f);
        };
        return FontMetrics;
    }();
    FontMetrics.prototype.$characterSize = {
        width: 0,
        height: 0
    };
    oop.implement(FontMetrics.prototype, EventEmitter);
    exports.FontMetrics = FontMetrics;
});
ace.define("ace/css/editor-css", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    module1.exports = '\n.ace_br1 {border-top-left-radius    : 3px;}\n.ace_br2 {border-top-right-radius   : 3px;}\n.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\n.ace_br4 {border-bottom-right-radius: 3px;}\n.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\n.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\n.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\n.ace_br8 {border-bottom-left-radius : 3px;}\n.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\n.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\n.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\n.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\n\n\n.ace_editor {\n    position: relative;\n    overflow: hidden;\n    padding: 0;\n    font: 12px/normal \'Monaco\', \'Menlo\', \'Ubuntu Mono\', \'Consolas\', \'Source Code Pro\', \'source-code-pro\', monospace;\n    direction: ltr;\n    text-align: left;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.ace_scroller {\n    position: absolute;\n    overflow: hidden;\n    top: 0;\n    bottom: 0;\n    background-color: inherit;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: text;\n}\n\n.ace_content {\n    position: absolute;\n    box-sizing: border-box;\n    min-width: 100%;\n    contain: style size layout;\n    font-variant-ligatures: no-common-ligatures;\n}\n\n.ace_keyboard-focus:focus {\n    box-shadow: inset 0 0 0 2px #5E9ED6;\n    outline: none;\n}\n\n.ace_dragging .ace_scroller:before{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: \'\';\n    background: rgba(250, 250, 250, 0.01);\n    z-index: 1000;\n}\n.ace_dragging.ace_dark .ace_scroller:before{\n    background: rgba(0, 0, 0, 0.01);\n}\n\n.ace_gutter {\n    position: absolute;\n    overflow : hidden;\n    width: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    cursor: default;\n    z-index: 4;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    contain: style size layout;\n}\n\n.ace_gutter-active-line {\n    position: absolute;\n    left: 0;\n    right: 0;\n}\n\n.ace_scroller.ace_scroll-left:after {\n    content: "";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\n    pointer-events: none;\n}\n\n.ace_gutter-cell, .ace_gutter-cell_svg-icons {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding-left: 19px;\n    padding-right: 6px;\n    background-repeat: no-repeat;\n}\n\n.ace_gutter-cell_svg-icons .ace_gutter_annotation {\n    margin-left: -14px;\n    float: left;\n}\n\n.ace_gutter-cell .ace_gutter_annotation {\n    margin-left: -19px;\n    float: left;\n}\n\n.ace_gutter-cell.ace_error, .ace_icon.ace_error, .ace_icon.ace_error_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_warning, .ace_icon.ace_warning, .ace_icon.ace_warning_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_info, .ace_icon.ace_info {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n.ace_dark .ace_gutter-cell.ace_info, .ace_dark .ace_icon.ace_info {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC");\n}\n\n.ace_icon_svg.ace_error {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJyZWQiIHNoYXBlLXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIj4KPGNpcmNsZSBmaWxsPSJub25lIiBjeD0iOCIgY3k9IjgiIHI9IjciIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGxpbmUgeDE9IjExIiB5MT0iNSIgeDI9IjUiIHkyPSIxMSIvPgo8bGluZSB4MT0iMTEiIHkxPSIxMSIgeDI9IjUiIHkyPSI1Ii8+CjwvZz4KPC9zdmc+");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJkYXJrb3JhbmdlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+Cjxwb2x5Z29uIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGZpbGw9Im5vbmUiIHBvaW50cz0iOCAxIDE1IDE1IDEgMTUgOCAxIi8+CjxyZWN0IHg9IjgiIHk9IjEyIiB3aWR0aD0iMC4wMSIgaGVpZ2h0PSIwLjAxIi8+CjxsaW5lIHgxPSI4IiB5MT0iNiIgeDI9IjgiIHkyPSIxMCIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: darkorange;\n}\n.ace_icon_svg.ace_info {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJibHVlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+CjxjaXJjbGUgZmlsbD0ibm9uZSIgY3g9IjgiIGN5PSI4IiByPSI3IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjxwb2x5bGluZSBwb2ludHM9IjggMTEgOCA4Ii8+Cjxwb2x5bGluZSBwb2ludHM9IjkgOCA2IDgiLz4KPGxpbmUgeDE9IjEwIiB5MT0iMTEiIHgyPSI2IiB5Mj0iMTEiLz4KPHJlY3QgeD0iOCIgeT0iNSIgd2lkdGg9IjAuMDEiIGhlaWdodD0iMC4wMSIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: royalblue;\n}\n\n.ace_icon_svg.ace_error_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZD0ibSAxOC45Mjk4NTEsNy44Mjk4MDc2IGMgMC4xNDYzNTMsNi4zMzc0NjA0IC02LjMyMzE0Nyw3Ljc3Nzg0NDQgLTcuNDc3OTEyLDcuNzc3ODQ0NCAtMi4xMDcyNzI2LC0wLjEyODc1IDUuMTE3Njc4LDAuMzU2MjQ5IDUuMDUxNjk4LC03Ljg3MDA2MTggLTAuNjA0NjcyLC04LjAwMzk3MzQ5IC03LjA3NzI3MDYsLTcuNTYzMTE4OSAtNC44NTczLC03LjQzMDM5NTU2IDEuNjA2LC0wLjExNTE0MjI1IDYuODk3NDg1LDEuMjYyNTQ1OTYgNy4yODM1MTQsNy41MjI2MTI5NiB6IiBmaWxsPSJjcmltc29uIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0ibSA4LjExNDc1NjIsMi4wNTI5ODI4IGMgMy4zNDkxNjk4LDAgNi4wNjQxMzI4LDIuNjc2ODYyNyA2LjA2NDEzMjgsNS45Nzg5NTMgMCwzLjMwMjExMjIgLTIuNzE0OTYzLDUuOTc4OTIwMiAtNi4wNjQxMzI4LDUuOTc4OTIwMiAtMy4zNDkxNDczLDAgLTYuMDY0MTc3MiwtMi42NzY4MDggLTYuMDY0MTc3MiwtNS45Nzg5MjAyIDAuMDA1MzksLTMuMjk5ODg2MSAyLjcxNzI2NTYsLTUuOTczNjQwOCA2LjA2NDE3NzIsLTUuOTc4OTUzIHogbSAwLC0xLjczNTgyNzE5IGMgLTQuMzIxNDgzNiwwIC03LjgyNDc0MDM4LDMuNDU0MDE4NDkgLTcuODI0NzQwMzgsNy43MTQ3ODAxOSAwLDQuMjYwNzI4MiAzLjUwMzI1Njc4LDcuNzE0NzQ1MiA3LjgyNDc0MDM4LDcuNzE0NzQ1MiA0LjMyMTQ0OTgsMCA3LjgyNDY5OTgsLTMuNDU0MDE3IDcuODI0Njk5OCwtNy43MTQ3NDUyIDAsLTIuMDQ2MDkxNCAtMC44MjQzOTIsLTQuMDA4MzY3MiAtMi4yOTE3NTYsLTUuNDU1MTc0NiBDIDEyLjE4MDIyNSwxLjEyOTk2NDggMTAuMTkwMDEzLDAuMzE3MTU1NjEgOC4xMTQ3NTYyLDAuMzE3MTU1NjEgWiBNIDYuOTM3NDU2Myw4LjI0MDU5ODUgNC42NzE4Njg1LDEwLjQ4NTg1MiA2LjAwODY4MTQsMTEuODc2NzI4IDguMzE3MDAzNSw5LjYwMDc5MTEgMTAuNjI1MzM3LDExLjg3NjcyOCAxMS45NjIxMzgsMTAuNDg1ODUyIDkuNjk2NTUwOCw4LjI0MDU5ODUgMTEuOTYyMTM4LDYuMDA2ODA2NiAxMC41NzMyNDYsNC42Mzc0MzM1IDguMzE3MDAzNSw2Ljg3MzQyOTcgNi4wNjA3NjA3LDQuNjM3NDMzNSA0LjY3MTg2ODUsNi4wMDY4MDY2IFoiIGZpbGw9ImNyaW1zb24iIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4=");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC43NzY5IDE0LjczMzdMOC42NTE5MiAyLjQ4MzY5QzguMzI5NDYgMS44Mzg3NyA3LjQwOTEzIDEuODM4NzcgNy4wODY2NyAyLjQ4MzY5TDAuOTYxNjY5IDE0LjczMzdDMC42NzA3NzUgMTUuMzE1NSAxLjA5MzgzIDE2IDEuNzQ0MjkgMTZIMTMuOTk0M0MxNC42NDQ4IDE2IDE1LjA2NzggMTUuMzE1NSAxNC43NzY5IDE0LjczMzdaTTMuMTYwMDcgMTQuMjVMNy44NjkyOSA0LjgzMTU2TDEyLjU3ODUgMTQuMjVIMy4xNjAwN1pNOC43NDQyOSAxMS42MjVWMTMuMzc1SDYuOTk0MjlWMTEuNjI1SDguNzQ0MjlaTTYuOTk0MjkgMTAuNzVWNy4yNUg4Ljc0NDI5VjEwLjc1SDYuOTk0MjlaIiBmaWxsPSIjRUM3MjExIi8+CjxwYXRoIGQ9Ik0xMS4xOTkxIDIuOTUyMzhDMTAuODgwOSAyLjMxNDY3IDEwLjM1MzcgMS44MDUyNiA5LjcwNTUgMS41MDlMMTEuMDQxIDEuMDY5NzhDMTEuNjg4MyAwLjk0OTgxNCAxMi4zMzcgMS4yNzI2MyAxMi42MzE3IDEuODYxNDFMMTcuNjEzNiAxMS44MTYxQzE4LjM1MjcgMTMuMjkyOSAxNy41OTM4IDE1LjA4MDQgMTYuMDE4IDE1LjU3NDVDMTYuNDA0NCAxNC40NTA3IDE2LjMyMzEgMTMuMjE4OCAxNS43OTI0IDEyLjE1NTVMMTEuMTk5MSAyLjk1MjM4WiIgZmlsbD0iI0VDNzIxMSIvPgo8L3N2Zz4=");\n    background-color: darkorange;\n}\n\n.ace_scrollbar {\n    contain: strict;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 6;\n}\n\n.ace_scrollbar-inner {\n    position: absolute;\n    cursor: text;\n    left: 0;\n    top: 0;\n}\n\n.ace_scrollbar-v{\n    overflow-x: hidden;\n    overflow-y: scroll;\n    top: 0;\n}\n\n.ace_scrollbar-h {\n    overflow-x: scroll;\n    overflow-y: hidden;\n    left: 0;\n}\n\n.ace_print-margin {\n    position: absolute;\n    height: 100%;\n}\n\n.ace_text-input {\n    position: absolute;\n    z-index: 0;\n    width: 0.5em;\n    height: 1em;\n    opacity: 0;\n    background: transparent;\n    -moz-appearance: none;\n    appearance: none;\n    border: none;\n    resize: none;\n    outline: none;\n    overflow: hidden;\n    font: inherit;\n    padding: 0 1px;\n    margin: 0 -1px;\n    contain: strict;\n    -ms-user-select: text;\n    -moz-user-select: text;\n    -webkit-user-select: text;\n    user-select: text;\n    /*with `pre-line` chrome inserts &nbsp; instead of space*/\n    white-space: pre!important;\n}\n.ace_text-input.ace_composition {\n    background: transparent;\n    color: inherit;\n    z-index: 1000;\n    opacity: 1;\n}\n.ace_composition_placeholder { color: transparent }\n.ace_composition_marker { \n    border-bottom: 1px solid;\n    position: absolute;\n    border-radius: 0;\n    margin-top: 1px;\n}\n\n[ace_nocontext=true] {\n    transform: none!important;\n    filter: none!important;\n    clip-path: none!important;\n    mask : none!important;\n    contain: none!important;\n    perspective: none!important;\n    mix-blend-mode: initial!important;\n    z-index: auto;\n}\n\n.ace_layer {\n    z-index: 1;\n    position: absolute;\n    overflow: hidden;\n    /* workaround for chrome bug https://github.com/ajaxorg/ace/issues/2312*/\n    word-wrap: normal;\n    white-space: pre;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    /* setting pointer-events: auto; on node under the mouse, which changes\n        during scroll, will break mouse wheel scrolling in Safari */\n    pointer-events: none;\n}\n\n.ace_gutter-layer {\n    position: relative;\n    width: auto;\n    text-align: right;\n    pointer-events: auto;\n    height: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer {\n    font: inherit !important;\n    position: absolute;\n    height: 1000000px;\n    width: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer > .ace_line, .ace_text-layer > .ace_line_group {\n    contain: style size layout;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n.ace_hidpi .ace_text-layer,\n.ace_hidpi .ace_gutter-layer,\n.ace_hidpi .ace_content,\n.ace_hidpi .ace_gutter {\n    contain: strict;\n}\n.ace_hidpi .ace_text-layer > .ace_line, \n.ace_hidpi .ace_text-layer > .ace_line_group {\n    contain: strict;\n}\n\n.ace_cjk {\n    display: inline-block;\n    text-align: center;\n}\n\n.ace_cursor-layer {\n    z-index: 4;\n}\n\n.ace_cursor {\n    z-index: 4;\n    position: absolute;\n    box-sizing: border-box;\n    border-left: 2px solid;\n    /* workaround for smooth cursor repaintng whole screen in chrome */\n    transform: translatez(0);\n}\n\n.ace_multiselect .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_slim-cursors .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_overwrite-cursors .ace_cursor {\n    border-left-width: 0;\n    border-bottom: 1px solid;\n}\n\n.ace_hidden-cursors .ace_cursor {\n    opacity: 0.2;\n}\n\n.ace_hasPlaceholder .ace_hidden-cursors .ace_cursor {\n    opacity: 0;\n}\n\n.ace_smooth-blinking .ace_cursor {\n    transition: opacity 0.18s;\n}\n\n.ace_animate-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: step-end;\n    animation-name: blink-ace-animate;\n    animation-iteration-count: infinite;\n}\n\n.ace_animate-blinking.ace_smooth-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: ease-in-out;\n    animation-name: blink-ace-animate-smooth;\n}\n    \n@keyframes blink-ace-animate {\n    from, to { opacity: 1; }\n    60% { opacity: 0; }\n}\n\n@keyframes blink-ace-animate-smooth {\n    from, to { opacity: 1; }\n    45% { opacity: 1; }\n    60% { opacity: 0; }\n    85% { opacity: 0; }\n}\n\n.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\n    position: absolute;\n    z-index: 3;\n}\n\n.ace_marker-layer .ace_selection {\n    position: absolute;\n    z-index: 5;\n}\n\n.ace_marker-layer .ace_bracket {\n    position: absolute;\n    z-index: 6;\n}\n\n.ace_marker-layer .ace_error_bracket {\n    position: absolute;\n    border-bottom: 1px solid #DE5555;\n    border-radius: 0;\n}\n\n.ace_marker-layer .ace_active-line {\n    position: absolute;\n    z-index: 2;\n}\n\n.ace_marker-layer .ace_selected-word {\n    position: absolute;\n    z-index: 4;\n    box-sizing: border-box;\n}\n\n.ace_line .ace_fold {\n    box-sizing: border-box;\n\n    display: inline-block;\n    height: 11px;\n    margin-top: -2px;\n    vertical-align: middle;\n\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=");\n    background-repeat: no-repeat, repeat-x;\n    background-position: center center, top left;\n    color: transparent;\n\n    border: 1px solid black;\n    border-radius: 2px;\n\n    cursor: pointer;\n    pointer-events: auto;\n}\n\n.ace_dark .ace_fold {\n}\n\n.ace_fold:hover{\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC");\n}\n\n.ace_tooltip {\n    background-color: #f5f5f5;\n    border: 1px solid gray;\n    border-radius: 1px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n    color: black;\n    max-width: 100%;\n    padding: 3px 4px;\n    position: fixed;\n    z-index: 999999;\n    box-sizing: border-box;\n    cursor: default;\n    white-space: pre;\n    word-wrap: break-word;\n    line-height: normal;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    pointer-events: none;\n}\n\n.ace_tooltip.ace_dark {\n    background-color: #636363;\n    color: #fff;\n}\n\n.ace_tooltip:focus {\n    outline: 1px solid #5E9ED6;\n}\n\n.ace_icon {\n    display: inline-block;\n    width: 18px;\n    vertical-align: top;\n}\n\n.ace_icon_svg {\n    display: inline-block;\n    width: 12px;\n    vertical-align: top;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-size: 12px;\n    -webkit-mask-position: center;\n}\n\n.ace_folding-enabled > .ace_gutter-cell, .ace_folding-enabled > .ace_gutter-cell_svg-icons {\n    padding-right: 13px;\n}\n\n.ace_fold-widget {\n    box-sizing: border-box;\n\n    margin: 0 -12px 0 1px;\n    display: none;\n    width: 11px;\n    vertical-align: top;\n\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: center;\n\n    border-radius: 3px;\n    \n    border: 1px solid transparent;\n    cursor: pointer;\n}\n\n.ace_folding-enabled .ace_fold-widget {\n    display: inline-block;   \n}\n\n.ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==");\n}\n\n.ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==");\n}\n\n.ace_fold-widget:hover {\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: rgba(255, 255, 255, 0.2);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\n}\n\n.ace_fold-widget:active {\n    border: 1px solid rgba(0, 0, 0, 0.4);\n    background-color: rgba(0, 0, 0, 0.05);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\n}\n/**\n * Dark version for fold widgets\n */\n.ace_dark .ace_fold-widget {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC");\n}\n.ace_dark .ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget:hover {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n    background-color: rgba(255, 255, 255, 0.1);\n}\n.ace_dark .ace_fold-widget:active {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n}\n\n.ace_inline_button {\n    border: 1px solid lightgray;\n    display: inline-block;\n    margin: -1px 8px;\n    padding: 0 5px;\n    pointer-events: auto;\n    cursor: pointer;\n}\n.ace_inline_button:hover {\n    border-color: gray;\n    background: rgba(200,200,200,0.2);\n    display: inline-block;\n    pointer-events: auto;\n}\n\n.ace_fold-widget.ace_invalid {\n    background-color: #FFB4B4;\n    border-color: #DE5555;\n}\n\n.ace_fade-fold-widgets .ace_fold-widget {\n    transition: opacity 0.4s ease 0.05s;\n    opacity: 0;\n}\n\n.ace_fade-fold-widgets:hover .ace_fold-widget {\n    transition: opacity 0.05s ease 0.05s;\n    opacity:1;\n}\n\n.ace_underline {\n    text-decoration: underline;\n}\n\n.ace_bold {\n    font-weight: bold;\n}\n\n.ace_nobold .ace_bold {\n    font-weight: normal;\n}\n\n.ace_italic {\n    font-style: italic;\n}\n\n\n.ace_error-marker {\n    background-color: rgba(255, 0, 0,0.2);\n    position: absolute;\n    z-index: 9;\n}\n\n.ace_highlight-marker {\n    background-color: rgba(255, 255, 0,0.2);\n    position: absolute;\n    z-index: 8;\n}\n\n.ace_mobile-menu {\n    position: absolute;\n    line-height: 1.5;\n    border-radius: 4px;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    background: white;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #dcdcdc;\n    color: black;\n}\n.ace_dark > .ace_mobile-menu {\n    background: #333;\n    color: #ccc;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #444;\n\n}\n.ace_mobile-button {\n    padding: 2px;\n    cursor: pointer;\n    overflow: hidden;\n}\n.ace_mobile-button:hover {\n    background-color: #eee;\n    opacity:1;\n}\n.ace_mobile-button:active {\n    background-color: #ddd;\n}\n\n.ace_placeholder {\n    font-family: arial;\n    transform: scale(0.9);\n    transform-origin: left;\n    white-space: pre;\n    opacity: 0.7;\n    margin: 0 10px;\n}\n\n.ace_ghost_text {\n    opacity: 0.5;\n    font-style: italic;\n    white-space: pre;\n}';
});
ace.define("ace/layer/decorators", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/lib/oop",
    "ace/lib/event_emitter"
], function(require, exports, module1) {
    "use strict";
    var dom = require("../lib/dom");
    var oop = require("../lib/oop");
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var Decorator = /** @class */ function() {
        function Decorator(parent, renderer) {
            this.canvas = dom.createElement("canvas");
            this.renderer = renderer;
            this.pixelRatio = 1;
            this.maxHeight = renderer.layerConfig.maxHeight;
            this.lineHeight = renderer.layerConfig.lineHeight;
            this.canvasHeight = parent.parent.scrollHeight;
            this.heightRatio = this.canvasHeight / this.maxHeight;
            this.canvasWidth = parent.width;
            this.minDecorationHeight = 2 * this.pixelRatio | 0;
            this.halfMinDecorationHeight = this.minDecorationHeight / 2 | 0;
            this.canvas.width = this.canvasWidth;
            this.canvas.height = this.canvasHeight;
            this.canvas.style.top = "0px";
            this.canvas.style.right = "0px";
            this.canvas.style.zIndex = "7px";
            this.canvas.style.position = "absolute";
            this.colors = {};
            this.colors.dark = {
                "error": "rgba(255, 18, 18, 1)",
                "warning": "rgba(18, 136, 18, 1)",
                "info": "rgba(18, 18, 136, 1)"
            };
            this.colors.light = {
                "error": "rgb(255,51,51)",
                "warning": "rgb(32,133,72)",
                "info": "rgb(35,68,138)"
            };
            parent.element.appendChild(this.canvas);
        }
        Decorator.prototype.$updateDecorators = function(config) {
            var colors = this.renderer.theme.isDark === true ? this.colors.dark : this.colors.light;
            if (config) {
                this.maxHeight = config.maxHeight;
                this.lineHeight = config.lineHeight;
                this.canvasHeight = config.height;
                var allLineHeight = (config.lastRow + 1) * this.lineHeight;
                if (allLineHeight < this.canvasHeight) this.heightRatio = 1;
                else this.heightRatio = this.canvasHeight / this.maxHeight;
            }
            var ctx = this.canvas.getContext("2d");
            function compare(a, b) {
                if (a.priority < b.priority) return -1;
                if (a.priority > b.priority) return 1;
                return 0;
            }
            var annotations = this.renderer.session.$annotations;
            ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            if (annotations) {
                var priorities = {
                    "info": 1,
                    "warning": 2,
                    "error": 3
                };
                annotations.forEach(function(item) {
                    item.priority = priorities[item.type] || null;
                });
                annotations = annotations.sort(compare);
                var foldData = this.renderer.session.$foldData;
                for(var i = 0; i < annotations.length; i++){
                    var row = annotations[i].row;
                    var compensateFold = this.compensateFoldRows(row, foldData);
                    var currentY = Math.round((row - compensateFold) * this.lineHeight * this.heightRatio);
                    var y1 = Math.round((row - compensateFold) * this.lineHeight * this.heightRatio);
                    var y2 = Math.round(((row - compensateFold) * this.lineHeight + this.lineHeight) * this.heightRatio);
                    var height = y2 - y1;
                    if (height < this.minDecorationHeight) {
                        var yCenter = (y1 + y2) / 2 | 0;
                        if (yCenter < this.halfMinDecorationHeight) yCenter = this.halfMinDecorationHeight;
                        else if (yCenter + this.halfMinDecorationHeight > this.canvasHeight) yCenter = this.canvasHeight - this.halfMinDecorationHeight;
                        y1 = Math.round(yCenter - this.halfMinDecorationHeight);
                        y2 = Math.round(yCenter + this.halfMinDecorationHeight);
                    }
                    ctx.fillStyle = colors[annotations[i].type] || null;
                    ctx.fillRect(0, currentY, this.canvasWidth, y2 - y1);
                }
            }
            var cursor = this.renderer.session.selection.getCursor();
            if (cursor) {
                var compensateFold = this.compensateFoldRows(cursor.row, foldData);
                var currentY = Math.round((cursor.row - compensateFold) * this.lineHeight * this.heightRatio);
                ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
                ctx.fillRect(0, currentY, this.canvasWidth, 2);
            }
        };
        Decorator.prototype.compensateFoldRows = function(row, foldData) {
            var compensateFold = 0;
            if (foldData && foldData.length > 0) for(var j = 0; j < foldData.length; j++){
                if (row > foldData[j].start.row && row < foldData[j].end.row) compensateFold += row - foldData[j].start.row;
                else if (row >= foldData[j].end.row) compensateFold += foldData[j].end.row - foldData[j].start.row;
            }
            return compensateFold;
        };
        return Decorator;
    }();
    oop.implement(Decorator.prototype, EventEmitter);
    exports.Decorator = Decorator;
});
ace.define("ace/virtual_renderer", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/dom",
    "ace/lib/lang",
    "ace/config",
    "ace/layer/gutter",
    "ace/layer/marker",
    "ace/layer/text",
    "ace/layer/cursor",
    "ace/scrollbar",
    "ace/scrollbar",
    "ace/scrollbar_custom",
    "ace/scrollbar_custom",
    "ace/renderloop",
    "ace/layer/font_metrics",
    "ace/lib/event_emitter",
    "ace/css/editor-css",
    "ace/layer/decorators",
    "ace/lib/useragent"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var dom = require("./lib/dom");
    var lang = require("./lib/lang");
    var config = require("./config");
    var GutterLayer = require("./layer/gutter").Gutter;
    var MarkerLayer = require("./layer/marker").Marker;
    var TextLayer = require("./layer/text").Text;
    var CursorLayer = require("./layer/cursor").Cursor;
    var HScrollBar = require("./scrollbar").HScrollBar;
    var VScrollBar = require("./scrollbar").VScrollBar;
    var HScrollBarCustom = require("./scrollbar_custom").HScrollBar;
    var VScrollBarCustom = require("./scrollbar_custom").VScrollBar;
    var RenderLoop = require("./renderloop").RenderLoop;
    var FontMetrics = require("./layer/font_metrics").FontMetrics;
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var editorCss = require("./css/editor-css");
    var Decorator = require("./layer/decorators").Decorator;
    var useragent = require("./lib/useragent");
    dom.importCssString(editorCss, "ace_editor.css", false);
    var VirtualRenderer = /** @class */ function() {
        function VirtualRenderer(container, theme) {
            var _self = this;
            this.container = container || dom.createElement("div");
            dom.addCssClass(this.container, "ace_editor");
            if (dom.HI_DPI) dom.addCssClass(this.container, "ace_hidpi");
            this.setTheme(theme);
            if (config.get("useStrictCSP") == null) config.set("useStrictCSP", false);
            this.$gutter = dom.createElement("div");
            this.$gutter.className = "ace_gutter";
            this.container.appendChild(this.$gutter);
            this.$gutter.setAttribute("aria-hidden", true);
            this.scroller = dom.createElement("div");
            this.scroller.className = "ace_scroller";
            this.container.appendChild(this.scroller);
            this.content = dom.createElement("div");
            this.content.className = "ace_content";
            this.scroller.appendChild(this.content);
            this.$gutterLayer = new GutterLayer(this.$gutter);
            this.$gutterLayer.on("changeGutterWidth", this.onGutterResize.bind(this));
            this.$markerBack = new MarkerLayer(this.content);
            var textLayer = this.$textLayer = new TextLayer(this.content);
            this.canvas = textLayer.element;
            this.$markerFront = new MarkerLayer(this.content);
            this.$cursorLayer = new CursorLayer(this.content);
            this.$horizScroll = false;
            this.$vScroll = false;
            this.scrollBar = this.scrollBarV = new VScrollBar(this.container, this);
            this.scrollBarH = new HScrollBar(this.container, this);
            this.scrollBarV.on("scroll", function(e) {
                if (!_self.$scrollAnimation) _self.session.setScrollTop(e.data - _self.scrollMargin.top);
            });
            this.scrollBarH.on("scroll", function(e) {
                if (!_self.$scrollAnimation) _self.session.setScrollLeft(e.data - _self.scrollMargin.left);
            });
            this.scrollTop = 0;
            this.scrollLeft = 0;
            this.cursorPos = {
                row: 0,
                column: 0
            };
            this.$fontMetrics = new FontMetrics(this.container);
            this.$textLayer.$setFontMetrics(this.$fontMetrics);
            this.$textLayer.on("changeCharacterSize", function(e) {
                _self.updateCharacterSize();
                _self.onResize(true, _self.gutterWidth, _self.$size.width, _self.$size.height);
                _self._signal("changeCharacterSize", e);
            });
            this.$size = {
                width: 0,
                height: 0,
                scrollerHeight: 0,
                scrollerWidth: 0,
                $dirty: true
            };
            this.layerConfig = {
                width: 1,
                padding: 0,
                firstRow: 0,
                firstRowScreen: 0,
                lastRow: 0,
                lineHeight: 0,
                characterWidth: 0,
                minHeight: 1,
                maxHeight: 1,
                offset: 0,
                height: 1,
                gutterOffset: 1
            };
            this.scrollMargin = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                v: 0,
                h: 0
            };
            this.margin = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                v: 0,
                h: 0
            };
            this.$keepTextAreaAtCursor = !useragent.isIOS;
            this.$loop = new RenderLoop(this.$renderChanges.bind(this), this.container.ownerDocument.defaultView);
            this.$loop.schedule(this.CHANGE_FULL);
            this.updateCharacterSize();
            this.setPadding(4);
            this.$addResizeObserver();
            config.resetOptions(this);
            config._signal("renderer", this);
        }
        VirtualRenderer.prototype.updateCharacterSize = function() {
            if (this.$textLayer.allowBoldFonts != this.$allowBoldFonts) {
                this.$allowBoldFonts = this.$textLayer.allowBoldFonts;
                this.setStyle("ace_nobold", !this.$allowBoldFonts);
            }
            this.layerConfig.characterWidth = this.characterWidth = this.$textLayer.getCharacterWidth();
            this.layerConfig.lineHeight = this.lineHeight = this.$textLayer.getLineHeight();
            this.$updatePrintMargin();
            dom.setStyle(this.scroller.style, "line-height", this.lineHeight + "px");
        };
        VirtualRenderer.prototype.setSession = function(session) {
            if (this.session) this.session.doc.off("changeNewLineMode", this.onChangeNewLineMode);
            this.session = session;
            if (session && this.scrollMargin.top && session.getScrollTop() <= 0) session.setScrollTop(-this.scrollMargin.top);
            this.$cursorLayer.setSession(session);
            this.$markerBack.setSession(session);
            this.$markerFront.setSession(session);
            this.$gutterLayer.setSession(session);
            this.$textLayer.setSession(session);
            if (!session) return;
            this.$loop.schedule(this.CHANGE_FULL);
            this.session.$setFontMetrics(this.$fontMetrics);
            this.scrollBarH.scrollLeft = this.scrollBarV.scrollTop = null;
            this.onChangeNewLineMode = this.onChangeNewLineMode.bind(this);
            this.onChangeNewLineMode();
            this.session.doc.on("changeNewLineMode", this.onChangeNewLineMode);
        };
        VirtualRenderer.prototype.updateLines = function(firstRow, lastRow, force) {
            if (lastRow === undefined) lastRow = Infinity;
            if (!this.$changedLines) this.$changedLines = {
                firstRow: firstRow,
                lastRow: lastRow
            };
            else {
                if (this.$changedLines.firstRow > firstRow) this.$changedLines.firstRow = firstRow;
                if (this.$changedLines.lastRow < lastRow) this.$changedLines.lastRow = lastRow;
            }
            if (this.$changedLines.lastRow < this.layerConfig.firstRow) {
                if (force) this.$changedLines.lastRow = this.layerConfig.lastRow;
                else return;
            }
            if (this.$changedLines.firstRow > this.layerConfig.lastRow) return;
            this.$loop.schedule(this.CHANGE_LINES);
        };
        VirtualRenderer.prototype.onChangeNewLineMode = function() {
            this.$loop.schedule(this.CHANGE_TEXT);
            this.$textLayer.$updateEolChar();
            this.session.$bidiHandler.setEolChar(this.$textLayer.EOL_CHAR);
        };
        VirtualRenderer.prototype.onChangeTabSize = function() {
            this.$loop.schedule(this.CHANGE_TEXT | this.CHANGE_MARKER);
            this.$textLayer.onChangeTabSize();
        };
        VirtualRenderer.prototype.updateText = function() {
            this.$loop.schedule(this.CHANGE_TEXT);
        };
        VirtualRenderer.prototype.updateFull = function(force) {
            if (force) this.$renderChanges(this.CHANGE_FULL, true);
            else this.$loop.schedule(this.CHANGE_FULL);
        };
        VirtualRenderer.prototype.updateFontSize = function() {
            this.$textLayer.checkForSizeChanges();
        };
        VirtualRenderer.prototype.$updateSizeAsync = function() {
            if (this.$loop.pending) this.$size.$dirty = true;
            else this.onResize();
        };
        VirtualRenderer.prototype.onResize = function(force, gutterWidth, width, height) {
            if (this.resizing > 2) return;
            else if (this.resizing > 0) this.resizing++;
            else this.resizing = force ? 1 : 0;
            var el = this.container;
            if (!height) height = el.clientHeight || el.scrollHeight;
            if (!width) width = el.clientWidth || el.scrollWidth;
            var changes = this.$updateCachedSize(force, gutterWidth, width, height);
            if (this.$resizeTimer) this.$resizeTimer.cancel();
            if (!this.$size.scrollerHeight || !width && !height) return this.resizing = 0;
            if (force) this.$gutterLayer.$padding = null;
            if (force) this.$renderChanges(changes | this.$changes, true);
            else this.$loop.schedule(changes | this.$changes);
            if (this.resizing) this.resizing = 0;
            this.scrollBarH.scrollLeft = this.scrollBarV.scrollTop = null;
            if (this.$customScrollbar) this.$updateCustomScrollbar(true);
        };
        VirtualRenderer.prototype.$updateCachedSize = function(force, gutterWidth, width, height) {
            height -= this.$extraHeight || 0;
            var changes = 0;
            var size = this.$size;
            var oldSize = {
                width: size.width,
                height: size.height,
                scrollerHeight: size.scrollerHeight,
                scrollerWidth: size.scrollerWidth
            };
            if (height && (force || size.height != height)) {
                size.height = height;
                changes |= this.CHANGE_SIZE;
                size.scrollerHeight = size.height;
                if (this.$horizScroll) size.scrollerHeight -= this.scrollBarH.getHeight();
                this.scrollBarV.setHeight(size.scrollerHeight);
                this.scrollBarV.element.style.bottom = this.scrollBarH.getHeight() + "px";
                changes = changes | this.CHANGE_SCROLL;
            }
            if (width && (force || size.width != width)) {
                changes |= this.CHANGE_SIZE;
                size.width = width;
                if (gutterWidth == null) gutterWidth = this.$showGutter ? this.$gutter.offsetWidth : 0;
                this.gutterWidth = gutterWidth;
                dom.setStyle(this.scrollBarH.element.style, "left", gutterWidth + "px");
                dom.setStyle(this.scroller.style, "left", gutterWidth + this.margin.left + "px");
                size.scrollerWidth = Math.max(0, width - gutterWidth - this.scrollBarV.getWidth() - this.margin.h);
                dom.setStyle(this.$gutter.style, "left", this.margin.left + "px");
                var right = this.scrollBarV.getWidth() + "px";
                dom.setStyle(this.scrollBarH.element.style, "right", right);
                dom.setStyle(this.scroller.style, "right", right);
                dom.setStyle(this.scroller.style, "bottom", this.scrollBarH.getHeight());
                this.scrollBarH.setWidth(size.scrollerWidth);
                if (this.session && this.session.getUseWrapMode() && this.adjustWrapLimit() || force) changes |= this.CHANGE_FULL;
            }
            size.$dirty = !width || !height;
            if (changes) this._signal("resize", oldSize);
            return changes;
        };
        VirtualRenderer.prototype.onGutterResize = function(width) {
            var gutterWidth = this.$showGutter ? width : 0;
            if (gutterWidth != this.gutterWidth) this.$changes |= this.$updateCachedSize(true, gutterWidth, this.$size.width, this.$size.height);
            if (this.session.getUseWrapMode() && this.adjustWrapLimit()) this.$loop.schedule(this.CHANGE_FULL);
            else if (this.$size.$dirty) this.$loop.schedule(this.CHANGE_FULL);
            else this.$computeLayerConfig();
        };
        VirtualRenderer.prototype.adjustWrapLimit = function() {
            var availableWidth = this.$size.scrollerWidth - this.$padding * 2;
            var limit = Math.floor(availableWidth / this.characterWidth);
            return this.session.adjustWrapLimit(limit, this.$showPrintMargin && this.$printMarginColumn);
        };
        VirtualRenderer.prototype.setAnimatedScroll = function(shouldAnimate) {
            this.setOption("animatedScroll", shouldAnimate);
        };
        VirtualRenderer.prototype.getAnimatedScroll = function() {
            return this.$animatedScroll;
        };
        VirtualRenderer.prototype.setShowInvisibles = function(showInvisibles) {
            this.setOption("showInvisibles", showInvisibles);
            this.session.$bidiHandler.setShowInvisibles(showInvisibles);
        };
        VirtualRenderer.prototype.getShowInvisibles = function() {
            return this.getOption("showInvisibles");
        };
        VirtualRenderer.prototype.getDisplayIndentGuides = function() {
            return this.getOption("displayIndentGuides");
        };
        VirtualRenderer.prototype.setDisplayIndentGuides = function(display) {
            this.setOption("displayIndentGuides", display);
        };
        VirtualRenderer.prototype.getHighlightIndentGuides = function() {
            return this.getOption("highlightIndentGuides");
        };
        VirtualRenderer.prototype.setHighlightIndentGuides = function(highlight) {
            this.setOption("highlightIndentGuides", highlight);
        };
        VirtualRenderer.prototype.setShowPrintMargin = function(showPrintMargin) {
            this.setOption("showPrintMargin", showPrintMargin);
        };
        VirtualRenderer.prototype.getShowPrintMargin = function() {
            return this.getOption("showPrintMargin");
        };
        VirtualRenderer.prototype.setPrintMarginColumn = function(showPrintMargin) {
            this.setOption("printMarginColumn", showPrintMargin);
        };
        VirtualRenderer.prototype.getPrintMarginColumn = function() {
            return this.getOption("printMarginColumn");
        };
        VirtualRenderer.prototype.getShowGutter = function() {
            return this.getOption("showGutter");
        };
        VirtualRenderer.prototype.setShowGutter = function(show) {
            return this.setOption("showGutter", show);
        };
        VirtualRenderer.prototype.getFadeFoldWidgets = function() {
            return this.getOption("fadeFoldWidgets");
        };
        VirtualRenderer.prototype.setFadeFoldWidgets = function(show) {
            this.setOption("fadeFoldWidgets", show);
        };
        VirtualRenderer.prototype.setHighlightGutterLine = function(shouldHighlight) {
            this.setOption("highlightGutterLine", shouldHighlight);
        };
        VirtualRenderer.prototype.getHighlightGutterLine = function() {
            return this.getOption("highlightGutterLine");
        };
        VirtualRenderer.prototype.$updatePrintMargin = function() {
            if (!this.$showPrintMargin && !this.$printMarginEl) return;
            if (!this.$printMarginEl) {
                var containerEl = dom.createElement("div");
                containerEl.className = "ace_layer ace_print-margin-layer";
                this.$printMarginEl = dom.createElement("div");
                this.$printMarginEl.className = "ace_print-margin";
                containerEl.appendChild(this.$printMarginEl);
                this.content.insertBefore(containerEl, this.content.firstChild);
            }
            var style = this.$printMarginEl.style;
            style.left = Math.round(this.characterWidth * this.$printMarginColumn + this.$padding) + "px";
            style.visibility = this.$showPrintMargin ? "visible" : "hidden";
            if (this.session && this.session.$wrap == -1) this.adjustWrapLimit();
        };
        VirtualRenderer.prototype.getContainerElement = function() {
            return this.container;
        };
        VirtualRenderer.prototype.getMouseEventTarget = function() {
            return this.scroller;
        };
        VirtualRenderer.prototype.getTextAreaContainer = function() {
            return this.container;
        };
        VirtualRenderer.prototype.$moveTextAreaToCursor = function() {
            if (this.$isMousePressed) return;
            var style = this.textarea.style;
            var composition = this.$composition;
            if (!this.$keepTextAreaAtCursor && !composition) {
                dom.translate(this.textarea, -100, 0);
                return;
            }
            var pixelPos = this.$cursorLayer.$pixelPos;
            if (!pixelPos) return;
            if (composition && composition.markerRange) pixelPos = this.$cursorLayer.getPixelPosition(composition.markerRange.start, true);
            var config = this.layerConfig;
            var posTop = pixelPos.top;
            var posLeft = pixelPos.left;
            posTop -= config.offset;
            var h = composition && composition.useTextareaForIME || useragent.isMobile ? this.lineHeight : 1;
            if (posTop < 0 || posTop > config.height - h) {
                dom.translate(this.textarea, 0, 0);
                return;
            }
            var w = 1;
            var maxTop = this.$size.height - h;
            if (!composition) posTop += this.lineHeight;
            else if (composition.useTextareaForIME) {
                var val = this.textarea.value;
                w = this.characterWidth * this.session.$getStringScreenWidth(val)[0];
            } else posTop += this.lineHeight + 2;
            posLeft -= this.scrollLeft;
            if (posLeft > this.$size.scrollerWidth - w) posLeft = this.$size.scrollerWidth - w;
            posLeft += this.gutterWidth + this.margin.left;
            dom.setStyle(style, "height", h + "px");
            dom.setStyle(style, "width", w + "px");
            dom.translate(this.textarea, Math.min(posLeft, this.$size.scrollerWidth - w), Math.min(posTop, maxTop));
        };
        VirtualRenderer.prototype.getFirstVisibleRow = function() {
            return this.layerConfig.firstRow;
        };
        VirtualRenderer.prototype.getFirstFullyVisibleRow = function() {
            return this.layerConfig.firstRow + (this.layerConfig.offset === 0 ? 0 : 1);
        };
        VirtualRenderer.prototype.getLastFullyVisibleRow = function() {
            var config = this.layerConfig;
            var lastRow = config.lastRow;
            var top = this.session.documentToScreenRow(lastRow, 0) * config.lineHeight;
            if (top - this.session.getScrollTop() > config.height - config.lineHeight) return lastRow - 1;
            return lastRow;
        };
        VirtualRenderer.prototype.getLastVisibleRow = function() {
            return this.layerConfig.lastRow;
        };
        VirtualRenderer.prototype.setPadding = function(padding) {
            this.$padding = padding;
            this.$textLayer.setPadding(padding);
            this.$cursorLayer.setPadding(padding);
            this.$markerFront.setPadding(padding);
            this.$markerBack.setPadding(padding);
            this.$loop.schedule(this.CHANGE_FULL);
            this.$updatePrintMargin();
        };
        VirtualRenderer.prototype.setScrollMargin = function(top, bottom, left, right) {
            var sm = this.scrollMargin;
            sm.top = top | 0;
            sm.bottom = bottom | 0;
            sm.right = right | 0;
            sm.left = left | 0;
            sm.v = sm.top + sm.bottom;
            sm.h = sm.left + sm.right;
            if (sm.top && this.scrollTop <= 0 && this.session) this.session.setScrollTop(-sm.top);
            this.updateFull();
        };
        VirtualRenderer.prototype.setMargin = function(top, bottom, left, right) {
            var sm = this.margin;
            sm.top = top | 0;
            sm.bottom = bottom | 0;
            sm.right = right | 0;
            sm.left = left | 0;
            sm.v = sm.top + sm.bottom;
            sm.h = sm.left + sm.right;
            this.$updateCachedSize(true, this.gutterWidth, this.$size.width, this.$size.height);
            this.updateFull();
        };
        VirtualRenderer.prototype.getHScrollBarAlwaysVisible = function() {
            return this.$hScrollBarAlwaysVisible;
        };
        VirtualRenderer.prototype.setHScrollBarAlwaysVisible = function(alwaysVisible) {
            this.setOption("hScrollBarAlwaysVisible", alwaysVisible);
        };
        VirtualRenderer.prototype.getVScrollBarAlwaysVisible = function() {
            return this.$vScrollBarAlwaysVisible;
        };
        VirtualRenderer.prototype.setVScrollBarAlwaysVisible = function(alwaysVisible) {
            this.setOption("vScrollBarAlwaysVisible", alwaysVisible);
        };
        VirtualRenderer.prototype.$updateScrollBarV = function() {
            var scrollHeight = this.layerConfig.maxHeight;
            var scrollerHeight = this.$size.scrollerHeight;
            if (!this.$maxLines && this.$scrollPastEnd) {
                scrollHeight -= (scrollerHeight - this.lineHeight) * this.$scrollPastEnd;
                if (this.scrollTop > scrollHeight - scrollerHeight) {
                    scrollHeight = this.scrollTop + scrollerHeight;
                    this.scrollBarV.scrollTop = null;
                }
            }
            this.scrollBarV.setScrollHeight(scrollHeight + this.scrollMargin.v);
            this.scrollBarV.setScrollTop(this.scrollTop + this.scrollMargin.top);
        };
        VirtualRenderer.prototype.$updateScrollBarH = function() {
            this.scrollBarH.setScrollWidth(this.layerConfig.width + 2 * this.$padding + this.scrollMargin.h);
            this.scrollBarH.setScrollLeft(this.scrollLeft + this.scrollMargin.left);
        };
        VirtualRenderer.prototype.freeze = function() {
            this.$frozen = true;
        };
        VirtualRenderer.prototype.unfreeze = function() {
            this.$frozen = false;
        };
        VirtualRenderer.prototype.$renderChanges = function(changes, force) {
            if (this.$changes) {
                changes |= this.$changes;
                this.$changes = 0;
            }
            if (!this.session || !this.container.offsetWidth || this.$frozen || !changes && !force) {
                this.$changes |= changes;
                return;
            }
            if (this.$size.$dirty) {
                this.$changes |= changes;
                return this.onResize(true);
            }
            if (!this.lineHeight) this.$textLayer.checkForSizeChanges();
            this._signal("beforeRender", changes);
            if (this.session && this.session.$bidiHandler) this.session.$bidiHandler.updateCharacterWidths(this.$fontMetrics);
            var config = this.layerConfig;
            if (changes & this.CHANGE_FULL || changes & this.CHANGE_SIZE || changes & this.CHANGE_TEXT || changes & this.CHANGE_LINES || changes & this.CHANGE_SCROLL || changes & this.CHANGE_H_SCROLL) {
                changes |= this.$computeLayerConfig() | this.$loop.clear();
                if (config.firstRow != this.layerConfig.firstRow && config.firstRowScreen == this.layerConfig.firstRowScreen) {
                    var st = this.scrollTop + (config.firstRow - Math.max(this.layerConfig.firstRow, 0)) * this.lineHeight;
                    if (st > 0) {
                        this.scrollTop = st;
                        changes = changes | this.CHANGE_SCROLL;
                        changes |= this.$computeLayerConfig() | this.$loop.clear();
                    }
                }
                config = this.layerConfig;
                this.$updateScrollBarV();
                if (changes & this.CHANGE_H_SCROLL) this.$updateScrollBarH();
                dom.translate(this.content, -this.scrollLeft, -config.offset);
                var width = config.width + 2 * this.$padding + "px";
                var height = config.minHeight + "px";
                dom.setStyle(this.content.style, "width", width);
                dom.setStyle(this.content.style, "height", height);
            }
            if (changes & this.CHANGE_H_SCROLL) {
                dom.translate(this.content, -this.scrollLeft, -config.offset);
                this.scroller.className = this.scrollLeft <= 0 ? "ace_scroller " : "ace_scroller ace_scroll-left ";
                if (this.enableKeyboardAccessibility) this.scroller.className += this.keyboardFocusClassName;
            }
            if (changes & this.CHANGE_FULL) {
                this.$changedLines = null;
                this.$textLayer.update(config);
                if (this.$showGutter) this.$gutterLayer.update(config);
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
                this.$markerBack.update(config);
                this.$markerFront.update(config);
                this.$cursorLayer.update(config);
                this.$moveTextAreaToCursor();
                this._signal("afterRender", changes);
                return;
            }
            if (changes & this.CHANGE_SCROLL) {
                this.$changedLines = null;
                if (changes & this.CHANGE_TEXT || changes & this.CHANGE_LINES) this.$textLayer.update(config);
                else this.$textLayer.scrollLines(config);
                if (this.$showGutter) {
                    if (changes & this.CHANGE_GUTTER || changes & this.CHANGE_LINES) this.$gutterLayer.update(config);
                    else this.$gutterLayer.scrollLines(config);
                }
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
                this.$markerBack.update(config);
                this.$markerFront.update(config);
                this.$cursorLayer.update(config);
                this.$moveTextAreaToCursor();
                this._signal("afterRender", changes);
                return;
            }
            if (changes & this.CHANGE_TEXT) {
                this.$changedLines = null;
                this.$textLayer.update(config);
                if (this.$showGutter) this.$gutterLayer.update(config);
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
            } else if (changes & this.CHANGE_LINES) {
                if (this.$updateLines() || changes & this.CHANGE_GUTTER && this.$showGutter) this.$gutterLayer.update(config);
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
            } else if (changes & this.CHANGE_TEXT || changes & this.CHANGE_GUTTER) {
                if (this.$showGutter) this.$gutterLayer.update(config);
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
            } else if (changes & this.CHANGE_CURSOR) {
                if (this.$highlightGutterLine) this.$gutterLayer.updateLineHighlight(config);
                if (this.$customScrollbar) this.$scrollDecorator.$updateDecorators(config);
            }
            if (changes & this.CHANGE_CURSOR) {
                this.$cursorLayer.update(config);
                this.$moveTextAreaToCursor();
            }
            if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_FRONT)) this.$markerFront.update(config);
            if (changes & (this.CHANGE_MARKER | this.CHANGE_MARKER_BACK)) this.$markerBack.update(config);
            this._signal("afterRender", changes);
        };
        VirtualRenderer.prototype.$autosize = function() {
            var height = this.session.getScreenLength() * this.lineHeight;
            var maxHeight = this.$maxLines * this.lineHeight;
            var desiredHeight = Math.min(maxHeight, Math.max((this.$minLines || 1) * this.lineHeight, height)) + this.scrollMargin.v + (this.$extraHeight || 0);
            if (this.$horizScroll) desiredHeight += this.scrollBarH.getHeight();
            if (this.$maxPixelHeight && desiredHeight > this.$maxPixelHeight) desiredHeight = this.$maxPixelHeight;
            var hideScrollbars = desiredHeight <= 2 * this.lineHeight;
            var vScroll = !hideScrollbars && height > maxHeight;
            if (desiredHeight != this.desiredHeight || this.$size.height != this.desiredHeight || vScroll != this.$vScroll) {
                if (vScroll != this.$vScroll) {
                    this.$vScroll = vScroll;
                    this.scrollBarV.setVisible(vScroll);
                }
                var w = this.container.clientWidth;
                this.container.style.height = desiredHeight + "px";
                this.$updateCachedSize(true, this.$gutterWidth, w, desiredHeight);
                this.desiredHeight = desiredHeight;
                this._signal("autosize");
            }
        };
        VirtualRenderer.prototype.$computeLayerConfig = function() {
            var session = this.session;
            var size = this.$size;
            var hideScrollbars = size.height <= 2 * this.lineHeight;
            var screenLines = this.session.getScreenLength();
            var maxHeight = screenLines * this.lineHeight;
            var longestLine = this.$getLongestLine();
            var horizScroll = !hideScrollbars && (this.$hScrollBarAlwaysVisible || size.scrollerWidth - longestLine - 2 * this.$padding < 0);
            var hScrollChanged = this.$horizScroll !== horizScroll;
            if (hScrollChanged) {
                this.$horizScroll = horizScroll;
                this.scrollBarH.setVisible(horizScroll);
            }
            var vScrollBefore = this.$vScroll; // autosize can change vscroll value in which case we need to update longestLine
            if (this.$maxLines && this.lineHeight > 1) this.$autosize();
            var minHeight = size.scrollerHeight + this.lineHeight;
            var scrollPastEnd = !this.$maxLines && this.$scrollPastEnd ? (size.scrollerHeight - this.lineHeight) * this.$scrollPastEnd : 0;
            maxHeight += scrollPastEnd;
            var sm = this.scrollMargin;
            this.session.setScrollTop(Math.max(-sm.top, Math.min(this.scrollTop, maxHeight - size.scrollerHeight + sm.bottom)));
            this.session.setScrollLeft(Math.max(-sm.left, Math.min(this.scrollLeft, longestLine + 2 * this.$padding - size.scrollerWidth + sm.right)));
            var vScroll = !hideScrollbars && (this.$vScrollBarAlwaysVisible || size.scrollerHeight - maxHeight + scrollPastEnd < 0 || this.scrollTop > sm.top);
            var vScrollChanged = vScrollBefore !== vScroll;
            if (vScrollChanged) {
                this.$vScroll = vScroll;
                this.scrollBarV.setVisible(vScroll);
            }
            var offset = this.scrollTop % this.lineHeight;
            var lineCount = Math.ceil(minHeight / this.lineHeight) - 1;
            var firstRow = Math.max(0, Math.round((this.scrollTop - offset) / this.lineHeight));
            var lastRow = firstRow + lineCount;
            var firstRowScreen, firstRowHeight;
            var lineHeight = this.lineHeight;
            firstRow = session.screenToDocumentRow(firstRow, 0);
            var foldLine = session.getFoldLine(firstRow);
            if (foldLine) firstRow = foldLine.start.row;
            firstRowScreen = session.documentToScreenRow(firstRow, 0);
            firstRowHeight = session.getRowLength(firstRow) * lineHeight;
            lastRow = Math.min(session.screenToDocumentRow(lastRow, 0), session.getLength() - 1);
            minHeight = size.scrollerHeight + session.getRowLength(lastRow) * lineHeight + firstRowHeight;
            offset = this.scrollTop - firstRowScreen * lineHeight;
            var changes = 0;
            if (this.layerConfig.width != longestLine || hScrollChanged) changes = this.CHANGE_H_SCROLL;
            if (hScrollChanged || vScrollChanged) {
                changes |= this.$updateCachedSize(true, this.gutterWidth, size.width, size.height);
                this._signal("scrollbarVisibilityChanged");
                if (vScrollChanged) longestLine = this.$getLongestLine();
            }
            this.layerConfig = {
                width: longestLine,
                padding: this.$padding,
                firstRow: firstRow,
                firstRowScreen: firstRowScreen,
                lastRow: lastRow,
                lineHeight: lineHeight,
                characterWidth: this.characterWidth,
                minHeight: minHeight,
                maxHeight: maxHeight,
                offset: offset,
                gutterOffset: lineHeight ? Math.max(0, Math.ceil((offset + size.height - size.scrollerHeight) / lineHeight)) : 0,
                height: this.$size.scrollerHeight
            };
            if (this.session.$bidiHandler) this.session.$bidiHandler.setContentWidth(longestLine - this.$padding);
            return changes;
        };
        VirtualRenderer.prototype.$updateLines = function() {
            if (!this.$changedLines) return;
            var firstRow = this.$changedLines.firstRow;
            var lastRow = this.$changedLines.lastRow;
            this.$changedLines = null;
            var layerConfig = this.layerConfig;
            if (firstRow > layerConfig.lastRow + 1) return;
            if (lastRow < layerConfig.firstRow) return;
            if (lastRow === Infinity) {
                if (this.$showGutter) this.$gutterLayer.update(layerConfig);
                this.$textLayer.update(layerConfig);
                return;
            }
            this.$textLayer.updateLines(layerConfig, firstRow, lastRow);
            return true;
        };
        VirtualRenderer.prototype.$getLongestLine = function() {
            var charCount = this.session.getScreenWidth();
            if (this.showInvisibles && !this.session.$useWrapMode) charCount += 1;
            if (this.$textLayer && charCount > this.$textLayer.MAX_LINE_LENGTH) charCount = this.$textLayer.MAX_LINE_LENGTH + 30;
            return Math.max(this.$size.scrollerWidth - 2 * this.$padding, Math.round(charCount * this.characterWidth));
        };
        VirtualRenderer.prototype.updateFrontMarkers = function() {
            this.$markerFront.setMarkers(this.session.getMarkers(true));
            this.$loop.schedule(this.CHANGE_MARKER_FRONT);
        };
        VirtualRenderer.prototype.updateBackMarkers = function() {
            this.$markerBack.setMarkers(this.session.getMarkers());
            this.$loop.schedule(this.CHANGE_MARKER_BACK);
        };
        VirtualRenderer.prototype.addGutterDecoration = function(row, className) {
            this.$gutterLayer.addGutterDecoration(row, className);
        };
        VirtualRenderer.prototype.removeGutterDecoration = function(row, className) {
            this.$gutterLayer.removeGutterDecoration(row, className);
        };
        VirtualRenderer.prototype.updateBreakpoints = function(rows) {
            this.$loop.schedule(this.CHANGE_GUTTER);
        };
        VirtualRenderer.prototype.setAnnotations = function(annotations) {
            this.$gutterLayer.setAnnotations(annotations);
            this.$loop.schedule(this.CHANGE_GUTTER);
        };
        VirtualRenderer.prototype.updateCursor = function() {
            this.$loop.schedule(this.CHANGE_CURSOR);
        };
        VirtualRenderer.prototype.hideCursor = function() {
            this.$cursorLayer.hideCursor();
        };
        VirtualRenderer.prototype.showCursor = function() {
            this.$cursorLayer.showCursor();
        };
        VirtualRenderer.prototype.scrollSelectionIntoView = function(anchor, lead, offset) {
            this.scrollCursorIntoView(anchor, offset);
            this.scrollCursorIntoView(lead, offset);
        };
        VirtualRenderer.prototype.scrollCursorIntoView = function(cursor, offset, $viewMargin) {
            if (this.$size.scrollerHeight === 0) return;
            var pos = this.$cursorLayer.getPixelPosition(cursor);
            var newLeft = pos.left;
            var newTop = pos.top;
            var topMargin = $viewMargin && $viewMargin.top || 0;
            var bottomMargin = $viewMargin && $viewMargin.bottom || 0;
            if (this.$scrollAnimation) this.$stopAnimation = true;
            var currentTop = this.$scrollAnimation ? this.session.getScrollTop() : this.scrollTop;
            if (currentTop + topMargin > newTop) {
                if (offset && currentTop + topMargin > newTop + this.lineHeight) newTop -= offset * this.$size.scrollerHeight;
                if (newTop === 0) newTop = -this.scrollMargin.top;
                this.session.setScrollTop(newTop);
            } else if (currentTop + this.$size.scrollerHeight - bottomMargin < newTop + this.lineHeight) {
                if (offset && currentTop + this.$size.scrollerHeight - bottomMargin < newTop - this.lineHeight) newTop += offset * this.$size.scrollerHeight;
                this.session.setScrollTop(newTop + this.lineHeight + bottomMargin - this.$size.scrollerHeight);
            }
            var currentLeft = this.scrollLeft;
            var twoCharsWidth = 2 * this.layerConfig.characterWidth;
            if (newLeft - twoCharsWidth < currentLeft) {
                newLeft -= twoCharsWidth;
                if (newLeft < this.$padding + twoCharsWidth) newLeft = -this.scrollMargin.left;
                this.session.setScrollLeft(newLeft);
            } else {
                newLeft += twoCharsWidth;
                if (currentLeft + this.$size.scrollerWidth < newLeft + this.characterWidth) this.session.setScrollLeft(Math.round(newLeft + this.characterWidth - this.$size.scrollerWidth));
                else if (currentLeft <= this.$padding && newLeft - currentLeft < this.characterWidth) this.session.setScrollLeft(0);
            }
        };
        VirtualRenderer.prototype.getScrollTop = function() {
            return this.session.getScrollTop();
        };
        VirtualRenderer.prototype.getScrollLeft = function() {
            return this.session.getScrollLeft();
        };
        VirtualRenderer.prototype.getScrollTopRow = function() {
            return this.scrollTop / this.lineHeight;
        };
        VirtualRenderer.prototype.getScrollBottomRow = function() {
            return Math.max(0, Math.floor((this.scrollTop + this.$size.scrollerHeight) / this.lineHeight) - 1);
        };
        VirtualRenderer.prototype.scrollToRow = function(row) {
            this.session.setScrollTop(row * this.lineHeight);
        };
        VirtualRenderer.prototype.alignCursor = function(cursor, alignment) {
            if (typeof cursor == "number") cursor = {
                row: cursor,
                column: 0
            };
            var pos = this.$cursorLayer.getPixelPosition(cursor);
            var h = this.$size.scrollerHeight - this.lineHeight;
            var offset = pos.top - h * (alignment || 0);
            this.session.setScrollTop(offset);
            return offset;
        };
        VirtualRenderer.prototype.$calcSteps = function(fromValue, toValue) {
            var i = 0;
            var l = this.STEPS;
            var steps = [];
            var func = function(t, x_min, dx) {
                return dx * (Math.pow(t - 1, 3) + 1) + x_min;
            };
            for(i = 0; i < l; ++i)steps.push(func(i / this.STEPS, fromValue, toValue - fromValue));
            return steps;
        };
        VirtualRenderer.prototype.scrollToLine = function(line, center, animate, callback) {
            var pos = this.$cursorLayer.getPixelPosition({
                row: line,
                column: 0
            });
            var offset = pos.top;
            if (center) offset -= this.$size.scrollerHeight / 2;
            var initialScroll = this.scrollTop;
            this.session.setScrollTop(offset);
            if (animate !== false) this.animateScrolling(initialScroll, callback);
        };
        VirtualRenderer.prototype.animateScrolling = function(fromValue, callback) {
            var toValue = this.scrollTop;
            if (!this.$animatedScroll) return;
            var _self = this;
            if (fromValue == toValue) return;
            if (this.$scrollAnimation) {
                var oldSteps = this.$scrollAnimation.steps;
                if (oldSteps.length) {
                    fromValue = oldSteps[0];
                    if (fromValue == toValue) return;
                }
            }
            var steps = _self.$calcSteps(fromValue, toValue);
            this.$scrollAnimation = {
                from: fromValue,
                to: toValue,
                steps: steps
            };
            clearInterval(this.$timer);
            _self.session.setScrollTop(steps.shift());
            _self.session.$scrollTop = toValue;
            function endAnimation() {
                _self.$timer = clearInterval(_self.$timer);
                _self.$scrollAnimation = null;
                _self.$stopAnimation = false;
                callback && callback();
            }
            this.$timer = setInterval(function() {
                if (_self.$stopAnimation) {
                    endAnimation();
                    return;
                }
                if (!_self.session) return clearInterval(_self.$timer);
                if (steps.length) {
                    _self.session.setScrollTop(steps.shift());
                    _self.session.$scrollTop = toValue;
                } else if (toValue != null) {
                    _self.session.$scrollTop = -1;
                    _self.session.setScrollTop(toValue);
                    toValue = null;
                } else endAnimation();
            }, 10);
        };
        VirtualRenderer.prototype.scrollToY = function(scrollTop) {
            if (this.scrollTop !== scrollTop) {
                this.$loop.schedule(this.CHANGE_SCROLL);
                this.scrollTop = scrollTop;
            }
        };
        VirtualRenderer.prototype.scrollToX = function(scrollLeft) {
            if (this.scrollLeft !== scrollLeft) this.scrollLeft = scrollLeft;
            this.$loop.schedule(this.CHANGE_H_SCROLL);
        };
        VirtualRenderer.prototype.scrollTo = function(x, y) {
            this.session.setScrollTop(y);
            this.session.setScrollLeft(x);
        };
        VirtualRenderer.prototype.scrollBy = function(deltaX, deltaY) {
            deltaY && this.session.setScrollTop(this.session.getScrollTop() + deltaY);
            deltaX && this.session.setScrollLeft(this.session.getScrollLeft() + deltaX);
        };
        VirtualRenderer.prototype.isScrollableBy = function(deltaX, deltaY) {
            if (deltaY < 0 && this.session.getScrollTop() >= 1 - this.scrollMargin.top) return true;
            if (deltaY > 0 && this.session.getScrollTop() + this.$size.scrollerHeight - this.layerConfig.maxHeight < -1 + this.scrollMargin.bottom) return true;
            if (deltaX < 0 && this.session.getScrollLeft() >= 1 - this.scrollMargin.left) return true;
            if (deltaX > 0 && this.session.getScrollLeft() + this.$size.scrollerWidth - this.layerConfig.width < -1 + this.scrollMargin.right) return true;
        };
        VirtualRenderer.prototype.pixelToScreenCoordinates = function(x, y) {
            var canvasPos;
            if (this.$hasCssTransforms) {
                canvasPos = {
                    top: 0,
                    left: 0
                };
                var p = this.$fontMetrics.transformCoordinates([
                    x,
                    y
                ]);
                x = p[1] - this.gutterWidth - this.margin.left;
                y = p[0];
            } else canvasPos = this.scroller.getBoundingClientRect();
            var offsetX = x + this.scrollLeft - canvasPos.left - this.$padding;
            var offset = offsetX / this.characterWidth;
            var row = Math.floor((y + this.scrollTop - canvasPos.top) / this.lineHeight);
            var col = this.$blockCursor ? Math.floor(offset) : Math.round(offset);
            return {
                row: row,
                column: col,
                side: offset - col > 0 ? 1 : -1,
                offsetX: offsetX
            };
        };
        VirtualRenderer.prototype.screenToTextCoordinates = function(x, y) {
            var canvasPos;
            if (this.$hasCssTransforms) {
                canvasPos = {
                    top: 0,
                    left: 0
                };
                var p = this.$fontMetrics.transformCoordinates([
                    x,
                    y
                ]);
                x = p[1] - this.gutterWidth - this.margin.left;
                y = p[0];
            } else canvasPos = this.scroller.getBoundingClientRect();
            var offsetX = x + this.scrollLeft - canvasPos.left - this.$padding;
            var offset = offsetX / this.characterWidth;
            var col = this.$blockCursor ? Math.floor(offset) : Math.round(offset);
            var row = Math.floor((y + this.scrollTop - canvasPos.top) / this.lineHeight);
            return this.session.screenToDocumentPosition(row, Math.max(col, 0), offsetX);
        };
        VirtualRenderer.prototype.textToScreenCoordinates = function(row, column) {
            var canvasPos = this.scroller.getBoundingClientRect();
            var pos = this.session.documentToScreenPosition(row, column);
            var x = this.$padding + (this.session.$bidiHandler.isBidiRow(pos.row, row) ? this.session.$bidiHandler.getPosLeft(pos.column) : Math.round(pos.column * this.characterWidth));
            var y = pos.row * this.lineHeight;
            return {
                pageX: canvasPos.left + x - this.scrollLeft,
                pageY: canvasPos.top + y - this.scrollTop
            };
        };
        VirtualRenderer.prototype.visualizeFocus = function() {
            dom.addCssClass(this.container, "ace_focus");
        };
        VirtualRenderer.prototype.visualizeBlur = function() {
            dom.removeCssClass(this.container, "ace_focus");
        };
        VirtualRenderer.prototype.showComposition = function(composition) {
            this.$composition = composition;
            if (!composition.cssText) composition.cssText = this.textarea.style.cssText;
            if (composition.useTextareaForIME == undefined) composition.useTextareaForIME = this.$useTextareaForIME;
            if (this.$useTextareaForIME) {
                dom.addCssClass(this.textarea, "ace_composition");
                this.textarea.style.cssText = "";
                this.$moveTextAreaToCursor();
                this.$cursorLayer.element.style.display = "none";
            } else composition.markerId = this.session.addMarker(composition.markerRange, "ace_composition_marker", "text");
        };
        VirtualRenderer.prototype.setCompositionText = function(text) {
            var cursor = this.session.selection.cursor;
            this.addToken(text, "composition_placeholder", cursor.row, cursor.column);
            this.$moveTextAreaToCursor();
        };
        VirtualRenderer.prototype.hideComposition = function() {
            if (!this.$composition) return;
            if (this.$composition.markerId) this.session.removeMarker(this.$composition.markerId);
            dom.removeCssClass(this.textarea, "ace_composition");
            this.textarea.style.cssText = this.$composition.cssText;
            var cursor = this.session.selection.cursor;
            this.removeExtraToken(cursor.row, cursor.column);
            this.$composition = null;
            this.$cursorLayer.element.style.display = "";
        };
        VirtualRenderer.prototype.setGhostText = function(text, position) {
            var cursor = this.session.selection.cursor;
            var insertPosition = position || {
                row: cursor.row,
                column: cursor.column
            };
            this.removeGhostText();
            var textLines = text.split("\n");
            this.addToken(textLines[0], "ghost_text", insertPosition.row, insertPosition.column);
            this.$ghostText = {
                text: text,
                position: {
                    row: insertPosition.row,
                    column: insertPosition.column
                }
            };
            if (textLines.length > 1) {
                this.$ghostTextWidget = {
                    text: textLines.slice(1).join("\n"),
                    row: insertPosition.row,
                    column: insertPosition.column,
                    className: "ace_ghost_text"
                };
                this.session.widgetManager.addLineWidget(this.$ghostTextWidget);
            }
        };
        VirtualRenderer.prototype.removeGhostText = function() {
            if (!this.$ghostText) return;
            var position = this.$ghostText.position;
            this.removeExtraToken(position.row, position.column);
            if (this.$ghostTextWidget) {
                this.session.widgetManager.removeLineWidget(this.$ghostTextWidget);
                this.$ghostTextWidget = null;
            }
            this.$ghostText = null;
        };
        VirtualRenderer.prototype.addToken = function(text, type, row, column) {
            var session = this.session;
            session.bgTokenizer.lines[row] = null;
            var newToken = {
                type: type,
                value: text
            };
            var tokens = session.getTokens(row);
            if (column == null || !tokens.length) tokens.push(newToken);
            else {
                var l = 0;
                for(var i = 0; i < tokens.length; i++){
                    var token = tokens[i];
                    l += token.value.length;
                    if (column <= l) {
                        var diff = token.value.length - (l - column);
                        var before = token.value.slice(0, diff);
                        var after = token.value.slice(diff);
                        tokens.splice(i, 1, {
                            type: token.type,
                            value: before
                        }, newToken, {
                            type: token.type,
                            value: after
                        });
                        break;
                    }
                }
            }
            this.updateLines(row, row);
        };
        VirtualRenderer.prototype.removeExtraToken = function(row, column) {
            this.session.bgTokenizer.lines[row] = null;
            this.updateLines(row, row);
        };
        VirtualRenderer.prototype.setTheme = function(theme, cb) {
            var _self = this;
            this.$themeId = theme;
            _self._dispatchEvent("themeChange", {
                theme: theme
            });
            if (!theme || typeof theme == "string") {
                var moduleName = theme || this.$options.theme.initialValue;
                config.loadModule([
                    "theme",
                    moduleName
                ], afterLoad);
            } else afterLoad(theme);
            function afterLoad(module1) {
                if (_self.$themeId != theme) return cb && cb();
                if (!module1 || !module1.cssClass) throw new Error("couldn't load module " + theme + " or it didn't call define");
                if (module1.$id) _self.$themeId = module1.$id;
                dom.importCssString(module1.cssText, module1.cssClass, _self.container);
                if (_self.theme) dom.removeCssClass(_self.container, _self.theme.cssClass);
                var padding = "padding" in module1 ? module1.padding : "padding" in (_self.theme || {}) ? 4 : _self.$padding;
                if (_self.$padding && padding != _self.$padding) _self.setPadding(padding);
                _self.$theme = module1.cssClass;
                _self.theme = module1;
                dom.addCssClass(_self.container, module1.cssClass);
                dom.setCssClass(_self.container, "ace_dark", module1.isDark);
                if (_self.$size) {
                    _self.$size.width = 0;
                    _self.$updateSizeAsync();
                }
                _self._dispatchEvent("themeLoaded", {
                    theme: module1
                });
                cb && cb();
            }
        };
        VirtualRenderer.prototype.getTheme = function() {
            return this.$themeId;
        };
        VirtualRenderer.prototype.setStyle = function(style, include) {
            dom.setCssClass(this.container, style, include !== false);
        };
        VirtualRenderer.prototype.unsetStyle = function(style) {
            dom.removeCssClass(this.container, style);
        };
        VirtualRenderer.prototype.setCursorStyle = function(style) {
            dom.setStyle(this.scroller.style, "cursor", style);
        };
        VirtualRenderer.prototype.setMouseCursor = function(cursorStyle) {
            dom.setStyle(this.scroller.style, "cursor", cursorStyle);
        };
        VirtualRenderer.prototype.attachToShadowRoot = function() {
            dom.importCssString(editorCss, "ace_editor.css", this.container);
        };
        VirtualRenderer.prototype.destroy = function() {
            this.freeze();
            this.$fontMetrics.destroy();
            this.$cursorLayer.destroy();
            this.removeAllListeners();
            this.container.textContent = "";
            this.setOption("useResizeObserver", false);
        };
        VirtualRenderer.prototype.$updateCustomScrollbar = function(val) {
            var _self = this;
            this.$horizScroll = this.$vScroll = null;
            this.scrollBarV.element.remove();
            this.scrollBarH.element.remove();
            if (this.$scrollDecorator) delete this.$scrollDecorator;
            if (val === true) {
                this.scrollBarV = new VScrollBarCustom(this.container, this);
                this.scrollBarH = new HScrollBarCustom(this.container, this);
                this.scrollBarV.setHeight(this.$size.scrollerHeight);
                this.scrollBarH.setWidth(this.$size.scrollerWidth);
                this.scrollBarV.addEventListener("scroll", function(e) {
                    if (!_self.$scrollAnimation) _self.session.setScrollTop(e.data - _self.scrollMargin.top);
                });
                this.scrollBarH.addEventListener("scroll", function(e) {
                    if (!_self.$scrollAnimation) _self.session.setScrollLeft(e.data - _self.scrollMargin.left);
                });
                this.$scrollDecorator = new Decorator(this.scrollBarV, this);
                this.$scrollDecorator.$updateDecorators();
            } else {
                this.scrollBarV = new VScrollBar(this.container, this);
                this.scrollBarH = new HScrollBar(this.container, this);
                this.scrollBarV.addEventListener("scroll", function(e) {
                    if (!_self.$scrollAnimation) _self.session.setScrollTop(e.data - _self.scrollMargin.top);
                });
                this.scrollBarH.addEventListener("scroll", function(e) {
                    if (!_self.$scrollAnimation) _self.session.setScrollLeft(e.data - _self.scrollMargin.left);
                });
            }
        };
        VirtualRenderer.prototype.$addResizeObserver = function() {
            if (!window.ResizeObserver || this.$resizeObserver) return;
            var self1 = this;
            this.$resizeTimer = lang.delayedCall(function() {
                if (!self1.destroyed) self1.onResize();
            }, 50);
            this.$resizeObserver = new window.ResizeObserver(function(e) {
                var w = e[0].contentRect.width;
                var h = e[0].contentRect.height;
                if (Math.abs(self1.$size.width - w) > 1 || Math.abs(self1.$size.height - h) > 1) self1.$resizeTimer.delay();
                else self1.$resizeTimer.cancel();
            });
            this.$resizeObserver.observe(this.container);
        };
        return VirtualRenderer;
    }();
    VirtualRenderer.prototype.CHANGE_CURSOR = 1;
    VirtualRenderer.prototype.CHANGE_MARKER = 2;
    VirtualRenderer.prototype.CHANGE_GUTTER = 4;
    VirtualRenderer.prototype.CHANGE_SCROLL = 8;
    VirtualRenderer.prototype.CHANGE_LINES = 16;
    VirtualRenderer.prototype.CHANGE_TEXT = 32;
    VirtualRenderer.prototype.CHANGE_SIZE = 64;
    VirtualRenderer.prototype.CHANGE_MARKER_BACK = 128;
    VirtualRenderer.prototype.CHANGE_MARKER_FRONT = 256;
    VirtualRenderer.prototype.CHANGE_FULL = 512;
    VirtualRenderer.prototype.CHANGE_H_SCROLL = 1024;
    VirtualRenderer.prototype.$changes = 0;
    VirtualRenderer.prototype.$padding = null;
    VirtualRenderer.prototype.$frozen = false;
    VirtualRenderer.prototype.STEPS = 8;
    oop.implement(VirtualRenderer.prototype, EventEmitter);
    config.defineOptions(VirtualRenderer.prototype, "renderer", {
        useResizeObserver: {
            set: function(value) {
                if (!value && this.$resizeObserver) {
                    this.$resizeObserver.disconnect();
                    this.$resizeTimer.cancel();
                    this.$resizeTimer = this.$resizeObserver = null;
                } else if (value && !this.$resizeObserver) this.$addResizeObserver();
            }
        },
        animatedScroll: {
            initialValue: false
        },
        showInvisibles: {
            set: function(value) {
                if (this.$textLayer.setShowInvisibles(value)) this.$loop.schedule(this.CHANGE_TEXT);
            },
            initialValue: false
        },
        showPrintMargin: {
            set: function() {
                this.$updatePrintMargin();
            },
            initialValue: true
        },
        printMarginColumn: {
            set: function() {
                this.$updatePrintMargin();
            },
            initialValue: 80
        },
        printMargin: {
            set: function(val) {
                if (typeof val == "number") this.$printMarginColumn = val;
                this.$showPrintMargin = !!val;
                this.$updatePrintMargin();
            },
            get: function() {
                return this.$showPrintMargin && this.$printMarginColumn;
            }
        },
        showGutter: {
            set: function(show) {
                this.$gutter.style.display = show ? "block" : "none";
                this.$loop.schedule(this.CHANGE_FULL);
                this.onGutterResize();
            },
            initialValue: true
        },
        useSvgGutterIcons: {
            set: function(value) {
                this.$gutterLayer.$useSvgGutterIcons = value;
            },
            initialValue: false
        },
        showFoldedAnnotations: {
            set: function(value) {
                this.$gutterLayer.$showFoldedAnnotations = value;
            },
            initialValue: false
        },
        fadeFoldWidgets: {
            set: function(show) {
                dom.setCssClass(this.$gutter, "ace_fade-fold-widgets", show);
            },
            initialValue: false
        },
        showFoldWidgets: {
            set: function(show) {
                this.$gutterLayer.setShowFoldWidgets(show);
                this.$loop.schedule(this.CHANGE_GUTTER);
            },
            initialValue: true
        },
        displayIndentGuides: {
            set: function(show) {
                if (this.$textLayer.setDisplayIndentGuides(show)) this.$loop.schedule(this.CHANGE_TEXT);
            },
            initialValue: true
        },
        highlightIndentGuides: {
            set: function(show) {
                if (this.$textLayer.setHighlightIndentGuides(show) == true) this.$textLayer.$highlightIndentGuide();
                else this.$textLayer.$clearActiveIndentGuide(this.$textLayer.$lines.cells);
            },
            initialValue: true
        },
        highlightGutterLine: {
            set: function(shouldHighlight) {
                this.$gutterLayer.setHighlightGutterLine(shouldHighlight);
                this.$loop.schedule(this.CHANGE_GUTTER);
            },
            initialValue: true
        },
        hScrollBarAlwaysVisible: {
            set: function(val) {
                if (!this.$hScrollBarAlwaysVisible || !this.$horizScroll) this.$loop.schedule(this.CHANGE_SCROLL);
            },
            initialValue: false
        },
        vScrollBarAlwaysVisible: {
            set: function(val) {
                if (!this.$vScrollBarAlwaysVisible || !this.$vScroll) this.$loop.schedule(this.CHANGE_SCROLL);
            },
            initialValue: false
        },
        fontSize: {
            set: function(size) {
                if (typeof size == "number") size = size + "px";
                this.container.style.fontSize = size;
                this.updateFontSize();
            },
            initialValue: 12
        },
        fontFamily: {
            set: function(name) {
                this.container.style.fontFamily = name;
                this.updateFontSize();
            }
        },
        maxLines: {
            set: function(val) {
                this.updateFull();
            }
        },
        minLines: {
            set: function(val) {
                if (!(this.$minLines < 0x1ffffffffffff)) this.$minLines = 0;
                this.updateFull();
            }
        },
        maxPixelHeight: {
            set: function(val) {
                this.updateFull();
            },
            initialValue: 0
        },
        scrollPastEnd: {
            set: function(val) {
                val = +val || 0;
                if (this.$scrollPastEnd == val) return;
                this.$scrollPastEnd = val;
                this.$loop.schedule(this.CHANGE_SCROLL);
            },
            initialValue: 0,
            handlesSet: true
        },
        fixedWidthGutter: {
            set: function(val) {
                this.$gutterLayer.$fixedWidth = !!val;
                this.$loop.schedule(this.CHANGE_GUTTER);
            }
        },
        customScrollbar: {
            set: function(val) {
                this.$updateCustomScrollbar(val);
            },
            initialValue: false
        },
        theme: {
            set: function(val) {
                this.setTheme(val);
            },
            get: function() {
                return this.$themeId || this.theme;
            },
            initialValue: "./theme/textmate",
            handlesSet: true
        },
        hasCssTransforms: {},
        useTextareaForIME: {
            initialValue: !useragent.isMobile && !useragent.isIE
        }
    });
    exports.VirtualRenderer = VirtualRenderer;
});
ace.define("ace/worker/worker_client", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/net",
    "ace/lib/event_emitter",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var net = require("../lib/net");
    var EventEmitter = require("../lib/event_emitter").EventEmitter;
    var config = require("../config");
    function $workerBlob(workerUrl) {
        var script = "importScripts('" + net.qualifyURL(workerUrl) + "');";
        try {
            return new Blob([
                script
            ], {
                "type": "application/javascript"
            });
        } catch (e) {
            var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
            var blobBuilder = new BlobBuilder();
            blobBuilder.append(script);
            return blobBuilder.getBlob("application/javascript");
        }
    }
    function createWorker(workerUrl) {
        if (typeof Worker == "undefined") return {
            postMessage: function() {},
            terminate: function() {}
        };
        if (config.get("loadWorkerFromBlob")) {
            var blob = $workerBlob(workerUrl);
            var URL = window.URL || window.webkitURL;
            var blobURL = URL.createObjectURL(blob);
            return new Worker(blobURL);
        }
        return new Worker(workerUrl);
    }
    var WorkerClient = function(worker) {
        if (!worker.postMessage) worker = this.$createWorkerFromOldConfig.apply(this, arguments);
        this.$worker = worker;
        this.$sendDeltaQueue = this.$sendDeltaQueue.bind(this);
        this.changeListener = this.changeListener.bind(this);
        this.onMessage = this.onMessage.bind(this);
        this.callbackId = 1;
        this.callbacks = {};
        this.$worker.onmessage = this.onMessage;
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.$createWorkerFromOldConfig = function(topLevelNamespaces, mod, classname, workerUrl, importScripts) {
            if (require.nameToUrl && !require.toUrl) require.toUrl = require.nameToUrl;
            if (config.get("packaged") || !require.toUrl) workerUrl = workerUrl || config.moduleUrl(mod, "worker");
            else {
                var normalizePath = this.$normalizePath;
                workerUrl = workerUrl || normalizePath(require.toUrl("ace/worker/worker.js", null, "_"));
                var tlns = {};
                topLevelNamespaces.forEach(function(ns) {
                    tlns[ns] = normalizePath(require.toUrl(ns, null, "_").replace(/(\.js)?(\?.*)?$/, ""));
                });
            }
            this.$worker = createWorker(workerUrl);
            if (importScripts) this.send("importScripts", importScripts);
            this.$worker.postMessage({
                init: true,
                tlns: tlns,
                module: mod,
                classname: classname
            });
            return this.$worker;
        };
        this.onMessage = function(e) {
            var msg = e.data;
            switch(msg.type){
                case "event":
                    this._signal(msg.name, {
                        data: msg.data
                    });
                    break;
                case "call":
                    var callback = this.callbacks[msg.id];
                    if (callback) {
                        callback(msg.data);
                        delete this.callbacks[msg.id];
                    }
                    break;
                case "error":
                    this.reportError(msg.data);
                    break;
                case "log":
                    window.console && console.log && console.log.apply(console, msg.data);
                    break;
            }
        };
        this.reportError = function(err) {
            window.console && console.error && console.error(err);
        };
        this.$normalizePath = function(path) {
            return net.qualifyURL(path);
        };
        this.terminate = function() {
            this._signal("terminate", {});
            this.deltaQueue = null;
            this.$worker.terminate();
            this.$worker.onerror = function(e) {
                e.preventDefault();
            };
            this.$worker = null;
            if (this.$doc) this.$doc.off("change", this.changeListener);
            this.$doc = null;
        };
        this.send = function(cmd, args) {
            this.$worker.postMessage({
                command: cmd,
                args: args
            });
        };
        this.call = function(cmd, args, callback) {
            if (callback) {
                var id = this.callbackId++;
                this.callbacks[id] = callback;
                args.push(id);
            }
            this.send(cmd, args);
        };
        this.emit = function(event, data) {
            try {
                if (data.data && data.data.err) data.data.err = {
                    message: data.data.err.message,
                    stack: data.data.err.stack,
                    code: data.data.err.code
                };
                this.$worker && this.$worker.postMessage({
                    event: event,
                    data: {
                        data: data.data
                    }
                });
            } catch (ex) {
                console.error(ex.stack);
            }
        };
        this.attachToDocument = function(doc) {
            if (this.$doc) this.terminate();
            this.$doc = doc;
            this.call("setValue", [
                doc.getValue()
            ]);
            doc.on("change", this.changeListener, true);
        };
        this.changeListener = function(delta) {
            if (!this.deltaQueue) {
                this.deltaQueue = [];
                setTimeout(this.$sendDeltaQueue, 0);
            }
            if (delta.action == "insert") this.deltaQueue.push(delta.start, delta.lines);
            else this.deltaQueue.push(delta.start, delta.end);
        };
        this.$sendDeltaQueue = function() {
            var q = this.deltaQueue;
            if (!q) return;
            this.deltaQueue = null;
            if (q.length > 50 && q.length > this.$doc.getLength() >> 1) this.call("setValue", [
                this.$doc.getValue()
            ]);
            else this.emit("change", {
                data: q
            });
        };
    }).call(WorkerClient.prototype);
    var UIWorkerClient = function(topLevelNamespaces, mod, classname) {
        var main = null;
        var emitSync = false;
        var sender = Object.create(EventEmitter);
        var messageBuffer = [];
        var workerClient = new WorkerClient({
            messageBuffer: messageBuffer,
            terminate: function() {},
            postMessage: function(e) {
                messageBuffer.push(e);
                if (!main) return;
                if (emitSync) setTimeout(processNext);
                else processNext();
            }
        });
        workerClient.setEmitSync = function(val) {
            emitSync = val;
        };
        var processNext = function() {
            var msg = messageBuffer.shift();
            if (msg.command) main[msg.command].apply(main, msg.args);
            else if (msg.event) sender._signal(msg.event, msg.data);
        };
        sender.postMessage = function(msg) {
            workerClient.onMessage({
                data: msg
            });
        };
        sender.callback = function(data, callbackId) {
            this.postMessage({
                type: "call",
                id: callbackId,
                data: data
            });
        };
        sender.emit = function(name, data) {
            this.postMessage({
                type: "event",
                name: name,
                data: data
            });
        };
        config.loadModule([
            "worker",
            mod
        ], function(Main) {
            main = new Main[classname](sender);
            while(messageBuffer.length)processNext();
        });
        return workerClient;
    };
    exports.UIWorkerClient = UIWorkerClient;
    exports.WorkerClient = WorkerClient;
    exports.createWorker = createWorker;
});
ace.define("ace/placeholder", [
    "require",
    "exports",
    "module",
    "ace/range",
    "ace/lib/event_emitter",
    "ace/lib/oop"
], function(require, exports, module1) {
    "use strict";
    var Range = require("./range").Range;
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var oop = require("./lib/oop");
    var PlaceHolder = /** @class */ function() {
        function PlaceHolder(session, length, pos, others, mainClass, othersClass) {
            var _self = this;
            this.length = length;
            this.session = session;
            this.doc = session.getDocument();
            this.mainClass = mainClass;
            this.othersClass = othersClass;
            this.$onUpdate = this.onUpdate.bind(this);
            this.doc.on("change", this.$onUpdate, true);
            this.$others = others;
            this.$onCursorChange = function() {
                setTimeout(function() {
                    _self.onCursorChange();
                });
            };
            this.$pos = pos;
            var undoStack = session.getUndoManager().$undoStack || session.getUndoManager().$undostack || {
                length: -1
            };
            this.$undoStackDepth = undoStack.length;
            this.setup();
            session.selection.on("changeCursor", this.$onCursorChange);
        }
        PlaceHolder.prototype.setup = function() {
            var _self = this;
            var doc = this.doc;
            var session = this.session;
            this.selectionBefore = session.selection.toJSON();
            if (session.selection.inMultiSelectMode) session.selection.toSingleRange();
            this.pos = doc.createAnchor(this.$pos.row, this.$pos.column);
            var pos = this.pos;
            pos.$insertRight = true;
            pos.detach();
            pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column + this.length), this.mainClass, null, false);
            this.others = [];
            this.$others.forEach(function(other) {
                var anchor = doc.createAnchor(other.row, other.column);
                anchor.$insertRight = true;
                anchor.detach();
                _self.others.push(anchor);
            });
            session.setUndoSelect(false);
        };
        PlaceHolder.prototype.showOtherMarkers = function() {
            if (this.othersActive) return;
            var session = this.session;
            var _self = this;
            this.othersActive = true;
            this.others.forEach(function(anchor) {
                anchor.markerId = session.addMarker(new Range(anchor.row, anchor.column, anchor.row, anchor.column + _self.length), _self.othersClass, null, false);
            });
        };
        PlaceHolder.prototype.hideOtherMarkers = function() {
            if (!this.othersActive) return;
            this.othersActive = false;
            for(var i = 0; i < this.others.length; i++)this.session.removeMarker(this.others[i].markerId);
        };
        PlaceHolder.prototype.onUpdate = function(delta) {
            if (this.$updating) return this.updateAnchors(delta);
            var range = delta;
            if (range.start.row !== range.end.row) return;
            if (range.start.row !== this.pos.row) return;
            this.$updating = true;
            var lengthDiff = delta.action === "insert" ? range.end.column - range.start.column : range.start.column - range.end.column;
            var inMainRange = range.start.column >= this.pos.column && range.start.column <= this.pos.column + this.length + 1;
            var distanceFromStart = range.start.column - this.pos.column;
            this.updateAnchors(delta);
            if (inMainRange) this.length += lengthDiff;
            if (inMainRange && !this.session.$fromUndo) {
                if (delta.action === "insert") for(var i = this.others.length - 1; i >= 0; i--){
                    var otherPos = this.others[i];
                    var newPos = {
                        row: otherPos.row,
                        column: otherPos.column + distanceFromStart
                    };
                    this.doc.insertMergedLines(newPos, delta.lines);
                }
                else if (delta.action === "remove") for(var i = this.others.length - 1; i >= 0; i--){
                    var otherPos = this.others[i];
                    var newPos = {
                        row: otherPos.row,
                        column: otherPos.column + distanceFromStart
                    };
                    this.doc.remove(new Range(newPos.row, newPos.column, newPos.row, newPos.column - lengthDiff));
                }
            }
            this.$updating = false;
            this.updateMarkers();
        };
        PlaceHolder.prototype.updateAnchors = function(delta) {
            this.pos.onChange(delta);
            for(var i = this.others.length; i--;)this.others[i].onChange(delta);
            this.updateMarkers();
        };
        PlaceHolder.prototype.updateMarkers = function() {
            if (this.$updating) return;
            var _self = this;
            var session = this.session;
            var updateMarker = function(pos, className) {
                session.removeMarker(pos.markerId);
                pos.markerId = session.addMarker(new Range(pos.row, pos.column, pos.row, pos.column + _self.length), className, null, false);
            };
            updateMarker(this.pos, this.mainClass);
            for(var i = this.others.length; i--;)updateMarker(this.others[i], this.othersClass);
        };
        PlaceHolder.prototype.onCursorChange = function(event) {
            if (this.$updating || !this.session) return;
            var pos = this.session.selection.getCursor();
            if (pos.row === this.pos.row && pos.column >= this.pos.column && pos.column <= this.pos.column + this.length) {
                this.showOtherMarkers();
                this._emit("cursorEnter", event);
            } else {
                this.hideOtherMarkers();
                this._emit("cursorLeave", event);
            }
        };
        PlaceHolder.prototype.detach = function() {
            this.session.removeMarker(this.pos && this.pos.markerId);
            this.hideOtherMarkers();
            this.doc.off("change", this.$onUpdate);
            this.session.selection.off("changeCursor", this.$onCursorChange);
            this.session.setUndoSelect(true);
            this.session = null;
        };
        PlaceHolder.prototype.cancel = function() {
            if (this.$undoStackDepth === -1) return;
            var undoManager = this.session.getUndoManager();
            var undosRequired = (undoManager.$undoStack || undoManager.$undostack).length - this.$undoStackDepth;
            for(var i = 0; i < undosRequired; i++)undoManager.undo(this.session, true);
            if (this.selectionBefore) this.session.selection.fromJSON(this.selectionBefore);
        };
        return PlaceHolder;
    }();
    oop.implement(PlaceHolder.prototype, EventEmitter);
    exports.PlaceHolder = PlaceHolder;
});
ace.define("ace/mouse/multi_select_handler", [
    "require",
    "exports",
    "module",
    "ace/lib/event",
    "ace/lib/useragent"
], function(require, exports, module1) {
    var event = require("../lib/event");
    var useragent = require("../lib/useragent");
    function isSamePoint(p1, p2) {
        return p1.row == p2.row && p1.column == p2.column;
    }
    function onMouseDown(e) {
        var ev = e.domEvent;
        var alt = ev.altKey;
        var shift = ev.shiftKey;
        var ctrl = ev.ctrlKey;
        var accel = e.getAccelKey();
        var button = e.getButton();
        if (ctrl && useragent.isMac) button = ev.button;
        if (e.editor.inMultiSelectMode && button == 2) {
            e.editor.textInput.onContextMenu(e.domEvent);
            return;
        }
        if (!ctrl && !alt && !accel) {
            if (button === 0 && e.editor.inMultiSelectMode) e.editor.exitMultiSelectMode();
            return;
        }
        if (button !== 0) return;
        var editor = e.editor;
        var selection = editor.selection;
        var isMultiSelect = editor.inMultiSelectMode;
        var pos = e.getDocumentPosition();
        var cursor = selection.getCursor();
        var inSelection = e.inSelection() || selection.isEmpty() && isSamePoint(pos, cursor);
        var mouseX = e.x, mouseY = e.y;
        var onMouseSelection = function(e) {
            mouseX = e.clientX;
            mouseY = e.clientY;
        };
        var session = editor.session;
        var screenAnchor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
        var screenCursor = screenAnchor;
        var selectionMode;
        if (editor.$mouseHandler.$enableJumpToDef) {
            if (ctrl && alt || accel && alt) selectionMode = shift ? "block" : "add";
            else if (alt && editor.$blockSelectEnabled) selectionMode = "block";
        } else {
            if (accel && !alt) {
                selectionMode = "add";
                if (!isMultiSelect && shift) return;
            } else if (alt && editor.$blockSelectEnabled) selectionMode = "block";
        }
        if (selectionMode && useragent.isMac && ev.ctrlKey) editor.$mouseHandler.cancelContextMenu();
        if (selectionMode == "add") {
            if (!isMultiSelect && inSelection) return; // dragging
            if (!isMultiSelect) {
                var range = selection.toOrientedRange();
                editor.addSelectionMarker(range);
            }
            var oldRange = selection.rangeList.rangeAtPoint(pos);
            editor.inVirtualSelectionMode = true;
            if (shift) {
                oldRange = null;
                range = selection.ranges[0] || range;
                editor.removeSelectionMarker(range);
            }
            editor.once("mouseup", function() {
                var tmpSel = selection.toOrientedRange();
                if (oldRange && tmpSel.isEmpty() && isSamePoint(oldRange.cursor, tmpSel.cursor)) selection.substractPoint(tmpSel.cursor);
                else {
                    if (shift) selection.substractPoint(range.cursor);
                    else if (range) {
                        editor.removeSelectionMarker(range);
                        selection.addRange(range);
                    }
                    selection.addRange(tmpSel);
                }
                editor.inVirtualSelectionMode = false;
            });
        } else if (selectionMode == "block") {
            e.stop();
            editor.inVirtualSelectionMode = true;
            var initialRange;
            var rectSel = [];
            var blockSelect = function() {
                var newCursor = editor.renderer.pixelToScreenCoordinates(mouseX, mouseY);
                var cursor = session.screenToDocumentPosition(newCursor.row, newCursor.column, newCursor.offsetX);
                if (isSamePoint(screenCursor, newCursor) && isSamePoint(cursor, selection.lead)) return;
                screenCursor = newCursor;
                editor.selection.moveToPosition(cursor);
                editor.renderer.scrollCursorIntoView();
                editor.removeSelectionMarkers(rectSel);
                rectSel = selection.rectangularRangeBlock(screenCursor, screenAnchor);
                if (editor.$mouseHandler.$clickSelection && rectSel.length == 1 && rectSel[0].isEmpty()) rectSel[0] = editor.$mouseHandler.$clickSelection.clone();
                rectSel.forEach(editor.addSelectionMarker, editor);
                editor.updateSelectionMarkers();
            };
            if (isMultiSelect && !accel) selection.toSingleRange();
            else if (!isMultiSelect && accel) {
                initialRange = selection.toOrientedRange();
                editor.addSelectionMarker(initialRange);
            }
            if (shift) screenAnchor = session.documentToScreenPosition(selection.lead);
            else selection.moveToPosition(pos);
            screenCursor = {
                row: -1,
                column: -1
            };
            var onMouseSelectionEnd = function(e) {
                blockSelect();
                clearInterval(timerId);
                editor.removeSelectionMarkers(rectSel);
                if (!rectSel.length) rectSel = [
                    selection.toOrientedRange()
                ];
                if (initialRange) {
                    editor.removeSelectionMarker(initialRange);
                    selection.toSingleRange(initialRange);
                }
                for(var i = 0; i < rectSel.length; i++)selection.addRange(rectSel[i]);
                editor.inVirtualSelectionMode = false;
                editor.$mouseHandler.$clickSelection = null;
            };
            var onSelectionInterval = blockSelect;
            event.capture(editor.container, onMouseSelection, onMouseSelectionEnd);
            var timerId = setInterval(function() {
                onSelectionInterval();
            }, 20);
            return e.preventDefault();
        }
    }
    exports.onMouseDown = onMouseDown;
});
ace.define("ace/commands/multi_select_commands", [
    "require",
    "exports",
    "module",
    "ace/keyboard/hash_handler"
], function(require, exports, module1) {
    exports.defaultCommands = [
        {
            name: "addCursorAbove",
            description: "Add cursor above",
            exec: function(editor) {
                editor.selectMoreLines(-1);
            },
            bindKey: {
                win: "Ctrl-Alt-Up",
                mac: "Ctrl-Alt-Up"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "addCursorBelow",
            description: "Add cursor below",
            exec: function(editor) {
                editor.selectMoreLines(1);
            },
            bindKey: {
                win: "Ctrl-Alt-Down",
                mac: "Ctrl-Alt-Down"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "addCursorAboveSkipCurrent",
            description: "Add cursor above (skip current)",
            exec: function(editor) {
                editor.selectMoreLines(-1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Up",
                mac: "Ctrl-Alt-Shift-Up"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "addCursorBelowSkipCurrent",
            description: "Add cursor below (skip current)",
            exec: function(editor) {
                editor.selectMoreLines(1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Down",
                mac: "Ctrl-Alt-Shift-Down"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectMoreBefore",
            description: "Select more before",
            exec: function(editor) {
                editor.selectMore(-1);
            },
            bindKey: {
                win: "Ctrl-Alt-Left",
                mac: "Ctrl-Alt-Left"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectMoreAfter",
            description: "Select more after",
            exec: function(editor) {
                editor.selectMore(1);
            },
            bindKey: {
                win: "Ctrl-Alt-Right",
                mac: "Ctrl-Alt-Right"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectNextBefore",
            description: "Select next before",
            exec: function(editor) {
                editor.selectMore(-1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Left",
                mac: "Ctrl-Alt-Shift-Left"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "selectNextAfter",
            description: "Select next after",
            exec: function(editor) {
                editor.selectMore(1, true);
            },
            bindKey: {
                win: "Ctrl-Alt-Shift-Right",
                mac: "Ctrl-Alt-Shift-Right"
            },
            scrollIntoView: "cursor",
            readOnly: true
        },
        {
            name: "toggleSplitSelectionIntoLines",
            description: "Split selection into lines",
            exec: function(editor) {
                if (editor.multiSelect.rangeCount > 1) editor.multiSelect.joinSelections();
                else editor.multiSelect.splitIntoLines();
            },
            bindKey: {
                win: "Ctrl-Alt-L",
                mac: "Ctrl-Alt-L"
            },
            readOnly: true
        },
        {
            name: "splitSelectionIntoLines",
            description: "Split into lines",
            exec: function(editor) {
                editor.multiSelect.splitIntoLines();
            },
            readOnly: true
        },
        {
            name: "alignCursors",
            description: "Align cursors",
            exec: function(editor) {
                editor.alignCursors();
            },
            bindKey: {
                win: "Ctrl-Alt-A",
                mac: "Ctrl-Alt-A"
            },
            scrollIntoView: "cursor"
        },
        {
            name: "findAll",
            description: "Find all",
            exec: function(editor) {
                editor.findAll();
            },
            bindKey: {
                win: "Ctrl-Alt-K",
                mac: "Ctrl-Alt-G"
            },
            scrollIntoView: "cursor",
            readOnly: true
        }
    ];
    exports.multiSelectCommands = [
        {
            name: "singleSelection",
            description: "Single selection",
            bindKey: "esc",
            exec: function(editor) {
                editor.exitMultiSelectMode();
            },
            scrollIntoView: "cursor",
            readOnly: true,
            isAvailable: function(editor) {
                return editor && editor.inMultiSelectMode;
            }
        }
    ];
    var HashHandler = require("../keyboard/hash_handler").HashHandler;
    exports.keyboardHandler = new HashHandler(exports.multiSelectCommands);
});
ace.define("ace/multi_select", [
    "require",
    "exports",
    "module",
    "ace/range_list",
    "ace/range",
    "ace/selection",
    "ace/mouse/multi_select_handler",
    "ace/lib/event",
    "ace/lib/lang",
    "ace/commands/multi_select_commands",
    "ace/search",
    "ace/edit_session",
    "ace/editor",
    "ace/config"
], function(require, exports, module1) {
    var RangeList = require("./range_list").RangeList;
    var Range = require("./range").Range;
    var Selection = require("./selection").Selection;
    var onMouseDown = require("./mouse/multi_select_handler").onMouseDown;
    var event = require("./lib/event");
    var lang = require("./lib/lang");
    var commands = require("./commands/multi_select_commands");
    exports.commands = commands.defaultCommands.concat(commands.multiSelectCommands);
    var Search = require("./search").Search;
    var search = new Search();
    function find(session, needle, dir) {
        search.$options.wrap = true;
        search.$options.needle = needle;
        search.$options.backwards = dir == -1;
        return search.find(session);
    }
    var EditSession = require("./edit_session").EditSession;
    (function() {
        this.getSelectionMarkers = function() {
            return this.$selectionMarkers;
        };
    }).call(EditSession.prototype);
    (function() {
        this.ranges = null;
        this.rangeList = null;
        this.addRange = function(range, $blockChangeEvents) {
            if (!range) return;
            if (!this.inMultiSelectMode && this.rangeCount === 0) {
                var oldRange = this.toOrientedRange();
                this.rangeList.add(oldRange);
                this.rangeList.add(range);
                if (this.rangeList.ranges.length != 2) {
                    this.rangeList.removeAll();
                    return $blockChangeEvents || this.fromOrientedRange(range);
                }
                this.rangeList.removeAll();
                this.rangeList.add(oldRange);
                this.$onAddRange(oldRange);
            }
            if (!range.cursor) range.cursor = range.end;
            var removed = this.rangeList.add(range);
            this.$onAddRange(range);
            if (removed.length) this.$onRemoveRange(removed);
            if (this.rangeCount > 1 && !this.inMultiSelectMode) {
                this._signal("multiSelect");
                this.inMultiSelectMode = true;
                this.session.$undoSelect = false;
                this.rangeList.attach(this.session);
            }
            return $blockChangeEvents || this.fromOrientedRange(range);
        };
        this.toSingleRange = function(range) {
            range = range || this.ranges[0];
            var removed = this.rangeList.removeAll();
            if (removed.length) this.$onRemoveRange(removed);
            range && this.fromOrientedRange(range);
        };
        this.substractPoint = function(pos) {
            var removed = this.rangeList.substractPoint(pos);
            if (removed) {
                this.$onRemoveRange(removed);
                return removed[0];
            }
        };
        this.mergeOverlappingRanges = function() {
            var removed = this.rangeList.merge();
            if (removed.length) this.$onRemoveRange(removed);
        };
        this.$onAddRange = function(range) {
            this.rangeCount = this.rangeList.ranges.length;
            this.ranges.unshift(range);
            this._signal("addRange", {
                range: range
            });
        };
        this.$onRemoveRange = function(removed) {
            this.rangeCount = this.rangeList.ranges.length;
            if (this.rangeCount == 1 && this.inMultiSelectMode) {
                var lastRange = this.rangeList.ranges.pop();
                removed.push(lastRange);
                this.rangeCount = 0;
            }
            for(var i = removed.length; i--;){
                var index = this.ranges.indexOf(removed[i]);
                this.ranges.splice(index, 1);
            }
            this._signal("removeRange", {
                ranges: removed
            });
            if (this.rangeCount === 0 && this.inMultiSelectMode) {
                this.inMultiSelectMode = false;
                this._signal("singleSelect");
                this.session.$undoSelect = true;
                this.rangeList.detach(this.session);
            }
            lastRange = lastRange || this.ranges[0];
            if (lastRange && !lastRange.isEqual(this.getRange())) this.fromOrientedRange(lastRange);
        };
        this.$initRangeList = function() {
            if (this.rangeList) return;
            this.rangeList = new RangeList();
            this.ranges = [];
            this.rangeCount = 0;
        };
        this.getAllRanges = function() {
            return this.rangeCount ? this.rangeList.ranges.concat() : [
                this.getRange()
            ];
        };
        this.splitIntoLines = function() {
            var ranges = this.ranges.length ? this.ranges : [
                this.getRange()
            ];
            var newRanges = [];
            for(var i = 0; i < ranges.length; i++){
                var range = ranges[i];
                var row = range.start.row;
                var endRow = range.end.row;
                if (row === endRow) newRanges.push(range.clone());
                else {
                    newRanges.push(new Range(row, range.start.column, row, this.session.getLine(row).length));
                    while(++row < endRow)newRanges.push(this.getLineRange(row, true));
                    newRanges.push(new Range(endRow, 0, endRow, range.end.column));
                }
                if (i == 0 && !this.isBackwards()) newRanges = newRanges.reverse();
            }
            this.toSingleRange();
            for(var i = newRanges.length; i--;)this.addRange(newRanges[i]);
        };
        this.joinSelections = function() {
            var ranges = this.rangeList.ranges;
            var lastRange = ranges[ranges.length - 1];
            var range = Range.fromPoints(ranges[0].start, lastRange.end);
            this.toSingleRange();
            this.setSelectionRange(range, lastRange.cursor == lastRange.start);
        };
        this.toggleBlockSelection = function() {
            if (this.rangeCount > 1) {
                var ranges = this.rangeList.ranges;
                var lastRange = ranges[ranges.length - 1];
                var range = Range.fromPoints(ranges[0].start, lastRange.end);
                this.toSingleRange();
                this.setSelectionRange(range, lastRange.cursor == lastRange.start);
            } else {
                var cursor = this.session.documentToScreenPosition(this.cursor);
                var anchor = this.session.documentToScreenPosition(this.anchor);
                var rectSel = this.rectangularRangeBlock(cursor, anchor);
                rectSel.forEach(this.addRange, this);
            }
        };
        this.rectangularRangeBlock = function(screenCursor, screenAnchor, includeEmptyLines) {
            var rectSel = [];
            var xBackwards = screenCursor.column < screenAnchor.column;
            if (xBackwards) {
                var startColumn = screenCursor.column;
                var endColumn = screenAnchor.column;
                var startOffsetX = screenCursor.offsetX;
                var endOffsetX = screenAnchor.offsetX;
            } else {
                var startColumn = screenAnchor.column;
                var endColumn = screenCursor.column;
                var startOffsetX = screenAnchor.offsetX;
                var endOffsetX = screenCursor.offsetX;
            }
            var yBackwards = screenCursor.row < screenAnchor.row;
            if (yBackwards) {
                var startRow = screenCursor.row;
                var endRow = screenAnchor.row;
            } else {
                var startRow = screenAnchor.row;
                var endRow = screenCursor.row;
            }
            if (startColumn < 0) startColumn = 0;
            if (startRow < 0) startRow = 0;
            if (startRow == endRow) includeEmptyLines = true;
            var docEnd;
            for(var row = startRow; row <= endRow; row++){
                var range = Range.fromPoints(this.session.screenToDocumentPosition(row, startColumn, startOffsetX), this.session.screenToDocumentPosition(row, endColumn, endOffsetX));
                if (range.isEmpty()) {
                    if (docEnd && isSamePoint(range.end, docEnd)) break;
                    docEnd = range.end;
                }
                range.cursor = xBackwards ? range.start : range.end;
                rectSel.push(range);
            }
            if (yBackwards) rectSel.reverse();
            if (!includeEmptyLines) {
                var end = rectSel.length - 1;
                while(rectSel[end].isEmpty() && end > 0)end--;
                if (end > 0) {
                    var start = 0;
                    while(rectSel[start].isEmpty())start++;
                }
                for(var i = end; i >= start; i--)if (rectSel[i].isEmpty()) rectSel.splice(i, 1);
            }
            return rectSel;
        };
    }).call(Selection.prototype);
    var Editor = require("./editor").Editor;
    (function() {
        this.updateSelectionMarkers = function() {
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.addSelectionMarker = function(orientedRange) {
            if (!orientedRange.cursor) orientedRange.cursor = orientedRange.end;
            var style = this.getSelectionStyle();
            orientedRange.marker = this.session.addMarker(orientedRange, "ace_selection", style);
            this.session.$selectionMarkers.push(orientedRange);
            this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
            return orientedRange;
        };
        this.removeSelectionMarker = function(range) {
            if (!range.marker) return;
            this.session.removeMarker(range.marker);
            var index = this.session.$selectionMarkers.indexOf(range);
            if (index != -1) this.session.$selectionMarkers.splice(index, 1);
            this.session.selectionMarkerCount = this.session.$selectionMarkers.length;
        };
        this.removeSelectionMarkers = function(ranges) {
            var markerList = this.session.$selectionMarkers;
            for(var i = ranges.length; i--;){
                var range = ranges[i];
                if (!range.marker) continue;
                this.session.removeMarker(range.marker);
                var index = markerList.indexOf(range);
                if (index != -1) markerList.splice(index, 1);
            }
            this.session.selectionMarkerCount = markerList.length;
        };
        this.$onAddRange = function(e) {
            this.addSelectionMarker(e.range);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.$onRemoveRange = function(e) {
            this.removeSelectionMarkers(e.ranges);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.$onMultiSelect = function(e) {
            if (this.inMultiSelectMode) return;
            this.inMultiSelectMode = true;
            this.setStyle("ace_multiselect");
            this.keyBinding.addKeyboardHandler(commands.keyboardHandler);
            this.commands.setDefaultHandler("exec", this.$onMultiSelectExec);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
        };
        this.$onSingleSelect = function(e) {
            if (this.session.multiSelect.inVirtualMode) return;
            this.inMultiSelectMode = false;
            this.unsetStyle("ace_multiselect");
            this.keyBinding.removeKeyboardHandler(commands.keyboardHandler);
            this.commands.removeDefaultHandler("exec", this.$onMultiSelectExec);
            this.renderer.updateCursor();
            this.renderer.updateBackMarkers();
            this._emit("changeSelection");
        };
        this.$onMultiSelectExec = function(e) {
            var command = e.command;
            var editor = e.editor;
            if (!editor.multiSelect) return;
            if (!command.multiSelectAction) {
                var result = command.exec(editor, e.args || {});
                editor.multiSelect.addRange(editor.multiSelect.toOrientedRange());
                editor.multiSelect.mergeOverlappingRanges();
            } else if (command.multiSelectAction == "forEach") result = editor.forEachSelection(command, e.args);
            else if (command.multiSelectAction == "forEachLine") result = editor.forEachSelection(command, e.args, true);
            else if (command.multiSelectAction == "single") {
                editor.exitMultiSelectMode();
                result = command.exec(editor, e.args || {});
            } else result = command.multiSelectAction(editor, e.args || {});
            return result;
        };
        this.forEachSelection = function(cmd, args, options) {
            if (this.inVirtualSelectionMode) return;
            var keepOrder = options && options.keepOrder;
            var $byLines = options == true || options && options.$byLines;
            var session = this.session;
            var selection = this.selection;
            var rangeList = selection.rangeList;
            var ranges = (keepOrder ? selection : rangeList).ranges;
            var result;
            if (!ranges.length) return cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
            var reg = selection._eventRegistry;
            selection._eventRegistry = {};
            var tmpSel = new Selection(session);
            this.inVirtualSelectionMode = true;
            for(var i = ranges.length; i--;){
                if ($byLines) while(i > 0 && ranges[i].start.row == ranges[i - 1].end.row)i--;
                tmpSel.fromOrientedRange(ranges[i]);
                tmpSel.index = i;
                this.selection = session.selection = tmpSel;
                var cmdResult = cmd.exec ? cmd.exec(this, args || {}) : cmd(this, args || {});
                if (!result && cmdResult !== undefined) result = cmdResult;
                tmpSel.toOrientedRange(ranges[i]);
            }
            tmpSel.detach();
            this.selection = session.selection = selection;
            this.inVirtualSelectionMode = false;
            selection._eventRegistry = reg;
            selection.mergeOverlappingRanges();
            if (selection.ranges[0]) selection.fromOrientedRange(selection.ranges[0]);
            var anim = this.renderer.$scrollAnimation;
            this.onCursorChange();
            this.onSelectionChange();
            if (anim && anim.from == anim.to) this.renderer.animateScrolling(anim.from);
            return result;
        };
        this.exitMultiSelectMode = function() {
            if (!this.inMultiSelectMode || this.inVirtualSelectionMode) return;
            this.multiSelect.toSingleRange();
        };
        this.getSelectedText = function() {
            var text = "";
            if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
                var ranges = this.multiSelect.rangeList.ranges;
                var buf = [];
                for(var i = 0; i < ranges.length; i++)buf.push(this.session.getTextRange(ranges[i]));
                var nl = this.session.getDocument().getNewLineCharacter();
                text = buf.join(nl);
                if (text.length == (buf.length - 1) * nl.length) text = "";
            } else if (!this.selection.isEmpty()) text = this.session.getTextRange(this.getSelectionRange());
            return text;
        };
        this.$checkMultiselectChange = function(e, anchor) {
            if (this.inMultiSelectMode && !this.inVirtualSelectionMode) {
                var range = this.multiSelect.ranges[0];
                if (this.multiSelect.isEmpty() && anchor == this.multiSelect.anchor) return;
                var pos = anchor == this.multiSelect.anchor ? range.cursor == range.start ? range.end : range.start : range.cursor;
                if (pos.row != anchor.row || this.session.$clipPositionToDocument(pos.row, pos.column).column != anchor.column) this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange());
                else this.multiSelect.mergeOverlappingRanges();
            }
        };
        this.findAll = function(needle, options, additive) {
            options = options || {};
            options.needle = needle || options.needle;
            if (options.needle == undefined) {
                var range = this.selection.isEmpty() ? this.selection.getWordRange() : this.selection.getRange();
                options.needle = this.session.getTextRange(range);
            }
            this.$search.set(options);
            var ranges = this.$search.findAll(this.session);
            if (!ranges.length) return 0;
            var selection = this.multiSelect;
            if (!additive) selection.toSingleRange(ranges[0]);
            for(var i = ranges.length; i--;)selection.addRange(ranges[i], true);
            if (range && selection.rangeList.rangeAtPoint(range.start)) selection.addRange(range, true);
            return ranges.length;
        };
        this.selectMoreLines = function(dir, skip) {
            var range = this.selection.toOrientedRange();
            var isBackwards = range.cursor == range.end;
            var screenLead = this.session.documentToScreenPosition(range.cursor);
            if (this.selection.$desiredColumn) screenLead.column = this.selection.$desiredColumn;
            var lead = this.session.screenToDocumentPosition(screenLead.row + dir, screenLead.column);
            if (!range.isEmpty()) {
                var screenAnchor = this.session.documentToScreenPosition(isBackwards ? range.end : range.start);
                var anchor = this.session.screenToDocumentPosition(screenAnchor.row + dir, screenAnchor.column);
            } else var anchor = lead;
            if (isBackwards) {
                var newRange = Range.fromPoints(lead, anchor);
                newRange.cursor = newRange.start;
            } else {
                var newRange = Range.fromPoints(anchor, lead);
                newRange.cursor = newRange.end;
            }
            newRange.desiredColumn = screenLead.column;
            if (!this.selection.inMultiSelectMode) this.selection.addRange(range);
            else if (skip) var toRemove = range.cursor;
            this.selection.addRange(newRange);
            if (toRemove) this.selection.substractPoint(toRemove);
        };
        this.transposeSelections = function(dir) {
            var session = this.session;
            var sel = session.multiSelect;
            var all = sel.ranges;
            for(var i = all.length; i--;){
                var range = all[i];
                if (range.isEmpty()) {
                    var tmp = session.getWordRange(range.start.row, range.start.column);
                    range.start.row = tmp.start.row;
                    range.start.column = tmp.start.column;
                    range.end.row = tmp.end.row;
                    range.end.column = tmp.end.column;
                }
            }
            sel.mergeOverlappingRanges();
            var words = [];
            for(var i = all.length; i--;){
                var range = all[i];
                words.unshift(session.getTextRange(range));
            }
            if (dir < 0) words.unshift(words.pop());
            else words.push(words.shift());
            for(var i = all.length; i--;){
                var range = all[i];
                var tmp = range.clone();
                session.replace(range, words[i]);
                range.start.row = tmp.start.row;
                range.start.column = tmp.start.column;
            }
            sel.fromOrientedRange(sel.ranges[0]);
        };
        this.selectMore = function(dir, skip, stopAtFirst) {
            var session = this.session;
            var sel = session.multiSelect;
            var range = sel.toOrientedRange();
            if (range.isEmpty()) {
                range = session.getWordRange(range.start.row, range.start.column);
                range.cursor = dir == -1 ? range.start : range.end;
                this.multiSelect.addRange(range);
                if (stopAtFirst) return;
            }
            var needle = session.getTextRange(range);
            var newRange = find(session, needle, dir);
            if (newRange) {
                newRange.cursor = dir == -1 ? newRange.start : newRange.end;
                this.session.unfold(newRange);
                this.multiSelect.addRange(newRange);
                this.renderer.scrollCursorIntoView(null, 0.5);
            }
            if (skip) this.multiSelect.substractPoint(range.cursor);
        };
        this.alignCursors = function() {
            var session = this.session;
            var sel = session.multiSelect;
            var ranges = sel.ranges;
            var row = -1;
            var sameRowRanges = ranges.filter(function(r) {
                if (r.cursor.row == row) return true;
                row = r.cursor.row;
            });
            if (!ranges.length || sameRowRanges.length == ranges.length - 1) {
                var range = this.selection.getRange();
                var fr = range.start.row, lr = range.end.row;
                var guessRange = fr == lr;
                if (guessRange) {
                    var max = this.session.getLength();
                    var line;
                    do line = this.session.getLine(lr);
                    while (/[=:]/.test(line) && ++lr < max);
                    do line = this.session.getLine(fr);
                    while (/[=:]/.test(line) && --fr > 0);
                    if (fr < 0) fr = 0;
                    if (lr >= max) lr = max - 1;
                }
                var lines = this.session.removeFullLines(fr, lr);
                lines = this.$reAlignText(lines, guessRange);
                this.session.insert({
                    row: fr,
                    column: 0
                }, lines.join("\n") + "\n");
                if (!guessRange) {
                    range.start.column = 0;
                    range.end.column = lines[lines.length - 1].length;
                }
                this.selection.setRange(range);
            } else {
                sameRowRanges.forEach(function(r) {
                    sel.substractPoint(r.cursor);
                });
                var maxCol = 0;
                var minSpace = Infinity;
                var spaceOffsets = ranges.map(function(r) {
                    var p = r.cursor;
                    var line = session.getLine(p.row);
                    var spaceOffset = line.substr(p.column).search(/\S/g);
                    if (spaceOffset == -1) spaceOffset = 0;
                    if (p.column > maxCol) maxCol = p.column;
                    if (spaceOffset < minSpace) minSpace = spaceOffset;
                    return spaceOffset;
                });
                ranges.forEach(function(r, i) {
                    var p = r.cursor;
                    var l = maxCol - p.column;
                    var d = spaceOffsets[i] - minSpace;
                    if (l > d) session.insert(p, lang.stringRepeat(" ", l - d));
                    else session.remove(new Range(p.row, p.column, p.row, p.column - l + d));
                    r.start.column = r.end.column = maxCol;
                    r.start.row = r.end.row = p.row;
                    r.cursor = r.end;
                });
                sel.fromOrientedRange(ranges[0]);
                this.renderer.updateCursor();
                this.renderer.updateBackMarkers();
            }
        };
        this.$reAlignText = function(lines, forceLeft) {
            var isLeftAligned = true, isRightAligned = true;
            var startW, textW, endW;
            return lines.map(function(line) {
                var m = line.match(/(\s*)(.*?)(\s*)([=:].*)/);
                if (!m) return [
                    line
                ];
                if (startW == null) {
                    startW = m[1].length;
                    textW = m[2].length;
                    endW = m[3].length;
                    return m;
                }
                if (startW + textW + endW != m[1].length + m[2].length + m[3].length) isRightAligned = false;
                if (startW != m[1].length) isLeftAligned = false;
                if (startW > m[1].length) startW = m[1].length;
                if (textW < m[2].length) textW = m[2].length;
                if (endW > m[3].length) endW = m[3].length;
                return m;
            }).map(forceLeft ? alignLeft : isLeftAligned ? isRightAligned ? alignRight : alignLeft : unAlign);
            function spaces(n) {
                return lang.stringRepeat(" ", n);
            }
            function alignLeft(m) {
                return !m[2] ? m[0] : spaces(startW) + m[2] + spaces(textW - m[2].length + endW) + m[4].replace(/^([=:])\s+/, "$1 ");
            }
            function alignRight(m) {
                return !m[2] ? m[0] : spaces(startW + textW - m[2].length) + m[2] + spaces(endW) + m[4].replace(/^([=:])\s+/, "$1 ");
            }
            function unAlign(m) {
                return !m[2] ? m[0] : spaces(startW) + m[2] + spaces(endW) + m[4].replace(/^([=:])\s+/, "$1 ");
            }
        };
    }).call(Editor.prototype);
    function isSamePoint(p1, p2) {
        return p1.row == p2.row && p1.column == p2.column;
    }
    exports.onSessionChange = function(e) {
        var session = e.session;
        if (session && !session.multiSelect) {
            session.$selectionMarkers = [];
            session.selection.$initRangeList();
            session.multiSelect = session.selection;
        }
        this.multiSelect = session && session.multiSelect;
        var oldSession = e.oldSession;
        if (oldSession) {
            oldSession.multiSelect.off("addRange", this.$onAddRange);
            oldSession.multiSelect.off("removeRange", this.$onRemoveRange);
            oldSession.multiSelect.off("multiSelect", this.$onMultiSelect);
            oldSession.multiSelect.off("singleSelect", this.$onSingleSelect);
            oldSession.multiSelect.lead.off("change", this.$checkMultiselectChange);
            oldSession.multiSelect.anchor.off("change", this.$checkMultiselectChange);
        }
        if (session) {
            session.multiSelect.on("addRange", this.$onAddRange);
            session.multiSelect.on("removeRange", this.$onRemoveRange);
            session.multiSelect.on("multiSelect", this.$onMultiSelect);
            session.multiSelect.on("singleSelect", this.$onSingleSelect);
            session.multiSelect.lead.on("change", this.$checkMultiselectChange);
            session.multiSelect.anchor.on("change", this.$checkMultiselectChange);
        }
        if (session && this.inMultiSelectMode != session.selection.inMultiSelectMode) {
            if (session.selection.inMultiSelectMode) this.$onMultiSelect();
            else this.$onSingleSelect();
        }
    };
    function MultiSelect(editor) {
        if (editor.$multiselectOnSessionChange) return;
        editor.$onAddRange = editor.$onAddRange.bind(editor);
        editor.$onRemoveRange = editor.$onRemoveRange.bind(editor);
        editor.$onMultiSelect = editor.$onMultiSelect.bind(editor);
        editor.$onSingleSelect = editor.$onSingleSelect.bind(editor);
        editor.$multiselectOnSessionChange = exports.onSessionChange.bind(editor);
        editor.$checkMultiselectChange = editor.$checkMultiselectChange.bind(editor);
        editor.$multiselectOnSessionChange(editor);
        editor.on("changeSession", editor.$multiselectOnSessionChange);
        editor.on("mousedown", onMouseDown);
        editor.commands.addCommands(commands.defaultCommands);
        addAltCursorListeners(editor);
    }
    function addAltCursorListeners(editor) {
        if (!editor.textInput) return;
        var el = editor.textInput.getElement();
        var altCursor = false;
        event.addListener(el, "keydown", function(e) {
            var altDown = e.keyCode == 18 && !(e.ctrlKey || e.shiftKey || e.metaKey);
            if (editor.$blockSelectEnabled && altDown) {
                if (!altCursor) {
                    editor.renderer.setMouseCursor("crosshair");
                    altCursor = true;
                }
            } else if (altCursor) reset();
        }, editor);
        event.addListener(el, "keyup", reset, editor);
        event.addListener(el, "blur", reset, editor);
        function reset(e) {
            if (altCursor) {
                editor.renderer.setMouseCursor("");
                altCursor = false;
            }
        }
    }
    exports.MultiSelect = MultiSelect;
    require("./config").defineOptions(Editor.prototype, "editor", {
        enableMultiselect: {
            set: function(val) {
                MultiSelect(this);
                if (val) this.on("mousedown", onMouseDown);
                else this.off("mousedown", onMouseDown);
            },
            value: true
        },
        enableBlockSelect: {
            set: function(val) {
                this.$blockSelectEnabled = val;
            },
            value: true
        }
    });
});
ace.define("ace/mode/folding/fold_mode", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../../range").Range;
    var FoldMode = exports.FoldMode = function() {};
    (function() {
        this.foldingStartMarker = null;
        this.foldingStopMarker = null;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.foldingStartMarker.test(line)) return "start";
            if (foldStyle == "markbeginend" && this.foldingStopMarker && this.foldingStopMarker.test(line)) return "end";
            return "";
        };
        this.getFoldWidgetRange = function(session, foldStyle, row) {
            return null;
        };
        this.indentationBlock = function(session, row, column) {
            var re = /\S/;
            var line = session.getLine(row);
            var startLevel = line.search(re);
            if (startLevel == -1) return;
            var startColumn = column || line.length;
            var maxRow = session.getLength();
            var startRow = row;
            var endRow = row;
            while(++row < maxRow){
                var level = session.getLine(row).search(re);
                if (level == -1) continue;
                if (level <= startLevel) {
                    var token = session.getTokenAt(row, 0);
                    if (!token || token.type !== "string") break;
                }
                endRow = row;
            }
            if (endRow > startRow) {
                var endColumn = session.getLine(endRow).length;
                return new Range(startRow, startColumn, endRow, endColumn);
            }
        };
        this.openingBracketBlock = function(session, bracket, row, column, typeRe) {
            var start = {
                row: row,
                column: column + 1
            };
            var end = session.$findClosingBracket(bracket, start, typeRe);
            if (!end) return;
            var fw = session.foldWidgets[end.row];
            if (fw == null) fw = session.getFoldWidget(end.row);
            if (fw == "start" && end.row > start.row) {
                end.row--;
                end.column = session.getLine(end.row).length;
            }
            return Range.fromPoints(start, end);
        };
        this.closingBracketBlock = function(session, bracket, row, column, typeRe) {
            var end = {
                row: row,
                column: column
            };
            var start = session.$findOpeningBracket(bracket, end);
            if (!start) return;
            start.column++;
            end.column--;
            return Range.fromPoints(start, end);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/ext/error_marker", [
    "require",
    "exports",
    "module",
    "ace/line_widgets",
    "ace/lib/dom",
    "ace/range",
    "ace/config"
], function(require, exports, module1) {
    "use strict";
    var LineWidgets = require("../line_widgets").LineWidgets;
    var dom = require("../lib/dom");
    var Range = require("../range").Range;
    var nls = require("../config").nls;
    function binarySearch(array, needle, comparator) {
        var first = 0;
        var last = array.length - 1;
        while(first <= last){
            var mid = first + last >> 1;
            var c = comparator(needle, array[mid]);
            if (c > 0) first = mid + 1;
            else if (c < 0) last = mid - 1;
            else return mid;
        }
        return -(first + 1);
    }
    function findAnnotations(session, row, dir) {
        var annotations = session.getAnnotations().sort(Range.comparePoints);
        if (!annotations.length) return;
        var i = binarySearch(annotations, {
            row: row,
            column: -1
        }, Range.comparePoints);
        if (i < 0) i = -i - 1;
        if (i >= annotations.length) i = dir > 0 ? 0 : annotations.length - 1;
        else if (i === 0 && dir < 0) i = annotations.length - 1;
        var annotation = annotations[i];
        if (!annotation || !dir) return;
        if (annotation.row === row) {
            do annotation = annotations[i += dir];
            while (annotation && annotation.row === row);
            if (!annotation) return annotations.slice();
        }
        var matched = [];
        row = annotation.row;
        do {
            matched[dir < 0 ? "unshift" : "push"](annotation);
            annotation = annotations[i += dir];
        }while (annotation && annotation.row == row);
        return matched.length && matched;
    }
    exports.showErrorMarker = function(editor, dir) {
        var session = editor.session;
        if (!session.widgetManager) {
            session.widgetManager = new LineWidgets(session);
            session.widgetManager.attach(editor);
        }
        var pos = editor.getCursorPosition();
        var row = pos.row;
        var oldWidget = session.widgetManager.getWidgetsAtRow(row).filter(function(w) {
            return w.type == "errorMarker";
        })[0];
        if (oldWidget) oldWidget.destroy();
        else row -= dir;
        var annotations = findAnnotations(session, row, dir);
        var gutterAnno;
        if (annotations) {
            var annotation = annotations[0];
            pos.column = (annotation.pos && typeof annotation.column != "number" ? annotation.pos.sc : annotation.column) || 0;
            pos.row = annotation.row;
            gutterAnno = editor.renderer.$gutterLayer.$annotations[pos.row];
        } else if (oldWidget) return;
        else gutterAnno = {
            text: [
                nls("Looks good!")
            ],
            className: "ace_ok"
        };
        editor.session.unfold(pos.row);
        editor.selection.moveToPosition(pos);
        var w = {
            row: pos.row,
            fixedWidth: true,
            coverGutter: true,
            el: dom.createElement("div"),
            type: "errorMarker"
        };
        var el = w.el.appendChild(dom.createElement("div"));
        var arrow = w.el.appendChild(dom.createElement("div"));
        arrow.className = "error_widget_arrow " + gutterAnno.className;
        var left = editor.renderer.$cursorLayer.getPixelPosition(pos).left;
        arrow.style.left = left + editor.renderer.gutterWidth - 5 + "px";
        w.el.className = "error_widget_wrapper";
        el.className = "error_widget " + gutterAnno.className;
        el.innerHTML = gutterAnno.text.join("<br>");
        el.appendChild(dom.createElement("div"));
        var kb = function(_, hashId, keyString) {
            if (hashId === 0 && (keyString === "esc" || keyString === "return")) {
                w.destroy();
                return {
                    command: "null"
                };
            }
        };
        w.destroy = function() {
            if (editor.$mouseHandler.isMousePressed) return;
            editor.keyBinding.removeKeyboardHandler(kb);
            session.widgetManager.removeLineWidget(w);
            editor.off("changeSelection", w.destroy);
            editor.off("changeSession", w.destroy);
            editor.off("mouseup", w.destroy);
            editor.off("change", w.destroy);
        };
        editor.keyBinding.addKeyboardHandler(kb);
        editor.on("changeSelection", w.destroy);
        editor.on("changeSession", w.destroy);
        editor.on("mouseup", w.destroy);
        editor.on("change", w.destroy);
        editor.session.widgetManager.addLineWidget(w);
        w.el.onmousedown = editor.focus.bind(editor);
        editor.renderer.scrollCursorIntoView(null, 0.5, {
            bottom: w.el.offsetHeight
        });
    };
    dom.importCssString("\n    .error_widget_wrapper {\n        background: inherit;\n        color: inherit;\n        border:none\n    }\n    .error_widget {\n        border-top: solid 2px;\n        border-bottom: solid 2px;\n        margin: 5px 0;\n        padding: 10px 40px;\n        white-space: pre-wrap;\n    }\n    .error_widget.ace_error, .error_widget_arrow.ace_error{\n        border-color: #ff5a5a\n    }\n    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\n        border-color: #F1D817\n    }\n    .error_widget.ace_info, .error_widget_arrow.ace_info{\n        border-color: #5a5a5a\n    }\n    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\n        border-color: #5aaa5a\n    }\n    .error_widget_arrow {\n        position: absolute;\n        border: solid 5px;\n        border-top-color: transparent!important;\n        border-right-color: transparent!important;\n        border-left-color: transparent!important;\n        top: -5px;\n    }\n", "error_marker.css", false);
});
ace.define("ace/ace", [
    "require",
    "exports",
    "module",
    "ace/lib/dom",
    "ace/range",
    "ace/editor",
    "ace/edit_session",
    "ace/undomanager",
    "ace/virtual_renderer",
    "ace/worker/worker_client",
    "ace/keyboard/hash_handler",
    "ace/placeholder",
    "ace/multi_select",
    "ace/mode/folding/fold_mode",
    "ace/theme/textmate",
    "ace/ext/error_marker",
    "ace/config",
    "ace/loader_build"
], function(require, exports, module1) {
    "use strict";
    require("./loader_build")(exports);
    var dom = require("./lib/dom");
    var Range = require("./range").Range;
    var Editor = require("./editor").Editor;
    var EditSession = require("./edit_session").EditSession;
    var UndoManager = require("./undomanager").UndoManager;
    var Renderer = require("./virtual_renderer").VirtualRenderer;
    require("./worker/worker_client");
    require("./keyboard/hash_handler");
    require("./placeholder");
    require("./multi_select");
    require("./mode/folding/fold_mode");
    require("./theme/textmate");
    require("./ext/error_marker");
    exports.config = require("./config");
    exports.edit = function(el, options) {
        if (typeof el == "string") {
            var _id = el;
            el = document.getElementById(_id);
            if (!el) throw new Error("ace.edit can't find div #" + _id);
        }
        if (el && el.env && el.env.editor instanceof Editor) return el.env.editor;
        var value = "";
        if (el && /input|textarea/i.test(el.tagName)) {
            var oldNode = el;
            value = oldNode.value;
            el = dom.createElement("pre");
            oldNode.parentNode.replaceChild(el, oldNode);
        } else if (el) {
            value = el.textContent;
            el.innerHTML = "";
        }
        var doc = exports.createEditSession(value);
        var editor = new Editor(new Renderer(el), doc, options);
        var env = {
            document: doc,
            editor: editor,
            onResize: editor.resize.bind(editor, null)
        };
        if (oldNode) env.textarea = oldNode;
        editor.on("destroy", function() {
            env.editor.container.env = null; // prevent memory leak on old ie
        });
        editor.container.env = editor.env = env;
        return editor;
    };
    exports.createEditSession = function(text, mode) {
        var doc = new EditSession(text, mode);
        doc.setUndoManager(new UndoManager());
        return doc;
    };
    exports.Range = Range;
    exports.Editor = Editor;
    exports.EditSession = EditSession;
    exports.UndoManager = UndoManager;
    exports.VirtualRenderer = Renderer;
    exports.version = exports.config.version;
});
(function() {
    ace.require([
        "ace/ace"
    ], function(a) {
        if (a) {
            a.config.init(true);
            a.define = ace.define;
        }
        var global = function() {
            return this;
        }();
        if (!global && typeof window != "undefined") global = window; // can happen in strict mode
        if (!global && typeof self != "undefined") global = self; // can happen in webworker
        if (!global.ace) global.ace = a;
        for(var key in a)if (a.hasOwnProperty(key)) global.ace[key] = a[key];
        global.ace["default"] = global.ace;
        if (module) module.exports = global.ace;
    });
})();

});

parcelRequire.register("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRequire.register("6cqMT", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRequire.register("3vplU", function(module, exports) {
ace.define("ace/split", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/lib/lang",
    "ace/lib/event_emitter",
    "ace/editor",
    "ace/virtual_renderer",
    "ace/edit_session"
], function(require, exports, module1) {
    "use strict";
    var oop = require("./lib/oop");
    var lang = require("./lib/lang");
    var EventEmitter = require("./lib/event_emitter").EventEmitter;
    var Editor = require("./editor").Editor;
    var Renderer = require("./virtual_renderer").VirtualRenderer;
    var EditSession = require("./edit_session").EditSession;
    var Split = function(container, theme, splits) {
        this.BELOW = 1;
        this.BESIDE = 0;
        this.$container = container;
        this.$theme = theme;
        this.$splits = 0;
        this.$editorCSS = "";
        this.$editors = [];
        this.$orientation = this.BESIDE;
        this.setSplits(splits || 1);
        this.$cEditor = this.$editors[0];
        this.on("focus", (function(editor) {
            this.$cEditor = editor;
        }).bind(this));
    };
    (function() {
        oop.implement(this, EventEmitter);
        this.$createEditor = function() {
            var el = document.createElement("div");
            el.className = this.$editorCSS;
            el.style.cssText = "position: absolute; top:0px; bottom:0px";
            this.$container.appendChild(el);
            var editor = new Editor(new Renderer(el, this.$theme));
            editor.on("focus", (function() {
                this._emit("focus", editor);
            }).bind(this));
            this.$editors.push(editor);
            editor.setFontSize(this.$fontSize);
            return editor;
        };
        this.setSplits = function(splits) {
            var editor;
            if (splits < 1) throw "The number of splits have to be > 0!";
            if (splits == this.$splits) return;
            else if (splits > this.$splits) {
                while(this.$splits < this.$editors.length && this.$splits < splits){
                    editor = this.$editors[this.$splits];
                    this.$container.appendChild(editor.container);
                    editor.setFontSize(this.$fontSize);
                    this.$splits++;
                }
                while(this.$splits < splits){
                    this.$createEditor();
                    this.$splits++;
                }
            } else while(this.$splits > splits){
                editor = this.$editors[this.$splits - 1];
                this.$container.removeChild(editor.container);
                this.$splits--;
            }
            this.resize();
        };
        this.getSplits = function() {
            return this.$splits;
        };
        this.getEditor = function(idx) {
            return this.$editors[idx];
        };
        this.getCurrentEditor = function() {
            return this.$cEditor;
        };
        this.focus = function() {
            this.$cEditor.focus();
        };
        this.blur = function() {
            this.$cEditor.blur();
        };
        this.setTheme = function(theme) {
            this.$editors.forEach(function(editor) {
                editor.setTheme(theme);
            });
        };
        this.setKeyboardHandler = function(keybinding) {
            this.$editors.forEach(function(editor) {
                editor.setKeyboardHandler(keybinding);
            });
        };
        this.forEach = function(callback, scope) {
            this.$editors.forEach(callback, scope);
        };
        this.$fontSize = "";
        this.setFontSize = function(size) {
            this.$fontSize = size;
            this.forEach(function(editor) {
                editor.setFontSize(size);
            });
        };
        this.$cloneSession = function(session) {
            var s = new EditSession(session.getDocument(), session.getMode());
            var undoManager = session.getUndoManager();
            s.setUndoManager(undoManager);
            s.setTabSize(session.getTabSize());
            s.setUseSoftTabs(session.getUseSoftTabs());
            s.setOverwrite(session.getOverwrite());
            s.setBreakpoints(session.getBreakpoints());
            s.setUseWrapMode(session.getUseWrapMode());
            s.setUseWorker(session.getUseWorker());
            s.setWrapLimitRange(session.$wrapLimitRange.min, session.$wrapLimitRange.max);
            s.$foldData = session.$cloneFoldData();
            return s;
        };
        this.setSession = function(session, idx) {
            var editor;
            if (idx == null) editor = this.$cEditor;
            else editor = this.$editors[idx];
            var isUsed = this.$editors.some(function(editor) {
                return editor.session === session;
            });
            if (isUsed) session = this.$cloneSession(session);
            editor.setSession(session);
            return session;
        };
        this.getOrientation = function() {
            return this.$orientation;
        };
        this.setOrientation = function(orientation) {
            if (this.$orientation == orientation) return;
            this.$orientation = orientation;
            this.resize();
        };
        this.resize = function() {
            var width = this.$container.clientWidth;
            var height = this.$container.clientHeight;
            var editor;
            if (this.$orientation == this.BESIDE) {
                var editorWidth = width / this.$splits;
                for(var i = 0; i < this.$splits; i++){
                    editor = this.$editors[i];
                    editor.container.style.width = editorWidth + "px";
                    editor.container.style.top = "0px";
                    editor.container.style.left = i * editorWidth + "px";
                    editor.container.style.height = height + "px";
                    editor.resize();
                }
            } else {
                var editorHeight = height / this.$splits;
                for(var i = 0; i < this.$splits; i++){
                    editor = this.$editors[i];
                    editor.container.style.width = width + "px";
                    editor.container.style.top = i * editorHeight + "px";
                    editor.container.style.left = "0px";
                    editor.container.style.height = editorHeight + "px";
                    editor.resize();
                }
            }
        };
    }).call(Split.prototype);
    exports.Split = Split;
});
ace.define("ace/ext/split", [
    "require",
    "exports",
    "module",
    "ace/split"
], function(require, exports, module1) {
    "use strict";
    module1.exports = require("../split");
});
(function() {
    ace.require([
        "ace/ext/split"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRequire.register("9ZTTk", function(module, exports) {
ace.define("ace/mode/jsdoc_comment_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var JsDocCommentHighlightRules = function() {
        this.$rules = {
            "start": [
                {
                    token: [
                        "comment.doc.tag",
                        "comment.doc.text",
                        "lparen.doc"
                    ],
                    regex: "(@(?:param|member|typedef|property|namespace|var|const|callback))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: [
                                "rparen.doc",
                                "text.doc",
                                "variable.parameter.doc",
                                "lparen.doc",
                                "variable.parameter.doc",
                                "rparen.doc"
                            ],
                            regex: /(})(\s*)(?:([\w=:\/\.]+)|(?:(\[)([\w=:\/\.]+)(\])))/,
                            next: "pop"
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "lparen.doc"
                    ],
                    regex: "(@(?:returns?|yields|type|this|suppress|public|protected|private|package|modifies|implements|external|exception|throws|enum|define|extends))(\\s*)({)",
                    push: [
                        {
                            token: "lparen.doc",
                            regex: "{",
                            push: [
                                {
                                    include: "doc-syntax"
                                },
                                {
                                    token: "rparen.doc",
                                    regex: "}|(?=$)",
                                    next: "pop"
                                }
                            ]
                        },
                        {
                            token: "rparen.doc",
                            regex: "}|(?=$)",
                            next: "pop"
                        },
                        {
                            include: "doc-syntax"
                        },
                        {
                            defaultToken: "text.doc"
                        }
                    ]
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: '(@(?:alias|memberof|instance|module|name|lends|namespace|external|this|template|requires|param|implements|function|extends|typedef|mixes|constructor|var|memberof\\!|event|listens|exports|class|constructs|interface|emits|fires|throws|const|callback|borrows|augments))(\\s+)(\\w[\\w#.:/~"\\-]*)?'
                },
                {
                    token: [
                        "comment.doc.tag",
                        "text.doc",
                        "variable.parameter.doc"
                    ],
                    regex: "(@method)(\\s+)(\\w[\\w.\\(\\)]*)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@access\\s+(?:private|public|protected)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@kind\\s+(?:class|constant|event|external|file|function|member|mixin|module|namespace|typedef)"
                },
                {
                    token: "comment.doc.tag",
                    regex: "@\\w+(?=\\s|$)"
                },
                JsDocCommentHighlightRules.getTagRule(),
                {
                    defaultToken: "comment.doc",
                    caseInsensitive: true
                }
            ],
            "doc-syntax": [
                {
                    token: "operator.doc",
                    regex: /[|:]/
                },
                {
                    token: "paren.doc",
                    regex: /[\[\]]/
                }
            ]
        };
        this.normalizeRules();
    };
    oop.inherits(JsDocCommentHighlightRules, TextHighlightRules);
    JsDocCommentHighlightRules.getTagRule = function(start) {
        return {
            token: "comment.doc.tag.storage.type",
            regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
        };
    };
    JsDocCommentHighlightRules.getStartRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\/\\*(?=\\*)",
            next: start
        };
    };
    JsDocCommentHighlightRules.getEndRule = function(start) {
        return {
            token: "comment.doc",
            regex: "\\*\\/",
            next: start
        };
    };
    exports.JsDocCommentHighlightRules = JsDocCommentHighlightRules;
});
ace.define("ace/mode/javascript_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/jsdoc_comment_highlight_rules",
    "ace/mode/text_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var DocCommentHighlightRules = require("./jsdoc_comment_highlight_rules").JsDocCommentHighlightRules;
    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
    var identifierRe = "[a-zA-Z\\$_\xa1-￿][a-zA-Z\\d\\$_\xa1-￿]*";
    var JavaScriptHighlightRules = function(options) {
        var keywordMapper = this.createKeywordMapper({
            "variable.language": "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|Symbol|Namespace|QName|XML|XMLList|ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|SyntaxError|TypeError|URIError|decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|isNaN|parseFloat|parseInt|JSON|Math|this|arguments|prototype|window|document",
            "keyword": "const|yield|import|get|set|async|await|break|case|catch|continue|default|delete|do|else|finally|for|function|if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|__parent__|__count__|escape|unescape|with|__proto__|class|enum|extends|super|export|implements|private|public|interface|package|protected|static|constructor",
            "storage.type": "const|let|var|function",
            "constant.language": "null|Infinity|NaN|undefined",
            "support.function": "alert",
            "constant.language.boolean": "true|false"
        }, "identifier");
        var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
        var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|u{[0-9a-fA-F]{1,6}}|[0-2][0-7]{0,2}|3[0-7][0-7]?|[4-7][0-7]?|.)";
        this.$rules = {
            "no_regex": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("no_regex"),
                {
                    token: "string",
                    regex: "'(?=.)",
                    next: "qstring"
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    next: "qqstring"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "support.function",
                        "punctuation.operator",
                        "entity.name.function",
                        "text",
                        "keyword.operator"
                    ],
                    regex: "(" + identifierRe + ")(\\.)(prototype)(\\.)(" + identifierRe + ")(\\s*)(=)",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "entity.name.function",
                        "text",
                        "keyword.operator",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\.)(" + identifierRe + ")(\\s*)(=)(\\s*)(function\\*?)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "keyword.operator",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(=)(\\s*)(function\\*?)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "entity.name.function",
                        "text",
                        "keyword.operator",
                        "text",
                        "storage.type",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\.)(" + identifierRe + ")(\\s*)(=)(\\s*)(function\\*?)(\\s+)(\\w+)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "storage.type",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(function\\*?)(\\s+)(" + identifierRe + ")(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "entity.name.function",
                        "text",
                        "punctuation.operator",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\s*)(:)(\\s*)(function\\*?)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: [
                        "text",
                        "text",
                        "storage.type",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(:)(\\s*)(function\\*?)(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "keyword",
                    regex: "from(?=\\s*('|\"))"
                },
                {
                    token: "keyword",
                    regex: "(?:" + kwBeforeRe + ")\\b",
                    next: "start"
                },
                {
                    token: "support.constant",
                    regex: /that\b/
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "support.function.firebug"
                    ],
                    regex: /(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/
                },
                {
                    token: keywordMapper,
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/,
                    next: "property"
                },
                {
                    token: "storage.type",
                    regex: /=>/,
                    next: "start"
                },
                {
                    token: "keyword.operator",
                    regex: /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
                    next: "start"
                },
                {
                    token: "punctuation.operator",
                    regex: /[?:,;.]/,
                    next: "start"
                },
                {
                    token: "paren.lparen",
                    regex: /[\[({]/,
                    next: "start"
                },
                {
                    token: "paren.rparen",
                    regex: /[\])}]/
                },
                {
                    token: "comment",
                    regex: /^#!.*$/
                }
            ],
            property: [
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: [
                        "storage.type",
                        "punctuation.operator",
                        "entity.name.function",
                        "text",
                        "keyword.operator",
                        "text",
                        "storage.type",
                        "text",
                        "entity.name.function",
                        "text",
                        "paren.lparen"
                    ],
                    regex: "(" + identifierRe + ")(\\.)(" + identifierRe + ")(\\s*)(=)(\\s*)(function\\*?)(?:(\\s+)(\\w+))?(\\s*)(\\()",
                    next: "function_arguments"
                },
                {
                    token: "punctuation.operator",
                    regex: /[.](?![.])/
                },
                {
                    token: "support.function",
                    regex: /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|lter|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward|rEach)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
                },
                {
                    token: "support.function.dom",
                    regex: /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
                },
                {
                    token: "support.constant",
                    regex: /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
                },
                {
                    token: "identifier",
                    regex: identifierRe
                },
                {
                    regex: "",
                    token: "empty",
                    next: "no_regex"
                }
            ],
            "start": [
                DocCommentHighlightRules.getStartRule("doc-start"),
                comments("start"),
                {
                    token: "string.regexp",
                    regex: "\\/",
                    next: "regex"
                },
                {
                    token: "text",
                    regex: "\\s+|^$",
                    next: "start"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "regex": [
                {
                    token: "regexp.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "string.regexp",
                    regex: "/[sxngimy]*",
                    next: "no_regex"
                },
                {
                    token: "invalid",
                    regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
                },
                {
                    token: "constant.language.escape",
                    regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
                },
                {
                    token: "constant.language.delimiter",
                    regex: /\|/
                },
                {
                    token: "constant.language.escape",
                    regex: /\[\^?/,
                    next: "regex_character_class"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp"
                }
            ],
            "regex_character_class": [
                {
                    token: "regexp.charclass.keyword.operator",
                    regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
                },
                {
                    token: "constant.language.escape",
                    regex: "]",
                    next: "regex"
                },
                {
                    token: "constant.language.escape",
                    regex: "-"
                },
                {
                    token: "empty",
                    regex: "$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string.regexp.charachterclass"
                }
            ],
            "default_parameter": [
                {
                    token: "string",
                    regex: "'(?=.)",
                    push: [
                        {
                            token: "string",
                            regex: "'|$",
                            next: "pop"
                        },
                        {
                            include: "qstring"
                        }
                    ]
                },
                {
                    token: "string",
                    regex: '"(?=.)',
                    push: [
                        {
                            token: "string",
                            regex: '"|$',
                            next: "pop"
                        },
                        {
                            include: "qqstring"
                        }
                    ]
                },
                {
                    token: "constant.language",
                    regex: "null|Infinity|NaN|undefined"
                },
                {
                    token: "constant.numeric",
                    regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
                },
                {
                    token: "constant.numeric",
                    regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
                },
                {
                    token: "punctuation.operator",
                    regex: ",",
                    next: "function_arguments"
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "function_arguments": [
                comments("function_arguments"),
                {
                    token: "variable.parameter",
                    regex: identifierRe
                },
                {
                    token: "punctuation.operator",
                    regex: ","
                },
                {
                    token: "text",
                    regex: "\\s+"
                },
                {
                    token: "punctuation.operator",
                    regex: "$"
                },
                {
                    token: "empty",
                    regex: "",
                    next: "no_regex"
                }
            ],
            "qqstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: '"|$',
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ],
            "qstring": [
                {
                    token: "constant.language.escape",
                    regex: escapedRe
                },
                {
                    token: "string",
                    regex: "\\\\$",
                    consumeLineEnd: true
                },
                {
                    token: "string",
                    regex: "'|$",
                    next: "no_regex"
                },
                {
                    defaultToken: "string"
                }
            ]
        };
        if (!options || !options.noES6) {
            this.$rules.no_regex.unshift({
                regex: "[{}]",
                onMatch: function(val, state, stack) {
                    this.next = val == "{" ? this.nextState : "";
                    if (val == "{" && stack.length) stack.unshift("start", state);
                    else if (val == "}" && stack.length) {
                        stack.shift();
                        this.next = stack.shift();
                        if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1) return "paren.quasi.end";
                    }
                    return val == "{" ? "paren.lparen" : "paren.rparen";
                },
                nextState: "start"
            }, {
                token: "string.quasi.start",
                regex: /`/,
                push: [
                    {
                        token: "constant.language.escape",
                        regex: escapedRe
                    },
                    {
                        token: "paren.quasi.start",
                        regex: /\${/,
                        push: "start"
                    },
                    {
                        token: "string.quasi.end",
                        regex: /`/,
                        next: "pop"
                    },
                    {
                        defaultToken: "string.quasi"
                    }
                ]
            }, {
                token: [
                    "variable.parameter",
                    "text"
                ],
                regex: "(" + identifierRe + ")(\\s*)(?=\\=>)"
            }, {
                token: "paren.lparen",
                regex: "(\\()(?=.+\\s*=>)",
                next: "function_arguments"
            }, {
                token: "variable.language",
                regex: "(?:(?:(?:Weak)?(?:Set|Map))|Promise)\\b"
            });
            this.$rules["function_arguments"].unshift({
                token: "keyword.operator",
                regex: "=",
                next: "default_parameter"
            }, {
                token: "keyword.operator",
                regex: "\\.{3}"
            });
            this.$rules["property"].unshift({
                token: "support.function",
                regex: "(findIndex|repeat|startsWith|endsWith|includes|isSafeInteger|trunc|cbrt|log2|log10|sign|then|catch|finally|resolve|reject|race|any|all|allSettled|keys|entries|isInteger)\\b(?=\\()"
            }, {
                token: "constant.language",
                regex: "(?:MAX_SAFE_INTEGER|MIN_SAFE_INTEGER|EPSILON)\\b"
            });
            if (!options || options.jsx != false) JSX.call(this);
        }
        this.embedRules(DocCommentHighlightRules, "doc-", [
            DocCommentHighlightRules.getEndRule("no_regex")
        ]);
        this.normalizeRules();
    };
    oop.inherits(JavaScriptHighlightRules, TextHighlightRules);
    function JSX() {
        var tagRegex = identifierRe.replace("\\d", "\\d\\-");
        var jsxTag = {
            onMatch: function(val, state, stack) {
                var offset = val.charAt(1) == "/" ? 2 : 1;
                if (offset == 1) {
                    if (state != this.nextState) stack.unshift(this.next, this.nextState, 0);
                    else stack.unshift(this.next);
                    stack[2]++;
                } else if (offset == 2) {
                    if (state == this.nextState) {
                        stack[1]--;
                        if (!stack[1] || stack[1] < 0) {
                            stack.shift();
                            stack.shift();
                        }
                    }
                }
                return [
                    {
                        type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
                        value: val.slice(0, offset)
                    },
                    {
                        type: "meta.tag.tag-name.xml",
                        value: val.substr(offset)
                    }
                ];
            },
            regex: "</?" + tagRegex + "",
            next: "jsxAttributes",
            nextState: "jsx"
        };
        this.$rules.start.unshift(jsxTag);
        var jsxJsRule = {
            regex: "{",
            token: "paren.quasi.start",
            push: "start"
        };
        this.$rules.jsx = [
            jsxJsRule,
            jsxTag,
            {
                include: "reference"
            },
            {
                defaultToken: "string"
            }
        ];
        this.$rules.jsxAttributes = [
            {
                token: "meta.tag.punctuation.tag-close.xml",
                regex: "/?>",
                onMatch: function(value, currentState, stack) {
                    if (currentState == stack[0]) stack.shift();
                    if (value.length == 2) {
                        if (stack[0] == this.nextState) stack[1]--;
                        if (!stack[1] || stack[1] < 0) stack.splice(0, 2);
                    }
                    this.next = stack[0] || "start";
                    return [
                        {
                            type: this.token,
                            value: value
                        }
                    ];
                },
                nextState: "jsx"
            },
            jsxJsRule,
            comments("jsxAttributes"),
            {
                token: "entity.other.attribute-name.xml",
                regex: tagRegex
            },
            {
                token: "keyword.operator.attribute-equals.xml",
                regex: "="
            },
            {
                token: "text.tag-whitespace.xml",
                regex: "\\s+"
            },
            {
                token: "string.attribute-value.xml",
                regex: "'",
                stateName: "jsx_attr_q",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: "'",
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            {
                token: "string.attribute-value.xml",
                regex: '"',
                stateName: "jsx_attr_qq",
                push: [
                    {
                        token: "string.attribute-value.xml",
                        regex: '"',
                        next: "pop"
                    },
                    {
                        include: "reference"
                    },
                    {
                        defaultToken: "string.attribute-value.xml"
                    }
                ]
            },
            jsxTag
        ];
        this.$rules.reference = [
            {
                token: "constant.language.escape.reference.xml",
                regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
            }
        ];
    }
    function comments(next) {
        return [
            {
                token: "comment",
                regex: /\/\*/,
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "\\*\\/",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            },
            {
                token: "comment",
                regex: "\\/\\/",
                next: [
                    DocCommentHighlightRules.getTagRule(),
                    {
                        token: "comment",
                        regex: "$|^",
                        next: next || "pop"
                    },
                    {
                        defaultToken: "comment",
                        caseInsensitive: true
                    }
                ]
            }
        ];
    }
    exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
});
ace.define("ace/mode/matching_brace_outdent", [
    "require",
    "exports",
    "module",
    "ace/range"
], function(require, exports, module1) {
    "use strict";
    var Range = require("../range").Range;
    var MatchingBraceOutdent = function() {};
    (function() {
        this.checkOutdent = function(line, input) {
            if (!/^\s+$/.test(line)) return false;
            return /^\s*\}/.test(input);
        };
        this.autoOutdent = function(doc, row) {
            var line = doc.getLine(row);
            var match = line.match(/^(\s*\})/);
            if (!match) return 0;
            var column = match[1].length;
            var openBracePos = doc.findMatchingBracket({
                row: row,
                column: column
            });
            if (!openBracePos || openBracePos.row == row) return 0;
            var indent = this.$getIndent(doc.getLine(openBracePos.row));
            doc.replace(new Range(row, 0, row, column - 1), indent);
        };
        this.$getIndent = function(line) {
            return line.match(/^\s*/)[0];
        };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
});
ace.define("ace/mode/folding/cstyle", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/range",
    "ace/mode/folding/fold_mode"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../../lib/oop");
    var Range = require("../../range").Range;
    var BaseFoldMode = require("./fold_mode").FoldMode;
    var FoldMode = exports.FoldMode = function(commentRegex) {
        if (commentRegex) {
            this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
            this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
        }
    };
    oop.inherits(FoldMode, BaseFoldMode);
    (function() {
        this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
        this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
        this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
        this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
        this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
        this._getFoldWidgetBase = this.getFoldWidget;
        this.getFoldWidget = function(session, foldStyle, row) {
            var line = session.getLine(row);
            if (this.singleLineBlockCommentRe.test(line)) {
                if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
            }
            var fw = this._getFoldWidgetBase(session, foldStyle, row);
            if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart
            return fw;
        };
        this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
            var line = session.getLine(row);
            if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
            var match = line.match(this.foldingStartMarker);
            if (match) {
                var i = match.index;
                if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
                var range = session.getCommentFoldRange(row, i + match[0].length, 1);
                if (range && !range.isMultiLine()) {
                    if (forceMultiline) range = this.getSectionRange(session, row);
                    else if (foldStyle != "all") range = null;
                }
                return range;
            }
            if (foldStyle === "markbegin") return;
            var match = line.match(this.foldingStopMarker);
            if (match) {
                var i = match.index + match[0].length;
                if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
                return session.getCommentFoldRange(row, i, -1);
            }
        };
        this.getSectionRange = function(session, row) {
            var line = session.getLine(row);
            var startIndent = line.search(/\S/);
            var startRow = row;
            var startColumn = line.length;
            row = row + 1;
            var endRow = row;
            var maxRow = session.getLength();
            while(++row < maxRow){
                line = session.getLine(row);
                var indent = line.search(/\S/);
                if (indent === -1) continue;
                if (startIndent > indent) break;
                var subRange = this.getFoldWidgetRange(session, "all", row);
                if (subRange) {
                    if (subRange.start.row <= startRow) break;
                    else if (subRange.isMultiLine()) row = subRange.end.row;
                    else if (startIndent == indent) break;
                }
                endRow = row;
            }
            return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
        };
        this.getCommentRegionBlock = function(session, line, row) {
            var startColumn = line.search(/\s*$/);
            var maxRow = session.getLength();
            var startRow = row;
            var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
            var depth = 1;
            while(++row < maxRow){
                line = session.getLine(row);
                var m = re.exec(line);
                if (!m) continue;
                if (m[1]) depth--;
                else depth++;
                if (!depth) break;
            }
            var endRow = row;
            if (endRow > startRow) return new Range(startRow, startColumn, endRow, line.length);
        };
    }).call(FoldMode.prototype);
});
ace.define("ace/mode/javascript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/text",
    "ace/mode/javascript_highlight_rules",
    "ace/mode/matching_brace_outdent",
    "ace/worker/worker_client",
    "ace/mode/behaviour/cstyle",
    "ace/mode/folding/cstyle"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var TextMode = require("./text").Mode;
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var WorkerClient = require("../worker/worker_client").WorkerClient;
    var CstyleBehaviour = require("./behaviour/cstyle").CstyleBehaviour;
    var CStyleFoldMode = require("./folding/cstyle").FoldMode;
    var Mode = function() {
        this.HighlightRules = JavaScriptHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = new CstyleBehaviour();
        this.foldingRules = new CStyleFoldMode();
    };
    oop.inherits(Mode, TextMode);
    (function() {
        this.lineCommentStart = "//";
        this.blockComment = {
            start: "/*",
            end: "*/"
        };
        this.$quotes = {
            '"': '"',
            "'": "'",
            "`": "`"
        };
        this.$pairQuotesAfter = {
            "`": /\w/
        };
        this.getNextLineIndent = function(state, line, tab) {
            var indent = this.$getIndent(line);
            var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
            var tokens = tokenizedLine.tokens;
            var endState = tokenizedLine.state;
            if (tokens.length && tokens[tokens.length - 1].type == "comment") return indent;
            if (state == "start" || state == "no_regex") {
                var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);
                if (match) indent += tab;
            } else if (state == "doc-start") {
                if (endState == "start" || endState == "no_regex") return "";
                var match = line.match(/^\s*(\/?)\*/);
                if (match) {
                    if (match[1]) indent += " ";
                    indent += "* ";
                }
            }
            return indent;
        };
        this.checkOutdent = function(state, line, input) {
            return this.$outdent.checkOutdent(line, input);
        };
        this.autoOutdent = function(state, doc, row) {
            this.$outdent.autoOutdent(doc, row);
        };
        this.createWorker = function(session) {
            var worker = new WorkerClient([
                "ace"
            ], "ace/mode/javascript_worker", "JavaScriptWorker");
            worker.attachToDocument(session.getDocument());
            worker.on("annotate", function(results) {
                session.setAnnotations(results.data);
            });
            worker.on("terminate", function() {
                session.clearAnnotations();
            });
            return worker;
        };
        this.$id = "ace/mode/javascript";
        this.snippetFileId = "ace/snippets/javascript";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
ace.define("ace/mode/typescript_highlight_rules", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/javascript_highlight_rules"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;
    var TypeScriptHighlightRules = function(options) {
        var tsRules = [
            {
                token: [
                    "storage.type",
                    "text",
                    "entity.name.function.ts"
                ],
                regex: "(function)(\\s+)([a-zA-Z0-9$_\xa1-￿][a-zA-Z0-9d$_\xa1-￿]*)"
            },
            {
                token: "keyword",
                regex: "(?:\\b(constructor|declare|interface|as|AS|public|private|extends|export|super|readonly|module|namespace|abstract|implements)\\b)"
            },
            {
                token: [
                    "keyword",
                    "storage.type.variable.ts"
                ],
                regex: "(class|type)(\\s+[a-zA-Z0-9_?.$][\\w?.$]*)"
            },
            {
                token: "keyword",
                regex: "\\b(?:super|export|import|keyof|infer)\\b"
            },
            {
                token: [
                    "storage.type.variable.ts"
                ],
                regex: "(?:\\b(this\\.|string\\b|bool\\b|boolean\\b|number\\b|true\\b|false\\b|undefined\\b|any\\b|null\\b|(?:unique )?symbol\\b|object\\b|never\\b|enum\\b))"
            }
        ];
        var JSRules = new JavaScriptHighlightRules({
            jsx: (options && options.jsx) == true
        }).getRules();
        JSRules.no_regex = tsRules.concat(JSRules.no_regex);
        this.$rules = JSRules;
    };
    oop.inherits(TypeScriptHighlightRules, JavaScriptHighlightRules);
    exports.TypeScriptHighlightRules = TypeScriptHighlightRules;
});
ace.define("ace/mode/typescript", [
    "require",
    "exports",
    "module",
    "ace/lib/oop",
    "ace/mode/javascript",
    "ace/mode/typescript_highlight_rules",
    "ace/mode/folding/cstyle",
    "ace/mode/matching_brace_outdent"
], function(require, exports, module1) {
    "use strict";
    var oop = require("../lib/oop");
    var jsMode = require("./javascript").Mode;
    var TypeScriptHighlightRules = require("./typescript_highlight_rules").TypeScriptHighlightRules;
    var CStyleFoldMode = require("./folding/cstyle").FoldMode;
    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;
    var Mode = function() {
        this.HighlightRules = TypeScriptHighlightRules;
        this.$outdent = new MatchingBraceOutdent();
        this.$behaviour = this.$defaultBehaviour;
        this.foldingRules = new CStyleFoldMode();
    };
    oop.inherits(Mode, jsMode);
    (function() {
        this.createWorker = function(session) {
            return null;
        };
        this.$id = "ace/mode/typescript";
    }).call(Mode.prototype);
    exports.Mode = Mode;
});
(function() {
    ace.require([
        "ace/mode/typescript"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRequire.register("6838E", function(module, exports) {
ace.define("ace/theme/github-css", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    module1.exports = '/* CSS style content from github\'s default pygments highlighter template.\n   Cursor and selection styles from textmate.css. */\n.ace-github .ace_gutter {\n  background: #e8e8e8;\n  color: #AAA;\n}\n\n.ace-github  {\n  background: #fff;\n  color: #000;\n}\n\n.ace-github .ace_keyword {\n  font-weight: bold;\n}\n\n.ace-github .ace_string {\n  color: #D14;\n}\n\n.ace-github .ace_variable.ace_class {\n  color: teal;\n}\n\n.ace-github .ace_constant.ace_numeric {\n  color: #099;\n}\n\n.ace-github .ace_constant.ace_buildin {\n  color: #0086B3;\n}\n\n.ace-github .ace_support.ace_function {\n  color: #0086B3;\n}\n\n.ace-github .ace_comment {\n  color: #998;\n  font-style: italic;\n}\n\n.ace-github .ace_variable.ace_language  {\n  color: #0086B3;\n}\n\n.ace-github .ace_paren {\n  font-weight: bold;\n}\n\n.ace-github .ace_boolean {\n  font-weight: bold;\n}\n\n.ace-github .ace_string.ace_regexp {\n  color: #009926;\n  font-weight: normal;\n}\n\n.ace-github .ace_variable.ace_instance {\n  color: teal;\n}\n\n.ace-github .ace_constant.ace_language {\n  font-weight: bold;\n}\n\n.ace-github .ace_cursor {\n  color: black;\n}\n\n.ace-github.ace_focus .ace_marker-layer .ace_active-line {\n  background: rgb(255, 255, 204);\n}\n.ace-github .ace_marker-layer .ace_active-line {\n  background: rgb(245, 245, 245);\n}\n\n.ace-github .ace_marker-layer .ace_selection {\n  background: rgb(181, 213, 255);\n}\n\n.ace-github.ace_multiselect .ace_selection.ace_start {\n  box-shadow: 0 0 3px 0px white;\n}\n/* bold keywords cause cursor issues for some fonts */\n/* this disables bold style for editor and keeps for static highlighter */\n.ace-github.ace_nobold .ace_line > span {\n    font-weight: normal !important;\n}\n\n.ace-github .ace_marker-layer .ace_step {\n  background: rgb(252, 255, 0);\n}\n\n.ace-github .ace_marker-layer .ace_stack {\n  background: rgb(164, 229, 101);\n}\n\n.ace-github .ace_marker-layer .ace_bracket {\n  margin: -1px 0 0 -1px;\n  border: 1px solid rgb(192, 192, 192);\n}\n\n.ace-github .ace_gutter-active-line {\n    background-color : rgba(0, 0, 0, 0.07);\n}\n\n.ace-github .ace_marker-layer .ace_selected-word {\n  background: rgb(250, 250, 255);\n  border: 1px solid rgb(200, 200, 250);\n}\n\n.ace-github .ace_invisible {\n  color: #BFBFBF\n}\n\n.ace-github .ace_print-margin {\n  width: 1px;\n  background: #e8e8e8;\n}\n\n.ace-github .ace_indent-guide {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y;\n}\n\n.ace-github .ace_indent-guide-active {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAZSURBVHjaYvj///9/hivKyv8BAAAA//8DACLqBhbvk+/eAAAAAElFTkSuQmCC") right repeat-y;\n}\n';
});
ace.define("ace/theme/github", [
    "require",
    "exports",
    "module",
    "ace/theme/github-css",
    "ace/lib/dom"
], function(require, exports, module1) {
    exports.isDark = false;
    exports.cssClass = "ace-github";
    exports.cssText = require("./github-css");
    var dom = require("../lib/dom");
    dom.importCssString(exports.cssText, exports.cssClass, false);
});
(function() {
    ace.require([
        "ace/theme/github"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

parcelRequire.register("7OnGR", function(module, exports) {
ace.define("ace/theme/monokai-css", [
    "require",
    "exports",
    "module"
], function(require, exports, module1) {
    module1.exports = ".ace-monokai .ace_gutter {\n  background: #2F3129;\n  color: #8F908A\n}\n\n.ace-monokai .ace_print-margin {\n  width: 1px;\n  background: #555651\n}\n\n.ace-monokai {\n  background-color: #272822;\n  color: #F8F8F2\n}\n\n.ace-monokai .ace_cursor {\n  color: #F8F8F0\n}\n\n.ace-monokai .ace_marker-layer .ace_selection {\n  background: #49483E\n}\n\n.ace-monokai.ace_multiselect .ace_selection.ace_start {\n  box-shadow: 0 0 3px 0px #272822;\n}\n\n.ace-monokai .ace_marker-layer .ace_step {\n  background: rgb(102, 82, 0)\n}\n\n.ace-monokai .ace_marker-layer .ace_bracket {\n  margin: -1px 0 0 -1px;\n  border: 1px solid #49483E\n}\n\n.ace-monokai .ace_marker-layer .ace_active-line {\n  background: #202020\n}\n\n.ace-monokai .ace_gutter-active-line {\n  background-color: #272727\n}\n\n.ace-monokai .ace_marker-layer .ace_selected-word {\n  border: 1px solid #49483E\n}\n\n.ace-monokai .ace_invisible {\n  color: #52524d\n}\n\n.ace-monokai .ace_entity.ace_name.ace_tag,\n.ace-monokai .ace_keyword,\n.ace-monokai .ace_meta.ace_tag,\n.ace-monokai .ace_storage {\n  color: #F92672\n}\n\n.ace-monokai .ace_punctuation,\n.ace-monokai .ace_punctuation.ace_tag {\n  color: #fff\n}\n\n.ace-monokai .ace_constant.ace_character,\n.ace-monokai .ace_constant.ace_language,\n.ace-monokai .ace_constant.ace_numeric,\n.ace-monokai .ace_constant.ace_other {\n  color: #AE81FF\n}\n\n.ace-monokai .ace_invalid {\n  color: #F8F8F0;\n  background-color: #F92672\n}\n\n.ace-monokai .ace_invalid.ace_deprecated {\n  color: #F8F8F0;\n  background-color: #AE81FF\n}\n\n.ace-monokai .ace_support.ace_constant,\n.ace-monokai .ace_support.ace_function {\n  color: #66D9EF\n}\n\n.ace-monokai .ace_fold {\n  background-color: #A6E22E;\n  border-color: #F8F8F2\n}\n\n.ace-monokai .ace_storage.ace_type,\n.ace-monokai .ace_support.ace_class,\n.ace-monokai .ace_support.ace_type {\n  font-style: italic;\n  color: #66D9EF\n}\n\n.ace-monokai .ace_entity.ace_name.ace_function,\n.ace-monokai .ace_entity.ace_other,\n.ace-monokai .ace_entity.ace_other.ace_attribute-name,\n.ace-monokai .ace_variable {\n  color: #A6E22E\n}\n\n.ace-monokai .ace_variable.ace_parameter {\n  font-style: italic;\n  color: #FD971F\n}\n\n.ace-monokai .ace_string {\n  color: #E6DB74\n}\n\n.ace-monokai .ace_comment {\n  color: #75715E\n}\n\n.ace-monokai .ace_indent-guide {\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWPQ0FD0ZXBzd/wPAAjVAoxeSgNeAAAAAElFTkSuQmCC) right repeat-y\n}\n\n.ace-monokai .ace_indent-guide-active {\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQIW2PQ1dX9zzBz5sz/ABCcBFFentLlAAAAAElFTkSuQmCC) right repeat-y;\n}\n";
});
ace.define("ace/theme/monokai", [
    "require",
    "exports",
    "module",
    "ace/theme/monokai-css",
    "ace/lib/dom"
], function(require, exports, module1) {
    exports.isDark = true;
    exports.cssClass = "ace-monokai";
    exports.cssText = require("./monokai-css");
    var dom = require("../lib/dom");
    dom.importCssString(exports.cssText, exports.cssClass, false);
});
(function() {
    ace.require([
        "ace/theme/monokai"
    ], function(m) {
        if (module) module.exports = m;
    });
})();

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $aa95f1d67c4fd307$var$NOOP = ()=>undefined;
const $aa95f1d67c4fd307$export$527e3627cf94f1a = (value, typeStructureVariety = [])=>{
    const typeStructureMap = typeStructureVariety.reduce((acc, typeStructure)=>{
        acc[typeStructure.type] = typeStructure;
        return acc;
    }, {});
    const valueTypeSignature = value && typeof value === "object" ? Object.keys(value).sort() : typeof value;
    const scoreMap = {};
    for (const tS of typeStructureVariety){
        if (typeof valueTypeSignature === "string" && tS.type === valueTypeSignature) return tS;
        else if (valueTypeSignature instanceof Array) {
            const typeSignature = tS.content?.length ? tS.content.map((tSC)=>tSC.name).sort() : tS.type;
            if (typeSignature instanceof Array) {
                for (const typeSigProp of typeSignature)if (valueTypeSignature.includes(typeSigProp)) scoreMap[tS.type] = scoreMap[tS.type] ? scoreMap[tS.type] + 1 : 1;
                else scoreMap[tS.type] = scoreMap[tS.type] ? scoreMap[tS.type] : 0;
            }
        }
    }
    const typeList = Object.keys(scoreMap);
    return typeList.reduce((acc, typeName)=>{
        if (!acc || scoreMap[typeName] > (scoreMap[acc.type] || 0)) return typeStructureMap[typeName];
        else return acc;
    }, typeStructureVariety[0]);
};
const $aa95f1d67c4fd307$export$223709e25f1d6a35 = (name, type, typeStructures = [])=>{
    let combinedTypeStructure;
    for (const tS of typeStructures)combinedTypeStructure = combinedTypeStructure ? {
        ...combinedTypeStructure,
        ...tS,
        content: [
            ...combinedTypeStructure.content || [],
            ...tS.content || []
        ]
    } : tS;
    return combinedTypeStructure ? {
        ...combinedTypeStructure,
        name: name,
        type: type
    } : undefined;
};
const $aa95f1d67c4fd307$export$172307a08a7d1e58 = (typeValue = "", namespace)=>{
    const cleanType = typeValue.replace(/\[]/gim, ()=>"");
    return namespace ? `${namespace}.${cleanType}` : cleanType;
};
const $aa95f1d67c4fd307$export$c867550b4c242c9c = ({ allowed: allowed = [] , disallowed: disallowed = []  } = {}, typeStructure)=>{
    const { content: content = []  } = typeStructure;
    const newContent = allowed && allowed.length > 0 ? content.filter((tS)=>allowed.includes(tS.name)) : disallowed && disallowed.length > 0 ? content.filter((tS)=>!disallowed.includes(tS.name)) : content;
    return {
        ...typeStructure,
        content: newContent
    };
};
const $aa95f1d67c4fd307$export$983a349dad361514 = (name, map)=>map[name];
const $aa95f1d67c4fd307$export$4ce751624b8a5630 = (...typeStructures)=>{
    let mergedTypeStructure = undefined;
    for (const tS of typeStructures){
        const partialMergedTS = mergedTypeStructure || {};
        const partialTS = tS || {};
        const { tags: mergedTags = {}  } = partialMergedTS;
        const { tags: tSTags = {}  } = partialTS;
        mergedTypeStructure = {
            ...partialMergedTS,
            ...tS,
            tags: {
                ...mergedTags,
                ...tSTags
            }
        };
    }
    return mergedTypeStructure;
};
const $aa95f1d67c4fd307$export$cafc02de3ffb00ae = (typeStructure, typeStructureMap)=>{
    const { namespace: namespace , name: name , type: type , typeAlias: typeAlias , literal: literal , comments: comments = [] , tags: tags = {}  } = typeStructure;
    if (literal) return typeStructure;
    else {
        const cleanType = $aa95f1d67c4fd307$export$172307a08a7d1e58(type);
        const cleanTypeWithNamespace = $aa95f1d67c4fd307$export$172307a08a7d1e58(type, namespace);
        const { [cleanTypeWithNamespace]: mappedTypeStructureWithNamespace , [cleanType]: mappedTypeStructureNoNamespace  } = typeStructureMap || {};
        const useMappedWithNamespace = !!mappedTypeStructureWithNamespace;
        const mappedTypeStructure = useMappedWithNamespace ? mappedTypeStructureWithNamespace : mappedTypeStructureNoNamespace;
        const { comments: mappedTypeStructureComments = [] , tags: mappedTypeStructureTags = {}  } = mappedTypeStructure || {};
        const mergedTypeStructure = {
            ...mappedTypeStructure,
            ...typeStructure,
            name: name,
            typeAlias: mappedTypeStructure ? type : typeAlias,
            comments: [
                ...mappedTypeStructureComments,
                ...comments
            ],
            tags: {
                ...mappedTypeStructureTags,
                ...tags
            }
        };
        const typeForMatching = useMappedWithNamespace ? cleanTypeWithNamespace : cleanType;
        const cleanMappedType = $aa95f1d67c4fd307$export$172307a08a7d1e58(mappedTypeStructure?.type || "", mappedTypeStructure?.namespace);
        if (mappedTypeStructure && cleanMappedType !== typeForMatching) return $aa95f1d67c4fd307$export$cafc02de3ffb00ae(mergedTypeStructure, typeStructureMap);
        return mergedTypeStructure;
    }
};
const $aa95f1d67c4fd307$export$403cdf01662f5b4b = (path, typeStructure, typeStructureMap)=>{
    const { multiple: multiple = false , type: type = ""  } = typeStructure;
    const baseTS = $aa95f1d67c4fd307$export$cafc02de3ffb00ae(typeStructure, typeStructureMap);
    const { content: content = []  } = baseTS || {};
    const [firstPathPart, ...multiPath] = path;
    const firstPathPartIsNumber = !isNaN(Number(firstPathPart));
    const firstPathPartIsInContent = !!content.find(({ name: name  })=>name === firstPathPart);
    const isItemSubPath = firstPathPartIsNumber || !firstPathPartIsInContent;
    const targetPath = multiple && isItemSubPath ? multiPath : path;
    let tS = baseTS;
    if (tS && targetPath.length > 0) {
        const [targetPathPart, ...remainingPath] = targetPath;
        const { content: currentContentList = []  } = tS;
        const targetContent = currentContentList.find(({ name: name  })=>name === targetPathPart);
        if (targetContent) tS = $aa95f1d67c4fd307$export$403cdf01662f5b4b(remainingPath, targetContent, typeStructureMap);
    }
    return tS ? tS : {};
};
const $aa95f1d67c4fd307$export$a03274fdd2ce9db0 = (typeStructure)=>{
    const { literal: literal = false , content: content = []  } = typeStructure;
    return literal && content.length === 0;
};
const $aa95f1d67c4fd307$export$ba72d4a6880d3748 = (typeStructure)=>{
    const { type: type , multiple: multiple  } = typeStructure;
    const isPrimitive = $aa95f1d67c4fd307$export$a03274fdd2ce9db0(typeStructure);
    if (isPrimitive) switch(type){
        case "string":
            return "";
        case "number":
            return 0;
        case "boolean":
            return false;
        default:
            return undefined;
    }
    else return multiple ? [] : {};
};
var $aa95f1d67c4fd307$export$34848ee8632b1f2f;
(function(TAG_TYPES) {
    TAG_TYPES["label"] = "label";
    TAG_TYPES["inline"] = "inline";
    TAG_TYPES["layout"] = "layout";
    TAG_TYPES["displayLayout"] = "displayLayout";
    TAG_TYPES["itemName"] = "itemName";
    TAG_TYPES["options"] = "options";
    TAG_TYPES["optionsType"] = "optionsType";
    TAG_TYPES["allowCustomValue"] = "allowCustomValue";
})($aa95f1d67c4fd307$export$34848ee8632b1f2f || ($aa95f1d67c4fd307$export$34848ee8632b1f2f = {}));
const $aa95f1d67c4fd307$export$42597d2e5829622e = (value)=>value !== undefined && value !== null ? `${value}` : "";
const $aa95f1d67c4fd307$export$31330438f6059b08 = (item = {}, itemNameTemplate = "")=>itemNameTemplate.replace(/\`(\w+)\`/g, (match, key)=>$aa95f1d67c4fd307$export$42597d2e5829622e(item[key]));
const $aa95f1d67c4fd307$export$137bf301edaceb2e = (tagName, typeStructure)=>{
    const { tags: { [tagName]: { value: tagValue  } = {}  } = {}  } = typeStructure;
    return tagValue;
};
const $aa95f1d67c4fd307$export$1ec8a1e99ee8bb25 = (tagNames = [], typeStructure)=>{
    const tagValues = {};
    for (const tagName of tagNames)tagValues[tagName] = $aa95f1d67c4fd307$export$137bf301edaceb2e(tagName, typeStructure);
    return tagValues;
};
const $aa95f1d67c4fd307$export$536af8185edb7363 = (itemNameTemplate = "")=>itemNameTemplate.match(/\`(\w+)\`/g) ?? [];
const $aa95f1d67c4fd307$export$7cffee0f9aed39d0 = (value, typeStructure, typeStructureMap)=>{
    const itemNameTemplate = $aa95f1d67c4fd307$export$137bf301edaceb2e($aa95f1d67c4fd307$export$34848ee8632b1f2f.itemName, typeStructure);
    if (typeof itemNameTemplate === "string" && itemNameTemplate.trim() !== "") {
        const itemNameKeys = $aa95f1d67c4fd307$export$536af8185edb7363(itemNameTemplate);
        const templateValueItem = {};
        for (const itemNameKey of itemNameKeys){
            const key = itemNameKey.replace(/\`/g, "");
            const typeStructureItem = $aa95f1d67c4fd307$export$403cdf01662f5b4b([
                key
            ], typeStructure, typeStructureMap);
            templateValueItem[key] = $aa95f1d67c4fd307$export$7cffee0f9aed39d0(value?.[key], typeStructureItem, typeStructureMap);
        }
        return $aa95f1d67c4fd307$export$31330438f6059b08(templateValueItem, itemNameTemplate);
    } else return value === undefined || value === null ? "" : `${value}`;
};




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $572982b12c8ed9c3$var$CHAR_LIST_STRING = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
const $572982b12c8ed9c3$export$beabf239890c0a71 = (length = 128)=>{
    let result = "";
    for(let i = length; i > 0; --i){
        const firstRandom = Math.random();
        const secondRandom = Math.random();
        const targetRandom = Math.random() > 0.5 ? firstRandom : secondRandom;
        result += $572982b12c8ed9c3$var$CHAR_LIST_STRING[Math.floor(targetRandom * $572982b12c8ed9c3$var$CHAR_LIST_STRING.length)];
    }
    return result;
};
const $572982b12c8ed9c3$export$95bc18c5d933ea05 = (numberOfSegments = 8, delimiter = "-", segmentLength = 4)=>new Array(numberOfSegments).fill(0).map(()=>$572982b12c8ed9c3$export$beabf239890c0a71(segmentLength)).join(delimiter);
const $572982b12c8ed9c3$export$36ec425867d538d7 = ()=>$572982b12c8ed9c3$export$95bc18c5d933ea05(32, "-", 4);


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


var $f8dbcd8598db1f0b$var$f = ("undefined" != typeof $cfae44f0dfdf62c0$exports && void 0 !== $cfae44f0dfdf62c0$exports.env && undefined, "data-styled"), $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "6.0.0-rc.5", $f8dbcd8598db1f0b$var$y = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$v = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.env, "undefined" != typeof $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.env, false)), $f8dbcd8598db1f0b$var$g = {}, $f8dbcd8598db1f0b$var$S = /invalid hook call/i, $f8dbcd8598db1f0b$var$w = new Set, $f8dbcd8598db1f0b$var$b = function(t, n) {
    var o, s, i, a, e;
}, $f8dbcd8598db1f0b$var$E = Object.freeze([]), $f8dbcd8598db1f0b$var$N = Object.freeze({});
function $f8dbcd8598db1f0b$var$P(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$N), e.theme !== n.theme && e.theme || t || n.theme;
}
var $f8dbcd8598db1f0b$var$_ = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $f8dbcd8598db1f0b$var$C = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$I = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$A(e) {
    return e.replace($f8dbcd8598db1f0b$var$C, "-").replace($f8dbcd8598db1f0b$var$I, "");
}
var $f8dbcd8598db1f0b$var$O = /(a)(d)/gi, $f8dbcd8598db1f0b$var$D = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$R(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$D(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$D(t % 52) + n).replace($f8dbcd8598db1f0b$var$O, "$1-$2");
}
var $f8dbcd8598db1f0b$var$T, $f8dbcd8598db1f0b$var$k = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$j = function(e) {
    return $f8dbcd8598db1f0b$var$k(5381, e);
};
function $f8dbcd8598db1f0b$var$x(e) {
    return $f8dbcd8598db1f0b$var$R($f8dbcd8598db1f0b$var$j(e) >>> 0);
}
function $f8dbcd8598db1f0b$var$V(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f8dbcd8598db1f0b$var$M(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$F = "function" == typeof Symbol && Symbol.for, $f8dbcd8598db1f0b$var$$ = $f8dbcd8598db1f0b$var$F ? Symbol.for("react.memo") : 60115, $f8dbcd8598db1f0b$var$z = $f8dbcd8598db1f0b$var$F ? Symbol.for("react.forward_ref") : 60112, $f8dbcd8598db1f0b$var$B = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$L = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f8dbcd8598db1f0b$var$G = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$Y = (($f8dbcd8598db1f0b$var$T = {})[$f8dbcd8598db1f0b$var$z] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $f8dbcd8598db1f0b$var$T[$f8dbcd8598db1f0b$var$$] = $f8dbcd8598db1f0b$var$G, $f8dbcd8598db1f0b$var$T);
function $f8dbcd8598db1f0b$var$W(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f8dbcd8598db1f0b$var$$ ? $f8dbcd8598db1f0b$var$G : "$$typeof" in e ? $f8dbcd8598db1f0b$var$Y[e.$$typeof] : $f8dbcd8598db1f0b$var$B;
}
var $f8dbcd8598db1f0b$var$q = Object.defineProperty, $f8dbcd8598db1f0b$var$H = Object.getOwnPropertyNames, $f8dbcd8598db1f0b$var$U = Object.getOwnPropertySymbols, $f8dbcd8598db1f0b$var$J = Object.getOwnPropertyDescriptor, $f8dbcd8598db1f0b$var$X = Object.getPrototypeOf, $f8dbcd8598db1f0b$var$Z = Object.prototype;
function $f8dbcd8598db1f0b$var$K(e, t, n) {
    if ("string" != typeof t) {
        if ($f8dbcd8598db1f0b$var$Z) {
            var o = $f8dbcd8598db1f0b$var$X(t);
            o && o !== $f8dbcd8598db1f0b$var$Z && $f8dbcd8598db1f0b$var$K(e, o, n);
        }
        var r = $f8dbcd8598db1f0b$var$H(t);
        $f8dbcd8598db1f0b$var$U && (r = r.concat($f8dbcd8598db1f0b$var$U(t)));
        for(var s = $f8dbcd8598db1f0b$var$W(e), i = $f8dbcd8598db1f0b$var$W(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $f8dbcd8598db1f0b$var$L || n && n[c] || i && c in i || s && c in s)) {
                var l = $f8dbcd8598db1f0b$var$J(t, c);
                try {
                    $f8dbcd8598db1f0b$var$q(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f8dbcd8598db1f0b$var$Q(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $f8dbcd8598db1f0b$var$te(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $f8dbcd8598db1f0b$var$ne(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $f8dbcd8598db1f0b$var$oe(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f8dbcd8598db1f0b$var$re(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$f8dbcd8598db1f0b$var$oe(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $f8dbcd8598db1f0b$var$re(e[o], t[o]);
    else if ($f8dbcd8598db1f0b$var$oe(t)) for(var o in t)e[o] = $f8dbcd8598db1f0b$var$re(e[o], t[o]);
    return e;
}
function $f8dbcd8598db1f0b$var$se(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $f8dbcd8598db1f0b$var$ie = {};
function $f8dbcd8598db1f0b$var$ae() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $f8dbcd8598db1f0b$var$ce(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $f8dbcd8598db1f0b$var$le = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $f8dbcd8598db1f0b$var$ce(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat("/*!sc*/\n");
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$ue = new Map, $f8dbcd8598db1f0b$var$pe = new Map, $f8dbcd8598db1f0b$var$de = 1, $f8dbcd8598db1f0b$var$he = function(e) {
    if ($f8dbcd8598db1f0b$var$ue.has(e)) return $f8dbcd8598db1f0b$var$ue.get(e);
    for(; $f8dbcd8598db1f0b$var$pe.has($f8dbcd8598db1f0b$var$de);)$f8dbcd8598db1f0b$var$de++;
    var t = $f8dbcd8598db1f0b$var$de++;
    return $f8dbcd8598db1f0b$var$ue.set(e, t), $f8dbcd8598db1f0b$var$pe.set(t, e), t;
}, $f8dbcd8598db1f0b$var$fe = function(e, t) {
    $f8dbcd8598db1f0b$var$ue.set(e, t), $f8dbcd8598db1f0b$var$pe.set(t, e);
}, $f8dbcd8598db1f0b$var$me = "style[".concat($f8dbcd8598db1f0b$var$f, "][").concat("data-styled-version", '="').concat("6.0.0-rc.5", '"]'), $f8dbcd8598db1f0b$var$ye = new RegExp("^".concat($f8dbcd8598db1f0b$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $f8dbcd8598db1f0b$var$ve = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $f8dbcd8598db1f0b$var$ge = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split("/*!sc*/\n"), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($f8dbcd8598db1f0b$var$ye);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($f8dbcd8598db1f0b$var$fe(u, l), $f8dbcd8598db1f0b$var$ve(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $f8dbcd8598db1f0b$var$Se() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $f8dbcd8598db1f0b$var$we = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var o = t[n];
            if (o && 1 === o.nodeType && o.hasAttribute($f8dbcd8598db1f0b$var$f)) return o;
        }
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($f8dbcd8598db1f0b$var$f, "active"), o.setAttribute("data-styled-version", "6.0.0-rc.5");
    var i = $f8dbcd8598db1f0b$var$Se();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $f8dbcd8598db1f0b$var$be = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$we(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $f8dbcd8598db1f0b$var$ce(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Ee = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$we(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Ne = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Pe = $f8dbcd8598db1f0b$var$y, $f8dbcd8598db1f0b$var$_e = {
    isServer: !$f8dbcd8598db1f0b$var$y,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$v
}, $f8dbcd8598db1f0b$var$Ce = function() {
    function e(e, n, o) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$N), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $f8dbcd8598db1f0b$var$_e), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$y && $f8dbcd8598db1f0b$var$Pe && ($f8dbcd8598db1f0b$var$Pe = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$me), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && "active" !== r.getAttribute($f8dbcd8598db1f0b$var$f) && ($f8dbcd8598db1f0b$var$ge(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $f8dbcd8598db1f0b$var$se(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $f8dbcd8598db1f0b$var$pe.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($f8dbcd8598db1f0b$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat("/*!sc*/\n");
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$he(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $f8dbcd8598db1f0b$var$Ne(n) : t ? new $f8dbcd8598db1f0b$var$be(n) : new $f8dbcd8598db1f0b$var$Ee(n);
        }(this.options), new $f8dbcd8598db1f0b$var$le(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$he(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$he(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$he(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $f8dbcd8598db1f0b$var$Ie = /&/g, $f8dbcd8598db1f0b$var$Ae = /^\s*\/\/.*$/gm;
function $f8dbcd8598db1f0b$var$Oe(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $f8dbcd8598db1f0b$var$Oe(e.children, t)), e;
    });
}
function $f8dbcd8598db1f0b$var$De(e) {
    var t, n, o, r = void 0 === e ? $f8dbcd8598db1f0b$var$N : e, s = r.options, i = void 0 === s ? $f8dbcd8598db1f0b$var$N : s, a = r.plugins, c = void 0 === a ? $f8dbcd8598db1f0b$var$E : a, l = function(e, o, r) {
        return r === n || r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $298fb931ed4fbf8b$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($f8dbcd8598db1f0b$var$Ie, n).replace(o, l));
    }), i.prefix && u.push($298fb931ed4fbf8b$export$e08c7d021b829b7a), u.push($298fb931ed4fbf8b$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($f8dbcd8598db1f0b$var$Ae, ""), l = $298fb931ed4fbf8b$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $f8dbcd8598db1f0b$var$Oe(l, i.namespace));
        var p = [];
        return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(l, $298fb931ed4fbf8b$export$5a7767152ae0305f(u.concat($298fb931ed4fbf8b$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$ce(15), $f8dbcd8598db1f0b$var$k(e, t.name);
    }, 5381).toString() : "", p;
}
var $f8dbcd8598db1f0b$var$Re = new $f8dbcd8598db1f0b$var$Ce, $f8dbcd8598db1f0b$var$Te = $f8dbcd8598db1f0b$var$De(), $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f8dbcd8598db1f0b$var$Re,
    stylis: $f8dbcd8598db1f0b$var$Te
}), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$xe = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0);
function $f8dbcd8598db1f0b$var$Ve() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86);
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $f8dbcd8598db1f0b$var$Ve().styleSheet, l = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$De({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    return (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$xe.Provider, {
        value: u
    }, e.children));
}
var $f8dbcd8598db1f0b$var$Fe = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$Te);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $f8dbcd8598db1f0b$var$se(this, function() {
            throw $f8dbcd8598db1f0b$var$ce(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$Te), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$$e = function(e) {
    return e >= "A" && e <= "Z";
};
function $f8dbcd8598db1f0b$var$ze(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $f8dbcd8598db1f0b$var$$e(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $f8dbcd8598db1f0b$var$Be = function(e) {
    return null == e || !1 === e || "" === e;
}, $f8dbcd8598db1f0b$var$Le = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$f8dbcd8598db1f0b$var$Be(i) && (Array.isArray(i) && i.isCss || $f8dbcd8598db1f0b$var$Q(i) ? r.push("".concat($f8dbcd8598db1f0b$var$ze(s), ":"), i, ";") : $f8dbcd8598db1f0b$var$oe(i) ? r.push.apply(r, (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $f8dbcd8598db1f0b$var$Le(i), !1), [
            "}"
        ], !1)) : r.push("".concat($f8dbcd8598db1f0b$var$ze(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $936be3b045ab836e$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $f8dbcd8598db1f0b$var$Ge(e, t, n, o) {
    if ($f8dbcd8598db1f0b$var$Be(e)) return [];
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($f8dbcd8598db1f0b$var$Q(e)) {
        if (!$f8dbcd8598db1f0b$var$Q(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $f8dbcd8598db1f0b$var$Ge(r, t, n, o);
    }
    var s;
    return e instanceof $f8dbcd8598db1f0b$var$Fe ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $f8dbcd8598db1f0b$var$oe(e) ? $f8dbcd8598db1f0b$var$Le(e) : Array.isArray(e) ? e.flatMap(function(e) {
        return $f8dbcd8598db1f0b$var$Ge(e, t, n, o);
    }) : [
        e.toString()
    ];
}
function $f8dbcd8598db1f0b$var$Ye(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$Q(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$We = $f8dbcd8598db1f0b$var$j("6.0.0-rc.5"), $f8dbcd8598db1f0b$var$qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$Ye(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$k($f8dbcd8598db1f0b$var$We, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$Ce.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $f8dbcd8598db1f0b$var$te(o, this.staticRulesId);
            else {
                var r = $f8dbcd8598db1f0b$var$ne($f8dbcd8598db1f0b$var$Ge(this.rules, e, t, n)), s = $f8dbcd8598db1f0b$var$R($f8dbcd8598db1f0b$var$k(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $f8dbcd8598db1f0b$var$te(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $f8dbcd8598db1f0b$var$k(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $f8dbcd8598db1f0b$var$ne($f8dbcd8598db1f0b$var$Ge(u, e, t, n));
                    a = $f8dbcd8598db1f0b$var$k(a, p), c += p;
                }
            }
            if (c) {
                var d = $f8dbcd8598db1f0b$var$R(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $f8dbcd8598db1f0b$var$te(o, d);
            }
        }
        return o;
    }, e;
}(), $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$93d4e7f90805808f() {
    var e = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
    if (!e) throw $f8dbcd8598db1f0b$var$ce(18);
    return e;
}
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, $acw62.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $f8dbcd8598db1f0b$var$ce(14);
            if ($f8dbcd8598db1f0b$var$Q(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f8dbcd8598db1f0b$var$ce(8);
            return n ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$Ze = {}, $f8dbcd8598db1f0b$var$Ke = new Set;
function $f8dbcd8598db1f0b$var$Qe(e, r, s) {
    var i = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), a = e, c = !$f8dbcd8598db1f0b$var$M(e), p = r.attrs, d = void 0 === p ? $f8dbcd8598db1f0b$var$E : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$A(e);
        $f8dbcd8598db1f0b$var$Ze[n] = ($f8dbcd8598db1f0b$var$Ze[n] || 0) + 1;
        var o = "".concat(n, "-").concat($f8dbcd8598db1f0b$var$x("6.0.0-rc.5" + n + $f8dbcd8598db1f0b$var$Ze[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $f8dbcd8598db1f0b$var$M(e) ? "styled.".concat(e) : "Styled(".concat($f8dbcd8598db1f0b$var$V(e), ")");
    }(e) : m, v = r.displayName && r.componentId ? "".concat($f8dbcd8598db1f0b$var$A(r.displayName), "-").concat(r.componentId) : r.componentId || f, g = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, S = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var w = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var C = r.shouldForwardProp;
            S = function(e, t) {
                return w(e, t) && C(e, t);
            };
        } else S = w;
    }
    var I = new $f8dbcd8598db1f0b$var$qe(s, v, i ? a.componentStyle : void 0), O = I.isStatic && 0 === d.length;
    function D(e, r) {
        return function(e, r, s, i) {
            var a = e.attrs, c = e.componentStyle, p = e.defaultProps, d = e.foldedComponentIds, h = e.styledComponentId, f = e.target, m = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), y = $f8dbcd8598db1f0b$var$Ve(), v = e.shouldForwardProp || y.shouldForwardProp;
            var g = function(e, n, o) {
                for(var r, s = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $f8dbcd8598db1f0b$var$Q(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $f8dbcd8598db1f0b$var$te(s[c], a[c]) : "style" === c ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $f8dbcd8598db1f0b$var$te(s.className, n.className)), s;
            }(a, r, $f8dbcd8598db1f0b$var$P(r, m, p) || $f8dbcd8598db1f0b$var$N), S = g.as || f, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b || ("forwardedAs" === b ? w.as = g.forwardedAs : v && !v(b, S) || (w[b] = g[b]));
            var E = function(e, t, n) {
                var o = $f8dbcd8598db1f0b$var$Ve(), r = e.generateAndInjectStyles(t ? $f8dbcd8598db1f0b$var$N : n, o.styleSheet, o.stylis);
                return r;
            }(c, i, g);
            var C = $f8dbcd8598db1f0b$var$te(d, h);
            return E && (C += " " + E), g.className && (C += " " + g.className), w[$f8dbcd8598db1f0b$var$M(S) && !$f8dbcd8598db1f0b$var$_.has(S) ? "class" : "className"] = C, w.ref = s, (0, $acw62.createElement)(S, w);
        }(R, e, r, O);
    }
    D.displayName = y;
    var R = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(D);
    return R.attrs = g, R.componentStyle = I, R.displayName = y, R.shouldForwardProp = S, R.foldedComponentIds = i ? $f8dbcd8598db1f0b$var$te(a.foldedComponentIds, a.styledComponentId) : "", R.styledComponentId = v, R.target = i ? a.target : e, Object.defineProperty(R, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$f8dbcd8598db1f0b$var$re(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $f8dbcd8598db1f0b$var$se(R, function() {
        return ".".concat(R.styledComponentId);
    }), c && $f8dbcd8598db1f0b$var$K(R, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), R;
}
function $f8dbcd8598db1f0b$var$et(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $f8dbcd8598db1f0b$var$tt = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($f8dbcd8598db1f0b$var$Q(t) || $f8dbcd8598db1f0b$var$oe(t)) {
        var r = t;
        return $f8dbcd8598db1f0b$var$tt($f8dbcd8598db1f0b$var$Ge($f8dbcd8598db1f0b$var$et($f8dbcd8598db1f0b$var$E, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            r
        ], n, !0))));
    }
    var s = t;
    return 0 === n.length && 1 === s.length && "string" == typeof s[0] ? $f8dbcd8598db1f0b$var$Ge(s) : $f8dbcd8598db1f0b$var$tt($f8dbcd8598db1f0b$var$Ge($f8dbcd8598db1f0b$var$et(s, n)));
}
function $f8dbcd8598db1f0b$var$ot(n, o, r) {
    if (void 0 === r && (r = $f8dbcd8598db1f0b$var$N), !o) throw $f8dbcd8598db1f0b$var$ce(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $f8dbcd8598db1f0b$var$ot(n, o, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $f8dbcd8598db1f0b$var$ot(n, o, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $f8dbcd8598db1f0b$var$rt = function(e) {
    return $f8dbcd8598db1f0b$var$ot($f8dbcd8598db1f0b$var$Qe, e);
}, $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$rt;
$f8dbcd8598db1f0b$var$_.forEach(function(e) {
    $f8dbcd8598db1f0b$export$2e2bcd8739ae039[e] = $f8dbcd8598db1f0b$var$rt(e);
});
var $f8dbcd8598db1f0b$var$it = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$Ye(e), $f8dbcd8598db1f0b$var$Ce.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($f8dbcd8598db1f0b$var$ne($f8dbcd8598db1f0b$var$Ge(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $f8dbcd8598db1f0b$var$Ce.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($f8dbcd8598db1f0b$var$x(JSON.stringify(i))), c = new $f8dbcd8598db1f0b$var$it(i, a);
    var l = function(e) {
        var t = $f8dbcd8598db1f0b$var$Ve(), n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useInsertionEffect || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect)(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $f8dbcd8598db1f0b$var$g, o, s);
        else {
            var i = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), {
                theme: $f8dbcd8598db1f0b$var$P(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $f8dbcd8598db1f0b$var$ne($f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $f8dbcd8598db1f0b$var$x(r);
    return new $f8dbcd8598db1f0b$var$Fe(s, r);
}
function $f8dbcd8598db1f0b$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(n, r) {
        var s = $f8dbcd8598db1f0b$var$P(n, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($f8dbcd8598db1f0b$var$V(e), ")"), $f8dbcd8598db1f0b$var$K(n, e);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $f8dbcd8598db1f0b$var$Se(), o = $f8dbcd8598db1f0b$var$ne([
                n && 'nonce="'.concat(n, '"'),
                "".concat($f8dbcd8598db1f0b$var$f, '="true"'),
                "".concat("data-styled-version", '="').concat("6.0.0-rc.5", '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $f8dbcd8598db1f0b$var$ce(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $f8dbcd8598db1f0b$var$ce(2);
            var r = ((n = {})[$f8dbcd8598db1f0b$var$f] = "", n["data-styled-version"] = "6.0.0-rc.5", n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $f8dbcd8598db1f0b$var$Se();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$Ce({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $f8dbcd8598db1f0b$var$ce(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $f8dbcd8598db1f0b$var$ce(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$Ce,
    mainSheet: $f8dbcd8598db1f0b$var$Re
};
var $f8dbcd8598db1f0b$var$dt = "__sc-".concat($f8dbcd8598db1f0b$var$f, "__");


const $73826083bc6dcf82$export$72f43f2fd75acb44 = {
    string: "text",
    number: "number",
    boolean: "checkbox",
    Date: "date",
    Time: "time",
    DateTime: "datetime-local",
    LongText: "textarea",
    Rating: "number",
    Color: "color",
    TelephoneNumber: "tel",
    EmailAddress: "email",
    File: "file",
    Hidden: "hidden",
    Image: "image",
    Month: "month",
    Password: "password",
    Radio: "radio",
    Range: "range",
    Search: "search",
    URL: "url",
    Week: "week",
    any: "text"
};


const $4b0b09b944c77e8f$var$getInputTypeForTypeStructureType = (type)=>(0, $73826083bc6dcf82$export$72f43f2fd75acb44)[type] || "text";
const $4b0b09b944c77e8f$var$InputBase = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).input`
  &[type='date']:before {
    content: attr(placeholder) !important;
    color: var(--form-element-placeholder-color);
    margin-right: 0.5em;
  }

  &[type='date']:focus:before,
  &[type='date']:valid:before {
    content: '';
  }
`;
const $4b0b09b944c77e8f$var$RatingBase = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).fieldset`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1em;
  padding: 1em;
  border: 0.05em solid var(--form-element-border-color);
  box-sizing: border-box;
`;
const $4b0b09b944c77e8f$var$RatingStarContainer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).label`
  &:before {
    content: '★';
    color: var(--pico-form-element-color);
    cursor: pointer;
  }

  &:has(input:checked) {
    &:before {
      color: var(--pico-primary);
    }
  }
`;
const $4b0b09b944c77e8f$var$RatingStar = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).input`
  display: none;
`;
const $4b0b09b944c77e8f$export$f5b8910cec6cf069 = ({ name: name , label: label = "" , type: type = "string" , value: value , onChange: onChange , options: options , allowCustomValue: allowCustomValue , readonly: readonly = false  })=>{
    const convertedType = $4b0b09b944c77e8f$var$getInputTypeForTypeStructureType(type);
    const inputUUID = (0, $acw62.useMemo)(()=>(0, $572982b12c8ed9c3$export$36ec425867d538d7)(), []);
    const optionsList = (0, $acw62.useMemo)(()=>{
        if (Array.isArray(options)) return options;
        else {
            const { content: content = []  } = options || {};
            return content.map(({ type: type  })=>type.replace(/['"]/gim, ()=>""));
        }
    }, [
        options
    ]);
    const onChangeInternal = (0, $acw62.useCallback)((event)=>{
        if (onChange) {
            const { target: target  } = event;
            const { checked: checked , value: inputValue  } = target;
            const newValue = convertedType === (0, $73826083bc6dcf82$export$72f43f2fd75acb44).boolean ? checked ?? false : convertedType === (0, $73826083bc6dcf82$export$72f43f2fd75acb44).Rating ? parseInt(inputValue, 10) : inputValue;
            onChange(name, newValue);
        }
    }, [
        name,
        convertedType,
        value,
        onChange
    ]);
    const cleanValue = (0, $acw62.useMemo)(()=>convertedType === (0, $73826083bc6dcf82$export$72f43f2fd75acb44).boolean ? value ?? false : value ?? "", [
        convertedType,
        value
    ]);
    const styleObj = (0, $acw62.useMemo)(()=>({
            gridArea: name
        }), [
        name
    ]);
    return type === "Rating" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($4b0b09b944c77e8f$var$RatingBase, {
        disabled: readonly,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$RatingStarContainer, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$RatingStar, {
                    type: "radio",
                    readOnly: true,
                    value: 1,
                    checked: cleanValue >= 1,
                    onClick: onChangeInternal
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$RatingStarContainer, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$RatingStar, {
                    type: "radio",
                    readOnly: true,
                    value: 2,
                    checked: cleanValue >= 2,
                    onClick: onChangeInternal
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$RatingStarContainer, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$RatingStar, {
                    type: "radio",
                    readOnly: true,
                    value: 3,
                    checked: cleanValue >= 3,
                    onClick: onChangeInternal
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$RatingStarContainer, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$RatingStar, {
                    type: "radio",
                    readOnly: true,
                    value: 4,
                    checked: cleanValue >= 4,
                    onClick: onChangeInternal
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$RatingStarContainer, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$RatingStar, {
                    type: "radio",
                    readOnly: true,
                    value: 5,
                    checked: cleanValue >= 5,
                    onClick: onChangeInternal
                })
            })
        ]
    }) : convertedType === (0, $73826083bc6dcf82$export$72f43f2fd75acb44).boolean ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$InputBase, {
        readOnly: readonly,
        placeholder: label,
        type: convertedType,
        checked: !!cleanValue,
        onChange: onChangeInternal,
        style: styleObj
    }) : convertedType === (0, $73826083bc6dcf82$export$72f43f2fd75acb44).LongText ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
        readOnly: readonly,
        placeholder: label,
        value: cleanValue,
        onChange: onChangeInternal,
        style: styleObj,
        rows: 5
    }) : options && !allowCustomValue ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
        disabled: readonly,
        value: cleanValue,
        onChange: onChangeInternal,
        style: styleObj,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                value: "",
                children: label
            }),
            optionsList.map((o, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                    value: o,
                    children: o
                }, index))
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4b0b09b944c77e8f$var$InputBase, {
                readOnly: readonly,
                placeholder: label,
                type: convertedType,
                value: `${cleanValue}`,
                onChange: onChangeInternal,
                style: styleObj,
                list: options && allowCustomValue ? inputUUID : undefined
            }),
            options && allowCustomValue ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("datalist", {
                id: inputUUID,
                children: optionsList.map((o, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: o
                    }, index))
            }) : undefined
        ]
    });
};




var $acw62 = parcelRequire("acw62");
const $c6f0e45c48b1cc19$export$a7fed597f4b8afd8 = ({ onSubmit: onSubmit , children: children , ...otherProps })=>{
    const onSubmitInternal = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        onSubmit();
    }, [
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
        ...otherProps,
        onSubmit: onSubmitInternal,
        children: children
    });
};


const $64157720666c1bd7$var$INVALID = {};
class $64157720666c1bd7$export$2e2bcd8739ae039 {
    static #_ = (()=>{
        this.DEFAULT_NAME = "HashMatrix";
    })();
    static #_1 = (()=>{
        this.DEFAULT_PATH_DELIMITER = ".";
    })();
    static keyIsNumeric(key) {
        let numeric = false;
        try {
            numeric = Number.isInteger(parseInt(`${key}`, 10));
        } catch (error) {
        // Ignore.
        }
        return numeric;
    }
    constructor(config = {}){
        this._changeHandlerMap = {};
        this._errorHandlerMap = {};
        Object.assign(this, config);
        if (typeof this.pathDelimiter !== "string") this.pathDelimiter = $64157720666c1bd7$export$2e2bcd8739ae039.DEFAULT_PATH_DELIMITER;
        this._setDefaultName();
    }
    _setDefaultName() {
        if (!this.hasOwnProperty("name")) {
            if (typeof this.constructor.DEFAULT_NAME === "string") this.name = this.constructor.DEFAULT_NAME;
            else this.name = $64157720666c1bd7$export$2e2bcd8739ae039.DEFAULT_NAME;
        }
    }
    getChangeHandlerList(path) {
        const pathString = this.getPathString(path);
        return this._changeHandlerMap[pathString] || [];
    }
    setChangeHandlerList(path, handlerList = []) {
        const pathString = this.getPathString(path);
        this._changeHandlerMap[pathString] = handlerList;
    }
    addChangeHandler(path = "", handler) {
        if (this.hashMatrix instanceof $64157720666c1bd7$export$2e2bcd8739ae039) return this.hashMatrix.addChangeHandler(this.getPathArray(path, this.targetPath), handler);
        if (!!handler) {
            const handlerList = this.getChangeHandlerList(path);
            if (handlerList.indexOf(handler) === -1) {
                handlerList.push(handler);
                this.setChangeHandlerList(path, handlerList);
                return ()=>this.removeChangeHandler(path, handler);
            }
        }
    }
    removeChangeHandler(path = "", handler) {
        if (this.hashMatrix instanceof $64157720666c1bd7$export$2e2bcd8739ae039) return this.hashMatrix.removeChangeHandler(this.getPathArray(path, this.targetPath), handler);
        const handlerList = this.getChangeHandlerList(path);
        if (handlerList.indexOf(handler) !== -1) {
            const newHandlerList = [];
            handlerList.forEach((h)=>{
                if (h !== handler) newHandlerList.push(h);
            });
            this.setChangeHandlerList(path, newHandlerList);
        }
    }
    onChange(path, causePath) {
        const handlerList = this.getChangeHandlerList(path);
        handlerList.forEach((h)=>h(path, causePath, this));
    }
    getErrorHandlerList(path) {
        const pathString = this.getPathString(path);
        return this._errorHandlerMap[pathString] || [];
    }
    setErrorHandlerList(path, handlerList = []) {
        const pathString = this.getPathString(path);
        this._errorHandlerMap[pathString] = handlerList;
    }
    addErrorHandler(path = "", handler) {
        if (this.hashMatrix instanceof $64157720666c1bd7$export$2e2bcd8739ae039) return this.hashMatrix.addErrorHandler(this.getPathArray(path, this.targetPath), handler);
        if (!!handler) {
            const handlerList = this.getErrorHandlerList(path);
            if (handlerList.indexOf(handler) === -1) {
                handlerList.push(handler);
                this.setErrorHandlerList(path, handlerList);
                return ()=>this.removeErrorHandler(path, handler);
            }
        }
    }
    removeErrorHandler(path = "", handler) {
        if (this.hashMatrix instanceof $64157720666c1bd7$export$2e2bcd8739ae039) return this.hashMatrix.removeErrorHandler(this.getPathArray(path, this.targetPath), handler);
        const handlerList = this.getErrorHandlerList(path);
        if (handlerList.indexOf(handler) !== -1) {
            const newHandlerList = [];
            handlerList.forEach((h)=>{
                if (h !== handler) newHandlerList.push(h);
            });
            this.setErrorHandlerList(path, newHandlerList);
        }
    }
    onError(error, path, causePath) {
        const handlerList = this.getErrorHandlerList(path);
        handlerList.forEach((h)=>h(error, path, causePath, this));
    }
    getBasePathArray(path = "") {
        return path instanceof Array ? [
            ...path
        ] : path === "" ? [] : `${path}`.split(this.pathDelimiter);
    }
    getPathArray(path = "", prefixPath = "") {
        const prefixPathArray = this.getBasePathArray(prefixPath);
        const pathArray = this.getBasePathArray(path);
        return [
            ...prefixPathArray,
            ...pathArray
        ];
    }
    getPathString(path, prefixPath) {
        return this.getPathArray(path, prefixPath).join(this.pathDelimiter);
    }
    dispatchChanges(path) {
        const pathArray = this.getPathArray(path);
        const pathString = this.getPathString(pathArray);
        // Notify lifecycle listeners of changes all the way up the path.
        if (pathArray.length) {
            const currentPath = [
                ...pathArray
            ];
            // TRICKY: Start with the deepest path and move up to the most shallow.
            while(currentPath.length){
                this.onChange(// Path as a string.
                this.getPathString(currentPath), // The cause path.
                pathString);
                currentPath.pop();
            }
        }
        this.onChange("", pathString);
    }
    dispatchErrors(error, path) {
        const pathArray = this.getPathArray(path);
        const pathString = this.getPathString(pathArray);
        // Notify lifecycle listeners of errors all the way up the path.
        if (pathArray.length) {
            const currentPath = [
                ...pathArray
            ];
            // TRICKY: Start with the deepest path and move up to the most shallow.
            while(currentPath.length){
                this.onError(// The error.
                error, // Path as a string.
                this.getPathString(currentPath), // The cause path.
                pathString);
                currentPath.pop();
            }
        }
        this.onError(error, "", pathString);
    }
    _setErrorInternal(path, error) {
        if (this.hashMatrix instanceof $64157720666c1bd7$export$2e2bcd8739ae039) return this.hashMatrix.setError(this.getPathArray(path, this.targetPath), error);
        this.dispatchErrors(error, path);
    }
    setError(path, error) {
        return this._setErrorInternal(path, error);
    }
    _getPathInternal(path) {
        if (this.hashMatrix instanceof $64157720666c1bd7$export$2e2bcd8739ae039) return this.hashMatrix.getPath(this.getPathArray(path, this.targetPath));
        const pathArray = this.getPathArray(path);
        if (pathArray.length) {
            let value, currentValue = this.hashMatrix, finished = true;
            for (const part of pathArray)// Don't fail, just return `undefined`.
            try {
                currentValue = currentValue?.[part];
            } catch (error) {
                finished = false;
                break;
            }
            // TRICKY: Don't select the current value if the full path wasn't processed.
            if (finished) value = currentValue;
            return value;
        } else return this.hashMatrix;
    }
    getPath(path) {
        return this._getPathInternal(path);
    }
    _setPathInternal(path, value) {
        if (this.hashMatrix instanceof $64157720666c1bd7$export$2e2bcd8739ae039) return this.hashMatrix.setPath(this.getPathArray(path, this.targetPath), value);
        const targetValue = value === $64157720666c1bd7$var$INVALID ? undefined : value;
        const pathArray = this.getPathArray(path);
        // TRICKY: DO NOT set if the value is exactly equal.
        if (targetValue !== this._getPathInternal(path)) {
            const newHashMatrix = {
                ...this.hashMatrix
            };
            if (pathArray.length) {
                const lastIndex = pathArray.length - 1;
                const lastPart = pathArray[lastIndex];
                let currentValue = newHashMatrix;
                for(let i = 0; i < lastIndex; i++){
                    const part = pathArray[i];
                    const nextPart = pathArray[i + 1];
                    // TRICKY: Build out the tree is it's not there.
                    if (typeof currentValue[part] === "undefined") currentValue[part] = $64157720666c1bd7$export$2e2bcd8739ae039.keyIsNumeric(nextPart) ? [] : {};
                    else if (currentValue[part] instanceof Array) currentValue[part] = [
                        ...currentValue[part]
                    ];
                    else if (currentValue[part] instanceof Object) currentValue[part] = {
                        ...currentValue[part]
                    };
                    currentValue = currentValue[part];
                }
                currentValue[lastPart] = targetValue;
                this.hashMatrix = newHashMatrix;
            } else this.hashMatrix = targetValue;
            this.dispatchChanges(pathArray);
        } else if (value === $64157720666c1bd7$var$INVALID) this.dispatchChanges(pathArray);
    }
    setPath(path, value) {
        return this._setPathInternal(path, value);
    }
    invalidatePath(path) {
        this.setPath(path, $64157720666c1bd7$var$INVALID);
    }
    getValue() {
        return this.getPath([]);
    }
    setValue(value) {
        return this.setPath([], value);
    }
    invalidate() {
        if (!this.preventInvalidation) {
            if (typeof this.debounceInvalidationMS === "number") {
                clearTimeout(this._invalidationDebounceTimeout);
                this._invalidationDebounceTimeout = setTimeout(()=>this.setValue($64157720666c1bd7$var$INVALID), this.debounceInvalidationMS);
            } else this.setValue($64157720666c1bd7$var$INVALID);
        }
    }
}



const $2181bc1b7740891a$export$d6e35ac3ed815924 = "FORM_CONTROLS_GRID_AREA";
const $2181bc1b7740891a$export$4a9e4644e90a0bb0 = (typeStructureLayout = "", topLevel = false)=>{
    const hasTemplate = typeof typeStructureLayout === "string" && !!typeStructureLayout.replace(/\s/g, ()=>"");
    if (hasTemplate) {
        const gridTemplateRows = typeStructureLayout.split("\n").map((l)=>l.trim()).filter((l)=>!!l);
        const maxColCount = gridTemplateRows.reduce((acc, row)=>{
            const colCount = row.split(" ").length;
            return Math.max(acc, colCount);
        }, 1);
        const rowsWithControls = topLevel ? [
            ...gridTemplateRows,
            $2181bc1b7740891a$export$d6e35ac3ed815924
        ] : gridTemplateRows;
        const filledGridTemplateRows = rowsWithControls.map((row)=>{
            const existingCols = row.split(" ");
            const colCount = existingCols.length;
            const ratio = maxColCount / colCount;
            return existingCols.reduce((acc, c, ind)=>{
                const intRatio = ind === existingCols.length - 1 ? Math.ceil(ratio) : Math.floor(ratio);
                const newCols = new Array(intRatio).fill(c);
                return [
                    ...acc,
                    ...newCols
                ];
            }, []).join(" ");
        });
        return filledGridTemplateRows.map((l)=>`"${l}"`).join("\n");
    } else return "";
};
const $2181bc1b7740891a$export$2cea2601f1396e57 = (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
`;
const $2181bc1b7740891a$export$4ff332f0f2806aa5 = (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)`
  @media screen and (max-width: 768px) {
    ${$2181bc1b7740891a$export$2cea2601f1396e57}
  }
`;
const $2181bc1b7740891a$export$15a4841ae7952a16 = ({ $isGrid: $isGrid = false , $gridTemplate: $gridTemplate , $gridArea: $gridArea  })=>(0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)`
  grid-area: ${$gridArea ? $gridArea : "auto"};
  display: ${$isGrid ? "grid" : "flex"};
  grid-template: ${$gridTemplate ? $gridTemplate : "auto"};
  gap: 1em;
  overflow: auto;

  ${!$gridTemplate ? $2181bc1b7740891a$export$2cea2601f1396e57 : ""}

  ${$2181bc1b7740891a$export$4ff332f0f2806aa5}
`;
const $2181bc1b7740891a$export$e49e2e6e9a949828 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  ${(p)=>$2181bc1b7740891a$export$15a4841ae7952a16(p)}
`;
const $2181bc1b7740891a$export$6da8b80e4d06de7d = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: center;
  gap: 1em;

  ${$2181bc1b7740891a$export$4ff332f0f2806aa5}
`;




const $93f29f71a052aecf$var$LayoutForm = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $c6f0e45c48b1cc19$export$a7fed597f4b8afd8))`
  ${(p)=>(0, $2181bc1b7740891a$export$15a4841ae7952a16)(p)}
`;
const $93f29f71a052aecf$var$OpenFormButtonBase = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  ${(p)=>p.$gridArea ? (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)`
          grid-area: ${p.$gridArea};
        ` : ""}
`;
const $93f29f71a052aecf$var$OpenFormButton = ({ disabled: disabled = false , name: name , label: label , onOpenForm: onOpenForm  })=>{
    const onOpenFormInternal = (0, $acw62.useCallback)(()=>{
        onOpenForm(name);
    }, [
        name,
        onOpenForm
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($93f29f71a052aecf$var$OpenFormButtonBase, {
        disabled: disabled,
        type: "button",
        $gridArea: name,
        onClick: onOpenFormInternal,
        children: [
            "Edit ",
            label
        ]
    });
};
const $93f29f71a052aecf$export$cd65c7053f9e5e98 = ({ typeStructureMap: typeStructureMap , typeStructure: typeStructure , value: value , onChange: onChange , onNavigateToPath: onNavigateToPath , onNavigateBack: onNavigateBack , navigationPathPrefix: navigationPathPrefix = [] , topLevel: topLevel = false , isEntryPoint: isEntryPoint = false  })=>{
    const baseTypeStructure = (0, $acw62.useMemo)(()=>{
        const { type: typeStructureType = ""  } = typeStructure;
        const topLevelTypeStructure = (0, $aa95f1d67c4fd307$export$983a349dad361514)(typeStructureType, typeStructureMap);
        return {
            ...topLevelTypeStructure,
            ...typeStructure
        };
    }, [
        typeStructureMap,
        typeStructure
    ]);
    const isForm = (0, $acw62.useMemo)(()=>{
        const { content: content = []  } = baseTypeStructure;
        return content.length > 0;
    }, [
        baseTypeStructure
    ]);
    const cleanTypeStructure = (0, $acw62.useMemo)(()=>{
        const { contentNames: contentNames  } = baseTypeStructure;
        return (0, $aa95f1d67c4fd307$export$c867550b4c242c9c)(contentNames, baseTypeStructure);
    }, [
        baseTypeStructure
    ]);
    const { name: typeStructureName = "" , type: typeStructureType , content: typeStructureContent = [] , readonly: readonly = false  } = cleanTypeStructure;
    const { [(0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).label]: typeStructureLabel , [(0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).layout]: typeStructureLayout , [(0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).options]: typeStructureOptionsString , [(0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).optionsType]: typeStructureOptionsTypeName , [(0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).allowCustomValue]: typeStructureAllowCustomValue  } = (0, $acw62.useMemo)(()=>(0, $aa95f1d67c4fd307$export$1ec8a1e99ee8bb25)([
            (0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).label,
            (0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).inline,
            (0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).layout,
            (0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).options,
            (0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).optionsType,
            (0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).allowCustomValue
        ], cleanTypeStructure), [
        cleanTypeStructure
    ]);
    const typeStructureOptions = (0, $acw62.useMemo)(()=>{
        if (typeof typeStructureOptionsString === "string") return typeStructureOptionsString.split("\n").map((l)=>l.split(","))// @ts-ignore
        .flat().map((l)=>l.trim());
        else return typeStructureOptionsTypeName && typeof typeStructureOptionsTypeName === "string" ? (0, $aa95f1d67c4fd307$export$983a349dad361514)(typeStructureOptionsTypeName, typeStructureMap) : undefined;
    }, [
        typeStructureOptionsString,
        typeStructureOptionsTypeName,
        typeStructureMap
    ]);
    const hasTypeStructureLayout = (0, $acw62.useMemo)(()=>typeof typeStructureLayout === "string", [
        typeStructureLayout
    ]);
    const [internalValueBase, setInternalValue] = (0, $acw62.useState)(value);
    const valueLastChanged = (0, $acw62.useMemo)(()=>new Date().getTime(), [
        value
    ]);
    const internalValueLastChanged = (0, $acw62.useMemo)(()=>new Date().getTime(), [
        internalValueBase
    ]);
    const internalValue = (0, $acw62.useMemo)(()=>valueLastChanged > internalValueLastChanged ? value : internalValueBase, [
        value,
        internalValueBase,
        valueLastChanged,
        internalValueLastChanged
    ]);
    const hasChanges = (0, $acw62.useMemo)(()=>internalValue !== value, [
        internalValue,
        value
    ]);
    const submissionTypeName = (0, $acw62.useMemo)(()=>{
        return topLevel ? "" : typeStructureName;
    }, [
        topLevel,
        typeStructureName
    ]);
    const onFormSubmit = (0, $acw62.useCallback)(()=>{
        onChange(submissionTypeName, internalValue);
        if (onNavigateBack) onNavigateBack();
    }, [
        topLevel,
        submissionTypeName,
        internalValue,
        onNavigateBack
    ]);
    const onResetForm = (0, $acw62.useCallback)(()=>{
        setInternalValue(value);
    }, [
        value
    ]);
    const onCancelForm = (0, $acw62.useCallback)(()=>{
        if (onNavigateBack) onNavigateBack();
    }, [
        onNavigateBack
    ]);
    const onPrimitiveChangeInternal = (0, $acw62.useCallback)((_n, v)=>{
        setInternalValue(v);
    }, [
        setInternalValue
    ]);
    const onPropertyChange = (0, $acw62.useCallback)((n, v)=>{
        const newValue = {
            ...internalValue,
            [n]: v
        };
        setInternalValue(newValue);
        if (!topLevel || isEntryPoint) onChange(submissionTypeName, newValue);
    }, [
        internalValue,
        setInternalValue,
        topLevel,
        isEntryPoint,
        onChange,
        submissionTypeName
    ]);
    const onNavigateToPathInternal = (0, $acw62.useCallback)((path = [])=>{
        if (onNavigateToPath) {
            const targetValue = new (0, $64157720666c1bd7$export$2e2bcd8739ae039)({
                hashMatrix: internalValue
            }).getPath(path);
            const targetTypeStructure = (0, $aa95f1d67c4fd307$export$403cdf01662f5b4b)(path, cleanTypeStructure, typeStructureMap);
            const { multiple: ttsMultiple  } = targetTypeStructure;
            const targetLabel = (0, $aa95f1d67c4fd307$export$137bf301edaceb2e)((0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).label, targetTypeStructure);
            const cleanTargetLabel = typeof targetLabel === "string" ? targetLabel : "";
            onNavigateToPath({
                label: ttsMultiple ? cleanTargetLabel : (0, $aa95f1d67c4fd307$export$7cffee0f9aed39d0)(targetValue, targetTypeStructure, typeStructureMap),
                path: [
                    ...navigationPathPrefix,
                    ...path
                ]
            });
        }
    }, [
        onNavigateToPath,
        navigationPathPrefix,
        internalValue,
        cleanTypeStructure,
        typeStructureMap
    ]);
    const onOpenForm = (0, $acw62.useCallback)((name)=>{
        onNavigateToPathInternal([
            name
        ]);
    }, [
        onNavigateToPathInternal
    ]);
    const FormComp = topLevel ? $93f29f71a052aecf$var$LayoutForm : (0, $2181bc1b7740891a$export$e49e2e6e9a949828);
    const formProps = (0, $acw62.useMemo)(()=>{
        return {
            ...topLevel ? {
                onSubmit: onFormSubmit
            } : {},
            $gridArea: !topLevel ? typeStructureName : undefined
        };
    }, [
        topLevel,
        onFormSubmit,
        topLevel,
        typeStructureName
    ]);
    const layoutBoxProps = (0, $acw62.useMemo)(()=>{
        return {
            $isGrid: hasTypeStructureLayout,
            $gridTemplate: (0, $2181bc1b7740891a$export$4a9e4644e90a0bb0)(typeStructureLayout, topLevel)
        };
    }, [
        hasTypeStructureLayout,
        typeStructureLayout,
        topLevel
    ]);
    const controls = (0, $acw62.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                topLevel && !isEntryPoint && hasChanges ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2181bc1b7740891a$export$6da8b80e4d06de7d), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            style: {
                                flex: "1 0 auto",
                                width: "auto"
                            },
                            type: "button",
                            onClick: onCancelForm,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            style: {
                                flex: "1 0 auto",
                                width: "auto"
                            },
                            type: "button",
                            onClick: onResetForm,
                            children: "Reset"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            style: {
                                flex: "1 0 auto",
                                width: "auto"
                            },
                            type: "submit",
                            children: "Submit"
                        })
                    ]
                }) : undefined,
                topLevel && !isEntryPoint && !hasChanges ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2181bc1b7740891a$export$6da8b80e4d06de7d), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        style: {
                            flex: "1 0 auto",
                            width: "auto"
                        },
                        type: "button",
                        onClick: onCancelForm,
                        children: "Done"
                    })
                }) : undefined
            ]
        });
    }, [
        topLevel,
        isEntryPoint,
        hasChanges,
        onCancelForm,
        onResetForm,
        onFormSubmit
    ]);
    if (isForm) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(FormComp, {
        ...formProps,
        $allowShrink: topLevel,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2181bc1b7740891a$export$e49e2e6e9a949828), {
                $allowShrink: topLevel,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2181bc1b7740891a$export$e49e2e6e9a949828), {
                    ...layoutBoxProps,
                    $allowShrink: false,
                    children: typeStructureContent.map((tS)=>{
                        const { name: tSName , literal: tSLiteral = false , type: tSType , multiple: tSMultiple  } = tS;
                        const { [(0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).inline]: tSInline , [(0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).label]: tSLabel  } = (0, $aa95f1d67c4fd307$export$1ec8a1e99ee8bb25)([
                            (0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).inline,
                            (0, $aa95f1d67c4fd307$export$34848ee8632b1f2f).label
                        ], tS);
                        const inputLabel = typeof tSLabel === "string" ? tSLabel : tSName;
                        const tSTypeIsTypeStructure = typeof tSType === "string" && !!typeStructureMap[tSType];
                        const useInputType = !tSTypeIsTypeStructure;
                        const isHelperType = tSType in (0, $73826083bc6dcf82$export$72f43f2fd75acb44);
                        if (!tSMultiple && (isHelperType || tSLiteral || tSInline || useInputType)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($93f29f71a052aecf$export$cd65c7053f9e5e98, {
                            typeStructureMap: typeStructureMap,
                            typeStructure: tS,
                            value: internalValue?.[tSName],
                            onChange: onPropertyChange,
                            onNavigateToPath: onNavigateToPath,
                            navigationPathPrefix: [
                                tSName
                            ]
                        }, tSName);
                        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($93f29f71a052aecf$var$OpenFormButton, {
                            disabled: hasChanges,
                            name: tSName,
                            label: inputLabel,
                            onOpenForm: onOpenForm
                        }, tSName);
                    })
                })
            }),
            controls
        ]
    });
    else {
        const inputComp = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b0b09b944c77e8f$export$f5b8910cec6cf069), {
            name: typeStructureName,
            label: `${typeStructureLabel ?? ""}`,
            value: topLevel ? internalValue : value,
            type: typeStructureType,
            onChange: topLevel ? onPrimitiveChangeInternal : onChange,
            options: typeStructureOptions,
            allowCustomValue: !!typeStructureAllowCustomValue,
            readonly: readonly
        }, typeStructureName);
        return topLevel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($93f29f71a052aecf$var$LayoutForm, {
            $allowShrink: false,
            onSubmit: onFormSubmit,
            children: [
                inputComp,
                controls
            ]
        }) : inputComp;
    }
};





var $acw62 = parcelRequire("acw62");



const $7a74bd04959f1591$var$ITEM_PLACEHOLDER = {};
const $7a74bd04959f1591$var$DeleteButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  background-color: #a41e1e;
`;
const $7a74bd04959f1591$var$SelectItemButtonBase = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  flex: 0 0 auto;
  width: revert;
`;
const $7a74bd04959f1591$var$SelectItemButton = ({ index: index , onSelectItem: onSelectItem , children: children  })=>{
    const onOpenItemInternal = (0, $acw62.useCallback)(()=>{
        onSelectItem(index);
    }, [
        index,
        onSelectItem
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7a74bd04959f1591$var$SelectItemButtonBase, {
        onClick: onOpenItemInternal,
        children: children
    });
};
const $7a74bd04959f1591$var$SelectItemCheckbox = ({ index: index , onSelectItem: onSelectItem , selected: selected = false  })=>{
    const onOpenItemInternal = (0, $acw62.useCallback)(()=>{
        onSelectItem(index);
    }, [
        index,
        onSelectItem
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
            type: "checkbox",
            checked: selected,
            onChange: onOpenItemInternal
        })
    });
};
const $7a74bd04959f1591$var$ItemBase = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: center;
  gap: 1em;
  max-width: 100%;
`;
const $7a74bd04959f1591$var$ItemLabelBase = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 1 1 auto;
  gap: 1em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 3em;
  padding: 1em 0;
  box-sizing: border-box;
`;
const $7a74bd04959f1591$export$54c2e3dc7acea9f5 = ({ typeStructure: typeStructure , typeStructureMap: typeStructureMap , items: items = [] , onChange: onChange , onNavigateToPath: onNavigateToPath , onNavigateBack: onNavigateBack  })=>{
    const [selectedIndices, setSelectedIndices] = (0, $acw62.useState)([]);
    const [tryingToDeleteSelectedItems, setTryingToDeleteSelectedItems] = (0, $acw62.useState)(false);
    const onBegineDelete = (0, $acw62.useCallback)(()=>{
        setTryingToDeleteSelectedItems(true);
    }, [
        setTryingToDeleteSelectedItems
    ]);
    const [itemsAreMoving, setItemsAreMoving] = (0, $acw62.useState)(false);
    const getItemLabel = (0, $acw62.useCallback)((item, index)=>((0, $aa95f1d67c4fd307$export$7cffee0f9aed39d0)(item, typeStructure, typeStructureMap) || "").trim() || `${index + 1}`, [
        typeStructure,
        typeStructureMap,
        items
    ]);
    const onChangeInternal = (0, $acw62.useCallback)((value)=>{
        if (onChange) onChange(value);
    }, [
        onChange
    ]);
    const onCancelDelete = (0, $acw62.useCallback)(()=>{
        setTryingToDeleteSelectedItems(false);
    }, [
        setTryingToDeleteSelectedItems
    ]);
    const onConfirmDelete = (0, $acw62.useCallback)(()=>{
        const newItems = items.filter((_, index)=>!selectedIndices.includes(index));
        onChangeInternal(newItems);
        setTryingToDeleteSelectedItems(false);
        setSelectedIndices([]);
    }, [
        items,
        onChangeInternal,
        selectedIndices,
        setTryingToDeleteSelectedItems,
        setSelectedIndices
    ]);
    const onAddItem = (0, $acw62.useCallback)(()=>{
        onChangeInternal([
            ...items,
            (0, $aa95f1d67c4fd307$export$ba72d4a6880d3748)(typeStructure)
        ]);
    }, [
        items,
        onChangeInternal,
        typeStructure
    ]);
    const onOpenItem = (0, $acw62.useCallback)((index)=>{
        if (onNavigateToPath) {
            const item = items?.[index];
            onNavigateToPath({
                label: getItemLabel(item, index),
                path: [
                    index
                ],
                isListItem: true
            });
        }
    }, [
        onNavigateToPath,
        items,
        getItemLabel
    ]);
    const onToggleItemSelected = (0, $acw62.useCallback)((index)=>{
        if (selectedIndices.includes(index)) setSelectedIndices(selectedIndices.filter((ind)=>ind !== index));
        else setSelectedIndices([
            ...selectedIndices,
            index
        ]);
    }, [
        selectedIndices,
        setSelectedIndices
    ]);
    const onSetItemsAreMoving = (0, $acw62.useCallback)(()=>{
        setItemsAreMoving(true);
    }, [
        setItemsAreMoving
    ]);
    const onCleanupMovingItems = (0, $acw62.useCallback)(()=>{
        setItemsAreMoving(false);
        setSelectedIndices([]);
    }, [
        setItemsAreMoving,
        setSelectedIndices
    ]);
    const onMoveItems = (0, $acw62.useCallback)((moveItemsToIndex)=>{
        const newItems = [
            ...items,
            $7a74bd04959f1591$var$ITEM_PLACEHOLDER
        ].reduce((acc, itm, ind)=>{
            if (selectedIndices.includes(ind)) return [
                ...acc,
                $7a74bd04959f1591$var$ITEM_PLACEHOLDER
            ];
            if (ind === moveItemsToIndex) return [
                ...acc,
                ...selectedIndices.map((i)=>items[i]),
                itm
            ];
            return [
                ...acc,
                itm
            ];
        }, []).filter((i)=>i !== $7a74bd04959f1591$var$ITEM_PLACEHOLDER);
        onChangeInternal(newItems);
        onCleanupMovingItems();
    }, [
        items,
        onChangeInternal,
        onCleanupMovingItems,
        selectedIndices
    ]);
    const onSelectAllItems = (0, $acw62.useCallback)(()=>{
        setSelectedIndices(items.map((_, index)=>index));
    }, [
        items,
        setSelectedIndices
    ]);
    const onDeselectAllItems = (0, $acw62.useCallback)(()=>{
        setSelectedIndices([]);
    }, [
        setSelectedIndices
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2181bc1b7740891a$export$e49e2e6e9a949828), {
        $allowShrink: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2181bc1b7740891a$export$e49e2e6e9a949828), {
                $allowShrink: true,
                children: items.map((item, index)=>{
                    return itemsAreMoving && selectedIndices.includes(index) ? undefined : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($7a74bd04959f1591$var$ItemBase, {
                        children: [
                            itemsAreMoving ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7a74bd04959f1591$var$SelectItemButton, {
                                index: index,
                                onSelectItem: onMoveItems,
                                children: "Move Here"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7a74bd04959f1591$var$SelectItemCheckbox, {
                                index: index,
                                onSelectItem: onToggleItemSelected,
                                selected: selectedIndices.includes(index)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7a74bd04959f1591$var$ItemLabelBase, {
                                children: getItemLabel(item, index)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7a74bd04959f1591$var$SelectItemButton, {
                                index: index,
                                onSelectItem: onOpenItem,
                                children: "Open"
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2181bc1b7740891a$export$6da8b80e4d06de7d), {
                children: [
                    selectedIndices.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: itemsAreMoving ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7a74bd04959f1591$var$SelectItemButton, {
                                    index: items.length,
                                    onSelectItem: onMoveItems,
                                    children: "Move Here"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: onCleanupMovingItems,
                                    children: "Cancel"
                                })
                            ]
                        }) : tryingToDeleteSelectedItems ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: onCancelDelete,
                                    children: "Cancel Delete"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7a74bd04959f1591$var$DeleteButton, {
                                    onClick: onConfirmDelete,
                                    children: "Confirm Delete"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: onDeselectAllItems,
                                    children: "Deselect All"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: onSetItemsAreMoving,
                                    children: "Move Item(s)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: onBegineDelete,
                                    children: "Delete Item(s)"
                                })
                            ]
                        })
                    }) : undefined,
                    itemsAreMoving ? undefined : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            selectedIndices.length < items.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: onSelectAllItems,
                                children: "Select All"
                            }) : undefined,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: onAddItem,
                                children: "+ Add Item"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: onNavigateBack,
                                children: "Done"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");

const $35d1461156b98374$export$d0f8f2aad94d6297 = (path)=>{
    const store = {
        create: (key, value)=>{
            localStorage.setItem(`${path}/${key}`, JSON.stringify(value));
        },
        read: (key)=>{
            const value = localStorage.getItem(`${path}/${key}`);
            try {
                return value ? JSON.parse(value) : undefined;
            } catch (_error) {
                return undefined;
            }
        },
        update: (key, value)=>store.create(key, value),
        delete: (key)=>{
            localStorage.removeItem(`${path}/${key}`);
        },
        list: ()=>{
            const keys = Object.keys(localStorage);
            return keys.map((key)=>{
                if (key.indexOf(`${path}/`) === 0) return store.read(key.replace(`${path}/`, ""));
            }).filter((v)=>typeof v !== "undefined");
        }
    };
    return store;
};


const $a2129c33b064c6db$var$TRAIL_PREFIX = "Trail";
const $a2129c33b064c6db$var$MAIN_TRAIL = "Default";
const $a2129c33b064c6db$var$TRAIL_SERVICE = (0, $35d1461156b98374$export$d0f8f2aad94d6297)($a2129c33b064c6db$var$TRAIL_PREFIX);
const $a2129c33b064c6db$var$DEFAULT_TRAIL = $a2129c33b064c6db$var$TRAIL_SERVICE.read($a2129c33b064c6db$var$MAIN_TRAIL) || [];
const $a2129c33b064c6db$export$971646e43cc4a11b = (breadcrumb, trail = [])=>[
        ...trail,
        breadcrumb
    ];
const $a2129c33b064c6db$export$bb13fa5e1be62892 = (trail = [])=>{
    const [_lastBreadCrumb, ...newTrail] = [
        ...trail
    ].reverse();
    return newTrail.reverse();
};
const $a2129c33b064c6db$export$a19d6a7f6f62378f = (trail = [])=>{
    return trail.map(({ path: path  })=>path)// @ts-ignore
    .flat();
};
const $a2129c33b064c6db$export$d0fd4b7106de2769 = (storeTrail = false)=>{
    const [trail, setTrail] = (0, $acw62.useState)(storeTrail ? $a2129c33b064c6db$var$DEFAULT_TRAIL : []);
    const path = (0, $acw62.useMemo)(()=>$a2129c33b064c6db$export$a19d6a7f6f62378f(trail), [
        trail
    ]);
    const onNavigateTo = (0, $acw62.useCallback)((breadcrumb)=>setTrail($a2129c33b064c6db$export$971646e43cc4a11b(breadcrumb, trail)), [
        trail,
        setTrail
    ]);
    const onNavigateBack = (0, $acw62.useCallback)(()=>setTrail($a2129c33b064c6db$export$bb13fa5e1be62892(trail)), [
        trail,
        setTrail
    ]);
    const navigation = (0, $acw62.useMemo)(()=>({
            trail: trail,
            path: path,
            onNavigateTo: onNavigateTo,
            onNavigateBack: onNavigateBack,
            onSetTrail: setTrail
        }), [
        trail,
        path,
        onNavigateTo,
        onNavigateBack
    ]);
    (0, $acw62.useEffect)(()=>{
        if (storeTrail) $a2129c33b064c6db$var$TRAIL_SERVICE.update($a2129c33b064c6db$var$MAIN_TRAIL, trail);
    }, [
        trail,
        storeTrail
    ]);
    return navigation;
};
const $a2129c33b064c6db$var$BreadcrumbBox = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1em;
  overflow: auto;
  width: 100%;
`;
const $a2129c33b064c6db$var$BreadcrumbButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  flex: 1 0 auto;
  text-wrap: none;
  width: auto;
`;
const $a2129c33b064c6db$export$3e54f91f86754209 = ({ trail: trail , onChange: onChange  })=>{
    const listRef = (0, $acw62.useRef)(null);
    const onGoToBreadcrumb = (0, $acw62.useCallback)((event)=>{
        const { target: { value: value  }  } = event;
        const index = parseInt(value, 10);
        const newTrail = [
            ...trail
        ].slice(0, index + 1);
        onChange(newTrail);
    }, [
        trail,
        onChange
    ]);
    (0, $acw62.useEffect)(()=>{
        listRef.current?.lastElementChild?.scrollIntoView();
    }, [
        trail
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a2129c33b064c6db$var$BreadcrumbBox, {
        ref: listRef,
        children: [
            trail.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2129c33b064c6db$var$BreadcrumbButton, {
                type: "button",
                value: -1,
                onClick: onGoToBreadcrumb,
                children: "Home"
            }) : undefined,
            trail.map((bc, index)=>{
                const { label: label  } = bc;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2129c33b064c6db$var$BreadcrumbButton, {
                    disabled: index === trail.length - 1,
                    type: "button",
                    value: index,
                    onClick: onGoToBreadcrumb,
                    children: label
                }, index);
            })
        ]
    });
};



const $39f15f48eca4c2f0$var$ApplicationBase = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 1em;
  overflow: hidden;
`;
const $39f15f48eca4c2f0$var$HeaderBase = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: center;
  gap: 1em;
`;
const $39f15f48eca4c2f0$export$16975c34e60e1e61 = ({ typeStructureMap: typeStructureMap , value: value , entryType: entryType , onChange: onChange , keepNavigationHistory: keepNavigationHistory = false  })=>{
    const typeStructure = (0, $acw62.useMemo)(()=>typeStructureMap[entryType], [
        typeStructureMap,
        entryType
    ]);
    const { trail: trail , path: path , onNavigateTo: onNavigateTo , onNavigateBack: onNavigateBack , onSetTrail: onSetTrail  } = (0, $a2129c33b064c6db$export$d0fd4b7106de2769)(keepNavigationHistory);
    const hashMatrix = (0, $acw62.useMemo)(()=>new (0, $64157720666c1bd7$export$2e2bcd8739ae039)({
            hashMatrix: value
        }), [
        value
    ]);
    const currentValue = (0, $acw62.useMemo)(()=>hashMatrix.getPath(path.map((p)=>`${p}`)), [
        hashMatrix,
        path
    ]);
    const currentTypeStructure = (0, $acw62.useMemo)(()=>(0, $aa95f1d67c4fd307$export$403cdf01662f5b4b)(path, typeStructure, typeStructureMap), [
        path,
        typeStructure,
        typeStructureMap
    ]);
    const tStructIsPrimitive = (0, $acw62.useMemo)(()=>(0, $aa95f1d67c4fd307$export$a03274fdd2ce9db0)(currentTypeStructure), [
        currentTypeStructure
    ]);
    const { multiple: currentTypeIsMultiple = false  } = currentTypeStructure;
    const currentValueIsItemInList = (0, $acw62.useMemo)(()=>{
        const { isListItem: isListItem = false  } = trail[trail.length - 1] || {};
        return isListItem;
    }, [
        trail
    ]);
    const onChangeInternal = (0, $acw62.useCallback)((name, value)=>{
        const stringNav = path.map((p)=>`${p}`);
        const targetPath = !!name && !tStructIsPrimitive ? [
            ...stringNav,
            name
        ] : stringNav;
        hashMatrix.setPath(targetPath, value);
        onChange(hashMatrix.getValue());
    }, [
        hashMatrix,
        path,
        onChange,
        tStructIsPrimitive
    ]);
    const onListChange = (0, $acw62.useCallback)((value)=>{
        hashMatrix.setPath(path.map((p)=>`${p}`), value);
        onChange(hashMatrix.getValue());
    }, [
        hashMatrix,
        path,
        onChange
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($39f15f48eca4c2f0$var$ApplicationBase, {
        children: [
            trail.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39f15f48eca4c2f0$var$HeaderBase, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2129c33b064c6db$export$3e54f91f86754209), {
                    trail: trail,
                    onChange: onSetTrail
                })
            }) : undefined,
            currentTypeIsMultiple && !currentValueIsItemInList ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a74bd04959f1591$export$54c2e3dc7acea9f5), {
                typeStructure: currentTypeStructure,
                typeStructureMap: typeStructureMap,
                items: currentValue,
                onChange: onListChange,
                onNavigateToPath: onNavigateTo,
                onNavigateBack: onNavigateBack
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93f29f71a052aecf$export$cd65c7053f9e5e98), {
                typeStructureMap: typeStructureMap,
                typeStructure: currentTypeStructure,
                value: currentValue,
                onChange: onChangeInternal,
                onNavigateToPath: onNavigateTo,
                onNavigateBack: onNavigateBack,
                topLevel: true,
                isEntryPoint: trail.length === 0
            })
        ]
    });
};



var $9f7fbaa73a3474ff$exports = {};

$9f7fbaa73a3474ff$exports = new URL((parcelRequire("27Lyk")).resolve("kTq5e"), import.meta.url).toString();


var $10339b5de87e77e2$exports = {};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ 
var $10339b5de87e77e2$var$__filename = "node_modules/typescript/lib/typescript.js";
var $10339b5de87e77e2$var$__dirname = "node_modules/typescript/lib";
"use strict";









var $10339b5de87e77e2$var$ts = (()=>{
    var __defProp = Object.defineProperty;
    var __getOwnPropNames = Object.getOwnPropertyNames;
    var __esm = (fn, res)=>function __init() {
            return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
        };
    var __commonJS = (cb, mod)=>function __require() {
            return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
                exports: {}
            }).exports, mod), mod.exports;
        };
    var __export = (target, all)=>{
        for(var name in all)__defProp(target, name, {
            get: all[name],
            enumerable: true
        });
    };
    // src/compiler/corePublic.ts
    var versionMajorMinor, version, Comparison;
    var init_corePublic = __esm({
        "src/compiler/corePublic.ts" () {
            "use strict";
            versionMajorMinor = "5.1";
            version = "5.1.3";
            Comparison = /* @__PURE__ */ ((Comparison3)=>{
                Comparison3[Comparison3["LessThan"] = -1] = "LessThan";
                Comparison3[Comparison3["EqualTo"] = 0] = "EqualTo";
                Comparison3[Comparison3["GreaterThan"] = 1] = "GreaterThan";
                return Comparison3;
            })(Comparison || {});
        }
    });
    // src/compiler/core.ts
    function length(array) {
        return array ? array.length : 0;
    }
    function forEach(array, callback) {
        if (array) for(let i = 0; i < array.length; i++){
            const result = callback(array[i], i);
            if (result) return result;
        }
        return void 0;
    }
    function forEachRight(array, callback) {
        if (array) for(let i = array.length - 1; i >= 0; i--){
            const result = callback(array[i], i);
            if (result) return result;
        }
        return void 0;
    }
    function firstDefined(array, callback) {
        if (array === void 0) return void 0;
        for(let i = 0; i < array.length; i++){
            const result = callback(array[i], i);
            if (result !== void 0) return result;
        }
        return void 0;
    }
    function firstDefinedIterator(iter, callback) {
        for (const value1 of iter){
            const result = callback(value1);
            if (result !== void 0) return result;
        }
        return void 0;
    }
    function reduceLeftIterator(iterator, f, initial) {
        let result = initial;
        if (iterator) {
            let pos = 0;
            for (const value1 of iterator){
                result = f(result, value1, pos);
                pos++;
            }
        }
        return result;
    }
    function zipWith(arrayA, arrayB, callback) {
        const result = [];
        Debug.assertEqual(arrayA.length, arrayB.length);
        for(let i = 0; i < arrayA.length; i++)result.push(callback(arrayA[i], arrayB[i], i));
        return result;
    }
    function intersperse(input, element) {
        if (input.length <= 1) return input;
        const result = [];
        for(let i = 0, n = input.length; i < n; i++){
            if (i) result.push(element);
            result.push(input[i]);
        }
        return result;
    }
    function every(array, callback) {
        if (array) for(let i = 0; i < array.length; i++){
            if (!callback(array[i], i)) return false;
        }
        return true;
    }
    function find(array, predicate, startIndex) {
        if (array === void 0) return void 0;
        for(let i = startIndex ?? 0; i < array.length; i++){
            const value1 = array[i];
            if (predicate(value1, i)) return value1;
        }
        return void 0;
    }
    function findLast(array, predicate, startIndex) {
        if (array === void 0) return void 0;
        for(let i = startIndex ?? array.length - 1; i >= 0; i--){
            const value1 = array[i];
            if (predicate(value1, i)) return value1;
        }
        return void 0;
    }
    function findIndex(array, predicate, startIndex) {
        if (array === void 0) return -1;
        for(let i = startIndex ?? 0; i < array.length; i++){
            if (predicate(array[i], i)) return i;
        }
        return -1;
    }
    function findLastIndex(array, predicate, startIndex) {
        if (array === void 0) return -1;
        for(let i = startIndex ?? array.length - 1; i >= 0; i--){
            if (predicate(array[i], i)) return i;
        }
        return -1;
    }
    function findMap(array, callback) {
        for(let i = 0; i < array.length; i++){
            const result = callback(array[i], i);
            if (result) return result;
        }
        return Debug.fail();
    }
    function contains(array, value1, equalityComparer = equateValues) {
        if (array) for (const v of array){
            if (equalityComparer(v, value1)) return true;
        }
        return false;
    }
    function arraysEqual(a, b, equalityComparer = equateValues) {
        return a.length === b.length && a.every((x, i)=>equalityComparer(x, b[i]));
    }
    function indexOfAnyCharCode(text, charCodes, start) {
        for(let i = start || 0; i < text.length; i++){
            if (contains(charCodes, text.charCodeAt(i))) return i;
        }
        return -1;
    }
    function countWhere(array, predicate) {
        let count = 0;
        if (array) for(let i = 0; i < array.length; i++){
            const v = array[i];
            if (predicate(v, i)) count++;
        }
        return count;
    }
    function filter(array, f) {
        if (array) {
            const len = array.length;
            let i = 0;
            while(i < len && f(array[i]))i++;
            if (i < len) {
                const result = array.slice(0, i);
                i++;
                while(i < len){
                    const item = array[i];
                    if (f(item)) result.push(item);
                    i++;
                }
                return result;
            }
        }
        return array;
    }
    function filterMutate(array, f) {
        let outIndex = 0;
        for(let i = 0; i < array.length; i++)if (f(array[i], i, array)) {
            array[outIndex] = array[i];
            outIndex++;
        }
        array.length = outIndex;
    }
    function clear(array) {
        array.length = 0;
    }
    function map(array, f) {
        let result;
        if (array) {
            result = [];
            for(let i = 0; i < array.length; i++)result.push(f(array[i], i));
        }
        return result;
    }
    function* mapIterator(iter, mapFn) {
        for (const x of iter)yield mapFn(x);
    }
    function sameMap(array, f) {
        if (array) for(let i = 0; i < array.length; i++){
            const item = array[i];
            const mapped = f(item, i);
            if (item !== mapped) {
                const result = array.slice(0, i);
                result.push(mapped);
                for(i++; i < array.length; i++)result.push(f(array[i], i));
                return result;
            }
        }
        return array;
    }
    function flatten(array) {
        const result = [];
        for (const v of array)if (v) {
            if (isArray(v)) addRange(result, v);
            else result.push(v);
        }
        return result;
    }
    function flatMap(array, mapfn) {
        let result;
        if (array) for(let i = 0; i < array.length; i++){
            const v = mapfn(array[i], i);
            if (v) {
                if (isArray(v)) result = addRange(result, v);
                else result = append(result, v);
            }
        }
        return result || emptyArray;
    }
    function flatMapToMutable(array, mapfn) {
        const result = [];
        if (array) for(let i = 0; i < array.length; i++){
            const v = mapfn(array[i], i);
            if (v) {
                if (isArray(v)) addRange(result, v);
                else result.push(v);
            }
        }
        return result;
    }
    function* flatMapIterator(iter, mapfn) {
        for (const x of iter){
            const iter2 = mapfn(x);
            if (!iter2) continue;
            yield* iter2;
        }
    }
    function sameFlatMap(array, mapfn) {
        let result;
        if (array) for(let i = 0; i < array.length; i++){
            const item = array[i];
            const mapped = mapfn(item, i);
            if (result || item !== mapped || isArray(mapped)) {
                if (!result) result = array.slice(0, i);
                if (isArray(mapped)) addRange(result, mapped);
                else result.push(mapped);
            }
        }
        return result || array;
    }
    function mapAllOrFail(array, mapFn) {
        const result = [];
        for(let i = 0; i < array.length; i++){
            const mapped = mapFn(array[i], i);
            if (mapped === void 0) return void 0;
            result.push(mapped);
        }
        return result;
    }
    function mapDefined(array, mapFn) {
        const result = [];
        if (array) for(let i = 0; i < array.length; i++){
            const mapped = mapFn(array[i], i);
            if (mapped !== void 0) result.push(mapped);
        }
        return result;
    }
    function* mapDefinedIterator(iter, mapFn) {
        for (const x of iter){
            const value1 = mapFn(x);
            if (value1 !== void 0) yield value1;
        }
    }
    function mapDefinedEntries(map2, f) {
        if (!map2) return void 0;
        const result = /* @__PURE__ */ new Map();
        map2.forEach((value1, key)=>{
            const entry = f(key, value1);
            if (entry !== void 0) {
                const [newKey, newValue] = entry;
                if (newKey !== void 0 && newValue !== void 0) result.set(newKey, newValue);
            }
        });
        return result;
    }
    function getOrUpdate(map2, key, callback) {
        if (map2.has(key)) return map2.get(key);
        const value1 = callback();
        map2.set(key, value1);
        return value1;
    }
    function tryAddToSet(set, value1) {
        if (!set.has(value1)) {
            set.add(value1);
            return true;
        }
        return false;
    }
    function* singleIterator(value1) {
        yield value1;
    }
    function spanMap(array, keyfn, mapfn) {
        let result;
        if (array) {
            result = [];
            const len = array.length;
            let previousKey;
            let key;
            let start = 0;
            let pos = 0;
            while(start < len){
                while(pos < len){
                    const value1 = array[pos];
                    key = keyfn(value1, pos);
                    if (pos === 0) previousKey = key;
                    else if (key !== previousKey) break;
                    pos++;
                }
                if (start < pos) {
                    const v = mapfn(array.slice(start, pos), previousKey, start, pos);
                    if (v) result.push(v);
                    start = pos;
                }
                previousKey = key;
                pos++;
            }
        }
        return result;
    }
    function mapEntries(map2, f) {
        if (!map2) return void 0;
        const result = /* @__PURE__ */ new Map();
        map2.forEach((value1, key)=>{
            const [newKey, newValue] = f(key, value1);
            result.set(newKey, newValue);
        });
        return result;
    }
    function some(array, predicate) {
        if (array) {
            if (predicate) for (const v of array){
                if (predicate(v)) return true;
            }
            else return array.length > 0;
        }
        return false;
    }
    function getRangesWhere(arr, pred, cb) {
        let start;
        for(let i = 0; i < arr.length; i++){
            if (pred(arr[i])) start = start === void 0 ? i : start;
            else if (start !== void 0) {
                cb(start, i);
                start = void 0;
            }
        }
        if (start !== void 0) cb(start, arr.length);
    }
    function concatenate(array1, array2) {
        if (!some(array2)) return array1;
        if (!some(array1)) return array2;
        return [
            ...array1,
            ...array2
        ];
    }
    function selectIndex(_, i) {
        return i;
    }
    function indicesOf(array) {
        return array.map(selectIndex);
    }
    function deduplicateRelational(array, equalityComparer, comparer) {
        const indices = indicesOf(array);
        stableSortIndices(array, indices, comparer);
        let last2 = array[indices[0]];
        const deduplicated = [
            indices[0]
        ];
        for(let i = 1; i < indices.length; i++){
            const index = indices[i];
            const item = array[index];
            if (!equalityComparer(last2, item)) {
                deduplicated.push(index);
                last2 = item;
            }
        }
        deduplicated.sort();
        return deduplicated.map((i)=>array[i]);
    }
    function deduplicateEquality(array, equalityComparer) {
        const result = [];
        for (const item of array)pushIfUnique(result, item, equalityComparer);
        return result;
    }
    function deduplicate(array, equalityComparer, comparer) {
        return array.length === 0 ? [] : array.length === 1 ? array.slice() : comparer ? deduplicateRelational(array, equalityComparer, comparer) : deduplicateEquality(array, equalityComparer);
    }
    function deduplicateSorted(array, comparer) {
        if (array.length === 0) return emptyArray;
        let last2 = array[0];
        const deduplicated = [
            last2
        ];
        for(let i = 1; i < array.length; i++){
            const next = array[i];
            switch(comparer(next, last2)){
                case true:
                case 0 /* EqualTo */ :
                    continue;
                case -1 /* LessThan */ :
                    return Debug.fail("Array is unsorted.");
            }
            deduplicated.push(last2 = next);
        }
        return deduplicated;
    }
    function createSortedArray() {
        return [];
    }
    function insertSorted(array, insert, compare, allowDuplicates) {
        if (array.length === 0) {
            array.push(insert);
            return true;
        }
        const insertIndex = binarySearch(array, insert, identity, compare);
        if (insertIndex < 0) {
            array.splice(~insertIndex, 0, insert);
            return true;
        }
        if (allowDuplicates) {
            array.splice(insertIndex, 0, insert);
            return true;
        }
        return false;
    }
    function sortAndDeduplicate(array, comparer, equalityComparer) {
        return deduplicateSorted(sort(array, comparer), equalityComparer || comparer || compareStringsCaseSensitive);
    }
    function arrayIsSorted(array, comparer) {
        if (array.length < 2) return true;
        for(let i = 1, len = array.length; i < len; i++){
            if (comparer(array[i - 1], array[i]) === 1 /* GreaterThan */ ) return false;
        }
        return true;
    }
    function detectSortCaseSensitivity(array, getString, compareStringsCaseSensitive2, compareStringsCaseInsensitive2) {
        let kind = 3 /* Both */ ;
        if (array.length < 2) return kind;
        let prevElement = getString(array[0]);
        for(let i = 1, len = array.length; i < len && kind !== 0 /* None */ ; i++){
            const element = getString(array[i]);
            if (kind & 1 /* CaseSensitive */  && compareStringsCaseSensitive2(prevElement, element) > 0) kind &= -2 /* CaseSensitive */ ;
            if (kind & 2 /* CaseInsensitive */  && compareStringsCaseInsensitive2(prevElement, element) > 0) kind &= -3 /* CaseInsensitive */ ;
            prevElement = element;
        }
        return kind;
    }
    function arrayIsEqualTo(array1, array2, equalityComparer = equateValues) {
        if (!array1 || !array2) return array1 === array2;
        if (array1.length !== array2.length) return false;
        for(let i = 0; i < array1.length; i++){
            if (!equalityComparer(array1[i], array2[i], i)) return false;
        }
        return true;
    }
    function compact(array) {
        let result;
        if (array) for(let i = 0; i < array.length; i++){
            const v = array[i];
            if (result || !v) {
                if (!result) result = array.slice(0, i);
                if (v) result.push(v);
            }
        }
        return result || array;
    }
    function relativeComplement(arrayA, arrayB, comparer) {
        if (!arrayB || !arrayA || arrayB.length === 0 || arrayA.length === 0) return arrayB;
        const result = [];
        loopB: for(let offsetA = 0, offsetB = 0; offsetB < arrayB.length; offsetB++){
            if (offsetB > 0) Debug.assertGreaterThanOrEqual(comparer(arrayB[offsetB], arrayB[offsetB - 1]), 0 /* EqualTo */ );
            loopA: for(const startA = offsetA; offsetA < arrayA.length; offsetA++){
                if (offsetA > startA) Debug.assertGreaterThanOrEqual(comparer(arrayA[offsetA], arrayA[offsetA - 1]), 0 /* EqualTo */ );
                switch(comparer(arrayB[offsetB], arrayA[offsetA])){
                    case -1 /* LessThan */ :
                        result.push(arrayB[offsetB]);
                        continue loopB;
                    case 0 /* EqualTo */ :
                        continue loopB;
                    case 1 /* GreaterThan */ :
                        continue loopA;
                }
            }
        }
        return result;
    }
    function append(to, value1) {
        if (value1 === void 0) return to;
        if (to === void 0) return [
            value1
        ];
        to.push(value1);
        return to;
    }
    function combine(xs, ys) {
        if (xs === void 0) return ys;
        if (ys === void 0) return xs;
        if (isArray(xs)) return isArray(ys) ? concatenate(xs, ys) : append(xs, ys);
        if (isArray(ys)) return append(ys, xs);
        return [
            xs,
            ys
        ];
    }
    function toOffset(array, offset) {
        return offset < 0 ? array.length + offset : offset;
    }
    function addRange(to, from, start, end) {
        if (from === void 0 || from.length === 0) return to;
        if (to === void 0) return from.slice(start, end);
        start = start === void 0 ? 0 : toOffset(from, start);
        end = end === void 0 ? from.length : toOffset(from, end);
        for(let i = start; i < end && i < from.length; i++)if (from[i] !== void 0) to.push(from[i]);
        return to;
    }
    function pushIfUnique(array, toAdd, equalityComparer) {
        if (contains(array, toAdd, equalityComparer)) return false;
        else {
            array.push(toAdd);
            return true;
        }
    }
    function appendIfUnique(array, toAdd, equalityComparer) {
        if (array) {
            pushIfUnique(array, toAdd, equalityComparer);
            return array;
        } else return [
            toAdd
        ];
    }
    function stableSortIndices(array, indices, comparer) {
        indices.sort((x, y)=>comparer(array[x], array[y]) || compareValues(x, y));
    }
    function sort(array, comparer) {
        return array.length === 0 ? array : array.slice().sort(comparer);
    }
    function* arrayReverseIterator(array) {
        for(let i = array.length - 1; i >= 0; i--)yield array[i];
    }
    function stableSort(array, comparer) {
        const indices = indicesOf(array);
        stableSortIndices(array, indices, comparer);
        return indices.map((i)=>array[i]);
    }
    function rangeEquals(array1, array2, pos, end) {
        while(pos < end){
            if (array1[pos] !== array2[pos]) return false;
            pos++;
        }
        return true;
    }
    function firstOrUndefined(array) {
        return array === void 0 || array.length === 0 ? void 0 : array[0];
    }
    function firstOrUndefinedIterator(iter) {
        if (iter) {
            for (const value1 of iter)return value1;
        }
        return void 0;
    }
    function first(array) {
        Debug.assert(array.length !== 0);
        return array[0];
    }
    function firstIterator(iter) {
        for (const value1 of iter)return value1;
        Debug.fail("iterator is empty");
    }
    function lastOrUndefined(array) {
        return array === void 0 || array.length === 0 ? void 0 : array[array.length - 1];
    }
    function last(array) {
        Debug.assert(array.length !== 0);
        return array[array.length - 1];
    }
    function singleOrUndefined(array) {
        return array && array.length === 1 ? array[0] : void 0;
    }
    function single(array) {
        return Debug.checkDefined(singleOrUndefined(array));
    }
    function singleOrMany(array) {
        return array && array.length === 1 ? array[0] : array;
    }
    function replaceElement(array, index, value1) {
        const result = array.slice(0);
        result[index] = value1;
        return result;
    }
    function binarySearch(array, value1, keySelector, keyComparer, offset) {
        return binarySearchKey(array, keySelector(value1), keySelector, keyComparer, offset);
    }
    function binarySearchKey(array, key, keySelector, keyComparer, offset) {
        if (!some(array)) return -1;
        let low = offset || 0;
        let high = array.length - 1;
        while(low <= high){
            const middle = low + (high - low >> 1);
            const midKey = keySelector(array[middle], middle);
            switch(keyComparer(midKey, key)){
                case -1 /* LessThan */ :
                    low = middle + 1;
                    break;
                case 0 /* EqualTo */ :
                    return middle;
                case 1 /* GreaterThan */ :
                    high = middle - 1;
                    break;
            }
        }
        return ~low;
    }
    function reduceLeft(array, f, initial, start, count) {
        if (array && array.length > 0) {
            const size = array.length;
            if (size > 0) {
                let pos = start === void 0 || start < 0 ? 0 : start;
                const end = count === void 0 || pos + count > size - 1 ? size - 1 : pos + count;
                let result;
                if (arguments.length <= 2) {
                    result = array[pos];
                    pos++;
                } else result = initial;
                while(pos <= end){
                    result = f(result, array[pos], pos);
                    pos++;
                }
                return result;
            }
        }
        return initial;
    }
    function hasProperty(map2, key) {
        return hasOwnProperty.call(map2, key);
    }
    function getProperty(map2, key) {
        return hasOwnProperty.call(map2, key) ? map2[key] : void 0;
    }
    function getOwnKeys(map2) {
        const keys = [];
        for(const key in map2)if (hasOwnProperty.call(map2, key)) keys.push(key);
        return keys;
    }
    function getAllKeys(obj) {
        const result = [];
        do {
            const names = Object.getOwnPropertyNames(obj);
            for (const name of names)pushIfUnique(result, name);
        }while (obj = Object.getPrototypeOf(obj));
        return result;
    }
    function getOwnValues(collection) {
        const values = [];
        for(const key in collection)if (hasOwnProperty.call(collection, key)) values.push(collection[key]);
        return values;
    }
    function arrayOf(count, f) {
        const result = new Array(count);
        for(let i = 0; i < count; i++)result[i] = f(i);
        return result;
    }
    function arrayFrom(iterator, map2) {
        const result = [];
        for (const value1 of iterator)result.push(map2 ? map2(value1) : value1);
        return result;
    }
    function assign(t, ...args) {
        for (const arg of args){
            if (arg === void 0) continue;
            for(const p in arg)if (hasProperty(arg, p)) t[p] = arg[p];
        }
        return t;
    }
    function equalOwnProperties(left, right, equalityComparer = equateValues) {
        if (left === right) return true;
        if (!left || !right) return false;
        for(const key in left)if (hasOwnProperty.call(left, key)) {
            if (!hasOwnProperty.call(right, key)) return false;
            if (!equalityComparer(left[key], right[key])) return false;
        }
        for(const key in right)if (hasOwnProperty.call(right, key)) {
            if (!hasOwnProperty.call(left, key)) return false;
        }
        return true;
    }
    function arrayToMap(array, makeKey, makeValue = identity) {
        const result = /* @__PURE__ */ new Map();
        for (const value1 of array){
            const key = makeKey(value1);
            if (key !== void 0) result.set(key, makeValue(value1));
        }
        return result;
    }
    function arrayToNumericMap(array, makeKey, makeValue = identity) {
        const result = [];
        for (const value1 of array)result[makeKey(value1)] = makeValue(value1);
        return result;
    }
    function arrayToMultiMap(values, makeKey, makeValue = identity) {
        const result = createMultiMap();
        for (const value1 of values)result.add(makeKey(value1), makeValue(value1));
        return result;
    }
    function group(values, getGroupId, resultSelector = identity) {
        return arrayFrom(arrayToMultiMap(values, getGroupId).values(), resultSelector);
    }
    function groupBy(values, keySelector) {
        const result = {};
        if (values) for (const value1 of values){
            const key = `${keySelector(value1)}`;
            const array = result[key] ?? (result[key] = []);
            array.push(value1);
        }
        return result;
    }
    function clone(object) {
        const result = {};
        for(const id in object)if (hasOwnProperty.call(object, id)) result[id] = object[id];
        return result;
    }
    function extend(first2, second) {
        const result = {};
        for(const id in second)if (hasOwnProperty.call(second, id)) result[id] = second[id];
        for(const id in first2)if (hasOwnProperty.call(first2, id)) result[id] = first2[id];
        return result;
    }
    function copyProperties(first2, second) {
        for(const id in second)if (hasOwnProperty.call(second, id)) first2[id] = second[id];
    }
    function maybeBind(obj, fn) {
        return fn ? fn.bind(obj) : void 0;
    }
    function createMultiMap() {
        const map2 = /* @__PURE__ */ new Map();
        map2.add = multiMapAdd;
        map2.remove = multiMapRemove;
        return map2;
    }
    function multiMapAdd(key, value1) {
        let values = this.get(key);
        if (values) values.push(value1);
        else this.set(key, values = [
            value1
        ]);
        return values;
    }
    function multiMapRemove(key, value1) {
        const values = this.get(key);
        if (values) {
            unorderedRemoveItem(values, value1);
            if (!values.length) this.delete(key);
        }
    }
    function createQueue(items) {
        const elements = (items == null ? void 0 : items.slice()) || [];
        let headIndex = 0;
        function isEmpty() {
            return headIndex === elements.length;
        }
        function enqueue(...items2) {
            elements.push(...items2);
        }
        function dequeue() {
            if (isEmpty()) throw new Error("Queue is empty");
            const result = elements[headIndex];
            elements[headIndex] = void 0;
            headIndex++;
            if (headIndex > 100 && headIndex > elements.length >> 1) {
                const newLength = elements.length - headIndex;
                elements.copyWithin(/*target*/ 0, /*start*/ headIndex);
                elements.length = newLength;
                headIndex = 0;
            }
            return result;
        }
        return {
            enqueue: enqueue,
            dequeue: dequeue,
            isEmpty: isEmpty
        };
    }
    function createSet(getHashCode, equals) {
        const multiMap = /* @__PURE__ */ new Map();
        let size = 0;
        function* getElementIterator() {
            for (const value1 of multiMap.values())if (isArray(value1)) yield* value1;
            else yield value1;
        }
        const set = {
            has (element) {
                const hash = getHashCode(element);
                if (!multiMap.has(hash)) return false;
                const candidates = multiMap.get(hash);
                if (!isArray(candidates)) return equals(candidates, element);
                for (const candidate of candidates){
                    if (equals(candidate, element)) return true;
                }
                return false;
            },
            add (element) {
                const hash = getHashCode(element);
                if (multiMap.has(hash)) {
                    const values = multiMap.get(hash);
                    if (isArray(values)) {
                        if (!contains(values, element, equals)) {
                            values.push(element);
                            size++;
                        }
                    } else {
                        const value1 = values;
                        if (!equals(value1, element)) {
                            multiMap.set(hash, [
                                value1,
                                element
                            ]);
                            size++;
                        }
                    }
                } else {
                    multiMap.set(hash, element);
                    size++;
                }
                return this;
            },
            delete (element) {
                const hash = getHashCode(element);
                if (!multiMap.has(hash)) return false;
                const candidates = multiMap.get(hash);
                if (isArray(candidates)) {
                    for(let i = 0; i < candidates.length; i++)if (equals(candidates[i], element)) {
                        if (candidates.length === 1) multiMap.delete(hash);
                        else if (candidates.length === 2) multiMap.set(hash, candidates[1 - i]);
                        else unorderedRemoveItemAt(candidates, i);
                        size--;
                        return true;
                    }
                } else {
                    const candidate = candidates;
                    if (equals(candidate, element)) {
                        multiMap.delete(hash);
                        size--;
                        return true;
                    }
                }
                return false;
            },
            clear () {
                multiMap.clear();
                size = 0;
            },
            get size () {
                return size;
            },
            forEach (action) {
                for (const elements of arrayFrom(multiMap.values())){
                    if (isArray(elements)) for (const element of elements)action(element, element, set);
                    else {
                        const element = elements;
                        action(element, element, set);
                    }
                }
            },
            keys () {
                return getElementIterator();
            },
            values () {
                return getElementIterator();
            },
            *entries () {
                for (const value1 of getElementIterator())yield [
                    value1,
                    value1
                ];
            },
            [Symbol.iterator]: ()=>{
                return getElementIterator();
            },
            [Symbol.toStringTag]: multiMap[Symbol.toStringTag]
        };
        return set;
    }
    function isArray(value1) {
        return Array.isArray(value1);
    }
    function toArray(value1) {
        return isArray(value1) ? value1 : [
            value1
        ];
    }
    function isString(text) {
        return typeof text === "string";
    }
    function isNumber(x) {
        return typeof x === "number";
    }
    function tryCast(value1, test) {
        return value1 !== void 0 && test(value1) ? value1 : void 0;
    }
    function cast(value1, test) {
        if (value1 !== void 0 && test(value1)) return value1;
        return Debug.fail(`Invalid cast. The supplied value ${value1} did not pass the test '${Debug.getFunctionName(test)}'.`);
    }
    function noop(_) {}
    function returnFalse() {
        return false;
    }
    function returnTrue() {
        return true;
    }
    function returnUndefined() {
        return void 0;
    }
    function identity(x) {
        return x;
    }
    function toLowerCase(x) {
        return x.toLowerCase();
    }
    function toFileNameLowerCase(x) {
        return fileNameLowerCaseRegExp.test(x) ? x.replace(fileNameLowerCaseRegExp, toLowerCase) : x;
    }
    function notImplemented() {
        throw new Error("Not implemented");
    }
    function memoize(callback) {
        let value1;
        return ()=>{
            if (callback) {
                value1 = callback();
                callback = void 0;
            }
            return value1;
        };
    }
    function memoizeOne(callback) {
        const map2 = /* @__PURE__ */ new Map();
        return (arg)=>{
            const key = `${typeof arg}:${arg}`;
            let value1 = map2.get(key);
            if (value1 === void 0 && !map2.has(key)) {
                value1 = callback(arg);
                map2.set(key, value1);
            }
            return value1;
        };
    }
    function memoizeWeak(callback) {
        const map2 = /* @__PURE__ */ new WeakMap();
        return (arg)=>{
            let value1 = map2.get(arg);
            if (value1 === void 0 && !map2.has(arg)) {
                value1 = callback(arg);
                map2.set(arg, value1);
            }
            return value1;
        };
    }
    function memoizeCached(callback, cache) {
        return (...args)=>{
            let value1 = cache.get(args);
            if (value1 === void 0 && !cache.has(args)) {
                value1 = callback(...args);
                cache.set(args, value1);
            }
            return value1;
        };
    }
    function compose(a, b, c, d, e) {
        if (!!e) {
            const args = [];
            for(let i = 0; i < arguments.length; i++)args[i] = arguments[i];
            return (t)=>reduceLeft(args, (u, f)=>f(u), t);
        } else if (d) return (t)=>d(c(b(a(t))));
        else if (c) return (t)=>c(b(a(t)));
        else if (b) return (t)=>b(a(t));
        else if (a) return (t)=>a(t);
        else return (t)=>t;
    }
    function equateValues(a, b) {
        return a === b;
    }
    function equateStringsCaseInsensitive(a, b) {
        return a === b || a !== void 0 && b !== void 0 && a.toUpperCase() === b.toUpperCase();
    }
    function equateStringsCaseSensitive(a, b) {
        return equateValues(a, b);
    }
    function compareComparableValues(a, b) {
        return a === b ? 0 /* EqualTo */  : a === void 0 ? -1 /* LessThan */  : b === void 0 ? 1 /* GreaterThan */  : a < b ? -1 /* LessThan */  : 1 /* GreaterThan */ ;
    }
    function compareValues(a, b) {
        return compareComparableValues(a, b);
    }
    function compareTextSpans(a, b) {
        return compareValues(a == null ? void 0 : a.start, b == null ? void 0 : b.start) || compareValues(a == null ? void 0 : a.length, b == null ? void 0 : b.length);
    }
    function min(items, compare) {
        return reduceLeft(items, (x, y)=>compare(x, y) === -1 /* LessThan */  ? x : y);
    }
    function compareStringsCaseInsensitive(a, b) {
        if (a === b) return 0 /* EqualTo */ ;
        if (a === void 0) return -1 /* LessThan */ ;
        if (b === void 0) return 1 /* GreaterThan */ ;
        a = a.toUpperCase();
        b = b.toUpperCase();
        return a < b ? -1 /* LessThan */  : a > b ? 1 /* GreaterThan */  : 0 /* EqualTo */ ;
    }
    function compareStringsCaseInsensitiveEslintCompatible(a, b) {
        if (a === b) return 0 /* EqualTo */ ;
        if (a === void 0) return -1 /* LessThan */ ;
        if (b === void 0) return 1 /* GreaterThan */ ;
        a = a.toLowerCase();
        b = b.toLowerCase();
        return a < b ? -1 /* LessThan */  : a > b ? 1 /* GreaterThan */  : 0 /* EqualTo */ ;
    }
    function compareStringsCaseSensitive(a, b) {
        return compareComparableValues(a, b);
    }
    function getStringComparer(ignoreCase) {
        return ignoreCase ? compareStringsCaseInsensitive : compareStringsCaseSensitive;
    }
    function getUILocale() {
        return uiLocale;
    }
    function setUILocale(value1) {
        if (uiLocale !== value1) {
            uiLocale = value1;
            uiComparerCaseSensitive = void 0;
        }
    }
    function compareStringsCaseSensitiveUI(a, b) {
        const comparer = uiComparerCaseSensitive || (uiComparerCaseSensitive = createUIStringComparer(uiLocale));
        return comparer(a, b);
    }
    function compareProperties(a, b, key, comparer) {
        return a === b ? 0 /* EqualTo */  : a === void 0 ? -1 /* LessThan */  : b === void 0 ? 1 /* GreaterThan */  : comparer(a[key], b[key]);
    }
    function compareBooleans(a, b) {
        return compareValues(a ? 1 : 0, b ? 1 : 0);
    }
    function getSpellingSuggestion(name, candidates, getName) {
        const maximumLengthDifference = Math.max(2, Math.floor(name.length * 0.34));
        let bestDistance = Math.floor(name.length * 0.4) + 1;
        let bestCandidate;
        for (const candidate of candidates){
            const candidateName = getName(candidate);
            if (candidateName !== void 0 && Math.abs(candidateName.length - name.length) <= maximumLengthDifference) {
                if (candidateName === name) continue;
                if (candidateName.length < 3 && candidateName.toLowerCase() !== name.toLowerCase()) continue;
                const distance = levenshteinWithMax(name, candidateName, bestDistance - 0.1);
                if (distance === void 0) continue;
                Debug.assert(distance < bestDistance);
                bestDistance = distance;
                bestCandidate = candidate;
            }
        }
        return bestCandidate;
    }
    function levenshteinWithMax(s1, s2, max) {
        let previous = new Array(s2.length + 1);
        let current = new Array(s2.length + 1);
        const big = max + 0.01;
        for(let i = 0; i <= s2.length; i++)previous[i] = i;
        for(let i = 1; i <= s1.length; i++){
            const c1 = s1.charCodeAt(i - 1);
            const minJ = Math.ceil(i > max ? i - max : 1);
            const maxJ = Math.floor(s2.length > max + i ? max + i : s2.length);
            current[0] = i;
            let colMin = i;
            for(let j = 1; j < minJ; j++)current[j] = big;
            for(let j = minJ; j <= maxJ; j++){
                const substitutionDistance = s1[i - 1].toLowerCase() === s2[j - 1].toLowerCase() ? previous[j - 1] + 0.1 : previous[j - 1] + 2;
                const dist = c1 === s2.charCodeAt(j - 1) ? previous[j - 1] : Math.min(/*delete*/ previous[j] + 1, /*insert*/ current[j - 1] + 1, /*substitute*/ substitutionDistance);
                current[j] = dist;
                colMin = Math.min(colMin, dist);
            }
            for(let j = maxJ + 1; j <= s2.length; j++)current[j] = big;
            if (colMin > max) return void 0;
            const temp = previous;
            previous = current;
            current = temp;
        }
        const res = previous[s2.length];
        return res > max ? void 0 : res;
    }
    function endsWith(str, suffix) {
        const expectedPos = str.length - suffix.length;
        return expectedPos >= 0 && str.indexOf(suffix, expectedPos) === expectedPos;
    }
    function removeSuffix(str, suffix) {
        return endsWith(str, suffix) ? str.slice(0, str.length - suffix.length) : str;
    }
    function tryRemoveSuffix(str, suffix) {
        return endsWith(str, suffix) ? str.slice(0, str.length - suffix.length) : void 0;
    }
    function stringContains(str, substring) {
        return str.indexOf(substring) !== -1;
    }
    function removeMinAndVersionNumbers(fileName) {
        let end = fileName.length;
        for(let pos = end - 1; pos > 0; pos--){
            let ch = fileName.charCodeAt(pos);
            if (ch >= 48 /* _0 */  && ch <= 57 /* _9 */ ) do {
                --pos;
                ch = fileName.charCodeAt(pos);
            }while (pos > 0 && ch >= 48 /* _0 */  && ch <= 57 /* _9 */ );
            else if (pos > 4 && (ch === 110 /* n */  || ch === 78 /* N */ )) {
                --pos;
                ch = fileName.charCodeAt(pos);
                if (ch !== 105 /* i */  && ch !== 73 /* I */ ) break;
                --pos;
                ch = fileName.charCodeAt(pos);
                if (ch !== 109 /* m */  && ch !== 77 /* M */ ) break;
                --pos;
                ch = fileName.charCodeAt(pos);
            } else break;
            if (ch !== 45 /* minus */  && ch !== 46 /* dot */ ) break;
            end = pos;
        }
        return end === fileName.length ? fileName : fileName.slice(0, end);
    }
    function orderedRemoveItem(array, item) {
        for(let i = 0; i < array.length; i++)if (array[i] === item) {
            orderedRemoveItemAt(array, i);
            return true;
        }
        return false;
    }
    function orderedRemoveItemAt(array, index) {
        for(let i = index; i < array.length - 1; i++)array[i] = array[i + 1];
        array.pop();
    }
    function unorderedRemoveItemAt(array, index) {
        array[index] = array[array.length - 1];
        array.pop();
    }
    function unorderedRemoveItem(array, item) {
        return unorderedRemoveFirstItemWhere(array, (element)=>element === item);
    }
    function unorderedRemoveFirstItemWhere(array, predicate) {
        for(let i = 0; i < array.length; i++)if (predicate(array[i])) {
            unorderedRemoveItemAt(array, i);
            return true;
        }
        return false;
    }
    function createGetCanonicalFileName(useCaseSensitiveFileNames) {
        return useCaseSensitiveFileNames ? identity : toFileNameLowerCase;
    }
    function patternText({ prefix: prefix , suffix: suffix  }) {
        return `${prefix}*${suffix}`;
    }
    function matchedText(pattern, candidate) {
        Debug.assert(isPatternMatch(pattern, candidate));
        return candidate.substring(pattern.prefix.length, candidate.length - pattern.suffix.length);
    }
    function findBestPatternMatch(values, getPattern, candidate) {
        let matchedValue;
        let longestMatchPrefixLength = -1;
        for (const v of values){
            const pattern = getPattern(v);
            if (isPatternMatch(pattern, candidate) && pattern.prefix.length > longestMatchPrefixLength) {
                longestMatchPrefixLength = pattern.prefix.length;
                matchedValue = v;
            }
        }
        return matchedValue;
    }
    function startsWith(str, prefix) {
        return str.lastIndexOf(prefix, 0) === 0;
    }
    function removePrefix(str, prefix) {
        return startsWith(str, prefix) ? str.substr(prefix.length) : str;
    }
    function tryRemovePrefix(str, prefix, getCanonicalFileName = identity) {
        return startsWith(getCanonicalFileName(str), getCanonicalFileName(prefix)) ? str.substring(prefix.length) : void 0;
    }
    function isPatternMatch({ prefix: prefix , suffix: suffix  }, candidate) {
        return candidate.length >= prefix.length + suffix.length && startsWith(candidate, prefix) && endsWith(candidate, suffix);
    }
    function and(f, g) {
        return (arg)=>f(arg) && g(arg);
    }
    function or(...fs) {
        return (...args)=>{
            let lastResult;
            for (const f of fs){
                lastResult = f(...args);
                if (lastResult) return lastResult;
            }
            return lastResult;
        };
    }
    function not(fn) {
        return (...args)=>!fn(...args);
    }
    function assertType(_) {}
    function singleElementArray(t) {
        return t === void 0 ? void 0 : [
            t
        ];
    }
    function enumerateInsertsAndDeletes(newItems, oldItems, comparer, inserted, deleted, unchanged) {
        unchanged = unchanged || noop;
        let newIndex = 0;
        let oldIndex = 0;
        const newLen = newItems.length;
        const oldLen = oldItems.length;
        let hasChanges = false;
        while(newIndex < newLen && oldIndex < oldLen){
            const newItem = newItems[newIndex];
            const oldItem = oldItems[oldIndex];
            const compareResult = comparer(newItem, oldItem);
            if (compareResult === -1 /* LessThan */ ) {
                inserted(newItem);
                newIndex++;
                hasChanges = true;
            } else if (compareResult === 1 /* GreaterThan */ ) {
                deleted(oldItem);
                oldIndex++;
                hasChanges = true;
            } else {
                unchanged(oldItem, newItem);
                newIndex++;
                oldIndex++;
            }
        }
        while(newIndex < newLen){
            inserted(newItems[newIndex++]);
            hasChanges = true;
        }
        while(oldIndex < oldLen){
            deleted(oldItems[oldIndex++]);
            hasChanges = true;
        }
        return hasChanges;
    }
    function cartesianProduct(arrays) {
        const result = [];
        cartesianProductWorker(arrays, result, /*outer*/ void 0, 0);
        return result;
    }
    function cartesianProductWorker(arrays, result, outer, index) {
        for (const element of arrays[index]){
            let inner;
            if (outer) {
                inner = outer.slice();
                inner.push(element);
            } else inner = [
                element
            ];
            if (index === arrays.length - 1) result.push(inner);
            else cartesianProductWorker(arrays, result, inner, index + 1);
        }
    }
    function padLeft(s, length2, padString = " ") {
        return length2 <= s.length ? s : padString.repeat(length2 - s.length) + s;
    }
    function padRight(s, length2, padString = " ") {
        return length2 <= s.length ? s : s + padString.repeat(length2 - s.length);
    }
    function takeWhile(array, predicate) {
        if (array) {
            const len = array.length;
            let index = 0;
            while(index < len && predicate(array[index]))index++;
            return array.slice(0, index);
        }
    }
    function skipWhile(array, predicate) {
        if (array) {
            const len = array.length;
            let index = 0;
            while(index < len && predicate(array[index]))index++;
            return array.slice(index);
        }
    }
    function trimEndImpl(s) {
        let end = s.length - 1;
        while(end >= 0){
            if (!isWhiteSpaceLike(s.charCodeAt(end))) break;
            end--;
        }
        return s.slice(0, end + 1);
    }
    function isNodeLikeSystem() {
        return typeof $cfae44f0dfdf62c0$exports !== "undefined" && !!$cfae44f0dfdf62c0$exports.nextTick && false;
    }
    var emptyArray, emptyMap, emptySet, SortKind, elementAt, hasOwnProperty, fileNameLowerCaseRegExp, AssertionLevel, createUIStringComparer, uiComparerCaseSensitive, uiLocale, trimString, trimStringEnd, trimStringStart;
    var init_core = __esm({
        "src/compiler/core.ts" () {
            "use strict";
            init_ts2();
            emptyArray = [];
            emptyMap = /* @__PURE__ */ new Map();
            emptySet = /* @__PURE__ */ new Set();
            SortKind = /* @__PURE__ */ ((SortKind2)=>{
                SortKind2[SortKind2["None"] = 0] = "None";
                SortKind2[SortKind2["CaseSensitive"] = 1] = "CaseSensitive";
                SortKind2[SortKind2["CaseInsensitive"] = 2] = "CaseInsensitive";
                SortKind2[SortKind2["Both"] = 3] = "Both";
                return SortKind2;
            })(SortKind || {});
            elementAt = !!Array.prototype.at ? (array, offset)=>array == null ? void 0 : array.at(offset) : (array, offset)=>{
                if (array) {
                    offset = toOffset(array, offset);
                    if (offset < array.length) return array[offset];
                }
                return void 0;
            };
            hasOwnProperty = Object.prototype.hasOwnProperty;
            fileNameLowerCaseRegExp = /[^\u0130\u0131\u00DFa-z0-9\\/:\-_\. ]+/g;
            AssertionLevel = /* @__PURE__ */ ((AssertionLevel2)=>{
                AssertionLevel2[AssertionLevel2["None"] = 0] = "None";
                AssertionLevel2[AssertionLevel2["Normal"] = 1] = "Normal";
                AssertionLevel2[AssertionLevel2["Aggressive"] = 2] = "Aggressive";
                AssertionLevel2[AssertionLevel2["VeryAggressive"] = 3] = "VeryAggressive";
                return AssertionLevel2;
            })(AssertionLevel || {});
            createUIStringComparer = (()=>{
                let defaultComparer;
                let enUSComparer;
                const stringComparerFactory = getStringComparerFactory();
                return createStringComparer;
                function compareWithCallback(a, b, comparer) {
                    if (a === b) return 0 /* EqualTo */ ;
                    if (a === void 0) return -1 /* LessThan */ ;
                    if (b === void 0) return 1 /* GreaterThan */ ;
                    const value1 = comparer(a, b);
                    return value1 < 0 ? -1 /* LessThan */  : value1 > 0 ? 1 /* GreaterThan */  : 0 /* EqualTo */ ;
                }
                function createIntlCollatorStringComparer(locale) {
                    const comparer = new Intl.Collator(locale, {
                        usage: "sort",
                        sensitivity: "variant"
                    }).compare;
                    return (a, b)=>compareWithCallback(a, b, comparer);
                }
                function createLocaleCompareStringComparer(locale) {
                    if (locale !== void 0) return createFallbackStringComparer();
                    return (a, b)=>compareWithCallback(a, b, compareStrings);
                    function compareStrings(a, b) {
                        return a.localeCompare(b);
                    }
                }
                function createFallbackStringComparer() {
                    return (a, b)=>compareWithCallback(a, b, compareDictionaryOrder);
                    function compareDictionaryOrder(a, b) {
                        return compareStrings(a.toUpperCase(), b.toUpperCase()) || compareStrings(a, b);
                    }
                    function compareStrings(a, b) {
                        return a < b ? -1 /* LessThan */  : a > b ? 1 /* GreaterThan */  : 0 /* EqualTo */ ;
                    }
                }
                function getStringComparerFactory() {
                    if (typeof Intl === "object" && typeof Intl.Collator === "function") return createIntlCollatorStringComparer;
                    if (typeof String.prototype.localeCompare === "function" && typeof String.prototype.toLocaleUpperCase === "function" && "a".localeCompare("B") < 0) return createLocaleCompareStringComparer;
                    return createFallbackStringComparer;
                }
                function createStringComparer(locale) {
                    if (locale === void 0) return defaultComparer || (defaultComparer = stringComparerFactory(locale));
                    else if (locale === "en-US") return enUSComparer || (enUSComparer = stringComparerFactory(locale));
                    else return stringComparerFactory(locale);
                }
            })();
            trimString = !!String.prototype.trim ? (s)=>s.trim() : (s)=>trimStringEnd(trimStringStart(s));
            trimStringEnd = !!String.prototype.trimEnd ? (s)=>s.trimEnd() : trimEndImpl;
            trimStringStart = !!String.prototype.trimStart ? (s)=>s.trimStart() : (s)=>s.replace(/^\s+/g, "");
        }
    });
    // src/compiler/debug.ts
    var LogLevel, Debug;
    var init_debug = __esm({
        "src/compiler/debug.ts" () {
            "use strict";
            init_ts2();
            init_ts2();
            LogLevel = /* @__PURE__ */ ((LogLevel2)=>{
                LogLevel2[LogLevel2["Off"] = 0] = "Off";
                LogLevel2[LogLevel2["Error"] = 1] = "Error";
                LogLevel2[LogLevel2["Warning"] = 2] = "Warning";
                LogLevel2[LogLevel2["Info"] = 3] = "Info";
                LogLevel2[LogLevel2["Verbose"] = 4] = "Verbose";
                return LogLevel2;
            })(LogLevel || {});
            ((Debug2)=>{
                let currentAssertionLevel = 0 /* None */ ;
                Debug2.currentLogLevel = 2 /* Warning */ ;
                Debug2.isDebugging = false;
                function shouldLog(level) {
                    return Debug2.currentLogLevel <= level;
                }
                Debug2.shouldLog = shouldLog;
                function logMessage(level, s) {
                    if (Debug2.loggingHost && shouldLog(level)) Debug2.loggingHost.log(level, s);
                }
                function log(s) {
                    logMessage(3 /* Info */ , s);
                }
                Debug2.log = log;
                ((_log)=>{
                    function error(s) {
                        logMessage(1 /* Error */ , s);
                    }
                    _log.error = error;
                    function warn(s) {
                        logMessage(2 /* Warning */ , s);
                    }
                    _log.warn = warn;
                    function log2(s) {
                        logMessage(3 /* Info */ , s);
                    }
                    _log.log = log2;
                    function trace2(s) {
                        logMessage(4 /* Verbose */ , s);
                    }
                    _log.trace = trace2;
                })(log = Debug2.log || (Debug2.log = {}));
                const assertionCache = {};
                function getAssertionLevel() {
                    return currentAssertionLevel;
                }
                Debug2.getAssertionLevel = getAssertionLevel;
                function setAssertionLevel(level) {
                    const prevAssertionLevel = currentAssertionLevel;
                    currentAssertionLevel = level;
                    if (level > prevAssertionLevel) for (const key of getOwnKeys(assertionCache)){
                        const cachedFunc = assertionCache[key];
                        if (cachedFunc !== void 0 && Debug2[key] !== cachedFunc.assertion && level >= cachedFunc.level) {
                            Debug2[key] = cachedFunc;
                            assertionCache[key] = void 0;
                        }
                    }
                }
                Debug2.setAssertionLevel = setAssertionLevel;
                function shouldAssert(level) {
                    return currentAssertionLevel >= level;
                }
                Debug2.shouldAssert = shouldAssert;
                function shouldAssertFunction(level, name) {
                    if (!shouldAssert(level)) {
                        assertionCache[name] = {
                            level: level,
                            assertion: Debug2[name]
                        };
                        Debug2[name] = noop;
                        return false;
                    }
                    return true;
                }
                function fail(message, stackCrawlMark) {
                    debugger;
                    const e = new Error(message ? `Debug Failure. ${message}` : "Debug Failure.");
                    if (Error.captureStackTrace) Error.captureStackTrace(e, stackCrawlMark || fail);
                    throw e;
                }
                Debug2.fail = fail;
                function failBadSyntaxKind(node, message, stackCrawlMark) {
                    return fail(`${message || "Unexpected node."}\r
Node ${formatSyntaxKind(node.kind)} was unexpected.`, stackCrawlMark || failBadSyntaxKind);
                }
                Debug2.failBadSyntaxKind = failBadSyntaxKind;
                function assert(expression, message, verboseDebugInfo, stackCrawlMark) {
                    if (!expression) {
                        message = message ? `False expression: ${message}` : "False expression.";
                        if (verboseDebugInfo) message += "\r\nVerbose Debug Information: " + (typeof verboseDebugInfo === "string" ? verboseDebugInfo : verboseDebugInfo());
                        fail(message, stackCrawlMark || assert);
                    }
                }
                Debug2.assert = assert;
                function assertEqual(a, b, msg, msg2, stackCrawlMark) {
                    if (a !== b) {
                        const message = msg ? msg2 ? `${msg} ${msg2}` : msg : "";
                        fail(`Expected ${a} === ${b}. ${message}`, stackCrawlMark || assertEqual);
                    }
                }
                Debug2.assertEqual = assertEqual;
                function assertLessThan(a, b, msg, stackCrawlMark) {
                    if (a >= b) fail(`Expected ${a} < ${b}. ${msg || ""}`, stackCrawlMark || assertLessThan);
                }
                Debug2.assertLessThan = assertLessThan;
                function assertLessThanOrEqual(a, b, stackCrawlMark) {
                    if (a > b) fail(`Expected ${a} <= ${b}`, stackCrawlMark || assertLessThanOrEqual);
                }
                Debug2.assertLessThanOrEqual = assertLessThanOrEqual;
                function assertGreaterThanOrEqual(a, b, stackCrawlMark) {
                    if (a < b) fail(`Expected ${a} >= ${b}`, stackCrawlMark || assertGreaterThanOrEqual);
                }
                Debug2.assertGreaterThanOrEqual = assertGreaterThanOrEqual;
                function assertIsDefined(value1, message, stackCrawlMark) {
                    if (value1 === void 0 || value1 === null) fail(message, stackCrawlMark || assertIsDefined);
                }
                Debug2.assertIsDefined = assertIsDefined;
                function checkDefined(value1, message, stackCrawlMark) {
                    assertIsDefined(value1, message, stackCrawlMark || checkDefined);
                    return value1;
                }
                Debug2.checkDefined = checkDefined;
                function assertEachIsDefined(value1, message, stackCrawlMark) {
                    for (const v of value1)assertIsDefined(v, message, stackCrawlMark || assertEachIsDefined);
                }
                Debug2.assertEachIsDefined = assertEachIsDefined;
                function checkEachDefined(value1, message, stackCrawlMark) {
                    assertEachIsDefined(value1, message, stackCrawlMark || checkEachDefined);
                    return value1;
                }
                Debug2.checkEachDefined = checkEachDefined;
                function assertNever(member, message = "Illegal value:", stackCrawlMark) {
                    const detail = typeof member === "object" && hasProperty(member, "kind") && hasProperty(member, "pos") ? "SyntaxKind: " + formatSyntaxKind(member.kind) : JSON.stringify(member);
                    return fail(`${message} ${detail}`, stackCrawlMark || assertNever);
                }
                Debug2.assertNever = assertNever;
                function assertEachNode(nodes, test, message, stackCrawlMark) {
                    if (shouldAssertFunction(1 /* Normal */ , "assertEachNode")) assert(test === void 0 || every(nodes, test), message || "Unexpected node.", ()=>`Node array did not pass test '${getFunctionName(test)}'.`, stackCrawlMark || assertEachNode);
                }
                Debug2.assertEachNode = assertEachNode;
                function assertNode(node, test, message, stackCrawlMark) {
                    if (shouldAssertFunction(1 /* Normal */ , "assertNode")) assert(node !== void 0 && (test === void 0 || test(node)), message || "Unexpected node.", ()=>`Node ${formatSyntaxKind(node == null ? void 0 : node.kind)} did not pass test '${getFunctionName(test)}'.`, stackCrawlMark || assertNode);
                }
                Debug2.assertNode = assertNode;
                function assertNotNode(node, test, message, stackCrawlMark) {
                    if (shouldAssertFunction(1 /* Normal */ , "assertNotNode")) assert(node === void 0 || test === void 0 || !test(node), message || "Unexpected node.", ()=>`Node ${formatSyntaxKind(node.kind)} should not have passed test '${getFunctionName(test)}'.`, stackCrawlMark || assertNotNode);
                }
                Debug2.assertNotNode = assertNotNode;
                function assertOptionalNode(node, test, message, stackCrawlMark) {
                    if (shouldAssertFunction(1 /* Normal */ , "assertOptionalNode")) assert(test === void 0 || node === void 0 || test(node), message || "Unexpected node.", ()=>`Node ${formatSyntaxKind(node == null ? void 0 : node.kind)} did not pass test '${getFunctionName(test)}'.`, stackCrawlMark || assertOptionalNode);
                }
                Debug2.assertOptionalNode = assertOptionalNode;
                function assertOptionalToken(node, kind, message, stackCrawlMark) {
                    if (shouldAssertFunction(1 /* Normal */ , "assertOptionalToken")) assert(kind === void 0 || node === void 0 || node.kind === kind, message || "Unexpected node.", ()=>`Node ${formatSyntaxKind(node == null ? void 0 : node.kind)} was not a '${formatSyntaxKind(kind)}' token.`, stackCrawlMark || assertOptionalToken);
                }
                Debug2.assertOptionalToken = assertOptionalToken;
                function assertMissingNode(node, message, stackCrawlMark) {
                    if (shouldAssertFunction(1 /* Normal */ , "assertMissingNode")) assert(node === void 0, message || "Unexpected node.", ()=>`Node ${formatSyntaxKind(node.kind)} was unexpected'.`, stackCrawlMark || assertMissingNode);
                }
                Debug2.assertMissingNode = assertMissingNode;
                function type(_value) {}
                Debug2.type = type;
                function getFunctionName(func) {
                    if (typeof func !== "function") return "";
                    else if (hasProperty(func, "name")) return func.name;
                    else {
                        const text = Function.prototype.toString.call(func);
                        const match = /^function\s+([\w\$]+)\s*\(/.exec(text);
                        return match ? match[1] : "";
                    }
                }
                Debug2.getFunctionName = getFunctionName;
                function formatSymbol(symbol) {
                    return `{ name: ${unescapeLeadingUnderscores(symbol.escapedName)}; flags: ${formatSymbolFlags(symbol.flags)}; declarations: ${map(symbol.declarations, (node)=>formatSyntaxKind(node.kind))} }`;
                }
                Debug2.formatSymbol = formatSymbol;
                function formatEnum(value1 = 0, enumObject, isFlags) {
                    const members = getEnumMembers(enumObject);
                    if (value1 === 0) return members.length > 0 && members[0][0] === 0 ? members[0][1] : "0";
                    if (isFlags) {
                        const result = [];
                        let remainingFlags = value1;
                        for (const [enumValue, enumName] of members){
                            if (enumValue > value1) break;
                            if (enumValue !== 0 && enumValue & value1) {
                                result.push(enumName);
                                remainingFlags &= ~enumValue;
                            }
                        }
                        if (remainingFlags === 0) return result.join("|");
                    } else for (const [enumValue, enumName] of members){
                        if (enumValue === value1) return enumName;
                    }
                    return value1.toString();
                }
                Debug2.formatEnum = formatEnum;
                const enumMemberCache = /* @__PURE__ */ new Map();
                function getEnumMembers(enumObject) {
                    const existing = enumMemberCache.get(enumObject);
                    if (existing) return existing;
                    const result = [];
                    for(const name in enumObject){
                        const value1 = enumObject[name];
                        if (typeof value1 === "number") result.push([
                            value1,
                            name
                        ]);
                    }
                    const sorted = stableSort(result, (x, y)=>compareValues(x[0], y[0]));
                    enumMemberCache.set(enumObject, sorted);
                    return sorted;
                }
                function formatSyntaxKind(kind) {
                    return formatEnum(kind, SyntaxKind, /*isFlags*/ false);
                }
                Debug2.formatSyntaxKind = formatSyntaxKind;
                function formatSnippetKind(kind) {
                    return formatEnum(kind, SnippetKind, /*isFlags*/ false);
                }
                Debug2.formatSnippetKind = formatSnippetKind;
                function formatNodeFlags(flags) {
                    return formatEnum(flags, NodeFlags, /*isFlags*/ true);
                }
                Debug2.formatNodeFlags = formatNodeFlags;
                function formatModifierFlags(flags) {
                    return formatEnum(flags, ModifierFlags, /*isFlags*/ true);
                }
                Debug2.formatModifierFlags = formatModifierFlags;
                function formatTransformFlags(flags) {
                    return formatEnum(flags, TransformFlags, /*isFlags*/ true);
                }
                Debug2.formatTransformFlags = formatTransformFlags;
                function formatEmitFlags(flags) {
                    return formatEnum(flags, EmitFlags, /*isFlags*/ true);
                }
                Debug2.formatEmitFlags = formatEmitFlags;
                function formatSymbolFlags(flags) {
                    return formatEnum(flags, SymbolFlags, /*isFlags*/ true);
                }
                Debug2.formatSymbolFlags = formatSymbolFlags;
                function formatTypeFlags(flags) {
                    return formatEnum(flags, TypeFlags, /*isFlags*/ true);
                }
                Debug2.formatTypeFlags = formatTypeFlags;
                function formatSignatureFlags(flags) {
                    return formatEnum(flags, SignatureFlags, /*isFlags*/ true);
                }
                Debug2.formatSignatureFlags = formatSignatureFlags;
                function formatObjectFlags(flags) {
                    return formatEnum(flags, ObjectFlags, /*isFlags*/ true);
                }
                Debug2.formatObjectFlags = formatObjectFlags;
                function formatFlowFlags(flags) {
                    return formatEnum(flags, FlowFlags, /*isFlags*/ true);
                }
                Debug2.formatFlowFlags = formatFlowFlags;
                function formatRelationComparisonResult(result) {
                    return formatEnum(result, RelationComparisonResult, /*isFlags*/ true);
                }
                Debug2.formatRelationComparisonResult = formatRelationComparisonResult;
                function formatCheckMode(mode) {
                    return formatEnum(mode, CheckMode, /*isFlags*/ true);
                }
                Debug2.formatCheckMode = formatCheckMode;
                function formatSignatureCheckMode(mode) {
                    return formatEnum(mode, SignatureCheckMode, /*isFlags*/ true);
                }
                Debug2.formatSignatureCheckMode = formatSignatureCheckMode;
                function formatTypeFacts(facts) {
                    return formatEnum(facts, TypeFacts, /*isFlags*/ true);
                }
                Debug2.formatTypeFacts = formatTypeFacts;
                let isDebugInfoEnabled = false;
                let flowNodeProto;
                function attachFlowNodeDebugInfoWorker(flowNode) {
                    if (!("__debugFlowFlags" in flowNode)) Object.defineProperties(flowNode, {
                        // for use with vscode-js-debug's new customDescriptionGenerator in launch.json
                        __tsDebuggerDisplay: {
                            value () {
                                const flowHeader = this.flags & 2 /* Start */  ? "FlowStart" : this.flags & 4 /* BranchLabel */  ? "FlowBranchLabel" : this.flags & 8 /* LoopLabel */  ? "FlowLoopLabel" : this.flags & 16 /* Assignment */  ? "FlowAssignment" : this.flags & 32 /* TrueCondition */  ? "FlowTrueCondition" : this.flags & 64 /* FalseCondition */  ? "FlowFalseCondition" : this.flags & 128 /* SwitchClause */  ? "FlowSwitchClause" : this.flags & 256 /* ArrayMutation */  ? "FlowArrayMutation" : this.flags & 512 /* Call */  ? "FlowCall" : this.flags & 1024 /* ReduceLabel */  ? "FlowReduceLabel" : this.flags & 1 /* Unreachable */  ? "FlowUnreachable" : "UnknownFlow";
                                const remainingFlags = this.flags & -2048;
                                return `${flowHeader}${remainingFlags ? ` (${formatFlowFlags(remainingFlags)})` : ""}`;
                            }
                        },
                        __debugFlowFlags: {
                            get () {
                                return formatEnum(this.flags, FlowFlags, /*isFlags*/ true);
                            }
                        },
                        __debugToString: {
                            value () {
                                return formatControlFlowGraph(this);
                            }
                        }
                    });
                }
                function attachFlowNodeDebugInfo(flowNode) {
                    if (isDebugInfoEnabled) {
                        if (typeof Object.setPrototypeOf === "function") {
                            if (!flowNodeProto) {
                                flowNodeProto = Object.create(Object.prototype);
                                attachFlowNodeDebugInfoWorker(flowNodeProto);
                            }
                            Object.setPrototypeOf(flowNode, flowNodeProto);
                        } else attachFlowNodeDebugInfoWorker(flowNode);
                    }
                }
                Debug2.attachFlowNodeDebugInfo = attachFlowNodeDebugInfo;
                let nodeArrayProto;
                function attachNodeArrayDebugInfoWorker(array) {
                    if (!("__tsDebuggerDisplay" in array)) Object.defineProperties(array, {
                        __tsDebuggerDisplay: {
                            value (defaultValue) {
                                defaultValue = String(defaultValue).replace(/(?:,[\s\w\d_]+:[^,]+)+\]$/, "]");
                                return `NodeArray ${defaultValue}`;
                            }
                        }
                    });
                }
                function attachNodeArrayDebugInfo(array) {
                    if (isDebugInfoEnabled) {
                        if (typeof Object.setPrototypeOf === "function") {
                            if (!nodeArrayProto) {
                                nodeArrayProto = Object.create(Array.prototype);
                                attachNodeArrayDebugInfoWorker(nodeArrayProto);
                            }
                            Object.setPrototypeOf(array, nodeArrayProto);
                        } else attachNodeArrayDebugInfoWorker(array);
                    }
                }
                Debug2.attachNodeArrayDebugInfo = attachNodeArrayDebugInfo;
                function enableDebugInfo() {
                    if (isDebugInfoEnabled) return;
                    const weakTypeTextMap = /* @__PURE__ */ new WeakMap();
                    const weakNodeTextMap = /* @__PURE__ */ new WeakMap();
                    Object.defineProperties(objectAllocator.getSymbolConstructor().prototype, {
                        // for use with vscode-js-debug's new customDescriptionGenerator in launch.json
                        __tsDebuggerDisplay: {
                            value () {
                                const symbolHeader = this.flags & 33554432 /* Transient */  ? "TransientSymbol" : "Symbol";
                                const remainingSymbolFlags = this.flags & -33554433 /* Transient */ ;
                                return `${symbolHeader} '${symbolName(this)}'${remainingSymbolFlags ? ` (${formatSymbolFlags(remainingSymbolFlags)})` : ""}`;
                            }
                        },
                        __debugFlags: {
                            get () {
                                return formatSymbolFlags(this.flags);
                            }
                        }
                    });
                    Object.defineProperties(objectAllocator.getTypeConstructor().prototype, {
                        // for use with vscode-js-debug's new customDescriptionGenerator in launch.json
                        __tsDebuggerDisplay: {
                            value () {
                                const typeHeader = this.flags & 98304 /* Nullable */  ? "NullableType" : this.flags & 384 /* StringOrNumberLiteral */  ? `LiteralType ${JSON.stringify(this.value)}` : this.flags & 2048 /* BigIntLiteral */  ? `LiteralType ${this.value.negative ? "-" : ""}${this.value.base10Value}n` : this.flags & 8192 /* UniqueESSymbol */  ? "UniqueESSymbolType" : this.flags & 32 /* Enum */  ? "EnumType" : this.flags & 67359327 /* Intrinsic */  ? `IntrinsicType ${this.intrinsicName}` : this.flags & 1048576 /* Union */  ? "UnionType" : this.flags & 2097152 /* Intersection */  ? "IntersectionType" : this.flags & 4194304 /* Index */  ? "IndexType" : this.flags & 8388608 /* IndexedAccess */  ? "IndexedAccessType" : this.flags & 16777216 /* Conditional */  ? "ConditionalType" : this.flags & 33554432 /* Substitution */  ? "SubstitutionType" : this.flags & 262144 /* TypeParameter */  ? "TypeParameter" : this.flags & 524288 /* Object */  ? this.objectFlags & 3 /* ClassOrInterface */  ? "InterfaceType" : this.objectFlags & 4 /* Reference */  ? "TypeReference" : this.objectFlags & 8 /* Tuple */  ? "TupleType" : this.objectFlags & 16 /* Anonymous */  ? "AnonymousType" : this.objectFlags & 32 /* Mapped */  ? "MappedType" : this.objectFlags & 1024 /* ReverseMapped */  ? "ReverseMappedType" : this.objectFlags & 256 /* EvolvingArray */  ? "EvolvingArrayType" : "ObjectType" : "Type";
                                const remainingObjectFlags = this.flags & 524288 /* Object */  ? this.objectFlags & -1344 /* ObjectTypeKindMask */  : 0;
                                return `${typeHeader}${this.symbol ? ` '${symbolName(this.symbol)}'` : ""}${remainingObjectFlags ? ` (${formatObjectFlags(remainingObjectFlags)})` : ""}`;
                            }
                        },
                        __debugFlags: {
                            get () {
                                return formatTypeFlags(this.flags);
                            }
                        },
                        __debugObjectFlags: {
                            get () {
                                return this.flags & 524288 /* Object */  ? formatObjectFlags(this.objectFlags) : "";
                            }
                        },
                        __debugTypeToString: {
                            value () {
                                let text = weakTypeTextMap.get(this);
                                if (text === void 0) {
                                    text = this.checker.typeToString(this);
                                    weakTypeTextMap.set(this, text);
                                }
                                return text;
                            }
                        }
                    });
                    Object.defineProperties(objectAllocator.getSignatureConstructor().prototype, {
                        __debugFlags: {
                            get () {
                                return formatSignatureFlags(this.flags);
                            }
                        },
                        __debugSignatureToString: {
                            value () {
                                var _a;
                                return (_a = this.checker) == null ? void 0 : _a.signatureToString(this);
                            }
                        }
                    });
                    const nodeConstructors = [
                        objectAllocator.getNodeConstructor(),
                        objectAllocator.getIdentifierConstructor(),
                        objectAllocator.getTokenConstructor(),
                        objectAllocator.getSourceFileConstructor()
                    ];
                    for (const ctor of nodeConstructors)if (!hasProperty(ctor.prototype, "__debugKind")) Object.defineProperties(ctor.prototype, {
                        // for use with vscode-js-debug's new customDescriptionGenerator in launch.json
                        __tsDebuggerDisplay: {
                            value () {
                                const nodeHeader = isGeneratedIdentifier(this) ? "GeneratedIdentifier" : isIdentifier(this) ? `Identifier '${idText(this)}'` : isPrivateIdentifier(this) ? `PrivateIdentifier '${idText(this)}'` : isStringLiteral(this) ? `StringLiteral ${JSON.stringify(this.text.length < 10 ? this.text : this.text.slice(10) + "...")}` : isNumericLiteral(this) ? `NumericLiteral ${this.text}` : isBigIntLiteral(this) ? `BigIntLiteral ${this.text}n` : isTypeParameterDeclaration(this) ? "TypeParameterDeclaration" : isParameter(this) ? "ParameterDeclaration" : isConstructorDeclaration(this) ? "ConstructorDeclaration" : isGetAccessorDeclaration(this) ? "GetAccessorDeclaration" : isSetAccessorDeclaration(this) ? "SetAccessorDeclaration" : isCallSignatureDeclaration(this) ? "CallSignatureDeclaration" : isConstructSignatureDeclaration(this) ? "ConstructSignatureDeclaration" : isIndexSignatureDeclaration(this) ? "IndexSignatureDeclaration" : isTypePredicateNode(this) ? "TypePredicateNode" : isTypeReferenceNode(this) ? "TypeReferenceNode" : isFunctionTypeNode(this) ? "FunctionTypeNode" : isConstructorTypeNode(this) ? "ConstructorTypeNode" : isTypeQueryNode(this) ? "TypeQueryNode" : isTypeLiteralNode(this) ? "TypeLiteralNode" : isArrayTypeNode(this) ? "ArrayTypeNode" : isTupleTypeNode(this) ? "TupleTypeNode" : isOptionalTypeNode(this) ? "OptionalTypeNode" : isRestTypeNode(this) ? "RestTypeNode" : isUnionTypeNode(this) ? "UnionTypeNode" : isIntersectionTypeNode(this) ? "IntersectionTypeNode" : isConditionalTypeNode(this) ? "ConditionalTypeNode" : isInferTypeNode(this) ? "InferTypeNode" : isParenthesizedTypeNode(this) ? "ParenthesizedTypeNode" : isThisTypeNode(this) ? "ThisTypeNode" : isTypeOperatorNode(this) ? "TypeOperatorNode" : isIndexedAccessTypeNode(this) ? "IndexedAccessTypeNode" : isMappedTypeNode(this) ? "MappedTypeNode" : isLiteralTypeNode(this) ? "LiteralTypeNode" : isNamedTupleMember(this) ? "NamedTupleMember" : isImportTypeNode(this) ? "ImportTypeNode" : formatSyntaxKind(this.kind);
                                return `${nodeHeader}${this.flags ? ` (${formatNodeFlags(this.flags)})` : ""}`;
                            }
                        },
                        __debugKind: {
                            get () {
                                return formatSyntaxKind(this.kind);
                            }
                        },
                        __debugNodeFlags: {
                            get () {
                                return formatNodeFlags(this.flags);
                            }
                        },
                        __debugModifierFlags: {
                            get () {
                                return formatModifierFlags(getEffectiveModifierFlagsNoCache(this));
                            }
                        },
                        __debugTransformFlags: {
                            get () {
                                return formatTransformFlags(this.transformFlags);
                            }
                        },
                        __debugIsParseTreeNode: {
                            get () {
                                return isParseTreeNode(this);
                            }
                        },
                        __debugEmitFlags: {
                            get () {
                                return formatEmitFlags(getEmitFlags(this));
                            }
                        },
                        __debugGetText: {
                            value (includeTrivia) {
                                if (nodeIsSynthesized(this)) return "";
                                let text = weakNodeTextMap.get(this);
                                if (text === void 0) {
                                    const parseNode = getParseTreeNode(this);
                                    const sourceFile = parseNode && getSourceFileOfNode(parseNode);
                                    text = sourceFile ? getSourceTextOfNodeFromSourceFile(sourceFile, parseNode, includeTrivia) : "";
                                    weakNodeTextMap.set(this, text);
                                }
                                return text;
                            }
                        }
                    });
                    isDebugInfoEnabled = true;
                }
                Debug2.enableDebugInfo = enableDebugInfo;
                function formatVariance(varianceFlags) {
                    const variance = varianceFlags & 7 /* VarianceMask */ ;
                    let result = variance === 0 /* Invariant */  ? "in out" : variance === 3 /* Bivariant */  ? "[bivariant]" : variance === 2 /* Contravariant */  ? "in" : variance === 1 /* Covariant */  ? "out" : variance === 4 /* Independent */  ? "[independent]" : "";
                    if (varianceFlags & 8 /* Unmeasurable */ ) result += " (unmeasurable)";
                    else if (varianceFlags & 16 /* Unreliable */ ) result += " (unreliable)";
                    return result;
                }
                Debug2.formatVariance = formatVariance;
                class DebugTypeMapper {
                    __debugToString() {
                        var _a;
                        type(this);
                        switch(this.kind){
                            case 3 /* Function */ :
                                return ((_a = this.debugInfo) == null ? void 0 : _a.call(this)) || "(function mapper)";
                            case 0 /* Simple */ :
                                return `${this.source.__debugTypeToString()} -> ${this.target.__debugTypeToString()}`;
                            case 1 /* Array */ :
                                return zipWith(this.sources, this.targets || map(this.sources, ()=>"any"), (s, t)=>`${s.__debugTypeToString()} -> ${typeof t === "string" ? t : t.__debugTypeToString()}`).join(", ");
                            case 2 /* Deferred */ :
                                return zipWith(this.sources, this.targets, (s, t)=>`${s.__debugTypeToString()} -> ${t().__debugTypeToString()}`).join(", ");
                            case 5 /* Merged */ :
                            case 4 /* Composite */ :
                                return `m1: ${this.mapper1.__debugToString().split("\n").join("\n    ")}
m2: ${this.mapper2.__debugToString().split("\n").join("\n    ")}`;
                            default:
                                return assertNever(this);
                        }
                    }
                }
                Debug2.DebugTypeMapper = DebugTypeMapper;
                function attachDebugPrototypeIfDebug(mapper) {
                    if (Debug2.isDebugging) return Object.setPrototypeOf(mapper, DebugTypeMapper.prototype);
                    return mapper;
                }
                Debug2.attachDebugPrototypeIfDebug = attachDebugPrototypeIfDebug;
                function printControlFlowGraph(flowNode) {
                    return console.log(formatControlFlowGraph(flowNode));
                }
                Debug2.printControlFlowGraph = printControlFlowGraph;
                function formatControlFlowGraph(flowNode) {
                    let nextDebugFlowId = -1;
                    function getDebugFlowNodeId(f) {
                        if (!f.id) {
                            f.id = nextDebugFlowId;
                            nextDebugFlowId--;
                        }
                        return f.id;
                    }
                    let BoxCharacter;
                    ((BoxCharacter2)=>{
                        BoxCharacter2["lr"] = "─";
                        BoxCharacter2["ud"] = "│";
                        BoxCharacter2["dr"] = "╭";
                        BoxCharacter2["dl"] = "╮";
                        BoxCharacter2["ul"] = "╯";
                        BoxCharacter2["ur"] = "╰";
                        BoxCharacter2["udr"] = "├";
                        BoxCharacter2["udl"] = "┤";
                        BoxCharacter2["dlr"] = "┬";
                        BoxCharacter2["ulr"] = "┴";
                        BoxCharacter2["udlr"] = "╫";
                    })(BoxCharacter || (BoxCharacter = {}));
                    let Connection;
                    ((Connection2)=>{
                        Connection2[Connection2["None"] = 0] = "None";
                        Connection2[Connection2["Up"] = 1] = "Up";
                        Connection2[Connection2["Down"] = 2] = "Down";
                        Connection2[Connection2["Left"] = 4] = "Left";
                        Connection2[Connection2["Right"] = 8] = "Right";
                        Connection2[Connection2["UpDown"] = 3] = "UpDown";
                        Connection2[Connection2["LeftRight"] = 12] = "LeftRight";
                        Connection2[Connection2["UpLeft"] = 5] = "UpLeft";
                        Connection2[Connection2["UpRight"] = 9] = "UpRight";
                        Connection2[Connection2["DownLeft"] = 6] = "DownLeft";
                        Connection2[Connection2["DownRight"] = 10] = "DownRight";
                        Connection2[Connection2["UpDownLeft"] = 7] = "UpDownLeft";
                        Connection2[Connection2["UpDownRight"] = 11] = "UpDownRight";
                        Connection2[Connection2["UpLeftRight"] = 13] = "UpLeftRight";
                        Connection2[Connection2["DownLeftRight"] = 14] = "DownLeftRight";
                        Connection2[Connection2["UpDownLeftRight"] = 15] = "UpDownLeftRight";
                        Connection2[Connection2["NoChildren"] = 16] = "NoChildren";
                    })(Connection || (Connection = {}));
                    const hasAntecedentFlags = 2032 /* ReduceLabel */ ;
                    const hasNodeFlags = 882 /* ArrayMutation */ ;
                    const links = /* @__PURE__ */ Object.create(/*o*/ null);
                    const nodes = [];
                    const edges = [];
                    const root = buildGraphNode(flowNode, /* @__PURE__ */ new Set());
                    for (const node of nodes){
                        node.text = renderFlowNode(node.flowNode, node.circular);
                        computeLevel(node);
                    }
                    const height = computeHeight(root);
                    const columnWidths = computeColumnWidths(height);
                    computeLanes(root, 0);
                    return renderGraph();
                    function isFlowSwitchClause(f) {
                        return !!(f.flags & 128 /* SwitchClause */ );
                    }
                    function hasAntecedents(f) {
                        return !!(f.flags & 12 /* Label */ ) && !!f.antecedents;
                    }
                    function hasAntecedent(f) {
                        return !!(f.flags & hasAntecedentFlags);
                    }
                    function hasNode(f) {
                        return !!(f.flags & hasNodeFlags);
                    }
                    function getChildren(node) {
                        const children = [];
                        for (const edge of node.edges)if (edge.source === node) children.push(edge.target);
                        return children;
                    }
                    function getParents(node) {
                        const parents = [];
                        for (const edge of node.edges)if (edge.target === node) parents.push(edge.source);
                        return parents;
                    }
                    function buildGraphNode(flowNode2, seen) {
                        const id = getDebugFlowNodeId(flowNode2);
                        let graphNode = links[id];
                        if (graphNode && seen.has(flowNode2)) {
                            graphNode.circular = true;
                            graphNode = {
                                id: -1,
                                flowNode: flowNode2,
                                edges: [],
                                text: "",
                                lane: -1,
                                endLane: -1,
                                level: -1,
                                circular: "circularity"
                            };
                            nodes.push(graphNode);
                            return graphNode;
                        }
                        seen.add(flowNode2);
                        if (!graphNode) {
                            links[id] = graphNode = {
                                id: id,
                                flowNode: flowNode2,
                                edges: [],
                                text: "",
                                lane: -1,
                                endLane: -1,
                                level: -1,
                                circular: false
                            };
                            nodes.push(graphNode);
                            if (hasAntecedents(flowNode2)) for (const antecedent of flowNode2.antecedents)buildGraphEdge(graphNode, antecedent, seen);
                            else if (hasAntecedent(flowNode2)) buildGraphEdge(graphNode, flowNode2.antecedent, seen);
                        }
                        seen.delete(flowNode2);
                        return graphNode;
                    }
                    function buildGraphEdge(source, antecedent, seen) {
                        const target = buildGraphNode(antecedent, seen);
                        const edge = {
                            source: source,
                            target: target
                        };
                        edges.push(edge);
                        source.edges.push(edge);
                        target.edges.push(edge);
                    }
                    function computeLevel(node) {
                        if (node.level !== -1) return node.level;
                        let level = 0;
                        for (const parent2 of getParents(node))level = Math.max(level, computeLevel(parent2) + 1);
                        return node.level = level;
                    }
                    function computeHeight(node) {
                        let height2 = 0;
                        for (const child of getChildren(node))height2 = Math.max(height2, computeHeight(child));
                        return height2 + 1;
                    }
                    function computeColumnWidths(height2) {
                        const columns = fill(Array(height2), 0);
                        for (const node of nodes)columns[node.level] = Math.max(columns[node.level], node.text.length);
                        return columns;
                    }
                    function computeLanes(node, lane) {
                        if (node.lane === -1) {
                            node.lane = lane;
                            node.endLane = lane;
                            const children = getChildren(node);
                            for(let i = 0; i < children.length; i++){
                                if (i > 0) lane++;
                                const child = children[i];
                                computeLanes(child, lane);
                                if (child.endLane > node.endLane) lane = child.endLane;
                            }
                            node.endLane = lane;
                        }
                    }
                    function getHeader(flags) {
                        if (flags & 2 /* Start */ ) return "Start";
                        if (flags & 4 /* BranchLabel */ ) return "Branch";
                        if (flags & 8 /* LoopLabel */ ) return "Loop";
                        if (flags & 16 /* Assignment */ ) return "Assignment";
                        if (flags & 32 /* TrueCondition */ ) return "True";
                        if (flags & 64 /* FalseCondition */ ) return "False";
                        if (flags & 128 /* SwitchClause */ ) return "SwitchClause";
                        if (flags & 256 /* ArrayMutation */ ) return "ArrayMutation";
                        if (flags & 512 /* Call */ ) return "Call";
                        if (flags & 1024 /* ReduceLabel */ ) return "ReduceLabel";
                        if (flags & 1 /* Unreachable */ ) return "Unreachable";
                        throw new Error();
                    }
                    function getNodeText(node) {
                        const sourceFile = getSourceFileOfNode(node);
                        return getSourceTextOfNodeFromSourceFile(sourceFile, node, /*includeTrivia*/ false);
                    }
                    function renderFlowNode(flowNode2, circular) {
                        let text = getHeader(flowNode2.flags);
                        if (circular) text = `${text}#${getDebugFlowNodeId(flowNode2)}`;
                        if (hasNode(flowNode2)) {
                            if (flowNode2.node) text += ` (${getNodeText(flowNode2.node)})`;
                        } else if (isFlowSwitchClause(flowNode2)) {
                            const clauses = [];
                            for(let i = flowNode2.clauseStart; i < flowNode2.clauseEnd; i++){
                                const clause = flowNode2.switchStatement.caseBlock.clauses[i];
                                if (isDefaultClause(clause)) clauses.push("default");
                                else clauses.push(getNodeText(clause.expression));
                            }
                            text += ` (${clauses.join(", ")})`;
                        }
                        return circular === "circularity" ? `Circular(${text})` : text;
                    }
                    function renderGraph() {
                        const columnCount = columnWidths.length;
                        const laneCount = nodes.reduce((x, n)=>Math.max(x, n.lane), 0) + 1;
                        const lanes = fill(Array(laneCount), "");
                        const grid = columnWidths.map(()=>Array(laneCount));
                        const connectors = columnWidths.map(()=>fill(Array(laneCount), 0));
                        for (const node of nodes){
                            grid[node.level][node.lane] = node;
                            const children = getChildren(node);
                            for(let i = 0; i < children.length; i++){
                                const child = children[i];
                                let connector = 8 /* Right */ ;
                                if (child.lane === node.lane) connector |= 4 /* Left */ ;
                                if (i > 0) connector |= 1 /* Up */ ;
                                if (i < children.length - 1) connector |= 2 /* Down */ ;
                                connectors[node.level][child.lane] |= connector;
                            }
                            if (children.length === 0) connectors[node.level][node.lane] |= 16 /* NoChildren */ ;
                            const parents = getParents(node);
                            for(let i = 0; i < parents.length; i++){
                                const parent2 = parents[i];
                                let connector = 4 /* Left */ ;
                                if (i > 0) connector |= 1 /* Up */ ;
                                if (i < parents.length - 1) connector |= 2 /* Down */ ;
                                connectors[node.level - 1][parent2.lane] |= connector;
                            }
                        }
                        for(let column = 0; column < columnCount; column++)for(let lane = 0; lane < laneCount; lane++){
                            const left = column > 0 ? connectors[column - 1][lane] : 0;
                            const above = lane > 0 ? connectors[column][lane - 1] : 0;
                            let connector = connectors[column][lane];
                            if (!connector) {
                                if (left & 8 /* Right */ ) connector |= 12 /* LeftRight */ ;
                                if (above & 2 /* Down */ ) connector |= 3 /* UpDown */ ;
                                connectors[column][lane] = connector;
                            }
                        }
                        for(let column = 0; column < columnCount; column++)for(let lane = 0; lane < lanes.length; lane++){
                            const connector = connectors[column][lane];
                            const fill2 = connector & 4 /* Left */  ? "─" /* lr */  : " ";
                            const node = grid[column][lane];
                            if (!node) {
                                if (column < columnCount - 1) writeLane(lane, repeat(fill2, columnWidths[column] + 1));
                            } else {
                                writeLane(lane, node.text);
                                if (column < columnCount - 1) {
                                    writeLane(lane, " ");
                                    writeLane(lane, repeat(fill2, columnWidths[column] - node.text.length));
                                }
                            }
                            writeLane(lane, getBoxCharacter(connector));
                            writeLane(lane, connector & 8 /* Right */  && column < columnCount - 1 && !grid[column + 1][lane] ? "─" /* lr */  : " ");
                        }
                        return `
${lanes.join("\n")}
`;
                        function writeLane(lane, text) {
                            lanes[lane] += text;
                        }
                    }
                    function getBoxCharacter(connector) {
                        switch(connector){
                            case 3 /* UpDown */ :
                                return "│" /* ud */ ;
                            case 12 /* LeftRight */ :
                                return "─" /* lr */ ;
                            case 5 /* UpLeft */ :
                                return "╯" /* ul */ ;
                            case 9 /* UpRight */ :
                                return "╰" /* ur */ ;
                            case 6 /* DownLeft */ :
                                return "╮" /* dl */ ;
                            case 10 /* DownRight */ :
                                return "╭" /* dr */ ;
                            case 7 /* UpDownLeft */ :
                                return "┤" /* udl */ ;
                            case 11 /* UpDownRight */ :
                                return "├" /* udr */ ;
                            case 13 /* UpLeftRight */ :
                                return "┴" /* ulr */ ;
                            case 14 /* DownLeftRight */ :
                                return "┬" /* dlr */ ;
                            case 15 /* UpDownLeftRight */ :
                                return "╫" /* udlr */ ;
                        }
                        return " ";
                    }
                    function fill(array, value1) {
                        if (array.fill) array.fill(value1);
                        else for(let i = 0; i < array.length; i++)array[i] = value1;
                        return array;
                    }
                    function repeat(ch, length2) {
                        if (ch.repeat) return length2 > 0 ? ch.repeat(length2) : "";
                        let s = "";
                        while(s.length < length2)s += ch;
                        return s;
                    }
                }
                Debug2.formatControlFlowGraph = formatControlFlowGraph;
            })(Debug || (Debug = {}));
        }
    });
    // src/compiler/semver.ts
    function tryParseComponents(text) {
        const match = versionRegExp.exec(text);
        if (!match) return void 0;
        const [, major, minor = "0", patch = "0", prerelease = "", build2 = ""] = match;
        if (prerelease && !prereleaseRegExp.test(prerelease)) return void 0;
        if (build2 && !buildRegExp.test(build2)) return void 0;
        return {
            major: parseInt(major, 10),
            minor: parseInt(minor, 10),
            patch: parseInt(patch, 10),
            prerelease: prerelease,
            build: build2
        };
    }
    function comparePrereleaseIdentifiers(left, right) {
        if (left === right) return 0 /* EqualTo */ ;
        if (left.length === 0) return right.length === 0 ? 0 /* EqualTo */  : 1 /* GreaterThan */ ;
        if (right.length === 0) return -1 /* LessThan */ ;
        const length2 = Math.min(left.length, right.length);
        for(let i = 0; i < length2; i++){
            const leftIdentifier = left[i];
            const rightIdentifier = right[i];
            if (leftIdentifier === rightIdentifier) continue;
            const leftIsNumeric = numericIdentifierRegExp.test(leftIdentifier);
            const rightIsNumeric = numericIdentifierRegExp.test(rightIdentifier);
            if (leftIsNumeric || rightIsNumeric) {
                if (leftIsNumeric !== rightIsNumeric) return leftIsNumeric ? -1 /* LessThan */  : 1 /* GreaterThan */ ;
                const result = compareValues(+leftIdentifier, +rightIdentifier);
                if (result) return result;
            } else {
                const result = compareStringsCaseSensitive(leftIdentifier, rightIdentifier);
                if (result) return result;
            }
        }
        return compareValues(left.length, right.length);
    }
    function parseRange(text) {
        const alternatives = [];
        for (let range of trimString(text).split(logicalOrRegExp)){
            if (!range) continue;
            const comparators = [];
            range = trimString(range);
            const match = hyphenRegExp.exec(range);
            if (match) {
                if (!parseHyphen(match[1], match[2], comparators)) return void 0;
            } else for (const simple of range.split(whitespaceRegExp)){
                const match2 = rangeRegExp.exec(trimString(simple));
                if (!match2 || !parseComparator(match2[1], match2[2], comparators)) return void 0;
            }
            alternatives.push(comparators);
        }
        return alternatives;
    }
    function parsePartial(text) {
        const match = partialRegExp.exec(text);
        if (!match) return void 0;
        const [, major, minor = "*", patch = "*", prerelease, build2] = match;
        const version2 = new Version(isWildcard(major) ? 0 : parseInt(major, 10), isWildcard(major) || isWildcard(minor) ? 0 : parseInt(minor, 10), isWildcard(major) || isWildcard(minor) || isWildcard(patch) ? 0 : parseInt(patch, 10), prerelease, build2);
        return {
            version: version2,
            major: major,
            minor: minor,
            patch: patch
        };
    }
    function parseHyphen(left, right, comparators) {
        const leftResult = parsePartial(left);
        if (!leftResult) return false;
        const rightResult = parsePartial(right);
        if (!rightResult) return false;
        if (!isWildcard(leftResult.major)) comparators.push(createComparator(">=", leftResult.version));
        if (!isWildcard(rightResult.major)) comparators.push(isWildcard(rightResult.minor) ? createComparator("<", rightResult.version.increment("major")) : isWildcard(rightResult.patch) ? createComparator("<", rightResult.version.increment("minor")) : createComparator("<=", rightResult.version));
        return true;
    }
    function parseComparator(operator, text, comparators) {
        const result = parsePartial(text);
        if (!result) return false;
        const { version: version2 , major: major , minor: minor , patch: patch  } = result;
        if (!isWildcard(major)) switch(operator){
            case "~":
                comparators.push(createComparator(">=", version2));
                comparators.push(createComparator("<", version2.increment(isWildcard(minor) ? "major" : "minor")));
                break;
            case "^":
                comparators.push(createComparator(">=", version2));
                comparators.push(createComparator("<", version2.increment(version2.major > 0 || isWildcard(minor) ? "major" : version2.minor > 0 || isWildcard(patch) ? "minor" : "patch")));
                break;
            case "<":
            case ">=":
                comparators.push(isWildcard(minor) || isWildcard(patch) ? createComparator(operator, version2.with({
                    prerelease: "0"
                })) : createComparator(operator, version2));
                break;
            case "<=":
            case ">":
                comparators.push(isWildcard(minor) ? createComparator(operator === "<=" ? "<" : ">=", version2.increment("major").with({
                    prerelease: "0"
                })) : isWildcard(patch) ? createComparator(operator === "<=" ? "<" : ">=", version2.increment("minor").with({
                    prerelease: "0"
                })) : createComparator(operator, version2));
                break;
            case "=":
            case void 0:
                if (isWildcard(minor) || isWildcard(patch)) {
                    comparators.push(createComparator(">=", version2.with({
                        prerelease: "0"
                    })));
                    comparators.push(createComparator("<", version2.increment(isWildcard(minor) ? "major" : "minor").with({
                        prerelease: "0"
                    })));
                } else comparators.push(createComparator("=", version2));
                break;
            default:
                return false;
        }
        else if (operator === "<" || operator === ">") comparators.push(createComparator("<", Version.zero));
        return true;
    }
    function isWildcard(part) {
        return part === "*" || part === "x" || part === "X";
    }
    function createComparator(operator, operand) {
        return {
            operator: operator,
            operand: operand
        };
    }
    function testDisjunction(version2, alternatives) {
        if (alternatives.length === 0) return true;
        for (const alternative of alternatives){
            if (testAlternative(version2, alternative)) return true;
        }
        return false;
    }
    function testAlternative(version2, comparators) {
        for (const comparator of comparators){
            if (!testComparator(version2, comparator.operator, comparator.operand)) return false;
        }
        return true;
    }
    function testComparator(version2, operator, operand) {
        const cmp = version2.compareTo(operand);
        switch(operator){
            case "<":
                return cmp < 0;
            case "<=":
                return cmp <= 0;
            case ">":
                return cmp > 0;
            case ">=":
                return cmp >= 0;
            case "=":
                return cmp === 0;
            default:
                return Debug.assertNever(operator);
        }
    }
    function formatDisjunction(alternatives) {
        return map(alternatives, formatAlternative).join(" || ") || "*";
    }
    function formatAlternative(comparators) {
        return map(comparators, formatComparator).join(" ");
    }
    function formatComparator(comparator) {
        return `${comparator.operator}${comparator.operand}`;
    }
    var versionRegExp, prereleaseRegExp, prereleasePartRegExp, buildRegExp, buildPartRegExp, numericIdentifierRegExp, _Version, Version, VersionRange, logicalOrRegExp, whitespaceRegExp, partialRegExp, hyphenRegExp, rangeRegExp;
    var init_semver = __esm({
        "src/compiler/semver.ts" () {
            "use strict";
            init_ts2();
            versionRegExp = /^(0|[1-9]\d*)(?:\.(0|[1-9]\d*)(?:\.(0|[1-9]\d*)(?:\-([a-z0-9-.]+))?(?:\+([a-z0-9-.]+))?)?)?$/i;
            prereleaseRegExp = /^(?:0|[1-9]\d*|[a-z-][a-z0-9-]*)(?:\.(?:0|[1-9]\d*|[a-z-][a-z0-9-]*))*$/i;
            prereleasePartRegExp = /^(?:0|[1-9]\d*|[a-z-][a-z0-9-]*)$/i;
            buildRegExp = /^[a-z0-9-]+(?:\.[a-z0-9-]+)*$/i;
            buildPartRegExp = /^[a-z0-9-]+$/i;
            numericIdentifierRegExp = /^(0|[1-9]\d*)$/;
            _Version = class {
                constructor(major, minor = 0, patch = 0, prerelease = "", build2 = ""){
                    if (typeof major === "string") {
                        const result = Debug.checkDefined(tryParseComponents(major), "Invalid version");
                        ({ major: major , minor: minor , patch: patch , prerelease: prerelease , build: build2  } = result);
                    }
                    Debug.assert(major >= 0, "Invalid argument: major");
                    Debug.assert(minor >= 0, "Invalid argument: minor");
                    Debug.assert(patch >= 0, "Invalid argument: patch");
                    const prereleaseArray = prerelease ? isArray(prerelease) ? prerelease : prerelease.split(".") : emptyArray;
                    const buildArray = build2 ? isArray(build2) ? build2 : build2.split(".") : emptyArray;
                    Debug.assert(every(prereleaseArray, (s)=>prereleasePartRegExp.test(s)), "Invalid argument: prerelease");
                    Debug.assert(every(buildArray, (s)=>buildPartRegExp.test(s)), "Invalid argument: build");
                    this.major = major;
                    this.minor = minor;
                    this.patch = patch;
                    this.prerelease = prereleaseArray;
                    this.build = buildArray;
                }
                static tryParse(text) {
                    const result = tryParseComponents(text);
                    if (!result) return void 0;
                    const { major: major , minor: minor , patch: patch , prerelease: prerelease , build: build2  } = result;
                    return new _Version(major, minor, patch, prerelease, build2);
                }
                compareTo(other) {
                    if (this === other) return 0 /* EqualTo */ ;
                    if (other === void 0) return 1 /* GreaterThan */ ;
                    return compareValues(this.major, other.major) || compareValues(this.minor, other.minor) || compareValues(this.patch, other.patch) || comparePrereleaseIdentifiers(this.prerelease, other.prerelease);
                }
                increment(field) {
                    switch(field){
                        case "major":
                            return new _Version(this.major + 1, 0, 0);
                        case "minor":
                            return new _Version(this.major, this.minor + 1, 0);
                        case "patch":
                            return new _Version(this.major, this.minor, this.patch + 1);
                        default:
                            return Debug.assertNever(field);
                    }
                }
                with(fields) {
                    const { major: major = this.major , minor: minor = this.minor , patch: patch = this.patch , prerelease: prerelease = this.prerelease , build: build2 = this.build  } = fields;
                    return new _Version(major, minor, patch, prerelease, build2);
                }
                toString() {
                    let result = `${this.major}.${this.minor}.${this.patch}`;
                    if (some(this.prerelease)) result += `-${this.prerelease.join(".")}`;
                    if (some(this.build)) result += `+${this.build.join(".")}`;
                    return result;
                }
            };
            Version = _Version;
            Version.zero = new _Version(0, 0, 0, [
                "0"
            ]);
            VersionRange = class {
                constructor(spec){
                    this._alternatives = spec ? Debug.checkDefined(parseRange(spec), "Invalid range spec.") : emptyArray;
                }
                static tryParse(text) {
                    const sets = parseRange(text);
                    if (sets) {
                        const range = new VersionRange("");
                        range._alternatives = sets;
                        return range;
                    }
                    return void 0;
                }
                /**
         * Tests whether a version matches the range. This is equivalent to `satisfies(version, range, { includePrerelease: true })`.
         * in `node-semver`.
         */ test(version2) {
                    if (typeof version2 === "string") version2 = new Version(version2);
                    return testDisjunction(version2, this._alternatives);
                }
                toString() {
                    return formatDisjunction(this._alternatives);
                }
            };
            logicalOrRegExp = /\|\|/g;
            whitespaceRegExp = /\s+/g;
            partialRegExp = /^([xX*0]|[1-9]\d*)(?:\.([xX*0]|[1-9]\d*)(?:\.([xX*0]|[1-9]\d*)(?:-([a-z0-9-.]+))?(?:\+([a-z0-9-.]+))?)?)?$/i;
            hyphenRegExp = /^\s*([a-z0-9-+.*]+)\s+-\s+([a-z0-9-+.*]+)\s*$/i;
            rangeRegExp = /^(~|\^|<|<=|>|>=|=)?\s*([a-z0-9-+.*]+)$/i;
        }
    });
    // src/compiler/performanceCore.ts
    function hasRequiredAPI(performance2, PerformanceObserver2) {
        return typeof performance2 === "object" && typeof performance2.timeOrigin === "number" && typeof performance2.mark === "function" && typeof performance2.measure === "function" && typeof performance2.now === "function" && typeof performance2.clearMarks === "function" && typeof performance2.clearMeasures === "function" && typeof PerformanceObserver2 === "function";
    }
    function tryGetWebPerformanceHooks() {
        if (typeof performance === "object" && typeof PerformanceObserver === "function" && hasRequiredAPI(performance, PerformanceObserver)) return {
            // For now we always write native performance events when running in the browser. We may
            // make this conditional in the future if we find that native web performance hooks
            // in the browser also slow down compilation.
            shouldWriteNativeEvents: true,
            performance: performance,
            PerformanceObserver: PerformanceObserver
        };
    }
    function tryGetNodePerformanceHooks() {
        if (isNodeLikeSystem()) try {
            const { performance: performance2 , PerformanceObserver: PerformanceObserver2  } = (parcelRequire("kjyEk"));
            if (hasRequiredAPI(performance2, PerformanceObserver2)) return {
                // By default, only write native events when generating a cpu profile or using the v8 profiler.
                shouldWriteNativeEvents: false,
                performance: performance2,
                PerformanceObserver: PerformanceObserver2
            };
        } catch  {}
    }
    function tryGetNativePerformanceHooks() {
        return nativePerformanceHooks;
    }
    var nativePerformanceHooks, nativePerformance, timestamp;
    var init_performanceCore = __esm({
        "src/compiler/performanceCore.ts" () {
            "use strict";
            init_ts2();
            nativePerformanceHooks = tryGetWebPerformanceHooks() || tryGetNodePerformanceHooks();
            nativePerformance = nativePerformanceHooks == null ? void 0 : nativePerformanceHooks.performance;
            timestamp = nativePerformance ? ()=>nativePerformance.now() : Date.now ? Date.now : ()=>+/* @__PURE__ */ new Date();
        }
    });
    // src/compiler/perfLogger.ts
    var etwModule, perfLogger;
    var init_perfLogger = __esm({
        "src/compiler/perfLogger.ts" () {
            "use strict";
            try {
                const etwModulePath = undefined ?? "./node_modules/@microsoft/typescript-etw";
                etwModule = require(etwModulePath);
            } catch (e) {
                etwModule = void 0;
            }
            perfLogger = (etwModule == null ? void 0 : etwModule.logEvent) ? etwModule : void 0;
        }
    });
    // src/compiler/performance.ts
    function createTimerIf(condition, measureName, startMarkName, endMarkName) {
        return condition ? createTimer(measureName, startMarkName, endMarkName) : nullTimer;
    }
    function createTimer(measureName, startMarkName, endMarkName) {
        let enterCount = 0;
        return {
            enter: enter,
            exit: exit
        };
        function enter() {
            if (++enterCount === 1) mark(startMarkName);
        }
        function exit() {
            if (--enterCount === 0) {
                mark(endMarkName);
                measure(measureName, startMarkName, endMarkName);
            } else if (enterCount < 0) Debug.fail("enter/exit count does not match.");
        }
    }
    function mark(markName) {
        if (enabled) {
            const count = counts.get(markName) ?? 0;
            counts.set(markName, count + 1);
            marks.set(markName, timestamp());
            performanceImpl == null || performanceImpl.mark(markName);
            if (typeof onProfilerEvent === "function") onProfilerEvent(markName);
        }
    }
    function measure(measureName, startMarkName, endMarkName) {
        if (enabled) {
            const end = (endMarkName !== void 0 ? marks.get(endMarkName) : void 0) ?? timestamp();
            const start = (startMarkName !== void 0 ? marks.get(startMarkName) : void 0) ?? timeorigin;
            const previousDuration = durations.get(measureName) || 0;
            durations.set(measureName, previousDuration + (end - start));
            performanceImpl == null || performanceImpl.measure(measureName, startMarkName, endMarkName);
        }
    }
    function getCount(markName) {
        return counts.get(markName) || 0;
    }
    function getDuration(measureName) {
        return durations.get(measureName) || 0;
    }
    function forEachMeasure(cb) {
        durations.forEach((duration, measureName)=>cb(measureName, duration));
    }
    function forEachMark(cb) {
        marks.forEach((_time, markName)=>cb(markName));
    }
    function clearMeasures(name) {
        if (name !== void 0) durations.delete(name);
        else durations.clear();
        performanceImpl == null || performanceImpl.clearMeasures(name);
    }
    function clearMarks(name) {
        if (name !== void 0) {
            counts.delete(name);
            marks.delete(name);
        } else {
            counts.clear();
            marks.clear();
        }
        performanceImpl == null || performanceImpl.clearMarks(name);
    }
    function isEnabled() {
        return enabled;
    }
    function enable(system = sys) {
        var _a;
        if (!enabled) {
            enabled = true;
            perfHooks || (perfHooks = tryGetNativePerformanceHooks());
            if (perfHooks) {
                timeorigin = perfHooks.performance.timeOrigin;
                if (perfHooks.shouldWriteNativeEvents || ((_a = system == null ? void 0 : system.cpuProfilingEnabled) == null ? void 0 : _a.call(system)) || (system == null ? void 0 : system.debugMode)) performanceImpl = perfHooks.performance;
            }
        }
        return true;
    }
    function disable() {
        if (enabled) {
            marks.clear();
            counts.clear();
            durations.clear();
            performanceImpl = void 0;
            enabled = false;
        }
    }
    var perfHooks, performanceImpl, nullTimer, enabled, timeorigin, marks, counts, durations;
    var init_performance = __esm({
        "src/compiler/performance.ts" () {
            "use strict";
            init_ts2();
            nullTimer = {
                enter: noop,
                exit: noop
            };
            enabled = false;
            timeorigin = timestamp();
            marks = /* @__PURE__ */ new Map();
            counts = /* @__PURE__ */ new Map();
            durations = /* @__PURE__ */ new Map();
        }
    });
    // src/compiler/_namespaces/ts.performance.ts
    var ts_performance_exports = {};
    __export(ts_performance_exports, {
        clearMarks: ()=>clearMarks,
        clearMeasures: ()=>clearMeasures,
        createTimer: ()=>createTimer,
        createTimerIf: ()=>createTimerIf,
        disable: ()=>disable,
        enable: ()=>enable,
        forEachMark: ()=>forEachMark,
        forEachMeasure: ()=>forEachMeasure,
        getCount: ()=>getCount,
        getDuration: ()=>getDuration,
        isEnabled: ()=>isEnabled,
        mark: ()=>mark,
        measure: ()=>measure,
        nullTimer: ()=>nullTimer
    });
    var init_ts_performance = __esm({
        "src/compiler/_namespaces/ts.performance.ts" () {
            "use strict";
            init_performance();
        }
    });
    // src/compiler/tracing.ts
    var tracing, tracingEnabled, startTracing, dumpTracingLegend;
    var init_tracing = __esm({
        "src/compiler/tracing.ts" () {
            "use strict";
            init_ts2();
            init_ts_performance();
            ((tracingEnabled2)=>{
                let fs;
                let traceCount = 0;
                let traceFd = 0;
                let mode;
                const typeCatalog = [];
                let legendPath;
                const legend = [];
                function startTracing2(tracingMode, traceDir, configFilePath) {
                    Debug.assert(!tracing, "Tracing already started");
                    if (fs === void 0) try {
                        fs = (parcelRequire("kjyEk"));
                    } catch (e) {
                        throw new Error(`tracing requires having fs
(original error: ${e.message || e})`);
                    }
                    mode = tracingMode;
                    typeCatalog.length = 0;
                    if (legendPath === void 0) legendPath = combinePaths(traceDir, "legend.json");
                    if (!fs.existsSync(traceDir)) fs.mkdirSync(traceDir, {
                        recursive: true
                    });
                    const countPart = mode === "build" ? `.${$cfae44f0dfdf62c0$exports.pid}-${++traceCount}` : mode === "server" ? `.${$cfae44f0dfdf62c0$exports.pid}` : ``;
                    const tracePath = combinePaths(traceDir, `trace${countPart}.json`);
                    const typesPath = combinePaths(traceDir, `types${countPart}.json`);
                    legend.push({
                        configFilePath: configFilePath,
                        tracePath: tracePath,
                        typesPath: typesPath
                    });
                    traceFd = fs.openSync(tracePath, "w");
                    tracing = tracingEnabled2;
                    const meta = {
                        cat: "__metadata",
                        ph: "M",
                        ts: 1e3 * timestamp(),
                        pid: 1,
                        tid: 1
                    };
                    fs.writeSync(traceFd, "[\n" + [
                        {
                            name: "process_name",
                            args: {
                                name: "tsc"
                            },
                            ...meta
                        },
                        {
                            name: "thread_name",
                            args: {
                                name: "Main"
                            },
                            ...meta
                        },
                        {
                            name: "TracingStartedInBrowser",
                            ...meta,
                            cat: "disabled-by-default-devtools.timeline"
                        }
                    ].map((v)=>JSON.stringify(v)).join(",\n"));
                }
                tracingEnabled2.startTracing = startTracing2;
                function stopTracing() {
                    Debug.assert(tracing, "Tracing is not in progress");
                    Debug.assert(!!typeCatalog.length === (mode !== "server"));
                    fs.writeSync(traceFd, `
]
`);
                    fs.closeSync(traceFd);
                    tracing = void 0;
                    if (typeCatalog.length) dumpTypes(typeCatalog);
                    else legend[legend.length - 1].typesPath = void 0;
                }
                tracingEnabled2.stopTracing = stopTracing;
                function recordType(type) {
                    if (mode !== "server") typeCatalog.push(type);
                }
                tracingEnabled2.recordType = recordType;
                let Phase;
                ((Phase2)=>{
                    Phase2["Parse"] = "parse";
                    Phase2["Program"] = "program";
                    Phase2["Bind"] = "bind";
                    Phase2["Check"] = "check";
                    Phase2["CheckTypes"] = "checkTypes";
                    Phase2["Emit"] = "emit";
                    Phase2["Session"] = "session";
                })(Phase = tracingEnabled2.Phase || (tracingEnabled2.Phase = {}));
                function instant(phase, name, args) {
                    writeEvent("I", phase, name, args, `"s":"g"`);
                }
                tracingEnabled2.instant = instant;
                const eventStack = [];
                function push(phase, name, args, separateBeginAndEnd = false) {
                    if (separateBeginAndEnd) writeEvent("B", phase, name, args);
                    eventStack.push({
                        phase: phase,
                        name: name,
                        args: args,
                        time: 1e3 * timestamp(),
                        separateBeginAndEnd: separateBeginAndEnd
                    });
                }
                tracingEnabled2.push = push;
                function pop(results) {
                    Debug.assert(eventStack.length > 0);
                    writeStackEvent(eventStack.length - 1, 1e3 * timestamp(), results);
                    eventStack.length--;
                }
                tracingEnabled2.pop = pop;
                function popAll() {
                    const endTime = 1e3 * timestamp();
                    for(let i = eventStack.length - 1; i >= 0; i--)writeStackEvent(i, endTime);
                    eventStack.length = 0;
                }
                tracingEnabled2.popAll = popAll;
                const sampleInterval = 10000;
                function writeStackEvent(index, endTime, results) {
                    const { phase: phase , name: name , args: args , time: time , separateBeginAndEnd: separateBeginAndEnd  } = eventStack[index];
                    if (separateBeginAndEnd) {
                        Debug.assert(!results, "`results` are not supported for events with `separateBeginAndEnd`");
                        writeEvent("E", phase, name, args, /*extras*/ void 0, endTime);
                    } else if (sampleInterval - time % sampleInterval <= endTime - time) writeEvent("X", phase, name, {
                        ...args,
                        results: results
                    }, `"dur":${endTime - time}`, time);
                }
                function writeEvent(eventType, phase, name, args, extras, time = 1e3 * timestamp()) {
                    if (mode === "server" && phase === "checkTypes" /* CheckTypes */ ) return;
                    mark("beginTracing");
                    fs.writeSync(traceFd, `,
{"pid":1,"tid":1,"ph":"${eventType}","cat":"${phase}","ts":${time},"name":"${name}"`);
                    if (extras) fs.writeSync(traceFd, `,${extras}`);
                    if (args) fs.writeSync(traceFd, `,"args":${JSON.stringify(args)}`);
                    fs.writeSync(traceFd, `}`);
                    mark("endTracing");
                    measure("Tracing", "beginTracing", "endTracing");
                }
                function getLocation(node) {
                    const file = getSourceFileOfNode(node);
                    return !file ? void 0 : {
                        path: file.path,
                        start: indexFromOne(getLineAndCharacterOfPosition(file, node.pos)),
                        end: indexFromOne(getLineAndCharacterOfPosition(file, node.end))
                    };
                    function indexFromOne(lc) {
                        return {
                            line: lc.line + 1,
                            character: lc.character + 1
                        };
                    }
                }
                function dumpTypes(types) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
                    mark("beginDumpTypes");
                    const typesPath = legend[legend.length - 1].typesPath;
                    const typesFd = fs.openSync(typesPath, "w");
                    const recursionIdentityMap = /* @__PURE__ */ new Map();
                    fs.writeSync(typesFd, "[");
                    const numTypes = types.length;
                    for(let i = 0; i < numTypes; i++){
                        const type = types[i];
                        const objectFlags = type.objectFlags;
                        const symbol = type.aliasSymbol ?? type.symbol;
                        let display;
                        if (objectFlags & 16 /* Anonymous */  | type.flags & 2944 /* Literal */ ) try {
                            display = (_a = type.checker) == null ? void 0 : _a.typeToString(type);
                        } catch  {
                            display = void 0;
                        }
                        let indexedAccessProperties = {};
                        if (type.flags & 8388608 /* IndexedAccess */ ) {
                            const indexedAccessType = type;
                            indexedAccessProperties = {
                                indexedAccessObjectType: (_b = indexedAccessType.objectType) == null ? void 0 : _b.id,
                                indexedAccessIndexType: (_c = indexedAccessType.indexType) == null ? void 0 : _c.id
                            };
                        }
                        let referenceProperties = {};
                        if (objectFlags & 4 /* Reference */ ) {
                            const referenceType = type;
                            referenceProperties = {
                                instantiatedType: (_d = referenceType.target) == null ? void 0 : _d.id,
                                typeArguments: (_e = referenceType.resolvedTypeArguments) == null ? void 0 : _e.map((t)=>t.id),
                                referenceLocation: getLocation(referenceType.node)
                            };
                        }
                        let conditionalProperties = {};
                        if (type.flags & 16777216 /* Conditional */ ) {
                            const conditionalType = type;
                            conditionalProperties = {
                                conditionalCheckType: (_f = conditionalType.checkType) == null ? void 0 : _f.id,
                                conditionalExtendsType: (_g = conditionalType.extendsType) == null ? void 0 : _g.id,
                                conditionalTrueType: ((_h = conditionalType.resolvedTrueType) == null ? void 0 : _h.id) ?? -1,
                                conditionalFalseType: ((_i = conditionalType.resolvedFalseType) == null ? void 0 : _i.id) ?? -1
                            };
                        }
                        let substitutionProperties = {};
                        if (type.flags & 33554432 /* Substitution */ ) {
                            const substitutionType = type;
                            substitutionProperties = {
                                substitutionBaseType: (_j = substitutionType.baseType) == null ? void 0 : _j.id,
                                constraintType: (_k = substitutionType.constraint) == null ? void 0 : _k.id
                            };
                        }
                        let reverseMappedProperties = {};
                        if (objectFlags & 1024 /* ReverseMapped */ ) {
                            const reverseMappedType = type;
                            reverseMappedProperties = {
                                reverseMappedSourceType: (_l = reverseMappedType.source) == null ? void 0 : _l.id,
                                reverseMappedMappedType: (_m = reverseMappedType.mappedType) == null ? void 0 : _m.id,
                                reverseMappedConstraintType: (_n = reverseMappedType.constraintType) == null ? void 0 : _n.id
                            };
                        }
                        let evolvingArrayProperties = {};
                        if (objectFlags & 256 /* EvolvingArray */ ) {
                            const evolvingArrayType = type;
                            evolvingArrayProperties = {
                                evolvingArrayElementType: evolvingArrayType.elementType.id,
                                evolvingArrayFinalType: (_o = evolvingArrayType.finalArrayType) == null ? void 0 : _o.id
                            };
                        }
                        let recursionToken;
                        const recursionIdentity = type.checker.getRecursionIdentity(type);
                        if (recursionIdentity) {
                            recursionToken = recursionIdentityMap.get(recursionIdentity);
                            if (!recursionToken) {
                                recursionToken = recursionIdentityMap.size;
                                recursionIdentityMap.set(recursionIdentity, recursionToken);
                            }
                        }
                        const descriptor = {
                            id: type.id,
                            intrinsicName: type.intrinsicName,
                            symbolName: (symbol == null ? void 0 : symbol.escapedName) && unescapeLeadingUnderscores(symbol.escapedName),
                            recursionId: recursionToken,
                            isTuple: objectFlags & 8 /* Tuple */  ? true : void 0,
                            unionTypes: type.flags & 1048576 /* Union */  ? (_p = type.types) == null ? void 0 : _p.map((t)=>t.id) : void 0,
                            intersectionTypes: type.flags & 2097152 /* Intersection */  ? type.types.map((t)=>t.id) : void 0,
                            aliasTypeArguments: (_q = type.aliasTypeArguments) == null ? void 0 : _q.map((t)=>t.id),
                            keyofType: type.flags & 4194304 /* Index */  ? (_r = type.type) == null ? void 0 : _r.id : void 0,
                            ...indexedAccessProperties,
                            ...referenceProperties,
                            ...conditionalProperties,
                            ...substitutionProperties,
                            ...reverseMappedProperties,
                            ...evolvingArrayProperties,
                            destructuringPattern: getLocation(type.pattern),
                            firstDeclaration: getLocation((_s = symbol == null ? void 0 : symbol.declarations) == null ? void 0 : _s[0]),
                            flags: Debug.formatTypeFlags(type.flags).split("|"),
                            display: display
                        };
                        fs.writeSync(typesFd, JSON.stringify(descriptor));
                        if (i < numTypes - 1) fs.writeSync(typesFd, ",\n");
                    }
                    fs.writeSync(typesFd, "]\n");
                    fs.closeSync(typesFd);
                    mark("endDumpTypes");
                    measure("Dump types", "beginDumpTypes", "endDumpTypes");
                }
                function dumpLegend() {
                    if (!legendPath) return;
                    fs.writeFileSync(legendPath, JSON.stringify(legend));
                }
                tracingEnabled2.dumpLegend = dumpLegend;
            })(tracingEnabled || (tracingEnabled = {}));
            startTracing = tracingEnabled.startTracing;
            dumpTracingLegend = tracingEnabled.dumpLegend;
        }
    });
    // src/compiler/types.ts
    function diagnosticCategoryName(d, lowerCase = true) {
        const name = DiagnosticCategory[d.category];
        return lowerCase ? name.toLowerCase() : name;
    }
    var SyntaxKind, NodeFlags, ModifierFlags, JsxFlags, RelationComparisonResult, GeneratedIdentifierFlags, TokenFlags, FlowFlags, CommentDirectiveType, OperationCanceledException, FileIncludeKind, FilePreprocessingDiagnosticsKind, EmitOnly, StructureIsReused, ExitStatus, MemberOverrideStatus, UnionReduction, ContextFlags, NodeBuilderFlags, TypeFormatFlags, SymbolFormatFlags, SymbolAccessibility, SyntheticSymbolKind, TypePredicateKind, TypeReferenceSerializationKind, SymbolFlags, EnumKind, CheckFlags, InternalSymbolName, NodeCheckFlags, TypeFlags, ObjectFlags, VarianceFlags, ElementFlags, AccessFlags, IndexFlags, JsxReferenceKind, SignatureKind, SignatureFlags, IndexKind, TypeMapKind, InferencePriority, InferenceFlags, Ternary, AssignmentDeclarationKind, DiagnosticCategory, ModuleResolutionKind, ModuleDetectionKind, WatchFileKind, WatchDirectoryKind, PollingWatchKind, ModuleKind, JsxEmit, ImportsNotUsedAsValues, NewLineKind, ScriptKind, ScriptTarget, LanguageVariant, WatchDirectoryFlags, CharacterCodes, Extension, TransformFlags, SnippetKind, EmitFlags, InternalEmitFlags, ExternalEmitHelpers, EmitHint, OuterExpressionKinds, LexicalEnvironmentFlags, BundleFileSectionKind, ListFormat, PragmaKindFlags, commentPragmas;
    var init_types = __esm({
        "src/compiler/types.ts" () {
            "use strict";
            SyntaxKind = /* @__PURE__ */ ((SyntaxKind5)=>{
                SyntaxKind5[SyntaxKind5["Unknown"] = 0] = "Unknown";
                SyntaxKind5[SyntaxKind5["EndOfFileToken"] = 1] = "EndOfFileToken";
                SyntaxKind5[SyntaxKind5["SingleLineCommentTrivia"] = 2] = "SingleLineCommentTrivia";
                SyntaxKind5[SyntaxKind5["MultiLineCommentTrivia"] = 3] = "MultiLineCommentTrivia";
                SyntaxKind5[SyntaxKind5["NewLineTrivia"] = 4] = "NewLineTrivia";
                SyntaxKind5[SyntaxKind5["WhitespaceTrivia"] = 5] = "WhitespaceTrivia";
                SyntaxKind5[SyntaxKind5["ShebangTrivia"] = 6] = "ShebangTrivia";
                SyntaxKind5[SyntaxKind5["ConflictMarkerTrivia"] = 7] = "ConflictMarkerTrivia";
                SyntaxKind5[SyntaxKind5["NonTextFileMarkerTrivia"] = 8] = "NonTextFileMarkerTrivia";
                SyntaxKind5[SyntaxKind5["NumericLiteral"] = 9] = "NumericLiteral";
                SyntaxKind5[SyntaxKind5["BigIntLiteral"] = 10] = "BigIntLiteral";
                SyntaxKind5[SyntaxKind5["StringLiteral"] = 11] = "StringLiteral";
                SyntaxKind5[SyntaxKind5["JsxText"] = 12] = "JsxText";
                SyntaxKind5[SyntaxKind5["JsxTextAllWhiteSpaces"] = 13] = "JsxTextAllWhiteSpaces";
                SyntaxKind5[SyntaxKind5["RegularExpressionLiteral"] = 14] = "RegularExpressionLiteral";
                SyntaxKind5[SyntaxKind5["NoSubstitutionTemplateLiteral"] = 15] = "NoSubstitutionTemplateLiteral";
                SyntaxKind5[SyntaxKind5["TemplateHead"] = 16] = "TemplateHead";
                SyntaxKind5[SyntaxKind5["TemplateMiddle"] = 17] = "TemplateMiddle";
                SyntaxKind5[SyntaxKind5["TemplateTail"] = 18] = "TemplateTail";
                SyntaxKind5[SyntaxKind5["OpenBraceToken"] = 19] = "OpenBraceToken";
                SyntaxKind5[SyntaxKind5["CloseBraceToken"] = 20] = "CloseBraceToken";
                SyntaxKind5[SyntaxKind5["OpenParenToken"] = 21] = "OpenParenToken";
                SyntaxKind5[SyntaxKind5["CloseParenToken"] = 22] = "CloseParenToken";
                SyntaxKind5[SyntaxKind5["OpenBracketToken"] = 23] = "OpenBracketToken";
                SyntaxKind5[SyntaxKind5["CloseBracketToken"] = 24] = "CloseBracketToken";
                SyntaxKind5[SyntaxKind5["DotToken"] = 25] = "DotToken";
                SyntaxKind5[SyntaxKind5["DotDotDotToken"] = 26] = "DotDotDotToken";
                SyntaxKind5[SyntaxKind5["SemicolonToken"] = 27] = "SemicolonToken";
                SyntaxKind5[SyntaxKind5["CommaToken"] = 28] = "CommaToken";
                SyntaxKind5[SyntaxKind5["QuestionDotToken"] = 29] = "QuestionDotToken";
                SyntaxKind5[SyntaxKind5["LessThanToken"] = 30] = "LessThanToken";
                SyntaxKind5[SyntaxKind5["LessThanSlashToken"] = 31] = "LessThanSlashToken";
                SyntaxKind5[SyntaxKind5["GreaterThanToken"] = 32] = "GreaterThanToken";
                SyntaxKind5[SyntaxKind5["LessThanEqualsToken"] = 33] = "LessThanEqualsToken";
                SyntaxKind5[SyntaxKind5["GreaterThanEqualsToken"] = 34] = "GreaterThanEqualsToken";
                SyntaxKind5[SyntaxKind5["EqualsEqualsToken"] = 35] = "EqualsEqualsToken";
                SyntaxKind5[SyntaxKind5["ExclamationEqualsToken"] = 36] = "ExclamationEqualsToken";
                SyntaxKind5[SyntaxKind5["EqualsEqualsEqualsToken"] = 37] = "EqualsEqualsEqualsToken";
                SyntaxKind5[SyntaxKind5["ExclamationEqualsEqualsToken"] = 38] = "ExclamationEqualsEqualsToken";
                SyntaxKind5[SyntaxKind5["EqualsGreaterThanToken"] = 39] = "EqualsGreaterThanToken";
                SyntaxKind5[SyntaxKind5["PlusToken"] = 40] = "PlusToken";
                SyntaxKind5[SyntaxKind5["MinusToken"] = 41] = "MinusToken";
                SyntaxKind5[SyntaxKind5["AsteriskToken"] = 42] = "AsteriskToken";
                SyntaxKind5[SyntaxKind5["AsteriskAsteriskToken"] = 43] = "AsteriskAsteriskToken";
                SyntaxKind5[SyntaxKind5["SlashToken"] = 44] = "SlashToken";
                SyntaxKind5[SyntaxKind5["PercentToken"] = 45] = "PercentToken";
                SyntaxKind5[SyntaxKind5["PlusPlusToken"] = 46] = "PlusPlusToken";
                SyntaxKind5[SyntaxKind5["MinusMinusToken"] = 47] = "MinusMinusToken";
                SyntaxKind5[SyntaxKind5["LessThanLessThanToken"] = 48] = "LessThanLessThanToken";
                SyntaxKind5[SyntaxKind5["GreaterThanGreaterThanToken"] = 49] = "GreaterThanGreaterThanToken";
                SyntaxKind5[SyntaxKind5["GreaterThanGreaterThanGreaterThanToken"] = 50] = "GreaterThanGreaterThanGreaterThanToken";
                SyntaxKind5[SyntaxKind5["AmpersandToken"] = 51] = "AmpersandToken";
                SyntaxKind5[SyntaxKind5["BarToken"] = 52] = "BarToken";
                SyntaxKind5[SyntaxKind5["CaretToken"] = 53] = "CaretToken";
                SyntaxKind5[SyntaxKind5["ExclamationToken"] = 54] = "ExclamationToken";
                SyntaxKind5[SyntaxKind5["TildeToken"] = 55] = "TildeToken";
                SyntaxKind5[SyntaxKind5["AmpersandAmpersandToken"] = 56] = "AmpersandAmpersandToken";
                SyntaxKind5[SyntaxKind5["BarBarToken"] = 57] = "BarBarToken";
                SyntaxKind5[SyntaxKind5["QuestionToken"] = 58] = "QuestionToken";
                SyntaxKind5[SyntaxKind5["ColonToken"] = 59] = "ColonToken";
                SyntaxKind5[SyntaxKind5["AtToken"] = 60] = "AtToken";
                SyntaxKind5[SyntaxKind5["QuestionQuestionToken"] = 61] = "QuestionQuestionToken";
                SyntaxKind5[SyntaxKind5["BacktickToken"] = 62] = "BacktickToken";
                SyntaxKind5[SyntaxKind5["HashToken"] = 63] = "HashToken";
                SyntaxKind5[SyntaxKind5["EqualsToken"] = 64] = "EqualsToken";
                SyntaxKind5[SyntaxKind5["PlusEqualsToken"] = 65] = "PlusEqualsToken";
                SyntaxKind5[SyntaxKind5["MinusEqualsToken"] = 66] = "MinusEqualsToken";
                SyntaxKind5[SyntaxKind5["AsteriskEqualsToken"] = 67] = "AsteriskEqualsToken";
                SyntaxKind5[SyntaxKind5["AsteriskAsteriskEqualsToken"] = 68] = "AsteriskAsteriskEqualsToken";
                SyntaxKind5[SyntaxKind5["SlashEqualsToken"] = 69] = "SlashEqualsToken";
                SyntaxKind5[SyntaxKind5["PercentEqualsToken"] = 70] = "PercentEqualsToken";
                SyntaxKind5[SyntaxKind5["LessThanLessThanEqualsToken"] = 71] = "LessThanLessThanEqualsToken";
                SyntaxKind5[SyntaxKind5["GreaterThanGreaterThanEqualsToken"] = 72] = "GreaterThanGreaterThanEqualsToken";
                SyntaxKind5[SyntaxKind5["GreaterThanGreaterThanGreaterThanEqualsToken"] = 73] = "GreaterThanGreaterThanGreaterThanEqualsToken";
                SyntaxKind5[SyntaxKind5["AmpersandEqualsToken"] = 74] = "AmpersandEqualsToken";
                SyntaxKind5[SyntaxKind5["BarEqualsToken"] = 75] = "BarEqualsToken";
                SyntaxKind5[SyntaxKind5["BarBarEqualsToken"] = 76] = "BarBarEqualsToken";
                SyntaxKind5[SyntaxKind5["AmpersandAmpersandEqualsToken"] = 77] = "AmpersandAmpersandEqualsToken";
                SyntaxKind5[SyntaxKind5["QuestionQuestionEqualsToken"] = 78] = "QuestionQuestionEqualsToken";
                SyntaxKind5[SyntaxKind5["CaretEqualsToken"] = 79] = "CaretEqualsToken";
                SyntaxKind5[SyntaxKind5["Identifier"] = 80] = "Identifier";
                SyntaxKind5[SyntaxKind5["PrivateIdentifier"] = 81] = "PrivateIdentifier";
                SyntaxKind5[SyntaxKind5["JSDocCommentTextToken"] = 82] = "JSDocCommentTextToken";
                SyntaxKind5[SyntaxKind5["BreakKeyword"] = 83] = "BreakKeyword";
                SyntaxKind5[SyntaxKind5["CaseKeyword"] = 84] = "CaseKeyword";
                SyntaxKind5[SyntaxKind5["CatchKeyword"] = 85] = "CatchKeyword";
                SyntaxKind5[SyntaxKind5["ClassKeyword"] = 86] = "ClassKeyword";
                SyntaxKind5[SyntaxKind5["ConstKeyword"] = 87] = "ConstKeyword";
                SyntaxKind5[SyntaxKind5["ContinueKeyword"] = 88] = "ContinueKeyword";
                SyntaxKind5[SyntaxKind5["DebuggerKeyword"] = 89] = "DebuggerKeyword";
                SyntaxKind5[SyntaxKind5["DefaultKeyword"] = 90] = "DefaultKeyword";
                SyntaxKind5[SyntaxKind5["DeleteKeyword"] = 91] = "DeleteKeyword";
                SyntaxKind5[SyntaxKind5["DoKeyword"] = 92] = "DoKeyword";
                SyntaxKind5[SyntaxKind5["ElseKeyword"] = 93] = "ElseKeyword";
                SyntaxKind5[SyntaxKind5["EnumKeyword"] = 94] = "EnumKeyword";
                SyntaxKind5[SyntaxKind5["ExportKeyword"] = 95] = "ExportKeyword";
                SyntaxKind5[SyntaxKind5["ExtendsKeyword"] = 96] = "ExtendsKeyword";
                SyntaxKind5[SyntaxKind5["FalseKeyword"] = 97] = "FalseKeyword";
                SyntaxKind5[SyntaxKind5["FinallyKeyword"] = 98] = "FinallyKeyword";
                SyntaxKind5[SyntaxKind5["ForKeyword"] = 99] = "ForKeyword";
                SyntaxKind5[SyntaxKind5["FunctionKeyword"] = 100] = "FunctionKeyword";
                SyntaxKind5[SyntaxKind5["IfKeyword"] = 101] = "IfKeyword";
                SyntaxKind5[SyntaxKind5["ImportKeyword"] = 102] = "ImportKeyword";
                SyntaxKind5[SyntaxKind5["InKeyword"] = 103] = "InKeyword";
                SyntaxKind5[SyntaxKind5["InstanceOfKeyword"] = 104] = "InstanceOfKeyword";
                SyntaxKind5[SyntaxKind5["NewKeyword"] = 105] = "NewKeyword";
                SyntaxKind5[SyntaxKind5["NullKeyword"] = 106] = "NullKeyword";
                SyntaxKind5[SyntaxKind5["ReturnKeyword"] = 107] = "ReturnKeyword";
                SyntaxKind5[SyntaxKind5["SuperKeyword"] = 108] = "SuperKeyword";
                SyntaxKind5[SyntaxKind5["SwitchKeyword"] = 109] = "SwitchKeyword";
                SyntaxKind5[SyntaxKind5["ThisKeyword"] = 110] = "ThisKeyword";
                SyntaxKind5[SyntaxKind5["ThrowKeyword"] = 111] = "ThrowKeyword";
                SyntaxKind5[SyntaxKind5["TrueKeyword"] = 112] = "TrueKeyword";
                SyntaxKind5[SyntaxKind5["TryKeyword"] = 113] = "TryKeyword";
                SyntaxKind5[SyntaxKind5["TypeOfKeyword"] = 114] = "TypeOfKeyword";
                SyntaxKind5[SyntaxKind5["VarKeyword"] = 115] = "VarKeyword";
                SyntaxKind5[SyntaxKind5["VoidKeyword"] = 116] = "VoidKeyword";
                SyntaxKind5[SyntaxKind5["WhileKeyword"] = 117] = "WhileKeyword";
                SyntaxKind5[SyntaxKind5["WithKeyword"] = 118] = "WithKeyword";
                SyntaxKind5[SyntaxKind5["ImplementsKeyword"] = 119] = "ImplementsKeyword";
                SyntaxKind5[SyntaxKind5["InterfaceKeyword"] = 120] = "InterfaceKeyword";
                SyntaxKind5[SyntaxKind5["LetKeyword"] = 121] = "LetKeyword";
                SyntaxKind5[SyntaxKind5["PackageKeyword"] = 122] = "PackageKeyword";
                SyntaxKind5[SyntaxKind5["PrivateKeyword"] = 123] = "PrivateKeyword";
                SyntaxKind5[SyntaxKind5["ProtectedKeyword"] = 124] = "ProtectedKeyword";
                SyntaxKind5[SyntaxKind5["PublicKeyword"] = 125] = "PublicKeyword";
                SyntaxKind5[SyntaxKind5["StaticKeyword"] = 126] = "StaticKeyword";
                SyntaxKind5[SyntaxKind5["YieldKeyword"] = 127] = "YieldKeyword";
                SyntaxKind5[SyntaxKind5["AbstractKeyword"] = 128] = "AbstractKeyword";
                SyntaxKind5[SyntaxKind5["AccessorKeyword"] = 129] = "AccessorKeyword";
                SyntaxKind5[SyntaxKind5["AsKeyword"] = 130] = "AsKeyword";
                SyntaxKind5[SyntaxKind5["AssertsKeyword"] = 131] = "AssertsKeyword";
                SyntaxKind5[SyntaxKind5["AssertKeyword"] = 132] = "AssertKeyword";
                SyntaxKind5[SyntaxKind5["AnyKeyword"] = 133] = "AnyKeyword";
                SyntaxKind5[SyntaxKind5["AsyncKeyword"] = 134] = "AsyncKeyword";
                SyntaxKind5[SyntaxKind5["AwaitKeyword"] = 135] = "AwaitKeyword";
                SyntaxKind5[SyntaxKind5["BooleanKeyword"] = 136] = "BooleanKeyword";
                SyntaxKind5[SyntaxKind5["ConstructorKeyword"] = 137] = "ConstructorKeyword";
                SyntaxKind5[SyntaxKind5["DeclareKeyword"] = 138] = "DeclareKeyword";
                SyntaxKind5[SyntaxKind5["GetKeyword"] = 139] = "GetKeyword";
                SyntaxKind5[SyntaxKind5["InferKeyword"] = 140] = "InferKeyword";
                SyntaxKind5[SyntaxKind5["IntrinsicKeyword"] = 141] = "IntrinsicKeyword";
                SyntaxKind5[SyntaxKind5["IsKeyword"] = 142] = "IsKeyword";
                SyntaxKind5[SyntaxKind5["KeyOfKeyword"] = 143] = "KeyOfKeyword";
                SyntaxKind5[SyntaxKind5["ModuleKeyword"] = 144] = "ModuleKeyword";
                SyntaxKind5[SyntaxKind5["NamespaceKeyword"] = 145] = "NamespaceKeyword";
                SyntaxKind5[SyntaxKind5["NeverKeyword"] = 146] = "NeverKeyword";
                SyntaxKind5[SyntaxKind5["OutKeyword"] = 147] = "OutKeyword";
                SyntaxKind5[SyntaxKind5["ReadonlyKeyword"] = 148] = "ReadonlyKeyword";
                SyntaxKind5[SyntaxKind5["RequireKeyword"] = 149] = "RequireKeyword";
                SyntaxKind5[SyntaxKind5["NumberKeyword"] = 150] = "NumberKeyword";
                SyntaxKind5[SyntaxKind5["ObjectKeyword"] = 151] = "ObjectKeyword";
                SyntaxKind5[SyntaxKind5["SatisfiesKeyword"] = 152] = "SatisfiesKeyword";
                SyntaxKind5[SyntaxKind5["SetKeyword"] = 153] = "SetKeyword";
                SyntaxKind5[SyntaxKind5["StringKeyword"] = 154] = "StringKeyword";
                SyntaxKind5[SyntaxKind5["SymbolKeyword"] = 155] = "SymbolKeyword";
                SyntaxKind5[SyntaxKind5["TypeKeyword"] = 156] = "TypeKeyword";
                SyntaxKind5[SyntaxKind5["UndefinedKeyword"] = 157] = "UndefinedKeyword";
                SyntaxKind5[SyntaxKind5["UniqueKeyword"] = 158] = "UniqueKeyword";
                SyntaxKind5[SyntaxKind5["UnknownKeyword"] = 159] = "UnknownKeyword";
                SyntaxKind5[SyntaxKind5["FromKeyword"] = 160] = "FromKeyword";
                SyntaxKind5[SyntaxKind5["GlobalKeyword"] = 161] = "GlobalKeyword";
                SyntaxKind5[SyntaxKind5["BigIntKeyword"] = 162] = "BigIntKeyword";
                SyntaxKind5[SyntaxKind5["OverrideKeyword"] = 163] = "OverrideKeyword";
                SyntaxKind5[SyntaxKind5["OfKeyword"] = 164] = "OfKeyword";
                SyntaxKind5[SyntaxKind5["QualifiedName"] = 165] = "QualifiedName";
                SyntaxKind5[SyntaxKind5["ComputedPropertyName"] = 166] = "ComputedPropertyName";
                SyntaxKind5[SyntaxKind5["TypeParameter"] = 167] = "TypeParameter";
                SyntaxKind5[SyntaxKind5["Parameter"] = 168] = "Parameter";
                SyntaxKind5[SyntaxKind5["Decorator"] = 169] = "Decorator";
                SyntaxKind5[SyntaxKind5["PropertySignature"] = 170] = "PropertySignature";
                SyntaxKind5[SyntaxKind5["PropertyDeclaration"] = 171] = "PropertyDeclaration";
                SyntaxKind5[SyntaxKind5["MethodSignature"] = 172] = "MethodSignature";
                SyntaxKind5[SyntaxKind5["MethodDeclaration"] = 173] = "MethodDeclaration";
                SyntaxKind5[SyntaxKind5["ClassStaticBlockDeclaration"] = 174] = "ClassStaticBlockDeclaration";
                SyntaxKind5[SyntaxKind5["Constructor"] = 175] = "Constructor";
                SyntaxKind5[SyntaxKind5["GetAccessor"] = 176] = "GetAccessor";
                SyntaxKind5[SyntaxKind5["SetAccessor"] = 177] = "SetAccessor";
                SyntaxKind5[SyntaxKind5["CallSignature"] = 178] = "CallSignature";
                SyntaxKind5[SyntaxKind5["ConstructSignature"] = 179] = "ConstructSignature";
                SyntaxKind5[SyntaxKind5["IndexSignature"] = 180] = "IndexSignature";
                SyntaxKind5[SyntaxKind5["TypePredicate"] = 181] = "TypePredicate";
                SyntaxKind5[SyntaxKind5["TypeReference"] = 182] = "TypeReference";
                SyntaxKind5[SyntaxKind5["FunctionType"] = 183] = "FunctionType";
                SyntaxKind5[SyntaxKind5["ConstructorType"] = 184] = "ConstructorType";
                SyntaxKind5[SyntaxKind5["TypeQuery"] = 185] = "TypeQuery";
                SyntaxKind5[SyntaxKind5["TypeLiteral"] = 186] = "TypeLiteral";
                SyntaxKind5[SyntaxKind5["ArrayType"] = 187] = "ArrayType";
                SyntaxKind5[SyntaxKind5["TupleType"] = 188] = "TupleType";
                SyntaxKind5[SyntaxKind5["OptionalType"] = 189] = "OptionalType";
                SyntaxKind5[SyntaxKind5["RestType"] = 190] = "RestType";
                SyntaxKind5[SyntaxKind5["UnionType"] = 191] = "UnionType";
                SyntaxKind5[SyntaxKind5["IntersectionType"] = 192] = "IntersectionType";
                SyntaxKind5[SyntaxKind5["ConditionalType"] = 193] = "ConditionalType";
                SyntaxKind5[SyntaxKind5["InferType"] = 194] = "InferType";
                SyntaxKind5[SyntaxKind5["ParenthesizedType"] = 195] = "ParenthesizedType";
                SyntaxKind5[SyntaxKind5["ThisType"] = 196] = "ThisType";
                SyntaxKind5[SyntaxKind5["TypeOperator"] = 197] = "TypeOperator";
                SyntaxKind5[SyntaxKind5["IndexedAccessType"] = 198] = "IndexedAccessType";
                SyntaxKind5[SyntaxKind5["MappedType"] = 199] = "MappedType";
                SyntaxKind5[SyntaxKind5["LiteralType"] = 200] = "LiteralType";
                SyntaxKind5[SyntaxKind5["NamedTupleMember"] = 201] = "NamedTupleMember";
                SyntaxKind5[SyntaxKind5["TemplateLiteralType"] = 202] = "TemplateLiteralType";
                SyntaxKind5[SyntaxKind5["TemplateLiteralTypeSpan"] = 203] = "TemplateLiteralTypeSpan";
                SyntaxKind5[SyntaxKind5["ImportType"] = 204] = "ImportType";
                SyntaxKind5[SyntaxKind5["ObjectBindingPattern"] = 205] = "ObjectBindingPattern";
                SyntaxKind5[SyntaxKind5["ArrayBindingPattern"] = 206] = "ArrayBindingPattern";
                SyntaxKind5[SyntaxKind5["BindingElement"] = 207] = "BindingElement";
                SyntaxKind5[SyntaxKind5["ArrayLiteralExpression"] = 208] = "ArrayLiteralExpression";
                SyntaxKind5[SyntaxKind5["ObjectLiteralExpression"] = 209] = "ObjectLiteralExpression";
                SyntaxKind5[SyntaxKind5["PropertyAccessExpression"] = 210] = "PropertyAccessExpression";
                SyntaxKind5[SyntaxKind5["ElementAccessExpression"] = 211] = "ElementAccessExpression";
                SyntaxKind5[SyntaxKind5["CallExpression"] = 212] = "CallExpression";
                SyntaxKind5[SyntaxKind5["NewExpression"] = 213] = "NewExpression";
                SyntaxKind5[SyntaxKind5["TaggedTemplateExpression"] = 214] = "TaggedTemplateExpression";
                SyntaxKind5[SyntaxKind5["TypeAssertionExpression"] = 215] = "TypeAssertionExpression";
                SyntaxKind5[SyntaxKind5["ParenthesizedExpression"] = 216] = "ParenthesizedExpression";
                SyntaxKind5[SyntaxKind5["FunctionExpression"] = 217] = "FunctionExpression";
                SyntaxKind5[SyntaxKind5["ArrowFunction"] = 218] = "ArrowFunction";
                SyntaxKind5[SyntaxKind5["DeleteExpression"] = 219] = "DeleteExpression";
                SyntaxKind5[SyntaxKind5["TypeOfExpression"] = 220] = "TypeOfExpression";
                SyntaxKind5[SyntaxKind5["VoidExpression"] = 221] = "VoidExpression";
                SyntaxKind5[SyntaxKind5["AwaitExpression"] = 222] = "AwaitExpression";
                SyntaxKind5[SyntaxKind5["PrefixUnaryExpression"] = 223] = "PrefixUnaryExpression";
                SyntaxKind5[SyntaxKind5["PostfixUnaryExpression"] = 224] = "PostfixUnaryExpression";
                SyntaxKind5[SyntaxKind5["BinaryExpression"] = 225] = "BinaryExpression";
                SyntaxKind5[SyntaxKind5["ConditionalExpression"] = 226] = "ConditionalExpression";
                SyntaxKind5[SyntaxKind5["TemplateExpression"] = 227] = "TemplateExpression";
                SyntaxKind5[SyntaxKind5["YieldExpression"] = 228] = "YieldExpression";
                SyntaxKind5[SyntaxKind5["SpreadElement"] = 229] = "SpreadElement";
                SyntaxKind5[SyntaxKind5["ClassExpression"] = 230] = "ClassExpression";
                SyntaxKind5[SyntaxKind5["OmittedExpression"] = 231] = "OmittedExpression";
                SyntaxKind5[SyntaxKind5["ExpressionWithTypeArguments"] = 232] = "ExpressionWithTypeArguments";
                SyntaxKind5[SyntaxKind5["AsExpression"] = 233] = "AsExpression";
                SyntaxKind5[SyntaxKind5["NonNullExpression"] = 234] = "NonNullExpression";
                SyntaxKind5[SyntaxKind5["MetaProperty"] = 235] = "MetaProperty";
                SyntaxKind5[SyntaxKind5["SyntheticExpression"] = 236] = "SyntheticExpression";
                SyntaxKind5[SyntaxKind5["SatisfiesExpression"] = 237] = "SatisfiesExpression";
                SyntaxKind5[SyntaxKind5["TemplateSpan"] = 238] = "TemplateSpan";
                SyntaxKind5[SyntaxKind5["SemicolonClassElement"] = 239] = "SemicolonClassElement";
                SyntaxKind5[SyntaxKind5["Block"] = 240] = "Block";
                SyntaxKind5[SyntaxKind5["EmptyStatement"] = 241] = "EmptyStatement";
                SyntaxKind5[SyntaxKind5["VariableStatement"] = 242] = "VariableStatement";
                SyntaxKind5[SyntaxKind5["ExpressionStatement"] = 243] = "ExpressionStatement";
                SyntaxKind5[SyntaxKind5["IfStatement"] = 244] = "IfStatement";
                SyntaxKind5[SyntaxKind5["DoStatement"] = 245] = "DoStatement";
                SyntaxKind5[SyntaxKind5["WhileStatement"] = 246] = "WhileStatement";
                SyntaxKind5[SyntaxKind5["ForStatement"] = 247] = "ForStatement";
                SyntaxKind5[SyntaxKind5["ForInStatement"] = 248] = "ForInStatement";
                SyntaxKind5[SyntaxKind5["ForOfStatement"] = 249] = "ForOfStatement";
                SyntaxKind5[SyntaxKind5["ContinueStatement"] = 250] = "ContinueStatement";
                SyntaxKind5[SyntaxKind5["BreakStatement"] = 251] = "BreakStatement";
                SyntaxKind5[SyntaxKind5["ReturnStatement"] = 252] = "ReturnStatement";
                SyntaxKind5[SyntaxKind5["WithStatement"] = 253] = "WithStatement";
                SyntaxKind5[SyntaxKind5["SwitchStatement"] = 254] = "SwitchStatement";
                SyntaxKind5[SyntaxKind5["LabeledStatement"] = 255] = "LabeledStatement";
                SyntaxKind5[SyntaxKind5["ThrowStatement"] = 256] = "ThrowStatement";
                SyntaxKind5[SyntaxKind5["TryStatement"] = 257] = "TryStatement";
                SyntaxKind5[SyntaxKind5["DebuggerStatement"] = 258] = "DebuggerStatement";
                SyntaxKind5[SyntaxKind5["VariableDeclaration"] = 259] = "VariableDeclaration";
                SyntaxKind5[SyntaxKind5["VariableDeclarationList"] = 260] = "VariableDeclarationList";
                SyntaxKind5[SyntaxKind5["FunctionDeclaration"] = 261] = "FunctionDeclaration";
                SyntaxKind5[SyntaxKind5["ClassDeclaration"] = 262] = "ClassDeclaration";
                SyntaxKind5[SyntaxKind5["InterfaceDeclaration"] = 263] = "InterfaceDeclaration";
                SyntaxKind5[SyntaxKind5["TypeAliasDeclaration"] = 264] = "TypeAliasDeclaration";
                SyntaxKind5[SyntaxKind5["EnumDeclaration"] = 265] = "EnumDeclaration";
                SyntaxKind5[SyntaxKind5["ModuleDeclaration"] = 266] = "ModuleDeclaration";
                SyntaxKind5[SyntaxKind5["ModuleBlock"] = 267] = "ModuleBlock";
                SyntaxKind5[SyntaxKind5["CaseBlock"] = 268] = "CaseBlock";
                SyntaxKind5[SyntaxKind5["NamespaceExportDeclaration"] = 269] = "NamespaceExportDeclaration";
                SyntaxKind5[SyntaxKind5["ImportEqualsDeclaration"] = 270] = "ImportEqualsDeclaration";
                SyntaxKind5[SyntaxKind5["ImportDeclaration"] = 271] = "ImportDeclaration";
                SyntaxKind5[SyntaxKind5["ImportClause"] = 272] = "ImportClause";
                SyntaxKind5[SyntaxKind5["NamespaceImport"] = 273] = "NamespaceImport";
                SyntaxKind5[SyntaxKind5["NamedImports"] = 274] = "NamedImports";
                SyntaxKind5[SyntaxKind5["ImportSpecifier"] = 275] = "ImportSpecifier";
                SyntaxKind5[SyntaxKind5["ExportAssignment"] = 276] = "ExportAssignment";
                SyntaxKind5[SyntaxKind5["ExportDeclaration"] = 277] = "ExportDeclaration";
                SyntaxKind5[SyntaxKind5["NamedExports"] = 278] = "NamedExports";
                SyntaxKind5[SyntaxKind5["NamespaceExport"] = 279] = "NamespaceExport";
                SyntaxKind5[SyntaxKind5["ExportSpecifier"] = 280] = "ExportSpecifier";
                SyntaxKind5[SyntaxKind5["MissingDeclaration"] = 281] = "MissingDeclaration";
                SyntaxKind5[SyntaxKind5["ExternalModuleReference"] = 282] = "ExternalModuleReference";
                SyntaxKind5[SyntaxKind5["JsxElement"] = 283] = "JsxElement";
                SyntaxKind5[SyntaxKind5["JsxSelfClosingElement"] = 284] = "JsxSelfClosingElement";
                SyntaxKind5[SyntaxKind5["JsxOpeningElement"] = 285] = "JsxOpeningElement";
                SyntaxKind5[SyntaxKind5["JsxClosingElement"] = 286] = "JsxClosingElement";
                SyntaxKind5[SyntaxKind5["JsxFragment"] = 287] = "JsxFragment";
                SyntaxKind5[SyntaxKind5["JsxOpeningFragment"] = 288] = "JsxOpeningFragment";
                SyntaxKind5[SyntaxKind5["JsxClosingFragment"] = 289] = "JsxClosingFragment";
                SyntaxKind5[SyntaxKind5["JsxAttribute"] = 290] = "JsxAttribute";
                SyntaxKind5[SyntaxKind5["JsxAttributes"] = 291] = "JsxAttributes";
                SyntaxKind5[SyntaxKind5["JsxSpreadAttribute"] = 292] = "JsxSpreadAttribute";
                SyntaxKind5[SyntaxKind5["JsxExpression"] = 293] = "JsxExpression";
                SyntaxKind5[SyntaxKind5["JsxNamespacedName"] = 294] = "JsxNamespacedName";
                SyntaxKind5[SyntaxKind5["CaseClause"] = 295] = "CaseClause";
                SyntaxKind5[SyntaxKind5["DefaultClause"] = 296] = "DefaultClause";
                SyntaxKind5[SyntaxKind5["HeritageClause"] = 297] = "HeritageClause";
                SyntaxKind5[SyntaxKind5["CatchClause"] = 298] = "CatchClause";
                SyntaxKind5[SyntaxKind5["AssertClause"] = 299] = "AssertClause";
                SyntaxKind5[SyntaxKind5["AssertEntry"] = 300] = "AssertEntry";
                SyntaxKind5[SyntaxKind5["ImportTypeAssertionContainer"] = 301] = "ImportTypeAssertionContainer";
                SyntaxKind5[SyntaxKind5["PropertyAssignment"] = 302] = "PropertyAssignment";
                SyntaxKind5[SyntaxKind5["ShorthandPropertyAssignment"] = 303] = "ShorthandPropertyAssignment";
                SyntaxKind5[SyntaxKind5["SpreadAssignment"] = 304] = "SpreadAssignment";
                SyntaxKind5[SyntaxKind5["EnumMember"] = 305] = "EnumMember";
                SyntaxKind5[SyntaxKind5["UnparsedPrologue"] = 306] = "UnparsedPrologue";
                SyntaxKind5[SyntaxKind5["UnparsedPrepend"] = 307] = "UnparsedPrepend";
                SyntaxKind5[SyntaxKind5["UnparsedText"] = 308] = "UnparsedText";
                SyntaxKind5[SyntaxKind5["UnparsedInternalText"] = 309] = "UnparsedInternalText";
                SyntaxKind5[SyntaxKind5["UnparsedSyntheticReference"] = 310] = "UnparsedSyntheticReference";
                SyntaxKind5[SyntaxKind5["SourceFile"] = 311] = "SourceFile";
                SyntaxKind5[SyntaxKind5["Bundle"] = 312] = "Bundle";
                SyntaxKind5[SyntaxKind5["UnparsedSource"] = 313] = "UnparsedSource";
                SyntaxKind5[SyntaxKind5["InputFiles"] = 314] = "InputFiles";
                SyntaxKind5[SyntaxKind5["JSDocTypeExpression"] = 315] = "JSDocTypeExpression";
                SyntaxKind5[SyntaxKind5["JSDocNameReference"] = 316] = "JSDocNameReference";
                SyntaxKind5[SyntaxKind5["JSDocMemberName"] = 317] = "JSDocMemberName";
                SyntaxKind5[SyntaxKind5["JSDocAllType"] = 318] = "JSDocAllType";
                SyntaxKind5[SyntaxKind5["JSDocUnknownType"] = 319] = "JSDocUnknownType";
                SyntaxKind5[SyntaxKind5["JSDocNullableType"] = 320] = "JSDocNullableType";
                SyntaxKind5[SyntaxKind5["JSDocNonNullableType"] = 321] = "JSDocNonNullableType";
                SyntaxKind5[SyntaxKind5["JSDocOptionalType"] = 322] = "JSDocOptionalType";
                SyntaxKind5[SyntaxKind5["JSDocFunctionType"] = 323] = "JSDocFunctionType";
                SyntaxKind5[SyntaxKind5["JSDocVariadicType"] = 324] = "JSDocVariadicType";
                SyntaxKind5[SyntaxKind5["JSDocNamepathType"] = 325] = "JSDocNamepathType";
                SyntaxKind5[SyntaxKind5["JSDoc"] = 326] = "JSDoc";
                SyntaxKind5[SyntaxKind5["JSDocComment"] = 326 /* JSDoc */ ] = "JSDocComment";
                SyntaxKind5[SyntaxKind5["JSDocText"] = 327] = "JSDocText";
                SyntaxKind5[SyntaxKind5["JSDocTypeLiteral"] = 328] = "JSDocTypeLiteral";
                SyntaxKind5[SyntaxKind5["JSDocSignature"] = 329] = "JSDocSignature";
                SyntaxKind5[SyntaxKind5["JSDocLink"] = 330] = "JSDocLink";
                SyntaxKind5[SyntaxKind5["JSDocLinkCode"] = 331] = "JSDocLinkCode";
                SyntaxKind5[SyntaxKind5["JSDocLinkPlain"] = 332] = "JSDocLinkPlain";
                SyntaxKind5[SyntaxKind5["JSDocTag"] = 333] = "JSDocTag";
                SyntaxKind5[SyntaxKind5["JSDocAugmentsTag"] = 334] = "JSDocAugmentsTag";
                SyntaxKind5[SyntaxKind5["JSDocImplementsTag"] = 335] = "JSDocImplementsTag";
                SyntaxKind5[SyntaxKind5["JSDocAuthorTag"] = 336] = "JSDocAuthorTag";
                SyntaxKind5[SyntaxKind5["JSDocDeprecatedTag"] = 337] = "JSDocDeprecatedTag";
                SyntaxKind5[SyntaxKind5["JSDocClassTag"] = 338] = "JSDocClassTag";
                SyntaxKind5[SyntaxKind5["JSDocPublicTag"] = 339] = "JSDocPublicTag";
                SyntaxKind5[SyntaxKind5["JSDocPrivateTag"] = 340] = "JSDocPrivateTag";
                SyntaxKind5[SyntaxKind5["JSDocProtectedTag"] = 341] = "JSDocProtectedTag";
                SyntaxKind5[SyntaxKind5["JSDocReadonlyTag"] = 342] = "JSDocReadonlyTag";
                SyntaxKind5[SyntaxKind5["JSDocOverrideTag"] = 343] = "JSDocOverrideTag";
                SyntaxKind5[SyntaxKind5["JSDocCallbackTag"] = 344] = "JSDocCallbackTag";
                SyntaxKind5[SyntaxKind5["JSDocOverloadTag"] = 345] = "JSDocOverloadTag";
                SyntaxKind5[SyntaxKind5["JSDocEnumTag"] = 346] = "JSDocEnumTag";
                SyntaxKind5[SyntaxKind5["JSDocParameterTag"] = 347] = "JSDocParameterTag";
                SyntaxKind5[SyntaxKind5["JSDocReturnTag"] = 348] = "JSDocReturnTag";
                SyntaxKind5[SyntaxKind5["JSDocThisTag"] = 349] = "JSDocThisTag";
                SyntaxKind5[SyntaxKind5["JSDocTypeTag"] = 350] = "JSDocTypeTag";
                SyntaxKind5[SyntaxKind5["JSDocTemplateTag"] = 351] = "JSDocTemplateTag";
                SyntaxKind5[SyntaxKind5["JSDocTypedefTag"] = 352] = "JSDocTypedefTag";
                SyntaxKind5[SyntaxKind5["JSDocSeeTag"] = 353] = "JSDocSeeTag";
                SyntaxKind5[SyntaxKind5["JSDocPropertyTag"] = 354] = "JSDocPropertyTag";
                SyntaxKind5[SyntaxKind5["JSDocThrowsTag"] = 355] = "JSDocThrowsTag";
                SyntaxKind5[SyntaxKind5["JSDocSatisfiesTag"] = 356] = "JSDocSatisfiesTag";
                SyntaxKind5[SyntaxKind5["SyntaxList"] = 357] = "SyntaxList";
                SyntaxKind5[SyntaxKind5["NotEmittedStatement"] = 358] = "NotEmittedStatement";
                SyntaxKind5[SyntaxKind5["PartiallyEmittedExpression"] = 359] = "PartiallyEmittedExpression";
                SyntaxKind5[SyntaxKind5["CommaListExpression"] = 360] = "CommaListExpression";
                SyntaxKind5[SyntaxKind5["SyntheticReferenceExpression"] = 361] = "SyntheticReferenceExpression";
                SyntaxKind5[SyntaxKind5["Count"] = 362] = "Count";
                SyntaxKind5[SyntaxKind5["FirstAssignment"] = 64 /* EqualsToken */ ] = "FirstAssignment";
                SyntaxKind5[SyntaxKind5["LastAssignment"] = 79 /* CaretEqualsToken */ ] = "LastAssignment";
                SyntaxKind5[SyntaxKind5["FirstCompoundAssignment"] = 65 /* PlusEqualsToken */ ] = "FirstCompoundAssignment";
                SyntaxKind5[SyntaxKind5["LastCompoundAssignment"] = 79 /* CaretEqualsToken */ ] = "LastCompoundAssignment";
                SyntaxKind5[SyntaxKind5["FirstReservedWord"] = 83 /* BreakKeyword */ ] = "FirstReservedWord";
                SyntaxKind5[SyntaxKind5["LastReservedWord"] = 118 /* WithKeyword */ ] = "LastReservedWord";
                SyntaxKind5[SyntaxKind5["FirstKeyword"] = 83 /* BreakKeyword */ ] = "FirstKeyword";
                SyntaxKind5[SyntaxKind5["LastKeyword"] = 164 /* OfKeyword */ ] = "LastKeyword";
                SyntaxKind5[SyntaxKind5["FirstFutureReservedWord"] = 119 /* ImplementsKeyword */ ] = "FirstFutureReservedWord";
                SyntaxKind5[SyntaxKind5["LastFutureReservedWord"] = 127 /* YieldKeyword */ ] = "LastFutureReservedWord";
                SyntaxKind5[SyntaxKind5["FirstTypeNode"] = 181 /* TypePredicate */ ] = "FirstTypeNode";
                SyntaxKind5[SyntaxKind5["LastTypeNode"] = 204 /* ImportType */ ] = "LastTypeNode";
                SyntaxKind5[SyntaxKind5["FirstPunctuation"] = 19 /* OpenBraceToken */ ] = "FirstPunctuation";
                SyntaxKind5[SyntaxKind5["LastPunctuation"] = 79 /* CaretEqualsToken */ ] = "LastPunctuation";
                SyntaxKind5[SyntaxKind5["FirstToken"] = 0 /* Unknown */ ] = "FirstToken";
                SyntaxKind5[SyntaxKind5["LastToken"] = 164 /* LastKeyword */ ] = "LastToken";
                SyntaxKind5[SyntaxKind5["FirstTriviaToken"] = 2 /* SingleLineCommentTrivia */ ] = "FirstTriviaToken";
                SyntaxKind5[SyntaxKind5["LastTriviaToken"] = 7 /* ConflictMarkerTrivia */ ] = "LastTriviaToken";
                SyntaxKind5[SyntaxKind5["FirstLiteralToken"] = 9 /* NumericLiteral */ ] = "FirstLiteralToken";
                SyntaxKind5[SyntaxKind5["LastLiteralToken"] = 15 /* NoSubstitutionTemplateLiteral */ ] = "LastLiteralToken";
                SyntaxKind5[SyntaxKind5["FirstTemplateToken"] = 15 /* NoSubstitutionTemplateLiteral */ ] = "FirstTemplateToken";
                SyntaxKind5[SyntaxKind5["LastTemplateToken"] = 18 /* TemplateTail */ ] = "LastTemplateToken";
                SyntaxKind5[SyntaxKind5["FirstBinaryOperator"] = 30 /* LessThanToken */ ] = "FirstBinaryOperator";
                SyntaxKind5[SyntaxKind5["LastBinaryOperator"] = 79 /* CaretEqualsToken */ ] = "LastBinaryOperator";
                SyntaxKind5[SyntaxKind5["FirstStatement"] = 242 /* VariableStatement */ ] = "FirstStatement";
                SyntaxKind5[SyntaxKind5["LastStatement"] = 258 /* DebuggerStatement */ ] = "LastStatement";
                SyntaxKind5[SyntaxKind5["FirstNode"] = 165 /* QualifiedName */ ] = "FirstNode";
                SyntaxKind5[SyntaxKind5["FirstJSDocNode"] = 315 /* JSDocTypeExpression */ ] = "FirstJSDocNode";
                SyntaxKind5[SyntaxKind5["LastJSDocNode"] = 356 /* JSDocSatisfiesTag */ ] = "LastJSDocNode";
                SyntaxKind5[SyntaxKind5["FirstJSDocTagNode"] = 333 /* JSDocTag */ ] = "FirstJSDocTagNode";
                SyntaxKind5[SyntaxKind5["LastJSDocTagNode"] = 356 /* JSDocSatisfiesTag */ ] = "LastJSDocTagNode";
                SyntaxKind5[SyntaxKind5["FirstContextualKeyword"] = 128 /* AbstractKeyword */ ] = "FirstContextualKeyword";
                SyntaxKind5[SyntaxKind5["LastContextualKeyword"] = 164 /* OfKeyword */ ] = "LastContextualKeyword";
                return SyntaxKind5;
            })(SyntaxKind || {});
            NodeFlags = /* @__PURE__ */ ((NodeFlags3)=>{
                NodeFlags3[NodeFlags3["None"] = 0] = "None";
                NodeFlags3[NodeFlags3["Let"] = 1] = "Let";
                NodeFlags3[NodeFlags3["Const"] = 2] = "Const";
                NodeFlags3[NodeFlags3["NestedNamespace"] = 4] = "NestedNamespace";
                NodeFlags3[NodeFlags3["Synthesized"] = 8] = "Synthesized";
                NodeFlags3[NodeFlags3["Namespace"] = 16] = "Namespace";
                NodeFlags3[NodeFlags3["OptionalChain"] = 32] = "OptionalChain";
                NodeFlags3[NodeFlags3["ExportContext"] = 64] = "ExportContext";
                NodeFlags3[NodeFlags3["ContainsThis"] = 128] = "ContainsThis";
                NodeFlags3[NodeFlags3["HasImplicitReturn"] = 256] = "HasImplicitReturn";
                NodeFlags3[NodeFlags3["HasExplicitReturn"] = 512] = "HasExplicitReturn";
                NodeFlags3[NodeFlags3["GlobalAugmentation"] = 1024] = "GlobalAugmentation";
                NodeFlags3[NodeFlags3["HasAsyncFunctions"] = 2048] = "HasAsyncFunctions";
                NodeFlags3[NodeFlags3["DisallowInContext"] = 4096] = "DisallowInContext";
                NodeFlags3[NodeFlags3["YieldContext"] = 8192] = "YieldContext";
                NodeFlags3[NodeFlags3["DecoratorContext"] = 16384] = "DecoratorContext";
                NodeFlags3[NodeFlags3["AwaitContext"] = 32768] = "AwaitContext";
                NodeFlags3[NodeFlags3["DisallowConditionalTypesContext"] = 65536] = "DisallowConditionalTypesContext";
                NodeFlags3[NodeFlags3["ThisNodeHasError"] = 131072] = "ThisNodeHasError";
                NodeFlags3[NodeFlags3["JavaScriptFile"] = 262144] = "JavaScriptFile";
                NodeFlags3[NodeFlags3["ThisNodeOrAnySubNodesHasError"] = 524288] = "ThisNodeOrAnySubNodesHasError";
                NodeFlags3[NodeFlags3["HasAggregatedChildData"] = 1048576] = "HasAggregatedChildData";
                NodeFlags3[NodeFlags3["PossiblyContainsDynamicImport"] = 2097152] = "PossiblyContainsDynamicImport";
                NodeFlags3[NodeFlags3["PossiblyContainsImportMeta"] = 4194304] = "PossiblyContainsImportMeta";
                NodeFlags3[NodeFlags3["JSDoc"] = 8388608] = "JSDoc";
                NodeFlags3[NodeFlags3["Ambient"] = 16777216] = "Ambient";
                NodeFlags3[NodeFlags3["InWithStatement"] = 33554432] = "InWithStatement";
                NodeFlags3[NodeFlags3["JsonFile"] = 67108864] = "JsonFile";
                NodeFlags3[NodeFlags3["TypeCached"] = 134217728] = "TypeCached";
                NodeFlags3[NodeFlags3["Deprecated"] = 268435456] = "Deprecated";
                NodeFlags3[NodeFlags3["BlockScoped"] = 3] = "BlockScoped";
                NodeFlags3[NodeFlags3["ReachabilityCheckFlags"] = 768] = "ReachabilityCheckFlags";
                NodeFlags3[NodeFlags3["ReachabilityAndEmitFlags"] = 2816] = "ReachabilityAndEmitFlags";
                NodeFlags3[NodeFlags3["ContextFlags"] = 50720768] = "ContextFlags";
                NodeFlags3[NodeFlags3["TypeExcludesFlags"] = 40960] = "TypeExcludesFlags";
                NodeFlags3[NodeFlags3["PermanentlySetIncrementalFlags"] = 6291456] = "PermanentlySetIncrementalFlags";
                NodeFlags3[NodeFlags3["IdentifierHasExtendedUnicodeEscape"] = 128 /* ContainsThis */ ] = "IdentifierHasExtendedUnicodeEscape";
                NodeFlags3[NodeFlags3["IdentifierIsInJSDocNamespace"] = 2048 /* HasAsyncFunctions */ ] = "IdentifierIsInJSDocNamespace";
                return NodeFlags3;
            })(NodeFlags || {});
            ModifierFlags = /* @__PURE__ */ ((ModifierFlags3)=>{
                ModifierFlags3[ModifierFlags3["None"] = 0] = "None";
                ModifierFlags3[ModifierFlags3["Export"] = 1] = "Export";
                ModifierFlags3[ModifierFlags3["Ambient"] = 2] = "Ambient";
                ModifierFlags3[ModifierFlags3["Public"] = 4] = "Public";
                ModifierFlags3[ModifierFlags3["Private"] = 8] = "Private";
                ModifierFlags3[ModifierFlags3["Protected"] = 16] = "Protected";
                ModifierFlags3[ModifierFlags3["Static"] = 32] = "Static";
                ModifierFlags3[ModifierFlags3["Readonly"] = 64] = "Readonly";
                ModifierFlags3[ModifierFlags3["Accessor"] = 128] = "Accessor";
                ModifierFlags3[ModifierFlags3["Abstract"] = 256] = "Abstract";
                ModifierFlags3[ModifierFlags3["Async"] = 512] = "Async";
                ModifierFlags3[ModifierFlags3["Default"] = 1024] = "Default";
                ModifierFlags3[ModifierFlags3["Const"] = 2048] = "Const";
                ModifierFlags3[ModifierFlags3["HasComputedJSDocModifiers"] = 4096] = "HasComputedJSDocModifiers";
                ModifierFlags3[ModifierFlags3["Deprecated"] = 8192] = "Deprecated";
                ModifierFlags3[ModifierFlags3["Override"] = 16384] = "Override";
                ModifierFlags3[ModifierFlags3["In"] = 32768] = "In";
                ModifierFlags3[ModifierFlags3["Out"] = 65536] = "Out";
                ModifierFlags3[ModifierFlags3["Decorator"] = 131072] = "Decorator";
                ModifierFlags3[ModifierFlags3["HasComputedFlags"] = 536870912] = "HasComputedFlags";
                ModifierFlags3[ModifierFlags3["AccessibilityModifier"] = 28] = "AccessibilityModifier";
                ModifierFlags3[ModifierFlags3["ParameterPropertyModifier"] = 16476] = "ParameterPropertyModifier";
                ModifierFlags3[ModifierFlags3["NonPublicAccessibilityModifier"] = 24] = "NonPublicAccessibilityModifier";
                ModifierFlags3[ModifierFlags3["TypeScriptModifier"] = 117086] = "TypeScriptModifier";
                ModifierFlags3[ModifierFlags3["ExportDefault"] = 1025] = "ExportDefault";
                ModifierFlags3[ModifierFlags3["All"] = 258047] = "All";
                ModifierFlags3[ModifierFlags3["Modifier"] = 126975] = "Modifier";
                return ModifierFlags3;
            })(ModifierFlags || {});
            JsxFlags = /* @__PURE__ */ ((JsxFlags2)=>{
                JsxFlags2[JsxFlags2["None"] = 0] = "None";
                JsxFlags2[JsxFlags2["IntrinsicNamedElement"] = 1] = "IntrinsicNamedElement";
                JsxFlags2[JsxFlags2["IntrinsicIndexedElement"] = 2] = "IntrinsicIndexedElement";
                JsxFlags2[JsxFlags2["IntrinsicElement"] = 3] = "IntrinsicElement";
                return JsxFlags2;
            })(JsxFlags || {});
            RelationComparisonResult = /* @__PURE__ */ ((RelationComparisonResult3)=>{
                RelationComparisonResult3[RelationComparisonResult3["Succeeded"] = 1] = "Succeeded";
                RelationComparisonResult3[RelationComparisonResult3["Failed"] = 2] = "Failed";
                RelationComparisonResult3[RelationComparisonResult3["Reported"] = 4] = "Reported";
                RelationComparisonResult3[RelationComparisonResult3["ReportsUnmeasurable"] = 8] = "ReportsUnmeasurable";
                RelationComparisonResult3[RelationComparisonResult3["ReportsUnreliable"] = 16] = "ReportsUnreliable";
                RelationComparisonResult3[RelationComparisonResult3["ReportsMask"] = 24] = "ReportsMask";
                return RelationComparisonResult3;
            })(RelationComparisonResult || {});
            GeneratedIdentifierFlags = /* @__PURE__ */ ((GeneratedIdentifierFlags2)=>{
                GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["None"] = 0] = "None";
                GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["Auto"] = 1] = "Auto";
                GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["Loop"] = 2] = "Loop";
                GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["Unique"] = 3] = "Unique";
                GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["Node"] = 4] = "Node";
                GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["KindMask"] = 7] = "KindMask";
                GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["ReservedInNestedScopes"] = 8] = "ReservedInNestedScopes";
                GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["Optimistic"] = 16] = "Optimistic";
                GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["FileLevel"] = 32] = "FileLevel";
                GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["AllowNameSubstitution"] = 64] = "AllowNameSubstitution";
                return GeneratedIdentifierFlags2;
            })(GeneratedIdentifierFlags || {});
            TokenFlags = /* @__PURE__ */ ((TokenFlags2)=>{
                TokenFlags2[TokenFlags2["None"] = 0] = "None";
                TokenFlags2[TokenFlags2["PrecedingLineBreak"] = 1] = "PrecedingLineBreak";
                TokenFlags2[TokenFlags2["PrecedingJSDocComment"] = 2] = "PrecedingJSDocComment";
                TokenFlags2[TokenFlags2["Unterminated"] = 4] = "Unterminated";
                TokenFlags2[TokenFlags2["ExtendedUnicodeEscape"] = 8] = "ExtendedUnicodeEscape";
                TokenFlags2[TokenFlags2["Scientific"] = 16] = "Scientific";
                TokenFlags2[TokenFlags2["Octal"] = 32] = "Octal";
                TokenFlags2[TokenFlags2["HexSpecifier"] = 64] = "HexSpecifier";
                TokenFlags2[TokenFlags2["BinarySpecifier"] = 128] = "BinarySpecifier";
                TokenFlags2[TokenFlags2["OctalSpecifier"] = 256] = "OctalSpecifier";
                TokenFlags2[TokenFlags2["ContainsSeparator"] = 512] = "ContainsSeparator";
                TokenFlags2[TokenFlags2["UnicodeEscape"] = 1024] = "UnicodeEscape";
                TokenFlags2[TokenFlags2["ContainsInvalidEscape"] = 2048] = "ContainsInvalidEscape";
                TokenFlags2[TokenFlags2["HexEscape"] = 4096] = "HexEscape";
                TokenFlags2[TokenFlags2["ContainsLeadingZero"] = 8192] = "ContainsLeadingZero";
                TokenFlags2[TokenFlags2["ContainsInvalidSeparator"] = 16384] = "ContainsInvalidSeparator";
                TokenFlags2[TokenFlags2["BinaryOrOctalSpecifier"] = 384] = "BinaryOrOctalSpecifier";
                TokenFlags2[TokenFlags2["WithSpecifier"] = 448] = "WithSpecifier";
                TokenFlags2[TokenFlags2["StringLiteralFlags"] = 7176] = "StringLiteralFlags";
                TokenFlags2[TokenFlags2["NumericLiteralFlags"] = 25584] = "NumericLiteralFlags";
                TokenFlags2[TokenFlags2["TemplateLiteralLikeFlags"] = 7176] = "TemplateLiteralLikeFlags";
                TokenFlags2[TokenFlags2["IsInvalid"] = 26656] = "IsInvalid";
                return TokenFlags2;
            })(TokenFlags || {});
            FlowFlags = /* @__PURE__ */ ((FlowFlags2)=>{
                FlowFlags2[FlowFlags2["Unreachable"] = 1] = "Unreachable";
                FlowFlags2[FlowFlags2["Start"] = 2] = "Start";
                FlowFlags2[FlowFlags2["BranchLabel"] = 4] = "BranchLabel";
                FlowFlags2[FlowFlags2["LoopLabel"] = 8] = "LoopLabel";
                FlowFlags2[FlowFlags2["Assignment"] = 16] = "Assignment";
                FlowFlags2[FlowFlags2["TrueCondition"] = 32] = "TrueCondition";
                FlowFlags2[FlowFlags2["FalseCondition"] = 64] = "FalseCondition";
                FlowFlags2[FlowFlags2["SwitchClause"] = 128] = "SwitchClause";
                FlowFlags2[FlowFlags2["ArrayMutation"] = 256] = "ArrayMutation";
                FlowFlags2[FlowFlags2["Call"] = 512] = "Call";
                FlowFlags2[FlowFlags2["ReduceLabel"] = 1024] = "ReduceLabel";
                FlowFlags2[FlowFlags2["Referenced"] = 2048] = "Referenced";
                FlowFlags2[FlowFlags2["Shared"] = 4096] = "Shared";
                FlowFlags2[FlowFlags2["Label"] = 12] = "Label";
                FlowFlags2[FlowFlags2["Condition"] = 96] = "Condition";
                return FlowFlags2;
            })(FlowFlags || {});
            CommentDirectiveType = /* @__PURE__ */ ((CommentDirectiveType2)=>{
                CommentDirectiveType2[CommentDirectiveType2["ExpectError"] = 0] = "ExpectError";
                CommentDirectiveType2[CommentDirectiveType2["Ignore"] = 1] = "Ignore";
                return CommentDirectiveType2;
            })(CommentDirectiveType || {});
            OperationCanceledException = class {
            };
            FileIncludeKind = /* @__PURE__ */ ((FileIncludeKind2)=>{
                FileIncludeKind2[FileIncludeKind2["RootFile"] = 0] = "RootFile";
                FileIncludeKind2[FileIncludeKind2["SourceFromProjectReference"] = 1] = "SourceFromProjectReference";
                FileIncludeKind2[FileIncludeKind2["OutputFromProjectReference"] = 2] = "OutputFromProjectReference";
                FileIncludeKind2[FileIncludeKind2["Import"] = 3] = "Import";
                FileIncludeKind2[FileIncludeKind2["ReferenceFile"] = 4] = "ReferenceFile";
                FileIncludeKind2[FileIncludeKind2["TypeReferenceDirective"] = 5] = "TypeReferenceDirective";
                FileIncludeKind2[FileIncludeKind2["LibFile"] = 6] = "LibFile";
                FileIncludeKind2[FileIncludeKind2["LibReferenceDirective"] = 7] = "LibReferenceDirective";
                FileIncludeKind2[FileIncludeKind2["AutomaticTypeDirectiveFile"] = 8] = "AutomaticTypeDirectiveFile";
                return FileIncludeKind2;
            })(FileIncludeKind || {});
            FilePreprocessingDiagnosticsKind = /* @__PURE__ */ ((FilePreprocessingDiagnosticsKind2)=>{
                FilePreprocessingDiagnosticsKind2[FilePreprocessingDiagnosticsKind2["FilePreprocessingReferencedDiagnostic"] = 0] = "FilePreprocessingReferencedDiagnostic";
                FilePreprocessingDiagnosticsKind2[FilePreprocessingDiagnosticsKind2["FilePreprocessingFileExplainingDiagnostic"] = 1] = "FilePreprocessingFileExplainingDiagnostic";
                FilePreprocessingDiagnosticsKind2[FilePreprocessingDiagnosticsKind2["ResolutionDiagnostics"] = 2] = "ResolutionDiagnostics";
                return FilePreprocessingDiagnosticsKind2;
            })(FilePreprocessingDiagnosticsKind || {});
            EmitOnly = /* @__PURE__ */ ((EmitOnly4)=>{
                EmitOnly4[EmitOnly4["Js"] = 0] = "Js";
                EmitOnly4[EmitOnly4["Dts"] = 1] = "Dts";
                return EmitOnly4;
            })(EmitOnly || {});
            StructureIsReused = /* @__PURE__ */ ((StructureIsReused2)=>{
                StructureIsReused2[StructureIsReused2["Not"] = 0] = "Not";
                StructureIsReused2[StructureIsReused2["SafeModules"] = 1] = "SafeModules";
                StructureIsReused2[StructureIsReused2["Completely"] = 2] = "Completely";
                return StructureIsReused2;
            })(StructureIsReused || {});
            ExitStatus = /* @__PURE__ */ ((ExitStatus2)=>{
                ExitStatus2[ExitStatus2["Success"] = 0] = "Success";
                ExitStatus2[ExitStatus2["DiagnosticsPresent_OutputsSkipped"] = 1] = "DiagnosticsPresent_OutputsSkipped";
                ExitStatus2[ExitStatus2["DiagnosticsPresent_OutputsGenerated"] = 2] = "DiagnosticsPresent_OutputsGenerated";
                ExitStatus2[ExitStatus2["InvalidProject_OutputsSkipped"] = 3] = "InvalidProject_OutputsSkipped";
                ExitStatus2[ExitStatus2["ProjectReferenceCycle_OutputsSkipped"] = 4] = "ProjectReferenceCycle_OutputsSkipped";
                return ExitStatus2;
            })(ExitStatus || {});
            MemberOverrideStatus = /* @__PURE__ */ ((MemberOverrideStatus2)=>{
                MemberOverrideStatus2[MemberOverrideStatus2["Ok"] = 0] = "Ok";
                MemberOverrideStatus2[MemberOverrideStatus2["NeedsOverride"] = 1] = "NeedsOverride";
                MemberOverrideStatus2[MemberOverrideStatus2["HasInvalidOverride"] = 2] = "HasInvalidOverride";
                return MemberOverrideStatus2;
            })(MemberOverrideStatus || {});
            UnionReduction = /* @__PURE__ */ ((UnionReduction2)=>{
                UnionReduction2[UnionReduction2["None"] = 0] = "None";
                UnionReduction2[UnionReduction2["Literal"] = 1] = "Literal";
                UnionReduction2[UnionReduction2["Subtype"] = 2] = "Subtype";
                return UnionReduction2;
            })(UnionReduction || {});
            ContextFlags = /* @__PURE__ */ ((ContextFlags3)=>{
                ContextFlags3[ContextFlags3["None"] = 0] = "None";
                ContextFlags3[ContextFlags3["Signature"] = 1] = "Signature";
                ContextFlags3[ContextFlags3["NoConstraints"] = 2] = "NoConstraints";
                ContextFlags3[ContextFlags3["Completions"] = 4] = "Completions";
                ContextFlags3[ContextFlags3["SkipBindingPatterns"] = 8] = "SkipBindingPatterns";
                return ContextFlags3;
            })(ContextFlags || {});
            NodeBuilderFlags = /* @__PURE__ */ ((NodeBuilderFlags2)=>{
                NodeBuilderFlags2[NodeBuilderFlags2["None"] = 0] = "None";
                NodeBuilderFlags2[NodeBuilderFlags2["NoTruncation"] = 1] = "NoTruncation";
                NodeBuilderFlags2[NodeBuilderFlags2["WriteArrayAsGenericType"] = 2] = "WriteArrayAsGenericType";
                NodeBuilderFlags2[NodeBuilderFlags2["GenerateNamesForShadowedTypeParams"] = 4] = "GenerateNamesForShadowedTypeParams";
                NodeBuilderFlags2[NodeBuilderFlags2["UseStructuralFallback"] = 8] = "UseStructuralFallback";
                NodeBuilderFlags2[NodeBuilderFlags2["ForbidIndexedAccessSymbolReferences"] = 16] = "ForbidIndexedAccessSymbolReferences";
                NodeBuilderFlags2[NodeBuilderFlags2["WriteTypeArgumentsOfSignature"] = 32] = "WriteTypeArgumentsOfSignature";
                NodeBuilderFlags2[NodeBuilderFlags2["UseFullyQualifiedType"] = 64] = "UseFullyQualifiedType";
                NodeBuilderFlags2[NodeBuilderFlags2["UseOnlyExternalAliasing"] = 128] = "UseOnlyExternalAliasing";
                NodeBuilderFlags2[NodeBuilderFlags2["SuppressAnyReturnType"] = 256] = "SuppressAnyReturnType";
                NodeBuilderFlags2[NodeBuilderFlags2["WriteTypeParametersInQualifiedName"] = 512] = "WriteTypeParametersInQualifiedName";
                NodeBuilderFlags2[NodeBuilderFlags2["MultilineObjectLiterals"] = 1024] = "MultilineObjectLiterals";
                NodeBuilderFlags2[NodeBuilderFlags2["WriteClassExpressionAsTypeLiteral"] = 2048] = "WriteClassExpressionAsTypeLiteral";
                NodeBuilderFlags2[NodeBuilderFlags2["UseTypeOfFunction"] = 4096] = "UseTypeOfFunction";
                NodeBuilderFlags2[NodeBuilderFlags2["OmitParameterModifiers"] = 8192] = "OmitParameterModifiers";
                NodeBuilderFlags2[NodeBuilderFlags2["UseAliasDefinedOutsideCurrentScope"] = 16384] = "UseAliasDefinedOutsideCurrentScope";
                NodeBuilderFlags2[NodeBuilderFlags2["UseSingleQuotesForStringLiteralType"] = 268435456] = "UseSingleQuotesForStringLiteralType";
                NodeBuilderFlags2[NodeBuilderFlags2["NoTypeReduction"] = 536870912] = "NoTypeReduction";
                NodeBuilderFlags2[NodeBuilderFlags2["OmitThisParameter"] = 33554432] = "OmitThisParameter";
                NodeBuilderFlags2[NodeBuilderFlags2["AllowThisInObjectLiteral"] = 32768] = "AllowThisInObjectLiteral";
                NodeBuilderFlags2[NodeBuilderFlags2["AllowQualifiedNameInPlaceOfIdentifier"] = 65536] = "AllowQualifiedNameInPlaceOfIdentifier";
                NodeBuilderFlags2[NodeBuilderFlags2["AllowAnonymousIdentifier"] = 131072] = "AllowAnonymousIdentifier";
                NodeBuilderFlags2[NodeBuilderFlags2["AllowEmptyUnionOrIntersection"] = 262144] = "AllowEmptyUnionOrIntersection";
                NodeBuilderFlags2[NodeBuilderFlags2["AllowEmptyTuple"] = 524288] = "AllowEmptyTuple";
                NodeBuilderFlags2[NodeBuilderFlags2["AllowUniqueESSymbolType"] = 1048576] = "AllowUniqueESSymbolType";
                NodeBuilderFlags2[NodeBuilderFlags2["AllowEmptyIndexInfoType"] = 2097152] = "AllowEmptyIndexInfoType";
                NodeBuilderFlags2[NodeBuilderFlags2["WriteComputedProps"] = 1073741824] = "WriteComputedProps";
                NodeBuilderFlags2[NodeBuilderFlags2["AllowNodeModulesRelativePaths"] = 67108864] = "AllowNodeModulesRelativePaths";
                NodeBuilderFlags2[NodeBuilderFlags2["DoNotIncludeSymbolChain"] = 134217728] = "DoNotIncludeSymbolChain";
                NodeBuilderFlags2[NodeBuilderFlags2["IgnoreErrors"] = 70221824] = "IgnoreErrors";
                NodeBuilderFlags2[NodeBuilderFlags2["InObjectTypeLiteral"] = 4194304] = "InObjectTypeLiteral";
                NodeBuilderFlags2[NodeBuilderFlags2["InTypeAlias"] = 8388608] = "InTypeAlias";
                NodeBuilderFlags2[NodeBuilderFlags2["InInitialEntityName"] = 16777216] = "InInitialEntityName";
                return NodeBuilderFlags2;
            })(NodeBuilderFlags || {});
            TypeFormatFlags = /* @__PURE__ */ ((TypeFormatFlags2)=>{
                TypeFormatFlags2[TypeFormatFlags2["None"] = 0] = "None";
                TypeFormatFlags2[TypeFormatFlags2["NoTruncation"] = 1] = "NoTruncation";
                TypeFormatFlags2[TypeFormatFlags2["WriteArrayAsGenericType"] = 2] = "WriteArrayAsGenericType";
                TypeFormatFlags2[TypeFormatFlags2["UseStructuralFallback"] = 8] = "UseStructuralFallback";
                TypeFormatFlags2[TypeFormatFlags2["WriteTypeArgumentsOfSignature"] = 32] = "WriteTypeArgumentsOfSignature";
                TypeFormatFlags2[TypeFormatFlags2["UseFullyQualifiedType"] = 64] = "UseFullyQualifiedType";
                TypeFormatFlags2[TypeFormatFlags2["SuppressAnyReturnType"] = 256] = "SuppressAnyReturnType";
                TypeFormatFlags2[TypeFormatFlags2["MultilineObjectLiterals"] = 1024] = "MultilineObjectLiterals";
                TypeFormatFlags2[TypeFormatFlags2["WriteClassExpressionAsTypeLiteral"] = 2048] = "WriteClassExpressionAsTypeLiteral";
                TypeFormatFlags2[TypeFormatFlags2["UseTypeOfFunction"] = 4096] = "UseTypeOfFunction";
                TypeFormatFlags2[TypeFormatFlags2["OmitParameterModifiers"] = 8192] = "OmitParameterModifiers";
                TypeFormatFlags2[TypeFormatFlags2["UseAliasDefinedOutsideCurrentScope"] = 16384] = "UseAliasDefinedOutsideCurrentScope";
                TypeFormatFlags2[TypeFormatFlags2["UseSingleQuotesForStringLiteralType"] = 268435456] = "UseSingleQuotesForStringLiteralType";
                TypeFormatFlags2[TypeFormatFlags2["NoTypeReduction"] = 536870912] = "NoTypeReduction";
                TypeFormatFlags2[TypeFormatFlags2["OmitThisParameter"] = 33554432] = "OmitThisParameter";
                TypeFormatFlags2[TypeFormatFlags2["AllowUniqueESSymbolType"] = 1048576] = "AllowUniqueESSymbolType";
                TypeFormatFlags2[TypeFormatFlags2["AddUndefined"] = 131072] = "AddUndefined";
                TypeFormatFlags2[TypeFormatFlags2["WriteArrowStyleSignature"] = 262144] = "WriteArrowStyleSignature";
                TypeFormatFlags2[TypeFormatFlags2["InArrayType"] = 524288] = "InArrayType";
                TypeFormatFlags2[TypeFormatFlags2["InElementType"] = 2097152] = "InElementType";
                TypeFormatFlags2[TypeFormatFlags2["InFirstTypeArgument"] = 4194304] = "InFirstTypeArgument";
                TypeFormatFlags2[TypeFormatFlags2["InTypeAlias"] = 8388608] = "InTypeAlias";
                TypeFormatFlags2[TypeFormatFlags2["NodeBuilderFlagsMask"] = 848330091] = "NodeBuilderFlagsMask";
                return TypeFormatFlags2;
            })(TypeFormatFlags || {});
            SymbolFormatFlags = /* @__PURE__ */ ((SymbolFormatFlags2)=>{
                SymbolFormatFlags2[SymbolFormatFlags2["None"] = 0] = "None";
                SymbolFormatFlags2[SymbolFormatFlags2["WriteTypeParametersOrArguments"] = 1] = "WriteTypeParametersOrArguments";
                SymbolFormatFlags2[SymbolFormatFlags2["UseOnlyExternalAliasing"] = 2] = "UseOnlyExternalAliasing";
                SymbolFormatFlags2[SymbolFormatFlags2["AllowAnyNodeKind"] = 4] = "AllowAnyNodeKind";
                SymbolFormatFlags2[SymbolFormatFlags2["UseAliasDefinedOutsideCurrentScope"] = 8] = "UseAliasDefinedOutsideCurrentScope";
                SymbolFormatFlags2[SymbolFormatFlags2["WriteComputedProps"] = 16] = "WriteComputedProps";
                SymbolFormatFlags2[SymbolFormatFlags2["DoNotIncludeSymbolChain"] = 32] = "DoNotIncludeSymbolChain";
                return SymbolFormatFlags2;
            })(SymbolFormatFlags || {});
            SymbolAccessibility = /* @__PURE__ */ ((SymbolAccessibility2)=>{
                SymbolAccessibility2[SymbolAccessibility2["Accessible"] = 0] = "Accessible";
                SymbolAccessibility2[SymbolAccessibility2["NotAccessible"] = 1] = "NotAccessible";
                SymbolAccessibility2[SymbolAccessibility2["CannotBeNamed"] = 2] = "CannotBeNamed";
                return SymbolAccessibility2;
            })(SymbolAccessibility || {});
            SyntheticSymbolKind = /* @__PURE__ */ ((SyntheticSymbolKind2)=>{
                SyntheticSymbolKind2[SyntheticSymbolKind2["UnionOrIntersection"] = 0] = "UnionOrIntersection";
                SyntheticSymbolKind2[SyntheticSymbolKind2["Spread"] = 1] = "Spread";
                return SyntheticSymbolKind2;
            })(SyntheticSymbolKind || {});
            TypePredicateKind = /* @__PURE__ */ ((TypePredicateKind2)=>{
                TypePredicateKind2[TypePredicateKind2["This"] = 0] = "This";
                TypePredicateKind2[TypePredicateKind2["Identifier"] = 1] = "Identifier";
                TypePredicateKind2[TypePredicateKind2["AssertsThis"] = 2] = "AssertsThis";
                TypePredicateKind2[TypePredicateKind2["AssertsIdentifier"] = 3] = "AssertsIdentifier";
                return TypePredicateKind2;
            })(TypePredicateKind || {});
            TypeReferenceSerializationKind = /* @__PURE__ */ ((TypeReferenceSerializationKind2)=>{
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["Unknown"] = 0] = "Unknown";
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["TypeWithConstructSignatureAndValue"] = 1] = "TypeWithConstructSignatureAndValue";
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["VoidNullableOrNeverType"] = 2] = "VoidNullableOrNeverType";
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["NumberLikeType"] = 3] = "NumberLikeType";
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["BigIntLikeType"] = 4] = "BigIntLikeType";
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["StringLikeType"] = 5] = "StringLikeType";
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["BooleanType"] = 6] = "BooleanType";
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["ArrayLikeType"] = 7] = "ArrayLikeType";
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["ESSymbolType"] = 8] = "ESSymbolType";
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["Promise"] = 9] = "Promise";
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["TypeWithCallSignature"] = 10] = "TypeWithCallSignature";
                TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["ObjectType"] = 11] = "ObjectType";
                return TypeReferenceSerializationKind2;
            })(TypeReferenceSerializationKind || {});
            SymbolFlags = /* @__PURE__ */ ((SymbolFlags3)=>{
                SymbolFlags3[SymbolFlags3["None"] = 0] = "None";
                SymbolFlags3[SymbolFlags3["FunctionScopedVariable"] = 1] = "FunctionScopedVariable";
                SymbolFlags3[SymbolFlags3["BlockScopedVariable"] = 2] = "BlockScopedVariable";
                SymbolFlags3[SymbolFlags3["Property"] = 4] = "Property";
                SymbolFlags3[SymbolFlags3["EnumMember"] = 8] = "EnumMember";
                SymbolFlags3[SymbolFlags3["Function"] = 16] = "Function";
                SymbolFlags3[SymbolFlags3["Class"] = 32] = "Class";
                SymbolFlags3[SymbolFlags3["Interface"] = 64] = "Interface";
                SymbolFlags3[SymbolFlags3["ConstEnum"] = 128] = "ConstEnum";
                SymbolFlags3[SymbolFlags3["RegularEnum"] = 256] = "RegularEnum";
                SymbolFlags3[SymbolFlags3["ValueModule"] = 512] = "ValueModule";
                SymbolFlags3[SymbolFlags3["NamespaceModule"] = 1024] = "NamespaceModule";
                SymbolFlags3[SymbolFlags3["TypeLiteral"] = 2048] = "TypeLiteral";
                SymbolFlags3[SymbolFlags3["ObjectLiteral"] = 4096] = "ObjectLiteral";
                SymbolFlags3[SymbolFlags3["Method"] = 8192] = "Method";
                SymbolFlags3[SymbolFlags3["Constructor"] = 16384] = "Constructor";
                SymbolFlags3[SymbolFlags3["GetAccessor"] = 32768] = "GetAccessor";
                SymbolFlags3[SymbolFlags3["SetAccessor"] = 65536] = "SetAccessor";
                SymbolFlags3[SymbolFlags3["Signature"] = 131072] = "Signature";
                SymbolFlags3[SymbolFlags3["TypeParameter"] = 262144] = "TypeParameter";
                SymbolFlags3[SymbolFlags3["TypeAlias"] = 524288] = "TypeAlias";
                SymbolFlags3[SymbolFlags3["ExportValue"] = 1048576] = "ExportValue";
                SymbolFlags3[SymbolFlags3["Alias"] = 2097152] = "Alias";
                SymbolFlags3[SymbolFlags3["Prototype"] = 4194304] = "Prototype";
                SymbolFlags3[SymbolFlags3["ExportStar"] = 8388608] = "ExportStar";
                SymbolFlags3[SymbolFlags3["Optional"] = 16777216] = "Optional";
                SymbolFlags3[SymbolFlags3["Transient"] = 33554432] = "Transient";
                SymbolFlags3[SymbolFlags3["Assignment"] = 67108864] = "Assignment";
                SymbolFlags3[SymbolFlags3["ModuleExports"] = 134217728] = "ModuleExports";
                SymbolFlags3[SymbolFlags3["All"] = 67108863] = "All";
                SymbolFlags3[SymbolFlags3["Enum"] = 384] = "Enum";
                SymbolFlags3[SymbolFlags3["Variable"] = 3] = "Variable";
                SymbolFlags3[SymbolFlags3["Value"] = 111551] = "Value";
                SymbolFlags3[SymbolFlags3["Type"] = 788968] = "Type";
                SymbolFlags3[SymbolFlags3["Namespace"] = 1920] = "Namespace";
                SymbolFlags3[SymbolFlags3["Module"] = 1536] = "Module";
                SymbolFlags3[SymbolFlags3["Accessor"] = 98304] = "Accessor";
                SymbolFlags3[SymbolFlags3["FunctionScopedVariableExcludes"] = 111550] = "FunctionScopedVariableExcludes";
                SymbolFlags3[SymbolFlags3["BlockScopedVariableExcludes"] = 111551 /* Value */ ] = "BlockScopedVariableExcludes";
                SymbolFlags3[SymbolFlags3["ParameterExcludes"] = 111551 /* Value */ ] = "ParameterExcludes";
                SymbolFlags3[SymbolFlags3["PropertyExcludes"] = 0 /* None */ ] = "PropertyExcludes";
                SymbolFlags3[SymbolFlags3["EnumMemberExcludes"] = 900095] = "EnumMemberExcludes";
                SymbolFlags3[SymbolFlags3["FunctionExcludes"] = 110991] = "FunctionExcludes";
                SymbolFlags3[SymbolFlags3["ClassExcludes"] = 899503] = "ClassExcludes";
                SymbolFlags3[SymbolFlags3["InterfaceExcludes"] = 788872] = "InterfaceExcludes";
                SymbolFlags3[SymbolFlags3["RegularEnumExcludes"] = 899327] = "RegularEnumExcludes";
                SymbolFlags3[SymbolFlags3["ConstEnumExcludes"] = 899967] = "ConstEnumExcludes";
                SymbolFlags3[SymbolFlags3["ValueModuleExcludes"] = 110735] = "ValueModuleExcludes";
                SymbolFlags3[SymbolFlags3["NamespaceModuleExcludes"] = 0] = "NamespaceModuleExcludes";
                SymbolFlags3[SymbolFlags3["MethodExcludes"] = 103359] = "MethodExcludes";
                SymbolFlags3[SymbolFlags3["GetAccessorExcludes"] = 46015] = "GetAccessorExcludes";
                SymbolFlags3[SymbolFlags3["SetAccessorExcludes"] = 78783] = "SetAccessorExcludes";
                SymbolFlags3[SymbolFlags3["AccessorExcludes"] = 13247] = "AccessorExcludes";
                SymbolFlags3[SymbolFlags3["TypeParameterExcludes"] = 526824] = "TypeParameterExcludes";
                SymbolFlags3[SymbolFlags3["TypeAliasExcludes"] = 788968 /* Type */ ] = "TypeAliasExcludes";
                SymbolFlags3[SymbolFlags3["AliasExcludes"] = 2097152 /* Alias */ ] = "AliasExcludes";
                SymbolFlags3[SymbolFlags3["ModuleMember"] = 2623475] = "ModuleMember";
                SymbolFlags3[SymbolFlags3["ExportHasLocal"] = 944] = "ExportHasLocal";
                SymbolFlags3[SymbolFlags3["BlockScoped"] = 418] = "BlockScoped";
                SymbolFlags3[SymbolFlags3["PropertyOrAccessor"] = 98308] = "PropertyOrAccessor";
                SymbolFlags3[SymbolFlags3["ClassMember"] = 106500] = "ClassMember";
                SymbolFlags3[SymbolFlags3["ExportSupportsDefaultModifier"] = 112] = "ExportSupportsDefaultModifier";
                SymbolFlags3[SymbolFlags3["ExportDoesNotSupportDefaultModifier"] = -113] = "ExportDoesNotSupportDefaultModifier";
                SymbolFlags3[SymbolFlags3["Classifiable"] = 2885600] = "Classifiable";
                SymbolFlags3[SymbolFlags3["LateBindingContainer"] = 6256] = "LateBindingContainer";
                return SymbolFlags3;
            })(SymbolFlags || {});
            EnumKind = /* @__PURE__ */ ((EnumKind2)=>{
                EnumKind2[EnumKind2["Numeric"] = 0] = "Numeric";
                EnumKind2[EnumKind2["Literal"] = 1] = "Literal";
                return EnumKind2;
            })(EnumKind || {});
            CheckFlags = /* @__PURE__ */ ((CheckFlags2)=>{
                CheckFlags2[CheckFlags2["None"] = 0] = "None";
                CheckFlags2[CheckFlags2["Instantiated"] = 1] = "Instantiated";
                CheckFlags2[CheckFlags2["SyntheticProperty"] = 2] = "SyntheticProperty";
                CheckFlags2[CheckFlags2["SyntheticMethod"] = 4] = "SyntheticMethod";
                CheckFlags2[CheckFlags2["Readonly"] = 8] = "Readonly";
                CheckFlags2[CheckFlags2["ReadPartial"] = 16] = "ReadPartial";
                CheckFlags2[CheckFlags2["WritePartial"] = 32] = "WritePartial";
                CheckFlags2[CheckFlags2["HasNonUniformType"] = 64] = "HasNonUniformType";
                CheckFlags2[CheckFlags2["HasLiteralType"] = 128] = "HasLiteralType";
                CheckFlags2[CheckFlags2["ContainsPublic"] = 256] = "ContainsPublic";
                CheckFlags2[CheckFlags2["ContainsProtected"] = 512] = "ContainsProtected";
                CheckFlags2[CheckFlags2["ContainsPrivate"] = 1024] = "ContainsPrivate";
                CheckFlags2[CheckFlags2["ContainsStatic"] = 2048] = "ContainsStatic";
                CheckFlags2[CheckFlags2["Late"] = 4096] = "Late";
                CheckFlags2[CheckFlags2["ReverseMapped"] = 8192] = "ReverseMapped";
                CheckFlags2[CheckFlags2["OptionalParameter"] = 16384] = "OptionalParameter";
                CheckFlags2[CheckFlags2["RestParameter"] = 32768] = "RestParameter";
                CheckFlags2[CheckFlags2["DeferredType"] = 65536] = "DeferredType";
                CheckFlags2[CheckFlags2["HasNeverType"] = 131072] = "HasNeverType";
                CheckFlags2[CheckFlags2["Mapped"] = 262144] = "Mapped";
                CheckFlags2[CheckFlags2["StripOptional"] = 524288] = "StripOptional";
                CheckFlags2[CheckFlags2["Unresolved"] = 1048576] = "Unresolved";
                CheckFlags2[CheckFlags2["Synthetic"] = 6] = "Synthetic";
                CheckFlags2[CheckFlags2["Discriminant"] = 192] = "Discriminant";
                CheckFlags2[CheckFlags2["Partial"] = 48] = "Partial";
                return CheckFlags2;
            })(CheckFlags || {});
            InternalSymbolName = /* @__PURE__ */ ((InternalSymbolName2)=>{
                InternalSymbolName2["Call"] = "__call";
                InternalSymbolName2["Constructor"] = "__constructor";
                InternalSymbolName2["New"] = "__new";
                InternalSymbolName2["Index"] = "__index";
                InternalSymbolName2["ExportStar"] = "__export";
                InternalSymbolName2["Global"] = "__global";
                InternalSymbolName2["Missing"] = "__missing";
                InternalSymbolName2["Type"] = "__type";
                InternalSymbolName2["Object"] = "__object";
                InternalSymbolName2["JSXAttributes"] = "__jsxAttributes";
                InternalSymbolName2["Class"] = "__class";
                InternalSymbolName2["Function"] = "__function";
                InternalSymbolName2["Computed"] = "__computed";
                InternalSymbolName2["Resolving"] = "__resolving__";
                InternalSymbolName2["ExportEquals"] = "export=";
                InternalSymbolName2["Default"] = "default";
                InternalSymbolName2["This"] = "this";
                return InternalSymbolName2;
            })(InternalSymbolName || {});
            NodeCheckFlags = /* @__PURE__ */ ((NodeCheckFlags2)=>{
                NodeCheckFlags2[NodeCheckFlags2["None"] = 0] = "None";
                NodeCheckFlags2[NodeCheckFlags2["TypeChecked"] = 1] = "TypeChecked";
                NodeCheckFlags2[NodeCheckFlags2["LexicalThis"] = 2] = "LexicalThis";
                NodeCheckFlags2[NodeCheckFlags2["CaptureThis"] = 4] = "CaptureThis";
                NodeCheckFlags2[NodeCheckFlags2["CaptureNewTarget"] = 8] = "CaptureNewTarget";
                NodeCheckFlags2[NodeCheckFlags2["SuperInstance"] = 16] = "SuperInstance";
                NodeCheckFlags2[NodeCheckFlags2["SuperStatic"] = 32] = "SuperStatic";
                NodeCheckFlags2[NodeCheckFlags2["ContextChecked"] = 64] = "ContextChecked";
                NodeCheckFlags2[NodeCheckFlags2["MethodWithSuperPropertyAccessInAsync"] = 128] = "MethodWithSuperPropertyAccessInAsync";
                NodeCheckFlags2[NodeCheckFlags2["MethodWithSuperPropertyAssignmentInAsync"] = 256] = "MethodWithSuperPropertyAssignmentInAsync";
                NodeCheckFlags2[NodeCheckFlags2["CaptureArguments"] = 512] = "CaptureArguments";
                NodeCheckFlags2[NodeCheckFlags2["EnumValuesComputed"] = 1024] = "EnumValuesComputed";
                NodeCheckFlags2[NodeCheckFlags2["LexicalModuleMergesWithClass"] = 2048] = "LexicalModuleMergesWithClass";
                NodeCheckFlags2[NodeCheckFlags2["LoopWithCapturedBlockScopedBinding"] = 4096] = "LoopWithCapturedBlockScopedBinding";
                NodeCheckFlags2[NodeCheckFlags2["ContainsCapturedBlockScopeBinding"] = 8192] = "ContainsCapturedBlockScopeBinding";
                NodeCheckFlags2[NodeCheckFlags2["CapturedBlockScopedBinding"] = 16384] = "CapturedBlockScopedBinding";
                NodeCheckFlags2[NodeCheckFlags2["BlockScopedBindingInLoop"] = 32768] = "BlockScopedBindingInLoop";
                NodeCheckFlags2[NodeCheckFlags2["ClassWithBodyScopedClassBinding"] = 65536] = "ClassWithBodyScopedClassBinding";
                NodeCheckFlags2[NodeCheckFlags2["BodyScopedClassBinding"] = 131072] = "BodyScopedClassBinding";
                NodeCheckFlags2[NodeCheckFlags2["NeedsLoopOutParameter"] = 262144] = "NeedsLoopOutParameter";
                NodeCheckFlags2[NodeCheckFlags2["AssignmentsMarked"] = 524288] = "AssignmentsMarked";
                NodeCheckFlags2[NodeCheckFlags2["ClassWithConstructorReference"] = 1048576] = "ClassWithConstructorReference";
                NodeCheckFlags2[NodeCheckFlags2["ConstructorReferenceInClass"] = 2097152] = "ConstructorReferenceInClass";
                NodeCheckFlags2[NodeCheckFlags2["ContainsClassWithPrivateIdentifiers"] = 4194304] = "ContainsClassWithPrivateIdentifiers";
                NodeCheckFlags2[NodeCheckFlags2["ContainsSuperPropertyInStaticInitializer"] = 8388608] = "ContainsSuperPropertyInStaticInitializer";
                NodeCheckFlags2[NodeCheckFlags2["InCheckIdentifier"] = 16777216] = "InCheckIdentifier";
                return NodeCheckFlags2;
            })(NodeCheckFlags || {});
            TypeFlags = /* @__PURE__ */ ((TypeFlags2)=>{
                TypeFlags2[TypeFlags2["Any"] = 1] = "Any";
                TypeFlags2[TypeFlags2["Unknown"] = 2] = "Unknown";
                TypeFlags2[TypeFlags2["String"] = 4] = "String";
                TypeFlags2[TypeFlags2["Number"] = 8] = "Number";
                TypeFlags2[TypeFlags2["Boolean"] = 16] = "Boolean";
                TypeFlags2[TypeFlags2["Enum"] = 32] = "Enum";
                TypeFlags2[TypeFlags2["BigInt"] = 64] = "BigInt";
                TypeFlags2[TypeFlags2["StringLiteral"] = 128] = "StringLiteral";
                TypeFlags2[TypeFlags2["NumberLiteral"] = 256] = "NumberLiteral";
                TypeFlags2[TypeFlags2["BooleanLiteral"] = 512] = "BooleanLiteral";
                TypeFlags2[TypeFlags2["EnumLiteral"] = 1024] = "EnumLiteral";
                TypeFlags2[TypeFlags2["BigIntLiteral"] = 2048] = "BigIntLiteral";
                TypeFlags2[TypeFlags2["ESSymbol"] = 4096] = "ESSymbol";
                TypeFlags2[TypeFlags2["UniqueESSymbol"] = 8192] = "UniqueESSymbol";
                TypeFlags2[TypeFlags2["Void"] = 16384] = "Void";
                TypeFlags2[TypeFlags2["Undefined"] = 32768] = "Undefined";
                TypeFlags2[TypeFlags2["Null"] = 65536] = "Null";
                TypeFlags2[TypeFlags2["Never"] = 131072] = "Never";
                TypeFlags2[TypeFlags2["TypeParameter"] = 262144] = "TypeParameter";
                TypeFlags2[TypeFlags2["Object"] = 524288] = "Object";
                TypeFlags2[TypeFlags2["Union"] = 1048576] = "Union";
                TypeFlags2[TypeFlags2["Intersection"] = 2097152] = "Intersection";
                TypeFlags2[TypeFlags2["Index"] = 4194304] = "Index";
                TypeFlags2[TypeFlags2["IndexedAccess"] = 8388608] = "IndexedAccess";
                TypeFlags2[TypeFlags2["Conditional"] = 16777216] = "Conditional";
                TypeFlags2[TypeFlags2["Substitution"] = 33554432] = "Substitution";
                TypeFlags2[TypeFlags2["NonPrimitive"] = 67108864] = "NonPrimitive";
                TypeFlags2[TypeFlags2["TemplateLiteral"] = 134217728] = "TemplateLiteral";
                TypeFlags2[TypeFlags2["StringMapping"] = 268435456] = "StringMapping";
                TypeFlags2[TypeFlags2["AnyOrUnknown"] = 3] = "AnyOrUnknown";
                TypeFlags2[TypeFlags2["Nullable"] = 98304] = "Nullable";
                TypeFlags2[TypeFlags2["Literal"] = 2944] = "Literal";
                TypeFlags2[TypeFlags2["Unit"] = 109472] = "Unit";
                TypeFlags2[TypeFlags2["Freshable"] = 2976] = "Freshable";
                TypeFlags2[TypeFlags2["StringOrNumberLiteral"] = 384] = "StringOrNumberLiteral";
                TypeFlags2[TypeFlags2["StringOrNumberLiteralOrUnique"] = 8576] = "StringOrNumberLiteralOrUnique";
                TypeFlags2[TypeFlags2["DefinitelyFalsy"] = 117632] = "DefinitelyFalsy";
                TypeFlags2[TypeFlags2["PossiblyFalsy"] = 117724] = "PossiblyFalsy";
                TypeFlags2[TypeFlags2["Intrinsic"] = 67359327] = "Intrinsic";
                TypeFlags2[TypeFlags2["StringLike"] = 402653316] = "StringLike";
                TypeFlags2[TypeFlags2["NumberLike"] = 296] = "NumberLike";
                TypeFlags2[TypeFlags2["BigIntLike"] = 2112] = "BigIntLike";
                TypeFlags2[TypeFlags2["BooleanLike"] = 528] = "BooleanLike";
                TypeFlags2[TypeFlags2["EnumLike"] = 1056] = "EnumLike";
                TypeFlags2[TypeFlags2["ESSymbolLike"] = 12288] = "ESSymbolLike";
                TypeFlags2[TypeFlags2["VoidLike"] = 49152] = "VoidLike";
                TypeFlags2[TypeFlags2["Primitive"] = 402784252] = "Primitive";
                TypeFlags2[TypeFlags2["DefinitelyNonNullable"] = 470302716] = "DefinitelyNonNullable";
                TypeFlags2[TypeFlags2["DisjointDomains"] = 469892092] = "DisjointDomains";
                TypeFlags2[TypeFlags2["UnionOrIntersection"] = 3145728] = "UnionOrIntersection";
                TypeFlags2[TypeFlags2["StructuredType"] = 3670016] = "StructuredType";
                TypeFlags2[TypeFlags2["TypeVariable"] = 8650752] = "TypeVariable";
                TypeFlags2[TypeFlags2["InstantiableNonPrimitive"] = 58982400] = "InstantiableNonPrimitive";
                TypeFlags2[TypeFlags2["InstantiablePrimitive"] = 406847488] = "InstantiablePrimitive";
                TypeFlags2[TypeFlags2["Instantiable"] = 465829888] = "Instantiable";
                TypeFlags2[TypeFlags2["StructuredOrInstantiable"] = 469499904] = "StructuredOrInstantiable";
                TypeFlags2[TypeFlags2["ObjectFlagsType"] = 138117121] = "ObjectFlagsType";
                TypeFlags2[TypeFlags2["Simplifiable"] = 25165824] = "Simplifiable";
                TypeFlags2[TypeFlags2["Singleton"] = 67358815] = "Singleton";
                TypeFlags2[TypeFlags2["Narrowable"] = 536624127] = "Narrowable";
                TypeFlags2[TypeFlags2["IncludesMask"] = 473694207] = "IncludesMask";
                TypeFlags2[TypeFlags2["IncludesMissingType"] = 262144 /* TypeParameter */ ] = "IncludesMissingType";
                TypeFlags2[TypeFlags2["IncludesNonWideningType"] = 4194304 /* Index */ ] = "IncludesNonWideningType";
                TypeFlags2[TypeFlags2["IncludesWildcard"] = 8388608 /* IndexedAccess */ ] = "IncludesWildcard";
                TypeFlags2[TypeFlags2["IncludesEmptyObject"] = 16777216 /* Conditional */ ] = "IncludesEmptyObject";
                TypeFlags2[TypeFlags2["IncludesInstantiable"] = 33554432 /* Substitution */ ] = "IncludesInstantiable";
                TypeFlags2[TypeFlags2["NotPrimitiveUnion"] = 36323331] = "NotPrimitiveUnion";
                return TypeFlags2;
            })(TypeFlags || {});
            ObjectFlags = /* @__PURE__ */ ((ObjectFlags3)=>{
                ObjectFlags3[ObjectFlags3["None"] = 0] = "None";
                ObjectFlags3[ObjectFlags3["Class"] = 1] = "Class";
                ObjectFlags3[ObjectFlags3["Interface"] = 2] = "Interface";
                ObjectFlags3[ObjectFlags3["Reference"] = 4] = "Reference";
                ObjectFlags3[ObjectFlags3["Tuple"] = 8] = "Tuple";
                ObjectFlags3[ObjectFlags3["Anonymous"] = 16] = "Anonymous";
                ObjectFlags3[ObjectFlags3["Mapped"] = 32] = "Mapped";
                ObjectFlags3[ObjectFlags3["Instantiated"] = 64] = "Instantiated";
                ObjectFlags3[ObjectFlags3["ObjectLiteral"] = 128] = "ObjectLiteral";
                ObjectFlags3[ObjectFlags3["EvolvingArray"] = 256] = "EvolvingArray";
                ObjectFlags3[ObjectFlags3["ObjectLiteralPatternWithComputedProperties"] = 512] = "ObjectLiteralPatternWithComputedProperties";
                ObjectFlags3[ObjectFlags3["ReverseMapped"] = 1024] = "ReverseMapped";
                ObjectFlags3[ObjectFlags3["JsxAttributes"] = 2048] = "JsxAttributes";
                ObjectFlags3[ObjectFlags3["JSLiteral"] = 4096] = "JSLiteral";
                ObjectFlags3[ObjectFlags3["FreshLiteral"] = 8192] = "FreshLiteral";
                ObjectFlags3[ObjectFlags3["ArrayLiteral"] = 16384] = "ArrayLiteral";
                ObjectFlags3[ObjectFlags3["PrimitiveUnion"] = 32768] = "PrimitiveUnion";
                ObjectFlags3[ObjectFlags3["ContainsWideningType"] = 65536] = "ContainsWideningType";
                ObjectFlags3[ObjectFlags3["ContainsObjectOrArrayLiteral"] = 131072] = "ContainsObjectOrArrayLiteral";
                ObjectFlags3[ObjectFlags3["NonInferrableType"] = 262144] = "NonInferrableType";
                ObjectFlags3[ObjectFlags3["CouldContainTypeVariablesComputed"] = 524288] = "CouldContainTypeVariablesComputed";
                ObjectFlags3[ObjectFlags3["CouldContainTypeVariables"] = 1048576] = "CouldContainTypeVariables";
                ObjectFlags3[ObjectFlags3["ClassOrInterface"] = 3] = "ClassOrInterface";
                ObjectFlags3[ObjectFlags3["RequiresWidening"] = 196608] = "RequiresWidening";
                ObjectFlags3[ObjectFlags3["PropagatingFlags"] = 458752] = "PropagatingFlags";
                ObjectFlags3[ObjectFlags3["ObjectTypeKindMask"] = 1343] = "ObjectTypeKindMask";
                ObjectFlags3[ObjectFlags3["ContainsSpread"] = 2097152] = "ContainsSpread";
                ObjectFlags3[ObjectFlags3["ObjectRestType"] = 4194304] = "ObjectRestType";
                ObjectFlags3[ObjectFlags3["InstantiationExpressionType"] = 8388608] = "InstantiationExpressionType";
                ObjectFlags3[ObjectFlags3["IsClassInstanceClone"] = 16777216] = "IsClassInstanceClone";
                ObjectFlags3[ObjectFlags3["IdenticalBaseTypeCalculated"] = 33554432] = "IdenticalBaseTypeCalculated";
                ObjectFlags3[ObjectFlags3["IdenticalBaseTypeExists"] = 67108864] = "IdenticalBaseTypeExists";
                ObjectFlags3[ObjectFlags3["IsGenericTypeComputed"] = 2097152] = "IsGenericTypeComputed";
                ObjectFlags3[ObjectFlags3["IsGenericObjectType"] = 4194304] = "IsGenericObjectType";
                ObjectFlags3[ObjectFlags3["IsGenericIndexType"] = 8388608] = "IsGenericIndexType";
                ObjectFlags3[ObjectFlags3["IsGenericType"] = 12582912] = "IsGenericType";
                ObjectFlags3[ObjectFlags3["ContainsIntersections"] = 16777216] = "ContainsIntersections";
                ObjectFlags3[ObjectFlags3["IsUnknownLikeUnionComputed"] = 33554432] = "IsUnknownLikeUnionComputed";
                ObjectFlags3[ObjectFlags3["IsUnknownLikeUnion"] = 67108864] = "IsUnknownLikeUnion";
                ObjectFlags3[ObjectFlags3["IsNeverIntersectionComputed"] = 16777216] = "IsNeverIntersectionComputed";
                ObjectFlags3[ObjectFlags3["IsNeverIntersection"] = 33554432] = "IsNeverIntersection";
                return ObjectFlags3;
            })(ObjectFlags || {});
            VarianceFlags = /* @__PURE__ */ ((VarianceFlags2)=>{
                VarianceFlags2[VarianceFlags2["Invariant"] = 0] = "Invariant";
                VarianceFlags2[VarianceFlags2["Covariant"] = 1] = "Covariant";
                VarianceFlags2[VarianceFlags2["Contravariant"] = 2] = "Contravariant";
                VarianceFlags2[VarianceFlags2["Bivariant"] = 3] = "Bivariant";
                VarianceFlags2[VarianceFlags2["Independent"] = 4] = "Independent";
                VarianceFlags2[VarianceFlags2["VarianceMask"] = 7] = "VarianceMask";
                VarianceFlags2[VarianceFlags2["Unmeasurable"] = 8] = "Unmeasurable";
                VarianceFlags2[VarianceFlags2["Unreliable"] = 16] = "Unreliable";
                VarianceFlags2[VarianceFlags2["AllowsStructuralFallback"] = 24] = "AllowsStructuralFallback";
                return VarianceFlags2;
            })(VarianceFlags || {});
            ElementFlags = /* @__PURE__ */ ((ElementFlags2)=>{
                ElementFlags2[ElementFlags2["Required"] = 1] = "Required";
                ElementFlags2[ElementFlags2["Optional"] = 2] = "Optional";
                ElementFlags2[ElementFlags2["Rest"] = 4] = "Rest";
                ElementFlags2[ElementFlags2["Variadic"] = 8] = "Variadic";
                ElementFlags2[ElementFlags2["Fixed"] = 3] = "Fixed";
                ElementFlags2[ElementFlags2["Variable"] = 12] = "Variable";
                ElementFlags2[ElementFlags2["NonRequired"] = 14] = "NonRequired";
                ElementFlags2[ElementFlags2["NonRest"] = 11] = "NonRest";
                return ElementFlags2;
            })(ElementFlags || {});
            AccessFlags = /* @__PURE__ */ ((AccessFlags2)=>{
                AccessFlags2[AccessFlags2["None"] = 0] = "None";
                AccessFlags2[AccessFlags2["IncludeUndefined"] = 1] = "IncludeUndefined";
                AccessFlags2[AccessFlags2["NoIndexSignatures"] = 2] = "NoIndexSignatures";
                AccessFlags2[AccessFlags2["Writing"] = 4] = "Writing";
                AccessFlags2[AccessFlags2["CacheSymbol"] = 8] = "CacheSymbol";
                AccessFlags2[AccessFlags2["NoTupleBoundsCheck"] = 16] = "NoTupleBoundsCheck";
                AccessFlags2[AccessFlags2["ExpressionPosition"] = 32] = "ExpressionPosition";
                AccessFlags2[AccessFlags2["ReportDeprecated"] = 64] = "ReportDeprecated";
                AccessFlags2[AccessFlags2["SuppressNoImplicitAnyError"] = 128] = "SuppressNoImplicitAnyError";
                AccessFlags2[AccessFlags2["Contextual"] = 256] = "Contextual";
                AccessFlags2[AccessFlags2["Persistent"] = 1 /* IncludeUndefined */ ] = "Persistent";
                return AccessFlags2;
            })(AccessFlags || {});
            IndexFlags = /* @__PURE__ */ ((IndexFlags2)=>{
                IndexFlags2[IndexFlags2["None"] = 0] = "None";
                IndexFlags2[IndexFlags2["StringsOnly"] = 1] = "StringsOnly";
                IndexFlags2[IndexFlags2["NoIndexSignatures"] = 2] = "NoIndexSignatures";
                IndexFlags2[IndexFlags2["NoReducibleCheck"] = 4] = "NoReducibleCheck";
                return IndexFlags2;
            })(IndexFlags || {});
            JsxReferenceKind = /* @__PURE__ */ ((JsxReferenceKind2)=>{
                JsxReferenceKind2[JsxReferenceKind2["Component"] = 0] = "Component";
                JsxReferenceKind2[JsxReferenceKind2["Function"] = 1] = "Function";
                JsxReferenceKind2[JsxReferenceKind2["Mixed"] = 2] = "Mixed";
                return JsxReferenceKind2;
            })(JsxReferenceKind || {});
            SignatureKind = /* @__PURE__ */ ((SignatureKind2)=>{
                SignatureKind2[SignatureKind2["Call"] = 0] = "Call";
                SignatureKind2[SignatureKind2["Construct"] = 1] = "Construct";
                return SignatureKind2;
            })(SignatureKind || {});
            SignatureFlags = /* @__PURE__ */ ((SignatureFlags5)=>{
                SignatureFlags5[SignatureFlags5["None"] = 0] = "None";
                SignatureFlags5[SignatureFlags5["HasRestParameter"] = 1] = "HasRestParameter";
                SignatureFlags5[SignatureFlags5["HasLiteralTypes"] = 2] = "HasLiteralTypes";
                SignatureFlags5[SignatureFlags5["Abstract"] = 4] = "Abstract";
                SignatureFlags5[SignatureFlags5["IsInnerCallChain"] = 8] = "IsInnerCallChain";
                SignatureFlags5[SignatureFlags5["IsOuterCallChain"] = 16] = "IsOuterCallChain";
                SignatureFlags5[SignatureFlags5["IsUntypedSignatureInJSFile"] = 32] = "IsUntypedSignatureInJSFile";
                SignatureFlags5[SignatureFlags5["IsNonInferrable"] = 64] = "IsNonInferrable";
                SignatureFlags5[SignatureFlags5["PropagatingFlags"] = 39] = "PropagatingFlags";
                SignatureFlags5[SignatureFlags5["CallChainFlags"] = 24] = "CallChainFlags";
                return SignatureFlags5;
            })(SignatureFlags || {});
            IndexKind = /* @__PURE__ */ ((IndexKind2)=>{
                IndexKind2[IndexKind2["String"] = 0] = "String";
                IndexKind2[IndexKind2["Number"] = 1] = "Number";
                return IndexKind2;
            })(IndexKind || {});
            TypeMapKind = /* @__PURE__ */ ((TypeMapKind2)=>{
                TypeMapKind2[TypeMapKind2["Simple"] = 0] = "Simple";
                TypeMapKind2[TypeMapKind2["Array"] = 1] = "Array";
                TypeMapKind2[TypeMapKind2["Deferred"] = 2] = "Deferred";
                TypeMapKind2[TypeMapKind2["Function"] = 3] = "Function";
                TypeMapKind2[TypeMapKind2["Composite"] = 4] = "Composite";
                TypeMapKind2[TypeMapKind2["Merged"] = 5] = "Merged";
                return TypeMapKind2;
            })(TypeMapKind || {});
            InferencePriority = /* @__PURE__ */ ((InferencePriority2)=>{
                InferencePriority2[InferencePriority2["None"] = 0] = "None";
                InferencePriority2[InferencePriority2["NakedTypeVariable"] = 1] = "NakedTypeVariable";
                InferencePriority2[InferencePriority2["SpeculativeTuple"] = 2] = "SpeculativeTuple";
                InferencePriority2[InferencePriority2["SubstituteSource"] = 4] = "SubstituteSource";
                InferencePriority2[InferencePriority2["HomomorphicMappedType"] = 8] = "HomomorphicMappedType";
                InferencePriority2[InferencePriority2["PartialHomomorphicMappedType"] = 16] = "PartialHomomorphicMappedType";
                InferencePriority2[InferencePriority2["MappedTypeConstraint"] = 32] = "MappedTypeConstraint";
                InferencePriority2[InferencePriority2["ContravariantConditional"] = 64] = "ContravariantConditional";
                InferencePriority2[InferencePriority2["ReturnType"] = 128] = "ReturnType";
                InferencePriority2[InferencePriority2["LiteralKeyof"] = 256] = "LiteralKeyof";
                InferencePriority2[InferencePriority2["NoConstraints"] = 512] = "NoConstraints";
                InferencePriority2[InferencePriority2["AlwaysStrict"] = 1024] = "AlwaysStrict";
                InferencePriority2[InferencePriority2["MaxValue"] = 2048] = "MaxValue";
                InferencePriority2[InferencePriority2["PriorityImpliesCombination"] = 416] = "PriorityImpliesCombination";
                InferencePriority2[InferencePriority2["Circularity"] = -1] = "Circularity";
                return InferencePriority2;
            })(InferencePriority || {});
            InferenceFlags = /* @__PURE__ */ ((InferenceFlags2)=>{
                InferenceFlags2[InferenceFlags2["None"] = 0] = "None";
                InferenceFlags2[InferenceFlags2["NoDefault"] = 1] = "NoDefault";
                InferenceFlags2[InferenceFlags2["AnyDefault"] = 2] = "AnyDefault";
                InferenceFlags2[InferenceFlags2["SkippedGenericFunction"] = 4] = "SkippedGenericFunction";
                return InferenceFlags2;
            })(InferenceFlags || {});
            Ternary = /* @__PURE__ */ ((Ternary2)=>{
                Ternary2[Ternary2["False"] = 0] = "False";
                Ternary2[Ternary2["Unknown"] = 1] = "Unknown";
                Ternary2[Ternary2["Maybe"] = 3] = "Maybe";
                Ternary2[Ternary2["True"] = -1] = "True";
                return Ternary2;
            })(Ternary || {});
            AssignmentDeclarationKind = /* @__PURE__ */ ((AssignmentDeclarationKind2)=>{
                AssignmentDeclarationKind2[AssignmentDeclarationKind2["None"] = 0] = "None";
                AssignmentDeclarationKind2[AssignmentDeclarationKind2["ExportsProperty"] = 1] = "ExportsProperty";
                AssignmentDeclarationKind2[AssignmentDeclarationKind2["ModuleExports"] = 2] = "ModuleExports";
                AssignmentDeclarationKind2[AssignmentDeclarationKind2["PrototypeProperty"] = 3] = "PrototypeProperty";
                AssignmentDeclarationKind2[AssignmentDeclarationKind2["ThisProperty"] = 4] = "ThisProperty";
                AssignmentDeclarationKind2[AssignmentDeclarationKind2["Property"] = 5] = "Property";
                AssignmentDeclarationKind2[AssignmentDeclarationKind2["Prototype"] = 6] = "Prototype";
                AssignmentDeclarationKind2[AssignmentDeclarationKind2["ObjectDefinePropertyValue"] = 7] = "ObjectDefinePropertyValue";
                AssignmentDeclarationKind2[AssignmentDeclarationKind2["ObjectDefinePropertyExports"] = 8] = "ObjectDefinePropertyExports";
                AssignmentDeclarationKind2[AssignmentDeclarationKind2["ObjectDefinePrototypeProperty"] = 9] = "ObjectDefinePrototypeProperty";
                return AssignmentDeclarationKind2;
            })(AssignmentDeclarationKind || {});
            DiagnosticCategory = /* @__PURE__ */ ((DiagnosticCategory2)=>{
                DiagnosticCategory2[DiagnosticCategory2["Warning"] = 0] = "Warning";
                DiagnosticCategory2[DiagnosticCategory2["Error"] = 1] = "Error";
                DiagnosticCategory2[DiagnosticCategory2["Suggestion"] = 2] = "Suggestion";
                DiagnosticCategory2[DiagnosticCategory2["Message"] = 3] = "Message";
                return DiagnosticCategory2;
            })(DiagnosticCategory || {});
            ModuleResolutionKind = /* @__PURE__ */ ((ModuleResolutionKind2)=>{
                ModuleResolutionKind2[ModuleResolutionKind2["Classic"] = 1] = "Classic";
                ModuleResolutionKind2[ModuleResolutionKind2["NodeJs"] = 2] = "NodeJs";
                ModuleResolutionKind2[ModuleResolutionKind2["Node10"] = 2] = "Node10";
                ModuleResolutionKind2[ModuleResolutionKind2["Node16"] = 3] = "Node16";
                ModuleResolutionKind2[ModuleResolutionKind2["NodeNext"] = 99] = "NodeNext";
                ModuleResolutionKind2[ModuleResolutionKind2["Bundler"] = 100] = "Bundler";
                return ModuleResolutionKind2;
            })(ModuleResolutionKind || {});
            ModuleDetectionKind = /* @__PURE__ */ ((ModuleDetectionKind2)=>{
                ModuleDetectionKind2[ModuleDetectionKind2["Legacy"] = 1] = "Legacy";
                ModuleDetectionKind2[ModuleDetectionKind2["Auto"] = 2] = "Auto";
                ModuleDetectionKind2[ModuleDetectionKind2["Force"] = 3] = "Force";
                return ModuleDetectionKind2;
            })(ModuleDetectionKind || {});
            WatchFileKind = /* @__PURE__ */ ((WatchFileKind2)=>{
                WatchFileKind2[WatchFileKind2["FixedPollingInterval"] = 0] = "FixedPollingInterval";
                WatchFileKind2[WatchFileKind2["PriorityPollingInterval"] = 1] = "PriorityPollingInterval";
                WatchFileKind2[WatchFileKind2["DynamicPriorityPolling"] = 2] = "DynamicPriorityPolling";
                WatchFileKind2[WatchFileKind2["FixedChunkSizePolling"] = 3] = "FixedChunkSizePolling";
                WatchFileKind2[WatchFileKind2["UseFsEvents"] = 4] = "UseFsEvents";
                WatchFileKind2[WatchFileKind2["UseFsEventsOnParentDirectory"] = 5] = "UseFsEventsOnParentDirectory";
                return WatchFileKind2;
            })(WatchFileKind || {});
            WatchDirectoryKind = /* @__PURE__ */ ((WatchDirectoryKind2)=>{
                WatchDirectoryKind2[WatchDirectoryKind2["UseFsEvents"] = 0] = "UseFsEvents";
                WatchDirectoryKind2[WatchDirectoryKind2["FixedPollingInterval"] = 1] = "FixedPollingInterval";
                WatchDirectoryKind2[WatchDirectoryKind2["DynamicPriorityPolling"] = 2] = "DynamicPriorityPolling";
                WatchDirectoryKind2[WatchDirectoryKind2["FixedChunkSizePolling"] = 3] = "FixedChunkSizePolling";
                return WatchDirectoryKind2;
            })(WatchDirectoryKind || {});
            PollingWatchKind = /* @__PURE__ */ ((PollingWatchKind2)=>{
                PollingWatchKind2[PollingWatchKind2["FixedInterval"] = 0] = "FixedInterval";
                PollingWatchKind2[PollingWatchKind2["PriorityInterval"] = 1] = "PriorityInterval";
                PollingWatchKind2[PollingWatchKind2["DynamicPriority"] = 2] = "DynamicPriority";
                PollingWatchKind2[PollingWatchKind2["FixedChunkSize"] = 3] = "FixedChunkSize";
                return PollingWatchKind2;
            })(PollingWatchKind || {});
            ModuleKind = /* @__PURE__ */ ((ModuleKind2)=>{
                ModuleKind2[ModuleKind2["None"] = 0] = "None";
                ModuleKind2[ModuleKind2["CommonJS"] = 1] = "CommonJS";
                ModuleKind2[ModuleKind2["AMD"] = 2] = "AMD";
                ModuleKind2[ModuleKind2["UMD"] = 3] = "UMD";
                ModuleKind2[ModuleKind2["System"] = 4] = "System";
                ModuleKind2[ModuleKind2["ES2015"] = 5] = "ES2015";
                ModuleKind2[ModuleKind2["ES2020"] = 6] = "ES2020";
                ModuleKind2[ModuleKind2["ES2022"] = 7] = "ES2022";
                ModuleKind2[ModuleKind2["ESNext"] = 99] = "ESNext";
                ModuleKind2[ModuleKind2["Node16"] = 100] = "Node16";
                ModuleKind2[ModuleKind2["NodeNext"] = 199] = "NodeNext";
                return ModuleKind2;
            })(ModuleKind || {});
            JsxEmit = /* @__PURE__ */ ((JsxEmit2)=>{
                JsxEmit2[JsxEmit2["None"] = 0] = "None";
                JsxEmit2[JsxEmit2["Preserve"] = 1] = "Preserve";
                JsxEmit2[JsxEmit2["React"] = 2] = "React";
                JsxEmit2[JsxEmit2["ReactNative"] = 3] = "ReactNative";
                JsxEmit2[JsxEmit2["ReactJSX"] = 4] = "ReactJSX";
                JsxEmit2[JsxEmit2["ReactJSXDev"] = 5] = "ReactJSXDev";
                return JsxEmit2;
            })(JsxEmit || {});
            ImportsNotUsedAsValues = /* @__PURE__ */ ((ImportsNotUsedAsValues2)=>{
                ImportsNotUsedAsValues2[ImportsNotUsedAsValues2["Remove"] = 0] = "Remove";
                ImportsNotUsedAsValues2[ImportsNotUsedAsValues2["Preserve"] = 1] = "Preserve";
                ImportsNotUsedAsValues2[ImportsNotUsedAsValues2["Error"] = 2] = "Error";
                return ImportsNotUsedAsValues2;
            })(ImportsNotUsedAsValues || {});
            NewLineKind = /* @__PURE__ */ ((NewLineKind2)=>{
                NewLineKind2[NewLineKind2["CarriageReturnLineFeed"] = 0] = "CarriageReturnLineFeed";
                NewLineKind2[NewLineKind2["LineFeed"] = 1] = "LineFeed";
                return NewLineKind2;
            })(NewLineKind || {});
            ScriptKind = /* @__PURE__ */ ((ScriptKind5)=>{
                ScriptKind5[ScriptKind5["Unknown"] = 0] = "Unknown";
                ScriptKind5[ScriptKind5["JS"] = 1] = "JS";
                ScriptKind5[ScriptKind5["JSX"] = 2] = "JSX";
                ScriptKind5[ScriptKind5["TS"] = 3] = "TS";
                ScriptKind5[ScriptKind5["TSX"] = 4] = "TSX";
                ScriptKind5[ScriptKind5["External"] = 5] = "External";
                ScriptKind5[ScriptKind5["JSON"] = 6] = "JSON";
                ScriptKind5[ScriptKind5["Deferred"] = 7] = "Deferred";
                return ScriptKind5;
            })(ScriptKind || {});
            ScriptTarget = /* @__PURE__ */ ((ScriptTarget10)=>{
                ScriptTarget10[ScriptTarget10["ES3"] = 0] = "ES3";
                ScriptTarget10[ScriptTarget10["ES5"] = 1] = "ES5";
                ScriptTarget10[ScriptTarget10["ES2015"] = 2] = "ES2015";
                ScriptTarget10[ScriptTarget10["ES2016"] = 3] = "ES2016";
                ScriptTarget10[ScriptTarget10["ES2017"] = 4] = "ES2017";
                ScriptTarget10[ScriptTarget10["ES2018"] = 5] = "ES2018";
                ScriptTarget10[ScriptTarget10["ES2019"] = 6] = "ES2019";
                ScriptTarget10[ScriptTarget10["ES2020"] = 7] = "ES2020";
                ScriptTarget10[ScriptTarget10["ES2021"] = 8] = "ES2021";
                ScriptTarget10[ScriptTarget10["ES2022"] = 9] = "ES2022";
                ScriptTarget10[ScriptTarget10["ESNext"] = 99] = "ESNext";
                ScriptTarget10[ScriptTarget10["JSON"] = 100] = "JSON";
                ScriptTarget10[ScriptTarget10["Latest"] = 99 /* ESNext */ ] = "Latest";
                return ScriptTarget10;
            })(ScriptTarget || {});
            LanguageVariant = /* @__PURE__ */ ((LanguageVariant4)=>{
                LanguageVariant4[LanguageVariant4["Standard"] = 0] = "Standard";
                LanguageVariant4[LanguageVariant4["JSX"] = 1] = "JSX";
                return LanguageVariant4;
            })(LanguageVariant || {});
            WatchDirectoryFlags = /* @__PURE__ */ ((WatchDirectoryFlags3)=>{
                WatchDirectoryFlags3[WatchDirectoryFlags3["None"] = 0] = "None";
                WatchDirectoryFlags3[WatchDirectoryFlags3["Recursive"] = 1] = "Recursive";
                return WatchDirectoryFlags3;
            })(WatchDirectoryFlags || {});
            CharacterCodes = /* @__PURE__ */ ((CharacterCodes2)=>{
                CharacterCodes2[CharacterCodes2["nullCharacter"] = 0] = "nullCharacter";
                CharacterCodes2[CharacterCodes2["maxAsciiCharacter"] = 127] = "maxAsciiCharacter";
                CharacterCodes2[CharacterCodes2["lineFeed"] = 10] = "lineFeed";
                CharacterCodes2[CharacterCodes2["carriageReturn"] = 13] = "carriageReturn";
                CharacterCodes2[CharacterCodes2["lineSeparator"] = 8232] = "lineSeparator";
                CharacterCodes2[CharacterCodes2["paragraphSeparator"] = 8233] = "paragraphSeparator";
                CharacterCodes2[CharacterCodes2["nextLine"] = 133] = "nextLine";
                CharacterCodes2[CharacterCodes2["space"] = 32] = "space";
                CharacterCodes2[CharacterCodes2["nonBreakingSpace"] = 160] = "nonBreakingSpace";
                CharacterCodes2[CharacterCodes2["enQuad"] = 8192] = "enQuad";
                CharacterCodes2[CharacterCodes2["emQuad"] = 8193] = "emQuad";
                CharacterCodes2[CharacterCodes2["enSpace"] = 8194] = "enSpace";
                CharacterCodes2[CharacterCodes2["emSpace"] = 8195] = "emSpace";
                CharacterCodes2[CharacterCodes2["threePerEmSpace"] = 8196] = "threePerEmSpace";
                CharacterCodes2[CharacterCodes2["fourPerEmSpace"] = 8197] = "fourPerEmSpace";
                CharacterCodes2[CharacterCodes2["sixPerEmSpace"] = 8198] = "sixPerEmSpace";
                CharacterCodes2[CharacterCodes2["figureSpace"] = 8199] = "figureSpace";
                CharacterCodes2[CharacterCodes2["punctuationSpace"] = 8200] = "punctuationSpace";
                CharacterCodes2[CharacterCodes2["thinSpace"] = 8201] = "thinSpace";
                CharacterCodes2[CharacterCodes2["hairSpace"] = 8202] = "hairSpace";
                CharacterCodes2[CharacterCodes2["zeroWidthSpace"] = 8203] = "zeroWidthSpace";
                CharacterCodes2[CharacterCodes2["narrowNoBreakSpace"] = 8239] = "narrowNoBreakSpace";
                CharacterCodes2[CharacterCodes2["ideographicSpace"] = 12288] = "ideographicSpace";
                CharacterCodes2[CharacterCodes2["mathematicalSpace"] = 8287] = "mathematicalSpace";
                CharacterCodes2[CharacterCodes2["ogham"] = 5760] = "ogham";
                CharacterCodes2[CharacterCodes2["replacementCharacter"] = 65533] = "replacementCharacter";
                CharacterCodes2[CharacterCodes2["_"] = 95] = "_";
                CharacterCodes2[CharacterCodes2["$"] = 36] = "$";
                CharacterCodes2[CharacterCodes2["_0"] = 48] = "_0";
                CharacterCodes2[CharacterCodes2["_1"] = 49] = "_1";
                CharacterCodes2[CharacterCodes2["_2"] = 50] = "_2";
                CharacterCodes2[CharacterCodes2["_3"] = 51] = "_3";
                CharacterCodes2[CharacterCodes2["_4"] = 52] = "_4";
                CharacterCodes2[CharacterCodes2["_5"] = 53] = "_5";
                CharacterCodes2[CharacterCodes2["_6"] = 54] = "_6";
                CharacterCodes2[CharacterCodes2["_7"] = 55] = "_7";
                CharacterCodes2[CharacterCodes2["_8"] = 56] = "_8";
                CharacterCodes2[CharacterCodes2["_9"] = 57] = "_9";
                CharacterCodes2[CharacterCodes2["a"] = 97] = "a";
                CharacterCodes2[CharacterCodes2["b"] = 98] = "b";
                CharacterCodes2[CharacterCodes2["c"] = 99] = "c";
                CharacterCodes2[CharacterCodes2["d"] = 100] = "d";
                CharacterCodes2[CharacterCodes2["e"] = 101] = "e";
                CharacterCodes2[CharacterCodes2["f"] = 102] = "f";
                CharacterCodes2[CharacterCodes2["g"] = 103] = "g";
                CharacterCodes2[CharacterCodes2["h"] = 104] = "h";
                CharacterCodes2[CharacterCodes2["i"] = 105] = "i";
                CharacterCodes2[CharacterCodes2["j"] = 106] = "j";
                CharacterCodes2[CharacterCodes2["k"] = 107] = "k";
                CharacterCodes2[CharacterCodes2["l"] = 108] = "l";
                CharacterCodes2[CharacterCodes2["m"] = 109] = "m";
                CharacterCodes2[CharacterCodes2["n"] = 110] = "n";
                CharacterCodes2[CharacterCodes2["o"] = 111] = "o";
                CharacterCodes2[CharacterCodes2["p"] = 112] = "p";
                CharacterCodes2[CharacterCodes2["q"] = 113] = "q";
                CharacterCodes2[CharacterCodes2["r"] = 114] = "r";
                CharacterCodes2[CharacterCodes2["s"] = 115] = "s";
                CharacterCodes2[CharacterCodes2["t"] = 116] = "t";
                CharacterCodes2[CharacterCodes2["u"] = 117] = "u";
                CharacterCodes2[CharacterCodes2["v"] = 118] = "v";
                CharacterCodes2[CharacterCodes2["w"] = 119] = "w";
                CharacterCodes2[CharacterCodes2["x"] = 120] = "x";
                CharacterCodes2[CharacterCodes2["y"] = 121] = "y";
                CharacterCodes2[CharacterCodes2["z"] = 122] = "z";
                CharacterCodes2[CharacterCodes2["A"] = 65] = "A";
                CharacterCodes2[CharacterCodes2["B"] = 66] = "B";
                CharacterCodes2[CharacterCodes2["C"] = 67] = "C";
                CharacterCodes2[CharacterCodes2["D"] = 68] = "D";
                CharacterCodes2[CharacterCodes2["E"] = 69] = "E";
                CharacterCodes2[CharacterCodes2["F"] = 70] = "F";
                CharacterCodes2[CharacterCodes2["G"] = 71] = "G";
                CharacterCodes2[CharacterCodes2["H"] = 72] = "H";
                CharacterCodes2[CharacterCodes2["I"] = 73] = "I";
                CharacterCodes2[CharacterCodes2["J"] = 74] = "J";
                CharacterCodes2[CharacterCodes2["K"] = 75] = "K";
                CharacterCodes2[CharacterCodes2["L"] = 76] = "L";
                CharacterCodes2[CharacterCodes2["M"] = 77] = "M";
                CharacterCodes2[CharacterCodes2["N"] = 78] = "N";
                CharacterCodes2[CharacterCodes2["O"] = 79] = "O";
                CharacterCodes2[CharacterCodes2["P"] = 80] = "P";
                CharacterCodes2[CharacterCodes2["Q"] = 81] = "Q";
                CharacterCodes2[CharacterCodes2["R"] = 82] = "R";
                CharacterCodes2[CharacterCodes2["S"] = 83] = "S";
                CharacterCodes2[CharacterCodes2["T"] = 84] = "T";
                CharacterCodes2[CharacterCodes2["U"] = 85] = "U";
                CharacterCodes2[CharacterCodes2["V"] = 86] = "V";
                CharacterCodes2[CharacterCodes2["W"] = 87] = "W";
                CharacterCodes2[CharacterCodes2["X"] = 88] = "X";
                CharacterCodes2[CharacterCodes2["Y"] = 89] = "Y";
                CharacterCodes2[CharacterCodes2["Z"] = 90] = "Z";
                CharacterCodes2[CharacterCodes2["ampersand"] = 38] = "ampersand";
                CharacterCodes2[CharacterCodes2["asterisk"] = 42] = "asterisk";
                CharacterCodes2[CharacterCodes2["at"] = 64] = "at";
                CharacterCodes2[CharacterCodes2["backslash"] = 92] = "backslash";
                CharacterCodes2[CharacterCodes2["backtick"] = 96] = "backtick";
                CharacterCodes2[CharacterCodes2["bar"] = 124] = "bar";
                CharacterCodes2[CharacterCodes2["caret"] = 94] = "caret";
                CharacterCodes2[CharacterCodes2["closeBrace"] = 125] = "closeBrace";
                CharacterCodes2[CharacterCodes2["closeBracket"] = 93] = "closeBracket";
                CharacterCodes2[CharacterCodes2["closeParen"] = 41] = "closeParen";
                CharacterCodes2[CharacterCodes2["colon"] = 58] = "colon";
                CharacterCodes2[CharacterCodes2["comma"] = 44] = "comma";
                CharacterCodes2[CharacterCodes2["dot"] = 46] = "dot";
                CharacterCodes2[CharacterCodes2["doubleQuote"] = 34] = "doubleQuote";
                CharacterCodes2[CharacterCodes2["equals"] = 61] = "equals";
                CharacterCodes2[CharacterCodes2["exclamation"] = 33] = "exclamation";
                CharacterCodes2[CharacterCodes2["greaterThan"] = 62] = "greaterThan";
                CharacterCodes2[CharacterCodes2["hash"] = 35] = "hash";
                CharacterCodes2[CharacterCodes2["lessThan"] = 60] = "lessThan";
                CharacterCodes2[CharacterCodes2["minus"] = 45] = "minus";
                CharacterCodes2[CharacterCodes2["openBrace"] = 123] = "openBrace";
                CharacterCodes2[CharacterCodes2["openBracket"] = 91] = "openBracket";
                CharacterCodes2[CharacterCodes2["openParen"] = 40] = "openParen";
                CharacterCodes2[CharacterCodes2["percent"] = 37] = "percent";
                CharacterCodes2[CharacterCodes2["plus"] = 43] = "plus";
                CharacterCodes2[CharacterCodes2["question"] = 63] = "question";
                CharacterCodes2[CharacterCodes2["semicolon"] = 59] = "semicolon";
                CharacterCodes2[CharacterCodes2["singleQuote"] = 39] = "singleQuote";
                CharacterCodes2[CharacterCodes2["slash"] = 47] = "slash";
                CharacterCodes2[CharacterCodes2["tilde"] = 126] = "tilde";
                CharacterCodes2[CharacterCodes2["backspace"] = 8] = "backspace";
                CharacterCodes2[CharacterCodes2["formFeed"] = 12] = "formFeed";
                CharacterCodes2[CharacterCodes2["byteOrderMark"] = 65279] = "byteOrderMark";
                CharacterCodes2[CharacterCodes2["tab"] = 9] = "tab";
                CharacterCodes2[CharacterCodes2["verticalTab"] = 11] = "verticalTab";
                return CharacterCodes2;
            })(CharacterCodes || {});
            Extension = /* @__PURE__ */ ((Extension2)=>{
                Extension2["Ts"] = ".ts";
                Extension2["Tsx"] = ".tsx";
                Extension2["Dts"] = ".d.ts";
                Extension2["Js"] = ".js";
                Extension2["Jsx"] = ".jsx";
                Extension2["Json"] = ".json";
                Extension2["TsBuildInfo"] = ".tsbuildinfo";
                Extension2["Mjs"] = ".mjs";
                Extension2["Mts"] = ".mts";
                Extension2["Dmts"] = ".d.mts";
                Extension2["Cjs"] = ".cjs";
                Extension2["Cts"] = ".cts";
                Extension2["Dcts"] = ".d.cts";
                return Extension2;
            })(Extension || {});
            TransformFlags = /* @__PURE__ */ ((TransformFlags3)=>{
                TransformFlags3[TransformFlags3["None"] = 0] = "None";
                TransformFlags3[TransformFlags3["ContainsTypeScript"] = 1] = "ContainsTypeScript";
                TransformFlags3[TransformFlags3["ContainsJsx"] = 2] = "ContainsJsx";
                TransformFlags3[TransformFlags3["ContainsESNext"] = 4] = "ContainsESNext";
                TransformFlags3[TransformFlags3["ContainsES2022"] = 8] = "ContainsES2022";
                TransformFlags3[TransformFlags3["ContainsES2021"] = 16] = "ContainsES2021";
                TransformFlags3[TransformFlags3["ContainsES2020"] = 32] = "ContainsES2020";
                TransformFlags3[TransformFlags3["ContainsES2019"] = 64] = "ContainsES2019";
                TransformFlags3[TransformFlags3["ContainsES2018"] = 128] = "ContainsES2018";
                TransformFlags3[TransformFlags3["ContainsES2017"] = 256] = "ContainsES2017";
                TransformFlags3[TransformFlags3["ContainsES2016"] = 512] = "ContainsES2016";
                TransformFlags3[TransformFlags3["ContainsES2015"] = 1024] = "ContainsES2015";
                TransformFlags3[TransformFlags3["ContainsGenerator"] = 2048] = "ContainsGenerator";
                TransformFlags3[TransformFlags3["ContainsDestructuringAssignment"] = 4096] = "ContainsDestructuringAssignment";
                TransformFlags3[TransformFlags3["ContainsTypeScriptClassSyntax"] = 8192] = "ContainsTypeScriptClassSyntax";
                TransformFlags3[TransformFlags3["ContainsLexicalThis"] = 16384] = "ContainsLexicalThis";
                TransformFlags3[TransformFlags3["ContainsRestOrSpread"] = 32768] = "ContainsRestOrSpread";
                TransformFlags3[TransformFlags3["ContainsObjectRestOrSpread"] = 65536] = "ContainsObjectRestOrSpread";
                TransformFlags3[TransformFlags3["ContainsComputedPropertyName"] = 131072] = "ContainsComputedPropertyName";
                TransformFlags3[TransformFlags3["ContainsBlockScopedBinding"] = 262144] = "ContainsBlockScopedBinding";
                TransformFlags3[TransformFlags3["ContainsBindingPattern"] = 524288] = "ContainsBindingPattern";
                TransformFlags3[TransformFlags3["ContainsYield"] = 1048576] = "ContainsYield";
                TransformFlags3[TransformFlags3["ContainsAwait"] = 2097152] = "ContainsAwait";
                TransformFlags3[TransformFlags3["ContainsHoistedDeclarationOrCompletion"] = 4194304] = "ContainsHoistedDeclarationOrCompletion";
                TransformFlags3[TransformFlags3["ContainsDynamicImport"] = 8388608] = "ContainsDynamicImport";
                TransformFlags3[TransformFlags3["ContainsClassFields"] = 16777216] = "ContainsClassFields";
                TransformFlags3[TransformFlags3["ContainsDecorators"] = 33554432] = "ContainsDecorators";
                TransformFlags3[TransformFlags3["ContainsPossibleTopLevelAwait"] = 67108864] = "ContainsPossibleTopLevelAwait";
                TransformFlags3[TransformFlags3["ContainsLexicalSuper"] = 134217728] = "ContainsLexicalSuper";
                TransformFlags3[TransformFlags3["ContainsUpdateExpressionForIdentifier"] = 268435456] = "ContainsUpdateExpressionForIdentifier";
                TransformFlags3[TransformFlags3["ContainsPrivateIdentifierInExpression"] = 536870912] = "ContainsPrivateIdentifierInExpression";
                TransformFlags3[TransformFlags3["HasComputedFlags"] = -2147483648] = "HasComputedFlags";
                TransformFlags3[TransformFlags3["AssertTypeScript"] = 1 /* ContainsTypeScript */ ] = "AssertTypeScript";
                TransformFlags3[TransformFlags3["AssertJsx"] = 2 /* ContainsJsx */ ] = "AssertJsx";
                TransformFlags3[TransformFlags3["AssertESNext"] = 4 /* ContainsESNext */ ] = "AssertESNext";
                TransformFlags3[TransformFlags3["AssertES2022"] = 8 /* ContainsES2022 */ ] = "AssertES2022";
                TransformFlags3[TransformFlags3["AssertES2021"] = 16 /* ContainsES2021 */ ] = "AssertES2021";
                TransformFlags3[TransformFlags3["AssertES2020"] = 32 /* ContainsES2020 */ ] = "AssertES2020";
                TransformFlags3[TransformFlags3["AssertES2019"] = 64 /* ContainsES2019 */ ] = "AssertES2019";
                TransformFlags3[TransformFlags3["AssertES2018"] = 128 /* ContainsES2018 */ ] = "AssertES2018";
                TransformFlags3[TransformFlags3["AssertES2017"] = 256 /* ContainsES2017 */ ] = "AssertES2017";
                TransformFlags3[TransformFlags3["AssertES2016"] = 512 /* ContainsES2016 */ ] = "AssertES2016";
                TransformFlags3[TransformFlags3["AssertES2015"] = 1024 /* ContainsES2015 */ ] = "AssertES2015";
                TransformFlags3[TransformFlags3["AssertGenerator"] = 2048 /* ContainsGenerator */ ] = "AssertGenerator";
                TransformFlags3[TransformFlags3["AssertDestructuringAssignment"] = 4096 /* ContainsDestructuringAssignment */ ] = "AssertDestructuringAssignment";
                TransformFlags3[TransformFlags3["OuterExpressionExcludes"] = -2147483648 /* HasComputedFlags */ ] = "OuterExpressionExcludes";
                TransformFlags3[TransformFlags3["PropertyAccessExcludes"] = -2147483648 /* OuterExpressionExcludes */ ] = "PropertyAccessExcludes";
                TransformFlags3[TransformFlags3["NodeExcludes"] = -2147483648 /* PropertyAccessExcludes */ ] = "NodeExcludes";
                TransformFlags3[TransformFlags3["ArrowFunctionExcludes"] = -2072174592] = "ArrowFunctionExcludes";
                TransformFlags3[TransformFlags3["FunctionExcludes"] = -1937940480] = "FunctionExcludes";
                TransformFlags3[TransformFlags3["ConstructorExcludes"] = -1937948672] = "ConstructorExcludes";
                TransformFlags3[TransformFlags3["MethodOrAccessorExcludes"] = -2005057536] = "MethodOrAccessorExcludes";
                TransformFlags3[TransformFlags3["PropertyExcludes"] = -2013249536] = "PropertyExcludes";
                TransformFlags3[TransformFlags3["ClassExcludes"] = -2147344384] = "ClassExcludes";
                TransformFlags3[TransformFlags3["ModuleExcludes"] = -1941676032] = "ModuleExcludes";
                TransformFlags3[TransformFlags3["TypeExcludes"] = -2] = "TypeExcludes";
                TransformFlags3[TransformFlags3["ObjectLiteralExcludes"] = -2147278848] = "ObjectLiteralExcludes";
                TransformFlags3[TransformFlags3["ArrayLiteralOrCallOrNewExcludes"] = -2147450880] = "ArrayLiteralOrCallOrNewExcludes";
                TransformFlags3[TransformFlags3["VariableDeclarationListExcludes"] = -2146893824] = "VariableDeclarationListExcludes";
                TransformFlags3[TransformFlags3["ParameterExcludes"] = -2147483648 /* NodeExcludes */ ] = "ParameterExcludes";
                TransformFlags3[TransformFlags3["CatchClauseExcludes"] = -2147418112] = "CatchClauseExcludes";
                TransformFlags3[TransformFlags3["BindingPatternExcludes"] = -2147450880] = "BindingPatternExcludes";
                TransformFlags3[TransformFlags3["ContainsLexicalThisOrSuper"] = 134234112] = "ContainsLexicalThisOrSuper";
                TransformFlags3[TransformFlags3["PropertyNamePropagatingFlags"] = 134234112] = "PropertyNamePropagatingFlags";
                return TransformFlags3;
            })(TransformFlags || {});
            SnippetKind = /* @__PURE__ */ ((SnippetKind3)=>{
                SnippetKind3[SnippetKind3["TabStop"] = 0] = "TabStop";
                SnippetKind3[SnippetKind3["Placeholder"] = 1] = "Placeholder";
                SnippetKind3[SnippetKind3["Choice"] = 2] = "Choice";
                SnippetKind3[SnippetKind3["Variable"] = 3] = "Variable";
                return SnippetKind3;
            })(SnippetKind || {});
            EmitFlags = /* @__PURE__ */ ((EmitFlags3)=>{
                EmitFlags3[EmitFlags3["None"] = 0] = "None";
                EmitFlags3[EmitFlags3["SingleLine"] = 1] = "SingleLine";
                EmitFlags3[EmitFlags3["MultiLine"] = 2] = "MultiLine";
                EmitFlags3[EmitFlags3["AdviseOnEmitNode"] = 4] = "AdviseOnEmitNode";
                EmitFlags3[EmitFlags3["NoSubstitution"] = 8] = "NoSubstitution";
                EmitFlags3[EmitFlags3["CapturesThis"] = 16] = "CapturesThis";
                EmitFlags3[EmitFlags3["NoLeadingSourceMap"] = 32] = "NoLeadingSourceMap";
                EmitFlags3[EmitFlags3["NoTrailingSourceMap"] = 64] = "NoTrailingSourceMap";
                EmitFlags3[EmitFlags3["NoSourceMap"] = 96] = "NoSourceMap";
                EmitFlags3[EmitFlags3["NoNestedSourceMaps"] = 128] = "NoNestedSourceMaps";
                EmitFlags3[EmitFlags3["NoTokenLeadingSourceMaps"] = 256] = "NoTokenLeadingSourceMaps";
                EmitFlags3[EmitFlags3["NoTokenTrailingSourceMaps"] = 512] = "NoTokenTrailingSourceMaps";
                EmitFlags3[EmitFlags3["NoTokenSourceMaps"] = 768] = "NoTokenSourceMaps";
                EmitFlags3[EmitFlags3["NoLeadingComments"] = 1024] = "NoLeadingComments";
                EmitFlags3[EmitFlags3["NoTrailingComments"] = 2048] = "NoTrailingComments";
                EmitFlags3[EmitFlags3["NoComments"] = 3072] = "NoComments";
                EmitFlags3[EmitFlags3["NoNestedComments"] = 4096] = "NoNestedComments";
                EmitFlags3[EmitFlags3["HelperName"] = 8192] = "HelperName";
                EmitFlags3[EmitFlags3["ExportName"] = 16384] = "ExportName";
                EmitFlags3[EmitFlags3["LocalName"] = 32768] = "LocalName";
                EmitFlags3[EmitFlags3["InternalName"] = 65536] = "InternalName";
                EmitFlags3[EmitFlags3["Indented"] = 131072] = "Indented";
                EmitFlags3[EmitFlags3["NoIndentation"] = 262144] = "NoIndentation";
                EmitFlags3[EmitFlags3["AsyncFunctionBody"] = 524288] = "AsyncFunctionBody";
                EmitFlags3[EmitFlags3["ReuseTempVariableScope"] = 1048576] = "ReuseTempVariableScope";
                EmitFlags3[EmitFlags3["CustomPrologue"] = 2097152] = "CustomPrologue";
                EmitFlags3[EmitFlags3["NoHoisting"] = 4194304] = "NoHoisting";
                EmitFlags3[EmitFlags3["Iterator"] = 8388608] = "Iterator";
                EmitFlags3[EmitFlags3["NoAsciiEscaping"] = 16777216] = "NoAsciiEscaping";
                return EmitFlags3;
            })(EmitFlags || {});
            InternalEmitFlags = /* @__PURE__ */ ((InternalEmitFlags3)=>{
                InternalEmitFlags3[InternalEmitFlags3["None"] = 0] = "None";
                InternalEmitFlags3[InternalEmitFlags3["TypeScriptClassWrapper"] = 1] = "TypeScriptClassWrapper";
                InternalEmitFlags3[InternalEmitFlags3["NeverApplyImportHelper"] = 2] = "NeverApplyImportHelper";
                InternalEmitFlags3[InternalEmitFlags3["IgnoreSourceNewlines"] = 4] = "IgnoreSourceNewlines";
                InternalEmitFlags3[InternalEmitFlags3["Immutable"] = 8] = "Immutable";
                InternalEmitFlags3[InternalEmitFlags3["IndirectCall"] = 16] = "IndirectCall";
                InternalEmitFlags3[InternalEmitFlags3["TransformPrivateStaticElements"] = 32] = "TransformPrivateStaticElements";
                return InternalEmitFlags3;
            })(InternalEmitFlags || {});
            ExternalEmitHelpers = /* @__PURE__ */ ((ExternalEmitHelpers2)=>{
                ExternalEmitHelpers2[ExternalEmitHelpers2["Extends"] = 1] = "Extends";
                ExternalEmitHelpers2[ExternalEmitHelpers2["Assign"] = 2] = "Assign";
                ExternalEmitHelpers2[ExternalEmitHelpers2["Rest"] = 4] = "Rest";
                ExternalEmitHelpers2[ExternalEmitHelpers2["Decorate"] = 8] = "Decorate";
                ExternalEmitHelpers2[ExternalEmitHelpers2["ESDecorateAndRunInitializers"] = 8 /* Decorate */ ] = "ESDecorateAndRunInitializers";
                ExternalEmitHelpers2[ExternalEmitHelpers2["Metadata"] = 16] = "Metadata";
                ExternalEmitHelpers2[ExternalEmitHelpers2["Param"] = 32] = "Param";
                ExternalEmitHelpers2[ExternalEmitHelpers2["Awaiter"] = 64] = "Awaiter";
                ExternalEmitHelpers2[ExternalEmitHelpers2["Generator"] = 128] = "Generator";
                ExternalEmitHelpers2[ExternalEmitHelpers2["Values"] = 256] = "Values";
                ExternalEmitHelpers2[ExternalEmitHelpers2["Read"] = 512] = "Read";
                ExternalEmitHelpers2[ExternalEmitHelpers2["SpreadArray"] = 1024] = "SpreadArray";
                ExternalEmitHelpers2[ExternalEmitHelpers2["Await"] = 2048] = "Await";
                ExternalEmitHelpers2[ExternalEmitHelpers2["AsyncGenerator"] = 4096] = "AsyncGenerator";
                ExternalEmitHelpers2[ExternalEmitHelpers2["AsyncDelegator"] = 8192] = "AsyncDelegator";
                ExternalEmitHelpers2[ExternalEmitHelpers2["AsyncValues"] = 16384] = "AsyncValues";
                ExternalEmitHelpers2[ExternalEmitHelpers2["ExportStar"] = 32768] = "ExportStar";
                ExternalEmitHelpers2[ExternalEmitHelpers2["ImportStar"] = 65536] = "ImportStar";
                ExternalEmitHelpers2[ExternalEmitHelpers2["ImportDefault"] = 131072] = "ImportDefault";
                ExternalEmitHelpers2[ExternalEmitHelpers2["MakeTemplateObject"] = 262144] = "MakeTemplateObject";
                ExternalEmitHelpers2[ExternalEmitHelpers2["ClassPrivateFieldGet"] = 524288] = "ClassPrivateFieldGet";
                ExternalEmitHelpers2[ExternalEmitHelpers2["ClassPrivateFieldSet"] = 1048576] = "ClassPrivateFieldSet";
                ExternalEmitHelpers2[ExternalEmitHelpers2["ClassPrivateFieldIn"] = 2097152] = "ClassPrivateFieldIn";
                ExternalEmitHelpers2[ExternalEmitHelpers2["CreateBinding"] = 4194304] = "CreateBinding";
                ExternalEmitHelpers2[ExternalEmitHelpers2["SetFunctionName"] = 8388608] = "SetFunctionName";
                ExternalEmitHelpers2[ExternalEmitHelpers2["PropKey"] = 16777216] = "PropKey";
                ExternalEmitHelpers2[ExternalEmitHelpers2["FirstEmitHelper"] = 1 /* Extends */ ] = "FirstEmitHelper";
                ExternalEmitHelpers2[ExternalEmitHelpers2["LastEmitHelper"] = 16777216 /* PropKey */ ] = "LastEmitHelper";
                ExternalEmitHelpers2[ExternalEmitHelpers2["ForOfIncludes"] = 256 /* Values */ ] = "ForOfIncludes";
                ExternalEmitHelpers2[ExternalEmitHelpers2["ForAwaitOfIncludes"] = 16384 /* AsyncValues */ ] = "ForAwaitOfIncludes";
                ExternalEmitHelpers2[ExternalEmitHelpers2["AsyncGeneratorIncludes"] = 6144] = "AsyncGeneratorIncludes";
                ExternalEmitHelpers2[ExternalEmitHelpers2["AsyncDelegatorIncludes"] = 26624] = "AsyncDelegatorIncludes";
                ExternalEmitHelpers2[ExternalEmitHelpers2["SpreadIncludes"] = 1536] = "SpreadIncludes";
                return ExternalEmitHelpers2;
            })(ExternalEmitHelpers || {});
            EmitHint = /* @__PURE__ */ ((EmitHint6)=>{
                EmitHint6[EmitHint6["SourceFile"] = 0] = "SourceFile";
                EmitHint6[EmitHint6["Expression"] = 1] = "Expression";
                EmitHint6[EmitHint6["IdentifierName"] = 2] = "IdentifierName";
                EmitHint6[EmitHint6["MappedTypeParameter"] = 3] = "MappedTypeParameter";
                EmitHint6[EmitHint6["Unspecified"] = 4] = "Unspecified";
                EmitHint6[EmitHint6["EmbeddedStatement"] = 5] = "EmbeddedStatement";
                EmitHint6[EmitHint6["JsxAttributeValue"] = 6] = "JsxAttributeValue";
                return EmitHint6;
            })(EmitHint || {});
            OuterExpressionKinds = /* @__PURE__ */ ((OuterExpressionKinds2)=>{
                OuterExpressionKinds2[OuterExpressionKinds2["Parentheses"] = 1] = "Parentheses";
                OuterExpressionKinds2[OuterExpressionKinds2["TypeAssertions"] = 2] = "TypeAssertions";
                OuterExpressionKinds2[OuterExpressionKinds2["NonNullAssertions"] = 4] = "NonNullAssertions";
                OuterExpressionKinds2[OuterExpressionKinds2["PartiallyEmittedExpressions"] = 8] = "PartiallyEmittedExpressions";
                OuterExpressionKinds2[OuterExpressionKinds2["Assertions"] = 6] = "Assertions";
                OuterExpressionKinds2[OuterExpressionKinds2["All"] = 15] = "All";
                OuterExpressionKinds2[OuterExpressionKinds2["ExcludeJSDocTypeAssertion"] = 16] = "ExcludeJSDocTypeAssertion";
                return OuterExpressionKinds2;
            })(OuterExpressionKinds || {});
            LexicalEnvironmentFlags = /* @__PURE__ */ ((LexicalEnvironmentFlags2)=>{
                LexicalEnvironmentFlags2[LexicalEnvironmentFlags2["None"] = 0] = "None";
                LexicalEnvironmentFlags2[LexicalEnvironmentFlags2["InParameters"] = 1] = "InParameters";
                LexicalEnvironmentFlags2[LexicalEnvironmentFlags2["VariablesHoistedInParameters"] = 2] = "VariablesHoistedInParameters";
                return LexicalEnvironmentFlags2;
            })(LexicalEnvironmentFlags || {});
            BundleFileSectionKind = /* @__PURE__ */ ((BundleFileSectionKind2)=>{
                BundleFileSectionKind2["Prologue"] = "prologue";
                BundleFileSectionKind2["EmitHelpers"] = "emitHelpers";
                BundleFileSectionKind2["NoDefaultLib"] = "no-default-lib";
                BundleFileSectionKind2["Reference"] = "reference";
                BundleFileSectionKind2["Type"] = "type";
                BundleFileSectionKind2["TypeResolutionModeRequire"] = "type-require";
                BundleFileSectionKind2["TypeResolutionModeImport"] = "type-import";
                BundleFileSectionKind2["Lib"] = "lib";
                BundleFileSectionKind2["Prepend"] = "prepend";
                BundleFileSectionKind2["Text"] = "text";
                BundleFileSectionKind2["Internal"] = "internal";
                return BundleFileSectionKind2;
            })(BundleFileSectionKind || {});
            ListFormat = /* @__PURE__ */ ((ListFormat2)=>{
                ListFormat2[ListFormat2["None"] = 0] = "None";
                ListFormat2[ListFormat2["SingleLine"] = 0] = "SingleLine";
                ListFormat2[ListFormat2["MultiLine"] = 1] = "MultiLine";
                ListFormat2[ListFormat2["PreserveLines"] = 2] = "PreserveLines";
                ListFormat2[ListFormat2["LinesMask"] = 3] = "LinesMask";
                ListFormat2[ListFormat2["NotDelimited"] = 0] = "NotDelimited";
                ListFormat2[ListFormat2["BarDelimited"] = 4] = "BarDelimited";
                ListFormat2[ListFormat2["AmpersandDelimited"] = 8] = "AmpersandDelimited";
                ListFormat2[ListFormat2["CommaDelimited"] = 16] = "CommaDelimited";
                ListFormat2[ListFormat2["AsteriskDelimited"] = 32] = "AsteriskDelimited";
                ListFormat2[ListFormat2["DelimitersMask"] = 60] = "DelimitersMask";
                ListFormat2[ListFormat2["AllowTrailingComma"] = 64] = "AllowTrailingComma";
                ListFormat2[ListFormat2["Indented"] = 128] = "Indented";
                ListFormat2[ListFormat2["SpaceBetweenBraces"] = 256] = "SpaceBetweenBraces";
                ListFormat2[ListFormat2["SpaceBetweenSiblings"] = 512] = "SpaceBetweenSiblings";
                ListFormat2[ListFormat2["Braces"] = 1024] = "Braces";
                ListFormat2[ListFormat2["Parenthesis"] = 2048] = "Parenthesis";
                ListFormat2[ListFormat2["AngleBrackets"] = 4096] = "AngleBrackets";
                ListFormat2[ListFormat2["SquareBrackets"] = 8192] = "SquareBrackets";
                ListFormat2[ListFormat2["BracketsMask"] = 15360] = "BracketsMask";
                ListFormat2[ListFormat2["OptionalIfUndefined"] = 16384] = "OptionalIfUndefined";
                ListFormat2[ListFormat2["OptionalIfEmpty"] = 32768] = "OptionalIfEmpty";
                ListFormat2[ListFormat2["Optional"] = 49152] = "Optional";
                ListFormat2[ListFormat2["PreferNewLine"] = 65536] = "PreferNewLine";
                ListFormat2[ListFormat2["NoTrailingNewLine"] = 131072] = "NoTrailingNewLine";
                ListFormat2[ListFormat2["NoInterveningComments"] = 262144] = "NoInterveningComments";
                ListFormat2[ListFormat2["NoSpaceIfEmpty"] = 524288] = "NoSpaceIfEmpty";
                ListFormat2[ListFormat2["SingleElement"] = 1048576] = "SingleElement";
                ListFormat2[ListFormat2["SpaceAfterList"] = 2097152] = "SpaceAfterList";
                ListFormat2[ListFormat2["Modifiers"] = 2359808] = "Modifiers";
                ListFormat2[ListFormat2["HeritageClauses"] = 512] = "HeritageClauses";
                ListFormat2[ListFormat2["SingleLineTypeLiteralMembers"] = 768] = "SingleLineTypeLiteralMembers";
                ListFormat2[ListFormat2["MultiLineTypeLiteralMembers"] = 32897] = "MultiLineTypeLiteralMembers";
                ListFormat2[ListFormat2["SingleLineTupleTypeElements"] = 528] = "SingleLineTupleTypeElements";
                ListFormat2[ListFormat2["MultiLineTupleTypeElements"] = 657] = "MultiLineTupleTypeElements";
                ListFormat2[ListFormat2["UnionTypeConstituents"] = 516] = "UnionTypeConstituents";
                ListFormat2[ListFormat2["IntersectionTypeConstituents"] = 520] = "IntersectionTypeConstituents";
                ListFormat2[ListFormat2["ObjectBindingPatternElements"] = 525136] = "ObjectBindingPatternElements";
                ListFormat2[ListFormat2["ArrayBindingPatternElements"] = 524880] = "ArrayBindingPatternElements";
                ListFormat2[ListFormat2["ObjectLiteralExpressionProperties"] = 526226] = "ObjectLiteralExpressionProperties";
                ListFormat2[ListFormat2["ImportClauseEntries"] = 526226] = "ImportClauseEntries";
                ListFormat2[ListFormat2["ArrayLiteralExpressionElements"] = 8914] = "ArrayLiteralExpressionElements";
                ListFormat2[ListFormat2["CommaListElements"] = 528] = "CommaListElements";
                ListFormat2[ListFormat2["CallExpressionArguments"] = 2576] = "CallExpressionArguments";
                ListFormat2[ListFormat2["NewExpressionArguments"] = 18960] = "NewExpressionArguments";
                ListFormat2[ListFormat2["TemplateExpressionSpans"] = 262144] = "TemplateExpressionSpans";
                ListFormat2[ListFormat2["SingleLineBlockStatements"] = 768] = "SingleLineBlockStatements";
                ListFormat2[ListFormat2["MultiLineBlockStatements"] = 129] = "MultiLineBlockStatements";
                ListFormat2[ListFormat2["VariableDeclarationList"] = 528] = "VariableDeclarationList";
                ListFormat2[ListFormat2["SingleLineFunctionBodyStatements"] = 768] = "SingleLineFunctionBodyStatements";
                ListFormat2[ListFormat2["MultiLineFunctionBodyStatements"] = 1 /* MultiLine */ ] = "MultiLineFunctionBodyStatements";
                ListFormat2[ListFormat2["ClassHeritageClauses"] = 0 /* SingleLine */ ] = "ClassHeritageClauses";
                ListFormat2[ListFormat2["ClassMembers"] = 129] = "ClassMembers";
                ListFormat2[ListFormat2["InterfaceMembers"] = 129] = "InterfaceMembers";
                ListFormat2[ListFormat2["EnumMembers"] = 145] = "EnumMembers";
                ListFormat2[ListFormat2["CaseBlockClauses"] = 129] = "CaseBlockClauses";
                ListFormat2[ListFormat2["NamedImportsOrExportsElements"] = 525136] = "NamedImportsOrExportsElements";
                ListFormat2[ListFormat2["JsxElementOrFragmentChildren"] = 262144] = "JsxElementOrFragmentChildren";
                ListFormat2[ListFormat2["JsxElementAttributes"] = 262656] = "JsxElementAttributes";
                ListFormat2[ListFormat2["CaseOrDefaultClauseStatements"] = 163969] = "CaseOrDefaultClauseStatements";
                ListFormat2[ListFormat2["HeritageClauseTypes"] = 528] = "HeritageClauseTypes";
                ListFormat2[ListFormat2["SourceFileStatements"] = 131073] = "SourceFileStatements";
                ListFormat2[ListFormat2["Decorators"] = 2146305] = "Decorators";
                ListFormat2[ListFormat2["TypeArguments"] = 53776] = "TypeArguments";
                ListFormat2[ListFormat2["TypeParameters"] = 53776] = "TypeParameters";
                ListFormat2[ListFormat2["Parameters"] = 2576] = "Parameters";
                ListFormat2[ListFormat2["IndexSignatureParameters"] = 8848] = "IndexSignatureParameters";
                ListFormat2[ListFormat2["JSDocComment"] = 33] = "JSDocComment";
                return ListFormat2;
            })(ListFormat || {});
            PragmaKindFlags = /* @__PURE__ */ ((PragmaKindFlags2)=>{
                PragmaKindFlags2[PragmaKindFlags2["None"] = 0] = "None";
                PragmaKindFlags2[PragmaKindFlags2["TripleSlashXML"] = 1] = "TripleSlashXML";
                PragmaKindFlags2[PragmaKindFlags2["SingleLine"] = 2] = "SingleLine";
                PragmaKindFlags2[PragmaKindFlags2["MultiLine"] = 4] = "MultiLine";
                PragmaKindFlags2[PragmaKindFlags2["All"] = 7] = "All";
                PragmaKindFlags2[PragmaKindFlags2["Default"] = 7 /* All */ ] = "Default";
                return PragmaKindFlags2;
            })(PragmaKindFlags || {});
            commentPragmas = {
                "reference": {
                    args: [
                        {
                            name: "types",
                            optional: true,
                            captureSpan: true
                        },
                        {
                            name: "lib",
                            optional: true,
                            captureSpan: true
                        },
                        {
                            name: "path",
                            optional: true,
                            captureSpan: true
                        },
                        {
                            name: "no-default-lib",
                            optional: true
                        },
                        {
                            name: "resolution-mode",
                            optional: true
                        }
                    ],
                    kind: 1 /* TripleSlashXML */ 
                },
                "amd-dependency": {
                    args: [
                        {
                            name: "path"
                        },
                        {
                            name: "name",
                            optional: true
                        }
                    ],
                    kind: 1 /* TripleSlashXML */ 
                },
                "amd-module": {
                    args: [
                        {
                            name: "name"
                        }
                    ],
                    kind: 1 /* TripleSlashXML */ 
                },
                "ts-check": {
                    kind: 2 /* SingleLine */ 
                },
                "ts-nocheck": {
                    kind: 2 /* SingleLine */ 
                },
                "jsx": {
                    args: [
                        {
                            name: "factory"
                        }
                    ],
                    kind: 4 /* MultiLine */ 
                },
                "jsxfrag": {
                    args: [
                        {
                            name: "factory"
                        }
                    ],
                    kind: 4 /* MultiLine */ 
                },
                "jsximportsource": {
                    args: [
                        {
                            name: "factory"
                        }
                    ],
                    kind: 4 /* MultiLine */ 
                },
                "jsxruntime": {
                    args: [
                        {
                            name: "factory"
                        }
                    ],
                    kind: 4 /* MultiLine */ 
                }
            };
        }
    });
    // src/compiler/sys.ts
    function generateDjb2Hash(data) {
        let acc = 5381;
        for(let i = 0; i < data.length; i++)acc = (acc << 5) + acc + data.charCodeAt(i);
        return acc.toString();
    }
    function setStackTraceLimit() {
        if (Error.stackTraceLimit < 100) Error.stackTraceLimit = 100;
    }
    function getModifiedTime(host, fileName) {
        return host.getModifiedTime(fileName) || missingFileModifiedTime;
    }
    function createPollingIntervalBasedLevels(levels) {
        return {
            [250 /* Low */ ]: levels.Low,
            [500 /* Medium */ ]: levels.Medium,
            [2e3 /* High */ ]: levels.High
        };
    }
    function setCustomPollingValues(system) {
        if (!system.getEnvironmentVariable) return;
        const pollingIntervalChanged = setCustomLevels("TSC_WATCH_POLLINGINTERVAL", PollingInterval);
        pollingChunkSize = getCustomPollingBasedLevels("TSC_WATCH_POLLINGCHUNKSIZE", defaultChunkLevels) || pollingChunkSize;
        unchangedPollThresholds = getCustomPollingBasedLevels("TSC_WATCH_UNCHANGEDPOLLTHRESHOLDS", defaultChunkLevels) || unchangedPollThresholds;
        function getLevel(envVar, level) {
            return system.getEnvironmentVariable(`${envVar}_${level.toUpperCase()}`);
        }
        function getCustomLevels(baseVariable) {
            let customLevels;
            setCustomLevel("Low");
            setCustomLevel("Medium");
            setCustomLevel("High");
            return customLevels;
            function setCustomLevel(level) {
                const customLevel = getLevel(baseVariable, level);
                if (customLevel) (customLevels || (customLevels = {}))[level] = Number(customLevel);
            }
        }
        function setCustomLevels(baseVariable, levels) {
            const customLevels = getCustomLevels(baseVariable);
            if (customLevels) {
                setLevel("Low");
                setLevel("Medium");
                setLevel("High");
                return true;
            }
            return false;
            function setLevel(level) {
                levels[level] = customLevels[level] || levels[level];
            }
        }
        function getCustomPollingBasedLevels(baseVariable, defaultLevels) {
            const customLevels = getCustomLevels(baseVariable);
            return (pollingIntervalChanged || customLevels) && createPollingIntervalBasedLevels(customLevels ? {
                ...defaultLevels,
                ...customLevels
            } : defaultLevels);
        }
    }
    function pollWatchedFileQueue(host, queue, pollIndex, chunkSize, callbackOnWatchFileStat) {
        let definedValueCopyToIndex = pollIndex;
        for(let canVisit = queue.length; chunkSize && canVisit; nextPollIndex(), canVisit--){
            const watchedFile = queue[pollIndex];
            if (!watchedFile) continue;
            else if (watchedFile.isClosed) {
                queue[pollIndex] = void 0;
                continue;
            }
            chunkSize--;
            const fileChanged = onWatchedFileStat(watchedFile, getModifiedTime(host, watchedFile.fileName));
            if (watchedFile.isClosed) {
                queue[pollIndex] = void 0;
                continue;
            }
            callbackOnWatchFileStat == null || callbackOnWatchFileStat(watchedFile, pollIndex, fileChanged);
            if (queue[pollIndex]) {
                if (definedValueCopyToIndex < pollIndex) {
                    queue[definedValueCopyToIndex] = watchedFile;
                    queue[pollIndex] = void 0;
                }
                definedValueCopyToIndex++;
            }
        }
        return pollIndex;
        function nextPollIndex() {
            pollIndex++;
            if (pollIndex === queue.length) {
                if (definedValueCopyToIndex < pollIndex) queue.length = definedValueCopyToIndex;
                pollIndex = 0;
                definedValueCopyToIndex = 0;
            }
        }
    }
    function createDynamicPriorityPollingWatchFile(host) {
        const watchedFiles = [];
        const changedFilesInLastPoll = [];
        const lowPollingIntervalQueue = createPollingIntervalQueue(250 /* Low */ );
        const mediumPollingIntervalQueue = createPollingIntervalQueue(500 /* Medium */ );
        const highPollingIntervalQueue = createPollingIntervalQueue(2e3 /* High */ );
        return watchFile2;
        function watchFile2(fileName, callback, defaultPollingInterval) {
            const file = {
                fileName: fileName,
                callback: callback,
                unchangedPolls: 0,
                mtime: getModifiedTime(host, fileName)
            };
            watchedFiles.push(file);
            addToPollingIntervalQueue(file, defaultPollingInterval);
            return {
                close: ()=>{
                    file.isClosed = true;
                    unorderedRemoveItem(watchedFiles, file);
                }
            };
        }
        function createPollingIntervalQueue(pollingInterval) {
            const queue = [];
            queue.pollingInterval = pollingInterval;
            queue.pollIndex = 0;
            queue.pollScheduled = false;
            return queue;
        }
        function pollPollingIntervalQueue(_timeoutType, queue) {
            queue.pollIndex = pollQueue(queue, queue.pollingInterval, queue.pollIndex, pollingChunkSize[queue.pollingInterval]);
            if (queue.length) scheduleNextPoll(queue.pollingInterval);
            else {
                Debug.assert(queue.pollIndex === 0);
                queue.pollScheduled = false;
            }
        }
        function pollLowPollingIntervalQueue(_timeoutType, queue) {
            pollQueue(changedFilesInLastPoll, 250 /* Low */ , /*pollIndex*/ 0, changedFilesInLastPoll.length);
            pollPollingIntervalQueue(_timeoutType, queue);
            if (!queue.pollScheduled && changedFilesInLastPoll.length) scheduleNextPoll(250 /* Low */ );
        }
        function pollQueue(queue, pollingInterval, pollIndex, chunkSize) {
            return pollWatchedFileQueue(host, queue, pollIndex, chunkSize, onWatchFileStat);
            function onWatchFileStat(watchedFile, pollIndex2, fileChanged) {
                if (fileChanged) {
                    watchedFile.unchangedPolls = 0;
                    if (queue !== changedFilesInLastPoll) {
                        queue[pollIndex2] = void 0;
                        addChangedFileToLowPollingIntervalQueue(watchedFile);
                    }
                } else if (watchedFile.unchangedPolls !== unchangedPollThresholds[pollingInterval]) watchedFile.unchangedPolls++;
                else if (queue === changedFilesInLastPoll) {
                    watchedFile.unchangedPolls = 1;
                    queue[pollIndex2] = void 0;
                    addToPollingIntervalQueue(watchedFile, 250 /* Low */ );
                } else if (pollingInterval !== 2e3 /* High */ ) {
                    watchedFile.unchangedPolls++;
                    queue[pollIndex2] = void 0;
                    addToPollingIntervalQueue(watchedFile, pollingInterval === 250 /* Low */  ? 500 /* Medium */  : 2e3 /* High */ );
                }
            }
        }
        function pollingIntervalQueue(pollingInterval) {
            switch(pollingInterval){
                case 250 /* Low */ :
                    return lowPollingIntervalQueue;
                case 500 /* Medium */ :
                    return mediumPollingIntervalQueue;
                case 2e3 /* High */ :
                    return highPollingIntervalQueue;
            }
        }
        function addToPollingIntervalQueue(file, pollingInterval) {
            pollingIntervalQueue(pollingInterval).push(file);
            scheduleNextPollIfNotAlreadyScheduled(pollingInterval);
        }
        function addChangedFileToLowPollingIntervalQueue(file) {
            changedFilesInLastPoll.push(file);
            scheduleNextPollIfNotAlreadyScheduled(250 /* Low */ );
        }
        function scheduleNextPollIfNotAlreadyScheduled(pollingInterval) {
            if (!pollingIntervalQueue(pollingInterval).pollScheduled) scheduleNextPoll(pollingInterval);
        }
        function scheduleNextPoll(pollingInterval) {
            pollingIntervalQueue(pollingInterval).pollScheduled = host.setTimeout(pollingInterval === 250 /* Low */  ? pollLowPollingIntervalQueue : pollPollingIntervalQueue, pollingInterval, pollingInterval === 250 /* Low */  ? "pollLowPollingIntervalQueue" : "pollPollingIntervalQueue", pollingIntervalQueue(pollingInterval));
        }
    }
    function createUseFsEventsOnParentDirectoryWatchFile(fsWatch, useCaseSensitiveFileNames) {
        const fileWatcherCallbacks = createMultiMap();
        const dirWatchers = /* @__PURE__ */ new Map();
        const toCanonicalName = createGetCanonicalFileName(useCaseSensitiveFileNames);
        return nonPollingWatchFile;
        function nonPollingWatchFile(fileName, callback, _pollingInterval, fallbackOptions) {
            const filePath = toCanonicalName(fileName);
            fileWatcherCallbacks.add(filePath, callback);
            const dirPath = getDirectoryPath(filePath) || ".";
            const watcher = dirWatchers.get(dirPath) || createDirectoryWatcher(getDirectoryPath(fileName) || ".", dirPath, fallbackOptions);
            watcher.referenceCount++;
            return {
                close: ()=>{
                    if (watcher.referenceCount === 1) {
                        watcher.close();
                        dirWatchers.delete(dirPath);
                    } else watcher.referenceCount--;
                    fileWatcherCallbacks.remove(filePath, callback);
                }
            };
        }
        function createDirectoryWatcher(dirName, dirPath, fallbackOptions) {
            const watcher = fsWatch(dirName, 1 /* Directory */ , (_eventName, relativeFileName, modifiedTime)=>{
                if (!isString(relativeFileName)) return;
                const fileName = getNormalizedAbsolutePath(relativeFileName, dirName);
                const callbacks = fileName && fileWatcherCallbacks.get(toCanonicalName(fileName));
                if (callbacks) for (const fileCallback of callbacks)fileCallback(fileName, 1 /* Changed */ , modifiedTime);
            }, /*recursive*/ false, 500 /* Medium */ , fallbackOptions);
            watcher.referenceCount = 0;
            dirWatchers.set(dirPath, watcher);
            return watcher;
        }
    }
    function createFixedChunkSizePollingWatchFile(host) {
        const watchedFiles = [];
        let pollIndex = 0;
        let pollScheduled;
        return watchFile2;
        function watchFile2(fileName, callback) {
            const file = {
                fileName: fileName,
                callback: callback,
                mtime: getModifiedTime(host, fileName)
            };
            watchedFiles.push(file);
            scheduleNextPoll();
            return {
                close: ()=>{
                    file.isClosed = true;
                    unorderedRemoveItem(watchedFiles, file);
                }
            };
        }
        function pollQueue() {
            pollScheduled = void 0;
            pollIndex = pollWatchedFileQueue(host, watchedFiles, pollIndex, pollingChunkSize[250 /* Low */ ]);
            scheduleNextPoll();
        }
        function scheduleNextPoll() {
            if (!watchedFiles.length || pollScheduled) return;
            pollScheduled = host.setTimeout(pollQueue, 2e3 /* High */ , "pollQueue");
        }
    }
    function createSingleWatcherPerName(cache, useCaseSensitiveFileNames, name, callback, createWatcher) {
        const toCanonicalFileName = createGetCanonicalFileName(useCaseSensitiveFileNames);
        const path = toCanonicalFileName(name);
        const existing = cache.get(path);
        if (existing) existing.callbacks.push(callback);
        else cache.set(path, {
            watcher: createWatcher(// Cant infer types correctly so lets satisfy checker
            (param1, param2, param3)=>{
                var _a;
                return (_a = cache.get(path)) == null ? void 0 : _a.callbacks.slice().forEach((cb)=>cb(param1, param2, param3));
            }),
            callbacks: [
                callback
            ]
        });
        return {
            close: ()=>{
                const watcher = cache.get(path);
                if (!watcher) return;
                if (!orderedRemoveItem(watcher.callbacks, callback) || watcher.callbacks.length) return;
                cache.delete(path);
                closeFileWatcherOf(watcher);
            }
        };
    }
    function onWatchedFileStat(watchedFile, modifiedTime) {
        const oldTime = watchedFile.mtime.getTime();
        const newTime = modifiedTime.getTime();
        if (oldTime !== newTime) {
            watchedFile.mtime = modifiedTime;
            watchedFile.callback(watchedFile.fileName, getFileWatcherEventKind(oldTime, newTime), modifiedTime);
            return true;
        }
        return false;
    }
    function getFileWatcherEventKind(oldTime, newTime) {
        return oldTime === 0 ? 0 /* Created */  : newTime === 0 ? 2 /* Deleted */  : 1 /* Changed */ ;
    }
    function sysLog(s) {
        return curSysLog(s);
    }
    function setSysLog(logger) {
        curSysLog = logger;
    }
    function createDirectoryWatcherSupportingRecursive({ watchDirectory: watchDirectory , useCaseSensitiveFileNames: useCaseSensitiveFileNames , getCurrentDirectory: getCurrentDirectory , getAccessibleSortedChildDirectories: getAccessibleSortedChildDirectories , fileSystemEntryExists: fileSystemEntryExists , realpath: realpath , setTimeout: setTimeout2 , clearTimeout: clearTimeout2  }) {
        const cache = /* @__PURE__ */ new Map();
        const callbackCache = createMultiMap();
        const cacheToUpdateChildWatches = /* @__PURE__ */ new Map();
        let timerToUpdateChildWatches;
        const filePathComparer = getStringComparer(!useCaseSensitiveFileNames);
        const toCanonicalFilePath = createGetCanonicalFileName(useCaseSensitiveFileNames);
        return (dirName, callback, recursive, options)=>recursive ? createDirectoryWatcher(dirName, options, callback) : watchDirectory(dirName, callback, recursive, options);
        function createDirectoryWatcher(dirName, options, callback) {
            const dirPath = toCanonicalFilePath(dirName);
            let directoryWatcher = cache.get(dirPath);
            if (directoryWatcher) directoryWatcher.refCount++;
            else {
                directoryWatcher = {
                    watcher: watchDirectory(dirName, (fileName)=>{
                        if (isIgnoredPath(fileName, options)) return;
                        if (options == null ? void 0 : options.synchronousWatchDirectory) {
                            invokeCallbacks(dirPath, fileName);
                            updateChildWatches(dirName, dirPath, options);
                        } else nonSyncUpdateChildWatches(dirName, dirPath, fileName, options);
                    }, /*recursive*/ false, options),
                    refCount: 1,
                    childWatches: emptyArray
                };
                cache.set(dirPath, directoryWatcher);
                updateChildWatches(dirName, dirPath, options);
            }
            const callbackToAdd = callback && {
                dirName: dirName,
                callback: callback
            };
            if (callbackToAdd) callbackCache.add(dirPath, callbackToAdd);
            return {
                dirName: dirName,
                close: ()=>{
                    const directoryWatcher2 = Debug.checkDefined(cache.get(dirPath));
                    if (callbackToAdd) callbackCache.remove(dirPath, callbackToAdd);
                    directoryWatcher2.refCount--;
                    if (directoryWatcher2.refCount) return;
                    cache.delete(dirPath);
                    closeFileWatcherOf(directoryWatcher2);
                    directoryWatcher2.childWatches.forEach(closeFileWatcher);
                }
            };
        }
        function invokeCallbacks(dirPath, fileNameOrInvokeMap, fileNames) {
            let fileName;
            let invokeMap;
            if (isString(fileNameOrInvokeMap)) fileName = fileNameOrInvokeMap;
            else invokeMap = fileNameOrInvokeMap;
            callbackCache.forEach((callbacks, rootDirName)=>{
                if (invokeMap && invokeMap.get(rootDirName) === true) return;
                if (rootDirName === dirPath || startsWith(dirPath, rootDirName) && dirPath[rootDirName.length] === directorySeparator) {
                    if (invokeMap) {
                        if (fileNames) {
                            const existing = invokeMap.get(rootDirName);
                            if (existing) existing.push(...fileNames);
                            else invokeMap.set(rootDirName, fileNames.slice());
                        } else invokeMap.set(rootDirName, true);
                    } else callbacks.forEach(({ callback: callback  })=>callback(fileName));
                }
            });
        }
        function nonSyncUpdateChildWatches(dirName, dirPath, fileName, options) {
            const parentWatcher = cache.get(dirPath);
            if (parentWatcher && fileSystemEntryExists(dirName, 1 /* Directory */ )) {
                scheduleUpdateChildWatches(dirName, dirPath, fileName, options);
                return;
            }
            invokeCallbacks(dirPath, fileName);
            removeChildWatches(parentWatcher);
        }
        function scheduleUpdateChildWatches(dirName, dirPath, fileName, options) {
            const existing = cacheToUpdateChildWatches.get(dirPath);
            if (existing) existing.fileNames.push(fileName);
            else cacheToUpdateChildWatches.set(dirPath, {
                dirName: dirName,
                options: options,
                fileNames: [
                    fileName
                ]
            });
            if (timerToUpdateChildWatches) {
                clearTimeout2(timerToUpdateChildWatches);
                timerToUpdateChildWatches = void 0;
            }
            timerToUpdateChildWatches = setTimeout2(onTimerToUpdateChildWatches, 1e3, "timerToUpdateChildWatches");
        }
        function onTimerToUpdateChildWatches() {
            timerToUpdateChildWatches = void 0;
            sysLog(`sysLog:: onTimerToUpdateChildWatches:: ${cacheToUpdateChildWatches.size}`);
            const start = timestamp();
            const invokeMap = /* @__PURE__ */ new Map();
            while(!timerToUpdateChildWatches && cacheToUpdateChildWatches.size){
                const result = cacheToUpdateChildWatches.entries().next();
                Debug.assert(!result.done);
                const { value: [dirPath, { dirName: dirName , options: options , fileNames: fileNames  }]  } = result;
                cacheToUpdateChildWatches.delete(dirPath);
                const hasChanges = updateChildWatches(dirName, dirPath, options);
                invokeCallbacks(dirPath, invokeMap, hasChanges ? void 0 : fileNames);
            }
            sysLog(`sysLog:: invokingWatchers:: Elapsed:: ${timestamp() - start}ms:: ${cacheToUpdateChildWatches.size}`);
            callbackCache.forEach((callbacks, rootDirName)=>{
                const existing = invokeMap.get(rootDirName);
                if (existing) callbacks.forEach(({ callback: callback , dirName: dirName  })=>{
                    if (isArray(existing)) existing.forEach(callback);
                    else callback(dirName);
                });
            });
            const elapsed = timestamp() - start;
            sysLog(`sysLog:: Elapsed:: ${elapsed}ms:: onTimerToUpdateChildWatches:: ${cacheToUpdateChildWatches.size} ${timerToUpdateChildWatches}`);
        }
        function removeChildWatches(parentWatcher) {
            if (!parentWatcher) return;
            const existingChildWatches = parentWatcher.childWatches;
            parentWatcher.childWatches = emptyArray;
            for (const childWatcher of existingChildWatches){
                childWatcher.close();
                removeChildWatches(cache.get(toCanonicalFilePath(childWatcher.dirName)));
            }
        }
        function updateChildWatches(parentDir, parentDirPath, options) {
            const parentWatcher = cache.get(parentDirPath);
            if (!parentWatcher) return false;
            let newChildWatches;
            const hasChanges = enumerateInsertsAndDeletes(fileSystemEntryExists(parentDir, 1 /* Directory */ ) ? mapDefined(getAccessibleSortedChildDirectories(parentDir), (child)=>{
                const childFullName = getNormalizedAbsolutePath(child, parentDir);
                return !isIgnoredPath(childFullName, options) && filePathComparer(childFullName, normalizePath(realpath(childFullName))) === 0 /* EqualTo */  ? childFullName : void 0;
            }) : emptyArray, parentWatcher.childWatches, (child, childWatcher)=>filePathComparer(child, childWatcher.dirName), createAndAddChildDirectoryWatcher, closeFileWatcher, addChildDirectoryWatcher);
            parentWatcher.childWatches = newChildWatches || emptyArray;
            return hasChanges;
            function createAndAddChildDirectoryWatcher(childName) {
                const result = createDirectoryWatcher(childName, options);
                addChildDirectoryWatcher(result);
            }
            function addChildDirectoryWatcher(childWatcher) {
                (newChildWatches || (newChildWatches = [])).push(childWatcher);
            }
        }
        function isIgnoredPath(path, options) {
            return some(ignoredPaths, (searchPath)=>isInPath(path, searchPath)) || isIgnoredByWatchOptions(path, options, useCaseSensitiveFileNames, getCurrentDirectory);
        }
        function isInPath(path, searchPath) {
            if (stringContains(path, searchPath)) return true;
            if (useCaseSensitiveFileNames) return false;
            return stringContains(toCanonicalFilePath(path), searchPath);
        }
    }
    function createFileWatcherCallback(callback) {
        return (_fileName, eventKind, modifiedTime)=>callback(eventKind === 1 /* Changed */  ? "change" : "rename", "", modifiedTime);
    }
    function createFsWatchCallbackForFileWatcherCallback(fileName, callback, getModifiedTime3) {
        return (eventName, _relativeFileName, modifiedTime)=>{
            if (eventName === "rename") {
                modifiedTime || (modifiedTime = getModifiedTime3(fileName) || missingFileModifiedTime);
                callback(fileName, modifiedTime !== missingFileModifiedTime ? 0 /* Created */  : 2 /* Deleted */ , modifiedTime);
            } else callback(fileName, 1 /* Changed */ , modifiedTime);
        };
    }
    function isIgnoredByWatchOptions(pathToCheck, options, useCaseSensitiveFileNames, getCurrentDirectory) {
        return ((options == null ? void 0 : options.excludeDirectories) || (options == null ? void 0 : options.excludeFiles)) && (matchesExclude(pathToCheck, options == null ? void 0 : options.excludeFiles, useCaseSensitiveFileNames, getCurrentDirectory()) || matchesExclude(pathToCheck, options == null ? void 0 : options.excludeDirectories, useCaseSensitiveFileNames, getCurrentDirectory()));
    }
    function createFsWatchCallbackForDirectoryWatcherCallback(directoryName, callback, options, useCaseSensitiveFileNames, getCurrentDirectory) {
        return (eventName, relativeFileName)=>{
            if (eventName === "rename") {
                const fileName = !relativeFileName ? directoryName : normalizePath(combinePaths(directoryName, relativeFileName));
                if (!relativeFileName || !isIgnoredByWatchOptions(fileName, options, useCaseSensitiveFileNames, getCurrentDirectory)) callback(fileName);
            }
        };
    }
    function createSystemWatchFunctions({ pollingWatchFileWorker: pollingWatchFileWorker , getModifiedTime: getModifiedTime3 , setTimeout: setTimeout2 , clearTimeout: clearTimeout2 , fsWatchWorker: fsWatchWorker , fileSystemEntryExists: fileSystemEntryExists , useCaseSensitiveFileNames: useCaseSensitiveFileNames , getCurrentDirectory: getCurrentDirectory , fsSupportsRecursiveFsWatch: fsSupportsRecursiveFsWatch , getAccessibleSortedChildDirectories: getAccessibleSortedChildDirectories , realpath: realpath , tscWatchFile: tscWatchFile , useNonPollingWatchers: useNonPollingWatchers , tscWatchDirectory: tscWatchDirectory , inodeWatching: inodeWatching , sysLog: sysLog2  }) {
        const pollingWatches = /* @__PURE__ */ new Map();
        const fsWatches = /* @__PURE__ */ new Map();
        const fsWatchesRecursive = /* @__PURE__ */ new Map();
        let dynamicPollingWatchFile;
        let fixedChunkSizePollingWatchFile;
        let nonPollingWatchFile;
        let hostRecursiveDirectoryWatcher;
        let hitSystemWatcherLimit = false;
        return {
            watchFile: watchFile2,
            watchDirectory: watchDirectory
        };
        function watchFile2(fileName, callback, pollingInterval, options) {
            options = updateOptionsForWatchFile(options, useNonPollingWatchers);
            const watchFileKind = Debug.checkDefined(options.watchFile);
            switch(watchFileKind){
                case 0 /* FixedPollingInterval */ :
                    return pollingWatchFile(fileName, callback, 250 /* Low */ , /*options*/ void 0);
                case 1 /* PriorityPollingInterval */ :
                    return pollingWatchFile(fileName, callback, pollingInterval, /*options*/ void 0);
                case 2 /* DynamicPriorityPolling */ :
                    return ensureDynamicPollingWatchFile()(fileName, callback, pollingInterval, /*options*/ void 0);
                case 3 /* FixedChunkSizePolling */ :
                    return ensureFixedChunkSizePollingWatchFile()(fileName, callback, /* pollingInterval */ void 0, /*options*/ void 0);
                case 4 /* UseFsEvents */ :
                    return fsWatch(fileName, 0 /* File */ , createFsWatchCallbackForFileWatcherCallback(fileName, callback, getModifiedTime3), /*recursive*/ false, pollingInterval, getFallbackOptions(options));
                case 5 /* UseFsEventsOnParentDirectory */ :
                    if (!nonPollingWatchFile) nonPollingWatchFile = createUseFsEventsOnParentDirectoryWatchFile(fsWatch, useCaseSensitiveFileNames);
                    return nonPollingWatchFile(fileName, callback, pollingInterval, getFallbackOptions(options));
                default:
                    Debug.assertNever(watchFileKind);
            }
        }
        function ensureDynamicPollingWatchFile() {
            return dynamicPollingWatchFile || (dynamicPollingWatchFile = createDynamicPriorityPollingWatchFile({
                getModifiedTime: getModifiedTime3,
                setTimeout: setTimeout2
            }));
        }
        function ensureFixedChunkSizePollingWatchFile() {
            return fixedChunkSizePollingWatchFile || (fixedChunkSizePollingWatchFile = createFixedChunkSizePollingWatchFile({
                getModifiedTime: getModifiedTime3,
                setTimeout: setTimeout2
            }));
        }
        function updateOptionsForWatchFile(options, useNonPollingWatchers2) {
            if (options && options.watchFile !== void 0) return options;
            switch(tscWatchFile){
                case "PriorityPollingInterval":
                    return {
                        watchFile: 1 /* PriorityPollingInterval */ 
                    };
                case "DynamicPriorityPolling":
                    return {
                        watchFile: 2 /* DynamicPriorityPolling */ 
                    };
                case "UseFsEvents":
                    return generateWatchFileOptions(4 /* UseFsEvents */ , 1 /* PriorityInterval */ , options);
                case "UseFsEventsWithFallbackDynamicPolling":
                    return generateWatchFileOptions(4 /* UseFsEvents */ , 2 /* DynamicPriority */ , options);
                case "UseFsEventsOnParentDirectory":
                    useNonPollingWatchers2 = true;
                default:
                    return useNonPollingWatchers2 ? // Use notifications from FS to watch with falling back to fs.watchFile
                    generateWatchFileOptions(5 /* UseFsEventsOnParentDirectory */ , 1 /* PriorityInterval */ , options) : // Default to using fs events
                    {
                        watchFile: 4 /* UseFsEvents */ 
                    };
            }
        }
        function generateWatchFileOptions(watchFile3, fallbackPolling, options) {
            const defaultFallbackPolling = options == null ? void 0 : options.fallbackPolling;
            return {
                watchFile: watchFile3,
                fallbackPolling: defaultFallbackPolling === void 0 ? fallbackPolling : defaultFallbackPolling
            };
        }
        function watchDirectory(directoryName, callback, recursive, options) {
            if (fsSupportsRecursiveFsWatch) return fsWatch(directoryName, 1 /* Directory */ , createFsWatchCallbackForDirectoryWatcherCallback(directoryName, callback, options, useCaseSensitiveFileNames, getCurrentDirectory), recursive, 500 /* Medium */ , getFallbackOptions(options));
            if (!hostRecursiveDirectoryWatcher) hostRecursiveDirectoryWatcher = createDirectoryWatcherSupportingRecursive({
                useCaseSensitiveFileNames: useCaseSensitiveFileNames,
                getCurrentDirectory: getCurrentDirectory,
                fileSystemEntryExists: fileSystemEntryExists,
                getAccessibleSortedChildDirectories: getAccessibleSortedChildDirectories,
                watchDirectory: nonRecursiveWatchDirectory,
                realpath: realpath,
                setTimeout: setTimeout2,
                clearTimeout: clearTimeout2
            });
            return hostRecursiveDirectoryWatcher(directoryName, callback, recursive, options);
        }
        function nonRecursiveWatchDirectory(directoryName, callback, recursive, options) {
            Debug.assert(!recursive);
            const watchDirectoryOptions = updateOptionsForWatchDirectory(options);
            const watchDirectoryKind = Debug.checkDefined(watchDirectoryOptions.watchDirectory);
            switch(watchDirectoryKind){
                case 1 /* FixedPollingInterval */ :
                    return pollingWatchFile(directoryName, ()=>callback(directoryName), 500 /* Medium */ , /*options*/ void 0);
                case 2 /* DynamicPriorityPolling */ :
                    return ensureDynamicPollingWatchFile()(directoryName, ()=>callback(directoryName), 500 /* Medium */ , /*options*/ void 0);
                case 3 /* FixedChunkSizePolling */ :
                    return ensureFixedChunkSizePollingWatchFile()(directoryName, ()=>callback(directoryName), /* pollingInterval */ void 0, /*options*/ void 0);
                case 0 /* UseFsEvents */ :
                    return fsWatch(directoryName, 1 /* Directory */ , createFsWatchCallbackForDirectoryWatcherCallback(directoryName, callback, options, useCaseSensitiveFileNames, getCurrentDirectory), recursive, 500 /* Medium */ , getFallbackOptions(watchDirectoryOptions));
                default:
                    Debug.assertNever(watchDirectoryKind);
            }
        }
        function updateOptionsForWatchDirectory(options) {
            if (options && options.watchDirectory !== void 0) return options;
            switch(tscWatchDirectory){
                case "RecursiveDirectoryUsingFsWatchFile":
                    return {
                        watchDirectory: 1 /* FixedPollingInterval */ 
                    };
                case "RecursiveDirectoryUsingDynamicPriorityPolling":
                    return {
                        watchDirectory: 2 /* DynamicPriorityPolling */ 
                    };
                default:
                    const defaultFallbackPolling = options == null ? void 0 : options.fallbackPolling;
                    return {
                        watchDirectory: 0 /* UseFsEvents */ ,
                        fallbackPolling: defaultFallbackPolling !== void 0 ? defaultFallbackPolling : void 0
                    };
            }
        }
        function pollingWatchFile(fileName, callback, pollingInterval, options) {
            return createSingleWatcherPerName(pollingWatches, useCaseSensitiveFileNames, fileName, callback, (cb)=>pollingWatchFileWorker(fileName, cb, pollingInterval, options));
        }
        function fsWatch(fileOrDirectory, entryKind, callback, recursive, fallbackPollingInterval, fallbackOptions) {
            return createSingleWatcherPerName(recursive ? fsWatchesRecursive : fsWatches, useCaseSensitiveFileNames, fileOrDirectory, callback, (cb)=>fsWatchHandlingExistenceOnHost(fileOrDirectory, entryKind, cb, recursive, fallbackPollingInterval, fallbackOptions));
        }
        function fsWatchHandlingExistenceOnHost(fileOrDirectory, entryKind, callback, recursive, fallbackPollingInterval, fallbackOptions) {
            let lastDirectoryPartWithDirectorySeparator;
            let lastDirectoryPart;
            if (inodeWatching) {
                lastDirectoryPartWithDirectorySeparator = fileOrDirectory.substring(fileOrDirectory.lastIndexOf(directorySeparator));
                lastDirectoryPart = lastDirectoryPartWithDirectorySeparator.slice(directorySeparator.length);
            }
            let watcher = !fileSystemEntryExists(fileOrDirectory, entryKind) ? watchMissingFileSystemEntry() : watchPresentFileSystemEntry();
            return {
                close: ()=>{
                    if (watcher) {
                        watcher.close();
                        watcher = void 0;
                    }
                }
            };
            function updateWatcher(createWatcher) {
                if (watcher) {
                    sysLog2(`sysLog:: ${fileOrDirectory}:: Changing watcher to ${createWatcher === watchPresentFileSystemEntry ? "Present" : "Missing"}FileSystemEntryWatcher`);
                    watcher.close();
                    watcher = createWatcher();
                }
            }
            function watchPresentFileSystemEntry() {
                if (hitSystemWatcherLimit) {
                    sysLog2(`sysLog:: ${fileOrDirectory}:: Defaulting to watchFile`);
                    return watchPresentFileSystemEntryWithFsWatchFile();
                }
                try {
                    const presentWatcher = fsWatchWorker(fileOrDirectory, recursive, inodeWatching ? callbackChangingToMissingFileSystemEntry : callback);
                    presentWatcher.on("error", ()=>{
                        callback("rename", "");
                        updateWatcher(watchMissingFileSystemEntry);
                    });
                    return presentWatcher;
                } catch (e) {
                    hitSystemWatcherLimit || (hitSystemWatcherLimit = e.code === "ENOSPC");
                    sysLog2(`sysLog:: ${fileOrDirectory}:: Changing to watchFile`);
                    return watchPresentFileSystemEntryWithFsWatchFile();
                }
            }
            function callbackChangingToMissingFileSystemEntry(event, relativeName) {
                let originalRelativeName;
                if (relativeName && endsWith(relativeName, "~")) {
                    originalRelativeName = relativeName;
                    relativeName = relativeName.slice(0, relativeName.length - 1);
                }
                if (event === "rename" && (!relativeName || relativeName === lastDirectoryPart || endsWith(relativeName, lastDirectoryPartWithDirectorySeparator))) {
                    const modifiedTime = getModifiedTime3(fileOrDirectory) || missingFileModifiedTime;
                    if (originalRelativeName) callback(event, originalRelativeName, modifiedTime);
                    callback(event, relativeName, modifiedTime);
                    if (inodeWatching) updateWatcher(modifiedTime === missingFileModifiedTime ? watchMissingFileSystemEntry : watchPresentFileSystemEntry);
                    else if (modifiedTime === missingFileModifiedTime) updateWatcher(watchMissingFileSystemEntry);
                } else {
                    if (originalRelativeName) callback(event, originalRelativeName);
                    callback(event, relativeName);
                }
            }
            function watchPresentFileSystemEntryWithFsWatchFile() {
                return watchFile2(fileOrDirectory, createFileWatcherCallback(callback), fallbackPollingInterval, fallbackOptions);
            }
            function watchMissingFileSystemEntry() {
                return watchFile2(fileOrDirectory, (_fileName, eventKind, modifiedTime)=>{
                    if (eventKind === 0 /* Created */ ) {
                        modifiedTime || (modifiedTime = getModifiedTime3(fileOrDirectory) || missingFileModifiedTime);
                        if (modifiedTime !== missingFileModifiedTime) {
                            callback("rename", "", modifiedTime);
                            updateWatcher(watchPresentFileSystemEntry);
                        }
                    }
                }, fallbackPollingInterval, fallbackOptions);
            }
        }
    }
    function patchWriteFileEnsuringDirectory(sys2) {
        const originalWriteFile = sys2.writeFile;
        sys2.writeFile = (path, data, writeBom)=>writeFileEnsuringDirectories(path, data, !!writeBom, (path2, data2, writeByteOrderMark)=>originalWriteFile.call(sys2, path2, data2, writeByteOrderMark), (path2)=>sys2.createDirectory(path2), (path2)=>sys2.directoryExists(path2));
    }
    function setSys(s) {
        sys = s;
    }
    var FileWatcherEventKind, PollingInterval, missingFileModifiedTime, defaultChunkLevels, pollingChunkSize, unchangedPollThresholds, ignoredPaths, curSysLog, FileSystemEntryKind, sys;
    var init_sys = __esm({
        "src/compiler/sys.ts" () {
            "use strict";
            init_ts2();
            FileWatcherEventKind = /* @__PURE__ */ ((FileWatcherEventKind2)=>{
                FileWatcherEventKind2[FileWatcherEventKind2["Created"] = 0] = "Created";
                FileWatcherEventKind2[FileWatcherEventKind2["Changed"] = 1] = "Changed";
                FileWatcherEventKind2[FileWatcherEventKind2["Deleted"] = 2] = "Deleted";
                return FileWatcherEventKind2;
            })(FileWatcherEventKind || {});
            PollingInterval = /* @__PURE__ */ ((PollingInterval3)=>{
                PollingInterval3[PollingInterval3["High"] = 2e3] = "High";
                PollingInterval3[PollingInterval3["Medium"] = 500] = "Medium";
                PollingInterval3[PollingInterval3["Low"] = 250] = "Low";
                return PollingInterval3;
            })(PollingInterval || {});
            missingFileModifiedTime = /* @__PURE__ */ new Date(0);
            defaultChunkLevels = {
                Low: 32,
                Medium: 64,
                High: 256
            };
            pollingChunkSize = createPollingIntervalBasedLevels(defaultChunkLevels);
            unchangedPollThresholds = createPollingIntervalBasedLevels(defaultChunkLevels);
            ignoredPaths = [
                "/node_modules/.",
                "/.git",
                "/.#"
            ];
            curSysLog = noop;
            FileSystemEntryKind = /* @__PURE__ */ ((FileSystemEntryKind2)=>{
                FileSystemEntryKind2[FileSystemEntryKind2["File"] = 0] = "File";
                FileSystemEntryKind2[FileSystemEntryKind2["Directory"] = 1] = "Directory";
                return FileSystemEntryKind2;
            })(FileSystemEntryKind || {});
            sys = (()=>{
                const byteOrderMarkIndicator = "\uFEFF";
                function getNodeSystem() {
                    const nativePattern = /^native |^\([^)]+\)$|^(internal[\\/]|[a-zA-Z0-9_\s]+(\.js)?$)/;
                    const _fs = (parcelRequire("kjyEk"));
                    const _path = (parcelRequire("kjyEk"));
                    const _os = (parcelRequire("kjyEk"));
                    let _crypto;
                    try {
                        _crypto = (parcelRequire("kjyEk"));
                    } catch  {
                        _crypto = void 0;
                    }
                    let activeSession;
                    let profilePath = "./profile.cpuprofile";
                    const Buffer2 = (parcelRequire("kjyEk")).Buffer;
                    const isLinuxOrMacOs = $cfae44f0dfdf62c0$exports.platform === "linux" || $cfae44f0dfdf62c0$exports.platform === "darwin";
                    const platform = _os.platform();
                    const useCaseSensitiveFileNames = isFileSystemCaseSensitive();
                    const fsRealpath = !!_fs.realpathSync.native ? $cfae44f0dfdf62c0$exports.platform === "win32" ? fsRealPathHandlingLongPath : _fs.realpathSync.native : _fs.realpathSync;
                    const executingFilePath = $10339b5de87e77e2$var$__filename.endsWith("sys.js") ? _path.join(_path.dirname($10339b5de87e77e2$var$__dirname), "__fake__.js") : $10339b5de87e77e2$var$__filename;
                    const fsSupportsRecursiveFsWatch = $cfae44f0dfdf62c0$exports.platform === "win32" || $cfae44f0dfdf62c0$exports.platform === "darwin";
                    const getCurrentDirectory = memoize(()=>$cfae44f0dfdf62c0$exports.cwd());
                    const { watchFile: watchFile2 , watchDirectory: watchDirectory  } = createSystemWatchFunctions({
                        pollingWatchFileWorker: fsWatchFileWorker,
                        getModifiedTime: getModifiedTime3,
                        setTimeout: setTimeout,
                        clearTimeout: clearTimeout,
                        fsWatchWorker: fsWatchWorker,
                        useCaseSensitiveFileNames: useCaseSensitiveFileNames,
                        getCurrentDirectory: getCurrentDirectory,
                        fileSystemEntryExists: fileSystemEntryExists,
                        fsSupportsRecursiveFsWatch: // Node 4.0 `fs.watch` function supports the "recursive" option on both OSX and Windows
                        // (ref: https://github.com/nodejs/node/pull/2649 and https://github.com/Microsoft/TypeScript/issues/4643)
                        fsSupportsRecursiveFsWatch,
                        getAccessibleSortedChildDirectories: (path)=>getAccessibleFileSystemEntries(path).directories,
                        realpath: realpath,
                        tscWatchFile: undefined,
                        useNonPollingWatchers: false,
                        tscWatchDirectory: undefined,
                        inodeWatching: isLinuxOrMacOs,
                        sysLog: sysLog
                    });
                    const nodeSystem = {
                        args: $cfae44f0dfdf62c0$exports.argv.slice(2),
                        newLine: _os.EOL,
                        useCaseSensitiveFileNames: useCaseSensitiveFileNames,
                        write (s) {
                            $cfae44f0dfdf62c0$exports.stdout.write(s);
                        },
                        getWidthOfTerminal () {
                            return $cfae44f0dfdf62c0$exports.stdout.columns;
                        },
                        writeOutputIsTTY () {
                            return $cfae44f0dfdf62c0$exports.stdout.isTTY;
                        },
                        readFile: readFile,
                        writeFile: writeFile2,
                        watchFile: watchFile2,
                        watchDirectory: watchDirectory,
                        resolvePath: (path)=>_path.resolve(path),
                        fileExists: fileExists,
                        directoryExists: directoryExists,
                        createDirectory (directoryName) {
                            if (!nodeSystem.directoryExists(directoryName)) try {
                                _fs.mkdirSync(directoryName);
                            } catch (e) {
                                if (e.code !== "EEXIST") throw e;
                            }
                        },
                        getExecutingFilePath () {
                            return executingFilePath;
                        },
                        getCurrentDirectory: getCurrentDirectory,
                        getDirectories: getDirectories,
                        getEnvironmentVariable (name) {
                            return $cfae44f0dfdf62c0$exports.env[name] || "";
                        },
                        readDirectory: readDirectory,
                        getModifiedTime: getModifiedTime3,
                        setModifiedTime: setModifiedTime,
                        deleteFile: deleteFile,
                        createHash: _crypto ? createSHA256Hash : generateDjb2Hash,
                        createSHA256Hash: _crypto ? createSHA256Hash : void 0,
                        getMemoryUsage () {
                            if ($parcel$global.gc) $parcel$global.gc();
                            return $cfae44f0dfdf62c0$exports.memoryUsage().heapUsed;
                        },
                        getFileSize (path) {
                            try {
                                const stat = statSync(path);
                                if (stat == null ? void 0 : stat.isFile()) return stat.size;
                            } catch  {}
                            return 0;
                        },
                        exit (exitCode) {
                            disableCPUProfiler(()=>$cfae44f0dfdf62c0$exports.exit(exitCode));
                        },
                        enableCPUProfiler: enableCPUProfiler,
                        disableCPUProfiler: disableCPUProfiler,
                        cpuProfilingEnabled: ()=>!!activeSession || contains($cfae44f0dfdf62c0$exports.execArgv, "--cpu-prof") || contains($cfae44f0dfdf62c0$exports.execArgv, "--prof"),
                        realpath: realpath,
                        debugMode: some($cfae44f0dfdf62c0$exports.execArgv, (arg)=>/^--(inspect|debug)(-brk)?(=\d+)?$/i.test(arg)),
                        tryEnableSourceMapsForHost () {
                            try {
                                (parcelRequire("kjyEk")).install();
                            } catch  {}
                        },
                        setTimeout: setTimeout,
                        clearTimeout: clearTimeout,
                        clearScreen: ()=>{
                            $cfae44f0dfdf62c0$exports.stdout.write("\x1bc");
                        },
                        setBlocking: ()=>{
                            var _a;
                            const handle = (_a = $cfae44f0dfdf62c0$exports.stdout) == null ? void 0 : _a._handle;
                            if (handle && handle.setBlocking) handle.setBlocking(true);
                        },
                        bufferFrom: bufferFrom,
                        base64decode: (input)=>bufferFrom(input, "base64").toString("utf8"),
                        base64encode: (input)=>bufferFrom(input).toString("base64"),
                        require: (baseDir, moduleName)=>{
                            try {
                                const modulePath = resolveJSModule(moduleName, baseDir, nodeSystem);
                                return {
                                    module: require(modulePath),
                                    modulePath: modulePath,
                                    error: void 0
                                };
                            } catch (error) {
                                return {
                                    module: void 0,
                                    modulePath: void 0,
                                    error: error
                                };
                            }
                        }
                    };
                    return nodeSystem;
                    function statSync(path) {
                        return _fs.statSync(path, {
                            throwIfNoEntry: false
                        });
                    }
                    function enableCPUProfiler(path, cb) {
                        if (activeSession) {
                            cb();
                            return false;
                        }
                        const inspector = (parcelRequire("kjyEk"));
                        if (!inspector || !inspector.Session) {
                            cb();
                            return false;
                        }
                        const session = new inspector.Session();
                        session.connect();
                        session.post("Profiler.enable", ()=>{
                            session.post("Profiler.start", ()=>{
                                activeSession = session;
                                profilePath = path;
                                cb();
                            });
                        });
                        return true;
                    }
                    function cleanupPaths(profile) {
                        let externalFileCounter = 0;
                        const remappedPaths = /* @__PURE__ */ new Map();
                        const normalizedDir = normalizeSlashes(_path.dirname(executingFilePath));
                        const fileUrlRoot = `file://${getRootLength(normalizedDir) === 1 ? "" : "/"}${normalizedDir}`;
                        for (const node of profile.nodes)if (node.callFrame.url) {
                            const url = normalizeSlashes(node.callFrame.url);
                            if (containsPath(fileUrlRoot, url, useCaseSensitiveFileNames)) node.callFrame.url = getRelativePathToDirectoryOrUrl(fileUrlRoot, url, fileUrlRoot, createGetCanonicalFileName(useCaseSensitiveFileNames), /*isAbsolutePathAnUrl*/ true);
                            else if (!nativePattern.test(url)) {
                                node.callFrame.url = (remappedPaths.has(url) ? remappedPaths : remappedPaths.set(url, `external${externalFileCounter}.js`)).get(url);
                                externalFileCounter++;
                            }
                        }
                        return profile;
                    }
                    function disableCPUProfiler(cb) {
                        if (activeSession && activeSession !== "stopping") {
                            const s = activeSession;
                            activeSession.post("Profiler.stop", (err, { profile: profile  })=>{
                                var _a;
                                if (!err) {
                                    try {
                                        if ((_a = statSync(profilePath)) == null ? void 0 : _a.isDirectory()) profilePath = _path.join(profilePath, `${/* @__PURE__ */ new Date().toISOString().replace(/:/g, "-")}+P${$cfae44f0dfdf62c0$exports.pid}.cpuprofile`);
                                    } catch  {}
                                    try {
                                        _fs.mkdirSync(_path.dirname(profilePath), {
                                            recursive: true
                                        });
                                    } catch  {}
                                    _fs.writeFileSync(profilePath, JSON.stringify(cleanupPaths(profile)));
                                }
                                activeSession = void 0;
                                s.disconnect();
                                cb();
                            });
                            activeSession = "stopping";
                            return true;
                        } else {
                            cb();
                            return false;
                        }
                    }
                    function bufferFrom(input, encoding) {
                        return Buffer2.from && Buffer2.from !== Int8Array.from ? Buffer2.from(input, encoding) : new Buffer2(input, encoding);
                    }
                    function isFileSystemCaseSensitive() {
                        if (platform === "win32" || platform === "win64") return false;
                        return !fileExists(swapCase($10339b5de87e77e2$var$__filename));
                    }
                    function swapCase(s) {
                        return s.replace(/\w/g, (ch)=>{
                            const up = ch.toUpperCase();
                            return ch === up ? ch.toLowerCase() : up;
                        });
                    }
                    function fsWatchFileWorker(fileName, callback, pollingInterval) {
                        _fs.watchFile(fileName, {
                            persistent: true,
                            interval: pollingInterval
                        }, fileChanged);
                        let eventKind;
                        return {
                            close: ()=>_fs.unwatchFile(fileName, fileChanged)
                        };
                        function fileChanged(curr, prev) {
                            const isPreviouslyDeleted = +prev.mtime === 0 || eventKind === 2 /* Deleted */ ;
                            if (+curr.mtime === 0) {
                                if (isPreviouslyDeleted) return;
                                eventKind = 2 /* Deleted */ ;
                            } else if (isPreviouslyDeleted) eventKind = 0 /* Created */ ;
                            else if (+curr.mtime === +prev.mtime) return;
                            else eventKind = 1 /* Changed */ ;
                            callback(fileName, eventKind, curr.mtime);
                        }
                    }
                    function fsWatchWorker(fileOrDirectory, recursive, callback) {
                        return _fs.watch(fileOrDirectory, fsSupportsRecursiveFsWatch ? {
                            persistent: true,
                            recursive: !!recursive
                        } : {
                            persistent: true
                        }, callback);
                    }
                    function readFileWorker(fileName, _encoding) {
                        let buffer;
                        try {
                            buffer = _fs.readFileSync(fileName);
                        } catch (e) {
                            return void 0;
                        }
                        let len = buffer.length;
                        if (len >= 2 && buffer[0] === 254 && buffer[1] === 255) {
                            len &= -2;
                            for(let i = 0; i < len; i += 2){
                                const temp = buffer[i];
                                buffer[i] = buffer[i + 1];
                                buffer[i + 1] = temp;
                            }
                            return buffer.toString("utf16le", 2);
                        }
                        if (len >= 2 && buffer[0] === 255 && buffer[1] === 254) return buffer.toString("utf16le", 2);
                        if (len >= 3 && buffer[0] === 239 && buffer[1] === 187 && buffer[2] === 191) return buffer.toString("utf8", 3);
                        return buffer.toString("utf8");
                    }
                    function readFile(fileName, _encoding) {
                        var _a, _b;
                        (_a = perfLogger) == null || _a.logStartReadFile(fileName);
                        const file = readFileWorker(fileName, _encoding);
                        (_b = perfLogger) == null || _b.logStopReadFile();
                        return file;
                    }
                    function writeFile2(fileName, data, writeByteOrderMark) {
                        var _a;
                        (_a = perfLogger) == null || _a.logEvent("WriteFile: " + fileName);
                        if (writeByteOrderMark) data = byteOrderMarkIndicator + data;
                        let fd;
                        try {
                            fd = _fs.openSync(fileName, "w");
                            _fs.writeSync(fd, data, /*position*/ void 0, "utf8");
                        } finally{
                            if (fd !== void 0) _fs.closeSync(fd);
                        }
                    }
                    function getAccessibleFileSystemEntries(path) {
                        var _a;
                        (_a = perfLogger) == null || _a.logEvent("ReadDir: " + (path || "."));
                        try {
                            const entries = _fs.readdirSync(path || ".", {
                                withFileTypes: true
                            });
                            const files = [];
                            const directories = [];
                            for (const dirent of entries){
                                const entry = typeof dirent === "string" ? dirent : dirent.name;
                                if (entry === "." || entry === "..") continue;
                                let stat;
                                if (typeof dirent === "string" || dirent.isSymbolicLink()) {
                                    const name = combinePaths(path, entry);
                                    try {
                                        stat = statSync(name);
                                        if (!stat) continue;
                                    } catch (e) {
                                        continue;
                                    }
                                } else stat = dirent;
                                if (stat.isFile()) files.push(entry);
                                else if (stat.isDirectory()) directories.push(entry);
                            }
                            files.sort();
                            directories.sort();
                            return {
                                files: files,
                                directories: directories
                            };
                        } catch (e) {
                            return emptyFileSystemEntries;
                        }
                    }
                    function readDirectory(path, extensions, excludes, includes, depth) {
                        return matchFiles(path, extensions, excludes, includes, useCaseSensitiveFileNames, $cfae44f0dfdf62c0$exports.cwd(), depth, getAccessibleFileSystemEntries, realpath);
                    }
                    function fileSystemEntryExists(path, entryKind) {
                        const originalStackTraceLimit = Error.stackTraceLimit;
                        Error.stackTraceLimit = 0;
                        try {
                            const stat = statSync(path);
                            if (!stat) return false;
                            switch(entryKind){
                                case 0 /* File */ :
                                    return stat.isFile();
                                case 1 /* Directory */ :
                                    return stat.isDirectory();
                                default:
                                    return false;
                            }
                        } catch (e) {
                            return false;
                        } finally{
                            Error.stackTraceLimit = originalStackTraceLimit;
                        }
                    }
                    function fileExists(path) {
                        return fileSystemEntryExists(path, 0 /* File */ );
                    }
                    function directoryExists(path) {
                        return fileSystemEntryExists(path, 1 /* Directory */ );
                    }
                    function getDirectories(path) {
                        return getAccessibleFileSystemEntries(path).directories.slice();
                    }
                    function fsRealPathHandlingLongPath(path) {
                        return path.length < 260 ? _fs.realpathSync.native(path) : _fs.realpathSync(path);
                    }
                    function realpath(path) {
                        try {
                            return fsRealpath(path);
                        } catch  {
                            return path;
                        }
                    }
                    function getModifiedTime3(path) {
                        var _a;
                        const originalStackTraceLimit = Error.stackTraceLimit;
                        Error.stackTraceLimit = 0;
                        try {
                            return (_a = statSync(path)) == null ? void 0 : _a.mtime;
                        } catch (e) {
                            return void 0;
                        } finally{
                            Error.stackTraceLimit = originalStackTraceLimit;
                        }
                    }
                    function setModifiedTime(path, time) {
                        try {
                            _fs.utimesSync(path, time, time);
                        } catch (e) {
                            return;
                        }
                    }
                    function deleteFile(path) {
                        try {
                            return _fs.unlinkSync(path);
                        } catch (e) {
                            return;
                        }
                    }
                    function createSHA256Hash(data) {
                        const hash = _crypto.createHash("sha256");
                        hash.update(data);
                        return hash.digest("hex");
                    }
                }
                let sys2;
                if (isNodeLikeSystem()) sys2 = getNodeSystem();
                if (sys2) patchWriteFileEnsuringDirectory(sys2);
                return sys2;
            })();
            if (sys && sys.getEnvironmentVariable) {
                setCustomPollingValues(sys);
                Debug.setAssertionLevel(/^development$/i.test(sys.getEnvironmentVariable("NODE_ENV")) ? 1 /* Normal */  : 0 /* None */ );
            }
            if (sys && sys.debugMode) Debug.isDebugging = true;
        }
    });
    // src/compiler/path.ts
    function isAnyDirectorySeparator(charCode) {
        return charCode === 47 /* slash */  || charCode === 92 /* backslash */ ;
    }
    function isUrl(path) {
        return getEncodedRootLength(path) < 0;
    }
    function isRootedDiskPath(path) {
        return getEncodedRootLength(path) > 0;
    }
    function isDiskPathRoot(path) {
        const rootLength = getEncodedRootLength(path);
        return rootLength > 0 && rootLength === path.length;
    }
    function pathIsAbsolute(path) {
        return getEncodedRootLength(path) !== 0;
    }
    function pathIsRelative(path) {
        return /^\.\.?($|[\\/])/.test(path);
    }
    function pathIsBareSpecifier(path) {
        return !pathIsAbsolute(path) && !pathIsRelative(path);
    }
    function hasExtension(fileName) {
        return stringContains(getBaseFileName(fileName), ".");
    }
    function fileExtensionIs(path, extension) {
        return path.length > extension.length && endsWith(path, extension);
    }
    function fileExtensionIsOneOf(path, extensions) {
        for (const extension of extensions){
            if (fileExtensionIs(path, extension)) return true;
        }
        return false;
    }
    function hasTrailingDirectorySeparator(path) {
        return path.length > 0 && isAnyDirectorySeparator(path.charCodeAt(path.length - 1));
    }
    function isVolumeCharacter(charCode) {
        return charCode >= 97 /* a */  && charCode <= 122 /* z */  || charCode >= 65 /* A */  && charCode <= 90 /* Z */ ;
    }
    function getFileUrlVolumeSeparatorEnd(url, start) {
        const ch0 = url.charCodeAt(start);
        if (ch0 === 58 /* colon */ ) return start + 1;
        if (ch0 === 37 /* percent */  && url.charCodeAt(start + 1) === 51 /* _3 */ ) {
            const ch2 = url.charCodeAt(start + 2);
            if (ch2 === 97 /* a */  || ch2 === 65 /* A */ ) return start + 3;
        }
        return -1;
    }
    function getEncodedRootLength(path) {
        if (!path) return 0;
        const ch0 = path.charCodeAt(0);
        if (ch0 === 47 /* slash */  || ch0 === 92 /* backslash */ ) {
            if (path.charCodeAt(1) !== ch0) return 1;
            const p1 = path.indexOf(ch0 === 47 /* slash */  ? directorySeparator : altDirectorySeparator, 2);
            if (p1 < 0) return path.length;
            return p1 + 1;
        }
        if (isVolumeCharacter(ch0) && path.charCodeAt(1) === 58 /* colon */ ) {
            const ch2 = path.charCodeAt(2);
            if (ch2 === 47 /* slash */  || ch2 === 92 /* backslash */ ) return 3;
            if (path.length === 2) return 2;
        }
        const schemeEnd = path.indexOf(urlSchemeSeparator);
        if (schemeEnd !== -1) {
            const authorityStart = schemeEnd + urlSchemeSeparator.length;
            const authorityEnd = path.indexOf(directorySeparator, authorityStart);
            if (authorityEnd !== -1) {
                const scheme = path.slice(0, schemeEnd);
                const authority = path.slice(authorityStart, authorityEnd);
                if (scheme === "file" && (authority === "" || authority === "localhost") && isVolumeCharacter(path.charCodeAt(authorityEnd + 1))) {
                    const volumeSeparatorEnd = getFileUrlVolumeSeparatorEnd(path, authorityEnd + 2);
                    if (volumeSeparatorEnd !== -1) {
                        if (path.charCodeAt(volumeSeparatorEnd) === 47 /* slash */ ) return ~(volumeSeparatorEnd + 1);
                        if (volumeSeparatorEnd === path.length) return ~volumeSeparatorEnd;
                    }
                }
                return ~(authorityEnd + 1);
            }
            return ~path.length;
        }
        return 0;
    }
    function getRootLength(path) {
        const rootLength = getEncodedRootLength(path);
        return rootLength < 0 ? ~rootLength : rootLength;
    }
    function getDirectoryPath(path) {
        path = normalizeSlashes(path);
        const rootLength = getRootLength(path);
        if (rootLength === path.length) return path;
        path = removeTrailingDirectorySeparator(path);
        return path.slice(0, Math.max(rootLength, path.lastIndexOf(directorySeparator)));
    }
    function getBaseFileName(path, extensions, ignoreCase) {
        path = normalizeSlashes(path);
        const rootLength = getRootLength(path);
        if (rootLength === path.length) return "";
        path = removeTrailingDirectorySeparator(path);
        const name = path.slice(Math.max(getRootLength(path), path.lastIndexOf(directorySeparator) + 1));
        const extension = extensions !== void 0 && ignoreCase !== void 0 ? getAnyExtensionFromPath(name, extensions, ignoreCase) : void 0;
        return extension ? name.slice(0, name.length - extension.length) : name;
    }
    function tryGetExtensionFromPath(path, extension, stringEqualityComparer) {
        if (!startsWith(extension, ".")) extension = "." + extension;
        if (path.length >= extension.length && path.charCodeAt(path.length - extension.length) === 46 /* dot */ ) {
            const pathExtension = path.slice(path.length - extension.length);
            if (stringEqualityComparer(pathExtension, extension)) return pathExtension;
        }
    }
    function getAnyExtensionFromPathWorker(path, extensions, stringEqualityComparer) {
        if (typeof extensions === "string") return tryGetExtensionFromPath(path, extensions, stringEqualityComparer) || "";
        for (const extension of extensions){
            const result = tryGetExtensionFromPath(path, extension, stringEqualityComparer);
            if (result) return result;
        }
        return "";
    }
    function getAnyExtensionFromPath(path, extensions, ignoreCase) {
        if (extensions) return getAnyExtensionFromPathWorker(removeTrailingDirectorySeparator(path), extensions, ignoreCase ? equateStringsCaseInsensitive : equateStringsCaseSensitive);
        const baseFileName = getBaseFileName(path);
        const extensionIndex = baseFileName.lastIndexOf(".");
        if (extensionIndex >= 0) return baseFileName.substring(extensionIndex);
        return "";
    }
    function pathComponents(path, rootLength) {
        const root = path.substring(0, rootLength);
        const rest = path.substring(rootLength).split(directorySeparator);
        if (rest.length && !lastOrUndefined(rest)) rest.pop();
        return [
            root,
            ...rest
        ];
    }
    function getPathComponents(path, currentDirectory = "") {
        path = combinePaths(currentDirectory, path);
        return pathComponents(path, getRootLength(path));
    }
    function getPathFromPathComponents(pathComponents2, length2) {
        if (pathComponents2.length === 0) return "";
        const root = pathComponents2[0] && ensureTrailingDirectorySeparator(pathComponents2[0]);
        return root + pathComponents2.slice(1, length2).join(directorySeparator);
    }
    function normalizeSlashes(path) {
        return path.indexOf("\\") !== -1 ? path.replace(backslashRegExp, directorySeparator) : path;
    }
    function reducePathComponents(components) {
        if (!some(components)) return [];
        const reduced = [
            components[0]
        ];
        for(let i = 1; i < components.length; i++){
            const component = components[i];
            if (!component) continue;
            if (component === ".") continue;
            if (component === "..") {
                if (reduced.length > 1) {
                    if (reduced[reduced.length - 1] !== "..") {
                        reduced.pop();
                        continue;
                    }
                } else if (reduced[0]) continue;
            }
            reduced.push(component);
        }
        return reduced;
    }
    function combinePaths(path, ...paths) {
        if (path) path = normalizeSlashes(path);
        for (let relativePath of paths){
            if (!relativePath) continue;
            relativePath = normalizeSlashes(relativePath);
            if (!path || getRootLength(relativePath) !== 0) path = relativePath;
            else path = ensureTrailingDirectorySeparator(path) + relativePath;
        }
        return path;
    }
    function resolvePath(path, ...paths) {
        return normalizePath(some(paths) ? combinePaths(path, ...paths) : normalizeSlashes(path));
    }
    function getNormalizedPathComponents(path, currentDirectory) {
        return reducePathComponents(getPathComponents(path, currentDirectory));
    }
    function getNormalizedAbsolutePath(fileName, currentDirectory) {
        return getPathFromPathComponents(getNormalizedPathComponents(fileName, currentDirectory));
    }
    function normalizePath(path) {
        path = normalizeSlashes(path);
        if (!relativePathSegmentRegExp.test(path)) return path;
        const simplified = path.replace(/\/\.\//g, "/").replace(/^\.\//, "");
        if (simplified !== path) {
            path = simplified;
            if (!relativePathSegmentRegExp.test(path)) return path;
        }
        const normalized = getPathFromPathComponents(reducePathComponents(getPathComponents(path)));
        return normalized && hasTrailingDirectorySeparator(path) ? ensureTrailingDirectorySeparator(normalized) : normalized;
    }
    function getPathWithoutRoot(pathComponents2) {
        if (pathComponents2.length === 0) return "";
        return pathComponents2.slice(1).join(directorySeparator);
    }
    function getNormalizedAbsolutePathWithoutRoot(fileName, currentDirectory) {
        return getPathWithoutRoot(getNormalizedPathComponents(fileName, currentDirectory));
    }
    function toPath(fileName, basePath, getCanonicalFileName) {
        const nonCanonicalizedPath = isRootedDiskPath(fileName) ? normalizePath(fileName) : getNormalizedAbsolutePath(fileName, basePath);
        return getCanonicalFileName(nonCanonicalizedPath);
    }
    function removeTrailingDirectorySeparator(path) {
        if (hasTrailingDirectorySeparator(path)) return path.substr(0, path.length - 1);
        return path;
    }
    function ensureTrailingDirectorySeparator(path) {
        if (!hasTrailingDirectorySeparator(path)) return path + directorySeparator;
        return path;
    }
    function ensurePathIsNonModuleName(path) {
        return !pathIsAbsolute(path) && !pathIsRelative(path) ? "./" + path : path;
    }
    function changeAnyExtension(path, ext, extensions, ignoreCase) {
        const pathext = extensions !== void 0 && ignoreCase !== void 0 ? getAnyExtensionFromPath(path, extensions, ignoreCase) : getAnyExtensionFromPath(path);
        return pathext ? path.slice(0, path.length - pathext.length) + (startsWith(ext, ".") ? ext : "." + ext) : path;
    }
    function comparePathsWorker(a, b, componentComparer) {
        if (a === b) return 0 /* EqualTo */ ;
        if (a === void 0) return -1 /* LessThan */ ;
        if (b === void 0) return 1 /* GreaterThan */ ;
        const aRoot = a.substring(0, getRootLength(a));
        const bRoot = b.substring(0, getRootLength(b));
        const result = compareStringsCaseInsensitive(aRoot, bRoot);
        if (result !== 0 /* EqualTo */ ) return result;
        const aRest = a.substring(aRoot.length);
        const bRest = b.substring(bRoot.length);
        if (!relativePathSegmentRegExp.test(aRest) && !relativePathSegmentRegExp.test(bRest)) return componentComparer(aRest, bRest);
        const aComponents = reducePathComponents(getPathComponents(a));
        const bComponents = reducePathComponents(getPathComponents(b));
        const sharedLength = Math.min(aComponents.length, bComponents.length);
        for(let i = 1; i < sharedLength; i++){
            const result2 = componentComparer(aComponents[i], bComponents[i]);
            if (result2 !== 0 /* EqualTo */ ) return result2;
        }
        return compareValues(aComponents.length, bComponents.length);
    }
    function comparePathsCaseSensitive(a, b) {
        return comparePathsWorker(a, b, compareStringsCaseSensitive);
    }
    function comparePathsCaseInsensitive(a, b) {
        return comparePathsWorker(a, b, compareStringsCaseInsensitive);
    }
    function comparePaths(a, b, currentDirectory, ignoreCase) {
        if (typeof currentDirectory === "string") {
            a = combinePaths(currentDirectory, a);
            b = combinePaths(currentDirectory, b);
        } else if (typeof currentDirectory === "boolean") ignoreCase = currentDirectory;
        return comparePathsWorker(a, b, getStringComparer(ignoreCase));
    }
    function containsPath(parent2, child, currentDirectory, ignoreCase) {
        if (typeof currentDirectory === "string") {
            parent2 = combinePaths(currentDirectory, parent2);
            child = combinePaths(currentDirectory, child);
        } else if (typeof currentDirectory === "boolean") ignoreCase = currentDirectory;
        if (parent2 === void 0 || child === void 0) return false;
        if (parent2 === child) return true;
        const parentComponents = reducePathComponents(getPathComponents(parent2));
        const childComponents = reducePathComponents(getPathComponents(child));
        if (childComponents.length < parentComponents.length) return false;
        const componentEqualityComparer = ignoreCase ? equateStringsCaseInsensitive : equateStringsCaseSensitive;
        for(let i = 0; i < parentComponents.length; i++){
            const equalityComparer = i === 0 ? equateStringsCaseInsensitive : componentEqualityComparer;
            if (!equalityComparer(parentComponents[i], childComponents[i])) return false;
        }
        return true;
    }
    function startsWithDirectory(fileName, directoryName, getCanonicalFileName) {
        const canonicalFileName = getCanonicalFileName(fileName);
        const canonicalDirectoryName = getCanonicalFileName(directoryName);
        return startsWith(canonicalFileName, canonicalDirectoryName + "/") || startsWith(canonicalFileName, canonicalDirectoryName + "\\");
    }
    function getPathComponentsRelativeTo(from, to, stringEqualityComparer, getCanonicalFileName) {
        const fromComponents = reducePathComponents(getPathComponents(from));
        const toComponents = reducePathComponents(getPathComponents(to));
        let start;
        for(start = 0; start < fromComponents.length && start < toComponents.length; start++){
            const fromComponent = getCanonicalFileName(fromComponents[start]);
            const toComponent = getCanonicalFileName(toComponents[start]);
            const comparer = start === 0 ? equateStringsCaseInsensitive : stringEqualityComparer;
            if (!comparer(fromComponent, toComponent)) break;
        }
        if (start === 0) return toComponents;
        const components = toComponents.slice(start);
        const relative = [];
        for(; start < fromComponents.length; start++)relative.push("..");
        return [
            "",
            ...relative,
            ...components
        ];
    }
    function getRelativePathFromDirectory(fromDirectory, to, getCanonicalFileNameOrIgnoreCase) {
        Debug.assert(getRootLength(fromDirectory) > 0 === getRootLength(to) > 0, "Paths must either both be absolute or both be relative");
        const getCanonicalFileName = typeof getCanonicalFileNameOrIgnoreCase === "function" ? getCanonicalFileNameOrIgnoreCase : identity;
        const ignoreCase = typeof getCanonicalFileNameOrIgnoreCase === "boolean" ? getCanonicalFileNameOrIgnoreCase : false;
        const pathComponents2 = getPathComponentsRelativeTo(fromDirectory, to, ignoreCase ? equateStringsCaseInsensitive : equateStringsCaseSensitive, getCanonicalFileName);
        return getPathFromPathComponents(pathComponents2);
    }
    function convertToRelativePath(absoluteOrRelativePath, basePath, getCanonicalFileName) {
        return !isRootedDiskPath(absoluteOrRelativePath) ? absoluteOrRelativePath : getRelativePathToDirectoryOrUrl(basePath, absoluteOrRelativePath, basePath, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
    }
    function getRelativePathFromFile(from, to, getCanonicalFileName) {
        return ensurePathIsNonModuleName(getRelativePathFromDirectory(getDirectoryPath(from), to, getCanonicalFileName));
    }
    function getRelativePathToDirectoryOrUrl(directoryPathOrUrl, relativeOrAbsolutePath, currentDirectory, getCanonicalFileName, isAbsolutePathAnUrl) {
        const pathComponents2 = getPathComponentsRelativeTo(resolvePath(currentDirectory, directoryPathOrUrl), resolvePath(currentDirectory, relativeOrAbsolutePath), equateStringsCaseSensitive, getCanonicalFileName);
        const firstComponent = pathComponents2[0];
        if (isAbsolutePathAnUrl && isRootedDiskPath(firstComponent)) {
            const prefix = firstComponent.charAt(0) === directorySeparator ? "file://" : "file:///";
            pathComponents2[0] = prefix + firstComponent;
        }
        return getPathFromPathComponents(pathComponents2);
    }
    function forEachAncestorDirectory(directory, callback) {
        while(true){
            const result = callback(directory);
            if (result !== void 0) return result;
            const parentPath = getDirectoryPath(directory);
            if (parentPath === directory) return void 0;
            directory = parentPath;
        }
    }
    function isNodeModulesDirectory(dirPath) {
        return endsWith(dirPath, "/node_modules");
    }
    var directorySeparator, altDirectorySeparator, urlSchemeSeparator, backslashRegExp, relativePathSegmentRegExp;
    var init_path = __esm({
        "src/compiler/path.ts" () {
            "use strict";
            init_ts2();
            directorySeparator = "/";
            altDirectorySeparator = "\\";
            urlSchemeSeparator = "://";
            backslashRegExp = /\\/g;
            relativePathSegmentRegExp = /(?:\/\/)|(?:^|\/)\.\.?(?:$|\/)/;
        }
    });
    // src/compiler/diagnosticInformationMap.generated.ts
    function diag(code, category, key, message, reportsUnnecessary, elidedInCompatabilityPyramid, reportsDeprecated) {
        return {
            code: code,
            category: category,
            key: key,
            message: message,
            reportsUnnecessary: reportsUnnecessary,
            elidedInCompatabilityPyramid: elidedInCompatabilityPyramid,
            reportsDeprecated: reportsDeprecated
        };
    }
    var Diagnostics;
    var init_diagnosticInformationMap_generated = __esm({
        "src/compiler/diagnosticInformationMap.generated.ts" () {
            "use strict";
            init_types();
            Diagnostics = {
                Unterminated_string_literal: diag(1002, 1 /* Error */ , "Unterminated_string_literal_1002", "Unterminated string literal."),
                Identifier_expected: diag(1003, 1 /* Error */ , "Identifier_expected_1003", "Identifier expected."),
                _0_expected: diag(1005, 1 /* Error */ , "_0_expected_1005", "'{0}' expected."),
                A_file_cannot_have_a_reference_to_itself: diag(1006, 1 /* Error */ , "A_file_cannot_have_a_reference_to_itself_1006", "A file cannot have a reference to itself."),
                The_parser_expected_to_find_a_1_to_match_the_0_token_here: diag(1007, 1 /* Error */ , "The_parser_expected_to_find_a_1_to_match_the_0_token_here_1007", "The parser expected to find a '{1}' to match the '{0}' token here."),
                Trailing_comma_not_allowed: diag(1009, 1 /* Error */ , "Trailing_comma_not_allowed_1009", "Trailing comma not allowed."),
                Asterisk_Slash_expected: diag(1010, 1 /* Error */ , "Asterisk_Slash_expected_1010", "'*/' expected."),
                An_element_access_expression_should_take_an_argument: diag(1011, 1 /* Error */ , "An_element_access_expression_should_take_an_argument_1011", "An element access expression should take an argument."),
                Unexpected_token: diag(1012, 1 /* Error */ , "Unexpected_token_1012", "Unexpected token."),
                A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma: diag(1013, 1 /* Error */ , "A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma_1013", "A rest parameter or binding pattern may not have a trailing comma."),
                A_rest_parameter_must_be_last_in_a_parameter_list: diag(1014, 1 /* Error */ , "A_rest_parameter_must_be_last_in_a_parameter_list_1014", "A rest parameter must be last in a parameter list."),
                Parameter_cannot_have_question_mark_and_initializer: diag(1015, 1 /* Error */ , "Parameter_cannot_have_question_mark_and_initializer_1015", "Parameter cannot have question mark and initializer."),
                A_required_parameter_cannot_follow_an_optional_parameter: diag(1016, 1 /* Error */ , "A_required_parameter_cannot_follow_an_optional_parameter_1016", "A required parameter cannot follow an optional parameter."),
                An_index_signature_cannot_have_a_rest_parameter: diag(1017, 1 /* Error */ , "An_index_signature_cannot_have_a_rest_parameter_1017", "An index signature cannot have a rest parameter."),
                An_index_signature_parameter_cannot_have_an_accessibility_modifier: diag(1018, 1 /* Error */ , "An_index_signature_parameter_cannot_have_an_accessibility_modifier_1018", "An index signature parameter cannot have an accessibility modifier."),
                An_index_signature_parameter_cannot_have_a_question_mark: diag(1019, 1 /* Error */ , "An_index_signature_parameter_cannot_have_a_question_mark_1019", "An index signature parameter cannot have a question mark."),
                An_index_signature_parameter_cannot_have_an_initializer: diag(1020, 1 /* Error */ , "An_index_signature_parameter_cannot_have_an_initializer_1020", "An index signature parameter cannot have an initializer."),
                An_index_signature_must_have_a_type_annotation: diag(1021, 1 /* Error */ , "An_index_signature_must_have_a_type_annotation_1021", "An index signature must have a type annotation."),
                An_index_signature_parameter_must_have_a_type_annotation: diag(1022, 1 /* Error */ , "An_index_signature_parameter_must_have_a_type_annotation_1022", "An index signature parameter must have a type annotation."),
                readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature: diag(1024, 1 /* Error */ , "readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature_1024", "'readonly' modifier can only appear on a property declaration or index signature."),
                An_index_signature_cannot_have_a_trailing_comma: diag(1025, 1 /* Error */ , "An_index_signature_cannot_have_a_trailing_comma_1025", "An index signature cannot have a trailing comma."),
                Accessibility_modifier_already_seen: diag(1028, 1 /* Error */ , "Accessibility_modifier_already_seen_1028", "Accessibility modifier already seen."),
                _0_modifier_must_precede_1_modifier: diag(1029, 1 /* Error */ , "_0_modifier_must_precede_1_modifier_1029", "'{0}' modifier must precede '{1}' modifier."),
                _0_modifier_already_seen: diag(1030, 1 /* Error */ , "_0_modifier_already_seen_1030", "'{0}' modifier already seen."),
                _0_modifier_cannot_appear_on_class_elements_of_this_kind: diag(1031, 1 /* Error */ , "_0_modifier_cannot_appear_on_class_elements_of_this_kind_1031", "'{0}' modifier cannot appear on class elements of this kind."),
                super_must_be_followed_by_an_argument_list_or_member_access: diag(1034, 1 /* Error */ , "super_must_be_followed_by_an_argument_list_or_member_access_1034", "'super' must be followed by an argument list or member access."),
                Only_ambient_modules_can_use_quoted_names: diag(1035, 1 /* Error */ , "Only_ambient_modules_can_use_quoted_names_1035", "Only ambient modules can use quoted names."),
                Statements_are_not_allowed_in_ambient_contexts: diag(1036, 1 /* Error */ , "Statements_are_not_allowed_in_ambient_contexts_1036", "Statements are not allowed in ambient contexts."),
                A_declare_modifier_cannot_be_used_in_an_already_ambient_context: diag(1038, 1 /* Error */ , "A_declare_modifier_cannot_be_used_in_an_already_ambient_context_1038", "A 'declare' modifier cannot be used in an already ambient context."),
                Initializers_are_not_allowed_in_ambient_contexts: diag(1039, 1 /* Error */ , "Initializers_are_not_allowed_in_ambient_contexts_1039", "Initializers are not allowed in ambient contexts."),
                _0_modifier_cannot_be_used_in_an_ambient_context: diag(1040, 1 /* Error */ , "_0_modifier_cannot_be_used_in_an_ambient_context_1040", "'{0}' modifier cannot be used in an ambient context."),
                _0_modifier_cannot_be_used_here: diag(1042, 1 /* Error */ , "_0_modifier_cannot_be_used_here_1042", "'{0}' modifier cannot be used here."),
                _0_modifier_cannot_appear_on_a_module_or_namespace_element: diag(1044, 1 /* Error */ , "_0_modifier_cannot_appear_on_a_module_or_namespace_element_1044", "'{0}' modifier cannot appear on a module or namespace element."),
                Top_level_declarations_in_d_ts_files_must_start_with_either_a_declare_or_export_modifier: diag(1046, 1 /* Error */ , "Top_level_declarations_in_d_ts_files_must_start_with_either_a_declare_or_export_modifier_1046", "Top-level declarations in .d.ts files must start with either a 'declare' or 'export' modifier."),
                A_rest_parameter_cannot_be_optional: diag(1047, 1 /* Error */ , "A_rest_parameter_cannot_be_optional_1047", "A rest parameter cannot be optional."),
                A_rest_parameter_cannot_have_an_initializer: diag(1048, 1 /* Error */ , "A_rest_parameter_cannot_have_an_initializer_1048", "A rest parameter cannot have an initializer."),
                A_set_accessor_must_have_exactly_one_parameter: diag(1049, 1 /* Error */ , "A_set_accessor_must_have_exactly_one_parameter_1049", "A 'set' accessor must have exactly one parameter."),
                A_set_accessor_cannot_have_an_optional_parameter: diag(1051, 1 /* Error */ , "A_set_accessor_cannot_have_an_optional_parameter_1051", "A 'set' accessor cannot have an optional parameter."),
                A_set_accessor_parameter_cannot_have_an_initializer: diag(1052, 1 /* Error */ , "A_set_accessor_parameter_cannot_have_an_initializer_1052", "A 'set' accessor parameter cannot have an initializer."),
                A_set_accessor_cannot_have_rest_parameter: diag(1053, 1 /* Error */ , "A_set_accessor_cannot_have_rest_parameter_1053", "A 'set' accessor cannot have rest parameter."),
                A_get_accessor_cannot_have_parameters: diag(1054, 1 /* Error */ , "A_get_accessor_cannot_have_parameters_1054", "A 'get' accessor cannot have parameters."),
                Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value: diag(1055, 1 /* Error */ , "Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Prom_1055", "Type '{0}' is not a valid async function return type in ES5/ES3 because it does not refer to a Promise-compatible constructor value."),
                Accessors_are_only_available_when_targeting_ECMAScript_5_and_higher: diag(1056, 1 /* Error */ , "Accessors_are_only_available_when_targeting_ECMAScript_5_and_higher_1056", "Accessors are only available when targeting ECMAScript 5 and higher."),
                The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1058, 1 /* Error */ , "The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_t_1058", "The return type of an async function must either be a valid promise or must not contain a callable 'then' member."),
                A_promise_must_have_a_then_method: diag(1059, 1 /* Error */ , "A_promise_must_have_a_then_method_1059", "A promise must have a 'then' method."),
                The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback: diag(1060, 1 /* Error */ , "The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback_1060", "The first parameter of the 'then' method of a promise must be a callback."),
                Enum_member_must_have_initializer: diag(1061, 1 /* Error */ , "Enum_member_must_have_initializer_1061", "Enum member must have initializer."),
                Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method: diag(1062, 1 /* Error */ , "Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method_1062", "Type is referenced directly or indirectly in the fulfillment callback of its own 'then' method."),
                An_export_assignment_cannot_be_used_in_a_namespace: diag(1063, 1 /* Error */ , "An_export_assignment_cannot_be_used_in_a_namespace_1063", "An export assignment cannot be used in a namespace."),
                The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type_Did_you_mean_to_write_Promise_0: diag(1064, 1 /* Error */ , "The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type_Did_you_mean_to_wri_1064", "The return type of an async function or method must be the global Promise<T> type. Did you mean to write 'Promise<{0}>'?"),
                In_ambient_enum_declarations_member_initializer_must_be_constant_expression: diag(1066, 1 /* Error */ , "In_ambient_enum_declarations_member_initializer_must_be_constant_expression_1066", "In ambient enum declarations member initializer must be constant expression."),
                Unexpected_token_A_constructor_method_accessor_or_property_was_expected: diag(1068, 1 /* Error */ , "Unexpected_token_A_constructor_method_accessor_or_property_was_expected_1068", "Unexpected token. A constructor, method, accessor, or property was expected."),
                Unexpected_token_A_type_parameter_name_was_expected_without_curly_braces: diag(1069, 1 /* Error */ , "Unexpected_token_A_type_parameter_name_was_expected_without_curly_braces_1069", "Unexpected token. A type parameter name was expected without curly braces."),
                _0_modifier_cannot_appear_on_a_type_member: diag(1070, 1 /* Error */ , "_0_modifier_cannot_appear_on_a_type_member_1070", "'{0}' modifier cannot appear on a type member."),
                _0_modifier_cannot_appear_on_an_index_signature: diag(1071, 1 /* Error */ , "_0_modifier_cannot_appear_on_an_index_signature_1071", "'{0}' modifier cannot appear on an index signature."),
                A_0_modifier_cannot_be_used_with_an_import_declaration: diag(1079, 1 /* Error */ , "A_0_modifier_cannot_be_used_with_an_import_declaration_1079", "A '{0}' modifier cannot be used with an import declaration."),
                Invalid_reference_directive_syntax: diag(1084, 1 /* Error */ , "Invalid_reference_directive_syntax_1084", "Invalid 'reference' directive syntax."),
                _0_modifier_cannot_appear_on_a_constructor_declaration: diag(1089, 1 /* Error */ , "_0_modifier_cannot_appear_on_a_constructor_declaration_1089", "'{0}' modifier cannot appear on a constructor declaration."),
                _0_modifier_cannot_appear_on_a_parameter: diag(1090, 1 /* Error */ , "_0_modifier_cannot_appear_on_a_parameter_1090", "'{0}' modifier cannot appear on a parameter."),
                Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement: diag(1091, 1 /* Error */ , "Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement_1091", "Only a single variable declaration is allowed in a 'for...in' statement."),
                Type_parameters_cannot_appear_on_a_constructor_declaration: diag(1092, 1 /* Error */ , "Type_parameters_cannot_appear_on_a_constructor_declaration_1092", "Type parameters cannot appear on a constructor declaration."),
                Type_annotation_cannot_appear_on_a_constructor_declaration: diag(1093, 1 /* Error */ , "Type_annotation_cannot_appear_on_a_constructor_declaration_1093", "Type annotation cannot appear on a constructor declaration."),
                An_accessor_cannot_have_type_parameters: diag(1094, 1 /* Error */ , "An_accessor_cannot_have_type_parameters_1094", "An accessor cannot have type parameters."),
                A_set_accessor_cannot_have_a_return_type_annotation: diag(1095, 1 /* Error */ , "A_set_accessor_cannot_have_a_return_type_annotation_1095", "A 'set' accessor cannot have a return type annotation."),
                An_index_signature_must_have_exactly_one_parameter: diag(1096, 1 /* Error */ , "An_index_signature_must_have_exactly_one_parameter_1096", "An index signature must have exactly one parameter."),
                _0_list_cannot_be_empty: diag(1097, 1 /* Error */ , "_0_list_cannot_be_empty_1097", "'{0}' list cannot be empty."),
                Type_parameter_list_cannot_be_empty: diag(1098, 1 /* Error */ , "Type_parameter_list_cannot_be_empty_1098", "Type parameter list cannot be empty."),
                Type_argument_list_cannot_be_empty: diag(1099, 1 /* Error */ , "Type_argument_list_cannot_be_empty_1099", "Type argument list cannot be empty."),
                Invalid_use_of_0_in_strict_mode: diag(1100, 1 /* Error */ , "Invalid_use_of_0_in_strict_mode_1100", "Invalid use of '{0}' in strict mode."),
                with_statements_are_not_allowed_in_strict_mode: diag(1101, 1 /* Error */ , "with_statements_are_not_allowed_in_strict_mode_1101", "'with' statements are not allowed in strict mode."),
                delete_cannot_be_called_on_an_identifier_in_strict_mode: diag(1102, 1 /* Error */ , "delete_cannot_be_called_on_an_identifier_in_strict_mode_1102", "'delete' cannot be called on an identifier in strict mode."),
                for_await_loops_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules: diag(1103, 1 /* Error */ , "for_await_loops_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules_1103", "'for await' loops are only allowed within async functions and at the top levels of modules."),
                A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement: diag(1104, 1 /* Error */ , "A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement_1104", "A 'continue' statement can only be used within an enclosing iteration statement."),
                A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement: diag(1105, 1 /* Error */ , "A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement_1105", "A 'break' statement can only be used within an enclosing iteration or switch statement."),
                The_left_hand_side_of_a_for_of_statement_may_not_be_async: diag(1106, 1 /* Error */ , "The_left_hand_side_of_a_for_of_statement_may_not_be_async_1106", "The left-hand side of a 'for...of' statement may not be 'async'."),
                Jump_target_cannot_cross_function_boundary: diag(1107, 1 /* Error */ , "Jump_target_cannot_cross_function_boundary_1107", "Jump target cannot cross function boundary."),
                A_return_statement_can_only_be_used_within_a_function_body: diag(1108, 1 /* Error */ , "A_return_statement_can_only_be_used_within_a_function_body_1108", "A 'return' statement can only be used within a function body."),
                Expression_expected: diag(1109, 1 /* Error */ , "Expression_expected_1109", "Expression expected."),
                Type_expected: diag(1110, 1 /* Error */ , "Type_expected_1110", "Type expected."),
                A_default_clause_cannot_appear_more_than_once_in_a_switch_statement: diag(1113, 1 /* Error */ , "A_default_clause_cannot_appear_more_than_once_in_a_switch_statement_1113", "A 'default' clause cannot appear more than once in a 'switch' statement."),
                Duplicate_label_0: diag(1114, 1 /* Error */ , "Duplicate_label_0_1114", "Duplicate label '{0}'."),
                A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement: diag(1115, 1 /* Error */ , "A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement_1115", "A 'continue' statement can only jump to a label of an enclosing iteration statement."),
                A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement: diag(1116, 1 /* Error */ , "A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement_1116", "A 'break' statement can only jump to a label of an enclosing statement."),
                An_object_literal_cannot_have_multiple_properties_with_the_same_name: diag(1117, 1 /* Error */ , "An_object_literal_cannot_have_multiple_properties_with_the_same_name_1117", "An object literal cannot have multiple properties with the same name."),
                An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name: diag(1118, 1 /* Error */ , "An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name_1118", "An object literal cannot have multiple get/set accessors with the same name."),
                An_object_literal_cannot_have_property_and_accessor_with_the_same_name: diag(1119, 1 /* Error */ , "An_object_literal_cannot_have_property_and_accessor_with_the_same_name_1119", "An object literal cannot have property and accessor with the same name."),
                An_export_assignment_cannot_have_modifiers: diag(1120, 1 /* Error */ , "An_export_assignment_cannot_have_modifiers_1120", "An export assignment cannot have modifiers."),
                Octal_literals_are_not_allowed_Use_the_syntax_0: diag(1121, 1 /* Error */ , "Octal_literals_are_not_allowed_Use_the_syntax_0_1121", "Octal literals are not allowed. Use the syntax '{0}'."),
                Variable_declaration_list_cannot_be_empty: diag(1123, 1 /* Error */ , "Variable_declaration_list_cannot_be_empty_1123", "Variable declaration list cannot be empty."),
                Digit_expected: diag(1124, 1 /* Error */ , "Digit_expected_1124", "Digit expected."),
                Hexadecimal_digit_expected: diag(1125, 1 /* Error */ , "Hexadecimal_digit_expected_1125", "Hexadecimal digit expected."),
                Unexpected_end_of_text: diag(1126, 1 /* Error */ , "Unexpected_end_of_text_1126", "Unexpected end of text."),
                Invalid_character: diag(1127, 1 /* Error */ , "Invalid_character_1127", "Invalid character."),
                Declaration_or_statement_expected: diag(1128, 1 /* Error */ , "Declaration_or_statement_expected_1128", "Declaration or statement expected."),
                Statement_expected: diag(1129, 1 /* Error */ , "Statement_expected_1129", "Statement expected."),
                case_or_default_expected: diag(1130, 1 /* Error */ , "case_or_default_expected_1130", "'case' or 'default' expected."),
                Property_or_signature_expected: diag(1131, 1 /* Error */ , "Property_or_signature_expected_1131", "Property or signature expected."),
                Enum_member_expected: diag(1132, 1 /* Error */ , "Enum_member_expected_1132", "Enum member expected."),
                Variable_declaration_expected: diag(1134, 1 /* Error */ , "Variable_declaration_expected_1134", "Variable declaration expected."),
                Argument_expression_expected: diag(1135, 1 /* Error */ , "Argument_expression_expected_1135", "Argument expression expected."),
                Property_assignment_expected: diag(1136, 1 /* Error */ , "Property_assignment_expected_1136", "Property assignment expected."),
                Expression_or_comma_expected: diag(1137, 1 /* Error */ , "Expression_or_comma_expected_1137", "Expression or comma expected."),
                Parameter_declaration_expected: diag(1138, 1 /* Error */ , "Parameter_declaration_expected_1138", "Parameter declaration expected."),
                Type_parameter_declaration_expected: diag(1139, 1 /* Error */ , "Type_parameter_declaration_expected_1139", "Type parameter declaration expected."),
                Type_argument_expected: diag(1140, 1 /* Error */ , "Type_argument_expected_1140", "Type argument expected."),
                String_literal_expected: diag(1141, 1 /* Error */ , "String_literal_expected_1141", "String literal expected."),
                Line_break_not_permitted_here: diag(1142, 1 /* Error */ , "Line_break_not_permitted_here_1142", "Line break not permitted here."),
                or_expected: diag(1144, 1 /* Error */ , "or_expected_1144", "'{' or ';' expected."),
                or_JSX_element_expected: diag(1145, 1 /* Error */ , "or_JSX_element_expected_1145", "'{' or JSX element expected."),
                Declaration_expected: diag(1146, 1 /* Error */ , "Declaration_expected_1146", "Declaration expected."),
                Import_declarations_in_a_namespace_cannot_reference_a_module: diag(1147, 1 /* Error */ , "Import_declarations_in_a_namespace_cannot_reference_a_module_1147", "Import declarations in a namespace cannot reference a module."),
                Cannot_use_imports_exports_or_module_augmentations_when_module_is_none: diag(1148, 1 /* Error */ , "Cannot_use_imports_exports_or_module_augmentations_when_module_is_none_1148", "Cannot use imports, exports, or module augmentations when '--module' is 'none'."),
                File_name_0_differs_from_already_included_file_name_1_only_in_casing: diag(1149, 1 /* Error */ , "File_name_0_differs_from_already_included_file_name_1_only_in_casing_1149", "File name '{0}' differs from already included file name '{1}' only in casing."),
                const_declarations_must_be_initialized: diag(1155, 1 /* Error */ , "const_declarations_must_be_initialized_1155", "'const' declarations must be initialized."),
                const_declarations_can_only_be_declared_inside_a_block: diag(1156, 1 /* Error */ , "const_declarations_can_only_be_declared_inside_a_block_1156", "'const' declarations can only be declared inside a block."),
                let_declarations_can_only_be_declared_inside_a_block: diag(1157, 1 /* Error */ , "let_declarations_can_only_be_declared_inside_a_block_1157", "'let' declarations can only be declared inside a block."),
                Unterminated_template_literal: diag(1160, 1 /* Error */ , "Unterminated_template_literal_1160", "Unterminated template literal."),
                Unterminated_regular_expression_literal: diag(1161, 1 /* Error */ , "Unterminated_regular_expression_literal_1161", "Unterminated regular expression literal."),
                An_object_member_cannot_be_declared_optional: diag(1162, 1 /* Error */ , "An_object_member_cannot_be_declared_optional_1162", "An object member cannot be declared optional."),
                A_yield_expression_is_only_allowed_in_a_generator_body: diag(1163, 1 /* Error */ , "A_yield_expression_is_only_allowed_in_a_generator_body_1163", "A 'yield' expression is only allowed in a generator body."),
                Computed_property_names_are_not_allowed_in_enums: diag(1164, 1 /* Error */ , "Computed_property_names_are_not_allowed_in_enums_1164", "Computed property names are not allowed in enums."),
                A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1165, 1 /* Error */ , "A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_t_1165", "A computed property name in an ambient context must refer to an expression whose type is a literal type or a 'unique symbol' type."),
                A_computed_property_name_in_a_class_property_declaration_must_have_a_simple_literal_type_or_a_unique_symbol_type: diag(1166, 1 /* Error */ , "A_computed_property_name_in_a_class_property_declaration_must_have_a_simple_literal_type_or_a_unique_1166", "A computed property name in a class property declaration must have a simple literal type or a 'unique symbol' type."),
                A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1168, 1 /* Error */ , "A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_ty_1168", "A computed property name in a method overload must refer to an expression whose type is a literal type or a 'unique symbol' type."),
                A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1169, 1 /* Error */ , "A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_1169", "A computed property name in an interface must refer to an expression whose type is a literal type or a 'unique symbol' type."),
                A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1170, 1 /* Error */ , "A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type__1170", "A computed property name in a type literal must refer to an expression whose type is a literal type or a 'unique symbol' type."),
                A_comma_expression_is_not_allowed_in_a_computed_property_name: diag(1171, 1 /* Error */ , "A_comma_expression_is_not_allowed_in_a_computed_property_name_1171", "A comma expression is not allowed in a computed property name."),
                extends_clause_already_seen: diag(1172, 1 /* Error */ , "extends_clause_already_seen_1172", "'extends' clause already seen."),
                extends_clause_must_precede_implements_clause: diag(1173, 1 /* Error */ , "extends_clause_must_precede_implements_clause_1173", "'extends' clause must precede 'implements' clause."),
                Classes_can_only_extend_a_single_class: diag(1174, 1 /* Error */ , "Classes_can_only_extend_a_single_class_1174", "Classes can only extend a single class."),
                implements_clause_already_seen: diag(1175, 1 /* Error */ , "implements_clause_already_seen_1175", "'implements' clause already seen."),
                Interface_declaration_cannot_have_implements_clause: diag(1176, 1 /* Error */ , "Interface_declaration_cannot_have_implements_clause_1176", "Interface declaration cannot have 'implements' clause."),
                Binary_digit_expected: diag(1177, 1 /* Error */ , "Binary_digit_expected_1177", "Binary digit expected."),
                Octal_digit_expected: diag(1178, 1 /* Error */ , "Octal_digit_expected_1178", "Octal digit expected."),
                Unexpected_token_expected: diag(1179, 1 /* Error */ , "Unexpected_token_expected_1179", "Unexpected token. '{' expected."),
                Property_destructuring_pattern_expected: diag(1180, 1 /* Error */ , "Property_destructuring_pattern_expected_1180", "Property destructuring pattern expected."),
                Array_element_destructuring_pattern_expected: diag(1181, 1 /* Error */ , "Array_element_destructuring_pattern_expected_1181", "Array element destructuring pattern expected."),
                A_destructuring_declaration_must_have_an_initializer: diag(1182, 1 /* Error */ , "A_destructuring_declaration_must_have_an_initializer_1182", "A destructuring declaration must have an initializer."),
                An_implementation_cannot_be_declared_in_ambient_contexts: diag(1183, 1 /* Error */ , "An_implementation_cannot_be_declared_in_ambient_contexts_1183", "An implementation cannot be declared in ambient contexts."),
                Modifiers_cannot_appear_here: diag(1184, 1 /* Error */ , "Modifiers_cannot_appear_here_1184", "Modifiers cannot appear here."),
                Merge_conflict_marker_encountered: diag(1185, 1 /* Error */ , "Merge_conflict_marker_encountered_1185", "Merge conflict marker encountered."),
                A_rest_element_cannot_have_an_initializer: diag(1186, 1 /* Error */ , "A_rest_element_cannot_have_an_initializer_1186", "A rest element cannot have an initializer."),
                A_parameter_property_may_not_be_declared_using_a_binding_pattern: diag(1187, 1 /* Error */ , "A_parameter_property_may_not_be_declared_using_a_binding_pattern_1187", "A parameter property may not be declared using a binding pattern."),
                Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement: diag(1188, 1 /* Error */ , "Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement_1188", "Only a single variable declaration is allowed in a 'for...of' statement."),
                The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer: diag(1189, 1 /* Error */ , "The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer_1189", "The variable declaration of a 'for...in' statement cannot have an initializer."),
                The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer: diag(1190, 1 /* Error */ , "The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer_1190", "The variable declaration of a 'for...of' statement cannot have an initializer."),
                An_import_declaration_cannot_have_modifiers: diag(1191, 1 /* Error */ , "An_import_declaration_cannot_have_modifiers_1191", "An import declaration cannot have modifiers."),
                Module_0_has_no_default_export: diag(1192, 1 /* Error */ , "Module_0_has_no_default_export_1192", "Module '{0}' has no default export."),
                An_export_declaration_cannot_have_modifiers: diag(1193, 1 /* Error */ , "An_export_declaration_cannot_have_modifiers_1193", "An export declaration cannot have modifiers."),
                Export_declarations_are_not_permitted_in_a_namespace: diag(1194, 1 /* Error */ , "Export_declarations_are_not_permitted_in_a_namespace_1194", "Export declarations are not permitted in a namespace."),
                export_Asterisk_does_not_re_export_a_default: diag(1195, 1 /* Error */ , "export_Asterisk_does_not_re_export_a_default_1195", "'export *' does not re-export a default."),
                Catch_clause_variable_type_annotation_must_be_any_or_unknown_if_specified: diag(1196, 1 /* Error */ , "Catch_clause_variable_type_annotation_must_be_any_or_unknown_if_specified_1196", "Catch clause variable type annotation must be 'any' or 'unknown' if specified."),
                Catch_clause_variable_cannot_have_an_initializer: diag(1197, 1 /* Error */ , "Catch_clause_variable_cannot_have_an_initializer_1197", "Catch clause variable cannot have an initializer."),
                An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive: diag(1198, 1 /* Error */ , "An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive_1198", "An extended Unicode escape value must be between 0x0 and 0x10FFFF inclusive."),
                Unterminated_Unicode_escape_sequence: diag(1199, 1 /* Error */ , "Unterminated_Unicode_escape_sequence_1199", "Unterminated Unicode escape sequence."),
                Line_terminator_not_permitted_before_arrow: diag(1200, 1 /* Error */ , "Line_terminator_not_permitted_before_arrow_1200", "Line terminator not permitted before arrow."),
                Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_ns_from_mod_import_a_from_mod_import_d_from_mod_or_another_module_format_instead: diag(1202, 1 /* Error */ , "Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_1202", `Import assignment cannot be used when targeting ECMAScript modules. Consider using 'import * as ns from "mod"', 'import {a} from "mod"', 'import d from "mod"', or another module format instead.`),
                Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or_another_module_format_instead: diag(1203, 1 /* Error */ , "Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or__1203", "Export assignment cannot be used when targeting ECMAScript modules. Consider using 'export default' or another module format instead."),
                Re_exporting_a_type_when_0_is_enabled_requires_using_export_type: diag(1205, 1 /* Error */ , "Re_exporting_a_type_when_0_is_enabled_requires_using_export_type_1205", "Re-exporting a type when '{0}' is enabled requires using 'export type'."),
                Decorators_are_not_valid_here: diag(1206, 1 /* Error */ , "Decorators_are_not_valid_here_1206", "Decorators are not valid here."),
                Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name: diag(1207, 1 /* Error */ , "Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name_1207", "Decorators cannot be applied to multiple get/set accessors of the same name."),
                Invalid_optional_chain_from_new_expression_Did_you_mean_to_call_0: diag(1209, 1 /* Error */ , "Invalid_optional_chain_from_new_expression_Did_you_mean_to_call_0_1209", "Invalid optional chain from new expression. Did you mean to call '{0}()'?"),
                Code_contained_in_a_class_is_evaluated_in_JavaScript_s_strict_mode_which_does_not_allow_this_use_of_0_For_more_information_see_https_Colon_Slash_Slashdeveloper_mozilla_org_Slashen_US_Slashdocs_SlashWeb_SlashJavaScript_SlashReference_SlashStrict_mode: diag(1210, 1 /* Error */ , "Code_contained_in_a_class_is_evaluated_in_JavaScript_s_strict_mode_which_does_not_allow_this_use_of__1210", "Code contained in a class is evaluated in JavaScript's strict mode which does not allow this use of '{0}'. For more information, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Strict_mode."),
                A_class_declaration_without_the_default_modifier_must_have_a_name: diag(1211, 1 /* Error */ , "A_class_declaration_without_the_default_modifier_must_have_a_name_1211", "A class declaration without the 'default' modifier must have a name."),
                Identifier_expected_0_is_a_reserved_word_in_strict_mode: diag(1212, 1 /* Error */ , "Identifier_expected_0_is_a_reserved_word_in_strict_mode_1212", "Identifier expected. '{0}' is a reserved word in strict mode."),
                Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_strict_mode: diag(1213, 1 /* Error */ , "Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_stric_1213", "Identifier expected. '{0}' is a reserved word in strict mode. Class definitions are automatically in strict mode."),
                Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode: diag(1214, 1 /* Error */ , "Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode_1214", "Identifier expected. '{0}' is a reserved word in strict mode. Modules are automatically in strict mode."),
                Invalid_use_of_0_Modules_are_automatically_in_strict_mode: diag(1215, 1 /* Error */ , "Invalid_use_of_0_Modules_are_automatically_in_strict_mode_1215", "Invalid use of '{0}'. Modules are automatically in strict mode."),
                Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules: diag(1216, 1 /* Error */ , "Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules_1216", "Identifier expected. '__esModule' is reserved as an exported marker when transforming ECMAScript modules."),
                Export_assignment_is_not_supported_when_module_flag_is_system: diag(1218, 1 /* Error */ , "Export_assignment_is_not_supported_when_module_flag_is_system_1218", "Export assignment is not supported when '--module' flag is 'system'."),
                Generators_are_not_allowed_in_an_ambient_context: diag(1221, 1 /* Error */ , "Generators_are_not_allowed_in_an_ambient_context_1221", "Generators are not allowed in an ambient context."),
                An_overload_signature_cannot_be_declared_as_a_generator: diag(1222, 1 /* Error */ , "An_overload_signature_cannot_be_declared_as_a_generator_1222", "An overload signature cannot be declared as a generator."),
                _0_tag_already_specified: diag(1223, 1 /* Error */ , "_0_tag_already_specified_1223", "'{0}' tag already specified."),
                Signature_0_must_be_a_type_predicate: diag(1224, 1 /* Error */ , "Signature_0_must_be_a_type_predicate_1224", "Signature '{0}' must be a type predicate."),
                Cannot_find_parameter_0: diag(1225, 1 /* Error */ , "Cannot_find_parameter_0_1225", "Cannot find parameter '{0}'."),
                Type_predicate_0_is_not_assignable_to_1: diag(1226, 1 /* Error */ , "Type_predicate_0_is_not_assignable_to_1_1226", "Type predicate '{0}' is not assignable to '{1}'."),
                Parameter_0_is_not_in_the_same_position_as_parameter_1: diag(1227, 1 /* Error */ , "Parameter_0_is_not_in_the_same_position_as_parameter_1_1227", "Parameter '{0}' is not in the same position as parameter '{1}'."),
                A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods: diag(1228, 1 /* Error */ , "A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods_1228", "A type predicate is only allowed in return type position for functions and methods."),
                A_type_predicate_cannot_reference_a_rest_parameter: diag(1229, 1 /* Error */ , "A_type_predicate_cannot_reference_a_rest_parameter_1229", "A type predicate cannot reference a rest parameter."),
                A_type_predicate_cannot_reference_element_0_in_a_binding_pattern: diag(1230, 1 /* Error */ , "A_type_predicate_cannot_reference_element_0_in_a_binding_pattern_1230", "A type predicate cannot reference element '{0}' in a binding pattern."),
                An_export_assignment_must_be_at_the_top_level_of_a_file_or_module_declaration: diag(1231, 1 /* Error */ , "An_export_assignment_must_be_at_the_top_level_of_a_file_or_module_declaration_1231", "An export assignment must be at the top level of a file or module declaration."),
                An_import_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module: diag(1232, 1 /* Error */ , "An_import_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module_1232", "An import declaration can only be used at the top level of a namespace or module."),
                An_export_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module: diag(1233, 1 /* Error */ , "An_export_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module_1233", "An export declaration can only be used at the top level of a namespace or module."),
                An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file: diag(1234, 1 /* Error */ , "An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file_1234", "An ambient module declaration is only allowed at the top level in a file."),
                A_namespace_declaration_is_only_allowed_at_the_top_level_of_a_namespace_or_module: diag(1235, 1 /* Error */ , "A_namespace_declaration_is_only_allowed_at_the_top_level_of_a_namespace_or_module_1235", "A namespace declaration is only allowed at the top level of a namespace or module."),
                The_return_type_of_a_property_decorator_function_must_be_either_void_or_any: diag(1236, 1 /* Error */ , "The_return_type_of_a_property_decorator_function_must_be_either_void_or_any_1236", "The return type of a property decorator function must be either 'void' or 'any'."),
                The_return_type_of_a_parameter_decorator_function_must_be_either_void_or_any: diag(1237, 1 /* Error */ , "The_return_type_of_a_parameter_decorator_function_must_be_either_void_or_any_1237", "The return type of a parameter decorator function must be either 'void' or 'any'."),
                Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression: diag(1238, 1 /* Error */ , "Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression_1238", "Unable to resolve signature of class decorator when called as an expression."),
                Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression: diag(1239, 1 /* Error */ , "Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression_1239", "Unable to resolve signature of parameter decorator when called as an expression."),
                Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression: diag(1240, 1 /* Error */ , "Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression_1240", "Unable to resolve signature of property decorator when called as an expression."),
                Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression: diag(1241, 1 /* Error */ , "Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression_1241", "Unable to resolve signature of method decorator when called as an expression."),
                abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration: diag(1242, 1 /* Error */ , "abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration_1242", "'abstract' modifier can only appear on a class, method, or property declaration."),
                _0_modifier_cannot_be_used_with_1_modifier: diag(1243, 1 /* Error */ , "_0_modifier_cannot_be_used_with_1_modifier_1243", "'{0}' modifier cannot be used with '{1}' modifier."),
                Abstract_methods_can_only_appear_within_an_abstract_class: diag(1244, 1 /* Error */ , "Abstract_methods_can_only_appear_within_an_abstract_class_1244", "Abstract methods can only appear within an abstract class."),
                Method_0_cannot_have_an_implementation_because_it_is_marked_abstract: diag(1245, 1 /* Error */ , "Method_0_cannot_have_an_implementation_because_it_is_marked_abstract_1245", "Method '{0}' cannot have an implementation because it is marked abstract."),
                An_interface_property_cannot_have_an_initializer: diag(1246, 1 /* Error */ , "An_interface_property_cannot_have_an_initializer_1246", "An interface property cannot have an initializer."),
                A_type_literal_property_cannot_have_an_initializer: diag(1247, 1 /* Error */ , "A_type_literal_property_cannot_have_an_initializer_1247", "A type literal property cannot have an initializer."),
                A_class_member_cannot_have_the_0_keyword: diag(1248, 1 /* Error */ , "A_class_member_cannot_have_the_0_keyword_1248", "A class member cannot have the '{0}' keyword."),
                A_decorator_can_only_decorate_a_method_implementation_not_an_overload: diag(1249, 1 /* Error */ , "A_decorator_can_only_decorate_a_method_implementation_not_an_overload_1249", "A decorator can only decorate a method implementation, not an overload."),
                Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5: diag(1250, 1 /* Error */ , "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_1250", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES3' or 'ES5'."),
                Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Class_definitions_are_automatically_in_strict_mode: diag(1251, 1 /* Error */ , "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Class_d_1251", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES3' or 'ES5'. Class definitions are automatically in strict mode."),
                Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Modules_are_automatically_in_strict_mode: diag(1252, 1 /* Error */ , "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Modules_1252", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES3' or 'ES5'. Modules are automatically in strict mode."),
                Abstract_properties_can_only_appear_within_an_abstract_class: diag(1253, 1 /* Error */ , "Abstract_properties_can_only_appear_within_an_abstract_class_1253", "Abstract properties can only appear within an abstract class."),
                A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal_or_literal_enum_reference: diag(1254, 1 /* Error */ , "A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal_or_literal_enum_refere_1254", "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference."),
                A_definite_assignment_assertion_is_not_permitted_in_this_context: diag(1255, 1 /* Error */ , "A_definite_assignment_assertion_is_not_permitted_in_this_context_1255", "A definite assignment assertion '!' is not permitted in this context."),
                A_required_element_cannot_follow_an_optional_element: diag(1257, 1 /* Error */ , "A_required_element_cannot_follow_an_optional_element_1257", "A required element cannot follow an optional element."),
                A_default_export_must_be_at_the_top_level_of_a_file_or_module_declaration: diag(1258, 1 /* Error */ , "A_default_export_must_be_at_the_top_level_of_a_file_or_module_declaration_1258", "A default export must be at the top level of a file or module declaration."),
                Module_0_can_only_be_default_imported_using_the_1_flag: diag(1259, 1 /* Error */ , "Module_0_can_only_be_default_imported_using_the_1_flag_1259", "Module '{0}' can only be default-imported using the '{1}' flag"),
                Keywords_cannot_contain_escape_characters: diag(1260, 1 /* Error */ , "Keywords_cannot_contain_escape_characters_1260", "Keywords cannot contain escape characters."),
                Already_included_file_name_0_differs_from_file_name_1_only_in_casing: diag(1261, 1 /* Error */ , "Already_included_file_name_0_differs_from_file_name_1_only_in_casing_1261", "Already included file name '{0}' differs from file name '{1}' only in casing."),
                Identifier_expected_0_is_a_reserved_word_at_the_top_level_of_a_module: diag(1262, 1 /* Error */ , "Identifier_expected_0_is_a_reserved_word_at_the_top_level_of_a_module_1262", "Identifier expected. '{0}' is a reserved word at the top-level of a module."),
                Declarations_with_initializers_cannot_also_have_definite_assignment_assertions: diag(1263, 1 /* Error */ , "Declarations_with_initializers_cannot_also_have_definite_assignment_assertions_1263", "Declarations with initializers cannot also have definite assignment assertions."),
                Declarations_with_definite_assignment_assertions_must_also_have_type_annotations: diag(1264, 1 /* Error */ , "Declarations_with_definite_assignment_assertions_must_also_have_type_annotations_1264", "Declarations with definite assignment assertions must also have type annotations."),
                A_rest_element_cannot_follow_another_rest_element: diag(1265, 1 /* Error */ , "A_rest_element_cannot_follow_another_rest_element_1265", "A rest element cannot follow another rest element."),
                An_optional_element_cannot_follow_a_rest_element: diag(1266, 1 /* Error */ , "An_optional_element_cannot_follow_a_rest_element_1266", "An optional element cannot follow a rest element."),
                Property_0_cannot_have_an_initializer_because_it_is_marked_abstract: diag(1267, 1 /* Error */ , "Property_0_cannot_have_an_initializer_because_it_is_marked_abstract_1267", "Property '{0}' cannot have an initializer because it is marked abstract."),
                An_index_signature_parameter_type_must_be_string_number_symbol_or_a_template_literal_type: diag(1268, 1 /* Error */ , "An_index_signature_parameter_type_must_be_string_number_symbol_or_a_template_literal_type_1268", "An index signature parameter type must be 'string', 'number', 'symbol', or a template literal type."),
                Cannot_use_export_import_on_a_type_or_type_only_namespace_when_0_is_enabled: diag(1269, 1 /* Error */ , "Cannot_use_export_import_on_a_type_or_type_only_namespace_when_0_is_enabled_1269", "Cannot use 'export import' on a type or type-only namespace when '{0}' is enabled."),
                Decorator_function_return_type_0_is_not_assignable_to_type_1: diag(1270, 1 /* Error */ , "Decorator_function_return_type_0_is_not_assignable_to_type_1_1270", "Decorator function return type '{0}' is not assignable to type '{1}'."),
                Decorator_function_return_type_is_0_but_is_expected_to_be_void_or_any: diag(1271, 1 /* Error */ , "Decorator_function_return_type_is_0_but_is_expected_to_be_void_or_any_1271", "Decorator function return type is '{0}' but is expected to be 'void' or 'any'."),
                A_type_referenced_in_a_decorated_signature_must_be_imported_with_import_type_or_a_namespace_import_when_isolatedModules_and_emitDecoratorMetadata_are_enabled: diag(1272, 1 /* Error */ , "A_type_referenced_in_a_decorated_signature_must_be_imported_with_import_type_or_a_namespace_import_w_1272", "A type referenced in a decorated signature must be imported with 'import type' or a namespace import when 'isolatedModules' and 'emitDecoratorMetadata' are enabled."),
                _0_modifier_cannot_appear_on_a_type_parameter: diag(1273, 1 /* Error */ , "_0_modifier_cannot_appear_on_a_type_parameter_1273", "'{0}' modifier cannot appear on a type parameter"),
                _0_modifier_can_only_appear_on_a_type_parameter_of_a_class_interface_or_type_alias: diag(1274, 1 /* Error */ , "_0_modifier_can_only_appear_on_a_type_parameter_of_a_class_interface_or_type_alias_1274", "'{0}' modifier can only appear on a type parameter of a class, interface or type alias"),
                accessor_modifier_can_only_appear_on_a_property_declaration: diag(1275, 1 /* Error */ , "accessor_modifier_can_only_appear_on_a_property_declaration_1275", "'accessor' modifier can only appear on a property declaration."),
                An_accessor_property_cannot_be_declared_optional: diag(1276, 1 /* Error */ , "An_accessor_property_cannot_be_declared_optional_1276", "An 'accessor' property cannot be declared optional."),
                _0_modifier_can_only_appear_on_a_type_parameter_of_a_function_method_or_class: diag(1277, 1 /* Error */ , "_0_modifier_can_only_appear_on_a_type_parameter_of_a_function_method_or_class_1277", "'{0}' modifier can only appear on a type parameter of a function, method or class"),
                The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_0: diag(1278, 1 /* Error */ , "The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_0_1278", "The runtime will invoke the decorator with {1} arguments, but the decorator expects {0}."),
                The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_at_least_0: diag(1279, 1 /* Error */ , "The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_at_least_0_1279", "The runtime will invoke the decorator with {1} arguments, but the decorator expects at least {0}."),
                Namespaces_are_not_allowed_in_global_script_files_when_0_is_enabled_If_this_file_is_not_intended_to_be_a_global_script_set_moduleDetection_to_force_or_add_an_empty_export_statement: diag(1280, 1 /* Error */ , "Namespaces_are_not_allowed_in_global_script_files_when_0_is_enabled_If_this_file_is_not_intended_to__1280", "Namespaces are not allowed in global script files when '{0}' is enabled. If this file is not intended to be a global script, set 'moduleDetection' to 'force' or add an empty 'export {}' statement."),
                Cannot_access_0_from_another_file_without_qualification_when_1_is_enabled_Use_2_instead: diag(1281, 1 /* Error */ , "Cannot_access_0_from_another_file_without_qualification_when_1_is_enabled_Use_2_instead_1281", "Cannot access '{0}' from another file without qualification when '{1}' is enabled. Use '{2}' instead."),
                An_export_declaration_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers_to_a_type: diag(1282, 1 /* Error */ , "An_export_declaration_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers__1282", "An 'export =' declaration must reference a value when 'verbatimModuleSyntax' is enabled, but '{0}' only refers to a type."),
                An_export_declaration_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolves_to_a_type_only_declaration: diag(1283, 1 /* Error */ , "An_export_declaration_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolve_1283", "An 'export =' declaration must reference a real value when 'verbatimModuleSyntax' is enabled, but '{0}' resolves to a type-only declaration."),
                An_export_default_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers_to_a_type: diag(1284, 1 /* Error */ , "An_export_default_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers_to_a_1284", "An 'export default' must reference a value when 'verbatimModuleSyntax' is enabled, but '{0}' only refers to a type."),
                An_export_default_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolves_to_a_type_only_declaration: diag(1285, 1 /* Error */ , "An_export_default_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolves_to_1285", "An 'export default' must reference a real value when 'verbatimModuleSyntax' is enabled, but '{0}' resolves to a type-only declaration."),
                ESM_syntax_is_not_allowed_in_a_CommonJS_module_when_verbatimModuleSyntax_is_enabled: diag(1286, 1 /* Error */ , "ESM_syntax_is_not_allowed_in_a_CommonJS_module_when_verbatimModuleSyntax_is_enabled_1286", "ESM syntax is not allowed in a CommonJS module when 'verbatimModuleSyntax' is enabled."),
                A_top_level_export_modifier_cannot_be_used_on_value_declarations_in_a_CommonJS_module_when_verbatimModuleSyntax_is_enabled: diag(1287, 1 /* Error */ , "A_top_level_export_modifier_cannot_be_used_on_value_declarations_in_a_CommonJS_module_when_verbatimM_1287", "A top-level 'export' modifier cannot be used on value declarations in a CommonJS module when 'verbatimModuleSyntax' is enabled."),
                An_import_alias_cannot_resolve_to_a_type_or_type_only_declaration_when_verbatimModuleSyntax_is_enabled: diag(1288, 1 /* Error */ , "An_import_alias_cannot_resolve_to_a_type_or_type_only_declaration_when_verbatimModuleSyntax_is_enabl_1288", "An import alias cannot resolve to a type or type-only declaration when 'verbatimModuleSyntax' is enabled."),
                with_statements_are_not_allowed_in_an_async_function_block: diag(1300, 1 /* Error */ , "with_statements_are_not_allowed_in_an_async_function_block_1300", "'with' statements are not allowed in an async function block."),
                await_expressions_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules: diag(1308, 1 /* Error */ , "await_expressions_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules_1308", "'await' expressions are only allowed within async functions and at the top levels of modules."),
                The_current_file_is_a_CommonJS_module_and_cannot_use_await_at_the_top_level: diag(1309, 1 /* Error */ , "The_current_file_is_a_CommonJS_module_and_cannot_use_await_at_the_top_level_1309", "The current file is a CommonJS module and cannot use 'await' at the top level."),
                Did_you_mean_to_use_a_Colon_An_can_only_follow_a_property_name_when_the_containing_object_literal_is_part_of_a_destructuring_pattern: diag(1312, 1 /* Error */ , "Did_you_mean_to_use_a_Colon_An_can_only_follow_a_property_name_when_the_containing_object_literal_is_1312", "Did you mean to use a ':'? An '=' can only follow a property name when the containing object literal is part of a destructuring pattern."),
                The_body_of_an_if_statement_cannot_be_the_empty_statement: diag(1313, 1 /* Error */ , "The_body_of_an_if_statement_cannot_be_the_empty_statement_1313", "The body of an 'if' statement cannot be the empty statement."),
                Global_module_exports_may_only_appear_in_module_files: diag(1314, 1 /* Error */ , "Global_module_exports_may_only_appear_in_module_files_1314", "Global module exports may only appear in module files."),
                Global_module_exports_may_only_appear_in_declaration_files: diag(1315, 1 /* Error */ , "Global_module_exports_may_only_appear_in_declaration_files_1315", "Global module exports may only appear in declaration files."),
                Global_module_exports_may_only_appear_at_top_level: diag(1316, 1 /* Error */ , "Global_module_exports_may_only_appear_at_top_level_1316", "Global module exports may only appear at top level."),
                A_parameter_property_cannot_be_declared_using_a_rest_parameter: diag(1317, 1 /* Error */ , "A_parameter_property_cannot_be_declared_using_a_rest_parameter_1317", "A parameter property cannot be declared using a rest parameter."),
                An_abstract_accessor_cannot_have_an_implementation: diag(1318, 1 /* Error */ , "An_abstract_accessor_cannot_have_an_implementation_1318", "An abstract accessor cannot have an implementation."),
                A_default_export_can_only_be_used_in_an_ECMAScript_style_module: diag(1319, 1 /* Error */ , "A_default_export_can_only_be_used_in_an_ECMAScript_style_module_1319", "A default export can only be used in an ECMAScript-style module."),
                Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1320, 1 /* Error */ , "Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member_1320", "Type of 'await' operand must either be a valid promise or must not contain a callable 'then' member."),
                Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1321, 1 /* Error */ , "Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_cal_1321", "Type of 'yield' operand in an async generator must either be a valid promise or must not contain a callable 'then' member."),
                Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1322, 1 /* Error */ , "Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_con_1322", "Type of iterated elements of a 'yield*' operand must either be a valid promise or must not contain a callable 'then' member."),
                Dynamic_imports_are_only_supported_when_the_module_flag_is_set_to_es2020_es2022_esnext_commonjs_amd_system_umd_node16_or_nodenext: diag(1323, 1 /* Error */ , "Dynamic_imports_are_only_supported_when_the_module_flag_is_set_to_es2020_es2022_esnext_commonjs_amd__1323", "Dynamic imports are only supported when the '--module' flag is set to 'es2020', 'es2022', 'esnext', 'commonjs', 'amd', 'system', 'umd', 'node16', or 'nodenext'."),
                Dynamic_imports_only_support_a_second_argument_when_the_module_option_is_set_to_esnext_node16_or_nodenext: diag(1324, 1 /* Error */ , "Dynamic_imports_only_support_a_second_argument_when_the_module_option_is_set_to_esnext_node16_or_nod_1324", "Dynamic imports only support a second argument when the '--module' option is set to 'esnext', 'node16', or 'nodenext'."),
                Argument_of_dynamic_import_cannot_be_spread_element: diag(1325, 1 /* Error */ , "Argument_of_dynamic_import_cannot_be_spread_element_1325", "Argument of dynamic import cannot be spread element."),
                This_use_of_import_is_invalid_import_calls_can_be_written_but_they_must_have_parentheses_and_cannot_have_type_arguments: diag(1326, 1 /* Error */ , "This_use_of_import_is_invalid_import_calls_can_be_written_but_they_must_have_parentheses_and_cannot__1326", "This use of 'import' is invalid. 'import()' calls can be written, but they must have parentheses and cannot have type arguments."),
                String_literal_with_double_quotes_expected: diag(1327, 1 /* Error */ , "String_literal_with_double_quotes_expected_1327", "String literal with double quotes expected."),
                Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_literal: diag(1328, 1 /* Error */ , "Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_li_1328", "Property value can only be string literal, numeric literal, 'true', 'false', 'null', object literal or array literal."),
                _0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0: diag(1329, 1 /* Error */ , "_0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write__1329", "'{0}' accepts too few arguments to be used as a decorator here. Did you mean to call it first and write '@{0}()'?"),
                A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly: diag(1330, 1 /* Error */ , "A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly_1330", "A property of an interface or type literal whose type is a 'unique symbol' type must be 'readonly'."),
                A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly: diag(1331, 1 /* Error */ , "A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly_1331", "A property of a class whose type is a 'unique symbol' type must be both 'static' and 'readonly'."),
                A_variable_whose_type_is_a_unique_symbol_type_must_be_const: diag(1332, 1 /* Error */ , "A_variable_whose_type_is_a_unique_symbol_type_must_be_const_1332", "A variable whose type is a 'unique symbol' type must be 'const'."),
                unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name: diag(1333, 1 /* Error */ , "unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name_1333", "'unique symbol' types may not be used on a variable declaration with a binding name."),
                unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement: diag(1334, 1 /* Error */ , "unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement_1334", "'unique symbol' types are only allowed on variables in a variable statement."),
                unique_symbol_types_are_not_allowed_here: diag(1335, 1 /* Error */ , "unique_symbol_types_are_not_allowed_here_1335", "'unique symbol' types are not allowed here."),
                An_index_signature_parameter_type_cannot_be_a_literal_type_or_generic_type_Consider_using_a_mapped_object_type_instead: diag(1337, 1 /* Error */ , "An_index_signature_parameter_type_cannot_be_a_literal_type_or_generic_type_Consider_using_a_mapped_o_1337", "An index signature parameter type cannot be a literal type or generic type. Consider using a mapped object type instead."),
                infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type: diag(1338, 1 /* Error */ , "infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type_1338", "'infer' declarations are only permitted in the 'extends' clause of a conditional type."),
                Module_0_does_not_refer_to_a_value_but_is_used_as_a_value_here: diag(1339, 1 /* Error */ , "Module_0_does_not_refer_to_a_value_but_is_used_as_a_value_here_1339", "Module '{0}' does not refer to a value, but is used as a value here."),
                Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here_Did_you_mean_typeof_import_0: diag(1340, 1 /* Error */ , "Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here_Did_you_mean_typeof_import_0_1340", "Module '{0}' does not refer to a type, but is used as a type here. Did you mean 'typeof import('{0}')'?"),
                Class_constructor_may_not_be_an_accessor: diag(1341, 1 /* Error */ , "Class_constructor_may_not_be_an_accessor_1341", "Class constructor may not be an accessor."),
                The_import_meta_meta_property_is_only_allowed_when_the_module_option_is_es2020_es2022_esnext_system_node16_or_nodenext: diag(1343, 1 /* Error */ , "The_import_meta_meta_property_is_only_allowed_when_the_module_option_is_es2020_es2022_esnext_system__1343", "The 'import.meta' meta-property is only allowed when the '--module' option is 'es2020', 'es2022', 'esnext', 'system', 'node16', or 'nodenext'."),
                A_label_is_not_allowed_here: diag(1344, 1 /* Error */ , "A_label_is_not_allowed_here_1344", "'A label is not allowed here."),
                An_expression_of_type_void_cannot_be_tested_for_truthiness: diag(1345, 1 /* Error */ , "An_expression_of_type_void_cannot_be_tested_for_truthiness_1345", "An expression of type 'void' cannot be tested for truthiness."),
                This_parameter_is_not_allowed_with_use_strict_directive: diag(1346, 1 /* Error */ , "This_parameter_is_not_allowed_with_use_strict_directive_1346", "This parameter is not allowed with 'use strict' directive."),
                use_strict_directive_cannot_be_used_with_non_simple_parameter_list: diag(1347, 1 /* Error */ , "use_strict_directive_cannot_be_used_with_non_simple_parameter_list_1347", "'use strict' directive cannot be used with non-simple parameter list."),
                Non_simple_parameter_declared_here: diag(1348, 1 /* Error */ , "Non_simple_parameter_declared_here_1348", "Non-simple parameter declared here."),
                use_strict_directive_used_here: diag(1349, 1 /* Error */ , "use_strict_directive_used_here_1349", "'use strict' directive used here."),
                Print_the_final_configuration_instead_of_building: diag(1350, 3 /* Message */ , "Print_the_final_configuration_instead_of_building_1350", "Print the final configuration instead of building."),
                An_identifier_or_keyword_cannot_immediately_follow_a_numeric_literal: diag(1351, 1 /* Error */ , "An_identifier_or_keyword_cannot_immediately_follow_a_numeric_literal_1351", "An identifier or keyword cannot immediately follow a numeric literal."),
                A_bigint_literal_cannot_use_exponential_notation: diag(1352, 1 /* Error */ , "A_bigint_literal_cannot_use_exponential_notation_1352", "A bigint literal cannot use exponential notation."),
                A_bigint_literal_must_be_an_integer: diag(1353, 1 /* Error */ , "A_bigint_literal_must_be_an_integer_1353", "A bigint literal must be an integer."),
                readonly_type_modifier_is_only_permitted_on_array_and_tuple_literal_types: diag(1354, 1 /* Error */ , "readonly_type_modifier_is_only_permitted_on_array_and_tuple_literal_types_1354", "'readonly' type modifier is only permitted on array and tuple literal types."),
                A_const_assertions_can_only_be_applied_to_references_to_enum_members_or_string_number_boolean_array_or_object_literals: diag(1355, 1 /* Error */ , "A_const_assertions_can_only_be_applied_to_references_to_enum_members_or_string_number_boolean_array__1355", "A 'const' assertions can only be applied to references to enum members, or string, number, boolean, array, or object literals."),
                Did_you_mean_to_mark_this_function_as_async: diag(1356, 1 /* Error */ , "Did_you_mean_to_mark_this_function_as_async_1356", "Did you mean to mark this function as 'async'?"),
                An_enum_member_name_must_be_followed_by_a_or: diag(1357, 1 /* Error */ , "An_enum_member_name_must_be_followed_by_a_or_1357", "An enum member name must be followed by a ',', '=', or '}'."),
                Tagged_template_expressions_are_not_permitted_in_an_optional_chain: diag(1358, 1 /* Error */ , "Tagged_template_expressions_are_not_permitted_in_an_optional_chain_1358", "Tagged template expressions are not permitted in an optional chain."),
                Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here: diag(1359, 1 /* Error */ , "Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here_1359", "Identifier expected. '{0}' is a reserved word that cannot be used here."),
                Type_0_does_not_satisfy_the_expected_type_1: diag(1360, 1 /* Error */ , "Type_0_does_not_satisfy_the_expected_type_1_1360", "Type '{0}' does not satisfy the expected type '{1}'."),
                _0_cannot_be_used_as_a_value_because_it_was_imported_using_import_type: diag(1361, 1 /* Error */ , "_0_cannot_be_used_as_a_value_because_it_was_imported_using_import_type_1361", "'{0}' cannot be used as a value because it was imported using 'import type'."),
                _0_cannot_be_used_as_a_value_because_it_was_exported_using_export_type: diag(1362, 1 /* Error */ , "_0_cannot_be_used_as_a_value_because_it_was_exported_using_export_type_1362", "'{0}' cannot be used as a value because it was exported using 'export type'."),
                A_type_only_import_can_specify_a_default_import_or_named_bindings_but_not_both: diag(1363, 1 /* Error */ , "A_type_only_import_can_specify_a_default_import_or_named_bindings_but_not_both_1363", "A type-only import can specify a default import or named bindings, but not both."),
                Convert_to_type_only_export: diag(1364, 3 /* Message */ , "Convert_to_type_only_export_1364", "Convert to type-only export"),
                Convert_all_re_exported_types_to_type_only_exports: diag(1365, 3 /* Message */ , "Convert_all_re_exported_types_to_type_only_exports_1365", "Convert all re-exported types to type-only exports"),
                Split_into_two_separate_import_declarations: diag(1366, 3 /* Message */ , "Split_into_two_separate_import_declarations_1366", "Split into two separate import declarations"),
                Split_all_invalid_type_only_imports: diag(1367, 3 /* Message */ , "Split_all_invalid_type_only_imports_1367", "Split all invalid type-only imports"),
                Class_constructor_may_not_be_a_generator: diag(1368, 1 /* Error */ , "Class_constructor_may_not_be_a_generator_1368", "Class constructor may not be a generator."),
                Did_you_mean_0: diag(1369, 3 /* Message */ , "Did_you_mean_0_1369", "Did you mean '{0}'?"),
                This_import_is_never_used_as_a_value_and_must_use_import_type_because_importsNotUsedAsValues_is_set_to_error: diag(1371, 1 /* Error */ , "This_import_is_never_used_as_a_value_and_must_use_import_type_because_importsNotUsedAsValues_is_set__1371", "This import is never used as a value and must use 'import type' because 'importsNotUsedAsValues' is set to 'error'."),
                Convert_to_type_only_import: diag(1373, 3 /* Message */ , "Convert_to_type_only_import_1373", "Convert to type-only import"),
                Convert_all_imports_not_used_as_a_value_to_type_only_imports: diag(1374, 3 /* Message */ , "Convert_all_imports_not_used_as_a_value_to_type_only_imports_1374", "Convert all imports not used as a value to type-only imports"),
                await_expressions_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module: diag(1375, 1 /* Error */ , "await_expressions_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_fi_1375", "'await' expressions are only allowed at the top level of a file when that file is a module, but this file has no imports or exports. Consider adding an empty 'export {}' to make this file a module."),
                _0_was_imported_here: diag(1376, 3 /* Message */ , "_0_was_imported_here_1376", "'{0}' was imported here."),
                _0_was_exported_here: diag(1377, 3 /* Message */ , "_0_was_exported_here_1377", "'{0}' was exported here."),
                Top_level_await_expressions_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_or_nodenext_and_the_target_option_is_set_to_es2017_or_higher: diag(1378, 1 /* Error */ , "Top_level_await_expressions_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_n_1378", "Top-level 'await' expressions are only allowed when the 'module' option is set to 'es2022', 'esnext', 'system', 'node16', or 'nodenext', and the 'target' option is set to 'es2017' or higher."),
                An_import_alias_cannot_reference_a_declaration_that_was_exported_using_export_type: diag(1379, 1 /* Error */ , "An_import_alias_cannot_reference_a_declaration_that_was_exported_using_export_type_1379", "An import alias cannot reference a declaration that was exported using 'export type'."),
                An_import_alias_cannot_reference_a_declaration_that_was_imported_using_import_type: diag(1380, 1 /* Error */ , "An_import_alias_cannot_reference_a_declaration_that_was_imported_using_import_type_1380", "An import alias cannot reference a declaration that was imported using 'import type'."),
                Unexpected_token_Did_you_mean_or_rbrace: diag(1381, 1 /* Error */ , "Unexpected_token_Did_you_mean_or_rbrace_1381", "Unexpected token. Did you mean `{'}'}` or `&rbrace;`?"),
                Unexpected_token_Did_you_mean_or_gt: diag(1382, 1 /* Error */ , "Unexpected_token_Did_you_mean_or_gt_1382", "Unexpected token. Did you mean `{'>'}` or `&gt;`?"),
                Function_type_notation_must_be_parenthesized_when_used_in_a_union_type: diag(1385, 1 /* Error */ , "Function_type_notation_must_be_parenthesized_when_used_in_a_union_type_1385", "Function type notation must be parenthesized when used in a union type."),
                Constructor_type_notation_must_be_parenthesized_when_used_in_a_union_type: diag(1386, 1 /* Error */ , "Constructor_type_notation_must_be_parenthesized_when_used_in_a_union_type_1386", "Constructor type notation must be parenthesized when used in a union type."),
                Function_type_notation_must_be_parenthesized_when_used_in_an_intersection_type: diag(1387, 1 /* Error */ , "Function_type_notation_must_be_parenthesized_when_used_in_an_intersection_type_1387", "Function type notation must be parenthesized when used in an intersection type."),
                Constructor_type_notation_must_be_parenthesized_when_used_in_an_intersection_type: diag(1388, 1 /* Error */ , "Constructor_type_notation_must_be_parenthesized_when_used_in_an_intersection_type_1388", "Constructor type notation must be parenthesized when used in an intersection type."),
                _0_is_not_allowed_as_a_variable_declaration_name: diag(1389, 1 /* Error */ , "_0_is_not_allowed_as_a_variable_declaration_name_1389", "'{0}' is not allowed as a variable declaration name."),
                _0_is_not_allowed_as_a_parameter_name: diag(1390, 1 /* Error */ , "_0_is_not_allowed_as_a_parameter_name_1390", "'{0}' is not allowed as a parameter name."),
                An_import_alias_cannot_use_import_type: diag(1392, 1 /* Error */ , "An_import_alias_cannot_use_import_type_1392", "An import alias cannot use 'import type'"),
                Imported_via_0_from_file_1: diag(1393, 3 /* Message */ , "Imported_via_0_from_file_1_1393", "Imported via {0} from file '{1}'"),
                Imported_via_0_from_file_1_with_packageId_2: diag(1394, 3 /* Message */ , "Imported_via_0_from_file_1_with_packageId_2_1394", "Imported via {0} from file '{1}' with packageId '{2}'"),
                Imported_via_0_from_file_1_to_import_importHelpers_as_specified_in_compilerOptions: diag(1395, 3 /* Message */ , "Imported_via_0_from_file_1_to_import_importHelpers_as_specified_in_compilerOptions_1395", "Imported via {0} from file '{1}' to import 'importHelpers' as specified in compilerOptions"),
                Imported_via_0_from_file_1_with_packageId_2_to_import_importHelpers_as_specified_in_compilerOptions: diag(1396, 3 /* Message */ , "Imported_via_0_from_file_1_with_packageId_2_to_import_importHelpers_as_specified_in_compilerOptions_1396", "Imported via {0} from file '{1}' with packageId '{2}' to import 'importHelpers' as specified in compilerOptions"),
                Imported_via_0_from_file_1_to_import_jsx_and_jsxs_factory_functions: diag(1397, 3 /* Message */ , "Imported_via_0_from_file_1_to_import_jsx_and_jsxs_factory_functions_1397", "Imported via {0} from file '{1}' to import 'jsx' and 'jsxs' factory functions"),
                Imported_via_0_from_file_1_with_packageId_2_to_import_jsx_and_jsxs_factory_functions: diag(1398, 3 /* Message */ , "Imported_via_0_from_file_1_with_packageId_2_to_import_jsx_and_jsxs_factory_functions_1398", "Imported via {0} from file '{1}' with packageId '{2}' to import 'jsx' and 'jsxs' factory functions"),
                File_is_included_via_import_here: diag(1399, 3 /* Message */ , "File_is_included_via_import_here_1399", "File is included via import here."),
                Referenced_via_0_from_file_1: diag(1400, 3 /* Message */ , "Referenced_via_0_from_file_1_1400", "Referenced via '{0}' from file '{1}'"),
                File_is_included_via_reference_here: diag(1401, 3 /* Message */ , "File_is_included_via_reference_here_1401", "File is included via reference here."),
                Type_library_referenced_via_0_from_file_1: diag(1402, 3 /* Message */ , "Type_library_referenced_via_0_from_file_1_1402", "Type library referenced via '{0}' from file '{1}'"),
                Type_library_referenced_via_0_from_file_1_with_packageId_2: diag(1403, 3 /* Message */ , "Type_library_referenced_via_0_from_file_1_with_packageId_2_1403", "Type library referenced via '{0}' from file '{1}' with packageId '{2}'"),
                File_is_included_via_type_library_reference_here: diag(1404, 3 /* Message */ , "File_is_included_via_type_library_reference_here_1404", "File is included via type library reference here."),
                Library_referenced_via_0_from_file_1: diag(1405, 3 /* Message */ , "Library_referenced_via_0_from_file_1_1405", "Library referenced via '{0}' from file '{1}'"),
                File_is_included_via_library_reference_here: diag(1406, 3 /* Message */ , "File_is_included_via_library_reference_here_1406", "File is included via library reference here."),
                Matched_by_include_pattern_0_in_1: diag(1407, 3 /* Message */ , "Matched_by_include_pattern_0_in_1_1407", "Matched by include pattern '{0}' in '{1}'"),
                File_is_matched_by_include_pattern_specified_here: diag(1408, 3 /* Message */ , "File_is_matched_by_include_pattern_specified_here_1408", "File is matched by include pattern specified here."),
                Part_of_files_list_in_tsconfig_json: diag(1409, 3 /* Message */ , "Part_of_files_list_in_tsconfig_json_1409", "Part of 'files' list in tsconfig.json"),
                File_is_matched_by_files_list_specified_here: diag(1410, 3 /* Message */ , "File_is_matched_by_files_list_specified_here_1410", "File is matched by 'files' list specified here."),
                Output_from_referenced_project_0_included_because_1_specified: diag(1411, 3 /* Message */ , "Output_from_referenced_project_0_included_because_1_specified_1411", "Output from referenced project '{0}' included because '{1}' specified"),
                Output_from_referenced_project_0_included_because_module_is_specified_as_none: diag(1412, 3 /* Message */ , "Output_from_referenced_project_0_included_because_module_is_specified_as_none_1412", "Output from referenced project '{0}' included because '--module' is specified as 'none'"),
                File_is_output_from_referenced_project_specified_here: diag(1413, 3 /* Message */ , "File_is_output_from_referenced_project_specified_here_1413", "File is output from referenced project specified here."),
                Source_from_referenced_project_0_included_because_1_specified: diag(1414, 3 /* Message */ , "Source_from_referenced_project_0_included_because_1_specified_1414", "Source from referenced project '{0}' included because '{1}' specified"),
                Source_from_referenced_project_0_included_because_module_is_specified_as_none: diag(1415, 3 /* Message */ , "Source_from_referenced_project_0_included_because_module_is_specified_as_none_1415", "Source from referenced project '{0}' included because '--module' is specified as 'none'"),
                File_is_source_from_referenced_project_specified_here: diag(1416, 3 /* Message */ , "File_is_source_from_referenced_project_specified_here_1416", "File is source from referenced project specified here."),
                Entry_point_of_type_library_0_specified_in_compilerOptions: diag(1417, 3 /* Message */ , "Entry_point_of_type_library_0_specified_in_compilerOptions_1417", "Entry point of type library '{0}' specified in compilerOptions"),
                Entry_point_of_type_library_0_specified_in_compilerOptions_with_packageId_1: diag(1418, 3 /* Message */ , "Entry_point_of_type_library_0_specified_in_compilerOptions_with_packageId_1_1418", "Entry point of type library '{0}' specified in compilerOptions with packageId '{1}'"),
                File_is_entry_point_of_type_library_specified_here: diag(1419, 3 /* Message */ , "File_is_entry_point_of_type_library_specified_here_1419", "File is entry point of type library specified here."),
                Entry_point_for_implicit_type_library_0: diag(1420, 3 /* Message */ , "Entry_point_for_implicit_type_library_0_1420", "Entry point for implicit type library '{0}'"),
                Entry_point_for_implicit_type_library_0_with_packageId_1: diag(1421, 3 /* Message */ , "Entry_point_for_implicit_type_library_0_with_packageId_1_1421", "Entry point for implicit type library '{0}' with packageId '{1}'"),
                Library_0_specified_in_compilerOptions: diag(1422, 3 /* Message */ , "Library_0_specified_in_compilerOptions_1422", "Library '{0}' specified in compilerOptions"),
                File_is_library_specified_here: diag(1423, 3 /* Message */ , "File_is_library_specified_here_1423", "File is library specified here."),
                Default_library: diag(1424, 3 /* Message */ , "Default_library_1424", "Default library"),
                Default_library_for_target_0: diag(1425, 3 /* Message */ , "Default_library_for_target_0_1425", "Default library for target '{0}'"),
                File_is_default_library_for_target_specified_here: diag(1426, 3 /* Message */ , "File_is_default_library_for_target_specified_here_1426", "File is default library for target specified here."),
                Root_file_specified_for_compilation: diag(1427, 3 /* Message */ , "Root_file_specified_for_compilation_1427", "Root file specified for compilation"),
                File_is_output_of_project_reference_source_0: diag(1428, 3 /* Message */ , "File_is_output_of_project_reference_source_0_1428", "File is output of project reference source '{0}'"),
                File_redirects_to_file_0: diag(1429, 3 /* Message */ , "File_redirects_to_file_0_1429", "File redirects to file '{0}'"),
                The_file_is_in_the_program_because_Colon: diag(1430, 3 /* Message */ , "The_file_is_in_the_program_because_Colon_1430", "The file is in the program because:"),
                for_await_loops_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module: diag(1431, 1 /* Error */ , "for_await_loops_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_1431", "'for await' loops are only allowed at the top level of a file when that file is a module, but this file has no imports or exports. Consider adding an empty 'export {}' to make this file a module."),
                Top_level_for_await_loops_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_or_nodenext_and_the_target_option_is_set_to_es2017_or_higher: diag(1432, 1 /* Error */ , "Top_level_for_await_loops_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_nod_1432", "Top-level 'for await' loops are only allowed when the 'module' option is set to 'es2022', 'esnext', 'system', 'node16', or 'nodenext', and the 'target' option is set to 'es2017' or higher."),
                Neither_decorators_nor_modifiers_may_be_applied_to_this_parameters: diag(1433, 1 /* Error */ , "Neither_decorators_nor_modifiers_may_be_applied_to_this_parameters_1433", "Neither decorators nor modifiers may be applied to 'this' parameters."),
                Unexpected_keyword_or_identifier: diag(1434, 1 /* Error */ , "Unexpected_keyword_or_identifier_1434", "Unexpected keyword or identifier."),
                Unknown_keyword_or_identifier_Did_you_mean_0: diag(1435, 1 /* Error */ , "Unknown_keyword_or_identifier_Did_you_mean_0_1435", "Unknown keyword or identifier. Did you mean '{0}'?"),
                Decorators_must_precede_the_name_and_all_keywords_of_property_declarations: diag(1436, 1 /* Error */ , "Decorators_must_precede_the_name_and_all_keywords_of_property_declarations_1436", "Decorators must precede the name and all keywords of property declarations."),
                Namespace_must_be_given_a_name: diag(1437, 1 /* Error */ , "Namespace_must_be_given_a_name_1437", "Namespace must be given a name."),
                Interface_must_be_given_a_name: diag(1438, 1 /* Error */ , "Interface_must_be_given_a_name_1438", "Interface must be given a name."),
                Type_alias_must_be_given_a_name: diag(1439, 1 /* Error */ , "Type_alias_must_be_given_a_name_1439", "Type alias must be given a name."),
                Variable_declaration_not_allowed_at_this_location: diag(1440, 1 /* Error */ , "Variable_declaration_not_allowed_at_this_location_1440", "Variable declaration not allowed at this location."),
                Cannot_start_a_function_call_in_a_type_annotation: diag(1441, 1 /* Error */ , "Cannot_start_a_function_call_in_a_type_annotation_1441", "Cannot start a function call in a type annotation."),
                Expected_for_property_initializer: diag(1442, 1 /* Error */ , "Expected_for_property_initializer_1442", "Expected '=' for property initializer."),
                Module_declaration_names_may_only_use_or_quoted_strings: diag(1443, 1 /* Error */ , "Module_declaration_names_may_only_use_or_quoted_strings_1443", `Module declaration names may only use ' or " quoted strings.`),
                _0_is_a_type_and_must_be_imported_using_a_type_only_import_when_preserveValueImports_and_isolatedModules_are_both_enabled: diag(1444, 1 /* Error */ , "_0_is_a_type_and_must_be_imported_using_a_type_only_import_when_preserveValueImports_and_isolatedMod_1444", "'{0}' is a type and must be imported using a type-only import when 'preserveValueImports' and 'isolatedModules' are both enabled."),
                _0_resolves_to_a_type_only_declaration_and_must_be_imported_using_a_type_only_import_when_preserveValueImports_and_isolatedModules_are_both_enabled: diag(1446, 1 /* Error */ , "_0_resolves_to_a_type_only_declaration_and_must_be_imported_using_a_type_only_import_when_preserveVa_1446", "'{0}' resolves to a type-only declaration and must be imported using a type-only import when 'preserveValueImports' and 'isolatedModules' are both enabled."),
                _0_resolves_to_a_type_only_declaration_and_must_be_re_exported_using_a_type_only_re_export_when_1_is_enabled: diag(1448, 1 /* Error */ , "_0_resolves_to_a_type_only_declaration_and_must_be_re_exported_using_a_type_only_re_export_when_1_is_1448", "'{0}' resolves to a type-only declaration and must be re-exported using a type-only re-export when '{1}' is enabled."),
                Preserve_unused_imported_values_in_the_JavaScript_output_that_would_otherwise_be_removed: diag(1449, 3 /* Message */ , "Preserve_unused_imported_values_in_the_JavaScript_output_that_would_otherwise_be_removed_1449", "Preserve unused imported values in the JavaScript output that would otherwise be removed."),
                Dynamic_imports_can_only_accept_a_module_specifier_and_an_optional_assertion_as_arguments: diag(1450, 3 /* Message */ , "Dynamic_imports_can_only_accept_a_module_specifier_and_an_optional_assertion_as_arguments_1450", "Dynamic imports can only accept a module specifier and an optional assertion as arguments"),
                Private_identifiers_are_only_allowed_in_class_bodies_and_may_only_be_used_as_part_of_a_class_member_declaration_property_access_or_on_the_left_hand_side_of_an_in_expression: diag(1451, 1 /* Error */ , "Private_identifiers_are_only_allowed_in_class_bodies_and_may_only_be_used_as_part_of_a_class_member__1451", "Private identifiers are only allowed in class bodies and may only be used as part of a class member declaration, property access, or on the left-hand-side of an 'in' expression"),
                resolution_mode_assertions_are_only_supported_when_moduleResolution_is_node16_or_nodenext: diag(1452, 1 /* Error */ , "resolution_mode_assertions_are_only_supported_when_moduleResolution_is_node16_or_nodenext_1452", "'resolution-mode' assertions are only supported when `moduleResolution` is `node16` or `nodenext`."),
                resolution_mode_should_be_either_require_or_import: diag(1453, 1 /* Error */ , "resolution_mode_should_be_either_require_or_import_1453", "`resolution-mode` should be either `require` or `import`."),
                resolution_mode_can_only_be_set_for_type_only_imports: diag(1454, 1 /* Error */ , "resolution_mode_can_only_be_set_for_type_only_imports_1454", "`resolution-mode` can only be set for type-only imports."),
                resolution_mode_is_the_only_valid_key_for_type_import_assertions: diag(1455, 1 /* Error */ , "resolution_mode_is_the_only_valid_key_for_type_import_assertions_1455", "`resolution-mode` is the only valid key for type import assertions."),
                Type_import_assertions_should_have_exactly_one_key_resolution_mode_with_value_import_or_require: diag(1456, 1 /* Error */ , "Type_import_assertions_should_have_exactly_one_key_resolution_mode_with_value_import_or_require_1456", "Type import assertions should have exactly one key - `resolution-mode` - with value `import` or `require`."),
                Matched_by_default_include_pattern_Asterisk_Asterisk_Slash_Asterisk: diag(1457, 3 /* Message */ , "Matched_by_default_include_pattern_Asterisk_Asterisk_Slash_Asterisk_1457", "Matched by default include pattern '**/*'"),
                File_is_ECMAScript_module_because_0_has_field_type_with_value_module: diag(1458, 3 /* Message */ , "File_is_ECMAScript_module_because_0_has_field_type_with_value_module_1458", `File is ECMAScript module because '{0}' has field "type" with value "module"`),
                File_is_CommonJS_module_because_0_has_field_type_whose_value_is_not_module: diag(1459, 3 /* Message */ , "File_is_CommonJS_module_because_0_has_field_type_whose_value_is_not_module_1459", `File is CommonJS module because '{0}' has field "type" whose value is not "module"`),
                File_is_CommonJS_module_because_0_does_not_have_field_type: diag(1460, 3 /* Message */ , "File_is_CommonJS_module_because_0_does_not_have_field_type_1460", `File is CommonJS module because '{0}' does not have field "type"`),
                File_is_CommonJS_module_because_package_json_was_not_found: diag(1461, 3 /* Message */ , "File_is_CommonJS_module_because_package_json_was_not_found_1461", "File is CommonJS module because 'package.json' was not found"),
                The_import_meta_meta_property_is_not_allowed_in_files_which_will_build_into_CommonJS_output: diag(1470, 1 /* Error */ , "The_import_meta_meta_property_is_not_allowed_in_files_which_will_build_into_CommonJS_output_1470", "The 'import.meta' meta-property is not allowed in files which will build into CommonJS output."),
                Module_0_cannot_be_imported_using_this_construct_The_specifier_only_resolves_to_an_ES_module_which_cannot_be_imported_with_require_Use_an_ECMAScript_import_instead: diag(1471, 1 /* Error */ , "Module_0_cannot_be_imported_using_this_construct_The_specifier_only_resolves_to_an_ES_module_which_c_1471", "Module '{0}' cannot be imported using this construct. The specifier only resolves to an ES module, which cannot be imported with 'require'. Use an ECMAScript import instead."),
                catch_or_finally_expected: diag(1472, 1 /* Error */ , "catch_or_finally_expected_1472", "'catch' or 'finally' expected."),
                An_import_declaration_can_only_be_used_at_the_top_level_of_a_module: diag(1473, 1 /* Error */ , "An_import_declaration_can_only_be_used_at_the_top_level_of_a_module_1473", "An import declaration can only be used at the top level of a module."),
                An_export_declaration_can_only_be_used_at_the_top_level_of_a_module: diag(1474, 1 /* Error */ , "An_export_declaration_can_only_be_used_at_the_top_level_of_a_module_1474", "An export declaration can only be used at the top level of a module."),
                Control_what_method_is_used_to_detect_module_format_JS_files: diag(1475, 3 /* Message */ , "Control_what_method_is_used_to_detect_module_format_JS_files_1475", "Control what method is used to detect module-format JS files."),
                auto_Colon_Treat_files_with_imports_exports_import_meta_jsx_with_jsx_Colon_react_jsx_or_esm_format_with_module_Colon_node16_as_modules: diag(1476, 3 /* Message */ , "auto_Colon_Treat_files_with_imports_exports_import_meta_jsx_with_jsx_Colon_react_jsx_or_esm_format_w_1476", '"auto": Treat files with imports, exports, import.meta, jsx (with jsx: react-jsx), or esm format (with module: node16+) as modules.'),
                An_instantiation_expression_cannot_be_followed_by_a_property_access: diag(1477, 1 /* Error */ , "An_instantiation_expression_cannot_be_followed_by_a_property_access_1477", "An instantiation expression cannot be followed by a property access."),
                Identifier_or_string_literal_expected: diag(1478, 1 /* Error */ , "Identifier_or_string_literal_expected_1478", "Identifier or string literal expected."),
                The_current_file_is_a_CommonJS_module_whose_imports_will_produce_require_calls_however_the_referenced_file_is_an_ECMAScript_module_and_cannot_be_imported_with_require_Consider_writing_a_dynamic_import_0_call_instead: diag(1479, 1 /* Error */ , "The_current_file_is_a_CommonJS_module_whose_imports_will_produce_require_calls_however_the_reference_1479", `The current file is a CommonJS module whose imports will produce 'require' calls; however, the referenced file is an ECMAScript module and cannot be imported with 'require'. Consider writing a dynamic 'import("{0}")' call instead.`),
                To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_create_a_local_package_json_file_with_type_Colon_module: diag(1480, 3 /* Message */ , "To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_create_a_local_packag_1480", 'To convert this file to an ECMAScript module, change its file extension to \'{0}\' or create a local package.json file with `{ "type": "module" }`.'),
                To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_add_the_field_type_Colon_module_to_1: diag(1481, 3 /* Message */ , "To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_add_the_field_type_Co_1481", `To convert this file to an ECMAScript module, change its file extension to '{0}', or add the field \`"type": "module"\` to '{1}'.`),
                To_convert_this_file_to_an_ECMAScript_module_add_the_field_type_Colon_module_to_0: diag(1482, 3 /* Message */ , "To_convert_this_file_to_an_ECMAScript_module_add_the_field_type_Colon_module_to_0_1482", 'To convert this file to an ECMAScript module, add the field `"type": "module"` to \'{0}\'.'),
                To_convert_this_file_to_an_ECMAScript_module_create_a_local_package_json_file_with_type_Colon_module: diag(1483, 3 /* Message */ , "To_convert_this_file_to_an_ECMAScript_module_create_a_local_package_json_file_with_type_Colon_module_1483", 'To convert this file to an ECMAScript module, create a local package.json file with `{ "type": "module" }`.'),
                _0_is_a_type_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled: diag(1484, 1 /* Error */ , "_0_is_a_type_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled_1484", "'{0}' is a type and must be imported using a type-only import when 'verbatimModuleSyntax' is enabled."),
                _0_resolves_to_a_type_only_declaration_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled: diag(1485, 1 /* Error */ , "_0_resolves_to_a_type_only_declaration_and_must_be_imported_using_a_type_only_import_when_verbatimMo_1485", "'{0}' resolves to a type-only declaration and must be imported using a type-only import when 'verbatimModuleSyntax' is enabled."),
                Decorator_used_before_export_here: diag(1486, 1 /* Error */ , "Decorator_used_before_export_here_1486", "Decorator used before 'export' here."),
                Octal_escape_sequences_are_not_allowed_Use_the_syntax_0: diag(1487, 1 /* Error */ , "Octal_escape_sequences_are_not_allowed_Use_the_syntax_0_1487", "Octal escape sequences are not allowed. Use the syntax '{0}'."),
                Escape_sequence_0_is_not_allowed: diag(1488, 1 /* Error */ , "Escape_sequence_0_is_not_allowed_1488", "Escape sequence '{0}' is not allowed."),
                Decimals_with_leading_zeros_are_not_allowed: diag(1489, 1 /* Error */ , "Decimals_with_leading_zeros_are_not_allowed_1489", "Decimals with leading zeros are not allowed."),
                File_appears_to_be_binary: diag(1490, 1 /* Error */ , "File_appears_to_be_binary_1490", "File appears to be binary."),
                The_types_of_0_are_incompatible_between_these_types: diag(2200, 1 /* Error */ , "The_types_of_0_are_incompatible_between_these_types_2200", "The types of '{0}' are incompatible between these types."),
                The_types_returned_by_0_are_incompatible_between_these_types: diag(2201, 1 /* Error */ , "The_types_returned_by_0_are_incompatible_between_these_types_2201", "The types returned by '{0}' are incompatible between these types."),
                Call_signature_return_types_0_and_1_are_incompatible: diag(2202, 1 /* Error */ , "Call_signature_return_types_0_and_1_are_incompatible_2202", "Call signature return types '{0}' and '{1}' are incompatible.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ true),
                Construct_signature_return_types_0_and_1_are_incompatible: diag(2203, 1 /* Error */ , "Construct_signature_return_types_0_and_1_are_incompatible_2203", "Construct signature return types '{0}' and '{1}' are incompatible.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ true),
                Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1: diag(2204, 1 /* Error */ , "Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1_2204", "Call signatures with no arguments have incompatible return types '{0}' and '{1}'.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ true),
                Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1: diag(2205, 1 /* Error */ , "Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1_2205", "Construct signatures with no arguments have incompatible return types '{0}' and '{1}'.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ true),
                The_type_modifier_cannot_be_used_on_a_named_import_when_import_type_is_used_on_its_import_statement: diag(2206, 1 /* Error */ , "The_type_modifier_cannot_be_used_on_a_named_import_when_import_type_is_used_on_its_import_statement_2206", "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement."),
                The_type_modifier_cannot_be_used_on_a_named_export_when_export_type_is_used_on_its_export_statement: diag(2207, 1 /* Error */ , "The_type_modifier_cannot_be_used_on_a_named_export_when_export_type_is_used_on_its_export_statement_2207", "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement."),
                This_type_parameter_might_need_an_extends_0_constraint: diag(2208, 1 /* Error */ , "This_type_parameter_might_need_an_extends_0_constraint_2208", "This type parameter might need an `extends {0}` constraint."),
                The_project_root_is_ambiguous_but_is_required_to_resolve_export_map_entry_0_in_file_1_Supply_the_rootDir_compiler_option_to_disambiguate: diag(2209, 1 /* Error */ , "The_project_root_is_ambiguous_but_is_required_to_resolve_export_map_entry_0_in_file_1_Supply_the_roo_2209", "The project root is ambiguous, but is required to resolve export map entry '{0}' in file '{1}'. Supply the `rootDir` compiler option to disambiguate."),
                The_project_root_is_ambiguous_but_is_required_to_resolve_import_map_entry_0_in_file_1_Supply_the_rootDir_compiler_option_to_disambiguate: diag(2210, 1 /* Error */ , "The_project_root_is_ambiguous_but_is_required_to_resolve_import_map_entry_0_in_file_1_Supply_the_roo_2210", "The project root is ambiguous, but is required to resolve import map entry '{0}' in file '{1}'. Supply the `rootDir` compiler option to disambiguate."),
                Add_extends_constraint: diag(2211, 3 /* Message */ , "Add_extends_constraint_2211", "Add `extends` constraint."),
                Add_extends_constraint_to_all_type_parameters: diag(2212, 3 /* Message */ , "Add_extends_constraint_to_all_type_parameters_2212", "Add `extends` constraint to all type parameters"),
                Duplicate_identifier_0: diag(2300, 1 /* Error */ , "Duplicate_identifier_0_2300", "Duplicate identifier '{0}'."),
                Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor: diag(2301, 1 /* Error */ , "Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor_2301", "Initializer of instance member variable '{0}' cannot reference identifier '{1}' declared in the constructor."),
                Static_members_cannot_reference_class_type_parameters: diag(2302, 1 /* Error */ , "Static_members_cannot_reference_class_type_parameters_2302", "Static members cannot reference class type parameters."),
                Circular_definition_of_import_alias_0: diag(2303, 1 /* Error */ , "Circular_definition_of_import_alias_0_2303", "Circular definition of import alias '{0}'."),
                Cannot_find_name_0: diag(2304, 1 /* Error */ , "Cannot_find_name_0_2304", "Cannot find name '{0}'."),
                Module_0_has_no_exported_member_1: diag(2305, 1 /* Error */ , "Module_0_has_no_exported_member_1_2305", "Module '{0}' has no exported member '{1}'."),
                File_0_is_not_a_module: diag(2306, 1 /* Error */ , "File_0_is_not_a_module_2306", "File '{0}' is not a module."),
                Cannot_find_module_0_or_its_corresponding_type_declarations: diag(2307, 1 /* Error */ , "Cannot_find_module_0_or_its_corresponding_type_declarations_2307", "Cannot find module '{0}' or its corresponding type declarations."),
                Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambiguity: diag(2308, 1 /* Error */ , "Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambig_2308", "Module {0} has already exported a member named '{1}'. Consider explicitly re-exporting to resolve the ambiguity."),
                An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements: diag(2309, 1 /* Error */ , "An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements_2309", "An export assignment cannot be used in a module with other exported elements."),
                Type_0_recursively_references_itself_as_a_base_type: diag(2310, 1 /* Error */ , "Type_0_recursively_references_itself_as_a_base_type_2310", "Type '{0}' recursively references itself as a base type."),
                Cannot_find_name_0_Did_you_mean_to_write_this_in_an_async_function: diag(2311, 1 /* Error */ , "Cannot_find_name_0_Did_you_mean_to_write_this_in_an_async_function_2311", "Cannot find name '{0}'. Did you mean to write this in an async function?"),
                An_interface_can_only_extend_an_object_type_or_intersection_of_object_types_with_statically_known_members: diag(2312, 1 /* Error */ , "An_interface_can_only_extend_an_object_type_or_intersection_of_object_types_with_statically_known_me_2312", "An interface can only extend an object type or intersection of object types with statically known members."),
                Type_parameter_0_has_a_circular_constraint: diag(2313, 1 /* Error */ , "Type_parameter_0_has_a_circular_constraint_2313", "Type parameter '{0}' has a circular constraint."),
                Generic_type_0_requires_1_type_argument_s: diag(2314, 1 /* Error */ , "Generic_type_0_requires_1_type_argument_s_2314", "Generic type '{0}' requires {1} type argument(s)."),
                Type_0_is_not_generic: diag(2315, 1 /* Error */ , "Type_0_is_not_generic_2315", "Type '{0}' is not generic."),
                Global_type_0_must_be_a_class_or_interface_type: diag(2316, 1 /* Error */ , "Global_type_0_must_be_a_class_or_interface_type_2316", "Global type '{0}' must be a class or interface type."),
                Global_type_0_must_have_1_type_parameter_s: diag(2317, 1 /* Error */ , "Global_type_0_must_have_1_type_parameter_s_2317", "Global type '{0}' must have {1} type parameter(s)."),
                Cannot_find_global_type_0: diag(2318, 1 /* Error */ , "Cannot_find_global_type_0_2318", "Cannot find global type '{0}'."),
                Named_property_0_of_types_1_and_2_are_not_identical: diag(2319, 1 /* Error */ , "Named_property_0_of_types_1_and_2_are_not_identical_2319", "Named property '{0}' of types '{1}' and '{2}' are not identical."),
                Interface_0_cannot_simultaneously_extend_types_1_and_2: diag(2320, 1 /* Error */ , "Interface_0_cannot_simultaneously_extend_types_1_and_2_2320", "Interface '{0}' cannot simultaneously extend types '{1}' and '{2}'."),
                Excessive_stack_depth_comparing_types_0_and_1: diag(2321, 1 /* Error */ , "Excessive_stack_depth_comparing_types_0_and_1_2321", "Excessive stack depth comparing types '{0}' and '{1}'."),
                Type_0_is_not_assignable_to_type_1: diag(2322, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_2322", "Type '{0}' is not assignable to type '{1}'."),
                Cannot_redeclare_exported_variable_0: diag(2323, 1 /* Error */ , "Cannot_redeclare_exported_variable_0_2323", "Cannot redeclare exported variable '{0}'."),
                Property_0_is_missing_in_type_1: diag(2324, 1 /* Error */ , "Property_0_is_missing_in_type_1_2324", "Property '{0}' is missing in type '{1}'."),
                Property_0_is_private_in_type_1_but_not_in_type_2: diag(2325, 1 /* Error */ , "Property_0_is_private_in_type_1_but_not_in_type_2_2325", "Property '{0}' is private in type '{1}' but not in type '{2}'."),
                Types_of_property_0_are_incompatible: diag(2326, 1 /* Error */ , "Types_of_property_0_are_incompatible_2326", "Types of property '{0}' are incompatible."),
                Property_0_is_optional_in_type_1_but_required_in_type_2: diag(2327, 1 /* Error */ , "Property_0_is_optional_in_type_1_but_required_in_type_2_2327", "Property '{0}' is optional in type '{1}' but required in type '{2}'."),
                Types_of_parameters_0_and_1_are_incompatible: diag(2328, 1 /* Error */ , "Types_of_parameters_0_and_1_are_incompatible_2328", "Types of parameters '{0}' and '{1}' are incompatible."),
                Index_signature_for_type_0_is_missing_in_type_1: diag(2329, 1 /* Error */ , "Index_signature_for_type_0_is_missing_in_type_1_2329", "Index signature for type '{0}' is missing in type '{1}'."),
                _0_and_1_index_signatures_are_incompatible: diag(2330, 1 /* Error */ , "_0_and_1_index_signatures_are_incompatible_2330", "'{0}' and '{1}' index signatures are incompatible."),
                this_cannot_be_referenced_in_a_module_or_namespace_body: diag(2331, 1 /* Error */ , "this_cannot_be_referenced_in_a_module_or_namespace_body_2331", "'this' cannot be referenced in a module or namespace body."),
                this_cannot_be_referenced_in_current_location: diag(2332, 1 /* Error */ , "this_cannot_be_referenced_in_current_location_2332", "'this' cannot be referenced in current location."),
                this_cannot_be_referenced_in_constructor_arguments: diag(2333, 1 /* Error */ , "this_cannot_be_referenced_in_constructor_arguments_2333", "'this' cannot be referenced in constructor arguments."),
                this_cannot_be_referenced_in_a_static_property_initializer: diag(2334, 1 /* Error */ , "this_cannot_be_referenced_in_a_static_property_initializer_2334", "'this' cannot be referenced in a static property initializer."),
                super_can_only_be_referenced_in_a_derived_class: diag(2335, 1 /* Error */ , "super_can_only_be_referenced_in_a_derived_class_2335", "'super' can only be referenced in a derived class."),
                super_cannot_be_referenced_in_constructor_arguments: diag(2336, 1 /* Error */ , "super_cannot_be_referenced_in_constructor_arguments_2336", "'super' cannot be referenced in constructor arguments."),
                Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors: diag(2337, 1 /* Error */ , "Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors_2337", "Super calls are not permitted outside constructors or in nested functions inside constructors."),
                super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_derived_class: diag(2338, 1 /* Error */ , "super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_der_2338", "'super' property access is permitted only in a constructor, member function, or member accessor of a derived class."),
                Property_0_does_not_exist_on_type_1: diag(2339, 1 /* Error */ , "Property_0_does_not_exist_on_type_1_2339", "Property '{0}' does not exist on type '{1}'."),
                Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword: diag(2340, 1 /* Error */ , "Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword_2340", "Only public and protected methods of the base class are accessible via the 'super' keyword."),
                Property_0_is_private_and_only_accessible_within_class_1: diag(2341, 1 /* Error */ , "Property_0_is_private_and_only_accessible_within_class_1_2341", "Property '{0}' is private and only accessible within class '{1}'."),
                This_syntax_requires_an_imported_helper_named_1_which_does_not_exist_in_0_Consider_upgrading_your_version_of_0: diag(2343, 1 /* Error */ , "This_syntax_requires_an_imported_helper_named_1_which_does_not_exist_in_0_Consider_upgrading_your_ve_2343", "This syntax requires an imported helper named '{1}' which does not exist in '{0}'. Consider upgrading your version of '{0}'."),
                Type_0_does_not_satisfy_the_constraint_1: diag(2344, 1 /* Error */ , "Type_0_does_not_satisfy_the_constraint_1_2344", "Type '{0}' does not satisfy the constraint '{1}'."),
                Argument_of_type_0_is_not_assignable_to_parameter_of_type_1: diag(2345, 1 /* Error */ , "Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_2345", "Argument of type '{0}' is not assignable to parameter of type '{1}'."),
                Call_target_does_not_contain_any_signatures: diag(2346, 1 /* Error */ , "Call_target_does_not_contain_any_signatures_2346", "Call target does not contain any signatures."),
                Untyped_function_calls_may_not_accept_type_arguments: diag(2347, 1 /* Error */ , "Untyped_function_calls_may_not_accept_type_arguments_2347", "Untyped function calls may not accept type arguments."),
                Value_of_type_0_is_not_callable_Did_you_mean_to_include_new: diag(2348, 1 /* Error */ , "Value_of_type_0_is_not_callable_Did_you_mean_to_include_new_2348", "Value of type '{0}' is not callable. Did you mean to include 'new'?"),
                This_expression_is_not_callable: diag(2349, 1 /* Error */ , "This_expression_is_not_callable_2349", "This expression is not callable."),
                Only_a_void_function_can_be_called_with_the_new_keyword: diag(2350, 1 /* Error */ , "Only_a_void_function_can_be_called_with_the_new_keyword_2350", "Only a void function can be called with the 'new' keyword."),
                This_expression_is_not_constructable: diag(2351, 1 /* Error */ , "This_expression_is_not_constructable_2351", "This expression is not constructable."),
                Conversion_of_type_0_to_type_1_may_be_a_mistake_because_neither_type_sufficiently_overlaps_with_the_other_If_this_was_intentional_convert_the_expression_to_unknown_first: diag(2352, 1 /* Error */ , "Conversion_of_type_0_to_type_1_may_be_a_mistake_because_neither_type_sufficiently_overlaps_with_the__2352", "Conversion of type '{0}' to type '{1}' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first."),
                Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1: diag(2353, 1 /* Error */ , "Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1_2353", "Object literal may only specify known properties, and '{0}' does not exist in type '{1}'."),
                This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found: diag(2354, 1 /* Error */ , "This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found_2354", "This syntax requires an imported helper but module '{0}' cannot be found."),
                A_function_whose_declared_type_is_neither_undefined_void_nor_any_must_return_a_value: diag(2355, 1 /* Error */ , "A_function_whose_declared_type_is_neither_undefined_void_nor_any_must_return_a_value_2355", "A function whose declared type is neither 'undefined', 'void', nor 'any' must return a value."),
                An_arithmetic_operand_must_be_of_type_any_number_bigint_or_an_enum_type: diag(2356, 1 /* Error */ , "An_arithmetic_operand_must_be_of_type_any_number_bigint_or_an_enum_type_2356", "An arithmetic operand must be of type 'any', 'number', 'bigint' or an enum type."),
                The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access: diag(2357, 1 /* Error */ , "The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access_2357", "The operand of an increment or decrement operator must be a variable or a property access."),
                The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_parameter: diag(2358, 1 /* Error */ , "The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_paramete_2358", "The left-hand side of an 'instanceof' expression must be of type 'any', an object type or a type parameter."),
                The_right_hand_side_of_an_instanceof_expression_must_be_of_type_any_or_of_a_type_assignable_to_the_Function_interface_type: diag(2359, 1 /* Error */ , "The_right_hand_side_of_an_instanceof_expression_must_be_of_type_any_or_of_a_type_assignable_to_the_F_2359", "The right-hand side of an 'instanceof' expression must be of type 'any' or of a type assignable to the 'Function' interface type."),
                The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type: diag(2362, 1 /* Error */ , "The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type_2362", "The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type."),
                The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type: diag(2363, 1 /* Error */ , "The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type_2363", "The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type."),
                The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access: diag(2364, 1 /* Error */ , "The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access_2364", "The left-hand side of an assignment expression must be a variable or a property access."),
                Operator_0_cannot_be_applied_to_types_1_and_2: diag(2365, 1 /* Error */ , "Operator_0_cannot_be_applied_to_types_1_and_2_2365", "Operator '{0}' cannot be applied to types '{1}' and '{2}'."),
                Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined: diag(2366, 1 /* Error */ , "Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined_2366", "Function lacks ending return statement and return type does not include 'undefined'."),
                This_comparison_appears_to_be_unintentional_because_the_types_0_and_1_have_no_overlap: diag(2367, 1 /* Error */ , "This_comparison_appears_to_be_unintentional_because_the_types_0_and_1_have_no_overlap_2367", "This comparison appears to be unintentional because the types '{0}' and '{1}' have no overlap."),
                Type_parameter_name_cannot_be_0: diag(2368, 1 /* Error */ , "Type_parameter_name_cannot_be_0_2368", "Type parameter name cannot be '{0}'."),
                A_parameter_property_is_only_allowed_in_a_constructor_implementation: diag(2369, 1 /* Error */ , "A_parameter_property_is_only_allowed_in_a_constructor_implementation_2369", "A parameter property is only allowed in a constructor implementation."),
                A_rest_parameter_must_be_of_an_array_type: diag(2370, 1 /* Error */ , "A_rest_parameter_must_be_of_an_array_type_2370", "A rest parameter must be of an array type."),
                A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation: diag(2371, 1 /* Error */ , "A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation_2371", "A parameter initializer is only allowed in a function or constructor implementation."),
                Parameter_0_cannot_reference_itself: diag(2372, 1 /* Error */ , "Parameter_0_cannot_reference_itself_2372", "Parameter '{0}' cannot reference itself."),
                Parameter_0_cannot_reference_identifier_1_declared_after_it: diag(2373, 1 /* Error */ , "Parameter_0_cannot_reference_identifier_1_declared_after_it_2373", "Parameter '{0}' cannot reference identifier '{1}' declared after it."),
                Duplicate_index_signature_for_type_0: diag(2374, 1 /* Error */ , "Duplicate_index_signature_for_type_0_2374", "Duplicate index signature for type '{0}'."),
                Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties: diag(2375, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefi_2375", "Type '{0}' is not assignable to type '{1}' with 'exactOptionalPropertyTypes: true'. Consider adding 'undefined' to the types of the target's properties."),
                A_super_call_must_be_the_first_statement_in_the_constructor_to_refer_to_super_or_this_when_a_derived_class_contains_initialized_properties_parameter_properties_or_private_identifiers: diag(2376, 1 /* Error */ , "A_super_call_must_be_the_first_statement_in_the_constructor_to_refer_to_super_or_this_when_a_derived_2376", "A 'super' call must be the first statement in the constructor to refer to 'super' or 'this' when a derived class contains initialized properties, parameter properties, or private identifiers."),
                Constructors_for_derived_classes_must_contain_a_super_call: diag(2377, 1 /* Error */ , "Constructors_for_derived_classes_must_contain_a_super_call_2377", "Constructors for derived classes must contain a 'super' call."),
                A_get_accessor_must_return_a_value: diag(2378, 1 /* Error */ , "A_get_accessor_must_return_a_value_2378", "A 'get' accessor must return a value."),
                Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties: diag(2379, 1 /* Error */ , "Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_with_exactOptionalPropertyTypes_Colon_tr_2379", "Argument of type '{0}' is not assignable to parameter of type '{1}' with 'exactOptionalPropertyTypes: true'. Consider adding 'undefined' to the types of the target's properties."),
                Overload_signatures_must_all_be_exported_or_non_exported: diag(2383, 1 /* Error */ , "Overload_signatures_must_all_be_exported_or_non_exported_2383", "Overload signatures must all be exported or non-exported."),
                Overload_signatures_must_all_be_ambient_or_non_ambient: diag(2384, 1 /* Error */ , "Overload_signatures_must_all_be_ambient_or_non_ambient_2384", "Overload signatures must all be ambient or non-ambient."),
                Overload_signatures_must_all_be_public_private_or_protected: diag(2385, 1 /* Error */ , "Overload_signatures_must_all_be_public_private_or_protected_2385", "Overload signatures must all be public, private or protected."),
                Overload_signatures_must_all_be_optional_or_required: diag(2386, 1 /* Error */ , "Overload_signatures_must_all_be_optional_or_required_2386", "Overload signatures must all be optional or required."),
                Function_overload_must_be_static: diag(2387, 1 /* Error */ , "Function_overload_must_be_static_2387", "Function overload must be static."),
                Function_overload_must_not_be_static: diag(2388, 1 /* Error */ , "Function_overload_must_not_be_static_2388", "Function overload must not be static."),
                Function_implementation_name_must_be_0: diag(2389, 1 /* Error */ , "Function_implementation_name_must_be_0_2389", "Function implementation name must be '{0}'."),
                Constructor_implementation_is_missing: diag(2390, 1 /* Error */ , "Constructor_implementation_is_missing_2390", "Constructor implementation is missing."),
                Function_implementation_is_missing_or_not_immediately_following_the_declaration: diag(2391, 1 /* Error */ , "Function_implementation_is_missing_or_not_immediately_following_the_declaration_2391", "Function implementation is missing or not immediately following the declaration."),
                Multiple_constructor_implementations_are_not_allowed: diag(2392, 1 /* Error */ , "Multiple_constructor_implementations_are_not_allowed_2392", "Multiple constructor implementations are not allowed."),
                Duplicate_function_implementation: diag(2393, 1 /* Error */ , "Duplicate_function_implementation_2393", "Duplicate function implementation."),
                This_overload_signature_is_not_compatible_with_its_implementation_signature: diag(2394, 1 /* Error */ , "This_overload_signature_is_not_compatible_with_its_implementation_signature_2394", "This overload signature is not compatible with its implementation signature."),
                Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local: diag(2395, 1 /* Error */ , "Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local_2395", "Individual declarations in merged declaration '{0}' must be all exported or all local."),
                Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters: diag(2396, 1 /* Error */ , "Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters_2396", "Duplicate identifier 'arguments'. Compiler uses 'arguments' to initialize rest parameters."),
                Declaration_name_conflicts_with_built_in_global_identifier_0: diag(2397, 1 /* Error */ , "Declaration_name_conflicts_with_built_in_global_identifier_0_2397", "Declaration name conflicts with built-in global identifier '{0}'."),
                constructor_cannot_be_used_as_a_parameter_property_name: diag(2398, 1 /* Error */ , "constructor_cannot_be_used_as_a_parameter_property_name_2398", "'constructor' cannot be used as a parameter property name."),
                Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference: diag(2399, 1 /* Error */ , "Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference_2399", "Duplicate identifier '_this'. Compiler uses variable declaration '_this' to capture 'this' reference."),
                Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference: diag(2400, 1 /* Error */ , "Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference_2400", "Expression resolves to variable declaration '_this' that compiler uses to capture 'this' reference."),
                A_super_call_must_be_a_root_level_statement_within_a_constructor_of_a_derived_class_that_contains_initialized_properties_parameter_properties_or_private_identifiers: diag(2401, 1 /* Error */ , "A_super_call_must_be_a_root_level_statement_within_a_constructor_of_a_derived_class_that_contains_in_2401", "A 'super' call must be a root-level statement within a constructor of a derived class that contains initialized properties, parameter properties, or private identifiers."),
                Expression_resolves_to_super_that_compiler_uses_to_capture_base_class_reference: diag(2402, 1 /* Error */ , "Expression_resolves_to_super_that_compiler_uses_to_capture_base_class_reference_2402", "Expression resolves to '_super' that compiler uses to capture base class reference."),
                Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_type_2: diag(2403, 1 /* Error */ , "Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_t_2403", "Subsequent variable declarations must have the same type.  Variable '{0}' must be of type '{1}', but here has type '{2}'."),
                The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation: diag(2404, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation_2404", "The left-hand side of a 'for...in' statement cannot use a type annotation."),
                The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any: diag(2405, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any_2405", "The left-hand side of a 'for...in' statement must be of type 'string' or 'any'."),
                The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access: diag(2406, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access_2406", "The left-hand side of a 'for...in' statement must be a variable or a property access."),
                The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter_but_here_has_type_0: diag(2407, 1 /* Error */ , "The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter_but_2407", "The right-hand side of a 'for...in' statement must be of type 'any', an object type or a type parameter, but here has type '{0}'."),
                Setters_cannot_return_a_value: diag(2408, 1 /* Error */ , "Setters_cannot_return_a_value_2408", "Setters cannot return a value."),
                Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class: diag(2409, 1 /* Error */ , "Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class_2409", "Return type of constructor signature must be assignable to the instance type of the class."),
                The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any: diag(2410, 1 /* Error */ , "The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any_2410", "The 'with' statement is not supported. All symbols in a 'with' block will have type 'any'."),
                Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_type_of_the_target: diag(2412, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefi_2412", "Type '{0}' is not assignable to type '{1}' with 'exactOptionalPropertyTypes: true'. Consider adding 'undefined' to the type of the target."),
                Property_0_of_type_1_is_not_assignable_to_2_index_type_3: diag(2411, 1 /* Error */ , "Property_0_of_type_1_is_not_assignable_to_2_index_type_3_2411", "Property '{0}' of type '{1}' is not assignable to '{2}' index type '{3}'."),
                _0_index_type_1_is_not_assignable_to_2_index_type_3: diag(2413, 1 /* Error */ , "_0_index_type_1_is_not_assignable_to_2_index_type_3_2413", "'{0}' index type '{1}' is not assignable to '{2}' index type '{3}'."),
                Class_name_cannot_be_0: diag(2414, 1 /* Error */ , "Class_name_cannot_be_0_2414", "Class name cannot be '{0}'."),
                Class_0_incorrectly_extends_base_class_1: diag(2415, 1 /* Error */ , "Class_0_incorrectly_extends_base_class_1_2415", "Class '{0}' incorrectly extends base class '{1}'."),
                Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2: diag(2416, 1 /* Error */ , "Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2_2416", "Property '{0}' in type '{1}' is not assignable to the same property in base type '{2}'."),
                Class_static_side_0_incorrectly_extends_base_class_static_side_1: diag(2417, 1 /* Error */ , "Class_static_side_0_incorrectly_extends_base_class_static_side_1_2417", "Class static side '{0}' incorrectly extends base class static side '{1}'."),
                Type_of_computed_property_s_value_is_0_which_is_not_assignable_to_type_1: diag(2418, 1 /* Error */ , "Type_of_computed_property_s_value_is_0_which_is_not_assignable_to_type_1_2418", "Type of computed property's value is '{0}', which is not assignable to type '{1}'."),
                Types_of_construct_signatures_are_incompatible: diag(2419, 1 /* Error */ , "Types_of_construct_signatures_are_incompatible_2419", "Types of construct signatures are incompatible."),
                Class_0_incorrectly_implements_interface_1: diag(2420, 1 /* Error */ , "Class_0_incorrectly_implements_interface_1_2420", "Class '{0}' incorrectly implements interface '{1}'."),
                A_class_can_only_implement_an_object_type_or_intersection_of_object_types_with_statically_known_members: diag(2422, 1 /* Error */ , "A_class_can_only_implement_an_object_type_or_intersection_of_object_types_with_statically_known_memb_2422", "A class can only implement an object type or intersection of object types with statically known members."),
                Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_accessor: diag(2423, 1 /* Error */ , "Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_access_2423", "Class '{0}' defines instance member function '{1}', but extended class '{2}' defines it as instance member accessor."),
                Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_function: diag(2425, 1 /* Error */ , "Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_functi_2425", "Class '{0}' defines instance member property '{1}', but extended class '{2}' defines it as instance member function."),
                Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_function: diag(2426, 1 /* Error */ , "Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_functi_2426", "Class '{0}' defines instance member accessor '{1}', but extended class '{2}' defines it as instance member function."),
                Interface_name_cannot_be_0: diag(2427, 1 /* Error */ , "Interface_name_cannot_be_0_2427", "Interface name cannot be '{0}'."),
                All_declarations_of_0_must_have_identical_type_parameters: diag(2428, 1 /* Error */ , "All_declarations_of_0_must_have_identical_type_parameters_2428", "All declarations of '{0}' must have identical type parameters."),
                Interface_0_incorrectly_extends_interface_1: diag(2430, 1 /* Error */ , "Interface_0_incorrectly_extends_interface_1_2430", "Interface '{0}' incorrectly extends interface '{1}'."),
                Enum_name_cannot_be_0: diag(2431, 1 /* Error */ , "Enum_name_cannot_be_0_2431", "Enum name cannot be '{0}'."),
                In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enum_element: diag(2432, 1 /* Error */ , "In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enu_2432", "In an enum with multiple declarations, only one declaration can omit an initializer for its first enum element."),
                A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merged: diag(2433, 1 /* Error */ , "A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merg_2433", "A namespace declaration cannot be in a different file from a class or function with which it is merged."),
                A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged: diag(2434, 1 /* Error */ , "A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged_2434", "A namespace declaration cannot be located prior to a class or function with which it is merged."),
                Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces: diag(2435, 1 /* Error */ , "Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces_2435", "Ambient modules cannot be nested in other modules or namespaces."),
                Ambient_module_declaration_cannot_specify_relative_module_name: diag(2436, 1 /* Error */ , "Ambient_module_declaration_cannot_specify_relative_module_name_2436", "Ambient module declaration cannot specify relative module name."),
                Module_0_is_hidden_by_a_local_declaration_with_the_same_name: diag(2437, 1 /* Error */ , "Module_0_is_hidden_by_a_local_declaration_with_the_same_name_2437", "Module '{0}' is hidden by a local declaration with the same name."),
                Import_name_cannot_be_0: diag(2438, 1 /* Error */ , "Import_name_cannot_be_0_2438", "Import name cannot be '{0}'."),
                Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relative_module_name: diag(2439, 1 /* Error */ , "Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relati_2439", "Import or export declaration in an ambient module declaration cannot reference module through relative module name."),
                Import_declaration_conflicts_with_local_declaration_of_0: diag(2440, 1 /* Error */ , "Import_declaration_conflicts_with_local_declaration_of_0_2440", "Import declaration conflicts with local declaration of '{0}'."),
                Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module: diag(2441, 1 /* Error */ , "Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_2441", "Duplicate identifier '{0}'. Compiler reserves name '{1}' in top level scope of a module."),
                Types_have_separate_declarations_of_a_private_property_0: diag(2442, 1 /* Error */ , "Types_have_separate_declarations_of_a_private_property_0_2442", "Types have separate declarations of a private property '{0}'."),
                Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2: diag(2443, 1 /* Error */ , "Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2_2443", "Property '{0}' is protected but type '{1}' is not a class derived from '{2}'."),
                Property_0_is_protected_in_type_1_but_public_in_type_2: diag(2444, 1 /* Error */ , "Property_0_is_protected_in_type_1_but_public_in_type_2_2444", "Property '{0}' is protected in type '{1}' but public in type '{2}'."),
                Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses: diag(2445, 1 /* Error */ , "Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses_2445", "Property '{0}' is protected and only accessible within class '{1}' and its subclasses."),
                Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1_This_is_an_instance_of_class_2: diag(2446, 1 /* Error */ , "Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1_This_is_an_instance_of_cl_2446", "Property '{0}' is protected and only accessible through an instance of class '{1}'. This is an instance of class '{2}'."),
                The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead: diag(2447, 1 /* Error */ , "The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead_2447", "The '{0}' operator is not allowed for boolean types. Consider using '{1}' instead."),
                Block_scoped_variable_0_used_before_its_declaration: diag(2448, 1 /* Error */ , "Block_scoped_variable_0_used_before_its_declaration_2448", "Block-scoped variable '{0}' used before its declaration."),
                Class_0_used_before_its_declaration: diag(2449, 1 /* Error */ , "Class_0_used_before_its_declaration_2449", "Class '{0}' used before its declaration."),
                Enum_0_used_before_its_declaration: diag(2450, 1 /* Error */ , "Enum_0_used_before_its_declaration_2450", "Enum '{0}' used before its declaration."),
                Cannot_redeclare_block_scoped_variable_0: diag(2451, 1 /* Error */ , "Cannot_redeclare_block_scoped_variable_0_2451", "Cannot redeclare block-scoped variable '{0}'."),
                An_enum_member_cannot_have_a_numeric_name: diag(2452, 1 /* Error */ , "An_enum_member_cannot_have_a_numeric_name_2452", "An enum member cannot have a numeric name."),
                Variable_0_is_used_before_being_assigned: diag(2454, 1 /* Error */ , "Variable_0_is_used_before_being_assigned_2454", "Variable '{0}' is used before being assigned."),
                Type_alias_0_circularly_references_itself: diag(2456, 1 /* Error */ , "Type_alias_0_circularly_references_itself_2456", "Type alias '{0}' circularly references itself."),
                Type_alias_name_cannot_be_0: diag(2457, 1 /* Error */ , "Type_alias_name_cannot_be_0_2457", "Type alias name cannot be '{0}'."),
                An_AMD_module_cannot_have_multiple_name_assignments: diag(2458, 1 /* Error */ , "An_AMD_module_cannot_have_multiple_name_assignments_2458", "An AMD module cannot have multiple name assignments."),
                Module_0_declares_1_locally_but_it_is_not_exported: diag(2459, 1 /* Error */ , "Module_0_declares_1_locally_but_it_is_not_exported_2459", "Module '{0}' declares '{1}' locally, but it is not exported."),
                Module_0_declares_1_locally_but_it_is_exported_as_2: diag(2460, 1 /* Error */ , "Module_0_declares_1_locally_but_it_is_exported_as_2_2460", "Module '{0}' declares '{1}' locally, but it is exported as '{2}'."),
                Type_0_is_not_an_array_type: diag(2461, 1 /* Error */ , "Type_0_is_not_an_array_type_2461", "Type '{0}' is not an array type."),
                A_rest_element_must_be_last_in_a_destructuring_pattern: diag(2462, 1 /* Error */ , "A_rest_element_must_be_last_in_a_destructuring_pattern_2462", "A rest element must be last in a destructuring pattern."),
                A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature: diag(2463, 1 /* Error */ , "A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature_2463", "A binding pattern parameter cannot be optional in an implementation signature."),
                A_computed_property_name_must_be_of_type_string_number_symbol_or_any: diag(2464, 1 /* Error */ , "A_computed_property_name_must_be_of_type_string_number_symbol_or_any_2464", "A computed property name must be of type 'string', 'number', 'symbol', or 'any'."),
                this_cannot_be_referenced_in_a_computed_property_name: diag(2465, 1 /* Error */ , "this_cannot_be_referenced_in_a_computed_property_name_2465", "'this' cannot be referenced in a computed property name."),
                super_cannot_be_referenced_in_a_computed_property_name: diag(2466, 1 /* Error */ , "super_cannot_be_referenced_in_a_computed_property_name_2466", "'super' cannot be referenced in a computed property name."),
                A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type: diag(2467, 1 /* Error */ , "A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type_2467", "A computed property name cannot reference a type parameter from its containing type."),
                Cannot_find_global_value_0: diag(2468, 1 /* Error */ , "Cannot_find_global_value_0_2468", "Cannot find global value '{0}'."),
                The_0_operator_cannot_be_applied_to_type_symbol: diag(2469, 1 /* Error */ , "The_0_operator_cannot_be_applied_to_type_symbol_2469", "The '{0}' operator cannot be applied to type 'symbol'."),
                Spread_operator_in_new_expressions_is_only_available_when_targeting_ECMAScript_5_and_higher: diag(2472, 1 /* Error */ , "Spread_operator_in_new_expressions_is_only_available_when_targeting_ECMAScript_5_and_higher_2472", "Spread operator in 'new' expressions is only available when targeting ECMAScript 5 and higher."),
                Enum_declarations_must_all_be_const_or_non_const: diag(2473, 1 /* Error */ , "Enum_declarations_must_all_be_const_or_non_const_2473", "Enum declarations must all be const or non-const."),
                const_enum_member_initializers_must_be_constant_expressions: diag(2474, 1 /* Error */ , "const_enum_member_initializers_must_be_constant_expressions_2474", "const enum member initializers must be constant expressions."),
                const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_import_declaration_or_export_assignment_or_type_query: diag(2475, 1 /* Error */ , "const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_im_2475", "'const' enums can only be used in property or index access expressions or the right hand side of an import declaration or export assignment or type query."),
                A_const_enum_member_can_only_be_accessed_using_a_string_literal: diag(2476, 1 /* Error */ , "A_const_enum_member_can_only_be_accessed_using_a_string_literal_2476", "A const enum member can only be accessed using a string literal."),
                const_enum_member_initializer_was_evaluated_to_a_non_finite_value: diag(2477, 1 /* Error */ , "const_enum_member_initializer_was_evaluated_to_a_non_finite_value_2477", "'const' enum member initializer was evaluated to a non-finite value."),
                const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN: diag(2478, 1 /* Error */ , "const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN_2478", "'const' enum member initializer was evaluated to disallowed value 'NaN'."),
                let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations: diag(2480, 1 /* Error */ , "let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations_2480", "'let' is not allowed to be used as a name in 'let' or 'const' declarations."),
                Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1: diag(2481, 1 /* Error */ , "Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1_2481", "Cannot initialize outer scoped variable '{0}' in the same scope as block scoped declaration '{1}'."),
                The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation: diag(2483, 1 /* Error */ , "The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation_2483", "The left-hand side of a 'for...of' statement cannot use a type annotation."),
                Export_declaration_conflicts_with_exported_declaration_of_0: diag(2484, 1 /* Error */ , "Export_declaration_conflicts_with_exported_declaration_of_0_2484", "Export declaration conflicts with exported declaration of '{0}'."),
                The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access: diag(2487, 1 /* Error */ , "The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access_2487", "The left-hand side of a 'for...of' statement must be a variable or a property access."),
                Type_0_must_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2488, 1 /* Error */ , "Type_0_must_have_a_Symbol_iterator_method_that_returns_an_iterator_2488", "Type '{0}' must have a '[Symbol.iterator]()' method that returns an iterator."),
                An_iterator_must_have_a_next_method: diag(2489, 1 /* Error */ , "An_iterator_must_have_a_next_method_2489", "An iterator must have a 'next()' method."),
                The_type_returned_by_the_0_method_of_an_iterator_must_have_a_value_property: diag(2490, 1 /* Error */ , "The_type_returned_by_the_0_method_of_an_iterator_must_have_a_value_property_2490", "The type returned by the '{0}()' method of an iterator must have a 'value' property."),
                The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern: diag(2491, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern_2491", "The left-hand side of a 'for...in' statement cannot be a destructuring pattern."),
                Cannot_redeclare_identifier_0_in_catch_clause: diag(2492, 1 /* Error */ , "Cannot_redeclare_identifier_0_in_catch_clause_2492", "Cannot redeclare identifier '{0}' in catch clause."),
                Tuple_type_0_of_length_1_has_no_element_at_index_2: diag(2493, 1 /* Error */ , "Tuple_type_0_of_length_1_has_no_element_at_index_2_2493", "Tuple type '{0}' of length '{1}' has no element at index '{2}'."),
                Using_a_string_in_a_for_of_statement_is_only_supported_in_ECMAScript_5_and_higher: diag(2494, 1 /* Error */ , "Using_a_string_in_a_for_of_statement_is_only_supported_in_ECMAScript_5_and_higher_2494", "Using a string in a 'for...of' statement is only supported in ECMAScript 5 and higher."),
                Type_0_is_not_an_array_type_or_a_string_type: diag(2495, 1 /* Error */ , "Type_0_is_not_an_array_type_or_a_string_type_2495", "Type '{0}' is not an array type or a string type."),
                The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES3_and_ES5_Consider_using_a_standard_function_expression: diag(2496, 1 /* Error */ , "The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES3_and_ES5_Consider_using_a_stand_2496", "The 'arguments' object cannot be referenced in an arrow function in ES3 and ES5. Consider using a standard function expression."),
                This_module_can_only_be_referenced_with_ECMAScript_imports_Slashexports_by_turning_on_the_0_flag_and_referencing_its_default_export: diag(2497, 1 /* Error */ , "This_module_can_only_be_referenced_with_ECMAScript_imports_Slashexports_by_turning_on_the_0_flag_and_2497", "This module can only be referenced with ECMAScript imports/exports by turning on the '{0}' flag and referencing its default export."),
                Module_0_uses_export_and_cannot_be_used_with_export_Asterisk: diag(2498, 1 /* Error */ , "Module_0_uses_export_and_cannot_be_used_with_export_Asterisk_2498", "Module '{0}' uses 'export =' and cannot be used with 'export *'."),
                An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments: diag(2499, 1 /* Error */ , "An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments_2499", "An interface can only extend an identifier/qualified-name with optional type arguments."),
                A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments: diag(2500, 1 /* Error */ , "A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments_2500", "A class can only implement an identifier/qualified-name with optional type arguments."),
                A_rest_element_cannot_contain_a_binding_pattern: diag(2501, 1 /* Error */ , "A_rest_element_cannot_contain_a_binding_pattern_2501", "A rest element cannot contain a binding pattern."),
                _0_is_referenced_directly_or_indirectly_in_its_own_type_annotation: diag(2502, 1 /* Error */ , "_0_is_referenced_directly_or_indirectly_in_its_own_type_annotation_2502", "'{0}' is referenced directly or indirectly in its own type annotation."),
                Cannot_find_namespace_0: diag(2503, 1 /* Error */ , "Cannot_find_namespace_0_2503", "Cannot find namespace '{0}'."),
                Type_0_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator: diag(2504, 1 /* Error */ , "Type_0_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator_2504", "Type '{0}' must have a '[Symbol.asyncIterator]()' method that returns an async iterator."),
                A_generator_cannot_have_a_void_type_annotation: diag(2505, 1 /* Error */ , "A_generator_cannot_have_a_void_type_annotation_2505", "A generator cannot have a 'void' type annotation."),
                _0_is_referenced_directly_or_indirectly_in_its_own_base_expression: diag(2506, 1 /* Error */ , "_0_is_referenced_directly_or_indirectly_in_its_own_base_expression_2506", "'{0}' is referenced directly or indirectly in its own base expression."),
                Type_0_is_not_a_constructor_function_type: diag(2507, 1 /* Error */ , "Type_0_is_not_a_constructor_function_type_2507", "Type '{0}' is not a constructor function type."),
                No_base_constructor_has_the_specified_number_of_type_arguments: diag(2508, 1 /* Error */ , "No_base_constructor_has_the_specified_number_of_type_arguments_2508", "No base constructor has the specified number of type arguments."),
                Base_constructor_return_type_0_is_not_an_object_type_or_intersection_of_object_types_with_statically_known_members: diag(2509, 1 /* Error */ , "Base_constructor_return_type_0_is_not_an_object_type_or_intersection_of_object_types_with_statically_2509", "Base constructor return type '{0}' is not an object type or intersection of object types with statically known members."),
                Base_constructors_must_all_have_the_same_return_type: diag(2510, 1 /* Error */ , "Base_constructors_must_all_have_the_same_return_type_2510", "Base constructors must all have the same return type."),
                Cannot_create_an_instance_of_an_abstract_class: diag(2511, 1 /* Error */ , "Cannot_create_an_instance_of_an_abstract_class_2511", "Cannot create an instance of an abstract class."),
                Overload_signatures_must_all_be_abstract_or_non_abstract: diag(2512, 1 /* Error */ , "Overload_signatures_must_all_be_abstract_or_non_abstract_2512", "Overload signatures must all be abstract or non-abstract."),
                Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression: diag(2513, 1 /* Error */ , "Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression_2513", "Abstract method '{0}' in class '{1}' cannot be accessed via super expression."),
                A_tuple_type_cannot_be_indexed_with_a_negative_value: diag(2514, 1 /* Error */ , "A_tuple_type_cannot_be_indexed_with_a_negative_value_2514", "A tuple type cannot be indexed with a negative value."),
                Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2: diag(2515, 1 /* Error */ , "Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2_2515", "Non-abstract class '{0}' does not implement inherited abstract member '{1}' from class '{2}'."),
                All_declarations_of_an_abstract_method_must_be_consecutive: diag(2516, 1 /* Error */ , "All_declarations_of_an_abstract_method_must_be_consecutive_2516", "All declarations of an abstract method must be consecutive."),
                Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type: diag(2517, 1 /* Error */ , "Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type_2517", "Cannot assign an abstract constructor type to a non-abstract constructor type."),
                A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard: diag(2518, 1 /* Error */ , "A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard_2518", "A 'this'-based type guard is not compatible with a parameter-based type guard."),
                An_async_iterator_must_have_a_next_method: diag(2519, 1 /* Error */ , "An_async_iterator_must_have_a_next_method_2519", "An async iterator must have a 'next()' method."),
                Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions: diag(2520, 1 /* Error */ , "Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions_2520", "Duplicate identifier '{0}'. Compiler uses declaration '{1}' to support async functions."),
                The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES3_and_ES5_Consider_using_a_standard_function_or_method: diag(2522, 1 /* Error */ , "The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES3_and_ES5_Consider_usi_2522", "The 'arguments' object cannot be referenced in an async function or method in ES3 and ES5. Consider using a standard function or method."),
                yield_expressions_cannot_be_used_in_a_parameter_initializer: diag(2523, 1 /* Error */ , "yield_expressions_cannot_be_used_in_a_parameter_initializer_2523", "'yield' expressions cannot be used in a parameter initializer."),
                await_expressions_cannot_be_used_in_a_parameter_initializer: diag(2524, 1 /* Error */ , "await_expressions_cannot_be_used_in_a_parameter_initializer_2524", "'await' expressions cannot be used in a parameter initializer."),
                Initializer_provides_no_value_for_this_binding_element_and_the_binding_element_has_no_default_value: diag(2525, 1 /* Error */ , "Initializer_provides_no_value_for_this_binding_element_and_the_binding_element_has_no_default_value_2525", "Initializer provides no value for this binding element and the binding element has no default value."),
                A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface: diag(2526, 1 /* Error */ , "A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface_2526", "A 'this' type is available only in a non-static member of a class or interface."),
                The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary: diag(2527, 1 /* Error */ , "The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary_2527", "The inferred type of '{0}' references an inaccessible '{1}' type. A type annotation is necessary."),
                A_module_cannot_have_multiple_default_exports: diag(2528, 1 /* Error */ , "A_module_cannot_have_multiple_default_exports_2528", "A module cannot have multiple default exports."),
                Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_functions: diag(2529, 1 /* Error */ , "Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_func_2529", "Duplicate identifier '{0}'. Compiler reserves name '{1}' in top level scope of a module containing async functions."),
                Property_0_is_incompatible_with_index_signature: diag(2530, 1 /* Error */ , "Property_0_is_incompatible_with_index_signature_2530", "Property '{0}' is incompatible with index signature."),
                Object_is_possibly_null: diag(2531, 1 /* Error */ , "Object_is_possibly_null_2531", "Object is possibly 'null'."),
                Object_is_possibly_undefined: diag(2532, 1 /* Error */ , "Object_is_possibly_undefined_2532", "Object is possibly 'undefined'."),
                Object_is_possibly_null_or_undefined: diag(2533, 1 /* Error */ , "Object_is_possibly_null_or_undefined_2533", "Object is possibly 'null' or 'undefined'."),
                A_function_returning_never_cannot_have_a_reachable_end_point: diag(2534, 1 /* Error */ , "A_function_returning_never_cannot_have_a_reachable_end_point_2534", "A function returning 'never' cannot have a reachable end point."),
                Type_0_cannot_be_used_to_index_type_1: diag(2536, 1 /* Error */ , "Type_0_cannot_be_used_to_index_type_1_2536", "Type '{0}' cannot be used to index type '{1}'."),
                Type_0_has_no_matching_index_signature_for_type_1: diag(2537, 1 /* Error */ , "Type_0_has_no_matching_index_signature_for_type_1_2537", "Type '{0}' has no matching index signature for type '{1}'."),
                Type_0_cannot_be_used_as_an_index_type: diag(2538, 1 /* Error */ , "Type_0_cannot_be_used_as_an_index_type_2538", "Type '{0}' cannot be used as an index type."),
                Cannot_assign_to_0_because_it_is_not_a_variable: diag(2539, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_not_a_variable_2539", "Cannot assign to '{0}' because it is not a variable."),
                Cannot_assign_to_0_because_it_is_a_read_only_property: diag(2540, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_a_read_only_property_2540", "Cannot assign to '{0}' because it is a read-only property."),
                Index_signature_in_type_0_only_permits_reading: diag(2542, 1 /* Error */ , "Index_signature_in_type_0_only_permits_reading_2542", "Index signature in type '{0}' only permits reading."),
                Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_meta_property_reference: diag(2543, 1 /* Error */ , "Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_me_2543", "Duplicate identifier '_newTarget'. Compiler uses variable declaration '_newTarget' to capture 'new.target' meta-property reference."),
                Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta_property_reference: diag(2544, 1 /* Error */ , "Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta__2544", "Expression resolves to variable declaration '_newTarget' that compiler uses to capture 'new.target' meta-property reference."),
                A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any: diag(2545, 1 /* Error */ , "A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any_2545", "A mixin class must have a constructor with a single rest parameter of type 'any[]'."),
                The_type_returned_by_the_0_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_property: diag(2547, 1 /* Error */ , "The_type_returned_by_the_0_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_pro_2547", "The type returned by the '{0}()' method of an async iterator must be a promise for a type with a 'value' property."),
                Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2548, 1 /* Error */ , "Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator_2548", "Type '{0}' is not an array type or does not have a '[Symbol.iterator]()' method that returns an iterator."),
                Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2549, 1 /* Error */ , "Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns__2549", "Type '{0}' is not an array type or a string type or does not have a '[Symbol.iterator]()' method that returns an iterator."),
                Property_0_does_not_exist_on_type_1_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_2_or_later: diag(2550, 1 /* Error */ , "Property_0_does_not_exist_on_type_1_Do_you_need_to_change_your_target_library_Try_changing_the_lib_c_2550", "Property '{0}' does not exist on type '{1}'. Do you need to change your target library? Try changing the 'lib' compiler option to '{2}' or later."),
                Property_0_does_not_exist_on_type_1_Did_you_mean_2: diag(2551, 1 /* Error */ , "Property_0_does_not_exist_on_type_1_Did_you_mean_2_2551", "Property '{0}' does not exist on type '{1}'. Did you mean '{2}'?"),
                Cannot_find_name_0_Did_you_mean_1: diag(2552, 1 /* Error */ , "Cannot_find_name_0_Did_you_mean_1_2552", "Cannot find name '{0}'. Did you mean '{1}'?"),
                Computed_values_are_not_permitted_in_an_enum_with_string_valued_members: diag(2553, 1 /* Error */ , "Computed_values_are_not_permitted_in_an_enum_with_string_valued_members_2553", "Computed values are not permitted in an enum with string valued members."),
                Expected_0_arguments_but_got_1: diag(2554, 1 /* Error */ , "Expected_0_arguments_but_got_1_2554", "Expected {0} arguments, but got {1}."),
                Expected_at_least_0_arguments_but_got_1: diag(2555, 1 /* Error */ , "Expected_at_least_0_arguments_but_got_1_2555", "Expected at least {0} arguments, but got {1}."),
                A_spread_argument_must_either_have_a_tuple_type_or_be_passed_to_a_rest_parameter: diag(2556, 1 /* Error */ , "A_spread_argument_must_either_have_a_tuple_type_or_be_passed_to_a_rest_parameter_2556", "A spread argument must either have a tuple type or be passed to a rest parameter."),
                Expected_0_type_arguments_but_got_1: diag(2558, 1 /* Error */ , "Expected_0_type_arguments_but_got_1_2558", "Expected {0} type arguments, but got {1}."),
                Type_0_has_no_properties_in_common_with_type_1: diag(2559, 1 /* Error */ , "Type_0_has_no_properties_in_common_with_type_1_2559", "Type '{0}' has no properties in common with type '{1}'."),
                Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it: diag(2560, 1 /* Error */ , "Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it_2560", "Value of type '{0}' has no properties in common with type '{1}'. Did you mean to call it?"),
                Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_write_2: diag(2561, 1 /* Error */ , "Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_writ_2561", "Object literal may only specify known properties, but '{0}' does not exist in type '{1}'. Did you mean to write '{2}'?"),
                Base_class_expressions_cannot_reference_class_type_parameters: diag(2562, 1 /* Error */ , "Base_class_expressions_cannot_reference_class_type_parameters_2562", "Base class expressions cannot reference class type parameters."),
                The_containing_function_or_module_body_is_too_large_for_control_flow_analysis: diag(2563, 1 /* Error */ , "The_containing_function_or_module_body_is_too_large_for_control_flow_analysis_2563", "The containing function or module body is too large for control flow analysis."),
                Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor: diag(2564, 1 /* Error */ , "Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor_2564", "Property '{0}' has no initializer and is not definitely assigned in the constructor."),
                Property_0_is_used_before_being_assigned: diag(2565, 1 /* Error */ , "Property_0_is_used_before_being_assigned_2565", "Property '{0}' is used before being assigned."),
                A_rest_element_cannot_have_a_property_name: diag(2566, 1 /* Error */ , "A_rest_element_cannot_have_a_property_name_2566", "A rest element cannot have a property name."),
                Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations: diag(2567, 1 /* Error */ , "Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations_2567", "Enum declarations can only merge with namespace or other enum declarations."),
                Property_0_may_not_exist_on_type_1_Did_you_mean_2: diag(2568, 1 /* Error */ , "Property_0_may_not_exist_on_type_1_Did_you_mean_2_2568", "Property '{0}' may not exist on type '{1}'. Did you mean '{2}'?"),
                Could_not_find_name_0_Did_you_mean_1: diag(2570, 1 /* Error */ , "Could_not_find_name_0_Did_you_mean_1_2570", "Could not find name '{0}'. Did you mean '{1}'?"),
                Object_is_of_type_unknown: diag(2571, 1 /* Error */ , "Object_is_of_type_unknown_2571", "Object is of type 'unknown'."),
                A_rest_element_type_must_be_an_array_type: diag(2574, 1 /* Error */ , "A_rest_element_type_must_be_an_array_type_2574", "A rest element type must be an array type."),
                No_overload_expects_0_arguments_but_overloads_do_exist_that_expect_either_1_or_2_arguments: diag(2575, 1 /* Error */ , "No_overload_expects_0_arguments_but_overloads_do_exist_that_expect_either_1_or_2_arguments_2575", "No overload expects {0} arguments, but overloads do exist that expect either {1} or {2} arguments."),
                Property_0_does_not_exist_on_type_1_Did_you_mean_to_access_the_static_member_2_instead: diag(2576, 1 /* Error */ , "Property_0_does_not_exist_on_type_1_Did_you_mean_to_access_the_static_member_2_instead_2576", "Property '{0}' does not exist on type '{1}'. Did you mean to access the static member '{2}' instead?"),
                Return_type_annotation_circularly_references_itself: diag(2577, 1 /* Error */ , "Return_type_annotation_circularly_references_itself_2577", "Return type annotation circularly references itself."),
                Unused_ts_expect_error_directive: diag(2578, 1 /* Error */ , "Unused_ts_expect_error_directive_2578", "Unused '@ts-expect-error' directive."),
                Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashnode: diag(2580, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashno_2580", "Cannot find name '{0}'. Do you need to install type definitions for node? Try `npm i --save-dev @types/node`."),
                Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slashjquery: diag(2581, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slash_2581", "Cannot find name '{0}'. Do you need to install type definitions for jQuery? Try `npm i --save-dev @types/jquery`."),
                Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_types_Slashjest_or_npm_i_save_dev_types_Slashmocha: diag(2582, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_type_2582", "Cannot find name '{0}'. Do you need to install type definitions for a test runner? Try `npm i --save-dev @types/jest` or `npm i --save-dev @types/mocha`."),
                Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_1_or_later: diag(2583, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_2583", "Cannot find name '{0}'. Do you need to change your target library? Try changing the 'lib' compiler option to '{1}' or later."),
                Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_include_dom: diag(2584, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_2584", "Cannot find name '{0}'. Do you need to change your target library? Try changing the 'lib' compiler option to include 'dom'."),
                _0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_es2015_or_later: diag(2585, 1 /* Error */ , "_0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Do_you_need_to_change_your_target_library_2585", "'{0}' only refers to a type, but is being used as a value here. Do you need to change your target library? Try changing the 'lib' compiler option to es2015 or later."),
                Cannot_assign_to_0_because_it_is_a_constant: diag(2588, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_a_constant_2588", "Cannot assign to '{0}' because it is a constant."),
                Type_instantiation_is_excessively_deep_and_possibly_infinite: diag(2589, 1 /* Error */ , "Type_instantiation_is_excessively_deep_and_possibly_infinite_2589", "Type instantiation is excessively deep and possibly infinite."),
                Expression_produces_a_union_type_that_is_too_complex_to_represent: diag(2590, 1 /* Error */ , "Expression_produces_a_union_type_that_is_too_complex_to_represent_2590", "Expression produces a union type that is too complex to represent."),
                Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashnode_and_then_add_node_to_the_types_field_in_your_tsconfig: diag(2591, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashno_2591", "Cannot find name '{0}'. Do you need to install type definitions for node? Try `npm i --save-dev @types/node` and then add 'node' to the types field in your tsconfig."),
                Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slashjquery_and_then_add_jquery_to_the_types_field_in_your_tsconfig: diag(2592, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slash_2592", "Cannot find name '{0}'. Do you need to install type definitions for jQuery? Try `npm i --save-dev @types/jquery` and then add 'jquery' to the types field in your tsconfig."),
                Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_types_Slashjest_or_npm_i_save_dev_types_Slashmocha_and_then_add_jest_or_mocha_to_the_types_field_in_your_tsconfig: diag(2593, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_type_2593", "Cannot find name '{0}'. Do you need to install type definitions for a test runner? Try `npm i --save-dev @types/jest` or `npm i --save-dev @types/mocha` and then add 'jest' or 'mocha' to the types field in your tsconfig."),
                This_module_is_declared_with_export_and_can_only_be_used_with_a_default_import_when_using_the_0_flag: diag(2594, 1 /* Error */ , "This_module_is_declared_with_export_and_can_only_be_used_with_a_default_import_when_using_the_0_flag_2594", "This module is declared with 'export =', and can only be used with a default import when using the '{0}' flag."),
                _0_can_only_be_imported_by_using_a_default_import: diag(2595, 1 /* Error */ , "_0_can_only_be_imported_by_using_a_default_import_2595", "'{0}' can only be imported by using a default import."),
                _0_can_only_be_imported_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import: diag(2596, 1 /* Error */ , "_0_can_only_be_imported_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import_2596", "'{0}' can only be imported by turning on the 'esModuleInterop' flag and using a default import."),
                _0_can_only_be_imported_by_using_a_require_call_or_by_using_a_default_import: diag(2597, 1 /* Error */ , "_0_can_only_be_imported_by_using_a_require_call_or_by_using_a_default_import_2597", "'{0}' can only be imported by using a 'require' call or by using a default import."),
                _0_can_only_be_imported_by_using_a_require_call_or_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import: diag(2598, 1 /* Error */ , "_0_can_only_be_imported_by_using_a_require_call_or_by_turning_on_the_esModuleInterop_flag_and_using__2598", "'{0}' can only be imported by using a 'require' call or by turning on the 'esModuleInterop' flag and using a default import."),
                JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist: diag(2602, 1 /* Error */ , "JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist_2602", "JSX element implicitly has type 'any' because the global type 'JSX.Element' does not exist."),
                Property_0_in_type_1_is_not_assignable_to_type_2: diag(2603, 1 /* Error */ , "Property_0_in_type_1_is_not_assignable_to_type_2_2603", "Property '{0}' in type '{1}' is not assignable to type '{2}'."),
                JSX_element_type_0_does_not_have_any_construct_or_call_signatures: diag(2604, 1 /* Error */ , "JSX_element_type_0_does_not_have_any_construct_or_call_signatures_2604", "JSX element type '{0}' does not have any construct or call signatures."),
                Property_0_of_JSX_spread_attribute_is_not_assignable_to_target_property: diag(2606, 1 /* Error */ , "Property_0_of_JSX_spread_attribute_is_not_assignable_to_target_property_2606", "Property '{0}' of JSX spread attribute is not assignable to target property."),
                JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property: diag(2607, 1 /* Error */ , "JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property_2607", "JSX element class does not support attributes because it does not have a '{0}' property."),
                The_global_type_JSX_0_may_not_have_more_than_one_property: diag(2608, 1 /* Error */ , "The_global_type_JSX_0_may_not_have_more_than_one_property_2608", "The global type 'JSX.{0}' may not have more than one property."),
                JSX_spread_child_must_be_an_array_type: diag(2609, 1 /* Error */ , "JSX_spread_child_must_be_an_array_type_2609", "JSX spread child must be an array type."),
                _0_is_defined_as_an_accessor_in_class_1_but_is_overridden_here_in_2_as_an_instance_property: diag(2610, 1 /* Error */ , "_0_is_defined_as_an_accessor_in_class_1_but_is_overridden_here_in_2_as_an_instance_property_2610", "'{0}' is defined as an accessor in class '{1}', but is overridden here in '{2}' as an instance property."),
                _0_is_defined_as_a_property_in_class_1_but_is_overridden_here_in_2_as_an_accessor: diag(2611, 1 /* Error */ , "_0_is_defined_as_a_property_in_class_1_but_is_overridden_here_in_2_as_an_accessor_2611", "'{0}' is defined as a property in class '{1}', but is overridden here in '{2}' as an accessor."),
                Property_0_will_overwrite_the_base_property_in_1_If_this_is_intentional_add_an_initializer_Otherwise_add_a_declare_modifier_or_remove_the_redundant_declaration: diag(2612, 1 /* Error */ , "Property_0_will_overwrite_the_base_property_in_1_If_this_is_intentional_add_an_initializer_Otherwise_2612", "Property '{0}' will overwrite the base property in '{1}'. If this is intentional, add an initializer. Otherwise, add a 'declare' modifier or remove the redundant declaration."),
                Module_0_has_no_default_export_Did_you_mean_to_use_import_1_from_0_instead: diag(2613, 1 /* Error */ , "Module_0_has_no_default_export_Did_you_mean_to_use_import_1_from_0_instead_2613", "Module '{0}' has no default export. Did you mean to use 'import { {1} } from {0}' instead?"),
                Module_0_has_no_exported_member_1_Did_you_mean_to_use_import_1_from_0_instead: diag(2614, 1 /* Error */ , "Module_0_has_no_exported_member_1_Did_you_mean_to_use_import_1_from_0_instead_2614", "Module '{0}' has no exported member '{1}'. Did you mean to use 'import {1} from {0}' instead?"),
                Type_of_property_0_circularly_references_itself_in_mapped_type_1: diag(2615, 1 /* Error */ , "Type_of_property_0_circularly_references_itself_in_mapped_type_1_2615", "Type of property '{0}' circularly references itself in mapped type '{1}'."),
                _0_can_only_be_imported_by_using_import_1_require_2_or_a_default_import: diag(2616, 1 /* Error */ , "_0_can_only_be_imported_by_using_import_1_require_2_or_a_default_import_2616", "'{0}' can only be imported by using 'import {1} = require({2})' or a default import."),
                _0_can_only_be_imported_by_using_import_1_require_2_or_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import: diag(2617, 1 /* Error */ , "_0_can_only_be_imported_by_using_import_1_require_2_or_by_turning_on_the_esModuleInterop_flag_and_us_2617", "'{0}' can only be imported by using 'import {1} = require({2})' or by turning on the 'esModuleInterop' flag and using a default import."),
                Source_has_0_element_s_but_target_requires_1: diag(2618, 1 /* Error */ , "Source_has_0_element_s_but_target_requires_1_2618", "Source has {0} element(s) but target requires {1}."),
                Source_has_0_element_s_but_target_allows_only_1: diag(2619, 1 /* Error */ , "Source_has_0_element_s_but_target_allows_only_1_2619", "Source has {0} element(s) but target allows only {1}."),
                Target_requires_0_element_s_but_source_may_have_fewer: diag(2620, 1 /* Error */ , "Target_requires_0_element_s_but_source_may_have_fewer_2620", "Target requires {0} element(s) but source may have fewer."),
                Target_allows_only_0_element_s_but_source_may_have_more: diag(2621, 1 /* Error */ , "Target_allows_only_0_element_s_but_source_may_have_more_2621", "Target allows only {0} element(s) but source may have more."),
                Source_provides_no_match_for_required_element_at_position_0_in_target: diag(2623, 1 /* Error */ , "Source_provides_no_match_for_required_element_at_position_0_in_target_2623", "Source provides no match for required element at position {0} in target."),
                Source_provides_no_match_for_variadic_element_at_position_0_in_target: diag(2624, 1 /* Error */ , "Source_provides_no_match_for_variadic_element_at_position_0_in_target_2624", "Source provides no match for variadic element at position {0} in target."),
                Variadic_element_at_position_0_in_source_does_not_match_element_at_position_1_in_target: diag(2625, 1 /* Error */ , "Variadic_element_at_position_0_in_source_does_not_match_element_at_position_1_in_target_2625", "Variadic element at position {0} in source does not match element at position {1} in target."),
                Type_at_position_0_in_source_is_not_compatible_with_type_at_position_1_in_target: diag(2626, 1 /* Error */ , "Type_at_position_0_in_source_is_not_compatible_with_type_at_position_1_in_target_2626", "Type at position {0} in source is not compatible with type at position {1} in target."),
                Type_at_positions_0_through_1_in_source_is_not_compatible_with_type_at_position_2_in_target: diag(2627, 1 /* Error */ , "Type_at_positions_0_through_1_in_source_is_not_compatible_with_type_at_position_2_in_target_2627", "Type at positions {0} through {1} in source is not compatible with type at position {2} in target."),
                Cannot_assign_to_0_because_it_is_an_enum: diag(2628, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_an_enum_2628", "Cannot assign to '{0}' because it is an enum."),
                Cannot_assign_to_0_because_it_is_a_class: diag(2629, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_a_class_2629", "Cannot assign to '{0}' because it is a class."),
                Cannot_assign_to_0_because_it_is_a_function: diag(2630, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_a_function_2630", "Cannot assign to '{0}' because it is a function."),
                Cannot_assign_to_0_because_it_is_a_namespace: diag(2631, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_a_namespace_2631", "Cannot assign to '{0}' because it is a namespace."),
                Cannot_assign_to_0_because_it_is_an_import: diag(2632, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_an_import_2632", "Cannot assign to '{0}' because it is an import."),
                JSX_property_access_expressions_cannot_include_JSX_namespace_names: diag(2633, 1 /* Error */ , "JSX_property_access_expressions_cannot_include_JSX_namespace_names_2633", "JSX property access expressions cannot include JSX namespace names"),
                _0_index_signatures_are_incompatible: diag(2634, 1 /* Error */ , "_0_index_signatures_are_incompatible_2634", "'{0}' index signatures are incompatible."),
                Type_0_has_no_signatures_for_which_the_type_argument_list_is_applicable: diag(2635, 1 /* Error */ , "Type_0_has_no_signatures_for_which_the_type_argument_list_is_applicable_2635", "Type '{0}' has no signatures for which the type argument list is applicable."),
                Type_0_is_not_assignable_to_type_1_as_implied_by_variance_annotation: diag(2636, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_as_implied_by_variance_annotation_2636", "Type '{0}' is not assignable to type '{1}' as implied by variance annotation."),
                Variance_annotations_are_only_supported_in_type_aliases_for_object_function_constructor_and_mapped_types: diag(2637, 1 /* Error */ , "Variance_annotations_are_only_supported_in_type_aliases_for_object_function_constructor_and_mapped_t_2637", "Variance annotations are only supported in type aliases for object, function, constructor, and mapped types."),
                Type_0_may_represent_a_primitive_value_which_is_not_permitted_as_the_right_operand_of_the_in_operator: diag(2638, 1 /* Error */ , "Type_0_may_represent_a_primitive_value_which_is_not_permitted_as_the_right_operand_of_the_in_operato_2638", "Type '{0}' may represent a primitive value, which is not permitted as the right operand of the 'in' operator."),
                React_components_cannot_include_JSX_namespace_names: diag(2639, 1 /* Error */ , "React_components_cannot_include_JSX_namespace_names_2639", "React components cannot include JSX namespace names"),
                Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity: diag(2649, 1 /* Error */ , "Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity_2649", "Cannot augment module '{0}' with value exports because it resolves to a non-module entity."),
                A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_members_defined_in_other_enums: diag(2651, 1 /* Error */ , "A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_memb_2651", "A member initializer in a enum declaration cannot reference members declared after it, including members defined in other enums."),
                Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_default_0_declaration_instead: diag(2652, 1 /* Error */ , "Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_d_2652", "Merged declaration '{0}' cannot include a default export declaration. Consider adding a separate 'export default {0}' declaration instead."),
                Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1: diag(2653, 1 /* Error */ , "Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1_2653", "Non-abstract class expression does not implement inherited abstract member '{0}' from class '{1}'."),
                JSX_expressions_must_have_one_parent_element: diag(2657, 1 /* Error */ , "JSX_expressions_must_have_one_parent_element_2657", "JSX expressions must have one parent element."),
                Type_0_provides_no_match_for_the_signature_1: diag(2658, 1 /* Error */ , "Type_0_provides_no_match_for_the_signature_1_2658", "Type '{0}' provides no match for the signature '{1}'."),
                super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_higher: diag(2659, 1 /* Error */ , "super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_highe_2659", "'super' is only allowed in members of object literal expressions when option 'target' is 'ES2015' or higher."),
                super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions: diag(2660, 1 /* Error */ , "super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions_2660", "'super' can only be referenced in members of derived classes or object literal expressions."),
                Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module: diag(2661, 1 /* Error */ , "Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module_2661", "Cannot export '{0}'. Only local declarations can be exported from a module."),
                Cannot_find_name_0_Did_you_mean_the_static_member_1_0: diag(2662, 1 /* Error */ , "Cannot_find_name_0_Did_you_mean_the_static_member_1_0_2662", "Cannot find name '{0}'. Did you mean the static member '{1}.{0}'?"),
                Cannot_find_name_0_Did_you_mean_the_instance_member_this_0: diag(2663, 1 /* Error */ , "Cannot_find_name_0_Did_you_mean_the_instance_member_this_0_2663", "Cannot find name '{0}'. Did you mean the instance member 'this.{0}'?"),
                Invalid_module_name_in_augmentation_module_0_cannot_be_found: diag(2664, 1 /* Error */ , "Invalid_module_name_in_augmentation_module_0_cannot_be_found_2664", "Invalid module name in augmentation, module '{0}' cannot be found."),
                Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augmented: diag(2665, 1 /* Error */ , "Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augm_2665", "Invalid module name in augmentation. Module '{0}' resolves to an untyped module at '{1}', which cannot be augmented."),
                Exports_and_export_assignments_are_not_permitted_in_module_augmentations: diag(2666, 1 /* Error */ , "Exports_and_export_assignments_are_not_permitted_in_module_augmentations_2666", "Exports and export assignments are not permitted in module augmentations."),
                Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_module: diag(2667, 1 /* Error */ , "Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_mod_2667", "Imports are not permitted in module augmentations. Consider moving them to the enclosing external module."),
                export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always_visible: diag(2668, 1 /* Error */ , "export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always__2668", "'export' modifier cannot be applied to ambient modules and module augmentations since they are always visible."),
                Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations: diag(2669, 1 /* Error */ , "Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_2669", "Augmentations for the global scope can only be directly nested in external modules or ambient module declarations."),
                Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambient_context: diag(2670, 1 /* Error */ , "Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambien_2670", "Augmentations for the global scope should have 'declare' modifier unless they appear in already ambient context."),
                Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity: diag(2671, 1 /* Error */ , "Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity_2671", "Cannot augment module '{0}' because it resolves to a non-module entity."),
                Cannot_assign_a_0_constructor_type_to_a_1_constructor_type: diag(2672, 1 /* Error */ , "Cannot_assign_a_0_constructor_type_to_a_1_constructor_type_2672", "Cannot assign a '{0}' constructor type to a '{1}' constructor type."),
                Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration: diag(2673, 1 /* Error */ , "Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration_2673", "Constructor of class '{0}' is private and only accessible within the class declaration."),
                Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration: diag(2674, 1 /* Error */ , "Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration_2674", "Constructor of class '{0}' is protected and only accessible within the class declaration."),
                Cannot_extend_a_class_0_Class_constructor_is_marked_as_private: diag(2675, 1 /* Error */ , "Cannot_extend_a_class_0_Class_constructor_is_marked_as_private_2675", "Cannot extend a class '{0}'. Class constructor is marked as private."),
                Accessors_must_both_be_abstract_or_non_abstract: diag(2676, 1 /* Error */ , "Accessors_must_both_be_abstract_or_non_abstract_2676", "Accessors must both be abstract or non-abstract."),
                A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type: diag(2677, 1 /* Error */ , "A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type_2677", "A type predicate's type must be assignable to its parameter's type."),
                Type_0_is_not_comparable_to_type_1: diag(2678, 1 /* Error */ , "Type_0_is_not_comparable_to_type_1_2678", "Type '{0}' is not comparable to type '{1}'."),
                A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void: diag(2679, 1 /* Error */ , "A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void_2679", "A function that is called with the 'new' keyword cannot have a 'this' type that is 'void'."),
                A_0_parameter_must_be_the_first_parameter: diag(2680, 1 /* Error */ , "A_0_parameter_must_be_the_first_parameter_2680", "A '{0}' parameter must be the first parameter."),
                A_constructor_cannot_have_a_this_parameter: diag(2681, 1 /* Error */ , "A_constructor_cannot_have_a_this_parameter_2681", "A constructor cannot have a 'this' parameter."),
                this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation: diag(2683, 1 /* Error */ , "this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_2683", "'this' implicitly has type 'any' because it does not have a type annotation."),
                The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1: diag(2684, 1 /* Error */ , "The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1_2684", "The 'this' context of type '{0}' is not assignable to method's 'this' of type '{1}'."),
                The_this_types_of_each_signature_are_incompatible: diag(2685, 1 /* Error */ , "The_this_types_of_each_signature_are_incompatible_2685", "The 'this' types of each signature are incompatible."),
                _0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead: diag(2686, 1 /* Error */ , "_0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead_2686", "'{0}' refers to a UMD global, but the current file is a module. Consider adding an import instead."),
                All_declarations_of_0_must_have_identical_modifiers: diag(2687, 1 /* Error */ , "All_declarations_of_0_must_have_identical_modifiers_2687", "All declarations of '{0}' must have identical modifiers."),
                Cannot_find_type_definition_file_for_0: diag(2688, 1 /* Error */ , "Cannot_find_type_definition_file_for_0_2688", "Cannot find type definition file for '{0}'."),
                Cannot_extend_an_interface_0_Did_you_mean_implements: diag(2689, 1 /* Error */ , "Cannot_extend_an_interface_0_Did_you_mean_implements_2689", "Cannot extend an interface '{0}'. Did you mean 'implements'?"),
                _0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Did_you_mean_to_use_1_in_0: diag(2690, 1 /* Error */ , "_0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Did_you_mean_to_use_1_in_0_2690", "'{0}' only refers to a type, but is being used as a value here. Did you mean to use '{1} in {0}'?"),
                _0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible: diag(2692, 1 /* Error */ , "_0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible_2692", "'{0}' is a primitive, but '{1}' is a wrapper object. Prefer using '{0}' when possible."),
                _0_only_refers_to_a_type_but_is_being_used_as_a_value_here: diag(2693, 1 /* Error */ , "_0_only_refers_to_a_type_but_is_being_used_as_a_value_here_2693", "'{0}' only refers to a type, but is being used as a value here."),
                Namespace_0_has_no_exported_member_1: diag(2694, 1 /* Error */ , "Namespace_0_has_no_exported_member_1_2694", "Namespace '{0}' has no exported member '{1}'."),
                Left_side_of_comma_operator_is_unused_and_has_no_side_effects: diag(2695, 1 /* Error */ , "Left_side_of_comma_operator_is_unused_and_has_no_side_effects_2695", "Left side of comma operator is unused and has no side effects.", /*reportsUnnecessary*/ true),
                The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead: diag(2696, 1 /* Error */ , "The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead_2696", "The 'Object' type is assignable to very few other types. Did you mean to use the 'any' type instead?"),
                An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option: diag(2697, 1 /* Error */ , "An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_in_2697", "An async function or method must return a 'Promise'. Make sure you have a declaration for 'Promise' or include 'ES2015' in your '--lib' option."),
                Spread_types_may_only_be_created_from_object_types: diag(2698, 1 /* Error */ , "Spread_types_may_only_be_created_from_object_types_2698", "Spread types may only be created from object types."),
                Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1: diag(2699, 1 /* Error */ , "Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1_2699", "Static property '{0}' conflicts with built-in property 'Function.{0}' of constructor function '{1}'."),
                Rest_types_may_only_be_created_from_object_types: diag(2700, 1 /* Error */ , "Rest_types_may_only_be_created_from_object_types_2700", "Rest types may only be created from object types."),
                The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access: diag(2701, 1 /* Error */ , "The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access_2701", "The target of an object rest assignment must be a variable or a property access."),
                _0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here: diag(2702, 1 /* Error */ , "_0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here_2702", "'{0}' only refers to a type, but is being used as a namespace here."),
                The_operand_of_a_delete_operator_must_be_a_property_reference: diag(2703, 1 /* Error */ , "The_operand_of_a_delete_operator_must_be_a_property_reference_2703", "The operand of a 'delete' operator must be a property reference."),
                The_operand_of_a_delete_operator_cannot_be_a_read_only_property: diag(2704, 1 /* Error */ , "The_operand_of_a_delete_operator_cannot_be_a_read_only_property_2704", "The operand of a 'delete' operator cannot be a read-only property."),
                An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option: diag(2705, 1 /* Error */ , "An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_de_2705", "An async function or method in ES5/ES3 requires the 'Promise' constructor.  Make sure you have a declaration for the 'Promise' constructor or include 'ES2015' in your '--lib' option."),
                Required_type_parameters_may_not_follow_optional_type_parameters: diag(2706, 1 /* Error */ , "Required_type_parameters_may_not_follow_optional_type_parameters_2706", "Required type parameters may not follow optional type parameters."),
                Generic_type_0_requires_between_1_and_2_type_arguments: diag(2707, 1 /* Error */ , "Generic_type_0_requires_between_1_and_2_type_arguments_2707", "Generic type '{0}' requires between {1} and {2} type arguments."),
                Cannot_use_namespace_0_as_a_value: diag(2708, 1 /* Error */ , "Cannot_use_namespace_0_as_a_value_2708", "Cannot use namespace '{0}' as a value."),
                Cannot_use_namespace_0_as_a_type: diag(2709, 1 /* Error */ , "Cannot_use_namespace_0_as_a_type_2709", "Cannot use namespace '{0}' as a type."),
                _0_are_specified_twice_The_attribute_named_0_will_be_overwritten: diag(2710, 1 /* Error */ , "_0_are_specified_twice_The_attribute_named_0_will_be_overwritten_2710", "'{0}' are specified twice. The attribute named '{0}' will be overwritten."),
                A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option: diag(2711, 1 /* Error */ , "A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES20_2711", "A dynamic import call returns a 'Promise'. Make sure you have a declaration for 'Promise' or include 'ES2015' in your '--lib' option."),
                A_dynamic_import_call_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option: diag(2712, 1 /* Error */ , "A_dynamic_import_call_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declarat_2712", "A dynamic import call in ES5/ES3 requires the 'Promise' constructor.  Make sure you have a declaration for the 'Promise' constructor or include 'ES2015' in your '--lib' option."),
                Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1: diag(2713, 1 /* Error */ , "Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_p_2713", `Cannot access '{0}.{1}' because '{0}' is a type, but not a namespace. Did you mean to retrieve the type of the property '{1}' in '{0}' with '{0}["{1}"]'?`),
                The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context: diag(2714, 1 /* Error */ , "The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context_2714", "The expression of an export assignment must be an identifier or qualified name in an ambient context."),
                Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor: diag(2715, 1 /* Error */ , "Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor_2715", "Abstract property '{0}' in class '{1}' cannot be accessed in the constructor."),
                Type_parameter_0_has_a_circular_default: diag(2716, 1 /* Error */ , "Type_parameter_0_has_a_circular_default_2716", "Type parameter '{0}' has a circular default."),
                Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_type_2: diag(2717, 1 /* Error */ , "Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_t_2717", "Subsequent property declarations must have the same type.  Property '{0}' must be of type '{1}', but here has type '{2}'."),
                Duplicate_property_0: diag(2718, 1 /* Error */ , "Duplicate_property_0_2718", "Duplicate property '{0}'."),
                Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated: diag(2719, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated_2719", "Type '{0}' is not assignable to type '{1}'. Two different types with this name exist, but they are unrelated."),
                Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass: diag(2720, 1 /* Error */ , "Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclas_2720", "Class '{0}' incorrectly implements class '{1}'. Did you mean to extend '{1}' and inherit its members as a subclass?"),
                Cannot_invoke_an_object_which_is_possibly_null: diag(2721, 1 /* Error */ , "Cannot_invoke_an_object_which_is_possibly_null_2721", "Cannot invoke an object which is possibly 'null'."),
                Cannot_invoke_an_object_which_is_possibly_undefined: diag(2722, 1 /* Error */ , "Cannot_invoke_an_object_which_is_possibly_undefined_2722", "Cannot invoke an object which is possibly 'undefined'."),
                Cannot_invoke_an_object_which_is_possibly_null_or_undefined: diag(2723, 1 /* Error */ , "Cannot_invoke_an_object_which_is_possibly_null_or_undefined_2723", "Cannot invoke an object which is possibly 'null' or 'undefined'."),
                _0_has_no_exported_member_named_1_Did_you_mean_2: diag(2724, 1 /* Error */ , "_0_has_no_exported_member_named_1_Did_you_mean_2_2724", "'{0}' has no exported member named '{1}'. Did you mean '{2}'?"),
                Class_name_cannot_be_Object_when_targeting_ES5_with_module_0: diag(2725, 1 /* Error */ , "Class_name_cannot_be_Object_when_targeting_ES5_with_module_0_2725", "Class name cannot be 'Object' when targeting ES5 with module {0}."),
                Cannot_find_lib_definition_for_0: diag(2726, 1 /* Error */ , "Cannot_find_lib_definition_for_0_2726", "Cannot find lib definition for '{0}'."),
                Cannot_find_lib_definition_for_0_Did_you_mean_1: diag(2727, 1 /* Error */ , "Cannot_find_lib_definition_for_0_Did_you_mean_1_2727", "Cannot find lib definition for '{0}'. Did you mean '{1}'?"),
                _0_is_declared_here: diag(2728, 3 /* Message */ , "_0_is_declared_here_2728", "'{0}' is declared here."),
                Property_0_is_used_before_its_initialization: diag(2729, 1 /* Error */ , "Property_0_is_used_before_its_initialization_2729", "Property '{0}' is used before its initialization."),
                An_arrow_function_cannot_have_a_this_parameter: diag(2730, 1 /* Error */ , "An_arrow_function_cannot_have_a_this_parameter_2730", "An arrow function cannot have a 'this' parameter."),
                Implicit_conversion_of_a_symbol_to_a_string_will_fail_at_runtime_Consider_wrapping_this_expression_in_String: diag(2731, 1 /* Error */ , "Implicit_conversion_of_a_symbol_to_a_string_will_fail_at_runtime_Consider_wrapping_this_expression_i_2731", "Implicit conversion of a 'symbol' to a 'string' will fail at runtime. Consider wrapping this expression in 'String(...)'."),
                Cannot_find_module_0_Consider_using_resolveJsonModule_to_import_module_with_json_extension: diag(2732, 1 /* Error */ , "Cannot_find_module_0_Consider_using_resolveJsonModule_to_import_module_with_json_extension_2732", "Cannot find module '{0}'. Consider using '--resolveJsonModule' to import module with '.json' extension."),
                Property_0_was_also_declared_here: diag(2733, 1 /* Error */ , "Property_0_was_also_declared_here_2733", "Property '{0}' was also declared here."),
                Are_you_missing_a_semicolon: diag(2734, 1 /* Error */ , "Are_you_missing_a_semicolon_2734", "Are you missing a semicolon?"),
                Did_you_mean_for_0_to_be_constrained_to_type_new_args_Colon_any_1: diag(2735, 1 /* Error */ , "Did_you_mean_for_0_to_be_constrained_to_type_new_args_Colon_any_1_2735", "Did you mean for '{0}' to be constrained to type 'new (...args: any[]) => {1}'?"),
                Operator_0_cannot_be_applied_to_type_1: diag(2736, 1 /* Error */ , "Operator_0_cannot_be_applied_to_type_1_2736", "Operator '{0}' cannot be applied to type '{1}'."),
                BigInt_literals_are_not_available_when_targeting_lower_than_ES2020: diag(2737, 1 /* Error */ , "BigInt_literals_are_not_available_when_targeting_lower_than_ES2020_2737", "BigInt literals are not available when targeting lower than ES2020."),
                An_outer_value_of_this_is_shadowed_by_this_container: diag(2738, 3 /* Message */ , "An_outer_value_of_this_is_shadowed_by_this_container_2738", "An outer value of 'this' is shadowed by this container."),
                Type_0_is_missing_the_following_properties_from_type_1_Colon_2: diag(2739, 1 /* Error */ , "Type_0_is_missing_the_following_properties_from_type_1_Colon_2_2739", "Type '{0}' is missing the following properties from type '{1}': {2}"),
                Type_0_is_missing_the_following_properties_from_type_1_Colon_2_and_3_more: diag(2740, 1 /* Error */ , "Type_0_is_missing_the_following_properties_from_type_1_Colon_2_and_3_more_2740", "Type '{0}' is missing the following properties from type '{1}': {2}, and {3} more."),
                Property_0_is_missing_in_type_1_but_required_in_type_2: diag(2741, 1 /* Error */ , "Property_0_is_missing_in_type_1_but_required_in_type_2_2741", "Property '{0}' is missing in type '{1}' but required in type '{2}'."),
                The_inferred_type_of_0_cannot_be_named_without_a_reference_to_1_This_is_likely_not_portable_A_type_annotation_is_necessary: diag(2742, 1 /* Error */ , "The_inferred_type_of_0_cannot_be_named_without_a_reference_to_1_This_is_likely_not_portable_A_type_a_2742", "The inferred type of '{0}' cannot be named without a reference to '{1}'. This is likely not portable. A type annotation is necessary."),
                No_overload_expects_0_type_arguments_but_overloads_do_exist_that_expect_either_1_or_2_type_arguments: diag(2743, 1 /* Error */ , "No_overload_expects_0_type_arguments_but_overloads_do_exist_that_expect_either_1_or_2_type_arguments_2743", "No overload expects {0} type arguments, but overloads do exist that expect either {1} or {2} type arguments."),
                Type_parameter_defaults_can_only_reference_previously_declared_type_parameters: diag(2744, 1 /* Error */ , "Type_parameter_defaults_can_only_reference_previously_declared_type_parameters_2744", "Type parameter defaults can only reference previously declared type parameters."),
                This_JSX_tag_s_0_prop_expects_type_1_which_requires_multiple_children_but_only_a_single_child_was_provided: diag(2745, 1 /* Error */ , "This_JSX_tag_s_0_prop_expects_type_1_which_requires_multiple_children_but_only_a_single_child_was_pr_2745", "This JSX tag's '{0}' prop expects type '{1}' which requires multiple children, but only a single child was provided."),
                This_JSX_tag_s_0_prop_expects_a_single_child_of_type_1_but_multiple_children_were_provided: diag(2746, 1 /* Error */ , "This_JSX_tag_s_0_prop_expects_a_single_child_of_type_1_but_multiple_children_were_provided_2746", "This JSX tag's '{0}' prop expects a single child of type '{1}', but multiple children were provided."),
                _0_components_don_t_accept_text_as_child_elements_Text_in_JSX_has_the_type_string_but_the_expected_type_of_1_is_2: diag(2747, 1 /* Error */ , "_0_components_don_t_accept_text_as_child_elements_Text_in_JSX_has_the_type_string_but_the_expected_t_2747", "'{0}' components don't accept text as child elements. Text in JSX has the type 'string', but the expected type of '{1}' is '{2}'."),
                Cannot_access_ambient_const_enums_when_0_is_enabled: diag(2748, 1 /* Error */ , "Cannot_access_ambient_const_enums_when_0_is_enabled_2748", "Cannot access ambient const enums when '{0}' is enabled."),
                _0_refers_to_a_value_but_is_being_used_as_a_type_here_Did_you_mean_typeof_0: diag(2749, 1 /* Error */ , "_0_refers_to_a_value_but_is_being_used_as_a_type_here_Did_you_mean_typeof_0_2749", "'{0}' refers to a value, but is being used as a type here. Did you mean 'typeof {0}'?"),
                The_implementation_signature_is_declared_here: diag(2750, 1 /* Error */ , "The_implementation_signature_is_declared_here_2750", "The implementation signature is declared here."),
                Circularity_originates_in_type_at_this_location: diag(2751, 1 /* Error */ , "Circularity_originates_in_type_at_this_location_2751", "Circularity originates in type at this location."),
                The_first_export_default_is_here: diag(2752, 1 /* Error */ , "The_first_export_default_is_here_2752", "The first export default is here."),
                Another_export_default_is_here: diag(2753, 1 /* Error */ , "Another_export_default_is_here_2753", "Another export default is here."),
                super_may_not_use_type_arguments: diag(2754, 1 /* Error */ , "super_may_not_use_type_arguments_2754", "'super' may not use type arguments."),
                No_constituent_of_type_0_is_callable: diag(2755, 1 /* Error */ , "No_constituent_of_type_0_is_callable_2755", "No constituent of type '{0}' is callable."),
                Not_all_constituents_of_type_0_are_callable: diag(2756, 1 /* Error */ , "Not_all_constituents_of_type_0_are_callable_2756", "Not all constituents of type '{0}' are callable."),
                Type_0_has_no_call_signatures: diag(2757, 1 /* Error */ , "Type_0_has_no_call_signatures_2757", "Type '{0}' has no call signatures."),
                Each_member_of_the_union_type_0_has_signatures_but_none_of_those_signatures_are_compatible_with_each_other: diag(2758, 1 /* Error */ , "Each_member_of_the_union_type_0_has_signatures_but_none_of_those_signatures_are_compatible_with_each_2758", "Each member of the union type '{0}' has signatures, but none of those signatures are compatible with each other."),
                No_constituent_of_type_0_is_constructable: diag(2759, 1 /* Error */ , "No_constituent_of_type_0_is_constructable_2759", "No constituent of type '{0}' is constructable."),
                Not_all_constituents_of_type_0_are_constructable: diag(2760, 1 /* Error */ , "Not_all_constituents_of_type_0_are_constructable_2760", "Not all constituents of type '{0}' are constructable."),
                Type_0_has_no_construct_signatures: diag(2761, 1 /* Error */ , "Type_0_has_no_construct_signatures_2761", "Type '{0}' has no construct signatures."),
                Each_member_of_the_union_type_0_has_construct_signatures_but_none_of_those_signatures_are_compatible_with_each_other: diag(2762, 1 /* Error */ , "Each_member_of_the_union_type_0_has_construct_signatures_but_none_of_those_signatures_are_compatible_2762", "Each member of the union type '{0}' has construct signatures, but none of those signatures are compatible with each other."),
                Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_for_of_will_always_send_0: diag(2763, 1 /* Error */ , "Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_for_of_will_always_s_2763", "Cannot iterate value because the 'next' method of its iterator expects type '{1}', but for-of will always send '{0}'."),
                Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_spread_will_always_send_0: diag(2764, 1 /* Error */ , "Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_spread_will_al_2764", "Cannot iterate value because the 'next' method of its iterator expects type '{1}', but array spread will always send '{0}'."),
                Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_destructuring_will_always_send_0: diag(2765, 1 /* Error */ , "Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_destructuring__2765", "Cannot iterate value because the 'next' method of its iterator expects type '{1}', but array destructuring will always send '{0}'."),
                Cannot_delegate_iteration_to_value_because_the_next_method_of_its_iterator_expects_type_1_but_the_containing_generator_will_always_send_0: diag(2766, 1 /* Error */ , "Cannot_delegate_iteration_to_value_because_the_next_method_of_its_iterator_expects_type_1_but_the_co_2766", "Cannot delegate iteration to value because the 'next' method of its iterator expects type '{1}', but the containing generator will always send '{0}'."),
                The_0_property_of_an_iterator_must_be_a_method: diag(2767, 1 /* Error */ , "The_0_property_of_an_iterator_must_be_a_method_2767", "The '{0}' property of an iterator must be a method."),
                The_0_property_of_an_async_iterator_must_be_a_method: diag(2768, 1 /* Error */ , "The_0_property_of_an_async_iterator_must_be_a_method_2768", "The '{0}' property of an async iterator must be a method."),
                No_overload_matches_this_call: diag(2769, 1 /* Error */ , "No_overload_matches_this_call_2769", "No overload matches this call."),
                The_last_overload_gave_the_following_error: diag(2770, 1 /* Error */ , "The_last_overload_gave_the_following_error_2770", "The last overload gave the following error."),
                The_last_overload_is_declared_here: diag(2771, 1 /* Error */ , "The_last_overload_is_declared_here_2771", "The last overload is declared here."),
                Overload_0_of_1_2_gave_the_following_error: diag(2772, 1 /* Error */ , "Overload_0_of_1_2_gave_the_following_error_2772", "Overload {0} of {1}, '{2}', gave the following error."),
                Did_you_forget_to_use_await: diag(2773, 1 /* Error */ , "Did_you_forget_to_use_await_2773", "Did you forget to use 'await'?"),
                This_condition_will_always_return_true_since_this_function_is_always_defined_Did_you_mean_to_call_it_instead: diag(2774, 1 /* Error */ , "This_condition_will_always_return_true_since_this_function_is_always_defined_Did_you_mean_to_call_it_2774", "This condition will always return true since this function is always defined. Did you mean to call it instead?"),
                Assertions_require_every_name_in_the_call_target_to_be_declared_with_an_explicit_type_annotation: diag(2775, 1 /* Error */ , "Assertions_require_every_name_in_the_call_target_to_be_declared_with_an_explicit_type_annotation_2775", "Assertions require every name in the call target to be declared with an explicit type annotation."),
                Assertions_require_the_call_target_to_be_an_identifier_or_qualified_name: diag(2776, 1 /* Error */ , "Assertions_require_the_call_target_to_be_an_identifier_or_qualified_name_2776", "Assertions require the call target to be an identifier or qualified name."),
                The_operand_of_an_increment_or_decrement_operator_may_not_be_an_optional_property_access: diag(2777, 1 /* Error */ , "The_operand_of_an_increment_or_decrement_operator_may_not_be_an_optional_property_access_2777", "The operand of an increment or decrement operator may not be an optional property access."),
                The_target_of_an_object_rest_assignment_may_not_be_an_optional_property_access: diag(2778, 1 /* Error */ , "The_target_of_an_object_rest_assignment_may_not_be_an_optional_property_access_2778", "The target of an object rest assignment may not be an optional property access."),
                The_left_hand_side_of_an_assignment_expression_may_not_be_an_optional_property_access: diag(2779, 1 /* Error */ , "The_left_hand_side_of_an_assignment_expression_may_not_be_an_optional_property_access_2779", "The left-hand side of an assignment expression may not be an optional property access."),
                The_left_hand_side_of_a_for_in_statement_may_not_be_an_optional_property_access: diag(2780, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_may_not_be_an_optional_property_access_2780", "The left-hand side of a 'for...in' statement may not be an optional property access."),
                The_left_hand_side_of_a_for_of_statement_may_not_be_an_optional_property_access: diag(2781, 1 /* Error */ , "The_left_hand_side_of_a_for_of_statement_may_not_be_an_optional_property_access_2781", "The left-hand side of a 'for...of' statement may not be an optional property access."),
                _0_needs_an_explicit_type_annotation: diag(2782, 3 /* Message */ , "_0_needs_an_explicit_type_annotation_2782", "'{0}' needs an explicit type annotation."),
                _0_is_specified_more_than_once_so_this_usage_will_be_overwritten: diag(2783, 1 /* Error */ , "_0_is_specified_more_than_once_so_this_usage_will_be_overwritten_2783", "'{0}' is specified more than once, so this usage will be overwritten."),
                get_and_set_accessors_cannot_declare_this_parameters: diag(2784, 1 /* Error */ , "get_and_set_accessors_cannot_declare_this_parameters_2784", "'get' and 'set' accessors cannot declare 'this' parameters."),
                This_spread_always_overwrites_this_property: diag(2785, 1 /* Error */ , "This_spread_always_overwrites_this_property_2785", "This spread always overwrites this property."),
                _0_cannot_be_used_as_a_JSX_component: diag(2786, 1 /* Error */ , "_0_cannot_be_used_as_a_JSX_component_2786", "'{0}' cannot be used as a JSX component."),
                Its_return_type_0_is_not_a_valid_JSX_element: diag(2787, 1 /* Error */ , "Its_return_type_0_is_not_a_valid_JSX_element_2787", "Its return type '{0}' is not a valid JSX element."),
                Its_instance_type_0_is_not_a_valid_JSX_element: diag(2788, 1 /* Error */ , "Its_instance_type_0_is_not_a_valid_JSX_element_2788", "Its instance type '{0}' is not a valid JSX element."),
                Its_element_type_0_is_not_a_valid_JSX_element: diag(2789, 1 /* Error */ , "Its_element_type_0_is_not_a_valid_JSX_element_2789", "Its element type '{0}' is not a valid JSX element."),
                The_operand_of_a_delete_operator_must_be_optional: diag(2790, 1 /* Error */ , "The_operand_of_a_delete_operator_must_be_optional_2790", "The operand of a 'delete' operator must be optional."),
                Exponentiation_cannot_be_performed_on_bigint_values_unless_the_target_option_is_set_to_es2016_or_later: diag(2791, 1 /* Error */ , "Exponentiation_cannot_be_performed_on_bigint_values_unless_the_target_option_is_set_to_es2016_or_lat_2791", "Exponentiation cannot be performed on 'bigint' values unless the 'target' option is set to 'es2016' or later."),
                Cannot_find_module_0_Did_you_mean_to_set_the_moduleResolution_option_to_nodenext_or_to_add_aliases_to_the_paths_option: diag(2792, 1 /* Error */ , "Cannot_find_module_0_Did_you_mean_to_set_the_moduleResolution_option_to_nodenext_or_to_add_aliases_t_2792", "Cannot find module '{0}'. Did you mean to set the 'moduleResolution' option to 'nodenext', or to add aliases to the 'paths' option?"),
                The_call_would_have_succeeded_against_this_implementation_but_implementation_signatures_of_overloads_are_not_externally_visible: diag(2793, 1 /* Error */ , "The_call_would_have_succeeded_against_this_implementation_but_implementation_signatures_of_overloads_2793", "The call would have succeeded against this implementation, but implementation signatures of overloads are not externally visible."),
                Expected_0_arguments_but_got_1_Did_you_forget_to_include_void_in_your_type_argument_to_Promise: diag(2794, 1 /* Error */ , "Expected_0_arguments_but_got_1_Did_you_forget_to_include_void_in_your_type_argument_to_Promise_2794", "Expected {0} arguments, but got {1}. Did you forget to include 'void' in your type argument to 'Promise'?"),
                The_intrinsic_keyword_can_only_be_used_to_declare_compiler_provided_intrinsic_types: diag(2795, 1 /* Error */ , "The_intrinsic_keyword_can_only_be_used_to_declare_compiler_provided_intrinsic_types_2795", "The 'intrinsic' keyword can only be used to declare compiler provided intrinsic types."),
                It_is_likely_that_you_are_missing_a_comma_to_separate_these_two_template_expressions_They_form_a_tagged_template_expression_which_cannot_be_invoked: diag(2796, 1 /* Error */ , "It_is_likely_that_you_are_missing_a_comma_to_separate_these_two_template_expressions_They_form_a_tag_2796", "It is likely that you are missing a comma to separate these two template expressions. They form a tagged template expression which cannot be invoked."),
                A_mixin_class_that_extends_from_a_type_variable_containing_an_abstract_construct_signature_must_also_be_declared_abstract: diag(2797, 1 /* Error */ , "A_mixin_class_that_extends_from_a_type_variable_containing_an_abstract_construct_signature_must_also_2797", "A mixin class that extends from a type variable containing an abstract construct signature must also be declared 'abstract'."),
                The_declaration_was_marked_as_deprecated_here: diag(2798, 1 /* Error */ , "The_declaration_was_marked_as_deprecated_here_2798", "The declaration was marked as deprecated here."),
                Type_produces_a_tuple_type_that_is_too_large_to_represent: diag(2799, 1 /* Error */ , "Type_produces_a_tuple_type_that_is_too_large_to_represent_2799", "Type produces a tuple type that is too large to represent."),
                Expression_produces_a_tuple_type_that_is_too_large_to_represent: diag(2800, 1 /* Error */ , "Expression_produces_a_tuple_type_that_is_too_large_to_represent_2800", "Expression produces a tuple type that is too large to represent."),
                This_condition_will_always_return_true_since_this_0_is_always_defined: diag(2801, 1 /* Error */ , "This_condition_will_always_return_true_since_this_0_is_always_defined_2801", "This condition will always return true since this '{0}' is always defined."),
                Type_0_can_only_be_iterated_through_when_using_the_downlevelIteration_flag_or_with_a_target_of_es2015_or_higher: diag(2802, 1 /* Error */ , "Type_0_can_only_be_iterated_through_when_using_the_downlevelIteration_flag_or_with_a_target_of_es201_2802", "Type '{0}' can only be iterated through when using the '--downlevelIteration' flag or with a '--target' of 'es2015' or higher."),
                Cannot_assign_to_private_method_0_Private_methods_are_not_writable: diag(2803, 1 /* Error */ , "Cannot_assign_to_private_method_0_Private_methods_are_not_writable_2803", "Cannot assign to private method '{0}'. Private methods are not writable."),
                Duplicate_identifier_0_Static_and_instance_elements_cannot_share_the_same_private_name: diag(2804, 1 /* Error */ , "Duplicate_identifier_0_Static_and_instance_elements_cannot_share_the_same_private_name_2804", "Duplicate identifier '{0}'. Static and instance elements cannot share the same private name."),
                Private_accessor_was_defined_without_a_getter: diag(2806, 1 /* Error */ , "Private_accessor_was_defined_without_a_getter_2806", "Private accessor was defined without a getter."),
                This_syntax_requires_an_imported_helper_named_1_with_2_parameters_which_is_not_compatible_with_the_one_in_0_Consider_upgrading_your_version_of_0: diag(2807, 1 /* Error */ , "This_syntax_requires_an_imported_helper_named_1_with_2_parameters_which_is_not_compatible_with_the_o_2807", "This syntax requires an imported helper named '{1}' with {2} parameters, which is not compatible with the one in '{0}'. Consider upgrading your version of '{0}'."),
                A_get_accessor_must_be_at_least_as_accessible_as_the_setter: diag(2808, 1 /* Error */ , "A_get_accessor_must_be_at_least_as_accessible_as_the_setter_2808", "A get accessor must be at least as accessible as the setter"),
                Declaration_or_statement_expected_This_follows_a_block_of_statements_so_if_you_intended_to_write_a_destructuring_assignment_you_might_need_to_wrap_the_whole_assignment_in_parentheses: diag(2809, 1 /* Error */ , "Declaration_or_statement_expected_This_follows_a_block_of_statements_so_if_you_intended_to_write_a_d_2809", "Declaration or statement expected. This '=' follows a block of statements, so if you intended to write a destructuring assignment, you might need to wrap the whole assignment in parentheses."),
                Expected_1_argument_but_got_0_new_Promise_needs_a_JSDoc_hint_to_produce_a_resolve_that_can_be_called_without_arguments: diag(2810, 1 /* Error */ , "Expected_1_argument_but_got_0_new_Promise_needs_a_JSDoc_hint_to_produce_a_resolve_that_can_be_called_2810", "Expected 1 argument, but got 0. 'new Promise()' needs a JSDoc hint to produce a 'resolve' that can be called without arguments."),
                Initializer_for_property_0: diag(2811, 1 /* Error */ , "Initializer_for_property_0_2811", "Initializer for property '{0}'"),
                Property_0_does_not_exist_on_type_1_Try_changing_the_lib_compiler_option_to_include_dom: diag(2812, 1 /* Error */ , "Property_0_does_not_exist_on_type_1_Try_changing_the_lib_compiler_option_to_include_dom_2812", "Property '{0}' does not exist on type '{1}'. Try changing the 'lib' compiler option to include 'dom'."),
                Class_declaration_cannot_implement_overload_list_for_0: diag(2813, 1 /* Error */ , "Class_declaration_cannot_implement_overload_list_for_0_2813", "Class declaration cannot implement overload list for '{0}'."),
                Function_with_bodies_can_only_merge_with_classes_that_are_ambient: diag(2814, 1 /* Error */ , "Function_with_bodies_can_only_merge_with_classes_that_are_ambient_2814", "Function with bodies can only merge with classes that are ambient."),
                arguments_cannot_be_referenced_in_property_initializers: diag(2815, 1 /* Error */ , "arguments_cannot_be_referenced_in_property_initializers_2815", "'arguments' cannot be referenced in property initializers."),
                Cannot_use_this_in_a_static_property_initializer_of_a_decorated_class: diag(2816, 1 /* Error */ , "Cannot_use_this_in_a_static_property_initializer_of_a_decorated_class_2816", "Cannot use 'this' in a static property initializer of a decorated class."),
                Property_0_has_no_initializer_and_is_not_definitely_assigned_in_a_class_static_block: diag(2817, 1 /* Error */ , "Property_0_has_no_initializer_and_is_not_definitely_assigned_in_a_class_static_block_2817", "Property '{0}' has no initializer and is not definitely assigned in a class static block."),
                Duplicate_identifier_0_Compiler_reserves_name_1_when_emitting_super_references_in_static_initializers: diag(2818, 1 /* Error */ , "Duplicate_identifier_0_Compiler_reserves_name_1_when_emitting_super_references_in_static_initializer_2818", "Duplicate identifier '{0}'. Compiler reserves name '{1}' when emitting 'super' references in static initializers."),
                Namespace_name_cannot_be_0: diag(2819, 1 /* Error */ , "Namespace_name_cannot_be_0_2819", "Namespace name cannot be '{0}'."),
                Type_0_is_not_assignable_to_type_1_Did_you_mean_2: diag(2820, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_Did_you_mean_2_2820", "Type '{0}' is not assignable to type '{1}'. Did you mean '{2}'?"),
                Import_assertions_are_only_supported_when_the_module_option_is_set_to_esnext_or_nodenext: diag(2821, 1 /* Error */ , "Import_assertions_are_only_supported_when_the_module_option_is_set_to_esnext_or_nodenext_2821", "Import assertions are only supported when the '--module' option is set to 'esnext' or 'nodenext'."),
                Import_assertions_cannot_be_used_with_type_only_imports_or_exports: diag(2822, 1 /* Error */ , "Import_assertions_cannot_be_used_with_type_only_imports_or_exports_2822", "Import assertions cannot be used with type-only imports or exports."),
                Cannot_find_namespace_0_Did_you_mean_1: diag(2833, 1 /* Error */ , "Cannot_find_namespace_0_Did_you_mean_1_2833", "Cannot find namespace '{0}'. Did you mean '{1}'?"),
                Relative_import_paths_need_explicit_file_extensions_in_EcmaScript_imports_when_moduleResolution_is_node16_or_nodenext_Consider_adding_an_extension_to_the_import_path: diag(2834, 1 /* Error */ , "Relative_import_paths_need_explicit_file_extensions_in_EcmaScript_imports_when_moduleResolution_is_n_2834", "Relative import paths need explicit file extensions in EcmaScript imports when '--moduleResolution' is 'node16' or 'nodenext'. Consider adding an extension to the import path."),
                Relative_import_paths_need_explicit_file_extensions_in_EcmaScript_imports_when_moduleResolution_is_node16_or_nodenext_Did_you_mean_0: diag(2835, 1 /* Error */ , "Relative_import_paths_need_explicit_file_extensions_in_EcmaScript_imports_when_moduleResolution_is_n_2835", "Relative import paths need explicit file extensions in EcmaScript imports when '--moduleResolution' is 'node16' or 'nodenext'. Did you mean '{0}'?"),
                Import_assertions_are_not_allowed_on_statements_that_transpile_to_commonjs_require_calls: diag(2836, 1 /* Error */ , "Import_assertions_are_not_allowed_on_statements_that_transpile_to_commonjs_require_calls_2836", "Import assertions are not allowed on statements that transpile to commonjs 'require' calls."),
                Import_assertion_values_must_be_string_literal_expressions: diag(2837, 1 /* Error */ , "Import_assertion_values_must_be_string_literal_expressions_2837", "Import assertion values must be string literal expressions."),
                All_declarations_of_0_must_have_identical_constraints: diag(2838, 1 /* Error */ , "All_declarations_of_0_must_have_identical_constraints_2838", "All declarations of '{0}' must have identical constraints."),
                This_condition_will_always_return_0_since_JavaScript_compares_objects_by_reference_not_value: diag(2839, 1 /* Error */ , "This_condition_will_always_return_0_since_JavaScript_compares_objects_by_reference_not_value_2839", "This condition will always return '{0}' since JavaScript compares objects by reference, not value."),
                An_interface_cannot_extend_a_primitive_type_like_0_an_interface_can_only_extend_named_types_and_classes: diag(2840, 1 /* Error */ , "An_interface_cannot_extend_a_primitive_type_like_0_an_interface_can_only_extend_named_types_and_clas_2840", "An interface cannot extend a primitive type like '{0}'; an interface can only extend named types and classes"),
                The_type_of_this_expression_cannot_be_named_without_a_resolution_mode_assertion_which_is_an_unstable_feature_Use_nightly_TypeScript_to_silence_this_error_Try_updating_with_npm_install_D_typescript_next: diag(2841, 1 /* Error */ , "The_type_of_this_expression_cannot_be_named_without_a_resolution_mode_assertion_which_is_an_unstable_2841", "The type of this expression cannot be named without a 'resolution-mode' assertion, which is an unstable feature. Use nightly TypeScript to silence this error. Try updating with 'npm install -D typescript@next'."),
                _0_is_an_unused_renaming_of_1_Did_you_intend_to_use_it_as_a_type_annotation: diag(2842, 1 /* Error */ , "_0_is_an_unused_renaming_of_1_Did_you_intend_to_use_it_as_a_type_annotation_2842", "'{0}' is an unused renaming of '{1}'. Did you intend to use it as a type annotation?"),
                We_can_only_write_a_type_for_0_by_adding_a_type_for_the_entire_parameter_here: diag(2843, 1 /* Error */ , "We_can_only_write_a_type_for_0_by_adding_a_type_for_the_entire_parameter_here_2843", "We can only write a type for '{0}' by adding a type for the entire parameter here."),
                Type_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor: diag(2844, 1 /* Error */ , "Type_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor_2844", "Type of instance member variable '{0}' cannot reference identifier '{1}' declared in the constructor."),
                This_condition_will_always_return_0: diag(2845, 1 /* Error */ , "This_condition_will_always_return_0_2845", "This condition will always return '{0}'."),
                A_declaration_file_cannot_be_imported_without_import_type_Did_you_mean_to_import_an_implementation_file_0_instead: diag(2846, 1 /* Error */ , "A_declaration_file_cannot_be_imported_without_import_type_Did_you_mean_to_import_an_implementation_f_2846", "A declaration file cannot be imported without 'import type'. Did you mean to import an implementation file '{0}' instead?"),
                The_right_hand_side_of_an_instanceof_expression_must_not_be_an_instantiation_expression: diag(2848, 1 /* Error */ , "The_right_hand_side_of_an_instanceof_expression_must_not_be_an_instantiation_expression_2848", "The right-hand side of an 'instanceof' expression must not be an instantiation expression."),
                Target_signature_provides_too_few_arguments_Expected_0_or_more_but_got_1: diag(2849, 1 /* Error */ , "Target_signature_provides_too_few_arguments_Expected_0_or_more_but_got_1_2849", "Target signature provides too few arguments. Expected {0} or more, but got {1}."),
                Import_declaration_0_is_using_private_name_1: diag(4e3, 1 /* Error */ , "Import_declaration_0_is_using_private_name_1_4000", "Import declaration '{0}' is using private name '{1}'."),
                Type_parameter_0_of_exported_class_has_or_is_using_private_name_1: diag(4002, 1 /* Error */ , "Type_parameter_0_of_exported_class_has_or_is_using_private_name_1_4002", "Type parameter '{0}' of exported class has or is using private name '{1}'."),
                Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1: diag(4004, 1 /* Error */ , "Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1_4004", "Type parameter '{0}' of exported interface has or is using private name '{1}'."),
                Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4006, 1 /* Error */ , "Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1_4006", "Type parameter '{0}' of constructor signature from exported interface has or is using private name '{1}'."),
                Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4008, 1 /* Error */ , "Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1_4008", "Type parameter '{0}' of call signature from exported interface has or is using private name '{1}'."),
                Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1: diag(4010, 1 /* Error */ , "Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1_4010", "Type parameter '{0}' of public static method from exported class has or is using private name '{1}'."),
                Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1: diag(4012, 1 /* Error */ , "Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1_4012", "Type parameter '{0}' of public method from exported class has or is using private name '{1}'."),
                Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1: diag(4014, 1 /* Error */ , "Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1_4014", "Type parameter '{0}' of method from exported interface has or is using private name '{1}'."),
                Type_parameter_0_of_exported_function_has_or_is_using_private_name_1: diag(4016, 1 /* Error */ , "Type_parameter_0_of_exported_function_has_or_is_using_private_name_1_4016", "Type parameter '{0}' of exported function has or is using private name '{1}'."),
                Implements_clause_of_exported_class_0_has_or_is_using_private_name_1: diag(4019, 1 /* Error */ , "Implements_clause_of_exported_class_0_has_or_is_using_private_name_1_4019", "Implements clause of exported class '{0}' has or is using private name '{1}'."),
                extends_clause_of_exported_class_0_has_or_is_using_private_name_1: diag(4020, 1 /* Error */ , "extends_clause_of_exported_class_0_has_or_is_using_private_name_1_4020", "'extends' clause of exported class '{0}' has or is using private name '{1}'."),
                extends_clause_of_exported_class_has_or_is_using_private_name_0: diag(4021, 1 /* Error */ , "extends_clause_of_exported_class_has_or_is_using_private_name_0_4021", "'extends' clause of exported class has or is using private name '{0}'."),
                extends_clause_of_exported_interface_0_has_or_is_using_private_name_1: diag(4022, 1 /* Error */ , "extends_clause_of_exported_interface_0_has_or_is_using_private_name_1_4022", "'extends' clause of exported interface '{0}' has or is using private name '{1}'."),
                Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4023, 1 /* Error */ , "Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4023", "Exported variable '{0}' has or is using name '{1}' from external module {2} but cannot be named."),
                Exported_variable_0_has_or_is_using_name_1_from_private_module_2: diag(4024, 1 /* Error */ , "Exported_variable_0_has_or_is_using_name_1_from_private_module_2_4024", "Exported variable '{0}' has or is using name '{1}' from private module '{2}'."),
                Exported_variable_0_has_or_is_using_private_name_1: diag(4025, 1 /* Error */ , "Exported_variable_0_has_or_is_using_private_name_1_4025", "Exported variable '{0}' has or is using private name '{1}'."),
                Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4026, 1 /* Error */ , "Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot__4026", "Public static property '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
                Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4027, 1 /* Error */ , "Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4027", "Public static property '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
                Public_static_property_0_of_exported_class_has_or_is_using_private_name_1: diag(4028, 1 /* Error */ , "Public_static_property_0_of_exported_class_has_or_is_using_private_name_1_4028", "Public static property '{0}' of exported class has or is using private name '{1}'."),
                Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4029, 1 /* Error */ , "Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_name_4029", "Public property '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
                Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4030, 1 /* Error */ , "Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4030", "Public property '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
                Public_property_0_of_exported_class_has_or_is_using_private_name_1: diag(4031, 1 /* Error */ , "Public_property_0_of_exported_class_has_or_is_using_private_name_1_4031", "Public property '{0}' of exported class has or is using private name '{1}'."),
                Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4032, 1 /* Error */ , "Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2_4032", "Property '{0}' of exported interface has or is using name '{1}' from private module '{2}'."),
                Property_0_of_exported_interface_has_or_is_using_private_name_1: diag(4033, 1 /* Error */ , "Property_0_of_exported_interface_has_or_is_using_private_name_1_4033", "Property '{0}' of exported interface has or is using private name '{1}'."),
                Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4034, 1 /* Error */ , "Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_mod_4034", "Parameter type of public static setter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
                Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1: diag(4035, 1 /* Error */ , "Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1_4035", "Parameter type of public static setter '{0}' from exported class has or is using private name '{1}'."),
                Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4036, 1 /* Error */ , "Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2_4036", "Parameter type of public setter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
                Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1: diag(4037, 1 /* Error */ , "Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1_4037", "Parameter type of public setter '{0}' from exported class has or is using private name '{1}'."),
                Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4038, 1 /* Error */ , "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_modul_4038", "Return type of public static getter '{0}' from exported class has or is using name '{1}' from external module {2} but cannot be named."),
                Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4039, 1 /* Error */ , "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_4039", "Return type of public static getter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
                Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1: diag(4040, 1 /* Error */ , "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1_4040", "Return type of public static getter '{0}' from exported class has or is using private name '{1}'."),
                Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4041, 1 /* Error */ , "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_4041", "Return type of public getter '{0}' from exported class has or is using name '{1}' from external module {2} but cannot be named."),
                Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4042, 1 /* Error */ , "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2_4042", "Return type of public getter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
                Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1: diag(4043, 1 /* Error */ , "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1_4043", "Return type of public getter '{0}' from exported class has or is using private name '{1}'."),
                Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4044, 1 /* Error */ , "Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_mod_4044", "Return type of constructor signature from exported interface has or is using name '{0}' from private module '{1}'."),
                Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4045, 1 /* Error */ , "Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0_4045", "Return type of constructor signature from exported interface has or is using private name '{0}'."),
                Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4046, 1 /* Error */ , "Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4046", "Return type of call signature from exported interface has or is using name '{0}' from private module '{1}'."),
                Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4047, 1 /* Error */ , "Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0_4047", "Return type of call signature from exported interface has or is using private name '{0}'."),
                Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4048, 1 /* Error */ , "Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4048", "Return type of index signature from exported interface has or is using name '{0}' from private module '{1}'."),
                Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4049, 1 /* Error */ , "Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0_4049", "Return type of index signature from exported interface has or is using private name '{0}'."),
                Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4050, 1 /* Error */ , "Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module__4050", "Return type of public static method from exported class has or is using name '{0}' from external module {1} but cannot be named."),
                Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1: diag(4051, 1 /* Error */ , "Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1_4051", "Return type of public static method from exported class has or is using name '{0}' from private module '{1}'."),
                Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0: diag(4052, 1 /* Error */ , "Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0_4052", "Return type of public static method from exported class has or is using private name '{0}'."),
                Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4053, 1 /* Error */ , "Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_c_4053", "Return type of public method from exported class has or is using name '{0}' from external module {1} but cannot be named."),
                Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1: diag(4054, 1 /* Error */ , "Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1_4054", "Return type of public method from exported class has or is using name '{0}' from private module '{1}'."),
                Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0: diag(4055, 1 /* Error */ , "Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0_4055", "Return type of public method from exported class has or is using private name '{0}'."),
                Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4056, 1 /* Error */ , "Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4056", "Return type of method from exported interface has or is using name '{0}' from private module '{1}'."),
                Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0: diag(4057, 1 /* Error */ , "Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0_4057", "Return type of method from exported interface has or is using private name '{0}'."),
                Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4058, 1 /* Error */ , "Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named_4058", "Return type of exported function has or is using name '{0}' from external module {1} but cannot be named."),
                Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1: diag(4059, 1 /* Error */ , "Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1_4059", "Return type of exported function has or is using name '{0}' from private module '{1}'."),
                Return_type_of_exported_function_has_or_is_using_private_name_0: diag(4060, 1 /* Error */ , "Return_type_of_exported_function_has_or_is_using_private_name_0_4060", "Return type of exported function has or is using private name '{0}'."),
                Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4061, 1 /* Error */ , "Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_can_4061", "Parameter '{0}' of constructor from exported class has or is using name '{1}' from external module {2} but cannot be named."),
                Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4062, 1 /* Error */ , "Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2_4062", "Parameter '{0}' of constructor from exported class has or is using name '{1}' from private module '{2}'."),
                Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1: diag(4063, 1 /* Error */ , "Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1_4063", "Parameter '{0}' of constructor from exported class has or is using private name '{1}'."),
                Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4064, 1 /* Error */ , "Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_mod_4064", "Parameter '{0}' of constructor signature from exported interface has or is using name '{1}' from private module '{2}'."),
                Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4065, 1 /* Error */ , "Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1_4065", "Parameter '{0}' of constructor signature from exported interface has or is using private name '{1}'."),
                Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4066, 1 /* Error */ , "Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4066", "Parameter '{0}' of call signature from exported interface has or is using name '{1}' from private module '{2}'."),
                Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4067, 1 /* Error */ , "Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1_4067", "Parameter '{0}' of call signature from exported interface has or is using private name '{1}'."),
                Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4068, 1 /* Error */ , "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module__4068", "Parameter '{0}' of public static method from exported class has or is using name '{1}' from external module {2} but cannot be named."),
                Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4069, 1 /* Error */ , "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2_4069", "Parameter '{0}' of public static method from exported class has or is using name '{1}' from private module '{2}'."),
                Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1: diag(4070, 1 /* Error */ , "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1_4070", "Parameter '{0}' of public static method from exported class has or is using private name '{1}'."),
                Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4071, 1 /* Error */ , "Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_c_4071", "Parameter '{0}' of public method from exported class has or is using name '{1}' from external module {2} but cannot be named."),
                Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4072, 1 /* Error */ , "Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2_4072", "Parameter '{0}' of public method from exported class has or is using name '{1}' from private module '{2}'."),
                Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1: diag(4073, 1 /* Error */ , "Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1_4073", "Parameter '{0}' of public method from exported class has or is using private name '{1}'."),
                Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4074, 1 /* Error */ , "Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4074", "Parameter '{0}' of method from exported interface has or is using name '{1}' from private module '{2}'."),
                Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1: diag(4075, 1 /* Error */ , "Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1_4075", "Parameter '{0}' of method from exported interface has or is using private name '{1}'."),
                Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4076, 1 /* Error */ , "Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4076", "Parameter '{0}' of exported function has or is using name '{1}' from external module {2} but cannot be named."),
                Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2: diag(4077, 1 /* Error */ , "Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2_4077", "Parameter '{0}' of exported function has or is using name '{1}' from private module '{2}'."),
                Parameter_0_of_exported_function_has_or_is_using_private_name_1: diag(4078, 1 /* Error */ , "Parameter_0_of_exported_function_has_or_is_using_private_name_1_4078", "Parameter '{0}' of exported function has or is using private name '{1}'."),
                Exported_type_alias_0_has_or_is_using_private_name_1: diag(4081, 1 /* Error */ , "Exported_type_alias_0_has_or_is_using_private_name_1_4081", "Exported type alias '{0}' has or is using private name '{1}'."),
                Default_export_of_the_module_has_or_is_using_private_name_0: diag(4082, 1 /* Error */ , "Default_export_of_the_module_has_or_is_using_private_name_0_4082", "Default export of the module has or is using private name '{0}'."),
                Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1: diag(4083, 1 /* Error */ , "Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1_4083", "Type parameter '{0}' of exported type alias has or is using private name '{1}'."),
                Exported_type_alias_0_has_or_is_using_private_name_1_from_module_2: diag(4084, 1 /* Error */ , "Exported_type_alias_0_has_or_is_using_private_name_1_from_module_2_4084", "Exported type alias '{0}' has or is using private name '{1}' from module {2}."),
                Extends_clause_for_inferred_type_0_has_or_is_using_private_name_1: diag(4085, 1 /* Error */ , "Extends_clause_for_inferred_type_0_has_or_is_using_private_name_1_4085", "Extends clause for inferred type '{0}' has or is using private name '{1}'."),
                Conflicting_definitions_for_0_found_at_1_and_2_Consider_installing_a_specific_version_of_this_library_to_resolve_the_conflict: diag(4090, 1 /* Error */ , "Conflicting_definitions_for_0_found_at_1_and_2_Consider_installing_a_specific_version_of_this_librar_4090", "Conflicting definitions for '{0}' found at '{1}' and '{2}'. Consider installing a specific version of this library to resolve the conflict."),
                Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4091, 1 /* Error */ , "Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4091", "Parameter '{0}' of index signature from exported interface has or is using name '{1}' from private module '{2}'."),
                Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4092, 1 /* Error */ , "Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1_4092", "Parameter '{0}' of index signature from exported interface has or is using private name '{1}'."),
                Property_0_of_exported_class_expression_may_not_be_private_or_protected: diag(4094, 1 /* Error */ , "Property_0_of_exported_class_expression_may_not_be_private_or_protected_4094", "Property '{0}' of exported class expression may not be private or protected."),
                Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4095, 1 /* Error */ , "Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_4095", "Public static method '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
                Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4096, 1 /* Error */ , "Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4096", "Public static method '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
                Public_static_method_0_of_exported_class_has_or_is_using_private_name_1: diag(4097, 1 /* Error */ , "Public_static_method_0_of_exported_class_has_or_is_using_private_name_1_4097", "Public static method '{0}' of exported class has or is using private name '{1}'."),
                Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4098, 1 /* Error */ , "Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4098", "Public method '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
                Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4099, 1 /* Error */ , "Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4099", "Public method '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
                Public_method_0_of_exported_class_has_or_is_using_private_name_1: diag(4100, 1 /* Error */ , "Public_method_0_of_exported_class_has_or_is_using_private_name_1_4100", "Public method '{0}' of exported class has or is using private name '{1}'."),
                Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4101, 1 /* Error */ , "Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2_4101", "Method '{0}' of exported interface has or is using name '{1}' from private module '{2}'."),
                Method_0_of_exported_interface_has_or_is_using_private_name_1: diag(4102, 1 /* Error */ , "Method_0_of_exported_interface_has_or_is_using_private_name_1_4102", "Method '{0}' of exported interface has or is using private name '{1}'."),
                Type_parameter_0_of_exported_mapped_object_type_is_using_private_name_1: diag(4103, 1 /* Error */ , "Type_parameter_0_of_exported_mapped_object_type_is_using_private_name_1_4103", "Type parameter '{0}' of exported mapped object type is using private name '{1}'."),
                The_type_0_is_readonly_and_cannot_be_assigned_to_the_mutable_type_1: diag(4104, 1 /* Error */ , "The_type_0_is_readonly_and_cannot_be_assigned_to_the_mutable_type_1_4104", "The type '{0}' is 'readonly' and cannot be assigned to the mutable type '{1}'."),
                Private_or_protected_member_0_cannot_be_accessed_on_a_type_parameter: diag(4105, 1 /* Error */ , "Private_or_protected_member_0_cannot_be_accessed_on_a_type_parameter_4105", "Private or protected member '{0}' cannot be accessed on a type parameter."),
                Parameter_0_of_accessor_has_or_is_using_private_name_1: diag(4106, 1 /* Error */ , "Parameter_0_of_accessor_has_or_is_using_private_name_1_4106", "Parameter '{0}' of accessor has or is using private name '{1}'."),
                Parameter_0_of_accessor_has_or_is_using_name_1_from_private_module_2: diag(4107, 1 /* Error */ , "Parameter_0_of_accessor_has_or_is_using_name_1_from_private_module_2_4107", "Parameter '{0}' of accessor has or is using name '{1}' from private module '{2}'."),
                Parameter_0_of_accessor_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4108, 1 /* Error */ , "Parameter_0_of_accessor_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4108", "Parameter '{0}' of accessor has or is using name '{1}' from external module '{2}' but cannot be named."),
                Type_arguments_for_0_circularly_reference_themselves: diag(4109, 1 /* Error */ , "Type_arguments_for_0_circularly_reference_themselves_4109", "Type arguments for '{0}' circularly reference themselves."),
                Tuple_type_arguments_circularly_reference_themselves: diag(4110, 1 /* Error */ , "Tuple_type_arguments_circularly_reference_themselves_4110", "Tuple type arguments circularly reference themselves."),
                Property_0_comes_from_an_index_signature_so_it_must_be_accessed_with_0: diag(4111, 1 /* Error */ , "Property_0_comes_from_an_index_signature_so_it_must_be_accessed_with_0_4111", "Property '{0}' comes from an index signature, so it must be accessed with ['{0}']."),
                This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another_class: diag(4112, 1 /* Error */ , "This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another__4112", "This member cannot have an 'override' modifier because its containing class '{0}' does not extend another class."),
                This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0: diag(4113, 1 /* Error */ , "This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0_4113", "This member cannot have an 'override' modifier because it is not declared in the base class '{0}'."),
                This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0: diag(4114, 1 /* Error */ , "This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0_4114", "This member must have an 'override' modifier because it overrides a member in the base class '{0}'."),
                This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0: diag(4115, 1 /* Error */ , "This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0_4115", "This parameter property must have an 'override' modifier because it overrides a member in base class '{0}'."),
                This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared_in_the_base_class_0: diag(4116, 1 /* Error */ , "This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared__4116", "This member must have an 'override' modifier because it overrides an abstract method that is declared in the base class '{0}'."),
                This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1: diag(4117, 1 /* Error */ , "This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0_Did_you__4117", "This member cannot have an 'override' modifier because it is not declared in the base class '{0}'. Did you mean '{1}'?"),
                The_type_of_this_node_cannot_be_serialized_because_its_property_0_cannot_be_serialized: diag(4118, 1 /* Error */ , "The_type_of_this_node_cannot_be_serialized_because_its_property_0_cannot_be_serialized_4118", "The type of this node cannot be serialized because its property '{0}' cannot be serialized."),
                This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0: diag(4119, 1 /* Error */ , "This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_4119", "This member must have a JSDoc comment with an '@override' tag because it overrides a member in the base class '{0}'."),
                This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0: diag(4120, 1 /* Error */ , "This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_4120", "This parameter property must have a JSDoc comment with an '@override' tag because it overrides a member in the base class '{0}'."),
                This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_extend_another_class: diag(4121, 1 /* Error */ , "This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_4121", "This member cannot have a JSDoc comment with an '@override' tag because its containing class '{0}' does not extend another class."),
                This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0: diag(4122, 1 /* Error */ , "This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base__4122", "This member cannot have a JSDoc comment with an '@override' tag because it is not declared in the base class '{0}'."),
                This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1: diag(4123, 1 /* Error */ , "This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base__4123", "This member cannot have a JSDoc comment with an 'override' tag because it is not declared in the base class '{0}'. Did you mean '{1}'?"),
                Compiler_option_0_of_value_1_is_unstable_Use_nightly_TypeScript_to_silence_this_error_Try_updating_with_npm_install_D_typescript_next: diag(4124, 1 /* Error */ , "Compiler_option_0_of_value_1_is_unstable_Use_nightly_TypeScript_to_silence_this_error_Try_updating_w_4124", "Compiler option '{0}' of value '{1}' is unstable. Use nightly TypeScript to silence this error. Try updating with 'npm install -D typescript@next'."),
                resolution_mode_assertions_are_unstable_Use_nightly_TypeScript_to_silence_this_error_Try_updating_with_npm_install_D_typescript_next: diag(4125, 1 /* Error */ , "resolution_mode_assertions_are_unstable_Use_nightly_TypeScript_to_silence_this_error_Try_updating_wi_4125", "'resolution-mode' assertions are unstable. Use nightly TypeScript to silence this error. Try updating with 'npm install -D typescript@next'."),
                The_current_host_does_not_support_the_0_option: diag(5001, 1 /* Error */ , "The_current_host_does_not_support_the_0_option_5001", "The current host does not support the '{0}' option."),
                Cannot_find_the_common_subdirectory_path_for_the_input_files: diag(5009, 1 /* Error */ , "Cannot_find_the_common_subdirectory_path_for_the_input_files_5009", "Cannot find the common subdirectory path for the input files."),
                File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0: diag(5010, 1 /* Error */ , "File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0_5010", "File specification cannot end in a recursive directory wildcard ('**'): '{0}'."),
                Cannot_read_file_0_Colon_1: diag(5012, 1 /* Error */ , "Cannot_read_file_0_Colon_1_5012", "Cannot read file '{0}': {1}."),
                Failed_to_parse_file_0_Colon_1: diag(5014, 1 /* Error */ , "Failed_to_parse_file_0_Colon_1_5014", "Failed to parse file '{0}': {1}."),
                Unknown_compiler_option_0: diag(5023, 1 /* Error */ , "Unknown_compiler_option_0_5023", "Unknown compiler option '{0}'."),
                Compiler_option_0_requires_a_value_of_type_1: diag(5024, 1 /* Error */ , "Compiler_option_0_requires_a_value_of_type_1_5024", "Compiler option '{0}' requires a value of type {1}."),
                Unknown_compiler_option_0_Did_you_mean_1: diag(5025, 1 /* Error */ , "Unknown_compiler_option_0_Did_you_mean_1_5025", "Unknown compiler option '{0}'. Did you mean '{1}'?"),
                Could_not_write_file_0_Colon_1: diag(5033, 1 /* Error */ , "Could_not_write_file_0_Colon_1_5033", "Could not write file '{0}': {1}."),
                Option_project_cannot_be_mixed_with_source_files_on_a_command_line: diag(5042, 1 /* Error */ , "Option_project_cannot_be_mixed_with_source_files_on_a_command_line_5042", "Option 'project' cannot be mixed with source files on a command line."),
                Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES2015_or_higher: diag(5047, 1 /* Error */ , "Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES_5047", "Option 'isolatedModules' can only be used when either option '--module' is provided or option 'target' is 'ES2015' or higher."),
                Option_0_cannot_be_specified_when_option_target_is_ES3: diag(5048, 1 /* Error */ , "Option_0_cannot_be_specified_when_option_target_is_ES3_5048", "Option '{0}' cannot be specified when option 'target' is 'ES3'."),
                Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided: diag(5051, 1 /* Error */ , "Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided_5051", "Option '{0} can only be used when either option '--inlineSourceMap' or option '--sourceMap' is provided."),
                Option_0_cannot_be_specified_without_specifying_option_1: diag(5052, 1 /* Error */ , "Option_0_cannot_be_specified_without_specifying_option_1_5052", "Option '{0}' cannot be specified without specifying option '{1}'."),
                Option_0_cannot_be_specified_with_option_1: diag(5053, 1 /* Error */ , "Option_0_cannot_be_specified_with_option_1_5053", "Option '{0}' cannot be specified with option '{1}'."),
                A_tsconfig_json_file_is_already_defined_at_Colon_0: diag(5054, 1 /* Error */ , "A_tsconfig_json_file_is_already_defined_at_Colon_0_5054", "A 'tsconfig.json' file is already defined at: '{0}'."),
                Cannot_write_file_0_because_it_would_overwrite_input_file: diag(5055, 1 /* Error */ , "Cannot_write_file_0_because_it_would_overwrite_input_file_5055", "Cannot write file '{0}' because it would overwrite input file."),
                Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files: diag(5056, 1 /* Error */ , "Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files_5056", "Cannot write file '{0}' because it would be overwritten by multiple input files."),
                Cannot_find_a_tsconfig_json_file_at_the_specified_directory_Colon_0: diag(5057, 1 /* Error */ , "Cannot_find_a_tsconfig_json_file_at_the_specified_directory_Colon_0_5057", "Cannot find a tsconfig.json file at the specified directory: '{0}'."),
                The_specified_path_does_not_exist_Colon_0: diag(5058, 1 /* Error */ , "The_specified_path_does_not_exist_Colon_0_5058", "The specified path does not exist: '{0}'."),
                Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier: diag(5059, 1 /* Error */ , "Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier_5059", "Invalid value for '--reactNamespace'. '{0}' is not a valid identifier."),
                Pattern_0_can_have_at_most_one_Asterisk_character: diag(5061, 1 /* Error */ , "Pattern_0_can_have_at_most_one_Asterisk_character_5061", "Pattern '{0}' can have at most one '*' character."),
                Substitution_0_in_pattern_1_can_have_at_most_one_Asterisk_character: diag(5062, 1 /* Error */ , "Substitution_0_in_pattern_1_can_have_at_most_one_Asterisk_character_5062", "Substitution '{0}' in pattern '{1}' can have at most one '*' character."),
                Substitutions_for_pattern_0_should_be_an_array: diag(5063, 1 /* Error */ , "Substitutions_for_pattern_0_should_be_an_array_5063", "Substitutions for pattern '{0}' should be an array."),
                Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2: diag(5064, 1 /* Error */ , "Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2_5064", "Substitution '{0}' for pattern '{1}' has incorrect type, expected 'string', got '{2}'."),
                File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0: diag(5065, 1 /* Error */ , "File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildca_5065", "File specification cannot contain a parent directory ('..') that appears after a recursive directory wildcard ('**'): '{0}'."),
                Substitutions_for_pattern_0_shouldn_t_be_an_empty_array: diag(5066, 1 /* Error */ , "Substitutions_for_pattern_0_shouldn_t_be_an_empty_array_5066", "Substitutions for pattern '{0}' shouldn't be an empty array."),
                Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name: diag(5067, 1 /* Error */ , "Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name_5067", "Invalid value for 'jsxFactory'. '{0}' is not a valid identifier or qualified-name."),
                Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript_files_Learn_more_at_https_Colon_Slash_Slashaka_ms_Slashtsconfig: diag(5068, 1 /* Error */ , "Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript__5068", "Adding a tsconfig.json file will help organize projects that contain both TypeScript and JavaScript files. Learn more at https://aka.ms/tsconfig."),
                Option_0_cannot_be_specified_without_specifying_option_1_or_option_2: diag(5069, 1 /* Error */ , "Option_0_cannot_be_specified_without_specifying_option_1_or_option_2_5069", "Option '{0}' cannot be specified without specifying option '{1}' or option '{2}'."),
                Option_resolveJsonModule_cannot_be_specified_when_moduleResolution_is_set_to_classic: diag(5070, 1 /* Error */ , "Option_resolveJsonModule_cannot_be_specified_when_moduleResolution_is_set_to_classic_5070", "Option '--resolveJsonModule' cannot be specified when 'moduleResolution' is set to 'classic'."),
                Option_resolveJsonModule_can_only_be_specified_when_module_code_generation_is_commonjs_amd_es2015_or_esNext: diag(5071, 1 /* Error */ , "Option_resolveJsonModule_can_only_be_specified_when_module_code_generation_is_commonjs_amd_es2015_or_5071", "Option '--resolveJsonModule' can only be specified when module code generation is 'commonjs', 'amd', 'es2015' or 'esNext'."),
                Unknown_build_option_0: diag(5072, 1 /* Error */ , "Unknown_build_option_0_5072", "Unknown build option '{0}'."),
                Build_option_0_requires_a_value_of_type_1: diag(5073, 1 /* Error */ , "Build_option_0_requires_a_value_of_type_1_5073", "Build option '{0}' requires a value of type {1}."),
                Option_incremental_can_only_be_specified_using_tsconfig_emitting_to_single_file_or_when_option_tsBuildInfoFile_is_specified: diag(5074, 1 /* Error */ , "Option_incremental_can_only_be_specified_using_tsconfig_emitting_to_single_file_or_when_option_tsBui_5074", "Option '--incremental' can only be specified using tsconfig, emitting to single file or when option '--tsBuildInfoFile' is specified."),
                _0_is_assignable_to_the_constraint_of_type_1_but_1_could_be_instantiated_with_a_different_subtype_of_constraint_2: diag(5075, 1 /* Error */ , "_0_is_assignable_to_the_constraint_of_type_1_but_1_could_be_instantiated_with_a_different_subtype_of_5075", "'{0}' is assignable to the constraint of type '{1}', but '{1}' could be instantiated with a different subtype of constraint '{2}'."),
                _0_and_1_operations_cannot_be_mixed_without_parentheses: diag(5076, 1 /* Error */ , "_0_and_1_operations_cannot_be_mixed_without_parentheses_5076", "'{0}' and '{1}' operations cannot be mixed without parentheses."),
                Unknown_build_option_0_Did_you_mean_1: diag(5077, 1 /* Error */ , "Unknown_build_option_0_Did_you_mean_1_5077", "Unknown build option '{0}'. Did you mean '{1}'?"),
                Unknown_watch_option_0: diag(5078, 1 /* Error */ , "Unknown_watch_option_0_5078", "Unknown watch option '{0}'."),
                Unknown_watch_option_0_Did_you_mean_1: diag(5079, 1 /* Error */ , "Unknown_watch_option_0_Did_you_mean_1_5079", "Unknown watch option '{0}'. Did you mean '{1}'?"),
                Watch_option_0_requires_a_value_of_type_1: diag(5080, 1 /* Error */ , "Watch_option_0_requires_a_value_of_type_1_5080", "Watch option '{0}' requires a value of type {1}."),
                Cannot_find_a_tsconfig_json_file_at_the_current_directory_Colon_0: diag(5081, 1 /* Error */ , "Cannot_find_a_tsconfig_json_file_at_the_current_directory_Colon_0_5081", "Cannot find a tsconfig.json file at the current directory: {0}."),
                _0_could_be_instantiated_with_an_arbitrary_type_which_could_be_unrelated_to_1: diag(5082, 1 /* Error */ , "_0_could_be_instantiated_with_an_arbitrary_type_which_could_be_unrelated_to_1_5082", "'{0}' could be instantiated with an arbitrary type which could be unrelated to '{1}'."),
                Cannot_read_file_0: diag(5083, 1 /* Error */ , "Cannot_read_file_0_5083", "Cannot read file '{0}'."),
                Tuple_members_must_all_have_names_or_all_not_have_names: diag(5084, 1 /* Error */ , "Tuple_members_must_all_have_names_or_all_not_have_names_5084", "Tuple members must all have names or all not have names."),
                A_tuple_member_cannot_be_both_optional_and_rest: diag(5085, 1 /* Error */ , "A_tuple_member_cannot_be_both_optional_and_rest_5085", "A tuple member cannot be both optional and rest."),
                A_labeled_tuple_element_is_declared_as_optional_with_a_question_mark_after_the_name_and_before_the_colon_rather_than_after_the_type: diag(5086, 1 /* Error */ , "A_labeled_tuple_element_is_declared_as_optional_with_a_question_mark_after_the_name_and_before_the_c_5086", "A labeled tuple element is declared as optional with a question mark after the name and before the colon, rather than after the type."),
                A_labeled_tuple_element_is_declared_as_rest_with_a_before_the_name_rather_than_before_the_type: diag(5087, 1 /* Error */ , "A_labeled_tuple_element_is_declared_as_rest_with_a_before_the_name_rather_than_before_the_type_5087", "A labeled tuple element is declared as rest with a '...' before the name, rather than before the type."),
                The_inferred_type_of_0_references_a_type_with_a_cyclic_structure_which_cannot_be_trivially_serialized_A_type_annotation_is_necessary: diag(5088, 1 /* Error */ , "The_inferred_type_of_0_references_a_type_with_a_cyclic_structure_which_cannot_be_trivially_serialize_5088", "The inferred type of '{0}' references a type with a cyclic structure which cannot be trivially serialized. A type annotation is necessary."),
                Option_0_cannot_be_specified_when_option_jsx_is_1: diag(5089, 1 /* Error */ , "Option_0_cannot_be_specified_when_option_jsx_is_1_5089", "Option '{0}' cannot be specified when option 'jsx' is '{1}'."),
                Non_relative_paths_are_not_allowed_when_baseUrl_is_not_set_Did_you_forget_a_leading_Slash: diag(5090, 1 /* Error */ , "Non_relative_paths_are_not_allowed_when_baseUrl_is_not_set_Did_you_forget_a_leading_Slash_5090", "Non-relative paths are not allowed when 'baseUrl' is not set. Did you forget a leading './'?"),
                Option_preserveConstEnums_cannot_be_disabled_when_0_is_enabled: diag(5091, 1 /* Error */ , "Option_preserveConstEnums_cannot_be_disabled_when_0_is_enabled_5091", "Option 'preserveConstEnums' cannot be disabled when '{0}' is enabled."),
                The_root_value_of_a_0_file_must_be_an_object: diag(5092, 1 /* Error */ , "The_root_value_of_a_0_file_must_be_an_object_5092", "The root value of a '{0}' file must be an object."),
                Compiler_option_0_may_only_be_used_with_build: diag(5093, 1 /* Error */ , "Compiler_option_0_may_only_be_used_with_build_5093", "Compiler option '--{0}' may only be used with '--build'."),
                Compiler_option_0_may_not_be_used_with_build: diag(5094, 1 /* Error */ , "Compiler_option_0_may_not_be_used_with_build_5094", "Compiler option '--{0}' may not be used with '--build'."),
                Option_0_can_only_be_used_when_module_is_set_to_es2015_or_later: diag(5095, 1 /* Error */ , "Option_0_can_only_be_used_when_module_is_set_to_es2015_or_later_5095", "Option '{0}' can only be used when 'module' is set to 'es2015' or later."),
                Option_allowImportingTsExtensions_can_only_be_used_when_either_noEmit_or_emitDeclarationOnly_is_set: diag(5096, 1 /* Error */ , "Option_allowImportingTsExtensions_can_only_be_used_when_either_noEmit_or_emitDeclarationOnly_is_set_5096", "Option 'allowImportingTsExtensions' can only be used when either 'noEmit' or 'emitDeclarationOnly' is set."),
                An_import_path_can_only_end_with_a_0_extension_when_allowImportingTsExtensions_is_enabled: diag(5097, 1 /* Error */ , "An_import_path_can_only_end_with_a_0_extension_when_allowImportingTsExtensions_is_enabled_5097", "An import path can only end with a '{0}' extension when 'allowImportingTsExtensions' is enabled."),
                Option_0_can_only_be_used_when_moduleResolution_is_set_to_node16_nodenext_or_bundler: diag(5098, 1 /* Error */ , "Option_0_can_only_be_used_when_moduleResolution_is_set_to_node16_nodenext_or_bundler_5098", "Option '{0}' can only be used when 'moduleResolution' is set to 'node16', 'nodenext', or 'bundler'."),
                Option_0_is_deprecated_and_will_stop_functioning_in_TypeScript_1_Specify_compilerOption_ignoreDeprecations_Colon_2_to_silence_this_error: diag(5101, 1 /* Error */ , "Option_0_is_deprecated_and_will_stop_functioning_in_TypeScript_1_Specify_compilerOption_ignoreDeprec_5101", `Option '{0}' is deprecated and will stop functioning in TypeScript {1}. Specify compilerOption '"ignoreDeprecations": "{2}"' to silence this error.`),
                Option_0_has_been_removed_Please_remove_it_from_your_configuration: diag(5102, 1 /* Error */ , "Option_0_has_been_removed_Please_remove_it_from_your_configuration_5102", "Option '{0}' has been removed. Please remove it from your configuration."),
                Invalid_value_for_ignoreDeprecations: diag(5103, 1 /* Error */ , "Invalid_value_for_ignoreDeprecations_5103", "Invalid value for '--ignoreDeprecations'."),
                Option_0_is_redundant_and_cannot_be_specified_with_option_1: diag(5104, 1 /* Error */ , "Option_0_is_redundant_and_cannot_be_specified_with_option_1_5104", "Option '{0}' is redundant and cannot be specified with option '{1}'."),
                Option_verbatimModuleSyntax_cannot_be_used_when_module_is_set_to_UMD_AMD_or_System: diag(5105, 1 /* Error */ , "Option_verbatimModuleSyntax_cannot_be_used_when_module_is_set_to_UMD_AMD_or_System_5105", "Option 'verbatimModuleSyntax' cannot be used when 'module' is set to 'UMD', 'AMD', or 'System'."),
                Use_0_instead: diag(5106, 3 /* Message */ , "Use_0_instead_5106", "Use '{0}' instead."),
                Option_0_1_is_deprecated_and_will_stop_functioning_in_TypeScript_2_Specify_compilerOption_ignoreDeprecations_Colon_3_to_silence_this_error: diag(5107, 1 /* Error */ , "Option_0_1_is_deprecated_and_will_stop_functioning_in_TypeScript_2_Specify_compilerOption_ignoreDepr_5107", `Option '{0}={1}' is deprecated and will stop functioning in TypeScript {2}. Specify compilerOption '"ignoreDeprecations": "{3}"' to silence this error.`),
                Option_0_1_has_been_removed_Please_remove_it_from_your_configuration: diag(5108, 1 /* Error */ , "Option_0_1_has_been_removed_Please_remove_it_from_your_configuration_5108", "Option '{0}={1}' has been removed. Please remove it from your configuration."),
                Generates_a_sourcemap_for_each_corresponding_d_ts_file: diag(6e3, 3 /* Message */ , "Generates_a_sourcemap_for_each_corresponding_d_ts_file_6000", "Generates a sourcemap for each corresponding '.d.ts' file."),
                Concatenate_and_emit_output_to_single_file: diag(6001, 3 /* Message */ , "Concatenate_and_emit_output_to_single_file_6001", "Concatenate and emit output to single file."),
                Generates_corresponding_d_ts_file: diag(6002, 3 /* Message */ , "Generates_corresponding_d_ts_file_6002", "Generates corresponding '.d.ts' file."),
                Specify_the_location_where_debugger_should_locate_TypeScript_files_instead_of_source_locations: diag(6004, 3 /* Message */ , "Specify_the_location_where_debugger_should_locate_TypeScript_files_instead_of_source_locations_6004", "Specify the location where debugger should locate TypeScript files instead of source locations."),
                Watch_input_files: diag(6005, 3 /* Message */ , "Watch_input_files_6005", "Watch input files."),
                Redirect_output_structure_to_the_directory: diag(6006, 3 /* Message */ , "Redirect_output_structure_to_the_directory_6006", "Redirect output structure to the directory."),
                Do_not_erase_const_enum_declarations_in_generated_code: diag(6007, 3 /* Message */ , "Do_not_erase_const_enum_declarations_in_generated_code_6007", "Do not erase const enum declarations in generated code."),
                Do_not_emit_outputs_if_any_errors_were_reported: diag(6008, 3 /* Message */ , "Do_not_emit_outputs_if_any_errors_were_reported_6008", "Do not emit outputs if any errors were reported."),
                Do_not_emit_comments_to_output: diag(6009, 3 /* Message */ , "Do_not_emit_comments_to_output_6009", "Do not emit comments to output."),
                Do_not_emit_outputs: diag(6010, 3 /* Message */ , "Do_not_emit_outputs_6010", "Do not emit outputs."),
                Allow_default_imports_from_modules_with_no_default_export_This_does_not_affect_code_emit_just_typechecking: diag(6011, 3 /* Message */ , "Allow_default_imports_from_modules_with_no_default_export_This_does_not_affect_code_emit_just_typech_6011", "Allow default imports from modules with no default export. This does not affect code emit, just typechecking."),
                Skip_type_checking_of_declaration_files: diag(6012, 3 /* Message */ , "Skip_type_checking_of_declaration_files_6012", "Skip type checking of declaration files."),
                Do_not_resolve_the_real_path_of_symlinks: diag(6013, 3 /* Message */ , "Do_not_resolve_the_real_path_of_symlinks_6013", "Do not resolve the real path of symlinks."),
                Only_emit_d_ts_declaration_files: diag(6014, 3 /* Message */ , "Only_emit_d_ts_declaration_files_6014", "Only emit '.d.ts' declaration files."),
                Specify_ECMAScript_target_version: diag(6015, 3 /* Message */ , "Specify_ECMAScript_target_version_6015", "Specify ECMAScript target version."),
                Specify_module_code_generation: diag(6016, 3 /* Message */ , "Specify_module_code_generation_6016", "Specify module code generation."),
                Print_this_message: diag(6017, 3 /* Message */ , "Print_this_message_6017", "Print this message."),
                Print_the_compiler_s_version: diag(6019, 3 /* Message */ , "Print_the_compiler_s_version_6019", "Print the compiler's version."),
                Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json: diag(6020, 3 /* Message */ , "Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json_6020", "Compile the project given the path to its configuration file, or to a folder with a 'tsconfig.json'."),
                Syntax_Colon_0: diag(6023, 3 /* Message */ , "Syntax_Colon_0_6023", "Syntax: {0}"),
                options: diag(6024, 3 /* Message */ , "options_6024", "options"),
                file: diag(6025, 3 /* Message */ , "file_6025", "file"),
                Examples_Colon_0: diag(6026, 3 /* Message */ , "Examples_Colon_0_6026", "Examples: {0}"),
                Options_Colon: diag(6027, 3 /* Message */ , "Options_Colon_6027", "Options:"),
                Version_0: diag(6029, 3 /* Message */ , "Version_0_6029", "Version {0}"),
                Insert_command_line_options_and_files_from_a_file: diag(6030, 3 /* Message */ , "Insert_command_line_options_and_files_from_a_file_6030", "Insert command line options and files from a file."),
                Starting_compilation_in_watch_mode: diag(6031, 3 /* Message */ , "Starting_compilation_in_watch_mode_6031", "Starting compilation in watch mode..."),
                File_change_detected_Starting_incremental_compilation: diag(6032, 3 /* Message */ , "File_change_detected_Starting_incremental_compilation_6032", "File change detected. Starting incremental compilation..."),
                KIND: diag(6034, 3 /* Message */ , "KIND_6034", "KIND"),
                FILE: diag(6035, 3 /* Message */ , "FILE_6035", "FILE"),
                VERSION: diag(6036, 3 /* Message */ , "VERSION_6036", "VERSION"),
                LOCATION: diag(6037, 3 /* Message */ , "LOCATION_6037", "LOCATION"),
                DIRECTORY: diag(6038, 3 /* Message */ , "DIRECTORY_6038", "DIRECTORY"),
                STRATEGY: diag(6039, 3 /* Message */ , "STRATEGY_6039", "STRATEGY"),
                FILE_OR_DIRECTORY: diag(6040, 3 /* Message */ , "FILE_OR_DIRECTORY_6040", "FILE OR DIRECTORY"),
                Errors_Files: diag(6041, 3 /* Message */ , "Errors_Files_6041", "Errors  Files"),
                Generates_corresponding_map_file: diag(6043, 3 /* Message */ , "Generates_corresponding_map_file_6043", "Generates corresponding '.map' file."),
                Compiler_option_0_expects_an_argument: diag(6044, 1 /* Error */ , "Compiler_option_0_expects_an_argument_6044", "Compiler option '{0}' expects an argument."),
                Unterminated_quoted_string_in_response_file_0: diag(6045, 1 /* Error */ , "Unterminated_quoted_string_in_response_file_0_6045", "Unterminated quoted string in response file '{0}'."),
                Argument_for_0_option_must_be_Colon_1: diag(6046, 1 /* Error */ , "Argument_for_0_option_must_be_Colon_1_6046", "Argument for '{0}' option must be: {1}."),
                Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1: diag(6048, 1 /* Error */ , "Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1_6048", "Locale must be of the form <language> or <language>-<territory>. For example '{0}' or '{1}'."),
                Unable_to_open_file_0: diag(6050, 1 /* Error */ , "Unable_to_open_file_0_6050", "Unable to open file '{0}'."),
                Corrupted_locale_file_0: diag(6051, 1 /* Error */ , "Corrupted_locale_file_0_6051", "Corrupted locale file {0}."),
                Raise_error_on_expressions_and_declarations_with_an_implied_any_type: diag(6052, 3 /* Message */ , "Raise_error_on_expressions_and_declarations_with_an_implied_any_type_6052", "Raise error on expressions and declarations with an implied 'any' type."),
                File_0_not_found: diag(6053, 1 /* Error */ , "File_0_not_found_6053", "File '{0}' not found."),
                File_0_has_an_unsupported_extension_The_only_supported_extensions_are_1: diag(6054, 1 /* Error */ , "File_0_has_an_unsupported_extension_The_only_supported_extensions_are_1_6054", "File '{0}' has an unsupported extension. The only supported extensions are {1}."),
                Suppress_noImplicitAny_errors_for_indexing_objects_lacking_index_signatures: diag(6055, 3 /* Message */ , "Suppress_noImplicitAny_errors_for_indexing_objects_lacking_index_signatures_6055", "Suppress noImplicitAny errors for indexing objects lacking index signatures."),
                Do_not_emit_declarations_for_code_that_has_an_internal_annotation: diag(6056, 3 /* Message */ , "Do_not_emit_declarations_for_code_that_has_an_internal_annotation_6056", "Do not emit declarations for code that has an '@internal' annotation."),
                Specify_the_root_directory_of_input_files_Use_to_control_the_output_directory_structure_with_outDir: diag(6058, 3 /* Message */ , "Specify_the_root_directory_of_input_files_Use_to_control_the_output_directory_structure_with_outDir_6058", "Specify the root directory of input files. Use to control the output directory structure with --outDir."),
                File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files: diag(6059, 1 /* Error */ , "File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files_6059", "File '{0}' is not under 'rootDir' '{1}'. 'rootDir' is expected to contain all source files."),
                Specify_the_end_of_line_sequence_to_be_used_when_emitting_files_Colon_CRLF_dos_or_LF_unix: diag(6060, 3 /* Message */ , "Specify_the_end_of_line_sequence_to_be_used_when_emitting_files_Colon_CRLF_dos_or_LF_unix_6060", "Specify the end of line sequence to be used when emitting files: 'CRLF' (dos) or 'LF' (unix)."),
                NEWLINE: diag(6061, 3 /* Message */ , "NEWLINE_6061", "NEWLINE"),
                Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_null_on_command_line: diag(6064, 1 /* Error */ , "Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_null_on_command_line_6064", "Option '{0}' can only be specified in 'tsconfig.json' file or set to 'null' on command line."),
                Enables_experimental_support_for_ES7_decorators: diag(6065, 3 /* Message */ , "Enables_experimental_support_for_ES7_decorators_6065", "Enables experimental support for ES7 decorators."),
                Enables_experimental_support_for_emitting_type_metadata_for_decorators: diag(6066, 3 /* Message */ , "Enables_experimental_support_for_emitting_type_metadata_for_decorators_6066", "Enables experimental support for emitting type metadata for decorators."),
                Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file: diag(6070, 3 /* Message */ , "Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file_6070", "Initializes a TypeScript project and creates a tsconfig.json file."),
                Successfully_created_a_tsconfig_json_file: diag(6071, 3 /* Message */ , "Successfully_created_a_tsconfig_json_file_6071", "Successfully created a tsconfig.json file."),
                Suppress_excess_property_checks_for_object_literals: diag(6072, 3 /* Message */ , "Suppress_excess_property_checks_for_object_literals_6072", "Suppress excess property checks for object literals."),
                Stylize_errors_and_messages_using_color_and_context_experimental: diag(6073, 3 /* Message */ , "Stylize_errors_and_messages_using_color_and_context_experimental_6073", "Stylize errors and messages using color and context (experimental)."),
                Do_not_report_errors_on_unused_labels: diag(6074, 3 /* Message */ , "Do_not_report_errors_on_unused_labels_6074", "Do not report errors on unused labels."),
                Report_error_when_not_all_code_paths_in_function_return_a_value: diag(6075, 3 /* Message */ , "Report_error_when_not_all_code_paths_in_function_return_a_value_6075", "Report error when not all code paths in function return a value."),
                Report_errors_for_fallthrough_cases_in_switch_statement: diag(6076, 3 /* Message */ , "Report_errors_for_fallthrough_cases_in_switch_statement_6076", "Report errors for fallthrough cases in switch statement."),
                Do_not_report_errors_on_unreachable_code: diag(6077, 3 /* Message */ , "Do_not_report_errors_on_unreachable_code_6077", "Do not report errors on unreachable code."),
                Disallow_inconsistently_cased_references_to_the_same_file: diag(6078, 3 /* Message */ , "Disallow_inconsistently_cased_references_to_the_same_file_6078", "Disallow inconsistently-cased references to the same file."),
                Specify_library_files_to_be_included_in_the_compilation: diag(6079, 3 /* Message */ , "Specify_library_files_to_be_included_in_the_compilation_6079", "Specify library files to be included in the compilation."),
                Specify_JSX_code_generation: diag(6080, 3 /* Message */ , "Specify_JSX_code_generation_6080", "Specify JSX code generation."),
                File_0_has_an_unsupported_extension_so_skipping_it: diag(6081, 3 /* Message */ , "File_0_has_an_unsupported_extension_so_skipping_it_6081", "File '{0}' has an unsupported extension, so skipping it."),
                Only_amd_and_system_modules_are_supported_alongside_0: diag(6082, 1 /* Error */ , "Only_amd_and_system_modules_are_supported_alongside_0_6082", "Only 'amd' and 'system' modules are supported alongside --{0}."),
                Base_directory_to_resolve_non_absolute_module_names: diag(6083, 3 /* Message */ , "Base_directory_to_resolve_non_absolute_module_names_6083", "Base directory to resolve non-absolute module names."),
                Deprecated_Use_jsxFactory_instead_Specify_the_object_invoked_for_createElement_when_targeting_react_JSX_emit: diag(6084, 3 /* Message */ , "Deprecated_Use_jsxFactory_instead_Specify_the_object_invoked_for_createElement_when_targeting_react__6084", "[Deprecated] Use '--jsxFactory' instead. Specify the object invoked for createElement when targeting 'react' JSX emit"),
                Enable_tracing_of_the_name_resolution_process: diag(6085, 3 /* Message */ , "Enable_tracing_of_the_name_resolution_process_6085", "Enable tracing of the name resolution process."),
                Resolving_module_0_from_1: diag(6086, 3 /* Message */ , "Resolving_module_0_from_1_6086", "======== Resolving module '{0}' from '{1}'. ========"),
                Explicitly_specified_module_resolution_kind_Colon_0: diag(6087, 3 /* Message */ , "Explicitly_specified_module_resolution_kind_Colon_0_6087", "Explicitly specified module resolution kind: '{0}'."),
                Module_resolution_kind_is_not_specified_using_0: diag(6088, 3 /* Message */ , "Module_resolution_kind_is_not_specified_using_0_6088", "Module resolution kind is not specified, using '{0}'."),
                Module_name_0_was_successfully_resolved_to_1: diag(6089, 3 /* Message */ , "Module_name_0_was_successfully_resolved_to_1_6089", "======== Module name '{0}' was successfully resolved to '{1}'. ========"),
                Module_name_0_was_not_resolved: diag(6090, 3 /* Message */ , "Module_name_0_was_not_resolved_6090", "======== Module name '{0}' was not resolved. ========"),
                paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0: diag(6091, 3 /* Message */ , "paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0_6091", "'paths' option is specified, looking for a pattern to match module name '{0}'."),
                Module_name_0_matched_pattern_1: diag(6092, 3 /* Message */ , "Module_name_0_matched_pattern_1_6092", "Module name '{0}', matched pattern '{1}'."),
                Trying_substitution_0_candidate_module_location_Colon_1: diag(6093, 3 /* Message */ , "Trying_substitution_0_candidate_module_location_Colon_1_6093", "Trying substitution '{0}', candidate module location: '{1}'."),
                Resolving_module_name_0_relative_to_base_url_1_2: diag(6094, 3 /* Message */ , "Resolving_module_name_0_relative_to_base_url_1_2_6094", "Resolving module name '{0}' relative to base url '{1}' - '{2}'."),
                Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_types_Colon_1: diag(6095, 3 /* Message */ , "Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_types_Colon_1_6095", "Loading module as file / folder, candidate module location '{0}', target file types: {1}."),
                File_0_does_not_exist: diag(6096, 3 /* Message */ , "File_0_does_not_exist_6096", "File '{0}' does not exist."),
                File_0_exists_use_it_as_a_name_resolution_result: diag(6097, 3 /* Message */ , "File_0_exists_use_it_as_a_name_resolution_result_6097", "File '{0}' exists - use it as a name resolution result."),
                Loading_module_0_from_node_modules_folder_target_file_types_Colon_1: diag(6098, 3 /* Message */ , "Loading_module_0_from_node_modules_folder_target_file_types_Colon_1_6098", "Loading module '{0}' from 'node_modules' folder, target file types: {1}."),
                Found_package_json_at_0: diag(6099, 3 /* Message */ , "Found_package_json_at_0_6099", "Found 'package.json' at '{0}'."),
                package_json_does_not_have_a_0_field: diag(6100, 3 /* Message */ , "package_json_does_not_have_a_0_field_6100", "'package.json' does not have a '{0}' field."),
                package_json_has_0_field_1_that_references_2: diag(6101, 3 /* Message */ , "package_json_has_0_field_1_that_references_2_6101", "'package.json' has '{0}' field '{1}' that references '{2}'."),
                Allow_javascript_files_to_be_compiled: diag(6102, 3 /* Message */ , "Allow_javascript_files_to_be_compiled_6102", "Allow javascript files to be compiled."),
                Checking_if_0_is_the_longest_matching_prefix_for_1_2: diag(6104, 3 /* Message */ , "Checking_if_0_is_the_longest_matching_prefix_for_1_2_6104", "Checking if '{0}' is the longest matching prefix for '{1}' - '{2}'."),
                Expected_type_of_0_field_in_package_json_to_be_1_got_2: diag(6105, 3 /* Message */ , "Expected_type_of_0_field_in_package_json_to_be_1_got_2_6105", "Expected type of '{0}' field in 'package.json' to be '{1}', got '{2}'."),
                baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1: diag(6106, 3 /* Message */ , "baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1_6106", "'baseUrl' option is set to '{0}', using this value to resolve non-relative module name '{1}'."),
                rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0: diag(6107, 3 /* Message */ , "rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0_6107", "'rootDirs' option is set, using it to resolve relative module name '{0}'."),
                Longest_matching_prefix_for_0_is_1: diag(6108, 3 /* Message */ , "Longest_matching_prefix_for_0_is_1_6108", "Longest matching prefix for '{0}' is '{1}'."),
                Loading_0_from_the_root_dir_1_candidate_location_2: diag(6109, 3 /* Message */ , "Loading_0_from_the_root_dir_1_candidate_location_2_6109", "Loading '{0}' from the root dir '{1}', candidate location '{2}'."),
                Trying_other_entries_in_rootDirs: diag(6110, 3 /* Message */ , "Trying_other_entries_in_rootDirs_6110", "Trying other entries in 'rootDirs'."),
                Module_resolution_using_rootDirs_has_failed: diag(6111, 3 /* Message */ , "Module_resolution_using_rootDirs_has_failed_6111", "Module resolution using 'rootDirs' has failed."),
                Do_not_emit_use_strict_directives_in_module_output: diag(6112, 3 /* Message */ , "Do_not_emit_use_strict_directives_in_module_output_6112", "Do not emit 'use strict' directives in module output."),
                Enable_strict_null_checks: diag(6113, 3 /* Message */ , "Enable_strict_null_checks_6113", "Enable strict null checks."),
                Unknown_option_excludes_Did_you_mean_exclude: diag(6114, 1 /* Error */ , "Unknown_option_excludes_Did_you_mean_exclude_6114", "Unknown option 'excludes'. Did you mean 'exclude'?"),
                Raise_error_on_this_expressions_with_an_implied_any_type: diag(6115, 3 /* Message */ , "Raise_error_on_this_expressions_with_an_implied_any_type_6115", "Raise error on 'this' expressions with an implied 'any' type."),
                Resolving_type_reference_directive_0_containing_file_1_root_directory_2: diag(6116, 3 /* Message */ , "Resolving_type_reference_directive_0_containing_file_1_root_directory_2_6116", "======== Resolving type reference directive '{0}', containing file '{1}', root directory '{2}'. ========"),
                Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2: diag(6119, 3 /* Message */ , "Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2_6119", "======== Type reference directive '{0}' was successfully resolved to '{1}', primary: {2}. ========"),
                Type_reference_directive_0_was_not_resolved: diag(6120, 3 /* Message */ , "Type_reference_directive_0_was_not_resolved_6120", "======== Type reference directive '{0}' was not resolved. ========"),
                Resolving_with_primary_search_path_0: diag(6121, 3 /* Message */ , "Resolving_with_primary_search_path_0_6121", "Resolving with primary search path '{0}'."),
                Root_directory_cannot_be_determined_skipping_primary_search_paths: diag(6122, 3 /* Message */ , "Root_directory_cannot_be_determined_skipping_primary_search_paths_6122", "Root directory cannot be determined, skipping primary search paths."),
                Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set: diag(6123, 3 /* Message */ , "Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set_6123", "======== Resolving type reference directive '{0}', containing file '{1}', root directory not set. ========"),
                Type_declaration_files_to_be_included_in_compilation: diag(6124, 3 /* Message */ , "Type_declaration_files_to_be_included_in_compilation_6124", "Type declaration files to be included in compilation."),
                Looking_up_in_node_modules_folder_initial_location_0: diag(6125, 3 /* Message */ , "Looking_up_in_node_modules_folder_initial_location_0_6125", "Looking up in 'node_modules' folder, initial location '{0}'."),
                Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_modules_folder: diag(6126, 3 /* Message */ , "Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_mod_6126", "Containing file is not specified and root directory cannot be determined, skipping lookup in 'node_modules' folder."),
                Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1: diag(6127, 3 /* Message */ , "Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1_6127", "======== Resolving type reference directive '{0}', containing file not set, root directory '{1}'. ========"),
                Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set: diag(6128, 3 /* Message */ , "Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set_6128", "======== Resolving type reference directive '{0}', containing file not set, root directory not set. ========"),
                Resolving_real_path_for_0_result_1: diag(6130, 3 /* Message */ , "Resolving_real_path_for_0_result_1_6130", "Resolving real path for '{0}', result '{1}'."),
                Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system: diag(6131, 1 /* Error */ , "Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system_6131", "Cannot compile modules using option '{0}' unless the '--module' flag is 'amd' or 'system'."),
                File_name_0_has_a_1_extension_stripping_it: diag(6132, 3 /* Message */ , "File_name_0_has_a_1_extension_stripping_it_6132", "File name '{0}' has a '{1}' extension - stripping it."),
                _0_is_declared_but_its_value_is_never_read: diag(6133, 1 /* Error */ , "_0_is_declared_but_its_value_is_never_read_6133", "'{0}' is declared but its value is never read.", /*reportsUnnecessary*/ true),
                Report_errors_on_unused_locals: diag(6134, 3 /* Message */ , "Report_errors_on_unused_locals_6134", "Report errors on unused locals."),
                Report_errors_on_unused_parameters: diag(6135, 3 /* Message */ , "Report_errors_on_unused_parameters_6135", "Report errors on unused parameters."),
                The_maximum_dependency_depth_to_search_under_node_modules_and_load_JavaScript_files: diag(6136, 3 /* Message */ , "The_maximum_dependency_depth_to_search_under_node_modules_and_load_JavaScript_files_6136", "The maximum dependency depth to search under node_modules and load JavaScript files."),
                Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1: diag(6137, 1 /* Error */ , "Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1_6137", "Cannot import type declaration files. Consider importing '{0}' instead of '{1}'."),
                Property_0_is_declared_but_its_value_is_never_read: diag(6138, 1 /* Error */ , "Property_0_is_declared_but_its_value_is_never_read_6138", "Property '{0}' is declared but its value is never read.", /*reportsUnnecessary*/ true),
                Import_emit_helpers_from_tslib: diag(6139, 3 /* Message */ , "Import_emit_helpers_from_tslib_6139", "Import emit helpers from 'tslib'."),
                Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using_cache_location_2: diag(6140, 1 /* Error */ , "Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using__6140", "Auto discovery for typings is enabled in project '{0}'. Running extra resolution pass for module '{1}' using cache location '{2}'."),
                Parse_in_strict_mode_and_emit_use_strict_for_each_source_file: diag(6141, 3 /* Message */ , "Parse_in_strict_mode_and_emit_use_strict_for_each_source_file_6141", 'Parse in strict mode and emit "use strict" for each source file.'),
                Module_0_was_resolved_to_1_but_jsx_is_not_set: diag(6142, 1 /* Error */ , "Module_0_was_resolved_to_1_but_jsx_is_not_set_6142", "Module '{0}' was resolved to '{1}', but '--jsx' is not set."),
                Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1: diag(6144, 3 /* Message */ , "Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1_6144", "Module '{0}' was resolved as locally declared ambient module in file '{1}'."),
                Module_0_was_resolved_as_ambient_module_declared_in_1_since_this_file_was_not_modified: diag(6145, 3 /* Message */ , "Module_0_was_resolved_as_ambient_module_declared_in_1_since_this_file_was_not_modified_6145", "Module '{0}' was resolved as ambient module declared in '{1}' since this file was not modified."),
                Specify_the_JSX_factory_function_to_use_when_targeting_react_JSX_emit_e_g_React_createElement_or_h: diag(6146, 3 /* Message */ , "Specify_the_JSX_factory_function_to_use_when_targeting_react_JSX_emit_e_g_React_createElement_or_h_6146", "Specify the JSX factory function to use when targeting 'react' JSX emit, e.g. 'React.createElement' or 'h'."),
                Resolution_for_module_0_was_found_in_cache_from_location_1: diag(6147, 3 /* Message */ , "Resolution_for_module_0_was_found_in_cache_from_location_1_6147", "Resolution for module '{0}' was found in cache from location '{1}'."),
                Directory_0_does_not_exist_skipping_all_lookups_in_it: diag(6148, 3 /* Message */ , "Directory_0_does_not_exist_skipping_all_lookups_in_it_6148", "Directory '{0}' does not exist, skipping all lookups in it."),
                Show_diagnostic_information: diag(6149, 3 /* Message */ , "Show_diagnostic_information_6149", "Show diagnostic information."),
                Show_verbose_diagnostic_information: diag(6150, 3 /* Message */ , "Show_verbose_diagnostic_information_6150", "Show verbose diagnostic information."),
                Emit_a_single_file_with_source_maps_instead_of_having_a_separate_file: diag(6151, 3 /* Message */ , "Emit_a_single_file_with_source_maps_instead_of_having_a_separate_file_6151", "Emit a single file with source maps instead of having a separate file."),
                Emit_the_source_alongside_the_sourcemaps_within_a_single_file_requires_inlineSourceMap_or_sourceMap_to_be_set: diag(6152, 3 /* Message */ , "Emit_the_source_alongside_the_sourcemaps_within_a_single_file_requires_inlineSourceMap_or_sourceMap__6152", "Emit the source alongside the sourcemaps within a single file; requires '--inlineSourceMap' or '--sourceMap' to be set."),
                Transpile_each_file_as_a_separate_module_similar_to_ts_transpileModule: diag(6153, 3 /* Message */ , "Transpile_each_file_as_a_separate_module_similar_to_ts_transpileModule_6153", "Transpile each file as a separate module (similar to 'ts.transpileModule')."),
                Print_names_of_generated_files_part_of_the_compilation: diag(6154, 3 /* Message */ , "Print_names_of_generated_files_part_of_the_compilation_6154", "Print names of generated files part of the compilation."),
                Print_names_of_files_part_of_the_compilation: diag(6155, 3 /* Message */ , "Print_names_of_files_part_of_the_compilation_6155", "Print names of files part of the compilation."),
                The_locale_used_when_displaying_messages_to_the_user_e_g_en_us: diag(6156, 3 /* Message */ , "The_locale_used_when_displaying_messages_to_the_user_e_g_en_us_6156", "The locale used when displaying messages to the user (e.g. 'en-us')"),
                Do_not_generate_custom_helper_functions_like_extends_in_compiled_output: diag(6157, 3 /* Message */ , "Do_not_generate_custom_helper_functions_like_extends_in_compiled_output_6157", "Do not generate custom helper functions like '__extends' in compiled output."),
                Do_not_include_the_default_library_file_lib_d_ts: diag(6158, 3 /* Message */ , "Do_not_include_the_default_library_file_lib_d_ts_6158", "Do not include the default library file (lib.d.ts)."),
                Do_not_add_triple_slash_references_or_imported_modules_to_the_list_of_compiled_files: diag(6159, 3 /* Message */ , "Do_not_add_triple_slash_references_or_imported_modules_to_the_list_of_compiled_files_6159", "Do not add triple-slash references or imported modules to the list of compiled files."),
                Deprecated_Use_skipLibCheck_instead_Skip_type_checking_of_default_library_declaration_files: diag(6160, 3 /* Message */ , "Deprecated_Use_skipLibCheck_instead_Skip_type_checking_of_default_library_declaration_files_6160", "[Deprecated] Use '--skipLibCheck' instead. Skip type checking of default library declaration files."),
                List_of_folders_to_include_type_definitions_from: diag(6161, 3 /* Message */ , "List_of_folders_to_include_type_definitions_from_6161", "List of folders to include type definitions from."),
                Disable_size_limitations_on_JavaScript_projects: diag(6162, 3 /* Message */ , "Disable_size_limitations_on_JavaScript_projects_6162", "Disable size limitations on JavaScript projects."),
                The_character_set_of_the_input_files: diag(6163, 3 /* Message */ , "The_character_set_of_the_input_files_6163", "The character set of the input files."),
                Skipping_module_0_that_looks_like_an_absolute_URI_target_file_types_Colon_1: diag(6164, 3 /* Message */ , "Skipping_module_0_that_looks_like_an_absolute_URI_target_file_types_Colon_1_6164", "Skipping module '{0}' that looks like an absolute URI, target file types: {1}."),
                Do_not_truncate_error_messages: diag(6165, 3 /* Message */ , "Do_not_truncate_error_messages_6165", "Do not truncate error messages."),
                Output_directory_for_generated_declaration_files: diag(6166, 3 /* Message */ , "Output_directory_for_generated_declaration_files_6166", "Output directory for generated declaration files."),
                A_series_of_entries_which_re_map_imports_to_lookup_locations_relative_to_the_baseUrl: diag(6167, 3 /* Message */ , "A_series_of_entries_which_re_map_imports_to_lookup_locations_relative_to_the_baseUrl_6167", "A series of entries which re-map imports to lookup locations relative to the 'baseUrl'."),
                List_of_root_folders_whose_combined_content_represents_the_structure_of_the_project_at_runtime: diag(6168, 3 /* Message */ , "List_of_root_folders_whose_combined_content_represents_the_structure_of_the_project_at_runtime_6168", "List of root folders whose combined content represents the structure of the project at runtime."),
                Show_all_compiler_options: diag(6169, 3 /* Message */ , "Show_all_compiler_options_6169", "Show all compiler options."),
                Deprecated_Use_outFile_instead_Concatenate_and_emit_output_to_single_file: diag(6170, 3 /* Message */ , "Deprecated_Use_outFile_instead_Concatenate_and_emit_output_to_single_file_6170", "[Deprecated] Use '--outFile' instead. Concatenate and emit output to single file"),
                Command_line_Options: diag(6171, 3 /* Message */ , "Command_line_Options_6171", "Command-line Options"),
                Provide_full_support_for_iterables_in_for_of_spread_and_destructuring_when_targeting_ES5_or_ES3: diag(6179, 3 /* Message */ , "Provide_full_support_for_iterables_in_for_of_spread_and_destructuring_when_targeting_ES5_or_ES3_6179", "Provide full support for iterables in 'for-of', spread, and destructuring when targeting 'ES5' or 'ES3'."),
                Enable_all_strict_type_checking_options: diag(6180, 3 /* Message */ , "Enable_all_strict_type_checking_options_6180", "Enable all strict type-checking options."),
                Scoped_package_detected_looking_in_0: diag(6182, 3 /* Message */ , "Scoped_package_detected_looking_in_0_6182", "Scoped package detected, looking in '{0}'"),
                Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2: diag(6183, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_6183", "Reusing resolution of module '{0}' from '{1}' of old program, it was successfully resolved to '{2}'."),
                Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3: diag(6184, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package__6184", "Reusing resolution of module '{0}' from '{1}' of old program, it was successfully resolved to '{2}' with Package ID '{3}'."),
                Enable_strict_checking_of_function_types: diag(6186, 3 /* Message */ , "Enable_strict_checking_of_function_types_6186", "Enable strict checking of function types."),
                Enable_strict_checking_of_property_initialization_in_classes: diag(6187, 3 /* Message */ , "Enable_strict_checking_of_property_initialization_in_classes_6187", "Enable strict checking of property initialization in classes."),
                Numeric_separators_are_not_allowed_here: diag(6188, 1 /* Error */ , "Numeric_separators_are_not_allowed_here_6188", "Numeric separators are not allowed here."),
                Multiple_consecutive_numeric_separators_are_not_permitted: diag(6189, 1 /* Error */ , "Multiple_consecutive_numeric_separators_are_not_permitted_6189", "Multiple consecutive numeric separators are not permitted."),
                Whether_to_keep_outdated_console_output_in_watch_mode_instead_of_clearing_the_screen: diag(6191, 3 /* Message */ , "Whether_to_keep_outdated_console_output_in_watch_mode_instead_of_clearing_the_screen_6191", "Whether to keep outdated console output in watch mode instead of clearing the screen."),
                All_imports_in_import_declaration_are_unused: diag(6192, 1 /* Error */ , "All_imports_in_import_declaration_are_unused_6192", "All imports in import declaration are unused.", /*reportsUnnecessary*/ true),
                Found_1_error_Watching_for_file_changes: diag(6193, 3 /* Message */ , "Found_1_error_Watching_for_file_changes_6193", "Found 1 error. Watching for file changes."),
                Found_0_errors_Watching_for_file_changes: diag(6194, 3 /* Message */ , "Found_0_errors_Watching_for_file_changes_6194", "Found {0} errors. Watching for file changes."),
                Resolve_keyof_to_string_valued_property_names_only_no_numbers_or_symbols: diag(6195, 3 /* Message */ , "Resolve_keyof_to_string_valued_property_names_only_no_numbers_or_symbols_6195", "Resolve 'keyof' to string valued property names only (no numbers or symbols)."),
                _0_is_declared_but_never_used: diag(6196, 1 /* Error */ , "_0_is_declared_but_never_used_6196", "'{0}' is declared but never used.", /*reportsUnnecessary*/ true),
                Include_modules_imported_with_json_extension: diag(6197, 3 /* Message */ , "Include_modules_imported_with_json_extension_6197", "Include modules imported with '.json' extension"),
                All_destructured_elements_are_unused: diag(6198, 1 /* Error */ , "All_destructured_elements_are_unused_6198", "All destructured elements are unused.", /*reportsUnnecessary*/ true),
                All_variables_are_unused: diag(6199, 1 /* Error */ , "All_variables_are_unused_6199", "All variables are unused.", /*reportsUnnecessary*/ true),
                Definitions_of_the_following_identifiers_conflict_with_those_in_another_file_Colon_0: diag(6200, 1 /* Error */ , "Definitions_of_the_following_identifiers_conflict_with_those_in_another_file_Colon_0_6200", "Definitions of the following identifiers conflict with those in another file: {0}"),
                Conflicts_are_in_this_file: diag(6201, 3 /* Message */ , "Conflicts_are_in_this_file_6201", "Conflicts are in this file."),
                Project_references_may_not_form_a_circular_graph_Cycle_detected_Colon_0: diag(6202, 1 /* Error */ , "Project_references_may_not_form_a_circular_graph_Cycle_detected_Colon_0_6202", "Project references may not form a circular graph. Cycle detected: {0}"),
                _0_was_also_declared_here: diag(6203, 3 /* Message */ , "_0_was_also_declared_here_6203", "'{0}' was also declared here."),
                and_here: diag(6204, 3 /* Message */ , "and_here_6204", "and here."),
                All_type_parameters_are_unused: diag(6205, 1 /* Error */ , "All_type_parameters_are_unused_6205", "All type parameters are unused."),
                package_json_has_a_typesVersions_field_with_version_specific_path_mappings: diag(6206, 3 /* Message */ , "package_json_has_a_typesVersions_field_with_version_specific_path_mappings_6206", "'package.json' has a 'typesVersions' field with version-specific path mappings."),
                package_json_does_not_have_a_typesVersions_entry_that_matches_version_0: diag(6207, 3 /* Message */ , "package_json_does_not_have_a_typesVersions_entry_that_matches_version_0_6207", "'package.json' does not have a 'typesVersions' entry that matches version '{0}'."),
                package_json_has_a_typesVersions_entry_0_that_matches_compiler_version_1_looking_for_a_pattern_to_match_module_name_2: diag(6208, 3 /* Message */ , "package_json_has_a_typesVersions_entry_0_that_matches_compiler_version_1_looking_for_a_pattern_to_ma_6208", "'package.json' has a 'typesVersions' entry '{0}' that matches compiler version '{1}', looking for a pattern to match module name '{2}'."),
                package_json_has_a_typesVersions_entry_0_that_is_not_a_valid_semver_range: diag(6209, 3 /* Message */ , "package_json_has_a_typesVersions_entry_0_that_is_not_a_valid_semver_range_6209", "'package.json' has a 'typesVersions' entry '{0}' that is not a valid semver range."),
                An_argument_for_0_was_not_provided: diag(6210, 3 /* Message */ , "An_argument_for_0_was_not_provided_6210", "An argument for '{0}' was not provided."),
                An_argument_matching_this_binding_pattern_was_not_provided: diag(6211, 3 /* Message */ , "An_argument_matching_this_binding_pattern_was_not_provided_6211", "An argument matching this binding pattern was not provided."),
                Did_you_mean_to_call_this_expression: diag(6212, 3 /* Message */ , "Did_you_mean_to_call_this_expression_6212", "Did you mean to call this expression?"),
                Did_you_mean_to_use_new_with_this_expression: diag(6213, 3 /* Message */ , "Did_you_mean_to_use_new_with_this_expression_6213", "Did you mean to use 'new' with this expression?"),
                Enable_strict_bind_call_and_apply_methods_on_functions: diag(6214, 3 /* Message */ , "Enable_strict_bind_call_and_apply_methods_on_functions_6214", "Enable strict 'bind', 'call', and 'apply' methods on functions."),
                Using_compiler_options_of_project_reference_redirect_0: diag(6215, 3 /* Message */ , "Using_compiler_options_of_project_reference_redirect_0_6215", "Using compiler options of project reference redirect '{0}'."),
                Found_1_error: diag(6216, 3 /* Message */ , "Found_1_error_6216", "Found 1 error."),
                Found_0_errors: diag(6217, 3 /* Message */ , "Found_0_errors_6217", "Found {0} errors."),
                Module_name_0_was_successfully_resolved_to_1_with_Package_ID_2: diag(6218, 3 /* Message */ , "Module_name_0_was_successfully_resolved_to_1_with_Package_ID_2_6218", "======== Module name '{0}' was successfully resolved to '{1}' with Package ID '{2}'. ========"),
                Type_reference_directive_0_was_successfully_resolved_to_1_with_Package_ID_2_primary_Colon_3: diag(6219, 3 /* Message */ , "Type_reference_directive_0_was_successfully_resolved_to_1_with_Package_ID_2_primary_Colon_3_6219", "======== Type reference directive '{0}' was successfully resolved to '{1}' with Package ID '{2}', primary: {3}. ========"),
                package_json_had_a_falsy_0_field: diag(6220, 3 /* Message */ , "package_json_had_a_falsy_0_field_6220", "'package.json' had a falsy '{0}' field."),
                Disable_use_of_source_files_instead_of_declaration_files_from_referenced_projects: diag(6221, 3 /* Message */ , "Disable_use_of_source_files_instead_of_declaration_files_from_referenced_projects_6221", "Disable use of source files instead of declaration files from referenced projects."),
                Emit_class_fields_with_Define_instead_of_Set: diag(6222, 3 /* Message */ , "Emit_class_fields_with_Define_instead_of_Set_6222", "Emit class fields with Define instead of Set."),
                Generates_a_CPU_profile: diag(6223, 3 /* Message */ , "Generates_a_CPU_profile_6223", "Generates a CPU profile."),
                Disable_solution_searching_for_this_project: diag(6224, 3 /* Message */ , "Disable_solution_searching_for_this_project_6224", "Disable solution searching for this project."),
                Specify_strategy_for_watching_file_Colon_FixedPollingInterval_default_PriorityPollingInterval_DynamicPriorityPolling_FixedChunkSizePolling_UseFsEvents_UseFsEventsOnParentDirectory: diag(6225, 3 /* Message */ , "Specify_strategy_for_watching_file_Colon_FixedPollingInterval_default_PriorityPollingInterval_Dynami_6225", "Specify strategy for watching file: 'FixedPollingInterval' (default), 'PriorityPollingInterval', 'DynamicPriorityPolling', 'FixedChunkSizePolling', 'UseFsEvents', 'UseFsEventsOnParentDirectory'."),
                Specify_strategy_for_watching_directory_on_platforms_that_don_t_support_recursive_watching_natively_Colon_UseFsEvents_default_FixedPollingInterval_DynamicPriorityPolling_FixedChunkSizePolling: diag(6226, 3 /* Message */ , "Specify_strategy_for_watching_directory_on_platforms_that_don_t_support_recursive_watching_natively__6226", "Specify strategy for watching directory on platforms that don't support recursive watching natively: 'UseFsEvents' (default), 'FixedPollingInterval', 'DynamicPriorityPolling', 'FixedChunkSizePolling'."),
                Specify_strategy_for_creating_a_polling_watch_when_it_fails_to_create_using_file_system_events_Colon_FixedInterval_default_PriorityInterval_DynamicPriority_FixedChunkSize: diag(6227, 3 /* Message */ , "Specify_strategy_for_creating_a_polling_watch_when_it_fails_to_create_using_file_system_events_Colon_6227", "Specify strategy for creating a polling watch when it fails to create using file system events: 'FixedInterval' (default), 'PriorityInterval', 'DynamicPriority', 'FixedChunkSize'."),
                Tag_0_expects_at_least_1_arguments_but_the_JSX_factory_2_provides_at_most_3: diag(6229, 1 /* Error */ , "Tag_0_expects_at_least_1_arguments_but_the_JSX_factory_2_provides_at_most_3_6229", "Tag '{0}' expects at least '{1}' arguments, but the JSX factory '{2}' provides at most '{3}'."),
                Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_false_or_null_on_command_line: diag(6230, 1 /* Error */ , "Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_false_or_null_on_command_line_6230", "Option '{0}' can only be specified in 'tsconfig.json' file or set to 'false' or 'null' on command line."),
                Could_not_resolve_the_path_0_with_the_extensions_Colon_1: diag(6231, 1 /* Error */ , "Could_not_resolve_the_path_0_with_the_extensions_Colon_1_6231", "Could not resolve the path '{0}' with the extensions: {1}."),
                Declaration_augments_declaration_in_another_file_This_cannot_be_serialized: diag(6232, 1 /* Error */ , "Declaration_augments_declaration_in_another_file_This_cannot_be_serialized_6232", "Declaration augments declaration in another file. This cannot be serialized."),
                This_is_the_declaration_being_augmented_Consider_moving_the_augmenting_declaration_into_the_same_file: diag(6233, 1 /* Error */ , "This_is_the_declaration_being_augmented_Consider_moving_the_augmenting_declaration_into_the_same_fil_6233", "This is the declaration being augmented. Consider moving the augmenting declaration into the same file."),
                This_expression_is_not_callable_because_it_is_a_get_accessor_Did_you_mean_to_use_it_without: diag(6234, 1 /* Error */ , "This_expression_is_not_callable_because_it_is_a_get_accessor_Did_you_mean_to_use_it_without_6234", "This expression is not callable because it is a 'get' accessor. Did you mean to use it without '()'?"),
                Disable_loading_referenced_projects: diag(6235, 3 /* Message */ , "Disable_loading_referenced_projects_6235", "Disable loading referenced projects."),
                Arguments_for_the_rest_parameter_0_were_not_provided: diag(6236, 1 /* Error */ , "Arguments_for_the_rest_parameter_0_were_not_provided_6236", "Arguments for the rest parameter '{0}' were not provided."),
                Generates_an_event_trace_and_a_list_of_types: diag(6237, 3 /* Message */ , "Generates_an_event_trace_and_a_list_of_types_6237", "Generates an event trace and a list of types."),
                Specify_the_module_specifier_to_be_used_to_import_the_jsx_and_jsxs_factory_functions_from_eg_react: diag(6238, 1 /* Error */ , "Specify_the_module_specifier_to_be_used_to_import_the_jsx_and_jsxs_factory_functions_from_eg_react_6238", "Specify the module specifier to be used to import the 'jsx' and 'jsxs' factory functions from. eg, react"),
                File_0_exists_according_to_earlier_cached_lookups: diag(6239, 3 /* Message */ , "File_0_exists_according_to_earlier_cached_lookups_6239", "File '{0}' exists according to earlier cached lookups."),
                File_0_does_not_exist_according_to_earlier_cached_lookups: diag(6240, 3 /* Message */ , "File_0_does_not_exist_according_to_earlier_cached_lookups_6240", "File '{0}' does not exist according to earlier cached lookups."),
                Resolution_for_type_reference_directive_0_was_found_in_cache_from_location_1: diag(6241, 3 /* Message */ , "Resolution_for_type_reference_directive_0_was_found_in_cache_from_location_1_6241", "Resolution for type reference directive '{0}' was found in cache from location '{1}'."),
                Resolving_type_reference_directive_0_containing_file_1: diag(6242, 3 /* Message */ , "Resolving_type_reference_directive_0_containing_file_1_6242", "======== Resolving type reference directive '{0}', containing file '{1}'. ========"),
                Interpret_optional_property_types_as_written_rather_than_adding_undefined: diag(6243, 3 /* Message */ , "Interpret_optional_property_types_as_written_rather_than_adding_undefined_6243", "Interpret optional property types as written, rather than adding 'undefined'."),
                Modules: diag(6244, 3 /* Message */ , "Modules_6244", "Modules"),
                File_Management: diag(6245, 3 /* Message */ , "File_Management_6245", "File Management"),
                Emit: diag(6246, 3 /* Message */ , "Emit_6246", "Emit"),
                JavaScript_Support: diag(6247, 3 /* Message */ , "JavaScript_Support_6247", "JavaScript Support"),
                Type_Checking: diag(6248, 3 /* Message */ , "Type_Checking_6248", "Type Checking"),
                Editor_Support: diag(6249, 3 /* Message */ , "Editor_Support_6249", "Editor Support"),
                Watch_and_Build_Modes: diag(6250, 3 /* Message */ , "Watch_and_Build_Modes_6250", "Watch and Build Modes"),
                Compiler_Diagnostics: diag(6251, 3 /* Message */ , "Compiler_Diagnostics_6251", "Compiler Diagnostics"),
                Interop_Constraints: diag(6252, 3 /* Message */ , "Interop_Constraints_6252", "Interop Constraints"),
                Backwards_Compatibility: diag(6253, 3 /* Message */ , "Backwards_Compatibility_6253", "Backwards Compatibility"),
                Language_and_Environment: diag(6254, 3 /* Message */ , "Language_and_Environment_6254", "Language and Environment"),
                Projects: diag(6255, 3 /* Message */ , "Projects_6255", "Projects"),
                Output_Formatting: diag(6256, 3 /* Message */ , "Output_Formatting_6256", "Output Formatting"),
                Completeness: diag(6257, 3 /* Message */ , "Completeness_6257", "Completeness"),
                _0_should_be_set_inside_the_compilerOptions_object_of_the_config_json_file: diag(6258, 1 /* Error */ , "_0_should_be_set_inside_the_compilerOptions_object_of_the_config_json_file_6258", "'{0}' should be set inside the 'compilerOptions' object of the config json file"),
                Found_1_error_in_0: diag(6259, 3 /* Message */ , "Found_1_error_in_0_6259", "Found 1 error in {0}"),
                Found_0_errors_in_the_same_file_starting_at_Colon_1: diag(6260, 3 /* Message */ , "Found_0_errors_in_the_same_file_starting_at_Colon_1_6260", "Found {0} errors in the same file, starting at: {1}"),
                Found_0_errors_in_1_files: diag(6261, 3 /* Message */ , "Found_0_errors_in_1_files_6261", "Found {0} errors in {1} files."),
                File_name_0_has_a_1_extension_looking_up_2_instead: diag(6262, 3 /* Message */ , "File_name_0_has_a_1_extension_looking_up_2_instead_6262", "File name '{0}' has a '{1}' extension - looking up '{2}' instead."),
                Module_0_was_resolved_to_1_but_allowArbitraryExtensions_is_not_set: diag(6263, 1 /* Error */ , "Module_0_was_resolved_to_1_but_allowArbitraryExtensions_is_not_set_6263", "Module '{0}' was resolved to '{1}', but '--allowArbitraryExtensions' is not set."),
                Enable_importing_files_with_any_extension_provided_a_declaration_file_is_present: diag(6264, 3 /* Message */ , "Enable_importing_files_with_any_extension_provided_a_declaration_file_is_present_6264", "Enable importing files with any extension, provided a declaration file is present."),
                Resolving_type_reference_directive_for_program_that_specifies_custom_typeRoots_skipping_lookup_in_node_modules_folder: diag(6265, 3 /* Message */ , "Resolving_type_reference_directive_for_program_that_specifies_custom_typeRoots_skipping_lookup_in_no_6265", "Resolving type reference directive for program that specifies custom typeRoots, skipping lookup in 'node_modules' folder."),
                Option_0_can_only_be_specified_on_command_line: diag(6266, 1 /* Error */ , "Option_0_can_only_be_specified_on_command_line_6266", "Option '{0}' can only be specified on command line."),
                Directory_0_has_no_containing_package_json_scope_Imports_will_not_resolve: diag(6270, 3 /* Message */ , "Directory_0_has_no_containing_package_json_scope_Imports_will_not_resolve_6270", "Directory '{0}' has no containing package.json scope. Imports will not resolve."),
                Import_specifier_0_does_not_exist_in_package_json_scope_at_path_1: diag(6271, 3 /* Message */ , "Import_specifier_0_does_not_exist_in_package_json_scope_at_path_1_6271", "Import specifier '{0}' does not exist in package.json scope at path '{1}'."),
                Invalid_import_specifier_0_has_no_possible_resolutions: diag(6272, 3 /* Message */ , "Invalid_import_specifier_0_has_no_possible_resolutions_6272", "Invalid import specifier '{0}' has no possible resolutions."),
                package_json_scope_0_has_no_imports_defined: diag(6273, 3 /* Message */ , "package_json_scope_0_has_no_imports_defined_6273", "package.json scope '{0}' has no imports defined."),
                package_json_scope_0_explicitly_maps_specifier_1_to_null: diag(6274, 3 /* Message */ , "package_json_scope_0_explicitly_maps_specifier_1_to_null_6274", "package.json scope '{0}' explicitly maps specifier '{1}' to null."),
                package_json_scope_0_has_invalid_type_for_target_of_specifier_1: diag(6275, 3 /* Message */ , "package_json_scope_0_has_invalid_type_for_target_of_specifier_1_6275", "package.json scope '{0}' has invalid type for target of specifier '{1}'"),
                Export_specifier_0_does_not_exist_in_package_json_scope_at_path_1: diag(6276, 3 /* Message */ , "Export_specifier_0_does_not_exist_in_package_json_scope_at_path_1_6276", "Export specifier '{0}' does not exist in package.json scope at path '{1}'."),
                Resolution_of_non_relative_name_failed_trying_with_modern_Node_resolution_features_disabled_to_see_if_npm_library_needs_configuration_update: diag(6277, 3 /* Message */ , "Resolution_of_non_relative_name_failed_trying_with_modern_Node_resolution_features_disabled_to_see_i_6277", "Resolution of non-relative name failed; trying with modern Node resolution features disabled to see if npm library needs configuration update."),
                There_are_types_at_0_but_this_result_could_not_be_resolved_when_respecting_package_json_exports_The_1_library_may_need_to_update_its_package_json_or_typings: diag(6278, 3 /* Message */ , "There_are_types_at_0_but_this_result_could_not_be_resolved_when_respecting_package_json_exports_The__6278", `There are types at '{0}', but this result could not be resolved when respecting package.json "exports". The '{1}' library may need to update its package.json or typings.`),
                Enable_project_compilation: diag(6302, 3 /* Message */ , "Enable_project_compilation_6302", "Enable project compilation"),
                Composite_projects_may_not_disable_declaration_emit: diag(6304, 1 /* Error */ , "Composite_projects_may_not_disable_declaration_emit_6304", "Composite projects may not disable declaration emit."),
                Output_file_0_has_not_been_built_from_source_file_1: diag(6305, 1 /* Error */ , "Output_file_0_has_not_been_built_from_source_file_1_6305", "Output file '{0}' has not been built from source file '{1}'."),
                Referenced_project_0_must_have_setting_composite_Colon_true: diag(6306, 1 /* Error */ , "Referenced_project_0_must_have_setting_composite_Colon_true_6306", `Referenced project '{0}' must have setting "composite": true.`),
                File_0_is_not_listed_within_the_file_list_of_project_1_Projects_must_list_all_files_or_use_an_include_pattern: diag(6307, 1 /* Error */ , "File_0_is_not_listed_within_the_file_list_of_project_1_Projects_must_list_all_files_or_use_an_includ_6307", "File '{0}' is not listed within the file list of project '{1}'. Projects must list all files or use an 'include' pattern."),
                Cannot_prepend_project_0_because_it_does_not_have_outFile_set: diag(6308, 1 /* Error */ , "Cannot_prepend_project_0_because_it_does_not_have_outFile_set_6308", "Cannot prepend project '{0}' because it does not have 'outFile' set"),
                Output_file_0_from_project_1_does_not_exist: diag(6309, 1 /* Error */ , "Output_file_0_from_project_1_does_not_exist_6309", "Output file '{0}' from project '{1}' does not exist"),
                Referenced_project_0_may_not_disable_emit: diag(6310, 1 /* Error */ , "Referenced_project_0_may_not_disable_emit_6310", "Referenced project '{0}' may not disable emit."),
                Project_0_is_out_of_date_because_output_1_is_older_than_input_2: diag(6350, 3 /* Message */ , "Project_0_is_out_of_date_because_output_1_is_older_than_input_2_6350", "Project '{0}' is out of date because output '{1}' is older than input '{2}'"),
                Project_0_is_up_to_date_because_newest_input_1_is_older_than_output_2: diag(6351, 3 /* Message */ , "Project_0_is_up_to_date_because_newest_input_1_is_older_than_output_2_6351", "Project '{0}' is up to date because newest input '{1}' is older than output '{2}'"),
                Project_0_is_out_of_date_because_output_file_1_does_not_exist: diag(6352, 3 /* Message */ , "Project_0_is_out_of_date_because_output_file_1_does_not_exist_6352", "Project '{0}' is out of date because output file '{1}' does not exist"),
                Project_0_is_out_of_date_because_its_dependency_1_is_out_of_date: diag(6353, 3 /* Message */ , "Project_0_is_out_of_date_because_its_dependency_1_is_out_of_date_6353", "Project '{0}' is out of date because its dependency '{1}' is out of date"),
                Project_0_is_up_to_date_with_d_ts_files_from_its_dependencies: diag(6354, 3 /* Message */ , "Project_0_is_up_to_date_with_d_ts_files_from_its_dependencies_6354", "Project '{0}' is up to date with .d.ts files from its dependencies"),
                Projects_in_this_build_Colon_0: diag(6355, 3 /* Message */ , "Projects_in_this_build_Colon_0_6355", "Projects in this build: {0}"),
                A_non_dry_build_would_delete_the_following_files_Colon_0: diag(6356, 3 /* Message */ , "A_non_dry_build_would_delete_the_following_files_Colon_0_6356", "A non-dry build would delete the following files: {0}"),
                A_non_dry_build_would_build_project_0: diag(6357, 3 /* Message */ , "A_non_dry_build_would_build_project_0_6357", "A non-dry build would build project '{0}'"),
                Building_project_0: diag(6358, 3 /* Message */ , "Building_project_0_6358", "Building project '{0}'..."),
                Updating_output_timestamps_of_project_0: diag(6359, 3 /* Message */ , "Updating_output_timestamps_of_project_0_6359", "Updating output timestamps of project '{0}'..."),
                Project_0_is_up_to_date: diag(6361, 3 /* Message */ , "Project_0_is_up_to_date_6361", "Project '{0}' is up to date"),
                Skipping_build_of_project_0_because_its_dependency_1_has_errors: diag(6362, 3 /* Message */ , "Skipping_build_of_project_0_because_its_dependency_1_has_errors_6362", "Skipping build of project '{0}' because its dependency '{1}' has errors"),
                Project_0_can_t_be_built_because_its_dependency_1_has_errors: diag(6363, 3 /* Message */ , "Project_0_can_t_be_built_because_its_dependency_1_has_errors_6363", "Project '{0}' can't be built because its dependency '{1}' has errors"),
                Build_one_or_more_projects_and_their_dependencies_if_out_of_date: diag(6364, 3 /* Message */ , "Build_one_or_more_projects_and_their_dependencies_if_out_of_date_6364", "Build one or more projects and their dependencies, if out of date"),
                Delete_the_outputs_of_all_projects: diag(6365, 3 /* Message */ , "Delete_the_outputs_of_all_projects_6365", "Delete the outputs of all projects."),
                Show_what_would_be_built_or_deleted_if_specified_with_clean: diag(6367, 3 /* Message */ , "Show_what_would_be_built_or_deleted_if_specified_with_clean_6367", "Show what would be built (or deleted, if specified with '--clean')"),
                Option_build_must_be_the_first_command_line_argument: diag(6369, 1 /* Error */ , "Option_build_must_be_the_first_command_line_argument_6369", "Option '--build' must be the first command line argument."),
                Options_0_and_1_cannot_be_combined: diag(6370, 1 /* Error */ , "Options_0_and_1_cannot_be_combined_6370", "Options '{0}' and '{1}' cannot be combined."),
                Updating_unchanged_output_timestamps_of_project_0: diag(6371, 3 /* Message */ , "Updating_unchanged_output_timestamps_of_project_0_6371", "Updating unchanged output timestamps of project '{0}'..."),
                Project_0_is_out_of_date_because_output_of_its_dependency_1_has_changed: diag(6372, 3 /* Message */ , "Project_0_is_out_of_date_because_output_of_its_dependency_1_has_changed_6372", "Project '{0}' is out of date because output of its dependency '{1}' has changed"),
                Updating_output_of_project_0: diag(6373, 3 /* Message */ , "Updating_output_of_project_0_6373", "Updating output of project '{0}'..."),
                A_non_dry_build_would_update_timestamps_for_output_of_project_0: diag(6374, 3 /* Message */ , "A_non_dry_build_would_update_timestamps_for_output_of_project_0_6374", "A non-dry build would update timestamps for output of project '{0}'"),
                A_non_dry_build_would_update_output_of_project_0: diag(6375, 3 /* Message */ , "A_non_dry_build_would_update_output_of_project_0_6375", "A non-dry build would update output of project '{0}'"),
                Cannot_update_output_of_project_0_because_there_was_error_reading_file_1: diag(6376, 3 /* Message */ , "Cannot_update_output_of_project_0_because_there_was_error_reading_file_1_6376", "Cannot update output of project '{0}' because there was error reading file '{1}'"),
                Cannot_write_file_0_because_it_will_overwrite_tsbuildinfo_file_generated_by_referenced_project_1: diag(6377, 1 /* Error */ , "Cannot_write_file_0_because_it_will_overwrite_tsbuildinfo_file_generated_by_referenced_project_1_6377", "Cannot write file '{0}' because it will overwrite '.tsbuildinfo' file generated by referenced project '{1}'"),
                Composite_projects_may_not_disable_incremental_compilation: diag(6379, 1 /* Error */ , "Composite_projects_may_not_disable_incremental_compilation_6379", "Composite projects may not disable incremental compilation."),
                Specify_file_to_store_incremental_compilation_information: diag(6380, 3 /* Message */ , "Specify_file_to_store_incremental_compilation_information_6380", "Specify file to store incremental compilation information"),
                Project_0_is_out_of_date_because_output_for_it_was_generated_with_version_1_that_differs_with_current_version_2: diag(6381, 3 /* Message */ , "Project_0_is_out_of_date_because_output_for_it_was_generated_with_version_1_that_differs_with_curren_6381", "Project '{0}' is out of date because output for it was generated with version '{1}' that differs with current version '{2}'"),
                Skipping_build_of_project_0_because_its_dependency_1_was_not_built: diag(6382, 3 /* Message */ , "Skipping_build_of_project_0_because_its_dependency_1_was_not_built_6382", "Skipping build of project '{0}' because its dependency '{1}' was not built"),
                Project_0_can_t_be_built_because_its_dependency_1_was_not_built: diag(6383, 3 /* Message */ , "Project_0_can_t_be_built_because_its_dependency_1_was_not_built_6383", "Project '{0}' can't be built because its dependency '{1}' was not built"),
                Have_recompiles_in_incremental_and_watch_assume_that_changes_within_a_file_will_only_affect_files_directly_depending_on_it: diag(6384, 3 /* Message */ , "Have_recompiles_in_incremental_and_watch_assume_that_changes_within_a_file_will_only_affect_files_di_6384", "Have recompiles in '--incremental' and '--watch' assume that changes within a file will only affect files directly depending on it."),
                _0_is_deprecated: diag(6385, 2 /* Suggestion */ , "_0_is_deprecated_6385", "'{0}' is deprecated.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ void 0, /*reportsDeprecated*/ true),
                Performance_timings_for_diagnostics_or_extendedDiagnostics_are_not_available_in_this_session_A_native_implementation_of_the_Web_Performance_API_could_not_be_found: diag(6386, 3 /* Message */ , "Performance_timings_for_diagnostics_or_extendedDiagnostics_are_not_available_in_this_session_A_nativ_6386", "Performance timings for '--diagnostics' or '--extendedDiagnostics' are not available in this session. A native implementation of the Web Performance API could not be found."),
                The_signature_0_of_1_is_deprecated: diag(6387, 2 /* Suggestion */ , "The_signature_0_of_1_is_deprecated_6387", "The signature '{0}' of '{1}' is deprecated.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ void 0, /*reportsDeprecated*/ true),
                Project_0_is_being_forcibly_rebuilt: diag(6388, 3 /* Message */ , "Project_0_is_being_forcibly_rebuilt_6388", "Project '{0}' is being forcibly rebuilt"),
                Reusing_resolution_of_module_0_from_1_of_old_program_it_was_not_resolved: diag(6389, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_of_old_program_it_was_not_resolved_6389", "Reusing resolution of module '{0}' from '{1}' of old program, it was not resolved."),
                Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2: diag(6390, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved__6390", "Reusing resolution of type reference directive '{0}' from '{1}' of old program, it was successfully resolved to '{2}'."),
                Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3: diag(6391, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved__6391", "Reusing resolution of type reference directive '{0}' from '{1}' of old program, it was successfully resolved to '{2}' with Package ID '{3}'."),
                Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_not_resolved: diag(6392, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_not_resolved_6392", "Reusing resolution of type reference directive '{0}' from '{1}' of old program, it was not resolved."),
                Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_3: diag(6393, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_6393", "Reusing resolution of module '{0}' from '{1}' found in cache from location '{2}', it was successfully resolved to '{3}'."),
                Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_3_with_Package_ID_4: diag(6394, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_6394", "Reusing resolution of module '{0}' from '{1}' found in cache from location '{2}', it was successfully resolved to '{3}' with Package ID '{4}'."),
                Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_not_resolved: diag(6395, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_not_resolved_6395", "Reusing resolution of module '{0}' from '{1}' found in cache from location '{2}', it was not resolved."),
                Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_3: diag(6396, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_succes_6396", "Reusing resolution of type reference directive '{0}' from '{1}' found in cache from location '{2}', it was successfully resolved to '{3}'."),
                Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_3_with_Package_ID_4: diag(6397, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_succes_6397", "Reusing resolution of type reference directive '{0}' from '{1}' found in cache from location '{2}', it was successfully resolved to '{3}' with Package ID '{4}'."),
                Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_not_resolved: diag(6398, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_not_re_6398", "Reusing resolution of type reference directive '{0}' from '{1}' found in cache from location '{2}', it was not resolved."),
                Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_some_of_the_changes_were_not_emitted: diag(6399, 3 /* Message */ , "Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_some_of_the_changes_were_not_emitte_6399", "Project '{0}' is out of date because buildinfo file '{1}' indicates that some of the changes were not emitted"),
                Project_0_is_up_to_date_but_needs_to_update_timestamps_of_output_files_that_are_older_than_input_files: diag(6400, 3 /* Message */ , "Project_0_is_up_to_date_but_needs_to_update_timestamps_of_output_files_that_are_older_than_input_fil_6400", "Project '{0}' is up to date but needs to update timestamps of output files that are older than input files"),
                Project_0_is_out_of_date_because_there_was_error_reading_file_1: diag(6401, 3 /* Message */ , "Project_0_is_out_of_date_because_there_was_error_reading_file_1_6401", "Project '{0}' is out of date because there was error reading file '{1}'"),
                Resolving_in_0_mode_with_conditions_1: diag(6402, 3 /* Message */ , "Resolving_in_0_mode_with_conditions_1_6402", "Resolving in {0} mode with conditions {1}."),
                Matched_0_condition_1: diag(6403, 3 /* Message */ , "Matched_0_condition_1_6403", "Matched '{0}' condition '{1}'."),
                Using_0_subpath_1_with_target_2: diag(6404, 3 /* Message */ , "Using_0_subpath_1_with_target_2_6404", "Using '{0}' subpath '{1}' with target '{2}'."),
                Saw_non_matching_condition_0: diag(6405, 3 /* Message */ , "Saw_non_matching_condition_0_6405", "Saw non-matching condition '{0}'."),
                Project_0_is_out_of_date_because_buildinfo_file_1_indicates_there_is_change_in_compilerOptions: diag(6406, 3 /* Message */ , "Project_0_is_out_of_date_because_buildinfo_file_1_indicates_there_is_change_in_compilerOptions_6406", "Project '{0}' is out of date because buildinfo file '{1}' indicates there is change in compilerOptions"),
                Allow_imports_to_include_TypeScript_file_extensions_Requires_moduleResolution_bundler_and_either_noEmit_or_emitDeclarationOnly_to_be_set: diag(6407, 3 /* Message */ , "Allow_imports_to_include_TypeScript_file_extensions_Requires_moduleResolution_bundler_and_either_noE_6407", "Allow imports to include TypeScript file extensions. Requires '--moduleResolution bundler' and either '--noEmit' or '--emitDeclarationOnly' to be set."),
                Use_the_package_json_exports_field_when_resolving_package_imports: diag(6408, 3 /* Message */ , "Use_the_package_json_exports_field_when_resolving_package_imports_6408", "Use the package.json 'exports' field when resolving package imports."),
                Use_the_package_json_imports_field_when_resolving_imports: diag(6409, 3 /* Message */ , "Use_the_package_json_imports_field_when_resolving_imports_6409", "Use the package.json 'imports' field when resolving imports."),
                Conditions_to_set_in_addition_to_the_resolver_specific_defaults_when_resolving_imports: diag(6410, 3 /* Message */ , "Conditions_to_set_in_addition_to_the_resolver_specific_defaults_when_resolving_imports_6410", "Conditions to set in addition to the resolver-specific defaults when resolving imports."),
                true_when_moduleResolution_is_node16_nodenext_or_bundler_otherwise_false: diag(6411, 3 /* Message */ , "true_when_moduleResolution_is_node16_nodenext_or_bundler_otherwise_false_6411", "`true` when 'moduleResolution' is 'node16', 'nodenext', or 'bundler'; otherwise `false`."),
                Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_file_2_was_root_file_of_compilation_but_not_any_more: diag(6412, 3 /* Message */ , "Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_file_2_was_root_file_of_compilation_6412", "Project '{0}' is out of date because buildinfo file '{1}' indicates that file '{2}' was root file of compilation but not any more."),
                Entering_conditional_exports: diag(6413, 3 /* Message */ , "Entering_conditional_exports_6413", "Entering conditional exports."),
                Resolved_under_condition_0: diag(6414, 3 /* Message */ , "Resolved_under_condition_0_6414", "Resolved under condition '{0}'."),
                Failed_to_resolve_under_condition_0: diag(6415, 3 /* Message */ , "Failed_to_resolve_under_condition_0_6415", "Failed to resolve under condition '{0}'."),
                Exiting_conditional_exports: diag(6416, 3 /* Message */ , "Exiting_conditional_exports_6416", "Exiting conditional exports."),
                The_expected_type_comes_from_property_0_which_is_declared_here_on_type_1: diag(6500, 3 /* Message */ , "The_expected_type_comes_from_property_0_which_is_declared_here_on_type_1_6500", "The expected type comes from property '{0}' which is declared here on type '{1}'"),
                The_expected_type_comes_from_this_index_signature: diag(6501, 3 /* Message */ , "The_expected_type_comes_from_this_index_signature_6501", "The expected type comes from this index signature."),
                The_expected_type_comes_from_the_return_type_of_this_signature: diag(6502, 3 /* Message */ , "The_expected_type_comes_from_the_return_type_of_this_signature_6502", "The expected type comes from the return type of this signature."),
                Print_names_of_files_that_are_part_of_the_compilation_and_then_stop_processing: diag(6503, 3 /* Message */ , "Print_names_of_files_that_are_part_of_the_compilation_and_then_stop_processing_6503", "Print names of files that are part of the compilation and then stop processing."),
                File_0_is_a_JavaScript_file_Did_you_mean_to_enable_the_allowJs_option: diag(6504, 1 /* Error */ , "File_0_is_a_JavaScript_file_Did_you_mean_to_enable_the_allowJs_option_6504", "File '{0}' is a JavaScript file. Did you mean to enable the 'allowJs' option?"),
                Print_names_of_files_and_the_reason_they_are_part_of_the_compilation: diag(6505, 3 /* Message */ , "Print_names_of_files_and_the_reason_they_are_part_of_the_compilation_6505", "Print names of files and the reason they are part of the compilation."),
                Consider_adding_a_declare_modifier_to_this_class: diag(6506, 3 /* Message */ , "Consider_adding_a_declare_modifier_to_this_class_6506", "Consider adding a 'declare' modifier to this class."),
                Allow_JavaScript_files_to_be_a_part_of_your_program_Use_the_checkJS_option_to_get_errors_from_these_files: diag(6600, 3 /* Message */ , "Allow_JavaScript_files_to_be_a_part_of_your_program_Use_the_checkJS_option_to_get_errors_from_these__6600", "Allow JavaScript files to be a part of your program. Use the 'checkJS' option to get errors from these files."),
                Allow_import_x_from_y_when_a_module_doesn_t_have_a_default_export: diag(6601, 3 /* Message */ , "Allow_import_x_from_y_when_a_module_doesn_t_have_a_default_export_6601", "Allow 'import x from y' when a module doesn't have a default export."),
                Allow_accessing_UMD_globals_from_modules: diag(6602, 3 /* Message */ , "Allow_accessing_UMD_globals_from_modules_6602", "Allow accessing UMD globals from modules."),
                Disable_error_reporting_for_unreachable_code: diag(6603, 3 /* Message */ , "Disable_error_reporting_for_unreachable_code_6603", "Disable error reporting for unreachable code."),
                Disable_error_reporting_for_unused_labels: diag(6604, 3 /* Message */ , "Disable_error_reporting_for_unused_labels_6604", "Disable error reporting for unused labels."),
                Ensure_use_strict_is_always_emitted: diag(6605, 3 /* Message */ , "Ensure_use_strict_is_always_emitted_6605", "Ensure 'use strict' is always emitted."),
                Have_recompiles_in_projects_that_use_incremental_and_watch_mode_assume_that_changes_within_a_file_will_only_affect_files_directly_depending_on_it: diag(6606, 3 /* Message */ , "Have_recompiles_in_projects_that_use_incremental_and_watch_mode_assume_that_changes_within_a_file_wi_6606", "Have recompiles in projects that use 'incremental' and 'watch' mode assume that changes within a file will only affect files directly depending on it."),
                Specify_the_base_directory_to_resolve_non_relative_module_names: diag(6607, 3 /* Message */ , "Specify_the_base_directory_to_resolve_non_relative_module_names_6607", "Specify the base directory to resolve non-relative module names."),
                No_longer_supported_In_early_versions_manually_set_the_text_encoding_for_reading_files: diag(6608, 3 /* Message */ , "No_longer_supported_In_early_versions_manually_set_the_text_encoding_for_reading_files_6608", "No longer supported. In early versions, manually set the text encoding for reading files."),
                Enable_error_reporting_in_type_checked_JavaScript_files: diag(6609, 3 /* Message */ , "Enable_error_reporting_in_type_checked_JavaScript_files_6609", "Enable error reporting in type-checked JavaScript files."),
                Enable_constraints_that_allow_a_TypeScript_project_to_be_used_with_project_references: diag(6611, 3 /* Message */ , "Enable_constraints_that_allow_a_TypeScript_project_to_be_used_with_project_references_6611", "Enable constraints that allow a TypeScript project to be used with project references."),
                Generate_d_ts_files_from_TypeScript_and_JavaScript_files_in_your_project: diag(6612, 3 /* Message */ , "Generate_d_ts_files_from_TypeScript_and_JavaScript_files_in_your_project_6612", "Generate .d.ts files from TypeScript and JavaScript files in your project."),
                Specify_the_output_directory_for_generated_declaration_files: diag(6613, 3 /* Message */ , "Specify_the_output_directory_for_generated_declaration_files_6613", "Specify the output directory for generated declaration files."),
                Create_sourcemaps_for_d_ts_files: diag(6614, 3 /* Message */ , "Create_sourcemaps_for_d_ts_files_6614", "Create sourcemaps for d.ts files."),
                Output_compiler_performance_information_after_building: diag(6615, 3 /* Message */ , "Output_compiler_performance_information_after_building_6615", "Output compiler performance information after building."),
                Disables_inference_for_type_acquisition_by_looking_at_filenames_in_a_project: diag(6616, 3 /* Message */ , "Disables_inference_for_type_acquisition_by_looking_at_filenames_in_a_project_6616", "Disables inference for type acquisition by looking at filenames in a project."),
                Reduce_the_number_of_projects_loaded_automatically_by_TypeScript: diag(6617, 3 /* Message */ , "Reduce_the_number_of_projects_loaded_automatically_by_TypeScript_6617", "Reduce the number of projects loaded automatically by TypeScript."),
                Remove_the_20mb_cap_on_total_source_code_size_for_JavaScript_files_in_the_TypeScript_language_server: diag(6618, 3 /* Message */ , "Remove_the_20mb_cap_on_total_source_code_size_for_JavaScript_files_in_the_TypeScript_language_server_6618", "Remove the 20mb cap on total source code size for JavaScript files in the TypeScript language server."),
                Opt_a_project_out_of_multi_project_reference_checking_when_editing: diag(6619, 3 /* Message */ , "Opt_a_project_out_of_multi_project_reference_checking_when_editing_6619", "Opt a project out of multi-project reference checking when editing."),
                Disable_preferring_source_files_instead_of_declaration_files_when_referencing_composite_projects: diag(6620, 3 /* Message */ , "Disable_preferring_source_files_instead_of_declaration_files_when_referencing_composite_projects_6620", "Disable preferring source files instead of declaration files when referencing composite projects."),
                Emit_more_compliant_but_verbose_and_less_performant_JavaScript_for_iteration: diag(6621, 3 /* Message */ , "Emit_more_compliant_but_verbose_and_less_performant_JavaScript_for_iteration_6621", "Emit more compliant, but verbose and less performant JavaScript for iteration."),
                Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files: diag(6622, 3 /* Message */ , "Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files_6622", "Emit a UTF-8 Byte Order Mark (BOM) in the beginning of output files."),
                Only_output_d_ts_files_and_not_JavaScript_files: diag(6623, 3 /* Message */ , "Only_output_d_ts_files_and_not_JavaScript_files_6623", "Only output d.ts files and not JavaScript files."),
                Emit_design_type_metadata_for_decorated_declarations_in_source_files: diag(6624, 3 /* Message */ , "Emit_design_type_metadata_for_decorated_declarations_in_source_files_6624", "Emit design-type metadata for decorated declarations in source files."),
                Disable_the_type_acquisition_for_JavaScript_projects: diag(6625, 3 /* Message */ , "Disable_the_type_acquisition_for_JavaScript_projects_6625", "Disable the type acquisition for JavaScript projects"),
                Emit_additional_JavaScript_to_ease_support_for_importing_CommonJS_modules_This_enables_allowSyntheticDefaultImports_for_type_compatibility: diag(6626, 3 /* Message */ , "Emit_additional_JavaScript_to_ease_support_for_importing_CommonJS_modules_This_enables_allowSyntheti_6626", "Emit additional JavaScript to ease support for importing CommonJS modules. This enables 'allowSyntheticDefaultImports' for type compatibility."),
                Filters_results_from_the_include_option: diag(6627, 3 /* Message */ , "Filters_results_from_the_include_option_6627", "Filters results from the `include` option."),
                Remove_a_list_of_directories_from_the_watch_process: diag(6628, 3 /* Message */ , "Remove_a_list_of_directories_from_the_watch_process_6628", "Remove a list of directories from the watch process."),
                Remove_a_list_of_files_from_the_watch_mode_s_processing: diag(6629, 3 /* Message */ , "Remove_a_list_of_files_from_the_watch_mode_s_processing_6629", "Remove a list of files from the watch mode's processing."),
                Enable_experimental_support_for_legacy_experimental_decorators: diag(6630, 3 /* Message */ , "Enable_experimental_support_for_legacy_experimental_decorators_6630", "Enable experimental support for legacy experimental decorators."),
                Print_files_read_during_the_compilation_including_why_it_was_included: diag(6631, 3 /* Message */ , "Print_files_read_during_the_compilation_including_why_it_was_included_6631", "Print files read during the compilation including why it was included."),
                Output_more_detailed_compiler_performance_information_after_building: diag(6632, 3 /* Message */ , "Output_more_detailed_compiler_performance_information_after_building_6632", "Output more detailed compiler performance information after building."),
                Specify_one_or_more_path_or_node_module_references_to_base_configuration_files_from_which_settings_are_inherited: diag(6633, 3 /* Message */ , "Specify_one_or_more_path_or_node_module_references_to_base_configuration_files_from_which_settings_a_6633", "Specify one or more path or node module references to base configuration files from which settings are inherited."),
                Specify_what_approach_the_watcher_should_use_if_the_system_runs_out_of_native_file_watchers: diag(6634, 3 /* Message */ , "Specify_what_approach_the_watcher_should_use_if_the_system_runs_out_of_native_file_watchers_6634", "Specify what approach the watcher should use if the system runs out of native file watchers."),
                Include_a_list_of_files_This_does_not_support_glob_patterns_as_opposed_to_include: diag(6635, 3 /* Message */ , "Include_a_list_of_files_This_does_not_support_glob_patterns_as_opposed_to_include_6635", "Include a list of files. This does not support glob patterns, as opposed to `include`."),
                Build_all_projects_including_those_that_appear_to_be_up_to_date: diag(6636, 3 /* Message */ , "Build_all_projects_including_those_that_appear_to_be_up_to_date_6636", "Build all projects, including those that appear to be up to date."),
                Ensure_that_casing_is_correct_in_imports: diag(6637, 3 /* Message */ , "Ensure_that_casing_is_correct_in_imports_6637", "Ensure that casing is correct in imports."),
                Emit_a_v8_CPU_profile_of_the_compiler_run_for_debugging: diag(6638, 3 /* Message */ , "Emit_a_v8_CPU_profile_of_the_compiler_run_for_debugging_6638", "Emit a v8 CPU profile of the compiler run for debugging."),
                Allow_importing_helper_functions_from_tslib_once_per_project_instead_of_including_them_per_file: diag(6639, 3 /* Message */ , "Allow_importing_helper_functions_from_tslib_once_per_project_instead_of_including_them_per_file_6639", "Allow importing helper functions from tslib once per project, instead of including them per-file."),
                Specify_a_list_of_glob_patterns_that_match_files_to_be_included_in_compilation: diag(6641, 3 /* Message */ , "Specify_a_list_of_glob_patterns_that_match_files_to_be_included_in_compilation_6641", "Specify a list of glob patterns that match files to be included in compilation."),
                Save_tsbuildinfo_files_to_allow_for_incremental_compilation_of_projects: diag(6642, 3 /* Message */ , "Save_tsbuildinfo_files_to_allow_for_incremental_compilation_of_projects_6642", "Save .tsbuildinfo files to allow for incremental compilation of projects."),
                Include_sourcemap_files_inside_the_emitted_JavaScript: diag(6643, 3 /* Message */ , "Include_sourcemap_files_inside_the_emitted_JavaScript_6643", "Include sourcemap files inside the emitted JavaScript."),
                Include_source_code_in_the_sourcemaps_inside_the_emitted_JavaScript: diag(6644, 3 /* Message */ , "Include_source_code_in_the_sourcemaps_inside_the_emitted_JavaScript_6644", "Include source code in the sourcemaps inside the emitted JavaScript."),
                Ensure_that_each_file_can_be_safely_transpiled_without_relying_on_other_imports: diag(6645, 3 /* Message */ , "Ensure_that_each_file_can_be_safely_transpiled_without_relying_on_other_imports_6645", "Ensure that each file can be safely transpiled without relying on other imports."),
                Specify_what_JSX_code_is_generated: diag(6646, 3 /* Message */ , "Specify_what_JSX_code_is_generated_6646", "Specify what JSX code is generated."),
                Specify_the_JSX_factory_function_used_when_targeting_React_JSX_emit_e_g_React_createElement_or_h: diag(6647, 3 /* Message */ , "Specify_the_JSX_factory_function_used_when_targeting_React_JSX_emit_e_g_React_createElement_or_h_6647", "Specify the JSX factory function used when targeting React JSX emit, e.g. 'React.createElement' or 'h'."),
                Specify_the_JSX_Fragment_reference_used_for_fragments_when_targeting_React_JSX_emit_e_g_React_Fragment_or_Fragment: diag(6648, 3 /* Message */ , "Specify_the_JSX_Fragment_reference_used_for_fragments_when_targeting_React_JSX_emit_e_g_React_Fragme_6648", "Specify the JSX Fragment reference used for fragments when targeting React JSX emit e.g. 'React.Fragment' or 'Fragment'."),
                Specify_module_specifier_used_to_import_the_JSX_factory_functions_when_using_jsx_Colon_react_jsx_Asterisk: diag(6649, 3 /* Message */ , "Specify_module_specifier_used_to_import_the_JSX_factory_functions_when_using_jsx_Colon_react_jsx_Ast_6649", "Specify module specifier used to import the JSX factory functions when using 'jsx: react-jsx*'."),
                Make_keyof_only_return_strings_instead_of_string_numbers_or_symbols_Legacy_option: diag(6650, 3 /* Message */ , "Make_keyof_only_return_strings_instead_of_string_numbers_or_symbols_Legacy_option_6650", "Make keyof only return strings instead of string, numbers or symbols. Legacy option."),
                Specify_a_set_of_bundled_library_declaration_files_that_describe_the_target_runtime_environment: diag(6651, 3 /* Message */ , "Specify_a_set_of_bundled_library_declaration_files_that_describe_the_target_runtime_environment_6651", "Specify a set of bundled library declaration files that describe the target runtime environment."),
                Print_the_names_of_emitted_files_after_a_compilation: diag(6652, 3 /* Message */ , "Print_the_names_of_emitted_files_after_a_compilation_6652", "Print the names of emitted files after a compilation."),
                Print_all_of_the_files_read_during_the_compilation: diag(6653, 3 /* Message */ , "Print_all_of_the_files_read_during_the_compilation_6653", "Print all of the files read during the compilation."),
                Set_the_language_of_the_messaging_from_TypeScript_This_does_not_affect_emit: diag(6654, 3 /* Message */ , "Set_the_language_of_the_messaging_from_TypeScript_This_does_not_affect_emit_6654", "Set the language of the messaging from TypeScript. This does not affect emit."),
                Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations: diag(6655, 3 /* Message */ , "Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations_6655", "Specify the location where debugger should locate map files instead of generated locations."),
                Specify_the_maximum_folder_depth_used_for_checking_JavaScript_files_from_node_modules_Only_applicable_with_allowJs: diag(6656, 3 /* Message */ , "Specify_the_maximum_folder_depth_used_for_checking_JavaScript_files_from_node_modules_Only_applicabl_6656", "Specify the maximum folder depth used for checking JavaScript files from 'node_modules'. Only applicable with 'allowJs'."),
                Specify_what_module_code_is_generated: diag(6657, 3 /* Message */ , "Specify_what_module_code_is_generated_6657", "Specify what module code is generated."),
                Specify_how_TypeScript_looks_up_a_file_from_a_given_module_specifier: diag(6658, 3 /* Message */ , "Specify_how_TypeScript_looks_up_a_file_from_a_given_module_specifier_6658", "Specify how TypeScript looks up a file from a given module specifier."),
                Set_the_newline_character_for_emitting_files: diag(6659, 3 /* Message */ , "Set_the_newline_character_for_emitting_files_6659", "Set the newline character for emitting files."),
                Disable_emitting_files_from_a_compilation: diag(6660, 3 /* Message */ , "Disable_emitting_files_from_a_compilation_6660", "Disable emitting files from a compilation."),
                Disable_generating_custom_helper_functions_like_extends_in_compiled_output: diag(6661, 3 /* Message */ , "Disable_generating_custom_helper_functions_like_extends_in_compiled_output_6661", "Disable generating custom helper functions like '__extends' in compiled output."),
                Disable_emitting_files_if_any_type_checking_errors_are_reported: diag(6662, 3 /* Message */ , "Disable_emitting_files_if_any_type_checking_errors_are_reported_6662", "Disable emitting files if any type checking errors are reported."),
                Disable_truncating_types_in_error_messages: diag(6663, 3 /* Message */ , "Disable_truncating_types_in_error_messages_6663", "Disable truncating types in error messages."),
                Enable_error_reporting_for_fallthrough_cases_in_switch_statements: diag(6664, 3 /* Message */ , "Enable_error_reporting_for_fallthrough_cases_in_switch_statements_6664", "Enable error reporting for fallthrough cases in switch statements."),
                Enable_error_reporting_for_expressions_and_declarations_with_an_implied_any_type: diag(6665, 3 /* Message */ , "Enable_error_reporting_for_expressions_and_declarations_with_an_implied_any_type_6665", "Enable error reporting for expressions and declarations with an implied 'any' type."),
                Ensure_overriding_members_in_derived_classes_are_marked_with_an_override_modifier: diag(6666, 3 /* Message */ , "Ensure_overriding_members_in_derived_classes_are_marked_with_an_override_modifier_6666", "Ensure overriding members in derived classes are marked with an override modifier."),
                Enable_error_reporting_for_codepaths_that_do_not_explicitly_return_in_a_function: diag(6667, 3 /* Message */ , "Enable_error_reporting_for_codepaths_that_do_not_explicitly_return_in_a_function_6667", "Enable error reporting for codepaths that do not explicitly return in a function."),
                Enable_error_reporting_when_this_is_given_the_type_any: diag(6668, 3 /* Message */ , "Enable_error_reporting_when_this_is_given_the_type_any_6668", "Enable error reporting when 'this' is given the type 'any'."),
                Disable_adding_use_strict_directives_in_emitted_JavaScript_files: diag(6669, 3 /* Message */ , "Disable_adding_use_strict_directives_in_emitted_JavaScript_files_6669", "Disable adding 'use strict' directives in emitted JavaScript files."),
                Disable_including_any_library_files_including_the_default_lib_d_ts: diag(6670, 3 /* Message */ , "Disable_including_any_library_files_including_the_default_lib_d_ts_6670", "Disable including any library files, including the default lib.d.ts."),
                Enforces_using_indexed_accessors_for_keys_declared_using_an_indexed_type: diag(6671, 3 /* Message */ , "Enforces_using_indexed_accessors_for_keys_declared_using_an_indexed_type_6671", "Enforces using indexed accessors for keys declared using an indexed type."),
                Disallow_import_s_require_s_or_reference_s_from_expanding_the_number_of_files_TypeScript_should_add_to_a_project: diag(6672, 3 /* Message */ , "Disallow_import_s_require_s_or_reference_s_from_expanding_the_number_of_files_TypeScript_should_add__6672", "Disallow 'import's, 'require's or '<reference>'s from expanding the number of files TypeScript should add to a project."),
                Disable_strict_checking_of_generic_signatures_in_function_types: diag(6673, 3 /* Message */ , "Disable_strict_checking_of_generic_signatures_in_function_types_6673", "Disable strict checking of generic signatures in function types."),
                Add_undefined_to_a_type_when_accessed_using_an_index: diag(6674, 3 /* Message */ , "Add_undefined_to_a_type_when_accessed_using_an_index_6674", "Add 'undefined' to a type when accessed using an index."),
                Enable_error_reporting_when_local_variables_aren_t_read: diag(6675, 3 /* Message */ , "Enable_error_reporting_when_local_variables_aren_t_read_6675", "Enable error reporting when local variables aren't read."),
                Raise_an_error_when_a_function_parameter_isn_t_read: diag(6676, 3 /* Message */ , "Raise_an_error_when_a_function_parameter_isn_t_read_6676", "Raise an error when a function parameter isn't read."),
                Deprecated_setting_Use_outFile_instead: diag(6677, 3 /* Message */ , "Deprecated_setting_Use_outFile_instead_6677", "Deprecated setting. Use 'outFile' instead."),
                Specify_an_output_folder_for_all_emitted_files: diag(6678, 3 /* Message */ , "Specify_an_output_folder_for_all_emitted_files_6678", "Specify an output folder for all emitted files."),
                Specify_a_file_that_bundles_all_outputs_into_one_JavaScript_file_If_declaration_is_true_also_designates_a_file_that_bundles_all_d_ts_output: diag(6679, 3 /* Message */ , "Specify_a_file_that_bundles_all_outputs_into_one_JavaScript_file_If_declaration_is_true_also_designa_6679", "Specify a file that bundles all outputs into one JavaScript file. If 'declaration' is true, also designates a file that bundles all .d.ts output."),
                Specify_a_set_of_entries_that_re_map_imports_to_additional_lookup_locations: diag(6680, 3 /* Message */ , "Specify_a_set_of_entries_that_re_map_imports_to_additional_lookup_locations_6680", "Specify a set of entries that re-map imports to additional lookup locations."),
                Specify_a_list_of_language_service_plugins_to_include: diag(6681, 3 /* Message */ , "Specify_a_list_of_language_service_plugins_to_include_6681", "Specify a list of language service plugins to include."),
                Disable_erasing_const_enum_declarations_in_generated_code: diag(6682, 3 /* Message */ , "Disable_erasing_const_enum_declarations_in_generated_code_6682", "Disable erasing 'const enum' declarations in generated code."),
                Disable_resolving_symlinks_to_their_realpath_This_correlates_to_the_same_flag_in_node: diag(6683, 3 /* Message */ , "Disable_resolving_symlinks_to_their_realpath_This_correlates_to_the_same_flag_in_node_6683", "Disable resolving symlinks to their realpath. This correlates to the same flag in node."),
                Disable_wiping_the_console_in_watch_mode: diag(6684, 3 /* Message */ , "Disable_wiping_the_console_in_watch_mode_6684", "Disable wiping the console in watch mode."),
                Enable_color_and_formatting_in_TypeScript_s_output_to_make_compiler_errors_easier_to_read: diag(6685, 3 /* Message */ , "Enable_color_and_formatting_in_TypeScript_s_output_to_make_compiler_errors_easier_to_read_6685", "Enable color and formatting in TypeScript's output to make compiler errors easier to read."),
                Specify_the_object_invoked_for_createElement_This_only_applies_when_targeting_react_JSX_emit: diag(6686, 3 /* Message */ , "Specify_the_object_invoked_for_createElement_This_only_applies_when_targeting_react_JSX_emit_6686", "Specify the object invoked for 'createElement'. This only applies when targeting 'react' JSX emit."),
                Specify_an_array_of_objects_that_specify_paths_for_projects_Used_in_project_references: diag(6687, 3 /* Message */ , "Specify_an_array_of_objects_that_specify_paths_for_projects_Used_in_project_references_6687", "Specify an array of objects that specify paths for projects. Used in project references."),
                Disable_emitting_comments: diag(6688, 3 /* Message */ , "Disable_emitting_comments_6688", "Disable emitting comments."),
                Enable_importing_json_files: diag(6689, 3 /* Message */ , "Enable_importing_json_files_6689", "Enable importing .json files."),
                Specify_the_root_folder_within_your_source_files: diag(6690, 3 /* Message */ , "Specify_the_root_folder_within_your_source_files_6690", "Specify the root folder within your source files."),
                Allow_multiple_folders_to_be_treated_as_one_when_resolving_modules: diag(6691, 3 /* Message */ , "Allow_multiple_folders_to_be_treated_as_one_when_resolving_modules_6691", "Allow multiple folders to be treated as one when resolving modules."),
                Skip_type_checking_d_ts_files_that_are_included_with_TypeScript: diag(6692, 3 /* Message */ , "Skip_type_checking_d_ts_files_that_are_included_with_TypeScript_6692", "Skip type checking .d.ts files that are included with TypeScript."),
                Skip_type_checking_all_d_ts_files: diag(6693, 3 /* Message */ , "Skip_type_checking_all_d_ts_files_6693", "Skip type checking all .d.ts files."),
                Create_source_map_files_for_emitted_JavaScript_files: diag(6694, 3 /* Message */ , "Create_source_map_files_for_emitted_JavaScript_files_6694", "Create source map files for emitted JavaScript files."),
                Specify_the_root_path_for_debuggers_to_find_the_reference_source_code: diag(6695, 3 /* Message */ , "Specify_the_root_path_for_debuggers_to_find_the_reference_source_code_6695", "Specify the root path for debuggers to find the reference source code."),
                Check_that_the_arguments_for_bind_call_and_apply_methods_match_the_original_function: diag(6697, 3 /* Message */ , "Check_that_the_arguments_for_bind_call_and_apply_methods_match_the_original_function_6697", "Check that the arguments for 'bind', 'call', and 'apply' methods match the original function."),
                When_assigning_functions_check_to_ensure_parameters_and_the_return_values_are_subtype_compatible: diag(6698, 3 /* Message */ , "When_assigning_functions_check_to_ensure_parameters_and_the_return_values_are_subtype_compatible_6698", "When assigning functions, check to ensure parameters and the return values are subtype-compatible."),
                When_type_checking_take_into_account_null_and_undefined: diag(6699, 3 /* Message */ , "When_type_checking_take_into_account_null_and_undefined_6699", "When type checking, take into account 'null' and 'undefined'."),
                Check_for_class_properties_that_are_declared_but_not_set_in_the_constructor: diag(6700, 3 /* Message */ , "Check_for_class_properties_that_are_declared_but_not_set_in_the_constructor_6700", "Check for class properties that are declared but not set in the constructor."),
                Disable_emitting_declarations_that_have_internal_in_their_JSDoc_comments: diag(6701, 3 /* Message */ , "Disable_emitting_declarations_that_have_internal_in_their_JSDoc_comments_6701", "Disable emitting declarations that have '@internal' in their JSDoc comments."),
                Disable_reporting_of_excess_property_errors_during_the_creation_of_object_literals: diag(6702, 3 /* Message */ , "Disable_reporting_of_excess_property_errors_during_the_creation_of_object_literals_6702", "Disable reporting of excess property errors during the creation of object literals."),
                Suppress_noImplicitAny_errors_when_indexing_objects_that_lack_index_signatures: diag(6703, 3 /* Message */ , "Suppress_noImplicitAny_errors_when_indexing_objects_that_lack_index_signatures_6703", "Suppress 'noImplicitAny' errors when indexing objects that lack index signatures."),
                Synchronously_call_callbacks_and_update_the_state_of_directory_watchers_on_platforms_that_don_t_support_recursive_watching_natively: diag(6704, 3 /* Message */ , "Synchronously_call_callbacks_and_update_the_state_of_directory_watchers_on_platforms_that_don_t_supp_6704", "Synchronously call callbacks and update the state of directory watchers on platforms that don`t support recursive watching natively."),
                Set_the_JavaScript_language_version_for_emitted_JavaScript_and_include_compatible_library_declarations: diag(6705, 3 /* Message */ , "Set_the_JavaScript_language_version_for_emitted_JavaScript_and_include_compatible_library_declaratio_6705", "Set the JavaScript language version for emitted JavaScript and include compatible library declarations."),
                Log_paths_used_during_the_moduleResolution_process: diag(6706, 3 /* Message */ , "Log_paths_used_during_the_moduleResolution_process_6706", "Log paths used during the 'moduleResolution' process."),
                Specify_the_path_to_tsbuildinfo_incremental_compilation_file: diag(6707, 3 /* Message */ , "Specify_the_path_to_tsbuildinfo_incremental_compilation_file_6707", "Specify the path to .tsbuildinfo incremental compilation file."),
                Specify_options_for_automatic_acquisition_of_declaration_files: diag(6709, 3 /* Message */ , "Specify_options_for_automatic_acquisition_of_declaration_files_6709", "Specify options for automatic acquisition of declaration files."),
                Specify_multiple_folders_that_act_like_Slashnode_modules_Slash_types: diag(6710, 3 /* Message */ , "Specify_multiple_folders_that_act_like_Slashnode_modules_Slash_types_6710", "Specify multiple folders that act like './node_modules/@types'."),
                Specify_type_package_names_to_be_included_without_being_referenced_in_a_source_file: diag(6711, 3 /* Message */ , "Specify_type_package_names_to_be_included_without_being_referenced_in_a_source_file_6711", "Specify type package names to be included without being referenced in a source file."),
                Emit_ECMAScript_standard_compliant_class_fields: diag(6712, 3 /* Message */ , "Emit_ECMAScript_standard_compliant_class_fields_6712", "Emit ECMAScript-standard-compliant class fields."),
                Enable_verbose_logging: diag(6713, 3 /* Message */ , "Enable_verbose_logging_6713", "Enable verbose logging."),
                Specify_how_directories_are_watched_on_systems_that_lack_recursive_file_watching_functionality: diag(6714, 3 /* Message */ , "Specify_how_directories_are_watched_on_systems_that_lack_recursive_file_watching_functionality_6714", "Specify how directories are watched on systems that lack recursive file-watching functionality."),
                Specify_how_the_TypeScript_watch_mode_works: diag(6715, 3 /* Message */ , "Specify_how_the_TypeScript_watch_mode_works_6715", "Specify how the TypeScript watch mode works."),
                Require_undeclared_properties_from_index_signatures_to_use_element_accesses: diag(6717, 3 /* Message */ , "Require_undeclared_properties_from_index_signatures_to_use_element_accesses_6717", "Require undeclared properties from index signatures to use element accesses."),
                Specify_emit_Slashchecking_behavior_for_imports_that_are_only_used_for_types: diag(6718, 3 /* Message */ , "Specify_emit_Slashchecking_behavior_for_imports_that_are_only_used_for_types_6718", "Specify emit/checking behavior for imports that are only used for types."),
                Default_catch_clause_variables_as_unknown_instead_of_any: diag(6803, 3 /* Message */ , "Default_catch_clause_variables_as_unknown_instead_of_any_6803", "Default catch clause variables as 'unknown' instead of 'any'."),
                Do_not_transform_or_elide_any_imports_or_exports_not_marked_as_type_only_ensuring_they_are_written_in_the_output_file_s_format_based_on_the_module_setting: diag(6804, 3 /* Message */ , "Do_not_transform_or_elide_any_imports_or_exports_not_marked_as_type_only_ensuring_they_are_written_i_6804", "Do not transform or elide any imports or exports not marked as type-only, ensuring they are written in the output file's format based on the 'module' setting."),
                one_of_Colon: diag(6900, 3 /* Message */ , "one_of_Colon_6900", "one of:"),
                one_or_more_Colon: diag(6901, 3 /* Message */ , "one_or_more_Colon_6901", "one or more:"),
                type_Colon: diag(6902, 3 /* Message */ , "type_Colon_6902", "type:"),
                default_Colon: diag(6903, 3 /* Message */ , "default_Colon_6903", "default:"),
                module_system_or_esModuleInterop: diag(6904, 3 /* Message */ , "module_system_or_esModuleInterop_6904", 'module === "system" or esModuleInterop'),
                false_unless_strict_is_set: diag(6905, 3 /* Message */ , "false_unless_strict_is_set_6905", "`false`, unless `strict` is set"),
                false_unless_composite_is_set: diag(6906, 3 /* Message */ , "false_unless_composite_is_set_6906", "`false`, unless `composite` is set"),
                node_modules_bower_components_jspm_packages_plus_the_value_of_outDir_if_one_is_specified: diag(6907, 3 /* Message */ , "node_modules_bower_components_jspm_packages_plus_the_value_of_outDir_if_one_is_specified_6907", '`["node_modules", "bower_components", "jspm_packages"]`, plus the value of `outDir` if one is specified.'),
                if_files_is_specified_otherwise_Asterisk_Asterisk_Slash_Asterisk: diag(6908, 3 /* Message */ , "if_files_is_specified_otherwise_Asterisk_Asterisk_Slash_Asterisk_6908", '`[]` if `files` is specified, otherwise `["**/*"]`'),
                true_if_composite_false_otherwise: diag(6909, 3 /* Message */ , "true_if_composite_false_otherwise_6909", "`true` if `composite`, `false` otherwise"),
                module_AMD_or_UMD_or_System_or_ES6_then_Classic_Otherwise_Node: diag(69010, 3 /* Message */ , "module_AMD_or_UMD_or_System_or_ES6_then_Classic_Otherwise_Node_69010", "module === `AMD` or `UMD` or `System` or `ES6`, then `Classic`, Otherwise `Node`"),
                Computed_from_the_list_of_input_files: diag(6911, 3 /* Message */ , "Computed_from_the_list_of_input_files_6911", "Computed from the list of input files"),
                Platform_specific: diag(6912, 3 /* Message */ , "Platform_specific_6912", "Platform specific"),
                You_can_learn_about_all_of_the_compiler_options_at_0: diag(6913, 3 /* Message */ , "You_can_learn_about_all_of_the_compiler_options_at_0_6913", "You can learn about all of the compiler options at {0}"),
                Including_watch_w_will_start_watching_the_current_project_for_the_file_changes_Once_set_you_can_config_watch_mode_with_Colon: diag(6914, 3 /* Message */ , "Including_watch_w_will_start_watching_the_current_project_for_the_file_changes_Once_set_you_can_conf_6914", "Including --watch, -w will start watching the current project for the file changes. Once set, you can config watch mode with:"),
                Using_build_b_will_make_tsc_behave_more_like_a_build_orchestrator_than_a_compiler_This_is_used_to_trigger_building_composite_projects_which_you_can_learn_more_about_at_0: diag(6915, 3 /* Message */ , "Using_build_b_will_make_tsc_behave_more_like_a_build_orchestrator_than_a_compiler_This_is_used_to_tr_6915", "Using --build, -b will make tsc behave more like a build orchestrator than a compiler. This is used to trigger building composite projects which you can learn more about at {0}"),
                COMMON_COMMANDS: diag(6916, 3 /* Message */ , "COMMON_COMMANDS_6916", "COMMON COMMANDS"),
                ALL_COMPILER_OPTIONS: diag(6917, 3 /* Message */ , "ALL_COMPILER_OPTIONS_6917", "ALL COMPILER OPTIONS"),
                WATCH_OPTIONS: diag(6918, 3 /* Message */ , "WATCH_OPTIONS_6918", "WATCH OPTIONS"),
                BUILD_OPTIONS: diag(6919, 3 /* Message */ , "BUILD_OPTIONS_6919", "BUILD OPTIONS"),
                COMMON_COMPILER_OPTIONS: diag(6920, 3 /* Message */ , "COMMON_COMPILER_OPTIONS_6920", "COMMON COMPILER OPTIONS"),
                COMMAND_LINE_FLAGS: diag(6921, 3 /* Message */ , "COMMAND_LINE_FLAGS_6921", "COMMAND LINE FLAGS"),
                tsc_Colon_The_TypeScript_Compiler: diag(6922, 3 /* Message */ , "tsc_Colon_The_TypeScript_Compiler_6922", "tsc: The TypeScript Compiler"),
                Compiles_the_current_project_tsconfig_json_in_the_working_directory: diag(6923, 3 /* Message */ , "Compiles_the_current_project_tsconfig_json_in_the_working_directory_6923", "Compiles the current project (tsconfig.json in the working directory.)"),
                Ignoring_tsconfig_json_compiles_the_specified_files_with_default_compiler_options: diag(6924, 3 /* Message */ , "Ignoring_tsconfig_json_compiles_the_specified_files_with_default_compiler_options_6924", "Ignoring tsconfig.json, compiles the specified files with default compiler options."),
                Build_a_composite_project_in_the_working_directory: diag(6925, 3 /* Message */ , "Build_a_composite_project_in_the_working_directory_6925", "Build a composite project in the working directory."),
                Creates_a_tsconfig_json_with_the_recommended_settings_in_the_working_directory: diag(6926, 3 /* Message */ , "Creates_a_tsconfig_json_with_the_recommended_settings_in_the_working_directory_6926", "Creates a tsconfig.json with the recommended settings in the working directory."),
                Compiles_the_TypeScript_project_located_at_the_specified_path: diag(6927, 3 /* Message */ , "Compiles_the_TypeScript_project_located_at_the_specified_path_6927", "Compiles the TypeScript project located at the specified path."),
                An_expanded_version_of_this_information_showing_all_possible_compiler_options: diag(6928, 3 /* Message */ , "An_expanded_version_of_this_information_showing_all_possible_compiler_options_6928", "An expanded version of this information, showing all possible compiler options"),
                Compiles_the_current_project_with_additional_settings: diag(6929, 3 /* Message */ , "Compiles_the_current_project_with_additional_settings_6929", "Compiles the current project, with additional settings."),
                true_for_ES2022_and_above_including_ESNext: diag(6930, 3 /* Message */ , "true_for_ES2022_and_above_including_ESNext_6930", "`true` for ES2022 and above, including ESNext."),
                List_of_file_name_suffixes_to_search_when_resolving_a_module: diag(6931, 1 /* Error */ , "List_of_file_name_suffixes_to_search_when_resolving_a_module_6931", "List of file name suffixes to search when resolving a module."),
                Variable_0_implicitly_has_an_1_type: diag(7005, 1 /* Error */ , "Variable_0_implicitly_has_an_1_type_7005", "Variable '{0}' implicitly has an '{1}' type."),
                Parameter_0_implicitly_has_an_1_type: diag(7006, 1 /* Error */ , "Parameter_0_implicitly_has_an_1_type_7006", "Parameter '{0}' implicitly has an '{1}' type."),
                Member_0_implicitly_has_an_1_type: diag(7008, 1 /* Error */ , "Member_0_implicitly_has_an_1_type_7008", "Member '{0}' implicitly has an '{1}' type."),
                new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type: diag(7009, 1 /* Error */ , "new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type_7009", "'new' expression, whose target lacks a construct signature, implicitly has an 'any' type."),
                _0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type: diag(7010, 1 /* Error */ , "_0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type_7010", "'{0}', which lacks return-type annotation, implicitly has an '{1}' return type."),
                Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type: diag(7011, 1 /* Error */ , "Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type_7011", "Function expression, which lacks return-type annotation, implicitly has an '{0}' return type."),
                This_overload_implicitly_returns_the_type_0_because_it_lacks_a_return_type_annotation: diag(7012, 1 /* Error */ , "This_overload_implicitly_returns_the_type_0_because_it_lacks_a_return_type_annotation_7012", "This overload implicitly returns the type '{0}' because it lacks a return type annotation."),
                Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type: diag(7013, 1 /* Error */ , "Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type_7013", "Construct signature, which lacks return-type annotation, implicitly has an 'any' return type."),
                Function_type_which_lacks_return_type_annotation_implicitly_has_an_0_return_type: diag(7014, 1 /* Error */ , "Function_type_which_lacks_return_type_annotation_implicitly_has_an_0_return_type_7014", "Function type, which lacks return-type annotation, implicitly has an '{0}' return type."),
                Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number: diag(7015, 1 /* Error */ , "Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number_7015", "Element implicitly has an 'any' type because index expression is not of type 'number'."),
                Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type: diag(7016, 1 /* Error */ , "Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type_7016", "Could not find a declaration file for module '{0}'. '{1}' implicitly has an 'any' type."),
                Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature: diag(7017, 1 /* Error */ , "Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature_7017", "Element implicitly has an 'any' type because type '{0}' has no index signature."),
                Object_literal_s_property_0_implicitly_has_an_1_type: diag(7018, 1 /* Error */ , "Object_literal_s_property_0_implicitly_has_an_1_type_7018", "Object literal's property '{0}' implicitly has an '{1}' type."),
                Rest_parameter_0_implicitly_has_an_any_type: diag(7019, 1 /* Error */ , "Rest_parameter_0_implicitly_has_an_any_type_7019", "Rest parameter '{0}' implicitly has an 'any[]' type."),
                Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type: diag(7020, 1 /* Error */ , "Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type_7020", "Call signature, which lacks return-type annotation, implicitly has an 'any' return type."),
                _0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or_indirectly_in_its_own_initializer: diag(7022, 1 /* Error */ , "_0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or__7022", "'{0}' implicitly has type 'any' because it does not have a type annotation and is referenced directly or indirectly in its own initializer."),
                _0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions: diag(7023, 1 /* Error */ , "_0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_reference_7023", "'{0}' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions."),
                Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions: diag(7024, 1 /* Error */ , "Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_ref_7024", "Function implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions."),
                Generator_implicitly_has_yield_type_0_because_it_does_not_yield_any_values_Consider_supplying_a_return_type_annotation: diag(7025, 1 /* Error */ , "Generator_implicitly_has_yield_type_0_because_it_does_not_yield_any_values_Consider_supplying_a_retu_7025", "Generator implicitly has yield type '{0}' because it does not yield any values. Consider supplying a return type annotation."),
                JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists: diag(7026, 1 /* Error */ , "JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists_7026", "JSX element implicitly has type 'any' because no interface 'JSX.{0}' exists."),
                Unreachable_code_detected: diag(7027, 1 /* Error */ , "Unreachable_code_detected_7027", "Unreachable code detected.", /*reportsUnnecessary*/ true),
                Unused_label: diag(7028, 1 /* Error */ , "Unused_label_7028", "Unused label.", /*reportsUnnecessary*/ true),
                Fallthrough_case_in_switch: diag(7029, 1 /* Error */ , "Fallthrough_case_in_switch_7029", "Fallthrough case in switch."),
                Not_all_code_paths_return_a_value: diag(7030, 1 /* Error */ , "Not_all_code_paths_return_a_value_7030", "Not all code paths return a value."),
                Binding_element_0_implicitly_has_an_1_type: diag(7031, 1 /* Error */ , "Binding_element_0_implicitly_has_an_1_type_7031", "Binding element '{0}' implicitly has an '{1}' type."),
                Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation: diag(7032, 1 /* Error */ , "Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation_7032", "Property '{0}' implicitly has type 'any', because its set accessor lacks a parameter type annotation."),
                Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation: diag(7033, 1 /* Error */ , "Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation_7033", "Property '{0}' implicitly has type 'any', because its get accessor lacks a return type annotation."),
                Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined: diag(7034, 1 /* Error */ , "Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined_7034", "Variable '{0}' implicitly has type '{1}' in some locations where its type cannot be determined."),
                Try_npm_i_save_dev_types_Slash_1_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare_module_0: diag(7035, 1 /* Error */ , "Try_npm_i_save_dev_types_Slash_1_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare__7035", "Try `npm i --save-dev @types/{1}` if it exists or add a new declaration (.d.ts) file containing `declare module '{0}';`"),
                Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0: diag(7036, 1 /* Error */ , "Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0_7036", "Dynamic import's specifier must be of type 'string', but here has type '{0}'."),
                Enables_emit_interoperability_between_CommonJS_and_ES_Modules_via_creation_of_namespace_objects_for_all_imports_Implies_allowSyntheticDefaultImports: diag(7037, 3 /* Message */ , "Enables_emit_interoperability_between_CommonJS_and_ES_Modules_via_creation_of_namespace_objects_for__7037", "Enables emit interoperability between CommonJS and ES Modules via creation of namespace objects for all imports. Implies 'allowSyntheticDefaultImports'."),
                Type_originates_at_this_import_A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime_Consider_using_a_default_import_or_import_require_here_instead: diag(7038, 3 /* Message */ , "Type_originates_at_this_import_A_namespace_style_import_cannot_be_called_or_constructed_and_will_cau_7038", "Type originates at this import. A namespace-style import cannot be called or constructed, and will cause a failure at runtime. Consider using a default import or import require here instead."),
                Mapped_object_type_implicitly_has_an_any_template_type: diag(7039, 1 /* Error */ , "Mapped_object_type_implicitly_has_an_any_template_type_7039", "Mapped object type implicitly has an 'any' template type."),
                If_the_0_package_actually_exposes_this_module_consider_sending_a_pull_request_to_amend_https_Colon_Slash_Slashgithub_com_SlashDefinitelyTyped_SlashDefinitelyTyped_Slashtree_Slashmaster_Slashtypes_Slash_1: diag(7040, 1 /* Error */ , "If_the_0_package_actually_exposes_this_module_consider_sending_a_pull_request_to_amend_https_Colon_S_7040", "If the '{0}' package actually exposes this module, consider sending a pull request to amend 'https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/{1}'"),
                The_containing_arrow_function_captures_the_global_value_of_this: diag(7041, 1 /* Error */ , "The_containing_arrow_function_captures_the_global_value_of_this_7041", "The containing arrow function captures the global value of 'this'."),
                Module_0_was_resolved_to_1_but_resolveJsonModule_is_not_used: diag(7042, 1 /* Error */ , "Module_0_was_resolved_to_1_but_resolveJsonModule_is_not_used_7042", "Module '{0}' was resolved to '{1}', but '--resolveJsonModule' is not used."),
                Variable_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage: diag(7043, 2 /* Suggestion */ , "Variable_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage_7043", "Variable '{0}' implicitly has an '{1}' type, but a better type may be inferred from usage."),
                Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage: diag(7044, 2 /* Suggestion */ , "Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage_7044", "Parameter '{0}' implicitly has an '{1}' type, but a better type may be inferred from usage."),
                Member_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage: diag(7045, 2 /* Suggestion */ , "Member_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage_7045", "Member '{0}' implicitly has an '{1}' type, but a better type may be inferred from usage."),
                Variable_0_implicitly_has_type_1_in_some_locations_but_a_better_type_may_be_inferred_from_usage: diag(7046, 2 /* Suggestion */ , "Variable_0_implicitly_has_type_1_in_some_locations_but_a_better_type_may_be_inferred_from_usage_7046", "Variable '{0}' implicitly has type '{1}' in some locations, but a better type may be inferred from usage."),
                Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage: diag(7047, 2 /* Suggestion */ , "Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage_7047", "Rest parameter '{0}' implicitly has an 'any[]' type, but a better type may be inferred from usage."),
                Property_0_implicitly_has_type_any_but_a_better_type_for_its_get_accessor_may_be_inferred_from_usage: diag(7048, 2 /* Suggestion */ , "Property_0_implicitly_has_type_any_but_a_better_type_for_its_get_accessor_may_be_inferred_from_usage_7048", "Property '{0}' implicitly has type 'any', but a better type for its get accessor may be inferred from usage."),
                Property_0_implicitly_has_type_any_but_a_better_type_for_its_set_accessor_may_be_inferred_from_usage: diag(7049, 2 /* Suggestion */ , "Property_0_implicitly_has_type_any_but_a_better_type_for_its_set_accessor_may_be_inferred_from_usage_7049", "Property '{0}' implicitly has type 'any', but a better type for its set accessor may be inferred from usage."),
                _0_implicitly_has_an_1_return_type_but_a_better_type_may_be_inferred_from_usage: diag(7050, 2 /* Suggestion */ , "_0_implicitly_has_an_1_return_type_but_a_better_type_may_be_inferred_from_usage_7050", "'{0}' implicitly has an '{1}' return type, but a better type may be inferred from usage."),
                Parameter_has_a_name_but_no_type_Did_you_mean_0_Colon_1: diag(7051, 1 /* Error */ , "Parameter_has_a_name_but_no_type_Did_you_mean_0_Colon_1_7051", "Parameter has a name but no type. Did you mean '{0}: {1}'?"),
                Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature_Did_you_mean_to_call_1: diag(7052, 1 /* Error */ , "Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature_Did_you_mean_to_call_1_7052", "Element implicitly has an 'any' type because type '{0}' has no index signature. Did you mean to call '{1}'?"),
                Element_implicitly_has_an_any_type_because_expression_of_type_0_can_t_be_used_to_index_type_1: diag(7053, 1 /* Error */ , "Element_implicitly_has_an_any_type_because_expression_of_type_0_can_t_be_used_to_index_type_1_7053", "Element implicitly has an 'any' type because expression of type '{0}' can't be used to index type '{1}'."),
                No_index_signature_with_a_parameter_of_type_0_was_found_on_type_1: diag(7054, 1 /* Error */ , "No_index_signature_with_a_parameter_of_type_0_was_found_on_type_1_7054", "No index signature with a parameter of type '{0}' was found on type '{1}'."),
                _0_which_lacks_return_type_annotation_implicitly_has_an_1_yield_type: diag(7055, 1 /* Error */ , "_0_which_lacks_return_type_annotation_implicitly_has_an_1_yield_type_7055", "'{0}', which lacks return-type annotation, implicitly has an '{1}' yield type."),
                The_inferred_type_of_this_node_exceeds_the_maximum_length_the_compiler_will_serialize_An_explicit_type_annotation_is_needed: diag(7056, 1 /* Error */ , "The_inferred_type_of_this_node_exceeds_the_maximum_length_the_compiler_will_serialize_An_explicit_ty_7056", "The inferred type of this node exceeds the maximum length the compiler will serialize. An explicit type annotation is needed."),
                yield_expression_implicitly_results_in_an_any_type_because_its_containing_generator_lacks_a_return_type_annotation: diag(7057, 1 /* Error */ , "yield_expression_implicitly_results_in_an_any_type_because_its_containing_generator_lacks_a_return_t_7057", "'yield' expression implicitly results in an 'any' type because its containing generator lacks a return-type annotation."),
                If_the_0_package_actually_exposes_this_module_try_adding_a_new_declaration_d_ts_file_containing_declare_module_1: diag(7058, 1 /* Error */ , "If_the_0_package_actually_exposes_this_module_try_adding_a_new_declaration_d_ts_file_containing_decl_7058", "If the '{0}' package actually exposes this module, try adding a new declaration (.d.ts) file containing `declare module '{1}';`"),
                This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Use_an_as_expression_instead: diag(7059, 1 /* Error */ , "This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Use_an_as_expression_instead_7059", "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead."),
                This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Add_a_trailing_comma_or_explicit_constraint: diag(7060, 1 /* Error */ , "This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Add_a_trailing_comma_or_explicit_cons_7060", "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma or explicit constraint."),
                A_mapped_type_may_not_declare_properties_or_methods: diag(7061, 1 /* Error */ , "A_mapped_type_may_not_declare_properties_or_methods_7061", "A mapped type may not declare properties or methods."),
                You_cannot_rename_this_element: diag(8e3, 1 /* Error */ , "You_cannot_rename_this_element_8000", "You cannot rename this element."),
                You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library: diag(8001, 1 /* Error */ , "You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library_8001", "You cannot rename elements that are defined in the standard TypeScript library."),
                import_can_only_be_used_in_TypeScript_files: diag(8002, 1 /* Error */ , "import_can_only_be_used_in_TypeScript_files_8002", "'import ... =' can only be used in TypeScript files."),
                export_can_only_be_used_in_TypeScript_files: diag(8003, 1 /* Error */ , "export_can_only_be_used_in_TypeScript_files_8003", "'export =' can only be used in TypeScript files."),
                Type_parameter_declarations_can_only_be_used_in_TypeScript_files: diag(8004, 1 /* Error */ , "Type_parameter_declarations_can_only_be_used_in_TypeScript_files_8004", "Type parameter declarations can only be used in TypeScript files."),
                implements_clauses_can_only_be_used_in_TypeScript_files: diag(8005, 1 /* Error */ , "implements_clauses_can_only_be_used_in_TypeScript_files_8005", "'implements' clauses can only be used in TypeScript files."),
                _0_declarations_can_only_be_used_in_TypeScript_files: diag(8006, 1 /* Error */ , "_0_declarations_can_only_be_used_in_TypeScript_files_8006", "'{0}' declarations can only be used in TypeScript files."),
                Type_aliases_can_only_be_used_in_TypeScript_files: diag(8008, 1 /* Error */ , "Type_aliases_can_only_be_used_in_TypeScript_files_8008", "Type aliases can only be used in TypeScript files."),
                The_0_modifier_can_only_be_used_in_TypeScript_files: diag(8009, 1 /* Error */ , "The_0_modifier_can_only_be_used_in_TypeScript_files_8009", "The '{0}' modifier can only be used in TypeScript files."),
                Type_annotations_can_only_be_used_in_TypeScript_files: diag(8010, 1 /* Error */ , "Type_annotations_can_only_be_used_in_TypeScript_files_8010", "Type annotations can only be used in TypeScript files."),
                Type_arguments_can_only_be_used_in_TypeScript_files: diag(8011, 1 /* Error */ , "Type_arguments_can_only_be_used_in_TypeScript_files_8011", "Type arguments can only be used in TypeScript files."),
                Parameter_modifiers_can_only_be_used_in_TypeScript_files: diag(8012, 1 /* Error */ , "Parameter_modifiers_can_only_be_used_in_TypeScript_files_8012", "Parameter modifiers can only be used in TypeScript files."),
                Non_null_assertions_can_only_be_used_in_TypeScript_files: diag(8013, 1 /* Error */ , "Non_null_assertions_can_only_be_used_in_TypeScript_files_8013", "Non-null assertions can only be used in TypeScript files."),
                Type_assertion_expressions_can_only_be_used_in_TypeScript_files: diag(8016, 1 /* Error */ , "Type_assertion_expressions_can_only_be_used_in_TypeScript_files_8016", "Type assertion expressions can only be used in TypeScript files."),
                Report_errors_in_js_files: diag(8019, 3 /* Message */ , "Report_errors_in_js_files_8019", "Report errors in .js files."),
                JSDoc_types_can_only_be_used_inside_documentation_comments: diag(8020, 1 /* Error */ , "JSDoc_types_can_only_be_used_inside_documentation_comments_8020", "JSDoc types can only be used inside documentation comments."),
                JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags: diag(8021, 1 /* Error */ , "JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags_8021", "JSDoc '@typedef' tag should either have a type annotation or be followed by '@property' or '@member' tags."),
                JSDoc_0_is_not_attached_to_a_class: diag(8022, 1 /* Error */ , "JSDoc_0_is_not_attached_to_a_class_8022", "JSDoc '@{0}' is not attached to a class."),
                JSDoc_0_1_does_not_match_the_extends_2_clause: diag(8023, 1 /* Error */ , "JSDoc_0_1_does_not_match_the_extends_2_clause_8023", "JSDoc '@{0} {1}' does not match the 'extends {2}' clause."),
                JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name: diag(8024, 1 /* Error */ , "JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_8024", "JSDoc '@param' tag has name '{0}', but there is no parameter with that name."),
                Class_declarations_cannot_have_more_than_one_augments_or_extends_tag: diag(8025, 1 /* Error */ , "Class_declarations_cannot_have_more_than_one_augments_or_extends_tag_8025", "Class declarations cannot have more than one '@augments' or '@extends' tag."),
                Expected_0_type_arguments_provide_these_with_an_extends_tag: diag(8026, 1 /* Error */ , "Expected_0_type_arguments_provide_these_with_an_extends_tag_8026", "Expected {0} type arguments; provide these with an '@extends' tag."),
                Expected_0_1_type_arguments_provide_these_with_an_extends_tag: diag(8027, 1 /* Error */ , "Expected_0_1_type_arguments_provide_these_with_an_extends_tag_8027", "Expected {0}-{1} type arguments; provide these with an '@extends' tag."),
                JSDoc_may_only_appear_in_the_last_parameter_of_a_signature: diag(8028, 1 /* Error */ , "JSDoc_may_only_appear_in_the_last_parameter_of_a_signature_8028", "JSDoc '...' may only appear in the last parameter of a signature."),
                JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_It_would_match_arguments_if_it_had_an_array_type: diag(8029, 1 /* Error */ , "JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_It_would_match_arguments_if_it_h_8029", "JSDoc '@param' tag has name '{0}', but there is no parameter with that name. It would match 'arguments' if it had an array type."),
                The_type_of_a_function_declaration_must_match_the_function_s_signature: diag(8030, 1 /* Error */ , "The_type_of_a_function_declaration_must_match_the_function_s_signature_8030", "The type of a function declaration must match the function's signature."),
                You_cannot_rename_a_module_via_a_global_import: diag(8031, 1 /* Error */ , "You_cannot_rename_a_module_via_a_global_import_8031", "You cannot rename a module via a global import."),
                Qualified_name_0_is_not_allowed_without_a_leading_param_object_1: diag(8032, 1 /* Error */ , "Qualified_name_0_is_not_allowed_without_a_leading_param_object_1_8032", "Qualified name '{0}' is not allowed without a leading '@param {object} {1}'."),
                A_JSDoc_typedef_comment_may_not_contain_multiple_type_tags: diag(8033, 1 /* Error */ , "A_JSDoc_typedef_comment_may_not_contain_multiple_type_tags_8033", "A JSDoc '@typedef' comment may not contain multiple '@type' tags."),
                The_tag_was_first_specified_here: diag(8034, 1 /* Error */ , "The_tag_was_first_specified_here_8034", "The tag was first specified here."),
                You_cannot_rename_elements_that_are_defined_in_a_node_modules_folder: diag(8035, 1 /* Error */ , "You_cannot_rename_elements_that_are_defined_in_a_node_modules_folder_8035", "You cannot rename elements that are defined in a 'node_modules' folder."),
                You_cannot_rename_elements_that_are_defined_in_another_node_modules_folder: diag(8036, 1 /* Error */ , "You_cannot_rename_elements_that_are_defined_in_another_node_modules_folder_8036", "You cannot rename elements that are defined in another 'node_modules' folder."),
                Type_satisfaction_expressions_can_only_be_used_in_TypeScript_files: diag(8037, 1 /* Error */ , "Type_satisfaction_expressions_can_only_be_used_in_TypeScript_files_8037", "Type satisfaction expressions can only be used in TypeScript files."),
                Decorators_may_not_appear_after_export_or_export_default_if_they_also_appear_before_export: diag(8038, 1 /* Error */ , "Decorators_may_not_appear_after_export_or_export_default_if_they_also_appear_before_export_8038", "Decorators may not appear after 'export' or 'export default' if they also appear before 'export'."),
                A_JSDoc_template_tag_may_not_follow_a_typedef_callback_or_overload_tag: diag(8039, 1 /* Error */ , "A_JSDoc_template_tag_may_not_follow_a_typedef_callback_or_overload_tag_8039", "A JSDoc '@template' tag may not follow a '@typedef', '@callback', or '@overload' tag"),
                Declaration_emit_for_this_file_requires_using_private_name_0_An_explicit_type_annotation_may_unblock_declaration_emit: diag(9005, 1 /* Error */ , "Declaration_emit_for_this_file_requires_using_private_name_0_An_explicit_type_annotation_may_unblock_9005", "Declaration emit for this file requires using private name '{0}'. An explicit type annotation may unblock declaration emit."),
                Declaration_emit_for_this_file_requires_using_private_name_0_from_module_1_An_explicit_type_annotation_may_unblock_declaration_emit: diag(9006, 1 /* Error */ , "Declaration_emit_for_this_file_requires_using_private_name_0_from_module_1_An_explicit_type_annotati_9006", "Declaration emit for this file requires using private name '{0}' from module '{1}'. An explicit type annotation may unblock declaration emit."),
                JSX_attributes_must_only_be_assigned_a_non_empty_expression: diag(17e3, 1 /* Error */ , "JSX_attributes_must_only_be_assigned_a_non_empty_expression_17000", "JSX attributes must only be assigned a non-empty 'expression'."),
                JSX_elements_cannot_have_multiple_attributes_with_the_same_name: diag(17001, 1 /* Error */ , "JSX_elements_cannot_have_multiple_attributes_with_the_same_name_17001", "JSX elements cannot have multiple attributes with the same name."),
                Expected_corresponding_JSX_closing_tag_for_0: diag(17002, 1 /* Error */ , "Expected_corresponding_JSX_closing_tag_for_0_17002", "Expected corresponding JSX closing tag for '{0}'."),
                Cannot_use_JSX_unless_the_jsx_flag_is_provided: diag(17004, 1 /* Error */ , "Cannot_use_JSX_unless_the_jsx_flag_is_provided_17004", "Cannot use JSX unless the '--jsx' flag is provided."),
                A_constructor_cannot_contain_a_super_call_when_its_class_extends_null: diag(17005, 1 /* Error */ , "A_constructor_cannot_contain_a_super_call_when_its_class_extends_null_17005", "A constructor cannot contain a 'super' call when its class extends 'null'."),
                An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses: diag(17006, 1 /* Error */ , "An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_ex_17006", "An unary expression with the '{0}' operator is not allowed in the left-hand side of an exponentiation expression. Consider enclosing the expression in parentheses."),
                A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses: diag(17007, 1 /* Error */ , "A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Con_17007", "A type assertion expression is not allowed in the left-hand side of an exponentiation expression. Consider enclosing the expression in parentheses."),
                JSX_element_0_has_no_corresponding_closing_tag: diag(17008, 1 /* Error */ , "JSX_element_0_has_no_corresponding_closing_tag_17008", "JSX element '{0}' has no corresponding closing tag."),
                super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class: diag(17009, 1 /* Error */ , "super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class_17009", "'super' must be called before accessing 'this' in the constructor of a derived class."),
                Unknown_type_acquisition_option_0: diag(17010, 1 /* Error */ , "Unknown_type_acquisition_option_0_17010", "Unknown type acquisition option '{0}'."),
                super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class: diag(17011, 1 /* Error */ , "super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class_17011", "'super' must be called before accessing a property of 'super' in the constructor of a derived class."),
                _0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2: diag(17012, 1 /* Error */ , "_0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2_17012", "'{0}' is not a valid meta-property for keyword '{1}'. Did you mean '{2}'?"),
                Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constructor: diag(17013, 1 /* Error */ , "Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constru_17013", "Meta-property '{0}' is only allowed in the body of a function declaration, function expression, or constructor."),
                JSX_fragment_has_no_corresponding_closing_tag: diag(17014, 1 /* Error */ , "JSX_fragment_has_no_corresponding_closing_tag_17014", "JSX fragment has no corresponding closing tag."),
                Expected_corresponding_closing_tag_for_JSX_fragment: diag(17015, 1 /* Error */ , "Expected_corresponding_closing_tag_for_JSX_fragment_17015", "Expected corresponding closing tag for JSX fragment."),
                The_jsxFragmentFactory_compiler_option_must_be_provided_to_use_JSX_fragments_with_the_jsxFactory_compiler_option: diag(17016, 1 /* Error */ , "The_jsxFragmentFactory_compiler_option_must_be_provided_to_use_JSX_fragments_with_the_jsxFactory_com_17016", "The 'jsxFragmentFactory' compiler option must be provided to use JSX fragments with the 'jsxFactory' compiler option."),
                An_jsxFrag_pragma_is_required_when_using_an_jsx_pragma_with_JSX_fragments: diag(17017, 1 /* Error */ , "An_jsxFrag_pragma_is_required_when_using_an_jsx_pragma_with_JSX_fragments_17017", "An @jsxFrag pragma is required when using an @jsx pragma with JSX fragments."),
                Unknown_type_acquisition_option_0_Did_you_mean_1: diag(17018, 1 /* Error */ , "Unknown_type_acquisition_option_0_Did_you_mean_1_17018", "Unknown type acquisition option '{0}'. Did you mean '{1}'?"),
                _0_at_the_end_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1: diag(17019, 1 /* Error */ , "_0_at_the_end_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1_17019", "'{0}' at the end of a type is not valid TypeScript syntax. Did you mean to write '{1}'?"),
                _0_at_the_start_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1: diag(17020, 1 /* Error */ , "_0_at_the_start_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1_17020", "'{0}' at the start of a type is not valid TypeScript syntax. Did you mean to write '{1}'?"),
                Circularity_detected_while_resolving_configuration_Colon_0: diag(18e3, 1 /* Error */ , "Circularity_detected_while_resolving_configuration_Colon_0_18000", "Circularity detected while resolving configuration: {0}"),
                The_files_list_in_config_file_0_is_empty: diag(18002, 1 /* Error */ , "The_files_list_in_config_file_0_is_empty_18002", "The 'files' list in config file '{0}' is empty."),
                No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2: diag(18003, 1 /* Error */ , "No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2_18003", "No inputs were found in config file '{0}'. Specified 'include' paths were '{1}' and 'exclude' paths were '{2}'."),
                File_is_a_CommonJS_module_it_may_be_converted_to_an_ES_module: diag(80001, 2 /* Suggestion */ , "File_is_a_CommonJS_module_it_may_be_converted_to_an_ES_module_80001", "File is a CommonJS module; it may be converted to an ES module."),
                This_constructor_function_may_be_converted_to_a_class_declaration: diag(80002, 2 /* Suggestion */ , "This_constructor_function_may_be_converted_to_a_class_declaration_80002", "This constructor function may be converted to a class declaration."),
                Import_may_be_converted_to_a_default_import: diag(80003, 2 /* Suggestion */ , "Import_may_be_converted_to_a_default_import_80003", "Import may be converted to a default import."),
                JSDoc_types_may_be_moved_to_TypeScript_types: diag(80004, 2 /* Suggestion */ , "JSDoc_types_may_be_moved_to_TypeScript_types_80004", "JSDoc types may be moved to TypeScript types."),
                require_call_may_be_converted_to_an_import: diag(80005, 2 /* Suggestion */ , "require_call_may_be_converted_to_an_import_80005", "'require' call may be converted to an import."),
                This_may_be_converted_to_an_async_function: diag(80006, 2 /* Suggestion */ , "This_may_be_converted_to_an_async_function_80006", "This may be converted to an async function."),
                await_has_no_effect_on_the_type_of_this_expression: diag(80007, 2 /* Suggestion */ , "await_has_no_effect_on_the_type_of_this_expression_80007", "'await' has no effect on the type of this expression."),
                Numeric_literals_with_absolute_values_equal_to_2_53_or_greater_are_too_large_to_be_represented_accurately_as_integers: diag(80008, 2 /* Suggestion */ , "Numeric_literals_with_absolute_values_equal_to_2_53_or_greater_are_too_large_to_be_represented_accur_80008", "Numeric literals with absolute values equal to 2^53 or greater are too large to be represented accurately as integers."),
                JSDoc_typedef_may_be_converted_to_TypeScript_type: diag(80009, 2 /* Suggestion */ , "JSDoc_typedef_may_be_converted_to_TypeScript_type_80009", "JSDoc typedef may be converted to TypeScript type."),
                JSDoc_typedefs_may_be_converted_to_TypeScript_types: diag(80010, 2 /* Suggestion */ , "JSDoc_typedefs_may_be_converted_to_TypeScript_types_80010", "JSDoc typedefs may be converted to TypeScript types."),
                Add_missing_super_call: diag(90001, 3 /* Message */ , "Add_missing_super_call_90001", "Add missing 'super()' call"),
                Make_super_call_the_first_statement_in_the_constructor: diag(90002, 3 /* Message */ , "Make_super_call_the_first_statement_in_the_constructor_90002", "Make 'super()' call the first statement in the constructor"),
                Change_extends_to_implements: diag(90003, 3 /* Message */ , "Change_extends_to_implements_90003", "Change 'extends' to 'implements'"),
                Remove_unused_declaration_for_Colon_0: diag(90004, 3 /* Message */ , "Remove_unused_declaration_for_Colon_0_90004", "Remove unused declaration for: '{0}'"),
                Remove_import_from_0: diag(90005, 3 /* Message */ , "Remove_import_from_0_90005", "Remove import from '{0}'"),
                Implement_interface_0: diag(90006, 3 /* Message */ , "Implement_interface_0_90006", "Implement interface '{0}'"),
                Implement_inherited_abstract_class: diag(90007, 3 /* Message */ , "Implement_inherited_abstract_class_90007", "Implement inherited abstract class"),
                Add_0_to_unresolved_variable: diag(90008, 3 /* Message */ , "Add_0_to_unresolved_variable_90008", "Add '{0}.' to unresolved variable"),
                Remove_variable_statement: diag(90010, 3 /* Message */ , "Remove_variable_statement_90010", "Remove variable statement"),
                Remove_template_tag: diag(90011, 3 /* Message */ , "Remove_template_tag_90011", "Remove template tag"),
                Remove_type_parameters: diag(90012, 3 /* Message */ , "Remove_type_parameters_90012", "Remove type parameters"),
                Import_0_from_1: diag(90013, 3 /* Message */ , "Import_0_from_1_90013", `Import '{0}' from "{1}"`),
                Change_0_to_1: diag(90014, 3 /* Message */ , "Change_0_to_1_90014", "Change '{0}' to '{1}'"),
                Declare_property_0: diag(90016, 3 /* Message */ , "Declare_property_0_90016", "Declare property '{0}'"),
                Add_index_signature_for_property_0: diag(90017, 3 /* Message */ , "Add_index_signature_for_property_0_90017", "Add index signature for property '{0}'"),
                Disable_checking_for_this_file: diag(90018, 3 /* Message */ , "Disable_checking_for_this_file_90018", "Disable checking for this file"),
                Ignore_this_error_message: diag(90019, 3 /* Message */ , "Ignore_this_error_message_90019", "Ignore this error message"),
                Initialize_property_0_in_the_constructor: diag(90020, 3 /* Message */ , "Initialize_property_0_in_the_constructor_90020", "Initialize property '{0}' in the constructor"),
                Initialize_static_property_0: diag(90021, 3 /* Message */ , "Initialize_static_property_0_90021", "Initialize static property '{0}'"),
                Change_spelling_to_0: diag(90022, 3 /* Message */ , "Change_spelling_to_0_90022", "Change spelling to '{0}'"),
                Declare_method_0: diag(90023, 3 /* Message */ , "Declare_method_0_90023", "Declare method '{0}'"),
                Declare_static_method_0: diag(90024, 3 /* Message */ , "Declare_static_method_0_90024", "Declare static method '{0}'"),
                Prefix_0_with_an_underscore: diag(90025, 3 /* Message */ , "Prefix_0_with_an_underscore_90025", "Prefix '{0}' with an underscore"),
                Rewrite_as_the_indexed_access_type_0: diag(90026, 3 /* Message */ , "Rewrite_as_the_indexed_access_type_0_90026", "Rewrite as the indexed access type '{0}'"),
                Declare_static_property_0: diag(90027, 3 /* Message */ , "Declare_static_property_0_90027", "Declare static property '{0}'"),
                Call_decorator_expression: diag(90028, 3 /* Message */ , "Call_decorator_expression_90028", "Call decorator expression"),
                Add_async_modifier_to_containing_function: diag(90029, 3 /* Message */ , "Add_async_modifier_to_containing_function_90029", "Add async modifier to containing function"),
                Replace_infer_0_with_unknown: diag(90030, 3 /* Message */ , "Replace_infer_0_with_unknown_90030", "Replace 'infer {0}' with 'unknown'"),
                Replace_all_unused_infer_with_unknown: diag(90031, 3 /* Message */ , "Replace_all_unused_infer_with_unknown_90031", "Replace all unused 'infer' with 'unknown'"),
                Add_parameter_name: diag(90034, 3 /* Message */ , "Add_parameter_name_90034", "Add parameter name"),
                Declare_private_property_0: diag(90035, 3 /* Message */ , "Declare_private_property_0_90035", "Declare private property '{0}'"),
                Replace_0_with_Promise_1: diag(90036, 3 /* Message */ , "Replace_0_with_Promise_1_90036", "Replace '{0}' with 'Promise<{1}>'"),
                Fix_all_incorrect_return_type_of_an_async_functions: diag(90037, 3 /* Message */ , "Fix_all_incorrect_return_type_of_an_async_functions_90037", "Fix all incorrect return type of an async functions"),
                Declare_private_method_0: diag(90038, 3 /* Message */ , "Declare_private_method_0_90038", "Declare private method '{0}'"),
                Remove_unused_destructuring_declaration: diag(90039, 3 /* Message */ , "Remove_unused_destructuring_declaration_90039", "Remove unused destructuring declaration"),
                Remove_unused_declarations_for_Colon_0: diag(90041, 3 /* Message */ , "Remove_unused_declarations_for_Colon_0_90041", "Remove unused declarations for: '{0}'"),
                Declare_a_private_field_named_0: diag(90053, 3 /* Message */ , "Declare_a_private_field_named_0_90053", "Declare a private field named '{0}'."),
                Includes_imports_of_types_referenced_by_0: diag(90054, 3 /* Message */ , "Includes_imports_of_types_referenced_by_0_90054", "Includes imports of types referenced by '{0}'"),
                Remove_type_from_import_declaration_from_0: diag(90055, 3 /* Message */ , "Remove_type_from_import_declaration_from_0_90055", `Remove 'type' from import declaration from "{0}"`),
                Remove_type_from_import_of_0_from_1: diag(90056, 3 /* Message */ , "Remove_type_from_import_of_0_from_1_90056", `Remove 'type' from import of '{0}' from "{1}"`),
                Add_import_from_0: diag(90057, 3 /* Message */ , "Add_import_from_0_90057", 'Add import from "{0}"'),
                Update_import_from_0: diag(90058, 3 /* Message */ , "Update_import_from_0_90058", 'Update import from "{0}"'),
                Export_0_from_module_1: diag(90059, 3 /* Message */ , "Export_0_from_module_1_90059", "Export '{0}' from module '{1}'"),
                Export_all_referenced_locals: diag(90060, 3 /* Message */ , "Export_all_referenced_locals_90060", "Export all referenced locals"),
                Convert_function_to_an_ES2015_class: diag(95001, 3 /* Message */ , "Convert_function_to_an_ES2015_class_95001", "Convert function to an ES2015 class"),
                Convert_0_to_1_in_0: diag(95003, 3 /* Message */ , "Convert_0_to_1_in_0_95003", "Convert '{0}' to '{1} in {0}'"),
                Extract_to_0_in_1: diag(95004, 3 /* Message */ , "Extract_to_0_in_1_95004", "Extract to {0} in {1}"),
                Extract_function: diag(95005, 3 /* Message */ , "Extract_function_95005", "Extract function"),
                Extract_constant: diag(95006, 3 /* Message */ , "Extract_constant_95006", "Extract constant"),
                Extract_to_0_in_enclosing_scope: diag(95007, 3 /* Message */ , "Extract_to_0_in_enclosing_scope_95007", "Extract to {0} in enclosing scope"),
                Extract_to_0_in_1_scope: diag(95008, 3 /* Message */ , "Extract_to_0_in_1_scope_95008", "Extract to {0} in {1} scope"),
                Annotate_with_type_from_JSDoc: diag(95009, 3 /* Message */ , "Annotate_with_type_from_JSDoc_95009", "Annotate with type from JSDoc"),
                Infer_type_of_0_from_usage: diag(95011, 3 /* Message */ , "Infer_type_of_0_from_usage_95011", "Infer type of '{0}' from usage"),
                Infer_parameter_types_from_usage: diag(95012, 3 /* Message */ , "Infer_parameter_types_from_usage_95012", "Infer parameter types from usage"),
                Convert_to_default_import: diag(95013, 3 /* Message */ , "Convert_to_default_import_95013", "Convert to default import"),
                Install_0: diag(95014, 3 /* Message */ , "Install_0_95014", "Install '{0}'"),
                Replace_import_with_0: diag(95015, 3 /* Message */ , "Replace_import_with_0_95015", "Replace import with '{0}'."),
                Use_synthetic_default_member: diag(95016, 3 /* Message */ , "Use_synthetic_default_member_95016", "Use synthetic 'default' member."),
                Convert_to_ES_module: diag(95017, 3 /* Message */ , "Convert_to_ES_module_95017", "Convert to ES module"),
                Add_undefined_type_to_property_0: diag(95018, 3 /* Message */ , "Add_undefined_type_to_property_0_95018", "Add 'undefined' type to property '{0}'"),
                Add_initializer_to_property_0: diag(95019, 3 /* Message */ , "Add_initializer_to_property_0_95019", "Add initializer to property '{0}'"),
                Add_definite_assignment_assertion_to_property_0: diag(95020, 3 /* Message */ , "Add_definite_assignment_assertion_to_property_0_95020", "Add definite assignment assertion to property '{0}'"),
                Convert_all_type_literals_to_mapped_type: diag(95021, 3 /* Message */ , "Convert_all_type_literals_to_mapped_type_95021", "Convert all type literals to mapped type"),
                Add_all_missing_members: diag(95022, 3 /* Message */ , "Add_all_missing_members_95022", "Add all missing members"),
                Infer_all_types_from_usage: diag(95023, 3 /* Message */ , "Infer_all_types_from_usage_95023", "Infer all types from usage"),
                Delete_all_unused_declarations: diag(95024, 3 /* Message */ , "Delete_all_unused_declarations_95024", "Delete all unused declarations"),
                Prefix_all_unused_declarations_with_where_possible: diag(95025, 3 /* Message */ , "Prefix_all_unused_declarations_with_where_possible_95025", "Prefix all unused declarations with '_' where possible"),
                Fix_all_detected_spelling_errors: diag(95026, 3 /* Message */ , "Fix_all_detected_spelling_errors_95026", "Fix all detected spelling errors"),
                Add_initializers_to_all_uninitialized_properties: diag(95027, 3 /* Message */ , "Add_initializers_to_all_uninitialized_properties_95027", "Add initializers to all uninitialized properties"),
                Add_definite_assignment_assertions_to_all_uninitialized_properties: diag(95028, 3 /* Message */ , "Add_definite_assignment_assertions_to_all_uninitialized_properties_95028", "Add definite assignment assertions to all uninitialized properties"),
                Add_undefined_type_to_all_uninitialized_properties: diag(95029, 3 /* Message */ , "Add_undefined_type_to_all_uninitialized_properties_95029", "Add undefined type to all uninitialized properties"),
                Change_all_jsdoc_style_types_to_TypeScript: diag(95030, 3 /* Message */ , "Change_all_jsdoc_style_types_to_TypeScript_95030", "Change all jsdoc-style types to TypeScript"),
                Change_all_jsdoc_style_types_to_TypeScript_and_add_undefined_to_nullable_types: diag(95031, 3 /* Message */ , "Change_all_jsdoc_style_types_to_TypeScript_and_add_undefined_to_nullable_types_95031", "Change all jsdoc-style types to TypeScript (and add '| undefined' to nullable types)"),
                Implement_all_unimplemented_interfaces: diag(95032, 3 /* Message */ , "Implement_all_unimplemented_interfaces_95032", "Implement all unimplemented interfaces"),
                Install_all_missing_types_packages: diag(95033, 3 /* Message */ , "Install_all_missing_types_packages_95033", "Install all missing types packages"),
                Rewrite_all_as_indexed_access_types: diag(95034, 3 /* Message */ , "Rewrite_all_as_indexed_access_types_95034", "Rewrite all as indexed access types"),
                Convert_all_to_default_imports: diag(95035, 3 /* Message */ , "Convert_all_to_default_imports_95035", "Convert all to default imports"),
                Make_all_super_calls_the_first_statement_in_their_constructor: diag(95036, 3 /* Message */ , "Make_all_super_calls_the_first_statement_in_their_constructor_95036", "Make all 'super()' calls the first statement in their constructor"),
                Add_qualifier_to_all_unresolved_variables_matching_a_member_name: diag(95037, 3 /* Message */ , "Add_qualifier_to_all_unresolved_variables_matching_a_member_name_95037", "Add qualifier to all unresolved variables matching a member name"),
                Change_all_extended_interfaces_to_implements: diag(95038, 3 /* Message */ , "Change_all_extended_interfaces_to_implements_95038", "Change all extended interfaces to 'implements'"),
                Add_all_missing_super_calls: diag(95039, 3 /* Message */ , "Add_all_missing_super_calls_95039", "Add all missing super calls"),
                Implement_all_inherited_abstract_classes: diag(95040, 3 /* Message */ , "Implement_all_inherited_abstract_classes_95040", "Implement all inherited abstract classes"),
                Add_all_missing_async_modifiers: diag(95041, 3 /* Message */ , "Add_all_missing_async_modifiers_95041", "Add all missing 'async' modifiers"),
                Add_ts_ignore_to_all_error_messages: diag(95042, 3 /* Message */ , "Add_ts_ignore_to_all_error_messages_95042", "Add '@ts-ignore' to all error messages"),
                Annotate_everything_with_types_from_JSDoc: diag(95043, 3 /* Message */ , "Annotate_everything_with_types_from_JSDoc_95043", "Annotate everything with types from JSDoc"),
                Add_to_all_uncalled_decorators: diag(95044, 3 /* Message */ , "Add_to_all_uncalled_decorators_95044", "Add '()' to all uncalled decorators"),
                Convert_all_constructor_functions_to_classes: diag(95045, 3 /* Message */ , "Convert_all_constructor_functions_to_classes_95045", "Convert all constructor functions to classes"),
                Generate_get_and_set_accessors: diag(95046, 3 /* Message */ , "Generate_get_and_set_accessors_95046", "Generate 'get' and 'set' accessors"),
                Convert_require_to_import: diag(95047, 3 /* Message */ , "Convert_require_to_import_95047", "Convert 'require' to 'import'"),
                Convert_all_require_to_import: diag(95048, 3 /* Message */ , "Convert_all_require_to_import_95048", "Convert all 'require' to 'import'"),
                Move_to_a_new_file: diag(95049, 3 /* Message */ , "Move_to_a_new_file_95049", "Move to a new file"),
                Remove_unreachable_code: diag(95050, 3 /* Message */ , "Remove_unreachable_code_95050", "Remove unreachable code"),
                Remove_all_unreachable_code: diag(95051, 3 /* Message */ , "Remove_all_unreachable_code_95051", "Remove all unreachable code"),
                Add_missing_typeof: diag(95052, 3 /* Message */ , "Add_missing_typeof_95052", "Add missing 'typeof'"),
                Remove_unused_label: diag(95053, 3 /* Message */ , "Remove_unused_label_95053", "Remove unused label"),
                Remove_all_unused_labels: diag(95054, 3 /* Message */ , "Remove_all_unused_labels_95054", "Remove all unused labels"),
                Convert_0_to_mapped_object_type: diag(95055, 3 /* Message */ , "Convert_0_to_mapped_object_type_95055", "Convert '{0}' to mapped object type"),
                Convert_namespace_import_to_named_imports: diag(95056, 3 /* Message */ , "Convert_namespace_import_to_named_imports_95056", "Convert namespace import to named imports"),
                Convert_named_imports_to_namespace_import: diag(95057, 3 /* Message */ , "Convert_named_imports_to_namespace_import_95057", "Convert named imports to namespace import"),
                Add_or_remove_braces_in_an_arrow_function: diag(95058, 3 /* Message */ , "Add_or_remove_braces_in_an_arrow_function_95058", "Add or remove braces in an arrow function"),
                Add_braces_to_arrow_function: diag(95059, 3 /* Message */ , "Add_braces_to_arrow_function_95059", "Add braces to arrow function"),
                Remove_braces_from_arrow_function: diag(95060, 3 /* Message */ , "Remove_braces_from_arrow_function_95060", "Remove braces from arrow function"),
                Convert_default_export_to_named_export: diag(95061, 3 /* Message */ , "Convert_default_export_to_named_export_95061", "Convert default export to named export"),
                Convert_named_export_to_default_export: diag(95062, 3 /* Message */ , "Convert_named_export_to_default_export_95062", "Convert named export to default export"),
                Add_missing_enum_member_0: diag(95063, 3 /* Message */ , "Add_missing_enum_member_0_95063", "Add missing enum member '{0}'"),
                Add_all_missing_imports: diag(95064, 3 /* Message */ , "Add_all_missing_imports_95064", "Add all missing imports"),
                Convert_to_async_function: diag(95065, 3 /* Message */ , "Convert_to_async_function_95065", "Convert to async function"),
                Convert_all_to_async_functions: diag(95066, 3 /* Message */ , "Convert_all_to_async_functions_95066", "Convert all to async functions"),
                Add_missing_call_parentheses: diag(95067, 3 /* Message */ , "Add_missing_call_parentheses_95067", "Add missing call parentheses"),
                Add_all_missing_call_parentheses: diag(95068, 3 /* Message */ , "Add_all_missing_call_parentheses_95068", "Add all missing call parentheses"),
                Add_unknown_conversion_for_non_overlapping_types: diag(95069, 3 /* Message */ , "Add_unknown_conversion_for_non_overlapping_types_95069", "Add 'unknown' conversion for non-overlapping types"),
                Add_unknown_to_all_conversions_of_non_overlapping_types: diag(95070, 3 /* Message */ , "Add_unknown_to_all_conversions_of_non_overlapping_types_95070", "Add 'unknown' to all conversions of non-overlapping types"),
                Add_missing_new_operator_to_call: diag(95071, 3 /* Message */ , "Add_missing_new_operator_to_call_95071", "Add missing 'new' operator to call"),
                Add_missing_new_operator_to_all_calls: diag(95072, 3 /* Message */ , "Add_missing_new_operator_to_all_calls_95072", "Add missing 'new' operator to all calls"),
                Add_names_to_all_parameters_without_names: diag(95073, 3 /* Message */ , "Add_names_to_all_parameters_without_names_95073", "Add names to all parameters without names"),
                Enable_the_experimentalDecorators_option_in_your_configuration_file: diag(95074, 3 /* Message */ , "Enable_the_experimentalDecorators_option_in_your_configuration_file_95074", "Enable the 'experimentalDecorators' option in your configuration file"),
                Convert_parameters_to_destructured_object: diag(95075, 3 /* Message */ , "Convert_parameters_to_destructured_object_95075", "Convert parameters to destructured object"),
                Extract_type: diag(95077, 3 /* Message */ , "Extract_type_95077", "Extract type"),
                Extract_to_type_alias: diag(95078, 3 /* Message */ , "Extract_to_type_alias_95078", "Extract to type alias"),
                Extract_to_typedef: diag(95079, 3 /* Message */ , "Extract_to_typedef_95079", "Extract to typedef"),
                Infer_this_type_of_0_from_usage: diag(95080, 3 /* Message */ , "Infer_this_type_of_0_from_usage_95080", "Infer 'this' type of '{0}' from usage"),
                Add_const_to_unresolved_variable: diag(95081, 3 /* Message */ , "Add_const_to_unresolved_variable_95081", "Add 'const' to unresolved variable"),
                Add_const_to_all_unresolved_variables: diag(95082, 3 /* Message */ , "Add_const_to_all_unresolved_variables_95082", "Add 'const' to all unresolved variables"),
                Add_await: diag(95083, 3 /* Message */ , "Add_await_95083", "Add 'await'"),
                Add_await_to_initializer_for_0: diag(95084, 3 /* Message */ , "Add_await_to_initializer_for_0_95084", "Add 'await' to initializer for '{0}'"),
                Fix_all_expressions_possibly_missing_await: diag(95085, 3 /* Message */ , "Fix_all_expressions_possibly_missing_await_95085", "Fix all expressions possibly missing 'await'"),
                Remove_unnecessary_await: diag(95086, 3 /* Message */ , "Remove_unnecessary_await_95086", "Remove unnecessary 'await'"),
                Remove_all_unnecessary_uses_of_await: diag(95087, 3 /* Message */ , "Remove_all_unnecessary_uses_of_await_95087", "Remove all unnecessary uses of 'await'"),
                Enable_the_jsx_flag_in_your_configuration_file: diag(95088, 3 /* Message */ , "Enable_the_jsx_flag_in_your_configuration_file_95088", "Enable the '--jsx' flag in your configuration file"),
                Add_await_to_initializers: diag(95089, 3 /* Message */ , "Add_await_to_initializers_95089", "Add 'await' to initializers"),
                Extract_to_interface: diag(95090, 3 /* Message */ , "Extract_to_interface_95090", "Extract to interface"),
                Convert_to_a_bigint_numeric_literal: diag(95091, 3 /* Message */ , "Convert_to_a_bigint_numeric_literal_95091", "Convert to a bigint numeric literal"),
                Convert_all_to_bigint_numeric_literals: diag(95092, 3 /* Message */ , "Convert_all_to_bigint_numeric_literals_95092", "Convert all to bigint numeric literals"),
                Convert_const_to_let: diag(95093, 3 /* Message */ , "Convert_const_to_let_95093", "Convert 'const' to 'let'"),
                Prefix_with_declare: diag(95094, 3 /* Message */ , "Prefix_with_declare_95094", "Prefix with 'declare'"),
                Prefix_all_incorrect_property_declarations_with_declare: diag(95095, 3 /* Message */ , "Prefix_all_incorrect_property_declarations_with_declare_95095", "Prefix all incorrect property declarations with 'declare'"),
                Convert_to_template_string: diag(95096, 3 /* Message */ , "Convert_to_template_string_95096", "Convert to template string"),
                Add_export_to_make_this_file_into_a_module: diag(95097, 3 /* Message */ , "Add_export_to_make_this_file_into_a_module_95097", "Add 'export {}' to make this file into a module"),
                Set_the_target_option_in_your_configuration_file_to_0: diag(95098, 3 /* Message */ , "Set_the_target_option_in_your_configuration_file_to_0_95098", "Set the 'target' option in your configuration file to '{0}'"),
                Set_the_module_option_in_your_configuration_file_to_0: diag(95099, 3 /* Message */ , "Set_the_module_option_in_your_configuration_file_to_0_95099", "Set the 'module' option in your configuration file to '{0}'"),
                Convert_invalid_character_to_its_html_entity_code: diag(95100, 3 /* Message */ , "Convert_invalid_character_to_its_html_entity_code_95100", "Convert invalid character to its html entity code"),
                Convert_all_invalid_characters_to_HTML_entity_code: diag(95101, 3 /* Message */ , "Convert_all_invalid_characters_to_HTML_entity_code_95101", "Convert all invalid characters to HTML entity code"),
                Convert_all_const_to_let: diag(95102, 3 /* Message */ , "Convert_all_const_to_let_95102", "Convert all 'const' to 'let'"),
                Convert_function_expression_0_to_arrow_function: diag(95105, 3 /* Message */ , "Convert_function_expression_0_to_arrow_function_95105", "Convert function expression '{0}' to arrow function"),
                Convert_function_declaration_0_to_arrow_function: diag(95106, 3 /* Message */ , "Convert_function_declaration_0_to_arrow_function_95106", "Convert function declaration '{0}' to arrow function"),
                Fix_all_implicit_this_errors: diag(95107, 3 /* Message */ , "Fix_all_implicit_this_errors_95107", "Fix all implicit-'this' errors"),
                Wrap_invalid_character_in_an_expression_container: diag(95108, 3 /* Message */ , "Wrap_invalid_character_in_an_expression_container_95108", "Wrap invalid character in an expression container"),
                Wrap_all_invalid_characters_in_an_expression_container: diag(95109, 3 /* Message */ , "Wrap_all_invalid_characters_in_an_expression_container_95109", "Wrap all invalid characters in an expression container"),
                Visit_https_Colon_Slash_Slashaka_ms_Slashtsconfig_to_read_more_about_this_file: diag(95110, 3 /* Message */ , "Visit_https_Colon_Slash_Slashaka_ms_Slashtsconfig_to_read_more_about_this_file_95110", "Visit https://aka.ms/tsconfig to read more about this file"),
                Add_a_return_statement: diag(95111, 3 /* Message */ , "Add_a_return_statement_95111", "Add a return statement"),
                Remove_braces_from_arrow_function_body: diag(95112, 3 /* Message */ , "Remove_braces_from_arrow_function_body_95112", "Remove braces from arrow function body"),
                Wrap_the_following_body_with_parentheses_which_should_be_an_object_literal: diag(95113, 3 /* Message */ , "Wrap_the_following_body_with_parentheses_which_should_be_an_object_literal_95113", "Wrap the following body with parentheses which should be an object literal"),
                Add_all_missing_return_statement: diag(95114, 3 /* Message */ , "Add_all_missing_return_statement_95114", "Add all missing return statement"),
                Remove_braces_from_all_arrow_function_bodies_with_relevant_issues: diag(95115, 3 /* Message */ , "Remove_braces_from_all_arrow_function_bodies_with_relevant_issues_95115", "Remove braces from all arrow function bodies with relevant issues"),
                Wrap_all_object_literal_with_parentheses: diag(95116, 3 /* Message */ , "Wrap_all_object_literal_with_parentheses_95116", "Wrap all object literal with parentheses"),
                Move_labeled_tuple_element_modifiers_to_labels: diag(95117, 3 /* Message */ , "Move_labeled_tuple_element_modifiers_to_labels_95117", "Move labeled tuple element modifiers to labels"),
                Convert_overload_list_to_single_signature: diag(95118, 3 /* Message */ , "Convert_overload_list_to_single_signature_95118", "Convert overload list to single signature"),
                Generate_get_and_set_accessors_for_all_overriding_properties: diag(95119, 3 /* Message */ , "Generate_get_and_set_accessors_for_all_overriding_properties_95119", "Generate 'get' and 'set' accessors for all overriding properties"),
                Wrap_in_JSX_fragment: diag(95120, 3 /* Message */ , "Wrap_in_JSX_fragment_95120", "Wrap in JSX fragment"),
                Wrap_all_unparented_JSX_in_JSX_fragment: diag(95121, 3 /* Message */ , "Wrap_all_unparented_JSX_in_JSX_fragment_95121", "Wrap all unparented JSX in JSX fragment"),
                Convert_arrow_function_or_function_expression: diag(95122, 3 /* Message */ , "Convert_arrow_function_or_function_expression_95122", "Convert arrow function or function expression"),
                Convert_to_anonymous_function: diag(95123, 3 /* Message */ , "Convert_to_anonymous_function_95123", "Convert to anonymous function"),
                Convert_to_named_function: diag(95124, 3 /* Message */ , "Convert_to_named_function_95124", "Convert to named function"),
                Convert_to_arrow_function: diag(95125, 3 /* Message */ , "Convert_to_arrow_function_95125", "Convert to arrow function"),
                Remove_parentheses: diag(95126, 3 /* Message */ , "Remove_parentheses_95126", "Remove parentheses"),
                Could_not_find_a_containing_arrow_function: diag(95127, 3 /* Message */ , "Could_not_find_a_containing_arrow_function_95127", "Could not find a containing arrow function"),
                Containing_function_is_not_an_arrow_function: diag(95128, 3 /* Message */ , "Containing_function_is_not_an_arrow_function_95128", "Containing function is not an arrow function"),
                Could_not_find_export_statement: diag(95129, 3 /* Message */ , "Could_not_find_export_statement_95129", "Could not find export statement"),
                This_file_already_has_a_default_export: diag(95130, 3 /* Message */ , "This_file_already_has_a_default_export_95130", "This file already has a default export"),
                Could_not_find_import_clause: diag(95131, 3 /* Message */ , "Could_not_find_import_clause_95131", "Could not find import clause"),
                Could_not_find_namespace_import_or_named_imports: diag(95132, 3 /* Message */ , "Could_not_find_namespace_import_or_named_imports_95132", "Could not find namespace import or named imports"),
                Selection_is_not_a_valid_type_node: diag(95133, 3 /* Message */ , "Selection_is_not_a_valid_type_node_95133", "Selection is not a valid type node"),
                No_type_could_be_extracted_from_this_type_node: diag(95134, 3 /* Message */ , "No_type_could_be_extracted_from_this_type_node_95134", "No type could be extracted from this type node"),
                Could_not_find_property_for_which_to_generate_accessor: diag(95135, 3 /* Message */ , "Could_not_find_property_for_which_to_generate_accessor_95135", "Could not find property for which to generate accessor"),
                Name_is_not_valid: diag(95136, 3 /* Message */ , "Name_is_not_valid_95136", "Name is not valid"),
                Can_only_convert_property_with_modifier: diag(95137, 3 /* Message */ , "Can_only_convert_property_with_modifier_95137", "Can only convert property with modifier"),
                Switch_each_misused_0_to_1: diag(95138, 3 /* Message */ , "Switch_each_misused_0_to_1_95138", "Switch each misused '{0}' to '{1}'"),
                Convert_to_optional_chain_expression: diag(95139, 3 /* Message */ , "Convert_to_optional_chain_expression_95139", "Convert to optional chain expression"),
                Could_not_find_convertible_access_expression: diag(95140, 3 /* Message */ , "Could_not_find_convertible_access_expression_95140", "Could not find convertible access expression"),
                Could_not_find_matching_access_expressions: diag(95141, 3 /* Message */ , "Could_not_find_matching_access_expressions_95141", "Could not find matching access expressions"),
                Can_only_convert_logical_AND_access_chains: diag(95142, 3 /* Message */ , "Can_only_convert_logical_AND_access_chains_95142", "Can only convert logical AND access chains"),
                Add_void_to_Promise_resolved_without_a_value: diag(95143, 3 /* Message */ , "Add_void_to_Promise_resolved_without_a_value_95143", "Add 'void' to Promise resolved without a value"),
                Add_void_to_all_Promises_resolved_without_a_value: diag(95144, 3 /* Message */ , "Add_void_to_all_Promises_resolved_without_a_value_95144", "Add 'void' to all Promises resolved without a value"),
                Use_element_access_for_0: diag(95145, 3 /* Message */ , "Use_element_access_for_0_95145", "Use element access for '{0}'"),
                Use_element_access_for_all_undeclared_properties: diag(95146, 3 /* Message */ , "Use_element_access_for_all_undeclared_properties_95146", "Use element access for all undeclared properties."),
                Delete_all_unused_imports: diag(95147, 3 /* Message */ , "Delete_all_unused_imports_95147", "Delete all unused imports"),
                Infer_function_return_type: diag(95148, 3 /* Message */ , "Infer_function_return_type_95148", "Infer function return type"),
                Return_type_must_be_inferred_from_a_function: diag(95149, 3 /* Message */ , "Return_type_must_be_inferred_from_a_function_95149", "Return type must be inferred from a function"),
                Could_not_determine_function_return_type: diag(95150, 3 /* Message */ , "Could_not_determine_function_return_type_95150", "Could not determine function return type"),
                Could_not_convert_to_arrow_function: diag(95151, 3 /* Message */ , "Could_not_convert_to_arrow_function_95151", "Could not convert to arrow function"),
                Could_not_convert_to_named_function: diag(95152, 3 /* Message */ , "Could_not_convert_to_named_function_95152", "Could not convert to named function"),
                Could_not_convert_to_anonymous_function: diag(95153, 3 /* Message */ , "Could_not_convert_to_anonymous_function_95153", "Could not convert to anonymous function"),
                Can_only_convert_string_concatenation: diag(95154, 3 /* Message */ , "Can_only_convert_string_concatenation_95154", "Can only convert string concatenation"),
                Selection_is_not_a_valid_statement_or_statements: diag(95155, 3 /* Message */ , "Selection_is_not_a_valid_statement_or_statements_95155", "Selection is not a valid statement or statements"),
                Add_missing_function_declaration_0: diag(95156, 3 /* Message */ , "Add_missing_function_declaration_0_95156", "Add missing function declaration '{0}'"),
                Add_all_missing_function_declarations: diag(95157, 3 /* Message */ , "Add_all_missing_function_declarations_95157", "Add all missing function declarations"),
                Method_not_implemented: diag(95158, 3 /* Message */ , "Method_not_implemented_95158", "Method not implemented."),
                Function_not_implemented: diag(95159, 3 /* Message */ , "Function_not_implemented_95159", "Function not implemented."),
                Add_override_modifier: diag(95160, 3 /* Message */ , "Add_override_modifier_95160", "Add 'override' modifier"),
                Remove_override_modifier: diag(95161, 3 /* Message */ , "Remove_override_modifier_95161", "Remove 'override' modifier"),
                Add_all_missing_override_modifiers: diag(95162, 3 /* Message */ , "Add_all_missing_override_modifiers_95162", "Add all missing 'override' modifiers"),
                Remove_all_unnecessary_override_modifiers: diag(95163, 3 /* Message */ , "Remove_all_unnecessary_override_modifiers_95163", "Remove all unnecessary 'override' modifiers"),
                Can_only_convert_named_export: diag(95164, 3 /* Message */ , "Can_only_convert_named_export_95164", "Can only convert named export"),
                Add_missing_properties: diag(95165, 3 /* Message */ , "Add_missing_properties_95165", "Add missing properties"),
                Add_all_missing_properties: diag(95166, 3 /* Message */ , "Add_all_missing_properties_95166", "Add all missing properties"),
                Add_missing_attributes: diag(95167, 3 /* Message */ , "Add_missing_attributes_95167", "Add missing attributes"),
                Add_all_missing_attributes: diag(95168, 3 /* Message */ , "Add_all_missing_attributes_95168", "Add all missing attributes"),
                Add_undefined_to_optional_property_type: diag(95169, 3 /* Message */ , "Add_undefined_to_optional_property_type_95169", "Add 'undefined' to optional property type"),
                Convert_named_imports_to_default_import: diag(95170, 3 /* Message */ , "Convert_named_imports_to_default_import_95170", "Convert named imports to default import"),
                Delete_unused_param_tag_0: diag(95171, 3 /* Message */ , "Delete_unused_param_tag_0_95171", "Delete unused '@param' tag '{0}'"),
                Delete_all_unused_param_tags: diag(95172, 3 /* Message */ , "Delete_all_unused_param_tags_95172", "Delete all unused '@param' tags"),
                Rename_param_tag_name_0_to_1: diag(95173, 3 /* Message */ , "Rename_param_tag_name_0_to_1_95173", "Rename '@param' tag name '{0}' to '{1}'"),
                Use_0: diag(95174, 3 /* Message */ , "Use_0_95174", "Use `{0}`."),
                Use_Number_isNaN_in_all_conditions: diag(95175, 3 /* Message */ , "Use_Number_isNaN_in_all_conditions_95175", "Use `Number.isNaN` in all conditions."),
                Convert_typedef_to_TypeScript_type: diag(95176, 3 /* Message */ , "Convert_typedef_to_TypeScript_type_95176", "Convert typedef to TypeScript type."),
                Convert_all_typedef_to_TypeScript_types: diag(95177, 3 /* Message */ , "Convert_all_typedef_to_TypeScript_types_95177", "Convert all typedef to TypeScript types."),
                Move_to_file: diag(95178, 3 /* Message */ , "Move_to_file_95178", "Move to file"),
                Cannot_move_to_file_selected_file_is_invalid: diag(95179, 3 /* Message */ , "Cannot_move_to_file_selected_file_is_invalid_95179", "Cannot move to file, selected file is invalid"),
                No_value_exists_in_scope_for_the_shorthand_property_0_Either_declare_one_or_provide_an_initializer: diag(18004, 1 /* Error */ , "No_value_exists_in_scope_for_the_shorthand_property_0_Either_declare_one_or_provide_an_initializer_18004", "No value exists in scope for the shorthand property '{0}'. Either declare one or provide an initializer."),
                Classes_may_not_have_a_field_named_constructor: diag(18006, 1 /* Error */ , "Classes_may_not_have_a_field_named_constructor_18006", "Classes may not have a field named 'constructor'."),
                JSX_expressions_may_not_use_the_comma_operator_Did_you_mean_to_write_an_array: diag(18007, 1 /* Error */ , "JSX_expressions_may_not_use_the_comma_operator_Did_you_mean_to_write_an_array_18007", "JSX expressions may not use the comma operator. Did you mean to write an array?"),
                Private_identifiers_cannot_be_used_as_parameters: diag(18009, 1 /* Error */ , "Private_identifiers_cannot_be_used_as_parameters_18009", "Private identifiers cannot be used as parameters."),
                An_accessibility_modifier_cannot_be_used_with_a_private_identifier: diag(18010, 1 /* Error */ , "An_accessibility_modifier_cannot_be_used_with_a_private_identifier_18010", "An accessibility modifier cannot be used with a private identifier."),
                The_operand_of_a_delete_operator_cannot_be_a_private_identifier: diag(18011, 1 /* Error */ , "The_operand_of_a_delete_operator_cannot_be_a_private_identifier_18011", "The operand of a 'delete' operator cannot be a private identifier."),
                constructor_is_a_reserved_word: diag(18012, 1 /* Error */ , "constructor_is_a_reserved_word_18012", "'#constructor' is a reserved word."),
                Property_0_is_not_accessible_outside_class_1_because_it_has_a_private_identifier: diag(18013, 1 /* Error */ , "Property_0_is_not_accessible_outside_class_1_because_it_has_a_private_identifier_18013", "Property '{0}' is not accessible outside class '{1}' because it has a private identifier."),
                The_property_0_cannot_be_accessed_on_type_1_within_this_class_because_it_is_shadowed_by_another_private_identifier_with_the_same_spelling: diag(18014, 1 /* Error */ , "The_property_0_cannot_be_accessed_on_type_1_within_this_class_because_it_is_shadowed_by_another_priv_18014", "The property '{0}' cannot be accessed on type '{1}' within this class because it is shadowed by another private identifier with the same spelling."),
                Property_0_in_type_1_refers_to_a_different_member_that_cannot_be_accessed_from_within_type_2: diag(18015, 1 /* Error */ , "Property_0_in_type_1_refers_to_a_different_member_that_cannot_be_accessed_from_within_type_2_18015", "Property '{0}' in type '{1}' refers to a different member that cannot be accessed from within type '{2}'."),
                Private_identifiers_are_not_allowed_outside_class_bodies: diag(18016, 1 /* Error */ , "Private_identifiers_are_not_allowed_outside_class_bodies_18016", "Private identifiers are not allowed outside class bodies."),
                The_shadowing_declaration_of_0_is_defined_here: diag(18017, 1 /* Error */ , "The_shadowing_declaration_of_0_is_defined_here_18017", "The shadowing declaration of '{0}' is defined here"),
                The_declaration_of_0_that_you_probably_intended_to_use_is_defined_here: diag(18018, 1 /* Error */ , "The_declaration_of_0_that_you_probably_intended_to_use_is_defined_here_18018", "The declaration of '{0}' that you probably intended to use is defined here"),
                _0_modifier_cannot_be_used_with_a_private_identifier: diag(18019, 1 /* Error */ , "_0_modifier_cannot_be_used_with_a_private_identifier_18019", "'{0}' modifier cannot be used with a private identifier."),
                An_enum_member_cannot_be_named_with_a_private_identifier: diag(18024, 1 /* Error */ , "An_enum_member_cannot_be_named_with_a_private_identifier_18024", "An enum member cannot be named with a private identifier."),
                can_only_be_used_at_the_start_of_a_file: diag(18026, 1 /* Error */ , "can_only_be_used_at_the_start_of_a_file_18026", "'#!' can only be used at the start of a file."),
                Compiler_reserves_name_0_when_emitting_private_identifier_downlevel: diag(18027, 1 /* Error */ , "Compiler_reserves_name_0_when_emitting_private_identifier_downlevel_18027", "Compiler reserves name '{0}' when emitting private identifier downlevel."),
                Private_identifiers_are_only_available_when_targeting_ECMAScript_2015_and_higher: diag(18028, 1 /* Error */ , "Private_identifiers_are_only_available_when_targeting_ECMAScript_2015_and_higher_18028", "Private identifiers are only available when targeting ECMAScript 2015 and higher."),
                Private_identifiers_are_not_allowed_in_variable_declarations: diag(18029, 1 /* Error */ , "Private_identifiers_are_not_allowed_in_variable_declarations_18029", "Private identifiers are not allowed in variable declarations."),
                An_optional_chain_cannot_contain_private_identifiers: diag(18030, 1 /* Error */ , "An_optional_chain_cannot_contain_private_identifiers_18030", "An optional chain cannot contain private identifiers."),
                The_intersection_0_was_reduced_to_never_because_property_1_has_conflicting_types_in_some_constituents: diag(18031, 1 /* Error */ , "The_intersection_0_was_reduced_to_never_because_property_1_has_conflicting_types_in_some_constituent_18031", "The intersection '{0}' was reduced to 'never' because property '{1}' has conflicting types in some constituents."),
                The_intersection_0_was_reduced_to_never_because_property_1_exists_in_multiple_constituents_and_is_private_in_some: diag(18032, 1 /* Error */ , "The_intersection_0_was_reduced_to_never_because_property_1_exists_in_multiple_constituents_and_is_pr_18032", "The intersection '{0}' was reduced to 'never' because property '{1}' exists in multiple constituents and is private in some."),
                Type_0_is_not_assignable_to_type_1_as_required_for_computed_enum_member_values: diag(18033, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_as_required_for_computed_enum_member_values_18033", "Type '{0}' is not assignable to type '{1}' as required for computed enum member values."),
                Specify_the_JSX_fragment_factory_function_to_use_when_targeting_react_JSX_emit_with_jsxFactory_compiler_option_is_specified_e_g_Fragment: diag(18034, 3 /* Message */ , "Specify_the_JSX_fragment_factory_function_to_use_when_targeting_react_JSX_emit_with_jsxFactory_compi_18034", "Specify the JSX fragment factory function to use when targeting 'react' JSX emit with 'jsxFactory' compiler option is specified, e.g. 'Fragment'."),
                Invalid_value_for_jsxFragmentFactory_0_is_not_a_valid_identifier_or_qualified_name: diag(18035, 1 /* Error */ , "Invalid_value_for_jsxFragmentFactory_0_is_not_a_valid_identifier_or_qualified_name_18035", "Invalid value for 'jsxFragmentFactory'. '{0}' is not a valid identifier or qualified-name."),
                Class_decorators_can_t_be_used_with_static_private_identifier_Consider_removing_the_experimental_decorator: diag(18036, 1 /* Error */ , "Class_decorators_can_t_be_used_with_static_private_identifier_Consider_removing_the_experimental_dec_18036", "Class decorators can't be used with static private identifier. Consider removing the experimental decorator."),
                Await_expression_cannot_be_used_inside_a_class_static_block: diag(18037, 1 /* Error */ , "Await_expression_cannot_be_used_inside_a_class_static_block_18037", "Await expression cannot be used inside a class static block."),
                For_await_loops_cannot_be_used_inside_a_class_static_block: diag(18038, 1 /* Error */ , "For_await_loops_cannot_be_used_inside_a_class_static_block_18038", "'For await' loops cannot be used inside a class static block."),
                Invalid_use_of_0_It_cannot_be_used_inside_a_class_static_block: diag(18039, 1 /* Error */ , "Invalid_use_of_0_It_cannot_be_used_inside_a_class_static_block_18039", "Invalid use of '{0}'. It cannot be used inside a class static block."),
                A_return_statement_cannot_be_used_inside_a_class_static_block: diag(18041, 1 /* Error */ , "A_return_statement_cannot_be_used_inside_a_class_static_block_18041", "A 'return' statement cannot be used inside a class static block."),
                _0_is_a_type_and_cannot_be_imported_in_JavaScript_files_Use_1_in_a_JSDoc_type_annotation: diag(18042, 1 /* Error */ , "_0_is_a_type_and_cannot_be_imported_in_JavaScript_files_Use_1_in_a_JSDoc_type_annotation_18042", "'{0}' is a type and cannot be imported in JavaScript files. Use '{1}' in a JSDoc type annotation."),
                Types_cannot_appear_in_export_declarations_in_JavaScript_files: diag(18043, 1 /* Error */ , "Types_cannot_appear_in_export_declarations_in_JavaScript_files_18043", "Types cannot appear in export declarations in JavaScript files."),
                _0_is_automatically_exported_here: diag(18044, 3 /* Message */ , "_0_is_automatically_exported_here_18044", "'{0}' is automatically exported here."),
                Properties_with_the_accessor_modifier_are_only_available_when_targeting_ECMAScript_2015_and_higher: diag(18045, 1 /* Error */ , "Properties_with_the_accessor_modifier_are_only_available_when_targeting_ECMAScript_2015_and_higher_18045", "Properties with the 'accessor' modifier are only available when targeting ECMAScript 2015 and higher."),
                _0_is_of_type_unknown: diag(18046, 1 /* Error */ , "_0_is_of_type_unknown_18046", "'{0}' is of type 'unknown'."),
                _0_is_possibly_null: diag(18047, 1 /* Error */ , "_0_is_possibly_null_18047", "'{0}' is possibly 'null'."),
                _0_is_possibly_undefined: diag(18048, 1 /* Error */ , "_0_is_possibly_undefined_18048", "'{0}' is possibly 'undefined'."),
                _0_is_possibly_null_or_undefined: diag(18049, 1 /* Error */ , "_0_is_possibly_null_or_undefined_18049", "'{0}' is possibly 'null' or 'undefined'."),
                The_value_0_cannot_be_used_here: diag(18050, 1 /* Error */ , "The_value_0_cannot_be_used_here_18050", "The value '{0}' cannot be used here."),
                Compiler_option_0_cannot_be_given_an_empty_string: diag(18051, 1 /* Error */ , "Compiler_option_0_cannot_be_given_an_empty_string_18051", "Compiler option '{0}' cannot be given an empty string."),
                Non_abstract_class_0_does_not_implement_all_abstract_members_of_1: diag(18052, 1 /* Error */ , "Non_abstract_class_0_does_not_implement_all_abstract_members_of_1_18052", "Non-abstract class '{0}' does not implement all abstract members of '{1}'"),
                Its_type_0_is_not_a_valid_JSX_element_type: diag(18053, 1 /* Error */ , "Its_type_0_is_not_a_valid_JSX_element_type_18053", "Its type '{0}' is not a valid JSX element type.")
            };
        }
    });
    // src/compiler/scanner.ts
    function tokenIsIdentifierOrKeyword(token) {
        return token >= 80 /* Identifier */ ;
    }
    function tokenIsIdentifierOrKeywordOrGreaterThan(token) {
        return token === 32 /* GreaterThanToken */  || tokenIsIdentifierOrKeyword(token);
    }
    function lookupInUnicodeMap(code, map2) {
        if (code < map2[0]) return false;
        let lo = 0;
        let hi = map2.length;
        let mid;
        while(lo + 1 < hi){
            mid = lo + (hi - lo) / 2;
            mid -= mid % 2;
            if (map2[mid] <= code && code <= map2[mid + 1]) return true;
            if (code < map2[mid]) hi = mid;
            else lo = mid + 2;
        }
        return false;
    }
    function isUnicodeIdentifierStart(code, languageVersion) {
        return languageVersion >= 2 /* ES2015 */  ? lookupInUnicodeMap(code, unicodeESNextIdentifierStart) : languageVersion === 1 /* ES5 */  ? lookupInUnicodeMap(code, unicodeES5IdentifierStart) : lookupInUnicodeMap(code, unicodeES3IdentifierStart);
    }
    function isUnicodeIdentifierPart(code, languageVersion) {
        return languageVersion >= 2 /* ES2015 */  ? lookupInUnicodeMap(code, unicodeESNextIdentifierPart) : languageVersion === 1 /* ES5 */  ? lookupInUnicodeMap(code, unicodeES5IdentifierPart) : lookupInUnicodeMap(code, unicodeES3IdentifierPart);
    }
    function makeReverseMap(source) {
        const result = [];
        source.forEach((value1, name)=>{
            result[value1] = name;
        });
        return result;
    }
    function tokenToString(t) {
        return tokenStrings[t];
    }
    function stringToToken(s) {
        return textToToken.get(s);
    }
    function computeLineStarts(text) {
        const result = [];
        let pos = 0;
        let lineStart = 0;
        while(pos < text.length){
            const ch = text.charCodeAt(pos);
            pos++;
            switch(ch){
                case 13 /* carriageReturn */ :
                    if (text.charCodeAt(pos) === 10 /* lineFeed */ ) pos++;
                case 10 /* lineFeed */ :
                    result.push(lineStart);
                    lineStart = pos;
                    break;
                default:
                    if (ch > 127 /* maxAsciiCharacter */  && isLineBreak(ch)) {
                        result.push(lineStart);
                        lineStart = pos;
                    }
                    break;
            }
        }
        result.push(lineStart);
        return result;
    }
    function getPositionOfLineAndCharacter(sourceFile, line, character, allowEdits) {
        return sourceFile.getPositionOfLineAndCharacter ? sourceFile.getPositionOfLineAndCharacter(line, character, allowEdits) : computePositionOfLineAndCharacter(getLineStarts(sourceFile), line, character, sourceFile.text, allowEdits);
    }
    function computePositionOfLineAndCharacter(lineStarts, line, character, debugText, allowEdits) {
        if (line < 0 || line >= lineStarts.length) {
            if (allowEdits) line = line < 0 ? 0 : line >= lineStarts.length ? lineStarts.length - 1 : line;
            else Debug.fail(`Bad line number. Line: ${line}, lineStarts.length: ${lineStarts.length} , line map is correct? ${debugText !== void 0 ? arraysEqual(lineStarts, computeLineStarts(debugText)) : "unknown"}`);
        }
        const res = lineStarts[line] + character;
        if (allowEdits) return res > lineStarts[line + 1] ? lineStarts[line + 1] : typeof debugText === "string" && res > debugText.length ? debugText.length : res;
        if (line < lineStarts.length - 1) Debug.assert(res < lineStarts[line + 1]);
        else if (debugText !== void 0) Debug.assert(res <= debugText.length);
        return res;
    }
    function getLineStarts(sourceFile) {
        return sourceFile.lineMap || (sourceFile.lineMap = computeLineStarts(sourceFile.text));
    }
    function computeLineAndCharacterOfPosition(lineStarts, position) {
        const lineNumber = computeLineOfPosition(lineStarts, position);
        return {
            line: lineNumber,
            character: position - lineStarts[lineNumber]
        };
    }
    function computeLineOfPosition(lineStarts, position, lowerBound) {
        let lineNumber = binarySearch(lineStarts, position, identity, compareValues, lowerBound);
        if (lineNumber < 0) {
            lineNumber = ~lineNumber - 1;
            Debug.assert(lineNumber !== -1, "position cannot precede the beginning of the file");
        }
        return lineNumber;
    }
    function getLinesBetweenPositions(sourceFile, pos1, pos2) {
        if (pos1 === pos2) return 0;
        const lineStarts = getLineStarts(sourceFile);
        const lower = Math.min(pos1, pos2);
        const isNegative = lower === pos2;
        const upper = isNegative ? pos1 : pos2;
        const lowerLine = computeLineOfPosition(lineStarts, lower);
        const upperLine = computeLineOfPosition(lineStarts, upper, lowerLine);
        return isNegative ? lowerLine - upperLine : upperLine - lowerLine;
    }
    function getLineAndCharacterOfPosition(sourceFile, position) {
        return computeLineAndCharacterOfPosition(getLineStarts(sourceFile), position);
    }
    function isWhiteSpaceLike(ch) {
        return isWhiteSpaceSingleLine(ch) || isLineBreak(ch);
    }
    function isWhiteSpaceSingleLine(ch) {
        return ch === 32 /* space */  || ch === 9 /* tab */  || ch === 11 /* verticalTab */  || ch === 12 /* formFeed */  || ch === 160 /* nonBreakingSpace */  || ch === 133 /* nextLine */  || ch === 5760 /* ogham */  || ch >= 8192 /* enQuad */  && ch <= 8203 /* zeroWidthSpace */  || ch === 8239 /* narrowNoBreakSpace */  || ch === 8287 /* mathematicalSpace */  || ch === 12288 /* ideographicSpace */  || ch === 65279 /* byteOrderMark */ ;
    }
    function isLineBreak(ch) {
        return ch === 10 /* lineFeed */  || ch === 13 /* carriageReturn */  || ch === 8232 /* lineSeparator */  || ch === 8233 /* paragraphSeparator */ ;
    }
    function isDigit(ch) {
        return ch >= 48 /* _0 */  && ch <= 57 /* _9 */ ;
    }
    function isHexDigit(ch) {
        return isDigit(ch) || ch >= 65 /* A */  && ch <= 70 /* F */  || ch >= 97 /* a */  && ch <= 102 /* f */ ;
    }
    function isCodePoint(code) {
        return code <= 1114111;
    }
    function isOctalDigit(ch) {
        return ch >= 48 /* _0 */  && ch <= 55 /* _7 */ ;
    }
    function couldStartTrivia(text, pos) {
        const ch = text.charCodeAt(pos);
        switch(ch){
            case 13 /* carriageReturn */ :
            case 10 /* lineFeed */ :
            case 9 /* tab */ :
            case 11 /* verticalTab */ :
            case 12 /* formFeed */ :
            case 32 /* space */ :
            case 47 /* slash */ :
            case 60 /* lessThan */ :
            case 124 /* bar */ :
            case 61 /* equals */ :
            case 62 /* greaterThan */ :
                return true;
            case 35 /* hash */ :
                return pos === 0;
            default:
                return ch > 127 /* maxAsciiCharacter */ ;
        }
    }
    function skipTrivia(text, pos, stopAfterLineBreak, stopAtComments, inJSDoc) {
        if (positionIsSynthesized(pos)) return pos;
        let canConsumeStar = false;
        while(true){
            const ch = text.charCodeAt(pos);
            switch(ch){
                case 13 /* carriageReturn */ :
                    if (text.charCodeAt(pos + 1) === 10 /* lineFeed */ ) pos++;
                case 10 /* lineFeed */ :
                    pos++;
                    if (stopAfterLineBreak) return pos;
                    canConsumeStar = !!inJSDoc;
                    continue;
                case 9 /* tab */ :
                case 11 /* verticalTab */ :
                case 12 /* formFeed */ :
                case 32 /* space */ :
                    pos++;
                    continue;
                case 47 /* slash */ :
                    if (stopAtComments) break;
                    if (text.charCodeAt(pos + 1) === 47 /* slash */ ) {
                        pos += 2;
                        while(pos < text.length){
                            if (isLineBreak(text.charCodeAt(pos))) break;
                            pos++;
                        }
                        canConsumeStar = false;
                        continue;
                    }
                    if (text.charCodeAt(pos + 1) === 42 /* asterisk */ ) {
                        pos += 2;
                        while(pos < text.length){
                            if (text.charCodeAt(pos) === 42 /* asterisk */  && text.charCodeAt(pos + 1) === 47 /* slash */ ) {
                                pos += 2;
                                break;
                            }
                            pos++;
                        }
                        canConsumeStar = false;
                        continue;
                    }
                    break;
                case 60 /* lessThan */ :
                case 124 /* bar */ :
                case 61 /* equals */ :
                case 62 /* greaterThan */ :
                    if (isConflictMarkerTrivia(text, pos)) {
                        pos = scanConflictMarkerTrivia(text, pos);
                        canConsumeStar = false;
                        continue;
                    }
                    break;
                case 35 /* hash */ :
                    if (pos === 0 && isShebangTrivia(text, pos)) {
                        pos = scanShebangTrivia(text, pos);
                        canConsumeStar = false;
                        continue;
                    }
                    break;
                case 42 /* asterisk */ :
                    if (canConsumeStar) {
                        pos++;
                        canConsumeStar = false;
                        continue;
                    }
                    break;
                default:
                    if (ch > 127 /* maxAsciiCharacter */  && isWhiteSpaceLike(ch)) {
                        pos++;
                        continue;
                    }
                    break;
            }
            return pos;
        }
    }
    function isConflictMarkerTrivia(text, pos) {
        Debug.assert(pos >= 0);
        if (pos === 0 || isLineBreak(text.charCodeAt(pos - 1))) {
            const ch = text.charCodeAt(pos);
            if (pos + mergeConflictMarkerLength < text.length) {
                for(let i = 0; i < mergeConflictMarkerLength; i++){
                    if (text.charCodeAt(pos + i) !== ch) return false;
                }
                return ch === 61 /* equals */  || text.charCodeAt(pos + mergeConflictMarkerLength) === 32 /* space */ ;
            }
        }
        return false;
    }
    function scanConflictMarkerTrivia(text, pos, error) {
        if (error) error(Diagnostics.Merge_conflict_marker_encountered, pos, mergeConflictMarkerLength);
        const ch = text.charCodeAt(pos);
        const len = text.length;
        if (ch === 60 /* lessThan */  || ch === 62 /* greaterThan */ ) while(pos < len && !isLineBreak(text.charCodeAt(pos)))pos++;
        else {
            Debug.assert(ch === 124 /* bar */  || ch === 61 /* equals */ );
            while(pos < len){
                const currentChar = text.charCodeAt(pos);
                if ((currentChar === 61 /* equals */  || currentChar === 62 /* greaterThan */ ) && currentChar !== ch && isConflictMarkerTrivia(text, pos)) break;
                pos++;
            }
        }
        return pos;
    }
    function isShebangTrivia(text, pos) {
        Debug.assert(pos === 0);
        return shebangTriviaRegex.test(text);
    }
    function scanShebangTrivia(text, pos) {
        const shebang = shebangTriviaRegex.exec(text)[0];
        pos = pos + shebang.length;
        return pos;
    }
    function iterateCommentRanges(reduce, text, pos, trailing, cb, state, initial) {
        let pendingPos;
        let pendingEnd;
        let pendingKind;
        let pendingHasTrailingNewLine;
        let hasPendingCommentRange = false;
        let collecting = trailing;
        let accumulator = initial;
        if (pos === 0) {
            collecting = true;
            const shebang = getShebang(text);
            if (shebang) pos = shebang.length;
        }
        scan: while(pos >= 0 && pos < text.length){
            const ch = text.charCodeAt(pos);
            switch(ch){
                case 13 /* carriageReturn */ :
                    if (text.charCodeAt(pos + 1) === 10 /* lineFeed */ ) pos++;
                case 10 /* lineFeed */ :
                    pos++;
                    if (trailing) break scan;
                    collecting = true;
                    if (hasPendingCommentRange) pendingHasTrailingNewLine = true;
                    continue;
                case 9 /* tab */ :
                case 11 /* verticalTab */ :
                case 12 /* formFeed */ :
                case 32 /* space */ :
                    pos++;
                    continue;
                case 47 /* slash */ :
                    const nextChar = text.charCodeAt(pos + 1);
                    let hasTrailingNewLine = false;
                    if (nextChar === 47 /* slash */  || nextChar === 42 /* asterisk */ ) {
                        const kind = nextChar === 47 /* slash */  ? 2 /* SingleLineCommentTrivia */  : 3 /* MultiLineCommentTrivia */ ;
                        const startPos = pos;
                        pos += 2;
                        if (nextChar === 47 /* slash */ ) while(pos < text.length){
                            if (isLineBreak(text.charCodeAt(pos))) {
                                hasTrailingNewLine = true;
                                break;
                            }
                            pos++;
                        }
                        else while(pos < text.length){
                            if (text.charCodeAt(pos) === 42 /* asterisk */  && text.charCodeAt(pos + 1) === 47 /* slash */ ) {
                                pos += 2;
                                break;
                            }
                            pos++;
                        }
                        if (collecting) {
                            if (hasPendingCommentRange) {
                                accumulator = cb(pendingPos, pendingEnd, pendingKind, pendingHasTrailingNewLine, state, accumulator);
                                if (!reduce && accumulator) return accumulator;
                            }
                            pendingPos = startPos;
                            pendingEnd = pos;
                            pendingKind = kind;
                            pendingHasTrailingNewLine = hasTrailingNewLine;
                            hasPendingCommentRange = true;
                        }
                        continue;
                    }
                    break scan;
                default:
                    if (ch > 127 /* maxAsciiCharacter */  && isWhiteSpaceLike(ch)) {
                        if (hasPendingCommentRange && isLineBreak(ch)) pendingHasTrailingNewLine = true;
                        pos++;
                        continue;
                    }
                    break scan;
            }
        }
        if (hasPendingCommentRange) accumulator = cb(pendingPos, pendingEnd, pendingKind, pendingHasTrailingNewLine, state, accumulator);
        return accumulator;
    }
    function forEachLeadingCommentRange(text, pos, cb, state) {
        return iterateCommentRanges(/*reduce*/ false, text, pos, /*trailing*/ false, cb, state);
    }
    function forEachTrailingCommentRange(text, pos, cb, state) {
        return iterateCommentRanges(/*reduce*/ false, text, pos, /*trailing*/ true, cb, state);
    }
    function reduceEachLeadingCommentRange(text, pos, cb, state, initial) {
        return iterateCommentRanges(/*reduce*/ true, text, pos, /*trailing*/ false, cb, state, initial);
    }
    function reduceEachTrailingCommentRange(text, pos, cb, state, initial) {
        return iterateCommentRanges(/*reduce*/ true, text, pos, /*trailing*/ true, cb, state, initial);
    }
    function appendCommentRange(pos, end, kind, hasTrailingNewLine, _state, comments = []) {
        comments.push({
            kind: kind,
            pos: pos,
            end: end,
            hasTrailingNewLine: hasTrailingNewLine
        });
        return comments;
    }
    function getLeadingCommentRanges(text, pos) {
        return reduceEachLeadingCommentRange(text, pos, appendCommentRange, /*state*/ void 0, /*initial*/ void 0);
    }
    function getTrailingCommentRanges(text, pos) {
        return reduceEachTrailingCommentRange(text, pos, appendCommentRange, /*state*/ void 0, /*initial*/ void 0);
    }
    function getShebang(text) {
        const match = shebangTriviaRegex.exec(text);
        if (match) return match[0];
    }
    function isIdentifierStart(ch, languageVersion) {
        return ch >= 65 /* A */  && ch <= 90 /* Z */  || ch >= 97 /* a */  && ch <= 122 /* z */  || ch === 36 /* $ */  || ch === 95 /* _ */  || ch > 127 /* maxAsciiCharacter */  && isUnicodeIdentifierStart(ch, languageVersion);
    }
    function isIdentifierPart(ch, languageVersion, identifierVariant) {
        return ch >= 65 /* A */  && ch <= 90 /* Z */  || ch >= 97 /* a */  && ch <= 122 /* z */  || ch >= 48 /* _0 */  && ch <= 57 /* _9 */  || ch === 36 /* $ */  || ch === 95 /* _ */  || // "-" and ":" are valid in JSX Identifiers
        (identifierVariant === 1 /* JSX */  ? ch === 45 /* minus */  || ch === 58 /* colon */  : false) || ch > 127 /* maxAsciiCharacter */  && isUnicodeIdentifierPart(ch, languageVersion);
    }
    function isIdentifierText(name, languageVersion, identifierVariant) {
        let ch = codePointAt(name, 0);
        if (!isIdentifierStart(ch, languageVersion)) return false;
        for(let i = charSize(ch); i < name.length; i += charSize(ch)){
            if (!isIdentifierPart(ch = codePointAt(name, i), languageVersion, identifierVariant)) return false;
        }
        return true;
    }
    function createScanner(languageVersion, skipTrivia2, languageVariant = 0 /* Standard */ , textInitial, onError, start, length2) {
        var text = textInitial;
        var pos;
        var end;
        var fullStartPos;
        var tokenStart;
        var token;
        var tokenValue;
        var tokenFlags;
        var commentDirectives;
        var inJSDocType = 0;
        setText(text, start, length2);
        var scanner2 = {
            getTokenFullStart: ()=>fullStartPos,
            getStartPos: ()=>fullStartPos,
            getTokenEnd: ()=>pos,
            getTextPos: ()=>pos,
            getToken: ()=>token,
            getTokenStart: ()=>tokenStart,
            getTokenPos: ()=>tokenStart,
            getTokenText: ()=>text.substring(tokenStart, pos),
            getTokenValue: ()=>tokenValue,
            hasUnicodeEscape: ()=>(tokenFlags & 1024 /* UnicodeEscape */ ) !== 0,
            hasExtendedUnicodeEscape: ()=>(tokenFlags & 8 /* ExtendedUnicodeEscape */ ) !== 0,
            hasPrecedingLineBreak: ()=>(tokenFlags & 1 /* PrecedingLineBreak */ ) !== 0,
            hasPrecedingJSDocComment: ()=>(tokenFlags & 2 /* PrecedingJSDocComment */ ) !== 0,
            isIdentifier: ()=>token === 80 /* Identifier */  || token > 118 /* LastReservedWord */ ,
            isReservedWord: ()=>token >= 83 /* FirstReservedWord */  && token <= 118 /* LastReservedWord */ ,
            isUnterminated: ()=>(tokenFlags & 4 /* Unterminated */ ) !== 0,
            getCommentDirectives: ()=>commentDirectives,
            getNumericLiteralFlags: ()=>tokenFlags & 25584 /* NumericLiteralFlags */ ,
            getTokenFlags: ()=>tokenFlags,
            reScanGreaterToken: reScanGreaterToken,
            reScanAsteriskEqualsToken: reScanAsteriskEqualsToken,
            reScanSlashToken: reScanSlashToken,
            reScanTemplateToken: reScanTemplateToken,
            reScanTemplateHeadOrNoSubstitutionTemplate: reScanTemplateHeadOrNoSubstitutionTemplate,
            scanJsxIdentifier: scanJsxIdentifier,
            scanJsxAttributeValue: scanJsxAttributeValue,
            reScanJsxAttributeValue: reScanJsxAttributeValue,
            reScanJsxToken: reScanJsxToken,
            reScanLessThanToken: reScanLessThanToken,
            reScanHashToken: reScanHashToken,
            reScanQuestionToken: reScanQuestionToken,
            reScanInvalidIdentifier: reScanInvalidIdentifier,
            scanJsxToken: scanJsxToken,
            scanJsDocToken: scanJsDocToken,
            scanJSDocCommentTextToken: scanJSDocCommentTextToken,
            scan: scan,
            getText: getText,
            clearCommentDirectives: clearCommentDirectives,
            setText: setText,
            setScriptTarget: setScriptTarget,
            setLanguageVariant: setLanguageVariant,
            setOnError: setOnError,
            resetTokenState: resetTokenState,
            setTextPos: resetTokenState,
            setInJSDocType: setInJSDocType,
            tryScan: tryScan,
            lookAhead: lookAhead,
            scanRange: scanRange
        };
        if (Debug.isDebugging) Object.defineProperty(scanner2, "__debugShowCurrentPositionInText", {
            get: ()=>{
                const text2 = scanner2.getText();
                return text2.slice(0, scanner2.getTokenFullStart()) + "║" + text2.slice(scanner2.getTokenFullStart());
            }
        });
        return scanner2;
        function error(message, errPos = pos, length3, arg0) {
            if (onError) {
                const oldPos = pos;
                pos = errPos;
                onError(message, length3 || 0, arg0);
                pos = oldPos;
            }
        }
        function scanNumberFragment() {
            let start2 = pos;
            let allowSeparator = false;
            let isPreviousTokenSeparator = false;
            let result = "";
            while(true){
                const ch = text.charCodeAt(pos);
                if (ch === 95 /* _ */ ) {
                    tokenFlags |= 512 /* ContainsSeparator */ ;
                    if (allowSeparator) {
                        allowSeparator = false;
                        isPreviousTokenSeparator = true;
                        result += text.substring(start2, pos);
                    } else {
                        tokenFlags |= 16384 /* ContainsInvalidSeparator */ ;
                        if (isPreviousTokenSeparator) error(Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
                        else error(Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
                    }
                    pos++;
                    start2 = pos;
                    continue;
                }
                if (isDigit(ch)) {
                    allowSeparator = true;
                    isPreviousTokenSeparator = false;
                    pos++;
                    continue;
                }
                break;
            }
            if (text.charCodeAt(pos - 1) === 95 /* _ */ ) {
                tokenFlags |= 16384 /* ContainsInvalidSeparator */ ;
                error(Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
            }
            return result + text.substring(start2, pos);
        }
        function scanNumber() {
            let start2 = pos;
            let mainFragment;
            if (text.charCodeAt(pos) === 48 /* _0 */ ) {
                pos++;
                if (text.charCodeAt(pos) === 95 /* _ */ ) {
                    tokenFlags |= 16896 /* ContainsInvalidSeparator */ ;
                    error(Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
                    pos--;
                    mainFragment = scanNumberFragment();
                } else if (!scanDigits()) {
                    tokenFlags |= 8192 /* ContainsLeadingZero */ ;
                    mainFragment = "" + +tokenValue;
                } else if (!tokenValue) mainFragment = "0";
                else {
                    tokenValue = "" + parseInt(tokenValue, 8);
                    tokenFlags |= 32 /* Octal */ ;
                    const withMinus = token === 41 /* MinusToken */ ;
                    const literal = (withMinus ? "-" : "") + "0o" + (+tokenValue).toString(8);
                    if (withMinus) start2--;
                    error(Diagnostics.Octal_literals_are_not_allowed_Use_the_syntax_0, start2, pos - start2, literal);
                    return {
                        type: 9 /* NumericLiteral */ ,
                        value: tokenValue
                    };
                }
            } else mainFragment = scanNumberFragment();
            let decimalFragment;
            let scientificFragment;
            if (text.charCodeAt(pos) === 46 /* dot */ ) {
                pos++;
                decimalFragment = scanNumberFragment();
            }
            let end2 = pos;
            if (text.charCodeAt(pos) === 69 /* E */  || text.charCodeAt(pos) === 101 /* e */ ) {
                pos++;
                tokenFlags |= 16 /* Scientific */ ;
                if (text.charCodeAt(pos) === 43 /* plus */  || text.charCodeAt(pos) === 45 /* minus */ ) pos++;
                const preNumericPart = pos;
                const finalFragment = scanNumberFragment();
                if (!finalFragment) error(Diagnostics.Digit_expected);
                else {
                    scientificFragment = text.substring(end2, preNumericPart) + finalFragment;
                    end2 = pos;
                }
            }
            let result;
            if (tokenFlags & 512 /* ContainsSeparator */ ) {
                result = mainFragment;
                if (decimalFragment) result += "." + decimalFragment;
                if (scientificFragment) result += scientificFragment;
            } else result = text.substring(start2, end2);
            if (tokenFlags & 8192 /* ContainsLeadingZero */ ) {
                error(Diagnostics.Decimals_with_leading_zeros_are_not_allowed, start2, end2 - start2);
                return {
                    type: 9 /* NumericLiteral */ ,
                    value: "" + +result
                };
            }
            if (decimalFragment !== void 0 || tokenFlags & 16 /* Scientific */ ) {
                checkForIdentifierStartAfterNumericLiteral(start2, decimalFragment === void 0 && !!(tokenFlags & 16 /* Scientific */ ));
                return {
                    type: 9 /* NumericLiteral */ ,
                    value: "" + +result
                };
            } else {
                tokenValue = result;
                const type = checkBigIntSuffix();
                checkForIdentifierStartAfterNumericLiteral(start2);
                return {
                    type: type,
                    value: tokenValue
                };
            }
        }
        function checkForIdentifierStartAfterNumericLiteral(numericStart, isScientific) {
            if (!isIdentifierStart(codePointAt(text, pos), languageVersion)) return;
            const identifierStart = pos;
            const { length: length3  } = scanIdentifierParts();
            if (length3 === 1 && text[identifierStart] === "n") {
                if (isScientific) error(Diagnostics.A_bigint_literal_cannot_use_exponential_notation, numericStart, identifierStart - numericStart + 1);
                else error(Diagnostics.A_bigint_literal_must_be_an_integer, numericStart, identifierStart - numericStart + 1);
            } else {
                error(Diagnostics.An_identifier_or_keyword_cannot_immediately_follow_a_numeric_literal, identifierStart, length3);
                pos = identifierStart;
            }
        }
        function scanDigits() {
            const start2 = pos;
            let isOctal = true;
            while(isDigit(text.charCodeAt(pos))){
                if (!isOctalDigit(text.charCodeAt(pos))) isOctal = false;
                pos++;
            }
            tokenValue = text.substring(start2, pos);
            return isOctal;
        }
        function scanExactNumberOfHexDigits(count, canHaveSeparators) {
            const valueString = scanHexDigits(/*minCount*/ count, /*scanAsManyAsPossible*/ false, canHaveSeparators);
            return valueString ? parseInt(valueString, 16) : -1;
        }
        function scanMinimumNumberOfHexDigits(count, canHaveSeparators) {
            return scanHexDigits(/*minCount*/ count, /*scanAsManyAsPossible*/ true, canHaveSeparators);
        }
        function scanHexDigits(minCount, scanAsManyAsPossible, canHaveSeparators) {
            let valueChars = [];
            let allowSeparator = false;
            let isPreviousTokenSeparator = false;
            while(valueChars.length < minCount || scanAsManyAsPossible){
                let ch = text.charCodeAt(pos);
                if (canHaveSeparators && ch === 95 /* _ */ ) {
                    tokenFlags |= 512 /* ContainsSeparator */ ;
                    if (allowSeparator) {
                        allowSeparator = false;
                        isPreviousTokenSeparator = true;
                    } else if (isPreviousTokenSeparator) error(Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
                    else error(Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
                    pos++;
                    continue;
                }
                allowSeparator = canHaveSeparators;
                if (ch >= 65 /* A */  && ch <= 70 /* F */ ) ch += 32 /* A */ ;
                else if (!(ch >= 48 /* _0 */  && ch <= 57 /* _9 */  || ch >= 97 /* a */  && ch <= 102 /* f */ )) break;
                valueChars.push(ch);
                pos++;
                isPreviousTokenSeparator = false;
            }
            if (valueChars.length < minCount) valueChars = [];
            if (text.charCodeAt(pos - 1) === 95 /* _ */ ) error(Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
            return String.fromCharCode(...valueChars);
        }
        function scanString(jsxAttributeString = false) {
            const quote2 = text.charCodeAt(pos);
            pos++;
            let result = "";
            let start2 = pos;
            while(true){
                if (pos >= end) {
                    result += text.substring(start2, pos);
                    tokenFlags |= 4 /* Unterminated */ ;
                    error(Diagnostics.Unterminated_string_literal);
                    break;
                }
                const ch = text.charCodeAt(pos);
                if (ch === quote2) {
                    result += text.substring(start2, pos);
                    pos++;
                    break;
                }
                if (ch === 92 /* backslash */  && !jsxAttributeString) {
                    result += text.substring(start2, pos);
                    result += scanEscapeSequence(/*shouldEmitInvalidEscapeError*/ true);
                    start2 = pos;
                    continue;
                }
                if (isLineBreak(ch) && !jsxAttributeString) {
                    result += text.substring(start2, pos);
                    tokenFlags |= 4 /* Unterminated */ ;
                    error(Diagnostics.Unterminated_string_literal);
                    break;
                }
                pos++;
            }
            return result;
        }
        function scanTemplateAndSetTokenValue(shouldEmitInvalidEscapeError) {
            const startedWithBacktick = text.charCodeAt(pos) === 96 /* backtick */ ;
            pos++;
            let start2 = pos;
            let contents = "";
            let resultingToken;
            while(true){
                if (pos >= end) {
                    contents += text.substring(start2, pos);
                    tokenFlags |= 4 /* Unterminated */ ;
                    error(Diagnostics.Unterminated_template_literal);
                    resultingToken = startedWithBacktick ? 15 /* NoSubstitutionTemplateLiteral */  : 18 /* TemplateTail */ ;
                    break;
                }
                const currChar = text.charCodeAt(pos);
                if (currChar === 96 /* backtick */ ) {
                    contents += text.substring(start2, pos);
                    pos++;
                    resultingToken = startedWithBacktick ? 15 /* NoSubstitutionTemplateLiteral */  : 18 /* TemplateTail */ ;
                    break;
                }
                if (currChar === 36 /* $ */  && pos + 1 < end && text.charCodeAt(pos + 1) === 123 /* openBrace */ ) {
                    contents += text.substring(start2, pos);
                    pos += 2;
                    resultingToken = startedWithBacktick ? 16 /* TemplateHead */  : 17 /* TemplateMiddle */ ;
                    break;
                }
                if (currChar === 92 /* backslash */ ) {
                    contents += text.substring(start2, pos);
                    contents += scanEscapeSequence(shouldEmitInvalidEscapeError);
                    start2 = pos;
                    continue;
                }
                if (currChar === 13 /* carriageReturn */ ) {
                    contents += text.substring(start2, pos);
                    pos++;
                    if (pos < end && text.charCodeAt(pos) === 10 /* lineFeed */ ) pos++;
                    contents += "\n";
                    start2 = pos;
                    continue;
                }
                pos++;
            }
            Debug.assert(resultingToken !== void 0);
            tokenValue = contents;
            return resultingToken;
        }
        function scanEscapeSequence(shouldEmitInvalidEscapeError) {
            const start2 = pos;
            pos++;
            if (pos >= end) {
                error(Diagnostics.Unexpected_end_of_text);
                return "";
            }
            const ch = text.charCodeAt(pos);
            pos++;
            switch(ch){
                case 48 /* _0 */ :
                    if (pos >= end || !isDigit(text.charCodeAt(pos))) return "\x00";
                case 49 /* _1 */ :
                case 50 /* _2 */ :
                case 51 /* _3 */ :
                    if (pos < end && isOctalDigit(text.charCodeAt(pos))) pos++;
                case 52 /* _4 */ :
                case 53 /* _5 */ :
                case 54 /* _6 */ :
                case 55 /* _7 */ :
                    if (pos < end && isOctalDigit(text.charCodeAt(pos))) pos++;
                    tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                    if (shouldEmitInvalidEscapeError) {
                        const code = parseInt(text.substring(start2 + 1, pos), 8);
                        error(Diagnostics.Octal_escape_sequences_are_not_allowed_Use_the_syntax_0, start2, pos - start2, "\\x" + padLeft(code.toString(16), 2, "0"));
                        return String.fromCharCode(code);
                    }
                    return text.substring(start2, pos);
                case 56 /* _8 */ :
                case 57 /* _9 */ :
                    tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                    if (shouldEmitInvalidEscapeError) {
                        error(Diagnostics.Escape_sequence_0_is_not_allowed, start2, pos - start2, text.substring(start2, pos));
                        return String.fromCharCode(ch);
                    }
                    return text.substring(start2, pos);
                case 98 /* b */ :
                    return "\b";
                case 116 /* t */ :
                    return "	";
                case 110 /* n */ :
                    return "\n";
                case 118 /* v */ :
                    return "\v";
                case 102 /* f */ :
                    return "\f";
                case 114 /* r */ :
                    return "\r";
                case 39 /* singleQuote */ :
                    return "'";
                case 34 /* doubleQuote */ :
                    return '"';
                case 117 /* u */ :
                    if (pos < end && text.charCodeAt(pos) === 123 /* openBrace */ ) {
                        pos++;
                        const escapedValueString = scanMinimumNumberOfHexDigits(1, /*canHaveSeparators*/ false);
                        const escapedValue = escapedValueString ? parseInt(escapedValueString, 16) : -1;
                        if (escapedValue < 0) {
                            tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                            if (shouldEmitInvalidEscapeError) error(Diagnostics.Hexadecimal_digit_expected);
                            return text.substring(start2, pos);
                        }
                        if (!isCodePoint(escapedValue)) {
                            tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                            if (shouldEmitInvalidEscapeError) error(Diagnostics.An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive);
                            return text.substring(start2, pos);
                        }
                        if (pos >= end) {
                            tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                            if (shouldEmitInvalidEscapeError) error(Diagnostics.Unexpected_end_of_text);
                            return text.substring(start2, pos);
                        }
                        if (text.charCodeAt(pos) !== 125 /* closeBrace */ ) {
                            tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                            if (shouldEmitInvalidEscapeError) error(Diagnostics.Unterminated_Unicode_escape_sequence);
                            return text.substring(start2, pos);
                        }
                        pos++;
                        tokenFlags |= 8 /* ExtendedUnicodeEscape */ ;
                        return utf16EncodeAsString(escapedValue);
                    }
                    for(; pos < start2 + 6; pos++)if (!(pos < end && isHexDigit(text.charCodeAt(pos)))) {
                        tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                        if (shouldEmitInvalidEscapeError) error(Diagnostics.Hexadecimal_digit_expected);
                        return text.substring(start2, pos);
                    }
                    tokenFlags |= 1024 /* UnicodeEscape */ ;
                    return String.fromCharCode(parseInt(text.substring(start2 + 2, pos), 16));
                case 120 /* x */ :
                    for(; pos < start2 + 4; pos++)if (!(pos < end && isHexDigit(text.charCodeAt(pos)))) {
                        tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                        if (shouldEmitInvalidEscapeError) error(Diagnostics.Hexadecimal_digit_expected);
                        return text.substring(start2, pos);
                    }
                    tokenFlags |= 4096 /* HexEscape */ ;
                    return String.fromCharCode(parseInt(text.substring(start2 + 2, pos), 16));
                case 13 /* carriageReturn */ :
                    if (pos < end && text.charCodeAt(pos) === 10 /* lineFeed */ ) pos++;
                case 10 /* lineFeed */ :
                case 8232 /* lineSeparator */ :
                case 8233 /* paragraphSeparator */ :
                    return "";
                default:
                    return String.fromCharCode(ch);
            }
        }
        function scanExtendedUnicodeEscape() {
            const escapedValueString = scanMinimumNumberOfHexDigits(1, /*canHaveSeparators*/ false);
            const escapedValue = escapedValueString ? parseInt(escapedValueString, 16) : -1;
            let isInvalidExtendedEscape = false;
            if (escapedValue < 0) {
                error(Diagnostics.Hexadecimal_digit_expected);
                isInvalidExtendedEscape = true;
            } else if (escapedValue > 1114111) {
                error(Diagnostics.An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive);
                isInvalidExtendedEscape = true;
            }
            if (pos >= end) {
                error(Diagnostics.Unexpected_end_of_text);
                isInvalidExtendedEscape = true;
            } else if (text.charCodeAt(pos) === 125 /* closeBrace */ ) pos++;
            else {
                error(Diagnostics.Unterminated_Unicode_escape_sequence);
                isInvalidExtendedEscape = true;
            }
            if (isInvalidExtendedEscape) return "";
            return utf16EncodeAsString(escapedValue);
        }
        function peekUnicodeEscape() {
            if (pos + 5 < end && text.charCodeAt(pos + 1) === 117 /* u */ ) {
                const start2 = pos;
                pos += 2;
                const value1 = scanExactNumberOfHexDigits(4, /*canHaveSeparators*/ false);
                pos = start2;
                return value1;
            }
            return -1;
        }
        function peekExtendedUnicodeEscape() {
            if (codePointAt(text, pos + 1) === 117 /* u */  && codePointAt(text, pos + 2) === 123 /* openBrace */ ) {
                const start2 = pos;
                pos += 3;
                const escapedValueString = scanMinimumNumberOfHexDigits(1, /*canHaveSeparators*/ false);
                const escapedValue = escapedValueString ? parseInt(escapedValueString, 16) : -1;
                pos = start2;
                return escapedValue;
            }
            return -1;
        }
        function scanIdentifierParts() {
            let result = "";
            let start2 = pos;
            while(pos < end){
                let ch = codePointAt(text, pos);
                if (isIdentifierPart(ch, languageVersion)) pos += charSize(ch);
                else if (ch === 92 /* backslash */ ) {
                    ch = peekExtendedUnicodeEscape();
                    if (ch >= 0 && isIdentifierPart(ch, languageVersion)) {
                        pos += 3;
                        tokenFlags |= 8 /* ExtendedUnicodeEscape */ ;
                        result += scanExtendedUnicodeEscape();
                        start2 = pos;
                        continue;
                    }
                    ch = peekUnicodeEscape();
                    if (!(ch >= 0 && isIdentifierPart(ch, languageVersion))) break;
                    tokenFlags |= 1024 /* UnicodeEscape */ ;
                    result += text.substring(start2, pos);
                    result += utf16EncodeAsString(ch);
                    pos += 6;
                    start2 = pos;
                } else break;
            }
            result += text.substring(start2, pos);
            return result;
        }
        function getIdentifierToken() {
            const len = tokenValue.length;
            if (len >= 2 && len <= 12) {
                const ch = tokenValue.charCodeAt(0);
                if (ch >= 97 /* a */  && ch <= 122 /* z */ ) {
                    const keyword = textToKeyword.get(tokenValue);
                    if (keyword !== void 0) return token = keyword;
                }
            }
            return token = 80 /* Identifier */ ;
        }
        function scanBinaryOrOctalDigits(base) {
            let value1 = "";
            let separatorAllowed = false;
            let isPreviousTokenSeparator = false;
            while(true){
                const ch = text.charCodeAt(pos);
                if (ch === 95 /* _ */ ) {
                    tokenFlags |= 512 /* ContainsSeparator */ ;
                    if (separatorAllowed) {
                        separatorAllowed = false;
                        isPreviousTokenSeparator = true;
                    } else if (isPreviousTokenSeparator) error(Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
                    else error(Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
                    pos++;
                    continue;
                }
                separatorAllowed = true;
                if (!isDigit(ch) || ch - 48 /* _0 */  >= base) break;
                value1 += text[pos];
                pos++;
                isPreviousTokenSeparator = false;
            }
            if (text.charCodeAt(pos - 1) === 95 /* _ */ ) error(Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
            return value1;
        }
        function checkBigIntSuffix() {
            if (text.charCodeAt(pos) === 110 /* n */ ) {
                tokenValue += "n";
                if (tokenFlags & 384 /* BinaryOrOctalSpecifier */ ) tokenValue = parsePseudoBigInt(tokenValue) + "n";
                pos++;
                return 10 /* BigIntLiteral */ ;
            } else {
                const numericValue = tokenFlags & 128 /* BinarySpecifier */  ? parseInt(tokenValue.slice(2), 2) : tokenFlags & 256 /* OctalSpecifier */  ? parseInt(tokenValue.slice(2), 8) : +tokenValue;
                tokenValue = "" + numericValue;
                return 9 /* NumericLiteral */ ;
            }
        }
        function scan() {
            fullStartPos = pos;
            tokenFlags = 0 /* None */ ;
            let asteriskSeen = false;
            while(true){
                tokenStart = pos;
                if (pos >= end) return token = 1 /* EndOfFileToken */ ;
                const ch = codePointAt(text, pos);
                if (pos === 0) {
                    if (ch === 65533 /* replacementCharacter */ ) {
                        error(Diagnostics.File_appears_to_be_binary);
                        pos = end;
                        return token = 8 /* NonTextFileMarkerTrivia */ ;
                    }
                    if (ch === 35 /* hash */  && isShebangTrivia(text, pos)) {
                        pos = scanShebangTrivia(text, pos);
                        if (skipTrivia2) continue;
                        else return token = 6 /* ShebangTrivia */ ;
                    }
                }
                switch(ch){
                    case 10 /* lineFeed */ :
                    case 13 /* carriageReturn */ :
                        tokenFlags |= 1 /* PrecedingLineBreak */ ;
                        if (skipTrivia2) {
                            pos++;
                            continue;
                        } else {
                            if (ch === 13 /* carriageReturn */  && pos + 1 < end && text.charCodeAt(pos + 1) === 10 /* lineFeed */ ) pos += 2;
                            else pos++;
                            return token = 4 /* NewLineTrivia */ ;
                        }
                    case 9 /* tab */ :
                    case 11 /* verticalTab */ :
                    case 12 /* formFeed */ :
                    case 32 /* space */ :
                    case 160 /* nonBreakingSpace */ :
                    case 5760 /* ogham */ :
                    case 8192 /* enQuad */ :
                    case 8193 /* emQuad */ :
                    case 8194 /* enSpace */ :
                    case 8195 /* emSpace */ :
                    case 8196 /* threePerEmSpace */ :
                    case 8197 /* fourPerEmSpace */ :
                    case 8198 /* sixPerEmSpace */ :
                    case 8199 /* figureSpace */ :
                    case 8200 /* punctuationSpace */ :
                    case 8201 /* thinSpace */ :
                    case 8202 /* hairSpace */ :
                    case 8203 /* zeroWidthSpace */ :
                    case 8239 /* narrowNoBreakSpace */ :
                    case 8287 /* mathematicalSpace */ :
                    case 12288 /* ideographicSpace */ :
                    case 65279 /* byteOrderMark */ :
                        if (skipTrivia2) {
                            pos++;
                            continue;
                        } else {
                            while(pos < end && isWhiteSpaceSingleLine(text.charCodeAt(pos)))pos++;
                            return token = 5 /* WhitespaceTrivia */ ;
                        }
                    case 33 /* exclamation */ :
                        if (text.charCodeAt(pos + 1) === 61 /* equals */ ) {
                            if (text.charCodeAt(pos + 2) === 61 /* equals */ ) return pos += 3, token = 38 /* ExclamationEqualsEqualsToken */ ;
                            return pos += 2, token = 36 /* ExclamationEqualsToken */ ;
                        }
                        pos++;
                        return token = 54 /* ExclamationToken */ ;
                    case 34 /* doubleQuote */ :
                    case 39 /* singleQuote */ :
                        tokenValue = scanString();
                        return token = 11 /* StringLiteral */ ;
                    case 96 /* backtick */ :
                        return token = scanTemplateAndSetTokenValue(/*shouldEmitInvalidEscapeError*/ false);
                    case 37 /* percent */ :
                        if (text.charCodeAt(pos + 1) === 61 /* equals */ ) return pos += 2, token = 70 /* PercentEqualsToken */ ;
                        pos++;
                        return token = 45 /* PercentToken */ ;
                    case 38 /* ampersand */ :
                        if (text.charCodeAt(pos + 1) === 38 /* ampersand */ ) {
                            if (text.charCodeAt(pos + 2) === 61 /* equals */ ) return pos += 3, token = 77 /* AmpersandAmpersandEqualsToken */ ;
                            return pos += 2, token = 56 /* AmpersandAmpersandToken */ ;
                        }
                        if (text.charCodeAt(pos + 1) === 61 /* equals */ ) return pos += 2, token = 74 /* AmpersandEqualsToken */ ;
                        pos++;
                        return token = 51 /* AmpersandToken */ ;
                    case 40 /* openParen */ :
                        pos++;
                        return token = 21 /* OpenParenToken */ ;
                    case 41 /* closeParen */ :
                        pos++;
                        return token = 22 /* CloseParenToken */ ;
                    case 42 /* asterisk */ :
                        if (text.charCodeAt(pos + 1) === 61 /* equals */ ) return pos += 2, token = 67 /* AsteriskEqualsToken */ ;
                        if (text.charCodeAt(pos + 1) === 42 /* asterisk */ ) {
                            if (text.charCodeAt(pos + 2) === 61 /* equals */ ) return pos += 3, token = 68 /* AsteriskAsteriskEqualsToken */ ;
                            return pos += 2, token = 43 /* AsteriskAsteriskToken */ ;
                        }
                        pos++;
                        if (inJSDocType && !asteriskSeen && tokenFlags & 1 /* PrecedingLineBreak */ ) {
                            asteriskSeen = true;
                            continue;
                        }
                        return token = 42 /* AsteriskToken */ ;
                    case 43 /* plus */ :
                        if (text.charCodeAt(pos + 1) === 43 /* plus */ ) return pos += 2, token = 46 /* PlusPlusToken */ ;
                        if (text.charCodeAt(pos + 1) === 61 /* equals */ ) return pos += 2, token = 65 /* PlusEqualsToken */ ;
                        pos++;
                        return token = 40 /* PlusToken */ ;
                    case 44 /* comma */ :
                        pos++;
                        return token = 28 /* CommaToken */ ;
                    case 45 /* minus */ :
                        if (text.charCodeAt(pos + 1) === 45 /* minus */ ) return pos += 2, token = 47 /* MinusMinusToken */ ;
                        if (text.charCodeAt(pos + 1) === 61 /* equals */ ) return pos += 2, token = 66 /* MinusEqualsToken */ ;
                        pos++;
                        return token = 41 /* MinusToken */ ;
                    case 46 /* dot */ :
                        if (isDigit(text.charCodeAt(pos + 1))) {
                            tokenValue = scanNumber().value;
                            return token = 9 /* NumericLiteral */ ;
                        }
                        if (text.charCodeAt(pos + 1) === 46 /* dot */  && text.charCodeAt(pos + 2) === 46 /* dot */ ) return pos += 3, token = 26 /* DotDotDotToken */ ;
                        pos++;
                        return token = 25 /* DotToken */ ;
                    case 47 /* slash */ :
                        if (text.charCodeAt(pos + 1) === 47 /* slash */ ) {
                            pos += 2;
                            while(pos < end){
                                if (isLineBreak(text.charCodeAt(pos))) break;
                                pos++;
                            }
                            commentDirectives = appendIfCommentDirective(commentDirectives, text.slice(tokenStart, pos), commentDirectiveRegExSingleLine, tokenStart);
                            if (skipTrivia2) continue;
                            else return token = 2 /* SingleLineCommentTrivia */ ;
                        }
                        if (text.charCodeAt(pos + 1) === 42 /* asterisk */ ) {
                            pos += 2;
                            if (text.charCodeAt(pos) === 42 /* asterisk */  && text.charCodeAt(pos + 1) !== 47 /* slash */ ) tokenFlags |= 2 /* PrecedingJSDocComment */ ;
                            let commentClosed = false;
                            let lastLineStart = tokenStart;
                            while(pos < end){
                                const ch2 = text.charCodeAt(pos);
                                if (ch2 === 42 /* asterisk */  && text.charCodeAt(pos + 1) === 47 /* slash */ ) {
                                    pos += 2;
                                    commentClosed = true;
                                    break;
                                }
                                pos++;
                                if (isLineBreak(ch2)) {
                                    lastLineStart = pos;
                                    tokenFlags |= 1 /* PrecedingLineBreak */ ;
                                }
                            }
                            commentDirectives = appendIfCommentDirective(commentDirectives, text.slice(lastLineStart, pos), commentDirectiveRegExMultiLine, lastLineStart);
                            if (!commentClosed) error(Diagnostics.Asterisk_Slash_expected);
                            if (skipTrivia2) continue;
                            else {
                                if (!commentClosed) tokenFlags |= 4 /* Unterminated */ ;
                                return token = 3 /* MultiLineCommentTrivia */ ;
                            }
                        }
                        if (text.charCodeAt(pos + 1) === 61 /* equals */ ) return pos += 2, token = 69 /* SlashEqualsToken */ ;
                        pos++;
                        return token = 44 /* SlashToken */ ;
                    case 48 /* _0 */ :
                        if (pos + 2 < end && (text.charCodeAt(pos + 1) === 88 /* X */  || text.charCodeAt(pos + 1) === 120 /* x */ )) {
                            pos += 2;
                            tokenValue = scanMinimumNumberOfHexDigits(1, /*canHaveSeparators*/ true);
                            if (!tokenValue) {
                                error(Diagnostics.Hexadecimal_digit_expected);
                                tokenValue = "0";
                            }
                            tokenValue = "0x" + tokenValue;
                            tokenFlags |= 64 /* HexSpecifier */ ;
                            return token = checkBigIntSuffix();
                        } else if (pos + 2 < end && (text.charCodeAt(pos + 1) === 66 /* B */  || text.charCodeAt(pos + 1) === 98 /* b */ )) {
                            pos += 2;
                            tokenValue = scanBinaryOrOctalDigits(/* base */ 2);
                            if (!tokenValue) {
                                error(Diagnostics.Binary_digit_expected);
                                tokenValue = "0";
                            }
                            tokenValue = "0b" + tokenValue;
                            tokenFlags |= 128 /* BinarySpecifier */ ;
                            return token = checkBigIntSuffix();
                        } else if (pos + 2 < end && (text.charCodeAt(pos + 1) === 79 /* O */  || text.charCodeAt(pos + 1) === 111 /* o */ )) {
                            pos += 2;
                            tokenValue = scanBinaryOrOctalDigits(/* base */ 8);
                            if (!tokenValue) {
                                error(Diagnostics.Octal_digit_expected);
                                tokenValue = "0";
                            }
                            tokenValue = "0o" + tokenValue;
                            tokenFlags |= 256 /* OctalSpecifier */ ;
                            return token = checkBigIntSuffix();
                        }
                    case 49 /* _1 */ :
                    case 50 /* _2 */ :
                    case 51 /* _3 */ :
                    case 52 /* _4 */ :
                    case 53 /* _5 */ :
                    case 54 /* _6 */ :
                    case 55 /* _7 */ :
                    case 56 /* _8 */ :
                    case 57 /* _9 */ :
                        ({ type: token , value: tokenValue  } = scanNumber());
                        return token;
                    case 58 /* colon */ :
                        pos++;
                        return token = 59 /* ColonToken */ ;
                    case 59 /* semicolon */ :
                        pos++;
                        return token = 27 /* SemicolonToken */ ;
                    case 60 /* lessThan */ :
                        if (isConflictMarkerTrivia(text, pos)) {
                            pos = scanConflictMarkerTrivia(text, pos, error);
                            if (skipTrivia2) continue;
                            else return token = 7 /* ConflictMarkerTrivia */ ;
                        }
                        if (text.charCodeAt(pos + 1) === 60 /* lessThan */ ) {
                            if (text.charCodeAt(pos + 2) === 61 /* equals */ ) return pos += 3, token = 71 /* LessThanLessThanEqualsToken */ ;
                            return pos += 2, token = 48 /* LessThanLessThanToken */ ;
                        }
                        if (text.charCodeAt(pos + 1) === 61 /* equals */ ) return pos += 2, token = 33 /* LessThanEqualsToken */ ;
                        if (languageVariant === 1 /* JSX */  && text.charCodeAt(pos + 1) === 47 /* slash */  && text.charCodeAt(pos + 2) !== 42 /* asterisk */ ) return pos += 2, token = 31 /* LessThanSlashToken */ ;
                        pos++;
                        return token = 30 /* LessThanToken */ ;
                    case 61 /* equals */ :
                        if (isConflictMarkerTrivia(text, pos)) {
                            pos = scanConflictMarkerTrivia(text, pos, error);
                            if (skipTrivia2) continue;
                            else return token = 7 /* ConflictMarkerTrivia */ ;
                        }
                        if (text.charCodeAt(pos + 1) === 61 /* equals */ ) {
                            if (text.charCodeAt(pos + 2) === 61 /* equals */ ) return pos += 3, token = 37 /* EqualsEqualsEqualsToken */ ;
                            return pos += 2, token = 35 /* EqualsEqualsToken */ ;
                        }
                        if (text.charCodeAt(pos + 1) === 62 /* greaterThan */ ) return pos += 2, token = 39 /* EqualsGreaterThanToken */ ;
                        pos++;
                        return token = 64 /* EqualsToken */ ;
                    case 62 /* greaterThan */ :
                        if (isConflictMarkerTrivia(text, pos)) {
                            pos = scanConflictMarkerTrivia(text, pos, error);
                            if (skipTrivia2) continue;
                            else return token = 7 /* ConflictMarkerTrivia */ ;
                        }
                        pos++;
                        return token = 32 /* GreaterThanToken */ ;
                    case 63 /* question */ :
                        if (text.charCodeAt(pos + 1) === 46 /* dot */  && !isDigit(text.charCodeAt(pos + 2))) return pos += 2, token = 29 /* QuestionDotToken */ ;
                        if (text.charCodeAt(pos + 1) === 63 /* question */ ) {
                            if (text.charCodeAt(pos + 2) === 61 /* equals */ ) return pos += 3, token = 78 /* QuestionQuestionEqualsToken */ ;
                            return pos += 2, token = 61 /* QuestionQuestionToken */ ;
                        }
                        pos++;
                        return token = 58 /* QuestionToken */ ;
                    case 91 /* openBracket */ :
                        pos++;
                        return token = 23 /* OpenBracketToken */ ;
                    case 93 /* closeBracket */ :
                        pos++;
                        return token = 24 /* CloseBracketToken */ ;
                    case 94 /* caret */ :
                        if (text.charCodeAt(pos + 1) === 61 /* equals */ ) return pos += 2, token = 79 /* CaretEqualsToken */ ;
                        pos++;
                        return token = 53 /* CaretToken */ ;
                    case 123 /* openBrace */ :
                        pos++;
                        return token = 19 /* OpenBraceToken */ ;
                    case 124 /* bar */ :
                        if (isConflictMarkerTrivia(text, pos)) {
                            pos = scanConflictMarkerTrivia(text, pos, error);
                            if (skipTrivia2) continue;
                            else return token = 7 /* ConflictMarkerTrivia */ ;
                        }
                        if (text.charCodeAt(pos + 1) === 124 /* bar */ ) {
                            if (text.charCodeAt(pos + 2) === 61 /* equals */ ) return pos += 3, token = 76 /* BarBarEqualsToken */ ;
                            return pos += 2, token = 57 /* BarBarToken */ ;
                        }
                        if (text.charCodeAt(pos + 1) === 61 /* equals */ ) return pos += 2, token = 75 /* BarEqualsToken */ ;
                        pos++;
                        return token = 52 /* BarToken */ ;
                    case 125 /* closeBrace */ :
                        pos++;
                        return token = 20 /* CloseBraceToken */ ;
                    case 126 /* tilde */ :
                        pos++;
                        return token = 55 /* TildeToken */ ;
                    case 64 /* at */ :
                        pos++;
                        return token = 60 /* AtToken */ ;
                    case 92 /* backslash */ :
                        const extendedCookedChar = peekExtendedUnicodeEscape();
                        if (extendedCookedChar >= 0 && isIdentifierStart(extendedCookedChar, languageVersion)) {
                            pos += 3;
                            tokenFlags |= 8 /* ExtendedUnicodeEscape */ ;
                            tokenValue = scanExtendedUnicodeEscape() + scanIdentifierParts();
                            return token = getIdentifierToken();
                        }
                        const cookedChar = peekUnicodeEscape();
                        if (cookedChar >= 0 && isIdentifierStart(cookedChar, languageVersion)) {
                            pos += 6;
                            tokenFlags |= 1024 /* UnicodeEscape */ ;
                            tokenValue = String.fromCharCode(cookedChar) + scanIdentifierParts();
                            return token = getIdentifierToken();
                        }
                        error(Diagnostics.Invalid_character);
                        pos++;
                        return token = 0 /* Unknown */ ;
                    case 35 /* hash */ :
                        if (pos !== 0 && text[pos + 1] === "!") {
                            error(Diagnostics.can_only_be_used_at_the_start_of_a_file);
                            pos++;
                            return token = 0 /* Unknown */ ;
                        }
                        const charAfterHash = codePointAt(text, pos + 1);
                        if (charAfterHash === 92 /* backslash */ ) {
                            pos++;
                            const extendedCookedChar2 = peekExtendedUnicodeEscape();
                            if (extendedCookedChar2 >= 0 && isIdentifierStart(extendedCookedChar2, languageVersion)) {
                                pos += 3;
                                tokenFlags |= 8 /* ExtendedUnicodeEscape */ ;
                                tokenValue = "#" + scanExtendedUnicodeEscape() + scanIdentifierParts();
                                return token = 81 /* PrivateIdentifier */ ;
                            }
                            const cookedChar2 = peekUnicodeEscape();
                            if (cookedChar2 >= 0 && isIdentifierStart(cookedChar2, languageVersion)) {
                                pos += 6;
                                tokenFlags |= 1024 /* UnicodeEscape */ ;
                                tokenValue = "#" + String.fromCharCode(cookedChar2) + scanIdentifierParts();
                                return token = 81 /* PrivateIdentifier */ ;
                            }
                            pos--;
                        }
                        if (isIdentifierStart(charAfterHash, languageVersion)) {
                            pos++;
                            scanIdentifier(charAfterHash, languageVersion);
                        } else {
                            tokenValue = "#";
                            error(Diagnostics.Invalid_character, pos++, charSize(ch));
                        }
                        return token = 81 /* PrivateIdentifier */ ;
                    default:
                        const identifierKind = scanIdentifier(ch, languageVersion);
                        if (identifierKind) return token = identifierKind;
                        else if (isWhiteSpaceSingleLine(ch)) {
                            pos += charSize(ch);
                            continue;
                        } else if (isLineBreak(ch)) {
                            tokenFlags |= 1 /* PrecedingLineBreak */ ;
                            pos += charSize(ch);
                            continue;
                        }
                        const size = charSize(ch);
                        error(Diagnostics.Invalid_character, pos, size);
                        pos += size;
                        return token = 0 /* Unknown */ ;
                }
            }
        }
        function reScanInvalidIdentifier() {
            Debug.assert(token === 0 /* Unknown */ , "'reScanInvalidIdentifier' should only be called when the current token is 'SyntaxKind.Unknown'.");
            pos = tokenStart = fullStartPos;
            tokenFlags = 0;
            const ch = codePointAt(text, pos);
            const identifierKind = scanIdentifier(ch, 99 /* ESNext */ );
            if (identifierKind) return token = identifierKind;
            pos += charSize(ch);
            return token;
        }
        function scanIdentifier(startCharacter, languageVersion2) {
            let ch = startCharacter;
            if (isIdentifierStart(ch, languageVersion2)) {
                pos += charSize(ch);
                while(pos < end && isIdentifierPart(ch = codePointAt(text, pos), languageVersion2))pos += charSize(ch);
                tokenValue = text.substring(tokenStart, pos);
                if (ch === 92 /* backslash */ ) tokenValue += scanIdentifierParts();
                return getIdentifierToken();
            }
        }
        function reScanGreaterToken() {
            if (token === 32 /* GreaterThanToken */ ) {
                if (text.charCodeAt(pos) === 62 /* greaterThan */ ) {
                    if (text.charCodeAt(pos + 1) === 62 /* greaterThan */ ) {
                        if (text.charCodeAt(pos + 2) === 61 /* equals */ ) return pos += 3, token = 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ ;
                        return pos += 2, token = 50 /* GreaterThanGreaterThanGreaterThanToken */ ;
                    }
                    if (text.charCodeAt(pos + 1) === 61 /* equals */ ) return pos += 2, token = 72 /* GreaterThanGreaterThanEqualsToken */ ;
                    pos++;
                    return token = 49 /* GreaterThanGreaterThanToken */ ;
                }
                if (text.charCodeAt(pos) === 61 /* equals */ ) {
                    pos++;
                    return token = 34 /* GreaterThanEqualsToken */ ;
                }
            }
            return token;
        }
        function reScanAsteriskEqualsToken() {
            Debug.assert(token === 67 /* AsteriskEqualsToken */ , "'reScanAsteriskEqualsToken' should only be called on a '*='");
            pos = tokenStart + 1;
            return token = 64 /* EqualsToken */ ;
        }
        function reScanSlashToken() {
            if (token === 44 /* SlashToken */  || token === 69 /* SlashEqualsToken */ ) {
                let p = tokenStart + 1;
                let inEscape = false;
                let inCharacterClass = false;
                while(true){
                    if (p >= end) {
                        tokenFlags |= 4 /* Unterminated */ ;
                        error(Diagnostics.Unterminated_regular_expression_literal);
                        break;
                    }
                    const ch = text.charCodeAt(p);
                    if (isLineBreak(ch)) {
                        tokenFlags |= 4 /* Unterminated */ ;
                        error(Diagnostics.Unterminated_regular_expression_literal);
                        break;
                    }
                    if (inEscape) inEscape = false;
                    else if (ch === 47 /* slash */  && !inCharacterClass) {
                        p++;
                        break;
                    } else if (ch === 91 /* openBracket */ ) inCharacterClass = true;
                    else if (ch === 92 /* backslash */ ) inEscape = true;
                    else if (ch === 93 /* closeBracket */ ) inCharacterClass = false;
                    p++;
                }
                while(p < end && isIdentifierPart(text.charCodeAt(p), languageVersion))p++;
                pos = p;
                tokenValue = text.substring(tokenStart, pos);
                token = 14 /* RegularExpressionLiteral */ ;
            }
            return token;
        }
        function appendIfCommentDirective(commentDirectives2, text2, commentDirectiveRegEx, lineStart) {
            const type = getDirectiveFromComment(trimStringStart(text2), commentDirectiveRegEx);
            if (type === void 0) return commentDirectives2;
            return append(commentDirectives2, {
                range: {
                    pos: lineStart,
                    end: pos
                },
                type: type
            });
        }
        function getDirectiveFromComment(text2, commentDirectiveRegEx) {
            const match = commentDirectiveRegEx.exec(text2);
            if (!match) return void 0;
            switch(match[1]){
                case "ts-expect-error":
                    return 0 /* ExpectError */ ;
                case "ts-ignore":
                    return 1 /* Ignore */ ;
            }
            return void 0;
        }
        function reScanTemplateToken(isTaggedTemplate) {
            pos = tokenStart;
            return token = scanTemplateAndSetTokenValue(!isTaggedTemplate);
        }
        function reScanTemplateHeadOrNoSubstitutionTemplate() {
            pos = tokenStart;
            return token = scanTemplateAndSetTokenValue(/*shouldEmitInvalidEscapeError*/ true);
        }
        function reScanJsxToken(allowMultilineJsxText = true) {
            pos = tokenStart = fullStartPos;
            return token = scanJsxToken(allowMultilineJsxText);
        }
        function reScanLessThanToken() {
            if (token === 48 /* LessThanLessThanToken */ ) {
                pos = tokenStart + 1;
                return token = 30 /* LessThanToken */ ;
            }
            return token;
        }
        function reScanHashToken() {
            if (token === 81 /* PrivateIdentifier */ ) {
                pos = tokenStart + 1;
                return token = 63 /* HashToken */ ;
            }
            return token;
        }
        function reScanQuestionToken() {
            Debug.assert(token === 61 /* QuestionQuestionToken */ , "'reScanQuestionToken' should only be called on a '??'");
            pos = tokenStart + 1;
            return token = 58 /* QuestionToken */ ;
        }
        function scanJsxToken(allowMultilineJsxText = true) {
            fullStartPos = tokenStart = pos;
            if (pos >= end) return token = 1 /* EndOfFileToken */ ;
            let char = text.charCodeAt(pos);
            if (char === 60 /* lessThan */ ) {
                if (text.charCodeAt(pos + 1) === 47 /* slash */ ) {
                    pos += 2;
                    return token = 31 /* LessThanSlashToken */ ;
                }
                pos++;
                return token = 30 /* LessThanToken */ ;
            }
            if (char === 123 /* openBrace */ ) {
                pos++;
                return token = 19 /* OpenBraceToken */ ;
            }
            let firstNonWhitespace = 0;
            while(pos < end){
                char = text.charCodeAt(pos);
                if (char === 123 /* openBrace */ ) break;
                if (char === 60 /* lessThan */ ) {
                    if (isConflictMarkerTrivia(text, pos)) {
                        pos = scanConflictMarkerTrivia(text, pos, error);
                        return token = 7 /* ConflictMarkerTrivia */ ;
                    }
                    break;
                }
                if (char === 62 /* greaterThan */ ) error(Diagnostics.Unexpected_token_Did_you_mean_or_gt, pos, 1);
                if (char === 125 /* closeBrace */ ) error(Diagnostics.Unexpected_token_Did_you_mean_or_rbrace, pos, 1);
                if (isLineBreak(char) && firstNonWhitespace === 0) firstNonWhitespace = -1;
                else if (!allowMultilineJsxText && isLineBreak(char) && firstNonWhitespace > 0) break;
                else if (!isWhiteSpaceLike(char)) firstNonWhitespace = pos;
                pos++;
            }
            tokenValue = text.substring(fullStartPos, pos);
            return firstNonWhitespace === -1 ? 13 /* JsxTextAllWhiteSpaces */  : 12 /* JsxText */ ;
        }
        function scanJsxIdentifier() {
            if (tokenIsIdentifierOrKeyword(token)) {
                while(pos < end){
                    const ch = text.charCodeAt(pos);
                    if (ch === 45 /* minus */ ) {
                        tokenValue += "-";
                        pos++;
                        continue;
                    }
                    const oldPos = pos;
                    tokenValue += scanIdentifierParts();
                    if (pos === oldPos) break;
                }
                return getIdentifierToken();
            }
            return token;
        }
        function scanJsxAttributeValue() {
            fullStartPos = pos;
            switch(text.charCodeAt(pos)){
                case 34 /* doubleQuote */ :
                case 39 /* singleQuote */ :
                    tokenValue = scanString(/*jsxAttributeString*/ true);
                    return token = 11 /* StringLiteral */ ;
                default:
                    return scan();
            }
        }
        function reScanJsxAttributeValue() {
            pos = tokenStart = fullStartPos;
            return scanJsxAttributeValue();
        }
        function scanJSDocCommentTextToken(inBackticks) {
            fullStartPos = tokenStart = pos;
            tokenFlags = 0 /* None */ ;
            if (pos >= end) return token = 1 /* EndOfFileToken */ ;
            for(let ch = text.charCodeAt(pos); pos < end && !isLineBreak(ch) && ch !== 96 /* backtick */ ; ch = codePointAt(text, ++pos))if (!inBackticks) {
                if (ch === 123 /* openBrace */ ) break;
                else if (ch === 64 /* at */  && pos - 1 >= 0 && isWhiteSpaceSingleLine(text.charCodeAt(pos - 1)) && !(pos + 1 < end && isWhiteSpaceLike(text.charCodeAt(pos + 1)))) break;
            }
            if (pos === tokenStart) return scanJsDocToken();
            tokenValue = text.substring(tokenStart, pos);
            return token = 82 /* JSDocCommentTextToken */ ;
        }
        function scanJsDocToken() {
            fullStartPos = tokenStart = pos;
            tokenFlags = 0 /* None */ ;
            if (pos >= end) return token = 1 /* EndOfFileToken */ ;
            const ch = codePointAt(text, pos);
            pos += charSize(ch);
            switch(ch){
                case 9 /* tab */ :
                case 11 /* verticalTab */ :
                case 12 /* formFeed */ :
                case 32 /* space */ :
                    while(pos < end && isWhiteSpaceSingleLine(text.charCodeAt(pos)))pos++;
                    return token = 5 /* WhitespaceTrivia */ ;
                case 64 /* at */ :
                    return token = 60 /* AtToken */ ;
                case 13 /* carriageReturn */ :
                    if (text.charCodeAt(pos) === 10 /* lineFeed */ ) pos++;
                case 10 /* lineFeed */ :
                    tokenFlags |= 1 /* PrecedingLineBreak */ ;
                    return token = 4 /* NewLineTrivia */ ;
                case 42 /* asterisk */ :
                    return token = 42 /* AsteriskToken */ ;
                case 123 /* openBrace */ :
                    return token = 19 /* OpenBraceToken */ ;
                case 125 /* closeBrace */ :
                    return token = 20 /* CloseBraceToken */ ;
                case 91 /* openBracket */ :
                    return token = 23 /* OpenBracketToken */ ;
                case 93 /* closeBracket */ :
                    return token = 24 /* CloseBracketToken */ ;
                case 60 /* lessThan */ :
                    return token = 30 /* LessThanToken */ ;
                case 62 /* greaterThan */ :
                    return token = 32 /* GreaterThanToken */ ;
                case 61 /* equals */ :
                    return token = 64 /* EqualsToken */ ;
                case 44 /* comma */ :
                    return token = 28 /* CommaToken */ ;
                case 46 /* dot */ :
                    return token = 25 /* DotToken */ ;
                case 96 /* backtick */ :
                    return token = 62 /* BacktickToken */ ;
                case 35 /* hash */ :
                    return token = 63 /* HashToken */ ;
                case 92 /* backslash */ :
                    pos--;
                    const extendedCookedChar = peekExtendedUnicodeEscape();
                    if (extendedCookedChar >= 0 && isIdentifierStart(extendedCookedChar, languageVersion)) {
                        pos += 3;
                        tokenFlags |= 8 /* ExtendedUnicodeEscape */ ;
                        tokenValue = scanExtendedUnicodeEscape() + scanIdentifierParts();
                        return token = getIdentifierToken();
                    }
                    const cookedChar = peekUnicodeEscape();
                    if (cookedChar >= 0 && isIdentifierStart(cookedChar, languageVersion)) {
                        pos += 6;
                        tokenFlags |= 1024 /* UnicodeEscape */ ;
                        tokenValue = String.fromCharCode(cookedChar) + scanIdentifierParts();
                        return token = getIdentifierToken();
                    }
                    pos++;
                    return token = 0 /* Unknown */ ;
            }
            if (isIdentifierStart(ch, languageVersion)) {
                let char = ch;
                while(pos < end && isIdentifierPart(char = codePointAt(text, pos), languageVersion) || text.charCodeAt(pos) === 45 /* minus */ )pos += charSize(char);
                tokenValue = text.substring(tokenStart, pos);
                if (char === 92 /* backslash */ ) tokenValue += scanIdentifierParts();
                return token = getIdentifierToken();
            } else return token = 0 /* Unknown */ ;
        }
        function speculationHelper(callback, isLookahead) {
            const savePos = pos;
            const saveStartPos = fullStartPos;
            const saveTokenPos = tokenStart;
            const saveToken = token;
            const saveTokenValue = tokenValue;
            const saveTokenFlags = tokenFlags;
            const result = callback();
            if (!result || isLookahead) {
                pos = savePos;
                fullStartPos = saveStartPos;
                tokenStart = saveTokenPos;
                token = saveToken;
                tokenValue = saveTokenValue;
                tokenFlags = saveTokenFlags;
            }
            return result;
        }
        function scanRange(start2, length3, callback) {
            const saveEnd = end;
            const savePos = pos;
            const saveStartPos = fullStartPos;
            const saveTokenPos = tokenStart;
            const saveToken = token;
            const saveTokenValue = tokenValue;
            const saveTokenFlags = tokenFlags;
            const saveErrorExpectations = commentDirectives;
            setText(text, start2, length3);
            const result = callback();
            end = saveEnd;
            pos = savePos;
            fullStartPos = saveStartPos;
            tokenStart = saveTokenPos;
            token = saveToken;
            tokenValue = saveTokenValue;
            tokenFlags = saveTokenFlags;
            commentDirectives = saveErrorExpectations;
            return result;
        }
        function lookAhead(callback) {
            return speculationHelper(callback, /*isLookahead*/ true);
        }
        function tryScan(callback) {
            return speculationHelper(callback, /*isLookahead*/ false);
        }
        function getText() {
            return text;
        }
        function clearCommentDirectives() {
            commentDirectives = void 0;
        }
        function setText(newText, start2, length3) {
            text = newText || "";
            end = length3 === void 0 ? text.length : start2 + length3;
            resetTokenState(start2 || 0);
        }
        function setOnError(errorCallback) {
            onError = errorCallback;
        }
        function setScriptTarget(scriptTarget) {
            languageVersion = scriptTarget;
        }
        function setLanguageVariant(variant) {
            languageVariant = variant;
        }
        function resetTokenState(position) {
            Debug.assert(position >= 0);
            pos = position;
            fullStartPos = position;
            tokenStart = position;
            token = 0 /* Unknown */ ;
            tokenValue = void 0;
            tokenFlags = 0 /* None */ ;
        }
        function setInJSDocType(inType) {
            inJSDocType += inType ? 1 : -1;
        }
    }
    function charSize(ch) {
        if (ch >= 65536) return 2;
        return 1;
    }
    function utf16EncodeAsStringFallback(codePoint) {
        Debug.assert(0 <= codePoint && codePoint <= 1114111);
        if (codePoint <= 65535) return String.fromCharCode(codePoint);
        const codeUnit1 = Math.floor((codePoint - 65536) / 1024) + 55296;
        const codeUnit2 = (codePoint - 65536) % 1024 + 56320;
        return String.fromCharCode(codeUnit1, codeUnit2);
    }
    function utf16EncodeAsString(codePoint) {
        return utf16EncodeAsStringWorker(codePoint);
    }
    var textToKeywordObj, textToKeyword, textToToken, unicodeES3IdentifierStart, unicodeES3IdentifierPart, unicodeES5IdentifierStart, unicodeES5IdentifierPart, unicodeESNextIdentifierStart, unicodeESNextIdentifierPart, commentDirectiveRegExSingleLine, commentDirectiveRegExMultiLine, tokenStrings, mergeConflictMarkerLength, shebangTriviaRegex, codePointAt, utf16EncodeAsStringWorker;
    var init_scanner = __esm({
        "src/compiler/scanner.ts" () {
            "use strict";
            init_ts2();
            textToKeywordObj = {
                abstract: 128 /* AbstractKeyword */ ,
                accessor: 129 /* AccessorKeyword */ ,
                any: 133 /* AnyKeyword */ ,
                as: 130 /* AsKeyword */ ,
                asserts: 131 /* AssertsKeyword */ ,
                assert: 132 /* AssertKeyword */ ,
                bigint: 162 /* BigIntKeyword */ ,
                boolean: 136 /* BooleanKeyword */ ,
                break: 83 /* BreakKeyword */ ,
                case: 84 /* CaseKeyword */ ,
                catch: 85 /* CatchKeyword */ ,
                class: 86 /* ClassKeyword */ ,
                continue: 88 /* ContinueKeyword */ ,
                const: 87 /* ConstKeyword */ ,
                ["constructor"]: 137 /* ConstructorKeyword */ ,
                debugger: 89 /* DebuggerKeyword */ ,
                declare: 138 /* DeclareKeyword */ ,
                default: 90 /* DefaultKeyword */ ,
                delete: 91 /* DeleteKeyword */ ,
                do: 92 /* DoKeyword */ ,
                else: 93 /* ElseKeyword */ ,
                enum: 94 /* EnumKeyword */ ,
                export: 95 /* ExportKeyword */ ,
                extends: 96 /* ExtendsKeyword */ ,
                false: 97 /* FalseKeyword */ ,
                finally: 98 /* FinallyKeyword */ ,
                for: 99 /* ForKeyword */ ,
                from: 160 /* FromKeyword */ ,
                function: 100 /* FunctionKeyword */ ,
                get: 139 /* GetKeyword */ ,
                if: 101 /* IfKeyword */ ,
                implements: 119 /* ImplementsKeyword */ ,
                import: 102 /* ImportKeyword */ ,
                in: 103 /* InKeyword */ ,
                infer: 140 /* InferKeyword */ ,
                instanceof: 104 /* InstanceOfKeyword */ ,
                interface: 120 /* InterfaceKeyword */ ,
                intrinsic: 141 /* IntrinsicKeyword */ ,
                is: 142 /* IsKeyword */ ,
                keyof: 143 /* KeyOfKeyword */ ,
                let: 121 /* LetKeyword */ ,
                module: 144 /* ModuleKeyword */ ,
                namespace: 145 /* NamespaceKeyword */ ,
                never: 146 /* NeverKeyword */ ,
                new: 105 /* NewKeyword */ ,
                null: 106 /* NullKeyword */ ,
                number: 150 /* NumberKeyword */ ,
                object: 151 /* ObjectKeyword */ ,
                package: 122 /* PackageKeyword */ ,
                private: 123 /* PrivateKeyword */ ,
                protected: 124 /* ProtectedKeyword */ ,
                public: 125 /* PublicKeyword */ ,
                override: 163 /* OverrideKeyword */ ,
                out: 147 /* OutKeyword */ ,
                readonly: 148 /* ReadonlyKeyword */ ,
                require: 149 /* RequireKeyword */ ,
                global: 161 /* GlobalKeyword */ ,
                return: 107 /* ReturnKeyword */ ,
                satisfies: 152 /* SatisfiesKeyword */ ,
                set: 153 /* SetKeyword */ ,
                static: 126 /* StaticKeyword */ ,
                string: 154 /* StringKeyword */ ,
                super: 108 /* SuperKeyword */ ,
                switch: 109 /* SwitchKeyword */ ,
                symbol: 155 /* SymbolKeyword */ ,
                this: 110 /* ThisKeyword */ ,
                throw: 111 /* ThrowKeyword */ ,
                true: 112 /* TrueKeyword */ ,
                try: 113 /* TryKeyword */ ,
                type: 156 /* TypeKeyword */ ,
                typeof: 114 /* TypeOfKeyword */ ,
                undefined: 157 /* UndefinedKeyword */ ,
                unique: 158 /* UniqueKeyword */ ,
                unknown: 159 /* UnknownKeyword */ ,
                var: 115 /* VarKeyword */ ,
                void: 116 /* VoidKeyword */ ,
                while: 117 /* WhileKeyword */ ,
                with: 118 /* WithKeyword */ ,
                yield: 127 /* YieldKeyword */ ,
                async: 134 /* AsyncKeyword */ ,
                await: 135 /* AwaitKeyword */ ,
                of: 164 /* OfKeyword */ 
            };
            textToKeyword = new Map(Object.entries(textToKeywordObj));
            textToToken = new Map(Object.entries({
                ...textToKeywordObj,
                "{": 19 /* OpenBraceToken */ ,
                "}": 20 /* CloseBraceToken */ ,
                "(": 21 /* OpenParenToken */ ,
                ")": 22 /* CloseParenToken */ ,
                "[": 23 /* OpenBracketToken */ ,
                "]": 24 /* CloseBracketToken */ ,
                ".": 25 /* DotToken */ ,
                "...": 26 /* DotDotDotToken */ ,
                ";": 27 /* SemicolonToken */ ,
                ",": 28 /* CommaToken */ ,
                "<": 30 /* LessThanToken */ ,
                ">": 32 /* GreaterThanToken */ ,
                "<=": 33 /* LessThanEqualsToken */ ,
                ">=": 34 /* GreaterThanEqualsToken */ ,
                "==": 35 /* EqualsEqualsToken */ ,
                "!=": 36 /* ExclamationEqualsToken */ ,
                "===": 37 /* EqualsEqualsEqualsToken */ ,
                "!==": 38 /* ExclamationEqualsEqualsToken */ ,
                "=>": 39 /* EqualsGreaterThanToken */ ,
                "+": 40 /* PlusToken */ ,
                "-": 41 /* MinusToken */ ,
                "**": 43 /* AsteriskAsteriskToken */ ,
                "*": 42 /* AsteriskToken */ ,
                "/": 44 /* SlashToken */ ,
                "%": 45 /* PercentToken */ ,
                "++": 46 /* PlusPlusToken */ ,
                "--": 47 /* MinusMinusToken */ ,
                "<<": 48 /* LessThanLessThanToken */ ,
                "</": 31 /* LessThanSlashToken */ ,
                ">>": 49 /* GreaterThanGreaterThanToken */ ,
                ">>>": 50 /* GreaterThanGreaterThanGreaterThanToken */ ,
                "&": 51 /* AmpersandToken */ ,
                "|": 52 /* BarToken */ ,
                "^": 53 /* CaretToken */ ,
                "!": 54 /* ExclamationToken */ ,
                "~": 55 /* TildeToken */ ,
                "&&": 56 /* AmpersandAmpersandToken */ ,
                "||": 57 /* BarBarToken */ ,
                "?": 58 /* QuestionToken */ ,
                "??": 61 /* QuestionQuestionToken */ ,
                "?.": 29 /* QuestionDotToken */ ,
                ":": 59 /* ColonToken */ ,
                "=": 64 /* EqualsToken */ ,
                "+=": 65 /* PlusEqualsToken */ ,
                "-=": 66 /* MinusEqualsToken */ ,
                "*=": 67 /* AsteriskEqualsToken */ ,
                "**=": 68 /* AsteriskAsteriskEqualsToken */ ,
                "/=": 69 /* SlashEqualsToken */ ,
                "%=": 70 /* PercentEqualsToken */ ,
                "<<=": 71 /* LessThanLessThanEqualsToken */ ,
                ">>=": 72 /* GreaterThanGreaterThanEqualsToken */ ,
                ">>>=": 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ ,
                "&=": 74 /* AmpersandEqualsToken */ ,
                "|=": 75 /* BarEqualsToken */ ,
                "^=": 79 /* CaretEqualsToken */ ,
                "||=": 76 /* BarBarEqualsToken */ ,
                "&&=": 77 /* AmpersandAmpersandEqualsToken */ ,
                "??=": 78 /* QuestionQuestionEqualsToken */ ,
                "@": 60 /* AtToken */ ,
                "#": 63 /* HashToken */ ,
                "`": 62 /* BacktickToken */ 
            }));
            unicodeES3IdentifierStart = [
                170,
                170,
                181,
                181,
                186,
                186,
                192,
                214,
                216,
                246,
                248,
                543,
                546,
                563,
                592,
                685,
                688,
                696,
                699,
                705,
                720,
                721,
                736,
                740,
                750,
                750,
                890,
                890,
                902,
                902,
                904,
                906,
                908,
                908,
                910,
                929,
                931,
                974,
                976,
                983,
                986,
                1011,
                1024,
                1153,
                1164,
                1220,
                1223,
                1224,
                1227,
                1228,
                1232,
                1269,
                1272,
                1273,
                1329,
                1366,
                1369,
                1369,
                1377,
                1415,
                1488,
                1514,
                1520,
                1522,
                1569,
                1594,
                1600,
                1610,
                1649,
                1747,
                1749,
                1749,
                1765,
                1766,
                1786,
                1788,
                1808,
                1808,
                1810,
                1836,
                1920,
                1957,
                2309,
                2361,
                2365,
                2365,
                2384,
                2384,
                2392,
                2401,
                2437,
                2444,
                2447,
                2448,
                2451,
                2472,
                2474,
                2480,
                2482,
                2482,
                2486,
                2489,
                2524,
                2525,
                2527,
                2529,
                2544,
                2545,
                2565,
                2570,
                2575,
                2576,
                2579,
                2600,
                2602,
                2608,
                2610,
                2611,
                2613,
                2614,
                2616,
                2617,
                2649,
                2652,
                2654,
                2654,
                2674,
                2676,
                2693,
                2699,
                2701,
                2701,
                2703,
                2705,
                2707,
                2728,
                2730,
                2736,
                2738,
                2739,
                2741,
                2745,
                2749,
                2749,
                2768,
                2768,
                2784,
                2784,
                2821,
                2828,
                2831,
                2832,
                2835,
                2856,
                2858,
                2864,
                2866,
                2867,
                2870,
                2873,
                2877,
                2877,
                2908,
                2909,
                2911,
                2913,
                2949,
                2954,
                2958,
                2960,
                2962,
                2965,
                2969,
                2970,
                2972,
                2972,
                2974,
                2975,
                2979,
                2980,
                2984,
                2986,
                2990,
                2997,
                2999,
                3001,
                3077,
                3084,
                3086,
                3088,
                3090,
                3112,
                3114,
                3123,
                3125,
                3129,
                3168,
                3169,
                3205,
                3212,
                3214,
                3216,
                3218,
                3240,
                3242,
                3251,
                3253,
                3257,
                3294,
                3294,
                3296,
                3297,
                3333,
                3340,
                3342,
                3344,
                3346,
                3368,
                3370,
                3385,
                3424,
                3425,
                3461,
                3478,
                3482,
                3505,
                3507,
                3515,
                3517,
                3517,
                3520,
                3526,
                3585,
                3632,
                3634,
                3635,
                3648,
                3654,
                3713,
                3714,
                3716,
                3716,
                3719,
                3720,
                3722,
                3722,
                3725,
                3725,
                3732,
                3735,
                3737,
                3743,
                3745,
                3747,
                3749,
                3749,
                3751,
                3751,
                3754,
                3755,
                3757,
                3760,
                3762,
                3763,
                3773,
                3773,
                3776,
                3780,
                3782,
                3782,
                3804,
                3805,
                3840,
                3840,
                3904,
                3911,
                3913,
                3946,
                3976,
                3979,
                4096,
                4129,
                4131,
                4135,
                4137,
                4138,
                4176,
                4181,
                4256,
                4293,
                4304,
                4342,
                4352,
                4441,
                4447,
                4514,
                4520,
                4601,
                4608,
                4614,
                4616,
                4678,
                4680,
                4680,
                4682,
                4685,
                4688,
                4694,
                4696,
                4696,
                4698,
                4701,
                4704,
                4742,
                4744,
                4744,
                4746,
                4749,
                4752,
                4782,
                4784,
                4784,
                4786,
                4789,
                4792,
                4798,
                4800,
                4800,
                4802,
                4805,
                4808,
                4814,
                4816,
                4822,
                4824,
                4846,
                4848,
                4878,
                4880,
                4880,
                4882,
                4885,
                4888,
                4894,
                4896,
                4934,
                4936,
                4954,
                5024,
                5108,
                5121,
                5740,
                5743,
                5750,
                5761,
                5786,
                5792,
                5866,
                6016,
                6067,
                6176,
                6263,
                6272,
                6312,
                7680,
                7835,
                7840,
                7929,
                7936,
                7957,
                7960,
                7965,
                7968,
                8005,
                8008,
                8013,
                8016,
                8023,
                8025,
                8025,
                8027,
                8027,
                8029,
                8029,
                8031,
                8061,
                8064,
                8116,
                8118,
                8124,
                8126,
                8126,
                8130,
                8132,
                8134,
                8140,
                8144,
                8147,
                8150,
                8155,
                8160,
                8172,
                8178,
                8180,
                8182,
                8188,
                8319,
                8319,
                8450,
                8450,
                8455,
                8455,
                8458,
                8467,
                8469,
                8469,
                8473,
                8477,
                8484,
                8484,
                8486,
                8486,
                8488,
                8488,
                8490,
                8493,
                8495,
                8497,
                8499,
                8505,
                8544,
                8579,
                12293,
                12295,
                12321,
                12329,
                12337,
                12341,
                12344,
                12346,
                12353,
                12436,
                12445,
                12446,
                12449,
                12538,
                12540,
                12542,
                12549,
                12588,
                12593,
                12686,
                12704,
                12727,
                13312,
                19893,
                19968,
                40869,
                40960,
                42124,
                44032,
                55203,
                63744,
                64045,
                64256,
                64262,
                64275,
                64279,
                64285,
                64285,
                64287,
                64296,
                64298,
                64310,
                64312,
                64316,
                64318,
                64318,
                64320,
                64321,
                64323,
                64324,
                64326,
                64433,
                64467,
                64829,
                64848,
                64911,
                64914,
                64967,
                65008,
                65019,
                65136,
                65138,
                65140,
                65140,
                65142,
                65276,
                65313,
                65338,
                65345,
                65370,
                65382,
                65470,
                65474,
                65479,
                65482,
                65487,
                65490,
                65495,
                65498,
                65500
            ];
            unicodeES3IdentifierPart = [
                170,
                170,
                181,
                181,
                186,
                186,
                192,
                214,
                216,
                246,
                248,
                543,
                546,
                563,
                592,
                685,
                688,
                696,
                699,
                705,
                720,
                721,
                736,
                740,
                750,
                750,
                768,
                846,
                864,
                866,
                890,
                890,
                902,
                902,
                904,
                906,
                908,
                908,
                910,
                929,
                931,
                974,
                976,
                983,
                986,
                1011,
                1024,
                1153,
                1155,
                1158,
                1164,
                1220,
                1223,
                1224,
                1227,
                1228,
                1232,
                1269,
                1272,
                1273,
                1329,
                1366,
                1369,
                1369,
                1377,
                1415,
                1425,
                1441,
                1443,
                1465,
                1467,
                1469,
                1471,
                1471,
                1473,
                1474,
                1476,
                1476,
                1488,
                1514,
                1520,
                1522,
                1569,
                1594,
                1600,
                1621,
                1632,
                1641,
                1648,
                1747,
                1749,
                1756,
                1759,
                1768,
                1770,
                1773,
                1776,
                1788,
                1808,
                1836,
                1840,
                1866,
                1920,
                1968,
                2305,
                2307,
                2309,
                2361,
                2364,
                2381,
                2384,
                2388,
                2392,
                2403,
                2406,
                2415,
                2433,
                2435,
                2437,
                2444,
                2447,
                2448,
                2451,
                2472,
                2474,
                2480,
                2482,
                2482,
                2486,
                2489,
                2492,
                2492,
                2494,
                2500,
                2503,
                2504,
                2507,
                2509,
                2519,
                2519,
                2524,
                2525,
                2527,
                2531,
                2534,
                2545,
                2562,
                2562,
                2565,
                2570,
                2575,
                2576,
                2579,
                2600,
                2602,
                2608,
                2610,
                2611,
                2613,
                2614,
                2616,
                2617,
                2620,
                2620,
                2622,
                2626,
                2631,
                2632,
                2635,
                2637,
                2649,
                2652,
                2654,
                2654,
                2662,
                2676,
                2689,
                2691,
                2693,
                2699,
                2701,
                2701,
                2703,
                2705,
                2707,
                2728,
                2730,
                2736,
                2738,
                2739,
                2741,
                2745,
                2748,
                2757,
                2759,
                2761,
                2763,
                2765,
                2768,
                2768,
                2784,
                2784,
                2790,
                2799,
                2817,
                2819,
                2821,
                2828,
                2831,
                2832,
                2835,
                2856,
                2858,
                2864,
                2866,
                2867,
                2870,
                2873,
                2876,
                2883,
                2887,
                2888,
                2891,
                2893,
                2902,
                2903,
                2908,
                2909,
                2911,
                2913,
                2918,
                2927,
                2946,
                2947,
                2949,
                2954,
                2958,
                2960,
                2962,
                2965,
                2969,
                2970,
                2972,
                2972,
                2974,
                2975,
                2979,
                2980,
                2984,
                2986,
                2990,
                2997,
                2999,
                3001,
                3006,
                3010,
                3014,
                3016,
                3018,
                3021,
                3031,
                3031,
                3047,
                3055,
                3073,
                3075,
                3077,
                3084,
                3086,
                3088,
                3090,
                3112,
                3114,
                3123,
                3125,
                3129,
                3134,
                3140,
                3142,
                3144,
                3146,
                3149,
                3157,
                3158,
                3168,
                3169,
                3174,
                3183,
                3202,
                3203,
                3205,
                3212,
                3214,
                3216,
                3218,
                3240,
                3242,
                3251,
                3253,
                3257,
                3262,
                3268,
                3270,
                3272,
                3274,
                3277,
                3285,
                3286,
                3294,
                3294,
                3296,
                3297,
                3302,
                3311,
                3330,
                3331,
                3333,
                3340,
                3342,
                3344,
                3346,
                3368,
                3370,
                3385,
                3390,
                3395,
                3398,
                3400,
                3402,
                3405,
                3415,
                3415,
                3424,
                3425,
                3430,
                3439,
                3458,
                3459,
                3461,
                3478,
                3482,
                3505,
                3507,
                3515,
                3517,
                3517,
                3520,
                3526,
                3530,
                3530,
                3535,
                3540,
                3542,
                3542,
                3544,
                3551,
                3570,
                3571,
                3585,
                3642,
                3648,
                3662,
                3664,
                3673,
                3713,
                3714,
                3716,
                3716,
                3719,
                3720,
                3722,
                3722,
                3725,
                3725,
                3732,
                3735,
                3737,
                3743,
                3745,
                3747,
                3749,
                3749,
                3751,
                3751,
                3754,
                3755,
                3757,
                3769,
                3771,
                3773,
                3776,
                3780,
                3782,
                3782,
                3784,
                3789,
                3792,
                3801,
                3804,
                3805,
                3840,
                3840,
                3864,
                3865,
                3872,
                3881,
                3893,
                3893,
                3895,
                3895,
                3897,
                3897,
                3902,
                3911,
                3913,
                3946,
                3953,
                3972,
                3974,
                3979,
                3984,
                3991,
                3993,
                4028,
                4038,
                4038,
                4096,
                4129,
                4131,
                4135,
                4137,
                4138,
                4140,
                4146,
                4150,
                4153,
                4160,
                4169,
                4176,
                4185,
                4256,
                4293,
                4304,
                4342,
                4352,
                4441,
                4447,
                4514,
                4520,
                4601,
                4608,
                4614,
                4616,
                4678,
                4680,
                4680,
                4682,
                4685,
                4688,
                4694,
                4696,
                4696,
                4698,
                4701,
                4704,
                4742,
                4744,
                4744,
                4746,
                4749,
                4752,
                4782,
                4784,
                4784,
                4786,
                4789,
                4792,
                4798,
                4800,
                4800,
                4802,
                4805,
                4808,
                4814,
                4816,
                4822,
                4824,
                4846,
                4848,
                4878,
                4880,
                4880,
                4882,
                4885,
                4888,
                4894,
                4896,
                4934,
                4936,
                4954,
                4969,
                4977,
                5024,
                5108,
                5121,
                5740,
                5743,
                5750,
                5761,
                5786,
                5792,
                5866,
                6016,
                6099,
                6112,
                6121,
                6160,
                6169,
                6176,
                6263,
                6272,
                6313,
                7680,
                7835,
                7840,
                7929,
                7936,
                7957,
                7960,
                7965,
                7968,
                8005,
                8008,
                8013,
                8016,
                8023,
                8025,
                8025,
                8027,
                8027,
                8029,
                8029,
                8031,
                8061,
                8064,
                8116,
                8118,
                8124,
                8126,
                8126,
                8130,
                8132,
                8134,
                8140,
                8144,
                8147,
                8150,
                8155,
                8160,
                8172,
                8178,
                8180,
                8182,
                8188,
                8255,
                8256,
                8319,
                8319,
                8400,
                8412,
                8417,
                8417,
                8450,
                8450,
                8455,
                8455,
                8458,
                8467,
                8469,
                8469,
                8473,
                8477,
                8484,
                8484,
                8486,
                8486,
                8488,
                8488,
                8490,
                8493,
                8495,
                8497,
                8499,
                8505,
                8544,
                8579,
                12293,
                12295,
                12321,
                12335,
                12337,
                12341,
                12344,
                12346,
                12353,
                12436,
                12441,
                12442,
                12445,
                12446,
                12449,
                12542,
                12549,
                12588,
                12593,
                12686,
                12704,
                12727,
                13312,
                19893,
                19968,
                40869,
                40960,
                42124,
                44032,
                55203,
                63744,
                64045,
                64256,
                64262,
                64275,
                64279,
                64285,
                64296,
                64298,
                64310,
                64312,
                64316,
                64318,
                64318,
                64320,
                64321,
                64323,
                64324,
                64326,
                64433,
                64467,
                64829,
                64848,
                64911,
                64914,
                64967,
                65008,
                65019,
                65056,
                65059,
                65075,
                65076,
                65101,
                65103,
                65136,
                65138,
                65140,
                65140,
                65142,
                65276,
                65296,
                65305,
                65313,
                65338,
                65343,
                65343,
                65345,
                65370,
                65381,
                65470,
                65474,
                65479,
                65482,
                65487,
                65490,
                65495,
                65498,
                65500
            ];
            unicodeES5IdentifierStart = [
                170,
                170,
                181,
                181,
                186,
                186,
                192,
                214,
                216,
                246,
                248,
                705,
                710,
                721,
                736,
                740,
                748,
                748,
                750,
                750,
                880,
                884,
                886,
                887,
                890,
                893,
                902,
                902,
                904,
                906,
                908,
                908,
                910,
                929,
                931,
                1013,
                1015,
                1153,
                1162,
                1319,
                1329,
                1366,
                1369,
                1369,
                1377,
                1415,
                1488,
                1514,
                1520,
                1522,
                1568,
                1610,
                1646,
                1647,
                1649,
                1747,
                1749,
                1749,
                1765,
                1766,
                1774,
                1775,
                1786,
                1788,
                1791,
                1791,
                1808,
                1808,
                1810,
                1839,
                1869,
                1957,
                1969,
                1969,
                1994,
                2026,
                2036,
                2037,
                2042,
                2042,
                2048,
                2069,
                2074,
                2074,
                2084,
                2084,
                2088,
                2088,
                2112,
                2136,
                2208,
                2208,
                2210,
                2220,
                2308,
                2361,
                2365,
                2365,
                2384,
                2384,
                2392,
                2401,
                2417,
                2423,
                2425,
                2431,
                2437,
                2444,
                2447,
                2448,
                2451,
                2472,
                2474,
                2480,
                2482,
                2482,
                2486,
                2489,
                2493,
                2493,
                2510,
                2510,
                2524,
                2525,
                2527,
                2529,
                2544,
                2545,
                2565,
                2570,
                2575,
                2576,
                2579,
                2600,
                2602,
                2608,
                2610,
                2611,
                2613,
                2614,
                2616,
                2617,
                2649,
                2652,
                2654,
                2654,
                2674,
                2676,
                2693,
                2701,
                2703,
                2705,
                2707,
                2728,
                2730,
                2736,
                2738,
                2739,
                2741,
                2745,
                2749,
                2749,
                2768,
                2768,
                2784,
                2785,
                2821,
                2828,
                2831,
                2832,
                2835,
                2856,
                2858,
                2864,
                2866,
                2867,
                2869,
                2873,
                2877,
                2877,
                2908,
                2909,
                2911,
                2913,
                2929,
                2929,
                2947,
                2947,
                2949,
                2954,
                2958,
                2960,
                2962,
                2965,
                2969,
                2970,
                2972,
                2972,
                2974,
                2975,
                2979,
                2980,
                2984,
                2986,
                2990,
                3001,
                3024,
                3024,
                3077,
                3084,
                3086,
                3088,
                3090,
                3112,
                3114,
                3123,
                3125,
                3129,
                3133,
                3133,
                3160,
                3161,
                3168,
                3169,
                3205,
                3212,
                3214,
                3216,
                3218,
                3240,
                3242,
                3251,
                3253,
                3257,
                3261,
                3261,
                3294,
                3294,
                3296,
                3297,
                3313,
                3314,
                3333,
                3340,
                3342,
                3344,
                3346,
                3386,
                3389,
                3389,
                3406,
                3406,
                3424,
                3425,
                3450,
                3455,
                3461,
                3478,
                3482,
                3505,
                3507,
                3515,
                3517,
                3517,
                3520,
                3526,
                3585,
                3632,
                3634,
                3635,
                3648,
                3654,
                3713,
                3714,
                3716,
                3716,
                3719,
                3720,
                3722,
                3722,
                3725,
                3725,
                3732,
                3735,
                3737,
                3743,
                3745,
                3747,
                3749,
                3749,
                3751,
                3751,
                3754,
                3755,
                3757,
                3760,
                3762,
                3763,
                3773,
                3773,
                3776,
                3780,
                3782,
                3782,
                3804,
                3807,
                3840,
                3840,
                3904,
                3911,
                3913,
                3948,
                3976,
                3980,
                4096,
                4138,
                4159,
                4159,
                4176,
                4181,
                4186,
                4189,
                4193,
                4193,
                4197,
                4198,
                4206,
                4208,
                4213,
                4225,
                4238,
                4238,
                4256,
                4293,
                4295,
                4295,
                4301,
                4301,
                4304,
                4346,
                4348,
                4680,
                4682,
                4685,
                4688,
                4694,
                4696,
                4696,
                4698,
                4701,
                4704,
                4744,
                4746,
                4749,
                4752,
                4784,
                4786,
                4789,
                4792,
                4798,
                4800,
                4800,
                4802,
                4805,
                4808,
                4822,
                4824,
                4880,
                4882,
                4885,
                4888,
                4954,
                4992,
                5007,
                5024,
                5108,
                5121,
                5740,
                5743,
                5759,
                5761,
                5786,
                5792,
                5866,
                5870,
                5872,
                5888,
                5900,
                5902,
                5905,
                5920,
                5937,
                5952,
                5969,
                5984,
                5996,
                5998,
                6e3,
                6016,
                6067,
                6103,
                6103,
                6108,
                6108,
                6176,
                6263,
                6272,
                6312,
                6314,
                6314,
                6320,
                6389,
                6400,
                6428,
                6480,
                6509,
                6512,
                6516,
                6528,
                6571,
                6593,
                6599,
                6656,
                6678,
                6688,
                6740,
                6823,
                6823,
                6917,
                6963,
                6981,
                6987,
                7043,
                7072,
                7086,
                7087,
                7098,
                7141,
                7168,
                7203,
                7245,
                7247,
                7258,
                7293,
                7401,
                7404,
                7406,
                7409,
                7413,
                7414,
                7424,
                7615,
                7680,
                7957,
                7960,
                7965,
                7968,
                8005,
                8008,
                8013,
                8016,
                8023,
                8025,
                8025,
                8027,
                8027,
                8029,
                8029,
                8031,
                8061,
                8064,
                8116,
                8118,
                8124,
                8126,
                8126,
                8130,
                8132,
                8134,
                8140,
                8144,
                8147,
                8150,
                8155,
                8160,
                8172,
                8178,
                8180,
                8182,
                8188,
                8305,
                8305,
                8319,
                8319,
                8336,
                8348,
                8450,
                8450,
                8455,
                8455,
                8458,
                8467,
                8469,
                8469,
                8473,
                8477,
                8484,
                8484,
                8486,
                8486,
                8488,
                8488,
                8490,
                8493,
                8495,
                8505,
                8508,
                8511,
                8517,
                8521,
                8526,
                8526,
                8544,
                8584,
                11264,
                11310,
                11312,
                11358,
                11360,
                11492,
                11499,
                11502,
                11506,
                11507,
                11520,
                11557,
                11559,
                11559,
                11565,
                11565,
                11568,
                11623,
                11631,
                11631,
                11648,
                11670,
                11680,
                11686,
                11688,
                11694,
                11696,
                11702,
                11704,
                11710,
                11712,
                11718,
                11720,
                11726,
                11728,
                11734,
                11736,
                11742,
                11823,
                11823,
                12293,
                12295,
                12321,
                12329,
                12337,
                12341,
                12344,
                12348,
                12353,
                12438,
                12445,
                12447,
                12449,
                12538,
                12540,
                12543,
                12549,
                12589,
                12593,
                12686,
                12704,
                12730,
                12784,
                12799,
                13312,
                19893,
                19968,
                40908,
                40960,
                42124,
                42192,
                42237,
                42240,
                42508,
                42512,
                42527,
                42538,
                42539,
                42560,
                42606,
                42623,
                42647,
                42656,
                42735,
                42775,
                42783,
                42786,
                42888,
                42891,
                42894,
                42896,
                42899,
                42912,
                42922,
                43e3,
                43009,
                43011,
                43013,
                43015,
                43018,
                43020,
                43042,
                43072,
                43123,
                43138,
                43187,
                43250,
                43255,
                43259,
                43259,
                43274,
                43301,
                43312,
                43334,
                43360,
                43388,
                43396,
                43442,
                43471,
                43471,
                43520,
                43560,
                43584,
                43586,
                43588,
                43595,
                43616,
                43638,
                43642,
                43642,
                43648,
                43695,
                43697,
                43697,
                43701,
                43702,
                43705,
                43709,
                43712,
                43712,
                43714,
                43714,
                43739,
                43741,
                43744,
                43754,
                43762,
                43764,
                43777,
                43782,
                43785,
                43790,
                43793,
                43798,
                43808,
                43814,
                43816,
                43822,
                43968,
                44002,
                44032,
                55203,
                55216,
                55238,
                55243,
                55291,
                63744,
                64109,
                64112,
                64217,
                64256,
                64262,
                64275,
                64279,
                64285,
                64285,
                64287,
                64296,
                64298,
                64310,
                64312,
                64316,
                64318,
                64318,
                64320,
                64321,
                64323,
                64324,
                64326,
                64433,
                64467,
                64829,
                64848,
                64911,
                64914,
                64967,
                65008,
                65019,
                65136,
                65140,
                65142,
                65276,
                65313,
                65338,
                65345,
                65370,
                65382,
                65470,
                65474,
                65479,
                65482,
                65487,
                65490,
                65495,
                65498,
                65500
            ];
            unicodeES5IdentifierPart = [
                170,
                170,
                181,
                181,
                186,
                186,
                192,
                214,
                216,
                246,
                248,
                705,
                710,
                721,
                736,
                740,
                748,
                748,
                750,
                750,
                768,
                884,
                886,
                887,
                890,
                893,
                902,
                902,
                904,
                906,
                908,
                908,
                910,
                929,
                931,
                1013,
                1015,
                1153,
                1155,
                1159,
                1162,
                1319,
                1329,
                1366,
                1369,
                1369,
                1377,
                1415,
                1425,
                1469,
                1471,
                1471,
                1473,
                1474,
                1476,
                1477,
                1479,
                1479,
                1488,
                1514,
                1520,
                1522,
                1552,
                1562,
                1568,
                1641,
                1646,
                1747,
                1749,
                1756,
                1759,
                1768,
                1770,
                1788,
                1791,
                1791,
                1808,
                1866,
                1869,
                1969,
                1984,
                2037,
                2042,
                2042,
                2048,
                2093,
                2112,
                2139,
                2208,
                2208,
                2210,
                2220,
                2276,
                2302,
                2304,
                2403,
                2406,
                2415,
                2417,
                2423,
                2425,
                2431,
                2433,
                2435,
                2437,
                2444,
                2447,
                2448,
                2451,
                2472,
                2474,
                2480,
                2482,
                2482,
                2486,
                2489,
                2492,
                2500,
                2503,
                2504,
                2507,
                2510,
                2519,
                2519,
                2524,
                2525,
                2527,
                2531,
                2534,
                2545,
                2561,
                2563,
                2565,
                2570,
                2575,
                2576,
                2579,
                2600,
                2602,
                2608,
                2610,
                2611,
                2613,
                2614,
                2616,
                2617,
                2620,
                2620,
                2622,
                2626,
                2631,
                2632,
                2635,
                2637,
                2641,
                2641,
                2649,
                2652,
                2654,
                2654,
                2662,
                2677,
                2689,
                2691,
                2693,
                2701,
                2703,
                2705,
                2707,
                2728,
                2730,
                2736,
                2738,
                2739,
                2741,
                2745,
                2748,
                2757,
                2759,
                2761,
                2763,
                2765,
                2768,
                2768,
                2784,
                2787,
                2790,
                2799,
                2817,
                2819,
                2821,
                2828,
                2831,
                2832,
                2835,
                2856,
                2858,
                2864,
                2866,
                2867,
                2869,
                2873,
                2876,
                2884,
                2887,
                2888,
                2891,
                2893,
                2902,
                2903,
                2908,
                2909,
                2911,
                2915,
                2918,
                2927,
                2929,
                2929,
                2946,
                2947,
                2949,
                2954,
                2958,
                2960,
                2962,
                2965,
                2969,
                2970,
                2972,
                2972,
                2974,
                2975,
                2979,
                2980,
                2984,
                2986,
                2990,
                3001,
                3006,
                3010,
                3014,
                3016,
                3018,
                3021,
                3024,
                3024,
                3031,
                3031,
                3046,
                3055,
                3073,
                3075,
                3077,
                3084,
                3086,
                3088,
                3090,
                3112,
                3114,
                3123,
                3125,
                3129,
                3133,
                3140,
                3142,
                3144,
                3146,
                3149,
                3157,
                3158,
                3160,
                3161,
                3168,
                3171,
                3174,
                3183,
                3202,
                3203,
                3205,
                3212,
                3214,
                3216,
                3218,
                3240,
                3242,
                3251,
                3253,
                3257,
                3260,
                3268,
                3270,
                3272,
                3274,
                3277,
                3285,
                3286,
                3294,
                3294,
                3296,
                3299,
                3302,
                3311,
                3313,
                3314,
                3330,
                3331,
                3333,
                3340,
                3342,
                3344,
                3346,
                3386,
                3389,
                3396,
                3398,
                3400,
                3402,
                3406,
                3415,
                3415,
                3424,
                3427,
                3430,
                3439,
                3450,
                3455,
                3458,
                3459,
                3461,
                3478,
                3482,
                3505,
                3507,
                3515,
                3517,
                3517,
                3520,
                3526,
                3530,
                3530,
                3535,
                3540,
                3542,
                3542,
                3544,
                3551,
                3570,
                3571,
                3585,
                3642,
                3648,
                3662,
                3664,
                3673,
                3713,
                3714,
                3716,
                3716,
                3719,
                3720,
                3722,
                3722,
                3725,
                3725,
                3732,
                3735,
                3737,
                3743,
                3745,
                3747,
                3749,
                3749,
                3751,
                3751,
                3754,
                3755,
                3757,
                3769,
                3771,
                3773,
                3776,
                3780,
                3782,
                3782,
                3784,
                3789,
                3792,
                3801,
                3804,
                3807,
                3840,
                3840,
                3864,
                3865,
                3872,
                3881,
                3893,
                3893,
                3895,
                3895,
                3897,
                3897,
                3902,
                3911,
                3913,
                3948,
                3953,
                3972,
                3974,
                3991,
                3993,
                4028,
                4038,
                4038,
                4096,
                4169,
                4176,
                4253,
                4256,
                4293,
                4295,
                4295,
                4301,
                4301,
                4304,
                4346,
                4348,
                4680,
                4682,
                4685,
                4688,
                4694,
                4696,
                4696,
                4698,
                4701,
                4704,
                4744,
                4746,
                4749,
                4752,
                4784,
                4786,
                4789,
                4792,
                4798,
                4800,
                4800,
                4802,
                4805,
                4808,
                4822,
                4824,
                4880,
                4882,
                4885,
                4888,
                4954,
                4957,
                4959,
                4992,
                5007,
                5024,
                5108,
                5121,
                5740,
                5743,
                5759,
                5761,
                5786,
                5792,
                5866,
                5870,
                5872,
                5888,
                5900,
                5902,
                5908,
                5920,
                5940,
                5952,
                5971,
                5984,
                5996,
                5998,
                6e3,
                6002,
                6003,
                6016,
                6099,
                6103,
                6103,
                6108,
                6109,
                6112,
                6121,
                6155,
                6157,
                6160,
                6169,
                6176,
                6263,
                6272,
                6314,
                6320,
                6389,
                6400,
                6428,
                6432,
                6443,
                6448,
                6459,
                6470,
                6509,
                6512,
                6516,
                6528,
                6571,
                6576,
                6601,
                6608,
                6617,
                6656,
                6683,
                6688,
                6750,
                6752,
                6780,
                6783,
                6793,
                6800,
                6809,
                6823,
                6823,
                6912,
                6987,
                6992,
                7001,
                7019,
                7027,
                7040,
                7155,
                7168,
                7223,
                7232,
                7241,
                7245,
                7293,
                7376,
                7378,
                7380,
                7414,
                7424,
                7654,
                7676,
                7957,
                7960,
                7965,
                7968,
                8005,
                8008,
                8013,
                8016,
                8023,
                8025,
                8025,
                8027,
                8027,
                8029,
                8029,
                8031,
                8061,
                8064,
                8116,
                8118,
                8124,
                8126,
                8126,
                8130,
                8132,
                8134,
                8140,
                8144,
                8147,
                8150,
                8155,
                8160,
                8172,
                8178,
                8180,
                8182,
                8188,
                8204,
                8205,
                8255,
                8256,
                8276,
                8276,
                8305,
                8305,
                8319,
                8319,
                8336,
                8348,
                8400,
                8412,
                8417,
                8417,
                8421,
                8432,
                8450,
                8450,
                8455,
                8455,
                8458,
                8467,
                8469,
                8469,
                8473,
                8477,
                8484,
                8484,
                8486,
                8486,
                8488,
                8488,
                8490,
                8493,
                8495,
                8505,
                8508,
                8511,
                8517,
                8521,
                8526,
                8526,
                8544,
                8584,
                11264,
                11310,
                11312,
                11358,
                11360,
                11492,
                11499,
                11507,
                11520,
                11557,
                11559,
                11559,
                11565,
                11565,
                11568,
                11623,
                11631,
                11631,
                11647,
                11670,
                11680,
                11686,
                11688,
                11694,
                11696,
                11702,
                11704,
                11710,
                11712,
                11718,
                11720,
                11726,
                11728,
                11734,
                11736,
                11742,
                11744,
                11775,
                11823,
                11823,
                12293,
                12295,
                12321,
                12335,
                12337,
                12341,
                12344,
                12348,
                12353,
                12438,
                12441,
                12442,
                12445,
                12447,
                12449,
                12538,
                12540,
                12543,
                12549,
                12589,
                12593,
                12686,
                12704,
                12730,
                12784,
                12799,
                13312,
                19893,
                19968,
                40908,
                40960,
                42124,
                42192,
                42237,
                42240,
                42508,
                42512,
                42539,
                42560,
                42607,
                42612,
                42621,
                42623,
                42647,
                42655,
                42737,
                42775,
                42783,
                42786,
                42888,
                42891,
                42894,
                42896,
                42899,
                42912,
                42922,
                43e3,
                43047,
                43072,
                43123,
                43136,
                43204,
                43216,
                43225,
                43232,
                43255,
                43259,
                43259,
                43264,
                43309,
                43312,
                43347,
                43360,
                43388,
                43392,
                43456,
                43471,
                43481,
                43520,
                43574,
                43584,
                43597,
                43600,
                43609,
                43616,
                43638,
                43642,
                43643,
                43648,
                43714,
                43739,
                43741,
                43744,
                43759,
                43762,
                43766,
                43777,
                43782,
                43785,
                43790,
                43793,
                43798,
                43808,
                43814,
                43816,
                43822,
                43968,
                44010,
                44012,
                44013,
                44016,
                44025,
                44032,
                55203,
                55216,
                55238,
                55243,
                55291,
                63744,
                64109,
                64112,
                64217,
                64256,
                64262,
                64275,
                64279,
                64285,
                64296,
                64298,
                64310,
                64312,
                64316,
                64318,
                64318,
                64320,
                64321,
                64323,
                64324,
                64326,
                64433,
                64467,
                64829,
                64848,
                64911,
                64914,
                64967,
                65008,
                65019,
                65024,
                65039,
                65056,
                65062,
                65075,
                65076,
                65101,
                65103,
                65136,
                65140,
                65142,
                65276,
                65296,
                65305,
                65313,
                65338,
                65343,
                65343,
                65345,
                65370,
                65382,
                65470,
                65474,
                65479,
                65482,
                65487,
                65490,
                65495,
                65498,
                65500
            ];
            unicodeESNextIdentifierStart = [
                65,
                90,
                97,
                122,
                170,
                170,
                181,
                181,
                186,
                186,
                192,
                214,
                216,
                246,
                248,
                705,
                710,
                721,
                736,
                740,
                748,
                748,
                750,
                750,
                880,
                884,
                886,
                887,
                890,
                893,
                895,
                895,
                902,
                902,
                904,
                906,
                908,
                908,
                910,
                929,
                931,
                1013,
                1015,
                1153,
                1162,
                1327,
                1329,
                1366,
                1369,
                1369,
                1376,
                1416,
                1488,
                1514,
                1519,
                1522,
                1568,
                1610,
                1646,
                1647,
                1649,
                1747,
                1749,
                1749,
                1765,
                1766,
                1774,
                1775,
                1786,
                1788,
                1791,
                1791,
                1808,
                1808,
                1810,
                1839,
                1869,
                1957,
                1969,
                1969,
                1994,
                2026,
                2036,
                2037,
                2042,
                2042,
                2048,
                2069,
                2074,
                2074,
                2084,
                2084,
                2088,
                2088,
                2112,
                2136,
                2144,
                2154,
                2208,
                2228,
                2230,
                2237,
                2308,
                2361,
                2365,
                2365,
                2384,
                2384,
                2392,
                2401,
                2417,
                2432,
                2437,
                2444,
                2447,
                2448,
                2451,
                2472,
                2474,
                2480,
                2482,
                2482,
                2486,
                2489,
                2493,
                2493,
                2510,
                2510,
                2524,
                2525,
                2527,
                2529,
                2544,
                2545,
                2556,
                2556,
                2565,
                2570,
                2575,
                2576,
                2579,
                2600,
                2602,
                2608,
                2610,
                2611,
                2613,
                2614,
                2616,
                2617,
                2649,
                2652,
                2654,
                2654,
                2674,
                2676,
                2693,
                2701,
                2703,
                2705,
                2707,
                2728,
                2730,
                2736,
                2738,
                2739,
                2741,
                2745,
                2749,
                2749,
                2768,
                2768,
                2784,
                2785,
                2809,
                2809,
                2821,
                2828,
                2831,
                2832,
                2835,
                2856,
                2858,
                2864,
                2866,
                2867,
                2869,
                2873,
                2877,
                2877,
                2908,
                2909,
                2911,
                2913,
                2929,
                2929,
                2947,
                2947,
                2949,
                2954,
                2958,
                2960,
                2962,
                2965,
                2969,
                2970,
                2972,
                2972,
                2974,
                2975,
                2979,
                2980,
                2984,
                2986,
                2990,
                3001,
                3024,
                3024,
                3077,
                3084,
                3086,
                3088,
                3090,
                3112,
                3114,
                3129,
                3133,
                3133,
                3160,
                3162,
                3168,
                3169,
                3200,
                3200,
                3205,
                3212,
                3214,
                3216,
                3218,
                3240,
                3242,
                3251,
                3253,
                3257,
                3261,
                3261,
                3294,
                3294,
                3296,
                3297,
                3313,
                3314,
                3333,
                3340,
                3342,
                3344,
                3346,
                3386,
                3389,
                3389,
                3406,
                3406,
                3412,
                3414,
                3423,
                3425,
                3450,
                3455,
                3461,
                3478,
                3482,
                3505,
                3507,
                3515,
                3517,
                3517,
                3520,
                3526,
                3585,
                3632,
                3634,
                3635,
                3648,
                3654,
                3713,
                3714,
                3716,
                3716,
                3718,
                3722,
                3724,
                3747,
                3749,
                3749,
                3751,
                3760,
                3762,
                3763,
                3773,
                3773,
                3776,
                3780,
                3782,
                3782,
                3804,
                3807,
                3840,
                3840,
                3904,
                3911,
                3913,
                3948,
                3976,
                3980,
                4096,
                4138,
                4159,
                4159,
                4176,
                4181,
                4186,
                4189,
                4193,
                4193,
                4197,
                4198,
                4206,
                4208,
                4213,
                4225,
                4238,
                4238,
                4256,
                4293,
                4295,
                4295,
                4301,
                4301,
                4304,
                4346,
                4348,
                4680,
                4682,
                4685,
                4688,
                4694,
                4696,
                4696,
                4698,
                4701,
                4704,
                4744,
                4746,
                4749,
                4752,
                4784,
                4786,
                4789,
                4792,
                4798,
                4800,
                4800,
                4802,
                4805,
                4808,
                4822,
                4824,
                4880,
                4882,
                4885,
                4888,
                4954,
                4992,
                5007,
                5024,
                5109,
                5112,
                5117,
                5121,
                5740,
                5743,
                5759,
                5761,
                5786,
                5792,
                5866,
                5870,
                5880,
                5888,
                5900,
                5902,
                5905,
                5920,
                5937,
                5952,
                5969,
                5984,
                5996,
                5998,
                6e3,
                6016,
                6067,
                6103,
                6103,
                6108,
                6108,
                6176,
                6264,
                6272,
                6312,
                6314,
                6314,
                6320,
                6389,
                6400,
                6430,
                6480,
                6509,
                6512,
                6516,
                6528,
                6571,
                6576,
                6601,
                6656,
                6678,
                6688,
                6740,
                6823,
                6823,
                6917,
                6963,
                6981,
                6987,
                7043,
                7072,
                7086,
                7087,
                7098,
                7141,
                7168,
                7203,
                7245,
                7247,
                7258,
                7293,
                7296,
                7304,
                7312,
                7354,
                7357,
                7359,
                7401,
                7404,
                7406,
                7411,
                7413,
                7414,
                7418,
                7418,
                7424,
                7615,
                7680,
                7957,
                7960,
                7965,
                7968,
                8005,
                8008,
                8013,
                8016,
                8023,
                8025,
                8025,
                8027,
                8027,
                8029,
                8029,
                8031,
                8061,
                8064,
                8116,
                8118,
                8124,
                8126,
                8126,
                8130,
                8132,
                8134,
                8140,
                8144,
                8147,
                8150,
                8155,
                8160,
                8172,
                8178,
                8180,
                8182,
                8188,
                8305,
                8305,
                8319,
                8319,
                8336,
                8348,
                8450,
                8450,
                8455,
                8455,
                8458,
                8467,
                8469,
                8469,
                8472,
                8477,
                8484,
                8484,
                8486,
                8486,
                8488,
                8488,
                8490,
                8505,
                8508,
                8511,
                8517,
                8521,
                8526,
                8526,
                8544,
                8584,
                11264,
                11310,
                11312,
                11358,
                11360,
                11492,
                11499,
                11502,
                11506,
                11507,
                11520,
                11557,
                11559,
                11559,
                11565,
                11565,
                11568,
                11623,
                11631,
                11631,
                11648,
                11670,
                11680,
                11686,
                11688,
                11694,
                11696,
                11702,
                11704,
                11710,
                11712,
                11718,
                11720,
                11726,
                11728,
                11734,
                11736,
                11742,
                12293,
                12295,
                12321,
                12329,
                12337,
                12341,
                12344,
                12348,
                12353,
                12438,
                12443,
                12447,
                12449,
                12538,
                12540,
                12543,
                12549,
                12591,
                12593,
                12686,
                12704,
                12730,
                12784,
                12799,
                13312,
                19893,
                19968,
                40943,
                40960,
                42124,
                42192,
                42237,
                42240,
                42508,
                42512,
                42527,
                42538,
                42539,
                42560,
                42606,
                42623,
                42653,
                42656,
                42735,
                42775,
                42783,
                42786,
                42888,
                42891,
                42943,
                42946,
                42950,
                42999,
                43009,
                43011,
                43013,
                43015,
                43018,
                43020,
                43042,
                43072,
                43123,
                43138,
                43187,
                43250,
                43255,
                43259,
                43259,
                43261,
                43262,
                43274,
                43301,
                43312,
                43334,
                43360,
                43388,
                43396,
                43442,
                43471,
                43471,
                43488,
                43492,
                43494,
                43503,
                43514,
                43518,
                43520,
                43560,
                43584,
                43586,
                43588,
                43595,
                43616,
                43638,
                43642,
                43642,
                43646,
                43695,
                43697,
                43697,
                43701,
                43702,
                43705,
                43709,
                43712,
                43712,
                43714,
                43714,
                43739,
                43741,
                43744,
                43754,
                43762,
                43764,
                43777,
                43782,
                43785,
                43790,
                43793,
                43798,
                43808,
                43814,
                43816,
                43822,
                43824,
                43866,
                43868,
                43879,
                43888,
                44002,
                44032,
                55203,
                55216,
                55238,
                55243,
                55291,
                63744,
                64109,
                64112,
                64217,
                64256,
                64262,
                64275,
                64279,
                64285,
                64285,
                64287,
                64296,
                64298,
                64310,
                64312,
                64316,
                64318,
                64318,
                64320,
                64321,
                64323,
                64324,
                64326,
                64433,
                64467,
                64829,
                64848,
                64911,
                64914,
                64967,
                65008,
                65019,
                65136,
                65140,
                65142,
                65276,
                65313,
                65338,
                65345,
                65370,
                65382,
                65470,
                65474,
                65479,
                65482,
                65487,
                65490,
                65495,
                65498,
                65500,
                65536,
                65547,
                65549,
                65574,
                65576,
                65594,
                65596,
                65597,
                65599,
                65613,
                65616,
                65629,
                65664,
                65786,
                65856,
                65908,
                66176,
                66204,
                66208,
                66256,
                66304,
                66335,
                66349,
                66378,
                66384,
                66421,
                66432,
                66461,
                66464,
                66499,
                66504,
                66511,
                66513,
                66517,
                66560,
                66717,
                66736,
                66771,
                66776,
                66811,
                66816,
                66855,
                66864,
                66915,
                67072,
                67382,
                67392,
                67413,
                67424,
                67431,
                67584,
                67589,
                67592,
                67592,
                67594,
                67637,
                67639,
                67640,
                67644,
                67644,
                67647,
                67669,
                67680,
                67702,
                67712,
                67742,
                67808,
                67826,
                67828,
                67829,
                67840,
                67861,
                67872,
                67897,
                67968,
                68023,
                68030,
                68031,
                68096,
                68096,
                68112,
                68115,
                68117,
                68119,
                68121,
                68149,
                68192,
                68220,
                68224,
                68252,
                68288,
                68295,
                68297,
                68324,
                68352,
                68405,
                68416,
                68437,
                68448,
                68466,
                68480,
                68497,
                68608,
                68680,
                68736,
                68786,
                68800,
                68850,
                68864,
                68899,
                69376,
                69404,
                69415,
                69415,
                69424,
                69445,
                69600,
                69622,
                69635,
                69687,
                69763,
                69807,
                69840,
                69864,
                69891,
                69926,
                69956,
                69956,
                69968,
                70002,
                70006,
                70006,
                70019,
                70066,
                70081,
                70084,
                70106,
                70106,
                70108,
                70108,
                70144,
                70161,
                70163,
                70187,
                70272,
                70278,
                70280,
                70280,
                70282,
                70285,
                70287,
                70301,
                70303,
                70312,
                70320,
                70366,
                70405,
                70412,
                70415,
                70416,
                70419,
                70440,
                70442,
                70448,
                70450,
                70451,
                70453,
                70457,
                70461,
                70461,
                70480,
                70480,
                70493,
                70497,
                70656,
                70708,
                70727,
                70730,
                70751,
                70751,
                70784,
                70831,
                70852,
                70853,
                70855,
                70855,
                71040,
                71086,
                71128,
                71131,
                71168,
                71215,
                71236,
                71236,
                71296,
                71338,
                71352,
                71352,
                71424,
                71450,
                71680,
                71723,
                71840,
                71903,
                71935,
                71935,
                72096,
                72103,
                72106,
                72144,
                72161,
                72161,
                72163,
                72163,
                72192,
                72192,
                72203,
                72242,
                72250,
                72250,
                72272,
                72272,
                72284,
                72329,
                72349,
                72349,
                72384,
                72440,
                72704,
                72712,
                72714,
                72750,
                72768,
                72768,
                72818,
                72847,
                72960,
                72966,
                72968,
                72969,
                72971,
                73008,
                73030,
                73030,
                73056,
                73061,
                73063,
                73064,
                73066,
                73097,
                73112,
                73112,
                73440,
                73458,
                73728,
                74649,
                74752,
                74862,
                74880,
                75075,
                77824,
                78894,
                82944,
                83526,
                92160,
                92728,
                92736,
                92766,
                92880,
                92909,
                92928,
                92975,
                92992,
                92995,
                93027,
                93047,
                93053,
                93071,
                93760,
                93823,
                93952,
                94026,
                94032,
                94032,
                94099,
                94111,
                94176,
                94177,
                94179,
                94179,
                94208,
                100343,
                100352,
                101106,
                110592,
                110878,
                110928,
                110930,
                110948,
                110951,
                110960,
                111355,
                113664,
                113770,
                113776,
                113788,
                113792,
                113800,
                113808,
                113817,
                119808,
                119892,
                119894,
                119964,
                119966,
                119967,
                119970,
                119970,
                119973,
                119974,
                119977,
                119980,
                119982,
                119993,
                119995,
                119995,
                119997,
                120003,
                120005,
                120069,
                120071,
                120074,
                120077,
                120084,
                120086,
                120092,
                120094,
                120121,
                120123,
                120126,
                120128,
                120132,
                120134,
                120134,
                120138,
                120144,
                120146,
                120485,
                120488,
                120512,
                120514,
                120538,
                120540,
                120570,
                120572,
                120596,
                120598,
                120628,
                120630,
                120654,
                120656,
                120686,
                120688,
                120712,
                120714,
                120744,
                120746,
                120770,
                120772,
                120779,
                123136,
                123180,
                123191,
                123197,
                123214,
                123214,
                123584,
                123627,
                124928,
                125124,
                125184,
                125251,
                125259,
                125259,
                126464,
                126467,
                126469,
                126495,
                126497,
                126498,
                126500,
                126500,
                126503,
                126503,
                126505,
                126514,
                126516,
                126519,
                126521,
                126521,
                126523,
                126523,
                126530,
                126530,
                126535,
                126535,
                126537,
                126537,
                126539,
                126539,
                126541,
                126543,
                126545,
                126546,
                126548,
                126548,
                126551,
                126551,
                126553,
                126553,
                126555,
                126555,
                126557,
                126557,
                126559,
                126559,
                126561,
                126562,
                126564,
                126564,
                126567,
                126570,
                126572,
                126578,
                126580,
                126583,
                126585,
                126588,
                126590,
                126590,
                126592,
                126601,
                126603,
                126619,
                126625,
                126627,
                126629,
                126633,
                126635,
                126651,
                131072,
                173782,
                173824,
                177972,
                177984,
                178205,
                178208,
                183969,
                183984,
                191456,
                194560,
                195101
            ];
            unicodeESNextIdentifierPart = [
                48,
                57,
                65,
                90,
                95,
                95,
                97,
                122,
                170,
                170,
                181,
                181,
                183,
                183,
                186,
                186,
                192,
                214,
                216,
                246,
                248,
                705,
                710,
                721,
                736,
                740,
                748,
                748,
                750,
                750,
                768,
                884,
                886,
                887,
                890,
                893,
                895,
                895,
                902,
                906,
                908,
                908,
                910,
                929,
                931,
                1013,
                1015,
                1153,
                1155,
                1159,
                1162,
                1327,
                1329,
                1366,
                1369,
                1369,
                1376,
                1416,
                1425,
                1469,
                1471,
                1471,
                1473,
                1474,
                1476,
                1477,
                1479,
                1479,
                1488,
                1514,
                1519,
                1522,
                1552,
                1562,
                1568,
                1641,
                1646,
                1747,
                1749,
                1756,
                1759,
                1768,
                1770,
                1788,
                1791,
                1791,
                1808,
                1866,
                1869,
                1969,
                1984,
                2037,
                2042,
                2042,
                2045,
                2045,
                2048,
                2093,
                2112,
                2139,
                2144,
                2154,
                2208,
                2228,
                2230,
                2237,
                2259,
                2273,
                2275,
                2403,
                2406,
                2415,
                2417,
                2435,
                2437,
                2444,
                2447,
                2448,
                2451,
                2472,
                2474,
                2480,
                2482,
                2482,
                2486,
                2489,
                2492,
                2500,
                2503,
                2504,
                2507,
                2510,
                2519,
                2519,
                2524,
                2525,
                2527,
                2531,
                2534,
                2545,
                2556,
                2556,
                2558,
                2558,
                2561,
                2563,
                2565,
                2570,
                2575,
                2576,
                2579,
                2600,
                2602,
                2608,
                2610,
                2611,
                2613,
                2614,
                2616,
                2617,
                2620,
                2620,
                2622,
                2626,
                2631,
                2632,
                2635,
                2637,
                2641,
                2641,
                2649,
                2652,
                2654,
                2654,
                2662,
                2677,
                2689,
                2691,
                2693,
                2701,
                2703,
                2705,
                2707,
                2728,
                2730,
                2736,
                2738,
                2739,
                2741,
                2745,
                2748,
                2757,
                2759,
                2761,
                2763,
                2765,
                2768,
                2768,
                2784,
                2787,
                2790,
                2799,
                2809,
                2815,
                2817,
                2819,
                2821,
                2828,
                2831,
                2832,
                2835,
                2856,
                2858,
                2864,
                2866,
                2867,
                2869,
                2873,
                2876,
                2884,
                2887,
                2888,
                2891,
                2893,
                2902,
                2903,
                2908,
                2909,
                2911,
                2915,
                2918,
                2927,
                2929,
                2929,
                2946,
                2947,
                2949,
                2954,
                2958,
                2960,
                2962,
                2965,
                2969,
                2970,
                2972,
                2972,
                2974,
                2975,
                2979,
                2980,
                2984,
                2986,
                2990,
                3001,
                3006,
                3010,
                3014,
                3016,
                3018,
                3021,
                3024,
                3024,
                3031,
                3031,
                3046,
                3055,
                3072,
                3084,
                3086,
                3088,
                3090,
                3112,
                3114,
                3129,
                3133,
                3140,
                3142,
                3144,
                3146,
                3149,
                3157,
                3158,
                3160,
                3162,
                3168,
                3171,
                3174,
                3183,
                3200,
                3203,
                3205,
                3212,
                3214,
                3216,
                3218,
                3240,
                3242,
                3251,
                3253,
                3257,
                3260,
                3268,
                3270,
                3272,
                3274,
                3277,
                3285,
                3286,
                3294,
                3294,
                3296,
                3299,
                3302,
                3311,
                3313,
                3314,
                3328,
                3331,
                3333,
                3340,
                3342,
                3344,
                3346,
                3396,
                3398,
                3400,
                3402,
                3406,
                3412,
                3415,
                3423,
                3427,
                3430,
                3439,
                3450,
                3455,
                3458,
                3459,
                3461,
                3478,
                3482,
                3505,
                3507,
                3515,
                3517,
                3517,
                3520,
                3526,
                3530,
                3530,
                3535,
                3540,
                3542,
                3542,
                3544,
                3551,
                3558,
                3567,
                3570,
                3571,
                3585,
                3642,
                3648,
                3662,
                3664,
                3673,
                3713,
                3714,
                3716,
                3716,
                3718,
                3722,
                3724,
                3747,
                3749,
                3749,
                3751,
                3773,
                3776,
                3780,
                3782,
                3782,
                3784,
                3789,
                3792,
                3801,
                3804,
                3807,
                3840,
                3840,
                3864,
                3865,
                3872,
                3881,
                3893,
                3893,
                3895,
                3895,
                3897,
                3897,
                3902,
                3911,
                3913,
                3948,
                3953,
                3972,
                3974,
                3991,
                3993,
                4028,
                4038,
                4038,
                4096,
                4169,
                4176,
                4253,
                4256,
                4293,
                4295,
                4295,
                4301,
                4301,
                4304,
                4346,
                4348,
                4680,
                4682,
                4685,
                4688,
                4694,
                4696,
                4696,
                4698,
                4701,
                4704,
                4744,
                4746,
                4749,
                4752,
                4784,
                4786,
                4789,
                4792,
                4798,
                4800,
                4800,
                4802,
                4805,
                4808,
                4822,
                4824,
                4880,
                4882,
                4885,
                4888,
                4954,
                4957,
                4959,
                4969,
                4977,
                4992,
                5007,
                5024,
                5109,
                5112,
                5117,
                5121,
                5740,
                5743,
                5759,
                5761,
                5786,
                5792,
                5866,
                5870,
                5880,
                5888,
                5900,
                5902,
                5908,
                5920,
                5940,
                5952,
                5971,
                5984,
                5996,
                5998,
                6e3,
                6002,
                6003,
                6016,
                6099,
                6103,
                6103,
                6108,
                6109,
                6112,
                6121,
                6155,
                6157,
                6160,
                6169,
                6176,
                6264,
                6272,
                6314,
                6320,
                6389,
                6400,
                6430,
                6432,
                6443,
                6448,
                6459,
                6470,
                6509,
                6512,
                6516,
                6528,
                6571,
                6576,
                6601,
                6608,
                6618,
                6656,
                6683,
                6688,
                6750,
                6752,
                6780,
                6783,
                6793,
                6800,
                6809,
                6823,
                6823,
                6832,
                6845,
                6912,
                6987,
                6992,
                7001,
                7019,
                7027,
                7040,
                7155,
                7168,
                7223,
                7232,
                7241,
                7245,
                7293,
                7296,
                7304,
                7312,
                7354,
                7357,
                7359,
                7376,
                7378,
                7380,
                7418,
                7424,
                7673,
                7675,
                7957,
                7960,
                7965,
                7968,
                8005,
                8008,
                8013,
                8016,
                8023,
                8025,
                8025,
                8027,
                8027,
                8029,
                8029,
                8031,
                8061,
                8064,
                8116,
                8118,
                8124,
                8126,
                8126,
                8130,
                8132,
                8134,
                8140,
                8144,
                8147,
                8150,
                8155,
                8160,
                8172,
                8178,
                8180,
                8182,
                8188,
                8255,
                8256,
                8276,
                8276,
                8305,
                8305,
                8319,
                8319,
                8336,
                8348,
                8400,
                8412,
                8417,
                8417,
                8421,
                8432,
                8450,
                8450,
                8455,
                8455,
                8458,
                8467,
                8469,
                8469,
                8472,
                8477,
                8484,
                8484,
                8486,
                8486,
                8488,
                8488,
                8490,
                8505,
                8508,
                8511,
                8517,
                8521,
                8526,
                8526,
                8544,
                8584,
                11264,
                11310,
                11312,
                11358,
                11360,
                11492,
                11499,
                11507,
                11520,
                11557,
                11559,
                11559,
                11565,
                11565,
                11568,
                11623,
                11631,
                11631,
                11647,
                11670,
                11680,
                11686,
                11688,
                11694,
                11696,
                11702,
                11704,
                11710,
                11712,
                11718,
                11720,
                11726,
                11728,
                11734,
                11736,
                11742,
                11744,
                11775,
                12293,
                12295,
                12321,
                12335,
                12337,
                12341,
                12344,
                12348,
                12353,
                12438,
                12441,
                12447,
                12449,
                12538,
                12540,
                12543,
                12549,
                12591,
                12593,
                12686,
                12704,
                12730,
                12784,
                12799,
                13312,
                19893,
                19968,
                40943,
                40960,
                42124,
                42192,
                42237,
                42240,
                42508,
                42512,
                42539,
                42560,
                42607,
                42612,
                42621,
                42623,
                42737,
                42775,
                42783,
                42786,
                42888,
                42891,
                42943,
                42946,
                42950,
                42999,
                43047,
                43072,
                43123,
                43136,
                43205,
                43216,
                43225,
                43232,
                43255,
                43259,
                43259,
                43261,
                43309,
                43312,
                43347,
                43360,
                43388,
                43392,
                43456,
                43471,
                43481,
                43488,
                43518,
                43520,
                43574,
                43584,
                43597,
                43600,
                43609,
                43616,
                43638,
                43642,
                43714,
                43739,
                43741,
                43744,
                43759,
                43762,
                43766,
                43777,
                43782,
                43785,
                43790,
                43793,
                43798,
                43808,
                43814,
                43816,
                43822,
                43824,
                43866,
                43868,
                43879,
                43888,
                44010,
                44012,
                44013,
                44016,
                44025,
                44032,
                55203,
                55216,
                55238,
                55243,
                55291,
                63744,
                64109,
                64112,
                64217,
                64256,
                64262,
                64275,
                64279,
                64285,
                64296,
                64298,
                64310,
                64312,
                64316,
                64318,
                64318,
                64320,
                64321,
                64323,
                64324,
                64326,
                64433,
                64467,
                64829,
                64848,
                64911,
                64914,
                64967,
                65008,
                65019,
                65024,
                65039,
                65056,
                65071,
                65075,
                65076,
                65101,
                65103,
                65136,
                65140,
                65142,
                65276,
                65296,
                65305,
                65313,
                65338,
                65343,
                65343,
                65345,
                65370,
                65382,
                65470,
                65474,
                65479,
                65482,
                65487,
                65490,
                65495,
                65498,
                65500,
                65536,
                65547,
                65549,
                65574,
                65576,
                65594,
                65596,
                65597,
                65599,
                65613,
                65616,
                65629,
                65664,
                65786,
                65856,
                65908,
                66045,
                66045,
                66176,
                66204,
                66208,
                66256,
                66272,
                66272,
                66304,
                66335,
                66349,
                66378,
                66384,
                66426,
                66432,
                66461,
                66464,
                66499,
                66504,
                66511,
                66513,
                66517,
                66560,
                66717,
                66720,
                66729,
                66736,
                66771,
                66776,
                66811,
                66816,
                66855,
                66864,
                66915,
                67072,
                67382,
                67392,
                67413,
                67424,
                67431,
                67584,
                67589,
                67592,
                67592,
                67594,
                67637,
                67639,
                67640,
                67644,
                67644,
                67647,
                67669,
                67680,
                67702,
                67712,
                67742,
                67808,
                67826,
                67828,
                67829,
                67840,
                67861,
                67872,
                67897,
                67968,
                68023,
                68030,
                68031,
                68096,
                68099,
                68101,
                68102,
                68108,
                68115,
                68117,
                68119,
                68121,
                68149,
                68152,
                68154,
                68159,
                68159,
                68192,
                68220,
                68224,
                68252,
                68288,
                68295,
                68297,
                68326,
                68352,
                68405,
                68416,
                68437,
                68448,
                68466,
                68480,
                68497,
                68608,
                68680,
                68736,
                68786,
                68800,
                68850,
                68864,
                68903,
                68912,
                68921,
                69376,
                69404,
                69415,
                69415,
                69424,
                69456,
                69600,
                69622,
                69632,
                69702,
                69734,
                69743,
                69759,
                69818,
                69840,
                69864,
                69872,
                69881,
                69888,
                69940,
                69942,
                69951,
                69956,
                69958,
                69968,
                70003,
                70006,
                70006,
                70016,
                70084,
                70089,
                70092,
                70096,
                70106,
                70108,
                70108,
                70144,
                70161,
                70163,
                70199,
                70206,
                70206,
                70272,
                70278,
                70280,
                70280,
                70282,
                70285,
                70287,
                70301,
                70303,
                70312,
                70320,
                70378,
                70384,
                70393,
                70400,
                70403,
                70405,
                70412,
                70415,
                70416,
                70419,
                70440,
                70442,
                70448,
                70450,
                70451,
                70453,
                70457,
                70459,
                70468,
                70471,
                70472,
                70475,
                70477,
                70480,
                70480,
                70487,
                70487,
                70493,
                70499,
                70502,
                70508,
                70512,
                70516,
                70656,
                70730,
                70736,
                70745,
                70750,
                70751,
                70784,
                70853,
                70855,
                70855,
                70864,
                70873,
                71040,
                71093,
                71096,
                71104,
                71128,
                71133,
                71168,
                71232,
                71236,
                71236,
                71248,
                71257,
                71296,
                71352,
                71360,
                71369,
                71424,
                71450,
                71453,
                71467,
                71472,
                71481,
                71680,
                71738,
                71840,
                71913,
                71935,
                71935,
                72096,
                72103,
                72106,
                72151,
                72154,
                72161,
                72163,
                72164,
                72192,
                72254,
                72263,
                72263,
                72272,
                72345,
                72349,
                72349,
                72384,
                72440,
                72704,
                72712,
                72714,
                72758,
                72760,
                72768,
                72784,
                72793,
                72818,
                72847,
                72850,
                72871,
                72873,
                72886,
                72960,
                72966,
                72968,
                72969,
                72971,
                73014,
                73018,
                73018,
                73020,
                73021,
                73023,
                73031,
                73040,
                73049,
                73056,
                73061,
                73063,
                73064,
                73066,
                73102,
                73104,
                73105,
                73107,
                73112,
                73120,
                73129,
                73440,
                73462,
                73728,
                74649,
                74752,
                74862,
                74880,
                75075,
                77824,
                78894,
                82944,
                83526,
                92160,
                92728,
                92736,
                92766,
                92768,
                92777,
                92880,
                92909,
                92912,
                92916,
                92928,
                92982,
                92992,
                92995,
                93008,
                93017,
                93027,
                93047,
                93053,
                93071,
                93760,
                93823,
                93952,
                94026,
                94031,
                94087,
                94095,
                94111,
                94176,
                94177,
                94179,
                94179,
                94208,
                100343,
                100352,
                101106,
                110592,
                110878,
                110928,
                110930,
                110948,
                110951,
                110960,
                111355,
                113664,
                113770,
                113776,
                113788,
                113792,
                113800,
                113808,
                113817,
                113821,
                113822,
                119141,
                119145,
                119149,
                119154,
                119163,
                119170,
                119173,
                119179,
                119210,
                119213,
                119362,
                119364,
                119808,
                119892,
                119894,
                119964,
                119966,
                119967,
                119970,
                119970,
                119973,
                119974,
                119977,
                119980,
                119982,
                119993,
                119995,
                119995,
                119997,
                120003,
                120005,
                120069,
                120071,
                120074,
                120077,
                120084,
                120086,
                120092,
                120094,
                120121,
                120123,
                120126,
                120128,
                120132,
                120134,
                120134,
                120138,
                120144,
                120146,
                120485,
                120488,
                120512,
                120514,
                120538,
                120540,
                120570,
                120572,
                120596,
                120598,
                120628,
                120630,
                120654,
                120656,
                120686,
                120688,
                120712,
                120714,
                120744,
                120746,
                120770,
                120772,
                120779,
                120782,
                120831,
                121344,
                121398,
                121403,
                121452,
                121461,
                121461,
                121476,
                121476,
                121499,
                121503,
                121505,
                121519,
                122880,
                122886,
                122888,
                122904,
                122907,
                122913,
                122915,
                122916,
                122918,
                122922,
                123136,
                123180,
                123184,
                123197,
                123200,
                123209,
                123214,
                123214,
                123584,
                123641,
                124928,
                125124,
                125136,
                125142,
                125184,
                125259,
                125264,
                125273,
                126464,
                126467,
                126469,
                126495,
                126497,
                126498,
                126500,
                126500,
                126503,
                126503,
                126505,
                126514,
                126516,
                126519,
                126521,
                126521,
                126523,
                126523,
                126530,
                126530,
                126535,
                126535,
                126537,
                126537,
                126539,
                126539,
                126541,
                126543,
                126545,
                126546,
                126548,
                126548,
                126551,
                126551,
                126553,
                126553,
                126555,
                126555,
                126557,
                126557,
                126559,
                126559,
                126561,
                126562,
                126564,
                126564,
                126567,
                126570,
                126572,
                126578,
                126580,
                126583,
                126585,
                126588,
                126590,
                126590,
                126592,
                126601,
                126603,
                126619,
                126625,
                126627,
                126629,
                126633,
                126635,
                126651,
                131072,
                173782,
                173824,
                177972,
                177984,
                178205,
                178208,
                183969,
                183984,
                191456,
                194560,
                195101,
                917760,
                917999
            ];
            commentDirectiveRegExSingleLine = /^\/\/\/?\s*@(ts-expect-error|ts-ignore)/;
            commentDirectiveRegExMultiLine = /^(?:\/|\*)*\s*@(ts-expect-error|ts-ignore)/;
            tokenStrings = makeReverseMap(textToToken);
            mergeConflictMarkerLength = 7;
            shebangTriviaRegex = /^#!.*/;
            codePointAt = String.prototype.codePointAt ? (s, i)=>s.codePointAt(i) : function codePointAt2(str, i) {
                const size = str.length;
                if (i < 0 || i >= size) return void 0;
                const first2 = str.charCodeAt(i);
                if (first2 >= 55296 && first2 <= 56319 && size > i + 1) {
                    const second = str.charCodeAt(i + 1);
                    if (second >= 56320 && second <= 57343) return (first2 - 55296) * 1024 + second - 56320 + 65536;
                }
                return first2;
            };
            utf16EncodeAsStringWorker = String.fromCodePoint ? (codePoint)=>String.fromCodePoint(codePoint) : utf16EncodeAsStringFallback;
        }
    });
    // src/compiler/utilitiesPublic.ts
    function isExternalModuleNameRelative(moduleName) {
        return pathIsRelative(moduleName) || isRootedDiskPath(moduleName);
    }
    function sortAndDeduplicateDiagnostics(diagnostics) {
        return sortAndDeduplicate(diagnostics, compareDiagnostics);
    }
    function getDefaultLibFileName(options) {
        switch(getEmitScriptTarget(options)){
            case 99 /* ESNext */ :
                return "lib.esnext.full.d.ts";
            case 9 /* ES2022 */ :
                return "lib.es2022.full.d.ts";
            case 8 /* ES2021 */ :
                return "lib.es2021.full.d.ts";
            case 7 /* ES2020 */ :
                return "lib.es2020.full.d.ts";
            case 6 /* ES2019 */ :
                return "lib.es2019.full.d.ts";
            case 5 /* ES2018 */ :
                return "lib.es2018.full.d.ts";
            case 4 /* ES2017 */ :
                return "lib.es2017.full.d.ts";
            case 3 /* ES2016 */ :
                return "lib.es2016.full.d.ts";
            case 2 /* ES2015 */ :
                return "lib.es6.d.ts";
            default:
                return "lib.d.ts";
        }
    }
    function textSpanEnd(span) {
        return span.start + span.length;
    }
    function textSpanIsEmpty(span) {
        return span.length === 0;
    }
    function textSpanContainsPosition(span, position) {
        return position >= span.start && position < textSpanEnd(span);
    }
    function textRangeContainsPositionInclusive(span, position) {
        return position >= span.pos && position <= span.end;
    }
    function textSpanContainsTextSpan(span, other) {
        return other.start >= span.start && textSpanEnd(other) <= textSpanEnd(span);
    }
    function textSpanOverlapsWith(span, other) {
        return textSpanOverlap(span, other) !== void 0;
    }
    function textSpanOverlap(span1, span2) {
        const overlap = textSpanIntersection(span1, span2);
        return overlap && overlap.length === 0 ? void 0 : overlap;
    }
    function textSpanIntersectsWithTextSpan(span, other) {
        return decodedTextSpanIntersectsWith(span.start, span.length, other.start, other.length);
    }
    function textSpanIntersectsWith(span, start, length2) {
        return decodedTextSpanIntersectsWith(span.start, span.length, start, length2);
    }
    function decodedTextSpanIntersectsWith(start1, length1, start2, length2) {
        const end1 = start1 + length1;
        const end2 = start2 + length2;
        return start2 <= end1 && end2 >= start1;
    }
    function textSpanIntersectsWithPosition(span, position) {
        return position <= textSpanEnd(span) && position >= span.start;
    }
    function textSpanIntersection(span1, span2) {
        const start = Math.max(span1.start, span2.start);
        const end = Math.min(textSpanEnd(span1), textSpanEnd(span2));
        return start <= end ? createTextSpanFromBounds(start, end) : void 0;
    }
    function createTextSpan(start, length2) {
        if (start < 0) throw new Error("start < 0");
        if (length2 < 0) throw new Error("length < 0");
        return {
            start: start,
            length: length2
        };
    }
    function createTextSpanFromBounds(start, end) {
        return createTextSpan(start, end - start);
    }
    function textChangeRangeNewSpan(range) {
        return createTextSpan(range.span.start, range.newLength);
    }
    function textChangeRangeIsUnchanged(range) {
        return textSpanIsEmpty(range.span) && range.newLength === 0;
    }
    function createTextChangeRange(span, newLength) {
        if (newLength < 0) throw new Error("newLength < 0");
        return {
            span: span,
            newLength: newLength
        };
    }
    function collapseTextChangeRangesAcrossMultipleVersions(changes) {
        if (changes.length === 0) return unchangedTextChangeRange;
        if (changes.length === 1) return changes[0];
        const change0 = changes[0];
        let oldStartN = change0.span.start;
        let oldEndN = textSpanEnd(change0.span);
        let newEndN = oldStartN + change0.newLength;
        for(let i = 1; i < changes.length; i++){
            const nextChange = changes[i];
            const oldStart1 = oldStartN;
            const oldEnd1 = oldEndN;
            const newEnd1 = newEndN;
            const oldStart2 = nextChange.span.start;
            const oldEnd2 = textSpanEnd(nextChange.span);
            const newEnd2 = oldStart2 + nextChange.newLength;
            oldStartN = Math.min(oldStart1, oldStart2);
            oldEndN = Math.max(oldEnd1, oldEnd1 + (oldEnd2 - newEnd1));
            newEndN = Math.max(newEnd2, newEnd2 + (newEnd1 - oldEnd2));
        }
        return createTextChangeRange(createTextSpanFromBounds(oldStartN, oldEndN), /*newLength*/ newEndN - oldStartN);
    }
    function getTypeParameterOwner(d) {
        if (d && d.kind === 167 /* TypeParameter */ ) for(let current = d; current; current = current.parent){
            if (isFunctionLike(current) || isClassLike(current) || current.kind === 263 /* InterfaceDeclaration */ ) return current;
        }
    }
    function isParameterPropertyDeclaration(node, parent2) {
        return isParameter(node) && hasSyntacticModifier(node, 16476 /* ParameterPropertyModifier */ ) && parent2.kind === 175 /* Constructor */ ;
    }
    function isEmptyBindingPattern(node) {
        if (isBindingPattern(node)) return every(node.elements, isEmptyBindingElement);
        return false;
    }
    function isEmptyBindingElement(node) {
        if (isOmittedExpression(node)) return true;
        return isEmptyBindingPattern(node.name);
    }
    function walkUpBindingElementsAndPatterns(binding) {
        let node = binding.parent;
        while(isBindingElement(node.parent))node = node.parent.parent;
        return node.parent;
    }
    function getCombinedFlags(node, getFlags) {
        if (isBindingElement(node)) node = walkUpBindingElementsAndPatterns(node);
        let flags = getFlags(node);
        if (node.kind === 259 /* VariableDeclaration */ ) node = node.parent;
        if (node && node.kind === 260 /* VariableDeclarationList */ ) {
            flags |= getFlags(node);
            node = node.parent;
        }
        if (node && node.kind === 242 /* VariableStatement */ ) flags |= getFlags(node);
        return flags;
    }
    function getCombinedModifierFlags(node) {
        return getCombinedFlags(node, getEffectiveModifierFlags);
    }
    function getCombinedNodeFlagsAlwaysIncludeJSDoc(node) {
        return getCombinedFlags(node, getEffectiveModifierFlagsAlwaysIncludeJSDoc);
    }
    function getCombinedNodeFlags(node) {
        return getCombinedFlags(node, (n)=>n.flags);
    }
    function validateLocaleAndSetLanguage(locale, sys2, errors) {
        const lowerCaseLocale = locale.toLowerCase();
        const matchResult = /^([a-z]+)([_\-]([a-z]+))?$/.exec(lowerCaseLocale);
        if (!matchResult) {
            if (errors) errors.push(createCompilerDiagnostic(Diagnostics.Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1, "en", "ja-jp"));
            return;
        }
        const language = matchResult[1];
        const territory = matchResult[3];
        if (contains(supportedLocaleDirectories, lowerCaseLocale) && !trySetLanguageAndTerritory(language, territory, errors)) trySetLanguageAndTerritory(language, /*territory*/ void 0, errors);
        setUILocale(locale);
        function trySetLanguageAndTerritory(language2, territory2, errors2) {
            const compilerFilePath = normalizePath(sys2.getExecutingFilePath());
            const containingDirectoryPath = getDirectoryPath(compilerFilePath);
            let filePath = combinePaths(containingDirectoryPath, language2);
            if (territory2) filePath = filePath + "-" + territory2;
            filePath = sys2.resolvePath(combinePaths(filePath, "diagnosticMessages.generated.json"));
            if (!sys2.fileExists(filePath)) return false;
            let fileContents = "";
            try {
                fileContents = sys2.readFile(filePath);
            } catch (e) {
                if (errors2) errors2.push(createCompilerDiagnostic(Diagnostics.Unable_to_open_file_0, filePath));
                return false;
            }
            try {
                setLocalizedDiagnosticMessages(JSON.parse(fileContents));
            } catch  {
                if (errors2) errors2.push(createCompilerDiagnostic(Diagnostics.Corrupted_locale_file_0, filePath));
                return false;
            }
            return true;
        }
    }
    function getOriginalNode(node, nodeTest) {
        if (node) while(node.original !== void 0)node = node.original;
        if (!node || !nodeTest) return node;
        return nodeTest(node) ? node : void 0;
    }
    function findAncestor(node, callback) {
        while(node){
            const result = callback(node);
            if (result === "quit") return void 0;
            else if (result) return node;
            node = node.parent;
        }
        return void 0;
    }
    function isParseTreeNode(node) {
        return (node.flags & 8 /* Synthesized */ ) === 0;
    }
    function getParseTreeNode(node, nodeTest) {
        if (node === void 0 || isParseTreeNode(node)) return node;
        node = node.original;
        while(node){
            if (isParseTreeNode(node)) return !nodeTest || nodeTest(node) ? node : void 0;
            node = node.original;
        }
    }
    function escapeLeadingUnderscores(identifier) {
        return identifier.length >= 2 && identifier.charCodeAt(0) === 95 /* _ */  && identifier.charCodeAt(1) === 95 /* _ */  ? "_" + identifier : identifier;
    }
    function unescapeLeadingUnderscores(identifier) {
        const id = identifier;
        return id.length >= 3 && id.charCodeAt(0) === 95 /* _ */  && id.charCodeAt(1) === 95 /* _ */  && id.charCodeAt(2) === 95 /* _ */  ? id.substr(1) : id;
    }
    function idText(identifierOrPrivateName) {
        return unescapeLeadingUnderscores(identifierOrPrivateName.escapedText);
    }
    function identifierToKeywordKind(node) {
        const token = stringToToken(node.escapedText);
        return token ? tryCast(token, isKeyword) : void 0;
    }
    function symbolName(symbol) {
        if (symbol.valueDeclaration && isPrivateIdentifierClassElementDeclaration(symbol.valueDeclaration)) return idText(symbol.valueDeclaration.name);
        return unescapeLeadingUnderscores(symbol.escapedName);
    }
    function nameForNamelessJSDocTypedef(declaration) {
        const hostNode = declaration.parent.parent;
        if (!hostNode) return void 0;
        if (isDeclaration(hostNode)) return getDeclarationIdentifier(hostNode);
        switch(hostNode.kind){
            case 242 /* VariableStatement */ :
                if (hostNode.declarationList && hostNode.declarationList.declarations[0]) return getDeclarationIdentifier(hostNode.declarationList.declarations[0]);
                break;
            case 243 /* ExpressionStatement */ :
                let expr = hostNode.expression;
                if (expr.kind === 225 /* BinaryExpression */  && expr.operatorToken.kind === 64 /* EqualsToken */ ) expr = expr.left;
                switch(expr.kind){
                    case 210 /* PropertyAccessExpression */ :
                        return expr.name;
                    case 211 /* ElementAccessExpression */ :
                        const arg = expr.argumentExpression;
                        if (isIdentifier(arg)) return arg;
                }
                break;
            case 216 /* ParenthesizedExpression */ :
                return getDeclarationIdentifier(hostNode.expression);
            case 255 /* LabeledStatement */ :
                if (isDeclaration(hostNode.statement) || isExpression(hostNode.statement)) return getDeclarationIdentifier(hostNode.statement);
                break;
        }
    }
    function getDeclarationIdentifier(node) {
        const name = getNameOfDeclaration(node);
        return name && isIdentifier(name) ? name : void 0;
    }
    function nodeHasName(statement, name) {
        if (isNamedDeclaration(statement) && isIdentifier(statement.name) && idText(statement.name) === idText(name)) return true;
        if (isVariableStatement(statement) && some(statement.declarationList.declarations, (d)=>nodeHasName(d, name))) return true;
        return false;
    }
    function getNameOfJSDocTypedef(declaration) {
        return declaration.name || nameForNamelessJSDocTypedef(declaration);
    }
    function isNamedDeclaration(node) {
        return !!node.name;
    }
    function getNonAssignedNameOfDeclaration(declaration) {
        switch(declaration.kind){
            case 80 /* Identifier */ :
                return declaration;
            case 354 /* JSDocPropertyTag */ :
            case 347 /* JSDocParameterTag */ :
                {
                    const { name: name  } = declaration;
                    if (name.kind === 165 /* QualifiedName */ ) return name.right;
                    break;
                }
            case 212 /* CallExpression */ :
            case 225 /* BinaryExpression */ :
                {
                    const expr2 = declaration;
                    switch(getAssignmentDeclarationKind(expr2)){
                        case 1 /* ExportsProperty */ :
                        case 4 /* ThisProperty */ :
                        case 5 /* Property */ :
                        case 3 /* PrototypeProperty */ :
                            return getElementOrPropertyAccessArgumentExpressionOrName(expr2.left);
                        case 7 /* ObjectDefinePropertyValue */ :
                        case 8 /* ObjectDefinePropertyExports */ :
                        case 9 /* ObjectDefinePrototypeProperty */ :
                            return expr2.arguments[1];
                        default:
                            return void 0;
                    }
                }
            case 352 /* JSDocTypedefTag */ :
                return getNameOfJSDocTypedef(declaration);
            case 346 /* JSDocEnumTag */ :
                return nameForNamelessJSDocTypedef(declaration);
            case 276 /* ExportAssignment */ :
                {
                    const { expression: expression  } = declaration;
                    return isIdentifier(expression) ? expression : void 0;
                }
            case 211 /* ElementAccessExpression */ :
                const expr = declaration;
                if (isBindableStaticElementAccessExpression(expr)) return expr.argumentExpression;
        }
        return declaration.name;
    }
    function getNameOfDeclaration(declaration) {
        if (declaration === void 0) return void 0;
        return getNonAssignedNameOfDeclaration(declaration) || (isFunctionExpression(declaration) || isArrowFunction(declaration) || isClassExpression(declaration) ? getAssignedName(declaration) : void 0);
    }
    function getAssignedName(node) {
        if (!node.parent) return void 0;
        else if (isPropertyAssignment(node.parent) || isBindingElement(node.parent)) return node.parent.name;
        else if (isBinaryExpression(node.parent) && node === node.parent.right) {
            if (isIdentifier(node.parent.left)) return node.parent.left;
            else if (isAccessExpression(node.parent.left)) return getElementOrPropertyAccessArgumentExpressionOrName(node.parent.left);
        } else if (isVariableDeclaration(node.parent) && isIdentifier(node.parent.name)) return node.parent.name;
    }
    function getDecorators(node) {
        if (hasDecorators(node)) return filter(node.modifiers, isDecorator);
    }
    function getModifiers(node) {
        if (hasSyntacticModifier(node, 126975 /* Modifier */ )) return filter(node.modifiers, isModifier);
    }
    function getJSDocParameterTagsWorker(param, noCache) {
        if (param.name) {
            if (isIdentifier(param.name)) {
                const name = param.name.escapedText;
                return getJSDocTagsWorker(param.parent, noCache).filter((tag)=>isJSDocParameterTag(tag) && isIdentifier(tag.name) && tag.name.escapedText === name);
            } else {
                const i = param.parent.parameters.indexOf(param);
                Debug.assert(i > -1, "Parameters should always be in their parents' parameter list");
                const paramTags = getJSDocTagsWorker(param.parent, noCache).filter(isJSDocParameterTag);
                if (i < paramTags.length) return [
                    paramTags[i]
                ];
            }
        }
        return emptyArray;
    }
    function getJSDocParameterTags(param) {
        return getJSDocParameterTagsWorker(param, /*noCache*/ false);
    }
    function getJSDocParameterTagsNoCache(param) {
        return getJSDocParameterTagsWorker(param, /*noCache*/ true);
    }
    function getJSDocTypeParameterTagsWorker(param, noCache) {
        const name = param.name.escapedText;
        return getJSDocTagsWorker(param.parent, noCache).filter((tag)=>isJSDocTemplateTag(tag) && tag.typeParameters.some((tp)=>tp.name.escapedText === name));
    }
    function getJSDocTypeParameterTags(param) {
        return getJSDocTypeParameterTagsWorker(param, /*noCache*/ false);
    }
    function getJSDocTypeParameterTagsNoCache(param) {
        return getJSDocTypeParameterTagsWorker(param, /*noCache*/ true);
    }
    function hasJSDocParameterTags(node) {
        return !!getFirstJSDocTag(node, isJSDocParameterTag);
    }
    function getJSDocAugmentsTag(node) {
        return getFirstJSDocTag(node, isJSDocAugmentsTag);
    }
    function getJSDocImplementsTags(node) {
        return getAllJSDocTags(node, isJSDocImplementsTag);
    }
    function getJSDocClassTag(node) {
        return getFirstJSDocTag(node, isJSDocClassTag);
    }
    function getJSDocPublicTag(node) {
        return getFirstJSDocTag(node, isJSDocPublicTag);
    }
    function getJSDocPublicTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocPublicTag, /*noCache*/ true);
    }
    function getJSDocPrivateTag(node) {
        return getFirstJSDocTag(node, isJSDocPrivateTag);
    }
    function getJSDocPrivateTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocPrivateTag, /*noCache*/ true);
    }
    function getJSDocProtectedTag(node) {
        return getFirstJSDocTag(node, isJSDocProtectedTag);
    }
    function getJSDocProtectedTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocProtectedTag, /*noCache*/ true);
    }
    function getJSDocReadonlyTag(node) {
        return getFirstJSDocTag(node, isJSDocReadonlyTag);
    }
    function getJSDocReadonlyTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocReadonlyTag, /*noCache*/ true);
    }
    function getJSDocOverrideTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocOverrideTag, /*noCache*/ true);
    }
    function getJSDocDeprecatedTag(node) {
        return getFirstJSDocTag(node, isJSDocDeprecatedTag);
    }
    function getJSDocDeprecatedTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocDeprecatedTag, /*noCache*/ true);
    }
    function getJSDocEnumTag(node) {
        return getFirstJSDocTag(node, isJSDocEnumTag);
    }
    function getJSDocThisTag(node) {
        return getFirstJSDocTag(node, isJSDocThisTag);
    }
    function getJSDocReturnTag(node) {
        return getFirstJSDocTag(node, isJSDocReturnTag);
    }
    function getJSDocTemplateTag(node) {
        return getFirstJSDocTag(node, isJSDocTemplateTag);
    }
    function getJSDocSatisfiesTag(node) {
        return getFirstJSDocTag(node, isJSDocSatisfiesTag);
    }
    function getJSDocTypeTag(node) {
        const tag = getFirstJSDocTag(node, isJSDocTypeTag);
        if (tag && tag.typeExpression && tag.typeExpression.type) return tag;
        return void 0;
    }
    function getJSDocType(node) {
        let tag = getFirstJSDocTag(node, isJSDocTypeTag);
        if (!tag && isParameter(node)) tag = find(getJSDocParameterTags(node), (tag2)=>!!tag2.typeExpression);
        return tag && tag.typeExpression && tag.typeExpression.type;
    }
    function getJSDocReturnType(node) {
        const returnTag = getJSDocReturnTag(node);
        if (returnTag && returnTag.typeExpression) return returnTag.typeExpression.type;
        const typeTag = getJSDocTypeTag(node);
        if (typeTag && typeTag.typeExpression) {
            const type = typeTag.typeExpression.type;
            if (isTypeLiteralNode(type)) {
                const sig = find(type.members, isCallSignatureDeclaration);
                return sig && sig.type;
            }
            if (isFunctionTypeNode(type) || isJSDocFunctionType(type)) return type.type;
        }
    }
    function getJSDocTagsWorker(node, noCache) {
        var _a;
        if (!canHaveJSDoc(node)) return emptyArray;
        let tags = (_a = node.jsDoc) == null ? void 0 : _a.jsDocCache;
        if (tags === void 0 || noCache) {
            const comments = getJSDocCommentsAndTags(node, noCache);
            Debug.assert(comments.length < 2 || comments[0] !== comments[1]);
            tags = flatMap(comments, (j)=>isJSDoc(j) ? j.tags : j);
            if (!noCache) {
                node.jsDoc ?? (node.jsDoc = []);
                node.jsDoc.jsDocCache = tags;
            }
        }
        return tags;
    }
    function getJSDocTags(node) {
        return getJSDocTagsWorker(node, /*noCache*/ false);
    }
    function getJSDocTagsNoCache(node) {
        return getJSDocTagsWorker(node, /*noCache*/ true);
    }
    function getFirstJSDocTag(node, predicate, noCache) {
        return find(getJSDocTagsWorker(node, noCache), predicate);
    }
    function getAllJSDocTags(node, predicate) {
        return getJSDocTags(node).filter(predicate);
    }
    function getAllJSDocTagsOfKind(node, kind) {
        return getJSDocTags(node).filter((doc)=>doc.kind === kind);
    }
    function getTextOfJSDocComment(comment) {
        return typeof comment === "string" ? comment : comment == null ? void 0 : comment.map((c)=>c.kind === 327 /* JSDocText */  ? c.text : formatJSDocLink(c)).join("");
    }
    function formatJSDocLink(link) {
        const kind = link.kind === 330 /* JSDocLink */  ? "link" : link.kind === 331 /* JSDocLinkCode */  ? "linkcode" : "linkplain";
        const name = link.name ? entityNameToString(link.name) : "";
        const space = link.name && link.text.startsWith("://") ? "" : " ";
        return `{@${kind} ${name}${space}${link.text}}`;
    }
    function getEffectiveTypeParameterDeclarations(node) {
        if (isJSDocSignature(node)) {
            if (isJSDocOverloadTag(node.parent)) {
                const jsDoc = getJSDocRoot(node.parent);
                if (jsDoc && length(jsDoc.tags)) return flatMap(jsDoc.tags, (tag)=>isJSDocTemplateTag(tag) ? tag.typeParameters : void 0);
            }
            return emptyArray;
        }
        if (isJSDocTypeAlias(node)) {
            Debug.assert(node.parent.kind === 326 /* JSDoc */ );
            return flatMap(node.parent.tags, (tag)=>isJSDocTemplateTag(tag) ? tag.typeParameters : void 0);
        }
        if (node.typeParameters) return node.typeParameters;
        if (canHaveIllegalTypeParameters(node) && node.typeParameters) return node.typeParameters;
        if (isInJSFile(node)) {
            const decls = getJSDocTypeParameterDeclarations(node);
            if (decls.length) return decls;
            const typeTag = getJSDocType(node);
            if (typeTag && isFunctionTypeNode(typeTag) && typeTag.typeParameters) return typeTag.typeParameters;
        }
        return emptyArray;
    }
    function getEffectiveConstraintOfTypeParameter(node) {
        return node.constraint ? node.constraint : isJSDocTemplateTag(node.parent) && node === node.parent.typeParameters[0] ? node.parent.constraint : void 0;
    }
    function isMemberName(node) {
        return node.kind === 80 /* Identifier */  || node.kind === 81 /* PrivateIdentifier */ ;
    }
    function isGetOrSetAccessorDeclaration(node) {
        return node.kind === 177 /* SetAccessor */  || node.kind === 176 /* GetAccessor */ ;
    }
    function isPropertyAccessChain(node) {
        return isPropertyAccessExpression(node) && !!(node.flags & 32 /* OptionalChain */ );
    }
    function isElementAccessChain(node) {
        return isElementAccessExpression(node) && !!(node.flags & 32 /* OptionalChain */ );
    }
    function isCallChain(node) {
        return isCallExpression(node) && !!(node.flags & 32 /* OptionalChain */ );
    }
    function isOptionalChain(node) {
        const kind = node.kind;
        return !!(node.flags & 32 /* OptionalChain */ ) && (kind === 210 /* PropertyAccessExpression */  || kind === 211 /* ElementAccessExpression */  || kind === 212 /* CallExpression */  || kind === 234 /* NonNullExpression */ );
    }
    function isOptionalChainRoot(node) {
        return isOptionalChain(node) && !isNonNullExpression(node) && !!node.questionDotToken;
    }
    function isExpressionOfOptionalChainRoot(node) {
        return isOptionalChainRoot(node.parent) && node.parent.expression === node;
    }
    function isOutermostOptionalChain(node) {
        return !isOptionalChain(node.parent) || isOptionalChainRoot(node.parent) || node !== node.parent.expression;
    }
    function isNullishCoalesce(node) {
        return node.kind === 225 /* BinaryExpression */  && node.operatorToken.kind === 61 /* QuestionQuestionToken */ ;
    }
    function isConstTypeReference(node) {
        return isTypeReferenceNode(node) && isIdentifier(node.typeName) && node.typeName.escapedText === "const" && !node.typeArguments;
    }
    function skipPartiallyEmittedExpressions(node) {
        return skipOuterExpressions(node, 8 /* PartiallyEmittedExpressions */ );
    }
    function isNonNullChain(node) {
        return isNonNullExpression(node) && !!(node.flags & 32 /* OptionalChain */ );
    }
    function isBreakOrContinueStatement(node) {
        return node.kind === 251 /* BreakStatement */  || node.kind === 250 /* ContinueStatement */ ;
    }
    function isNamedExportBindings(node) {
        return node.kind === 279 /* NamespaceExport */  || node.kind === 278 /* NamedExports */ ;
    }
    function isUnparsedTextLike(node) {
        switch(node.kind){
            case 308 /* UnparsedText */ :
            case 309 /* UnparsedInternalText */ :
                return true;
            default:
                return false;
        }
    }
    function isUnparsedNode(node) {
        return isUnparsedTextLike(node) || node.kind === 306 /* UnparsedPrologue */  || node.kind === 310 /* UnparsedSyntheticReference */ ;
    }
    function isJSDocPropertyLikeTag(node) {
        return node.kind === 354 /* JSDocPropertyTag */  || node.kind === 347 /* JSDocParameterTag */ ;
    }
    function isNode(node) {
        return isNodeKind(node.kind);
    }
    function isNodeKind(kind) {
        return kind >= 165 /* FirstNode */ ;
    }
    function isTokenKind(kind) {
        return kind >= 0 /* FirstToken */  && kind <= 164 /* LastToken */ ;
    }
    function isToken(n) {
        return isTokenKind(n.kind);
    }
    function isNodeArray(array) {
        return hasProperty(array, "pos") && hasProperty(array, "end");
    }
    function isLiteralKind(kind) {
        return 9 /* FirstLiteralToken */  <= kind && kind <= 15 /* LastLiteralToken */ ;
    }
    function isLiteralExpression(node) {
        return isLiteralKind(node.kind);
    }
    function isLiteralExpressionOfObject(node) {
        switch(node.kind){
            case 209 /* ObjectLiteralExpression */ :
            case 208 /* ArrayLiteralExpression */ :
            case 14 /* RegularExpressionLiteral */ :
            case 217 /* FunctionExpression */ :
            case 230 /* ClassExpression */ :
                return true;
        }
        return false;
    }
    function isTemplateLiteralKind(kind) {
        return 15 /* FirstTemplateToken */  <= kind && kind <= 18 /* LastTemplateToken */ ;
    }
    function isTemplateLiteralToken(node) {
        return isTemplateLiteralKind(node.kind);
    }
    function isTemplateMiddleOrTemplateTail(node) {
        const kind = node.kind;
        return kind === 17 /* TemplateMiddle */  || kind === 18 /* TemplateTail */ ;
    }
    function isImportOrExportSpecifier(node) {
        return isImportSpecifier(node) || isExportSpecifier(node);
    }
    function isTypeOnlyImportDeclaration(node) {
        switch(node.kind){
            case 275 /* ImportSpecifier */ :
                return node.isTypeOnly || node.parent.parent.isTypeOnly;
            case 273 /* NamespaceImport */ :
                return node.parent.isTypeOnly;
            case 272 /* ImportClause */ :
            case 270 /* ImportEqualsDeclaration */ :
                return node.isTypeOnly;
        }
        return false;
    }
    function isTypeOnlyExportDeclaration(node) {
        switch(node.kind){
            case 280 /* ExportSpecifier */ :
                return node.isTypeOnly || node.parent.parent.isTypeOnly;
            case 277 /* ExportDeclaration */ :
                return node.isTypeOnly && !!node.moduleSpecifier && !node.exportClause;
            case 279 /* NamespaceExport */ :
                return node.parent.isTypeOnly;
        }
        return false;
    }
    function isTypeOnlyImportOrExportDeclaration(node) {
        return isTypeOnlyImportDeclaration(node) || isTypeOnlyExportDeclaration(node);
    }
    function isAssertionKey(node) {
        return isStringLiteral(node) || isIdentifier(node);
    }
    function isStringTextContainingNode(node) {
        return node.kind === 11 /* StringLiteral */  || isTemplateLiteralKind(node.kind);
    }
    function isGeneratedIdentifier(node) {
        var _a;
        return isIdentifier(node) && ((_a = node.emitNode) == null ? void 0 : _a.autoGenerate) !== void 0;
    }
    function isGeneratedPrivateIdentifier(node) {
        var _a;
        return isPrivateIdentifier(node) && ((_a = node.emitNode) == null ? void 0 : _a.autoGenerate) !== void 0;
    }
    function isPrivateIdentifierClassElementDeclaration(node) {
        return (isPropertyDeclaration(node) || isMethodOrAccessor(node)) && isPrivateIdentifier(node.name);
    }
    function isPrivateIdentifierPropertyAccessExpression(node) {
        return isPropertyAccessExpression(node) && isPrivateIdentifier(node.name);
    }
    function isModifierKind(token) {
        switch(token){
            case 128 /* AbstractKeyword */ :
            case 129 /* AccessorKeyword */ :
            case 134 /* AsyncKeyword */ :
            case 87 /* ConstKeyword */ :
            case 138 /* DeclareKeyword */ :
            case 90 /* DefaultKeyword */ :
            case 95 /* ExportKeyword */ :
            case 103 /* InKeyword */ :
            case 125 /* PublicKeyword */ :
            case 123 /* PrivateKeyword */ :
            case 124 /* ProtectedKeyword */ :
            case 148 /* ReadonlyKeyword */ :
            case 126 /* StaticKeyword */ :
            case 147 /* OutKeyword */ :
            case 163 /* OverrideKeyword */ :
                return true;
        }
        return false;
    }
    function isParameterPropertyModifier(kind) {
        return !!(modifierToFlag(kind) & 16476 /* ParameterPropertyModifier */ );
    }
    function isClassMemberModifier(idToken) {
        return isParameterPropertyModifier(idToken) || idToken === 126 /* StaticKeyword */  || idToken === 163 /* OverrideKeyword */  || idToken === 129 /* AccessorKeyword */ ;
    }
    function isModifier(node) {
        return isModifierKind(node.kind);
    }
    function isEntityName(node) {
        const kind = node.kind;
        return kind === 165 /* QualifiedName */  || kind === 80 /* Identifier */ ;
    }
    function isPropertyName(node) {
        const kind = node.kind;
        return kind === 80 /* Identifier */  || kind === 81 /* PrivateIdentifier */  || kind === 11 /* StringLiteral */  || kind === 9 /* NumericLiteral */  || kind === 166 /* ComputedPropertyName */ ;
    }
    function isBindingName(node) {
        const kind = node.kind;
        return kind === 80 /* Identifier */  || kind === 205 /* ObjectBindingPattern */  || kind === 206 /* ArrayBindingPattern */ ;
    }
    function isFunctionLike(node) {
        return !!node && isFunctionLikeKind(node.kind);
    }
    function isFunctionLikeOrClassStaticBlockDeclaration(node) {
        return !!node && (isFunctionLikeKind(node.kind) || isClassStaticBlockDeclaration(node));
    }
    function isFunctionLikeDeclaration(node) {
        return node && isFunctionLikeDeclarationKind(node.kind);
    }
    function isBooleanLiteral(node) {
        return node.kind === 112 /* TrueKeyword */  || node.kind === 97 /* FalseKeyword */ ;
    }
    function isFunctionLikeDeclarationKind(kind) {
        switch(kind){
            case 261 /* FunctionDeclaration */ :
            case 173 /* MethodDeclaration */ :
            case 175 /* Constructor */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
                return true;
            default:
                return false;
        }
    }
    function isFunctionLikeKind(kind) {
        switch(kind){
            case 172 /* MethodSignature */ :
            case 178 /* CallSignature */ :
            case 329 /* JSDocSignature */ :
            case 179 /* ConstructSignature */ :
            case 180 /* IndexSignature */ :
            case 183 /* FunctionType */ :
            case 323 /* JSDocFunctionType */ :
            case 184 /* ConstructorType */ :
                return true;
            default:
                return isFunctionLikeDeclarationKind(kind);
        }
    }
    function isFunctionOrModuleBlock(node) {
        return isSourceFile(node) || isModuleBlock(node) || isBlock(node) && isFunctionLike(node.parent);
    }
    function isClassElement(node) {
        const kind = node.kind;
        return kind === 175 /* Constructor */  || kind === 171 /* PropertyDeclaration */  || kind === 173 /* MethodDeclaration */  || kind === 176 /* GetAccessor */  || kind === 177 /* SetAccessor */  || kind === 180 /* IndexSignature */  || kind === 174 /* ClassStaticBlockDeclaration */  || kind === 239 /* SemicolonClassElement */ ;
    }
    function isClassLike(node) {
        return node && (node.kind === 262 /* ClassDeclaration */  || node.kind === 230 /* ClassExpression */ );
    }
    function isAccessor(node) {
        return node && (node.kind === 176 /* GetAccessor */  || node.kind === 177 /* SetAccessor */ );
    }
    function isAutoAccessorPropertyDeclaration(node) {
        return isPropertyDeclaration(node) && hasAccessorModifier(node);
    }
    function isMethodOrAccessor(node) {
        switch(node.kind){
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
                return true;
            default:
                return false;
        }
    }
    function isNamedClassElement(node) {
        switch(node.kind){
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 171 /* PropertyDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function isModifierLike(node) {
        return isModifier(node) || isDecorator(node);
    }
    function isTypeElement(node) {
        const kind = node.kind;
        return kind === 179 /* ConstructSignature */  || kind === 178 /* CallSignature */  || kind === 170 /* PropertySignature */  || kind === 172 /* MethodSignature */  || kind === 180 /* IndexSignature */  || kind === 176 /* GetAccessor */  || kind === 177 /* SetAccessor */ ;
    }
    function isClassOrTypeElement(node) {
        return isTypeElement(node) || isClassElement(node);
    }
    function isObjectLiteralElementLike(node) {
        const kind = node.kind;
        return kind === 302 /* PropertyAssignment */  || kind === 303 /* ShorthandPropertyAssignment */  || kind === 304 /* SpreadAssignment */  || kind === 173 /* MethodDeclaration */  || kind === 176 /* GetAccessor */  || kind === 177 /* SetAccessor */ ;
    }
    function isTypeNode(node) {
        return isTypeNodeKind(node.kind);
    }
    function isFunctionOrConstructorTypeNode(node) {
        switch(node.kind){
            case 183 /* FunctionType */ :
            case 184 /* ConstructorType */ :
                return true;
        }
        return false;
    }
    function isBindingPattern(node) {
        if (node) {
            const kind = node.kind;
            return kind === 206 /* ArrayBindingPattern */  || kind === 205 /* ObjectBindingPattern */ ;
        }
        return false;
    }
    function isAssignmentPattern(node) {
        const kind = node.kind;
        return kind === 208 /* ArrayLiteralExpression */  || kind === 209 /* ObjectLiteralExpression */ ;
    }
    function isArrayBindingElement(node) {
        const kind = node.kind;
        return kind === 207 /* BindingElement */  || kind === 231 /* OmittedExpression */ ;
    }
    function isDeclarationBindingElement(bindingElement) {
        switch(bindingElement.kind){
            case 259 /* VariableDeclaration */ :
            case 168 /* Parameter */ :
            case 207 /* BindingElement */ :
                return true;
        }
        return false;
    }
    function isBindingOrAssignmentElement(node) {
        return isVariableDeclaration(node) || isParameter(node) || isObjectBindingOrAssignmentElement(node) || isArrayBindingOrAssignmentElement(node);
    }
    function isBindingOrAssignmentPattern(node) {
        return isObjectBindingOrAssignmentPattern(node) || isArrayBindingOrAssignmentPattern(node);
    }
    function isObjectBindingOrAssignmentPattern(node) {
        switch(node.kind){
            case 205 /* ObjectBindingPattern */ :
            case 209 /* ObjectLiteralExpression */ :
                return true;
        }
        return false;
    }
    function isObjectBindingOrAssignmentElement(node) {
        switch(node.kind){
            case 207 /* BindingElement */ :
            case 302 /* PropertyAssignment */ :
            case 303 /* ShorthandPropertyAssignment */ :
            case 304 /* SpreadAssignment */ :
                return true;
        }
        return false;
    }
    function isArrayBindingOrAssignmentPattern(node) {
        switch(node.kind){
            case 206 /* ArrayBindingPattern */ :
            case 208 /* ArrayLiteralExpression */ :
                return true;
        }
        return false;
    }
    function isArrayBindingOrAssignmentElement(node) {
        switch(node.kind){
            case 207 /* BindingElement */ :
            case 231 /* OmittedExpression */ :
            case 229 /* SpreadElement */ :
            case 208 /* ArrayLiteralExpression */ :
            case 209 /* ObjectLiteralExpression */ :
            case 80 /* Identifier */ :
            case 210 /* PropertyAccessExpression */ :
            case 211 /* ElementAccessExpression */ :
                return true;
        }
        return isAssignmentExpression(node, /*excludeCompoundAssignment*/ true);
    }
    function isPropertyAccessOrQualifiedNameOrImportTypeNode(node) {
        const kind = node.kind;
        return kind === 210 /* PropertyAccessExpression */  || kind === 165 /* QualifiedName */  || kind === 204 /* ImportType */ ;
    }
    function isPropertyAccessOrQualifiedName(node) {
        const kind = node.kind;
        return kind === 210 /* PropertyAccessExpression */  || kind === 165 /* QualifiedName */ ;
    }
    function isCallLikeExpression(node) {
        switch(node.kind){
            case 285 /* JsxOpeningElement */ :
            case 284 /* JsxSelfClosingElement */ :
            case 212 /* CallExpression */ :
            case 213 /* NewExpression */ :
            case 214 /* TaggedTemplateExpression */ :
            case 169 /* Decorator */ :
                return true;
            default:
                return false;
        }
    }
    function isCallOrNewExpression(node) {
        return node.kind === 212 /* CallExpression */  || node.kind === 213 /* NewExpression */ ;
    }
    function isTemplateLiteral(node) {
        const kind = node.kind;
        return kind === 227 /* TemplateExpression */  || kind === 15 /* NoSubstitutionTemplateLiteral */ ;
    }
    function isLeftHandSideExpression(node) {
        return isLeftHandSideExpressionKind(skipPartiallyEmittedExpressions(node).kind);
    }
    function isLeftHandSideExpressionKind(kind) {
        switch(kind){
            case 210 /* PropertyAccessExpression */ :
            case 211 /* ElementAccessExpression */ :
            case 213 /* NewExpression */ :
            case 212 /* CallExpression */ :
            case 283 /* JsxElement */ :
            case 284 /* JsxSelfClosingElement */ :
            case 287 /* JsxFragment */ :
            case 214 /* TaggedTemplateExpression */ :
            case 208 /* ArrayLiteralExpression */ :
            case 216 /* ParenthesizedExpression */ :
            case 209 /* ObjectLiteralExpression */ :
            case 230 /* ClassExpression */ :
            case 217 /* FunctionExpression */ :
            case 80 /* Identifier */ :
            case 81 /* PrivateIdentifier */ :
            case 14 /* RegularExpressionLiteral */ :
            case 9 /* NumericLiteral */ :
            case 10 /* BigIntLiteral */ :
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 227 /* TemplateExpression */ :
            case 97 /* FalseKeyword */ :
            case 106 /* NullKeyword */ :
            case 110 /* ThisKeyword */ :
            case 112 /* TrueKeyword */ :
            case 108 /* SuperKeyword */ :
            case 234 /* NonNullExpression */ :
            case 232 /* ExpressionWithTypeArguments */ :
            case 235 /* MetaProperty */ :
            case 102 /* ImportKeyword */ :
            case 281 /* MissingDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function isUnaryExpression(node) {
        return isUnaryExpressionKind(skipPartiallyEmittedExpressions(node).kind);
    }
    function isUnaryExpressionKind(kind) {
        switch(kind){
            case 223 /* PrefixUnaryExpression */ :
            case 224 /* PostfixUnaryExpression */ :
            case 219 /* DeleteExpression */ :
            case 220 /* TypeOfExpression */ :
            case 221 /* VoidExpression */ :
            case 222 /* AwaitExpression */ :
            case 215 /* TypeAssertionExpression */ :
                return true;
            default:
                return isLeftHandSideExpressionKind(kind);
        }
    }
    function isUnaryExpressionWithWrite(expr) {
        switch(expr.kind){
            case 224 /* PostfixUnaryExpression */ :
                return true;
            case 223 /* PrefixUnaryExpression */ :
                return expr.operator === 46 /* PlusPlusToken */  || expr.operator === 47 /* MinusMinusToken */ ;
            default:
                return false;
        }
    }
    function isLiteralTypeLiteral(node) {
        switch(node.kind){
            case 106 /* NullKeyword */ :
            case 112 /* TrueKeyword */ :
            case 97 /* FalseKeyword */ :
            case 223 /* PrefixUnaryExpression */ :
                return true;
            default:
                return isLiteralExpression(node);
        }
    }
    function isExpression(node) {
        return isExpressionKind(skipPartiallyEmittedExpressions(node).kind);
    }
    function isExpressionKind(kind) {
        switch(kind){
            case 226 /* ConditionalExpression */ :
            case 228 /* YieldExpression */ :
            case 218 /* ArrowFunction */ :
            case 225 /* BinaryExpression */ :
            case 229 /* SpreadElement */ :
            case 233 /* AsExpression */ :
            case 231 /* OmittedExpression */ :
            case 360 /* CommaListExpression */ :
            case 359 /* PartiallyEmittedExpression */ :
            case 237 /* SatisfiesExpression */ :
                return true;
            default:
                return isUnaryExpressionKind(kind);
        }
    }
    function isAssertionExpression(node) {
        const kind = node.kind;
        return kind === 215 /* TypeAssertionExpression */  || kind === 233 /* AsExpression */ ;
    }
    function isNotEmittedOrPartiallyEmittedNode(node) {
        return isNotEmittedStatement(node) || isPartiallyEmittedExpression(node);
    }
    function isIterationStatement(node, lookInLabeledStatements) {
        switch(node.kind){
            case 247 /* ForStatement */ :
            case 248 /* ForInStatement */ :
            case 249 /* ForOfStatement */ :
            case 245 /* DoStatement */ :
            case 246 /* WhileStatement */ :
                return true;
            case 255 /* LabeledStatement */ :
                return lookInLabeledStatements && isIterationStatement(node.statement, lookInLabeledStatements);
        }
        return false;
    }
    function isScopeMarker(node) {
        return isExportAssignment(node) || isExportDeclaration(node);
    }
    function hasScopeMarker(statements) {
        return some(statements, isScopeMarker);
    }
    function needsScopeMarker(result) {
        return !isAnyImportOrReExport(result) && !isExportAssignment(result) && !hasSyntacticModifier(result, 1 /* Export */ ) && !isAmbientModule(result);
    }
    function isExternalModuleIndicator(result) {
        return isAnyImportOrReExport(result) || isExportAssignment(result) || hasSyntacticModifier(result, 1 /* Export */ );
    }
    function isForInOrOfStatement(node) {
        return node.kind === 248 /* ForInStatement */  || node.kind === 249 /* ForOfStatement */ ;
    }
    function isConciseBody(node) {
        return isBlock(node) || isExpression(node);
    }
    function isFunctionBody(node) {
        return isBlock(node);
    }
    function isForInitializer(node) {
        return isVariableDeclarationList(node) || isExpression(node);
    }
    function isModuleBody(node) {
        const kind = node.kind;
        return kind === 267 /* ModuleBlock */  || kind === 266 /* ModuleDeclaration */  || kind === 80 /* Identifier */ ;
    }
    function isNamespaceBody(node) {
        const kind = node.kind;
        return kind === 267 /* ModuleBlock */  || kind === 266 /* ModuleDeclaration */ ;
    }
    function isJSDocNamespaceBody(node) {
        const kind = node.kind;
        return kind === 80 /* Identifier */  || kind === 266 /* ModuleDeclaration */ ;
    }
    function isNamedImportBindings(node) {
        const kind = node.kind;
        return kind === 274 /* NamedImports */  || kind === 273 /* NamespaceImport */ ;
    }
    function isModuleOrEnumDeclaration(node) {
        return node.kind === 266 /* ModuleDeclaration */  || node.kind === 265 /* EnumDeclaration */ ;
    }
    function canHaveSymbol(node) {
        switch(node.kind){
            case 218 /* ArrowFunction */ :
            case 225 /* BinaryExpression */ :
            case 207 /* BindingElement */ :
            case 212 /* CallExpression */ :
            case 178 /* CallSignature */ :
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
            case 174 /* ClassStaticBlockDeclaration */ :
            case 175 /* Constructor */ :
            case 184 /* ConstructorType */ :
            case 179 /* ConstructSignature */ :
            case 211 /* ElementAccessExpression */ :
            case 265 /* EnumDeclaration */ :
            case 305 /* EnumMember */ :
            case 276 /* ExportAssignment */ :
            case 277 /* ExportDeclaration */ :
            case 280 /* ExportSpecifier */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 183 /* FunctionType */ :
            case 176 /* GetAccessor */ :
            case 80 /* Identifier */ :
            case 272 /* ImportClause */ :
            case 270 /* ImportEqualsDeclaration */ :
            case 275 /* ImportSpecifier */ :
            case 180 /* IndexSignature */ :
            case 263 /* InterfaceDeclaration */ :
            case 344 /* JSDocCallbackTag */ :
            case 346 /* JSDocEnumTag */ :
            case 323 /* JSDocFunctionType */ :
            case 347 /* JSDocParameterTag */ :
            case 354 /* JSDocPropertyTag */ :
            case 329 /* JSDocSignature */ :
            case 352 /* JSDocTypedefTag */ :
            case 328 /* JSDocTypeLiteral */ :
            case 290 /* JsxAttribute */ :
            case 291 /* JsxAttributes */ :
            case 292 /* JsxSpreadAttribute */ :
            case 199 /* MappedType */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 266 /* ModuleDeclaration */ :
            case 201 /* NamedTupleMember */ :
            case 279 /* NamespaceExport */ :
            case 269 /* NamespaceExportDeclaration */ :
            case 273 /* NamespaceImport */ :
            case 213 /* NewExpression */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 9 /* NumericLiteral */ :
            case 209 /* ObjectLiteralExpression */ :
            case 168 /* Parameter */ :
            case 210 /* PropertyAccessExpression */ :
            case 302 /* PropertyAssignment */ :
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
            case 177 /* SetAccessor */ :
            case 303 /* ShorthandPropertyAssignment */ :
            case 311 /* SourceFile */ :
            case 304 /* SpreadAssignment */ :
            case 11 /* StringLiteral */ :
            case 264 /* TypeAliasDeclaration */ :
            case 186 /* TypeLiteral */ :
            case 167 /* TypeParameter */ :
            case 259 /* VariableDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function canHaveLocals(node) {
        switch(node.kind){
            case 218 /* ArrowFunction */ :
            case 240 /* Block */ :
            case 178 /* CallSignature */ :
            case 268 /* CaseBlock */ :
            case 298 /* CatchClause */ :
            case 174 /* ClassStaticBlockDeclaration */ :
            case 193 /* ConditionalType */ :
            case 175 /* Constructor */ :
            case 184 /* ConstructorType */ :
            case 179 /* ConstructSignature */ :
            case 247 /* ForStatement */ :
            case 248 /* ForInStatement */ :
            case 249 /* ForOfStatement */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 183 /* FunctionType */ :
            case 176 /* GetAccessor */ :
            case 180 /* IndexSignature */ :
            case 344 /* JSDocCallbackTag */ :
            case 346 /* JSDocEnumTag */ :
            case 323 /* JSDocFunctionType */ :
            case 329 /* JSDocSignature */ :
            case 352 /* JSDocTypedefTag */ :
            case 199 /* MappedType */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 266 /* ModuleDeclaration */ :
            case 177 /* SetAccessor */ :
            case 311 /* SourceFile */ :
            case 264 /* TypeAliasDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function isDeclarationKind(kind) {
        return kind === 218 /* ArrowFunction */  || kind === 207 /* BindingElement */  || kind === 262 /* ClassDeclaration */  || kind === 230 /* ClassExpression */  || kind === 174 /* ClassStaticBlockDeclaration */  || kind === 175 /* Constructor */  || kind === 265 /* EnumDeclaration */  || kind === 305 /* EnumMember */  || kind === 280 /* ExportSpecifier */  || kind === 261 /* FunctionDeclaration */  || kind === 217 /* FunctionExpression */  || kind === 176 /* GetAccessor */  || kind === 272 /* ImportClause */  || kind === 270 /* ImportEqualsDeclaration */  || kind === 275 /* ImportSpecifier */  || kind === 263 /* InterfaceDeclaration */  || kind === 290 /* JsxAttribute */  || kind === 173 /* MethodDeclaration */  || kind === 172 /* MethodSignature */  || kind === 266 /* ModuleDeclaration */  || kind === 269 /* NamespaceExportDeclaration */  || kind === 273 /* NamespaceImport */  || kind === 279 /* NamespaceExport */  || kind === 168 /* Parameter */  || kind === 302 /* PropertyAssignment */  || kind === 171 /* PropertyDeclaration */  || kind === 170 /* PropertySignature */  || kind === 177 /* SetAccessor */  || kind === 303 /* ShorthandPropertyAssignment */  || kind === 264 /* TypeAliasDeclaration */  || kind === 167 /* TypeParameter */  || kind === 259 /* VariableDeclaration */  || kind === 352 /* JSDocTypedefTag */  || kind === 344 /* JSDocCallbackTag */  || kind === 354 /* JSDocPropertyTag */ ;
    }
    function isDeclarationStatementKind(kind) {
        return kind === 261 /* FunctionDeclaration */  || kind === 281 /* MissingDeclaration */  || kind === 262 /* ClassDeclaration */  || kind === 263 /* InterfaceDeclaration */  || kind === 264 /* TypeAliasDeclaration */  || kind === 265 /* EnumDeclaration */  || kind === 266 /* ModuleDeclaration */  || kind === 271 /* ImportDeclaration */  || kind === 270 /* ImportEqualsDeclaration */  || kind === 277 /* ExportDeclaration */  || kind === 276 /* ExportAssignment */  || kind === 269 /* NamespaceExportDeclaration */ ;
    }
    function isStatementKindButNotDeclarationKind(kind) {
        return kind === 251 /* BreakStatement */  || kind === 250 /* ContinueStatement */  || kind === 258 /* DebuggerStatement */  || kind === 245 /* DoStatement */  || kind === 243 /* ExpressionStatement */  || kind === 241 /* EmptyStatement */  || kind === 248 /* ForInStatement */  || kind === 249 /* ForOfStatement */  || kind === 247 /* ForStatement */  || kind === 244 /* IfStatement */  || kind === 255 /* LabeledStatement */  || kind === 252 /* ReturnStatement */  || kind === 254 /* SwitchStatement */  || kind === 256 /* ThrowStatement */  || kind === 257 /* TryStatement */  || kind === 242 /* VariableStatement */  || kind === 246 /* WhileStatement */  || kind === 253 /* WithStatement */  || kind === 358 /* NotEmittedStatement */ ;
    }
    function isDeclaration(node) {
        if (node.kind === 167 /* TypeParameter */ ) return node.parent && node.parent.kind !== 351 /* JSDocTemplateTag */  || isInJSFile(node);
        return isDeclarationKind(node.kind);
    }
    function isDeclarationStatement(node) {
        return isDeclarationStatementKind(node.kind);
    }
    function isStatementButNotDeclaration(node) {
        return isStatementKindButNotDeclarationKind(node.kind);
    }
    function isStatement(node) {
        const kind = node.kind;
        return isStatementKindButNotDeclarationKind(kind) || isDeclarationStatementKind(kind) || isBlockStatement(node);
    }
    function isBlockStatement(node) {
        if (node.kind !== 240 /* Block */ ) return false;
        if (node.parent !== void 0) {
            if (node.parent.kind === 257 /* TryStatement */  || node.parent.kind === 298 /* CatchClause */ ) return false;
        }
        return !isFunctionBlock(node);
    }
    function isStatementOrBlock(node) {
        const kind = node.kind;
        return isStatementKindButNotDeclarationKind(kind) || isDeclarationStatementKind(kind) || kind === 240 /* Block */ ;
    }
    function isModuleReference(node) {
        const kind = node.kind;
        return kind === 282 /* ExternalModuleReference */  || kind === 165 /* QualifiedName */  || kind === 80 /* Identifier */ ;
    }
    function isJsxTagNameExpression(node) {
        const kind = node.kind;
        return kind === 110 /* ThisKeyword */  || kind === 80 /* Identifier */  || kind === 210 /* PropertyAccessExpression */  || kind === 294 /* JsxNamespacedName */ ;
    }
    function isJsxChild(node) {
        const kind = node.kind;
        return kind === 283 /* JsxElement */  || kind === 293 /* JsxExpression */  || kind === 284 /* JsxSelfClosingElement */  || kind === 12 /* JsxText */  || kind === 287 /* JsxFragment */ ;
    }
    function isJsxAttributeLike(node) {
        const kind = node.kind;
        return kind === 290 /* JsxAttribute */  || kind === 292 /* JsxSpreadAttribute */ ;
    }
    function isStringLiteralOrJsxExpression(node) {
        const kind = node.kind;
        return kind === 11 /* StringLiteral */  || kind === 293 /* JsxExpression */ ;
    }
    function isJsxOpeningLikeElement(node) {
        const kind = node.kind;
        return kind === 285 /* JsxOpeningElement */  || kind === 284 /* JsxSelfClosingElement */ ;
    }
    function isCaseOrDefaultClause(node) {
        const kind = node.kind;
        return kind === 295 /* CaseClause */  || kind === 296 /* DefaultClause */ ;
    }
    function isJSDocNode(node) {
        return node.kind >= 315 /* FirstJSDocNode */  && node.kind <= 356 /* LastJSDocNode */ ;
    }
    function isJSDocCommentContainingNode(node) {
        return node.kind === 326 /* JSDoc */  || node.kind === 325 /* JSDocNamepathType */  || node.kind === 327 /* JSDocText */  || isJSDocLinkLike(node) || isJSDocTag(node) || isJSDocTypeLiteral(node) || isJSDocSignature(node);
    }
    function isJSDocTag(node) {
        return node.kind >= 333 /* FirstJSDocTagNode */  && node.kind <= 356 /* LastJSDocTagNode */ ;
    }
    function isSetAccessor(node) {
        return node.kind === 177 /* SetAccessor */ ;
    }
    function isGetAccessor(node) {
        return node.kind === 176 /* GetAccessor */ ;
    }
    function hasJSDocNodes(node) {
        if (!canHaveJSDoc(node)) return false;
        const { jsDoc: jsDoc  } = node;
        return !!jsDoc && jsDoc.length > 0;
    }
    function hasType(node) {
        return !!node.type;
    }
    function hasInitializer(node) {
        return !!node.initializer;
    }
    function hasOnlyExpressionInitializer(node) {
        switch(node.kind){
            case 259 /* VariableDeclaration */ :
            case 168 /* Parameter */ :
            case 207 /* BindingElement */ :
            case 171 /* PropertyDeclaration */ :
            case 302 /* PropertyAssignment */ :
            case 305 /* EnumMember */ :
                return true;
            default:
                return false;
        }
    }
    function isObjectLiteralElement(node) {
        return node.kind === 290 /* JsxAttribute */  || node.kind === 292 /* JsxSpreadAttribute */  || isObjectLiteralElementLike(node);
    }
    function isTypeReferenceType(node) {
        return node.kind === 182 /* TypeReference */  || node.kind === 232 /* ExpressionWithTypeArguments */ ;
    }
    function guessIndentation(lines) {
        let indentation = MAX_SMI_X86;
        for (const line of lines){
            if (!line.length) continue;
            let i = 0;
            for(; i < line.length && i < indentation; i++){
                if (!isWhiteSpaceLike(line.charCodeAt(i))) break;
            }
            if (i < indentation) indentation = i;
            if (indentation === 0) return 0;
        }
        return indentation === MAX_SMI_X86 ? void 0 : indentation;
    }
    function isStringLiteralLike(node) {
        return node.kind === 11 /* StringLiteral */  || node.kind === 15 /* NoSubstitutionTemplateLiteral */ ;
    }
    function isJSDocLinkLike(node) {
        return node.kind === 330 /* JSDocLink */  || node.kind === 331 /* JSDocLinkCode */  || node.kind === 332 /* JSDocLinkPlain */ ;
    }
    function hasRestParameter(s) {
        const last2 = lastOrUndefined(s.parameters);
        return !!last2 && isRestParameter(last2);
    }
    function isRestParameter(node) {
        const type = isJSDocParameterTag(node) ? node.typeExpression && node.typeExpression.type : node.type;
        return node.dotDotDotToken !== void 0 || !!type && type.kind === 324 /* JSDocVariadicType */ ;
    }
    var unchangedTextChangeRange, supportedLocaleDirectories, MAX_SMI_X86;
    var init_utilitiesPublic = __esm({
        "src/compiler/utilitiesPublic.ts" () {
            "use strict";
            init_ts2();
            unchangedTextChangeRange = createTextChangeRange(createTextSpan(0, 0), 0);
            supportedLocaleDirectories = [
                "cs",
                "de",
                "es",
                "fr",
                "it",
                "ja",
                "ko",
                "pl",
                "pt-br",
                "ru",
                "tr",
                "zh-cn",
                "zh-tw"
            ];
            MAX_SMI_X86 = 1073741823;
        }
    });
    // src/compiler/utilities.ts
    function getDeclarationOfKind(symbol, kind) {
        const declarations = symbol.declarations;
        if (declarations) for (const declaration of declarations){
            if (declaration.kind === kind) return declaration;
        }
        return void 0;
    }
    function getDeclarationsOfKind(symbol, kind) {
        return filter(symbol.declarations || emptyArray, (d)=>d.kind === kind);
    }
    function createSymbolTable(symbols) {
        const result = /* @__PURE__ */ new Map();
        if (symbols) for (const symbol of symbols)result.set(symbol.escapedName, symbol);
        return result;
    }
    function isTransientSymbol(symbol) {
        return (symbol.flags & 33554432 /* Transient */ ) !== 0;
    }
    function createSingleLineStringWriter() {
        var str = "";
        const writeText = (text)=>str += text;
        return {
            getText: ()=>str,
            write: writeText,
            rawWrite: writeText,
            writeKeyword: writeText,
            writeOperator: writeText,
            writePunctuation: writeText,
            writeSpace: writeText,
            writeStringLiteral: writeText,
            writeLiteral: writeText,
            writeParameter: writeText,
            writeProperty: writeText,
            writeSymbol: (s, _)=>writeText(s),
            writeTrailingSemicolon: writeText,
            writeComment: writeText,
            getTextPos: ()=>str.length,
            getLine: ()=>0,
            getColumn: ()=>0,
            getIndent: ()=>0,
            isAtStartOfLine: ()=>false,
            hasTrailingComment: ()=>false,
            hasTrailingWhitespace: ()=>!!str.length && isWhiteSpaceLike(str.charCodeAt(str.length - 1)),
            // Completely ignore indentation for string writers.  And map newlines to
            // a single space.
            writeLine: ()=>str += " ",
            increaseIndent: noop,
            decreaseIndent: noop,
            clear: ()=>str = ""
        };
    }
    function changesAffectModuleResolution(oldOptions, newOptions) {
        return oldOptions.configFilePath !== newOptions.configFilePath || optionsHaveModuleResolutionChanges(oldOptions, newOptions);
    }
    function optionsHaveModuleResolutionChanges(oldOptions, newOptions) {
        return optionsHaveChanges(oldOptions, newOptions, moduleResolutionOptionDeclarations);
    }
    function changesAffectingProgramStructure(oldOptions, newOptions) {
        return optionsHaveChanges(oldOptions, newOptions, optionsAffectingProgramStructure);
    }
    function optionsHaveChanges(oldOptions, newOptions, optionDeclarations2) {
        return oldOptions !== newOptions && optionDeclarations2.some((o)=>!isJsonEqual(getCompilerOptionValue(oldOptions, o), getCompilerOptionValue(newOptions, o)));
    }
    function forEachAncestor(node, callback) {
        while(true){
            const res = callback(node);
            if (res === "quit") return void 0;
            if (res !== void 0) return res;
            if (isSourceFile(node)) return void 0;
            node = node.parent;
        }
    }
    function forEachEntry(map2, callback) {
        const iterator = map2.entries();
        for (const [key, value1] of iterator){
            const result = callback(value1, key);
            if (result) return result;
        }
        return void 0;
    }
    function forEachKey(map2, callback) {
        const iterator = map2.keys();
        for (const key of iterator){
            const result = callback(key);
            if (result) return result;
        }
        return void 0;
    }
    function copyEntries(source, target) {
        source.forEach((value1, key)=>{
            target.set(key, value1);
        });
    }
    function usingSingleLineStringWriter(action) {
        const oldString = stringWriter.getText();
        try {
            action(stringWriter);
            return stringWriter.getText();
        } finally{
            stringWriter.clear();
            stringWriter.writeKeyword(oldString);
        }
    }
    function getFullWidth(node) {
        return node.end - node.pos;
    }
    function getResolvedModule(sourceFile, moduleNameText, mode) {
        var _a, _b;
        return (_b = (_a = sourceFile == null ? void 0 : sourceFile.resolvedModules) == null ? void 0 : _a.get(moduleNameText, mode)) == null ? void 0 : _b.resolvedModule;
    }
    function setResolvedModule(sourceFile, moduleNameText, resolvedModule, mode) {
        if (!sourceFile.resolvedModules) sourceFile.resolvedModules = createModeAwareCache();
        sourceFile.resolvedModules.set(moduleNameText, mode, resolvedModule);
    }
    function setResolvedTypeReferenceDirective(sourceFile, typeReferenceDirectiveName, resolvedTypeReferenceDirective, mode) {
        if (!sourceFile.resolvedTypeReferenceDirectiveNames) sourceFile.resolvedTypeReferenceDirectiveNames = createModeAwareCache();
        sourceFile.resolvedTypeReferenceDirectiveNames.set(typeReferenceDirectiveName, mode, resolvedTypeReferenceDirective);
    }
    function getResolvedTypeReferenceDirective(sourceFile, typeReferenceDirectiveName, mode) {
        var _a, _b;
        return (_b = (_a = sourceFile == null ? void 0 : sourceFile.resolvedTypeReferenceDirectiveNames) == null ? void 0 : _a.get(typeReferenceDirectiveName, mode)) == null ? void 0 : _b.resolvedTypeReferenceDirective;
    }
    function projectReferenceIsEqualTo(oldRef, newRef) {
        return oldRef.path === newRef.path && !oldRef.prepend === !newRef.prepend && !oldRef.circular === !newRef.circular;
    }
    function moduleResolutionIsEqualTo(oldResolution, newResolution) {
        return oldResolution === newResolution || oldResolution.resolvedModule === newResolution.resolvedModule || !!oldResolution.resolvedModule && !!newResolution.resolvedModule && oldResolution.resolvedModule.isExternalLibraryImport === newResolution.resolvedModule.isExternalLibraryImport && oldResolution.resolvedModule.extension === newResolution.resolvedModule.extension && oldResolution.resolvedModule.resolvedFileName === newResolution.resolvedModule.resolvedFileName && oldResolution.resolvedModule.originalPath === newResolution.resolvedModule.originalPath && packageIdIsEqual(oldResolution.resolvedModule.packageId, newResolution.resolvedModule.packageId) && oldResolution.node10Result === newResolution.node10Result;
    }
    function createModuleNotFoundChain(sourceFile, host, moduleReference, mode, packageName) {
        var _a, _b;
        const node10Result = (_b = (_a = sourceFile.resolvedModules) == null ? void 0 : _a.get(moduleReference, mode)) == null ? void 0 : _b.node10Result;
        const result = node10Result ? chainDiagnosticMessages(/*details*/ void 0, Diagnostics.There_are_types_at_0_but_this_result_could_not_be_resolved_when_respecting_package_json_exports_The_1_library_may_need_to_update_its_package_json_or_typings, node10Result, node10Result.indexOf(nodeModulesPathPart + "@types/") > -1 ? `@types/${mangleScopedPackageName(packageName)}` : packageName) : host.typesPackageExists(packageName) ? chainDiagnosticMessages(/*details*/ void 0, Diagnostics.If_the_0_package_actually_exposes_this_module_consider_sending_a_pull_request_to_amend_https_Colon_Slash_Slashgithub_com_SlashDefinitelyTyped_SlashDefinitelyTyped_Slashtree_Slashmaster_Slashtypes_Slash_1, packageName, mangleScopedPackageName(packageName)) : host.packageBundlesTypes(packageName) ? chainDiagnosticMessages(/*details*/ void 0, Diagnostics.If_the_0_package_actually_exposes_this_module_try_adding_a_new_declaration_d_ts_file_containing_declare_module_1, packageName, moduleReference) : chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Try_npm_i_save_dev_types_Slash_1_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare_module_0, moduleReference, mangleScopedPackageName(packageName));
        if (result) result.repopulateInfo = ()=>({
                moduleReference: moduleReference,
                mode: mode,
                packageName: packageName === moduleReference ? void 0 : packageName
            });
        return result;
    }
    function packageIdIsEqual(a, b) {
        return a === b || !!a && !!b && a.name === b.name && a.subModuleName === b.subModuleName && a.version === b.version;
    }
    function packageIdToPackageName({ name: name , subModuleName: subModuleName  }) {
        return subModuleName ? `${name}/${subModuleName}` : name;
    }
    function packageIdToString(packageId) {
        return `${packageIdToPackageName(packageId)}@${packageId.version}`;
    }
    function typeDirectiveIsEqualTo(oldResolution, newResolution) {
        return oldResolution === newResolution || oldResolution.resolvedTypeReferenceDirective === newResolution.resolvedTypeReferenceDirective || !!oldResolution.resolvedTypeReferenceDirective && !!newResolution.resolvedTypeReferenceDirective && oldResolution.resolvedTypeReferenceDirective.resolvedFileName === newResolution.resolvedTypeReferenceDirective.resolvedFileName && !!oldResolution.resolvedTypeReferenceDirective.primary === !!newResolution.resolvedTypeReferenceDirective.primary && oldResolution.resolvedTypeReferenceDirective.originalPath === newResolution.resolvedTypeReferenceDirective.originalPath;
    }
    function hasChangesInResolutions(names, newSourceFile, newResolutions, oldResolutions, comparer, nameAndModeGetter) {
        Debug.assert(names.length === newResolutions.length);
        for(let i = 0; i < names.length; i++){
            const newResolution = newResolutions[i];
            const entry = names[i];
            const name = nameAndModeGetter.getName(entry);
            const mode = nameAndModeGetter.getMode(entry, newSourceFile);
            const oldResolution = oldResolutions && oldResolutions.get(name, mode);
            const changed = oldResolution ? !newResolution || !comparer(oldResolution, newResolution) : newResolution;
            if (changed) return true;
        }
        return false;
    }
    function containsParseError(node) {
        aggregateChildData(node);
        return (node.flags & 524288 /* ThisNodeOrAnySubNodesHasError */ ) !== 0;
    }
    function aggregateChildData(node) {
        if (!(node.flags & 1048576 /* HasAggregatedChildData */ )) {
            const thisNodeOrAnySubNodesHasError = (node.flags & 131072 /* ThisNodeHasError */ ) !== 0 || forEachChild(node, containsParseError);
            if (thisNodeOrAnySubNodesHasError) node.flags |= 524288 /* ThisNodeOrAnySubNodesHasError */ ;
            node.flags |= 1048576 /* HasAggregatedChildData */ ;
        }
    }
    function getSourceFileOfNode(node) {
        while(node && node.kind !== 311 /* SourceFile */ )node = node.parent;
        return node;
    }
    function getSourceFileOfModule(module2) {
        return getSourceFileOfNode(module2.valueDeclaration || getNonAugmentationDeclaration(module2));
    }
    function isPlainJsFile(file, checkJs) {
        return !!file && (file.scriptKind === 1 /* JS */  || file.scriptKind === 2 /* JSX */ ) && !file.checkJsDirective && checkJs === void 0;
    }
    function isStatementWithLocals(node) {
        switch(node.kind){
            case 240 /* Block */ :
            case 268 /* CaseBlock */ :
            case 247 /* ForStatement */ :
            case 248 /* ForInStatement */ :
            case 249 /* ForOfStatement */ :
                return true;
        }
        return false;
    }
    function getStartPositionOfLine(line, sourceFile) {
        Debug.assert(line >= 0);
        return getLineStarts(sourceFile)[line];
    }
    function nodePosToString(node) {
        const file = getSourceFileOfNode(node);
        const loc = getLineAndCharacterOfPosition(file, node.pos);
        return `${file.fileName}(${loc.line + 1},${loc.character + 1})`;
    }
    function getEndLinePosition(line, sourceFile) {
        Debug.assert(line >= 0);
        const lineStarts = getLineStarts(sourceFile);
        const lineIndex = line;
        const sourceText = sourceFile.text;
        if (lineIndex + 1 === lineStarts.length) return sourceText.length - 1;
        else {
            const start = lineStarts[lineIndex];
            let pos = lineStarts[lineIndex + 1] - 1;
            Debug.assert(isLineBreak(sourceText.charCodeAt(pos)));
            while(start <= pos && isLineBreak(sourceText.charCodeAt(pos)))pos--;
            return pos;
        }
    }
    function isFileLevelUniqueName(sourceFile, name, hasGlobalName) {
        return !(hasGlobalName && hasGlobalName(name)) && !sourceFile.identifiers.has(name);
    }
    function nodeIsMissing(node) {
        if (node === void 0) return true;
        return node.pos === node.end && node.pos >= 0 && node.kind !== 1 /* EndOfFileToken */ ;
    }
    function nodeIsPresent(node) {
        return !nodeIsMissing(node);
    }
    function isGrammarError(parent2, child) {
        if (isTypeParameterDeclaration(parent2)) return child === parent2.expression;
        if (isClassStaticBlockDeclaration(parent2)) return child === parent2.modifiers;
        if (isPropertySignature(parent2)) return child === parent2.initializer;
        if (isPropertyDeclaration(parent2)) return child === parent2.questionToken && isAutoAccessorPropertyDeclaration(parent2);
        if (isPropertyAssignment(parent2)) return child === parent2.modifiers || child === parent2.questionToken || child === parent2.exclamationToken || isGrammarErrorElement(parent2.modifiers, child, isModifierLike);
        if (isShorthandPropertyAssignment(parent2)) return child === parent2.equalsToken || child === parent2.modifiers || child === parent2.questionToken || child === parent2.exclamationToken || isGrammarErrorElement(parent2.modifiers, child, isModifierLike);
        if (isMethodDeclaration(parent2)) return child === parent2.exclamationToken;
        if (isConstructorDeclaration(parent2)) return child === parent2.typeParameters || child === parent2.type || isGrammarErrorElement(parent2.typeParameters, child, isTypeParameterDeclaration);
        if (isGetAccessorDeclaration(parent2)) return child === parent2.typeParameters || isGrammarErrorElement(parent2.typeParameters, child, isTypeParameterDeclaration);
        if (isSetAccessorDeclaration(parent2)) return child === parent2.typeParameters || child === parent2.type || isGrammarErrorElement(parent2.typeParameters, child, isTypeParameterDeclaration);
        if (isNamespaceExportDeclaration(parent2)) return child === parent2.modifiers || isGrammarErrorElement(parent2.modifiers, child, isModifierLike);
        return false;
    }
    function isGrammarErrorElement(nodeArray, child, isElement) {
        if (!nodeArray || isArray(child) || !isElement(child)) return false;
        return contains(nodeArray, child);
    }
    function insertStatementsAfterPrologue(to, from, isPrologueDirective2) {
        if (from === void 0 || from.length === 0) return to;
        let statementIndex = 0;
        for(; statementIndex < to.length; ++statementIndex){
            if (!isPrologueDirective2(to[statementIndex])) break;
        }
        to.splice(statementIndex, 0, ...from);
        return to;
    }
    function insertStatementAfterPrologue(to, statement, isPrologueDirective2) {
        if (statement === void 0) return to;
        let statementIndex = 0;
        for(; statementIndex < to.length; ++statementIndex){
            if (!isPrologueDirective2(to[statementIndex])) break;
        }
        to.splice(statementIndex, 0, statement);
        return to;
    }
    function isAnyPrologueDirective(node) {
        return isPrologueDirective(node) || !!(getEmitFlags(node) & 2097152 /* CustomPrologue */ );
    }
    function insertStatementsAfterStandardPrologue(to, from) {
        return insertStatementsAfterPrologue(to, from, isPrologueDirective);
    }
    function insertStatementsAfterCustomPrologue(to, from) {
        return insertStatementsAfterPrologue(to, from, isAnyPrologueDirective);
    }
    function insertStatementAfterStandardPrologue(to, statement) {
        return insertStatementAfterPrologue(to, statement, isPrologueDirective);
    }
    function insertStatementAfterCustomPrologue(to, statement) {
        return insertStatementAfterPrologue(to, statement, isAnyPrologueDirective);
    }
    function isRecognizedTripleSlashComment(text, commentPos, commentEnd) {
        if (text.charCodeAt(commentPos + 1) === 47 /* slash */  && commentPos + 2 < commentEnd && text.charCodeAt(commentPos + 2) === 47 /* slash */ ) {
            const textSubStr = text.substring(commentPos, commentEnd);
            return fullTripleSlashReferencePathRegEx.test(textSubStr) || fullTripleSlashAMDReferencePathRegEx.test(textSubStr) || fullTripleSlashAMDModuleRegEx.test(textSubStr) || fullTripleSlashReferenceTypeReferenceDirectiveRegEx.test(textSubStr) || fullTripleSlashLibReferenceRegEx.test(textSubStr) || defaultLibReferenceRegEx.test(textSubStr) ? true : false;
        }
        return false;
    }
    function isPinnedComment(text, start) {
        return text.charCodeAt(start + 1) === 42 /* asterisk */  && text.charCodeAt(start + 2) === 33 /* exclamation */ ;
    }
    function createCommentDirectivesMap(sourceFile, commentDirectives) {
        const directivesByLine = new Map(commentDirectives.map((commentDirective)=>[
                `${getLineAndCharacterOfPosition(sourceFile, commentDirective.range.end).line}`,
                commentDirective
            ]));
        const usedLines = /* @__PURE__ */ new Map();
        return {
            getUnusedExpectations: getUnusedExpectations,
            markUsed: markUsed
        };
        function getUnusedExpectations() {
            return arrayFrom(directivesByLine.entries()).filter(([line, directive])=>directive.type === 0 /* ExpectError */  && !usedLines.get(line)).map(([_, directive])=>directive);
        }
        function markUsed(line) {
            if (!directivesByLine.has(`${line}`)) return false;
            usedLines.set(`${line}`, true);
            return true;
        }
    }
    function getTokenPosOfNode(node, sourceFile, includeJsDoc) {
        if (nodeIsMissing(node)) return node.pos;
        if (isJSDocNode(node) || node.kind === 12 /* JsxText */ ) return skipTrivia((sourceFile || getSourceFileOfNode(node)).text, node.pos, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
        if (includeJsDoc && hasJSDocNodes(node)) return getTokenPosOfNode(node.jsDoc[0], sourceFile);
        if (node.kind === 357 /* SyntaxList */  && node._children.length > 0) return getTokenPosOfNode(node._children[0], sourceFile, includeJsDoc);
        return skipTrivia((sourceFile || getSourceFileOfNode(node)).text, node.pos, /*stopAfterLineBreak*/ false, /*stopAtComments*/ false, isInJSDoc(node));
    }
    function getNonDecoratorTokenPosOfNode(node, sourceFile) {
        const lastDecorator = !nodeIsMissing(node) && canHaveModifiers(node) ? findLast(node.modifiers, isDecorator) : void 0;
        if (!lastDecorator) return getTokenPosOfNode(node, sourceFile);
        return skipTrivia((sourceFile || getSourceFileOfNode(node)).text, lastDecorator.end);
    }
    function getSourceTextOfNodeFromSourceFile(sourceFile, node, includeTrivia = false) {
        return getTextOfNodeFromSourceText(sourceFile.text, node, includeTrivia);
    }
    function isJSDocTypeExpressionOrChild(node) {
        return !!findAncestor(node, isJSDocTypeExpression);
    }
    function isExportNamespaceAsDefaultDeclaration(node) {
        return !!(isExportDeclaration(node) && node.exportClause && isNamespaceExport(node.exportClause) && node.exportClause.name.escapedText === "default");
    }
    function getTextOfNodeFromSourceText(sourceText, node, includeTrivia = false) {
        if (nodeIsMissing(node)) return "";
        let text = sourceText.substring(includeTrivia ? node.pos : skipTrivia(sourceText, node.pos), node.end);
        if (isJSDocTypeExpressionOrChild(node)) text = text.split(/\r\n|\n|\r/).map((line)=>trimStringStart(line.replace(/^\s*\*/, ""))).join("\n");
        return text;
    }
    function getTextOfNode(node, includeTrivia = false) {
        return getSourceTextOfNodeFromSourceFile(getSourceFileOfNode(node), node, includeTrivia);
    }
    function getPos(range) {
        return range.pos;
    }
    function indexOfNode(nodeArray, node) {
        return binarySearch(nodeArray, node, getPos, compareValues);
    }
    function getEmitFlags(node) {
        const emitNode = node.emitNode;
        return emitNode && emitNode.flags || 0;
    }
    function getInternalEmitFlags(node) {
        const emitNode = node.emitNode;
        return emitNode && emitNode.internalFlags || 0;
    }
    function getScriptTargetFeatures() {
        return new Map(Object.entries({
            Array: new Map(Object.entries({
                es2015: [
                    "find",
                    "findIndex",
                    "fill",
                    "copyWithin",
                    "entries",
                    "keys",
                    "values"
                ],
                es2016: [
                    "includes"
                ],
                es2019: [
                    "flat",
                    "flatMap"
                ],
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            Iterator: new Map(Object.entries({
                es2015: emptyArray
            })),
            AsyncIterator: new Map(Object.entries({
                es2015: emptyArray
            })),
            Atomics: new Map(Object.entries({
                es2017: emptyArray
            })),
            SharedArrayBuffer: new Map(Object.entries({
                es2017: emptyArray
            })),
            AsyncIterable: new Map(Object.entries({
                es2018: emptyArray
            })),
            AsyncIterableIterator: new Map(Object.entries({
                es2018: emptyArray
            })),
            AsyncGenerator: new Map(Object.entries({
                es2018: emptyArray
            })),
            AsyncGeneratorFunction: new Map(Object.entries({
                es2018: emptyArray
            })),
            RegExp: new Map(Object.entries({
                es2015: [
                    "flags",
                    "sticky",
                    "unicode"
                ],
                es2018: [
                    "dotAll"
                ]
            })),
            Reflect: new Map(Object.entries({
                es2015: [
                    "apply",
                    "construct",
                    "defineProperty",
                    "deleteProperty",
                    "get",
                    " getOwnPropertyDescriptor",
                    "getPrototypeOf",
                    "has",
                    "isExtensible",
                    "ownKeys",
                    "preventExtensions",
                    "set",
                    "setPrototypeOf"
                ]
            })),
            ArrayConstructor: new Map(Object.entries({
                es2015: [
                    "from",
                    "of"
                ]
            })),
            ObjectConstructor: new Map(Object.entries({
                es2015: [
                    "assign",
                    "getOwnPropertySymbols",
                    "keys",
                    "is",
                    "setPrototypeOf"
                ],
                es2017: [
                    "values",
                    "entries",
                    "getOwnPropertyDescriptors"
                ],
                es2019: [
                    "fromEntries"
                ],
                es2022: [
                    "hasOwn"
                ]
            })),
            NumberConstructor: new Map(Object.entries({
                es2015: [
                    "isFinite",
                    "isInteger",
                    "isNaN",
                    "isSafeInteger",
                    "parseFloat",
                    "parseInt"
                ]
            })),
            Math: new Map(Object.entries({
                es2015: [
                    "clz32",
                    "imul",
                    "sign",
                    "log10",
                    "log2",
                    "log1p",
                    "expm1",
                    "cosh",
                    "sinh",
                    "tanh",
                    "acosh",
                    "asinh",
                    "atanh",
                    "hypot",
                    "trunc",
                    "fround",
                    "cbrt"
                ]
            })),
            Map: new Map(Object.entries({
                es2015: [
                    "entries",
                    "keys",
                    "values"
                ]
            })),
            Set: new Map(Object.entries({
                es2015: [
                    "entries",
                    "keys",
                    "values"
                ]
            })),
            PromiseConstructor: new Map(Object.entries({
                es2015: [
                    "all",
                    "race",
                    "reject",
                    "resolve"
                ],
                es2020: [
                    "allSettled"
                ],
                es2021: [
                    "any"
                ]
            })),
            Symbol: new Map(Object.entries({
                es2015: [
                    "for",
                    "keyFor"
                ],
                es2019: [
                    "description"
                ]
            })),
            WeakMap: new Map(Object.entries({
                es2015: [
                    "entries",
                    "keys",
                    "values"
                ]
            })),
            WeakSet: new Map(Object.entries({
                es2015: [
                    "entries",
                    "keys",
                    "values"
                ]
            })),
            String: new Map(Object.entries({
                es2015: [
                    "codePointAt",
                    "includes",
                    "endsWith",
                    "normalize",
                    "repeat",
                    "startsWith",
                    "anchor",
                    "big",
                    "blink",
                    "bold",
                    "fixed",
                    "fontcolor",
                    "fontsize",
                    "italics",
                    "link",
                    "small",
                    "strike",
                    "sub",
                    "sup"
                ],
                es2017: [
                    "padStart",
                    "padEnd"
                ],
                es2019: [
                    "trimStart",
                    "trimEnd",
                    "trimLeft",
                    "trimRight"
                ],
                es2020: [
                    "matchAll"
                ],
                es2021: [
                    "replaceAll"
                ],
                es2022: [
                    "at"
                ]
            })),
            StringConstructor: new Map(Object.entries({
                es2015: [
                    "fromCodePoint",
                    "raw"
                ]
            })),
            DateTimeFormat: new Map(Object.entries({
                es2017: [
                    "formatToParts"
                ]
            })),
            Promise: new Map(Object.entries({
                es2015: emptyArray,
                es2018: [
                    "finally"
                ]
            })),
            RegExpMatchArray: new Map(Object.entries({
                es2018: [
                    "groups"
                ]
            })),
            RegExpExecArray: new Map(Object.entries({
                es2018: [
                    "groups"
                ]
            })),
            Intl: new Map(Object.entries({
                es2018: [
                    "PluralRules"
                ]
            })),
            NumberFormat: new Map(Object.entries({
                es2018: [
                    "formatToParts"
                ]
            })),
            SymbolConstructor: new Map(Object.entries({
                es2020: [
                    "matchAll"
                ]
            })),
            DataView: new Map(Object.entries({
                es2020: [
                    "setBigInt64",
                    "setBigUint64",
                    "getBigInt64",
                    "getBigUint64"
                ]
            })),
            BigInt: new Map(Object.entries({
                es2020: emptyArray
            })),
            RelativeTimeFormat: new Map(Object.entries({
                es2020: [
                    "format",
                    "formatToParts",
                    "resolvedOptions"
                ]
            })),
            Int8Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            Uint8Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            Uint8ClampedArray: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            Int16Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            Uint16Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            Int32Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            Uint32Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            Float32Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            Float64Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            BigInt64Array: new Map(Object.entries({
                es2020: emptyArray,
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            BigUint64Array: new Map(Object.entries({
                es2020: emptyArray,
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast"
                ]
            })),
            Error: new Map(Object.entries({
                es2022: [
                    "cause"
                ]
            }))
        }));
    }
    function getLiteralText(node, sourceFile, flags) {
        if (sourceFile && canUseOriginalText(node, flags)) return getSourceTextOfNodeFromSourceFile(sourceFile, node);
        switch(node.kind){
            case 11 /* StringLiteral */ :
                {
                    const escapeText = flags & 2 /* JsxAttributeEscape */  ? escapeJsxAttributeString : flags & 1 /* NeverAsciiEscape */  || getEmitFlags(node) & 16777216 /* NoAsciiEscaping */  ? escapeString : escapeNonAsciiString;
                    if (node.singleQuote) return "'" + escapeText(node.text, 39 /* singleQuote */ ) + "'";
                    else return '"' + escapeText(node.text, 34 /* doubleQuote */ ) + '"';
                }
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 16 /* TemplateHead */ :
            case 17 /* TemplateMiddle */ :
            case 18 /* TemplateTail */ :
                {
                    const escapeText = flags & 1 /* NeverAsciiEscape */  || getEmitFlags(node) & 16777216 /* NoAsciiEscaping */  ? escapeString : escapeNonAsciiString;
                    const rawText = node.rawText ?? escapeTemplateSubstitution(escapeText(node.text, 96 /* backtick */ ));
                    switch(node.kind){
                        case 15 /* NoSubstitutionTemplateLiteral */ :
                            return "`" + rawText + "`";
                        case 16 /* TemplateHead */ :
                            return "`" + rawText + "${";
                        case 17 /* TemplateMiddle */ :
                            return "}" + rawText + "${";
                        case 18 /* TemplateTail */ :
                            return "}" + rawText + "`";
                    }
                    break;
                }
            case 9 /* NumericLiteral */ :
            case 10 /* BigIntLiteral */ :
                return node.text;
            case 14 /* RegularExpressionLiteral */ :
                if (flags & 4 /* TerminateUnterminatedLiterals */  && node.isUnterminated) return node.text + (node.text.charCodeAt(node.text.length - 1) === 92 /* backslash */  ? " /" : "/");
                return node.text;
        }
        return Debug.fail(`Literal kind '${node.kind}' not accounted for.`);
    }
    function canUseOriginalText(node, flags) {
        if (nodeIsSynthesized(node) || !node.parent || flags & 4 /* TerminateUnterminatedLiterals */  && node.isUnterminated) return false;
        if (isNumericLiteral(node)) {
            if (node.numericLiteralFlags & 26656 /* IsInvalid */ ) return false;
            if (node.numericLiteralFlags & 512 /* ContainsSeparator */ ) return !!(flags & 8 /* AllowNumericSeparator */ );
        }
        return !isBigIntLiteral(node);
    }
    function getTextOfConstantValue(value1) {
        return isString(value1) ? '"' + escapeNonAsciiString(value1) + '"' : "" + value1;
    }
    function makeIdentifierFromModuleName(moduleName) {
        return getBaseFileName(moduleName).replace(/^(\d)/, "_$1").replace(/\W/g, "_");
    }
    function isBlockOrCatchScoped(declaration) {
        return (getCombinedNodeFlags(declaration) & 3 /* BlockScoped */ ) !== 0 || isCatchClauseVariableDeclarationOrBindingElement(declaration);
    }
    function isCatchClauseVariableDeclarationOrBindingElement(declaration) {
        const node = getRootDeclaration(declaration);
        return node.kind === 259 /* VariableDeclaration */  && node.parent.kind === 298 /* CatchClause */ ;
    }
    function isAmbientModule(node) {
        return isModuleDeclaration(node) && (node.name.kind === 11 /* StringLiteral */  || isGlobalScopeAugmentation(node));
    }
    function isModuleWithStringLiteralName(node) {
        return isModuleDeclaration(node) && node.name.kind === 11 /* StringLiteral */ ;
    }
    function isNonGlobalAmbientModule(node) {
        return isModuleDeclaration(node) && isStringLiteral(node.name);
    }
    function isEffectiveModuleDeclaration(node) {
        return isModuleDeclaration(node) || isIdentifier(node);
    }
    function isShorthandAmbientModuleSymbol(moduleSymbol) {
        return isShorthandAmbientModule(moduleSymbol.valueDeclaration);
    }
    function isShorthandAmbientModule(node) {
        return !!node && node.kind === 266 /* ModuleDeclaration */  && !node.body;
    }
    function isBlockScopedContainerTopLevel(node) {
        return node.kind === 311 /* SourceFile */  || node.kind === 266 /* ModuleDeclaration */  || isFunctionLikeOrClassStaticBlockDeclaration(node);
    }
    function isGlobalScopeAugmentation(module2) {
        return !!(module2.flags & 1024 /* GlobalAugmentation */ );
    }
    function isExternalModuleAugmentation(node) {
        return isAmbientModule(node) && isModuleAugmentationExternal(node);
    }
    function isModuleAugmentationExternal(node) {
        switch(node.parent.kind){
            case 311 /* SourceFile */ :
                return isExternalModule(node.parent);
            case 267 /* ModuleBlock */ :
                return isAmbientModule(node.parent.parent) && isSourceFile(node.parent.parent.parent) && !isExternalModule(node.parent.parent.parent);
        }
        return false;
    }
    function getNonAugmentationDeclaration(symbol) {
        var _a;
        return (_a = symbol.declarations) == null ? void 0 : _a.find((d)=>!isExternalModuleAugmentation(d) && !(isModuleDeclaration(d) && isGlobalScopeAugmentation(d)));
    }
    function isCommonJSContainingModuleKind(kind) {
        return kind === 1 /* CommonJS */  || kind === 100 /* Node16 */  || kind === 199 /* NodeNext */ ;
    }
    function isEffectiveExternalModule(node, compilerOptions) {
        return isExternalModule(node) || isCommonJSContainingModuleKind(getEmitModuleKind(compilerOptions)) && !!node.commonJsModuleIndicator;
    }
    function isEffectiveStrictModeSourceFile(node, compilerOptions) {
        switch(node.scriptKind){
            case 1 /* JS */ :
            case 3 /* TS */ :
            case 2 /* JSX */ :
            case 4 /* TSX */ :
                break;
            default:
                return false;
        }
        if (node.isDeclarationFile) return false;
        if (getStrictOptionValue(compilerOptions, "alwaysStrict")) return true;
        if (startsWithUseStrict(node.statements)) return true;
        if (isExternalModule(node) || getIsolatedModules(compilerOptions)) {
            if (getEmitModuleKind(compilerOptions) >= 5 /* ES2015 */ ) return true;
            return !compilerOptions.noImplicitUseStrict;
        }
        return false;
    }
    function isAmbientPropertyDeclaration(node) {
        return !!(node.flags & 16777216 /* Ambient */ ) || hasSyntacticModifier(node, 2 /* Ambient */ );
    }
    function isBlockScope(node, parentNode) {
        switch(node.kind){
            case 311 /* SourceFile */ :
            case 268 /* CaseBlock */ :
            case 298 /* CatchClause */ :
            case 266 /* ModuleDeclaration */ :
            case 247 /* ForStatement */ :
            case 248 /* ForInStatement */ :
            case 249 /* ForOfStatement */ :
            case 175 /* Constructor */ :
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
            case 171 /* PropertyDeclaration */ :
            case 174 /* ClassStaticBlockDeclaration */ :
                return true;
            case 240 /* Block */ :
                return !isFunctionLikeOrClassStaticBlockDeclaration(parentNode);
        }
        return false;
    }
    function isDeclarationWithTypeParameters(node) {
        Debug.type(node);
        switch(node.kind){
            case 344 /* JSDocCallbackTag */ :
            case 352 /* JSDocTypedefTag */ :
            case 329 /* JSDocSignature */ :
                return true;
            default:
                assertType(node);
                return isDeclarationWithTypeParameterChildren(node);
        }
    }
    function isDeclarationWithTypeParameterChildren(node) {
        Debug.type(node);
        switch(node.kind){
            case 178 /* CallSignature */ :
            case 179 /* ConstructSignature */ :
            case 172 /* MethodSignature */ :
            case 180 /* IndexSignature */ :
            case 183 /* FunctionType */ :
            case 184 /* ConstructorType */ :
            case 323 /* JSDocFunctionType */ :
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
            case 263 /* InterfaceDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
            case 351 /* JSDocTemplateTag */ :
            case 261 /* FunctionDeclaration */ :
            case 173 /* MethodDeclaration */ :
            case 175 /* Constructor */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
                return true;
            default:
                assertType(node);
                return false;
        }
    }
    function isAnyImportSyntax(node) {
        switch(node.kind){
            case 271 /* ImportDeclaration */ :
            case 270 /* ImportEqualsDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function isAnyImportOrBareOrAccessedRequire(node) {
        return isAnyImportSyntax(node) || isVariableDeclarationInitializedToBareOrAccessedRequire(node);
    }
    function isLateVisibilityPaintedStatement(node) {
        switch(node.kind){
            case 271 /* ImportDeclaration */ :
            case 270 /* ImportEqualsDeclaration */ :
            case 242 /* VariableStatement */ :
            case 262 /* ClassDeclaration */ :
            case 261 /* FunctionDeclaration */ :
            case 266 /* ModuleDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
            case 263 /* InterfaceDeclaration */ :
            case 265 /* EnumDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function hasPossibleExternalModuleReference(node) {
        return isAnyImportOrReExport(node) || isModuleDeclaration(node) || isImportTypeNode(node) || isImportCall(node);
    }
    function isAnyImportOrReExport(node) {
        return isAnyImportSyntax(node) || isExportDeclaration(node);
    }
    function getEnclosingBlockScopeContainer(node) {
        return findAncestor(node.parent, (current)=>isBlockScope(current, current.parent));
    }
    function forEachEnclosingBlockScopeContainer(node, cb) {
        let container = getEnclosingBlockScopeContainer(node);
        while(container){
            cb(container);
            container = getEnclosingBlockScopeContainer(container);
        }
    }
    function declarationNameToString(name) {
        return !name || getFullWidth(name) === 0 ? "(Missing)" : getTextOfNode(name);
    }
    function getNameFromIndexInfo(info) {
        return info.declaration ? declarationNameToString(info.declaration.parameters[0].name) : void 0;
    }
    function isComputedNonLiteralName(name) {
        return name.kind === 166 /* ComputedPropertyName */  && !isStringOrNumericLiteralLike(name.expression);
    }
    function tryGetTextOfPropertyName(name) {
        var _a;
        switch(name.kind){
            case 80 /* Identifier */ :
            case 81 /* PrivateIdentifier */ :
                return ((_a = name.emitNode) == null ? void 0 : _a.autoGenerate) ? void 0 : name.escapedText;
            case 11 /* StringLiteral */ :
            case 9 /* NumericLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
                return escapeLeadingUnderscores(name.text);
            case 166 /* ComputedPropertyName */ :
                if (isStringOrNumericLiteralLike(name.expression)) return escapeLeadingUnderscores(name.expression.text);
                return void 0;
            case 294 /* JsxNamespacedName */ :
                return getEscapedTextOfJsxNamespacedName(name);
            default:
                return Debug.assertNever(name);
        }
    }
    function getTextOfPropertyName(name) {
        return Debug.checkDefined(tryGetTextOfPropertyName(name));
    }
    function entityNameToString(name) {
        switch(name.kind){
            case 110 /* ThisKeyword */ :
                return "this";
            case 81 /* PrivateIdentifier */ :
            case 80 /* Identifier */ :
                return getFullWidth(name) === 0 ? idText(name) : getTextOfNode(name);
            case 165 /* QualifiedName */ :
                return entityNameToString(name.left) + "." + entityNameToString(name.right);
            case 210 /* PropertyAccessExpression */ :
                if (isIdentifier(name.name) || isPrivateIdentifier(name.name)) return entityNameToString(name.expression) + "." + entityNameToString(name.name);
                else return Debug.assertNever(name.name);
            case 317 /* JSDocMemberName */ :
                return entityNameToString(name.left) + entityNameToString(name.right);
            case 294 /* JsxNamespacedName */ :
                return entityNameToString(name.namespace) + ":" + entityNameToString(name.name);
            default:
                return Debug.assertNever(name);
        }
    }
    function createDiagnosticForNode(node, message, ...args) {
        const sourceFile = getSourceFileOfNode(node);
        return createDiagnosticForNodeInSourceFile(sourceFile, node, message, ...args);
    }
    function createDiagnosticForNodeArray(sourceFile, nodes, message, ...args) {
        const start = skipTrivia(sourceFile.text, nodes.pos);
        return createFileDiagnostic(sourceFile, start, nodes.end - start, message, ...args);
    }
    function createDiagnosticForNodeInSourceFile(sourceFile, node, message, ...args) {
        const span = getErrorSpanForNode(sourceFile, node);
        return createFileDiagnostic(sourceFile, span.start, span.length, message, ...args);
    }
    function createDiagnosticForNodeFromMessageChain(sourceFile, node, messageChain, relatedInformation) {
        const span = getErrorSpanForNode(sourceFile, node);
        return createFileDiagnosticFromMessageChain(sourceFile, span.start, span.length, messageChain, relatedInformation);
    }
    function createDiagnosticForNodeArrayFromMessageChain(sourceFile, nodes, messageChain, relatedInformation) {
        const start = skipTrivia(sourceFile.text, nodes.pos);
        return createFileDiagnosticFromMessageChain(sourceFile, start, nodes.end - start, messageChain, relatedInformation);
    }
    function assertDiagnosticLocation(file, start, length2) {
        Debug.assertGreaterThanOrEqual(start, 0);
        Debug.assertGreaterThanOrEqual(length2, 0);
        if (file) {
            Debug.assertLessThanOrEqual(start, file.text.length);
            Debug.assertLessThanOrEqual(start + length2, file.text.length);
        }
    }
    function createFileDiagnosticFromMessageChain(file, start, length2, messageChain, relatedInformation) {
        assertDiagnosticLocation(file, start, length2);
        return {
            file: file,
            start: start,
            length: length2,
            code: messageChain.code,
            category: messageChain.category,
            messageText: messageChain.next ? messageChain : messageChain.messageText,
            relatedInformation: relatedInformation
        };
    }
    function createDiagnosticForFileFromMessageChain(sourceFile, messageChain, relatedInformation) {
        return {
            file: sourceFile,
            start: 0,
            length: 0,
            code: messageChain.code,
            category: messageChain.category,
            messageText: messageChain.next ? messageChain : messageChain.messageText,
            relatedInformation: relatedInformation
        };
    }
    function createDiagnosticMessageChainFromDiagnostic(diagnostic) {
        return typeof diagnostic.messageText === "string" ? {
            code: diagnostic.code,
            category: diagnostic.category,
            messageText: diagnostic.messageText,
            next: diagnostic.next
        } : diagnostic.messageText;
    }
    function createDiagnosticForRange(sourceFile, range, message) {
        return {
            file: sourceFile,
            start: range.pos,
            length: range.end - range.pos,
            code: message.code,
            category: message.category,
            messageText: message.message
        };
    }
    function getSpanOfTokenAtPosition(sourceFile, pos) {
        const scanner2 = createScanner(sourceFile.languageVersion, /*skipTrivia*/ true, sourceFile.languageVariant, sourceFile.text, /*onError*/ void 0, pos);
        scanner2.scan();
        const start = scanner2.getTokenStart();
        return createTextSpanFromBounds(start, scanner2.getTokenEnd());
    }
    function scanTokenAtPosition(sourceFile, pos) {
        const scanner2 = createScanner(sourceFile.languageVersion, /*skipTrivia*/ true, sourceFile.languageVariant, sourceFile.text, /*onError*/ void 0, pos);
        scanner2.scan();
        return scanner2.getToken();
    }
    function getErrorSpanForArrowFunction(sourceFile, node) {
        const pos = skipTrivia(sourceFile.text, node.pos);
        if (node.body && node.body.kind === 240 /* Block */ ) {
            const { line: startLine  } = getLineAndCharacterOfPosition(sourceFile, node.body.pos);
            const { line: endLine  } = getLineAndCharacterOfPosition(sourceFile, node.body.end);
            if (startLine < endLine) return createTextSpan(pos, getEndLinePosition(startLine, sourceFile) - pos + 1);
        }
        return createTextSpanFromBounds(pos, node.end);
    }
    function getErrorSpanForNode(sourceFile, node) {
        let errorNode = node;
        switch(node.kind){
            case 311 /* SourceFile */ :
                {
                    const pos2 = skipTrivia(sourceFile.text, 0, /*stopAfterLineBreak*/ false);
                    if (pos2 === sourceFile.text.length) return createTextSpan(0, 0);
                    return getSpanOfTokenAtPosition(sourceFile, pos2);
                }
            case 259 /* VariableDeclaration */ :
            case 207 /* BindingElement */ :
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
            case 263 /* InterfaceDeclaration */ :
            case 266 /* ModuleDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 305 /* EnumMember */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 264 /* TypeAliasDeclaration */ :
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
            case 273 /* NamespaceImport */ :
                errorNode = node.name;
                break;
            case 218 /* ArrowFunction */ :
                return getErrorSpanForArrowFunction(sourceFile, node);
            case 295 /* CaseClause */ :
            case 296 /* DefaultClause */ :
                {
                    const start = skipTrivia(sourceFile.text, node.pos);
                    const end = node.statements.length > 0 ? node.statements[0].pos : node.end;
                    return createTextSpanFromBounds(start, end);
                }
            case 252 /* ReturnStatement */ :
            case 228 /* YieldExpression */ :
                {
                    const pos2 = skipTrivia(sourceFile.text, node.pos);
                    return getSpanOfTokenAtPosition(sourceFile, pos2);
                }
            case 237 /* SatisfiesExpression */ :
                {
                    const pos2 = skipTrivia(sourceFile.text, node.expression.end);
                    return getSpanOfTokenAtPosition(sourceFile, pos2);
                }
            case 356 /* JSDocSatisfiesTag */ :
                {
                    const pos2 = skipTrivia(sourceFile.text, node.tagName.pos);
                    return getSpanOfTokenAtPosition(sourceFile, pos2);
                }
        }
        if (errorNode === void 0) return getSpanOfTokenAtPosition(sourceFile, node.pos);
        Debug.assert(!isJSDoc(errorNode));
        const isMissing = nodeIsMissing(errorNode);
        const pos = isMissing || isJsxText(node) ? errorNode.pos : skipTrivia(sourceFile.text, errorNode.pos);
        if (isMissing) {
            Debug.assert(pos === errorNode.pos, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
            Debug.assert(pos === errorNode.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
        } else {
            Debug.assert(pos >= errorNode.pos, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
            Debug.assert(pos <= errorNode.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
        }
        return createTextSpanFromBounds(pos, errorNode.end);
    }
    function isExternalOrCommonJsModule(file) {
        return (file.externalModuleIndicator || file.commonJsModuleIndicator) !== void 0;
    }
    function isJsonSourceFile(file) {
        return file.scriptKind === 6 /* JSON */ ;
    }
    function isEnumConst(node) {
        return !!(getCombinedModifierFlags(node) & 2048 /* Const */ );
    }
    function isDeclarationReadonly(declaration) {
        return !!(getCombinedModifierFlags(declaration) & 64 /* Readonly */  && !isParameterPropertyDeclaration(declaration, declaration.parent));
    }
    function isVarConst(node) {
        return !!(getCombinedNodeFlags(node) & 2 /* Const */ );
    }
    function isLet(node) {
        return !!(getCombinedNodeFlags(node) & 1 /* Let */ );
    }
    function isSuperCall(n) {
        return n.kind === 212 /* CallExpression */  && n.expression.kind === 108 /* SuperKeyword */ ;
    }
    function isImportCall(n) {
        return n.kind === 212 /* CallExpression */  && n.expression.kind === 102 /* ImportKeyword */ ;
    }
    function isImportMeta(n) {
        return isMetaProperty(n) && n.keywordToken === 102 /* ImportKeyword */  && n.name.escapedText === "meta";
    }
    function isLiteralImportTypeNode(n) {
        return isImportTypeNode(n) && isLiteralTypeNode(n.argument) && isStringLiteral(n.argument.literal);
    }
    function isPrologueDirective(node) {
        return node.kind === 243 /* ExpressionStatement */  && node.expression.kind === 11 /* StringLiteral */ ;
    }
    function isCustomPrologue(node) {
        return !!(getEmitFlags(node) & 2097152 /* CustomPrologue */ );
    }
    function isHoistedFunction(node) {
        return isCustomPrologue(node) && isFunctionDeclaration(node);
    }
    function isHoistedVariable(node) {
        return isIdentifier(node.name) && !node.initializer;
    }
    function isHoistedVariableStatement(node) {
        return isCustomPrologue(node) && isVariableStatement(node) && every(node.declarationList.declarations, isHoistedVariable);
    }
    function getLeadingCommentRangesOfNode(node, sourceFileOfNode) {
        return node.kind !== 12 /* JsxText */  ? getLeadingCommentRanges(sourceFileOfNode.text, node.pos) : void 0;
    }
    function getJSDocCommentRanges(node, text) {
        const commentRanges = node.kind === 168 /* Parameter */  || node.kind === 167 /* TypeParameter */  || node.kind === 217 /* FunctionExpression */  || node.kind === 218 /* ArrowFunction */  || node.kind === 216 /* ParenthesizedExpression */  || node.kind === 259 /* VariableDeclaration */  || node.kind === 280 /* ExportSpecifier */  ? concatenate(getTrailingCommentRanges(text, node.pos), getLeadingCommentRanges(text, node.pos)) : getLeadingCommentRanges(text, node.pos);
        return filter(commentRanges, (comment)=>text.charCodeAt(comment.pos + 1) === 42 /* asterisk */  && text.charCodeAt(comment.pos + 2) === 42 /* asterisk */  && text.charCodeAt(comment.pos + 3) !== 47 /* slash */ );
    }
    function isPartOfTypeNode(node) {
        if (181 /* FirstTypeNode */  <= node.kind && node.kind <= 204 /* LastTypeNode */ ) return true;
        switch(node.kind){
            case 133 /* AnyKeyword */ :
            case 159 /* UnknownKeyword */ :
            case 150 /* NumberKeyword */ :
            case 162 /* BigIntKeyword */ :
            case 154 /* StringKeyword */ :
            case 136 /* BooleanKeyword */ :
            case 155 /* SymbolKeyword */ :
            case 151 /* ObjectKeyword */ :
            case 157 /* UndefinedKeyword */ :
            case 106 /* NullKeyword */ :
            case 146 /* NeverKeyword */ :
                return true;
            case 116 /* VoidKeyword */ :
                return node.parent.kind !== 221 /* VoidExpression */ ;
            case 232 /* ExpressionWithTypeArguments */ :
                return isHeritageClause(node.parent) && !isExpressionWithTypeArgumentsInClassExtendsClause(node);
            case 167 /* TypeParameter */ :
                return node.parent.kind === 199 /* MappedType */  || node.parent.kind === 194 /* InferType */ ;
            case 80 /* Identifier */ :
                if (node.parent.kind === 165 /* QualifiedName */  && node.parent.right === node) node = node.parent;
                else if (node.parent.kind === 210 /* PropertyAccessExpression */  && node.parent.name === node) node = node.parent;
                Debug.assert(node.kind === 80 /* Identifier */  || node.kind === 165 /* QualifiedName */  || node.kind === 210 /* PropertyAccessExpression */ , "'node' was expected to be a qualified name, identifier or property access in 'isPartOfTypeNode'.");
            case 165 /* QualifiedName */ :
            case 210 /* PropertyAccessExpression */ :
            case 110 /* ThisKeyword */ :
                {
                    const { parent: parent2  } = node;
                    if (parent2.kind === 185 /* TypeQuery */ ) return false;
                    if (parent2.kind === 204 /* ImportType */ ) return !parent2.isTypeOf;
                    if (181 /* FirstTypeNode */  <= parent2.kind && parent2.kind <= 204 /* LastTypeNode */ ) return true;
                    switch(parent2.kind){
                        case 232 /* ExpressionWithTypeArguments */ :
                            return isHeritageClause(parent2.parent) && !isExpressionWithTypeArgumentsInClassExtendsClause(parent2);
                        case 167 /* TypeParameter */ :
                            return node === parent2.constraint;
                        case 351 /* JSDocTemplateTag */ :
                            return node === parent2.constraint;
                        case 171 /* PropertyDeclaration */ :
                        case 170 /* PropertySignature */ :
                        case 168 /* Parameter */ :
                        case 259 /* VariableDeclaration */ :
                            return node === parent2.type;
                        case 261 /* FunctionDeclaration */ :
                        case 217 /* FunctionExpression */ :
                        case 218 /* ArrowFunction */ :
                        case 175 /* Constructor */ :
                        case 173 /* MethodDeclaration */ :
                        case 172 /* MethodSignature */ :
                        case 176 /* GetAccessor */ :
                        case 177 /* SetAccessor */ :
                            return node === parent2.type;
                        case 178 /* CallSignature */ :
                        case 179 /* ConstructSignature */ :
                        case 180 /* IndexSignature */ :
                            return node === parent2.type;
                        case 215 /* TypeAssertionExpression */ :
                            return node === parent2.type;
                        case 212 /* CallExpression */ :
                        case 213 /* NewExpression */ :
                        case 214 /* TaggedTemplateExpression */ :
                            return contains(parent2.typeArguments, node);
                    }
                }
        }
        return false;
    }
    function isChildOfNodeWithKind(node, kind) {
        while(node){
            if (node.kind === kind) return true;
            node = node.parent;
        }
        return false;
    }
    function forEachReturnStatement(body, visitor) {
        return traverse(body);
        function traverse(node) {
            switch(node.kind){
                case 252 /* ReturnStatement */ :
                    return visitor(node);
                case 268 /* CaseBlock */ :
                case 240 /* Block */ :
                case 244 /* IfStatement */ :
                case 245 /* DoStatement */ :
                case 246 /* WhileStatement */ :
                case 247 /* ForStatement */ :
                case 248 /* ForInStatement */ :
                case 249 /* ForOfStatement */ :
                case 253 /* WithStatement */ :
                case 254 /* SwitchStatement */ :
                case 295 /* CaseClause */ :
                case 296 /* DefaultClause */ :
                case 255 /* LabeledStatement */ :
                case 257 /* TryStatement */ :
                case 298 /* CatchClause */ :
                    return forEachChild(node, traverse);
            }
        }
    }
    function forEachYieldExpression(body, visitor) {
        return traverse(body);
        function traverse(node) {
            switch(node.kind){
                case 228 /* YieldExpression */ :
                    visitor(node);
                    const operand = node.expression;
                    if (operand) traverse(operand);
                    return;
                case 265 /* EnumDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                case 266 /* ModuleDeclaration */ :
                case 264 /* TypeAliasDeclaration */ :
                    return;
                default:
                    if (isFunctionLike(node)) {
                        if (node.name && node.name.kind === 166 /* ComputedPropertyName */ ) {
                            traverse(node.name.expression);
                            return;
                        }
                    } else if (!isPartOfTypeNode(node)) forEachChild(node, traverse);
            }
        }
    }
    function getRestParameterElementType(node) {
        if (node && node.kind === 187 /* ArrayType */ ) return node.elementType;
        else if (node && node.kind === 182 /* TypeReference */ ) return singleOrUndefined(node.typeArguments);
        else return void 0;
    }
    function getMembersOfDeclaration(node) {
        switch(node.kind){
            case 263 /* InterfaceDeclaration */ :
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
            case 186 /* TypeLiteral */ :
                return node.members;
            case 209 /* ObjectLiteralExpression */ :
                return node.properties;
        }
    }
    function isVariableLike(node) {
        if (node) switch(node.kind){
            case 207 /* BindingElement */ :
            case 305 /* EnumMember */ :
            case 168 /* Parameter */ :
            case 302 /* PropertyAssignment */ :
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
            case 303 /* ShorthandPropertyAssignment */ :
            case 259 /* VariableDeclaration */ :
                return true;
        }
        return false;
    }
    function isVariableLikeOrAccessor(node) {
        return isVariableLike(node) || isAccessor(node);
    }
    function isVariableDeclarationInVariableStatement(node) {
        return node.parent.kind === 260 /* VariableDeclarationList */  && node.parent.parent.kind === 242 /* VariableStatement */ ;
    }
    function isCommonJsExportedExpression(node) {
        if (!isInJSFile(node)) return false;
        return isObjectLiteralExpression(node.parent) && isBinaryExpression(node.parent.parent) && getAssignmentDeclarationKind(node.parent.parent) === 2 /* ModuleExports */  || isCommonJsExportPropertyAssignment(node.parent);
    }
    function isCommonJsExportPropertyAssignment(node) {
        if (!isInJSFile(node)) return false;
        return isBinaryExpression(node) && getAssignmentDeclarationKind(node) === 1 /* ExportsProperty */ ;
    }
    function isValidESSymbolDeclaration(node) {
        return (isVariableDeclaration(node) ? isVarConst(node) && isIdentifier(node.name) && isVariableDeclarationInVariableStatement(node) : isPropertyDeclaration(node) ? hasEffectiveReadonlyModifier(node) && hasStaticModifier(node) : isPropertySignature(node) && hasEffectiveReadonlyModifier(node)) || isCommonJsExportPropertyAssignment(node);
    }
    function introducesArgumentsExoticObject(node) {
        switch(node.kind){
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 175 /* Constructor */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
                return true;
        }
        return false;
    }
    function unwrapInnermostStatementOfLabel(node, beforeUnwrapLabelCallback) {
        while(true){
            if (beforeUnwrapLabelCallback) beforeUnwrapLabelCallback(node);
            if (node.statement.kind !== 255 /* LabeledStatement */ ) return node.statement;
            node = node.statement;
        }
    }
    function isFunctionBlock(node) {
        return node && node.kind === 240 /* Block */  && isFunctionLike(node.parent);
    }
    function isObjectLiteralMethod(node) {
        return node && node.kind === 173 /* MethodDeclaration */  && node.parent.kind === 209 /* ObjectLiteralExpression */ ;
    }
    function isObjectLiteralOrClassExpressionMethodOrAccessor(node) {
        return (node.kind === 173 /* MethodDeclaration */  || node.kind === 176 /* GetAccessor */  || node.kind === 177 /* SetAccessor */ ) && (node.parent.kind === 209 /* ObjectLiteralExpression */  || node.parent.kind === 230 /* ClassExpression */ );
    }
    function isIdentifierTypePredicate(predicate) {
        return predicate && predicate.kind === 1 /* Identifier */ ;
    }
    function isThisTypePredicate(predicate) {
        return predicate && predicate.kind === 0 /* This */ ;
    }
    function forEachPropertyAssignment(objectLiteral, key, callback, key2) {
        return forEach(objectLiteral == null ? void 0 : objectLiteral.properties, (property)=>{
            if (!isPropertyAssignment(property)) return void 0;
            const propName = tryGetTextOfPropertyName(property.name);
            return key === propName || key2 && key2 === propName ? callback(property) : void 0;
        });
    }
    function getPropertyArrayElementValue(objectLiteral, propKey, elementValue) {
        return forEachPropertyAssignment(objectLiteral, propKey, (property)=>isArrayLiteralExpression(property.initializer) ? find(property.initializer.elements, (element)=>isStringLiteral(element) && element.text === elementValue) : void 0);
    }
    function getTsConfigObjectLiteralExpression(tsConfigSourceFile) {
        if (tsConfigSourceFile && tsConfigSourceFile.statements.length) {
            const expression = tsConfigSourceFile.statements[0].expression;
            return tryCast(expression, isObjectLiteralExpression);
        }
    }
    function getTsConfigPropArrayElementValue(tsConfigSourceFile, propKey, elementValue) {
        return forEachTsConfigPropArray(tsConfigSourceFile, propKey, (property)=>isArrayLiteralExpression(property.initializer) ? find(property.initializer.elements, (element)=>isStringLiteral(element) && element.text === elementValue) : void 0);
    }
    function forEachTsConfigPropArray(tsConfigSourceFile, propKey, callback) {
        return forEachPropertyAssignment(getTsConfigObjectLiteralExpression(tsConfigSourceFile), propKey, callback);
    }
    function getContainingFunction(node) {
        return findAncestor(node.parent, isFunctionLike);
    }
    function getContainingFunctionDeclaration(node) {
        return findAncestor(node.parent, isFunctionLikeDeclaration);
    }
    function getContainingClass(node) {
        return findAncestor(node.parent, isClassLike);
    }
    function getContainingClassStaticBlock(node) {
        return findAncestor(node.parent, (n)=>{
            if (isClassLike(n) || isFunctionLike(n)) return "quit";
            return isClassStaticBlockDeclaration(n);
        });
    }
    function getContainingFunctionOrClassStaticBlock(node) {
        return findAncestor(node.parent, isFunctionLikeOrClassStaticBlockDeclaration);
    }
    function getThisContainer(node, includeArrowFunctions, includeClassComputedPropertyName) {
        Debug.assert(node.kind !== 311 /* SourceFile */ );
        while(true){
            node = node.parent;
            if (!node) return Debug.fail();
            switch(node.kind){
                case 166 /* ComputedPropertyName */ :
                    if (includeClassComputedPropertyName && isClassLike(node.parent.parent)) return node;
                    node = node.parent.parent;
                    break;
                case 169 /* Decorator */ :
                    if (node.parent.kind === 168 /* Parameter */  && isClassElement(node.parent.parent)) node = node.parent.parent;
                    else if (isClassElement(node.parent)) node = node.parent;
                    break;
                case 218 /* ArrowFunction */ :
                    if (!includeArrowFunctions) continue;
                case 261 /* FunctionDeclaration */ :
                case 217 /* FunctionExpression */ :
                case 266 /* ModuleDeclaration */ :
                case 174 /* ClassStaticBlockDeclaration */ :
                case 171 /* PropertyDeclaration */ :
                case 170 /* PropertySignature */ :
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                case 175 /* Constructor */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                case 178 /* CallSignature */ :
                case 179 /* ConstructSignature */ :
                case 180 /* IndexSignature */ :
                case 265 /* EnumDeclaration */ :
                case 311 /* SourceFile */ :
                    return node;
            }
        }
    }
    function isThisContainerOrFunctionBlock(node) {
        switch(node.kind){
            case 218 /* ArrowFunction */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 171 /* PropertyDeclaration */ :
                return true;
            case 240 /* Block */ :
                switch(node.parent.kind){
                    case 175 /* Constructor */ :
                    case 173 /* MethodDeclaration */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                        return true;
                    default:
                        return false;
                }
            default:
                return false;
        }
    }
    function isInTopLevelContext(node) {
        if (isIdentifier(node) && (isClassDeclaration(node.parent) || isFunctionDeclaration(node.parent)) && node.parent.name === node) node = node.parent;
        const container = getThisContainer(node, /*includeArrowFunctions*/ true, /*includeClassComputedPropertyName*/ false);
        return isSourceFile(container);
    }
    function getNewTargetContainer(node) {
        const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
        if (container) switch(container.kind){
            case 175 /* Constructor */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
                return container;
        }
        return void 0;
    }
    function getSuperContainer(node, stopOnFunctions) {
        while(true){
            node = node.parent;
            if (!node) return void 0;
            switch(node.kind){
                case 166 /* ComputedPropertyName */ :
                    node = node.parent;
                    break;
                case 261 /* FunctionDeclaration */ :
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                    if (!stopOnFunctions) continue;
                case 171 /* PropertyDeclaration */ :
                case 170 /* PropertySignature */ :
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                case 175 /* Constructor */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                case 174 /* ClassStaticBlockDeclaration */ :
                    return node;
                case 169 /* Decorator */ :
                    if (node.parent.kind === 168 /* Parameter */  && isClassElement(node.parent.parent)) node = node.parent.parent;
                    else if (isClassElement(node.parent)) node = node.parent;
                    break;
            }
        }
    }
    function getImmediatelyInvokedFunctionExpression(func) {
        if (func.kind === 217 /* FunctionExpression */  || func.kind === 218 /* ArrowFunction */ ) {
            let prev = func;
            let parent2 = func.parent;
            while(parent2.kind === 216 /* ParenthesizedExpression */ ){
                prev = parent2;
                parent2 = parent2.parent;
            }
            if (parent2.kind === 212 /* CallExpression */  && parent2.expression === prev) return parent2;
        }
    }
    function isSuperOrSuperProperty(node) {
        return node.kind === 108 /* SuperKeyword */  || isSuperProperty(node);
    }
    function isSuperProperty(node) {
        const kind = node.kind;
        return (kind === 210 /* PropertyAccessExpression */  || kind === 211 /* ElementAccessExpression */ ) && node.expression.kind === 108 /* SuperKeyword */ ;
    }
    function isThisProperty(node) {
        const kind = node.kind;
        return (kind === 210 /* PropertyAccessExpression */  || kind === 211 /* ElementAccessExpression */ ) && node.expression.kind === 110 /* ThisKeyword */ ;
    }
    function isThisInitializedDeclaration(node) {
        var _a;
        return !!node && isVariableDeclaration(node) && ((_a = node.initializer) == null ? void 0 : _a.kind) === 110 /* ThisKeyword */ ;
    }
    function isThisInitializedObjectBindingExpression(node) {
        return !!node && (isShorthandPropertyAssignment(node) || isPropertyAssignment(node)) && isBinaryExpression(node.parent.parent) && node.parent.parent.operatorToken.kind === 64 /* EqualsToken */  && node.parent.parent.right.kind === 110 /* ThisKeyword */ ;
    }
    function getEntityNameFromTypeNode(node) {
        switch(node.kind){
            case 182 /* TypeReference */ :
                return node.typeName;
            case 232 /* ExpressionWithTypeArguments */ :
                return isEntityNameExpression(node.expression) ? node.expression : void 0;
            case 80 /* Identifier */ :
            case 165 /* QualifiedName */ :
                return node;
        }
        return void 0;
    }
    function getInvokedExpression(node) {
        switch(node.kind){
            case 214 /* TaggedTemplateExpression */ :
                return node.tag;
            case 285 /* JsxOpeningElement */ :
            case 284 /* JsxSelfClosingElement */ :
                return node.tagName;
            default:
                return node.expression;
        }
    }
    function nodeCanBeDecorated(useLegacyDecorators, node, parent2, grandparent) {
        if (useLegacyDecorators && isNamedDeclaration(node) && isPrivateIdentifier(node.name)) return false;
        switch(node.kind){
            case 262 /* ClassDeclaration */ :
                return true;
            case 230 /* ClassExpression */ :
                return !useLegacyDecorators;
            case 171 /* PropertyDeclaration */ :
                return parent2 !== void 0 && (useLegacyDecorators ? isClassDeclaration(parent2) : isClassLike(parent2) && !hasAbstractModifier(node) && !hasAmbientModifier(node));
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 173 /* MethodDeclaration */ :
                return node.body !== void 0 && parent2 !== void 0 && (useLegacyDecorators ? isClassDeclaration(parent2) : isClassLike(parent2));
            case 168 /* Parameter */ :
                if (!useLegacyDecorators) return false;
                return parent2 !== void 0 && parent2.body !== void 0 && (parent2.kind === 175 /* Constructor */  || parent2.kind === 173 /* MethodDeclaration */  || parent2.kind === 177 /* SetAccessor */ ) && getThisParameter(parent2) !== node && grandparent !== void 0 && grandparent.kind === 262 /* ClassDeclaration */ ;
        }
        return false;
    }
    function nodeIsDecorated(useLegacyDecorators, node, parent2, grandparent) {
        return hasDecorators(node) && nodeCanBeDecorated(useLegacyDecorators, node, parent2, grandparent);
    }
    function nodeOrChildIsDecorated(useLegacyDecorators, node, parent2, grandparent) {
        return nodeIsDecorated(useLegacyDecorators, node, parent2, grandparent) || childIsDecorated(useLegacyDecorators, node, parent2);
    }
    function childIsDecorated(useLegacyDecorators, node, parent2) {
        switch(node.kind){
            case 262 /* ClassDeclaration */ :
                return some(node.members, (m)=>nodeOrChildIsDecorated(useLegacyDecorators, m, node, parent2));
            case 230 /* ClassExpression */ :
                return !useLegacyDecorators && some(node.members, (m)=>nodeOrChildIsDecorated(useLegacyDecorators, m, node, parent2));
            case 173 /* MethodDeclaration */ :
            case 177 /* SetAccessor */ :
            case 175 /* Constructor */ :
                return some(node.parameters, (p)=>nodeIsDecorated(useLegacyDecorators, p, node, parent2));
            default:
                return false;
        }
    }
    function classOrConstructorParameterIsDecorated(useLegacyDecorators, node) {
        if (nodeIsDecorated(useLegacyDecorators, node)) return true;
        const constructor = getFirstConstructorWithBody(node);
        return !!constructor && childIsDecorated(useLegacyDecorators, constructor, node);
    }
    function classElementOrClassElementParameterIsDecorated(useLegacyDecorators, node, parent2) {
        let parameters;
        if (isAccessor(node)) {
            const { firstAccessor: firstAccessor , secondAccessor: secondAccessor , setAccessor: setAccessor  } = getAllAccessorDeclarations(parent2.members, node);
            const firstAccessorWithDecorators = hasDecorators(firstAccessor) ? firstAccessor : secondAccessor && hasDecorators(secondAccessor) ? secondAccessor : void 0;
            if (!firstAccessorWithDecorators || node !== firstAccessorWithDecorators) return false;
            parameters = setAccessor == null ? void 0 : setAccessor.parameters;
        } else if (isMethodDeclaration(node)) parameters = node.parameters;
        if (nodeIsDecorated(useLegacyDecorators, node, parent2)) return true;
        if (parameters) for (const parameter of parameters){
            if (parameterIsThisKeyword(parameter)) continue;
            if (nodeIsDecorated(useLegacyDecorators, parameter, node, parent2)) return true;
        }
        return false;
    }
    function isEmptyStringLiteral(node) {
        if (node.textSourceNode) {
            switch(node.textSourceNode.kind){
                case 11 /* StringLiteral */ :
                    return isEmptyStringLiteral(node.textSourceNode);
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    return node.text === "";
            }
            return false;
        }
        return node.text === "";
    }
    function isJSXTagName(node) {
        const { parent: parent2  } = node;
        if (parent2.kind === 285 /* JsxOpeningElement */  || parent2.kind === 284 /* JsxSelfClosingElement */  || parent2.kind === 286 /* JsxClosingElement */ ) return parent2.tagName === node;
        return false;
    }
    function isExpressionNode(node) {
        switch(node.kind){
            case 108 /* SuperKeyword */ :
            case 106 /* NullKeyword */ :
            case 112 /* TrueKeyword */ :
            case 97 /* FalseKeyword */ :
            case 14 /* RegularExpressionLiteral */ :
            case 208 /* ArrayLiteralExpression */ :
            case 209 /* ObjectLiteralExpression */ :
            case 210 /* PropertyAccessExpression */ :
            case 211 /* ElementAccessExpression */ :
            case 212 /* CallExpression */ :
            case 213 /* NewExpression */ :
            case 214 /* TaggedTemplateExpression */ :
            case 233 /* AsExpression */ :
            case 215 /* TypeAssertionExpression */ :
            case 237 /* SatisfiesExpression */ :
            case 234 /* NonNullExpression */ :
            case 216 /* ParenthesizedExpression */ :
            case 217 /* FunctionExpression */ :
            case 230 /* ClassExpression */ :
            case 218 /* ArrowFunction */ :
            case 221 /* VoidExpression */ :
            case 219 /* DeleteExpression */ :
            case 220 /* TypeOfExpression */ :
            case 223 /* PrefixUnaryExpression */ :
            case 224 /* PostfixUnaryExpression */ :
            case 225 /* BinaryExpression */ :
            case 226 /* ConditionalExpression */ :
            case 229 /* SpreadElement */ :
            case 227 /* TemplateExpression */ :
            case 231 /* OmittedExpression */ :
            case 283 /* JsxElement */ :
            case 284 /* JsxSelfClosingElement */ :
            case 287 /* JsxFragment */ :
            case 228 /* YieldExpression */ :
            case 222 /* AwaitExpression */ :
            case 235 /* MetaProperty */ :
                return true;
            case 232 /* ExpressionWithTypeArguments */ :
                return !isHeritageClause(node.parent) && !isJSDocAugmentsTag(node.parent);
            case 165 /* QualifiedName */ :
                while(node.parent.kind === 165 /* QualifiedName */ )node = node.parent;
                return node.parent.kind === 185 /* TypeQuery */  || isJSDocLinkLike(node.parent) || isJSDocNameReference(node.parent) || isJSDocMemberName(node.parent) || isJSXTagName(node);
            case 317 /* JSDocMemberName */ :
                while(isJSDocMemberName(node.parent))node = node.parent;
                return node.parent.kind === 185 /* TypeQuery */  || isJSDocLinkLike(node.parent) || isJSDocNameReference(node.parent) || isJSDocMemberName(node.parent) || isJSXTagName(node);
            case 81 /* PrivateIdentifier */ :
                return isBinaryExpression(node.parent) && node.parent.left === node && node.parent.operatorToken.kind === 103 /* InKeyword */ ;
            case 80 /* Identifier */ :
                if (node.parent.kind === 185 /* TypeQuery */  || isJSDocLinkLike(node.parent) || isJSDocNameReference(node.parent) || isJSDocMemberName(node.parent) || isJSXTagName(node)) return true;
            case 9 /* NumericLiteral */ :
            case 10 /* BigIntLiteral */ :
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 110 /* ThisKeyword */ :
                return isInExpressionContext(node);
            default:
                return false;
        }
    }
    function isInExpressionContext(node) {
        const { parent: parent2  } = node;
        switch(parent2.kind){
            case 259 /* VariableDeclaration */ :
            case 168 /* Parameter */ :
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
            case 305 /* EnumMember */ :
            case 302 /* PropertyAssignment */ :
            case 207 /* BindingElement */ :
                return parent2.initializer === node;
            case 243 /* ExpressionStatement */ :
            case 244 /* IfStatement */ :
            case 245 /* DoStatement */ :
            case 246 /* WhileStatement */ :
            case 252 /* ReturnStatement */ :
            case 253 /* WithStatement */ :
            case 254 /* SwitchStatement */ :
            case 295 /* CaseClause */ :
            case 256 /* ThrowStatement */ :
                return parent2.expression === node;
            case 247 /* ForStatement */ :
                const forStatement = parent2;
                return forStatement.initializer === node && forStatement.initializer.kind !== 260 /* VariableDeclarationList */  || forStatement.condition === node || forStatement.incrementor === node;
            case 248 /* ForInStatement */ :
            case 249 /* ForOfStatement */ :
                const forInStatement = parent2;
                return forInStatement.initializer === node && forInStatement.initializer.kind !== 260 /* VariableDeclarationList */  || forInStatement.expression === node;
            case 215 /* TypeAssertionExpression */ :
            case 233 /* AsExpression */ :
                return node === parent2.expression;
            case 238 /* TemplateSpan */ :
                return node === parent2.expression;
            case 166 /* ComputedPropertyName */ :
                return node === parent2.expression;
            case 169 /* Decorator */ :
            case 293 /* JsxExpression */ :
            case 292 /* JsxSpreadAttribute */ :
            case 304 /* SpreadAssignment */ :
                return true;
            case 232 /* ExpressionWithTypeArguments */ :
                return parent2.expression === node && !isPartOfTypeNode(parent2);
            case 303 /* ShorthandPropertyAssignment */ :
                return parent2.objectAssignmentInitializer === node;
            case 237 /* SatisfiesExpression */ :
                return node === parent2.expression;
            default:
                return isExpressionNode(parent2);
        }
    }
    function isPartOfTypeQuery(node) {
        while(node.kind === 165 /* QualifiedName */  || node.kind === 80 /* Identifier */ )node = node.parent;
        return node.kind === 185 /* TypeQuery */ ;
    }
    function isNamespaceReexportDeclaration(node) {
        return isNamespaceExport(node) && !!node.parent.moduleSpecifier;
    }
    function isExternalModuleImportEqualsDeclaration(node) {
        return node.kind === 270 /* ImportEqualsDeclaration */  && node.moduleReference.kind === 282 /* ExternalModuleReference */ ;
    }
    function getExternalModuleImportEqualsDeclarationExpression(node) {
        Debug.assert(isExternalModuleImportEqualsDeclaration(node));
        return node.moduleReference.expression;
    }
    function getExternalModuleRequireArgument(node) {
        return isVariableDeclarationInitializedToBareOrAccessedRequire(node) && getLeftmostAccessExpression(node.initializer).arguments[0];
    }
    function isInternalModuleImportEqualsDeclaration(node) {
        return node.kind === 270 /* ImportEqualsDeclaration */  && node.moduleReference.kind !== 282 /* ExternalModuleReference */ ;
    }
    function isSourceFileJS(file) {
        return isInJSFile(file);
    }
    function isSourceFileNotJS(file) {
        return !isInJSFile(file);
    }
    function isInJSFile(node) {
        return !!node && !!(node.flags & 262144 /* JavaScriptFile */ );
    }
    function isInJsonFile(node) {
        return !!node && !!(node.flags & 67108864 /* JsonFile */ );
    }
    function isSourceFileNotJson(file) {
        return !isJsonSourceFile(file);
    }
    function isInJSDoc(node) {
        return !!node && !!(node.flags & 8388608 /* JSDoc */ );
    }
    function isJSDocIndexSignature(node) {
        return isTypeReferenceNode(node) && isIdentifier(node.typeName) && node.typeName.escapedText === "Object" && node.typeArguments && node.typeArguments.length === 2 && (node.typeArguments[0].kind === 154 /* StringKeyword */  || node.typeArguments[0].kind === 150 /* NumberKeyword */ );
    }
    function isRequireCall(callExpression, requireStringLiteralLikeArgument) {
        if (callExpression.kind !== 212 /* CallExpression */ ) return false;
        const { expression: expression , arguments: args  } = callExpression;
        if (expression.kind !== 80 /* Identifier */  || expression.escapedText !== "require") return false;
        if (args.length !== 1) return false;
        const arg = args[0];
        return !requireStringLiteralLikeArgument || isStringLiteralLike(arg);
    }
    function isVariableDeclarationInitializedToRequire(node) {
        return isVariableDeclarationInitializedWithRequireHelper(node, /*allowAccessedRequire*/ false);
    }
    function isVariableDeclarationInitializedToBareOrAccessedRequire(node) {
        return isVariableDeclarationInitializedWithRequireHelper(node, /*allowAccessedRequire*/ true);
    }
    function isBindingElementOfBareOrAccessedRequire(node) {
        return isBindingElement(node) && isVariableDeclarationInitializedToBareOrAccessedRequire(node.parent.parent);
    }
    function isVariableDeclarationInitializedWithRequireHelper(node, allowAccessedRequire) {
        return isVariableDeclaration(node) && !!node.initializer && isRequireCall(allowAccessedRequire ? getLeftmostAccessExpression(node.initializer) : node.initializer, /*requireStringLiteralLikeArgument*/ true);
    }
    function isRequireVariableStatement(node) {
        return isVariableStatement(node) && node.declarationList.declarations.length > 0 && every(node.declarationList.declarations, (decl)=>isVariableDeclarationInitializedToRequire(decl));
    }
    function isSingleOrDoubleQuote(charCode) {
        return charCode === 39 /* singleQuote */  || charCode === 34 /* doubleQuote */ ;
    }
    function isStringDoubleQuoted(str, sourceFile) {
        return getSourceTextOfNodeFromSourceFile(sourceFile, str).charCodeAt(0) === 34 /* doubleQuote */ ;
    }
    function isAssignmentDeclaration(decl) {
        return isBinaryExpression(decl) || isAccessExpression(decl) || isIdentifier(decl) || isCallExpression(decl);
    }
    function getEffectiveInitializer(node) {
        if (isInJSFile(node) && node.initializer && isBinaryExpression(node.initializer) && (node.initializer.operatorToken.kind === 57 /* BarBarToken */  || node.initializer.operatorToken.kind === 61 /* QuestionQuestionToken */ ) && node.name && isEntityNameExpression(node.name) && isSameEntityName(node.name, node.initializer.left)) return node.initializer.right;
        return node.initializer;
    }
    function getDeclaredExpandoInitializer(node) {
        const init = getEffectiveInitializer(node);
        return init && getExpandoInitializer(init, isPrototypeAccess(node.name));
    }
    function hasExpandoValueProperty(node, isPrototypeAssignment) {
        return forEach(node.properties, (p)=>isPropertyAssignment(p) && isIdentifier(p.name) && p.name.escapedText === "value" && p.initializer && getExpandoInitializer(p.initializer, isPrototypeAssignment));
    }
    function getAssignedExpandoInitializer(node) {
        if (node && node.parent && isBinaryExpression(node.parent) && node.parent.operatorToken.kind === 64 /* EqualsToken */ ) {
            const isPrototypeAssignment = isPrototypeAccess(node.parent.left);
            return getExpandoInitializer(node.parent.right, isPrototypeAssignment) || getDefaultedExpandoInitializer(node.parent.left, node.parent.right, isPrototypeAssignment);
        }
        if (node && isCallExpression(node) && isBindableObjectDefinePropertyCall(node)) {
            const result = hasExpandoValueProperty(node.arguments[2], node.arguments[1].text === "prototype");
            if (result) return result;
        }
    }
    function getExpandoInitializer(initializer, isPrototypeAssignment) {
        if (isCallExpression(initializer)) {
            const e = skipParentheses(initializer.expression);
            return e.kind === 217 /* FunctionExpression */  || e.kind === 218 /* ArrowFunction */  ? initializer : void 0;
        }
        if (initializer.kind === 217 /* FunctionExpression */  || initializer.kind === 230 /* ClassExpression */  || initializer.kind === 218 /* ArrowFunction */ ) return initializer;
        if (isObjectLiteralExpression(initializer) && (initializer.properties.length === 0 || isPrototypeAssignment)) return initializer;
    }
    function getDefaultedExpandoInitializer(name, initializer, isPrototypeAssignment) {
        const e = isBinaryExpression(initializer) && (initializer.operatorToken.kind === 57 /* BarBarToken */  || initializer.operatorToken.kind === 61 /* QuestionQuestionToken */ ) && getExpandoInitializer(initializer.right, isPrototypeAssignment);
        if (e && isSameEntityName(name, initializer.left)) return e;
    }
    function isDefaultedExpandoInitializer(node) {
        const name = isVariableDeclaration(node.parent) ? node.parent.name : isBinaryExpression(node.parent) && node.parent.operatorToken.kind === 64 /* EqualsToken */  ? node.parent.left : void 0;
        return name && getExpandoInitializer(node.right, isPrototypeAccess(name)) && isEntityNameExpression(name) && isSameEntityName(name, node.left);
    }
    function getNameOfExpando(node) {
        if (isBinaryExpression(node.parent)) {
            const parent2 = (node.parent.operatorToken.kind === 57 /* BarBarToken */  || node.parent.operatorToken.kind === 61 /* QuestionQuestionToken */ ) && isBinaryExpression(node.parent.parent) ? node.parent.parent : node.parent;
            if (parent2.operatorToken.kind === 64 /* EqualsToken */  && isIdentifier(parent2.left)) return parent2.left;
        } else if (isVariableDeclaration(node.parent)) return node.parent.name;
    }
    function isSameEntityName(name, initializer) {
        if (isPropertyNameLiteral(name) && isPropertyNameLiteral(initializer)) return getTextOfIdentifierOrLiteral(name) === getTextOfIdentifierOrLiteral(initializer);
        if (isMemberName(name) && isLiteralLikeAccess(initializer) && (initializer.expression.kind === 110 /* ThisKeyword */  || isIdentifier(initializer.expression) && (initializer.expression.escapedText === "window" || initializer.expression.escapedText === "self" || initializer.expression.escapedText === "global"))) return isSameEntityName(name, getNameOrArgument(initializer));
        if (isLiteralLikeAccess(name) && isLiteralLikeAccess(initializer)) return getElementOrPropertyAccessName(name) === getElementOrPropertyAccessName(initializer) && isSameEntityName(name.expression, initializer.expression);
        return false;
    }
    function getRightMostAssignedExpression(node) {
        while(isAssignmentExpression(node, /*excludeCompoundAssignment*/ true))node = node.right;
        return node;
    }
    function isExportsIdentifier(node) {
        return isIdentifier(node) && node.escapedText === "exports";
    }
    function isModuleIdentifier(node) {
        return isIdentifier(node) && node.escapedText === "module";
    }
    function isModuleExportsAccessExpression(node) {
        return (isPropertyAccessExpression(node) || isLiteralLikeElementAccess(node)) && isModuleIdentifier(node.expression) && getElementOrPropertyAccessName(node) === "exports";
    }
    function getAssignmentDeclarationKind(expr) {
        const special = getAssignmentDeclarationKindWorker(expr);
        return special === 5 /* Property */  || isInJSFile(expr) ? special : 0 /* None */ ;
    }
    function isBindableObjectDefinePropertyCall(expr) {
        return length(expr.arguments) === 3 && isPropertyAccessExpression(expr.expression) && isIdentifier(expr.expression.expression) && idText(expr.expression.expression) === "Object" && idText(expr.expression.name) === "defineProperty" && isStringOrNumericLiteralLike(expr.arguments[1]) && isBindableStaticNameExpression(expr.arguments[0], /*excludeThisKeyword*/ true);
    }
    function isLiteralLikeAccess(node) {
        return isPropertyAccessExpression(node) || isLiteralLikeElementAccess(node);
    }
    function isLiteralLikeElementAccess(node) {
        return isElementAccessExpression(node) && isStringOrNumericLiteralLike(node.argumentExpression);
    }
    function isBindableStaticAccessExpression(node, excludeThisKeyword) {
        return isPropertyAccessExpression(node) && (!excludeThisKeyword && node.expression.kind === 110 /* ThisKeyword */  || isIdentifier(node.name) && isBindableStaticNameExpression(node.expression, /*excludeThisKeyword*/ true)) || isBindableStaticElementAccessExpression(node, excludeThisKeyword);
    }
    function isBindableStaticElementAccessExpression(node, excludeThisKeyword) {
        return isLiteralLikeElementAccess(node) && (!excludeThisKeyword && node.expression.kind === 110 /* ThisKeyword */  || isEntityNameExpression(node.expression) || isBindableStaticAccessExpression(node.expression, /*excludeThisKeyword*/ true));
    }
    function isBindableStaticNameExpression(node, excludeThisKeyword) {
        return isEntityNameExpression(node) || isBindableStaticAccessExpression(node, excludeThisKeyword);
    }
    function getNameOrArgument(expr) {
        if (isPropertyAccessExpression(expr)) return expr.name;
        return expr.argumentExpression;
    }
    function getAssignmentDeclarationKindWorker(expr) {
        if (isCallExpression(expr)) {
            if (!isBindableObjectDefinePropertyCall(expr)) return 0 /* None */ ;
            const entityName = expr.arguments[0];
            if (isExportsIdentifier(entityName) || isModuleExportsAccessExpression(entityName)) return 8 /* ObjectDefinePropertyExports */ ;
            if (isBindableStaticAccessExpression(entityName) && getElementOrPropertyAccessName(entityName) === "prototype") return 9 /* ObjectDefinePrototypeProperty */ ;
            return 7 /* ObjectDefinePropertyValue */ ;
        }
        if (expr.operatorToken.kind !== 64 /* EqualsToken */  || !isAccessExpression(expr.left) || isVoidZero(getRightMostAssignedExpression(expr))) return 0 /* None */ ;
        if (isBindableStaticNameExpression(expr.left.expression, /*excludeThisKeyword*/ true) && getElementOrPropertyAccessName(expr.left) === "prototype" && isObjectLiteralExpression(getInitializerOfBinaryExpression(expr))) return 6 /* Prototype */ ;
        return getAssignmentDeclarationPropertyAccessKind(expr.left);
    }
    function isVoidZero(node) {
        return isVoidExpression(node) && isNumericLiteral(node.expression) && node.expression.text === "0";
    }
    function getElementOrPropertyAccessArgumentExpressionOrName(node) {
        if (isPropertyAccessExpression(node)) return node.name;
        const arg = skipParentheses(node.argumentExpression);
        if (isNumericLiteral(arg) || isStringLiteralLike(arg)) return arg;
        return node;
    }
    function getElementOrPropertyAccessName(node) {
        const name = getElementOrPropertyAccessArgumentExpressionOrName(node);
        if (name) {
            if (isIdentifier(name)) return name.escapedText;
            if (isStringLiteralLike(name) || isNumericLiteral(name)) return escapeLeadingUnderscores(name.text);
        }
        return void 0;
    }
    function getAssignmentDeclarationPropertyAccessKind(lhs) {
        if (lhs.expression.kind === 110 /* ThisKeyword */ ) return 4 /* ThisProperty */ ;
        else if (isModuleExportsAccessExpression(lhs)) return 2 /* ModuleExports */ ;
        else if (isBindableStaticNameExpression(lhs.expression, /*excludeThisKeyword*/ true)) {
            if (isPrototypeAccess(lhs.expression)) return 3 /* PrototypeProperty */ ;
            let nextToLast = lhs;
            while(!isIdentifier(nextToLast.expression))nextToLast = nextToLast.expression;
            const id = nextToLast.expression;
            if ((id.escapedText === "exports" || id.escapedText === "module" && getElementOrPropertyAccessName(nextToLast) === "exports") && // ExportsProperty does not support binding with computed names
            isBindableStaticAccessExpression(lhs)) return 1 /* ExportsProperty */ ;
            if (isBindableStaticNameExpression(lhs, /*excludeThisKeyword*/ true) || isElementAccessExpression(lhs) && isDynamicName(lhs)) return 5 /* Property */ ;
        }
        return 0 /* None */ ;
    }
    function getInitializerOfBinaryExpression(expr) {
        while(isBinaryExpression(expr.right))expr = expr.right;
        return expr.right;
    }
    function isPrototypePropertyAssignment(node) {
        return isBinaryExpression(node) && getAssignmentDeclarationKind(node) === 3 /* PrototypeProperty */ ;
    }
    function isSpecialPropertyDeclaration(expr) {
        return isInJSFile(expr) && expr.parent && expr.parent.kind === 243 /* ExpressionStatement */  && (!isElementAccessExpression(expr) || isLiteralLikeElementAccess(expr)) && !!getJSDocTypeTag(expr.parent);
    }
    function setValueDeclaration(symbol, node) {
        const { valueDeclaration: valueDeclaration  } = symbol;
        if (!valueDeclaration || !(node.flags & 16777216 /* Ambient */  && !isInJSFile(node) && !(valueDeclaration.flags & 16777216 /* Ambient */ )) && isAssignmentDeclaration(valueDeclaration) && !isAssignmentDeclaration(node) || valueDeclaration.kind !== node.kind && isEffectiveModuleDeclaration(valueDeclaration)) symbol.valueDeclaration = node;
    }
    function isFunctionSymbol(symbol) {
        if (!symbol || !symbol.valueDeclaration) return false;
        const decl = symbol.valueDeclaration;
        return decl.kind === 261 /* FunctionDeclaration */  || isVariableDeclaration(decl) && decl.initializer && isFunctionLike(decl.initializer);
    }
    function tryGetModuleSpecifierFromDeclaration(node) {
        var _a, _b;
        switch(node.kind){
            case 259 /* VariableDeclaration */ :
            case 207 /* BindingElement */ :
                return (_a = findAncestor(node.initializer, (node2)=>isRequireCall(node2, /*requireStringLiteralLikeArgument*/ true))) == null ? void 0 : _a.arguments[0];
            case 271 /* ImportDeclaration */ :
                return tryCast(node.moduleSpecifier, isStringLiteralLike);
            case 270 /* ImportEqualsDeclaration */ :
                return tryCast((_b = tryCast(node.moduleReference, isExternalModuleReference)) == null ? void 0 : _b.expression, isStringLiteralLike);
            case 272 /* ImportClause */ :
            case 279 /* NamespaceExport */ :
                return tryCast(node.parent.moduleSpecifier, isStringLiteralLike);
            case 273 /* NamespaceImport */ :
            case 280 /* ExportSpecifier */ :
                return tryCast(node.parent.parent.moduleSpecifier, isStringLiteralLike);
            case 275 /* ImportSpecifier */ :
                return tryCast(node.parent.parent.parent.moduleSpecifier, isStringLiteralLike);
            default:
                Debug.assertNever(node);
        }
    }
    function importFromModuleSpecifier(node) {
        return tryGetImportFromModuleSpecifier(node) || Debug.failBadSyntaxKind(node.parent);
    }
    function tryGetImportFromModuleSpecifier(node) {
        switch(node.parent.kind){
            case 271 /* ImportDeclaration */ :
            case 277 /* ExportDeclaration */ :
                return node.parent;
            case 282 /* ExternalModuleReference */ :
                return node.parent.parent;
            case 212 /* CallExpression */ :
                return isImportCall(node.parent) || isRequireCall(node.parent, /*requireStringLiteralLikeArgument*/ false) ? node.parent : void 0;
            case 200 /* LiteralType */ :
                Debug.assert(isStringLiteral(node));
                return tryCast(node.parent.parent, isImportTypeNode);
            default:
                return void 0;
        }
    }
    function getExternalModuleName(node) {
        switch(node.kind){
            case 271 /* ImportDeclaration */ :
            case 277 /* ExportDeclaration */ :
                return node.moduleSpecifier;
            case 270 /* ImportEqualsDeclaration */ :
                return node.moduleReference.kind === 282 /* ExternalModuleReference */  ? node.moduleReference.expression : void 0;
            case 204 /* ImportType */ :
                return isLiteralImportTypeNode(node) ? node.argument.literal : void 0;
            case 212 /* CallExpression */ :
                return node.arguments[0];
            case 266 /* ModuleDeclaration */ :
                return node.name.kind === 11 /* StringLiteral */  ? node.name : void 0;
            default:
                return Debug.assertNever(node);
        }
    }
    function getNamespaceDeclarationNode(node) {
        switch(node.kind){
            case 271 /* ImportDeclaration */ :
                return node.importClause && tryCast(node.importClause.namedBindings, isNamespaceImport);
            case 270 /* ImportEqualsDeclaration */ :
                return node;
            case 277 /* ExportDeclaration */ :
                return node.exportClause && tryCast(node.exportClause, isNamespaceExport);
            default:
                return Debug.assertNever(node);
        }
    }
    function isDefaultImport(node) {
        return node.kind === 271 /* ImportDeclaration */  && !!node.importClause && !!node.importClause.name;
    }
    function forEachImportClauseDeclaration(node, action) {
        if (node.name) {
            const result = action(node);
            if (result) return result;
        }
        if (node.namedBindings) {
            const result = isNamespaceImport(node.namedBindings) ? action(node.namedBindings) : forEach(node.namedBindings.elements, action);
            if (result) return result;
        }
    }
    function hasQuestionToken(node) {
        if (node) switch(node.kind){
            case 168 /* Parameter */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 303 /* ShorthandPropertyAssignment */ :
            case 302 /* PropertyAssignment */ :
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
                return node.questionToken !== void 0;
        }
        return false;
    }
    function isJSDocConstructSignature(node) {
        const param = isJSDocFunctionType(node) ? firstOrUndefined(node.parameters) : void 0;
        const name = tryCast(param && param.name, isIdentifier);
        return !!name && name.escapedText === "new";
    }
    function isJSDocTypeAlias(node) {
        return node.kind === 352 /* JSDocTypedefTag */  || node.kind === 344 /* JSDocCallbackTag */  || node.kind === 346 /* JSDocEnumTag */ ;
    }
    function isTypeAlias(node) {
        return isJSDocTypeAlias(node) || isTypeAliasDeclaration(node);
    }
    function getSourceOfAssignment(node) {
        return isExpressionStatement(node) && isBinaryExpression(node.expression) && node.expression.operatorToken.kind === 64 /* EqualsToken */  ? getRightMostAssignedExpression(node.expression) : void 0;
    }
    function getSourceOfDefaultedAssignment(node) {
        return isExpressionStatement(node) && isBinaryExpression(node.expression) && getAssignmentDeclarationKind(node.expression) !== 0 /* None */  && isBinaryExpression(node.expression.right) && (node.expression.right.operatorToken.kind === 57 /* BarBarToken */  || node.expression.right.operatorToken.kind === 61 /* QuestionQuestionToken */ ) ? node.expression.right.right : void 0;
    }
    function getSingleInitializerOfVariableStatementOrPropertyDeclaration(node) {
        switch(node.kind){
            case 242 /* VariableStatement */ :
                const v = getSingleVariableOfVariableStatement(node);
                return v && v.initializer;
            case 171 /* PropertyDeclaration */ :
                return node.initializer;
            case 302 /* PropertyAssignment */ :
                return node.initializer;
        }
    }
    function getSingleVariableOfVariableStatement(node) {
        return isVariableStatement(node) ? firstOrUndefined(node.declarationList.declarations) : void 0;
    }
    function getNestedModuleDeclaration(node) {
        return isModuleDeclaration(node) && node.body && node.body.kind === 266 /* ModuleDeclaration */  ? node.body : void 0;
    }
    function canHaveFlowNode(node) {
        if (node.kind >= 242 /* FirstStatement */  && node.kind <= 258 /* LastStatement */ ) return true;
        switch(node.kind){
            case 80 /* Identifier */ :
            case 110 /* ThisKeyword */ :
            case 108 /* SuperKeyword */ :
            case 165 /* QualifiedName */ :
            case 235 /* MetaProperty */ :
            case 211 /* ElementAccessExpression */ :
            case 210 /* PropertyAccessExpression */ :
            case 207 /* BindingElement */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
                return true;
            default:
                return false;
        }
    }
    function canHaveJSDoc(node) {
        switch(node.kind){
            case 218 /* ArrowFunction */ :
            case 225 /* BinaryExpression */ :
            case 240 /* Block */ :
            case 251 /* BreakStatement */ :
            case 178 /* CallSignature */ :
            case 295 /* CaseClause */ :
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
            case 174 /* ClassStaticBlockDeclaration */ :
            case 175 /* Constructor */ :
            case 184 /* ConstructorType */ :
            case 179 /* ConstructSignature */ :
            case 250 /* ContinueStatement */ :
            case 258 /* DebuggerStatement */ :
            case 245 /* DoStatement */ :
            case 211 /* ElementAccessExpression */ :
            case 241 /* EmptyStatement */ :
            case 1 /* EndOfFileToken */ :
            case 265 /* EnumDeclaration */ :
            case 305 /* EnumMember */ :
            case 276 /* ExportAssignment */ :
            case 277 /* ExportDeclaration */ :
            case 280 /* ExportSpecifier */ :
            case 243 /* ExpressionStatement */ :
            case 248 /* ForInStatement */ :
            case 249 /* ForOfStatement */ :
            case 247 /* ForStatement */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 183 /* FunctionType */ :
            case 176 /* GetAccessor */ :
            case 80 /* Identifier */ :
            case 244 /* IfStatement */ :
            case 271 /* ImportDeclaration */ :
            case 270 /* ImportEqualsDeclaration */ :
            case 180 /* IndexSignature */ :
            case 263 /* InterfaceDeclaration */ :
            case 323 /* JSDocFunctionType */ :
            case 329 /* JSDocSignature */ :
            case 255 /* LabeledStatement */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 266 /* ModuleDeclaration */ :
            case 201 /* NamedTupleMember */ :
            case 269 /* NamespaceExportDeclaration */ :
            case 209 /* ObjectLiteralExpression */ :
            case 168 /* Parameter */ :
            case 216 /* ParenthesizedExpression */ :
            case 210 /* PropertyAccessExpression */ :
            case 302 /* PropertyAssignment */ :
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
            case 252 /* ReturnStatement */ :
            case 239 /* SemicolonClassElement */ :
            case 177 /* SetAccessor */ :
            case 303 /* ShorthandPropertyAssignment */ :
            case 304 /* SpreadAssignment */ :
            case 254 /* SwitchStatement */ :
            case 256 /* ThrowStatement */ :
            case 257 /* TryStatement */ :
            case 264 /* TypeAliasDeclaration */ :
            case 167 /* TypeParameter */ :
            case 259 /* VariableDeclaration */ :
            case 242 /* VariableStatement */ :
            case 246 /* WhileStatement */ :
            case 253 /* WithStatement */ :
                return true;
            default:
                return false;
        }
    }
    function getJSDocCommentsAndTags(hostNode, noCache) {
        let result;
        if (isVariableLike(hostNode) && hasInitializer(hostNode) && hasJSDocNodes(hostNode.initializer)) result = addRange(result, filterOwnedJSDocTags(hostNode, last(hostNode.initializer.jsDoc)));
        let node = hostNode;
        while(node && node.parent){
            if (hasJSDocNodes(node)) result = addRange(result, filterOwnedJSDocTags(hostNode, last(node.jsDoc)));
            if (node.kind === 168 /* Parameter */ ) {
                result = addRange(result, (noCache ? getJSDocParameterTagsNoCache : getJSDocParameterTags)(node));
                break;
            }
            if (node.kind === 167 /* TypeParameter */ ) {
                result = addRange(result, (noCache ? getJSDocTypeParameterTagsNoCache : getJSDocTypeParameterTags)(node));
                break;
            }
            node = getNextJSDocCommentLocation(node);
        }
        return result || emptyArray;
    }
    function filterOwnedJSDocTags(hostNode, jsDoc) {
        if (isJSDoc(jsDoc)) {
            const ownedTags = filter(jsDoc.tags, (tag)=>ownsJSDocTag(hostNode, tag));
            return jsDoc.tags === ownedTags ? [
                jsDoc
            ] : ownedTags;
        }
        return ownsJSDocTag(hostNode, jsDoc) ? [
            jsDoc
        ] : void 0;
    }
    function ownsJSDocTag(hostNode, tag) {
        return !(isJSDocTypeTag(tag) || isJSDocSatisfiesTag(tag)) || !tag.parent || !isJSDoc(tag.parent) || !isParenthesizedExpression(tag.parent.parent) || tag.parent.parent === hostNode;
    }
    function getNextJSDocCommentLocation(node) {
        const parent2 = node.parent;
        if (parent2.kind === 302 /* PropertyAssignment */  || parent2.kind === 276 /* ExportAssignment */  || parent2.kind === 171 /* PropertyDeclaration */  || parent2.kind === 243 /* ExpressionStatement */  && node.kind === 210 /* PropertyAccessExpression */  || parent2.kind === 252 /* ReturnStatement */  || getNestedModuleDeclaration(parent2) || isBinaryExpression(node) && node.operatorToken.kind === 64 /* EqualsToken */ ) return parent2;
        else if (parent2.parent && (getSingleVariableOfVariableStatement(parent2.parent) === node || isBinaryExpression(parent2) && parent2.operatorToken.kind === 64 /* EqualsToken */ )) return parent2.parent;
        else if (parent2.parent && parent2.parent.parent && (getSingleVariableOfVariableStatement(parent2.parent.parent) || getSingleInitializerOfVariableStatementOrPropertyDeclaration(parent2.parent.parent) === node || getSourceOfDefaultedAssignment(parent2.parent.parent))) return parent2.parent.parent;
    }
    function getParameterSymbolFromJSDoc(node) {
        if (node.symbol) return node.symbol;
        if (!isIdentifier(node.name)) return void 0;
        const name = node.name.escapedText;
        const decl = getHostSignatureFromJSDoc(node);
        if (!decl) return void 0;
        const parameter = find(decl.parameters, (p)=>p.name.kind === 80 /* Identifier */  && p.name.escapedText === name);
        return parameter && parameter.symbol;
    }
    function getEffectiveContainerForJSDocTemplateTag(node) {
        if (isJSDoc(node.parent) && node.parent.tags) {
            const typeAlias = find(node.parent.tags, isJSDocTypeAlias);
            if (typeAlias) return typeAlias;
        }
        return getHostSignatureFromJSDoc(node);
    }
    function getHostSignatureFromJSDoc(node) {
        const host = getEffectiveJSDocHost(node);
        if (host) return isPropertySignature(host) && host.type && isFunctionLike(host.type) ? host.type : isFunctionLike(host) ? host : void 0;
        return void 0;
    }
    function getEffectiveJSDocHost(node) {
        const host = getJSDocHost(node);
        if (host) return getSourceOfDefaultedAssignment(host) || getSourceOfAssignment(host) || getSingleInitializerOfVariableStatementOrPropertyDeclaration(host) || getSingleVariableOfVariableStatement(host) || getNestedModuleDeclaration(host) || host;
    }
    function getJSDocHost(node) {
        const jsDoc = getJSDocRoot(node);
        if (!jsDoc) return void 0;
        const host = jsDoc.parent;
        if (host && host.jsDoc && jsDoc === lastOrUndefined(host.jsDoc)) return host;
    }
    function getJSDocRoot(node) {
        return findAncestor(node.parent, isJSDoc);
    }
    function getTypeParameterFromJsDoc(node) {
        const name = node.name.escapedText;
        const { typeParameters: typeParameters  } = node.parent.parent.parent;
        return typeParameters && find(typeParameters, (p)=>p.name.escapedText === name);
    }
    function hasTypeArguments(node) {
        return !!node.typeArguments;
    }
    function getAssignmentTargetKind(node) {
        let parent2 = node.parent;
        while(true){
            switch(parent2.kind){
                case 225 /* BinaryExpression */ :
                    const binaryOperator = parent2.operatorToken.kind;
                    return isAssignmentOperator(binaryOperator) && parent2.left === node ? binaryOperator === 64 /* EqualsToken */  || isLogicalOrCoalescingAssignmentOperator(binaryOperator) ? 1 /* Definite */  : 2 /* Compound */  : 0 /* None */ ;
                case 223 /* PrefixUnaryExpression */ :
                case 224 /* PostfixUnaryExpression */ :
                    const unaryOperator = parent2.operator;
                    return unaryOperator === 46 /* PlusPlusToken */  || unaryOperator === 47 /* MinusMinusToken */  ? 2 /* Compound */  : 0 /* None */ ;
                case 248 /* ForInStatement */ :
                case 249 /* ForOfStatement */ :
                    return parent2.initializer === node ? 1 /* Definite */  : 0 /* None */ ;
                case 216 /* ParenthesizedExpression */ :
                case 208 /* ArrayLiteralExpression */ :
                case 229 /* SpreadElement */ :
                case 234 /* NonNullExpression */ :
                    node = parent2;
                    break;
                case 304 /* SpreadAssignment */ :
                    node = parent2.parent;
                    break;
                case 303 /* ShorthandPropertyAssignment */ :
                    if (parent2.name !== node) return 0 /* None */ ;
                    node = parent2.parent;
                    break;
                case 302 /* PropertyAssignment */ :
                    if (parent2.name === node) return 0 /* None */ ;
                    node = parent2.parent;
                    break;
                default:
                    return 0 /* None */ ;
            }
            parent2 = node.parent;
        }
    }
    function isAssignmentTarget(node) {
        return getAssignmentTargetKind(node) !== 0 /* None */ ;
    }
    function isNodeWithPossibleHoistedDeclaration(node) {
        switch(node.kind){
            case 240 /* Block */ :
            case 242 /* VariableStatement */ :
            case 253 /* WithStatement */ :
            case 244 /* IfStatement */ :
            case 254 /* SwitchStatement */ :
            case 268 /* CaseBlock */ :
            case 295 /* CaseClause */ :
            case 296 /* DefaultClause */ :
            case 255 /* LabeledStatement */ :
            case 247 /* ForStatement */ :
            case 248 /* ForInStatement */ :
            case 249 /* ForOfStatement */ :
            case 245 /* DoStatement */ :
            case 246 /* WhileStatement */ :
            case 257 /* TryStatement */ :
            case 298 /* CatchClause */ :
                return true;
        }
        return false;
    }
    function isValueSignatureDeclaration(node) {
        return isFunctionExpression(node) || isArrowFunction(node) || isMethodOrAccessor(node) || isFunctionDeclaration(node) || isConstructorDeclaration(node);
    }
    function walkUp(node, kind) {
        while(node && node.kind === kind)node = node.parent;
        return node;
    }
    function walkUpParenthesizedTypes(node) {
        return walkUp(node, 195 /* ParenthesizedType */ );
    }
    function walkUpParenthesizedExpressions(node) {
        return walkUp(node, 216 /* ParenthesizedExpression */ );
    }
    function walkUpParenthesizedTypesAndGetParentAndChild(node) {
        let child;
        while(node && node.kind === 195 /* ParenthesizedType */ ){
            child = node;
            node = node.parent;
        }
        return [
            child,
            node
        ];
    }
    function skipTypeParentheses(node) {
        while(isParenthesizedTypeNode(node))node = node.type;
        return node;
    }
    function skipParentheses(node, excludeJSDocTypeAssertions) {
        const flags = excludeJSDocTypeAssertions ? 17 /* ExcludeJSDocTypeAssertion */  : 1 /* Parentheses */ ;
        return skipOuterExpressions(node, flags);
    }
    function isDeleteTarget(node) {
        if (node.kind !== 210 /* PropertyAccessExpression */  && node.kind !== 211 /* ElementAccessExpression */ ) return false;
        node = walkUpParenthesizedExpressions(node.parent);
        return node && node.kind === 219 /* DeleteExpression */ ;
    }
    function isNodeDescendantOf(node, ancestor) {
        while(node){
            if (node === ancestor) return true;
            node = node.parent;
        }
        return false;
    }
    function isDeclarationName(name) {
        return !isSourceFile(name) && !isBindingPattern(name) && isDeclaration(name.parent) && name.parent.name === name;
    }
    function getDeclarationFromName(name) {
        const parent2 = name.parent;
        switch(name.kind){
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 9 /* NumericLiteral */ :
                if (isComputedPropertyName(parent2)) return parent2.parent;
            case 80 /* Identifier */ :
                if (isDeclaration(parent2)) return parent2.name === name ? parent2 : void 0;
                else if (isQualifiedName(parent2)) {
                    const tag = parent2.parent;
                    return isJSDocParameterTag(tag) && tag.name === parent2 ? tag : void 0;
                } else {
                    const binExp = parent2.parent;
                    return isBinaryExpression(binExp) && getAssignmentDeclarationKind(binExp) !== 0 /* None */  && (binExp.left.symbol || binExp.symbol) && getNameOfDeclaration(binExp) === name ? binExp : void 0;
                }
            case 81 /* PrivateIdentifier */ :
                return isDeclaration(parent2) && parent2.name === name ? parent2 : void 0;
            default:
                return void 0;
        }
    }
    function isLiteralComputedPropertyDeclarationName(node) {
        return isStringOrNumericLiteralLike(node) && node.parent.kind === 166 /* ComputedPropertyName */  && isDeclaration(node.parent.parent);
    }
    function isIdentifierName(node) {
        const parent2 = node.parent;
        switch(parent2.kind){
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 305 /* EnumMember */ :
            case 302 /* PropertyAssignment */ :
            case 210 /* PropertyAccessExpression */ :
                return parent2.name === node;
            case 165 /* QualifiedName */ :
                return parent2.right === node;
            case 207 /* BindingElement */ :
            case 275 /* ImportSpecifier */ :
                return parent2.propertyName === node;
            case 280 /* ExportSpecifier */ :
            case 290 /* JsxAttribute */ :
            case 284 /* JsxSelfClosingElement */ :
            case 285 /* JsxOpeningElement */ :
            case 286 /* JsxClosingElement */ :
                return true;
        }
        return false;
    }
    function isAliasSymbolDeclaration(node) {
        if (node.kind === 270 /* ImportEqualsDeclaration */  || node.kind === 269 /* NamespaceExportDeclaration */  || node.kind === 272 /* ImportClause */  && !!node.name || node.kind === 273 /* NamespaceImport */  || node.kind === 279 /* NamespaceExport */  || node.kind === 275 /* ImportSpecifier */  || node.kind === 280 /* ExportSpecifier */  || node.kind === 276 /* ExportAssignment */  && exportAssignmentIsAlias(node)) return true;
        return isInJSFile(node) && (isBinaryExpression(node) && getAssignmentDeclarationKind(node) === 2 /* ModuleExports */  && exportAssignmentIsAlias(node) || isPropertyAccessExpression(node) && isBinaryExpression(node.parent) && node.parent.left === node && node.parent.operatorToken.kind === 64 /* EqualsToken */  && isAliasableExpression(node.parent.right));
    }
    function getAliasDeclarationFromName(node) {
        switch(node.parent.kind){
            case 272 /* ImportClause */ :
            case 275 /* ImportSpecifier */ :
            case 273 /* NamespaceImport */ :
            case 280 /* ExportSpecifier */ :
            case 276 /* ExportAssignment */ :
            case 270 /* ImportEqualsDeclaration */ :
            case 279 /* NamespaceExport */ :
                return node.parent;
            case 165 /* QualifiedName */ :
                do node = node.parent;
                while (node.parent.kind === 165 /* QualifiedName */ );
                return getAliasDeclarationFromName(node);
        }
    }
    function isAliasableExpression(e) {
        return isEntityNameExpression(e) || isClassExpression(e);
    }
    function exportAssignmentIsAlias(node) {
        const e = getExportAssignmentExpression(node);
        return isAliasableExpression(e);
    }
    function getExportAssignmentExpression(node) {
        return isExportAssignment(node) ? node.expression : node.right;
    }
    function getPropertyAssignmentAliasLikeExpression(node) {
        return node.kind === 303 /* ShorthandPropertyAssignment */  ? node.name : node.kind === 302 /* PropertyAssignment */  ? node.initializer : node.parent.right;
    }
    function getEffectiveBaseTypeNode(node) {
        const baseType = getClassExtendsHeritageElement(node);
        if (baseType && isInJSFile(node)) {
            const tag = getJSDocAugmentsTag(node);
            if (tag) return tag.class;
        }
        return baseType;
    }
    function getClassExtendsHeritageElement(node) {
        const heritageClause = getHeritageClause(node.heritageClauses, 96 /* ExtendsKeyword */ );
        return heritageClause && heritageClause.types.length > 0 ? heritageClause.types[0] : void 0;
    }
    function getEffectiveImplementsTypeNodes(node) {
        if (isInJSFile(node)) return getJSDocImplementsTags(node).map((n)=>n.class);
        else {
            const heritageClause = getHeritageClause(node.heritageClauses, 119 /* ImplementsKeyword */ );
            return heritageClause == null ? void 0 : heritageClause.types;
        }
    }
    function getAllSuperTypeNodes(node) {
        return isInterfaceDeclaration(node) ? getInterfaceBaseTypeNodes(node) || emptyArray : isClassLike(node) ? concatenate(singleElementArray(getEffectiveBaseTypeNode(node)), getEffectiveImplementsTypeNodes(node)) || emptyArray : emptyArray;
    }
    function getInterfaceBaseTypeNodes(node) {
        const heritageClause = getHeritageClause(node.heritageClauses, 96 /* ExtendsKeyword */ );
        return heritageClause ? heritageClause.types : void 0;
    }
    function getHeritageClause(clauses, kind) {
        if (clauses) for (const clause of clauses){
            if (clause.token === kind) return clause;
        }
        return void 0;
    }
    function getAncestor(node, kind) {
        while(node){
            if (node.kind === kind) return node;
            node = node.parent;
        }
        return void 0;
    }
    function isKeyword(token) {
        return 83 /* FirstKeyword */  <= token && token <= 164 /* LastKeyword */ ;
    }
    function isPunctuation(token) {
        return 19 /* FirstPunctuation */  <= token && token <= 79 /* LastPunctuation */ ;
    }
    function isKeywordOrPunctuation(token) {
        return isKeyword(token) || isPunctuation(token);
    }
    function isContextualKeyword(token) {
        return 128 /* FirstContextualKeyword */  <= token && token <= 164 /* LastContextualKeyword */ ;
    }
    function isNonContextualKeyword(token) {
        return isKeyword(token) && !isContextualKeyword(token);
    }
    function isFutureReservedKeyword(token) {
        return 119 /* FirstFutureReservedWord */  <= token && token <= 127 /* LastFutureReservedWord */ ;
    }
    function isStringANonContextualKeyword(name) {
        const token = stringToToken(name);
        return token !== void 0 && isNonContextualKeyword(token);
    }
    function isStringAKeyword(name) {
        const token = stringToToken(name);
        return token !== void 0 && isKeyword(token);
    }
    function isIdentifierANonContextualKeyword(node) {
        const originalKeywordKind = identifierToKeywordKind(node);
        return !!originalKeywordKind && !isContextualKeyword(originalKeywordKind);
    }
    function isTrivia(token) {
        return 2 /* FirstTriviaToken */  <= token && token <= 7 /* LastTriviaToken */ ;
    }
    function getFunctionFlags(node) {
        if (!node) return 4 /* Invalid */ ;
        let flags = 0 /* Normal */ ;
        switch(node.kind){
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 173 /* MethodDeclaration */ :
                if (node.asteriskToken) flags |= 1 /* Generator */ ;
            case 218 /* ArrowFunction */ :
                if (hasSyntacticModifier(node, 512 /* Async */ )) flags |= 2 /* Async */ ;
                break;
        }
        if (!node.body) flags |= 4 /* Invalid */ ;
        return flags;
    }
    function isAsyncFunction(node) {
        switch(node.kind){
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
            case 173 /* MethodDeclaration */ :
                return node.body !== void 0 && node.asteriskToken === void 0 && hasSyntacticModifier(node, 512 /* Async */ );
        }
        return false;
    }
    function isStringOrNumericLiteralLike(node) {
        return isStringLiteralLike(node) || isNumericLiteral(node);
    }
    function isSignedNumericLiteral(node) {
        return isPrefixUnaryExpression(node) && (node.operator === 40 /* PlusToken */  || node.operator === 41 /* MinusToken */ ) && isNumericLiteral(node.operand);
    }
    function hasDynamicName(declaration) {
        const name = getNameOfDeclaration(declaration);
        return !!name && isDynamicName(name);
    }
    function isDynamicName(name) {
        if (!(name.kind === 166 /* ComputedPropertyName */  || name.kind === 211 /* ElementAccessExpression */ )) return false;
        const expr = isElementAccessExpression(name) ? skipParentheses(name.argumentExpression) : name.expression;
        return !isStringOrNumericLiteralLike(expr) && !isSignedNumericLiteral(expr);
    }
    function getPropertyNameForPropertyNameNode(name) {
        switch(name.kind){
            case 80 /* Identifier */ :
            case 81 /* PrivateIdentifier */ :
                return name.escapedText;
            case 11 /* StringLiteral */ :
            case 9 /* NumericLiteral */ :
                return escapeLeadingUnderscores(name.text);
            case 166 /* ComputedPropertyName */ :
                const nameExpression = name.expression;
                if (isStringOrNumericLiteralLike(nameExpression)) return escapeLeadingUnderscores(nameExpression.text);
                else if (isSignedNumericLiteral(nameExpression)) {
                    if (nameExpression.operator === 41 /* MinusToken */ ) return tokenToString(nameExpression.operator) + nameExpression.operand.text;
                    return nameExpression.operand.text;
                }
                return void 0;
            case 294 /* JsxNamespacedName */ :
                return getEscapedTextOfJsxNamespacedName(name);
            default:
                return Debug.assertNever(name);
        }
    }
    function isPropertyNameLiteral(node) {
        switch(node.kind){
            case 80 /* Identifier */ :
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 9 /* NumericLiteral */ :
                return true;
            default:
                return false;
        }
    }
    function getTextOfIdentifierOrLiteral(node) {
        return isMemberName(node) ? idText(node) : isJsxNamespacedName(node) ? getTextOfJsxNamespacedName(node) : node.text;
    }
    function getEscapedTextOfIdentifierOrLiteral(node) {
        return isMemberName(node) ? node.escapedText : isJsxNamespacedName(node) ? getEscapedTextOfJsxNamespacedName(node) : escapeLeadingUnderscores(node.text);
    }
    function getPropertyNameForUniqueESSymbol(symbol) {
        return `__@${getSymbolId(symbol)}@${symbol.escapedName}`;
    }
    function getSymbolNameForPrivateIdentifier(containingClassSymbol, description3) {
        return `__#${getSymbolId(containingClassSymbol)}@${description3}`;
    }
    function isKnownSymbol(symbol) {
        return startsWith(symbol.escapedName, "__@");
    }
    function isPrivateIdentifierSymbol(symbol) {
        return startsWith(symbol.escapedName, "__#");
    }
    function isESSymbolIdentifier(node) {
        return node.kind === 80 /* Identifier */  && node.escapedText === "Symbol";
    }
    function isProtoSetter(node) {
        return isIdentifier(node) ? idText(node) === "__proto__" : isStringLiteral(node) && node.text === "__proto__";
    }
    function isAnonymousFunctionDefinition(node, cb) {
        node = skipOuterExpressions(node);
        switch(node.kind){
            case 230 /* ClassExpression */ :
            case 217 /* FunctionExpression */ :
                if (node.name) return false;
                break;
            case 218 /* ArrowFunction */ :
                break;
            default:
                return false;
        }
        return typeof cb === "function" ? cb(node) : true;
    }
    function isNamedEvaluationSource(node) {
        switch(node.kind){
            case 302 /* PropertyAssignment */ :
                return !isProtoSetter(node.name);
            case 303 /* ShorthandPropertyAssignment */ :
                return !!node.objectAssignmentInitializer;
            case 259 /* VariableDeclaration */ :
                return isIdentifier(node.name) && !!node.initializer;
            case 168 /* Parameter */ :
                return isIdentifier(node.name) && !!node.initializer && !node.dotDotDotToken;
            case 207 /* BindingElement */ :
                return isIdentifier(node.name) && !!node.initializer && !node.dotDotDotToken;
            case 171 /* PropertyDeclaration */ :
                return !!node.initializer;
            case 225 /* BinaryExpression */ :
                switch(node.operatorToken.kind){
                    case 64 /* EqualsToken */ :
                    case 77 /* AmpersandAmpersandEqualsToken */ :
                    case 76 /* BarBarEqualsToken */ :
                    case 78 /* QuestionQuestionEqualsToken */ :
                        return isIdentifier(node.left);
                }
                break;
            case 276 /* ExportAssignment */ :
                return true;
        }
        return false;
    }
    function isNamedEvaluation(node, cb) {
        if (!isNamedEvaluationSource(node)) return false;
        switch(node.kind){
            case 302 /* PropertyAssignment */ :
                return isAnonymousFunctionDefinition(node.initializer, cb);
            case 303 /* ShorthandPropertyAssignment */ :
                return isAnonymousFunctionDefinition(node.objectAssignmentInitializer, cb);
            case 259 /* VariableDeclaration */ :
            case 168 /* Parameter */ :
            case 207 /* BindingElement */ :
            case 171 /* PropertyDeclaration */ :
                return isAnonymousFunctionDefinition(node.initializer, cb);
            case 225 /* BinaryExpression */ :
                return isAnonymousFunctionDefinition(node.right, cb);
            case 276 /* ExportAssignment */ :
                return isAnonymousFunctionDefinition(node.expression, cb);
        }
    }
    function isPushOrUnshiftIdentifier(node) {
        return node.escapedText === "push" || node.escapedText === "unshift";
    }
    function isParameterDeclaration(node) {
        const root = getRootDeclaration(node);
        return root.kind === 168 /* Parameter */ ;
    }
    function getRootDeclaration(node) {
        while(node.kind === 207 /* BindingElement */ )node = node.parent.parent;
        return node;
    }
    function nodeStartsNewLexicalEnvironment(node) {
        const kind = node.kind;
        return kind === 175 /* Constructor */  || kind === 217 /* FunctionExpression */  || kind === 261 /* FunctionDeclaration */  || kind === 218 /* ArrowFunction */  || kind === 173 /* MethodDeclaration */  || kind === 176 /* GetAccessor */  || kind === 177 /* SetAccessor */  || kind === 266 /* ModuleDeclaration */  || kind === 311 /* SourceFile */ ;
    }
    function nodeIsSynthesized(range) {
        return positionIsSynthesized(range.pos) || positionIsSynthesized(range.end);
    }
    function getOriginalSourceFile(sourceFile) {
        return getParseTreeNode(sourceFile, isSourceFile) || sourceFile;
    }
    function getExpressionAssociativity(expression) {
        const operator = getOperator(expression);
        const hasArguments = expression.kind === 213 /* NewExpression */  && expression.arguments !== void 0;
        return getOperatorAssociativity(expression.kind, operator, hasArguments);
    }
    function getOperatorAssociativity(kind, operator, hasArguments) {
        switch(kind){
            case 213 /* NewExpression */ :
                return hasArguments ? 0 /* Left */  : 1 /* Right */ ;
            case 223 /* PrefixUnaryExpression */ :
            case 220 /* TypeOfExpression */ :
            case 221 /* VoidExpression */ :
            case 219 /* DeleteExpression */ :
            case 222 /* AwaitExpression */ :
            case 226 /* ConditionalExpression */ :
            case 228 /* YieldExpression */ :
                return 1 /* Right */ ;
            case 225 /* BinaryExpression */ :
                switch(operator){
                    case 43 /* AsteriskAsteriskToken */ :
                    case 64 /* EqualsToken */ :
                    case 65 /* PlusEqualsToken */ :
                    case 66 /* MinusEqualsToken */ :
                    case 68 /* AsteriskAsteriskEqualsToken */ :
                    case 67 /* AsteriskEqualsToken */ :
                    case 69 /* SlashEqualsToken */ :
                    case 70 /* PercentEqualsToken */ :
                    case 71 /* LessThanLessThanEqualsToken */ :
                    case 72 /* GreaterThanGreaterThanEqualsToken */ :
                    case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                    case 74 /* AmpersandEqualsToken */ :
                    case 79 /* CaretEqualsToken */ :
                    case 75 /* BarEqualsToken */ :
                    case 76 /* BarBarEqualsToken */ :
                    case 77 /* AmpersandAmpersandEqualsToken */ :
                    case 78 /* QuestionQuestionEqualsToken */ :
                        return 1 /* Right */ ;
                }
        }
        return 0 /* Left */ ;
    }
    function getExpressionPrecedence(expression) {
        const operator = getOperator(expression);
        const hasArguments = expression.kind === 213 /* NewExpression */  && expression.arguments !== void 0;
        return getOperatorPrecedence(expression.kind, operator, hasArguments);
    }
    function getOperator(expression) {
        if (expression.kind === 225 /* BinaryExpression */ ) return expression.operatorToken.kind;
        else if (expression.kind === 223 /* PrefixUnaryExpression */  || expression.kind === 224 /* PostfixUnaryExpression */ ) return expression.operator;
        else return expression.kind;
    }
    function getOperatorPrecedence(nodeKind, operatorKind, hasArguments) {
        switch(nodeKind){
            case 360 /* CommaListExpression */ :
                return 0 /* Comma */ ;
            case 229 /* SpreadElement */ :
                return 1 /* Spread */ ;
            case 228 /* YieldExpression */ :
                return 2 /* Yield */ ;
            case 226 /* ConditionalExpression */ :
                return 4 /* Conditional */ ;
            case 225 /* BinaryExpression */ :
                switch(operatorKind){
                    case 28 /* CommaToken */ :
                        return 0 /* Comma */ ;
                    case 64 /* EqualsToken */ :
                    case 65 /* PlusEqualsToken */ :
                    case 66 /* MinusEqualsToken */ :
                    case 68 /* AsteriskAsteriskEqualsToken */ :
                    case 67 /* AsteriskEqualsToken */ :
                    case 69 /* SlashEqualsToken */ :
                    case 70 /* PercentEqualsToken */ :
                    case 71 /* LessThanLessThanEqualsToken */ :
                    case 72 /* GreaterThanGreaterThanEqualsToken */ :
                    case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                    case 74 /* AmpersandEqualsToken */ :
                    case 79 /* CaretEqualsToken */ :
                    case 75 /* BarEqualsToken */ :
                    case 76 /* BarBarEqualsToken */ :
                    case 77 /* AmpersandAmpersandEqualsToken */ :
                    case 78 /* QuestionQuestionEqualsToken */ :
                        return 3 /* Assignment */ ;
                    default:
                        return getBinaryOperatorPrecedence(operatorKind);
                }
            case 215 /* TypeAssertionExpression */ :
            case 234 /* NonNullExpression */ :
            case 223 /* PrefixUnaryExpression */ :
            case 220 /* TypeOfExpression */ :
            case 221 /* VoidExpression */ :
            case 219 /* DeleteExpression */ :
            case 222 /* AwaitExpression */ :
                return 16 /* Unary */ ;
            case 224 /* PostfixUnaryExpression */ :
                return 17 /* Update */ ;
            case 212 /* CallExpression */ :
                return 18 /* LeftHandSide */ ;
            case 213 /* NewExpression */ :
                return hasArguments ? 19 /* Member */  : 18 /* LeftHandSide */ ;
            case 214 /* TaggedTemplateExpression */ :
            case 210 /* PropertyAccessExpression */ :
            case 211 /* ElementAccessExpression */ :
            case 235 /* MetaProperty */ :
                return 19 /* Member */ ;
            case 233 /* AsExpression */ :
            case 237 /* SatisfiesExpression */ :
                return 11 /* Relational */ ;
            case 110 /* ThisKeyword */ :
            case 108 /* SuperKeyword */ :
            case 80 /* Identifier */ :
            case 81 /* PrivateIdentifier */ :
            case 106 /* NullKeyword */ :
            case 112 /* TrueKeyword */ :
            case 97 /* FalseKeyword */ :
            case 9 /* NumericLiteral */ :
            case 10 /* BigIntLiteral */ :
            case 11 /* StringLiteral */ :
            case 208 /* ArrayLiteralExpression */ :
            case 209 /* ObjectLiteralExpression */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
            case 230 /* ClassExpression */ :
            case 14 /* RegularExpressionLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 227 /* TemplateExpression */ :
            case 216 /* ParenthesizedExpression */ :
            case 231 /* OmittedExpression */ :
            case 283 /* JsxElement */ :
            case 284 /* JsxSelfClosingElement */ :
            case 287 /* JsxFragment */ :
                return 20 /* Primary */ ;
            default:
                return -1 /* Invalid */ ;
        }
    }
    function getBinaryOperatorPrecedence(kind) {
        switch(kind){
            case 61 /* QuestionQuestionToken */ :
                return 4 /* Coalesce */ ;
            case 57 /* BarBarToken */ :
                return 5 /* LogicalOR */ ;
            case 56 /* AmpersandAmpersandToken */ :
                return 6 /* LogicalAND */ ;
            case 52 /* BarToken */ :
                return 7 /* BitwiseOR */ ;
            case 53 /* CaretToken */ :
                return 8 /* BitwiseXOR */ ;
            case 51 /* AmpersandToken */ :
                return 9 /* BitwiseAND */ ;
            case 35 /* EqualsEqualsToken */ :
            case 36 /* ExclamationEqualsToken */ :
            case 37 /* EqualsEqualsEqualsToken */ :
            case 38 /* ExclamationEqualsEqualsToken */ :
                return 10 /* Equality */ ;
            case 30 /* LessThanToken */ :
            case 32 /* GreaterThanToken */ :
            case 33 /* LessThanEqualsToken */ :
            case 34 /* GreaterThanEqualsToken */ :
            case 104 /* InstanceOfKeyword */ :
            case 103 /* InKeyword */ :
            case 130 /* AsKeyword */ :
            case 152 /* SatisfiesKeyword */ :
                return 11 /* Relational */ ;
            case 48 /* LessThanLessThanToken */ :
            case 49 /* GreaterThanGreaterThanToken */ :
            case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                return 12 /* Shift */ ;
            case 40 /* PlusToken */ :
            case 41 /* MinusToken */ :
                return 13 /* Additive */ ;
            case 42 /* AsteriskToken */ :
            case 44 /* SlashToken */ :
            case 45 /* PercentToken */ :
                return 14 /* Multiplicative */ ;
            case 43 /* AsteriskAsteriskToken */ :
                return 15 /* Exponentiation */ ;
        }
        return -1;
    }
    function getSemanticJsxChildren(children) {
        return filter(children, (i)=>{
            switch(i.kind){
                case 293 /* JsxExpression */ :
                    return !!i.expression;
                case 12 /* JsxText */ :
                    return !i.containsOnlyTriviaWhiteSpaces;
                default:
                    return true;
            }
        });
    }
    function createDiagnosticCollection() {
        let nonFileDiagnostics = [];
        const filesWithDiagnostics = [];
        const fileDiagnostics = /* @__PURE__ */ new Map();
        let hasReadNonFileDiagnostics = false;
        return {
            add: add,
            lookup: lookup,
            getGlobalDiagnostics: getGlobalDiagnostics,
            getDiagnostics: getDiagnostics2
        };
        function lookup(diagnostic) {
            let diagnostics;
            if (diagnostic.file) diagnostics = fileDiagnostics.get(diagnostic.file.fileName);
            else diagnostics = nonFileDiagnostics;
            if (!diagnostics) return void 0;
            const result = binarySearch(diagnostics, diagnostic, identity, compareDiagnosticsSkipRelatedInformation);
            if (result >= 0) return diagnostics[result];
            return void 0;
        }
        function add(diagnostic) {
            let diagnostics;
            if (diagnostic.file) {
                diagnostics = fileDiagnostics.get(diagnostic.file.fileName);
                if (!diagnostics) {
                    diagnostics = [];
                    fileDiagnostics.set(diagnostic.file.fileName, diagnostics);
                    insertSorted(filesWithDiagnostics, diagnostic.file.fileName, compareStringsCaseSensitive);
                }
            } else {
                if (hasReadNonFileDiagnostics) {
                    hasReadNonFileDiagnostics = false;
                    nonFileDiagnostics = nonFileDiagnostics.slice();
                }
                diagnostics = nonFileDiagnostics;
            }
            insertSorted(diagnostics, diagnostic, compareDiagnosticsSkipRelatedInformation);
        }
        function getGlobalDiagnostics() {
            hasReadNonFileDiagnostics = true;
            return nonFileDiagnostics;
        }
        function getDiagnostics2(fileName) {
            if (fileName) return fileDiagnostics.get(fileName) || [];
            const fileDiags = flatMapToMutable(filesWithDiagnostics, (f)=>fileDiagnostics.get(f));
            if (!nonFileDiagnostics.length) return fileDiags;
            fileDiags.unshift(...nonFileDiagnostics);
            return fileDiags;
        }
    }
    function escapeTemplateSubstitution(str) {
        return str.replace(templateSubstitutionRegExp, "\\${");
    }
    function hasInvalidEscape(template) {
        return template && !!(isNoSubstitutionTemplateLiteral(template) ? template.templateFlags : template.head.templateFlags || some(template.templateSpans, (span)=>!!span.literal.templateFlags));
    }
    function encodeUtf16EscapeSequence(charCode) {
        const hexCharCode = charCode.toString(16).toUpperCase();
        const paddedHexCode = ("0000" + hexCharCode).slice(-4);
        return "\\u" + paddedHexCode;
    }
    function getReplacement(c, offset, input) {
        if (c.charCodeAt(0) === 0 /* nullCharacter */ ) {
            const lookAhead = input.charCodeAt(offset + c.length);
            if (lookAhead >= 48 /* _0 */  && lookAhead <= 57 /* _9 */ ) return "\\x00";
            return "\\0";
        }
        return escapedCharsMap.get(c) || encodeUtf16EscapeSequence(c.charCodeAt(0));
    }
    function escapeString(s, quoteChar) {
        const escapedCharsRegExp = quoteChar === 96 /* backtick */  ? backtickQuoteEscapedCharsRegExp : quoteChar === 39 /* singleQuote */  ? singleQuoteEscapedCharsRegExp : doubleQuoteEscapedCharsRegExp;
        return s.replace(escapedCharsRegExp, getReplacement);
    }
    function escapeNonAsciiString(s, quoteChar) {
        s = escapeString(s, quoteChar);
        return nonAsciiCharacters.test(s) ? s.replace(nonAsciiCharacters, (c)=>encodeUtf16EscapeSequence(c.charCodeAt(0))) : s;
    }
    function encodeJsxCharacterEntity(charCode) {
        const hexCharCode = charCode.toString(16).toUpperCase();
        return "&#x" + hexCharCode + ";";
    }
    function getJsxAttributeStringReplacement(c) {
        if (c.charCodeAt(0) === 0 /* nullCharacter */ ) return "&#0;";
        return jsxEscapedCharsMap.get(c) || encodeJsxCharacterEntity(c.charCodeAt(0));
    }
    function escapeJsxAttributeString(s, quoteChar) {
        const escapedCharsRegExp = quoteChar === 39 /* singleQuote */  ? jsxSingleQuoteEscapedCharsRegExp : jsxDoubleQuoteEscapedCharsRegExp;
        return s.replace(escapedCharsRegExp, getJsxAttributeStringReplacement);
    }
    function stripQuotes(name) {
        const length2 = name.length;
        if (length2 >= 2 && name.charCodeAt(0) === name.charCodeAt(length2 - 1) && isQuoteOrBacktick(name.charCodeAt(0))) return name.substring(1, length2 - 1);
        return name;
    }
    function isQuoteOrBacktick(charCode) {
        return charCode === 39 /* singleQuote */  || charCode === 34 /* doubleQuote */  || charCode === 96 /* backtick */ ;
    }
    function isIntrinsicJsxName(name) {
        const ch = name.charCodeAt(0);
        return ch >= 97 /* a */  && ch <= 122 /* z */  || stringContains(name, "-");
    }
    function getIndentString(level) {
        const singleLevel = indentStrings[1];
        for(let current = indentStrings.length; current <= level; current++)indentStrings.push(indentStrings[current - 1] + singleLevel);
        return indentStrings[level];
    }
    function getIndentSize() {
        return indentStrings[1].length;
    }
    function isNightly() {
        return stringContains(version, "-dev") || stringContains(version, "-insiders");
    }
    function createTextWriter(newLine) {
        var output;
        var indent2;
        var lineStart;
        var lineCount;
        var linePos;
        var hasTrailingComment = false;
        function updateLineCountAndPosFor(s) {
            const lineStartsOfS = computeLineStarts(s);
            if (lineStartsOfS.length > 1) {
                lineCount = lineCount + lineStartsOfS.length - 1;
                linePos = output.length - s.length + last(lineStartsOfS);
                lineStart = linePos - output.length === 0;
            } else lineStart = false;
        }
        function writeText(s) {
            if (s && s.length) {
                if (lineStart) {
                    s = getIndentString(indent2) + s;
                    lineStart = false;
                }
                output += s;
                updateLineCountAndPosFor(s);
            }
        }
        function write(s) {
            if (s) hasTrailingComment = false;
            writeText(s);
        }
        function writeComment(s) {
            if (s) hasTrailingComment = true;
            writeText(s);
        }
        function reset2() {
            output = "";
            indent2 = 0;
            lineStart = true;
            lineCount = 0;
            linePos = 0;
            hasTrailingComment = false;
        }
        function rawWrite(s) {
            if (s !== void 0) {
                output += s;
                updateLineCountAndPosFor(s);
                hasTrailingComment = false;
            }
        }
        function writeLiteral(s) {
            if (s && s.length) write(s);
        }
        function writeLine(force) {
            if (!lineStart || force) {
                output += newLine;
                lineCount++;
                linePos = output.length;
                lineStart = true;
                hasTrailingComment = false;
            }
        }
        function getTextPosWithWriteLine() {
            return lineStart ? output.length : output.length + newLine.length;
        }
        reset2();
        return {
            write: write,
            rawWrite: rawWrite,
            writeLiteral: writeLiteral,
            writeLine: writeLine,
            increaseIndent: ()=>{
                indent2++;
            },
            decreaseIndent: ()=>{
                indent2--;
            },
            getIndent: ()=>indent2,
            getTextPos: ()=>output.length,
            getLine: ()=>lineCount,
            getColumn: ()=>lineStart ? indent2 * getIndentSize() : output.length - linePos,
            getText: ()=>output,
            isAtStartOfLine: ()=>lineStart,
            hasTrailingComment: ()=>hasTrailingComment,
            hasTrailingWhitespace: ()=>!!output.length && isWhiteSpaceLike(output.charCodeAt(output.length - 1)),
            clear: reset2,
            writeKeyword: write,
            writeOperator: write,
            writeParameter: write,
            writeProperty: write,
            writePunctuation: write,
            writeSpace: write,
            writeStringLiteral: write,
            writeSymbol: (s, _)=>write(s),
            writeTrailingSemicolon: write,
            writeComment: writeComment,
            getTextPosWithWriteLine: getTextPosWithWriteLine
        };
    }
    function getTrailingSemicolonDeferringWriter(writer) {
        let pendingTrailingSemicolon = false;
        function commitPendingTrailingSemicolon() {
            if (pendingTrailingSemicolon) {
                writer.writeTrailingSemicolon(";");
                pendingTrailingSemicolon = false;
            }
        }
        return {
            ...writer,
            writeTrailingSemicolon () {
                pendingTrailingSemicolon = true;
            },
            writeLiteral (s) {
                commitPendingTrailingSemicolon();
                writer.writeLiteral(s);
            },
            writeStringLiteral (s) {
                commitPendingTrailingSemicolon();
                writer.writeStringLiteral(s);
            },
            writeSymbol (s, sym) {
                commitPendingTrailingSemicolon();
                writer.writeSymbol(s, sym);
            },
            writePunctuation (s) {
                commitPendingTrailingSemicolon();
                writer.writePunctuation(s);
            },
            writeKeyword (s) {
                commitPendingTrailingSemicolon();
                writer.writeKeyword(s);
            },
            writeOperator (s) {
                commitPendingTrailingSemicolon();
                writer.writeOperator(s);
            },
            writeParameter (s) {
                commitPendingTrailingSemicolon();
                writer.writeParameter(s);
            },
            writeSpace (s) {
                commitPendingTrailingSemicolon();
                writer.writeSpace(s);
            },
            writeProperty (s) {
                commitPendingTrailingSemicolon();
                writer.writeProperty(s);
            },
            writeComment (s) {
                commitPendingTrailingSemicolon();
                writer.writeComment(s);
            },
            writeLine () {
                commitPendingTrailingSemicolon();
                writer.writeLine();
            },
            increaseIndent () {
                commitPendingTrailingSemicolon();
                writer.increaseIndent();
            },
            decreaseIndent () {
                commitPendingTrailingSemicolon();
                writer.decreaseIndent();
            }
        };
    }
    function hostUsesCaseSensitiveFileNames(host) {
        return host.useCaseSensitiveFileNames ? host.useCaseSensitiveFileNames() : false;
    }
    function hostGetCanonicalFileName(host) {
        return createGetCanonicalFileName(hostUsesCaseSensitiveFileNames(host));
    }
    function getResolvedExternalModuleName(host, file, referenceFile) {
        return file.moduleName || getExternalModuleNameFromPath(host, file.fileName, referenceFile && referenceFile.fileName);
    }
    function getCanonicalAbsolutePath(host, path) {
        return host.getCanonicalFileName(getNormalizedAbsolutePath(path, host.getCurrentDirectory()));
    }
    function getExternalModuleNameFromDeclaration(host, resolver, declaration) {
        const file = resolver.getExternalModuleFileFromDeclaration(declaration);
        if (!file || file.isDeclarationFile) return void 0;
        const specifier = getExternalModuleName(declaration);
        if (specifier && isStringLiteralLike(specifier) && !pathIsRelative(specifier.text) && getCanonicalAbsolutePath(host, file.path).indexOf(getCanonicalAbsolutePath(host, ensureTrailingDirectorySeparator(host.getCommonSourceDirectory()))) === -1) return void 0;
        return getResolvedExternalModuleName(host, file);
    }
    function getExternalModuleNameFromPath(host, fileName, referencePath) {
        const getCanonicalFileName = (f)=>host.getCanonicalFileName(f);
        const dir = toPath(referencePath ? getDirectoryPath(referencePath) : host.getCommonSourceDirectory(), host.getCurrentDirectory(), getCanonicalFileName);
        const filePath = getNormalizedAbsolutePath(fileName, host.getCurrentDirectory());
        const relativePath = getRelativePathToDirectoryOrUrl(dir, filePath, dir, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
        const extensionless = removeFileExtension(relativePath);
        return referencePath ? ensurePathIsNonModuleName(extensionless) : extensionless;
    }
    function getOwnEmitOutputFilePath(fileName, host, extension) {
        const compilerOptions = host.getCompilerOptions();
        let emitOutputFilePathWithoutExtension;
        if (compilerOptions.outDir) emitOutputFilePathWithoutExtension = removeFileExtension(getSourceFilePathInNewDir(fileName, host, compilerOptions.outDir));
        else emitOutputFilePathWithoutExtension = removeFileExtension(fileName);
        return emitOutputFilePathWithoutExtension + extension;
    }
    function getDeclarationEmitOutputFilePath(fileName, host) {
        return getDeclarationEmitOutputFilePathWorker(fileName, host.getCompilerOptions(), host.getCurrentDirectory(), host.getCommonSourceDirectory(), (f)=>host.getCanonicalFileName(f));
    }
    function getDeclarationEmitOutputFilePathWorker(fileName, options, currentDirectory, commonSourceDirectory, getCanonicalFileName) {
        const outputDir = options.declarationDir || options.outDir;
        const path = outputDir ? getSourceFilePathInNewDirWorker(fileName, outputDir, currentDirectory, commonSourceDirectory, getCanonicalFileName) : fileName;
        const declarationExtension = getDeclarationEmitExtensionForPath(path);
        return removeFileExtension(path) + declarationExtension;
    }
    function getDeclarationEmitExtensionForPath(path) {
        return fileExtensionIsOneOf(path, [
            ".mjs" /* Mjs */ ,
            ".mts" /* Mts */ 
        ]) ? ".d.mts" /* Dmts */  : fileExtensionIsOneOf(path, [
            ".cjs" /* Cjs */ ,
            ".cts" /* Cts */ 
        ]) ? ".d.cts" /* Dcts */  : fileExtensionIsOneOf(path, [
            ".json" /* Json */ 
        ]) ? `.d.json.ts` : // Drive-by redefinition of json declaration file output name so if it's ever enabled, it behaves well
        ".d.ts" /* Dts */ ;
    }
    function getPossibleOriginalInputExtensionForExtension(path) {
        return fileExtensionIsOneOf(path, [
            ".d.mts" /* Dmts */ ,
            ".mjs" /* Mjs */ ,
            ".mts" /* Mts */ 
        ]) ? [
            ".mts" /* Mts */ ,
            ".mjs" /* Mjs */ 
        ] : fileExtensionIsOneOf(path, [
            ".d.cts" /* Dcts */ ,
            ".cjs" /* Cjs */ ,
            ".cts" /* Cts */ 
        ]) ? [
            ".cts" /* Cts */ ,
            ".cjs" /* Cjs */ 
        ] : fileExtensionIsOneOf(path, [
            `.d.json.ts`
        ]) ? [
            ".json" /* Json */ 
        ] : [
            ".tsx" /* Tsx */ ,
            ".ts" /* Ts */ ,
            ".jsx" /* Jsx */ ,
            ".js" /* Js */ 
        ];
    }
    function outFile(options) {
        return options.outFile || options.out;
    }
    function getPathsBasePath(options, host) {
        var _a;
        if (!options.paths) return void 0;
        return options.baseUrl ?? Debug.checkDefined(options.pathsBasePath || ((_a = host.getCurrentDirectory) == null ? void 0 : _a.call(host)), "Encountered 'paths' without a 'baseUrl', config file, or host 'getCurrentDirectory'.");
    }
    function getSourceFilesToEmit(host, targetSourceFile, forceDtsEmit) {
        const options = host.getCompilerOptions();
        if (outFile(options)) {
            const moduleKind = getEmitModuleKind(options);
            const moduleEmitEnabled = options.emitDeclarationOnly || moduleKind === 2 /* AMD */  || moduleKind === 4 /* System */ ;
            return filter(host.getSourceFiles(), (sourceFile)=>(moduleEmitEnabled || !isExternalModule(sourceFile)) && sourceFileMayBeEmitted(sourceFile, host, forceDtsEmit));
        } else {
            const sourceFiles = targetSourceFile === void 0 ? host.getSourceFiles() : [
                targetSourceFile
            ];
            return filter(sourceFiles, (sourceFile)=>sourceFileMayBeEmitted(sourceFile, host, forceDtsEmit));
        }
    }
    function sourceFileMayBeEmitted(sourceFile, host, forceDtsEmit) {
        const options = host.getCompilerOptions();
        return !(options.noEmitForJsFiles && isSourceFileJS(sourceFile)) && !sourceFile.isDeclarationFile && !host.isSourceFileFromExternalLibrary(sourceFile) && (forceDtsEmit || !(isJsonSourceFile(sourceFile) && host.getResolvedProjectReferenceToRedirect(sourceFile.fileName)) && !host.isSourceOfProjectReferenceRedirect(sourceFile.fileName));
    }
    function getSourceFilePathInNewDir(fileName, host, newDirPath) {
        return getSourceFilePathInNewDirWorker(fileName, newDirPath, host.getCurrentDirectory(), host.getCommonSourceDirectory(), (f)=>host.getCanonicalFileName(f));
    }
    function getSourceFilePathInNewDirWorker(fileName, newDirPath, currentDirectory, commonSourceDirectory, getCanonicalFileName) {
        let sourceFilePath = getNormalizedAbsolutePath(fileName, currentDirectory);
        const isSourceFileInCommonSourceDirectory = getCanonicalFileName(sourceFilePath).indexOf(getCanonicalFileName(commonSourceDirectory)) === 0;
        sourceFilePath = isSourceFileInCommonSourceDirectory ? sourceFilePath.substring(commonSourceDirectory.length) : sourceFilePath;
        return combinePaths(newDirPath, sourceFilePath);
    }
    function writeFile(host, diagnostics, fileName, text, writeByteOrderMark, sourceFiles, data) {
        host.writeFile(fileName, text, writeByteOrderMark, (hostErrorMessage)=>{
            diagnostics.add(createCompilerDiagnostic(Diagnostics.Could_not_write_file_0_Colon_1, fileName, hostErrorMessage));
        }, sourceFiles, data);
    }
    function ensureDirectoriesExist(directoryPath, createDirectory, directoryExists) {
        if (directoryPath.length > getRootLength(directoryPath) && !directoryExists(directoryPath)) {
            const parentDirectory = getDirectoryPath(directoryPath);
            ensureDirectoriesExist(parentDirectory, createDirectory, directoryExists);
            createDirectory(directoryPath);
        }
    }
    function writeFileEnsuringDirectories(path, data, writeByteOrderMark, writeFile2, createDirectory, directoryExists) {
        try {
            writeFile2(path, data, writeByteOrderMark);
        } catch  {
            ensureDirectoriesExist(getDirectoryPath(normalizePath(path)), createDirectory, directoryExists);
            writeFile2(path, data, writeByteOrderMark);
        }
    }
    function getLineOfLocalPosition(sourceFile, pos) {
        const lineStarts = getLineStarts(sourceFile);
        return computeLineOfPosition(lineStarts, pos);
    }
    function getLineOfLocalPositionFromLineMap(lineMap, pos) {
        return computeLineOfPosition(lineMap, pos);
    }
    function getFirstConstructorWithBody(node) {
        return find(node.members, (member)=>isConstructorDeclaration(member) && nodeIsPresent(member.body));
    }
    function getSetAccessorValueParameter(accessor) {
        if (accessor && accessor.parameters.length > 0) {
            const hasThis = accessor.parameters.length === 2 && parameterIsThisKeyword(accessor.parameters[0]);
            return accessor.parameters[hasThis ? 1 : 0];
        }
    }
    function getSetAccessorTypeAnnotationNode(accessor) {
        const parameter = getSetAccessorValueParameter(accessor);
        return parameter && parameter.type;
    }
    function getThisParameter(signature) {
        if (signature.parameters.length && !isJSDocSignature(signature)) {
            const thisParameter = signature.parameters[0];
            if (parameterIsThisKeyword(thisParameter)) return thisParameter;
        }
    }
    function parameterIsThisKeyword(parameter) {
        return isThisIdentifier(parameter.name);
    }
    function isThisIdentifier(node) {
        return !!node && node.kind === 80 /* Identifier */  && identifierIsThisKeyword(node);
    }
    function isThisInTypeQuery(node) {
        if (!isThisIdentifier(node)) return false;
        while(isQualifiedName(node.parent) && node.parent.left === node)node = node.parent;
        return node.parent.kind === 185 /* TypeQuery */ ;
    }
    function identifierIsThisKeyword(id) {
        return id.escapedText === "this";
    }
    function getAllAccessorDeclarations(declarations, accessor) {
        let firstAccessor;
        let secondAccessor;
        let getAccessor;
        let setAccessor;
        if (hasDynamicName(accessor)) {
            firstAccessor = accessor;
            if (accessor.kind === 176 /* GetAccessor */ ) getAccessor = accessor;
            else if (accessor.kind === 177 /* SetAccessor */ ) setAccessor = accessor;
            else Debug.fail("Accessor has wrong kind");
        } else forEach(declarations, (member)=>{
            if (isAccessor(member) && isStatic(member) === isStatic(accessor)) {
                const memberName = getPropertyNameForPropertyNameNode(member.name);
                const accessorName = getPropertyNameForPropertyNameNode(accessor.name);
                if (memberName === accessorName) {
                    if (!firstAccessor) firstAccessor = member;
                    else if (!secondAccessor) secondAccessor = member;
                    if (member.kind === 176 /* GetAccessor */  && !getAccessor) getAccessor = member;
                    if (member.kind === 177 /* SetAccessor */  && !setAccessor) setAccessor = member;
                }
            }
        });
        return {
            firstAccessor: firstAccessor,
            secondAccessor: secondAccessor,
            getAccessor: getAccessor,
            setAccessor: setAccessor
        };
    }
    function getEffectiveTypeAnnotationNode(node) {
        if (!isInJSFile(node) && isFunctionDeclaration(node)) return void 0;
        const type = node.type;
        if (type || !isInJSFile(node)) return type;
        return isJSDocPropertyLikeTag(node) ? node.typeExpression && node.typeExpression.type : getJSDocType(node);
    }
    function getTypeAnnotationNode(node) {
        return node.type;
    }
    function getEffectiveReturnTypeNode(node) {
        return isJSDocSignature(node) ? node.type && node.type.typeExpression && node.type.typeExpression.type : node.type || (isInJSFile(node) ? getJSDocReturnType(node) : void 0);
    }
    function getJSDocTypeParameterDeclarations(node) {
        return flatMap(getJSDocTags(node), (tag)=>isNonTypeAliasTemplate(tag) ? tag.typeParameters : void 0);
    }
    function isNonTypeAliasTemplate(tag) {
        return isJSDocTemplateTag(tag) && !(tag.parent.kind === 326 /* JSDoc */  && (tag.parent.tags.some(isJSDocTypeAlias) || tag.parent.tags.some(isJSDocOverloadTag)));
    }
    function getEffectiveSetAccessorTypeAnnotationNode(node) {
        const parameter = getSetAccessorValueParameter(node);
        return parameter && getEffectiveTypeAnnotationNode(parameter);
    }
    function emitNewLineBeforeLeadingComments(lineMap, writer, node, leadingComments) {
        emitNewLineBeforeLeadingCommentsOfPosition(lineMap, writer, node.pos, leadingComments);
    }
    function emitNewLineBeforeLeadingCommentsOfPosition(lineMap, writer, pos, leadingComments) {
        if (leadingComments && leadingComments.length && pos !== leadingComments[0].pos && getLineOfLocalPositionFromLineMap(lineMap, pos) !== getLineOfLocalPositionFromLineMap(lineMap, leadingComments[0].pos)) writer.writeLine();
    }
    function emitNewLineBeforeLeadingCommentOfPosition(lineMap, writer, pos, commentPos) {
        if (pos !== commentPos && getLineOfLocalPositionFromLineMap(lineMap, pos) !== getLineOfLocalPositionFromLineMap(lineMap, commentPos)) writer.writeLine();
    }
    function emitComments(text, lineMap, writer, comments, leadingSeparator, trailingSeparator, newLine, writeComment) {
        if (comments && comments.length > 0) {
            if (leadingSeparator) writer.writeSpace(" ");
            let emitInterveningSeparator = false;
            for (const comment of comments){
                if (emitInterveningSeparator) {
                    writer.writeSpace(" ");
                    emitInterveningSeparator = false;
                }
                writeComment(text, lineMap, writer, comment.pos, comment.end, newLine);
                if (comment.hasTrailingNewLine) writer.writeLine();
                else emitInterveningSeparator = true;
            }
            if (emitInterveningSeparator && trailingSeparator) writer.writeSpace(" ");
        }
    }
    function emitDetachedComments(text, lineMap, writer, writeComment, node, newLine, removeComments) {
        let leadingComments;
        let currentDetachedCommentInfo;
        if (removeComments) {
            if (node.pos === 0) leadingComments = filter(getLeadingCommentRanges(text, node.pos), isPinnedCommentLocal);
        } else leadingComments = getLeadingCommentRanges(text, node.pos);
        if (leadingComments) {
            const detachedComments = [];
            let lastComment;
            for (const comment of leadingComments){
                if (lastComment) {
                    const lastCommentLine = getLineOfLocalPositionFromLineMap(lineMap, lastComment.end);
                    const commentLine = getLineOfLocalPositionFromLineMap(lineMap, comment.pos);
                    if (commentLine >= lastCommentLine + 2) break;
                }
                detachedComments.push(comment);
                lastComment = comment;
            }
            if (detachedComments.length) {
                const lastCommentLine = getLineOfLocalPositionFromLineMap(lineMap, last(detachedComments).end);
                const nodeLine = getLineOfLocalPositionFromLineMap(lineMap, skipTrivia(text, node.pos));
                if (nodeLine >= lastCommentLine + 2) {
                    emitNewLineBeforeLeadingComments(lineMap, writer, node, leadingComments);
                    emitComments(text, lineMap, writer, detachedComments, /*leadingSeparator*/ false, /*trailingSeparator*/ true, newLine, writeComment);
                    currentDetachedCommentInfo = {
                        nodePos: node.pos,
                        detachedCommentEndPos: last(detachedComments).end
                    };
                }
            }
        }
        return currentDetachedCommentInfo;
        function isPinnedCommentLocal(comment) {
            return isPinnedComment(text, comment.pos);
        }
    }
    function writeCommentRange(text, lineMap, writer, commentPos, commentEnd, newLine) {
        if (text.charCodeAt(commentPos + 1) === 42 /* asterisk */ ) {
            const firstCommentLineAndCharacter = computeLineAndCharacterOfPosition(lineMap, commentPos);
            const lineCount = lineMap.length;
            let firstCommentLineIndent;
            for(let pos = commentPos, currentLine = firstCommentLineAndCharacter.line; pos < commentEnd; currentLine++){
                const nextLineStart = currentLine + 1 === lineCount ? text.length + 1 : lineMap[currentLine + 1];
                if (pos !== commentPos) {
                    if (firstCommentLineIndent === void 0) firstCommentLineIndent = calculateIndent(text, lineMap[firstCommentLineAndCharacter.line], commentPos);
                    const currentWriterIndentSpacing = writer.getIndent() * getIndentSize();
                    const spacesToEmit = currentWriterIndentSpacing - firstCommentLineIndent + calculateIndent(text, pos, nextLineStart);
                    if (spacesToEmit > 0) {
                        let numberOfSingleSpacesToEmit = spacesToEmit % getIndentSize();
                        const indentSizeSpaceString = getIndentString((spacesToEmit - numberOfSingleSpacesToEmit) / getIndentSize());
                        writer.rawWrite(indentSizeSpaceString);
                        while(numberOfSingleSpacesToEmit){
                            writer.rawWrite(" ");
                            numberOfSingleSpacesToEmit--;
                        }
                    } else writer.rawWrite("");
                }
                writeTrimmedCurrentLine(text, commentEnd, writer, newLine, pos, nextLineStart);
                pos = nextLineStart;
            }
        } else writer.writeComment(text.substring(commentPos, commentEnd));
    }
    function writeTrimmedCurrentLine(text, commentEnd, writer, newLine, pos, nextLineStart) {
        const end = Math.min(commentEnd, nextLineStart - 1);
        const currentLineText = trimString(text.substring(pos, end));
        if (currentLineText) {
            writer.writeComment(currentLineText);
            if (end !== commentEnd) writer.writeLine();
        } else writer.rawWrite(newLine);
    }
    function calculateIndent(text, pos, end) {
        let currentLineIndent = 0;
        for(; pos < end && isWhiteSpaceSingleLine(text.charCodeAt(pos)); pos++)if (text.charCodeAt(pos) === 9 /* tab */ ) currentLineIndent += getIndentSize() - currentLineIndent % getIndentSize();
        else currentLineIndent++;
        return currentLineIndent;
    }
    function hasEffectiveModifiers(node) {
        return getEffectiveModifierFlags(node) !== 0 /* None */ ;
    }
    function hasSyntacticModifiers(node) {
        return getSyntacticModifierFlags(node) !== 0 /* None */ ;
    }
    function hasEffectiveModifier(node, flags) {
        return !!getSelectedEffectiveModifierFlags(node, flags);
    }
    function hasSyntacticModifier(node, flags) {
        return !!getSelectedSyntacticModifierFlags(node, flags);
    }
    function isStatic(node) {
        return isClassElement(node) && hasStaticModifier(node) || isClassStaticBlockDeclaration(node);
    }
    function hasStaticModifier(node) {
        return hasSyntacticModifier(node, 32 /* Static */ );
    }
    function hasOverrideModifier(node) {
        return hasEffectiveModifier(node, 16384 /* Override */ );
    }
    function hasAbstractModifier(node) {
        return hasSyntacticModifier(node, 256 /* Abstract */ );
    }
    function hasAmbientModifier(node) {
        return hasSyntacticModifier(node, 2 /* Ambient */ );
    }
    function hasAccessorModifier(node) {
        return hasSyntacticModifier(node, 128 /* Accessor */ );
    }
    function hasEffectiveReadonlyModifier(node) {
        return hasEffectiveModifier(node, 64 /* Readonly */ );
    }
    function hasDecorators(node) {
        return hasSyntacticModifier(node, 131072 /* Decorator */ );
    }
    function getSelectedEffectiveModifierFlags(node, flags) {
        return getEffectiveModifierFlags(node) & flags;
    }
    function getSelectedSyntacticModifierFlags(node, flags) {
        return getSyntacticModifierFlags(node) & flags;
    }
    function getModifierFlagsWorker(node, includeJSDoc, alwaysIncludeJSDoc) {
        if (node.kind >= 0 /* FirstToken */  && node.kind <= 164 /* LastToken */ ) return 0 /* None */ ;
        if (!(node.modifierFlagsCache & 536870912 /* HasComputedFlags */ )) node.modifierFlagsCache = getSyntacticModifierFlagsNoCache(node) | 536870912 /* HasComputedFlags */ ;
        if (includeJSDoc && !(node.modifierFlagsCache & 4096 /* HasComputedJSDocModifiers */ ) && (alwaysIncludeJSDoc || isInJSFile(node)) && node.parent) node.modifierFlagsCache |= getJSDocModifierFlagsNoCache(node) | 4096 /* HasComputedJSDocModifiers */ ;
        return node.modifierFlagsCache & -536875009;
    }
    function getEffectiveModifierFlags(node) {
        return getModifierFlagsWorker(node, /*includeJSDoc*/ true);
    }
    function getEffectiveModifierFlagsAlwaysIncludeJSDoc(node) {
        return getModifierFlagsWorker(node, /*includeJSDoc*/ true, /*alwaysIncludeJSDoc*/ true);
    }
    function getSyntacticModifierFlags(node) {
        return getModifierFlagsWorker(node, /*includeJSDoc*/ false);
    }
    function getJSDocModifierFlagsNoCache(node) {
        let flags = 0 /* None */ ;
        if (!!node.parent && !isParameter(node)) {
            if (isInJSFile(node)) {
                if (getJSDocPublicTagNoCache(node)) flags |= 4 /* Public */ ;
                if (getJSDocPrivateTagNoCache(node)) flags |= 8 /* Private */ ;
                if (getJSDocProtectedTagNoCache(node)) flags |= 16 /* Protected */ ;
                if (getJSDocReadonlyTagNoCache(node)) flags |= 64 /* Readonly */ ;
                if (getJSDocOverrideTagNoCache(node)) flags |= 16384 /* Override */ ;
            }
            if (getJSDocDeprecatedTagNoCache(node)) flags |= 8192 /* Deprecated */ ;
        }
        return flags;
    }
    function getEffectiveModifierFlagsNoCache(node) {
        return getSyntacticModifierFlagsNoCache(node) | getJSDocModifierFlagsNoCache(node);
    }
    function getSyntacticModifierFlagsNoCache(node) {
        let flags = canHaveModifiers(node) ? modifiersToFlags(node.modifiers) : 0 /* None */ ;
        if (node.flags & 4 /* NestedNamespace */  || node.kind === 80 /* Identifier */  && node.flags & 2048 /* IdentifierIsInJSDocNamespace */ ) flags |= 1 /* Export */ ;
        return flags;
    }
    function modifiersToFlags(modifiers) {
        let flags = 0 /* None */ ;
        if (modifiers) for (const modifier of modifiers)flags |= modifierToFlag(modifier.kind);
        return flags;
    }
    function modifierToFlag(token) {
        switch(token){
            case 126 /* StaticKeyword */ :
                return 32 /* Static */ ;
            case 125 /* PublicKeyword */ :
                return 4 /* Public */ ;
            case 124 /* ProtectedKeyword */ :
                return 16 /* Protected */ ;
            case 123 /* PrivateKeyword */ :
                return 8 /* Private */ ;
            case 128 /* AbstractKeyword */ :
                return 256 /* Abstract */ ;
            case 129 /* AccessorKeyword */ :
                return 128 /* Accessor */ ;
            case 95 /* ExportKeyword */ :
                return 1 /* Export */ ;
            case 138 /* DeclareKeyword */ :
                return 2 /* Ambient */ ;
            case 87 /* ConstKeyword */ :
                return 2048 /* Const */ ;
            case 90 /* DefaultKeyword */ :
                return 1024 /* Default */ ;
            case 134 /* AsyncKeyword */ :
                return 512 /* Async */ ;
            case 148 /* ReadonlyKeyword */ :
                return 64 /* Readonly */ ;
            case 163 /* OverrideKeyword */ :
                return 16384 /* Override */ ;
            case 103 /* InKeyword */ :
                return 32768 /* In */ ;
            case 147 /* OutKeyword */ :
                return 65536 /* Out */ ;
            case 169 /* Decorator */ :
                return 131072 /* Decorator */ ;
        }
        return 0 /* None */ ;
    }
    function isBinaryLogicalOperator(token) {
        return token === 57 /* BarBarToken */  || token === 56 /* AmpersandAmpersandToken */ ;
    }
    function isLogicalOperator(token) {
        return isBinaryLogicalOperator(token) || token === 54 /* ExclamationToken */ ;
    }
    function isLogicalOrCoalescingAssignmentOperator(token) {
        return token === 76 /* BarBarEqualsToken */  || token === 77 /* AmpersandAmpersandEqualsToken */  || token === 78 /* QuestionQuestionEqualsToken */ ;
    }
    function isLogicalOrCoalescingAssignmentExpression(expr) {
        return isBinaryExpression(expr) && isLogicalOrCoalescingAssignmentOperator(expr.operatorToken.kind);
    }
    function isLogicalOrCoalescingBinaryOperator(token) {
        return isBinaryLogicalOperator(token) || token === 61 /* QuestionQuestionToken */ ;
    }
    function isLogicalOrCoalescingBinaryExpression(expr) {
        return isBinaryExpression(expr) && isLogicalOrCoalescingBinaryOperator(expr.operatorToken.kind);
    }
    function isAssignmentOperator(token) {
        return token >= 64 /* FirstAssignment */  && token <= 79 /* LastAssignment */ ;
    }
    function tryGetClassExtendingExpressionWithTypeArguments(node) {
        const cls = tryGetClassImplementingOrExtendingExpressionWithTypeArguments(node);
        return cls && !cls.isImplements ? cls.class : void 0;
    }
    function tryGetClassImplementingOrExtendingExpressionWithTypeArguments(node) {
        if (isExpressionWithTypeArguments(node)) {
            if (isHeritageClause(node.parent) && isClassLike(node.parent.parent)) return {
                class: node.parent.parent,
                isImplements: node.parent.token === 119 /* ImplementsKeyword */ 
            };
            if (isJSDocAugmentsTag(node.parent)) {
                const host = getEffectiveJSDocHost(node.parent);
                if (host && isClassLike(host)) return {
                    class: host,
                    isImplements: false
                };
            }
        }
        return void 0;
    }
    function isAssignmentExpression(node, excludeCompoundAssignment) {
        return isBinaryExpression(node) && (excludeCompoundAssignment ? node.operatorToken.kind === 64 /* EqualsToken */  : isAssignmentOperator(node.operatorToken.kind)) && isLeftHandSideExpression(node.left);
    }
    function isLeftHandSideOfAssignment(node) {
        return isAssignmentExpression(node.parent) && node.parent.left === node;
    }
    function isDestructuringAssignment(node) {
        if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) {
            const kind = node.left.kind;
            return kind === 209 /* ObjectLiteralExpression */  || kind === 208 /* ArrayLiteralExpression */ ;
        }
        return false;
    }
    function isExpressionWithTypeArgumentsInClassExtendsClause(node) {
        return tryGetClassExtendingExpressionWithTypeArguments(node) !== void 0;
    }
    function isEntityNameExpression(node) {
        return node.kind === 80 /* Identifier */  || isPropertyAccessEntityNameExpression(node);
    }
    function getFirstIdentifier(node) {
        switch(node.kind){
            case 80 /* Identifier */ :
                return node;
            case 165 /* QualifiedName */ :
                do node = node.left;
                while (node.kind !== 80 /* Identifier */ );
                return node;
            case 210 /* PropertyAccessExpression */ :
                do node = node.expression;
                while (node.kind !== 80 /* Identifier */ );
                return node;
        }
    }
    function isDottedName(node) {
        return node.kind === 80 /* Identifier */  || node.kind === 110 /* ThisKeyword */  || node.kind === 108 /* SuperKeyword */  || node.kind === 235 /* MetaProperty */  || node.kind === 210 /* PropertyAccessExpression */  && isDottedName(node.expression) || node.kind === 216 /* ParenthesizedExpression */  && isDottedName(node.expression);
    }
    function isPropertyAccessEntityNameExpression(node) {
        return isPropertyAccessExpression(node) && isIdentifier(node.name) && isEntityNameExpression(node.expression);
    }
    function tryGetPropertyAccessOrIdentifierToString(expr) {
        if (isPropertyAccessExpression(expr)) {
            const baseStr = tryGetPropertyAccessOrIdentifierToString(expr.expression);
            if (baseStr !== void 0) return baseStr + "." + entityNameToString(expr.name);
        } else if (isElementAccessExpression(expr)) {
            const baseStr = tryGetPropertyAccessOrIdentifierToString(expr.expression);
            if (baseStr !== void 0 && isPropertyName(expr.argumentExpression)) return baseStr + "." + getPropertyNameForPropertyNameNode(expr.argumentExpression);
        } else if (isIdentifier(expr)) return unescapeLeadingUnderscores(expr.escapedText);
        else if (isJsxNamespacedName(expr)) return getTextOfJsxNamespacedName(expr);
        return void 0;
    }
    function isPrototypeAccess(node) {
        return isBindableStaticAccessExpression(node) && getElementOrPropertyAccessName(node) === "prototype";
    }
    function isRightSideOfQualifiedNameOrPropertyAccess(node) {
        return node.parent.kind === 165 /* QualifiedName */  && node.parent.right === node || node.parent.kind === 210 /* PropertyAccessExpression */  && node.parent.name === node;
    }
    function isRightSideOfAccessExpression(node) {
        return isPropertyAccessExpression(node.parent) && node.parent.name === node || isElementAccessExpression(node.parent) && node.parent.argumentExpression === node;
    }
    function isRightSideOfQualifiedNameOrPropertyAccessOrJSDocMemberName(node) {
        return isQualifiedName(node.parent) && node.parent.right === node || isPropertyAccessExpression(node.parent) && node.parent.name === node || isJSDocMemberName(node.parent) && node.parent.right === node;
    }
    function isEmptyObjectLiteral(expression) {
        return expression.kind === 209 /* ObjectLiteralExpression */  && expression.properties.length === 0;
    }
    function isEmptyArrayLiteral(expression) {
        return expression.kind === 208 /* ArrayLiteralExpression */  && expression.elements.length === 0;
    }
    function getLocalSymbolForExportDefault(symbol) {
        if (!isExportDefaultSymbol(symbol) || !symbol.declarations) return void 0;
        for (const decl of symbol.declarations){
            if (decl.localSymbol) return decl.localSymbol;
        }
        return void 0;
    }
    function isExportDefaultSymbol(symbol) {
        return symbol && length(symbol.declarations) > 0 && hasSyntacticModifier(symbol.declarations[0], 1024 /* Default */ );
    }
    function tryExtractTSExtension(fileName) {
        return find(supportedTSExtensionsForExtractExtension, (extension)=>fileExtensionIs(fileName, extension));
    }
    function getExpandedCharCodes(input) {
        const output = [];
        const length2 = input.length;
        for(let i = 0; i < length2; i++){
            const charCode = input.charCodeAt(i);
            if (charCode < 128) output.push(charCode);
            else if (charCode < 2048) {
                output.push(charCode >> 6 | 192);
                output.push(charCode & 63 | 128);
            } else if (charCode < 65536) {
                output.push(charCode >> 12 | 224);
                output.push(charCode >> 6 & 63 | 128);
                output.push(charCode & 63 | 128);
            } else if (charCode < 131072) {
                output.push(charCode >> 18 | 240);
                output.push(charCode >> 12 & 63 | 128);
                output.push(charCode >> 6 & 63 | 128);
                output.push(charCode & 63 | 128);
            } else Debug.assert(false, "Unexpected code point");
        }
        return output;
    }
    function convertToBase64(input) {
        let result = "";
        const charCodes = getExpandedCharCodes(input);
        let i = 0;
        const length2 = charCodes.length;
        let byte1, byte2, byte3, byte4;
        while(i < length2){
            byte1 = charCodes[i] >> 2;
            byte2 = (charCodes[i] & 3) << 4 | charCodes[i + 1] >> 4;
            byte3 = (charCodes[i + 1] & 15) << 2 | charCodes[i + 2] >> 6;
            byte4 = charCodes[i + 2] & 63;
            if (i + 1 >= length2) byte3 = byte4 = 64;
            else if (i + 2 >= length2) byte4 = 64;
            result += base64Digits.charAt(byte1) + base64Digits.charAt(byte2) + base64Digits.charAt(byte3) + base64Digits.charAt(byte4);
            i += 3;
        }
        return result;
    }
    function getStringFromExpandedCharCodes(codes) {
        let output = "";
        let i = 0;
        const length2 = codes.length;
        while(i < length2){
            const charCode = codes[i];
            if (charCode < 128) {
                output += String.fromCharCode(charCode);
                i++;
            } else if ((charCode & 192) === 192) {
                let value1 = charCode & 63;
                i++;
                let nextCode = codes[i];
                while((nextCode & 192) === 128){
                    value1 = value1 << 6 | nextCode & 63;
                    i++;
                    nextCode = codes[i];
                }
                output += String.fromCharCode(value1);
            } else {
                output += String.fromCharCode(charCode);
                i++;
            }
        }
        return output;
    }
    function base64encode(host, input) {
        if (host && host.base64encode) return host.base64encode(input);
        return convertToBase64(input);
    }
    function base64decode(host, input) {
        if (host && host.base64decode) return host.base64decode(input);
        const length2 = input.length;
        const expandedCharCodes = [];
        let i = 0;
        while(i < length2){
            if (input.charCodeAt(i) === base64Digits.charCodeAt(64)) break;
            const ch1 = base64Digits.indexOf(input[i]);
            const ch2 = base64Digits.indexOf(input[i + 1]);
            const ch3 = base64Digits.indexOf(input[i + 2]);
            const ch4 = base64Digits.indexOf(input[i + 3]);
            const code1 = (ch1 & 63) << 2 | ch2 >> 4 & 3;
            const code2 = (ch2 & 15) << 4 | ch3 >> 2 & 15;
            const code3 = (ch3 & 3) << 6 | ch4 & 63;
            if (code2 === 0 && ch3 !== 0) expandedCharCodes.push(code1);
            else if (code3 === 0 && ch4 !== 0) expandedCharCodes.push(code1, code2);
            else expandedCharCodes.push(code1, code2, code3);
            i += 4;
        }
        return getStringFromExpandedCharCodes(expandedCharCodes);
    }
    function readJsonOrUndefined(path, hostOrText) {
        const jsonText = isString(hostOrText) ? hostOrText : hostOrText.readFile(path);
        if (!jsonText) return void 0;
        const result = parseConfigFileTextToJson(path, jsonText);
        return !result.error ? result.config : void 0;
    }
    function readJson(path, host) {
        return readJsonOrUndefined(path, host) || {};
    }
    function directoryProbablyExists(directoryName, host) {
        return !host.directoryExists || host.directoryExists(directoryName);
    }
    function getNewLineCharacter(options) {
        switch(options.newLine){
            case 0 /* CarriageReturnLineFeed */ :
                return carriageReturnLineFeed;
            case 1 /* LineFeed */ :
            case void 0:
                return lineFeed;
        }
    }
    function createRange(pos, end = pos) {
        Debug.assert(end >= pos || end === -1);
        return {
            pos: pos,
            end: end
        };
    }
    function moveRangeEnd(range, end) {
        return createRange(range.pos, end);
    }
    function moveRangePos(range, pos) {
        return createRange(pos, range.end);
    }
    function moveRangePastDecorators(node) {
        const lastDecorator = canHaveModifiers(node) ? findLast(node.modifiers, isDecorator) : void 0;
        return lastDecorator && !positionIsSynthesized(lastDecorator.end) ? moveRangePos(node, lastDecorator.end) : node;
    }
    function moveRangePastModifiers(node) {
        if (isPropertyDeclaration(node) || isMethodDeclaration(node)) return moveRangePos(node, node.name.pos);
        const lastModifier = canHaveModifiers(node) ? lastOrUndefined(node.modifiers) : void 0;
        return lastModifier && !positionIsSynthesized(lastModifier.end) ? moveRangePos(node, lastModifier.end) : moveRangePastDecorators(node);
    }
    function isCollapsedRange(range) {
        return range.pos === range.end;
    }
    function createTokenRange(pos, token) {
        return createRange(pos, pos + tokenToString(token).length);
    }
    function rangeIsOnSingleLine(range, sourceFile) {
        return rangeStartIsOnSameLineAsRangeEnd(range, range, sourceFile);
    }
    function rangeStartPositionsAreOnSameLine(range1, range2, sourceFile) {
        return positionsAreOnSameLine(getStartPositionOfRange(range1, sourceFile, /*includeComments*/ false), getStartPositionOfRange(range2, sourceFile, /*includeComments*/ false), sourceFile);
    }
    function rangeEndPositionsAreOnSameLine(range1, range2, sourceFile) {
        return positionsAreOnSameLine(range1.end, range2.end, sourceFile);
    }
    function rangeStartIsOnSameLineAsRangeEnd(range1, range2, sourceFile) {
        return positionsAreOnSameLine(getStartPositionOfRange(range1, sourceFile, /*includeComments*/ false), range2.end, sourceFile);
    }
    function rangeEndIsOnSameLineAsRangeStart(range1, range2, sourceFile) {
        return positionsAreOnSameLine(range1.end, getStartPositionOfRange(range2, sourceFile, /*includeComments*/ false), sourceFile);
    }
    function getLinesBetweenRangeEndAndRangeStart(range1, range2, sourceFile, includeSecondRangeComments) {
        const range2Start = getStartPositionOfRange(range2, sourceFile, includeSecondRangeComments);
        return getLinesBetweenPositions(sourceFile, range1.end, range2Start);
    }
    function getLinesBetweenRangeEndPositions(range1, range2, sourceFile) {
        return getLinesBetweenPositions(sourceFile, range1.end, range2.end);
    }
    function isNodeArrayMultiLine(list, sourceFile) {
        return !positionsAreOnSameLine(list.pos, list.end, sourceFile);
    }
    function positionsAreOnSameLine(pos1, pos2, sourceFile) {
        return getLinesBetweenPositions(sourceFile, pos1, pos2) === 0;
    }
    function getStartPositionOfRange(range, sourceFile, includeComments) {
        return positionIsSynthesized(range.pos) ? -1 : skipTrivia(sourceFile.text, range.pos, /*stopAfterLineBreak*/ false, includeComments);
    }
    function getLinesBetweenPositionAndPrecedingNonWhitespaceCharacter(pos, stopPos, sourceFile, includeComments) {
        const startPos = skipTrivia(sourceFile.text, pos, /*stopAfterLineBreak*/ false, includeComments);
        const prevPos = getPreviousNonWhitespacePosition(startPos, stopPos, sourceFile);
        return getLinesBetweenPositions(sourceFile, prevPos ?? stopPos, startPos);
    }
    function getLinesBetweenPositionAndNextNonWhitespaceCharacter(pos, stopPos, sourceFile, includeComments) {
        const nextPos = skipTrivia(sourceFile.text, pos, /*stopAfterLineBreak*/ false, includeComments);
        return getLinesBetweenPositions(sourceFile, pos, Math.min(stopPos, nextPos));
    }
    function getPreviousNonWhitespacePosition(pos, stopPos = 0, sourceFile) {
        while(pos-- > stopPos){
            if (!isWhiteSpaceLike(sourceFile.text.charCodeAt(pos))) return pos;
        }
    }
    function isDeclarationNameOfEnumOrNamespace(node) {
        const parseNode = getParseTreeNode(node);
        if (parseNode) switch(parseNode.parent.kind){
            case 265 /* EnumDeclaration */ :
            case 266 /* ModuleDeclaration */ :
                return parseNode === parseNode.parent.name;
        }
        return false;
    }
    function getInitializedVariables(node) {
        return filter(node.declarations, isInitializedVariable);
    }
    function isInitializedVariable(node) {
        return isVariableDeclaration(node) && node.initializer !== void 0;
    }
    function isWatchSet(options) {
        return options.watch && hasProperty(options, "watch");
    }
    function closeFileWatcher(watcher) {
        watcher.close();
    }
    function getCheckFlags(symbol) {
        return symbol.flags & 33554432 /* Transient */  ? symbol.links.checkFlags : 0;
    }
    function getDeclarationModifierFlagsFromSymbol(s, isWrite = false) {
        if (s.valueDeclaration) {
            const declaration = isWrite && s.declarations && find(s.declarations, isSetAccessorDeclaration) || s.flags & 32768 /* GetAccessor */  && find(s.declarations, isGetAccessorDeclaration) || s.valueDeclaration;
            const flags = getCombinedModifierFlags(declaration);
            return s.parent && s.parent.flags & 32 /* Class */  ? flags : flags & -29 /* AccessibilityModifier */ ;
        }
        if (getCheckFlags(s) & 6 /* Synthetic */ ) {
            const checkFlags = s.links.checkFlags;
            const accessModifier = checkFlags & 1024 /* ContainsPrivate */  ? 8 /* Private */  : checkFlags & 256 /* ContainsPublic */  ? 4 /* Public */  : 16 /* Protected */ ;
            const staticModifier = checkFlags & 2048 /* ContainsStatic */  ? 32 /* Static */  : 0;
            return accessModifier | staticModifier;
        }
        if (s.flags & 4194304 /* Prototype */ ) return 36 /* Static */ ;
        return 0;
    }
    function skipAlias(symbol, checker) {
        return symbol.flags & 2097152 /* Alias */  ? checker.getAliasedSymbol(symbol) : symbol;
    }
    function getCombinedLocalAndExportSymbolFlags(symbol) {
        return symbol.exportSymbol ? symbol.exportSymbol.flags | symbol.flags : symbol.flags;
    }
    function isWriteOnlyAccess(node) {
        return accessKind(node) === 1 /* Write */ ;
    }
    function isWriteAccess(node) {
        return accessKind(node) !== 0 /* Read */ ;
    }
    function accessKind(node) {
        const { parent: parent2  } = node;
        switch(parent2 == null ? void 0 : parent2.kind){
            case 216 /* ParenthesizedExpression */ :
                return accessKind(parent2);
            case 224 /* PostfixUnaryExpression */ :
            case 223 /* PrefixUnaryExpression */ :
                const { operator: operator  } = parent2;
                return operator === 46 /* PlusPlusToken */  || operator === 47 /* MinusMinusToken */  ? 2 /* ReadWrite */  : 0 /* Read */ ;
            case 225 /* BinaryExpression */ :
                const { left: left , operatorToken: operatorToken  } = parent2;
                return left === node && isAssignmentOperator(operatorToken.kind) ? operatorToken.kind === 64 /* EqualsToken */  ? 1 /* Write */  : 2 /* ReadWrite */  : 0 /* Read */ ;
            case 210 /* PropertyAccessExpression */ :
                return parent2.name !== node ? 0 /* Read */  : accessKind(parent2);
            case 302 /* PropertyAssignment */ :
                {
                    const parentAccess = accessKind(parent2.parent);
                    return node === parent2.name ? reverseAccessKind(parentAccess) : parentAccess;
                }
            case 303 /* ShorthandPropertyAssignment */ :
                return node === parent2.objectAssignmentInitializer ? 0 /* Read */  : accessKind(parent2.parent);
            case 208 /* ArrayLiteralExpression */ :
                return accessKind(parent2);
            default:
                return 0 /* Read */ ;
        }
    }
    function reverseAccessKind(a) {
        switch(a){
            case 0 /* Read */ :
                return 1 /* Write */ ;
            case 1 /* Write */ :
                return 0 /* Read */ ;
            case 2 /* ReadWrite */ :
                return 2 /* ReadWrite */ ;
            default:
                return Debug.assertNever(a);
        }
    }
    function compareDataObjects(dst, src) {
        if (!dst || !src || Object.keys(dst).length !== Object.keys(src).length) return false;
        for(const e in dst){
            if (typeof dst[e] === "object") {
                if (!compareDataObjects(dst[e], src[e])) return false;
            } else if (typeof dst[e] !== "function") {
                if (dst[e] !== src[e]) return false;
            }
        }
        return true;
    }
    function clearMap(map2, onDeleteValue) {
        map2.forEach(onDeleteValue);
        map2.clear();
    }
    function mutateMapSkippingNewValues(map2, newMap, options) {
        const { onDeleteValue: onDeleteValue , onExistingValue: onExistingValue  } = options;
        map2.forEach((existingValue, key)=>{
            const valueInNewMap = newMap.get(key);
            if (valueInNewMap === void 0) {
                map2.delete(key);
                onDeleteValue(existingValue, key);
            } else if (onExistingValue) onExistingValue(existingValue, valueInNewMap, key);
        });
    }
    function mutateMap(map2, newMap, options) {
        mutateMapSkippingNewValues(map2, newMap, options);
        const { createNewValue: createNewValue  } = options;
        newMap.forEach((valueInNewMap, key)=>{
            if (!map2.has(key)) map2.set(key, createNewValue(key, valueInNewMap));
        });
    }
    function isAbstractConstructorSymbol(symbol) {
        if (symbol.flags & 32 /* Class */ ) {
            const declaration = getClassLikeDeclarationOfSymbol(symbol);
            return !!declaration && hasSyntacticModifier(declaration, 256 /* Abstract */ );
        }
        return false;
    }
    function getClassLikeDeclarationOfSymbol(symbol) {
        var _a;
        return (_a = symbol.declarations) == null ? void 0 : _a.find(isClassLike);
    }
    function getObjectFlags(type) {
        return type.flags & 138117121 /* ObjectFlagsType */  ? type.objectFlags : 0;
    }
    function forSomeAncestorDirectory(directory, callback) {
        return !!forEachAncestorDirectory(directory, (d)=>callback(d) ? true : void 0);
    }
    function isUMDExportSymbol(symbol) {
        return !!symbol && !!symbol.declarations && !!symbol.declarations[0] && isNamespaceExportDeclaration(symbol.declarations[0]);
    }
    function showModuleSpecifier({ moduleSpecifier: moduleSpecifier  }) {
        return isStringLiteral(moduleSpecifier) ? moduleSpecifier.text : getTextOfNode(moduleSpecifier);
    }
    function getLastChild(node) {
        let lastChild;
        forEachChild(node, (child)=>{
            if (nodeIsPresent(child)) lastChild = child;
        }, (children)=>{
            for(let i = children.length - 1; i >= 0; i--)if (nodeIsPresent(children[i])) {
                lastChild = children[i];
                break;
            }
        });
        return lastChild;
    }
    function addToSeen(seen, key, value1 = true) {
        if (seen.has(key)) return false;
        seen.set(key, value1);
        return true;
    }
    function isObjectTypeDeclaration(node) {
        return isClassLike(node) || isInterfaceDeclaration(node) || isTypeLiteralNode(node);
    }
    function isTypeNodeKind(kind) {
        return kind >= 181 /* FirstTypeNode */  && kind <= 204 /* LastTypeNode */  || kind === 133 /* AnyKeyword */  || kind === 159 /* UnknownKeyword */  || kind === 150 /* NumberKeyword */  || kind === 162 /* BigIntKeyword */  || kind === 151 /* ObjectKeyword */  || kind === 136 /* BooleanKeyword */  || kind === 154 /* StringKeyword */  || kind === 155 /* SymbolKeyword */  || kind === 116 /* VoidKeyword */  || kind === 157 /* UndefinedKeyword */  || kind === 146 /* NeverKeyword */  || kind === 141 /* IntrinsicKeyword */  || kind === 232 /* ExpressionWithTypeArguments */  || kind === 318 /* JSDocAllType */  || kind === 319 /* JSDocUnknownType */  || kind === 320 /* JSDocNullableType */  || kind === 321 /* JSDocNonNullableType */  || kind === 322 /* JSDocOptionalType */  || kind === 323 /* JSDocFunctionType */  || kind === 324 /* JSDocVariadicType */ ;
    }
    function isAccessExpression(node) {
        return node.kind === 210 /* PropertyAccessExpression */  || node.kind === 211 /* ElementAccessExpression */ ;
    }
    function getNameOfAccessExpression(node) {
        if (node.kind === 210 /* PropertyAccessExpression */ ) return node.name;
        Debug.assert(node.kind === 211 /* ElementAccessExpression */ );
        return node.argumentExpression;
    }
    function isBundleFileTextLike(section) {
        switch(section.kind){
            case "text" /* Text */ :
            case "internal" /* Internal */ :
                return true;
            default:
                return false;
        }
    }
    function isNamedImportsOrExports(node) {
        return node.kind === 274 /* NamedImports */  || node.kind === 278 /* NamedExports */ ;
    }
    function getLeftmostAccessExpression(expr) {
        while(isAccessExpression(expr))expr = expr.expression;
        return expr;
    }
    function forEachNameInAccessChainWalkingLeft(name, action) {
        if (isAccessExpression(name.parent) && isRightSideOfAccessExpression(name)) return walkAccessExpression(name.parent);
        function walkAccessExpression(access) {
            if (access.kind === 210 /* PropertyAccessExpression */ ) {
                const res = action(access.name);
                if (res !== void 0) return res;
            } else if (access.kind === 211 /* ElementAccessExpression */ ) {
                if (isIdentifier(access.argumentExpression) || isStringLiteralLike(access.argumentExpression)) {
                    const res = action(access.argumentExpression);
                    if (res !== void 0) return res;
                } else return void 0;
            }
            if (isAccessExpression(access.expression)) return walkAccessExpression(access.expression);
            if (isIdentifier(access.expression)) return action(access.expression);
            return void 0;
        }
    }
    function getLeftmostExpression(node, stopAtCallExpressions) {
        while(true){
            switch(node.kind){
                case 224 /* PostfixUnaryExpression */ :
                    node = node.operand;
                    continue;
                case 225 /* BinaryExpression */ :
                    node = node.left;
                    continue;
                case 226 /* ConditionalExpression */ :
                    node = node.condition;
                    continue;
                case 214 /* TaggedTemplateExpression */ :
                    node = node.tag;
                    continue;
                case 212 /* CallExpression */ :
                    if (stopAtCallExpressions) return node;
                case 233 /* AsExpression */ :
                case 211 /* ElementAccessExpression */ :
                case 210 /* PropertyAccessExpression */ :
                case 234 /* NonNullExpression */ :
                case 359 /* PartiallyEmittedExpression */ :
                case 237 /* SatisfiesExpression */ :
                    node = node.expression;
                    continue;
            }
            return node;
        }
    }
    function Symbol4(flags, name) {
        this.flags = flags;
        this.escapedName = name;
        this.declarations = void 0;
        this.valueDeclaration = void 0;
        this.id = 0;
        this.mergeId = 0;
        this.parent = void 0;
        this.members = void 0;
        this.exports = void 0;
        this.exportSymbol = void 0;
        this.constEnumOnlyModule = void 0;
        this.isReferenced = void 0;
        this.isAssigned = void 0;
        this.links = void 0;
    }
    function Type3(checker, flags) {
        this.flags = flags;
        if (Debug.isDebugging || tracing) this.checker = checker;
    }
    function Signature2(checker, flags) {
        this.flags = flags;
        if (Debug.isDebugging) this.checker = checker;
    }
    function Node4(kind, pos, end) {
        this.pos = pos;
        this.end = end;
        this.kind = kind;
        this.id = 0;
        this.flags = 0 /* None */ ;
        this.modifierFlagsCache = 0 /* None */ ;
        this.transformFlags = 0 /* None */ ;
        this.parent = void 0;
        this.original = void 0;
        this.emitNode = void 0;
    }
    function Token(kind, pos, end) {
        this.pos = pos;
        this.end = end;
        this.kind = kind;
        this.id = 0;
        this.flags = 0 /* None */ ;
        this.transformFlags = 0 /* None */ ;
        this.parent = void 0;
        this.emitNode = void 0;
    }
    function Identifier2(kind, pos, end) {
        this.pos = pos;
        this.end = end;
        this.kind = kind;
        this.id = 0;
        this.flags = 0 /* None */ ;
        this.transformFlags = 0 /* None */ ;
        this.parent = void 0;
        this.original = void 0;
        this.emitNode = void 0;
    }
    function SourceMapSource(fileName, text, skipTrivia2) {
        this.fileName = fileName;
        this.text = text;
        this.skipTrivia = skipTrivia2 || ((pos)=>pos);
    }
    function addObjectAllocatorPatcher(fn) {
        objectAllocatorPatchers.push(fn);
        fn(objectAllocator);
    }
    function setObjectAllocator(alloc) {
        Object.assign(objectAllocator, alloc);
        forEach(objectAllocatorPatchers, (fn)=>fn(objectAllocator));
    }
    function formatStringFromArgs(text, args, baseIndex = 0) {
        return text.replace(/{(\d+)}/g, (_match, index)=>"" + Debug.checkDefined(args[+index + baseIndex]));
    }
    function setLocalizedDiagnosticMessages(messages) {
        localizedDiagnosticMessages = messages;
    }
    function maybeSetLocalizedDiagnosticMessages(getMessages) {
        if (!localizedDiagnosticMessages && getMessages) localizedDiagnosticMessages = getMessages();
    }
    function getLocaleSpecificMessage(message) {
        return localizedDiagnosticMessages && localizedDiagnosticMessages[message.key] || message.message;
    }
    function createDetachedDiagnostic(fileName, start, length2, message) {
        assertDiagnosticLocation(/*file*/ void 0, start, length2);
        let text = getLocaleSpecificMessage(message);
        if (arguments.length > 4) text = formatStringFromArgs(text, arguments, 4);
        return {
            file: void 0,
            start: start,
            length: length2,
            messageText: text,
            category: message.category,
            code: message.code,
            reportsUnnecessary: message.reportsUnnecessary,
            fileName: fileName
        };
    }
    function isDiagnosticWithDetachedLocation(diagnostic) {
        return diagnostic.file === void 0 && diagnostic.start !== void 0 && diagnostic.length !== void 0 && typeof diagnostic.fileName === "string";
    }
    function attachFileToDiagnostic(diagnostic, file) {
        const fileName = file.fileName || "";
        const length2 = file.text.length;
        Debug.assertEqual(diagnostic.fileName, fileName);
        Debug.assertLessThanOrEqual(diagnostic.start, length2);
        Debug.assertLessThanOrEqual(diagnostic.start + diagnostic.length, length2);
        const diagnosticWithLocation = {
            file: file,
            start: diagnostic.start,
            length: diagnostic.length,
            messageText: diagnostic.messageText,
            category: diagnostic.category,
            code: diagnostic.code,
            reportsUnnecessary: diagnostic.reportsUnnecessary
        };
        if (diagnostic.relatedInformation) {
            diagnosticWithLocation.relatedInformation = [];
            for (const related of diagnostic.relatedInformation)if (isDiagnosticWithDetachedLocation(related) && related.fileName === fileName) {
                Debug.assertLessThanOrEqual(related.start, length2);
                Debug.assertLessThanOrEqual(related.start + related.length, length2);
                diagnosticWithLocation.relatedInformation.push(attachFileToDiagnostic(related, file));
            } else diagnosticWithLocation.relatedInformation.push(related);
        }
        return diagnosticWithLocation;
    }
    function attachFileToDiagnostics(diagnostics, file) {
        const diagnosticsWithLocation = [];
        for (const diagnostic of diagnostics)diagnosticsWithLocation.push(attachFileToDiagnostic(diagnostic, file));
        return diagnosticsWithLocation;
    }
    function createFileDiagnostic(file, start, length2, message) {
        assertDiagnosticLocation(file, start, length2);
        let text = getLocaleSpecificMessage(message);
        if (arguments.length > 4) text = formatStringFromArgs(text, arguments, 4);
        return {
            file: file,
            start: start,
            length: length2,
            messageText: text,
            category: message.category,
            code: message.code,
            reportsUnnecessary: message.reportsUnnecessary,
            reportsDeprecated: message.reportsDeprecated
        };
    }
    function formatMessage(_dummy, message) {
        let text = getLocaleSpecificMessage(message);
        if (arguments.length > 2) text = formatStringFromArgs(text, arguments, 2);
        return text;
    }
    function createCompilerDiagnostic(message) {
        let text = getLocaleSpecificMessage(message);
        if (arguments.length > 1) text = formatStringFromArgs(text, arguments, 1);
        return {
            file: void 0,
            start: void 0,
            length: void 0,
            messageText: text,
            category: message.category,
            code: message.code,
            reportsUnnecessary: message.reportsUnnecessary,
            reportsDeprecated: message.reportsDeprecated
        };
    }
    function createCompilerDiagnosticFromMessageChain(chain, relatedInformation) {
        return {
            file: void 0,
            start: void 0,
            length: void 0,
            code: chain.code,
            category: chain.category,
            messageText: chain.next ? chain : chain.messageText,
            relatedInformation: relatedInformation
        };
    }
    function chainDiagnosticMessages(details, message) {
        let text = getLocaleSpecificMessage(message);
        if (arguments.length > 2) text = formatStringFromArgs(text, arguments, 2);
        return {
            messageText: text,
            category: message.category,
            code: message.code,
            next: details === void 0 || Array.isArray(details) ? details : [
                details
            ]
        };
    }
    function concatenateDiagnosticMessageChains(headChain, tailChain) {
        let lastChain = headChain;
        while(lastChain.next)lastChain = lastChain.next[0];
        lastChain.next = [
            tailChain
        ];
    }
    function getDiagnosticFilePath(diagnostic) {
        return diagnostic.file ? diagnostic.file.path : void 0;
    }
    function compareDiagnostics(d1, d2) {
        return compareDiagnosticsSkipRelatedInformation(d1, d2) || compareRelatedInformation(d1, d2) || 0 /* EqualTo */ ;
    }
    function compareDiagnosticsSkipRelatedInformation(d1, d2) {
        return compareStringsCaseSensitive(getDiagnosticFilePath(d1), getDiagnosticFilePath(d2)) || compareValues(d1.start, d2.start) || compareValues(d1.length, d2.length) || compareValues(d1.code, d2.code) || compareMessageText(d1.messageText, d2.messageText) || 0 /* EqualTo */ ;
    }
    function compareRelatedInformation(d1, d2) {
        if (!d1.relatedInformation && !d2.relatedInformation) return 0 /* EqualTo */ ;
        if (d1.relatedInformation && d2.relatedInformation) return compareValues(d1.relatedInformation.length, d2.relatedInformation.length) || forEach(d1.relatedInformation, (d1i, index)=>{
            const d2i = d2.relatedInformation[index];
            return compareDiagnostics(d1i, d2i);
        }) || 0 /* EqualTo */ ;
        return d1.relatedInformation ? -1 /* LessThan */  : 1 /* GreaterThan */ ;
    }
    function compareMessageText(t1, t2) {
        if (typeof t1 === "string" && typeof t2 === "string") return compareStringsCaseSensitive(t1, t2);
        else if (typeof t1 === "string") return -1 /* LessThan */ ;
        else if (typeof t2 === "string") return 1 /* GreaterThan */ ;
        let res = compareStringsCaseSensitive(t1.messageText, t2.messageText);
        if (res) return res;
        if (!t1.next && !t2.next) return 0 /* EqualTo */ ;
        if (!t1.next) return -1 /* LessThan */ ;
        if (!t2.next) return 1 /* GreaterThan */ ;
        const len = Math.min(t1.next.length, t2.next.length);
        for(let i = 0; i < len; i++){
            res = compareMessageText(t1.next[i], t2.next[i]);
            if (res) return res;
        }
        if (t1.next.length < t2.next.length) return -1 /* LessThan */ ;
        else if (t1.next.length > t2.next.length) return 1 /* GreaterThan */ ;
        return 0 /* EqualTo */ ;
    }
    function getLanguageVariant(scriptKind) {
        return scriptKind === 4 /* TSX */  || scriptKind === 2 /* JSX */  || scriptKind === 1 /* JS */  || scriptKind === 6 /* JSON */  ? 1 /* JSX */  : 0 /* Standard */ ;
    }
    function walkTreeForJSXTags(node) {
        if (!(node.transformFlags & 2 /* ContainsJsx */ )) return void 0;
        return isJsxOpeningLikeElement(node) || isJsxFragment(node) ? node : forEachChild(node, walkTreeForJSXTags);
    }
    function isFileModuleFromUsingJSXTag(file) {
        return !file.isDeclarationFile ? walkTreeForJSXTags(file) : void 0;
    }
    function isFileForcedToBeModuleByFormat(file) {
        return (file.impliedNodeFormat === 99 /* ESNext */  || fileExtensionIsOneOf(file.fileName, [
            ".cjs" /* Cjs */ ,
            ".cts" /* Cts */ ,
            ".mjs" /* Mjs */ ,
            ".mts" /* Mts */ 
        ])) && !file.isDeclarationFile ? true : void 0;
    }
    function getSetExternalModuleIndicator(options) {
        switch(getEmitModuleDetectionKind(options)){
            case 3 /* Force */ :
                return (file)=>{
                    file.externalModuleIndicator = isFileProbablyExternalModule(file) || !file.isDeclarationFile || void 0;
                };
            case 1 /* Legacy */ :
                return (file)=>{
                    file.externalModuleIndicator = isFileProbablyExternalModule(file);
                };
            case 2 /* Auto */ :
                const checks = [
                    isFileProbablyExternalModule
                ];
                if (options.jsx === 4 /* ReactJSX */  || options.jsx === 5 /* ReactJSXDev */ ) checks.push(isFileModuleFromUsingJSXTag);
                checks.push(isFileForcedToBeModuleByFormat);
                const combined = or(...checks);
                const callback = (file)=>void (file.externalModuleIndicator = combined(file));
                return callback;
        }
    }
    function getEmitScriptTarget(compilerOptions) {
        return compilerOptions.target ?? (compilerOptions.module === 100 /* Node16 */  && 9 /* ES2022 */  || compilerOptions.module === 199 /* NodeNext */  && 99 /* ESNext */  || 1 /* ES5 */ );
    }
    function getEmitModuleKind(compilerOptions) {
        return typeof compilerOptions.module === "number" ? compilerOptions.module : getEmitScriptTarget(compilerOptions) >= 2 /* ES2015 */  ? 5 /* ES2015 */  : 1 /* CommonJS */ ;
    }
    function emitModuleKindIsNonNodeESM(moduleKind) {
        return moduleKind >= 5 /* ES2015 */  && moduleKind <= 99 /* ESNext */ ;
    }
    function getEmitModuleResolutionKind(compilerOptions) {
        let moduleResolution = compilerOptions.moduleResolution;
        if (moduleResolution === void 0) switch(getEmitModuleKind(compilerOptions)){
            case 1 /* CommonJS */ :
                moduleResolution = 2 /* Node10 */ ;
                break;
            case 100 /* Node16 */ :
                moduleResolution = 3 /* Node16 */ ;
                break;
            case 199 /* NodeNext */ :
                moduleResolution = 99 /* NodeNext */ ;
                break;
            default:
                moduleResolution = 1 /* Classic */ ;
                break;
        }
        return moduleResolution;
    }
    function getEmitModuleDetectionKind(options) {
        return options.moduleDetection || (getEmitModuleKind(options) === 100 /* Node16 */  || getEmitModuleKind(options) === 199 /* NodeNext */  ? 3 /* Force */  : 2 /* Auto */ );
    }
    function hasJsonModuleEmitEnabled(options) {
        switch(getEmitModuleKind(options)){
            case 1 /* CommonJS */ :
            case 2 /* AMD */ :
            case 5 /* ES2015 */ :
            case 6 /* ES2020 */ :
            case 7 /* ES2022 */ :
            case 99 /* ESNext */ :
            case 100 /* Node16 */ :
            case 199 /* NodeNext */ :
                return true;
            default:
                return false;
        }
    }
    function getIsolatedModules(options) {
        return !!(options.isolatedModules || options.verbatimModuleSyntax);
    }
    function importNameElisionDisabled(options) {
        return options.verbatimModuleSyntax || options.isolatedModules && options.preserveValueImports;
    }
    function unreachableCodeIsError(options) {
        return options.allowUnreachableCode === false;
    }
    function unusedLabelIsError(options) {
        return options.allowUnusedLabels === false;
    }
    function getAreDeclarationMapsEnabled(options) {
        return !!(getEmitDeclarations(options) && options.declarationMap);
    }
    function getESModuleInterop(compilerOptions) {
        if (compilerOptions.esModuleInterop !== void 0) return compilerOptions.esModuleInterop;
        switch(getEmitModuleKind(compilerOptions)){
            case 100 /* Node16 */ :
            case 199 /* NodeNext */ :
                return true;
        }
        return void 0;
    }
    function getAllowSyntheticDefaultImports(compilerOptions) {
        if (compilerOptions.allowSyntheticDefaultImports !== void 0) return compilerOptions.allowSyntheticDefaultImports;
        return getESModuleInterop(compilerOptions) || getEmitModuleKind(compilerOptions) === 4 /* System */  || getEmitModuleResolutionKind(compilerOptions) === 100 /* Bundler */ ;
    }
    function moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution) {
        return moduleResolution >= 3 /* Node16 */  && moduleResolution <= 99 /* NodeNext */  || moduleResolution === 100 /* Bundler */ ;
    }
    function shouldResolveJsRequire(compilerOptions) {
        return !!compilerOptions.noDtsResolution || getEmitModuleResolutionKind(compilerOptions) !== 100 /* Bundler */ ;
    }
    function getResolvePackageJsonExports(compilerOptions) {
        const moduleResolution = getEmitModuleResolutionKind(compilerOptions);
        if (!moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution)) return false;
        if (compilerOptions.resolvePackageJsonExports !== void 0) return compilerOptions.resolvePackageJsonExports;
        switch(moduleResolution){
            case 3 /* Node16 */ :
            case 99 /* NodeNext */ :
            case 100 /* Bundler */ :
                return true;
        }
        return false;
    }
    function getResolvePackageJsonImports(compilerOptions) {
        const moduleResolution = getEmitModuleResolutionKind(compilerOptions);
        if (!moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution)) return false;
        if (compilerOptions.resolvePackageJsonExports !== void 0) return compilerOptions.resolvePackageJsonExports;
        switch(moduleResolution){
            case 3 /* Node16 */ :
            case 99 /* NodeNext */ :
            case 100 /* Bundler */ :
                return true;
        }
        return false;
    }
    function getResolveJsonModule(compilerOptions) {
        if (compilerOptions.resolveJsonModule !== void 0) return compilerOptions.resolveJsonModule;
        return getEmitModuleResolutionKind(compilerOptions) === 100 /* Bundler */ ;
    }
    function getEmitDeclarations(compilerOptions) {
        return !!(compilerOptions.declaration || compilerOptions.composite);
    }
    function shouldPreserveConstEnums(compilerOptions) {
        return !!(compilerOptions.preserveConstEnums || getIsolatedModules(compilerOptions));
    }
    function isIncrementalCompilation(options) {
        return !!(options.incremental || options.composite);
    }
    function getStrictOptionValue(compilerOptions, flag) {
        return compilerOptions[flag] === void 0 ? !!compilerOptions.strict : !!compilerOptions[flag];
    }
    function getAllowJSCompilerOption(compilerOptions) {
        return compilerOptions.allowJs === void 0 ? !!compilerOptions.checkJs : compilerOptions.allowJs;
    }
    function getUseDefineForClassFields(compilerOptions) {
        return compilerOptions.useDefineForClassFields === void 0 ? getEmitScriptTarget(compilerOptions) >= 9 /* ES2022 */  : compilerOptions.useDefineForClassFields;
    }
    function compilerOptionsAffectSemanticDiagnostics(newOptions, oldOptions) {
        return optionsHaveChanges(oldOptions, newOptions, semanticDiagnosticsOptionDeclarations);
    }
    function compilerOptionsAffectEmit(newOptions, oldOptions) {
        return optionsHaveChanges(oldOptions, newOptions, affectsEmitOptionDeclarations);
    }
    function compilerOptionsAffectDeclarationPath(newOptions, oldOptions) {
        return optionsHaveChanges(oldOptions, newOptions, affectsDeclarationPathOptionDeclarations);
    }
    function getCompilerOptionValue(options, option) {
        return option.strictFlag ? getStrictOptionValue(options, option.name) : options[option.name];
    }
    function getJSXTransformEnabled(options) {
        const jsx = options.jsx;
        return jsx === 2 /* React */  || jsx === 4 /* ReactJSX */  || jsx === 5 /* ReactJSXDev */ ;
    }
    function getJSXImplicitImportBase(compilerOptions, file) {
        const jsxImportSourcePragmas = file == null ? void 0 : file.pragmas.get("jsximportsource");
        const jsxImportSourcePragma = isArray(jsxImportSourcePragmas) ? jsxImportSourcePragmas[jsxImportSourcePragmas.length - 1] : jsxImportSourcePragmas;
        return compilerOptions.jsx === 4 /* ReactJSX */  || compilerOptions.jsx === 5 /* ReactJSXDev */  || compilerOptions.jsxImportSource || jsxImportSourcePragma ? (jsxImportSourcePragma == null ? void 0 : jsxImportSourcePragma.arguments.factory) || compilerOptions.jsxImportSource || "react" : void 0;
    }
    function getJSXRuntimeImport(base, options) {
        return base ? `${base}/${options.jsx === 5 /* ReactJSXDev */  ? "jsx-dev-runtime" : "jsx-runtime"}` : void 0;
    }
    function hasZeroOrOneAsteriskCharacter(str) {
        let seenAsterisk = false;
        for(let i = 0; i < str.length; i++)if (str.charCodeAt(i) === 42 /* asterisk */ ) {
            if (!seenAsterisk) seenAsterisk = true;
            else return false;
        }
        return true;
    }
    function createSymlinkCache(cwd, getCanonicalFileName) {
        let symlinkedDirectories;
        let symlinkedDirectoriesByRealpath;
        let symlinkedFiles;
        let hasProcessedResolutions = false;
        return {
            getSymlinkedFiles: ()=>symlinkedFiles,
            getSymlinkedDirectories: ()=>symlinkedDirectories,
            getSymlinkedDirectoriesByRealpath: ()=>symlinkedDirectoriesByRealpath,
            setSymlinkedFile: (path, real)=>(symlinkedFiles || (symlinkedFiles = /* @__PURE__ */ new Map())).set(path, real),
            setSymlinkedDirectory: (symlink, real)=>{
                let symlinkPath = toPath(symlink, cwd, getCanonicalFileName);
                if (!containsIgnoredPath(symlinkPath)) {
                    symlinkPath = ensureTrailingDirectorySeparator(symlinkPath);
                    if (real !== false && !(symlinkedDirectories == null ? void 0 : symlinkedDirectories.has(symlinkPath))) (symlinkedDirectoriesByRealpath || (symlinkedDirectoriesByRealpath = createMultiMap())).add(ensureTrailingDirectorySeparator(real.realPath), symlink);
                    (symlinkedDirectories || (symlinkedDirectories = /* @__PURE__ */ new Map())).set(symlinkPath, real);
                }
            },
            setSymlinksFromResolutions (files, typeReferenceDirectives) {
                var _a, _b;
                Debug.assert(!hasProcessedResolutions);
                hasProcessedResolutions = true;
                for (const file of files){
                    (_a = file.resolvedModules) == null || _a.forEach((resolution)=>processResolution(this, resolution.resolvedModule));
                    (_b = file.resolvedTypeReferenceDirectiveNames) == null || _b.forEach((resolution)=>processResolution(this, resolution.resolvedTypeReferenceDirective));
                }
                typeReferenceDirectives.forEach((resolution)=>processResolution(this, resolution.resolvedTypeReferenceDirective));
            },
            hasProcessedResolutions: ()=>hasProcessedResolutions
        };
        function processResolution(cache, resolution) {
            if (!resolution || !resolution.originalPath || !resolution.resolvedFileName) return;
            const { resolvedFileName: resolvedFileName , originalPath: originalPath  } = resolution;
            cache.setSymlinkedFile(toPath(originalPath, cwd, getCanonicalFileName), resolvedFileName);
            const [commonResolved, commonOriginal] = guessDirectorySymlink(resolvedFileName, originalPath, cwd, getCanonicalFileName) || emptyArray;
            if (commonResolved && commonOriginal) cache.setSymlinkedDirectory(commonOriginal, {
                real: commonResolved,
                realPath: toPath(commonResolved, cwd, getCanonicalFileName)
            });
        }
    }
    function guessDirectorySymlink(a, b, cwd, getCanonicalFileName) {
        const aParts = getPathComponents(getNormalizedAbsolutePath(a, cwd));
        const bParts = getPathComponents(getNormalizedAbsolutePath(b, cwd));
        let isDirectory = false;
        while(aParts.length >= 2 && bParts.length >= 2 && !isNodeModulesOrScopedPackageDirectory(aParts[aParts.length - 2], getCanonicalFileName) && !isNodeModulesOrScopedPackageDirectory(bParts[bParts.length - 2], getCanonicalFileName) && getCanonicalFileName(aParts[aParts.length - 1]) === getCanonicalFileName(bParts[bParts.length - 1])){
            aParts.pop();
            bParts.pop();
            isDirectory = true;
        }
        return isDirectory ? [
            getPathFromPathComponents(aParts),
            getPathFromPathComponents(bParts)
        ] : void 0;
    }
    function isNodeModulesOrScopedPackageDirectory(s, getCanonicalFileName) {
        return s !== void 0 && (getCanonicalFileName(s) === "node_modules" || startsWith(s, "@"));
    }
    function stripLeadingDirectorySeparator(s) {
        return isAnyDirectorySeparator(s.charCodeAt(0)) ? s.slice(1) : void 0;
    }
    function tryRemoveDirectoryPrefix(path, dirPath, getCanonicalFileName) {
        const withoutPrefix = tryRemovePrefix(path, dirPath, getCanonicalFileName);
        return withoutPrefix === void 0 ? void 0 : stripLeadingDirectorySeparator(withoutPrefix);
    }
    function regExpEscape(text) {
        return text.replace(reservedCharacterPattern, escapeRegExpCharacter);
    }
    function escapeRegExpCharacter(match) {
        return "\\" + match;
    }
    function getRegularExpressionForWildcard(specs, basePath, usage) {
        const patterns = getRegularExpressionsForWildcards(specs, basePath, usage);
        if (!patterns || !patterns.length) return void 0;
        const pattern = patterns.map((pattern2)=>`(${pattern2})`).join("|");
        const terminator = usage === "exclude" ? "($|/)" : "$";
        return `^(${pattern})${terminator}`;
    }
    function getRegularExpressionsForWildcards(specs, basePath, usage) {
        if (specs === void 0 || specs.length === 0) return void 0;
        return flatMap(specs, (spec)=>spec && getSubPatternFromSpec(spec, basePath, usage, wildcardMatchers[usage]));
    }
    function isImplicitGlob(lastPathComponent) {
        return !/[.*?]/.test(lastPathComponent);
    }
    function getPatternFromSpec(spec, basePath, usage) {
        const pattern = spec && getSubPatternFromSpec(spec, basePath, usage, wildcardMatchers[usage]);
        return pattern && `^(${pattern})${usage === "exclude" ? "($|/)" : "$"}`;
    }
    function getSubPatternFromSpec(spec, basePath, usage, { singleAsteriskRegexFragment: singleAsteriskRegexFragment , doubleAsteriskRegexFragment: doubleAsteriskRegexFragment , replaceWildcardCharacter: replaceWildcardCharacter2  }) {
        let subpattern = "";
        let hasWrittenComponent = false;
        const components = getNormalizedPathComponents(spec, basePath);
        const lastComponent = last(components);
        if (usage !== "exclude" && lastComponent === "**") return void 0;
        components[0] = removeTrailingDirectorySeparator(components[0]);
        if (isImplicitGlob(lastComponent)) components.push("**", "*");
        let optionalCount = 0;
        for (let component of components){
            if (component === "**") subpattern += doubleAsteriskRegexFragment;
            else {
                if (usage === "directories") {
                    subpattern += "(";
                    optionalCount++;
                }
                if (hasWrittenComponent) subpattern += directorySeparator;
                if (usage !== "exclude") {
                    let componentPattern = "";
                    if (component.charCodeAt(0) === 42 /* asterisk */ ) {
                        componentPattern += "([^./]" + singleAsteriskRegexFragment + ")?";
                        component = component.substr(1);
                    } else if (component.charCodeAt(0) === 63 /* question */ ) {
                        componentPattern += "[^./]";
                        component = component.substr(1);
                    }
                    componentPattern += component.replace(reservedCharacterPattern, replaceWildcardCharacter2);
                    if (componentPattern !== component) subpattern += implicitExcludePathRegexPattern;
                    subpattern += componentPattern;
                } else subpattern += component.replace(reservedCharacterPattern, replaceWildcardCharacter2);
            }
            hasWrittenComponent = true;
        }
        while(optionalCount > 0){
            subpattern += ")?";
            optionalCount--;
        }
        return subpattern;
    }
    function replaceWildcardCharacter(match, singleAsteriskRegexFragment) {
        return match === "*" ? singleAsteriskRegexFragment : match === "?" ? "[^/]" : "\\" + match;
    }
    function getFileMatcherPatterns(path, excludes, includes, useCaseSensitiveFileNames, currentDirectory) {
        path = normalizePath(path);
        currentDirectory = normalizePath(currentDirectory);
        const absolutePath = combinePaths(currentDirectory, path);
        return {
            includeFilePatterns: map(getRegularExpressionsForWildcards(includes, absolutePath, "files"), (pattern)=>`^${pattern}$`),
            includeFilePattern: getRegularExpressionForWildcard(includes, absolutePath, "files"),
            includeDirectoryPattern: getRegularExpressionForWildcard(includes, absolutePath, "directories"),
            excludePattern: getRegularExpressionForWildcard(excludes, absolutePath, "exclude"),
            basePaths: getBasePaths(path, includes, useCaseSensitiveFileNames)
        };
    }
    function getRegexFromPattern(pattern, useCaseSensitiveFileNames) {
        return new RegExp(pattern, useCaseSensitiveFileNames ? "" : "i");
    }
    function matchFiles(path, extensions, excludes, includes, useCaseSensitiveFileNames, currentDirectory, depth, getFileSystemEntries, realpath) {
        path = normalizePath(path);
        currentDirectory = normalizePath(currentDirectory);
        const patterns = getFileMatcherPatterns(path, excludes, includes, useCaseSensitiveFileNames, currentDirectory);
        const includeFileRegexes = patterns.includeFilePatterns && patterns.includeFilePatterns.map((pattern)=>getRegexFromPattern(pattern, useCaseSensitiveFileNames));
        const includeDirectoryRegex = patterns.includeDirectoryPattern && getRegexFromPattern(patterns.includeDirectoryPattern, useCaseSensitiveFileNames);
        const excludeRegex = patterns.excludePattern && getRegexFromPattern(patterns.excludePattern, useCaseSensitiveFileNames);
        const results = includeFileRegexes ? includeFileRegexes.map(()=>[]) : [
            []
        ];
        const visited = /* @__PURE__ */ new Map();
        const toCanonical = createGetCanonicalFileName(useCaseSensitiveFileNames);
        for (const basePath of patterns.basePaths)visitDirectory(basePath, combinePaths(currentDirectory, basePath), depth);
        return flatten(results);
        function visitDirectory(path2, absolutePath, depth2) {
            const canonicalPath = toCanonical(realpath(absolutePath));
            if (visited.has(canonicalPath)) return;
            visited.set(canonicalPath, true);
            const { files: files , directories: directories  } = getFileSystemEntries(path2);
            for (const current of sort(files, compareStringsCaseSensitive)){
                const name = combinePaths(path2, current);
                const absoluteName = combinePaths(absolutePath, current);
                if (extensions && !fileExtensionIsOneOf(name, extensions)) continue;
                if (excludeRegex && excludeRegex.test(absoluteName)) continue;
                if (!includeFileRegexes) results[0].push(name);
                else {
                    const includeIndex = findIndex(includeFileRegexes, (re)=>re.test(absoluteName));
                    if (includeIndex !== -1) results[includeIndex].push(name);
                }
            }
            if (depth2 !== void 0) {
                depth2--;
                if (depth2 === 0) return;
            }
            for (const current of sort(directories, compareStringsCaseSensitive)){
                const name = combinePaths(path2, current);
                const absoluteName = combinePaths(absolutePath, current);
                if ((!includeDirectoryRegex || includeDirectoryRegex.test(absoluteName)) && (!excludeRegex || !excludeRegex.test(absoluteName))) visitDirectory(name, absoluteName, depth2);
            }
        }
    }
    function getBasePaths(path, includes, useCaseSensitiveFileNames) {
        const basePaths = [
            path
        ];
        if (includes) {
            const includeBasePaths = [];
            for (const include of includes){
                const absolute = isRootedDiskPath(include) ? include : normalizePath(combinePaths(path, include));
                includeBasePaths.push(getIncludeBasePath(absolute));
            }
            includeBasePaths.sort(getStringComparer(!useCaseSensitiveFileNames));
            for (const includeBasePath of includeBasePaths)if (every(basePaths, (basePath)=>!containsPath(basePath, includeBasePath, path, !useCaseSensitiveFileNames))) basePaths.push(includeBasePath);
        }
        return basePaths;
    }
    function getIncludeBasePath(absolute) {
        const wildcardOffset = indexOfAnyCharCode(absolute, wildcardCharCodes);
        if (wildcardOffset < 0) return !hasExtension(absolute) ? absolute : removeTrailingDirectorySeparator(getDirectoryPath(absolute));
        return absolute.substring(0, absolute.lastIndexOf(directorySeparator, wildcardOffset));
    }
    function ensureScriptKind(fileName, scriptKind) {
        return scriptKind || getScriptKindFromFileName(fileName) || 3 /* TS */ ;
    }
    function getScriptKindFromFileName(fileName) {
        const ext = fileName.substr(fileName.lastIndexOf("."));
        switch(ext.toLowerCase()){
            case ".js" /* Js */ :
            case ".cjs" /* Cjs */ :
            case ".mjs" /* Mjs */ :
                return 1 /* JS */ ;
            case ".jsx" /* Jsx */ :
                return 2 /* JSX */ ;
            case ".ts" /* Ts */ :
            case ".cts" /* Cts */ :
            case ".mts" /* Mts */ :
                return 3 /* TS */ ;
            case ".tsx" /* Tsx */ :
                return 4 /* TSX */ ;
            case ".json" /* Json */ :
                return 6 /* JSON */ ;
            default:
                return 0 /* Unknown */ ;
        }
    }
    function getSupportedExtensions(options, extraFileExtensions) {
        const needJsExtensions = options && getAllowJSCompilerOption(options);
        if (!extraFileExtensions || extraFileExtensions.length === 0) return needJsExtensions ? allSupportedExtensions : supportedTSExtensions;
        const builtins = needJsExtensions ? allSupportedExtensions : supportedTSExtensions;
        const flatBuiltins = flatten(builtins);
        const extensions = [
            ...builtins,
            ...mapDefined(extraFileExtensions, (x)=>x.scriptKind === 7 /* Deferred */  || needJsExtensions && isJSLike(x.scriptKind) && flatBuiltins.indexOf(x.extension) === -1 ? [
                    x.extension
                ] : void 0)
        ];
        return extensions;
    }
    function getSupportedExtensionsWithJsonIfResolveJsonModule(options, supportedExtensions) {
        if (!options || !getResolveJsonModule(options)) return supportedExtensions;
        if (supportedExtensions === allSupportedExtensions) return allSupportedExtensionsWithJson;
        if (supportedExtensions === supportedTSExtensions) return supportedTSExtensionsWithJson;
        return [
            ...supportedExtensions,
            [
                ".json" /* Json */ 
            ]
        ];
    }
    function isJSLike(scriptKind) {
        return scriptKind === 1 /* JS */  || scriptKind === 2 /* JSX */ ;
    }
    function hasJSFileExtension(fileName) {
        return some(supportedJSExtensionsFlat, (extension)=>fileExtensionIs(fileName, extension));
    }
    function hasTSFileExtension(fileName) {
        return some(supportedTSExtensionsFlat, (extension)=>fileExtensionIs(fileName, extension));
    }
    function usesExtensionsOnImports({ imports: imports  }, hasExtension2 = or(hasJSFileExtension, hasTSFileExtension)) {
        return firstDefined(imports, ({ text: text  })=>pathIsRelative(text) && !fileExtensionIsOneOf(text, extensionsNotSupportingExtensionlessResolution) ? hasExtension2(text) : void 0) || false;
    }
    function getModuleSpecifierEndingPreference(preference, resolutionMode, compilerOptions, sourceFile) {
        if (preference === "js" || resolutionMode === 99 /* ESNext */ ) {
            if (!shouldAllowImportingTsExtension(compilerOptions)) return 2 /* JsExtension */ ;
            return inferPreference() !== 2 /* JsExtension */  ? 3 /* TsExtension */  : 2 /* JsExtension */ ;
        }
        if (preference === "minimal") return 0 /* Minimal */ ;
        if (preference === "index") return 1 /* Index */ ;
        if (!shouldAllowImportingTsExtension(compilerOptions)) return usesExtensionsOnImports(sourceFile) ? 2 /* JsExtension */  : 0 /* Minimal */ ;
        return inferPreference();
        function inferPreference() {
            let usesJsExtensions = false;
            const specifiers = sourceFile.imports.length ? sourceFile.imports.map((i)=>i.text) : isSourceFileJS(sourceFile) ? getRequiresAtTopOfFile(sourceFile).map((r)=>r.arguments[0].text) : emptyArray;
            for (const specifier of specifiers)if (pathIsRelative(specifier)) {
                if (fileExtensionIsOneOf(specifier, extensionsNotSupportingExtensionlessResolution)) continue;
                if (hasTSFileExtension(specifier)) return 3 /* TsExtension */ ;
                if (hasJSFileExtension(specifier)) usesJsExtensions = true;
            }
            return usesJsExtensions ? 2 /* JsExtension */  : 0 /* Minimal */ ;
        }
    }
    function getRequiresAtTopOfFile(sourceFile) {
        let nonRequireStatementCount = 0;
        let requires;
        for (const statement of sourceFile.statements){
            if (nonRequireStatementCount > 3) break;
            if (isRequireVariableStatement(statement)) requires = concatenate(requires, statement.declarationList.declarations.map((d)=>d.initializer));
            else if (isExpressionStatement(statement) && isRequireCall(statement.expression, /*requireStringLiteralLikeArgument*/ true)) requires = append(requires, statement.expression);
            else nonRequireStatementCount++;
        }
        return requires || emptyArray;
    }
    function isSupportedSourceFileName(fileName, compilerOptions, extraFileExtensions) {
        if (!fileName) return false;
        const supportedExtensions = getSupportedExtensions(compilerOptions, extraFileExtensions);
        for (const extension of flatten(getSupportedExtensionsWithJsonIfResolveJsonModule(compilerOptions, supportedExtensions))){
            if (fileExtensionIs(fileName, extension)) return true;
        }
        return false;
    }
    function numberOfDirectorySeparators(str) {
        const match = str.match(/\//g);
        return match ? match.length : 0;
    }
    function compareNumberOfDirectorySeparators(path1, path2) {
        return compareValues(numberOfDirectorySeparators(path1), numberOfDirectorySeparators(path2));
    }
    function removeFileExtension(path) {
        for (const ext of extensionsToRemove){
            const extensionless = tryRemoveExtension(path, ext);
            if (extensionless !== void 0) return extensionless;
        }
        return path;
    }
    function tryRemoveExtension(path, extension) {
        return fileExtensionIs(path, extension) ? removeExtension(path, extension) : void 0;
    }
    function removeExtension(path, extension) {
        return path.substring(0, path.length - extension.length);
    }
    function changeExtension(path, newExtension) {
        return changeAnyExtension(path, newExtension, extensionsToRemove, /*ignoreCase*/ false);
    }
    function tryParsePattern(pattern) {
        const indexOfStar = pattern.indexOf("*");
        if (indexOfStar === -1) return pattern;
        return pattern.indexOf("*", indexOfStar + 1) !== -1 ? void 0 : {
            prefix: pattern.substr(0, indexOfStar),
            suffix: pattern.substr(indexOfStar + 1)
        };
    }
    function tryParsePatterns(paths) {
        return mapDefined(getOwnKeys(paths), (path)=>tryParsePattern(path));
    }
    function positionIsSynthesized(pos) {
        return !(pos >= 0);
    }
    function extensionIsTS(ext) {
        return ext === ".ts" /* Ts */  || ext === ".tsx" /* Tsx */  || ext === ".d.ts" /* Dts */  || ext === ".cts" /* Cts */  || ext === ".mts" /* Mts */  || ext === ".d.mts" /* Dmts */  || ext === ".d.cts" /* Dcts */  || startsWith(ext, ".d.") && endsWith(ext, ".ts");
    }
    function resolutionExtensionIsTSOrJson(ext) {
        return extensionIsTS(ext) || ext === ".json" /* Json */ ;
    }
    function extensionFromPath(path) {
        const ext = tryGetExtensionFromPath2(path);
        return ext !== void 0 ? ext : Debug.fail(`File ${path} has unknown extension.`);
    }
    function isAnySupportedFileExtension(path) {
        return tryGetExtensionFromPath2(path) !== void 0;
    }
    function tryGetExtensionFromPath2(path) {
        return find(extensionsToRemove, (e)=>fileExtensionIs(path, e));
    }
    function isCheckJsEnabledForFile(sourceFile, compilerOptions) {
        return sourceFile.checkJsDirective ? sourceFile.checkJsDirective.enabled : compilerOptions.checkJs;
    }
    function matchPatternOrExact(patternOrStrings, candidate) {
        const patterns = [];
        for (const patternOrString of patternOrStrings){
            if (patternOrString === candidate) return candidate;
            if (!isString(patternOrString)) patterns.push(patternOrString);
        }
        return findBestPatternMatch(patterns, (_)=>_, candidate);
    }
    function sliceAfter(arr, value1) {
        const index = arr.indexOf(value1);
        Debug.assert(index !== -1);
        return arr.slice(index);
    }
    function addRelatedInfo(diagnostic, ...relatedInformation) {
        if (!relatedInformation.length) return diagnostic;
        if (!diagnostic.relatedInformation) diagnostic.relatedInformation = [];
        Debug.assert(diagnostic.relatedInformation !== emptyArray, "Diagnostic had empty array singleton for related info, but is still being constructed!");
        diagnostic.relatedInformation.push(...relatedInformation);
        return diagnostic;
    }
    function minAndMax(arr, getValue) {
        Debug.assert(arr.length !== 0);
        let min2 = getValue(arr[0]);
        let max = min2;
        for(let i = 1; i < arr.length; i++){
            const value1 = getValue(arr[i]);
            if (value1 < min2) min2 = value1;
            else if (value1 > max) max = value1;
        }
        return {
            min: min2,
            max: max
        };
    }
    function rangeOfNode(node) {
        return {
            pos: getTokenPosOfNode(node),
            end: node.end
        };
    }
    function rangeOfTypeParameters(sourceFile, typeParameters) {
        const pos = typeParameters.pos - 1;
        const end = Math.min(sourceFile.text.length, skipTrivia(sourceFile.text, typeParameters.end) + 1);
        return {
            pos: pos,
            end: end
        };
    }
    function skipTypeChecking(sourceFile, options, host) {
        return options.skipLibCheck && sourceFile.isDeclarationFile || options.skipDefaultLibCheck && sourceFile.hasNoDefaultLib || host.isSourceOfProjectReferenceRedirect(sourceFile.fileName);
    }
    function isJsonEqual(a, b) {
        return a === b || typeof a === "object" && a !== null && typeof b === "object" && b !== null && equalOwnProperties(a, b, isJsonEqual);
    }
    function parsePseudoBigInt(stringValue) {
        let log2Base;
        switch(stringValue.charCodeAt(1)){
            case 98 /* b */ :
            case 66 /* B */ :
                log2Base = 1;
                break;
            case 111 /* o */ :
            case 79 /* O */ :
                log2Base = 3;
                break;
            case 120 /* x */ :
            case 88 /* X */ :
                log2Base = 4;
                break;
            default:
                const nIndex = stringValue.length - 1;
                let nonZeroStart = 0;
                while(stringValue.charCodeAt(nonZeroStart) === 48 /* _0 */ )nonZeroStart++;
                return stringValue.slice(nonZeroStart, nIndex) || "0";
        }
        const startIndex = 2, endIndex = stringValue.length - 1;
        const bitsNeeded = (endIndex - startIndex) * log2Base;
        const segments = new Uint16Array((bitsNeeded >>> 4) + (bitsNeeded & 15 ? 1 : 0));
        for(let i = endIndex - 1, bitOffset = 0; i >= startIndex; i--, bitOffset += log2Base){
            const segment = bitOffset >>> 4;
            const digitChar = stringValue.charCodeAt(i);
            const digit = digitChar <= 57 /* _9 */  ? digitChar - 48 /* _0 */  : 10 + digitChar - (digitChar <= 70 /* F */  ? 65 /* A */  : 97 /* a */ );
            const shiftedDigit = digit << (bitOffset & 15);
            segments[segment] |= shiftedDigit;
            const residual = shiftedDigit >>> 16;
            if (residual) segments[segment + 1] |= residual;
        }
        let base10Value = "";
        let firstNonzeroSegment = segments.length - 1;
        let segmentsRemaining = true;
        while(segmentsRemaining){
            let mod10 = 0;
            segmentsRemaining = false;
            for(let segment = firstNonzeroSegment; segment >= 0; segment--){
                const newSegment = mod10 << 16 | segments[segment];
                const segmentValue = newSegment / 10 | 0;
                segments[segment] = segmentValue;
                mod10 = newSegment - segmentValue * 10;
                if (segmentValue && !segmentsRemaining) {
                    firstNonzeroSegment = segment;
                    segmentsRemaining = true;
                }
            }
            base10Value = mod10 + base10Value;
        }
        return base10Value;
    }
    function pseudoBigIntToString({ negative: negative , base10Value: base10Value  }) {
        return (negative && base10Value !== "0" ? "-" : "") + base10Value;
    }
    function parseBigInt(text) {
        if (!isValidBigIntString(text, /*roundTripOnly*/ false)) return void 0;
        return parseValidBigInt(text);
    }
    function parseValidBigInt(text) {
        const negative = text.startsWith("-");
        const base10Value = parsePseudoBigInt(`${negative ? text.slice(1) : text}n`);
        return {
            negative: negative,
            base10Value: base10Value
        };
    }
    function isValidBigIntString(s, roundTripOnly) {
        if (s === "") return false;
        const scanner2 = createScanner(99 /* ESNext */ , /*skipTrivia*/ false);
        let success = true;
        scanner2.setOnError(()=>success = false);
        scanner2.setText(s + "n");
        let result = scanner2.scan();
        const negative = result === 41 /* MinusToken */ ;
        if (negative) result = scanner2.scan();
        const flags = scanner2.getTokenFlags();
        return success && result === 10 /* BigIntLiteral */  && scanner2.getTokenEnd() === s.length + 1 && !(flags & 512 /* ContainsSeparator */ ) && (!roundTripOnly || s === pseudoBigIntToString({
            negative: negative,
            base10Value: parsePseudoBigInt(scanner2.getTokenValue())
        }));
    }
    function isValidTypeOnlyAliasUseSite(useSite) {
        return !!(useSite.flags & 16777216 /* Ambient */ ) || isPartOfTypeQuery(useSite) || isIdentifierInNonEmittingHeritageClause(useSite) || isPartOfPossiblyValidTypeOrAbstractComputedPropertyName(useSite) || !(isExpressionNode(useSite) || isShorthandPropertyNameUseSite(useSite));
    }
    function isShorthandPropertyNameUseSite(useSite) {
        return isIdentifier(useSite) && isShorthandPropertyAssignment(useSite.parent) && useSite.parent.name === useSite;
    }
    function isPartOfPossiblyValidTypeOrAbstractComputedPropertyName(node) {
        while(node.kind === 80 /* Identifier */  || node.kind === 210 /* PropertyAccessExpression */ )node = node.parent;
        if (node.kind !== 166 /* ComputedPropertyName */ ) return false;
        if (hasSyntacticModifier(node.parent, 256 /* Abstract */ )) return true;
        const containerKind = node.parent.parent.kind;
        return containerKind === 263 /* InterfaceDeclaration */  || containerKind === 186 /* TypeLiteral */ ;
    }
    function isIdentifierInNonEmittingHeritageClause(node) {
        if (node.kind !== 80 /* Identifier */ ) return false;
        const heritageClause = findAncestor(node.parent, (parent2)=>{
            switch(parent2.kind){
                case 297 /* HeritageClause */ :
                    return true;
                case 210 /* PropertyAccessExpression */ :
                case 232 /* ExpressionWithTypeArguments */ :
                    return false;
                default:
                    return "quit";
            }
        });
        return (heritageClause == null ? void 0 : heritageClause.token) === 119 /* ImplementsKeyword */  || (heritageClause == null ? void 0 : heritageClause.parent.kind) === 263 /* InterfaceDeclaration */ ;
    }
    function isIdentifierTypeReference(node) {
        return isTypeReferenceNode(node) && isIdentifier(node.typeName);
    }
    function arrayIsHomogeneous(array, comparer = equateValues) {
        if (array.length < 2) return true;
        const first2 = array[0];
        for(let i = 1, length2 = array.length; i < length2; i++){
            const target = array[i];
            if (!comparer(first2, target)) return false;
        }
        return true;
    }
    function setTextRangePos(range, pos) {
        range.pos = pos;
        return range;
    }
    function setTextRangeEnd(range, end) {
        range.end = end;
        return range;
    }
    function setTextRangePosEnd(range, pos, end) {
        return setTextRangeEnd(setTextRangePos(range, pos), end);
    }
    function setTextRangePosWidth(range, pos, width) {
        return setTextRangePosEnd(range, pos, pos + width);
    }
    function setNodeFlags(node, newFlags) {
        if (node) node.flags = newFlags;
        return node;
    }
    function setParent(child, parent2) {
        if (child && parent2) child.parent = parent2;
        return child;
    }
    function setEachParent(children, parent2) {
        if (children) for (const child of children)setParent(child, parent2);
        return children;
    }
    function setParentRecursive(rootNode, incremental) {
        if (!rootNode) return rootNode;
        forEachChildRecursively(rootNode, isJSDocNode(rootNode) ? bindParentToChildIgnoringJSDoc : bindParentToChild);
        return rootNode;
        function bindParentToChildIgnoringJSDoc(child, parent2) {
            if (incremental && child.parent === parent2) return "skip";
            setParent(child, parent2);
        }
        function bindJSDoc(child) {
            if (hasJSDocNodes(child)) for (const doc of child.jsDoc){
                bindParentToChildIgnoringJSDoc(doc, child);
                forEachChildRecursively(doc, bindParentToChildIgnoringJSDoc);
            }
        }
        function bindParentToChild(child, parent2) {
            return bindParentToChildIgnoringJSDoc(child, parent2) || bindJSDoc(child);
        }
    }
    function isPackedElement(node) {
        return !isOmittedExpression(node);
    }
    function isPackedArrayLiteral(node) {
        return isArrayLiteralExpression(node) && every(node.elements, isPackedElement);
    }
    function expressionResultIsUnused(node) {
        Debug.assertIsDefined(node.parent);
        while(true){
            const parent2 = node.parent;
            if (isParenthesizedExpression(parent2)) {
                node = parent2;
                continue;
            }
            if (isExpressionStatement(parent2) || isVoidExpression(parent2) || isForStatement(parent2) && (parent2.initializer === node || parent2.incrementor === node)) return true;
            if (isCommaListExpression(parent2)) {
                if (node !== last(parent2.elements)) return true;
                node = parent2;
                continue;
            }
            if (isBinaryExpression(parent2) && parent2.operatorToken.kind === 28 /* CommaToken */ ) {
                if (node === parent2.left) return true;
                node = parent2;
                continue;
            }
            return false;
        }
    }
    function containsIgnoredPath(path) {
        return some(ignoredPaths, (p)=>stringContains(path, p));
    }
    function getContainingNodeArray(node) {
        if (!node.parent) return void 0;
        switch(node.kind){
            case 167 /* TypeParameter */ :
                const { parent: parent3  } = node;
                return parent3.kind === 194 /* InferType */  ? void 0 : parent3.typeParameters;
            case 168 /* Parameter */ :
                return node.parent.parameters;
            case 203 /* TemplateLiteralTypeSpan */ :
                return node.parent.templateSpans;
            case 238 /* TemplateSpan */ :
                return node.parent.templateSpans;
            case 169 /* Decorator */ :
                {
                    const { parent: parent4  } = node;
                    return canHaveDecorators(parent4) ? parent4.modifiers : void 0;
                }
            case 297 /* HeritageClause */ :
                return node.parent.heritageClauses;
        }
        const { parent: parent2  } = node;
        if (isJSDocTag(node)) return isJSDocTypeLiteral(node.parent) ? void 0 : node.parent.tags;
        switch(parent2.kind){
            case 186 /* TypeLiteral */ :
            case 263 /* InterfaceDeclaration */ :
                return isTypeElement(node) ? parent2.members : void 0;
            case 191 /* UnionType */ :
            case 192 /* IntersectionType */ :
                return parent2.types;
            case 188 /* TupleType */ :
            case 208 /* ArrayLiteralExpression */ :
            case 360 /* CommaListExpression */ :
            case 274 /* NamedImports */ :
            case 278 /* NamedExports */ :
                return parent2.elements;
            case 209 /* ObjectLiteralExpression */ :
            case 291 /* JsxAttributes */ :
                return parent2.properties;
            case 212 /* CallExpression */ :
            case 213 /* NewExpression */ :
                return isTypeNode(node) ? parent2.typeArguments : parent2.expression === node ? void 0 : parent2.arguments;
            case 283 /* JsxElement */ :
            case 287 /* JsxFragment */ :
                return isJsxChild(node) ? parent2.children : void 0;
            case 285 /* JsxOpeningElement */ :
            case 284 /* JsxSelfClosingElement */ :
                return isTypeNode(node) ? parent2.typeArguments : void 0;
            case 240 /* Block */ :
            case 295 /* CaseClause */ :
            case 296 /* DefaultClause */ :
            case 267 /* ModuleBlock */ :
                return parent2.statements;
            case 268 /* CaseBlock */ :
                return parent2.clauses;
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
                return isClassElement(node) ? parent2.members : void 0;
            case 265 /* EnumDeclaration */ :
                return isEnumMember(node) ? parent2.members : void 0;
            case 311 /* SourceFile */ :
                return parent2.statements;
        }
    }
    function hasContextSensitiveParameters(node) {
        if (!node.typeParameters) {
            if (some(node.parameters, (p)=>!getEffectiveTypeAnnotationNode(p))) return true;
            if (node.kind !== 218 /* ArrowFunction */ ) {
                const parameter = firstOrUndefined(node.parameters);
                if (!(parameter && parameterIsThisKeyword(parameter))) return true;
            }
        }
        return false;
    }
    function isInfinityOrNaNString(name) {
        return name === "Infinity" || name === "-Infinity" || name === "NaN";
    }
    function isCatchClauseVariableDeclaration(node) {
        return node.kind === 259 /* VariableDeclaration */  && node.parent.kind === 298 /* CatchClause */ ;
    }
    function isParameterOrCatchClauseVariable(symbol) {
        const declaration = symbol.valueDeclaration && getRootDeclaration(symbol.valueDeclaration);
        return !!declaration && (isParameter(declaration) || isCatchClauseVariableDeclaration(declaration));
    }
    function isFunctionExpressionOrArrowFunction(node) {
        return node.kind === 217 /* FunctionExpression */  || node.kind === 218 /* ArrowFunction */ ;
    }
    function escapeSnippetText(text) {
        return text.replace(/\$/gm, ()=>"\\$");
    }
    function isNumericLiteralName(name) {
        return (+name).toString() === name;
    }
    function createPropertyNameNodeForIdentifierOrLiteral(name, target, singleQuote, stringNamed) {
        return isIdentifierText(name, target) ? factory.createIdentifier(name) : !stringNamed && isNumericLiteralName(name) && +name >= 0 ? factory.createNumericLiteral(+name) : factory.createStringLiteral(name, !!singleQuote);
    }
    function isThisTypeParameter(type) {
        return !!(type.flags & 262144 /* TypeParameter */  && type.isThisType);
    }
    function getNodeModulePathParts(fullPath) {
        let topLevelNodeModulesIndex = 0;
        let topLevelPackageNameIndex = 0;
        let packageRootIndex = 0;
        let fileNameIndex = 0;
        let States;
        ((States2)=>{
            States2[States2["BeforeNodeModules"] = 0] = "BeforeNodeModules";
            States2[States2["NodeModules"] = 1] = "NodeModules";
            States2[States2["Scope"] = 2] = "Scope";
            States2[States2["PackageContent"] = 3] = "PackageContent";
        })(States || (States = {}));
        let partStart = 0;
        let partEnd = 0;
        let state = 0 /* BeforeNodeModules */ ;
        while(partEnd >= 0){
            partStart = partEnd;
            partEnd = fullPath.indexOf("/", partStart + 1);
            switch(state){
                case 0 /* BeforeNodeModules */ :
                    if (fullPath.indexOf(nodeModulesPathPart, partStart) === partStart) {
                        topLevelNodeModulesIndex = partStart;
                        topLevelPackageNameIndex = partEnd;
                        state = 1 /* NodeModules */ ;
                    }
                    break;
                case 1 /* NodeModules */ :
                case 2 /* Scope */ :
                    if (state === 1 /* NodeModules */  && fullPath.charAt(partStart + 1) === "@") state = 2 /* Scope */ ;
                    else {
                        packageRootIndex = partEnd;
                        state = 3 /* PackageContent */ ;
                    }
                    break;
                case 3 /* PackageContent */ :
                    if (fullPath.indexOf(nodeModulesPathPart, partStart) === partStart) state = 1 /* NodeModules */ ;
                    else state = 3 /* PackageContent */ ;
                    break;
            }
        }
        fileNameIndex = partStart;
        return state > 1 /* NodeModules */  ? {
            topLevelNodeModulesIndex: topLevelNodeModulesIndex,
            topLevelPackageNameIndex: topLevelPackageNameIndex,
            packageRootIndex: packageRootIndex,
            fileNameIndex: fileNameIndex
        } : void 0;
    }
    function getParameterTypeNode(parameter) {
        var _a;
        return parameter.kind === 347 /* JSDocParameterTag */  ? (_a = parameter.typeExpression) == null ? void 0 : _a.type : parameter.type;
    }
    function isTypeDeclaration(node) {
        switch(node.kind){
            case 167 /* TypeParameter */ :
            case 262 /* ClassDeclaration */ :
            case 263 /* InterfaceDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 352 /* JSDocTypedefTag */ :
            case 344 /* JSDocCallbackTag */ :
            case 346 /* JSDocEnumTag */ :
                return true;
            case 272 /* ImportClause */ :
                return node.isTypeOnly;
            case 275 /* ImportSpecifier */ :
            case 280 /* ExportSpecifier */ :
                return node.parent.parent.isTypeOnly;
            default:
                return false;
        }
    }
    function canHaveExportModifier(node) {
        return isEnumDeclaration(node) || isVariableStatement(node) || isFunctionDeclaration(node) || isClassDeclaration(node) || isInterfaceDeclaration(node) || isTypeDeclaration(node) || isModuleDeclaration(node) && !isExternalModuleAugmentation(node) && !isGlobalScopeAugmentation(node);
    }
    function isOptionalJSDocPropertyLikeTag(node) {
        if (!isJSDocPropertyLikeTag(node)) return false;
        const { isBracketed: isBracketed , typeExpression: typeExpression  } = node;
        return isBracketed || !!typeExpression && typeExpression.type.kind === 322 /* JSDocOptionalType */ ;
    }
    function canUsePropertyAccess(name, languageVersion) {
        if (name.length === 0) return false;
        const firstChar = name.charCodeAt(0);
        return firstChar === 35 /* hash */  ? name.length > 1 && isIdentifierStart(name.charCodeAt(1), languageVersion) : isIdentifierStart(firstChar, languageVersion);
    }
    function hasTabstop(node) {
        var _a;
        return ((_a = getSnippetElement(node)) == null ? void 0 : _a.kind) === 0 /* TabStop */ ;
    }
    function isJSDocOptionalParameter(node) {
        return isInJSFile(node) && // node.type should only be a JSDocOptionalType when node is a parameter of a JSDocFunctionType
        (node.type && node.type.kind === 322 /* JSDocOptionalType */  || getJSDocParameterTags(node).some(({ isBracketed: isBracketed , typeExpression: typeExpression  })=>isBracketed || !!typeExpression && typeExpression.type.kind === 322 /* JSDocOptionalType */ ));
    }
    function isOptionalDeclaration(declaration) {
        switch(declaration.kind){
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
                return !!declaration.questionToken;
            case 168 /* Parameter */ :
                return !!declaration.questionToken || isJSDocOptionalParameter(declaration);
            case 354 /* JSDocPropertyTag */ :
            case 347 /* JSDocParameterTag */ :
                return isOptionalJSDocPropertyLikeTag(declaration);
            default:
                return false;
        }
    }
    function isNonNullAccess(node) {
        const kind = node.kind;
        return (kind === 210 /* PropertyAccessExpression */  || kind === 211 /* ElementAccessExpression */ ) && isNonNullExpression(node.expression);
    }
    function isJSDocSatisfiesExpression(node) {
        return isInJSFile(node) && isParenthesizedExpression(node) && hasJSDocNodes(node) && !!getJSDocSatisfiesTag(node);
    }
    function getJSDocSatisfiesExpressionType(node) {
        return Debug.checkDefined(tryGetJSDocSatisfiesTypeNode(node));
    }
    function tryGetJSDocSatisfiesTypeNode(node) {
        const tag = getJSDocSatisfiesTag(node);
        return tag && tag.typeExpression && tag.typeExpression.type;
    }
    function getEscapedTextOfJsxAttributeName(node) {
        return isIdentifier(node) ? node.escapedText : getEscapedTextOfJsxNamespacedName(node);
    }
    function getTextOfJsxAttributeName(node) {
        return isIdentifier(node) ? idText(node) : getTextOfJsxNamespacedName(node);
    }
    function isJsxAttributeName(node) {
        const kind = node.kind;
        return kind === 80 /* Identifier */  || kind === 294 /* JsxNamespacedName */ ;
    }
    function getEscapedTextOfJsxNamespacedName(node) {
        return `${node.namespace.escapedText}:${idText(node.name)}`;
    }
    function getTextOfJsxNamespacedName(node) {
        return `${idText(node.namespace)}:${idText(node.name)}`;
    }
    function intrinsicTagNameToString(node) {
        return isIdentifier(node) ? idText(node) : getTextOfJsxNamespacedName(node);
    }
    var resolvingEmptyArray, externalHelpersModuleNameText, defaultMaximumTruncationLength, noTruncationMaximumTruncationLength, stringWriter, GetLiteralTextFlags, fullTripleSlashReferencePathRegEx, fullTripleSlashReferenceTypeReferenceDirectiveRegEx, fullTripleSlashLibReferenceRegEx, fullTripleSlashAMDReferencePathRegEx, fullTripleSlashAMDModuleRegEx, defaultLibReferenceRegEx, AssignmentKind, FunctionFlags, Associativity, OperatorPrecedence, templateSubstitutionRegExp, doubleQuoteEscapedCharsRegExp, singleQuoteEscapedCharsRegExp, backtickQuoteEscapedCharsRegExp, escapedCharsMap, nonAsciiCharacters, jsxDoubleQuoteEscapedCharsRegExp, jsxSingleQuoteEscapedCharsRegExp, jsxEscapedCharsMap, indentStrings, base64Digits, carriageReturnLineFeed, lineFeed, objectAllocator, objectAllocatorPatchers, localizedDiagnosticMessages, reservedCharacterPattern, wildcardCharCodes, commonPackageFolders, implicitExcludePathRegexPattern, filesMatcher, directoriesMatcher, excludeMatcher, wildcardMatchers, supportedTSExtensions, supportedTSExtensionsFlat, supportedTSExtensionsWithJson, supportedTSExtensionsForExtractExtension, supportedJSExtensions, supportedJSExtensionsFlat, allSupportedExtensions, allSupportedExtensionsWithJson, supportedDeclarationExtensions, supportedTSImplementationExtensions, extensionsNotSupportingExtensionlessResolution, ModuleSpecifierEnding, extensionsToRemove, emptyFileSystemEntries;
    var init_utilities = __esm({
        "src/compiler/utilities.ts" () {
            "use strict";
            init_ts2();
            resolvingEmptyArray = [];
            externalHelpersModuleNameText = "tslib";
            defaultMaximumTruncationLength = 160;
            noTruncationMaximumTruncationLength = 1e6;
            stringWriter = createSingleLineStringWriter();
            GetLiteralTextFlags = /* @__PURE__ */ ((GetLiteralTextFlags2)=>{
                GetLiteralTextFlags2[GetLiteralTextFlags2["None"] = 0] = "None";
                GetLiteralTextFlags2[GetLiteralTextFlags2["NeverAsciiEscape"] = 1] = "NeverAsciiEscape";
                GetLiteralTextFlags2[GetLiteralTextFlags2["JsxAttributeEscape"] = 2] = "JsxAttributeEscape";
                GetLiteralTextFlags2[GetLiteralTextFlags2["TerminateUnterminatedLiterals"] = 4] = "TerminateUnterminatedLiterals";
                GetLiteralTextFlags2[GetLiteralTextFlags2["AllowNumericSeparator"] = 8] = "AllowNumericSeparator";
                return GetLiteralTextFlags2;
            })(GetLiteralTextFlags || {});
            fullTripleSlashReferencePathRegEx = /^(\/\/\/\s*<reference\s+path\s*=\s*)(('[^']*')|("[^"]*")).*?\/>/;
            fullTripleSlashReferenceTypeReferenceDirectiveRegEx = /^(\/\/\/\s*<reference\s+types\s*=\s*)(('[^']*')|("[^"]*")).*?\/>/;
            fullTripleSlashLibReferenceRegEx = /^(\/\/\/\s*<reference\s+lib\s*=\s*)(('[^']*')|("[^"]*")).*?\/>/;
            fullTripleSlashAMDReferencePathRegEx = /^(\/\/\/\s*<amd-dependency\s+path\s*=\s*)(('[^']*')|("[^"]*")).*?\/>/;
            fullTripleSlashAMDModuleRegEx = /^\/\/\/\s*<amd-module\s+.*?\/>/;
            defaultLibReferenceRegEx = /^(\/\/\/\s*<reference\s+no-default-lib\s*=\s*)(('[^']*')|("[^"]*"))\s*\/>/;
            AssignmentKind = /* @__PURE__ */ ((AssignmentKind2)=>{
                AssignmentKind2[AssignmentKind2["None"] = 0] = "None";
                AssignmentKind2[AssignmentKind2["Definite"] = 1] = "Definite";
                AssignmentKind2[AssignmentKind2["Compound"] = 2] = "Compound";
                return AssignmentKind2;
            })(AssignmentKind || {});
            FunctionFlags = /* @__PURE__ */ ((FunctionFlags2)=>{
                FunctionFlags2[FunctionFlags2["Normal"] = 0] = "Normal";
                FunctionFlags2[FunctionFlags2["Generator"] = 1] = "Generator";
                FunctionFlags2[FunctionFlags2["Async"] = 2] = "Async";
                FunctionFlags2[FunctionFlags2["Invalid"] = 4] = "Invalid";
                FunctionFlags2[FunctionFlags2["AsyncGenerator"] = 3] = "AsyncGenerator";
                return FunctionFlags2;
            })(FunctionFlags || {});
            Associativity = /* @__PURE__ */ ((Associativity2)=>{
                Associativity2[Associativity2["Left"] = 0] = "Left";
                Associativity2[Associativity2["Right"] = 1] = "Right";
                return Associativity2;
            })(Associativity || {});
            OperatorPrecedence = /* @__PURE__ */ ((OperatorPrecedence2)=>{
                OperatorPrecedence2[OperatorPrecedence2["Comma"] = 0] = "Comma";
                OperatorPrecedence2[OperatorPrecedence2["Spread"] = 1] = "Spread";
                OperatorPrecedence2[OperatorPrecedence2["Yield"] = 2] = "Yield";
                OperatorPrecedence2[OperatorPrecedence2["Assignment"] = 3] = "Assignment";
                OperatorPrecedence2[OperatorPrecedence2["Conditional"] = 4] = "Conditional";
                OperatorPrecedence2[OperatorPrecedence2["Coalesce"] = 4 /* Conditional */ ] = "Coalesce";
                OperatorPrecedence2[OperatorPrecedence2["LogicalOR"] = 5] = "LogicalOR";
                OperatorPrecedence2[OperatorPrecedence2["LogicalAND"] = 6] = "LogicalAND";
                OperatorPrecedence2[OperatorPrecedence2["BitwiseOR"] = 7] = "BitwiseOR";
                OperatorPrecedence2[OperatorPrecedence2["BitwiseXOR"] = 8] = "BitwiseXOR";
                OperatorPrecedence2[OperatorPrecedence2["BitwiseAND"] = 9] = "BitwiseAND";
                OperatorPrecedence2[OperatorPrecedence2["Equality"] = 10] = "Equality";
                OperatorPrecedence2[OperatorPrecedence2["Relational"] = 11] = "Relational";
                OperatorPrecedence2[OperatorPrecedence2["Shift"] = 12] = "Shift";
                OperatorPrecedence2[OperatorPrecedence2["Additive"] = 13] = "Additive";
                OperatorPrecedence2[OperatorPrecedence2["Multiplicative"] = 14] = "Multiplicative";
                OperatorPrecedence2[OperatorPrecedence2["Exponentiation"] = 15] = "Exponentiation";
                OperatorPrecedence2[OperatorPrecedence2["Unary"] = 16] = "Unary";
                OperatorPrecedence2[OperatorPrecedence2["Update"] = 17] = "Update";
                OperatorPrecedence2[OperatorPrecedence2["LeftHandSide"] = 18] = "LeftHandSide";
                OperatorPrecedence2[OperatorPrecedence2["Member"] = 19] = "Member";
                OperatorPrecedence2[OperatorPrecedence2["Primary"] = 20] = "Primary";
                OperatorPrecedence2[OperatorPrecedence2["Highest"] = 20 /* Primary */ ] = "Highest";
                OperatorPrecedence2[OperatorPrecedence2["Lowest"] = 0 /* Comma */ ] = "Lowest";
                OperatorPrecedence2[OperatorPrecedence2["Invalid"] = -1] = "Invalid";
                return OperatorPrecedence2;
            })(OperatorPrecedence || {});
            templateSubstitutionRegExp = /\$\{/g;
            doubleQuoteEscapedCharsRegExp = /[\\\"\u0000-\u001f\t\v\f\b\r\n\u2028\u2029\u0085]/g;
            singleQuoteEscapedCharsRegExp = /[\\\'\u0000-\u001f\t\v\f\b\r\n\u2028\u2029\u0085]/g;
            backtickQuoteEscapedCharsRegExp = /\r\n|[\\\`\u0000-\u001f\t\v\f\b\r\u2028\u2029\u0085]/g;
            escapedCharsMap = new Map(Object.entries({
                "	": "\\t",
                "\v": "\\v",
                "\f": "\\f",
                "\b": "\\b",
                "\r": "\\r",
                "\n": "\\n",
                "\\": "\\\\",
                '"': '\\"',
                "'": "\\'",
                "`": "\\`",
                "\u2028": "\\u2028",
                // lineSeparator
                "\u2029": "\\u2029",
                // paragraphSeparator
                "\x85": "\\u0085",
                // nextLine
                "\r\n": "\\r\\n"
            }));
            nonAsciiCharacters = /[^\u0000-\u007F]/g;
            jsxDoubleQuoteEscapedCharsRegExp = /[\"\u0000-\u001f\u2028\u2029\u0085]/g;
            jsxSingleQuoteEscapedCharsRegExp = /[\'\u0000-\u001f\u2028\u2029\u0085]/g;
            jsxEscapedCharsMap = new Map(Object.entries({
                '"': "&quot;",
                "'": "&apos;"
            }));
            indentStrings = [
                "",
                "    "
            ];
            base64Digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            carriageReturnLineFeed = "\r\n";
            lineFeed = "\n";
            objectAllocator = {
                getNodeConstructor: ()=>Node4,
                getTokenConstructor: ()=>Token,
                getIdentifierConstructor: ()=>Identifier2,
                getPrivateIdentifierConstructor: ()=>Node4,
                getSourceFileConstructor: ()=>Node4,
                getSymbolConstructor: ()=>Symbol4,
                getTypeConstructor: ()=>Type3,
                getSignatureConstructor: ()=>Signature2,
                getSourceMapSourceConstructor: ()=>SourceMapSource
            };
            objectAllocatorPatchers = [];
            reservedCharacterPattern = /[^\w\s\/]/g;
            wildcardCharCodes = [
                42 /* asterisk */ ,
                63 /* question */ 
            ];
            commonPackageFolders = [
                "node_modules",
                "bower_components",
                "jspm_packages"
            ];
            implicitExcludePathRegexPattern = `(?!(${commonPackageFolders.join("|")})(/|$))`;
            filesMatcher = {
                /**
         * Matches any single directory segment unless it is the last segment and a .min.js file
         * Breakdown:
         *  [^./]                   # matches everything up to the first . character (excluding directory separators)
         *  (\\.(?!min\\.js$))?     # matches . characters but not if they are part of the .min.js file extension
         */ singleAsteriskRegexFragment: "([^./]|(\\.(?!min\\.js$))?)*",
                /**
         * Regex for the ** wildcard. Matches any number of subdirectories. When used for including
         * files or directories, does not match subdirectories that start with a . character
         */ doubleAsteriskRegexFragment: `(/${implicitExcludePathRegexPattern}[^/.][^/]*)*?`,
                replaceWildcardCharacter: (match)=>replaceWildcardCharacter(match, filesMatcher.singleAsteriskRegexFragment)
            };
            directoriesMatcher = {
                singleAsteriskRegexFragment: "[^/]*",
                /**
         * Regex for the ** wildcard. Matches any number of subdirectories. When used for including
         * files or directories, does not match subdirectories that start with a . character
         */ doubleAsteriskRegexFragment: `(/${implicitExcludePathRegexPattern}[^/.][^/]*)*?`,
                replaceWildcardCharacter: (match)=>replaceWildcardCharacter(match, directoriesMatcher.singleAsteriskRegexFragment)
            };
            excludeMatcher = {
                singleAsteriskRegexFragment: "[^/]*",
                doubleAsteriskRegexFragment: "(/.+?)?",
                replaceWildcardCharacter: (match)=>replaceWildcardCharacter(match, excludeMatcher.singleAsteriskRegexFragment)
            };
            wildcardMatchers = {
                files: filesMatcher,
                directories: directoriesMatcher,
                exclude: excludeMatcher
            };
            supportedTSExtensions = [
                [
                    ".ts" /* Ts */ ,
                    ".tsx" /* Tsx */ ,
                    ".d.ts" /* Dts */ 
                ],
                [
                    ".cts" /* Cts */ ,
                    ".d.cts" /* Dcts */ 
                ],
                [
                    ".mts" /* Mts */ ,
                    ".d.mts" /* Dmts */ 
                ]
            ];
            supportedTSExtensionsFlat = flatten(supportedTSExtensions);
            supportedTSExtensionsWithJson = [
                ...supportedTSExtensions,
                [
                    ".json" /* Json */ 
                ]
            ];
            supportedTSExtensionsForExtractExtension = [
                ".d.ts" /* Dts */ ,
                ".d.cts" /* Dcts */ ,
                ".d.mts" /* Dmts */ ,
                ".cts" /* Cts */ ,
                ".mts" /* Mts */ ,
                ".ts" /* Ts */ ,
                ".tsx" /* Tsx */ 
            ];
            supportedJSExtensions = [
                [
                    ".js" /* Js */ ,
                    ".jsx" /* Jsx */ 
                ],
                [
                    ".mjs" /* Mjs */ 
                ],
                [
                    ".cjs" /* Cjs */ 
                ]
            ];
            supportedJSExtensionsFlat = flatten(supportedJSExtensions);
            allSupportedExtensions = [
                [
                    ".ts" /* Ts */ ,
                    ".tsx" /* Tsx */ ,
                    ".d.ts" /* Dts */ ,
                    ".js" /* Js */ ,
                    ".jsx" /* Jsx */ 
                ],
                [
                    ".cts" /* Cts */ ,
                    ".d.cts" /* Dcts */ ,
                    ".cjs" /* Cjs */ 
                ],
                [
                    ".mts" /* Mts */ ,
                    ".d.mts" /* Dmts */ ,
                    ".mjs" /* Mjs */ 
                ]
            ];
            allSupportedExtensionsWithJson = [
                ...allSupportedExtensions,
                [
                    ".json" /* Json */ 
                ]
            ];
            supportedDeclarationExtensions = [
                ".d.ts" /* Dts */ ,
                ".d.cts" /* Dcts */ ,
                ".d.mts" /* Dmts */ 
            ];
            supportedTSImplementationExtensions = [
                ".ts" /* Ts */ ,
                ".cts" /* Cts */ ,
                ".mts" /* Mts */ ,
                ".tsx" /* Tsx */ 
            ];
            extensionsNotSupportingExtensionlessResolution = [
                ".mts" /* Mts */ ,
                ".d.mts" /* Dmts */ ,
                ".mjs" /* Mjs */ ,
                ".cts" /* Cts */ ,
                ".d.cts" /* Dcts */ ,
                ".cjs" /* Cjs */ 
            ];
            ModuleSpecifierEnding = /* @__PURE__ */ ((ModuleSpecifierEnding2)=>{
                ModuleSpecifierEnding2[ModuleSpecifierEnding2["Minimal"] = 0] = "Minimal";
                ModuleSpecifierEnding2[ModuleSpecifierEnding2["Index"] = 1] = "Index";
                ModuleSpecifierEnding2[ModuleSpecifierEnding2["JsExtension"] = 2] = "JsExtension";
                ModuleSpecifierEnding2[ModuleSpecifierEnding2["TsExtension"] = 3] = "TsExtension";
                return ModuleSpecifierEnding2;
            })(ModuleSpecifierEnding || {});
            extensionsToRemove = [
                ".d.ts" /* Dts */ ,
                ".d.mts" /* Dmts */ ,
                ".d.cts" /* Dcts */ ,
                ".mjs" /* Mjs */ ,
                ".mts" /* Mts */ ,
                ".cjs" /* Cjs */ ,
                ".cts" /* Cts */ ,
                ".ts" /* Ts */ ,
                ".js" /* Js */ ,
                ".tsx" /* Tsx */ ,
                ".jsx" /* Jsx */ ,
                ".json" /* Json */ 
            ];
            emptyFileSystemEntries = {
                files: emptyArray,
                directories: emptyArray
            };
        }
    });
    // src/compiler/factory/baseNodeFactory.ts
    function createBaseNodeFactory() {
        let NodeConstructor2;
        let TokenConstructor2;
        let IdentifierConstructor2;
        let PrivateIdentifierConstructor2;
        let SourceFileConstructor2;
        return {
            createBaseSourceFileNode: createBaseSourceFileNode,
            createBaseIdentifierNode: createBaseIdentifierNode,
            createBasePrivateIdentifierNode: createBasePrivateIdentifierNode,
            createBaseTokenNode: createBaseTokenNode,
            createBaseNode: createBaseNode
        };
        function createBaseSourceFileNode(kind) {
            return new (SourceFileConstructor2 || (SourceFileConstructor2 = objectAllocator.getSourceFileConstructor()))(kind, /*pos*/ -1, /*end*/ -1);
        }
        function createBaseIdentifierNode(kind) {
            return new (IdentifierConstructor2 || (IdentifierConstructor2 = objectAllocator.getIdentifierConstructor()))(kind, /*pos*/ -1, /*end*/ -1);
        }
        function createBasePrivateIdentifierNode(kind) {
            return new (PrivateIdentifierConstructor2 || (PrivateIdentifierConstructor2 = objectAllocator.getPrivateIdentifierConstructor()))(kind, /*pos*/ -1, /*end*/ -1);
        }
        function createBaseTokenNode(kind) {
            return new (TokenConstructor2 || (TokenConstructor2 = objectAllocator.getTokenConstructor()))(kind, /*pos*/ -1, /*end*/ -1);
        }
        function createBaseNode(kind) {
            return new (NodeConstructor2 || (NodeConstructor2 = objectAllocator.getNodeConstructor()))(kind, /*pos*/ -1, /*end*/ -1);
        }
    }
    var init_baseNodeFactory = __esm({
        "src/compiler/factory/baseNodeFactory.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/factory/parenthesizerRules.ts
    function createParenthesizerRules(factory2) {
        let binaryLeftOperandParenthesizerCache;
        let binaryRightOperandParenthesizerCache;
        return {
            getParenthesizeLeftSideOfBinaryForOperator: getParenthesizeLeftSideOfBinaryForOperator,
            getParenthesizeRightSideOfBinaryForOperator: getParenthesizeRightSideOfBinaryForOperator,
            parenthesizeLeftSideOfBinary: parenthesizeLeftSideOfBinary,
            parenthesizeRightSideOfBinary: parenthesizeRightSideOfBinary,
            parenthesizeExpressionOfComputedPropertyName: parenthesizeExpressionOfComputedPropertyName,
            parenthesizeConditionOfConditionalExpression: parenthesizeConditionOfConditionalExpression,
            parenthesizeBranchOfConditionalExpression: parenthesizeBranchOfConditionalExpression,
            parenthesizeExpressionOfExportDefault: parenthesizeExpressionOfExportDefault,
            parenthesizeExpressionOfNew: parenthesizeExpressionOfNew,
            parenthesizeLeftSideOfAccess: parenthesizeLeftSideOfAccess,
            parenthesizeOperandOfPostfixUnary: parenthesizeOperandOfPostfixUnary,
            parenthesizeOperandOfPrefixUnary: parenthesizeOperandOfPrefixUnary,
            parenthesizeExpressionsOfCommaDelimitedList: parenthesizeExpressionsOfCommaDelimitedList,
            parenthesizeExpressionForDisallowedComma: parenthesizeExpressionForDisallowedComma,
            parenthesizeExpressionOfExpressionStatement: parenthesizeExpressionOfExpressionStatement,
            parenthesizeConciseBodyOfArrowFunction: parenthesizeConciseBodyOfArrowFunction,
            parenthesizeCheckTypeOfConditionalType: parenthesizeCheckTypeOfConditionalType,
            parenthesizeExtendsTypeOfConditionalType: parenthesizeExtendsTypeOfConditionalType,
            parenthesizeConstituentTypesOfUnionType: parenthesizeConstituentTypesOfUnionType,
            parenthesizeConstituentTypeOfUnionType: parenthesizeConstituentTypeOfUnionType,
            parenthesizeConstituentTypesOfIntersectionType: parenthesizeConstituentTypesOfIntersectionType,
            parenthesizeConstituentTypeOfIntersectionType: parenthesizeConstituentTypeOfIntersectionType,
            parenthesizeOperandOfTypeOperator: parenthesizeOperandOfTypeOperator,
            parenthesizeOperandOfReadonlyTypeOperator: parenthesizeOperandOfReadonlyTypeOperator,
            parenthesizeNonArrayTypeOfPostfixType: parenthesizeNonArrayTypeOfPostfixType,
            parenthesizeElementTypesOfTupleType: parenthesizeElementTypesOfTupleType,
            parenthesizeElementTypeOfTupleType: parenthesizeElementTypeOfTupleType,
            parenthesizeTypeOfOptionalType: parenthesizeTypeOfOptionalType,
            parenthesizeTypeArguments: parenthesizeTypeArguments,
            parenthesizeLeadingTypeArgument: parenthesizeLeadingTypeArgument
        };
        function getParenthesizeLeftSideOfBinaryForOperator(operatorKind) {
            binaryLeftOperandParenthesizerCache || (binaryLeftOperandParenthesizerCache = /* @__PURE__ */ new Map());
            let parenthesizerRule = binaryLeftOperandParenthesizerCache.get(operatorKind);
            if (!parenthesizerRule) {
                parenthesizerRule = (node)=>parenthesizeLeftSideOfBinary(operatorKind, node);
                binaryLeftOperandParenthesizerCache.set(operatorKind, parenthesizerRule);
            }
            return parenthesizerRule;
        }
        function getParenthesizeRightSideOfBinaryForOperator(operatorKind) {
            binaryRightOperandParenthesizerCache || (binaryRightOperandParenthesizerCache = /* @__PURE__ */ new Map());
            let parenthesizerRule = binaryRightOperandParenthesizerCache.get(operatorKind);
            if (!parenthesizerRule) {
                parenthesizerRule = (node)=>parenthesizeRightSideOfBinary(operatorKind, /*leftSide*/ void 0, node);
                binaryRightOperandParenthesizerCache.set(operatorKind, parenthesizerRule);
            }
            return parenthesizerRule;
        }
        function binaryOperandNeedsParentheses(binaryOperator, operand, isLeftSideOfBinary, leftOperand) {
            const binaryOperatorPrecedence = getOperatorPrecedence(225 /* BinaryExpression */ , binaryOperator);
            const binaryOperatorAssociativity = getOperatorAssociativity(225 /* BinaryExpression */ , binaryOperator);
            const emittedOperand = skipPartiallyEmittedExpressions(operand);
            if (!isLeftSideOfBinary && operand.kind === 218 /* ArrowFunction */  && binaryOperatorPrecedence > 3 /* Assignment */ ) return true;
            const operandPrecedence = getExpressionPrecedence(emittedOperand);
            switch(compareValues(operandPrecedence, binaryOperatorPrecedence)){
                case -1 /* LessThan */ :
                    if (!isLeftSideOfBinary && binaryOperatorAssociativity === 1 /* Right */  && operand.kind === 228 /* YieldExpression */ ) return false;
                    return true;
                case 1 /* GreaterThan */ :
                    return false;
                case 0 /* EqualTo */ :
                    if (isLeftSideOfBinary) return binaryOperatorAssociativity === 1 /* Right */ ;
                    else {
                        if (isBinaryExpression(emittedOperand) && emittedOperand.operatorToken.kind === binaryOperator) {
                            if (operatorHasAssociativeProperty(binaryOperator)) return false;
                            if (binaryOperator === 40 /* PlusToken */ ) {
                                const leftKind = leftOperand ? getLiteralKindOfBinaryPlusOperand(leftOperand) : 0 /* Unknown */ ;
                                if (isLiteralKind(leftKind) && leftKind === getLiteralKindOfBinaryPlusOperand(emittedOperand)) return false;
                            }
                        }
                        const operandAssociativity = getExpressionAssociativity(emittedOperand);
                        return operandAssociativity === 0 /* Left */ ;
                    }
            }
        }
        function operatorHasAssociativeProperty(binaryOperator) {
            return binaryOperator === 42 /* AsteriskToken */  || binaryOperator === 52 /* BarToken */  || binaryOperator === 51 /* AmpersandToken */  || binaryOperator === 53 /* CaretToken */  || binaryOperator === 28 /* CommaToken */ ;
        }
        function getLiteralKindOfBinaryPlusOperand(node) {
            node = skipPartiallyEmittedExpressions(node);
            if (isLiteralKind(node.kind)) return node.kind;
            if (node.kind === 225 /* BinaryExpression */  && node.operatorToken.kind === 40 /* PlusToken */ ) {
                if (node.cachedLiteralKind !== void 0) return node.cachedLiteralKind;
                const leftKind = getLiteralKindOfBinaryPlusOperand(node.left);
                const literalKind = isLiteralKind(leftKind) && leftKind === getLiteralKindOfBinaryPlusOperand(node.right) ? leftKind : 0 /* Unknown */ ;
                node.cachedLiteralKind = literalKind;
                return literalKind;
            }
            return 0 /* Unknown */ ;
        }
        function parenthesizeBinaryOperand(binaryOperator, operand, isLeftSideOfBinary, leftOperand) {
            const skipped = skipPartiallyEmittedExpressions(operand);
            if (skipped.kind === 216 /* ParenthesizedExpression */ ) return operand;
            return binaryOperandNeedsParentheses(binaryOperator, operand, isLeftSideOfBinary, leftOperand) ? factory2.createParenthesizedExpression(operand) : operand;
        }
        function parenthesizeLeftSideOfBinary(binaryOperator, leftSide) {
            return parenthesizeBinaryOperand(binaryOperator, leftSide, /*isLeftSideOfBinary*/ true);
        }
        function parenthesizeRightSideOfBinary(binaryOperator, leftSide, rightSide) {
            return parenthesizeBinaryOperand(binaryOperator, rightSide, /*isLeftSideOfBinary*/ false, leftSide);
        }
        function parenthesizeExpressionOfComputedPropertyName(expression) {
            return isCommaSequence(expression) ? factory2.createParenthesizedExpression(expression) : expression;
        }
        function parenthesizeConditionOfConditionalExpression(condition) {
            const conditionalPrecedence = getOperatorPrecedence(226 /* ConditionalExpression */ , 58 /* QuestionToken */ );
            const emittedCondition = skipPartiallyEmittedExpressions(condition);
            const conditionPrecedence = getExpressionPrecedence(emittedCondition);
            if (compareValues(conditionPrecedence, conditionalPrecedence) !== 1 /* GreaterThan */ ) return factory2.createParenthesizedExpression(condition);
            return condition;
        }
        function parenthesizeBranchOfConditionalExpression(branch) {
            const emittedExpression = skipPartiallyEmittedExpressions(branch);
            return isCommaSequence(emittedExpression) ? factory2.createParenthesizedExpression(branch) : branch;
        }
        function parenthesizeExpressionOfExportDefault(expression) {
            const check = skipPartiallyEmittedExpressions(expression);
            let needsParens = isCommaSequence(check);
            if (!needsParens) switch(getLeftmostExpression(check, /*stopAtCallExpressions*/ false).kind){
                case 230 /* ClassExpression */ :
                case 217 /* FunctionExpression */ :
                    needsParens = true;
            }
            return needsParens ? factory2.createParenthesizedExpression(expression) : expression;
        }
        function parenthesizeExpressionOfNew(expression) {
            const leftmostExpr = getLeftmostExpression(expression, /*stopAtCallExpressions*/ true);
            switch(leftmostExpr.kind){
                case 212 /* CallExpression */ :
                    return factory2.createParenthesizedExpression(expression);
                case 213 /* NewExpression */ :
                    return !leftmostExpr.arguments ? factory2.createParenthesizedExpression(expression) : expression;
            }
            return parenthesizeLeftSideOfAccess(expression);
        }
        function parenthesizeLeftSideOfAccess(expression, optionalChain) {
            const emittedExpression = skipPartiallyEmittedExpressions(expression);
            if (isLeftHandSideExpression(emittedExpression) && (emittedExpression.kind !== 213 /* NewExpression */  || emittedExpression.arguments) && (optionalChain || !isOptionalChain(emittedExpression))) return expression;
            return setTextRange(factory2.createParenthesizedExpression(expression), expression);
        }
        function parenthesizeOperandOfPostfixUnary(operand) {
            return isLeftHandSideExpression(operand) ? operand : setTextRange(factory2.createParenthesizedExpression(operand), operand);
        }
        function parenthesizeOperandOfPrefixUnary(operand) {
            return isUnaryExpression(operand) ? operand : setTextRange(factory2.createParenthesizedExpression(operand), operand);
        }
        function parenthesizeExpressionsOfCommaDelimitedList(elements) {
            const result = sameMap(elements, parenthesizeExpressionForDisallowedComma);
            return setTextRange(factory2.createNodeArray(result, elements.hasTrailingComma), elements);
        }
        function parenthesizeExpressionForDisallowedComma(expression) {
            const emittedExpression = skipPartiallyEmittedExpressions(expression);
            const expressionPrecedence = getExpressionPrecedence(emittedExpression);
            const commaPrecedence = getOperatorPrecedence(225 /* BinaryExpression */ , 28 /* CommaToken */ );
            return expressionPrecedence > commaPrecedence ? expression : setTextRange(factory2.createParenthesizedExpression(expression), expression);
        }
        function parenthesizeExpressionOfExpressionStatement(expression) {
            const emittedExpression = skipPartiallyEmittedExpressions(expression);
            if (isCallExpression(emittedExpression)) {
                const callee = emittedExpression.expression;
                const kind = skipPartiallyEmittedExpressions(callee).kind;
                if (kind === 217 /* FunctionExpression */  || kind === 218 /* ArrowFunction */ ) {
                    const updated = factory2.updateCallExpression(emittedExpression, setTextRange(factory2.createParenthesizedExpression(callee), callee), emittedExpression.typeArguments, emittedExpression.arguments);
                    return factory2.restoreOuterExpressions(expression, updated, 8 /* PartiallyEmittedExpressions */ );
                }
            }
            const leftmostExpressionKind = getLeftmostExpression(emittedExpression, /*stopAtCallExpressions*/ false).kind;
            if (leftmostExpressionKind === 209 /* ObjectLiteralExpression */  || leftmostExpressionKind === 217 /* FunctionExpression */ ) return setTextRange(factory2.createParenthesizedExpression(expression), expression);
            return expression;
        }
        function parenthesizeConciseBodyOfArrowFunction(body) {
            if (!isBlock(body) && (isCommaSequence(body) || getLeftmostExpression(body, /*stopAtCallExpressions*/ false).kind === 209 /* ObjectLiteralExpression */ )) return setTextRange(factory2.createParenthesizedExpression(body), body);
            return body;
        }
        function parenthesizeCheckTypeOfConditionalType(checkType) {
            switch(checkType.kind){
                case 183 /* FunctionType */ :
                case 184 /* ConstructorType */ :
                case 193 /* ConditionalType */ :
                    return factory2.createParenthesizedType(checkType);
            }
            return checkType;
        }
        function parenthesizeExtendsTypeOfConditionalType(extendsType) {
            switch(extendsType.kind){
                case 193 /* ConditionalType */ :
                    return factory2.createParenthesizedType(extendsType);
            }
            return extendsType;
        }
        function parenthesizeConstituentTypeOfUnionType(type) {
            switch(type.kind){
                case 191 /* UnionType */ :
                case 192 /* IntersectionType */ :
                    return factory2.createParenthesizedType(type);
            }
            return parenthesizeCheckTypeOfConditionalType(type);
        }
        function parenthesizeConstituentTypesOfUnionType(members) {
            return factory2.createNodeArray(sameMap(members, parenthesizeConstituentTypeOfUnionType));
        }
        function parenthesizeConstituentTypeOfIntersectionType(type) {
            switch(type.kind){
                case 191 /* UnionType */ :
                case 192 /* IntersectionType */ :
                    return factory2.createParenthesizedType(type);
            }
            return parenthesizeConstituentTypeOfUnionType(type);
        }
        function parenthesizeConstituentTypesOfIntersectionType(members) {
            return factory2.createNodeArray(sameMap(members, parenthesizeConstituentTypeOfIntersectionType));
        }
        function parenthesizeOperandOfTypeOperator(type) {
            switch(type.kind){
                case 192 /* IntersectionType */ :
                    return factory2.createParenthesizedType(type);
            }
            return parenthesizeConstituentTypeOfIntersectionType(type);
        }
        function parenthesizeOperandOfReadonlyTypeOperator(type) {
            switch(type.kind){
                case 197 /* TypeOperator */ :
                    return factory2.createParenthesizedType(type);
            }
            return parenthesizeOperandOfTypeOperator(type);
        }
        function parenthesizeNonArrayTypeOfPostfixType(type) {
            switch(type.kind){
                case 194 /* InferType */ :
                case 197 /* TypeOperator */ :
                case 185 /* TypeQuery */ :
                    return factory2.createParenthesizedType(type);
            }
            return parenthesizeOperandOfTypeOperator(type);
        }
        function parenthesizeElementTypesOfTupleType(types) {
            return factory2.createNodeArray(sameMap(types, parenthesizeElementTypeOfTupleType));
        }
        function parenthesizeElementTypeOfTupleType(type) {
            if (hasJSDocPostfixQuestion(type)) return factory2.createParenthesizedType(type);
            return type;
        }
        function hasJSDocPostfixQuestion(type) {
            if (isJSDocNullableType(type)) return type.postfix;
            if (isNamedTupleMember(type)) return hasJSDocPostfixQuestion(type.type);
            if (isFunctionTypeNode(type) || isConstructorTypeNode(type) || isTypeOperatorNode(type)) return hasJSDocPostfixQuestion(type.type);
            if (isConditionalTypeNode(type)) return hasJSDocPostfixQuestion(type.falseType);
            if (isUnionTypeNode(type)) return hasJSDocPostfixQuestion(last(type.types));
            if (isIntersectionTypeNode(type)) return hasJSDocPostfixQuestion(last(type.types));
            if (isInferTypeNode(type)) return !!type.typeParameter.constraint && hasJSDocPostfixQuestion(type.typeParameter.constraint);
            return false;
        }
        function parenthesizeTypeOfOptionalType(type) {
            if (hasJSDocPostfixQuestion(type)) return factory2.createParenthesizedType(type);
            return parenthesizeNonArrayTypeOfPostfixType(type);
        }
        function parenthesizeLeadingTypeArgument(node) {
            return isFunctionOrConstructorTypeNode(node) && node.typeParameters ? factory2.createParenthesizedType(node) : node;
        }
        function parenthesizeOrdinalTypeArgument(node, i) {
            return i === 0 ? parenthesizeLeadingTypeArgument(node) : node;
        }
        function parenthesizeTypeArguments(typeArguments) {
            if (some(typeArguments)) return factory2.createNodeArray(sameMap(typeArguments, parenthesizeOrdinalTypeArgument));
        }
    }
    var nullParenthesizerRules;
    var init_parenthesizerRules = __esm({
        "src/compiler/factory/parenthesizerRules.ts" () {
            "use strict";
            init_ts2();
            nullParenthesizerRules = {
                getParenthesizeLeftSideOfBinaryForOperator: (_)=>identity,
                getParenthesizeRightSideOfBinaryForOperator: (_)=>identity,
                parenthesizeLeftSideOfBinary: (_binaryOperator, leftSide)=>leftSide,
                parenthesizeRightSideOfBinary: (_binaryOperator, _leftSide, rightSide)=>rightSide,
                parenthesizeExpressionOfComputedPropertyName: identity,
                parenthesizeConditionOfConditionalExpression: identity,
                parenthesizeBranchOfConditionalExpression: identity,
                parenthesizeExpressionOfExportDefault: identity,
                parenthesizeExpressionOfNew: (expression)=>cast(expression, isLeftHandSideExpression),
                parenthesizeLeftSideOfAccess: (expression)=>cast(expression, isLeftHandSideExpression),
                parenthesizeOperandOfPostfixUnary: (operand)=>cast(operand, isLeftHandSideExpression),
                parenthesizeOperandOfPrefixUnary: (operand)=>cast(operand, isUnaryExpression),
                parenthesizeExpressionsOfCommaDelimitedList: (nodes)=>cast(nodes, isNodeArray),
                parenthesizeExpressionForDisallowedComma: identity,
                parenthesizeExpressionOfExpressionStatement: identity,
                parenthesizeConciseBodyOfArrowFunction: identity,
                parenthesizeCheckTypeOfConditionalType: identity,
                parenthesizeExtendsTypeOfConditionalType: identity,
                parenthesizeConstituentTypesOfUnionType: (nodes)=>cast(nodes, isNodeArray),
                parenthesizeConstituentTypeOfUnionType: identity,
                parenthesizeConstituentTypesOfIntersectionType: (nodes)=>cast(nodes, isNodeArray),
                parenthesizeConstituentTypeOfIntersectionType: identity,
                parenthesizeOperandOfTypeOperator: identity,
                parenthesizeOperandOfReadonlyTypeOperator: identity,
                parenthesizeNonArrayTypeOfPostfixType: identity,
                parenthesizeElementTypesOfTupleType: (nodes)=>cast(nodes, isNodeArray),
                parenthesizeElementTypeOfTupleType: identity,
                parenthesizeTypeOfOptionalType: identity,
                parenthesizeTypeArguments: (nodes)=>nodes && cast(nodes, isNodeArray),
                parenthesizeLeadingTypeArgument: identity
            };
        }
    });
    // src/compiler/factory/nodeConverters.ts
    function createNodeConverters(factory2) {
        return {
            convertToFunctionBlock: convertToFunctionBlock,
            convertToFunctionExpression: convertToFunctionExpression,
            convertToArrayAssignmentElement: convertToArrayAssignmentElement,
            convertToObjectAssignmentElement: convertToObjectAssignmentElement,
            convertToAssignmentPattern: convertToAssignmentPattern,
            convertToObjectAssignmentPattern: convertToObjectAssignmentPattern,
            convertToArrayAssignmentPattern: convertToArrayAssignmentPattern,
            convertToAssignmentElementTarget: convertToAssignmentElementTarget
        };
        function convertToFunctionBlock(node, multiLine) {
            if (isBlock(node)) return node;
            const returnStatement = factory2.createReturnStatement(node);
            setTextRange(returnStatement, node);
            const body = factory2.createBlock([
                returnStatement
            ], multiLine);
            setTextRange(body, node);
            return body;
        }
        function convertToFunctionExpression(node) {
            if (!node.body) return Debug.fail(`Cannot convert a FunctionDeclaration without a body`);
            const updated = factory2.createFunctionExpression(getModifiers(node), node.asteriskToken, node.name, node.typeParameters, node.parameters, node.type, node.body);
            setOriginalNode(updated, node);
            setTextRange(updated, node);
            if (getStartsOnNewLine(node)) setStartsOnNewLine(updated, /*newLine*/ true);
            return updated;
        }
        function convertToArrayAssignmentElement(element) {
            if (isBindingElement(element)) {
                if (element.dotDotDotToken) {
                    Debug.assertNode(element.name, isIdentifier);
                    return setOriginalNode(setTextRange(factory2.createSpreadElement(element.name), element), element);
                }
                const expression = convertToAssignmentElementTarget(element.name);
                return element.initializer ? setOriginalNode(setTextRange(factory2.createAssignment(expression, element.initializer), element), element) : expression;
            }
            return cast(element, isExpression);
        }
        function convertToObjectAssignmentElement(element) {
            if (isBindingElement(element)) {
                if (element.dotDotDotToken) {
                    Debug.assertNode(element.name, isIdentifier);
                    return setOriginalNode(setTextRange(factory2.createSpreadAssignment(element.name), element), element);
                }
                if (element.propertyName) {
                    const expression = convertToAssignmentElementTarget(element.name);
                    return setOriginalNode(setTextRange(factory2.createPropertyAssignment(element.propertyName, element.initializer ? factory2.createAssignment(expression, element.initializer) : expression), element), element);
                }
                Debug.assertNode(element.name, isIdentifier);
                return setOriginalNode(setTextRange(factory2.createShorthandPropertyAssignment(element.name, element.initializer), element), element);
            }
            return cast(element, isObjectLiteralElementLike);
        }
        function convertToAssignmentPattern(node) {
            switch(node.kind){
                case 206 /* ArrayBindingPattern */ :
                case 208 /* ArrayLiteralExpression */ :
                    return convertToArrayAssignmentPattern(node);
                case 205 /* ObjectBindingPattern */ :
                case 209 /* ObjectLiteralExpression */ :
                    return convertToObjectAssignmentPattern(node);
            }
        }
        function convertToObjectAssignmentPattern(node) {
            if (isObjectBindingPattern(node)) return setOriginalNode(setTextRange(factory2.createObjectLiteralExpression(map(node.elements, convertToObjectAssignmentElement)), node), node);
            return cast(node, isObjectLiteralExpression);
        }
        function convertToArrayAssignmentPattern(node) {
            if (isArrayBindingPattern(node)) return setOriginalNode(setTextRange(factory2.createArrayLiteralExpression(map(node.elements, convertToArrayAssignmentElement)), node), node);
            return cast(node, isArrayLiteralExpression);
        }
        function convertToAssignmentElementTarget(node) {
            if (isBindingPattern(node)) return convertToAssignmentPattern(node);
            return cast(node, isExpression);
        }
    }
    var nullNodeConverters;
    var init_nodeConverters = __esm({
        "src/compiler/factory/nodeConverters.ts" () {
            "use strict";
            init_ts2();
            nullNodeConverters = {
                convertToFunctionBlock: notImplemented,
                convertToFunctionExpression: notImplemented,
                convertToArrayAssignmentElement: notImplemented,
                convertToObjectAssignmentElement: notImplemented,
                convertToAssignmentPattern: notImplemented,
                convertToObjectAssignmentPattern: notImplemented,
                convertToArrayAssignmentPattern: notImplemented,
                convertToAssignmentElementTarget: notImplemented
            };
        }
    });
    // src/compiler/factory/nodeFactory.ts
    function addNodeFactoryPatcher(fn) {
        nodeFactoryPatchers.push(fn);
    }
    function createNodeFactory(flags, baseFactory2) {
        const update = flags & 8 /* NoOriginalNode */  ? updateWithoutOriginal : updateWithOriginal;
        const parenthesizerRules = memoize(()=>flags & 1 /* NoParenthesizerRules */  ? nullParenthesizerRules : createParenthesizerRules(factory2));
        const converters = memoize(()=>flags & 2 /* NoNodeConverters */  ? nullNodeConverters : createNodeConverters(factory2));
        const getBinaryCreateFunction = memoizeOne((operator)=>(left, right)=>createBinaryExpression(left, operator, right));
        const getPrefixUnaryCreateFunction = memoizeOne((operator)=>(operand)=>createPrefixUnaryExpression(operator, operand));
        const getPostfixUnaryCreateFunction = memoizeOne((operator)=>(operand)=>createPostfixUnaryExpression(operand, operator));
        const getJSDocPrimaryTypeCreateFunction = memoizeOne((kind)=>()=>createJSDocPrimaryTypeWorker(kind));
        const getJSDocUnaryTypeCreateFunction = memoizeOne((kind)=>(type)=>createJSDocUnaryTypeWorker(kind, type));
        const getJSDocUnaryTypeUpdateFunction = memoizeOne((kind)=>(node, type)=>updateJSDocUnaryTypeWorker(kind, node, type));
        const getJSDocPrePostfixUnaryTypeCreateFunction = memoizeOne((kind)=>(type, postfix)=>createJSDocPrePostfixUnaryTypeWorker(kind, type, postfix));
        const getJSDocPrePostfixUnaryTypeUpdateFunction = memoizeOne((kind)=>(node, type)=>updateJSDocPrePostfixUnaryTypeWorker(kind, node, type));
        const getJSDocSimpleTagCreateFunction = memoizeOne((kind)=>(tagName, comment)=>createJSDocSimpleTagWorker(kind, tagName, comment));
        const getJSDocSimpleTagUpdateFunction = memoizeOne((kind)=>(node, tagName, comment)=>updateJSDocSimpleTagWorker(kind, node, tagName, comment));
        const getJSDocTypeLikeTagCreateFunction = memoizeOne((kind)=>(tagName, typeExpression, comment)=>createJSDocTypeLikeTagWorker(kind, tagName, typeExpression, comment));
        const getJSDocTypeLikeTagUpdateFunction = memoizeOne((kind)=>(node, tagName, typeExpression, comment)=>updateJSDocTypeLikeTagWorker(kind, node, tagName, typeExpression, comment));
        const factory2 = {
            get parenthesizer () {
                return parenthesizerRules();
            },
            get converters () {
                return converters();
            },
            baseFactory: baseFactory2,
            flags: flags,
            createNodeArray: createNodeArray,
            createNumericLiteral: createNumericLiteral,
            createBigIntLiteral: createBigIntLiteral,
            createStringLiteral: createStringLiteral,
            createStringLiteralFromNode: createStringLiteralFromNode,
            createRegularExpressionLiteral: createRegularExpressionLiteral,
            createLiteralLikeNode: createLiteralLikeNode,
            createIdentifier: createIdentifier,
            createTempVariable: createTempVariable,
            createLoopVariable: createLoopVariable,
            createUniqueName: createUniqueName,
            getGeneratedNameForNode: getGeneratedNameForNode,
            createPrivateIdentifier: createPrivateIdentifier,
            createUniquePrivateName: createUniquePrivateName,
            getGeneratedPrivateNameForNode: getGeneratedPrivateNameForNode,
            createToken: createToken,
            createSuper: createSuper,
            createThis: createThis,
            createNull: createNull,
            createTrue: createTrue,
            createFalse: createFalse,
            createModifier: createModifier,
            createModifiersFromModifierFlags: createModifiersFromModifierFlags,
            createQualifiedName: createQualifiedName,
            updateQualifiedName: updateQualifiedName,
            createComputedPropertyName: createComputedPropertyName,
            updateComputedPropertyName: updateComputedPropertyName,
            createTypeParameterDeclaration: createTypeParameterDeclaration,
            updateTypeParameterDeclaration: updateTypeParameterDeclaration,
            createParameterDeclaration: createParameterDeclaration,
            updateParameterDeclaration: updateParameterDeclaration,
            createDecorator: createDecorator,
            updateDecorator: updateDecorator,
            createPropertySignature: createPropertySignature,
            updatePropertySignature: updatePropertySignature,
            createPropertyDeclaration: createPropertyDeclaration,
            updatePropertyDeclaration: updatePropertyDeclaration2,
            createMethodSignature: createMethodSignature,
            updateMethodSignature: updateMethodSignature,
            createMethodDeclaration: createMethodDeclaration,
            updateMethodDeclaration: updateMethodDeclaration,
            createConstructorDeclaration: createConstructorDeclaration,
            updateConstructorDeclaration: updateConstructorDeclaration,
            createGetAccessorDeclaration: createGetAccessorDeclaration,
            updateGetAccessorDeclaration: updateGetAccessorDeclaration,
            createSetAccessorDeclaration: createSetAccessorDeclaration,
            updateSetAccessorDeclaration: updateSetAccessorDeclaration,
            createCallSignature: createCallSignature,
            updateCallSignature: updateCallSignature,
            createConstructSignature: createConstructSignature,
            updateConstructSignature: updateConstructSignature,
            createIndexSignature: createIndexSignature,
            updateIndexSignature: updateIndexSignature,
            createClassStaticBlockDeclaration: createClassStaticBlockDeclaration,
            updateClassStaticBlockDeclaration: updateClassStaticBlockDeclaration,
            createTemplateLiteralTypeSpan: createTemplateLiteralTypeSpan,
            updateTemplateLiteralTypeSpan: updateTemplateLiteralTypeSpan,
            createKeywordTypeNode: createKeywordTypeNode,
            createTypePredicateNode: createTypePredicateNode,
            updateTypePredicateNode: updateTypePredicateNode,
            createTypeReferenceNode: createTypeReferenceNode,
            updateTypeReferenceNode: updateTypeReferenceNode,
            createFunctionTypeNode: createFunctionTypeNode,
            updateFunctionTypeNode: updateFunctionTypeNode,
            createConstructorTypeNode: createConstructorTypeNode,
            updateConstructorTypeNode: updateConstructorTypeNode,
            createTypeQueryNode: createTypeQueryNode,
            updateTypeQueryNode: updateTypeQueryNode,
            createTypeLiteralNode: createTypeLiteralNode,
            updateTypeLiteralNode: updateTypeLiteralNode,
            createArrayTypeNode: createArrayTypeNode,
            updateArrayTypeNode: updateArrayTypeNode,
            createTupleTypeNode: createTupleTypeNode,
            updateTupleTypeNode: updateTupleTypeNode,
            createNamedTupleMember: createNamedTupleMember,
            updateNamedTupleMember: updateNamedTupleMember,
            createOptionalTypeNode: createOptionalTypeNode,
            updateOptionalTypeNode: updateOptionalTypeNode,
            createRestTypeNode: createRestTypeNode,
            updateRestTypeNode: updateRestTypeNode,
            createUnionTypeNode: createUnionTypeNode,
            updateUnionTypeNode: updateUnionTypeNode,
            createIntersectionTypeNode: createIntersectionTypeNode,
            updateIntersectionTypeNode: updateIntersectionTypeNode,
            createConditionalTypeNode: createConditionalTypeNode,
            updateConditionalTypeNode: updateConditionalTypeNode,
            createInferTypeNode: createInferTypeNode,
            updateInferTypeNode: updateInferTypeNode,
            createImportTypeNode: createImportTypeNode,
            updateImportTypeNode: updateImportTypeNode,
            createParenthesizedType: createParenthesizedType,
            updateParenthesizedType: updateParenthesizedType,
            createThisTypeNode: createThisTypeNode,
            createTypeOperatorNode: createTypeOperatorNode,
            updateTypeOperatorNode: updateTypeOperatorNode,
            createIndexedAccessTypeNode: createIndexedAccessTypeNode,
            updateIndexedAccessTypeNode: updateIndexedAccessTypeNode,
            createMappedTypeNode: createMappedTypeNode,
            updateMappedTypeNode: updateMappedTypeNode,
            createLiteralTypeNode: createLiteralTypeNode,
            updateLiteralTypeNode: updateLiteralTypeNode,
            createTemplateLiteralType: createTemplateLiteralType,
            updateTemplateLiteralType: updateTemplateLiteralType,
            createObjectBindingPattern: createObjectBindingPattern,
            updateObjectBindingPattern: updateObjectBindingPattern,
            createArrayBindingPattern: createArrayBindingPattern,
            updateArrayBindingPattern: updateArrayBindingPattern,
            createBindingElement: createBindingElement,
            updateBindingElement: updateBindingElement,
            createArrayLiteralExpression: createArrayLiteralExpression,
            updateArrayLiteralExpression: updateArrayLiteralExpression,
            createObjectLiteralExpression: createObjectLiteralExpression,
            updateObjectLiteralExpression: updateObjectLiteralExpression,
            createPropertyAccessExpression: flags & 4 /* NoIndentationOnFreshPropertyAccess */  ? (expression, name)=>setEmitFlags(createPropertyAccessExpression(expression, name), 262144 /* NoIndentation */ ) : createPropertyAccessExpression,
            updatePropertyAccessExpression: updatePropertyAccessExpression,
            createPropertyAccessChain: flags & 4 /* NoIndentationOnFreshPropertyAccess */  ? (expression, questionDotToken, name)=>setEmitFlags(createPropertyAccessChain(expression, questionDotToken, name), 262144 /* NoIndentation */ ) : createPropertyAccessChain,
            updatePropertyAccessChain: updatePropertyAccessChain,
            createElementAccessExpression: createElementAccessExpression,
            updateElementAccessExpression: updateElementAccessExpression,
            createElementAccessChain: createElementAccessChain,
            updateElementAccessChain: updateElementAccessChain,
            createCallExpression: createCallExpression,
            updateCallExpression: updateCallExpression,
            createCallChain: createCallChain,
            updateCallChain: updateCallChain,
            createNewExpression: createNewExpression,
            updateNewExpression: updateNewExpression,
            createTaggedTemplateExpression: createTaggedTemplateExpression,
            updateTaggedTemplateExpression: updateTaggedTemplateExpression,
            createTypeAssertion: createTypeAssertion,
            updateTypeAssertion: updateTypeAssertion,
            createParenthesizedExpression: createParenthesizedExpression,
            updateParenthesizedExpression: updateParenthesizedExpression,
            createFunctionExpression: createFunctionExpression,
            updateFunctionExpression: updateFunctionExpression,
            createArrowFunction: createArrowFunction,
            updateArrowFunction: updateArrowFunction,
            createDeleteExpression: createDeleteExpression,
            updateDeleteExpression: updateDeleteExpression,
            createTypeOfExpression: createTypeOfExpression,
            updateTypeOfExpression: updateTypeOfExpression,
            createVoidExpression: createVoidExpression,
            updateVoidExpression: updateVoidExpression,
            createAwaitExpression: createAwaitExpression,
            updateAwaitExpression: updateAwaitExpression,
            createPrefixUnaryExpression: createPrefixUnaryExpression,
            updatePrefixUnaryExpression: updatePrefixUnaryExpression,
            createPostfixUnaryExpression: createPostfixUnaryExpression,
            updatePostfixUnaryExpression: updatePostfixUnaryExpression,
            createBinaryExpression: createBinaryExpression,
            updateBinaryExpression: updateBinaryExpression,
            createConditionalExpression: createConditionalExpression,
            updateConditionalExpression: updateConditionalExpression,
            createTemplateExpression: createTemplateExpression,
            updateTemplateExpression: updateTemplateExpression,
            createTemplateHead: createTemplateHead,
            createTemplateMiddle: createTemplateMiddle,
            createTemplateTail: createTemplateTail,
            createNoSubstitutionTemplateLiteral: createNoSubstitutionTemplateLiteral,
            createTemplateLiteralLikeNode: createTemplateLiteralLikeNode,
            createYieldExpression: createYieldExpression,
            updateYieldExpression: updateYieldExpression,
            createSpreadElement: createSpreadElement,
            updateSpreadElement: updateSpreadElement,
            createClassExpression: createClassExpression,
            updateClassExpression: updateClassExpression,
            createOmittedExpression: createOmittedExpression,
            createExpressionWithTypeArguments: createExpressionWithTypeArguments,
            updateExpressionWithTypeArguments: updateExpressionWithTypeArguments,
            createAsExpression: createAsExpression,
            updateAsExpression: updateAsExpression,
            createNonNullExpression: createNonNullExpression,
            updateNonNullExpression: updateNonNullExpression,
            createSatisfiesExpression: createSatisfiesExpression,
            updateSatisfiesExpression: updateSatisfiesExpression,
            createNonNullChain: createNonNullChain,
            updateNonNullChain: updateNonNullChain,
            createMetaProperty: createMetaProperty,
            updateMetaProperty: updateMetaProperty,
            createTemplateSpan: createTemplateSpan,
            updateTemplateSpan: updateTemplateSpan,
            createSemicolonClassElement: createSemicolonClassElement,
            createBlock: createBlock,
            updateBlock: updateBlock,
            createVariableStatement: createVariableStatement,
            updateVariableStatement: updateVariableStatement,
            createEmptyStatement: createEmptyStatement,
            createExpressionStatement: createExpressionStatement,
            updateExpressionStatement: updateExpressionStatement,
            createIfStatement: createIfStatement,
            updateIfStatement: updateIfStatement,
            createDoStatement: createDoStatement,
            updateDoStatement: updateDoStatement,
            createWhileStatement: createWhileStatement,
            updateWhileStatement: updateWhileStatement,
            createForStatement: createForStatement,
            updateForStatement: updateForStatement,
            createForInStatement: createForInStatement,
            updateForInStatement: updateForInStatement,
            createForOfStatement: createForOfStatement,
            updateForOfStatement: updateForOfStatement,
            createContinueStatement: createContinueStatement,
            updateContinueStatement: updateContinueStatement,
            createBreakStatement: createBreakStatement,
            updateBreakStatement: updateBreakStatement,
            createReturnStatement: createReturnStatement,
            updateReturnStatement: updateReturnStatement,
            createWithStatement: createWithStatement,
            updateWithStatement: updateWithStatement,
            createSwitchStatement: createSwitchStatement,
            updateSwitchStatement: updateSwitchStatement,
            createLabeledStatement: createLabeledStatement,
            updateLabeledStatement: updateLabeledStatement,
            createThrowStatement: createThrowStatement,
            updateThrowStatement: updateThrowStatement,
            createTryStatement: createTryStatement,
            updateTryStatement: updateTryStatement,
            createDebuggerStatement: createDebuggerStatement,
            createVariableDeclaration: createVariableDeclaration,
            updateVariableDeclaration: updateVariableDeclaration,
            createVariableDeclarationList: createVariableDeclarationList,
            updateVariableDeclarationList: updateVariableDeclarationList,
            createFunctionDeclaration: createFunctionDeclaration,
            updateFunctionDeclaration: updateFunctionDeclaration,
            createClassDeclaration: createClassDeclaration,
            updateClassDeclaration: updateClassDeclaration,
            createInterfaceDeclaration: createInterfaceDeclaration,
            updateInterfaceDeclaration: updateInterfaceDeclaration,
            createTypeAliasDeclaration: createTypeAliasDeclaration,
            updateTypeAliasDeclaration: updateTypeAliasDeclaration,
            createEnumDeclaration: createEnumDeclaration,
            updateEnumDeclaration: updateEnumDeclaration,
            createModuleDeclaration: createModuleDeclaration,
            updateModuleDeclaration: updateModuleDeclaration,
            createModuleBlock: createModuleBlock,
            updateModuleBlock: updateModuleBlock,
            createCaseBlock: createCaseBlock,
            updateCaseBlock: updateCaseBlock,
            createNamespaceExportDeclaration: createNamespaceExportDeclaration,
            updateNamespaceExportDeclaration: updateNamespaceExportDeclaration,
            createImportEqualsDeclaration: createImportEqualsDeclaration,
            updateImportEqualsDeclaration: updateImportEqualsDeclaration,
            createImportDeclaration: createImportDeclaration,
            updateImportDeclaration: updateImportDeclaration,
            createImportClause: createImportClause,
            updateImportClause: updateImportClause,
            createAssertClause: createAssertClause,
            updateAssertClause: updateAssertClause,
            createAssertEntry: createAssertEntry,
            updateAssertEntry: updateAssertEntry,
            createImportTypeAssertionContainer: createImportTypeAssertionContainer,
            updateImportTypeAssertionContainer: updateImportTypeAssertionContainer,
            createNamespaceImport: createNamespaceImport,
            updateNamespaceImport: updateNamespaceImport,
            createNamespaceExport: createNamespaceExport,
            updateNamespaceExport: updateNamespaceExport,
            createNamedImports: createNamedImports,
            updateNamedImports: updateNamedImports,
            createImportSpecifier: createImportSpecifier,
            updateImportSpecifier: updateImportSpecifier,
            createExportAssignment: createExportAssignment2,
            updateExportAssignment: updateExportAssignment,
            createExportDeclaration: createExportDeclaration,
            updateExportDeclaration: updateExportDeclaration,
            createNamedExports: createNamedExports,
            updateNamedExports: updateNamedExports,
            createExportSpecifier: createExportSpecifier,
            updateExportSpecifier: updateExportSpecifier,
            createMissingDeclaration: createMissingDeclaration,
            createExternalModuleReference: createExternalModuleReference,
            updateExternalModuleReference: updateExternalModuleReference,
            // lazily load factory members for JSDoc types with similar structure
            get createJSDocAllType () {
                return getJSDocPrimaryTypeCreateFunction(318 /* JSDocAllType */ );
            },
            get createJSDocUnknownType () {
                return getJSDocPrimaryTypeCreateFunction(319 /* JSDocUnknownType */ );
            },
            get createJSDocNonNullableType () {
                return getJSDocPrePostfixUnaryTypeCreateFunction(321 /* JSDocNonNullableType */ );
            },
            get updateJSDocNonNullableType () {
                return getJSDocPrePostfixUnaryTypeUpdateFunction(321 /* JSDocNonNullableType */ );
            },
            get createJSDocNullableType () {
                return getJSDocPrePostfixUnaryTypeCreateFunction(320 /* JSDocNullableType */ );
            },
            get updateJSDocNullableType () {
                return getJSDocPrePostfixUnaryTypeUpdateFunction(320 /* JSDocNullableType */ );
            },
            get createJSDocOptionalType () {
                return getJSDocUnaryTypeCreateFunction(322 /* JSDocOptionalType */ );
            },
            get updateJSDocOptionalType () {
                return getJSDocUnaryTypeUpdateFunction(322 /* JSDocOptionalType */ );
            },
            get createJSDocVariadicType () {
                return getJSDocUnaryTypeCreateFunction(324 /* JSDocVariadicType */ );
            },
            get updateJSDocVariadicType () {
                return getJSDocUnaryTypeUpdateFunction(324 /* JSDocVariadicType */ );
            },
            get createJSDocNamepathType () {
                return getJSDocUnaryTypeCreateFunction(325 /* JSDocNamepathType */ );
            },
            get updateJSDocNamepathType () {
                return getJSDocUnaryTypeUpdateFunction(325 /* JSDocNamepathType */ );
            },
            createJSDocFunctionType: createJSDocFunctionType,
            updateJSDocFunctionType: updateJSDocFunctionType,
            createJSDocTypeLiteral: createJSDocTypeLiteral,
            updateJSDocTypeLiteral: updateJSDocTypeLiteral,
            createJSDocTypeExpression: createJSDocTypeExpression,
            updateJSDocTypeExpression: updateJSDocTypeExpression,
            createJSDocSignature: createJSDocSignature,
            updateJSDocSignature: updateJSDocSignature,
            createJSDocTemplateTag: createJSDocTemplateTag,
            updateJSDocTemplateTag: updateJSDocTemplateTag,
            createJSDocTypedefTag: createJSDocTypedefTag,
            updateJSDocTypedefTag: updateJSDocTypedefTag,
            createJSDocParameterTag: createJSDocParameterTag,
            updateJSDocParameterTag: updateJSDocParameterTag,
            createJSDocPropertyTag: createJSDocPropertyTag,
            updateJSDocPropertyTag: updateJSDocPropertyTag,
            createJSDocCallbackTag: createJSDocCallbackTag,
            updateJSDocCallbackTag: updateJSDocCallbackTag,
            createJSDocOverloadTag: createJSDocOverloadTag,
            updateJSDocOverloadTag: updateJSDocOverloadTag,
            createJSDocAugmentsTag: createJSDocAugmentsTag,
            updateJSDocAugmentsTag: updateJSDocAugmentsTag,
            createJSDocImplementsTag: createJSDocImplementsTag,
            updateJSDocImplementsTag: updateJSDocImplementsTag,
            createJSDocSeeTag: createJSDocSeeTag,
            updateJSDocSeeTag: updateJSDocSeeTag,
            createJSDocNameReference: createJSDocNameReference,
            updateJSDocNameReference: updateJSDocNameReference,
            createJSDocMemberName: createJSDocMemberName,
            updateJSDocMemberName: updateJSDocMemberName,
            createJSDocLink: createJSDocLink,
            updateJSDocLink: updateJSDocLink,
            createJSDocLinkCode: createJSDocLinkCode,
            updateJSDocLinkCode: updateJSDocLinkCode,
            createJSDocLinkPlain: createJSDocLinkPlain,
            updateJSDocLinkPlain: updateJSDocLinkPlain,
            // lazily load factory members for JSDoc tags with similar structure
            get createJSDocTypeTag () {
                return getJSDocTypeLikeTagCreateFunction(350 /* JSDocTypeTag */ );
            },
            get updateJSDocTypeTag () {
                return getJSDocTypeLikeTagUpdateFunction(350 /* JSDocTypeTag */ );
            },
            get createJSDocReturnTag () {
                return getJSDocTypeLikeTagCreateFunction(348 /* JSDocReturnTag */ );
            },
            get updateJSDocReturnTag () {
                return getJSDocTypeLikeTagUpdateFunction(348 /* JSDocReturnTag */ );
            },
            get createJSDocThisTag () {
                return getJSDocTypeLikeTagCreateFunction(349 /* JSDocThisTag */ );
            },
            get updateJSDocThisTag () {
                return getJSDocTypeLikeTagUpdateFunction(349 /* JSDocThisTag */ );
            },
            get createJSDocAuthorTag () {
                return getJSDocSimpleTagCreateFunction(336 /* JSDocAuthorTag */ );
            },
            get updateJSDocAuthorTag () {
                return getJSDocSimpleTagUpdateFunction(336 /* JSDocAuthorTag */ );
            },
            get createJSDocClassTag () {
                return getJSDocSimpleTagCreateFunction(338 /* JSDocClassTag */ );
            },
            get updateJSDocClassTag () {
                return getJSDocSimpleTagUpdateFunction(338 /* JSDocClassTag */ );
            },
            get createJSDocPublicTag () {
                return getJSDocSimpleTagCreateFunction(339 /* JSDocPublicTag */ );
            },
            get updateJSDocPublicTag () {
                return getJSDocSimpleTagUpdateFunction(339 /* JSDocPublicTag */ );
            },
            get createJSDocPrivateTag () {
                return getJSDocSimpleTagCreateFunction(340 /* JSDocPrivateTag */ );
            },
            get updateJSDocPrivateTag () {
                return getJSDocSimpleTagUpdateFunction(340 /* JSDocPrivateTag */ );
            },
            get createJSDocProtectedTag () {
                return getJSDocSimpleTagCreateFunction(341 /* JSDocProtectedTag */ );
            },
            get updateJSDocProtectedTag () {
                return getJSDocSimpleTagUpdateFunction(341 /* JSDocProtectedTag */ );
            },
            get createJSDocReadonlyTag () {
                return getJSDocSimpleTagCreateFunction(342 /* JSDocReadonlyTag */ );
            },
            get updateJSDocReadonlyTag () {
                return getJSDocSimpleTagUpdateFunction(342 /* JSDocReadonlyTag */ );
            },
            get createJSDocOverrideTag () {
                return getJSDocSimpleTagCreateFunction(343 /* JSDocOverrideTag */ );
            },
            get updateJSDocOverrideTag () {
                return getJSDocSimpleTagUpdateFunction(343 /* JSDocOverrideTag */ );
            },
            get createJSDocDeprecatedTag () {
                return getJSDocSimpleTagCreateFunction(337 /* JSDocDeprecatedTag */ );
            },
            get updateJSDocDeprecatedTag () {
                return getJSDocSimpleTagUpdateFunction(337 /* JSDocDeprecatedTag */ );
            },
            get createJSDocThrowsTag () {
                return getJSDocTypeLikeTagCreateFunction(355 /* JSDocThrowsTag */ );
            },
            get updateJSDocThrowsTag () {
                return getJSDocTypeLikeTagUpdateFunction(355 /* JSDocThrowsTag */ );
            },
            get createJSDocSatisfiesTag () {
                return getJSDocTypeLikeTagCreateFunction(356 /* JSDocSatisfiesTag */ );
            },
            get updateJSDocSatisfiesTag () {
                return getJSDocTypeLikeTagUpdateFunction(356 /* JSDocSatisfiesTag */ );
            },
            createJSDocEnumTag: createJSDocEnumTag,
            updateJSDocEnumTag: updateJSDocEnumTag,
            createJSDocUnknownTag: createJSDocUnknownTag,
            updateJSDocUnknownTag: updateJSDocUnknownTag,
            createJSDocText: createJSDocText,
            updateJSDocText: updateJSDocText,
            createJSDocComment: createJSDocComment,
            updateJSDocComment: updateJSDocComment,
            createJsxElement: createJsxElement,
            updateJsxElement: updateJsxElement,
            createJsxSelfClosingElement: createJsxSelfClosingElement,
            updateJsxSelfClosingElement: updateJsxSelfClosingElement,
            createJsxOpeningElement: createJsxOpeningElement,
            updateJsxOpeningElement: updateJsxOpeningElement,
            createJsxClosingElement: createJsxClosingElement,
            updateJsxClosingElement: updateJsxClosingElement,
            createJsxFragment: createJsxFragment,
            createJsxText: createJsxText,
            updateJsxText: updateJsxText,
            createJsxOpeningFragment: createJsxOpeningFragment,
            createJsxJsxClosingFragment: createJsxJsxClosingFragment,
            updateJsxFragment: updateJsxFragment,
            createJsxAttribute: createJsxAttribute,
            updateJsxAttribute: updateJsxAttribute,
            createJsxAttributes: createJsxAttributes,
            updateJsxAttributes: updateJsxAttributes,
            createJsxSpreadAttribute: createJsxSpreadAttribute,
            updateJsxSpreadAttribute: updateJsxSpreadAttribute,
            createJsxExpression: createJsxExpression,
            updateJsxExpression: updateJsxExpression,
            createJsxNamespacedName: createJsxNamespacedName,
            updateJsxNamespacedName: updateJsxNamespacedName,
            createCaseClause: createCaseClause,
            updateCaseClause: updateCaseClause,
            createDefaultClause: createDefaultClause,
            updateDefaultClause: updateDefaultClause,
            createHeritageClause: createHeritageClause,
            updateHeritageClause: updateHeritageClause,
            createCatchClause: createCatchClause,
            updateCatchClause: updateCatchClause,
            createPropertyAssignment: createPropertyAssignment,
            updatePropertyAssignment: updatePropertyAssignment,
            createShorthandPropertyAssignment: createShorthandPropertyAssignment,
            updateShorthandPropertyAssignment: updateShorthandPropertyAssignment,
            createSpreadAssignment: createSpreadAssignment,
            updateSpreadAssignment: updateSpreadAssignment,
            createEnumMember: createEnumMember,
            updateEnumMember: updateEnumMember,
            createSourceFile: createSourceFile2,
            updateSourceFile: updateSourceFile2,
            createRedirectedSourceFile: createRedirectedSourceFile,
            createBundle: createBundle,
            updateBundle: updateBundle,
            createUnparsedSource: createUnparsedSource,
            createUnparsedPrologue: createUnparsedPrologue,
            createUnparsedPrepend: createUnparsedPrepend,
            createUnparsedTextLike: createUnparsedTextLike,
            createUnparsedSyntheticReference: createUnparsedSyntheticReference,
            createInputFiles: createInputFiles2,
            createSyntheticExpression: createSyntheticExpression,
            createSyntaxList: createSyntaxList3,
            createNotEmittedStatement: createNotEmittedStatement,
            createPartiallyEmittedExpression: createPartiallyEmittedExpression,
            updatePartiallyEmittedExpression: updatePartiallyEmittedExpression,
            createCommaListExpression: createCommaListExpression,
            updateCommaListExpression: updateCommaListExpression,
            createSyntheticReferenceExpression: createSyntheticReferenceExpression,
            updateSyntheticReferenceExpression: updateSyntheticReferenceExpression,
            cloneNode: cloneNode,
            // Lazily load factory methods for common operator factories and utilities
            get createComma () {
                return getBinaryCreateFunction(28 /* CommaToken */ );
            },
            get createAssignment () {
                return getBinaryCreateFunction(64 /* EqualsToken */ );
            },
            get createLogicalOr () {
                return getBinaryCreateFunction(57 /* BarBarToken */ );
            },
            get createLogicalAnd () {
                return getBinaryCreateFunction(56 /* AmpersandAmpersandToken */ );
            },
            get createBitwiseOr () {
                return getBinaryCreateFunction(52 /* BarToken */ );
            },
            get createBitwiseXor () {
                return getBinaryCreateFunction(53 /* CaretToken */ );
            },
            get createBitwiseAnd () {
                return getBinaryCreateFunction(51 /* AmpersandToken */ );
            },
            get createStrictEquality () {
                return getBinaryCreateFunction(37 /* EqualsEqualsEqualsToken */ );
            },
            get createStrictInequality () {
                return getBinaryCreateFunction(38 /* ExclamationEqualsEqualsToken */ );
            },
            get createEquality () {
                return getBinaryCreateFunction(35 /* EqualsEqualsToken */ );
            },
            get createInequality () {
                return getBinaryCreateFunction(36 /* ExclamationEqualsToken */ );
            },
            get createLessThan () {
                return getBinaryCreateFunction(30 /* LessThanToken */ );
            },
            get createLessThanEquals () {
                return getBinaryCreateFunction(33 /* LessThanEqualsToken */ );
            },
            get createGreaterThan () {
                return getBinaryCreateFunction(32 /* GreaterThanToken */ );
            },
            get createGreaterThanEquals () {
                return getBinaryCreateFunction(34 /* GreaterThanEqualsToken */ );
            },
            get createLeftShift () {
                return getBinaryCreateFunction(48 /* LessThanLessThanToken */ );
            },
            get createRightShift () {
                return getBinaryCreateFunction(49 /* GreaterThanGreaterThanToken */ );
            },
            get createUnsignedRightShift () {
                return getBinaryCreateFunction(50 /* GreaterThanGreaterThanGreaterThanToken */ );
            },
            get createAdd () {
                return getBinaryCreateFunction(40 /* PlusToken */ );
            },
            get createSubtract () {
                return getBinaryCreateFunction(41 /* MinusToken */ );
            },
            get createMultiply () {
                return getBinaryCreateFunction(42 /* AsteriskToken */ );
            },
            get createDivide () {
                return getBinaryCreateFunction(44 /* SlashToken */ );
            },
            get createModulo () {
                return getBinaryCreateFunction(45 /* PercentToken */ );
            },
            get createExponent () {
                return getBinaryCreateFunction(43 /* AsteriskAsteriskToken */ );
            },
            get createPrefixPlus () {
                return getPrefixUnaryCreateFunction(40 /* PlusToken */ );
            },
            get createPrefixMinus () {
                return getPrefixUnaryCreateFunction(41 /* MinusToken */ );
            },
            get createPrefixIncrement () {
                return getPrefixUnaryCreateFunction(46 /* PlusPlusToken */ );
            },
            get createPrefixDecrement () {
                return getPrefixUnaryCreateFunction(47 /* MinusMinusToken */ );
            },
            get createBitwiseNot () {
                return getPrefixUnaryCreateFunction(55 /* TildeToken */ );
            },
            get createLogicalNot () {
                return getPrefixUnaryCreateFunction(54 /* ExclamationToken */ );
            },
            get createPostfixIncrement () {
                return getPostfixUnaryCreateFunction(46 /* PlusPlusToken */ );
            },
            get createPostfixDecrement () {
                return getPostfixUnaryCreateFunction(47 /* MinusMinusToken */ );
            },
            createImmediatelyInvokedFunctionExpression: // Compound nodes
            createImmediatelyInvokedFunctionExpression,
            createImmediatelyInvokedArrowFunction: createImmediatelyInvokedArrowFunction,
            createVoidZero: createVoidZero,
            createExportDefault: createExportDefault,
            createExternalModuleExport: createExternalModuleExport,
            createTypeCheck: createTypeCheck,
            createMethodCall: createMethodCall,
            createGlobalMethodCall: createGlobalMethodCall,
            createFunctionBindCall: createFunctionBindCall,
            createFunctionCallCall: createFunctionCallCall,
            createFunctionApplyCall: createFunctionApplyCall,
            createArraySliceCall: createArraySliceCall,
            createArrayConcatCall: createArrayConcatCall,
            createObjectDefinePropertyCall: createObjectDefinePropertyCall,
            createObjectGetOwnPropertyDescriptorCall: createObjectGetOwnPropertyDescriptorCall,
            createReflectGetCall: createReflectGetCall,
            createReflectSetCall: createReflectSetCall,
            createPropertyDescriptor: createPropertyDescriptor,
            createCallBinding: createCallBinding,
            createAssignmentTargetWrapper: createAssignmentTargetWrapper,
            inlineExpressions: // Utilities
            inlineExpressions,
            getInternalName: getInternalName,
            getLocalName: getLocalName,
            getExportName: getExportName,
            getDeclarationName: getDeclarationName,
            getNamespaceMemberName: getNamespaceMemberName,
            getExternalModuleOrNamespaceExportName: getExternalModuleOrNamespaceExportName,
            restoreOuterExpressions: restoreOuterExpressions,
            restoreEnclosingLabel: restoreEnclosingLabel,
            createUseStrictPrologue: createUseStrictPrologue,
            copyPrologue: copyPrologue,
            copyStandardPrologue: copyStandardPrologue,
            copyCustomPrologue: copyCustomPrologue,
            ensureUseStrict: ensureUseStrict,
            liftToBlock: liftToBlock,
            mergeLexicalEnvironment: mergeLexicalEnvironment,
            updateModifiers: updateModifiers
        };
        forEach(nodeFactoryPatchers, (fn)=>fn(factory2));
        return factory2;
        function createNodeArray(elements, hasTrailingComma) {
            if (elements === void 0 || elements === emptyArray) elements = [];
            else if (isNodeArray(elements)) {
                if (hasTrailingComma === void 0 || elements.hasTrailingComma === hasTrailingComma) {
                    if (elements.transformFlags === void 0) aggregateChildrenFlags(elements);
                    Debug.attachNodeArrayDebugInfo(elements);
                    return elements;
                }
                const array2 = elements.slice();
                array2.pos = elements.pos;
                array2.end = elements.end;
                array2.hasTrailingComma = hasTrailingComma;
                array2.transformFlags = elements.transformFlags;
                Debug.attachNodeArrayDebugInfo(array2);
                return array2;
            }
            const length2 = elements.length;
            const array = length2 >= 1 && length2 <= 4 ? elements.slice() : elements;
            array.pos = -1;
            array.end = -1;
            array.hasTrailingComma = !!hasTrailingComma;
            array.transformFlags = 0 /* None */ ;
            aggregateChildrenFlags(array);
            Debug.attachNodeArrayDebugInfo(array);
            return array;
        }
        function createBaseNode(kind) {
            return baseFactory2.createBaseNode(kind);
        }
        function createBaseDeclaration(kind) {
            const node = createBaseNode(kind);
            node.symbol = void 0;
            node.localSymbol = void 0;
            return node;
        }
        function finishUpdateBaseSignatureDeclaration(updated, original) {
            if (updated !== original) updated.typeArguments = original.typeArguments;
            return update(updated, original);
        }
        function createNumericLiteral(value1, numericLiteralFlags = 0 /* None */ ) {
            const node = createBaseDeclaration(9 /* NumericLiteral */ );
            node.text = typeof value1 === "number" ? value1 + "" : value1;
            node.numericLiteralFlags = numericLiteralFlags;
            if (numericLiteralFlags & 384 /* BinaryOrOctalSpecifier */ ) node.transformFlags |= 1024 /* ContainsES2015 */ ;
            return node;
        }
        function createBigIntLiteral(value1) {
            const node = createBaseToken(10 /* BigIntLiteral */ );
            node.text = typeof value1 === "string" ? value1 : pseudoBigIntToString(value1) + "n";
            node.transformFlags |= 32 /* ContainsES2020 */ ;
            return node;
        }
        function createBaseStringLiteral(text, isSingleQuote) {
            const node = createBaseDeclaration(11 /* StringLiteral */ );
            node.text = text;
            node.singleQuote = isSingleQuote;
            return node;
        }
        function createStringLiteral(text, isSingleQuote, hasExtendedUnicodeEscape) {
            const node = createBaseStringLiteral(text, isSingleQuote);
            node.hasExtendedUnicodeEscape = hasExtendedUnicodeEscape;
            if (hasExtendedUnicodeEscape) node.transformFlags |= 1024 /* ContainsES2015 */ ;
            return node;
        }
        function createStringLiteralFromNode(sourceNode) {
            const node = createBaseStringLiteral(getTextOfIdentifierOrLiteral(sourceNode), /*isSingleQuote*/ void 0);
            node.textSourceNode = sourceNode;
            return node;
        }
        function createRegularExpressionLiteral(text) {
            const node = createBaseToken(14 /* RegularExpressionLiteral */ );
            node.text = text;
            return node;
        }
        function createLiteralLikeNode(kind, text) {
            switch(kind){
                case 9 /* NumericLiteral */ :
                    return createNumericLiteral(text, /*numericLiteralFlags*/ 0);
                case 10 /* BigIntLiteral */ :
                    return createBigIntLiteral(text);
                case 11 /* StringLiteral */ :
                    return createStringLiteral(text, /*isSingleQuote*/ void 0);
                case 12 /* JsxText */ :
                    return createJsxText(text, /*containsOnlyTriviaWhiteSpaces*/ false);
                case 13 /* JsxTextAllWhiteSpaces */ :
                    return createJsxText(text, /*containsOnlyTriviaWhiteSpaces*/ true);
                case 14 /* RegularExpressionLiteral */ :
                    return createRegularExpressionLiteral(text);
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    return createTemplateLiteralLikeNode(kind, text, /*rawText*/ void 0, /*templateFlags*/ 0);
            }
        }
        function createBaseIdentifier(escapedText) {
            const node = baseFactory2.createBaseIdentifierNode(80 /* Identifier */ );
            node.escapedText = escapedText;
            node.jsDoc = void 0;
            node.flowNode = void 0;
            node.symbol = void 0;
            return node;
        }
        function createBaseGeneratedIdentifier(text, autoGenerateFlags, prefix, suffix) {
            const node = createBaseIdentifier(escapeLeadingUnderscores(text));
            setIdentifierAutoGenerate(node, {
                flags: autoGenerateFlags,
                id: nextAutoGenerateId,
                prefix: prefix,
                suffix: suffix
            });
            nextAutoGenerateId++;
            return node;
        }
        function createIdentifier(text, originalKeywordKind, hasExtendedUnicodeEscape) {
            if (originalKeywordKind === void 0 && text) originalKeywordKind = stringToToken(text);
            if (originalKeywordKind === 80 /* Identifier */ ) originalKeywordKind = void 0;
            const node = createBaseIdentifier(escapeLeadingUnderscores(text));
            if (hasExtendedUnicodeEscape) node.flags |= 128 /* IdentifierHasExtendedUnicodeEscape */ ;
            if (node.escapedText === "await") node.transformFlags |= 67108864 /* ContainsPossibleTopLevelAwait */ ;
            if (node.flags & 128 /* IdentifierHasExtendedUnicodeEscape */ ) node.transformFlags |= 1024 /* ContainsES2015 */ ;
            return node;
        }
        function createTempVariable(recordTempVariable, reservedInNestedScopes, prefix, suffix) {
            let flags2 = 1 /* Auto */ ;
            if (reservedInNestedScopes) flags2 |= 8 /* ReservedInNestedScopes */ ;
            const name = createBaseGeneratedIdentifier("", flags2, prefix, suffix);
            if (recordTempVariable) recordTempVariable(name);
            return name;
        }
        function createLoopVariable(reservedInNestedScopes) {
            let flags2 = 2 /* Loop */ ;
            if (reservedInNestedScopes) flags2 |= 8 /* ReservedInNestedScopes */ ;
            return createBaseGeneratedIdentifier("", flags2, /*prefix*/ void 0, /*suffix*/ void 0);
        }
        function createUniqueName(text, flags2 = 0 /* None */ , prefix, suffix) {
            Debug.assert(!(flags2 & 7 /* KindMask */ ), "Argument out of range: flags");
            Debug.assert((flags2 & 48 /* FileLevel */ ) !== 32 /* FileLevel */ , "GeneratedIdentifierFlags.FileLevel cannot be set without also setting GeneratedIdentifierFlags.Optimistic");
            return createBaseGeneratedIdentifier(text, 3 /* Unique */  | flags2, prefix, suffix);
        }
        function getGeneratedNameForNode(node, flags2 = 0, prefix, suffix) {
            Debug.assert(!(flags2 & 7 /* KindMask */ ), "Argument out of range: flags");
            const text = !node ? "" : isMemberName(node) ? formatGeneratedName(/*privateName*/ false, prefix, node, suffix, idText) : `generated@${getNodeId(node)}`;
            if (prefix || suffix) flags2 |= 16 /* Optimistic */ ;
            const name = createBaseGeneratedIdentifier(text, 4 /* Node */  | flags2, prefix, suffix);
            name.original = node;
            return name;
        }
        function createBasePrivateIdentifier(escapedText) {
            const node = baseFactory2.createBasePrivateIdentifierNode(81 /* PrivateIdentifier */ );
            node.escapedText = escapedText;
            node.transformFlags |= 16777216 /* ContainsClassFields */ ;
            return node;
        }
        function createPrivateIdentifier(text) {
            if (!startsWith(text, "#")) Debug.fail("First character of private identifier must be #: " + text);
            return createBasePrivateIdentifier(escapeLeadingUnderscores(text));
        }
        function createBaseGeneratedPrivateIdentifier(text, autoGenerateFlags, prefix, suffix) {
            const node = createBasePrivateIdentifier(escapeLeadingUnderscores(text));
            setIdentifierAutoGenerate(node, {
                flags: autoGenerateFlags,
                id: nextAutoGenerateId,
                prefix: prefix,
                suffix: suffix
            });
            nextAutoGenerateId++;
            return node;
        }
        function createUniquePrivateName(text, prefix, suffix) {
            if (text && !startsWith(text, "#")) Debug.fail("First character of private identifier must be #: " + text);
            const autoGenerateFlags = 8 /* ReservedInNestedScopes */  | (text ? 3 /* Unique */  : 1 /* Auto */ );
            return createBaseGeneratedPrivateIdentifier(text ?? "", autoGenerateFlags, prefix, suffix);
        }
        function getGeneratedPrivateNameForNode(node, prefix, suffix) {
            const text = isMemberName(node) ? formatGeneratedName(/*privateName*/ true, prefix, node, suffix, idText) : `#generated@${getNodeId(node)}`;
            const flags2 = prefix || suffix ? 16 /* Optimistic */  : 0 /* None */ ;
            const name = createBaseGeneratedPrivateIdentifier(text, 4 /* Node */  | flags2, prefix, suffix);
            name.original = node;
            return name;
        }
        function createBaseToken(kind) {
            return baseFactory2.createBaseTokenNode(kind);
        }
        function createToken(token) {
            Debug.assert(token >= 0 /* FirstToken */  && token <= 164 /* LastToken */ , "Invalid token");
            Debug.assert(token <= 15 /* FirstTemplateToken */  || token >= 18 /* LastTemplateToken */ , "Invalid token. Use 'createTemplateLiteralLikeNode' to create template literals.");
            Debug.assert(token <= 9 /* FirstLiteralToken */  || token >= 15 /* LastLiteralToken */ , "Invalid token. Use 'createLiteralLikeNode' to create literals.");
            Debug.assert(token !== 80 /* Identifier */ , "Invalid token. Use 'createIdentifier' to create identifiers");
            const node = createBaseToken(token);
            let transformFlags = 0 /* None */ ;
            switch(token){
                case 134 /* AsyncKeyword */ :
                    transformFlags = 384 /* ContainsES2018 */ ;
                    break;
                case 125 /* PublicKeyword */ :
                case 123 /* PrivateKeyword */ :
                case 124 /* ProtectedKeyword */ :
                case 148 /* ReadonlyKeyword */ :
                case 128 /* AbstractKeyword */ :
                case 138 /* DeclareKeyword */ :
                case 87 /* ConstKeyword */ :
                case 133 /* AnyKeyword */ :
                case 150 /* NumberKeyword */ :
                case 162 /* BigIntKeyword */ :
                case 146 /* NeverKeyword */ :
                case 151 /* ObjectKeyword */ :
                case 103 /* InKeyword */ :
                case 147 /* OutKeyword */ :
                case 163 /* OverrideKeyword */ :
                case 154 /* StringKeyword */ :
                case 136 /* BooleanKeyword */ :
                case 155 /* SymbolKeyword */ :
                case 116 /* VoidKeyword */ :
                case 159 /* UnknownKeyword */ :
                case 157 /* UndefinedKeyword */ :
                    transformFlags = 1 /* ContainsTypeScript */ ;
                    break;
                case 108 /* SuperKeyword */ :
                    transformFlags = 134218752 /* ContainsLexicalSuper */ ;
                    node.flowNode = void 0;
                    break;
                case 126 /* StaticKeyword */ :
                    transformFlags = 1024 /* ContainsES2015 */ ;
                    break;
                case 129 /* AccessorKeyword */ :
                    transformFlags = 16777216 /* ContainsClassFields */ ;
                    break;
                case 110 /* ThisKeyword */ :
                    transformFlags = 16384 /* ContainsLexicalThis */ ;
                    node.flowNode = void 0;
                    break;
            }
            if (transformFlags) node.transformFlags |= transformFlags;
            return node;
        }
        function createSuper() {
            return createToken(108 /* SuperKeyword */ );
        }
        function createThis() {
            return createToken(110 /* ThisKeyword */ );
        }
        function createNull() {
            return createToken(106 /* NullKeyword */ );
        }
        function createTrue() {
            return createToken(112 /* TrueKeyword */ );
        }
        function createFalse() {
            return createToken(97 /* FalseKeyword */ );
        }
        function createModifier(kind) {
            return createToken(kind);
        }
        function createModifiersFromModifierFlags(flags2) {
            const result = [];
            if (flags2 & 1 /* Export */ ) result.push(createModifier(95 /* ExportKeyword */ ));
            if (flags2 & 2 /* Ambient */ ) result.push(createModifier(138 /* DeclareKeyword */ ));
            if (flags2 & 1024 /* Default */ ) result.push(createModifier(90 /* DefaultKeyword */ ));
            if (flags2 & 2048 /* Const */ ) result.push(createModifier(87 /* ConstKeyword */ ));
            if (flags2 & 4 /* Public */ ) result.push(createModifier(125 /* PublicKeyword */ ));
            if (flags2 & 8 /* Private */ ) result.push(createModifier(123 /* PrivateKeyword */ ));
            if (flags2 & 16 /* Protected */ ) result.push(createModifier(124 /* ProtectedKeyword */ ));
            if (flags2 & 256 /* Abstract */ ) result.push(createModifier(128 /* AbstractKeyword */ ));
            if (flags2 & 32 /* Static */ ) result.push(createModifier(126 /* StaticKeyword */ ));
            if (flags2 & 16384 /* Override */ ) result.push(createModifier(163 /* OverrideKeyword */ ));
            if (flags2 & 64 /* Readonly */ ) result.push(createModifier(148 /* ReadonlyKeyword */ ));
            if (flags2 & 128 /* Accessor */ ) result.push(createModifier(129 /* AccessorKeyword */ ));
            if (flags2 & 512 /* Async */ ) result.push(createModifier(134 /* AsyncKeyword */ ));
            if (flags2 & 32768 /* In */ ) result.push(createModifier(103 /* InKeyword */ ));
            if (flags2 & 65536 /* Out */ ) result.push(createModifier(147 /* OutKeyword */ ));
            return result.length ? result : void 0;
        }
        function createQualifiedName(left, right) {
            const node = createBaseNode(165 /* QualifiedName */ );
            node.left = left;
            node.right = asName(right);
            node.transformFlags |= propagateChildFlags(node.left) | propagateIdentifierNameFlags(node.right);
            node.flowNode = void 0;
            return node;
        }
        function updateQualifiedName(node, left, right) {
            return node.left !== left || node.right !== right ? update(createQualifiedName(left, right), node) : node;
        }
        function createComputedPropertyName(expression) {
            const node = createBaseNode(166 /* ComputedPropertyName */ );
            node.expression = parenthesizerRules().parenthesizeExpressionOfComputedPropertyName(expression);
            node.transformFlags |= propagateChildFlags(node.expression) | 132096 /* ContainsComputedPropertyName */ ;
            return node;
        }
        function updateComputedPropertyName(node, expression) {
            return node.expression !== expression ? update(createComputedPropertyName(expression), node) : node;
        }
        function createTypeParameterDeclaration(modifiers, name, constraint, defaultType) {
            const node = createBaseDeclaration(167 /* TypeParameter */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.constraint = constraint;
            node.default = defaultType;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.expression = void 0;
            node.jsDoc = void 0;
            return node;
        }
        function updateTypeParameterDeclaration(node, modifiers, name, constraint, defaultType) {
            return node.modifiers !== modifiers || node.name !== name || node.constraint !== constraint || node.default !== defaultType ? update(createTypeParameterDeclaration(modifiers, name, constraint, defaultType), node) : node;
        }
        function createParameterDeclaration(modifiers, dotDotDotToken, name, questionToken, type, initializer) {
            const node = createBaseDeclaration(168 /* Parameter */ );
            node.modifiers = asNodeArray(modifiers);
            node.dotDotDotToken = dotDotDotToken;
            node.name = asName(name);
            node.questionToken = questionToken;
            node.type = type;
            node.initializer = asInitializer(initializer);
            if (isThisIdentifier(node.name)) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.dotDotDotToken) | propagateNameFlags(node.name) | propagateChildFlags(node.questionToken) | propagateChildFlags(node.initializer) | (node.questionToken ?? node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | (node.dotDotDotToken ?? node.initializer ? 1024 /* ContainsES2015 */  : 0 /* None */ ) | (modifiersToFlags(node.modifiers) & 16476 /* ParameterPropertyModifier */  ? 8192 /* ContainsTypeScriptClassSyntax */  : 0 /* None */ );
            node.jsDoc = void 0;
            return node;
        }
        function updateParameterDeclaration(node, modifiers, dotDotDotToken, name, questionToken, type, initializer) {
            return node.modifiers !== modifiers || node.dotDotDotToken !== dotDotDotToken || node.name !== name || node.questionToken !== questionToken || node.type !== type || node.initializer !== initializer ? update(createParameterDeclaration(modifiers, dotDotDotToken, name, questionToken, type, initializer), node) : node;
        }
        function createDecorator(expression) {
            const node = createBaseNode(169 /* Decorator */ );
            node.expression = parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false);
            node.transformFlags |= propagateChildFlags(node.expression) | 33562625 /* ContainsDecorators */ ;
            return node;
        }
        function updateDecorator(node, expression) {
            return node.expression !== expression ? update(createDecorator(expression), node) : node;
        }
        function createPropertySignature(modifiers, name, questionToken, type) {
            const node = createBaseDeclaration(170 /* PropertySignature */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.type = type;
            node.questionToken = questionToken;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.initializer = void 0;
            node.jsDoc = void 0;
            return node;
        }
        function updatePropertySignature(node, modifiers, name, questionToken, type) {
            return node.modifiers !== modifiers || node.name !== name || node.questionToken !== questionToken || node.type !== type ? finishUpdatePropertySignature(createPropertySignature(modifiers, name, questionToken, type), node) : node;
        }
        function finishUpdatePropertySignature(updated, original) {
            if (updated !== original) updated.initializer = original.initializer;
            return update(updated, original);
        }
        function createPropertyDeclaration(modifiers, name, questionOrExclamationToken, type, initializer) {
            const node = createBaseDeclaration(171 /* PropertyDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.questionToken = questionOrExclamationToken && isQuestionToken(questionOrExclamationToken) ? questionOrExclamationToken : void 0;
            node.exclamationToken = questionOrExclamationToken && isExclamationToken(questionOrExclamationToken) ? questionOrExclamationToken : void 0;
            node.type = type;
            node.initializer = asInitializer(initializer);
            const isAmbient = node.flags & 16777216 /* Ambient */  || modifiersToFlags(node.modifiers) & 2 /* Ambient */ ;
            node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateNameFlags(node.name) | propagateChildFlags(node.initializer) | (isAmbient || node.questionToken || node.exclamationToken || node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | (isComputedPropertyName(node.name) || modifiersToFlags(node.modifiers) & 32 /* Static */  && node.initializer ? 8192 /* ContainsTypeScriptClassSyntax */  : 0 /* None */ ) | 16777216 /* ContainsClassFields */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updatePropertyDeclaration2(node, modifiers, name, questionOrExclamationToken, type, initializer) {
            return node.modifiers !== modifiers || node.name !== name || node.questionToken !== (questionOrExclamationToken !== void 0 && isQuestionToken(questionOrExclamationToken) ? questionOrExclamationToken : void 0) || node.exclamationToken !== (questionOrExclamationToken !== void 0 && isExclamationToken(questionOrExclamationToken) ? questionOrExclamationToken : void 0) || node.type !== type || node.initializer !== initializer ? update(createPropertyDeclaration(modifiers, name, questionOrExclamationToken, type, initializer), node) : node;
        }
        function createMethodSignature(modifiers, name, questionToken, typeParameters, parameters, type) {
            const node = createBaseDeclaration(172 /* MethodSignature */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.questionToken = questionToken;
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateMethodSignature(node, modifiers, name, questionToken, typeParameters, parameters, type) {
            return node.modifiers !== modifiers || node.name !== name || node.questionToken !== questionToken || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? finishUpdateBaseSignatureDeclaration(createMethodSignature(modifiers, name, questionToken, typeParameters, parameters, type), node) : node;
        }
        function createMethodDeclaration(modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body) {
            const node = createBaseDeclaration(173 /* MethodDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.asteriskToken = asteriskToken;
            node.name = asName(name);
            node.questionToken = questionToken;
            node.exclamationToken = void 0;
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.body = body;
            if (!node.body) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else {
                const isAsync = modifiersToFlags(node.modifiers) & 512 /* Async */ ;
                const isGenerator = !!node.asteriskToken;
                const isAsyncGenerator = isAsync && isGenerator;
                node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.asteriskToken) | propagateNameFlags(node.name) | propagateChildFlags(node.questionToken) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.type) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (isAsyncGenerator ? 128 /* ContainsES2018 */  : isAsync ? 256 /* ContainsES2017 */  : isGenerator ? 2048 /* ContainsGenerator */  : 0 /* None */ ) | (node.questionToken || node.typeParameters || node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | 1024 /* ContainsES2015 */ ;
            }
            node.typeArguments = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateMethodDeclaration(node, modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body) {
            return node.modifiers !== modifiers || node.asteriskToken !== asteriskToken || node.name !== name || node.questionToken !== questionToken || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type || node.body !== body ? finishUpdateMethodDeclaration(createMethodDeclaration(modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body), node) : node;
        }
        function finishUpdateMethodDeclaration(updated, original) {
            if (updated !== original) updated.exclamationToken = original.exclamationToken;
            return update(updated, original);
        }
        function createClassStaticBlockDeclaration(body) {
            const node = createBaseDeclaration(174 /* ClassStaticBlockDeclaration */ );
            node.body = body;
            node.transformFlags = propagateChildFlags(body) | 16777216 /* ContainsClassFields */ ;
            node.modifiers = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateClassStaticBlockDeclaration(node, body) {
            return node.body !== body ? finishUpdateClassStaticBlockDeclaration(createClassStaticBlockDeclaration(body), node) : node;
        }
        function finishUpdateClassStaticBlockDeclaration(updated, original) {
            if (updated !== original) updated.modifiers = original.modifiers;
            return update(updated, original);
        }
        function createConstructorDeclaration(modifiers, parameters, body) {
            const node = createBaseDeclaration(175 /* Constructor */ );
            node.modifiers = asNodeArray(modifiers);
            node.parameters = createNodeArray(parameters);
            node.body = body;
            node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | 1024 /* ContainsES2015 */ ;
            node.typeParameters = void 0;
            node.type = void 0;
            node.typeArguments = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateConstructorDeclaration(node, modifiers, parameters, body) {
            return node.modifiers !== modifiers || node.parameters !== parameters || node.body !== body ? finishUpdateConstructorDeclaration(createConstructorDeclaration(modifiers, parameters, body), node) : node;
        }
        function finishUpdateConstructorDeclaration(updated, original) {
            if (updated !== original) {
                updated.typeParameters = original.typeParameters;
                updated.type = original.type;
            }
            return finishUpdateBaseSignatureDeclaration(updated, original);
        }
        function createGetAccessorDeclaration(modifiers, name, parameters, type, body) {
            const node = createBaseDeclaration(176 /* GetAccessor */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.body = body;
            if (!node.body) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateNameFlags(node.name) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.type) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ );
            node.typeArguments = void 0;
            node.typeParameters = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateGetAccessorDeclaration(node, modifiers, name, parameters, type, body) {
            return node.modifiers !== modifiers || node.name !== name || node.parameters !== parameters || node.type !== type || node.body !== body ? finishUpdateGetAccessorDeclaration(createGetAccessorDeclaration(modifiers, name, parameters, type, body), node) : node;
        }
        function finishUpdateGetAccessorDeclaration(updated, original) {
            if (updated !== original) updated.typeParameters = original.typeParameters;
            return finishUpdateBaseSignatureDeclaration(updated, original);
        }
        function createSetAccessorDeclaration(modifiers, name, parameters, body) {
            const node = createBaseDeclaration(177 /* SetAccessor */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.parameters = createNodeArray(parameters);
            node.body = body;
            if (!node.body) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateNameFlags(node.name) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ );
            node.typeArguments = void 0;
            node.typeParameters = void 0;
            node.type = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateSetAccessorDeclaration(node, modifiers, name, parameters, body) {
            return node.modifiers !== modifiers || node.name !== name || node.parameters !== parameters || node.body !== body ? finishUpdateSetAccessorDeclaration(createSetAccessorDeclaration(modifiers, name, parameters, body), node) : node;
        }
        function finishUpdateSetAccessorDeclaration(updated, original) {
            if (updated !== original) {
                updated.typeParameters = original.typeParameters;
                updated.type = original.type;
            }
            return finishUpdateBaseSignatureDeclaration(updated, original);
        }
        function createCallSignature(typeParameters, parameters, type) {
            const node = createBaseDeclaration(178 /* CallSignature */ );
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateCallSignature(node, typeParameters, parameters, type) {
            return node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? finishUpdateBaseSignatureDeclaration(createCallSignature(typeParameters, parameters, type), node) : node;
        }
        function createConstructSignature(typeParameters, parameters, type) {
            const node = createBaseDeclaration(179 /* ConstructSignature */ );
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateConstructSignature(node, typeParameters, parameters, type) {
            return node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? finishUpdateBaseSignatureDeclaration(createConstructSignature(typeParameters, parameters, type), node) : node;
        }
        function createIndexSignature(modifiers, parameters, type) {
            const node = createBaseDeclaration(180 /* IndexSignature */ );
            node.modifiers = asNodeArray(modifiers);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateIndexSignature(node, modifiers, parameters, type) {
            return node.parameters !== parameters || node.type !== type || node.modifiers !== modifiers ? finishUpdateBaseSignatureDeclaration(createIndexSignature(modifiers, parameters, type), node) : node;
        }
        function createTemplateLiteralTypeSpan(type, literal) {
            const node = createBaseNode(203 /* TemplateLiteralTypeSpan */ );
            node.type = type;
            node.literal = literal;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTemplateLiteralTypeSpan(node, type, literal) {
            return node.type !== type || node.literal !== literal ? update(createTemplateLiteralTypeSpan(type, literal), node) : node;
        }
        function createKeywordTypeNode(kind) {
            return createToken(kind);
        }
        function createTypePredicateNode(assertsModifier, parameterName, type) {
            const node = createBaseNode(181 /* TypePredicate */ );
            node.assertsModifier = assertsModifier;
            node.parameterName = asName(parameterName);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypePredicateNode(node, assertsModifier, parameterName, type) {
            return node.assertsModifier !== assertsModifier || node.parameterName !== parameterName || node.type !== type ? update(createTypePredicateNode(assertsModifier, parameterName, type), node) : node;
        }
        function createTypeReferenceNode(typeName, typeArguments) {
            const node = createBaseNode(182 /* TypeReference */ );
            node.typeName = asName(typeName);
            node.typeArguments = typeArguments && parenthesizerRules().parenthesizeTypeArguments(createNodeArray(typeArguments));
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypeReferenceNode(node, typeName, typeArguments) {
            return node.typeName !== typeName || node.typeArguments !== typeArguments ? update(createTypeReferenceNode(typeName, typeArguments), node) : node;
        }
        function createFunctionTypeNode(typeParameters, parameters, type) {
            const node = createBaseDeclaration(183 /* FunctionType */ );
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.modifiers = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateFunctionTypeNode(node, typeParameters, parameters, type) {
            return node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? finishUpdateFunctionTypeNode(createFunctionTypeNode(typeParameters, parameters, type), node) : node;
        }
        function finishUpdateFunctionTypeNode(updated, original) {
            if (updated !== original) updated.modifiers = original.modifiers;
            return finishUpdateBaseSignatureDeclaration(updated, original);
        }
        function createConstructorTypeNode(...args) {
            return args.length === 4 ? createConstructorTypeNode1(...args) : args.length === 3 ? createConstructorTypeNode2(...args) : Debug.fail("Incorrect number of arguments specified.");
        }
        function createConstructorTypeNode1(modifiers, typeParameters, parameters, type) {
            const node = createBaseDeclaration(184 /* ConstructorType */ );
            node.modifiers = asNodeArray(modifiers);
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function createConstructorTypeNode2(typeParameters, parameters, type) {
            return createConstructorTypeNode1(/*modifiers*/ void 0, typeParameters, parameters, type);
        }
        function updateConstructorTypeNode(...args) {
            return args.length === 5 ? updateConstructorTypeNode1(...args) : args.length === 4 ? updateConstructorTypeNode2(...args) : Debug.fail("Incorrect number of arguments specified.");
        }
        function updateConstructorTypeNode1(node, modifiers, typeParameters, parameters, type) {
            return node.modifiers !== modifiers || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? finishUpdateBaseSignatureDeclaration(createConstructorTypeNode(modifiers, typeParameters, parameters, type), node) : node;
        }
        function updateConstructorTypeNode2(node, typeParameters, parameters, type) {
            return updateConstructorTypeNode1(node, node.modifiers, typeParameters, parameters, type);
        }
        function createTypeQueryNode(exprName, typeArguments) {
            const node = createBaseNode(185 /* TypeQuery */ );
            node.exprName = exprName;
            node.typeArguments = typeArguments && parenthesizerRules().parenthesizeTypeArguments(typeArguments);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypeQueryNode(node, exprName, typeArguments) {
            return node.exprName !== exprName || node.typeArguments !== typeArguments ? update(createTypeQueryNode(exprName, typeArguments), node) : node;
        }
        function createTypeLiteralNode(members) {
            const node = createBaseDeclaration(186 /* TypeLiteral */ );
            node.members = createNodeArray(members);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypeLiteralNode(node, members) {
            return node.members !== members ? update(createTypeLiteralNode(members), node) : node;
        }
        function createArrayTypeNode(elementType) {
            const node = createBaseNode(187 /* ArrayType */ );
            node.elementType = parenthesizerRules().parenthesizeNonArrayTypeOfPostfixType(elementType);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateArrayTypeNode(node, elementType) {
            return node.elementType !== elementType ? update(createArrayTypeNode(elementType), node) : node;
        }
        function createTupleTypeNode(elements) {
            const node = createBaseNode(188 /* TupleType */ );
            node.elements = createNodeArray(parenthesizerRules().parenthesizeElementTypesOfTupleType(elements));
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTupleTypeNode(node, elements) {
            return node.elements !== elements ? update(createTupleTypeNode(elements), node) : node;
        }
        function createNamedTupleMember(dotDotDotToken, name, questionToken, type) {
            const node = createBaseDeclaration(201 /* NamedTupleMember */ );
            node.dotDotDotToken = dotDotDotToken;
            node.name = name;
            node.questionToken = questionToken;
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateNamedTupleMember(node, dotDotDotToken, name, questionToken, type) {
            return node.dotDotDotToken !== dotDotDotToken || node.name !== name || node.questionToken !== questionToken || node.type !== type ? update(createNamedTupleMember(dotDotDotToken, name, questionToken, type), node) : node;
        }
        function createOptionalTypeNode(type) {
            const node = createBaseNode(189 /* OptionalType */ );
            node.type = parenthesizerRules().parenthesizeTypeOfOptionalType(type);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateOptionalTypeNode(node, type) {
            return node.type !== type ? update(createOptionalTypeNode(type), node) : node;
        }
        function createRestTypeNode(type) {
            const node = createBaseNode(190 /* RestType */ );
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateRestTypeNode(node, type) {
            return node.type !== type ? update(createRestTypeNode(type), node) : node;
        }
        function createUnionOrIntersectionTypeNode(kind, types, parenthesize) {
            const node = createBaseNode(kind);
            node.types = factory2.createNodeArray(parenthesize(types));
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateUnionOrIntersectionTypeNode(node, types, parenthesize) {
            return node.types !== types ? update(createUnionOrIntersectionTypeNode(node.kind, types, parenthesize), node) : node;
        }
        function createUnionTypeNode(types) {
            return createUnionOrIntersectionTypeNode(191 /* UnionType */ , types, parenthesizerRules().parenthesizeConstituentTypesOfUnionType);
        }
        function updateUnionTypeNode(node, types) {
            return updateUnionOrIntersectionTypeNode(node, types, parenthesizerRules().parenthesizeConstituentTypesOfUnionType);
        }
        function createIntersectionTypeNode(types) {
            return createUnionOrIntersectionTypeNode(192 /* IntersectionType */ , types, parenthesizerRules().parenthesizeConstituentTypesOfIntersectionType);
        }
        function updateIntersectionTypeNode(node, types) {
            return updateUnionOrIntersectionTypeNode(node, types, parenthesizerRules().parenthesizeConstituentTypesOfIntersectionType);
        }
        function createConditionalTypeNode(checkType, extendsType, trueType, falseType) {
            const node = createBaseNode(193 /* ConditionalType */ );
            node.checkType = parenthesizerRules().parenthesizeCheckTypeOfConditionalType(checkType);
            node.extendsType = parenthesizerRules().parenthesizeExtendsTypeOfConditionalType(extendsType);
            node.trueType = trueType;
            node.falseType = falseType;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateConditionalTypeNode(node, checkType, extendsType, trueType, falseType) {
            return node.checkType !== checkType || node.extendsType !== extendsType || node.trueType !== trueType || node.falseType !== falseType ? update(createConditionalTypeNode(checkType, extendsType, trueType, falseType), node) : node;
        }
        function createInferTypeNode(typeParameter) {
            const node = createBaseNode(194 /* InferType */ );
            node.typeParameter = typeParameter;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateInferTypeNode(node, typeParameter) {
            return node.typeParameter !== typeParameter ? update(createInferTypeNode(typeParameter), node) : node;
        }
        function createTemplateLiteralType(head, templateSpans) {
            const node = createBaseNode(202 /* TemplateLiteralType */ );
            node.head = head;
            node.templateSpans = createNodeArray(templateSpans);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTemplateLiteralType(node, head, templateSpans) {
            return node.head !== head || node.templateSpans !== templateSpans ? update(createTemplateLiteralType(head, templateSpans), node) : node;
        }
        function createImportTypeNode(argument, assertions, qualifier, typeArguments, isTypeOf = false) {
            const node = createBaseNode(204 /* ImportType */ );
            node.argument = argument;
            node.assertions = assertions;
            node.qualifier = qualifier;
            node.typeArguments = typeArguments && parenthesizerRules().parenthesizeTypeArguments(typeArguments);
            node.isTypeOf = isTypeOf;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateImportTypeNode(node, argument, assertions, qualifier, typeArguments, isTypeOf = node.isTypeOf) {
            return node.argument !== argument || node.assertions !== assertions || node.qualifier !== qualifier || node.typeArguments !== typeArguments || node.isTypeOf !== isTypeOf ? update(createImportTypeNode(argument, assertions, qualifier, typeArguments, isTypeOf), node) : node;
        }
        function createParenthesizedType(type) {
            const node = createBaseNode(195 /* ParenthesizedType */ );
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateParenthesizedType(node, type) {
            return node.type !== type ? update(createParenthesizedType(type), node) : node;
        }
        function createThisTypeNode() {
            const node = createBaseNode(196 /* ThisType */ );
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function createTypeOperatorNode(operator, type) {
            const node = createBaseNode(197 /* TypeOperator */ );
            node.operator = operator;
            node.type = operator === 148 /* ReadonlyKeyword */  ? parenthesizerRules().parenthesizeOperandOfReadonlyTypeOperator(type) : parenthesizerRules().parenthesizeOperandOfTypeOperator(type);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypeOperatorNode(node, type) {
            return node.type !== type ? update(createTypeOperatorNode(node.operator, type), node) : node;
        }
        function createIndexedAccessTypeNode(objectType, indexType) {
            const node = createBaseNode(198 /* IndexedAccessType */ );
            node.objectType = parenthesizerRules().parenthesizeNonArrayTypeOfPostfixType(objectType);
            node.indexType = indexType;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateIndexedAccessTypeNode(node, objectType, indexType) {
            return node.objectType !== objectType || node.indexType !== indexType ? update(createIndexedAccessTypeNode(objectType, indexType), node) : node;
        }
        function createMappedTypeNode(readonlyToken, typeParameter, nameType, questionToken, type, members) {
            const node = createBaseDeclaration(199 /* MappedType */ );
            node.readonlyToken = readonlyToken;
            node.typeParameter = typeParameter;
            node.nameType = nameType;
            node.questionToken = questionToken;
            node.type = type;
            node.members = members && createNodeArray(members);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateMappedTypeNode(node, readonlyToken, typeParameter, nameType, questionToken, type, members) {
            return node.readonlyToken !== readonlyToken || node.typeParameter !== typeParameter || node.nameType !== nameType || node.questionToken !== questionToken || node.type !== type || node.members !== members ? update(createMappedTypeNode(readonlyToken, typeParameter, nameType, questionToken, type, members), node) : node;
        }
        function createLiteralTypeNode(literal) {
            const node = createBaseNode(200 /* LiteralType */ );
            node.literal = literal;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateLiteralTypeNode(node, literal) {
            return node.literal !== literal ? update(createLiteralTypeNode(literal), node) : node;
        }
        function createObjectBindingPattern(elements) {
            const node = createBaseNode(205 /* ObjectBindingPattern */ );
            node.elements = createNodeArray(elements);
            node.transformFlags |= propagateChildrenFlags(node.elements) | 525312 /* ContainsBindingPattern */ ;
            if (node.transformFlags & 32768 /* ContainsRestOrSpread */ ) node.transformFlags |= 65664 /* ContainsObjectRestOrSpread */ ;
            return node;
        }
        function updateObjectBindingPattern(node, elements) {
            return node.elements !== elements ? update(createObjectBindingPattern(elements), node) : node;
        }
        function createArrayBindingPattern(elements) {
            const node = createBaseNode(206 /* ArrayBindingPattern */ );
            node.elements = createNodeArray(elements);
            node.transformFlags |= propagateChildrenFlags(node.elements) | 525312 /* ContainsBindingPattern */ ;
            return node;
        }
        function updateArrayBindingPattern(node, elements) {
            return node.elements !== elements ? update(createArrayBindingPattern(elements), node) : node;
        }
        function createBindingElement(dotDotDotToken, propertyName, name, initializer) {
            const node = createBaseDeclaration(207 /* BindingElement */ );
            node.dotDotDotToken = dotDotDotToken;
            node.propertyName = asName(propertyName);
            node.name = asName(name);
            node.initializer = asInitializer(initializer);
            node.transformFlags |= propagateChildFlags(node.dotDotDotToken) | propagateNameFlags(node.propertyName) | propagateNameFlags(node.name) | propagateChildFlags(node.initializer) | (node.dotDotDotToken ? 32768 /* ContainsRestOrSpread */  : 0 /* None */ ) | 1024 /* ContainsES2015 */ ;
            node.flowNode = void 0;
            return node;
        }
        function updateBindingElement(node, dotDotDotToken, propertyName, name, initializer) {
            return node.propertyName !== propertyName || node.dotDotDotToken !== dotDotDotToken || node.name !== name || node.initializer !== initializer ? update(createBindingElement(dotDotDotToken, propertyName, name, initializer), node) : node;
        }
        function createArrayLiteralExpression(elements, multiLine) {
            const node = createBaseNode(208 /* ArrayLiteralExpression */ );
            const lastElement = elements && lastOrUndefined(elements);
            const elementsArray = createNodeArray(elements, lastElement && isOmittedExpression(lastElement) ? true : void 0);
            node.elements = parenthesizerRules().parenthesizeExpressionsOfCommaDelimitedList(elementsArray);
            node.multiLine = multiLine;
            node.transformFlags |= propagateChildrenFlags(node.elements);
            return node;
        }
        function updateArrayLiteralExpression(node, elements) {
            return node.elements !== elements ? update(createArrayLiteralExpression(elements, node.multiLine), node) : node;
        }
        function createObjectLiteralExpression(properties, multiLine) {
            const node = createBaseDeclaration(209 /* ObjectLiteralExpression */ );
            node.properties = createNodeArray(properties);
            node.multiLine = multiLine;
            node.transformFlags |= propagateChildrenFlags(node.properties);
            node.jsDoc = void 0;
            return node;
        }
        function updateObjectLiteralExpression(node, properties) {
            return node.properties !== properties ? update(createObjectLiteralExpression(properties, node.multiLine), node) : node;
        }
        function createBasePropertyAccessExpression(expression, questionDotToken, name) {
            const node = createBaseDeclaration(210 /* PropertyAccessExpression */ );
            node.expression = expression;
            node.questionDotToken = questionDotToken;
            node.name = name;
            node.transformFlags = propagateChildFlags(node.expression) | propagateChildFlags(node.questionDotToken) | (isIdentifier(node.name) ? propagateIdentifierNameFlags(node.name) : propagateChildFlags(node.name) | 536870912 /* ContainsPrivateIdentifierInExpression */ );
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function createPropertyAccessExpression(expression, name) {
            const node = createBasePropertyAccessExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false), /*questionDotToken*/ void 0, asName(name));
            if (isSuperKeyword(expression)) node.transformFlags |= 384 /* ContainsES2018 */ ;
            return node;
        }
        function updatePropertyAccessExpression(node, expression, name) {
            if (isPropertyAccessChain(node)) return updatePropertyAccessChain(node, expression, node.questionDotToken, cast(name, isIdentifier));
            return node.expression !== expression || node.name !== name ? update(createPropertyAccessExpression(expression, name), node) : node;
        }
        function createPropertyAccessChain(expression, questionDotToken, name) {
            const node = createBasePropertyAccessExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ true), questionDotToken, asName(name));
            node.flags |= 32 /* OptionalChain */ ;
            node.transformFlags |= 32 /* ContainsES2020 */ ;
            return node;
        }
        function updatePropertyAccessChain(node, expression, questionDotToken, name) {
            Debug.assert(!!(node.flags & 32 /* OptionalChain */ ), "Cannot update a PropertyAccessExpression using updatePropertyAccessChain. Use updatePropertyAccess instead.");
            return node.expression !== expression || node.questionDotToken !== questionDotToken || node.name !== name ? update(createPropertyAccessChain(expression, questionDotToken, name), node) : node;
        }
        function createBaseElementAccessExpression(expression, questionDotToken, argumentExpression) {
            const node = createBaseDeclaration(211 /* ElementAccessExpression */ );
            node.expression = expression;
            node.questionDotToken = questionDotToken;
            node.argumentExpression = argumentExpression;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.questionDotToken) | propagateChildFlags(node.argumentExpression);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function createElementAccessExpression(expression, index) {
            const node = createBaseElementAccessExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false), /*questionDotToken*/ void 0, asExpression(index));
            if (isSuperKeyword(expression)) node.transformFlags |= 384 /* ContainsES2018 */ ;
            return node;
        }
        function updateElementAccessExpression(node, expression, argumentExpression) {
            if (isElementAccessChain(node)) return updateElementAccessChain(node, expression, node.questionDotToken, argumentExpression);
            return node.expression !== expression || node.argumentExpression !== argumentExpression ? update(createElementAccessExpression(expression, argumentExpression), node) : node;
        }
        function createElementAccessChain(expression, questionDotToken, index) {
            const node = createBaseElementAccessExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ true), questionDotToken, asExpression(index));
            node.flags |= 32 /* OptionalChain */ ;
            node.transformFlags |= 32 /* ContainsES2020 */ ;
            return node;
        }
        function updateElementAccessChain(node, expression, questionDotToken, argumentExpression) {
            Debug.assert(!!(node.flags & 32 /* OptionalChain */ ), "Cannot update a ElementAccessExpression using updateElementAccessChain. Use updateElementAccess instead.");
            return node.expression !== expression || node.questionDotToken !== questionDotToken || node.argumentExpression !== argumentExpression ? update(createElementAccessChain(expression, questionDotToken, argumentExpression), node) : node;
        }
        function createBaseCallExpression(expression, questionDotToken, typeArguments, argumentsArray) {
            const node = createBaseDeclaration(212 /* CallExpression */ );
            node.expression = expression;
            node.questionDotToken = questionDotToken;
            node.typeArguments = typeArguments;
            node.arguments = argumentsArray;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.questionDotToken) | propagateChildrenFlags(node.typeArguments) | propagateChildrenFlags(node.arguments);
            if (node.typeArguments) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            if (isSuperProperty(node.expression)) node.transformFlags |= 16384 /* ContainsLexicalThis */ ;
            return node;
        }
        function createCallExpression(expression, typeArguments, argumentsArray) {
            const node = createBaseCallExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false), /*questionDotToken*/ void 0, asNodeArray(typeArguments), parenthesizerRules().parenthesizeExpressionsOfCommaDelimitedList(createNodeArray(argumentsArray)));
            if (isImportKeyword(node.expression)) node.transformFlags |= 8388608 /* ContainsDynamicImport */ ;
            return node;
        }
        function updateCallExpression(node, expression, typeArguments, argumentsArray) {
            if (isCallChain(node)) return updateCallChain(node, expression, node.questionDotToken, typeArguments, argumentsArray);
            return node.expression !== expression || node.typeArguments !== typeArguments || node.arguments !== argumentsArray ? update(createCallExpression(expression, typeArguments, argumentsArray), node) : node;
        }
        function createCallChain(expression, questionDotToken, typeArguments, argumentsArray) {
            const node = createBaseCallExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ true), questionDotToken, asNodeArray(typeArguments), parenthesizerRules().parenthesizeExpressionsOfCommaDelimitedList(createNodeArray(argumentsArray)));
            node.flags |= 32 /* OptionalChain */ ;
            node.transformFlags |= 32 /* ContainsES2020 */ ;
            return node;
        }
        function updateCallChain(node, expression, questionDotToken, typeArguments, argumentsArray) {
            Debug.assert(!!(node.flags & 32 /* OptionalChain */ ), "Cannot update a CallExpression using updateCallChain. Use updateCall instead.");
            return node.expression !== expression || node.questionDotToken !== questionDotToken || node.typeArguments !== typeArguments || node.arguments !== argumentsArray ? update(createCallChain(expression, questionDotToken, typeArguments, argumentsArray), node) : node;
        }
        function createNewExpression(expression, typeArguments, argumentsArray) {
            const node = createBaseDeclaration(213 /* NewExpression */ );
            node.expression = parenthesizerRules().parenthesizeExpressionOfNew(expression);
            node.typeArguments = asNodeArray(typeArguments);
            node.arguments = argumentsArray ? parenthesizerRules().parenthesizeExpressionsOfCommaDelimitedList(argumentsArray) : void 0;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildrenFlags(node.typeArguments) | propagateChildrenFlags(node.arguments) | 32 /* ContainsES2020 */ ;
            if (node.typeArguments) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateNewExpression(node, expression, typeArguments, argumentsArray) {
            return node.expression !== expression || node.typeArguments !== typeArguments || node.arguments !== argumentsArray ? update(createNewExpression(expression, typeArguments, argumentsArray), node) : node;
        }
        function createTaggedTemplateExpression(tag, typeArguments, template) {
            const node = createBaseNode(214 /* TaggedTemplateExpression */ );
            node.tag = parenthesizerRules().parenthesizeLeftSideOfAccess(tag, /*optionalChain*/ false);
            node.typeArguments = asNodeArray(typeArguments);
            node.template = template;
            node.transformFlags |= propagateChildFlags(node.tag) | propagateChildrenFlags(node.typeArguments) | propagateChildFlags(node.template) | 1024 /* ContainsES2015 */ ;
            if (node.typeArguments) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            if (hasInvalidEscape(node.template)) node.transformFlags |= 128 /* ContainsES2018 */ ;
            return node;
        }
        function updateTaggedTemplateExpression(node, tag, typeArguments, template) {
            return node.tag !== tag || node.typeArguments !== typeArguments || node.template !== template ? update(createTaggedTemplateExpression(tag, typeArguments, template), node) : node;
        }
        function createTypeAssertion(type, expression) {
            const node = createBaseNode(215 /* TypeAssertionExpression */ );
            node.expression = parenthesizerRules().parenthesizeOperandOfPrefixUnary(expression);
            node.type = type;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.type) | 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypeAssertion(node, type, expression) {
            return node.type !== type || node.expression !== expression ? update(createTypeAssertion(type, expression), node) : node;
        }
        function createParenthesizedExpression(expression) {
            const node = createBaseNode(216 /* ParenthesizedExpression */ );
            node.expression = expression;
            node.transformFlags = propagateChildFlags(node.expression);
            node.jsDoc = void 0;
            return node;
        }
        function updateParenthesizedExpression(node, expression) {
            return node.expression !== expression ? update(createParenthesizedExpression(expression), node) : node;
        }
        function createFunctionExpression(modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
            const node = createBaseDeclaration(217 /* FunctionExpression */ );
            node.modifiers = asNodeArray(modifiers);
            node.asteriskToken = asteriskToken;
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.body = body;
            const isAsync = modifiersToFlags(node.modifiers) & 512 /* Async */ ;
            const isGenerator = !!node.asteriskToken;
            const isAsyncGenerator = isAsync && isGenerator;
            node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.asteriskToken) | propagateNameFlags(node.name) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.type) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (isAsyncGenerator ? 128 /* ContainsES2018 */  : isAsync ? 256 /* ContainsES2017 */  : isGenerator ? 2048 /* ContainsGenerator */  : 0 /* None */ ) | (node.typeParameters || node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | 4194304 /* ContainsHoistedDeclarationOrCompletion */ ;
            node.typeArguments = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateFunctionExpression(node, modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
            return node.name !== name || node.modifiers !== modifiers || node.asteriskToken !== asteriskToken || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type || node.body !== body ? finishUpdateBaseSignatureDeclaration(createFunctionExpression(modifiers, asteriskToken, name, typeParameters, parameters, type, body), node) : node;
        }
        function createArrowFunction(modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body) {
            const node = createBaseDeclaration(218 /* ArrowFunction */ );
            node.modifiers = asNodeArray(modifiers);
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.equalsGreaterThanToken = equalsGreaterThanToken ?? createToken(39 /* EqualsGreaterThanToken */ );
            node.body = parenthesizerRules().parenthesizeConciseBodyOfArrowFunction(body);
            const isAsync = modifiersToFlags(node.modifiers) & 512 /* Async */ ;
            node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.type) | propagateChildFlags(node.equalsGreaterThanToken) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (node.typeParameters || node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | (isAsync ? 16640 /* ContainsLexicalThis */  : 0 /* None */ ) | 1024 /* ContainsES2015 */ ;
            node.typeArguments = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateArrowFunction(node, modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body) {
            return node.modifiers !== modifiers || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type || node.equalsGreaterThanToken !== equalsGreaterThanToken || node.body !== body ? finishUpdateBaseSignatureDeclaration(createArrowFunction(modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body), node) : node;
        }
        function createDeleteExpression(expression) {
            const node = createBaseNode(219 /* DeleteExpression */ );
            node.expression = parenthesizerRules().parenthesizeOperandOfPrefixUnary(expression);
            node.transformFlags |= propagateChildFlags(node.expression);
            return node;
        }
        function updateDeleteExpression(node, expression) {
            return node.expression !== expression ? update(createDeleteExpression(expression), node) : node;
        }
        function createTypeOfExpression(expression) {
            const node = createBaseNode(220 /* TypeOfExpression */ );
            node.expression = parenthesizerRules().parenthesizeOperandOfPrefixUnary(expression);
            node.transformFlags |= propagateChildFlags(node.expression);
            return node;
        }
        function updateTypeOfExpression(node, expression) {
            return node.expression !== expression ? update(createTypeOfExpression(expression), node) : node;
        }
        function createVoidExpression(expression) {
            const node = createBaseNode(221 /* VoidExpression */ );
            node.expression = parenthesizerRules().parenthesizeOperandOfPrefixUnary(expression);
            node.transformFlags |= propagateChildFlags(node.expression);
            return node;
        }
        function updateVoidExpression(node, expression) {
            return node.expression !== expression ? update(createVoidExpression(expression), node) : node;
        }
        function createAwaitExpression(expression) {
            const node = createBaseNode(222 /* AwaitExpression */ );
            node.expression = parenthesizerRules().parenthesizeOperandOfPrefixUnary(expression);
            node.transformFlags |= propagateChildFlags(node.expression) | 2097536 /* ContainsAwait */ ;
            return node;
        }
        function updateAwaitExpression(node, expression) {
            return node.expression !== expression ? update(createAwaitExpression(expression), node) : node;
        }
        function createPrefixUnaryExpression(operator, operand) {
            const node = createBaseNode(223 /* PrefixUnaryExpression */ );
            node.operator = operator;
            node.operand = parenthesizerRules().parenthesizeOperandOfPrefixUnary(operand);
            node.transformFlags |= propagateChildFlags(node.operand);
            if ((operator === 46 /* PlusPlusToken */  || operator === 47 /* MinusMinusToken */ ) && isIdentifier(node.operand) && !isGeneratedIdentifier(node.operand) && !isLocalName(node.operand)) node.transformFlags |= 268435456 /* ContainsUpdateExpressionForIdentifier */ ;
            return node;
        }
        function updatePrefixUnaryExpression(node, operand) {
            return node.operand !== operand ? update(createPrefixUnaryExpression(node.operator, operand), node) : node;
        }
        function createPostfixUnaryExpression(operand, operator) {
            const node = createBaseNode(224 /* PostfixUnaryExpression */ );
            node.operator = operator;
            node.operand = parenthesizerRules().parenthesizeOperandOfPostfixUnary(operand);
            node.transformFlags |= propagateChildFlags(node.operand);
            if (isIdentifier(node.operand) && !isGeneratedIdentifier(node.operand) && !isLocalName(node.operand)) node.transformFlags |= 268435456 /* ContainsUpdateExpressionForIdentifier */ ;
            return node;
        }
        function updatePostfixUnaryExpression(node, operand) {
            return node.operand !== operand ? update(createPostfixUnaryExpression(operand, node.operator), node) : node;
        }
        function createBinaryExpression(left, operator, right) {
            const node = createBaseDeclaration(225 /* BinaryExpression */ );
            const operatorToken = asToken(operator);
            const operatorKind = operatorToken.kind;
            node.left = parenthesizerRules().parenthesizeLeftSideOfBinary(operatorKind, left);
            node.operatorToken = operatorToken;
            node.right = parenthesizerRules().parenthesizeRightSideOfBinary(operatorKind, node.left, right);
            node.transformFlags |= propagateChildFlags(node.left) | propagateChildFlags(node.operatorToken) | propagateChildFlags(node.right);
            if (operatorKind === 61 /* QuestionQuestionToken */ ) node.transformFlags |= 32 /* ContainsES2020 */ ;
            else if (operatorKind === 64 /* EqualsToken */ ) {
                if (isObjectLiteralExpression(node.left)) node.transformFlags |= 5248 /* ContainsDestructuringAssignment */  | propagateAssignmentPatternFlags(node.left);
                else if (isArrayLiteralExpression(node.left)) node.transformFlags |= 5120 /* ContainsDestructuringAssignment */  | propagateAssignmentPatternFlags(node.left);
            } else if (operatorKind === 43 /* AsteriskAsteriskToken */  || operatorKind === 68 /* AsteriskAsteriskEqualsToken */ ) node.transformFlags |= 512 /* ContainsES2016 */ ;
            else if (isLogicalOrCoalescingAssignmentOperator(operatorKind)) node.transformFlags |= 16 /* ContainsES2021 */ ;
            if (operatorKind === 103 /* InKeyword */  && isPrivateIdentifier(node.left)) node.transformFlags |= 536870912 /* ContainsPrivateIdentifierInExpression */ ;
            node.jsDoc = void 0;
            return node;
        }
        function propagateAssignmentPatternFlags(node) {
            return containsObjectRestOrSpread(node) ? 65536 /* ContainsObjectRestOrSpread */  : 0 /* None */ ;
        }
        function updateBinaryExpression(node, left, operator, right) {
            return node.left !== left || node.operatorToken !== operator || node.right !== right ? update(createBinaryExpression(left, operator, right), node) : node;
        }
        function createConditionalExpression(condition, questionToken, whenTrue, colonToken, whenFalse) {
            const node = createBaseNode(226 /* ConditionalExpression */ );
            node.condition = parenthesizerRules().parenthesizeConditionOfConditionalExpression(condition);
            node.questionToken = questionToken ?? createToken(58 /* QuestionToken */ );
            node.whenTrue = parenthesizerRules().parenthesizeBranchOfConditionalExpression(whenTrue);
            node.colonToken = colonToken ?? createToken(59 /* ColonToken */ );
            node.whenFalse = parenthesizerRules().parenthesizeBranchOfConditionalExpression(whenFalse);
            node.transformFlags |= propagateChildFlags(node.condition) | propagateChildFlags(node.questionToken) | propagateChildFlags(node.whenTrue) | propagateChildFlags(node.colonToken) | propagateChildFlags(node.whenFalse);
            return node;
        }
        function updateConditionalExpression(node, condition, questionToken, whenTrue, colonToken, whenFalse) {
            return node.condition !== condition || node.questionToken !== questionToken || node.whenTrue !== whenTrue || node.colonToken !== colonToken || node.whenFalse !== whenFalse ? update(createConditionalExpression(condition, questionToken, whenTrue, colonToken, whenFalse), node) : node;
        }
        function createTemplateExpression(head, templateSpans) {
            const node = createBaseNode(227 /* TemplateExpression */ );
            node.head = head;
            node.templateSpans = createNodeArray(templateSpans);
            node.transformFlags |= propagateChildFlags(node.head) | propagateChildrenFlags(node.templateSpans) | 1024 /* ContainsES2015 */ ;
            return node;
        }
        function updateTemplateExpression(node, head, templateSpans) {
            return node.head !== head || node.templateSpans !== templateSpans ? update(createTemplateExpression(head, templateSpans), node) : node;
        }
        function checkTemplateLiteralLikeNode(kind, text, rawText, templateFlags = 0 /* None */ ) {
            Debug.assert(!(templateFlags & -7177 /* TemplateLiteralLikeFlags */ ), "Unsupported template flags.");
            let cooked = void 0;
            if (rawText !== void 0 && rawText !== text) {
                cooked = getCookedText(kind, rawText);
                if (typeof cooked === "object") return Debug.fail("Invalid raw text");
            }
            if (text === void 0) {
                if (cooked === void 0) return Debug.fail("Arguments 'text' and 'rawText' may not both be undefined.");
                text = cooked;
            } else if (cooked !== void 0) Debug.assert(text === cooked, "Expected argument 'text' to be the normalized (i.e. 'cooked') version of argument 'rawText'.");
            return text;
        }
        function getTransformFlagsOfTemplateLiteralLike(templateFlags) {
            let transformFlags = 1024 /* ContainsES2015 */ ;
            if (templateFlags) transformFlags |= 128 /* ContainsES2018 */ ;
            return transformFlags;
        }
        function createTemplateLiteralLikeToken(kind, text, rawText, templateFlags) {
            const node = createBaseToken(kind);
            node.text = text;
            node.rawText = rawText;
            node.templateFlags = templateFlags & 7176 /* TemplateLiteralLikeFlags */ ;
            node.transformFlags = getTransformFlagsOfTemplateLiteralLike(node.templateFlags);
            return node;
        }
        function createTemplateLiteralLikeDeclaration(kind, text, rawText, templateFlags) {
            const node = createBaseDeclaration(kind);
            node.text = text;
            node.rawText = rawText;
            node.templateFlags = templateFlags & 7176 /* TemplateLiteralLikeFlags */ ;
            node.transformFlags = getTransformFlagsOfTemplateLiteralLike(node.templateFlags);
            return node;
        }
        function createTemplateLiteralLikeNode(kind, text, rawText, templateFlags) {
            if (kind === 15 /* NoSubstitutionTemplateLiteral */ ) return createTemplateLiteralLikeDeclaration(kind, text, rawText, templateFlags);
            return createTemplateLiteralLikeToken(kind, text, rawText, templateFlags);
        }
        function createTemplateHead(text, rawText, templateFlags) {
            text = checkTemplateLiteralLikeNode(16 /* TemplateHead */ , text, rawText, templateFlags);
            return createTemplateLiteralLikeNode(16 /* TemplateHead */ , text, rawText, templateFlags);
        }
        function createTemplateMiddle(text, rawText, templateFlags) {
            text = checkTemplateLiteralLikeNode(16 /* TemplateHead */ , text, rawText, templateFlags);
            return createTemplateLiteralLikeNode(17 /* TemplateMiddle */ , text, rawText, templateFlags);
        }
        function createTemplateTail(text, rawText, templateFlags) {
            text = checkTemplateLiteralLikeNode(16 /* TemplateHead */ , text, rawText, templateFlags);
            return createTemplateLiteralLikeNode(18 /* TemplateTail */ , text, rawText, templateFlags);
        }
        function createNoSubstitutionTemplateLiteral(text, rawText, templateFlags) {
            text = checkTemplateLiteralLikeNode(16 /* TemplateHead */ , text, rawText, templateFlags);
            return createTemplateLiteralLikeDeclaration(15 /* NoSubstitutionTemplateLiteral */ , text, rawText, templateFlags);
        }
        function createYieldExpression(asteriskToken, expression) {
            Debug.assert(!asteriskToken || !!expression, "A `YieldExpression` with an asteriskToken must have an expression.");
            const node = createBaseNode(228 /* YieldExpression */ );
            node.expression = expression && parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.asteriskToken = asteriskToken;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.asteriskToken) | 1049728 /* ContainsYield */ ;
            return node;
        }
        function updateYieldExpression(node, asteriskToken, expression) {
            return node.expression !== expression || node.asteriskToken !== asteriskToken ? update(createYieldExpression(asteriskToken, expression), node) : node;
        }
        function createSpreadElement(expression) {
            const node = createBaseNode(229 /* SpreadElement */ );
            node.expression = parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.transformFlags |= propagateChildFlags(node.expression) | 33792 /* ContainsRestOrSpread */ ;
            return node;
        }
        function updateSpreadElement(node, expression) {
            return node.expression !== expression ? update(createSpreadElement(expression), node) : node;
        }
        function createClassExpression(modifiers, name, typeParameters, heritageClauses, members) {
            const node = createBaseDeclaration(230 /* ClassExpression */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.heritageClauses = asNodeArray(heritageClauses);
            node.members = createNodeArray(members);
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateNameFlags(node.name) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.heritageClauses) | propagateChildrenFlags(node.members) | (node.typeParameters ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | 1024 /* ContainsES2015 */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateClassExpression(node, modifiers, name, typeParameters, heritageClauses, members) {
            return node.modifiers !== modifiers || node.name !== name || node.typeParameters !== typeParameters || node.heritageClauses !== heritageClauses || node.members !== members ? update(createClassExpression(modifiers, name, typeParameters, heritageClauses, members), node) : node;
        }
        function createOmittedExpression() {
            return createBaseNode(231 /* OmittedExpression */ );
        }
        function createExpressionWithTypeArguments(expression, typeArguments) {
            const node = createBaseNode(232 /* ExpressionWithTypeArguments */ );
            node.expression = parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false);
            node.typeArguments = typeArguments && parenthesizerRules().parenthesizeTypeArguments(typeArguments);
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildrenFlags(node.typeArguments) | 1024 /* ContainsES2015 */ ;
            return node;
        }
        function updateExpressionWithTypeArguments(node, expression, typeArguments) {
            return node.expression !== expression || node.typeArguments !== typeArguments ? update(createExpressionWithTypeArguments(expression, typeArguments), node) : node;
        }
        function createAsExpression(expression, type) {
            const node = createBaseNode(233 /* AsExpression */ );
            node.expression = expression;
            node.type = type;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.type) | 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateAsExpression(node, expression, type) {
            return node.expression !== expression || node.type !== type ? update(createAsExpression(expression, type), node) : node;
        }
        function createNonNullExpression(expression) {
            const node = createBaseNode(234 /* NonNullExpression */ );
            node.expression = parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false);
            node.transformFlags |= propagateChildFlags(node.expression) | 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateNonNullExpression(node, expression) {
            if (isNonNullChain(node)) return updateNonNullChain(node, expression);
            return node.expression !== expression ? update(createNonNullExpression(expression), node) : node;
        }
        function createSatisfiesExpression(expression, type) {
            const node = createBaseNode(237 /* SatisfiesExpression */ );
            node.expression = expression;
            node.type = type;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.type) | 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateSatisfiesExpression(node, expression, type) {
            return node.expression !== expression || node.type !== type ? update(createSatisfiesExpression(expression, type), node) : node;
        }
        function createNonNullChain(expression) {
            const node = createBaseNode(234 /* NonNullExpression */ );
            node.flags |= 32 /* OptionalChain */ ;
            node.expression = parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ true);
            node.transformFlags |= propagateChildFlags(node.expression) | 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateNonNullChain(node, expression) {
            Debug.assert(!!(node.flags & 32 /* OptionalChain */ ), "Cannot update a NonNullExpression using updateNonNullChain. Use updateNonNullExpression instead.");
            return node.expression !== expression ? update(createNonNullChain(expression), node) : node;
        }
        function createMetaProperty(keywordToken, name) {
            const node = createBaseNode(235 /* MetaProperty */ );
            node.keywordToken = keywordToken;
            node.name = name;
            node.transformFlags |= propagateChildFlags(node.name);
            switch(keywordToken){
                case 105 /* NewKeyword */ :
                    node.transformFlags |= 1024 /* ContainsES2015 */ ;
                    break;
                case 102 /* ImportKeyword */ :
                    node.transformFlags |= 32 /* ContainsES2020 */ ;
                    break;
                default:
                    return Debug.assertNever(keywordToken);
            }
            node.flowNode = void 0;
            return node;
        }
        function updateMetaProperty(node, name) {
            return node.name !== name ? update(createMetaProperty(node.keywordToken, name), node) : node;
        }
        function createTemplateSpan(expression, literal) {
            const node = createBaseNode(238 /* TemplateSpan */ );
            node.expression = expression;
            node.literal = literal;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.literal) | 1024 /* ContainsES2015 */ ;
            return node;
        }
        function updateTemplateSpan(node, expression, literal) {
            return node.expression !== expression || node.literal !== literal ? update(createTemplateSpan(expression, literal), node) : node;
        }
        function createSemicolonClassElement() {
            const node = createBaseNode(239 /* SemicolonClassElement */ );
            node.transformFlags |= 1024 /* ContainsES2015 */ ;
            return node;
        }
        function createBlock(statements, multiLine) {
            const node = createBaseNode(240 /* Block */ );
            node.statements = createNodeArray(statements);
            node.multiLine = multiLine;
            node.transformFlags |= propagateChildrenFlags(node.statements);
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateBlock(node, statements) {
            return node.statements !== statements ? update(createBlock(statements, node.multiLine), node) : node;
        }
        function createVariableStatement(modifiers, declarationList) {
            const node = createBaseNode(242 /* VariableStatement */ );
            node.modifiers = asNodeArray(modifiers);
            node.declarationList = isArray(declarationList) ? createVariableDeclarationList(declarationList) : declarationList;
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.declarationList);
            if (modifiersToFlags(node.modifiers) & 2 /* Ambient */ ) node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateVariableStatement(node, modifiers, declarationList) {
            return node.modifiers !== modifiers || node.declarationList !== declarationList ? update(createVariableStatement(modifiers, declarationList), node) : node;
        }
        function createEmptyStatement() {
            const node = createBaseNode(241 /* EmptyStatement */ );
            node.jsDoc = void 0;
            return node;
        }
        function createExpressionStatement(expression) {
            const node = createBaseNode(243 /* ExpressionStatement */ );
            node.expression = parenthesizerRules().parenthesizeExpressionOfExpressionStatement(expression);
            node.transformFlags |= propagateChildFlags(node.expression);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateExpressionStatement(node, expression) {
            return node.expression !== expression ? update(createExpressionStatement(expression), node) : node;
        }
        function createIfStatement(expression, thenStatement, elseStatement) {
            const node = createBaseNode(244 /* IfStatement */ );
            node.expression = expression;
            node.thenStatement = asEmbeddedStatement(thenStatement);
            node.elseStatement = asEmbeddedStatement(elseStatement);
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.thenStatement) | propagateChildFlags(node.elseStatement);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateIfStatement(node, expression, thenStatement, elseStatement) {
            return node.expression !== expression || node.thenStatement !== thenStatement || node.elseStatement !== elseStatement ? update(createIfStatement(expression, thenStatement, elseStatement), node) : node;
        }
        function createDoStatement(statement, expression) {
            const node = createBaseNode(245 /* DoStatement */ );
            node.statement = asEmbeddedStatement(statement);
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.statement) | propagateChildFlags(node.expression);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateDoStatement(node, statement, expression) {
            return node.statement !== statement || node.expression !== expression ? update(createDoStatement(statement, expression), node) : node;
        }
        function createWhileStatement(expression, statement) {
            const node = createBaseNode(246 /* WhileStatement */ );
            node.expression = expression;
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.statement);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateWhileStatement(node, expression, statement) {
            return node.expression !== expression || node.statement !== statement ? update(createWhileStatement(expression, statement), node) : node;
        }
        function createForStatement(initializer, condition, incrementor, statement) {
            const node = createBaseNode(247 /* ForStatement */ );
            node.initializer = initializer;
            node.condition = condition;
            node.incrementor = incrementor;
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.initializer) | propagateChildFlags(node.condition) | propagateChildFlags(node.incrementor) | propagateChildFlags(node.statement);
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateForStatement(node, initializer, condition, incrementor, statement) {
            return node.initializer !== initializer || node.condition !== condition || node.incrementor !== incrementor || node.statement !== statement ? update(createForStatement(initializer, condition, incrementor, statement), node) : node;
        }
        function createForInStatement(initializer, expression, statement) {
            const node = createBaseNode(248 /* ForInStatement */ );
            node.initializer = initializer;
            node.expression = expression;
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.initializer) | propagateChildFlags(node.expression) | propagateChildFlags(node.statement);
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateForInStatement(node, initializer, expression, statement) {
            return node.initializer !== initializer || node.expression !== expression || node.statement !== statement ? update(createForInStatement(initializer, expression, statement), node) : node;
        }
        function createForOfStatement(awaitModifier, initializer, expression, statement) {
            const node = createBaseNode(249 /* ForOfStatement */ );
            node.awaitModifier = awaitModifier;
            node.initializer = initializer;
            node.expression = parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.awaitModifier) | propagateChildFlags(node.initializer) | propagateChildFlags(node.expression) | propagateChildFlags(node.statement) | 1024 /* ContainsES2015 */ ;
            if (awaitModifier) node.transformFlags |= 128 /* ContainsES2018 */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateForOfStatement(node, awaitModifier, initializer, expression, statement) {
            return node.awaitModifier !== awaitModifier || node.initializer !== initializer || node.expression !== expression || node.statement !== statement ? update(createForOfStatement(awaitModifier, initializer, expression, statement), node) : node;
        }
        function createContinueStatement(label) {
            const node = createBaseNode(250 /* ContinueStatement */ );
            node.label = asName(label);
            node.transformFlags |= propagateChildFlags(node.label) | 4194304 /* ContainsHoistedDeclarationOrCompletion */ ;
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateContinueStatement(node, label) {
            return node.label !== label ? update(createContinueStatement(label), node) : node;
        }
        function createBreakStatement(label) {
            const node = createBaseNode(251 /* BreakStatement */ );
            node.label = asName(label);
            node.transformFlags |= propagateChildFlags(node.label) | 4194304 /* ContainsHoistedDeclarationOrCompletion */ ;
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateBreakStatement(node, label) {
            return node.label !== label ? update(createBreakStatement(label), node) : node;
        }
        function createReturnStatement(expression) {
            const node = createBaseNode(252 /* ReturnStatement */ );
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.expression) | 4194432 /* ContainsHoistedDeclarationOrCompletion */ ;
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateReturnStatement(node, expression) {
            return node.expression !== expression ? update(createReturnStatement(expression), node) : node;
        }
        function createWithStatement(expression, statement) {
            const node = createBaseNode(253 /* WithStatement */ );
            node.expression = expression;
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.statement);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateWithStatement(node, expression, statement) {
            return node.expression !== expression || node.statement !== statement ? update(createWithStatement(expression, statement), node) : node;
        }
        function createSwitchStatement(expression, caseBlock) {
            const node = createBaseNode(254 /* SwitchStatement */ );
            node.expression = parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.caseBlock = caseBlock;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.caseBlock);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            node.possiblyExhaustive = false;
            return node;
        }
        function updateSwitchStatement(node, expression, caseBlock) {
            return node.expression !== expression || node.caseBlock !== caseBlock ? update(createSwitchStatement(expression, caseBlock), node) : node;
        }
        function createLabeledStatement(label, statement) {
            const node = createBaseNode(255 /* LabeledStatement */ );
            node.label = asName(label);
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.label) | propagateChildFlags(node.statement);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateLabeledStatement(node, label, statement) {
            return node.label !== label || node.statement !== statement ? update(createLabeledStatement(label, statement), node) : node;
        }
        function createThrowStatement(expression) {
            const node = createBaseNode(256 /* ThrowStatement */ );
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.expression);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateThrowStatement(node, expression) {
            return node.expression !== expression ? update(createThrowStatement(expression), node) : node;
        }
        function createTryStatement(tryBlock, catchClause, finallyBlock) {
            const node = createBaseNode(257 /* TryStatement */ );
            node.tryBlock = tryBlock;
            node.catchClause = catchClause;
            node.finallyBlock = finallyBlock;
            node.transformFlags |= propagateChildFlags(node.tryBlock) | propagateChildFlags(node.catchClause) | propagateChildFlags(node.finallyBlock);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateTryStatement(node, tryBlock, catchClause, finallyBlock) {
            return node.tryBlock !== tryBlock || node.catchClause !== catchClause || node.finallyBlock !== finallyBlock ? update(createTryStatement(tryBlock, catchClause, finallyBlock), node) : node;
        }
        function createDebuggerStatement() {
            const node = createBaseNode(258 /* DebuggerStatement */ );
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function createVariableDeclaration(name, exclamationToken, type, initializer) {
            const node = createBaseDeclaration(259 /* VariableDeclaration */ );
            node.name = asName(name);
            node.exclamationToken = exclamationToken;
            node.type = type;
            node.initializer = asInitializer(initializer);
            node.transformFlags |= propagateNameFlags(node.name) | propagateChildFlags(node.initializer) | (node.exclamationToken ?? node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ );
            node.jsDoc = void 0;
            return node;
        }
        function updateVariableDeclaration(node, name, exclamationToken, type, initializer) {
            return node.name !== name || node.type !== type || node.exclamationToken !== exclamationToken || node.initializer !== initializer ? update(createVariableDeclaration(name, exclamationToken, type, initializer), node) : node;
        }
        function createVariableDeclarationList(declarations, flags2 = 0 /* None */ ) {
            const node = createBaseNode(260 /* VariableDeclarationList */ );
            node.flags |= flags2 & 3 /* BlockScoped */ ;
            node.declarations = createNodeArray(declarations);
            node.transformFlags |= propagateChildrenFlags(node.declarations) | 4194304 /* ContainsHoistedDeclarationOrCompletion */ ;
            if (flags2 & 3 /* BlockScoped */ ) node.transformFlags |= 263168 /* ContainsBlockScopedBinding */ ;
            return node;
        }
        function updateVariableDeclarationList(node, declarations) {
            return node.declarations !== declarations ? update(createVariableDeclarationList(declarations, node.flags), node) : node;
        }
        function createFunctionDeclaration(modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
            const node = createBaseDeclaration(261 /* FunctionDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.asteriskToken = asteriskToken;
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.body = body;
            if (!node.body || modifiersToFlags(node.modifiers) & 2 /* Ambient */ ) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else {
                const isAsync = modifiersToFlags(node.modifiers) & 512 /* Async */ ;
                const isGenerator = !!node.asteriskToken;
                const isAsyncGenerator = isAsync && isGenerator;
                node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.asteriskToken) | propagateNameFlags(node.name) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.type) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (isAsyncGenerator ? 128 /* ContainsES2018 */  : isAsync ? 256 /* ContainsES2017 */  : isGenerator ? 2048 /* ContainsGenerator */  : 0 /* None */ ) | (node.typeParameters || node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | 4194304 /* ContainsHoistedDeclarationOrCompletion */ ;
            }
            node.typeArguments = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateFunctionDeclaration(node, modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
            return node.modifiers !== modifiers || node.asteriskToken !== asteriskToken || node.name !== name || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type || node.body !== body ? finishUpdateFunctionDeclaration(createFunctionDeclaration(modifiers, asteriskToken, name, typeParameters, parameters, type, body), node) : node;
        }
        function finishUpdateFunctionDeclaration(updated, original) {
            if (updated !== original) {
                if (updated.modifiers === original.modifiers) updated.modifiers = original.modifiers;
            }
            return finishUpdateBaseSignatureDeclaration(updated, original);
        }
        function createClassDeclaration(modifiers, name, typeParameters, heritageClauses, members) {
            const node = createBaseDeclaration(262 /* ClassDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.heritageClauses = asNodeArray(heritageClauses);
            node.members = createNodeArray(members);
            if (modifiersToFlags(node.modifiers) & 2 /* Ambient */ ) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else {
                node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateNameFlags(node.name) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.heritageClauses) | propagateChildrenFlags(node.members) | (node.typeParameters ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | 1024 /* ContainsES2015 */ ;
                if (node.transformFlags & 8192 /* ContainsTypeScriptClassSyntax */ ) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            }
            node.jsDoc = void 0;
            return node;
        }
        function updateClassDeclaration(node, modifiers, name, typeParameters, heritageClauses, members) {
            return node.modifiers !== modifiers || node.name !== name || node.typeParameters !== typeParameters || node.heritageClauses !== heritageClauses || node.members !== members ? update(createClassDeclaration(modifiers, name, typeParameters, heritageClauses, members), node) : node;
        }
        function createInterfaceDeclaration(modifiers, name, typeParameters, heritageClauses, members) {
            const node = createBaseDeclaration(263 /* InterfaceDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.heritageClauses = asNodeArray(heritageClauses);
            node.members = createNodeArray(members);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateInterfaceDeclaration(node, modifiers, name, typeParameters, heritageClauses, members) {
            return node.modifiers !== modifiers || node.name !== name || node.typeParameters !== typeParameters || node.heritageClauses !== heritageClauses || node.members !== members ? update(createInterfaceDeclaration(modifiers, name, typeParameters, heritageClauses, members), node) : node;
        }
        function createTypeAliasDeclaration(modifiers, name, typeParameters, type) {
            const node = createBaseDeclaration(264 /* TypeAliasDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateTypeAliasDeclaration(node, modifiers, name, typeParameters, type) {
            return node.modifiers !== modifiers || node.name !== name || node.typeParameters !== typeParameters || node.type !== type ? update(createTypeAliasDeclaration(modifiers, name, typeParameters, type), node) : node;
        }
        function createEnumDeclaration(modifiers, name, members) {
            const node = createBaseDeclaration(265 /* EnumDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.members = createNodeArray(members);
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.name) | propagateChildrenFlags(node.members) | 1 /* ContainsTypeScript */ ;
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateEnumDeclaration(node, modifiers, name, members) {
            return node.modifiers !== modifiers || node.name !== name || node.members !== members ? update(createEnumDeclaration(modifiers, name, members), node) : node;
        }
        function createModuleDeclaration(modifiers, name, body, flags2 = 0 /* None */ ) {
            const node = createBaseDeclaration(266 /* ModuleDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.flags |= flags2 & 1044 /* GlobalAugmentation */ ;
            node.name = name;
            node.body = body;
            if (modifiersToFlags(node.modifiers) & 2 /* Ambient */ ) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.name) | propagateChildFlags(node.body) | 1 /* ContainsTypeScript */ ;
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateModuleDeclaration(node, modifiers, name, body) {
            return node.modifiers !== modifiers || node.name !== name || node.body !== body ? update(createModuleDeclaration(modifiers, name, body, node.flags), node) : node;
        }
        function createModuleBlock(statements) {
            const node = createBaseNode(267 /* ModuleBlock */ );
            node.statements = createNodeArray(statements);
            node.transformFlags |= propagateChildrenFlags(node.statements);
            node.jsDoc = void 0;
            return node;
        }
        function updateModuleBlock(node, statements) {
            return node.statements !== statements ? update(createModuleBlock(statements), node) : node;
        }
        function createCaseBlock(clauses) {
            const node = createBaseNode(268 /* CaseBlock */ );
            node.clauses = createNodeArray(clauses);
            node.transformFlags |= propagateChildrenFlags(node.clauses);
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateCaseBlock(node, clauses) {
            return node.clauses !== clauses ? update(createCaseBlock(clauses), node) : node;
        }
        function createNamespaceExportDeclaration(name) {
            const node = createBaseDeclaration(269 /* NamespaceExportDeclaration */ );
            node.name = asName(name);
            node.transformFlags |= propagateIdentifierNameFlags(node.name) | 1 /* ContainsTypeScript */ ;
            node.modifiers = void 0;
            node.jsDoc = void 0;
            return node;
        }
        function updateNamespaceExportDeclaration(node, name) {
            return node.name !== name ? finishUpdateNamespaceExportDeclaration(createNamespaceExportDeclaration(name), node) : node;
        }
        function finishUpdateNamespaceExportDeclaration(updated, original) {
            if (updated !== original) updated.modifiers = original.modifiers;
            return update(updated, original);
        }
        function createImportEqualsDeclaration(modifiers, isTypeOnly, name, moduleReference) {
            const node = createBaseDeclaration(270 /* ImportEqualsDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.isTypeOnly = isTypeOnly;
            node.moduleReference = moduleReference;
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateIdentifierNameFlags(node.name) | propagateChildFlags(node.moduleReference);
            if (!isExternalModuleReference(node.moduleReference)) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateImportEqualsDeclaration(node, modifiers, isTypeOnly, name, moduleReference) {
            return node.modifiers !== modifiers || node.isTypeOnly !== isTypeOnly || node.name !== name || node.moduleReference !== moduleReference ? update(createImportEqualsDeclaration(modifiers, isTypeOnly, name, moduleReference), node) : node;
        }
        function createImportDeclaration(modifiers, importClause, moduleSpecifier, assertClause) {
            const node = createBaseNode(271 /* ImportDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.importClause = importClause;
            node.moduleSpecifier = moduleSpecifier;
            node.assertClause = assertClause;
            node.transformFlags |= propagateChildFlags(node.importClause) | propagateChildFlags(node.moduleSpecifier);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateImportDeclaration(node, modifiers, importClause, moduleSpecifier, assertClause) {
            return node.modifiers !== modifiers || node.importClause !== importClause || node.moduleSpecifier !== moduleSpecifier || node.assertClause !== assertClause ? update(createImportDeclaration(modifiers, importClause, moduleSpecifier, assertClause), node) : node;
        }
        function createImportClause(isTypeOnly, name, namedBindings) {
            const node = createBaseDeclaration(272 /* ImportClause */ );
            node.isTypeOnly = isTypeOnly;
            node.name = name;
            node.namedBindings = namedBindings;
            node.transformFlags |= propagateChildFlags(node.name) | propagateChildFlags(node.namedBindings);
            if (isTypeOnly) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateImportClause(node, isTypeOnly, name, namedBindings) {
            return node.isTypeOnly !== isTypeOnly || node.name !== name || node.namedBindings !== namedBindings ? update(createImportClause(isTypeOnly, name, namedBindings), node) : node;
        }
        function createAssertClause(elements, multiLine) {
            const node = createBaseNode(299 /* AssertClause */ );
            node.elements = createNodeArray(elements);
            node.multiLine = multiLine;
            node.transformFlags |= 4 /* ContainsESNext */ ;
            return node;
        }
        function updateAssertClause(node, elements, multiLine) {
            return node.elements !== elements || node.multiLine !== multiLine ? update(createAssertClause(elements, multiLine), node) : node;
        }
        function createAssertEntry(name, value1) {
            const node = createBaseNode(300 /* AssertEntry */ );
            node.name = name;
            node.value = value1;
            node.transformFlags |= 4 /* ContainsESNext */ ;
            return node;
        }
        function updateAssertEntry(node, name, value1) {
            return node.name !== name || node.value !== value1 ? update(createAssertEntry(name, value1), node) : node;
        }
        function createImportTypeAssertionContainer(clause, multiLine) {
            const node = createBaseNode(301 /* ImportTypeAssertionContainer */ );
            node.assertClause = clause;
            node.multiLine = multiLine;
            return node;
        }
        function updateImportTypeAssertionContainer(node, clause, multiLine) {
            return node.assertClause !== clause || node.multiLine !== multiLine ? update(createImportTypeAssertionContainer(clause, multiLine), node) : node;
        }
        function createNamespaceImport(name) {
            const node = createBaseDeclaration(273 /* NamespaceImport */ );
            node.name = name;
            node.transformFlags |= propagateChildFlags(node.name);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateNamespaceImport(node, name) {
            return node.name !== name ? update(createNamespaceImport(name), node) : node;
        }
        function createNamespaceExport(name) {
            const node = createBaseDeclaration(279 /* NamespaceExport */ );
            node.name = name;
            node.transformFlags |= propagateChildFlags(node.name) | 32 /* ContainsES2020 */ ;
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateNamespaceExport(node, name) {
            return node.name !== name ? update(createNamespaceExport(name), node) : node;
        }
        function createNamedImports(elements) {
            const node = createBaseNode(274 /* NamedImports */ );
            node.elements = createNodeArray(elements);
            node.transformFlags |= propagateChildrenFlags(node.elements);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateNamedImports(node, elements) {
            return node.elements !== elements ? update(createNamedImports(elements), node) : node;
        }
        function createImportSpecifier(isTypeOnly, propertyName, name) {
            const node = createBaseDeclaration(275 /* ImportSpecifier */ );
            node.isTypeOnly = isTypeOnly;
            node.propertyName = propertyName;
            node.name = name;
            node.transformFlags |= propagateChildFlags(node.propertyName) | propagateChildFlags(node.name);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateImportSpecifier(node, isTypeOnly, propertyName, name) {
            return node.isTypeOnly !== isTypeOnly || node.propertyName !== propertyName || node.name !== name ? update(createImportSpecifier(isTypeOnly, propertyName, name), node) : node;
        }
        function createExportAssignment2(modifiers, isExportEquals, expression) {
            const node = createBaseDeclaration(276 /* ExportAssignment */ );
            node.modifiers = asNodeArray(modifiers);
            node.isExportEquals = isExportEquals;
            node.expression = isExportEquals ? parenthesizerRules().parenthesizeRightSideOfBinary(64 /* EqualsToken */ , /*leftSide*/ void 0, expression) : parenthesizerRules().parenthesizeExpressionOfExportDefault(expression);
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.expression);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateExportAssignment(node, modifiers, expression) {
            return node.modifiers !== modifiers || node.expression !== expression ? update(createExportAssignment2(modifiers, node.isExportEquals, expression), node) : node;
        }
        function createExportDeclaration(modifiers, isTypeOnly, exportClause, moduleSpecifier, assertClause) {
            const node = createBaseDeclaration(277 /* ExportDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.isTypeOnly = isTypeOnly;
            node.exportClause = exportClause;
            node.moduleSpecifier = moduleSpecifier;
            node.assertClause = assertClause;
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.exportClause) | propagateChildFlags(node.moduleSpecifier);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateExportDeclaration(node, modifiers, isTypeOnly, exportClause, moduleSpecifier, assertClause) {
            return node.modifiers !== modifiers || node.isTypeOnly !== isTypeOnly || node.exportClause !== exportClause || node.moduleSpecifier !== moduleSpecifier || node.assertClause !== assertClause ? finishUpdateExportDeclaration(createExportDeclaration(modifiers, isTypeOnly, exportClause, moduleSpecifier, assertClause), node) : node;
        }
        function finishUpdateExportDeclaration(updated, original) {
            if (updated !== original) {
                if (updated.modifiers === original.modifiers) updated.modifiers = original.modifiers;
            }
            return update(updated, original);
        }
        function createNamedExports(elements) {
            const node = createBaseNode(278 /* NamedExports */ );
            node.elements = createNodeArray(elements);
            node.transformFlags |= propagateChildrenFlags(node.elements);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateNamedExports(node, elements) {
            return node.elements !== elements ? update(createNamedExports(elements), node) : node;
        }
        function createExportSpecifier(isTypeOnly, propertyName, name) {
            const node = createBaseNode(280 /* ExportSpecifier */ );
            node.isTypeOnly = isTypeOnly;
            node.propertyName = asName(propertyName);
            node.name = asName(name);
            node.transformFlags |= propagateChildFlags(node.propertyName) | propagateChildFlags(node.name);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateExportSpecifier(node, isTypeOnly, propertyName, name) {
            return node.isTypeOnly !== isTypeOnly || node.propertyName !== propertyName || node.name !== name ? update(createExportSpecifier(isTypeOnly, propertyName, name), node) : node;
        }
        function createMissingDeclaration() {
            const node = createBaseDeclaration(281 /* MissingDeclaration */ );
            node.jsDoc = void 0;
            return node;
        }
        function createExternalModuleReference(expression) {
            const node = createBaseNode(282 /* ExternalModuleReference */ );
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.expression);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateExternalModuleReference(node, expression) {
            return node.expression !== expression ? update(createExternalModuleReference(expression), node) : node;
        }
        function createJSDocPrimaryTypeWorker(kind) {
            return createBaseNode(kind);
        }
        function createJSDocPrePostfixUnaryTypeWorker(kind, type, postfix = false) {
            const node = createJSDocUnaryTypeWorker(kind, postfix ? type && parenthesizerRules().parenthesizeNonArrayTypeOfPostfixType(type) : type);
            node.postfix = postfix;
            return node;
        }
        function createJSDocUnaryTypeWorker(kind, type) {
            const node = createBaseNode(kind);
            node.type = type;
            return node;
        }
        function updateJSDocPrePostfixUnaryTypeWorker(kind, node, type) {
            return node.type !== type ? update(createJSDocPrePostfixUnaryTypeWorker(kind, type, node.postfix), node) : node;
        }
        function updateJSDocUnaryTypeWorker(kind, node, type) {
            return node.type !== type ? update(createJSDocUnaryTypeWorker(kind, type), node) : node;
        }
        function createJSDocFunctionType(parameters, type) {
            const node = createBaseDeclaration(323 /* JSDocFunctionType */ );
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = propagateChildrenFlags(node.parameters) | (node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ );
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateJSDocFunctionType(node, parameters, type) {
            return node.parameters !== parameters || node.type !== type ? update(createJSDocFunctionType(parameters, type), node) : node;
        }
        function createJSDocTypeLiteral(propertyTags, isArrayType = false) {
            const node = createBaseDeclaration(328 /* JSDocTypeLiteral */ );
            node.jsDocPropertyTags = asNodeArray(propertyTags);
            node.isArrayType = isArrayType;
            return node;
        }
        function updateJSDocTypeLiteral(node, propertyTags, isArrayType) {
            return node.jsDocPropertyTags !== propertyTags || node.isArrayType !== isArrayType ? update(createJSDocTypeLiteral(propertyTags, isArrayType), node) : node;
        }
        function createJSDocTypeExpression(type) {
            const node = createBaseNode(315 /* JSDocTypeExpression */ );
            node.type = type;
            return node;
        }
        function updateJSDocTypeExpression(node, type) {
            return node.type !== type ? update(createJSDocTypeExpression(type), node) : node;
        }
        function createJSDocSignature(typeParameters, parameters, type) {
            const node = createBaseDeclaration(329 /* JSDocSignature */ );
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateJSDocSignature(node, typeParameters, parameters, type) {
            return node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? update(createJSDocSignature(typeParameters, parameters, type), node) : node;
        }
        function getDefaultTagName(node) {
            const defaultTagName = getDefaultTagNameForKind(node.kind);
            return node.tagName.escapedText === escapeLeadingUnderscores(defaultTagName) ? node.tagName : createIdentifier(defaultTagName);
        }
        function createBaseJSDocTag(kind, tagName, comment) {
            const node = createBaseNode(kind);
            node.tagName = tagName;
            node.comment = comment;
            return node;
        }
        function createBaseJSDocTagDeclaration(kind, tagName, comment) {
            const node = createBaseDeclaration(kind);
            node.tagName = tagName;
            node.comment = comment;
            return node;
        }
        function createJSDocTemplateTag(tagName, constraint, typeParameters, comment) {
            const node = createBaseJSDocTag(351 /* JSDocTemplateTag */ , tagName ?? createIdentifier("template"), comment);
            node.constraint = constraint;
            node.typeParameters = createNodeArray(typeParameters);
            return node;
        }
        function updateJSDocTemplateTag(node, tagName = getDefaultTagName(node), constraint, typeParameters, comment) {
            return node.tagName !== tagName || node.constraint !== constraint || node.typeParameters !== typeParameters || node.comment !== comment ? update(createJSDocTemplateTag(tagName, constraint, typeParameters, comment), node) : node;
        }
        function createJSDocTypedefTag(tagName, typeExpression, fullName, comment) {
            const node = createBaseJSDocTagDeclaration(352 /* JSDocTypedefTag */ , tagName ?? createIdentifier("typedef"), comment);
            node.typeExpression = typeExpression;
            node.fullName = fullName;
            node.name = getJSDocTypeAliasName(fullName);
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateJSDocTypedefTag(node, tagName = getDefaultTagName(node), typeExpression, fullName, comment) {
            return node.tagName !== tagName || node.typeExpression !== typeExpression || node.fullName !== fullName || node.comment !== comment ? update(createJSDocTypedefTag(tagName, typeExpression, fullName, comment), node) : node;
        }
        function createJSDocParameterTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment) {
            const node = createBaseJSDocTagDeclaration(347 /* JSDocParameterTag */ , tagName ?? createIdentifier("param"), comment);
            node.typeExpression = typeExpression;
            node.name = name;
            node.isNameFirst = !!isNameFirst;
            node.isBracketed = isBracketed;
            return node;
        }
        function updateJSDocParameterTag(node, tagName = getDefaultTagName(node), name, isBracketed, typeExpression, isNameFirst, comment) {
            return node.tagName !== tagName || node.name !== name || node.isBracketed !== isBracketed || node.typeExpression !== typeExpression || node.isNameFirst !== isNameFirst || node.comment !== comment ? update(createJSDocParameterTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment), node) : node;
        }
        function createJSDocPropertyTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment) {
            const node = createBaseJSDocTagDeclaration(354 /* JSDocPropertyTag */ , tagName ?? createIdentifier("prop"), comment);
            node.typeExpression = typeExpression;
            node.name = name;
            node.isNameFirst = !!isNameFirst;
            node.isBracketed = isBracketed;
            return node;
        }
        function updateJSDocPropertyTag(node, tagName = getDefaultTagName(node), name, isBracketed, typeExpression, isNameFirst, comment) {
            return node.tagName !== tagName || node.name !== name || node.isBracketed !== isBracketed || node.typeExpression !== typeExpression || node.isNameFirst !== isNameFirst || node.comment !== comment ? update(createJSDocPropertyTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment), node) : node;
        }
        function createJSDocCallbackTag(tagName, typeExpression, fullName, comment) {
            const node = createBaseJSDocTagDeclaration(344 /* JSDocCallbackTag */ , tagName ?? createIdentifier("callback"), comment);
            node.typeExpression = typeExpression;
            node.fullName = fullName;
            node.name = getJSDocTypeAliasName(fullName);
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateJSDocCallbackTag(node, tagName = getDefaultTagName(node), typeExpression, fullName, comment) {
            return node.tagName !== tagName || node.typeExpression !== typeExpression || node.fullName !== fullName || node.comment !== comment ? update(createJSDocCallbackTag(tagName, typeExpression, fullName, comment), node) : node;
        }
        function createJSDocOverloadTag(tagName, typeExpression, comment) {
            const node = createBaseJSDocTag(345 /* JSDocOverloadTag */ , tagName ?? createIdentifier("overload"), comment);
            node.typeExpression = typeExpression;
            return node;
        }
        function updateJSDocOverloadTag(node, tagName = getDefaultTagName(node), typeExpression, comment) {
            return node.tagName !== tagName || node.typeExpression !== typeExpression || node.comment !== comment ? update(createJSDocOverloadTag(tagName, typeExpression, comment), node) : node;
        }
        function createJSDocAugmentsTag(tagName, className, comment) {
            const node = createBaseJSDocTag(334 /* JSDocAugmentsTag */ , tagName ?? createIdentifier("augments"), comment);
            node.class = className;
            return node;
        }
        function updateJSDocAugmentsTag(node, tagName = getDefaultTagName(node), className, comment) {
            return node.tagName !== tagName || node.class !== className || node.comment !== comment ? update(createJSDocAugmentsTag(tagName, className, comment), node) : node;
        }
        function createJSDocImplementsTag(tagName, className, comment) {
            const node = createBaseJSDocTag(335 /* JSDocImplementsTag */ , tagName ?? createIdentifier("implements"), comment);
            node.class = className;
            return node;
        }
        function createJSDocSeeTag(tagName, name, comment) {
            const node = createBaseJSDocTag(353 /* JSDocSeeTag */ , tagName ?? createIdentifier("see"), comment);
            node.name = name;
            return node;
        }
        function updateJSDocSeeTag(node, tagName, name, comment) {
            return node.tagName !== tagName || node.name !== name || node.comment !== comment ? update(createJSDocSeeTag(tagName, name, comment), node) : node;
        }
        function createJSDocNameReference(name) {
            const node = createBaseNode(316 /* JSDocNameReference */ );
            node.name = name;
            return node;
        }
        function updateJSDocNameReference(node, name) {
            return node.name !== name ? update(createJSDocNameReference(name), node) : node;
        }
        function createJSDocMemberName(left, right) {
            const node = createBaseNode(317 /* JSDocMemberName */ );
            node.left = left;
            node.right = right;
            node.transformFlags |= propagateChildFlags(node.left) | propagateChildFlags(node.right);
            return node;
        }
        function updateJSDocMemberName(node, left, right) {
            return node.left !== left || node.right !== right ? update(createJSDocMemberName(left, right), node) : node;
        }
        function createJSDocLink(name, text) {
            const node = createBaseNode(330 /* JSDocLink */ );
            node.name = name;
            node.text = text;
            return node;
        }
        function updateJSDocLink(node, name, text) {
            return node.name !== name ? update(createJSDocLink(name, text), node) : node;
        }
        function createJSDocLinkCode(name, text) {
            const node = createBaseNode(331 /* JSDocLinkCode */ );
            node.name = name;
            node.text = text;
            return node;
        }
        function updateJSDocLinkCode(node, name, text) {
            return node.name !== name ? update(createJSDocLinkCode(name, text), node) : node;
        }
        function createJSDocLinkPlain(name, text) {
            const node = createBaseNode(332 /* JSDocLinkPlain */ );
            node.name = name;
            node.text = text;
            return node;
        }
        function updateJSDocLinkPlain(node, name, text) {
            return node.name !== name ? update(createJSDocLinkPlain(name, text), node) : node;
        }
        function updateJSDocImplementsTag(node, tagName = getDefaultTagName(node), className, comment) {
            return node.tagName !== tagName || node.class !== className || node.comment !== comment ? update(createJSDocImplementsTag(tagName, className, comment), node) : node;
        }
        function createJSDocSimpleTagWorker(kind, tagName, comment) {
            const node = createBaseJSDocTag(kind, tagName ?? createIdentifier(getDefaultTagNameForKind(kind)), comment);
            return node;
        }
        function updateJSDocSimpleTagWorker(kind, node, tagName = getDefaultTagName(node), comment) {
            return node.tagName !== tagName || node.comment !== comment ? update(createJSDocSimpleTagWorker(kind, tagName, comment), node) : node;
        }
        function createJSDocTypeLikeTagWorker(kind, tagName, typeExpression, comment) {
            const node = createBaseJSDocTag(kind, tagName ?? createIdentifier(getDefaultTagNameForKind(kind)), comment);
            node.typeExpression = typeExpression;
            return node;
        }
        function updateJSDocTypeLikeTagWorker(kind, node, tagName = getDefaultTagName(node), typeExpression, comment) {
            return node.tagName !== tagName || node.typeExpression !== typeExpression || node.comment !== comment ? update(createJSDocTypeLikeTagWorker(kind, tagName, typeExpression, comment), node) : node;
        }
        function createJSDocUnknownTag(tagName, comment) {
            const node = createBaseJSDocTag(333 /* JSDocTag */ , tagName, comment);
            return node;
        }
        function updateJSDocUnknownTag(node, tagName, comment) {
            return node.tagName !== tagName || node.comment !== comment ? update(createJSDocUnknownTag(tagName, comment), node) : node;
        }
        function createJSDocEnumTag(tagName, typeExpression, comment) {
            const node = createBaseJSDocTagDeclaration(346 /* JSDocEnumTag */ , tagName ?? createIdentifier(getDefaultTagNameForKind(346 /* JSDocEnumTag */ )), comment);
            node.typeExpression = typeExpression;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateJSDocEnumTag(node, tagName = getDefaultTagName(node), typeExpression, comment) {
            return node.tagName !== tagName || node.typeExpression !== typeExpression || node.comment !== comment ? update(createJSDocEnumTag(tagName, typeExpression, comment), node) : node;
        }
        function createJSDocText(text) {
            const node = createBaseNode(327 /* JSDocText */ );
            node.text = text;
            return node;
        }
        function updateJSDocText(node, text) {
            return node.text !== text ? update(createJSDocText(text), node) : node;
        }
        function createJSDocComment(comment, tags) {
            const node = createBaseNode(326 /* JSDoc */ );
            node.comment = comment;
            node.tags = asNodeArray(tags);
            return node;
        }
        function updateJSDocComment(node, comment, tags) {
            return node.comment !== comment || node.tags !== tags ? update(createJSDocComment(comment, tags), node) : node;
        }
        function createJsxElement(openingElement, children, closingElement) {
            const node = createBaseNode(283 /* JsxElement */ );
            node.openingElement = openingElement;
            node.children = createNodeArray(children);
            node.closingElement = closingElement;
            node.transformFlags |= propagateChildFlags(node.openingElement) | propagateChildrenFlags(node.children) | propagateChildFlags(node.closingElement) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxElement(node, openingElement, children, closingElement) {
            return node.openingElement !== openingElement || node.children !== children || node.closingElement !== closingElement ? update(createJsxElement(openingElement, children, closingElement), node) : node;
        }
        function createJsxSelfClosingElement(tagName, typeArguments, attributes) {
            const node = createBaseNode(284 /* JsxSelfClosingElement */ );
            node.tagName = tagName;
            node.typeArguments = asNodeArray(typeArguments);
            node.attributes = attributes;
            node.transformFlags |= propagateChildFlags(node.tagName) | propagateChildrenFlags(node.typeArguments) | propagateChildFlags(node.attributes) | 2 /* ContainsJsx */ ;
            if (node.typeArguments) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateJsxSelfClosingElement(node, tagName, typeArguments, attributes) {
            return node.tagName !== tagName || node.typeArguments !== typeArguments || node.attributes !== attributes ? update(createJsxSelfClosingElement(tagName, typeArguments, attributes), node) : node;
        }
        function createJsxOpeningElement(tagName, typeArguments, attributes) {
            const node = createBaseNode(285 /* JsxOpeningElement */ );
            node.tagName = tagName;
            node.typeArguments = asNodeArray(typeArguments);
            node.attributes = attributes;
            node.transformFlags |= propagateChildFlags(node.tagName) | propagateChildrenFlags(node.typeArguments) | propagateChildFlags(node.attributes) | 2 /* ContainsJsx */ ;
            if (typeArguments) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateJsxOpeningElement(node, tagName, typeArguments, attributes) {
            return node.tagName !== tagName || node.typeArguments !== typeArguments || node.attributes !== attributes ? update(createJsxOpeningElement(tagName, typeArguments, attributes), node) : node;
        }
        function createJsxClosingElement(tagName) {
            const node = createBaseNode(286 /* JsxClosingElement */ );
            node.tagName = tagName;
            node.transformFlags |= propagateChildFlags(node.tagName) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxClosingElement(node, tagName) {
            return node.tagName !== tagName ? update(createJsxClosingElement(tagName), node) : node;
        }
        function createJsxFragment(openingFragment, children, closingFragment) {
            const node = createBaseNode(287 /* JsxFragment */ );
            node.openingFragment = openingFragment;
            node.children = createNodeArray(children);
            node.closingFragment = closingFragment;
            node.transformFlags |= propagateChildFlags(node.openingFragment) | propagateChildrenFlags(node.children) | propagateChildFlags(node.closingFragment) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxFragment(node, openingFragment, children, closingFragment) {
            return node.openingFragment !== openingFragment || node.children !== children || node.closingFragment !== closingFragment ? update(createJsxFragment(openingFragment, children, closingFragment), node) : node;
        }
        function createJsxText(text, containsOnlyTriviaWhiteSpaces) {
            const node = createBaseNode(12 /* JsxText */ );
            node.text = text;
            node.containsOnlyTriviaWhiteSpaces = !!containsOnlyTriviaWhiteSpaces;
            node.transformFlags |= 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxText(node, text, containsOnlyTriviaWhiteSpaces) {
            return node.text !== text || node.containsOnlyTriviaWhiteSpaces !== containsOnlyTriviaWhiteSpaces ? update(createJsxText(text, containsOnlyTriviaWhiteSpaces), node) : node;
        }
        function createJsxOpeningFragment() {
            const node = createBaseNode(288 /* JsxOpeningFragment */ );
            node.transformFlags |= 2 /* ContainsJsx */ ;
            return node;
        }
        function createJsxJsxClosingFragment() {
            const node = createBaseNode(289 /* JsxClosingFragment */ );
            node.transformFlags |= 2 /* ContainsJsx */ ;
            return node;
        }
        function createJsxAttribute(name, initializer) {
            const node = createBaseDeclaration(290 /* JsxAttribute */ );
            node.name = name;
            node.initializer = initializer;
            node.transformFlags |= propagateChildFlags(node.name) | propagateChildFlags(node.initializer) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxAttribute(node, name, initializer) {
            return node.name !== name || node.initializer !== initializer ? update(createJsxAttribute(name, initializer), node) : node;
        }
        function createJsxAttributes(properties) {
            const node = createBaseDeclaration(291 /* JsxAttributes */ );
            node.properties = createNodeArray(properties);
            node.transformFlags |= propagateChildrenFlags(node.properties) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxAttributes(node, properties) {
            return node.properties !== properties ? update(createJsxAttributes(properties), node) : node;
        }
        function createJsxSpreadAttribute(expression) {
            const node = createBaseNode(292 /* JsxSpreadAttribute */ );
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.expression) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxSpreadAttribute(node, expression) {
            return node.expression !== expression ? update(createJsxSpreadAttribute(expression), node) : node;
        }
        function createJsxExpression(dotDotDotToken, expression) {
            const node = createBaseNode(293 /* JsxExpression */ );
            node.dotDotDotToken = dotDotDotToken;
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.dotDotDotToken) | propagateChildFlags(node.expression) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxExpression(node, expression) {
            return node.expression !== expression ? update(createJsxExpression(node.dotDotDotToken, expression), node) : node;
        }
        function createJsxNamespacedName(namespace, name) {
            const node = createBaseNode(294 /* JsxNamespacedName */ );
            node.namespace = namespace;
            node.name = name;
            node.transformFlags |= propagateChildFlags(node.namespace) | propagateChildFlags(node.name) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxNamespacedName(node, namespace, name) {
            return node.namespace !== namespace || node.name !== name ? update(createJsxNamespacedName(namespace, name), node) : node;
        }
        function createCaseClause(expression, statements) {
            const node = createBaseNode(295 /* CaseClause */ );
            node.expression = parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.statements = createNodeArray(statements);
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildrenFlags(node.statements);
            node.jsDoc = void 0;
            return node;
        }
        function updateCaseClause(node, expression, statements) {
            return node.expression !== expression || node.statements !== statements ? update(createCaseClause(expression, statements), node) : node;
        }
        function createDefaultClause(statements) {
            const node = createBaseNode(296 /* DefaultClause */ );
            node.statements = createNodeArray(statements);
            node.transformFlags = propagateChildrenFlags(node.statements);
            return node;
        }
        function updateDefaultClause(node, statements) {
            return node.statements !== statements ? update(createDefaultClause(statements), node) : node;
        }
        function createHeritageClause(token, types) {
            const node = createBaseNode(297 /* HeritageClause */ );
            node.token = token;
            node.types = createNodeArray(types);
            node.transformFlags |= propagateChildrenFlags(node.types);
            switch(token){
                case 96 /* ExtendsKeyword */ :
                    node.transformFlags |= 1024 /* ContainsES2015 */ ;
                    break;
                case 119 /* ImplementsKeyword */ :
                    node.transformFlags |= 1 /* ContainsTypeScript */ ;
                    break;
                default:
                    return Debug.assertNever(token);
            }
            return node;
        }
        function updateHeritageClause(node, types) {
            return node.types !== types ? update(createHeritageClause(node.token, types), node) : node;
        }
        function createCatchClause(variableDeclaration, block) {
            const node = createBaseNode(298 /* CatchClause */ );
            node.variableDeclaration = asVariableDeclaration(variableDeclaration);
            node.block = block;
            node.transformFlags |= propagateChildFlags(node.variableDeclaration) | propagateChildFlags(node.block) | (!variableDeclaration ? 64 /* ContainsES2019 */  : 0 /* None */ );
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateCatchClause(node, variableDeclaration, block) {
            return node.variableDeclaration !== variableDeclaration || node.block !== block ? update(createCatchClause(variableDeclaration, block), node) : node;
        }
        function createPropertyAssignment(name, initializer) {
            const node = createBaseDeclaration(302 /* PropertyAssignment */ );
            node.name = asName(name);
            node.initializer = parenthesizerRules().parenthesizeExpressionForDisallowedComma(initializer);
            node.transformFlags |= propagateNameFlags(node.name) | propagateChildFlags(node.initializer);
            node.modifiers = void 0;
            node.questionToken = void 0;
            node.exclamationToken = void 0;
            node.jsDoc = void 0;
            return node;
        }
        function updatePropertyAssignment(node, name, initializer) {
            return node.name !== name || node.initializer !== initializer ? finishUpdatePropertyAssignment(createPropertyAssignment(name, initializer), node) : node;
        }
        function finishUpdatePropertyAssignment(updated, original) {
            if (updated !== original) {
                updated.modifiers = original.modifiers;
                updated.questionToken = original.questionToken;
                updated.exclamationToken = original.exclamationToken;
            }
            return update(updated, original);
        }
        function createShorthandPropertyAssignment(name, objectAssignmentInitializer) {
            const node = createBaseDeclaration(303 /* ShorthandPropertyAssignment */ );
            node.name = asName(name);
            node.objectAssignmentInitializer = objectAssignmentInitializer && parenthesizerRules().parenthesizeExpressionForDisallowedComma(objectAssignmentInitializer);
            node.transformFlags |= propagateIdentifierNameFlags(node.name) | propagateChildFlags(node.objectAssignmentInitializer) | 1024 /* ContainsES2015 */ ;
            node.equalsToken = void 0;
            node.modifiers = void 0;
            node.questionToken = void 0;
            node.exclamationToken = void 0;
            node.jsDoc = void 0;
            return node;
        }
        function updateShorthandPropertyAssignment(node, name, objectAssignmentInitializer) {
            return node.name !== name || node.objectAssignmentInitializer !== objectAssignmentInitializer ? finishUpdateShorthandPropertyAssignment(createShorthandPropertyAssignment(name, objectAssignmentInitializer), node) : node;
        }
        function finishUpdateShorthandPropertyAssignment(updated, original) {
            if (updated !== original) {
                updated.modifiers = original.modifiers;
                updated.questionToken = original.questionToken;
                updated.exclamationToken = original.exclamationToken;
                updated.equalsToken = original.equalsToken;
            }
            return update(updated, original);
        }
        function createSpreadAssignment(expression) {
            const node = createBaseDeclaration(304 /* SpreadAssignment */ );
            node.expression = parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.transformFlags |= propagateChildFlags(node.expression) | 65664 /* ContainsObjectRestOrSpread */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateSpreadAssignment(node, expression) {
            return node.expression !== expression ? update(createSpreadAssignment(expression), node) : node;
        }
        function createEnumMember(name, initializer) {
            const node = createBaseDeclaration(305 /* EnumMember */ );
            node.name = asName(name);
            node.initializer = initializer && parenthesizerRules().parenthesizeExpressionForDisallowedComma(initializer);
            node.transformFlags |= propagateChildFlags(node.name) | propagateChildFlags(node.initializer) | 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateEnumMember(node, name, initializer) {
            return node.name !== name || node.initializer !== initializer ? update(createEnumMember(name, initializer), node) : node;
        }
        function createSourceFile2(statements, endOfFileToken, flags2) {
            const node = baseFactory2.createBaseSourceFileNode(311 /* SourceFile */ );
            node.statements = createNodeArray(statements);
            node.endOfFileToken = endOfFileToken;
            node.flags |= flags2;
            node.text = "";
            node.fileName = "";
            node.path = "";
            node.resolvedPath = "";
            node.originalFileName = "";
            node.languageVersion = 0;
            node.languageVariant = 0;
            node.scriptKind = 0;
            node.isDeclarationFile = false;
            node.hasNoDefaultLib = false;
            node.transformFlags |= propagateChildrenFlags(node.statements) | propagateChildFlags(node.endOfFileToken);
            node.locals = void 0;
            node.nextContainer = void 0;
            node.endFlowNode = void 0;
            node.nodeCount = 0;
            node.identifierCount = 0;
            node.symbolCount = 0;
            node.parseDiagnostics = void 0;
            node.bindDiagnostics = void 0;
            node.bindSuggestionDiagnostics = void 0;
            node.lineMap = void 0;
            node.externalModuleIndicator = void 0;
            node.setExternalModuleIndicator = void 0;
            node.pragmas = void 0;
            node.checkJsDirective = void 0;
            node.referencedFiles = void 0;
            node.typeReferenceDirectives = void 0;
            node.libReferenceDirectives = void 0;
            node.amdDependencies = void 0;
            node.commentDirectives = void 0;
            node.identifiers = void 0;
            node.packageJsonLocations = void 0;
            node.packageJsonScope = void 0;
            node.imports = void 0;
            node.moduleAugmentations = void 0;
            node.ambientModuleNames = void 0;
            node.resolvedModules = void 0;
            node.classifiableNames = void 0;
            node.impliedNodeFormat = void 0;
            return node;
        }
        function createRedirectedSourceFile(redirectInfo) {
            const node = Object.create(redirectInfo.redirectTarget);
            Object.defineProperties(node, {
                id: {
                    get () {
                        return this.redirectInfo.redirectTarget.id;
                    },
                    set (value1) {
                        this.redirectInfo.redirectTarget.id = value1;
                    }
                },
                symbol: {
                    get () {
                        return this.redirectInfo.redirectTarget.symbol;
                    },
                    set (value1) {
                        this.redirectInfo.redirectTarget.symbol = value1;
                    }
                }
            });
            node.redirectInfo = redirectInfo;
            return node;
        }
        function cloneRedirectedSourceFile(source) {
            const node = createRedirectedSourceFile(source.redirectInfo);
            node.flags |= source.flags & -9 /* Synthesized */ ;
            node.fileName = source.fileName;
            node.path = source.path;
            node.resolvedPath = source.resolvedPath;
            node.originalFileName = source.originalFileName;
            node.packageJsonLocations = source.packageJsonLocations;
            node.packageJsonScope = source.packageJsonScope;
            node.emitNode = void 0;
            return node;
        }
        function cloneSourceFileWorker(source) {
            const node = baseFactory2.createBaseSourceFileNode(311 /* SourceFile */ );
            node.flags |= source.flags & -9 /* Synthesized */ ;
            for(const p in source){
                if (hasProperty(node, p) || !hasProperty(source, p)) continue;
                if (p === "emitNode") {
                    node.emitNode = void 0;
                    continue;
                }
                node[p] = source[p];
            }
            return node;
        }
        function cloneSourceFile(source) {
            const node = source.redirectInfo ? cloneRedirectedSourceFile(source) : cloneSourceFileWorker(source);
            setOriginalNode(node, source);
            return node;
        }
        function cloneSourceFileWithChanges(source, statements, isDeclarationFile, referencedFiles, typeReferences, hasNoDefaultLib, libReferences) {
            const node = cloneSourceFile(source);
            node.statements = createNodeArray(statements);
            node.isDeclarationFile = isDeclarationFile;
            node.referencedFiles = referencedFiles;
            node.typeReferenceDirectives = typeReferences;
            node.hasNoDefaultLib = hasNoDefaultLib;
            node.libReferenceDirectives = libReferences;
            node.transformFlags = propagateChildrenFlags(node.statements) | propagateChildFlags(node.endOfFileToken);
            return node;
        }
        function updateSourceFile2(node, statements, isDeclarationFile = node.isDeclarationFile, referencedFiles = node.referencedFiles, typeReferenceDirectives = node.typeReferenceDirectives, hasNoDefaultLib = node.hasNoDefaultLib, libReferenceDirectives = node.libReferenceDirectives) {
            return node.statements !== statements || node.isDeclarationFile !== isDeclarationFile || node.referencedFiles !== referencedFiles || node.typeReferenceDirectives !== typeReferenceDirectives || node.hasNoDefaultLib !== hasNoDefaultLib || node.libReferenceDirectives !== libReferenceDirectives ? update(cloneSourceFileWithChanges(node, statements, isDeclarationFile, referencedFiles, typeReferenceDirectives, hasNoDefaultLib, libReferenceDirectives), node) : node;
        }
        function createBundle(sourceFiles, prepends = emptyArray) {
            const node = createBaseNode(312 /* Bundle */ );
            node.prepends = prepends;
            node.sourceFiles = sourceFiles;
            node.syntheticFileReferences = void 0;
            node.syntheticTypeReferences = void 0;
            node.syntheticLibReferences = void 0;
            node.hasNoDefaultLib = void 0;
            return node;
        }
        function updateBundle(node, sourceFiles, prepends = emptyArray) {
            return node.sourceFiles !== sourceFiles || node.prepends !== prepends ? update(createBundle(sourceFiles, prepends), node) : node;
        }
        function createUnparsedSource(prologues, syntheticReferences, texts) {
            const node = createBaseNode(313 /* UnparsedSource */ );
            node.prologues = prologues;
            node.syntheticReferences = syntheticReferences;
            node.texts = texts;
            node.fileName = "";
            node.text = "";
            node.referencedFiles = emptyArray;
            node.libReferenceDirectives = emptyArray;
            node.getLineAndCharacterOfPosition = (pos)=>getLineAndCharacterOfPosition(node, pos);
            return node;
        }
        function createBaseUnparsedNode(kind, data) {
            const node = createBaseNode(kind);
            node.data = data;
            return node;
        }
        function createUnparsedPrologue(data) {
            return createBaseUnparsedNode(306 /* UnparsedPrologue */ , data);
        }
        function createUnparsedPrepend(data, texts) {
            const node = createBaseUnparsedNode(307 /* UnparsedPrepend */ , data);
            node.texts = texts;
            return node;
        }
        function createUnparsedTextLike(data, internal) {
            return createBaseUnparsedNode(internal ? 309 /* UnparsedInternalText */  : 308 /* UnparsedText */ , data);
        }
        function createUnparsedSyntheticReference(section) {
            const node = createBaseNode(310 /* UnparsedSyntheticReference */ );
            node.data = section.data;
            node.section = section;
            return node;
        }
        function createInputFiles2() {
            const node = createBaseNode(314 /* InputFiles */ );
            node.javascriptText = "";
            node.declarationText = "";
            return node;
        }
        function createSyntheticExpression(type, isSpread = false, tupleNameSource) {
            const node = createBaseNode(236 /* SyntheticExpression */ );
            node.type = type;
            node.isSpread = isSpread;
            node.tupleNameSource = tupleNameSource;
            return node;
        }
        function createSyntaxList3(children) {
            const node = createBaseNode(357 /* SyntaxList */ );
            node._children = children;
            return node;
        }
        function createNotEmittedStatement(original) {
            const node = createBaseNode(358 /* NotEmittedStatement */ );
            node.original = original;
            setTextRange(node, original);
            return node;
        }
        function createPartiallyEmittedExpression(expression, original) {
            const node = createBaseNode(359 /* PartiallyEmittedExpression */ );
            node.expression = expression;
            node.original = original;
            node.transformFlags |= propagateChildFlags(node.expression) | 1 /* ContainsTypeScript */ ;
            setTextRange(node, original);
            return node;
        }
        function updatePartiallyEmittedExpression(node, expression) {
            return node.expression !== expression ? update(createPartiallyEmittedExpression(expression, node.original), node) : node;
        }
        function flattenCommaElements(node) {
            if (nodeIsSynthesized(node) && !isParseTreeNode(node) && !node.original && !node.emitNode && !node.id) {
                if (isCommaListExpression(node)) return node.elements;
                if (isBinaryExpression(node) && isCommaToken(node.operatorToken)) return [
                    node.left,
                    node.right
                ];
            }
            return node;
        }
        function createCommaListExpression(elements) {
            const node = createBaseNode(360 /* CommaListExpression */ );
            node.elements = createNodeArray(sameFlatMap(elements, flattenCommaElements));
            node.transformFlags |= propagateChildrenFlags(node.elements);
            return node;
        }
        function updateCommaListExpression(node, elements) {
            return node.elements !== elements ? update(createCommaListExpression(elements), node) : node;
        }
        function createSyntheticReferenceExpression(expression, thisArg) {
            const node = createBaseNode(361 /* SyntheticReferenceExpression */ );
            node.expression = expression;
            node.thisArg = thisArg;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.thisArg);
            return node;
        }
        function updateSyntheticReferenceExpression(node, expression, thisArg) {
            return node.expression !== expression || node.thisArg !== thisArg ? update(createSyntheticReferenceExpression(expression, thisArg), node) : node;
        }
        function cloneGeneratedIdentifier(node) {
            const clone2 = createBaseIdentifier(node.escapedText);
            clone2.flags |= node.flags & -9 /* Synthesized */ ;
            clone2.transformFlags = node.transformFlags;
            setOriginalNode(clone2, node);
            setIdentifierAutoGenerate(clone2, {
                ...node.emitNode.autoGenerate
            });
            return clone2;
        }
        function cloneIdentifier(node) {
            const clone2 = createBaseIdentifier(node.escapedText);
            clone2.flags |= node.flags & -9 /* Synthesized */ ;
            clone2.jsDoc = node.jsDoc;
            clone2.flowNode = node.flowNode;
            clone2.symbol = node.symbol;
            clone2.transformFlags = node.transformFlags;
            setOriginalNode(clone2, node);
            const typeArguments = getIdentifierTypeArguments(node);
            if (typeArguments) setIdentifierTypeArguments(clone2, typeArguments);
            return clone2;
        }
        function cloneGeneratedPrivateIdentifier(node) {
            const clone2 = createBasePrivateIdentifier(node.escapedText);
            clone2.flags |= node.flags & -9 /* Synthesized */ ;
            clone2.transformFlags = node.transformFlags;
            setOriginalNode(clone2, node);
            setIdentifierAutoGenerate(clone2, {
                ...node.emitNode.autoGenerate
            });
            return clone2;
        }
        function clonePrivateIdentifier(node) {
            const clone2 = createBasePrivateIdentifier(node.escapedText);
            clone2.flags |= node.flags & -9 /* Synthesized */ ;
            clone2.transformFlags = node.transformFlags;
            setOriginalNode(clone2, node);
            return clone2;
        }
        function cloneNode(node) {
            if (node === void 0) return node;
            if (isSourceFile(node)) return cloneSourceFile(node);
            if (isGeneratedIdentifier(node)) return cloneGeneratedIdentifier(node);
            if (isIdentifier(node)) return cloneIdentifier(node);
            if (isGeneratedPrivateIdentifier(node)) return cloneGeneratedPrivateIdentifier(node);
            if (isPrivateIdentifier(node)) return clonePrivateIdentifier(node);
            const clone2 = !isNodeKind(node.kind) ? baseFactory2.createBaseTokenNode(node.kind) : baseFactory2.createBaseNode(node.kind);
            clone2.flags |= node.flags & -9 /* Synthesized */ ;
            clone2.transformFlags = node.transformFlags;
            setOriginalNode(clone2, node);
            for(const key in node){
                if (hasProperty(clone2, key) || !hasProperty(node, key)) continue;
                clone2[key] = node[key];
            }
            return clone2;
        }
        function createImmediatelyInvokedFunctionExpression(statements, param, paramValue) {
            return createCallExpression(createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, /*parameters*/ param ? [
                param
            ] : [], /*type*/ void 0, createBlock(statements, /*multiLine*/ true)), /*typeArguments*/ void 0, /*argumentsArray*/ paramValue ? [
                paramValue
            ] : []);
        }
        function createImmediatelyInvokedArrowFunction(statements, param, paramValue) {
            return createCallExpression(createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, /*parameters*/ param ? [
                param
            ] : [], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, createBlock(statements, /*multiLine*/ true)), /*typeArguments*/ void 0, /*argumentsArray*/ paramValue ? [
                paramValue
            ] : []);
        }
        function createVoidZero() {
            return createVoidExpression(createNumericLiteral("0"));
        }
        function createExportDefault(expression) {
            return createExportAssignment2(/*modifiers*/ void 0, /*isExportEquals*/ false, expression);
        }
        function createExternalModuleExport(exportName) {
            return createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, createNamedExports([
                createExportSpecifier(/*isTypeOnly*/ false, /*propertyName*/ void 0, exportName)
            ]));
        }
        function createTypeCheck(value1, tag) {
            return tag === "undefined" ? factory2.createStrictEquality(value1, createVoidZero()) : factory2.createStrictEquality(createTypeOfExpression(value1), createStringLiteral(tag));
        }
        function createMethodCall(object, methodName, argumentsList) {
            if (isCallChain(object)) return createCallChain(createPropertyAccessChain(object, /*questionDotToken*/ void 0, methodName), /*questionDotToken*/ void 0, /*typeArguments*/ void 0, argumentsList);
            return createCallExpression(createPropertyAccessExpression(object, methodName), /*typeArguments*/ void 0, argumentsList);
        }
        function createFunctionBindCall(target, thisArg, argumentsList) {
            return createMethodCall(target, "bind", [
                thisArg,
                ...argumentsList
            ]);
        }
        function createFunctionCallCall(target, thisArg, argumentsList) {
            return createMethodCall(target, "call", [
                thisArg,
                ...argumentsList
            ]);
        }
        function createFunctionApplyCall(target, thisArg, argumentsExpression) {
            return createMethodCall(target, "apply", [
                thisArg,
                argumentsExpression
            ]);
        }
        function createGlobalMethodCall(globalObjectName, methodName, argumentsList) {
            return createMethodCall(createIdentifier(globalObjectName), methodName, argumentsList);
        }
        function createArraySliceCall(array, start) {
            return createMethodCall(array, "slice", start === void 0 ? [] : [
                asExpression(start)
            ]);
        }
        function createArrayConcatCall(array, argumentsList) {
            return createMethodCall(array, "concat", argumentsList);
        }
        function createObjectDefinePropertyCall(target, propertyName, attributes) {
            return createGlobalMethodCall("Object", "defineProperty", [
                target,
                asExpression(propertyName),
                attributes
            ]);
        }
        function createObjectGetOwnPropertyDescriptorCall(target, propertyName) {
            return createGlobalMethodCall("Object", "getOwnPropertyDescriptor", [
                target,
                asExpression(propertyName)
            ]);
        }
        function createReflectGetCall(target, propertyKey, receiver) {
            return createGlobalMethodCall("Reflect", "get", receiver ? [
                target,
                propertyKey,
                receiver
            ] : [
                target,
                propertyKey
            ]);
        }
        function createReflectSetCall(target, propertyKey, value1, receiver) {
            return createGlobalMethodCall("Reflect", "set", receiver ? [
                target,
                propertyKey,
                value1,
                receiver
            ] : [
                target,
                propertyKey,
                value1
            ]);
        }
        function tryAddPropertyAssignment(properties, propertyName, expression) {
            if (expression) {
                properties.push(createPropertyAssignment(propertyName, expression));
                return true;
            }
            return false;
        }
        function createPropertyDescriptor(attributes, singleLine) {
            const properties = [];
            tryAddPropertyAssignment(properties, "enumerable", asExpression(attributes.enumerable));
            tryAddPropertyAssignment(properties, "configurable", asExpression(attributes.configurable));
            let isData = tryAddPropertyAssignment(properties, "writable", asExpression(attributes.writable));
            isData = tryAddPropertyAssignment(properties, "value", attributes.value) || isData;
            let isAccessor2 = tryAddPropertyAssignment(properties, "get", attributes.get);
            isAccessor2 = tryAddPropertyAssignment(properties, "set", attributes.set) || isAccessor2;
            Debug.assert(!(isData && isAccessor2), "A PropertyDescriptor may not be both an accessor descriptor and a data descriptor.");
            return createObjectLiteralExpression(properties, !singleLine);
        }
        function updateOuterExpression(outerExpression, expression) {
            switch(outerExpression.kind){
                case 216 /* ParenthesizedExpression */ :
                    return updateParenthesizedExpression(outerExpression, expression);
                case 215 /* TypeAssertionExpression */ :
                    return updateTypeAssertion(outerExpression, outerExpression.type, expression);
                case 233 /* AsExpression */ :
                    return updateAsExpression(outerExpression, expression, outerExpression.type);
                case 237 /* SatisfiesExpression */ :
                    return updateSatisfiesExpression(outerExpression, expression, outerExpression.type);
                case 234 /* NonNullExpression */ :
                    return updateNonNullExpression(outerExpression, expression);
                case 359 /* PartiallyEmittedExpression */ :
                    return updatePartiallyEmittedExpression(outerExpression, expression);
            }
        }
        function isIgnorableParen(node) {
            return isParenthesizedExpression(node) && nodeIsSynthesized(node) && nodeIsSynthesized(getSourceMapRange(node)) && nodeIsSynthesized(getCommentRange(node)) && !some(getSyntheticLeadingComments(node)) && !some(getSyntheticTrailingComments(node));
        }
        function restoreOuterExpressions(outerExpression, innerExpression, kinds = 15 /* All */ ) {
            if (outerExpression && isOuterExpression(outerExpression, kinds) && !isIgnorableParen(outerExpression)) return updateOuterExpression(outerExpression, restoreOuterExpressions(outerExpression.expression, innerExpression));
            return innerExpression;
        }
        function restoreEnclosingLabel(node, outermostLabeledStatement, afterRestoreLabelCallback) {
            if (!outermostLabeledStatement) return node;
            const updated = updateLabeledStatement(outermostLabeledStatement, outermostLabeledStatement.label, isLabeledStatement(outermostLabeledStatement.statement) ? restoreEnclosingLabel(node, outermostLabeledStatement.statement) : node);
            if (afterRestoreLabelCallback) afterRestoreLabelCallback(outermostLabeledStatement);
            return updated;
        }
        function shouldBeCapturedInTempVariable(node, cacheIdentifiers) {
            const target = skipParentheses(node);
            switch(target.kind){
                case 80 /* Identifier */ :
                    return cacheIdentifiers;
                case 110 /* ThisKeyword */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 11 /* StringLiteral */ :
                    return false;
                case 208 /* ArrayLiteralExpression */ :
                    const elements = target.elements;
                    if (elements.length === 0) return false;
                    return true;
                case 209 /* ObjectLiteralExpression */ :
                    return target.properties.length > 0;
                default:
                    return true;
            }
        }
        function createCallBinding(expression, recordTempVariable, languageVersion, cacheIdentifiers = false) {
            const callee = skipOuterExpressions(expression, 15 /* All */ );
            let thisArg;
            let target;
            if (isSuperProperty(callee)) {
                thisArg = createThis();
                target = callee;
            } else if (isSuperKeyword(callee)) {
                thisArg = createThis();
                target = languageVersion !== void 0 && languageVersion < 2 /* ES2015 */  ? setTextRange(createIdentifier("_super"), callee) : callee;
            } else if (getEmitFlags(callee) & 8192 /* HelperName */ ) {
                thisArg = createVoidZero();
                target = parenthesizerRules().parenthesizeLeftSideOfAccess(callee, /*optionalChain*/ false);
            } else if (isPropertyAccessExpression(callee)) {
                if (shouldBeCapturedInTempVariable(callee.expression, cacheIdentifiers)) {
                    thisArg = createTempVariable(recordTempVariable);
                    target = createPropertyAccessExpression(setTextRange(factory2.createAssignment(thisArg, callee.expression), callee.expression), callee.name);
                    setTextRange(target, callee);
                } else {
                    thisArg = callee.expression;
                    target = callee;
                }
            } else if (isElementAccessExpression(callee)) {
                if (shouldBeCapturedInTempVariable(callee.expression, cacheIdentifiers)) {
                    thisArg = createTempVariable(recordTempVariable);
                    target = createElementAccessExpression(setTextRange(factory2.createAssignment(thisArg, callee.expression), callee.expression), callee.argumentExpression);
                    setTextRange(target, callee);
                } else {
                    thisArg = callee.expression;
                    target = callee;
                }
            } else {
                thisArg = createVoidZero();
                target = parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false);
            }
            return {
                target: target,
                thisArg: thisArg
            };
        }
        function createAssignmentTargetWrapper(paramName, expression) {
            return createPropertyAccessExpression(// Explicit parens required because of v8 regression (https://bugs.chromium.org/p/v8/issues/detail?id=9560)
            createParenthesizedExpression(createObjectLiteralExpression([
                createSetAccessorDeclaration(/*modifiers*/ void 0, "value", [
                    createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, paramName, /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0)
                ], createBlock([
                    createExpressionStatement(expression)
                ]))
            ])), "value");
        }
        function inlineExpressions(expressions) {
            return expressions.length > 10 ? createCommaListExpression(expressions) : reduceLeft(expressions, factory2.createComma);
        }
        function getName(node, allowComments, allowSourceMaps, emitFlags = 0, ignoreAssignedName) {
            const nodeName = ignoreAssignedName ? node && getNonAssignedNameOfDeclaration(node) : getNameOfDeclaration(node);
            if (nodeName && isIdentifier(nodeName) && !isGeneratedIdentifier(nodeName)) {
                const name = setParent(setTextRange(cloneNode(nodeName), nodeName), nodeName.parent);
                emitFlags |= getEmitFlags(nodeName);
                if (!allowSourceMaps) emitFlags |= 96 /* NoSourceMap */ ;
                if (!allowComments) emitFlags |= 3072 /* NoComments */ ;
                if (emitFlags) setEmitFlags(name, emitFlags);
                return name;
            }
            return getGeneratedNameForNode(node);
        }
        function getInternalName(node, allowComments, allowSourceMaps) {
            return getName(node, allowComments, allowSourceMaps, 98304 /* InternalName */ );
        }
        function getLocalName(node, allowComments, allowSourceMaps, ignoreAssignedName) {
            return getName(node, allowComments, allowSourceMaps, 32768 /* LocalName */ , ignoreAssignedName);
        }
        function getExportName(node, allowComments, allowSourceMaps) {
            return getName(node, allowComments, allowSourceMaps, 16384 /* ExportName */ );
        }
        function getDeclarationName(node, allowComments, allowSourceMaps) {
            return getName(node, allowComments, allowSourceMaps);
        }
        function getNamespaceMemberName(ns, name, allowComments, allowSourceMaps) {
            const qualifiedName = createPropertyAccessExpression(ns, nodeIsSynthesized(name) ? name : cloneNode(name));
            setTextRange(qualifiedName, name);
            let emitFlags = 0;
            if (!allowSourceMaps) emitFlags |= 96 /* NoSourceMap */ ;
            if (!allowComments) emitFlags |= 3072 /* NoComments */ ;
            if (emitFlags) setEmitFlags(qualifiedName, emitFlags);
            return qualifiedName;
        }
        function getExternalModuleOrNamespaceExportName(ns, node, allowComments, allowSourceMaps) {
            if (ns && hasSyntacticModifier(node, 1 /* Export */ )) return getNamespaceMemberName(ns, getName(node), allowComments, allowSourceMaps);
            return getExportName(node, allowComments, allowSourceMaps);
        }
        function copyPrologue(source, target, ensureUseStrict2, visitor) {
            const offset = copyStandardPrologue(source, target, 0, ensureUseStrict2);
            return copyCustomPrologue(source, target, offset, visitor);
        }
        function isUseStrictPrologue2(node) {
            return isStringLiteral(node.expression) && node.expression.text === "use strict";
        }
        function createUseStrictPrologue() {
            return startOnNewLine(createExpressionStatement(createStringLiteral("use strict")));
        }
        function copyStandardPrologue(source, target, statementOffset = 0, ensureUseStrict2) {
            Debug.assert(target.length === 0, "Prologue directives should be at the first statement in the target statements array");
            let foundUseStrict = false;
            const numStatements = source.length;
            while(statementOffset < numStatements){
                const statement = source[statementOffset];
                if (isPrologueDirective(statement)) {
                    if (isUseStrictPrologue2(statement)) foundUseStrict = true;
                    target.push(statement);
                } else break;
                statementOffset++;
            }
            if (ensureUseStrict2 && !foundUseStrict) target.push(createUseStrictPrologue());
            return statementOffset;
        }
        function copyCustomPrologue(source, target, statementOffset, visitor, filter2 = returnTrue) {
            const numStatements = source.length;
            while(statementOffset !== void 0 && statementOffset < numStatements){
                const statement = source[statementOffset];
                if (getEmitFlags(statement) & 2097152 /* CustomPrologue */  && filter2(statement)) append(target, visitor ? visitNode(statement, visitor, isStatement) : statement);
                else break;
                statementOffset++;
            }
            return statementOffset;
        }
        function ensureUseStrict(statements) {
            const foundUseStrict = findUseStrictPrologue(statements);
            if (!foundUseStrict) return setTextRange(createNodeArray([
                createUseStrictPrologue(),
                ...statements
            ]), statements);
            return statements;
        }
        function liftToBlock(nodes) {
            Debug.assert(every(nodes, isStatementOrBlock), "Cannot lift nodes to a Block.");
            return singleOrUndefined(nodes) || createBlock(nodes);
        }
        function findSpanEnd(array, test, start) {
            let i = start;
            while(i < array.length && test(array[i]))i++;
            return i;
        }
        function mergeLexicalEnvironment(statements, declarations) {
            if (!some(declarations)) return statements;
            const leftStandardPrologueEnd = findSpanEnd(statements, isPrologueDirective, 0);
            const leftHoistedFunctionsEnd = findSpanEnd(statements, isHoistedFunction, leftStandardPrologueEnd);
            const leftHoistedVariablesEnd = findSpanEnd(statements, isHoistedVariableStatement, leftHoistedFunctionsEnd);
            const rightStandardPrologueEnd = findSpanEnd(declarations, isPrologueDirective, 0);
            const rightHoistedFunctionsEnd = findSpanEnd(declarations, isHoistedFunction, rightStandardPrologueEnd);
            const rightHoistedVariablesEnd = findSpanEnd(declarations, isHoistedVariableStatement, rightHoistedFunctionsEnd);
            const rightCustomPrologueEnd = findSpanEnd(declarations, isCustomPrologue, rightHoistedVariablesEnd);
            Debug.assert(rightCustomPrologueEnd === declarations.length, "Expected declarations to be valid standard or custom prologues");
            const left = isNodeArray(statements) ? statements.slice() : statements;
            if (rightCustomPrologueEnd > rightHoistedVariablesEnd) left.splice(leftHoistedVariablesEnd, 0, ...declarations.slice(rightHoistedVariablesEnd, rightCustomPrologueEnd));
            if (rightHoistedVariablesEnd > rightHoistedFunctionsEnd) left.splice(leftHoistedFunctionsEnd, 0, ...declarations.slice(rightHoistedFunctionsEnd, rightHoistedVariablesEnd));
            if (rightHoistedFunctionsEnd > rightStandardPrologueEnd) left.splice(leftStandardPrologueEnd, 0, ...declarations.slice(rightStandardPrologueEnd, rightHoistedFunctionsEnd));
            if (rightStandardPrologueEnd > 0) {
                if (leftStandardPrologueEnd === 0) left.splice(0, 0, ...declarations.slice(0, rightStandardPrologueEnd));
                else {
                    const leftPrologues = /* @__PURE__ */ new Map();
                    for(let i = 0; i < leftStandardPrologueEnd; i++){
                        const leftPrologue = statements[i];
                        leftPrologues.set(leftPrologue.expression.text, true);
                    }
                    for(let i = rightStandardPrologueEnd - 1; i >= 0; i--){
                        const rightPrologue = declarations[i];
                        if (!leftPrologues.has(rightPrologue.expression.text)) left.unshift(rightPrologue);
                    }
                }
            }
            if (isNodeArray(statements)) return setTextRange(createNodeArray(left, statements.hasTrailingComma), statements);
            return statements;
        }
        function updateModifiers(node, modifiers) {
            let modifierArray;
            if (typeof modifiers === "number") modifierArray = createModifiersFromModifierFlags(modifiers);
            else modifierArray = modifiers;
            return isTypeParameterDeclaration(node) ? updateTypeParameterDeclaration(node, modifierArray, node.name, node.constraint, node.default) : isParameter(node) ? updateParameterDeclaration(node, modifierArray, node.dotDotDotToken, node.name, node.questionToken, node.type, node.initializer) : isConstructorTypeNode(node) ? updateConstructorTypeNode1(node, modifierArray, node.typeParameters, node.parameters, node.type) : isPropertySignature(node) ? updatePropertySignature(node, modifierArray, node.name, node.questionToken, node.type) : isPropertyDeclaration(node) ? updatePropertyDeclaration2(node, modifierArray, node.name, node.questionToken ?? node.exclamationToken, node.type, node.initializer) : isMethodSignature(node) ? updateMethodSignature(node, modifierArray, node.name, node.questionToken, node.typeParameters, node.parameters, node.type) : isMethodDeclaration(node) ? updateMethodDeclaration(node, modifierArray, node.asteriskToken, node.name, node.questionToken, node.typeParameters, node.parameters, node.type, node.body) : isConstructorDeclaration(node) ? updateConstructorDeclaration(node, modifierArray, node.parameters, node.body) : isGetAccessorDeclaration(node) ? updateGetAccessorDeclaration(node, modifierArray, node.name, node.parameters, node.type, node.body) : isSetAccessorDeclaration(node) ? updateSetAccessorDeclaration(node, modifierArray, node.name, node.parameters, node.body) : isIndexSignatureDeclaration(node) ? updateIndexSignature(node, modifierArray, node.parameters, node.type) : isFunctionExpression(node) ? updateFunctionExpression(node, modifierArray, node.asteriskToken, node.name, node.typeParameters, node.parameters, node.type, node.body) : isArrowFunction(node) ? updateArrowFunction(node, modifierArray, node.typeParameters, node.parameters, node.type, node.equalsGreaterThanToken, node.body) : isClassExpression(node) ? updateClassExpression(node, modifierArray, node.name, node.typeParameters, node.heritageClauses, node.members) : isVariableStatement(node) ? updateVariableStatement(node, modifierArray, node.declarationList) : isFunctionDeclaration(node) ? updateFunctionDeclaration(node, modifierArray, node.asteriskToken, node.name, node.typeParameters, node.parameters, node.type, node.body) : isClassDeclaration(node) ? updateClassDeclaration(node, modifierArray, node.name, node.typeParameters, node.heritageClauses, node.members) : isInterfaceDeclaration(node) ? updateInterfaceDeclaration(node, modifierArray, node.name, node.typeParameters, node.heritageClauses, node.members) : isTypeAliasDeclaration(node) ? updateTypeAliasDeclaration(node, modifierArray, node.name, node.typeParameters, node.type) : isEnumDeclaration(node) ? updateEnumDeclaration(node, modifierArray, node.name, node.members) : isModuleDeclaration(node) ? updateModuleDeclaration(node, modifierArray, node.name, node.body) : isImportEqualsDeclaration(node) ? updateImportEqualsDeclaration(node, modifierArray, node.isTypeOnly, node.name, node.moduleReference) : isImportDeclaration(node) ? updateImportDeclaration(node, modifierArray, node.importClause, node.moduleSpecifier, node.assertClause) : isExportAssignment(node) ? updateExportAssignment(node, modifierArray, node.expression) : isExportDeclaration(node) ? updateExportDeclaration(node, modifierArray, node.isTypeOnly, node.exportClause, node.moduleSpecifier, node.assertClause) : Debug.assertNever(node);
        }
        function asNodeArray(array) {
            return array ? createNodeArray(array) : void 0;
        }
        function asName(name) {
            return typeof name === "string" ? createIdentifier(name) : name;
        }
        function asExpression(value1) {
            return typeof value1 === "string" ? createStringLiteral(value1) : typeof value1 === "number" ? createNumericLiteral(value1) : typeof value1 === "boolean" ? value1 ? createTrue() : createFalse() : value1;
        }
        function asInitializer(node) {
            return node && parenthesizerRules().parenthesizeExpressionForDisallowedComma(node);
        }
        function asToken(value1) {
            return typeof value1 === "number" ? createToken(value1) : value1;
        }
        function asEmbeddedStatement(statement) {
            return statement && isNotEmittedStatement(statement) ? setTextRange(setOriginalNode(createEmptyStatement(), statement), statement) : statement;
        }
        function asVariableDeclaration(variableDeclaration) {
            if (typeof variableDeclaration === "string" || variableDeclaration && !isVariableDeclaration(variableDeclaration)) return createVariableDeclaration(variableDeclaration, /*exclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
            return variableDeclaration;
        }
    }
    function updateWithoutOriginal(updated, original) {
        if (updated !== original) setTextRange(updated, original);
        return updated;
    }
    function updateWithOriginal(updated, original) {
        if (updated !== original) {
            setOriginalNode(updated, original);
            setTextRange(updated, original);
        }
        return updated;
    }
    function getDefaultTagNameForKind(kind) {
        switch(kind){
            case 350 /* JSDocTypeTag */ :
                return "type";
            case 348 /* JSDocReturnTag */ :
                return "returns";
            case 349 /* JSDocThisTag */ :
                return "this";
            case 346 /* JSDocEnumTag */ :
                return "enum";
            case 336 /* JSDocAuthorTag */ :
                return "author";
            case 338 /* JSDocClassTag */ :
                return "class";
            case 339 /* JSDocPublicTag */ :
                return "public";
            case 340 /* JSDocPrivateTag */ :
                return "private";
            case 341 /* JSDocProtectedTag */ :
                return "protected";
            case 342 /* JSDocReadonlyTag */ :
                return "readonly";
            case 343 /* JSDocOverrideTag */ :
                return "override";
            case 351 /* JSDocTemplateTag */ :
                return "template";
            case 352 /* JSDocTypedefTag */ :
                return "typedef";
            case 347 /* JSDocParameterTag */ :
                return "param";
            case 354 /* JSDocPropertyTag */ :
                return "prop";
            case 344 /* JSDocCallbackTag */ :
                return "callback";
            case 345 /* JSDocOverloadTag */ :
                return "overload";
            case 334 /* JSDocAugmentsTag */ :
                return "augments";
            case 335 /* JSDocImplementsTag */ :
                return "implements";
            default:
                return Debug.fail(`Unsupported kind: ${Debug.formatSyntaxKind(kind)}`);
        }
    }
    function getCookedText(kind, rawText) {
        if (!rawTextScanner) rawTextScanner = createScanner(99 /* Latest */ , /*skipTrivia*/ false, 0 /* Standard */ );
        switch(kind){
            case 15 /* NoSubstitutionTemplateLiteral */ :
                rawTextScanner.setText("`" + rawText + "`");
                break;
            case 16 /* TemplateHead */ :
                rawTextScanner.setText("`" + rawText + "${");
                break;
            case 17 /* TemplateMiddle */ :
                rawTextScanner.setText("}" + rawText + "${");
                break;
            case 18 /* TemplateTail */ :
                rawTextScanner.setText("}" + rawText + "`");
                break;
        }
        let token = rawTextScanner.scan();
        if (token === 20 /* CloseBraceToken */ ) token = rawTextScanner.reScanTemplateToken(/*isTaggedTemplate*/ false);
        if (rawTextScanner.isUnterminated()) {
            rawTextScanner.setText(void 0);
            return invalidValueSentinel;
        }
        let tokenValue;
        switch(token){
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 16 /* TemplateHead */ :
            case 17 /* TemplateMiddle */ :
            case 18 /* TemplateTail */ :
                tokenValue = rawTextScanner.getTokenValue();
                break;
        }
        if (tokenValue === void 0 || rawTextScanner.scan() !== 1 /* EndOfFileToken */ ) {
            rawTextScanner.setText(void 0);
            return invalidValueSentinel;
        }
        rawTextScanner.setText(void 0);
        return tokenValue;
    }
    function propagateNameFlags(node) {
        return node && isIdentifier(node) ? propagateIdentifierNameFlags(node) : propagateChildFlags(node);
    }
    function propagateIdentifierNameFlags(node) {
        return propagateChildFlags(node) & -67108865 /* ContainsPossibleTopLevelAwait */ ;
    }
    function propagatePropertyNameFlagsOfChild(node, transformFlags) {
        return transformFlags | node.transformFlags & 134234112 /* PropertyNamePropagatingFlags */ ;
    }
    function propagateChildFlags(child) {
        if (!child) return 0 /* None */ ;
        const childFlags = child.transformFlags & ~getTransformFlagsSubtreeExclusions(child.kind);
        return isNamedDeclaration(child) && isPropertyName(child.name) ? propagatePropertyNameFlagsOfChild(child.name, childFlags) : childFlags;
    }
    function propagateChildrenFlags(children) {
        return children ? children.transformFlags : 0 /* None */ ;
    }
    function aggregateChildrenFlags(children) {
        let subtreeFlags = 0 /* None */ ;
        for (const child of children)subtreeFlags |= propagateChildFlags(child);
        children.transformFlags = subtreeFlags;
    }
    function getTransformFlagsSubtreeExclusions(kind) {
        if (kind >= 181 /* FirstTypeNode */  && kind <= 204 /* LastTypeNode */ ) return -2 /* TypeExcludes */ ;
        switch(kind){
            case 212 /* CallExpression */ :
            case 213 /* NewExpression */ :
            case 208 /* ArrayLiteralExpression */ :
                return -2147450880 /* ArrayLiteralOrCallOrNewExcludes */ ;
            case 266 /* ModuleDeclaration */ :
                return -1941676032 /* ModuleExcludes */ ;
            case 168 /* Parameter */ :
                return -2147483648 /* ParameterExcludes */ ;
            case 218 /* ArrowFunction */ :
                return -2072174592 /* ArrowFunctionExcludes */ ;
            case 217 /* FunctionExpression */ :
            case 261 /* FunctionDeclaration */ :
                return -1937940480 /* FunctionExcludes */ ;
            case 260 /* VariableDeclarationList */ :
                return -2146893824 /* VariableDeclarationListExcludes */ ;
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
                return -2147344384 /* ClassExcludes */ ;
            case 175 /* Constructor */ :
                return -1937948672 /* ConstructorExcludes */ ;
            case 171 /* PropertyDeclaration */ :
                return -2013249536 /* PropertyExcludes */ ;
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
                return -2005057536 /* MethodOrAccessorExcludes */ ;
            case 133 /* AnyKeyword */ :
            case 150 /* NumberKeyword */ :
            case 162 /* BigIntKeyword */ :
            case 146 /* NeverKeyword */ :
            case 154 /* StringKeyword */ :
            case 151 /* ObjectKeyword */ :
            case 136 /* BooleanKeyword */ :
            case 155 /* SymbolKeyword */ :
            case 116 /* VoidKeyword */ :
            case 167 /* TypeParameter */ :
            case 170 /* PropertySignature */ :
            case 172 /* MethodSignature */ :
            case 178 /* CallSignature */ :
            case 179 /* ConstructSignature */ :
            case 180 /* IndexSignature */ :
            case 263 /* InterfaceDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
                return -2 /* TypeExcludes */ ;
            case 209 /* ObjectLiteralExpression */ :
                return -2147278848 /* ObjectLiteralExcludes */ ;
            case 298 /* CatchClause */ :
                return -2147418112 /* CatchClauseExcludes */ ;
            case 205 /* ObjectBindingPattern */ :
            case 206 /* ArrayBindingPattern */ :
                return -2147450880 /* BindingPatternExcludes */ ;
            case 215 /* TypeAssertionExpression */ :
            case 237 /* SatisfiesExpression */ :
            case 233 /* AsExpression */ :
            case 359 /* PartiallyEmittedExpression */ :
            case 216 /* ParenthesizedExpression */ :
            case 108 /* SuperKeyword */ :
                return -2147483648 /* OuterExpressionExcludes */ ;
            case 210 /* PropertyAccessExpression */ :
            case 211 /* ElementAccessExpression */ :
                return -2147483648 /* PropertyAccessExcludes */ ;
            default:
                return -2147483648 /* NodeExcludes */ ;
        }
    }
    function makeSynthetic(node) {
        node.flags |= 8 /* Synthesized */ ;
        return node;
    }
    function createUnparsedSourceFile(textOrInputFiles, mapPathOrType, mapTextOrStripInternal) {
        let stripInternal;
        let bundleFileInfo;
        let fileName;
        let text;
        let length2;
        let sourceMapPath;
        let sourceMapText;
        let getText;
        let getSourceMapText;
        let oldFileOfCurrentEmit;
        if (!isString(textOrInputFiles)) {
            Debug.assert(mapPathOrType === "js" || mapPathOrType === "dts");
            fileName = (mapPathOrType === "js" ? textOrInputFiles.javascriptPath : textOrInputFiles.declarationPath) || "";
            sourceMapPath = mapPathOrType === "js" ? textOrInputFiles.javascriptMapPath : textOrInputFiles.declarationMapPath;
            getText = ()=>mapPathOrType === "js" ? textOrInputFiles.javascriptText : textOrInputFiles.declarationText;
            getSourceMapText = ()=>mapPathOrType === "js" ? textOrInputFiles.javascriptMapText : textOrInputFiles.declarationMapText;
            length2 = ()=>getText().length;
            if (textOrInputFiles.buildInfo && textOrInputFiles.buildInfo.bundle) {
                Debug.assert(mapTextOrStripInternal === void 0 || typeof mapTextOrStripInternal === "boolean");
                stripInternal = mapTextOrStripInternal;
                bundleFileInfo = mapPathOrType === "js" ? textOrInputFiles.buildInfo.bundle.js : textOrInputFiles.buildInfo.bundle.dts;
                oldFileOfCurrentEmit = textOrInputFiles.oldFileOfCurrentEmit;
            }
        } else {
            fileName = "";
            text = textOrInputFiles;
            length2 = textOrInputFiles.length;
            sourceMapPath = mapPathOrType;
            sourceMapText = mapTextOrStripInternal;
        }
        const node = oldFileOfCurrentEmit ? parseOldFileOfCurrentEmit(Debug.checkDefined(bundleFileInfo)) : parseUnparsedSourceFile(bundleFileInfo, stripInternal, length2);
        node.fileName = fileName;
        node.sourceMapPath = sourceMapPath;
        node.oldFileOfCurrentEmit = oldFileOfCurrentEmit;
        if (getText && getSourceMapText) {
            Object.defineProperty(node, "text", {
                get: getText
            });
            Object.defineProperty(node, "sourceMapText", {
                get: getSourceMapText
            });
        } else {
            Debug.assert(!oldFileOfCurrentEmit);
            node.text = text ?? "";
            node.sourceMapText = sourceMapText;
        }
        return node;
    }
    function parseUnparsedSourceFile(bundleFileInfo, stripInternal, length2) {
        let prologues;
        let helpers;
        let referencedFiles;
        let typeReferenceDirectives;
        let libReferenceDirectives;
        let prependChildren;
        let texts;
        let hasNoDefaultLib;
        for (const section of bundleFileInfo ? bundleFileInfo.sections : emptyArray)switch(section.kind){
            case "prologue" /* Prologue */ :
                prologues = append(prologues, setTextRange(factory.createUnparsedPrologue(section.data), section));
                break;
            case "emitHelpers" /* EmitHelpers */ :
                helpers = append(helpers, getAllUnscopedEmitHelpers().get(section.data));
                break;
            case "no-default-lib" /* NoDefaultLib */ :
                hasNoDefaultLib = true;
                break;
            case "reference" /* Reference */ :
                referencedFiles = append(referencedFiles, {
                    pos: -1,
                    end: -1,
                    fileName: section.data
                });
                break;
            case "type" /* Type */ :
                typeReferenceDirectives = append(typeReferenceDirectives, {
                    pos: -1,
                    end: -1,
                    fileName: section.data
                });
                break;
            case "type-import" /* TypeResolutionModeImport */ :
                typeReferenceDirectives = append(typeReferenceDirectives, {
                    pos: -1,
                    end: -1,
                    fileName: section.data,
                    resolutionMode: 99 /* ESNext */ 
                });
                break;
            case "type-require" /* TypeResolutionModeRequire */ :
                typeReferenceDirectives = append(typeReferenceDirectives, {
                    pos: -1,
                    end: -1,
                    fileName: section.data,
                    resolutionMode: 1 /* CommonJS */ 
                });
                break;
            case "lib" /* Lib */ :
                libReferenceDirectives = append(libReferenceDirectives, {
                    pos: -1,
                    end: -1,
                    fileName: section.data
                });
                break;
            case "prepend" /* Prepend */ :
                let prependTexts;
                for (const text of section.texts)if (!stripInternal || text.kind !== "internal" /* Internal */ ) prependTexts = append(prependTexts, setTextRange(factory.createUnparsedTextLike(text.data, text.kind === "internal" /* Internal */ ), text));
                prependChildren = addRange(prependChildren, prependTexts);
                texts = append(texts, factory.createUnparsedPrepend(section.data, prependTexts ?? emptyArray));
                break;
            case "internal" /* Internal */ :
                if (stripInternal) {
                    if (!texts) texts = [];
                    break;
                }
            case "text" /* Text */ :
                texts = append(texts, setTextRange(factory.createUnparsedTextLike(section.data, section.kind === "internal" /* Internal */ ), section));
                break;
            default:
                Debug.assertNever(section);
        }
        if (!texts) {
            const textNode = factory.createUnparsedTextLike(/*data*/ void 0, /*internal*/ false);
            setTextRangePosWidth(textNode, 0, typeof length2 === "function" ? length2() : length2);
            texts = [
                textNode
            ];
        }
        const node = parseNodeFactory.createUnparsedSource(prologues ?? emptyArray, /*syntheticReferences*/ void 0, texts);
        setEachParent(prologues, node);
        setEachParent(texts, node);
        setEachParent(prependChildren, node);
        node.hasNoDefaultLib = hasNoDefaultLib;
        node.helpers = helpers;
        node.referencedFiles = referencedFiles || emptyArray;
        node.typeReferenceDirectives = typeReferenceDirectives;
        node.libReferenceDirectives = libReferenceDirectives || emptyArray;
        return node;
    }
    function parseOldFileOfCurrentEmit(bundleFileInfo) {
        let texts;
        let syntheticReferences;
        for (const section of bundleFileInfo.sections)switch(section.kind){
            case "internal" /* Internal */ :
            case "text" /* Text */ :
                texts = append(texts, setTextRange(factory.createUnparsedTextLike(section.data, section.kind === "internal" /* Internal */ ), section));
                break;
            case "no-default-lib" /* NoDefaultLib */ :
            case "reference" /* Reference */ :
            case "type" /* Type */ :
            case "type-import" /* TypeResolutionModeImport */ :
            case "type-require" /* TypeResolutionModeRequire */ :
            case "lib" /* Lib */ :
                syntheticReferences = append(syntheticReferences, setTextRange(factory.createUnparsedSyntheticReference(section), section));
                break;
            case "prologue" /* Prologue */ :
            case "emitHelpers" /* EmitHelpers */ :
            case "prepend" /* Prepend */ :
                break;
            default:
                Debug.assertNever(section);
        }
        const node = factory.createUnparsedSource(emptyArray, syntheticReferences, texts ?? emptyArray);
        setEachParent(syntheticReferences, node);
        setEachParent(texts, node);
        node.helpers = map(bundleFileInfo.sources && bundleFileInfo.sources.helpers, (name)=>getAllUnscopedEmitHelpers().get(name));
        return node;
    }
    function createInputFiles(javascriptTextOrReadFileText, declarationTextOrJavascriptPath, javascriptMapPath, javascriptMapTextOrDeclarationPath, declarationMapPath, declarationMapTextOrBuildInfoPath) {
        return !isString(javascriptTextOrReadFileText) ? createInputFilesWithFilePaths(javascriptTextOrReadFileText, declarationTextOrJavascriptPath, javascriptMapPath, javascriptMapTextOrDeclarationPath, declarationMapPath, declarationMapTextOrBuildInfoPath) : createInputFilesWithFileTexts(/*javascriptPath*/ void 0, javascriptTextOrReadFileText, javascriptMapPath, javascriptMapTextOrDeclarationPath, /*declarationPath*/ void 0, declarationTextOrJavascriptPath, declarationMapPath, declarationMapTextOrBuildInfoPath);
    }
    function createInputFilesWithFilePaths(readFileText, javascriptPath, javascriptMapPath, declarationPath, declarationMapPath, buildInfoPath, host, options) {
        const node = parseNodeFactory.createInputFiles();
        node.javascriptPath = javascriptPath;
        node.javascriptMapPath = javascriptMapPath;
        node.declarationPath = declarationPath;
        node.declarationMapPath = declarationMapPath;
        node.buildInfoPath = buildInfoPath;
        const cache = /* @__PURE__ */ new Map();
        const textGetter = (path)=>{
            if (path === void 0) return void 0;
            let value1 = cache.get(path);
            if (value1 === void 0) {
                value1 = readFileText(path);
                cache.set(path, value1 !== void 0 ? value1 : false);
            }
            return value1 !== false ? value1 : void 0;
        };
        const definedTextGetter = (path)=>{
            const result = textGetter(path);
            return result !== void 0 ? result : `/* Input file ${path} was missing */\r
`;
        };
        let buildInfo;
        const getAndCacheBuildInfo = ()=>{
            if (buildInfo === void 0 && buildInfoPath) {
                if (host == null ? void 0 : host.getBuildInfo) buildInfo = host.getBuildInfo(buildInfoPath, options.configFilePath) ?? false;
                else {
                    const result = textGetter(buildInfoPath);
                    buildInfo = result !== void 0 ? getBuildInfo(buildInfoPath, result) ?? false : false;
                }
            }
            return buildInfo || void 0;
        };
        Object.defineProperties(node, {
            javascriptText: {
                get: ()=>definedTextGetter(javascriptPath)
            },
            javascriptMapText: {
                get: ()=>textGetter(javascriptMapPath)
            },
            // TODO:: if there is inline sourceMap in jsFile, use that
            declarationText: {
                get: ()=>definedTextGetter(Debug.checkDefined(declarationPath))
            },
            declarationMapText: {
                get: ()=>textGetter(declarationMapPath)
            },
            // TODO:: if there is inline sourceMap in dtsFile, use that
            buildInfo: {
                get: getAndCacheBuildInfo
            }
        });
        return node;
    }
    function createInputFilesWithFileTexts(javascriptPath, javascriptText, javascriptMapPath, javascriptMapText, declarationPath, declarationText, declarationMapPath, declarationMapText, buildInfoPath, buildInfo, oldFileOfCurrentEmit) {
        const node = parseNodeFactory.createInputFiles();
        node.javascriptPath = javascriptPath;
        node.javascriptText = javascriptText;
        node.javascriptMapPath = javascriptMapPath;
        node.javascriptMapText = javascriptMapText;
        node.declarationPath = declarationPath;
        node.declarationText = declarationText;
        node.declarationMapPath = declarationMapPath;
        node.declarationMapText = declarationMapText;
        node.buildInfoPath = buildInfoPath;
        node.buildInfo = buildInfo;
        node.oldFileOfCurrentEmit = oldFileOfCurrentEmit;
        return node;
    }
    function createSourceMapSource(fileName, text, skipTrivia2) {
        return new (SourceMapSource2 || (SourceMapSource2 = objectAllocator.getSourceMapSourceConstructor()))(fileName, text, skipTrivia2);
    }
    function setOriginalNode(node, original) {
        node.original = original;
        if (original) {
            const emitNode = original.emitNode;
            if (emitNode) node.emitNode = mergeEmitNode(emitNode, node.emitNode);
        }
        return node;
    }
    function mergeEmitNode(sourceEmitNode, destEmitNode) {
        const { flags: flags , internalFlags: internalFlags , leadingComments: leadingComments , trailingComments: trailingComments , commentRange: commentRange , sourceMapRange: sourceMapRange , tokenSourceMapRanges: tokenSourceMapRanges , constantValue: constantValue , helpers: helpers , startsOnNewLine: startsOnNewLine , snippetElement: snippetElement  } = sourceEmitNode;
        if (!destEmitNode) destEmitNode = {};
        if (leadingComments) destEmitNode.leadingComments = addRange(leadingComments.slice(), destEmitNode.leadingComments);
        if (trailingComments) destEmitNode.trailingComments = addRange(trailingComments.slice(), destEmitNode.trailingComments);
        if (flags) destEmitNode.flags = flags;
        if (internalFlags) destEmitNode.internalFlags = internalFlags & -9 /* Immutable */ ;
        if (commentRange) destEmitNode.commentRange = commentRange;
        if (sourceMapRange) destEmitNode.sourceMapRange = sourceMapRange;
        if (tokenSourceMapRanges) destEmitNode.tokenSourceMapRanges = mergeTokenSourceMapRanges(tokenSourceMapRanges, destEmitNode.tokenSourceMapRanges);
        if (constantValue !== void 0) destEmitNode.constantValue = constantValue;
        if (helpers) for (const helper of helpers)destEmitNode.helpers = appendIfUnique(destEmitNode.helpers, helper);
        if (startsOnNewLine !== void 0) destEmitNode.startsOnNewLine = startsOnNewLine;
        if (snippetElement !== void 0) destEmitNode.snippetElement = snippetElement;
        return destEmitNode;
    }
    function mergeTokenSourceMapRanges(sourceRanges, destRanges) {
        if (!destRanges) destRanges = [];
        for(const key in sourceRanges)destRanges[key] = sourceRanges[key];
        return destRanges;
    }
    var nextAutoGenerateId, NodeFactoryFlags, nodeFactoryPatchers, rawTextScanner, invalidValueSentinel, baseFactory, syntheticFactory, factory, SourceMapSource2;
    var init_nodeFactory = __esm({
        "src/compiler/factory/nodeFactory.ts" () {
            "use strict";
            init_ts2();
            nextAutoGenerateId = 0;
            NodeFactoryFlags = /* @__PURE__ */ ((NodeFactoryFlags2)=>{
                NodeFactoryFlags2[NodeFactoryFlags2["None"] = 0] = "None";
                NodeFactoryFlags2[NodeFactoryFlags2["NoParenthesizerRules"] = 1] = "NoParenthesizerRules";
                NodeFactoryFlags2[NodeFactoryFlags2["NoNodeConverters"] = 2] = "NoNodeConverters";
                NodeFactoryFlags2[NodeFactoryFlags2["NoIndentationOnFreshPropertyAccess"] = 4] = "NoIndentationOnFreshPropertyAccess";
                NodeFactoryFlags2[NodeFactoryFlags2["NoOriginalNode"] = 8] = "NoOriginalNode";
                return NodeFactoryFlags2;
            })(NodeFactoryFlags || {});
            nodeFactoryPatchers = [];
            invalidValueSentinel = {};
            baseFactory = createBaseNodeFactory();
            syntheticFactory = {
                createBaseSourceFileNode: (kind)=>makeSynthetic(baseFactory.createBaseSourceFileNode(kind)),
                createBaseIdentifierNode: (kind)=>makeSynthetic(baseFactory.createBaseIdentifierNode(kind)),
                createBasePrivateIdentifierNode: (kind)=>makeSynthetic(baseFactory.createBasePrivateIdentifierNode(kind)),
                createBaseTokenNode: (kind)=>makeSynthetic(baseFactory.createBaseTokenNode(kind)),
                createBaseNode: (kind)=>makeSynthetic(baseFactory.createBaseNode(kind))
            };
            factory = createNodeFactory(4 /* NoIndentationOnFreshPropertyAccess */ , syntheticFactory);
        }
    });
    // src/compiler/factory/emitNode.ts
    function getOrCreateEmitNode(node) {
        if (!node.emitNode) {
            if (isParseTreeNode(node)) {
                if (node.kind === 311 /* SourceFile */ ) return node.emitNode = {
                    annotatedNodes: [
                        node
                    ]
                };
                const sourceFile = getSourceFileOfNode(getParseTreeNode(getSourceFileOfNode(node))) ?? Debug.fail("Could not determine parsed source file.");
                getOrCreateEmitNode(sourceFile).annotatedNodes.push(node);
            }
            node.emitNode = {};
        } else Debug.assert(!(node.emitNode.internalFlags & 8 /* Immutable */ ), "Invalid attempt to mutate an immutable node.");
        return node.emitNode;
    }
    function disposeEmitNodes(sourceFile) {
        var _a, _b;
        const annotatedNodes = (_b = (_a = getSourceFileOfNode(getParseTreeNode(sourceFile))) == null ? void 0 : _a.emitNode) == null ? void 0 : _b.annotatedNodes;
        if (annotatedNodes) for (const node of annotatedNodes)node.emitNode = void 0;
    }
    function removeAllComments(node) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.flags |= 3072 /* NoComments */ ;
        emitNode.leadingComments = void 0;
        emitNode.trailingComments = void 0;
        return node;
    }
    function setEmitFlags(node, emitFlags) {
        getOrCreateEmitNode(node).flags = emitFlags;
        return node;
    }
    function addEmitFlags(node, emitFlags) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.flags = emitNode.flags | emitFlags;
        return node;
    }
    function setInternalEmitFlags(node, emitFlags) {
        getOrCreateEmitNode(node).internalFlags = emitFlags;
        return node;
    }
    function addInternalEmitFlags(node, emitFlags) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.internalFlags = emitNode.internalFlags | emitFlags;
        return node;
    }
    function getSourceMapRange(node) {
        var _a;
        return ((_a = node.emitNode) == null ? void 0 : _a.sourceMapRange) ?? node;
    }
    function setSourceMapRange(node, range) {
        getOrCreateEmitNode(node).sourceMapRange = range;
        return node;
    }
    function getTokenSourceMapRange(node, token) {
        var _a, _b;
        return (_b = (_a = node.emitNode) == null ? void 0 : _a.tokenSourceMapRanges) == null ? void 0 : _b[token];
    }
    function setTokenSourceMapRange(node, token, range) {
        const emitNode = getOrCreateEmitNode(node);
        const tokenSourceMapRanges = emitNode.tokenSourceMapRanges ?? (emitNode.tokenSourceMapRanges = []);
        tokenSourceMapRanges[token] = range;
        return node;
    }
    function getStartsOnNewLine(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.startsOnNewLine;
    }
    function setStartsOnNewLine(node, newLine) {
        getOrCreateEmitNode(node).startsOnNewLine = newLine;
        return node;
    }
    function getCommentRange(node) {
        var _a;
        return ((_a = node.emitNode) == null ? void 0 : _a.commentRange) ?? node;
    }
    function setCommentRange(node, range) {
        getOrCreateEmitNode(node).commentRange = range;
        return node;
    }
    function getSyntheticLeadingComments(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.leadingComments;
    }
    function setSyntheticLeadingComments(node, comments) {
        getOrCreateEmitNode(node).leadingComments = comments;
        return node;
    }
    function addSyntheticLeadingComment(node, kind, text, hasTrailingNewLine) {
        return setSyntheticLeadingComments(node, append(getSyntheticLeadingComments(node), {
            kind: kind,
            pos: -1,
            end: -1,
            hasTrailingNewLine: hasTrailingNewLine,
            text: text
        }));
    }
    function getSyntheticTrailingComments(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.trailingComments;
    }
    function setSyntheticTrailingComments(node, comments) {
        getOrCreateEmitNode(node).trailingComments = comments;
        return node;
    }
    function addSyntheticTrailingComment(node, kind, text, hasTrailingNewLine) {
        return setSyntheticTrailingComments(node, append(getSyntheticTrailingComments(node), {
            kind: kind,
            pos: -1,
            end: -1,
            hasTrailingNewLine: hasTrailingNewLine,
            text: text
        }));
    }
    function moveSyntheticComments(node, original) {
        setSyntheticLeadingComments(node, getSyntheticLeadingComments(original));
        setSyntheticTrailingComments(node, getSyntheticTrailingComments(original));
        const emit = getOrCreateEmitNode(original);
        emit.leadingComments = void 0;
        emit.trailingComments = void 0;
        return node;
    }
    function getConstantValue(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.constantValue;
    }
    function setConstantValue(node, value1) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.constantValue = value1;
        return node;
    }
    function addEmitHelper(node, helper) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.helpers = append(emitNode.helpers, helper);
        return node;
    }
    function addEmitHelpers(node, helpers) {
        if (some(helpers)) {
            const emitNode = getOrCreateEmitNode(node);
            for (const helper of helpers)emitNode.helpers = appendIfUnique(emitNode.helpers, helper);
        }
        return node;
    }
    function removeEmitHelper(node, helper) {
        var _a;
        const helpers = (_a = node.emitNode) == null ? void 0 : _a.helpers;
        if (helpers) return orderedRemoveItem(helpers, helper);
        return false;
    }
    function getEmitHelpers(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.helpers;
    }
    function moveEmitHelpers(source, target, predicate) {
        const sourceEmitNode = source.emitNode;
        const sourceEmitHelpers = sourceEmitNode && sourceEmitNode.helpers;
        if (!some(sourceEmitHelpers)) return;
        const targetEmitNode = getOrCreateEmitNode(target);
        let helpersRemoved = 0;
        for(let i = 0; i < sourceEmitHelpers.length; i++){
            const helper = sourceEmitHelpers[i];
            if (predicate(helper)) {
                helpersRemoved++;
                targetEmitNode.helpers = appendIfUnique(targetEmitNode.helpers, helper);
            } else if (helpersRemoved > 0) sourceEmitHelpers[i - helpersRemoved] = helper;
        }
        if (helpersRemoved > 0) sourceEmitHelpers.length -= helpersRemoved;
    }
    function getSnippetElement(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.snippetElement;
    }
    function setSnippetElement(node, snippet) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.snippetElement = snippet;
        return node;
    }
    function ignoreSourceNewlines(node) {
        getOrCreateEmitNode(node).internalFlags |= 4 /* IgnoreSourceNewlines */ ;
        return node;
    }
    function setTypeNode(node, type) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.typeNode = type;
        return node;
    }
    function getTypeNode(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.typeNode;
    }
    function setIdentifierTypeArguments(node, typeArguments) {
        getOrCreateEmitNode(node).identifierTypeArguments = typeArguments;
        return node;
    }
    function getIdentifierTypeArguments(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.identifierTypeArguments;
    }
    function setIdentifierAutoGenerate(node, autoGenerate) {
        getOrCreateEmitNode(node).autoGenerate = autoGenerate;
        return node;
    }
    function getIdentifierAutoGenerate(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.autoGenerate;
    }
    function setIdentifierGeneratedImportReference(node, value1) {
        getOrCreateEmitNode(node).generatedImportReference = value1;
        return node;
    }
    function getIdentifierGeneratedImportReference(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.generatedImportReference;
    }
    var init_emitNode = __esm({
        "src/compiler/factory/emitNode.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/factory/emitHelpers.ts
    function createEmitHelperFactory(context) {
        const factory2 = context.factory;
        const immutableTrue = memoize(()=>setInternalEmitFlags(factory2.createTrue(), 8 /* Immutable */ ));
        const immutableFalse = memoize(()=>setInternalEmitFlags(factory2.createFalse(), 8 /* Immutable */ ));
        return {
            getUnscopedHelperName: getUnscopedHelperName,
            createDecorateHelper: // TypeScript Helpers
            createDecorateHelper,
            createMetadataHelper: createMetadataHelper,
            createParamHelper: createParamHelper,
            createESDecorateHelper: // ES Decorators Helpers
            createESDecorateHelper,
            createRunInitializersHelper: createRunInitializersHelper,
            createAssignHelper: // ES2018 Helpers
            createAssignHelper,
            createAwaitHelper: createAwaitHelper,
            createAsyncGeneratorHelper: createAsyncGeneratorHelper,
            createAsyncDelegatorHelper: createAsyncDelegatorHelper,
            createAsyncValuesHelper: createAsyncValuesHelper,
            createRestHelper: // ES2018 Destructuring Helpers
            createRestHelper,
            createAwaiterHelper: // ES2017 Helpers
            createAwaiterHelper,
            createExtendsHelper: // ES2015 Helpers
            createExtendsHelper,
            createTemplateObjectHelper: createTemplateObjectHelper,
            createSpreadArrayHelper: createSpreadArrayHelper,
            createPropKeyHelper: createPropKeyHelper,
            createSetFunctionNameHelper: createSetFunctionNameHelper,
            createValuesHelper: // ES2015 Destructuring Helpers
            createValuesHelper,
            createReadHelper: createReadHelper,
            createGeneratorHelper: // ES2015 Generator Helpers
            createGeneratorHelper,
            createCreateBindingHelper: // ES Module Helpers
            createCreateBindingHelper,
            createImportStarHelper: createImportStarHelper,
            createImportStarCallbackHelper: createImportStarCallbackHelper,
            createImportDefaultHelper: createImportDefaultHelper,
            createExportStarHelper: createExportStarHelper,
            createClassPrivateFieldGetHelper: // Class Fields Helpers
            createClassPrivateFieldGetHelper,
            createClassPrivateFieldSetHelper: createClassPrivateFieldSetHelper,
            createClassPrivateFieldInHelper: createClassPrivateFieldInHelper
        };
        function getUnscopedHelperName(name) {
            return setEmitFlags(factory2.createIdentifier(name), 8196 /* AdviseOnEmitNode */ );
        }
        function createDecorateHelper(decoratorExpressions, target, memberName, descriptor) {
            context.requestEmitHelper(decorateHelper);
            const argumentsArray = [];
            argumentsArray.push(factory2.createArrayLiteralExpression(decoratorExpressions, /*multiLine*/ true));
            argumentsArray.push(target);
            if (memberName) {
                argumentsArray.push(memberName);
                if (descriptor) argumentsArray.push(descriptor);
            }
            return factory2.createCallExpression(getUnscopedHelperName("__decorate"), /*typeArguments*/ void 0, argumentsArray);
        }
        function createMetadataHelper(metadataKey, metadataValue) {
            context.requestEmitHelper(metadataHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__metadata"), /*typeArguments*/ void 0, [
                factory2.createStringLiteral(metadataKey),
                metadataValue
            ]);
        }
        function createParamHelper(expression, parameterOffset, location) {
            context.requestEmitHelper(paramHelper);
            return setTextRange(factory2.createCallExpression(getUnscopedHelperName("__param"), /*typeArguments*/ void 0, [
                factory2.createNumericLiteral(parameterOffset + ""),
                expression
            ]), location);
        }
        function createESDecorateClassContextObject(contextIn) {
            return factory2.createObjectLiteralExpression([
                factory2.createPropertyAssignment(factory2.createIdentifier("kind"), factory2.createStringLiteral("class")),
                factory2.createPropertyAssignment(factory2.createIdentifier("name"), contextIn.name)
            ]);
        }
        function createESDecorateClassElementAccessGetMethod(elementName) {
            const accessor = elementName.computed ? factory2.createElementAccessExpression(factory2.createIdentifier("obj"), elementName.name) : factory2.createPropertyAccessExpression(factory2.createIdentifier("obj"), elementName.name);
            return factory2.createPropertyAssignment("get", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.createIdentifier("obj"))
            ], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, accessor));
        }
        function createESDecorateClassElementAccessSetMethod(elementName) {
            const accessor = elementName.computed ? factory2.createElementAccessExpression(factory2.createIdentifier("obj"), elementName.name) : factory2.createPropertyAccessExpression(factory2.createIdentifier("obj"), elementName.name);
            return factory2.createPropertyAssignment("set", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.createIdentifier("obj")),
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.createIdentifier("value"))
            ], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, factory2.createBlock([
                factory2.createExpressionStatement(factory2.createAssignment(accessor, factory2.createIdentifier("value")))
            ])));
        }
        function createESDecorateClassElementAccessHasMethod(elementName) {
            const propertyName = elementName.computed ? elementName.name : isIdentifier(elementName.name) ? factory2.createStringLiteralFromNode(elementName.name) : elementName.name;
            return factory2.createPropertyAssignment("has", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.createIdentifier("obj"))
            ], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, factory2.createBinaryExpression(propertyName, 103 /* InKeyword */ , factory2.createIdentifier("obj"))));
        }
        function createESDecorateClassElementAccessObject(name, access) {
            const properties = [];
            properties.push(createESDecorateClassElementAccessHasMethod(name));
            if (access.get) properties.push(createESDecorateClassElementAccessGetMethod(name));
            if (access.set) properties.push(createESDecorateClassElementAccessSetMethod(name));
            return factory2.createObjectLiteralExpression(properties);
        }
        function createESDecorateClassElementContextObject(contextIn) {
            return factory2.createObjectLiteralExpression([
                factory2.createPropertyAssignment(factory2.createIdentifier("kind"), factory2.createStringLiteral(contextIn.kind)),
                factory2.createPropertyAssignment(factory2.createIdentifier("name"), contextIn.name.computed ? contextIn.name.name : factory2.createStringLiteralFromNode(contextIn.name.name)),
                factory2.createPropertyAssignment(factory2.createIdentifier("static"), contextIn.static ? factory2.createTrue() : factory2.createFalse()),
                factory2.createPropertyAssignment(factory2.createIdentifier("private"), contextIn.private ? factory2.createTrue() : factory2.createFalse()),
                factory2.createPropertyAssignment(factory2.createIdentifier("access"), createESDecorateClassElementAccessObject(contextIn.name, contextIn.access))
            ]);
        }
        function createESDecorateContextObject(contextIn) {
            return contextIn.kind === "class" ? createESDecorateClassContextObject(contextIn) : createESDecorateClassElementContextObject(contextIn);
        }
        function createESDecorateHelper(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
            context.requestEmitHelper(esDecorateHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__esDecorate"), /*typeArguments*/ void 0, [
                ctor ?? factory2.createNull(),
                descriptorIn ?? factory2.createNull(),
                decorators,
                createESDecorateContextObject(contextIn),
                initializers,
                extraInitializers
            ]);
        }
        function createRunInitializersHelper(thisArg, initializers, value1) {
            context.requestEmitHelper(runInitializersHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__runInitializers"), /*typeArguments*/ void 0, value1 ? [
                thisArg,
                initializers,
                value1
            ] : [
                thisArg,
                initializers
            ]);
        }
        function createAssignHelper(attributesSegments) {
            if (getEmitScriptTarget(context.getCompilerOptions()) >= 2 /* ES2015 */ ) return factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Object"), "assign"), /*typeArguments*/ void 0, attributesSegments);
            context.requestEmitHelper(assignHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__assign"), /*typeArguments*/ void 0, attributesSegments);
        }
        function createAwaitHelper(expression) {
            context.requestEmitHelper(awaitHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__await"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createAsyncGeneratorHelper(generatorFunc, hasLexicalThis) {
            context.requestEmitHelper(awaitHelper);
            context.requestEmitHelper(asyncGeneratorHelper);
            (generatorFunc.emitNode || (generatorFunc.emitNode = {})).flags |= 1572864 /* ReuseTempVariableScope */ ;
            return factory2.createCallExpression(getUnscopedHelperName("__asyncGenerator"), /*typeArguments*/ void 0, [
                hasLexicalThis ? factory2.createThis() : factory2.createVoidZero(),
                factory2.createIdentifier("arguments"),
                generatorFunc
            ]);
        }
        function createAsyncDelegatorHelper(expression) {
            context.requestEmitHelper(awaitHelper);
            context.requestEmitHelper(asyncDelegator);
            return factory2.createCallExpression(getUnscopedHelperName("__asyncDelegator"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createAsyncValuesHelper(expression) {
            context.requestEmitHelper(asyncValues);
            return factory2.createCallExpression(getUnscopedHelperName("__asyncValues"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createRestHelper(value1, elements, computedTempVariables, location) {
            context.requestEmitHelper(restHelper);
            const propertyNames = [];
            let computedTempVariableOffset = 0;
            for(let i = 0; i < elements.length - 1; i++){
                const propertyName = getPropertyNameOfBindingOrAssignmentElement(elements[i]);
                if (propertyName) {
                    if (isComputedPropertyName(propertyName)) {
                        Debug.assertIsDefined(computedTempVariables, "Encountered computed property name but 'computedTempVariables' argument was not provided.");
                        const temp = computedTempVariables[computedTempVariableOffset];
                        computedTempVariableOffset++;
                        propertyNames.push(factory2.createConditionalExpression(factory2.createTypeCheck(temp, "symbol"), /*questionToken*/ void 0, temp, /*colonToken*/ void 0, factory2.createAdd(temp, factory2.createStringLiteral(""))));
                    } else propertyNames.push(factory2.createStringLiteralFromNode(propertyName));
                }
            }
            return factory2.createCallExpression(getUnscopedHelperName("__rest"), /*typeArguments*/ void 0, [
                value1,
                setTextRange(factory2.createArrayLiteralExpression(propertyNames), location)
            ]);
        }
        function createAwaiterHelper(hasLexicalThis, hasLexicalArguments, promiseConstructor, body) {
            context.requestEmitHelper(awaiterHelper);
            const generatorFunc = factory2.createFunctionExpression(/*modifiers*/ void 0, factory2.createToken(42 /* AsteriskToken */ ), /*name*/ void 0, /*typeParameters*/ void 0, /*parameters*/ [], /*type*/ void 0, body);
            (generatorFunc.emitNode || (generatorFunc.emitNode = {})).flags |= 1572864 /* ReuseTempVariableScope */ ;
            return factory2.createCallExpression(getUnscopedHelperName("__awaiter"), /*typeArguments*/ void 0, [
                hasLexicalThis ? factory2.createThis() : factory2.createVoidZero(),
                hasLexicalArguments ? factory2.createIdentifier("arguments") : factory2.createVoidZero(),
                promiseConstructor ? createExpressionFromEntityName(factory2, promiseConstructor) : factory2.createVoidZero(),
                generatorFunc
            ]);
        }
        function createExtendsHelper(name) {
            context.requestEmitHelper(extendsHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__extends"), /*typeArguments*/ void 0, [
                name,
                factory2.createUniqueName("_super", 48 /* FileLevel */ )
            ]);
        }
        function createTemplateObjectHelper(cooked, raw) {
            context.requestEmitHelper(templateObjectHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__makeTemplateObject"), /*typeArguments*/ void 0, [
                cooked,
                raw
            ]);
        }
        function createSpreadArrayHelper(to, from, packFrom) {
            context.requestEmitHelper(spreadArrayHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__spreadArray"), /*typeArguments*/ void 0, [
                to,
                from,
                packFrom ? immutableTrue() : immutableFalse()
            ]);
        }
        function createPropKeyHelper(expr) {
            context.requestEmitHelper(propKeyHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__propKey"), /*typeArguments*/ void 0, [
                expr
            ]);
        }
        function createSetFunctionNameHelper(f, name, prefix) {
            context.requestEmitHelper(setFunctionNameHelper);
            return context.factory.createCallExpression(getUnscopedHelperName("__setFunctionName"), /*typeArguments*/ void 0, prefix ? [
                f,
                name,
                context.factory.createStringLiteral(prefix)
            ] : [
                f,
                name
            ]);
        }
        function createValuesHelper(expression) {
            context.requestEmitHelper(valuesHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__values"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createReadHelper(iteratorRecord, count) {
            context.requestEmitHelper(readHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__read"), /*typeArguments*/ void 0, count !== void 0 ? [
                iteratorRecord,
                factory2.createNumericLiteral(count + "")
            ] : [
                iteratorRecord
            ]);
        }
        function createGeneratorHelper(body) {
            context.requestEmitHelper(generatorHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__generator"), /*typeArguments*/ void 0, [
                factory2.createThis(),
                body
            ]);
        }
        function createCreateBindingHelper(module2, inputName, outputName) {
            context.requestEmitHelper(createBindingHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__createBinding"), /*typeArguments*/ void 0, [
                factory2.createIdentifier("exports"),
                module2,
                inputName,
                ...outputName ? [
                    outputName
                ] : []
            ]);
        }
        function createImportStarHelper(expression) {
            context.requestEmitHelper(importStarHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__importStar"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createImportStarCallbackHelper() {
            context.requestEmitHelper(importStarHelper);
            return getUnscopedHelperName("__importStar");
        }
        function createImportDefaultHelper(expression) {
            context.requestEmitHelper(importDefaultHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__importDefault"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createExportStarHelper(moduleExpression, exportsExpression = factory2.createIdentifier("exports")) {
            context.requestEmitHelper(exportStarHelper);
            context.requestEmitHelper(createBindingHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__exportStar"), /*typeArguments*/ void 0, [
                moduleExpression,
                exportsExpression
            ]);
        }
        function createClassPrivateFieldGetHelper(receiver, state, kind, f) {
            context.requestEmitHelper(classPrivateFieldGetHelper);
            let args;
            if (!f) args = [
                receiver,
                state,
                factory2.createStringLiteral(kind)
            ];
            else args = [
                receiver,
                state,
                factory2.createStringLiteral(kind),
                f
            ];
            return factory2.createCallExpression(getUnscopedHelperName("__classPrivateFieldGet"), /*typeArguments*/ void 0, args);
        }
        function createClassPrivateFieldSetHelper(receiver, state, value1, kind, f) {
            context.requestEmitHelper(classPrivateFieldSetHelper);
            let args;
            if (!f) args = [
                receiver,
                state,
                value1,
                factory2.createStringLiteral(kind)
            ];
            else args = [
                receiver,
                state,
                value1,
                factory2.createStringLiteral(kind),
                f
            ];
            return factory2.createCallExpression(getUnscopedHelperName("__classPrivateFieldSet"), /*typeArguments*/ void 0, args);
        }
        function createClassPrivateFieldInHelper(state, receiver) {
            context.requestEmitHelper(classPrivateFieldInHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__classPrivateFieldIn"), /*typeArguments*/ void 0, [
                state,
                receiver
            ]);
        }
    }
    function compareEmitHelpers(x, y) {
        if (x === y) return 0 /* EqualTo */ ;
        if (x.priority === y.priority) return 0 /* EqualTo */ ;
        if (x.priority === void 0) return 1 /* GreaterThan */ ;
        if (y.priority === void 0) return -1 /* LessThan */ ;
        return compareValues(x.priority, y.priority);
    }
    function helperString(input, ...args) {
        return (uniqueName)=>{
            let result = "";
            for(let i = 0; i < args.length; i++){
                result += input[i];
                result += uniqueName(args[i]);
            }
            result += input[input.length - 1];
            return result;
        };
    }
    function getAllUnscopedEmitHelpers() {
        return allUnscopedEmitHelpers || (allUnscopedEmitHelpers = arrayToMap([
            decorateHelper,
            metadataHelper,
            paramHelper,
            esDecorateHelper,
            runInitializersHelper,
            assignHelper,
            awaitHelper,
            asyncGeneratorHelper,
            asyncDelegator,
            asyncValues,
            restHelper,
            awaiterHelper,
            extendsHelper,
            templateObjectHelper,
            spreadArrayHelper,
            valuesHelper,
            readHelper,
            propKeyHelper,
            setFunctionNameHelper,
            generatorHelper,
            importStarHelper,
            importDefaultHelper,
            exportStarHelper,
            classPrivateFieldGetHelper,
            classPrivateFieldSetHelper,
            classPrivateFieldInHelper,
            createBindingHelper,
            setModuleDefaultHelper
        ], (helper)=>helper.name));
    }
    function isCallToHelper(firstSegment, helperName) {
        return isCallExpression(firstSegment) && isIdentifier(firstSegment.expression) && (getEmitFlags(firstSegment.expression) & 8192 /* HelperName */ ) !== 0 && firstSegment.expression.escapedText === helperName;
    }
    var PrivateIdentifierKind, decorateHelper, metadataHelper, paramHelper, esDecorateHelper, runInitializersHelper, assignHelper, awaitHelper, asyncGeneratorHelper, asyncDelegator, asyncValues, restHelper, awaiterHelper, extendsHelper, templateObjectHelper, readHelper, spreadArrayHelper, propKeyHelper, setFunctionNameHelper, valuesHelper, generatorHelper, createBindingHelper, setModuleDefaultHelper, importStarHelper, importDefaultHelper, exportStarHelper, classPrivateFieldGetHelper, classPrivateFieldSetHelper, classPrivateFieldInHelper, allUnscopedEmitHelpers, asyncSuperHelper, advancedAsyncSuperHelper;
    var init_emitHelpers = __esm({
        "src/compiler/factory/emitHelpers.ts" () {
            "use strict";
            init_ts2();
            PrivateIdentifierKind = /* @__PURE__ */ ((PrivateIdentifierKind2)=>{
                PrivateIdentifierKind2["Field"] = "f";
                PrivateIdentifierKind2["Method"] = "m";
                PrivateIdentifierKind2["Accessor"] = "a";
                return PrivateIdentifierKind2;
            })(PrivateIdentifierKind || {});
            decorateHelper = {
                name: "typescript:decorate",
                importName: "__decorate",
                scoped: false,
                priority: 2,
                text: `
            var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };`
            };
            metadataHelper = {
                name: "typescript:metadata",
                importName: "__metadata",
                scoped: false,
                priority: 3,
                text: `
            var __metadata = (this && this.__metadata) || function (k, v) {
                if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
            };`
            };
            paramHelper = {
                name: "typescript:param",
                importName: "__param",
                scoped: false,
                priority: 4,
                text: `
            var __param = (this && this.__param) || function (paramIndex, decorator) {
                return function (target, key) { decorator(target, key, paramIndex); }
            };`
            };
            esDecorateHelper = {
                name: "typescript:esDecorate",
                importName: "__esDecorate",
                scoped: false,
                priority: 2,
                text: `
        var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
            function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
            var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
            var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
            var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
            var _, done = false;
            for (var i = decorators.length - 1; i >= 0; i--) {
                var context = {};
                for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
                for (var p in contextIn.access) context.access[p] = contextIn.access[p];
                context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
                var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
                if (kind === "accessor") {
                    if (result === void 0) continue;
                    if (result === null || typeof result !== "object") throw new TypeError("Object expected");
                    if (_ = accept(result.get)) descriptor.get = _;
                    if (_ = accept(result.set)) descriptor.set = _;
                    if (_ = accept(result.init)) initializers.unshift(_);
                }
                else if (_ = accept(result)) {
                    if (kind === "field") initializers.unshift(_);
                    else descriptor[key] = _;
                }
            }
            if (target) Object.defineProperty(target, contextIn.name, descriptor);
            done = true;
        };`
            };
            runInitializersHelper = {
                name: "typescript:runInitializers",
                importName: "__runInitializers",
                scoped: false,
                priority: 2,
                text: `
        var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
            var useValue = arguments.length > 2;
            for (var i = 0; i < initializers.length; i++) {
                value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
            }
            return useValue ? value : void 0;
        };`
            };
            assignHelper = {
                name: "typescript:assign",
                importName: "__assign",
                scoped: false,
                priority: 1,
                text: `
            var __assign = (this && this.__assign) || function () {
                __assign = Object.assign || function(t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                            t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };`
            };
            awaitHelper = {
                name: "typescript:await",
                importName: "__await",
                scoped: false,
                text: `
            var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }`
            };
            asyncGeneratorHelper = {
                name: "typescript:asyncGenerator",
                importName: "__asyncGenerator",
                scoped: false,
                dependencies: [
                    awaitHelper
                ],
                text: `
            var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var g = generator.apply(thisArg, _arguments || []), i, q = [];
                return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
                function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
                function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
                function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
                function fulfill(value) { resume("next", value); }
                function reject(value) { resume("throw", value); }
                function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
            };`
            };
            asyncDelegator = {
                name: "typescript:asyncDelegator",
                importName: "__asyncDelegator",
                scoped: false,
                dependencies: [
                    awaitHelper
                ],
                text: `
            var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
                var i, p;
                return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
                function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
            };`
            };
            asyncValues = {
                name: "typescript:asyncValues",
                importName: "__asyncValues",
                scoped: false,
                text: `
            var __asyncValues = (this && this.__asyncValues) || function (o) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var m = o[Symbol.asyncIterator], i;
                return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
                function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
                function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
            };`
            };
            restHelper = {
                name: "typescript:rest",
                importName: "__rest",
                scoped: false,
                text: `
            var __rest = (this && this.__rest) || function (s, e) {
                var t = {};
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
                    t[p] = s[p];
                if (s != null && typeof Object.getOwnPropertySymbols === "function")
                    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                            t[p[i]] = s[p[i]];
                    }
                return t;
            };`
            };
            awaiterHelper = {
                name: "typescript:awaiter",
                importName: "__awaiter",
                scoped: false,
                priority: 5,
                text: `
            var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
                function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
                return new (P || (P = Promise))(function (resolve, reject) {
                    function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
                    function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
                    function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };`
            };
            extendsHelper = {
                name: "typescript:extends",
                importName: "__extends",
                scoped: false,
                priority: 0,
                text: `
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = function (d, b) {
                    extendStatics = Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
                    return extendStatics(d, b);
                };

                return function (d, b) {
                    if (typeof b !== "function" && b !== null)
                        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();`
            };
            templateObjectHelper = {
                name: "typescript:makeTemplateObject",
                importName: "__makeTemplateObject",
                scoped: false,
                priority: 0,
                text: `
            var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
                if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
                return cooked;
            };`
            };
            readHelper = {
                name: "typescript:read",
                importName: "__read",
                scoped: false,
                text: `
            var __read = (this && this.__read) || function (o, n) {
                var m = typeof Symbol === "function" && o[Symbol.iterator];
                if (!m) return o;
                var i = m.call(o), r, ar = [], e;
                try {
                    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
                }
                catch (error) { e = { error: error }; }
                finally {
                    try {
                        if (r && !r.done && (m = i["return"])) m.call(i);
                    }
                    finally { if (e) throw e.error; }
                }
                return ar;
            };`
            };
            spreadArrayHelper = {
                name: "typescript:spreadArray",
                importName: "__spreadArray",
                scoped: false,
                text: `
            var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
                if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
                    if (ar || !(i in from)) {
                        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                        ar[i] = from[i];
                    }
                }
                return to.concat(ar || Array.prototype.slice.call(from));
            };`
            };
            propKeyHelper = {
                name: "typescript:propKey",
                importName: "__propKey",
                scoped: false,
                text: `
        var __propKey = (this && this.__propKey) || function (x) {
            return typeof x === "symbol" ? x : "".concat(x);
        };`
            };
            setFunctionNameHelper = {
                name: "typescript:setFunctionName",
                importName: "__setFunctionName",
                scoped: false,
                text: `
        var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
            if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
            return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
        };`
            };
            valuesHelper = {
                name: "typescript:values",
                importName: "__values",
                scoped: false,
                text: `
            var __values = (this && this.__values) || function(o) {
                var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
                if (m) return m.call(o);
                if (o && typeof o.length === "number") return {
                    next: function () {
                        if (o && i >= o.length) o = void 0;
                        return { value: o && o[i++], done: !o };
                    }
                };
                throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };`
            };
            generatorHelper = {
                name: "typescript:generator",
                importName: "__generator",
                scoped: false,
                priority: 6,
                text: `
            var __generator = (this && this.__generator) || function (thisArg, body) {
                var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
                return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
                function verb(n) { return function (v) { return step([n, v]); }; }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while (g && (g = 0, op[0] && (_ = 0)), _) try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [op[0] & 2, t.value];
                        switch (op[0]) {
                            case 0: case 1: t = op; break;
                            case 4: _.label++; return { value: op[1], done: false };
                            case 5: _.label++; y = op[1]; op = [0]; continue;
                            case 7: op = _.ops.pop(); _.trys.pop(); continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                                if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                                if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                                if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                                if (t[2]) _.ops.pop();
                                _.trys.pop(); continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
                    if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
                }
            };`
            };
            createBindingHelper = {
                name: "typescript:commonjscreatebinding",
                importName: "__createBinding",
                scoped: false,
                priority: 1,
                text: `
            var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                var desc = Object.getOwnPropertyDescriptor(m, k);
                if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                  desc = { enumerable: true, get: function() { return m[k]; } };
                }
                Object.defineProperty(o, k2, desc);
            }) : (function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            }));`
            };
            setModuleDefaultHelper = {
                name: "typescript:commonjscreatevalue",
                importName: "__setModuleDefault",
                scoped: false,
                priority: 1,
                text: `
            var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
                Object.defineProperty(o, "default", { enumerable: true, value: v });
            }) : function(o, v) {
                o["default"] = v;
            });`
            };
            importStarHelper = {
                name: "typescript:commonjsimportstar",
                importName: "__importStar",
                scoped: false,
                dependencies: [
                    createBindingHelper,
                    setModuleDefaultHelper
                ],
                priority: 2,
                text: `
            var __importStar = (this && this.__importStar) || function (mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                __setModuleDefault(result, mod);
                return result;
            };`
            };
            importDefaultHelper = {
                name: "typescript:commonjsimportdefault",
                importName: "__importDefault",
                scoped: false,
                text: `
            var __importDefault = (this && this.__importDefault) || function (mod) {
                return (mod && mod.__esModule) ? mod : { "default": mod };
            };`
            };
            exportStarHelper = {
                name: "typescript:export-star",
                importName: "__exportStar",
                scoped: false,
                dependencies: [
                    createBindingHelper
                ],
                priority: 2,
                text: `
            var __exportStar = (this && this.__exportStar) || function(m, exports) {
                for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
            };`
            };
            classPrivateFieldGetHelper = {
                name: "typescript:classPrivateFieldGet",
                importName: "__classPrivateFieldGet",
                scoped: false,
                text: `
            var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
                if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
                if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
            };`
            };
            classPrivateFieldSetHelper = {
                name: "typescript:classPrivateFieldSet",
                importName: "__classPrivateFieldSet",
                scoped: false,
                text: `
            var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
                if (kind === "m") throw new TypeError("Private method is not writable");
                if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
                if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
            };`
            };
            classPrivateFieldInHelper = {
                name: "typescript:classPrivateFieldIn",
                importName: "__classPrivateFieldIn",
                scoped: false,
                text: `
            var __classPrivateFieldIn = (this && this.__classPrivateFieldIn) || function(state, receiver) {
                if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
                return typeof state === "function" ? receiver === state : state.has(receiver);
            };`
            };
            asyncSuperHelper = {
                name: "typescript:async-super",
                scoped: true,
                text: helperString`
            const ${"_superIndex"} = name => super[name];`
            };
            advancedAsyncSuperHelper = {
                name: "typescript:advanced-async-super",
                scoped: true,
                text: helperString`
            const ${"_superIndex"} = (function (geti, seti) {
                const cache = Object.create(null);
                return name => cache[name] || (cache[name] = { get value() { return geti(name); }, set value(v) { seti(name, v); } });
            })(name => super[name], (name, value) => super[name] = value);`
            };
        }
    });
    // src/compiler/factory/nodeTests.ts
    function isNumericLiteral(node) {
        return node.kind === 9 /* NumericLiteral */ ;
    }
    function isBigIntLiteral(node) {
        return node.kind === 10 /* BigIntLiteral */ ;
    }
    function isStringLiteral(node) {
        return node.kind === 11 /* StringLiteral */ ;
    }
    function isJsxText(node) {
        return node.kind === 12 /* JsxText */ ;
    }
    function isRegularExpressionLiteral(node) {
        return node.kind === 14 /* RegularExpressionLiteral */ ;
    }
    function isNoSubstitutionTemplateLiteral(node) {
        return node.kind === 15 /* NoSubstitutionTemplateLiteral */ ;
    }
    function isTemplateHead(node) {
        return node.kind === 16 /* TemplateHead */ ;
    }
    function isTemplateMiddle(node) {
        return node.kind === 17 /* TemplateMiddle */ ;
    }
    function isTemplateTail(node) {
        return node.kind === 18 /* TemplateTail */ ;
    }
    function isDotDotDotToken(node) {
        return node.kind === 26 /* DotDotDotToken */ ;
    }
    function isCommaToken(node) {
        return node.kind === 28 /* CommaToken */ ;
    }
    function isPlusToken(node) {
        return node.kind === 40 /* PlusToken */ ;
    }
    function isMinusToken(node) {
        return node.kind === 41 /* MinusToken */ ;
    }
    function isAsteriskToken(node) {
        return node.kind === 42 /* AsteriskToken */ ;
    }
    function isExclamationToken(node) {
        return node.kind === 54 /* ExclamationToken */ ;
    }
    function isQuestionToken(node) {
        return node.kind === 58 /* QuestionToken */ ;
    }
    function isColonToken(node) {
        return node.kind === 59 /* ColonToken */ ;
    }
    function isQuestionDotToken(node) {
        return node.kind === 29 /* QuestionDotToken */ ;
    }
    function isEqualsGreaterThanToken(node) {
        return node.kind === 39 /* EqualsGreaterThanToken */ ;
    }
    function isIdentifier(node) {
        return node.kind === 80 /* Identifier */ ;
    }
    function isPrivateIdentifier(node) {
        return node.kind === 81 /* PrivateIdentifier */ ;
    }
    function isExportModifier(node) {
        return node.kind === 95 /* ExportKeyword */ ;
    }
    function isDefaultModifier(node) {
        return node.kind === 90 /* DefaultKeyword */ ;
    }
    function isAsyncModifier(node) {
        return node.kind === 134 /* AsyncKeyword */ ;
    }
    function isAssertsKeyword(node) {
        return node.kind === 131 /* AssertsKeyword */ ;
    }
    function isAwaitKeyword(node) {
        return node.kind === 135 /* AwaitKeyword */ ;
    }
    function isReadonlyKeyword(node) {
        return node.kind === 148 /* ReadonlyKeyword */ ;
    }
    function isStaticModifier(node) {
        return node.kind === 126 /* StaticKeyword */ ;
    }
    function isAbstractModifier(node) {
        return node.kind === 128 /* AbstractKeyword */ ;
    }
    function isOverrideModifier(node) {
        return node.kind === 163 /* OverrideKeyword */ ;
    }
    function isAccessorModifier(node) {
        return node.kind === 129 /* AccessorKeyword */ ;
    }
    function isSuperKeyword(node) {
        return node.kind === 108 /* SuperKeyword */ ;
    }
    function isImportKeyword(node) {
        return node.kind === 102 /* ImportKeyword */ ;
    }
    function isCaseKeyword(node) {
        return node.kind === 84 /* CaseKeyword */ ;
    }
    function isQualifiedName(node) {
        return node.kind === 165 /* QualifiedName */ ;
    }
    function isComputedPropertyName(node) {
        return node.kind === 166 /* ComputedPropertyName */ ;
    }
    function isTypeParameterDeclaration(node) {
        return node.kind === 167 /* TypeParameter */ ;
    }
    function isParameter(node) {
        return node.kind === 168 /* Parameter */ ;
    }
    function isDecorator(node) {
        return node.kind === 169 /* Decorator */ ;
    }
    function isPropertySignature(node) {
        return node.kind === 170 /* PropertySignature */ ;
    }
    function isPropertyDeclaration(node) {
        return node.kind === 171 /* PropertyDeclaration */ ;
    }
    function isMethodSignature(node) {
        return node.kind === 172 /* MethodSignature */ ;
    }
    function isMethodDeclaration(node) {
        return node.kind === 173 /* MethodDeclaration */ ;
    }
    function isClassStaticBlockDeclaration(node) {
        return node.kind === 174 /* ClassStaticBlockDeclaration */ ;
    }
    function isConstructorDeclaration(node) {
        return node.kind === 175 /* Constructor */ ;
    }
    function isGetAccessorDeclaration(node) {
        return node.kind === 176 /* GetAccessor */ ;
    }
    function isSetAccessorDeclaration(node) {
        return node.kind === 177 /* SetAccessor */ ;
    }
    function isCallSignatureDeclaration(node) {
        return node.kind === 178 /* CallSignature */ ;
    }
    function isConstructSignatureDeclaration(node) {
        return node.kind === 179 /* ConstructSignature */ ;
    }
    function isIndexSignatureDeclaration(node) {
        return node.kind === 180 /* IndexSignature */ ;
    }
    function isTypePredicateNode(node) {
        return node.kind === 181 /* TypePredicate */ ;
    }
    function isTypeReferenceNode(node) {
        return node.kind === 182 /* TypeReference */ ;
    }
    function isFunctionTypeNode(node) {
        return node.kind === 183 /* FunctionType */ ;
    }
    function isConstructorTypeNode(node) {
        return node.kind === 184 /* ConstructorType */ ;
    }
    function isTypeQueryNode(node) {
        return node.kind === 185 /* TypeQuery */ ;
    }
    function isTypeLiteralNode(node) {
        return node.kind === 186 /* TypeLiteral */ ;
    }
    function isArrayTypeNode(node) {
        return node.kind === 187 /* ArrayType */ ;
    }
    function isTupleTypeNode(node) {
        return node.kind === 188 /* TupleType */ ;
    }
    function isNamedTupleMember(node) {
        return node.kind === 201 /* NamedTupleMember */ ;
    }
    function isOptionalTypeNode(node) {
        return node.kind === 189 /* OptionalType */ ;
    }
    function isRestTypeNode(node) {
        return node.kind === 190 /* RestType */ ;
    }
    function isUnionTypeNode(node) {
        return node.kind === 191 /* UnionType */ ;
    }
    function isIntersectionTypeNode(node) {
        return node.kind === 192 /* IntersectionType */ ;
    }
    function isConditionalTypeNode(node) {
        return node.kind === 193 /* ConditionalType */ ;
    }
    function isInferTypeNode(node) {
        return node.kind === 194 /* InferType */ ;
    }
    function isParenthesizedTypeNode(node) {
        return node.kind === 195 /* ParenthesizedType */ ;
    }
    function isThisTypeNode(node) {
        return node.kind === 196 /* ThisType */ ;
    }
    function isTypeOperatorNode(node) {
        return node.kind === 197 /* TypeOperator */ ;
    }
    function isIndexedAccessTypeNode(node) {
        return node.kind === 198 /* IndexedAccessType */ ;
    }
    function isMappedTypeNode(node) {
        return node.kind === 199 /* MappedType */ ;
    }
    function isLiteralTypeNode(node) {
        return node.kind === 200 /* LiteralType */ ;
    }
    function isImportTypeNode(node) {
        return node.kind === 204 /* ImportType */ ;
    }
    function isTemplateLiteralTypeSpan(node) {
        return node.kind === 203 /* TemplateLiteralTypeSpan */ ;
    }
    function isTemplateLiteralTypeNode(node) {
        return node.kind === 202 /* TemplateLiteralType */ ;
    }
    function isObjectBindingPattern(node) {
        return node.kind === 205 /* ObjectBindingPattern */ ;
    }
    function isArrayBindingPattern(node) {
        return node.kind === 206 /* ArrayBindingPattern */ ;
    }
    function isBindingElement(node) {
        return node.kind === 207 /* BindingElement */ ;
    }
    function isArrayLiteralExpression(node) {
        return node.kind === 208 /* ArrayLiteralExpression */ ;
    }
    function isObjectLiteralExpression(node) {
        return node.kind === 209 /* ObjectLiteralExpression */ ;
    }
    function isPropertyAccessExpression(node) {
        return node.kind === 210 /* PropertyAccessExpression */ ;
    }
    function isElementAccessExpression(node) {
        return node.kind === 211 /* ElementAccessExpression */ ;
    }
    function isCallExpression(node) {
        return node.kind === 212 /* CallExpression */ ;
    }
    function isNewExpression(node) {
        return node.kind === 213 /* NewExpression */ ;
    }
    function isTaggedTemplateExpression(node) {
        return node.kind === 214 /* TaggedTemplateExpression */ ;
    }
    function isTypeAssertionExpression(node) {
        return node.kind === 215 /* TypeAssertionExpression */ ;
    }
    function isParenthesizedExpression(node) {
        return node.kind === 216 /* ParenthesizedExpression */ ;
    }
    function isFunctionExpression(node) {
        return node.kind === 217 /* FunctionExpression */ ;
    }
    function isArrowFunction(node) {
        return node.kind === 218 /* ArrowFunction */ ;
    }
    function isDeleteExpression(node) {
        return node.kind === 219 /* DeleteExpression */ ;
    }
    function isTypeOfExpression(node) {
        return node.kind === 220 /* TypeOfExpression */ ;
    }
    function isVoidExpression(node) {
        return node.kind === 221 /* VoidExpression */ ;
    }
    function isAwaitExpression(node) {
        return node.kind === 222 /* AwaitExpression */ ;
    }
    function isPrefixUnaryExpression(node) {
        return node.kind === 223 /* PrefixUnaryExpression */ ;
    }
    function isPostfixUnaryExpression(node) {
        return node.kind === 224 /* PostfixUnaryExpression */ ;
    }
    function isBinaryExpression(node) {
        return node.kind === 225 /* BinaryExpression */ ;
    }
    function isConditionalExpression(node) {
        return node.kind === 226 /* ConditionalExpression */ ;
    }
    function isTemplateExpression(node) {
        return node.kind === 227 /* TemplateExpression */ ;
    }
    function isYieldExpression(node) {
        return node.kind === 228 /* YieldExpression */ ;
    }
    function isSpreadElement(node) {
        return node.kind === 229 /* SpreadElement */ ;
    }
    function isClassExpression(node) {
        return node.kind === 230 /* ClassExpression */ ;
    }
    function isOmittedExpression(node) {
        return node.kind === 231 /* OmittedExpression */ ;
    }
    function isExpressionWithTypeArguments(node) {
        return node.kind === 232 /* ExpressionWithTypeArguments */ ;
    }
    function isAsExpression(node) {
        return node.kind === 233 /* AsExpression */ ;
    }
    function isSatisfiesExpression(node) {
        return node.kind === 237 /* SatisfiesExpression */ ;
    }
    function isNonNullExpression(node) {
        return node.kind === 234 /* NonNullExpression */ ;
    }
    function isMetaProperty(node) {
        return node.kind === 235 /* MetaProperty */ ;
    }
    function isSyntheticExpression(node) {
        return node.kind === 236 /* SyntheticExpression */ ;
    }
    function isPartiallyEmittedExpression(node) {
        return node.kind === 359 /* PartiallyEmittedExpression */ ;
    }
    function isCommaListExpression(node) {
        return node.kind === 360 /* CommaListExpression */ ;
    }
    function isTemplateSpan(node) {
        return node.kind === 238 /* TemplateSpan */ ;
    }
    function isSemicolonClassElement(node) {
        return node.kind === 239 /* SemicolonClassElement */ ;
    }
    function isBlock(node) {
        return node.kind === 240 /* Block */ ;
    }
    function isVariableStatement(node) {
        return node.kind === 242 /* VariableStatement */ ;
    }
    function isEmptyStatement(node) {
        return node.kind === 241 /* EmptyStatement */ ;
    }
    function isExpressionStatement(node) {
        return node.kind === 243 /* ExpressionStatement */ ;
    }
    function isIfStatement(node) {
        return node.kind === 244 /* IfStatement */ ;
    }
    function isDoStatement(node) {
        return node.kind === 245 /* DoStatement */ ;
    }
    function isWhileStatement(node) {
        return node.kind === 246 /* WhileStatement */ ;
    }
    function isForStatement(node) {
        return node.kind === 247 /* ForStatement */ ;
    }
    function isForInStatement(node) {
        return node.kind === 248 /* ForInStatement */ ;
    }
    function isForOfStatement(node) {
        return node.kind === 249 /* ForOfStatement */ ;
    }
    function isContinueStatement(node) {
        return node.kind === 250 /* ContinueStatement */ ;
    }
    function isBreakStatement(node) {
        return node.kind === 251 /* BreakStatement */ ;
    }
    function isReturnStatement(node) {
        return node.kind === 252 /* ReturnStatement */ ;
    }
    function isWithStatement(node) {
        return node.kind === 253 /* WithStatement */ ;
    }
    function isSwitchStatement(node) {
        return node.kind === 254 /* SwitchStatement */ ;
    }
    function isLabeledStatement(node) {
        return node.kind === 255 /* LabeledStatement */ ;
    }
    function isThrowStatement(node) {
        return node.kind === 256 /* ThrowStatement */ ;
    }
    function isTryStatement(node) {
        return node.kind === 257 /* TryStatement */ ;
    }
    function isDebuggerStatement(node) {
        return node.kind === 258 /* DebuggerStatement */ ;
    }
    function isVariableDeclaration(node) {
        return node.kind === 259 /* VariableDeclaration */ ;
    }
    function isVariableDeclarationList(node) {
        return node.kind === 260 /* VariableDeclarationList */ ;
    }
    function isFunctionDeclaration(node) {
        return node.kind === 261 /* FunctionDeclaration */ ;
    }
    function isClassDeclaration(node) {
        return node.kind === 262 /* ClassDeclaration */ ;
    }
    function isInterfaceDeclaration(node) {
        return node.kind === 263 /* InterfaceDeclaration */ ;
    }
    function isTypeAliasDeclaration(node) {
        return node.kind === 264 /* TypeAliasDeclaration */ ;
    }
    function isEnumDeclaration(node) {
        return node.kind === 265 /* EnumDeclaration */ ;
    }
    function isModuleDeclaration(node) {
        return node.kind === 266 /* ModuleDeclaration */ ;
    }
    function isModuleBlock(node) {
        return node.kind === 267 /* ModuleBlock */ ;
    }
    function isCaseBlock(node) {
        return node.kind === 268 /* CaseBlock */ ;
    }
    function isNamespaceExportDeclaration(node) {
        return node.kind === 269 /* NamespaceExportDeclaration */ ;
    }
    function isImportEqualsDeclaration(node) {
        return node.kind === 270 /* ImportEqualsDeclaration */ ;
    }
    function isImportDeclaration(node) {
        return node.kind === 271 /* ImportDeclaration */ ;
    }
    function isImportClause(node) {
        return node.kind === 272 /* ImportClause */ ;
    }
    function isImportTypeAssertionContainer(node) {
        return node.kind === 301 /* ImportTypeAssertionContainer */ ;
    }
    function isAssertClause(node) {
        return node.kind === 299 /* AssertClause */ ;
    }
    function isAssertEntry(node) {
        return node.kind === 300 /* AssertEntry */ ;
    }
    function isNamespaceImport(node) {
        return node.kind === 273 /* NamespaceImport */ ;
    }
    function isNamespaceExport(node) {
        return node.kind === 279 /* NamespaceExport */ ;
    }
    function isNamedImports(node) {
        return node.kind === 274 /* NamedImports */ ;
    }
    function isImportSpecifier(node) {
        return node.kind === 275 /* ImportSpecifier */ ;
    }
    function isExportAssignment(node) {
        return node.kind === 276 /* ExportAssignment */ ;
    }
    function isExportDeclaration(node) {
        return node.kind === 277 /* ExportDeclaration */ ;
    }
    function isNamedExports(node) {
        return node.kind === 278 /* NamedExports */ ;
    }
    function isExportSpecifier(node) {
        return node.kind === 280 /* ExportSpecifier */ ;
    }
    function isMissingDeclaration(node) {
        return node.kind === 281 /* MissingDeclaration */ ;
    }
    function isNotEmittedStatement(node) {
        return node.kind === 358 /* NotEmittedStatement */ ;
    }
    function isSyntheticReference(node) {
        return node.kind === 361 /* SyntheticReferenceExpression */ ;
    }
    function isExternalModuleReference(node) {
        return node.kind === 282 /* ExternalModuleReference */ ;
    }
    function isJsxElement(node) {
        return node.kind === 283 /* JsxElement */ ;
    }
    function isJsxSelfClosingElement(node) {
        return node.kind === 284 /* JsxSelfClosingElement */ ;
    }
    function isJsxOpeningElement(node) {
        return node.kind === 285 /* JsxOpeningElement */ ;
    }
    function isJsxClosingElement(node) {
        return node.kind === 286 /* JsxClosingElement */ ;
    }
    function isJsxFragment(node) {
        return node.kind === 287 /* JsxFragment */ ;
    }
    function isJsxOpeningFragment(node) {
        return node.kind === 288 /* JsxOpeningFragment */ ;
    }
    function isJsxClosingFragment(node) {
        return node.kind === 289 /* JsxClosingFragment */ ;
    }
    function isJsxAttribute(node) {
        return node.kind === 290 /* JsxAttribute */ ;
    }
    function isJsxAttributes(node) {
        return node.kind === 291 /* JsxAttributes */ ;
    }
    function isJsxSpreadAttribute(node) {
        return node.kind === 292 /* JsxSpreadAttribute */ ;
    }
    function isJsxExpression(node) {
        return node.kind === 293 /* JsxExpression */ ;
    }
    function isJsxNamespacedName(node) {
        return node.kind === 294 /* JsxNamespacedName */ ;
    }
    function isCaseClause(node) {
        return node.kind === 295 /* CaseClause */ ;
    }
    function isDefaultClause(node) {
        return node.kind === 296 /* DefaultClause */ ;
    }
    function isHeritageClause(node) {
        return node.kind === 297 /* HeritageClause */ ;
    }
    function isCatchClause(node) {
        return node.kind === 298 /* CatchClause */ ;
    }
    function isPropertyAssignment(node) {
        return node.kind === 302 /* PropertyAssignment */ ;
    }
    function isShorthandPropertyAssignment(node) {
        return node.kind === 303 /* ShorthandPropertyAssignment */ ;
    }
    function isSpreadAssignment(node) {
        return node.kind === 304 /* SpreadAssignment */ ;
    }
    function isEnumMember(node) {
        return node.kind === 305 /* EnumMember */ ;
    }
    function isUnparsedPrepend(node) {
        return node.kind === 307 /* UnparsedPrepend */ ;
    }
    function isSourceFile(node) {
        return node.kind === 311 /* SourceFile */ ;
    }
    function isBundle(node) {
        return node.kind === 312 /* Bundle */ ;
    }
    function isUnparsedSource(node) {
        return node.kind === 313 /* UnparsedSource */ ;
    }
    function isJSDocTypeExpression(node) {
        return node.kind === 315 /* JSDocTypeExpression */ ;
    }
    function isJSDocNameReference(node) {
        return node.kind === 316 /* JSDocNameReference */ ;
    }
    function isJSDocMemberName(node) {
        return node.kind === 317 /* JSDocMemberName */ ;
    }
    function isJSDocLink(node) {
        return node.kind === 330 /* JSDocLink */ ;
    }
    function isJSDocLinkCode(node) {
        return node.kind === 331 /* JSDocLinkCode */ ;
    }
    function isJSDocLinkPlain(node) {
        return node.kind === 332 /* JSDocLinkPlain */ ;
    }
    function isJSDocAllType(node) {
        return node.kind === 318 /* JSDocAllType */ ;
    }
    function isJSDocUnknownType(node) {
        return node.kind === 319 /* JSDocUnknownType */ ;
    }
    function isJSDocNullableType(node) {
        return node.kind === 320 /* JSDocNullableType */ ;
    }
    function isJSDocNonNullableType(node) {
        return node.kind === 321 /* JSDocNonNullableType */ ;
    }
    function isJSDocOptionalType(node) {
        return node.kind === 322 /* JSDocOptionalType */ ;
    }
    function isJSDocFunctionType(node) {
        return node.kind === 323 /* JSDocFunctionType */ ;
    }
    function isJSDocVariadicType(node) {
        return node.kind === 324 /* JSDocVariadicType */ ;
    }
    function isJSDocNamepathType(node) {
        return node.kind === 325 /* JSDocNamepathType */ ;
    }
    function isJSDoc(node) {
        return node.kind === 326 /* JSDoc */ ;
    }
    function isJSDocTypeLiteral(node) {
        return node.kind === 328 /* JSDocTypeLiteral */ ;
    }
    function isJSDocSignature(node) {
        return node.kind === 329 /* JSDocSignature */ ;
    }
    function isJSDocAugmentsTag(node) {
        return node.kind === 334 /* JSDocAugmentsTag */ ;
    }
    function isJSDocAuthorTag(node) {
        return node.kind === 336 /* JSDocAuthorTag */ ;
    }
    function isJSDocClassTag(node) {
        return node.kind === 338 /* JSDocClassTag */ ;
    }
    function isJSDocCallbackTag(node) {
        return node.kind === 344 /* JSDocCallbackTag */ ;
    }
    function isJSDocPublicTag(node) {
        return node.kind === 339 /* JSDocPublicTag */ ;
    }
    function isJSDocPrivateTag(node) {
        return node.kind === 340 /* JSDocPrivateTag */ ;
    }
    function isJSDocProtectedTag(node) {
        return node.kind === 341 /* JSDocProtectedTag */ ;
    }
    function isJSDocReadonlyTag(node) {
        return node.kind === 342 /* JSDocReadonlyTag */ ;
    }
    function isJSDocOverrideTag(node) {
        return node.kind === 343 /* JSDocOverrideTag */ ;
    }
    function isJSDocOverloadTag(node) {
        return node.kind === 345 /* JSDocOverloadTag */ ;
    }
    function isJSDocDeprecatedTag(node) {
        return node.kind === 337 /* JSDocDeprecatedTag */ ;
    }
    function isJSDocSeeTag(node) {
        return node.kind === 353 /* JSDocSeeTag */ ;
    }
    function isJSDocEnumTag(node) {
        return node.kind === 346 /* JSDocEnumTag */ ;
    }
    function isJSDocParameterTag(node) {
        return node.kind === 347 /* JSDocParameterTag */ ;
    }
    function isJSDocReturnTag(node) {
        return node.kind === 348 /* JSDocReturnTag */ ;
    }
    function isJSDocThisTag(node) {
        return node.kind === 349 /* JSDocThisTag */ ;
    }
    function isJSDocTypeTag(node) {
        return node.kind === 350 /* JSDocTypeTag */ ;
    }
    function isJSDocTemplateTag(node) {
        return node.kind === 351 /* JSDocTemplateTag */ ;
    }
    function isJSDocTypedefTag(node) {
        return node.kind === 352 /* JSDocTypedefTag */ ;
    }
    function isJSDocUnknownTag(node) {
        return node.kind === 333 /* JSDocTag */ ;
    }
    function isJSDocPropertyTag(node) {
        return node.kind === 354 /* JSDocPropertyTag */ ;
    }
    function isJSDocImplementsTag(node) {
        return node.kind === 335 /* JSDocImplementsTag */ ;
    }
    function isJSDocSatisfiesTag(node) {
        return node.kind === 356 /* JSDocSatisfiesTag */ ;
    }
    function isJSDocThrowsTag(node) {
        return node.kind === 355 /* JSDocThrowsTag */ ;
    }
    function isSyntaxList(n) {
        return n.kind === 357 /* SyntaxList */ ;
    }
    var init_nodeTests = __esm({
        "src/compiler/factory/nodeTests.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/factory/utilities.ts
    function createEmptyExports(factory2) {
        return factory2.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory2.createNamedExports([]), /*moduleSpecifier*/ void 0);
    }
    function createMemberAccessForPropertyName(factory2, target, memberName, location) {
        if (isComputedPropertyName(memberName)) return setTextRange(factory2.createElementAccessExpression(target, memberName.expression), location);
        else {
            const expression = setTextRange(isMemberName(memberName) ? factory2.createPropertyAccessExpression(target, memberName) : factory2.createElementAccessExpression(target, memberName), memberName);
            addEmitFlags(expression, 128 /* NoNestedSourceMaps */ );
            return expression;
        }
    }
    function createReactNamespace(reactNamespace, parent2) {
        const react = parseNodeFactory.createIdentifier(reactNamespace || "React");
        setParent(react, getParseTreeNode(parent2));
        return react;
    }
    function createJsxFactoryExpressionFromEntityName(factory2, jsxFactory, parent2) {
        if (isQualifiedName(jsxFactory)) {
            const left = createJsxFactoryExpressionFromEntityName(factory2, jsxFactory.left, parent2);
            const right = factory2.createIdentifier(idText(jsxFactory.right));
            right.escapedText = jsxFactory.right.escapedText;
            return factory2.createPropertyAccessExpression(left, right);
        } else return createReactNamespace(idText(jsxFactory), parent2);
    }
    function createJsxFactoryExpression(factory2, jsxFactoryEntity, reactNamespace, parent2) {
        return jsxFactoryEntity ? createJsxFactoryExpressionFromEntityName(factory2, jsxFactoryEntity, parent2) : factory2.createPropertyAccessExpression(createReactNamespace(reactNamespace, parent2), "createElement");
    }
    function createJsxFragmentFactoryExpression(factory2, jsxFragmentFactoryEntity, reactNamespace, parent2) {
        return jsxFragmentFactoryEntity ? createJsxFactoryExpressionFromEntityName(factory2, jsxFragmentFactoryEntity, parent2) : factory2.createPropertyAccessExpression(createReactNamespace(reactNamespace, parent2), "Fragment");
    }
    function createExpressionForJsxElement(factory2, callee, tagName, props, children, location) {
        const argumentsList = [
            tagName
        ];
        if (props) argumentsList.push(props);
        if (children && children.length > 0) {
            if (!props) argumentsList.push(factory2.createNull());
            if (children.length > 1) for (const child of children){
                startOnNewLine(child);
                argumentsList.push(child);
            }
            else argumentsList.push(children[0]);
        }
        return setTextRange(factory2.createCallExpression(callee, /*typeArguments*/ void 0, argumentsList), location);
    }
    function createExpressionForJsxFragment(factory2, jsxFactoryEntity, jsxFragmentFactoryEntity, reactNamespace, children, parentElement, location) {
        const tagName = createJsxFragmentFactoryExpression(factory2, jsxFragmentFactoryEntity, reactNamespace, parentElement);
        const argumentsList = [
            tagName,
            factory2.createNull()
        ];
        if (children && children.length > 0) {
            if (children.length > 1) for (const child of children){
                startOnNewLine(child);
                argumentsList.push(child);
            }
            else argumentsList.push(children[0]);
        }
        return setTextRange(factory2.createCallExpression(createJsxFactoryExpression(factory2, jsxFactoryEntity, reactNamespace, parentElement), /*typeArguments*/ void 0, argumentsList), location);
    }
    function createForOfBindingStatement(factory2, node, boundValue) {
        if (isVariableDeclarationList(node)) {
            const firstDeclaration = first(node.declarations);
            const updatedDeclaration = factory2.updateVariableDeclaration(firstDeclaration, firstDeclaration.name, /*exclamationToken*/ void 0, /*type*/ void 0, boundValue);
            return setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.updateVariableDeclarationList(node, [
                updatedDeclaration
            ])), /*location*/ node);
        } else {
            const updatedExpression = setTextRange(factory2.createAssignment(node, boundValue), /*location*/ node);
            return setTextRange(factory2.createExpressionStatement(updatedExpression), /*location*/ node);
        }
    }
    function insertLeadingStatement(factory2, dest, source) {
        if (isBlock(dest)) return factory2.updateBlock(dest, setTextRange(factory2.createNodeArray([
            source,
            ...dest.statements
        ]), dest.statements));
        else return factory2.createBlock(factory2.createNodeArray([
            dest,
            source
        ]), /*multiLine*/ true);
    }
    function createExpressionFromEntityName(factory2, node) {
        if (isQualifiedName(node)) {
            const left = createExpressionFromEntityName(factory2, node.left);
            const right = setParent(setTextRange(factory2.cloneNode(node.right), node.right), node.right.parent);
            return setTextRange(factory2.createPropertyAccessExpression(left, right), node);
        } else return setParent(setTextRange(factory2.cloneNode(node), node), node.parent);
    }
    function createExpressionForPropertyName(factory2, memberName) {
        if (isIdentifier(memberName)) return factory2.createStringLiteralFromNode(memberName);
        else if (isComputedPropertyName(memberName)) return setParent(setTextRange(factory2.cloneNode(memberName.expression), memberName.expression), memberName.expression.parent);
        else return setParent(setTextRange(factory2.cloneNode(memberName), memberName), memberName.parent);
    }
    function createExpressionForAccessorDeclaration(factory2, properties, property, receiver, multiLine) {
        const { firstAccessor: firstAccessor , getAccessor: getAccessor , setAccessor: setAccessor  } = getAllAccessorDeclarations(properties, property);
        if (property === firstAccessor) return setTextRange(factory2.createObjectDefinePropertyCall(receiver, createExpressionForPropertyName(factory2, property.name), factory2.createPropertyDescriptor({
            enumerable: factory2.createFalse(),
            configurable: true,
            get: getAccessor && setTextRange(setOriginalNode(factory2.createFunctionExpression(getModifiers(getAccessor), /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, getAccessor.parameters, /*type*/ void 0, getAccessor.body), getAccessor), getAccessor),
            set: setAccessor && setTextRange(setOriginalNode(factory2.createFunctionExpression(getModifiers(setAccessor), /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, setAccessor.parameters, /*type*/ void 0, setAccessor.body), setAccessor), setAccessor)
        }, !multiLine)), firstAccessor);
        return void 0;
    }
    function createExpressionForPropertyAssignment(factory2, property, receiver) {
        return setOriginalNode(setTextRange(factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, property.name, /*location*/ property.name), property.initializer), property), property);
    }
    function createExpressionForShorthandPropertyAssignment(factory2, property, receiver) {
        return setOriginalNode(setTextRange(factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, property.name, /*location*/ property.name), factory2.cloneNode(property.name)), /*location*/ property), /*original*/ property);
    }
    function createExpressionForMethodDeclaration(factory2, method, receiver) {
        return setOriginalNode(setTextRange(factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, method.name, /*location*/ method.name), setOriginalNode(setTextRange(factory2.createFunctionExpression(getModifiers(method), method.asteriskToken, /*name*/ void 0, /*typeParameters*/ void 0, method.parameters, /*type*/ void 0, method.body), /*location*/ method), /*original*/ method)), /*location*/ method), /*original*/ method);
    }
    function createExpressionForObjectLiteralElementLike(factory2, node, property, receiver) {
        if (property.name && isPrivateIdentifier(property.name)) Debug.failBadSyntaxKind(property.name, "Private identifiers are not allowed in object literals.");
        switch(property.kind){
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
                return createExpressionForAccessorDeclaration(factory2, node.properties, property, receiver, !!node.multiLine);
            case 302 /* PropertyAssignment */ :
                return createExpressionForPropertyAssignment(factory2, property, receiver);
            case 303 /* ShorthandPropertyAssignment */ :
                return createExpressionForShorthandPropertyAssignment(factory2, property, receiver);
            case 173 /* MethodDeclaration */ :
                return createExpressionForMethodDeclaration(factory2, property, receiver);
        }
    }
    function expandPreOrPostfixIncrementOrDecrementExpression(factory2, node, expression, recordTempVariable, resultVariable) {
        const operator = node.operator;
        Debug.assert(operator === 46 /* PlusPlusToken */  || operator === 47 /* MinusMinusToken */ , "Expected 'node' to be a pre- or post-increment or pre- or post-decrement expression");
        const temp = factory2.createTempVariable(recordTempVariable);
        expression = factory2.createAssignment(temp, expression);
        setTextRange(expression, node.operand);
        let operation = isPrefixUnaryExpression(node) ? factory2.createPrefixUnaryExpression(operator, temp) : factory2.createPostfixUnaryExpression(temp, operator);
        setTextRange(operation, node);
        if (resultVariable) {
            operation = factory2.createAssignment(resultVariable, operation);
            setTextRange(operation, node);
        }
        expression = factory2.createComma(expression, operation);
        setTextRange(expression, node);
        if (isPostfixUnaryExpression(node)) {
            expression = factory2.createComma(expression, temp);
            setTextRange(expression, node);
        }
        return expression;
    }
    function isInternalName(node) {
        return (getEmitFlags(node) & 65536 /* InternalName */ ) !== 0;
    }
    function isLocalName(node) {
        return (getEmitFlags(node) & 32768 /* LocalName */ ) !== 0;
    }
    function isExportName(node) {
        return (getEmitFlags(node) & 16384 /* ExportName */ ) !== 0;
    }
    function isUseStrictPrologue(node) {
        return isStringLiteral(node.expression) && node.expression.text === "use strict";
    }
    function findUseStrictPrologue(statements) {
        for (const statement of statements){
            if (isPrologueDirective(statement)) {
                if (isUseStrictPrologue(statement)) return statement;
            } else break;
        }
        return void 0;
    }
    function startsWithUseStrict(statements) {
        const firstStatement = firstOrUndefined(statements);
        return firstStatement !== void 0 && isPrologueDirective(firstStatement) && isUseStrictPrologue(firstStatement);
    }
    function isCommaExpression(node) {
        return node.kind === 225 /* BinaryExpression */  && node.operatorToken.kind === 28 /* CommaToken */ ;
    }
    function isCommaSequence(node) {
        return isCommaExpression(node) || isCommaListExpression(node);
    }
    function isJSDocTypeAssertion(node) {
        return isParenthesizedExpression(node) && isInJSFile(node) && !!getJSDocTypeTag(node);
    }
    function getJSDocTypeAssertionType(node) {
        const type = getJSDocType(node);
        Debug.assertIsDefined(type);
        return type;
    }
    function isOuterExpression(node, kinds = 15 /* All */ ) {
        switch(node.kind){
            case 216 /* ParenthesizedExpression */ :
                if (kinds & 16 /* ExcludeJSDocTypeAssertion */  && isJSDocTypeAssertion(node)) return false;
                return (kinds & 1 /* Parentheses */ ) !== 0;
            case 215 /* TypeAssertionExpression */ :
            case 233 /* AsExpression */ :
            case 232 /* ExpressionWithTypeArguments */ :
            case 237 /* SatisfiesExpression */ :
                return (kinds & 2 /* TypeAssertions */ ) !== 0;
            case 234 /* NonNullExpression */ :
                return (kinds & 4 /* NonNullAssertions */ ) !== 0;
            case 359 /* PartiallyEmittedExpression */ :
                return (kinds & 8 /* PartiallyEmittedExpressions */ ) !== 0;
        }
        return false;
    }
    function skipOuterExpressions(node, kinds = 15 /* All */ ) {
        while(isOuterExpression(node, kinds))node = node.expression;
        return node;
    }
    function walkUpOuterExpressions(node, kinds = 15 /* All */ ) {
        let parent2 = node.parent;
        while(isOuterExpression(parent2, kinds)){
            parent2 = parent2.parent;
            Debug.assert(parent2);
        }
        return parent2;
    }
    function skipAssertions(node) {
        return skipOuterExpressions(node, 6 /* Assertions */ );
    }
    function startOnNewLine(node) {
        return setStartsOnNewLine(node, /*newLine*/ true);
    }
    function getExternalHelpersModuleName(node) {
        const parseNode = getOriginalNode(node, isSourceFile);
        const emitNode = parseNode && parseNode.emitNode;
        return emitNode && emitNode.externalHelpersModuleName;
    }
    function hasRecordedExternalHelpers(sourceFile) {
        const parseNode = getOriginalNode(sourceFile, isSourceFile);
        const emitNode = parseNode && parseNode.emitNode;
        return !!emitNode && (!!emitNode.externalHelpersModuleName || !!emitNode.externalHelpers);
    }
    function createExternalHelpersImportDeclarationIfNeeded(nodeFactory, helperFactory, sourceFile, compilerOptions, hasExportStarsToExportValues, hasImportStar, hasImportDefault) {
        if (compilerOptions.importHelpers && isEffectiveExternalModule(sourceFile, compilerOptions)) {
            let namedBindings;
            const moduleKind = getEmitModuleKind(compilerOptions);
            if (moduleKind >= 5 /* ES2015 */  && moduleKind <= 99 /* ESNext */  || sourceFile.impliedNodeFormat === 99 /* ESNext */ ) {
                const helpers = getEmitHelpers(sourceFile);
                if (helpers) {
                    const helperNames = [];
                    for (const helper of helpers)if (!helper.scoped) {
                        const importName = helper.importName;
                        if (importName) pushIfUnique(helperNames, importName);
                    }
                    if (some(helperNames)) {
                        helperNames.sort(compareStringsCaseSensitive);
                        namedBindings = nodeFactory.createNamedImports(map(helperNames, (name)=>isFileLevelUniqueName(sourceFile, name) ? nodeFactory.createImportSpecifier(/*isTypeOnly*/ false, /*propertyName*/ void 0, nodeFactory.createIdentifier(name)) : nodeFactory.createImportSpecifier(/*isTypeOnly*/ false, nodeFactory.createIdentifier(name), helperFactory.getUnscopedHelperName(name))));
                        const parseNode = getOriginalNode(sourceFile, isSourceFile);
                        const emitNode = getOrCreateEmitNode(parseNode);
                        emitNode.externalHelpers = true;
                    }
                }
            } else {
                const externalHelpersModuleName = getOrCreateExternalHelpersModuleNameIfNeeded(nodeFactory, sourceFile, compilerOptions, hasExportStarsToExportValues, hasImportStar || hasImportDefault);
                if (externalHelpersModuleName) namedBindings = nodeFactory.createNamespaceImport(externalHelpersModuleName);
            }
            if (namedBindings) {
                const externalHelpersImportDeclaration = nodeFactory.createImportDeclaration(/*modifiers*/ void 0, nodeFactory.createImportClause(/*isTypeOnly*/ false, /*name*/ void 0, namedBindings), nodeFactory.createStringLiteral(externalHelpersModuleNameText), /*assertClause*/ void 0);
                addInternalEmitFlags(externalHelpersImportDeclaration, 2 /* NeverApplyImportHelper */ );
                return externalHelpersImportDeclaration;
            }
        }
    }
    function getOrCreateExternalHelpersModuleNameIfNeeded(factory2, node, compilerOptions, hasExportStarsToExportValues, hasImportStarOrImportDefault) {
        if (compilerOptions.importHelpers && isEffectiveExternalModule(node, compilerOptions)) {
            const externalHelpersModuleName = getExternalHelpersModuleName(node);
            if (externalHelpersModuleName) return externalHelpersModuleName;
            const moduleKind = getEmitModuleKind(compilerOptions);
            let create = (hasExportStarsToExportValues || getESModuleInterop(compilerOptions) && hasImportStarOrImportDefault) && moduleKind !== 4 /* System */  && (moduleKind < 5 /* ES2015 */  || node.impliedNodeFormat === 1 /* CommonJS */ );
            if (!create) {
                const helpers = getEmitHelpers(node);
                if (helpers) {
                    for (const helper of helpers)if (!helper.scoped) {
                        create = true;
                        break;
                    }
                }
            }
            if (create) {
                const parseNode = getOriginalNode(node, isSourceFile);
                const emitNode = getOrCreateEmitNode(parseNode);
                return emitNode.externalHelpersModuleName || (emitNode.externalHelpersModuleName = factory2.createUniqueName(externalHelpersModuleNameText));
            }
        }
    }
    function getLocalNameForExternalImport(factory2, node, sourceFile) {
        const namespaceDeclaration = getNamespaceDeclarationNode(node);
        if (namespaceDeclaration && !isDefaultImport(node) && !isExportNamespaceAsDefaultDeclaration(node)) {
            const name = namespaceDeclaration.name;
            return isGeneratedIdentifier(name) ? name : factory2.createIdentifier(getSourceTextOfNodeFromSourceFile(sourceFile, name) || idText(name));
        }
        if (node.kind === 271 /* ImportDeclaration */  && node.importClause) return factory2.getGeneratedNameForNode(node);
        if (node.kind === 277 /* ExportDeclaration */  && node.moduleSpecifier) return factory2.getGeneratedNameForNode(node);
        return void 0;
    }
    function getExternalModuleNameLiteral(factory2, importNode, sourceFile, host, resolver, compilerOptions) {
        const moduleName = getExternalModuleName(importNode);
        if (moduleName && isStringLiteral(moduleName)) return tryGetModuleNameFromDeclaration(importNode, host, factory2, resolver, compilerOptions) || tryRenameExternalModule(factory2, moduleName, sourceFile) || factory2.cloneNode(moduleName);
        return void 0;
    }
    function tryRenameExternalModule(factory2, moduleName, sourceFile) {
        const rename = sourceFile.renamedDependencies && sourceFile.renamedDependencies.get(moduleName.text);
        return rename ? factory2.createStringLiteral(rename) : void 0;
    }
    function tryGetModuleNameFromFile(factory2, file, host, options) {
        if (!file) return void 0;
        if (file.moduleName) return factory2.createStringLiteral(file.moduleName);
        if (!file.isDeclarationFile && outFile(options)) return factory2.createStringLiteral(getExternalModuleNameFromPath(host, file.fileName));
        return void 0;
    }
    function tryGetModuleNameFromDeclaration(declaration, host, factory2, resolver, compilerOptions) {
        return tryGetModuleNameFromFile(factory2, resolver.getExternalModuleFileFromDeclaration(declaration), host, compilerOptions);
    }
    function getInitializerOfBindingOrAssignmentElement(bindingElement) {
        if (isDeclarationBindingElement(bindingElement)) return bindingElement.initializer;
        if (isPropertyAssignment(bindingElement)) {
            const initializer = bindingElement.initializer;
            return isAssignmentExpression(initializer, /*excludeCompoundAssignment*/ true) ? initializer.right : void 0;
        }
        if (isShorthandPropertyAssignment(bindingElement)) return bindingElement.objectAssignmentInitializer;
        if (isAssignmentExpression(bindingElement, /*excludeCompoundAssignment*/ true)) return bindingElement.right;
        if (isSpreadElement(bindingElement)) return getInitializerOfBindingOrAssignmentElement(bindingElement.expression);
    }
    function getTargetOfBindingOrAssignmentElement(bindingElement) {
        if (isDeclarationBindingElement(bindingElement)) return bindingElement.name;
        if (isObjectLiteralElementLike(bindingElement)) {
            switch(bindingElement.kind){
                case 302 /* PropertyAssignment */ :
                    return getTargetOfBindingOrAssignmentElement(bindingElement.initializer);
                case 303 /* ShorthandPropertyAssignment */ :
                    return bindingElement.name;
                case 304 /* SpreadAssignment */ :
                    return getTargetOfBindingOrAssignmentElement(bindingElement.expression);
            }
            return void 0;
        }
        if (isAssignmentExpression(bindingElement, /*excludeCompoundAssignment*/ true)) return getTargetOfBindingOrAssignmentElement(bindingElement.left);
        if (isSpreadElement(bindingElement)) return getTargetOfBindingOrAssignmentElement(bindingElement.expression);
        return bindingElement;
    }
    function getRestIndicatorOfBindingOrAssignmentElement(bindingElement) {
        switch(bindingElement.kind){
            case 168 /* Parameter */ :
            case 207 /* BindingElement */ :
                return bindingElement.dotDotDotToken;
            case 229 /* SpreadElement */ :
            case 304 /* SpreadAssignment */ :
                return bindingElement;
        }
        return void 0;
    }
    function getPropertyNameOfBindingOrAssignmentElement(bindingElement) {
        const propertyName = tryGetPropertyNameOfBindingOrAssignmentElement(bindingElement);
        Debug.assert(!!propertyName || isSpreadAssignment(bindingElement), "Invalid property name for binding element.");
        return propertyName;
    }
    function tryGetPropertyNameOfBindingOrAssignmentElement(bindingElement) {
        switch(bindingElement.kind){
            case 207 /* BindingElement */ :
                if (bindingElement.propertyName) {
                    const propertyName = bindingElement.propertyName;
                    if (isPrivateIdentifier(propertyName)) return Debug.failBadSyntaxKind(propertyName);
                    return isComputedPropertyName(propertyName) && isStringOrNumericLiteral(propertyName.expression) ? propertyName.expression : propertyName;
                }
                break;
            case 302 /* PropertyAssignment */ :
                if (bindingElement.name) {
                    const propertyName = bindingElement.name;
                    if (isPrivateIdentifier(propertyName)) return Debug.failBadSyntaxKind(propertyName);
                    return isComputedPropertyName(propertyName) && isStringOrNumericLiteral(propertyName.expression) ? propertyName.expression : propertyName;
                }
                break;
            case 304 /* SpreadAssignment */ :
                if (bindingElement.name && isPrivateIdentifier(bindingElement.name)) return Debug.failBadSyntaxKind(bindingElement.name);
                return bindingElement.name;
        }
        const target = getTargetOfBindingOrAssignmentElement(bindingElement);
        if (target && isPropertyName(target)) return target;
    }
    function isStringOrNumericLiteral(node) {
        const kind = node.kind;
        return kind === 11 /* StringLiteral */  || kind === 9 /* NumericLiteral */ ;
    }
    function getElementsOfBindingOrAssignmentPattern(name) {
        switch(name.kind){
            case 205 /* ObjectBindingPattern */ :
            case 206 /* ArrayBindingPattern */ :
            case 208 /* ArrayLiteralExpression */ :
                return name.elements;
            case 209 /* ObjectLiteralExpression */ :
                return name.properties;
        }
    }
    function getJSDocTypeAliasName(fullName) {
        if (fullName) {
            let rightNode = fullName;
            while(true){
                if (isIdentifier(rightNode) || !rightNode.body) return isIdentifier(rightNode) ? rightNode : rightNode.name;
                rightNode = rightNode.body;
            }
        }
    }
    function canHaveIllegalType(node) {
        const kind = node.kind;
        return kind === 175 /* Constructor */  || kind === 177 /* SetAccessor */ ;
    }
    function canHaveIllegalTypeParameters(node) {
        const kind = node.kind;
        return kind === 175 /* Constructor */  || kind === 176 /* GetAccessor */  || kind === 177 /* SetAccessor */ ;
    }
    function canHaveIllegalDecorators(node) {
        const kind = node.kind;
        return kind === 302 /* PropertyAssignment */  || kind === 303 /* ShorthandPropertyAssignment */  || kind === 261 /* FunctionDeclaration */  || kind === 175 /* Constructor */  || kind === 180 /* IndexSignature */  || kind === 174 /* ClassStaticBlockDeclaration */  || kind === 281 /* MissingDeclaration */  || kind === 242 /* VariableStatement */  || kind === 263 /* InterfaceDeclaration */  || kind === 264 /* TypeAliasDeclaration */  || kind === 265 /* EnumDeclaration */  || kind === 266 /* ModuleDeclaration */  || kind === 270 /* ImportEqualsDeclaration */  || kind === 271 /* ImportDeclaration */  || kind === 269 /* NamespaceExportDeclaration */  || kind === 277 /* ExportDeclaration */  || kind === 276 /* ExportAssignment */ ;
    }
    function canHaveIllegalModifiers(node) {
        const kind = node.kind;
        return kind === 174 /* ClassStaticBlockDeclaration */  || kind === 302 /* PropertyAssignment */  || kind === 303 /* ShorthandPropertyAssignment */  || kind === 281 /* MissingDeclaration */  || kind === 269 /* NamespaceExportDeclaration */ ;
    }
    function isQuestionOrExclamationToken(node) {
        return isQuestionToken(node) || isExclamationToken(node);
    }
    function isIdentifierOrThisTypeNode(node) {
        return isIdentifier(node) || isThisTypeNode(node);
    }
    function isReadonlyKeywordOrPlusOrMinusToken(node) {
        return isReadonlyKeyword(node) || isPlusToken(node) || isMinusToken(node);
    }
    function isQuestionOrPlusOrMinusToken(node) {
        return isQuestionToken(node) || isPlusToken(node) || isMinusToken(node);
    }
    function isModuleName(node) {
        return isIdentifier(node) || isStringLiteral(node);
    }
    function isLiteralTypeLikeExpression(node) {
        const kind = node.kind;
        return kind === 106 /* NullKeyword */  || kind === 112 /* TrueKeyword */  || kind === 97 /* FalseKeyword */  || isLiteralExpression(node) || isPrefixUnaryExpression(node);
    }
    function isExponentiationOperator(kind) {
        return kind === 43 /* AsteriskAsteriskToken */ ;
    }
    function isMultiplicativeOperator(kind) {
        return kind === 42 /* AsteriskToken */  || kind === 44 /* SlashToken */  || kind === 45 /* PercentToken */ ;
    }
    function isMultiplicativeOperatorOrHigher(kind) {
        return isExponentiationOperator(kind) || isMultiplicativeOperator(kind);
    }
    function isAdditiveOperator(kind) {
        return kind === 40 /* PlusToken */  || kind === 41 /* MinusToken */ ;
    }
    function isAdditiveOperatorOrHigher(kind) {
        return isAdditiveOperator(kind) || isMultiplicativeOperatorOrHigher(kind);
    }
    function isShiftOperator(kind) {
        return kind === 48 /* LessThanLessThanToken */  || kind === 49 /* GreaterThanGreaterThanToken */  || kind === 50 /* GreaterThanGreaterThanGreaterThanToken */ ;
    }
    function isShiftOperatorOrHigher(kind) {
        return isShiftOperator(kind) || isAdditiveOperatorOrHigher(kind);
    }
    function isRelationalOperator(kind) {
        return kind === 30 /* LessThanToken */  || kind === 33 /* LessThanEqualsToken */  || kind === 32 /* GreaterThanToken */  || kind === 34 /* GreaterThanEqualsToken */  || kind === 104 /* InstanceOfKeyword */  || kind === 103 /* InKeyword */ ;
    }
    function isRelationalOperatorOrHigher(kind) {
        return isRelationalOperator(kind) || isShiftOperatorOrHigher(kind);
    }
    function isEqualityOperator(kind) {
        return kind === 35 /* EqualsEqualsToken */  || kind === 37 /* EqualsEqualsEqualsToken */  || kind === 36 /* ExclamationEqualsToken */  || kind === 38 /* ExclamationEqualsEqualsToken */ ;
    }
    function isEqualityOperatorOrHigher(kind) {
        return isEqualityOperator(kind) || isRelationalOperatorOrHigher(kind);
    }
    function isBitwiseOperator(kind) {
        return kind === 51 /* AmpersandToken */  || kind === 52 /* BarToken */  || kind === 53 /* CaretToken */ ;
    }
    function isBitwiseOperatorOrHigher(kind) {
        return isBitwiseOperator(kind) || isEqualityOperatorOrHigher(kind);
    }
    function isLogicalOperator2(kind) {
        return kind === 56 /* AmpersandAmpersandToken */  || kind === 57 /* BarBarToken */ ;
    }
    function isLogicalOperatorOrHigher(kind) {
        return isLogicalOperator2(kind) || isBitwiseOperatorOrHigher(kind);
    }
    function isAssignmentOperatorOrHigher(kind) {
        return kind === 61 /* QuestionQuestionToken */  || isLogicalOperatorOrHigher(kind) || isAssignmentOperator(kind);
    }
    function isBinaryOperator(kind) {
        return isAssignmentOperatorOrHigher(kind) || kind === 28 /* CommaToken */ ;
    }
    function isBinaryOperatorToken(node) {
        return isBinaryOperator(node.kind);
    }
    function createBinaryExpressionTrampoline(onEnter, onLeft, onOperator, onRight, onExit, foldState) {
        const machine = new BinaryExpressionStateMachine(onEnter, onLeft, onOperator, onRight, onExit, foldState);
        return trampoline;
        function trampoline(node, outerState) {
            const resultHolder = {
                value: void 0
            };
            const stateStack = [
                BinaryExpressionState.enter
            ];
            const nodeStack = [
                node
            ];
            const userStateStack = [
                void 0
            ];
            let stackIndex = 0;
            while(stateStack[stackIndex] !== BinaryExpressionState.done)stackIndex = stateStack[stackIndex](machine, stackIndex, stateStack, nodeStack, userStateStack, resultHolder, outerState);
            Debug.assertEqual(stackIndex, 0);
            return resultHolder.value;
        }
    }
    function isExportOrDefaultKeywordKind(kind) {
        return kind === 95 /* ExportKeyword */  || kind === 90 /* DefaultKeyword */ ;
    }
    function isExportOrDefaultModifier(node) {
        const kind = node.kind;
        return isExportOrDefaultKeywordKind(kind);
    }
    function isNonExportDefaultModifier(node) {
        const kind = node.kind;
        return isModifierKind(kind) && !isExportOrDefaultKeywordKind(kind);
    }
    function elideNodes(factory2, nodes) {
        if (nodes === void 0) return void 0;
        if (nodes.length === 0) return nodes;
        return setTextRange(factory2.createNodeArray([], nodes.hasTrailingComma), nodes);
    }
    function getNodeForGeneratedName(name) {
        var _a;
        const autoGenerate = name.emitNode.autoGenerate;
        if (autoGenerate.flags & 4 /* Node */ ) {
            const autoGenerateId = autoGenerate.id;
            let node = name;
            let original = node.original;
            while(original){
                node = original;
                const autoGenerate2 = (_a = node.emitNode) == null ? void 0 : _a.autoGenerate;
                if (isMemberName(node) && (autoGenerate2 === void 0 || !!(autoGenerate2.flags & 4 /* Node */ ) && autoGenerate2.id !== autoGenerateId)) break;
                original = node.original;
            }
            return node;
        }
        return name;
    }
    function formatGeneratedNamePart(part, generateName) {
        return typeof part === "object" ? formatGeneratedName(/*privateName*/ false, part.prefix, part.node, part.suffix, generateName) : typeof part === "string" ? part.length > 0 && part.charCodeAt(0) === 35 /* hash */  ? part.slice(1) : part : "";
    }
    function formatIdentifier(name, generateName) {
        return typeof name === "string" ? name : formatIdentifierWorker(name, Debug.checkDefined(generateName));
    }
    function formatIdentifierWorker(node, generateName) {
        return isGeneratedPrivateIdentifier(node) ? generateName(node).slice(1) : isGeneratedIdentifier(node) ? generateName(node) : isPrivateIdentifier(node) ? node.escapedText.slice(1) : idText(node);
    }
    function formatGeneratedName(privateName, prefix, baseName, suffix, generateName) {
        prefix = formatGeneratedNamePart(prefix, generateName);
        suffix = formatGeneratedNamePart(suffix, generateName);
        baseName = formatIdentifier(baseName, generateName);
        return `${privateName ? "#" : ""}${prefix}${baseName}${suffix}`;
    }
    function createAccessorPropertyBackingField(factory2, node, modifiers, initializer) {
        return factory2.updatePropertyDeclaration(node, modifiers, factory2.getGeneratedPrivateNameForNode(node.name, /*prefix*/ void 0, "_accessor_storage"), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, initializer);
    }
    function createAccessorPropertyGetRedirector(factory2, node, modifiers, name) {
        return factory2.createGetAccessorDeclaration(modifiers, name, [], /*type*/ void 0, factory2.createBlock([
            factory2.createReturnStatement(factory2.createPropertyAccessExpression(factory2.createThis(), factory2.getGeneratedPrivateNameForNode(node.name, /*prefix*/ void 0, "_accessor_storage")))
        ]));
    }
    function createAccessorPropertySetRedirector(factory2, node, modifiers, name) {
        return factory2.createSetAccessorDeclaration(modifiers, name, [
            factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "value")
        ], factory2.createBlock([
            factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createThis(), factory2.getGeneratedPrivateNameForNode(node.name, /*prefix*/ void 0, "_accessor_storage")), factory2.createIdentifier("value")))
        ]));
    }
    function findComputedPropertyNameCacheAssignment(name) {
        let node = name.expression;
        while(true){
            node = skipOuterExpressions(node);
            if (isCommaListExpression(node)) {
                node = last(node.elements);
                continue;
            }
            if (isCommaExpression(node)) {
                node = node.right;
                continue;
            }
            if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true) && isGeneratedIdentifier(node.left)) return node;
            break;
        }
    }
    function isSyntheticParenthesizedExpression(node) {
        return isParenthesizedExpression(node) && nodeIsSynthesized(node) && !node.emitNode;
    }
    function flattenCommaListWorker(node, expressions) {
        if (isSyntheticParenthesizedExpression(node)) flattenCommaListWorker(node.expression, expressions);
        else if (isCommaExpression(node)) {
            flattenCommaListWorker(node.left, expressions);
            flattenCommaListWorker(node.right, expressions);
        } else if (isCommaListExpression(node)) for (const child of node.elements)flattenCommaListWorker(child, expressions);
        else expressions.push(node);
    }
    function flattenCommaList(node) {
        const expressions = [];
        flattenCommaListWorker(node, expressions);
        return expressions;
    }
    function containsObjectRestOrSpread(node) {
        if (node.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) return true;
        if (node.transformFlags & 128 /* ContainsES2018 */ ) for (const element of getElementsOfBindingOrAssignmentPattern(node)){
            const target = getTargetOfBindingOrAssignmentElement(element);
            if (target && isAssignmentPattern(target)) {
                if (target.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) return true;
                if (target.transformFlags & 128 /* ContainsES2018 */ ) {
                    if (containsObjectRestOrSpread(target)) return true;
                }
            }
        }
        return false;
    }
    var BinaryExpressionState, BinaryExpressionStateMachine;
    var init_utilities2 = __esm({
        "src/compiler/factory/utilities.ts" () {
            "use strict";
            init_ts2();
            ((BinaryExpressionState2)=>{
                function enter(machine, stackIndex, stateStack, nodeStack, userStateStack, _resultHolder, outerState) {
                    const prevUserState = stackIndex > 0 ? userStateStack[stackIndex - 1] : void 0;
                    Debug.assertEqual(stateStack[stackIndex], enter);
                    userStateStack[stackIndex] = machine.onEnter(nodeStack[stackIndex], prevUserState, outerState);
                    stateStack[stackIndex] = nextState(machine, enter);
                    return stackIndex;
                }
                BinaryExpressionState2.enter = enter;
                function left(machine, stackIndex, stateStack, nodeStack, userStateStack, _resultHolder, _outerState) {
                    Debug.assertEqual(stateStack[stackIndex], left);
                    Debug.assertIsDefined(machine.onLeft);
                    stateStack[stackIndex] = nextState(machine, left);
                    const nextNode = machine.onLeft(nodeStack[stackIndex].left, userStateStack[stackIndex], nodeStack[stackIndex]);
                    if (nextNode) {
                        checkCircularity(stackIndex, nodeStack, nextNode);
                        return pushStack(stackIndex, stateStack, nodeStack, userStateStack, nextNode);
                    }
                    return stackIndex;
                }
                BinaryExpressionState2.left = left;
                function operator(machine, stackIndex, stateStack, nodeStack, userStateStack, _resultHolder, _outerState) {
                    Debug.assertEqual(stateStack[stackIndex], operator);
                    Debug.assertIsDefined(machine.onOperator);
                    stateStack[stackIndex] = nextState(machine, operator);
                    machine.onOperator(nodeStack[stackIndex].operatorToken, userStateStack[stackIndex], nodeStack[stackIndex]);
                    return stackIndex;
                }
                BinaryExpressionState2.operator = operator;
                function right(machine, stackIndex, stateStack, nodeStack, userStateStack, _resultHolder, _outerState) {
                    Debug.assertEqual(stateStack[stackIndex], right);
                    Debug.assertIsDefined(machine.onRight);
                    stateStack[stackIndex] = nextState(machine, right);
                    const nextNode = machine.onRight(nodeStack[stackIndex].right, userStateStack[stackIndex], nodeStack[stackIndex]);
                    if (nextNode) {
                        checkCircularity(stackIndex, nodeStack, nextNode);
                        return pushStack(stackIndex, stateStack, nodeStack, userStateStack, nextNode);
                    }
                    return stackIndex;
                }
                BinaryExpressionState2.right = right;
                function exit(machine, stackIndex, stateStack, nodeStack, userStateStack, resultHolder, _outerState) {
                    Debug.assertEqual(stateStack[stackIndex], exit);
                    stateStack[stackIndex] = nextState(machine, exit);
                    const result = machine.onExit(nodeStack[stackIndex], userStateStack[stackIndex]);
                    if (stackIndex > 0) {
                        stackIndex--;
                        if (machine.foldState) {
                            const side = stateStack[stackIndex] === exit ? "right" : "left";
                            userStateStack[stackIndex] = machine.foldState(userStateStack[stackIndex], result, side);
                        }
                    } else resultHolder.value = result;
                    return stackIndex;
                }
                BinaryExpressionState2.exit = exit;
                function done(_machine, stackIndex, stateStack, _nodeStack, _userStateStack, _resultHolder, _outerState) {
                    Debug.assertEqual(stateStack[stackIndex], done);
                    return stackIndex;
                }
                BinaryExpressionState2.done = done;
                function nextState(machine, currentState) {
                    switch(currentState){
                        case enter:
                            if (machine.onLeft) return left;
                        case left:
                            if (machine.onOperator) return operator;
                        case operator:
                            if (machine.onRight) return right;
                        case right:
                            return exit;
                        case exit:
                            return done;
                        case done:
                            return done;
                        default:
                            Debug.fail("Invalid state");
                    }
                }
                BinaryExpressionState2.nextState = nextState;
                function pushStack(stackIndex, stateStack, nodeStack, userStateStack, node) {
                    stackIndex++;
                    stateStack[stackIndex] = enter;
                    nodeStack[stackIndex] = node;
                    userStateStack[stackIndex] = void 0;
                    return stackIndex;
                }
                function checkCircularity(stackIndex, nodeStack, node) {
                    if (Debug.shouldAssert(2 /* Aggressive */ )) while(stackIndex >= 0){
                        Debug.assert(nodeStack[stackIndex] !== node, "Circular traversal detected.");
                        stackIndex--;
                    }
                }
            })(BinaryExpressionState || (BinaryExpressionState = {}));
            BinaryExpressionStateMachine = class {
                constructor(onEnter, onLeft, onOperator, onRight, onExit, foldState){
                    this.onEnter = onEnter;
                    this.onLeft = onLeft;
                    this.onOperator = onOperator;
                    this.onRight = onRight;
                    this.onExit = onExit;
                    this.foldState = foldState;
                }
            };
        }
    });
    // src/compiler/factory/utilitiesPublic.ts
    function setTextRange(range, location) {
        return location ? setTextRangePosEnd(range, location.pos, location.end) : range;
    }
    function canHaveModifiers(node) {
        const kind = node.kind;
        return kind === 167 /* TypeParameter */  || kind === 168 /* Parameter */  || kind === 170 /* PropertySignature */  || kind === 171 /* PropertyDeclaration */  || kind === 172 /* MethodSignature */  || kind === 173 /* MethodDeclaration */  || kind === 175 /* Constructor */  || kind === 176 /* GetAccessor */  || kind === 177 /* SetAccessor */  || kind === 180 /* IndexSignature */  || kind === 184 /* ConstructorType */  || kind === 217 /* FunctionExpression */  || kind === 218 /* ArrowFunction */  || kind === 230 /* ClassExpression */  || kind === 242 /* VariableStatement */  || kind === 261 /* FunctionDeclaration */  || kind === 262 /* ClassDeclaration */  || kind === 263 /* InterfaceDeclaration */  || kind === 264 /* TypeAliasDeclaration */  || kind === 265 /* EnumDeclaration */  || kind === 266 /* ModuleDeclaration */  || kind === 270 /* ImportEqualsDeclaration */  || kind === 271 /* ImportDeclaration */  || kind === 276 /* ExportAssignment */  || kind === 277 /* ExportDeclaration */ ;
    }
    function canHaveDecorators(node) {
        const kind = node.kind;
        return kind === 168 /* Parameter */  || kind === 171 /* PropertyDeclaration */  || kind === 173 /* MethodDeclaration */  || kind === 176 /* GetAccessor */  || kind === 177 /* SetAccessor */  || kind === 230 /* ClassExpression */  || kind === 262 /* ClassDeclaration */ ;
    }
    var init_utilitiesPublic2 = __esm({
        "src/compiler/factory/utilitiesPublic.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/parser.ts
    function visitNode2(cbNode, node) {
        return node && cbNode(node);
    }
    function visitNodes(cbNode, cbNodes, nodes) {
        if (nodes) {
            if (cbNodes) return cbNodes(nodes);
            for (const node of nodes){
                const result = cbNode(node);
                if (result) return result;
            }
        }
    }
    function isJSDocLikeText(text, start) {
        return text.charCodeAt(start + 1) === 42 /* asterisk */  && text.charCodeAt(start + 2) === 42 /* asterisk */  && text.charCodeAt(start + 3) !== 47 /* slash */ ;
    }
    function isFileProbablyExternalModule(sourceFile) {
        return forEach(sourceFile.statements, isAnExternalModuleIndicatorNode) || getImportMetaIfNecessary(sourceFile);
    }
    function isAnExternalModuleIndicatorNode(node) {
        return canHaveModifiers(node) && hasModifierOfKind(node, 95 /* ExportKeyword */ ) || isImportEqualsDeclaration(node) && isExternalModuleReference(node.moduleReference) || isImportDeclaration(node) || isExportAssignment(node) || isExportDeclaration(node) ? node : void 0;
    }
    function getImportMetaIfNecessary(sourceFile) {
        return sourceFile.flags & 4194304 /* PossiblyContainsImportMeta */  ? walkTreeForImportMeta(sourceFile) : void 0;
    }
    function walkTreeForImportMeta(node) {
        return isImportMeta2(node) ? node : forEachChild(node, walkTreeForImportMeta);
    }
    function hasModifierOfKind(node, kind) {
        return some(node.modifiers, (m)=>m.kind === kind);
    }
    function isImportMeta2(node) {
        return isMetaProperty(node) && node.keywordToken === 102 /* ImportKeyword */  && node.name.escapedText === "meta";
    }
    function forEachChildInCallOrConstructSignature(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
    }
    function forEachChildInUnionOrIntersectionType(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.types);
    }
    function forEachChildInParenthesizedTypeOrTypeOperator(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.type);
    }
    function forEachChildInObjectOrArrayBindingPattern(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.elements);
    }
    function forEachChildInCallOrNewExpression(node, cbNode, cbNodes) {
        return visitNode2(cbNode, node.expression) || // TODO: should we separate these branches out?
        visitNode2(cbNode, node.questionDotToken) || visitNodes(cbNode, cbNodes, node.typeArguments) || visitNodes(cbNode, cbNodes, node.arguments);
    }
    function forEachChildInBlock(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.statements);
    }
    function forEachChildInContinueOrBreakStatement(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.label);
    }
    function forEachChildInClassDeclarationOrExpression(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.heritageClauses) || visitNodes(cbNode, cbNodes, node.members);
    }
    function forEachChildInNamedImportsOrExports(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.elements);
    }
    function forEachChildInImportOrExportSpecifier(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.propertyName) || visitNode2(cbNode, node.name);
    }
    function forEachChildInJsxOpeningOrSelfClosingElement(node, cbNode, cbNodes) {
        return visitNode2(cbNode, node.tagName) || visitNodes(cbNode, cbNodes, node.typeArguments) || visitNode2(cbNode, node.attributes);
    }
    function forEachChildInOptionalRestOrJSDocParameterModifier(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.type);
    }
    function forEachChildInJSDocParameterOrPropertyTag(node, cbNode, cbNodes) {
        return visitNode2(cbNode, node.tagName) || (node.isNameFirst ? visitNode2(cbNode, node.name) || visitNode2(cbNode, node.typeExpression) : visitNode2(cbNode, node.typeExpression) || visitNode2(cbNode, node.name)) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
    }
    function forEachChildInJSDocTypeLikeTag(node, cbNode, cbNodes) {
        return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.typeExpression) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
    }
    function forEachChildInJSDocLinkCodeOrPlain(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.name);
    }
    function forEachChildInJSDocTag(node, cbNode, cbNodes) {
        return visitNode2(cbNode, node.tagName) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
    }
    function forEachChildInPartiallyEmittedExpression(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.expression);
    }
    function forEachChild(node, cbNode, cbNodes) {
        if (node === void 0 || node.kind <= 164 /* LastToken */ ) return;
        const fn = forEachChildTable[node.kind];
        return fn === void 0 ? void 0 : fn(node, cbNode, cbNodes);
    }
    function forEachChildRecursively(rootNode, cbNode, cbNodes) {
        const queue = gatherPossibleChildren(rootNode);
        const parents = [];
        while(parents.length < queue.length)parents.push(rootNode);
        while(queue.length !== 0){
            const current = queue.pop();
            const parent2 = parents.pop();
            if (isArray(current)) {
                if (cbNodes) {
                    const res = cbNodes(current, parent2);
                    if (res) {
                        if (res === "skip") continue;
                        return res;
                    }
                }
                for(let i = current.length - 1; i >= 0; --i){
                    queue.push(current[i]);
                    parents.push(parent2);
                }
            } else {
                const res = cbNode(current, parent2);
                if (res) {
                    if (res === "skip") continue;
                    return res;
                }
                if (current.kind >= 165 /* FirstNode */ ) for (const child of gatherPossibleChildren(current)){
                    queue.push(child);
                    parents.push(current);
                }
            }
        }
    }
    function gatherPossibleChildren(node) {
        const children = [];
        forEachChild(node, addWorkItem, addWorkItem);
        return children;
        function addWorkItem(n) {
            children.unshift(n);
        }
    }
    function setExternalModuleIndicator(sourceFile) {
        sourceFile.externalModuleIndicator = isFileProbablyExternalModule(sourceFile);
    }
    function createSourceFile(fileName, sourceText, languageVersionOrOptions, setParentNodes = false, scriptKind) {
        var _a, _b, _c, _d;
        (_a = tracing) == null || _a.push(tracing.Phase.Parse, "createSourceFile", {
            path: fileName
        }, /*separateBeginAndEnd*/ true);
        mark("beforeParse");
        let result;
        (_b = perfLogger) == null || _b.logStartParseSourceFile(fileName);
        const { languageVersion: languageVersion , setExternalModuleIndicator: overrideSetExternalModuleIndicator , impliedNodeFormat: format  } = typeof languageVersionOrOptions === "object" ? languageVersionOrOptions : {
            languageVersion: languageVersionOrOptions
        };
        if (languageVersion === 100 /* JSON */ ) result = Parser.parseSourceFile(fileName, sourceText, languageVersion, /*syntaxCursor*/ void 0, setParentNodes, 6 /* JSON */ , noop);
        else {
            const setIndicator = format === void 0 ? overrideSetExternalModuleIndicator : (file)=>{
                file.impliedNodeFormat = format;
                return (overrideSetExternalModuleIndicator || setExternalModuleIndicator)(file);
            };
            result = Parser.parseSourceFile(fileName, sourceText, languageVersion, /*syntaxCursor*/ void 0, setParentNodes, scriptKind, setIndicator);
        }
        (_c = perfLogger) == null || _c.logStopParseSourceFile();
        mark("afterParse");
        measure("Parse", "beforeParse", "afterParse");
        (_d = tracing) == null || _d.pop();
        return result;
    }
    function parseIsolatedEntityName(text, languageVersion) {
        return Parser.parseIsolatedEntityName(text, languageVersion);
    }
    function parseJsonText(fileName, sourceText) {
        return Parser.parseJsonText(fileName, sourceText);
    }
    function isExternalModule(file) {
        return file.externalModuleIndicator !== void 0;
    }
    function updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks = false) {
        const newSourceFile = IncrementalParser.updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks);
        newSourceFile.flags |= sourceFile.flags & 6291456 /* PermanentlySetIncrementalFlags */ ;
        return newSourceFile;
    }
    function parseIsolatedJSDocComment(content, start, length2) {
        const result = Parser.JSDocParser.parseIsolatedJSDocComment(content, start, length2);
        if (result && result.jsDoc) Parser.fixupParentReferences(result.jsDoc);
        return result;
    }
    function parseJSDocTypeExpressionForTests(content, start, length2) {
        return Parser.JSDocParser.parseJSDocTypeExpressionForTests(content, start, length2);
    }
    function isDeclarationFileName(fileName) {
        return fileExtensionIsOneOf(fileName, supportedDeclarationExtensions) || fileExtensionIs(fileName, ".ts" /* Ts */ ) && stringContains(getBaseFileName(fileName), ".d.");
    }
    function parseResolutionMode(mode, pos, end, reportDiagnostic) {
        if (!mode) return void 0;
        if (mode === "import") return 99 /* ESNext */ ;
        if (mode === "require") return 1 /* CommonJS */ ;
        reportDiagnostic(pos, end - pos, Diagnostics.resolution_mode_should_be_either_require_or_import);
        return void 0;
    }
    function processCommentPragmas(context, sourceText) {
        const pragmas = [];
        for (const range of getLeadingCommentRanges(sourceText, 0) || emptyArray){
            const comment = sourceText.substring(range.pos, range.end);
            extractPragmas(pragmas, range, comment);
        }
        context.pragmas = /* @__PURE__ */ new Map();
        for (const pragma of pragmas){
            if (context.pragmas.has(pragma.name)) {
                const currentValue = context.pragmas.get(pragma.name);
                if (currentValue instanceof Array) currentValue.push(pragma.args);
                else context.pragmas.set(pragma.name, [
                    currentValue,
                    pragma.args
                ]);
                continue;
            }
            context.pragmas.set(pragma.name, pragma.args);
        }
    }
    function processPragmasIntoFields(context, reportDiagnostic) {
        context.checkJsDirective = void 0;
        context.referencedFiles = [];
        context.typeReferenceDirectives = [];
        context.libReferenceDirectives = [];
        context.amdDependencies = [];
        context.hasNoDefaultLib = false;
        context.pragmas.forEach((entryOrList, key)=>{
            switch(key){
                case "reference":
                    {
                        const referencedFiles = context.referencedFiles;
                        const typeReferenceDirectives = context.typeReferenceDirectives;
                        const libReferenceDirectives = context.libReferenceDirectives;
                        forEach(toArray(entryOrList), (arg)=>{
                            const { types: types , lib: lib , path: path , ["resolution-mode"]: res  } = arg.arguments;
                            if (arg.arguments["no-default-lib"]) context.hasNoDefaultLib = true;
                            else if (types) {
                                const parsed = parseResolutionMode(res, types.pos, types.end, reportDiagnostic);
                                typeReferenceDirectives.push({
                                    pos: types.pos,
                                    end: types.end,
                                    fileName: types.value,
                                    ...parsed ? {
                                        resolutionMode: parsed
                                    } : {}
                                });
                            } else if (lib) libReferenceDirectives.push({
                                pos: lib.pos,
                                end: lib.end,
                                fileName: lib.value
                            });
                            else if (path) referencedFiles.push({
                                pos: path.pos,
                                end: path.end,
                                fileName: path.value
                            });
                            else reportDiagnostic(arg.range.pos, arg.range.end - arg.range.pos, Diagnostics.Invalid_reference_directive_syntax);
                        });
                        break;
                    }
                case "amd-dependency":
                    context.amdDependencies = map(toArray(entryOrList), (x)=>({
                            name: x.arguments.name,
                            path: x.arguments.path
                        }));
                    break;
                case "amd-module":
                    if (entryOrList instanceof Array) for (const entry of entryOrList){
                        if (context.moduleName) reportDiagnostic(entry.range.pos, entry.range.end - entry.range.pos, Diagnostics.An_AMD_module_cannot_have_multiple_name_assignments);
                        context.moduleName = entry.arguments.name;
                    }
                    else context.moduleName = entryOrList.arguments.name;
                    break;
                case "ts-nocheck":
                case "ts-check":
                    forEach(toArray(entryOrList), (entry)=>{
                        if (!context.checkJsDirective || entry.range.pos > context.checkJsDirective.pos) context.checkJsDirective = {
                            enabled: key === "ts-check",
                            end: entry.range.end,
                            pos: entry.range.pos
                        };
                    });
                    break;
                case "jsx":
                case "jsxfrag":
                case "jsximportsource":
                case "jsxruntime":
                    return;
                default:
                    Debug.fail("Unhandled pragma kind");
            }
        });
    }
    function getNamedArgRegEx(name) {
        if (namedArgRegExCache.has(name)) return namedArgRegExCache.get(name);
        const result = new RegExp(`(\\s${name}\\s*=\\s*)(?:(?:'([^']*)')|(?:"([^"]*)"))`, "im");
        namedArgRegExCache.set(name, result);
        return result;
    }
    function extractPragmas(pragmas, range, text) {
        const tripleSlash = range.kind === 2 /* SingleLineCommentTrivia */  && tripleSlashXMLCommentStartRegEx.exec(text);
        if (tripleSlash) {
            const name = tripleSlash[1].toLowerCase();
            const pragma = commentPragmas[name];
            if (!pragma || !(pragma.kind & 1 /* TripleSlashXML */ )) return;
            if (pragma.args) {
                const argument = {};
                for (const arg of pragma.args){
                    const matcher = getNamedArgRegEx(arg.name);
                    const matchResult = matcher.exec(text);
                    if (!matchResult && !arg.optional) return;
                    else if (matchResult) {
                        const value1 = matchResult[2] || matchResult[3];
                        if (arg.captureSpan) {
                            const startPos = range.pos + matchResult.index + matchResult[1].length + 1;
                            argument[arg.name] = {
                                value: value1,
                                pos: startPos,
                                end: startPos + value1.length
                            };
                        } else argument[arg.name] = value1;
                    }
                }
                pragmas.push({
                    name: name,
                    args: {
                        arguments: argument,
                        range: range
                    }
                });
            } else pragmas.push({
                name: name,
                args: {
                    arguments: {},
                    range: range
                }
            });
            return;
        }
        const singleLine = range.kind === 2 /* SingleLineCommentTrivia */  && singleLinePragmaRegEx.exec(text);
        if (singleLine) return addPragmaForMatch(pragmas, range, 2 /* SingleLine */ , singleLine);
        if (range.kind === 3 /* MultiLineCommentTrivia */ ) {
            const multiLinePragmaRegEx = /@(\S+)(\s+.*)?$/gim;
            let multiLineMatch;
            while(multiLineMatch = multiLinePragmaRegEx.exec(text))addPragmaForMatch(pragmas, range, 4 /* MultiLine */ , multiLineMatch);
        }
    }
    function addPragmaForMatch(pragmas, range, kind, match) {
        if (!match) return;
        const name = match[1].toLowerCase();
        const pragma = commentPragmas[name];
        if (!pragma || !(pragma.kind & kind)) return;
        const args = match[2];
        const argument = getNamedPragmaArguments(pragma, args);
        if (argument === "fail") return;
        pragmas.push({
            name: name,
            args: {
                arguments: argument,
                range: range
            }
        });
        return;
    }
    function getNamedPragmaArguments(pragma, text) {
        if (!text) return {};
        if (!pragma.args) return {};
        const args = trimString(text).split(/\s+/);
        const argMap = {};
        for(let i = 0; i < pragma.args.length; i++){
            const argument = pragma.args[i];
            if (!args[i] && !argument.optional) return "fail";
            if (argument.captureSpan) return Debug.fail("Capture spans not yet implemented for non-xml pragmas");
            argMap[argument.name] = args[i];
        }
        return argMap;
    }
    function tagNamesAreEquivalent(lhs, rhs) {
        if (lhs.kind !== rhs.kind) return false;
        if (lhs.kind === 80 /* Identifier */ ) return lhs.escapedText === rhs.escapedText;
        if (lhs.kind === 110 /* ThisKeyword */ ) return true;
        if (lhs.kind === 294 /* JsxNamespacedName */ ) return lhs.namespace.escapedText === rhs.namespace.escapedText && lhs.name.escapedText === rhs.name.escapedText;
        return lhs.name.escapedText === rhs.name.escapedText && tagNamesAreEquivalent(lhs.expression, rhs.expression);
    }
    var NodeConstructor, TokenConstructor, IdentifierConstructor, PrivateIdentifierConstructor, SourceFileConstructor, parseBaseNodeFactory, parseNodeFactory, forEachChildTable, Parser, IncrementalParser, namedArgRegExCache, tripleSlashXMLCommentStartRegEx, singleLinePragmaRegEx;
    var init_parser = __esm({
        "src/compiler/parser.ts" () {
            "use strict";
            init_ts2();
            init_ts_performance();
            parseBaseNodeFactory = {
                createBaseSourceFileNode: (kind)=>new (SourceFileConstructor || (SourceFileConstructor = objectAllocator.getSourceFileConstructor()))(kind, -1, -1),
                createBaseIdentifierNode: (kind)=>new (IdentifierConstructor || (IdentifierConstructor = objectAllocator.getIdentifierConstructor()))(kind, -1, -1),
                createBasePrivateIdentifierNode: (kind)=>new (PrivateIdentifierConstructor || (PrivateIdentifierConstructor = objectAllocator.getPrivateIdentifierConstructor()))(kind, -1, -1),
                createBaseTokenNode: (kind)=>new (TokenConstructor || (TokenConstructor = objectAllocator.getTokenConstructor()))(kind, -1, -1),
                createBaseNode: (kind)=>new (NodeConstructor || (NodeConstructor = objectAllocator.getNodeConstructor()))(kind, -1, -1)
            };
            parseNodeFactory = createNodeFactory(1 /* NoParenthesizerRules */ , parseBaseNodeFactory);
            forEachChildTable = {
                [165 /* QualifiedName */ ]: function forEachChildInQualifiedName(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.left) || visitNode2(cbNode, node.right);
                },
                [167 /* TypeParameter */ ]: function forEachChildInTypeParameter(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.constraint) || visitNode2(cbNode, node.default) || visitNode2(cbNode, node.expression);
                },
                [303 /* ShorthandPropertyAssignment */ ]: function forEachChildInShorthandPropertyAssignment(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.exclamationToken) || visitNode2(cbNode, node.equalsToken) || visitNode2(cbNode, node.objectAssignmentInitializer);
                },
                [304 /* SpreadAssignment */ ]: function forEachChildInSpreadAssignment(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [168 /* Parameter */ ]: function forEachChildInParameter(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.dotDotDotToken) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.initializer);
                },
                [171 /* PropertyDeclaration */ ]: function forEachChildInPropertyDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.exclamationToken) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.initializer);
                },
                [170 /* PropertySignature */ ]: function forEachChildInPropertySignature(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.initializer);
                },
                [302 /* PropertyAssignment */ ]: function forEachChildInPropertyAssignment(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.exclamationToken) || visitNode2(cbNode, node.initializer);
                },
                [259 /* VariableDeclaration */ ]: function forEachChildInVariableDeclaration(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.name) || visitNode2(cbNode, node.exclamationToken) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.initializer);
                },
                [207 /* BindingElement */ ]: function forEachChildInBindingElement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.dotDotDotToken) || visitNode2(cbNode, node.propertyName) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.initializer);
                },
                [180 /* IndexSignature */ ]: function forEachChildInIndexSignature(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
                },
                [184 /* ConstructorType */ ]: function forEachChildInConstructorType(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
                },
                [183 /* FunctionType */ ]: function forEachChildInFunctionType(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
                },
                [178 /* CallSignature */ ]: forEachChildInCallOrConstructSignature,
                [179 /* ConstructSignature */ ]: forEachChildInCallOrConstructSignature,
                [173 /* MethodDeclaration */ ]: function forEachChildInMethodDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.asteriskToken) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.exclamationToken) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
                },
                [172 /* MethodSignature */ ]: function forEachChildInMethodSignature(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
                },
                [175 /* Constructor */ ]: function forEachChildInConstructor(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
                },
                [176 /* GetAccessor */ ]: function forEachChildInGetAccessor(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
                },
                [177 /* SetAccessor */ ]: function forEachChildInSetAccessor(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
                },
                [261 /* FunctionDeclaration */ ]: function forEachChildInFunctionDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.asteriskToken) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
                },
                [217 /* FunctionExpression */ ]: function forEachChildInFunctionExpression(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.asteriskToken) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
                },
                [218 /* ArrowFunction */ ]: function forEachChildInArrowFunction(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.equalsGreaterThanToken) || visitNode2(cbNode, node.body);
                },
                [174 /* ClassStaticBlockDeclaration */ ]: function forEachChildInClassStaticBlockDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.body);
                },
                [182 /* TypeReference */ ]: function forEachChildInTypeReference(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.typeName) || visitNodes(cbNode, cbNodes, node.typeArguments);
                },
                [181 /* TypePredicate */ ]: function forEachChildInTypePredicate(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.assertsModifier) || visitNode2(cbNode, node.parameterName) || visitNode2(cbNode, node.type);
                },
                [185 /* TypeQuery */ ]: function forEachChildInTypeQuery(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.exprName) || visitNodes(cbNode, cbNodes, node.typeArguments);
                },
                [186 /* TypeLiteral */ ]: function forEachChildInTypeLiteral(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.members);
                },
                [187 /* ArrayType */ ]: function forEachChildInArrayType(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.elementType);
                },
                [188 /* TupleType */ ]: function forEachChildInTupleType(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.elements);
                },
                [191 /* UnionType */ ]: forEachChildInUnionOrIntersectionType,
                [192 /* IntersectionType */ ]: forEachChildInUnionOrIntersectionType,
                [193 /* ConditionalType */ ]: function forEachChildInConditionalType(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.checkType) || visitNode2(cbNode, node.extendsType) || visitNode2(cbNode, node.trueType) || visitNode2(cbNode, node.falseType);
                },
                [194 /* InferType */ ]: function forEachChildInInferType(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.typeParameter);
                },
                [204 /* ImportType */ ]: function forEachChildInImportType(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.argument) || visitNode2(cbNode, node.assertions) || visitNode2(cbNode, node.qualifier) || visitNodes(cbNode, cbNodes, node.typeArguments);
                },
                [301 /* ImportTypeAssertionContainer */ ]: function forEachChildInImportTypeAssertionContainer(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.assertClause);
                },
                [195 /* ParenthesizedType */ ]: forEachChildInParenthesizedTypeOrTypeOperator,
                [197 /* TypeOperator */ ]: forEachChildInParenthesizedTypeOrTypeOperator,
                [198 /* IndexedAccessType */ ]: function forEachChildInIndexedAccessType(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.objectType) || visitNode2(cbNode, node.indexType);
                },
                [199 /* MappedType */ ]: function forEachChildInMappedType(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.readonlyToken) || visitNode2(cbNode, node.typeParameter) || visitNode2(cbNode, node.nameType) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.type) || visitNodes(cbNode, cbNodes, node.members);
                },
                [200 /* LiteralType */ ]: function forEachChildInLiteralType(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.literal);
                },
                [201 /* NamedTupleMember */ ]: function forEachChildInNamedTupleMember(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.dotDotDotToken) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.type);
                },
                [205 /* ObjectBindingPattern */ ]: forEachChildInObjectOrArrayBindingPattern,
                [206 /* ArrayBindingPattern */ ]: forEachChildInObjectOrArrayBindingPattern,
                [208 /* ArrayLiteralExpression */ ]: function forEachChildInArrayLiteralExpression(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.elements);
                },
                [209 /* ObjectLiteralExpression */ ]: function forEachChildInObjectLiteralExpression(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.properties);
                },
                [210 /* PropertyAccessExpression */ ]: function forEachChildInPropertyAccessExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.questionDotToken) || visitNode2(cbNode, node.name);
                },
                [211 /* ElementAccessExpression */ ]: function forEachChildInElementAccessExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.questionDotToken) || visitNode2(cbNode, node.argumentExpression);
                },
                [212 /* CallExpression */ ]: forEachChildInCallOrNewExpression,
                [213 /* NewExpression */ ]: forEachChildInCallOrNewExpression,
                [214 /* TaggedTemplateExpression */ ]: function forEachChildInTaggedTemplateExpression(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.tag) || visitNode2(cbNode, node.questionDotToken) || visitNodes(cbNode, cbNodes, node.typeArguments) || visitNode2(cbNode, node.template);
                },
                [215 /* TypeAssertionExpression */ ]: function forEachChildInTypeAssertionExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.type) || visitNode2(cbNode, node.expression);
                },
                [216 /* ParenthesizedExpression */ ]: function forEachChildInParenthesizedExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [219 /* DeleteExpression */ ]: function forEachChildInDeleteExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [220 /* TypeOfExpression */ ]: function forEachChildInTypeOfExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [221 /* VoidExpression */ ]: function forEachChildInVoidExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [223 /* PrefixUnaryExpression */ ]: function forEachChildInPrefixUnaryExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.operand);
                },
                [228 /* YieldExpression */ ]: function forEachChildInYieldExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.asteriskToken) || visitNode2(cbNode, node.expression);
                },
                [222 /* AwaitExpression */ ]: function forEachChildInAwaitExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [224 /* PostfixUnaryExpression */ ]: function forEachChildInPostfixUnaryExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.operand);
                },
                [225 /* BinaryExpression */ ]: function forEachChildInBinaryExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.left) || visitNode2(cbNode, node.operatorToken) || visitNode2(cbNode, node.right);
                },
                [233 /* AsExpression */ ]: function forEachChildInAsExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.type);
                },
                [234 /* NonNullExpression */ ]: function forEachChildInNonNullExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [237 /* SatisfiesExpression */ ]: function forEachChildInSatisfiesExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.type);
                },
                [235 /* MetaProperty */ ]: function forEachChildInMetaProperty(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.name);
                },
                [226 /* ConditionalExpression */ ]: function forEachChildInConditionalExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.condition) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.whenTrue) || visitNode2(cbNode, node.colonToken) || visitNode2(cbNode, node.whenFalse);
                },
                [229 /* SpreadElement */ ]: function forEachChildInSpreadElement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [240 /* Block */ ]: forEachChildInBlock,
                [267 /* ModuleBlock */ ]: forEachChildInBlock,
                [311 /* SourceFile */ ]: function forEachChildInSourceFile(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.statements) || visitNode2(cbNode, node.endOfFileToken);
                },
                [242 /* VariableStatement */ ]: function forEachChildInVariableStatement(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.declarationList);
                },
                [260 /* VariableDeclarationList */ ]: function forEachChildInVariableDeclarationList(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.declarations);
                },
                [243 /* ExpressionStatement */ ]: function forEachChildInExpressionStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [244 /* IfStatement */ ]: function forEachChildInIfStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.thenStatement) || visitNode2(cbNode, node.elseStatement);
                },
                [245 /* DoStatement */ ]: function forEachChildInDoStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.statement) || visitNode2(cbNode, node.expression);
                },
                [246 /* WhileStatement */ ]: function forEachChildInWhileStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.statement);
                },
                [247 /* ForStatement */ ]: function forEachChildInForStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.initializer) || visitNode2(cbNode, node.condition) || visitNode2(cbNode, node.incrementor) || visitNode2(cbNode, node.statement);
                },
                [248 /* ForInStatement */ ]: function forEachChildInForInStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.initializer) || visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.statement);
                },
                [249 /* ForOfStatement */ ]: function forEachChildInForOfStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.awaitModifier) || visitNode2(cbNode, node.initializer) || visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.statement);
                },
                [250 /* ContinueStatement */ ]: forEachChildInContinueOrBreakStatement,
                [251 /* BreakStatement */ ]: forEachChildInContinueOrBreakStatement,
                [252 /* ReturnStatement */ ]: function forEachChildInReturnStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [253 /* WithStatement */ ]: function forEachChildInWithStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.statement);
                },
                [254 /* SwitchStatement */ ]: function forEachChildInSwitchStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.caseBlock);
                },
                [268 /* CaseBlock */ ]: function forEachChildInCaseBlock(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.clauses);
                },
                [295 /* CaseClause */ ]: function forEachChildInCaseClause(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.expression) || visitNodes(cbNode, cbNodes, node.statements);
                },
                [296 /* DefaultClause */ ]: function forEachChildInDefaultClause(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.statements);
                },
                [255 /* LabeledStatement */ ]: function forEachChildInLabeledStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.label) || visitNode2(cbNode, node.statement);
                },
                [256 /* ThrowStatement */ ]: function forEachChildInThrowStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [257 /* TryStatement */ ]: function forEachChildInTryStatement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.tryBlock) || visitNode2(cbNode, node.catchClause) || visitNode2(cbNode, node.finallyBlock);
                },
                [298 /* CatchClause */ ]: function forEachChildInCatchClause(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.variableDeclaration) || visitNode2(cbNode, node.block);
                },
                [169 /* Decorator */ ]: function forEachChildInDecorator(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [262 /* ClassDeclaration */ ]: forEachChildInClassDeclarationOrExpression,
                [230 /* ClassExpression */ ]: forEachChildInClassDeclarationOrExpression,
                [263 /* InterfaceDeclaration */ ]: function forEachChildInInterfaceDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.heritageClauses) || visitNodes(cbNode, cbNodes, node.members);
                },
                [264 /* TypeAliasDeclaration */ ]: function forEachChildInTypeAliasDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNode2(cbNode, node.type);
                },
                [265 /* EnumDeclaration */ ]: function forEachChildInEnumDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.members);
                },
                [305 /* EnumMember */ ]: function forEachChildInEnumMember(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.name) || visitNode2(cbNode, node.initializer);
                },
                [266 /* ModuleDeclaration */ ]: function forEachChildInModuleDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.body);
                },
                [270 /* ImportEqualsDeclaration */ ]: function forEachChildInImportEqualsDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.moduleReference);
                },
                [271 /* ImportDeclaration */ ]: function forEachChildInImportDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.importClause) || visitNode2(cbNode, node.moduleSpecifier) || visitNode2(cbNode, node.assertClause);
                },
                [272 /* ImportClause */ ]: function forEachChildInImportClause(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.name) || visitNode2(cbNode, node.namedBindings);
                },
                [299 /* AssertClause */ ]: function forEachChildInAssertClause(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.elements);
                },
                [300 /* AssertEntry */ ]: function forEachChildInAssertEntry(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.name) || visitNode2(cbNode, node.value);
                },
                [269 /* NamespaceExportDeclaration */ ]: function forEachChildInNamespaceExportDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name);
                },
                [273 /* NamespaceImport */ ]: function forEachChildInNamespaceImport(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.name);
                },
                [279 /* NamespaceExport */ ]: function forEachChildInNamespaceExport(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.name);
                },
                [274 /* NamedImports */ ]: forEachChildInNamedImportsOrExports,
                [278 /* NamedExports */ ]: forEachChildInNamedImportsOrExports,
                [277 /* ExportDeclaration */ ]: function forEachChildInExportDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.exportClause) || visitNode2(cbNode, node.moduleSpecifier) || visitNode2(cbNode, node.assertClause);
                },
                [275 /* ImportSpecifier */ ]: forEachChildInImportOrExportSpecifier,
                [280 /* ExportSpecifier */ ]: forEachChildInImportOrExportSpecifier,
                [276 /* ExportAssignment */ ]: function forEachChildInExportAssignment(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.expression);
                },
                [227 /* TemplateExpression */ ]: function forEachChildInTemplateExpression(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.head) || visitNodes(cbNode, cbNodes, node.templateSpans);
                },
                [238 /* TemplateSpan */ ]: function forEachChildInTemplateSpan(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.literal);
                },
                [202 /* TemplateLiteralType */ ]: function forEachChildInTemplateLiteralType(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.head) || visitNodes(cbNode, cbNodes, node.templateSpans);
                },
                [203 /* TemplateLiteralTypeSpan */ ]: function forEachChildInTemplateLiteralTypeSpan(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.type) || visitNode2(cbNode, node.literal);
                },
                [166 /* ComputedPropertyName */ ]: function forEachChildInComputedPropertyName(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [297 /* HeritageClause */ ]: function forEachChildInHeritageClause(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.types);
                },
                [232 /* ExpressionWithTypeArguments */ ]: function forEachChildInExpressionWithTypeArguments(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.expression) || visitNodes(cbNode, cbNodes, node.typeArguments);
                },
                [282 /* ExternalModuleReference */ ]: function forEachChildInExternalModuleReference(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [281 /* MissingDeclaration */ ]: function forEachChildInMissingDeclaration(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.modifiers);
                },
                [360 /* CommaListExpression */ ]: function forEachChildInCommaListExpression(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.elements);
                },
                [283 /* JsxElement */ ]: function forEachChildInJsxElement(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.openingElement) || visitNodes(cbNode, cbNodes, node.children) || visitNode2(cbNode, node.closingElement);
                },
                [287 /* JsxFragment */ ]: function forEachChildInJsxFragment(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.openingFragment) || visitNodes(cbNode, cbNodes, node.children) || visitNode2(cbNode, node.closingFragment);
                },
                [284 /* JsxSelfClosingElement */ ]: forEachChildInJsxOpeningOrSelfClosingElement,
                [285 /* JsxOpeningElement */ ]: forEachChildInJsxOpeningOrSelfClosingElement,
                [291 /* JsxAttributes */ ]: function forEachChildInJsxAttributes(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.properties);
                },
                [290 /* JsxAttribute */ ]: function forEachChildInJsxAttribute(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.name) || visitNode2(cbNode, node.initializer);
                },
                [292 /* JsxSpreadAttribute */ ]: function forEachChildInJsxSpreadAttribute(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.expression);
                },
                [293 /* JsxExpression */ ]: function forEachChildInJsxExpression(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.dotDotDotToken) || visitNode2(cbNode, node.expression);
                },
                [286 /* JsxClosingElement */ ]: function forEachChildInJsxClosingElement(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.tagName);
                },
                [294 /* JsxNamespacedName */ ]: function forEachChildInJsxNamespacedName(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.namespace) || visitNode2(cbNode, node.name);
                },
                [189 /* OptionalType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
                [190 /* RestType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
                [315 /* JSDocTypeExpression */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
                [321 /* JSDocNonNullableType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
                [320 /* JSDocNullableType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
                [322 /* JSDocOptionalType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
                [324 /* JSDocVariadicType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
                [323 /* JSDocFunctionType */ ]: function forEachChildInJSDocFunctionType(node, cbNode, cbNodes) {
                    return visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
                },
                [326 /* JSDoc */ ]: function forEachChildInJSDoc(node, cbNode, cbNodes) {
                    return (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment)) || visitNodes(cbNode, cbNodes, node.tags);
                },
                [353 /* JSDocSeeTag */ ]: function forEachChildInJSDocSeeTag(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.name) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
                },
                [316 /* JSDocNameReference */ ]: function forEachChildInJSDocNameReference(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.name);
                },
                [317 /* JSDocMemberName */ ]: function forEachChildInJSDocMemberName(node, cbNode, _cbNodes) {
                    return visitNode2(cbNode, node.left) || visitNode2(cbNode, node.right);
                },
                [347 /* JSDocParameterTag */ ]: forEachChildInJSDocParameterOrPropertyTag,
                [354 /* JSDocPropertyTag */ ]: forEachChildInJSDocParameterOrPropertyTag,
                [336 /* JSDocAuthorTag */ ]: function forEachChildInJSDocAuthorTag(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.tagName) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
                },
                [335 /* JSDocImplementsTag */ ]: function forEachChildInJSDocImplementsTag(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.class) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
                },
                [334 /* JSDocAugmentsTag */ ]: function forEachChildInJSDocAugmentsTag(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.class) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
                },
                [351 /* JSDocTemplateTag */ ]: function forEachChildInJSDocTemplateTag(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.constraint) || visitNodes(cbNode, cbNodes, node.typeParameters) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
                },
                [352 /* JSDocTypedefTag */ ]: function forEachChildInJSDocTypedefTag(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.tagName) || (node.typeExpression && node.typeExpression.kind === 315 /* JSDocTypeExpression */  ? visitNode2(cbNode, node.typeExpression) || visitNode2(cbNode, node.fullName) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment)) : visitNode2(cbNode, node.fullName) || visitNode2(cbNode, node.typeExpression) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment)));
                },
                [344 /* JSDocCallbackTag */ ]: function forEachChildInJSDocCallbackTag(node, cbNode, cbNodes) {
                    return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.fullName) || visitNode2(cbNode, node.typeExpression) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
                },
                [348 /* JSDocReturnTag */ ]: forEachChildInJSDocTypeLikeTag,
                [350 /* JSDocTypeTag */ ]: forEachChildInJSDocTypeLikeTag,
                [349 /* JSDocThisTag */ ]: forEachChildInJSDocTypeLikeTag,
                [346 /* JSDocEnumTag */ ]: forEachChildInJSDocTypeLikeTag,
                [356 /* JSDocSatisfiesTag */ ]: forEachChildInJSDocTypeLikeTag,
                [355 /* JSDocThrowsTag */ ]: forEachChildInJSDocTypeLikeTag,
                [345 /* JSDocOverloadTag */ ]: forEachChildInJSDocTypeLikeTag,
                [329 /* JSDocSignature */ ]: function forEachChildInJSDocSignature(node, cbNode, _cbNodes) {
                    return forEach(node.typeParameters, cbNode) || forEach(node.parameters, cbNode) || visitNode2(cbNode, node.type);
                },
                [330 /* JSDocLink */ ]: forEachChildInJSDocLinkCodeOrPlain,
                [331 /* JSDocLinkCode */ ]: forEachChildInJSDocLinkCodeOrPlain,
                [332 /* JSDocLinkPlain */ ]: forEachChildInJSDocLinkCodeOrPlain,
                [328 /* JSDocTypeLiteral */ ]: function forEachChildInJSDocTypeLiteral(node, cbNode, _cbNodes) {
                    return forEach(node.jsDocPropertyTags, cbNode);
                },
                [333 /* JSDocTag */ ]: forEachChildInJSDocTag,
                [338 /* JSDocClassTag */ ]: forEachChildInJSDocTag,
                [339 /* JSDocPublicTag */ ]: forEachChildInJSDocTag,
                [340 /* JSDocPrivateTag */ ]: forEachChildInJSDocTag,
                [341 /* JSDocProtectedTag */ ]: forEachChildInJSDocTag,
                [342 /* JSDocReadonlyTag */ ]: forEachChildInJSDocTag,
                [337 /* JSDocDeprecatedTag */ ]: forEachChildInJSDocTag,
                [343 /* JSDocOverrideTag */ ]: forEachChildInJSDocTag,
                [359 /* PartiallyEmittedExpression */ ]: forEachChildInPartiallyEmittedExpression
            };
            ((Parser2)=>{
                var scanner2 = createScanner(99 /* Latest */ , /*skipTrivia*/ true);
                var disallowInAndDecoratorContext = 20480 /* DecoratorContext */ ;
                var NodeConstructor2;
                var TokenConstructor2;
                var IdentifierConstructor2;
                var PrivateIdentifierConstructor2;
                var SourceFileConstructor2;
                function countNode(node) {
                    nodeCount++;
                    return node;
                }
                var baseNodeFactory = {
                    createBaseSourceFileNode: (kind)=>countNode(new SourceFileConstructor2(kind, /*pos*/ 0, /*end*/ 0)),
                    createBaseIdentifierNode: (kind)=>countNode(new IdentifierConstructor2(kind, /*pos*/ 0, /*end*/ 0)),
                    createBasePrivateIdentifierNode: (kind)=>countNode(new PrivateIdentifierConstructor2(kind, /*pos*/ 0, /*end*/ 0)),
                    createBaseTokenNode: (kind)=>countNode(new TokenConstructor2(kind, /*pos*/ 0, /*end*/ 0)),
                    createBaseNode: (kind)=>countNode(new NodeConstructor2(kind, /*pos*/ 0, /*end*/ 0))
                };
                var factory2 = createNodeFactory(11 /* NoOriginalNode */ , baseNodeFactory);
                var { createNodeArray: factoryCreateNodeArray , createNumericLiteral: factoryCreateNumericLiteral , createStringLiteral: factoryCreateStringLiteral , createLiteralLikeNode: factoryCreateLiteralLikeNode , createIdentifier: factoryCreateIdentifier , createPrivateIdentifier: factoryCreatePrivateIdentifier , createToken: factoryCreateToken , createArrayLiteralExpression: factoryCreateArrayLiteralExpression , createObjectLiteralExpression: factoryCreateObjectLiteralExpression , createPropertyAccessExpression: factoryCreatePropertyAccessExpression , createPropertyAccessChain: factoryCreatePropertyAccessChain , createElementAccessExpression: factoryCreateElementAccessExpression , createElementAccessChain: factoryCreateElementAccessChain , createCallExpression: factoryCreateCallExpression , createCallChain: factoryCreateCallChain , createNewExpression: factoryCreateNewExpression , createParenthesizedExpression: factoryCreateParenthesizedExpression , createBlock: factoryCreateBlock , createVariableStatement: factoryCreateVariableStatement , createExpressionStatement: factoryCreateExpressionStatement , createIfStatement: factoryCreateIfStatement , createWhileStatement: factoryCreateWhileStatement , createForStatement: factoryCreateForStatement , createForOfStatement: factoryCreateForOfStatement , createVariableDeclaration: factoryCreateVariableDeclaration , createVariableDeclarationList: factoryCreateVariableDeclarationList  } = factory2;
                var fileName;
                var sourceFlags;
                var sourceText;
                var languageVersion;
                var scriptKind;
                var languageVariant;
                var parseDiagnostics;
                var jsDocDiagnostics;
                var syntaxCursor;
                var currentToken;
                var nodeCount;
                var identifiers;
                var identifierCount;
                var parsingContext;
                var notParenthesizedArrow;
                var contextFlags;
                var topLevel = true;
                var parseErrorBeforeNextFinishedNode = false;
                function parseSourceFile(fileName2, sourceText2, languageVersion2, syntaxCursor2, setParentNodes = false, scriptKind2, setExternalModuleIndicatorOverride) {
                    var _a;
                    scriptKind2 = ensureScriptKind(fileName2, scriptKind2);
                    if (scriptKind2 === 6 /* JSON */ ) {
                        const result2 = parseJsonText2(fileName2, sourceText2, languageVersion2, syntaxCursor2, setParentNodes);
                        convertToJson(result2, (_a = result2.statements[0]) == null ? void 0 : _a.expression, result2.parseDiagnostics, /*returnValue*/ false, /*jsonConversionNotifier*/ void 0);
                        result2.referencedFiles = emptyArray;
                        result2.typeReferenceDirectives = emptyArray;
                        result2.libReferenceDirectives = emptyArray;
                        result2.amdDependencies = emptyArray;
                        result2.hasNoDefaultLib = false;
                        result2.pragmas = emptyMap;
                        return result2;
                    }
                    initializeState(fileName2, sourceText2, languageVersion2, syntaxCursor2, scriptKind2);
                    const result = parseSourceFileWorker(languageVersion2, setParentNodes, scriptKind2, setExternalModuleIndicatorOverride || setExternalModuleIndicator);
                    clearState();
                    return result;
                }
                Parser2.parseSourceFile = parseSourceFile;
                function parseIsolatedEntityName2(content, languageVersion2) {
                    initializeState("", content, languageVersion2, /*syntaxCursor*/ void 0, 1 /* JS */ );
                    nextToken();
                    const entityName = parseEntityName(/*allowReservedWords*/ true);
                    const isInvalid = token() === 1 /* EndOfFileToken */  && !parseDiagnostics.length;
                    clearState();
                    return isInvalid ? entityName : void 0;
                }
                Parser2.parseIsolatedEntityName = parseIsolatedEntityName2;
                function parseJsonText2(fileName2, sourceText2, languageVersion2 = 2 /* ES2015 */ , syntaxCursor2, setParentNodes = false) {
                    initializeState(fileName2, sourceText2, languageVersion2, syntaxCursor2, 6 /* JSON */ );
                    sourceFlags = contextFlags;
                    nextToken();
                    const pos = getNodePos();
                    let statements, endOfFileToken;
                    if (token() === 1 /* EndOfFileToken */ ) {
                        statements = createNodeArray([], pos, pos);
                        endOfFileToken = parseTokenNode();
                    } else {
                        let expressions;
                        while(token() !== 1 /* EndOfFileToken */ ){
                            let expression2;
                            switch(token()){
                                case 23 /* OpenBracketToken */ :
                                    expression2 = parseArrayLiteralExpression();
                                    break;
                                case 112 /* TrueKeyword */ :
                                case 97 /* FalseKeyword */ :
                                case 106 /* NullKeyword */ :
                                    expression2 = parseTokenNode();
                                    break;
                                case 41 /* MinusToken */ :
                                    if (lookAhead(()=>nextToken() === 9 /* NumericLiteral */  && nextToken() !== 59 /* ColonToken */ )) expression2 = parsePrefixUnaryExpression();
                                    else expression2 = parseObjectLiteralExpression();
                                    break;
                                case 9 /* NumericLiteral */ :
                                case 11 /* StringLiteral */ :
                                    if (lookAhead(()=>nextToken() !== 59 /* ColonToken */ )) {
                                        expression2 = parseLiteralNode();
                                        break;
                                    }
                                default:
                                    expression2 = parseObjectLiteralExpression();
                                    break;
                            }
                            if (expressions && isArray(expressions)) expressions.push(expression2);
                            else if (expressions) expressions = [
                                expressions,
                                expression2
                            ];
                            else {
                                expressions = expression2;
                                if (token() !== 1 /* EndOfFileToken */ ) parseErrorAtCurrentToken(Diagnostics.Unexpected_token);
                            }
                        }
                        const expression = isArray(expressions) ? finishNode(factoryCreateArrayLiteralExpression(expressions), pos) : Debug.checkDefined(expressions);
                        const statement = factoryCreateExpressionStatement(expression);
                        finishNode(statement, pos);
                        statements = createNodeArray([
                            statement
                        ], pos);
                        endOfFileToken = parseExpectedToken(1 /* EndOfFileToken */ , Diagnostics.Unexpected_token);
                    }
                    const sourceFile = createSourceFile2(fileName2, 2 /* ES2015 */ , 6 /* JSON */ , /*isDeclarationFile*/ false, statements, endOfFileToken, sourceFlags, noop);
                    if (setParentNodes) fixupParentReferences(sourceFile);
                    sourceFile.nodeCount = nodeCount;
                    sourceFile.identifierCount = identifierCount;
                    sourceFile.identifiers = identifiers;
                    sourceFile.parseDiagnostics = attachFileToDiagnostics(parseDiagnostics, sourceFile);
                    if (jsDocDiagnostics) sourceFile.jsDocDiagnostics = attachFileToDiagnostics(jsDocDiagnostics, sourceFile);
                    const result = sourceFile;
                    clearState();
                    return result;
                }
                Parser2.parseJsonText = parseJsonText2;
                function initializeState(_fileName, _sourceText, _languageVersion, _syntaxCursor, _scriptKind) {
                    NodeConstructor2 = objectAllocator.getNodeConstructor();
                    TokenConstructor2 = objectAllocator.getTokenConstructor();
                    IdentifierConstructor2 = objectAllocator.getIdentifierConstructor();
                    PrivateIdentifierConstructor2 = objectAllocator.getPrivateIdentifierConstructor();
                    SourceFileConstructor2 = objectAllocator.getSourceFileConstructor();
                    fileName = normalizePath(_fileName);
                    sourceText = _sourceText;
                    languageVersion = _languageVersion;
                    syntaxCursor = _syntaxCursor;
                    scriptKind = _scriptKind;
                    languageVariant = getLanguageVariant(_scriptKind);
                    parseDiagnostics = [];
                    parsingContext = 0;
                    identifiers = /* @__PURE__ */ new Map();
                    identifierCount = 0;
                    nodeCount = 0;
                    sourceFlags = 0;
                    topLevel = true;
                    switch(scriptKind){
                        case 1 /* JS */ :
                        case 2 /* JSX */ :
                            contextFlags = 262144 /* JavaScriptFile */ ;
                            break;
                        case 6 /* JSON */ :
                            contextFlags = 67371008 /* JsonFile */ ;
                            break;
                        default:
                            contextFlags = 0 /* None */ ;
                            break;
                    }
                    parseErrorBeforeNextFinishedNode = false;
                    scanner2.setText(sourceText);
                    scanner2.setOnError(scanError);
                    scanner2.setScriptTarget(languageVersion);
                    scanner2.setLanguageVariant(languageVariant);
                }
                function clearState() {
                    scanner2.clearCommentDirectives();
                    scanner2.setText("");
                    scanner2.setOnError(void 0);
                    sourceText = void 0;
                    languageVersion = void 0;
                    syntaxCursor = void 0;
                    scriptKind = void 0;
                    languageVariant = void 0;
                    sourceFlags = 0;
                    parseDiagnostics = void 0;
                    jsDocDiagnostics = void 0;
                    parsingContext = 0;
                    identifiers = void 0;
                    notParenthesizedArrow = void 0;
                    topLevel = true;
                }
                function parseSourceFileWorker(languageVersion2, setParentNodes, scriptKind2, setExternalModuleIndicator2) {
                    const isDeclarationFile = isDeclarationFileName(fileName);
                    if (isDeclarationFile) contextFlags |= 16777216 /* Ambient */ ;
                    sourceFlags = contextFlags;
                    nextToken();
                    const statements = parseList(0 /* SourceElements */ , parseStatement);
                    Debug.assert(token() === 1 /* EndOfFileToken */ );
                    const endOfFileToken = addJSDocComment(parseTokenNode());
                    const sourceFile = createSourceFile2(fileName, languageVersion2, scriptKind2, isDeclarationFile, statements, endOfFileToken, sourceFlags, setExternalModuleIndicator2);
                    processCommentPragmas(sourceFile, sourceText);
                    processPragmasIntoFields(sourceFile, reportPragmaDiagnostic);
                    sourceFile.commentDirectives = scanner2.getCommentDirectives();
                    sourceFile.nodeCount = nodeCount;
                    sourceFile.identifierCount = identifierCount;
                    sourceFile.identifiers = identifiers;
                    sourceFile.parseDiagnostics = attachFileToDiagnostics(parseDiagnostics, sourceFile);
                    if (jsDocDiagnostics) sourceFile.jsDocDiagnostics = attachFileToDiagnostics(jsDocDiagnostics, sourceFile);
                    if (setParentNodes) fixupParentReferences(sourceFile);
                    return sourceFile;
                    function reportPragmaDiagnostic(pos, end, diagnostic) {
                        parseDiagnostics.push(createDetachedDiagnostic(fileName, pos, end, diagnostic));
                    }
                }
                function withJSDoc(node, hasJSDoc) {
                    return hasJSDoc ? addJSDocComment(node) : node;
                }
                let hasDeprecatedTag = false;
                function addJSDocComment(node) {
                    Debug.assert(!node.jsDoc);
                    const jsDoc = mapDefined(getJSDocCommentRanges(node, sourceText), (comment)=>JSDocParser.parseJSDocComment(node, comment.pos, comment.end - comment.pos));
                    if (jsDoc.length) node.jsDoc = jsDoc;
                    if (hasDeprecatedTag) {
                        hasDeprecatedTag = false;
                        node.flags |= 268435456 /* Deprecated */ ;
                    }
                    return node;
                }
                function reparseTopLevelAwait(sourceFile) {
                    const savedSyntaxCursor = syntaxCursor;
                    const baseSyntaxCursor = IncrementalParser.createSyntaxCursor(sourceFile);
                    syntaxCursor = {
                        currentNode: currentNode2
                    };
                    const statements = [];
                    const savedParseDiagnostics = parseDiagnostics;
                    parseDiagnostics = [];
                    let pos = 0;
                    let start = findNextStatementWithAwait(sourceFile.statements, 0);
                    while(start !== -1){
                        const prevStatement = sourceFile.statements[pos];
                        const nextStatement = sourceFile.statements[start];
                        addRange(statements, sourceFile.statements, pos, start);
                        pos = findNextStatementWithoutAwait(sourceFile.statements, start);
                        const diagnosticStart = findIndex(savedParseDiagnostics, (diagnostic)=>diagnostic.start >= prevStatement.pos);
                        const diagnosticEnd = diagnosticStart >= 0 ? findIndex(savedParseDiagnostics, (diagnostic)=>diagnostic.start >= nextStatement.pos, diagnosticStart) : -1;
                        if (diagnosticStart >= 0) addRange(parseDiagnostics, savedParseDiagnostics, diagnosticStart, diagnosticEnd >= 0 ? diagnosticEnd : void 0);
                        speculationHelper(()=>{
                            const savedContextFlags = contextFlags;
                            contextFlags |= 32768 /* AwaitContext */ ;
                            scanner2.resetTokenState(nextStatement.pos);
                            nextToken();
                            while(token() !== 1 /* EndOfFileToken */ ){
                                const startPos = scanner2.getTokenFullStart();
                                const statement = parseListElement(0 /* SourceElements */ , parseStatement);
                                statements.push(statement);
                                if (startPos === scanner2.getTokenFullStart()) nextToken();
                                if (pos >= 0) {
                                    const nonAwaitStatement = sourceFile.statements[pos];
                                    if (statement.end === nonAwaitStatement.pos) break;
                                    if (statement.end > nonAwaitStatement.pos) pos = findNextStatementWithoutAwait(sourceFile.statements, pos + 1);
                                }
                            }
                            contextFlags = savedContextFlags;
                        }, 2 /* Reparse */ );
                        start = pos >= 0 ? findNextStatementWithAwait(sourceFile.statements, pos) : -1;
                    }
                    if (pos >= 0) {
                        const prevStatement = sourceFile.statements[pos];
                        addRange(statements, sourceFile.statements, pos);
                        const diagnosticStart = findIndex(savedParseDiagnostics, (diagnostic)=>diagnostic.start >= prevStatement.pos);
                        if (diagnosticStart >= 0) addRange(parseDiagnostics, savedParseDiagnostics, diagnosticStart);
                    }
                    syntaxCursor = savedSyntaxCursor;
                    return factory2.updateSourceFile(sourceFile, setTextRange(factoryCreateNodeArray(statements), sourceFile.statements));
                    function containsPossibleTopLevelAwait(node) {
                        return !(node.flags & 32768 /* AwaitContext */ ) && !!(node.transformFlags & 67108864 /* ContainsPossibleTopLevelAwait */ );
                    }
                    function findNextStatementWithAwait(statements2, start2) {
                        for(let i = start2; i < statements2.length; i++){
                            if (containsPossibleTopLevelAwait(statements2[i])) return i;
                        }
                        return -1;
                    }
                    function findNextStatementWithoutAwait(statements2, start2) {
                        for(let i = start2; i < statements2.length; i++){
                            if (!containsPossibleTopLevelAwait(statements2[i])) return i;
                        }
                        return -1;
                    }
                    function currentNode2(position) {
                        const node = baseSyntaxCursor.currentNode(position);
                        if (topLevel && node && containsPossibleTopLevelAwait(node)) node.intersectsChange = true;
                        return node;
                    }
                }
                function fixupParentReferences(rootNode) {
                    setParentRecursive(rootNode, /*incremental*/ true);
                }
                Parser2.fixupParentReferences = fixupParentReferences;
                function createSourceFile2(fileName2, languageVersion2, scriptKind2, isDeclarationFile, statements, endOfFileToken, flags, setExternalModuleIndicator2) {
                    let sourceFile = factory2.createSourceFile(statements, endOfFileToken, flags);
                    setTextRangePosWidth(sourceFile, 0, sourceText.length);
                    setFields(sourceFile);
                    if (!isDeclarationFile && isExternalModule(sourceFile) && sourceFile.transformFlags & 67108864 /* ContainsPossibleTopLevelAwait */ ) {
                        sourceFile = reparseTopLevelAwait(sourceFile);
                        setFields(sourceFile);
                    }
                    return sourceFile;
                    function setFields(sourceFile2) {
                        sourceFile2.text = sourceText;
                        sourceFile2.bindDiagnostics = [];
                        sourceFile2.bindSuggestionDiagnostics = void 0;
                        sourceFile2.languageVersion = languageVersion2;
                        sourceFile2.fileName = fileName2;
                        sourceFile2.languageVariant = getLanguageVariant(scriptKind2);
                        sourceFile2.isDeclarationFile = isDeclarationFile;
                        sourceFile2.scriptKind = scriptKind2;
                        setExternalModuleIndicator2(sourceFile2);
                        sourceFile2.setExternalModuleIndicator = setExternalModuleIndicator2;
                    }
                }
                function setContextFlag(val, flag) {
                    if (val) contextFlags |= flag;
                    else contextFlags &= ~flag;
                }
                function setDisallowInContext(val) {
                    setContextFlag(val, 4096 /* DisallowInContext */ );
                }
                function setYieldContext(val) {
                    setContextFlag(val, 8192 /* YieldContext */ );
                }
                function setDecoratorContext(val) {
                    setContextFlag(val, 16384 /* DecoratorContext */ );
                }
                function setAwaitContext(val) {
                    setContextFlag(val, 32768 /* AwaitContext */ );
                }
                function doOutsideOfContext(context, func) {
                    const contextFlagsToClear = context & contextFlags;
                    if (contextFlagsToClear) {
                        setContextFlag(/*val*/ false, contextFlagsToClear);
                        const result = func();
                        setContextFlag(/*val*/ true, contextFlagsToClear);
                        return result;
                    }
                    return func();
                }
                function doInsideOfContext(context, func) {
                    const contextFlagsToSet = context & ~contextFlags;
                    if (contextFlagsToSet) {
                        setContextFlag(/*val*/ true, contextFlagsToSet);
                        const result = func();
                        setContextFlag(/*val*/ false, contextFlagsToSet);
                        return result;
                    }
                    return func();
                }
                function allowInAnd(func) {
                    return doOutsideOfContext(4096 /* DisallowInContext */ , func);
                }
                function disallowInAnd(func) {
                    return doInsideOfContext(4096 /* DisallowInContext */ , func);
                }
                function allowConditionalTypesAnd(func) {
                    return doOutsideOfContext(65536 /* DisallowConditionalTypesContext */ , func);
                }
                function disallowConditionalTypesAnd(func) {
                    return doInsideOfContext(65536 /* DisallowConditionalTypesContext */ , func);
                }
                function doInYieldContext(func) {
                    return doInsideOfContext(8192 /* YieldContext */ , func);
                }
                function doInDecoratorContext(func) {
                    return doInsideOfContext(16384 /* DecoratorContext */ , func);
                }
                function doInAwaitContext(func) {
                    return doInsideOfContext(32768 /* AwaitContext */ , func);
                }
                function doOutsideOfAwaitContext(func) {
                    return doOutsideOfContext(32768 /* AwaitContext */ , func);
                }
                function doInYieldAndAwaitContext(func) {
                    return doInsideOfContext(40960 /* AwaitContext */ , func);
                }
                function doOutsideOfYieldAndAwaitContext(func) {
                    return doOutsideOfContext(40960 /* AwaitContext */ , func);
                }
                function inContext(flags) {
                    return (contextFlags & flags) !== 0;
                }
                function inYieldContext() {
                    return inContext(8192 /* YieldContext */ );
                }
                function inDisallowInContext() {
                    return inContext(4096 /* DisallowInContext */ );
                }
                function inDisallowConditionalTypesContext() {
                    return inContext(65536 /* DisallowConditionalTypesContext */ );
                }
                function inDecoratorContext() {
                    return inContext(16384 /* DecoratorContext */ );
                }
                function inAwaitContext() {
                    return inContext(32768 /* AwaitContext */ );
                }
                function parseErrorAtCurrentToken(message, ...args) {
                    return parseErrorAt(scanner2.getTokenStart(), scanner2.getTokenEnd(), message, ...args);
                }
                function parseErrorAtPosition(start, length2, message, ...args) {
                    const lastError = lastOrUndefined(parseDiagnostics);
                    let result;
                    if (!lastError || start !== lastError.start) {
                        result = createDetachedDiagnostic(fileName, start, length2, message, ...args);
                        parseDiagnostics.push(result);
                    }
                    parseErrorBeforeNextFinishedNode = true;
                    return result;
                }
                function parseErrorAt(start, end, message, ...args) {
                    return parseErrorAtPosition(start, end - start, message, ...args);
                }
                function parseErrorAtRange(range, message, ...args) {
                    parseErrorAt(range.pos, range.end, message, ...args);
                }
                function scanError(message, length2, arg0) {
                    parseErrorAtPosition(scanner2.getTokenEnd(), length2, message, arg0);
                }
                function getNodePos() {
                    return scanner2.getTokenFullStart();
                }
                function hasPrecedingJSDocComment() {
                    return scanner2.hasPrecedingJSDocComment();
                }
                function token() {
                    return currentToken;
                }
                function nextTokenWithoutCheck() {
                    return currentToken = scanner2.scan();
                }
                function nextTokenAnd(func) {
                    nextToken();
                    return func();
                }
                function nextToken() {
                    if (isKeyword(currentToken) && (scanner2.hasUnicodeEscape() || scanner2.hasExtendedUnicodeEscape())) parseErrorAt(scanner2.getTokenStart(), scanner2.getTokenEnd(), Diagnostics.Keywords_cannot_contain_escape_characters);
                    return nextTokenWithoutCheck();
                }
                function nextTokenJSDoc() {
                    return currentToken = scanner2.scanJsDocToken();
                }
                function nextJSDocCommentTextToken(inBackticks) {
                    return currentToken = scanner2.scanJSDocCommentTextToken(inBackticks);
                }
                function reScanGreaterToken() {
                    return currentToken = scanner2.reScanGreaterToken();
                }
                function reScanSlashToken() {
                    return currentToken = scanner2.reScanSlashToken();
                }
                function reScanTemplateToken(isTaggedTemplate) {
                    return currentToken = scanner2.reScanTemplateToken(isTaggedTemplate);
                }
                function reScanLessThanToken() {
                    return currentToken = scanner2.reScanLessThanToken();
                }
                function reScanHashToken() {
                    return currentToken = scanner2.reScanHashToken();
                }
                function scanJsxIdentifier() {
                    return currentToken = scanner2.scanJsxIdentifier();
                }
                function scanJsxText() {
                    return currentToken = scanner2.scanJsxToken();
                }
                function scanJsxAttributeValue() {
                    return currentToken = scanner2.scanJsxAttributeValue();
                }
                function speculationHelper(callback, speculationKind) {
                    const saveToken = currentToken;
                    const saveParseDiagnosticsLength = parseDiagnostics.length;
                    const saveParseErrorBeforeNextFinishedNode = parseErrorBeforeNextFinishedNode;
                    const saveContextFlags = contextFlags;
                    const result = speculationKind !== 0 /* TryParse */  ? scanner2.lookAhead(callback) : scanner2.tryScan(callback);
                    Debug.assert(saveContextFlags === contextFlags);
                    if (!result || speculationKind !== 0 /* TryParse */ ) {
                        currentToken = saveToken;
                        if (speculationKind !== 2 /* Reparse */ ) parseDiagnostics.length = saveParseDiagnosticsLength;
                        parseErrorBeforeNextFinishedNode = saveParseErrorBeforeNextFinishedNode;
                    }
                    return result;
                }
                function lookAhead(callback) {
                    return speculationHelper(callback, 1 /* Lookahead */ );
                }
                function tryParse(callback) {
                    return speculationHelper(callback, 0 /* TryParse */ );
                }
                function isBindingIdentifier() {
                    if (token() === 80 /* Identifier */ ) return true;
                    return token() > 118 /* LastReservedWord */ ;
                }
                function isIdentifier2() {
                    if (token() === 80 /* Identifier */ ) return true;
                    if (token() === 127 /* YieldKeyword */  && inYieldContext()) return false;
                    if (token() === 135 /* AwaitKeyword */  && inAwaitContext()) return false;
                    return token() > 118 /* LastReservedWord */ ;
                }
                function parseExpected(kind, diagnosticMessage, shouldAdvance = true) {
                    if (token() === kind) {
                        if (shouldAdvance) nextToken();
                        return true;
                    }
                    if (diagnosticMessage) parseErrorAtCurrentToken(diagnosticMessage);
                    else parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(kind));
                    return false;
                }
                const viableKeywordSuggestions = Object.keys(textToKeywordObj).filter((keyword)=>keyword.length > 2);
                function parseErrorForMissingSemicolonAfter(node) {
                    if (isTaggedTemplateExpression(node)) {
                        parseErrorAt(skipTrivia(sourceText, node.template.pos), node.template.end, Diagnostics.Module_declaration_names_may_only_use_or_quoted_strings);
                        return;
                    }
                    const expressionText = isIdentifier(node) ? idText(node) : void 0;
                    if (!expressionText || !isIdentifierText(expressionText, languageVersion)) {
                        parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(27 /* SemicolonToken */ ));
                        return;
                    }
                    const pos = skipTrivia(sourceText, node.pos);
                    switch(expressionText){
                        case "const":
                        case "let":
                        case "var":
                            parseErrorAt(pos, node.end, Diagnostics.Variable_declaration_not_allowed_at_this_location);
                            return;
                        case "declare":
                            return;
                        case "interface":
                            parseErrorForInvalidName(Diagnostics.Interface_name_cannot_be_0, Diagnostics.Interface_must_be_given_a_name, 19 /* OpenBraceToken */ );
                            return;
                        case "is":
                            parseErrorAt(pos, scanner2.getTokenStart(), Diagnostics.A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods);
                            return;
                        case "module":
                        case "namespace":
                            parseErrorForInvalidName(Diagnostics.Namespace_name_cannot_be_0, Diagnostics.Namespace_must_be_given_a_name, 19 /* OpenBraceToken */ );
                            return;
                        case "type":
                            parseErrorForInvalidName(Diagnostics.Type_alias_name_cannot_be_0, Diagnostics.Type_alias_must_be_given_a_name, 64 /* EqualsToken */ );
                            return;
                    }
                    const suggestion = getSpellingSuggestion(expressionText, viableKeywordSuggestions, (n)=>n) ?? getSpaceSuggestion(expressionText);
                    if (suggestion) {
                        parseErrorAt(pos, node.end, Diagnostics.Unknown_keyword_or_identifier_Did_you_mean_0, suggestion);
                        return;
                    }
                    if (token() === 0 /* Unknown */ ) return;
                    parseErrorAt(pos, node.end, Diagnostics.Unexpected_keyword_or_identifier);
                }
                function parseErrorForInvalidName(nameDiagnostic, blankDiagnostic, tokenIfBlankName) {
                    if (token() === tokenIfBlankName) parseErrorAtCurrentToken(blankDiagnostic);
                    else parseErrorAtCurrentToken(nameDiagnostic, scanner2.getTokenValue());
                }
                function getSpaceSuggestion(expressionText) {
                    for (const keyword of viableKeywordSuggestions){
                        if (expressionText.length > keyword.length + 2 && startsWith(expressionText, keyword)) return `${keyword} ${expressionText.slice(keyword.length)}`;
                    }
                    return void 0;
                }
                function parseSemicolonAfterPropertyName(name, type, initializer) {
                    if (token() === 60 /* AtToken */  && !scanner2.hasPrecedingLineBreak()) {
                        parseErrorAtCurrentToken(Diagnostics.Decorators_must_precede_the_name_and_all_keywords_of_property_declarations);
                        return;
                    }
                    if (token() === 21 /* OpenParenToken */ ) {
                        parseErrorAtCurrentToken(Diagnostics.Cannot_start_a_function_call_in_a_type_annotation);
                        nextToken();
                        return;
                    }
                    if (type && !canParseSemicolon()) {
                        if (initializer) parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(27 /* SemicolonToken */ ));
                        else parseErrorAtCurrentToken(Diagnostics.Expected_for_property_initializer);
                        return;
                    }
                    if (tryParseSemicolon()) return;
                    if (initializer) {
                        parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(27 /* SemicolonToken */ ));
                        return;
                    }
                    parseErrorForMissingSemicolonAfter(name);
                }
                function parseExpectedJSDoc(kind) {
                    if (token() === kind) {
                        nextTokenJSDoc();
                        return true;
                    }
                    Debug.assert(isKeywordOrPunctuation(kind));
                    parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(kind));
                    return false;
                }
                function parseExpectedMatchingBrackets(openKind, closeKind, openParsed, openPosition) {
                    if (token() === closeKind) {
                        nextToken();
                        return;
                    }
                    const lastError = parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(closeKind));
                    if (!openParsed) return;
                    if (lastError) addRelatedInfo(lastError, createDetachedDiagnostic(fileName, openPosition, 1, Diagnostics.The_parser_expected_to_find_a_1_to_match_the_0_token_here, tokenToString(openKind), tokenToString(closeKind)));
                }
                function parseOptional(t) {
                    if (token() === t) {
                        nextToken();
                        return true;
                    }
                    return false;
                }
                function parseOptionalToken(t) {
                    if (token() === t) return parseTokenNode();
                    return void 0;
                }
                function parseOptionalTokenJSDoc(t) {
                    if (token() === t) return parseTokenNodeJSDoc();
                    return void 0;
                }
                function parseExpectedToken(t, diagnosticMessage, arg0) {
                    return parseOptionalToken(t) || createMissingNode(t, /*reportAtCurrentPosition*/ false, diagnosticMessage || Diagnostics._0_expected, arg0 || tokenToString(t));
                }
                function parseExpectedTokenJSDoc(t) {
                    const optional = parseOptionalTokenJSDoc(t);
                    if (optional) return optional;
                    Debug.assert(isKeywordOrPunctuation(t));
                    return createMissingNode(t, /*reportAtCurrentPosition*/ false, Diagnostics._0_expected, tokenToString(t));
                }
                function parseTokenNode() {
                    const pos = getNodePos();
                    const kind = token();
                    nextToken();
                    return finishNode(factoryCreateToken(kind), pos);
                }
                function parseTokenNodeJSDoc() {
                    const pos = getNodePos();
                    const kind = token();
                    nextTokenJSDoc();
                    return finishNode(factoryCreateToken(kind), pos);
                }
                function canParseSemicolon() {
                    if (token() === 27 /* SemicolonToken */ ) return true;
                    return token() === 20 /* CloseBraceToken */  || token() === 1 /* EndOfFileToken */  || scanner2.hasPrecedingLineBreak();
                }
                function tryParseSemicolon() {
                    if (!canParseSemicolon()) return false;
                    if (token() === 27 /* SemicolonToken */ ) nextToken();
                    return true;
                }
                function parseSemicolon() {
                    return tryParseSemicolon() || parseExpected(27 /* SemicolonToken */ );
                }
                function createNodeArray(elements, pos, end, hasTrailingComma) {
                    const array = factoryCreateNodeArray(elements, hasTrailingComma);
                    setTextRangePosEnd(array, pos, end ?? scanner2.getTokenFullStart());
                    return array;
                }
                function finishNode(node, pos, end) {
                    setTextRangePosEnd(node, pos, end ?? scanner2.getTokenFullStart());
                    if (contextFlags) node.flags |= contextFlags;
                    if (parseErrorBeforeNextFinishedNode) {
                        parseErrorBeforeNextFinishedNode = false;
                        node.flags |= 131072 /* ThisNodeHasError */ ;
                    }
                    return node;
                }
                function createMissingNode(kind, reportAtCurrentPosition, diagnosticMessage, ...args) {
                    if (reportAtCurrentPosition) parseErrorAtPosition(scanner2.getTokenFullStart(), 0, diagnosticMessage, ...args);
                    else if (diagnosticMessage) parseErrorAtCurrentToken(diagnosticMessage, ...args);
                    const pos = getNodePos();
                    const result = kind === 80 /* Identifier */  ? factoryCreateIdentifier("", /*originalKeywordKind*/ void 0) : isTemplateLiteralKind(kind) ? factory2.createTemplateLiteralLikeNode(kind, "", "", /*templateFlags*/ void 0) : kind === 9 /* NumericLiteral */  ? factoryCreateNumericLiteral("", /*numericLiteralFlags*/ void 0) : kind === 11 /* StringLiteral */  ? factoryCreateStringLiteral("", /*isSingleQuote*/ void 0) : kind === 281 /* MissingDeclaration */  ? factory2.createMissingDeclaration() : factoryCreateToken(kind);
                    return finishNode(result, pos);
                }
                function internIdentifier(text) {
                    let identifier = identifiers.get(text);
                    if (identifier === void 0) identifiers.set(text, identifier = text);
                    return identifier;
                }
                function createIdentifier(isIdentifier3, diagnosticMessage, privateIdentifierDiagnosticMessage) {
                    if (isIdentifier3) {
                        identifierCount++;
                        const pos = getNodePos();
                        const originalKeywordKind = token();
                        const text = internIdentifier(scanner2.getTokenValue());
                        const hasExtendedUnicodeEscape = scanner2.hasExtendedUnicodeEscape();
                        nextTokenWithoutCheck();
                        return finishNode(factoryCreateIdentifier(text, originalKeywordKind, hasExtendedUnicodeEscape), pos);
                    }
                    if (token() === 81 /* PrivateIdentifier */ ) {
                        parseErrorAtCurrentToken(privateIdentifierDiagnosticMessage || Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
                        return createIdentifier(/*isIdentifier*/ true);
                    }
                    if (token() === 0 /* Unknown */  && scanner2.tryScan(()=>scanner2.reScanInvalidIdentifier() === 80 /* Identifier */ )) return createIdentifier(/*isIdentifier*/ true);
                    identifierCount++;
                    const reportAtCurrentPosition = token() === 1 /* EndOfFileToken */ ;
                    const isReservedWord = scanner2.isReservedWord();
                    const msgArg = scanner2.getTokenText();
                    const defaultMessage = isReservedWord ? Diagnostics.Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here : Diagnostics.Identifier_expected;
                    return createMissingNode(80 /* Identifier */ , reportAtCurrentPosition, diagnosticMessage || defaultMessage, msgArg);
                }
                function parseBindingIdentifier(privateIdentifierDiagnosticMessage) {
                    return createIdentifier(isBindingIdentifier(), /*diagnosticMessage*/ void 0, privateIdentifierDiagnosticMessage);
                }
                function parseIdentifier(diagnosticMessage, privateIdentifierDiagnosticMessage) {
                    return createIdentifier(isIdentifier2(), diagnosticMessage, privateIdentifierDiagnosticMessage);
                }
                function parseIdentifierName(diagnosticMessage) {
                    return createIdentifier(tokenIsIdentifierOrKeyword(token()), diagnosticMessage);
                }
                function isLiteralPropertyName() {
                    return tokenIsIdentifierOrKeyword(token()) || token() === 11 /* StringLiteral */  || token() === 9 /* NumericLiteral */ ;
                }
                function isAssertionKey2() {
                    return tokenIsIdentifierOrKeyword(token()) || token() === 11 /* StringLiteral */ ;
                }
                function parsePropertyNameWorker(allowComputedPropertyNames) {
                    if (token() === 11 /* StringLiteral */  || token() === 9 /* NumericLiteral */ ) {
                        const node = parseLiteralNode();
                        node.text = internIdentifier(node.text);
                        return node;
                    }
                    if (allowComputedPropertyNames && token() === 23 /* OpenBracketToken */ ) return parseComputedPropertyName();
                    if (token() === 81 /* PrivateIdentifier */ ) return parsePrivateIdentifier();
                    return parseIdentifierName();
                }
                function parsePropertyName() {
                    return parsePropertyNameWorker(/*allowComputedPropertyNames*/ true);
                }
                function parseComputedPropertyName() {
                    const pos = getNodePos();
                    parseExpected(23 /* OpenBracketToken */ );
                    const expression = allowInAnd(parseExpression);
                    parseExpected(24 /* CloseBracketToken */ );
                    return finishNode(factory2.createComputedPropertyName(expression), pos);
                }
                function parsePrivateIdentifier() {
                    const pos = getNodePos();
                    const node = factoryCreatePrivateIdentifier(internIdentifier(scanner2.getTokenValue()));
                    nextToken();
                    return finishNode(node, pos);
                }
                function parseContextualModifier(t) {
                    return token() === t && tryParse(nextTokenCanFollowModifier);
                }
                function nextTokenIsOnSameLineAndCanFollowModifier() {
                    nextToken();
                    if (scanner2.hasPrecedingLineBreak()) return false;
                    return canFollowModifier();
                }
                function nextTokenCanFollowModifier() {
                    switch(token()){
                        case 87 /* ConstKeyword */ :
                            return nextToken() === 94 /* EnumKeyword */ ;
                        case 95 /* ExportKeyword */ :
                            nextToken();
                            if (token() === 90 /* DefaultKeyword */ ) return lookAhead(nextTokenCanFollowDefaultKeyword);
                            if (token() === 156 /* TypeKeyword */ ) return lookAhead(nextTokenCanFollowExportModifier);
                            return canFollowExportModifier();
                        case 90 /* DefaultKeyword */ :
                            return nextTokenCanFollowDefaultKeyword();
                        case 126 /* StaticKeyword */ :
                        case 139 /* GetKeyword */ :
                        case 153 /* SetKeyword */ :
                            nextToken();
                            return canFollowModifier();
                        default:
                            return nextTokenIsOnSameLineAndCanFollowModifier();
                    }
                }
                function canFollowExportModifier() {
                    return token() === 60 /* AtToken */  || token() !== 42 /* AsteriskToken */  && token() !== 130 /* AsKeyword */  && token() !== 19 /* OpenBraceToken */  && canFollowModifier();
                }
                function nextTokenCanFollowExportModifier() {
                    nextToken();
                    return canFollowExportModifier();
                }
                function parseAnyContextualModifier() {
                    return isModifierKind(token()) && tryParse(nextTokenCanFollowModifier);
                }
                function canFollowModifier() {
                    return token() === 23 /* OpenBracketToken */  || token() === 19 /* OpenBraceToken */  || token() === 42 /* AsteriskToken */  || token() === 26 /* DotDotDotToken */  || isLiteralPropertyName();
                }
                function nextTokenCanFollowDefaultKeyword() {
                    nextToken();
                    return token() === 86 /* ClassKeyword */  || token() === 100 /* FunctionKeyword */  || token() === 120 /* InterfaceKeyword */  || token() === 60 /* AtToken */  || token() === 128 /* AbstractKeyword */  && lookAhead(nextTokenIsClassKeywordOnSameLine) || token() === 134 /* AsyncKeyword */  && lookAhead(nextTokenIsFunctionKeywordOnSameLine);
                }
                function isListElement2(parsingContext2, inErrorRecovery) {
                    const node = currentNode(parsingContext2);
                    if (node) return true;
                    switch(parsingContext2){
                        case 0 /* SourceElements */ :
                        case 1 /* BlockStatements */ :
                        case 3 /* SwitchClauseStatements */ :
                            return !(token() === 27 /* SemicolonToken */  && inErrorRecovery) && isStartOfStatement();
                        case 2 /* SwitchClauses */ :
                            return token() === 84 /* CaseKeyword */  || token() === 90 /* DefaultKeyword */ ;
                        case 4 /* TypeMembers */ :
                            return lookAhead(isTypeMemberStart);
                        case 5 /* ClassMembers */ :
                            return lookAhead(isClassMemberStart) || token() === 27 /* SemicolonToken */  && !inErrorRecovery;
                        case 6 /* EnumMembers */ :
                            return token() === 23 /* OpenBracketToken */  || isLiteralPropertyName();
                        case 12 /* ObjectLiteralMembers */ :
                            switch(token()){
                                case 23 /* OpenBracketToken */ :
                                case 42 /* AsteriskToken */ :
                                case 26 /* DotDotDotToken */ :
                                case 25 /* DotToken */ :
                                    return true;
                                default:
                                    return isLiteralPropertyName();
                            }
                        case 18 /* RestProperties */ :
                            return isLiteralPropertyName();
                        case 9 /* ObjectBindingElements */ :
                            return token() === 23 /* OpenBracketToken */  || token() === 26 /* DotDotDotToken */  || isLiteralPropertyName();
                        case 24 /* AssertEntries */ :
                            return isAssertionKey2();
                        case 7 /* HeritageClauseElement */ :
                            if (token() === 19 /* OpenBraceToken */ ) return lookAhead(isValidHeritageClauseObjectLiteral);
                            if (!inErrorRecovery) return isStartOfLeftHandSideExpression() && !isHeritageClauseExtendsOrImplementsKeyword();
                            else return isIdentifier2() && !isHeritageClauseExtendsOrImplementsKeyword();
                        case 8 /* VariableDeclarations */ :
                            return isBindingIdentifierOrPrivateIdentifierOrPattern();
                        case 10 /* ArrayBindingElements */ :
                            return token() === 28 /* CommaToken */  || token() === 26 /* DotDotDotToken */  || isBindingIdentifierOrPrivateIdentifierOrPattern();
                        case 19 /* TypeParameters */ :
                            return token() === 103 /* InKeyword */  || token() === 87 /* ConstKeyword */  || isIdentifier2();
                        case 15 /* ArrayLiteralMembers */ :
                            switch(token()){
                                case 28 /* CommaToken */ :
                                case 25 /* DotToken */ :
                                    return true;
                            }
                        case 11 /* ArgumentExpressions */ :
                            return token() === 26 /* DotDotDotToken */  || isStartOfExpression();
                        case 16 /* Parameters */ :
                            return isStartOfParameter(/*isJSDocParameter*/ false);
                        case 17 /* JSDocParameters */ :
                            return isStartOfParameter(/*isJSDocParameter*/ true);
                        case 20 /* TypeArguments */ :
                        case 21 /* TupleElementTypes */ :
                            return token() === 28 /* CommaToken */  || isStartOfType();
                        case 22 /* HeritageClauses */ :
                            return isHeritageClause2();
                        case 23 /* ImportOrExportSpecifiers */ :
                            return tokenIsIdentifierOrKeyword(token());
                        case 13 /* JsxAttributes */ :
                            return tokenIsIdentifierOrKeyword(token()) || token() === 19 /* OpenBraceToken */ ;
                        case 14 /* JsxChildren */ :
                            return true;
                        case 25 /* JSDocComment */ :
                            return true;
                        case 26 /* Count */ :
                            return Debug.fail("ParsingContext.Count used as a context");
                        default:
                            Debug.assertNever(parsingContext2, "Non-exhaustive case in 'isListElement'.");
                    }
                }
                function isValidHeritageClauseObjectLiteral() {
                    Debug.assert(token() === 19 /* OpenBraceToken */ );
                    if (nextToken() === 20 /* CloseBraceToken */ ) {
                        const next = nextToken();
                        return next === 28 /* CommaToken */  || next === 19 /* OpenBraceToken */  || next === 96 /* ExtendsKeyword */  || next === 119 /* ImplementsKeyword */ ;
                    }
                    return true;
                }
                function nextTokenIsIdentifier() {
                    nextToken();
                    return isIdentifier2();
                }
                function nextTokenIsIdentifierOrKeyword() {
                    nextToken();
                    return tokenIsIdentifierOrKeyword(token());
                }
                function nextTokenIsIdentifierOrKeywordOrGreaterThan() {
                    nextToken();
                    return tokenIsIdentifierOrKeywordOrGreaterThan(token());
                }
                function isHeritageClauseExtendsOrImplementsKeyword() {
                    if (token() === 119 /* ImplementsKeyword */  || token() === 96 /* ExtendsKeyword */ ) return lookAhead(nextTokenIsStartOfExpression);
                    return false;
                }
                function nextTokenIsStartOfExpression() {
                    nextToken();
                    return isStartOfExpression();
                }
                function nextTokenIsStartOfType() {
                    nextToken();
                    return isStartOfType();
                }
                function isListTerminator(kind) {
                    if (token() === 1 /* EndOfFileToken */ ) return true;
                    switch(kind){
                        case 1 /* BlockStatements */ :
                        case 2 /* SwitchClauses */ :
                        case 4 /* TypeMembers */ :
                        case 5 /* ClassMembers */ :
                        case 6 /* EnumMembers */ :
                        case 12 /* ObjectLiteralMembers */ :
                        case 9 /* ObjectBindingElements */ :
                        case 23 /* ImportOrExportSpecifiers */ :
                        case 24 /* AssertEntries */ :
                            return token() === 20 /* CloseBraceToken */ ;
                        case 3 /* SwitchClauseStatements */ :
                            return token() === 20 /* CloseBraceToken */  || token() === 84 /* CaseKeyword */  || token() === 90 /* DefaultKeyword */ ;
                        case 7 /* HeritageClauseElement */ :
                            return token() === 19 /* OpenBraceToken */  || token() === 96 /* ExtendsKeyword */  || token() === 119 /* ImplementsKeyword */ ;
                        case 8 /* VariableDeclarations */ :
                            return isVariableDeclaratorListTerminator();
                        case 19 /* TypeParameters */ :
                            return token() === 32 /* GreaterThanToken */  || token() === 21 /* OpenParenToken */  || token() === 19 /* OpenBraceToken */  || token() === 96 /* ExtendsKeyword */  || token() === 119 /* ImplementsKeyword */ ;
                        case 11 /* ArgumentExpressions */ :
                            return token() === 22 /* CloseParenToken */  || token() === 27 /* SemicolonToken */ ;
                        case 15 /* ArrayLiteralMembers */ :
                        case 21 /* TupleElementTypes */ :
                        case 10 /* ArrayBindingElements */ :
                            return token() === 24 /* CloseBracketToken */ ;
                        case 17 /* JSDocParameters */ :
                        case 16 /* Parameters */ :
                        case 18 /* RestProperties */ :
                            return token() === 22 /* CloseParenToken */  || token() === 24 /* CloseBracketToken */ ;
                        case 20 /* TypeArguments */ :
                            return token() !== 28 /* CommaToken */ ;
                        case 22 /* HeritageClauses */ :
                            return token() === 19 /* OpenBraceToken */  || token() === 20 /* CloseBraceToken */ ;
                        case 13 /* JsxAttributes */ :
                            return token() === 32 /* GreaterThanToken */  || token() === 44 /* SlashToken */ ;
                        case 14 /* JsxChildren */ :
                            return token() === 30 /* LessThanToken */  && lookAhead(nextTokenIsSlash);
                        default:
                            return false;
                    }
                }
                function isVariableDeclaratorListTerminator() {
                    if (canParseSemicolon()) return true;
                    if (isInOrOfKeyword(token())) return true;
                    if (token() === 39 /* EqualsGreaterThanToken */ ) return true;
                    return false;
                }
                function isInSomeParsingContext() {
                    Debug.assert(parsingContext, "Missing parsing context");
                    for(let kind = 0; kind < 26 /* Count */ ; kind++)if (parsingContext & 1 << kind) {
                        if (isListElement2(kind, /*inErrorRecovery*/ true) || isListTerminator(kind)) return true;
                    }
                    return false;
                }
                function parseList(kind, parseElement) {
                    const saveParsingContext = parsingContext;
                    parsingContext |= 1 << kind;
                    const list = [];
                    const listPos = getNodePos();
                    while(!isListTerminator(kind)){
                        if (isListElement2(kind, /*inErrorRecovery*/ false)) {
                            list.push(parseListElement(kind, parseElement));
                            continue;
                        }
                        if (abortParsingListOrMoveToNextToken(kind)) break;
                    }
                    parsingContext = saveParsingContext;
                    return createNodeArray(list, listPos);
                }
                function parseListElement(parsingContext2, parseElement) {
                    const node = currentNode(parsingContext2);
                    if (node) return consumeNode(node);
                    return parseElement();
                }
                function currentNode(parsingContext2, pos) {
                    var _a;
                    if (!syntaxCursor || !isReusableParsingContext(parsingContext2) || parseErrorBeforeNextFinishedNode) return void 0;
                    const node = syntaxCursor.currentNode(pos ?? scanner2.getTokenFullStart());
                    if (nodeIsMissing(node) || node.intersectsChange || containsParseError(node)) return void 0;
                    const nodeContextFlags = node.flags & 50720768 /* ContextFlags */ ;
                    if (nodeContextFlags !== contextFlags) return void 0;
                    if (!canReuseNode(node, parsingContext2)) return void 0;
                    if (canHaveJSDoc(node) && ((_a = node.jsDoc) == null ? void 0 : _a.jsDocCache)) node.jsDoc.jsDocCache = void 0;
                    return node;
                }
                function consumeNode(node) {
                    scanner2.resetTokenState(node.end);
                    nextToken();
                    return node;
                }
                function isReusableParsingContext(parsingContext2) {
                    switch(parsingContext2){
                        case 5 /* ClassMembers */ :
                        case 2 /* SwitchClauses */ :
                        case 0 /* SourceElements */ :
                        case 1 /* BlockStatements */ :
                        case 3 /* SwitchClauseStatements */ :
                        case 6 /* EnumMembers */ :
                        case 4 /* TypeMembers */ :
                        case 8 /* VariableDeclarations */ :
                        case 17 /* JSDocParameters */ :
                        case 16 /* Parameters */ :
                            return true;
                    }
                    return false;
                }
                function canReuseNode(node, parsingContext2) {
                    switch(parsingContext2){
                        case 5 /* ClassMembers */ :
                            return isReusableClassMember(node);
                        case 2 /* SwitchClauses */ :
                            return isReusableSwitchClause(node);
                        case 0 /* SourceElements */ :
                        case 1 /* BlockStatements */ :
                        case 3 /* SwitchClauseStatements */ :
                            return isReusableStatement(node);
                        case 6 /* EnumMembers */ :
                            return isReusableEnumMember(node);
                        case 4 /* TypeMembers */ :
                            return isReusableTypeMember(node);
                        case 8 /* VariableDeclarations */ :
                            return isReusableVariableDeclaration(node);
                        case 17 /* JSDocParameters */ :
                        case 16 /* Parameters */ :
                            return isReusableParameter(node);
                    }
                    return false;
                }
                function isReusableClassMember(node) {
                    if (node) switch(node.kind){
                        case 175 /* Constructor */ :
                        case 180 /* IndexSignature */ :
                        case 176 /* GetAccessor */ :
                        case 177 /* SetAccessor */ :
                        case 171 /* PropertyDeclaration */ :
                        case 239 /* SemicolonClassElement */ :
                            return true;
                        case 173 /* MethodDeclaration */ :
                            const methodDeclaration = node;
                            const nameIsConstructor = methodDeclaration.name.kind === 80 /* Identifier */  && methodDeclaration.name.escapedText === "constructor";
                            return !nameIsConstructor;
                    }
                    return false;
                }
                function isReusableSwitchClause(node) {
                    if (node) switch(node.kind){
                        case 295 /* CaseClause */ :
                        case 296 /* DefaultClause */ :
                            return true;
                    }
                    return false;
                }
                function isReusableStatement(node) {
                    if (node) switch(node.kind){
                        case 261 /* FunctionDeclaration */ :
                        case 242 /* VariableStatement */ :
                        case 240 /* Block */ :
                        case 244 /* IfStatement */ :
                        case 243 /* ExpressionStatement */ :
                        case 256 /* ThrowStatement */ :
                        case 252 /* ReturnStatement */ :
                        case 254 /* SwitchStatement */ :
                        case 251 /* BreakStatement */ :
                        case 250 /* ContinueStatement */ :
                        case 248 /* ForInStatement */ :
                        case 249 /* ForOfStatement */ :
                        case 247 /* ForStatement */ :
                        case 246 /* WhileStatement */ :
                        case 253 /* WithStatement */ :
                        case 241 /* EmptyStatement */ :
                        case 257 /* TryStatement */ :
                        case 255 /* LabeledStatement */ :
                        case 245 /* DoStatement */ :
                        case 258 /* DebuggerStatement */ :
                        case 271 /* ImportDeclaration */ :
                        case 270 /* ImportEqualsDeclaration */ :
                        case 277 /* ExportDeclaration */ :
                        case 276 /* ExportAssignment */ :
                        case 266 /* ModuleDeclaration */ :
                        case 262 /* ClassDeclaration */ :
                        case 263 /* InterfaceDeclaration */ :
                        case 265 /* EnumDeclaration */ :
                        case 264 /* TypeAliasDeclaration */ :
                            return true;
                    }
                    return false;
                }
                function isReusableEnumMember(node) {
                    return node.kind === 305 /* EnumMember */ ;
                }
                function isReusableTypeMember(node) {
                    if (node) switch(node.kind){
                        case 179 /* ConstructSignature */ :
                        case 172 /* MethodSignature */ :
                        case 180 /* IndexSignature */ :
                        case 170 /* PropertySignature */ :
                        case 178 /* CallSignature */ :
                            return true;
                    }
                    return false;
                }
                function isReusableVariableDeclaration(node) {
                    if (node.kind !== 259 /* VariableDeclaration */ ) return false;
                    const variableDeclarator = node;
                    return variableDeclarator.initializer === void 0;
                }
                function isReusableParameter(node) {
                    if (node.kind !== 168 /* Parameter */ ) return false;
                    const parameter = node;
                    return parameter.initializer === void 0;
                }
                function abortParsingListOrMoveToNextToken(kind) {
                    parsingContextErrors(kind);
                    if (isInSomeParsingContext()) return true;
                    nextToken();
                    return false;
                }
                function parsingContextErrors(context) {
                    switch(context){
                        case 0 /* SourceElements */ :
                            return token() === 90 /* DefaultKeyword */  ? parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(95 /* ExportKeyword */ )) : parseErrorAtCurrentToken(Diagnostics.Declaration_or_statement_expected);
                        case 1 /* BlockStatements */ :
                            return parseErrorAtCurrentToken(Diagnostics.Declaration_or_statement_expected);
                        case 2 /* SwitchClauses */ :
                            return parseErrorAtCurrentToken(Diagnostics.case_or_default_expected);
                        case 3 /* SwitchClauseStatements */ :
                            return parseErrorAtCurrentToken(Diagnostics.Statement_expected);
                        case 18 /* RestProperties */ :
                        case 4 /* TypeMembers */ :
                            return parseErrorAtCurrentToken(Diagnostics.Property_or_signature_expected);
                        case 5 /* ClassMembers */ :
                            return parseErrorAtCurrentToken(Diagnostics.Unexpected_token_A_constructor_method_accessor_or_property_was_expected);
                        case 6 /* EnumMembers */ :
                            return parseErrorAtCurrentToken(Diagnostics.Enum_member_expected);
                        case 7 /* HeritageClauseElement */ :
                            return parseErrorAtCurrentToken(Diagnostics.Expression_expected);
                        case 8 /* VariableDeclarations */ :
                            return isKeyword(token()) ? parseErrorAtCurrentToken(Diagnostics._0_is_not_allowed_as_a_variable_declaration_name, tokenToString(token())) : parseErrorAtCurrentToken(Diagnostics.Variable_declaration_expected);
                        case 9 /* ObjectBindingElements */ :
                            return parseErrorAtCurrentToken(Diagnostics.Property_destructuring_pattern_expected);
                        case 10 /* ArrayBindingElements */ :
                            return parseErrorAtCurrentToken(Diagnostics.Array_element_destructuring_pattern_expected);
                        case 11 /* ArgumentExpressions */ :
                            return parseErrorAtCurrentToken(Diagnostics.Argument_expression_expected);
                        case 12 /* ObjectLiteralMembers */ :
                            return parseErrorAtCurrentToken(Diagnostics.Property_assignment_expected);
                        case 15 /* ArrayLiteralMembers */ :
                            return parseErrorAtCurrentToken(Diagnostics.Expression_or_comma_expected);
                        case 17 /* JSDocParameters */ :
                            return parseErrorAtCurrentToken(Diagnostics.Parameter_declaration_expected);
                        case 16 /* Parameters */ :
                            return isKeyword(token()) ? parseErrorAtCurrentToken(Diagnostics._0_is_not_allowed_as_a_parameter_name, tokenToString(token())) : parseErrorAtCurrentToken(Diagnostics.Parameter_declaration_expected);
                        case 19 /* TypeParameters */ :
                            return parseErrorAtCurrentToken(Diagnostics.Type_parameter_declaration_expected);
                        case 20 /* TypeArguments */ :
                            return parseErrorAtCurrentToken(Diagnostics.Type_argument_expected);
                        case 21 /* TupleElementTypes */ :
                            return parseErrorAtCurrentToken(Diagnostics.Type_expected);
                        case 22 /* HeritageClauses */ :
                            return parseErrorAtCurrentToken(Diagnostics.Unexpected_token_expected);
                        case 23 /* ImportOrExportSpecifiers */ :
                            return parseErrorAtCurrentToken(Diagnostics.Identifier_expected);
                        case 13 /* JsxAttributes */ :
                            return parseErrorAtCurrentToken(Diagnostics.Identifier_expected);
                        case 14 /* JsxChildren */ :
                            return parseErrorAtCurrentToken(Diagnostics.Identifier_expected);
                        case 24 /* AssertEntries */ :
                            return parseErrorAtCurrentToken(Diagnostics.Identifier_or_string_literal_expected);
                        case 25 /* JSDocComment */ :
                            return parseErrorAtCurrentToken(Diagnostics.Identifier_expected);
                        case 26 /* Count */ :
                            return Debug.fail("ParsingContext.Count used as a context");
                        default:
                            Debug.assertNever(context);
                    }
                }
                function parseDelimitedList(kind, parseElement, considerSemicolonAsDelimiter) {
                    const saveParsingContext = parsingContext;
                    parsingContext |= 1 << kind;
                    const list = [];
                    const listPos = getNodePos();
                    let commaStart = -1;
                    while(true){
                        if (isListElement2(kind, /*inErrorRecovery*/ false)) {
                            const startPos = scanner2.getTokenFullStart();
                            const result = parseListElement(kind, parseElement);
                            if (!result) {
                                parsingContext = saveParsingContext;
                                return void 0;
                            }
                            list.push(result);
                            commaStart = scanner2.getTokenStart();
                            if (parseOptional(28 /* CommaToken */ )) continue;
                            commaStart = -1;
                            if (isListTerminator(kind)) break;
                            parseExpected(28 /* CommaToken */ , getExpectedCommaDiagnostic(kind));
                            if (considerSemicolonAsDelimiter && token() === 27 /* SemicolonToken */  && !scanner2.hasPrecedingLineBreak()) nextToken();
                            if (startPos === scanner2.getTokenFullStart()) nextToken();
                            continue;
                        }
                        if (isListTerminator(kind)) break;
                        if (abortParsingListOrMoveToNextToken(kind)) break;
                    }
                    parsingContext = saveParsingContext;
                    return createNodeArray(list, listPos, /*end*/ void 0, commaStart >= 0);
                }
                function getExpectedCommaDiagnostic(kind) {
                    return kind === 6 /* EnumMembers */  ? Diagnostics.An_enum_member_name_must_be_followed_by_a_or : void 0;
                }
                function createMissingList() {
                    const list = createNodeArray([], getNodePos());
                    list.isMissingList = true;
                    return list;
                }
                function isMissingList(arr) {
                    return !!arr.isMissingList;
                }
                function parseBracketedList(kind, parseElement, open, close) {
                    if (parseExpected(open)) {
                        const result = parseDelimitedList(kind, parseElement);
                        parseExpected(close);
                        return result;
                    }
                    return createMissingList();
                }
                function parseEntityName(allowReservedWords, diagnosticMessage) {
                    const pos = getNodePos();
                    let entity = allowReservedWords ? parseIdentifierName(diagnosticMessage) : parseIdentifier(diagnosticMessage);
                    while(parseOptional(25 /* DotToken */ )){
                        if (token() === 30 /* LessThanToken */ ) break;
                        entity = finishNode(factory2.createQualifiedName(entity, parseRightSideOfDot(allowReservedWords, /*allowPrivateIdentifiers*/ false)), pos);
                    }
                    return entity;
                }
                function createQualifiedName(entity, name) {
                    return finishNode(factory2.createQualifiedName(entity, name), entity.pos);
                }
                function parseRightSideOfDot(allowIdentifierNames, allowPrivateIdentifiers) {
                    if (scanner2.hasPrecedingLineBreak() && tokenIsIdentifierOrKeyword(token())) {
                        const matchesPattern = lookAhead(nextTokenIsIdentifierOrKeywordOnSameLine);
                        if (matchesPattern) return createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ true, Diagnostics.Identifier_expected);
                    }
                    if (token() === 81 /* PrivateIdentifier */ ) {
                        const node = parsePrivateIdentifier();
                        return allowPrivateIdentifiers ? node : createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ true, Diagnostics.Identifier_expected);
                    }
                    return allowIdentifierNames ? parseIdentifierName() : parseIdentifier();
                }
                function parseTemplateSpans(isTaggedTemplate) {
                    const pos = getNodePos();
                    const list = [];
                    let node;
                    do {
                        node = parseTemplateSpan(isTaggedTemplate);
                        list.push(node);
                    }while (node.literal.kind === 17 /* TemplateMiddle */ );
                    return createNodeArray(list, pos);
                }
                function parseTemplateExpression(isTaggedTemplate) {
                    const pos = getNodePos();
                    return finishNode(factory2.createTemplateExpression(parseTemplateHead(isTaggedTemplate), parseTemplateSpans(isTaggedTemplate)), pos);
                }
                function parseTemplateType() {
                    const pos = getNodePos();
                    return finishNode(factory2.createTemplateLiteralType(parseTemplateHead(/*isTaggedTemplate*/ false), parseTemplateTypeSpans()), pos);
                }
                function parseTemplateTypeSpans() {
                    const pos = getNodePos();
                    const list = [];
                    let node;
                    do {
                        node = parseTemplateTypeSpan();
                        list.push(node);
                    }while (node.literal.kind === 17 /* TemplateMiddle */ );
                    return createNodeArray(list, pos);
                }
                function parseTemplateTypeSpan() {
                    const pos = getNodePos();
                    return finishNode(factory2.createTemplateLiteralTypeSpan(parseType(), parseLiteralOfTemplateSpan(/*isTaggedTemplate*/ false)), pos);
                }
                function parseLiteralOfTemplateSpan(isTaggedTemplate) {
                    if (token() === 20 /* CloseBraceToken */ ) {
                        reScanTemplateToken(isTaggedTemplate);
                        return parseTemplateMiddleOrTemplateTail();
                    } else return parseExpectedToken(18 /* TemplateTail */ , Diagnostics._0_expected, tokenToString(20 /* CloseBraceToken */ ));
                }
                function parseTemplateSpan(isTaggedTemplate) {
                    const pos = getNodePos();
                    return finishNode(factory2.createTemplateSpan(allowInAnd(parseExpression), parseLiteralOfTemplateSpan(isTaggedTemplate)), pos);
                }
                function parseLiteralNode() {
                    return parseLiteralLikeNode(token());
                }
                function parseTemplateHead(isTaggedTemplate) {
                    if (!isTaggedTemplate && scanner2.getTokenFlags() & 26656 /* IsInvalid */ ) reScanTemplateToken(/*isTaggedTemplate*/ false);
                    const fragment = parseLiteralLikeNode(token());
                    Debug.assert(fragment.kind === 16 /* TemplateHead */ , "Template head has wrong token kind");
                    return fragment;
                }
                function parseTemplateMiddleOrTemplateTail() {
                    const fragment = parseLiteralLikeNode(token());
                    Debug.assert(fragment.kind === 17 /* TemplateMiddle */  || fragment.kind === 18 /* TemplateTail */ , "Template fragment has wrong token kind");
                    return fragment;
                }
                function getTemplateLiteralRawText(kind) {
                    const isLast = kind === 15 /* NoSubstitutionTemplateLiteral */  || kind === 18 /* TemplateTail */ ;
                    const tokenText = scanner2.getTokenText();
                    return tokenText.substring(1, tokenText.length - (scanner2.isUnterminated() ? 0 : isLast ? 1 : 2));
                }
                function parseLiteralLikeNode(kind) {
                    const pos = getNodePos();
                    const node = isTemplateLiteralKind(kind) ? factory2.createTemplateLiteralLikeNode(kind, scanner2.getTokenValue(), getTemplateLiteralRawText(kind), scanner2.getTokenFlags() & 7176 /* TemplateLiteralLikeFlags */ ) : // Note that theoretically the following condition would hold true literals like 009,
                    // which is not octal. But because of how the scanner separates the tokens, we would
                    // never get a token like this. Instead, we would get 00 and 9 as two separate tokens.
                    // We also do not need to check for negatives because any prefix operator would be part of a
                    // parent unary expression.
                    kind === 9 /* NumericLiteral */  ? factoryCreateNumericLiteral(scanner2.getTokenValue(), scanner2.getNumericLiteralFlags()) : kind === 11 /* StringLiteral */  ? factoryCreateStringLiteral(scanner2.getTokenValue(), /*isSingleQuote*/ void 0, scanner2.hasExtendedUnicodeEscape()) : isLiteralKind(kind) ? factoryCreateLiteralLikeNode(kind, scanner2.getTokenValue()) : Debug.fail();
                    if (scanner2.hasExtendedUnicodeEscape()) node.hasExtendedUnicodeEscape = true;
                    if (scanner2.isUnterminated()) node.isUnterminated = true;
                    nextToken();
                    return finishNode(node, pos);
                }
                function parseEntityNameOfTypeReference() {
                    return parseEntityName(/*allowReservedWords*/ true, Diagnostics.Type_expected);
                }
                function parseTypeArgumentsOfTypeReference() {
                    if (!scanner2.hasPrecedingLineBreak() && reScanLessThanToken() === 30 /* LessThanToken */ ) return parseBracketedList(20 /* TypeArguments */ , parseType, 30 /* LessThanToken */ , 32 /* GreaterThanToken */ );
                }
                function parseTypeReference() {
                    const pos = getNodePos();
                    return finishNode(factory2.createTypeReferenceNode(parseEntityNameOfTypeReference(), parseTypeArgumentsOfTypeReference()), pos);
                }
                function typeHasArrowFunctionBlockingParseError(node) {
                    switch(node.kind){
                        case 182 /* TypeReference */ :
                            return nodeIsMissing(node.typeName);
                        case 183 /* FunctionType */ :
                        case 184 /* ConstructorType */ :
                            {
                                const { parameters: parameters , type: type  } = node;
                                return isMissingList(parameters) || typeHasArrowFunctionBlockingParseError(type);
                            }
                        case 195 /* ParenthesizedType */ :
                            return typeHasArrowFunctionBlockingParseError(node.type);
                        default:
                            return false;
                    }
                }
                function parseThisTypePredicate(lhs) {
                    nextToken();
                    return finishNode(factory2.createTypePredicateNode(/*assertsModifier*/ void 0, lhs, parseType()), lhs.pos);
                }
                function parseThisTypeNode() {
                    const pos = getNodePos();
                    nextToken();
                    return finishNode(factory2.createThisTypeNode(), pos);
                }
                function parseJSDocAllType() {
                    const pos = getNodePos();
                    nextToken();
                    return finishNode(factory2.createJSDocAllType(), pos);
                }
                function parseJSDocNonNullableType() {
                    const pos = getNodePos();
                    nextToken();
                    return finishNode(factory2.createJSDocNonNullableType(parseNonArrayType(), /*postfix*/ false), pos);
                }
                function parseJSDocUnknownOrNullableType() {
                    const pos = getNodePos();
                    nextToken();
                    if (token() === 28 /* CommaToken */  || token() === 20 /* CloseBraceToken */  || token() === 22 /* CloseParenToken */  || token() === 32 /* GreaterThanToken */  || token() === 64 /* EqualsToken */  || token() === 52 /* BarToken */ ) return finishNode(factory2.createJSDocUnknownType(), pos);
                    else return finishNode(factory2.createJSDocNullableType(parseType(), /*postfix*/ false), pos);
                }
                function parseJSDocFunctionType() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    if (lookAhead(nextTokenIsOpenParen)) {
                        nextToken();
                        const parameters = parseParameters(36 /* JSDoc */ );
                        const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
                        return withJSDoc(finishNode(factory2.createJSDocFunctionType(parameters, type), pos), hasJSDoc);
                    }
                    return finishNode(factory2.createTypeReferenceNode(parseIdentifierName(), /*typeArguments*/ void 0), pos);
                }
                function parseJSDocParameter() {
                    const pos = getNodePos();
                    let name;
                    if (token() === 110 /* ThisKeyword */  || token() === 105 /* NewKeyword */ ) {
                        name = parseIdentifierName();
                        parseExpected(59 /* ColonToken */ );
                    }
                    return finishNode(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, // TODO(rbuckton): JSDoc parameters don't have names (except `this`/`new`), should we manufacture an empty identifier?
                    name, /*questionToken*/ void 0, parseJSDocType(), /*initializer*/ void 0), pos);
                }
                function parseJSDocType() {
                    scanner2.setInJSDocType(true);
                    const pos = getNodePos();
                    if (parseOptional(144 /* ModuleKeyword */ )) {
                        const moduleTag = factory2.createJSDocNamepathType(/*type*/ void 0);
                        terminate: while(true)switch(token()){
                            case 20 /* CloseBraceToken */ :
                            case 1 /* EndOfFileToken */ :
                            case 28 /* CommaToken */ :
                            case 5 /* WhitespaceTrivia */ :
                                break terminate;
                            default:
                                nextTokenJSDoc();
                        }
                        scanner2.setInJSDocType(false);
                        return finishNode(moduleTag, pos);
                    }
                    const hasDotDotDot = parseOptional(26 /* DotDotDotToken */ );
                    let type = parseTypeOrTypePredicate();
                    scanner2.setInJSDocType(false);
                    if (hasDotDotDot) type = finishNode(factory2.createJSDocVariadicType(type), pos);
                    if (token() === 64 /* EqualsToken */ ) {
                        nextToken();
                        return finishNode(factory2.createJSDocOptionalType(type), pos);
                    }
                    return type;
                }
                function parseTypeQuery() {
                    const pos = getNodePos();
                    parseExpected(114 /* TypeOfKeyword */ );
                    const entityName = parseEntityName(/*allowReservedWords*/ true);
                    const typeArguments = !scanner2.hasPrecedingLineBreak() ? tryParseTypeArguments() : void 0;
                    return finishNode(factory2.createTypeQueryNode(entityName, typeArguments), pos);
                }
                function parseTypeParameter() {
                    const pos = getNodePos();
                    const modifiers = parseModifiers(/*allowDecorators*/ false, /*permitConstAsModifier*/ true);
                    const name = parseIdentifier();
                    let constraint;
                    let expression;
                    if (parseOptional(96 /* ExtendsKeyword */ )) {
                        if (isStartOfType() || !isStartOfExpression()) constraint = parseType();
                        else expression = parseUnaryExpressionOrHigher();
                    }
                    const defaultType = parseOptional(64 /* EqualsToken */ ) ? parseType() : void 0;
                    const node = factory2.createTypeParameterDeclaration(modifiers, name, constraint, defaultType);
                    node.expression = expression;
                    return finishNode(node, pos);
                }
                function parseTypeParameters() {
                    if (token() === 30 /* LessThanToken */ ) return parseBracketedList(19 /* TypeParameters */ , parseTypeParameter, 30 /* LessThanToken */ , 32 /* GreaterThanToken */ );
                }
                function isStartOfParameter(isJSDocParameter) {
                    return token() === 26 /* DotDotDotToken */  || isBindingIdentifierOrPrivateIdentifierOrPattern() || isModifierKind(token()) || token() === 60 /* AtToken */  || isStartOfType(/*inStartOfParameter*/ !isJSDocParameter);
                }
                function parseNameOfParameter(modifiers) {
                    const name = parseIdentifierOrPattern(Diagnostics.Private_identifiers_cannot_be_used_as_parameters);
                    if (getFullWidth(name) === 0 && !some(modifiers) && isModifierKind(token())) nextToken();
                    return name;
                }
                function isParameterNameStart() {
                    return isBindingIdentifier() || token() === 23 /* OpenBracketToken */  || token() === 19 /* OpenBraceToken */ ;
                }
                function parseParameter(inOuterAwaitContext) {
                    return parseParameterWorker(inOuterAwaitContext);
                }
                function parseParameterForSpeculation(inOuterAwaitContext) {
                    return parseParameterWorker(inOuterAwaitContext, /*allowAmbiguity*/ false);
                }
                function parseParameterWorker(inOuterAwaitContext, allowAmbiguity = true) {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    const modifiers = inOuterAwaitContext ? doInAwaitContext(()=>parseModifiers(/*allowDecorators*/ true)) : doOutsideOfAwaitContext(()=>parseModifiers(/*allowDecorators*/ true));
                    if (token() === 110 /* ThisKeyword */ ) {
                        const node2 = factory2.createParameterDeclaration(modifiers, /*dotDotDotToken*/ void 0, createIdentifier(/*isIdentifier*/ true), /*questionToken*/ void 0, parseTypeAnnotation(), /*initializer*/ void 0);
                        const modifier = firstOrUndefined(modifiers);
                        if (modifier) parseErrorAtRange(modifier, Diagnostics.Neither_decorators_nor_modifiers_may_be_applied_to_this_parameters);
                        return withJSDoc(finishNode(node2, pos), hasJSDoc);
                    }
                    const savedTopLevel = topLevel;
                    topLevel = false;
                    const dotDotDotToken = parseOptionalToken(26 /* DotDotDotToken */ );
                    if (!allowAmbiguity && !isParameterNameStart()) return void 0;
                    const node = withJSDoc(finishNode(factory2.createParameterDeclaration(modifiers, dotDotDotToken, parseNameOfParameter(modifiers), parseOptionalToken(58 /* QuestionToken */ ), parseTypeAnnotation(), parseInitializer()), pos), hasJSDoc);
                    topLevel = savedTopLevel;
                    return node;
                }
                function parseReturnType(returnToken, isType) {
                    if (shouldParseReturnType(returnToken, isType)) return allowConditionalTypesAnd(parseTypeOrTypePredicate);
                }
                function shouldParseReturnType(returnToken, isType) {
                    if (returnToken === 39 /* EqualsGreaterThanToken */ ) {
                        parseExpected(returnToken);
                        return true;
                    } else if (parseOptional(59 /* ColonToken */ )) return true;
                    else if (isType && token() === 39 /* EqualsGreaterThanToken */ ) {
                        parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(59 /* ColonToken */ ));
                        nextToken();
                        return true;
                    }
                    return false;
                }
                function parseParametersWorker(flags, allowAmbiguity) {
                    const savedYieldContext = inYieldContext();
                    const savedAwaitContext = inAwaitContext();
                    setYieldContext(!!(flags & 1 /* Yield */ ));
                    setAwaitContext(!!(flags & 2 /* Await */ ));
                    const parameters = flags & 32 /* JSDoc */  ? parseDelimitedList(17 /* JSDocParameters */ , parseJSDocParameter) : parseDelimitedList(16 /* Parameters */ , ()=>allowAmbiguity ? parseParameter(savedAwaitContext) : parseParameterForSpeculation(savedAwaitContext));
                    setYieldContext(savedYieldContext);
                    setAwaitContext(savedAwaitContext);
                    return parameters;
                }
                function parseParameters(flags) {
                    if (!parseExpected(21 /* OpenParenToken */ )) return createMissingList();
                    const parameters = parseParametersWorker(flags, /*allowAmbiguity*/ true);
                    parseExpected(22 /* CloseParenToken */ );
                    return parameters;
                }
                function parseTypeMemberSemicolon() {
                    if (parseOptional(28 /* CommaToken */ )) return;
                    parseSemicolon();
                }
                function parseSignatureMember(kind) {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    if (kind === 179 /* ConstructSignature */ ) parseExpected(105 /* NewKeyword */ );
                    const typeParameters = parseTypeParameters();
                    const parameters = parseParameters(4 /* Type */ );
                    const type = parseReturnType(59 /* ColonToken */ , /*isType*/ true);
                    parseTypeMemberSemicolon();
                    const node = kind === 178 /* CallSignature */  ? factory2.createCallSignature(typeParameters, parameters, type) : factory2.createConstructSignature(typeParameters, parameters, type);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function isIndexSignature() {
                    return token() === 23 /* OpenBracketToken */  && lookAhead(isUnambiguouslyIndexSignature);
                }
                function isUnambiguouslyIndexSignature() {
                    nextToken();
                    if (token() === 26 /* DotDotDotToken */  || token() === 24 /* CloseBracketToken */ ) return true;
                    if (isModifierKind(token())) {
                        nextToken();
                        if (isIdentifier2()) return true;
                    } else if (!isIdentifier2()) return false;
                    else nextToken();
                    if (token() === 59 /* ColonToken */  || token() === 28 /* CommaToken */ ) return true;
                    if (token() !== 58 /* QuestionToken */ ) return false;
                    nextToken();
                    return token() === 59 /* ColonToken */  || token() === 28 /* CommaToken */  || token() === 24 /* CloseBracketToken */ ;
                }
                function parseIndexSignatureDeclaration(pos, hasJSDoc, modifiers) {
                    const parameters = parseBracketedList(16 /* Parameters */ , ()=>parseParameter(/*inOuterAwaitContext*/ false), 23 /* OpenBracketToken */ , 24 /* CloseBracketToken */ );
                    const type = parseTypeAnnotation();
                    parseTypeMemberSemicolon();
                    const node = factory2.createIndexSignature(modifiers, parameters, type);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parsePropertyOrMethodSignature(pos, hasJSDoc, modifiers) {
                    const name = parsePropertyName();
                    const questionToken = parseOptionalToken(58 /* QuestionToken */ );
                    let node;
                    if (token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */ ) {
                        const typeParameters = parseTypeParameters();
                        const parameters = parseParameters(4 /* Type */ );
                        const type = parseReturnType(59 /* ColonToken */ , /*isType*/ true);
                        node = factory2.createMethodSignature(modifiers, name, questionToken, typeParameters, parameters, type);
                    } else {
                        const type = parseTypeAnnotation();
                        node = factory2.createPropertySignature(modifiers, name, questionToken, type);
                        if (token() === 64 /* EqualsToken */ ) node.initializer = parseInitializer();
                    }
                    parseTypeMemberSemicolon();
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function isTypeMemberStart() {
                    if (token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */  || token() === 139 /* GetKeyword */  || token() === 153 /* SetKeyword */ ) return true;
                    let idToken = false;
                    while(isModifierKind(token())){
                        idToken = true;
                        nextToken();
                    }
                    if (token() === 23 /* OpenBracketToken */ ) return true;
                    if (isLiteralPropertyName()) {
                        idToken = true;
                        nextToken();
                    }
                    if (idToken) return token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */  || token() === 58 /* QuestionToken */  || token() === 59 /* ColonToken */  || token() === 28 /* CommaToken */  || canParseSemicolon();
                    return false;
                }
                function parseTypeMember() {
                    if (token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */ ) return parseSignatureMember(178 /* CallSignature */ );
                    if (token() === 105 /* NewKeyword */  && lookAhead(nextTokenIsOpenParenOrLessThan)) return parseSignatureMember(179 /* ConstructSignature */ );
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    const modifiers = parseModifiers(/*allowDecorators*/ false);
                    if (parseContextualModifier(139 /* GetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 176 /* GetAccessor */ , 4 /* Type */ );
                    if (parseContextualModifier(153 /* SetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 177 /* SetAccessor */ , 4 /* Type */ );
                    if (isIndexSignature()) return parseIndexSignatureDeclaration(pos, hasJSDoc, modifiers);
                    return parsePropertyOrMethodSignature(pos, hasJSDoc, modifiers);
                }
                function nextTokenIsOpenParenOrLessThan() {
                    nextToken();
                    return token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */ ;
                }
                function nextTokenIsDot() {
                    return nextToken() === 25 /* DotToken */ ;
                }
                function nextTokenIsOpenParenOrLessThanOrDot() {
                    switch(nextToken()){
                        case 21 /* OpenParenToken */ :
                        case 30 /* LessThanToken */ :
                        case 25 /* DotToken */ :
                            return true;
                    }
                    return false;
                }
                function parseTypeLiteral() {
                    const pos = getNodePos();
                    return finishNode(factory2.createTypeLiteralNode(parseObjectTypeMembers()), pos);
                }
                function parseObjectTypeMembers() {
                    let members;
                    if (parseExpected(19 /* OpenBraceToken */ )) {
                        members = parseList(4 /* TypeMembers */ , parseTypeMember);
                        parseExpected(20 /* CloseBraceToken */ );
                    } else members = createMissingList();
                    return members;
                }
                function isStartOfMappedType() {
                    nextToken();
                    if (token() === 40 /* PlusToken */  || token() === 41 /* MinusToken */ ) return nextToken() === 148 /* ReadonlyKeyword */ ;
                    if (token() === 148 /* ReadonlyKeyword */ ) nextToken();
                    return token() === 23 /* OpenBracketToken */  && nextTokenIsIdentifier() && nextToken() === 103 /* InKeyword */ ;
                }
                function parseMappedTypeParameter() {
                    const pos = getNodePos();
                    const name = parseIdentifierName();
                    parseExpected(103 /* InKeyword */ );
                    const type = parseType();
                    return finishNode(factory2.createTypeParameterDeclaration(/*modifiers*/ void 0, name, type, /*defaultType*/ void 0), pos);
                }
                function parseMappedType() {
                    const pos = getNodePos();
                    parseExpected(19 /* OpenBraceToken */ );
                    let readonlyToken;
                    if (token() === 148 /* ReadonlyKeyword */  || token() === 40 /* PlusToken */  || token() === 41 /* MinusToken */ ) {
                        readonlyToken = parseTokenNode();
                        if (readonlyToken.kind !== 148 /* ReadonlyKeyword */ ) parseExpected(148 /* ReadonlyKeyword */ );
                    }
                    parseExpected(23 /* OpenBracketToken */ );
                    const typeParameter = parseMappedTypeParameter();
                    const nameType = parseOptional(130 /* AsKeyword */ ) ? parseType() : void 0;
                    parseExpected(24 /* CloseBracketToken */ );
                    let questionToken;
                    if (token() === 58 /* QuestionToken */  || token() === 40 /* PlusToken */  || token() === 41 /* MinusToken */ ) {
                        questionToken = parseTokenNode();
                        if (questionToken.kind !== 58 /* QuestionToken */ ) parseExpected(58 /* QuestionToken */ );
                    }
                    const type = parseTypeAnnotation();
                    parseSemicolon();
                    const members = parseList(4 /* TypeMembers */ , parseTypeMember);
                    parseExpected(20 /* CloseBraceToken */ );
                    return finishNode(factory2.createMappedTypeNode(readonlyToken, typeParameter, nameType, questionToken, type, members), pos);
                }
                function parseTupleElementType() {
                    const pos = getNodePos();
                    if (parseOptional(26 /* DotDotDotToken */ )) return finishNode(factory2.createRestTypeNode(parseType()), pos);
                    const type = parseType();
                    if (isJSDocNullableType(type) && type.pos === type.type.pos) {
                        const node = factory2.createOptionalTypeNode(type.type);
                        setTextRange(node, type);
                        node.flags = type.flags;
                        return node;
                    }
                    return type;
                }
                function isNextTokenColonOrQuestionColon() {
                    return nextToken() === 59 /* ColonToken */  || token() === 58 /* QuestionToken */  && nextToken() === 59 /* ColonToken */ ;
                }
                function isTupleElementName() {
                    if (token() === 26 /* DotDotDotToken */ ) return tokenIsIdentifierOrKeyword(nextToken()) && isNextTokenColonOrQuestionColon();
                    return tokenIsIdentifierOrKeyword(token()) && isNextTokenColonOrQuestionColon();
                }
                function parseTupleElementNameOrTupleElementType() {
                    if (lookAhead(isTupleElementName)) {
                        const pos = getNodePos();
                        const hasJSDoc = hasPrecedingJSDocComment();
                        const dotDotDotToken = parseOptionalToken(26 /* DotDotDotToken */ );
                        const name = parseIdentifierName();
                        const questionToken = parseOptionalToken(58 /* QuestionToken */ );
                        parseExpected(59 /* ColonToken */ );
                        const type = parseTupleElementType();
                        const node = factory2.createNamedTupleMember(dotDotDotToken, name, questionToken, type);
                        return withJSDoc(finishNode(node, pos), hasJSDoc);
                    }
                    return parseTupleElementType();
                }
                function parseTupleType() {
                    const pos = getNodePos();
                    return finishNode(factory2.createTupleTypeNode(parseBracketedList(21 /* TupleElementTypes */ , parseTupleElementNameOrTupleElementType, 23 /* OpenBracketToken */ , 24 /* CloseBracketToken */ )), pos);
                }
                function parseParenthesizedType() {
                    const pos = getNodePos();
                    parseExpected(21 /* OpenParenToken */ );
                    const type = parseType();
                    parseExpected(22 /* CloseParenToken */ );
                    return finishNode(factory2.createParenthesizedType(type), pos);
                }
                function parseModifiersForConstructorType() {
                    let modifiers;
                    if (token() === 128 /* AbstractKeyword */ ) {
                        const pos = getNodePos();
                        nextToken();
                        const modifier = finishNode(factoryCreateToken(128 /* AbstractKeyword */ ), pos);
                        modifiers = createNodeArray([
                            modifier
                        ], pos);
                    }
                    return modifiers;
                }
                function parseFunctionOrConstructorType() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    const modifiers = parseModifiersForConstructorType();
                    const isConstructorType = parseOptional(105 /* NewKeyword */ );
                    Debug.assert(!modifiers || isConstructorType, "Per isStartOfFunctionOrConstructorType, a function type cannot have modifiers.");
                    const typeParameters = parseTypeParameters();
                    const parameters = parseParameters(4 /* Type */ );
                    const type = parseReturnType(39 /* EqualsGreaterThanToken */ , /*isType*/ false);
                    const node = isConstructorType ? factory2.createConstructorTypeNode(modifiers, typeParameters, parameters, type) : factory2.createFunctionTypeNode(typeParameters, parameters, type);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseKeywordAndNoDot() {
                    const node = parseTokenNode();
                    return token() === 25 /* DotToken */  ? void 0 : node;
                }
                function parseLiteralTypeNode(negative) {
                    const pos = getNodePos();
                    if (negative) nextToken();
                    let expression = token() === 112 /* TrueKeyword */  || token() === 97 /* FalseKeyword */  || token() === 106 /* NullKeyword */  ? parseTokenNode() : parseLiteralLikeNode(token());
                    if (negative) expression = finishNode(factory2.createPrefixUnaryExpression(41 /* MinusToken */ , expression), pos);
                    return finishNode(factory2.createLiteralTypeNode(expression), pos);
                }
                function isStartOfTypeOfImportType() {
                    nextToken();
                    return token() === 102 /* ImportKeyword */ ;
                }
                function parseImportTypeAssertions() {
                    const pos = getNodePos();
                    const openBracePosition = scanner2.getTokenStart();
                    parseExpected(19 /* OpenBraceToken */ );
                    const multiLine = scanner2.hasPrecedingLineBreak();
                    parseExpected(132 /* AssertKeyword */ );
                    parseExpected(59 /* ColonToken */ );
                    const clause = parseAssertClause(/*skipAssertKeyword*/ true);
                    if (!parseExpected(20 /* CloseBraceToken */ )) {
                        const lastError = lastOrUndefined(parseDiagnostics);
                        if (lastError && lastError.code === Diagnostics._0_expected.code) addRelatedInfo(lastError, createDetachedDiagnostic(fileName, openBracePosition, 1, Diagnostics.The_parser_expected_to_find_a_1_to_match_the_0_token_here, "{", "}"));
                    }
                    return finishNode(factory2.createImportTypeAssertionContainer(clause, multiLine), pos);
                }
                function parseImportType() {
                    sourceFlags |= 2097152 /* PossiblyContainsDynamicImport */ ;
                    const pos = getNodePos();
                    const isTypeOf = parseOptional(114 /* TypeOfKeyword */ );
                    parseExpected(102 /* ImportKeyword */ );
                    parseExpected(21 /* OpenParenToken */ );
                    const type = parseType();
                    let assertions;
                    if (parseOptional(28 /* CommaToken */ )) assertions = parseImportTypeAssertions();
                    parseExpected(22 /* CloseParenToken */ );
                    const qualifier = parseOptional(25 /* DotToken */ ) ? parseEntityNameOfTypeReference() : void 0;
                    const typeArguments = parseTypeArgumentsOfTypeReference();
                    return finishNode(factory2.createImportTypeNode(type, assertions, qualifier, typeArguments, isTypeOf), pos);
                }
                function nextTokenIsNumericOrBigIntLiteral() {
                    nextToken();
                    return token() === 9 /* NumericLiteral */  || token() === 10 /* BigIntLiteral */ ;
                }
                function parseNonArrayType() {
                    switch(token()){
                        case 133 /* AnyKeyword */ :
                        case 159 /* UnknownKeyword */ :
                        case 154 /* StringKeyword */ :
                        case 150 /* NumberKeyword */ :
                        case 162 /* BigIntKeyword */ :
                        case 155 /* SymbolKeyword */ :
                        case 136 /* BooleanKeyword */ :
                        case 157 /* UndefinedKeyword */ :
                        case 146 /* NeverKeyword */ :
                        case 151 /* ObjectKeyword */ :
                            return tryParse(parseKeywordAndNoDot) || parseTypeReference();
                        case 67 /* AsteriskEqualsToken */ :
                            scanner2.reScanAsteriskEqualsToken();
                        case 42 /* AsteriskToken */ :
                            return parseJSDocAllType();
                        case 61 /* QuestionQuestionToken */ :
                            scanner2.reScanQuestionToken();
                        case 58 /* QuestionToken */ :
                            return parseJSDocUnknownOrNullableType();
                        case 100 /* FunctionKeyword */ :
                            return parseJSDocFunctionType();
                        case 54 /* ExclamationToken */ :
                            return parseJSDocNonNullableType();
                        case 15 /* NoSubstitutionTemplateLiteral */ :
                        case 11 /* StringLiteral */ :
                        case 9 /* NumericLiteral */ :
                        case 10 /* BigIntLiteral */ :
                        case 112 /* TrueKeyword */ :
                        case 97 /* FalseKeyword */ :
                        case 106 /* NullKeyword */ :
                            return parseLiteralTypeNode();
                        case 41 /* MinusToken */ :
                            return lookAhead(nextTokenIsNumericOrBigIntLiteral) ? parseLiteralTypeNode(/*negative*/ true) : parseTypeReference();
                        case 116 /* VoidKeyword */ :
                            return parseTokenNode();
                        case 110 /* ThisKeyword */ :
                            {
                                const thisKeyword = parseThisTypeNode();
                                if (token() === 142 /* IsKeyword */  && !scanner2.hasPrecedingLineBreak()) return parseThisTypePredicate(thisKeyword);
                                else return thisKeyword;
                            }
                        case 114 /* TypeOfKeyword */ :
                            return lookAhead(isStartOfTypeOfImportType) ? parseImportType() : parseTypeQuery();
                        case 19 /* OpenBraceToken */ :
                            return lookAhead(isStartOfMappedType) ? parseMappedType() : parseTypeLiteral();
                        case 23 /* OpenBracketToken */ :
                            return parseTupleType();
                        case 21 /* OpenParenToken */ :
                            return parseParenthesizedType();
                        case 102 /* ImportKeyword */ :
                            return parseImportType();
                        case 131 /* AssertsKeyword */ :
                            return lookAhead(nextTokenIsIdentifierOrKeywordOnSameLine) ? parseAssertsTypePredicate() : parseTypeReference();
                        case 16 /* TemplateHead */ :
                            return parseTemplateType();
                        default:
                            return parseTypeReference();
                    }
                }
                function isStartOfType(inStartOfParameter) {
                    switch(token()){
                        case 133 /* AnyKeyword */ :
                        case 159 /* UnknownKeyword */ :
                        case 154 /* StringKeyword */ :
                        case 150 /* NumberKeyword */ :
                        case 162 /* BigIntKeyword */ :
                        case 136 /* BooleanKeyword */ :
                        case 148 /* ReadonlyKeyword */ :
                        case 155 /* SymbolKeyword */ :
                        case 158 /* UniqueKeyword */ :
                        case 116 /* VoidKeyword */ :
                        case 157 /* UndefinedKeyword */ :
                        case 106 /* NullKeyword */ :
                        case 110 /* ThisKeyword */ :
                        case 114 /* TypeOfKeyword */ :
                        case 146 /* NeverKeyword */ :
                        case 19 /* OpenBraceToken */ :
                        case 23 /* OpenBracketToken */ :
                        case 30 /* LessThanToken */ :
                        case 52 /* BarToken */ :
                        case 51 /* AmpersandToken */ :
                        case 105 /* NewKeyword */ :
                        case 11 /* StringLiteral */ :
                        case 9 /* NumericLiteral */ :
                        case 10 /* BigIntLiteral */ :
                        case 112 /* TrueKeyword */ :
                        case 97 /* FalseKeyword */ :
                        case 151 /* ObjectKeyword */ :
                        case 42 /* AsteriskToken */ :
                        case 58 /* QuestionToken */ :
                        case 54 /* ExclamationToken */ :
                        case 26 /* DotDotDotToken */ :
                        case 140 /* InferKeyword */ :
                        case 102 /* ImportKeyword */ :
                        case 131 /* AssertsKeyword */ :
                        case 15 /* NoSubstitutionTemplateLiteral */ :
                        case 16 /* TemplateHead */ :
                            return true;
                        case 100 /* FunctionKeyword */ :
                            return !inStartOfParameter;
                        case 41 /* MinusToken */ :
                            return !inStartOfParameter && lookAhead(nextTokenIsNumericOrBigIntLiteral);
                        case 21 /* OpenParenToken */ :
                            return !inStartOfParameter && lookAhead(isStartOfParenthesizedOrFunctionType);
                        default:
                            return isIdentifier2();
                    }
                }
                function isStartOfParenthesizedOrFunctionType() {
                    nextToken();
                    return token() === 22 /* CloseParenToken */  || isStartOfParameter(/*isJSDocParameter*/ false) || isStartOfType();
                }
                function parsePostfixTypeOrHigher() {
                    const pos = getNodePos();
                    let type = parseNonArrayType();
                    while(!scanner2.hasPrecedingLineBreak())switch(token()){
                        case 54 /* ExclamationToken */ :
                            nextToken();
                            type = finishNode(factory2.createJSDocNonNullableType(type, /*postfix*/ true), pos);
                            break;
                        case 58 /* QuestionToken */ :
                            if (lookAhead(nextTokenIsStartOfType)) return type;
                            nextToken();
                            type = finishNode(factory2.createJSDocNullableType(type, /*postfix*/ true), pos);
                            break;
                        case 23 /* OpenBracketToken */ :
                            parseExpected(23 /* OpenBracketToken */ );
                            if (isStartOfType()) {
                                const indexType = parseType();
                                parseExpected(24 /* CloseBracketToken */ );
                                type = finishNode(factory2.createIndexedAccessTypeNode(type, indexType), pos);
                            } else {
                                parseExpected(24 /* CloseBracketToken */ );
                                type = finishNode(factory2.createArrayTypeNode(type), pos);
                            }
                            break;
                        default:
                            return type;
                    }
                    return type;
                }
                function parseTypeOperator(operator) {
                    const pos = getNodePos();
                    parseExpected(operator);
                    return finishNode(factory2.createTypeOperatorNode(operator, parseTypeOperatorOrHigher()), pos);
                }
                function tryParseConstraintOfInferType() {
                    if (parseOptional(96 /* ExtendsKeyword */ )) {
                        const constraint = disallowConditionalTypesAnd(parseType);
                        if (inDisallowConditionalTypesContext() || token() !== 58 /* QuestionToken */ ) return constraint;
                    }
                }
                function parseTypeParameterOfInferType() {
                    const pos = getNodePos();
                    const name = parseIdentifier();
                    const constraint = tryParse(tryParseConstraintOfInferType);
                    const node = factory2.createTypeParameterDeclaration(/*modifiers*/ void 0, name, constraint);
                    return finishNode(node, pos);
                }
                function parseInferType() {
                    const pos = getNodePos();
                    parseExpected(140 /* InferKeyword */ );
                    return finishNode(factory2.createInferTypeNode(parseTypeParameterOfInferType()), pos);
                }
                function parseTypeOperatorOrHigher() {
                    const operator = token();
                    switch(operator){
                        case 143 /* KeyOfKeyword */ :
                        case 158 /* UniqueKeyword */ :
                        case 148 /* ReadonlyKeyword */ :
                            return parseTypeOperator(operator);
                        case 140 /* InferKeyword */ :
                            return parseInferType();
                    }
                    return allowConditionalTypesAnd(parsePostfixTypeOrHigher);
                }
                function parseFunctionOrConstructorTypeToError(isInUnionType) {
                    if (isStartOfFunctionTypeOrConstructorType()) {
                        const type = parseFunctionOrConstructorType();
                        let diagnostic;
                        if (isFunctionTypeNode(type)) diagnostic = isInUnionType ? Diagnostics.Function_type_notation_must_be_parenthesized_when_used_in_a_union_type : Diagnostics.Function_type_notation_must_be_parenthesized_when_used_in_an_intersection_type;
                        else diagnostic = isInUnionType ? Diagnostics.Constructor_type_notation_must_be_parenthesized_when_used_in_a_union_type : Diagnostics.Constructor_type_notation_must_be_parenthesized_when_used_in_an_intersection_type;
                        parseErrorAtRange(type, diagnostic);
                        return type;
                    }
                    return void 0;
                }
                function parseUnionOrIntersectionType(operator, parseConstituentType, createTypeNode) {
                    const pos = getNodePos();
                    const isUnionType = operator === 52 /* BarToken */ ;
                    const hasLeadingOperator = parseOptional(operator);
                    let type = hasLeadingOperator && parseFunctionOrConstructorTypeToError(isUnionType) || parseConstituentType();
                    if (token() === operator || hasLeadingOperator) {
                        const types = [
                            type
                        ];
                        while(parseOptional(operator))types.push(parseFunctionOrConstructorTypeToError(isUnionType) || parseConstituentType());
                        type = finishNode(createTypeNode(createNodeArray(types, pos)), pos);
                    }
                    return type;
                }
                function parseIntersectionTypeOrHigher() {
                    return parseUnionOrIntersectionType(51 /* AmpersandToken */ , parseTypeOperatorOrHigher, factory2.createIntersectionTypeNode);
                }
                function parseUnionTypeOrHigher() {
                    return parseUnionOrIntersectionType(52 /* BarToken */ , parseIntersectionTypeOrHigher, factory2.createUnionTypeNode);
                }
                function nextTokenIsNewKeyword() {
                    nextToken();
                    return token() === 105 /* NewKeyword */ ;
                }
                function isStartOfFunctionTypeOrConstructorType() {
                    if (token() === 30 /* LessThanToken */ ) return true;
                    if (token() === 21 /* OpenParenToken */  && lookAhead(isUnambiguouslyStartOfFunctionType)) return true;
                    return token() === 105 /* NewKeyword */  || token() === 128 /* AbstractKeyword */  && lookAhead(nextTokenIsNewKeyword);
                }
                function skipParameterStart() {
                    if (isModifierKind(token())) parseModifiers(/*allowDecorators*/ false);
                    if (isIdentifier2() || token() === 110 /* ThisKeyword */ ) {
                        nextToken();
                        return true;
                    }
                    if (token() === 23 /* OpenBracketToken */  || token() === 19 /* OpenBraceToken */ ) {
                        const previousErrorCount = parseDiagnostics.length;
                        parseIdentifierOrPattern();
                        return previousErrorCount === parseDiagnostics.length;
                    }
                    return false;
                }
                function isUnambiguouslyStartOfFunctionType() {
                    nextToken();
                    if (token() === 22 /* CloseParenToken */  || token() === 26 /* DotDotDotToken */ ) return true;
                    if (skipParameterStart()) {
                        if (token() === 59 /* ColonToken */  || token() === 28 /* CommaToken */  || token() === 58 /* QuestionToken */  || token() === 64 /* EqualsToken */ ) return true;
                        if (token() === 22 /* CloseParenToken */ ) {
                            nextToken();
                            if (token() === 39 /* EqualsGreaterThanToken */ ) return true;
                        }
                    }
                    return false;
                }
                function parseTypeOrTypePredicate() {
                    const pos = getNodePos();
                    const typePredicateVariable = isIdentifier2() && tryParse(parseTypePredicatePrefix);
                    const type = parseType();
                    if (typePredicateVariable) return finishNode(factory2.createTypePredicateNode(/*assertsModifier*/ void 0, typePredicateVariable, type), pos);
                    else return type;
                }
                function parseTypePredicatePrefix() {
                    const id = parseIdentifier();
                    if (token() === 142 /* IsKeyword */  && !scanner2.hasPrecedingLineBreak()) {
                        nextToken();
                        return id;
                    }
                }
                function parseAssertsTypePredicate() {
                    const pos = getNodePos();
                    const assertsModifier = parseExpectedToken(131 /* AssertsKeyword */ );
                    const parameterName = token() === 110 /* ThisKeyword */  ? parseThisTypeNode() : parseIdentifier();
                    const type = parseOptional(142 /* IsKeyword */ ) ? parseType() : void 0;
                    return finishNode(factory2.createTypePredicateNode(assertsModifier, parameterName, type), pos);
                }
                function parseType() {
                    if (contextFlags & 40960 /* TypeExcludesFlags */ ) return doOutsideOfContext(40960 /* TypeExcludesFlags */ , parseType);
                    if (isStartOfFunctionTypeOrConstructorType()) return parseFunctionOrConstructorType();
                    const pos = getNodePos();
                    const type = parseUnionTypeOrHigher();
                    if (!inDisallowConditionalTypesContext() && !scanner2.hasPrecedingLineBreak() && parseOptional(96 /* ExtendsKeyword */ )) {
                        const extendsType = disallowConditionalTypesAnd(parseType);
                        parseExpected(58 /* QuestionToken */ );
                        const trueType = allowConditionalTypesAnd(parseType);
                        parseExpected(59 /* ColonToken */ );
                        const falseType = allowConditionalTypesAnd(parseType);
                        return finishNode(factory2.createConditionalTypeNode(type, extendsType, trueType, falseType), pos);
                    }
                    return type;
                }
                function parseTypeAnnotation() {
                    return parseOptional(59 /* ColonToken */ ) ? parseType() : void 0;
                }
                function isStartOfLeftHandSideExpression() {
                    switch(token()){
                        case 110 /* ThisKeyword */ :
                        case 108 /* SuperKeyword */ :
                        case 106 /* NullKeyword */ :
                        case 112 /* TrueKeyword */ :
                        case 97 /* FalseKeyword */ :
                        case 9 /* NumericLiteral */ :
                        case 10 /* BigIntLiteral */ :
                        case 11 /* StringLiteral */ :
                        case 15 /* NoSubstitutionTemplateLiteral */ :
                        case 16 /* TemplateHead */ :
                        case 21 /* OpenParenToken */ :
                        case 23 /* OpenBracketToken */ :
                        case 19 /* OpenBraceToken */ :
                        case 100 /* FunctionKeyword */ :
                        case 86 /* ClassKeyword */ :
                        case 105 /* NewKeyword */ :
                        case 44 /* SlashToken */ :
                        case 69 /* SlashEqualsToken */ :
                        case 80 /* Identifier */ :
                            return true;
                        case 102 /* ImportKeyword */ :
                            return lookAhead(nextTokenIsOpenParenOrLessThanOrDot);
                        default:
                            return isIdentifier2();
                    }
                }
                function isStartOfExpression() {
                    if (isStartOfLeftHandSideExpression()) return true;
                    switch(token()){
                        case 40 /* PlusToken */ :
                        case 41 /* MinusToken */ :
                        case 55 /* TildeToken */ :
                        case 54 /* ExclamationToken */ :
                        case 91 /* DeleteKeyword */ :
                        case 114 /* TypeOfKeyword */ :
                        case 116 /* VoidKeyword */ :
                        case 46 /* PlusPlusToken */ :
                        case 47 /* MinusMinusToken */ :
                        case 30 /* LessThanToken */ :
                        case 135 /* AwaitKeyword */ :
                        case 127 /* YieldKeyword */ :
                        case 81 /* PrivateIdentifier */ :
                        case 60 /* AtToken */ :
                            return true;
                        default:
                            if (isBinaryOperator2()) return true;
                            return isIdentifier2();
                    }
                }
                function isStartOfExpressionStatement() {
                    return token() !== 19 /* OpenBraceToken */  && token() !== 100 /* FunctionKeyword */  && token() !== 86 /* ClassKeyword */  && token() !== 60 /* AtToken */  && isStartOfExpression();
                }
                function parseExpression() {
                    const saveDecoratorContext = inDecoratorContext();
                    if (saveDecoratorContext) setDecoratorContext(/*val*/ false);
                    const pos = getNodePos();
                    let expr = parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
                    let operatorToken;
                    while(operatorToken = parseOptionalToken(28 /* CommaToken */ ))expr = makeBinaryExpression(expr, operatorToken, parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true), pos);
                    if (saveDecoratorContext) setDecoratorContext(/*val*/ true);
                    return expr;
                }
                function parseInitializer() {
                    return parseOptional(64 /* EqualsToken */ ) ? parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true) : void 0;
                }
                function parseAssignmentExpressionOrHigher(allowReturnTypeInArrowFunction) {
                    if (isYieldExpression2()) return parseYieldExpression();
                    const arrowExpression = tryParseParenthesizedArrowFunctionExpression(allowReturnTypeInArrowFunction) || tryParseAsyncSimpleArrowFunctionExpression(allowReturnTypeInArrowFunction);
                    if (arrowExpression) return arrowExpression;
                    const pos = getNodePos();
                    const expr = parseBinaryExpressionOrHigher(0 /* Lowest */ );
                    if (expr.kind === 80 /* Identifier */  && token() === 39 /* EqualsGreaterThanToken */ ) return parseSimpleArrowFunctionExpression(pos, expr, allowReturnTypeInArrowFunction, /*asyncModifier*/ void 0);
                    if (isLeftHandSideExpression(expr) && isAssignmentOperator(reScanGreaterToken())) return makeBinaryExpression(expr, parseTokenNode(), parseAssignmentExpressionOrHigher(allowReturnTypeInArrowFunction), pos);
                    return parseConditionalExpressionRest(expr, pos, allowReturnTypeInArrowFunction);
                }
                function isYieldExpression2() {
                    if (token() === 127 /* YieldKeyword */ ) {
                        if (inYieldContext()) return true;
                        return lookAhead(nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine);
                    }
                    return false;
                }
                function nextTokenIsIdentifierOnSameLine() {
                    nextToken();
                    return !scanner2.hasPrecedingLineBreak() && isIdentifier2();
                }
                function parseYieldExpression() {
                    const pos = getNodePos();
                    nextToken();
                    if (!scanner2.hasPrecedingLineBreak() && (token() === 42 /* AsteriskToken */  || isStartOfExpression())) return finishNode(factory2.createYieldExpression(parseOptionalToken(42 /* AsteriskToken */ ), parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true)), pos);
                    else return finishNode(factory2.createYieldExpression(/*asteriskToken*/ void 0, /*expression*/ void 0), pos);
                }
                function parseSimpleArrowFunctionExpression(pos, identifier, allowReturnTypeInArrowFunction, asyncModifier) {
                    Debug.assert(token() === 39 /* EqualsGreaterThanToken */ , "parseSimpleArrowFunctionExpression should only have been called if we had a =>");
                    const parameter = factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, identifier, /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
                    finishNode(parameter, identifier.pos);
                    const parameters = createNodeArray([
                        parameter
                    ], parameter.pos, parameter.end);
                    const equalsGreaterThanToken = parseExpectedToken(39 /* EqualsGreaterThanToken */ );
                    const body = parseArrowFunctionExpressionBody(/*isAsync*/ !!asyncModifier, allowReturnTypeInArrowFunction);
                    const node = factory2.createArrowFunction(asyncModifier, /*typeParameters*/ void 0, parameters, /*type*/ void 0, equalsGreaterThanToken, body);
                    return addJSDocComment(finishNode(node, pos));
                }
                function tryParseParenthesizedArrowFunctionExpression(allowReturnTypeInArrowFunction) {
                    const triState = isParenthesizedArrowFunctionExpression();
                    if (triState === 0 /* False */ ) return void 0;
                    return triState === 1 /* True */  ? parseParenthesizedArrowFunctionExpression(/*allowAmbiguity*/ true, /*allowReturnTypeInArrowFunction*/ true) : tryParse(()=>parsePossibleParenthesizedArrowFunctionExpression(allowReturnTypeInArrowFunction));
                }
                function isParenthesizedArrowFunctionExpression() {
                    if (token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */  || token() === 134 /* AsyncKeyword */ ) return lookAhead(isParenthesizedArrowFunctionExpressionWorker);
                    if (token() === 39 /* EqualsGreaterThanToken */ ) return 1 /* True */ ;
                    return 0 /* False */ ;
                }
                function isParenthesizedArrowFunctionExpressionWorker() {
                    if (token() === 134 /* AsyncKeyword */ ) {
                        nextToken();
                        if (scanner2.hasPrecedingLineBreak()) return 0 /* False */ ;
                        if (token() !== 21 /* OpenParenToken */  && token() !== 30 /* LessThanToken */ ) return 0 /* False */ ;
                    }
                    const first2 = token();
                    const second = nextToken();
                    if (first2 === 21 /* OpenParenToken */ ) {
                        if (second === 22 /* CloseParenToken */ ) {
                            const third = nextToken();
                            switch(third){
                                case 39 /* EqualsGreaterThanToken */ :
                                case 59 /* ColonToken */ :
                                case 19 /* OpenBraceToken */ :
                                    return 1 /* True */ ;
                                default:
                                    return 0 /* False */ ;
                            }
                        }
                        if (second === 23 /* OpenBracketToken */  || second === 19 /* OpenBraceToken */ ) return 2 /* Unknown */ ;
                        if (second === 26 /* DotDotDotToken */ ) return 1 /* True */ ;
                        if (isModifierKind(second) && second !== 134 /* AsyncKeyword */  && lookAhead(nextTokenIsIdentifier)) {
                            if (nextToken() === 130 /* AsKeyword */ ) return 0 /* False */ ;
                            return 1 /* True */ ;
                        }
                        if (!isIdentifier2() && second !== 110 /* ThisKeyword */ ) return 0 /* False */ ;
                        switch(nextToken()){
                            case 59 /* ColonToken */ :
                                return 1 /* True */ ;
                            case 58 /* QuestionToken */ :
                                nextToken();
                                if (token() === 59 /* ColonToken */  || token() === 28 /* CommaToken */  || token() === 64 /* EqualsToken */  || token() === 22 /* CloseParenToken */ ) return 1 /* True */ ;
                                return 0 /* False */ ;
                            case 28 /* CommaToken */ :
                            case 64 /* EqualsToken */ :
                            case 22 /* CloseParenToken */ :
                                return 2 /* Unknown */ ;
                        }
                        return 0 /* False */ ;
                    } else {
                        Debug.assert(first2 === 30 /* LessThanToken */ );
                        if (!isIdentifier2() && token() !== 87 /* ConstKeyword */ ) return 0 /* False */ ;
                        if (languageVariant === 1 /* JSX */ ) {
                            const isArrowFunctionInJsx = lookAhead(()=>{
                                parseOptional(87 /* ConstKeyword */ );
                                const third = nextToken();
                                if (third === 96 /* ExtendsKeyword */ ) {
                                    const fourth = nextToken();
                                    switch(fourth){
                                        case 64 /* EqualsToken */ :
                                        case 32 /* GreaterThanToken */ :
                                        case 44 /* SlashToken */ :
                                            return false;
                                        default:
                                            return true;
                                    }
                                } else if (third === 28 /* CommaToken */  || third === 64 /* EqualsToken */ ) return true;
                                return false;
                            });
                            if (isArrowFunctionInJsx) return 1 /* True */ ;
                            return 0 /* False */ ;
                        }
                        return 2 /* Unknown */ ;
                    }
                }
                function parsePossibleParenthesizedArrowFunctionExpression(allowReturnTypeInArrowFunction) {
                    const tokenPos = scanner2.getTokenStart();
                    if (notParenthesizedArrow == null ? void 0 : notParenthesizedArrow.has(tokenPos)) return void 0;
                    const result = parseParenthesizedArrowFunctionExpression(/*allowAmbiguity*/ false, allowReturnTypeInArrowFunction);
                    if (!result) (notParenthesizedArrow || (notParenthesizedArrow = /* @__PURE__ */ new Set())).add(tokenPos);
                    return result;
                }
                function tryParseAsyncSimpleArrowFunctionExpression(allowReturnTypeInArrowFunction) {
                    if (token() === 134 /* AsyncKeyword */ ) {
                        if (lookAhead(isUnParenthesizedAsyncArrowFunctionWorker) === 1 /* True */ ) {
                            const pos = getNodePos();
                            const asyncModifier = parseModifiersForArrowFunction();
                            const expr = parseBinaryExpressionOrHigher(0 /* Lowest */ );
                            return parseSimpleArrowFunctionExpression(pos, expr, allowReturnTypeInArrowFunction, asyncModifier);
                        }
                    }
                    return void 0;
                }
                function isUnParenthesizedAsyncArrowFunctionWorker() {
                    if (token() === 134 /* AsyncKeyword */ ) {
                        nextToken();
                        if (scanner2.hasPrecedingLineBreak() || token() === 39 /* EqualsGreaterThanToken */ ) return 0 /* False */ ;
                        const expr = parseBinaryExpressionOrHigher(0 /* Lowest */ );
                        if (!scanner2.hasPrecedingLineBreak() && expr.kind === 80 /* Identifier */  && token() === 39 /* EqualsGreaterThanToken */ ) return 1 /* True */ ;
                    }
                    return 0 /* False */ ;
                }
                function parseParenthesizedArrowFunctionExpression(allowAmbiguity, allowReturnTypeInArrowFunction) {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    const modifiers = parseModifiersForArrowFunction();
                    const isAsync = some(modifiers, isAsyncModifier) ? 2 /* Await */  : 0 /* None */ ;
                    const typeParameters = parseTypeParameters();
                    let parameters;
                    if (!parseExpected(21 /* OpenParenToken */ )) {
                        if (!allowAmbiguity) return void 0;
                        parameters = createMissingList();
                    } else {
                        if (!allowAmbiguity) {
                            const maybeParameters = parseParametersWorker(isAsync, allowAmbiguity);
                            if (!maybeParameters) return void 0;
                            parameters = maybeParameters;
                        } else parameters = parseParametersWorker(isAsync, allowAmbiguity);
                        if (!parseExpected(22 /* CloseParenToken */ ) && !allowAmbiguity) return void 0;
                    }
                    const hasReturnColon = token() === 59 /* ColonToken */ ;
                    const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
                    if (type && !allowAmbiguity && typeHasArrowFunctionBlockingParseError(type)) return void 0;
                    let unwrappedType = type;
                    while((unwrappedType == null ? void 0 : unwrappedType.kind) === 195 /* ParenthesizedType */ )unwrappedType = unwrappedType.type;
                    const hasJSDocFunctionType = unwrappedType && isJSDocFunctionType(unwrappedType);
                    if (!allowAmbiguity && token() !== 39 /* EqualsGreaterThanToken */  && (hasJSDocFunctionType || token() !== 19 /* OpenBraceToken */ )) return void 0;
                    const lastToken = token();
                    const equalsGreaterThanToken = parseExpectedToken(39 /* EqualsGreaterThanToken */ );
                    const body = lastToken === 39 /* EqualsGreaterThanToken */  || lastToken === 19 /* OpenBraceToken */  ? parseArrowFunctionExpressionBody(some(modifiers, isAsyncModifier), allowReturnTypeInArrowFunction) : parseIdentifier();
                    if (!allowReturnTypeInArrowFunction && hasReturnColon) {
                        if (token() !== 59 /* ColonToken */ ) return void 0;
                    }
                    const node = factory2.createArrowFunction(modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseArrowFunctionExpressionBody(isAsync, allowReturnTypeInArrowFunction) {
                    if (token() === 19 /* OpenBraceToken */ ) return parseFunctionBlock(isAsync ? 2 /* Await */  : 0 /* None */ );
                    if (token() !== 27 /* SemicolonToken */  && token() !== 100 /* FunctionKeyword */  && token() !== 86 /* ClassKeyword */  && isStartOfStatement() && !isStartOfExpressionStatement()) return parseFunctionBlock(16 /* IgnoreMissingOpenBrace */  | (isAsync ? 2 /* Await */  : 0 /* None */ ));
                    const savedTopLevel = topLevel;
                    topLevel = false;
                    const node = isAsync ? doInAwaitContext(()=>parseAssignmentExpressionOrHigher(allowReturnTypeInArrowFunction)) : doOutsideOfAwaitContext(()=>parseAssignmentExpressionOrHigher(allowReturnTypeInArrowFunction));
                    topLevel = savedTopLevel;
                    return node;
                }
                function parseConditionalExpressionRest(leftOperand, pos, allowReturnTypeInArrowFunction) {
                    const questionToken = parseOptionalToken(58 /* QuestionToken */ );
                    if (!questionToken) return leftOperand;
                    let colonToken;
                    return finishNode(factory2.createConditionalExpression(leftOperand, questionToken, doOutsideOfContext(disallowInAndDecoratorContext, ()=>parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ false)), colonToken = parseExpectedToken(59 /* ColonToken */ ), nodeIsPresent(colonToken) ? parseAssignmentExpressionOrHigher(allowReturnTypeInArrowFunction) : createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ false, Diagnostics._0_expected, tokenToString(59 /* ColonToken */ ))), pos);
                }
                function parseBinaryExpressionOrHigher(precedence) {
                    const pos = getNodePos();
                    const leftOperand = parseUnaryExpressionOrHigher();
                    return parseBinaryExpressionRest(precedence, leftOperand, pos);
                }
                function isInOrOfKeyword(t) {
                    return t === 103 /* InKeyword */  || t === 164 /* OfKeyword */ ;
                }
                function parseBinaryExpressionRest(precedence, leftOperand, pos) {
                    while(true){
                        reScanGreaterToken();
                        const newPrecedence = getBinaryOperatorPrecedence(token());
                        const consumeCurrentOperator = token() === 43 /* AsteriskAsteriskToken */  ? newPrecedence >= precedence : newPrecedence > precedence;
                        if (!consumeCurrentOperator) break;
                        if (token() === 103 /* InKeyword */  && inDisallowInContext()) break;
                        if (token() === 130 /* AsKeyword */  || token() === 152 /* SatisfiesKeyword */ ) {
                            if (scanner2.hasPrecedingLineBreak()) break;
                            else {
                                const keywordKind = token();
                                nextToken();
                                leftOperand = keywordKind === 152 /* SatisfiesKeyword */  ? makeSatisfiesExpression(leftOperand, parseType()) : makeAsExpression(leftOperand, parseType());
                            }
                        } else leftOperand = makeBinaryExpression(leftOperand, parseTokenNode(), parseBinaryExpressionOrHigher(newPrecedence), pos);
                    }
                    return leftOperand;
                }
                function isBinaryOperator2() {
                    if (inDisallowInContext() && token() === 103 /* InKeyword */ ) return false;
                    return getBinaryOperatorPrecedence(token()) > 0;
                }
                function makeSatisfiesExpression(left, right) {
                    return finishNode(factory2.createSatisfiesExpression(left, right), left.pos);
                }
                function makeBinaryExpression(left, operatorToken, right, pos) {
                    return finishNode(factory2.createBinaryExpression(left, operatorToken, right), pos);
                }
                function makeAsExpression(left, right) {
                    return finishNode(factory2.createAsExpression(left, right), left.pos);
                }
                function parsePrefixUnaryExpression() {
                    const pos = getNodePos();
                    return finishNode(factory2.createPrefixUnaryExpression(token(), nextTokenAnd(parseSimpleUnaryExpression)), pos);
                }
                function parseDeleteExpression() {
                    const pos = getNodePos();
                    return finishNode(factory2.createDeleteExpression(nextTokenAnd(parseSimpleUnaryExpression)), pos);
                }
                function parseTypeOfExpression() {
                    const pos = getNodePos();
                    return finishNode(factory2.createTypeOfExpression(nextTokenAnd(parseSimpleUnaryExpression)), pos);
                }
                function parseVoidExpression() {
                    const pos = getNodePos();
                    return finishNode(factory2.createVoidExpression(nextTokenAnd(parseSimpleUnaryExpression)), pos);
                }
                function isAwaitExpression2() {
                    if (token() === 135 /* AwaitKeyword */ ) {
                        if (inAwaitContext()) return true;
                        return lookAhead(nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine);
                    }
                    return false;
                }
                function parseAwaitExpression() {
                    const pos = getNodePos();
                    return finishNode(factory2.createAwaitExpression(nextTokenAnd(parseSimpleUnaryExpression)), pos);
                }
                function parseUnaryExpressionOrHigher() {
                    if (isUpdateExpression()) {
                        const pos = getNodePos();
                        const updateExpression = parseUpdateExpression();
                        return token() === 43 /* AsteriskAsteriskToken */  ? parseBinaryExpressionRest(getBinaryOperatorPrecedence(token()), updateExpression, pos) : updateExpression;
                    }
                    const unaryOperator = token();
                    const simpleUnaryExpression = parseSimpleUnaryExpression();
                    if (token() === 43 /* AsteriskAsteriskToken */ ) {
                        const pos = skipTrivia(sourceText, simpleUnaryExpression.pos);
                        const { end: end  } = simpleUnaryExpression;
                        if (simpleUnaryExpression.kind === 215 /* TypeAssertionExpression */ ) parseErrorAt(pos, end, Diagnostics.A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses);
                        else {
                            Debug.assert(isKeywordOrPunctuation(unaryOperator));
                            parseErrorAt(pos, end, Diagnostics.An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses, tokenToString(unaryOperator));
                        }
                    }
                    return simpleUnaryExpression;
                }
                function parseSimpleUnaryExpression() {
                    switch(token()){
                        case 40 /* PlusToken */ :
                        case 41 /* MinusToken */ :
                        case 55 /* TildeToken */ :
                        case 54 /* ExclamationToken */ :
                            return parsePrefixUnaryExpression();
                        case 91 /* DeleteKeyword */ :
                            return parseDeleteExpression();
                        case 114 /* TypeOfKeyword */ :
                            return parseTypeOfExpression();
                        case 116 /* VoidKeyword */ :
                            return parseVoidExpression();
                        case 30 /* LessThanToken */ :
                            if (languageVariant === 1 /* JSX */ ) return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true, /*topInvalidNodePosition*/ void 0, /*openingTag*/ void 0, /*mustBeUnary*/ true);
                            return parseTypeAssertion();
                        case 135 /* AwaitKeyword */ :
                            if (isAwaitExpression2()) return parseAwaitExpression();
                        default:
                            return parseUpdateExpression();
                    }
                }
                function isUpdateExpression() {
                    switch(token()){
                        case 40 /* PlusToken */ :
                        case 41 /* MinusToken */ :
                        case 55 /* TildeToken */ :
                        case 54 /* ExclamationToken */ :
                        case 91 /* DeleteKeyword */ :
                        case 114 /* TypeOfKeyword */ :
                        case 116 /* VoidKeyword */ :
                        case 135 /* AwaitKeyword */ :
                            return false;
                        case 30 /* LessThanToken */ :
                            if (languageVariant !== 1 /* JSX */ ) return false;
                        default:
                            return true;
                    }
                }
                function parseUpdateExpression() {
                    if (token() === 46 /* PlusPlusToken */  || token() === 47 /* MinusMinusToken */ ) {
                        const pos = getNodePos();
                        return finishNode(factory2.createPrefixUnaryExpression(token(), nextTokenAnd(parseLeftHandSideExpressionOrHigher)), pos);
                    } else if (languageVariant === 1 /* JSX */  && token() === 30 /* LessThanToken */  && lookAhead(nextTokenIsIdentifierOrKeywordOrGreaterThan)) return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true);
                    const expression = parseLeftHandSideExpressionOrHigher();
                    Debug.assert(isLeftHandSideExpression(expression));
                    if ((token() === 46 /* PlusPlusToken */  || token() === 47 /* MinusMinusToken */ ) && !scanner2.hasPrecedingLineBreak()) {
                        const operator = token();
                        nextToken();
                        return finishNode(factory2.createPostfixUnaryExpression(expression, operator), expression.pos);
                    }
                    return expression;
                }
                function parseLeftHandSideExpressionOrHigher() {
                    const pos = getNodePos();
                    let expression;
                    if (token() === 102 /* ImportKeyword */ ) {
                        if (lookAhead(nextTokenIsOpenParenOrLessThan)) {
                            sourceFlags |= 2097152 /* PossiblyContainsDynamicImport */ ;
                            expression = parseTokenNode();
                        } else if (lookAhead(nextTokenIsDot)) {
                            nextToken();
                            nextToken();
                            expression = finishNode(factory2.createMetaProperty(102 /* ImportKeyword */ , parseIdentifierName()), pos);
                            sourceFlags |= 4194304 /* PossiblyContainsImportMeta */ ;
                        } else expression = parseMemberExpressionOrHigher();
                    } else expression = token() === 108 /* SuperKeyword */  ? parseSuperExpression() : parseMemberExpressionOrHigher();
                    return parseCallExpressionRest(pos, expression);
                }
                function parseMemberExpressionOrHigher() {
                    const pos = getNodePos();
                    const expression = parsePrimaryExpression();
                    return parseMemberExpressionRest(pos, expression, /*allowOptionalChain*/ true);
                }
                function parseSuperExpression() {
                    const pos = getNodePos();
                    let expression = parseTokenNode();
                    if (token() === 30 /* LessThanToken */ ) {
                        const startPos = getNodePos();
                        const typeArguments = tryParse(parseTypeArgumentsInExpression);
                        if (typeArguments !== void 0) {
                            parseErrorAt(startPos, getNodePos(), Diagnostics.super_may_not_use_type_arguments);
                            if (!isTemplateStartOfTaggedTemplate()) expression = factory2.createExpressionWithTypeArguments(expression, typeArguments);
                        }
                    }
                    if (token() === 21 /* OpenParenToken */  || token() === 25 /* DotToken */  || token() === 23 /* OpenBracketToken */ ) return expression;
                    parseExpectedToken(25 /* DotToken */ , Diagnostics.super_must_be_followed_by_an_argument_list_or_member_access);
                    return finishNode(factoryCreatePropertyAccessExpression(expression, parseRightSideOfDot(/*allowIdentifierNames*/ true, /*allowPrivateIdentifiers*/ true)), pos);
                }
                function parseJsxElementOrSelfClosingElementOrFragment(inExpressionContext, topInvalidNodePosition, openingTag, mustBeUnary = false) {
                    const pos = getNodePos();
                    const opening = parseJsxOpeningOrSelfClosingElementOrOpeningFragment(inExpressionContext);
                    let result;
                    if (opening.kind === 285 /* JsxOpeningElement */ ) {
                        let children = parseJsxChildren(opening);
                        let closingElement;
                        const lastChild = children[children.length - 1];
                        if ((lastChild == null ? void 0 : lastChild.kind) === 283 /* JsxElement */  && !tagNamesAreEquivalent(lastChild.openingElement.tagName, lastChild.closingElement.tagName) && tagNamesAreEquivalent(opening.tagName, lastChild.closingElement.tagName)) {
                            const end = lastChild.children.end;
                            const newLast = finishNode(factory2.createJsxElement(lastChild.openingElement, lastChild.children, finishNode(factory2.createJsxClosingElement(finishNode(factoryCreateIdentifier(""), end, end)), end, end)), lastChild.openingElement.pos, end);
                            children = createNodeArray([
                                ...children.slice(0, children.length - 1),
                                newLast
                            ], children.pos, end);
                            closingElement = lastChild.closingElement;
                        } else {
                            closingElement = parseJsxClosingElement(opening, inExpressionContext);
                            if (!tagNamesAreEquivalent(opening.tagName, closingElement.tagName)) {
                                if (openingTag && isJsxOpeningElement(openingTag) && tagNamesAreEquivalent(closingElement.tagName, openingTag.tagName)) parseErrorAtRange(opening.tagName, Diagnostics.JSX_element_0_has_no_corresponding_closing_tag, getTextOfNodeFromSourceText(sourceText, opening.tagName));
                                else parseErrorAtRange(closingElement.tagName, Diagnostics.Expected_corresponding_JSX_closing_tag_for_0, getTextOfNodeFromSourceText(sourceText, opening.tagName));
                            }
                        }
                        result = finishNode(factory2.createJsxElement(opening, children, closingElement), pos);
                    } else if (opening.kind === 288 /* JsxOpeningFragment */ ) result = finishNode(factory2.createJsxFragment(opening, parseJsxChildren(opening), parseJsxClosingFragment(inExpressionContext)), pos);
                    else {
                        Debug.assert(opening.kind === 284 /* JsxSelfClosingElement */ );
                        result = opening;
                    }
                    if (!mustBeUnary && inExpressionContext && token() === 30 /* LessThanToken */ ) {
                        const topBadPos = typeof topInvalidNodePosition === "undefined" ? result.pos : topInvalidNodePosition;
                        const invalidElement = tryParse(()=>parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true, topBadPos));
                        if (invalidElement) {
                            const operatorToken = createMissingNode(28 /* CommaToken */ , /*reportAtCurrentPosition*/ false);
                            setTextRangePosWidth(operatorToken, invalidElement.pos, 0);
                            parseErrorAt(skipTrivia(sourceText, topBadPos), invalidElement.end, Diagnostics.JSX_expressions_must_have_one_parent_element);
                            return finishNode(factory2.createBinaryExpression(result, operatorToken, invalidElement), pos);
                        }
                    }
                    return result;
                }
                function parseJsxText() {
                    const pos = getNodePos();
                    const node = factory2.createJsxText(scanner2.getTokenValue(), currentToken === 13 /* JsxTextAllWhiteSpaces */ );
                    currentToken = scanner2.scanJsxToken();
                    return finishNode(node, pos);
                }
                function parseJsxChild(openingTag, token2) {
                    switch(token2){
                        case 1 /* EndOfFileToken */ :
                            if (isJsxOpeningFragment(openingTag)) parseErrorAtRange(openingTag, Diagnostics.JSX_fragment_has_no_corresponding_closing_tag);
                            else {
                                const tag = openingTag.tagName;
                                const start = Math.min(skipTrivia(sourceText, tag.pos), tag.end);
                                parseErrorAt(start, tag.end, Diagnostics.JSX_element_0_has_no_corresponding_closing_tag, getTextOfNodeFromSourceText(sourceText, openingTag.tagName));
                            }
                            return void 0;
                        case 31 /* LessThanSlashToken */ :
                        case 7 /* ConflictMarkerTrivia */ :
                            return void 0;
                        case 12 /* JsxText */ :
                        case 13 /* JsxTextAllWhiteSpaces */ :
                            return parseJsxText();
                        case 19 /* OpenBraceToken */ :
                            return parseJsxExpression(/*inExpressionContext*/ false);
                        case 30 /* LessThanToken */ :
                            return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ false, /*topInvalidNodePosition*/ void 0, openingTag);
                        default:
                            return Debug.assertNever(token2);
                    }
                }
                function parseJsxChildren(openingTag) {
                    const list = [];
                    const listPos = getNodePos();
                    const saveParsingContext = parsingContext;
                    parsingContext |= 16384 /* JsxChildren */ ;
                    while(true){
                        const child = parseJsxChild(openingTag, currentToken = scanner2.reScanJsxToken());
                        if (!child) break;
                        list.push(child);
                        if (isJsxOpeningElement(openingTag) && (child == null ? void 0 : child.kind) === 283 /* JsxElement */  && !tagNamesAreEquivalent(child.openingElement.tagName, child.closingElement.tagName) && tagNamesAreEquivalent(openingTag.tagName, child.closingElement.tagName)) break;
                    }
                    parsingContext = saveParsingContext;
                    return createNodeArray(list, listPos);
                }
                function parseJsxAttributes() {
                    const pos = getNodePos();
                    return finishNode(factory2.createJsxAttributes(parseList(13 /* JsxAttributes */ , parseJsxAttribute)), pos);
                }
                function parseJsxOpeningOrSelfClosingElementOrOpeningFragment(inExpressionContext) {
                    const pos = getNodePos();
                    parseExpected(30 /* LessThanToken */ );
                    if (token() === 32 /* GreaterThanToken */ ) {
                        scanJsxText();
                        return finishNode(factory2.createJsxOpeningFragment(), pos);
                    }
                    const tagName = parseJsxElementName();
                    const typeArguments = (contextFlags & 262144 /* JavaScriptFile */ ) === 0 ? tryParseTypeArguments() : void 0;
                    const attributes = parseJsxAttributes();
                    let node;
                    if (token() === 32 /* GreaterThanToken */ ) {
                        scanJsxText();
                        node = factory2.createJsxOpeningElement(tagName, typeArguments, attributes);
                    } else {
                        parseExpected(44 /* SlashToken */ );
                        if (parseExpected(32 /* GreaterThanToken */ , /*diagnosticMessage*/ void 0, /*shouldAdvance*/ false)) {
                            if (inExpressionContext) nextToken();
                            else scanJsxText();
                        }
                        node = factory2.createJsxSelfClosingElement(tagName, typeArguments, attributes);
                    }
                    return finishNode(node, pos);
                }
                function parseJsxElementName() {
                    const pos = getNodePos();
                    const initialExpression = parseJsxTagName();
                    if (isJsxNamespacedName(initialExpression)) return initialExpression;
                    let expression = initialExpression;
                    while(parseOptional(25 /* DotToken */ ))expression = finishNode(factoryCreatePropertyAccessExpression(expression, parseRightSideOfDot(/*allowIdentifierNames*/ true, /*allowPrivateIdentifiers*/ false)), pos);
                    return expression;
                }
                function parseJsxTagName() {
                    const pos = getNodePos();
                    scanJsxIdentifier();
                    const isThis2 = token() === 110 /* ThisKeyword */ ;
                    const tagName = parseIdentifierName();
                    if (parseOptional(59 /* ColonToken */ )) {
                        scanJsxIdentifier();
                        return finishNode(factory2.createJsxNamespacedName(tagName, parseIdentifierName()), pos);
                    }
                    return isThis2 ? finishNode(factory2.createToken(110 /* ThisKeyword */ ), pos) : tagName;
                }
                function parseJsxExpression(inExpressionContext) {
                    const pos = getNodePos();
                    if (!parseExpected(19 /* OpenBraceToken */ )) return void 0;
                    let dotDotDotToken;
                    let expression;
                    if (token() !== 20 /* CloseBraceToken */ ) {
                        dotDotDotToken = parseOptionalToken(26 /* DotDotDotToken */ );
                        expression = parseExpression();
                    }
                    if (inExpressionContext) parseExpected(20 /* CloseBraceToken */ );
                    else if (parseExpected(20 /* CloseBraceToken */ , /*diagnosticMessage*/ void 0, /*shouldAdvance*/ false)) scanJsxText();
                    return finishNode(factory2.createJsxExpression(dotDotDotToken, expression), pos);
                }
                function parseJsxAttribute() {
                    if (token() === 19 /* OpenBraceToken */ ) return parseJsxSpreadAttribute();
                    const pos = getNodePos();
                    return finishNode(factory2.createJsxAttribute(parseJsxAttributeName(), parseJsxAttributeValue()), pos);
                }
                function parseJsxAttributeValue() {
                    if (token() === 64 /* EqualsToken */ ) {
                        if (scanJsxAttributeValue() === 11 /* StringLiteral */ ) return parseLiteralNode();
                        if (token() === 19 /* OpenBraceToken */ ) return parseJsxExpression(/*inExpressionContext*/ true);
                        if (token() === 30 /* LessThanToken */ ) return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true);
                        parseErrorAtCurrentToken(Diagnostics.or_JSX_element_expected);
                    }
                    return void 0;
                }
                function parseJsxAttributeName() {
                    const pos = getNodePos();
                    scanJsxIdentifier();
                    const attrName = parseIdentifierName();
                    if (parseOptional(59 /* ColonToken */ )) {
                        scanJsxIdentifier();
                        return finishNode(factory2.createJsxNamespacedName(attrName, parseIdentifierName()), pos);
                    }
                    return attrName;
                }
                function parseJsxSpreadAttribute() {
                    const pos = getNodePos();
                    parseExpected(19 /* OpenBraceToken */ );
                    parseExpected(26 /* DotDotDotToken */ );
                    const expression = parseExpression();
                    parseExpected(20 /* CloseBraceToken */ );
                    return finishNode(factory2.createJsxSpreadAttribute(expression), pos);
                }
                function parseJsxClosingElement(open, inExpressionContext) {
                    const pos = getNodePos();
                    parseExpected(31 /* LessThanSlashToken */ );
                    const tagName = parseJsxElementName();
                    if (parseExpected(32 /* GreaterThanToken */ , /*diagnosticMessage*/ void 0, /*shouldAdvance*/ false)) {
                        if (inExpressionContext || !tagNamesAreEquivalent(open.tagName, tagName)) nextToken();
                        else scanJsxText();
                    }
                    return finishNode(factory2.createJsxClosingElement(tagName), pos);
                }
                function parseJsxClosingFragment(inExpressionContext) {
                    const pos = getNodePos();
                    parseExpected(31 /* LessThanSlashToken */ );
                    if (parseExpected(32 /* GreaterThanToken */ , Diagnostics.Expected_corresponding_closing_tag_for_JSX_fragment, /*shouldAdvance*/ false)) {
                        if (inExpressionContext) nextToken();
                        else scanJsxText();
                    }
                    return finishNode(factory2.createJsxJsxClosingFragment(), pos);
                }
                function parseTypeAssertion() {
                    Debug.assert(languageVariant !== 1 /* JSX */ , "Type assertions should never be parsed in JSX; they should be parsed as comparisons or JSX elements/fragments.");
                    const pos = getNodePos();
                    parseExpected(30 /* LessThanToken */ );
                    const type = parseType();
                    parseExpected(32 /* GreaterThanToken */ );
                    const expression = parseSimpleUnaryExpression();
                    return finishNode(factory2.createTypeAssertion(type, expression), pos);
                }
                function nextTokenIsIdentifierOrKeywordOrOpenBracketOrTemplate() {
                    nextToken();
                    return tokenIsIdentifierOrKeyword(token()) || token() === 23 /* OpenBracketToken */  || isTemplateStartOfTaggedTemplate();
                }
                function isStartOfOptionalPropertyOrElementAccessChain() {
                    return token() === 29 /* QuestionDotToken */  && lookAhead(nextTokenIsIdentifierOrKeywordOrOpenBracketOrTemplate);
                }
                function tryReparseOptionalChain(node) {
                    if (node.flags & 32 /* OptionalChain */ ) return true;
                    if (isNonNullExpression(node)) {
                        let expr = node.expression;
                        while(isNonNullExpression(expr) && !(expr.flags & 32 /* OptionalChain */ ))expr = expr.expression;
                        if (expr.flags & 32 /* OptionalChain */ ) {
                            while(isNonNullExpression(node)){
                                node.flags |= 32 /* OptionalChain */ ;
                                node = node.expression;
                            }
                            return true;
                        }
                    }
                    return false;
                }
                function parsePropertyAccessExpressionRest(pos, expression, questionDotToken) {
                    const name = parseRightSideOfDot(/*allowIdentifierNames*/ true, /*allowPrivateIdentifiers*/ true);
                    const isOptionalChain2 = questionDotToken || tryReparseOptionalChain(expression);
                    const propertyAccess = isOptionalChain2 ? factoryCreatePropertyAccessChain(expression, questionDotToken, name) : factoryCreatePropertyAccessExpression(expression, name);
                    if (isOptionalChain2 && isPrivateIdentifier(propertyAccess.name)) parseErrorAtRange(propertyAccess.name, Diagnostics.An_optional_chain_cannot_contain_private_identifiers);
                    if (isExpressionWithTypeArguments(expression) && expression.typeArguments) {
                        const pos2 = expression.typeArguments.pos - 1;
                        const end = skipTrivia(sourceText, expression.typeArguments.end) + 1;
                        parseErrorAt(pos2, end, Diagnostics.An_instantiation_expression_cannot_be_followed_by_a_property_access);
                    }
                    return finishNode(propertyAccess, pos);
                }
                function parseElementAccessExpressionRest(pos, expression, questionDotToken) {
                    let argumentExpression;
                    if (token() === 24 /* CloseBracketToken */ ) argumentExpression = createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ true, Diagnostics.An_element_access_expression_should_take_an_argument);
                    else {
                        const argument = allowInAnd(parseExpression);
                        if (isStringOrNumericLiteralLike(argument)) argument.text = internIdentifier(argument.text);
                        argumentExpression = argument;
                    }
                    parseExpected(24 /* CloseBracketToken */ );
                    const indexedAccess = questionDotToken || tryReparseOptionalChain(expression) ? factoryCreateElementAccessChain(expression, questionDotToken, argumentExpression) : factoryCreateElementAccessExpression(expression, argumentExpression);
                    return finishNode(indexedAccess, pos);
                }
                function parseMemberExpressionRest(pos, expression, allowOptionalChain) {
                    while(true){
                        let questionDotToken;
                        let isPropertyAccess = false;
                        if (allowOptionalChain && isStartOfOptionalPropertyOrElementAccessChain()) {
                            questionDotToken = parseExpectedToken(29 /* QuestionDotToken */ );
                            isPropertyAccess = tokenIsIdentifierOrKeyword(token());
                        } else isPropertyAccess = parseOptional(25 /* DotToken */ );
                        if (isPropertyAccess) {
                            expression = parsePropertyAccessExpressionRest(pos, expression, questionDotToken);
                            continue;
                        }
                        if ((questionDotToken || !inDecoratorContext()) && parseOptional(23 /* OpenBracketToken */ )) {
                            expression = parseElementAccessExpressionRest(pos, expression, questionDotToken);
                            continue;
                        }
                        if (isTemplateStartOfTaggedTemplate()) {
                            expression = !questionDotToken && expression.kind === 232 /* ExpressionWithTypeArguments */  ? parseTaggedTemplateRest(pos, expression.expression, questionDotToken, expression.typeArguments) : parseTaggedTemplateRest(pos, expression, questionDotToken, /*typeArguments*/ void 0);
                            continue;
                        }
                        if (!questionDotToken) {
                            if (token() === 54 /* ExclamationToken */  && !scanner2.hasPrecedingLineBreak()) {
                                nextToken();
                                expression = finishNode(factory2.createNonNullExpression(expression), pos);
                                continue;
                            }
                            const typeArguments = tryParse(parseTypeArgumentsInExpression);
                            if (typeArguments) {
                                expression = finishNode(factory2.createExpressionWithTypeArguments(expression, typeArguments), pos);
                                continue;
                            }
                        }
                        return expression;
                    }
                }
                function isTemplateStartOfTaggedTemplate() {
                    return token() === 15 /* NoSubstitutionTemplateLiteral */  || token() === 16 /* TemplateHead */ ;
                }
                function parseTaggedTemplateRest(pos, tag, questionDotToken, typeArguments) {
                    const tagExpression = factory2.createTaggedTemplateExpression(tag, typeArguments, token() === 15 /* NoSubstitutionTemplateLiteral */  ? (reScanTemplateToken(/*isTaggedTemplate*/ true), parseLiteralNode()) : parseTemplateExpression(/*isTaggedTemplate*/ true));
                    if (questionDotToken || tag.flags & 32 /* OptionalChain */ ) tagExpression.flags |= 32 /* OptionalChain */ ;
                    tagExpression.questionDotToken = questionDotToken;
                    return finishNode(tagExpression, pos);
                }
                function parseCallExpressionRest(pos, expression) {
                    while(true){
                        expression = parseMemberExpressionRest(pos, expression, /*allowOptionalChain*/ true);
                        let typeArguments;
                        const questionDotToken = parseOptionalToken(29 /* QuestionDotToken */ );
                        if (questionDotToken) {
                            typeArguments = tryParse(parseTypeArgumentsInExpression);
                            if (isTemplateStartOfTaggedTemplate()) {
                                expression = parseTaggedTemplateRest(pos, expression, questionDotToken, typeArguments);
                                continue;
                            }
                        }
                        if (typeArguments || token() === 21 /* OpenParenToken */ ) {
                            if (!questionDotToken && expression.kind === 232 /* ExpressionWithTypeArguments */ ) {
                                typeArguments = expression.typeArguments;
                                expression = expression.expression;
                            }
                            const argumentList = parseArgumentList();
                            const callExpr = questionDotToken || tryReparseOptionalChain(expression) ? factoryCreateCallChain(expression, questionDotToken, typeArguments, argumentList) : factoryCreateCallExpression(expression, typeArguments, argumentList);
                            expression = finishNode(callExpr, pos);
                            continue;
                        }
                        if (questionDotToken) {
                            const name = createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ false, Diagnostics.Identifier_expected);
                            expression = finishNode(factoryCreatePropertyAccessChain(expression, questionDotToken, name), pos);
                        }
                        break;
                    }
                    return expression;
                }
                function parseArgumentList() {
                    parseExpected(21 /* OpenParenToken */ );
                    const result = parseDelimitedList(11 /* ArgumentExpressions */ , parseArgumentExpression);
                    parseExpected(22 /* CloseParenToken */ );
                    return result;
                }
                function parseTypeArgumentsInExpression() {
                    if ((contextFlags & 262144 /* JavaScriptFile */ ) !== 0) return void 0;
                    if (reScanLessThanToken() !== 30 /* LessThanToken */ ) return void 0;
                    nextToken();
                    const typeArguments = parseDelimitedList(20 /* TypeArguments */ , parseType);
                    if (reScanGreaterToken() !== 32 /* GreaterThanToken */ ) return void 0;
                    nextToken();
                    return typeArguments && canFollowTypeArgumentsInExpression() ? typeArguments : void 0;
                }
                function canFollowTypeArgumentsInExpression() {
                    switch(token()){
                        case 21 /* OpenParenToken */ :
                        case 15 /* NoSubstitutionTemplateLiteral */ :
                        case 16 /* TemplateHead */ :
                            return true;
                        case 30 /* LessThanToken */ :
                        case 32 /* GreaterThanToken */ :
                        case 40 /* PlusToken */ :
                        case 41 /* MinusToken */ :
                            return false;
                    }
                    return scanner2.hasPrecedingLineBreak() || isBinaryOperator2() || !isStartOfExpression();
                }
                function parsePrimaryExpression() {
                    switch(token()){
                        case 15 /* NoSubstitutionTemplateLiteral */ :
                            if (scanner2.getTokenFlags() & 26656 /* IsInvalid */ ) reScanTemplateToken(/*isTaggedTemplate*/ false);
                        case 9 /* NumericLiteral */ :
                        case 10 /* BigIntLiteral */ :
                        case 11 /* StringLiteral */ :
                            return parseLiteralNode();
                        case 110 /* ThisKeyword */ :
                        case 108 /* SuperKeyword */ :
                        case 106 /* NullKeyword */ :
                        case 112 /* TrueKeyword */ :
                        case 97 /* FalseKeyword */ :
                            return parseTokenNode();
                        case 21 /* OpenParenToken */ :
                            return parseParenthesizedExpression();
                        case 23 /* OpenBracketToken */ :
                            return parseArrayLiteralExpression();
                        case 19 /* OpenBraceToken */ :
                            return parseObjectLiteralExpression();
                        case 134 /* AsyncKeyword */ :
                            if (!lookAhead(nextTokenIsFunctionKeywordOnSameLine)) break;
                            return parseFunctionExpression();
                        case 60 /* AtToken */ :
                            return parseDecoratedExpression();
                        case 86 /* ClassKeyword */ :
                            return parseClassExpression();
                        case 100 /* FunctionKeyword */ :
                            return parseFunctionExpression();
                        case 105 /* NewKeyword */ :
                            return parseNewExpressionOrNewDotTarget();
                        case 44 /* SlashToken */ :
                        case 69 /* SlashEqualsToken */ :
                            if (reScanSlashToken() === 14 /* RegularExpressionLiteral */ ) return parseLiteralNode();
                            break;
                        case 16 /* TemplateHead */ :
                            return parseTemplateExpression(/*isTaggedTemplate*/ false);
                        case 81 /* PrivateIdentifier */ :
                            return parsePrivateIdentifier();
                    }
                    return parseIdentifier(Diagnostics.Expression_expected);
                }
                function parseParenthesizedExpression() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(21 /* OpenParenToken */ );
                    const expression = allowInAnd(parseExpression);
                    parseExpected(22 /* CloseParenToken */ );
                    return withJSDoc(finishNode(factoryCreateParenthesizedExpression(expression), pos), hasJSDoc);
                }
                function parseSpreadElement() {
                    const pos = getNodePos();
                    parseExpected(26 /* DotDotDotToken */ );
                    const expression = parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
                    return finishNode(factory2.createSpreadElement(expression), pos);
                }
                function parseArgumentOrArrayLiteralElement() {
                    return token() === 26 /* DotDotDotToken */  ? parseSpreadElement() : token() === 28 /* CommaToken */  ? finishNode(factory2.createOmittedExpression(), getNodePos()) : parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
                }
                function parseArgumentExpression() {
                    return doOutsideOfContext(disallowInAndDecoratorContext, parseArgumentOrArrayLiteralElement);
                }
                function parseArrayLiteralExpression() {
                    const pos = getNodePos();
                    const openBracketPosition = scanner2.getTokenStart();
                    const openBracketParsed = parseExpected(23 /* OpenBracketToken */ );
                    const multiLine = scanner2.hasPrecedingLineBreak();
                    const elements = parseDelimitedList(15 /* ArrayLiteralMembers */ , parseArgumentOrArrayLiteralElement);
                    parseExpectedMatchingBrackets(23 /* OpenBracketToken */ , 24 /* CloseBracketToken */ , openBracketParsed, openBracketPosition);
                    return finishNode(factoryCreateArrayLiteralExpression(elements, multiLine), pos);
                }
                function parseObjectLiteralElement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    if (parseOptionalToken(26 /* DotDotDotToken */ )) {
                        const expression = parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
                        return withJSDoc(finishNode(factory2.createSpreadAssignment(expression), pos), hasJSDoc);
                    }
                    const modifiers = parseModifiers(/*allowDecorators*/ true);
                    if (parseContextualModifier(139 /* GetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 176 /* GetAccessor */ , 0 /* None */ );
                    if (parseContextualModifier(153 /* SetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 177 /* SetAccessor */ , 0 /* None */ );
                    const asteriskToken = parseOptionalToken(42 /* AsteriskToken */ );
                    const tokenIsIdentifier = isIdentifier2();
                    const name = parsePropertyName();
                    const questionToken = parseOptionalToken(58 /* QuestionToken */ );
                    const exclamationToken = parseOptionalToken(54 /* ExclamationToken */ );
                    if (asteriskToken || token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */ ) return parseMethodDeclaration(pos, hasJSDoc, modifiers, asteriskToken, name, questionToken, exclamationToken);
                    let node;
                    const isShorthandPropertyAssignment2 = tokenIsIdentifier && token() !== 59 /* ColonToken */ ;
                    if (isShorthandPropertyAssignment2) {
                        const equalsToken = parseOptionalToken(64 /* EqualsToken */ );
                        const objectAssignmentInitializer = equalsToken ? allowInAnd(()=>parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true)) : void 0;
                        node = factory2.createShorthandPropertyAssignment(name, objectAssignmentInitializer);
                        node.equalsToken = equalsToken;
                    } else {
                        parseExpected(59 /* ColonToken */ );
                        const initializer = allowInAnd(()=>parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true));
                        node = factory2.createPropertyAssignment(name, initializer);
                    }
                    node.modifiers = modifiers;
                    node.questionToken = questionToken;
                    node.exclamationToken = exclamationToken;
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseObjectLiteralExpression() {
                    const pos = getNodePos();
                    const openBracePosition = scanner2.getTokenStart();
                    const openBraceParsed = parseExpected(19 /* OpenBraceToken */ );
                    const multiLine = scanner2.hasPrecedingLineBreak();
                    const properties = parseDelimitedList(12 /* ObjectLiteralMembers */ , parseObjectLiteralElement, /*considerSemicolonAsDelimiter*/ true);
                    parseExpectedMatchingBrackets(19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , openBraceParsed, openBracePosition);
                    return finishNode(factoryCreateObjectLiteralExpression(properties, multiLine), pos);
                }
                function parseFunctionExpression() {
                    const savedDecoratorContext = inDecoratorContext();
                    setDecoratorContext(/*val*/ false);
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    const modifiers = parseModifiers(/*allowDecorators*/ false);
                    parseExpected(100 /* FunctionKeyword */ );
                    const asteriskToken = parseOptionalToken(42 /* AsteriskToken */ );
                    const isGenerator = asteriskToken ? 1 /* Yield */  : 0 /* None */ ;
                    const isAsync = some(modifiers, isAsyncModifier) ? 2 /* Await */  : 0 /* None */ ;
                    const name = isGenerator && isAsync ? doInYieldAndAwaitContext(parseOptionalBindingIdentifier) : isGenerator ? doInYieldContext(parseOptionalBindingIdentifier) : isAsync ? doInAwaitContext(parseOptionalBindingIdentifier) : parseOptionalBindingIdentifier();
                    const typeParameters = parseTypeParameters();
                    const parameters = parseParameters(isGenerator | isAsync);
                    const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
                    const body = parseFunctionBlock(isGenerator | isAsync);
                    setDecoratorContext(savedDecoratorContext);
                    const node = factory2.createFunctionExpression(modifiers, asteriskToken, name, typeParameters, parameters, type, body);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseOptionalBindingIdentifier() {
                    return isBindingIdentifier() ? parseBindingIdentifier() : void 0;
                }
                function parseNewExpressionOrNewDotTarget() {
                    const pos = getNodePos();
                    parseExpected(105 /* NewKeyword */ );
                    if (parseOptional(25 /* DotToken */ )) {
                        const name = parseIdentifierName();
                        return finishNode(factory2.createMetaProperty(105 /* NewKeyword */ , name), pos);
                    }
                    const expressionPos = getNodePos();
                    let expression = parseMemberExpressionRest(expressionPos, parsePrimaryExpression(), /*allowOptionalChain*/ false);
                    let typeArguments;
                    if (expression.kind === 232 /* ExpressionWithTypeArguments */ ) {
                        typeArguments = expression.typeArguments;
                        expression = expression.expression;
                    }
                    if (token() === 29 /* QuestionDotToken */ ) parseErrorAtCurrentToken(Diagnostics.Invalid_optional_chain_from_new_expression_Did_you_mean_to_call_0, getTextOfNodeFromSourceText(sourceText, expression));
                    const argumentList = token() === 21 /* OpenParenToken */  ? parseArgumentList() : void 0;
                    return finishNode(factoryCreateNewExpression(expression, typeArguments, argumentList), pos);
                }
                function parseBlock(ignoreMissingOpenBrace, diagnosticMessage) {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    const openBracePosition = scanner2.getTokenStart();
                    const openBraceParsed = parseExpected(19 /* OpenBraceToken */ , diagnosticMessage);
                    if (openBraceParsed || ignoreMissingOpenBrace) {
                        const multiLine = scanner2.hasPrecedingLineBreak();
                        const statements = parseList(1 /* BlockStatements */ , parseStatement);
                        parseExpectedMatchingBrackets(19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , openBraceParsed, openBracePosition);
                        const result = withJSDoc(finishNode(factoryCreateBlock(statements, multiLine), pos), hasJSDoc);
                        if (token() === 64 /* EqualsToken */ ) {
                            parseErrorAtCurrentToken(Diagnostics.Declaration_or_statement_expected_This_follows_a_block_of_statements_so_if_you_intended_to_write_a_destructuring_assignment_you_might_need_to_wrap_the_whole_assignment_in_parentheses);
                            nextToken();
                        }
                        return result;
                    } else {
                        const statements = createMissingList();
                        return withJSDoc(finishNode(factoryCreateBlock(statements, /*multiLine*/ void 0), pos), hasJSDoc);
                    }
                }
                function parseFunctionBlock(flags, diagnosticMessage) {
                    const savedYieldContext = inYieldContext();
                    setYieldContext(!!(flags & 1 /* Yield */ ));
                    const savedAwaitContext = inAwaitContext();
                    setAwaitContext(!!(flags & 2 /* Await */ ));
                    const savedTopLevel = topLevel;
                    topLevel = false;
                    const saveDecoratorContext = inDecoratorContext();
                    if (saveDecoratorContext) setDecoratorContext(/*val*/ false);
                    const block = parseBlock(!!(flags & 16 /* IgnoreMissingOpenBrace */ ), diagnosticMessage);
                    if (saveDecoratorContext) setDecoratorContext(/*val*/ true);
                    topLevel = savedTopLevel;
                    setYieldContext(savedYieldContext);
                    setAwaitContext(savedAwaitContext);
                    return block;
                }
                function parseEmptyStatement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(27 /* SemicolonToken */ );
                    return withJSDoc(finishNode(factory2.createEmptyStatement(), pos), hasJSDoc);
                }
                function parseIfStatement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(101 /* IfKeyword */ );
                    const openParenPosition = scanner2.getTokenStart();
                    const openParenParsed = parseExpected(21 /* OpenParenToken */ );
                    const expression = allowInAnd(parseExpression);
                    parseExpectedMatchingBrackets(21 /* OpenParenToken */ , 22 /* CloseParenToken */ , openParenParsed, openParenPosition);
                    const thenStatement = parseStatement();
                    const elseStatement = parseOptional(93 /* ElseKeyword */ ) ? parseStatement() : void 0;
                    return withJSDoc(finishNode(factoryCreateIfStatement(expression, thenStatement, elseStatement), pos), hasJSDoc);
                }
                function parseDoStatement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(92 /* DoKeyword */ );
                    const statement = parseStatement();
                    parseExpected(117 /* WhileKeyword */ );
                    const openParenPosition = scanner2.getTokenStart();
                    const openParenParsed = parseExpected(21 /* OpenParenToken */ );
                    const expression = allowInAnd(parseExpression);
                    parseExpectedMatchingBrackets(21 /* OpenParenToken */ , 22 /* CloseParenToken */ , openParenParsed, openParenPosition);
                    parseOptional(27 /* SemicolonToken */ );
                    return withJSDoc(finishNode(factory2.createDoStatement(statement, expression), pos), hasJSDoc);
                }
                function parseWhileStatement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(117 /* WhileKeyword */ );
                    const openParenPosition = scanner2.getTokenStart();
                    const openParenParsed = parseExpected(21 /* OpenParenToken */ );
                    const expression = allowInAnd(parseExpression);
                    parseExpectedMatchingBrackets(21 /* OpenParenToken */ , 22 /* CloseParenToken */ , openParenParsed, openParenPosition);
                    const statement = parseStatement();
                    return withJSDoc(finishNode(factoryCreateWhileStatement(expression, statement), pos), hasJSDoc);
                }
                function parseForOrForInOrForOfStatement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(99 /* ForKeyword */ );
                    const awaitToken = parseOptionalToken(135 /* AwaitKeyword */ );
                    parseExpected(21 /* OpenParenToken */ );
                    let initializer;
                    if (token() !== 27 /* SemicolonToken */ ) {
                        if (token() === 115 /* VarKeyword */  || token() === 121 /* LetKeyword */  || token() === 87 /* ConstKeyword */ ) initializer = parseVariableDeclarationList(/*inForStatementInitializer*/ true);
                        else initializer = disallowInAnd(parseExpression);
                    }
                    let node;
                    if (awaitToken ? parseExpected(164 /* OfKeyword */ ) : parseOptional(164 /* OfKeyword */ )) {
                        const expression = allowInAnd(()=>parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true));
                        parseExpected(22 /* CloseParenToken */ );
                        node = factoryCreateForOfStatement(awaitToken, initializer, expression, parseStatement());
                    } else if (parseOptional(103 /* InKeyword */ )) {
                        const expression = allowInAnd(parseExpression);
                        parseExpected(22 /* CloseParenToken */ );
                        node = factory2.createForInStatement(initializer, expression, parseStatement());
                    } else {
                        parseExpected(27 /* SemicolonToken */ );
                        const condition = token() !== 27 /* SemicolonToken */  && token() !== 22 /* CloseParenToken */  ? allowInAnd(parseExpression) : void 0;
                        parseExpected(27 /* SemicolonToken */ );
                        const incrementor = token() !== 22 /* CloseParenToken */  ? allowInAnd(parseExpression) : void 0;
                        parseExpected(22 /* CloseParenToken */ );
                        node = factoryCreateForStatement(initializer, condition, incrementor, parseStatement());
                    }
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseBreakOrContinueStatement(kind) {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(kind === 251 /* BreakStatement */  ? 83 /* BreakKeyword */  : 88 /* ContinueKeyword */ );
                    const label = canParseSemicolon() ? void 0 : parseIdentifier();
                    parseSemicolon();
                    const node = kind === 251 /* BreakStatement */  ? factory2.createBreakStatement(label) : factory2.createContinueStatement(label);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseReturnStatement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(107 /* ReturnKeyword */ );
                    const expression = canParseSemicolon() ? void 0 : allowInAnd(parseExpression);
                    parseSemicolon();
                    return withJSDoc(finishNode(factory2.createReturnStatement(expression), pos), hasJSDoc);
                }
                function parseWithStatement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(118 /* WithKeyword */ );
                    const openParenPosition = scanner2.getTokenStart();
                    const openParenParsed = parseExpected(21 /* OpenParenToken */ );
                    const expression = allowInAnd(parseExpression);
                    parseExpectedMatchingBrackets(21 /* OpenParenToken */ , 22 /* CloseParenToken */ , openParenParsed, openParenPosition);
                    const statement = doInsideOfContext(33554432 /* InWithStatement */ , parseStatement);
                    return withJSDoc(finishNode(factory2.createWithStatement(expression, statement), pos), hasJSDoc);
                }
                function parseCaseClause() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(84 /* CaseKeyword */ );
                    const expression = allowInAnd(parseExpression);
                    parseExpected(59 /* ColonToken */ );
                    const statements = parseList(3 /* SwitchClauseStatements */ , parseStatement);
                    return withJSDoc(finishNode(factory2.createCaseClause(expression, statements), pos), hasJSDoc);
                }
                function parseDefaultClause() {
                    const pos = getNodePos();
                    parseExpected(90 /* DefaultKeyword */ );
                    parseExpected(59 /* ColonToken */ );
                    const statements = parseList(3 /* SwitchClauseStatements */ , parseStatement);
                    return finishNode(factory2.createDefaultClause(statements), pos);
                }
                function parseCaseOrDefaultClause() {
                    return token() === 84 /* CaseKeyword */  ? parseCaseClause() : parseDefaultClause();
                }
                function parseCaseBlock() {
                    const pos = getNodePos();
                    parseExpected(19 /* OpenBraceToken */ );
                    const clauses = parseList(2 /* SwitchClauses */ , parseCaseOrDefaultClause);
                    parseExpected(20 /* CloseBraceToken */ );
                    return finishNode(factory2.createCaseBlock(clauses), pos);
                }
                function parseSwitchStatement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(109 /* SwitchKeyword */ );
                    parseExpected(21 /* OpenParenToken */ );
                    const expression = allowInAnd(parseExpression);
                    parseExpected(22 /* CloseParenToken */ );
                    const caseBlock = parseCaseBlock();
                    return withJSDoc(finishNode(factory2.createSwitchStatement(expression, caseBlock), pos), hasJSDoc);
                }
                function parseThrowStatement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(111 /* ThrowKeyword */ );
                    let expression = scanner2.hasPrecedingLineBreak() ? void 0 : allowInAnd(parseExpression);
                    if (expression === void 0) {
                        identifierCount++;
                        expression = finishNode(factoryCreateIdentifier(""), getNodePos());
                    }
                    if (!tryParseSemicolon()) parseErrorForMissingSemicolonAfter(expression);
                    return withJSDoc(finishNode(factory2.createThrowStatement(expression), pos), hasJSDoc);
                }
                function parseTryStatement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(113 /* TryKeyword */ );
                    const tryBlock = parseBlock(/*ignoreMissingOpenBrace*/ false);
                    const catchClause = token() === 85 /* CatchKeyword */  ? parseCatchClause() : void 0;
                    let finallyBlock;
                    if (!catchClause || token() === 98 /* FinallyKeyword */ ) {
                        parseExpected(98 /* FinallyKeyword */ , Diagnostics.catch_or_finally_expected);
                        finallyBlock = parseBlock(/*ignoreMissingOpenBrace*/ false);
                    }
                    return withJSDoc(finishNode(factory2.createTryStatement(tryBlock, catchClause, finallyBlock), pos), hasJSDoc);
                }
                function parseCatchClause() {
                    const pos = getNodePos();
                    parseExpected(85 /* CatchKeyword */ );
                    let variableDeclaration;
                    if (parseOptional(21 /* OpenParenToken */ )) {
                        variableDeclaration = parseVariableDeclaration();
                        parseExpected(22 /* CloseParenToken */ );
                    } else variableDeclaration = void 0;
                    const block = parseBlock(/*ignoreMissingOpenBrace*/ false);
                    return finishNode(factory2.createCatchClause(variableDeclaration, block), pos);
                }
                function parseDebuggerStatement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    parseExpected(89 /* DebuggerKeyword */ );
                    parseSemicolon();
                    return withJSDoc(finishNode(factory2.createDebuggerStatement(), pos), hasJSDoc);
                }
                function parseExpressionOrLabeledStatement() {
                    const pos = getNodePos();
                    let hasJSDoc = hasPrecedingJSDocComment();
                    let node;
                    const hasParen = token() === 21 /* OpenParenToken */ ;
                    const expression = allowInAnd(parseExpression);
                    if (isIdentifier(expression) && parseOptional(59 /* ColonToken */ )) node = factory2.createLabeledStatement(expression, parseStatement());
                    else {
                        if (!tryParseSemicolon()) parseErrorForMissingSemicolonAfter(expression);
                        node = factoryCreateExpressionStatement(expression);
                        if (hasParen) hasJSDoc = false;
                    }
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function nextTokenIsIdentifierOrKeywordOnSameLine() {
                    nextToken();
                    return tokenIsIdentifierOrKeyword(token()) && !scanner2.hasPrecedingLineBreak();
                }
                function nextTokenIsClassKeywordOnSameLine() {
                    nextToken();
                    return token() === 86 /* ClassKeyword */  && !scanner2.hasPrecedingLineBreak();
                }
                function nextTokenIsFunctionKeywordOnSameLine() {
                    nextToken();
                    return token() === 100 /* FunctionKeyword */  && !scanner2.hasPrecedingLineBreak();
                }
                function nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine() {
                    nextToken();
                    return (tokenIsIdentifierOrKeyword(token()) || token() === 9 /* NumericLiteral */  || token() === 10 /* BigIntLiteral */  || token() === 11 /* StringLiteral */ ) && !scanner2.hasPrecedingLineBreak();
                }
                function isDeclaration2() {
                    while(true)switch(token()){
                        case 115 /* VarKeyword */ :
                        case 121 /* LetKeyword */ :
                        case 87 /* ConstKeyword */ :
                        case 100 /* FunctionKeyword */ :
                        case 86 /* ClassKeyword */ :
                        case 94 /* EnumKeyword */ :
                            return true;
                        case 120 /* InterfaceKeyword */ :
                        case 156 /* TypeKeyword */ :
                            return nextTokenIsIdentifierOnSameLine();
                        case 144 /* ModuleKeyword */ :
                        case 145 /* NamespaceKeyword */ :
                            return nextTokenIsIdentifierOrStringLiteralOnSameLine();
                        case 128 /* AbstractKeyword */ :
                        case 129 /* AccessorKeyword */ :
                        case 134 /* AsyncKeyword */ :
                        case 138 /* DeclareKeyword */ :
                        case 123 /* PrivateKeyword */ :
                        case 124 /* ProtectedKeyword */ :
                        case 125 /* PublicKeyword */ :
                        case 148 /* ReadonlyKeyword */ :
                            nextToken();
                            if (scanner2.hasPrecedingLineBreak()) return false;
                            continue;
                        case 161 /* GlobalKeyword */ :
                            nextToken();
                            return token() === 19 /* OpenBraceToken */  || token() === 80 /* Identifier */  || token() === 95 /* ExportKeyword */ ;
                        case 102 /* ImportKeyword */ :
                            nextToken();
                            return token() === 11 /* StringLiteral */  || token() === 42 /* AsteriskToken */  || token() === 19 /* OpenBraceToken */  || tokenIsIdentifierOrKeyword(token());
                        case 95 /* ExportKeyword */ :
                            let currentToken2 = nextToken();
                            if (currentToken2 === 156 /* TypeKeyword */ ) currentToken2 = lookAhead(nextToken);
                            if (currentToken2 === 64 /* EqualsToken */  || currentToken2 === 42 /* AsteriskToken */  || currentToken2 === 19 /* OpenBraceToken */  || currentToken2 === 90 /* DefaultKeyword */  || currentToken2 === 130 /* AsKeyword */  || currentToken2 === 60 /* AtToken */ ) return true;
                            continue;
                        case 126 /* StaticKeyword */ :
                            nextToken();
                            continue;
                        default:
                            return false;
                    }
                }
                function isStartOfDeclaration() {
                    return lookAhead(isDeclaration2);
                }
                function isStartOfStatement() {
                    switch(token()){
                        case 60 /* AtToken */ :
                        case 27 /* SemicolonToken */ :
                        case 19 /* OpenBraceToken */ :
                        case 115 /* VarKeyword */ :
                        case 121 /* LetKeyword */ :
                        case 100 /* FunctionKeyword */ :
                        case 86 /* ClassKeyword */ :
                        case 94 /* EnumKeyword */ :
                        case 101 /* IfKeyword */ :
                        case 92 /* DoKeyword */ :
                        case 117 /* WhileKeyword */ :
                        case 99 /* ForKeyword */ :
                        case 88 /* ContinueKeyword */ :
                        case 83 /* BreakKeyword */ :
                        case 107 /* ReturnKeyword */ :
                        case 118 /* WithKeyword */ :
                        case 109 /* SwitchKeyword */ :
                        case 111 /* ThrowKeyword */ :
                        case 113 /* TryKeyword */ :
                        case 89 /* DebuggerKeyword */ :
                        case 85 /* CatchKeyword */ :
                        case 98 /* FinallyKeyword */ :
                            return true;
                        case 102 /* ImportKeyword */ :
                            return isStartOfDeclaration() || lookAhead(nextTokenIsOpenParenOrLessThanOrDot);
                        case 87 /* ConstKeyword */ :
                        case 95 /* ExportKeyword */ :
                            return isStartOfDeclaration();
                        case 134 /* AsyncKeyword */ :
                        case 138 /* DeclareKeyword */ :
                        case 120 /* InterfaceKeyword */ :
                        case 144 /* ModuleKeyword */ :
                        case 145 /* NamespaceKeyword */ :
                        case 156 /* TypeKeyword */ :
                        case 161 /* GlobalKeyword */ :
                            return true;
                        case 129 /* AccessorKeyword */ :
                        case 125 /* PublicKeyword */ :
                        case 123 /* PrivateKeyword */ :
                        case 124 /* ProtectedKeyword */ :
                        case 126 /* StaticKeyword */ :
                        case 148 /* ReadonlyKeyword */ :
                            return isStartOfDeclaration() || !lookAhead(nextTokenIsIdentifierOrKeywordOnSameLine);
                        default:
                            return isStartOfExpression();
                    }
                }
                function nextTokenIsBindingIdentifierOrStartOfDestructuring() {
                    nextToken();
                    return isBindingIdentifier() || token() === 19 /* OpenBraceToken */  || token() === 23 /* OpenBracketToken */ ;
                }
                function isLetDeclaration() {
                    return lookAhead(nextTokenIsBindingIdentifierOrStartOfDestructuring);
                }
                function parseStatement() {
                    switch(token()){
                        case 27 /* SemicolonToken */ :
                            return parseEmptyStatement();
                        case 19 /* OpenBraceToken */ :
                            return parseBlock(/*ignoreMissingOpenBrace*/ false);
                        case 115 /* VarKeyword */ :
                            return parseVariableStatement(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0);
                        case 121 /* LetKeyword */ :
                            if (isLetDeclaration()) return parseVariableStatement(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0);
                            break;
                        case 100 /* FunctionKeyword */ :
                            return parseFunctionDeclaration(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0);
                        case 86 /* ClassKeyword */ :
                            return parseClassDeclaration(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0);
                        case 101 /* IfKeyword */ :
                            return parseIfStatement();
                        case 92 /* DoKeyword */ :
                            return parseDoStatement();
                        case 117 /* WhileKeyword */ :
                            return parseWhileStatement();
                        case 99 /* ForKeyword */ :
                            return parseForOrForInOrForOfStatement();
                        case 88 /* ContinueKeyword */ :
                            return parseBreakOrContinueStatement(250 /* ContinueStatement */ );
                        case 83 /* BreakKeyword */ :
                            return parseBreakOrContinueStatement(251 /* BreakStatement */ );
                        case 107 /* ReturnKeyword */ :
                            return parseReturnStatement();
                        case 118 /* WithKeyword */ :
                            return parseWithStatement();
                        case 109 /* SwitchKeyword */ :
                            return parseSwitchStatement();
                        case 111 /* ThrowKeyword */ :
                            return parseThrowStatement();
                        case 113 /* TryKeyword */ :
                        case 85 /* CatchKeyword */ :
                        case 98 /* FinallyKeyword */ :
                            return parseTryStatement();
                        case 89 /* DebuggerKeyword */ :
                            return parseDebuggerStatement();
                        case 60 /* AtToken */ :
                            return parseDeclaration();
                        case 134 /* AsyncKeyword */ :
                        case 120 /* InterfaceKeyword */ :
                        case 156 /* TypeKeyword */ :
                        case 144 /* ModuleKeyword */ :
                        case 145 /* NamespaceKeyword */ :
                        case 138 /* DeclareKeyword */ :
                        case 87 /* ConstKeyword */ :
                        case 94 /* EnumKeyword */ :
                        case 95 /* ExportKeyword */ :
                        case 102 /* ImportKeyword */ :
                        case 123 /* PrivateKeyword */ :
                        case 124 /* ProtectedKeyword */ :
                        case 125 /* PublicKeyword */ :
                        case 128 /* AbstractKeyword */ :
                        case 129 /* AccessorKeyword */ :
                        case 126 /* StaticKeyword */ :
                        case 148 /* ReadonlyKeyword */ :
                        case 161 /* GlobalKeyword */ :
                            if (isStartOfDeclaration()) return parseDeclaration();
                            break;
                    }
                    return parseExpressionOrLabeledStatement();
                }
                function isDeclareModifier(modifier) {
                    return modifier.kind === 138 /* DeclareKeyword */ ;
                }
                function parseDeclaration() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    const modifiers = parseModifiers(/*allowDecorators*/ true);
                    const isAmbient = some(modifiers, isDeclareModifier);
                    if (isAmbient) {
                        const node = tryReuseAmbientDeclaration(pos);
                        if (node) return node;
                        for (const m of modifiers)m.flags |= 16777216 /* Ambient */ ;
                        return doInsideOfContext(16777216 /* Ambient */ , ()=>parseDeclarationWorker(pos, hasJSDoc, modifiers));
                    } else return parseDeclarationWorker(pos, hasJSDoc, modifiers);
                }
                function tryReuseAmbientDeclaration(pos) {
                    return doInsideOfContext(16777216 /* Ambient */ , ()=>{
                        const node = currentNode(parsingContext, pos);
                        if (node) return consumeNode(node);
                    });
                }
                function parseDeclarationWorker(pos, hasJSDoc, modifiersIn) {
                    switch(token()){
                        case 115 /* VarKeyword */ :
                        case 121 /* LetKeyword */ :
                        case 87 /* ConstKeyword */ :
                            return parseVariableStatement(pos, hasJSDoc, modifiersIn);
                        case 100 /* FunctionKeyword */ :
                            return parseFunctionDeclaration(pos, hasJSDoc, modifiersIn);
                        case 86 /* ClassKeyword */ :
                            return parseClassDeclaration(pos, hasJSDoc, modifiersIn);
                        case 120 /* InterfaceKeyword */ :
                            return parseInterfaceDeclaration(pos, hasJSDoc, modifiersIn);
                        case 156 /* TypeKeyword */ :
                            return parseTypeAliasDeclaration(pos, hasJSDoc, modifiersIn);
                        case 94 /* EnumKeyword */ :
                            return parseEnumDeclaration(pos, hasJSDoc, modifiersIn);
                        case 161 /* GlobalKeyword */ :
                        case 144 /* ModuleKeyword */ :
                        case 145 /* NamespaceKeyword */ :
                            return parseModuleDeclaration(pos, hasJSDoc, modifiersIn);
                        case 102 /* ImportKeyword */ :
                            return parseImportDeclarationOrImportEqualsDeclaration(pos, hasJSDoc, modifiersIn);
                        case 95 /* ExportKeyword */ :
                            nextToken();
                            switch(token()){
                                case 90 /* DefaultKeyword */ :
                                case 64 /* EqualsToken */ :
                                    return parseExportAssignment(pos, hasJSDoc, modifiersIn);
                                case 130 /* AsKeyword */ :
                                    return parseNamespaceExportDeclaration(pos, hasJSDoc, modifiersIn);
                                default:
                                    return parseExportDeclaration(pos, hasJSDoc, modifiersIn);
                            }
                        default:
                            if (modifiersIn) {
                                const missing = createMissingNode(281 /* MissingDeclaration */ , /*reportAtCurrentPosition*/ true, Diagnostics.Declaration_expected);
                                setTextRangePos(missing, pos);
                                missing.modifiers = modifiersIn;
                                return missing;
                            }
                            return void 0;
                    }
                }
                function nextTokenIsIdentifierOrStringLiteralOnSameLine() {
                    nextToken();
                    return !scanner2.hasPrecedingLineBreak() && (isIdentifier2() || token() === 11 /* StringLiteral */ );
                }
                function parseFunctionBlockOrSemicolon(flags, diagnosticMessage) {
                    if (token() !== 19 /* OpenBraceToken */ ) {
                        if (flags & 4 /* Type */ ) {
                            parseTypeMemberSemicolon();
                            return;
                        }
                        if (canParseSemicolon()) {
                            parseSemicolon();
                            return;
                        }
                    }
                    return parseFunctionBlock(flags, diagnosticMessage);
                }
                function parseArrayBindingElement() {
                    const pos = getNodePos();
                    if (token() === 28 /* CommaToken */ ) return finishNode(factory2.createOmittedExpression(), pos);
                    const dotDotDotToken = parseOptionalToken(26 /* DotDotDotToken */ );
                    const name = parseIdentifierOrPattern();
                    const initializer = parseInitializer();
                    return finishNode(factory2.createBindingElement(dotDotDotToken, /*propertyName*/ void 0, name, initializer), pos);
                }
                function parseObjectBindingElement() {
                    const pos = getNodePos();
                    const dotDotDotToken = parseOptionalToken(26 /* DotDotDotToken */ );
                    const tokenIsIdentifier = isBindingIdentifier();
                    let propertyName = parsePropertyName();
                    let name;
                    if (tokenIsIdentifier && token() !== 59 /* ColonToken */ ) {
                        name = propertyName;
                        propertyName = void 0;
                    } else {
                        parseExpected(59 /* ColonToken */ );
                        name = parseIdentifierOrPattern();
                    }
                    const initializer = parseInitializer();
                    return finishNode(factory2.createBindingElement(dotDotDotToken, propertyName, name, initializer), pos);
                }
                function parseObjectBindingPattern() {
                    const pos = getNodePos();
                    parseExpected(19 /* OpenBraceToken */ );
                    const elements = parseDelimitedList(9 /* ObjectBindingElements */ , parseObjectBindingElement);
                    parseExpected(20 /* CloseBraceToken */ );
                    return finishNode(factory2.createObjectBindingPattern(elements), pos);
                }
                function parseArrayBindingPattern() {
                    const pos = getNodePos();
                    parseExpected(23 /* OpenBracketToken */ );
                    const elements = parseDelimitedList(10 /* ArrayBindingElements */ , parseArrayBindingElement);
                    parseExpected(24 /* CloseBracketToken */ );
                    return finishNode(factory2.createArrayBindingPattern(elements), pos);
                }
                function isBindingIdentifierOrPrivateIdentifierOrPattern() {
                    return token() === 19 /* OpenBraceToken */  || token() === 23 /* OpenBracketToken */  || token() === 81 /* PrivateIdentifier */  || isBindingIdentifier();
                }
                function parseIdentifierOrPattern(privateIdentifierDiagnosticMessage) {
                    if (token() === 23 /* OpenBracketToken */ ) return parseArrayBindingPattern();
                    if (token() === 19 /* OpenBraceToken */ ) return parseObjectBindingPattern();
                    return parseBindingIdentifier(privateIdentifierDiagnosticMessage);
                }
                function parseVariableDeclarationAllowExclamation() {
                    return parseVariableDeclaration(/*allowExclamation*/ true);
                }
                function parseVariableDeclaration(allowExclamation) {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    const name = parseIdentifierOrPattern(Diagnostics.Private_identifiers_are_not_allowed_in_variable_declarations);
                    let exclamationToken;
                    if (allowExclamation && name.kind === 80 /* Identifier */  && token() === 54 /* ExclamationToken */  && !scanner2.hasPrecedingLineBreak()) exclamationToken = parseTokenNode();
                    const type = parseTypeAnnotation();
                    const initializer = isInOrOfKeyword(token()) ? void 0 : parseInitializer();
                    const node = factoryCreateVariableDeclaration(name, exclamationToken, type, initializer);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseVariableDeclarationList(inForStatementInitializer) {
                    const pos = getNodePos();
                    let flags = 0;
                    switch(token()){
                        case 115 /* VarKeyword */ :
                            break;
                        case 121 /* LetKeyword */ :
                            flags |= 1 /* Let */ ;
                            break;
                        case 87 /* ConstKeyword */ :
                            flags |= 2 /* Const */ ;
                            break;
                        default:
                            Debug.fail();
                    }
                    nextToken();
                    let declarations;
                    if (token() === 164 /* OfKeyword */  && lookAhead(canFollowContextualOfKeyword)) declarations = createMissingList();
                    else {
                        const savedDisallowIn = inDisallowInContext();
                        setDisallowInContext(inForStatementInitializer);
                        declarations = parseDelimitedList(8 /* VariableDeclarations */ , inForStatementInitializer ? parseVariableDeclaration : parseVariableDeclarationAllowExclamation);
                        setDisallowInContext(savedDisallowIn);
                    }
                    return finishNode(factoryCreateVariableDeclarationList(declarations, flags), pos);
                }
                function canFollowContextualOfKeyword() {
                    return nextTokenIsIdentifier() && nextToken() === 22 /* CloseParenToken */ ;
                }
                function parseVariableStatement(pos, hasJSDoc, modifiers) {
                    const declarationList = parseVariableDeclarationList(/*inForStatementInitializer*/ false);
                    parseSemicolon();
                    const node = factoryCreateVariableStatement(modifiers, declarationList);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseFunctionDeclaration(pos, hasJSDoc, modifiers) {
                    const savedAwaitContext = inAwaitContext();
                    const modifierFlags = modifiersToFlags(modifiers);
                    parseExpected(100 /* FunctionKeyword */ );
                    const asteriskToken = parseOptionalToken(42 /* AsteriskToken */ );
                    const name = modifierFlags & 1024 /* Default */  ? parseOptionalBindingIdentifier() : parseBindingIdentifier();
                    const isGenerator = asteriskToken ? 1 /* Yield */  : 0 /* None */ ;
                    const isAsync = modifierFlags & 512 /* Async */  ? 2 /* Await */  : 0 /* None */ ;
                    const typeParameters = parseTypeParameters();
                    if (modifierFlags & 1 /* Export */ ) setAwaitContext(/*value*/ true);
                    const parameters = parseParameters(isGenerator | isAsync);
                    const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
                    const body = parseFunctionBlockOrSemicolon(isGenerator | isAsync, Diagnostics.or_expected);
                    setAwaitContext(savedAwaitContext);
                    const node = factory2.createFunctionDeclaration(modifiers, asteriskToken, name, typeParameters, parameters, type, body);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseConstructorName() {
                    if (token() === 137 /* ConstructorKeyword */ ) return parseExpected(137 /* ConstructorKeyword */ );
                    if (token() === 11 /* StringLiteral */  && lookAhead(nextToken) === 21 /* OpenParenToken */ ) return tryParse(()=>{
                        const literalNode = parseLiteralNode();
                        return literalNode.text === "constructor" ? literalNode : void 0;
                    });
                }
                function tryParseConstructorDeclaration(pos, hasJSDoc, modifiers) {
                    return tryParse(()=>{
                        if (parseConstructorName()) {
                            const typeParameters = parseTypeParameters();
                            const parameters = parseParameters(0 /* None */ );
                            const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
                            const body = parseFunctionBlockOrSemicolon(0 /* None */ , Diagnostics.or_expected);
                            const node = factory2.createConstructorDeclaration(modifiers, parameters, body);
                            node.typeParameters = typeParameters;
                            node.type = type;
                            return withJSDoc(finishNode(node, pos), hasJSDoc);
                        }
                    });
                }
                function parseMethodDeclaration(pos, hasJSDoc, modifiers, asteriskToken, name, questionToken, exclamationToken, diagnosticMessage) {
                    const isGenerator = asteriskToken ? 1 /* Yield */  : 0 /* None */ ;
                    const isAsync = some(modifiers, isAsyncModifier) ? 2 /* Await */  : 0 /* None */ ;
                    const typeParameters = parseTypeParameters();
                    const parameters = parseParameters(isGenerator | isAsync);
                    const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
                    const body = parseFunctionBlockOrSemicolon(isGenerator | isAsync, diagnosticMessage);
                    const node = factory2.createMethodDeclaration(modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body);
                    node.exclamationToken = exclamationToken;
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parsePropertyDeclaration(pos, hasJSDoc, modifiers, name, questionToken) {
                    const exclamationToken = !questionToken && !scanner2.hasPrecedingLineBreak() ? parseOptionalToken(54 /* ExclamationToken */ ) : void 0;
                    const type = parseTypeAnnotation();
                    const initializer = doOutsideOfContext(45056 /* DisallowInContext */ , parseInitializer);
                    parseSemicolonAfterPropertyName(name, type, initializer);
                    const node = factory2.createPropertyDeclaration(modifiers, name, questionToken || exclamationToken, type, initializer);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parsePropertyOrMethodDeclaration(pos, hasJSDoc, modifiers) {
                    const asteriskToken = parseOptionalToken(42 /* AsteriskToken */ );
                    const name = parsePropertyName();
                    const questionToken = parseOptionalToken(58 /* QuestionToken */ );
                    if (asteriskToken || token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */ ) return parseMethodDeclaration(pos, hasJSDoc, modifiers, asteriskToken, name, questionToken, /*exclamationToken*/ void 0, Diagnostics.or_expected);
                    return parsePropertyDeclaration(pos, hasJSDoc, modifiers, name, questionToken);
                }
                function parseAccessorDeclaration(pos, hasJSDoc, modifiers, kind, flags) {
                    const name = parsePropertyName();
                    const typeParameters = parseTypeParameters();
                    const parameters = parseParameters(0 /* None */ );
                    const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
                    const body = parseFunctionBlockOrSemicolon(flags);
                    const node = kind === 176 /* GetAccessor */  ? factory2.createGetAccessorDeclaration(modifiers, name, parameters, type, body) : factory2.createSetAccessorDeclaration(modifiers, name, parameters, body);
                    node.typeParameters = typeParameters;
                    if (isSetAccessorDeclaration(node)) node.type = type;
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function isClassMemberStart() {
                    let idToken;
                    if (token() === 60 /* AtToken */ ) return true;
                    while(isModifierKind(token())){
                        idToken = token();
                        if (isClassMemberModifier(idToken)) return true;
                        nextToken();
                    }
                    if (token() === 42 /* AsteriskToken */ ) return true;
                    if (isLiteralPropertyName()) {
                        idToken = token();
                        nextToken();
                    }
                    if (token() === 23 /* OpenBracketToken */ ) return true;
                    if (idToken !== void 0) {
                        if (!isKeyword(idToken) || idToken === 153 /* SetKeyword */  || idToken === 139 /* GetKeyword */ ) return true;
                        switch(token()){
                            case 21 /* OpenParenToken */ :
                            case 30 /* LessThanToken */ :
                            case 54 /* ExclamationToken */ :
                            case 59 /* ColonToken */ :
                            case 64 /* EqualsToken */ :
                            case 58 /* QuestionToken */ :
                                return true;
                            default:
                                return canParseSemicolon();
                        }
                    }
                    return false;
                }
                function parseClassStaticBlockDeclaration(pos, hasJSDoc, modifiers) {
                    parseExpectedToken(126 /* StaticKeyword */ );
                    const body = parseClassStaticBlockBody();
                    const node = withJSDoc(finishNode(factory2.createClassStaticBlockDeclaration(body), pos), hasJSDoc);
                    node.modifiers = modifiers;
                    return node;
                }
                function parseClassStaticBlockBody() {
                    const savedYieldContext = inYieldContext();
                    const savedAwaitContext = inAwaitContext();
                    setYieldContext(false);
                    setAwaitContext(true);
                    const body = parseBlock(/*ignoreMissingOpenBrace*/ false);
                    setYieldContext(savedYieldContext);
                    setAwaitContext(savedAwaitContext);
                    return body;
                }
                function parseDecoratorExpression() {
                    if (inAwaitContext() && token() === 135 /* AwaitKeyword */ ) {
                        const pos = getNodePos();
                        const awaitExpression = parseIdentifier(Diagnostics.Expression_expected);
                        nextToken();
                        const memberExpression = parseMemberExpressionRest(pos, awaitExpression, /*allowOptionalChain*/ true);
                        return parseCallExpressionRest(pos, memberExpression);
                    }
                    return parseLeftHandSideExpressionOrHigher();
                }
                function tryParseDecorator() {
                    const pos = getNodePos();
                    if (!parseOptional(60 /* AtToken */ )) return void 0;
                    const expression = doInDecoratorContext(parseDecoratorExpression);
                    return finishNode(factory2.createDecorator(expression), pos);
                }
                function tryParseModifier(hasSeenStaticModifier, permitConstAsModifier, stopOnStartOfClassStaticBlock) {
                    const pos = getNodePos();
                    const kind = token();
                    if (token() === 87 /* ConstKeyword */  && permitConstAsModifier) {
                        if (!tryParse(nextTokenIsOnSameLineAndCanFollowModifier)) return void 0;
                    } else if (stopOnStartOfClassStaticBlock && token() === 126 /* StaticKeyword */  && lookAhead(nextTokenIsOpenBrace)) return void 0;
                    else if (hasSeenStaticModifier && token() === 126 /* StaticKeyword */ ) return void 0;
                    else {
                        if (!parseAnyContextualModifier()) return void 0;
                    }
                    return finishNode(factoryCreateToken(kind), pos);
                }
                function parseModifiers(allowDecorators, permitConstAsModifier, stopOnStartOfClassStaticBlock) {
                    const pos = getNodePos();
                    let list;
                    let decorator, modifier, hasSeenStaticModifier = false, hasLeadingModifier = false, hasTrailingDecorator = false;
                    if (allowDecorators && token() === 60 /* AtToken */ ) while(decorator = tryParseDecorator())list = append(list, decorator);
                    while(modifier = tryParseModifier(hasSeenStaticModifier, permitConstAsModifier, stopOnStartOfClassStaticBlock)){
                        if (modifier.kind === 126 /* StaticKeyword */ ) hasSeenStaticModifier = true;
                        list = append(list, modifier);
                        hasLeadingModifier = true;
                    }
                    if (hasLeadingModifier && allowDecorators && token() === 60 /* AtToken */ ) while(decorator = tryParseDecorator()){
                        list = append(list, decorator);
                        hasTrailingDecorator = true;
                    }
                    if (hasTrailingDecorator) while(modifier = tryParseModifier(hasSeenStaticModifier, permitConstAsModifier, stopOnStartOfClassStaticBlock)){
                        if (modifier.kind === 126 /* StaticKeyword */ ) hasSeenStaticModifier = true;
                        list = append(list, modifier);
                    }
                    return list && createNodeArray(list, pos);
                }
                function parseModifiersForArrowFunction() {
                    let modifiers;
                    if (token() === 134 /* AsyncKeyword */ ) {
                        const pos = getNodePos();
                        nextToken();
                        const modifier = finishNode(factoryCreateToken(134 /* AsyncKeyword */ ), pos);
                        modifiers = createNodeArray([
                            modifier
                        ], pos);
                    }
                    return modifiers;
                }
                function parseClassElement() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    if (token() === 27 /* SemicolonToken */ ) {
                        nextToken();
                        return withJSDoc(finishNode(factory2.createSemicolonClassElement(), pos), hasJSDoc);
                    }
                    const modifiers = parseModifiers(/*allowDecorators*/ true, /*permitConstAsModifier*/ true, /*stopOnStartOfClassStaticBlock*/ true);
                    if (token() === 126 /* StaticKeyword */  && lookAhead(nextTokenIsOpenBrace)) return parseClassStaticBlockDeclaration(pos, hasJSDoc, modifiers);
                    if (parseContextualModifier(139 /* GetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 176 /* GetAccessor */ , 0 /* None */ );
                    if (parseContextualModifier(153 /* SetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 177 /* SetAccessor */ , 0 /* None */ );
                    if (token() === 137 /* ConstructorKeyword */  || token() === 11 /* StringLiteral */ ) {
                        const constructorDeclaration = tryParseConstructorDeclaration(pos, hasJSDoc, modifiers);
                        if (constructorDeclaration) return constructorDeclaration;
                    }
                    if (isIndexSignature()) return parseIndexSignatureDeclaration(pos, hasJSDoc, modifiers);
                    if (tokenIsIdentifierOrKeyword(token()) || token() === 11 /* StringLiteral */  || token() === 9 /* NumericLiteral */  || token() === 42 /* AsteriskToken */  || token() === 23 /* OpenBracketToken */ ) {
                        const isAmbient = some(modifiers, isDeclareModifier);
                        if (isAmbient) {
                            for (const m of modifiers)m.flags |= 16777216 /* Ambient */ ;
                            return doInsideOfContext(16777216 /* Ambient */ , ()=>parsePropertyOrMethodDeclaration(pos, hasJSDoc, modifiers));
                        } else return parsePropertyOrMethodDeclaration(pos, hasJSDoc, modifiers);
                    }
                    if (modifiers) {
                        const name = createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ true, Diagnostics.Declaration_expected);
                        return parsePropertyDeclaration(pos, hasJSDoc, modifiers, name, /*questionToken*/ void 0);
                    }
                    return Debug.fail("Should not have attempted to parse class member declaration.");
                }
                function parseDecoratedExpression() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    const modifiers = parseModifiers(/*allowDecorators*/ true);
                    if (token() === 86 /* ClassKeyword */ ) return parseClassDeclarationOrExpression(pos, hasJSDoc, modifiers, 230 /* ClassExpression */ );
                    const missing = createMissingNode(281 /* MissingDeclaration */ , /*reportAtCurrentPosition*/ true, Diagnostics.Expression_expected);
                    setTextRangePos(missing, pos);
                    missing.modifiers = modifiers;
                    return missing;
                }
                function parseClassExpression() {
                    return parseClassDeclarationOrExpression(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0, 230 /* ClassExpression */ );
                }
                function parseClassDeclaration(pos, hasJSDoc, modifiers) {
                    return parseClassDeclarationOrExpression(pos, hasJSDoc, modifiers, 262 /* ClassDeclaration */ );
                }
                function parseClassDeclarationOrExpression(pos, hasJSDoc, modifiers, kind) {
                    const savedAwaitContext = inAwaitContext();
                    parseExpected(86 /* ClassKeyword */ );
                    const name = parseNameOfClassDeclarationOrExpression();
                    const typeParameters = parseTypeParameters();
                    if (some(modifiers, isExportModifier)) setAwaitContext(/*value*/ true);
                    const heritageClauses = parseHeritageClauses();
                    let members;
                    if (parseExpected(19 /* OpenBraceToken */ )) {
                        members = parseClassMembers();
                        parseExpected(20 /* CloseBraceToken */ );
                    } else members = createMissingList();
                    setAwaitContext(savedAwaitContext);
                    const node = kind === 262 /* ClassDeclaration */  ? factory2.createClassDeclaration(modifiers, name, typeParameters, heritageClauses, members) : factory2.createClassExpression(modifiers, name, typeParameters, heritageClauses, members);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseNameOfClassDeclarationOrExpression() {
                    return isBindingIdentifier() && !isImplementsClause() ? createIdentifier(isBindingIdentifier()) : void 0;
                }
                function isImplementsClause() {
                    return token() === 119 /* ImplementsKeyword */  && lookAhead(nextTokenIsIdentifierOrKeyword);
                }
                function parseHeritageClauses() {
                    if (isHeritageClause2()) return parseList(22 /* HeritageClauses */ , parseHeritageClause);
                    return void 0;
                }
                function parseHeritageClause() {
                    const pos = getNodePos();
                    const tok = token();
                    Debug.assert(tok === 96 /* ExtendsKeyword */  || tok === 119 /* ImplementsKeyword */ );
                    nextToken();
                    const types = parseDelimitedList(7 /* HeritageClauseElement */ , parseExpressionWithTypeArguments);
                    return finishNode(factory2.createHeritageClause(tok, types), pos);
                }
                function parseExpressionWithTypeArguments() {
                    const pos = getNodePos();
                    const expression = parseLeftHandSideExpressionOrHigher();
                    if (expression.kind === 232 /* ExpressionWithTypeArguments */ ) return expression;
                    const typeArguments = tryParseTypeArguments();
                    return finishNode(factory2.createExpressionWithTypeArguments(expression, typeArguments), pos);
                }
                function tryParseTypeArguments() {
                    return token() === 30 /* LessThanToken */  ? parseBracketedList(20 /* TypeArguments */ , parseType, 30 /* LessThanToken */ , 32 /* GreaterThanToken */ ) : void 0;
                }
                function isHeritageClause2() {
                    return token() === 96 /* ExtendsKeyword */  || token() === 119 /* ImplementsKeyword */ ;
                }
                function parseClassMembers() {
                    return parseList(5 /* ClassMembers */ , parseClassElement);
                }
                function parseInterfaceDeclaration(pos, hasJSDoc, modifiers) {
                    parseExpected(120 /* InterfaceKeyword */ );
                    const name = parseIdentifier();
                    const typeParameters = parseTypeParameters();
                    const heritageClauses = parseHeritageClauses();
                    const members = parseObjectTypeMembers();
                    const node = factory2.createInterfaceDeclaration(modifiers, name, typeParameters, heritageClauses, members);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseTypeAliasDeclaration(pos, hasJSDoc, modifiers) {
                    parseExpected(156 /* TypeKeyword */ );
                    const name = parseIdentifier();
                    const typeParameters = parseTypeParameters();
                    parseExpected(64 /* EqualsToken */ );
                    const type = token() === 141 /* IntrinsicKeyword */  && tryParse(parseKeywordAndNoDot) || parseType();
                    parseSemicolon();
                    const node = factory2.createTypeAliasDeclaration(modifiers, name, typeParameters, type);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseEnumMember() {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    const name = parsePropertyName();
                    const initializer = allowInAnd(parseInitializer);
                    return withJSDoc(finishNode(factory2.createEnumMember(name, initializer), pos), hasJSDoc);
                }
                function parseEnumDeclaration(pos, hasJSDoc, modifiers) {
                    parseExpected(94 /* EnumKeyword */ );
                    const name = parseIdentifier();
                    let members;
                    if (parseExpected(19 /* OpenBraceToken */ )) {
                        members = doOutsideOfYieldAndAwaitContext(()=>parseDelimitedList(6 /* EnumMembers */ , parseEnumMember));
                        parseExpected(20 /* CloseBraceToken */ );
                    } else members = createMissingList();
                    const node = factory2.createEnumDeclaration(modifiers, name, members);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseModuleBlock() {
                    const pos = getNodePos();
                    let statements;
                    if (parseExpected(19 /* OpenBraceToken */ )) {
                        statements = parseList(1 /* BlockStatements */ , parseStatement);
                        parseExpected(20 /* CloseBraceToken */ );
                    } else statements = createMissingList();
                    return finishNode(factory2.createModuleBlock(statements), pos);
                }
                function parseModuleOrNamespaceDeclaration(pos, hasJSDoc, modifiers, flags) {
                    const namespaceFlag = flags & 16 /* Namespace */ ;
                    const name = parseIdentifier();
                    const body = parseOptional(25 /* DotToken */ ) ? parseModuleOrNamespaceDeclaration(getNodePos(), /*hasJSDoc*/ false, /*modifiers*/ void 0, 4 /* NestedNamespace */  | namespaceFlag) : parseModuleBlock();
                    const node = factory2.createModuleDeclaration(modifiers, name, body, flags);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseAmbientExternalModuleDeclaration(pos, hasJSDoc, modifiersIn) {
                    let flags = 0;
                    let name;
                    if (token() === 161 /* GlobalKeyword */ ) {
                        name = parseIdentifier();
                        flags |= 1024 /* GlobalAugmentation */ ;
                    } else {
                        name = parseLiteralNode();
                        name.text = internIdentifier(name.text);
                    }
                    let body;
                    if (token() === 19 /* OpenBraceToken */ ) body = parseModuleBlock();
                    else parseSemicolon();
                    const node = factory2.createModuleDeclaration(modifiersIn, name, body, flags);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseModuleDeclaration(pos, hasJSDoc, modifiersIn) {
                    let flags = 0;
                    if (token() === 161 /* GlobalKeyword */ ) return parseAmbientExternalModuleDeclaration(pos, hasJSDoc, modifiersIn);
                    else if (parseOptional(145 /* NamespaceKeyword */ )) flags |= 16 /* Namespace */ ;
                    else {
                        parseExpected(144 /* ModuleKeyword */ );
                        if (token() === 11 /* StringLiteral */ ) return parseAmbientExternalModuleDeclaration(pos, hasJSDoc, modifiersIn);
                    }
                    return parseModuleOrNamespaceDeclaration(pos, hasJSDoc, modifiersIn, flags);
                }
                function isExternalModuleReference2() {
                    return token() === 149 /* RequireKeyword */  && lookAhead(nextTokenIsOpenParen);
                }
                function nextTokenIsOpenParen() {
                    return nextToken() === 21 /* OpenParenToken */ ;
                }
                function nextTokenIsOpenBrace() {
                    return nextToken() === 19 /* OpenBraceToken */ ;
                }
                function nextTokenIsSlash() {
                    return nextToken() === 44 /* SlashToken */ ;
                }
                function parseNamespaceExportDeclaration(pos, hasJSDoc, modifiers) {
                    parseExpected(130 /* AsKeyword */ );
                    parseExpected(145 /* NamespaceKeyword */ );
                    const name = parseIdentifier();
                    parseSemicolon();
                    const node = factory2.createNamespaceExportDeclaration(name);
                    node.modifiers = modifiers;
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseImportDeclarationOrImportEqualsDeclaration(pos, hasJSDoc, modifiers) {
                    parseExpected(102 /* ImportKeyword */ );
                    const afterImportPos = scanner2.getTokenFullStart();
                    let identifier;
                    if (isIdentifier2()) identifier = parseIdentifier();
                    let isTypeOnly = false;
                    if (token() !== 160 /* FromKeyword */  && (identifier == null ? void 0 : identifier.escapedText) === "type" && (isIdentifier2() || tokenAfterImportDefinitelyProducesImportDeclaration())) {
                        isTypeOnly = true;
                        identifier = isIdentifier2() ? parseIdentifier() : void 0;
                    }
                    if (identifier && !tokenAfterImportedIdentifierDefinitelyProducesImportDeclaration()) return parseImportEqualsDeclaration(pos, hasJSDoc, modifiers, identifier, isTypeOnly);
                    let importClause;
                    if (identifier || // import id
                    token() === 42 /* AsteriskToken */  || // import *
                    token() === 19 /* OpenBraceToken */ ) {
                        importClause = parseImportClause(identifier, afterImportPos, isTypeOnly);
                        parseExpected(160 /* FromKeyword */ );
                    }
                    const moduleSpecifier = parseModuleSpecifier();
                    let assertClause;
                    if (token() === 132 /* AssertKeyword */  && !scanner2.hasPrecedingLineBreak()) assertClause = parseAssertClause();
                    parseSemicolon();
                    const node = factory2.createImportDeclaration(modifiers, importClause, moduleSpecifier, assertClause);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseAssertEntry() {
                    const pos = getNodePos();
                    const name = tokenIsIdentifierOrKeyword(token()) ? parseIdentifierName() : parseLiteralLikeNode(11 /* StringLiteral */ );
                    parseExpected(59 /* ColonToken */ );
                    const value1 = parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
                    return finishNode(factory2.createAssertEntry(name, value1), pos);
                }
                function parseAssertClause(skipAssertKeyword) {
                    const pos = getNodePos();
                    if (!skipAssertKeyword) parseExpected(132 /* AssertKeyword */ );
                    const openBracePosition = scanner2.getTokenStart();
                    if (parseExpected(19 /* OpenBraceToken */ )) {
                        const multiLine = scanner2.hasPrecedingLineBreak();
                        const elements = parseDelimitedList(24 /* AssertEntries */ , parseAssertEntry, /*considerSemicolonAsDelimiter*/ true);
                        if (!parseExpected(20 /* CloseBraceToken */ )) {
                            const lastError = lastOrUndefined(parseDiagnostics);
                            if (lastError && lastError.code === Diagnostics._0_expected.code) addRelatedInfo(lastError, createDetachedDiagnostic(fileName, openBracePosition, 1, Diagnostics.The_parser_expected_to_find_a_1_to_match_the_0_token_here, "{", "}"));
                        }
                        return finishNode(factory2.createAssertClause(elements, multiLine), pos);
                    } else {
                        const elements = createNodeArray([], getNodePos(), /*end*/ void 0, /*hasTrailingComma*/ false);
                        return finishNode(factory2.createAssertClause(elements, /*multiLine*/ false), pos);
                    }
                }
                function tokenAfterImportDefinitelyProducesImportDeclaration() {
                    return token() === 42 /* AsteriskToken */  || token() === 19 /* OpenBraceToken */ ;
                }
                function tokenAfterImportedIdentifierDefinitelyProducesImportDeclaration() {
                    return token() === 28 /* CommaToken */  || token() === 160 /* FromKeyword */ ;
                }
                function parseImportEqualsDeclaration(pos, hasJSDoc, modifiers, identifier, isTypeOnly) {
                    parseExpected(64 /* EqualsToken */ );
                    const moduleReference = parseModuleReference();
                    parseSemicolon();
                    const node = factory2.createImportEqualsDeclaration(modifiers, isTypeOnly, identifier, moduleReference);
                    const finished = withJSDoc(finishNode(node, pos), hasJSDoc);
                    return finished;
                }
                function parseImportClause(identifier, pos, isTypeOnly) {
                    let namedBindings;
                    if (!identifier || parseOptional(28 /* CommaToken */ )) namedBindings = token() === 42 /* AsteriskToken */  ? parseNamespaceImport() : parseNamedImportsOrExports(274 /* NamedImports */ );
                    return finishNode(factory2.createImportClause(isTypeOnly, identifier, namedBindings), pos);
                }
                function parseModuleReference() {
                    return isExternalModuleReference2() ? parseExternalModuleReference() : parseEntityName(/*allowReservedWords*/ false);
                }
                function parseExternalModuleReference() {
                    const pos = getNodePos();
                    parseExpected(149 /* RequireKeyword */ );
                    parseExpected(21 /* OpenParenToken */ );
                    const expression = parseModuleSpecifier();
                    parseExpected(22 /* CloseParenToken */ );
                    return finishNode(factory2.createExternalModuleReference(expression), pos);
                }
                function parseModuleSpecifier() {
                    if (token() === 11 /* StringLiteral */ ) {
                        const result = parseLiteralNode();
                        result.text = internIdentifier(result.text);
                        return result;
                    } else return parseExpression();
                }
                function parseNamespaceImport() {
                    const pos = getNodePos();
                    parseExpected(42 /* AsteriskToken */ );
                    parseExpected(130 /* AsKeyword */ );
                    const name = parseIdentifier();
                    return finishNode(factory2.createNamespaceImport(name), pos);
                }
                function parseNamedImportsOrExports(kind) {
                    const pos = getNodePos();
                    const node = kind === 274 /* NamedImports */  ? factory2.createNamedImports(parseBracketedList(23 /* ImportOrExportSpecifiers */ , parseImportSpecifier, 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ )) : factory2.createNamedExports(parseBracketedList(23 /* ImportOrExportSpecifiers */ , parseExportSpecifier, 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ ));
                    return finishNode(node, pos);
                }
                function parseExportSpecifier() {
                    const hasJSDoc = hasPrecedingJSDocComment();
                    return withJSDoc(parseImportOrExportSpecifier(280 /* ExportSpecifier */ ), hasJSDoc);
                }
                function parseImportSpecifier() {
                    return parseImportOrExportSpecifier(275 /* ImportSpecifier */ );
                }
                function parseImportOrExportSpecifier(kind) {
                    const pos = getNodePos();
                    let checkIdentifierIsKeyword = isKeyword(token()) && !isIdentifier2();
                    let checkIdentifierStart = scanner2.getTokenStart();
                    let checkIdentifierEnd = scanner2.getTokenEnd();
                    let isTypeOnly = false;
                    let propertyName;
                    let canParseAsKeyword = true;
                    let name = parseIdentifierName();
                    if (name.escapedText === "type") {
                        if (token() === 130 /* AsKeyword */ ) {
                            const firstAs = parseIdentifierName();
                            if (token() === 130 /* AsKeyword */ ) {
                                const secondAs = parseIdentifierName();
                                if (tokenIsIdentifierOrKeyword(token())) {
                                    isTypeOnly = true;
                                    propertyName = firstAs;
                                    name = parseNameWithKeywordCheck();
                                    canParseAsKeyword = false;
                                } else {
                                    propertyName = name;
                                    name = secondAs;
                                    canParseAsKeyword = false;
                                }
                            } else if (tokenIsIdentifierOrKeyword(token())) {
                                propertyName = name;
                                canParseAsKeyword = false;
                                name = parseNameWithKeywordCheck();
                            } else {
                                isTypeOnly = true;
                                name = firstAs;
                            }
                        } else if (tokenIsIdentifierOrKeyword(token())) {
                            isTypeOnly = true;
                            name = parseNameWithKeywordCheck();
                        }
                    }
                    if (canParseAsKeyword && token() === 130 /* AsKeyword */ ) {
                        propertyName = name;
                        parseExpected(130 /* AsKeyword */ );
                        name = parseNameWithKeywordCheck();
                    }
                    if (kind === 275 /* ImportSpecifier */  && checkIdentifierIsKeyword) parseErrorAt(checkIdentifierStart, checkIdentifierEnd, Diagnostics.Identifier_expected);
                    const node = kind === 275 /* ImportSpecifier */  ? factory2.createImportSpecifier(isTypeOnly, propertyName, name) : factory2.createExportSpecifier(isTypeOnly, propertyName, name);
                    return finishNode(node, pos);
                    function parseNameWithKeywordCheck() {
                        checkIdentifierIsKeyword = isKeyword(token()) && !isIdentifier2();
                        checkIdentifierStart = scanner2.getTokenStart();
                        checkIdentifierEnd = scanner2.getTokenEnd();
                        return parseIdentifierName();
                    }
                }
                function parseNamespaceExport(pos) {
                    return finishNode(factory2.createNamespaceExport(parseIdentifierName()), pos);
                }
                function parseExportDeclaration(pos, hasJSDoc, modifiers) {
                    const savedAwaitContext = inAwaitContext();
                    setAwaitContext(/*value*/ true);
                    let exportClause;
                    let moduleSpecifier;
                    let assertClause;
                    const isTypeOnly = parseOptional(156 /* TypeKeyword */ );
                    const namespaceExportPos = getNodePos();
                    if (parseOptional(42 /* AsteriskToken */ )) {
                        if (parseOptional(130 /* AsKeyword */ )) exportClause = parseNamespaceExport(namespaceExportPos);
                        parseExpected(160 /* FromKeyword */ );
                        moduleSpecifier = parseModuleSpecifier();
                    } else {
                        exportClause = parseNamedImportsOrExports(278 /* NamedExports */ );
                        if (token() === 160 /* FromKeyword */  || token() === 11 /* StringLiteral */  && !scanner2.hasPrecedingLineBreak()) {
                            parseExpected(160 /* FromKeyword */ );
                            moduleSpecifier = parseModuleSpecifier();
                        }
                    }
                    if (moduleSpecifier && token() === 132 /* AssertKeyword */  && !scanner2.hasPrecedingLineBreak()) assertClause = parseAssertClause();
                    parseSemicolon();
                    setAwaitContext(savedAwaitContext);
                    const node = factory2.createExportDeclaration(modifiers, isTypeOnly, exportClause, moduleSpecifier, assertClause);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                function parseExportAssignment(pos, hasJSDoc, modifiers) {
                    const savedAwaitContext = inAwaitContext();
                    setAwaitContext(/*value*/ true);
                    let isExportEquals;
                    if (parseOptional(64 /* EqualsToken */ )) isExportEquals = true;
                    else parseExpected(90 /* DefaultKeyword */ );
                    const expression = parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
                    parseSemicolon();
                    setAwaitContext(savedAwaitContext);
                    const node = factory2.createExportAssignment(modifiers, isExportEquals, expression);
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
                let ParsingContext;
                ((ParsingContext2)=>{
                    ParsingContext2[ParsingContext2["SourceElements"] = 0] = "SourceElements";
                    ParsingContext2[ParsingContext2["BlockStatements"] = 1] = "BlockStatements";
                    ParsingContext2[ParsingContext2["SwitchClauses"] = 2] = "SwitchClauses";
                    ParsingContext2[ParsingContext2["SwitchClauseStatements"] = 3] = "SwitchClauseStatements";
                    ParsingContext2[ParsingContext2["TypeMembers"] = 4] = "TypeMembers";
                    ParsingContext2[ParsingContext2["ClassMembers"] = 5] = "ClassMembers";
                    ParsingContext2[ParsingContext2["EnumMembers"] = 6] = "EnumMembers";
                    ParsingContext2[ParsingContext2["HeritageClauseElement"] = 7] = "HeritageClauseElement";
                    ParsingContext2[ParsingContext2["VariableDeclarations"] = 8] = "VariableDeclarations";
                    ParsingContext2[ParsingContext2["ObjectBindingElements"] = 9] = "ObjectBindingElements";
                    ParsingContext2[ParsingContext2["ArrayBindingElements"] = 10] = "ArrayBindingElements";
                    ParsingContext2[ParsingContext2["ArgumentExpressions"] = 11] = "ArgumentExpressions";
                    ParsingContext2[ParsingContext2["ObjectLiteralMembers"] = 12] = "ObjectLiteralMembers";
                    ParsingContext2[ParsingContext2["JsxAttributes"] = 13] = "JsxAttributes";
                    ParsingContext2[ParsingContext2["JsxChildren"] = 14] = "JsxChildren";
                    ParsingContext2[ParsingContext2["ArrayLiteralMembers"] = 15] = "ArrayLiteralMembers";
                    ParsingContext2[ParsingContext2["Parameters"] = 16] = "Parameters";
                    ParsingContext2[ParsingContext2["JSDocParameters"] = 17] = "JSDocParameters";
                    ParsingContext2[ParsingContext2["RestProperties"] = 18] = "RestProperties";
                    ParsingContext2[ParsingContext2["TypeParameters"] = 19] = "TypeParameters";
                    ParsingContext2[ParsingContext2["TypeArguments"] = 20] = "TypeArguments";
                    ParsingContext2[ParsingContext2["TupleElementTypes"] = 21] = "TupleElementTypes";
                    ParsingContext2[ParsingContext2["HeritageClauses"] = 22] = "HeritageClauses";
                    ParsingContext2[ParsingContext2["ImportOrExportSpecifiers"] = 23] = "ImportOrExportSpecifiers";
                    ParsingContext2[ParsingContext2["AssertEntries"] = 24] = "AssertEntries";
                    ParsingContext2[ParsingContext2["JSDocComment"] = 25] = "JSDocComment";
                    ParsingContext2[ParsingContext2["Count"] = 26] = "Count";
                })(ParsingContext || (ParsingContext = {}));
                let Tristate;
                ((Tristate2)=>{
                    Tristate2[Tristate2["False"] = 0] = "False";
                    Tristate2[Tristate2["True"] = 1] = "True";
                    Tristate2[Tristate2["Unknown"] = 2] = "Unknown";
                })(Tristate || (Tristate = {}));
                let JSDocParser;
                ((JSDocParser2)=>{
                    function parseJSDocTypeExpressionForTests2(content, start, length2) {
                        initializeState("file.js", content, 99 /* Latest */ , /*syntaxCursor*/ void 0, 1 /* JS */ );
                        scanner2.setText(content, start, length2);
                        currentToken = scanner2.scan();
                        const jsDocTypeExpression = parseJSDocTypeExpression();
                        const sourceFile = createSourceFile2("file.js", 99 /* Latest */ , 1 /* JS */ , /*isDeclarationFile*/ false, [], factoryCreateToken(1 /* EndOfFileToken */ ), 0 /* None */ , noop);
                        const diagnostics = attachFileToDiagnostics(parseDiagnostics, sourceFile);
                        if (jsDocDiagnostics) sourceFile.jsDocDiagnostics = attachFileToDiagnostics(jsDocDiagnostics, sourceFile);
                        clearState();
                        return jsDocTypeExpression ? {
                            jsDocTypeExpression: jsDocTypeExpression,
                            diagnostics: diagnostics
                        } : void 0;
                    }
                    JSDocParser2.parseJSDocTypeExpressionForTests = parseJSDocTypeExpressionForTests2;
                    function parseJSDocTypeExpression(mayOmitBraces) {
                        const pos = getNodePos();
                        const hasBrace = (mayOmitBraces ? parseOptional : parseExpected)(19 /* OpenBraceToken */ );
                        const type = doInsideOfContext(8388608 /* JSDoc */ , parseJSDocType);
                        if (!mayOmitBraces || hasBrace) parseExpectedJSDoc(20 /* CloseBraceToken */ );
                        const result = factory2.createJSDocTypeExpression(type);
                        fixupParentReferences(result);
                        return finishNode(result, pos);
                    }
                    JSDocParser2.parseJSDocTypeExpression = parseJSDocTypeExpression;
                    function parseJSDocNameReference() {
                        const pos = getNodePos();
                        const hasBrace = parseOptional(19 /* OpenBraceToken */ );
                        const p2 = getNodePos();
                        let entityName = parseEntityName(/*allowReservedWords*/ false);
                        while(token() === 81 /* PrivateIdentifier */ ){
                            reScanHashToken();
                            nextTokenJSDoc();
                            entityName = finishNode(factory2.createJSDocMemberName(entityName, parseIdentifier()), p2);
                        }
                        if (hasBrace) parseExpectedJSDoc(20 /* CloseBraceToken */ );
                        const result = factory2.createJSDocNameReference(entityName);
                        fixupParentReferences(result);
                        return finishNode(result, pos);
                    }
                    JSDocParser2.parseJSDocNameReference = parseJSDocNameReference;
                    function parseIsolatedJSDocComment2(content, start, length2) {
                        initializeState("", content, 99 /* Latest */ , /*syntaxCursor*/ void 0, 1 /* JS */ );
                        const jsDoc = doInsideOfContext(8388608 /* JSDoc */ , ()=>parseJSDocCommentWorker(start, length2));
                        const sourceFile = {
                            languageVariant: 0 /* Standard */ ,
                            text: content
                        };
                        const diagnostics = attachFileToDiagnostics(parseDiagnostics, sourceFile);
                        clearState();
                        return jsDoc ? {
                            jsDoc: jsDoc,
                            diagnostics: diagnostics
                        } : void 0;
                    }
                    JSDocParser2.parseIsolatedJSDocComment = parseIsolatedJSDocComment2;
                    function parseJSDocComment(parent2, start, length2) {
                        const saveToken = currentToken;
                        const saveParseDiagnosticsLength = parseDiagnostics.length;
                        const saveParseErrorBeforeNextFinishedNode = parseErrorBeforeNextFinishedNode;
                        const comment = doInsideOfContext(8388608 /* JSDoc */ , ()=>parseJSDocCommentWorker(start, length2));
                        setParent(comment, parent2);
                        if (contextFlags & 262144 /* JavaScriptFile */ ) {
                            if (!jsDocDiagnostics) jsDocDiagnostics = [];
                            jsDocDiagnostics.push(...parseDiagnostics);
                        }
                        currentToken = saveToken;
                        parseDiagnostics.length = saveParseDiagnosticsLength;
                        parseErrorBeforeNextFinishedNode = saveParseErrorBeforeNextFinishedNode;
                        return comment;
                    }
                    JSDocParser2.parseJSDocComment = parseJSDocComment;
                    let JSDocState;
                    ((JSDocState2)=>{
                        JSDocState2[JSDocState2["BeginningOfLine"] = 0] = "BeginningOfLine";
                        JSDocState2[JSDocState2["SawAsterisk"] = 1] = "SawAsterisk";
                        JSDocState2[JSDocState2["SavingComments"] = 2] = "SavingComments";
                        JSDocState2[JSDocState2["SavingBackticks"] = 3] = "SavingBackticks";
                    })(JSDocState || (JSDocState = {}));
                    let PropertyLikeParse;
                    ((PropertyLikeParse2)=>{
                        PropertyLikeParse2[PropertyLikeParse2["Property"] = 1] = "Property";
                        PropertyLikeParse2[PropertyLikeParse2["Parameter"] = 2] = "Parameter";
                        PropertyLikeParse2[PropertyLikeParse2["CallbackParameter"] = 4] = "CallbackParameter";
                    })(PropertyLikeParse || (PropertyLikeParse = {}));
                    function parseJSDocCommentWorker(start = 0, length2) {
                        const saveParsingContext = parsingContext;
                        parsingContext |= 33554432 /* JSDocComment */ ;
                        const content = sourceText;
                        const end = length2 === void 0 ? content.length : start + length2;
                        length2 = end - start;
                        Debug.assert(start >= 0);
                        Debug.assert(start <= end);
                        Debug.assert(end <= content.length);
                        if (!isJSDocLikeText(content, start)) return void 0;
                        let tags;
                        let tagsPos;
                        let tagsEnd;
                        let linkEnd;
                        let commentsPos;
                        let comments = [];
                        const parts = [];
                        const result = scanner2.scanRange(start + 3, length2 - 5, doJSDocScan);
                        parsingContext = saveParsingContext;
                        return result;
                        function doJSDocScan() {
                            let state = 1 /* SawAsterisk */ ;
                            let margin;
                            let indent2 = start - (content.lastIndexOf("\n", start) + 1) + 4;
                            function pushComment(text) {
                                if (!margin) margin = indent2;
                                comments.push(text);
                                indent2 += text.length;
                            }
                            nextTokenJSDoc();
                            while(parseOptionalJsdoc(5 /* WhitespaceTrivia */ ));
                            if (parseOptionalJsdoc(4 /* NewLineTrivia */ )) {
                                state = 0 /* BeginningOfLine */ ;
                                indent2 = 0;
                            }
                            loop: while(true){
                                switch(token()){
                                    case 60 /* AtToken */ :
                                        removeTrailingWhitespace(comments);
                                        if (!commentsPos) commentsPos = getNodePos();
                                        addTag(parseTag(indent2));
                                        state = 0 /* BeginningOfLine */ ;
                                        margin = void 0;
                                        break;
                                    case 4 /* NewLineTrivia */ :
                                        comments.push(scanner2.getTokenText());
                                        state = 0 /* BeginningOfLine */ ;
                                        indent2 = 0;
                                        break;
                                    case 42 /* AsteriskToken */ :
                                        const asterisk = scanner2.getTokenText();
                                        if (state === 1 /* SawAsterisk */ ) {
                                            state = 2 /* SavingComments */ ;
                                            pushComment(asterisk);
                                        } else {
                                            Debug.assert(state === 0 /* BeginningOfLine */ );
                                            state = 1 /* SawAsterisk */ ;
                                            indent2 += asterisk.length;
                                        }
                                        break;
                                    case 5 /* WhitespaceTrivia */ :
                                        Debug.assert(state !== 2 /* SavingComments */ , "whitespace shouldn't come from the scanner while saving top-level comment text");
                                        const whitespace = scanner2.getTokenText();
                                        if (margin !== void 0 && indent2 + whitespace.length > margin) comments.push(whitespace.slice(margin - indent2));
                                        indent2 += whitespace.length;
                                        break;
                                    case 1 /* EndOfFileToken */ :
                                        break loop;
                                    case 82 /* JSDocCommentTextToken */ :
                                        state = 2 /* SavingComments */ ;
                                        pushComment(scanner2.getTokenValue());
                                        break;
                                    case 19 /* OpenBraceToken */ :
                                        state = 2 /* SavingComments */ ;
                                        const commentEnd = scanner2.getTokenFullStart();
                                        const linkStart = scanner2.getTokenEnd() - 1;
                                        const link = parseJSDocLink(linkStart);
                                        if (link) {
                                            if (!linkEnd) removeLeadingNewlines(comments);
                                            parts.push(finishNode(factory2.createJSDocText(comments.join("")), linkEnd ?? start, commentEnd));
                                            parts.push(link);
                                            comments = [];
                                            linkEnd = scanner2.getTokenEnd();
                                            break;
                                        }
                                    default:
                                        state = 2 /* SavingComments */ ;
                                        pushComment(scanner2.getTokenText());
                                        break;
                                }
                                if (state === 2 /* SavingComments */ ) nextJSDocCommentTextToken(/*inBackticks*/ false);
                                else nextTokenJSDoc();
                            }
                            const trimmedComments = trimStringEnd(comments.join(""));
                            if (parts.length && trimmedComments.length) parts.push(finishNode(factory2.createJSDocText(trimmedComments), linkEnd ?? start, commentsPos));
                            if (parts.length && tags) Debug.assertIsDefined(commentsPos, "having parsed tags implies that the end of the comment span should be set");
                            const tagsArray = tags && createNodeArray(tags, tagsPos, tagsEnd);
                            return finishNode(factory2.createJSDocComment(parts.length ? createNodeArray(parts, start, commentsPos) : trimmedComments.length ? trimmedComments : void 0, tagsArray), start, end);
                        }
                        function removeLeadingNewlines(comments2) {
                            while(comments2.length && (comments2[0] === "\n" || comments2[0] === "\r"))comments2.shift();
                        }
                        function removeTrailingWhitespace(comments2) {
                            while(comments2.length){
                                const trimmed = trimStringEnd(comments2[comments2.length - 1]);
                                if (trimmed === "") comments2.pop();
                                else if (trimmed.length < comments2[comments2.length - 1].length) {
                                    comments2[comments2.length - 1] = trimmed;
                                    break;
                                } else break;
                            }
                        }
                        function isNextNonwhitespaceTokenEndOfFile() {
                            while(true){
                                nextTokenJSDoc();
                                if (token() === 1 /* EndOfFileToken */ ) return true;
                                if (!(token() === 5 /* WhitespaceTrivia */  || token() === 4 /* NewLineTrivia */ )) return false;
                            }
                        }
                        function skipWhitespace() {
                            if (token() === 5 /* WhitespaceTrivia */  || token() === 4 /* NewLineTrivia */ ) {
                                if (lookAhead(isNextNonwhitespaceTokenEndOfFile)) return;
                            }
                            while(token() === 5 /* WhitespaceTrivia */  || token() === 4 /* NewLineTrivia */ )nextTokenJSDoc();
                        }
                        function skipWhitespaceOrAsterisk() {
                            if (token() === 5 /* WhitespaceTrivia */  || token() === 4 /* NewLineTrivia */ ) {
                                if (lookAhead(isNextNonwhitespaceTokenEndOfFile)) return "";
                            }
                            let precedingLineBreak = scanner2.hasPrecedingLineBreak();
                            let seenLineBreak = false;
                            let indentText = "";
                            while(precedingLineBreak && token() === 42 /* AsteriskToken */  || token() === 5 /* WhitespaceTrivia */  || token() === 4 /* NewLineTrivia */ ){
                                indentText += scanner2.getTokenText();
                                if (token() === 4 /* NewLineTrivia */ ) {
                                    precedingLineBreak = true;
                                    seenLineBreak = true;
                                    indentText = "";
                                } else if (token() === 42 /* AsteriskToken */ ) precedingLineBreak = false;
                                nextTokenJSDoc();
                            }
                            return seenLineBreak ? indentText : "";
                        }
                        function parseTag(margin) {
                            Debug.assert(token() === 60 /* AtToken */ );
                            const start2 = scanner2.getTokenStart();
                            nextTokenJSDoc();
                            const tagName = parseJSDocIdentifierName(/*message*/ void 0);
                            const indentText = skipWhitespaceOrAsterisk();
                            let tag;
                            switch(tagName.escapedText){
                                case "author":
                                    tag = parseAuthorTag(start2, tagName, margin, indentText);
                                    break;
                                case "implements":
                                    tag = parseImplementsTag(start2, tagName, margin, indentText);
                                    break;
                                case "augments":
                                case "extends":
                                    tag = parseAugmentsTag(start2, tagName, margin, indentText);
                                    break;
                                case "class":
                                case "constructor":
                                    tag = parseSimpleTag(start2, factory2.createJSDocClassTag, tagName, margin, indentText);
                                    break;
                                case "public":
                                    tag = parseSimpleTag(start2, factory2.createJSDocPublicTag, tagName, margin, indentText);
                                    break;
                                case "private":
                                    tag = parseSimpleTag(start2, factory2.createJSDocPrivateTag, tagName, margin, indentText);
                                    break;
                                case "protected":
                                    tag = parseSimpleTag(start2, factory2.createJSDocProtectedTag, tagName, margin, indentText);
                                    break;
                                case "readonly":
                                    tag = parseSimpleTag(start2, factory2.createJSDocReadonlyTag, tagName, margin, indentText);
                                    break;
                                case "override":
                                    tag = parseSimpleTag(start2, factory2.createJSDocOverrideTag, tagName, margin, indentText);
                                    break;
                                case "deprecated":
                                    hasDeprecatedTag = true;
                                    tag = parseSimpleTag(start2, factory2.createJSDocDeprecatedTag, tagName, margin, indentText);
                                    break;
                                case "this":
                                    tag = parseThisTag(start2, tagName, margin, indentText);
                                    break;
                                case "enum":
                                    tag = parseEnumTag(start2, tagName, margin, indentText);
                                    break;
                                case "arg":
                                case "argument":
                                case "param":
                                    return parseParameterOrPropertyTag(start2, tagName, 2 /* Parameter */ , margin);
                                case "return":
                                case "returns":
                                    tag = parseReturnTag(start2, tagName, margin, indentText);
                                    break;
                                case "template":
                                    tag = parseTemplateTag(start2, tagName, margin, indentText);
                                    break;
                                case "type":
                                    tag = parseTypeTag(start2, tagName, margin, indentText);
                                    break;
                                case "typedef":
                                    tag = parseTypedefTag(start2, tagName, margin, indentText);
                                    break;
                                case "callback":
                                    tag = parseCallbackTag(start2, tagName, margin, indentText);
                                    break;
                                case "overload":
                                    tag = parseOverloadTag(start2, tagName, margin, indentText);
                                    break;
                                case "satisfies":
                                    tag = parseSatisfiesTag(start2, tagName, margin, indentText);
                                    break;
                                case "see":
                                    tag = parseSeeTag(start2, tagName, margin, indentText);
                                    break;
                                case "exception":
                                case "throws":
                                    tag = parseThrowsTag(start2, tagName, margin, indentText);
                                    break;
                                default:
                                    tag = parseUnknownTag(start2, tagName, margin, indentText);
                                    break;
                            }
                            return tag;
                        }
                        function parseTrailingTagComments(pos, end2, margin, indentText) {
                            if (!indentText) margin += end2 - pos;
                            return parseTagComments(margin, indentText.slice(margin));
                        }
                        function parseTagComments(indent2, initialMargin) {
                            const commentsPos2 = getNodePos();
                            let comments2 = [];
                            const parts2 = [];
                            let linkEnd2;
                            let state = 0 /* BeginningOfLine */ ;
                            let margin;
                            function pushComment(text) {
                                if (!margin) margin = indent2;
                                comments2.push(text);
                                indent2 += text.length;
                            }
                            if (initialMargin !== void 0) {
                                if (initialMargin !== "") pushComment(initialMargin);
                                state = 1 /* SawAsterisk */ ;
                            }
                            let tok = token();
                            loop: while(true){
                                switch(tok){
                                    case 4 /* NewLineTrivia */ :
                                        state = 0 /* BeginningOfLine */ ;
                                        comments2.push(scanner2.getTokenText());
                                        indent2 = 0;
                                        break;
                                    case 60 /* AtToken */ :
                                        scanner2.resetTokenState(scanner2.getTokenEnd() - 1);
                                        break loop;
                                    case 1 /* EndOfFileToken */ :
                                        break loop;
                                    case 5 /* WhitespaceTrivia */ :
                                        Debug.assert(state !== 2 /* SavingComments */  && state !== 3 /* SavingBackticks */ , "whitespace shouldn't come from the scanner while saving comment text");
                                        const whitespace = scanner2.getTokenText();
                                        if (margin !== void 0 && indent2 + whitespace.length > margin) {
                                            comments2.push(whitespace.slice(margin - indent2));
                                            state = 2 /* SavingComments */ ;
                                        }
                                        indent2 += whitespace.length;
                                        break;
                                    case 19 /* OpenBraceToken */ :
                                        state = 2 /* SavingComments */ ;
                                        const commentEnd = scanner2.getTokenFullStart();
                                        const linkStart = scanner2.getTokenEnd() - 1;
                                        const link = parseJSDocLink(linkStart);
                                        if (link) {
                                            parts2.push(finishNode(factory2.createJSDocText(comments2.join("")), linkEnd2 ?? commentsPos2, commentEnd));
                                            parts2.push(link);
                                            comments2 = [];
                                            linkEnd2 = scanner2.getTokenEnd();
                                        } else pushComment(scanner2.getTokenText());
                                        break;
                                    case 62 /* BacktickToken */ :
                                        if (state === 3 /* SavingBackticks */ ) state = 2 /* SavingComments */ ;
                                        else state = 3 /* SavingBackticks */ ;
                                        pushComment(scanner2.getTokenText());
                                        break;
                                    case 82 /* JSDocCommentTextToken */ :
                                        if (state !== 3 /* SavingBackticks */ ) state = 2 /* SavingComments */ ;
                                        pushComment(scanner2.getTokenValue());
                                        break;
                                    case 42 /* AsteriskToken */ :
                                        if (state === 0 /* BeginningOfLine */ ) {
                                            state = 1 /* SawAsterisk */ ;
                                            indent2 += 1;
                                            break;
                                        }
                                    default:
                                        if (state !== 3 /* SavingBackticks */ ) state = 2 /* SavingComments */ ;
                                        pushComment(scanner2.getTokenText());
                                        break;
                                }
                                if (state === 2 /* SavingComments */  || state === 3 /* SavingBackticks */ ) tok = nextJSDocCommentTextToken(state === 3 /* SavingBackticks */ );
                                else tok = nextTokenJSDoc();
                            }
                            removeLeadingNewlines(comments2);
                            const trimmedComments = trimStringEnd(comments2.join(""));
                            if (parts2.length) {
                                if (trimmedComments.length) parts2.push(finishNode(factory2.createJSDocText(trimmedComments), linkEnd2 ?? commentsPos2));
                                return createNodeArray(parts2, commentsPos2, scanner2.getTokenEnd());
                            } else if (trimmedComments.length) return trimmedComments;
                        }
                        function parseJSDocLink(start2) {
                            const linkType = tryParse(parseJSDocLinkPrefix);
                            if (!linkType) return void 0;
                            nextTokenJSDoc();
                            skipWhitespace();
                            const p2 = getNodePos();
                            let name = tokenIsIdentifierOrKeyword(token()) ? parseEntityName(/*allowReservedWords*/ true) : void 0;
                            if (name) while(token() === 81 /* PrivateIdentifier */ ){
                                reScanHashToken();
                                nextTokenJSDoc();
                                name = finishNode(factory2.createJSDocMemberName(name, parseIdentifier()), p2);
                            }
                            const text = [];
                            while(token() !== 20 /* CloseBraceToken */  && token() !== 4 /* NewLineTrivia */  && token() !== 1 /* EndOfFileToken */ ){
                                text.push(scanner2.getTokenText());
                                nextTokenJSDoc();
                            }
                            const create = linkType === "link" ? factory2.createJSDocLink : linkType === "linkcode" ? factory2.createJSDocLinkCode : factory2.createJSDocLinkPlain;
                            return finishNode(create(name, text.join("")), start2, scanner2.getTokenEnd());
                        }
                        function parseJSDocLinkPrefix() {
                            skipWhitespaceOrAsterisk();
                            if (token() === 19 /* OpenBraceToken */  && nextTokenJSDoc() === 60 /* AtToken */  && tokenIsIdentifierOrKeyword(nextTokenJSDoc())) {
                                const kind = scanner2.getTokenValue();
                                if (isJSDocLinkTag(kind)) return kind;
                            }
                        }
                        function isJSDocLinkTag(kind) {
                            return kind === "link" || kind === "linkcode" || kind === "linkplain";
                        }
                        function parseUnknownTag(start2, tagName, indent2, indentText) {
                            return finishNode(factory2.createJSDocUnknownTag(tagName, parseTrailingTagComments(start2, getNodePos(), indent2, indentText)), start2);
                        }
                        function addTag(tag) {
                            if (!tag) return;
                            if (!tags) {
                                tags = [
                                    tag
                                ];
                                tagsPos = tag.pos;
                            } else tags.push(tag);
                            tagsEnd = tag.end;
                        }
                        function tryParseTypeExpression() {
                            skipWhitespaceOrAsterisk();
                            return token() === 19 /* OpenBraceToken */  ? parseJSDocTypeExpression() : void 0;
                        }
                        function parseBracketNameInPropertyAndParamTag() {
                            const isBracketed = parseOptionalJsdoc(23 /* OpenBracketToken */ );
                            if (isBracketed) skipWhitespace();
                            const isBackquoted = parseOptionalJsdoc(62 /* BacktickToken */ );
                            const name = parseJSDocEntityName();
                            if (isBackquoted) parseExpectedTokenJSDoc(62 /* BacktickToken */ );
                            if (isBracketed) {
                                skipWhitespace();
                                if (parseOptionalToken(64 /* EqualsToken */ )) parseExpression();
                                parseExpected(24 /* CloseBracketToken */ );
                            }
                            return {
                                name: name,
                                isBracketed: isBracketed
                            };
                        }
                        function isObjectOrObjectArrayTypeReference(node) {
                            switch(node.kind){
                                case 151 /* ObjectKeyword */ :
                                    return true;
                                case 187 /* ArrayType */ :
                                    return isObjectOrObjectArrayTypeReference(node.elementType);
                                default:
                                    return isTypeReferenceNode(node) && isIdentifier(node.typeName) && node.typeName.escapedText === "Object" && !node.typeArguments;
                            }
                        }
                        function parseParameterOrPropertyTag(start2, tagName, target, indent2) {
                            let typeExpression = tryParseTypeExpression();
                            let isNameFirst = !typeExpression;
                            skipWhitespaceOrAsterisk();
                            const { name: name , isBracketed: isBracketed  } = parseBracketNameInPropertyAndParamTag();
                            const indentText = skipWhitespaceOrAsterisk();
                            if (isNameFirst && !lookAhead(parseJSDocLinkPrefix)) typeExpression = tryParseTypeExpression();
                            const comment = parseTrailingTagComments(start2, getNodePos(), indent2, indentText);
                            const nestedTypeLiteral = target !== 4 /* CallbackParameter */  && parseNestedTypeLiteral(typeExpression, name, target, indent2);
                            if (nestedTypeLiteral) {
                                typeExpression = nestedTypeLiteral;
                                isNameFirst = true;
                            }
                            const result2 = target === 1 /* Property */  ? factory2.createJSDocPropertyTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment) : factory2.createJSDocParameterTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment);
                            return finishNode(result2, start2);
                        }
                        function parseNestedTypeLiteral(typeExpression, name, target, indent2) {
                            if (typeExpression && isObjectOrObjectArrayTypeReference(typeExpression.type)) {
                                const pos = getNodePos();
                                let child;
                                let children;
                                while(child = tryParse(()=>parseChildParameterOrPropertyTag(target, indent2, name))){
                                    if (child.kind === 347 /* JSDocParameterTag */  || child.kind === 354 /* JSDocPropertyTag */ ) children = append(children, child);
                                    else if (child.kind === 351 /* JSDocTemplateTag */ ) parseErrorAtRange(child.tagName, Diagnostics.A_JSDoc_template_tag_may_not_follow_a_typedef_callback_or_overload_tag);
                                }
                                if (children) {
                                    const literal = finishNode(factory2.createJSDocTypeLiteral(children, typeExpression.type.kind === 187 /* ArrayType */ ), pos);
                                    return finishNode(factory2.createJSDocTypeExpression(literal), pos);
                                }
                            }
                        }
                        function parseReturnTag(start2, tagName, indent2, indentText) {
                            if (some(tags, isJSDocReturnTag)) parseErrorAt(tagName.pos, scanner2.getTokenStart(), Diagnostics._0_tag_already_specified, unescapeLeadingUnderscores(tagName.escapedText));
                            const typeExpression = tryParseTypeExpression();
                            return finishNode(factory2.createJSDocReturnTag(tagName, typeExpression, parseTrailingTagComments(start2, getNodePos(), indent2, indentText)), start2);
                        }
                        function parseTypeTag(start2, tagName, indent2, indentText) {
                            if (some(tags, isJSDocTypeTag)) parseErrorAt(tagName.pos, scanner2.getTokenStart(), Diagnostics._0_tag_already_specified, unescapeLeadingUnderscores(tagName.escapedText));
                            const typeExpression = parseJSDocTypeExpression(/*mayOmitBraces*/ true);
                            const comments2 = indent2 !== void 0 && indentText !== void 0 ? parseTrailingTagComments(start2, getNodePos(), indent2, indentText) : void 0;
                            return finishNode(factory2.createJSDocTypeTag(tagName, typeExpression, comments2), start2);
                        }
                        function parseSeeTag(start2, tagName, indent2, indentText) {
                            const isMarkdownOrJSDocLink = token() === 23 /* OpenBracketToken */  || lookAhead(()=>nextTokenJSDoc() === 60 /* AtToken */  && tokenIsIdentifierOrKeyword(nextTokenJSDoc()) && isJSDocLinkTag(scanner2.getTokenValue()));
                            const nameExpression = isMarkdownOrJSDocLink ? void 0 : parseJSDocNameReference();
                            const comments2 = indent2 !== void 0 && indentText !== void 0 ? parseTrailingTagComments(start2, getNodePos(), indent2, indentText) : void 0;
                            return finishNode(factory2.createJSDocSeeTag(tagName, nameExpression, comments2), start2);
                        }
                        function parseThrowsTag(start2, tagName, indent2, indentText) {
                            const typeExpression = tryParseTypeExpression();
                            const comment = parseTrailingTagComments(start2, getNodePos(), indent2, indentText);
                            return finishNode(factory2.createJSDocThrowsTag(tagName, typeExpression, comment), start2);
                        }
                        function parseAuthorTag(start2, tagName, indent2, indentText) {
                            const commentStart = getNodePos();
                            const textOnly = parseAuthorNameAndEmail();
                            let commentEnd = scanner2.getTokenFullStart();
                            const comments2 = parseTrailingTagComments(start2, commentEnd, indent2, indentText);
                            if (!comments2) commentEnd = scanner2.getTokenFullStart();
                            const allParts = typeof comments2 !== "string" ? createNodeArray(concatenate([
                                finishNode(textOnly, commentStart, commentEnd)
                            ], comments2), commentStart) : textOnly.text + comments2;
                            return finishNode(factory2.createJSDocAuthorTag(tagName, allParts), start2);
                        }
                        function parseAuthorNameAndEmail() {
                            const comments2 = [];
                            let inEmail = false;
                            let token2 = scanner2.getToken();
                            while(token2 !== 1 /* EndOfFileToken */  && token2 !== 4 /* NewLineTrivia */ ){
                                if (token2 === 30 /* LessThanToken */ ) inEmail = true;
                                else if (token2 === 60 /* AtToken */  && !inEmail) break;
                                else if (token2 === 32 /* GreaterThanToken */  && inEmail) {
                                    comments2.push(scanner2.getTokenText());
                                    scanner2.resetTokenState(scanner2.getTokenEnd());
                                    break;
                                }
                                comments2.push(scanner2.getTokenText());
                                token2 = nextTokenJSDoc();
                            }
                            return factory2.createJSDocText(comments2.join(""));
                        }
                        function parseImplementsTag(start2, tagName, margin, indentText) {
                            const className = parseExpressionWithTypeArgumentsForAugments();
                            return finishNode(factory2.createJSDocImplementsTag(tagName, className, parseTrailingTagComments(start2, getNodePos(), margin, indentText)), start2);
                        }
                        function parseAugmentsTag(start2, tagName, margin, indentText) {
                            const className = parseExpressionWithTypeArgumentsForAugments();
                            return finishNode(factory2.createJSDocAugmentsTag(tagName, className, parseTrailingTagComments(start2, getNodePos(), margin, indentText)), start2);
                        }
                        function parseSatisfiesTag(start2, tagName, margin, indentText) {
                            const typeExpression = parseJSDocTypeExpression(/*mayOmitBraces*/ false);
                            const comments2 = margin !== void 0 && indentText !== void 0 ? parseTrailingTagComments(start2, getNodePos(), margin, indentText) : void 0;
                            return finishNode(factory2.createJSDocSatisfiesTag(tagName, typeExpression, comments2), start2);
                        }
                        function parseExpressionWithTypeArgumentsForAugments() {
                            const usedBrace = parseOptional(19 /* OpenBraceToken */ );
                            const pos = getNodePos();
                            const expression = parsePropertyAccessEntityNameExpression();
                            scanner2.setInJSDocType(true);
                            const typeArguments = tryParseTypeArguments();
                            scanner2.setInJSDocType(false);
                            const node = factory2.createExpressionWithTypeArguments(expression, typeArguments);
                            const res = finishNode(node, pos);
                            if (usedBrace) parseExpected(20 /* CloseBraceToken */ );
                            return res;
                        }
                        function parsePropertyAccessEntityNameExpression() {
                            const pos = getNodePos();
                            let node = parseJSDocIdentifierName();
                            while(parseOptional(25 /* DotToken */ )){
                                const name = parseJSDocIdentifierName();
                                node = finishNode(factoryCreatePropertyAccessExpression(node, name), pos);
                            }
                            return node;
                        }
                        function parseSimpleTag(start2, createTag, tagName, margin, indentText) {
                            return finishNode(createTag(tagName, parseTrailingTagComments(start2, getNodePos(), margin, indentText)), start2);
                        }
                        function parseThisTag(start2, tagName, margin, indentText) {
                            const typeExpression = parseJSDocTypeExpression(/*mayOmitBraces*/ true);
                            skipWhitespace();
                            return finishNode(factory2.createJSDocThisTag(tagName, typeExpression, parseTrailingTagComments(start2, getNodePos(), margin, indentText)), start2);
                        }
                        function parseEnumTag(start2, tagName, margin, indentText) {
                            const typeExpression = parseJSDocTypeExpression(/*mayOmitBraces*/ true);
                            skipWhitespace();
                            return finishNode(factory2.createJSDocEnumTag(tagName, typeExpression, parseTrailingTagComments(start2, getNodePos(), margin, indentText)), start2);
                        }
                        function parseTypedefTag(start2, tagName, indent2, indentText) {
                            let typeExpression = tryParseTypeExpression();
                            skipWhitespaceOrAsterisk();
                            const fullName = parseJSDocTypeNameWithNamespace();
                            skipWhitespace();
                            let comment = parseTagComments(indent2);
                            let end2;
                            if (!typeExpression || isObjectOrObjectArrayTypeReference(typeExpression.type)) {
                                let child;
                                let childTypeTag;
                                let jsDocPropertyTags;
                                let hasChildren = false;
                                while(child = tryParse(()=>parseChildPropertyTag(indent2))){
                                    if (child.kind === 351 /* JSDocTemplateTag */ ) break;
                                    hasChildren = true;
                                    if (child.kind === 350 /* JSDocTypeTag */ ) {
                                        if (childTypeTag) {
                                            const lastError = parseErrorAtCurrentToken(Diagnostics.A_JSDoc_typedef_comment_may_not_contain_multiple_type_tags);
                                            if (lastError) addRelatedInfo(lastError, createDetachedDiagnostic(fileName, 0, 0, Diagnostics.The_tag_was_first_specified_here));
                                            break;
                                        } else childTypeTag = child;
                                    } else jsDocPropertyTags = append(jsDocPropertyTags, child);
                                }
                                if (hasChildren) {
                                    const isArrayType = typeExpression && typeExpression.type.kind === 187 /* ArrayType */ ;
                                    const jsdocTypeLiteral = factory2.createJSDocTypeLiteral(jsDocPropertyTags, isArrayType);
                                    typeExpression = childTypeTag && childTypeTag.typeExpression && !isObjectOrObjectArrayTypeReference(childTypeTag.typeExpression.type) ? childTypeTag.typeExpression : finishNode(jsdocTypeLiteral, start2);
                                    end2 = typeExpression.end;
                                }
                            }
                            end2 = end2 || comment !== void 0 ? getNodePos() : (fullName ?? typeExpression ?? tagName).end;
                            if (!comment) comment = parseTrailingTagComments(start2, end2, indent2, indentText);
                            const typedefTag = factory2.createJSDocTypedefTag(tagName, typeExpression, fullName, comment);
                            return finishNode(typedefTag, start2, end2);
                        }
                        function parseJSDocTypeNameWithNamespace(nested) {
                            const start2 = scanner2.getTokenStart();
                            if (!tokenIsIdentifierOrKeyword(token())) return void 0;
                            const typeNameOrNamespaceName = parseJSDocIdentifierName();
                            if (parseOptional(25 /* DotToken */ )) {
                                const body = parseJSDocTypeNameWithNamespace(/*nested*/ true);
                                const jsDocNamespaceNode = factory2.createModuleDeclaration(/*modifiers*/ void 0, typeNameOrNamespaceName, body, nested ? 4 /* NestedNamespace */  : void 0);
                                return finishNode(jsDocNamespaceNode, start2);
                            }
                            if (nested) typeNameOrNamespaceName.flags |= 2048 /* IdentifierIsInJSDocNamespace */ ;
                            return typeNameOrNamespaceName;
                        }
                        function parseCallbackTagParameters(indent2) {
                            const pos = getNodePos();
                            let child;
                            let parameters;
                            while(child = tryParse(()=>parseChildParameterOrPropertyTag(4 /* CallbackParameter */ , indent2))){
                                if (child.kind === 351 /* JSDocTemplateTag */ ) {
                                    parseErrorAtRange(child.tagName, Diagnostics.A_JSDoc_template_tag_may_not_follow_a_typedef_callback_or_overload_tag);
                                    break;
                                }
                                parameters = append(parameters, child);
                            }
                            return createNodeArray(parameters || [], pos);
                        }
                        function parseJSDocSignature(start2, indent2) {
                            const parameters = parseCallbackTagParameters(indent2);
                            const returnTag = tryParse(()=>{
                                if (parseOptionalJsdoc(60 /* AtToken */ )) {
                                    const tag = parseTag(indent2);
                                    if (tag && tag.kind === 348 /* JSDocReturnTag */ ) return tag;
                                }
                            });
                            return finishNode(factory2.createJSDocSignature(/*typeParameters*/ void 0, parameters, returnTag), start2);
                        }
                        function parseCallbackTag(start2, tagName, indent2, indentText) {
                            const fullName = parseJSDocTypeNameWithNamespace();
                            skipWhitespace();
                            let comment = parseTagComments(indent2);
                            const typeExpression = parseJSDocSignature(start2, indent2);
                            if (!comment) comment = parseTrailingTagComments(start2, getNodePos(), indent2, indentText);
                            const end2 = comment !== void 0 ? getNodePos() : typeExpression.end;
                            return finishNode(factory2.createJSDocCallbackTag(tagName, typeExpression, fullName, comment), start2, end2);
                        }
                        function parseOverloadTag(start2, tagName, indent2, indentText) {
                            skipWhitespace();
                            let comment = parseTagComments(indent2);
                            const typeExpression = parseJSDocSignature(start2, indent2);
                            if (!comment) comment = parseTrailingTagComments(start2, getNodePos(), indent2, indentText);
                            const end2 = comment !== void 0 ? getNodePos() : typeExpression.end;
                            return finishNode(factory2.createJSDocOverloadTag(tagName, typeExpression, comment), start2, end2);
                        }
                        function escapedTextsEqual(a, b) {
                            while(!isIdentifier(a) || !isIdentifier(b)){
                                if (!isIdentifier(a) && !isIdentifier(b) && a.right.escapedText === b.right.escapedText) {
                                    a = a.left;
                                    b = b.left;
                                } else return false;
                            }
                            return a.escapedText === b.escapedText;
                        }
                        function parseChildPropertyTag(indent2) {
                            return parseChildParameterOrPropertyTag(1 /* Property */ , indent2);
                        }
                        function parseChildParameterOrPropertyTag(target, indent2, name) {
                            let canParseTag = true;
                            let seenAsterisk = false;
                            while(true)switch(nextTokenJSDoc()){
                                case 60 /* AtToken */ :
                                    if (canParseTag) {
                                        const child = tryParseChildTag(target, indent2);
                                        if (child && (child.kind === 347 /* JSDocParameterTag */  || child.kind === 354 /* JSDocPropertyTag */ ) && target !== 4 /* CallbackParameter */  && name && (isIdentifier(child.name) || !escapedTextsEqual(name, child.name.left))) return false;
                                        return child;
                                    }
                                    seenAsterisk = false;
                                    break;
                                case 4 /* NewLineTrivia */ :
                                    canParseTag = true;
                                    seenAsterisk = false;
                                    break;
                                case 42 /* AsteriskToken */ :
                                    if (seenAsterisk) canParseTag = false;
                                    seenAsterisk = true;
                                    break;
                                case 80 /* Identifier */ :
                                    canParseTag = false;
                                    break;
                                case 1 /* EndOfFileToken */ :
                                    return false;
                            }
                        }
                        function tryParseChildTag(target, indent2) {
                            Debug.assert(token() === 60 /* AtToken */ );
                            const start2 = scanner2.getTokenFullStart();
                            nextTokenJSDoc();
                            const tagName = parseJSDocIdentifierName();
                            const indentText = skipWhitespaceOrAsterisk();
                            let t;
                            switch(tagName.escapedText){
                                case "type":
                                    return target === 1 /* Property */  && parseTypeTag(start2, tagName);
                                case "prop":
                                case "property":
                                    t = 1 /* Property */ ;
                                    break;
                                case "arg":
                                case "argument":
                                case "param":
                                    t = 6 /* CallbackParameter */ ;
                                    break;
                                case "template":
                                    return parseTemplateTag(start2, tagName, indent2, indentText);
                                default:
                                    return false;
                            }
                            if (!(target & t)) return false;
                            return parseParameterOrPropertyTag(start2, tagName, target, indent2);
                        }
                        function parseTemplateTagTypeParameter() {
                            const typeParameterPos = getNodePos();
                            const isBracketed = parseOptionalJsdoc(23 /* OpenBracketToken */ );
                            if (isBracketed) skipWhitespace();
                            const name = parseJSDocIdentifierName(Diagnostics.Unexpected_token_A_type_parameter_name_was_expected_without_curly_braces);
                            let defaultType;
                            if (isBracketed) {
                                skipWhitespace();
                                parseExpected(64 /* EqualsToken */ );
                                defaultType = doInsideOfContext(8388608 /* JSDoc */ , parseJSDocType);
                                parseExpected(24 /* CloseBracketToken */ );
                            }
                            if (nodeIsMissing(name)) return void 0;
                            return finishNode(factory2.createTypeParameterDeclaration(/*modifiers*/ void 0, name, /*constraint*/ void 0, defaultType), typeParameterPos);
                        }
                        function parseTemplateTagTypeParameters() {
                            const pos = getNodePos();
                            const typeParameters = [];
                            do {
                                skipWhitespace();
                                const node = parseTemplateTagTypeParameter();
                                if (node !== void 0) typeParameters.push(node);
                                skipWhitespaceOrAsterisk();
                            }while (parseOptionalJsdoc(28 /* CommaToken */ ));
                            return createNodeArray(typeParameters, pos);
                        }
                        function parseTemplateTag(start2, tagName, indent2, indentText) {
                            const constraint = token() === 19 /* OpenBraceToken */  ? parseJSDocTypeExpression() : void 0;
                            const typeParameters = parseTemplateTagTypeParameters();
                            return finishNode(factory2.createJSDocTemplateTag(tagName, constraint, typeParameters, parseTrailingTagComments(start2, getNodePos(), indent2, indentText)), start2);
                        }
                        function parseOptionalJsdoc(t) {
                            if (token() === t) {
                                nextTokenJSDoc();
                                return true;
                            }
                            return false;
                        }
                        function parseJSDocEntityName() {
                            let entity = parseJSDocIdentifierName();
                            if (parseOptional(23 /* OpenBracketToken */ )) parseExpected(24 /* CloseBracketToken */ );
                            while(parseOptional(25 /* DotToken */ )){
                                const name = parseJSDocIdentifierName();
                                if (parseOptional(23 /* OpenBracketToken */ )) parseExpected(24 /* CloseBracketToken */ );
                                entity = createQualifiedName(entity, name);
                            }
                            return entity;
                        }
                        function parseJSDocIdentifierName(message) {
                            if (!tokenIsIdentifierOrKeyword(token())) return createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ !message, message || Diagnostics.Identifier_expected);
                            identifierCount++;
                            const start2 = scanner2.getTokenStart();
                            const end2 = scanner2.getTokenEnd();
                            const originalKeywordKind = token();
                            const text = internIdentifier(scanner2.getTokenValue());
                            const result2 = finishNode(factoryCreateIdentifier(text, originalKeywordKind), start2, end2);
                            nextTokenJSDoc();
                            return result2;
                        }
                    }
                })(JSDocParser = Parser2.JSDocParser || (Parser2.JSDocParser = {}));
            })(Parser || (Parser = {}));
            ((IncrementalParser2)=>{
                function updateSourceFile2(sourceFile, newText, textChangeRange, aggressiveChecks) {
                    aggressiveChecks = aggressiveChecks || Debug.shouldAssert(2 /* Aggressive */ );
                    checkChangeRange(sourceFile, newText, textChangeRange, aggressiveChecks);
                    if (textChangeRangeIsUnchanged(textChangeRange)) return sourceFile;
                    if (sourceFile.statements.length === 0) return Parser.parseSourceFile(sourceFile.fileName, newText, sourceFile.languageVersion, /*syntaxCursor*/ void 0, /*setParentNodes*/ true, sourceFile.scriptKind, sourceFile.setExternalModuleIndicator);
                    const incrementalSourceFile = sourceFile;
                    Debug.assert(!incrementalSourceFile.hasBeenIncrementallyParsed);
                    incrementalSourceFile.hasBeenIncrementallyParsed = true;
                    Parser.fixupParentReferences(incrementalSourceFile);
                    const oldText = sourceFile.text;
                    const syntaxCursor = createSyntaxCursor(sourceFile);
                    const changeRange = extendToAffectedRange(sourceFile, textChangeRange);
                    checkChangeRange(sourceFile, newText, changeRange, aggressiveChecks);
                    Debug.assert(changeRange.span.start <= textChangeRange.span.start);
                    Debug.assert(textSpanEnd(changeRange.span) === textSpanEnd(textChangeRange.span));
                    Debug.assert(textSpanEnd(textChangeRangeNewSpan(changeRange)) === textSpanEnd(textChangeRangeNewSpan(textChangeRange)));
                    const delta = textChangeRangeNewSpan(changeRange).length - changeRange.span.length;
                    updateTokenPositionsAndMarkElements(incrementalSourceFile, changeRange.span.start, textSpanEnd(changeRange.span), textSpanEnd(textChangeRangeNewSpan(changeRange)), delta, oldText, newText, aggressiveChecks);
                    const result = Parser.parseSourceFile(sourceFile.fileName, newText, sourceFile.languageVersion, syntaxCursor, /*setParentNodes*/ true, sourceFile.scriptKind, sourceFile.setExternalModuleIndicator);
                    result.commentDirectives = getNewCommentDirectives(sourceFile.commentDirectives, result.commentDirectives, changeRange.span.start, textSpanEnd(changeRange.span), delta, oldText, newText, aggressiveChecks);
                    result.impliedNodeFormat = sourceFile.impliedNodeFormat;
                    return result;
                }
                IncrementalParser2.updateSourceFile = updateSourceFile2;
                function getNewCommentDirectives(oldDirectives, newDirectives, changeStart, changeRangeOldEnd, delta, oldText, newText, aggressiveChecks) {
                    if (!oldDirectives) return newDirectives;
                    let commentDirectives;
                    let addedNewlyScannedDirectives = false;
                    for (const directive of oldDirectives){
                        const { range: range , type: type  } = directive;
                        if (range.end < changeStart) commentDirectives = append(commentDirectives, directive);
                        else if (range.pos > changeRangeOldEnd) {
                            addNewlyScannedDirectives();
                            const updatedDirective = {
                                range: {
                                    pos: range.pos + delta,
                                    end: range.end + delta
                                },
                                type: type
                            };
                            commentDirectives = append(commentDirectives, updatedDirective);
                            if (aggressiveChecks) Debug.assert(oldText.substring(range.pos, range.end) === newText.substring(updatedDirective.range.pos, updatedDirective.range.end));
                        }
                    }
                    addNewlyScannedDirectives();
                    return commentDirectives;
                    function addNewlyScannedDirectives() {
                        if (addedNewlyScannedDirectives) return;
                        addedNewlyScannedDirectives = true;
                        if (!commentDirectives) commentDirectives = newDirectives;
                        else if (newDirectives) commentDirectives.push(...newDirectives);
                    }
                }
                function moveElementEntirelyPastChangeRange(element, isArray2, delta, oldText, newText, aggressiveChecks) {
                    if (isArray2) visitArray2(element);
                    else visitNode3(element);
                    return;
                    function visitNode3(node) {
                        let text = "";
                        if (aggressiveChecks && shouldCheckNode(node)) text = oldText.substring(node.pos, node.end);
                        if (node._children) node._children = void 0;
                        setTextRangePosEnd(node, node.pos + delta, node.end + delta);
                        if (aggressiveChecks && shouldCheckNode(node)) Debug.assert(text === newText.substring(node.pos, node.end));
                        forEachChild(node, visitNode3, visitArray2);
                        if (hasJSDocNodes(node)) for (const jsDocComment of node.jsDoc)visitNode3(jsDocComment);
                        checkNodePositions(node, aggressiveChecks);
                    }
                    function visitArray2(array) {
                        array._children = void 0;
                        setTextRangePosEnd(array, array.pos + delta, array.end + delta);
                        for (const node of array)visitNode3(node);
                    }
                }
                function shouldCheckNode(node) {
                    switch(node.kind){
                        case 11 /* StringLiteral */ :
                        case 9 /* NumericLiteral */ :
                        case 80 /* Identifier */ :
                            return true;
                    }
                    return false;
                }
                function adjustIntersectingElement(element, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta) {
                    Debug.assert(element.end >= changeStart, "Adjusting an element that was entirely before the change range");
                    Debug.assert(element.pos <= changeRangeOldEnd, "Adjusting an element that was entirely after the change range");
                    Debug.assert(element.pos <= element.end);
                    const pos = Math.min(element.pos, changeRangeNewEnd);
                    const end = element.end >= changeRangeOldEnd ? // Element ends after the change range.  Always adjust the end pos.
                    element.end + delta : // Element ends in the change range.  The element will keep its position if
                    // possible. Or Move backward to the new-end if it's in the 'Y' range.
                    Math.min(element.end, changeRangeNewEnd);
                    Debug.assert(pos <= end);
                    if (element.parent) {
                        Debug.assertGreaterThanOrEqual(pos, element.parent.pos);
                        Debug.assertLessThanOrEqual(end, element.parent.end);
                    }
                    setTextRangePosEnd(element, pos, end);
                }
                function checkNodePositions(node, aggressiveChecks) {
                    if (aggressiveChecks) {
                        let pos = node.pos;
                        const visitNode3 = (child)=>{
                            Debug.assert(child.pos >= pos);
                            pos = child.end;
                        };
                        if (hasJSDocNodes(node)) for (const jsDocComment of node.jsDoc)visitNode3(jsDocComment);
                        forEachChild(node, visitNode3);
                        Debug.assert(pos <= node.end);
                    }
                }
                function updateTokenPositionsAndMarkElements(sourceFile, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta, oldText, newText, aggressiveChecks) {
                    visitNode3(sourceFile);
                    return;
                    function visitNode3(child) {
                        Debug.assert(child.pos <= child.end);
                        if (child.pos > changeRangeOldEnd) {
                            moveElementEntirelyPastChangeRange(child, /*isArray*/ false, delta, oldText, newText, aggressiveChecks);
                            return;
                        }
                        const fullEnd = child.end;
                        if (fullEnd >= changeStart) {
                            child.intersectsChange = true;
                            child._children = void 0;
                            adjustIntersectingElement(child, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta);
                            forEachChild(child, visitNode3, visitArray2);
                            if (hasJSDocNodes(child)) for (const jsDocComment of child.jsDoc)visitNode3(jsDocComment);
                            checkNodePositions(child, aggressiveChecks);
                            return;
                        }
                        Debug.assert(fullEnd < changeStart);
                    }
                    function visitArray2(array) {
                        Debug.assert(array.pos <= array.end);
                        if (array.pos > changeRangeOldEnd) {
                            moveElementEntirelyPastChangeRange(array, /*isArray*/ true, delta, oldText, newText, aggressiveChecks);
                            return;
                        }
                        const fullEnd = array.end;
                        if (fullEnd >= changeStart) {
                            array.intersectsChange = true;
                            array._children = void 0;
                            adjustIntersectingElement(array, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta);
                            for (const node of array)visitNode3(node);
                            return;
                        }
                        Debug.assert(fullEnd < changeStart);
                    }
                }
                function extendToAffectedRange(sourceFile, changeRange) {
                    const maxLookahead = 1;
                    let start = changeRange.span.start;
                    for(let i = 0; start > 0 && i <= maxLookahead; i++){
                        const nearestNode = findNearestNodeStartingBeforeOrAtPosition(sourceFile, start);
                        Debug.assert(nearestNode.pos <= start);
                        const position = nearestNode.pos;
                        start = Math.max(0, position - 1);
                    }
                    const finalSpan = createTextSpanFromBounds(start, textSpanEnd(changeRange.span));
                    const finalLength = changeRange.newLength + (changeRange.span.start - start);
                    return createTextChangeRange(finalSpan, finalLength);
                }
                function findNearestNodeStartingBeforeOrAtPosition(sourceFile, position) {
                    let bestResult = sourceFile;
                    let lastNodeEntirelyBeforePosition;
                    forEachChild(sourceFile, visit);
                    if (lastNodeEntirelyBeforePosition) {
                        const lastChildOfLastEntireNodeBeforePosition = getLastDescendant(lastNodeEntirelyBeforePosition);
                        if (lastChildOfLastEntireNodeBeforePosition.pos > bestResult.pos) bestResult = lastChildOfLastEntireNodeBeforePosition;
                    }
                    return bestResult;
                    function getLastDescendant(node) {
                        while(true){
                            const lastChild = getLastChild(node);
                            if (lastChild) node = lastChild;
                            else return node;
                        }
                    }
                    function visit(child) {
                        if (nodeIsMissing(child)) return;
                        if (child.pos <= position) {
                            if (child.pos >= bestResult.pos) bestResult = child;
                            if (position < child.end) {
                                forEachChild(child, visit);
                                return true;
                            } else {
                                Debug.assert(child.end <= position);
                                lastNodeEntirelyBeforePosition = child;
                            }
                        } else {
                            Debug.assert(child.pos > position);
                            return true;
                        }
                    }
                }
                function checkChangeRange(sourceFile, newText, textChangeRange, aggressiveChecks) {
                    const oldText = sourceFile.text;
                    if (textChangeRange) {
                        Debug.assert(oldText.length - textChangeRange.span.length + textChangeRange.newLength === newText.length);
                        if (aggressiveChecks || Debug.shouldAssert(3 /* VeryAggressive */ )) {
                            const oldTextPrefix = oldText.substr(0, textChangeRange.span.start);
                            const newTextPrefix = newText.substr(0, textChangeRange.span.start);
                            Debug.assert(oldTextPrefix === newTextPrefix);
                            const oldTextSuffix = oldText.substring(textSpanEnd(textChangeRange.span), oldText.length);
                            const newTextSuffix = newText.substring(textSpanEnd(textChangeRangeNewSpan(textChangeRange)), newText.length);
                            Debug.assert(oldTextSuffix === newTextSuffix);
                        }
                    }
                }
                function createSyntaxCursor(sourceFile) {
                    let currentArray = sourceFile.statements;
                    let currentArrayIndex = 0;
                    Debug.assert(currentArrayIndex < currentArray.length);
                    let current = currentArray[currentArrayIndex];
                    let lastQueriedPosition = -1 /* Value */ ;
                    return {
                        currentNode (position) {
                            if (position !== lastQueriedPosition) {
                                if (current && current.end === position && currentArrayIndex < currentArray.length - 1) {
                                    currentArrayIndex++;
                                    current = currentArray[currentArrayIndex];
                                }
                                if (!current || current.pos !== position) findHighestListElementThatStartsAtPosition(position);
                            }
                            lastQueriedPosition = position;
                            Debug.assert(!current || current.pos === position);
                            return current;
                        }
                    };
                    function findHighestListElementThatStartsAtPosition(position) {
                        currentArray = void 0;
                        currentArrayIndex = -1 /* Value */ ;
                        current = void 0;
                        forEachChild(sourceFile, visitNode3, visitArray2);
                        return;
                        function visitNode3(node) {
                            if (position >= node.pos && position < node.end) {
                                forEachChild(node, visitNode3, visitArray2);
                                return true;
                            }
                            return false;
                        }
                        function visitArray2(array) {
                            if (position >= array.pos && position < array.end) for(let i = 0; i < array.length; i++){
                                const child = array[i];
                                if (child) {
                                    if (child.pos === position) {
                                        currentArray = array;
                                        currentArrayIndex = i;
                                        current = child;
                                        return true;
                                    } else if (child.pos < position && position < child.end) {
                                        forEachChild(child, visitNode3, visitArray2);
                                        return true;
                                    }
                                }
                            }
                            return false;
                        }
                    }
                }
                IncrementalParser2.createSyntaxCursor = createSyntaxCursor;
                let InvalidPosition;
                ((InvalidPosition2)=>{
                    InvalidPosition2[InvalidPosition2["Value"] = -1] = "Value";
                })(InvalidPosition || (InvalidPosition = {}));
            })(IncrementalParser || (IncrementalParser = {}));
            namedArgRegExCache = /* @__PURE__ */ new Map();
            tripleSlashXMLCommentStartRegEx = /^\/\/\/\s*<(\S+)\s.*?\/>/im;
            singleLinePragmaRegEx = /^\/\/\/?\s*@(\S+)\s*(.*)\s*$/im;
        }
    });
    // src/compiler/commandLineParser.ts
    function createOptionNameMap(optionDeclarations2) {
        const optionsNameMap = /* @__PURE__ */ new Map();
        const shortOptionNames = /* @__PURE__ */ new Map();
        forEach(optionDeclarations2, (option)=>{
            optionsNameMap.set(option.name.toLowerCase(), option);
            if (option.shortName) shortOptionNames.set(option.shortName, option.name);
        });
        return {
            optionsNameMap: optionsNameMap,
            shortOptionNames: shortOptionNames
        };
    }
    function getOptionsNameMap() {
        return optionsNameMapCache || (optionsNameMapCache = createOptionNameMap(optionDeclarations));
    }
    function createCompilerDiagnosticForInvalidCustomType(opt) {
        return createDiagnosticForInvalidCustomType(opt, createCompilerDiagnostic);
    }
    function createDiagnosticForInvalidCustomType(opt, createDiagnostic) {
        const namesOfType = arrayFrom(opt.type.keys());
        const stringNames = (opt.deprecatedKeys ? namesOfType.filter((k)=>!opt.deprecatedKeys.has(k)) : namesOfType).map((key)=>`'${key}'`).join(", ");
        return createDiagnostic(Diagnostics.Argument_for_0_option_must_be_Colon_1, `--${opt.name}`, stringNames);
    }
    function parseCustomTypeOption(opt, value1, errors) {
        return convertJsonOptionOfCustomType(opt, trimString(value1 || ""), errors);
    }
    function parseListTypeOption(opt, value1 = "", errors) {
        value1 = trimString(value1);
        if (startsWith(value1, "-")) return void 0;
        if (opt.type === "listOrElement" && !stringContains(value1, ",")) return validateJsonOptionValue(opt, value1, errors);
        if (value1 === "") return [];
        const values = value1.split(",");
        switch(opt.element.type){
            case "number":
                return mapDefined(values, (v)=>validateJsonOptionValue(opt.element, parseInt(v), errors));
            case "string":
                return mapDefined(values, (v)=>validateJsonOptionValue(opt.element, v || "", errors));
            case "boolean":
            case "object":
                return Debug.fail(`List of ${opt.element.type} is not yet supported.`);
            default:
                return mapDefined(values, (v)=>parseCustomTypeOption(opt.element, v, errors));
        }
    }
    function getOptionName(option) {
        return option.name;
    }
    function createUnknownOptionError(unknownOption, diagnostics, unknownOptionErrorText, node, sourceFile) {
        var _a;
        if ((_a = diagnostics.alternateMode) == null ? void 0 : _a.getOptionsNameMap().optionsNameMap.has(unknownOption.toLowerCase())) return createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, node, diagnostics.alternateMode.diagnostic, unknownOption);
        const possibleOption = getSpellingSuggestion(unknownOption, diagnostics.optionDeclarations, getOptionName);
        return possibleOption ? createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, node, diagnostics.unknownDidYouMeanDiagnostic, unknownOptionErrorText || unknownOption, possibleOption.name) : createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, node, diagnostics.unknownOptionDiagnostic, unknownOptionErrorText || unknownOption);
    }
    function parseCommandLineWorker(diagnostics, commandLine, readFile) {
        const options = {};
        let watchOptions;
        const fileNames = [];
        const errors = [];
        parseStrings(commandLine);
        return {
            options: options,
            watchOptions: watchOptions,
            fileNames: fileNames,
            errors: errors
        };
        function parseStrings(args) {
            let i = 0;
            while(i < args.length){
                const s = args[i];
                i++;
                if (s.charCodeAt(0) === 64 /* at */ ) parseResponseFile(s.slice(1));
                else if (s.charCodeAt(0) === 45 /* minus */ ) {
                    const inputOptionName = s.slice(s.charCodeAt(1) === 45 /* minus */  ? 2 : 1);
                    const opt = getOptionDeclarationFromName(diagnostics.getOptionsNameMap, inputOptionName, /*allowShort*/ true);
                    if (opt) i = parseOptionValue(args, i, diagnostics, opt, options, errors);
                    else {
                        const watchOpt = getOptionDeclarationFromName(watchOptionsDidYouMeanDiagnostics.getOptionsNameMap, inputOptionName, /*allowShort*/ true);
                        if (watchOpt) i = parseOptionValue(args, i, watchOptionsDidYouMeanDiagnostics, watchOpt, watchOptions || (watchOptions = {}), errors);
                        else errors.push(createUnknownOptionError(inputOptionName, diagnostics, s));
                    }
                } else fileNames.push(s);
            }
        }
        function parseResponseFile(fileName) {
            const text = tryReadFile(fileName, readFile || ((fileName2)=>sys.readFile(fileName2)));
            if (!isString(text)) {
                errors.push(text);
                return;
            }
            const args = [];
            let pos = 0;
            while(true){
                while(pos < text.length && text.charCodeAt(pos) <= 32 /* space */ )pos++;
                if (pos >= text.length) break;
                const start = pos;
                if (text.charCodeAt(start) === 34 /* doubleQuote */ ) {
                    pos++;
                    while(pos < text.length && text.charCodeAt(pos) !== 34 /* doubleQuote */ )pos++;
                    if (pos < text.length) {
                        args.push(text.substring(start + 1, pos));
                        pos++;
                    } else errors.push(createCompilerDiagnostic(Diagnostics.Unterminated_quoted_string_in_response_file_0, fileName));
                } else {
                    while(text.charCodeAt(pos) > 32 /* space */ )pos++;
                    args.push(text.substring(start, pos));
                }
            }
            parseStrings(args);
        }
    }
    function parseOptionValue(args, i, diagnostics, opt, options, errors) {
        if (opt.isTSConfigOnly) {
            const optValue = args[i];
            if (optValue === "null") {
                options[opt.name] = void 0;
                i++;
            } else if (opt.type === "boolean") {
                if (optValue === "false") {
                    options[opt.name] = validateJsonOptionValue(opt, /*value*/ false, errors);
                    i++;
                } else {
                    if (optValue === "true") i++;
                    errors.push(createCompilerDiagnostic(Diagnostics.Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_false_or_null_on_command_line, opt.name));
                }
            } else {
                errors.push(createCompilerDiagnostic(Diagnostics.Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_null_on_command_line, opt.name));
                if (optValue && !startsWith(optValue, "-")) i++;
            }
        } else {
            if (!args[i] && opt.type !== "boolean") errors.push(createCompilerDiagnostic(diagnostics.optionTypeMismatchDiagnostic, opt.name, getCompilerOptionValueTypeString(opt)));
            if (args[i] !== "null") switch(opt.type){
                case "number":
                    options[opt.name] = validateJsonOptionValue(opt, parseInt(args[i]), errors);
                    i++;
                    break;
                case "boolean":
                    const optValue = args[i];
                    options[opt.name] = validateJsonOptionValue(opt, optValue !== "false", errors);
                    if (optValue === "false" || optValue === "true") i++;
                    break;
                case "string":
                    options[opt.name] = validateJsonOptionValue(opt, args[i] || "", errors);
                    i++;
                    break;
                case "list":
                    const result = parseListTypeOption(opt, args[i], errors);
                    options[opt.name] = result || [];
                    if (result) i++;
                    break;
                case "listOrElement":
                    Debug.fail("listOrElement not supported here");
                    break;
                default:
                    options[opt.name] = parseCustomTypeOption(opt, args[i], errors);
                    i++;
                    break;
            }
            else {
                options[opt.name] = void 0;
                i++;
            }
        }
        return i;
    }
    function parseCommandLine(commandLine, readFile) {
        return parseCommandLineWorker(compilerOptionsDidYouMeanDiagnostics, commandLine, readFile);
    }
    function getOptionFromName(optionName, allowShort) {
        return getOptionDeclarationFromName(getOptionsNameMap, optionName, allowShort);
    }
    function getOptionDeclarationFromName(getOptionNameMap, optionName, allowShort = false) {
        optionName = optionName.toLowerCase();
        const { optionsNameMap: optionsNameMap , shortOptionNames: shortOptionNames  } = getOptionNameMap();
        if (allowShort) {
            const short = shortOptionNames.get(optionName);
            if (short !== void 0) optionName = short;
        }
        return optionsNameMap.get(optionName);
    }
    function getBuildOptionsNameMap() {
        return buildOptionsNameMapCache || (buildOptionsNameMapCache = createOptionNameMap(buildOpts));
    }
    function parseBuildCommand(args) {
        const { options: options , watchOptions: watchOptions , fileNames: projects , errors: errors  } = parseCommandLineWorker(buildOptionsDidYouMeanDiagnostics, args);
        const buildOptions = options;
        if (projects.length === 0) projects.push(".");
        if (buildOptions.clean && buildOptions.force) errors.push(createCompilerDiagnostic(Diagnostics.Options_0_and_1_cannot_be_combined, "clean", "force"));
        if (buildOptions.clean && buildOptions.verbose) errors.push(createCompilerDiagnostic(Diagnostics.Options_0_and_1_cannot_be_combined, "clean", "verbose"));
        if (buildOptions.clean && buildOptions.watch) errors.push(createCompilerDiagnostic(Diagnostics.Options_0_and_1_cannot_be_combined, "clean", "watch"));
        if (buildOptions.watch && buildOptions.dry) errors.push(createCompilerDiagnostic(Diagnostics.Options_0_and_1_cannot_be_combined, "watch", "dry"));
        return {
            buildOptions: buildOptions,
            watchOptions: watchOptions,
            projects: projects,
            errors: errors
        };
    }
    function getDiagnosticText(_message, ..._args) {
        const diagnostic = createCompilerDiagnostic.apply(void 0, arguments);
        return diagnostic.messageText;
    }
    function getParsedCommandLineOfConfigFile(configFileName, optionsToExtend, host, extendedConfigCache, watchOptionsToExtend, extraFileExtensions) {
        const configFileText = tryReadFile(configFileName, (fileName)=>host.readFile(fileName));
        if (!isString(configFileText)) {
            host.onUnRecoverableConfigFileDiagnostic(configFileText);
            return void 0;
        }
        const result = parseJsonText(configFileName, configFileText);
        const cwd = host.getCurrentDirectory();
        result.path = toPath(configFileName, cwd, createGetCanonicalFileName(host.useCaseSensitiveFileNames));
        result.resolvedPath = result.path;
        result.originalFileName = result.fileName;
        return parseJsonSourceFileConfigFileContent(result, host, getNormalizedAbsolutePath(getDirectoryPath(configFileName), cwd), optionsToExtend, getNormalizedAbsolutePath(configFileName, cwd), /*resolutionStack*/ void 0, extraFileExtensions, extendedConfigCache, watchOptionsToExtend);
    }
    function readConfigFile(fileName, readFile) {
        const textOrDiagnostic = tryReadFile(fileName, readFile);
        return isString(textOrDiagnostic) ? parseConfigFileTextToJson(fileName, textOrDiagnostic) : {
            config: {},
            error: textOrDiagnostic
        };
    }
    function parseConfigFileTextToJson(fileName, jsonText) {
        const jsonSourceFile = parseJsonText(fileName, jsonText);
        return {
            config: convertConfigFileToObject(jsonSourceFile, jsonSourceFile.parseDiagnostics, /*jsonConversionNotifier*/ void 0),
            error: jsonSourceFile.parseDiagnostics.length ? jsonSourceFile.parseDiagnostics[0] : void 0
        };
    }
    function readJsonConfigFile(fileName, readFile) {
        const textOrDiagnostic = tryReadFile(fileName, readFile);
        return isString(textOrDiagnostic) ? parseJsonText(fileName, textOrDiagnostic) : {
            fileName: fileName,
            parseDiagnostics: [
                textOrDiagnostic
            ]
        };
    }
    function tryReadFile(fileName, readFile) {
        let text;
        try {
            text = readFile(fileName);
        } catch (e) {
            return createCompilerDiagnostic(Diagnostics.Cannot_read_file_0_Colon_1, fileName, e.message);
        }
        return text === void 0 ? createCompilerDiagnostic(Diagnostics.Cannot_read_file_0, fileName) : text;
    }
    function commandLineOptionsToMap(options) {
        return arrayToMap(options, getOptionName);
    }
    function getWatchOptionsNameMap() {
        return watchOptionsNameMapCache || (watchOptionsNameMapCache = createOptionNameMap(optionsForWatch));
    }
    function getCommandLineCompilerOptionsMap() {
        return commandLineCompilerOptionsMapCache || (commandLineCompilerOptionsMapCache = commandLineOptionsToMap(optionDeclarations));
    }
    function getCommandLineWatchOptionsMap() {
        return commandLineWatchOptionsMapCache || (commandLineWatchOptionsMapCache = commandLineOptionsToMap(optionsForWatch));
    }
    function getCommandLineTypeAcquisitionMap() {
        return commandLineTypeAcquisitionMapCache || (commandLineTypeAcquisitionMapCache = commandLineOptionsToMap(typeAcquisitionDeclarations));
    }
    function getTsconfigRootOptionsMap() {
        if (_tsconfigRootOptions === void 0) _tsconfigRootOptions = {
            name: void 0,
            // should never be needed since this is root
            type: "object",
            elementOptions: commandLineOptionsToMap([
                compilerOptionsDeclaration,
                watchOptionsDeclaration,
                typeAcquisitionDeclaration,
                extendsOptionDeclaration,
                {
                    name: "references",
                    type: "list",
                    element: {
                        name: "references",
                        type: "object"
                    },
                    category: Diagnostics.Projects
                },
                {
                    name: "files",
                    type: "list",
                    element: {
                        name: "files",
                        type: "string"
                    },
                    category: Diagnostics.File_Management
                },
                {
                    name: "include",
                    type: "list",
                    element: {
                        name: "include",
                        type: "string"
                    },
                    category: Diagnostics.File_Management,
                    defaultValueDescription: Diagnostics.if_files_is_specified_otherwise_Asterisk_Asterisk_Slash_Asterisk
                },
                {
                    name: "exclude",
                    type: "list",
                    element: {
                        name: "exclude",
                        type: "string"
                    },
                    category: Diagnostics.File_Management,
                    defaultValueDescription: Diagnostics.node_modules_bower_components_jspm_packages_plus_the_value_of_outDir_if_one_is_specified
                },
                compileOnSaveCommandLineOption
            ])
        };
        return _tsconfigRootOptions;
    }
    function convertConfigFileToObject(sourceFile, errors, jsonConversionNotifier) {
        var _a;
        const rootExpression = (_a = sourceFile.statements[0]) == null ? void 0 : _a.expression;
        if (rootExpression && rootExpression.kind !== 209 /* ObjectLiteralExpression */ ) {
            errors.push(createDiagnosticForNodeInSourceFile(sourceFile, rootExpression, Diagnostics.The_root_value_of_a_0_file_must_be_an_object, getBaseFileName(sourceFile.fileName) === "jsconfig.json" ? "jsconfig.json" : "tsconfig.json"));
            if (isArrayLiteralExpression(rootExpression)) {
                const firstObject = find(rootExpression.elements, isObjectLiteralExpression);
                if (firstObject) return convertToJson(sourceFile, firstObject, errors, /*returnValue*/ true, jsonConversionNotifier);
            }
            return {};
        }
        return convertToJson(sourceFile, rootExpression, errors, /*returnValue*/ true, jsonConversionNotifier);
    }
    function convertToObject(sourceFile, errors) {
        var _a;
        return convertToJson(sourceFile, (_a = sourceFile.statements[0]) == null ? void 0 : _a.expression, errors, /*returnValue*/ true, /*jsonConversionNotifier*/ void 0);
    }
    function convertToJson(sourceFile, rootExpression, errors, returnValue, jsonConversionNotifier) {
        if (!rootExpression) return returnValue ? {} : void 0;
        return convertPropertyValueToJson(rootExpression, jsonConversionNotifier == null ? void 0 : jsonConversionNotifier.rootOptions);
        function convertObjectLiteralExpressionToJson(node, objectOption) {
            var _a;
            const result = returnValue ? {} : void 0;
            for (const element of node.properties){
                if (element.kind !== 302 /* PropertyAssignment */ ) {
                    errors.push(createDiagnosticForNodeInSourceFile(sourceFile, element, Diagnostics.Property_assignment_expected));
                    continue;
                }
                if (element.questionToken) errors.push(createDiagnosticForNodeInSourceFile(sourceFile, element.questionToken, Diagnostics.The_0_modifier_can_only_be_used_in_TypeScript_files, "?"));
                if (!isDoubleQuotedString(element.name)) errors.push(createDiagnosticForNodeInSourceFile(sourceFile, element.name, Diagnostics.String_literal_with_double_quotes_expected));
                const textOfKey = isComputedNonLiteralName(element.name) ? void 0 : getTextOfPropertyName(element.name);
                const keyText = textOfKey && unescapeLeadingUnderscores(textOfKey);
                const option = keyText ? (_a = objectOption == null ? void 0 : objectOption.elementOptions) == null ? void 0 : _a.get(keyText) : void 0;
                const value1 = convertPropertyValueToJson(element.initializer, option);
                if (typeof keyText !== "undefined") {
                    if (returnValue) result[keyText] = value1;
                    jsonConversionNotifier == null || jsonConversionNotifier.onPropertySet(keyText, value1, element, objectOption, option);
                }
            }
            return result;
        }
        function convertArrayLiteralExpressionToJson(elements, elementOption) {
            if (!returnValue) {
                elements.forEach((element)=>convertPropertyValueToJson(element, elementOption));
                return void 0;
            }
            return filter(elements.map((element)=>convertPropertyValueToJson(element, elementOption)), (v)=>v !== void 0);
        }
        function convertPropertyValueToJson(valueExpression, option) {
            switch(valueExpression.kind){
                case 112 /* TrueKeyword */ :
                    return true;
                case 97 /* FalseKeyword */ :
                    return false;
                case 106 /* NullKeyword */ :
                    return null;
                case 11 /* StringLiteral */ :
                    if (!isDoubleQuotedString(valueExpression)) errors.push(createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, Diagnostics.String_literal_with_double_quotes_expected));
                    return valueExpression.text;
                case 9 /* NumericLiteral */ :
                    return Number(valueExpression.text);
                case 223 /* PrefixUnaryExpression */ :
                    if (valueExpression.operator !== 41 /* MinusToken */  || valueExpression.operand.kind !== 9 /* NumericLiteral */ ) break;
                    return -Number(valueExpression.operand.text);
                case 209 /* ObjectLiteralExpression */ :
                    const objectLiteralExpression = valueExpression;
                    return convertObjectLiteralExpressionToJson(objectLiteralExpression, option);
                case 208 /* ArrayLiteralExpression */ :
                    return convertArrayLiteralExpressionToJson(valueExpression.elements, option && option.element);
            }
            if (option) errors.push(createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, Diagnostics.Compiler_option_0_requires_a_value_of_type_1, option.name, getCompilerOptionValueTypeString(option)));
            else errors.push(createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, Diagnostics.Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_literal));
            return void 0;
        }
        function isDoubleQuotedString(node) {
            return isStringLiteral(node) && isStringDoubleQuoted(node, sourceFile);
        }
    }
    function getCompilerOptionValueTypeString(option) {
        return option.type === "listOrElement" ? `${getCompilerOptionValueTypeString(option.element)} or Array` : option.type === "list" ? "Array" : isString(option.type) ? option.type : "string";
    }
    function isCompilerOptionsValue(option, value1) {
        if (option) {
            if (isNullOrUndefined(value1)) return !option.disallowNullOrUndefined;
            if (option.type === "list") return isArray(value1);
            if (option.type === "listOrElement") return isArray(value1) || isCompilerOptionsValue(option.element, value1);
            const expectedType = isString(option.type) ? option.type : "string";
            return typeof value1 === expectedType;
        }
        return false;
    }
    function convertToTSConfig(configParseResult, configFileName, host) {
        var _a, _b, _c;
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames);
        const files = map(filter(configParseResult.fileNames, !((_b = (_a = configParseResult.options.configFile) == null ? void 0 : _a.configFileSpecs) == null ? void 0 : _b.validatedIncludeSpecs) ? returnTrue : matchesSpecs(configFileName, configParseResult.options.configFile.configFileSpecs.validatedIncludeSpecs, configParseResult.options.configFile.configFileSpecs.validatedExcludeSpecs, host)), (f)=>getRelativePathFromFile(getNormalizedAbsolutePath(configFileName, host.getCurrentDirectory()), getNormalizedAbsolutePath(f, host.getCurrentDirectory()), getCanonicalFileName));
        const optionMap = serializeCompilerOptions(configParseResult.options, {
            configFilePath: getNormalizedAbsolutePath(configFileName, host.getCurrentDirectory()),
            useCaseSensitiveFileNames: host.useCaseSensitiveFileNames
        });
        const watchOptionMap = configParseResult.watchOptions && serializeWatchOptions(configParseResult.watchOptions);
        const config = {
            compilerOptions: {
                ...optionMapToObject(optionMap),
                showConfig: void 0,
                configFile: void 0,
                configFilePath: void 0,
                help: void 0,
                init: void 0,
                listFiles: void 0,
                listEmittedFiles: void 0,
                project: void 0,
                build: void 0,
                version: void 0
            },
            watchOptions: watchOptionMap && optionMapToObject(watchOptionMap),
            references: map(configParseResult.projectReferences, (r)=>({
                    ...r,
                    path: r.originalPath ? r.originalPath : "",
                    originalPath: void 0
                })),
            files: length(files) ? files : void 0,
            ...((_c = configParseResult.options.configFile) == null ? void 0 : _c.configFileSpecs) ? {
                include: filterSameAsDefaultInclude(configParseResult.options.configFile.configFileSpecs.validatedIncludeSpecs),
                exclude: configParseResult.options.configFile.configFileSpecs.validatedExcludeSpecs
            } : {},
            compileOnSave: !!configParseResult.compileOnSave ? true : void 0
        };
        return config;
    }
    function optionMapToObject(optionMap) {
        return {
            ...arrayFrom(optionMap.entries()).reduce((prev, cur)=>({
                    ...prev,
                    [cur[0]]: cur[1]
                }), {})
        };
    }
    function filterSameAsDefaultInclude(specs) {
        if (!length(specs)) return void 0;
        if (length(specs) !== 1) return specs;
        if (specs[0] === defaultIncludeSpec) return void 0;
        return specs;
    }
    function matchesSpecs(path, includeSpecs, excludeSpecs, host) {
        if (!includeSpecs) return returnTrue;
        const patterns = getFileMatcherPatterns(path, excludeSpecs, includeSpecs, host.useCaseSensitiveFileNames, host.getCurrentDirectory());
        const excludeRe = patterns.excludePattern && getRegexFromPattern(patterns.excludePattern, host.useCaseSensitiveFileNames);
        const includeRe = patterns.includeFilePattern && getRegexFromPattern(patterns.includeFilePattern, host.useCaseSensitiveFileNames);
        if (includeRe) {
            if (excludeRe) return (path2)=>!(includeRe.test(path2) && !excludeRe.test(path2));
            return (path2)=>!includeRe.test(path2);
        }
        if (excludeRe) return (path2)=>excludeRe.test(path2);
        return returnTrue;
    }
    function getCustomTypeMapOfCommandLineOption(optionDefinition) {
        switch(optionDefinition.type){
            case "string":
            case "number":
            case "boolean":
            case "object":
                return void 0;
            case "list":
            case "listOrElement":
                return getCustomTypeMapOfCommandLineOption(optionDefinition.element);
            default:
                return optionDefinition.type;
        }
    }
    function getNameOfCompilerOptionValue(value1, customTypeMap) {
        return forEachEntry(customTypeMap, (mapValue, key)=>{
            if (mapValue === value1) return key;
        });
    }
    function serializeCompilerOptions(options, pathOptions) {
        return serializeOptionBaseObject(options, getOptionsNameMap(), pathOptions);
    }
    function serializeWatchOptions(options) {
        return serializeOptionBaseObject(options, getWatchOptionsNameMap());
    }
    function serializeOptionBaseObject(options, { optionsNameMap: optionsNameMap  }, pathOptions) {
        const result = /* @__PURE__ */ new Map();
        const getCanonicalFileName = pathOptions && createGetCanonicalFileName(pathOptions.useCaseSensitiveFileNames);
        for(const name in options)if (hasProperty(options, name)) {
            if (optionsNameMap.has(name) && (optionsNameMap.get(name).category === Diagnostics.Command_line_Options || optionsNameMap.get(name).category === Diagnostics.Output_Formatting)) continue;
            const value1 = options[name];
            const optionDefinition = optionsNameMap.get(name.toLowerCase());
            if (optionDefinition) {
                Debug.assert(optionDefinition.type !== "listOrElement");
                const customTypeMap = getCustomTypeMapOfCommandLineOption(optionDefinition);
                if (!customTypeMap) {
                    if (pathOptions && optionDefinition.isFilePath) result.set(name, getRelativePathFromFile(pathOptions.configFilePath, getNormalizedAbsolutePath(value1, getDirectoryPath(pathOptions.configFilePath)), getCanonicalFileName));
                    else result.set(name, value1);
                } else if (optionDefinition.type === "list") result.set(name, value1.map((element)=>getNameOfCompilerOptionValue(element, customTypeMap)));
                else result.set(name, getNameOfCompilerOptionValue(value1, customTypeMap));
            }
        }
        return result;
    }
    function getCompilerOptionsDiffValue(options, newLine) {
        const compilerOptionsMap = getSerializedCompilerOption(options);
        return getOverwrittenDefaultOptions();
        function makePadding(paddingLength) {
            return Array(paddingLength + 1).join(" ");
        }
        function getOverwrittenDefaultOptions() {
            const result = [];
            const tab = makePadding(2);
            commandOptionsWithoutBuild.forEach((cmd)=>{
                if (!compilerOptionsMap.has(cmd.name)) return;
                const newValue = compilerOptionsMap.get(cmd.name);
                const defaultValue = getDefaultValueForOption(cmd);
                if (newValue !== defaultValue) result.push(`${tab}${cmd.name}: ${newValue}`);
                else if (hasProperty(defaultInitCompilerOptions, cmd.name)) result.push(`${tab}${cmd.name}: ${defaultValue}`);
            });
            return result.join(newLine) + newLine;
        }
    }
    function getSerializedCompilerOption(options) {
        const compilerOptions = extend(options, defaultInitCompilerOptions);
        return serializeCompilerOptions(compilerOptions);
    }
    function generateTSConfig(options, fileNames, newLine) {
        const compilerOptionsMap = getSerializedCompilerOption(options);
        return writeConfigurations();
        function makePadding(paddingLength) {
            return Array(paddingLength + 1).join(" ");
        }
        function isAllowedOptionForOutput({ category: category , name: name , isCommandLineOnly: isCommandLineOnly  }) {
            const categoriesToSkip = [
                Diagnostics.Command_line_Options,
                Diagnostics.Editor_Support,
                Diagnostics.Compiler_Diagnostics,
                Diagnostics.Backwards_Compatibility,
                Diagnostics.Watch_and_Build_Modes,
                Diagnostics.Output_Formatting
            ];
            return !isCommandLineOnly && category !== void 0 && (!categoriesToSkip.includes(category) || compilerOptionsMap.has(name));
        }
        function writeConfigurations() {
            const categorizedOptions = /* @__PURE__ */ new Map();
            categorizedOptions.set(Diagnostics.Projects, []);
            categorizedOptions.set(Diagnostics.Language_and_Environment, []);
            categorizedOptions.set(Diagnostics.Modules, []);
            categorizedOptions.set(Diagnostics.JavaScript_Support, []);
            categorizedOptions.set(Diagnostics.Emit, []);
            categorizedOptions.set(Diagnostics.Interop_Constraints, []);
            categorizedOptions.set(Diagnostics.Type_Checking, []);
            categorizedOptions.set(Diagnostics.Completeness, []);
            for (const option of optionDeclarations)if (isAllowedOptionForOutput(option)) {
                let listForCategory = categorizedOptions.get(option.category);
                if (!listForCategory) categorizedOptions.set(option.category, listForCategory = []);
                listForCategory.push(option);
            }
            let marginLength = 0;
            let seenKnownKeys = 0;
            const entries = [];
            categorizedOptions.forEach((options2, category)=>{
                if (entries.length !== 0) entries.push({
                    value: ""
                });
                entries.push({
                    value: `/* ${getLocaleSpecificMessage(category)} */`
                });
                for (const option of options2){
                    let optionName;
                    if (compilerOptionsMap.has(option.name)) optionName = `"${option.name}": ${JSON.stringify(compilerOptionsMap.get(option.name))}${(seenKnownKeys += 1) === compilerOptionsMap.size ? "" : ","}`;
                    else optionName = `// "${option.name}": ${JSON.stringify(getDefaultValueForOption(option))},`;
                    entries.push({
                        value: optionName,
                        description: `/* ${option.description && getLocaleSpecificMessage(option.description) || option.name} */`
                    });
                    marginLength = Math.max(optionName.length, marginLength);
                }
            });
            const tab = makePadding(2);
            const result = [];
            result.push(`{`);
            result.push(`${tab}"compilerOptions": {`);
            result.push(`${tab}${tab}/* ${getLocaleSpecificMessage(Diagnostics.Visit_https_Colon_Slash_Slashaka_ms_Slashtsconfig_to_read_more_about_this_file)} */`);
            result.push("");
            for (const entry of entries){
                const { value: value1 , description: description3 = ""  } = entry;
                result.push(value1 && `${tab}${tab}${value1}${description3 && makePadding(marginLength - value1.length + 2) + description3}`);
            }
            if (fileNames.length) {
                result.push(`${tab}},`);
                result.push(`${tab}"files": [`);
                for(let i = 0; i < fileNames.length; i++)result.push(`${tab}${tab}${JSON.stringify(fileNames[i])}${i === fileNames.length - 1 ? "" : ","}`);
                result.push(`${tab}]`);
            } else result.push(`${tab}}`);
            result.push(`}`);
            return result.join(newLine) + newLine;
        }
    }
    function convertToOptionsWithAbsolutePaths(options, toAbsolutePath) {
        const result = {};
        const optionsNameMap = getOptionsNameMap().optionsNameMap;
        for(const name in options)if (hasProperty(options, name)) result[name] = convertToOptionValueWithAbsolutePaths(optionsNameMap.get(name.toLowerCase()), options[name], toAbsolutePath);
        if (result.configFilePath) result.configFilePath = toAbsolutePath(result.configFilePath);
        return result;
    }
    function convertToOptionValueWithAbsolutePaths(option, value1, toAbsolutePath) {
        if (option && !isNullOrUndefined(value1)) {
            if (option.type === "list") {
                const values = value1;
                if (option.element.isFilePath && values.length) return values.map(toAbsolutePath);
            } else if (option.isFilePath) return toAbsolutePath(value1);
            Debug.assert(option.type !== "listOrElement");
        }
        return value1;
    }
    function parseJsonConfigFileContent(json, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions, extendedConfigCache, existingWatchOptions) {
        return parseJsonConfigFileContentWorker(json, /*sourceFile*/ void 0, host, basePath, existingOptions, existingWatchOptions, configFileName, resolutionStack, extraFileExtensions, extendedConfigCache);
    }
    function parseJsonSourceFileConfigFileContent(sourceFile, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions, extendedConfigCache, existingWatchOptions) {
        var _a, _b;
        (_a = tracing) == null || _a.push(tracing.Phase.Parse, "parseJsonSourceFileConfigFileContent", {
            path: sourceFile.fileName
        });
        const result = parseJsonConfigFileContentWorker(/*json*/ void 0, sourceFile, host, basePath, existingOptions, existingWatchOptions, configFileName, resolutionStack, extraFileExtensions, extendedConfigCache);
        (_b = tracing) == null || _b.pop();
        return result;
    }
    function setConfigFileInOptions(options, configFile) {
        if (configFile) Object.defineProperty(options, "configFile", {
            enumerable: false,
            writable: false,
            value: configFile
        });
    }
    function isNullOrUndefined(x) {
        return x === void 0 || x === null;
    }
    function directoryOfCombinedPath(fileName, basePath) {
        return getDirectoryPath(getNormalizedAbsolutePath(fileName, basePath));
    }
    function parseJsonConfigFileContentWorker(json, sourceFile, host, basePath, existingOptions = {}, existingWatchOptions, configFileName, resolutionStack = [], extraFileExtensions = [], extendedConfigCache) {
        Debug.assert(json === void 0 && sourceFile !== void 0 || json !== void 0 && sourceFile === void 0);
        const errors = [];
        const parsedConfig = parseConfig(json, sourceFile, host, basePath, configFileName, resolutionStack, errors, extendedConfigCache);
        const { raw: raw  } = parsedConfig;
        const options = extend(existingOptions, parsedConfig.options || {});
        const watchOptions = existingWatchOptions && parsedConfig.watchOptions ? extend(existingWatchOptions, parsedConfig.watchOptions) : parsedConfig.watchOptions || existingWatchOptions;
        options.configFilePath = configFileName && normalizeSlashes(configFileName);
        const configFileSpecs = getConfigFileSpecs();
        if (sourceFile) sourceFile.configFileSpecs = configFileSpecs;
        setConfigFileInOptions(options, sourceFile);
        const basePathForFileNames = normalizePath(configFileName ? directoryOfCombinedPath(configFileName, basePath) : basePath);
        return {
            options: options,
            watchOptions: watchOptions,
            fileNames: getFileNames(basePathForFileNames),
            projectReferences: getProjectReferences(basePathForFileNames),
            typeAcquisition: parsedConfig.typeAcquisition || getDefaultTypeAcquisition(),
            raw: raw,
            errors: errors,
            // Wildcard directories (provided as part of a wildcard path) are stored in a
            // file map that marks whether it was a regular wildcard match (with a `*` or `?` token),
            // or a recursive directory. This information is used by filesystem watchers to monitor for
            // new entries in these paths.
            wildcardDirectories: getWildcardDirectories(configFileSpecs, basePathForFileNames, host.useCaseSensitiveFileNames),
            compileOnSave: !!raw.compileOnSave
        };
        function getConfigFileSpecs() {
            const referencesOfRaw = getPropFromRaw("references", (element)=>typeof element === "object", "object");
            const filesSpecs = toPropValue(getSpecsFromRaw("files"));
            if (filesSpecs) {
                const hasZeroOrNoReferences = referencesOfRaw === "no-prop" || isArray(referencesOfRaw) && referencesOfRaw.length === 0;
                const hasExtends = hasProperty(raw, "extends");
                if (filesSpecs.length === 0 && hasZeroOrNoReferences && !hasExtends) {
                    if (sourceFile) {
                        const fileName = configFileName || "tsconfig.json";
                        const diagnosticMessage = Diagnostics.The_files_list_in_config_file_0_is_empty;
                        const nodeValue = forEachTsConfigPropArray(sourceFile, "files", (property)=>property.initializer);
                        const error = createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, nodeValue, diagnosticMessage, fileName);
                        errors.push(error);
                    } else createCompilerDiagnosticOnlyIfJson(Diagnostics.The_files_list_in_config_file_0_is_empty, configFileName || "tsconfig.json");
                }
            }
            let includeSpecs = toPropValue(getSpecsFromRaw("include"));
            const excludeOfRaw = getSpecsFromRaw("exclude");
            let isDefaultIncludeSpec = false;
            let excludeSpecs = toPropValue(excludeOfRaw);
            if (excludeOfRaw === "no-prop" && raw.compilerOptions) {
                const outDir = raw.compilerOptions.outDir;
                const declarationDir = raw.compilerOptions.declarationDir;
                if (outDir || declarationDir) excludeSpecs = [
                    outDir,
                    declarationDir
                ].filter((d)=>!!d);
            }
            if (filesSpecs === void 0 && includeSpecs === void 0) {
                includeSpecs = [
                    defaultIncludeSpec
                ];
                isDefaultIncludeSpec = true;
            }
            let validatedIncludeSpecs, validatedExcludeSpecs;
            if (includeSpecs) validatedIncludeSpecs = validateSpecs(includeSpecs, errors, /*disallowTrailingRecursion*/ true, sourceFile, "include");
            if (excludeSpecs) validatedExcludeSpecs = validateSpecs(excludeSpecs, errors, /*disallowTrailingRecursion*/ false, sourceFile, "exclude");
            return {
                filesSpecs: filesSpecs,
                includeSpecs: includeSpecs,
                excludeSpecs: excludeSpecs,
                validatedFilesSpec: filter(filesSpecs, isString),
                validatedIncludeSpecs: validatedIncludeSpecs,
                validatedExcludeSpecs: validatedExcludeSpecs,
                pathPatterns: void 0,
                isDefaultIncludeSpec: // Initialized on first use
                isDefaultIncludeSpec
            };
        }
        function getFileNames(basePath2) {
            const fileNames = getFileNamesFromConfigSpecs(configFileSpecs, basePath2, options, host, extraFileExtensions);
            if (shouldReportNoInputFiles(fileNames, canJsonReportNoInputFiles(raw), resolutionStack)) errors.push(getErrorForNoInputFiles(configFileSpecs, configFileName));
            return fileNames;
        }
        function getProjectReferences(basePath2) {
            let projectReferences;
            const referencesOfRaw = getPropFromRaw("references", (element)=>typeof element === "object", "object");
            if (isArray(referencesOfRaw)) {
                for (const ref of referencesOfRaw)if (typeof ref.path !== "string") createCompilerDiagnosticOnlyIfJson(Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "reference.path", "string");
                else (projectReferences || (projectReferences = [])).push({
                    path: getNormalizedAbsolutePath(ref.path, basePath2),
                    originalPath: ref.path,
                    prepend: ref.prepend,
                    circular: ref.circular
                });
            }
            return projectReferences;
        }
        function toPropValue(specResult) {
            return isArray(specResult) ? specResult : void 0;
        }
        function getSpecsFromRaw(prop) {
            return getPropFromRaw(prop, isString, "string");
        }
        function getPropFromRaw(prop, validateElement, elementTypeName) {
            if (hasProperty(raw, prop) && !isNullOrUndefined(raw[prop])) {
                if (isArray(raw[prop])) {
                    const result = raw[prop];
                    if (!sourceFile && !every(result, validateElement)) errors.push(createCompilerDiagnostic(Diagnostics.Compiler_option_0_requires_a_value_of_type_1, prop, elementTypeName));
                    return result;
                } else {
                    createCompilerDiagnosticOnlyIfJson(Diagnostics.Compiler_option_0_requires_a_value_of_type_1, prop, "Array");
                    return "not-array";
                }
            }
            return "no-prop";
        }
        function createCompilerDiagnosticOnlyIfJson(message, ...args) {
            if (!sourceFile) errors.push(createCompilerDiagnostic(message, ...args));
        }
    }
    function isErrorNoInputFiles(error) {
        return error.code === Diagnostics.No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2.code;
    }
    function getErrorForNoInputFiles({ includeSpecs: includeSpecs , excludeSpecs: excludeSpecs  }, configFileName) {
        return createCompilerDiagnostic(Diagnostics.No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2, configFileName || "tsconfig.json", JSON.stringify(includeSpecs || []), JSON.stringify(excludeSpecs || []));
    }
    function shouldReportNoInputFiles(fileNames, canJsonReportNoInutFiles, resolutionStack) {
        return fileNames.length === 0 && canJsonReportNoInutFiles && (!resolutionStack || resolutionStack.length === 0);
    }
    function canJsonReportNoInputFiles(raw) {
        return !hasProperty(raw, "files") && !hasProperty(raw, "references");
    }
    function updateErrorForNoInputFiles(fileNames, configFileName, configFileSpecs, configParseDiagnostics, canJsonReportNoInutFiles) {
        const existingErrors = configParseDiagnostics.length;
        if (shouldReportNoInputFiles(fileNames, canJsonReportNoInutFiles)) configParseDiagnostics.push(getErrorForNoInputFiles(configFileSpecs, configFileName));
        else filterMutate(configParseDiagnostics, (error)=>!isErrorNoInputFiles(error));
        return existingErrors !== configParseDiagnostics.length;
    }
    function isSuccessfulParsedTsconfig(value1) {
        return !!value1.options;
    }
    function parseConfig(json, sourceFile, host, basePath, configFileName, resolutionStack, errors, extendedConfigCache) {
        var _a;
        basePath = normalizeSlashes(basePath);
        const resolvedPath = getNormalizedAbsolutePath(configFileName || "", basePath);
        if (resolutionStack.indexOf(resolvedPath) >= 0) {
            errors.push(createCompilerDiagnostic(Diagnostics.Circularity_detected_while_resolving_configuration_Colon_0, [
                ...resolutionStack,
                resolvedPath
            ].join(" -> ")));
            return {
                raw: json || convertToObject(sourceFile, errors)
            };
        }
        const ownConfig = json ? parseOwnConfigOfJson(json, host, basePath, configFileName, errors) : parseOwnConfigOfJsonSourceFile(sourceFile, host, basePath, configFileName, errors);
        if ((_a = ownConfig.options) == null ? void 0 : _a.paths) ownConfig.options.pathsBasePath = basePath;
        if (ownConfig.extendedConfigPath) {
            resolutionStack = resolutionStack.concat([
                resolvedPath
            ]);
            const result = {
                options: {}
            };
            if (isString(ownConfig.extendedConfigPath)) applyExtendedConfig(result, ownConfig.extendedConfigPath);
            else ownConfig.extendedConfigPath.forEach((extendedConfigPath)=>applyExtendedConfig(result, extendedConfigPath));
            if (!ownConfig.raw.include && result.include) ownConfig.raw.include = result.include;
            if (!ownConfig.raw.exclude && result.exclude) ownConfig.raw.exclude = result.exclude;
            if (!ownConfig.raw.files && result.files) ownConfig.raw.files = result.files;
            if (ownConfig.raw.compileOnSave === void 0 && result.compileOnSave) ownConfig.raw.compileOnSave = result.compileOnSave;
            if (sourceFile && result.extendedSourceFiles) sourceFile.extendedSourceFiles = arrayFrom(result.extendedSourceFiles.keys());
            ownConfig.options = assign(result.options, ownConfig.options);
            ownConfig.watchOptions = ownConfig.watchOptions && result.watchOptions ? assign(result.watchOptions, ownConfig.watchOptions) : ownConfig.watchOptions || result.watchOptions;
        }
        return ownConfig;
        function applyExtendedConfig(result, extendedConfigPath) {
            const extendedConfig = getExtendedConfig(sourceFile, extendedConfigPath, host, resolutionStack, errors, extendedConfigCache, result);
            if (extendedConfig && isSuccessfulParsedTsconfig(extendedConfig)) {
                const extendsRaw = extendedConfig.raw;
                let relativeDifference;
                const setPropertyInResultIfNotUndefined = (propertyName)=>{
                    if (extendsRaw[propertyName]) result[propertyName] = map(extendsRaw[propertyName], (path)=>isRootedDiskPath(path) ? path : combinePaths(relativeDifference || (relativeDifference = convertToRelativePath(getDirectoryPath(extendedConfigPath), basePath, createGetCanonicalFileName(host.useCaseSensitiveFileNames))), path));
                };
                setPropertyInResultIfNotUndefined("include");
                setPropertyInResultIfNotUndefined("exclude");
                setPropertyInResultIfNotUndefined("files");
                if (extendsRaw.compileOnSave !== void 0) result.compileOnSave = extendsRaw.compileOnSave;
                assign(result.options, extendedConfig.options);
                result.watchOptions = result.watchOptions && extendedConfig.watchOptions ? assign({}, result.watchOptions, extendedConfig.watchOptions) : result.watchOptions || extendedConfig.watchOptions;
            }
        }
    }
    function parseOwnConfigOfJson(json, host, basePath, configFileName, errors) {
        if (hasProperty(json, "excludes")) errors.push(createCompilerDiagnostic(Diagnostics.Unknown_option_excludes_Did_you_mean_exclude));
        const options = convertCompilerOptionsFromJsonWorker(json.compilerOptions, basePath, errors, configFileName);
        const typeAcquisition = convertTypeAcquisitionFromJsonWorker(json.typeAcquisition, basePath, errors, configFileName);
        const watchOptions = convertWatchOptionsFromJsonWorker(json.watchOptions, basePath, errors);
        json.compileOnSave = convertCompileOnSaveOptionFromJson(json, basePath, errors);
        const extendedConfigPath = json.extends || json.extends === "" ? getExtendsConfigPathOrArray(json.extends, host, basePath, configFileName, errors) : void 0;
        return {
            raw: json,
            options: options,
            watchOptions: watchOptions,
            typeAcquisition: typeAcquisition,
            extendedConfigPath: extendedConfigPath
        };
    }
    function getExtendsConfigPathOrArray(value1, host, basePath, configFileName, errors, propertyAssignment, valueExpression, sourceFile) {
        let extendedConfigPath;
        const newBase = configFileName ? directoryOfCombinedPath(configFileName, basePath) : basePath;
        if (isString(value1)) extendedConfigPath = getExtendsConfigPath(value1, host, newBase, errors, valueExpression, sourceFile);
        else if (isArray(value1)) {
            extendedConfigPath = [];
            for(let index = 0; index < value1.length; index++){
                const fileName = value1[index];
                if (isString(fileName)) extendedConfigPath = append(extendedConfigPath, getExtendsConfigPath(fileName, host, newBase, errors, valueExpression == null ? void 0 : valueExpression.elements[index], sourceFile));
                else convertJsonOption(extendsOptionDeclaration.element, value1, basePath, errors, propertyAssignment, valueExpression == null ? void 0 : valueExpression.elements[index], sourceFile);
            }
        } else convertJsonOption(extendsOptionDeclaration, value1, basePath, errors, propertyAssignment, valueExpression, sourceFile);
        return extendedConfigPath;
    }
    function parseOwnConfigOfJsonSourceFile(sourceFile, host, basePath, configFileName, errors) {
        const options = getDefaultCompilerOptions(configFileName);
        let typeAcquisition;
        let watchOptions;
        let extendedConfigPath;
        let rootCompilerOptions;
        const rootOptions = getTsconfigRootOptionsMap();
        const json = convertConfigFileToObject(sourceFile, errors, {
            rootOptions: rootOptions,
            onPropertySet: onPropertySet
        });
        if (!typeAcquisition) typeAcquisition = getDefaultTypeAcquisition(configFileName);
        if (rootCompilerOptions && json && json.compilerOptions === void 0) errors.push(createDiagnosticForNodeInSourceFile(sourceFile, rootCompilerOptions[0], Diagnostics._0_should_be_set_inside_the_compilerOptions_object_of_the_config_json_file, getTextOfPropertyName(rootCompilerOptions[0])));
        return {
            raw: json,
            options: options,
            watchOptions: watchOptions,
            typeAcquisition: typeAcquisition,
            extendedConfigPath: extendedConfigPath
        };
        function onPropertySet(keyText, value1, propertyAssignment, parentOption, option) {
            if (option && option !== extendsOptionDeclaration) value1 = convertJsonOption(option, value1, basePath, errors, propertyAssignment, propertyAssignment.initializer, sourceFile);
            if (parentOption == null ? void 0 : parentOption.name) {
                if (option) {
                    let currentOption;
                    if (parentOption === compilerOptionsDeclaration) currentOption = options;
                    else if (parentOption === watchOptionsDeclaration) currentOption = watchOptions ?? (watchOptions = {});
                    else if (parentOption === typeAcquisitionDeclaration) currentOption = typeAcquisition ?? (typeAcquisition = getDefaultTypeAcquisition(configFileName));
                    else Debug.fail("Unknown option");
                    currentOption[option.name] = value1;
                } else if (keyText && (parentOption == null ? void 0 : parentOption.extraKeyDiagnostics)) {
                    if (parentOption.elementOptions) errors.push(createUnknownOptionError(keyText, parentOption.extraKeyDiagnostics, /*unknownOptionErrorText*/ void 0, propertyAssignment.name, sourceFile));
                    else errors.push(createDiagnosticForNodeInSourceFile(sourceFile, propertyAssignment.name, parentOption.extraKeyDiagnostics.unknownOptionDiagnostic, keyText));
                }
            } else if (parentOption === rootOptions) {
                if (option === extendsOptionDeclaration) extendedConfigPath = getExtendsConfigPathOrArray(value1, host, basePath, configFileName, errors, propertyAssignment, propertyAssignment.initializer, sourceFile);
                else if (!option) {
                    if (keyText === "excludes") errors.push(createDiagnosticForNodeInSourceFile(sourceFile, propertyAssignment.name, Diagnostics.Unknown_option_excludes_Did_you_mean_exclude));
                    if (find(commandOptionsWithoutBuild, (opt)=>opt.name === keyText)) rootCompilerOptions = append(rootCompilerOptions, propertyAssignment.name);
                }
            }
        }
    }
    function getExtendsConfigPath(extendedConfig, host, basePath, errors, valueExpression, sourceFile) {
        extendedConfig = normalizeSlashes(extendedConfig);
        if (isRootedDiskPath(extendedConfig) || startsWith(extendedConfig, "./") || startsWith(extendedConfig, "../")) {
            let extendedConfigPath = getNormalizedAbsolutePath(extendedConfig, basePath);
            if (!host.fileExists(extendedConfigPath) && !endsWith(extendedConfigPath, ".json" /* Json */ )) {
                extendedConfigPath = `${extendedConfigPath}.json`;
                if (!host.fileExists(extendedConfigPath)) {
                    errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, Diagnostics.File_0_not_found, extendedConfig));
                    return void 0;
                }
            }
            return extendedConfigPath;
        }
        const resolved = nodeNextJsonConfigResolver(extendedConfig, combinePaths(basePath, "tsconfig.json"), host);
        if (resolved.resolvedModule) return resolved.resolvedModule.resolvedFileName;
        if (extendedConfig === "") errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, Diagnostics.Compiler_option_0_cannot_be_given_an_empty_string, "extends"));
        else errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, Diagnostics.File_0_not_found, extendedConfig));
        return void 0;
    }
    function getExtendedConfig(sourceFile, extendedConfigPath, host, resolutionStack, errors, extendedConfigCache, result) {
        const path = host.useCaseSensitiveFileNames ? extendedConfigPath : toFileNameLowerCase(extendedConfigPath);
        let value1;
        let extendedResult;
        let extendedConfig;
        if (extendedConfigCache && (value1 = extendedConfigCache.get(path))) ({ extendedResult: extendedResult , extendedConfig: extendedConfig  } = value1);
        else {
            extendedResult = readJsonConfigFile(extendedConfigPath, (path2)=>host.readFile(path2));
            if (!extendedResult.parseDiagnostics.length) extendedConfig = parseConfig(/*json*/ void 0, extendedResult, host, getDirectoryPath(extendedConfigPath), getBaseFileName(extendedConfigPath), resolutionStack, errors, extendedConfigCache);
            if (extendedConfigCache) extendedConfigCache.set(path, {
                extendedResult: extendedResult,
                extendedConfig: extendedConfig
            });
        }
        if (sourceFile) {
            (result.extendedSourceFiles ?? (result.extendedSourceFiles = /* @__PURE__ */ new Set())).add(extendedResult.fileName);
            if (extendedResult.extendedSourceFiles) for (const extenedSourceFile of extendedResult.extendedSourceFiles)result.extendedSourceFiles.add(extenedSourceFile);
        }
        if (extendedResult.parseDiagnostics.length) {
            errors.push(...extendedResult.parseDiagnostics);
            return void 0;
        }
        return extendedConfig;
    }
    function convertCompileOnSaveOptionFromJson(jsonOption, basePath, errors) {
        if (!hasProperty(jsonOption, compileOnSaveCommandLineOption.name)) return false;
        const result = convertJsonOption(compileOnSaveCommandLineOption, jsonOption.compileOnSave, basePath, errors);
        return typeof result === "boolean" && result;
    }
    function convertCompilerOptionsFromJson(jsonOptions, basePath, configFileName) {
        const errors = [];
        const options = convertCompilerOptionsFromJsonWorker(jsonOptions, basePath, errors, configFileName);
        return {
            options: options,
            errors: errors
        };
    }
    function convertTypeAcquisitionFromJson(jsonOptions, basePath, configFileName) {
        const errors = [];
        const options = convertTypeAcquisitionFromJsonWorker(jsonOptions, basePath, errors, configFileName);
        return {
            options: options,
            errors: errors
        };
    }
    function getDefaultCompilerOptions(configFileName) {
        const options = configFileName && getBaseFileName(configFileName) === "jsconfig.json" ? {
            allowJs: true,
            maxNodeModuleJsDepth: 2,
            allowSyntheticDefaultImports: true,
            skipLibCheck: true,
            noEmit: true
        } : {};
        return options;
    }
    function convertCompilerOptionsFromJsonWorker(jsonOptions, basePath, errors, configFileName) {
        const options = getDefaultCompilerOptions(configFileName);
        convertOptionsFromJson(getCommandLineCompilerOptionsMap(), jsonOptions, basePath, options, compilerOptionsDidYouMeanDiagnostics, errors);
        if (configFileName) options.configFilePath = normalizeSlashes(configFileName);
        return options;
    }
    function getDefaultTypeAcquisition(configFileName) {
        return {
            enable: !!configFileName && getBaseFileName(configFileName) === "jsconfig.json",
            include: [],
            exclude: []
        };
    }
    function convertTypeAcquisitionFromJsonWorker(jsonOptions, basePath, errors, configFileName) {
        const options = getDefaultTypeAcquisition(configFileName);
        convertOptionsFromJson(getCommandLineTypeAcquisitionMap(), jsonOptions, basePath, options, typeAcquisitionDidYouMeanDiagnostics, errors);
        return options;
    }
    function convertWatchOptionsFromJsonWorker(jsonOptions, basePath, errors) {
        return convertOptionsFromJson(getCommandLineWatchOptionsMap(), jsonOptions, basePath, /*defaultOptions*/ void 0, watchOptionsDidYouMeanDiagnostics, errors);
    }
    function convertOptionsFromJson(optionsNameMap, jsonOptions, basePath, defaultOptions, diagnostics, errors) {
        if (!jsonOptions) return;
        for(const id in jsonOptions){
            const opt = optionsNameMap.get(id);
            if (opt) (defaultOptions || (defaultOptions = {}))[opt.name] = convertJsonOption(opt, jsonOptions[id], basePath, errors);
            else errors.push(createUnknownOptionError(id, diagnostics));
        }
        return defaultOptions;
    }
    function createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, node, message, ...args) {
        return sourceFile && node ? createDiagnosticForNodeInSourceFile(sourceFile, node, message, ...args) : createCompilerDiagnostic(message, ...args);
    }
    function convertJsonOption(opt, value1, basePath, errors, propertyAssignment, valueExpression, sourceFile) {
        if (opt.isCommandLineOnly) {
            errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, propertyAssignment == null ? void 0 : propertyAssignment.name, Diagnostics.Option_0_can_only_be_specified_on_command_line, opt.name));
            return void 0;
        }
        if (isCompilerOptionsValue(opt, value1)) {
            const optType = opt.type;
            if (optType === "list" && isArray(value1)) return convertJsonOptionOfListType(opt, value1, basePath, errors, propertyAssignment, valueExpression, sourceFile);
            else if (optType === "listOrElement") return isArray(value1) ? convertJsonOptionOfListType(opt, value1, basePath, errors, propertyAssignment, valueExpression, sourceFile) : convertJsonOption(opt.element, value1, basePath, errors, propertyAssignment, valueExpression, sourceFile);
            else if (!isString(opt.type)) return convertJsonOptionOfCustomType(opt, value1, errors, valueExpression, sourceFile);
            const validatedValue = validateJsonOptionValue(opt, value1, errors, valueExpression, sourceFile);
            return isNullOrUndefined(validatedValue) ? validatedValue : normalizeNonListOptionValue(opt, basePath, validatedValue);
        } else errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, Diagnostics.Compiler_option_0_requires_a_value_of_type_1, opt.name, getCompilerOptionValueTypeString(opt)));
    }
    function normalizeNonListOptionValue(option, basePath, value1) {
        if (option.isFilePath) {
            value1 = getNormalizedAbsolutePath(value1, basePath);
            if (value1 === "") value1 = ".";
        }
        return value1;
    }
    function validateJsonOptionValue(opt, value1, errors, valueExpression, sourceFile) {
        var _a;
        if (isNullOrUndefined(value1)) return void 0;
        const d = (_a = opt.extraValidation) == null ? void 0 : _a.call(opt, value1);
        if (!d) return value1;
        errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, ...d));
        return void 0;
    }
    function convertJsonOptionOfCustomType(opt, value1, errors, valueExpression, sourceFile) {
        if (isNullOrUndefined(value1)) return void 0;
        const key = value1.toLowerCase();
        const val = opt.type.get(key);
        if (val !== void 0) return validateJsonOptionValue(opt, val, errors, valueExpression, sourceFile);
        else errors.push(createDiagnosticForInvalidCustomType(opt, (message, ...args)=>createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, message, ...args)));
    }
    function convertJsonOptionOfListType(option, values, basePath, errors, propertyAssignment, valueExpression, sourceFile) {
        return filter(map(values, (v, index)=>convertJsonOption(option.element, v, basePath, errors, propertyAssignment, valueExpression == null ? void 0 : valueExpression.elements[index], sourceFile)), (v)=>option.listPreserveFalsyValues ? true : !!v);
    }
    function getFileNamesFromConfigSpecs(configFileSpecs, basePath, options, host, extraFileExtensions = emptyArray) {
        basePath = normalizePath(basePath);
        const keyMapper = createGetCanonicalFileName(host.useCaseSensitiveFileNames);
        const literalFileMap = /* @__PURE__ */ new Map();
        const wildcardFileMap = /* @__PURE__ */ new Map();
        const wildCardJsonFileMap = /* @__PURE__ */ new Map();
        const { validatedFilesSpec: validatedFilesSpec , validatedIncludeSpecs: validatedIncludeSpecs , validatedExcludeSpecs: validatedExcludeSpecs  } = configFileSpecs;
        const supportedExtensions = getSupportedExtensions(options, extraFileExtensions);
        const supportedExtensionsWithJsonIfResolveJsonModule = getSupportedExtensionsWithJsonIfResolveJsonModule(options, supportedExtensions);
        if (validatedFilesSpec) for (const fileName of validatedFilesSpec){
            const file = getNormalizedAbsolutePath(fileName, basePath);
            literalFileMap.set(keyMapper(file), file);
        }
        let jsonOnlyIncludeRegexes;
        if (validatedIncludeSpecs && validatedIncludeSpecs.length > 0) for (const file of host.readDirectory(basePath, flatten(supportedExtensionsWithJsonIfResolveJsonModule), validatedExcludeSpecs, validatedIncludeSpecs, /*depth*/ void 0)){
            if (fileExtensionIs(file, ".json" /* Json */ )) {
                if (!jsonOnlyIncludeRegexes) {
                    const includes = validatedIncludeSpecs.filter((s)=>endsWith(s, ".json" /* Json */ ));
                    const includeFilePatterns = map(getRegularExpressionsForWildcards(includes, basePath, "files"), (pattern)=>`^${pattern}$`);
                    jsonOnlyIncludeRegexes = includeFilePatterns ? includeFilePatterns.map((pattern)=>getRegexFromPattern(pattern, host.useCaseSensitiveFileNames)) : emptyArray;
                }
                const includeIndex = findIndex(jsonOnlyIncludeRegexes, (re)=>re.test(file));
                if (includeIndex !== -1) {
                    const key2 = keyMapper(file);
                    if (!literalFileMap.has(key2) && !wildCardJsonFileMap.has(key2)) wildCardJsonFileMap.set(key2, file);
                }
                continue;
            }
            if (hasFileWithHigherPriorityExtension(file, literalFileMap, wildcardFileMap, supportedExtensions, keyMapper)) continue;
            removeWildcardFilesWithLowerPriorityExtension(file, wildcardFileMap, supportedExtensions, keyMapper);
            const key = keyMapper(file);
            if (!literalFileMap.has(key) && !wildcardFileMap.has(key)) wildcardFileMap.set(key, file);
        }
        const literalFiles = arrayFrom(literalFileMap.values());
        const wildcardFiles = arrayFrom(wildcardFileMap.values());
        return literalFiles.concat(wildcardFiles, arrayFrom(wildCardJsonFileMap.values()));
    }
    function isExcludedFile(pathToCheck, spec, basePath, useCaseSensitiveFileNames, currentDirectory) {
        const { validatedFilesSpec: validatedFilesSpec , validatedIncludeSpecs: validatedIncludeSpecs , validatedExcludeSpecs: validatedExcludeSpecs  } = spec;
        if (!length(validatedIncludeSpecs) || !length(validatedExcludeSpecs)) return false;
        basePath = normalizePath(basePath);
        const keyMapper = createGetCanonicalFileName(useCaseSensitiveFileNames);
        if (validatedFilesSpec) for (const fileName of validatedFilesSpec){
            if (keyMapper(getNormalizedAbsolutePath(fileName, basePath)) === pathToCheck) return false;
        }
        return matchesExcludeWorker(pathToCheck, validatedExcludeSpecs, useCaseSensitiveFileNames, currentDirectory, basePath);
    }
    function invalidDotDotAfterRecursiveWildcard(s) {
        const wildcardIndex = startsWith(s, "**/") ? 0 : s.indexOf("/**/");
        if (wildcardIndex === -1) return false;
        const lastDotIndex = endsWith(s, "/..") ? s.length : s.lastIndexOf("/../");
        return lastDotIndex > wildcardIndex;
    }
    function matchesExclude(pathToCheck, excludeSpecs, useCaseSensitiveFileNames, currentDirectory) {
        return matchesExcludeWorker(pathToCheck, filter(excludeSpecs, (spec)=>!invalidDotDotAfterRecursiveWildcard(spec)), useCaseSensitiveFileNames, currentDirectory);
    }
    function matchesExcludeWorker(pathToCheck, excludeSpecs, useCaseSensitiveFileNames, currentDirectory, basePath) {
        const excludePattern = getRegularExpressionForWildcard(excludeSpecs, combinePaths(normalizePath(currentDirectory), basePath), "exclude");
        const excludeRegex = excludePattern && getRegexFromPattern(excludePattern, useCaseSensitiveFileNames);
        if (!excludeRegex) return false;
        if (excludeRegex.test(pathToCheck)) return true;
        return !hasExtension(pathToCheck) && excludeRegex.test(ensureTrailingDirectorySeparator(pathToCheck));
    }
    function validateSpecs(specs, errors, disallowTrailingRecursion, jsonSourceFile, specKey) {
        return specs.filter((spec)=>{
            if (!isString(spec)) return false;
            const diag2 = specToDiagnostic(spec, disallowTrailingRecursion);
            if (diag2 !== void 0) errors.push(createDiagnostic(...diag2));
            return diag2 === void 0;
        });
        function createDiagnostic(message, spec) {
            const element = getTsConfigPropArrayElementValue(jsonSourceFile, specKey, spec);
            return createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(jsonSourceFile, element, message, spec);
        }
    }
    function specToDiagnostic(spec, disallowTrailingRecursion) {
        Debug.assert(typeof spec === "string");
        if (disallowTrailingRecursion && invalidTrailingRecursionPattern.test(spec)) return [
            Diagnostics.File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0,
            spec
        ];
        else if (invalidDotDotAfterRecursiveWildcard(spec)) return [
            Diagnostics.File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0,
            spec
        ];
    }
    function getWildcardDirectories({ validatedIncludeSpecs: include , validatedExcludeSpecs: exclude  }, path, useCaseSensitiveFileNames) {
        const rawExcludeRegex = getRegularExpressionForWildcard(exclude, path, "exclude");
        const excludeRegex = rawExcludeRegex && new RegExp(rawExcludeRegex, useCaseSensitiveFileNames ? "" : "i");
        const wildcardDirectories = {};
        if (include !== void 0) {
            const recursiveKeys = [];
            for (const file of include){
                const spec = normalizePath(combinePaths(path, file));
                if (excludeRegex && excludeRegex.test(spec)) continue;
                const match = getWildcardDirectoryFromSpec(spec, useCaseSensitiveFileNames);
                if (match) {
                    const { key: key , flags: flags  } = match;
                    const existingFlags = wildcardDirectories[key];
                    if (existingFlags === void 0 || existingFlags < flags) {
                        wildcardDirectories[key] = flags;
                        if (flags === 1 /* Recursive */ ) recursiveKeys.push(key);
                    }
                }
            }
            for(const key in wildcardDirectories)if (hasProperty(wildcardDirectories, key)) {
                for (const recursiveKey of recursiveKeys)if (key !== recursiveKey && containsPath(recursiveKey, key, path, !useCaseSensitiveFileNames)) delete wildcardDirectories[key];
            }
        }
        return wildcardDirectories;
    }
    function getWildcardDirectoryFromSpec(spec, useCaseSensitiveFileNames) {
        const match = wildcardDirectoryPattern.exec(spec);
        if (match) {
            const questionWildcardIndex = spec.indexOf("?");
            const starWildcardIndex = spec.indexOf("*");
            const lastDirectorySeperatorIndex = spec.lastIndexOf(directorySeparator);
            return {
                key: useCaseSensitiveFileNames ? match[0] : toFileNameLowerCase(match[0]),
                flags: questionWildcardIndex !== -1 && questionWildcardIndex < lastDirectorySeperatorIndex || starWildcardIndex !== -1 && starWildcardIndex < lastDirectorySeperatorIndex ? 1 /* Recursive */  : 0 /* None */ 
            };
        }
        if (isImplicitGlob(spec.substring(spec.lastIndexOf(directorySeparator) + 1))) return {
            key: removeTrailingDirectorySeparator(useCaseSensitiveFileNames ? spec : toFileNameLowerCase(spec)),
            flags: 1 /* Recursive */ 
        };
        return void 0;
    }
    function hasFileWithHigherPriorityExtension(file, literalFiles, wildcardFiles, extensions, keyMapper) {
        const extensionGroup = forEach(extensions, (group2)=>fileExtensionIsOneOf(file, group2) ? group2 : void 0);
        if (!extensionGroup) return false;
        for (const ext of extensionGroup){
            if (fileExtensionIs(file, ext)) return false;
            const higherPriorityPath = keyMapper(changeExtension(file, ext));
            if (literalFiles.has(higherPriorityPath) || wildcardFiles.has(higherPriorityPath)) {
                if (ext === ".d.ts" /* Dts */  && (fileExtensionIs(file, ".js" /* Js */ ) || fileExtensionIs(file, ".jsx" /* Jsx */ ))) continue;
                return true;
            }
        }
        return false;
    }
    function removeWildcardFilesWithLowerPriorityExtension(file, wildcardFiles, extensions, keyMapper) {
        const extensionGroup = forEach(extensions, (group2)=>fileExtensionIsOneOf(file, group2) ? group2 : void 0);
        if (!extensionGroup) return;
        for(let i = extensionGroup.length - 1; i >= 0; i--){
            const ext = extensionGroup[i];
            if (fileExtensionIs(file, ext)) return;
            const lowerPriorityPath = keyMapper(changeExtension(file, ext));
            wildcardFiles.delete(lowerPriorityPath);
        }
    }
    function convertCompilerOptionsForTelemetry(opts) {
        const out = {};
        for(const key in opts)if (hasProperty(opts, key)) {
            const type = getOptionFromName(key);
            if (type !== void 0) out[key] = getOptionValueWithEmptyStrings(opts[key], type);
        }
        return out;
    }
    function getOptionValueWithEmptyStrings(value1, option) {
        if (value1 === void 0) return value1;
        switch(option.type){
            case "object":
                return "";
            case "string":
                return "";
            case "number":
                return typeof value1 === "number" ? value1 : "";
            case "boolean":
                return typeof value1 === "boolean" ? value1 : "";
            case "listOrElement":
                if (!isArray(value1)) return getOptionValueWithEmptyStrings(value1, option.element);
            case "list":
                const elementType = option.element;
                return isArray(value1) ? mapDefined(value1, (v)=>getOptionValueWithEmptyStrings(v, elementType)) : "";
            default:
                return forEachEntry(option.type, (optionEnumValue, optionStringValue)=>{
                    if (optionEnumValue === value1) return optionStringValue;
                });
        }
    }
    function getDefaultValueForOption(option) {
        switch(option.type){
            case "number":
                return 1;
            case "boolean":
                return true;
            case "string":
                const defaultValue = option.defaultValueDescription;
                return option.isFilePath ? `./${defaultValue && typeof defaultValue === "string" ? defaultValue : ""}` : "";
            case "list":
                return [];
            case "listOrElement":
                return getDefaultValueForOption(option.element);
            case "object":
                return {};
            default:
                const value1 = firstOrUndefinedIterator(option.type.keys());
                if (value1 !== void 0) return value1;
                return Debug.fail("Expected 'option.type' to have entries.");
        }
    }
    var compileOnSaveCommandLineOption, jsxOptionMap, inverseJsxOptionMap, libEntries, libs, libMap, optionsForWatch, commonOptionsWithBuild, targetOptionDeclaration, moduleOptionDeclaration, commandOptionsWithoutBuild, optionDeclarations, semanticDiagnosticsOptionDeclarations, affectsEmitOptionDeclarations, affectsDeclarationPathOptionDeclarations, moduleResolutionOptionDeclarations, sourceFileAffectingCompilerOptions, optionsAffectingProgramStructure, transpileOptionValueCompilerOptions, optionsForBuild, buildOpts, typeAcquisitionDeclarations, optionsNameMapCache, compilerOptionsAlternateMode, defaultInitCompilerOptions, compilerOptionsDidYouMeanDiagnostics, buildOptionsNameMapCache, buildOptionsAlternateMode, buildOptionsDidYouMeanDiagnostics, typeAcquisitionDidYouMeanDiagnostics, watchOptionsNameMapCache, watchOptionsDidYouMeanDiagnostics, commandLineCompilerOptionsMapCache, commandLineWatchOptionsMapCache, commandLineTypeAcquisitionMapCache, extendsOptionDeclaration, compilerOptionsDeclaration, watchOptionsDeclaration, typeAcquisitionDeclaration, _tsconfigRootOptions, defaultIncludeSpec, invalidTrailingRecursionPattern, wildcardDirectoryPattern;
    var init_commandLineParser = __esm({
        "src/compiler/commandLineParser.ts" () {
            "use strict";
            init_ts2();
            compileOnSaveCommandLineOption = {
                name: "compileOnSave",
                type: "boolean",
                defaultValueDescription: false
            };
            jsxOptionMap = new Map(Object.entries({
                "preserve": 1 /* Preserve */ ,
                "react-native": 3 /* ReactNative */ ,
                "react": 2 /* React */ ,
                "react-jsx": 4 /* ReactJSX */ ,
                "react-jsxdev": 5 /* ReactJSXDev */ 
            }));
            inverseJsxOptionMap = new Map(mapIterator(jsxOptionMap.entries(), ([key, value1])=>[
                    "" + value1,
                    key
                ]));
            libEntries = [
                // JavaScript only
                [
                    "es5",
                    "lib.es5.d.ts"
                ],
                [
                    "es6",
                    "lib.es2015.d.ts"
                ],
                [
                    "es2015",
                    "lib.es2015.d.ts"
                ],
                [
                    "es7",
                    "lib.es2016.d.ts"
                ],
                [
                    "es2016",
                    "lib.es2016.d.ts"
                ],
                [
                    "es2017",
                    "lib.es2017.d.ts"
                ],
                [
                    "es2018",
                    "lib.es2018.d.ts"
                ],
                [
                    "es2019",
                    "lib.es2019.d.ts"
                ],
                [
                    "es2020",
                    "lib.es2020.d.ts"
                ],
                [
                    "es2021",
                    "lib.es2021.d.ts"
                ],
                [
                    "es2022",
                    "lib.es2022.d.ts"
                ],
                [
                    "es2023",
                    "lib.es2023.d.ts"
                ],
                [
                    "esnext",
                    "lib.esnext.d.ts"
                ],
                // Host only
                [
                    "dom",
                    "lib.dom.d.ts"
                ],
                [
                    "dom.iterable",
                    "lib.dom.iterable.d.ts"
                ],
                [
                    "webworker",
                    "lib.webworker.d.ts"
                ],
                [
                    "webworker.importscripts",
                    "lib.webworker.importscripts.d.ts"
                ],
                [
                    "webworker.iterable",
                    "lib.webworker.iterable.d.ts"
                ],
                [
                    "scripthost",
                    "lib.scripthost.d.ts"
                ],
                // ES2015 Or ESNext By-feature options
                [
                    "es2015.core",
                    "lib.es2015.core.d.ts"
                ],
                [
                    "es2015.collection",
                    "lib.es2015.collection.d.ts"
                ],
                [
                    "es2015.generator",
                    "lib.es2015.generator.d.ts"
                ],
                [
                    "es2015.iterable",
                    "lib.es2015.iterable.d.ts"
                ],
                [
                    "es2015.promise",
                    "lib.es2015.promise.d.ts"
                ],
                [
                    "es2015.proxy",
                    "lib.es2015.proxy.d.ts"
                ],
                [
                    "es2015.reflect",
                    "lib.es2015.reflect.d.ts"
                ],
                [
                    "es2015.symbol",
                    "lib.es2015.symbol.d.ts"
                ],
                [
                    "es2015.symbol.wellknown",
                    "lib.es2015.symbol.wellknown.d.ts"
                ],
                [
                    "es2016.array.include",
                    "lib.es2016.array.include.d.ts"
                ],
                [
                    "es2017.object",
                    "lib.es2017.object.d.ts"
                ],
                [
                    "es2017.sharedmemory",
                    "lib.es2017.sharedmemory.d.ts"
                ],
                [
                    "es2017.string",
                    "lib.es2017.string.d.ts"
                ],
                [
                    "es2017.intl",
                    "lib.es2017.intl.d.ts"
                ],
                [
                    "es2017.typedarrays",
                    "lib.es2017.typedarrays.d.ts"
                ],
                [
                    "es2018.asyncgenerator",
                    "lib.es2018.asyncgenerator.d.ts"
                ],
                [
                    "es2018.asynciterable",
                    "lib.es2018.asynciterable.d.ts"
                ],
                [
                    "es2018.intl",
                    "lib.es2018.intl.d.ts"
                ],
                [
                    "es2018.promise",
                    "lib.es2018.promise.d.ts"
                ],
                [
                    "es2018.regexp",
                    "lib.es2018.regexp.d.ts"
                ],
                [
                    "es2019.array",
                    "lib.es2019.array.d.ts"
                ],
                [
                    "es2019.object",
                    "lib.es2019.object.d.ts"
                ],
                [
                    "es2019.string",
                    "lib.es2019.string.d.ts"
                ],
                [
                    "es2019.symbol",
                    "lib.es2019.symbol.d.ts"
                ],
                [
                    "es2019.intl",
                    "lib.es2019.intl.d.ts"
                ],
                [
                    "es2020.bigint",
                    "lib.es2020.bigint.d.ts"
                ],
                [
                    "es2020.date",
                    "lib.es2020.date.d.ts"
                ],
                [
                    "es2020.promise",
                    "lib.es2020.promise.d.ts"
                ],
                [
                    "es2020.sharedmemory",
                    "lib.es2020.sharedmemory.d.ts"
                ],
                [
                    "es2020.string",
                    "lib.es2020.string.d.ts"
                ],
                [
                    "es2020.symbol.wellknown",
                    "lib.es2020.symbol.wellknown.d.ts"
                ],
                [
                    "es2020.intl",
                    "lib.es2020.intl.d.ts"
                ],
                [
                    "es2020.number",
                    "lib.es2020.number.d.ts"
                ],
                [
                    "es2021.promise",
                    "lib.es2021.promise.d.ts"
                ],
                [
                    "es2021.string",
                    "lib.es2021.string.d.ts"
                ],
                [
                    "es2021.weakref",
                    "lib.es2021.weakref.d.ts"
                ],
                [
                    "es2021.intl",
                    "lib.es2021.intl.d.ts"
                ],
                [
                    "es2022.array",
                    "lib.es2022.array.d.ts"
                ],
                [
                    "es2022.error",
                    "lib.es2022.error.d.ts"
                ],
                [
                    "es2022.intl",
                    "lib.es2022.intl.d.ts"
                ],
                [
                    "es2022.object",
                    "lib.es2022.object.d.ts"
                ],
                [
                    "es2022.sharedmemory",
                    "lib.es2022.sharedmemory.d.ts"
                ],
                [
                    "es2022.string",
                    "lib.es2022.string.d.ts"
                ],
                [
                    "es2022.regexp",
                    "lib.es2022.regexp.d.ts"
                ],
                [
                    "es2023.array",
                    "lib.es2023.array.d.ts"
                ],
                [
                    "esnext.array",
                    "lib.es2023.array.d.ts"
                ],
                [
                    "esnext.symbol",
                    "lib.es2019.symbol.d.ts"
                ],
                [
                    "esnext.asynciterable",
                    "lib.es2018.asynciterable.d.ts"
                ],
                [
                    "esnext.intl",
                    "lib.esnext.intl.d.ts"
                ],
                [
                    "esnext.bigint",
                    "lib.es2020.bigint.d.ts"
                ],
                [
                    "esnext.string",
                    "lib.es2022.string.d.ts"
                ],
                [
                    "esnext.promise",
                    "lib.es2021.promise.d.ts"
                ],
                [
                    "esnext.weakref",
                    "lib.es2021.weakref.d.ts"
                ],
                [
                    "decorators",
                    "lib.decorators.d.ts"
                ],
                [
                    "decorators.legacy",
                    "lib.decorators.legacy.d.ts"
                ]
            ];
            libs = libEntries.map((entry)=>entry[0]);
            libMap = new Map(libEntries);
            optionsForWatch = [
                {
                    name: "watchFile",
                    type: new Map(Object.entries({
                        fixedpollinginterval: 0 /* FixedPollingInterval */ ,
                        prioritypollinginterval: 1 /* PriorityPollingInterval */ ,
                        dynamicprioritypolling: 2 /* DynamicPriorityPolling */ ,
                        fixedchunksizepolling: 3 /* FixedChunkSizePolling */ ,
                        usefsevents: 4 /* UseFsEvents */ ,
                        usefseventsonparentdirectory: 5 /* UseFsEventsOnParentDirectory */ 
                    })),
                    category: Diagnostics.Watch_and_Build_Modes,
                    description: Diagnostics.Specify_how_the_TypeScript_watch_mode_works,
                    defaultValueDescription: 4 /* UseFsEvents */ 
                },
                {
                    name: "watchDirectory",
                    type: new Map(Object.entries({
                        usefsevents: 0 /* UseFsEvents */ ,
                        fixedpollinginterval: 1 /* FixedPollingInterval */ ,
                        dynamicprioritypolling: 2 /* DynamicPriorityPolling */ ,
                        fixedchunksizepolling: 3 /* FixedChunkSizePolling */ 
                    })),
                    category: Diagnostics.Watch_and_Build_Modes,
                    description: Diagnostics.Specify_how_directories_are_watched_on_systems_that_lack_recursive_file_watching_functionality,
                    defaultValueDescription: 0 /* UseFsEvents */ 
                },
                {
                    name: "fallbackPolling",
                    type: new Map(Object.entries({
                        fixedinterval: 0 /* FixedInterval */ ,
                        priorityinterval: 1 /* PriorityInterval */ ,
                        dynamicpriority: 2 /* DynamicPriority */ ,
                        fixedchunksize: 3 /* FixedChunkSize */ 
                    })),
                    category: Diagnostics.Watch_and_Build_Modes,
                    description: Diagnostics.Specify_what_approach_the_watcher_should_use_if_the_system_runs_out_of_native_file_watchers,
                    defaultValueDescription: 1 /* PriorityInterval */ 
                },
                {
                    name: "synchronousWatchDirectory",
                    type: "boolean",
                    category: Diagnostics.Watch_and_Build_Modes,
                    description: Diagnostics.Synchronously_call_callbacks_and_update_the_state_of_directory_watchers_on_platforms_that_don_t_support_recursive_watching_natively,
                    defaultValueDescription: false
                },
                {
                    name: "excludeDirectories",
                    type: "list",
                    element: {
                        name: "excludeDirectory",
                        type: "string",
                        isFilePath: true,
                        extraValidation: specToDiagnostic
                    },
                    category: Diagnostics.Watch_and_Build_Modes,
                    description: Diagnostics.Remove_a_list_of_directories_from_the_watch_process
                },
                {
                    name: "excludeFiles",
                    type: "list",
                    element: {
                        name: "excludeFile",
                        type: "string",
                        isFilePath: true,
                        extraValidation: specToDiagnostic
                    },
                    category: Diagnostics.Watch_and_Build_Modes,
                    description: Diagnostics.Remove_a_list_of_files_from_the_watch_mode_s_processing
                }
            ];
            commonOptionsWithBuild = [
                {
                    name: "help",
                    shortName: "h",
                    type: "boolean",
                    showInSimplifiedHelpView: true,
                    isCommandLineOnly: true,
                    category: Diagnostics.Command_line_Options,
                    description: Diagnostics.Print_this_message,
                    defaultValueDescription: false
                },
                {
                    name: "help",
                    shortName: "?",
                    type: "boolean",
                    isCommandLineOnly: true,
                    category: Diagnostics.Command_line_Options,
                    defaultValueDescription: false
                },
                {
                    name: "watch",
                    shortName: "w",
                    type: "boolean",
                    showInSimplifiedHelpView: true,
                    isCommandLineOnly: true,
                    category: Diagnostics.Command_line_Options,
                    description: Diagnostics.Watch_input_files,
                    defaultValueDescription: false
                },
                {
                    name: "preserveWatchOutput",
                    type: "boolean",
                    showInSimplifiedHelpView: false,
                    category: Diagnostics.Output_Formatting,
                    description: Diagnostics.Disable_wiping_the_console_in_watch_mode,
                    defaultValueDescription: false
                },
                {
                    name: "listFiles",
                    type: "boolean",
                    category: Diagnostics.Compiler_Diagnostics,
                    description: Diagnostics.Print_all_of_the_files_read_during_the_compilation,
                    defaultValueDescription: false
                },
                {
                    name: "explainFiles",
                    type: "boolean",
                    category: Diagnostics.Compiler_Diagnostics,
                    description: Diagnostics.Print_files_read_during_the_compilation_including_why_it_was_included,
                    defaultValueDescription: false
                },
                {
                    name: "listEmittedFiles",
                    type: "boolean",
                    category: Diagnostics.Compiler_Diagnostics,
                    description: Diagnostics.Print_the_names_of_emitted_files_after_a_compilation,
                    defaultValueDescription: false
                },
                {
                    name: "pretty",
                    type: "boolean",
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Output_Formatting,
                    description: Diagnostics.Enable_color_and_formatting_in_TypeScript_s_output_to_make_compiler_errors_easier_to_read,
                    defaultValueDescription: true
                },
                {
                    name: "traceResolution",
                    type: "boolean",
                    category: Diagnostics.Compiler_Diagnostics,
                    description: Diagnostics.Log_paths_used_during_the_moduleResolution_process,
                    defaultValueDescription: false
                },
                {
                    name: "diagnostics",
                    type: "boolean",
                    category: Diagnostics.Compiler_Diagnostics,
                    description: Diagnostics.Output_compiler_performance_information_after_building,
                    defaultValueDescription: false
                },
                {
                    name: "extendedDiagnostics",
                    type: "boolean",
                    category: Diagnostics.Compiler_Diagnostics,
                    description: Diagnostics.Output_more_detailed_compiler_performance_information_after_building,
                    defaultValueDescription: false
                },
                {
                    name: "generateCpuProfile",
                    type: "string",
                    isFilePath: true,
                    paramType: Diagnostics.FILE_OR_DIRECTORY,
                    category: Diagnostics.Compiler_Diagnostics,
                    description: Diagnostics.Emit_a_v8_CPU_profile_of_the_compiler_run_for_debugging,
                    defaultValueDescription: "profile.cpuprofile"
                },
                {
                    name: "generateTrace",
                    type: "string",
                    isFilePath: true,
                    isCommandLineOnly: true,
                    paramType: Diagnostics.DIRECTORY,
                    category: Diagnostics.Compiler_Diagnostics,
                    description: Diagnostics.Generates_an_event_trace_and_a_list_of_types
                },
                {
                    name: "incremental",
                    shortName: "i",
                    type: "boolean",
                    category: Diagnostics.Projects,
                    description: Diagnostics.Save_tsbuildinfo_files_to_allow_for_incremental_compilation_of_projects,
                    transpileOptionValue: void 0,
                    defaultValueDescription: Diagnostics.false_unless_composite_is_set
                },
                {
                    name: "declaration",
                    shortName: "d",
                    type: "boolean",
                    // Not setting affectsEmit because we calculate this flag might not affect full emit
                    affectsBuildInfo: true,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Emit,
                    transpileOptionValue: void 0,
                    description: Diagnostics.Generate_d_ts_files_from_TypeScript_and_JavaScript_files_in_your_project,
                    defaultValueDescription: Diagnostics.false_unless_composite_is_set
                },
                {
                    name: "declarationMap",
                    type: "boolean",
                    // Not setting affectsEmit because we calculate this flag might not affect full emit
                    affectsBuildInfo: true,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Emit,
                    transpileOptionValue: void 0,
                    defaultValueDescription: false,
                    description: Diagnostics.Create_sourcemaps_for_d_ts_files
                },
                {
                    name: "emitDeclarationOnly",
                    type: "boolean",
                    // Not setting affectsEmit because we calculate this flag might not affect full emit
                    affectsBuildInfo: true,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Only_output_d_ts_files_and_not_JavaScript_files,
                    transpileOptionValue: void 0,
                    defaultValueDescription: false
                },
                {
                    name: "sourceMap",
                    type: "boolean",
                    // Not setting affectsEmit because we calculate this flag might not affect full emit
                    affectsBuildInfo: true,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Emit,
                    defaultValueDescription: false,
                    description: Diagnostics.Create_source_map_files_for_emitted_JavaScript_files
                },
                {
                    name: "inlineSourceMap",
                    type: "boolean",
                    // Not setting affectsEmit because we calculate this flag might not affect full emit
                    affectsBuildInfo: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Include_sourcemap_files_inside_the_emitted_JavaScript,
                    defaultValueDescription: false
                },
                {
                    name: "assumeChangesOnlyAffectDirectDependencies",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Watch_and_Build_Modes,
                    description: Diagnostics.Have_recompiles_in_projects_that_use_incremental_and_watch_mode_assume_that_changes_within_a_file_will_only_affect_files_directly_depending_on_it,
                    defaultValueDescription: false
                },
                {
                    name: "locale",
                    type: "string",
                    category: Diagnostics.Command_line_Options,
                    isCommandLineOnly: true,
                    description: Diagnostics.Set_the_language_of_the_messaging_from_TypeScript_This_does_not_affect_emit,
                    defaultValueDescription: Diagnostics.Platform_specific
                }
            ];
            targetOptionDeclaration = {
                name: "target",
                shortName: "t",
                type: new Map(Object.entries({
                    es3: 0 /* ES3 */ ,
                    es5: 1 /* ES5 */ ,
                    es6: 2 /* ES2015 */ ,
                    es2015: 2 /* ES2015 */ ,
                    es2016: 3 /* ES2016 */ ,
                    es2017: 4 /* ES2017 */ ,
                    es2018: 5 /* ES2018 */ ,
                    es2019: 6 /* ES2019 */ ,
                    es2020: 7 /* ES2020 */ ,
                    es2021: 8 /* ES2021 */ ,
                    es2022: 9 /* ES2022 */ ,
                    esnext: 99 /* ESNext */ 
                })),
                affectsSourceFile: true,
                affectsModuleResolution: true,
                affectsEmit: true,
                affectsBuildInfo: true,
                paramType: Diagnostics.VERSION,
                showInSimplifiedHelpView: true,
                category: Diagnostics.Language_and_Environment,
                description: Diagnostics.Set_the_JavaScript_language_version_for_emitted_JavaScript_and_include_compatible_library_declarations,
                defaultValueDescription: 1 /* ES5 */ 
            };
            moduleOptionDeclaration = {
                name: "module",
                shortName: "m",
                type: new Map(Object.entries({
                    none: 0 /* None */ ,
                    commonjs: 1 /* CommonJS */ ,
                    amd: 2 /* AMD */ ,
                    system: 4 /* System */ ,
                    umd: 3 /* UMD */ ,
                    es6: 5 /* ES2015 */ ,
                    es2015: 5 /* ES2015 */ ,
                    es2020: 6 /* ES2020 */ ,
                    es2022: 7 /* ES2022 */ ,
                    esnext: 99 /* ESNext */ ,
                    node16: 100 /* Node16 */ ,
                    nodenext: 199 /* NodeNext */ 
                })),
                affectsModuleResolution: true,
                affectsEmit: true,
                affectsBuildInfo: true,
                paramType: Diagnostics.KIND,
                showInSimplifiedHelpView: true,
                category: Diagnostics.Modules,
                description: Diagnostics.Specify_what_module_code_is_generated,
                defaultValueDescription: void 0
            };
            commandOptionsWithoutBuild = [
                // CommandLine only options
                {
                    name: "all",
                    type: "boolean",
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Command_line_Options,
                    description: Diagnostics.Show_all_compiler_options,
                    defaultValueDescription: false
                },
                {
                    name: "version",
                    shortName: "v",
                    type: "boolean",
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Command_line_Options,
                    description: Diagnostics.Print_the_compiler_s_version,
                    defaultValueDescription: false
                },
                {
                    name: "init",
                    type: "boolean",
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Command_line_Options,
                    description: Diagnostics.Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file,
                    defaultValueDescription: false
                },
                {
                    name: "project",
                    shortName: "p",
                    type: "string",
                    isFilePath: true,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Command_line_Options,
                    paramType: Diagnostics.FILE_OR_DIRECTORY,
                    description: Diagnostics.Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json
                },
                {
                    name: "build",
                    type: "boolean",
                    shortName: "b",
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Command_line_Options,
                    description: Diagnostics.Build_one_or_more_projects_and_their_dependencies_if_out_of_date,
                    defaultValueDescription: false
                },
                {
                    name: "showConfig",
                    type: "boolean",
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Command_line_Options,
                    isCommandLineOnly: true,
                    description: Diagnostics.Print_the_final_configuration_instead_of_building,
                    defaultValueDescription: false
                },
                {
                    name: "listFilesOnly",
                    type: "boolean",
                    category: Diagnostics.Command_line_Options,
                    isCommandLineOnly: true,
                    description: Diagnostics.Print_names_of_files_that_are_part_of_the_compilation_and_then_stop_processing,
                    defaultValueDescription: false
                },
                // Basic
                targetOptionDeclaration,
                moduleOptionDeclaration,
                {
                    name: "lib",
                    type: "list",
                    element: {
                        name: "lib",
                        type: libMap,
                        defaultValueDescription: void 0
                    },
                    affectsProgramStructure: true,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Language_and_Environment,
                    description: Diagnostics.Specify_a_set_of_bundled_library_declaration_files_that_describe_the_target_runtime_environment,
                    transpileOptionValue: void 0
                },
                {
                    name: "allowJs",
                    type: "boolean",
                    affectsModuleResolution: true,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.JavaScript_Support,
                    description: Diagnostics.Allow_JavaScript_files_to_be_a_part_of_your_program_Use_the_checkJS_option_to_get_errors_from_these_files,
                    defaultValueDescription: false
                },
                {
                    name: "checkJs",
                    type: "boolean",
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.JavaScript_Support,
                    description: Diagnostics.Enable_error_reporting_in_type_checked_JavaScript_files,
                    defaultValueDescription: false
                },
                {
                    name: "jsx",
                    type: jsxOptionMap,
                    affectsSourceFile: true,
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    affectsModuleResolution: true,
                    paramType: Diagnostics.KIND,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Language_and_Environment,
                    description: Diagnostics.Specify_what_JSX_code_is_generated,
                    defaultValueDescription: void 0
                },
                {
                    name: "outFile",
                    type: "string",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    affectsDeclarationPath: true,
                    isFilePath: true,
                    paramType: Diagnostics.FILE,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Specify_a_file_that_bundles_all_outputs_into_one_JavaScript_file_If_declaration_is_true_also_designates_a_file_that_bundles_all_d_ts_output,
                    transpileOptionValue: void 0
                },
                {
                    name: "outDir",
                    type: "string",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    affectsDeclarationPath: true,
                    isFilePath: true,
                    paramType: Diagnostics.DIRECTORY,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Specify_an_output_folder_for_all_emitted_files
                },
                {
                    name: "rootDir",
                    type: "string",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    affectsDeclarationPath: true,
                    isFilePath: true,
                    paramType: Diagnostics.LOCATION,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Specify_the_root_folder_within_your_source_files,
                    defaultValueDescription: Diagnostics.Computed_from_the_list_of_input_files
                },
                {
                    name: "composite",
                    type: "boolean",
                    // Not setting affectsEmit because we calculate this flag might not affect full emit
                    affectsBuildInfo: true,
                    isTSConfigOnly: true,
                    category: Diagnostics.Projects,
                    transpileOptionValue: void 0,
                    defaultValueDescription: false,
                    description: Diagnostics.Enable_constraints_that_allow_a_TypeScript_project_to_be_used_with_project_references
                },
                {
                    name: "tsBuildInfoFile",
                    type: "string",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    isFilePath: true,
                    paramType: Diagnostics.FILE,
                    category: Diagnostics.Projects,
                    transpileOptionValue: void 0,
                    defaultValueDescription: ".tsbuildinfo",
                    description: Diagnostics.Specify_the_path_to_tsbuildinfo_incremental_compilation_file
                },
                {
                    name: "removeComments",
                    type: "boolean",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Emit,
                    defaultValueDescription: false,
                    description: Diagnostics.Disable_emitting_comments
                },
                {
                    name: "noEmit",
                    type: "boolean",
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Disable_emitting_files_from_a_compilation,
                    transpileOptionValue: void 0,
                    defaultValueDescription: false
                },
                {
                    name: "importHelpers",
                    type: "boolean",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Allow_importing_helper_functions_from_tslib_once_per_project_instead_of_including_them_per_file,
                    defaultValueDescription: false
                },
                {
                    name: "importsNotUsedAsValues",
                    type: new Map(Object.entries({
                        remove: 0 /* Remove */ ,
                        preserve: 1 /* Preserve */ ,
                        error: 2 /* Error */ 
                    })),
                    affectsEmit: true,
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Specify_emit_Slashchecking_behavior_for_imports_that_are_only_used_for_types,
                    defaultValueDescription: 0 /* Remove */ 
                },
                {
                    name: "downlevelIteration",
                    type: "boolean",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Emit_more_compliant_but_verbose_and_less_performant_JavaScript_for_iteration,
                    defaultValueDescription: false
                },
                {
                    name: "isolatedModules",
                    type: "boolean",
                    category: Diagnostics.Interop_Constraints,
                    description: Diagnostics.Ensure_that_each_file_can_be_safely_transpiled_without_relying_on_other_imports,
                    transpileOptionValue: true,
                    defaultValueDescription: false
                },
                {
                    name: "verbatimModuleSyntax",
                    type: "boolean",
                    category: Diagnostics.Interop_Constraints,
                    description: Diagnostics.Do_not_transform_or_elide_any_imports_or_exports_not_marked_as_type_only_ensuring_they_are_written_in_the_output_file_s_format_based_on_the_module_setting,
                    defaultValueDescription: false
                },
                // Strict Type Checks
                {
                    name: "strict",
                    type: "boolean",
                    // Though this affects semantic diagnostics, affectsSemanticDiagnostics is not set here
                    // The value of each strictFlag depends on own strictFlag value or this and never accessed directly.
                    // But we need to store `strict` in builf info, even though it won't be examined directly, so that the
                    // flags it controls (e.g. `strictNullChecks`) will be retrieved correctly
                    affectsBuildInfo: true,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Enable_all_strict_type_checking_options,
                    defaultValueDescription: false
                },
                {
                    name: "noImplicitAny",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    strictFlag: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Enable_error_reporting_for_expressions_and_declarations_with_an_implied_any_type,
                    defaultValueDescription: Diagnostics.false_unless_strict_is_set
                },
                {
                    name: "strictNullChecks",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    strictFlag: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.When_type_checking_take_into_account_null_and_undefined,
                    defaultValueDescription: Diagnostics.false_unless_strict_is_set
                },
                {
                    name: "strictFunctionTypes",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    strictFlag: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.When_assigning_functions_check_to_ensure_parameters_and_the_return_values_are_subtype_compatible,
                    defaultValueDescription: Diagnostics.false_unless_strict_is_set
                },
                {
                    name: "strictBindCallApply",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    strictFlag: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Check_that_the_arguments_for_bind_call_and_apply_methods_match_the_original_function,
                    defaultValueDescription: Diagnostics.false_unless_strict_is_set
                },
                {
                    name: "strictPropertyInitialization",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    strictFlag: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Check_for_class_properties_that_are_declared_but_not_set_in_the_constructor,
                    defaultValueDescription: Diagnostics.false_unless_strict_is_set
                },
                {
                    name: "noImplicitThis",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    strictFlag: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Enable_error_reporting_when_this_is_given_the_type_any,
                    defaultValueDescription: Diagnostics.false_unless_strict_is_set
                },
                {
                    name: "useUnknownInCatchVariables",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    strictFlag: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Default_catch_clause_variables_as_unknown_instead_of_any,
                    defaultValueDescription: false
                },
                {
                    name: "alwaysStrict",
                    type: "boolean",
                    affectsSourceFile: true,
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    strictFlag: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Ensure_use_strict_is_always_emitted,
                    defaultValueDescription: Diagnostics.false_unless_strict_is_set
                },
                // Additional Checks
                {
                    name: "noUnusedLocals",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Enable_error_reporting_when_local_variables_aren_t_read,
                    defaultValueDescription: false
                },
                {
                    name: "noUnusedParameters",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Raise_an_error_when_a_function_parameter_isn_t_read,
                    defaultValueDescription: false
                },
                {
                    name: "exactOptionalPropertyTypes",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Interpret_optional_property_types_as_written_rather_than_adding_undefined,
                    defaultValueDescription: false
                },
                {
                    name: "noImplicitReturns",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Enable_error_reporting_for_codepaths_that_do_not_explicitly_return_in_a_function,
                    defaultValueDescription: false
                },
                {
                    name: "noFallthroughCasesInSwitch",
                    type: "boolean",
                    affectsBindDiagnostics: true,
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Enable_error_reporting_for_fallthrough_cases_in_switch_statements,
                    defaultValueDescription: false
                },
                {
                    name: "noUncheckedIndexedAccess",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Add_undefined_to_a_type_when_accessed_using_an_index,
                    defaultValueDescription: false
                },
                {
                    name: "noImplicitOverride",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Ensure_overriding_members_in_derived_classes_are_marked_with_an_override_modifier,
                    defaultValueDescription: false
                },
                {
                    name: "noPropertyAccessFromIndexSignature",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    showInSimplifiedHelpView: false,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Enforces_using_indexed_accessors_for_keys_declared_using_an_indexed_type,
                    defaultValueDescription: false
                },
                // Module Resolution
                {
                    name: "moduleResolution",
                    type: new Map(Object.entries({
                        // N.B. The first entry specifies the value shown in `tsc --init`
                        node10: 2 /* Node10 */ ,
                        node: 2 /* Node10 */ ,
                        classic: 1 /* Classic */ ,
                        node16: 3 /* Node16 */ ,
                        nodenext: 99 /* NodeNext */ ,
                        bundler: 100 /* Bundler */ 
                    })),
                    deprecatedKeys: /* @__PURE__ */ new Set([
                        "node"
                    ]),
                    affectsModuleResolution: true,
                    paramType: Diagnostics.STRATEGY,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Specify_how_TypeScript_looks_up_a_file_from_a_given_module_specifier,
                    defaultValueDescription: Diagnostics.module_AMD_or_UMD_or_System_or_ES6_then_Classic_Otherwise_Node
                },
                {
                    name: "baseUrl",
                    type: "string",
                    affectsModuleResolution: true,
                    isFilePath: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Specify_the_base_directory_to_resolve_non_relative_module_names
                },
                {
                    // this option can only be specified in tsconfig.json
                    // use type = object to copy the value as-is
                    name: "paths",
                    type: "object",
                    affectsModuleResolution: true,
                    isTSConfigOnly: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Specify_a_set_of_entries_that_re_map_imports_to_additional_lookup_locations,
                    transpileOptionValue: void 0
                },
                {
                    // this option can only be specified in tsconfig.json
                    // use type = object to copy the value as-is
                    name: "rootDirs",
                    type: "list",
                    isTSConfigOnly: true,
                    element: {
                        name: "rootDirs",
                        type: "string",
                        isFilePath: true
                    },
                    affectsModuleResolution: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Allow_multiple_folders_to_be_treated_as_one_when_resolving_modules,
                    transpileOptionValue: void 0,
                    defaultValueDescription: Diagnostics.Computed_from_the_list_of_input_files
                },
                {
                    name: "typeRoots",
                    type: "list",
                    element: {
                        name: "typeRoots",
                        type: "string",
                        isFilePath: true
                    },
                    affectsModuleResolution: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Specify_multiple_folders_that_act_like_Slashnode_modules_Slash_types
                },
                {
                    name: "types",
                    type: "list",
                    element: {
                        name: "types",
                        type: "string"
                    },
                    affectsProgramStructure: true,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Specify_type_package_names_to_be_included_without_being_referenced_in_a_source_file,
                    transpileOptionValue: void 0
                },
                {
                    name: "allowSyntheticDefaultImports",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Interop_Constraints,
                    description: Diagnostics.Allow_import_x_from_y_when_a_module_doesn_t_have_a_default_export,
                    defaultValueDescription: Diagnostics.module_system_or_esModuleInterop
                },
                {
                    name: "esModuleInterop",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    showInSimplifiedHelpView: true,
                    category: Diagnostics.Interop_Constraints,
                    description: Diagnostics.Emit_additional_JavaScript_to_ease_support_for_importing_CommonJS_modules_This_enables_allowSyntheticDefaultImports_for_type_compatibility,
                    defaultValueDescription: false
                },
                {
                    name: "preserveSymlinks",
                    type: "boolean",
                    category: Diagnostics.Interop_Constraints,
                    description: Diagnostics.Disable_resolving_symlinks_to_their_realpath_This_correlates_to_the_same_flag_in_node,
                    defaultValueDescription: false
                },
                {
                    name: "allowUmdGlobalAccess",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Allow_accessing_UMD_globals_from_modules,
                    defaultValueDescription: false
                },
                {
                    name: "moduleSuffixes",
                    type: "list",
                    element: {
                        name: "suffix",
                        type: "string"
                    },
                    listPreserveFalsyValues: true,
                    affectsModuleResolution: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.List_of_file_name_suffixes_to_search_when_resolving_a_module
                },
                {
                    name: "allowImportingTsExtensions",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Allow_imports_to_include_TypeScript_file_extensions_Requires_moduleResolution_bundler_and_either_noEmit_or_emitDeclarationOnly_to_be_set,
                    defaultValueDescription: false,
                    transpileOptionValue: void 0
                },
                {
                    name: "resolvePackageJsonExports",
                    type: "boolean",
                    affectsModuleResolution: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Use_the_package_json_exports_field_when_resolving_package_imports,
                    defaultValueDescription: Diagnostics.true_when_moduleResolution_is_node16_nodenext_or_bundler_otherwise_false
                },
                {
                    name: "resolvePackageJsonImports",
                    type: "boolean",
                    affectsModuleResolution: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Use_the_package_json_imports_field_when_resolving_imports,
                    defaultValueDescription: Diagnostics.true_when_moduleResolution_is_node16_nodenext_or_bundler_otherwise_false
                },
                {
                    name: "customConditions",
                    type: "list",
                    element: {
                        name: "condition",
                        type: "string"
                    },
                    affectsModuleResolution: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Conditions_to_set_in_addition_to_the_resolver_specific_defaults_when_resolving_imports
                },
                // Source Maps
                {
                    name: "sourceRoot",
                    type: "string",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    paramType: Diagnostics.LOCATION,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Specify_the_root_path_for_debuggers_to_find_the_reference_source_code
                },
                {
                    name: "mapRoot",
                    type: "string",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    paramType: Diagnostics.LOCATION,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations
                },
                {
                    name: "inlineSources",
                    type: "boolean",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Include_source_code_in_the_sourcemaps_inside_the_emitted_JavaScript,
                    defaultValueDescription: false
                },
                // Experimental
                {
                    name: "experimentalDecorators",
                    type: "boolean",
                    affectsEmit: true,
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Language_and_Environment,
                    description: Diagnostics.Enable_experimental_support_for_legacy_experimental_decorators,
                    defaultValueDescription: false
                },
                {
                    name: "emitDecoratorMetadata",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Language_and_Environment,
                    description: Diagnostics.Emit_design_type_metadata_for_decorated_declarations_in_source_files,
                    defaultValueDescription: false
                },
                // Advanced
                {
                    name: "jsxFactory",
                    type: "string",
                    category: Diagnostics.Language_and_Environment,
                    description: Diagnostics.Specify_the_JSX_factory_function_used_when_targeting_React_JSX_emit_e_g_React_createElement_or_h,
                    defaultValueDescription: "`React.createElement`"
                },
                {
                    name: "jsxFragmentFactory",
                    type: "string",
                    category: Diagnostics.Language_and_Environment,
                    description: Diagnostics.Specify_the_JSX_Fragment_reference_used_for_fragments_when_targeting_React_JSX_emit_e_g_React_Fragment_or_Fragment,
                    defaultValueDescription: "React.Fragment"
                },
                {
                    name: "jsxImportSource",
                    type: "string",
                    affectsSemanticDiagnostics: true,
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    affectsModuleResolution: true,
                    category: Diagnostics.Language_and_Environment,
                    description: Diagnostics.Specify_module_specifier_used_to_import_the_JSX_factory_functions_when_using_jsx_Colon_react_jsx_Asterisk,
                    defaultValueDescription: "react"
                },
                {
                    name: "resolveJsonModule",
                    type: "boolean",
                    affectsModuleResolution: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Enable_importing_json_files,
                    defaultValueDescription: false
                },
                {
                    name: "allowArbitraryExtensions",
                    type: "boolean",
                    affectsProgramStructure: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Enable_importing_files_with_any_extension_provided_a_declaration_file_is_present,
                    defaultValueDescription: false
                },
                {
                    name: "out",
                    type: "string",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    affectsDeclarationPath: true,
                    isFilePath: false,
                    // This is intentionally broken to support compatability with existing tsconfig files
                    // for correct behaviour, please use outFile
                    category: Diagnostics.Backwards_Compatibility,
                    paramType: Diagnostics.FILE,
                    transpileOptionValue: void 0,
                    description: Diagnostics.Deprecated_setting_Use_outFile_instead
                },
                {
                    name: "reactNamespace",
                    type: "string",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Language_and_Environment,
                    description: Diagnostics.Specify_the_object_invoked_for_createElement_This_only_applies_when_targeting_react_JSX_emit,
                    defaultValueDescription: "`React`"
                },
                {
                    name: "skipDefaultLibCheck",
                    type: "boolean",
                    // We need to store these to determine whether `lib` files need to be rechecked
                    affectsBuildInfo: true,
                    category: Diagnostics.Completeness,
                    description: Diagnostics.Skip_type_checking_d_ts_files_that_are_included_with_TypeScript,
                    defaultValueDescription: false
                },
                {
                    name: "charset",
                    type: "string",
                    category: Diagnostics.Backwards_Compatibility,
                    description: Diagnostics.No_longer_supported_In_early_versions_manually_set_the_text_encoding_for_reading_files,
                    defaultValueDescription: "utf8"
                },
                {
                    name: "emitBOM",
                    type: "boolean",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files,
                    defaultValueDescription: false
                },
                {
                    name: "newLine",
                    type: new Map(Object.entries({
                        crlf: 0 /* CarriageReturnLineFeed */ ,
                        lf: 1 /* LineFeed */ 
                    })),
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    paramType: Diagnostics.NEWLINE,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Set_the_newline_character_for_emitting_files,
                    defaultValueDescription: "lf"
                },
                {
                    name: "noErrorTruncation",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Output_Formatting,
                    description: Diagnostics.Disable_truncating_types_in_error_messages,
                    defaultValueDescription: false
                },
                {
                    name: "noLib",
                    type: "boolean",
                    category: Diagnostics.Language_and_Environment,
                    affectsProgramStructure: true,
                    description: Diagnostics.Disable_including_any_library_files_including_the_default_lib_d_ts,
                    // We are not returning a sourceFile for lib file when asked by the program,
                    // so pass --noLib to avoid reporting a file not found error.
                    transpileOptionValue: true,
                    defaultValueDescription: false
                },
                {
                    name: "noResolve",
                    type: "boolean",
                    affectsModuleResolution: true,
                    category: Diagnostics.Modules,
                    description: Diagnostics.Disallow_import_s_require_s_or_reference_s_from_expanding_the_number_of_files_TypeScript_should_add_to_a_project,
                    // We are not doing a full typecheck, we are not resolving the whole context,
                    // so pass --noResolve to avoid reporting missing file errors.
                    transpileOptionValue: true,
                    defaultValueDescription: false
                },
                {
                    name: "stripInternal",
                    type: "boolean",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Disable_emitting_declarations_that_have_internal_in_their_JSDoc_comments,
                    defaultValueDescription: false
                },
                {
                    name: "disableSizeLimit",
                    type: "boolean",
                    affectsProgramStructure: true,
                    category: Diagnostics.Editor_Support,
                    description: Diagnostics.Remove_the_20mb_cap_on_total_source_code_size_for_JavaScript_files_in_the_TypeScript_language_server,
                    defaultValueDescription: false
                },
                {
                    name: "disableSourceOfProjectReferenceRedirect",
                    type: "boolean",
                    isTSConfigOnly: true,
                    category: Diagnostics.Projects,
                    description: Diagnostics.Disable_preferring_source_files_instead_of_declaration_files_when_referencing_composite_projects,
                    defaultValueDescription: false
                },
                {
                    name: "disableSolutionSearching",
                    type: "boolean",
                    isTSConfigOnly: true,
                    category: Diagnostics.Projects,
                    description: Diagnostics.Opt_a_project_out_of_multi_project_reference_checking_when_editing,
                    defaultValueDescription: false
                },
                {
                    name: "disableReferencedProjectLoad",
                    type: "boolean",
                    isTSConfigOnly: true,
                    category: Diagnostics.Projects,
                    description: Diagnostics.Reduce_the_number_of_projects_loaded_automatically_by_TypeScript,
                    defaultValueDescription: false
                },
                {
                    name: "noImplicitUseStrict",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Backwards_Compatibility,
                    description: Diagnostics.Disable_adding_use_strict_directives_in_emitted_JavaScript_files,
                    defaultValueDescription: false
                },
                {
                    name: "noEmitHelpers",
                    type: "boolean",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Disable_generating_custom_helper_functions_like_extends_in_compiled_output,
                    defaultValueDescription: false
                },
                {
                    name: "noEmitOnError",
                    type: "boolean",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Emit,
                    transpileOptionValue: void 0,
                    description: Diagnostics.Disable_emitting_files_if_any_type_checking_errors_are_reported,
                    defaultValueDescription: false
                },
                {
                    name: "preserveConstEnums",
                    type: "boolean",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Disable_erasing_const_enum_declarations_in_generated_code,
                    defaultValueDescription: false
                },
                {
                    name: "declarationDir",
                    type: "string",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    affectsDeclarationPath: true,
                    isFilePath: true,
                    paramType: Diagnostics.DIRECTORY,
                    category: Diagnostics.Emit,
                    transpileOptionValue: void 0,
                    description: Diagnostics.Specify_the_output_directory_for_generated_declaration_files
                },
                {
                    name: "skipLibCheck",
                    type: "boolean",
                    // We need to store these to determine whether `lib` files need to be rechecked
                    affectsBuildInfo: true,
                    category: Diagnostics.Completeness,
                    description: Diagnostics.Skip_type_checking_all_d_ts_files,
                    defaultValueDescription: false
                },
                {
                    name: "allowUnusedLabels",
                    type: "boolean",
                    affectsBindDiagnostics: true,
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Disable_error_reporting_for_unused_labels,
                    defaultValueDescription: void 0
                },
                {
                    name: "allowUnreachableCode",
                    type: "boolean",
                    affectsBindDiagnostics: true,
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Type_Checking,
                    description: Diagnostics.Disable_error_reporting_for_unreachable_code,
                    defaultValueDescription: void 0
                },
                {
                    name: "suppressExcessPropertyErrors",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Backwards_Compatibility,
                    description: Diagnostics.Disable_reporting_of_excess_property_errors_during_the_creation_of_object_literals,
                    defaultValueDescription: false
                },
                {
                    name: "suppressImplicitAnyIndexErrors",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Backwards_Compatibility,
                    description: Diagnostics.Suppress_noImplicitAny_errors_when_indexing_objects_that_lack_index_signatures,
                    defaultValueDescription: false
                },
                {
                    name: "forceConsistentCasingInFileNames",
                    type: "boolean",
                    affectsModuleResolution: true,
                    category: Diagnostics.Interop_Constraints,
                    description: Diagnostics.Ensure_that_casing_is_correct_in_imports,
                    defaultValueDescription: true
                },
                {
                    name: "maxNodeModuleJsDepth",
                    type: "number",
                    affectsModuleResolution: true,
                    category: Diagnostics.JavaScript_Support,
                    description: Diagnostics.Specify_the_maximum_folder_depth_used_for_checking_JavaScript_files_from_node_modules_Only_applicable_with_allowJs,
                    defaultValueDescription: 0
                },
                {
                    name: "noStrictGenericChecks",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Backwards_Compatibility,
                    description: Diagnostics.Disable_strict_checking_of_generic_signatures_in_function_types,
                    defaultValueDescription: false
                },
                {
                    name: "useDefineForClassFields",
                    type: "boolean",
                    affectsSemanticDiagnostics: true,
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Language_and_Environment,
                    description: Diagnostics.Emit_ECMAScript_standard_compliant_class_fields,
                    defaultValueDescription: Diagnostics.true_for_ES2022_and_above_including_ESNext
                },
                {
                    name: "preserveValueImports",
                    type: "boolean",
                    affectsEmit: true,
                    affectsBuildInfo: true,
                    category: Diagnostics.Emit,
                    description: Diagnostics.Preserve_unused_imported_values_in_the_JavaScript_output_that_would_otherwise_be_removed,
                    defaultValueDescription: false
                },
                {
                    name: "keyofStringsOnly",
                    type: "boolean",
                    category: Diagnostics.Backwards_Compatibility,
                    description: Diagnostics.Make_keyof_only_return_strings_instead_of_string_numbers_or_symbols_Legacy_option,
                    defaultValueDescription: false
                },
                {
                    // A list of plugins to load in the language service
                    name: "plugins",
                    type: "list",
                    isTSConfigOnly: true,
                    element: {
                        name: "plugin",
                        type: "object"
                    },
                    description: Diagnostics.Specify_a_list_of_language_service_plugins_to_include,
                    category: Diagnostics.Editor_Support
                },
                {
                    name: "moduleDetection",
                    type: new Map(Object.entries({
                        auto: 2 /* Auto */ ,
                        legacy: 1 /* Legacy */ ,
                        force: 3 /* Force */ 
                    })),
                    affectsModuleResolution: true,
                    description: Diagnostics.Control_what_method_is_used_to_detect_module_format_JS_files,
                    category: Diagnostics.Language_and_Environment,
                    defaultValueDescription: Diagnostics.auto_Colon_Treat_files_with_imports_exports_import_meta_jsx_with_jsx_Colon_react_jsx_or_esm_format_with_module_Colon_node16_as_modules
                },
                {
                    name: "ignoreDeprecations",
                    type: "string",
                    defaultValueDescription: void 0
                }
            ];
            optionDeclarations = [
                ...commonOptionsWithBuild,
                ...commandOptionsWithoutBuild
            ];
            semanticDiagnosticsOptionDeclarations = optionDeclarations.filter((option)=>!!option.affectsSemanticDiagnostics);
            affectsEmitOptionDeclarations = optionDeclarations.filter((option)=>!!option.affectsEmit);
            affectsDeclarationPathOptionDeclarations = optionDeclarations.filter((option)=>!!option.affectsDeclarationPath);
            moduleResolutionOptionDeclarations = optionDeclarations.filter((option)=>!!option.affectsModuleResolution);
            sourceFileAffectingCompilerOptions = optionDeclarations.filter((option)=>!!option.affectsSourceFile || !!option.affectsModuleResolution || !!option.affectsBindDiagnostics);
            optionsAffectingProgramStructure = optionDeclarations.filter((option)=>!!option.affectsProgramStructure);
            transpileOptionValueCompilerOptions = optionDeclarations.filter((option)=>hasProperty(option, "transpileOptionValue"));
            optionsForBuild = [
                {
                    name: "verbose",
                    shortName: "v",
                    category: Diagnostics.Command_line_Options,
                    description: Diagnostics.Enable_verbose_logging,
                    type: "boolean",
                    defaultValueDescription: false
                },
                {
                    name: "dry",
                    shortName: "d",
                    category: Diagnostics.Command_line_Options,
                    description: Diagnostics.Show_what_would_be_built_or_deleted_if_specified_with_clean,
                    type: "boolean",
                    defaultValueDescription: false
                },
                {
                    name: "force",
                    shortName: "f",
                    category: Diagnostics.Command_line_Options,
                    description: Diagnostics.Build_all_projects_including_those_that_appear_to_be_up_to_date,
                    type: "boolean",
                    defaultValueDescription: false
                },
                {
                    name: "clean",
                    category: Diagnostics.Command_line_Options,
                    description: Diagnostics.Delete_the_outputs_of_all_projects,
                    type: "boolean",
                    defaultValueDescription: false
                }
            ];
            buildOpts = [
                ...commonOptionsWithBuild,
                ...optionsForBuild
            ];
            typeAcquisitionDeclarations = [
                {
                    name: "enable",
                    type: "boolean",
                    defaultValueDescription: false
                },
                {
                    name: "include",
                    type: "list",
                    element: {
                        name: "include",
                        type: "string"
                    }
                },
                {
                    name: "exclude",
                    type: "list",
                    element: {
                        name: "exclude",
                        type: "string"
                    }
                },
                {
                    name: "disableFilenameBasedTypeAcquisition",
                    type: "boolean",
                    defaultValueDescription: false
                }
            ];
            compilerOptionsAlternateMode = {
                diagnostic: Diagnostics.Compiler_option_0_may_only_be_used_with_build,
                getOptionsNameMap: getBuildOptionsNameMap
            };
            defaultInitCompilerOptions = {
                module: 1 /* CommonJS */ ,
                target: 3 /* ES2016 */ ,
                strict: true,
                esModuleInterop: true,
                forceConsistentCasingInFileNames: true,
                skipLibCheck: true
            };
            compilerOptionsDidYouMeanDiagnostics = {
                alternateMode: compilerOptionsAlternateMode,
                getOptionsNameMap: getOptionsNameMap,
                optionDeclarations: optionDeclarations,
                unknownOptionDiagnostic: Diagnostics.Unknown_compiler_option_0,
                unknownDidYouMeanDiagnostic: Diagnostics.Unknown_compiler_option_0_Did_you_mean_1,
                optionTypeMismatchDiagnostic: Diagnostics.Compiler_option_0_expects_an_argument
            };
            buildOptionsAlternateMode = {
                diagnostic: Diagnostics.Compiler_option_0_may_not_be_used_with_build,
                getOptionsNameMap: getOptionsNameMap
            };
            buildOptionsDidYouMeanDiagnostics = {
                alternateMode: buildOptionsAlternateMode,
                getOptionsNameMap: getBuildOptionsNameMap,
                optionDeclarations: buildOpts,
                unknownOptionDiagnostic: Diagnostics.Unknown_build_option_0,
                unknownDidYouMeanDiagnostic: Diagnostics.Unknown_build_option_0_Did_you_mean_1,
                optionTypeMismatchDiagnostic: Diagnostics.Build_option_0_requires_a_value_of_type_1
            };
            typeAcquisitionDidYouMeanDiagnostics = {
                optionDeclarations: typeAcquisitionDeclarations,
                unknownOptionDiagnostic: Diagnostics.Unknown_type_acquisition_option_0,
                unknownDidYouMeanDiagnostic: Diagnostics.Unknown_type_acquisition_option_0_Did_you_mean_1
            };
            watchOptionsDidYouMeanDiagnostics = {
                getOptionsNameMap: getWatchOptionsNameMap,
                optionDeclarations: optionsForWatch,
                unknownOptionDiagnostic: Diagnostics.Unknown_watch_option_0,
                unknownDidYouMeanDiagnostic: Diagnostics.Unknown_watch_option_0_Did_you_mean_1,
                optionTypeMismatchDiagnostic: Diagnostics.Watch_option_0_requires_a_value_of_type_1
            };
            extendsOptionDeclaration = {
                name: "extends",
                type: "listOrElement",
                element: {
                    name: "extends",
                    type: "string"
                },
                category: Diagnostics.File_Management,
                disallowNullOrUndefined: true
            };
            compilerOptionsDeclaration = {
                name: "compilerOptions",
                type: "object",
                elementOptions: getCommandLineCompilerOptionsMap(),
                extraKeyDiagnostics: compilerOptionsDidYouMeanDiagnostics
            };
            watchOptionsDeclaration = {
                name: "watchOptions",
                type: "object",
                elementOptions: getCommandLineWatchOptionsMap(),
                extraKeyDiagnostics: watchOptionsDidYouMeanDiagnostics
            };
            typeAcquisitionDeclaration = {
                name: "typeAcquisition",
                type: "object",
                elementOptions: getCommandLineTypeAcquisitionMap(),
                extraKeyDiagnostics: typeAcquisitionDidYouMeanDiagnostics
            };
            defaultIncludeSpec = "**/*";
            invalidTrailingRecursionPattern = /(^|\/)\*\*\/?$/;
            wildcardDirectoryPattern = /^[^*?]*(?=\/[^/]*[*?])/;
        }
    });
    // src/compiler/moduleNameResolver.ts
    function trace(host) {
        host.trace(formatMessage.apply(void 0, arguments));
    }
    function isTraceEnabled(compilerOptions, host) {
        return !!compilerOptions.traceResolution && host.trace !== void 0;
    }
    function withPackageId(packageInfo, r) {
        let packageId;
        if (r && packageInfo) {
            const packageJsonContent = packageInfo.contents.packageJsonContent;
            if (typeof packageJsonContent.name === "string" && typeof packageJsonContent.version === "string") packageId = {
                name: packageJsonContent.name,
                subModuleName: r.path.slice(packageInfo.packageDirectory.length + directorySeparator.length),
                version: packageJsonContent.version
            };
        }
        return r && {
            path: r.path,
            extension: r.ext,
            packageId: packageId,
            resolvedUsingTsExtension: r.resolvedUsingTsExtension
        };
    }
    function noPackageId(r) {
        return withPackageId(/*packageInfo*/ void 0, r);
    }
    function removeIgnoredPackageId(r) {
        if (r) {
            Debug.assert(r.packageId === void 0);
            return {
                path: r.path,
                ext: r.extension,
                resolvedUsingTsExtension: r.resolvedUsingTsExtension
            };
        }
    }
    function formatExtensions(extensions) {
        const result = [];
        if (extensions & 1 /* TypeScript */ ) result.push("TypeScript");
        if (extensions & 2 /* JavaScript */ ) result.push("JavaScript");
        if (extensions & 4 /* Declaration */ ) result.push("Declaration");
        if (extensions & 8 /* Json */ ) result.push("JSON");
        return result.join(", ");
    }
    function resolvedTypeScriptOnly(resolved) {
        if (!resolved) return void 0;
        Debug.assert(extensionIsTS(resolved.extension));
        return {
            fileName: resolved.path,
            packageId: resolved.packageId
        };
    }
    function createResolvedModuleWithFailedLookupLocationsHandlingSymlink(moduleName, resolved, isExternalLibraryImport, failedLookupLocations, affectingLocations, diagnostics, state, legacyResult) {
        if (!state.resultFromCache && !state.compilerOptions.preserveSymlinks && resolved && isExternalLibraryImport && !resolved.originalPath && !isExternalModuleNameRelative(moduleName)) {
            const { resolvedFileName: resolvedFileName , originalPath: originalPath  } = getOriginalAndResolvedFileName(resolved.path, state.host, state.traceEnabled);
            if (originalPath) resolved = {
                ...resolved,
                path: resolvedFileName,
                originalPath: originalPath
            };
        }
        return createResolvedModuleWithFailedLookupLocations(resolved, isExternalLibraryImport, failedLookupLocations, affectingLocations, diagnostics, state.resultFromCache, legacyResult);
    }
    function createResolvedModuleWithFailedLookupLocations(resolved, isExternalLibraryImport, failedLookupLocations, affectingLocations, diagnostics, resultFromCache, legacyResult) {
        if (resultFromCache) {
            resultFromCache.failedLookupLocations = updateResolutionField(resultFromCache.failedLookupLocations, failedLookupLocations);
            resultFromCache.affectingLocations = updateResolutionField(resultFromCache.affectingLocations, affectingLocations);
            resultFromCache.resolutionDiagnostics = updateResolutionField(resultFromCache.resolutionDiagnostics, diagnostics);
            return resultFromCache;
        }
        return {
            resolvedModule: resolved && {
                resolvedFileName: resolved.path,
                originalPath: resolved.originalPath === true ? void 0 : resolved.originalPath,
                extension: resolved.extension,
                isExternalLibraryImport: isExternalLibraryImport,
                packageId: resolved.packageId,
                resolvedUsingTsExtension: !!resolved.resolvedUsingTsExtension
            },
            failedLookupLocations: initializeResolutionField(failedLookupLocations),
            affectingLocations: initializeResolutionField(affectingLocations),
            resolutionDiagnostics: initializeResolutionField(diagnostics),
            node10Result: legacyResult
        };
    }
    function initializeResolutionField(value1) {
        return value1.length ? value1 : void 0;
    }
    function updateResolutionField(to, value1) {
        if (!(value1 == null ? void 0 : value1.length)) return to;
        if (!(to == null ? void 0 : to.length)) return value1;
        to.push(...value1);
        return to;
    }
    function readPackageJsonField(jsonContent, fieldName, typeOfTag, state) {
        if (!hasProperty(jsonContent, fieldName)) {
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_does_not_have_a_0_field, fieldName);
            return;
        }
        const value1 = jsonContent[fieldName];
        if (typeof value1 !== typeOfTag || value1 === null) {
            if (state.traceEnabled) trace(state.host, Diagnostics.Expected_type_of_0_field_in_package_json_to_be_1_got_2, fieldName, typeOfTag, value1 === null ? "null" : typeof value1);
            return;
        }
        return value1;
    }
    function readPackageJsonPathField(jsonContent, fieldName, baseDirectory, state) {
        const fileName = readPackageJsonField(jsonContent, fieldName, "string", state);
        if (fileName === void 0) return;
        if (!fileName) {
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_had_a_falsy_0_field, fieldName);
            return;
        }
        const path = normalizePath(combinePaths(baseDirectory, fileName));
        if (state.traceEnabled) trace(state.host, Diagnostics.package_json_has_0_field_1_that_references_2, fieldName, fileName, path);
        return path;
    }
    function readPackageJsonTypesFields(jsonContent, baseDirectory, state) {
        return readPackageJsonPathField(jsonContent, "typings", baseDirectory, state) || readPackageJsonPathField(jsonContent, "types", baseDirectory, state);
    }
    function readPackageJsonTSConfigField(jsonContent, baseDirectory, state) {
        return readPackageJsonPathField(jsonContent, "tsconfig", baseDirectory, state);
    }
    function readPackageJsonMainField(jsonContent, baseDirectory, state) {
        return readPackageJsonPathField(jsonContent, "main", baseDirectory, state);
    }
    function readPackageJsonTypesVersionsField(jsonContent, state) {
        const typesVersions = readPackageJsonField(jsonContent, "typesVersions", "object", state);
        if (typesVersions === void 0) return;
        if (state.traceEnabled) trace(state.host, Diagnostics.package_json_has_a_typesVersions_field_with_version_specific_path_mappings);
        return typesVersions;
    }
    function readPackageJsonTypesVersionPaths(jsonContent, state) {
        const typesVersions = readPackageJsonTypesVersionsField(jsonContent, state);
        if (typesVersions === void 0) return;
        if (state.traceEnabled) {
            for(const key in typesVersions)if (hasProperty(typesVersions, key) && !VersionRange.tryParse(key)) trace(state.host, Diagnostics.package_json_has_a_typesVersions_entry_0_that_is_not_a_valid_semver_range, key);
        }
        const result = getPackageJsonTypesVersionsPaths(typesVersions);
        if (!result) {
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_does_not_have_a_typesVersions_entry_that_matches_version_0, versionMajorMinor);
            return;
        }
        const { version: bestVersionKey , paths: bestVersionPaths  } = result;
        if (typeof bestVersionPaths !== "object") {
            if (state.traceEnabled) trace(state.host, Diagnostics.Expected_type_of_0_field_in_package_json_to_be_1_got_2, `typesVersions['${bestVersionKey}']`, "object", typeof bestVersionPaths);
            return;
        }
        return result;
    }
    function getPackageJsonTypesVersionsPaths(typesVersions) {
        if (!typeScriptVersion) typeScriptVersion = new Version(version);
        for(const key in typesVersions){
            if (!hasProperty(typesVersions, key)) continue;
            const keyRange = VersionRange.tryParse(key);
            if (keyRange === void 0) continue;
            if (keyRange.test(typeScriptVersion)) return {
                version: key,
                paths: typesVersions[key]
            };
        }
    }
    function getEffectiveTypeRoots(options, host) {
        if (options.typeRoots) return options.typeRoots;
        let currentDirectory;
        if (options.configFilePath) currentDirectory = getDirectoryPath(options.configFilePath);
        else if (host.getCurrentDirectory) currentDirectory = host.getCurrentDirectory();
        if (currentDirectory !== void 0) return getDefaultTypeRoots(currentDirectory);
    }
    function getDefaultTypeRoots(currentDirectory) {
        let typeRoots;
        forEachAncestorDirectory(normalizePath(currentDirectory), (directory)=>{
            const atTypes = combinePaths(directory, nodeModulesAtTypes);
            (typeRoots ?? (typeRoots = [])).push(atTypes);
        });
        return typeRoots;
    }
    function arePathsEqual(path1, path2, host) {
        const useCaseSensitiveFileNames = typeof host.useCaseSensitiveFileNames === "function" ? host.useCaseSensitiveFileNames() : host.useCaseSensitiveFileNames;
        return comparePaths(path1, path2, !useCaseSensitiveFileNames) === 0 /* EqualTo */ ;
    }
    function getOriginalAndResolvedFileName(fileName, host, traceEnabled) {
        const resolvedFileName = realPath(fileName, host, traceEnabled);
        const pathsAreEqual = arePathsEqual(fileName, resolvedFileName, host);
        return {
            // If the fileName and realpath are differing only in casing prefer fileName so that we can issue correct errors for casing under forceConsistentCasingInFileNames
            resolvedFileName: pathsAreEqual ? fileName : resolvedFileName,
            originalPath: pathsAreEqual ? void 0 : fileName
        };
    }
    function getCandidateFromTypeRoot(typeRoot, typeReferenceDirectiveName, moduleResolutionState) {
        const nameForLookup = endsWith(typeRoot, "/node_modules/@types") || endsWith(typeRoot, "/node_modules/@types/") ? mangleScopedPackageNameWithTrace(typeReferenceDirectiveName, moduleResolutionState) : typeReferenceDirectiveName;
        return combinePaths(typeRoot, nameForLookup);
    }
    function resolveTypeReferenceDirective(typeReferenceDirectiveName, containingFile, options, host, redirectedReference, cache, resolutionMode) {
        Debug.assert(typeof typeReferenceDirectiveName === "string", "Non-string value passed to `ts.resolveTypeReferenceDirective`, likely by a wrapping package working with an outdated `resolveTypeReferenceDirectives` signature. This is probably not a problem in TS itself.");
        const traceEnabled = isTraceEnabled(options, host);
        if (redirectedReference) options = redirectedReference.commandLine.options;
        const containingDirectory = containingFile ? getDirectoryPath(containingFile) : void 0;
        let result = containingDirectory ? cache == null ? void 0 : cache.getFromDirectoryCache(typeReferenceDirectiveName, resolutionMode, containingDirectory, redirectedReference) : void 0;
        if (!result && containingDirectory && !isExternalModuleNameRelative(typeReferenceDirectiveName)) result = cache == null ? void 0 : cache.getFromNonRelativeNameCache(typeReferenceDirectiveName, resolutionMode, containingDirectory, redirectedReference);
        if (result) {
            if (traceEnabled) {
                trace(host, Diagnostics.Resolving_type_reference_directive_0_containing_file_1, typeReferenceDirectiveName, containingFile);
                if (redirectedReference) trace(host, Diagnostics.Using_compiler_options_of_project_reference_redirect_0, redirectedReference.sourceFile.fileName);
                trace(host, Diagnostics.Resolution_for_type_reference_directive_0_was_found_in_cache_from_location_1, typeReferenceDirectiveName, containingDirectory);
                traceResult(result);
            }
            return result;
        }
        const typeRoots = getEffectiveTypeRoots(options, host);
        if (traceEnabled) {
            if (containingFile === void 0) {
                if (typeRoots === void 0) trace(host, Diagnostics.Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set, typeReferenceDirectiveName);
                else trace(host, Diagnostics.Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1, typeReferenceDirectiveName, typeRoots);
            } else if (typeRoots === void 0) trace(host, Diagnostics.Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set, typeReferenceDirectiveName, containingFile);
            else trace(host, Diagnostics.Resolving_type_reference_directive_0_containing_file_1_root_directory_2, typeReferenceDirectiveName, containingFile, typeRoots);
            if (redirectedReference) trace(host, Diagnostics.Using_compiler_options_of_project_reference_redirect_0, redirectedReference.sourceFile.fileName);
        }
        const failedLookupLocations = [];
        const affectingLocations = [];
        let features = getNodeResolutionFeatures(options);
        if (resolutionMode === 99 /* ESNext */  && (getEmitModuleResolutionKind(options) === 3 /* Node16 */  || getEmitModuleResolutionKind(options) === 99 /* NodeNext */ )) features |= 32 /* EsmMode */ ;
        const conditions = features & 8 /* Exports */  ? getConditions(options, !!(features & 32 /* EsmMode */ )) : [];
        const diagnostics = [];
        const moduleResolutionState = {
            compilerOptions: options,
            host: host,
            traceEnabled: traceEnabled,
            failedLookupLocations: failedLookupLocations,
            affectingLocations: affectingLocations,
            packageJsonInfoCache: cache,
            features: features,
            conditions: conditions,
            requestContainingDirectory: containingDirectory,
            reportDiagnostic: (diag2)=>void diagnostics.push(diag2),
            isConfigLookup: false,
            candidateIsFromPackageJsonField: false
        };
        let resolved = primaryLookup();
        let primary = true;
        if (!resolved) {
            resolved = secondaryLookup();
            primary = false;
        }
        let resolvedTypeReferenceDirective;
        if (resolved) {
            const { fileName: fileName , packageId: packageId  } = resolved;
            let resolvedFileName = fileName, originalPath;
            if (!options.preserveSymlinks) ({ resolvedFileName: resolvedFileName , originalPath: originalPath  } = getOriginalAndResolvedFileName(fileName, host, traceEnabled));
            resolvedTypeReferenceDirective = {
                primary: primary,
                resolvedFileName: resolvedFileName,
                originalPath: originalPath,
                packageId: packageId,
                isExternalLibraryImport: pathContainsNodeModules(fileName)
            };
        }
        result = {
            resolvedTypeReferenceDirective: resolvedTypeReferenceDirective,
            failedLookupLocations: initializeResolutionField(failedLookupLocations),
            affectingLocations: initializeResolutionField(affectingLocations),
            resolutionDiagnostics: initializeResolutionField(diagnostics)
        };
        if (containingDirectory) {
            cache == null || cache.getOrCreateCacheForDirectory(containingDirectory, redirectedReference).set(typeReferenceDirectiveName, /*mode*/ resolutionMode, result);
            if (!isExternalModuleNameRelative(typeReferenceDirectiveName)) cache == null || cache.getOrCreateCacheForNonRelativeName(typeReferenceDirectiveName, resolutionMode, redirectedReference).set(containingDirectory, result);
        }
        if (traceEnabled) traceResult(result);
        return result;
        function traceResult(result2) {
            var _a;
            if (!((_a = result2.resolvedTypeReferenceDirective) == null ? void 0 : _a.resolvedFileName)) trace(host, Diagnostics.Type_reference_directive_0_was_not_resolved, typeReferenceDirectiveName);
            else if (result2.resolvedTypeReferenceDirective.packageId) trace(host, Diagnostics.Type_reference_directive_0_was_successfully_resolved_to_1_with_Package_ID_2_primary_Colon_3, typeReferenceDirectiveName, result2.resolvedTypeReferenceDirective.resolvedFileName, packageIdToString(result2.resolvedTypeReferenceDirective.packageId), result2.resolvedTypeReferenceDirective.primary);
            else trace(host, Diagnostics.Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2, typeReferenceDirectiveName, result2.resolvedTypeReferenceDirective.resolvedFileName, result2.resolvedTypeReferenceDirective.primary);
        }
        function primaryLookup() {
            if (typeRoots && typeRoots.length) {
                if (traceEnabled) trace(host, Diagnostics.Resolving_with_primary_search_path_0, typeRoots.join(", "));
                return firstDefined(typeRoots, (typeRoot)=>{
                    const candidate = getCandidateFromTypeRoot(typeRoot, typeReferenceDirectiveName, moduleResolutionState);
                    const directoryExists = directoryProbablyExists(typeRoot, host);
                    if (!directoryExists && traceEnabled) trace(host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, typeRoot);
                    if (options.typeRoots) {
                        const resolvedFromFile = loadModuleFromFile(4 /* Declaration */ , candidate, !directoryExists, moduleResolutionState);
                        if (resolvedFromFile) {
                            const packageDirectory = parseNodeModuleFromPath(resolvedFromFile.path);
                            const packageInfo = packageDirectory ? getPackageJsonInfo(packageDirectory, /*onlyRecordFailures*/ false, moduleResolutionState) : void 0;
                            return resolvedTypeScriptOnly(withPackageId(packageInfo, resolvedFromFile));
                        }
                    }
                    return resolvedTypeScriptOnly(loadNodeModuleFromDirectory(4 /* Declaration */ , candidate, !directoryExists, moduleResolutionState));
                });
            } else if (traceEnabled) trace(host, Diagnostics.Root_directory_cannot_be_determined_skipping_primary_search_paths);
        }
        function secondaryLookup() {
            const initialLocationForSecondaryLookup = containingFile && getDirectoryPath(containingFile);
            if (initialLocationForSecondaryLookup !== void 0) {
                let result2;
                if (!options.typeRoots || !endsWith(containingFile, inferredTypesContainingFile)) {
                    if (traceEnabled) trace(host, Diagnostics.Looking_up_in_node_modules_folder_initial_location_0, initialLocationForSecondaryLookup);
                    if (!isExternalModuleNameRelative(typeReferenceDirectiveName)) {
                        const searchResult = loadModuleFromNearestNodeModulesDirectory(4 /* Declaration */ , typeReferenceDirectiveName, initialLocationForSecondaryLookup, moduleResolutionState, /*cache*/ void 0, /*redirectedReference*/ void 0);
                        result2 = searchResult && searchResult.value;
                    } else {
                        const { path: candidate  } = normalizePathForCJSResolution(initialLocationForSecondaryLookup, typeReferenceDirectiveName);
                        result2 = nodeLoadModuleByRelativeName(4 /* Declaration */ , candidate, /*onlyRecordFailures*/ false, moduleResolutionState, /*considerPackageJson*/ true);
                    }
                } else if (traceEnabled) trace(host, Diagnostics.Resolving_type_reference_directive_for_program_that_specifies_custom_typeRoots_skipping_lookup_in_node_modules_folder);
                return resolvedTypeScriptOnly(result2);
            } else if (traceEnabled) trace(host, Diagnostics.Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_modules_folder);
        }
    }
    function getNodeResolutionFeatures(options) {
        let features = 0 /* None */ ;
        switch(getEmitModuleResolutionKind(options)){
            case 3 /* Node16 */ :
                features = 30 /* Node16Default */ ;
                break;
            case 99 /* NodeNext */ :
                features = 30 /* NodeNextDefault */ ;
                break;
            case 100 /* Bundler */ :
                features = 30 /* BundlerDefault */ ;
                break;
        }
        if (options.resolvePackageJsonExports) features |= 8 /* Exports */ ;
        else if (options.resolvePackageJsonExports === false) features &= -9 /* Exports */ ;
        if (options.resolvePackageJsonImports) features |= 2 /* Imports */ ;
        else if (options.resolvePackageJsonImports === false) features &= -3 /* Imports */ ;
        return features;
    }
    function getConditions(options, esmMode) {
        const conditions = esmMode || getEmitModuleResolutionKind(options) === 100 /* Bundler */  ? [
            "import"
        ] : [
            "require"
        ];
        if (!options.noDtsResolution) conditions.push("types");
        if (getEmitModuleResolutionKind(options) !== 100 /* Bundler */ ) conditions.push("node");
        return concatenate(conditions, options.customConditions);
    }
    function resolvePackageNameToPackageJson(packageName, containingDirectory, options, host, cache) {
        const moduleResolutionState = getTemporaryModuleResolutionState(cache == null ? void 0 : cache.getPackageJsonInfoCache(), host, options);
        return forEachAncestorDirectory(containingDirectory, (ancestorDirectory)=>{
            if (getBaseFileName(ancestorDirectory) !== "node_modules") {
                const nodeModulesFolder = combinePaths(ancestorDirectory, "node_modules");
                const candidate = combinePaths(nodeModulesFolder, packageName);
                return getPackageJsonInfo(candidate, /*onlyRecordFailures*/ false, moduleResolutionState);
            }
        });
    }
    function getAutomaticTypeDirectiveNames(options, host) {
        if (options.types) return options.types;
        const result = [];
        if (host.directoryExists && host.getDirectories) {
            const typeRoots = getEffectiveTypeRoots(options, host);
            if (typeRoots) for (const root of typeRoots){
                if (host.directoryExists(root)) for (const typeDirectivePath of host.getDirectories(root)){
                    const normalized = normalizePath(typeDirectivePath);
                    const packageJsonPath = combinePaths(root, normalized, "package.json");
                    const isNotNeededPackage = host.fileExists(packageJsonPath) && readJson(packageJsonPath, host).typings === null;
                    if (!isNotNeededPackage) {
                        const baseFileName = getBaseFileName(normalized);
                        if (baseFileName.charCodeAt(0) !== 46 /* dot */ ) result.push(baseFileName);
                    }
                }
            }
        }
        return result;
    }
    function compilerOptionValueToString(value1) {
        var _a;
        if (value1 === null || typeof value1 !== "object") return "" + value1;
        if (isArray(value1)) return `[${(_a = value1.map((e)=>compilerOptionValueToString(e))) == null ? void 0 : _a.join(",")}]`;
        let str = "{";
        for(const key in value1)if (hasProperty(value1, key)) str += `${key}: ${compilerOptionValueToString(value1[key])}`;
        return str + "}";
    }
    function getKeyForCompilerOptions(options, affectingOptionDeclarations) {
        return affectingOptionDeclarations.map((option)=>compilerOptionValueToString(getCompilerOptionValue(options, option))).join("|") + (options.pathsBasePath ? `|${options.pathsBasePath}` : void 0);
    }
    function createCacheWithRedirects(ownOptions) {
        const redirectsMap = /* @__PURE__ */ new Map();
        const optionsToRedirectsKey = /* @__PURE__ */ new Map();
        const redirectsKeyToMap = /* @__PURE__ */ new Map();
        let ownMap = /* @__PURE__ */ new Map();
        if (ownOptions) redirectsMap.set(ownOptions, ownMap);
        return {
            getMapOfCacheRedirects: getMapOfCacheRedirects,
            getOrCreateMapOfCacheRedirects: getOrCreateMapOfCacheRedirects,
            update: update,
            clear: clear2
        };
        function getMapOfCacheRedirects(redirectedReference) {
            return redirectedReference ? getOrCreateMap(redirectedReference.commandLine.options, /*create*/ false) : ownMap;
        }
        function getOrCreateMapOfCacheRedirects(redirectedReference) {
            return redirectedReference ? getOrCreateMap(redirectedReference.commandLine.options, /*create*/ true) : ownMap;
        }
        function update(newOptions) {
            if (ownOptions !== newOptions) {
                if (ownOptions) ownMap = getOrCreateMap(newOptions, /*create*/ true);
                else redirectsMap.set(newOptions, ownMap);
                ownOptions = newOptions;
            }
        }
        function getOrCreateMap(redirectOptions, create) {
            let result = redirectsMap.get(redirectOptions);
            if (result) return result;
            const key = getRedirectsCacheKey(redirectOptions);
            result = redirectsKeyToMap.get(key);
            if (!result) {
                if (ownOptions) {
                    const ownKey = getRedirectsCacheKey(ownOptions);
                    if (ownKey === key) result = ownMap;
                    else if (!redirectsKeyToMap.has(ownKey)) redirectsKeyToMap.set(ownKey, ownMap);
                }
                if (create) result ?? (result = /* @__PURE__ */ new Map());
                if (result) redirectsKeyToMap.set(key, result);
            }
            if (result) redirectsMap.set(redirectOptions, result);
            return result;
        }
        function clear2() {
            const ownKey = ownOptions && optionsToRedirectsKey.get(ownOptions);
            ownMap.clear();
            redirectsMap.clear();
            optionsToRedirectsKey.clear();
            redirectsKeyToMap.clear();
            if (ownOptions) {
                if (ownKey) optionsToRedirectsKey.set(ownOptions, ownKey);
                redirectsMap.set(ownOptions, ownMap);
            }
        }
        function getRedirectsCacheKey(options) {
            let result = optionsToRedirectsKey.get(options);
            if (!result) optionsToRedirectsKey.set(options, result = getKeyForCompilerOptions(options, moduleResolutionOptionDeclarations));
            return result;
        }
    }
    function createPackageJsonInfoCache(currentDirectory, getCanonicalFileName) {
        let cache;
        return {
            getPackageJsonInfo: getPackageJsonInfo2,
            setPackageJsonInfo: setPackageJsonInfo,
            clear: clear2,
            entries: entries,
            getInternalMap: getInternalMap
        };
        function getPackageJsonInfo2(packageJsonPath) {
            return cache == null ? void 0 : cache.get(toPath(packageJsonPath, currentDirectory, getCanonicalFileName));
        }
        function setPackageJsonInfo(packageJsonPath, info) {
            (cache || (cache = /* @__PURE__ */ new Map())).set(toPath(packageJsonPath, currentDirectory, getCanonicalFileName), info);
        }
        function clear2() {
            cache = void 0;
        }
        function entries() {
            const iter = cache == null ? void 0 : cache.entries();
            return iter ? arrayFrom(iter) : [];
        }
        function getInternalMap() {
            return cache;
        }
    }
    function getOrCreateCache(cacheWithRedirects, redirectedReference, key, create) {
        const cache = cacheWithRedirects.getOrCreateMapOfCacheRedirects(redirectedReference);
        let result = cache.get(key);
        if (!result) {
            result = create();
            cache.set(key, result);
        }
        return result;
    }
    function createPerDirectoryResolutionCache(currentDirectory, getCanonicalFileName, options) {
        const directoryToModuleNameMap = createCacheWithRedirects(options);
        return {
            getFromDirectoryCache: getFromDirectoryCache,
            getOrCreateCacheForDirectory: getOrCreateCacheForDirectory,
            clear: clear2,
            update: update
        };
        function clear2() {
            directoryToModuleNameMap.clear();
        }
        function update(options2) {
            directoryToModuleNameMap.update(options2);
        }
        function getOrCreateCacheForDirectory(directoryName, redirectedReference) {
            const path = toPath(directoryName, currentDirectory, getCanonicalFileName);
            return getOrCreateCache(directoryToModuleNameMap, redirectedReference, path, ()=>createModeAwareCache());
        }
        function getFromDirectoryCache(name, mode, directoryName, redirectedReference) {
            var _a, _b;
            const path = toPath(directoryName, currentDirectory, getCanonicalFileName);
            return (_b = (_a = directoryToModuleNameMap.getMapOfCacheRedirects(redirectedReference)) == null ? void 0 : _a.get(path)) == null ? void 0 : _b.get(name, mode);
        }
    }
    function createModeAwareCacheKey(specifier, mode) {
        return mode === void 0 ? specifier : `${mode}|${specifier}`;
    }
    function createModeAwareCache() {
        const underlying = /* @__PURE__ */ new Map();
        const memoizedReverseKeys = /* @__PURE__ */ new Map();
        const cache = {
            get (specifier, mode) {
                return underlying.get(getUnderlyingCacheKey(specifier, mode));
            },
            set (specifier, mode, value1) {
                underlying.set(getUnderlyingCacheKey(specifier, mode), value1);
                return cache;
            },
            delete (specifier, mode) {
                underlying.delete(getUnderlyingCacheKey(specifier, mode));
                return cache;
            },
            has (specifier, mode) {
                return underlying.has(getUnderlyingCacheKey(specifier, mode));
            },
            forEach (cb) {
                return underlying.forEach((elem, key)=>{
                    const [specifier, mode] = memoizedReverseKeys.get(key);
                    return cb(elem, specifier, mode);
                });
            },
            size () {
                return underlying.size;
            }
        };
        return cache;
        function getUnderlyingCacheKey(specifier, mode) {
            const result = createModeAwareCacheKey(specifier, mode);
            memoizedReverseKeys.set(result, [
                specifier,
                mode
            ]);
            return result;
        }
    }
    function zipToModeAwareCache(file, keys, values, nameAndModeGetter) {
        Debug.assert(keys.length === values.length);
        const map2 = createModeAwareCache();
        for(let i = 0; i < keys.length; ++i){
            const entry = keys[i];
            map2.set(nameAndModeGetter.getName(entry), nameAndModeGetter.getMode(entry, file), values[i]);
        }
        return map2;
    }
    function getOriginalOrResolvedModuleFileName(result) {
        return result.resolvedModule && (result.resolvedModule.originalPath || result.resolvedModule.resolvedFileName);
    }
    function getOriginalOrResolvedTypeReferenceFileName(result) {
        return result.resolvedTypeReferenceDirective && (result.resolvedTypeReferenceDirective.originalPath || result.resolvedTypeReferenceDirective.resolvedFileName);
    }
    function createNonRelativeNameResolutionCache(currentDirectory, getCanonicalFileName, options, getResolvedFileName) {
        const moduleNameToDirectoryMap = createCacheWithRedirects(options);
        return {
            getFromNonRelativeNameCache: getFromNonRelativeNameCache,
            getOrCreateCacheForNonRelativeName: getOrCreateCacheForNonRelativeName,
            clear: clear2,
            update: update
        };
        function clear2() {
            moduleNameToDirectoryMap.clear();
        }
        function update(options2) {
            moduleNameToDirectoryMap.update(options2);
        }
        function getFromNonRelativeNameCache(nonRelativeModuleName, mode, directoryName, redirectedReference) {
            var _a, _b;
            Debug.assert(!isExternalModuleNameRelative(nonRelativeModuleName));
            return (_b = (_a = moduleNameToDirectoryMap.getMapOfCacheRedirects(redirectedReference)) == null ? void 0 : _a.get(createModeAwareCacheKey(nonRelativeModuleName, mode))) == null ? void 0 : _b.get(directoryName);
        }
        function getOrCreateCacheForNonRelativeName(nonRelativeModuleName, mode, redirectedReference) {
            Debug.assert(!isExternalModuleNameRelative(nonRelativeModuleName));
            return getOrCreateCache(moduleNameToDirectoryMap, redirectedReference, createModeAwareCacheKey(nonRelativeModuleName, mode), createPerModuleNameCache);
        }
        function createPerModuleNameCache() {
            const directoryPathMap = /* @__PURE__ */ new Map();
            return {
                get: get,
                set: set
            };
            function get(directory) {
                return directoryPathMap.get(toPath(directory, currentDirectory, getCanonicalFileName));
            }
            function set(directory, result) {
                const path = toPath(directory, currentDirectory, getCanonicalFileName);
                if (directoryPathMap.has(path)) return;
                directoryPathMap.set(path, result);
                const resolvedFileName = getResolvedFileName(result);
                const commonPrefix = resolvedFileName && getCommonPrefix(path, resolvedFileName);
                let current = path;
                while(current !== commonPrefix){
                    const parent2 = getDirectoryPath(current);
                    if (parent2 === current || directoryPathMap.has(parent2)) break;
                    directoryPathMap.set(parent2, result);
                    current = parent2;
                }
            }
            function getCommonPrefix(directory, resolution) {
                const resolutionDirectory = toPath(getDirectoryPath(resolution), currentDirectory, getCanonicalFileName);
                let i = 0;
                const limit = Math.min(directory.length, resolutionDirectory.length);
                while(i < limit && directory.charCodeAt(i) === resolutionDirectory.charCodeAt(i))i++;
                if (i === directory.length && (resolutionDirectory.length === i || resolutionDirectory[i] === directorySeparator)) return directory;
                const rootLength = getRootLength(directory);
                if (i < rootLength) return void 0;
                const sep = directory.lastIndexOf(directorySeparator, i - 1);
                if (sep === -1) return void 0;
                return directory.substr(0, Math.max(sep, rootLength));
            }
        }
    }
    function createModuleOrTypeReferenceResolutionCache(currentDirectory, getCanonicalFileName, options, packageJsonInfoCache, getResolvedFileName) {
        const perDirectoryResolutionCache = createPerDirectoryResolutionCache(currentDirectory, getCanonicalFileName, options);
        const nonRelativeNameResolutionCache = createNonRelativeNameResolutionCache(currentDirectory, getCanonicalFileName, options, getResolvedFileName);
        packageJsonInfoCache ?? (packageJsonInfoCache = createPackageJsonInfoCache(currentDirectory, getCanonicalFileName));
        return {
            ...packageJsonInfoCache,
            ...perDirectoryResolutionCache,
            ...nonRelativeNameResolutionCache,
            clear: clear2,
            update: update,
            getPackageJsonInfoCache: ()=>packageJsonInfoCache,
            clearAllExceptPackageJsonInfoCache: clearAllExceptPackageJsonInfoCache
        };
        function clear2() {
            clearAllExceptPackageJsonInfoCache();
            packageJsonInfoCache.clear();
        }
        function clearAllExceptPackageJsonInfoCache() {
            perDirectoryResolutionCache.clear();
            nonRelativeNameResolutionCache.clear();
        }
        function update(options2) {
            perDirectoryResolutionCache.update(options2);
            nonRelativeNameResolutionCache.update(options2);
        }
    }
    function createModuleResolutionCache(currentDirectory, getCanonicalFileName, options, packageJsonInfoCache) {
        const result = createModuleOrTypeReferenceResolutionCache(currentDirectory, getCanonicalFileName, options, packageJsonInfoCache, getOriginalOrResolvedModuleFileName);
        result.getOrCreateCacheForModuleName = (nonRelativeName, mode, redirectedReference)=>result.getOrCreateCacheForNonRelativeName(nonRelativeName, mode, redirectedReference);
        return result;
    }
    function createTypeReferenceDirectiveResolutionCache(currentDirectory, getCanonicalFileName, options, packageJsonInfoCache) {
        return createModuleOrTypeReferenceResolutionCache(currentDirectory, getCanonicalFileName, options, packageJsonInfoCache, getOriginalOrResolvedTypeReferenceFileName);
    }
    function getOptionsForLibraryResolution(options) {
        return {
            moduleResolution: 2 /* Node10 */ ,
            traceResolution: options.traceResolution
        };
    }
    function resolveLibrary(libraryName, resolveFrom, compilerOptions, host, cache) {
        return resolveModuleName(libraryName, resolveFrom, getOptionsForLibraryResolution(compilerOptions), host, cache);
    }
    function resolveModuleNameFromCache(moduleName, containingFile, cache, mode) {
        const containingDirectory = getDirectoryPath(containingFile);
        return cache.getFromDirectoryCache(moduleName, mode, containingDirectory, /*redirectedReference*/ void 0);
    }
    function resolveModuleName(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode) {
        var _a, _b, _c;
        const traceEnabled = isTraceEnabled(compilerOptions, host);
        if (redirectedReference) compilerOptions = redirectedReference.commandLine.options;
        if (traceEnabled) {
            trace(host, Diagnostics.Resolving_module_0_from_1, moduleName, containingFile);
            if (redirectedReference) trace(host, Diagnostics.Using_compiler_options_of_project_reference_redirect_0, redirectedReference.sourceFile.fileName);
        }
        const containingDirectory = getDirectoryPath(containingFile);
        let result = cache == null ? void 0 : cache.getFromDirectoryCache(moduleName, resolutionMode, containingDirectory, redirectedReference);
        if (result) {
            if (traceEnabled) trace(host, Diagnostics.Resolution_for_module_0_was_found_in_cache_from_location_1, moduleName, containingDirectory);
        } else {
            let moduleResolution = compilerOptions.moduleResolution;
            if (moduleResolution === void 0) {
                switch(getEmitModuleKind(compilerOptions)){
                    case 1 /* CommonJS */ :
                        moduleResolution = 2 /* Node10 */ ;
                        break;
                    case 100 /* Node16 */ :
                        moduleResolution = 3 /* Node16 */ ;
                        break;
                    case 199 /* NodeNext */ :
                        moduleResolution = 99 /* NodeNext */ ;
                        break;
                    default:
                        moduleResolution = 1 /* Classic */ ;
                        break;
                }
                if (traceEnabled) trace(host, Diagnostics.Module_resolution_kind_is_not_specified_using_0, ModuleResolutionKind[moduleResolution]);
            } else if (traceEnabled) trace(host, Diagnostics.Explicitly_specified_module_resolution_kind_Colon_0, ModuleResolutionKind[moduleResolution]);
            (_a = perfLogger) == null || _a.logStartResolveModule(moduleName);
            switch(moduleResolution){
                case 3 /* Node16 */ :
                    result = node16ModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode);
                    break;
                case 99 /* NodeNext */ :
                    result = nodeNextModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode);
                    break;
                case 2 /* Node10 */ :
                    result = nodeModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference);
                    break;
                case 1 /* Classic */ :
                    result = classicNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference);
                    break;
                case 100 /* Bundler */ :
                    result = bundlerModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference);
                    break;
                default:
                    return Debug.fail(`Unexpected moduleResolution: ${moduleResolution}`);
            }
            if (result && result.resolvedModule) (_b = perfLogger) == null || _b.logInfoEvent(`Module "${moduleName}" resolved to "${result.resolvedModule.resolvedFileName}"`);
            (_c = perfLogger) == null || _c.logStopResolveModule(result && result.resolvedModule ? "" + result.resolvedModule.resolvedFileName : "null");
            cache == null || cache.getOrCreateCacheForDirectory(containingDirectory, redirectedReference).set(moduleName, resolutionMode, result);
            if (!isExternalModuleNameRelative(moduleName)) cache == null || cache.getOrCreateCacheForNonRelativeName(moduleName, resolutionMode, redirectedReference).set(containingDirectory, result);
        }
        if (traceEnabled) {
            if (result.resolvedModule) {
                if (result.resolvedModule.packageId) trace(host, Diagnostics.Module_name_0_was_successfully_resolved_to_1_with_Package_ID_2, moduleName, result.resolvedModule.resolvedFileName, packageIdToString(result.resolvedModule.packageId));
                else trace(host, Diagnostics.Module_name_0_was_successfully_resolved_to_1, moduleName, result.resolvedModule.resolvedFileName);
            } else trace(host, Diagnostics.Module_name_0_was_not_resolved, moduleName);
        }
        return result;
    }
    function tryLoadModuleUsingOptionalResolutionSettings(extensions, moduleName, containingDirectory, loader, state) {
        const resolved = tryLoadModuleUsingPathsIfEligible(extensions, moduleName, loader, state);
        if (resolved) return resolved.value;
        if (!isExternalModuleNameRelative(moduleName)) return tryLoadModuleUsingBaseUrl(extensions, moduleName, loader, state);
        else return tryLoadModuleUsingRootDirs(extensions, moduleName, containingDirectory, loader, state);
    }
    function tryLoadModuleUsingPathsIfEligible(extensions, moduleName, loader, state) {
        var _a;
        const { baseUrl: baseUrl , paths: paths , configFile: configFile  } = state.compilerOptions;
        if (paths && !pathIsRelative(moduleName)) {
            if (state.traceEnabled) {
                if (baseUrl) trace(state.host, Diagnostics.baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1, baseUrl, moduleName);
                trace(state.host, Diagnostics.paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0, moduleName);
            }
            const baseDirectory = getPathsBasePath(state.compilerOptions, state.host);
            const pathPatterns = (configFile == null ? void 0 : configFile.configFileSpecs) ? (_a = configFile.configFileSpecs).pathPatterns || (_a.pathPatterns = tryParsePatterns(paths)) : void 0;
            return tryLoadModuleUsingPaths(extensions, moduleName, baseDirectory, paths, pathPatterns, loader, /*onlyRecordFailures*/ false, state);
        }
    }
    function tryLoadModuleUsingRootDirs(extensions, moduleName, containingDirectory, loader, state) {
        if (!state.compilerOptions.rootDirs) return void 0;
        if (state.traceEnabled) trace(state.host, Diagnostics.rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0, moduleName);
        const candidate = normalizePath(combinePaths(containingDirectory, moduleName));
        let matchedRootDir;
        let matchedNormalizedPrefix;
        for (const rootDir of state.compilerOptions.rootDirs){
            let normalizedRoot = normalizePath(rootDir);
            if (!endsWith(normalizedRoot, directorySeparator)) normalizedRoot += directorySeparator;
            const isLongestMatchingPrefix = startsWith(candidate, normalizedRoot) && (matchedNormalizedPrefix === void 0 || matchedNormalizedPrefix.length < normalizedRoot.length);
            if (state.traceEnabled) trace(state.host, Diagnostics.Checking_if_0_is_the_longest_matching_prefix_for_1_2, normalizedRoot, candidate, isLongestMatchingPrefix);
            if (isLongestMatchingPrefix) {
                matchedNormalizedPrefix = normalizedRoot;
                matchedRootDir = rootDir;
            }
        }
        if (matchedNormalizedPrefix) {
            if (state.traceEnabled) trace(state.host, Diagnostics.Longest_matching_prefix_for_0_is_1, candidate, matchedNormalizedPrefix);
            const suffix = candidate.substr(matchedNormalizedPrefix.length);
            if (state.traceEnabled) trace(state.host, Diagnostics.Loading_0_from_the_root_dir_1_candidate_location_2, suffix, matchedNormalizedPrefix, candidate);
            const resolvedFileName = loader(extensions, candidate, !directoryProbablyExists(containingDirectory, state.host), state);
            if (resolvedFileName) return resolvedFileName;
            if (state.traceEnabled) trace(state.host, Diagnostics.Trying_other_entries_in_rootDirs);
            for (const rootDir of state.compilerOptions.rootDirs){
                if (rootDir === matchedRootDir) continue;
                const candidate2 = combinePaths(normalizePath(rootDir), suffix);
                if (state.traceEnabled) trace(state.host, Diagnostics.Loading_0_from_the_root_dir_1_candidate_location_2, suffix, rootDir, candidate2);
                const baseDirectory = getDirectoryPath(candidate2);
                const resolvedFileName2 = loader(extensions, candidate2, !directoryProbablyExists(baseDirectory, state.host), state);
                if (resolvedFileName2) return resolvedFileName2;
            }
            if (state.traceEnabled) trace(state.host, Diagnostics.Module_resolution_using_rootDirs_has_failed);
        }
        return void 0;
    }
    function tryLoadModuleUsingBaseUrl(extensions, moduleName, loader, state) {
        const { baseUrl: baseUrl  } = state.compilerOptions;
        if (!baseUrl) return void 0;
        if (state.traceEnabled) trace(state.host, Diagnostics.baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1, baseUrl, moduleName);
        const candidate = normalizePath(combinePaths(baseUrl, moduleName));
        if (state.traceEnabled) trace(state.host, Diagnostics.Resolving_module_name_0_relative_to_base_url_1_2, moduleName, baseUrl, candidate);
        return loader(extensions, candidate, !directoryProbablyExists(getDirectoryPath(candidate), state.host), state);
    }
    function resolveJSModule(moduleName, initialDir, host) {
        const { resolvedModule: resolvedModule , failedLookupLocations: failedLookupLocations  } = tryResolveJSModuleWorker(moduleName, initialDir, host);
        if (!resolvedModule) throw new Error(`Could not resolve JS module '${moduleName}' starting at '${initialDir}'. Looked in: ${failedLookupLocations == null ? void 0 : failedLookupLocations.join(", ")}`);
        return resolvedModule.resolvedFileName;
    }
    function node16ModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode) {
        return nodeNextModuleNameResolverWorker(30 /* Node16Default */ , moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode);
    }
    function nodeNextModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode) {
        return nodeNextModuleNameResolverWorker(30 /* NodeNextDefault */ , moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode);
    }
    function nodeNextModuleNameResolverWorker(features, moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode) {
        const containingDirectory = getDirectoryPath(containingFile);
        const esmMode = resolutionMode === 99 /* ESNext */  ? 32 /* EsmMode */  : 0;
        let extensions = compilerOptions.noDtsResolution ? 3 /* ImplementationFiles */  : 7 /* Declaration */ ;
        if (getResolveJsonModule(compilerOptions)) extensions |= 8 /* Json */ ;
        return nodeModuleNameResolverWorker(features | esmMode, moduleName, containingDirectory, compilerOptions, host, cache, extensions, /*isConfigLookup*/ false, redirectedReference);
    }
    function tryResolveJSModuleWorker(moduleName, initialDir, host) {
        return nodeModuleNameResolverWorker(0 /* None */ , moduleName, initialDir, {
            moduleResolution: 2 /* Node10 */ ,
            allowJs: true
        }, host, /*cache*/ void 0, 2 /* JavaScript */ , /*isConfigLookup*/ false, /*redirectedReference*/ void 0);
    }
    function bundlerModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference) {
        const containingDirectory = getDirectoryPath(containingFile);
        let extensions = compilerOptions.noDtsResolution ? 3 /* ImplementationFiles */  : 7 /* Declaration */ ;
        if (getResolveJsonModule(compilerOptions)) extensions |= 8 /* Json */ ;
        return nodeModuleNameResolverWorker(getNodeResolutionFeatures(compilerOptions), moduleName, containingDirectory, compilerOptions, host, cache, extensions, /*isConfigLookup*/ false, redirectedReference);
    }
    function nodeModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, isConfigLookup) {
        let extensions;
        if (isConfigLookup) extensions = 8 /* Json */ ;
        else if (compilerOptions.noDtsResolution) {
            extensions = 3 /* ImplementationFiles */ ;
            if (getResolveJsonModule(compilerOptions)) extensions |= 8 /* Json */ ;
        } else extensions = getResolveJsonModule(compilerOptions) ? 15 /* Json */  : 7 /* Declaration */ ;
        return nodeModuleNameResolverWorker(0 /* None */ , moduleName, getDirectoryPath(containingFile), compilerOptions, host, cache, extensions, !!isConfigLookup, redirectedReference);
    }
    function nodeNextJsonConfigResolver(moduleName, containingFile, host) {
        return nodeModuleNameResolverWorker(30 /* NodeNextDefault */ , moduleName, getDirectoryPath(containingFile), {
            moduleResolution: 99 /* NodeNext */ 
        }, host, /*cache*/ void 0, 8 /* Json */ , /*isConfigLookup*/ true, /*redirectedReference*/ void 0);
    }
    function nodeModuleNameResolverWorker(features, moduleName, containingDirectory, compilerOptions, host, cache, extensions, isConfigLookup, redirectedReference) {
        var _a, _b, _c, _d;
        const traceEnabled = isTraceEnabled(compilerOptions, host);
        const failedLookupLocations = [];
        const affectingLocations = [];
        const conditions = getConditions(compilerOptions, !!(features & 32 /* EsmMode */ ));
        const diagnostics = [];
        const state = {
            compilerOptions: compilerOptions,
            host: host,
            traceEnabled: traceEnabled,
            failedLookupLocations: failedLookupLocations,
            affectingLocations: affectingLocations,
            packageJsonInfoCache: cache,
            features: features,
            conditions: conditions,
            requestContainingDirectory: containingDirectory,
            reportDiagnostic: (diag2)=>void diagnostics.push(diag2),
            isConfigLookup: isConfigLookup,
            candidateIsFromPackageJsonField: false
        };
        if (traceEnabled && moduleResolutionSupportsPackageJsonExportsAndImports(getEmitModuleResolutionKind(compilerOptions))) trace(host, Diagnostics.Resolving_in_0_mode_with_conditions_1, features & 32 /* EsmMode */  ? "ESM" : "CJS", conditions.map((c)=>`'${c}'`).join(", "));
        let result;
        if (getEmitModuleResolutionKind(compilerOptions) === 2 /* Node10 */ ) {
            const priorityExtensions = extensions & 5 /* Declaration */ ;
            const secondaryExtensions = extensions & -6;
            result = priorityExtensions && tryResolve(priorityExtensions, state) || secondaryExtensions && tryResolve(secondaryExtensions, state) || void 0;
        } else result = tryResolve(extensions, state);
        let legacyResult;
        if (((_a = result == null ? void 0 : result.value) == null ? void 0 : _a.isExternalLibraryImport) && !isConfigLookup && extensions & 5 /* Declaration */  && features & 8 /* Exports */  && !isExternalModuleNameRelative(moduleName) && !extensionIsOk(5 /* Declaration */ , result.value.resolved.extension) && conditions.indexOf("import") > -1) {
            traceIfEnabled(state, Diagnostics.Resolution_of_non_relative_name_failed_trying_with_modern_Node_resolution_features_disabled_to_see_if_npm_library_needs_configuration_update);
            const diagnosticState = {
                ...state,
                features: state.features & -9 /* Exports */ ,
                reportDiagnostic: noop
            };
            const diagnosticResult = tryResolve(extensions & 5 /* Declaration */ , diagnosticState);
            if ((_b = diagnosticResult == null ? void 0 : diagnosticResult.value) == null ? void 0 : _b.isExternalLibraryImport) legacyResult = diagnosticResult.value.resolved.path;
        }
        return createResolvedModuleWithFailedLookupLocationsHandlingSymlink(moduleName, (_c = result == null ? void 0 : result.value) == null ? void 0 : _c.resolved, (_d = result == null ? void 0 : result.value) == null ? void 0 : _d.isExternalLibraryImport, failedLookupLocations, affectingLocations, diagnostics, state, legacyResult);
        function tryResolve(extensions2, state2) {
            const loader = (extensions3, candidate, onlyRecordFailures, state3)=>nodeLoadModuleByRelativeName(extensions3, candidate, onlyRecordFailures, state3, /*considerPackageJson*/ true);
            const resolved = tryLoadModuleUsingOptionalResolutionSettings(extensions2, moduleName, containingDirectory, loader, state2);
            if (resolved) return toSearchResult({
                resolved: resolved,
                isExternalLibraryImport: pathContainsNodeModules(resolved.path)
            });
            if (!isExternalModuleNameRelative(moduleName)) {
                let resolved2;
                if (features & 2 /* Imports */  && startsWith(moduleName, "#")) resolved2 = loadModuleFromImports(extensions2, moduleName, containingDirectory, state2, cache, redirectedReference);
                if (!resolved2 && features & 4 /* SelfName */ ) resolved2 = loadModuleFromSelfNameReference(extensions2, moduleName, containingDirectory, state2, cache, redirectedReference);
                if (!resolved2) {
                    if (moduleName.indexOf(":") > -1) {
                        if (traceEnabled) trace(host, Diagnostics.Skipping_module_0_that_looks_like_an_absolute_URI_target_file_types_Colon_1, moduleName, formatExtensions(extensions2));
                        return void 0;
                    }
                    if (traceEnabled) trace(host, Diagnostics.Loading_module_0_from_node_modules_folder_target_file_types_Colon_1, moduleName, formatExtensions(extensions2));
                    resolved2 = loadModuleFromNearestNodeModulesDirectory(extensions2, moduleName, containingDirectory, state2, cache, redirectedReference);
                }
                if (extensions2 & 4 /* Declaration */ ) resolved2 ?? (resolved2 = resolveFromTypeRoot(moduleName, state2));
                return resolved2 && {
                    value: resolved2.value && {
                        resolved: resolved2.value,
                        isExternalLibraryImport: true
                    }
                };
            } else {
                const { path: candidate , parts: parts  } = normalizePathForCJSResolution(containingDirectory, moduleName);
                const resolved2 = nodeLoadModuleByRelativeName(extensions2, candidate, /*onlyRecordFailures*/ false, state2, /*considerPackageJson*/ true);
                return resolved2 && toSearchResult({
                    resolved: resolved2,
                    isExternalLibraryImport: contains(parts, "node_modules")
                });
            }
        }
    }
    function normalizePathForCJSResolution(containingDirectory, moduleName) {
        const combined = combinePaths(containingDirectory, moduleName);
        const parts = getPathComponents(combined);
        const lastPart = lastOrUndefined(parts);
        const path = lastPart === "." || lastPart === ".." ? ensureTrailingDirectorySeparator(normalizePath(combined)) : normalizePath(combined);
        return {
            path: path,
            parts: parts
        };
    }
    function realPath(path, host, traceEnabled) {
        if (!host.realpath) return path;
        const real = normalizePath(host.realpath(path));
        if (traceEnabled) trace(host, Diagnostics.Resolving_real_path_for_0_result_1, path, real);
        Debug.assert(host.fileExists(real), `${path} linked to nonexistent file ${real}`);
        return real;
    }
    function nodeLoadModuleByRelativeName(extensions, candidate, onlyRecordFailures, state, considerPackageJson) {
        if (state.traceEnabled) trace(state.host, Diagnostics.Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_types_Colon_1, candidate, formatExtensions(extensions));
        if (!hasTrailingDirectorySeparator(candidate)) {
            if (!onlyRecordFailures) {
                const parentOfCandidate = getDirectoryPath(candidate);
                if (!directoryProbablyExists(parentOfCandidate, state.host)) {
                    if (state.traceEnabled) trace(state.host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, parentOfCandidate);
                    onlyRecordFailures = true;
                }
            }
            const resolvedFromFile = loadModuleFromFile(extensions, candidate, onlyRecordFailures, state);
            if (resolvedFromFile) {
                const packageDirectory = considerPackageJson ? parseNodeModuleFromPath(resolvedFromFile.path) : void 0;
                const packageInfo = packageDirectory ? getPackageJsonInfo(packageDirectory, /*onlyRecordFailures*/ false, state) : void 0;
                return withPackageId(packageInfo, resolvedFromFile);
            }
        }
        if (!onlyRecordFailures) {
            const candidateExists = directoryProbablyExists(candidate, state.host);
            if (!candidateExists) {
                if (state.traceEnabled) trace(state.host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, candidate);
                onlyRecordFailures = true;
            }
        }
        if (!(state.features & 32 /* EsmMode */ )) return loadNodeModuleFromDirectory(extensions, candidate, onlyRecordFailures, state, considerPackageJson);
        return void 0;
    }
    function pathContainsNodeModules(path) {
        return stringContains(path, nodeModulesPathPart);
    }
    function parseNodeModuleFromPath(resolved, isFolder) {
        const path = normalizePath(resolved);
        const idx = path.lastIndexOf(nodeModulesPathPart);
        if (idx === -1) return void 0;
        const indexAfterNodeModules = idx + nodeModulesPathPart.length;
        let indexAfterPackageName = moveToNextDirectorySeparatorIfAvailable(path, indexAfterNodeModules, isFolder);
        if (path.charCodeAt(indexAfterNodeModules) === 64 /* at */ ) indexAfterPackageName = moveToNextDirectorySeparatorIfAvailable(path, indexAfterPackageName, isFolder);
        return path.slice(0, indexAfterPackageName);
    }
    function moveToNextDirectorySeparatorIfAvailable(path, prevSeparatorIndex, isFolder) {
        const nextSeparatorIndex = path.indexOf(directorySeparator, prevSeparatorIndex + 1);
        return nextSeparatorIndex === -1 ? isFolder ? path.length : prevSeparatorIndex : nextSeparatorIndex;
    }
    function loadModuleFromFileNoPackageId(extensions, candidate, onlyRecordFailures, state) {
        return noPackageId(loadModuleFromFile(extensions, candidate, onlyRecordFailures, state));
    }
    function loadModuleFromFile(extensions, candidate, onlyRecordFailures, state) {
        const resolvedByReplacingExtension = loadModuleFromFileNoImplicitExtensions(extensions, candidate, onlyRecordFailures, state);
        if (resolvedByReplacingExtension) return resolvedByReplacingExtension;
        if (!(state.features & 32 /* EsmMode */ )) {
            const resolvedByAddingExtension = tryAddingExtensions(candidate, extensions, "", onlyRecordFailures, state);
            if (resolvedByAddingExtension) return resolvedByAddingExtension;
        }
    }
    function loadModuleFromFileNoImplicitExtensions(extensions, candidate, onlyRecordFailures, state) {
        const filename = getBaseFileName(candidate);
        if (filename.indexOf(".") === -1) return void 0;
        let extensionless = removeFileExtension(candidate);
        if (extensionless === candidate) extensionless = candidate.substring(0, candidate.lastIndexOf("."));
        const extension = candidate.substring(extensionless.length);
        if (state.traceEnabled) trace(state.host, Diagnostics.File_name_0_has_a_1_extension_stripping_it, candidate, extension);
        return tryAddingExtensions(extensionless, extensions, extension, onlyRecordFailures, state);
    }
    function loadFileNameFromPackageJsonField(extensions, candidate, onlyRecordFailures, state) {
        if (extensions & 1 /* TypeScript */  && fileExtensionIsOneOf(candidate, supportedTSImplementationExtensions) || extensions & 4 /* Declaration */  && fileExtensionIsOneOf(candidate, supportedDeclarationExtensions)) {
            const result = tryFile(candidate, onlyRecordFailures, state);
            return result !== void 0 ? {
                path: candidate,
                ext: tryExtractTSExtension(candidate),
                resolvedUsingTsExtension: void 0
            } : void 0;
        }
        if (state.isConfigLookup && extensions === 8 /* Json */  && fileExtensionIs(candidate, ".json" /* Json */ )) {
            const result = tryFile(candidate, onlyRecordFailures, state);
            return result !== void 0 ? {
                path: candidate,
                ext: ".json" /* Json */ ,
                resolvedUsingTsExtension: void 0
            } : void 0;
        }
        return loadModuleFromFileNoImplicitExtensions(extensions, candidate, onlyRecordFailures, state);
    }
    function tryAddingExtensions(candidate, extensions, originalExtension, onlyRecordFailures, state) {
        if (!onlyRecordFailures) {
            const directory = getDirectoryPath(candidate);
            if (directory) onlyRecordFailures = !directoryProbablyExists(directory, state.host);
        }
        switch(originalExtension){
            case ".mjs" /* Mjs */ :
            case ".mts" /* Mts */ :
            case ".d.mts" /* Dmts */ :
                return extensions & 1 /* TypeScript */  && tryExtension(".mts" /* Mts */ , originalExtension === ".mts" /* Mts */  || originalExtension === ".d.mts" /* Dmts */ ) || extensions & 4 /* Declaration */  && tryExtension(".d.mts" /* Dmts */ , originalExtension === ".mts" /* Mts */  || originalExtension === ".d.mts" /* Dmts */ ) || extensions & 2 /* JavaScript */  && tryExtension(".mjs" /* Mjs */ ) || void 0;
            case ".cjs" /* Cjs */ :
            case ".cts" /* Cts */ :
            case ".d.cts" /* Dcts */ :
                return extensions & 1 /* TypeScript */  && tryExtension(".cts" /* Cts */ , originalExtension === ".cts" /* Cts */  || originalExtension === ".d.cts" /* Dcts */ ) || extensions & 4 /* Declaration */  && tryExtension(".d.cts" /* Dcts */ , originalExtension === ".cts" /* Cts */  || originalExtension === ".d.cts" /* Dcts */ ) || extensions & 2 /* JavaScript */  && tryExtension(".cjs" /* Cjs */ ) || void 0;
            case ".json" /* Json */ :
                return extensions & 4 /* Declaration */  && tryExtension(".d.json.ts") || extensions & 8 /* Json */  && tryExtension(".json" /* Json */ ) || void 0;
            case ".tsx" /* Tsx */ :
            case ".jsx" /* Jsx */ :
                return extensions & 1 /* TypeScript */  && (tryExtension(".tsx" /* Tsx */ , originalExtension === ".tsx" /* Tsx */ ) || tryExtension(".ts" /* Ts */ , originalExtension === ".tsx" /* Tsx */ )) || extensions & 4 /* Declaration */  && tryExtension(".d.ts" /* Dts */ , originalExtension === ".tsx" /* Tsx */ ) || extensions & 2 /* JavaScript */  && (tryExtension(".jsx" /* Jsx */ ) || tryExtension(".js" /* Js */ )) || void 0;
            case ".ts" /* Ts */ :
            case ".d.ts" /* Dts */ :
            case ".js" /* Js */ :
            case "":
                return extensions & 1 /* TypeScript */  && (tryExtension(".ts" /* Ts */ , originalExtension === ".ts" /* Ts */  || originalExtension === ".d.ts" /* Dts */ ) || tryExtension(".tsx" /* Tsx */ , originalExtension === ".ts" /* Ts */  || originalExtension === ".d.ts" /* Dts */ )) || extensions & 4 /* Declaration */  && tryExtension(".d.ts" /* Dts */ , originalExtension === ".ts" /* Ts */  || originalExtension === ".d.ts" /* Dts */ ) || extensions & 2 /* JavaScript */  && (tryExtension(".js" /* Js */ ) || tryExtension(".jsx" /* Jsx */ )) || state.isConfigLookup && tryExtension(".json" /* Json */ ) || void 0;
            default:
                return extensions & 4 /* Declaration */  && !isDeclarationFileName(candidate + originalExtension) && tryExtension(`.d${originalExtension}.ts`) || void 0;
        }
        function tryExtension(ext, resolvedUsingTsExtension) {
            const path = tryFile(candidate + ext, onlyRecordFailures, state);
            return path === void 0 ? void 0 : {
                path: path,
                ext: ext,
                resolvedUsingTsExtension: !state.candidateIsFromPackageJsonField && resolvedUsingTsExtension
            };
        }
    }
    function tryFile(fileName, onlyRecordFailures, state) {
        var _a;
        if (!((_a = state.compilerOptions.moduleSuffixes) == null ? void 0 : _a.length)) return tryFileLookup(fileName, onlyRecordFailures, state);
        const ext = tryGetExtensionFromPath2(fileName) ?? "";
        const fileNameNoExtension = ext ? removeExtension(fileName, ext) : fileName;
        return forEach(state.compilerOptions.moduleSuffixes, (suffix)=>tryFileLookup(fileNameNoExtension + suffix + ext, onlyRecordFailures, state));
    }
    function tryFileLookup(fileName, onlyRecordFailures, state) {
        var _a;
        if (!onlyRecordFailures) {
            if (state.host.fileExists(fileName)) {
                if (state.traceEnabled) trace(state.host, Diagnostics.File_0_exists_use_it_as_a_name_resolution_result, fileName);
                return fileName;
            } else if (state.traceEnabled) trace(state.host, Diagnostics.File_0_does_not_exist, fileName);
        }
        (_a = state.failedLookupLocations) == null || _a.push(fileName);
        return void 0;
    }
    function loadNodeModuleFromDirectory(extensions, candidate, onlyRecordFailures, state, considerPackageJson = true) {
        const packageInfo = considerPackageJson ? getPackageJsonInfo(candidate, onlyRecordFailures, state) : void 0;
        const packageJsonContent = packageInfo && packageInfo.contents.packageJsonContent;
        const versionPaths = packageInfo && getVersionPathsOfPackageJsonInfo(packageInfo, state);
        return withPackageId(packageInfo, loadNodeModuleFromDirectoryWorker(extensions, candidate, onlyRecordFailures, state, packageJsonContent, versionPaths));
    }
    function getEntrypointsFromPackageJsonInfo(packageJsonInfo, options, host, cache, resolveJs) {
        if (!resolveJs && packageJsonInfo.contents.resolvedEntrypoints !== void 0) return packageJsonInfo.contents.resolvedEntrypoints;
        let entrypoints;
        const extensions = 5 /* Declaration */  | (resolveJs ? 2 /* JavaScript */  : 0);
        const features = getNodeResolutionFeatures(options);
        const loadPackageJsonMainState = getTemporaryModuleResolutionState(cache == null ? void 0 : cache.getPackageJsonInfoCache(), host, options);
        loadPackageJsonMainState.conditions = getConditions(options);
        loadPackageJsonMainState.requestContainingDirectory = packageJsonInfo.packageDirectory;
        const mainResolution = loadNodeModuleFromDirectoryWorker(extensions, packageJsonInfo.packageDirectory, /*onlyRecordFailures*/ false, loadPackageJsonMainState, packageJsonInfo.contents.packageJsonContent, getVersionPathsOfPackageJsonInfo(packageJsonInfo, loadPackageJsonMainState));
        entrypoints = append(entrypoints, mainResolution == null ? void 0 : mainResolution.path);
        if (features & 8 /* Exports */  && packageJsonInfo.contents.packageJsonContent.exports) {
            const conditionSets = deduplicate([
                getConditions(options, /*esmMode*/ true),
                getConditions(options, /*esmMode*/ false)
            ], arrayIsEqualTo);
            for (const conditions of conditionSets){
                const loadPackageJsonExportsState = {
                    ...loadPackageJsonMainState,
                    failedLookupLocations: [],
                    conditions: conditions
                };
                const exportResolutions = loadEntrypointsFromExportMap(packageJsonInfo, packageJsonInfo.contents.packageJsonContent.exports, loadPackageJsonExportsState, extensions);
                if (exportResolutions) for (const resolution of exportResolutions)entrypoints = appendIfUnique(entrypoints, resolution.path);
            }
        }
        return packageJsonInfo.contents.resolvedEntrypoints = entrypoints || false;
    }
    function loadEntrypointsFromExportMap(scope, exports, state, extensions) {
        let entrypoints;
        if (isArray(exports)) for (const target of exports)loadEntrypointsFromTargetExports(target);
        else if (typeof exports === "object" && exports !== null && allKeysStartWithDot(exports)) for(const key in exports)loadEntrypointsFromTargetExports(exports[key]);
        else loadEntrypointsFromTargetExports(exports);
        return entrypoints;
        function loadEntrypointsFromTargetExports(target) {
            var _a, _b;
            if (typeof target === "string" && startsWith(target, "./") && target.indexOf("*") === -1) {
                const partsAfterFirst = getPathComponents(target).slice(2);
                if (partsAfterFirst.indexOf("..") >= 0 || partsAfterFirst.indexOf(".") >= 0 || partsAfterFirst.indexOf("node_modules") >= 0) return false;
                const resolvedTarget = combinePaths(scope.packageDirectory, target);
                const finalPath = getNormalizedAbsolutePath(resolvedTarget, (_b = (_a = state.host).getCurrentDirectory) == null ? void 0 : _b.call(_a));
                const result = loadFileNameFromPackageJsonField(extensions, finalPath, /*onlyRecordFailures*/ false, state);
                if (result) {
                    entrypoints = appendIfUnique(entrypoints, result, (a, b)=>a.path === b.path);
                    return true;
                }
            } else if (Array.isArray(target)) for (const t of target){
                const success = loadEntrypointsFromTargetExports(t);
                if (success) return true;
            }
            else if (typeof target === "object" && target !== null) return forEach(getOwnKeys(target), (key)=>{
                if (key === "default" || contains(state.conditions, key) || isApplicableVersionedTypesKey(state.conditions, key)) {
                    loadEntrypointsFromTargetExports(target[key]);
                    return true;
                }
            });
        }
    }
    function getTemporaryModuleResolutionState(packageJsonInfoCache, host, options) {
        return {
            host: host,
            compilerOptions: options,
            traceEnabled: isTraceEnabled(options, host),
            failedLookupLocations: void 0,
            affectingLocations: void 0,
            packageJsonInfoCache: packageJsonInfoCache,
            features: 0 /* None */ ,
            conditions: emptyArray,
            requestContainingDirectory: void 0,
            reportDiagnostic: noop,
            isConfigLookup: false,
            candidateIsFromPackageJsonField: false
        };
    }
    function getPackageScopeForPath(fileName, state) {
        const parts = getPathComponents(fileName);
        parts.pop();
        while(parts.length > 0){
            const pkg = getPackageJsonInfo(getPathFromPathComponents(parts), /*onlyRecordFailures*/ false, state);
            if (pkg) return pkg;
            parts.pop();
        }
        return void 0;
    }
    function getVersionPathsOfPackageJsonInfo(packageJsonInfo, state) {
        if (packageJsonInfo.contents.versionPaths === void 0) packageJsonInfo.contents.versionPaths = readPackageJsonTypesVersionPaths(packageJsonInfo.contents.packageJsonContent, state) || false;
        return packageJsonInfo.contents.versionPaths || void 0;
    }
    function getPackageJsonInfo(packageDirectory, onlyRecordFailures, state) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const { host: host , traceEnabled: traceEnabled  } = state;
        const packageJsonPath = combinePaths(packageDirectory, "package.json");
        if (onlyRecordFailures) {
            (_a = state.failedLookupLocations) == null || _a.push(packageJsonPath);
            return void 0;
        }
        const existing = (_b = state.packageJsonInfoCache) == null ? void 0 : _b.getPackageJsonInfo(packageJsonPath);
        if (existing !== void 0) {
            if (typeof existing !== "boolean") {
                if (traceEnabled) trace(host, Diagnostics.File_0_exists_according_to_earlier_cached_lookups, packageJsonPath);
                (_c = state.affectingLocations) == null || _c.push(packageJsonPath);
                return existing.packageDirectory === packageDirectory ? existing : {
                    packageDirectory: packageDirectory,
                    contents: existing.contents
                };
            } else {
                if (existing && traceEnabled) trace(host, Diagnostics.File_0_does_not_exist_according_to_earlier_cached_lookups, packageJsonPath);
                (_d = state.failedLookupLocations) == null || _d.push(packageJsonPath);
                return void 0;
            }
        }
        const directoryExists = directoryProbablyExists(packageDirectory, host);
        if (directoryExists && host.fileExists(packageJsonPath)) {
            const packageJsonContent = readJson(packageJsonPath, host);
            if (traceEnabled) trace(host, Diagnostics.Found_package_json_at_0, packageJsonPath);
            const result = {
                packageDirectory: packageDirectory,
                contents: {
                    packageJsonContent: packageJsonContent,
                    versionPaths: void 0,
                    resolvedEntrypoints: void 0
                }
            };
            (_e = state.packageJsonInfoCache) == null || _e.setPackageJsonInfo(packageJsonPath, result);
            (_f = state.affectingLocations) == null || _f.push(packageJsonPath);
            return result;
        } else {
            if (directoryExists && traceEnabled) trace(host, Diagnostics.File_0_does_not_exist, packageJsonPath);
            (_g = state.packageJsonInfoCache) == null || _g.setPackageJsonInfo(packageJsonPath, directoryExists);
            (_h = state.failedLookupLocations) == null || _h.push(packageJsonPath);
        }
    }
    function loadNodeModuleFromDirectoryWorker(extensions, candidate, onlyRecordFailures, state, jsonContent, versionPaths) {
        let packageFile;
        if (jsonContent) {
            if (state.isConfigLookup) packageFile = readPackageJsonTSConfigField(jsonContent, candidate, state);
            else packageFile = extensions & 4 /* Declaration */  && readPackageJsonTypesFields(jsonContent, candidate, state) || extensions & 7 /* Declaration */  && readPackageJsonMainField(jsonContent, candidate, state) || void 0;
        }
        const loader = (extensions2, candidate2, onlyRecordFailures2, state2)=>{
            const fromFile = tryFile(candidate2, onlyRecordFailures2, state2);
            if (fromFile) {
                const resolved = resolvedIfExtensionMatches(extensions2, fromFile);
                if (resolved) return noPackageId(resolved);
                if (state2.traceEnabled) trace(state2.host, Diagnostics.File_0_has_an_unsupported_extension_so_skipping_it, fromFile);
            }
            const expandedExtensions = extensions2 === 4 /* Declaration */  ? 5 /* Declaration */  : extensions2;
            const features = state2.features;
            const candidateIsFromPackageJsonField = state2.candidateIsFromPackageJsonField;
            state2.candidateIsFromPackageJsonField = true;
            if ((jsonContent == null ? void 0 : jsonContent.type) !== "module") state2.features &= -33 /* EsmMode */ ;
            const result = nodeLoadModuleByRelativeName(expandedExtensions, candidate2, onlyRecordFailures2, state2, /*considerPackageJson*/ false);
            state2.features = features;
            state2.candidateIsFromPackageJsonField = candidateIsFromPackageJsonField;
            return result;
        };
        const onlyRecordFailuresForPackageFile = packageFile ? !directoryProbablyExists(getDirectoryPath(packageFile), state.host) : void 0;
        const onlyRecordFailuresForIndex = onlyRecordFailures || !directoryProbablyExists(candidate, state.host);
        const indexPath = combinePaths(candidate, state.isConfigLookup ? "tsconfig" : "index");
        if (versionPaths && (!packageFile || containsPath(candidate, packageFile))) {
            const moduleName = getRelativePathFromDirectory(candidate, packageFile || indexPath, /*ignoreCase*/ false);
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_has_a_typesVersions_entry_0_that_matches_compiler_version_1_looking_for_a_pattern_to_match_module_name_2, versionPaths.version, version, moduleName);
            const result = tryLoadModuleUsingPaths(extensions, moduleName, candidate, versionPaths.paths, /*pathPatterns*/ void 0, loader, onlyRecordFailuresForPackageFile || onlyRecordFailuresForIndex, state);
            if (result) return removeIgnoredPackageId(result.value);
        }
        const packageFileResult = packageFile && removeIgnoredPackageId(loader(extensions, packageFile, onlyRecordFailuresForPackageFile, state));
        if (packageFileResult) return packageFileResult;
        if (!(state.features & 32 /* EsmMode */ )) return loadModuleFromFile(extensions, indexPath, onlyRecordFailuresForIndex, state);
    }
    function resolvedIfExtensionMatches(extensions, path, resolvedUsingTsExtension) {
        const ext = tryGetExtensionFromPath2(path);
        return ext !== void 0 && extensionIsOk(extensions, ext) ? {
            path: path,
            ext: ext,
            resolvedUsingTsExtension: resolvedUsingTsExtension
        } : void 0;
    }
    function extensionIsOk(extensions, extension) {
        return extensions & 2 /* JavaScript */  && (extension === ".js" /* Js */  || extension === ".jsx" /* Jsx */  || extension === ".mjs" /* Mjs */  || extension === ".cjs" /* Cjs */ ) || extensions & 1 /* TypeScript */  && (extension === ".ts" /* Ts */  || extension === ".tsx" /* Tsx */  || extension === ".mts" /* Mts */  || extension === ".cts" /* Cts */ ) || extensions & 4 /* Declaration */  && (extension === ".d.ts" /* Dts */  || extension === ".d.mts" /* Dmts */  || extension === ".d.cts" /* Dcts */ ) || extensions & 8 /* Json */  && extension === ".json" /* Json */  || false;
    }
    function parsePackageName(moduleName) {
        let idx = moduleName.indexOf(directorySeparator);
        if (moduleName[0] === "@") idx = moduleName.indexOf(directorySeparator, idx + 1);
        return idx === -1 ? {
            packageName: moduleName,
            rest: ""
        } : {
            packageName: moduleName.slice(0, idx),
            rest: moduleName.slice(idx + 1)
        };
    }
    function allKeysStartWithDot(obj) {
        return every(getOwnKeys(obj), (k)=>startsWith(k, "."));
    }
    function noKeyStartsWithDot(obj) {
        return !some(getOwnKeys(obj), (k)=>startsWith(k, "."));
    }
    function loadModuleFromSelfNameReference(extensions, moduleName, directory, state, cache, redirectedReference) {
        var _a, _b;
        const directoryPath = getNormalizedAbsolutePath(combinePaths(directory, "dummy"), (_b = (_a = state.host).getCurrentDirectory) == null ? void 0 : _b.call(_a));
        const scope = getPackageScopeForPath(directoryPath, state);
        if (!scope || !scope.contents.packageJsonContent.exports) return void 0;
        if (typeof scope.contents.packageJsonContent.name !== "string") return void 0;
        const parts = getPathComponents(moduleName);
        const nameParts = getPathComponents(scope.contents.packageJsonContent.name);
        if (!every(nameParts, (p, i)=>parts[i] === p)) return void 0;
        const trailingParts = parts.slice(nameParts.length);
        const subpath = !length(trailingParts) ? "." : `.${directorySeparator}${trailingParts.join(directorySeparator)}`;
        const priorityExtensions = extensions & 5 /* Declaration */ ;
        const secondaryExtensions = extensions & -6;
        return loadModuleFromExports(scope, priorityExtensions, subpath, state, cache, redirectedReference) || loadModuleFromExports(scope, secondaryExtensions, subpath, state, cache, redirectedReference);
    }
    function loadModuleFromExports(scope, extensions, subpath, state, cache, redirectedReference) {
        if (!scope.contents.packageJsonContent.exports) return void 0;
        if (subpath === ".") {
            let mainExport;
            if (typeof scope.contents.packageJsonContent.exports === "string" || Array.isArray(scope.contents.packageJsonContent.exports) || typeof scope.contents.packageJsonContent.exports === "object" && noKeyStartsWithDot(scope.contents.packageJsonContent.exports)) mainExport = scope.contents.packageJsonContent.exports;
            else if (hasProperty(scope.contents.packageJsonContent.exports, ".")) mainExport = scope.contents.packageJsonContent.exports["."];
            if (mainExport) {
                const loadModuleFromTargetImportOrExport = getLoadModuleFromTargetImportOrExport(extensions, state, cache, redirectedReference, subpath, scope, /*isImports*/ false);
                return loadModuleFromTargetImportOrExport(mainExport, "", /*pattern*/ false, ".");
            }
        } else if (allKeysStartWithDot(scope.contents.packageJsonContent.exports)) {
            if (typeof scope.contents.packageJsonContent.exports !== "object") {
                if (state.traceEnabled) trace(state.host, Diagnostics.Export_specifier_0_does_not_exist_in_package_json_scope_at_path_1, subpath, scope.packageDirectory);
                return toSearchResult(/*value*/ void 0);
            }
            const result = loadModuleFromImportsOrExports(extensions, state, cache, redirectedReference, subpath, scope.contents.packageJsonContent.exports, scope, /*isImports*/ false);
            if (result) return result;
        }
        if (state.traceEnabled) trace(state.host, Diagnostics.Export_specifier_0_does_not_exist_in_package_json_scope_at_path_1, subpath, scope.packageDirectory);
        return toSearchResult(/*value*/ void 0);
    }
    function loadModuleFromImports(extensions, moduleName, directory, state, cache, redirectedReference) {
        var _a, _b;
        if (moduleName === "#" || startsWith(moduleName, "#/")) {
            if (state.traceEnabled) trace(state.host, Diagnostics.Invalid_import_specifier_0_has_no_possible_resolutions, moduleName);
            return toSearchResult(/*value*/ void 0);
        }
        const directoryPath = getNormalizedAbsolutePath(combinePaths(directory, "dummy"), (_b = (_a = state.host).getCurrentDirectory) == null ? void 0 : _b.call(_a));
        const scope = getPackageScopeForPath(directoryPath, state);
        if (!scope) {
            if (state.traceEnabled) trace(state.host, Diagnostics.Directory_0_has_no_containing_package_json_scope_Imports_will_not_resolve, directoryPath);
            return toSearchResult(/*value*/ void 0);
        }
        if (!scope.contents.packageJsonContent.imports) {
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_no_imports_defined, scope.packageDirectory);
            return toSearchResult(/*value*/ void 0);
        }
        const result = loadModuleFromImportsOrExports(extensions, state, cache, redirectedReference, moduleName, scope.contents.packageJsonContent.imports, scope, /*isImports*/ true);
        if (result) return result;
        if (state.traceEnabled) trace(state.host, Diagnostics.Import_specifier_0_does_not_exist_in_package_json_scope_at_path_1, moduleName, scope.packageDirectory);
        return toSearchResult(/*value*/ void 0);
    }
    function comparePatternKeys(a, b) {
        const aPatternIndex = a.indexOf("*");
        const bPatternIndex = b.indexOf("*");
        const baseLenA = aPatternIndex === -1 ? a.length : aPatternIndex + 1;
        const baseLenB = bPatternIndex === -1 ? b.length : bPatternIndex + 1;
        if (baseLenA > baseLenB) return -1;
        if (baseLenB > baseLenA) return 1;
        if (aPatternIndex === -1) return 1;
        if (bPatternIndex === -1) return -1;
        if (a.length > b.length) return -1;
        if (b.length > a.length) return 1;
        return 0;
    }
    function loadModuleFromImportsOrExports(extensions, state, cache, redirectedReference, moduleName, lookupTable, scope, isImports) {
        const loadModuleFromTargetImportOrExport = getLoadModuleFromTargetImportOrExport(extensions, state, cache, redirectedReference, moduleName, scope, isImports);
        if (!endsWith(moduleName, directorySeparator) && moduleName.indexOf("*") === -1 && hasProperty(lookupTable, moduleName)) {
            const target = lookupTable[moduleName];
            return loadModuleFromTargetImportOrExport(target, /*subpath*/ "", /*pattern*/ false, moduleName);
        }
        const expandingKeys = sort(filter(getOwnKeys(lookupTable), (k)=>k.indexOf("*") !== -1 || endsWith(k, "/")), comparePatternKeys);
        for (const potentialTarget of expandingKeys){
            if (state.features & 16 /* ExportsPatternTrailers */  && matchesPatternWithTrailer(potentialTarget, moduleName)) {
                const target = lookupTable[potentialTarget];
                const starPos = potentialTarget.indexOf("*");
                const subpath = moduleName.substring(potentialTarget.substring(0, starPos).length, moduleName.length - (potentialTarget.length - 1 - starPos));
                return loadModuleFromTargetImportOrExport(target, subpath, /*pattern*/ true, potentialTarget);
            } else if (endsWith(potentialTarget, "*") && startsWith(moduleName, potentialTarget.substring(0, potentialTarget.length - 1))) {
                const target = lookupTable[potentialTarget];
                const subpath = moduleName.substring(potentialTarget.length - 1);
                return loadModuleFromTargetImportOrExport(target, subpath, /*pattern*/ true, potentialTarget);
            } else if (startsWith(moduleName, potentialTarget)) {
                const target = lookupTable[potentialTarget];
                const subpath = moduleName.substring(potentialTarget.length);
                return loadModuleFromTargetImportOrExport(target, subpath, /*pattern*/ false, potentialTarget);
            }
        }
        function matchesPatternWithTrailer(target, name) {
            if (endsWith(target, "*")) return false;
            const starPos = target.indexOf("*");
            if (starPos === -1) return false;
            return startsWith(name, target.substring(0, starPos)) && endsWith(name, target.substring(starPos + 1));
        }
    }
    function getLoadModuleFromTargetImportOrExport(extensions, state, cache, redirectedReference, moduleName, scope, isImports) {
        return loadModuleFromTargetImportOrExport;
        function loadModuleFromTargetImportOrExport(target, subpath, pattern, key) {
            if (typeof target === "string") {
                if (!pattern && subpath.length > 0 && !endsWith(target, "/")) {
                    if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
                    return toSearchResult(/*value*/ void 0);
                }
                if (!startsWith(target, "./")) {
                    if (isImports && !startsWith(target, "../") && !startsWith(target, "/") && !isRootedDiskPath(target)) {
                        const combinedLookup = pattern ? target.replace(/\*/g, subpath) : target + subpath;
                        traceIfEnabled(state, Diagnostics.Using_0_subpath_1_with_target_2, "imports", key, combinedLookup);
                        traceIfEnabled(state, Diagnostics.Resolving_module_0_from_1, combinedLookup, scope.packageDirectory + "/");
                        const result = nodeModuleNameResolverWorker(state.features, combinedLookup, scope.packageDirectory + "/", state.compilerOptions, state.host, cache, extensions, /*isConfigLookup*/ false, redirectedReference);
                        return toSearchResult(result.resolvedModule ? {
                            path: result.resolvedModule.resolvedFileName,
                            extension: result.resolvedModule.extension,
                            packageId: result.resolvedModule.packageId,
                            originalPath: result.resolvedModule.originalPath,
                            resolvedUsingTsExtension: result.resolvedModule.resolvedUsingTsExtension
                        } : void 0);
                    }
                    if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
                    return toSearchResult(/*value*/ void 0);
                }
                const parts = pathIsRelative(target) ? getPathComponents(target).slice(1) : getPathComponents(target);
                const partsAfterFirst = parts.slice(1);
                if (partsAfterFirst.indexOf("..") >= 0 || partsAfterFirst.indexOf(".") >= 0 || partsAfterFirst.indexOf("node_modules") >= 0) {
                    if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
                    return toSearchResult(/*value*/ void 0);
                }
                const resolvedTarget = combinePaths(scope.packageDirectory, target);
                const subpathParts = getPathComponents(subpath);
                if (subpathParts.indexOf("..") >= 0 || subpathParts.indexOf(".") >= 0 || subpathParts.indexOf("node_modules") >= 0) {
                    if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
                    return toSearchResult(/*value*/ void 0);
                }
                if (state.traceEnabled) trace(state.host, Diagnostics.Using_0_subpath_1_with_target_2, isImports ? "imports" : "exports", key, pattern ? target.replace(/\*/g, subpath) : target + subpath);
                const finalPath = toAbsolutePath(pattern ? resolvedTarget.replace(/\*/g, subpath) : resolvedTarget + subpath);
                const inputLink = tryLoadInputFileForPath(finalPath, subpath, combinePaths(scope.packageDirectory, "package.json"), isImports);
                if (inputLink) return inputLink;
                return toSearchResult(withPackageId(scope, loadFileNameFromPackageJsonField(extensions, finalPath, /*onlyRecordFailures*/ false, state)));
            } else if (typeof target === "object" && target !== null) {
                if (!Array.isArray(target)) {
                    traceIfEnabled(state, Diagnostics.Entering_conditional_exports);
                    for (const condition of getOwnKeys(target))if (condition === "default" || state.conditions.indexOf(condition) >= 0 || isApplicableVersionedTypesKey(state.conditions, condition)) {
                        traceIfEnabled(state, Diagnostics.Matched_0_condition_1, isImports ? "imports" : "exports", condition);
                        const subTarget = target[condition];
                        const result = loadModuleFromTargetImportOrExport(subTarget, subpath, pattern, key);
                        if (result) {
                            traceIfEnabled(state, Diagnostics.Resolved_under_condition_0, condition);
                            traceIfEnabled(state, Diagnostics.Exiting_conditional_exports);
                            return result;
                        } else traceIfEnabled(state, Diagnostics.Failed_to_resolve_under_condition_0, condition);
                    } else traceIfEnabled(state, Diagnostics.Saw_non_matching_condition_0, condition);
                    traceIfEnabled(state, Diagnostics.Exiting_conditional_exports);
                    return void 0;
                } else {
                    if (!length(target)) {
                        if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
                        return toSearchResult(/*value*/ void 0);
                    }
                    for (const elem of target){
                        const result = loadModuleFromTargetImportOrExport(elem, subpath, pattern, key);
                        if (result) return result;
                    }
                }
            } else if (target === null) {
                if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_explicitly_maps_specifier_1_to_null, scope.packageDirectory, moduleName);
                return toSearchResult(/*value*/ void 0);
            }
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
            return toSearchResult(/*value*/ void 0);
            function toAbsolutePath(path) {
                var _a, _b;
                if (path === void 0) return path;
                return getNormalizedAbsolutePath(path, (_b = (_a = state.host).getCurrentDirectory) == null ? void 0 : _b.call(_a));
            }
            function combineDirectoryPath(root, dir) {
                return ensureTrailingDirectorySeparator(combinePaths(root, dir));
            }
            function useCaseSensitiveFileNames() {
                return !state.host.useCaseSensitiveFileNames ? true : typeof state.host.useCaseSensitiveFileNames === "boolean" ? state.host.useCaseSensitiveFileNames : state.host.useCaseSensitiveFileNames();
            }
            function tryLoadInputFileForPath(finalPath, entry, packagePath, isImports2) {
                var _a, _b, _c, _d;
                if (!state.isConfigLookup && (state.compilerOptions.declarationDir || state.compilerOptions.outDir) && finalPath.indexOf("/node_modules/") === -1 && (state.compilerOptions.configFile ? containsPath(scope.packageDirectory, toAbsolutePath(state.compilerOptions.configFile.fileName), !useCaseSensitiveFileNames()) : true)) {
                    const getCanonicalFileName = hostGetCanonicalFileName({
                        useCaseSensitiveFileNames: useCaseSensitiveFileNames
                    });
                    const commonSourceDirGuesses = [];
                    if (state.compilerOptions.rootDir || state.compilerOptions.composite && state.compilerOptions.configFilePath) {
                        const commonDir = toAbsolutePath(getCommonSourceDirectory(state.compilerOptions, ()=>[], ((_b = (_a = state.host).getCurrentDirectory) == null ? void 0 : _b.call(_a)) || "", getCanonicalFileName));
                        commonSourceDirGuesses.push(commonDir);
                    } else if (state.requestContainingDirectory) {
                        const requestingFile = toAbsolutePath(combinePaths(state.requestContainingDirectory, "index.ts"));
                        const commonDir = toAbsolutePath(getCommonSourceDirectory(state.compilerOptions, ()=>[
                                requestingFile,
                                toAbsolutePath(packagePath)
                            ], ((_d = (_c = state.host).getCurrentDirectory) == null ? void 0 : _d.call(_c)) || "", getCanonicalFileName));
                        commonSourceDirGuesses.push(commonDir);
                        let fragment = ensureTrailingDirectorySeparator(commonDir);
                        while(fragment && fragment.length > 1){
                            const parts = getPathComponents(fragment);
                            parts.pop();
                            const commonDir2 = getPathFromPathComponents(parts);
                            commonSourceDirGuesses.unshift(commonDir2);
                            fragment = ensureTrailingDirectorySeparator(commonDir2);
                        }
                    }
                    if (commonSourceDirGuesses.length > 1) state.reportDiagnostic(createCompilerDiagnostic(isImports2 ? Diagnostics.The_project_root_is_ambiguous_but_is_required_to_resolve_import_map_entry_0_in_file_1_Supply_the_rootDir_compiler_option_to_disambiguate : Diagnostics.The_project_root_is_ambiguous_but_is_required_to_resolve_export_map_entry_0_in_file_1_Supply_the_rootDir_compiler_option_to_disambiguate, entry === "" ? "." : entry, // replace empty string with `.` - the reverse of the operation done when entries are built - so main entrypoint errors don't look weird
                    packagePath));
                    for (const commonSourceDirGuess of commonSourceDirGuesses){
                        const candidateDirectories = getOutputDirectoriesForBaseDirectory(commonSourceDirGuess);
                        for (const candidateDir of candidateDirectories)if (containsPath(candidateDir, finalPath, !useCaseSensitiveFileNames())) {
                            const pathFragment = finalPath.slice(candidateDir.length + 1);
                            const possibleInputBase = combinePaths(commonSourceDirGuess, pathFragment);
                            const jsAndDtsExtensions = [
                                ".mjs" /* Mjs */ ,
                                ".cjs" /* Cjs */ ,
                                ".js" /* Js */ ,
                                ".json" /* Json */ ,
                                ".d.mts" /* Dmts */ ,
                                ".d.cts" /* Dcts */ ,
                                ".d.ts" /* Dts */ 
                            ];
                            for (const ext of jsAndDtsExtensions)if (fileExtensionIs(possibleInputBase, ext)) {
                                const inputExts = getPossibleOriginalInputExtensionForExtension(possibleInputBase);
                                for (const possibleExt of inputExts){
                                    if (!extensionIsOk(extensions, possibleExt)) continue;
                                    const possibleInputWithInputExtension = changeAnyExtension(possibleInputBase, possibleExt, ext, !useCaseSensitiveFileNames());
                                    if (state.host.fileExists(possibleInputWithInputExtension)) return toSearchResult(withPackageId(scope, loadFileNameFromPackageJsonField(extensions, possibleInputWithInputExtension, /*onlyRecordFailures*/ false, state)));
                                }
                            }
                        }
                    }
                }
                return void 0;
                function getOutputDirectoriesForBaseDirectory(commonSourceDirGuess) {
                    var _a2, _b2;
                    const currentDir = state.compilerOptions.configFile ? ((_b2 = (_a2 = state.host).getCurrentDirectory) == null ? void 0 : _b2.call(_a2)) || "" : commonSourceDirGuess;
                    const candidateDirectories = [];
                    if (state.compilerOptions.declarationDir) candidateDirectories.push(toAbsolutePath(combineDirectoryPath(currentDir, state.compilerOptions.declarationDir)));
                    if (state.compilerOptions.outDir && state.compilerOptions.outDir !== state.compilerOptions.declarationDir) candidateDirectories.push(toAbsolutePath(combineDirectoryPath(currentDir, state.compilerOptions.outDir)));
                    return candidateDirectories;
                }
            }
        }
    }
    function isApplicableVersionedTypesKey(conditions, key) {
        if (conditions.indexOf("types") === -1) return false;
        if (!startsWith(key, "types@")) return false;
        const range = VersionRange.tryParse(key.substring(6));
        if (!range) return false;
        return range.test(version);
    }
    function loadModuleFromNearestNodeModulesDirectory(extensions, moduleName, directory, state, cache, redirectedReference) {
        return loadModuleFromNearestNodeModulesDirectoryWorker(extensions, moduleName, directory, state, /*typesScopeOnly*/ false, cache, redirectedReference);
    }
    function loadModuleFromNearestNodeModulesDirectoryTypesScope(moduleName, directory, state) {
        return loadModuleFromNearestNodeModulesDirectoryWorker(4 /* Declaration */ , moduleName, directory, state, /*typesScopeOnly*/ true, /*cache*/ void 0, /*redirectedReference*/ void 0);
    }
    function loadModuleFromNearestNodeModulesDirectoryWorker(extensions, moduleName, directory, state, typesScopeOnly, cache, redirectedReference) {
        const mode = state.features === 0 ? void 0 : state.features & 32 /* EsmMode */  ? 99 /* ESNext */  : 1 /* CommonJS */ ;
        const priorityExtensions = extensions & 5 /* Declaration */ ;
        const secondaryExtensions = extensions & -6;
        if (priorityExtensions) {
            const result = lookup(priorityExtensions);
            if (result) return result;
        }
        if (secondaryExtensions && !typesScopeOnly) return lookup(secondaryExtensions);
        function lookup(extensions2) {
            return forEachAncestorDirectory(normalizeSlashes(directory), (ancestorDirectory)=>{
                if (getBaseFileName(ancestorDirectory) !== "node_modules") {
                    const resolutionFromCache = tryFindNonRelativeModuleNameInCache(cache, moduleName, mode, ancestorDirectory, redirectedReference, state);
                    if (resolutionFromCache) return resolutionFromCache;
                    return toSearchResult(loadModuleFromImmediateNodeModulesDirectory(extensions2, moduleName, ancestorDirectory, state, typesScopeOnly, cache, redirectedReference));
                }
            });
        }
    }
    function loadModuleFromImmediateNodeModulesDirectory(extensions, moduleName, directory, state, typesScopeOnly, cache, redirectedReference) {
        const nodeModulesFolder = combinePaths(directory, "node_modules");
        const nodeModulesFolderExists = directoryProbablyExists(nodeModulesFolder, state.host);
        if (!nodeModulesFolderExists && state.traceEnabled) trace(state.host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, nodeModulesFolder);
        if (!typesScopeOnly) {
            const packageResult = loadModuleFromSpecificNodeModulesDirectory(extensions, moduleName, nodeModulesFolder, nodeModulesFolderExists, state, cache, redirectedReference);
            if (packageResult) return packageResult;
        }
        if (extensions & 4 /* Declaration */ ) {
            const nodeModulesAtTypes2 = combinePaths(nodeModulesFolder, "@types");
            let nodeModulesAtTypesExists = nodeModulesFolderExists;
            if (nodeModulesFolderExists && !directoryProbablyExists(nodeModulesAtTypes2, state.host)) {
                if (state.traceEnabled) trace(state.host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, nodeModulesAtTypes2);
                nodeModulesAtTypesExists = false;
            }
            return loadModuleFromSpecificNodeModulesDirectory(4 /* Declaration */ , mangleScopedPackageNameWithTrace(moduleName, state), nodeModulesAtTypes2, nodeModulesAtTypesExists, state, cache, redirectedReference);
        }
    }
    function loadModuleFromSpecificNodeModulesDirectory(extensions, moduleName, nodeModulesDirectory, nodeModulesDirectoryExists, state, cache, redirectedReference) {
        var _a, _b;
        const candidate = normalizePath(combinePaths(nodeModulesDirectory, moduleName));
        const { packageName: packageName , rest: rest  } = parsePackageName(moduleName);
        const packageDirectory = combinePaths(nodeModulesDirectory, packageName);
        let rootPackageInfo;
        let packageInfo = getPackageJsonInfo(candidate, !nodeModulesDirectoryExists, state);
        if (rest !== "" && packageInfo && (!(state.features & 8 /* Exports */ ) || !hasProperty(((_a = rootPackageInfo = getPackageJsonInfo(packageDirectory, !nodeModulesDirectoryExists, state)) == null ? void 0 : _a.contents.packageJsonContent) ?? emptyArray, "exports"))) {
            const fromFile = loadModuleFromFile(extensions, candidate, !nodeModulesDirectoryExists, state);
            if (fromFile) return noPackageId(fromFile);
            const fromDirectory = loadNodeModuleFromDirectoryWorker(extensions, candidate, !nodeModulesDirectoryExists, state, packageInfo.contents.packageJsonContent, getVersionPathsOfPackageJsonInfo(packageInfo, state));
            return withPackageId(packageInfo, fromDirectory);
        }
        const loader = (extensions2, candidate2, onlyRecordFailures, state2)=>{
            let pathAndExtension = (rest || !(state2.features & 32 /* EsmMode */ )) && loadModuleFromFile(extensions2, candidate2, onlyRecordFailures, state2) || loadNodeModuleFromDirectoryWorker(extensions2, candidate2, onlyRecordFailures, state2, packageInfo && packageInfo.contents.packageJsonContent, packageInfo && getVersionPathsOfPackageJsonInfo(packageInfo, state2));
            if (!pathAndExtension && packageInfo && (packageInfo.contents.packageJsonContent.exports === void 0 || packageInfo.contents.packageJsonContent.exports === null) && state2.features & 32 /* EsmMode */ ) pathAndExtension = loadModuleFromFile(extensions2, combinePaths(candidate2, "index.js"), onlyRecordFailures, state2);
            return withPackageId(packageInfo, pathAndExtension);
        };
        if (rest !== "") packageInfo = rootPackageInfo ?? getPackageJsonInfo(packageDirectory, !nodeModulesDirectoryExists, state);
        if (packageInfo && packageInfo.contents.packageJsonContent.exports && state.features & 8 /* Exports */ ) return (_b = loadModuleFromExports(packageInfo, extensions, combinePaths(".", rest), state, cache, redirectedReference)) == null ? void 0 : _b.value;
        const versionPaths = rest !== "" && packageInfo ? getVersionPathsOfPackageJsonInfo(packageInfo, state) : void 0;
        if (versionPaths) {
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_has_a_typesVersions_entry_0_that_matches_compiler_version_1_looking_for_a_pattern_to_match_module_name_2, versionPaths.version, version, rest);
            const packageDirectoryExists = nodeModulesDirectoryExists && directoryProbablyExists(packageDirectory, state.host);
            const fromPaths = tryLoadModuleUsingPaths(extensions, rest, packageDirectory, versionPaths.paths, /*pathPatterns*/ void 0, loader, !packageDirectoryExists, state);
            if (fromPaths) return fromPaths.value;
        }
        return loader(extensions, candidate, !nodeModulesDirectoryExists, state);
    }
    function tryLoadModuleUsingPaths(extensions, moduleName, baseDirectory, paths, pathPatterns, loader, onlyRecordFailures, state) {
        pathPatterns || (pathPatterns = tryParsePatterns(paths));
        const matchedPattern = matchPatternOrExact(pathPatterns, moduleName);
        if (matchedPattern) {
            const matchedStar = isString(matchedPattern) ? void 0 : matchedText(matchedPattern, moduleName);
            const matchedPatternText = isString(matchedPattern) ? matchedPattern : patternText(matchedPattern);
            if (state.traceEnabled) trace(state.host, Diagnostics.Module_name_0_matched_pattern_1, moduleName, matchedPatternText);
            const resolved = forEach(paths[matchedPatternText], (subst)=>{
                const path = matchedStar ? subst.replace("*", matchedStar) : subst;
                const candidate = normalizePath(combinePaths(baseDirectory, path));
                if (state.traceEnabled) trace(state.host, Diagnostics.Trying_substitution_0_candidate_module_location_Colon_1, subst, path);
                const extension = tryGetExtensionFromPath2(subst);
                if (extension !== void 0) {
                    const path2 = tryFile(candidate, onlyRecordFailures, state);
                    if (path2 !== void 0) return noPackageId({
                        path: path2,
                        ext: extension,
                        resolvedUsingTsExtension: void 0
                    });
                }
                return loader(extensions, candidate, onlyRecordFailures || !directoryProbablyExists(getDirectoryPath(candidate), state.host), state);
            });
            return {
                value: resolved
            };
        }
    }
    function mangleScopedPackageNameWithTrace(packageName, state) {
        const mangled = mangleScopedPackageName(packageName);
        if (state.traceEnabled && mangled !== packageName) trace(state.host, Diagnostics.Scoped_package_detected_looking_in_0, mangled);
        return mangled;
    }
    function getTypesPackageName(packageName) {
        return `@types/${mangleScopedPackageName(packageName)}`;
    }
    function mangleScopedPackageName(packageName) {
        if (startsWith(packageName, "@")) {
            const replaceSlash = packageName.replace(directorySeparator, mangledScopedPackageSeparator);
            if (replaceSlash !== packageName) return replaceSlash.slice(1);
        }
        return packageName;
    }
    function getPackageNameFromTypesPackageName(mangledName) {
        const withoutAtTypePrefix = removePrefix(mangledName, "@types/");
        if (withoutAtTypePrefix !== mangledName) return unmangleScopedPackageName(withoutAtTypePrefix);
        return mangledName;
    }
    function unmangleScopedPackageName(typesPackageName) {
        return stringContains(typesPackageName, mangledScopedPackageSeparator) ? "@" + typesPackageName.replace(mangledScopedPackageSeparator, directorySeparator) : typesPackageName;
    }
    function tryFindNonRelativeModuleNameInCache(cache, moduleName, mode, containingDirectory, redirectedReference, state) {
        const result = cache && cache.getFromNonRelativeNameCache(moduleName, mode, containingDirectory, redirectedReference);
        if (result) {
            if (state.traceEnabled) trace(state.host, Diagnostics.Resolution_for_module_0_was_found_in_cache_from_location_1, moduleName, containingDirectory);
            state.resultFromCache = result;
            return {
                value: result.resolvedModule && {
                    path: result.resolvedModule.resolvedFileName,
                    originalPath: result.resolvedModule.originalPath || true,
                    extension: result.resolvedModule.extension,
                    packageId: result.resolvedModule.packageId,
                    resolvedUsingTsExtension: result.resolvedModule.resolvedUsingTsExtension
                }
            };
        }
    }
    function classicNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference) {
        const traceEnabled = isTraceEnabled(compilerOptions, host);
        const failedLookupLocations = [];
        const affectingLocations = [];
        const containingDirectory = getDirectoryPath(containingFile);
        const diagnostics = [];
        const state = {
            compilerOptions: compilerOptions,
            host: host,
            traceEnabled: traceEnabled,
            failedLookupLocations: failedLookupLocations,
            affectingLocations: affectingLocations,
            packageJsonInfoCache: cache,
            features: 0 /* None */ ,
            conditions: [],
            requestContainingDirectory: containingDirectory,
            reportDiagnostic: (diag2)=>void diagnostics.push(diag2),
            isConfigLookup: false,
            candidateIsFromPackageJsonField: false
        };
        const resolved = tryResolve(5 /* Declaration */ ) || tryResolve(2 /* JavaScript */  | (compilerOptions.resolveJsonModule ? 8 /* Json */  : 0));
        return createResolvedModuleWithFailedLookupLocationsHandlingSymlink(moduleName, resolved && resolved.value, (resolved == null ? void 0 : resolved.value) && pathContainsNodeModules(resolved.value.path), failedLookupLocations, affectingLocations, diagnostics, state);
        function tryResolve(extensions) {
            const resolvedUsingSettings = tryLoadModuleUsingOptionalResolutionSettings(extensions, moduleName, containingDirectory, loadModuleFromFileNoPackageId, state);
            if (resolvedUsingSettings) return {
                value: resolvedUsingSettings
            };
            if (!isExternalModuleNameRelative(moduleName)) {
                const resolved2 = forEachAncestorDirectory(containingDirectory, (directory)=>{
                    const resolutionFromCache = tryFindNonRelativeModuleNameInCache(cache, moduleName, /*mode*/ void 0, directory, redirectedReference, state);
                    if (resolutionFromCache) return resolutionFromCache;
                    const searchName = normalizePath(combinePaths(directory, moduleName));
                    return toSearchResult(loadModuleFromFileNoPackageId(extensions, searchName, /*onlyRecordFailures*/ false, state));
                });
                if (resolved2) return resolved2;
                if (extensions & 5 /* Declaration */ ) {
                    let resolved3 = loadModuleFromNearestNodeModulesDirectoryTypesScope(moduleName, containingDirectory, state);
                    if (extensions & 4 /* Declaration */ ) resolved3 ?? (resolved3 = resolveFromTypeRoot(moduleName, state));
                    return resolved3;
                }
            } else {
                const candidate = normalizePath(combinePaths(containingDirectory, moduleName));
                return toSearchResult(loadModuleFromFileNoPackageId(extensions, candidate, /*onlyRecordFailures*/ false, state));
            }
        }
    }
    function resolveFromTypeRoot(moduleName, state) {
        if (!state.compilerOptions.typeRoots) return;
        for (const typeRoot of state.compilerOptions.typeRoots){
            const candidate = getCandidateFromTypeRoot(typeRoot, moduleName, state);
            const directoryExists = directoryProbablyExists(typeRoot, state.host);
            if (!directoryExists && state.traceEnabled) trace(state.host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, typeRoot);
            const resolvedFromFile = loadModuleFromFile(4 /* Declaration */ , candidate, !directoryExists, state);
            if (resolvedFromFile) {
                const packageDirectory = parseNodeModuleFromPath(resolvedFromFile.path);
                const packageInfo = packageDirectory ? getPackageJsonInfo(packageDirectory, /*onlyRecordFailures*/ false, state) : void 0;
                return toSearchResult(withPackageId(packageInfo, resolvedFromFile));
            }
            const resolved = loadNodeModuleFromDirectory(4 /* Declaration */ , candidate, !directoryExists, state);
            if (resolved) return toSearchResult(resolved);
        }
    }
    function shouldAllowImportingTsExtension(compilerOptions, fromFileName) {
        return !!compilerOptions.allowImportingTsExtensions || fromFileName && isDeclarationFileName(fromFileName);
    }
    function loadModuleFromGlobalCache(moduleName, projectName, compilerOptions, host, globalCache, packageJsonInfoCache) {
        const traceEnabled = isTraceEnabled(compilerOptions, host);
        if (traceEnabled) trace(host, Diagnostics.Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using_cache_location_2, projectName, moduleName, globalCache);
        const failedLookupLocations = [];
        const affectingLocations = [];
        const diagnostics = [];
        const state = {
            compilerOptions: compilerOptions,
            host: host,
            traceEnabled: traceEnabled,
            failedLookupLocations: failedLookupLocations,
            affectingLocations: affectingLocations,
            packageJsonInfoCache: packageJsonInfoCache,
            features: 0 /* None */ ,
            conditions: [],
            requestContainingDirectory: void 0,
            reportDiagnostic: (diag2)=>void diagnostics.push(diag2),
            isConfigLookup: false,
            candidateIsFromPackageJsonField: false
        };
        const resolved = loadModuleFromImmediateNodeModulesDirectory(4 /* Declaration */ , moduleName, globalCache, state, /*typesScopeOnly*/ false, /*cache*/ void 0, /*redirectedReference*/ void 0);
        return createResolvedModuleWithFailedLookupLocations(resolved, /*isExternalLibraryImport*/ true, failedLookupLocations, affectingLocations, diagnostics, state.resultFromCache);
    }
    function toSearchResult(value1) {
        return value1 !== void 0 ? {
            value: value1
        } : void 0;
    }
    function traceIfEnabled(state, diagnostic, ...args) {
        if (state.traceEnabled) trace(state.host, diagnostic, ...args);
    }
    var typeScriptVersion, nodeModulesAtTypes, NodeResolutionFeatures, nodeModulesPathPart, mangledScopedPackageSeparator;
    var init_moduleNameResolver = __esm({
        "src/compiler/moduleNameResolver.ts" () {
            "use strict";
            init_ts2();
            nodeModulesAtTypes = combinePaths("node_modules", "@types");
            NodeResolutionFeatures = /* @__PURE__ */ ((NodeResolutionFeatures2)=>{
                NodeResolutionFeatures2[NodeResolutionFeatures2["None"] = 0] = "None";
                NodeResolutionFeatures2[NodeResolutionFeatures2["Imports"] = 2] = "Imports";
                NodeResolutionFeatures2[NodeResolutionFeatures2["SelfName"] = 4] = "SelfName";
                NodeResolutionFeatures2[NodeResolutionFeatures2["Exports"] = 8] = "Exports";
                NodeResolutionFeatures2[NodeResolutionFeatures2["ExportsPatternTrailers"] = 16] = "ExportsPatternTrailers";
                NodeResolutionFeatures2[NodeResolutionFeatures2["AllFeatures"] = 30] = "AllFeatures";
                NodeResolutionFeatures2[NodeResolutionFeatures2["Node16Default"] = 30] = "Node16Default";
                NodeResolutionFeatures2[NodeResolutionFeatures2["NodeNextDefault"] = 30 /* AllFeatures */ ] = "NodeNextDefault";
                NodeResolutionFeatures2[NodeResolutionFeatures2["BundlerDefault"] = 30] = "BundlerDefault";
                NodeResolutionFeatures2[NodeResolutionFeatures2["EsmMode"] = 32] = "EsmMode";
                return NodeResolutionFeatures2;
            })(NodeResolutionFeatures || {});
            nodeModulesPathPart = "/node_modules/";
            mangledScopedPackageSeparator = "__";
        }
    });
    // src/compiler/binder.ts
    function getModuleInstanceState(node, visited) {
        if (node.body && !node.body.parent) {
            setParent(node.body, node);
            setParentRecursive(node.body, /*incremental*/ false);
        }
        return node.body ? getModuleInstanceStateCached(node.body, visited) : 1 /* Instantiated */ ;
    }
    function getModuleInstanceStateCached(node, visited = /* @__PURE__ */ new Map()) {
        const nodeId = getNodeId(node);
        if (visited.has(nodeId)) return visited.get(nodeId) || 0 /* NonInstantiated */ ;
        visited.set(nodeId, void 0);
        const result = getModuleInstanceStateWorker(node, visited);
        visited.set(nodeId, result);
        return result;
    }
    function getModuleInstanceStateWorker(node, visited) {
        switch(node.kind){
            case 263 /* InterfaceDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
                return 0 /* NonInstantiated */ ;
            case 265 /* EnumDeclaration */ :
                if (isEnumConst(node)) return 2 /* ConstEnumOnly */ ;
                break;
            case 271 /* ImportDeclaration */ :
            case 270 /* ImportEqualsDeclaration */ :
                if (!hasSyntacticModifier(node, 1 /* Export */ )) return 0 /* NonInstantiated */ ;
                break;
            case 277 /* ExportDeclaration */ :
                const exportDeclaration = node;
                if (!exportDeclaration.moduleSpecifier && exportDeclaration.exportClause && exportDeclaration.exportClause.kind === 278 /* NamedExports */ ) {
                    let state = 0 /* NonInstantiated */ ;
                    for (const specifier of exportDeclaration.exportClause.elements){
                        const specifierState = getModuleInstanceStateForAliasTarget(specifier, visited);
                        if (specifierState > state) state = specifierState;
                        if (state === 1 /* Instantiated */ ) return state;
                    }
                    return state;
                }
                break;
            case 267 /* ModuleBlock */ :
                {
                    let state = 0 /* NonInstantiated */ ;
                    forEachChild(node, (n)=>{
                        const childState = getModuleInstanceStateCached(n, visited);
                        switch(childState){
                            case 0 /* NonInstantiated */ :
                                return;
                            case 2 /* ConstEnumOnly */ :
                                state = 2 /* ConstEnumOnly */ ;
                                return;
                            case 1 /* Instantiated */ :
                                state = 1 /* Instantiated */ ;
                                return true;
                            default:
                                Debug.assertNever(childState);
                        }
                    });
                    return state;
                }
            case 266 /* ModuleDeclaration */ :
                return getModuleInstanceState(node, visited);
            case 80 /* Identifier */ :
                if (node.flags & 2048 /* IdentifierIsInJSDocNamespace */ ) return 0 /* NonInstantiated */ ;
        }
        return 1 /* Instantiated */ ;
    }
    function getModuleInstanceStateForAliasTarget(specifier, visited) {
        const name = specifier.propertyName || specifier.name;
        let p = specifier.parent;
        while(p){
            if (isBlock(p) || isModuleBlock(p) || isSourceFile(p)) {
                const statements = p.statements;
                let found;
                for (const statement of statements)if (nodeHasName(statement, name)) {
                    if (!statement.parent) {
                        setParent(statement, p);
                        setParentRecursive(statement, /*incremental*/ false);
                    }
                    const state = getModuleInstanceStateCached(statement, visited);
                    if (found === void 0 || state > found) found = state;
                    if (found === 1 /* Instantiated */ ) return found;
                }
                if (found !== void 0) return found;
            }
            p = p.parent;
        }
        return 1 /* Instantiated */ ;
    }
    function initFlowNode(node) {
        Debug.attachFlowNodeDebugInfo(node);
        return node;
    }
    function bindSourceFile(file, options) {
        var _a, _b;
        mark("beforeBind");
        (_a = perfLogger) == null || _a.logStartBindFile("" + file.fileName);
        binder(file, options);
        (_b = perfLogger) == null || _b.logStopBindFile();
        mark("afterBind");
        measure("Bind", "beforeBind", "afterBind");
    }
    function createBinder() {
        var file;
        var options;
        var languageVersion;
        var parent2;
        var container;
        var thisParentContainer;
        var blockScopeContainer;
        var lastContainer;
        var delayedTypeAliases;
        var seenThisKeyword;
        var currentFlow;
        var currentBreakTarget;
        var currentContinueTarget;
        var currentReturnTarget;
        var currentTrueTarget;
        var currentFalseTarget;
        var currentExceptionTarget;
        var preSwitchCaseFlow;
        var activeLabelList;
        var hasExplicitReturn;
        var emitFlags;
        var inStrictMode;
        var inAssignmentPattern = false;
        var symbolCount = 0;
        var Symbol47;
        var classifiableNames;
        var unreachableFlow = {
            flags: 1 /* Unreachable */ 
        };
        var reportedUnreachableFlow = {
            flags: 1 /* Unreachable */ 
        };
        var bindBinaryExpressionFlow = createBindBinaryExpressionFlow();
        return bindSourceFile2;
        function createDiagnosticForNode2(node, message, ...args) {
            return createDiagnosticForNodeInSourceFile(getSourceFileOfNode(node) || file, node, message, ...args);
        }
        function bindSourceFile2(f, opts) {
            var _a, _b;
            file = f;
            options = opts;
            languageVersion = getEmitScriptTarget(options);
            inStrictMode = bindInStrictMode(file, opts);
            classifiableNames = /* @__PURE__ */ new Set();
            symbolCount = 0;
            Symbol47 = objectAllocator.getSymbolConstructor();
            Debug.attachFlowNodeDebugInfo(unreachableFlow);
            Debug.attachFlowNodeDebugInfo(reportedUnreachableFlow);
            if (!file.locals) {
                (_a = tracing) == null || _a.push(tracing.Phase.Bind, "bindSourceFile", {
                    path: file.path
                }, /*separateBeginAndEnd*/ true);
                bind(file);
                (_b = tracing) == null || _b.pop();
                file.symbolCount = symbolCount;
                file.classifiableNames = classifiableNames;
                delayedBindJSDocTypedefTag();
            }
            file = void 0;
            options = void 0;
            languageVersion = void 0;
            parent2 = void 0;
            container = void 0;
            thisParentContainer = void 0;
            blockScopeContainer = void 0;
            lastContainer = void 0;
            delayedTypeAliases = void 0;
            seenThisKeyword = false;
            currentFlow = void 0;
            currentBreakTarget = void 0;
            currentContinueTarget = void 0;
            currentReturnTarget = void 0;
            currentTrueTarget = void 0;
            currentFalseTarget = void 0;
            currentExceptionTarget = void 0;
            activeLabelList = void 0;
            hasExplicitReturn = false;
            inAssignmentPattern = false;
            emitFlags = 0 /* None */ ;
        }
        function bindInStrictMode(file2, opts) {
            if (getStrictOptionValue(opts, "alwaysStrict") && !file2.isDeclarationFile) return true;
            else return !!file2.externalModuleIndicator;
        }
        function createSymbol(flags, name) {
            symbolCount++;
            return new Symbol47(flags, name);
        }
        function addDeclarationToSymbol(symbol, node, symbolFlags) {
            symbol.flags |= symbolFlags;
            node.symbol = symbol;
            symbol.declarations = appendIfUnique(symbol.declarations, node);
            if (symbolFlags & 1955 /* Variable */  && !symbol.exports) symbol.exports = createSymbolTable();
            if (symbolFlags & 6240 /* ObjectLiteral */  && !symbol.members) symbol.members = createSymbolTable();
            if (symbol.constEnumOnlyModule && symbol.flags & 304 /* RegularEnum */ ) symbol.constEnumOnlyModule = false;
            if (symbolFlags & 111551 /* Value */ ) setValueDeclaration(symbol, node);
        }
        function getDeclarationName(node) {
            if (node.kind === 276 /* ExportAssignment */ ) return node.isExportEquals ? "export=" /* ExportEquals */  : "default" /* Default */ ;
            const name = getNameOfDeclaration(node);
            if (name) {
                if (isAmbientModule(node)) {
                    const moduleName = getTextOfIdentifierOrLiteral(name);
                    return isGlobalScopeAugmentation(node) ? "__global" : `"${moduleName}"`;
                }
                if (name.kind === 166 /* ComputedPropertyName */ ) {
                    const nameExpression = name.expression;
                    if (isStringOrNumericLiteralLike(nameExpression)) return escapeLeadingUnderscores(nameExpression.text);
                    if (isSignedNumericLiteral(nameExpression)) return tokenToString(nameExpression.operator) + nameExpression.operand.text;
                    else Debug.fail("Only computed properties with literal names have declaration names");
                }
                if (isPrivateIdentifier(name)) {
                    const containingClass = getContainingClass(node);
                    if (!containingClass) return void 0;
                    const containingClassSymbol = containingClass.symbol;
                    return getSymbolNameForPrivateIdentifier(containingClassSymbol, name.escapedText);
                }
                if (isJsxNamespacedName(name)) return getEscapedTextOfJsxNamespacedName(name);
                return isPropertyNameLiteral(name) ? getEscapedTextOfIdentifierOrLiteral(name) : void 0;
            }
            switch(node.kind){
                case 175 /* Constructor */ :
                    return "__constructor" /* Constructor */ ;
                case 183 /* FunctionType */ :
                case 178 /* CallSignature */ :
                case 329 /* JSDocSignature */ :
                    return "__call" /* Call */ ;
                case 184 /* ConstructorType */ :
                case 179 /* ConstructSignature */ :
                    return "__new" /* New */ ;
                case 180 /* IndexSignature */ :
                    return "__index" /* Index */ ;
                case 277 /* ExportDeclaration */ :
                    return "__export" /* ExportStar */ ;
                case 311 /* SourceFile */ :
                    return "export=" /* ExportEquals */ ;
                case 225 /* BinaryExpression */ :
                    if (getAssignmentDeclarationKind(node) === 2 /* ModuleExports */ ) return "export=" /* ExportEquals */ ;
                    Debug.fail("Unknown binary declaration kind");
                    break;
                case 323 /* JSDocFunctionType */ :
                    return isJSDocConstructSignature(node) ? "__new" /* New */  : "__call" /* Call */ ;
                case 168 /* Parameter */ :
                    Debug.assert(node.parent.kind === 323 /* JSDocFunctionType */ , "Impossible parameter parent kind", ()=>`parent is: ${Debug.formatSyntaxKind(node.parent.kind)}, expected JSDocFunctionType`);
                    const functionType = node.parent;
                    const index = functionType.parameters.indexOf(node);
                    return "arg" + index;
            }
        }
        function getDisplayName(node) {
            return isNamedDeclaration(node) ? declarationNameToString(node.name) : unescapeLeadingUnderscores(Debug.checkDefined(getDeclarationName(node)));
        }
        function declareSymbol(symbolTable, parent3, node, includes, excludes, isReplaceableByMethod, isComputedName) {
            Debug.assert(isComputedName || !hasDynamicName(node));
            const isDefaultExport = hasSyntacticModifier(node, 1024 /* Default */ ) || isExportSpecifier(node) && node.name.escapedText === "default";
            const name = isComputedName ? "__computed" /* Computed */  : isDefaultExport && parent3 ? "default" /* Default */  : getDeclarationName(node);
            let symbol;
            if (name === void 0) symbol = createSymbol(0 /* None */ , "__missing" /* Missing */ );
            else {
                symbol = symbolTable.get(name);
                if (includes & 2885600 /* Classifiable */ ) classifiableNames.add(name);
                if (!symbol) {
                    symbolTable.set(name, symbol = createSymbol(0 /* None */ , name));
                    if (isReplaceableByMethod) symbol.isReplaceableByMethod = true;
                } else if (isReplaceableByMethod && !symbol.isReplaceableByMethod) return symbol;
                else if (symbol.flags & excludes) {
                    if (symbol.isReplaceableByMethod) symbolTable.set(name, symbol = createSymbol(0 /* None */ , name));
                    else if (!(includes & 3 /* Variable */  && symbol.flags & 67108864 /* Assignment */ )) {
                        if (isNamedDeclaration(node)) setParent(node.name, node);
                        let message = symbol.flags & 2 /* BlockScopedVariable */  ? Diagnostics.Cannot_redeclare_block_scoped_variable_0 : Diagnostics.Duplicate_identifier_0;
                        let messageNeedsName = true;
                        if (symbol.flags & 384 /* Enum */  || includes & 384 /* Enum */ ) {
                            message = Diagnostics.Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations;
                            messageNeedsName = false;
                        }
                        let multipleDefaultExports = false;
                        if (length(symbol.declarations)) {
                            if (isDefaultExport) {
                                message = Diagnostics.A_module_cannot_have_multiple_default_exports;
                                messageNeedsName = false;
                                multipleDefaultExports = true;
                            } else if (symbol.declarations && symbol.declarations.length && node.kind === 276 /* ExportAssignment */  && !node.isExportEquals) {
                                message = Diagnostics.A_module_cannot_have_multiple_default_exports;
                                messageNeedsName = false;
                                multipleDefaultExports = true;
                            }
                        }
                        const relatedInformation = [];
                        if (isTypeAliasDeclaration(node) && nodeIsMissing(node.type) && hasSyntacticModifier(node, 1 /* Export */ ) && symbol.flags & 2887656 /* Namespace */ ) relatedInformation.push(createDiagnosticForNode2(node, Diagnostics.Did_you_mean_0, `export type { ${unescapeLeadingUnderscores(node.name.escapedText)} }`));
                        const declarationName = getNameOfDeclaration(node) || node;
                        forEach(symbol.declarations, (declaration, index)=>{
                            const decl = getNameOfDeclaration(declaration) || declaration;
                            const diag3 = messageNeedsName ? createDiagnosticForNode2(decl, message, getDisplayName(declaration)) : createDiagnosticForNode2(decl, message);
                            file.bindDiagnostics.push(multipleDefaultExports ? addRelatedInfo(diag3, createDiagnosticForNode2(declarationName, index === 0 ? Diagnostics.Another_export_default_is_here : Diagnostics.and_here)) : diag3);
                            if (multipleDefaultExports) relatedInformation.push(createDiagnosticForNode2(decl, Diagnostics.The_first_export_default_is_here));
                        });
                        const diag2 = messageNeedsName ? createDiagnosticForNode2(declarationName, message, getDisplayName(node)) : createDiagnosticForNode2(declarationName, message);
                        file.bindDiagnostics.push(addRelatedInfo(diag2, ...relatedInformation));
                        symbol = createSymbol(0 /* None */ , name);
                    }
                }
            }
            addDeclarationToSymbol(symbol, node, includes);
            if (symbol.parent) Debug.assert(symbol.parent === parent3, "Existing symbol parent should match new one");
            else symbol.parent = parent3;
            return symbol;
        }
        function declareModuleMember(node, symbolFlags, symbolExcludes) {
            const hasExportModifier = !!(getCombinedModifierFlags(node) & 1 /* Export */ ) || jsdocTreatAsExported(node);
            if (symbolFlags & 2097152 /* Alias */ ) {
                if (node.kind === 280 /* ExportSpecifier */  || node.kind === 270 /* ImportEqualsDeclaration */  && hasExportModifier) return declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
                else {
                    Debug.assertNode(container, canHaveLocals);
                    return declareSymbol(container.locals, /*parent*/ void 0, node, symbolFlags, symbolExcludes);
                }
            } else {
                if (isJSDocTypeAlias(node)) Debug.assert(isInJSFile(node));
                if (!isAmbientModule(node) && (hasExportModifier || container.flags & 64 /* ExportContext */ )) {
                    if (!canHaveLocals(container) || !container.locals || hasSyntacticModifier(node, 1024 /* Default */ ) && !getDeclarationName(node)) return declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
                    const exportKind = symbolFlags & 111551 /* Value */  ? 1048576 /* ExportValue */  : 0;
                    const local = declareSymbol(container.locals, /*parent*/ void 0, node, exportKind, symbolExcludes);
                    local.exportSymbol = declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
                    node.localSymbol = local;
                    return local;
                } else {
                    Debug.assertNode(container, canHaveLocals);
                    return declareSymbol(container.locals, /*parent*/ void 0, node, symbolFlags, symbolExcludes);
                }
            }
        }
        function jsdocTreatAsExported(node) {
            if (node.parent && isModuleDeclaration(node)) node = node.parent;
            if (!isJSDocTypeAlias(node)) return false;
            if (!isJSDocEnumTag(node) && !!node.fullName) return true;
            const declName = getNameOfDeclaration(node);
            if (!declName) return false;
            if (isPropertyAccessEntityNameExpression(declName.parent) && isTopLevelNamespaceAssignment(declName.parent)) return true;
            if (isDeclaration(declName.parent) && getCombinedModifierFlags(declName.parent) & 1 /* Export */ ) return true;
            return false;
        }
        function bindContainer(node, containerFlags) {
            const saveContainer = container;
            const saveThisParentContainer = thisParentContainer;
            const savedBlockScopeContainer = blockScopeContainer;
            if (containerFlags & 1 /* IsContainer */ ) {
                if (node.kind !== 218 /* ArrowFunction */ ) thisParentContainer = container;
                container = blockScopeContainer = node;
                if (containerFlags & 32 /* HasLocals */ ) {
                    container.locals = createSymbolTable();
                    addToContainerChain(container);
                }
            } else if (containerFlags & 2 /* IsBlockScopedContainer */ ) {
                blockScopeContainer = node;
                if (containerFlags & 32 /* HasLocals */ ) blockScopeContainer.locals = void 0;
            }
            if (containerFlags & 4 /* IsControlFlowContainer */ ) {
                const saveCurrentFlow = currentFlow;
                const saveBreakTarget = currentBreakTarget;
                const saveContinueTarget = currentContinueTarget;
                const saveReturnTarget = currentReturnTarget;
                const saveExceptionTarget = currentExceptionTarget;
                const saveActiveLabelList = activeLabelList;
                const saveHasExplicitReturn = hasExplicitReturn;
                const isImmediatelyInvoked = containerFlags & 16 /* IsFunctionExpression */  && !hasSyntacticModifier(node, 512 /* Async */ ) && !node.asteriskToken && !!getImmediatelyInvokedFunctionExpression(node) || node.kind === 174 /* ClassStaticBlockDeclaration */ ;
                if (!isImmediatelyInvoked) {
                    currentFlow = initFlowNode({
                        flags: 2 /* Start */ 
                    });
                    if (containerFlags & 144 /* IsObjectLiteralOrClassExpressionMethodOrAccessor */ ) currentFlow.node = node;
                }
                currentReturnTarget = isImmediatelyInvoked || node.kind === 175 /* Constructor */  || isInJSFile(node) && (node.kind === 261 /* FunctionDeclaration */  || node.kind === 217 /* FunctionExpression */ ) ? createBranchLabel() : void 0;
                currentExceptionTarget = void 0;
                currentBreakTarget = void 0;
                currentContinueTarget = void 0;
                activeLabelList = void 0;
                hasExplicitReturn = false;
                bindChildren(node);
                node.flags &= -2817 /* ReachabilityAndEmitFlags */ ;
                if (!(currentFlow.flags & 1 /* Unreachable */ ) && containerFlags & 8 /* IsFunctionLike */  && nodeIsPresent(node.body)) {
                    node.flags |= 256 /* HasImplicitReturn */ ;
                    if (hasExplicitReturn) node.flags |= 512 /* HasExplicitReturn */ ;
                    node.endFlowNode = currentFlow;
                }
                if (node.kind === 311 /* SourceFile */ ) {
                    node.flags |= emitFlags;
                    node.endFlowNode = currentFlow;
                }
                if (currentReturnTarget) {
                    addAntecedent(currentReturnTarget, currentFlow);
                    currentFlow = finishFlowLabel(currentReturnTarget);
                    if (node.kind === 175 /* Constructor */  || node.kind === 174 /* ClassStaticBlockDeclaration */  || isInJSFile(node) && (node.kind === 261 /* FunctionDeclaration */  || node.kind === 217 /* FunctionExpression */ )) node.returnFlowNode = currentFlow;
                }
                if (!isImmediatelyInvoked) currentFlow = saveCurrentFlow;
                currentBreakTarget = saveBreakTarget;
                currentContinueTarget = saveContinueTarget;
                currentReturnTarget = saveReturnTarget;
                currentExceptionTarget = saveExceptionTarget;
                activeLabelList = saveActiveLabelList;
                hasExplicitReturn = saveHasExplicitReturn;
            } else if (containerFlags & 64 /* IsInterface */ ) {
                seenThisKeyword = false;
                bindChildren(node);
                Debug.assertNotNode(node, isIdentifier);
                node.flags = seenThisKeyword ? node.flags | 128 /* ContainsThis */  : node.flags & -129 /* ContainsThis */ ;
            } else bindChildren(node);
            container = saveContainer;
            thisParentContainer = saveThisParentContainer;
            blockScopeContainer = savedBlockScopeContainer;
        }
        function bindEachFunctionsFirst(nodes) {
            bindEach(nodes, (n)=>n.kind === 261 /* FunctionDeclaration */  ? bind(n) : void 0);
            bindEach(nodes, (n)=>n.kind !== 261 /* FunctionDeclaration */  ? bind(n) : void 0);
        }
        function bindEach(nodes, bindFunction = bind) {
            if (nodes === void 0) return;
            forEach(nodes, bindFunction);
        }
        function bindEachChild(node) {
            forEachChild(node, bind, bindEach);
        }
        function bindChildren(node) {
            const saveInAssignmentPattern = inAssignmentPattern;
            inAssignmentPattern = false;
            if (checkUnreachable(node)) {
                bindEachChild(node);
                bindJSDoc(node);
                inAssignmentPattern = saveInAssignmentPattern;
                return;
            }
            if (node.kind >= 242 /* FirstStatement */  && node.kind <= 258 /* LastStatement */  && !options.allowUnreachableCode) node.flowNode = currentFlow;
            switch(node.kind){
                case 246 /* WhileStatement */ :
                    bindWhileStatement(node);
                    break;
                case 245 /* DoStatement */ :
                    bindDoStatement(node);
                    break;
                case 247 /* ForStatement */ :
                    bindForStatement(node);
                    break;
                case 248 /* ForInStatement */ :
                case 249 /* ForOfStatement */ :
                    bindForInOrForOfStatement(node);
                    break;
                case 244 /* IfStatement */ :
                    bindIfStatement(node);
                    break;
                case 252 /* ReturnStatement */ :
                case 256 /* ThrowStatement */ :
                    bindReturnOrThrow(node);
                    break;
                case 251 /* BreakStatement */ :
                case 250 /* ContinueStatement */ :
                    bindBreakOrContinueStatement(node);
                    break;
                case 257 /* TryStatement */ :
                    bindTryStatement(node);
                    break;
                case 254 /* SwitchStatement */ :
                    bindSwitchStatement(node);
                    break;
                case 268 /* CaseBlock */ :
                    bindCaseBlock(node);
                    break;
                case 295 /* CaseClause */ :
                    bindCaseClause(node);
                    break;
                case 243 /* ExpressionStatement */ :
                    bindExpressionStatement(node);
                    break;
                case 255 /* LabeledStatement */ :
                    bindLabeledStatement(node);
                    break;
                case 223 /* PrefixUnaryExpression */ :
                    bindPrefixUnaryExpressionFlow(node);
                    break;
                case 224 /* PostfixUnaryExpression */ :
                    bindPostfixUnaryExpressionFlow(node);
                    break;
                case 225 /* BinaryExpression */ :
                    if (isDestructuringAssignment(node)) {
                        inAssignmentPattern = saveInAssignmentPattern;
                        bindDestructuringAssignmentFlow(node);
                        return;
                    }
                    bindBinaryExpressionFlow(node);
                    break;
                case 219 /* DeleteExpression */ :
                    bindDeleteExpressionFlow(node);
                    break;
                case 226 /* ConditionalExpression */ :
                    bindConditionalExpressionFlow(node);
                    break;
                case 259 /* VariableDeclaration */ :
                    bindVariableDeclarationFlow(node);
                    break;
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    bindAccessExpressionFlow(node);
                    break;
                case 212 /* CallExpression */ :
                    bindCallExpressionFlow(node);
                    break;
                case 234 /* NonNullExpression */ :
                    bindNonNullExpressionFlow(node);
                    break;
                case 352 /* JSDocTypedefTag */ :
                case 344 /* JSDocCallbackTag */ :
                case 346 /* JSDocEnumTag */ :
                    bindJSDocTypeAlias(node);
                    break;
                case 311 /* SourceFile */ :
                    bindEachFunctionsFirst(node.statements);
                    bind(node.endOfFileToken);
                    break;
                case 240 /* Block */ :
                case 267 /* ModuleBlock */ :
                    bindEachFunctionsFirst(node.statements);
                    break;
                case 207 /* BindingElement */ :
                    bindBindingElementFlow(node);
                    break;
                case 168 /* Parameter */ :
                    bindParameterFlow(node);
                    break;
                case 209 /* ObjectLiteralExpression */ :
                case 208 /* ArrayLiteralExpression */ :
                case 302 /* PropertyAssignment */ :
                case 229 /* SpreadElement */ :
                    inAssignmentPattern = saveInAssignmentPattern;
                default:
                    bindEachChild(node);
                    break;
            }
            bindJSDoc(node);
            inAssignmentPattern = saveInAssignmentPattern;
        }
        function isNarrowingExpression(expr) {
            switch(expr.kind){
                case 80 /* Identifier */ :
                case 81 /* PrivateIdentifier */ :
                case 110 /* ThisKeyword */ :
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    return containsNarrowableReference(expr);
                case 212 /* CallExpression */ :
                    return hasNarrowableArgument(expr);
                case 216 /* ParenthesizedExpression */ :
                case 234 /* NonNullExpression */ :
                    return isNarrowingExpression(expr.expression);
                case 225 /* BinaryExpression */ :
                    return isNarrowingBinaryExpression(expr);
                case 223 /* PrefixUnaryExpression */ :
                    return expr.operator === 54 /* ExclamationToken */  && isNarrowingExpression(expr.operand);
                case 220 /* TypeOfExpression */ :
                    return isNarrowingExpression(expr.expression);
            }
            return false;
        }
        function isNarrowableReference(expr) {
            return isDottedName(expr) || (isPropertyAccessExpression(expr) || isNonNullExpression(expr) || isParenthesizedExpression(expr)) && isNarrowableReference(expr.expression) || isBinaryExpression(expr) && expr.operatorToken.kind === 28 /* CommaToken */  && isNarrowableReference(expr.right) || isElementAccessExpression(expr) && (isStringOrNumericLiteralLike(expr.argumentExpression) || isEntityNameExpression(expr.argumentExpression)) && isNarrowableReference(expr.expression) || isAssignmentExpression(expr) && isNarrowableReference(expr.left);
        }
        function containsNarrowableReference(expr) {
            return isNarrowableReference(expr) || isOptionalChain(expr) && containsNarrowableReference(expr.expression);
        }
        function hasNarrowableArgument(expr) {
            if (expr.arguments) for (const argument of expr.arguments){
                if (containsNarrowableReference(argument)) return true;
            }
            if (expr.expression.kind === 210 /* PropertyAccessExpression */  && containsNarrowableReference(expr.expression.expression)) return true;
            return false;
        }
        function isNarrowingTypeofOperands(expr1, expr2) {
            return isTypeOfExpression(expr1) && isNarrowableOperand(expr1.expression) && isStringLiteralLike(expr2);
        }
        function isNarrowingBinaryExpression(expr) {
            switch(expr.operatorToken.kind){
                case 64 /* EqualsToken */ :
                case 76 /* BarBarEqualsToken */ :
                case 77 /* AmpersandAmpersandEqualsToken */ :
                case 78 /* QuestionQuestionEqualsToken */ :
                    return containsNarrowableReference(expr.left);
                case 35 /* EqualsEqualsToken */ :
                case 36 /* ExclamationEqualsToken */ :
                case 37 /* EqualsEqualsEqualsToken */ :
                case 38 /* ExclamationEqualsEqualsToken */ :
                    return isNarrowableOperand(expr.left) || isNarrowableOperand(expr.right) || isNarrowingTypeofOperands(expr.right, expr.left) || isNarrowingTypeofOperands(expr.left, expr.right);
                case 104 /* InstanceOfKeyword */ :
                    return isNarrowableOperand(expr.left);
                case 103 /* InKeyword */ :
                    return isNarrowingExpression(expr.right);
                case 28 /* CommaToken */ :
                    return isNarrowingExpression(expr.right);
            }
            return false;
        }
        function isNarrowableOperand(expr) {
            switch(expr.kind){
                case 216 /* ParenthesizedExpression */ :
                    return isNarrowableOperand(expr.expression);
                case 225 /* BinaryExpression */ :
                    switch(expr.operatorToken.kind){
                        case 64 /* EqualsToken */ :
                            return isNarrowableOperand(expr.left);
                        case 28 /* CommaToken */ :
                            return isNarrowableOperand(expr.right);
                    }
            }
            return containsNarrowableReference(expr);
        }
        function createBranchLabel() {
            return initFlowNode({
                flags: 4 /* BranchLabel */ ,
                antecedents: void 0
            });
        }
        function createLoopLabel() {
            return initFlowNode({
                flags: 8 /* LoopLabel */ ,
                antecedents: void 0
            });
        }
        function createReduceLabel(target, antecedents, antecedent) {
            return initFlowNode({
                flags: 1024 /* ReduceLabel */ ,
                target: target,
                antecedents: antecedents,
                antecedent: antecedent
            });
        }
        function setFlowNodeReferenced(flow) {
            flow.flags |= flow.flags & 2048 /* Referenced */  ? 4096 /* Shared */  : 2048 /* Referenced */ ;
        }
        function addAntecedent(label, antecedent) {
            if (!(antecedent.flags & 1 /* Unreachable */ ) && !contains(label.antecedents, antecedent)) {
                (label.antecedents || (label.antecedents = [])).push(antecedent);
                setFlowNodeReferenced(antecedent);
            }
        }
        function createFlowCondition(flags, antecedent, expression) {
            if (antecedent.flags & 1 /* Unreachable */ ) return antecedent;
            if (!expression) return flags & 32 /* TrueCondition */  ? antecedent : unreachableFlow;
            if ((expression.kind === 112 /* TrueKeyword */  && flags & 64 /* FalseCondition */  || expression.kind === 97 /* FalseKeyword */  && flags & 32 /* TrueCondition */ ) && !isExpressionOfOptionalChainRoot(expression) && !isNullishCoalesce(expression.parent)) return unreachableFlow;
            if (!isNarrowingExpression(expression)) return antecedent;
            setFlowNodeReferenced(antecedent);
            return initFlowNode({
                flags: flags,
                antecedent: antecedent,
                node: expression
            });
        }
        function createFlowSwitchClause(antecedent, switchStatement, clauseStart, clauseEnd) {
            setFlowNodeReferenced(antecedent);
            return initFlowNode({
                flags: 128 /* SwitchClause */ ,
                antecedent: antecedent,
                switchStatement: switchStatement,
                clauseStart: clauseStart,
                clauseEnd: clauseEnd
            });
        }
        function createFlowMutation(flags, antecedent, node) {
            setFlowNodeReferenced(antecedent);
            const result = initFlowNode({
                flags: flags,
                antecedent: antecedent,
                node: node
            });
            if (currentExceptionTarget) addAntecedent(currentExceptionTarget, result);
            return result;
        }
        function createFlowCall(antecedent, node) {
            setFlowNodeReferenced(antecedent);
            return initFlowNode({
                flags: 512 /* Call */ ,
                antecedent: antecedent,
                node: node
            });
        }
        function finishFlowLabel(flow) {
            const antecedents = flow.antecedents;
            if (!antecedents) return unreachableFlow;
            if (antecedents.length === 1) return antecedents[0];
            return flow;
        }
        function isStatementCondition(node) {
            const parent3 = node.parent;
            switch(parent3.kind){
                case 244 /* IfStatement */ :
                case 246 /* WhileStatement */ :
                case 245 /* DoStatement */ :
                    return parent3.expression === node;
                case 247 /* ForStatement */ :
                case 226 /* ConditionalExpression */ :
                    return parent3.condition === node;
            }
            return false;
        }
        function isLogicalExpression(node) {
            while(true){
                if (node.kind === 216 /* ParenthesizedExpression */ ) node = node.expression;
                else if (node.kind === 223 /* PrefixUnaryExpression */  && node.operator === 54 /* ExclamationToken */ ) node = node.operand;
                else return isLogicalOrCoalescingBinaryExpression(node);
            }
        }
        function isLogicalAssignmentExpression(node) {
            return isLogicalOrCoalescingAssignmentExpression(skipParentheses(node));
        }
        function isTopLevelLogicalExpression(node) {
            while(isParenthesizedExpression(node.parent) || isPrefixUnaryExpression(node.parent) && node.parent.operator === 54 /* ExclamationToken */ )node = node.parent;
            return !isStatementCondition(node) && !isLogicalExpression(node.parent) && !(isOptionalChain(node.parent) && node.parent.expression === node);
        }
        function doWithConditionalBranches(action, value1, trueTarget, falseTarget) {
            const savedTrueTarget = currentTrueTarget;
            const savedFalseTarget = currentFalseTarget;
            currentTrueTarget = trueTarget;
            currentFalseTarget = falseTarget;
            action(value1);
            currentTrueTarget = savedTrueTarget;
            currentFalseTarget = savedFalseTarget;
        }
        function bindCondition(node, trueTarget, falseTarget) {
            doWithConditionalBranches(bind, node, trueTarget, falseTarget);
            if (!node || !isLogicalAssignmentExpression(node) && !isLogicalExpression(node) && !(isOptionalChain(node) && isOutermostOptionalChain(node))) {
                addAntecedent(trueTarget, createFlowCondition(32 /* TrueCondition */ , currentFlow, node));
                addAntecedent(falseTarget, createFlowCondition(64 /* FalseCondition */ , currentFlow, node));
            }
        }
        function bindIterativeStatement(node, breakTarget, continueTarget) {
            const saveBreakTarget = currentBreakTarget;
            const saveContinueTarget = currentContinueTarget;
            currentBreakTarget = breakTarget;
            currentContinueTarget = continueTarget;
            bind(node);
            currentBreakTarget = saveBreakTarget;
            currentContinueTarget = saveContinueTarget;
        }
        function setContinueTarget(node, target) {
            let label = activeLabelList;
            while(label && node.parent.kind === 255 /* LabeledStatement */ ){
                label.continueTarget = target;
                label = label.next;
                node = node.parent;
            }
            return target;
        }
        function bindWhileStatement(node) {
            const preWhileLabel = setContinueTarget(node, createLoopLabel());
            const preBodyLabel = createBranchLabel();
            const postWhileLabel = createBranchLabel();
            addAntecedent(preWhileLabel, currentFlow);
            currentFlow = preWhileLabel;
            bindCondition(node.expression, preBodyLabel, postWhileLabel);
            currentFlow = finishFlowLabel(preBodyLabel);
            bindIterativeStatement(node.statement, postWhileLabel, preWhileLabel);
            addAntecedent(preWhileLabel, currentFlow);
            currentFlow = finishFlowLabel(postWhileLabel);
        }
        function bindDoStatement(node) {
            const preDoLabel = createLoopLabel();
            const preConditionLabel = setContinueTarget(node, createBranchLabel());
            const postDoLabel = createBranchLabel();
            addAntecedent(preDoLabel, currentFlow);
            currentFlow = preDoLabel;
            bindIterativeStatement(node.statement, postDoLabel, preConditionLabel);
            addAntecedent(preConditionLabel, currentFlow);
            currentFlow = finishFlowLabel(preConditionLabel);
            bindCondition(node.expression, preDoLabel, postDoLabel);
            currentFlow = finishFlowLabel(postDoLabel);
        }
        function bindForStatement(node) {
            const preLoopLabel = setContinueTarget(node, createLoopLabel());
            const preBodyLabel = createBranchLabel();
            const postLoopLabel = createBranchLabel();
            bind(node.initializer);
            addAntecedent(preLoopLabel, currentFlow);
            currentFlow = preLoopLabel;
            bindCondition(node.condition, preBodyLabel, postLoopLabel);
            currentFlow = finishFlowLabel(preBodyLabel);
            bindIterativeStatement(node.statement, postLoopLabel, preLoopLabel);
            bind(node.incrementor);
            addAntecedent(preLoopLabel, currentFlow);
            currentFlow = finishFlowLabel(postLoopLabel);
        }
        function bindForInOrForOfStatement(node) {
            const preLoopLabel = setContinueTarget(node, createLoopLabel());
            const postLoopLabel = createBranchLabel();
            bind(node.expression);
            addAntecedent(preLoopLabel, currentFlow);
            currentFlow = preLoopLabel;
            if (node.kind === 249 /* ForOfStatement */ ) bind(node.awaitModifier);
            addAntecedent(postLoopLabel, currentFlow);
            bind(node.initializer);
            if (node.initializer.kind !== 260 /* VariableDeclarationList */ ) bindAssignmentTargetFlow(node.initializer);
            bindIterativeStatement(node.statement, postLoopLabel, preLoopLabel);
            addAntecedent(preLoopLabel, currentFlow);
            currentFlow = finishFlowLabel(postLoopLabel);
        }
        function bindIfStatement(node) {
            const thenLabel = createBranchLabel();
            const elseLabel = createBranchLabel();
            const postIfLabel = createBranchLabel();
            bindCondition(node.expression, thenLabel, elseLabel);
            currentFlow = finishFlowLabel(thenLabel);
            bind(node.thenStatement);
            addAntecedent(postIfLabel, currentFlow);
            currentFlow = finishFlowLabel(elseLabel);
            bind(node.elseStatement);
            addAntecedent(postIfLabel, currentFlow);
            currentFlow = finishFlowLabel(postIfLabel);
        }
        function bindReturnOrThrow(node) {
            bind(node.expression);
            if (node.kind === 252 /* ReturnStatement */ ) {
                hasExplicitReturn = true;
                if (currentReturnTarget) addAntecedent(currentReturnTarget, currentFlow);
            }
            currentFlow = unreachableFlow;
        }
        function findActiveLabel(name) {
            for(let label = activeLabelList; label; label = label.next){
                if (label.name === name) return label;
            }
            return void 0;
        }
        function bindBreakOrContinueFlow(node, breakTarget, continueTarget) {
            const flowLabel = node.kind === 251 /* BreakStatement */  ? breakTarget : continueTarget;
            if (flowLabel) {
                addAntecedent(flowLabel, currentFlow);
                currentFlow = unreachableFlow;
            }
        }
        function bindBreakOrContinueStatement(node) {
            bind(node.label);
            if (node.label) {
                const activeLabel = findActiveLabel(node.label.escapedText);
                if (activeLabel) {
                    activeLabel.referenced = true;
                    bindBreakOrContinueFlow(node, activeLabel.breakTarget, activeLabel.continueTarget);
                }
            } else bindBreakOrContinueFlow(node, currentBreakTarget, currentContinueTarget);
        }
        function bindTryStatement(node) {
            const saveReturnTarget = currentReturnTarget;
            const saveExceptionTarget = currentExceptionTarget;
            const normalExitLabel = createBranchLabel();
            const returnLabel = createBranchLabel();
            let exceptionLabel = createBranchLabel();
            if (node.finallyBlock) currentReturnTarget = returnLabel;
            addAntecedent(exceptionLabel, currentFlow);
            currentExceptionTarget = exceptionLabel;
            bind(node.tryBlock);
            addAntecedent(normalExitLabel, currentFlow);
            if (node.catchClause) {
                currentFlow = finishFlowLabel(exceptionLabel);
                exceptionLabel = createBranchLabel();
                addAntecedent(exceptionLabel, currentFlow);
                currentExceptionTarget = exceptionLabel;
                bind(node.catchClause);
                addAntecedent(normalExitLabel, currentFlow);
            }
            currentReturnTarget = saveReturnTarget;
            currentExceptionTarget = saveExceptionTarget;
            if (node.finallyBlock) {
                const finallyLabel = createBranchLabel();
                finallyLabel.antecedents = concatenate(concatenate(normalExitLabel.antecedents, exceptionLabel.antecedents), returnLabel.antecedents);
                currentFlow = finallyLabel;
                bind(node.finallyBlock);
                if (currentFlow.flags & 1 /* Unreachable */ ) currentFlow = unreachableFlow;
                else {
                    if (currentReturnTarget && returnLabel.antecedents) addAntecedent(currentReturnTarget, createReduceLabel(finallyLabel, returnLabel.antecedents, currentFlow));
                    if (currentExceptionTarget && exceptionLabel.antecedents) addAntecedent(currentExceptionTarget, createReduceLabel(finallyLabel, exceptionLabel.antecedents, currentFlow));
                    currentFlow = normalExitLabel.antecedents ? createReduceLabel(finallyLabel, normalExitLabel.antecedents, currentFlow) : unreachableFlow;
                }
            } else currentFlow = finishFlowLabel(normalExitLabel);
        }
        function bindSwitchStatement(node) {
            const postSwitchLabel = createBranchLabel();
            bind(node.expression);
            const saveBreakTarget = currentBreakTarget;
            const savePreSwitchCaseFlow = preSwitchCaseFlow;
            currentBreakTarget = postSwitchLabel;
            preSwitchCaseFlow = currentFlow;
            bind(node.caseBlock);
            addAntecedent(postSwitchLabel, currentFlow);
            const hasDefault = forEach(node.caseBlock.clauses, (c)=>c.kind === 296 /* DefaultClause */ );
            node.possiblyExhaustive = !hasDefault && !postSwitchLabel.antecedents;
            if (!hasDefault) addAntecedent(postSwitchLabel, createFlowSwitchClause(preSwitchCaseFlow, node, 0, 0));
            currentBreakTarget = saveBreakTarget;
            preSwitchCaseFlow = savePreSwitchCaseFlow;
            currentFlow = finishFlowLabel(postSwitchLabel);
        }
        function bindCaseBlock(node) {
            const clauses = node.clauses;
            const isNarrowingSwitch = isNarrowingExpression(node.parent.expression);
            let fallthroughFlow = unreachableFlow;
            for(let i = 0; i < clauses.length; i++){
                const clauseStart = i;
                while(!clauses[i].statements.length && i + 1 < clauses.length){
                    bind(clauses[i]);
                    i++;
                }
                const preCaseLabel = createBranchLabel();
                addAntecedent(preCaseLabel, isNarrowingSwitch ? createFlowSwitchClause(preSwitchCaseFlow, node.parent, clauseStart, i + 1) : preSwitchCaseFlow);
                addAntecedent(preCaseLabel, fallthroughFlow);
                currentFlow = finishFlowLabel(preCaseLabel);
                const clause = clauses[i];
                bind(clause);
                fallthroughFlow = currentFlow;
                if (!(currentFlow.flags & 1 /* Unreachable */ ) && i !== clauses.length - 1 && options.noFallthroughCasesInSwitch) clause.fallthroughFlowNode = currentFlow;
            }
        }
        function bindCaseClause(node) {
            const saveCurrentFlow = currentFlow;
            currentFlow = preSwitchCaseFlow;
            bind(node.expression);
            currentFlow = saveCurrentFlow;
            bindEach(node.statements);
        }
        function bindExpressionStatement(node) {
            bind(node.expression);
            maybeBindExpressionFlowIfCall(node.expression);
        }
        function maybeBindExpressionFlowIfCall(node) {
            if (node.kind === 212 /* CallExpression */ ) {
                const call = node;
                if (call.expression.kind !== 108 /* SuperKeyword */  && isDottedName(call.expression)) currentFlow = createFlowCall(currentFlow, call);
            }
        }
        function bindLabeledStatement(node) {
            const postStatementLabel = createBranchLabel();
            activeLabelList = {
                next: activeLabelList,
                name: node.label.escapedText,
                breakTarget: postStatementLabel,
                continueTarget: void 0,
                referenced: false
            };
            bind(node.label);
            bind(node.statement);
            if (!activeLabelList.referenced && !options.allowUnusedLabels) errorOrSuggestionOnNode(unusedLabelIsError(options), node.label, Diagnostics.Unused_label);
            activeLabelList = activeLabelList.next;
            addAntecedent(postStatementLabel, currentFlow);
            currentFlow = finishFlowLabel(postStatementLabel);
        }
        function bindDestructuringTargetFlow(node) {
            if (node.kind === 225 /* BinaryExpression */  && node.operatorToken.kind === 64 /* EqualsToken */ ) bindAssignmentTargetFlow(node.left);
            else bindAssignmentTargetFlow(node);
        }
        function bindAssignmentTargetFlow(node) {
            if (isNarrowableReference(node)) currentFlow = createFlowMutation(16 /* Assignment */ , currentFlow, node);
            else if (node.kind === 208 /* ArrayLiteralExpression */ ) {
                for (const e of node.elements)if (e.kind === 229 /* SpreadElement */ ) bindAssignmentTargetFlow(e.expression);
                else bindDestructuringTargetFlow(e);
            } else if (node.kind === 209 /* ObjectLiteralExpression */ ) for (const p of node.properties){
                if (p.kind === 302 /* PropertyAssignment */ ) bindDestructuringTargetFlow(p.initializer);
                else if (p.kind === 303 /* ShorthandPropertyAssignment */ ) bindAssignmentTargetFlow(p.name);
                else if (p.kind === 304 /* SpreadAssignment */ ) bindAssignmentTargetFlow(p.expression);
            }
        }
        function bindLogicalLikeExpression(node, trueTarget, falseTarget) {
            const preRightLabel = createBranchLabel();
            if (node.operatorToken.kind === 56 /* AmpersandAmpersandToken */  || node.operatorToken.kind === 77 /* AmpersandAmpersandEqualsToken */ ) bindCondition(node.left, preRightLabel, falseTarget);
            else bindCondition(node.left, trueTarget, preRightLabel);
            currentFlow = finishFlowLabel(preRightLabel);
            bind(node.operatorToken);
            if (isLogicalOrCoalescingAssignmentOperator(node.operatorToken.kind)) {
                doWithConditionalBranches(bind, node.right, trueTarget, falseTarget);
                bindAssignmentTargetFlow(node.left);
                addAntecedent(trueTarget, createFlowCondition(32 /* TrueCondition */ , currentFlow, node));
                addAntecedent(falseTarget, createFlowCondition(64 /* FalseCondition */ , currentFlow, node));
            } else bindCondition(node.right, trueTarget, falseTarget);
        }
        function bindPrefixUnaryExpressionFlow(node) {
            if (node.operator === 54 /* ExclamationToken */ ) {
                const saveTrueTarget = currentTrueTarget;
                currentTrueTarget = currentFalseTarget;
                currentFalseTarget = saveTrueTarget;
                bindEachChild(node);
                currentFalseTarget = currentTrueTarget;
                currentTrueTarget = saveTrueTarget;
            } else {
                bindEachChild(node);
                if (node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) bindAssignmentTargetFlow(node.operand);
            }
        }
        function bindPostfixUnaryExpressionFlow(node) {
            bindEachChild(node);
            if (node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) bindAssignmentTargetFlow(node.operand);
        }
        function bindDestructuringAssignmentFlow(node) {
            if (inAssignmentPattern) {
                inAssignmentPattern = false;
                bind(node.operatorToken);
                bind(node.right);
                inAssignmentPattern = true;
                bind(node.left);
            } else {
                inAssignmentPattern = true;
                bind(node.left);
                inAssignmentPattern = false;
                bind(node.operatorToken);
                bind(node.right);
            }
            bindAssignmentTargetFlow(node.left);
        }
        function createBindBinaryExpressionFlow() {
            return createBinaryExpressionTrampoline(onEnter, onLeft, onOperator, onRight, onExit, /*foldState*/ void 0);
            function onEnter(node, state) {
                if (state) {
                    state.stackIndex++;
                    setParent(node, parent2);
                    const saveInStrictMode = inStrictMode;
                    bindWorker(node);
                    const saveParent = parent2;
                    parent2 = node;
                    state.skip = false;
                    state.inStrictModeStack[state.stackIndex] = saveInStrictMode;
                    state.parentStack[state.stackIndex] = saveParent;
                } else state = {
                    stackIndex: 0,
                    skip: false,
                    inStrictModeStack: [
                        void 0
                    ],
                    parentStack: [
                        void 0
                    ]
                };
                const operator = node.operatorToken.kind;
                if (isLogicalOrCoalescingBinaryOperator(operator) || isLogicalOrCoalescingAssignmentOperator(operator)) {
                    if (isTopLevelLogicalExpression(node)) {
                        const postExpressionLabel = createBranchLabel();
                        bindLogicalLikeExpression(node, postExpressionLabel, postExpressionLabel);
                        currentFlow = finishFlowLabel(postExpressionLabel);
                    } else bindLogicalLikeExpression(node, currentTrueTarget, currentFalseTarget);
                    state.skip = true;
                }
                return state;
            }
            function onLeft(left, state, node) {
                if (!state.skip) {
                    const maybeBound = maybeBind2(left);
                    if (node.operatorToken.kind === 28 /* CommaToken */ ) maybeBindExpressionFlowIfCall(left);
                    return maybeBound;
                }
            }
            function onOperator(operatorToken, state, _node) {
                if (!state.skip) bind(operatorToken);
            }
            function onRight(right, state, node) {
                if (!state.skip) {
                    const maybeBound = maybeBind2(right);
                    if (node.operatorToken.kind === 28 /* CommaToken */ ) maybeBindExpressionFlowIfCall(right);
                    return maybeBound;
                }
            }
            function onExit(node, state) {
                if (!state.skip) {
                    const operator = node.operatorToken.kind;
                    if (isAssignmentOperator(operator) && !isAssignmentTarget(node)) {
                        bindAssignmentTargetFlow(node.left);
                        if (operator === 64 /* EqualsToken */  && node.left.kind === 211 /* ElementAccessExpression */ ) {
                            const elementAccess = node.left;
                            if (isNarrowableOperand(elementAccess.expression)) currentFlow = createFlowMutation(256 /* ArrayMutation */ , currentFlow, node);
                        }
                    }
                }
                const savedInStrictMode = state.inStrictModeStack[state.stackIndex];
                const savedParent = state.parentStack[state.stackIndex];
                if (savedInStrictMode !== void 0) inStrictMode = savedInStrictMode;
                if (savedParent !== void 0) parent2 = savedParent;
                state.skip = false;
                state.stackIndex--;
            }
            function maybeBind2(node) {
                if (node && isBinaryExpression(node) && !isDestructuringAssignment(node)) return node;
                bind(node);
            }
        }
        function bindDeleteExpressionFlow(node) {
            bindEachChild(node);
            if (node.expression.kind === 210 /* PropertyAccessExpression */ ) bindAssignmentTargetFlow(node.expression);
        }
        function bindConditionalExpressionFlow(node) {
            const trueLabel = createBranchLabel();
            const falseLabel = createBranchLabel();
            const postExpressionLabel = createBranchLabel();
            bindCondition(node.condition, trueLabel, falseLabel);
            currentFlow = finishFlowLabel(trueLabel);
            bind(node.questionToken);
            bind(node.whenTrue);
            addAntecedent(postExpressionLabel, currentFlow);
            currentFlow = finishFlowLabel(falseLabel);
            bind(node.colonToken);
            bind(node.whenFalse);
            addAntecedent(postExpressionLabel, currentFlow);
            currentFlow = finishFlowLabel(postExpressionLabel);
        }
        function bindInitializedVariableFlow(node) {
            const name = !isOmittedExpression(node) ? node.name : void 0;
            if (isBindingPattern(name)) for (const child of name.elements)bindInitializedVariableFlow(child);
            else currentFlow = createFlowMutation(16 /* Assignment */ , currentFlow, node);
        }
        function bindVariableDeclarationFlow(node) {
            bindEachChild(node);
            if (node.initializer || isForInOrOfStatement(node.parent.parent)) bindInitializedVariableFlow(node);
        }
        function bindBindingElementFlow(node) {
            bind(node.dotDotDotToken);
            bind(node.propertyName);
            bindInitializer(node.initializer);
            bind(node.name);
        }
        function bindParameterFlow(node) {
            bindEach(node.modifiers);
            bind(node.dotDotDotToken);
            bind(node.questionToken);
            bind(node.type);
            bindInitializer(node.initializer);
            bind(node.name);
        }
        function bindInitializer(node) {
            if (!node) return;
            const entryFlow = currentFlow;
            bind(node);
            if (entryFlow === unreachableFlow || entryFlow === currentFlow) return;
            const exitFlow = createBranchLabel();
            addAntecedent(exitFlow, entryFlow);
            addAntecedent(exitFlow, currentFlow);
            currentFlow = finishFlowLabel(exitFlow);
        }
        function bindJSDocTypeAlias(node) {
            bind(node.tagName);
            if (node.kind !== 346 /* JSDocEnumTag */  && node.fullName) {
                setParent(node.fullName, node);
                setParentRecursive(node.fullName, /*incremental*/ false);
            }
            if (typeof node.comment !== "string") bindEach(node.comment);
        }
        function bindJSDocClassTag(node) {
            bindEachChild(node);
            const host = getHostSignatureFromJSDoc(node);
            if (host && host.kind !== 173 /* MethodDeclaration */ ) addDeclarationToSymbol(host.symbol, host, 32 /* Class */ );
        }
        function bindOptionalExpression(node, trueTarget, falseTarget) {
            doWithConditionalBranches(bind, node, trueTarget, falseTarget);
            if (!isOptionalChain(node) || isOutermostOptionalChain(node)) {
                addAntecedent(trueTarget, createFlowCondition(32 /* TrueCondition */ , currentFlow, node));
                addAntecedent(falseTarget, createFlowCondition(64 /* FalseCondition */ , currentFlow, node));
            }
        }
        function bindOptionalChainRest(node) {
            switch(node.kind){
                case 210 /* PropertyAccessExpression */ :
                    bind(node.questionDotToken);
                    bind(node.name);
                    break;
                case 211 /* ElementAccessExpression */ :
                    bind(node.questionDotToken);
                    bind(node.argumentExpression);
                    break;
                case 212 /* CallExpression */ :
                    bind(node.questionDotToken);
                    bindEach(node.typeArguments);
                    bindEach(node.arguments);
                    break;
            }
        }
        function bindOptionalChain(node, trueTarget, falseTarget) {
            const preChainLabel = isOptionalChainRoot(node) ? createBranchLabel() : void 0;
            bindOptionalExpression(node.expression, preChainLabel || trueTarget, falseTarget);
            if (preChainLabel) currentFlow = finishFlowLabel(preChainLabel);
            doWithConditionalBranches(bindOptionalChainRest, node, trueTarget, falseTarget);
            if (isOutermostOptionalChain(node)) {
                addAntecedent(trueTarget, createFlowCondition(32 /* TrueCondition */ , currentFlow, node));
                addAntecedent(falseTarget, createFlowCondition(64 /* FalseCondition */ , currentFlow, node));
            }
        }
        function bindOptionalChainFlow(node) {
            if (isTopLevelLogicalExpression(node)) {
                const postExpressionLabel = createBranchLabel();
                bindOptionalChain(node, postExpressionLabel, postExpressionLabel);
                currentFlow = finishFlowLabel(postExpressionLabel);
            } else bindOptionalChain(node, currentTrueTarget, currentFalseTarget);
        }
        function bindNonNullExpressionFlow(node) {
            if (isOptionalChain(node)) bindOptionalChainFlow(node);
            else bindEachChild(node);
        }
        function bindAccessExpressionFlow(node) {
            if (isOptionalChain(node)) bindOptionalChainFlow(node);
            else bindEachChild(node);
        }
        function bindCallExpressionFlow(node) {
            if (isOptionalChain(node)) bindOptionalChainFlow(node);
            else {
                const expr = skipParentheses(node.expression);
                if (expr.kind === 217 /* FunctionExpression */  || expr.kind === 218 /* ArrowFunction */ ) {
                    bindEach(node.typeArguments);
                    bindEach(node.arguments);
                    bind(node.expression);
                } else {
                    bindEachChild(node);
                    if (node.expression.kind === 108 /* SuperKeyword */ ) currentFlow = createFlowCall(currentFlow, node);
                }
            }
            if (node.expression.kind === 210 /* PropertyAccessExpression */ ) {
                const propertyAccess = node.expression;
                if (isIdentifier(propertyAccess.name) && isNarrowableOperand(propertyAccess.expression) && isPushOrUnshiftIdentifier(propertyAccess.name)) currentFlow = createFlowMutation(256 /* ArrayMutation */ , currentFlow, node);
            }
        }
        function addToContainerChain(next) {
            if (lastContainer) lastContainer.nextContainer = next;
            lastContainer = next;
        }
        function declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes) {
            switch(container.kind){
                case 266 /* ModuleDeclaration */ :
                    return declareModuleMember(node, symbolFlags, symbolExcludes);
                case 311 /* SourceFile */ :
                    return declareSourceFileMember(node, symbolFlags, symbolExcludes);
                case 230 /* ClassExpression */ :
                case 262 /* ClassDeclaration */ :
                    return declareClassMember(node, symbolFlags, symbolExcludes);
                case 265 /* EnumDeclaration */ :
                    return declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
                case 186 /* TypeLiteral */ :
                case 328 /* JSDocTypeLiteral */ :
                case 209 /* ObjectLiteralExpression */ :
                case 263 /* InterfaceDeclaration */ :
                case 291 /* JsxAttributes */ :
                    return declareSymbol(container.symbol.members, container.symbol, node, symbolFlags, symbolExcludes);
                case 183 /* FunctionType */ :
                case 184 /* ConstructorType */ :
                case 178 /* CallSignature */ :
                case 179 /* ConstructSignature */ :
                case 329 /* JSDocSignature */ :
                case 180 /* IndexSignature */ :
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                case 175 /* Constructor */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                case 261 /* FunctionDeclaration */ :
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                case 323 /* JSDocFunctionType */ :
                case 174 /* ClassStaticBlockDeclaration */ :
                case 264 /* TypeAliasDeclaration */ :
                case 199 /* MappedType */ :
                    if (container.locals) Debug.assertNode(container, canHaveLocals);
                    return declareSymbol(container.locals, /*parent*/ void 0, node, symbolFlags, symbolExcludes);
            }
        }
        function declareClassMember(node, symbolFlags, symbolExcludes) {
            return isStatic(node) ? declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes) : declareSymbol(container.symbol.members, container.symbol, node, symbolFlags, symbolExcludes);
        }
        function declareSourceFileMember(node, symbolFlags, symbolExcludes) {
            return isExternalModule(file) ? declareModuleMember(node, symbolFlags, symbolExcludes) : declareSymbol(file.locals, /*parent*/ void 0, node, symbolFlags, symbolExcludes);
        }
        function hasExportDeclarations(node) {
            const body = isSourceFile(node) ? node : tryCast(node.body, isModuleBlock);
            return !!body && body.statements.some((s)=>isExportDeclaration(s) || isExportAssignment(s));
        }
        function setExportContextFlag(node) {
            if (node.flags & 16777216 /* Ambient */  && !hasExportDeclarations(node)) node.flags |= 64 /* ExportContext */ ;
            else node.flags &= -65 /* ExportContext */ ;
        }
        function bindModuleDeclaration(node) {
            setExportContextFlag(node);
            if (isAmbientModule(node)) {
                if (hasSyntacticModifier(node, 1 /* Export */ )) errorOnFirstToken(node, Diagnostics.export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always_visible);
                if (isModuleAugmentationExternal(node)) declareModuleSymbol(node);
                else {
                    let pattern;
                    if (node.name.kind === 11 /* StringLiteral */ ) {
                        const { text: text  } = node.name;
                        pattern = tryParsePattern(text);
                        if (pattern === void 0) errorOnFirstToken(node.name, Diagnostics.Pattern_0_can_have_at_most_one_Asterisk_character, text);
                    }
                    const symbol = declareSymbolAndAddToSymbolTable(node, 512 /* ValueModule */ , 110735 /* ValueModuleExcludes */ );
                    file.patternAmbientModules = append(file.patternAmbientModules, pattern && !isString(pattern) ? {
                        pattern: pattern,
                        symbol: symbol
                    } : void 0);
                }
            } else {
                const state = declareModuleSymbol(node);
                if (state !== 0 /* NonInstantiated */ ) {
                    const { symbol: symbol  } = node;
                    symbol.constEnumOnlyModule = !(symbol.flags & 304 /* RegularEnum */ ) && state === 2 /* ConstEnumOnly */  && symbol.constEnumOnlyModule !== false;
                }
            }
        }
        function declareModuleSymbol(node) {
            const state = getModuleInstanceState(node);
            const instantiated = state !== 0 /* NonInstantiated */ ;
            declareSymbolAndAddToSymbolTable(node, instantiated ? 512 /* ValueModule */  : 1024 /* NamespaceModule */ , instantiated ? 110735 /* ValueModuleExcludes */  : 0 /* NamespaceModuleExcludes */ );
            return state;
        }
        function bindFunctionOrConstructorType(node) {
            const symbol = createSymbol(131072 /* Signature */ , getDeclarationName(node));
            addDeclarationToSymbol(symbol, node, 131072 /* Signature */ );
            const typeLiteralSymbol = createSymbol(2048 /* TypeLiteral */ , "__type" /* Type */ );
            addDeclarationToSymbol(typeLiteralSymbol, node, 2048 /* TypeLiteral */ );
            typeLiteralSymbol.members = createSymbolTable();
            typeLiteralSymbol.members.set(symbol.escapedName, symbol);
        }
        function bindObjectLiteralExpression(node) {
            return bindAnonymousDeclaration(node, 4096 /* ObjectLiteral */ , "__object" /* Object */ );
        }
        function bindJsxAttributes(node) {
            return bindAnonymousDeclaration(node, 4096 /* ObjectLiteral */ , "__jsxAttributes" /* JSXAttributes */ );
        }
        function bindJsxAttribute(node, symbolFlags, symbolExcludes) {
            return declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes);
        }
        function bindAnonymousDeclaration(node, symbolFlags, name) {
            const symbol = createSymbol(symbolFlags, name);
            if (symbolFlags & 106508 /* ClassMember */ ) symbol.parent = container.symbol;
            addDeclarationToSymbol(symbol, node, symbolFlags);
            return symbol;
        }
        function bindBlockScopedDeclaration(node, symbolFlags, symbolExcludes) {
            switch(blockScopeContainer.kind){
                case 266 /* ModuleDeclaration */ :
                    declareModuleMember(node, symbolFlags, symbolExcludes);
                    break;
                case 311 /* SourceFile */ :
                    if (isExternalOrCommonJsModule(container)) {
                        declareModuleMember(node, symbolFlags, symbolExcludes);
                        break;
                    }
                default:
                    Debug.assertNode(blockScopeContainer, canHaveLocals);
                    if (!blockScopeContainer.locals) {
                        blockScopeContainer.locals = createSymbolTable();
                        addToContainerChain(blockScopeContainer);
                    }
                    declareSymbol(blockScopeContainer.locals, /*parent*/ void 0, node, symbolFlags, symbolExcludes);
            }
        }
        function delayedBindJSDocTypedefTag() {
            if (!delayedTypeAliases) return;
            const saveContainer = container;
            const saveLastContainer = lastContainer;
            const saveBlockScopeContainer = blockScopeContainer;
            const saveParent = parent2;
            const saveCurrentFlow = currentFlow;
            for (const typeAlias of delayedTypeAliases){
                const host = typeAlias.parent.parent;
                container = findAncestor(host.parent, (n)=>!!(getContainerFlags(n) & 1 /* IsContainer */ )) || file;
                blockScopeContainer = getEnclosingBlockScopeContainer(host) || file;
                currentFlow = initFlowNode({
                    flags: 2 /* Start */ 
                });
                parent2 = typeAlias;
                bind(typeAlias.typeExpression);
                const declName = getNameOfDeclaration(typeAlias);
                if ((isJSDocEnumTag(typeAlias) || !typeAlias.fullName) && declName && isPropertyAccessEntityNameExpression(declName.parent)) {
                    const isTopLevel = isTopLevelNamespaceAssignment(declName.parent);
                    if (isTopLevel) {
                        bindPotentiallyMissingNamespaces(file.symbol, declName.parent, isTopLevel, !!findAncestor(declName, (d)=>isPropertyAccessExpression(d) && d.name.escapedText === "prototype"), /*containerIsClass*/ false);
                        const oldContainer = container;
                        switch(getAssignmentDeclarationPropertyAccessKind(declName.parent)){
                            case 1 /* ExportsProperty */ :
                            case 2 /* ModuleExports */ :
                                if (!isExternalOrCommonJsModule(file)) container = void 0;
                                else container = file;
                                break;
                            case 4 /* ThisProperty */ :
                                container = declName.parent.expression;
                                break;
                            case 3 /* PrototypeProperty */ :
                                container = declName.parent.expression.name;
                                break;
                            case 5 /* Property */ :
                                container = isExportsOrModuleExportsOrAlias(file, declName.parent.expression) ? file : isPropertyAccessExpression(declName.parent.expression) ? declName.parent.expression.name : declName.parent.expression;
                                break;
                            case 0 /* None */ :
                                return Debug.fail("Shouldn't have detected typedef or enum on non-assignment declaration");
                        }
                        if (container) declareModuleMember(typeAlias, 524288 /* TypeAlias */ , 788968 /* TypeAliasExcludes */ );
                        container = oldContainer;
                    }
                } else if (isJSDocEnumTag(typeAlias) || !typeAlias.fullName || typeAlias.fullName.kind === 80 /* Identifier */ ) {
                    parent2 = typeAlias.parent;
                    bindBlockScopedDeclaration(typeAlias, 524288 /* TypeAlias */ , 788968 /* TypeAliasExcludes */ );
                } else bind(typeAlias.fullName);
            }
            container = saveContainer;
            lastContainer = saveLastContainer;
            blockScopeContainer = saveBlockScopeContainer;
            parent2 = saveParent;
            currentFlow = saveCurrentFlow;
        }
        function checkContextualIdentifier(node) {
            if (!file.parseDiagnostics.length && !(node.flags & 16777216 /* Ambient */ ) && !(node.flags & 8388608 /* JSDoc */ ) && !isIdentifierName(node)) {
                const originalKeywordKind = identifierToKeywordKind(node);
                if (originalKeywordKind === void 0) return;
                if (inStrictMode && originalKeywordKind >= 119 /* FirstFutureReservedWord */  && originalKeywordKind <= 127 /* LastFutureReservedWord */ ) file.bindDiagnostics.push(createDiagnosticForNode2(node, getStrictModeIdentifierMessage(node), declarationNameToString(node)));
                else if (originalKeywordKind === 135 /* AwaitKeyword */ ) {
                    if (isExternalModule(file) && isInTopLevelContext(node)) file.bindDiagnostics.push(createDiagnosticForNode2(node, Diagnostics.Identifier_expected_0_is_a_reserved_word_at_the_top_level_of_a_module, declarationNameToString(node)));
                    else if (node.flags & 32768 /* AwaitContext */ ) file.bindDiagnostics.push(createDiagnosticForNode2(node, Diagnostics.Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here, declarationNameToString(node)));
                } else if (originalKeywordKind === 127 /* YieldKeyword */  && node.flags & 8192 /* YieldContext */ ) file.bindDiagnostics.push(createDiagnosticForNode2(node, Diagnostics.Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here, declarationNameToString(node)));
            }
        }
        function getStrictModeIdentifierMessage(node) {
            if (getContainingClass(node)) return Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_strict_mode;
            if (file.externalModuleIndicator) return Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode;
            return Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode;
        }
        function checkPrivateIdentifier(node) {
            if (node.escapedText === "#constructor") {
                if (!file.parseDiagnostics.length) file.bindDiagnostics.push(createDiagnosticForNode2(node, Diagnostics.constructor_is_a_reserved_word, declarationNameToString(node)));
            }
        }
        function checkStrictModeBinaryExpression(node) {
            if (inStrictMode && isLeftHandSideExpression(node.left) && isAssignmentOperator(node.operatorToken.kind)) checkStrictModeEvalOrArguments(node, node.left);
        }
        function checkStrictModeCatchClause(node) {
            if (inStrictMode && node.variableDeclaration) checkStrictModeEvalOrArguments(node, node.variableDeclaration.name);
        }
        function checkStrictModeDeleteExpression(node) {
            if (inStrictMode && node.expression.kind === 80 /* Identifier */ ) {
                const span = getErrorSpanForNode(file, node.expression);
                file.bindDiagnostics.push(createFileDiagnostic(file, span.start, span.length, Diagnostics.delete_cannot_be_called_on_an_identifier_in_strict_mode));
            }
        }
        function isEvalOrArgumentsIdentifier(node) {
            return isIdentifier(node) && (node.escapedText === "eval" || node.escapedText === "arguments");
        }
        function checkStrictModeEvalOrArguments(contextNode, name) {
            if (name && name.kind === 80 /* Identifier */ ) {
                const identifier = name;
                if (isEvalOrArgumentsIdentifier(identifier)) {
                    const span = getErrorSpanForNode(file, name);
                    file.bindDiagnostics.push(createFileDiagnostic(file, span.start, span.length, getStrictModeEvalOrArgumentsMessage(contextNode), idText(identifier)));
                }
            }
        }
        function getStrictModeEvalOrArgumentsMessage(node) {
            if (getContainingClass(node)) return Diagnostics.Code_contained_in_a_class_is_evaluated_in_JavaScript_s_strict_mode_which_does_not_allow_this_use_of_0_For_more_information_see_https_Colon_Slash_Slashdeveloper_mozilla_org_Slashen_US_Slashdocs_SlashWeb_SlashJavaScript_SlashReference_SlashStrict_mode;
            if (file.externalModuleIndicator) return Diagnostics.Invalid_use_of_0_Modules_are_automatically_in_strict_mode;
            return Diagnostics.Invalid_use_of_0_in_strict_mode;
        }
        function checkStrictModeFunctionName(node) {
            if (inStrictMode) checkStrictModeEvalOrArguments(node, node.name);
        }
        function getStrictModeBlockScopeFunctionDeclarationMessage(node) {
            if (getContainingClass(node)) return Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Class_definitions_are_automatically_in_strict_mode;
            if (file.externalModuleIndicator) return Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Modules_are_automatically_in_strict_mode;
            return Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5;
        }
        function checkStrictModeFunctionDeclaration(node) {
            if (languageVersion < 2 /* ES2015 */ ) {
                if (blockScopeContainer.kind !== 311 /* SourceFile */  && blockScopeContainer.kind !== 266 /* ModuleDeclaration */  && !isFunctionLikeOrClassStaticBlockDeclaration(blockScopeContainer)) {
                    const errorSpan = getErrorSpanForNode(file, node);
                    file.bindDiagnostics.push(createFileDiagnostic(file, errorSpan.start, errorSpan.length, getStrictModeBlockScopeFunctionDeclarationMessage(node)));
                }
            }
        }
        function checkStrictModePostfixUnaryExpression(node) {
            if (inStrictMode) checkStrictModeEvalOrArguments(node, node.operand);
        }
        function checkStrictModePrefixUnaryExpression(node) {
            if (inStrictMode) {
                if (node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) checkStrictModeEvalOrArguments(node, node.operand);
            }
        }
        function checkStrictModeWithStatement(node) {
            if (inStrictMode) errorOnFirstToken(node, Diagnostics.with_statements_are_not_allowed_in_strict_mode);
        }
        function checkStrictModeLabeledStatement(node) {
            if (inStrictMode && getEmitScriptTarget(options) >= 2 /* ES2015 */ ) {
                if (isDeclarationStatement(node.statement) || isVariableStatement(node.statement)) errorOnFirstToken(node.label, Diagnostics.A_label_is_not_allowed_here);
            }
        }
        function errorOnFirstToken(node, message, ...args) {
            const span = getSpanOfTokenAtPosition(file, node.pos);
            file.bindDiagnostics.push(createFileDiagnostic(file, span.start, span.length, message, ...args));
        }
        function errorOrSuggestionOnNode(isError, node, message) {
            errorOrSuggestionOnRange(isError, node, node, message);
        }
        function errorOrSuggestionOnRange(isError, startNode2, endNode2, message) {
            addErrorOrSuggestionDiagnostic(isError, {
                pos: getTokenPosOfNode(startNode2, file),
                end: endNode2.end
            }, message);
        }
        function addErrorOrSuggestionDiagnostic(isError, range, message) {
            const diag2 = createFileDiagnostic(file, range.pos, range.end - range.pos, message);
            if (isError) file.bindDiagnostics.push(diag2);
            else file.bindSuggestionDiagnostics = append(file.bindSuggestionDiagnostics, {
                ...diag2,
                category: 2 /* Suggestion */ 
            });
        }
        function bind(node) {
            if (!node) return;
            setParent(node, parent2);
            if (tracing) node.tracingPath = file.path;
            const saveInStrictMode = inStrictMode;
            bindWorker(node);
            if (node.kind > 164 /* LastToken */ ) {
                const saveParent = parent2;
                parent2 = node;
                const containerFlags = getContainerFlags(node);
                if (containerFlags === 0 /* None */ ) bindChildren(node);
                else bindContainer(node, containerFlags);
                parent2 = saveParent;
            } else {
                const saveParent = parent2;
                if (node.kind === 1 /* EndOfFileToken */ ) parent2 = node;
                bindJSDoc(node);
                parent2 = saveParent;
            }
            inStrictMode = saveInStrictMode;
        }
        function bindJSDoc(node) {
            if (hasJSDocNodes(node)) {
                if (isInJSFile(node)) for (const j of node.jsDoc)bind(j);
                else for (const j of node.jsDoc){
                    setParent(j, node);
                    setParentRecursive(j, /*incremental*/ false);
                }
            }
        }
        function updateStrictModeStatementList(statements) {
            if (!inStrictMode) for (const statement of statements){
                if (!isPrologueDirective(statement)) return;
                if (isUseStrictPrologueDirective(statement)) {
                    inStrictMode = true;
                    return;
                }
            }
        }
        function isUseStrictPrologueDirective(node) {
            const nodeText2 = getSourceTextOfNodeFromSourceFile(file, node.expression);
            return nodeText2 === '"use strict"' || nodeText2 === "'use strict'";
        }
        function bindWorker(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    if (node.flags & 2048 /* IdentifierIsInJSDocNamespace */ ) {
                        let parentNode = node.parent;
                        while(parentNode && !isJSDocTypeAlias(parentNode))parentNode = parentNode.parent;
                        bindBlockScopedDeclaration(parentNode, 524288 /* TypeAlias */ , 788968 /* TypeAliasExcludes */ );
                        break;
                    }
                case 110 /* ThisKeyword */ :
                    if (currentFlow && (isExpression(node) || parent2.kind === 303 /* ShorthandPropertyAssignment */ )) node.flowNode = currentFlow;
                    return checkContextualIdentifier(node);
                case 165 /* QualifiedName */ :
                    if (currentFlow && isPartOfTypeQuery(node)) node.flowNode = currentFlow;
                    break;
                case 235 /* MetaProperty */ :
                case 108 /* SuperKeyword */ :
                    node.flowNode = currentFlow;
                    break;
                case 81 /* PrivateIdentifier */ :
                    return checkPrivateIdentifier(node);
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    const expr = node;
                    if (currentFlow && isNarrowableReference(expr)) expr.flowNode = currentFlow;
                    if (isSpecialPropertyDeclaration(expr)) bindSpecialPropertyDeclaration(expr);
                    if (isInJSFile(expr) && file.commonJsModuleIndicator && isModuleExportsAccessExpression(expr) && !lookupSymbolForName(blockScopeContainer, "module")) declareSymbol(file.locals, /*parent*/ void 0, expr.expression, 134217729 /* ModuleExports */ , 111550 /* FunctionScopedVariableExcludes */ );
                    break;
                case 225 /* BinaryExpression */ :
                    const specialKind = getAssignmentDeclarationKind(node);
                    switch(specialKind){
                        case 1 /* ExportsProperty */ :
                            bindExportsPropertyAssignment(node);
                            break;
                        case 2 /* ModuleExports */ :
                            bindModuleExportsAssignment(node);
                            break;
                        case 3 /* PrototypeProperty */ :
                            bindPrototypePropertyAssignment(node.left, node);
                            break;
                        case 6 /* Prototype */ :
                            bindPrototypeAssignment(node);
                            break;
                        case 4 /* ThisProperty */ :
                            bindThisPropertyAssignment(node);
                            break;
                        case 5 /* Property */ :
                            const expression = node.left.expression;
                            if (isInJSFile(node) && isIdentifier(expression)) {
                                const symbol = lookupSymbolForName(blockScopeContainer, expression.escapedText);
                                if (isThisInitializedDeclaration(symbol == null ? void 0 : symbol.valueDeclaration)) {
                                    bindThisPropertyAssignment(node);
                                    break;
                                }
                            }
                            bindSpecialPropertyAssignment(node);
                            break;
                        case 0 /* None */ :
                            break;
                        default:
                            Debug.fail("Unknown binary expression special property assignment kind");
                    }
                    return checkStrictModeBinaryExpression(node);
                case 298 /* CatchClause */ :
                    return checkStrictModeCatchClause(node);
                case 219 /* DeleteExpression */ :
                    return checkStrictModeDeleteExpression(node);
                case 224 /* PostfixUnaryExpression */ :
                    return checkStrictModePostfixUnaryExpression(node);
                case 223 /* PrefixUnaryExpression */ :
                    return checkStrictModePrefixUnaryExpression(node);
                case 253 /* WithStatement */ :
                    return checkStrictModeWithStatement(node);
                case 255 /* LabeledStatement */ :
                    return checkStrictModeLabeledStatement(node);
                case 196 /* ThisType */ :
                    seenThisKeyword = true;
                    return;
                case 181 /* TypePredicate */ :
                    break;
                case 167 /* TypeParameter */ :
                    return bindTypeParameter(node);
                case 168 /* Parameter */ :
                    return bindParameter(node);
                case 259 /* VariableDeclaration */ :
                    return bindVariableDeclarationOrBindingElement(node);
                case 207 /* BindingElement */ :
                    node.flowNode = currentFlow;
                    return bindVariableDeclarationOrBindingElement(node);
                case 171 /* PropertyDeclaration */ :
                case 170 /* PropertySignature */ :
                    return bindPropertyWorker(node);
                case 302 /* PropertyAssignment */ :
                case 303 /* ShorthandPropertyAssignment */ :
                    return bindPropertyOrMethodOrAccessor(node, 4 /* Property */ , 0 /* PropertyExcludes */ );
                case 305 /* EnumMember */ :
                    return bindPropertyOrMethodOrAccessor(node, 8 /* EnumMember */ , 900095 /* EnumMemberExcludes */ );
                case 178 /* CallSignature */ :
                case 179 /* ConstructSignature */ :
                case 180 /* IndexSignature */ :
                    return declareSymbolAndAddToSymbolTable(node, 131072 /* Signature */ , 0 /* None */ );
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                    return bindPropertyOrMethodOrAccessor(node, 8192 /* Method */  | (node.questionToken ? 16777216 /* Optional */  : 0 /* None */ ), isObjectLiteralMethod(node) ? 0 /* PropertyExcludes */  : 103359 /* MethodExcludes */ );
                case 261 /* FunctionDeclaration */ :
                    return bindFunctionDeclaration(node);
                case 175 /* Constructor */ :
                    return declareSymbolAndAddToSymbolTable(node, 16384 /* Constructor */ , /*symbolExcludes:*/ 0 /* None */ );
                case 176 /* GetAccessor */ :
                    return bindPropertyOrMethodOrAccessor(node, 32768 /* GetAccessor */ , 46015 /* GetAccessorExcludes */ );
                case 177 /* SetAccessor */ :
                    return bindPropertyOrMethodOrAccessor(node, 65536 /* SetAccessor */ , 78783 /* SetAccessorExcludes */ );
                case 183 /* FunctionType */ :
                case 323 /* JSDocFunctionType */ :
                case 329 /* JSDocSignature */ :
                case 184 /* ConstructorType */ :
                    return bindFunctionOrConstructorType(node);
                case 186 /* TypeLiteral */ :
                case 328 /* JSDocTypeLiteral */ :
                case 199 /* MappedType */ :
                    return bindAnonymousTypeWorker(node);
                case 338 /* JSDocClassTag */ :
                    return bindJSDocClassTag(node);
                case 209 /* ObjectLiteralExpression */ :
                    return bindObjectLiteralExpression(node);
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                    return bindFunctionExpression(node);
                case 212 /* CallExpression */ :
                    const assignmentKind = getAssignmentDeclarationKind(node);
                    switch(assignmentKind){
                        case 7 /* ObjectDefinePropertyValue */ :
                            return bindObjectDefinePropertyAssignment(node);
                        case 8 /* ObjectDefinePropertyExports */ :
                            return bindObjectDefinePropertyExport(node);
                        case 9 /* ObjectDefinePrototypeProperty */ :
                            return bindObjectDefinePrototypeProperty(node);
                        case 0 /* None */ :
                            break;
                        default:
                            return Debug.fail("Unknown call expression assignment declaration kind");
                    }
                    if (isInJSFile(node)) bindCallExpression(node);
                    break;
                case 230 /* ClassExpression */ :
                case 262 /* ClassDeclaration */ :
                    inStrictMode = true;
                    return bindClassLikeDeclaration(node);
                case 263 /* InterfaceDeclaration */ :
                    return bindBlockScopedDeclaration(node, 64 /* Interface */ , 788872 /* InterfaceExcludes */ );
                case 264 /* TypeAliasDeclaration */ :
                    return bindBlockScopedDeclaration(node, 524288 /* TypeAlias */ , 788968 /* TypeAliasExcludes */ );
                case 265 /* EnumDeclaration */ :
                    return bindEnumDeclaration(node);
                case 266 /* ModuleDeclaration */ :
                    return bindModuleDeclaration(node);
                case 291 /* JsxAttributes */ :
                    return bindJsxAttributes(node);
                case 290 /* JsxAttribute */ :
                    return bindJsxAttribute(node, 4 /* Property */ , 0 /* PropertyExcludes */ );
                case 270 /* ImportEqualsDeclaration */ :
                case 273 /* NamespaceImport */ :
                case 275 /* ImportSpecifier */ :
                case 280 /* ExportSpecifier */ :
                    return declareSymbolAndAddToSymbolTable(node, 2097152 /* Alias */ , 2097152 /* AliasExcludes */ );
                case 269 /* NamespaceExportDeclaration */ :
                    return bindNamespaceExportDeclaration(node);
                case 272 /* ImportClause */ :
                    return bindImportClause(node);
                case 277 /* ExportDeclaration */ :
                    return bindExportDeclaration(node);
                case 276 /* ExportAssignment */ :
                    return bindExportAssignment(node);
                case 311 /* SourceFile */ :
                    updateStrictModeStatementList(node.statements);
                    return bindSourceFileIfExternalModule();
                case 240 /* Block */ :
                    if (!isFunctionLikeOrClassStaticBlockDeclaration(node.parent)) return;
                case 267 /* ModuleBlock */ :
                    return updateStrictModeStatementList(node.statements);
                case 347 /* JSDocParameterTag */ :
                    if (node.parent.kind === 329 /* JSDocSignature */ ) return bindParameter(node);
                    if (node.parent.kind !== 328 /* JSDocTypeLiteral */ ) break;
                case 354 /* JSDocPropertyTag */ :
                    const propTag = node;
                    const flags = propTag.isBracketed || propTag.typeExpression && propTag.typeExpression.type.kind === 322 /* JSDocOptionalType */  ? 16777220 /* Optional */  : 4 /* Property */ ;
                    return declareSymbolAndAddToSymbolTable(propTag, flags, 0 /* PropertyExcludes */ );
                case 352 /* JSDocTypedefTag */ :
                case 344 /* JSDocCallbackTag */ :
                case 346 /* JSDocEnumTag */ :
                    return (delayedTypeAliases || (delayedTypeAliases = [])).push(node);
                case 345 /* JSDocOverloadTag */ :
                    return bind(node.typeExpression);
            }
        }
        function bindPropertyWorker(node) {
            const isAutoAccessor = isAutoAccessorPropertyDeclaration(node);
            const includes = isAutoAccessor ? 98304 /* Accessor */  : 4 /* Property */ ;
            const excludes = isAutoAccessor ? 13247 /* AccessorExcludes */  : 0 /* PropertyExcludes */ ;
            return bindPropertyOrMethodOrAccessor(node, includes | (node.questionToken ? 16777216 /* Optional */  : 0 /* None */ ), excludes);
        }
        function bindAnonymousTypeWorker(node) {
            return bindAnonymousDeclaration(node, 2048 /* TypeLiteral */ , "__type" /* Type */ );
        }
        function bindSourceFileIfExternalModule() {
            setExportContextFlag(file);
            if (isExternalModule(file)) bindSourceFileAsExternalModule();
            else if (isJsonSourceFile(file)) {
                bindSourceFileAsExternalModule();
                const originalSymbol = file.symbol;
                declareSymbol(file.symbol.exports, file.symbol, file, 4 /* Property */ , 67108863 /* All */ );
                file.symbol = originalSymbol;
            }
        }
        function bindSourceFileAsExternalModule() {
            bindAnonymousDeclaration(file, 512 /* ValueModule */ , `"${removeFileExtension(file.fileName)}"`);
        }
        function bindExportAssignment(node) {
            if (!container.symbol || !container.symbol.exports) bindAnonymousDeclaration(node, 111551 /* Value */ , getDeclarationName(node));
            else {
                const flags = exportAssignmentIsAlias(node) ? 2097152 /* Alias */  : 4 /* Property */ ;
                const symbol = declareSymbol(container.symbol.exports, container.symbol, node, flags, 67108863 /* All */ );
                if (node.isExportEquals) setValueDeclaration(symbol, node);
            }
        }
        function bindNamespaceExportDeclaration(node) {
            if (some(node.modifiers)) file.bindDiagnostics.push(createDiagnosticForNode2(node, Diagnostics.Modifiers_cannot_appear_here));
            const diag2 = !isSourceFile(node.parent) ? Diagnostics.Global_module_exports_may_only_appear_at_top_level : !isExternalModule(node.parent) ? Diagnostics.Global_module_exports_may_only_appear_in_module_files : !node.parent.isDeclarationFile ? Diagnostics.Global_module_exports_may_only_appear_in_declaration_files : void 0;
            if (diag2) file.bindDiagnostics.push(createDiagnosticForNode2(node, diag2));
            else {
                file.symbol.globalExports = file.symbol.globalExports || createSymbolTable();
                declareSymbol(file.symbol.globalExports, file.symbol, node, 2097152 /* Alias */ , 2097152 /* AliasExcludes */ );
            }
        }
        function bindExportDeclaration(node) {
            if (!container.symbol || !container.symbol.exports) bindAnonymousDeclaration(node, 8388608 /* ExportStar */ , getDeclarationName(node));
            else if (!node.exportClause) declareSymbol(container.symbol.exports, container.symbol, node, 8388608 /* ExportStar */ , 0 /* None */ );
            else if (isNamespaceExport(node.exportClause)) {
                setParent(node.exportClause, node);
                declareSymbol(container.symbol.exports, container.symbol, node.exportClause, 2097152 /* Alias */ , 2097152 /* AliasExcludes */ );
            }
        }
        function bindImportClause(node) {
            if (node.name) declareSymbolAndAddToSymbolTable(node, 2097152 /* Alias */ , 2097152 /* AliasExcludes */ );
        }
        function setCommonJsModuleIndicator(node) {
            if (file.externalModuleIndicator && file.externalModuleIndicator !== true) return false;
            if (!file.commonJsModuleIndicator) {
                file.commonJsModuleIndicator = node;
                if (!file.externalModuleIndicator) bindSourceFileAsExternalModule();
            }
            return true;
        }
        function bindObjectDefinePropertyExport(node) {
            if (!setCommonJsModuleIndicator(node)) return;
            const symbol = forEachIdentifierInEntityName(node.arguments[0], /*parent*/ void 0, (id, symbol2)=>{
                if (symbol2) addDeclarationToSymbol(symbol2, id, 67110400 /* Assignment */ );
                return symbol2;
            });
            if (symbol) {
                const flags = 1048580 /* ExportValue */ ;
                declareSymbol(symbol.exports, symbol, node, flags, 0 /* None */ );
            }
        }
        function bindExportsPropertyAssignment(node) {
            if (!setCommonJsModuleIndicator(node)) return;
            const symbol = forEachIdentifierInEntityName(node.left.expression, /*parent*/ void 0, (id, symbol2)=>{
                if (symbol2) addDeclarationToSymbol(symbol2, id, 67110400 /* Assignment */ );
                return symbol2;
            });
            if (symbol) {
                const isAlias = isAliasableExpression(node.right) && (isExportsIdentifier(node.left.expression) || isModuleExportsAccessExpression(node.left.expression));
                const flags = isAlias ? 2097152 /* Alias */  : 1048580 /* ExportValue */ ;
                setParent(node.left, node);
                declareSymbol(symbol.exports, symbol, node.left, flags, 0 /* None */ );
            }
        }
        function bindModuleExportsAssignment(node) {
            if (!setCommonJsModuleIndicator(node)) return;
            const assignedExpression = getRightMostAssignedExpression(node.right);
            if (isEmptyObjectLiteral(assignedExpression) || container === file && isExportsOrModuleExportsOrAlias(file, assignedExpression)) return;
            if (isObjectLiteralExpression(assignedExpression) && every(assignedExpression.properties, isShorthandPropertyAssignment)) {
                forEach(assignedExpression.properties, bindExportAssignedObjectMemberAlias);
                return;
            }
            const flags = exportAssignmentIsAlias(node) ? 2097152 /* Alias */  : 1049092 /* ValueModule */ ;
            const symbol = declareSymbol(file.symbol.exports, file.symbol, node, flags | 67108864 /* Assignment */ , 0 /* None */ );
            setValueDeclaration(symbol, node);
        }
        function bindExportAssignedObjectMemberAlias(node) {
            declareSymbol(file.symbol.exports, file.symbol, node, 69206016 /* Assignment */ , 0 /* None */ );
        }
        function bindThisPropertyAssignment(node) {
            Debug.assert(isInJSFile(node));
            const hasPrivateIdentifier = isBinaryExpression(node) && isPropertyAccessExpression(node.left) && isPrivateIdentifier(node.left.name) || isPropertyAccessExpression(node) && isPrivateIdentifier(node.name);
            if (hasPrivateIdentifier) return;
            const thisContainer = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            switch(thisContainer.kind){
                case 261 /* FunctionDeclaration */ :
                case 217 /* FunctionExpression */ :
                    let constructorSymbol = thisContainer.symbol;
                    if (isBinaryExpression(thisContainer.parent) && thisContainer.parent.operatorToken.kind === 64 /* EqualsToken */ ) {
                        const l = thisContainer.parent.left;
                        if (isBindableStaticAccessExpression(l) && isPrototypeAccess(l.expression)) constructorSymbol = lookupSymbolForPropertyAccess(l.expression.expression, thisParentContainer);
                    }
                    if (constructorSymbol && constructorSymbol.valueDeclaration) {
                        constructorSymbol.members = constructorSymbol.members || createSymbolTable();
                        if (hasDynamicName(node)) bindDynamicallyNamedThisPropertyAssignment(node, constructorSymbol, constructorSymbol.members);
                        else declareSymbol(constructorSymbol.members, constructorSymbol, node, 67108868 /* Assignment */ , 0 /* Property */ );
                        addDeclarationToSymbol(constructorSymbol, constructorSymbol.valueDeclaration, 32 /* Class */ );
                    }
                    break;
                case 175 /* Constructor */ :
                case 171 /* PropertyDeclaration */ :
                case 173 /* MethodDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                case 174 /* ClassStaticBlockDeclaration */ :
                    const containingClass = thisContainer.parent;
                    const symbolTable = isStatic(thisContainer) ? containingClass.symbol.exports : containingClass.symbol.members;
                    if (hasDynamicName(node)) bindDynamicallyNamedThisPropertyAssignment(node, containingClass.symbol, symbolTable);
                    else declareSymbol(symbolTable, containingClass.symbol, node, 67108868 /* Assignment */ , 0 /* None */ , /*isReplaceableByMethod*/ true);
                    break;
                case 311 /* SourceFile */ :
                    if (hasDynamicName(node)) break;
                    else if (thisContainer.commonJsModuleIndicator) declareSymbol(thisContainer.symbol.exports, thisContainer.symbol, node, 1048580 /* ExportValue */ , 0 /* None */ );
                    else declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */ , 111550 /* FunctionScopedVariableExcludes */ );
                    break;
                case 266 /* ModuleDeclaration */ :
                    break;
                default:
                    Debug.failBadSyntaxKind(thisContainer);
            }
        }
        function bindDynamicallyNamedThisPropertyAssignment(node, symbol, symbolTable) {
            declareSymbol(symbolTable, symbol, node, 4 /* Property */ , 0 /* None */ , /*isReplaceableByMethod*/ true, /*isComputedName*/ true);
            addLateBoundAssignmentDeclarationToSymbol(node, symbol);
        }
        function addLateBoundAssignmentDeclarationToSymbol(node, symbol) {
            if (symbol) (symbol.assignmentDeclarationMembers || (symbol.assignmentDeclarationMembers = /* @__PURE__ */ new Map())).set(getNodeId(node), node);
        }
        function bindSpecialPropertyDeclaration(node) {
            if (node.expression.kind === 110 /* ThisKeyword */ ) bindThisPropertyAssignment(node);
            else if (isBindableStaticAccessExpression(node) && node.parent.parent.kind === 311 /* SourceFile */ ) {
                if (isPrototypeAccess(node.expression)) bindPrototypePropertyAssignment(node, node.parent);
                else bindStaticPropertyAssignment(node);
            }
        }
        function bindPrototypeAssignment(node) {
            setParent(node.left, node);
            setParent(node.right, node);
            bindPropertyAssignment(node.left.expression, node.left, /*isPrototypeProperty*/ false, /*containerIsClass*/ true);
        }
        function bindObjectDefinePrototypeProperty(node) {
            const namespaceSymbol = lookupSymbolForPropertyAccess(node.arguments[0].expression);
            if (namespaceSymbol && namespaceSymbol.valueDeclaration) addDeclarationToSymbol(namespaceSymbol, namespaceSymbol.valueDeclaration, 32 /* Class */ );
            bindPotentiallyNewExpandoMemberToNamespace(node, namespaceSymbol, /*isPrototypeProperty*/ true);
        }
        function bindPrototypePropertyAssignment(lhs, parent3) {
            const classPrototype = lhs.expression;
            const constructorFunction = classPrototype.expression;
            setParent(constructorFunction, classPrototype);
            setParent(classPrototype, lhs);
            setParent(lhs, parent3);
            bindPropertyAssignment(constructorFunction, lhs, /*isPrototypeProperty*/ true, /*containerIsClass*/ true);
        }
        function bindObjectDefinePropertyAssignment(node) {
            let namespaceSymbol = lookupSymbolForPropertyAccess(node.arguments[0]);
            const isToplevel = node.parent.parent.kind === 311 /* SourceFile */ ;
            namespaceSymbol = bindPotentiallyMissingNamespaces(namespaceSymbol, node.arguments[0], isToplevel, /*isPrototypeProperty*/ false, /*containerIsClass*/ false);
            bindPotentiallyNewExpandoMemberToNamespace(node, namespaceSymbol, /*isPrototypeProperty*/ false);
        }
        function bindSpecialPropertyAssignment(node) {
            var _a;
            const parentSymbol = lookupSymbolForPropertyAccess(node.left.expression, container) || lookupSymbolForPropertyAccess(node.left.expression, blockScopeContainer);
            if (!isInJSFile(node) && !isFunctionSymbol(parentSymbol)) return;
            const rootExpr = getLeftmostAccessExpression(node.left);
            if (isIdentifier(rootExpr) && ((_a = lookupSymbolForName(container, rootExpr.escapedText)) == null ? void 0 : _a.flags) & 2097152 /* Alias */ ) return;
            setParent(node.left, node);
            setParent(node.right, node);
            if (isIdentifier(node.left.expression) && container === file && isExportsOrModuleExportsOrAlias(file, node.left.expression)) bindExportsPropertyAssignment(node);
            else if (hasDynamicName(node)) {
                bindAnonymousDeclaration(node, 67108868 /* Assignment */ , "__computed" /* Computed */ );
                const sym = bindPotentiallyMissingNamespaces(parentSymbol, node.left.expression, isTopLevelNamespaceAssignment(node.left), /*isPrototypeProperty*/ false, /*containerIsClass*/ false);
                addLateBoundAssignmentDeclarationToSymbol(node, sym);
            } else bindStaticPropertyAssignment(cast(node.left, isBindableStaticNameExpression));
        }
        function bindStaticPropertyAssignment(node) {
            Debug.assert(!isIdentifier(node));
            setParent(node.expression, node);
            bindPropertyAssignment(node.expression, node, /*isPrototypeProperty*/ false, /*containerIsClass*/ false);
        }
        function bindPotentiallyMissingNamespaces(namespaceSymbol, entityName, isToplevel, isPrototypeProperty, containerIsClass) {
            if ((namespaceSymbol == null ? void 0 : namespaceSymbol.flags) & 2097152 /* Alias */ ) return namespaceSymbol;
            if (isToplevel && !isPrototypeProperty) {
                const flags = 67110400 /* Assignment */ ;
                const excludeFlags = 110735 /* Assignment */ ;
                namespaceSymbol = forEachIdentifierInEntityName(entityName, namespaceSymbol, (id, symbol, parent3)=>{
                    if (symbol) {
                        addDeclarationToSymbol(symbol, id, flags);
                        return symbol;
                    } else {
                        const table = parent3 ? parent3.exports : file.jsGlobalAugmentations || (file.jsGlobalAugmentations = createSymbolTable());
                        return declareSymbol(table, parent3, id, flags, excludeFlags);
                    }
                });
            }
            if (containerIsClass && namespaceSymbol && namespaceSymbol.valueDeclaration) addDeclarationToSymbol(namespaceSymbol, namespaceSymbol.valueDeclaration, 32 /* Class */ );
            return namespaceSymbol;
        }
        function bindPotentiallyNewExpandoMemberToNamespace(declaration, namespaceSymbol, isPrototypeProperty) {
            if (!namespaceSymbol || !isExpandoSymbol(namespaceSymbol)) return;
            const symbolTable = isPrototypeProperty ? namespaceSymbol.members || (namespaceSymbol.members = createSymbolTable()) : namespaceSymbol.exports || (namespaceSymbol.exports = createSymbolTable());
            let includes = 0 /* None */ ;
            let excludes = 0 /* None */ ;
            if (isFunctionLikeDeclaration(getAssignedExpandoInitializer(declaration))) {
                includes = 8192 /* Method */ ;
                excludes = 103359 /* MethodExcludes */ ;
            } else if (isCallExpression(declaration) && isBindableObjectDefinePropertyCall(declaration)) {
                if (some(declaration.arguments[2].properties, (p)=>{
                    const id = getNameOfDeclaration(p);
                    return !!id && isIdentifier(id) && idText(id) === "set";
                })) {
                    includes |= 65540 /* Property */ ;
                    excludes |= 78783 /* SetAccessorExcludes */ ;
                }
                if (some(declaration.arguments[2].properties, (p)=>{
                    const id = getNameOfDeclaration(p);
                    return !!id && isIdentifier(id) && idText(id) === "get";
                })) {
                    includes |= 32772 /* Property */ ;
                    excludes |= 46015 /* GetAccessorExcludes */ ;
                }
            }
            if (includes === 0 /* None */ ) {
                includes = 4 /* Property */ ;
                excludes = 0 /* PropertyExcludes */ ;
            }
            declareSymbol(symbolTable, namespaceSymbol, declaration, includes | 67108864 /* Assignment */ , excludes & -67108865 /* Assignment */ );
        }
        function isTopLevelNamespaceAssignment(propertyAccess) {
            return isBinaryExpression(propertyAccess.parent) ? getParentOfBinaryExpression(propertyAccess.parent).parent.kind === 311 /* SourceFile */  : propertyAccess.parent.parent.kind === 311 /* SourceFile */ ;
        }
        function bindPropertyAssignment(name, propertyAccess, isPrototypeProperty, containerIsClass) {
            let namespaceSymbol = lookupSymbolForPropertyAccess(name, container) || lookupSymbolForPropertyAccess(name, blockScopeContainer);
            const isToplevel = isTopLevelNamespaceAssignment(propertyAccess);
            namespaceSymbol = bindPotentiallyMissingNamespaces(namespaceSymbol, propertyAccess.expression, isToplevel, isPrototypeProperty, containerIsClass);
            bindPotentiallyNewExpandoMemberToNamespace(propertyAccess, namespaceSymbol, isPrototypeProperty);
        }
        function isExpandoSymbol(symbol) {
            if (symbol.flags & 1072 /* NamespaceModule */ ) return true;
            const node = symbol.valueDeclaration;
            if (node && isCallExpression(node)) return !!getAssignedExpandoInitializer(node);
            let init = !node ? void 0 : isVariableDeclaration(node) ? node.initializer : isBinaryExpression(node) ? node.right : isPropertyAccessExpression(node) && isBinaryExpression(node.parent) ? node.parent.right : void 0;
            init = init && getRightMostAssignedExpression(init);
            if (init) {
                const isPrototypeAssignment = isPrototypeAccess(isVariableDeclaration(node) ? node.name : isBinaryExpression(node) ? node.left : node);
                return !!getExpandoInitializer(isBinaryExpression(init) && (init.operatorToken.kind === 57 /* BarBarToken */  || init.operatorToken.kind === 61 /* QuestionQuestionToken */ ) ? init.right : init, isPrototypeAssignment);
            }
            return false;
        }
        function getParentOfBinaryExpression(expr) {
            while(isBinaryExpression(expr.parent))expr = expr.parent;
            return expr.parent;
        }
        function lookupSymbolForPropertyAccess(node, lookupContainer = container) {
            if (isIdentifier(node)) return lookupSymbolForName(lookupContainer, node.escapedText);
            else {
                const symbol = lookupSymbolForPropertyAccess(node.expression);
                return symbol && symbol.exports && symbol.exports.get(getElementOrPropertyAccessName(node));
            }
        }
        function forEachIdentifierInEntityName(e, parent3, action) {
            if (isExportsOrModuleExportsOrAlias(file, e)) return file.symbol;
            else if (isIdentifier(e)) return action(e, lookupSymbolForPropertyAccess(e), parent3);
            else {
                const s = forEachIdentifierInEntityName(e.expression, parent3, action);
                const name = getNameOrArgument(e);
                if (isPrivateIdentifier(name)) Debug.fail("unexpected PrivateIdentifier");
                return action(name, s && s.exports && s.exports.get(getElementOrPropertyAccessName(e)), s);
            }
        }
        function bindCallExpression(node) {
            if (!file.commonJsModuleIndicator && isRequireCall(node, /*requireStringLiteralLikeArgument*/ false)) setCommonJsModuleIndicator(node);
        }
        function bindClassLikeDeclaration(node) {
            if (node.kind === 262 /* ClassDeclaration */ ) bindBlockScopedDeclaration(node, 32 /* Class */ , 899503 /* ClassExcludes */ );
            else {
                const bindingName = node.name ? node.name.escapedText : "__class" /* Class */ ;
                bindAnonymousDeclaration(node, 32 /* Class */ , bindingName);
                if (node.name) classifiableNames.add(node.name.escapedText);
            }
            const { symbol: symbol  } = node;
            const prototypeSymbol = createSymbol(4194308 /* Prototype */ , "prototype");
            const symbolExport = symbol.exports.get(prototypeSymbol.escapedName);
            if (symbolExport) {
                if (node.name) setParent(node.name, node);
                file.bindDiagnostics.push(createDiagnosticForNode2(symbolExport.declarations[0], Diagnostics.Duplicate_identifier_0, symbolName(prototypeSymbol)));
            }
            symbol.exports.set(prototypeSymbol.escapedName, prototypeSymbol);
            prototypeSymbol.parent = symbol;
        }
        function bindEnumDeclaration(node) {
            return isEnumConst(node) ? bindBlockScopedDeclaration(node, 128 /* ConstEnum */ , 899967 /* ConstEnumExcludes */ ) : bindBlockScopedDeclaration(node, 256 /* RegularEnum */ , 899327 /* RegularEnumExcludes */ );
        }
        function bindVariableDeclarationOrBindingElement(node) {
            if (inStrictMode) checkStrictModeEvalOrArguments(node, node.name);
            if (!isBindingPattern(node.name)) {
                const possibleVariableDecl = node.kind === 259 /* VariableDeclaration */  ? node : node.parent.parent;
                if (isInJSFile(node) && shouldResolveJsRequire(options) && isVariableDeclarationInitializedToBareOrAccessedRequire(possibleVariableDecl) && !getJSDocTypeTag(node) && !(getCombinedModifierFlags(node) & 1 /* Export */ )) declareSymbolAndAddToSymbolTable(node, 2097152 /* Alias */ , 2097152 /* AliasExcludes */ );
                else if (isBlockOrCatchScoped(node)) bindBlockScopedDeclaration(node, 2 /* BlockScopedVariable */ , 111551 /* BlockScopedVariableExcludes */ );
                else if (isParameterDeclaration(node)) declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */ , 111551 /* ParameterExcludes */ );
                else declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */ , 111550 /* FunctionScopedVariableExcludes */ );
            }
        }
        function bindParameter(node) {
            if (node.kind === 347 /* JSDocParameterTag */  && container.kind !== 329 /* JSDocSignature */ ) return;
            if (inStrictMode && !(node.flags & 16777216 /* Ambient */ )) checkStrictModeEvalOrArguments(node, node.name);
            if (isBindingPattern(node.name)) bindAnonymousDeclaration(node, 1 /* FunctionScopedVariable */ , "__" + node.parent.parameters.indexOf(node));
            else declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */ , 111551 /* ParameterExcludes */ );
            if (isParameterPropertyDeclaration(node, node.parent)) {
                const classDeclaration = node.parent.parent;
                declareSymbol(classDeclaration.symbol.members, classDeclaration.symbol, node, 4 /* Property */  | (node.questionToken ? 16777216 /* Optional */  : 0 /* None */ ), 0 /* PropertyExcludes */ );
            }
        }
        function bindFunctionDeclaration(node) {
            if (!file.isDeclarationFile && !(node.flags & 16777216 /* Ambient */ )) {
                if (isAsyncFunction(node)) emitFlags |= 2048 /* HasAsyncFunctions */ ;
            }
            checkStrictModeFunctionName(node);
            if (inStrictMode) {
                checkStrictModeFunctionDeclaration(node);
                bindBlockScopedDeclaration(node, 16 /* Function */ , 110991 /* FunctionExcludes */ );
            } else declareSymbolAndAddToSymbolTable(node, 16 /* Function */ , 110991 /* FunctionExcludes */ );
        }
        function bindFunctionExpression(node) {
            if (!file.isDeclarationFile && !(node.flags & 16777216 /* Ambient */ )) {
                if (isAsyncFunction(node)) emitFlags |= 2048 /* HasAsyncFunctions */ ;
            }
            if (currentFlow) node.flowNode = currentFlow;
            checkStrictModeFunctionName(node);
            const bindingName = node.name ? node.name.escapedText : "__function" /* Function */ ;
            return bindAnonymousDeclaration(node, 16 /* Function */ , bindingName);
        }
        function bindPropertyOrMethodOrAccessor(node, symbolFlags, symbolExcludes) {
            if (!file.isDeclarationFile && !(node.flags & 16777216 /* Ambient */ ) && isAsyncFunction(node)) emitFlags |= 2048 /* HasAsyncFunctions */ ;
            if (currentFlow && isObjectLiteralOrClassExpressionMethodOrAccessor(node)) node.flowNode = currentFlow;
            return hasDynamicName(node) ? bindAnonymousDeclaration(node, symbolFlags, "__computed" /* Computed */ ) : declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes);
        }
        function getInferTypeContainer(node) {
            const extendsType = findAncestor(node, (n)=>n.parent && isConditionalTypeNode(n.parent) && n.parent.extendsType === n);
            return extendsType && extendsType.parent;
        }
        function bindTypeParameter(node) {
            if (isJSDocTemplateTag(node.parent)) {
                const container2 = getEffectiveContainerForJSDocTemplateTag(node.parent);
                if (container2) {
                    Debug.assertNode(container2, canHaveLocals);
                    container2.locals ?? (container2.locals = createSymbolTable());
                    declareSymbol(container2.locals, /*parent*/ void 0, node, 262144 /* TypeParameter */ , 526824 /* TypeParameterExcludes */ );
                } else declareSymbolAndAddToSymbolTable(node, 262144 /* TypeParameter */ , 526824 /* TypeParameterExcludes */ );
            } else if (node.parent.kind === 194 /* InferType */ ) {
                const container2 = getInferTypeContainer(node.parent);
                if (container2) {
                    Debug.assertNode(container2, canHaveLocals);
                    container2.locals ?? (container2.locals = createSymbolTable());
                    declareSymbol(container2.locals, /*parent*/ void 0, node, 262144 /* TypeParameter */ , 526824 /* TypeParameterExcludes */ );
                } else bindAnonymousDeclaration(node, 262144 /* TypeParameter */ , getDeclarationName(node));
            } else declareSymbolAndAddToSymbolTable(node, 262144 /* TypeParameter */ , 526824 /* TypeParameterExcludes */ );
        }
        function shouldReportErrorOnModuleDeclaration(node) {
            const instanceState = getModuleInstanceState(node);
            return instanceState === 1 /* Instantiated */  || instanceState === 2 /* ConstEnumOnly */  && shouldPreserveConstEnums(options);
        }
        function checkUnreachable(node) {
            if (!(currentFlow.flags & 1 /* Unreachable */ )) return false;
            if (currentFlow === unreachableFlow) {
                const reportError = // report error on all statements except empty ones
                isStatementButNotDeclaration(node) && node.kind !== 241 /* EmptyStatement */  || // report error on class declarations
                node.kind === 262 /* ClassDeclaration */  || // report error on instantiated modules or const-enums only modules if preserveConstEnums is set
                node.kind === 266 /* ModuleDeclaration */  && shouldReportErrorOnModuleDeclaration(node);
                if (reportError) {
                    currentFlow = reportedUnreachableFlow;
                    if (!options.allowUnreachableCode) {
                        const isError = unreachableCodeIsError(options) && !(node.flags & 16777216 /* Ambient */ ) && (!isVariableStatement(node) || !!(getCombinedNodeFlags(node.declarationList) & 3 /* BlockScoped */ ) || node.declarationList.declarations.some((d)=>!!d.initializer));
                        eachUnreachableRange(node, (start, end)=>errorOrSuggestionOnRange(isError, start, end, Diagnostics.Unreachable_code_detected));
                    }
                }
            }
            return true;
        }
    }
    function eachUnreachableRange(node, cb) {
        if (isStatement(node) && isExecutableStatement(node) && isBlock(node.parent)) {
            const { statements: statements  } = node.parent;
            const slice = sliceAfter(statements, node);
            getRangesWhere(slice, isExecutableStatement, (start, afterEnd)=>cb(slice[start], slice[afterEnd - 1]));
        } else cb(node, node);
    }
    function isExecutableStatement(s) {
        return !isFunctionDeclaration(s) && !isPurelyTypeDeclaration(s) && !isEnumDeclaration(s) && // `var x;` may declare a variable used above
        !(isVariableStatement(s) && !(getCombinedNodeFlags(s) & 3 /* Const */ ) && s.declarationList.declarations.some((d)=>!d.initializer));
    }
    function isPurelyTypeDeclaration(s) {
        switch(s.kind){
            case 263 /* InterfaceDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
                return true;
            case 266 /* ModuleDeclaration */ :
                return getModuleInstanceState(s) !== 1 /* Instantiated */ ;
            case 265 /* EnumDeclaration */ :
                return hasSyntacticModifier(s, 2048 /* Const */ );
            default:
                return false;
        }
    }
    function isExportsOrModuleExportsOrAlias(sourceFile, node) {
        let i = 0;
        const q = createQueue();
        q.enqueue(node);
        while(!q.isEmpty() && i < 100){
            i++;
            node = q.dequeue();
            if (isExportsIdentifier(node) || isModuleExportsAccessExpression(node)) return true;
            else if (isIdentifier(node)) {
                const symbol = lookupSymbolForName(sourceFile, node.escapedText);
                if (!!symbol && !!symbol.valueDeclaration && isVariableDeclaration(symbol.valueDeclaration) && !!symbol.valueDeclaration.initializer) {
                    const init = symbol.valueDeclaration.initializer;
                    q.enqueue(init);
                    if (isAssignmentExpression(init, /*excludeCompoundAssignment*/ true)) {
                        q.enqueue(init.left);
                        q.enqueue(init.right);
                    }
                }
            }
        }
        return false;
    }
    function getContainerFlags(node) {
        switch(node.kind){
            case 230 /* ClassExpression */ :
            case 262 /* ClassDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 209 /* ObjectLiteralExpression */ :
            case 186 /* TypeLiteral */ :
            case 328 /* JSDocTypeLiteral */ :
            case 291 /* JsxAttributes */ :
                return 1 /* IsContainer */ ;
            case 263 /* InterfaceDeclaration */ :
                return 65 /* IsInterface */ ;
            case 266 /* ModuleDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
            case 199 /* MappedType */ :
            case 180 /* IndexSignature */ :
                return 33 /* HasLocals */ ;
            case 311 /* SourceFile */ :
                return 37 /* HasLocals */ ;
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 173 /* MethodDeclaration */ :
                if (isObjectLiteralOrClassExpressionMethodOrAccessor(node)) return 173 /* IsObjectLiteralOrClassExpressionMethodOrAccessor */ ;
            case 175 /* Constructor */ :
            case 261 /* FunctionDeclaration */ :
            case 172 /* MethodSignature */ :
            case 178 /* CallSignature */ :
            case 329 /* JSDocSignature */ :
            case 323 /* JSDocFunctionType */ :
            case 183 /* FunctionType */ :
            case 179 /* ConstructSignature */ :
            case 184 /* ConstructorType */ :
            case 174 /* ClassStaticBlockDeclaration */ :
                return 45 /* IsFunctionLike */ ;
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
                return 61 /* IsFunctionExpression */ ;
            case 267 /* ModuleBlock */ :
                return 4 /* IsControlFlowContainer */ ;
            case 171 /* PropertyDeclaration */ :
                return node.initializer ? 4 /* IsControlFlowContainer */  : 0;
            case 298 /* CatchClause */ :
            case 247 /* ForStatement */ :
            case 248 /* ForInStatement */ :
            case 249 /* ForOfStatement */ :
            case 268 /* CaseBlock */ :
                return 34 /* HasLocals */ ;
            case 240 /* Block */ :
                return isFunctionLike(node.parent) || isClassStaticBlockDeclaration(node.parent) ? 0 /* None */  : 34 /* HasLocals */ ;
        }
        return 0 /* None */ ;
    }
    function lookupSymbolForName(container, name) {
        var _a, _b, _c, _d;
        const local = (_b = (_a = tryCast(container, canHaveLocals)) == null ? void 0 : _a.locals) == null ? void 0 : _b.get(name);
        if (local) return local.exportSymbol ?? local;
        if (isSourceFile(container) && container.jsGlobalAugmentations && container.jsGlobalAugmentations.has(name)) return container.jsGlobalAugmentations.get(name);
        if (canHaveSymbol(container)) return (_d = (_c = container.symbol) == null ? void 0 : _c.exports) == null ? void 0 : _d.get(name);
    }
    var ModuleInstanceState, binder;
    var init_binder = __esm({
        "src/compiler/binder.ts" () {
            "use strict";
            init_ts2();
            init_ts_performance();
            ModuleInstanceState = /* @__PURE__ */ ((ModuleInstanceState2)=>{
                ModuleInstanceState2[ModuleInstanceState2["NonInstantiated"] = 0] = "NonInstantiated";
                ModuleInstanceState2[ModuleInstanceState2["Instantiated"] = 1] = "Instantiated";
                ModuleInstanceState2[ModuleInstanceState2["ConstEnumOnly"] = 2] = "ConstEnumOnly";
                return ModuleInstanceState2;
            })(ModuleInstanceState || {});
            binder = /* @__PURE__ */ createBinder();
        }
    });
    // src/compiler/symbolWalker.ts
    function createGetSymbolWalker(getRestTypeOfSignature, getTypePredicateOfSignature, getReturnTypeOfSignature, getBaseTypes, resolveStructuredTypeMembers, getTypeOfSymbol, getResolvedSymbol, getConstraintOfTypeParameter, getFirstIdentifier2, getTypeArguments) {
        return getSymbolWalker;
        function getSymbolWalker(accept = ()=>true) {
            const visitedTypes = [];
            const visitedSymbols = [];
            return {
                walkType: (type)=>{
                    try {
                        visitType(type);
                        return {
                            visitedTypes: getOwnValues(visitedTypes),
                            visitedSymbols: getOwnValues(visitedSymbols)
                        };
                    } finally{
                        clear(visitedTypes);
                        clear(visitedSymbols);
                    }
                },
                walkSymbol: (symbol)=>{
                    try {
                        visitSymbol(symbol);
                        return {
                            visitedTypes: getOwnValues(visitedTypes),
                            visitedSymbols: getOwnValues(visitedSymbols)
                        };
                    } finally{
                        clear(visitedTypes);
                        clear(visitedSymbols);
                    }
                }
            };
            function visitType(type) {
                if (!type) return;
                if (visitedTypes[type.id]) return;
                visitedTypes[type.id] = type;
                const shouldBail = visitSymbol(type.symbol);
                if (shouldBail) return;
                if (type.flags & 524288 /* Object */ ) {
                    const objectType = type;
                    const objectFlags = objectType.objectFlags;
                    if (objectFlags & 4 /* Reference */ ) visitTypeReference(type);
                    if (objectFlags & 32 /* Mapped */ ) visitMappedType(type);
                    if (objectFlags & 3 /* Interface */ ) visitInterfaceType(type);
                    if (objectFlags & 24 /* Anonymous */ ) visitObjectType(objectType);
                }
                if (type.flags & 262144 /* TypeParameter */ ) visitTypeParameter(type);
                if (type.flags & 3145728 /* UnionOrIntersection */ ) visitUnionOrIntersectionType(type);
                if (type.flags & 4194304 /* Index */ ) visitIndexType(type);
                if (type.flags & 8388608 /* IndexedAccess */ ) visitIndexedAccessType(type);
            }
            function visitTypeReference(type) {
                visitType(type.target);
                forEach(getTypeArguments(type), visitType);
            }
            function visitTypeParameter(type) {
                visitType(getConstraintOfTypeParameter(type));
            }
            function visitUnionOrIntersectionType(type) {
                forEach(type.types, visitType);
            }
            function visitIndexType(type) {
                visitType(type.type);
            }
            function visitIndexedAccessType(type) {
                visitType(type.objectType);
                visitType(type.indexType);
                visitType(type.constraint);
            }
            function visitMappedType(type) {
                visitType(type.typeParameter);
                visitType(type.constraintType);
                visitType(type.templateType);
                visitType(type.modifiersType);
            }
            function visitSignature(signature) {
                const typePredicate = getTypePredicateOfSignature(signature);
                if (typePredicate) visitType(typePredicate.type);
                forEach(signature.typeParameters, visitType);
                for (const parameter of signature.parameters)visitSymbol(parameter);
                visitType(getRestTypeOfSignature(signature));
                visitType(getReturnTypeOfSignature(signature));
            }
            function visitInterfaceType(interfaceT) {
                visitObjectType(interfaceT);
                forEach(interfaceT.typeParameters, visitType);
                forEach(getBaseTypes(interfaceT), visitType);
                visitType(interfaceT.thisType);
            }
            function visitObjectType(type) {
                const resolved = resolveStructuredTypeMembers(type);
                for (const info of resolved.indexInfos){
                    visitType(info.keyType);
                    visitType(info.type);
                }
                for (const signature of resolved.callSignatures)visitSignature(signature);
                for (const signature of resolved.constructSignatures)visitSignature(signature);
                for (const p of resolved.properties)visitSymbol(p);
            }
            function visitSymbol(symbol) {
                if (!symbol) return false;
                const symbolId = getSymbolId(symbol);
                if (visitedSymbols[symbolId]) return false;
                visitedSymbols[symbolId] = symbol;
                if (!accept(symbol)) return true;
                const t = getTypeOfSymbol(symbol);
                visitType(t);
                if (symbol.exports) symbol.exports.forEach(visitSymbol);
                forEach(symbol.declarations, (d)=>{
                    if (d.type && d.type.kind === 185 /* TypeQuery */ ) {
                        const query = d.type;
                        const entity = getResolvedSymbol(getFirstIdentifier2(query.exprName));
                        visitSymbol(entity);
                    }
                });
                return false;
            }
        }
    }
    var init_symbolWalker = __esm({
        "src/compiler/symbolWalker.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/moduleSpecifiers.ts
    function getPreferences({ importModuleSpecifierPreference: importModuleSpecifierPreference , importModuleSpecifierEnding: importModuleSpecifierEnding  }, compilerOptions, importingSourceFile, oldImportSpecifier) {
        const preferredEnding = getPreferredEnding();
        return {
            relativePreference: oldImportSpecifier !== void 0 ? isExternalModuleNameRelative(oldImportSpecifier) ? 0 /* Relative */  : 1 /* NonRelative */  : importModuleSpecifierPreference === "relative" ? 0 /* Relative */  : importModuleSpecifierPreference === "non-relative" ? 1 /* NonRelative */  : importModuleSpecifierPreference === "project-relative" ? 3 /* ExternalNonRelative */  : 2 /* Shortest */ ,
            getAllowedEndingsInPreferredOrder: (syntaxImpliedNodeFormat)=>{
                if ((syntaxImpliedNodeFormat ?? importingSourceFile.impliedNodeFormat) === 99 /* ESNext */ ) {
                    if (shouldAllowImportingTsExtension(compilerOptions, importingSourceFile.fileName)) return [
                        3 /* TsExtension */ ,
                        2 /* JsExtension */ 
                    ];
                    return [
                        2 /* JsExtension */ 
                    ];
                }
                if (getEmitModuleResolutionKind(compilerOptions) === 1 /* Classic */ ) return preferredEnding === 2 /* JsExtension */  ? [
                    2 /* JsExtension */ ,
                    1 /* Index */ 
                ] : [
                    1 /* Index */ ,
                    2 /* JsExtension */ 
                ];
                const allowImportingTsExtension = shouldAllowImportingTsExtension(compilerOptions, importingSourceFile.fileName);
                switch(preferredEnding){
                    case 2 /* JsExtension */ :
                        return allowImportingTsExtension ? [
                            2 /* JsExtension */ ,
                            3 /* TsExtension */ ,
                            0 /* Minimal */ ,
                            1 /* Index */ 
                        ] : [
                            2 /* JsExtension */ ,
                            0 /* Minimal */ ,
                            1 /* Index */ 
                        ];
                    case 3 /* TsExtension */ :
                        return [
                            3 /* TsExtension */ ,
                            0 /* Minimal */ ,
                            2 /* JsExtension */ ,
                            1 /* Index */ 
                        ];
                    case 1 /* Index */ :
                        return allowImportingTsExtension ? [
                            1 /* Index */ ,
                            0 /* Minimal */ ,
                            3 /* TsExtension */ ,
                            2 /* JsExtension */ 
                        ] : [
                            1 /* Index */ ,
                            0 /* Minimal */ ,
                            2 /* JsExtension */ 
                        ];
                    case 0 /* Minimal */ :
                        return allowImportingTsExtension ? [
                            0 /* Minimal */ ,
                            1 /* Index */ ,
                            3 /* TsExtension */ ,
                            2 /* JsExtension */ 
                        ] : [
                            0 /* Minimal */ ,
                            1 /* Index */ ,
                            2 /* JsExtension */ 
                        ];
                    default:
                        Debug.assertNever(preferredEnding);
                }
            }
        };
        function getPreferredEnding() {
            if (oldImportSpecifier !== void 0) {
                if (hasJSFileExtension(oldImportSpecifier)) return 2 /* JsExtension */ ;
                if (endsWith(oldImportSpecifier, "/index")) return 1 /* Index */ ;
            }
            return getModuleSpecifierEndingPreference(importModuleSpecifierEnding, importingSourceFile.impliedNodeFormat, compilerOptions, importingSourceFile);
        }
    }
    function updateModuleSpecifier(compilerOptions, importingSourceFile, importingSourceFileName, toFileName2, host, oldImportSpecifier, options = {}) {
        const res = getModuleSpecifierWorker(compilerOptions, importingSourceFile, importingSourceFileName, toFileName2, host, getPreferences({}, compilerOptions, importingSourceFile, oldImportSpecifier), {}, options);
        if (res === oldImportSpecifier) return void 0;
        return res;
    }
    function getModuleSpecifier(compilerOptions, importingSourceFile, importingSourceFileName, toFileName2, host, options = {}) {
        return getModuleSpecifierWorker(compilerOptions, importingSourceFile, importingSourceFileName, toFileName2, host, getPreferences({}, compilerOptions, importingSourceFile), {}, options);
    }
    function getNodeModulesPackageName(compilerOptions, importingSourceFile, nodeModulesFileName, host, preferences, options = {}) {
        const info = getInfo(importingSourceFile.path, host);
        const modulePaths = getAllModulePaths(importingSourceFile.path, nodeModulesFileName, host, preferences, options);
        return firstDefined(modulePaths, (modulePath)=>tryGetModuleNameAsNodeModule(modulePath, info, importingSourceFile, host, compilerOptions, preferences, /*packageNameOnly*/ true, options.overrideImportMode));
    }
    function getModuleSpecifierWorker(compilerOptions, importingSourceFile, importingSourceFileName, toFileName2, host, preferences, userPreferences, options = {}) {
        const info = getInfo(importingSourceFileName, host);
        const modulePaths = getAllModulePaths(importingSourceFileName, toFileName2, host, userPreferences, options);
        return firstDefined(modulePaths, (modulePath)=>tryGetModuleNameAsNodeModule(modulePath, info, importingSourceFile, host, compilerOptions, userPreferences, /*packageNameOnly*/ void 0, options.overrideImportMode)) || getLocalModuleSpecifier(toFileName2, info, compilerOptions, host, options.overrideImportMode || importingSourceFile.impliedNodeFormat, preferences);
    }
    function tryGetModuleSpecifiersFromCache(moduleSymbol, importingSourceFile, host, userPreferences, options = {}) {
        return tryGetModuleSpecifiersFromCacheWorker(moduleSymbol, importingSourceFile, host, userPreferences, options)[0];
    }
    function tryGetModuleSpecifiersFromCacheWorker(moduleSymbol, importingSourceFile, host, userPreferences, options = {}) {
        var _a;
        const moduleSourceFile = getSourceFileOfModule(moduleSymbol);
        if (!moduleSourceFile) return emptyArray;
        const cache = (_a = host.getModuleSpecifierCache) == null ? void 0 : _a.call(host);
        const cached = cache == null ? void 0 : cache.get(importingSourceFile.path, moduleSourceFile.path, userPreferences, options);
        return [
            cached == null ? void 0 : cached.moduleSpecifiers,
            moduleSourceFile,
            cached == null ? void 0 : cached.modulePaths,
            cache
        ];
    }
    function getModuleSpecifiers(moduleSymbol, checker, compilerOptions, importingSourceFile, host, userPreferences, options = {}) {
        return getModuleSpecifiersWithCacheInfo(moduleSymbol, checker, compilerOptions, importingSourceFile, host, userPreferences, options).moduleSpecifiers;
    }
    function getModuleSpecifiersWithCacheInfo(moduleSymbol, checker, compilerOptions, importingSourceFile, host, userPreferences, options = {}) {
        let computedWithoutCache = false;
        const ambient = tryGetModuleNameFromAmbientModule(moduleSymbol, checker);
        if (ambient) return {
            moduleSpecifiers: [
                ambient
            ],
            computedWithoutCache: computedWithoutCache
        };
        let [specifiers, moduleSourceFile, modulePaths, cache] = tryGetModuleSpecifiersFromCacheWorker(moduleSymbol, importingSourceFile, host, userPreferences, options);
        if (specifiers) return {
            moduleSpecifiers: specifiers,
            computedWithoutCache: computedWithoutCache
        };
        if (!moduleSourceFile) return {
            moduleSpecifiers: emptyArray,
            computedWithoutCache: computedWithoutCache
        };
        computedWithoutCache = true;
        modulePaths || (modulePaths = getAllModulePathsWorker(importingSourceFile.path, moduleSourceFile.originalFileName, host));
        const result = computeModuleSpecifiers(modulePaths, compilerOptions, importingSourceFile, host, userPreferences, options);
        cache == null || cache.set(importingSourceFile.path, moduleSourceFile.path, userPreferences, options, modulePaths, result);
        return {
            moduleSpecifiers: result,
            computedWithoutCache: computedWithoutCache
        };
    }
    function computeModuleSpecifiers(modulePaths, compilerOptions, importingSourceFile, host, userPreferences, options = {}) {
        const info = getInfo(importingSourceFile.path, host);
        const preferences = getPreferences(userPreferences, compilerOptions, importingSourceFile);
        const existingSpecifier = forEach(modulePaths, (modulePath)=>forEach(host.getFileIncludeReasons().get(toPath(modulePath.path, host.getCurrentDirectory(), info.getCanonicalFileName)), (reason)=>{
                if (reason.kind !== 3 /* Import */  || reason.file !== importingSourceFile.path) return void 0;
                if (importingSourceFile.impliedNodeFormat && importingSourceFile.impliedNodeFormat !== getModeForResolutionAtIndex(importingSourceFile, reason.index)) return void 0;
                const specifier = getModuleNameStringLiteralAt(importingSourceFile, reason.index).text;
                return preferences.relativePreference !== 1 /* NonRelative */  || !pathIsRelative(specifier) ? specifier : void 0;
            }));
        if (existingSpecifier) {
            const moduleSpecifiers = [
                existingSpecifier
            ];
            return moduleSpecifiers;
        }
        const importedFileIsInNodeModules = some(modulePaths, (p)=>p.isInNodeModules);
        let nodeModulesSpecifiers;
        let pathsSpecifiers;
        let redirectPathsSpecifiers;
        let relativeSpecifiers;
        for (const modulePath of modulePaths){
            const specifier = modulePath.isInNodeModules ? tryGetModuleNameAsNodeModule(modulePath, info, importingSourceFile, host, compilerOptions, userPreferences, /*packageNameOnly*/ void 0, options.overrideImportMode) : void 0;
            nodeModulesSpecifiers = append(nodeModulesSpecifiers, specifier);
            if (specifier && modulePath.isRedirect) return nodeModulesSpecifiers;
            if (!specifier) {
                const local = getLocalModuleSpecifier(modulePath.path, info, compilerOptions, host, options.overrideImportMode || importingSourceFile.impliedNodeFormat, preferences, /*pathsOnly*/ modulePath.isRedirect);
                if (!local) continue;
                if (modulePath.isRedirect) redirectPathsSpecifiers = append(redirectPathsSpecifiers, local);
                else if (pathIsBareSpecifier(local)) pathsSpecifiers = append(pathsSpecifiers, local);
                else if (!importedFileIsInNodeModules || modulePath.isInNodeModules) relativeSpecifiers = append(relativeSpecifiers, local);
            }
        }
        return (pathsSpecifiers == null ? void 0 : pathsSpecifiers.length) ? pathsSpecifiers : (redirectPathsSpecifiers == null ? void 0 : redirectPathsSpecifiers.length) ? redirectPathsSpecifiers : (nodeModulesSpecifiers == null ? void 0 : nodeModulesSpecifiers.length) ? nodeModulesSpecifiers : Debug.checkDefined(relativeSpecifiers);
    }
    function getInfo(importingSourceFileName, host) {
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames ? host.useCaseSensitiveFileNames() : true);
        const sourceDirectory = getDirectoryPath(importingSourceFileName);
        return {
            getCanonicalFileName: getCanonicalFileName,
            importingSourceFileName: importingSourceFileName,
            sourceDirectory: sourceDirectory
        };
    }
    function getLocalModuleSpecifier(moduleFileName, info, compilerOptions, host, importMode, { getAllowedEndingsInPreferredOrder: getAllowedEndingsInPrefererredOrder , relativePreference: relativePreference  }, pathsOnly) {
        const { baseUrl: baseUrl , paths: paths , rootDirs: rootDirs  } = compilerOptions;
        if (pathsOnly && !paths) return void 0;
        const { sourceDirectory: sourceDirectory , getCanonicalFileName: getCanonicalFileName  } = info;
        const allowedEndings = getAllowedEndingsInPrefererredOrder(importMode);
        const relativePath = rootDirs && tryGetModuleNameFromRootDirs(rootDirs, moduleFileName, sourceDirectory, getCanonicalFileName, allowedEndings, compilerOptions) || processEnding(ensurePathIsNonModuleName(getRelativePathFromDirectory(sourceDirectory, moduleFileName, getCanonicalFileName)), allowedEndings, compilerOptions);
        if (!baseUrl && !paths || relativePreference === 0 /* Relative */ ) return pathsOnly ? void 0 : relativePath;
        const baseDirectory = getNormalizedAbsolutePath(getPathsBasePath(compilerOptions, host) || baseUrl, host.getCurrentDirectory());
        const relativeToBaseUrl = getRelativePathIfInSameVolume(moduleFileName, baseDirectory, getCanonicalFileName);
        if (!relativeToBaseUrl) return pathsOnly ? void 0 : relativePath;
        const fromPaths = paths && tryGetModuleNameFromPaths(relativeToBaseUrl, paths, allowedEndings, host, compilerOptions);
        if (pathsOnly) return fromPaths;
        const maybeNonRelative = fromPaths === void 0 && baseUrl !== void 0 ? processEnding(relativeToBaseUrl, allowedEndings, compilerOptions) : fromPaths;
        if (!maybeNonRelative) return relativePath;
        if (relativePreference === 1 /* NonRelative */  && !pathIsRelative(maybeNonRelative)) return maybeNonRelative;
        if (relativePreference === 3 /* ExternalNonRelative */  && !pathIsRelative(maybeNonRelative)) {
            const projectDirectory = compilerOptions.configFilePath ? toPath(getDirectoryPath(compilerOptions.configFilePath), host.getCurrentDirectory(), info.getCanonicalFileName) : info.getCanonicalFileName(host.getCurrentDirectory());
            const modulePath = toPath(moduleFileName, projectDirectory, getCanonicalFileName);
            const sourceIsInternal = startsWith(sourceDirectory, projectDirectory);
            const targetIsInternal = startsWith(modulePath, projectDirectory);
            if (sourceIsInternal && !targetIsInternal || !sourceIsInternal && targetIsInternal) return maybeNonRelative;
            const nearestTargetPackageJson = getNearestAncestorDirectoryWithPackageJson(host, getDirectoryPath(modulePath));
            const nearestSourcePackageJson = getNearestAncestorDirectoryWithPackageJson(host, sourceDirectory);
            if (nearestSourcePackageJson !== nearestTargetPackageJson) return maybeNonRelative;
            return relativePath;
        }
        return isPathRelativeToParent(maybeNonRelative) || countPathComponents(relativePath) < countPathComponents(maybeNonRelative) ? relativePath : maybeNonRelative;
    }
    function countPathComponents(path) {
        let count = 0;
        for(let i = startsWith(path, "./") ? 2 : 0; i < path.length; i++)if (path.charCodeAt(i) === 47 /* slash */ ) count++;
        return count;
    }
    function comparePathsByRedirectAndNumberOfDirectorySeparators(a, b) {
        return compareBooleans(b.isRedirect, a.isRedirect) || compareNumberOfDirectorySeparators(a.path, b.path);
    }
    function getNearestAncestorDirectoryWithPackageJson(host, fileName) {
        if (host.getNearestAncestorDirectoryWithPackageJson) return host.getNearestAncestorDirectoryWithPackageJson(fileName);
        return !!forEachAncestorDirectory(fileName, (directory)=>{
            return host.fileExists(combinePaths(directory, "package.json")) ? true : void 0;
        });
    }
    function forEachFileNameOfModule(importingFileName, importedFileName, host, preferSymlinks, cb) {
        var _a;
        const getCanonicalFileName = hostGetCanonicalFileName(host);
        const cwd = host.getCurrentDirectory();
        const referenceRedirect = host.isSourceOfProjectReferenceRedirect(importedFileName) ? host.getProjectReferenceRedirect(importedFileName) : void 0;
        const importedPath = toPath(importedFileName, cwd, getCanonicalFileName);
        const redirects = host.redirectTargetsMap.get(importedPath) || emptyArray;
        const importedFileNames = [
            ...referenceRedirect ? [
                referenceRedirect
            ] : emptyArray,
            importedFileName,
            ...redirects
        ];
        const targets = importedFileNames.map((f)=>getNormalizedAbsolutePath(f, cwd));
        let shouldFilterIgnoredPaths = !every(targets, containsIgnoredPath);
        if (!preferSymlinks) {
            const result2 = forEach(targets, (p)=>!(shouldFilterIgnoredPaths && containsIgnoredPath(p)) && cb(p, referenceRedirect === p));
            if (result2) return result2;
        }
        const symlinkedDirectories = (_a = host.getSymlinkCache) == null ? void 0 : _a.call(host).getSymlinkedDirectoriesByRealpath();
        const fullImportedFileName = getNormalizedAbsolutePath(importedFileName, cwd);
        const result = symlinkedDirectories && forEachAncestorDirectory(getDirectoryPath(fullImportedFileName), (realPathDirectory)=>{
            const symlinkDirectories = symlinkedDirectories.get(ensureTrailingDirectorySeparator(toPath(realPathDirectory, cwd, getCanonicalFileName)));
            if (!symlinkDirectories) return void 0;
            if (startsWithDirectory(importingFileName, realPathDirectory, getCanonicalFileName)) return false;
            return forEach(targets, (target)=>{
                if (!startsWithDirectory(target, realPathDirectory, getCanonicalFileName)) return;
                const relative = getRelativePathFromDirectory(realPathDirectory, target, getCanonicalFileName);
                for (const symlinkDirectory of symlinkDirectories){
                    const option = resolvePath(symlinkDirectory, relative);
                    const result2 = cb(option, target === referenceRedirect);
                    shouldFilterIgnoredPaths = true;
                    if (result2) return result2;
                }
            });
        });
        return result || (preferSymlinks ? forEach(targets, (p)=>shouldFilterIgnoredPaths && containsIgnoredPath(p) ? void 0 : cb(p, p === referenceRedirect)) : void 0);
    }
    function getAllModulePaths(importingFilePath, importedFileName, host, preferences, options = {}) {
        var _a;
        const importedFilePath = toPath(importedFileName, host.getCurrentDirectory(), hostGetCanonicalFileName(host));
        const cache = (_a = host.getModuleSpecifierCache) == null ? void 0 : _a.call(host);
        if (cache) {
            const cached = cache.get(importingFilePath, importedFilePath, preferences, options);
            if (cached == null ? void 0 : cached.modulePaths) return cached.modulePaths;
        }
        const modulePaths = getAllModulePathsWorker(importingFilePath, importedFileName, host);
        if (cache) cache.setModulePaths(importingFilePath, importedFilePath, preferences, options, modulePaths);
        return modulePaths;
    }
    function getAllModulePathsWorker(importingFileName, importedFileName, host) {
        const getCanonicalFileName = hostGetCanonicalFileName(host);
        const allFileNames = /* @__PURE__ */ new Map();
        let importedFileFromNodeModules = false;
        forEachFileNameOfModule(importingFileName, importedFileName, host, /*preferSymlinks*/ true, (path, isRedirect)=>{
            const isInNodeModules = pathContainsNodeModules(path);
            allFileNames.set(path, {
                path: getCanonicalFileName(path),
                isRedirect: isRedirect,
                isInNodeModules: isInNodeModules
            });
            importedFileFromNodeModules = importedFileFromNodeModules || isInNodeModules;
        });
        const sortedPaths = [];
        for(let directory = getDirectoryPath(importingFileName); allFileNames.size !== 0;){
            const directoryStart = ensureTrailingDirectorySeparator(directory);
            let pathsInDirectory;
            allFileNames.forEach(({ path: path , isRedirect: isRedirect , isInNodeModules: isInNodeModules  }, fileName)=>{
                if (startsWith(path, directoryStart)) {
                    (pathsInDirectory || (pathsInDirectory = [])).push({
                        path: fileName,
                        isRedirect: isRedirect,
                        isInNodeModules: isInNodeModules
                    });
                    allFileNames.delete(fileName);
                }
            });
            if (pathsInDirectory) {
                if (pathsInDirectory.length > 1) pathsInDirectory.sort(comparePathsByRedirectAndNumberOfDirectorySeparators);
                sortedPaths.push(...pathsInDirectory);
            }
            const newDirectory = getDirectoryPath(directory);
            if (newDirectory === directory) break;
            directory = newDirectory;
        }
        if (allFileNames.size) {
            const remainingPaths = arrayFrom(allFileNames.values());
            if (remainingPaths.length > 1) remainingPaths.sort(comparePathsByRedirectAndNumberOfDirectorySeparators);
            sortedPaths.push(...remainingPaths);
        }
        return sortedPaths;
    }
    function tryGetModuleNameFromAmbientModule(moduleSymbol, checker) {
        var _a;
        const decl = (_a = moduleSymbol.declarations) == null ? void 0 : _a.find((d)=>isNonGlobalAmbientModule(d) && (!isExternalModuleAugmentation(d) || !isExternalModuleNameRelative(getTextOfIdentifierOrLiteral(d.name))));
        if (decl) return decl.name.text;
        const ambientModuleDeclareCandidates = mapDefined(moduleSymbol.declarations, (d)=>{
            var _a2, _b, _c, _d;
            if (!isModuleDeclaration(d)) return;
            const topNamespace = getTopNamespace(d);
            if (!(((_a2 = topNamespace == null ? void 0 : topNamespace.parent) == null ? void 0 : _a2.parent) && isModuleBlock(topNamespace.parent) && isAmbientModule(topNamespace.parent.parent) && isSourceFile(topNamespace.parent.parent.parent))) return;
            const exportAssignment = (_d = (_c = (_b = topNamespace.parent.parent.symbol.exports) == null ? void 0 : _b.get("export=")) == null ? void 0 : _c.valueDeclaration) == null ? void 0 : _d.expression;
            if (!exportAssignment) return;
            const exportSymbol = checker.getSymbolAtLocation(exportAssignment);
            if (!exportSymbol) return;
            const originalExportSymbol = (exportSymbol == null ? void 0 : exportSymbol.flags) & 2097152 /* Alias */  ? checker.getAliasedSymbol(exportSymbol) : exportSymbol;
            if (originalExportSymbol === d.symbol) return topNamespace.parent.parent;
            function getTopNamespace(namespaceDeclaration) {
                while(namespaceDeclaration.flags & 4 /* NestedNamespace */ )namespaceDeclaration = namespaceDeclaration.parent;
                return namespaceDeclaration;
            }
        });
        const ambientModuleDeclare = ambientModuleDeclareCandidates[0];
        if (ambientModuleDeclare) return ambientModuleDeclare.name.text;
    }
    function tryGetModuleNameFromPaths(relativeToBaseUrl, paths, allowedEndings, host, compilerOptions) {
        for(const key in paths)for (const patternText2 of paths[key]){
            const pattern = normalizePath(patternText2);
            const indexOfStar = pattern.indexOf("*");
            const candidates = allowedEndings.map((ending)=>({
                    ending: ending,
                    value: processEnding(relativeToBaseUrl, [
                        ending
                    ], compilerOptions)
                }));
            if (tryGetExtensionFromPath2(pattern)) candidates.push({
                ending: void 0,
                value: relativeToBaseUrl
            });
            if (indexOfStar !== -1) {
                const prefix = pattern.substring(0, indexOfStar);
                const suffix = pattern.substring(indexOfStar + 1);
                for (const { ending: ending , value: value1  } of candidates)if (value1.length >= prefix.length + suffix.length && startsWith(value1, prefix) && endsWith(value1, suffix) && validateEnding({
                    ending: ending,
                    value: value1
                })) {
                    const matchedStar = value1.substring(prefix.length, value1.length - suffix.length);
                    return pathIsRelative(matchedStar) ? void 0 : key.replace("*", matchedStar);
                }
            } else if (some(candidates, (c)=>c.ending !== 0 /* Minimal */  && pattern === c.value) || some(candidates, (c)=>c.ending === 0 /* Minimal */  && pattern === c.value && validateEnding(c))) return key;
        }
        function validateEnding({ ending: ending , value: value1  }) {
            return ending !== 0 /* Minimal */  || value1 === processEnding(relativeToBaseUrl, [
                ending
            ], compilerOptions, host);
        }
    }
    function tryGetModuleNameFromExports(options, targetFilePath, packageDirectory, packageName, exports, conditions, mode = 0 /* Exact */ ) {
        if (typeof exports === "string") {
            const pathOrPattern = getNormalizedAbsolutePath(combinePaths(packageDirectory, exports), /*currentDirectory*/ void 0);
            const extensionSwappedTarget = hasTSFileExtension(targetFilePath) ? removeFileExtension(targetFilePath) + tryGetJSExtensionForFile(targetFilePath, options) : void 0;
            switch(mode){
                case 0 /* Exact */ :
                    if (comparePaths(targetFilePath, pathOrPattern) === 0 /* EqualTo */  || extensionSwappedTarget && comparePaths(extensionSwappedTarget, pathOrPattern) === 0 /* EqualTo */ ) return {
                        moduleFileToTry: packageName
                    };
                    break;
                case 1 /* Directory */ :
                    if (containsPath(pathOrPattern, targetFilePath)) {
                        const fragment = getRelativePathFromDirectory(pathOrPattern, targetFilePath, /*ignoreCase*/ false);
                        return {
                            moduleFileToTry: getNormalizedAbsolutePath(combinePaths(combinePaths(packageName, exports), fragment), /*currentDirectory*/ void 0)
                        };
                    }
                    break;
                case 2 /* Pattern */ :
                    const starPos = pathOrPattern.indexOf("*");
                    const leadingSlice = pathOrPattern.slice(0, starPos);
                    const trailingSlice = pathOrPattern.slice(starPos + 1);
                    if (startsWith(targetFilePath, leadingSlice) && endsWith(targetFilePath, trailingSlice)) {
                        const starReplacement = targetFilePath.slice(leadingSlice.length, targetFilePath.length - trailingSlice.length);
                        return {
                            moduleFileToTry: packageName.replace("*", starReplacement)
                        };
                    }
                    if (extensionSwappedTarget && startsWith(extensionSwappedTarget, leadingSlice) && endsWith(extensionSwappedTarget, trailingSlice)) {
                        const starReplacement = extensionSwappedTarget.slice(leadingSlice.length, extensionSwappedTarget.length - trailingSlice.length);
                        return {
                            moduleFileToTry: packageName.replace("*", starReplacement)
                        };
                    }
                    break;
            }
        } else if (Array.isArray(exports)) return forEach(exports, (e)=>tryGetModuleNameFromExports(options, targetFilePath, packageDirectory, packageName, e, conditions));
        else if (typeof exports === "object" && exports !== null) {
            if (allKeysStartWithDot(exports)) return forEach(getOwnKeys(exports), (k)=>{
                const subPackageName = getNormalizedAbsolutePath(combinePaths(packageName, k), /*currentDirectory*/ void 0);
                const mode2 = endsWith(k, "/") ? 1 /* Directory */  : stringContains(k, "*") ? 2 /* Pattern */  : 0 /* Exact */ ;
                return tryGetModuleNameFromExports(options, targetFilePath, packageDirectory, subPackageName, exports[k], conditions, mode2);
            });
            else {
                for (const key of getOwnKeys(exports))if (key === "default" || conditions.indexOf(key) >= 0 || isApplicableVersionedTypesKey(conditions, key)) {
                    const subTarget = exports[key];
                    const result = tryGetModuleNameFromExports(options, targetFilePath, packageDirectory, packageName, subTarget, conditions);
                    if (result) return result;
                }
            }
        }
        return void 0;
    }
    function tryGetModuleNameFromRootDirs(rootDirs, moduleFileName, sourceDirectory, getCanonicalFileName, allowedEndings, compilerOptions) {
        const normalizedTargetPaths = getPathsRelativeToRootDirs(moduleFileName, rootDirs, getCanonicalFileName);
        if (normalizedTargetPaths === void 0) return void 0;
        const normalizedSourcePaths = getPathsRelativeToRootDirs(sourceDirectory, rootDirs, getCanonicalFileName);
        const relativePaths = flatMap(normalizedSourcePaths, (sourcePath)=>{
            return map(normalizedTargetPaths, (targetPath)=>ensurePathIsNonModuleName(getRelativePathFromDirectory(sourcePath, targetPath, getCanonicalFileName)));
        });
        const shortest = min(relativePaths, compareNumberOfDirectorySeparators);
        if (!shortest) return void 0;
        return processEnding(shortest, allowedEndings, compilerOptions);
    }
    function tryGetModuleNameAsNodeModule({ path: path , isRedirect: isRedirect  }, { getCanonicalFileName: getCanonicalFileName , sourceDirectory: sourceDirectory  }, importingSourceFile, host, options, userPreferences, packageNameOnly, overrideMode) {
        if (!host.fileExists || !host.readFile) return void 0;
        const parts = getNodeModulePathParts(path);
        if (!parts) return void 0;
        const preferences = getPreferences(userPreferences, options, importingSourceFile);
        const allowedEndings = preferences.getAllowedEndingsInPreferredOrder();
        let moduleSpecifier = path;
        let isPackageRootPath = false;
        if (!packageNameOnly) {
            let packageRootIndex = parts.packageRootIndex;
            let moduleFileName;
            while(true){
                const { moduleFileToTry: moduleFileToTry , packageRootPath: packageRootPath , blockedByExports: blockedByExports , verbatimFromExports: verbatimFromExports  } = tryDirectoryWithPackageJson(packageRootIndex);
                if (getEmitModuleResolutionKind(options) !== 1 /* Classic */ ) {
                    if (blockedByExports) return void 0;
                    if (verbatimFromExports) return moduleFileToTry;
                }
                if (packageRootPath) {
                    moduleSpecifier = packageRootPath;
                    isPackageRootPath = true;
                    break;
                }
                if (!moduleFileName) moduleFileName = moduleFileToTry;
                packageRootIndex = path.indexOf(directorySeparator, packageRootIndex + 1);
                if (packageRootIndex === -1) {
                    moduleSpecifier = processEnding(moduleFileName, allowedEndings, options, host);
                    break;
                }
            }
        }
        if (isRedirect && !isPackageRootPath) return void 0;
        const globalTypingsCacheLocation = host.getGlobalTypingsCacheLocation && host.getGlobalTypingsCacheLocation();
        const pathToTopLevelNodeModules = getCanonicalFileName(moduleSpecifier.substring(0, parts.topLevelNodeModulesIndex));
        if (!(startsWith(sourceDirectory, pathToTopLevelNodeModules) || globalTypingsCacheLocation && startsWith(getCanonicalFileName(globalTypingsCacheLocation), pathToTopLevelNodeModules))) return void 0;
        const nodeModulesDirectoryName = moduleSpecifier.substring(parts.topLevelPackageNameIndex + 1);
        const packageName = getPackageNameFromTypesPackageName(nodeModulesDirectoryName);
        return getEmitModuleResolutionKind(options) === 1 /* Classic */  && packageName === nodeModulesDirectoryName ? void 0 : packageName;
        function tryDirectoryWithPackageJson(packageRootIndex) {
            var _a, _b;
            const packageRootPath = path.substring(0, packageRootIndex);
            const packageJsonPath = combinePaths(packageRootPath, "package.json");
            let moduleFileToTry = path;
            let maybeBlockedByTypesVersions = false;
            const cachedPackageJson = (_b = (_a = host.getPackageJsonInfoCache) == null ? void 0 : _a.call(host)) == null ? void 0 : _b.getPackageJsonInfo(packageJsonPath);
            if (typeof cachedPackageJson === "object" || cachedPackageJson === void 0 && host.fileExists(packageJsonPath)) {
                const packageJsonContent = (cachedPackageJson == null ? void 0 : cachedPackageJson.contents.packageJsonContent) || JSON.parse(host.readFile(packageJsonPath));
                const importMode = overrideMode || importingSourceFile.impliedNodeFormat;
                if (getResolvePackageJsonExports(options)) {
                    const nodeModulesDirectoryName2 = packageRootPath.substring(parts.topLevelPackageNameIndex + 1);
                    const packageName2 = getPackageNameFromTypesPackageName(nodeModulesDirectoryName2);
                    const conditions = getConditions(options, importMode === 99 /* ESNext */ );
                    const fromExports = packageJsonContent.exports ? tryGetModuleNameFromExports(options, path, packageRootPath, packageName2, packageJsonContent.exports, conditions) : void 0;
                    if (fromExports) {
                        const withJsExtension = !hasTSFileExtension(fromExports.moduleFileToTry) ? fromExports : {
                            moduleFileToTry: removeFileExtension(fromExports.moduleFileToTry) + tryGetJSExtensionForFile(fromExports.moduleFileToTry, options)
                        };
                        return {
                            ...withJsExtension,
                            verbatimFromExports: true
                        };
                    }
                    if (packageJsonContent.exports) return {
                        moduleFileToTry: path,
                        blockedByExports: true
                    };
                }
                const versionPaths = packageJsonContent.typesVersions ? getPackageJsonTypesVersionsPaths(packageJsonContent.typesVersions) : void 0;
                if (versionPaths) {
                    const subModuleName = path.slice(packageRootPath.length + 1);
                    const fromPaths = tryGetModuleNameFromPaths(subModuleName, versionPaths.paths, allowedEndings, host, options);
                    if (fromPaths === void 0) maybeBlockedByTypesVersions = true;
                    else moduleFileToTry = combinePaths(packageRootPath, fromPaths);
                }
                const mainFileRelative = packageJsonContent.typings || packageJsonContent.types || packageJsonContent.main || "index.js";
                if (isString(mainFileRelative) && !(maybeBlockedByTypesVersions && matchPatternOrExact(tryParsePatterns(versionPaths.paths), mainFileRelative))) {
                    const mainExportFile = toPath(mainFileRelative, packageRootPath, getCanonicalFileName);
                    const canonicalModuleFileToTry = getCanonicalFileName(moduleFileToTry);
                    if (removeFileExtension(mainExportFile) === removeFileExtension(canonicalModuleFileToTry)) return {
                        packageRootPath: packageRootPath,
                        moduleFileToTry: moduleFileToTry
                    };
                    else if (packageJsonContent.type !== "module" && !fileExtensionIsOneOf(canonicalModuleFileToTry, extensionsNotSupportingExtensionlessResolution) && startsWith(canonicalModuleFileToTry, mainExportFile) && getDirectoryPath(canonicalModuleFileToTry) === removeTrailingDirectorySeparator(mainExportFile) && removeFileExtension(getBaseFileName(canonicalModuleFileToTry)) === "index") return {
                        packageRootPath: packageRootPath,
                        moduleFileToTry: moduleFileToTry
                    };
                }
            } else {
                const fileName = getCanonicalFileName(moduleFileToTry.substring(parts.packageRootIndex + 1));
                if (fileName === "index.d.ts" || fileName === "index.js" || fileName === "index.ts" || fileName === "index.tsx") return {
                    moduleFileToTry: moduleFileToTry,
                    packageRootPath: packageRootPath
                };
            }
            return {
                moduleFileToTry: moduleFileToTry
            };
        }
    }
    function tryGetAnyFileFromPath(host, path) {
        if (!host.fileExists) return;
        const extensions = flatten(getSupportedExtensions({
            allowJs: true
        }, [
            {
                extension: "node",
                isMixedContent: false
            },
            {
                extension: "json",
                isMixedContent: false,
                scriptKind: 6 /* JSON */ 
            }
        ]));
        for (const e of extensions){
            const fullPath = path + e;
            if (host.fileExists(fullPath)) return fullPath;
        }
    }
    function getPathsRelativeToRootDirs(path, rootDirs, getCanonicalFileName) {
        return mapDefined(rootDirs, (rootDir)=>{
            const relativePath = getRelativePathIfInSameVolume(path, rootDir, getCanonicalFileName);
            return relativePath !== void 0 && isPathRelativeToParent(relativePath) ? void 0 : relativePath;
        });
    }
    function processEnding(fileName, allowedEndings, options, host) {
        if (fileExtensionIsOneOf(fileName, [
            ".json" /* Json */ ,
            ".mjs" /* Mjs */ ,
            ".cjs" /* Cjs */ 
        ])) return fileName;
        const noExtension = removeFileExtension(fileName);
        if (fileName === noExtension) return fileName;
        const jsPriority = allowedEndings.indexOf(2 /* JsExtension */ );
        const tsPriority = allowedEndings.indexOf(3 /* TsExtension */ );
        if (fileExtensionIsOneOf(fileName, [
            ".mts" /* Mts */ ,
            ".cts" /* Cts */ 
        ]) && tsPriority !== -1 && tsPriority < jsPriority) return fileName;
        else if (fileExtensionIsOneOf(fileName, [
            ".d.mts" /* Dmts */ ,
            ".mts" /* Mts */ ,
            ".d.cts" /* Dcts */ ,
            ".cts" /* Cts */ 
        ])) return noExtension + getJSExtensionForFile(fileName, options);
        else if (!fileExtensionIsOneOf(fileName, [
            ".d.ts" /* Dts */ 
        ]) && fileExtensionIsOneOf(fileName, [
            ".ts" /* Ts */ 
        ]) && stringContains(fileName, ".d.")) return tryGetRealFileNameForNonJsDeclarationFileName(fileName);
        switch(allowedEndings[0]){
            case 0 /* Minimal */ :
                const withoutIndex = removeSuffix(noExtension, "/index");
                if (host && withoutIndex !== noExtension && tryGetAnyFileFromPath(host, withoutIndex)) return noExtension;
                return withoutIndex;
            case 1 /* Index */ :
                return noExtension;
            case 2 /* JsExtension */ :
                return noExtension + getJSExtensionForFile(fileName, options);
            case 3 /* TsExtension */ :
                if (isDeclarationFileName(fileName)) {
                    const extensionlessPriority = allowedEndings.findIndex((e)=>e === 0 /* Minimal */  || e === 1 /* Index */ );
                    return extensionlessPriority !== -1 && extensionlessPriority < jsPriority ? noExtension : noExtension + getJSExtensionForFile(fileName, options);
                }
                return fileName;
            default:
                return Debug.assertNever(allowedEndings[0]);
        }
    }
    function tryGetRealFileNameForNonJsDeclarationFileName(fileName) {
        const baseName = getBaseFileName(fileName);
        if (!endsWith(fileName, ".ts" /* Ts */ ) || !stringContains(baseName, ".d.") || fileExtensionIsOneOf(baseName, [
            ".d.ts" /* Dts */ 
        ])) return void 0;
        const noExtension = removeExtension(fileName, ".ts" /* Ts */ );
        const ext = noExtension.substring(noExtension.lastIndexOf("."));
        return noExtension.substring(0, noExtension.indexOf(".d.")) + ext;
    }
    function getJSExtensionForFile(fileName, options) {
        return tryGetJSExtensionForFile(fileName, options) ?? Debug.fail(`Extension ${extensionFromPath(fileName)} is unsupported:: FileName:: ${fileName}`);
    }
    function tryGetJSExtensionForFile(fileName, options) {
        const ext = tryGetExtensionFromPath2(fileName);
        switch(ext){
            case ".ts" /* Ts */ :
            case ".d.ts" /* Dts */ :
                return ".js" /* Js */ ;
            case ".tsx" /* Tsx */ :
                return options.jsx === 1 /* Preserve */  ? ".jsx" /* Jsx */  : ".js" /* Js */ ;
            case ".js" /* Js */ :
            case ".jsx" /* Jsx */ :
            case ".json" /* Json */ :
                return ext;
            case ".d.mts" /* Dmts */ :
            case ".mts" /* Mts */ :
            case ".mjs" /* Mjs */ :
                return ".mjs" /* Mjs */ ;
            case ".d.cts" /* Dcts */ :
            case ".cts" /* Cts */ :
            case ".cjs" /* Cjs */ :
                return ".cjs" /* Cjs */ ;
            default:
                return void 0;
        }
    }
    function getRelativePathIfInSameVolume(path, directoryPath, getCanonicalFileName) {
        const relativePath = getRelativePathToDirectoryOrUrl(directoryPath, path, directoryPath, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
        return isRootedDiskPath(relativePath) ? void 0 : relativePath;
    }
    function isPathRelativeToParent(path) {
        return startsWith(path, "..");
    }
    var init_moduleSpecifiers = __esm({
        "src/compiler/moduleSpecifiers.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/_namespaces/ts.moduleSpecifiers.ts
    var ts_moduleSpecifiers_exports = {};
    __export(ts_moduleSpecifiers_exports, {
        countPathComponents: ()=>countPathComponents,
        forEachFileNameOfModule: ()=>forEachFileNameOfModule,
        getModuleSpecifier: ()=>getModuleSpecifier,
        getModuleSpecifiers: ()=>getModuleSpecifiers,
        getModuleSpecifiersWithCacheInfo: ()=>getModuleSpecifiersWithCacheInfo,
        getNodeModulesPackageName: ()=>getNodeModulesPackageName,
        tryGetJSExtensionForFile: ()=>tryGetJSExtensionForFile,
        tryGetModuleSpecifiersFromCache: ()=>tryGetModuleSpecifiersFromCache,
        tryGetRealFileNameForNonJsDeclarationFileName: ()=>tryGetRealFileNameForNonJsDeclarationFileName,
        updateModuleSpecifier: ()=>updateModuleSpecifier
    });
    var init_ts_moduleSpecifiers = __esm({
        "src/compiler/_namespaces/ts.moduleSpecifiers.ts" () {
            "use strict";
            init_moduleSpecifiers();
        }
    });
    // src/compiler/checker.ts
    function NodeLinks() {
        this.flags = 0 /* None */ ;
    }
    function getNodeId(node) {
        if (!node.id) {
            node.id = nextNodeId;
            nextNodeId++;
        }
        return node.id;
    }
    function getSymbolId(symbol) {
        if (!symbol.id) {
            symbol.id = nextSymbolId;
            nextSymbolId++;
        }
        return symbol.id;
    }
    function isInstantiatedModule(node, preserveConstEnums) {
        const moduleState = getModuleInstanceState(node);
        return moduleState === 1 /* Instantiated */  || preserveConstEnums && moduleState === 2 /* ConstEnumOnly */ ;
    }
    function createTypeChecker(host) {
        var deferredDiagnosticsCallbacks = [];
        var addLazyDiagnostic = (arg)=>{
            deferredDiagnosticsCallbacks.push(arg);
        };
        var cancellationToken;
        var requestedExternalEmitHelperNames = /* @__PURE__ */ new Set();
        var requestedExternalEmitHelpers;
        var externalHelpersModule;
        var Symbol47 = objectAllocator.getSymbolConstructor();
        var Type27 = objectAllocator.getTypeConstructor();
        var Signature15 = objectAllocator.getSignatureConstructor();
        var typeCount = 0;
        var symbolCount = 0;
        var totalInstantiationCount = 0;
        var instantiationCount = 0;
        var instantiationDepth = 0;
        var inlineLevel = 0;
        var currentNode;
        var varianceTypeParameter;
        var isInferencePartiallyBlocked = false;
        var emptySymbols = createSymbolTable();
        var arrayVariances = [
            1 /* Covariant */ 
        ];
        var compilerOptions = host.getCompilerOptions();
        var languageVersion = getEmitScriptTarget(compilerOptions);
        var moduleKind = getEmitModuleKind(compilerOptions);
        var legacyDecorators = !!compilerOptions.experimentalDecorators;
        var useDefineForClassFields = getUseDefineForClassFields(compilerOptions);
        var allowSyntheticDefaultImports = getAllowSyntheticDefaultImports(compilerOptions);
        var strictNullChecks = getStrictOptionValue(compilerOptions, "strictNullChecks");
        var strictFunctionTypes = getStrictOptionValue(compilerOptions, "strictFunctionTypes");
        var strictBindCallApply = getStrictOptionValue(compilerOptions, "strictBindCallApply");
        var strictPropertyInitialization = getStrictOptionValue(compilerOptions, "strictPropertyInitialization");
        var noImplicitAny = getStrictOptionValue(compilerOptions, "noImplicitAny");
        var noImplicitThis = getStrictOptionValue(compilerOptions, "noImplicitThis");
        var useUnknownInCatchVariables = getStrictOptionValue(compilerOptions, "useUnknownInCatchVariables");
        var keyofStringsOnly = !!compilerOptions.keyofStringsOnly;
        var defaultIndexFlags = keyofStringsOnly ? 1 /* StringsOnly */  : 0 /* None */ ;
        var freshObjectLiteralFlag = compilerOptions.suppressExcessPropertyErrors ? 0 : 8192 /* FreshLiteral */ ;
        var exactOptionalPropertyTypes = compilerOptions.exactOptionalPropertyTypes;
        var checkBinaryExpression = createCheckBinaryExpression();
        var emitResolver = createResolver();
        var nodeBuilder = createNodeBuilder();
        var globals = createSymbolTable();
        var undefinedSymbol = createSymbol(4 /* Property */ , "undefined");
        undefinedSymbol.declarations = [];
        var globalThisSymbol = createSymbol(1536 /* Module */ , "globalThis", 8 /* Readonly */ );
        globalThisSymbol.exports = globals;
        globalThisSymbol.declarations = [];
        globals.set(globalThisSymbol.escapedName, globalThisSymbol);
        var argumentsSymbol = createSymbol(4 /* Property */ , "arguments");
        var requireSymbol = createSymbol(4 /* Property */ , "require");
        var isolatedModulesLikeFlagName = compilerOptions.verbatimModuleSyntax ? "verbatimModuleSyntax" : "isolatedModules";
        var canCollectSymbolAliasAccessabilityData = !compilerOptions.verbatimModuleSyntax || !!compilerOptions.importsNotUsedAsValues;
        var apparentArgumentCount;
        const checker = {
            getNodeCount: ()=>reduceLeft(host.getSourceFiles(), (n, s)=>n + s.nodeCount, 0),
            getIdentifierCount: ()=>reduceLeft(host.getSourceFiles(), (n, s)=>n + s.identifierCount, 0),
            getSymbolCount: ()=>reduceLeft(host.getSourceFiles(), (n, s)=>n + s.symbolCount, symbolCount),
            getTypeCount: ()=>typeCount,
            getInstantiationCount: ()=>totalInstantiationCount,
            getRelationCacheSizes: ()=>({
                    assignable: assignableRelation.size,
                    identity: identityRelation.size,
                    subtype: subtypeRelation.size,
                    strictSubtype: strictSubtypeRelation.size
                }),
            isUndefinedSymbol: (symbol)=>symbol === undefinedSymbol,
            isArgumentsSymbol: (symbol)=>symbol === argumentsSymbol,
            isUnknownSymbol: (symbol)=>symbol === unknownSymbol,
            getMergedSymbol: getMergedSymbol,
            getDiagnostics: getDiagnostics2,
            getGlobalDiagnostics: getGlobalDiagnostics,
            getRecursionIdentity: getRecursionIdentity,
            getUnmatchedProperties: getUnmatchedProperties,
            getTypeOfSymbolAtLocation: (symbol, locationIn)=>{
                const location = getParseTreeNode(locationIn);
                return location ? getTypeOfSymbolAtLocation(symbol, location) : errorType;
            },
            getTypeOfSymbol: getTypeOfSymbol,
            getSymbolsOfParameterPropertyDeclaration: (parameterIn, parameterName)=>{
                const parameter = getParseTreeNode(parameterIn, isParameter);
                if (parameter === void 0) return Debug.fail("Cannot get symbols of a synthetic parameter that cannot be resolved to a parse-tree node.");
                Debug.assert(isParameterPropertyDeclaration(parameter, parameter.parent));
                return getSymbolsOfParameterPropertyDeclaration(parameter, escapeLeadingUnderscores(parameterName));
            },
            getDeclaredTypeOfSymbol: getDeclaredTypeOfSymbol,
            getPropertiesOfType: getPropertiesOfType,
            getPropertyOfType: (type, name)=>getPropertyOfType(type, escapeLeadingUnderscores(name)),
            getPrivateIdentifierPropertyOfType: (leftType, name, location)=>{
                const node = getParseTreeNode(location);
                if (!node) return void 0;
                const propName = escapeLeadingUnderscores(name);
                const lexicallyScopedIdentifier = lookupSymbolForPrivateIdentifierDeclaration(propName, node);
                return lexicallyScopedIdentifier ? getPrivateIdentifierPropertyOfType(leftType, lexicallyScopedIdentifier) : void 0;
            },
            getTypeOfPropertyOfType: (type, name)=>getTypeOfPropertyOfType(type, escapeLeadingUnderscores(name)),
            getIndexInfoOfType: (type, kind)=>getIndexInfoOfType(type, kind === 0 /* String */  ? stringType : numberType),
            getIndexInfosOfType: getIndexInfosOfType,
            getIndexInfosOfIndexSymbol: getIndexInfosOfIndexSymbol,
            getSignaturesOfType: getSignaturesOfType,
            getIndexTypeOfType: (type, kind)=>getIndexTypeOfType(type, kind === 0 /* String */  ? stringType : numberType),
            getIndexType: (type)=>getIndexType(type),
            getBaseTypes: getBaseTypes,
            getBaseTypeOfLiteralType: getBaseTypeOfLiteralType,
            getWidenedType: getWidenedType,
            getTypeFromTypeNode: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isTypeNode);
                return node ? getTypeFromTypeNode(node) : errorType;
            },
            getParameterType: getTypeAtPosition,
            getParameterIdentifierNameAtPosition: getParameterIdentifierNameAtPosition,
            getPromisedTypeOfPromise: getPromisedTypeOfPromise,
            getAwaitedType: (type)=>getAwaitedType(type),
            getReturnTypeOfSignature: getReturnTypeOfSignature,
            isNullableType: isNullableType,
            getNullableType: getNullableType,
            getNonNullableType: getNonNullableType,
            getNonOptionalType: removeOptionalTypeMarker,
            getTypeArguments: getTypeArguments,
            typeToTypeNode: nodeBuilder.typeToTypeNode,
            indexInfoToIndexSignatureDeclaration: nodeBuilder.indexInfoToIndexSignatureDeclaration,
            signatureToSignatureDeclaration: nodeBuilder.signatureToSignatureDeclaration,
            symbolToEntityName: nodeBuilder.symbolToEntityName,
            symbolToExpression: nodeBuilder.symbolToExpression,
            symbolToNode: nodeBuilder.symbolToNode,
            symbolToTypeParameterDeclarations: nodeBuilder.symbolToTypeParameterDeclarations,
            symbolToParameterDeclaration: nodeBuilder.symbolToParameterDeclaration,
            typeParameterToDeclaration: nodeBuilder.typeParameterToDeclaration,
            getSymbolsInScope: (locationIn, meaning)=>{
                const location = getParseTreeNode(locationIn);
                return location ? getSymbolsInScope(location, meaning) : [];
            },
            getSymbolAtLocation: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn);
                return node ? getSymbolAtLocation(node, /*ignoreErrors*/ true) : void 0;
            },
            getIndexInfosAtLocation: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn);
                return node ? getIndexInfosAtLocation(node) : void 0;
            },
            getShorthandAssignmentValueSymbol: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn);
                return node ? getShorthandAssignmentValueSymbol(node) : void 0;
            },
            getExportSpecifierLocalTargetSymbol: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isExportSpecifier);
                return node ? getExportSpecifierLocalTargetSymbol(node) : void 0;
            },
            getExportSymbolOfSymbol (symbol) {
                return getMergedSymbol(symbol.exportSymbol || symbol);
            },
            getTypeAtLocation: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn);
                return node ? getTypeOfNode(node) : errorType;
            },
            getTypeOfAssignmentPattern: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isAssignmentPattern);
                return node && getTypeOfAssignmentPattern(node) || errorType;
            },
            getPropertySymbolOfDestructuringAssignment: (locationIn)=>{
                const location = getParseTreeNode(locationIn, isIdentifier);
                return location ? getPropertySymbolOfDestructuringAssignment(location) : void 0;
            },
            signatureToString: (signature, enclosingDeclaration, flags, kind)=>{
                return signatureToString(signature, getParseTreeNode(enclosingDeclaration), flags, kind);
            },
            typeToString: (type, enclosingDeclaration, flags)=>{
                return typeToString(type, getParseTreeNode(enclosingDeclaration), flags);
            },
            symbolToString: (symbol, enclosingDeclaration, meaning, flags)=>{
                return symbolToString(symbol, getParseTreeNode(enclosingDeclaration), meaning, flags);
            },
            typePredicateToString: (predicate, enclosingDeclaration, flags)=>{
                return typePredicateToString(predicate, getParseTreeNode(enclosingDeclaration), flags);
            },
            writeSignature: (signature, enclosingDeclaration, flags, kind, writer)=>{
                return signatureToString(signature, getParseTreeNode(enclosingDeclaration), flags, kind, writer);
            },
            writeType: (type, enclosingDeclaration, flags, writer)=>{
                return typeToString(type, getParseTreeNode(enclosingDeclaration), flags, writer);
            },
            writeSymbol: (symbol, enclosingDeclaration, meaning, flags, writer)=>{
                return symbolToString(symbol, getParseTreeNode(enclosingDeclaration), meaning, flags, writer);
            },
            writeTypePredicate: (predicate, enclosingDeclaration, flags, writer)=>{
                return typePredicateToString(predicate, getParseTreeNode(enclosingDeclaration), flags, writer);
            },
            getAugmentedPropertiesOfType: getAugmentedPropertiesOfType,
            getRootSymbols: getRootSymbols,
            getSymbolOfExpando: getSymbolOfExpando,
            getContextualType: (nodeIn, contextFlags)=>{
                const node = getParseTreeNode(nodeIn, isExpression);
                if (!node) return void 0;
                if (contextFlags & 4 /* Completions */ ) return runWithInferenceBlockedFromSourceNode(node, ()=>getContextualType2(node, contextFlags));
                return getContextualType2(node, contextFlags);
            },
            getContextualTypeForObjectLiteralElement: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isObjectLiteralElementLike);
                return node ? getContextualTypeForObjectLiteralElement(node, /*contextFlags*/ void 0) : void 0;
            },
            getContextualTypeForArgumentAtIndex: (nodeIn, argIndex)=>{
                const node = getParseTreeNode(nodeIn, isCallLikeExpression);
                return node && getContextualTypeForArgumentAtIndex(node, argIndex);
            },
            getContextualTypeForJsxAttribute: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isJsxAttributeLike);
                return node && getContextualTypeForJsxAttribute(node, /*contextFlags*/ void 0);
            },
            isContextSensitive: isContextSensitive,
            getTypeOfPropertyOfContextualType: getTypeOfPropertyOfContextualType,
            getFullyQualifiedName: getFullyQualifiedName,
            getResolvedSignature: (node, candidatesOutArray, argumentCount)=>getResolvedSignatureWorker(node, candidatesOutArray, argumentCount, 0 /* Normal */ ),
            getResolvedSignatureForStringLiteralCompletions: (call, editingArgument, candidatesOutArray)=>runWithInferenceBlockedFromSourceNode(editingArgument, ()=>getResolvedSignatureWorker(call, candidatesOutArray, /*argumentCount*/ void 0, 32 /* IsForStringLiteralArgumentCompletions */ )),
            getResolvedSignatureForSignatureHelp: (node, candidatesOutArray, argumentCount)=>runWithoutResolvedSignatureCaching(node, ()=>getResolvedSignatureWorker(node, candidatesOutArray, argumentCount, 16 /* IsForSignatureHelp */ )),
            getExpandedParameters: getExpandedParameters,
            hasEffectiveRestParameter: hasEffectiveRestParameter,
            containsArgumentsReference: containsArgumentsReference,
            getConstantValue: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, canHaveConstantValue);
                return node ? getConstantValue2(node) : void 0;
            },
            isValidPropertyAccess: (nodeIn, propertyName)=>{
                const node = getParseTreeNode(nodeIn, isPropertyAccessOrQualifiedNameOrImportTypeNode);
                return !!node && isValidPropertyAccess(node, escapeLeadingUnderscores(propertyName));
            },
            isValidPropertyAccessForCompletions: (nodeIn, type, property)=>{
                const node = getParseTreeNode(nodeIn, isPropertyAccessExpression);
                return !!node && isValidPropertyAccessForCompletions(node, type, property);
            },
            getSignatureFromDeclaration: (declarationIn)=>{
                const declaration = getParseTreeNode(declarationIn, isFunctionLike);
                return declaration ? getSignatureFromDeclaration(declaration) : void 0;
            },
            isImplementationOfOverload: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isFunctionLike);
                return node ? isImplementationOfOverload(node) : void 0;
            },
            getImmediateAliasedSymbol: getImmediateAliasedSymbol,
            getAliasedSymbol: resolveAlias,
            getEmitResolver: getEmitResolver,
            getExportsOfModule: getExportsOfModuleAsArray,
            getExportsAndPropertiesOfModule: getExportsAndPropertiesOfModule,
            forEachExportAndPropertyOfModule: forEachExportAndPropertyOfModule,
            getSymbolWalker: createGetSymbolWalker(getRestTypeOfSignature, getTypePredicateOfSignature, getReturnTypeOfSignature, getBaseTypes, resolveStructuredTypeMembers, getTypeOfSymbol, getResolvedSymbol, getConstraintOfTypeParameter, getFirstIdentifier, getTypeArguments),
            getAmbientModules: getAmbientModules,
            getJsxIntrinsicTagNamesAt: getJsxIntrinsicTagNamesAt,
            isOptionalParameter: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isParameter);
                return node ? isOptionalParameter(node) : false;
            },
            tryGetMemberInModuleExports: (name, symbol)=>tryGetMemberInModuleExports(escapeLeadingUnderscores(name), symbol),
            tryGetMemberInModuleExportsAndProperties: (name, symbol)=>tryGetMemberInModuleExportsAndProperties(escapeLeadingUnderscores(name), symbol),
            tryFindAmbientModule: (moduleName)=>tryFindAmbientModule(moduleName, /*withAugmentations*/ true),
            tryFindAmbientModuleWithoutAugmentations: (moduleName)=>{
                return tryFindAmbientModule(moduleName, /*withAugmentations*/ false);
            },
            getApparentType: getApparentType,
            getUnionType: getUnionType,
            isTypeAssignableTo: isTypeAssignableTo,
            createAnonymousType: createAnonymousType,
            createSignature: createSignature,
            createSymbol: createSymbol,
            createIndexInfo: createIndexInfo,
            getAnyType: ()=>anyType,
            getStringType: ()=>stringType,
            getStringLiteralType: getStringLiteralType,
            getNumberType: ()=>numberType,
            getNumberLiteralType: getNumberLiteralType,
            getBigIntType: ()=>bigintType,
            createPromiseType: createPromiseType,
            createArrayType: createArrayType,
            getElementTypeOfArrayType: getElementTypeOfArrayType,
            getBooleanType: ()=>booleanType,
            getFalseType: (fresh)=>fresh ? falseType : regularFalseType,
            getTrueType: (fresh)=>fresh ? trueType : regularTrueType,
            getVoidType: ()=>voidType,
            getUndefinedType: ()=>undefinedType,
            getNullType: ()=>nullType,
            getESSymbolType: ()=>esSymbolType,
            getNeverType: ()=>neverType,
            getOptionalType: ()=>optionalType,
            getPromiseType: ()=>getGlobalPromiseType(/*reportErrors*/ false),
            getPromiseLikeType: ()=>getGlobalPromiseLikeType(/*reportErrors*/ false),
            getAsyncIterableType: ()=>{
                const type = getGlobalAsyncIterableType(/*reportErrors*/ false);
                if (type === emptyGenericType) return void 0;
                return type;
            },
            isSymbolAccessible: isSymbolAccessible,
            isArrayType: isArrayType,
            isTupleType: isTupleType,
            isArrayLikeType: isArrayLikeType,
            isEmptyAnonymousObjectType: isEmptyAnonymousObjectType,
            isTypeInvalidDueToUnionDiscriminant: isTypeInvalidDueToUnionDiscriminant,
            getExactOptionalProperties: getExactOptionalProperties,
            getAllPossiblePropertiesOfTypes: getAllPossiblePropertiesOfTypes,
            getSuggestedSymbolForNonexistentProperty: getSuggestedSymbolForNonexistentProperty,
            getSuggestionForNonexistentProperty: getSuggestionForNonexistentProperty,
            getSuggestedSymbolForNonexistentJSXAttribute: getSuggestedSymbolForNonexistentJSXAttribute,
            getSuggestedSymbolForNonexistentSymbol: (location, name, meaning)=>getSuggestedSymbolForNonexistentSymbol(location, escapeLeadingUnderscores(name), meaning),
            getSuggestionForNonexistentSymbol: (location, name, meaning)=>getSuggestionForNonexistentSymbol(location, escapeLeadingUnderscores(name), meaning),
            getSuggestedSymbolForNonexistentModule: getSuggestedSymbolForNonexistentModule,
            getSuggestionForNonexistentExport: getSuggestionForNonexistentExport,
            getSuggestedSymbolForNonexistentClassMember: getSuggestedSymbolForNonexistentClassMember,
            getBaseConstraintOfType: getBaseConstraintOfType,
            getDefaultFromTypeParameter: (type)=>type && type.flags & 262144 /* TypeParameter */  ? getDefaultFromTypeParameter(type) : void 0,
            resolveName (name, location, meaning, excludeGlobals) {
                return resolveName(location, escapeLeadingUnderscores(name), meaning, /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false, excludeGlobals);
            },
            getJsxNamespace: (n)=>unescapeLeadingUnderscores(getJsxNamespace(n)),
            getJsxFragmentFactory: (n)=>{
                const jsxFragmentFactory = getJsxFragmentFactoryEntity(n);
                return jsxFragmentFactory && unescapeLeadingUnderscores(getFirstIdentifier(jsxFragmentFactory).escapedText);
            },
            getAccessibleSymbolChain: getAccessibleSymbolChain,
            getTypePredicateOfSignature: getTypePredicateOfSignature,
            resolveExternalModuleName: (moduleSpecifierIn)=>{
                const moduleSpecifier = getParseTreeNode(moduleSpecifierIn, isExpression);
                return moduleSpecifier && resolveExternalModuleName(moduleSpecifier, moduleSpecifier, /*ignoreErrors*/ true);
            },
            resolveExternalModuleSymbol: resolveExternalModuleSymbol,
            tryGetThisTypeAt: (nodeIn, includeGlobalThis, container)=>{
                const node = getParseTreeNode(nodeIn);
                return node && tryGetThisTypeAt(node, includeGlobalThis, container);
            },
            getTypeArgumentConstraint: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isTypeNode);
                return node && getTypeArgumentConstraint(node);
            },
            getSuggestionDiagnostics: (fileIn, ct)=>{
                const file = getParseTreeNode(fileIn, isSourceFile) || Debug.fail("Could not determine parsed source file.");
                if (skipTypeChecking(file, compilerOptions, host)) return emptyArray;
                let diagnostics2;
                try {
                    cancellationToken = ct;
                    checkSourceFileWithEagerDiagnostics(file);
                    Debug.assert(!!(getNodeLinks(file).flags & 1 /* TypeChecked */ ));
                    diagnostics2 = addRange(diagnostics2, suggestionDiagnostics.getDiagnostics(file.fileName));
                    checkUnusedIdentifiers(getPotentiallyUnusedIdentifiers(file), (containingNode, kind, diag2)=>{
                        if (!containsParseError(containingNode) && !unusedIsError(kind, !!(containingNode.flags & 16777216 /* Ambient */ ))) (diagnostics2 || (diagnostics2 = [])).push({
                            ...diag2,
                            category: 2 /* Suggestion */ 
                        });
                    });
                    return diagnostics2 || emptyArray;
                } finally{
                    cancellationToken = void 0;
                }
            },
            runWithCancellationToken: (token, callback)=>{
                try {
                    cancellationToken = token;
                    return callback(checker);
                } finally{
                    cancellationToken = void 0;
                }
            },
            getLocalTypeParametersOfClassOrInterfaceOrTypeAlias: getLocalTypeParametersOfClassOrInterfaceOrTypeAlias,
            isDeclarationVisible: isDeclarationVisible,
            isPropertyAccessible: isPropertyAccessible,
            getTypeOnlyAliasDeclaration: getTypeOnlyAliasDeclaration,
            getMemberOverrideModifierStatus: getMemberOverrideModifierStatus,
            isTypeParameterPossiblyReferenced: isTypeParameterPossiblyReferenced,
            typeHasCallOrConstructSignatures: typeHasCallOrConstructSignatures
        };
        function runWithoutResolvedSignatureCaching(node, fn) {
            const containingCall = findAncestor(node, isCallLikeExpression);
            const containingCallResolvedSignature = containingCall && getNodeLinks(containingCall).resolvedSignature;
            if (containingCall) getNodeLinks(containingCall).resolvedSignature = void 0;
            const result = fn();
            if (containingCall) getNodeLinks(containingCall).resolvedSignature = containingCallResolvedSignature;
            return result;
        }
        function runWithInferenceBlockedFromSourceNode(node, fn) {
            const containingCall = findAncestor(node, isCallLikeExpression);
            if (containingCall) {
                let toMarkSkip = node;
                do {
                    getNodeLinks(toMarkSkip).skipDirectInference = true;
                    toMarkSkip = toMarkSkip.parent;
                }while (toMarkSkip && toMarkSkip !== containingCall);
            }
            isInferencePartiallyBlocked = true;
            const result = runWithoutResolvedSignatureCaching(node, fn);
            isInferencePartiallyBlocked = false;
            if (containingCall) {
                let toMarkSkip = node;
                do {
                    getNodeLinks(toMarkSkip).skipDirectInference = void 0;
                    toMarkSkip = toMarkSkip.parent;
                }while (toMarkSkip && toMarkSkip !== containingCall);
            }
            return result;
        }
        function getResolvedSignatureWorker(nodeIn, candidatesOutArray, argumentCount, checkMode) {
            const node = getParseTreeNode(nodeIn, isCallLikeExpression);
            apparentArgumentCount = argumentCount;
            const res = !node ? void 0 : getResolvedSignature(node, candidatesOutArray, checkMode);
            apparentArgumentCount = void 0;
            return res;
        }
        var tupleTypes = /* @__PURE__ */ new Map();
        var unionTypes = /* @__PURE__ */ new Map();
        var unionOfUnionTypes = /* @__PURE__ */ new Map();
        var intersectionTypes = /* @__PURE__ */ new Map();
        var stringLiteralTypes = /* @__PURE__ */ new Map();
        var numberLiteralTypes = /* @__PURE__ */ new Map();
        var bigIntLiteralTypes = /* @__PURE__ */ new Map();
        var enumLiteralTypes = /* @__PURE__ */ new Map();
        var indexedAccessTypes = /* @__PURE__ */ new Map();
        var templateLiteralTypes = /* @__PURE__ */ new Map();
        var stringMappingTypes = /* @__PURE__ */ new Map();
        var substitutionTypes = /* @__PURE__ */ new Map();
        var subtypeReductionCache = /* @__PURE__ */ new Map();
        var decoratorContextOverrideTypeCache = /* @__PURE__ */ new Map();
        var cachedTypes = /* @__PURE__ */ new Map();
        var evolvingArrayTypes = [];
        var undefinedProperties = /* @__PURE__ */ new Map();
        var markerTypes = /* @__PURE__ */ new Set();
        var unknownSymbol = createSymbol(4 /* Property */ , "unknown");
        var resolvingSymbol = createSymbol(0, "__resolving__" /* Resolving */ );
        var unresolvedSymbols = /* @__PURE__ */ new Map();
        var errorTypes = /* @__PURE__ */ new Map();
        var anyType = createIntrinsicType(1 /* Any */ , "any");
        var autoType = createIntrinsicType(1 /* Any */ , "any", 262144 /* NonInferrableType */ );
        var wildcardType = createIntrinsicType(1 /* Any */ , "any");
        var errorType = createIntrinsicType(1 /* Any */ , "error");
        var unresolvedType = createIntrinsicType(1 /* Any */ , "unresolved");
        var nonInferrableAnyType = createIntrinsicType(1 /* Any */ , "any", 65536 /* ContainsWideningType */ );
        var intrinsicMarkerType = createIntrinsicType(1 /* Any */ , "intrinsic");
        var unknownType = createIntrinsicType(2 /* Unknown */ , "unknown");
        var nonNullUnknownType = createIntrinsicType(2 /* Unknown */ , "unknown");
        var undefinedType = createIntrinsicType(32768 /* Undefined */ , "undefined");
        var undefinedWideningType = strictNullChecks ? undefinedType : createIntrinsicType(32768 /* Undefined */ , "undefined", 65536 /* ContainsWideningType */ );
        var missingType = createIntrinsicType(32768 /* Undefined */ , "undefined");
        var undefinedOrMissingType = exactOptionalPropertyTypes ? missingType : undefinedType;
        var optionalType = createIntrinsicType(32768 /* Undefined */ , "undefined");
        var nullType = createIntrinsicType(65536 /* Null */ , "null");
        var nullWideningType = strictNullChecks ? nullType : createIntrinsicType(65536 /* Null */ , "null", 65536 /* ContainsWideningType */ );
        var stringType = createIntrinsicType(4 /* String */ , "string");
        var numberType = createIntrinsicType(8 /* Number */ , "number");
        var bigintType = createIntrinsicType(64 /* BigInt */ , "bigint");
        var falseType = createIntrinsicType(512 /* BooleanLiteral */ , "false");
        var regularFalseType = createIntrinsicType(512 /* BooleanLiteral */ , "false");
        var trueType = createIntrinsicType(512 /* BooleanLiteral */ , "true");
        var regularTrueType = createIntrinsicType(512 /* BooleanLiteral */ , "true");
        trueType.regularType = regularTrueType;
        trueType.freshType = trueType;
        regularTrueType.regularType = regularTrueType;
        regularTrueType.freshType = trueType;
        falseType.regularType = regularFalseType;
        falseType.freshType = falseType;
        regularFalseType.regularType = regularFalseType;
        regularFalseType.freshType = falseType;
        var booleanType = getUnionType([
            regularFalseType,
            regularTrueType
        ]);
        var esSymbolType = createIntrinsicType(4096 /* ESSymbol */ , "symbol");
        var voidType = createIntrinsicType(16384 /* Void */ , "void");
        var neverType = createIntrinsicType(131072 /* Never */ , "never");
        var silentNeverType = createIntrinsicType(131072 /* Never */ , "never", 262144 /* NonInferrableType */ );
        var implicitNeverType = createIntrinsicType(131072 /* Never */ , "never");
        var unreachableNeverType = createIntrinsicType(131072 /* Never */ , "never");
        var nonPrimitiveType = createIntrinsicType(67108864 /* NonPrimitive */ , "object");
        var stringOrNumberType = getUnionType([
            stringType,
            numberType
        ]);
        var stringNumberSymbolType = getUnionType([
            stringType,
            numberType,
            esSymbolType
        ]);
        var keyofConstraintType = keyofStringsOnly ? stringType : stringNumberSymbolType;
        var numberOrBigIntType = getUnionType([
            numberType,
            bigintType
        ]);
        var templateConstraintType = getUnionType([
            stringType,
            numberType,
            booleanType,
            bigintType,
            nullType,
            undefinedType
        ]);
        var numericStringType = getTemplateLiteralType([
            "",
            ""
        ], [
            numberType
        ]);
        var restrictiveMapper = makeFunctionTypeMapper((t)=>t.flags & 262144 /* TypeParameter */  ? getRestrictiveTypeParameter(t) : t, ()=>"(restrictive mapper)");
        var permissiveMapper = makeFunctionTypeMapper((t)=>t.flags & 262144 /* TypeParameter */  ? wildcardType : t, ()=>"(permissive mapper)");
        var uniqueLiteralType = createIntrinsicType(131072 /* Never */ , "never");
        var uniqueLiteralMapper = makeFunctionTypeMapper((t)=>t.flags & 262144 /* TypeParameter */  ? uniqueLiteralType : t, ()=>"(unique literal mapper)");
        var outofbandVarianceMarkerHandler;
        var reportUnreliableMapper = makeFunctionTypeMapper((t)=>{
            if (outofbandVarianceMarkerHandler && (t === markerSuperType || t === markerSubType || t === markerOtherType)) outofbandVarianceMarkerHandler(/*onlyUnreliable*/ true);
            return t;
        }, ()=>"(unmeasurable reporter)");
        var reportUnmeasurableMapper = makeFunctionTypeMapper((t)=>{
            if (outofbandVarianceMarkerHandler && (t === markerSuperType || t === markerSubType || t === markerOtherType)) outofbandVarianceMarkerHandler(/*onlyUnreliable*/ false);
            return t;
        }, ()=>"(unreliable reporter)");
        var emptyObjectType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        var emptyJsxObjectType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        emptyJsxObjectType.objectFlags |= 2048 /* JsxAttributes */ ;
        var emptyTypeLiteralSymbol = createSymbol(2048 /* TypeLiteral */ , "__type" /* Type */ );
        emptyTypeLiteralSymbol.members = createSymbolTable();
        var emptyTypeLiteralType = createAnonymousType(emptyTypeLiteralSymbol, emptySymbols, emptyArray, emptyArray, emptyArray);
        var unknownEmptyObjectType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        var unknownUnionType = strictNullChecks ? getUnionType([
            undefinedType,
            nullType,
            unknownEmptyObjectType
        ]) : unknownType;
        var emptyGenericType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        emptyGenericType.instantiations = /* @__PURE__ */ new Map();
        var anyFunctionType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        anyFunctionType.objectFlags |= 262144 /* NonInferrableType */ ;
        var noConstraintType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        var circularConstraintType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        var resolvingDefaultType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        var markerSuperType = createTypeParameter();
        var markerSubType = createTypeParameter();
        markerSubType.constraint = markerSuperType;
        var markerOtherType = createTypeParameter();
        var markerSuperTypeForCheck = createTypeParameter();
        var markerSubTypeForCheck = createTypeParameter();
        markerSubTypeForCheck.constraint = markerSuperTypeForCheck;
        var noTypePredicate = createTypePredicate(1 /* Identifier */ , "<<unresolved>>", 0, anyType);
        var anySignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, anyType, /*resolvedTypePredicate*/ void 0, 0, 0 /* None */ );
        var unknownSignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, errorType, /*resolvedTypePredicate*/ void 0, 0, 0 /* None */ );
        var resolvingSignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, anyType, /*resolvedTypePredicate*/ void 0, 0, 0 /* None */ );
        var silentNeverSignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, silentNeverType, /*resolvedTypePredicate*/ void 0, 0, 0 /* None */ );
        var enumNumberIndexInfo = createIndexInfo(numberType, stringType, /*isReadonly*/ true);
        var iterationTypesCache = /* @__PURE__ */ new Map();
        var noIterationTypes = {
            get yieldType () {
                return Debug.fail("Not supported");
            },
            get returnType () {
                return Debug.fail("Not supported");
            },
            get nextType () {
                return Debug.fail("Not supported");
            }
        };
        var anyIterationTypes = createIterationTypes(anyType, anyType, anyType);
        var anyIterationTypesExceptNext = createIterationTypes(anyType, anyType, unknownType);
        var defaultIterationTypes = createIterationTypes(neverType, anyType, undefinedType);
        var asyncIterationTypesResolver = {
            iterableCacheKey: "iterationTypesOfAsyncIterable",
            iteratorCacheKey: "iterationTypesOfAsyncIterator",
            iteratorSymbolName: "asyncIterator",
            getGlobalIteratorType: getGlobalAsyncIteratorType,
            getGlobalIterableType: getGlobalAsyncIterableType,
            getGlobalIterableIteratorType: getGlobalAsyncIterableIteratorType,
            getGlobalGeneratorType: getGlobalAsyncGeneratorType,
            resolveIterationType: (type, errorNode)=>getAwaitedType(type, errorNode, Diagnostics.Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member),
            mustHaveANextMethodDiagnostic: Diagnostics.An_async_iterator_must_have_a_next_method,
            mustBeAMethodDiagnostic: Diagnostics.The_0_property_of_an_async_iterator_must_be_a_method,
            mustHaveAValueDiagnostic: Diagnostics.The_type_returned_by_the_0_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_property
        };
        var syncIterationTypesResolver = {
            iterableCacheKey: "iterationTypesOfIterable",
            iteratorCacheKey: "iterationTypesOfIterator",
            iteratorSymbolName: "iterator",
            getGlobalIteratorType: getGlobalIteratorType,
            getGlobalIterableType: getGlobalIterableType,
            getGlobalIterableIteratorType: getGlobalIterableIteratorType,
            getGlobalGeneratorType: getGlobalGeneratorType,
            resolveIterationType: (type, _errorNode)=>type,
            mustHaveANextMethodDiagnostic: Diagnostics.An_iterator_must_have_a_next_method,
            mustBeAMethodDiagnostic: Diagnostics.The_0_property_of_an_iterator_must_be_a_method,
            mustHaveAValueDiagnostic: Diagnostics.The_type_returned_by_the_0_method_of_an_iterator_must_have_a_value_property
        };
        var amalgamatedDuplicates;
        var reverseMappedCache = /* @__PURE__ */ new Map();
        var inInferTypeForHomomorphicMappedType = false;
        var ambientModulesCache;
        var patternAmbientModules;
        var patternAmbientModuleAugmentations;
        var globalObjectType;
        var globalFunctionType;
        var globalCallableFunctionType;
        var globalNewableFunctionType;
        var globalArrayType;
        var globalReadonlyArrayType;
        var globalStringType;
        var globalNumberType;
        var globalBooleanType;
        var globalRegExpType;
        var globalThisType;
        var anyArrayType;
        var autoArrayType;
        var anyReadonlyArrayType;
        var deferredGlobalNonNullableTypeAlias;
        var deferredGlobalESSymbolConstructorSymbol;
        var deferredGlobalESSymbolConstructorTypeSymbol;
        var deferredGlobalESSymbolType;
        var deferredGlobalTypedPropertyDescriptorType;
        var deferredGlobalPromiseType;
        var deferredGlobalPromiseLikeType;
        var deferredGlobalPromiseConstructorSymbol;
        var deferredGlobalPromiseConstructorLikeType;
        var deferredGlobalIterableType;
        var deferredGlobalIteratorType;
        var deferredGlobalIterableIteratorType;
        var deferredGlobalGeneratorType;
        var deferredGlobalIteratorYieldResultType;
        var deferredGlobalIteratorReturnResultType;
        var deferredGlobalAsyncIterableType;
        var deferredGlobalAsyncIteratorType;
        var deferredGlobalAsyncIterableIteratorType;
        var deferredGlobalAsyncGeneratorType;
        var deferredGlobalTemplateStringsArrayType;
        var deferredGlobalImportMetaType;
        var deferredGlobalImportMetaExpressionType;
        var deferredGlobalImportCallOptionsType;
        var deferredGlobalExtractSymbol;
        var deferredGlobalOmitSymbol;
        var deferredGlobalAwaitedSymbol;
        var deferredGlobalBigIntType;
        var deferredGlobalNaNSymbol;
        var deferredGlobalRecordSymbol;
        var deferredGlobalClassDecoratorContextType;
        var deferredGlobalClassMethodDecoratorContextType;
        var deferredGlobalClassGetterDecoratorContextType;
        var deferredGlobalClassSetterDecoratorContextType;
        var deferredGlobalClassAccessorDecoratorContextType;
        var deferredGlobalClassAccessorDecoratorTargetType;
        var deferredGlobalClassAccessorDecoratorResultType;
        var deferredGlobalClassFieldDecoratorContextType;
        var allPotentiallyUnusedIdentifiers = /* @__PURE__ */ new Map();
        var flowLoopStart = 0;
        var flowLoopCount = 0;
        var sharedFlowCount = 0;
        var flowAnalysisDisabled = false;
        var flowInvocationCount = 0;
        var lastFlowNode;
        var lastFlowNodeReachable;
        var flowTypeCache;
        var contextualTypeNodes = [];
        var contextualTypes = [];
        var contextualIsCache = [];
        var contextualTypeCount = 0;
        var inferenceContextNodes = [];
        var inferenceContexts = [];
        var inferenceContextCount = 0;
        var emptyStringType = getStringLiteralType("");
        var zeroType = getNumberLiteralType(0);
        var zeroBigIntType = getBigIntLiteralType({
            negative: false,
            base10Value: "0"
        });
        var resolutionTargets = [];
        var resolutionResults = [];
        var resolutionPropertyNames = [];
        var resolutionStart = 0;
        var inVarianceComputation = false;
        var suggestionCount = 0;
        var maximumSuggestionCount = 10;
        var mergedSymbols = [];
        var symbolLinks = [];
        var nodeLinks = [];
        var flowLoopCaches = [];
        var flowLoopNodes = [];
        var flowLoopKeys = [];
        var flowLoopTypes = [];
        var sharedFlowNodes = [];
        var sharedFlowTypes = [];
        var flowNodeReachable = [];
        var flowNodePostSuper = [];
        var potentialThisCollisions = [];
        var potentialNewTargetCollisions = [];
        var potentialWeakMapSetCollisions = [];
        var potentialReflectCollisions = [];
        var potentialUnusedRenamedBindingElementsInTypes = [];
        var awaitedTypeStack = [];
        var diagnostics = createDiagnosticCollection();
        var suggestionDiagnostics = createDiagnosticCollection();
        var typeofType = createTypeofType();
        var _jsxNamespace;
        var _jsxFactoryEntity;
        var subtypeRelation = /* @__PURE__ */ new Map();
        var strictSubtypeRelation = /* @__PURE__ */ new Map();
        var assignableRelation = /* @__PURE__ */ new Map();
        var comparableRelation = /* @__PURE__ */ new Map();
        var identityRelation = /* @__PURE__ */ new Map();
        var enumRelation = /* @__PURE__ */ new Map();
        var builtinGlobals = createSymbolTable();
        builtinGlobals.set(undefinedSymbol.escapedName, undefinedSymbol);
        var suggestedExtensions = [
            [
                ".mts",
                ".mjs"
            ],
            [
                ".ts",
                ".js"
            ],
            [
                ".cts",
                ".cjs"
            ],
            [
                ".mjs",
                ".mjs"
            ],
            [
                ".js",
                ".js"
            ],
            [
                ".cjs",
                ".cjs"
            ],
            [
                ".tsx",
                compilerOptions.jsx === 1 /* Preserve */  ? ".jsx" : ".js"
            ],
            [
                ".jsx",
                ".jsx"
            ],
            [
                ".json",
                ".json"
            ]
        ];
        initializeTypeChecker();
        return checker;
        function getCachedType(key) {
            return key ? cachedTypes.get(key) : void 0;
        }
        function setCachedType(key, type) {
            if (key) cachedTypes.set(key, type);
            return type;
        }
        function getJsxNamespace(location) {
            if (location) {
                const file = getSourceFileOfNode(location);
                if (file) {
                    if (isJsxOpeningFragment(location)) {
                        if (file.localJsxFragmentNamespace) return file.localJsxFragmentNamespace;
                        const jsxFragmentPragma = file.pragmas.get("jsxfrag");
                        if (jsxFragmentPragma) {
                            const chosenPragma = isArray(jsxFragmentPragma) ? jsxFragmentPragma[0] : jsxFragmentPragma;
                            file.localJsxFragmentFactory = parseIsolatedEntityName(chosenPragma.arguments.factory, languageVersion);
                            visitNode(file.localJsxFragmentFactory, markAsSynthetic, isEntityName);
                            if (file.localJsxFragmentFactory) return file.localJsxFragmentNamespace = getFirstIdentifier(file.localJsxFragmentFactory).escapedText;
                        }
                        const entity = getJsxFragmentFactoryEntity(location);
                        if (entity) {
                            file.localJsxFragmentFactory = entity;
                            return file.localJsxFragmentNamespace = getFirstIdentifier(entity).escapedText;
                        }
                    } else {
                        const localJsxNamespace = getLocalJsxNamespace(file);
                        if (localJsxNamespace) return file.localJsxNamespace = localJsxNamespace;
                    }
                }
            }
            if (!_jsxNamespace) {
                _jsxNamespace = "React";
                if (compilerOptions.jsxFactory) {
                    _jsxFactoryEntity = parseIsolatedEntityName(compilerOptions.jsxFactory, languageVersion);
                    visitNode(_jsxFactoryEntity, markAsSynthetic);
                    if (_jsxFactoryEntity) _jsxNamespace = getFirstIdentifier(_jsxFactoryEntity).escapedText;
                } else if (compilerOptions.reactNamespace) _jsxNamespace = escapeLeadingUnderscores(compilerOptions.reactNamespace);
            }
            if (!_jsxFactoryEntity) _jsxFactoryEntity = factory.createQualifiedName(factory.createIdentifier(unescapeLeadingUnderscores(_jsxNamespace)), "createElement");
            return _jsxNamespace;
        }
        function getLocalJsxNamespace(file) {
            if (file.localJsxNamespace) return file.localJsxNamespace;
            const jsxPragma = file.pragmas.get("jsx");
            if (jsxPragma) {
                const chosenPragma = isArray(jsxPragma) ? jsxPragma[0] : jsxPragma;
                file.localJsxFactory = parseIsolatedEntityName(chosenPragma.arguments.factory, languageVersion);
                visitNode(file.localJsxFactory, markAsSynthetic, isEntityName);
                if (file.localJsxFactory) return file.localJsxNamespace = getFirstIdentifier(file.localJsxFactory).escapedText;
            }
        }
        function markAsSynthetic(node) {
            setTextRangePosEnd(node, -1, -1);
            return visitEachChild(node, markAsSynthetic, nullTransformationContext);
        }
        function getEmitResolver(sourceFile, cancellationToken2) {
            getDiagnostics2(sourceFile, cancellationToken2);
            return emitResolver;
        }
        function lookupOrIssueError(location, message, ...args) {
            const diagnostic = location ? createDiagnosticForNode(location, message, ...args) : createCompilerDiagnostic(message, ...args);
            const existing = diagnostics.lookup(diagnostic);
            if (existing) return existing;
            else {
                diagnostics.add(diagnostic);
                return diagnostic;
            }
        }
        function errorSkippedOn(key, location, message, ...args) {
            const diagnostic = error(location, message, ...args);
            diagnostic.skippedOn = key;
            return diagnostic;
        }
        function createError(location, message, ...args) {
            return location ? createDiagnosticForNode(location, message, ...args) : createCompilerDiagnostic(message, ...args);
        }
        function error(location, message, ...args) {
            const diagnostic = createError(location, message, ...args);
            diagnostics.add(diagnostic);
            return diagnostic;
        }
        function addErrorOrSuggestion(isError, diagnostic) {
            if (isError) diagnostics.add(diagnostic);
            else suggestionDiagnostics.add({
                ...diagnostic,
                category: 2 /* Suggestion */ 
            });
        }
        function errorOrSuggestion(isError, location, message, ...args) {
            if (location.pos < 0 || location.end < 0) {
                if (!isError) return;
                const file = getSourceFileOfNode(location);
                addErrorOrSuggestion(isError, "message" in message ? createFileDiagnostic(file, 0, 0, message, ...args) : createDiagnosticForFileFromMessageChain(file, message));
                return;
            }
            addErrorOrSuggestion(isError, "message" in message ? createDiagnosticForNode(location, message, ...args) : createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(location), location, message));
        }
        function errorAndMaybeSuggestAwait(location, maybeMissingAwait, message, ...args) {
            const diagnostic = error(location, message, ...args);
            if (maybeMissingAwait) {
                const related = createDiagnosticForNode(location, Diagnostics.Did_you_forget_to_use_await);
                addRelatedInfo(diagnostic, related);
            }
            return diagnostic;
        }
        function addDeprecatedSuggestionWorker(declarations, diagnostic) {
            const deprecatedTag = Array.isArray(declarations) ? forEach(declarations, getJSDocDeprecatedTag) : getJSDocDeprecatedTag(declarations);
            if (deprecatedTag) addRelatedInfo(diagnostic, createDiagnosticForNode(deprecatedTag, Diagnostics.The_declaration_was_marked_as_deprecated_here));
            suggestionDiagnostics.add(diagnostic);
            return diagnostic;
        }
        function isDeprecatedSymbol(symbol) {
            const parentSymbol = getParentOfSymbol(symbol);
            if (parentSymbol && length(symbol.declarations) > 1) return parentSymbol.flags & 64 /* Interface */  ? some(symbol.declarations, isDeprecatedDeclaration2) : every(symbol.declarations, isDeprecatedDeclaration2);
            return !!symbol.valueDeclaration && isDeprecatedDeclaration2(symbol.valueDeclaration) || length(symbol.declarations) && every(symbol.declarations, isDeprecatedDeclaration2);
        }
        function isDeprecatedDeclaration2(declaration) {
            return !!(getCombinedNodeFlags(declaration) & 268435456 /* Deprecated */ );
        }
        function addDeprecatedSuggestion(location, declarations, deprecatedEntity) {
            const diagnostic = createDiagnosticForNode(location, Diagnostics._0_is_deprecated, deprecatedEntity);
            return addDeprecatedSuggestionWorker(declarations, diagnostic);
        }
        function addDeprecatedSuggestionWithSignature(location, declaration, deprecatedEntity, signatureString) {
            const diagnostic = deprecatedEntity ? createDiagnosticForNode(location, Diagnostics.The_signature_0_of_1_is_deprecated, signatureString, deprecatedEntity) : createDiagnosticForNode(location, Diagnostics._0_is_deprecated, signatureString);
            return addDeprecatedSuggestionWorker(declaration, diagnostic);
        }
        function createSymbol(flags, name, checkFlags) {
            symbolCount++;
            const symbol = new Symbol47(flags | 33554432 /* Transient */ , name);
            symbol.links = new SymbolLinks();
            symbol.links.checkFlags = checkFlags || 0 /* None */ ;
            return symbol;
        }
        function createParameter(name, type) {
            const symbol = createSymbol(1 /* FunctionScopedVariable */ , name);
            symbol.links.type = type;
            return symbol;
        }
        function createProperty(name, type) {
            const symbol = createSymbol(4 /* Property */ , name);
            symbol.links.type = type;
            return symbol;
        }
        function getExcludedSymbolFlags(flags) {
            let result = 0;
            if (flags & 2 /* BlockScopedVariable */ ) result |= 111551 /* BlockScopedVariableExcludes */ ;
            if (flags & 1 /* FunctionScopedVariable */ ) result |= 111550 /* FunctionScopedVariableExcludes */ ;
            if (flags & 4 /* Property */ ) result |= 0 /* PropertyExcludes */ ;
            if (flags & 8 /* EnumMember */ ) result |= 900095 /* EnumMemberExcludes */ ;
            if (flags & 16 /* Function */ ) result |= 110991 /* FunctionExcludes */ ;
            if (flags & 32 /* Class */ ) result |= 899503 /* ClassExcludes */ ;
            if (flags & 64 /* Interface */ ) result |= 788872 /* InterfaceExcludes */ ;
            if (flags & 256 /* RegularEnum */ ) result |= 899327 /* RegularEnumExcludes */ ;
            if (flags & 128 /* ConstEnum */ ) result |= 899967 /* ConstEnumExcludes */ ;
            if (flags & 512 /* ValueModule */ ) result |= 110735 /* ValueModuleExcludes */ ;
            if (flags & 8192 /* Method */ ) result |= 103359 /* MethodExcludes */ ;
            if (flags & 32768 /* GetAccessor */ ) result |= 46015 /* GetAccessorExcludes */ ;
            if (flags & 65536 /* SetAccessor */ ) result |= 78783 /* SetAccessorExcludes */ ;
            if (flags & 262144 /* TypeParameter */ ) result |= 526824 /* TypeParameterExcludes */ ;
            if (flags & 524288 /* TypeAlias */ ) result |= 788968 /* TypeAliasExcludes */ ;
            if (flags & 2097152 /* Alias */ ) result |= 2097152 /* AliasExcludes */ ;
            return result;
        }
        function recordMergedSymbol(target, source) {
            if (!source.mergeId) {
                source.mergeId = nextMergeId;
                nextMergeId++;
            }
            mergedSymbols[source.mergeId] = target;
        }
        function cloneSymbol(symbol) {
            const result = createSymbol(symbol.flags, symbol.escapedName);
            result.declarations = symbol.declarations ? symbol.declarations.slice() : [];
            result.parent = symbol.parent;
            if (symbol.valueDeclaration) result.valueDeclaration = symbol.valueDeclaration;
            if (symbol.constEnumOnlyModule) result.constEnumOnlyModule = true;
            if (symbol.members) result.members = new Map(symbol.members);
            if (symbol.exports) result.exports = new Map(symbol.exports);
            recordMergedSymbol(result, symbol);
            return result;
        }
        function mergeSymbol(target, source, unidirectional = false) {
            if (!(target.flags & getExcludedSymbolFlags(source.flags)) || (source.flags | target.flags) & 67108864 /* Assignment */ ) {
                if (source === target) return target;
                if (!(target.flags & 33554432 /* Transient */ )) {
                    const resolvedTarget = resolveSymbol(target);
                    if (resolvedTarget === unknownSymbol) return source;
                    target = cloneSymbol(resolvedTarget);
                }
                if (source.flags & 512 /* ValueModule */  && target.flags & 512 /* ValueModule */  && target.constEnumOnlyModule && !source.constEnumOnlyModule) target.constEnumOnlyModule = false;
                target.flags |= source.flags;
                if (source.valueDeclaration) setValueDeclaration(target, source.valueDeclaration);
                addRange(target.declarations, source.declarations);
                if (source.members) {
                    if (!target.members) target.members = createSymbolTable();
                    mergeSymbolTable(target.members, source.members, unidirectional);
                }
                if (source.exports) {
                    if (!target.exports) target.exports = createSymbolTable();
                    mergeSymbolTable(target.exports, source.exports, unidirectional);
                }
                if (!unidirectional) recordMergedSymbol(target, source);
            } else if (target.flags & 1024 /* NamespaceModule */ ) {
                if (target !== globalThisSymbol) error(source.declarations && getNameOfDeclaration(source.declarations[0]), Diagnostics.Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity, symbolToString(target));
            } else {
                const isEitherEnum = !!(target.flags & 384 /* Enum */  || source.flags & 384 /* Enum */ );
                const isEitherBlockScoped = !!(target.flags & 2 /* BlockScopedVariable */  || source.flags & 2 /* BlockScopedVariable */ );
                const message = isEitherEnum ? Diagnostics.Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations : isEitherBlockScoped ? Diagnostics.Cannot_redeclare_block_scoped_variable_0 : Diagnostics.Duplicate_identifier_0;
                const sourceSymbolFile = source.declarations && getSourceFileOfNode(source.declarations[0]);
                const targetSymbolFile = target.declarations && getSourceFileOfNode(target.declarations[0]);
                const isSourcePlainJs = isPlainJsFile(sourceSymbolFile, compilerOptions.checkJs);
                const isTargetPlainJs = isPlainJsFile(targetSymbolFile, compilerOptions.checkJs);
                const symbolName2 = symbolToString(source);
                if (sourceSymbolFile && targetSymbolFile && amalgamatedDuplicates && !isEitherEnum && sourceSymbolFile !== targetSymbolFile) {
                    const firstFile = comparePaths(sourceSymbolFile.path, targetSymbolFile.path) === -1 /* LessThan */  ? sourceSymbolFile : targetSymbolFile;
                    const secondFile = firstFile === sourceSymbolFile ? targetSymbolFile : sourceSymbolFile;
                    const filesDuplicates = getOrUpdate(amalgamatedDuplicates, `${firstFile.path}|${secondFile.path}`, ()=>({
                            firstFile: firstFile,
                            secondFile: secondFile,
                            conflictingSymbols: /* @__PURE__ */ new Map()
                        }));
                    const conflictingSymbolInfo = getOrUpdate(filesDuplicates.conflictingSymbols, symbolName2, ()=>({
                            isBlockScoped: isEitherBlockScoped,
                            firstFileLocations: [],
                            secondFileLocations: []
                        }));
                    if (!isSourcePlainJs) addDuplicateLocations(conflictingSymbolInfo.firstFileLocations, source);
                    if (!isTargetPlainJs) addDuplicateLocations(conflictingSymbolInfo.secondFileLocations, target);
                } else {
                    if (!isSourcePlainJs) addDuplicateDeclarationErrorsForSymbols(source, message, symbolName2, target);
                    if (!isTargetPlainJs) addDuplicateDeclarationErrorsForSymbols(target, message, symbolName2, source);
                }
            }
            return target;
            function addDuplicateLocations(locs, symbol) {
                if (symbol.declarations) for (const decl of symbol.declarations)pushIfUnique(locs, decl);
            }
        }
        function addDuplicateDeclarationErrorsForSymbols(target, message, symbolName2, source) {
            forEach(target.declarations, (node)=>{
                addDuplicateDeclarationError(node, message, symbolName2, source.declarations);
            });
        }
        function addDuplicateDeclarationError(node, message, symbolName2, relatedNodes) {
            const errorNode = (getExpandoInitializer(node, /*isPrototypeAssignment*/ false) ? getNameOfExpando(node) : getNameOfDeclaration(node)) || node;
            const err = lookupOrIssueError(errorNode, message, symbolName2);
            for (const relatedNode of relatedNodes || emptyArray){
                const adjustedNode = (getExpandoInitializer(relatedNode, /*isPrototypeAssignment*/ false) ? getNameOfExpando(relatedNode) : getNameOfDeclaration(relatedNode)) || relatedNode;
                if (adjustedNode === errorNode) continue;
                err.relatedInformation = err.relatedInformation || [];
                const leadingMessage = createDiagnosticForNode(adjustedNode, Diagnostics._0_was_also_declared_here, symbolName2);
                const followOnMessage = createDiagnosticForNode(adjustedNode, Diagnostics.and_here);
                if (length(err.relatedInformation) >= 5 || some(err.relatedInformation, (r)=>compareDiagnostics(r, followOnMessage) === 0 /* EqualTo */  || compareDiagnostics(r, leadingMessage) === 0 /* EqualTo */ )) continue;
                addRelatedInfo(err, !length(err.relatedInformation) ? leadingMessage : followOnMessage);
            }
        }
        function combineSymbolTables(first2, second) {
            if (!(first2 == null ? void 0 : first2.size)) return second;
            if (!(second == null ? void 0 : second.size)) return first2;
            const combined = createSymbolTable();
            mergeSymbolTable(combined, first2);
            mergeSymbolTable(combined, second);
            return combined;
        }
        function mergeSymbolTable(target, source, unidirectional = false) {
            source.forEach((sourceSymbol, id)=>{
                const targetSymbol = target.get(id);
                target.set(id, targetSymbol ? mergeSymbol(targetSymbol, sourceSymbol, unidirectional) : getMergedSymbol(sourceSymbol));
            });
        }
        function mergeModuleAugmentation(moduleName) {
            var _a, _b, _c;
            const moduleAugmentation = moduleName.parent;
            if (((_a = moduleAugmentation.symbol.declarations) == null ? void 0 : _a[0]) !== moduleAugmentation) {
                Debug.assert(moduleAugmentation.symbol.declarations.length > 1);
                return;
            }
            if (isGlobalScopeAugmentation(moduleAugmentation)) mergeSymbolTable(globals, moduleAugmentation.symbol.exports);
            else {
                const moduleNotFoundError = !(moduleName.parent.parent.flags & 16777216 /* Ambient */ ) ? Diagnostics.Invalid_module_name_in_augmentation_module_0_cannot_be_found : void 0;
                let mainModule = resolveExternalModuleNameWorker(moduleName, moduleName, moduleNotFoundError, /*isForAugmentation*/ true);
                if (!mainModule) return;
                mainModule = resolveExternalModuleSymbol(mainModule);
                if (mainModule.flags & 1920 /* Namespace */ ) {
                    if (some(patternAmbientModules, (module2)=>mainModule === module2.symbol)) {
                        const merged = mergeSymbol(moduleAugmentation.symbol, mainModule, /*unidirectional*/ true);
                        if (!patternAmbientModuleAugmentations) patternAmbientModuleAugmentations = /* @__PURE__ */ new Map();
                        patternAmbientModuleAugmentations.set(moduleName.text, merged);
                    } else {
                        if (((_b = mainModule.exports) == null ? void 0 : _b.get("__export" /* ExportStar */ )) && ((_c = moduleAugmentation.symbol.exports) == null ? void 0 : _c.size)) {
                            const resolvedExports = getResolvedMembersOrExportsOfSymbol(mainModule, "resolvedExports" /* resolvedExports */ );
                            for (const [key, value1] of arrayFrom(moduleAugmentation.symbol.exports.entries()))if (resolvedExports.has(key) && !mainModule.exports.has(key)) mergeSymbol(resolvedExports.get(key), value1);
                        }
                        mergeSymbol(mainModule, moduleAugmentation.symbol);
                    }
                } else error(moduleName, Diagnostics.Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity, moduleName.text);
            }
        }
        function addToSymbolTable(target, source, message) {
            source.forEach((sourceSymbol, id)=>{
                const targetSymbol = target.get(id);
                if (targetSymbol) forEach(targetSymbol.declarations, addDeclarationDiagnostic(unescapeLeadingUnderscores(id), message));
                else target.set(id, sourceSymbol);
            });
            function addDeclarationDiagnostic(id, message2) {
                return (declaration)=>diagnostics.add(createDiagnosticForNode(declaration, message2, id));
            }
        }
        function getSymbolLinks(symbol) {
            if (symbol.flags & 33554432 /* Transient */ ) return symbol.links;
            const id = getSymbolId(symbol);
            return symbolLinks[id] ?? (symbolLinks[id] = new SymbolLinks());
        }
        function getNodeLinks(node) {
            const nodeId = getNodeId(node);
            return nodeLinks[nodeId] || (nodeLinks[nodeId] = new NodeLinks());
        }
        function isGlobalSourceFile(node) {
            return node.kind === 311 /* SourceFile */  && !isExternalOrCommonJsModule(node);
        }
        function getSymbol2(symbols, name, meaning) {
            if (meaning) {
                const symbol = getMergedSymbol(symbols.get(name));
                if (symbol) {
                    Debug.assert((getCheckFlags(symbol) & 1 /* Instantiated */ ) === 0, "Should never get an instantiated symbol here.");
                    if (symbol.flags & meaning) return symbol;
                    if (symbol.flags & 2097152 /* Alias */ ) {
                        const targetFlags = getAllSymbolFlags(symbol);
                        if (targetFlags & meaning) return symbol;
                    }
                }
            }
        }
        function getSymbolsOfParameterPropertyDeclaration(parameter, parameterName) {
            const constructorDeclaration = parameter.parent;
            const classDeclaration = parameter.parent.parent;
            const parameterSymbol = getSymbol2(constructorDeclaration.locals, parameterName, 111551 /* Value */ );
            const propertySymbol = getSymbol2(getMembersOfSymbol(classDeclaration.symbol), parameterName, 111551 /* Value */ );
            if (parameterSymbol && propertySymbol) return [
                parameterSymbol,
                propertySymbol
            ];
            return Debug.fail("There should exist two symbols, one as property declaration and one as parameter declaration");
        }
        function isBlockScopedNameDeclaredBeforeUse(declaration, usage) {
            const declarationFile = getSourceFileOfNode(declaration);
            const useFile = getSourceFileOfNode(usage);
            const declContainer = getEnclosingBlockScopeContainer(declaration);
            if (declarationFile !== useFile) {
                if (moduleKind && (declarationFile.externalModuleIndicator || useFile.externalModuleIndicator) || !outFile(compilerOptions) || isInTypeQuery(usage) || declaration.flags & 16777216 /* Ambient */ ) return true;
                if (isUsedInFunctionOrInstanceProperty(usage, declaration)) return true;
                const sourceFiles = host.getSourceFiles();
                return sourceFiles.indexOf(declarationFile) <= sourceFiles.indexOf(useFile);
            }
            if (declaration.pos <= usage.pos && !(isPropertyDeclaration(declaration) && isThisProperty(usage.parent) && !declaration.initializer && !declaration.exclamationToken)) {
                if (declaration.kind === 207 /* BindingElement */ ) {
                    const errorBindingElement = getAncestor(usage, 207 /* BindingElement */ );
                    if (errorBindingElement) return findAncestor(errorBindingElement, isBindingElement) !== findAncestor(declaration, isBindingElement) || declaration.pos < errorBindingElement.pos;
                    return isBlockScopedNameDeclaredBeforeUse(getAncestor(declaration, 259 /* VariableDeclaration */ ), usage);
                } else if (declaration.kind === 259 /* VariableDeclaration */ ) return !isImmediatelyUsedInInitializerOfBlockScopedVariable(declaration, usage);
                else if (isClassDeclaration(declaration)) return !findAncestor(usage, (n)=>isComputedPropertyName(n) && n.parent.parent === declaration);
                else if (isPropertyDeclaration(declaration)) return !isPropertyImmediatelyReferencedWithinDeclaration(declaration, usage, /*stopAtAnyPropertyDeclaration*/ false);
                else if (isParameterPropertyDeclaration(declaration, declaration.parent)) return !(getEmitScriptTarget(compilerOptions) === 99 /* ESNext */  && useDefineForClassFields && getContainingClass(declaration) === getContainingClass(usage) && isUsedInFunctionOrInstanceProperty(usage, declaration));
                return true;
            }
            if (usage.parent.kind === 280 /* ExportSpecifier */  || usage.parent.kind === 276 /* ExportAssignment */  && usage.parent.isExportEquals) return true;
            if (usage.kind === 276 /* ExportAssignment */  && usage.isExportEquals) return true;
            if (!!(usage.flags & 8388608 /* JSDoc */ ) || isInTypeQuery(usage) || isInAmbientOrTypeNode(usage)) return true;
            if (isUsedInFunctionOrInstanceProperty(usage, declaration)) {
                if (getEmitScriptTarget(compilerOptions) >= 9 /* ES2022 */  && useDefineForClassFields && getContainingClass(declaration) && (isPropertyDeclaration(declaration) || isParameterPropertyDeclaration(declaration, declaration.parent))) return !isPropertyImmediatelyReferencedWithinDeclaration(declaration, usage, /*stopAtAnyPropertyDeclaration*/ true);
                else return true;
            }
            return false;
            function isImmediatelyUsedInInitializerOfBlockScopedVariable(declaration2, usage2) {
                switch(declaration2.parent.parent.kind){
                    case 242 /* VariableStatement */ :
                    case 247 /* ForStatement */ :
                    case 249 /* ForOfStatement */ :
                        if (isSameScopeDescendentOf(usage2, declaration2, declContainer)) return true;
                        break;
                }
                const grandparent = declaration2.parent.parent;
                return isForInOrOfStatement(grandparent) && isSameScopeDescendentOf(usage2, grandparent.expression, declContainer);
            }
            function isUsedInFunctionOrInstanceProperty(usage2, declaration2) {
                return !!findAncestor(usage2, (current)=>{
                    if (current === declContainer) return "quit";
                    if (isFunctionLike(current)) return true;
                    if (isClassStaticBlockDeclaration(current)) return declaration2.pos < usage2.pos;
                    const propertyDeclaration = tryCast(current.parent, isPropertyDeclaration);
                    if (propertyDeclaration) {
                        const initializerOfProperty = propertyDeclaration.initializer === current;
                        if (initializerOfProperty) {
                            if (isStatic(current.parent)) {
                                if (declaration2.kind === 173 /* MethodDeclaration */ ) return true;
                                if (isPropertyDeclaration(declaration2) && getContainingClass(usage2) === getContainingClass(declaration2)) {
                                    const propName = declaration2.name;
                                    if (isIdentifier(propName) || isPrivateIdentifier(propName)) {
                                        const type = getTypeOfSymbol(getSymbolOfDeclaration(declaration2));
                                        const staticBlocks = filter(declaration2.parent.members, isClassStaticBlockDeclaration);
                                        if (isPropertyInitializedInStaticBlocks(propName, type, staticBlocks, declaration2.parent.pos, current.pos)) return true;
                                    }
                                }
                            } else {
                                const isDeclarationInstanceProperty = declaration2.kind === 171 /* PropertyDeclaration */  && !isStatic(declaration2);
                                if (!isDeclarationInstanceProperty || getContainingClass(usage2) !== getContainingClass(declaration2)) return true;
                            }
                        }
                    }
                    return false;
                });
            }
            function isPropertyImmediatelyReferencedWithinDeclaration(declaration2, usage2, stopAtAnyPropertyDeclaration) {
                if (usage2.end > declaration2.end) return false;
                const ancestorChangingReferenceScope = findAncestor(usage2, (node)=>{
                    if (node === declaration2) return "quit";
                    switch(node.kind){
                        case 218 /* ArrowFunction */ :
                            return true;
                        case 171 /* PropertyDeclaration */ :
                            return stopAtAnyPropertyDeclaration && (isPropertyDeclaration(declaration2) && node.parent === declaration2.parent || isParameterPropertyDeclaration(declaration2, declaration2.parent) && node.parent === declaration2.parent.parent) ? "quit" : true;
                        case 240 /* Block */ :
                            switch(node.parent.kind){
                                case 176 /* GetAccessor */ :
                                case 173 /* MethodDeclaration */ :
                                case 177 /* SetAccessor */ :
                                    return true;
                                default:
                                    return false;
                            }
                        default:
                            return false;
                    }
                });
                return ancestorChangingReferenceScope === void 0;
            }
        }
        function useOuterVariableScopeInParameter(result, location, lastLocation) {
            const target = getEmitScriptTarget(compilerOptions);
            const functionLocation = location;
            if (isParameter(lastLocation) && functionLocation.body && result.valueDeclaration && result.valueDeclaration.pos >= functionLocation.body.pos && result.valueDeclaration.end <= functionLocation.body.end) {
                if (target >= 2 /* ES2015 */ ) {
                    const links = getNodeLinks(functionLocation);
                    if (links.declarationRequiresScopeChange === void 0) links.declarationRequiresScopeChange = forEach(functionLocation.parameters, requiresScopeChange) || false;
                    return !links.declarationRequiresScopeChange;
                }
            }
            return false;
            function requiresScopeChange(node) {
                return requiresScopeChangeWorker(node.name) || !!node.initializer && requiresScopeChangeWorker(node.initializer);
            }
            function requiresScopeChangeWorker(node) {
                switch(node.kind){
                    case 218 /* ArrowFunction */ :
                    case 217 /* FunctionExpression */ :
                    case 261 /* FunctionDeclaration */ :
                    case 175 /* Constructor */ :
                        return false;
                    case 173 /* MethodDeclaration */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                    case 302 /* PropertyAssignment */ :
                        return requiresScopeChangeWorker(node.name);
                    case 171 /* PropertyDeclaration */ :
                        if (hasStaticModifier(node)) return target < 99 /* ESNext */  || !useDefineForClassFields;
                        return requiresScopeChangeWorker(node.name);
                    default:
                        if (isNullishCoalesce(node) || isOptionalChain(node)) return target < 7 /* ES2020 */ ;
                        if (isBindingElement(node) && node.dotDotDotToken && isObjectBindingPattern(node.parent)) return target < 4 /* ES2017 */ ;
                        if (isTypeNode(node)) return false;
                        return forEachChild(node, requiresScopeChangeWorker) || false;
                }
            }
        }
        function isConstAssertion(location) {
            return isAssertionExpression(location) && isConstTypeReference(location.type) || isJSDocTypeTag(location) && isConstTypeReference(location.typeExpression);
        }
        function resolveName(location, name, meaning, nameNotFoundMessage, nameArg, isUse, excludeGlobals = false, getSpellingSuggestions = true) {
            return resolveNameHelper(location, name, meaning, nameNotFoundMessage, nameArg, isUse, excludeGlobals, getSpellingSuggestions, getSymbol2);
        }
        function resolveNameHelper(location, name, meaning, nameNotFoundMessage, nameArg, isUse, excludeGlobals, getSpellingSuggestions, lookup) {
            var _a, _b, _c;
            const originalLocation = location;
            let result;
            let lastLocation;
            let lastSelfReferenceLocation;
            let propertyWithInvalidInitializer;
            let associatedDeclarationForContainingInitializerOrBindingName;
            let withinDeferredContext = false;
            const errorLocation = location;
            let grandparent;
            let isInExternalModule = false;
            loop: while(location){
                if (name === "const" && isConstAssertion(location)) return void 0;
                if (isModuleDeclaration(location) && lastLocation && location.name === lastLocation) {
                    lastLocation = location;
                    location = location.parent;
                }
                if (canHaveLocals(location) && location.locals && !isGlobalSourceFile(location)) {
                    if (result = lookup(location.locals, name, meaning)) {
                        let useResult = true;
                        if (isFunctionLike(location) && lastLocation && lastLocation !== location.body) {
                            if (meaning & result.flags & 788968 /* Type */  && lastLocation.kind !== 326 /* JSDoc */ ) useResult = result.flags & 262144 /* TypeParameter */  ? lastLocation === location.type || lastLocation.kind === 168 /* Parameter */  || lastLocation.kind === 347 /* JSDocParameterTag */  || lastLocation.kind === 348 /* JSDocReturnTag */  || lastLocation.kind === 167 /* TypeParameter */  : false;
                            if (meaning & result.flags & 3 /* Variable */ ) {
                                if (useOuterVariableScopeInParameter(result, location, lastLocation)) useResult = false;
                                else if (result.flags & 1 /* FunctionScopedVariable */ ) useResult = lastLocation.kind === 168 /* Parameter */  || lastLocation === location.type && !!findAncestor(result.valueDeclaration, isParameter);
                            }
                        } else if (location.kind === 193 /* ConditionalType */ ) useResult = lastLocation === location.trueType;
                        if (useResult) break loop;
                        else result = void 0;
                    }
                }
                withinDeferredContext = withinDeferredContext || getIsDeferredContext(location, lastLocation);
                switch(location.kind){
                    case 311 /* SourceFile */ :
                        if (!isExternalOrCommonJsModule(location)) break;
                        isInExternalModule = true;
                    case 266 /* ModuleDeclaration */ :
                        const moduleExports = ((_a = getSymbolOfDeclaration(location)) == null ? void 0 : _a.exports) || emptySymbols;
                        if (location.kind === 311 /* SourceFile */  || isModuleDeclaration(location) && location.flags & 16777216 /* Ambient */  && !isGlobalScopeAugmentation(location)) {
                            if (result = moduleExports.get("default" /* Default */ )) {
                                const localSymbol = getLocalSymbolForExportDefault(result);
                                if (localSymbol && result.flags & meaning && localSymbol.escapedName === name) break loop;
                                result = void 0;
                            }
                            const moduleExport = moduleExports.get(name);
                            if (moduleExport && moduleExport.flags === 2097152 /* Alias */  && (getDeclarationOfKind(moduleExport, 280 /* ExportSpecifier */ ) || getDeclarationOfKind(moduleExport, 279 /* NamespaceExport */ ))) break;
                        }
                        if (name !== "default" /* Default */  && (result = lookup(moduleExports, name, meaning & 2623475 /* ModuleMember */ ))) {
                            if (isSourceFile(location) && location.commonJsModuleIndicator && !((_b = result.declarations) == null ? void 0 : _b.some(isJSDocTypeAlias))) result = void 0;
                            else break loop;
                        }
                        break;
                    case 265 /* EnumDeclaration */ :
                        if (result = lookup(((_c = getSymbolOfDeclaration(location)) == null ? void 0 : _c.exports) || emptySymbols, name, meaning & 8 /* EnumMember */ )) {
                            if (nameNotFoundMessage && getIsolatedModules(compilerOptions) && !(location.flags & 16777216 /* Ambient */ ) && getSourceFileOfNode(location) !== getSourceFileOfNode(result.valueDeclaration)) error(errorLocation, Diagnostics.Cannot_access_0_from_another_file_without_qualification_when_1_is_enabled_Use_2_instead, unescapeLeadingUnderscores(name), isolatedModulesLikeFlagName, `${unescapeLeadingUnderscores(getSymbolOfNode(location).escapedName)}.${unescapeLeadingUnderscores(name)}`);
                            break loop;
                        }
                        break;
                    case 171 /* PropertyDeclaration */ :
                        if (!isStatic(location)) {
                            const ctor = findConstructorDeclaration(location.parent);
                            if (ctor && ctor.locals) {
                                if (lookup(ctor.locals, name, meaning & 111551 /* Value */ )) {
                                    Debug.assertNode(location, isPropertyDeclaration);
                                    propertyWithInvalidInitializer = location;
                                }
                            }
                        }
                        break;
                    case 262 /* ClassDeclaration */ :
                    case 230 /* ClassExpression */ :
                    case 263 /* InterfaceDeclaration */ :
                        if (result = lookup(getSymbolOfDeclaration(location).members || emptySymbols, name, meaning & 788968 /* Type */ )) {
                            if (!isTypeParameterSymbolDeclaredInContainer(result, location)) {
                                result = void 0;
                                break;
                            }
                            if (lastLocation && isStatic(lastLocation)) {
                                if (nameNotFoundMessage) error(errorLocation, Diagnostics.Static_members_cannot_reference_class_type_parameters);
                                return void 0;
                            }
                            break loop;
                        }
                        if (isClassExpression(location) && meaning & 32 /* Class */ ) {
                            const className = location.name;
                            if (className && name === className.escapedText) {
                                result = location.symbol;
                                break loop;
                            }
                        }
                        break;
                    case 232 /* ExpressionWithTypeArguments */ :
                        if (lastLocation === location.expression && location.parent.token === 96 /* ExtendsKeyword */ ) {
                            const container = location.parent.parent;
                            if (isClassLike(container) && (result = lookup(getSymbolOfDeclaration(container).members, name, meaning & 788968 /* Type */ ))) {
                                if (nameNotFoundMessage) error(errorLocation, Diagnostics.Base_class_expressions_cannot_reference_class_type_parameters);
                                return void 0;
                            }
                        }
                        break;
                    case 166 /* ComputedPropertyName */ :
                        grandparent = location.parent.parent;
                        if (isClassLike(grandparent) || grandparent.kind === 263 /* InterfaceDeclaration */ ) {
                            if (result = lookup(getSymbolOfDeclaration(grandparent).members, name, meaning & 788968 /* Type */ )) {
                                if (nameNotFoundMessage) error(errorLocation, Diagnostics.A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type);
                                return void 0;
                            }
                        }
                        break;
                    case 218 /* ArrowFunction */ :
                        if (getEmitScriptTarget(compilerOptions) >= 2 /* ES2015 */ ) break;
                    case 173 /* MethodDeclaration */ :
                    case 175 /* Constructor */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                    case 261 /* FunctionDeclaration */ :
                        if (meaning & 3 /* Variable */  && name === "arguments") {
                            result = argumentsSymbol;
                            break loop;
                        }
                        break;
                    case 217 /* FunctionExpression */ :
                        if (meaning & 3 /* Variable */  && name === "arguments") {
                            result = argumentsSymbol;
                            break loop;
                        }
                        if (meaning & 16 /* Function */ ) {
                            const functionName = location.name;
                            if (functionName && name === functionName.escapedText) {
                                result = location.symbol;
                                break loop;
                            }
                        }
                        break;
                    case 169 /* Decorator */ :
                        if (location.parent && location.parent.kind === 168 /* Parameter */ ) location = location.parent;
                        if (location.parent && (isClassElement(location.parent) || location.parent.kind === 262 /* ClassDeclaration */ )) location = location.parent;
                        break;
                    case 352 /* JSDocTypedefTag */ :
                    case 344 /* JSDocCallbackTag */ :
                    case 346 /* JSDocEnumTag */ :
                        const root = getJSDocRoot(location);
                        if (root) location = root.parent;
                        break;
                    case 168 /* Parameter */ :
                        if (lastLocation && (lastLocation === location.initializer || lastLocation === location.name && isBindingPattern(lastLocation))) {
                            if (!associatedDeclarationForContainingInitializerOrBindingName) associatedDeclarationForContainingInitializerOrBindingName = location;
                        }
                        break;
                    case 207 /* BindingElement */ :
                        if (lastLocation && (lastLocation === location.initializer || lastLocation === location.name && isBindingPattern(lastLocation))) {
                            if (isParameterDeclaration(location) && !associatedDeclarationForContainingInitializerOrBindingName) associatedDeclarationForContainingInitializerOrBindingName = location;
                        }
                        break;
                    case 194 /* InferType */ :
                        if (meaning & 262144 /* TypeParameter */ ) {
                            const parameterName = location.typeParameter.name;
                            if (parameterName && name === parameterName.escapedText) {
                                result = location.typeParameter.symbol;
                                break loop;
                            }
                        }
                        break;
                    case 280 /* ExportSpecifier */ :
                        if (lastLocation && lastLocation === location.propertyName && location.parent.parent.moduleSpecifier) location = location.parent.parent.parent;
                        break;
                }
                if (isSelfReferenceLocation(location)) lastSelfReferenceLocation = location;
                lastLocation = location;
                location = isJSDocTemplateTag(location) ? getEffectiveContainerForJSDocTemplateTag(location) || location.parent : isJSDocParameterTag(location) || isJSDocReturnTag(location) ? getHostSignatureFromJSDoc(location) || location.parent : location.parent;
            }
            if (isUse && result && (!lastSelfReferenceLocation || result !== lastSelfReferenceLocation.symbol)) result.isReferenced |= meaning;
            if (!result) {
                if (lastLocation) {
                    Debug.assertNode(lastLocation, isSourceFile);
                    if (lastLocation.commonJsModuleIndicator && name === "exports" && meaning & lastLocation.symbol.flags) return lastLocation.symbol;
                }
                if (!excludeGlobals) result = lookup(globals, name, meaning);
            }
            if (!result) {
                if (originalLocation && isInJSFile(originalLocation) && originalLocation.parent) {
                    if (isRequireCall(originalLocation.parent, /*requireStringLiteralLikeArgument*/ false)) return requireSymbol;
                }
            }
            function checkAndReportErrorForInvalidInitializer() {
                if (propertyWithInvalidInitializer && !(useDefineForClassFields && getEmitScriptTarget(compilerOptions) >= 9 /* ES2022 */ )) {
                    error(errorLocation, errorLocation && propertyWithInvalidInitializer.type && textRangeContainsPositionInclusive(propertyWithInvalidInitializer.type, errorLocation.pos) ? Diagnostics.Type_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor : Diagnostics.Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor, declarationNameToString(propertyWithInvalidInitializer.name), diagnosticName(nameArg));
                    return true;
                }
                return false;
            }
            if (!result) {
                if (nameNotFoundMessage) addLazyDiagnostic(()=>{
                    if (!errorLocation || errorLocation.parent.kind !== 330 /* JSDocLink */  && !checkAndReportErrorForMissingPrefix(errorLocation, name, nameArg) && // TODO: GH#18217
                    !checkAndReportErrorForInvalidInitializer() && !checkAndReportErrorForExtendingInterface(errorLocation) && !checkAndReportErrorForUsingTypeAsNamespace(errorLocation, name, meaning) && !checkAndReportErrorForExportingPrimitiveType(errorLocation, name) && !checkAndReportErrorForUsingNamespaceAsTypeOrValue(errorLocation, name, meaning) && !checkAndReportErrorForUsingTypeAsValue(errorLocation, name, meaning) && !checkAndReportErrorForUsingValueAsType(errorLocation, name, meaning)) {
                        let suggestion;
                        let suggestedLib;
                        if (nameArg) {
                            suggestedLib = getSuggestedLibForNonExistentName(nameArg);
                            if (suggestedLib) error(errorLocation, nameNotFoundMessage, diagnosticName(nameArg), suggestedLib);
                        }
                        if (!suggestedLib && getSpellingSuggestions && suggestionCount < maximumSuggestionCount) {
                            suggestion = getSuggestedSymbolForNonexistentSymbol(originalLocation, name, meaning);
                            const isGlobalScopeAugmentationDeclaration = (suggestion == null ? void 0 : suggestion.valueDeclaration) && isAmbientModule(suggestion.valueDeclaration) && isGlobalScopeAugmentation(suggestion.valueDeclaration);
                            if (isGlobalScopeAugmentationDeclaration) suggestion = void 0;
                            if (suggestion) {
                                const suggestionName = symbolToString(suggestion);
                                const isUncheckedJS = isUncheckedJSSuggestion(originalLocation, suggestion, /*excludeClasses*/ false);
                                const message = meaning === 1920 /* Namespace */  || nameArg && typeof nameArg !== "string" && nodeIsSynthesized(nameArg) ? Diagnostics.Cannot_find_namespace_0_Did_you_mean_1 : isUncheckedJS ? Diagnostics.Could_not_find_name_0_Did_you_mean_1 : Diagnostics.Cannot_find_name_0_Did_you_mean_1;
                                const diagnostic = createError(errorLocation, message, diagnosticName(nameArg), suggestionName);
                                addErrorOrSuggestion(!isUncheckedJS, diagnostic);
                                if (suggestion.valueDeclaration) addRelatedInfo(diagnostic, createDiagnosticForNode(suggestion.valueDeclaration, Diagnostics._0_is_declared_here, suggestionName));
                            }
                        }
                        if (!suggestion && !suggestedLib && nameArg) error(errorLocation, nameNotFoundMessage, diagnosticName(nameArg));
                        suggestionCount++;
                    }
                });
                return void 0;
            } else if (nameNotFoundMessage && checkAndReportErrorForInvalidInitializer()) return void 0;
            if (nameNotFoundMessage) addLazyDiagnostic(()=>{
                if (errorLocation && (meaning & 2 /* BlockScopedVariable */  || (meaning & 32 /* Class */  || meaning & 384 /* Enum */ ) && (meaning & 111551 /* Value */ ) === 111551 /* Value */ )) {
                    const exportOrLocalSymbol = getExportSymbolOfValueSymbolIfExported(result);
                    if (exportOrLocalSymbol.flags & 2 /* BlockScopedVariable */  || exportOrLocalSymbol.flags & 32 /* Class */  || exportOrLocalSymbol.flags & 384 /* Enum */ ) checkResolvedBlockScopedVariable(exportOrLocalSymbol, errorLocation);
                }
                if (result && isInExternalModule && (meaning & 111551 /* Value */ ) === 111551 /* Value */  && !(originalLocation.flags & 8388608 /* JSDoc */ )) {
                    const merged = getMergedSymbol(result);
                    if (length(merged.declarations) && every(merged.declarations, (d)=>isNamespaceExportDeclaration(d) || isSourceFile(d) && !!d.symbol.globalExports)) errorOrSuggestion(!compilerOptions.allowUmdGlobalAccess, errorLocation, Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead, unescapeLeadingUnderscores(name));
                }
                if (result && associatedDeclarationForContainingInitializerOrBindingName && !withinDeferredContext && (meaning & 111551 /* Value */ ) === 111551 /* Value */ ) {
                    const candidate = getMergedSymbol(getLateBoundSymbol(result));
                    const root = getRootDeclaration(associatedDeclarationForContainingInitializerOrBindingName);
                    if (candidate === getSymbolOfDeclaration(associatedDeclarationForContainingInitializerOrBindingName)) error(errorLocation, Diagnostics.Parameter_0_cannot_reference_itself, declarationNameToString(associatedDeclarationForContainingInitializerOrBindingName.name));
                    else if (candidate.valueDeclaration && candidate.valueDeclaration.pos > associatedDeclarationForContainingInitializerOrBindingName.pos && root.parent.locals && lookup(root.parent.locals, candidate.escapedName, meaning) === candidate) error(errorLocation, Diagnostics.Parameter_0_cannot_reference_identifier_1_declared_after_it, declarationNameToString(associatedDeclarationForContainingInitializerOrBindingName.name), declarationNameToString(errorLocation));
                }
                if (result && errorLocation && meaning & 111551 /* Value */  && result.flags & 2097152 /* Alias */  && !(result.flags & 111551 /* Value */ ) && !isValidTypeOnlyAliasUseSite(errorLocation)) {
                    const typeOnlyDeclaration = getTypeOnlyAliasDeclaration(result, 111551 /* Value */ );
                    if (typeOnlyDeclaration) {
                        const message = typeOnlyDeclaration.kind === 280 /* ExportSpecifier */  || typeOnlyDeclaration.kind === 277 /* ExportDeclaration */  || typeOnlyDeclaration.kind === 279 /* NamespaceExport */  ? Diagnostics._0_cannot_be_used_as_a_value_because_it_was_exported_using_export_type : Diagnostics._0_cannot_be_used_as_a_value_because_it_was_imported_using_import_type;
                        const unescapedName = unescapeLeadingUnderscores(name);
                        addTypeOnlyDeclarationRelatedInfo(error(errorLocation, message, unescapedName), typeOnlyDeclaration, unescapedName);
                    }
                }
            });
            return result;
        }
        function addTypeOnlyDeclarationRelatedInfo(diagnostic, typeOnlyDeclaration, unescapedName) {
            if (!typeOnlyDeclaration) return diagnostic;
            return addRelatedInfo(diagnostic, createDiagnosticForNode(typeOnlyDeclaration, typeOnlyDeclaration.kind === 280 /* ExportSpecifier */  || typeOnlyDeclaration.kind === 277 /* ExportDeclaration */  || typeOnlyDeclaration.kind === 279 /* NamespaceExport */  ? Diagnostics._0_was_exported_here : Diagnostics._0_was_imported_here, unescapedName));
        }
        function getIsDeferredContext(location, lastLocation) {
            if (location.kind !== 218 /* ArrowFunction */  && location.kind !== 217 /* FunctionExpression */ ) return isTypeQueryNode(location) || (isFunctionLikeDeclaration(location) || location.kind === 171 /* PropertyDeclaration */  && !isStatic(location)) && (!lastLocation || lastLocation !== location.name);
            if (lastLocation && lastLocation === location.name) return false;
            if (location.asteriskToken || hasSyntacticModifier(location, 512 /* Async */ )) return true;
            return !getImmediatelyInvokedFunctionExpression(location);
        }
        function isSelfReferenceLocation(node) {
            switch(node.kind){
                case 261 /* FunctionDeclaration */ :
                case 262 /* ClassDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                case 265 /* EnumDeclaration */ :
                case 264 /* TypeAliasDeclaration */ :
                case 266 /* ModuleDeclaration */ :
                    return true;
                default:
                    return false;
            }
        }
        function diagnosticName(nameArg) {
            return isString(nameArg) ? unescapeLeadingUnderscores(nameArg) : declarationNameToString(nameArg);
        }
        function isTypeParameterSymbolDeclaredInContainer(symbol, container) {
            if (symbol.declarations) {
                for (const decl of symbol.declarations)if (decl.kind === 167 /* TypeParameter */ ) {
                    const parent2 = isJSDocTemplateTag(decl.parent) ? getJSDocHost(decl.parent) : decl.parent;
                    if (parent2 === container) return !(isJSDocTemplateTag(decl.parent) && find(decl.parent.parent.tags, isJSDocTypeAlias));
                }
            }
            return false;
        }
        function checkAndReportErrorForMissingPrefix(errorLocation, name, nameArg) {
            if (!isIdentifier(errorLocation) || errorLocation.escapedText !== name || isTypeReferenceIdentifier(errorLocation) || isInTypeQuery(errorLocation)) return false;
            const container = getThisContainer(errorLocation, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            let location = container;
            while(location){
                if (isClassLike(location.parent)) {
                    const classSymbol = getSymbolOfDeclaration(location.parent);
                    if (!classSymbol) break;
                    const constructorType = getTypeOfSymbol(classSymbol);
                    if (getPropertyOfType(constructorType, name)) {
                        error(errorLocation, Diagnostics.Cannot_find_name_0_Did_you_mean_the_static_member_1_0, diagnosticName(nameArg), symbolToString(classSymbol));
                        return true;
                    }
                    if (location === container && !isStatic(location)) {
                        const instanceType = getDeclaredTypeOfSymbol(classSymbol).thisType;
                        if (getPropertyOfType(instanceType, name)) {
                            error(errorLocation, Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0, diagnosticName(nameArg));
                            return true;
                        }
                    }
                }
                location = location.parent;
            }
            return false;
        }
        function checkAndReportErrorForExtendingInterface(errorLocation) {
            const expression = getEntityNameForExtendingInterface(errorLocation);
            if (expression && resolveEntityName(expression, 64 /* Interface */ , /*ignoreErrors*/ true)) {
                error(errorLocation, Diagnostics.Cannot_extend_an_interface_0_Did_you_mean_implements, getTextOfNode(expression));
                return true;
            }
            return false;
        }
        function getEntityNameForExtendingInterface(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                case 210 /* PropertyAccessExpression */ :
                    return node.parent ? getEntityNameForExtendingInterface(node.parent) : void 0;
                case 232 /* ExpressionWithTypeArguments */ :
                    if (isEntityNameExpression(node.expression)) return node.expression;
                default:
                    return void 0;
            }
        }
        function checkAndReportErrorForUsingTypeAsNamespace(errorLocation, name, meaning) {
            const namespaceMeaning = 1920 /* Namespace */  | (isInJSFile(errorLocation) ? 111551 /* Value */  : 0);
            if (meaning === namespaceMeaning) {
                const symbol = resolveSymbol(resolveName(errorLocation, name, 788968 /* Type */  & ~namespaceMeaning, /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false));
                const parent2 = errorLocation.parent;
                if (symbol) {
                    if (isQualifiedName(parent2)) {
                        Debug.assert(parent2.left === errorLocation, "Should only be resolving left side of qualified name as a namespace");
                        const propName = parent2.right.escapedText;
                        const propType = getPropertyOfType(getDeclaredTypeOfSymbol(symbol), propName);
                        if (propType) {
                            error(parent2, Diagnostics.Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1, unescapeLeadingUnderscores(name), unescapeLeadingUnderscores(propName));
                            return true;
                        }
                    }
                    error(errorLocation, Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here, unescapeLeadingUnderscores(name));
                    return true;
                }
            }
            return false;
        }
        function checkAndReportErrorForUsingValueAsType(errorLocation, name, meaning) {
            if (meaning & 788584 /* Namespace */ ) {
                const symbol = resolveSymbol(resolveName(errorLocation, name, 111127 /* Value */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false));
                if (symbol && !(symbol.flags & 1920 /* Namespace */ )) {
                    error(errorLocation, Diagnostics._0_refers_to_a_value_but_is_being_used_as_a_type_here_Did_you_mean_typeof_0, unescapeLeadingUnderscores(name));
                    return true;
                }
            }
            return false;
        }
        function isPrimitiveTypeName(name) {
            return name === "any" || name === "string" || name === "number" || name === "boolean" || name === "never" || name === "unknown";
        }
        function checkAndReportErrorForExportingPrimitiveType(errorLocation, name) {
            if (isPrimitiveTypeName(name) && errorLocation.parent.kind === 280 /* ExportSpecifier */ ) {
                error(errorLocation, Diagnostics.Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module, name);
                return true;
            }
            return false;
        }
        function checkAndReportErrorForUsingTypeAsValue(errorLocation, name, meaning) {
            if (meaning & 111551 /* Value */ ) {
                if (isPrimitiveTypeName(name)) {
                    if (isExtendedByInterface(errorLocation)) error(errorLocation, Diagnostics.An_interface_cannot_extend_a_primitive_type_like_0_an_interface_can_only_extend_named_types_and_classes, unescapeLeadingUnderscores(name));
                    else error(errorLocation, Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here, unescapeLeadingUnderscores(name));
                    return true;
                }
                const symbol = resolveSymbol(resolveName(errorLocation, name, 788544 /* Value */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false));
                const allFlags = symbol && getAllSymbolFlags(symbol);
                if (symbol && allFlags !== void 0 && !(allFlags & 111551 /* Value */ )) {
                    const rawName = unescapeLeadingUnderscores(name);
                    if (isES2015OrLaterConstructorName(name)) error(errorLocation, Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_es2015_or_later, rawName);
                    else if (maybeMappedType(errorLocation, symbol)) error(errorLocation, Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Did_you_mean_to_use_1_in_0, rawName, rawName === "K" ? "P" : "K");
                    else error(errorLocation, Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here, rawName);
                    return true;
                }
            }
            return false;
        }
        function isExtendedByInterface(node) {
            const grandparent = node.parent.parent;
            const parentOfGrandparent = grandparent.parent;
            if (grandparent && parentOfGrandparent) {
                const isExtending = isHeritageClause(grandparent) && grandparent.token === 96 /* ExtendsKeyword */ ;
                const isInterface = isInterfaceDeclaration(parentOfGrandparent);
                return isExtending && isInterface;
            }
            return false;
        }
        function maybeMappedType(node, symbol) {
            const container = findAncestor(node.parent, (n)=>isComputedPropertyName(n) || isPropertySignature(n) ? false : isTypeLiteralNode(n) || "quit");
            if (container && container.members.length === 1) {
                const type = getDeclaredTypeOfSymbol(symbol);
                return !!(type.flags & 1048576 /* Union */ ) && allTypesAssignableToKind(type, 384 /* StringOrNumberLiteral */ , /*strict*/ true);
            }
            return false;
        }
        function isES2015OrLaterConstructorName(n) {
            switch(n){
                case "Promise":
                case "Symbol":
                case "Map":
                case "WeakMap":
                case "Set":
                case "WeakSet":
                    return true;
            }
            return false;
        }
        function checkAndReportErrorForUsingNamespaceAsTypeOrValue(errorLocation, name, meaning) {
            if (meaning & 111127 /* Type */ ) {
                const symbol = resolveSymbol(resolveName(errorLocation, name, 1024 /* NamespaceModule */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false));
                if (symbol) {
                    error(errorLocation, Diagnostics.Cannot_use_namespace_0_as_a_value, unescapeLeadingUnderscores(name));
                    return true;
                }
            } else if (meaning & 788544 /* Value */ ) {
                const symbol = resolveSymbol(resolveName(errorLocation, name, 1536 /* Module */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false));
                if (symbol) {
                    error(errorLocation, Diagnostics.Cannot_use_namespace_0_as_a_type, unescapeLeadingUnderscores(name));
                    return true;
                }
            }
            return false;
        }
        function checkResolvedBlockScopedVariable(result, errorLocation) {
            var _a;
            Debug.assert(!!(result.flags & 2 /* BlockScopedVariable */  || result.flags & 32 /* Class */  || result.flags & 384 /* Enum */ ));
            if (result.flags & 67108881 /* Assignment */  && result.flags & 32 /* Class */ ) return;
            const declaration = (_a = result.declarations) == null ? void 0 : _a.find((d)=>isBlockOrCatchScoped(d) || isClassLike(d) || d.kind === 265 /* EnumDeclaration */ );
            if (declaration === void 0) return Debug.fail("checkResolvedBlockScopedVariable could not find block-scoped declaration");
            if (!(declaration.flags & 16777216 /* Ambient */ ) && !isBlockScopedNameDeclaredBeforeUse(declaration, errorLocation)) {
                let diagnosticMessage;
                const declarationName = declarationNameToString(getNameOfDeclaration(declaration));
                if (result.flags & 2 /* BlockScopedVariable */ ) diagnosticMessage = error(errorLocation, Diagnostics.Block_scoped_variable_0_used_before_its_declaration, declarationName);
                else if (result.flags & 32 /* Class */ ) diagnosticMessage = error(errorLocation, Diagnostics.Class_0_used_before_its_declaration, declarationName);
                else if (result.flags & 256 /* RegularEnum */ ) diagnosticMessage = error(errorLocation, Diagnostics.Enum_0_used_before_its_declaration, declarationName);
                if (diagnosticMessage) addRelatedInfo(diagnosticMessage, createDiagnosticForNode(declaration, Diagnostics._0_is_declared_here, declarationName));
            }
        }
        function isSameScopeDescendentOf(initial, parent2, stopAt) {
            return !!parent2 && !!findAncestor(initial, (n)=>n === parent2 || (n === stopAt || isFunctionLike(n) && (!getImmediatelyInvokedFunctionExpression(n) || isAsyncFunction(n)) ? "quit" : false));
        }
        function getAnyImportSyntax(node) {
            switch(node.kind){
                case 270 /* ImportEqualsDeclaration */ :
                    return node;
                case 272 /* ImportClause */ :
                    return node.parent;
                case 273 /* NamespaceImport */ :
                    return node.parent.parent;
                case 275 /* ImportSpecifier */ :
                    return node.parent.parent.parent;
                default:
                    return void 0;
            }
        }
        function getDeclarationOfAliasSymbol(symbol) {
            return symbol.declarations && findLast(symbol.declarations, isAliasSymbolDeclaration2);
        }
        function isAliasSymbolDeclaration2(node) {
            return node.kind === 270 /* ImportEqualsDeclaration */  || node.kind === 269 /* NamespaceExportDeclaration */  || node.kind === 272 /* ImportClause */  && !!node.name || node.kind === 273 /* NamespaceImport */  || node.kind === 279 /* NamespaceExport */  || node.kind === 275 /* ImportSpecifier */  || node.kind === 280 /* ExportSpecifier */  || node.kind === 276 /* ExportAssignment */  && exportAssignmentIsAlias(node) || isBinaryExpression(node) && getAssignmentDeclarationKind(node) === 2 /* ModuleExports */  && exportAssignmentIsAlias(node) || isAccessExpression(node) && isBinaryExpression(node.parent) && node.parent.left === node && node.parent.operatorToken.kind === 64 /* EqualsToken */  && isAliasableOrJsExpression(node.parent.right) || node.kind === 303 /* ShorthandPropertyAssignment */  || node.kind === 302 /* PropertyAssignment */  && isAliasableOrJsExpression(node.initializer) || node.kind === 259 /* VariableDeclaration */  && isVariableDeclarationInitializedToBareOrAccessedRequire(node) || node.kind === 207 /* BindingElement */  && isVariableDeclarationInitializedToBareOrAccessedRequire(node.parent.parent);
        }
        function isAliasableOrJsExpression(e) {
            return isAliasableExpression(e) || isFunctionExpression(e) && isJSConstructor(e);
        }
        function getTargetOfImportEqualsDeclaration(node, dontResolveAlias) {
            const commonJSPropertyAccess = getCommonJSPropertyAccess(node);
            if (commonJSPropertyAccess) {
                const name = getLeftmostAccessExpression(commonJSPropertyAccess.expression).arguments[0];
                return isIdentifier(commonJSPropertyAccess.name) ? resolveSymbol(getPropertyOfType(resolveExternalModuleTypeByLiteral(name), commonJSPropertyAccess.name.escapedText)) : void 0;
            }
            if (isVariableDeclaration(node) || node.moduleReference.kind === 282 /* ExternalModuleReference */ ) {
                const immediate = resolveExternalModuleName(node, getExternalModuleRequireArgument(node) || getExternalModuleImportEqualsDeclarationExpression(node));
                const resolved2 = resolveExternalModuleSymbol(immediate);
                markSymbolOfAliasDeclarationIfTypeOnly(node, immediate, resolved2, /*overwriteEmpty*/ false);
                return resolved2;
            }
            const resolved = getSymbolOfPartOfRightHandSideOfImportEquals(node.moduleReference, dontResolveAlias);
            checkAndReportErrorForResolvingImportAliasToTypeOnlySymbol(node, resolved);
            return resolved;
        }
        function checkAndReportErrorForResolvingImportAliasToTypeOnlySymbol(node, resolved) {
            if (markSymbolOfAliasDeclarationIfTypeOnly(node, /*immediateTarget*/ void 0, resolved, /*overwriteEmpty*/ false) && !node.isTypeOnly) {
                const typeOnlyDeclaration = getTypeOnlyAliasDeclaration(getSymbolOfDeclaration(node));
                const isExport = typeOnlyDeclaration.kind === 280 /* ExportSpecifier */  || typeOnlyDeclaration.kind === 277 /* ExportDeclaration */ ;
                const message = isExport ? Diagnostics.An_import_alias_cannot_reference_a_declaration_that_was_exported_using_export_type : Diagnostics.An_import_alias_cannot_reference_a_declaration_that_was_imported_using_import_type;
                const relatedMessage = isExport ? Diagnostics._0_was_exported_here : Diagnostics._0_was_imported_here;
                const name = typeOnlyDeclaration.kind === 277 /* ExportDeclaration */  ? "*" : unescapeLeadingUnderscores(typeOnlyDeclaration.name.escapedText);
                addRelatedInfo(error(node.moduleReference, message), createDiagnosticForNode(typeOnlyDeclaration, relatedMessage, name));
            }
        }
        function resolveExportByName(moduleSymbol, name, sourceNode, dontResolveAlias) {
            const exportValue = moduleSymbol.exports.get("export=" /* ExportEquals */ );
            const exportSymbol = exportValue ? getPropertyOfType(getTypeOfSymbol(exportValue), name, /*skipObjectFunctionPropertyAugment*/ true) : moduleSymbol.exports.get(name);
            const resolved = resolveSymbol(exportSymbol, dontResolveAlias);
            markSymbolOfAliasDeclarationIfTypeOnly(sourceNode, exportSymbol, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function isSyntacticDefault(node) {
            return isExportAssignment(node) && !node.isExportEquals || hasSyntacticModifier(node, 1024 /* Default */ ) || isExportSpecifier(node);
        }
        function getUsageModeForExpression(usage) {
            return isStringLiteralLike(usage) ? getModeForUsageLocation(getSourceFileOfNode(usage), usage) : void 0;
        }
        function isESMFormatImportImportingCommonjsFormatFile(usageMode, targetMode) {
            return usageMode === 99 /* ESNext */  && targetMode === 1 /* CommonJS */ ;
        }
        function isOnlyImportedAsDefault(usage) {
            const usageMode = getUsageModeForExpression(usage);
            return usageMode === 99 /* ESNext */  && endsWith(usage.text, ".json" /* Json */ );
        }
        function canHaveSyntheticDefault(file, moduleSymbol, dontResolveAlias, usage) {
            const usageMode = file && getUsageModeForExpression(usage);
            if (file && usageMode !== void 0) {
                const result = isESMFormatImportImportingCommonjsFormatFile(usageMode, file.impliedNodeFormat);
                if (usageMode === 99 /* ESNext */  || result) return result;
            }
            if (!allowSyntheticDefaultImports) return false;
            if (!file || file.isDeclarationFile) {
                const defaultExportSymbol = resolveExportByName(moduleSymbol, "default" /* Default */ , /*sourceNode*/ void 0, /*dontResolveAlias*/ true);
                if (defaultExportSymbol && some(defaultExportSymbol.declarations, isSyntacticDefault)) return false;
                if (resolveExportByName(moduleSymbol, escapeLeadingUnderscores("__esModule"), /*sourceNode*/ void 0, dontResolveAlias)) return false;
                return true;
            }
            if (!isSourceFileJS(file)) return hasExportAssignmentSymbol(moduleSymbol);
            return typeof file.externalModuleIndicator !== "object" && !resolveExportByName(moduleSymbol, escapeLeadingUnderscores("__esModule"), /*sourceNode*/ void 0, dontResolveAlias);
        }
        function getTargetOfImportClause(node, dontResolveAlias) {
            const moduleSymbol = resolveExternalModuleName(node, node.parent.moduleSpecifier);
            if (moduleSymbol) return getTargetofModuleDefault(moduleSymbol, node, dontResolveAlias);
        }
        function getTargetofModuleDefault(moduleSymbol, node, dontResolveAlias) {
            var _a;
            let exportDefaultSymbol;
            if (isShorthandAmbientModuleSymbol(moduleSymbol)) exportDefaultSymbol = moduleSymbol;
            else exportDefaultSymbol = resolveExportByName(moduleSymbol, "default" /* Default */ , node, dontResolveAlias);
            const file = (_a = moduleSymbol.declarations) == null ? void 0 : _a.find(isSourceFile);
            const specifier = getModuleSpecifierForImportOrExport(node);
            if (!specifier) return exportDefaultSymbol;
            const hasDefaultOnly = isOnlyImportedAsDefault(specifier);
            const hasSyntheticDefault = canHaveSyntheticDefault(file, moduleSymbol, dontResolveAlias, specifier);
            if (!exportDefaultSymbol && !hasSyntheticDefault && !hasDefaultOnly) {
                if (hasExportAssignmentSymbol(moduleSymbol) && !allowSyntheticDefaultImports) {
                    const compilerOptionName = moduleKind >= 5 /* ES2015 */  ? "allowSyntheticDefaultImports" : "esModuleInterop";
                    const exportEqualsSymbol = moduleSymbol.exports.get("export=" /* ExportEquals */ );
                    const exportAssignment = exportEqualsSymbol.valueDeclaration;
                    const err = error(node.name, Diagnostics.Module_0_can_only_be_default_imported_using_the_1_flag, symbolToString(moduleSymbol), compilerOptionName);
                    if (exportAssignment) addRelatedInfo(err, createDiagnosticForNode(exportAssignment, Diagnostics.This_module_is_declared_with_export_and_can_only_be_used_with_a_default_import_when_using_the_0_flag, compilerOptionName));
                } else if (isImportClause(node)) reportNonDefaultExport(moduleSymbol, node);
                else errorNoModuleMemberSymbol(moduleSymbol, moduleSymbol, node, isImportOrExportSpecifier(node) && node.propertyName || node.name);
            } else if (hasSyntheticDefault || hasDefaultOnly) {
                const resolved = resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) || resolveSymbol(moduleSymbol, dontResolveAlias);
                markSymbolOfAliasDeclarationIfTypeOnly(node, moduleSymbol, resolved, /*overwriteEmpty*/ false);
                return resolved;
            }
            markSymbolOfAliasDeclarationIfTypeOnly(node, exportDefaultSymbol, /*finalTarget*/ void 0, /*overwriteEmpty*/ false);
            return exportDefaultSymbol;
        }
        function getModuleSpecifierForImportOrExport(node) {
            switch(node.kind){
                case 272 /* ImportClause */ :
                    return node.parent.moduleSpecifier;
                case 270 /* ImportEqualsDeclaration */ :
                    return isExternalModuleReference(node.moduleReference) ? node.moduleReference.expression : void 0;
                case 273 /* NamespaceImport */ :
                    return node.parent.parent.moduleSpecifier;
                case 275 /* ImportSpecifier */ :
                    return node.parent.parent.parent.moduleSpecifier;
                case 280 /* ExportSpecifier */ :
                    return node.parent.parent.moduleSpecifier;
                default:
                    return Debug.assertNever(node);
            }
        }
        function reportNonDefaultExport(moduleSymbol, node) {
            var _a, _b, _c;
            if ((_a = moduleSymbol.exports) == null ? void 0 : _a.has(node.symbol.escapedName)) error(node.name, Diagnostics.Module_0_has_no_default_export_Did_you_mean_to_use_import_1_from_0_instead, symbolToString(moduleSymbol), symbolToString(node.symbol));
            else {
                const diagnostic = error(node.name, Diagnostics.Module_0_has_no_default_export, symbolToString(moduleSymbol));
                const exportStar = (_b = moduleSymbol.exports) == null ? void 0 : _b.get("__export" /* ExportStar */ );
                if (exportStar) {
                    const defaultExport = (_c = exportStar.declarations) == null ? void 0 : _c.find((decl)=>{
                        var _a2, _b2;
                        return !!(isExportDeclaration(decl) && decl.moduleSpecifier && ((_b2 = (_a2 = resolveExternalModuleName(decl, decl.moduleSpecifier)) == null ? void 0 : _a2.exports) == null ? void 0 : _b2.has("default" /* Default */ )));
                    });
                    if (defaultExport) addRelatedInfo(diagnostic, createDiagnosticForNode(defaultExport, Diagnostics.export_Asterisk_does_not_re_export_a_default));
                }
            }
        }
        function getTargetOfNamespaceImport(node, dontResolveAlias) {
            const moduleSpecifier = node.parent.parent.moduleSpecifier;
            const immediate = resolveExternalModuleName(node, moduleSpecifier);
            const resolved = resolveESModuleSymbol(immediate, moduleSpecifier, dontResolveAlias, /*suppressInteropError*/ false);
            markSymbolOfAliasDeclarationIfTypeOnly(node, immediate, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function getTargetOfNamespaceExport(node, dontResolveAlias) {
            const moduleSpecifier = node.parent.moduleSpecifier;
            const immediate = moduleSpecifier && resolveExternalModuleName(node, moduleSpecifier);
            const resolved = moduleSpecifier && resolveESModuleSymbol(immediate, moduleSpecifier, dontResolveAlias, /*suppressInteropError*/ false);
            markSymbolOfAliasDeclarationIfTypeOnly(node, immediate, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function combineValueAndTypeSymbols(valueSymbol, typeSymbol) {
            if (valueSymbol === unknownSymbol && typeSymbol === unknownSymbol) return unknownSymbol;
            if (valueSymbol.flags & 790504 /* Namespace */ ) return valueSymbol;
            const result = createSymbol(valueSymbol.flags | typeSymbol.flags, valueSymbol.escapedName);
            Debug.assert(valueSymbol.declarations || typeSymbol.declarations);
            result.declarations = deduplicate(concatenate(valueSymbol.declarations, typeSymbol.declarations), equateValues);
            result.parent = valueSymbol.parent || typeSymbol.parent;
            if (valueSymbol.valueDeclaration) result.valueDeclaration = valueSymbol.valueDeclaration;
            if (typeSymbol.members) result.members = new Map(typeSymbol.members);
            if (valueSymbol.exports) result.exports = new Map(valueSymbol.exports);
            return result;
        }
        function getExportOfModule(symbol, name, specifier, dontResolveAlias) {
            var _a;
            if (symbol.flags & 1536 /* Module */ ) {
                const exportSymbol = getExportsOfSymbol(symbol).get(name.escapedText);
                const resolved = resolveSymbol(exportSymbol, dontResolveAlias);
                const exportStarDeclaration = (_a = getSymbolLinks(symbol).typeOnlyExportStarMap) == null ? void 0 : _a.get(name.escapedText);
                markSymbolOfAliasDeclarationIfTypeOnly(specifier, exportSymbol, resolved, /*overwriteEmpty*/ false, exportStarDeclaration, name.escapedText);
                return resolved;
            }
        }
        function getPropertyOfVariable(symbol, name) {
            if (symbol.flags & 3 /* Variable */ ) {
                const typeAnnotation = symbol.valueDeclaration.type;
                if (typeAnnotation) return resolveSymbol(getPropertyOfType(getTypeFromTypeNode(typeAnnotation), name));
            }
        }
        function getExternalModuleMember(node, specifier, dontResolveAlias = false) {
            var _a;
            const moduleSpecifier = getExternalModuleRequireArgument(node) || node.moduleSpecifier;
            const moduleSymbol = resolveExternalModuleName(node, moduleSpecifier);
            const name = !isPropertyAccessExpression(specifier) && specifier.propertyName || specifier.name;
            if (!isIdentifier(name)) return void 0;
            const suppressInteropError = name.escapedText === "default" /* Default */  && allowSyntheticDefaultImports;
            const targetSymbol = resolveESModuleSymbol(moduleSymbol, moduleSpecifier, /*dontResolveAlias*/ false, suppressInteropError);
            if (targetSymbol) {
                if (name.escapedText) {
                    if (isShorthandAmbientModuleSymbol(moduleSymbol)) return moduleSymbol;
                    let symbolFromVariable;
                    if (moduleSymbol && moduleSymbol.exports && moduleSymbol.exports.get("export=" /* ExportEquals */ )) symbolFromVariable = getPropertyOfType(getTypeOfSymbol(targetSymbol), name.escapedText, /*skipObjectFunctionPropertyAugment*/ true);
                    else symbolFromVariable = getPropertyOfVariable(targetSymbol, name.escapedText);
                    symbolFromVariable = resolveSymbol(symbolFromVariable, dontResolveAlias);
                    let symbolFromModule = getExportOfModule(targetSymbol, name, specifier, dontResolveAlias);
                    if (symbolFromModule === void 0 && name.escapedText === "default" /* Default */ ) {
                        const file = (_a = moduleSymbol.declarations) == null ? void 0 : _a.find(isSourceFile);
                        if (isOnlyImportedAsDefault(moduleSpecifier) || canHaveSyntheticDefault(file, moduleSymbol, dontResolveAlias, moduleSpecifier)) symbolFromModule = resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) || resolveSymbol(moduleSymbol, dontResolveAlias);
                    }
                    const symbol = symbolFromModule && symbolFromVariable && symbolFromModule !== symbolFromVariable ? combineValueAndTypeSymbols(symbolFromVariable, symbolFromModule) : symbolFromModule || symbolFromVariable;
                    if (!symbol) errorNoModuleMemberSymbol(moduleSymbol, targetSymbol, node, name);
                    return symbol;
                }
            }
        }
        function errorNoModuleMemberSymbol(moduleSymbol, targetSymbol, node, name) {
            var _a;
            const moduleName = getFullyQualifiedName(moduleSymbol, node);
            const declarationName = declarationNameToString(name);
            const suggestion = getSuggestedSymbolForNonexistentModule(name, targetSymbol);
            if (suggestion !== void 0) {
                const suggestionName = symbolToString(suggestion);
                const diagnostic = error(name, Diagnostics._0_has_no_exported_member_named_1_Did_you_mean_2, moduleName, declarationName, suggestionName);
                if (suggestion.valueDeclaration) addRelatedInfo(diagnostic, createDiagnosticForNode(suggestion.valueDeclaration, Diagnostics._0_is_declared_here, suggestionName));
            } else if ((_a = moduleSymbol.exports) == null ? void 0 : _a.has("default" /* Default */ )) error(name, Diagnostics.Module_0_has_no_exported_member_1_Did_you_mean_to_use_import_1_from_0_instead, moduleName, declarationName);
            else reportNonExportedMember(node, name, declarationName, moduleSymbol, moduleName);
        }
        function reportNonExportedMember(node, name, declarationName, moduleSymbol, moduleName) {
            var _a, _b;
            const localSymbol = (_b = (_a = tryCast(moduleSymbol.valueDeclaration, canHaveLocals)) == null ? void 0 : _a.locals) == null ? void 0 : _b.get(name.escapedText);
            const exports = moduleSymbol.exports;
            if (localSymbol) {
                const exportedEqualsSymbol = exports == null ? void 0 : exports.get("export=" /* ExportEquals */ );
                if (exportedEqualsSymbol) getSymbolIfSameReference(exportedEqualsSymbol, localSymbol) ? reportInvalidImportEqualsExportMember(node, name, declarationName, moduleName) : error(name, Diagnostics.Module_0_has_no_exported_member_1, moduleName, declarationName);
                else {
                    const exportedSymbol = exports ? find(symbolsToArray(exports), (symbol)=>!!getSymbolIfSameReference(symbol, localSymbol)) : void 0;
                    const diagnostic = exportedSymbol ? error(name, Diagnostics.Module_0_declares_1_locally_but_it_is_exported_as_2, moduleName, declarationName, symbolToString(exportedSymbol)) : error(name, Diagnostics.Module_0_declares_1_locally_but_it_is_not_exported, moduleName, declarationName);
                    if (localSymbol.declarations) addRelatedInfo(diagnostic, ...map(localSymbol.declarations, (decl, index)=>createDiagnosticForNode(decl, index === 0 ? Diagnostics._0_is_declared_here : Diagnostics.and_here, declarationName)));
                }
            } else error(name, Diagnostics.Module_0_has_no_exported_member_1, moduleName, declarationName);
        }
        function reportInvalidImportEqualsExportMember(node, name, declarationName, moduleName) {
            if (moduleKind >= 5 /* ES2015 */ ) {
                const message = getESModuleInterop(compilerOptions) ? Diagnostics._0_can_only_be_imported_by_using_a_default_import : Diagnostics._0_can_only_be_imported_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import;
                error(name, message, declarationName);
            } else if (isInJSFile(node)) {
                const message = getESModuleInterop(compilerOptions) ? Diagnostics._0_can_only_be_imported_by_using_a_require_call_or_by_using_a_default_import : Diagnostics._0_can_only_be_imported_by_using_a_require_call_or_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import;
                error(name, message, declarationName);
            } else {
                const message = getESModuleInterop(compilerOptions) ? Diagnostics._0_can_only_be_imported_by_using_import_1_require_2_or_a_default_import : Diagnostics._0_can_only_be_imported_by_using_import_1_require_2_or_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import;
                error(name, message, declarationName, declarationName, moduleName);
            }
        }
        function getTargetOfImportSpecifier(node, dontResolveAlias) {
            if (isImportSpecifier(node) && idText(node.propertyName || node.name) === "default" /* Default */ ) {
                const specifier = getModuleSpecifierForImportOrExport(node);
                const moduleSymbol = specifier && resolveExternalModuleName(node, specifier);
                if (moduleSymbol) return getTargetofModuleDefault(moduleSymbol, node, dontResolveAlias);
            }
            const root = isBindingElement(node) ? getRootDeclaration(node) : node.parent.parent.parent;
            const commonJSPropertyAccess = getCommonJSPropertyAccess(root);
            const resolved = getExternalModuleMember(root, commonJSPropertyAccess || node, dontResolveAlias);
            const name = node.propertyName || node.name;
            if (commonJSPropertyAccess && resolved && isIdentifier(name)) return resolveSymbol(getPropertyOfType(getTypeOfSymbol(resolved), name.escapedText), dontResolveAlias);
            markSymbolOfAliasDeclarationIfTypeOnly(node, /*immediateTarget*/ void 0, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function getCommonJSPropertyAccess(node) {
            if (isVariableDeclaration(node) && node.initializer && isPropertyAccessExpression(node.initializer)) return node.initializer;
        }
        function getTargetOfNamespaceExportDeclaration(node, dontResolveAlias) {
            if (canHaveSymbol(node.parent)) {
                const resolved = resolveExternalModuleSymbol(node.parent.symbol, dontResolveAlias);
                markSymbolOfAliasDeclarationIfTypeOnly(node, /*immediateTarget*/ void 0, resolved, /*overwriteEmpty*/ false);
                return resolved;
            }
        }
        function getTargetOfExportSpecifier(node, meaning, dontResolveAlias) {
            if (idText(node.propertyName || node.name) === "default" /* Default */ ) {
                const specifier = getModuleSpecifierForImportOrExport(node);
                const moduleSymbol = specifier && resolveExternalModuleName(node, specifier);
                if (moduleSymbol) return getTargetofModuleDefault(moduleSymbol, node, !!dontResolveAlias);
            }
            const resolved = node.parent.parent.moduleSpecifier ? getExternalModuleMember(node.parent.parent, node, dontResolveAlias) : resolveEntityName(node.propertyName || node.name, meaning, /*ignoreErrors*/ false, dontResolveAlias);
            markSymbolOfAliasDeclarationIfTypeOnly(node, /*immediateTarget*/ void 0, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function getTargetOfExportAssignment(node, dontResolveAlias) {
            const expression = isExportAssignment(node) ? node.expression : node.right;
            const resolved = getTargetOfAliasLikeExpression(expression, dontResolveAlias);
            markSymbolOfAliasDeclarationIfTypeOnly(node, /*immediateTarget*/ void 0, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function getTargetOfAliasLikeExpression(expression, dontResolveAlias) {
            if (isClassExpression(expression)) return checkExpressionCached(expression).symbol;
            if (!isEntityName(expression) && !isEntityNameExpression(expression)) return void 0;
            const aliasLike = resolveEntityName(expression, 901119 /* Namespace */ , /*ignoreErrors*/ true, dontResolveAlias);
            if (aliasLike) return aliasLike;
            checkExpressionCached(expression);
            return getNodeLinks(expression).resolvedSymbol;
        }
        function getTargetOfAccessExpression(node, dontRecursivelyResolve) {
            if (!(isBinaryExpression(node.parent) && node.parent.left === node && node.parent.operatorToken.kind === 64 /* EqualsToken */ )) return void 0;
            return getTargetOfAliasLikeExpression(node.parent.right, dontRecursivelyResolve);
        }
        function getTargetOfAliasDeclaration(node, dontRecursivelyResolve = false) {
            switch(node.kind){
                case 270 /* ImportEqualsDeclaration */ :
                case 259 /* VariableDeclaration */ :
                    return getTargetOfImportEqualsDeclaration(node, dontRecursivelyResolve);
                case 272 /* ImportClause */ :
                    return getTargetOfImportClause(node, dontRecursivelyResolve);
                case 273 /* NamespaceImport */ :
                    return getTargetOfNamespaceImport(node, dontRecursivelyResolve);
                case 279 /* NamespaceExport */ :
                    return getTargetOfNamespaceExport(node, dontRecursivelyResolve);
                case 275 /* ImportSpecifier */ :
                case 207 /* BindingElement */ :
                    return getTargetOfImportSpecifier(node, dontRecursivelyResolve);
                case 280 /* ExportSpecifier */ :
                    return getTargetOfExportSpecifier(node, 901119 /* Namespace */ , dontRecursivelyResolve);
                case 276 /* ExportAssignment */ :
                case 225 /* BinaryExpression */ :
                    return getTargetOfExportAssignment(node, dontRecursivelyResolve);
                case 269 /* NamespaceExportDeclaration */ :
                    return getTargetOfNamespaceExportDeclaration(node, dontRecursivelyResolve);
                case 303 /* ShorthandPropertyAssignment */ :
                    return resolveEntityName(node.name, 901119 /* Namespace */ , /*ignoreErrors*/ true, dontRecursivelyResolve);
                case 302 /* PropertyAssignment */ :
                    return getTargetOfAliasLikeExpression(node.initializer, dontRecursivelyResolve);
                case 211 /* ElementAccessExpression */ :
                case 210 /* PropertyAccessExpression */ :
                    return getTargetOfAccessExpression(node, dontRecursivelyResolve);
                default:
                    return Debug.fail();
            }
        }
        function isNonLocalAlias(symbol, excludes = 901119 /* Namespace */ ) {
            if (!symbol) return false;
            return (symbol.flags & (2097152 /* Alias */  | excludes)) === 2097152 /* Alias */  || !!(symbol.flags & 2097152 /* Alias */  && symbol.flags & 67108864 /* Assignment */ );
        }
        function resolveSymbol(symbol, dontResolveAlias) {
            return !dontResolveAlias && isNonLocalAlias(symbol) ? resolveAlias(symbol) : symbol;
        }
        function resolveAlias(symbol) {
            Debug.assert((symbol.flags & 2097152 /* Alias */ ) !== 0, "Should only get Alias here.");
            const links = getSymbolLinks(symbol);
            if (!links.aliasTarget) {
                links.aliasTarget = resolvingSymbol;
                const node = getDeclarationOfAliasSymbol(symbol);
                if (!node) return Debug.fail();
                const target = getTargetOfAliasDeclaration(node);
                if (links.aliasTarget === resolvingSymbol) links.aliasTarget = target || unknownSymbol;
                else error(node, Diagnostics.Circular_definition_of_import_alias_0, symbolToString(symbol));
            } else if (links.aliasTarget === resolvingSymbol) links.aliasTarget = unknownSymbol;
            return links.aliasTarget;
        }
        function tryResolveAlias(symbol) {
            const links = getSymbolLinks(symbol);
            if (links.aliasTarget !== resolvingSymbol) return resolveAlias(symbol);
            return void 0;
        }
        function getAllSymbolFlags(symbol) {
            let flags = symbol.flags;
            let seenSymbols;
            while(symbol.flags & 2097152 /* Alias */ ){
                const target = resolveAlias(symbol);
                if (target === unknownSymbol) return 67108863 /* All */ ;
                if (target === symbol || (seenSymbols == null ? void 0 : seenSymbols.has(target))) break;
                if (target.flags & 2097152 /* Alias */ ) {
                    if (seenSymbols) seenSymbols.add(target);
                    else seenSymbols = /* @__PURE__ */ new Set([
                        symbol,
                        target
                    ]);
                }
                flags |= target.flags;
                symbol = target;
            }
            return flags;
        }
        function markSymbolOfAliasDeclarationIfTypeOnly(aliasDeclaration, immediateTarget, finalTarget, overwriteEmpty, exportStarDeclaration, exportStarName) {
            if (!aliasDeclaration || isPropertyAccessExpression(aliasDeclaration)) return false;
            const sourceSymbol = getSymbolOfDeclaration(aliasDeclaration);
            if (isTypeOnlyImportOrExportDeclaration(aliasDeclaration)) {
                const links2 = getSymbolLinks(sourceSymbol);
                links2.typeOnlyDeclaration = aliasDeclaration;
                return true;
            }
            if (exportStarDeclaration) {
                const links2 = getSymbolLinks(sourceSymbol);
                links2.typeOnlyDeclaration = exportStarDeclaration;
                if (sourceSymbol.escapedName !== exportStarName) links2.typeOnlyExportStarName = exportStarName;
                return true;
            }
            const links = getSymbolLinks(sourceSymbol);
            return markSymbolOfAliasDeclarationIfTypeOnlyWorker(links, immediateTarget, overwriteEmpty) || markSymbolOfAliasDeclarationIfTypeOnlyWorker(links, finalTarget, overwriteEmpty);
        }
        function markSymbolOfAliasDeclarationIfTypeOnlyWorker(aliasDeclarationLinks, target, overwriteEmpty) {
            var _a;
            if (target && (aliasDeclarationLinks.typeOnlyDeclaration === void 0 || overwriteEmpty && aliasDeclarationLinks.typeOnlyDeclaration === false)) {
                const exportSymbol = ((_a = target.exports) == null ? void 0 : _a.get("export=" /* ExportEquals */ )) ?? target;
                const typeOnly = exportSymbol.declarations && find(exportSymbol.declarations, isTypeOnlyImportOrExportDeclaration);
                aliasDeclarationLinks.typeOnlyDeclaration = typeOnly ?? getSymbolLinks(exportSymbol).typeOnlyDeclaration ?? false;
            }
            return !!aliasDeclarationLinks.typeOnlyDeclaration;
        }
        function getTypeOnlyAliasDeclaration(symbol, include) {
            if (!(symbol.flags & 2097152 /* Alias */ )) return void 0;
            const links = getSymbolLinks(symbol);
            if (include === void 0) return links.typeOnlyDeclaration || void 0;
            if (links.typeOnlyDeclaration) {
                const resolved = links.typeOnlyDeclaration.kind === 277 /* ExportDeclaration */  ? resolveSymbol(getExportsOfModule(links.typeOnlyDeclaration.symbol.parent).get(links.typeOnlyExportStarName || symbol.escapedName)) : resolveAlias(links.typeOnlyDeclaration.symbol);
                return getAllSymbolFlags(resolved) & include ? links.typeOnlyDeclaration : void 0;
            }
            return void 0;
        }
        function markExportAsReferenced(node) {
            if (!canCollectSymbolAliasAccessabilityData) return;
            const symbol = getSymbolOfDeclaration(node);
            const target = resolveAlias(symbol);
            if (target) {
                const markAlias = target === unknownSymbol || getAllSymbolFlags(target) & 111551 /* Value */  && !isConstEnumOrConstEnumOnlyModule(target) && !getTypeOnlyAliasDeclaration(symbol, 111551 /* Value */ );
                if (markAlias) markAliasSymbolAsReferenced(symbol);
            }
        }
        function markAliasSymbolAsReferenced(symbol) {
            Debug.assert(canCollectSymbolAliasAccessabilityData);
            const links = getSymbolLinks(symbol);
            if (!links.referenced) {
                links.referenced = true;
                const node = getDeclarationOfAliasSymbol(symbol);
                if (!node) return Debug.fail();
                if (isInternalModuleImportEqualsDeclaration(node)) {
                    if (getAllSymbolFlags(resolveSymbol(symbol)) & 111551 /* Value */ ) checkExpressionCached(node.moduleReference);
                }
            }
        }
        function markConstEnumAliasAsReferenced(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.constEnumReferenced) links.constEnumReferenced = true;
        }
        function getSymbolOfPartOfRightHandSideOfImportEquals(entityName, dontResolveAlias) {
            if (entityName.kind === 80 /* Identifier */  && isRightSideOfQualifiedNameOrPropertyAccess(entityName)) entityName = entityName.parent;
            if (entityName.kind === 80 /* Identifier */  || entityName.parent.kind === 165 /* QualifiedName */ ) return resolveEntityName(entityName, 1920 /* Namespace */ , /*ignoreErrors*/ false, dontResolveAlias);
            else {
                Debug.assert(entityName.parent.kind === 270 /* ImportEqualsDeclaration */ );
                return resolveEntityName(entityName, 901119 /* Namespace */ , /*ignoreErrors*/ false, dontResolveAlias);
            }
        }
        function getFullyQualifiedName(symbol, containingLocation) {
            return symbol.parent ? getFullyQualifiedName(symbol.parent, containingLocation) + "." + symbolToString(symbol) : symbolToString(symbol, containingLocation, /*meaning*/ void 0, 36 /* AllowAnyNodeKind */ );
        }
        function getContainingQualifiedNameNode(node) {
            while(isQualifiedName(node.parent))node = node.parent;
            return node;
        }
        function tryGetQualifiedNameAsValue(node) {
            let left = getFirstIdentifier(node);
            let symbol = resolveName(left, left.escapedText, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, left, /*isUse*/ true);
            if (!symbol) return void 0;
            while(isQualifiedName(left.parent)){
                const type = getTypeOfSymbol(symbol);
                symbol = getPropertyOfType(type, left.parent.right.escapedText);
                if (!symbol) return void 0;
                left = left.parent;
            }
            return symbol;
        }
        function resolveEntityName(name, meaning, ignoreErrors, dontResolveAlias, location) {
            if (nodeIsMissing(name)) return void 0;
            const namespaceMeaning = 1920 /* Namespace */  | (isInJSFile(name) ? meaning & 111551 /* Value */  : 0);
            let symbol;
            if (name.kind === 80 /* Identifier */ ) {
                const message = meaning === namespaceMeaning || nodeIsSynthesized(name) ? Diagnostics.Cannot_find_namespace_0 : getCannotFindNameDiagnosticForName(getFirstIdentifier(name));
                const symbolFromJSPrototype = isInJSFile(name) && !nodeIsSynthesized(name) ? resolveEntityNameFromAssignmentDeclaration(name, meaning) : void 0;
                symbol = getMergedSymbol(resolveName(location || name, name.escapedText, meaning, ignoreErrors || symbolFromJSPrototype ? void 0 : message, name, /*isUse*/ true, /*excludeGlobals*/ false));
                if (!symbol) return getMergedSymbol(symbolFromJSPrototype);
            } else if (name.kind === 165 /* QualifiedName */  || name.kind === 210 /* PropertyAccessExpression */ ) {
                const left = name.kind === 165 /* QualifiedName */  ? name.left : name.expression;
                const right = name.kind === 165 /* QualifiedName */  ? name.right : name.name;
                let namespace = resolveEntityName(left, namespaceMeaning, ignoreErrors, /*dontResolveAlias*/ false, location);
                if (!namespace || nodeIsMissing(right)) return void 0;
                else if (namespace === unknownSymbol) return namespace;
                if (namespace.valueDeclaration && isInJSFile(namespace.valueDeclaration) && getEmitModuleResolutionKind(compilerOptions) !== 100 /* Bundler */  && isVariableDeclaration(namespace.valueDeclaration) && namespace.valueDeclaration.initializer && isCommonJsRequire(namespace.valueDeclaration.initializer)) {
                    const moduleName = namespace.valueDeclaration.initializer.arguments[0];
                    const moduleSym = resolveExternalModuleName(moduleName, moduleName);
                    if (moduleSym) {
                        const resolvedModuleSymbol = resolveExternalModuleSymbol(moduleSym);
                        if (resolvedModuleSymbol) namespace = resolvedModuleSymbol;
                    }
                }
                symbol = getMergedSymbol(getSymbol2(getExportsOfSymbol(namespace), right.escapedText, meaning));
                if (!symbol && namespace.flags & 2097152 /* Alias */ ) symbol = getMergedSymbol(getSymbol2(getExportsOfSymbol(resolveAlias(namespace)), right.escapedText, meaning));
                if (!symbol) {
                    if (!ignoreErrors) {
                        const namespaceName = getFullyQualifiedName(namespace);
                        const declarationName = declarationNameToString(right);
                        const suggestionForNonexistentModule = getSuggestedSymbolForNonexistentModule(right, namespace);
                        if (suggestionForNonexistentModule) {
                            error(right, Diagnostics._0_has_no_exported_member_named_1_Did_you_mean_2, namespaceName, declarationName, symbolToString(suggestionForNonexistentModule));
                            return void 0;
                        }
                        const containingQualifiedName = isQualifiedName(name) && getContainingQualifiedNameNode(name);
                        const canSuggestTypeof = globalObjectType && meaning & 788968 /* Type */  && containingQualifiedName && !isTypeOfExpression(containingQualifiedName.parent) && tryGetQualifiedNameAsValue(containingQualifiedName);
                        if (canSuggestTypeof) {
                            error(containingQualifiedName, Diagnostics._0_refers_to_a_value_but_is_being_used_as_a_type_here_Did_you_mean_typeof_0, entityNameToString(containingQualifiedName));
                            return void 0;
                        }
                        if (meaning & 1920 /* Namespace */  && isQualifiedName(name.parent)) {
                            const exportedTypeSymbol = getMergedSymbol(getSymbol2(getExportsOfSymbol(namespace), right.escapedText, 788968 /* Type */ ));
                            if (exportedTypeSymbol) {
                                error(name.parent.right, Diagnostics.Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1, symbolToString(exportedTypeSymbol), unescapeLeadingUnderscores(name.parent.right.escapedText));
                                return void 0;
                            }
                        }
                        error(right, Diagnostics.Namespace_0_has_no_exported_member_1, namespaceName, declarationName);
                    }
                    return void 0;
                }
            } else Debug.assertNever(name, "Unknown entity name kind.");
            Debug.assert((getCheckFlags(symbol) & 1 /* Instantiated */ ) === 0, "Should never get an instantiated symbol here.");
            if (!nodeIsSynthesized(name) && isEntityName(name) && (symbol.flags & 2097152 /* Alias */  || name.parent.kind === 276 /* ExportAssignment */ )) markSymbolOfAliasDeclarationIfTypeOnly(getAliasDeclarationFromName(name), symbol, /*finalTarget*/ void 0, /*overwriteEmpty*/ true);
            return symbol.flags & meaning || dontResolveAlias ? symbol : resolveAlias(symbol);
        }
        function resolveEntityNameFromAssignmentDeclaration(name, meaning) {
            if (isJSDocTypeReference(name.parent)) {
                const secondaryLocation = getAssignmentDeclarationLocation(name.parent);
                if (secondaryLocation) return resolveName(secondaryLocation, name.escapedText, meaning, /*nameNotFoundMessage*/ void 0, name, /*isUse*/ true);
            }
        }
        function getAssignmentDeclarationLocation(node) {
            const typeAlias = findAncestor(node, (node2)=>!(isJSDocNode(node2) || node2.flags & 8388608 /* JSDoc */ ) ? "quit" : isJSDocTypeAlias(node2));
            if (typeAlias) return;
            const host2 = getJSDocHost(node);
            if (host2 && isExpressionStatement(host2) && isPrototypePropertyAssignment(host2.expression)) {
                const symbol = getSymbolOfDeclaration(host2.expression.left);
                if (symbol) return getDeclarationOfJSPrototypeContainer(symbol);
            }
            if (host2 && isFunctionExpression(host2) && isPrototypePropertyAssignment(host2.parent) && isExpressionStatement(host2.parent.parent)) {
                const symbol = getSymbolOfDeclaration(host2.parent.left);
                if (symbol) return getDeclarationOfJSPrototypeContainer(symbol);
            }
            if (host2 && (isObjectLiteralMethod(host2) || isPropertyAssignment(host2)) && isBinaryExpression(host2.parent.parent) && getAssignmentDeclarationKind(host2.parent.parent) === 6 /* Prototype */ ) {
                const symbol = getSymbolOfDeclaration(host2.parent.parent.left);
                if (symbol) return getDeclarationOfJSPrototypeContainer(symbol);
            }
            const sig = getEffectiveJSDocHost(node);
            if (sig && isFunctionLike(sig)) {
                const symbol = getSymbolOfDeclaration(sig);
                return symbol && symbol.valueDeclaration;
            }
        }
        function getDeclarationOfJSPrototypeContainer(symbol) {
            const decl = symbol.parent.valueDeclaration;
            if (!decl) return void 0;
            const initializer = isAssignmentDeclaration(decl) ? getAssignedExpandoInitializer(decl) : hasOnlyExpressionInitializer(decl) ? getDeclaredExpandoInitializer(decl) : void 0;
            return initializer || decl;
        }
        function getExpandoSymbol(symbol) {
            const decl = symbol.valueDeclaration;
            if (!decl || !isInJSFile(decl) || symbol.flags & 524288 /* TypeAlias */  || getExpandoInitializer(decl, /*isPrototypeAssignment*/ false)) return void 0;
            const init = isVariableDeclaration(decl) ? getDeclaredExpandoInitializer(decl) : getAssignedExpandoInitializer(decl);
            if (init) {
                const initSymbol = getSymbolOfNode(init);
                if (initSymbol) return mergeJSSymbols(initSymbol, symbol);
            }
        }
        function resolveExternalModuleName(location, moduleReferenceExpression, ignoreErrors) {
            const isClassic = getEmitModuleResolutionKind(compilerOptions) === 1 /* Classic */ ;
            const errorMessage = isClassic ? Diagnostics.Cannot_find_module_0_Did_you_mean_to_set_the_moduleResolution_option_to_nodenext_or_to_add_aliases_to_the_paths_option : Diagnostics.Cannot_find_module_0_or_its_corresponding_type_declarations;
            return resolveExternalModuleNameWorker(location, moduleReferenceExpression, ignoreErrors ? void 0 : errorMessage);
        }
        function resolveExternalModuleNameWorker(location, moduleReferenceExpression, moduleNotFoundError, isForAugmentation = false) {
            return isStringLiteralLike(moduleReferenceExpression) ? resolveExternalModule(location, moduleReferenceExpression.text, moduleNotFoundError, moduleReferenceExpression, isForAugmentation) : void 0;
        }
        function resolveExternalModule(location, moduleReference, moduleNotFoundError, errorNode, isForAugmentation = false) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _i;
            if (startsWith(moduleReference, "@types/")) {
                const diag2 = Diagnostics.Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1;
                const withoutAtTypePrefix = removePrefix(moduleReference, "@types/");
                error(errorNode, diag2, withoutAtTypePrefix, moduleReference);
            }
            const ambientModule = tryFindAmbientModule(moduleReference, /*withAugmentations*/ true);
            if (ambientModule) return ambientModule;
            const currentSourceFile = getSourceFileOfNode(location);
            const contextSpecifier = isStringLiteralLike(location) ? location : ((_a = findAncestor(location, isImportCall)) == null ? void 0 : _a.arguments[0]) || ((_b = findAncestor(location, isImportDeclaration)) == null ? void 0 : _b.moduleSpecifier) || ((_c = findAncestor(location, isExternalModuleImportEqualsDeclaration)) == null ? void 0 : _c.moduleReference.expression) || ((_d = findAncestor(location, isExportDeclaration)) == null ? void 0 : _d.moduleSpecifier) || ((_e = isModuleDeclaration(location) ? location : location.parent && isModuleDeclaration(location.parent) && location.parent.name === location ? location.parent : void 0) == null ? void 0 : _e.name) || ((_f = isLiteralImportTypeNode(location) ? location : void 0) == null ? void 0 : _f.argument.literal);
            const mode = contextSpecifier && isStringLiteralLike(contextSpecifier) ? getModeForUsageLocation(currentSourceFile, contextSpecifier) : currentSourceFile.impliedNodeFormat;
            const moduleResolutionKind = getEmitModuleResolutionKind(compilerOptions);
            const resolvedModule = getResolvedModule(currentSourceFile, moduleReference, mode);
            const resolutionDiagnostic = resolvedModule && getResolutionDiagnostic(compilerOptions, resolvedModule, currentSourceFile);
            const sourceFile = resolvedModule && (!resolutionDiagnostic || resolutionDiagnostic === Diagnostics.Module_0_was_resolved_to_1_but_jsx_is_not_set) && host.getSourceFile(resolvedModule.resolvedFileName);
            if (sourceFile) {
                if (resolutionDiagnostic) error(errorNode, resolutionDiagnostic, moduleReference, resolvedModule.resolvedFileName);
                if (resolvedModule.resolvedUsingTsExtension && isDeclarationFileName(moduleReference)) {
                    const importOrExport = ((_g = findAncestor(location, isImportDeclaration)) == null ? void 0 : _g.importClause) || findAncestor(location, or(isImportEqualsDeclaration, isExportDeclaration));
                    if (importOrExport && !importOrExport.isTypeOnly || findAncestor(location, isImportCall)) error(errorNode, Diagnostics.A_declaration_file_cannot_be_imported_without_import_type_Did_you_mean_to_import_an_implementation_file_0_instead, getSuggestedImportSource(Debug.checkDefined(tryExtractTSExtension(moduleReference))));
                } else if (resolvedModule.resolvedUsingTsExtension && !shouldAllowImportingTsExtension(compilerOptions, currentSourceFile.fileName)) {
                    const tsExtension = Debug.checkDefined(tryExtractTSExtension(moduleReference));
                    error(errorNode, Diagnostics.An_import_path_can_only_end_with_a_0_extension_when_allowImportingTsExtensions_is_enabled, tsExtension);
                }
                if (sourceFile.symbol) {
                    if (resolvedModule.isExternalLibraryImport && !resolutionExtensionIsTSOrJson(resolvedModule.extension)) errorOnImplicitAnyModule(/*isError*/ false, errorNode, currentSourceFile, mode, resolvedModule, moduleReference);
                    if (moduleResolutionKind === 3 /* Node16 */  || moduleResolutionKind === 99 /* NodeNext */ ) {
                        const isSyncImport = currentSourceFile.impliedNodeFormat === 1 /* CommonJS */  && !findAncestor(location, isImportCall) || !!findAncestor(location, isImportEqualsDeclaration);
                        const overrideClauseHost = findAncestor(location, (l)=>isImportTypeNode(l) || isExportDeclaration(l) || isImportDeclaration(l));
                        const overrideClause = overrideClauseHost && isImportTypeNode(overrideClauseHost) ? (_h = overrideClauseHost.assertions) == null ? void 0 : _h.assertClause : overrideClauseHost == null ? void 0 : overrideClauseHost.assertClause;
                        if (isSyncImport && sourceFile.impliedNodeFormat === 99 /* ESNext */  && !getResolutionModeOverrideForClause(overrideClause)) {
                            if (findAncestor(location, isImportEqualsDeclaration)) error(errorNode, Diagnostics.Module_0_cannot_be_imported_using_this_construct_The_specifier_only_resolves_to_an_ES_module_which_cannot_be_imported_with_require_Use_an_ECMAScript_import_instead, moduleReference);
                            else {
                                let diagnosticDetails;
                                const ext = tryGetExtensionFromPath2(currentSourceFile.fileName);
                                if (ext === ".ts" /* Ts */  || ext === ".js" /* Js */  || ext === ".tsx" /* Tsx */  || ext === ".jsx" /* Jsx */ ) {
                                    const scope = currentSourceFile.packageJsonScope;
                                    const targetExt = ext === ".ts" /* Ts */  ? ".mts" /* Mts */  : ext === ".js" /* Js */  ? ".mjs" /* Mjs */  : void 0;
                                    if (scope && !scope.contents.packageJsonContent.type) {
                                        if (targetExt) diagnosticDetails = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_add_the_field_type_Colon_module_to_1, targetExt, combinePaths(scope.packageDirectory, "package.json"));
                                        else diagnosticDetails = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.To_convert_this_file_to_an_ECMAScript_module_add_the_field_type_Colon_module_to_0, combinePaths(scope.packageDirectory, "package.json"));
                                    } else if (targetExt) diagnosticDetails = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_create_a_local_package_json_file_with_type_Colon_module, targetExt);
                                    else diagnosticDetails = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.To_convert_this_file_to_an_ECMAScript_module_create_a_local_package_json_file_with_type_Colon_module);
                                }
                                diagnostics.add(createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(errorNode), errorNode, chainDiagnosticMessages(diagnosticDetails, Diagnostics.The_current_file_is_a_CommonJS_module_whose_imports_will_produce_require_calls_however_the_referenced_file_is_an_ECMAScript_module_and_cannot_be_imported_with_require_Consider_writing_a_dynamic_import_0_call_instead, moduleReference)));
                            }
                        }
                    }
                    return getMergedSymbol(sourceFile.symbol);
                }
                if (moduleNotFoundError) error(errorNode, Diagnostics.File_0_is_not_a_module, sourceFile.fileName);
                return void 0;
            }
            if (patternAmbientModules) {
                const pattern = findBestPatternMatch(patternAmbientModules, (_)=>_.pattern, moduleReference);
                if (pattern) {
                    const augmentation = patternAmbientModuleAugmentations && patternAmbientModuleAugmentations.get(moduleReference);
                    if (augmentation) return getMergedSymbol(augmentation);
                    return getMergedSymbol(pattern.symbol);
                }
            }
            if (resolvedModule && !resolutionExtensionIsTSOrJson(resolvedModule.extension) && resolutionDiagnostic === void 0 || resolutionDiagnostic === Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type) {
                if (isForAugmentation) {
                    const diag2 = Diagnostics.Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augmented;
                    error(errorNode, diag2, moduleReference, resolvedModule.resolvedFileName);
                } else errorOnImplicitAnyModule(/*isError*/ noImplicitAny && !!moduleNotFoundError, errorNode, currentSourceFile, mode, resolvedModule, moduleReference);
                return void 0;
            }
            if (moduleNotFoundError) {
                if (resolvedModule) {
                    const redirect = host.getProjectReferenceRedirect(resolvedModule.resolvedFileName);
                    if (redirect) {
                        error(errorNode, Diagnostics.Output_file_0_has_not_been_built_from_source_file_1, redirect, resolvedModule.resolvedFileName);
                        return void 0;
                    }
                }
                if (resolutionDiagnostic) error(errorNode, resolutionDiagnostic, moduleReference, resolvedModule.resolvedFileName);
                else {
                    const isExtensionlessRelativePathImport = pathIsRelative(moduleReference) && !hasExtension(moduleReference);
                    const resolutionIsNode16OrNext = moduleResolutionKind === 3 /* Node16 */  || moduleResolutionKind === 99 /* NodeNext */ ;
                    if (!getResolveJsonModule(compilerOptions) && fileExtensionIs(moduleReference, ".json" /* Json */ ) && moduleResolutionKind !== 1 /* Classic */  && hasJsonModuleEmitEnabled(compilerOptions)) error(errorNode, Diagnostics.Cannot_find_module_0_Consider_using_resolveJsonModule_to_import_module_with_json_extension, moduleReference);
                    else if (mode === 99 /* ESNext */  && resolutionIsNode16OrNext && isExtensionlessRelativePathImport) {
                        const absoluteRef = getNormalizedAbsolutePath(moduleReference, getDirectoryPath(currentSourceFile.path));
                        const suggestedExt = (_i = suggestedExtensions.find(([actualExt, _importExt])=>host.fileExists(absoluteRef + actualExt))) == null ? void 0 : _i[1];
                        if (suggestedExt) error(errorNode, Diagnostics.Relative_import_paths_need_explicit_file_extensions_in_EcmaScript_imports_when_moduleResolution_is_node16_or_nodenext_Did_you_mean_0, moduleReference + suggestedExt);
                        else error(errorNode, Diagnostics.Relative_import_paths_need_explicit_file_extensions_in_EcmaScript_imports_when_moduleResolution_is_node16_or_nodenext_Consider_adding_an_extension_to_the_import_path);
                    } else error(errorNode, moduleNotFoundError, moduleReference);
                }
            }
            return void 0;
            function getSuggestedImportSource(tsExtension) {
                const importSourceWithoutExtension = removeExtension(moduleReference, tsExtension);
                if (emitModuleKindIsNonNodeESM(moduleKind) || mode === 99 /* ESNext */ ) {
                    const preferTs = isDeclarationFileName(moduleReference) && shouldAllowImportingTsExtension(compilerOptions);
                    const ext = tsExtension === ".mts" /* Mts */  || tsExtension === ".d.mts" /* Dmts */  ? preferTs ? ".mts" : ".mjs" : tsExtension === ".cts" /* Cts */  || tsExtension === ".d.mts" /* Dmts */  ? preferTs ? ".cts" : ".cjs" : preferTs ? ".ts" : ".js";
                    return importSourceWithoutExtension + ext;
                }
                return importSourceWithoutExtension;
            }
        }
        function errorOnImplicitAnyModule(isError, errorNode, sourceFile, mode, { packageId: packageId , resolvedFileName: resolvedFileName  }, moduleReference) {
            let errorInfo;
            if (!isExternalModuleNameRelative(moduleReference) && packageId) errorInfo = createModuleNotFoundChain(sourceFile, host, moduleReference, mode, packageId.name);
            errorOrSuggestion(isError, errorNode, chainDiagnosticMessages(errorInfo, Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type, moduleReference, resolvedFileName));
        }
        function resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) {
            if (moduleSymbol == null ? void 0 : moduleSymbol.exports) {
                const exportEquals = resolveSymbol(moduleSymbol.exports.get("export=" /* ExportEquals */ ), dontResolveAlias);
                const exported = getCommonJsExportEquals(getMergedSymbol(exportEquals), getMergedSymbol(moduleSymbol));
                return getMergedSymbol(exported) || moduleSymbol;
            }
            return void 0;
        }
        function getCommonJsExportEquals(exported, moduleSymbol) {
            if (!exported || exported === unknownSymbol || exported === moduleSymbol || moduleSymbol.exports.size === 1 || exported.flags & 2097152 /* Alias */ ) return exported;
            const links = getSymbolLinks(exported);
            if (links.cjsExportMerged) return links.cjsExportMerged;
            const merged = exported.flags & 33554432 /* Transient */  ? exported : cloneSymbol(exported);
            merged.flags = merged.flags | 512 /* ValueModule */ ;
            if (merged.exports === void 0) merged.exports = createSymbolTable();
            moduleSymbol.exports.forEach((s, name)=>{
                if (name === "export=" /* ExportEquals */ ) return;
                merged.exports.set(name, merged.exports.has(name) ? mergeSymbol(merged.exports.get(name), s) : s);
            });
            if (merged === exported) {
                getSymbolLinks(merged).resolvedExports = void 0;
                getSymbolLinks(merged).resolvedMembers = void 0;
            }
            getSymbolLinks(merged).cjsExportMerged = merged;
            return links.cjsExportMerged = merged;
        }
        function resolveESModuleSymbol(moduleSymbol, referencingLocation, dontResolveAlias, suppressInteropError) {
            var _a;
            const symbol = resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias);
            if (!dontResolveAlias && symbol) {
                if (!suppressInteropError && !(symbol.flags & 1539 /* Variable */ ) && !getDeclarationOfKind(symbol, 311 /* SourceFile */ )) {
                    const compilerOptionName = moduleKind >= 5 /* ES2015 */  ? "allowSyntheticDefaultImports" : "esModuleInterop";
                    error(referencingLocation, Diagnostics.This_module_can_only_be_referenced_with_ECMAScript_imports_Slashexports_by_turning_on_the_0_flag_and_referencing_its_default_export, compilerOptionName);
                    return symbol;
                }
                const referenceParent = referencingLocation.parent;
                if (isImportDeclaration(referenceParent) && getNamespaceDeclarationNode(referenceParent) || isImportCall(referenceParent)) {
                    const reference = isImportCall(referenceParent) ? referenceParent.arguments[0] : referenceParent.moduleSpecifier;
                    const type = getTypeOfSymbol(symbol);
                    const defaultOnlyType = getTypeWithSyntheticDefaultOnly(type, symbol, moduleSymbol, reference);
                    if (defaultOnlyType) return cloneTypeAsModuleType(symbol, defaultOnlyType, referenceParent);
                    const targetFile = (_a = moduleSymbol == null ? void 0 : moduleSymbol.declarations) == null ? void 0 : _a.find(isSourceFile);
                    const isEsmCjsRef = targetFile && isESMFormatImportImportingCommonjsFormatFile(getUsageModeForExpression(reference), targetFile.impliedNodeFormat);
                    if (getESModuleInterop(compilerOptions) || isEsmCjsRef) {
                        let sigs = getSignaturesOfStructuredType(type, 0 /* Call */ );
                        if (!sigs || !sigs.length) sigs = getSignaturesOfStructuredType(type, 1 /* Construct */ );
                        if (sigs && sigs.length || getPropertyOfType(type, "default" /* Default */ , /*skipObjectFunctionPropertyAugment*/ true) || isEsmCjsRef) {
                            const moduleType = type.flags & 3670016 /* StructuredType */  ? getTypeWithSyntheticDefaultImportType(type, symbol, moduleSymbol, reference) : createDefaultPropertyWrapperForModule(symbol, symbol.parent);
                            return cloneTypeAsModuleType(symbol, moduleType, referenceParent);
                        }
                    }
                }
            }
            return symbol;
        }
        function cloneTypeAsModuleType(symbol, moduleType, referenceParent) {
            const result = createSymbol(symbol.flags, symbol.escapedName);
            result.declarations = symbol.declarations ? symbol.declarations.slice() : [];
            result.parent = symbol.parent;
            result.links.target = symbol;
            result.links.originatingImport = referenceParent;
            if (symbol.valueDeclaration) result.valueDeclaration = symbol.valueDeclaration;
            if (symbol.constEnumOnlyModule) result.constEnumOnlyModule = true;
            if (symbol.members) result.members = new Map(symbol.members);
            if (symbol.exports) result.exports = new Map(symbol.exports);
            const resolvedModuleType = resolveStructuredTypeMembers(moduleType);
            result.links.type = createAnonymousType(result, resolvedModuleType.members, emptyArray, emptyArray, resolvedModuleType.indexInfos);
            return result;
        }
        function hasExportAssignmentSymbol(moduleSymbol) {
            return moduleSymbol.exports.get("export=" /* ExportEquals */ ) !== void 0;
        }
        function getExportsOfModuleAsArray(moduleSymbol) {
            return symbolsToArray(getExportsOfModule(moduleSymbol));
        }
        function getExportsAndPropertiesOfModule(moduleSymbol) {
            const exports = getExportsOfModuleAsArray(moduleSymbol);
            const exportEquals = resolveExternalModuleSymbol(moduleSymbol);
            if (exportEquals !== moduleSymbol) {
                const type = getTypeOfSymbol(exportEquals);
                if (shouldTreatPropertiesOfExternalModuleAsExports(type)) addRange(exports, getPropertiesOfType(type));
            }
            return exports;
        }
        function forEachExportAndPropertyOfModule(moduleSymbol, cb) {
            const exports = getExportsOfModule(moduleSymbol);
            exports.forEach((symbol, key)=>{
                if (!isReservedMemberName(key)) cb(symbol, key);
            });
            const exportEquals = resolveExternalModuleSymbol(moduleSymbol);
            if (exportEquals !== moduleSymbol) {
                const type = getTypeOfSymbol(exportEquals);
                if (shouldTreatPropertiesOfExternalModuleAsExports(type)) forEachPropertyOfType(type, (symbol, escapedName)=>{
                    cb(symbol, escapedName);
                });
            }
        }
        function tryGetMemberInModuleExports(memberName, moduleSymbol) {
            const symbolTable = getExportsOfModule(moduleSymbol);
            if (symbolTable) return symbolTable.get(memberName);
        }
        function tryGetMemberInModuleExportsAndProperties(memberName, moduleSymbol) {
            const symbol = tryGetMemberInModuleExports(memberName, moduleSymbol);
            if (symbol) return symbol;
            const exportEquals = resolveExternalModuleSymbol(moduleSymbol);
            if (exportEquals === moduleSymbol) return void 0;
            const type = getTypeOfSymbol(exportEquals);
            return shouldTreatPropertiesOfExternalModuleAsExports(type) ? getPropertyOfType(type, memberName) : void 0;
        }
        function shouldTreatPropertiesOfExternalModuleAsExports(resolvedExternalModuleType) {
            return !(resolvedExternalModuleType.flags & 402784252 /* Primitive */  || getObjectFlags(resolvedExternalModuleType) & 1 /* Class */  || // `isArrayOrTupleLikeType` is too expensive to use in this auto-imports hot path
            isArrayType(resolvedExternalModuleType) || isTupleType(resolvedExternalModuleType));
        }
        function getExportsOfSymbol(symbol) {
            return symbol.flags & 6256 /* LateBindingContainer */  ? getResolvedMembersOrExportsOfSymbol(symbol, "resolvedExports" /* resolvedExports */ ) : symbol.flags & 1536 /* Module */  ? getExportsOfModule(symbol) : symbol.exports || emptySymbols;
        }
        function getExportsOfModule(moduleSymbol) {
            const links = getSymbolLinks(moduleSymbol);
            if (!links.resolvedExports) {
                const { exports: exports , typeOnlyExportStarMap: typeOnlyExportStarMap  } = getExportsOfModuleWorker(moduleSymbol);
                links.resolvedExports = exports;
                links.typeOnlyExportStarMap = typeOnlyExportStarMap;
            }
            return links.resolvedExports;
        }
        function extendExportSymbols(target, source, lookupTable, exportNode) {
            if (!source) return;
            source.forEach((sourceSymbol, id)=>{
                if (id === "default" /* Default */ ) return;
                const targetSymbol = target.get(id);
                if (!targetSymbol) {
                    target.set(id, sourceSymbol);
                    if (lookupTable && exportNode) lookupTable.set(id, {
                        specifierText: getTextOfNode(exportNode.moduleSpecifier)
                    });
                } else if (lookupTable && exportNode && targetSymbol && resolveSymbol(targetSymbol) !== resolveSymbol(sourceSymbol)) {
                    const collisionTracker = lookupTable.get(id);
                    if (!collisionTracker.exportsWithDuplicate) collisionTracker.exportsWithDuplicate = [
                        exportNode
                    ];
                    else collisionTracker.exportsWithDuplicate.push(exportNode);
                }
            });
        }
        function getExportsOfModuleWorker(moduleSymbol) {
            const visitedSymbols = [];
            let typeOnlyExportStarMap;
            const nonTypeOnlyNames = /* @__PURE__ */ new Set();
            moduleSymbol = resolveExternalModuleSymbol(moduleSymbol);
            const exports = visit(moduleSymbol) || emptySymbols;
            if (typeOnlyExportStarMap) nonTypeOnlyNames.forEach((name)=>typeOnlyExportStarMap.delete(name));
            return {
                exports: exports,
                typeOnlyExportStarMap: typeOnlyExportStarMap
            };
            function visit(symbol, exportStar, isTypeOnly) {
                if (!isTypeOnly && (symbol == null ? void 0 : symbol.exports)) symbol.exports.forEach((_, name)=>nonTypeOnlyNames.add(name));
                if (!(symbol && symbol.exports && pushIfUnique(visitedSymbols, symbol))) return;
                const symbols = new Map(symbol.exports);
                const exportStars = symbol.exports.get("__export" /* ExportStar */ );
                if (exportStars) {
                    const nestedSymbols = createSymbolTable();
                    const lookupTable = /* @__PURE__ */ new Map();
                    if (exportStars.declarations) for (const node of exportStars.declarations){
                        const resolvedModule = resolveExternalModuleName(node, node.moduleSpecifier);
                        const exportedSymbols = visit(resolvedModule, node, isTypeOnly || node.isTypeOnly);
                        extendExportSymbols(nestedSymbols, exportedSymbols, lookupTable, node);
                    }
                    lookupTable.forEach(({ exportsWithDuplicate: exportsWithDuplicate  }, id)=>{
                        if (id === "export=" || !(exportsWithDuplicate && exportsWithDuplicate.length) || symbols.has(id)) return;
                        for (const node of exportsWithDuplicate)diagnostics.add(createDiagnosticForNode(node, Diagnostics.Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambiguity, lookupTable.get(id).specifierText, unescapeLeadingUnderscores(id)));
                    });
                    extendExportSymbols(symbols, nestedSymbols);
                }
                if (exportStar == null ? void 0 : exportStar.isTypeOnly) {
                    typeOnlyExportStarMap ?? (typeOnlyExportStarMap = /* @__PURE__ */ new Map());
                    symbols.forEach((_, escapedName)=>typeOnlyExportStarMap.set(escapedName, exportStar));
                }
                return symbols;
            }
        }
        function getMergedSymbol(symbol) {
            let merged;
            return symbol && symbol.mergeId && (merged = mergedSymbols[symbol.mergeId]) ? merged : symbol;
        }
        function getSymbolOfDeclaration(node) {
            return getMergedSymbol(node.symbol && getLateBoundSymbol(node.symbol));
        }
        function getSymbolOfNode(node) {
            return canHaveSymbol(node) ? getSymbolOfDeclaration(node) : void 0;
        }
        function getParentOfSymbol(symbol) {
            return getMergedSymbol(symbol.parent && getLateBoundSymbol(symbol.parent));
        }
        function getAlternativeContainingModules(symbol, enclosingDeclaration) {
            const containingFile = getSourceFileOfNode(enclosingDeclaration);
            const id = getNodeId(containingFile);
            const links = getSymbolLinks(symbol);
            let results;
            if (links.extendedContainersByFile && (results = links.extendedContainersByFile.get(id))) return results;
            if (containingFile && containingFile.imports) {
                for (const importRef of containingFile.imports){
                    if (nodeIsSynthesized(importRef)) continue;
                    const resolvedModule = resolveExternalModuleName(enclosingDeclaration, importRef, /*ignoreErrors*/ true);
                    if (!resolvedModule) continue;
                    const ref = getAliasForSymbolInContainer(resolvedModule, symbol);
                    if (!ref) continue;
                    results = append(results, resolvedModule);
                }
                if (length(results)) {
                    (links.extendedContainersByFile || (links.extendedContainersByFile = /* @__PURE__ */ new Map())).set(id, results);
                    return results;
                }
            }
            if (links.extendedContainers) return links.extendedContainers;
            const otherFiles = host.getSourceFiles();
            for (const file of otherFiles){
                if (!isExternalModule(file)) continue;
                const sym = getSymbolOfDeclaration(file);
                const ref = getAliasForSymbolInContainer(sym, symbol);
                if (!ref) continue;
                results = append(results, sym);
            }
            return links.extendedContainers = results || emptyArray;
        }
        function getContainersOfSymbol(symbol, enclosingDeclaration, meaning) {
            const container = getParentOfSymbol(symbol);
            if (container && !(symbol.flags & 262144 /* TypeParameter */ )) {
                const additionalContainers = mapDefined(container.declarations, fileSymbolIfFileSymbolExportEqualsContainer);
                const reexportContainers = enclosingDeclaration && getAlternativeContainingModules(symbol, enclosingDeclaration);
                const objectLiteralContainer = getVariableDeclarationOfObjectLiteral(container, meaning);
                if (enclosingDeclaration && container.flags & getQualifiedLeftMeaning(meaning) && getAccessibleSymbolChain(container, enclosingDeclaration, 1920 /* Namespace */ , /*useOnlyExternalAliasing*/ false)) return append(concatenate(concatenate([
                    container
                ], additionalContainers), reexportContainers), objectLiteralContainer);
                const firstVariableMatch = !(container.flags & getQualifiedLeftMeaning(meaning)) && container.flags & 788968 /* Type */  && getDeclaredTypeOfSymbol(container).flags & 524288 /* Object */  && meaning === 111551 /* Value */  ? forEachSymbolTableInScope(enclosingDeclaration, (t)=>{
                    return forEachEntry(t, (s)=>{
                        if (s.flags & getQualifiedLeftMeaning(meaning) && getTypeOfSymbol(s) === getDeclaredTypeOfSymbol(container)) return s;
                    });
                }) : void 0;
                let res = firstVariableMatch ? [
                    firstVariableMatch,
                    ...additionalContainers,
                    container
                ] : [
                    ...additionalContainers,
                    container
                ];
                res = append(res, objectLiteralContainer);
                res = addRange(res, reexportContainers);
                return res;
            }
            const candidates = mapDefined(symbol.declarations, (d)=>{
                if (!isAmbientModule(d) && d.parent) {
                    if (hasNonGlobalAugmentationExternalModuleSymbol(d.parent)) return getSymbolOfDeclaration(d.parent);
                    if (isModuleBlock(d.parent) && d.parent.parent && resolveExternalModuleSymbol(getSymbolOfDeclaration(d.parent.parent)) === symbol) return getSymbolOfDeclaration(d.parent.parent);
                }
                if (isClassExpression(d) && isBinaryExpression(d.parent) && d.parent.operatorToken.kind === 64 /* EqualsToken */  && isAccessExpression(d.parent.left) && isEntityNameExpression(d.parent.left.expression)) {
                    if (isModuleExportsAccessExpression(d.parent.left) || isExportsIdentifier(d.parent.left.expression)) return getSymbolOfDeclaration(getSourceFileOfNode(d));
                    checkExpressionCached(d.parent.left.expression);
                    return getNodeLinks(d.parent.left.expression).resolvedSymbol;
                }
            });
            if (!length(candidates)) return void 0;
            return mapDefined(candidates, (candidate)=>getAliasForSymbolInContainer(candidate, symbol) ? candidate : void 0);
            function fileSymbolIfFileSymbolExportEqualsContainer(d) {
                return container && getFileSymbolIfFileSymbolExportEqualsContainer(d, container);
            }
        }
        function getVariableDeclarationOfObjectLiteral(symbol, meaning) {
            const firstDecl = !!length(symbol.declarations) && first(symbol.declarations);
            if (meaning & 111551 /* Value */  && firstDecl && firstDecl.parent && isVariableDeclaration(firstDecl.parent)) {
                if (isObjectLiteralExpression(firstDecl) && firstDecl === firstDecl.parent.initializer || isTypeLiteralNode(firstDecl) && firstDecl === firstDecl.parent.type) return getSymbolOfDeclaration(firstDecl.parent);
            }
        }
        function getFileSymbolIfFileSymbolExportEqualsContainer(d, container) {
            const fileSymbol = getExternalModuleContainer(d);
            const exported = fileSymbol && fileSymbol.exports && fileSymbol.exports.get("export=" /* ExportEquals */ );
            return exported && getSymbolIfSameReference(exported, container) ? fileSymbol : void 0;
        }
        function getAliasForSymbolInContainer(container, symbol) {
            if (container === getParentOfSymbol(symbol)) return symbol;
            const exportEquals = container.exports && container.exports.get("export=" /* ExportEquals */ );
            if (exportEquals && getSymbolIfSameReference(exportEquals, symbol)) return container;
            const exports = getExportsOfSymbol(container);
            const quick = exports.get(symbol.escapedName);
            if (quick && getSymbolIfSameReference(quick, symbol)) return quick;
            return forEachEntry(exports, (exported)=>{
                if (getSymbolIfSameReference(exported, symbol)) return exported;
            });
        }
        function getSymbolIfSameReference(s1, s2) {
            if (getMergedSymbol(resolveSymbol(getMergedSymbol(s1))) === getMergedSymbol(resolveSymbol(getMergedSymbol(s2)))) return s1;
        }
        function getExportSymbolOfValueSymbolIfExported(symbol) {
            return getMergedSymbol(symbol && (symbol.flags & 1048576 /* ExportValue */ ) !== 0 && symbol.exportSymbol || symbol);
        }
        function symbolIsValue(symbol, includeTypeOnlyMembers) {
            return !!(symbol.flags & 111551 /* Value */  || symbol.flags & 2097152 /* Alias */  && getAllSymbolFlags(symbol) & 111551 /* Value */  && (includeTypeOnlyMembers || !getTypeOnlyAliasDeclaration(symbol)));
        }
        function findConstructorDeclaration(node) {
            const members = node.members;
            for (const member of members){
                if (member.kind === 175 /* Constructor */  && nodeIsPresent(member.body)) return member;
            }
        }
        function createType(flags) {
            var _a;
            const result = new Type27(checker, flags);
            typeCount++;
            result.id = typeCount;
            (_a = tracing) == null || _a.recordType(result);
            return result;
        }
        function createTypeWithSymbol(flags, symbol) {
            const result = createType(flags);
            result.symbol = symbol;
            return result;
        }
        function createOriginType(flags) {
            return new Type27(checker, flags);
        }
        function createIntrinsicType(kind, intrinsicName, objectFlags = 0 /* None */ ) {
            const type = createType(kind);
            type.intrinsicName = intrinsicName;
            type.objectFlags = objectFlags;
            return type;
        }
        function createObjectType(objectFlags, symbol) {
            const type = createTypeWithSymbol(524288 /* Object */ , symbol);
            type.objectFlags = objectFlags;
            type.members = void 0;
            type.properties = void 0;
            type.callSignatures = void 0;
            type.constructSignatures = void 0;
            type.indexInfos = void 0;
            return type;
        }
        function createTypeofType() {
            return getUnionType(arrayFrom(typeofNEFacts.keys(), getStringLiteralType));
        }
        function createTypeParameter(symbol) {
            return createTypeWithSymbol(262144 /* TypeParameter */ , symbol);
        }
        function isReservedMemberName(name) {
            return name.charCodeAt(0) === 95 /* _ */  && name.charCodeAt(1) === 95 /* _ */  && name.charCodeAt(2) !== 95 /* _ */  && name.charCodeAt(2) !== 64 /* at */  && name.charCodeAt(2) !== 35 /* hash */ ;
        }
        function getNamedMembers(members) {
            let result;
            members.forEach((symbol, id)=>{
                if (isNamedMember(symbol, id)) (result || (result = [])).push(symbol);
            });
            return result || emptyArray;
        }
        function isNamedMember(member, escapedName) {
            return !isReservedMemberName(escapedName) && symbolIsValue(member);
        }
        function getNamedOrIndexSignatureMembers(members) {
            const result = getNamedMembers(members);
            const index = getIndexSymbolFromSymbolTable(members);
            return index ? concatenate(result, [
                index
            ]) : result;
        }
        function setStructuredTypeMembers(type, members, callSignatures, constructSignatures, indexInfos) {
            const resolved = type;
            resolved.members = members;
            resolved.properties = emptyArray;
            resolved.callSignatures = callSignatures;
            resolved.constructSignatures = constructSignatures;
            resolved.indexInfos = indexInfos;
            if (members !== emptySymbols) resolved.properties = getNamedMembers(members);
            return resolved;
        }
        function createAnonymousType(symbol, members, callSignatures, constructSignatures, indexInfos) {
            return setStructuredTypeMembers(createObjectType(16 /* Anonymous */ , symbol), members, callSignatures, constructSignatures, indexInfos);
        }
        function getResolvedTypeWithoutAbstractConstructSignatures(type) {
            if (type.constructSignatures.length === 0) return type;
            if (type.objectTypeWithoutAbstractConstructSignatures) return type.objectTypeWithoutAbstractConstructSignatures;
            const constructSignatures = filter(type.constructSignatures, (signature)=>!(signature.flags & 4 /* Abstract */ ));
            if (type.constructSignatures === constructSignatures) return type;
            const typeCopy = createAnonymousType(type.symbol, type.members, type.callSignatures, some(constructSignatures) ? constructSignatures : emptyArray, type.indexInfos);
            type.objectTypeWithoutAbstractConstructSignatures = typeCopy;
            typeCopy.objectTypeWithoutAbstractConstructSignatures = typeCopy;
            return typeCopy;
        }
        function forEachSymbolTableInScope(enclosingDeclaration, callback) {
            let result;
            for(let location = enclosingDeclaration; location; location = location.parent){
                if (canHaveLocals(location) && location.locals && !isGlobalSourceFile(location)) {
                    if (result = callback(location.locals, /*ignoreQualification*/ void 0, /*isLocalNameLookup*/ true, location)) return result;
                }
                switch(location.kind){
                    case 311 /* SourceFile */ :
                        if (!isExternalOrCommonJsModule(location)) break;
                    case 266 /* ModuleDeclaration */ :
                        const sym = getSymbolOfDeclaration(location);
                        if (result = callback((sym == null ? void 0 : sym.exports) || emptySymbols, /*ignoreQualification*/ void 0, /*isLocalNameLookup*/ true, location)) return result;
                        break;
                    case 262 /* ClassDeclaration */ :
                    case 230 /* ClassExpression */ :
                    case 263 /* InterfaceDeclaration */ :
                        let table;
                        (getSymbolOfDeclaration(location).members || emptySymbols).forEach((memberSymbol, key)=>{
                            if (memberSymbol.flags & 788968 /* Assignment */ ) (table || (table = createSymbolTable())).set(key, memberSymbol);
                        });
                        if (table && (result = callback(table, /*ignoreQualification*/ void 0, /*isLocalNameLookup*/ false, location))) return result;
                        break;
                }
            }
            return callback(globals, /*ignoreQualification*/ void 0, /*isLocalNameLookup*/ true);
        }
        function getQualifiedLeftMeaning(rightMeaning) {
            return rightMeaning === 111551 /* Value */  ? 111551 /* Value */  : 1920 /* Namespace */ ;
        }
        function getAccessibleSymbolChain(symbol, enclosingDeclaration, meaning, useOnlyExternalAliasing, visitedSymbolTablesMap = /* @__PURE__ */ new Map()) {
            if (!(symbol && !isPropertyOrMethodDeclarationSymbol(symbol))) return void 0;
            const links = getSymbolLinks(symbol);
            const cache = links.accessibleChainCache || (links.accessibleChainCache = /* @__PURE__ */ new Map());
            const firstRelevantLocation = forEachSymbolTableInScope(enclosingDeclaration, (_, __, ___, node)=>node);
            const key = `${useOnlyExternalAliasing ? 0 : 1}|${firstRelevantLocation && getNodeId(firstRelevantLocation)}|${meaning}`;
            if (cache.has(key)) return cache.get(key);
            const id = getSymbolId(symbol);
            let visitedSymbolTables = visitedSymbolTablesMap.get(id);
            if (!visitedSymbolTables) visitedSymbolTablesMap.set(id, visitedSymbolTables = []);
            const result = forEachSymbolTableInScope(enclosingDeclaration, getAccessibleSymbolChainFromSymbolTable);
            cache.set(key, result);
            return result;
            function getAccessibleSymbolChainFromSymbolTable(symbols, ignoreQualification, isLocalNameLookup) {
                if (!pushIfUnique(visitedSymbolTables, symbols)) return void 0;
                const result2 = trySymbolTable(symbols, ignoreQualification, isLocalNameLookup);
                visitedSymbolTables.pop();
                return result2;
            }
            function canQualifySymbol(symbolFromSymbolTable, meaning2) {
                return !needsQualification(symbolFromSymbolTable, enclosingDeclaration, meaning2) || // If symbol needs qualification, make sure that parent is accessible, if it is then this symbol is accessible too
                !!getAccessibleSymbolChain(symbolFromSymbolTable.parent, enclosingDeclaration, getQualifiedLeftMeaning(meaning2), useOnlyExternalAliasing, visitedSymbolTablesMap);
            }
            function isAccessible(symbolFromSymbolTable, resolvedAliasSymbol, ignoreQualification) {
                return (symbol === (resolvedAliasSymbol || symbolFromSymbolTable) || getMergedSymbol(symbol) === getMergedSymbol(resolvedAliasSymbol || symbolFromSymbolTable)) && // if the symbolFromSymbolTable is not external module (it could be if it was determined as ambient external module and would be in globals table)
                // and if symbolFromSymbolTable or alias resolution matches the symbol,
                // check the symbol can be qualified, it is only then this symbol is accessible
                !some(symbolFromSymbolTable.declarations, hasNonGlobalAugmentationExternalModuleSymbol) && (ignoreQualification || canQualifySymbol(getMergedSymbol(symbolFromSymbolTable), meaning));
            }
            function trySymbolTable(symbols, ignoreQualification, isLocalNameLookup) {
                if (isAccessible(symbols.get(symbol.escapedName), /*resolvedAliasSymbol*/ void 0, ignoreQualification)) return [
                    symbol
                ];
                const result2 = forEachEntry(symbols, (symbolFromSymbolTable)=>{
                    if (symbolFromSymbolTable.flags & 2097152 /* Alias */  && symbolFromSymbolTable.escapedName !== "export=" /* ExportEquals */  && symbolFromSymbolTable.escapedName !== "default" /* Default */  && !(isUMDExportSymbol(symbolFromSymbolTable) && enclosingDeclaration && isExternalModule(getSourceFileOfNode(enclosingDeclaration))) && (!useOnlyExternalAliasing || some(symbolFromSymbolTable.declarations, isExternalModuleImportEqualsDeclaration)) && (isLocalNameLookup ? !some(symbolFromSymbolTable.declarations, isNamespaceReexportDeclaration) : true) && (ignoreQualification || !getDeclarationOfKind(symbolFromSymbolTable, 280 /* ExportSpecifier */ ))) {
                        const resolvedImportedSymbol = resolveAlias(symbolFromSymbolTable);
                        const candidate = getCandidateListForSymbol(symbolFromSymbolTable, resolvedImportedSymbol, ignoreQualification);
                        if (candidate) return candidate;
                    }
                    if (symbolFromSymbolTable.escapedName === symbol.escapedName && symbolFromSymbolTable.exportSymbol) {
                        if (isAccessible(getMergedSymbol(symbolFromSymbolTable.exportSymbol), /*resolvedAliasSymbol*/ void 0, ignoreQualification)) return [
                            symbol
                        ];
                    }
                });
                return result2 || (symbols === globals ? getCandidateListForSymbol(globalThisSymbol, globalThisSymbol, ignoreQualification) : void 0);
            }
            function getCandidateListForSymbol(symbolFromSymbolTable, resolvedImportedSymbol, ignoreQualification) {
                if (isAccessible(symbolFromSymbolTable, resolvedImportedSymbol, ignoreQualification)) return [
                    symbolFromSymbolTable
                ];
                const candidateTable = getExportsOfSymbol(resolvedImportedSymbol);
                const accessibleSymbolsFromExports = candidateTable && getAccessibleSymbolChainFromSymbolTable(candidateTable, /*ignoreQualification*/ true);
                if (accessibleSymbolsFromExports && canQualifySymbol(symbolFromSymbolTable, getQualifiedLeftMeaning(meaning))) return [
                    symbolFromSymbolTable
                ].concat(accessibleSymbolsFromExports);
            }
        }
        function needsQualification(symbol, enclosingDeclaration, meaning) {
            let qualify = false;
            forEachSymbolTableInScope(enclosingDeclaration, (symbolTable)=>{
                let symbolFromSymbolTable = getMergedSymbol(symbolTable.get(symbol.escapedName));
                if (!symbolFromSymbolTable) return false;
                if (symbolFromSymbolTable === symbol) return true;
                const shouldResolveAlias = symbolFromSymbolTable.flags & 2097152 /* Alias */  && !getDeclarationOfKind(symbolFromSymbolTable, 280 /* ExportSpecifier */ );
                symbolFromSymbolTable = shouldResolveAlias ? resolveAlias(symbolFromSymbolTable) : symbolFromSymbolTable;
                const flags = shouldResolveAlias ? getAllSymbolFlags(symbolFromSymbolTable) : symbolFromSymbolTable.flags;
                if (flags & meaning) {
                    qualify = true;
                    return true;
                }
                return false;
            });
            return qualify;
        }
        function isPropertyOrMethodDeclarationSymbol(symbol) {
            if (symbol.declarations && symbol.declarations.length) {
                for (const declaration of symbol.declarations)switch(declaration.kind){
                    case 171 /* PropertyDeclaration */ :
                    case 173 /* MethodDeclaration */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                        continue;
                    default:
                        return false;
                }
                return true;
            }
            return false;
        }
        function isTypeSymbolAccessible(typeSymbol, enclosingDeclaration) {
            const access = isSymbolAccessibleWorker(typeSymbol, enclosingDeclaration, 788968 /* Type */ , /*shouldComputeAliasesToMakeVisible*/ false, /*allowModules*/ true);
            return access.accessibility === 0 /* Accessible */ ;
        }
        function isValueSymbolAccessible(typeSymbol, enclosingDeclaration) {
            const access = isSymbolAccessibleWorker(typeSymbol, enclosingDeclaration, 111551 /* Value */ , /*shouldComputeAliasesToMakeVisible*/ false, /*allowModules*/ true);
            return access.accessibility === 0 /* Accessible */ ;
        }
        function isSymbolAccessibleByFlags(typeSymbol, enclosingDeclaration, flags) {
            const access = isSymbolAccessibleWorker(typeSymbol, enclosingDeclaration, flags, /*shouldComputeAliasesToMakeVisible*/ false, /*allowModules*/ false);
            return access.accessibility === 0 /* Accessible */ ;
        }
        function isAnySymbolAccessible(symbols, enclosingDeclaration, initialSymbol, meaning, shouldComputeAliasesToMakeVisible, allowModules) {
            if (!length(symbols)) return;
            let hadAccessibleChain;
            let earlyModuleBail = false;
            for (const symbol of symbols){
                const accessibleSymbolChain = getAccessibleSymbolChain(symbol, enclosingDeclaration, meaning, /*useOnlyExternalAliasing*/ false);
                if (accessibleSymbolChain) {
                    hadAccessibleChain = symbol;
                    const hasAccessibleDeclarations = hasVisibleDeclarations(accessibleSymbolChain[0], shouldComputeAliasesToMakeVisible);
                    if (hasAccessibleDeclarations) return hasAccessibleDeclarations;
                }
                if (allowModules) {
                    if (some(symbol.declarations, hasNonGlobalAugmentationExternalModuleSymbol)) {
                        if (shouldComputeAliasesToMakeVisible) {
                            earlyModuleBail = true;
                            continue;
                        }
                        return {
                            accessibility: 0 /* Accessible */ 
                        };
                    }
                }
                const containers = getContainersOfSymbol(symbol, enclosingDeclaration, meaning);
                const parentResult = isAnySymbolAccessible(containers, enclosingDeclaration, initialSymbol, initialSymbol === symbol ? getQualifiedLeftMeaning(meaning) : meaning, shouldComputeAliasesToMakeVisible, allowModules);
                if (parentResult) return parentResult;
            }
            if (earlyModuleBail) return {
                accessibility: 0 /* Accessible */ 
            };
            if (hadAccessibleChain) return {
                accessibility: 1 /* NotAccessible */ ,
                errorSymbolName: symbolToString(initialSymbol, enclosingDeclaration, meaning),
                errorModuleName: hadAccessibleChain !== initialSymbol ? symbolToString(hadAccessibleChain, enclosingDeclaration, 1920 /* Namespace */ ) : void 0
            };
        }
        function isSymbolAccessible(symbol, enclosingDeclaration, meaning, shouldComputeAliasesToMakeVisible) {
            return isSymbolAccessibleWorker(symbol, enclosingDeclaration, meaning, shouldComputeAliasesToMakeVisible, /*allowModules*/ true);
        }
        function isSymbolAccessibleWorker(symbol, enclosingDeclaration, meaning, shouldComputeAliasesToMakeVisible, allowModules) {
            if (symbol && enclosingDeclaration) {
                const result = isAnySymbolAccessible([
                    symbol
                ], enclosingDeclaration, symbol, meaning, shouldComputeAliasesToMakeVisible, allowModules);
                if (result) return result;
                const symbolExternalModule = forEach(symbol.declarations, getExternalModuleContainer);
                if (symbolExternalModule) {
                    const enclosingExternalModule = getExternalModuleContainer(enclosingDeclaration);
                    if (symbolExternalModule !== enclosingExternalModule) return {
                        accessibility: 2 /* CannotBeNamed */ ,
                        errorSymbolName: symbolToString(symbol, enclosingDeclaration, meaning),
                        errorModuleName: symbolToString(symbolExternalModule),
                        errorNode: isInJSFile(enclosingDeclaration) ? enclosingDeclaration : void 0
                    };
                }
                return {
                    accessibility: 1 /* NotAccessible */ ,
                    errorSymbolName: symbolToString(symbol, enclosingDeclaration, meaning)
                };
            }
            return {
                accessibility: 0 /* Accessible */ 
            };
        }
        function getExternalModuleContainer(declaration) {
            const node = findAncestor(declaration, hasExternalModuleSymbol);
            return node && getSymbolOfDeclaration(node);
        }
        function hasExternalModuleSymbol(declaration) {
            return isAmbientModule(declaration) || declaration.kind === 311 /* SourceFile */  && isExternalOrCommonJsModule(declaration);
        }
        function hasNonGlobalAugmentationExternalModuleSymbol(declaration) {
            return isModuleWithStringLiteralName(declaration) || declaration.kind === 311 /* SourceFile */  && isExternalOrCommonJsModule(declaration);
        }
        function hasVisibleDeclarations(symbol, shouldComputeAliasToMakeVisible) {
            let aliasesToMakeVisible;
            if (!every(filter(symbol.declarations, (d)=>d.kind !== 80 /* Identifier */ ), getIsDeclarationVisible)) return void 0;
            return {
                accessibility: 0 /* Accessible */ ,
                aliasesToMakeVisible: aliasesToMakeVisible
            };
            function getIsDeclarationVisible(declaration) {
                var _a, _b;
                if (!isDeclarationVisible(declaration)) {
                    const anyImportSyntax = getAnyImportSyntax(declaration);
                    if (anyImportSyntax && !hasSyntacticModifier(anyImportSyntax, 1 /* Export */ ) && // import clause without export
                    isDeclarationVisible(anyImportSyntax.parent)) return addVisibleAlias(declaration, anyImportSyntax);
                    else if (isVariableDeclaration(declaration) && isVariableStatement(declaration.parent.parent) && !hasSyntacticModifier(declaration.parent.parent, 1 /* Export */ ) && // unexported variable statement
                    isDeclarationVisible(declaration.parent.parent.parent)) return addVisibleAlias(declaration, declaration.parent.parent);
                    else if (isLateVisibilityPaintedStatement(declaration) && !hasSyntacticModifier(declaration, 1 /* Export */ ) && isDeclarationVisible(declaration.parent)) return addVisibleAlias(declaration, declaration);
                    else if (isBindingElement(declaration)) {
                        if (symbol.flags & 2097152 /* Alias */  && isInJSFile(declaration) && ((_a = declaration.parent) == null ? void 0 : _a.parent) && isVariableDeclaration(declaration.parent.parent) && ((_b = declaration.parent.parent.parent) == null ? void 0 : _b.parent) && isVariableStatement(declaration.parent.parent.parent.parent) && !hasSyntacticModifier(declaration.parent.parent.parent.parent, 1 /* Export */ ) && declaration.parent.parent.parent.parent.parent && isDeclarationVisible(declaration.parent.parent.parent.parent.parent)) return addVisibleAlias(declaration, declaration.parent.parent.parent.parent);
                        else if (symbol.flags & 2 /* BlockScopedVariable */ ) {
                            const variableStatement = findAncestor(declaration, isVariableStatement);
                            if (hasSyntacticModifier(variableStatement, 1 /* Export */ )) return true;
                            if (!isDeclarationVisible(variableStatement.parent)) return false;
                            return addVisibleAlias(declaration, variableStatement);
                        }
                    }
                    return false;
                }
                return true;
            }
            function addVisibleAlias(declaration, aliasingStatement) {
                if (shouldComputeAliasToMakeVisible) {
                    getNodeLinks(declaration).isVisible = true;
                    aliasesToMakeVisible = appendIfUnique(aliasesToMakeVisible, aliasingStatement);
                }
                return true;
            }
        }
        function isEntityNameVisible(entityName, enclosingDeclaration) {
            let meaning;
            if (entityName.parent.kind === 185 /* TypeQuery */  || entityName.parent.kind === 232 /* ExpressionWithTypeArguments */  && !isPartOfTypeNode(entityName.parent) || entityName.parent.kind === 166 /* ComputedPropertyName */ ) meaning = 1160127 /* ExportValue */ ;
            else if (entityName.kind === 165 /* QualifiedName */  || entityName.kind === 210 /* PropertyAccessExpression */  || entityName.parent.kind === 270 /* ImportEqualsDeclaration */ ) meaning = 1920 /* Namespace */ ;
            else meaning = 788968 /* Type */ ;
            const firstIdentifier = getFirstIdentifier(entityName);
            const symbol = resolveName(enclosingDeclaration, firstIdentifier.escapedText, meaning, /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false);
            if (symbol && symbol.flags & 262144 /* TypeParameter */  && meaning & 788968 /* Type */ ) return {
                accessibility: 0 /* Accessible */ 
            };
            if (!symbol && isThisIdentifier(firstIdentifier) && isSymbolAccessible(getSymbolOfDeclaration(getThisContainer(firstIdentifier, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false)), firstIdentifier, meaning, /*shouldComputeAliasesToMakeVisible*/ false).accessibility === 0 /* Accessible */ ) return {
                accessibility: 0 /* Accessible */ 
            };
            return symbol && hasVisibleDeclarations(symbol, /*shouldComputeAliasToMakeVisible*/ true) || {
                accessibility: 1 /* NotAccessible */ ,
                errorSymbolName: getTextOfNode(firstIdentifier),
                errorNode: firstIdentifier
            };
        }
        function symbolToString(symbol, enclosingDeclaration, meaning, flags = 4 /* AllowAnyNodeKind */ , writer) {
            let nodeFlags = 70221824 /* IgnoreErrors */ ;
            if (flags & 2 /* UseOnlyExternalAliasing */ ) nodeFlags |= 128 /* UseOnlyExternalAliasing */ ;
            if (flags & 1 /* WriteTypeParametersOrArguments */ ) nodeFlags |= 512 /* WriteTypeParametersInQualifiedName */ ;
            if (flags & 8 /* UseAliasDefinedOutsideCurrentScope */ ) nodeFlags |= 16384 /* UseAliasDefinedOutsideCurrentScope */ ;
            if (flags & 32 /* DoNotIncludeSymbolChain */ ) nodeFlags |= 134217728 /* DoNotIncludeSymbolChain */ ;
            if (flags & 16 /* WriteComputedProps */ ) nodeFlags |= 1073741824 /* WriteComputedProps */ ;
            const builder = flags & 4 /* AllowAnyNodeKind */  ? nodeBuilder.symbolToNode : nodeBuilder.symbolToEntityName;
            return writer ? symbolToStringWorker(writer).getText() : usingSingleLineStringWriter(symbolToStringWorker);
            function symbolToStringWorker(writer2) {
                const entity = builder(symbol, meaning, enclosingDeclaration, nodeFlags);
                const printer = (enclosingDeclaration == null ? void 0 : enclosingDeclaration.kind) === 311 /* SourceFile */  ? createPrinterWithRemoveCommentsNeverAsciiEscape() : createPrinterWithRemoveComments();
                const sourceFile = enclosingDeclaration && getSourceFileOfNode(enclosingDeclaration);
                printer.writeNode(4 /* Unspecified */ , entity, /*sourceFile*/ sourceFile, writer2);
                return writer2;
            }
        }
        function signatureToString(signature, enclosingDeclaration, flags = 0 /* None */ , kind, writer) {
            return writer ? signatureToStringWorker(writer).getText() : usingSingleLineStringWriter(signatureToStringWorker);
            function signatureToStringWorker(writer2) {
                let sigOutput;
                if (flags & 262144 /* WriteArrowStyleSignature */ ) sigOutput = kind === 1 /* Construct */  ? 184 /* ConstructorType */  : 183 /* FunctionType */ ;
                else sigOutput = kind === 1 /* Construct */  ? 179 /* ConstructSignature */  : 178 /* CallSignature */ ;
                const sig = nodeBuilder.signatureToSignatureDeclaration(signature, sigOutput, enclosingDeclaration, toNodeBuilderFlags(flags) | 70222336 /* WriteTypeParametersInQualifiedName */ );
                const printer = createPrinterWithRemoveCommentsOmitTrailingSemicolon();
                const sourceFile = enclosingDeclaration && getSourceFileOfNode(enclosingDeclaration);
                printer.writeNode(4 /* Unspecified */ , sig, /*sourceFile*/ sourceFile, getTrailingSemicolonDeferringWriter(writer2));
                return writer2;
            }
        }
        function typeToString(type, enclosingDeclaration, flags = 1064960 /* UseAliasDefinedOutsideCurrentScope */ , writer = createTextWriter("")) {
            const noTruncation = compilerOptions.noErrorTruncation || flags & 1 /* NoTruncation */ ;
            const typeNode = nodeBuilder.typeToTypeNode(type, enclosingDeclaration, toNodeBuilderFlags(flags) | 70221824 /* IgnoreErrors */  | (noTruncation ? 1 /* NoTruncation */  : 0));
            if (typeNode === void 0) return Debug.fail("should always get typenode");
            const printer = type !== unresolvedType ? createPrinterWithRemoveComments() : createPrinterWithDefaults();
            const sourceFile = enclosingDeclaration && getSourceFileOfNode(enclosingDeclaration);
            printer.writeNode(4 /* Unspecified */ , typeNode, /*sourceFile*/ sourceFile, writer);
            const result = writer.getText();
            const maxLength2 = noTruncation ? noTruncationMaximumTruncationLength * 2 : defaultMaximumTruncationLength * 2;
            if (maxLength2 && result && result.length >= maxLength2) return result.substr(0, maxLength2 - 3) + "...";
            return result;
        }
        function getTypeNamesForErrorDisplay(left, right) {
            let leftStr = symbolValueDeclarationIsContextSensitive(left.symbol) ? typeToString(left, left.symbol.valueDeclaration) : typeToString(left);
            let rightStr = symbolValueDeclarationIsContextSensitive(right.symbol) ? typeToString(right, right.symbol.valueDeclaration) : typeToString(right);
            if (leftStr === rightStr) {
                leftStr = getTypeNameForErrorDisplay(left);
                rightStr = getTypeNameForErrorDisplay(right);
            }
            return [
                leftStr,
                rightStr
            ];
        }
        function getTypeNameForErrorDisplay(type) {
            return typeToString(type, /*enclosingDeclaration*/ void 0, 64 /* UseFullyQualifiedType */ );
        }
        function symbolValueDeclarationIsContextSensitive(symbol) {
            return symbol && !!symbol.valueDeclaration && isExpression(symbol.valueDeclaration) && !isContextSensitive(symbol.valueDeclaration);
        }
        function toNodeBuilderFlags(flags = 0 /* None */ ) {
            return flags & 848330091 /* NodeBuilderFlagsMask */ ;
        }
        function isClassInstanceSide(type) {
            return !!type.symbol && !!(type.symbol.flags & 32 /* Class */ ) && (type === getDeclaredTypeOfClassOrInterface(type.symbol) || !!(type.flags & 524288 /* Object */ ) && !!(getObjectFlags(type) & 16777216 /* IsClassInstanceClone */ ));
        }
        function createNodeBuilder() {
            return {
                typeToTypeNode: (type, enclosingDeclaration, flags, tracker)=>withContext(enclosingDeclaration, flags, tracker, (context)=>typeToTypeNodeHelper(type, context)),
                indexInfoToIndexSignatureDeclaration: (indexInfo, enclosingDeclaration, flags, tracker)=>withContext(enclosingDeclaration, flags, tracker, (context)=>indexInfoToIndexSignatureDeclarationHelper(indexInfo, context, /*typeNode*/ void 0)),
                signatureToSignatureDeclaration: (signature, kind, enclosingDeclaration, flags, tracker)=>withContext(enclosingDeclaration, flags, tracker, (context)=>signatureToSignatureDeclarationHelper(signature, kind, context)),
                symbolToEntityName: (symbol, meaning, enclosingDeclaration, flags, tracker)=>withContext(enclosingDeclaration, flags, tracker, (context)=>symbolToName(symbol, context, meaning, /*expectsIdentifier*/ false)),
                symbolToExpression: (symbol, meaning, enclosingDeclaration, flags, tracker)=>withContext(enclosingDeclaration, flags, tracker, (context)=>symbolToExpression(symbol, context, meaning)),
                symbolToTypeParameterDeclarations: (symbol, enclosingDeclaration, flags, tracker)=>withContext(enclosingDeclaration, flags, tracker, (context)=>typeParametersToTypeParameterDeclarations(symbol, context)),
                symbolToParameterDeclaration: (symbol, enclosingDeclaration, flags, tracker)=>withContext(enclosingDeclaration, flags, tracker, (context)=>symbolToParameterDeclaration(symbol, context)),
                typeParameterToDeclaration: (parameter, enclosingDeclaration, flags, tracker)=>withContext(enclosingDeclaration, flags, tracker, (context)=>typeParameterToDeclaration(parameter, context)),
                symbolTableToDeclarationStatements: (symbolTable, enclosingDeclaration, flags, tracker, bundled)=>withContext(enclosingDeclaration, flags, tracker, (context)=>symbolTableToDeclarationStatements(symbolTable, context, bundled)),
                symbolToNode: (symbol, meaning, enclosingDeclaration, flags, tracker)=>withContext(enclosingDeclaration, flags, tracker, (context)=>symbolToNode(symbol, context, meaning))
            };
            function symbolToNode(symbol, context, meaning) {
                if (context.flags & 1073741824 /* WriteComputedProps */ ) {
                    if (symbol.valueDeclaration) {
                        const name = getNameOfDeclaration(symbol.valueDeclaration);
                        if (name && isComputedPropertyName(name)) return name;
                    }
                    const nameType = getSymbolLinks(symbol).nameType;
                    if (nameType && nameType.flags & 9216 /* UniqueESSymbol */ ) {
                        context.enclosingDeclaration = nameType.symbol.valueDeclaration;
                        return factory.createComputedPropertyName(symbolToExpression(nameType.symbol, context, meaning));
                    }
                }
                return symbolToExpression(symbol, context, meaning);
            }
            function withContext(enclosingDeclaration, flags, tracker, cb) {
                Debug.assert(enclosingDeclaration === void 0 || (enclosingDeclaration.flags & 8 /* Synthesized */ ) === 0);
                const moduleResolverHost = (tracker == null ? void 0 : tracker.trackSymbol) ? tracker.moduleResolverHost : flags & 134217728 /* DoNotIncludeSymbolChain */  ? createBasicNodeBuilderModuleSpecifierResolutionHost(host) : void 0;
                const context = {
                    enclosingDeclaration: enclosingDeclaration,
                    flags: flags || 0 /* None */ ,
                    tracker: void 0,
                    encounteredError: false,
                    reportedDiagnostic: false,
                    visitedTypes: void 0,
                    symbolDepth: void 0,
                    inferTypeParameters: void 0,
                    approximateLength: 0
                };
                context.tracker = new SymbolTrackerImpl(context, tracker, moduleResolverHost);
                const resultingNode = cb(context);
                if (context.truncating && context.flags & 1 /* NoTruncation */ ) context.tracker.reportTruncationError();
                return context.encounteredError ? void 0 : resultingNode;
            }
            function checkTruncationLength(context) {
                if (context.truncating) return context.truncating;
                return context.truncating = context.approximateLength > (context.flags & 1 /* NoTruncation */  ? noTruncationMaximumTruncationLength : defaultMaximumTruncationLength);
            }
            function typeToTypeNodeHelper(type, context) {
                const savedFlags = context.flags;
                const typeNode = typeToTypeNodeWorker(type, context);
                context.flags = savedFlags;
                return typeNode;
            }
            function typeToTypeNodeWorker(type, context) {
                var _a, _b;
                if (cancellationToken && cancellationToken.throwIfCancellationRequested) cancellationToken.throwIfCancellationRequested();
                const inTypeAlias = context.flags & 8388608 /* InTypeAlias */ ;
                context.flags &= -8388609 /* InTypeAlias */ ;
                if (!type) {
                    if (!(context.flags & 262144 /* AllowEmptyUnionOrIntersection */ )) {
                        context.encounteredError = true;
                        return void 0;
                    }
                    context.approximateLength += 3;
                    return factory.createKeywordTypeNode(133 /* AnyKeyword */ );
                }
                if (!(context.flags & 536870912 /* NoTypeReduction */ )) type = getReducedType(type);
                if (type.flags & 1 /* Any */ ) {
                    if (type.aliasSymbol) return factory.createTypeReferenceNode(symbolToEntityNameNode(type.aliasSymbol), mapToTypeNodes(type.aliasTypeArguments, context));
                    if (type === unresolvedType) return addSyntheticLeadingComment(factory.createKeywordTypeNode(133 /* AnyKeyword */ ), 3 /* MultiLineCommentTrivia */ , "unresolved");
                    context.approximateLength += 3;
                    return factory.createKeywordTypeNode(type === intrinsicMarkerType ? 141 /* IntrinsicKeyword */  : 133 /* AnyKeyword */ );
                }
                if (type.flags & 2 /* Unknown */ ) return factory.createKeywordTypeNode(159 /* UnknownKeyword */ );
                if (type.flags & 4 /* String */ ) {
                    context.approximateLength += 6;
                    return factory.createKeywordTypeNode(154 /* StringKeyword */ );
                }
                if (type.flags & 8 /* Number */ ) {
                    context.approximateLength += 6;
                    return factory.createKeywordTypeNode(150 /* NumberKeyword */ );
                }
                if (type.flags & 64 /* BigInt */ ) {
                    context.approximateLength += 6;
                    return factory.createKeywordTypeNode(162 /* BigIntKeyword */ );
                }
                if (type.flags & 16 /* Boolean */  && !type.aliasSymbol) {
                    context.approximateLength += 7;
                    return factory.createKeywordTypeNode(136 /* BooleanKeyword */ );
                }
                if (type.flags & 1056 /* EnumLike */ ) {
                    if (type.symbol.flags & 8 /* EnumMember */ ) {
                        const parentSymbol = getParentOfSymbol(type.symbol);
                        const parentName = symbolToTypeNode(parentSymbol, context, 788968 /* Type */ );
                        if (getDeclaredTypeOfSymbol(parentSymbol) === type) return parentName;
                        const memberName = symbolName(type.symbol);
                        if (isIdentifierText(memberName, 0 /* ES3 */ )) return appendReferenceToType(parentName, factory.createTypeReferenceNode(memberName, /*typeArguments*/ void 0));
                        if (isImportTypeNode(parentName)) {
                            parentName.isTypeOf = true;
                            return factory.createIndexedAccessTypeNode(parentName, factory.createLiteralTypeNode(factory.createStringLiteral(memberName)));
                        } else if (isTypeReferenceNode(parentName)) return factory.createIndexedAccessTypeNode(factory.createTypeQueryNode(parentName.typeName), factory.createLiteralTypeNode(factory.createStringLiteral(memberName)));
                        else return Debug.fail("Unhandled type node kind returned from `symbolToTypeNode`.");
                    }
                    return symbolToTypeNode(type.symbol, context, 788968 /* Type */ );
                }
                if (type.flags & 128 /* StringLiteral */ ) {
                    context.approximateLength += type.value.length + 2;
                    return factory.createLiteralTypeNode(setEmitFlags(factory.createStringLiteral(type.value, !!(context.flags & 268435456 /* UseSingleQuotesForStringLiteralType */ )), 16777216 /* NoAsciiEscaping */ ));
                }
                if (type.flags & 256 /* NumberLiteral */ ) {
                    const value1 = type.value;
                    context.approximateLength += ("" + value1).length;
                    return factory.createLiteralTypeNode(value1 < 0 ? factory.createPrefixUnaryExpression(41 /* MinusToken */ , factory.createNumericLiteral(-value1)) : factory.createNumericLiteral(value1));
                }
                if (type.flags & 2048 /* BigIntLiteral */ ) {
                    context.approximateLength += pseudoBigIntToString(type.value).length + 1;
                    return factory.createLiteralTypeNode(factory.createBigIntLiteral(type.value));
                }
                if (type.flags & 512 /* BooleanLiteral */ ) {
                    context.approximateLength += type.intrinsicName.length;
                    return factory.createLiteralTypeNode(type.intrinsicName === "true" ? factory.createTrue() : factory.createFalse());
                }
                if (type.flags & 8192 /* UniqueESSymbol */ ) {
                    if (!(context.flags & 1048576 /* AllowUniqueESSymbolType */ )) {
                        if (isValueSymbolAccessible(type.symbol, context.enclosingDeclaration)) {
                            context.approximateLength += 6;
                            return symbolToTypeNode(type.symbol, context, 111551 /* Value */ );
                        }
                        if (context.tracker.reportInaccessibleUniqueSymbolError) context.tracker.reportInaccessibleUniqueSymbolError();
                    }
                    context.approximateLength += 13;
                    return factory.createTypeOperatorNode(158 /* UniqueKeyword */ , factory.createKeywordTypeNode(155 /* SymbolKeyword */ ));
                }
                if (type.flags & 16384 /* Void */ ) {
                    context.approximateLength += 4;
                    return factory.createKeywordTypeNode(116 /* VoidKeyword */ );
                }
                if (type.flags & 32768 /* Undefined */ ) {
                    context.approximateLength += 9;
                    return factory.createKeywordTypeNode(157 /* UndefinedKeyword */ );
                }
                if (type.flags & 65536 /* Null */ ) {
                    context.approximateLength += 4;
                    return factory.createLiteralTypeNode(factory.createNull());
                }
                if (type.flags & 131072 /* Never */ ) {
                    context.approximateLength += 5;
                    return factory.createKeywordTypeNode(146 /* NeverKeyword */ );
                }
                if (type.flags & 4096 /* ESSymbol */ ) {
                    context.approximateLength += 6;
                    return factory.createKeywordTypeNode(155 /* SymbolKeyword */ );
                }
                if (type.flags & 67108864 /* NonPrimitive */ ) {
                    context.approximateLength += 6;
                    return factory.createKeywordTypeNode(151 /* ObjectKeyword */ );
                }
                if (isThisTypeParameter(type)) {
                    if (context.flags & 4194304 /* InObjectTypeLiteral */ ) {
                        if (!context.encounteredError && !(context.flags & 32768 /* AllowThisInObjectLiteral */ )) context.encounteredError = true;
                        (_b = (_a = context.tracker).reportInaccessibleThisError) == null || _b.call(_a);
                    }
                    context.approximateLength += 4;
                    return factory.createThisTypeNode();
                }
                if (!inTypeAlias && type.aliasSymbol && (context.flags & 16384 /* UseAliasDefinedOutsideCurrentScope */  || isTypeSymbolAccessible(type.aliasSymbol, context.enclosingDeclaration))) {
                    const typeArgumentNodes = mapToTypeNodes(type.aliasTypeArguments, context);
                    if (isReservedMemberName(type.aliasSymbol.escapedName) && !(type.aliasSymbol.flags & 32 /* Class */ )) return factory.createTypeReferenceNode(factory.createIdentifier(""), typeArgumentNodes);
                    if (length(typeArgumentNodes) === 1 && type.aliasSymbol === globalArrayType.symbol) return factory.createArrayTypeNode(typeArgumentNodes[0]);
                    return symbolToTypeNode(type.aliasSymbol, context, 788968 /* Type */ , typeArgumentNodes);
                }
                const objectFlags = getObjectFlags(type);
                if (objectFlags & 4 /* Reference */ ) {
                    Debug.assert(!!(type.flags & 524288 /* Object */ ));
                    return type.node ? visitAndTransformType(type, typeReferenceToTypeNode) : typeReferenceToTypeNode(type);
                }
                if (type.flags & 262144 /* TypeParameter */  || objectFlags & 3 /* ClassOrInterface */ ) {
                    if (type.flags & 262144 /* TypeParameter */  && contains(context.inferTypeParameters, type)) {
                        context.approximateLength += symbolName(type.symbol).length + 6;
                        let constraintNode;
                        const constraint = getConstraintOfTypeParameter(type);
                        if (constraint) {
                            const inferredConstraint = getInferredTypeParameterConstraint(type, /*omitTypeReferences*/ true);
                            if (!(inferredConstraint && isTypeIdenticalTo(constraint, inferredConstraint))) {
                                context.approximateLength += 9;
                                constraintNode = constraint && typeToTypeNodeHelper(constraint, context);
                            }
                        }
                        return factory.createInferTypeNode(typeParameterToDeclarationWithConstraint(type, context, constraintNode));
                    }
                    if (context.flags & 4 /* GenerateNamesForShadowedTypeParams */  && type.flags & 262144 /* TypeParameter */  && !isTypeSymbolAccessible(type.symbol, context.enclosingDeclaration)) {
                        const name2 = typeParameterToName(type, context);
                        context.approximateLength += idText(name2).length;
                        return factory.createTypeReferenceNode(factory.createIdentifier(idText(name2)), /*typeArguments*/ void 0);
                    }
                    if (type.symbol) return symbolToTypeNode(type.symbol, context, 788968 /* Type */ );
                    const name = (type === markerSuperTypeForCheck || type === markerSubTypeForCheck) && varianceTypeParameter && varianceTypeParameter.symbol ? (type === markerSubTypeForCheck ? "sub-" : "super-") + symbolName(varianceTypeParameter.symbol) : "?";
                    return factory.createTypeReferenceNode(factory.createIdentifier(name), /*typeArguments*/ void 0);
                }
                if (type.flags & 1048576 /* Union */  && type.origin) type = type.origin;
                if (type.flags & 3145728 /* Intersection */ ) {
                    const types = type.flags & 1048576 /* Union */  ? formatUnionTypes(type.types) : type.types;
                    if (length(types) === 1) return typeToTypeNodeHelper(types[0], context);
                    const typeNodes = mapToTypeNodes(types, context, /*isBareList*/ true);
                    if (typeNodes && typeNodes.length > 0) return type.flags & 1048576 /* Union */  ? factory.createUnionTypeNode(typeNodes) : factory.createIntersectionTypeNode(typeNodes);
                    else {
                        if (!context.encounteredError && !(context.flags & 262144 /* AllowEmptyUnionOrIntersection */ )) context.encounteredError = true;
                        return void 0;
                    }
                }
                if (objectFlags & 48 /* Mapped */ ) {
                    Debug.assert(!!(type.flags & 524288 /* Object */ ));
                    return createAnonymousTypeNode(type);
                }
                if (type.flags & 4194304 /* Index */ ) {
                    const indexedType = type.type;
                    context.approximateLength += 6;
                    const indexTypeNode = typeToTypeNodeHelper(indexedType, context);
                    return factory.createTypeOperatorNode(143 /* KeyOfKeyword */ , indexTypeNode);
                }
                if (type.flags & 134217728 /* TemplateLiteral */ ) {
                    const texts = type.texts;
                    const types = type.types;
                    const templateHead = factory.createTemplateHead(texts[0]);
                    const templateSpans = factory.createNodeArray(map(types, (t, i)=>factory.createTemplateLiteralTypeSpan(typeToTypeNodeHelper(t, context), (i < types.length - 1 ? factory.createTemplateMiddle : factory.createTemplateTail)(texts[i + 1]))));
                    context.approximateLength += 2;
                    return factory.createTemplateLiteralType(templateHead, templateSpans);
                }
                if (type.flags & 268435456 /* StringMapping */ ) {
                    const typeNode = typeToTypeNodeHelper(type.type, context);
                    return symbolToTypeNode(type.symbol, context, 788968 /* Type */ , [
                        typeNode
                    ]);
                }
                if (type.flags & 8388608 /* IndexedAccess */ ) {
                    const objectTypeNode = typeToTypeNodeHelper(type.objectType, context);
                    const indexTypeNode = typeToTypeNodeHelper(type.indexType, context);
                    context.approximateLength += 2;
                    return factory.createIndexedAccessTypeNode(objectTypeNode, indexTypeNode);
                }
                if (type.flags & 16777216 /* Conditional */ ) return visitAndTransformType(type, (type2)=>conditionalTypeToTypeNode(type2));
                if (type.flags & 33554432 /* Substitution */ ) return typeToTypeNodeHelper(type.baseType, context);
                return Debug.fail("Should be unreachable.");
                function conditionalTypeToTypeNode(type2) {
                    const checkTypeNode = typeToTypeNodeHelper(type2.checkType, context);
                    context.approximateLength += 15;
                    if (context.flags & 4 /* GenerateNamesForShadowedTypeParams */  && type2.root.isDistributive && !(type2.checkType.flags & 262144 /* TypeParameter */ )) {
                        const newParam = createTypeParameter(createSymbol(262144 /* TypeParameter */ , "T"));
                        const name = typeParameterToName(newParam, context);
                        const newTypeVariable = factory.createTypeReferenceNode(name);
                        context.approximateLength += 37;
                        const newMapper = prependTypeMapping(type2.root.checkType, newParam, type2.mapper);
                        const saveInferTypeParameters2 = context.inferTypeParameters;
                        context.inferTypeParameters = type2.root.inferTypeParameters;
                        const extendsTypeNode2 = typeToTypeNodeHelper(instantiateType(type2.root.extendsType, newMapper), context);
                        context.inferTypeParameters = saveInferTypeParameters2;
                        const trueTypeNode2 = typeToTypeNodeOrCircularityElision(instantiateType(getTypeFromTypeNode(type2.root.node.trueType), newMapper));
                        const falseTypeNode2 = typeToTypeNodeOrCircularityElision(instantiateType(getTypeFromTypeNode(type2.root.node.falseType), newMapper));
                        return factory.createConditionalTypeNode(checkTypeNode, factory.createInferTypeNode(factory.createTypeParameterDeclaration(/*modifiers*/ void 0, factory.cloneNode(newTypeVariable.typeName))), factory.createConditionalTypeNode(factory.createTypeReferenceNode(factory.cloneNode(name)), typeToTypeNodeHelper(type2.checkType, context), factory.createConditionalTypeNode(newTypeVariable, extendsTypeNode2, trueTypeNode2, falseTypeNode2), factory.createKeywordTypeNode(146 /* NeverKeyword */ )), factory.createKeywordTypeNode(146 /* NeverKeyword */ ));
                    }
                    const saveInferTypeParameters = context.inferTypeParameters;
                    context.inferTypeParameters = type2.root.inferTypeParameters;
                    const extendsTypeNode = typeToTypeNodeHelper(type2.extendsType, context);
                    context.inferTypeParameters = saveInferTypeParameters;
                    const trueTypeNode = typeToTypeNodeOrCircularityElision(getTrueTypeFromConditionalType(type2));
                    const falseTypeNode = typeToTypeNodeOrCircularityElision(getFalseTypeFromConditionalType(type2));
                    return factory.createConditionalTypeNode(checkTypeNode, extendsTypeNode, trueTypeNode, falseTypeNode);
                }
                function typeToTypeNodeOrCircularityElision(type2) {
                    var _a2, _b2, _c;
                    if (type2.flags & 1048576 /* Union */ ) {
                        if ((_a2 = context.visitedTypes) == null ? void 0 : _a2.has(getTypeId(type2))) {
                            if (!(context.flags & 131072 /* AllowAnonymousIdentifier */ )) {
                                context.encounteredError = true;
                                (_c = (_b2 = context.tracker) == null ? void 0 : _b2.reportCyclicStructureError) == null || _c.call(_b2);
                            }
                            return createElidedInformationPlaceholder(context);
                        }
                        return visitAndTransformType(type2, (type3)=>typeToTypeNodeHelper(type3, context));
                    }
                    return typeToTypeNodeHelper(type2, context);
                }
                function isMappedTypeHomomorphic(type2) {
                    return !!getHomomorphicTypeVariable(type2);
                }
                function isHomomorphicMappedTypeWithNonHomomorphicInstantiation(type2) {
                    return !!type2.target && isMappedTypeHomomorphic(type2.target) && !isMappedTypeHomomorphic(type2);
                }
                function createMappedTypeNodeFromType(type2) {
                    Debug.assert(!!(type2.flags & 524288 /* Object */ ));
                    const readonlyToken = type2.declaration.readonlyToken ? factory.createToken(type2.declaration.readonlyToken.kind) : void 0;
                    const questionToken = type2.declaration.questionToken ? factory.createToken(type2.declaration.questionToken.kind) : void 0;
                    let appropriateConstraintTypeNode;
                    let newTypeVariable;
                    if (isMappedTypeWithKeyofConstraintDeclaration(type2)) {
                        if (isHomomorphicMappedTypeWithNonHomomorphicInstantiation(type2) && context.flags & 4 /* GenerateNamesForShadowedTypeParams */ ) {
                            const newParam = createTypeParameter(createSymbol(262144 /* TypeParameter */ , "T"));
                            const name = typeParameterToName(newParam, context);
                            newTypeVariable = factory.createTypeReferenceNode(name);
                        }
                        appropriateConstraintTypeNode = factory.createTypeOperatorNode(143 /* KeyOfKeyword */ , newTypeVariable || typeToTypeNodeHelper(getModifiersTypeFromMappedType(type2), context));
                    } else appropriateConstraintTypeNode = typeToTypeNodeHelper(getConstraintTypeFromMappedType(type2), context);
                    const typeParameterNode = typeParameterToDeclarationWithConstraint(getTypeParameterFromMappedType(type2), context, appropriateConstraintTypeNode);
                    const nameTypeNode = type2.declaration.nameType ? typeToTypeNodeHelper(getNameTypeFromMappedType(type2), context) : void 0;
                    const templateTypeNode = typeToTypeNodeHelper(removeMissingType(getTemplateTypeFromMappedType(type2), !!(getMappedTypeModifiers(type2) & 4 /* IncludeOptional */ )), context);
                    const mappedTypeNode = factory.createMappedTypeNode(readonlyToken, typeParameterNode, nameTypeNode, questionToken, templateTypeNode, /*members*/ void 0);
                    context.approximateLength += 10;
                    const result = setEmitFlags(mappedTypeNode, 1 /* SingleLine */ );
                    if (isHomomorphicMappedTypeWithNonHomomorphicInstantiation(type2) && context.flags & 4 /* GenerateNamesForShadowedTypeParams */ ) {
                        const originalConstraint = instantiateType(getConstraintOfTypeParameter(getTypeFromTypeNode(type2.declaration.typeParameter.constraint.type)) || unknownType, type2.mapper);
                        return factory.createConditionalTypeNode(typeToTypeNodeHelper(getModifiersTypeFromMappedType(type2), context), factory.createInferTypeNode(factory.createTypeParameterDeclaration(/*modifiers*/ void 0, factory.cloneNode(newTypeVariable.typeName), originalConstraint.flags & 2 /* Unknown */  ? void 0 : typeToTypeNodeHelper(originalConstraint, context))), result, factory.createKeywordTypeNode(146 /* NeverKeyword */ ));
                    }
                    return result;
                }
                function createAnonymousTypeNode(type2) {
                    var _a2, _b2;
                    const typeId = type2.id;
                    const symbol = type2.symbol;
                    if (symbol) {
                        const isInstanceType = isClassInstanceSide(type2) ? 788968 /* Type */  : 111551 /* Value */ ;
                        if (isJSConstructor(symbol.valueDeclaration)) return symbolToTypeNode(symbol, context, isInstanceType);
                        else if (symbol.flags & 32 /* Class */  && !getBaseTypeVariableOfClass(symbol) && !(symbol.valueDeclaration && isClassLike(symbol.valueDeclaration) && context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */  && (!isClassDeclaration(symbol.valueDeclaration) || isSymbolAccessible(symbol, context.enclosingDeclaration, isInstanceType, /*shouldComputeAliasesToMakeVisible*/ false).accessibility !== 0 /* Accessible */ )) || symbol.flags & 896 /* ValueModule */  || shouldWriteTypeOfFunctionSymbol()) return symbolToTypeNode(symbol, context, isInstanceType);
                        else if ((_a2 = context.visitedTypes) == null ? void 0 : _a2.has(typeId)) {
                            const typeAlias = getTypeAliasForTypeLiteral(type2);
                            if (typeAlias) return symbolToTypeNode(typeAlias, context, 788968 /* Type */ );
                            else return createElidedInformationPlaceholder(context);
                        } else return visitAndTransformType(type2, createTypeNodeFromObjectType);
                    } else {
                        const isInstantiationExpressionType = !!(getObjectFlags(type2) & 8388608 /* InstantiationExpressionType */ );
                        if (isInstantiationExpressionType) {
                            const instantiationExpressionType = type2;
                            if (isTypeQueryNode(instantiationExpressionType.node)) {
                                const typeNode = serializeExistingTypeNode(context, instantiationExpressionType.node);
                                if (typeNode) return typeNode;
                            }
                            if ((_b2 = context.visitedTypes) == null ? void 0 : _b2.has(typeId)) return createElidedInformationPlaceholder(context);
                            return visitAndTransformType(type2, createTypeNodeFromObjectType);
                        }
                        return createTypeNodeFromObjectType(type2);
                    }
                    function shouldWriteTypeOfFunctionSymbol() {
                        var _a3;
                        const isStaticMethodSymbol = !!(symbol.flags & 8192 /* Method */ ) && // typeof static method
                        some(symbol.declarations, (declaration)=>isStatic(declaration));
                        const isNonLocalFunctionSymbol = !!(symbol.flags & 16 /* Function */ ) && (symbol.parent || // is exported function symbol
                        forEach(symbol.declarations, (declaration)=>declaration.parent.kind === 311 /* SourceFile */  || declaration.parent.kind === 267 /* ModuleBlock */ ));
                        if (isStaticMethodSymbol || isNonLocalFunctionSymbol) return (!!(context.flags & 4096 /* UseTypeOfFunction */ ) || ((_a3 = context.visitedTypes) == null ? void 0 : _a3.has(typeId))) && // it is type of the symbol uses itself recursively
                        (!(context.flags & 8 /* UseStructuralFallback */ ) || isValueSymbolAccessible(symbol, context.enclosingDeclaration));
                    }
                }
                function visitAndTransformType(type2, transform2) {
                    var _a2, _b2;
                    const typeId = type2.id;
                    const isConstructorObject = getObjectFlags(type2) & 16 /* Anonymous */  && type2.symbol && type2.symbol.flags & 32 /* Class */ ;
                    const id = getObjectFlags(type2) & 4 /* Reference */  && type2.node ? "N" + getNodeId(type2.node) : type2.flags & 16777216 /* Conditional */  ? "N" + getNodeId(type2.root.node) : type2.symbol ? (isConstructorObject ? "+" : "") + getSymbolId(type2.symbol) : void 0;
                    if (!context.visitedTypes) context.visitedTypes = /* @__PURE__ */ new Set();
                    if (id && !context.symbolDepth) context.symbolDepth = /* @__PURE__ */ new Map();
                    const links = context.enclosingDeclaration && getNodeLinks(context.enclosingDeclaration);
                    const key = `${getTypeId(type2)}|${context.flags}`;
                    if (links) links.serializedTypes || (links.serializedTypes = /* @__PURE__ */ new Map());
                    const cachedResult = (_a2 = links == null ? void 0 : links.serializedTypes) == null ? void 0 : _a2.get(key);
                    if (cachedResult) {
                        if (cachedResult.truncating) context.truncating = true;
                        context.approximateLength += cachedResult.addedLength;
                        return deepCloneOrReuseNode(cachedResult.node);
                    }
                    let depth;
                    if (id) {
                        depth = context.symbolDepth.get(id) || 0;
                        if (depth > 10) return createElidedInformationPlaceholder(context);
                        context.symbolDepth.set(id, depth + 1);
                    }
                    context.visitedTypes.add(typeId);
                    const startLength = context.approximateLength;
                    const result = transform2(type2);
                    const addedLength = context.approximateLength - startLength;
                    if (!context.reportedDiagnostic && !context.encounteredError) (_b2 = links == null ? void 0 : links.serializedTypes) == null || _b2.set(key, {
                        node: result,
                        truncating: context.truncating,
                        addedLength: addedLength
                    });
                    context.visitedTypes.delete(typeId);
                    if (id) context.symbolDepth.set(id, depth);
                    return result;
                    function deepCloneOrReuseNode(node) {
                        if (!nodeIsSynthesized(node) && getParseTreeNode(node) === node) return node;
                        return setTextRange(factory.cloneNode(visitEachChild(node, deepCloneOrReuseNode, nullTransformationContext, deepCloneOrReuseNodes)), node);
                    }
                    function deepCloneOrReuseNodes(nodes, visitor, test, start, count) {
                        if (nodes && nodes.length === 0) return setTextRange(factory.createNodeArray(/*elements*/ void 0, nodes.hasTrailingComma), nodes);
                        return visitNodes2(nodes, visitor, test, start, count);
                    }
                }
                function createTypeNodeFromObjectType(type2) {
                    if (isGenericMappedType(type2) || type2.containsError) return createMappedTypeNodeFromType(type2);
                    const resolved = resolveStructuredTypeMembers(type2);
                    if (!resolved.properties.length && !resolved.indexInfos.length) {
                        if (!resolved.callSignatures.length && !resolved.constructSignatures.length) {
                            context.approximateLength += 2;
                            return setEmitFlags(factory.createTypeLiteralNode(/*members*/ void 0), 1 /* SingleLine */ );
                        }
                        if (resolved.callSignatures.length === 1 && !resolved.constructSignatures.length) {
                            const signature = resolved.callSignatures[0];
                            const signatureNode = signatureToSignatureDeclarationHelper(signature, 183 /* FunctionType */ , context);
                            return signatureNode;
                        }
                        if (resolved.constructSignatures.length === 1 && !resolved.callSignatures.length) {
                            const signature = resolved.constructSignatures[0];
                            const signatureNode = signatureToSignatureDeclarationHelper(signature, 184 /* ConstructorType */ , context);
                            return signatureNode;
                        }
                    }
                    const abstractSignatures = filter(resolved.constructSignatures, (signature)=>!!(signature.flags & 4 /* Abstract */ ));
                    if (some(abstractSignatures)) {
                        const types = map(abstractSignatures, getOrCreateTypeFromSignature);
                        const typeElementCount = resolved.callSignatures.length + (resolved.constructSignatures.length - abstractSignatures.length) + resolved.indexInfos.length + // exclude `prototype` when writing a class expression as a type literal, as per
                        // the logic in `createTypeNodesFromResolvedType`.
                        (context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */  ? countWhere(resolved.properties, (p)=>!(p.flags & 4194304 /* Prototype */ )) : length(resolved.properties));
                        if (typeElementCount) types.push(getResolvedTypeWithoutAbstractConstructSignatures(resolved));
                        return typeToTypeNodeHelper(getIntersectionType(types), context);
                    }
                    const savedFlags = context.flags;
                    context.flags |= 4194304 /* InObjectTypeLiteral */ ;
                    const members = createTypeNodesFromResolvedType(resolved);
                    context.flags = savedFlags;
                    const typeLiteralNode = factory.createTypeLiteralNode(members);
                    context.approximateLength += 2;
                    setEmitFlags(typeLiteralNode, context.flags & 1024 /* MultilineObjectLiterals */  ? 0 : 1 /* SingleLine */ );
                    return typeLiteralNode;
                }
                function typeReferenceToTypeNode(type2) {
                    let typeArguments = getTypeArguments(type2);
                    if (type2.target === globalArrayType || type2.target === globalReadonlyArrayType) {
                        if (context.flags & 2 /* WriteArrayAsGenericType */ ) {
                            const typeArgumentNode = typeToTypeNodeHelper(typeArguments[0], context);
                            return factory.createTypeReferenceNode(type2.target === globalArrayType ? "Array" : "ReadonlyArray", [
                                typeArgumentNode
                            ]);
                        }
                        const elementType = typeToTypeNodeHelper(typeArguments[0], context);
                        const arrayType = factory.createArrayTypeNode(elementType);
                        return type2.target === globalArrayType ? arrayType : factory.createTypeOperatorNode(148 /* ReadonlyKeyword */ , arrayType);
                    } else if (type2.target.objectFlags & 8 /* Tuple */ ) {
                        typeArguments = sameMap(typeArguments, (t, i)=>removeMissingType(t, !!(type2.target.elementFlags[i] & 2 /* Optional */ )));
                        if (typeArguments.length > 0) {
                            const arity = getTypeReferenceArity(type2);
                            const tupleConstituentNodes = mapToTypeNodes(typeArguments.slice(0, arity), context);
                            if (tupleConstituentNodes) {
                                if (type2.target.labeledElementDeclarations) for(let i = 0; i < tupleConstituentNodes.length; i++){
                                    const flags = type2.target.elementFlags[i];
                                    tupleConstituentNodes[i] = factory.createNamedTupleMember(flags & 12 /* Variable */  ? factory.createToken(26 /* DotDotDotToken */ ) : void 0, factory.createIdentifier(unescapeLeadingUnderscores(getTupleElementLabel(type2.target.labeledElementDeclarations[i]))), flags & 2 /* Optional */  ? factory.createToken(58 /* QuestionToken */ ) : void 0, flags & 4 /* Rest */  ? factory.createArrayTypeNode(tupleConstituentNodes[i]) : tupleConstituentNodes[i]);
                                }
                                else for(let i = 0; i < Math.min(arity, tupleConstituentNodes.length); i++){
                                    const flags = type2.target.elementFlags[i];
                                    tupleConstituentNodes[i] = flags & 12 /* Variable */  ? factory.createRestTypeNode(flags & 4 /* Rest */  ? factory.createArrayTypeNode(tupleConstituentNodes[i]) : tupleConstituentNodes[i]) : flags & 2 /* Optional */  ? factory.createOptionalTypeNode(tupleConstituentNodes[i]) : tupleConstituentNodes[i];
                                }
                                const tupleTypeNode = setEmitFlags(factory.createTupleTypeNode(tupleConstituentNodes), 1 /* SingleLine */ );
                                return type2.target.readonly ? factory.createTypeOperatorNode(148 /* ReadonlyKeyword */ , tupleTypeNode) : tupleTypeNode;
                            }
                        }
                        if (context.encounteredError || context.flags & 524288 /* AllowEmptyTuple */ ) {
                            const tupleTypeNode = setEmitFlags(factory.createTupleTypeNode([]), 1 /* SingleLine */ );
                            return type2.target.readonly ? factory.createTypeOperatorNode(148 /* ReadonlyKeyword */ , tupleTypeNode) : tupleTypeNode;
                        }
                        context.encounteredError = true;
                        return void 0;
                    } else if (context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */  && type2.symbol.valueDeclaration && isClassLike(type2.symbol.valueDeclaration) && !isValueSymbolAccessible(type2.symbol, context.enclosingDeclaration)) return createAnonymousTypeNode(type2);
                    else {
                        const outerTypeParameters = type2.target.outerTypeParameters;
                        let i = 0;
                        let resultType;
                        if (outerTypeParameters) {
                            const length2 = outerTypeParameters.length;
                            while(i < length2){
                                const start = i;
                                const parent2 = getParentSymbolOfTypeParameter(outerTypeParameters[i]);
                                do i++;
                                while (i < length2 && getParentSymbolOfTypeParameter(outerTypeParameters[i]) === parent2);
                                if (!rangeEquals(outerTypeParameters, typeArguments, start, i)) {
                                    const typeArgumentSlice = mapToTypeNodes(typeArguments.slice(start, i), context);
                                    const flags2 = context.flags;
                                    context.flags |= 16 /* ForbidIndexedAccessSymbolReferences */ ;
                                    const ref = symbolToTypeNode(parent2, context, 788968 /* Type */ , typeArgumentSlice);
                                    context.flags = flags2;
                                    resultType = !resultType ? ref : appendReferenceToType(resultType, ref);
                                }
                            }
                        }
                        let typeArgumentNodes;
                        if (typeArguments.length > 0) {
                            const typeParameterCount = (type2.target.typeParameters || emptyArray).length;
                            typeArgumentNodes = mapToTypeNodes(typeArguments.slice(i, typeParameterCount), context);
                        }
                        const flags = context.flags;
                        context.flags |= 16 /* ForbidIndexedAccessSymbolReferences */ ;
                        const finalRef = symbolToTypeNode(type2.symbol, context, 788968 /* Type */ , typeArgumentNodes);
                        context.flags = flags;
                        return !resultType ? finalRef : appendReferenceToType(resultType, finalRef);
                    }
                }
                function appendReferenceToType(root, ref) {
                    if (isImportTypeNode(root)) {
                        let typeArguments = root.typeArguments;
                        let qualifier = root.qualifier;
                        if (qualifier) {
                            if (isIdentifier(qualifier)) {
                                if (typeArguments !== getIdentifierTypeArguments(qualifier)) qualifier = setIdentifierTypeArguments(factory.cloneNode(qualifier), typeArguments);
                            } else if (typeArguments !== getIdentifierTypeArguments(qualifier.right)) qualifier = factory.updateQualifiedName(qualifier, qualifier.left, setIdentifierTypeArguments(factory.cloneNode(qualifier.right), typeArguments));
                        }
                        typeArguments = ref.typeArguments;
                        const ids = getAccessStack(ref);
                        for (const id of ids)qualifier = qualifier ? factory.createQualifiedName(qualifier, id) : id;
                        return factory.updateImportTypeNode(root, root.argument, root.assertions, qualifier, typeArguments, root.isTypeOf);
                    } else {
                        let typeArguments = root.typeArguments;
                        let typeName = root.typeName;
                        if (isIdentifier(typeName)) {
                            if (typeArguments !== getIdentifierTypeArguments(typeName)) typeName = setIdentifierTypeArguments(factory.cloneNode(typeName), typeArguments);
                        } else if (typeArguments !== getIdentifierTypeArguments(typeName.right)) typeName = factory.updateQualifiedName(typeName, typeName.left, setIdentifierTypeArguments(factory.cloneNode(typeName.right), typeArguments));
                        typeArguments = ref.typeArguments;
                        const ids = getAccessStack(ref);
                        for (const id of ids)typeName = factory.createQualifiedName(typeName, id);
                        return factory.updateTypeReferenceNode(root, typeName, typeArguments);
                    }
                }
                function getAccessStack(ref) {
                    let state = ref.typeName;
                    const ids = [];
                    while(!isIdentifier(state)){
                        ids.unshift(state.right);
                        state = state.left;
                    }
                    ids.unshift(state);
                    return ids;
                }
                function createTypeNodesFromResolvedType(resolvedType) {
                    if (checkTruncationLength(context)) return [
                        factory.createPropertySignature(/*modifiers*/ void 0, "...", /*questionToken*/ void 0, /*type*/ void 0)
                    ];
                    const typeElements = [];
                    for (const signature of resolvedType.callSignatures)typeElements.push(signatureToSignatureDeclarationHelper(signature, 178 /* CallSignature */ , context));
                    for (const signature of resolvedType.constructSignatures){
                        if (signature.flags & 4 /* Abstract */ ) continue;
                        typeElements.push(signatureToSignatureDeclarationHelper(signature, 179 /* ConstructSignature */ , context));
                    }
                    for (const info of resolvedType.indexInfos)typeElements.push(indexInfoToIndexSignatureDeclarationHelper(info, context, resolvedType.objectFlags & 1024 /* ReverseMapped */  ? createElidedInformationPlaceholder(context) : void 0));
                    const properties = resolvedType.properties;
                    if (!properties) return typeElements;
                    let i = 0;
                    for (const propertySymbol of properties){
                        i++;
                        if (context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */ ) {
                            if (propertySymbol.flags & 4194304 /* Prototype */ ) continue;
                            if (getDeclarationModifierFlagsFromSymbol(propertySymbol) & 24 /* Protected */  && context.tracker.reportPrivateInBaseOfClassExpression) context.tracker.reportPrivateInBaseOfClassExpression(unescapeLeadingUnderscores(propertySymbol.escapedName));
                        }
                        if (checkTruncationLength(context) && i + 2 < properties.length - 1) {
                            typeElements.push(factory.createPropertySignature(/*modifiers*/ void 0, `... ${properties.length - i} more ...`, /*questionToken*/ void 0, /*type*/ void 0));
                            addPropertyToElementList(properties[properties.length - 1], context, typeElements);
                            break;
                        }
                        addPropertyToElementList(propertySymbol, context, typeElements);
                    }
                    return typeElements.length ? typeElements : void 0;
                }
            }
            function createElidedInformationPlaceholder(context) {
                context.approximateLength += 3;
                if (!(context.flags & 1 /* NoTruncation */ )) return factory.createTypeReferenceNode(factory.createIdentifier("..."), /*typeArguments*/ void 0);
                return factory.createKeywordTypeNode(133 /* AnyKeyword */ );
            }
            function shouldUsePlaceholderForProperty(propertySymbol, context) {
                var _a;
                return !!(getCheckFlags(propertySymbol) & 8192 /* ReverseMapped */ ) && (contains(context.reverseMappedStack, propertySymbol) || ((_a = context.reverseMappedStack) == null ? void 0 : _a[0]) && !(getObjectFlags(last(context.reverseMappedStack).links.propertyType) & 16 /* Anonymous */ ));
            }
            function addPropertyToElementList(propertySymbol, context, typeElements) {
                var _a;
                const propertyIsReverseMapped = !!(getCheckFlags(propertySymbol) & 8192 /* ReverseMapped */ );
                const propertyType = shouldUsePlaceholderForProperty(propertySymbol, context) ? anyType : getNonMissingTypeOfSymbol(propertySymbol);
                const saveEnclosingDeclaration = context.enclosingDeclaration;
                context.enclosingDeclaration = void 0;
                if (context.tracker.canTrackSymbol && isLateBoundName(propertySymbol.escapedName)) {
                    if (propertySymbol.declarations) {
                        const decl = first(propertySymbol.declarations);
                        if (hasLateBindableName(decl)) {
                            if (isBinaryExpression(decl)) {
                                const name = getNameOfDeclaration(decl);
                                if (name && isElementAccessExpression(name) && isPropertyAccessEntityNameExpression(name.argumentExpression)) trackComputedName(name.argumentExpression, saveEnclosingDeclaration, context);
                            } else trackComputedName(decl.name.expression, saveEnclosingDeclaration, context);
                        }
                    } else context.tracker.reportNonSerializableProperty(symbolToString(propertySymbol));
                }
                context.enclosingDeclaration = propertySymbol.valueDeclaration || ((_a = propertySymbol.declarations) == null ? void 0 : _a[0]) || saveEnclosingDeclaration;
                const propertyName = getPropertyNameNodeForSymbol(propertySymbol, context);
                context.enclosingDeclaration = saveEnclosingDeclaration;
                context.approximateLength += symbolName(propertySymbol).length + 1;
                const optionalToken = propertySymbol.flags & 16777216 /* Optional */  ? factory.createToken(58 /* QuestionToken */ ) : void 0;
                if (propertySymbol.flags & 8208 /* Method */  && !getPropertiesOfObjectType(propertyType).length && !isReadonlySymbol(propertySymbol)) {
                    const signatures = getSignaturesOfType(filterType(propertyType, (t)=>!(t.flags & 32768 /* Undefined */ )), 0 /* Call */ );
                    for (const signature of signatures){
                        const methodDeclaration = signatureToSignatureDeclarationHelper(signature, 172 /* MethodSignature */ , context, {
                            name: propertyName,
                            questionToken: optionalToken
                        });
                        typeElements.push(preserveCommentsOn(methodDeclaration));
                    }
                } else {
                    let propertyTypeNode;
                    if (shouldUsePlaceholderForProperty(propertySymbol, context)) propertyTypeNode = createElidedInformationPlaceholder(context);
                    else {
                        if (propertyIsReverseMapped) {
                            context.reverseMappedStack || (context.reverseMappedStack = []);
                            context.reverseMappedStack.push(propertySymbol);
                        }
                        propertyTypeNode = propertyType ? serializeTypeForDeclaration(context, propertyType, propertySymbol, saveEnclosingDeclaration) : factory.createKeywordTypeNode(133 /* AnyKeyword */ );
                        if (propertyIsReverseMapped) context.reverseMappedStack.pop();
                    }
                    const modifiers = isReadonlySymbol(propertySymbol) ? [
                        factory.createToken(148 /* ReadonlyKeyword */ )
                    ] : void 0;
                    if (modifiers) context.approximateLength += 9;
                    const propertySignature = factory.createPropertySignature(modifiers, propertyName, optionalToken, propertyTypeNode);
                    typeElements.push(preserveCommentsOn(propertySignature));
                }
                function preserveCommentsOn(node) {
                    var _a2;
                    if (some(propertySymbol.declarations, (d)=>d.kind === 354 /* JSDocPropertyTag */ )) {
                        const d = (_a2 = propertySymbol.declarations) == null ? void 0 : _a2.find((d2)=>d2.kind === 354 /* JSDocPropertyTag */ );
                        const commentText = getTextOfJSDocComment(d.comment);
                        if (commentText) setSyntheticLeadingComments(node, [
                            {
                                kind: 3 /* MultiLineCommentTrivia */ ,
                                text: "*\n * " + commentText.replace(/\n/g, "\n * ") + "\n ",
                                pos: -1,
                                end: -1,
                                hasTrailingNewLine: true
                            }
                        ]);
                    } else if (propertySymbol.valueDeclaration) setCommentRange(node, propertySymbol.valueDeclaration);
                    return node;
                }
            }
            function mapToTypeNodes(types, context, isBareList) {
                if (some(types)) {
                    if (checkTruncationLength(context)) {
                        if (!isBareList) return [
                            factory.createTypeReferenceNode("...", /*typeArguments*/ void 0)
                        ];
                        else if (types.length > 2) return [
                            typeToTypeNodeHelper(types[0], context),
                            factory.createTypeReferenceNode(`... ${types.length - 2} more ...`, /*typeArguments*/ void 0),
                            typeToTypeNodeHelper(types[types.length - 1], context)
                        ];
                    }
                    const mayHaveNameCollisions = !(context.flags & 64 /* UseFullyQualifiedType */ );
                    const seenNames = mayHaveNameCollisions ? createMultiMap() : void 0;
                    const result = [];
                    let i = 0;
                    for (const type of types){
                        i++;
                        if (checkTruncationLength(context) && i + 2 < types.length - 1) {
                            result.push(factory.createTypeReferenceNode(`... ${types.length - i} more ...`, /*typeArguments*/ void 0));
                            const typeNode2 = typeToTypeNodeHelper(types[types.length - 1], context);
                            if (typeNode2) result.push(typeNode2);
                            break;
                        }
                        context.approximateLength += 2;
                        const typeNode = typeToTypeNodeHelper(type, context);
                        if (typeNode) {
                            result.push(typeNode);
                            if (seenNames && isIdentifierTypeReference(typeNode)) seenNames.add(typeNode.typeName.escapedText, [
                                type,
                                result.length - 1
                            ]);
                        }
                    }
                    if (seenNames) {
                        const saveContextFlags = context.flags;
                        context.flags |= 64 /* UseFullyQualifiedType */ ;
                        seenNames.forEach((types2)=>{
                            if (!arrayIsHomogeneous(types2, ([a], [b])=>typesAreSameReference(a, b))) for (const [type, resultIndex] of types2)result[resultIndex] = typeToTypeNodeHelper(type, context);
                        });
                        context.flags = saveContextFlags;
                    }
                    return result;
                }
            }
            function typesAreSameReference(a, b) {
                return a === b || !!a.symbol && a.symbol === b.symbol || !!a.aliasSymbol && a.aliasSymbol === b.aliasSymbol;
            }
            function indexInfoToIndexSignatureDeclarationHelper(indexInfo, context, typeNode) {
                const name = getNameFromIndexInfo(indexInfo) || "x";
                const indexerTypeNode = typeToTypeNodeHelper(indexInfo.keyType, context);
                const indexingParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, name, /*questionToken*/ void 0, indexerTypeNode, /*initializer*/ void 0);
                if (!typeNode) typeNode = typeToTypeNodeHelper(indexInfo.type || anyType, context);
                if (!indexInfo.type && !(context.flags & 2097152 /* AllowEmptyIndexInfoType */ )) context.encounteredError = true;
                context.approximateLength += name.length + 4;
                return factory.createIndexSignature(indexInfo.isReadonly ? [
                    factory.createToken(148 /* ReadonlyKeyword */ )
                ] : void 0, [
                    indexingParameter
                ], typeNode);
            }
            function signatureToSignatureDeclarationHelper(signature, kind, context, options) {
                const suppressAny = context.flags & 256 /* SuppressAnyReturnType */ ;
                if (suppressAny) context.flags &= -257 /* SuppressAnyReturnType */ ;
                context.approximateLength += 3;
                let typeParameters;
                let typeArguments;
                if (context.flags & 32 /* WriteTypeArgumentsOfSignature */  && signature.target && signature.mapper && signature.target.typeParameters) typeArguments = signature.target.typeParameters.map((parameter)=>typeToTypeNodeHelper(instantiateType(parameter, signature.mapper), context));
                else typeParameters = signature.typeParameters && signature.typeParameters.map((parameter)=>typeParameterToDeclaration(parameter, context));
                const expandedParams = getExpandedParameters(signature, /*skipUnionExpanding*/ true)[0];
                let cleanup;
                if (context.enclosingDeclaration && signature.declaration && signature.declaration !== context.enclosingDeclaration && !isInJSFile(signature.declaration) && some(expandedParams)) {
                    const existingFakeScope = getNodeLinks(context.enclosingDeclaration).fakeScopeForSignatureDeclaration ? context.enclosingDeclaration : void 0;
                    Debug.assertOptionalNode(existingFakeScope, isBlock);
                    const locals = (existingFakeScope == null ? void 0 : existingFakeScope.locals) ?? createSymbolTable();
                    let newLocals;
                    for (const param of expandedParams)if (!locals.has(param.escapedName)) {
                        newLocals = append(newLocals, param.escapedName);
                        locals.set(param.escapedName, param);
                    }
                    if (newLocals) {
                        let removeNewLocals2 = function() {
                            forEach(newLocals, (s)=>locals.delete(s));
                        };
                        var removeNewLocals = removeNewLocals2;
                        if (existingFakeScope) cleanup = removeNewLocals2;
                        else {
                            const fakeScope = parseNodeFactory.createBlock(emptyArray);
                            getNodeLinks(fakeScope).fakeScopeForSignatureDeclaration = true;
                            fakeScope.locals = locals;
                            const saveEnclosingDeclaration = context.enclosingDeclaration;
                            setParent(fakeScope, saveEnclosingDeclaration);
                            context.enclosingDeclaration = fakeScope;
                            cleanup = ()=>{
                                context.enclosingDeclaration = saveEnclosingDeclaration;
                                removeNewLocals2();
                            };
                        }
                    }
                }
                const parameters = (some(expandedParams, (p)=>p !== expandedParams[expandedParams.length - 1] && !!(getCheckFlags(p) & 32768 /* RestParameter */ )) ? signature.parameters : expandedParams).map((parameter)=>symbolToParameterDeclaration(parameter, context, kind === 175 /* Constructor */ , options == null ? void 0 : options.privateSymbolVisitor, options == null ? void 0 : options.bundledImports));
                const thisParameter = context.flags & 33554432 /* OmitThisParameter */  ? void 0 : tryGetThisParameterDeclaration(signature, context);
                if (thisParameter) parameters.unshift(thisParameter);
                let returnTypeNode;
                const typePredicate = getTypePredicateOfSignature(signature);
                if (typePredicate) {
                    const assertsModifier = typePredicate.kind === 2 /* AssertsThis */  || typePredicate.kind === 3 /* AssertsIdentifier */  ? factory.createToken(131 /* AssertsKeyword */ ) : void 0;
                    const parameterName = typePredicate.kind === 1 /* Identifier */  || typePredicate.kind === 3 /* AssertsIdentifier */  ? setEmitFlags(factory.createIdentifier(typePredicate.parameterName), 16777216 /* NoAsciiEscaping */ ) : factory.createThisTypeNode();
                    const typeNode = typePredicate.type && typeToTypeNodeHelper(typePredicate.type, context);
                    returnTypeNode = factory.createTypePredicateNode(assertsModifier, parameterName, typeNode);
                } else {
                    const returnType = getReturnTypeOfSignature(signature);
                    if (returnType && !(suppressAny && isTypeAny(returnType))) returnTypeNode = serializeReturnTypeForSignature(context, returnType, signature, options == null ? void 0 : options.privateSymbolVisitor, options == null ? void 0 : options.bundledImports);
                    else if (!suppressAny) returnTypeNode = factory.createKeywordTypeNode(133 /* AnyKeyword */ );
                }
                let modifiers = options == null ? void 0 : options.modifiers;
                if (kind === 184 /* ConstructorType */  && signature.flags & 4 /* Abstract */ ) {
                    const flags = modifiersToFlags(modifiers);
                    modifiers = factory.createModifiersFromModifierFlags(flags | 256 /* Abstract */ );
                }
                const node = kind === 178 /* CallSignature */  ? factory.createCallSignature(typeParameters, parameters, returnTypeNode) : kind === 179 /* ConstructSignature */  ? factory.createConstructSignature(typeParameters, parameters, returnTypeNode) : kind === 172 /* MethodSignature */  ? factory.createMethodSignature(modifiers, (options == null ? void 0 : options.name) ?? factory.createIdentifier(""), options == null ? void 0 : options.questionToken, typeParameters, parameters, returnTypeNode) : kind === 173 /* MethodDeclaration */  ? factory.createMethodDeclaration(modifiers, /*asteriskToken*/ void 0, (options == null ? void 0 : options.name) ?? factory.createIdentifier(""), /*questionToken*/ void 0, typeParameters, parameters, returnTypeNode, /*body*/ void 0) : kind === 175 /* Constructor */  ? factory.createConstructorDeclaration(modifiers, parameters, /*body*/ void 0) : kind === 176 /* GetAccessor */  ? factory.createGetAccessorDeclaration(modifiers, (options == null ? void 0 : options.name) ?? factory.createIdentifier(""), parameters, returnTypeNode, /*body*/ void 0) : kind === 177 /* SetAccessor */  ? factory.createSetAccessorDeclaration(modifiers, (options == null ? void 0 : options.name) ?? factory.createIdentifier(""), parameters, /*body*/ void 0) : kind === 180 /* IndexSignature */  ? factory.createIndexSignature(modifiers, parameters, returnTypeNode) : kind === 323 /* JSDocFunctionType */  ? factory.createJSDocFunctionType(parameters, returnTypeNode) : kind === 183 /* FunctionType */  ? factory.createFunctionTypeNode(typeParameters, parameters, returnTypeNode ?? factory.createTypeReferenceNode(factory.createIdentifier(""))) : kind === 184 /* ConstructorType */  ? factory.createConstructorTypeNode(modifiers, typeParameters, parameters, returnTypeNode ?? factory.createTypeReferenceNode(factory.createIdentifier(""))) : kind === 261 /* FunctionDeclaration */  ? factory.createFunctionDeclaration(modifiers, /*asteriskToken*/ void 0, (options == null ? void 0 : options.name) ? cast(options.name, isIdentifier) : factory.createIdentifier(""), typeParameters, parameters, returnTypeNode, /*body*/ void 0) : kind === 217 /* FunctionExpression */  ? factory.createFunctionExpression(modifiers, /*asteriskToken*/ void 0, (options == null ? void 0 : options.name) ? cast(options.name, isIdentifier) : factory.createIdentifier(""), typeParameters, parameters, returnTypeNode, factory.createBlock([])) : kind === 218 /* ArrowFunction */  ? factory.createArrowFunction(modifiers, typeParameters, parameters, returnTypeNode, /*equalsGreaterThanToken*/ void 0, factory.createBlock([])) : Debug.assertNever(kind);
                if (typeArguments) node.typeArguments = factory.createNodeArray(typeArguments);
                cleanup == null || cleanup();
                return node;
            }
            function tryGetThisParameterDeclaration(signature, context) {
                if (signature.thisParameter) return symbolToParameterDeclaration(signature.thisParameter, context);
                if (signature.declaration && isInJSFile(signature.declaration)) {
                    const thisTag = getJSDocThisTag(signature.declaration);
                    if (thisTag && thisTag.typeExpression) return factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "this", /*questionToken*/ void 0, typeToTypeNodeHelper(getTypeFromTypeNode(thisTag.typeExpression), context));
                }
            }
            function typeParameterToDeclarationWithConstraint(type, context, constraintNode) {
                const savedContextFlags = context.flags;
                context.flags &= -513 /* WriteTypeParametersInQualifiedName */ ;
                const modifiers = factory.createModifiersFromModifierFlags(getTypeParameterModifiers(type));
                const name = typeParameterToName(type, context);
                const defaultParameter = getDefaultFromTypeParameter(type);
                const defaultParameterNode = defaultParameter && typeToTypeNodeHelper(defaultParameter, context);
                context.flags = savedContextFlags;
                return factory.createTypeParameterDeclaration(modifiers, name, constraintNode, defaultParameterNode);
            }
            function typeParameterToDeclaration(type, context, constraint = getConstraintOfTypeParameter(type)) {
                const constraintNode = constraint && typeToTypeNodeHelper(constraint, context);
                return typeParameterToDeclarationWithConstraint(type, context, constraintNode);
            }
            function symbolToParameterDeclaration(parameterSymbol, context, preserveModifierFlags, privateSymbolVisitor, bundledImports) {
                let parameterDeclaration = getDeclarationOfKind(parameterSymbol, 168 /* Parameter */ );
                if (!parameterDeclaration && !isTransientSymbol(parameterSymbol)) parameterDeclaration = getDeclarationOfKind(parameterSymbol, 347 /* JSDocParameterTag */ );
                let parameterType = getTypeOfSymbol(parameterSymbol);
                if (parameterDeclaration && isRequiredInitializedParameter(parameterDeclaration)) parameterType = getOptionalType(parameterType);
                const parameterTypeNode = serializeTypeForDeclaration(context, parameterType, parameterSymbol, context.enclosingDeclaration, privateSymbolVisitor, bundledImports);
                const modifiers = !(context.flags & 8192 /* OmitParameterModifiers */ ) && preserveModifierFlags && parameterDeclaration && canHaveModifiers(parameterDeclaration) ? map(getModifiers(parameterDeclaration), factory.cloneNode) : void 0;
                const isRest = parameterDeclaration && isRestParameter(parameterDeclaration) || getCheckFlags(parameterSymbol) & 32768 /* RestParameter */ ;
                const dotDotDotToken = isRest ? factory.createToken(26 /* DotDotDotToken */ ) : void 0;
                const name = parameterDeclaration ? parameterDeclaration.name ? parameterDeclaration.name.kind === 80 /* Identifier */  ? setEmitFlags(factory.cloneNode(parameterDeclaration.name), 16777216 /* NoAsciiEscaping */ ) : parameterDeclaration.name.kind === 165 /* QualifiedName */  ? setEmitFlags(factory.cloneNode(parameterDeclaration.name.right), 16777216 /* NoAsciiEscaping */ ) : cloneBindingName(parameterDeclaration.name) : symbolName(parameterSymbol) : symbolName(parameterSymbol);
                const isOptional = parameterDeclaration && isOptionalParameter(parameterDeclaration) || getCheckFlags(parameterSymbol) & 16384 /* OptionalParameter */ ;
                const questionToken = isOptional ? factory.createToken(58 /* QuestionToken */ ) : void 0;
                const parameterNode = factory.createParameterDeclaration(modifiers, dotDotDotToken, name, questionToken, parameterTypeNode, /*initializer*/ void 0);
                context.approximateLength += symbolName(parameterSymbol).length + 3;
                return parameterNode;
                function cloneBindingName(node) {
                    return elideInitializerAndSetEmitFlags(node);
                    function elideInitializerAndSetEmitFlags(node2) {
                        if (context.tracker.canTrackSymbol && isComputedPropertyName(node2) && isLateBindableName(node2)) trackComputedName(node2.expression, context.enclosingDeclaration, context);
                        let visited = visitEachChild(node2, elideInitializerAndSetEmitFlags, nullTransformationContext, /*nodesVisitor*/ void 0, elideInitializerAndSetEmitFlags);
                        if (isBindingElement(visited)) visited = factory.updateBindingElement(visited, visited.dotDotDotToken, visited.propertyName, visited.name, /*initializer*/ void 0);
                        if (!nodeIsSynthesized(visited)) visited = factory.cloneNode(visited);
                        return setEmitFlags(visited, 16777217 /* NoAsciiEscaping */ );
                    }
                }
            }
            function trackComputedName(accessExpression, enclosingDeclaration, context) {
                if (!context.tracker.canTrackSymbol) return;
                const firstIdentifier = getFirstIdentifier(accessExpression);
                const name = resolveName(firstIdentifier, firstIdentifier.escapedText, 1160127 /* ExportValue */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ true);
                if (name) context.tracker.trackSymbol(name, enclosingDeclaration, 111551 /* Value */ );
            }
            function lookupSymbolChain(symbol, context, meaning, yieldModuleSymbol) {
                context.tracker.trackSymbol(symbol, context.enclosingDeclaration, meaning);
                return lookupSymbolChainWorker(symbol, context, meaning, yieldModuleSymbol);
            }
            function lookupSymbolChainWorker(symbol, context, meaning, yieldModuleSymbol) {
                let chain;
                const isTypeParameter = symbol.flags & 262144 /* TypeParameter */ ;
                if (!isTypeParameter && (context.enclosingDeclaration || context.flags & 64 /* UseFullyQualifiedType */ ) && !(context.flags & 134217728 /* DoNotIncludeSymbolChain */ )) {
                    chain = Debug.checkDefined(getSymbolChain(symbol, meaning, /*endOfChain*/ true));
                    Debug.assert(chain && chain.length > 0);
                } else chain = [
                    symbol
                ];
                return chain;
                function getSymbolChain(symbol2, meaning2, endOfChain) {
                    let accessibleSymbolChain = getAccessibleSymbolChain(symbol2, context.enclosingDeclaration, meaning2, !!(context.flags & 128 /* UseOnlyExternalAliasing */ ));
                    let parentSpecifiers;
                    if (!accessibleSymbolChain || needsQualification(accessibleSymbolChain[0], context.enclosingDeclaration, accessibleSymbolChain.length === 1 ? meaning2 : getQualifiedLeftMeaning(meaning2))) {
                        const parents = getContainersOfSymbol(accessibleSymbolChain ? accessibleSymbolChain[0] : symbol2, context.enclosingDeclaration, meaning2);
                        if (length(parents)) {
                            parentSpecifiers = parents.map((symbol3)=>some(symbol3.declarations, hasNonGlobalAugmentationExternalModuleSymbol) ? getSpecifierForModuleSymbol(symbol3, context) : void 0);
                            const indices = parents.map((_, i)=>i);
                            indices.sort(sortByBestName);
                            const sortedParents = indices.map((i)=>parents[i]);
                            for (const parent2 of sortedParents){
                                const parentChain = getSymbolChain(parent2, getQualifiedLeftMeaning(meaning2), /*endOfChain*/ false);
                                if (parentChain) {
                                    if (parent2.exports && parent2.exports.get("export=" /* ExportEquals */ ) && getSymbolIfSameReference(parent2.exports.get("export=" /* ExportEquals */ ), symbol2)) {
                                        accessibleSymbolChain = parentChain;
                                        break;
                                    }
                                    accessibleSymbolChain = parentChain.concat(accessibleSymbolChain || [
                                        getAliasForSymbolInContainer(parent2, symbol2) || symbol2
                                    ]);
                                    break;
                                }
                            }
                        }
                    }
                    if (accessibleSymbolChain) return accessibleSymbolChain;
                    if (// If this is the last part of outputting the symbol, always output. The cases apply only to parent symbols.
                    endOfChain || // If a parent symbol is an anonymous type, don't write it.
                    !(symbol2.flags & 6144 /* ObjectLiteral */ )) {
                        if (!endOfChain && !yieldModuleSymbol && !!forEach(symbol2.declarations, hasNonGlobalAugmentationExternalModuleSymbol)) return;
                        return [
                            symbol2
                        ];
                    }
                    function sortByBestName(a, b) {
                        const specifierA = parentSpecifiers[a];
                        const specifierB = parentSpecifiers[b];
                        if (specifierA && specifierB) {
                            const isBRelative = pathIsRelative(specifierB);
                            if (pathIsRelative(specifierA) === isBRelative) return countPathComponents(specifierA) - countPathComponents(specifierB);
                            if (isBRelative) return -1;
                            return 1;
                        }
                        return 0;
                    }
                }
            }
            function typeParametersToTypeParameterDeclarations(symbol, context) {
                let typeParameterNodes;
                const targetSymbol = getTargetSymbol(symbol);
                if (targetSymbol.flags & 524384 /* TypeAlias */ ) typeParameterNodes = factory.createNodeArray(map(getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol), (tp)=>typeParameterToDeclaration(tp, context)));
                return typeParameterNodes;
            }
            function lookupTypeParameterNodes(chain, index, context) {
                var _a;
                Debug.assert(chain && 0 <= index && index < chain.length);
                const symbol = chain[index];
                const symbolId = getSymbolId(symbol);
                if ((_a = context.typeParameterSymbolList) == null ? void 0 : _a.has(symbolId)) return void 0;
                (context.typeParameterSymbolList || (context.typeParameterSymbolList = /* @__PURE__ */ new Set())).add(symbolId);
                let typeParameterNodes;
                if (context.flags & 512 /* WriteTypeParametersInQualifiedName */  && index < chain.length - 1) {
                    const parentSymbol = symbol;
                    const nextSymbol = chain[index + 1];
                    if (getCheckFlags(nextSymbol) & 1 /* Instantiated */ ) {
                        const params = getTypeParametersOfClassOrInterface(parentSymbol.flags & 2097152 /* Alias */  ? resolveAlias(parentSymbol) : parentSymbol);
                        typeParameterNodes = mapToTypeNodes(map(params, (t)=>getMappedType(t, nextSymbol.links.mapper)), context);
                    } else typeParameterNodes = typeParametersToTypeParameterDeclarations(symbol, context);
                }
                return typeParameterNodes;
            }
            function getTopmostIndexedAccessType(top) {
                if (isIndexedAccessTypeNode(top.objectType)) return getTopmostIndexedAccessType(top.objectType);
                return top;
            }
            function getSpecifierForModuleSymbol(symbol, context, overrideImportMode) {
                let file = getDeclarationOfKind(symbol, 311 /* SourceFile */ );
                if (!file) {
                    const equivalentFileSymbol = firstDefined(symbol.declarations, (d)=>getFileSymbolIfFileSymbolExportEqualsContainer(d, symbol));
                    if (equivalentFileSymbol) file = getDeclarationOfKind(equivalentFileSymbol, 311 /* SourceFile */ );
                }
                if (file && file.moduleName !== void 0) return file.moduleName;
                if (!file) {
                    if (context.tracker.trackReferencedAmbientModule) {
                        const ambientDecls = filter(symbol.declarations, isAmbientModule);
                        if (length(ambientDecls)) for (const decl of ambientDecls)context.tracker.trackReferencedAmbientModule(decl, symbol);
                    }
                    if (ambientModuleSymbolRegex.test(symbol.escapedName)) return symbol.escapedName.substring(1, symbol.escapedName.length - 1);
                }
                if (!context.enclosingDeclaration || !context.tracker.moduleResolverHost) {
                    if (ambientModuleSymbolRegex.test(symbol.escapedName)) return symbol.escapedName.substring(1, symbol.escapedName.length - 1);
                    return getSourceFileOfNode(getNonAugmentationDeclaration(symbol)).fileName;
                }
                const contextFile = getSourceFileOfNode(getOriginalNode(context.enclosingDeclaration));
                const resolutionMode = overrideImportMode || (contextFile == null ? void 0 : contextFile.impliedNodeFormat);
                const cacheKey = createModeAwareCacheKey(contextFile.path, resolutionMode);
                const links = getSymbolLinks(symbol);
                let specifier = links.specifierCache && links.specifierCache.get(cacheKey);
                if (!specifier) {
                    const isBundle2 = !!outFile(compilerOptions);
                    const { moduleResolverHost: moduleResolverHost  } = context.tracker;
                    const specifierCompilerOptions = isBundle2 ? {
                        ...compilerOptions,
                        baseUrl: moduleResolverHost.getCommonSourceDirectory()
                    } : compilerOptions;
                    specifier = first(getModuleSpecifiers(symbol, checker, specifierCompilerOptions, contextFile, moduleResolverHost, {
                        importModuleSpecifierPreference: isBundle2 ? "non-relative" : "project-relative",
                        importModuleSpecifierEnding: isBundle2 ? "minimal" : resolutionMode === 99 /* ESNext */  ? "js" : void 0
                    }, {
                        overrideImportMode: overrideImportMode
                    }));
                    links.specifierCache ?? (links.specifierCache = /* @__PURE__ */ new Map());
                    links.specifierCache.set(cacheKey, specifier);
                }
                return specifier;
            }
            function symbolToEntityNameNode(symbol) {
                const identifier = factory.createIdentifier(unescapeLeadingUnderscores(symbol.escapedName));
                return symbol.parent ? factory.createQualifiedName(symbolToEntityNameNode(symbol.parent), identifier) : identifier;
            }
            function symbolToTypeNode(symbol, context, meaning, overrideTypeArguments) {
                var _a, _b, _c, _d;
                const chain = lookupSymbolChain(symbol, context, meaning, !(context.flags & 16384 /* UseAliasDefinedOutsideCurrentScope */ ));
                const isTypeOf = meaning === 111551 /* Value */ ;
                if (some(chain[0].declarations, hasNonGlobalAugmentationExternalModuleSymbol)) {
                    const nonRootParts = chain.length > 1 ? createAccessFromSymbolChain(chain, chain.length - 1, 1) : void 0;
                    const typeParameterNodes = overrideTypeArguments || lookupTypeParameterNodes(chain, 0, context);
                    const contextFile = getSourceFileOfNode(getOriginalNode(context.enclosingDeclaration));
                    const targetFile = getSourceFileOfModule(chain[0]);
                    let specifier;
                    let assertion;
                    if (getEmitModuleResolutionKind(compilerOptions) === 3 /* Node16 */  || getEmitModuleResolutionKind(compilerOptions) === 99 /* NodeNext */ ) {
                        if ((targetFile == null ? void 0 : targetFile.impliedNodeFormat) === 99 /* ESNext */  && targetFile.impliedNodeFormat !== (contextFile == null ? void 0 : contextFile.impliedNodeFormat)) {
                            specifier = getSpecifierForModuleSymbol(chain[0], context, 99 /* ESNext */ );
                            assertion = factory.createImportTypeAssertionContainer(factory.createAssertClause(factory.createNodeArray([
                                factory.createAssertEntry(factory.createStringLiteral("resolution-mode"), factory.createStringLiteral("import"))
                            ])));
                            (_b = (_a = context.tracker).reportImportTypeNodeResolutionModeOverride) == null || _b.call(_a);
                        }
                    }
                    if (!specifier) specifier = getSpecifierForModuleSymbol(chain[0], context);
                    if (!(context.flags & 67108864 /* AllowNodeModulesRelativePaths */ ) && getEmitModuleResolutionKind(compilerOptions) !== 1 /* Classic */  && specifier.indexOf("/node_modules/") >= 0) {
                        const oldSpecifier = specifier;
                        if (getEmitModuleResolutionKind(compilerOptions) === 3 /* Node16 */  || getEmitModuleResolutionKind(compilerOptions) === 99 /* NodeNext */ ) {
                            const swappedMode = (contextFile == null ? void 0 : contextFile.impliedNodeFormat) === 99 /* ESNext */  ? 1 /* CommonJS */  : 99 /* ESNext */ ;
                            specifier = getSpecifierForModuleSymbol(chain[0], context, swappedMode);
                            if (specifier.indexOf("/node_modules/") >= 0) specifier = oldSpecifier;
                            else {
                                assertion = factory.createImportTypeAssertionContainer(factory.createAssertClause(factory.createNodeArray([
                                    factory.createAssertEntry(factory.createStringLiteral("resolution-mode"), factory.createStringLiteral(swappedMode === 99 /* ESNext */  ? "import" : "require"))
                                ])));
                                (_d = (_c = context.tracker).reportImportTypeNodeResolutionModeOverride) == null || _d.call(_c);
                            }
                        }
                        if (!assertion) {
                            context.encounteredError = true;
                            if (context.tracker.reportLikelyUnsafeImportRequiredError) context.tracker.reportLikelyUnsafeImportRequiredError(oldSpecifier);
                        }
                    }
                    const lit = factory.createLiteralTypeNode(factory.createStringLiteral(specifier));
                    if (context.tracker.trackExternalModuleSymbolOfImportTypeNode) context.tracker.trackExternalModuleSymbolOfImportTypeNode(chain[0]);
                    context.approximateLength += specifier.length + 10;
                    if (!nonRootParts || isEntityName(nonRootParts)) {
                        if (nonRootParts) {
                            const lastId = isIdentifier(nonRootParts) ? nonRootParts : nonRootParts.right;
                            setIdentifierTypeArguments(lastId, /*typeArguments*/ void 0);
                        }
                        return factory.createImportTypeNode(lit, assertion, nonRootParts, typeParameterNodes, isTypeOf);
                    } else {
                        const splitNode = getTopmostIndexedAccessType(nonRootParts);
                        const qualifier = splitNode.objectType.typeName;
                        return factory.createIndexedAccessTypeNode(factory.createImportTypeNode(lit, assertion, qualifier, typeParameterNodes, isTypeOf), splitNode.indexType);
                    }
                }
                const entityName = createAccessFromSymbolChain(chain, chain.length - 1, 0);
                if (isIndexedAccessTypeNode(entityName)) return entityName;
                if (isTypeOf) return factory.createTypeQueryNode(entityName);
                else {
                    const lastId = isIdentifier(entityName) ? entityName : entityName.right;
                    const lastTypeArgs = getIdentifierTypeArguments(lastId);
                    setIdentifierTypeArguments(lastId, /*typeArguments*/ void 0);
                    return factory.createTypeReferenceNode(entityName, lastTypeArgs);
                }
                function createAccessFromSymbolChain(chain2, index, stopper) {
                    const typeParameterNodes = index === chain2.length - 1 ? overrideTypeArguments : lookupTypeParameterNodes(chain2, index, context);
                    const symbol2 = chain2[index];
                    const parent2 = chain2[index - 1];
                    let symbolName2;
                    if (index === 0) {
                        context.flags |= 16777216 /* InInitialEntityName */ ;
                        symbolName2 = getNameOfSymbolAsWritten(symbol2, context);
                        context.approximateLength += (symbolName2 ? symbolName2.length : 0) + 1;
                        context.flags ^= 16777216 /* InInitialEntityName */ ;
                    } else if (parent2 && getExportsOfSymbol(parent2)) {
                        const exports = getExportsOfSymbol(parent2);
                        forEachEntry(exports, (ex, name)=>{
                            if (getSymbolIfSameReference(ex, symbol2) && !isLateBoundName(name) && name !== "export=" /* ExportEquals */ ) {
                                symbolName2 = unescapeLeadingUnderscores(name);
                                return true;
                            }
                        });
                    }
                    if (symbolName2 === void 0) {
                        const name = firstDefined(symbol2.declarations, getNameOfDeclaration);
                        if (name && isComputedPropertyName(name) && isEntityName(name.expression)) {
                            const LHS = createAccessFromSymbolChain(chain2, index - 1, stopper);
                            if (isEntityName(LHS)) return factory.createIndexedAccessTypeNode(factory.createParenthesizedType(factory.createTypeQueryNode(LHS)), factory.createTypeQueryNode(name.expression));
                            return LHS;
                        }
                        symbolName2 = getNameOfSymbolAsWritten(symbol2, context);
                    }
                    context.approximateLength += symbolName2.length + 1;
                    if (!(context.flags & 16 /* ForbidIndexedAccessSymbolReferences */ ) && parent2 && getMembersOfSymbol(parent2) && getMembersOfSymbol(parent2).get(symbol2.escapedName) && getSymbolIfSameReference(getMembersOfSymbol(parent2).get(symbol2.escapedName), symbol2)) {
                        const LHS = createAccessFromSymbolChain(chain2, index - 1, stopper);
                        if (isIndexedAccessTypeNode(LHS)) return factory.createIndexedAccessTypeNode(LHS, factory.createLiteralTypeNode(factory.createStringLiteral(symbolName2)));
                        else return factory.createIndexedAccessTypeNode(factory.createTypeReferenceNode(LHS, typeParameterNodes), factory.createLiteralTypeNode(factory.createStringLiteral(symbolName2)));
                    }
                    const identifier = setEmitFlags(factory.createIdentifier(symbolName2), 16777216 /* NoAsciiEscaping */ );
                    if (typeParameterNodes) setIdentifierTypeArguments(identifier, factory.createNodeArray(typeParameterNodes));
                    identifier.symbol = symbol2;
                    if (index > stopper) {
                        const LHS = createAccessFromSymbolChain(chain2, index - 1, stopper);
                        if (!isEntityName(LHS)) return Debug.fail("Impossible construct - an export of an indexed access cannot be reachable");
                        return factory.createQualifiedName(LHS, identifier);
                    }
                    return identifier;
                }
            }
            function typeParameterShadowsNameInScope(escapedName, context, type) {
                const result = resolveName(context.enclosingDeclaration, escapedName, 788968 /* Type */ , /*nameNotFoundMessage*/ void 0, escapedName, /*isUse*/ false);
                if (result) {
                    if (result.flags & 262144 /* TypeParameter */  && result === type.symbol) return false;
                    return true;
                }
                return false;
            }
            function typeParameterToName(type, context) {
                var _a, _b;
                if (context.flags & 4 /* GenerateNamesForShadowedTypeParams */  && context.typeParameterNames) {
                    const cached = context.typeParameterNames.get(getTypeId(type));
                    if (cached) return cached;
                }
                let result = symbolToName(type.symbol, context, 788968 /* Type */ , /*expectsIdentifier*/ true);
                if (!(result.kind & 80 /* Identifier */ )) return factory.createIdentifier("(Missing type parameter)");
                if (context.flags & 4 /* GenerateNamesForShadowedTypeParams */ ) {
                    const rawtext = result.escapedText;
                    let i = ((_a = context.typeParameterNamesByTextNextNameCount) == null ? void 0 : _a.get(rawtext)) || 0;
                    let text = rawtext;
                    while(((_b = context.typeParameterNamesByText) == null ? void 0 : _b.has(text)) || typeParameterShadowsNameInScope(text, context, type)){
                        i++;
                        text = `${rawtext}_${i}`;
                    }
                    if (text !== rawtext) {
                        const typeArguments = getIdentifierTypeArguments(result);
                        result = factory.createIdentifier(text);
                        setIdentifierTypeArguments(result, typeArguments);
                    }
                    (context.typeParameterNamesByTextNextNameCount || (context.typeParameterNamesByTextNextNameCount = /* @__PURE__ */ new Map())).set(rawtext, i);
                    (context.typeParameterNames || (context.typeParameterNames = /* @__PURE__ */ new Map())).set(getTypeId(type), result);
                    (context.typeParameterNamesByText || (context.typeParameterNamesByText = /* @__PURE__ */ new Set())).add(rawtext);
                }
                return result;
            }
            function symbolToName(symbol, context, meaning, expectsIdentifier) {
                const chain = lookupSymbolChain(symbol, context, meaning);
                if (expectsIdentifier && chain.length !== 1 && !context.encounteredError && !(context.flags & 65536 /* AllowQualifiedNameInPlaceOfIdentifier */ )) context.encounteredError = true;
                return createEntityNameFromSymbolChain(chain, chain.length - 1);
                function createEntityNameFromSymbolChain(chain2, index) {
                    const typeParameterNodes = lookupTypeParameterNodes(chain2, index, context);
                    const symbol2 = chain2[index];
                    if (index === 0) context.flags |= 16777216 /* InInitialEntityName */ ;
                    const symbolName2 = getNameOfSymbolAsWritten(symbol2, context);
                    if (index === 0) context.flags ^= 16777216 /* InInitialEntityName */ ;
                    const identifier = setEmitFlags(factory.createIdentifier(symbolName2), 16777216 /* NoAsciiEscaping */ );
                    if (typeParameterNodes) setIdentifierTypeArguments(identifier, factory.createNodeArray(typeParameterNodes));
                    identifier.symbol = symbol2;
                    return index > 0 ? factory.createQualifiedName(createEntityNameFromSymbolChain(chain2, index - 1), identifier) : identifier;
                }
            }
            function symbolToExpression(symbol, context, meaning) {
                const chain = lookupSymbolChain(symbol, context, meaning);
                return createExpressionFromSymbolChain(chain, chain.length - 1);
                function createExpressionFromSymbolChain(chain2, index) {
                    const typeParameterNodes = lookupTypeParameterNodes(chain2, index, context);
                    const symbol2 = chain2[index];
                    if (index === 0) context.flags |= 16777216 /* InInitialEntityName */ ;
                    let symbolName2 = getNameOfSymbolAsWritten(symbol2, context);
                    if (index === 0) context.flags ^= 16777216 /* InInitialEntityName */ ;
                    let firstChar = symbolName2.charCodeAt(0);
                    if (isSingleOrDoubleQuote(firstChar) && some(symbol2.declarations, hasNonGlobalAugmentationExternalModuleSymbol)) return factory.createStringLiteral(getSpecifierForModuleSymbol(symbol2, context));
                    if (index === 0 || canUsePropertyAccess(symbolName2, languageVersion)) {
                        const identifier = setEmitFlags(factory.createIdentifier(symbolName2), 16777216 /* NoAsciiEscaping */ );
                        if (typeParameterNodes) setIdentifierTypeArguments(identifier, factory.createNodeArray(typeParameterNodes));
                        identifier.symbol = symbol2;
                        return index > 0 ? factory.createPropertyAccessExpression(createExpressionFromSymbolChain(chain2, index - 1), identifier) : identifier;
                    } else {
                        if (firstChar === 91 /* openBracket */ ) {
                            symbolName2 = symbolName2.substring(1, symbolName2.length - 1);
                            firstChar = symbolName2.charCodeAt(0);
                        }
                        let expression;
                        if (isSingleOrDoubleQuote(firstChar) && !(symbol2.flags & 8 /* EnumMember */ )) expression = factory.createStringLiteral(stripQuotes(symbolName2).replace(/\\./g, (s)=>s.substring(1)), firstChar === 39 /* singleQuote */ );
                        else if ("" + +symbolName2 === symbolName2) expression = factory.createNumericLiteral(+symbolName2);
                        if (!expression) {
                            const identifier = setEmitFlags(factory.createIdentifier(symbolName2), 16777216 /* NoAsciiEscaping */ );
                            if (typeParameterNodes) setIdentifierTypeArguments(identifier, factory.createNodeArray(typeParameterNodes));
                            identifier.symbol = symbol2;
                            expression = identifier;
                        }
                        return factory.createElementAccessExpression(createExpressionFromSymbolChain(chain2, index - 1), expression);
                    }
                }
            }
            function isStringNamed(d) {
                const name = getNameOfDeclaration(d);
                return !!name && isStringLiteral(name);
            }
            function isSingleQuotedStringNamed(d) {
                const name = getNameOfDeclaration(d);
                return !!(name && isStringLiteral(name) && (name.singleQuote || !nodeIsSynthesized(name) && startsWith(getTextOfNode(name, /*includeTrivia*/ false), "'")));
            }
            function getPropertyNameNodeForSymbol(symbol, context) {
                const stringNamed = !!length(symbol.declarations) && every(symbol.declarations, isStringNamed);
                const singleQuote = !!length(symbol.declarations) && every(symbol.declarations, isSingleQuotedStringNamed);
                const fromNameType = getPropertyNameNodeForSymbolFromNameType(symbol, context, singleQuote, stringNamed);
                if (fromNameType) return fromNameType;
                const rawName = unescapeLeadingUnderscores(symbol.escapedName);
                return createPropertyNameNodeForIdentifierOrLiteral(rawName, getEmitScriptTarget(compilerOptions), singleQuote, stringNamed);
            }
            function getPropertyNameNodeForSymbolFromNameType(symbol, context, singleQuote, stringNamed) {
                const nameType = getSymbolLinks(symbol).nameType;
                if (nameType) {
                    if (nameType.flags & 384 /* StringOrNumberLiteral */ ) {
                        const name = "" + nameType.value;
                        if (!isIdentifierText(name, getEmitScriptTarget(compilerOptions)) && (stringNamed || !isNumericLiteralName(name))) return factory.createStringLiteral(name, !!singleQuote);
                        if (isNumericLiteralName(name) && startsWith(name, "-")) return factory.createComputedPropertyName(factory.createNumericLiteral(+name));
                        return createPropertyNameNodeForIdentifierOrLiteral(name, getEmitScriptTarget(compilerOptions));
                    }
                    if (nameType.flags & 8192 /* UniqueESSymbol */ ) return factory.createComputedPropertyName(symbolToExpression(nameType.symbol, context, 111551 /* Value */ ));
                }
            }
            function cloneNodeBuilderContext(context) {
                const initial = {
                    ...context
                };
                if (initial.typeParameterNames) initial.typeParameterNames = new Map(initial.typeParameterNames);
                if (initial.typeParameterNamesByText) initial.typeParameterNamesByText = new Set(initial.typeParameterNamesByText);
                if (initial.typeParameterSymbolList) initial.typeParameterSymbolList = new Set(initial.typeParameterSymbolList);
                initial.tracker = new SymbolTrackerImpl(initial, initial.tracker.inner, initial.tracker.moduleResolverHost);
                return initial;
            }
            function getDeclarationWithTypeAnnotation(symbol, enclosingDeclaration) {
                return symbol.declarations && find(symbol.declarations, (s)=>!!getEffectiveTypeAnnotationNode(s) && (!enclosingDeclaration || !!findAncestor(s, (n)=>n === enclosingDeclaration)));
            }
            function existingTypeNodeIsNotReferenceOrIsReferenceWithCompatibleTypeArgumentCount(existing, type) {
                return !(getObjectFlags(type) & 4 /* Reference */ ) || !isTypeReferenceNode(existing) || length(existing.typeArguments) >= getMinTypeArgumentCount(type.target.typeParameters);
            }
            function getEnclosingDeclarationIgnoringFakeScope(enclosingDeclaration) {
                return getNodeLinks(enclosingDeclaration).fakeScopeForSignatureDeclaration ? enclosingDeclaration.parent : enclosingDeclaration;
            }
            function serializeTypeForDeclaration(context, type, symbol, enclosingDeclaration, includePrivateSymbol, bundled) {
                if (!isErrorType(type) && enclosingDeclaration) {
                    const declWithExistingAnnotation = getDeclarationWithTypeAnnotation(symbol, getEnclosingDeclarationIgnoringFakeScope(enclosingDeclaration));
                    if (declWithExistingAnnotation && !isFunctionLikeDeclaration(declWithExistingAnnotation) && !isGetAccessorDeclaration(declWithExistingAnnotation)) {
                        const existing = getEffectiveTypeAnnotationNode(declWithExistingAnnotation);
                        if (typeNodeIsEquivalentToType(existing, declWithExistingAnnotation, type) && existingTypeNodeIsNotReferenceOrIsReferenceWithCompatibleTypeArgumentCount(existing, type)) {
                            const result2 = serializeExistingTypeNode(context, existing, includePrivateSymbol, bundled);
                            if (result2) return result2;
                        }
                    }
                }
                const oldFlags = context.flags;
                if (type.flags & 8192 /* UniqueESSymbol */  && type.symbol === symbol && (!context.enclosingDeclaration || some(symbol.declarations, (d)=>getSourceFileOfNode(d) === getSourceFileOfNode(context.enclosingDeclaration)))) context.flags |= 1048576 /* AllowUniqueESSymbolType */ ;
                const result = typeToTypeNodeHelper(type, context);
                context.flags = oldFlags;
                return result;
            }
            function typeNodeIsEquivalentToType(typeNode, annotatedDeclaration, type) {
                const typeFromTypeNode = getTypeFromTypeNode(typeNode);
                if (typeFromTypeNode === type) return true;
                if (isParameter(annotatedDeclaration) && annotatedDeclaration.questionToken) return getTypeWithFacts(type, 524288 /* NEUndefined */ ) === typeFromTypeNode;
                return false;
            }
            function serializeReturnTypeForSignature(context, type, signature, includePrivateSymbol, bundled) {
                if (!isErrorType(type) && context.enclosingDeclaration) {
                    const annotation = signature.declaration && getEffectiveReturnTypeNode(signature.declaration);
                    const enclosingDeclarationIgnoringFakeScope = getEnclosingDeclarationIgnoringFakeScope(context.enclosingDeclaration);
                    if (!!findAncestor(annotation, (n)=>n === enclosingDeclarationIgnoringFakeScope) && annotation) {
                        const annotated = getTypeFromTypeNode(annotation);
                        const thisInstantiated = annotated.flags & 262144 /* TypeParameter */  && annotated.isThisType ? instantiateType(annotated, signature.mapper) : annotated;
                        if (thisInstantiated === type && existingTypeNodeIsNotReferenceOrIsReferenceWithCompatibleTypeArgumentCount(annotation, type)) {
                            const result = serializeExistingTypeNode(context, annotation, includePrivateSymbol, bundled);
                            if (result) return result;
                        }
                    }
                }
                return typeToTypeNodeHelper(type, context);
            }
            function trackExistingEntityName(node, context, includePrivateSymbol) {
                let introducesError = false;
                const leftmost = getFirstIdentifier(node);
                if (isInJSFile(node) && (isExportsIdentifier(leftmost) || isModuleExportsAccessExpression(leftmost.parent) || isQualifiedName(leftmost.parent) && isModuleIdentifier(leftmost.parent.left) && isExportsIdentifier(leftmost.parent.right))) {
                    introducesError = true;
                    return {
                        introducesError: introducesError,
                        node: node
                    };
                }
                const sym = resolveEntityName(leftmost, 67108863 /* All */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true);
                if (sym) {
                    if (isSymbolAccessible(sym, context.enclosingDeclaration, 67108863 /* All */ , /*shouldComputeAliasesToMakeVisible*/ false).accessibility !== 0 /* Accessible */ ) introducesError = true;
                    else {
                        context.tracker.trackSymbol(sym, context.enclosingDeclaration, 67108863 /* All */ );
                        includePrivateSymbol == null || includePrivateSymbol(sym);
                    }
                    if (isIdentifier(node)) {
                        const type = getDeclaredTypeOfSymbol(sym);
                        const name = sym.flags & 262144 /* TypeParameter */  && !isTypeSymbolAccessible(type.symbol, context.enclosingDeclaration) ? typeParameterToName(type, context) : factory.cloneNode(node);
                        name.symbol = sym;
                        return {
                            introducesError: introducesError,
                            node: setEmitFlags(setOriginalNode(name, node), 16777216 /* NoAsciiEscaping */ )
                        };
                    }
                }
                return {
                    introducesError: introducesError,
                    node: node
                };
            }
            function serializeExistingTypeNode(context, existing, includePrivateSymbol, bundled) {
                if (cancellationToken && cancellationToken.throwIfCancellationRequested) cancellationToken.throwIfCancellationRequested();
                let hadError = false;
                const file = getSourceFileOfNode(existing);
                const transformed = visitNode(existing, visitExistingNodeTreeSymbols, isTypeNode);
                if (hadError) return void 0;
                return transformed === existing ? setTextRange(factory.cloneNode(existing), existing) : transformed;
                function visitExistingNodeTreeSymbols(node) {
                    if (isJSDocAllType(node) || node.kind === 325 /* JSDocNamepathType */ ) return factory.createKeywordTypeNode(133 /* AnyKeyword */ );
                    if (isJSDocUnknownType(node)) return factory.createKeywordTypeNode(159 /* UnknownKeyword */ );
                    if (isJSDocNullableType(node)) return factory.createUnionTypeNode([
                        visitNode(node.type, visitExistingNodeTreeSymbols, isTypeNode),
                        factory.createLiteralTypeNode(factory.createNull())
                    ]);
                    if (isJSDocOptionalType(node)) return factory.createUnionTypeNode([
                        visitNode(node.type, visitExistingNodeTreeSymbols, isTypeNode),
                        factory.createKeywordTypeNode(157 /* UndefinedKeyword */ )
                    ]);
                    if (isJSDocNonNullableType(node)) return visitNode(node.type, visitExistingNodeTreeSymbols);
                    if (isJSDocVariadicType(node)) return factory.createArrayTypeNode(visitNode(node.type, visitExistingNodeTreeSymbols, isTypeNode));
                    if (isJSDocTypeLiteral(node)) return factory.createTypeLiteralNode(map(node.jsDocPropertyTags, (t)=>{
                        const name = isIdentifier(t.name) ? t.name : t.name.right;
                        const typeViaParent = getTypeOfPropertyOfType(getTypeFromTypeNode(node), name.escapedText);
                        const overrideTypeNode = typeViaParent && t.typeExpression && getTypeFromTypeNode(t.typeExpression.type) !== typeViaParent ? typeToTypeNodeHelper(typeViaParent, context) : void 0;
                        return factory.createPropertySignature(/*modifiers*/ void 0, name, t.isBracketed || t.typeExpression && isJSDocOptionalType(t.typeExpression.type) ? factory.createToken(58 /* QuestionToken */ ) : void 0, overrideTypeNode || t.typeExpression && visitNode(t.typeExpression.type, visitExistingNodeTreeSymbols, isTypeNode) || factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
                    }));
                    if (isTypeReferenceNode(node) && isIdentifier(node.typeName) && node.typeName.escapedText === "") return setOriginalNode(factory.createKeywordTypeNode(133 /* AnyKeyword */ ), node);
                    if ((isExpressionWithTypeArguments(node) || isTypeReferenceNode(node)) && isJSDocIndexSignature(node)) return factory.createTypeLiteralNode([
                        factory.createIndexSignature(/*modifiers*/ void 0, [
                            factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "x", /*questionToken*/ void 0, visitNode(node.typeArguments[0], visitExistingNodeTreeSymbols, isTypeNode))
                        ], visitNode(node.typeArguments[1], visitExistingNodeTreeSymbols, isTypeNode))
                    ]);
                    if (isJSDocFunctionType(node)) {
                        if (isJSDocConstructSignature(node)) {
                            let newTypeNode;
                            return factory.createConstructorTypeNode(/*modifiers*/ void 0, visitNodes2(node.typeParameters, visitExistingNodeTreeSymbols, isTypeParameterDeclaration), mapDefined(node.parameters, (p, i)=>p.name && isIdentifier(p.name) && p.name.escapedText === "new" ? (newTypeNode = p.type, void 0) : factory.createParameterDeclaration(/*modifiers*/ void 0, getEffectiveDotDotDotForParameter(p), getNameForJSDocFunctionParameter(p, i), p.questionToken, visitNode(p.type, visitExistingNodeTreeSymbols, isTypeNode), /*initializer*/ void 0)), visitNode(newTypeNode || node.type, visitExistingNodeTreeSymbols, isTypeNode) || factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
                        } else return factory.createFunctionTypeNode(visitNodes2(node.typeParameters, visitExistingNodeTreeSymbols, isTypeParameterDeclaration), map(node.parameters, (p, i)=>factory.createParameterDeclaration(/*modifiers*/ void 0, getEffectiveDotDotDotForParameter(p), getNameForJSDocFunctionParameter(p, i), p.questionToken, visitNode(p.type, visitExistingNodeTreeSymbols, isTypeNode), /*initializer*/ void 0)), visitNode(node.type, visitExistingNodeTreeSymbols, isTypeNode) || factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
                    }
                    if (isTypeReferenceNode(node) && isInJSDoc(node) && (!existingTypeNodeIsNotReferenceOrIsReferenceWithCompatibleTypeArgumentCount(node, getTypeFromTypeNode(node)) || getIntendedTypeFromJSDocTypeReference(node) || unknownSymbol === resolveTypeReferenceName(node, 788968 /* Type */ , /*ignoreErrors*/ true))) return setOriginalNode(typeToTypeNodeHelper(getTypeFromTypeNode(node), context), node);
                    if (isLiteralImportTypeNode(node)) {
                        const nodeSymbol = getNodeLinks(node).resolvedSymbol;
                        if (isInJSDoc(node) && nodeSymbol && // The import type resolved using jsdoc fallback logic
                        (!node.isTypeOf && !(nodeSymbol.flags & 788968 /* Type */ ) || // The import type had type arguments autofilled by js fallback logic
                        !(length(node.typeArguments) >= getMinTypeArgumentCount(getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(nodeSymbol))))) return setOriginalNode(typeToTypeNodeHelper(getTypeFromTypeNode(node), context), node);
                        return factory.updateImportTypeNode(node, factory.updateLiteralTypeNode(node.argument, rewriteModuleSpecifier(node, node.argument.literal)), node.assertions, node.qualifier, visitNodes2(node.typeArguments, visitExistingNodeTreeSymbols, isTypeNode), node.isTypeOf);
                    }
                    if (isEntityName(node) || isEntityNameExpression(node)) {
                        const { introducesError: introducesError , node: result  } = trackExistingEntityName(node, context, includePrivateSymbol);
                        hadError = hadError || introducesError;
                        if (result !== node) return result;
                    }
                    if (file && isTupleTypeNode(node) && getLineAndCharacterOfPosition(file, node.pos).line === getLineAndCharacterOfPosition(file, node.end).line) setEmitFlags(node, 1 /* SingleLine */ );
                    return visitEachChild(node, visitExistingNodeTreeSymbols, nullTransformationContext);
                    function getEffectiveDotDotDotForParameter(p) {
                        return p.dotDotDotToken || (p.type && isJSDocVariadicType(p.type) ? factory.createToken(26 /* DotDotDotToken */ ) : void 0);
                    }
                    function getNameForJSDocFunctionParameter(p, index) {
                        return p.name && isIdentifier(p.name) && p.name.escapedText === "this" ? "this" : getEffectiveDotDotDotForParameter(p) ? `args` : `arg${index}`;
                    }
                    function rewriteModuleSpecifier(parent2, lit) {
                        if (bundled) {
                            if (context.tracker && context.tracker.moduleResolverHost) {
                                const targetFile = getExternalModuleFileFromDeclaration(parent2);
                                if (targetFile) {
                                    const getCanonicalFileName = createGetCanonicalFileName(!!host.useCaseSensitiveFileNames);
                                    const resolverHost = {
                                        getCanonicalFileName: getCanonicalFileName,
                                        getCurrentDirectory: ()=>context.tracker.moduleResolverHost.getCurrentDirectory(),
                                        getCommonSourceDirectory: ()=>context.tracker.moduleResolverHost.getCommonSourceDirectory()
                                    };
                                    const newName = getResolvedExternalModuleName(resolverHost, targetFile);
                                    return factory.createStringLiteral(newName);
                                }
                            }
                        } else if (context.tracker && context.tracker.trackExternalModuleSymbolOfImportTypeNode) {
                            const moduleSym = resolveExternalModuleNameWorker(lit, lit, /*moduleNotFoundError*/ void 0);
                            if (moduleSym) context.tracker.trackExternalModuleSymbolOfImportTypeNode(moduleSym);
                        }
                        return lit;
                    }
                }
            }
            function symbolTableToDeclarationStatements(symbolTable, context, bundled) {
                const serializePropertySymbolForClass = makeSerializePropertySymbol(factory.createPropertyDeclaration, 173 /* MethodDeclaration */ , /*useAccessors*/ true);
                const serializePropertySymbolForInterfaceWorker = makeSerializePropertySymbol((mods, name, question, type)=>factory.createPropertySignature(mods, name, question, type), 172 /* MethodSignature */ , /*useAccessors*/ false);
                const enclosingDeclaration = context.enclosingDeclaration;
                let results = [];
                const visitedSymbols = /* @__PURE__ */ new Set();
                const deferredPrivatesStack = [];
                const oldcontext = context;
                context = {
                    ...oldcontext,
                    usedSymbolNames: new Set(oldcontext.usedSymbolNames),
                    remappedSymbolNames: /* @__PURE__ */ new Map(),
                    tracker: void 0
                };
                const tracker = {
                    ...oldcontext.tracker.inner,
                    trackSymbol: (sym, decl, meaning)=>{
                        var _a;
                        const accessibleResult = isSymbolAccessible(sym, decl, meaning, /*shouldComputeAliasesToMakeVisible*/ false);
                        if (accessibleResult.accessibility === 0 /* Accessible */ ) {
                            const chain = lookupSymbolChainWorker(sym, context, meaning);
                            if (!(sym.flags & 4 /* Property */ )) includePrivateSymbol(chain[0]);
                        } else if ((_a = oldcontext.tracker.inner) == null ? void 0 : _a.trackSymbol) return oldcontext.tracker.inner.trackSymbol(sym, decl, meaning);
                        return false;
                    }
                };
                context.tracker = new SymbolTrackerImpl(context, tracker, oldcontext.tracker.moduleResolverHost);
                forEachEntry(symbolTable, (symbol, name)=>{
                    const baseName = unescapeLeadingUnderscores(name);
                    getInternalSymbolName(symbol, baseName);
                });
                let addingDeclare = !bundled;
                const exportEquals = symbolTable.get("export=" /* ExportEquals */ );
                if (exportEquals && symbolTable.size > 1 && exportEquals.flags & 2097152 /* Alias */ ) {
                    symbolTable = createSymbolTable();
                    symbolTable.set("export=" /* ExportEquals */ , exportEquals);
                }
                visitSymbolTable(symbolTable);
                return mergeRedundantStatements(results);
                function isIdentifierAndNotUndefined(node) {
                    return !!node && node.kind === 80 /* Identifier */ ;
                }
                function getNamesOfDeclaration(statement) {
                    if (isVariableStatement(statement)) return filter(map(statement.declarationList.declarations, getNameOfDeclaration), isIdentifierAndNotUndefined);
                    return filter([
                        getNameOfDeclaration(statement)
                    ], isIdentifierAndNotUndefined);
                }
                function flattenExportAssignedNamespace(statements) {
                    const exportAssignment = find(statements, isExportAssignment);
                    const nsIndex = findIndex(statements, isModuleDeclaration);
                    let ns = nsIndex !== -1 ? statements[nsIndex] : void 0;
                    if (ns && exportAssignment && exportAssignment.isExportEquals && isIdentifier(exportAssignment.expression) && isIdentifier(ns.name) && idText(ns.name) === idText(exportAssignment.expression) && ns.body && isModuleBlock(ns.body)) {
                        const excessExports = filter(statements, (s)=>!!(getEffectiveModifierFlags(s) & 1 /* Export */ ));
                        const name = ns.name;
                        let body = ns.body;
                        if (length(excessExports)) {
                            ns = factory.updateModuleDeclaration(ns, ns.modifiers, ns.name, body = factory.updateModuleBlock(body, factory.createNodeArray([
                                ...ns.body.statements,
                                factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports(map(flatMap(excessExports, (e)=>getNamesOfDeclaration(e)), (id)=>factory.createExportSpecifier(/*isTypeOnly*/ false, /*propertyName*/ void 0, id))), /*moduleSpecifier*/ void 0)
                            ])));
                            statements = [
                                ...statements.slice(0, nsIndex),
                                ns,
                                ...statements.slice(nsIndex + 1)
                            ];
                        }
                        if (!find(statements, (s)=>s !== ns && nodeHasName(s, name))) {
                            results = [];
                            const mixinExportFlag = !some(body.statements, (s)=>hasSyntacticModifier(s, 1 /* Export */ ) || isExportAssignment(s) || isExportDeclaration(s));
                            forEach(body.statements, (s)=>{
                                addResult(s, mixinExportFlag ? 1 /* Export */  : 0 /* None */ );
                            });
                            statements = [
                                ...filter(statements, (s)=>s !== ns && s !== exportAssignment),
                                ...results
                            ];
                        }
                    }
                    return statements;
                }
                function mergeExportDeclarations(statements) {
                    const exports = filter(statements, (d)=>isExportDeclaration(d) && !d.moduleSpecifier && !!d.exportClause && isNamedExports(d.exportClause));
                    if (length(exports) > 1) {
                        const nonExports = filter(statements, (d)=>!isExportDeclaration(d) || !!d.moduleSpecifier || !d.exportClause);
                        statements = [
                            ...nonExports,
                            factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports(flatMap(exports, (e)=>cast(e.exportClause, isNamedExports).elements)), /*moduleSpecifier*/ void 0)
                        ];
                    }
                    const reexports = filter(statements, (d)=>isExportDeclaration(d) && !!d.moduleSpecifier && !!d.exportClause && isNamedExports(d.exportClause));
                    if (length(reexports) > 1) {
                        const groups = group(reexports, (decl)=>isStringLiteral(decl.moduleSpecifier) ? ">" + decl.moduleSpecifier.text : ">");
                        if (groups.length !== reexports.length) {
                            for (const group2 of groups)if (group2.length > 1) statements = [
                                ...filter(statements, (s)=>group2.indexOf(s) === -1),
                                factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports(flatMap(group2, (e)=>cast(e.exportClause, isNamedExports).elements)), group2[0].moduleSpecifier)
                            ];
                        }
                    }
                    return statements;
                }
                function inlineExportModifiers(statements) {
                    const index = findIndex(statements, (d)=>isExportDeclaration(d) && !d.moduleSpecifier && !d.assertClause && !!d.exportClause && isNamedExports(d.exportClause));
                    if (index >= 0) {
                        const exportDecl = statements[index];
                        const replacements = mapDefined(exportDecl.exportClause.elements, (e)=>{
                            if (!e.propertyName) {
                                const indices = indicesOf(statements);
                                const associatedIndices = filter(indices, (i)=>nodeHasName(statements[i], e.name));
                                if (length(associatedIndices) && every(associatedIndices, (i)=>canHaveExportModifier(statements[i]))) {
                                    for (const index2 of associatedIndices)statements[index2] = addExportModifier(statements[index2]);
                                    return void 0;
                                }
                            }
                            return e;
                        });
                        if (!length(replacements)) orderedRemoveItemAt(statements, index);
                        else statements[index] = factory.updateExportDeclaration(exportDecl, exportDecl.modifiers, exportDecl.isTypeOnly, factory.updateNamedExports(exportDecl.exportClause, replacements), exportDecl.moduleSpecifier, exportDecl.assertClause);
                    }
                    return statements;
                }
                function mergeRedundantStatements(statements) {
                    statements = flattenExportAssignedNamespace(statements);
                    statements = mergeExportDeclarations(statements);
                    statements = inlineExportModifiers(statements);
                    if (enclosingDeclaration && (isSourceFile(enclosingDeclaration) && isExternalOrCommonJsModule(enclosingDeclaration) || isModuleDeclaration(enclosingDeclaration)) && (!some(statements, isExternalModuleIndicator) || !hasScopeMarker(statements) && some(statements, needsScopeMarker))) statements.push(createEmptyExports(factory));
                    return statements;
                }
                function addExportModifier(node) {
                    const flags = (getEffectiveModifierFlags(node) | 1 /* Export */ ) & -3 /* Ambient */ ;
                    return factory.updateModifiers(node, flags);
                }
                function removeExportModifier(node) {
                    const flags = getEffectiveModifierFlags(node) & -2 /* Export */ ;
                    return factory.updateModifiers(node, flags);
                }
                function visitSymbolTable(symbolTable2, suppressNewPrivateContext, propertyAsAlias) {
                    if (!suppressNewPrivateContext) deferredPrivatesStack.push(/* @__PURE__ */ new Map());
                    symbolTable2.forEach((symbol)=>{
                        serializeSymbol(symbol, /*isPrivate*/ false, !!propertyAsAlias);
                    });
                    if (!suppressNewPrivateContext) {
                        deferredPrivatesStack[deferredPrivatesStack.length - 1].forEach((symbol)=>{
                            serializeSymbol(symbol, /*isPrivate*/ true, !!propertyAsAlias);
                        });
                        deferredPrivatesStack.pop();
                    }
                }
                function serializeSymbol(symbol, isPrivate, propertyAsAlias) {
                    const visitedSym = getMergedSymbol(symbol);
                    if (visitedSymbols.has(getSymbolId(visitedSym))) return;
                    visitedSymbols.add(getSymbolId(visitedSym));
                    const skipMembershipCheck = !isPrivate;
                    if (skipMembershipCheck || !!length(symbol.declarations) && some(symbol.declarations, (d)=>!!findAncestor(d, (n)=>n === enclosingDeclaration))) {
                        const oldContext = context;
                        context = cloneNodeBuilderContext(context);
                        serializeSymbolWorker(symbol, isPrivate, propertyAsAlias);
                        if (context.reportedDiagnostic) oldcontext.reportedDiagnostic = context.reportedDiagnostic;
                        context = oldContext;
                    }
                }
                function serializeSymbolWorker(symbol, isPrivate, propertyAsAlias) {
                    var _a, _b, _c, _d;
                    const symbolName2 = unescapeLeadingUnderscores(symbol.escapedName);
                    const isDefault = symbol.escapedName === "default" /* Default */ ;
                    if (isPrivate && !(context.flags & 131072 /* AllowAnonymousIdentifier */ ) && isStringANonContextualKeyword(symbolName2) && !isDefault) {
                        context.encounteredError = true;
                        return;
                    }
                    let needsPostExportDefault = isDefault && !!(symbol.flags & -113 /* ExportDoesNotSupportDefaultModifier */  || symbol.flags & 16 /* Function */  && length(getPropertiesOfType(getTypeOfSymbol(symbol)))) && !(symbol.flags & 2097152 /* Alias */ );
                    let needsExportDeclaration = !needsPostExportDefault && !isPrivate && isStringANonContextualKeyword(symbolName2) && !isDefault;
                    if (needsPostExportDefault || needsExportDeclaration) isPrivate = true;
                    const modifierFlags = (!isPrivate ? 1 /* Export */  : 0) | (isDefault && !needsPostExportDefault ? 1024 /* Default */  : 0);
                    const isConstMergedWithNS = symbol.flags & 1536 /* Module */  && symbol.flags & 7 /* Property */  && symbol.escapedName !== "export=" /* ExportEquals */ ;
                    const isConstMergedWithNSPrintableAsSignatureMerge = isConstMergedWithNS && isTypeRepresentableAsFunctionNamespaceMerge(getTypeOfSymbol(symbol), symbol);
                    if (symbol.flags & 8208 /* Method */  || isConstMergedWithNSPrintableAsSignatureMerge) serializeAsFunctionNamespaceMerge(getTypeOfSymbol(symbol), symbol, getInternalSymbolName(symbol, symbolName2), modifierFlags);
                    if (symbol.flags & 524288 /* TypeAlias */ ) serializeTypeAlias(symbol, symbolName2, modifierFlags);
                    if (symbol.flags & 98311 /* Accessor */  && symbol.escapedName !== "export=" /* ExportEquals */  && !(symbol.flags & 4194304 /* Prototype */ ) && !(symbol.flags & 32 /* Class */ ) && !(symbol.flags & 8192 /* Method */ ) && !isConstMergedWithNSPrintableAsSignatureMerge) {
                        if (propertyAsAlias) {
                            const createdExport = serializeMaybeAliasAssignment(symbol);
                            if (createdExport) {
                                needsExportDeclaration = false;
                                needsPostExportDefault = false;
                            }
                        } else {
                            const type = getTypeOfSymbol(symbol);
                            const localName = getInternalSymbolName(symbol, symbolName2);
                            if (!(symbol.flags & 16 /* Function */ ) && isTypeRepresentableAsFunctionNamespaceMerge(type, symbol)) serializeAsFunctionNamespaceMerge(type, symbol, localName, modifierFlags);
                            else {
                                const flags = !(symbol.flags & 2 /* BlockScopedVariable */ ) ? ((_a = symbol.parent) == null ? void 0 : _a.valueDeclaration) && isSourceFile((_b = symbol.parent) == null ? void 0 : _b.valueDeclaration) ? 2 /* Const */  : void 0 : isConstVariable(symbol) ? 2 /* Const */  : 1 /* Let */ ;
                                const name = needsPostExportDefault || !(symbol.flags & 4 /* Property */ ) ? localName : getUnusedName(localName, symbol);
                                let textRange = symbol.declarations && find(symbol.declarations, (d)=>isVariableDeclaration(d));
                                if (textRange && isVariableDeclarationList(textRange.parent) && textRange.parent.declarations.length === 1) textRange = textRange.parent.parent;
                                const propertyAccessRequire = (_c = symbol.declarations) == null ? void 0 : _c.find(isPropertyAccessExpression);
                                if (propertyAccessRequire && isBinaryExpression(propertyAccessRequire.parent) && isIdentifier(propertyAccessRequire.parent.right) && ((_d = type.symbol) == null ? void 0 : _d.valueDeclaration) && isSourceFile(type.symbol.valueDeclaration)) {
                                    const alias = localName === propertyAccessRequire.parent.right.escapedText ? void 0 : propertyAccessRequire.parent.right;
                                    addResult(factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                                        factory.createExportSpecifier(/*isTypeOnly*/ false, alias, localName)
                                    ])), 0 /* None */ );
                                    context.tracker.trackSymbol(type.symbol, context.enclosingDeclaration, 111551 /* Value */ );
                                } else {
                                    const statement = setTextRange(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                                        factory.createVariableDeclaration(name, /*exclamationToken*/ void 0, serializeTypeForDeclaration(context, type, symbol, enclosingDeclaration, includePrivateSymbol, bundled))
                                    ], flags)), textRange);
                                    addResult(statement, name !== localName ? modifierFlags & -2 /* Export */  : modifierFlags);
                                    if (name !== localName && !isPrivate) {
                                        addResult(factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                                            factory.createExportSpecifier(/*isTypeOnly*/ false, name, localName)
                                        ])), 0 /* None */ );
                                        needsExportDeclaration = false;
                                        needsPostExportDefault = false;
                                    }
                                }
                            }
                        }
                    }
                    if (symbol.flags & 384 /* Enum */ ) serializeEnum(symbol, symbolName2, modifierFlags);
                    if (symbol.flags & 32 /* Class */ ) {
                        if (symbol.flags & 4 /* Property */  && symbol.valueDeclaration && isBinaryExpression(symbol.valueDeclaration.parent) && isClassExpression(symbol.valueDeclaration.parent.right)) serializeAsAlias(symbol, getInternalSymbolName(symbol, symbolName2), modifierFlags);
                        else serializeAsClass(symbol, getInternalSymbolName(symbol, symbolName2), modifierFlags);
                    }
                    if (symbol.flags & 1536 /* NamespaceModule */  && (!isConstMergedWithNS || isTypeOnlyNamespace(symbol)) || isConstMergedWithNSPrintableAsSignatureMerge) serializeModule(symbol, symbolName2, modifierFlags);
                    if (symbol.flags & 64 /* Interface */  && !(symbol.flags & 32 /* Class */ )) serializeInterface(symbol, symbolName2, modifierFlags);
                    if (symbol.flags & 2097152 /* Alias */ ) serializeAsAlias(symbol, getInternalSymbolName(symbol, symbolName2), modifierFlags);
                    if (symbol.flags & 4 /* Property */  && symbol.escapedName === "export=" /* ExportEquals */ ) serializeMaybeAliasAssignment(symbol);
                    if (symbol.flags & 8388608 /* ExportStar */ ) {
                        if (symbol.declarations) for (const node of symbol.declarations){
                            const resolvedModule = resolveExternalModuleName(node, node.moduleSpecifier);
                            if (!resolvedModule) continue;
                            addResult(factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ node.isTypeOnly, /*exportClause*/ void 0, factory.createStringLiteral(getSpecifierForModuleSymbol(resolvedModule, context))), 0 /* None */ );
                        }
                    }
                    if (needsPostExportDefault) addResult(factory.createExportAssignment(/*modifiers*/ void 0, /*isExportEquals*/ false, factory.createIdentifier(getInternalSymbolName(symbol, symbolName2))), 0 /* None */ );
                    else if (needsExportDeclaration) addResult(factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                        factory.createExportSpecifier(/*isTypeOnly*/ false, getInternalSymbolName(symbol, symbolName2), symbolName2)
                    ])), 0 /* None */ );
                }
                function includePrivateSymbol(symbol) {
                    if (some(symbol.declarations, isParameterDeclaration)) return;
                    Debug.assertIsDefined(deferredPrivatesStack[deferredPrivatesStack.length - 1]);
                    getUnusedName(unescapeLeadingUnderscores(symbol.escapedName), symbol);
                    const isExternalImportAlias = !!(symbol.flags & 2097152 /* Alias */ ) && !some(symbol.declarations, (d)=>!!findAncestor(d, isExportDeclaration) || isNamespaceExport(d) || isImportEqualsDeclaration(d) && !isExternalModuleReference(d.moduleReference));
                    deferredPrivatesStack[isExternalImportAlias ? 0 : deferredPrivatesStack.length - 1].set(getSymbolId(symbol), symbol);
                }
                function isExportingScope(enclosingDeclaration2) {
                    return isSourceFile(enclosingDeclaration2) && (isExternalOrCommonJsModule(enclosingDeclaration2) || isJsonSourceFile(enclosingDeclaration2)) || isAmbientModule(enclosingDeclaration2) && !isGlobalScopeAugmentation(enclosingDeclaration2);
                }
                function addResult(node, additionalModifierFlags) {
                    if (canHaveModifiers(node)) {
                        let newModifierFlags = 0 /* None */ ;
                        const enclosingDeclaration2 = context.enclosingDeclaration && (isJSDocTypeAlias(context.enclosingDeclaration) ? getSourceFileOfNode(context.enclosingDeclaration) : context.enclosingDeclaration);
                        if (additionalModifierFlags & 1 /* Export */  && enclosingDeclaration2 && (isExportingScope(enclosingDeclaration2) || isModuleDeclaration(enclosingDeclaration2)) && canHaveExportModifier(node)) newModifierFlags |= 1 /* Export */ ;
                        if (addingDeclare && !(newModifierFlags & 1 /* Export */ ) && (!enclosingDeclaration2 || !(enclosingDeclaration2.flags & 16777216 /* Ambient */ )) && (isEnumDeclaration(node) || isVariableStatement(node) || isFunctionDeclaration(node) || isClassDeclaration(node) || isModuleDeclaration(node))) newModifierFlags |= 2 /* Ambient */ ;
                        if (additionalModifierFlags & 1024 /* Default */  && (isClassDeclaration(node) || isInterfaceDeclaration(node) || isFunctionDeclaration(node))) newModifierFlags |= 1024 /* Default */ ;
                        if (newModifierFlags) node = factory.updateModifiers(node, newModifierFlags | getEffectiveModifierFlags(node));
                    }
                    results.push(node);
                }
                function serializeTypeAlias(symbol, symbolName2, modifierFlags) {
                    var _a;
                    const aliasType = getDeclaredTypeOfTypeAlias(symbol);
                    const typeParams = getSymbolLinks(symbol).typeParameters;
                    const typeParamDecls = map(typeParams, (p)=>typeParameterToDeclaration(p, context));
                    const jsdocAliasDecl = (_a = symbol.declarations) == null ? void 0 : _a.find(isJSDocTypeAlias);
                    const commentText = getTextOfJSDocComment(jsdocAliasDecl ? jsdocAliasDecl.comment || jsdocAliasDecl.parent.comment : void 0);
                    const oldFlags = context.flags;
                    context.flags |= 8388608 /* InTypeAlias */ ;
                    const oldEnclosingDecl = context.enclosingDeclaration;
                    context.enclosingDeclaration = jsdocAliasDecl;
                    const typeNode = jsdocAliasDecl && jsdocAliasDecl.typeExpression && isJSDocTypeExpression(jsdocAliasDecl.typeExpression) && serializeExistingTypeNode(context, jsdocAliasDecl.typeExpression.type, includePrivateSymbol, bundled) || typeToTypeNodeHelper(aliasType, context);
                    addResult(setSyntheticLeadingComments(factory.createTypeAliasDeclaration(/*modifiers*/ void 0, getInternalSymbolName(symbol, symbolName2), typeParamDecls, typeNode), !commentText ? [] : [
                        {
                            kind: 3 /* MultiLineCommentTrivia */ ,
                            text: "*\n * " + commentText.replace(/\n/g, "\n * ") + "\n ",
                            pos: -1,
                            end: -1,
                            hasTrailingNewLine: true
                        }
                    ]), modifierFlags);
                    context.flags = oldFlags;
                    context.enclosingDeclaration = oldEnclosingDecl;
                }
                function serializeInterface(symbol, symbolName2, modifierFlags) {
                    const interfaceType = getDeclaredTypeOfClassOrInterface(symbol);
                    const localParams = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
                    const typeParamDecls = map(localParams, (p)=>typeParameterToDeclaration(p, context));
                    const baseTypes = getBaseTypes(interfaceType);
                    const baseType = length(baseTypes) ? getIntersectionType(baseTypes) : void 0;
                    const members = flatMap(getPropertiesOfType(interfaceType), (p)=>serializePropertySymbolForInterface(p, baseType));
                    const callSignatures = serializeSignatures(0 /* Call */ , interfaceType, baseType, 178 /* CallSignature */ );
                    const constructSignatures = serializeSignatures(1 /* Construct */ , interfaceType, baseType, 179 /* ConstructSignature */ );
                    const indexSignatures = serializeIndexSignatures(interfaceType, baseType);
                    const heritageClauses = !length(baseTypes) ? void 0 : [
                        factory.createHeritageClause(96 /* ExtendsKeyword */ , mapDefined(baseTypes, (b)=>trySerializeAsTypeReference(b, 111551 /* Value */ )))
                    ];
                    addResult(factory.createInterfaceDeclaration(/*modifiers*/ void 0, getInternalSymbolName(symbol, symbolName2), typeParamDecls, heritageClauses, [
                        ...indexSignatures,
                        ...constructSignatures,
                        ...callSignatures,
                        ...members
                    ]), modifierFlags);
                }
                function getNamespaceMembersForSerialization(symbol) {
                    const exports = getExportsOfSymbol(symbol);
                    return !exports ? [] : filter(arrayFrom(exports.values()), (m)=>isNamespaceMember(m) && isIdentifierText(m.escapedName, 99 /* ESNext */ ));
                }
                function isTypeOnlyNamespace(symbol) {
                    return every(getNamespaceMembersForSerialization(symbol), (m)=>!(getAllSymbolFlags(resolveSymbol(m)) & 111551 /* Value */ ));
                }
                function serializeModule(symbol, symbolName2, modifierFlags) {
                    const members = getNamespaceMembersForSerialization(symbol);
                    const locationMap = arrayToMultiMap(members, (m)=>m.parent && m.parent === symbol ? "real" : "merged");
                    const realMembers = locationMap.get("real") || emptyArray;
                    const mergedMembers = locationMap.get("merged") || emptyArray;
                    if (length(realMembers)) {
                        const localName = getInternalSymbolName(symbol, symbolName2);
                        serializeAsNamespaceDeclaration(realMembers, localName, modifierFlags, !!(symbol.flags & 67108880 /* Assignment */ ));
                    }
                    if (length(mergedMembers)) {
                        const containingFile = getSourceFileOfNode(context.enclosingDeclaration);
                        const localName = getInternalSymbolName(symbol, symbolName2);
                        const nsBody = factory.createModuleBlock([
                            factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports(mapDefined(filter(mergedMembers, (n)=>n.escapedName !== "export=" /* ExportEquals */ ), (s)=>{
                                var _a, _b;
                                const name = unescapeLeadingUnderscores(s.escapedName);
                                const localName2 = getInternalSymbolName(s, name);
                                const aliasDecl = s.declarations && getDeclarationOfAliasSymbol(s);
                                if (containingFile && (aliasDecl ? containingFile !== getSourceFileOfNode(aliasDecl) : !some(s.declarations, (d)=>getSourceFileOfNode(d) === containingFile))) {
                                    (_b = (_a = context.tracker) == null ? void 0 : _a.reportNonlocalAugmentation) == null || _b.call(_a, containingFile, symbol, s);
                                    return void 0;
                                }
                                const target = aliasDecl && getTargetOfAliasDeclaration(aliasDecl, /*dontRecursivelyResolve*/ true);
                                includePrivateSymbol(target || s);
                                const targetName = target ? getInternalSymbolName(target, unescapeLeadingUnderscores(target.escapedName)) : localName2;
                                return factory.createExportSpecifier(/*isTypeOnly*/ false, name === targetName ? void 0 : targetName, name);
                            })))
                        ]);
                        addResult(factory.createModuleDeclaration(/*modifiers*/ void 0, factory.createIdentifier(localName), nsBody, 16 /* Namespace */ ), 0 /* None */ );
                    }
                }
                function serializeEnum(symbol, symbolName2, modifierFlags) {
                    addResult(factory.createEnumDeclaration(factory.createModifiersFromModifierFlags(isConstEnumSymbol(symbol) ? 2048 /* Const */  : 0), getInternalSymbolName(symbol, symbolName2), map(filter(getPropertiesOfType(getTypeOfSymbol(symbol)), (p)=>!!(p.flags & 8 /* EnumMember */ )), (p)=>{
                        const initializedValue = p.declarations && p.declarations[0] && isEnumMember(p.declarations[0]) ? getConstantValue2(p.declarations[0]) : void 0;
                        return factory.createEnumMember(unescapeLeadingUnderscores(p.escapedName), initializedValue === void 0 ? void 0 : typeof initializedValue === "string" ? factory.createStringLiteral(initializedValue) : factory.createNumericLiteral(initializedValue));
                    })), modifierFlags);
                }
                function serializeAsFunctionNamespaceMerge(type, symbol, localName, modifierFlags) {
                    const signatures = getSignaturesOfType(type, 0 /* Call */ );
                    for (const sig of signatures){
                        const decl = signatureToSignatureDeclarationHelper(sig, 261 /* FunctionDeclaration */ , context, {
                            name: factory.createIdentifier(localName),
                            privateSymbolVisitor: includePrivateSymbol,
                            bundledImports: bundled
                        });
                        addResult(setTextRange(decl, getSignatureTextRangeLocation(sig)), modifierFlags);
                    }
                    if (!(symbol.flags & 1536 /* NamespaceModule */  && !!symbol.exports && !!symbol.exports.size)) {
                        const props = filter(getPropertiesOfType(type), isNamespaceMember);
                        serializeAsNamespaceDeclaration(props, localName, modifierFlags, /*suppressNewPrivateContext*/ true);
                    }
                }
                function getSignatureTextRangeLocation(signature) {
                    if (signature.declaration && signature.declaration.parent) {
                        if (isBinaryExpression(signature.declaration.parent) && getAssignmentDeclarationKind(signature.declaration.parent) === 5 /* Property */ ) return signature.declaration.parent;
                        if (isVariableDeclaration(signature.declaration.parent) && signature.declaration.parent.parent) return signature.declaration.parent.parent;
                    }
                    return signature.declaration;
                }
                function serializeAsNamespaceDeclaration(props, localName, modifierFlags, suppressNewPrivateContext) {
                    if (length(props)) {
                        const localVsRemoteMap = arrayToMultiMap(props, (p)=>!length(p.declarations) || some(p.declarations, (d)=>getSourceFileOfNode(d) === getSourceFileOfNode(context.enclosingDeclaration)) ? "local" : "remote");
                        const localProps = localVsRemoteMap.get("local") || emptyArray;
                        let fakespace = parseNodeFactory.createModuleDeclaration(/*modifiers*/ void 0, factory.createIdentifier(localName), factory.createModuleBlock([]), 16 /* Namespace */ );
                        setParent(fakespace, enclosingDeclaration);
                        fakespace.locals = createSymbolTable(props);
                        fakespace.symbol = props[0].parent;
                        const oldResults = results;
                        results = [];
                        const oldAddingDeclare = addingDeclare;
                        addingDeclare = false;
                        const subcontext = {
                            ...context,
                            enclosingDeclaration: fakespace
                        };
                        const oldContext = context;
                        context = subcontext;
                        visitSymbolTable(createSymbolTable(localProps), suppressNewPrivateContext, /*propertyAsAlias*/ true);
                        context = oldContext;
                        addingDeclare = oldAddingDeclare;
                        const declarations = results;
                        results = oldResults;
                        const defaultReplaced = map(declarations, (d)=>isExportAssignment(d) && !d.isExportEquals && isIdentifier(d.expression) ? factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                                factory.createExportSpecifier(/*isTypeOnly*/ false, d.expression, factory.createIdentifier("default" /* Default */ ))
                            ])) : d);
                        const exportModifierStripped = every(defaultReplaced, (d)=>hasSyntacticModifier(d, 1 /* Export */ )) ? map(defaultReplaced, removeExportModifier) : defaultReplaced;
                        fakespace = factory.updateModuleDeclaration(fakespace, fakespace.modifiers, fakespace.name, factory.createModuleBlock(exportModifierStripped));
                        addResult(fakespace, modifierFlags);
                    }
                }
                function isNamespaceMember(p) {
                    return !!(p.flags & 2887656 /* Alias */ ) || !(p.flags & 4194304 /* Prototype */  || p.escapedName === "prototype" || p.valueDeclaration && isStatic(p.valueDeclaration) && isClassLike(p.valueDeclaration.parent));
                }
                function sanitizeJSDocImplements(clauses) {
                    const result = mapDefined(clauses, (e)=>{
                        const oldEnclosing = context.enclosingDeclaration;
                        context.enclosingDeclaration = e;
                        let expr = e.expression;
                        if (isEntityNameExpression(expr)) {
                            if (isIdentifier(expr) && idText(expr) === "") return cleanup(/*result*/ void 0);
                            let introducesError;
                            ({ introducesError: introducesError , node: expr  } = trackExistingEntityName(expr, context, includePrivateSymbol));
                            if (introducesError) return cleanup(/*result*/ void 0);
                        }
                        return cleanup(factory.createExpressionWithTypeArguments(expr, map(e.typeArguments, (a)=>serializeExistingTypeNode(context, a, includePrivateSymbol, bundled) || typeToTypeNodeHelper(getTypeFromTypeNode(a), context))));
                        function cleanup(result2) {
                            context.enclosingDeclaration = oldEnclosing;
                            return result2;
                        }
                    });
                    if (result.length === clauses.length) return result;
                    return void 0;
                }
                function serializeAsClass(symbol, localName, modifierFlags) {
                    var _a, _b;
                    const originalDecl = (_a = symbol.declarations) == null ? void 0 : _a.find(isClassLike);
                    const oldEnclosing = context.enclosingDeclaration;
                    context.enclosingDeclaration = originalDecl || oldEnclosing;
                    const localParams = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
                    const typeParamDecls = map(localParams, (p)=>typeParameterToDeclaration(p, context));
                    const classType = getTypeWithThisArgument(getDeclaredTypeOfClassOrInterface(symbol));
                    const baseTypes = getBaseTypes(classType);
                    const originalImplements = originalDecl && getEffectiveImplementsTypeNodes(originalDecl);
                    const implementsExpressions = originalImplements && sanitizeJSDocImplements(originalImplements) || mapDefined(getImplementsTypes(classType), serializeImplementedType);
                    const staticType = getTypeOfSymbol(symbol);
                    const isClass = !!((_b = staticType.symbol) == null ? void 0 : _b.valueDeclaration) && isClassLike(staticType.symbol.valueDeclaration);
                    const staticBaseType = isClass ? getBaseConstructorTypeOfClass(staticType) : anyType;
                    const heritageClauses = [
                        ...!length(baseTypes) ? [] : [
                            factory.createHeritageClause(96 /* ExtendsKeyword */ , map(baseTypes, (b)=>serializeBaseType(b, staticBaseType, localName)))
                        ],
                        ...!length(implementsExpressions) ? [] : [
                            factory.createHeritageClause(119 /* ImplementsKeyword */ , implementsExpressions)
                        ]
                    ];
                    const symbolProps = getNonInheritedProperties(classType, baseTypes, getPropertiesOfType(classType));
                    const publicSymbolProps = filter(symbolProps, (s)=>{
                        const valueDecl = s.valueDeclaration;
                        return !!valueDecl && !(isNamedDeclaration(valueDecl) && isPrivateIdentifier(valueDecl.name));
                    });
                    const hasPrivateIdentifier = some(symbolProps, (s)=>{
                        const valueDecl = s.valueDeclaration;
                        return !!valueDecl && isNamedDeclaration(valueDecl) && isPrivateIdentifier(valueDecl.name);
                    });
                    const privateProperties = hasPrivateIdentifier ? [
                        factory.createPropertyDeclaration(/*modifiers*/ void 0, factory.createPrivateIdentifier("#private"), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0)
                    ] : emptyArray;
                    const publicProperties = flatMap(publicSymbolProps, (p)=>serializePropertySymbolForClass(p, /*isStatic*/ false, baseTypes[0]));
                    const staticMembers = flatMap(filter(getPropertiesOfType(staticType), (p)=>!(p.flags & 4194304 /* Prototype */ ) && p.escapedName !== "prototype" && !isNamespaceMember(p)), (p)=>serializePropertySymbolForClass(p, /*isStatic*/ true, staticBaseType));
                    const isNonConstructableClassLikeInJsFile = !isClass && !!symbol.valueDeclaration && isInJSFile(symbol.valueDeclaration) && !some(getSignaturesOfType(staticType, 1 /* Construct */ ));
                    const constructors = isNonConstructableClassLikeInJsFile ? [
                        factory.createConstructorDeclaration(factory.createModifiersFromModifierFlags(8 /* Private */ ), [], /*body*/ void 0)
                    ] : serializeSignatures(1 /* Construct */ , staticType, staticBaseType, 175 /* Constructor */ );
                    const indexSignatures = serializeIndexSignatures(classType, baseTypes[0]);
                    context.enclosingDeclaration = oldEnclosing;
                    addResult(setTextRange(factory.createClassDeclaration(/*modifiers*/ void 0, localName, typeParamDecls, heritageClauses, [
                        ...indexSignatures,
                        ...staticMembers,
                        ...constructors,
                        ...publicProperties,
                        ...privateProperties
                    ]), symbol.declarations && filter(symbol.declarations, (d)=>isClassDeclaration(d) || isClassExpression(d))[0]), modifierFlags);
                }
                function getSomeTargetNameFromDeclarations(declarations) {
                    return firstDefined(declarations, (d)=>{
                        if (isImportSpecifier(d) || isExportSpecifier(d)) return idText(d.propertyName || d.name);
                        if (isBinaryExpression(d) || isExportAssignment(d)) {
                            const expression = isExportAssignment(d) ? d.expression : d.right;
                            if (isPropertyAccessExpression(expression)) return idText(expression.name);
                        }
                        if (isAliasSymbolDeclaration2(d)) {
                            const name = getNameOfDeclaration(d);
                            if (name && isIdentifier(name)) return idText(name);
                        }
                        return void 0;
                    });
                }
                function serializeAsAlias(symbol, localName, modifierFlags) {
                    var _a, _b, _c, _d, _e;
                    const node = getDeclarationOfAliasSymbol(symbol);
                    if (!node) return Debug.fail();
                    const target = getMergedSymbol(getTargetOfAliasDeclaration(node, /*dontRecursivelyResolve*/ true));
                    if (!target) return;
                    let verbatimTargetName = isShorthandAmbientModuleSymbol(target) && getSomeTargetNameFromDeclarations(symbol.declarations) || unescapeLeadingUnderscores(target.escapedName);
                    if (verbatimTargetName === "export=" /* ExportEquals */  && allowSyntheticDefaultImports) verbatimTargetName = "default" /* Default */ ;
                    const targetName = getInternalSymbolName(target, verbatimTargetName);
                    includePrivateSymbol(target);
                    switch(node.kind){
                        case 207 /* BindingElement */ :
                            if (((_b = (_a = node.parent) == null ? void 0 : _a.parent) == null ? void 0 : _b.kind) === 259 /* VariableDeclaration */ ) {
                                const specifier2 = getSpecifierForModuleSymbol(target.parent || target, context);
                                const { propertyName: propertyName  } = node;
                                addResult(factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/*isTypeOnly*/ false, /*name*/ void 0, factory.createNamedImports([
                                    factory.createImportSpecifier(/*isTypeOnly*/ false, propertyName && isIdentifier(propertyName) ? factory.createIdentifier(idText(propertyName)) : void 0, factory.createIdentifier(localName))
                                ])), factory.createStringLiteral(specifier2), /*assertClause*/ void 0), 0 /* None */ );
                                break;
                            }
                            Debug.failBadSyntaxKind(((_c = node.parent) == null ? void 0 : _c.parent) || node, "Unhandled binding element grandparent kind in declaration serialization");
                            break;
                        case 303 /* ShorthandPropertyAssignment */ :
                            if (((_e = (_d = node.parent) == null ? void 0 : _d.parent) == null ? void 0 : _e.kind) === 225 /* BinaryExpression */ ) serializeExportSpecifier(unescapeLeadingUnderscores(symbol.escapedName), targetName);
                            break;
                        case 259 /* VariableDeclaration */ :
                            if (isPropertyAccessExpression(node.initializer)) {
                                const initializer = node.initializer;
                                const uniqueName = factory.createUniqueName(localName);
                                const specifier2 = getSpecifierForModuleSymbol(target.parent || target, context);
                                addResult(factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, uniqueName, factory.createExternalModuleReference(factory.createStringLiteral(specifier2))), 0 /* None */ );
                                addResult(factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createIdentifier(localName), factory.createQualifiedName(uniqueName, initializer.name)), modifierFlags);
                                break;
                            }
                        case 270 /* ImportEqualsDeclaration */ :
                            if (target.escapedName === "export=" /* ExportEquals */  && some(target.declarations, (d)=>isSourceFile(d) && isJsonSourceFile(d))) {
                                serializeMaybeAliasAssignment(symbol);
                                break;
                            }
                            const isLocalImport = !(target.flags & 512 /* ValueModule */ ) && !isVariableDeclaration(node);
                            addResult(factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createIdentifier(localName), isLocalImport ? symbolToName(target, context, 67108863 /* All */ , /*expectsIdentifier*/ false) : factory.createExternalModuleReference(factory.createStringLiteral(getSpecifierForModuleSymbol(target, context)))), isLocalImport ? modifierFlags : 0 /* None */ );
                            break;
                        case 269 /* NamespaceExportDeclaration */ :
                            addResult(factory.createNamespaceExportDeclaration(idText(node.name)), 0 /* None */ );
                            break;
                        case 272 /* ImportClause */ :
                            {
                                const generatedSpecifier = getSpecifierForModuleSymbol(target.parent || target, context);
                                const specifier2 = bundled ? factory.createStringLiteral(generatedSpecifier) : node.parent.moduleSpecifier;
                                addResult(factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/*isTypeOnly*/ false, factory.createIdentifier(localName), /*namedBindings*/ void 0), specifier2, node.parent.assertClause), 0 /* None */ );
                                break;
                            }
                        case 273 /* NamespaceImport */ :
                            {
                                const generatedSpecifier = getSpecifierForModuleSymbol(target.parent || target, context);
                                const specifier2 = bundled ? factory.createStringLiteral(generatedSpecifier) : node.parent.parent.moduleSpecifier;
                                addResult(factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/*isTypeOnly*/ false, /*name*/ void 0, factory.createNamespaceImport(factory.createIdentifier(localName))), specifier2, node.parent.parent.assertClause), 0 /* None */ );
                                break;
                            }
                        case 279 /* NamespaceExport */ :
                            addResult(factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamespaceExport(factory.createIdentifier(localName)), factory.createStringLiteral(getSpecifierForModuleSymbol(target, context))), 0 /* None */ );
                            break;
                        case 275 /* ImportSpecifier */ :
                            {
                                const generatedSpecifier = getSpecifierForModuleSymbol(target.parent || target, context);
                                const specifier2 = bundled ? factory.createStringLiteral(generatedSpecifier) : node.parent.parent.parent.moduleSpecifier;
                                addResult(factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/*isTypeOnly*/ false, /*name*/ void 0, factory.createNamedImports([
                                    factory.createImportSpecifier(/*isTypeOnly*/ false, localName !== verbatimTargetName ? factory.createIdentifier(verbatimTargetName) : void 0, factory.createIdentifier(localName))
                                ])), specifier2, node.parent.parent.parent.assertClause), 0 /* None */ );
                                break;
                            }
                        case 280 /* ExportSpecifier */ :
                            const specifier = node.parent.parent.moduleSpecifier;
                            serializeExportSpecifier(unescapeLeadingUnderscores(symbol.escapedName), specifier ? verbatimTargetName : targetName, specifier && isStringLiteralLike(specifier) ? factory.createStringLiteral(specifier.text) : void 0);
                            break;
                        case 276 /* ExportAssignment */ :
                            serializeMaybeAliasAssignment(symbol);
                            break;
                        case 225 /* BinaryExpression */ :
                        case 210 /* PropertyAccessExpression */ :
                        case 211 /* ElementAccessExpression */ :
                            if (symbol.escapedName === "default" /* Default */  || symbol.escapedName === "export=" /* ExportEquals */ ) serializeMaybeAliasAssignment(symbol);
                            else serializeExportSpecifier(localName, targetName);
                            break;
                        default:
                            return Debug.failBadSyntaxKind(node, "Unhandled alias declaration kind in symbol serializer!");
                    }
                }
                function serializeExportSpecifier(localName, targetName, specifier) {
                    addResult(factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                        factory.createExportSpecifier(/*isTypeOnly*/ false, localName !== targetName ? targetName : void 0, localName)
                    ]), specifier), 0 /* None */ );
                }
                function serializeMaybeAliasAssignment(symbol) {
                    var _a;
                    if (symbol.flags & 4194304 /* Prototype */ ) return false;
                    const name = unescapeLeadingUnderscores(symbol.escapedName);
                    const isExportEquals = name === "export=" /* ExportEquals */ ;
                    const isDefault = name === "default" /* Default */ ;
                    const isExportAssignmentCompatibleSymbolName = isExportEquals || isDefault;
                    const aliasDecl = symbol.declarations && getDeclarationOfAliasSymbol(symbol);
                    const target = aliasDecl && getTargetOfAliasDeclaration(aliasDecl, /*dontRecursivelyResolve*/ true);
                    if (target && length(target.declarations) && some(target.declarations, (d)=>getSourceFileOfNode(d) === getSourceFileOfNode(enclosingDeclaration))) {
                        const expr = aliasDecl && (isExportAssignment(aliasDecl) || isBinaryExpression(aliasDecl) ? getExportAssignmentExpression(aliasDecl) : getPropertyAssignmentAliasLikeExpression(aliasDecl));
                        const first2 = expr && isEntityNameExpression(expr) ? getFirstNonModuleExportsIdentifier(expr) : void 0;
                        const referenced = first2 && resolveEntityName(first2, 67108863 /* All */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true, enclosingDeclaration);
                        if (referenced || target) includePrivateSymbol(referenced || target);
                        const prevDisableTrackSymbol = context.tracker.disableTrackSymbol;
                        context.tracker.disableTrackSymbol = true;
                        if (isExportAssignmentCompatibleSymbolName) results.push(factory.createExportAssignment(/*modifiers*/ void 0, isExportEquals, symbolToExpression(target, context, 67108863 /* All */ )));
                        else {
                            if (first2 === expr && first2) serializeExportSpecifier(name, idText(first2));
                            else if (expr && isClassExpression(expr)) serializeExportSpecifier(name, getInternalSymbolName(target, symbolName(target)));
                            else {
                                const varName = getUnusedName(name, symbol);
                                addResult(factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createIdentifier(varName), symbolToName(target, context, 67108863 /* All */ , /*expectsIdentifier*/ false)), 0 /* None */ );
                                serializeExportSpecifier(name, varName);
                            }
                        }
                        context.tracker.disableTrackSymbol = prevDisableTrackSymbol;
                        return true;
                    } else {
                        const varName = getUnusedName(name, symbol);
                        const typeToSerialize = getWidenedType(getTypeOfSymbol(getMergedSymbol(symbol)));
                        if (isTypeRepresentableAsFunctionNamespaceMerge(typeToSerialize, symbol)) serializeAsFunctionNamespaceMerge(typeToSerialize, symbol, varName, isExportAssignmentCompatibleSymbolName ? 0 /* None */  : 1 /* Export */ );
                        else {
                            const statement = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                                factory.createVariableDeclaration(varName, /*exclamationToken*/ void 0, serializeTypeForDeclaration(context, typeToSerialize, symbol, enclosingDeclaration, includePrivateSymbol, bundled))
                            ], ((_a = context.enclosingDeclaration) == null ? void 0 : _a.kind) === 266 /* ModuleDeclaration */  ? 1 /* Let */  : 2 /* Const */ ));
                            addResult(statement, target && target.flags & 4 /* Property */  && target.escapedName === "export=" /* ExportEquals */  ? 2 /* Ambient */  : name === varName ? 1 /* Export */  : 0 /* None */ );
                        }
                        if (isExportAssignmentCompatibleSymbolName) {
                            results.push(factory.createExportAssignment(/*modifiers*/ void 0, isExportEquals, factory.createIdentifier(varName)));
                            return true;
                        } else if (name !== varName) {
                            serializeExportSpecifier(name, varName);
                            return true;
                        }
                        return false;
                    }
                }
                function isTypeRepresentableAsFunctionNamespaceMerge(typeToSerialize, hostSymbol) {
                    const ctxSrc = getSourceFileOfNode(context.enclosingDeclaration);
                    return getObjectFlags(typeToSerialize) & 48 /* Mapped */  && !length(getIndexInfosOfType(typeToSerialize)) && !isClassInstanceSide(typeToSerialize) && // While a class instance is potentially representable as a NS, prefer printing a reference to the instance type and serializing the class
                    !!(length(filter(getPropertiesOfType(typeToSerialize), isNamespaceMember)) || length(getSignaturesOfType(typeToSerialize, 0 /* Call */ ))) && !length(getSignaturesOfType(typeToSerialize, 1 /* Construct */ )) && // TODO: could probably serialize as function + ns + class, now that that's OK
                    !getDeclarationWithTypeAnnotation(hostSymbol, enclosingDeclaration) && !(typeToSerialize.symbol && some(typeToSerialize.symbol.declarations, (d)=>getSourceFileOfNode(d) !== ctxSrc)) && !some(getPropertiesOfType(typeToSerialize), (p)=>isLateBoundName(p.escapedName)) && !some(getPropertiesOfType(typeToSerialize), (p)=>some(p.declarations, (d)=>getSourceFileOfNode(d) !== ctxSrc)) && every(getPropertiesOfType(typeToSerialize), (p)=>isIdentifierText(symbolName(p), languageVersion));
                }
                function makeSerializePropertySymbol(createProperty2, methodKind, useAccessors) {
                    return function serializePropertySymbol(p, isStatic2, baseType) {
                        var _a, _b, _c, _d, _e;
                        const modifierFlags = getDeclarationModifierFlagsFromSymbol(p);
                        const isPrivate = !!(modifierFlags & 8 /* Private */ );
                        if (isStatic2 && p.flags & 2887656 /* Alias */ ) return [];
                        if (p.flags & 4194304 /* Prototype */  || p.escapedName === "constructor" || baseType && getPropertyOfType(baseType, p.escapedName) && isReadonlySymbol(getPropertyOfType(baseType, p.escapedName)) === isReadonlySymbol(p) && (p.flags & 16777216 /* Optional */ ) === (getPropertyOfType(baseType, p.escapedName).flags & 16777216 /* Optional */ ) && isTypeIdenticalTo(getTypeOfSymbol(p), getTypeOfPropertyOfType(baseType, p.escapedName))) return [];
                        const flag = modifierFlags & -513 /* Async */  | (isStatic2 ? 32 /* Static */  : 0);
                        const name = getPropertyNameNodeForSymbol(p, context);
                        const firstPropertyLikeDecl = (_a = p.declarations) == null ? void 0 : _a.find(or(isPropertyDeclaration, isAccessor, isVariableDeclaration, isPropertySignature, isBinaryExpression, isPropertyAccessExpression));
                        if (p.flags & 98304 /* Accessor */  && useAccessors) {
                            const result = [];
                            if (p.flags & 65536 /* SetAccessor */ ) result.push(setTextRange(factory.createSetAccessorDeclaration(factory.createModifiersFromModifierFlags(flag), name, [
                                factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "arg", /*questionToken*/ void 0, isPrivate ? void 0 : serializeTypeForDeclaration(context, getTypeOfSymbol(p), p, enclosingDeclaration, includePrivateSymbol, bundled))
                            ], /*body*/ void 0), ((_b = p.declarations) == null ? void 0 : _b.find(isSetAccessor)) || firstPropertyLikeDecl));
                            if (p.flags & 32768 /* GetAccessor */ ) {
                                const isPrivate2 = modifierFlags & 8 /* Private */ ;
                                result.push(setTextRange(factory.createGetAccessorDeclaration(factory.createModifiersFromModifierFlags(flag), name, [], isPrivate2 ? void 0 : serializeTypeForDeclaration(context, getTypeOfSymbol(p), p, enclosingDeclaration, includePrivateSymbol, bundled), /*body*/ void 0), ((_c = p.declarations) == null ? void 0 : _c.find(isGetAccessor)) || firstPropertyLikeDecl));
                            }
                            return result;
                        } else if (p.flags & 98311 /* Accessor */ ) return setTextRange(createProperty2(factory.createModifiersFromModifierFlags((isReadonlySymbol(p) ? 64 /* Readonly */  : 0) | flag), name, p.flags & 16777216 /* Optional */  ? factory.createToken(58 /* QuestionToken */ ) : void 0, isPrivate ? void 0 : serializeTypeForDeclaration(context, getWriteTypeOfSymbol(p), p, enclosingDeclaration, includePrivateSymbol, bundled), // TODO: https://github.com/microsoft/TypeScript/pull/32372#discussion_r328386357
                        // interface members can't have initializers, however class members _can_
                        /*initializer*/ void 0), ((_d = p.declarations) == null ? void 0 : _d.find(or(isPropertyDeclaration, isVariableDeclaration))) || firstPropertyLikeDecl);
                        if (p.flags & 8208 /* Function */ ) {
                            const type = getTypeOfSymbol(p);
                            const signatures = getSignaturesOfType(type, 0 /* Call */ );
                            if (flag & 8 /* Private */ ) return setTextRange(createProperty2(factory.createModifiersFromModifierFlags((isReadonlySymbol(p) ? 64 /* Readonly */  : 0) | flag), name, p.flags & 16777216 /* Optional */  ? factory.createToken(58 /* QuestionToken */ ) : void 0, /*type*/ void 0, /*initializer*/ void 0), ((_e = p.declarations) == null ? void 0 : _e.find(isFunctionLikeDeclaration)) || signatures[0] && signatures[0].declaration || p.declarations && p.declarations[0]);
                            const results2 = [];
                            for (const sig of signatures){
                                const decl = signatureToSignatureDeclarationHelper(sig, methodKind, context, {
                                    name: name,
                                    questionToken: p.flags & 16777216 /* Optional */  ? factory.createToken(58 /* QuestionToken */ ) : void 0,
                                    modifiers: flag ? factory.createModifiersFromModifierFlags(flag) : void 0
                                });
                                const location = sig.declaration && isPrototypePropertyAssignment(sig.declaration.parent) ? sig.declaration.parent : sig.declaration;
                                results2.push(setTextRange(decl, location));
                            }
                            return results2;
                        }
                        return Debug.fail(`Unhandled class member kind! ${p.__debugFlags || p.flags}`);
                    };
                }
                function serializePropertySymbolForInterface(p, baseType) {
                    return serializePropertySymbolForInterfaceWorker(p, /*isStatic*/ false, baseType);
                }
                function serializeSignatures(kind, input, baseType, outputKind) {
                    const signatures = getSignaturesOfType(input, kind);
                    if (kind === 1 /* Construct */ ) {
                        if (!baseType && every(signatures, (s)=>length(s.parameters) === 0)) return [];
                        if (baseType) {
                            const baseSigs = getSignaturesOfType(baseType, 1 /* Construct */ );
                            if (!length(baseSigs) && every(signatures, (s)=>length(s.parameters) === 0)) return [];
                            if (baseSigs.length === signatures.length) {
                                let failed = false;
                                for(let i = 0; i < baseSigs.length; i++)if (!compareSignaturesIdentical(signatures[i], baseSigs[i], /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ true, compareTypesIdentical)) {
                                    failed = true;
                                    break;
                                }
                                if (!failed) return [];
                            }
                        }
                        let privateProtected = 0;
                        for (const s of signatures)if (s.declaration) privateProtected |= getSelectedEffectiveModifierFlags(s.declaration, 24 /* Protected */ );
                        if (privateProtected) return [
                            setTextRange(factory.createConstructorDeclaration(factory.createModifiersFromModifierFlags(privateProtected), /*parameters*/ [], /*body*/ void 0), signatures[0].declaration)
                        ];
                    }
                    const results2 = [];
                    for (const sig of signatures){
                        const decl = signatureToSignatureDeclarationHelper(sig, outputKind, context);
                        results2.push(setTextRange(decl, sig.declaration));
                    }
                    return results2;
                }
                function serializeIndexSignatures(input, baseType) {
                    const results2 = [];
                    for (const info of getIndexInfosOfType(input)){
                        if (baseType) {
                            const baseInfo = getIndexInfoOfType(baseType, info.keyType);
                            if (baseInfo) {
                                if (isTypeIdenticalTo(info.type, baseInfo.type)) continue;
                            }
                        }
                        results2.push(indexInfoToIndexSignatureDeclarationHelper(info, context, /*typeNode*/ void 0));
                    }
                    return results2;
                }
                function serializeBaseType(t, staticType, rootName) {
                    const ref = trySerializeAsTypeReference(t, 111551 /* Value */ );
                    if (ref) return ref;
                    const tempName = getUnusedName(`${rootName}_base`);
                    const statement = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                        factory.createVariableDeclaration(tempName, /*exclamationToken*/ void 0, typeToTypeNodeHelper(staticType, context))
                    ], 2 /* Const */ ));
                    addResult(statement, 0 /* None */ );
                    return factory.createExpressionWithTypeArguments(factory.createIdentifier(tempName), /*typeArguments*/ void 0);
                }
                function trySerializeAsTypeReference(t, flags) {
                    let typeArgs;
                    let reference;
                    if (t.target && isSymbolAccessibleByFlags(t.target.symbol, enclosingDeclaration, flags)) {
                        typeArgs = map(getTypeArguments(t), (t2)=>typeToTypeNodeHelper(t2, context));
                        reference = symbolToExpression(t.target.symbol, context, 788968 /* Type */ );
                    } else if (t.symbol && isSymbolAccessibleByFlags(t.symbol, enclosingDeclaration, flags)) reference = symbolToExpression(t.symbol, context, 788968 /* Type */ );
                    if (reference) return factory.createExpressionWithTypeArguments(reference, typeArgs);
                }
                function serializeImplementedType(t) {
                    const ref = trySerializeAsTypeReference(t, 788968 /* Type */ );
                    if (ref) return ref;
                    if (t.symbol) return factory.createExpressionWithTypeArguments(symbolToExpression(t.symbol, context, 788968 /* Type */ ), /*typeArguments*/ void 0);
                }
                function getUnusedName(input, symbol) {
                    var _a, _b;
                    const id = symbol ? getSymbolId(symbol) : void 0;
                    if (id) {
                        if (context.remappedSymbolNames.has(id)) return context.remappedSymbolNames.get(id);
                    }
                    if (symbol) input = getNameCandidateWorker(symbol, input);
                    let i = 0;
                    const original = input;
                    while((_a = context.usedSymbolNames) == null ? void 0 : _a.has(input)){
                        i++;
                        input = `${original}_${i}`;
                    }
                    (_b = context.usedSymbolNames) == null || _b.add(input);
                    if (id) context.remappedSymbolNames.set(id, input);
                    return input;
                }
                function getNameCandidateWorker(symbol, localName) {
                    if (localName === "default" /* Default */  || localName === "__class" /* Class */  || localName === "__function" /* Function */ ) {
                        const flags = context.flags;
                        context.flags |= 16777216 /* InInitialEntityName */ ;
                        const nameCandidate = getNameOfSymbolAsWritten(symbol, context);
                        context.flags = flags;
                        localName = nameCandidate.length > 0 && isSingleOrDoubleQuote(nameCandidate.charCodeAt(0)) ? stripQuotes(nameCandidate) : nameCandidate;
                    }
                    if (localName === "default" /* Default */ ) localName = "_default";
                    else if (localName === "export=" /* ExportEquals */ ) localName = "_exports";
                    localName = isIdentifierText(localName, languageVersion) && !isStringANonContextualKeyword(localName) ? localName : "_" + localName.replace(/[^a-zA-Z0-9]/g, "_");
                    return localName;
                }
                function getInternalSymbolName(symbol, localName) {
                    const id = getSymbolId(symbol);
                    if (context.remappedSymbolNames.has(id)) return context.remappedSymbolNames.get(id);
                    localName = getNameCandidateWorker(symbol, localName);
                    context.remappedSymbolNames.set(id, localName);
                    return localName;
                }
            }
        }
        function typePredicateToString(typePredicate, enclosingDeclaration, flags = 16384 /* UseAliasDefinedOutsideCurrentScope */ , writer) {
            return writer ? typePredicateToStringWorker(writer).getText() : usingSingleLineStringWriter(typePredicateToStringWorker);
            function typePredicateToStringWorker(writer2) {
                const predicate = factory.createTypePredicateNode(typePredicate.kind === 2 /* AssertsThis */  || typePredicate.kind === 3 /* AssertsIdentifier */  ? factory.createToken(131 /* AssertsKeyword */ ) : void 0, typePredicate.kind === 1 /* Identifier */  || typePredicate.kind === 3 /* AssertsIdentifier */  ? factory.createIdentifier(typePredicate.parameterName) : factory.createThisTypeNode(), typePredicate.type && nodeBuilder.typeToTypeNode(typePredicate.type, enclosingDeclaration, toNodeBuilderFlags(flags) | 70222336 /* WriteTypeParametersInQualifiedName */ ));
                const printer = createPrinterWithRemoveComments();
                const sourceFile = enclosingDeclaration && getSourceFileOfNode(enclosingDeclaration);
                printer.writeNode(4 /* Unspecified */ , predicate, /*sourceFile*/ sourceFile, writer2);
                return writer2;
            }
        }
        function formatUnionTypes(types) {
            const result = [];
            let flags = 0;
            for(let i = 0; i < types.length; i++){
                const t = types[i];
                flags |= t.flags;
                if (!(t.flags & 98304 /* Nullable */ )) {
                    if (t.flags & 1568 /* EnumLike */ ) {
                        const baseType = t.flags & 512 /* BooleanLiteral */  ? booleanType : getBaseTypeOfEnumLikeType(t);
                        if (baseType.flags & 1048576 /* Union */ ) {
                            const count = baseType.types.length;
                            if (i + count <= types.length && getRegularTypeOfLiteralType(types[i + count - 1]) === getRegularTypeOfLiteralType(baseType.types[count - 1])) {
                                result.push(baseType);
                                i += count - 1;
                                continue;
                            }
                        }
                    }
                    result.push(t);
                }
            }
            if (flags & 65536 /* Null */ ) result.push(nullType);
            if (flags & 32768 /* Undefined */ ) result.push(undefinedType);
            return result || types;
        }
        function visibilityToString(flags) {
            if (flags === 8 /* Private */ ) return "private";
            if (flags === 16 /* Protected */ ) return "protected";
            return "public";
        }
        function getTypeAliasForTypeLiteral(type) {
            if (type.symbol && type.symbol.flags & 2048 /* TypeLiteral */  && type.symbol.declarations) {
                const node = walkUpParenthesizedTypes(type.symbol.declarations[0].parent);
                if (isTypeAliasDeclaration(node)) return getSymbolOfDeclaration(node);
            }
            return void 0;
        }
        function isTopLevelInExternalModuleAugmentation(node) {
            return node && node.parent && node.parent.kind === 267 /* ModuleBlock */  && isExternalModuleAugmentation(node.parent.parent);
        }
        function isDefaultBindingContext(location) {
            return location.kind === 311 /* SourceFile */  || isAmbientModule(location);
        }
        function getNameOfSymbolFromNameType(symbol, context) {
            const nameType = getSymbolLinks(symbol).nameType;
            if (nameType) {
                if (nameType.flags & 384 /* StringOrNumberLiteral */ ) {
                    const name = "" + nameType.value;
                    if (!isIdentifierText(name, getEmitScriptTarget(compilerOptions)) && !isNumericLiteralName(name)) return `"${escapeString(name, 34 /* doubleQuote */ )}"`;
                    if (isNumericLiteralName(name) && startsWith(name, "-")) return `[${name}]`;
                    return name;
                }
                if (nameType.flags & 8192 /* UniqueESSymbol */ ) return `[${getNameOfSymbolAsWritten(nameType.symbol, context)}]`;
            }
        }
        function getNameOfSymbolAsWritten(symbol, context) {
            if (context && symbol.escapedName === "default" /* Default */  && !(context.flags & 16384 /* UseAliasDefinedOutsideCurrentScope */ ) && // If it's not the first part of an entity name, it must print as `default`
            (!(context.flags & 16777216 /* InInitialEntityName */ ) || // if the symbol is synthesized, it will only be referenced externally it must print as `default`
            !symbol.declarations || // if not in the same binding context (source file, module declaration), it must print as `default`
            context.enclosingDeclaration && findAncestor(symbol.declarations[0], isDefaultBindingContext) !== findAncestor(context.enclosingDeclaration, isDefaultBindingContext))) return "default";
            if (symbol.declarations && symbol.declarations.length) {
                let declaration = firstDefined(symbol.declarations, (d)=>getNameOfDeclaration(d) ? d : void 0);
                const name2 = declaration && getNameOfDeclaration(declaration);
                if (declaration && name2) {
                    if (isCallExpression(declaration) && isBindableObjectDefinePropertyCall(declaration)) return symbolName(symbol);
                    if (isComputedPropertyName(name2) && !(getCheckFlags(symbol) & 4096 /* Late */ )) {
                        const nameType = getSymbolLinks(symbol).nameType;
                        if (nameType && nameType.flags & 384 /* StringOrNumberLiteral */ ) {
                            const result = getNameOfSymbolFromNameType(symbol, context);
                            if (result !== void 0) return result;
                        }
                    }
                    return declarationNameToString(name2);
                }
                if (!declaration) declaration = symbol.declarations[0];
                if (declaration.parent && declaration.parent.kind === 259 /* VariableDeclaration */ ) return declarationNameToString(declaration.parent.name);
                switch(declaration.kind){
                    case 230 /* ClassExpression */ :
                    case 217 /* FunctionExpression */ :
                    case 218 /* ArrowFunction */ :
                        if (context && !context.encounteredError && !(context.flags & 131072 /* AllowAnonymousIdentifier */ )) context.encounteredError = true;
                        return declaration.kind === 230 /* ClassExpression */  ? "(Anonymous class)" : "(Anonymous function)";
                }
            }
            const name = getNameOfSymbolFromNameType(symbol, context);
            return name !== void 0 ? name : symbolName(symbol);
        }
        function isDeclarationVisible(node) {
            if (node) {
                const links = getNodeLinks(node);
                if (links.isVisible === void 0) links.isVisible = !!determineIfDeclarationIsVisible();
                return links.isVisible;
            }
            return false;
            function determineIfDeclarationIsVisible() {
                switch(node.kind){
                    case 344 /* JSDocCallbackTag */ :
                    case 352 /* JSDocTypedefTag */ :
                    case 346 /* JSDocEnumTag */ :
                        return !!(node.parent && node.parent.parent && node.parent.parent.parent && isSourceFile(node.parent.parent.parent));
                    case 207 /* BindingElement */ :
                        return isDeclarationVisible(node.parent.parent);
                    case 259 /* VariableDeclaration */ :
                        if (isBindingPattern(node.name) && !node.name.elements.length) return false;
                    case 266 /* ModuleDeclaration */ :
                    case 262 /* ClassDeclaration */ :
                    case 263 /* InterfaceDeclaration */ :
                    case 264 /* TypeAliasDeclaration */ :
                    case 261 /* FunctionDeclaration */ :
                    case 265 /* EnumDeclaration */ :
                    case 270 /* ImportEqualsDeclaration */ :
                        if (isExternalModuleAugmentation(node)) return true;
                        const parent2 = getDeclarationContainer(node);
                        if (!(getCombinedModifierFlags(node) & 1 /* Export */ ) && !(node.kind !== 270 /* ImportEqualsDeclaration */  && parent2.kind !== 311 /* SourceFile */  && parent2.flags & 16777216 /* Ambient */ )) return isGlobalSourceFile(parent2);
                        return isDeclarationVisible(parent2);
                    case 171 /* PropertyDeclaration */ :
                    case 170 /* PropertySignature */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                    case 173 /* MethodDeclaration */ :
                    case 172 /* MethodSignature */ :
                        if (hasEffectiveModifier(node, 24 /* Protected */ )) return false;
                    case 175 /* Constructor */ :
                    case 179 /* ConstructSignature */ :
                    case 178 /* CallSignature */ :
                    case 180 /* IndexSignature */ :
                    case 168 /* Parameter */ :
                    case 267 /* ModuleBlock */ :
                    case 183 /* FunctionType */ :
                    case 184 /* ConstructorType */ :
                    case 186 /* TypeLiteral */ :
                    case 182 /* TypeReference */ :
                    case 187 /* ArrayType */ :
                    case 188 /* TupleType */ :
                    case 191 /* UnionType */ :
                    case 192 /* IntersectionType */ :
                    case 195 /* ParenthesizedType */ :
                    case 201 /* NamedTupleMember */ :
                        return isDeclarationVisible(node.parent);
                    case 272 /* ImportClause */ :
                    case 273 /* NamespaceImport */ :
                    case 275 /* ImportSpecifier */ :
                        return false;
                    case 167 /* TypeParameter */ :
                    case 311 /* SourceFile */ :
                    case 269 /* NamespaceExportDeclaration */ :
                        return true;
                    case 276 /* ExportAssignment */ :
                        return false;
                    default:
                        return false;
                }
            }
        }
        function collectLinkedAliases(node, setVisibility) {
            let exportSymbol;
            if (node.parent && node.parent.kind === 276 /* ExportAssignment */ ) exportSymbol = resolveName(node, node.escapedText, 2998271 /* Alias */ , /*nameNotFoundMessage*/ void 0, node, /*isUse*/ false);
            else if (node.parent.kind === 280 /* ExportSpecifier */ ) exportSymbol = getTargetOfExportSpecifier(node.parent, 2998271 /* Alias */ );
            let result;
            let visited;
            if (exportSymbol) {
                visited = /* @__PURE__ */ new Set();
                visited.add(getSymbolId(exportSymbol));
                buildVisibleNodeList(exportSymbol.declarations);
            }
            return result;
            function buildVisibleNodeList(declarations) {
                forEach(declarations, (declaration)=>{
                    const resultNode = getAnyImportSyntax(declaration) || declaration;
                    if (setVisibility) getNodeLinks(declaration).isVisible = true;
                    else {
                        result = result || [];
                        pushIfUnique(result, resultNode);
                    }
                    if (isInternalModuleImportEqualsDeclaration(declaration)) {
                        const internalModuleReference = declaration.moduleReference;
                        const firstIdentifier = getFirstIdentifier(internalModuleReference);
                        const importSymbol = resolveName(declaration, firstIdentifier.escapedText, 901119 /* Namespace */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false);
                        if (importSymbol && visited) {
                            if (tryAddToSet(visited, getSymbolId(importSymbol))) buildVisibleNodeList(importSymbol.declarations);
                        }
                    }
                });
            }
        }
        function pushTypeResolution(target, propertyName) {
            const resolutionCycleStartIndex = findResolutionCycleStartIndex(target, propertyName);
            if (resolutionCycleStartIndex >= 0) {
                const { length: length2  } = resolutionTargets;
                for(let i = resolutionCycleStartIndex; i < length2; i++)resolutionResults[i] = false;
                return false;
            }
            resolutionTargets.push(target);
            resolutionResults.push(/*items*/ true);
            resolutionPropertyNames.push(propertyName);
            return true;
        }
        function findResolutionCycleStartIndex(target, propertyName) {
            for(let i = resolutionTargets.length - 1; i >= resolutionStart; i--){
                if (resolutionTargetHasProperty(resolutionTargets[i], resolutionPropertyNames[i])) return -1;
                if (resolutionTargets[i] === target && resolutionPropertyNames[i] === propertyName) return i;
            }
            return -1;
        }
        function resolutionTargetHasProperty(target, propertyName) {
            switch(propertyName){
                case 0 /* Type */ :
                    return !!getSymbolLinks(target).type;
                case 5 /* EnumTagType */ :
                    return !!getNodeLinks(target).resolvedEnumType;
                case 2 /* DeclaredType */ :
                    return !!getSymbolLinks(target).declaredType;
                case 1 /* ResolvedBaseConstructorType */ :
                    return !!target.resolvedBaseConstructorType;
                case 3 /* ResolvedReturnType */ :
                    return !!target.resolvedReturnType;
                case 4 /* ImmediateBaseConstraint */ :
                    return !!target.immediateBaseConstraint;
                case 6 /* ResolvedTypeArguments */ :
                    return !!target.resolvedTypeArguments;
                case 7 /* ResolvedBaseTypes */ :
                    return !!target.baseTypesResolved;
                case 8 /* WriteType */ :
                    return !!getSymbolLinks(target).writeType;
                case 9 /* ParameterInitializerContainsUndefined */ :
                    return getNodeLinks(target).parameterInitializerContainsUndefined !== void 0;
            }
            return Debug.assertNever(propertyName);
        }
        function popTypeResolution() {
            resolutionTargets.pop();
            resolutionPropertyNames.pop();
            return resolutionResults.pop();
        }
        function getDeclarationContainer(node) {
            return findAncestor(getRootDeclaration(node), (node2)=>{
                switch(node2.kind){
                    case 259 /* VariableDeclaration */ :
                    case 260 /* VariableDeclarationList */ :
                    case 275 /* ImportSpecifier */ :
                    case 274 /* NamedImports */ :
                    case 273 /* NamespaceImport */ :
                    case 272 /* ImportClause */ :
                        return false;
                    default:
                        return true;
                }
            }).parent;
        }
        function getTypeOfPrototypeProperty(prototype) {
            const classType = getDeclaredTypeOfSymbol(getParentOfSymbol(prototype));
            return classType.typeParameters ? createTypeReference(classType, map(classType.typeParameters, (_)=>anyType)) : classType;
        }
        function getTypeOfPropertyOfType(type, name) {
            const prop = getPropertyOfType(type, name);
            return prop ? getTypeOfSymbol(prop) : void 0;
        }
        function getTypeOfPropertyOrIndexSignature(type, name) {
            var _a;
            return getTypeOfPropertyOfType(type, name) || ((_a = getApplicableIndexInfoForName(type, name)) == null ? void 0 : _a.type) || unknownType;
        }
        function isTypeAny(type) {
            return type && (type.flags & 1 /* Any */ ) !== 0;
        }
        function isErrorType(type) {
            return type === errorType || !!(type.flags & 1 /* Any */  && type.aliasSymbol);
        }
        function getTypeForBindingElementParent(node, checkMode) {
            if (checkMode !== 0 /* Normal */ ) return getTypeForVariableLikeDeclaration(node, /*includeOptionality*/ false, checkMode);
            const symbol = getSymbolOfDeclaration(node);
            return symbol && getSymbolLinks(symbol).type || getTypeForVariableLikeDeclaration(node, /*includeOptionality*/ false, checkMode);
        }
        function getRestType(source, properties, symbol) {
            source = filterType(source, (t)=>!(t.flags & 98304 /* Nullable */ ));
            if (source.flags & 131072 /* Never */ ) return emptyObjectType;
            if (source.flags & 1048576 /* Union */ ) return mapType(source, (t)=>getRestType(t, properties, symbol));
            let omitKeyType = getUnionType(map(properties, getLiteralTypeFromPropertyName));
            const spreadableProperties = [];
            const unspreadableToRestKeys = [];
            for (const prop of getPropertiesOfType(source)){
                const literalTypeFromProperty = getLiteralTypeFromProperty(prop, 8576 /* StringOrNumberLiteralOrUnique */ );
                if (!isTypeAssignableTo(literalTypeFromProperty, omitKeyType) && !(getDeclarationModifierFlagsFromSymbol(prop) & 24 /* Protected */ ) && isSpreadableProperty(prop)) spreadableProperties.push(prop);
                else unspreadableToRestKeys.push(literalTypeFromProperty);
            }
            if (isGenericObjectType(source) || isGenericIndexType(omitKeyType)) {
                if (unspreadableToRestKeys.length) omitKeyType = getUnionType([
                    omitKeyType,
                    ...unspreadableToRestKeys
                ]);
                if (omitKeyType.flags & 131072 /* Never */ ) return source;
                const omitTypeAlias = getGlobalOmitSymbol();
                if (!omitTypeAlias) return errorType;
                return getTypeAliasInstantiation(omitTypeAlias, [
                    source,
                    omitKeyType
                ]);
            }
            const members = createSymbolTable();
            for (const prop of spreadableProperties)members.set(prop.escapedName, getSpreadSymbol(prop, /*readonly*/ false));
            const result = createAnonymousType(symbol, members, emptyArray, emptyArray, getIndexInfosOfType(source));
            result.objectFlags |= 4194304 /* ObjectRestType */ ;
            return result;
        }
        function isGenericTypeWithUndefinedConstraint(type) {
            return !!(type.flags & 465829888 /* Instantiable */ ) && maybeTypeOfKind(getBaseConstraintOfType(type) || unknownType, 32768 /* Undefined */ );
        }
        function getNonUndefinedType(type) {
            const typeOrConstraint = someType(type, isGenericTypeWithUndefinedConstraint) ? mapType(type, (t)=>t.flags & 465829888 /* Instantiable */  ? getBaseConstraintOrType(t) : t) : type;
            return getTypeWithFacts(typeOrConstraint, 524288 /* NEUndefined */ );
        }
        function getFlowTypeOfDestructuring(node, declaredType) {
            const reference = getSyntheticElementAccess(node);
            return reference ? getFlowTypeOfReference(reference, declaredType) : declaredType;
        }
        function getSyntheticElementAccess(node) {
            const parentAccess = getParentElementAccess(node);
            if (parentAccess && canHaveFlowNode(parentAccess) && parentAccess.flowNode) {
                const propName = getDestructuringPropertyName(node);
                if (propName) {
                    const literal = setTextRange(parseNodeFactory.createStringLiteral(propName), node);
                    const lhsExpr = isLeftHandSideExpression(parentAccess) ? parentAccess : parseNodeFactory.createParenthesizedExpression(parentAccess);
                    const result = setTextRange(parseNodeFactory.createElementAccessExpression(lhsExpr, literal), node);
                    setParent(literal, result);
                    setParent(result, node);
                    if (lhsExpr !== parentAccess) setParent(lhsExpr, result);
                    result.flowNode = parentAccess.flowNode;
                    return result;
                }
            }
        }
        function getParentElementAccess(node) {
            const ancestor = node.parent.parent;
            switch(ancestor.kind){
                case 207 /* BindingElement */ :
                case 302 /* PropertyAssignment */ :
                    return getSyntheticElementAccess(ancestor);
                case 208 /* ArrayLiteralExpression */ :
                    return getSyntheticElementAccess(node.parent);
                case 259 /* VariableDeclaration */ :
                    return ancestor.initializer;
                case 225 /* BinaryExpression */ :
                    return ancestor.right;
            }
        }
        function getDestructuringPropertyName(node) {
            const parent2 = node.parent;
            if (node.kind === 207 /* BindingElement */  && parent2.kind === 205 /* ObjectBindingPattern */ ) return getLiteralPropertyNameText(node.propertyName || node.name);
            if (node.kind === 302 /* PropertyAssignment */  || node.kind === 303 /* ShorthandPropertyAssignment */ ) return getLiteralPropertyNameText(node.name);
            return "" + parent2.elements.indexOf(node);
        }
        function getLiteralPropertyNameText(name) {
            const type = getLiteralTypeFromPropertyName(name);
            return type.flags & 384 /* NumberLiteral */  ? "" + type.value : void 0;
        }
        function getTypeForBindingElement(declaration) {
            const checkMode = declaration.dotDotDotToken ? 64 /* RestBindingElement */  : 0 /* Normal */ ;
            const parentType = getTypeForBindingElementParent(declaration.parent.parent, checkMode);
            return parentType && getBindingElementTypeFromParentType(declaration, parentType);
        }
        function getBindingElementTypeFromParentType(declaration, parentType) {
            if (isTypeAny(parentType)) return parentType;
            const pattern = declaration.parent;
            if (strictNullChecks && declaration.flags & 16777216 /* Ambient */  && isParameterDeclaration(declaration)) parentType = getNonNullableType(parentType);
            else if (strictNullChecks && pattern.parent.initializer && !(getTypeFacts(getTypeOfInitializer(pattern.parent.initializer)) & 65536 /* EQUndefined */ )) parentType = getTypeWithFacts(parentType, 524288 /* NEUndefined */ );
            let type;
            if (pattern.kind === 205 /* ObjectBindingPattern */ ) {
                if (declaration.dotDotDotToken) {
                    parentType = getReducedType(parentType);
                    if (parentType.flags & 2 /* Unknown */  || !isValidSpreadType(parentType)) {
                        error(declaration, Diagnostics.Rest_types_may_only_be_created_from_object_types);
                        return errorType;
                    }
                    const literalMembers = [];
                    for (const element of pattern.elements)if (!element.dotDotDotToken) literalMembers.push(element.propertyName || element.name);
                    type = getRestType(parentType, literalMembers, declaration.symbol);
                } else {
                    const name = declaration.propertyName || declaration.name;
                    const indexType = getLiteralTypeFromPropertyName(name);
                    const declaredType = getIndexedAccessType(parentType, indexType, 32 /* ExpressionPosition */ , name);
                    type = getFlowTypeOfDestructuring(declaration, declaredType);
                }
            } else {
                const elementType = checkIteratedTypeOrElementType(65 /* Destructuring */  | (declaration.dotDotDotToken ? 0 : 128 /* PossiblyOutOfBounds */ ), parentType, undefinedType, pattern);
                const index = pattern.elements.indexOf(declaration);
                if (declaration.dotDotDotToken) {
                    const baseConstraint = mapType(parentType, (t)=>t.flags & 58982400 /* InstantiableNonPrimitive */  ? getBaseConstraintOrType(t) : t);
                    type = everyType(baseConstraint, isTupleType) ? mapType(baseConstraint, (t)=>sliceTupleType(t, index)) : createArrayType(elementType);
                } else if (isArrayLikeType(parentType)) {
                    const indexType = getNumberLiteralType(index);
                    const accessFlags = 32 /* ExpressionPosition */  | (hasDefaultValue(declaration) ? 16 /* NoTupleBoundsCheck */  : 0);
                    const declaredType = getIndexedAccessTypeOrUndefined(parentType, indexType, accessFlags, declaration.name) || errorType;
                    type = getFlowTypeOfDestructuring(declaration, declaredType);
                } else type = elementType;
            }
            if (!declaration.initializer) return type;
            if (getEffectiveTypeAnnotationNode(walkUpBindingElementsAndPatterns(declaration))) return strictNullChecks && !(getTypeFacts(checkDeclarationInitializer(declaration, 0 /* Normal */ )) & 16777216 /* IsUndefined */ ) ? getNonUndefinedType(type) : type;
            return widenTypeInferredFromInitializer(declaration, getUnionType([
                getNonUndefinedType(type),
                checkDeclarationInitializer(declaration, 0 /* Normal */ )
            ], 2 /* Subtype */ ));
        }
        function getTypeForDeclarationFromJSDocComment(declaration) {
            const jsdocType = getJSDocType(declaration);
            if (jsdocType) return getTypeFromTypeNode(jsdocType);
            return void 0;
        }
        function isNullOrUndefined3(node) {
            const expr = skipParentheses(node, /*excludeJSDocTypeAssertions*/ true);
            return expr.kind === 106 /* NullKeyword */  || expr.kind === 80 /* Identifier */  && getResolvedSymbol(expr) === undefinedSymbol;
        }
        function isEmptyArrayLiteral2(node) {
            const expr = skipParentheses(node, /*excludeJSDocTypeAssertions*/ true);
            return expr.kind === 208 /* ArrayLiteralExpression */  && expr.elements.length === 0;
        }
        function addOptionality(type, isProperty = false, isOptional = true) {
            return strictNullChecks && isOptional ? getOptionalType(type, isProperty) : type;
        }
        function getTypeForVariableLikeDeclaration(declaration, includeOptionality, checkMode) {
            if (isVariableDeclaration(declaration) && declaration.parent.parent.kind === 248 /* ForInStatement */ ) {
                const indexType = getIndexType(getNonNullableTypeIfNeeded(checkExpression(declaration.parent.parent.expression, /*checkMode*/ checkMode)));
                return indexType.flags & 4456448 /* Index */  ? getExtractStringType(indexType) : stringType;
            }
            if (isVariableDeclaration(declaration) && declaration.parent.parent.kind === 249 /* ForOfStatement */ ) {
                const forOfStatement = declaration.parent.parent;
                return checkRightHandSideOfForOf(forOfStatement) || anyType;
            }
            if (isBindingPattern(declaration.parent)) return getTypeForBindingElement(declaration);
            const isProperty = isPropertyDeclaration(declaration) && !hasAccessorModifier(declaration) || isPropertySignature(declaration) || isJSDocPropertyTag(declaration);
            const isOptional = includeOptionality && isOptionalDeclaration(declaration);
            const declaredType = tryGetTypeFromEffectiveTypeNode(declaration);
            if (isCatchClauseVariableDeclarationOrBindingElement(declaration)) {
                if (declaredType) return isTypeAny(declaredType) || declaredType === unknownType ? declaredType : errorType;
                return useUnknownInCatchVariables ? unknownType : anyType;
            }
            if (declaredType) return addOptionality(declaredType, isProperty, isOptional);
            if ((noImplicitAny || isInJSFile(declaration)) && isVariableDeclaration(declaration) && !isBindingPattern(declaration.name) && !(getCombinedModifierFlags(declaration) & 1 /* Export */ ) && !(declaration.flags & 16777216 /* Ambient */ )) {
                if (!(getCombinedNodeFlags(declaration) & 2 /* Const */ ) && (!declaration.initializer || isNullOrUndefined3(declaration.initializer))) return autoType;
                if (declaration.initializer && isEmptyArrayLiteral2(declaration.initializer)) return autoArrayType;
            }
            if (isParameter(declaration)) {
                const func = declaration.parent;
                if (func.kind === 177 /* SetAccessor */  && hasBindableName(func)) {
                    const getter = getDeclarationOfKind(getSymbolOfDeclaration(declaration.parent), 176 /* GetAccessor */ );
                    if (getter) {
                        const getterSignature = getSignatureFromDeclaration(getter);
                        const thisParameter = getAccessorThisParameter(func);
                        if (thisParameter && declaration === thisParameter) {
                            Debug.assert(!thisParameter.type);
                            return getTypeOfSymbol(getterSignature.thisParameter);
                        }
                        return getReturnTypeOfSignature(getterSignature);
                    }
                }
                const parameterTypeOfTypeTag = getParameterTypeOfTypeTag(func, declaration);
                if (parameterTypeOfTypeTag) return parameterTypeOfTypeTag;
                const type = declaration.symbol.escapedName === "this" /* This */  ? getContextualThisParameterType(func) : getContextuallyTypedParameterType(declaration);
                if (type) return addOptionality(type, /*isProperty*/ false, isOptional);
            }
            if (hasOnlyExpressionInitializer(declaration) && !!declaration.initializer) {
                if (isInJSFile(declaration) && !isParameter(declaration)) {
                    const containerObjectType = getJSContainerObjectType(declaration, getSymbolOfDeclaration(declaration), getDeclaredExpandoInitializer(declaration));
                    if (containerObjectType) return containerObjectType;
                }
                const type = widenTypeInferredFromInitializer(declaration, checkDeclarationInitializer(declaration, checkMode));
                return addOptionality(type, isProperty, isOptional);
            }
            if (isPropertyDeclaration(declaration) && (noImplicitAny || isInJSFile(declaration))) {
                if (!hasStaticModifier(declaration)) {
                    const constructor = findConstructorDeclaration(declaration.parent);
                    const type = constructor ? getFlowTypeInConstructor(declaration.symbol, constructor) : getEffectiveModifierFlags(declaration) & 2 /* Ambient */  ? getTypeOfPropertyInBaseClass(declaration.symbol) : void 0;
                    return type && addOptionality(type, /*isProperty*/ true, isOptional);
                } else {
                    const staticBlocks = filter(declaration.parent.members, isClassStaticBlockDeclaration);
                    const type = staticBlocks.length ? getFlowTypeInStaticBlocks(declaration.symbol, staticBlocks) : getEffectiveModifierFlags(declaration) & 2 /* Ambient */  ? getTypeOfPropertyInBaseClass(declaration.symbol) : void 0;
                    return type && addOptionality(type, /*isProperty*/ true, isOptional);
                }
            }
            if (isJsxAttribute(declaration)) return trueType;
            if (isBindingPattern(declaration.name)) return getTypeFromBindingPattern(declaration.name, /*includePatternInType*/ false, /*reportErrors*/ true);
            return void 0;
        }
        function isConstructorDeclaredProperty(symbol) {
            if (symbol.valueDeclaration && isBinaryExpression(symbol.valueDeclaration)) {
                const links = getSymbolLinks(symbol);
                if (links.isConstructorDeclaredProperty === void 0) {
                    links.isConstructorDeclaredProperty = false;
                    links.isConstructorDeclaredProperty = !!getDeclaringConstructor(symbol) && every(symbol.declarations, (declaration)=>isBinaryExpression(declaration) && isPossiblyAliasedThisProperty(declaration) && (declaration.left.kind !== 211 /* ElementAccessExpression */  || isStringOrNumericLiteralLike(declaration.left.argumentExpression)) && !getAnnotatedTypeForAssignmentDeclaration(/*declaredType*/ void 0, declaration, symbol, declaration));
                }
                return links.isConstructorDeclaredProperty;
            }
            return false;
        }
        function isAutoTypedProperty(symbol) {
            const declaration = symbol.valueDeclaration;
            return declaration && isPropertyDeclaration(declaration) && !getEffectiveTypeAnnotationNode(declaration) && !declaration.initializer && (noImplicitAny || isInJSFile(declaration));
        }
        function getDeclaringConstructor(symbol) {
            if (!symbol.declarations) return;
            for (const declaration of symbol.declarations){
                const container = getThisContainer(declaration, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                if (container && (container.kind === 175 /* Constructor */  || isJSConstructor(container))) return container;
            }
        }
        function getFlowTypeFromCommonJSExport(symbol) {
            const file = getSourceFileOfNode(symbol.declarations[0]);
            const accessName = unescapeLeadingUnderscores(symbol.escapedName);
            const areAllModuleExports = symbol.declarations.every((d)=>isInJSFile(d) && isAccessExpression(d) && isModuleExportsAccessExpression(d.expression));
            const reference = areAllModuleExports ? factory.createPropertyAccessExpression(factory.createPropertyAccessExpression(factory.createIdentifier("module"), factory.createIdentifier("exports")), accessName) : factory.createPropertyAccessExpression(factory.createIdentifier("exports"), accessName);
            if (areAllModuleExports) setParent(reference.expression.expression, reference.expression);
            setParent(reference.expression, reference);
            setParent(reference, file);
            reference.flowNode = file.endFlowNode;
            return getFlowTypeOfReference(reference, autoType, undefinedType);
        }
        function getFlowTypeInStaticBlocks(symbol, staticBlocks) {
            const accessName = startsWith(symbol.escapedName, "__#") ? factory.createPrivateIdentifier(symbol.escapedName.split("@")[1]) : unescapeLeadingUnderscores(symbol.escapedName);
            for (const staticBlock of staticBlocks){
                const reference = factory.createPropertyAccessExpression(factory.createThis(), accessName);
                setParent(reference.expression, reference);
                setParent(reference, staticBlock);
                reference.flowNode = staticBlock.returnFlowNode;
                const flowType = getFlowTypeOfProperty(reference, symbol);
                if (noImplicitAny && (flowType === autoType || flowType === autoArrayType)) error(symbol.valueDeclaration, Diagnostics.Member_0_implicitly_has_an_1_type, symbolToString(symbol), typeToString(flowType));
                if (everyType(flowType, isNullableType)) continue;
                return convertAutoToAny(flowType);
            }
        }
        function getFlowTypeInConstructor(symbol, constructor) {
            const accessName = startsWith(symbol.escapedName, "__#") ? factory.createPrivateIdentifier(symbol.escapedName.split("@")[1]) : unescapeLeadingUnderscores(symbol.escapedName);
            const reference = factory.createPropertyAccessExpression(factory.createThis(), accessName);
            setParent(reference.expression, reference);
            setParent(reference, constructor);
            reference.flowNode = constructor.returnFlowNode;
            const flowType = getFlowTypeOfProperty(reference, symbol);
            if (noImplicitAny && (flowType === autoType || flowType === autoArrayType)) error(symbol.valueDeclaration, Diagnostics.Member_0_implicitly_has_an_1_type, symbolToString(symbol), typeToString(flowType));
            return everyType(flowType, isNullableType) ? void 0 : convertAutoToAny(flowType);
        }
        function getFlowTypeOfProperty(reference, prop) {
            const initialType = (prop == null ? void 0 : prop.valueDeclaration) && (!isAutoTypedProperty(prop) || getEffectiveModifierFlags(prop.valueDeclaration) & 2 /* Ambient */ ) && getTypeOfPropertyInBaseClass(prop) || undefinedType;
            return getFlowTypeOfReference(reference, autoType, initialType);
        }
        function getWidenedTypeForAssignmentDeclaration(symbol, resolvedSymbol) {
            const container = getAssignedExpandoInitializer(symbol.valueDeclaration);
            if (container) {
                const tag = isInJSFile(container) ? getJSDocTypeTag(container) : void 0;
                if (tag && tag.typeExpression) return getTypeFromTypeNode(tag.typeExpression);
                const containerObjectType = symbol.valueDeclaration && getJSContainerObjectType(symbol.valueDeclaration, symbol, container);
                return containerObjectType || getWidenedLiteralType(checkExpressionCached(container));
            }
            let type;
            let definedInConstructor = false;
            let definedInMethod = false;
            if (isConstructorDeclaredProperty(symbol)) type = getFlowTypeInConstructor(symbol, getDeclaringConstructor(symbol));
            if (!type) {
                let types;
                if (symbol.declarations) {
                    let jsdocType;
                    for (const declaration of symbol.declarations){
                        const expression = isBinaryExpression(declaration) || isCallExpression(declaration) ? declaration : isAccessExpression(declaration) ? isBinaryExpression(declaration.parent) ? declaration.parent : declaration : void 0;
                        if (!expression) continue;
                        const kind = isAccessExpression(expression) ? getAssignmentDeclarationPropertyAccessKind(expression) : getAssignmentDeclarationKind(expression);
                        if (kind === 4 /* ThisProperty */  || isBinaryExpression(expression) && isPossiblyAliasedThisProperty(expression, kind)) {
                            if (isDeclarationInConstructor(expression)) definedInConstructor = true;
                            else definedInMethod = true;
                        }
                        if (!isCallExpression(expression)) jsdocType = getAnnotatedTypeForAssignmentDeclaration(jsdocType, expression, symbol, declaration);
                        if (!jsdocType) (types || (types = [])).push(isBinaryExpression(expression) || isCallExpression(expression) ? getInitializerTypeFromAssignmentDeclaration(symbol, resolvedSymbol, expression, kind) : neverType);
                    }
                    type = jsdocType;
                }
                if (!type) {
                    if (!length(types)) return errorType;
                    let constructorTypes = definedInConstructor && symbol.declarations ? getConstructorDefinedThisAssignmentTypes(types, symbol.declarations) : void 0;
                    if (definedInMethod) {
                        const propType = getTypeOfPropertyInBaseClass(symbol);
                        if (propType) {
                            (constructorTypes || (constructorTypes = [])).push(propType);
                            definedInConstructor = true;
                        }
                    }
                    const sourceTypes = some(constructorTypes, (t)=>!!(t.flags & -98305 /* Nullable */ )) ? constructorTypes : types;
                    type = getUnionType(sourceTypes);
                }
            }
            const widened = getWidenedType(addOptionality(type, /*isProperty*/ false, definedInMethod && !definedInConstructor));
            if (symbol.valueDeclaration && filterType(widened, (t)=>!!(t.flags & -98305 /* Nullable */ )) === neverType) {
                reportImplicitAny(symbol.valueDeclaration, anyType);
                return anyType;
            }
            return widened;
        }
        function getJSContainerObjectType(decl, symbol, init) {
            var _a, _b;
            if (!isInJSFile(decl) || !init || !isObjectLiteralExpression(init) || init.properties.length) return void 0;
            const exports = createSymbolTable();
            while(isBinaryExpression(decl) || isPropertyAccessExpression(decl)){
                const s2 = getSymbolOfNode(decl);
                if ((_a = s2 == null ? void 0 : s2.exports) == null ? void 0 : _a.size) mergeSymbolTable(exports, s2.exports);
                decl = isBinaryExpression(decl) ? decl.parent : decl.parent.parent;
            }
            const s = getSymbolOfNode(decl);
            if ((_b = s == null ? void 0 : s.exports) == null ? void 0 : _b.size) mergeSymbolTable(exports, s.exports);
            const type = createAnonymousType(symbol, exports, emptyArray, emptyArray, emptyArray);
            type.objectFlags |= 4096 /* JSLiteral */ ;
            return type;
        }
        function getAnnotatedTypeForAssignmentDeclaration(declaredType, expression, symbol, declaration) {
            var _a;
            const typeNode = getEffectiveTypeAnnotationNode(expression.parent);
            if (typeNode) {
                const type = getWidenedType(getTypeFromTypeNode(typeNode));
                if (!declaredType) return type;
                else if (!isErrorType(declaredType) && !isErrorType(type) && !isTypeIdenticalTo(declaredType, type)) errorNextVariableOrPropertyDeclarationMustHaveSameType(/*firstDeclaration*/ void 0, declaredType, declaration, type);
            }
            if ((_a = symbol.parent) == null ? void 0 : _a.valueDeclaration) {
                const typeNode2 = getEffectiveTypeAnnotationNode(symbol.parent.valueDeclaration);
                if (typeNode2) {
                    const annotationSymbol = getPropertyOfType(getTypeFromTypeNode(typeNode2), symbol.escapedName);
                    if (annotationSymbol) return getNonMissingTypeOfSymbol(annotationSymbol);
                }
            }
            return declaredType;
        }
        function getInitializerTypeFromAssignmentDeclaration(symbol, resolvedSymbol, expression, kind) {
            if (isCallExpression(expression)) {
                if (resolvedSymbol) return getTypeOfSymbol(resolvedSymbol);
                const objectLitType = checkExpressionCached(expression.arguments[2]);
                const valueType = getTypeOfPropertyOfType(objectLitType, "value");
                if (valueType) return valueType;
                const getFunc = getTypeOfPropertyOfType(objectLitType, "get");
                if (getFunc) {
                    const getSig = getSingleCallSignature(getFunc);
                    if (getSig) return getReturnTypeOfSignature(getSig);
                }
                const setFunc = getTypeOfPropertyOfType(objectLitType, "set");
                if (setFunc) {
                    const setSig = getSingleCallSignature(setFunc);
                    if (setSig) return getTypeOfFirstParameterOfSignature(setSig);
                }
                return anyType;
            }
            if (containsSameNamedThisProperty(expression.left, expression.right)) return anyType;
            const isDirectExport = kind === 1 /* ExportsProperty */  && (isPropertyAccessExpression(expression.left) || isElementAccessExpression(expression.left)) && (isModuleExportsAccessExpression(expression.left.expression) || isIdentifier(expression.left.expression) && isExportsIdentifier(expression.left.expression));
            const type = resolvedSymbol ? getTypeOfSymbol(resolvedSymbol) : isDirectExport ? getRegularTypeOfLiteralType(checkExpressionCached(expression.right)) : getWidenedLiteralType(checkExpressionCached(expression.right));
            if (type.flags & 524288 /* Object */  && kind === 2 /* ModuleExports */  && symbol.escapedName === "export=" /* ExportEquals */ ) {
                const exportedType = resolveStructuredTypeMembers(type);
                const members = createSymbolTable();
                copyEntries(exportedType.members, members);
                const initialSize = members.size;
                if (resolvedSymbol && !resolvedSymbol.exports) resolvedSymbol.exports = createSymbolTable();
                (resolvedSymbol || symbol).exports.forEach((s, name)=>{
                    var _a;
                    const exportedMember = members.get(name);
                    if (exportedMember && exportedMember !== s && !(s.flags & 2097152 /* Alias */ )) {
                        if (s.flags & 111551 /* Value */  && exportedMember.flags & 111551 /* Value */ ) {
                            if (s.valueDeclaration && exportedMember.valueDeclaration && getSourceFileOfNode(s.valueDeclaration) !== getSourceFileOfNode(exportedMember.valueDeclaration)) {
                                const unescapedName = unescapeLeadingUnderscores(s.escapedName);
                                const exportedMemberName = ((_a = tryCast(exportedMember.valueDeclaration, isNamedDeclaration)) == null ? void 0 : _a.name) || exportedMember.valueDeclaration;
                                addRelatedInfo(error(s.valueDeclaration, Diagnostics.Duplicate_identifier_0, unescapedName), createDiagnosticForNode(exportedMemberName, Diagnostics._0_was_also_declared_here, unescapedName));
                                addRelatedInfo(error(exportedMemberName, Diagnostics.Duplicate_identifier_0, unescapedName), createDiagnosticForNode(s.valueDeclaration, Diagnostics._0_was_also_declared_here, unescapedName));
                            }
                            const union = createSymbol(s.flags | exportedMember.flags, name);
                            union.links.type = getUnionType([
                                getTypeOfSymbol(s),
                                getTypeOfSymbol(exportedMember)
                            ]);
                            union.valueDeclaration = exportedMember.valueDeclaration;
                            union.declarations = concatenate(exportedMember.declarations, s.declarations);
                            members.set(name, union);
                        } else members.set(name, mergeSymbol(s, exportedMember));
                    } else members.set(name, s);
                });
                const result = createAnonymousType(initialSize !== members.size ? void 0 : exportedType.symbol, // Only set the type's symbol if it looks to be the same as the original type
                members, exportedType.callSignatures, exportedType.constructSignatures, exportedType.indexInfos);
                if (initialSize === members.size) {
                    if (type.aliasSymbol) {
                        result.aliasSymbol = type.aliasSymbol;
                        result.aliasTypeArguments = type.aliasTypeArguments;
                    }
                    if (getObjectFlags(type) & 4 /* Reference */ ) {
                        result.aliasSymbol = type.symbol;
                        const args = getTypeArguments(type);
                        result.aliasTypeArguments = length(args) ? args : void 0;
                    }
                }
                result.objectFlags |= getObjectFlags(type) & 4096 /* JSLiteral */ ;
                if (result.symbol && result.symbol.flags & 32 /* Class */  && type === getDeclaredTypeOfClassOrInterface(result.symbol)) result.objectFlags |= 16777216 /* IsClassInstanceClone */ ;
                return result;
            }
            if (isEmptyArrayLiteralType(type)) {
                reportImplicitAny(expression, anyArrayType);
                return anyArrayType;
            }
            return type;
        }
        function containsSameNamedThisProperty(thisProperty, expression) {
            return isPropertyAccessExpression(thisProperty) && thisProperty.expression.kind === 110 /* ThisKeyword */  && forEachChildRecursively(expression, (n)=>isMatchingReference(thisProperty, n));
        }
        function isDeclarationInConstructor(expression) {
            const thisContainer = getThisContainer(expression, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            return thisContainer.kind === 175 /* Constructor */  || thisContainer.kind === 261 /* FunctionDeclaration */  || thisContainer.kind === 217 /* FunctionExpression */  && !isPrototypePropertyAssignment(thisContainer.parent);
        }
        function getConstructorDefinedThisAssignmentTypes(types, declarations) {
            Debug.assert(types.length === declarations.length);
            return types.filter((_, i)=>{
                const declaration = declarations[i];
                const expression = isBinaryExpression(declaration) ? declaration : isBinaryExpression(declaration.parent) ? declaration.parent : void 0;
                return expression && isDeclarationInConstructor(expression);
            });
        }
        function getTypeFromBindingElement(element, includePatternInType, reportErrors2) {
            if (element.initializer) {
                const contextualType = isBindingPattern(element.name) ? getTypeFromBindingPattern(element.name, /*includePatternInType*/ true, /*reportErrors*/ false) : unknownType;
                return addOptionality(widenTypeInferredFromInitializer(element, checkDeclarationInitializer(element, 0 /* Normal */ , contextualType)));
            }
            if (isBindingPattern(element.name)) return getTypeFromBindingPattern(element.name, includePatternInType, reportErrors2);
            if (reportErrors2 && !declarationBelongsToPrivateAmbientMember(element)) reportImplicitAny(element, anyType);
            return includePatternInType ? nonInferrableAnyType : anyType;
        }
        function getTypeFromObjectBindingPattern(pattern, includePatternInType, reportErrors2) {
            const members = createSymbolTable();
            let stringIndexInfo;
            let objectFlags = 131200 /* ContainsObjectOrArrayLiteral */ ;
            forEach(pattern.elements, (e)=>{
                const name = e.propertyName || e.name;
                if (e.dotDotDotToken) {
                    stringIndexInfo = createIndexInfo(stringType, anyType, /*isReadonly*/ false);
                    return;
                }
                const exprType = getLiteralTypeFromPropertyName(name);
                if (!isTypeUsableAsPropertyName(exprType)) {
                    objectFlags |= 512 /* ObjectLiteralPatternWithComputedProperties */ ;
                    return;
                }
                const text = getPropertyNameFromType(exprType);
                const flags = 4 /* Property */  | (e.initializer ? 16777216 /* Optional */  : 0);
                const symbol = createSymbol(flags, text);
                symbol.links.type = getTypeFromBindingElement(e, includePatternInType, reportErrors2);
                symbol.links.bindingElement = e;
                members.set(symbol.escapedName, symbol);
            });
            const result = createAnonymousType(/*symbol*/ void 0, members, emptyArray, emptyArray, stringIndexInfo ? [
                stringIndexInfo
            ] : emptyArray);
            result.objectFlags |= objectFlags;
            if (includePatternInType) {
                result.pattern = pattern;
                result.objectFlags |= 131072 /* ContainsObjectOrArrayLiteral */ ;
            }
            return result;
        }
        function getTypeFromArrayBindingPattern(pattern, includePatternInType, reportErrors2) {
            const elements = pattern.elements;
            const lastElement = lastOrUndefined(elements);
            const restElement = lastElement && lastElement.kind === 207 /* BindingElement */  && lastElement.dotDotDotToken ? lastElement : void 0;
            if (elements.length === 0 || elements.length === 1 && restElement) return languageVersion >= 2 /* ES2015 */  ? createIterableType(anyType) : anyArrayType;
            const elementTypes = map(elements, (e)=>isOmittedExpression(e) ? anyType : getTypeFromBindingElement(e, includePatternInType, reportErrors2));
            const minLength = findLastIndex(elements, (e)=>!(e === restElement || isOmittedExpression(e) || hasDefaultValue(e)), elements.length - 1) + 1;
            const elementFlags = map(elements, (e, i)=>e === restElement ? 4 /* Rest */  : i >= minLength ? 2 /* Optional */  : 1 /* Required */ );
            let result = createTupleType(elementTypes, elementFlags);
            if (includePatternInType) {
                result = cloneTypeReference(result);
                result.pattern = pattern;
                result.objectFlags |= 131072 /* ContainsObjectOrArrayLiteral */ ;
            }
            return result;
        }
        function getTypeFromBindingPattern(pattern, includePatternInType = false, reportErrors2 = false) {
            return pattern.kind === 205 /* ObjectBindingPattern */  ? getTypeFromObjectBindingPattern(pattern, includePatternInType, reportErrors2) : getTypeFromArrayBindingPattern(pattern, includePatternInType, reportErrors2);
        }
        function getWidenedTypeForVariableLikeDeclaration(declaration, reportErrors2) {
            return widenTypeForVariableLikeDeclaration(getTypeForVariableLikeDeclaration(declaration, /*includeOptionality*/ true, 0 /* Normal */ ), declaration, reportErrors2);
        }
        function isGlobalSymbolConstructor(node) {
            const symbol = getSymbolOfNode(node);
            const globalSymbol = getGlobalESSymbolConstructorTypeSymbol(/*reportErrors*/ false);
            return globalSymbol && symbol && symbol === globalSymbol;
        }
        function widenTypeForVariableLikeDeclaration(type, declaration, reportErrors2) {
            if (type) {
                if (type.flags & 4096 /* ESSymbol */  && isGlobalSymbolConstructor(declaration.parent)) type = getESSymbolLikeTypeForNode(declaration);
                if (reportErrors2) reportErrorsFromWidening(declaration, type);
                if (type.flags & 8192 /* UniqueESSymbol */  && (isBindingElement(declaration) || !declaration.type) && type.symbol !== getSymbolOfDeclaration(declaration)) type = esSymbolType;
                return getWidenedType(type);
            }
            type = isParameter(declaration) && declaration.dotDotDotToken ? anyArrayType : anyType;
            if (reportErrors2) {
                if (!declarationBelongsToPrivateAmbientMember(declaration)) reportImplicitAny(declaration, type);
            }
            return type;
        }
        function declarationBelongsToPrivateAmbientMember(declaration) {
            const root = getRootDeclaration(declaration);
            const memberDeclaration = root.kind === 168 /* Parameter */  ? root.parent : root;
            return isPrivateWithinAmbient(memberDeclaration);
        }
        function tryGetTypeFromEffectiveTypeNode(node) {
            const typeNode = getEffectiveTypeAnnotationNode(node);
            if (typeNode) return getTypeFromTypeNode(typeNode);
        }
        function isParameterOfContextSensitiveSignature(symbol) {
            let decl = symbol.valueDeclaration;
            if (!decl) return false;
            if (isBindingElement(decl)) decl = walkUpBindingElementsAndPatterns(decl);
            if (isParameter(decl)) return isContextSensitiveFunctionOrObjectLiteralMethod(decl.parent);
            return false;
        }
        function getTypeOfVariableOrParameterOrProperty(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.type) {
                const type = getTypeOfVariableOrParameterOrPropertyWorker(symbol);
                if (!links.type && !isParameterOfContextSensitiveSignature(symbol)) links.type = type;
                return type;
            }
            return links.type;
        }
        function getTypeOfVariableOrParameterOrPropertyWorker(symbol) {
            if (symbol.flags & 4194304 /* Prototype */ ) return getTypeOfPrototypeProperty(symbol);
            if (symbol === requireSymbol) return anyType;
            if (symbol.flags & 134217728 /* ModuleExports */  && symbol.valueDeclaration) {
                const fileSymbol = getSymbolOfDeclaration(getSourceFileOfNode(symbol.valueDeclaration));
                const result = createSymbol(fileSymbol.flags, "exports");
                result.declarations = fileSymbol.declarations ? fileSymbol.declarations.slice() : [];
                result.parent = symbol;
                result.links.target = fileSymbol;
                if (fileSymbol.valueDeclaration) result.valueDeclaration = fileSymbol.valueDeclaration;
                if (fileSymbol.members) result.members = new Map(fileSymbol.members);
                if (fileSymbol.exports) result.exports = new Map(fileSymbol.exports);
                const members = createSymbolTable();
                members.set("exports", result);
                return createAnonymousType(symbol, members, emptyArray, emptyArray, emptyArray);
            }
            Debug.assertIsDefined(symbol.valueDeclaration);
            const declaration = symbol.valueDeclaration;
            if (isSourceFile(declaration) && isJsonSourceFile(declaration)) {
                if (!declaration.statements.length) return emptyObjectType;
                return getWidenedType(getWidenedLiteralType(checkExpression(declaration.statements[0].expression)));
            }
            if (isAccessor(declaration)) return getTypeOfAccessors(symbol);
            if (!pushTypeResolution(symbol, 0 /* Type */ )) {
                if (symbol.flags & 512 /* ValueModule */  && !(symbol.flags & 67108864 /* Assignment */ )) return getTypeOfFuncClassEnumModule(symbol);
                return reportCircularityError(symbol);
            }
            let type;
            if (declaration.kind === 276 /* ExportAssignment */ ) type = widenTypeForVariableLikeDeclaration(tryGetTypeFromEffectiveTypeNode(declaration) || checkExpressionCached(declaration.expression), declaration);
            else if (isBinaryExpression(declaration) || isInJSFile(declaration) && (isCallExpression(declaration) || (isPropertyAccessExpression(declaration) || isBindableStaticElementAccessExpression(declaration)) && isBinaryExpression(declaration.parent))) type = getWidenedTypeForAssignmentDeclaration(symbol);
            else if (isPropertyAccessExpression(declaration) || isElementAccessExpression(declaration) || isIdentifier(declaration) || isStringLiteralLike(declaration) || isNumericLiteral(declaration) || isClassDeclaration(declaration) || isFunctionDeclaration(declaration) || isMethodDeclaration(declaration) && !isObjectLiteralMethod(declaration) || isMethodSignature(declaration) || isSourceFile(declaration)) {
                if (symbol.flags & 9136 /* ValueModule */ ) return getTypeOfFuncClassEnumModule(symbol);
                type = isBinaryExpression(declaration.parent) ? getWidenedTypeForAssignmentDeclaration(symbol) : tryGetTypeFromEffectiveTypeNode(declaration) || anyType;
            } else if (isPropertyAssignment(declaration)) type = tryGetTypeFromEffectiveTypeNode(declaration) || checkPropertyAssignment(declaration);
            else if (isJsxAttribute(declaration)) type = tryGetTypeFromEffectiveTypeNode(declaration) || checkJsxAttribute(declaration);
            else if (isShorthandPropertyAssignment(declaration)) type = tryGetTypeFromEffectiveTypeNode(declaration) || checkExpressionForMutableLocation(declaration.name, 0 /* Normal */ );
            else if (isObjectLiteralMethod(declaration)) type = tryGetTypeFromEffectiveTypeNode(declaration) || checkObjectLiteralMethod(declaration, 0 /* Normal */ );
            else if (isParameter(declaration) || isPropertyDeclaration(declaration) || isPropertySignature(declaration) || isVariableDeclaration(declaration) || isBindingElement(declaration) || isJSDocPropertyLikeTag(declaration)) type = getWidenedTypeForVariableLikeDeclaration(declaration, /*reportErrors*/ true);
            else if (isEnumDeclaration(declaration)) type = getTypeOfFuncClassEnumModule(symbol);
            else if (isEnumMember(declaration)) type = getTypeOfEnumMember(symbol);
            else return Debug.fail("Unhandled declaration kind! " + Debug.formatSyntaxKind(declaration.kind) + " for " + Debug.formatSymbol(symbol));
            if (!popTypeResolution()) {
                if (symbol.flags & 512 /* ValueModule */  && !(symbol.flags & 67108864 /* Assignment */ )) return getTypeOfFuncClassEnumModule(symbol);
                return reportCircularityError(symbol);
            }
            return type;
        }
        function getAnnotatedAccessorTypeNode(accessor) {
            if (accessor) switch(accessor.kind){
                case 176 /* GetAccessor */ :
                    const getterTypeAnnotation = getEffectiveReturnTypeNode(accessor);
                    return getterTypeAnnotation;
                case 177 /* SetAccessor */ :
                    const setterTypeAnnotation = getEffectiveSetAccessorTypeAnnotationNode(accessor);
                    return setterTypeAnnotation;
                case 171 /* PropertyDeclaration */ :
                    Debug.assert(hasAccessorModifier(accessor));
                    const accessorTypeAnnotation = getEffectiveTypeAnnotationNode(accessor);
                    return accessorTypeAnnotation;
            }
            return void 0;
        }
        function getAnnotatedAccessorType(accessor) {
            const node = getAnnotatedAccessorTypeNode(accessor);
            return node && getTypeFromTypeNode(node);
        }
        function getAnnotatedAccessorThisParameter(accessor) {
            const parameter = getAccessorThisParameter(accessor);
            return parameter && parameter.symbol;
        }
        function getThisTypeOfDeclaration(declaration) {
            return getThisTypeOfSignature(getSignatureFromDeclaration(declaration));
        }
        function getTypeOfAccessors(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.type) {
                if (!pushTypeResolution(symbol, 0 /* Type */ )) return errorType;
                const getter = getDeclarationOfKind(symbol, 176 /* GetAccessor */ );
                const setter = getDeclarationOfKind(symbol, 177 /* SetAccessor */ );
                const accessor = tryCast(getDeclarationOfKind(symbol, 171 /* PropertyDeclaration */ ), isAutoAccessorPropertyDeclaration);
                let type = getter && isInJSFile(getter) && getTypeForDeclarationFromJSDocComment(getter) || getAnnotatedAccessorType(getter) || getAnnotatedAccessorType(setter) || getAnnotatedAccessorType(accessor) || getter && getter.body && getReturnTypeFromBody(getter) || accessor && accessor.initializer && getWidenedTypeForVariableLikeDeclaration(accessor, /*reportErrors*/ true);
                if (!type) {
                    if (setter && !isPrivateWithinAmbient(setter)) errorOrSuggestion(noImplicitAny, setter, Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation, symbolToString(symbol));
                    else if (getter && !isPrivateWithinAmbient(getter)) errorOrSuggestion(noImplicitAny, getter, Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation, symbolToString(symbol));
                    else if (accessor && !isPrivateWithinAmbient(accessor)) errorOrSuggestion(noImplicitAny, accessor, Diagnostics.Member_0_implicitly_has_an_1_type, symbolToString(symbol), "any");
                    type = anyType;
                }
                if (!popTypeResolution()) {
                    if (getAnnotatedAccessorTypeNode(getter)) error(getter, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
                    else if (getAnnotatedAccessorTypeNode(setter)) error(setter, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
                    else if (getAnnotatedAccessorTypeNode(accessor)) error(setter, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
                    else if (getter && noImplicitAny) error(getter, Diagnostics._0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions, symbolToString(symbol));
                    type = anyType;
                }
                links.type = type;
            }
            return links.type;
        }
        function getWriteTypeOfAccessors(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.writeType) {
                if (!pushTypeResolution(symbol, 8 /* WriteType */ )) return errorType;
                const setter = getDeclarationOfKind(symbol, 177 /* SetAccessor */ ) ?? tryCast(getDeclarationOfKind(symbol, 171 /* PropertyDeclaration */ ), isAutoAccessorPropertyDeclaration);
                let writeType = getAnnotatedAccessorType(setter);
                if (!popTypeResolution()) {
                    if (getAnnotatedAccessorTypeNode(setter)) error(setter, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
                    writeType = anyType;
                }
                links.writeType = writeType || getTypeOfAccessors(symbol);
            }
            return links.writeType;
        }
        function getBaseTypeVariableOfClass(symbol) {
            const baseConstructorType = getBaseConstructorTypeOfClass(getDeclaredTypeOfClassOrInterface(symbol));
            return baseConstructorType.flags & 8650752 /* TypeVariable */  ? baseConstructorType : baseConstructorType.flags & 2097152 /* Intersection */  ? find(baseConstructorType.types, (t)=>!!(t.flags & 8650752 /* TypeVariable */ )) : void 0;
        }
        function getTypeOfFuncClassEnumModule(symbol) {
            let links = getSymbolLinks(symbol);
            const originalLinks = links;
            if (!links.type) {
                const expando = symbol.valueDeclaration && getSymbolOfExpando(symbol.valueDeclaration, /*allowDeclaration*/ false);
                if (expando) {
                    const merged = mergeJSSymbols(symbol, expando);
                    if (merged) {
                        symbol = merged;
                        links = merged.links;
                    }
                }
                originalLinks.type = links.type = getTypeOfFuncClassEnumModuleWorker(symbol);
            }
            return links.type;
        }
        function getTypeOfFuncClassEnumModuleWorker(symbol) {
            const declaration = symbol.valueDeclaration;
            if (symbol.flags & 1536 /* Module */  && isShorthandAmbientModuleSymbol(symbol)) return anyType;
            else if (declaration && (declaration.kind === 225 /* BinaryExpression */  || isAccessExpression(declaration) && declaration.parent.kind === 225 /* BinaryExpression */ )) return getWidenedTypeForAssignmentDeclaration(symbol);
            else if (symbol.flags & 512 /* ValueModule */  && declaration && isSourceFile(declaration) && declaration.commonJsModuleIndicator) {
                const resolvedModule = resolveExternalModuleSymbol(symbol);
                if (resolvedModule !== symbol) {
                    if (!pushTypeResolution(symbol, 0 /* Type */ )) return errorType;
                    const exportEquals = getMergedSymbol(symbol.exports.get("export=" /* ExportEquals */ ));
                    const type2 = getWidenedTypeForAssignmentDeclaration(exportEquals, exportEquals === resolvedModule ? void 0 : resolvedModule);
                    if (!popTypeResolution()) return reportCircularityError(symbol);
                    return type2;
                }
            }
            const type = createObjectType(16 /* Anonymous */ , symbol);
            if (symbol.flags & 32 /* Class */ ) {
                const baseTypeVariable = getBaseTypeVariableOfClass(symbol);
                return baseTypeVariable ? getIntersectionType([
                    type,
                    baseTypeVariable
                ]) : type;
            } else return strictNullChecks && symbol.flags & 16777216 /* Optional */  ? getOptionalType(type, /*isProperty*/ true) : type;
        }
        function getTypeOfEnumMember(symbol) {
            const links = getSymbolLinks(symbol);
            return links.type || (links.type = getDeclaredTypeOfEnumMember(symbol));
        }
        function getTypeOfAlias(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.type) {
                const targetSymbol = resolveAlias(symbol);
                const exportSymbol = symbol.declarations && getTargetOfAliasDeclaration(getDeclarationOfAliasSymbol(symbol), /*dontRecursivelyResolve*/ true);
                const declaredType = firstDefined(exportSymbol == null ? void 0 : exportSymbol.declarations, (d)=>isExportAssignment(d) ? tryGetTypeFromEffectiveTypeNode(d) : void 0);
                links.type = (exportSymbol == null ? void 0 : exportSymbol.declarations) && isDuplicatedCommonJSExport(exportSymbol.declarations) && symbol.declarations.length ? getFlowTypeFromCommonJSExport(exportSymbol) : isDuplicatedCommonJSExport(symbol.declarations) ? autoType : declaredType ? declaredType : getAllSymbolFlags(targetSymbol) & 111551 /* Value */  ? getTypeOfSymbol(targetSymbol) : errorType;
            }
            return links.type;
        }
        function getTypeOfInstantiatedSymbol(symbol) {
            const links = getSymbolLinks(symbol);
            return links.type || (links.type = instantiateType(getTypeOfSymbol(links.target), links.mapper));
        }
        function getWriteTypeOfInstantiatedSymbol(symbol) {
            const links = getSymbolLinks(symbol);
            return links.writeType || (links.writeType = instantiateType(getWriteTypeOfSymbol(links.target), links.mapper));
        }
        function reportCircularityError(symbol) {
            const declaration = symbol.valueDeclaration;
            if (getEffectiveTypeAnnotationNode(declaration)) {
                error(symbol.valueDeclaration, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
                return errorType;
            }
            if (noImplicitAny && (declaration.kind !== 168 /* Parameter */  || declaration.initializer)) error(symbol.valueDeclaration, Diagnostics._0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or_indirectly_in_its_own_initializer, symbolToString(symbol));
            return anyType;
        }
        function getTypeOfSymbolWithDeferredType(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.type) {
                Debug.assertIsDefined(links.deferralParent);
                Debug.assertIsDefined(links.deferralConstituents);
                links.type = links.deferralParent.flags & 1048576 /* Union */  ? getUnionType(links.deferralConstituents) : getIntersectionType(links.deferralConstituents);
            }
            return links.type;
        }
        function getWriteTypeOfSymbolWithDeferredType(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.writeType && links.deferralWriteConstituents) {
                Debug.assertIsDefined(links.deferralParent);
                Debug.assertIsDefined(links.deferralConstituents);
                links.writeType = links.deferralParent.flags & 1048576 /* Union */  ? getUnionType(links.deferralWriteConstituents) : getIntersectionType(links.deferralWriteConstituents);
            }
            return links.writeType;
        }
        function getWriteTypeOfSymbol(symbol) {
            const checkFlags = getCheckFlags(symbol);
            if (symbol.flags & 4 /* Property */ ) return checkFlags & 2 /* SyntheticProperty */  ? checkFlags & 65536 /* DeferredType */  ? getWriteTypeOfSymbolWithDeferredType(symbol) || getTypeOfSymbolWithDeferredType(symbol) : // NOTE: cast to TransientSymbol should be safe because only TransientSymbols can have CheckFlags.SyntheticProperty
            symbol.links.writeType || symbol.links.type : getTypeOfSymbol(symbol);
            if (symbol.flags & 98304 /* Accessor */ ) return checkFlags & 1 /* Instantiated */  ? getWriteTypeOfInstantiatedSymbol(symbol) : getWriteTypeOfAccessors(symbol);
            return getTypeOfSymbol(symbol);
        }
        function getTypeOfSymbol(symbol) {
            const checkFlags = getCheckFlags(symbol);
            if (checkFlags & 65536 /* DeferredType */ ) return getTypeOfSymbolWithDeferredType(symbol);
            if (checkFlags & 1 /* Instantiated */ ) return getTypeOfInstantiatedSymbol(symbol);
            if (checkFlags & 262144 /* Mapped */ ) return getTypeOfMappedSymbol(symbol);
            if (checkFlags & 8192 /* ReverseMapped */ ) return getTypeOfReverseMappedSymbol(symbol);
            if (symbol.flags & 7 /* Property */ ) return getTypeOfVariableOrParameterOrProperty(symbol);
            if (symbol.flags & 9136 /* ValueModule */ ) return getTypeOfFuncClassEnumModule(symbol);
            if (symbol.flags & 8 /* EnumMember */ ) return getTypeOfEnumMember(symbol);
            if (symbol.flags & 98304 /* Accessor */ ) return getTypeOfAccessors(symbol);
            if (symbol.flags & 2097152 /* Alias */ ) return getTypeOfAlias(symbol);
            return errorType;
        }
        function getNonMissingTypeOfSymbol(symbol) {
            return removeMissingType(getTypeOfSymbol(symbol), !!(symbol.flags & 16777216 /* Optional */ ));
        }
        function isReferenceToType2(type, target) {
            return type !== void 0 && target !== void 0 && (getObjectFlags(type) & 4 /* Reference */ ) !== 0 && type.target === target;
        }
        function getTargetType(type) {
            return getObjectFlags(type) & 4 /* Reference */  ? type.target : type;
        }
        function hasBaseType(type, checkBase) {
            return check(type);
            function check(type2) {
                if (getObjectFlags(type2) & 7 /* Reference */ ) {
                    const target = getTargetType(type2);
                    return target === checkBase || some(getBaseTypes(target), check);
                } else if (type2.flags & 2097152 /* Intersection */ ) return some(type2.types, check);
                return false;
            }
        }
        function appendTypeParameters(typeParameters, declarations) {
            for (const declaration of declarations)typeParameters = appendIfUnique(typeParameters, getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(declaration)));
            return typeParameters;
        }
        function getOuterTypeParameters(node, includeThisTypes) {
            while(true){
                node = node.parent;
                if (node && isBinaryExpression(node)) {
                    const assignmentKind = getAssignmentDeclarationKind(node);
                    if (assignmentKind === 6 /* Prototype */  || assignmentKind === 3 /* PrototypeProperty */ ) {
                        const symbol = getSymbolOfDeclaration(node.left);
                        if (symbol && symbol.parent && !findAncestor(symbol.parent.valueDeclaration, (d)=>node === d)) node = symbol.parent.valueDeclaration;
                    }
                }
                if (!node) return void 0;
                switch(node.kind){
                    case 262 /* ClassDeclaration */ :
                    case 230 /* ClassExpression */ :
                    case 263 /* InterfaceDeclaration */ :
                    case 178 /* CallSignature */ :
                    case 179 /* ConstructSignature */ :
                    case 172 /* MethodSignature */ :
                    case 183 /* FunctionType */ :
                    case 184 /* ConstructorType */ :
                    case 323 /* JSDocFunctionType */ :
                    case 261 /* FunctionDeclaration */ :
                    case 173 /* MethodDeclaration */ :
                    case 217 /* FunctionExpression */ :
                    case 218 /* ArrowFunction */ :
                    case 264 /* TypeAliasDeclaration */ :
                    case 351 /* JSDocTemplateTag */ :
                    case 352 /* JSDocTypedefTag */ :
                    case 346 /* JSDocEnumTag */ :
                    case 344 /* JSDocCallbackTag */ :
                    case 199 /* MappedType */ :
                    case 193 /* ConditionalType */ :
                        {
                            const outerTypeParameters = getOuterTypeParameters(node, includeThisTypes);
                            if (node.kind === 199 /* MappedType */ ) return append(outerTypeParameters, getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(node.typeParameter)));
                            else if (node.kind === 193 /* ConditionalType */ ) return concatenate(outerTypeParameters, getInferTypeParameters(node));
                            const outerAndOwnTypeParameters = appendTypeParameters(outerTypeParameters, getEffectiveTypeParameterDeclarations(node));
                            const thisType = includeThisTypes && (node.kind === 262 /* ClassDeclaration */  || node.kind === 230 /* ClassExpression */  || node.kind === 263 /* InterfaceDeclaration */  || isJSConstructor(node)) && getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(node)).thisType;
                            return thisType ? append(outerAndOwnTypeParameters, thisType) : outerAndOwnTypeParameters;
                        }
                    case 347 /* JSDocParameterTag */ :
                        const paramSymbol = getParameterSymbolFromJSDoc(node);
                        if (paramSymbol) node = paramSymbol.valueDeclaration;
                        break;
                    case 326 /* JSDoc */ :
                        {
                            const outerTypeParameters = getOuterTypeParameters(node, includeThisTypes);
                            return node.tags ? appendTypeParameters(outerTypeParameters, flatMap(node.tags, (t)=>isJSDocTemplateTag(t) ? t.typeParameters : void 0)) : outerTypeParameters;
                        }
                }
            }
        }
        function getOuterTypeParametersOfClassOrInterface(symbol) {
            var _a;
            const declaration = symbol.flags & 32 /* Class */  || symbol.flags & 16 /* Function */  ? symbol.valueDeclaration : (_a = symbol.declarations) == null ? void 0 : _a.find((decl)=>{
                if (decl.kind === 263 /* InterfaceDeclaration */ ) return true;
                if (decl.kind !== 259 /* VariableDeclaration */ ) return false;
                const initializer = decl.initializer;
                return !!initializer && (initializer.kind === 217 /* FunctionExpression */  || initializer.kind === 218 /* ArrowFunction */ );
            });
            Debug.assert(!!declaration, "Class was missing valueDeclaration -OR- non-class had no interface declarations");
            return getOuterTypeParameters(declaration);
        }
        function getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol) {
            if (!symbol.declarations) return;
            let result;
            for (const node of symbol.declarations)if (node.kind === 263 /* InterfaceDeclaration */  || node.kind === 262 /* ClassDeclaration */  || node.kind === 230 /* ClassExpression */  || isJSConstructor(node) || isTypeAlias(node)) {
                const declaration = node;
                result = appendTypeParameters(result, getEffectiveTypeParameterDeclarations(declaration));
            }
            return result;
        }
        function getTypeParametersOfClassOrInterface(symbol) {
            return concatenate(getOuterTypeParametersOfClassOrInterface(symbol), getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol));
        }
        function isMixinConstructorType(type) {
            const signatures = getSignaturesOfType(type, 1 /* Construct */ );
            if (signatures.length === 1) {
                const s = signatures[0];
                if (!s.typeParameters && s.parameters.length === 1 && signatureHasRestParameter(s)) {
                    const paramType = getTypeOfParameter(s.parameters[0]);
                    return isTypeAny(paramType) || getElementTypeOfArrayType(paramType) === anyType;
                }
            }
            return false;
        }
        function isConstructorType(type) {
            if (getSignaturesOfType(type, 1 /* Construct */ ).length > 0) return true;
            if (type.flags & 8650752 /* TypeVariable */ ) {
                const constraint = getBaseConstraintOfType(type);
                return !!constraint && isMixinConstructorType(constraint);
            }
            return false;
        }
        function getBaseTypeNodeOfClass(type) {
            const decl = getClassLikeDeclarationOfSymbol(type.symbol);
            return decl && getEffectiveBaseTypeNode(decl);
        }
        function getConstructorsForTypeArguments(type, typeArgumentNodes, location) {
            const typeArgCount = length(typeArgumentNodes);
            const isJavascript = isInJSFile(location);
            return filter(getSignaturesOfType(type, 1 /* Construct */ ), (sig)=>(isJavascript || typeArgCount >= getMinTypeArgumentCount(sig.typeParameters)) && typeArgCount <= length(sig.typeParameters));
        }
        function getInstantiatedConstructorsForTypeArguments(type, typeArgumentNodes, location) {
            const signatures = getConstructorsForTypeArguments(type, typeArgumentNodes, location);
            const typeArguments = map(typeArgumentNodes, getTypeFromTypeNode);
            return sameMap(signatures, (sig)=>some(sig.typeParameters) ? getSignatureInstantiation(sig, typeArguments, isInJSFile(location)) : sig);
        }
        function getBaseConstructorTypeOfClass(type) {
            if (!type.resolvedBaseConstructorType) {
                const decl = getClassLikeDeclarationOfSymbol(type.symbol);
                const extended = decl && getEffectiveBaseTypeNode(decl);
                const baseTypeNode = getBaseTypeNodeOfClass(type);
                if (!baseTypeNode) return type.resolvedBaseConstructorType = undefinedType;
                if (!pushTypeResolution(type, 1 /* ResolvedBaseConstructorType */ )) return errorType;
                const baseConstructorType = checkExpression(baseTypeNode.expression);
                if (extended && baseTypeNode !== extended) {
                    Debug.assert(!extended.typeArguments);
                    checkExpression(extended.expression);
                }
                if (baseConstructorType.flags & 2621440 /* Intersection */ ) resolveStructuredTypeMembers(baseConstructorType);
                if (!popTypeResolution()) {
                    error(type.symbol.valueDeclaration, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_base_expression, symbolToString(type.symbol));
                    return type.resolvedBaseConstructorType = errorType;
                }
                if (!(baseConstructorType.flags & 1 /* Any */ ) && baseConstructorType !== nullWideningType && !isConstructorType(baseConstructorType)) {
                    const err = error(baseTypeNode.expression, Diagnostics.Type_0_is_not_a_constructor_function_type, typeToString(baseConstructorType));
                    if (baseConstructorType.flags & 262144 /* TypeParameter */ ) {
                        const constraint = getConstraintFromTypeParameter(baseConstructorType);
                        let ctorReturn = unknownType;
                        if (constraint) {
                            const ctorSig = getSignaturesOfType(constraint, 1 /* Construct */ );
                            if (ctorSig[0]) ctorReturn = getReturnTypeOfSignature(ctorSig[0]);
                        }
                        if (baseConstructorType.symbol.declarations) addRelatedInfo(err, createDiagnosticForNode(baseConstructorType.symbol.declarations[0], Diagnostics.Did_you_mean_for_0_to_be_constrained_to_type_new_args_Colon_any_1, symbolToString(baseConstructorType.symbol), typeToString(ctorReturn)));
                    }
                    return type.resolvedBaseConstructorType = errorType;
                }
                type.resolvedBaseConstructorType = baseConstructorType;
            }
            return type.resolvedBaseConstructorType;
        }
        function getImplementsTypes(type) {
            let resolvedImplementsTypes = emptyArray;
            if (type.symbol.declarations) for (const declaration of type.symbol.declarations){
                const implementsTypeNodes = getEffectiveImplementsTypeNodes(declaration);
                if (!implementsTypeNodes) continue;
                for (const node of implementsTypeNodes){
                    const implementsType = getTypeFromTypeNode(node);
                    if (!isErrorType(implementsType)) {
                        if (resolvedImplementsTypes === emptyArray) resolvedImplementsTypes = [
                            implementsType
                        ];
                        else resolvedImplementsTypes.push(implementsType);
                    }
                }
            }
            return resolvedImplementsTypes;
        }
        function reportCircularBaseType(node, type) {
            error(node, Diagnostics.Type_0_recursively_references_itself_as_a_base_type, typeToString(type, /*enclosingDeclaration*/ void 0, 2 /* WriteArrayAsGenericType */ ));
        }
        function getBaseTypes(type) {
            if (!type.baseTypesResolved) {
                if (pushTypeResolution(type, 7 /* ResolvedBaseTypes */ )) {
                    if (type.objectFlags & 8 /* Tuple */ ) type.resolvedBaseTypes = [
                        getTupleBaseType(type)
                    ];
                    else if (type.symbol.flags & 96 /* Interface */ ) {
                        if (type.symbol.flags & 32 /* Class */ ) resolveBaseTypesOfClass(type);
                        if (type.symbol.flags & 64 /* Interface */ ) resolveBaseTypesOfInterface(type);
                    } else Debug.fail("type must be class or interface");
                    if (!popTypeResolution() && type.symbol.declarations) {
                        for (const declaration of type.symbol.declarations)if (declaration.kind === 262 /* ClassDeclaration */  || declaration.kind === 263 /* InterfaceDeclaration */ ) reportCircularBaseType(declaration, type);
                    }
                }
                type.baseTypesResolved = true;
            }
            return type.resolvedBaseTypes;
        }
        function getTupleBaseType(type) {
            const elementTypes = sameMap(type.typeParameters, (t, i)=>type.elementFlags[i] & 8 /* Variadic */  ? getIndexedAccessType(t, numberType) : t);
            return createArrayType(getUnionType(elementTypes || emptyArray), type.readonly);
        }
        function resolveBaseTypesOfClass(type) {
            type.resolvedBaseTypes = resolvingEmptyArray;
            const baseConstructorType = getApparentType(getBaseConstructorTypeOfClass(type));
            if (!(baseConstructorType.flags & 2621441 /* Any */ )) return type.resolvedBaseTypes = emptyArray;
            const baseTypeNode = getBaseTypeNodeOfClass(type);
            let baseType;
            const originalBaseType = baseConstructorType.symbol ? getDeclaredTypeOfSymbol(baseConstructorType.symbol) : void 0;
            if (baseConstructorType.symbol && baseConstructorType.symbol.flags & 32 /* Class */  && areAllOuterTypeParametersApplied(originalBaseType)) baseType = getTypeFromClassOrInterfaceReference(baseTypeNode, baseConstructorType.symbol);
            else if (baseConstructorType.flags & 1 /* Any */ ) baseType = baseConstructorType;
            else {
                const constructors = getInstantiatedConstructorsForTypeArguments(baseConstructorType, baseTypeNode.typeArguments, baseTypeNode);
                if (!constructors.length) {
                    error(baseTypeNode.expression, Diagnostics.No_base_constructor_has_the_specified_number_of_type_arguments);
                    return type.resolvedBaseTypes = emptyArray;
                }
                baseType = getReturnTypeOfSignature(constructors[0]);
            }
            if (isErrorType(baseType)) return type.resolvedBaseTypes = emptyArray;
            const reducedBaseType = getReducedType(baseType);
            if (!isValidBaseType(reducedBaseType)) {
                const elaboration = elaborateNeverIntersection(/*errorInfo*/ void 0, baseType);
                const diagnostic = chainDiagnosticMessages(elaboration, Diagnostics.Base_constructor_return_type_0_is_not_an_object_type_or_intersection_of_object_types_with_statically_known_members, typeToString(reducedBaseType));
                diagnostics.add(createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(baseTypeNode.expression), baseTypeNode.expression, diagnostic));
                return type.resolvedBaseTypes = emptyArray;
            }
            if (type === reducedBaseType || hasBaseType(reducedBaseType, type)) {
                error(type.symbol.valueDeclaration, Diagnostics.Type_0_recursively_references_itself_as_a_base_type, typeToString(type, /*enclosingDeclaration*/ void 0, 2 /* WriteArrayAsGenericType */ ));
                return type.resolvedBaseTypes = emptyArray;
            }
            if (type.resolvedBaseTypes === resolvingEmptyArray) type.members = void 0;
            return type.resolvedBaseTypes = [
                reducedBaseType
            ];
        }
        function areAllOuterTypeParametersApplied(type) {
            const outerTypeParameters = type.outerTypeParameters;
            if (outerTypeParameters) {
                const last2 = outerTypeParameters.length - 1;
                const typeArguments = getTypeArguments(type);
                return outerTypeParameters[last2].symbol !== typeArguments[last2].symbol;
            }
            return true;
        }
        function isValidBaseType(type) {
            if (type.flags & 262144 /* TypeParameter */ ) {
                const constraint = getBaseConstraintOfType(type);
                if (constraint) return isValidBaseType(constraint);
            }
            return !!(type.flags & 67633153 /* Any */  && !isGenericMappedType(type) || type.flags & 2097152 /* Intersection */  && every(type.types, isValidBaseType));
        }
        function resolveBaseTypesOfInterface(type) {
            type.resolvedBaseTypes = type.resolvedBaseTypes || emptyArray;
            if (type.symbol.declarations) for (const declaration of type.symbol.declarations){
                if (declaration.kind === 263 /* InterfaceDeclaration */  && getInterfaceBaseTypeNodes(declaration)) for (const node of getInterfaceBaseTypeNodes(declaration)){
                    const baseType = getReducedType(getTypeFromTypeNode(node));
                    if (!isErrorType(baseType)) {
                        if (isValidBaseType(baseType)) {
                            if (type !== baseType && !hasBaseType(baseType, type)) {
                                if (type.resolvedBaseTypes === emptyArray) type.resolvedBaseTypes = [
                                    baseType
                                ];
                                else type.resolvedBaseTypes.push(baseType);
                            } else reportCircularBaseType(declaration, type);
                        } else error(node, Diagnostics.An_interface_can_only_extend_an_object_type_or_intersection_of_object_types_with_statically_known_members);
                    }
                }
            }
        }
        function isThislessInterface(symbol) {
            if (!symbol.declarations) return true;
            for (const declaration of symbol.declarations)if (declaration.kind === 263 /* InterfaceDeclaration */ ) {
                if (declaration.flags & 128 /* ContainsThis */ ) return false;
                const baseTypeNodes = getInterfaceBaseTypeNodes(declaration);
                if (baseTypeNodes) {
                    for (const node of baseTypeNodes)if (isEntityNameExpression(node.expression)) {
                        const baseSymbol = resolveEntityName(node.expression, 788968 /* Type */ , /*ignoreErrors*/ true);
                        if (!baseSymbol || !(baseSymbol.flags & 64 /* Interface */ ) || getDeclaredTypeOfClassOrInterface(baseSymbol).thisType) return false;
                    }
                }
            }
            return true;
        }
        function getDeclaredTypeOfClassOrInterface(symbol) {
            let links = getSymbolLinks(symbol);
            const originalLinks = links;
            if (!links.declaredType) {
                const kind = symbol.flags & 32 /* Class */  ? 1 /* Class */  : 2 /* Interface */ ;
                const merged = mergeJSSymbols(symbol, symbol.valueDeclaration && getAssignedClassSymbol(symbol.valueDeclaration));
                if (merged) {
                    symbol = merged;
                    links = merged.links;
                }
                const type = originalLinks.declaredType = links.declaredType = createObjectType(kind, symbol);
                const outerTypeParameters = getOuterTypeParametersOfClassOrInterface(symbol);
                const localTypeParameters = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
                if (outerTypeParameters || localTypeParameters || kind === 1 /* Class */  || !isThislessInterface(symbol)) {
                    type.objectFlags |= 4 /* Reference */ ;
                    type.typeParameters = concatenate(outerTypeParameters, localTypeParameters);
                    type.outerTypeParameters = outerTypeParameters;
                    type.localTypeParameters = localTypeParameters;
                    type.instantiations = /* @__PURE__ */ new Map();
                    type.instantiations.set(getTypeListId(type.typeParameters), type);
                    type.target = type;
                    type.resolvedTypeArguments = type.typeParameters;
                    type.thisType = createTypeParameter(symbol);
                    type.thisType.isThisType = true;
                    type.thisType.constraint = type;
                }
            }
            return links.declaredType;
        }
        function getDeclaredTypeOfTypeAlias(symbol) {
            var _a;
            const links = getSymbolLinks(symbol);
            if (!links.declaredType) {
                if (!pushTypeResolution(symbol, 2 /* DeclaredType */ )) return errorType;
                const declaration = Debug.checkDefined((_a = symbol.declarations) == null ? void 0 : _a.find(isTypeAlias), "Type alias symbol with no valid declaration found");
                const typeNode = isJSDocTypeAlias(declaration) ? declaration.typeExpression : declaration.type;
                let type = typeNode ? getTypeFromTypeNode(typeNode) : errorType;
                if (popTypeResolution()) {
                    const typeParameters = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
                    if (typeParameters) {
                        links.typeParameters = typeParameters;
                        links.instantiations = /* @__PURE__ */ new Map();
                        links.instantiations.set(getTypeListId(typeParameters), type);
                    }
                } else {
                    type = errorType;
                    if (declaration.kind === 346 /* JSDocEnumTag */ ) error(declaration.typeExpression.type, Diagnostics.Type_alias_0_circularly_references_itself, symbolToString(symbol));
                    else error(isNamedDeclaration(declaration) ? declaration.name || declaration : declaration, Diagnostics.Type_alias_0_circularly_references_itself, symbolToString(symbol));
                }
                links.declaredType = type;
            }
            return links.declaredType;
        }
        function getBaseTypeOfEnumLikeType(type) {
            return type.flags & 1056 /* EnumLike */  && type.symbol.flags & 8 /* EnumMember */  ? getDeclaredTypeOfSymbol(getParentOfSymbol(type.symbol)) : type;
        }
        function getDeclaredTypeOfEnum(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.declaredType) {
                const memberTypeList = [];
                if (symbol.declarations) {
                    for (const declaration of symbol.declarations)if (declaration.kind === 265 /* EnumDeclaration */ ) {
                        for (const member of declaration.members)if (hasBindableName(member)) {
                            const memberSymbol = getSymbolOfDeclaration(member);
                            const value1 = getEnumMemberValue(member);
                            const memberType = getFreshTypeOfLiteralType(value1 !== void 0 ? getEnumLiteralType(value1, getSymbolId(symbol), memberSymbol) : createComputedEnumType(memberSymbol));
                            getSymbolLinks(memberSymbol).declaredType = memberType;
                            memberTypeList.push(getRegularTypeOfLiteralType(memberType));
                        }
                    }
                }
                const enumType = memberTypeList.length ? getUnionType(memberTypeList, 1 /* Literal */ , symbol, /*aliasTypeArguments*/ void 0) : createComputedEnumType(symbol);
                if (enumType.flags & 1048576 /* Union */ ) {
                    enumType.flags |= 1024 /* EnumLiteral */ ;
                    enumType.symbol = symbol;
                }
                links.declaredType = enumType;
            }
            return links.declaredType;
        }
        function createComputedEnumType(symbol) {
            const regularType = createTypeWithSymbol(32 /* Enum */ , symbol);
            const freshType = createTypeWithSymbol(32 /* Enum */ , symbol);
            regularType.regularType = regularType;
            regularType.freshType = freshType;
            freshType.regularType = regularType;
            freshType.freshType = freshType;
            return regularType;
        }
        function getDeclaredTypeOfEnumMember(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.declaredType) {
                const enumType = getDeclaredTypeOfEnum(getParentOfSymbol(symbol));
                if (!links.declaredType) links.declaredType = enumType;
            }
            return links.declaredType;
        }
        function getDeclaredTypeOfTypeParameter(symbol) {
            const links = getSymbolLinks(symbol);
            return links.declaredType || (links.declaredType = createTypeParameter(symbol));
        }
        function getDeclaredTypeOfAlias(symbol) {
            const links = getSymbolLinks(symbol);
            return links.declaredType || (links.declaredType = getDeclaredTypeOfSymbol(resolveAlias(symbol)));
        }
        function getDeclaredTypeOfSymbol(symbol) {
            return tryGetDeclaredTypeOfSymbol(symbol) || errorType;
        }
        function tryGetDeclaredTypeOfSymbol(symbol) {
            if (symbol.flags & 96 /* Interface */ ) return getDeclaredTypeOfClassOrInterface(symbol);
            if (symbol.flags & 524288 /* TypeAlias */ ) return getDeclaredTypeOfTypeAlias(symbol);
            if (symbol.flags & 262144 /* TypeParameter */ ) return getDeclaredTypeOfTypeParameter(symbol);
            if (symbol.flags & 384 /* Enum */ ) return getDeclaredTypeOfEnum(symbol);
            if (symbol.flags & 8 /* EnumMember */ ) return getDeclaredTypeOfEnumMember(symbol);
            if (symbol.flags & 2097152 /* Alias */ ) return getDeclaredTypeOfAlias(symbol);
            return void 0;
        }
        function isThislessType(node) {
            switch(node.kind){
                case 133 /* AnyKeyword */ :
                case 159 /* UnknownKeyword */ :
                case 154 /* StringKeyword */ :
                case 150 /* NumberKeyword */ :
                case 162 /* BigIntKeyword */ :
                case 136 /* BooleanKeyword */ :
                case 155 /* SymbolKeyword */ :
                case 151 /* ObjectKeyword */ :
                case 116 /* VoidKeyword */ :
                case 157 /* UndefinedKeyword */ :
                case 146 /* NeverKeyword */ :
                case 200 /* LiteralType */ :
                    return true;
                case 187 /* ArrayType */ :
                    return isThislessType(node.elementType);
                case 182 /* TypeReference */ :
                    return !node.typeArguments || node.typeArguments.every(isThislessType);
            }
            return false;
        }
        function isThislessTypeParameter(node) {
            const constraint = getEffectiveConstraintOfTypeParameter(node);
            return !constraint || isThislessType(constraint);
        }
        function isThislessVariableLikeDeclaration(node) {
            const typeNode = getEffectiveTypeAnnotationNode(node);
            return typeNode ? isThislessType(typeNode) : !hasInitializer(node);
        }
        function isThislessFunctionLikeDeclaration(node) {
            const returnType = getEffectiveReturnTypeNode(node);
            const typeParameters = getEffectiveTypeParameterDeclarations(node);
            return (node.kind === 175 /* Constructor */  || !!returnType && isThislessType(returnType)) && node.parameters.every(isThislessVariableLikeDeclaration) && typeParameters.every(isThislessTypeParameter);
        }
        function isThisless(symbol) {
            if (symbol.declarations && symbol.declarations.length === 1) {
                const declaration = symbol.declarations[0];
                if (declaration) switch(declaration.kind){
                    case 171 /* PropertyDeclaration */ :
                    case 170 /* PropertySignature */ :
                        return isThislessVariableLikeDeclaration(declaration);
                    case 173 /* MethodDeclaration */ :
                    case 172 /* MethodSignature */ :
                    case 175 /* Constructor */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                        return isThislessFunctionLikeDeclaration(declaration);
                }
            }
            return false;
        }
        function createInstantiatedSymbolTable(symbols, mapper, mappingThisOnly) {
            const result = createSymbolTable();
            for (const symbol of symbols)result.set(symbol.escapedName, mappingThisOnly && isThisless(symbol) ? symbol : instantiateSymbol(symbol, mapper));
            return result;
        }
        function addInheritedMembers(symbols, baseSymbols) {
            for (const base of baseSymbols){
                if (isStaticPrivateIdentifierProperty(base)) continue;
                const derived = symbols.get(base.escapedName);
                if (!derived || derived.valueDeclaration && isBinaryExpression(derived.valueDeclaration) && !isConstructorDeclaredProperty(derived) && !getContainingClassStaticBlock(derived.valueDeclaration)) {
                    symbols.set(base.escapedName, base);
                    symbols.set(base.escapedName, base);
                }
            }
        }
        function isStaticPrivateIdentifierProperty(s) {
            return !!s.valueDeclaration && isPrivateIdentifierClassElementDeclaration(s.valueDeclaration) && isStatic(s.valueDeclaration);
        }
        function resolveDeclaredMembers(type) {
            if (!type.declaredProperties) {
                const symbol = type.symbol;
                const members = getMembersOfSymbol(symbol);
                type.declaredProperties = getNamedMembers(members);
                type.declaredCallSignatures = emptyArray;
                type.declaredConstructSignatures = emptyArray;
                type.declaredIndexInfos = emptyArray;
                type.declaredCallSignatures = getSignaturesOfSymbol(members.get("__call" /* Call */ ));
                type.declaredConstructSignatures = getSignaturesOfSymbol(members.get("__new" /* New */ ));
                type.declaredIndexInfos = getIndexInfosOfSymbol(symbol);
            }
            return type;
        }
        function isTypeUsableAsPropertyName(type) {
            return !!(type.flags & 8576 /* StringOrNumberLiteralOrUnique */ );
        }
        function isLateBindableName(node) {
            if (!isComputedPropertyName(node) && !isElementAccessExpression(node)) return false;
            const expr = isComputedPropertyName(node) ? node.expression : node.argumentExpression;
            return isEntityNameExpression(expr) && isTypeUsableAsPropertyName(isComputedPropertyName(node) ? checkComputedPropertyName(node) : checkExpressionCached(expr));
        }
        function isLateBoundName(name) {
            return name.charCodeAt(0) === 95 /* _ */  && name.charCodeAt(1) === 95 /* _ */  && name.charCodeAt(2) === 64 /* at */ ;
        }
        function hasLateBindableName(node) {
            const name = getNameOfDeclaration(node);
            return !!name && isLateBindableName(name);
        }
        function hasBindableName(node) {
            return !hasDynamicName(node) || hasLateBindableName(node);
        }
        function isNonBindableDynamicName(node) {
            return isDynamicName(node) && !isLateBindableName(node);
        }
        function getPropertyNameFromType(type) {
            if (type.flags & 8192 /* UniqueESSymbol */ ) return type.escapedName;
            if (type.flags & 384 /* NumberLiteral */ ) return escapeLeadingUnderscores("" + type.value);
            return Debug.fail();
        }
        function addDeclarationToLateBoundSymbol(symbol, member, symbolFlags) {
            Debug.assert(!!(getCheckFlags(symbol) & 4096 /* Late */ ), "Expected a late-bound symbol.");
            symbol.flags |= symbolFlags;
            getSymbolLinks(member.symbol).lateSymbol = symbol;
            if (!symbol.declarations) symbol.declarations = [
                member
            ];
            else if (!member.symbol.isReplaceableByMethod) symbol.declarations.push(member);
            if (symbolFlags & 111551 /* Value */ ) {
                if (!symbol.valueDeclaration || symbol.valueDeclaration.kind !== member.kind) symbol.valueDeclaration = member;
            }
        }
        function lateBindMember(parent2, earlySymbols, lateSymbols, decl) {
            Debug.assert(!!decl.symbol, "The member is expected to have a symbol.");
            const links = getNodeLinks(decl);
            if (!links.resolvedSymbol) {
                links.resolvedSymbol = decl.symbol;
                const declName = isBinaryExpression(decl) ? decl.left : decl.name;
                const type = isElementAccessExpression(declName) ? checkExpressionCached(declName.argumentExpression) : checkComputedPropertyName(declName);
                if (isTypeUsableAsPropertyName(type)) {
                    const memberName = getPropertyNameFromType(type);
                    const symbolFlags = decl.symbol.flags;
                    let lateSymbol = lateSymbols.get(memberName);
                    if (!lateSymbol) lateSymbols.set(memberName, lateSymbol = createSymbol(0 /* None */ , memberName, 4096 /* Late */ ));
                    const earlySymbol = earlySymbols && earlySymbols.get(memberName);
                    if (lateSymbol.flags & getExcludedSymbolFlags(symbolFlags) || earlySymbol) {
                        const declarations = earlySymbol ? concatenate(earlySymbol.declarations, lateSymbol.declarations) : lateSymbol.declarations;
                        const name = !(type.flags & 8192 /* UniqueESSymbol */ ) && unescapeLeadingUnderscores(memberName) || declarationNameToString(declName);
                        forEach(declarations, (declaration)=>error(getNameOfDeclaration(declaration) || declaration, Diagnostics.Property_0_was_also_declared_here, name));
                        error(declName || decl, Diagnostics.Duplicate_property_0, name);
                        lateSymbol = createSymbol(0 /* None */ , memberName, 4096 /* Late */ );
                    }
                    lateSymbol.links.nameType = type;
                    addDeclarationToLateBoundSymbol(lateSymbol, decl, symbolFlags);
                    if (lateSymbol.parent) Debug.assert(lateSymbol.parent === parent2, "Existing symbol parent should match new one");
                    else lateSymbol.parent = parent2;
                    return links.resolvedSymbol = lateSymbol;
                }
            }
            return links.resolvedSymbol;
        }
        function getResolvedMembersOrExportsOfSymbol(symbol, resolutionKind) {
            const links = getSymbolLinks(symbol);
            if (!links[resolutionKind]) {
                const isStatic2 = resolutionKind === "resolvedExports" /* resolvedExports */ ;
                const earlySymbols = !isStatic2 ? symbol.members : symbol.flags & 1536 /* Module */  ? getExportsOfModuleWorker(symbol).exports : symbol.exports;
                links[resolutionKind] = earlySymbols || emptySymbols;
                const lateSymbols = createSymbolTable();
                for (const decl of symbol.declarations || emptyArray){
                    const members = getMembersOfDeclaration(decl);
                    if (members) for (const member of members){
                        if (isStatic2 === hasStaticModifier(member)) {
                            if (hasLateBindableName(member)) lateBindMember(symbol, earlySymbols, lateSymbols, member);
                        }
                    }
                }
                const assignments = symbol.assignmentDeclarationMembers;
                if (assignments) {
                    const decls = arrayFrom(assignments.values());
                    for (const member of decls){
                        const assignmentKind = getAssignmentDeclarationKind(member);
                        const isInstanceMember = assignmentKind === 3 /* PrototypeProperty */  || isBinaryExpression(member) && isPossiblyAliasedThisProperty(member, assignmentKind) || assignmentKind === 9 /* ObjectDefinePrototypeProperty */  || assignmentKind === 6 /* Prototype */ ;
                        if (isStatic2 === !isInstanceMember) {
                            if (hasLateBindableName(member)) lateBindMember(symbol, earlySymbols, lateSymbols, member);
                        }
                    }
                }
                links[resolutionKind] = combineSymbolTables(earlySymbols, lateSymbols) || emptySymbols;
            }
            return links[resolutionKind];
        }
        function getMembersOfSymbol(symbol) {
            return symbol.flags & 6256 /* LateBindingContainer */  ? getResolvedMembersOrExportsOfSymbol(symbol, "resolvedMembers" /* resolvedMembers */ ) : symbol.members || emptySymbols;
        }
        function getLateBoundSymbol(symbol) {
            if (symbol.flags & 106500 /* ClassMember */  && symbol.escapedName === "__computed" /* Computed */ ) {
                const links = getSymbolLinks(symbol);
                if (!links.lateSymbol && some(symbol.declarations, hasLateBindableName)) {
                    const parent2 = getMergedSymbol(symbol.parent);
                    if (some(symbol.declarations, hasStaticModifier)) getExportsOfSymbol(parent2);
                    else getMembersOfSymbol(parent2);
                }
                return links.lateSymbol || (links.lateSymbol = symbol);
            }
            return symbol;
        }
        function getTypeWithThisArgument(type, thisArgument, needApparentType) {
            if (getObjectFlags(type) & 4 /* Reference */ ) {
                const target = type.target;
                const typeArguments = getTypeArguments(type);
                if (length(target.typeParameters) === length(typeArguments)) {
                    const ref = createTypeReference(target, concatenate(typeArguments, [
                        thisArgument || target.thisType
                    ]));
                    return needApparentType ? getApparentType(ref) : ref;
                }
            } else if (type.flags & 2097152 /* Intersection */ ) {
                const types = sameMap(type.types, (t)=>getTypeWithThisArgument(t, thisArgument, needApparentType));
                return types !== type.types ? getIntersectionType(types) : type;
            }
            return needApparentType ? getApparentType(type) : type;
        }
        function getThisArgument(type) {
            return getObjectFlags(type) & 4 /* Reference */  && length(getTypeArguments(type)) > getTypeReferenceArity(type) ? last(getTypeArguments(type)) : type;
        }
        function resolveObjectTypeMembers(type, source, typeParameters, typeArguments) {
            let mapper;
            let members;
            let callSignatures;
            let constructSignatures;
            let indexInfos;
            if (rangeEquals(typeParameters, typeArguments, 0, typeParameters.length)) {
                members = source.symbol ? getMembersOfSymbol(source.symbol) : createSymbolTable(source.declaredProperties);
                callSignatures = source.declaredCallSignatures;
                constructSignatures = source.declaredConstructSignatures;
                indexInfos = source.declaredIndexInfos;
            } else {
                mapper = createTypeMapper(typeParameters, typeArguments);
                members = createInstantiatedSymbolTable(source.declaredProperties, mapper, /*mappingThisOnly*/ typeParameters.length === 1);
                callSignatures = instantiateSignatures(source.declaredCallSignatures, mapper);
                constructSignatures = instantiateSignatures(source.declaredConstructSignatures, mapper);
                indexInfos = instantiateIndexInfos(source.declaredIndexInfos, mapper);
            }
            const baseTypes = getBaseTypes(source);
            if (baseTypes.length) {
                if (source.symbol && members === getMembersOfSymbol(source.symbol)) members = createSymbolTable(source.declaredProperties);
                setStructuredTypeMembers(type, members, callSignatures, constructSignatures, indexInfos);
                const thisArgument = lastOrUndefined(typeArguments);
                for (const baseType of baseTypes){
                    const instantiatedBaseType = thisArgument ? getTypeWithThisArgument(instantiateType(baseType, mapper), thisArgument) : baseType;
                    addInheritedMembers(members, getPropertiesOfType(instantiatedBaseType));
                    callSignatures = concatenate(callSignatures, getSignaturesOfType(instantiatedBaseType, 0 /* Call */ ));
                    constructSignatures = concatenate(constructSignatures, getSignaturesOfType(instantiatedBaseType, 1 /* Construct */ ));
                    const inheritedIndexInfos = instantiatedBaseType !== anyType ? getIndexInfosOfType(instantiatedBaseType) : [
                        createIndexInfo(stringType, anyType, /*isReadonly*/ false)
                    ];
                    indexInfos = concatenate(indexInfos, filter(inheritedIndexInfos, (info)=>!findIndexInfo(indexInfos, info.keyType)));
                }
            }
            setStructuredTypeMembers(type, members, callSignatures, constructSignatures, indexInfos);
        }
        function resolveClassOrInterfaceMembers(type) {
            resolveObjectTypeMembers(type, resolveDeclaredMembers(type), emptyArray, emptyArray);
        }
        function resolveTypeReferenceMembers(type) {
            const source = resolveDeclaredMembers(type.target);
            const typeParameters = concatenate(source.typeParameters, [
                source.thisType
            ]);
            const typeArguments = getTypeArguments(type);
            const paddedTypeArguments = typeArguments.length === typeParameters.length ? typeArguments : concatenate(typeArguments, [
                type
            ]);
            resolveObjectTypeMembers(type, source, typeParameters, paddedTypeArguments);
        }
        function createSignature(declaration, typeParameters, thisParameter, parameters, resolvedReturnType, resolvedTypePredicate, minArgumentCount, flags) {
            const sig = new Signature15(checker, flags);
            sig.declaration = declaration;
            sig.typeParameters = typeParameters;
            sig.parameters = parameters;
            sig.thisParameter = thisParameter;
            sig.resolvedReturnType = resolvedReturnType;
            sig.resolvedTypePredicate = resolvedTypePredicate;
            sig.minArgumentCount = minArgumentCount;
            sig.resolvedMinArgumentCount = void 0;
            sig.target = void 0;
            sig.mapper = void 0;
            sig.compositeSignatures = void 0;
            sig.compositeKind = void 0;
            return sig;
        }
        function cloneSignature(sig) {
            const result = createSignature(sig.declaration, sig.typeParameters, sig.thisParameter, sig.parameters, /*resolvedReturnType*/ void 0, /*resolvedTypePredicate*/ void 0, sig.minArgumentCount, sig.flags & 39 /* PropagatingFlags */ );
            result.target = sig.target;
            result.mapper = sig.mapper;
            result.compositeSignatures = sig.compositeSignatures;
            result.compositeKind = sig.compositeKind;
            return result;
        }
        function createUnionSignature(signature, unionSignatures) {
            const result = cloneSignature(signature);
            result.compositeSignatures = unionSignatures;
            result.compositeKind = 1048576 /* Union */ ;
            result.target = void 0;
            result.mapper = void 0;
            return result;
        }
        function getOptionalCallSignature(signature, callChainFlags) {
            if ((signature.flags & 24 /* CallChainFlags */ ) === callChainFlags) return signature;
            if (!signature.optionalCallSignatureCache) signature.optionalCallSignatureCache = {};
            const key = callChainFlags === 8 /* IsInnerCallChain */  ? "inner" : "outer";
            return signature.optionalCallSignatureCache[key] || (signature.optionalCallSignatureCache[key] = createOptionalCallSignature(signature, callChainFlags));
        }
        function createOptionalCallSignature(signature, callChainFlags) {
            Debug.assert(callChainFlags === 8 /* IsInnerCallChain */  || callChainFlags === 16 /* IsOuterCallChain */ , "An optional call signature can either be for an inner call chain or an outer call chain, but not both.");
            const result = cloneSignature(signature);
            result.flags |= callChainFlags;
            return result;
        }
        function getExpandedParameters(sig, skipUnionExpanding) {
            if (signatureHasRestParameter(sig)) {
                const restIndex = sig.parameters.length - 1;
                const restType = getTypeOfSymbol(sig.parameters[restIndex]);
                if (isTupleType(restType)) return [
                    expandSignatureParametersWithTupleMembers(restType, restIndex)
                ];
                else if (!skipUnionExpanding && restType.flags & 1048576 /* Union */  && every(restType.types, isTupleType)) return map(restType.types, (t)=>expandSignatureParametersWithTupleMembers(t, restIndex));
            }
            return [
                sig.parameters
            ];
            function expandSignatureParametersWithTupleMembers(restType, restIndex) {
                const elementTypes = getElementTypes(restType);
                const associatedNames = getUniqAssociatedNamesFromTupleType(restType);
                const restParams = map(elementTypes, (t, i)=>{
                    const name = associatedNames && associatedNames[i] ? associatedNames[i] : getParameterNameAtPosition(sig, restIndex + i, restType);
                    const flags = restType.target.elementFlags[i];
                    const checkFlags = flags & 12 /* Variable */  ? 32768 /* RestParameter */  : flags & 2 /* Optional */  ? 16384 /* OptionalParameter */  : 0;
                    const symbol = createSymbol(1 /* FunctionScopedVariable */ , name, checkFlags);
                    symbol.links.type = flags & 4 /* Rest */  ? createArrayType(t) : t;
                    return symbol;
                });
                return concatenate(sig.parameters.slice(0, restIndex), restParams);
            }
            function getUniqAssociatedNamesFromTupleType(type) {
                const associatedNamesMap = /* @__PURE__ */ new Map();
                return map(type.target.labeledElementDeclarations, (labeledElement)=>{
                    const name = getTupleElementLabel(labeledElement);
                    const prevCounter = associatedNamesMap.get(name);
                    if (prevCounter === void 0) {
                        associatedNamesMap.set(name, 1);
                        return name;
                    } else {
                        associatedNamesMap.set(name, prevCounter + 1);
                        return `${name}_${prevCounter}`;
                    }
                });
            }
        }
        function getDefaultConstructSignatures(classType) {
            const baseConstructorType = getBaseConstructorTypeOfClass(classType);
            const baseSignatures = getSignaturesOfType(baseConstructorType, 1 /* Construct */ );
            const declaration = getClassLikeDeclarationOfSymbol(classType.symbol);
            const isAbstract = !!declaration && hasSyntacticModifier(declaration, 256 /* Abstract */ );
            if (baseSignatures.length === 0) return [
                createSignature(/*declaration*/ void 0, classType.localTypeParameters, /*thisParameter*/ void 0, emptyArray, classType, /*resolvedTypePredicate*/ void 0, 0, isAbstract ? 4 /* Abstract */  : 0 /* None */ )
            ];
            const baseTypeNode = getBaseTypeNodeOfClass(classType);
            const isJavaScript = isInJSFile(baseTypeNode);
            const typeArguments = typeArgumentsFromTypeReferenceNode(baseTypeNode);
            const typeArgCount = length(typeArguments);
            const result = [];
            for (const baseSig of baseSignatures){
                const minTypeArgumentCount = getMinTypeArgumentCount(baseSig.typeParameters);
                const typeParamCount = length(baseSig.typeParameters);
                if (isJavaScript || typeArgCount >= minTypeArgumentCount && typeArgCount <= typeParamCount) {
                    const sig = typeParamCount ? createSignatureInstantiation(baseSig, fillMissingTypeArguments(typeArguments, baseSig.typeParameters, minTypeArgumentCount, isJavaScript)) : cloneSignature(baseSig);
                    sig.typeParameters = classType.localTypeParameters;
                    sig.resolvedReturnType = classType;
                    sig.flags = isAbstract ? sig.flags | 4 /* Abstract */  : sig.flags & -5 /* Abstract */ ;
                    result.push(sig);
                }
            }
            return result;
        }
        function findMatchingSignature(signatureList, signature, partialMatch, ignoreThisTypes, ignoreReturnTypes) {
            for (const s of signatureList){
                if (compareSignaturesIdentical(s, signature, partialMatch, ignoreThisTypes, ignoreReturnTypes, partialMatch ? compareTypesSubtypeOf : compareTypesIdentical)) return s;
            }
        }
        function findMatchingSignatures(signatureLists, signature, listIndex) {
            if (signature.typeParameters) {
                if (listIndex > 0) return void 0;
                for(let i = 1; i < signatureLists.length; i++){
                    if (!findMatchingSignature(signatureLists[i], signature, /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ false)) return void 0;
                }
                return [
                    signature
                ];
            }
            let result;
            for(let i = 0; i < signatureLists.length; i++){
                const match = i === listIndex ? signature : findMatchingSignature(signatureLists[i], signature, /*partialMatch*/ true, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ true);
                if (!match) return void 0;
                result = appendIfUnique(result, match);
            }
            return result;
        }
        function getUnionSignatures(signatureLists) {
            let result;
            let indexWithLengthOverOne;
            for(let i = 0; i < signatureLists.length; i++){
                if (signatureLists[i].length === 0) return emptyArray;
                if (signatureLists[i].length > 1) indexWithLengthOverOne = indexWithLengthOverOne === void 0 ? i : -1;
                for (const signature of signatureLists[i])if (!result || !findMatchingSignature(result, signature, /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ true)) {
                    const unionSignatures = findMatchingSignatures(signatureLists, signature, i);
                    if (unionSignatures) {
                        let s = signature;
                        if (unionSignatures.length > 1) {
                            let thisParameter = signature.thisParameter;
                            const firstThisParameterOfUnionSignatures = forEach(unionSignatures, (sig)=>sig.thisParameter);
                            if (firstThisParameterOfUnionSignatures) {
                                const thisType = getIntersectionType(mapDefined(unionSignatures, (sig)=>sig.thisParameter && getTypeOfSymbol(sig.thisParameter)));
                                thisParameter = createSymbolWithType(firstThisParameterOfUnionSignatures, thisType);
                            }
                            s = createUnionSignature(signature, unionSignatures);
                            s.thisParameter = thisParameter;
                        }
                        (result || (result = [])).push(s);
                    }
                }
            }
            if (!length(result) && indexWithLengthOverOne !== -1) {
                const masterList = signatureLists[indexWithLengthOverOne !== void 0 ? indexWithLengthOverOne : 0];
                let results = masterList.slice();
                for (const signatures of signatureLists)if (signatures !== masterList) {
                    const signature = signatures[0];
                    Debug.assert(!!signature, "getUnionSignatures bails early on empty signature lists and should not have empty lists on second pass");
                    results = !!signature.typeParameters && some(results, (s)=>!!s.typeParameters && !compareTypeParametersIdentical(signature.typeParameters, s.typeParameters)) ? void 0 : map(results, (sig)=>combineSignaturesOfUnionMembers(sig, signature));
                    if (!results) break;
                }
                result = results;
            }
            return result || emptyArray;
        }
        function compareTypeParametersIdentical(sourceParams, targetParams) {
            if (length(sourceParams) !== length(targetParams)) return false;
            if (!sourceParams || !targetParams) return true;
            const mapper = createTypeMapper(targetParams, sourceParams);
            for(let i = 0; i < sourceParams.length; i++){
                const source = sourceParams[i];
                const target = targetParams[i];
                if (source === target) continue;
                if (!isTypeIdenticalTo(getConstraintFromTypeParameter(source) || unknownType, instantiateType(getConstraintFromTypeParameter(target) || unknownType, mapper))) return false;
            }
            return true;
        }
        function combineUnionThisParam(left, right, mapper) {
            if (!left || !right) return left || right;
            const thisType = getIntersectionType([
                getTypeOfSymbol(left),
                instantiateType(getTypeOfSymbol(right), mapper)
            ]);
            return createSymbolWithType(left, thisType);
        }
        function combineUnionParameters(left, right, mapper) {
            const leftCount = getParameterCount(left);
            const rightCount = getParameterCount(right);
            const longest = leftCount >= rightCount ? left : right;
            const shorter = longest === left ? right : left;
            const longestCount = longest === left ? leftCount : rightCount;
            const eitherHasEffectiveRest = hasEffectiveRestParameter(left) || hasEffectiveRestParameter(right);
            const needsExtraRestElement = eitherHasEffectiveRest && !hasEffectiveRestParameter(longest);
            const params = new Array(longestCount + (needsExtraRestElement ? 1 : 0));
            for(let i = 0; i < longestCount; i++){
                let longestParamType = tryGetTypeAtPosition(longest, i);
                if (longest === right) longestParamType = instantiateType(longestParamType, mapper);
                let shorterParamType = tryGetTypeAtPosition(shorter, i) || unknownType;
                if (shorter === right) shorterParamType = instantiateType(shorterParamType, mapper);
                const unionParamType = getIntersectionType([
                    longestParamType,
                    shorterParamType
                ]);
                const isRestParam = eitherHasEffectiveRest && !needsExtraRestElement && i === longestCount - 1;
                const isOptional = i >= getMinArgumentCount(longest) && i >= getMinArgumentCount(shorter);
                const leftName = i >= leftCount ? void 0 : getParameterNameAtPosition(left, i);
                const rightName = i >= rightCount ? void 0 : getParameterNameAtPosition(right, i);
                const paramName = leftName === rightName ? leftName : !leftName ? rightName : !rightName ? leftName : void 0;
                const paramSymbol = createSymbol(1 /* FunctionScopedVariable */  | (isOptional && !isRestParam ? 16777216 /* Optional */  : 0), paramName || `arg${i}`);
                paramSymbol.links.type = isRestParam ? createArrayType(unionParamType) : unionParamType;
                params[i] = paramSymbol;
            }
            if (needsExtraRestElement) {
                const restParamSymbol = createSymbol(1 /* FunctionScopedVariable */ , "args");
                restParamSymbol.links.type = createArrayType(getTypeAtPosition(shorter, longestCount));
                if (shorter === right) restParamSymbol.links.type = instantiateType(restParamSymbol.links.type, mapper);
                params[longestCount] = restParamSymbol;
            }
            return params;
        }
        function combineSignaturesOfUnionMembers(left, right) {
            const typeParams = left.typeParameters || right.typeParameters;
            let paramMapper;
            if (left.typeParameters && right.typeParameters) paramMapper = createTypeMapper(right.typeParameters, left.typeParameters);
            const declaration = left.declaration;
            const params = combineUnionParameters(left, right, paramMapper);
            const thisParam = combineUnionThisParam(left.thisParameter, right.thisParameter, paramMapper);
            const minArgCount = Math.max(left.minArgumentCount, right.minArgumentCount);
            const result = createSignature(declaration, typeParams, thisParam, params, /*resolvedReturnType*/ void 0, /*resolvedTypePredicate*/ void 0, minArgCount, (left.flags | right.flags) & 39 /* PropagatingFlags */ );
            result.compositeKind = 1048576 /* Union */ ;
            result.compositeSignatures = concatenate(left.compositeKind !== 2097152 /* Intersection */  && left.compositeSignatures || [
                left
            ], [
                right
            ]);
            if (paramMapper) result.mapper = left.compositeKind !== 2097152 /* Intersection */  && left.mapper && left.compositeSignatures ? combineTypeMappers(left.mapper, paramMapper) : paramMapper;
            return result;
        }
        function getUnionIndexInfos(types) {
            const sourceInfos = getIndexInfosOfType(types[0]);
            if (sourceInfos) {
                const result = [];
                for (const info of sourceInfos){
                    const indexType = info.keyType;
                    if (every(types, (t)=>!!getIndexInfoOfType(t, indexType))) result.push(createIndexInfo(indexType, getUnionType(map(types, (t)=>getIndexTypeOfType(t, indexType))), some(types, (t)=>getIndexInfoOfType(t, indexType).isReadonly)));
                }
                return result;
            }
            return emptyArray;
        }
        function resolveUnionTypeMembers(type) {
            const callSignatures = getUnionSignatures(map(type.types, (t)=>t === globalFunctionType ? [
                    unknownSignature
                ] : getSignaturesOfType(t, 0 /* Call */ )));
            const constructSignatures = getUnionSignatures(map(type.types, (t)=>getSignaturesOfType(t, 1 /* Construct */ )));
            const indexInfos = getUnionIndexInfos(type.types);
            setStructuredTypeMembers(type, emptySymbols, callSignatures, constructSignatures, indexInfos);
        }
        function intersectTypes(type1, type2) {
            return !type1 ? type2 : !type2 ? type1 : getIntersectionType([
                type1,
                type2
            ]);
        }
        function findMixins(types) {
            const constructorTypeCount = countWhere(types, (t)=>getSignaturesOfType(t, 1 /* Construct */ ).length > 0);
            const mixinFlags = map(types, isMixinConstructorType);
            if (constructorTypeCount > 0 && constructorTypeCount === countWhere(mixinFlags, (b)=>b)) {
                const firstMixinIndex = mixinFlags.indexOf(/*searchElement*/ true);
                mixinFlags[firstMixinIndex] = false;
            }
            return mixinFlags;
        }
        function includeMixinType(type, types, mixinFlags, index) {
            const mixedTypes = [];
            for(let i = 0; i < types.length; i++){
                if (i === index) mixedTypes.push(type);
                else if (mixinFlags[i]) mixedTypes.push(getReturnTypeOfSignature(getSignaturesOfType(types[i], 1 /* Construct */ )[0]));
            }
            return getIntersectionType(mixedTypes);
        }
        function resolveIntersectionTypeMembers(type) {
            let callSignatures;
            let constructSignatures;
            let indexInfos;
            const types = type.types;
            const mixinFlags = findMixins(types);
            const mixinCount = countWhere(mixinFlags, (b)=>b);
            for(let i = 0; i < types.length; i++){
                const t = type.types[i];
                if (!mixinFlags[i]) {
                    let signatures = getSignaturesOfType(t, 1 /* Construct */ );
                    if (signatures.length && mixinCount > 0) signatures = map(signatures, (s)=>{
                        const clone2 = cloneSignature(s);
                        clone2.resolvedReturnType = includeMixinType(getReturnTypeOfSignature(s), types, mixinFlags, i);
                        return clone2;
                    });
                    constructSignatures = appendSignatures(constructSignatures, signatures);
                }
                callSignatures = appendSignatures(callSignatures, getSignaturesOfType(t, 0 /* Call */ ));
                indexInfos = reduceLeft(getIndexInfosOfType(t), (infos, newInfo)=>appendIndexInfo(infos, newInfo, /*union*/ false), indexInfos);
            }
            setStructuredTypeMembers(type, emptySymbols, callSignatures || emptyArray, constructSignatures || emptyArray, indexInfos || emptyArray);
        }
        function appendSignatures(signatures, newSignatures) {
            for (const sig of newSignatures)if (!signatures || every(signatures, (s)=>!compareSignaturesIdentical(s, sig, /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ false, compareTypesIdentical))) signatures = append(signatures, sig);
            return signatures;
        }
        function appendIndexInfo(indexInfos, newInfo, union) {
            if (indexInfos) for(let i = 0; i < indexInfos.length; i++){
                const info = indexInfos[i];
                if (info.keyType === newInfo.keyType) {
                    indexInfos[i] = createIndexInfo(info.keyType, union ? getUnionType([
                        info.type,
                        newInfo.type
                    ]) : getIntersectionType([
                        info.type,
                        newInfo.type
                    ]), union ? info.isReadonly || newInfo.isReadonly : info.isReadonly && newInfo.isReadonly);
                    return indexInfos;
                }
            }
            return append(indexInfos, newInfo);
        }
        function resolveAnonymousTypeMembers(type) {
            if (type.target) {
                setStructuredTypeMembers(type, emptySymbols, emptyArray, emptyArray, emptyArray);
                const members2 = createInstantiatedSymbolTable(getPropertiesOfObjectType(type.target), type.mapper, /*mappingThisOnly*/ false);
                const callSignatures = instantiateSignatures(getSignaturesOfType(type.target, 0 /* Call */ ), type.mapper);
                const constructSignatures = instantiateSignatures(getSignaturesOfType(type.target, 1 /* Construct */ ), type.mapper);
                const indexInfos2 = instantiateIndexInfos(getIndexInfosOfType(type.target), type.mapper);
                setStructuredTypeMembers(type, members2, callSignatures, constructSignatures, indexInfos2);
                return;
            }
            const symbol = getMergedSymbol(type.symbol);
            if (symbol.flags & 2048 /* TypeLiteral */ ) {
                setStructuredTypeMembers(type, emptySymbols, emptyArray, emptyArray, emptyArray);
                const members2 = getMembersOfSymbol(symbol);
                const callSignatures = getSignaturesOfSymbol(members2.get("__call" /* Call */ ));
                const constructSignatures = getSignaturesOfSymbol(members2.get("__new" /* New */ ));
                const indexInfos2 = getIndexInfosOfSymbol(symbol);
                setStructuredTypeMembers(type, members2, callSignatures, constructSignatures, indexInfos2);
                return;
            }
            let members = emptySymbols;
            let indexInfos;
            if (symbol.exports) {
                members = getExportsOfSymbol(symbol);
                if (symbol === globalThisSymbol) {
                    const varsOnly = /* @__PURE__ */ new Map();
                    members.forEach((p)=>{
                        var _a;
                        if (!(p.flags & 418 /* BlockScoped */ ) && !(p.flags & 512 /* ValueModule */  && ((_a = p.declarations) == null ? void 0 : _a.length) && every(p.declarations, isAmbientModule))) varsOnly.set(p.escapedName, p);
                    });
                    members = varsOnly;
                }
            }
            let baseConstructorIndexInfo;
            setStructuredTypeMembers(type, members, emptyArray, emptyArray, emptyArray);
            if (symbol.flags & 32 /* Class */ ) {
                const classType = getDeclaredTypeOfClassOrInterface(symbol);
                const baseConstructorType = getBaseConstructorTypeOfClass(classType);
                if (baseConstructorType.flags & 11272192 /* TypeVariable */ ) {
                    members = createSymbolTable(getNamedOrIndexSignatureMembers(members));
                    addInheritedMembers(members, getPropertiesOfType(baseConstructorType));
                } else if (baseConstructorType === anyType) baseConstructorIndexInfo = createIndexInfo(stringType, anyType, /*isReadonly*/ false);
            }
            const indexSymbol = getIndexSymbolFromSymbolTable(members);
            if (indexSymbol) indexInfos = getIndexInfosOfIndexSymbol(indexSymbol);
            else {
                if (baseConstructorIndexInfo) indexInfos = append(indexInfos, baseConstructorIndexInfo);
                if (symbol.flags & 384 /* Enum */  && (getDeclaredTypeOfSymbol(symbol).flags & 32 /* Enum */  || some(type.properties, (prop)=>!!(getTypeOfSymbol(prop).flags & 296 /* NumberLike */ )))) indexInfos = append(indexInfos, enumNumberIndexInfo);
            }
            setStructuredTypeMembers(type, members, emptyArray, emptyArray, indexInfos || emptyArray);
            if (symbol.flags & 8208 /* Method */ ) type.callSignatures = getSignaturesOfSymbol(symbol);
            if (symbol.flags & 32 /* Class */ ) {
                const classType = getDeclaredTypeOfClassOrInterface(symbol);
                let constructSignatures = symbol.members ? getSignaturesOfSymbol(symbol.members.get("__constructor" /* Constructor */ )) : emptyArray;
                if (symbol.flags & 16 /* Function */ ) constructSignatures = addRange(constructSignatures.slice(), mapDefined(type.callSignatures, (sig)=>isJSConstructor(sig.declaration) ? createSignature(sig.declaration, sig.typeParameters, sig.thisParameter, sig.parameters, classType, /*resolvedTypePredicate*/ void 0, sig.minArgumentCount, sig.flags & 39 /* PropagatingFlags */ ) : void 0));
                if (!constructSignatures.length) constructSignatures = getDefaultConstructSignatures(classType);
                type.constructSignatures = constructSignatures;
            }
        }
        function replaceIndexedAccess(instantiable, type, replacement) {
            return instantiateType(instantiable, createTypeMapper([
                type.indexType,
                type.objectType
            ], [
                getNumberLiteralType(0),
                createTupleType([
                    replacement
                ])
            ]));
        }
        function resolveReverseMappedTypeMembers(type) {
            const indexInfo = getIndexInfoOfType(type.source, stringType);
            const modifiers = getMappedTypeModifiers(type.mappedType);
            const readonlyMask = modifiers & 1 /* IncludeReadonly */  ? false : true;
            const optionalMask = modifiers & 4 /* IncludeOptional */  ? 0 : 16777216 /* Optional */ ;
            const indexInfos = indexInfo ? [
                createIndexInfo(stringType, inferReverseMappedType(indexInfo.type, type.mappedType, type.constraintType), readonlyMask && indexInfo.isReadonly)
            ] : emptyArray;
            const members = createSymbolTable();
            for (const prop of getPropertiesOfType(type.source)){
                const checkFlags = 8192 /* ReverseMapped */  | (readonlyMask && isReadonlySymbol(prop) ? 8 /* Readonly */  : 0);
                const inferredProp = createSymbol(4 /* Property */  | prop.flags & optionalMask, prop.escapedName, checkFlags);
                inferredProp.declarations = prop.declarations;
                inferredProp.links.nameType = getSymbolLinks(prop).nameType;
                inferredProp.links.propertyType = getTypeOfSymbol(prop);
                if (type.constraintType.type.flags & 8388608 /* IndexedAccess */  && type.constraintType.type.objectType.flags & 262144 /* TypeParameter */  && type.constraintType.type.indexType.flags & 262144 /* TypeParameter */ ) {
                    const newTypeParam = type.constraintType.type.objectType;
                    const newMappedType = replaceIndexedAccess(type.mappedType, type.constraintType.type, newTypeParam);
                    inferredProp.links.mappedType = newMappedType;
                    inferredProp.links.constraintType = getIndexType(newTypeParam);
                } else {
                    inferredProp.links.mappedType = type.mappedType;
                    inferredProp.links.constraintType = type.constraintType;
                }
                members.set(prop.escapedName, inferredProp);
            }
            setStructuredTypeMembers(type, members, emptyArray, emptyArray, indexInfos);
        }
        function getLowerBoundOfKeyType(type) {
            if (type.flags & 4194304 /* Index */ ) {
                const t = getApparentType(type.type);
                return isGenericTupleType(t) ? getKnownKeysOfTupleType(t) : getIndexType(t);
            }
            if (type.flags & 16777216 /* Conditional */ ) {
                if (type.root.isDistributive) {
                    const checkType = type.checkType;
                    const constraint = getLowerBoundOfKeyType(checkType);
                    if (constraint !== checkType) return getConditionalTypeInstantiation(type, prependTypeMapping(type.root.checkType, constraint, type.mapper));
                }
                return type;
            }
            if (type.flags & 1048576 /* Union */ ) return mapType(type, getLowerBoundOfKeyType, /*noReductions*/ true);
            if (type.flags & 2097152 /* Intersection */ ) {
                const types = type.types;
                if (types.length === 2 && !!(types[0].flags & 76 /* BigInt */ ) && types[1] === emptyTypeLiteralType) return type;
                return getIntersectionType(sameMap(type.types, getLowerBoundOfKeyType));
            }
            return type;
        }
        function getIsLateCheckFlag(s) {
            return getCheckFlags(s) & 4096 /* Late */ ;
        }
        function forEachMappedTypePropertyKeyTypeAndIndexSignatureKeyType(type, include, stringsOnly, cb) {
            for (const prop of getPropertiesOfType(type))cb(getLiteralTypeFromProperty(prop, include));
            if (type.flags & 1 /* Any */ ) cb(stringType);
            else {
                for (const info of getIndexInfosOfType(type))if (!stringsOnly || info.keyType.flags & 134217732 /* TemplateLiteral */ ) cb(info.keyType);
            }
        }
        function resolveMappedTypeMembers(type) {
            const members = createSymbolTable();
            let indexInfos;
            setStructuredTypeMembers(type, emptySymbols, emptyArray, emptyArray, emptyArray);
            const typeParameter = getTypeParameterFromMappedType(type);
            const constraintType = getConstraintTypeFromMappedType(type);
            const mappedType = type.target || type;
            const nameType = getNameTypeFromMappedType(mappedType);
            const shouldLinkPropDeclarations = !nameType || isFilteringMappedType(mappedType);
            const templateType = getTemplateTypeFromMappedType(mappedType);
            const modifiersType = getApparentType(getModifiersTypeFromMappedType(type));
            const templateModifiers = getMappedTypeModifiers(type);
            const include = keyofStringsOnly ? 128 /* StringLiteral */  : 8576 /* StringOrNumberLiteralOrUnique */ ;
            if (isMappedTypeWithKeyofConstraintDeclaration(type)) forEachMappedTypePropertyKeyTypeAndIndexSignatureKeyType(modifiersType, include, keyofStringsOnly, addMemberForKeyType);
            else forEachType(getLowerBoundOfKeyType(constraintType), addMemberForKeyType);
            setStructuredTypeMembers(type, members, emptyArray, emptyArray, indexInfos || emptyArray);
            function addMemberForKeyType(keyType) {
                const propNameType = nameType ? instantiateType(nameType, appendTypeMapping(type.mapper, typeParameter, keyType)) : keyType;
                forEachType(propNameType, (t)=>addMemberForKeyTypeWorker(keyType, t));
            }
            function addMemberForKeyTypeWorker(keyType, propNameType) {
                if (isTypeUsableAsPropertyName(propNameType)) {
                    const propName = getPropertyNameFromType(propNameType);
                    const existingProp = members.get(propName);
                    if (existingProp) {
                        existingProp.links.nameType = getUnionType([
                            existingProp.links.nameType,
                            propNameType
                        ]);
                        existingProp.links.keyType = getUnionType([
                            existingProp.links.keyType,
                            keyType
                        ]);
                    } else {
                        const modifiersProp = isTypeUsableAsPropertyName(keyType) ? getPropertyOfType(modifiersType, getPropertyNameFromType(keyType)) : void 0;
                        const isOptional = !!(templateModifiers & 4 /* IncludeOptional */  || !(templateModifiers & 8 /* ExcludeOptional */ ) && modifiersProp && modifiersProp.flags & 16777216 /* Optional */ );
                        const isReadonly = !!(templateModifiers & 1 /* IncludeReadonly */  || !(templateModifiers & 2 /* ExcludeReadonly */ ) && modifiersProp && isReadonlySymbol(modifiersProp));
                        const stripOptional = strictNullChecks && !isOptional && modifiersProp && modifiersProp.flags & 16777216 /* Optional */ ;
                        const lateFlag = modifiersProp ? getIsLateCheckFlag(modifiersProp) : 0;
                        const prop = createSymbol(4 /* Property */  | (isOptional ? 16777216 /* Optional */  : 0), propName, lateFlag | 262144 /* Mapped */  | (isReadonly ? 8 /* Readonly */  : 0) | (stripOptional ? 524288 /* StripOptional */  : 0));
                        prop.links.mappedType = type;
                        prop.links.nameType = propNameType;
                        prop.links.keyType = keyType;
                        if (modifiersProp) {
                            prop.links.syntheticOrigin = modifiersProp;
                            prop.declarations = shouldLinkPropDeclarations ? modifiersProp.declarations : void 0;
                        }
                        members.set(propName, prop);
                    }
                } else if (isValidIndexKeyType(propNameType) || propNameType.flags & 33 /* Enum */ ) {
                    const indexKeyType = propNameType.flags & 5 /* String */  ? stringType : propNameType.flags & 40 /* Enum */  ? numberType : propNameType;
                    const propType = instantiateType(templateType, appendTypeMapping(type.mapper, typeParameter, keyType));
                    const indexInfo = createIndexInfo(indexKeyType, propType, !!(templateModifiers & 1 /* IncludeReadonly */ ));
                    indexInfos = appendIndexInfo(indexInfos, indexInfo, /*union*/ true);
                }
            }
        }
        function getTypeOfMappedSymbol(symbol) {
            if (!symbol.links.type) {
                const mappedType = symbol.links.mappedType;
                if (!pushTypeResolution(symbol, 0 /* Type */ )) {
                    mappedType.containsError = true;
                    return errorType;
                }
                const templateType = getTemplateTypeFromMappedType(mappedType.target || mappedType);
                const mapper = appendTypeMapping(mappedType.mapper, getTypeParameterFromMappedType(mappedType), symbol.links.keyType);
                const propType = instantiateType(templateType, mapper);
                let type = strictNullChecks && symbol.flags & 16777216 /* Optional */  && !maybeTypeOfKind(propType, 49152 /* Void */ ) ? getOptionalType(propType, /*isProperty*/ true) : symbol.links.checkFlags & 524288 /* StripOptional */  ? removeMissingOrUndefinedType(propType) : propType;
                if (!popTypeResolution()) {
                    error(currentNode, Diagnostics.Type_of_property_0_circularly_references_itself_in_mapped_type_1, symbolToString(symbol), typeToString(mappedType));
                    type = errorType;
                }
                symbol.links.type = type;
            }
            return symbol.links.type;
        }
        function getTypeParameterFromMappedType(type) {
            return type.typeParameter || (type.typeParameter = getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(type.declaration.typeParameter)));
        }
        function getConstraintTypeFromMappedType(type) {
            return type.constraintType || (type.constraintType = getConstraintOfTypeParameter(getTypeParameterFromMappedType(type)) || errorType);
        }
        function getNameTypeFromMappedType(type) {
            return type.declaration.nameType ? type.nameType || (type.nameType = instantiateType(getTypeFromTypeNode(type.declaration.nameType), type.mapper)) : void 0;
        }
        function getTemplateTypeFromMappedType(type) {
            return type.templateType || (type.templateType = type.declaration.type ? instantiateType(addOptionality(getTypeFromTypeNode(type.declaration.type), /*isProperty*/ true, !!(getMappedTypeModifiers(type) & 4 /* IncludeOptional */ )), type.mapper) : errorType);
        }
        function getConstraintDeclarationForMappedType(type) {
            return getEffectiveConstraintOfTypeParameter(type.declaration.typeParameter);
        }
        function isMappedTypeWithKeyofConstraintDeclaration(type) {
            const constraintDeclaration = getConstraintDeclarationForMappedType(type);
            return constraintDeclaration.kind === 197 /* TypeOperator */  && constraintDeclaration.operator === 143 /* KeyOfKeyword */ ;
        }
        function getModifiersTypeFromMappedType(type) {
            if (!type.modifiersType) {
                if (isMappedTypeWithKeyofConstraintDeclaration(type)) type.modifiersType = instantiateType(getTypeFromTypeNode(getConstraintDeclarationForMappedType(type).type), type.mapper);
                else {
                    const declaredType = getTypeFromMappedTypeNode(type.declaration);
                    const constraint = getConstraintTypeFromMappedType(declaredType);
                    const extendedConstraint = constraint && constraint.flags & 262144 /* TypeParameter */  ? getConstraintOfTypeParameter(constraint) : constraint;
                    type.modifiersType = extendedConstraint && extendedConstraint.flags & 4194304 /* Index */  ? instantiateType(extendedConstraint.type, type.mapper) : unknownType;
                }
            }
            return type.modifiersType;
        }
        function getMappedTypeModifiers(type) {
            const declaration = type.declaration;
            return (declaration.readonlyToken ? declaration.readonlyToken.kind === 41 /* MinusToken */  ? 2 /* ExcludeReadonly */  : 1 /* IncludeReadonly */  : 0) | (declaration.questionToken ? declaration.questionToken.kind === 41 /* MinusToken */  ? 8 /* ExcludeOptional */  : 4 /* IncludeOptional */  : 0);
        }
        function getMappedTypeOptionality(type) {
            const modifiers = getMappedTypeModifiers(type);
            return modifiers & 8 /* ExcludeOptional */  ? -1 : modifiers & 4 /* IncludeOptional */  ? 1 : 0;
        }
        function getCombinedMappedTypeOptionality(type) {
            const optionality = getMappedTypeOptionality(type);
            const modifiersType = getModifiersTypeFromMappedType(type);
            return optionality || (isGenericMappedType(modifiersType) ? getMappedTypeOptionality(modifiersType) : 0);
        }
        function isPartialMappedType(type) {
            return !!(getObjectFlags(type) & 32 /* Mapped */  && getMappedTypeModifiers(type) & 4 /* IncludeOptional */ );
        }
        function isGenericMappedType(type) {
            if (getObjectFlags(type) & 32 /* Mapped */ ) {
                const constraint = getConstraintTypeFromMappedType(type);
                if (isGenericIndexType(constraint)) return true;
                const nameType = getNameTypeFromMappedType(type);
                if (nameType && isGenericIndexType(instantiateType(nameType, makeUnaryTypeMapper(getTypeParameterFromMappedType(type), constraint)))) return true;
            }
            return false;
        }
        function isFilteringMappedType(type) {
            const nameType = getNameTypeFromMappedType(type);
            return !!nameType && isTypeAssignableTo(nameType, getTypeParameterFromMappedType(type));
        }
        function resolveStructuredTypeMembers(type) {
            if (!type.members) {
                if (type.flags & 524288 /* Object */ ) {
                    if (type.objectFlags & 4 /* Reference */ ) resolveTypeReferenceMembers(type);
                    else if (type.objectFlags & 3 /* ClassOrInterface */ ) resolveClassOrInterfaceMembers(type);
                    else if (type.objectFlags & 1024 /* ReverseMapped */ ) resolveReverseMappedTypeMembers(type);
                    else if (type.objectFlags & 16 /* Anonymous */ ) resolveAnonymousTypeMembers(type);
                    else if (type.objectFlags & 32 /* Mapped */ ) resolveMappedTypeMembers(type);
                    else Debug.fail("Unhandled object type " + Debug.formatObjectFlags(type.objectFlags));
                } else if (type.flags & 1048576 /* Union */ ) resolveUnionTypeMembers(type);
                else if (type.flags & 2097152 /* Intersection */ ) resolveIntersectionTypeMembers(type);
                else Debug.fail("Unhandled type " + Debug.formatTypeFlags(type.flags));
            }
            return type;
        }
        function getPropertiesOfObjectType(type) {
            if (type.flags & 524288 /* Object */ ) return resolveStructuredTypeMembers(type).properties;
            return emptyArray;
        }
        function getPropertyOfObjectType(type, name) {
            if (type.flags & 524288 /* Object */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                const symbol = resolved.members.get(name);
                if (symbol && symbolIsValue(symbol)) return symbol;
            }
        }
        function getPropertiesOfUnionOrIntersectionType(type) {
            if (!type.resolvedProperties) {
                const members = createSymbolTable();
                for (const current of type.types){
                    for (const prop of getPropertiesOfType(current))if (!members.has(prop.escapedName)) {
                        const combinedProp = getPropertyOfUnionOrIntersectionType(type, prop.escapedName);
                        if (combinedProp) members.set(prop.escapedName, combinedProp);
                    }
                    if (type.flags & 1048576 /* Union */  && getIndexInfosOfType(current).length === 0) break;
                }
                type.resolvedProperties = getNamedMembers(members);
            }
            return type.resolvedProperties;
        }
        function getPropertiesOfType(type) {
            type = getReducedApparentType(type);
            return type.flags & 3145728 /* UnionOrIntersection */  ? getPropertiesOfUnionOrIntersectionType(type) : getPropertiesOfObjectType(type);
        }
        function forEachPropertyOfType(type, action) {
            type = getReducedApparentType(type);
            if (type.flags & 3670016 /* StructuredType */ ) resolveStructuredTypeMembers(type).members.forEach((symbol, escapedName)=>{
                if (isNamedMember(symbol, escapedName)) action(symbol, escapedName);
            });
        }
        function isTypeInvalidDueToUnionDiscriminant(contextualType, obj) {
            const list = obj.properties;
            return list.some((property)=>{
                const nameType = property.name && (isJsxNamespacedName(property.name) ? getStringLiteralType(getTextOfJsxAttributeName(property.name)) : getLiteralTypeFromPropertyName(property.name));
                const name = nameType && isTypeUsableAsPropertyName(nameType) ? getPropertyNameFromType(nameType) : void 0;
                const expected = name === void 0 ? void 0 : getTypeOfPropertyOfType(contextualType, name);
                return !!expected && isLiteralType(expected) && !isTypeAssignableTo(getTypeOfNode(property), expected);
            });
        }
        function getAllPossiblePropertiesOfTypes(types) {
            const unionType = getUnionType(types);
            if (!(unionType.flags & 1048576 /* Union */ )) return getAugmentedPropertiesOfType(unionType);
            const props = createSymbolTable();
            for (const memberType of types){
                for (const { escapedName: escapedName  } of getAugmentedPropertiesOfType(memberType))if (!props.has(escapedName)) {
                    const prop = createUnionOrIntersectionProperty(unionType, escapedName);
                    if (prop) props.set(escapedName, prop);
                }
            }
            return arrayFrom(props.values());
        }
        function getConstraintOfType(type) {
            return type.flags & 262144 /* TypeParameter */  ? getConstraintOfTypeParameter(type) : type.flags & 8388608 /* IndexedAccess */  ? getConstraintOfIndexedAccess(type) : type.flags & 16777216 /* Conditional */  ? getConstraintOfConditionalType(type) : getBaseConstraintOfType(type);
        }
        function getConstraintOfTypeParameter(typeParameter) {
            return hasNonCircularBaseConstraint(typeParameter) ? getConstraintFromTypeParameter(typeParameter) : void 0;
        }
        function isConstTypeVariable(type) {
            var _a;
            return !!(type && (type.flags & 262144 /* TypeParameter */  && some((_a = type.symbol) == null ? void 0 : _a.declarations, (d)=>hasSyntacticModifier(d, 2048 /* Const */ )) || type.flags & 1048576 /* Union */  && some(type.types, isConstTypeVariable) || type.flags & 8388608 /* IndexedAccess */  && isConstTypeVariable(type.objectType) || type.flags & 16777216 /* Conditional */  && isConstTypeVariable(getConstraintOfConditionalType(type)) || type.flags & 33554432 /* Substitution */  && isConstTypeVariable(type.baseType) || isGenericTupleType(type) && findIndex(getElementTypes(type), (t, i)=>!!(type.target.elementFlags[i] & 8 /* Variadic */ ) && isConstTypeVariable(t)) >= 0));
        }
        function getConstraintOfIndexedAccess(type) {
            return hasNonCircularBaseConstraint(type) ? getConstraintFromIndexedAccess(type) : void 0;
        }
        function getSimplifiedTypeOrConstraint(type) {
            const simplified = getSimplifiedType(type, /*writing*/ false);
            return simplified !== type ? simplified : getConstraintOfType(type);
        }
        function getConstraintFromIndexedAccess(type) {
            if (isMappedTypeGenericIndexedAccess(type) || isGenericMappedType(type.objectType)) return substituteIndexedMappedType(type.objectType, type.indexType);
            const indexConstraint = getSimplifiedTypeOrConstraint(type.indexType);
            if (indexConstraint && indexConstraint !== type.indexType) {
                const indexedAccess = getIndexedAccessTypeOrUndefined(type.objectType, indexConstraint, type.accessFlags);
                if (indexedAccess) return indexedAccess;
            }
            const objectConstraint = getSimplifiedTypeOrConstraint(type.objectType);
            if (objectConstraint && objectConstraint !== type.objectType) return getIndexedAccessTypeOrUndefined(objectConstraint, type.indexType, type.accessFlags);
            return void 0;
        }
        function getDefaultConstraintOfConditionalType(type) {
            if (!type.resolvedDefaultConstraint) {
                const trueConstraint = getInferredTrueTypeFromConditionalType(type);
                const falseConstraint = getFalseTypeFromConditionalType(type);
                type.resolvedDefaultConstraint = isTypeAny(trueConstraint) ? falseConstraint : isTypeAny(falseConstraint) ? trueConstraint : getUnionType([
                    trueConstraint,
                    falseConstraint
                ]);
            }
            return type.resolvedDefaultConstraint;
        }
        function getConstraintOfDistributiveConditionalType(type) {
            if (type.resolvedConstraintOfDistributive !== void 0) return type.resolvedConstraintOfDistributive || void 0;
            if (type.root.isDistributive && type.restrictiveInstantiation !== type) {
                const simplified = getSimplifiedType(type.checkType, /*writing*/ false);
                const constraint = simplified === type.checkType ? getConstraintOfType(simplified) : simplified;
                if (constraint && constraint !== type.checkType) {
                    const instantiated = getConditionalTypeInstantiation(type, prependTypeMapping(type.root.checkType, constraint, type.mapper));
                    if (!(instantiated.flags & 131072 /* Never */ )) {
                        type.resolvedConstraintOfDistributive = instantiated;
                        return instantiated;
                    }
                }
            }
            type.resolvedConstraintOfDistributive = false;
            return void 0;
        }
        function getConstraintFromConditionalType(type) {
            return getConstraintOfDistributiveConditionalType(type) || getDefaultConstraintOfConditionalType(type);
        }
        function getConstraintOfConditionalType(type) {
            return hasNonCircularBaseConstraint(type) ? getConstraintFromConditionalType(type) : void 0;
        }
        function getEffectiveConstraintOfIntersection(types, targetIsUnion) {
            let constraints;
            let hasDisjointDomainType = false;
            for (const t of types){
                if (t.flags & 465829888 /* Instantiable */ ) {
                    let constraint = getConstraintOfType(t);
                    while(constraint && constraint.flags & 21233664 /* Conditional */ )constraint = getConstraintOfType(constraint);
                    if (constraint) {
                        constraints = append(constraints, constraint);
                        if (targetIsUnion) constraints = append(constraints, t);
                    }
                } else if (t.flags & 469892092 /* DisjointDomains */  || isEmptyAnonymousObjectType(t)) hasDisjointDomainType = true;
            }
            if (constraints && (targetIsUnion || hasDisjointDomainType)) {
                if (hasDisjointDomainType) {
                    for (const t of types)if (t.flags & 469892092 /* DisjointDomains */  || isEmptyAnonymousObjectType(t)) constraints = append(constraints, t);
                }
                return getNormalizedType(getIntersectionType(constraints), /*writing*/ false);
            }
            return void 0;
        }
        function getBaseConstraintOfType(type) {
            if (type.flags & 464781312 /* StringMapping */  || isGenericTupleType(type)) {
                const constraint = getResolvedBaseConstraint(type);
                return constraint !== noConstraintType && constraint !== circularConstraintType ? constraint : void 0;
            }
            return type.flags & 4194304 /* Index */  ? keyofConstraintType : void 0;
        }
        function getBaseConstraintOrType(type) {
            return getBaseConstraintOfType(type) || type;
        }
        function hasNonCircularBaseConstraint(type) {
            return getResolvedBaseConstraint(type) !== circularConstraintType;
        }
        function getResolvedBaseConstraint(type) {
            if (type.resolvedBaseConstraint) return type.resolvedBaseConstraint;
            const stack = [];
            return type.resolvedBaseConstraint = getTypeWithThisArgument(getImmediateBaseConstraint(type), getThisArgument(type));
            function getImmediateBaseConstraint(t) {
                if (!t.immediateBaseConstraint) {
                    if (!pushTypeResolution(t, 4 /* ImmediateBaseConstraint */ )) return circularConstraintType;
                    let result;
                    const identity2 = getRecursionIdentity(t);
                    if (stack.length < 10 || stack.length < 50 && !contains(stack, identity2)) {
                        stack.push(identity2);
                        result = computeBaseConstraint(getSimplifiedType(t, /*writing*/ false));
                        stack.pop();
                    }
                    if (!popTypeResolution()) {
                        if (t.flags & 262144 /* TypeParameter */ ) {
                            const errorNode = getConstraintDeclaration(t);
                            if (errorNode) {
                                const diagnostic = error(errorNode, Diagnostics.Type_parameter_0_has_a_circular_constraint, typeToString(t));
                                if (currentNode && !isNodeDescendantOf(errorNode, currentNode) && !isNodeDescendantOf(currentNode, errorNode)) addRelatedInfo(diagnostic, createDiagnosticForNode(currentNode, Diagnostics.Circularity_originates_in_type_at_this_location));
                            }
                        }
                        result = circularConstraintType;
                    }
                    t.immediateBaseConstraint = result || noConstraintType;
                }
                return t.immediateBaseConstraint;
            }
            function getBaseConstraint(t) {
                const c = getImmediateBaseConstraint(t);
                return c !== noConstraintType && c !== circularConstraintType ? c : void 0;
            }
            function computeBaseConstraint(t) {
                if (t.flags & 262144 /* TypeParameter */ ) {
                    const constraint = getConstraintFromTypeParameter(t);
                    return t.isThisType || !constraint ? constraint : getBaseConstraint(constraint);
                }
                if (t.flags & 3145728 /* UnionOrIntersection */ ) {
                    const types = t.types;
                    const baseTypes = [];
                    let different = false;
                    for (const type2 of types){
                        const baseType = getBaseConstraint(type2);
                        if (baseType) {
                            if (baseType !== type2) different = true;
                            baseTypes.push(baseType);
                        } else different = true;
                    }
                    if (!different) return t;
                    return t.flags & 1048576 /* Union */  && baseTypes.length === types.length ? getUnionType(baseTypes) : t.flags & 2097152 /* Intersection */  && baseTypes.length ? getIntersectionType(baseTypes) : void 0;
                }
                if (t.flags & 4194304 /* Index */ ) return keyofConstraintType;
                if (t.flags & 134217728 /* TemplateLiteral */ ) {
                    const types = t.types;
                    const constraints = mapDefined(types, getBaseConstraint);
                    return constraints.length === types.length ? getTemplateLiteralType(t.texts, constraints) : stringType;
                }
                if (t.flags & 268435456 /* StringMapping */ ) {
                    const constraint = getBaseConstraint(t.type);
                    return constraint && constraint !== t.type ? getStringMappingType(t.symbol, constraint) : stringType;
                }
                if (t.flags & 8388608 /* IndexedAccess */ ) {
                    if (isMappedTypeGenericIndexedAccess(t)) return getBaseConstraint(substituteIndexedMappedType(t.objectType, t.indexType));
                    const baseObjectType = getBaseConstraint(t.objectType);
                    const baseIndexType = getBaseConstraint(t.indexType);
                    const baseIndexedAccess = baseObjectType && baseIndexType && getIndexedAccessTypeOrUndefined(baseObjectType, baseIndexType, t.accessFlags);
                    return baseIndexedAccess && getBaseConstraint(baseIndexedAccess);
                }
                if (t.flags & 16777216 /* Conditional */ ) {
                    const constraint = getConstraintFromConditionalType(t);
                    return constraint && getBaseConstraint(constraint);
                }
                if (t.flags & 33554432 /* Substitution */ ) return getBaseConstraint(getSubstitutionIntersection(t));
                if (isGenericTupleType(t)) {
                    const newElements = map(getElementTypes(t), (v, i)=>{
                        const constraint = t.target.elementFlags[i] & 8 /* Variadic */  && getBaseConstraint(v) || v;
                        return constraint && everyType(constraint, (c)=>isArrayOrTupleType(c) && !isGenericTupleType(c)) ? constraint : v;
                    });
                    return createTupleType(newElements, t.target.elementFlags, t.target.readonly, t.target.labeledElementDeclarations);
                }
                return t;
            }
        }
        function getApparentTypeOfIntersectionType(type) {
            return type.resolvedApparentType || (type.resolvedApparentType = getTypeWithThisArgument(type, type, /*needApparentType*/ true));
        }
        function getResolvedTypeParameterDefault(typeParameter) {
            if (!typeParameter.default) {
                if (typeParameter.target) {
                    const targetDefault = getResolvedTypeParameterDefault(typeParameter.target);
                    typeParameter.default = targetDefault ? instantiateType(targetDefault, typeParameter.mapper) : noConstraintType;
                } else {
                    typeParameter.default = resolvingDefaultType;
                    const defaultDeclaration = typeParameter.symbol && forEach(typeParameter.symbol.declarations, (decl)=>isTypeParameterDeclaration(decl) && decl.default);
                    const defaultType = defaultDeclaration ? getTypeFromTypeNode(defaultDeclaration) : noConstraintType;
                    if (typeParameter.default === resolvingDefaultType) typeParameter.default = defaultType;
                }
            } else if (typeParameter.default === resolvingDefaultType) typeParameter.default = circularConstraintType;
            return typeParameter.default;
        }
        function getDefaultFromTypeParameter(typeParameter) {
            const defaultType = getResolvedTypeParameterDefault(typeParameter);
            return defaultType !== noConstraintType && defaultType !== circularConstraintType ? defaultType : void 0;
        }
        function hasNonCircularTypeParameterDefault(typeParameter) {
            return getResolvedTypeParameterDefault(typeParameter) !== circularConstraintType;
        }
        function hasTypeParameterDefault(typeParameter) {
            return !!(typeParameter.symbol && forEach(typeParameter.symbol.declarations, (decl)=>isTypeParameterDeclaration(decl) && decl.default));
        }
        function getApparentTypeOfMappedType(type) {
            return type.resolvedApparentType || (type.resolvedApparentType = getResolvedApparentTypeOfMappedType(type));
        }
        function getResolvedApparentTypeOfMappedType(type) {
            const typeVariable = getHomomorphicTypeVariable(type);
            if (typeVariable && !type.declaration.nameType) {
                const constraint = getConstraintOfTypeParameter(typeVariable);
                if (constraint && everyType(constraint, isArrayOrTupleType)) return instantiateType(type, prependTypeMapping(typeVariable, constraint, type.mapper));
            }
            return type;
        }
        function isMappedTypeGenericIndexedAccess(type) {
            let objectType;
            return !!(type.flags & 8388608 /* IndexedAccess */  && getObjectFlags(objectType = type.objectType) & 32 /* Mapped */  && !isGenericMappedType(objectType) && isGenericIndexType(type.indexType) && !(getMappedTypeModifiers(objectType) & 8 /* ExcludeOptional */ ) && !objectType.declaration.nameType);
        }
        function getApparentType(type) {
            const t = !(type.flags & 465829888 /* Instantiable */ ) ? type : getBaseConstraintOfType(type) || unknownType;
            return getObjectFlags(t) & 32 /* Mapped */  ? getApparentTypeOfMappedType(t) : t.flags & 2097152 /* Intersection */  ? getApparentTypeOfIntersectionType(t) : t.flags & 402653316 /* StringLike */  ? globalStringType : t.flags & 296 /* NumberLike */  ? globalNumberType : t.flags & 2112 /* BigIntLike */  ? getGlobalBigIntType() : t.flags & 528 /* BooleanLike */  ? globalBooleanType : t.flags & 12288 /* ESSymbolLike */  ? getGlobalESSymbolType() : t.flags & 67108864 /* NonPrimitive */  ? emptyObjectType : t.flags & 4194304 /* Index */  ? keyofConstraintType : t.flags & 2 /* Unknown */  && !strictNullChecks ? emptyObjectType : t;
        }
        function getReducedApparentType(type) {
            return getReducedType(getApparentType(getReducedType(type)));
        }
        function createUnionOrIntersectionProperty(containingType, name, skipObjectFunctionPropertyAugment) {
            var _a, _b, _c;
            let singleProp;
            let propSet;
            let indexTypes;
            const isUnion = containingType.flags & 1048576 /* Union */ ;
            let optionalFlag;
            let syntheticFlag = 4 /* SyntheticMethod */ ;
            let checkFlags = isUnion ? 0 : 8 /* Readonly */ ;
            let mergedInstantiations = false;
            for (const current of containingType.types){
                const type = getApparentType(current);
                if (!(isErrorType(type) || type.flags & 131072 /* Never */ )) {
                    const prop = getPropertyOfType(type, name, skipObjectFunctionPropertyAugment);
                    const modifiers = prop ? getDeclarationModifierFlagsFromSymbol(prop) : 0;
                    if (prop) {
                        if (prop.flags & 106500 /* ClassMember */ ) {
                            optionalFlag ?? (optionalFlag = isUnion ? 0 /* None */  : 16777216 /* Optional */ );
                            if (isUnion) optionalFlag |= prop.flags & 16777216 /* Optional */ ;
                            else optionalFlag &= prop.flags;
                        }
                        if (!singleProp) singleProp = prop;
                        else if (prop !== singleProp) {
                            const isInstantiation = (getTargetSymbol(prop) || prop) === (getTargetSymbol(singleProp) || singleProp);
                            if (isInstantiation && compareProperties2(singleProp, prop, (a, b)=>a === b ? -1 /* True */  : 0 /* False */ ) === -1 /* True */ ) mergedInstantiations = !!singleProp.parent && !!length(getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(singleProp.parent));
                            else {
                                if (!propSet) {
                                    propSet = /* @__PURE__ */ new Map();
                                    propSet.set(getSymbolId(singleProp), singleProp);
                                }
                                const id = getSymbolId(prop);
                                if (!propSet.has(id)) propSet.set(id, prop);
                            }
                        }
                        if (isUnion && isReadonlySymbol(prop)) checkFlags |= 8 /* Readonly */ ;
                        else if (!isUnion && !isReadonlySymbol(prop)) checkFlags &= -9 /* Readonly */ ;
                        checkFlags |= (!(modifiers & 24 /* NonPublicAccessibilityModifier */ ) ? 256 /* ContainsPublic */  : 0) | (modifiers & 16 /* Protected */  ? 512 /* ContainsProtected */  : 0) | (modifiers & 8 /* Private */  ? 1024 /* ContainsPrivate */  : 0) | (modifiers & 32 /* Static */  ? 2048 /* ContainsStatic */  : 0);
                        if (!isPrototypeProperty(prop)) syntheticFlag = 2 /* SyntheticProperty */ ;
                    } else if (isUnion) {
                        const indexInfo = !isLateBoundName(name) && getApplicableIndexInfoForName(type, name);
                        if (indexInfo) {
                            checkFlags |= 32 /* WritePartial */  | (indexInfo.isReadonly ? 8 /* Readonly */  : 0);
                            indexTypes = append(indexTypes, isTupleType(type) ? getRestTypeOfTupleType(type) || undefinedType : indexInfo.type);
                        } else if (isObjectLiteralType2(type) && !(getObjectFlags(type) & 2097152 /* ContainsSpread */ )) {
                            checkFlags |= 32 /* WritePartial */ ;
                            indexTypes = append(indexTypes, undefinedType);
                        } else checkFlags |= 16 /* ReadPartial */ ;
                    }
                }
            }
            if (!singleProp || isUnion && (propSet || checkFlags & 48 /* Partial */ ) && checkFlags & 1536 /* ContainsProtected */  && !(propSet && getCommonDeclarationsOfSymbols(propSet.values()))) return void 0;
            if (!propSet && !(checkFlags & 16 /* ReadPartial */ ) && !indexTypes) {
                if (mergedInstantiations) {
                    const links = (_a = tryCast(singleProp, isTransientSymbol)) == null ? void 0 : _a.links;
                    const clone2 = createSymbolWithType(singleProp, links == null ? void 0 : links.type);
                    clone2.parent = (_c = (_b = singleProp.valueDeclaration) == null ? void 0 : _b.symbol) == null ? void 0 : _c.parent;
                    clone2.links.containingType = containingType;
                    clone2.links.mapper = links == null ? void 0 : links.mapper;
                    return clone2;
                } else return singleProp;
            }
            const props = propSet ? arrayFrom(propSet.values()) : [
                singleProp
            ];
            let declarations;
            let firstType;
            let nameType;
            const propTypes = [];
            let writeTypes;
            let firstValueDeclaration;
            let hasNonUniformValueDeclaration = false;
            for (const prop of props){
                if (!firstValueDeclaration) firstValueDeclaration = prop.valueDeclaration;
                else if (prop.valueDeclaration && prop.valueDeclaration !== firstValueDeclaration) hasNonUniformValueDeclaration = true;
                declarations = addRange(declarations, prop.declarations);
                const type = getTypeOfSymbol(prop);
                if (!firstType) {
                    firstType = type;
                    nameType = getSymbolLinks(prop).nameType;
                }
                const writeType = getWriteTypeOfSymbol(prop);
                if (writeTypes || writeType !== type) writeTypes = append(!writeTypes ? propTypes.slice() : writeTypes, writeType);
                else if (type !== firstType) checkFlags |= 64 /* HasNonUniformType */ ;
                if (isLiteralType(type) || isPatternLiteralType(type)) checkFlags |= 128 /* HasLiteralType */ ;
                if (type.flags & 131072 /* Never */  && type !== uniqueLiteralType) checkFlags |= 131072 /* HasNeverType */ ;
                propTypes.push(type);
            }
            addRange(propTypes, indexTypes);
            const result = createSymbol(4 /* Property */  | (optionalFlag ?? 0), name, syntheticFlag | checkFlags);
            result.links.containingType = containingType;
            if (!hasNonUniformValueDeclaration && firstValueDeclaration) {
                result.valueDeclaration = firstValueDeclaration;
                if (firstValueDeclaration.symbol.parent) result.parent = firstValueDeclaration.symbol.parent;
            }
            result.declarations = declarations;
            result.links.nameType = nameType;
            if (propTypes.length > 2) {
                result.links.checkFlags |= 65536 /* DeferredType */ ;
                result.links.deferralParent = containingType;
                result.links.deferralConstituents = propTypes;
                result.links.deferralWriteConstituents = writeTypes;
            } else {
                result.links.type = isUnion ? getUnionType(propTypes) : getIntersectionType(propTypes);
                if (writeTypes) result.links.writeType = isUnion ? getUnionType(writeTypes) : getIntersectionType(writeTypes);
            }
            return result;
        }
        function getUnionOrIntersectionProperty(type, name, skipObjectFunctionPropertyAugment) {
            var _a, _b;
            let property = ((_a = type.propertyCacheWithoutObjectFunctionPropertyAugment) == null ? void 0 : _a.get(name)) || !skipObjectFunctionPropertyAugment ? (_b = type.propertyCache) == null ? void 0 : _b.get(name) : void 0;
            if (!property) {
                property = createUnionOrIntersectionProperty(type, name, skipObjectFunctionPropertyAugment);
                if (property) {
                    const properties = skipObjectFunctionPropertyAugment ? type.propertyCacheWithoutObjectFunctionPropertyAugment || (type.propertyCacheWithoutObjectFunctionPropertyAugment = createSymbolTable()) : type.propertyCache || (type.propertyCache = createSymbolTable());
                    properties.set(name, property);
                }
            }
            return property;
        }
        function getCommonDeclarationsOfSymbols(symbols) {
            let commonDeclarations;
            for (const symbol of symbols){
                if (!symbol.declarations) return void 0;
                if (!commonDeclarations) {
                    commonDeclarations = new Set(symbol.declarations);
                    continue;
                }
                commonDeclarations.forEach((declaration)=>{
                    if (!contains(symbol.declarations, declaration)) commonDeclarations.delete(declaration);
                });
                if (commonDeclarations.size === 0) return void 0;
            }
            return commonDeclarations;
        }
        function getPropertyOfUnionOrIntersectionType(type, name, skipObjectFunctionPropertyAugment) {
            const property = getUnionOrIntersectionProperty(type, name, skipObjectFunctionPropertyAugment);
            return property && !(getCheckFlags(property) & 16 /* ReadPartial */ ) ? property : void 0;
        }
        function getReducedType(type) {
            if (type.flags & 1048576 /* Union */  && type.objectFlags & 16777216 /* ContainsIntersections */ ) return type.resolvedReducedType || (type.resolvedReducedType = getReducedUnionType(type));
            else if (type.flags & 2097152 /* Intersection */ ) {
                if (!(type.objectFlags & 16777216 /* IsNeverIntersectionComputed */ )) type.objectFlags |= 16777216 /* IsNeverIntersectionComputed */  | (some(getPropertiesOfUnionOrIntersectionType(type), isNeverReducedProperty) ? 33554432 /* IsNeverIntersection */  : 0);
                return type.objectFlags & 33554432 /* IsNeverIntersection */  ? neverType : type;
            }
            return type;
        }
        function getReducedUnionType(unionType) {
            const reducedTypes = sameMap(unionType.types, getReducedType);
            if (reducedTypes === unionType.types) return unionType;
            const reduced = getUnionType(reducedTypes);
            if (reduced.flags & 1048576 /* Union */ ) reduced.resolvedReducedType = reduced;
            return reduced;
        }
        function isNeverReducedProperty(prop) {
            return isDiscriminantWithNeverType(prop) || isConflictingPrivateProperty(prop);
        }
        function isDiscriminantWithNeverType(prop) {
            return !(prop.flags & 16777216 /* Optional */ ) && (getCheckFlags(prop) & 131264 /* HasNeverType */ ) === 192 /* Discriminant */  && !!(getTypeOfSymbol(prop).flags & 131072 /* Never */ );
        }
        function isConflictingPrivateProperty(prop) {
            return !prop.valueDeclaration && !!(getCheckFlags(prop) & 1024 /* ContainsPrivate */ );
        }
        function isGenericReducibleType(type) {
            return !!(type.flags & 1048576 /* Union */  && type.objectFlags & 16777216 /* ContainsIntersections */  && some(type.types, isGenericReducibleType) || type.flags & 2097152 /* Intersection */  && isReducibleIntersection(type));
        }
        function isReducibleIntersection(type) {
            const uniqueFilled = type.uniqueLiteralFilledInstantiation || (type.uniqueLiteralFilledInstantiation = instantiateType(type, uniqueLiteralMapper));
            return getReducedType(uniqueFilled) !== uniqueFilled;
        }
        function elaborateNeverIntersection(errorInfo, type) {
            if (type.flags & 2097152 /* Intersection */  && getObjectFlags(type) & 33554432 /* IsNeverIntersection */ ) {
                const neverProp = find(getPropertiesOfUnionOrIntersectionType(type), isDiscriminantWithNeverType);
                if (neverProp) return chainDiagnosticMessages(errorInfo, Diagnostics.The_intersection_0_was_reduced_to_never_because_property_1_has_conflicting_types_in_some_constituents, typeToString(type, /*enclosingDeclaration*/ void 0, 536870912 /* NoTypeReduction */ ), symbolToString(neverProp));
                const privateProp = find(getPropertiesOfUnionOrIntersectionType(type), isConflictingPrivateProperty);
                if (privateProp) return chainDiagnosticMessages(errorInfo, Diagnostics.The_intersection_0_was_reduced_to_never_because_property_1_exists_in_multiple_constituents_and_is_private_in_some, typeToString(type, /*enclosingDeclaration*/ void 0, 536870912 /* NoTypeReduction */ ), symbolToString(privateProp));
            }
            return errorInfo;
        }
        function getPropertyOfType(type, name, skipObjectFunctionPropertyAugment, includeTypeOnlyMembers) {
            type = getReducedApparentType(type);
            if (type.flags & 524288 /* Object */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                const symbol = resolved.members.get(name);
                if (symbol && symbolIsValue(symbol, includeTypeOnlyMembers)) return symbol;
                if (skipObjectFunctionPropertyAugment) return void 0;
                const functionType = resolved === anyFunctionType ? globalFunctionType : resolved.callSignatures.length ? globalCallableFunctionType : resolved.constructSignatures.length ? globalNewableFunctionType : void 0;
                if (functionType) {
                    const symbol2 = getPropertyOfObjectType(functionType, name);
                    if (symbol2) return symbol2;
                }
                return getPropertyOfObjectType(globalObjectType, name);
            }
            if (type.flags & 3145728 /* UnionOrIntersection */ ) return getPropertyOfUnionOrIntersectionType(type, name, skipObjectFunctionPropertyAugment);
            return void 0;
        }
        function getSignaturesOfStructuredType(type, kind) {
            if (type.flags & 3670016 /* StructuredType */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                return kind === 0 /* Call */  ? resolved.callSignatures : resolved.constructSignatures;
            }
            return emptyArray;
        }
        function getSignaturesOfType(type, kind) {
            return getSignaturesOfStructuredType(getReducedApparentType(type), kind);
        }
        function findIndexInfo(indexInfos, keyType) {
            return find(indexInfos, (info)=>info.keyType === keyType);
        }
        function findApplicableIndexInfo(indexInfos, keyType) {
            let stringIndexInfo;
            let applicableInfo;
            let applicableInfos;
            for (const info of indexInfos){
                if (info.keyType === stringType) stringIndexInfo = info;
                else if (isApplicableIndexType(keyType, info.keyType)) {
                    if (!applicableInfo) applicableInfo = info;
                    else (applicableInfos || (applicableInfos = [
                        applicableInfo
                    ])).push(info);
                }
            }
            return applicableInfos ? createIndexInfo(unknownType, getIntersectionType(map(applicableInfos, (info)=>info.type)), reduceLeft(applicableInfos, (isReadonly, info)=>isReadonly && info.isReadonly, /*initial*/ true)) : applicableInfo ? applicableInfo : stringIndexInfo && isApplicableIndexType(keyType, stringType) ? stringIndexInfo : void 0;
        }
        function isApplicableIndexType(source, target) {
            return isTypeAssignableTo(source, target) || target === stringType && isTypeAssignableTo(source, numberType) || target === numberType && (source === numericStringType || !!(source.flags & 128 /* StringLiteral */ ) && isNumericLiteralName(source.value));
        }
        function getIndexInfosOfStructuredType(type) {
            if (type.flags & 3670016 /* StructuredType */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                return resolved.indexInfos;
            }
            return emptyArray;
        }
        function getIndexInfosOfType(type) {
            return getIndexInfosOfStructuredType(getReducedApparentType(type));
        }
        function getIndexInfoOfType(type, keyType) {
            return findIndexInfo(getIndexInfosOfType(type), keyType);
        }
        function getIndexTypeOfType(type, keyType) {
            var _a;
            return (_a = getIndexInfoOfType(type, keyType)) == null ? void 0 : _a.type;
        }
        function getApplicableIndexInfos(type, keyType) {
            return getIndexInfosOfType(type).filter((info)=>isApplicableIndexType(keyType, info.keyType));
        }
        function getApplicableIndexInfo(type, keyType) {
            return findApplicableIndexInfo(getIndexInfosOfType(type), keyType);
        }
        function getApplicableIndexInfoForName(type, name) {
            return getApplicableIndexInfo(type, isLateBoundName(name) ? esSymbolType : getStringLiteralType(unescapeLeadingUnderscores(name)));
        }
        function getTypeParametersFromDeclaration(declaration) {
            var _a;
            let result;
            for (const node of getEffectiveTypeParameterDeclarations(declaration))result = appendIfUnique(result, getDeclaredTypeOfTypeParameter(node.symbol));
            return (result == null ? void 0 : result.length) ? result : isFunctionDeclaration(declaration) ? (_a = getSignatureOfTypeTag(declaration)) == null ? void 0 : _a.typeParameters : void 0;
        }
        function symbolsToArray(symbols) {
            const result = [];
            symbols.forEach((symbol, id)=>{
                if (!isReservedMemberName(id)) result.push(symbol);
            });
            return result;
        }
        function tryFindAmbientModule(moduleName, withAugmentations) {
            if (isExternalModuleNameRelative(moduleName)) return void 0;
            const symbol = getSymbol2(globals, '"' + moduleName + '"', 512 /* ValueModule */ );
            return symbol && withAugmentations ? getMergedSymbol(symbol) : symbol;
        }
        function isOptionalParameter(node) {
            if (hasQuestionToken(node) || isOptionalJSDocPropertyLikeTag(node) || isJSDocOptionalParameter(node)) return true;
            if (node.initializer) {
                const signature = getSignatureFromDeclaration(node.parent);
                const parameterIndex = node.parent.parameters.indexOf(node);
                Debug.assert(parameterIndex >= 0);
                return parameterIndex >= getMinArgumentCount(signature, 3 /* VoidIsNonOptional */ );
            }
            const iife = getImmediatelyInvokedFunctionExpression(node.parent);
            if (iife) return !node.type && !node.dotDotDotToken && node.parent.parameters.indexOf(node) >= iife.arguments.length;
            return false;
        }
        function isOptionalPropertyDeclaration(node) {
            return isPropertyDeclaration(node) && !hasAccessorModifier(node) && node.questionToken;
        }
        function createTypePredicate(kind, parameterName, parameterIndex, type) {
            return {
                kind: kind,
                parameterName: parameterName,
                parameterIndex: parameterIndex,
                type: type
            };
        }
        function getMinTypeArgumentCount(typeParameters) {
            let minTypeArgumentCount = 0;
            if (typeParameters) {
                for(let i = 0; i < typeParameters.length; i++)if (!hasTypeParameterDefault(typeParameters[i])) minTypeArgumentCount = i + 1;
            }
            return minTypeArgumentCount;
        }
        function fillMissingTypeArguments(typeArguments, typeParameters, minTypeArgumentCount, isJavaScriptImplicitAny) {
            const numTypeParameters = length(typeParameters);
            if (!numTypeParameters) return [];
            const numTypeArguments = length(typeArguments);
            if (isJavaScriptImplicitAny || numTypeArguments >= minTypeArgumentCount && numTypeArguments <= numTypeParameters) {
                const result = typeArguments ? typeArguments.slice() : [];
                for(let i = numTypeArguments; i < numTypeParameters; i++)result[i] = errorType;
                const baseDefaultType = getDefaultTypeArgumentType(isJavaScriptImplicitAny);
                for(let i = numTypeArguments; i < numTypeParameters; i++){
                    let defaultType = getDefaultFromTypeParameter(typeParameters[i]);
                    if (isJavaScriptImplicitAny && defaultType && (isTypeIdenticalTo(defaultType, unknownType) || isTypeIdenticalTo(defaultType, emptyObjectType))) defaultType = anyType;
                    result[i] = defaultType ? instantiateType(defaultType, createTypeMapper(typeParameters, result)) : baseDefaultType;
                }
                result.length = typeParameters.length;
                return result;
            }
            return typeArguments && typeArguments.slice();
        }
        function getSignatureFromDeclaration(declaration) {
            const links = getNodeLinks(declaration);
            if (!links.resolvedSignature) {
                const parameters = [];
                let flags = 0 /* None */ ;
                let minArgumentCount = 0;
                let thisParameter;
                let hasThisParameter2 = false;
                const iife = getImmediatelyInvokedFunctionExpression(declaration);
                const isJSConstructSignature = isJSDocConstructSignature(declaration);
                const isUntypedSignatureInJSFile = !iife && isInJSFile(declaration) && isValueSignatureDeclaration(declaration) && !hasJSDocParameterTags(declaration) && !getJSDocType(declaration);
                if (isUntypedSignatureInJSFile) flags |= 32 /* IsUntypedSignatureInJSFile */ ;
                for(let i = isJSConstructSignature ? 1 : 0; i < declaration.parameters.length; i++){
                    const param = declaration.parameters[i];
                    let paramSymbol = param.symbol;
                    const type = isJSDocParameterTag(param) ? param.typeExpression && param.typeExpression.type : param.type;
                    if (paramSymbol && !!(paramSymbol.flags & 4 /* Property */ ) && !isBindingPattern(param.name)) {
                        const resolvedSymbol = resolveName(param, paramSymbol.escapedName, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false);
                        paramSymbol = resolvedSymbol;
                    }
                    if (i === 0 && paramSymbol.escapedName === "this" /* This */ ) {
                        hasThisParameter2 = true;
                        thisParameter = param.symbol;
                    } else parameters.push(paramSymbol);
                    if (type && type.kind === 200 /* LiteralType */ ) flags |= 2 /* HasLiteralTypes */ ;
                    const isOptionalParameter2 = isOptionalJSDocPropertyLikeTag(param) || param.initializer || param.questionToken || isRestParameter(param) || iife && parameters.length > iife.arguments.length && !type || isJSDocOptionalParameter(param);
                    if (!isOptionalParameter2) minArgumentCount = parameters.length;
                }
                if ((declaration.kind === 176 /* GetAccessor */  || declaration.kind === 177 /* SetAccessor */ ) && hasBindableName(declaration) && (!hasThisParameter2 || !thisParameter)) {
                    const otherKind = declaration.kind === 176 /* GetAccessor */  ? 177 /* SetAccessor */  : 176 /* GetAccessor */ ;
                    const other = getDeclarationOfKind(getSymbolOfDeclaration(declaration), otherKind);
                    if (other) thisParameter = getAnnotatedAccessorThisParameter(other);
                }
                if (isInJSFile(declaration)) {
                    const thisTag = getJSDocThisTag(declaration);
                    if (thisTag && thisTag.typeExpression) thisParameter = createSymbolWithType(createSymbol(1 /* FunctionScopedVariable */ , "this" /* This */ ), getTypeFromTypeNode(thisTag.typeExpression));
                }
                const hostDeclaration = isJSDocSignature(declaration) ? getEffectiveJSDocHost(declaration) : declaration;
                const classType = hostDeclaration && isConstructorDeclaration(hostDeclaration) ? getDeclaredTypeOfClassOrInterface(getMergedSymbol(hostDeclaration.parent.symbol)) : void 0;
                const typeParameters = classType ? classType.localTypeParameters : getTypeParametersFromDeclaration(declaration);
                if (hasRestParameter(declaration) || isInJSFile(declaration) && maybeAddJsSyntheticRestParameter(declaration, parameters)) flags |= 1 /* HasRestParameter */ ;
                if (isConstructorTypeNode(declaration) && hasSyntacticModifier(declaration, 256 /* Abstract */ ) || isConstructorDeclaration(declaration) && hasSyntacticModifier(declaration.parent, 256 /* Abstract */ )) flags |= 4 /* Abstract */ ;
                links.resolvedSignature = createSignature(declaration, typeParameters, thisParameter, parameters, /*resolvedReturnType*/ void 0, /*resolvedTypePredicate*/ void 0, minArgumentCount, flags);
            }
            return links.resolvedSignature;
        }
        function maybeAddJsSyntheticRestParameter(declaration, parameters) {
            if (isJSDocSignature(declaration) || !containsArgumentsReference(declaration)) return false;
            const lastParam = lastOrUndefined(declaration.parameters);
            const lastParamTags = lastParam ? getJSDocParameterTags(lastParam) : getJSDocTags(declaration).filter(isJSDocParameterTag);
            const lastParamVariadicType = firstDefined(lastParamTags, (p)=>p.typeExpression && isJSDocVariadicType(p.typeExpression.type) ? p.typeExpression.type : void 0);
            const syntheticArgsSymbol = createSymbol(3 /* Variable */ , "args", 32768 /* RestParameter */ );
            if (lastParamVariadicType) syntheticArgsSymbol.links.type = createArrayType(getTypeFromTypeNode(lastParamVariadicType.type));
            else {
                syntheticArgsSymbol.links.checkFlags |= 65536 /* DeferredType */ ;
                syntheticArgsSymbol.links.deferralParent = neverType;
                syntheticArgsSymbol.links.deferralConstituents = [
                    anyArrayType
                ];
                syntheticArgsSymbol.links.deferralWriteConstituents = [
                    anyArrayType
                ];
            }
            if (lastParamVariadicType) parameters.pop();
            parameters.push(syntheticArgsSymbol);
            return true;
        }
        function getSignatureOfTypeTag(node) {
            if (!(isInJSFile(node) && isFunctionLikeDeclaration(node))) return void 0;
            const typeTag = getJSDocTypeTag(node);
            return (typeTag == null ? void 0 : typeTag.typeExpression) && getSingleCallSignature(getTypeFromTypeNode(typeTag.typeExpression));
        }
        function getParameterTypeOfTypeTag(func, parameter) {
            const signature = getSignatureOfTypeTag(func);
            if (!signature) return void 0;
            const pos = func.parameters.indexOf(parameter);
            return parameter.dotDotDotToken ? getRestTypeAtPosition(signature, pos) : getTypeAtPosition(signature, pos);
        }
        function getReturnTypeOfTypeTag(node) {
            const signature = getSignatureOfTypeTag(node);
            return signature && getReturnTypeOfSignature(signature);
        }
        function containsArgumentsReference(declaration) {
            const links = getNodeLinks(declaration);
            if (links.containsArgumentsReference === void 0) {
                if (links.flags & 512 /* CaptureArguments */ ) links.containsArgumentsReference = true;
                else links.containsArgumentsReference = traverse(declaration.body);
            }
            return links.containsArgumentsReference;
            function traverse(node) {
                if (!node) return false;
                switch(node.kind){
                    case 80 /* Identifier */ :
                        return node.escapedText === argumentsSymbol.escapedName && getReferencedValueSymbol(node) === argumentsSymbol;
                    case 171 /* PropertyDeclaration */ :
                    case 173 /* MethodDeclaration */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                        return node.name.kind === 166 /* ComputedPropertyName */  && traverse(node.name);
                    case 210 /* PropertyAccessExpression */ :
                    case 211 /* ElementAccessExpression */ :
                        return traverse(node.expression);
                    case 302 /* PropertyAssignment */ :
                        return traverse(node.initializer);
                    default:
                        return !nodeStartsNewLexicalEnvironment(node) && !isPartOfTypeNode(node) && !!forEachChild(node, traverse);
                }
            }
        }
        function getSignaturesOfSymbol(symbol) {
            if (!symbol || !symbol.declarations) return emptyArray;
            const result = [];
            for(let i = 0; i < symbol.declarations.length; i++){
                const decl = symbol.declarations[i];
                if (!isFunctionLike(decl)) continue;
                if (i > 0 && decl.body) {
                    const previous = symbol.declarations[i - 1];
                    if (decl.parent === previous.parent && decl.kind === previous.kind && decl.pos === previous.end) continue;
                }
                if (isInJSFile(decl) && decl.jsDoc) {
                    let hasJSDocOverloads = false;
                    for (const node of decl.jsDoc)if (node.tags) {
                        for (const tag of node.tags)if (isJSDocOverloadTag(tag)) {
                            const jsDocSignature = tag.typeExpression;
                            if (jsDocSignature.type === void 0 && !isConstructorDeclaration(decl)) reportImplicitAny(jsDocSignature, anyType);
                            result.push(getSignatureFromDeclaration(jsDocSignature));
                            hasJSDocOverloads = true;
                        }
                    }
                    if (hasJSDocOverloads) continue;
                }
                result.push(!isFunctionExpressionOrArrowFunction(decl) && !isObjectLiteralMethod(decl) && getSignatureOfTypeTag(decl) || getSignatureFromDeclaration(decl));
            }
            return result;
        }
        function resolveExternalModuleTypeByLiteral(name) {
            const moduleSym = resolveExternalModuleName(name, name);
            if (moduleSym) {
                const resolvedModuleSymbol = resolveExternalModuleSymbol(moduleSym);
                if (resolvedModuleSymbol) return getTypeOfSymbol(resolvedModuleSymbol);
            }
            return anyType;
        }
        function getThisTypeOfSignature(signature) {
            if (signature.thisParameter) return getTypeOfSymbol(signature.thisParameter);
        }
        function getTypePredicateOfSignature(signature) {
            if (!signature.resolvedTypePredicate) {
                if (signature.target) {
                    const targetTypePredicate = getTypePredicateOfSignature(signature.target);
                    signature.resolvedTypePredicate = targetTypePredicate ? instantiateTypePredicate(targetTypePredicate, signature.mapper) : noTypePredicate;
                } else if (signature.compositeSignatures) signature.resolvedTypePredicate = getUnionOrIntersectionTypePredicate(signature.compositeSignatures, signature.compositeKind) || noTypePredicate;
                else {
                    const type = signature.declaration && getEffectiveReturnTypeNode(signature.declaration);
                    let jsdocPredicate;
                    if (!type) {
                        const jsdocSignature = getSignatureOfTypeTag(signature.declaration);
                        if (jsdocSignature && signature !== jsdocSignature) jsdocPredicate = getTypePredicateOfSignature(jsdocSignature);
                    }
                    signature.resolvedTypePredicate = type && isTypePredicateNode(type) ? createTypePredicateFromTypePredicateNode(type, signature) : jsdocPredicate || noTypePredicate;
                }
                Debug.assert(!!signature.resolvedTypePredicate);
            }
            return signature.resolvedTypePredicate === noTypePredicate ? void 0 : signature.resolvedTypePredicate;
        }
        function createTypePredicateFromTypePredicateNode(node, signature) {
            const parameterName = node.parameterName;
            const type = node.type && getTypeFromTypeNode(node.type);
            return parameterName.kind === 196 /* ThisType */  ? createTypePredicate(node.assertsModifier ? 2 /* AssertsThis */  : 0 /* This */ , /*parameterName*/ void 0, /*parameterIndex*/ void 0, type) : createTypePredicate(node.assertsModifier ? 3 /* AssertsIdentifier */  : 1 /* Identifier */ , parameterName.escapedText, findIndex(signature.parameters, (p)=>p.escapedName === parameterName.escapedText), type);
        }
        function getUnionOrIntersectionType(types, kind, unionReduction) {
            return kind !== 2097152 /* Intersection */  ? getUnionType(types, unionReduction) : getIntersectionType(types);
        }
        function getReturnTypeOfSignature(signature) {
            if (!signature.resolvedReturnType) {
                if (!pushTypeResolution(signature, 3 /* ResolvedReturnType */ )) return errorType;
                let type = signature.target ? instantiateType(getReturnTypeOfSignature(signature.target), signature.mapper) : signature.compositeSignatures ? instantiateType(getUnionOrIntersectionType(map(signature.compositeSignatures, getReturnTypeOfSignature), signature.compositeKind, 2 /* Subtype */ ), signature.mapper) : getReturnTypeFromAnnotation(signature.declaration) || (nodeIsMissing(signature.declaration.body) ? anyType : getReturnTypeFromBody(signature.declaration));
                if (signature.flags & 8 /* IsInnerCallChain */ ) type = addOptionalTypeMarker(type);
                else if (signature.flags & 16 /* IsOuterCallChain */ ) type = getOptionalType(type);
                if (!popTypeResolution()) {
                    if (signature.declaration) {
                        const typeNode = getEffectiveReturnTypeNode(signature.declaration);
                        if (typeNode) error(typeNode, Diagnostics.Return_type_annotation_circularly_references_itself);
                        else if (noImplicitAny) {
                            const declaration = signature.declaration;
                            const name = getNameOfDeclaration(declaration);
                            if (name) error(name, Diagnostics._0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions, declarationNameToString(name));
                            else error(declaration, Diagnostics.Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions);
                        }
                    }
                    type = anyType;
                }
                signature.resolvedReturnType = type;
            }
            return signature.resolvedReturnType;
        }
        function getReturnTypeFromAnnotation(declaration) {
            if (declaration.kind === 175 /* Constructor */ ) return getDeclaredTypeOfClassOrInterface(getMergedSymbol(declaration.parent.symbol));
            const typeNode = getEffectiveReturnTypeNode(declaration);
            if (isJSDocSignature(declaration)) {
                const root = getJSDocRoot(declaration);
                if (root && isConstructorDeclaration(root.parent) && !typeNode) return getDeclaredTypeOfClassOrInterface(getMergedSymbol(root.parent.parent.symbol));
            }
            if (isJSDocConstructSignature(declaration)) return getTypeFromTypeNode(declaration.parameters[0].type);
            if (typeNode) return getTypeFromTypeNode(typeNode);
            if (declaration.kind === 176 /* GetAccessor */  && hasBindableName(declaration)) {
                const jsDocType = isInJSFile(declaration) && getTypeForDeclarationFromJSDocComment(declaration);
                if (jsDocType) return jsDocType;
                const setter = getDeclarationOfKind(getSymbolOfDeclaration(declaration), 177 /* SetAccessor */ );
                const setterType = getAnnotatedAccessorType(setter);
                if (setterType) return setterType;
            }
            return getReturnTypeOfTypeTag(declaration);
        }
        function isResolvingReturnTypeOfSignature(signature) {
            return !signature.resolvedReturnType && findResolutionCycleStartIndex(signature, 3 /* ResolvedReturnType */ ) >= 0;
        }
        function getRestTypeOfSignature(signature) {
            return tryGetRestTypeOfSignature(signature) || anyType;
        }
        function tryGetRestTypeOfSignature(signature) {
            if (signatureHasRestParameter(signature)) {
                const sigRestType = getTypeOfSymbol(signature.parameters[signature.parameters.length - 1]);
                const restType = isTupleType(sigRestType) ? getRestTypeOfTupleType(sigRestType) : sigRestType;
                return restType && getIndexTypeOfType(restType, numberType);
            }
            return void 0;
        }
        function getSignatureInstantiation(signature, typeArguments, isJavascript, inferredTypeParameters) {
            const instantiatedSignature = getSignatureInstantiationWithoutFillingInTypeArguments(signature, fillMissingTypeArguments(typeArguments, signature.typeParameters, getMinTypeArgumentCount(signature.typeParameters), isJavascript));
            if (inferredTypeParameters) {
                const returnSignature = getSingleCallOrConstructSignature(getReturnTypeOfSignature(instantiatedSignature));
                if (returnSignature) {
                    const newReturnSignature = cloneSignature(returnSignature);
                    newReturnSignature.typeParameters = inferredTypeParameters;
                    const newInstantiatedSignature = cloneSignature(instantiatedSignature);
                    newInstantiatedSignature.resolvedReturnType = getOrCreateTypeFromSignature(newReturnSignature);
                    return newInstantiatedSignature;
                }
            }
            return instantiatedSignature;
        }
        function getSignatureInstantiationWithoutFillingInTypeArguments(signature, typeArguments) {
            const instantiations = signature.instantiations || (signature.instantiations = /* @__PURE__ */ new Map());
            const id = getTypeListId(typeArguments);
            let instantiation = instantiations.get(id);
            if (!instantiation) instantiations.set(id, instantiation = createSignatureInstantiation(signature, typeArguments));
            return instantiation;
        }
        function createSignatureInstantiation(signature, typeArguments) {
            return instantiateSignature(signature, createSignatureTypeMapper(signature, typeArguments), /*eraseTypeParameters*/ true);
        }
        function createSignatureTypeMapper(signature, typeArguments) {
            return createTypeMapper(signature.typeParameters, typeArguments);
        }
        function getErasedSignature(signature) {
            return signature.typeParameters ? signature.erasedSignatureCache || (signature.erasedSignatureCache = createErasedSignature(signature)) : signature;
        }
        function createErasedSignature(signature) {
            return instantiateSignature(signature, createTypeEraser(signature.typeParameters), /*eraseTypeParameters*/ true);
        }
        function getCanonicalSignature(signature) {
            return signature.typeParameters ? signature.canonicalSignatureCache || (signature.canonicalSignatureCache = createCanonicalSignature(signature)) : signature;
        }
        function createCanonicalSignature(signature) {
            return getSignatureInstantiation(signature, map(signature.typeParameters, (tp)=>tp.target && !getConstraintOfTypeParameter(tp.target) ? tp.target : tp), isInJSFile(signature.declaration));
        }
        function getBaseSignature(signature) {
            const typeParameters = signature.typeParameters;
            if (typeParameters) {
                if (signature.baseSignatureCache) return signature.baseSignatureCache;
                const typeEraser = createTypeEraser(typeParameters);
                const baseConstraintMapper = createTypeMapper(typeParameters, map(typeParameters, (tp)=>getConstraintOfTypeParameter(tp) || unknownType));
                let baseConstraints = map(typeParameters, (tp)=>instantiateType(tp, baseConstraintMapper) || unknownType);
                for(let i = 0; i < typeParameters.length - 1; i++)baseConstraints = instantiateTypes(baseConstraints, baseConstraintMapper);
                baseConstraints = instantiateTypes(baseConstraints, typeEraser);
                return signature.baseSignatureCache = instantiateSignature(signature, createTypeMapper(typeParameters, baseConstraints), /*eraseTypeParameters*/ true);
            }
            return signature;
        }
        function getOrCreateTypeFromSignature(signature) {
            var _a;
            if (!signature.isolatedSignatureType) {
                const kind = (_a = signature.declaration) == null ? void 0 : _a.kind;
                const isConstructor = kind === void 0 || kind === 175 /* Constructor */  || kind === 179 /* ConstructSignature */  || kind === 184 /* ConstructorType */ ;
                const type = createObjectType(16 /* Anonymous */ );
                type.members = emptySymbols;
                type.properties = emptyArray;
                type.callSignatures = !isConstructor ? [
                    signature
                ] : emptyArray;
                type.constructSignatures = isConstructor ? [
                    signature
                ] : emptyArray;
                type.indexInfos = emptyArray;
                signature.isolatedSignatureType = type;
            }
            return signature.isolatedSignatureType;
        }
        function getIndexSymbol(symbol) {
            return symbol.members ? getIndexSymbolFromSymbolTable(symbol.members) : void 0;
        }
        function getIndexSymbolFromSymbolTable(symbolTable) {
            return symbolTable.get("__index" /* Index */ );
        }
        function createIndexInfo(keyType, type, isReadonly, declaration) {
            return {
                keyType: keyType,
                type: type,
                isReadonly: isReadonly,
                declaration: declaration
            };
        }
        function getIndexInfosOfSymbol(symbol) {
            const indexSymbol = getIndexSymbol(symbol);
            return indexSymbol ? getIndexInfosOfIndexSymbol(indexSymbol) : emptyArray;
        }
        function getIndexInfosOfIndexSymbol(indexSymbol) {
            if (indexSymbol.declarations) {
                const indexInfos = [];
                for (const declaration of indexSymbol.declarations)if (declaration.parameters.length === 1) {
                    const parameter = declaration.parameters[0];
                    if (parameter.type) forEachType(getTypeFromTypeNode(parameter.type), (keyType)=>{
                        if (isValidIndexKeyType(keyType) && !findIndexInfo(indexInfos, keyType)) indexInfos.push(createIndexInfo(keyType, declaration.type ? getTypeFromTypeNode(declaration.type) : anyType, hasEffectiveModifier(declaration, 64 /* Readonly */ ), declaration));
                    });
                }
                return indexInfos;
            }
            return emptyArray;
        }
        function isValidIndexKeyType(type) {
            return !!(type.flags & 4108 /* ESSymbol */ ) || isPatternLiteralType(type) || !!(type.flags & 2097152 /* Intersection */ ) && !isGenericType(type) && some(type.types, isValidIndexKeyType);
        }
        function getConstraintDeclaration(type) {
            return mapDefined(filter(type.symbol && type.symbol.declarations, isTypeParameterDeclaration), getEffectiveConstraintOfTypeParameter)[0];
        }
        function getInferredTypeParameterConstraint(typeParameter, omitTypeReferences) {
            var _a;
            let inferences;
            if ((_a = typeParameter.symbol) == null ? void 0 : _a.declarations) {
                for (const declaration of typeParameter.symbol.declarations)if (declaration.parent.kind === 194 /* InferType */ ) {
                    const [childTypeParameter = declaration.parent, grandParent] = walkUpParenthesizedTypesAndGetParentAndChild(declaration.parent.parent);
                    if (grandParent.kind === 182 /* TypeReference */  && !omitTypeReferences) {
                        const typeReference = grandParent;
                        const typeParameters = getTypeParametersForTypeReferenceOrImport(typeReference);
                        if (typeParameters) {
                            const index = typeReference.typeArguments.indexOf(childTypeParameter);
                            if (index < typeParameters.length) {
                                const declaredConstraint = getConstraintOfTypeParameter(typeParameters[index]);
                                if (declaredConstraint) {
                                    const mapper = makeDeferredTypeMapper(typeParameters, typeParameters.map((_, index2)=>()=>{
                                            return getEffectiveTypeArgumentAtIndex(typeReference, typeParameters, index2);
                                        }));
                                    const constraint = instantiateType(declaredConstraint, mapper);
                                    if (constraint !== typeParameter) inferences = append(inferences, constraint);
                                }
                            }
                        }
                    } else if (grandParent.kind === 168 /* Parameter */  && grandParent.dotDotDotToken || grandParent.kind === 190 /* RestType */  || grandParent.kind === 201 /* NamedTupleMember */  && grandParent.dotDotDotToken) inferences = append(inferences, createArrayType(unknownType));
                    else if (grandParent.kind === 203 /* TemplateLiteralTypeSpan */ ) inferences = append(inferences, stringType);
                    else if (grandParent.kind === 167 /* TypeParameter */  && grandParent.parent.kind === 199 /* MappedType */ ) inferences = append(inferences, keyofConstraintType);
                    else if (grandParent.kind === 199 /* MappedType */  && grandParent.type && skipParentheses(grandParent.type) === declaration.parent && grandParent.parent.kind === 193 /* ConditionalType */  && grandParent.parent.extendsType === grandParent && grandParent.parent.checkType.kind === 199 /* MappedType */  && grandParent.parent.checkType.type) {
                        const checkMappedType2 = grandParent.parent.checkType;
                        const nodeType = getTypeFromTypeNode(checkMappedType2.type);
                        inferences = append(inferences, instantiateType(nodeType, makeUnaryTypeMapper(getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(checkMappedType2.typeParameter)), checkMappedType2.typeParameter.constraint ? getTypeFromTypeNode(checkMappedType2.typeParameter.constraint) : keyofConstraintType)));
                    }
                }
            }
            return inferences && getIntersectionType(inferences);
        }
        function getConstraintFromTypeParameter(typeParameter) {
            if (!typeParameter.constraint) {
                if (typeParameter.target) {
                    const targetConstraint = getConstraintOfTypeParameter(typeParameter.target);
                    typeParameter.constraint = targetConstraint ? instantiateType(targetConstraint, typeParameter.mapper) : noConstraintType;
                } else {
                    const constraintDeclaration = getConstraintDeclaration(typeParameter);
                    if (!constraintDeclaration) typeParameter.constraint = getInferredTypeParameterConstraint(typeParameter) || noConstraintType;
                    else {
                        let type = getTypeFromTypeNode(constraintDeclaration);
                        if (type.flags & 1 /* Any */  && !isErrorType(type)) type = constraintDeclaration.parent.parent.kind === 199 /* MappedType */  ? keyofConstraintType : unknownType;
                        typeParameter.constraint = type;
                    }
                }
            }
            return typeParameter.constraint === noConstraintType ? void 0 : typeParameter.constraint;
        }
        function getParentSymbolOfTypeParameter(typeParameter) {
            const tp = getDeclarationOfKind(typeParameter.symbol, 167 /* TypeParameter */ );
            const host2 = isJSDocTemplateTag(tp.parent) ? getEffectiveContainerForJSDocTemplateTag(tp.parent) : tp.parent;
            return host2 && getSymbolOfNode(host2);
        }
        function getTypeListId(types) {
            let result = "";
            if (types) {
                const length2 = types.length;
                let i = 0;
                while(i < length2){
                    const startId = types[i].id;
                    let count = 1;
                    while(i + count < length2 && types[i + count].id === startId + count)count++;
                    if (result.length) result += ",";
                    result += startId;
                    if (count > 1) result += ":" + count;
                    i += count;
                }
            }
            return result;
        }
        function getAliasId(aliasSymbol, aliasTypeArguments) {
            return aliasSymbol ? `@${getSymbolId(aliasSymbol)}` + (aliasTypeArguments ? `:${getTypeListId(aliasTypeArguments)}` : "") : "";
        }
        function getPropagatingFlagsOfTypes(types, excludeKinds) {
            let result = 0;
            for (const type of types)if (excludeKinds === void 0 || !(type.flags & excludeKinds)) result |= getObjectFlags(type);
            return result & 458752 /* PropagatingFlags */ ;
        }
        function tryCreateTypeReference(target, typeArguments) {
            if (some(typeArguments) && target === emptyGenericType) return unknownType;
            return createTypeReference(target, typeArguments);
        }
        function createTypeReference(target, typeArguments) {
            const id = getTypeListId(typeArguments);
            let type = target.instantiations.get(id);
            if (!type) {
                type = createObjectType(4 /* Reference */ , target.symbol);
                target.instantiations.set(id, type);
                type.objectFlags |= typeArguments ? getPropagatingFlagsOfTypes(typeArguments) : 0;
                type.target = target;
                type.resolvedTypeArguments = typeArguments;
            }
            return type;
        }
        function cloneTypeReference(source) {
            const type = createTypeWithSymbol(source.flags, source.symbol);
            type.objectFlags = source.objectFlags;
            type.target = source.target;
            type.resolvedTypeArguments = source.resolvedTypeArguments;
            return type;
        }
        function createDeferredTypeReference(target, node, mapper, aliasSymbol, aliasTypeArguments) {
            if (!aliasSymbol) {
                aliasSymbol = getAliasSymbolForTypeNode(node);
                const localAliasTypeArguments = getTypeArgumentsForAliasSymbol(aliasSymbol);
                aliasTypeArguments = mapper ? instantiateTypes(localAliasTypeArguments, mapper) : localAliasTypeArguments;
            }
            const type = createObjectType(4 /* Reference */ , target.symbol);
            type.target = target;
            type.node = node;
            type.mapper = mapper;
            type.aliasSymbol = aliasSymbol;
            type.aliasTypeArguments = aliasTypeArguments;
            return type;
        }
        function getTypeArguments(type) {
            var _a, _b;
            if (!type.resolvedTypeArguments) {
                if (!pushTypeResolution(type, 6 /* ResolvedTypeArguments */ )) return ((_a = type.target.localTypeParameters) == null ? void 0 : _a.map(()=>errorType)) || emptyArray;
                const node = type.node;
                const typeArguments = !node ? emptyArray : node.kind === 182 /* TypeReference */  ? concatenate(type.target.outerTypeParameters, getEffectiveTypeArguments2(node, type.target.localTypeParameters)) : node.kind === 187 /* ArrayType */  ? [
                    getTypeFromTypeNode(node.elementType)
                ] : map(node.elements, getTypeFromTypeNode);
                if (popTypeResolution()) type.resolvedTypeArguments = type.mapper ? instantiateTypes(typeArguments, type.mapper) : typeArguments;
                else {
                    type.resolvedTypeArguments = ((_b = type.target.localTypeParameters) == null ? void 0 : _b.map(()=>errorType)) || emptyArray;
                    error(type.node || currentNode, type.target.symbol ? Diagnostics.Type_arguments_for_0_circularly_reference_themselves : Diagnostics.Tuple_type_arguments_circularly_reference_themselves, type.target.symbol && symbolToString(type.target.symbol));
                }
            }
            return type.resolvedTypeArguments;
        }
        function getTypeReferenceArity(type) {
            return length(type.target.typeParameters);
        }
        function getTypeFromClassOrInterfaceReference(node, symbol) {
            const type = getDeclaredTypeOfSymbol(getMergedSymbol(symbol));
            const typeParameters = type.localTypeParameters;
            if (typeParameters) {
                const numTypeArguments = length(node.typeArguments);
                const minTypeArgumentCount = getMinTypeArgumentCount(typeParameters);
                const isJs = isInJSFile(node);
                const isJsImplicitAny = !noImplicitAny && isJs;
                if (!isJsImplicitAny && (numTypeArguments < minTypeArgumentCount || numTypeArguments > typeParameters.length)) {
                    const missingAugmentsTag = isJs && isExpressionWithTypeArguments(node) && !isJSDocAugmentsTag(node.parent);
                    const diag2 = minTypeArgumentCount === typeParameters.length ? missingAugmentsTag ? Diagnostics.Expected_0_type_arguments_provide_these_with_an_extends_tag : Diagnostics.Generic_type_0_requires_1_type_argument_s : missingAugmentsTag ? Diagnostics.Expected_0_1_type_arguments_provide_these_with_an_extends_tag : Diagnostics.Generic_type_0_requires_between_1_and_2_type_arguments;
                    const typeStr = typeToString(type, /*enclosingDeclaration*/ void 0, 2 /* WriteArrayAsGenericType */ );
                    error(node, diag2, typeStr, minTypeArgumentCount, typeParameters.length);
                    if (!isJs) return errorType;
                }
                if (node.kind === 182 /* TypeReference */  && isDeferredTypeReferenceNode(node, length(node.typeArguments) !== typeParameters.length)) return createDeferredTypeReference(type, node, /*mapper*/ void 0);
                const typeArguments = concatenate(type.outerTypeParameters, fillMissingTypeArguments(typeArgumentsFromTypeReferenceNode(node), typeParameters, minTypeArgumentCount, isJs));
                return createTypeReference(type, typeArguments);
            }
            return checkNoTypeArguments(node, symbol) ? type : errorType;
        }
        function getTypeAliasInstantiation(symbol, typeArguments, aliasSymbol, aliasTypeArguments) {
            const type = getDeclaredTypeOfSymbol(symbol);
            if (type === intrinsicMarkerType && intrinsicTypeKinds.has(symbol.escapedName) && typeArguments && typeArguments.length === 1) return getStringMappingType(symbol, typeArguments[0]);
            const links = getSymbolLinks(symbol);
            const typeParameters = links.typeParameters;
            const id = getTypeListId(typeArguments) + getAliasId(aliasSymbol, aliasTypeArguments);
            let instantiation = links.instantiations.get(id);
            if (!instantiation) links.instantiations.set(id, instantiation = instantiateTypeWithAlias(type, createTypeMapper(typeParameters, fillMissingTypeArguments(typeArguments, typeParameters, getMinTypeArgumentCount(typeParameters), isInJSFile(symbol.valueDeclaration))), aliasSymbol, aliasTypeArguments));
            return instantiation;
        }
        function getTypeFromTypeAliasReference(node, symbol) {
            if (getCheckFlags(symbol) & 1048576 /* Unresolved */ ) {
                const typeArguments = typeArgumentsFromTypeReferenceNode(node);
                const id = getAliasId(symbol, typeArguments);
                let errorType2 = errorTypes.get(id);
                if (!errorType2) {
                    errorType2 = createIntrinsicType(1 /* Any */ , "error");
                    errorType2.aliasSymbol = symbol;
                    errorType2.aliasTypeArguments = typeArguments;
                    errorTypes.set(id, errorType2);
                }
                return errorType2;
            }
            const type = getDeclaredTypeOfSymbol(symbol);
            const typeParameters = getSymbolLinks(symbol).typeParameters;
            if (typeParameters) {
                const numTypeArguments = length(node.typeArguments);
                const minTypeArgumentCount = getMinTypeArgumentCount(typeParameters);
                if (numTypeArguments < minTypeArgumentCount || numTypeArguments > typeParameters.length) {
                    error(node, minTypeArgumentCount === typeParameters.length ? Diagnostics.Generic_type_0_requires_1_type_argument_s : Diagnostics.Generic_type_0_requires_between_1_and_2_type_arguments, symbolToString(symbol), minTypeArgumentCount, typeParameters.length);
                    return errorType;
                }
                const aliasSymbol = getAliasSymbolForTypeNode(node);
                let newAliasSymbol = aliasSymbol && (isLocalTypeAlias(symbol) || !isLocalTypeAlias(aliasSymbol)) ? aliasSymbol : void 0;
                let aliasTypeArguments;
                if (newAliasSymbol) aliasTypeArguments = getTypeArgumentsForAliasSymbol(newAliasSymbol);
                else if (isTypeReferenceType(node)) {
                    const aliasSymbol2 = resolveTypeReferenceName(node, 2097152 /* Alias */ , /*ignoreErrors*/ true);
                    if (aliasSymbol2 && aliasSymbol2 !== unknownSymbol) {
                        const resolved = resolveAlias(aliasSymbol2);
                        if (resolved && resolved.flags & 524288 /* TypeAlias */ ) {
                            newAliasSymbol = resolved;
                            aliasTypeArguments = typeArgumentsFromTypeReferenceNode(node) || (typeParameters ? [] : void 0);
                        }
                    }
                }
                return getTypeAliasInstantiation(symbol, typeArgumentsFromTypeReferenceNode(node), newAliasSymbol, aliasTypeArguments);
            }
            return checkNoTypeArguments(node, symbol) ? type : errorType;
        }
        function isLocalTypeAlias(symbol) {
            var _a;
            const declaration = (_a = symbol.declarations) == null ? void 0 : _a.find(isTypeAlias);
            return !!(declaration && getContainingFunction(declaration));
        }
        function getTypeReferenceName(node) {
            switch(node.kind){
                case 182 /* TypeReference */ :
                    return node.typeName;
                case 232 /* ExpressionWithTypeArguments */ :
                    const expr = node.expression;
                    if (isEntityNameExpression(expr)) return expr;
            }
            return void 0;
        }
        function getSymbolPath(symbol) {
            return symbol.parent ? `${getSymbolPath(symbol.parent)}.${symbol.escapedName}` : symbol.escapedName;
        }
        function getUnresolvedSymbolForEntityName(name) {
            const identifier = name.kind === 165 /* QualifiedName */  ? name.right : name.kind === 210 /* PropertyAccessExpression */  ? name.name : name;
            const text = identifier.escapedText;
            if (text) {
                const parentSymbol = name.kind === 165 /* QualifiedName */  ? getUnresolvedSymbolForEntityName(name.left) : name.kind === 210 /* PropertyAccessExpression */  ? getUnresolvedSymbolForEntityName(name.expression) : void 0;
                const path = parentSymbol ? `${getSymbolPath(parentSymbol)}.${text}` : text;
                let result = unresolvedSymbols.get(path);
                if (!result) {
                    unresolvedSymbols.set(path, result = createSymbol(524288 /* TypeAlias */ , text, 1048576 /* Unresolved */ ));
                    result.parent = parentSymbol;
                    result.links.declaredType = unresolvedType;
                }
                return result;
            }
            return unknownSymbol;
        }
        function resolveTypeReferenceName(typeReference, meaning, ignoreErrors) {
            const name = getTypeReferenceName(typeReference);
            if (!name) return unknownSymbol;
            const symbol = resolveEntityName(name, meaning, ignoreErrors);
            return symbol && symbol !== unknownSymbol ? symbol : ignoreErrors ? unknownSymbol : getUnresolvedSymbolForEntityName(name);
        }
        function getTypeReferenceType(node, symbol) {
            if (symbol === unknownSymbol) return errorType;
            symbol = getExpandoSymbol(symbol) || symbol;
            if (symbol.flags & 96 /* Interface */ ) return getTypeFromClassOrInterfaceReference(node, symbol);
            if (symbol.flags & 524288 /* TypeAlias */ ) return getTypeFromTypeAliasReference(node, symbol);
            const res = tryGetDeclaredTypeOfSymbol(symbol);
            if (res) return checkNoTypeArguments(node, symbol) ? getRegularTypeOfLiteralType(res) : errorType;
            if (symbol.flags & 111551 /* Value */  && isJSDocTypeReference(node)) {
                const jsdocType = getTypeFromJSDocValueReference(node, symbol);
                if (jsdocType) return jsdocType;
                else {
                    resolveTypeReferenceName(node, 788968 /* Type */ );
                    return getTypeOfSymbol(symbol);
                }
            }
            return errorType;
        }
        function getTypeFromJSDocValueReference(node, symbol) {
            const links = getNodeLinks(node);
            if (!links.resolvedJSDocType) {
                const valueType = getTypeOfSymbol(symbol);
                let typeType = valueType;
                if (symbol.valueDeclaration) {
                    const isImportTypeWithQualifier = node.kind === 204 /* ImportType */  && node.qualifier;
                    if (valueType.symbol && valueType.symbol !== symbol && isImportTypeWithQualifier) typeType = getTypeReferenceType(node, valueType.symbol);
                }
                links.resolvedJSDocType = typeType;
            }
            return links.resolvedJSDocType;
        }
        function getSubstitutionType(baseType, constraint) {
            if (constraint.flags & 3 /* AnyOrUnknown */  || constraint === baseType || baseType.flags & 1 /* Any */ ) return baseType;
            const id = `${getTypeId(baseType)}>${getTypeId(constraint)}`;
            const cached = substitutionTypes.get(id);
            if (cached) return cached;
            const result = createType(33554432 /* Substitution */ );
            result.baseType = baseType;
            result.constraint = constraint;
            substitutionTypes.set(id, result);
            return result;
        }
        function getSubstitutionIntersection(substitutionType) {
            return getIntersectionType([
                substitutionType.constraint,
                substitutionType.baseType
            ]);
        }
        function isUnaryTupleTypeNode(node) {
            return node.kind === 188 /* TupleType */  && node.elements.length === 1;
        }
        function getImpliedConstraint(type, checkNode, extendsNode) {
            return isUnaryTupleTypeNode(checkNode) && isUnaryTupleTypeNode(extendsNode) ? getImpliedConstraint(type, checkNode.elements[0], extendsNode.elements[0]) : getActualTypeVariable(getTypeFromTypeNode(checkNode)) === getActualTypeVariable(type) ? getTypeFromTypeNode(extendsNode) : void 0;
        }
        function getConditionalFlowTypeOfType(type, node) {
            let constraints;
            let covariant = true;
            while(node && !isStatement(node) && node.kind !== 326 /* JSDoc */ ){
                const parent2 = node.parent;
                if (parent2.kind === 168 /* Parameter */ ) covariant = !covariant;
                if ((covariant || type.flags & 8650752 /* TypeVariable */ ) && parent2.kind === 193 /* ConditionalType */  && node === parent2.trueType) {
                    const constraint = getImpliedConstraint(type, parent2.checkType, parent2.extendsType);
                    if (constraint) constraints = append(constraints, constraint);
                } else if (type.flags & 262144 /* TypeParameter */  && parent2.kind === 199 /* MappedType */  && node === parent2.type) {
                    const mappedType = getTypeFromTypeNode(parent2);
                    if (getTypeParameterFromMappedType(mappedType) === getActualTypeVariable(type)) {
                        const typeParameter = getHomomorphicTypeVariable(mappedType);
                        if (typeParameter) {
                            const constraint = getConstraintOfTypeParameter(typeParameter);
                            if (constraint && everyType(constraint, isArrayOrTupleType)) constraints = append(constraints, getUnionType([
                                numberType,
                                numericStringType
                            ]));
                        }
                    }
                }
                node = parent2;
            }
            return constraints ? getSubstitutionType(type, getIntersectionType(constraints)) : type;
        }
        function isJSDocTypeReference(node) {
            return !!(node.flags & 8388608 /* JSDoc */ ) && (node.kind === 182 /* TypeReference */  || node.kind === 204 /* ImportType */ );
        }
        function checkNoTypeArguments(node, symbol) {
            if (node.typeArguments) {
                error(node, Diagnostics.Type_0_is_not_generic, symbol ? symbolToString(symbol) : node.typeName ? declarationNameToString(node.typeName) : anon);
                return false;
            }
            return true;
        }
        function getIntendedTypeFromJSDocTypeReference(node) {
            if (isIdentifier(node.typeName)) {
                const typeArgs = node.typeArguments;
                switch(node.typeName.escapedText){
                    case "String":
                        checkNoTypeArguments(node);
                        return stringType;
                    case "Number":
                        checkNoTypeArguments(node);
                        return numberType;
                    case "Boolean":
                        checkNoTypeArguments(node);
                        return booleanType;
                    case "Void":
                        checkNoTypeArguments(node);
                        return voidType;
                    case "Undefined":
                        checkNoTypeArguments(node);
                        return undefinedType;
                    case "Null":
                        checkNoTypeArguments(node);
                        return nullType;
                    case "Function":
                    case "function":
                        checkNoTypeArguments(node);
                        return globalFunctionType;
                    case "array":
                        return (!typeArgs || !typeArgs.length) && !noImplicitAny ? anyArrayType : void 0;
                    case "promise":
                        return (!typeArgs || !typeArgs.length) && !noImplicitAny ? createPromiseType(anyType) : void 0;
                    case "Object":
                        if (typeArgs && typeArgs.length === 2) {
                            if (isJSDocIndexSignature(node)) {
                                const indexed = getTypeFromTypeNode(typeArgs[0]);
                                const target = getTypeFromTypeNode(typeArgs[1]);
                                const indexInfo = indexed === stringType || indexed === numberType ? [
                                    createIndexInfo(indexed, target, /*isReadonly*/ false)
                                ] : emptyArray;
                                return createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, indexInfo);
                            }
                            return anyType;
                        }
                        checkNoTypeArguments(node);
                        return !noImplicitAny ? anyType : void 0;
                }
            }
        }
        function getTypeFromJSDocNullableTypeNode(node) {
            const type = getTypeFromTypeNode(node.type);
            return strictNullChecks ? getNullableType(type, 65536 /* Null */ ) : type;
        }
        function getTypeFromTypeReference(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                if (isConstTypeReference(node) && isAssertionExpression(node.parent)) {
                    links.resolvedSymbol = unknownSymbol;
                    return links.resolvedType = checkExpressionCached(node.parent.expression);
                }
                let symbol;
                let type;
                const meaning = 788968 /* Type */ ;
                if (isJSDocTypeReference(node)) {
                    type = getIntendedTypeFromJSDocTypeReference(node);
                    if (!type) {
                        symbol = resolveTypeReferenceName(node, meaning, /*ignoreErrors*/ true);
                        if (symbol === unknownSymbol) symbol = resolveTypeReferenceName(node, meaning | 111551 /* Value */ );
                        else resolveTypeReferenceName(node, meaning);
                        type = getTypeReferenceType(node, symbol);
                    }
                }
                if (!type) {
                    symbol = resolveTypeReferenceName(node, meaning);
                    type = getTypeReferenceType(node, symbol);
                }
                links.resolvedSymbol = symbol;
                links.resolvedType = type;
            }
            return links.resolvedType;
        }
        function typeArgumentsFromTypeReferenceNode(node) {
            return map(node.typeArguments, getTypeFromTypeNode);
        }
        function getTypeFromTypeQueryNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const type = checkExpressionWithTypeArguments(node);
                links.resolvedType = getRegularTypeOfLiteralType(getWidenedType(type));
            }
            return links.resolvedType;
        }
        function getTypeOfGlobalSymbol(symbol, arity) {
            function getTypeDeclaration(symbol2) {
                const declarations = symbol2.declarations;
                if (declarations) for (const declaration of declarations)switch(declaration.kind){
                    case 262 /* ClassDeclaration */ :
                    case 263 /* InterfaceDeclaration */ :
                    case 265 /* EnumDeclaration */ :
                        return declaration;
                }
            }
            if (!symbol) return arity ? emptyGenericType : emptyObjectType;
            const type = getDeclaredTypeOfSymbol(symbol);
            if (!(type.flags & 524288 /* Object */ )) {
                error(getTypeDeclaration(symbol), Diagnostics.Global_type_0_must_be_a_class_or_interface_type, symbolName(symbol));
                return arity ? emptyGenericType : emptyObjectType;
            }
            if (length(type.typeParameters) !== arity) {
                error(getTypeDeclaration(symbol), Diagnostics.Global_type_0_must_have_1_type_parameter_s, symbolName(symbol), arity);
                return arity ? emptyGenericType : emptyObjectType;
            }
            return type;
        }
        function getGlobalValueSymbol(name, reportErrors2) {
            return getGlobalSymbol(name, 111551 /* Value */ , reportErrors2 ? Diagnostics.Cannot_find_global_value_0 : void 0);
        }
        function getGlobalTypeSymbol(name, reportErrors2) {
            return getGlobalSymbol(name, 788968 /* Type */ , reportErrors2 ? Diagnostics.Cannot_find_global_type_0 : void 0);
        }
        function getGlobalTypeAliasSymbol(name, arity, reportErrors2) {
            const symbol = getGlobalSymbol(name, 788968 /* Type */ , reportErrors2 ? Diagnostics.Cannot_find_global_type_0 : void 0);
            if (symbol) {
                getDeclaredTypeOfSymbol(symbol);
                if (length(getSymbolLinks(symbol).typeParameters) !== arity) {
                    const decl = symbol.declarations && find(symbol.declarations, isTypeAliasDeclaration);
                    error(decl, Diagnostics.Global_type_0_must_have_1_type_parameter_s, symbolName(symbol), arity);
                    return void 0;
                }
            }
            return symbol;
        }
        function getGlobalSymbol(name, meaning, diagnostic) {
            return resolveName(/*location*/ void 0, name, meaning, diagnostic, name, /*isUse*/ false, /*excludeGlobals*/ false, /*getSpellingSuggestions*/ false);
        }
        function getGlobalType(name, arity, reportErrors2) {
            const symbol = getGlobalTypeSymbol(name, reportErrors2);
            return symbol || reportErrors2 ? getTypeOfGlobalSymbol(symbol, arity) : void 0;
        }
        function getGlobalTypedPropertyDescriptorType() {
            return deferredGlobalTypedPropertyDescriptorType || (deferredGlobalTypedPropertyDescriptorType = getGlobalType("TypedPropertyDescriptor", /*arity*/ 1, /*reportErrors*/ true) || emptyGenericType);
        }
        function getGlobalTemplateStringsArrayType() {
            return deferredGlobalTemplateStringsArrayType || (deferredGlobalTemplateStringsArrayType = getGlobalType("TemplateStringsArray", /*arity*/ 0, /*reportErrors*/ true) || emptyObjectType);
        }
        function getGlobalImportMetaType() {
            return deferredGlobalImportMetaType || (deferredGlobalImportMetaType = getGlobalType("ImportMeta", /*arity*/ 0, /*reportErrors*/ true) || emptyObjectType);
        }
        function getGlobalImportMetaExpressionType() {
            if (!deferredGlobalImportMetaExpressionType) {
                const symbol = createSymbol(0 /* None */ , "ImportMetaExpression");
                const importMetaType = getGlobalImportMetaType();
                const metaPropertySymbol = createSymbol(4 /* Property */ , "meta", 8 /* Readonly */ );
                metaPropertySymbol.parent = symbol;
                metaPropertySymbol.links.type = importMetaType;
                const members = createSymbolTable([
                    metaPropertySymbol
                ]);
                symbol.members = members;
                deferredGlobalImportMetaExpressionType = createAnonymousType(symbol, members, emptyArray, emptyArray, emptyArray);
            }
            return deferredGlobalImportMetaExpressionType;
        }
        function getGlobalImportCallOptionsType(reportErrors2) {
            return deferredGlobalImportCallOptionsType || (deferredGlobalImportCallOptionsType = getGlobalType("ImportCallOptions", /*arity*/ 0, reportErrors2)) || emptyObjectType;
        }
        function getGlobalESSymbolConstructorSymbol(reportErrors2) {
            return deferredGlobalESSymbolConstructorSymbol || (deferredGlobalESSymbolConstructorSymbol = getGlobalValueSymbol("Symbol", reportErrors2));
        }
        function getGlobalESSymbolConstructorTypeSymbol(reportErrors2) {
            return deferredGlobalESSymbolConstructorTypeSymbol || (deferredGlobalESSymbolConstructorTypeSymbol = getGlobalTypeSymbol("SymbolConstructor", reportErrors2));
        }
        function getGlobalESSymbolType() {
            return deferredGlobalESSymbolType || (deferredGlobalESSymbolType = getGlobalType("Symbol", /*arity*/ 0, /*reportErrors*/ false)) || emptyObjectType;
        }
        function getGlobalPromiseType(reportErrors2) {
            return deferredGlobalPromiseType || (deferredGlobalPromiseType = getGlobalType("Promise", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalPromiseLikeType(reportErrors2) {
            return deferredGlobalPromiseLikeType || (deferredGlobalPromiseLikeType = getGlobalType("PromiseLike", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalPromiseConstructorSymbol(reportErrors2) {
            return deferredGlobalPromiseConstructorSymbol || (deferredGlobalPromiseConstructorSymbol = getGlobalValueSymbol("Promise", reportErrors2));
        }
        function getGlobalPromiseConstructorLikeType(reportErrors2) {
            return deferredGlobalPromiseConstructorLikeType || (deferredGlobalPromiseConstructorLikeType = getGlobalType("PromiseConstructorLike", /*arity*/ 0, reportErrors2)) || emptyObjectType;
        }
        function getGlobalAsyncIterableType(reportErrors2) {
            return deferredGlobalAsyncIterableType || (deferredGlobalAsyncIterableType = getGlobalType("AsyncIterable", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalAsyncIteratorType(reportErrors2) {
            return deferredGlobalAsyncIteratorType || (deferredGlobalAsyncIteratorType = getGlobalType("AsyncIterator", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalAsyncIterableIteratorType(reportErrors2) {
            return deferredGlobalAsyncIterableIteratorType || (deferredGlobalAsyncIterableIteratorType = getGlobalType("AsyncIterableIterator", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalAsyncGeneratorType(reportErrors2) {
            return deferredGlobalAsyncGeneratorType || (deferredGlobalAsyncGeneratorType = getGlobalType("AsyncGenerator", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalIterableType(reportErrors2) {
            return deferredGlobalIterableType || (deferredGlobalIterableType = getGlobalType("Iterable", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalIteratorType(reportErrors2) {
            return deferredGlobalIteratorType || (deferredGlobalIteratorType = getGlobalType("Iterator", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalIterableIteratorType(reportErrors2) {
            return deferredGlobalIterableIteratorType || (deferredGlobalIterableIteratorType = getGlobalType("IterableIterator", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalGeneratorType(reportErrors2) {
            return deferredGlobalGeneratorType || (deferredGlobalGeneratorType = getGlobalType("Generator", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalIteratorYieldResultType(reportErrors2) {
            return deferredGlobalIteratorYieldResultType || (deferredGlobalIteratorYieldResultType = getGlobalType("IteratorYieldResult", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalIteratorReturnResultType(reportErrors2) {
            return deferredGlobalIteratorReturnResultType || (deferredGlobalIteratorReturnResultType = getGlobalType("IteratorReturnResult", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalTypeOrUndefined(name, arity = 0) {
            const symbol = getGlobalSymbol(name, 788968 /* Type */ , /*diagnostic*/ void 0);
            return symbol && getTypeOfGlobalSymbol(symbol, arity);
        }
        function getGlobalExtractSymbol() {
            deferredGlobalExtractSymbol || (deferredGlobalExtractSymbol = getGlobalTypeAliasSymbol("Extract", /*arity*/ 2, /*reportErrors*/ true) || unknownSymbol);
            return deferredGlobalExtractSymbol === unknownSymbol ? void 0 : deferredGlobalExtractSymbol;
        }
        function getGlobalOmitSymbol() {
            deferredGlobalOmitSymbol || (deferredGlobalOmitSymbol = getGlobalTypeAliasSymbol("Omit", /*arity*/ 2, /*reportErrors*/ true) || unknownSymbol);
            return deferredGlobalOmitSymbol === unknownSymbol ? void 0 : deferredGlobalOmitSymbol;
        }
        function getGlobalAwaitedSymbol(reportErrors2) {
            deferredGlobalAwaitedSymbol || (deferredGlobalAwaitedSymbol = getGlobalTypeAliasSymbol("Awaited", /*arity*/ 1, reportErrors2) || (reportErrors2 ? unknownSymbol : void 0));
            return deferredGlobalAwaitedSymbol === unknownSymbol ? void 0 : deferredGlobalAwaitedSymbol;
        }
        function getGlobalBigIntType() {
            return deferredGlobalBigIntType || (deferredGlobalBigIntType = getGlobalType("BigInt", /*arity*/ 0, /*reportErrors*/ false)) || emptyObjectType;
        }
        function getGlobalClassDecoratorContextType(reportErrors2) {
            return deferredGlobalClassDecoratorContextType ?? (deferredGlobalClassDecoratorContextType = getGlobalType("ClassDecoratorContext", /*arity*/ 1, reportErrors2)) ?? emptyGenericType;
        }
        function getGlobalClassMethodDecoratorContextType(reportErrors2) {
            return deferredGlobalClassMethodDecoratorContextType ?? (deferredGlobalClassMethodDecoratorContextType = getGlobalType("ClassMethodDecoratorContext", /*arity*/ 2, reportErrors2)) ?? emptyGenericType;
        }
        function getGlobalClassGetterDecoratorContextType(reportErrors2) {
            return deferredGlobalClassGetterDecoratorContextType ?? (deferredGlobalClassGetterDecoratorContextType = getGlobalType("ClassGetterDecoratorContext", /*arity*/ 2, reportErrors2)) ?? emptyGenericType;
        }
        function getGlobalClassSetterDecoratorContextType(reportErrors2) {
            return deferredGlobalClassSetterDecoratorContextType ?? (deferredGlobalClassSetterDecoratorContextType = getGlobalType("ClassSetterDecoratorContext", /*arity*/ 2, reportErrors2)) ?? emptyGenericType;
        }
        function getGlobalClassAccessorDecoratorContextType(reportErrors2) {
            return deferredGlobalClassAccessorDecoratorContextType ?? (deferredGlobalClassAccessorDecoratorContextType = getGlobalType("ClassAccessorDecoratorContext", /*arity*/ 2, reportErrors2)) ?? emptyGenericType;
        }
        function getGlobalClassAccessorDecoratorTargetType(reportErrors2) {
            return deferredGlobalClassAccessorDecoratorTargetType ?? (deferredGlobalClassAccessorDecoratorTargetType = getGlobalType("ClassAccessorDecoratorTarget", /*arity*/ 2, reportErrors2)) ?? emptyGenericType;
        }
        function getGlobalClassAccessorDecoratorResultType(reportErrors2) {
            return deferredGlobalClassAccessorDecoratorResultType ?? (deferredGlobalClassAccessorDecoratorResultType = getGlobalType("ClassAccessorDecoratorResult", /*arity*/ 2, reportErrors2)) ?? emptyGenericType;
        }
        function getGlobalClassFieldDecoratorContextType(reportErrors2) {
            return deferredGlobalClassFieldDecoratorContextType ?? (deferredGlobalClassFieldDecoratorContextType = getGlobalType("ClassFieldDecoratorContext", /*arity*/ 2, reportErrors2)) ?? emptyGenericType;
        }
        function getGlobalNaNSymbol() {
            return deferredGlobalNaNSymbol || (deferredGlobalNaNSymbol = getGlobalValueSymbol("NaN", /*reportErrors*/ false));
        }
        function getGlobalRecordSymbol() {
            deferredGlobalRecordSymbol || (deferredGlobalRecordSymbol = getGlobalTypeAliasSymbol("Record", /*arity*/ 2, /*reportErrors*/ true) || unknownSymbol);
            return deferredGlobalRecordSymbol === unknownSymbol ? void 0 : deferredGlobalRecordSymbol;
        }
        function createTypeFromGenericGlobalType(genericGlobalType, typeArguments) {
            return genericGlobalType !== emptyGenericType ? createTypeReference(genericGlobalType, typeArguments) : emptyObjectType;
        }
        function createTypedPropertyDescriptorType(propertyType) {
            return createTypeFromGenericGlobalType(getGlobalTypedPropertyDescriptorType(), [
                propertyType
            ]);
        }
        function createIterableType(iteratedType) {
            return createTypeFromGenericGlobalType(getGlobalIterableType(/*reportErrors*/ true), [
                iteratedType
            ]);
        }
        function createArrayType(elementType, readonly) {
            return createTypeFromGenericGlobalType(readonly ? globalReadonlyArrayType : globalArrayType, [
                elementType
            ]);
        }
        function getTupleElementFlags(node) {
            switch(node.kind){
                case 189 /* OptionalType */ :
                    return 2 /* Optional */ ;
                case 190 /* RestType */ :
                    return getRestTypeElementFlags(node);
                case 201 /* NamedTupleMember */ :
                    return node.questionToken ? 2 /* Optional */  : node.dotDotDotToken ? getRestTypeElementFlags(node) : 1 /* Required */ ;
                default:
                    return 1 /* Required */ ;
            }
        }
        function getRestTypeElementFlags(node) {
            return getArrayElementTypeNode(node.type) ? 4 /* Rest */  : 8 /* Variadic */ ;
        }
        function getArrayOrTupleTargetType(node) {
            const readonly = isReadonlyTypeOperator(node.parent);
            const elementType = getArrayElementTypeNode(node);
            if (elementType) return readonly ? globalReadonlyArrayType : globalArrayType;
            const elementFlags = map(node.elements, getTupleElementFlags);
            const missingName = some(node.elements, (e)=>e.kind !== 201 /* NamedTupleMember */ );
            return getTupleTargetType(elementFlags, readonly, /*associatedNames*/ missingName ? void 0 : node.elements);
        }
        function isDeferredTypeReferenceNode(node, hasDefaultTypeArguments) {
            return !!getAliasSymbolForTypeNode(node) || isResolvedByTypeAlias(node) && (node.kind === 187 /* ArrayType */  ? mayResolveTypeAlias(node.elementType) : node.kind === 188 /* TupleType */  ? some(node.elements, mayResolveTypeAlias) : hasDefaultTypeArguments || some(node.typeArguments, mayResolveTypeAlias));
        }
        function isResolvedByTypeAlias(node) {
            const parent2 = node.parent;
            switch(parent2.kind){
                case 195 /* ParenthesizedType */ :
                case 201 /* NamedTupleMember */ :
                case 182 /* TypeReference */ :
                case 191 /* UnionType */ :
                case 192 /* IntersectionType */ :
                case 198 /* IndexedAccessType */ :
                case 193 /* ConditionalType */ :
                case 197 /* TypeOperator */ :
                case 187 /* ArrayType */ :
                case 188 /* TupleType */ :
                    return isResolvedByTypeAlias(parent2);
                case 264 /* TypeAliasDeclaration */ :
                    return true;
            }
            return false;
        }
        function mayResolveTypeAlias(node) {
            switch(node.kind){
                case 182 /* TypeReference */ :
                    return isJSDocTypeReference(node) || !!(resolveTypeReferenceName(node, 788968 /* Type */ ).flags & 524288 /* TypeAlias */ );
                case 185 /* TypeQuery */ :
                    return true;
                case 197 /* TypeOperator */ :
                    return node.operator !== 158 /* UniqueKeyword */  && mayResolveTypeAlias(node.type);
                case 195 /* ParenthesizedType */ :
                case 189 /* OptionalType */ :
                case 201 /* NamedTupleMember */ :
                case 322 /* JSDocOptionalType */ :
                case 320 /* JSDocNullableType */ :
                case 321 /* JSDocNonNullableType */ :
                case 315 /* JSDocTypeExpression */ :
                    return mayResolveTypeAlias(node.type);
                case 190 /* RestType */ :
                    return node.type.kind !== 187 /* ArrayType */  || mayResolveTypeAlias(node.type.elementType);
                case 191 /* UnionType */ :
                case 192 /* IntersectionType */ :
                    return some(node.types, mayResolveTypeAlias);
                case 198 /* IndexedAccessType */ :
                    return mayResolveTypeAlias(node.objectType) || mayResolveTypeAlias(node.indexType);
                case 193 /* ConditionalType */ :
                    return mayResolveTypeAlias(node.checkType) || mayResolveTypeAlias(node.extendsType) || mayResolveTypeAlias(node.trueType) || mayResolveTypeAlias(node.falseType);
            }
            return false;
        }
        function getTypeFromArrayOrTupleTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const target = getArrayOrTupleTargetType(node);
                if (target === emptyGenericType) links.resolvedType = emptyObjectType;
                else if (!(node.kind === 188 /* TupleType */  && some(node.elements, (e)=>!!(getTupleElementFlags(e) & 8 /* Variadic */ ))) && isDeferredTypeReferenceNode(node)) links.resolvedType = node.kind === 188 /* TupleType */  && node.elements.length === 0 ? target : createDeferredTypeReference(target, node, /*mapper*/ void 0);
                else {
                    const elementTypes = node.kind === 187 /* ArrayType */  ? [
                        getTypeFromTypeNode(node.elementType)
                    ] : map(node.elements, getTypeFromTypeNode);
                    links.resolvedType = createNormalizedTypeReference(target, elementTypes);
                }
            }
            return links.resolvedType;
        }
        function isReadonlyTypeOperator(node) {
            return isTypeOperatorNode(node) && node.operator === 148 /* ReadonlyKeyword */ ;
        }
        function createTupleType(elementTypes, elementFlags, readonly = false, namedMemberDeclarations) {
            const tupleTarget = getTupleTargetType(elementFlags || map(elementTypes, (_)=>1 /* Required */ ), readonly, namedMemberDeclarations);
            return tupleTarget === emptyGenericType ? emptyObjectType : elementTypes.length ? createNormalizedTypeReference(tupleTarget, elementTypes) : tupleTarget;
        }
        function getTupleTargetType(elementFlags, readonly, namedMemberDeclarations) {
            if (elementFlags.length === 1 && elementFlags[0] & 4 /* Rest */ ) return readonly ? globalReadonlyArrayType : globalArrayType;
            const key = map(elementFlags, (f)=>f & 1 /* Required */  ? "#" : f & 2 /* Optional */  ? "?" : f & 4 /* Rest */  ? "." : "*").join() + (readonly ? "R" : "") + (namedMemberDeclarations && namedMemberDeclarations.length ? "," + map(namedMemberDeclarations, getNodeId).join(",") : "");
            let type = tupleTypes.get(key);
            if (!type) tupleTypes.set(key, type = createTupleTargetType(elementFlags, readonly, namedMemberDeclarations));
            return type;
        }
        function createTupleTargetType(elementFlags, readonly, namedMemberDeclarations) {
            const arity = elementFlags.length;
            const minLength = countWhere(elementFlags, (f)=>!!(f & 9 /* Variadic */ ));
            let typeParameters;
            const properties = [];
            let combinedFlags = 0;
            if (arity) {
                typeParameters = new Array(arity);
                for(let i = 0; i < arity; i++){
                    const typeParameter = typeParameters[i] = createTypeParameter();
                    const flags = elementFlags[i];
                    combinedFlags |= flags;
                    if (!(combinedFlags & 12 /* Variable */ )) {
                        const property = createSymbol(4 /* Property */  | (flags & 2 /* Optional */  ? 16777216 /* Optional */  : 0), "" + i, readonly ? 8 /* Readonly */  : 0);
                        property.links.tupleLabelDeclaration = namedMemberDeclarations == null ? void 0 : namedMemberDeclarations[i];
                        property.links.type = typeParameter;
                        properties.push(property);
                    }
                }
            }
            const fixedLength = properties.length;
            const lengthSymbol = createSymbol(4 /* Property */ , "length", readonly ? 8 /* Readonly */  : 0);
            if (combinedFlags & 12 /* Variable */ ) lengthSymbol.links.type = numberType;
            else {
                const literalTypes = [];
                for(let i = minLength; i <= arity; i++)literalTypes.push(getNumberLiteralType(i));
                lengthSymbol.links.type = getUnionType(literalTypes);
            }
            properties.push(lengthSymbol);
            const type = createObjectType(12 /* Reference */ );
            type.typeParameters = typeParameters;
            type.outerTypeParameters = void 0;
            type.localTypeParameters = typeParameters;
            type.instantiations = /* @__PURE__ */ new Map();
            type.instantiations.set(getTypeListId(type.typeParameters), type);
            type.target = type;
            type.resolvedTypeArguments = type.typeParameters;
            type.thisType = createTypeParameter();
            type.thisType.isThisType = true;
            type.thisType.constraint = type;
            type.declaredProperties = properties;
            type.declaredCallSignatures = emptyArray;
            type.declaredConstructSignatures = emptyArray;
            type.declaredIndexInfos = emptyArray;
            type.elementFlags = elementFlags;
            type.minLength = minLength;
            type.fixedLength = fixedLength;
            type.hasRestElement = !!(combinedFlags & 12 /* Variable */ );
            type.combinedFlags = combinedFlags;
            type.readonly = readonly;
            type.labeledElementDeclarations = namedMemberDeclarations;
            return type;
        }
        function createNormalizedTypeReference(target, typeArguments) {
            return target.objectFlags & 8 /* Tuple */  ? createNormalizedTupleType(target, typeArguments) : createTypeReference(target, typeArguments);
        }
        function createNormalizedTupleType(target, elementTypes) {
            var _a, _b, _c;
            if (!(target.combinedFlags & 14 /* NonRequired */ )) return createTypeReference(target, elementTypes);
            if (target.combinedFlags & 8 /* Variadic */ ) {
                const unionIndex = findIndex(elementTypes, (t, i)=>!!(target.elementFlags[i] & 8 /* Variadic */  && t.flags & 1179648 /* Union */ ));
                if (unionIndex >= 0) return checkCrossProductUnion(map(elementTypes, (t, i)=>target.elementFlags[i] & 8 /* Variadic */  ? t : unknownType)) ? mapType(elementTypes[unionIndex], (t)=>createNormalizedTupleType(target, replaceElement(elementTypes, unionIndex, t))) : errorType;
            }
            const expandedTypes = [];
            const expandedFlags = [];
            let expandedDeclarations = [];
            let lastRequiredIndex = -1;
            let firstRestIndex = -1;
            let lastOptionalOrRestIndex = -1;
            for(let i = 0; i < elementTypes.length; i++){
                const type = elementTypes[i];
                const flags = target.elementFlags[i];
                if (flags & 8 /* Variadic */ ) {
                    if (type.flags & 58982400 /* InstantiableNonPrimitive */  || isGenericMappedType(type)) addElement(type, 8 /* Variadic */ , (_a = target.labeledElementDeclarations) == null ? void 0 : _a[i]);
                    else if (isTupleType(type)) {
                        const elements = getElementTypes(type);
                        if (elements.length + expandedTypes.length >= 1e4) {
                            error(currentNode, isPartOfTypeNode(currentNode) ? Diagnostics.Type_produces_a_tuple_type_that_is_too_large_to_represent : Diagnostics.Expression_produces_a_tuple_type_that_is_too_large_to_represent);
                            return errorType;
                        }
                        forEach(elements, (t, n)=>{
                            var _a2;
                            return addElement(t, type.target.elementFlags[n], (_a2 = type.target.labeledElementDeclarations) == null ? void 0 : _a2[n]);
                        });
                    } else addElement(isArrayLikeType(type) && getIndexTypeOfType(type, numberType) || errorType, 4 /* Rest */ , (_b = target.labeledElementDeclarations) == null ? void 0 : _b[i]);
                } else addElement(type, flags, (_c = target.labeledElementDeclarations) == null ? void 0 : _c[i]);
            }
            for(let i = 0; i < lastRequiredIndex; i++)if (expandedFlags[i] & 2 /* Optional */ ) expandedFlags[i] = 1 /* Required */ ;
            if (firstRestIndex >= 0 && firstRestIndex < lastOptionalOrRestIndex) {
                expandedTypes[firstRestIndex] = getUnionType(sameMap(expandedTypes.slice(firstRestIndex, lastOptionalOrRestIndex + 1), (t, i)=>expandedFlags[firstRestIndex + i] & 8 /* Variadic */  ? getIndexedAccessType(t, numberType) : t));
                expandedTypes.splice(firstRestIndex + 1, lastOptionalOrRestIndex - firstRestIndex);
                expandedFlags.splice(firstRestIndex + 1, lastOptionalOrRestIndex - firstRestIndex);
                expandedDeclarations == null || expandedDeclarations.splice(firstRestIndex + 1, lastOptionalOrRestIndex - firstRestIndex);
            }
            const tupleTarget = getTupleTargetType(expandedFlags, target.readonly, expandedDeclarations);
            return tupleTarget === emptyGenericType ? emptyObjectType : expandedFlags.length ? createTypeReference(tupleTarget, expandedTypes) : tupleTarget;
            function addElement(type, flags, declaration) {
                if (flags & 1 /* Required */ ) lastRequiredIndex = expandedFlags.length;
                if (flags & 4 /* Rest */  && firstRestIndex < 0) firstRestIndex = expandedFlags.length;
                if (flags & 6 /* Rest */ ) lastOptionalOrRestIndex = expandedFlags.length;
                expandedTypes.push(flags & 2 /* Optional */  ? addOptionality(type, /*isProperty*/ true) : type);
                expandedFlags.push(flags);
                if (expandedDeclarations && declaration) expandedDeclarations.push(declaration);
                else expandedDeclarations = void 0;
            }
        }
        function sliceTupleType(type, index, endSkipCount = 0) {
            const target = type.target;
            const endIndex = getTypeReferenceArity(type) - endSkipCount;
            return index > target.fixedLength ? getRestArrayTypeOfTupleType(type) || createTupleType(emptyArray) : createTupleType(getTypeArguments(type).slice(index, endIndex), target.elementFlags.slice(index, endIndex), /*readonly*/ false, target.labeledElementDeclarations && target.labeledElementDeclarations.slice(index, endIndex));
        }
        function getKnownKeysOfTupleType(type) {
            return getUnionType(append(arrayOf(type.target.fixedLength, (i)=>getStringLiteralType("" + i)), getIndexType(type.target.readonly ? globalReadonlyArrayType : globalArrayType)));
        }
        function getStartElementCount(type, flags) {
            const index = findIndex(type.elementFlags, (f)=>!(f & flags));
            return index >= 0 ? index : type.elementFlags.length;
        }
        function getEndElementCount(type, flags) {
            return type.elementFlags.length - findLastIndex(type.elementFlags, (f)=>!(f & flags)) - 1;
        }
        function getElementTypes(type) {
            const typeArguments = getTypeArguments(type);
            const arity = getTypeReferenceArity(type);
            return typeArguments.length === arity ? typeArguments : typeArguments.slice(0, arity);
        }
        function getTypeFromOptionalTypeNode(node) {
            return addOptionality(getTypeFromTypeNode(node.type), /*isProperty*/ true);
        }
        function getTypeId(type) {
            return type.id;
        }
        function containsType(types, type) {
            return binarySearch(types, type, getTypeId, compareValues) >= 0;
        }
        function insertType(types, type) {
            const index = binarySearch(types, type, getTypeId, compareValues);
            if (index < 0) {
                types.splice(~index, 0, type);
                return true;
            }
            return false;
        }
        function addTypeToUnion(typeSet, includes, type) {
            const flags = type.flags;
            if (!(flags & 131072 /* Never */ )) {
                includes |= flags & 473694207 /* IncludesMask */ ;
                if (flags & 465829888 /* Instantiable */ ) includes |= 33554432 /* IncludesInstantiable */ ;
                if (type === wildcardType) includes |= 8388608 /* IncludesWildcard */ ;
                if (!strictNullChecks && flags & 98304 /* Nullable */ ) {
                    if (!(getObjectFlags(type) & 65536 /* ContainsWideningType */ )) includes |= 4194304 /* IncludesNonWideningType */ ;
                } else {
                    const len = typeSet.length;
                    const index = len && type.id > typeSet[len - 1].id ? ~len : binarySearch(typeSet, type, getTypeId, compareValues);
                    if (index < 0) typeSet.splice(~index, 0, type);
                }
            }
            return includes;
        }
        function addTypesToUnion(typeSet, includes, types) {
            let lastType;
            for (const type of types)if (type !== lastType) {
                includes = type.flags & 1048576 /* Union */  ? addTypesToUnion(typeSet, includes | (isNamedUnionType(type) ? 1048576 /* Union */  : 0), type.types) : addTypeToUnion(typeSet, includes, type);
                lastType = type;
            }
            return includes;
        }
        function removeSubtypes(types, hasObjectTypes) {
            var _a;
            if (types.length < 2) return types;
            const id = getTypeListId(types);
            const match = subtypeReductionCache.get(id);
            if (match) return match;
            const hasEmptyObject = hasObjectTypes && some(types, (t)=>!!(t.flags & 524288 /* Object */ ) && !isGenericMappedType(t) && isEmptyResolvedType(resolveStructuredTypeMembers(t)));
            const len = types.length;
            let i = len;
            let count = 0;
            while(i > 0){
                i--;
                const source = types[i];
                if (hasEmptyObject || source.flags & 469499904 /* StructuredOrInstantiable */ ) {
                    if (source.flags & 262144 /* TypeParameter */  && getBaseConstraintOrType(source).flags & 1048576 /* Union */ ) {
                        if (isTypeRelatedTo(source, getUnionType(map(types, (t)=>t === source ? neverType : t)), strictSubtypeRelation)) orderedRemoveItemAt(types, i);
                        continue;
                    }
                    const keyProperty = source.flags & 61603840 /* InstantiableNonPrimitive */  ? find(getPropertiesOfType(source), (p)=>isUnitType(getTypeOfSymbol(p))) : void 0;
                    const keyPropertyType = keyProperty && getRegularTypeOfLiteralType(getTypeOfSymbol(keyProperty));
                    for (const target of types)if (source !== target) {
                        if (count === 1e5) {
                            const estimatedCount = count / (len - i) * len;
                            if (estimatedCount > 1e6) {
                                (_a = tracing) == null || _a.instant(tracing.Phase.CheckTypes, "removeSubtypes_DepthLimit", {
                                    typeIds: types.map((t)=>t.id)
                                });
                                error(currentNode, Diagnostics.Expression_produces_a_union_type_that_is_too_complex_to_represent);
                                return void 0;
                            }
                        }
                        count++;
                        if (keyProperty && target.flags & 61603840 /* InstantiableNonPrimitive */ ) {
                            const t = getTypeOfPropertyOfType(target, keyProperty.escapedName);
                            if (t && isUnitType(t) && getRegularTypeOfLiteralType(t) !== keyPropertyType) continue;
                        }
                        if (isTypeRelatedTo(source, target, strictSubtypeRelation) && (!(getObjectFlags(getTargetType(source)) & 1 /* Class */ ) || !(getObjectFlags(getTargetType(target)) & 1 /* Class */ ) || isTypeDerivedFrom(source, target))) {
                            orderedRemoveItemAt(types, i);
                            break;
                        }
                    }
                }
            }
            subtypeReductionCache.set(id, types);
            return types;
        }
        function removeRedundantLiteralTypes(types, includes, reduceVoidUndefined) {
            let i = types.length;
            while(i > 0){
                i--;
                const t = types[i];
                const flags = t.flags;
                const remove = flags & 402653312 /* StringMapping */  && includes & 4 /* String */  || flags & 256 /* NumberLiteral */  && includes & 8 /* Number */  || flags & 2048 /* BigIntLiteral */  && includes & 64 /* BigInt */  || flags & 8192 /* UniqueESSymbol */  && includes & 4096 /* ESSymbol */  || reduceVoidUndefined && flags & 32768 /* Undefined */  && includes & 16384 /* Void */  || isFreshLiteralType(t) && containsType(types, t.regularType);
                if (remove) orderedRemoveItemAt(types, i);
            }
        }
        function removeStringLiteralsMatchedByTemplateLiterals(types) {
            const templates = filter(types, (t)=>!!(t.flags & 134217728 /* TemplateLiteral */ ) && isPatternLiteralType(t));
            if (templates.length) {
                let i = types.length;
                while(i > 0){
                    i--;
                    const t = types[i];
                    if (t.flags & 128 /* StringLiteral */  && some(templates, (template)=>isTypeMatchedByTemplateLiteralType(t, template))) orderedRemoveItemAt(types, i);
                }
            }
        }
        function isNamedUnionType(type) {
            return !!(type.flags & 1048576 /* Union */  && (type.aliasSymbol || type.origin));
        }
        function addNamedUnions(namedUnions, types) {
            for (const t of types)if (t.flags & 1048576 /* Union */ ) {
                const origin = t.origin;
                if (t.aliasSymbol || origin && !(origin.flags & 1048576 /* Union */ )) pushIfUnique(namedUnions, t);
                else if (origin && origin.flags & 1048576 /* Union */ ) addNamedUnions(namedUnions, origin.types);
            }
        }
        function createOriginUnionOrIntersectionType(flags, types) {
            const result = createOriginType(flags);
            result.types = types;
            return result;
        }
        function getUnionType(types, unionReduction = 1 /* Literal */ , aliasSymbol, aliasTypeArguments, origin) {
            if (types.length === 0) return neverType;
            if (types.length === 1) return types[0];
            if (types.length === 2 && !origin && (types[0].flags & 1048576 /* Union */  || types[1].flags & 1048576 /* Union */ )) {
                const infix = unionReduction === 0 /* None */  ? "N" : unionReduction === 2 /* Subtype */  ? "S" : "L";
                const index = types[0].id < types[1].id ? 0 : 1;
                const id = types[index].id + infix + types[1 - index].id + getAliasId(aliasSymbol, aliasTypeArguments);
                let type = unionOfUnionTypes.get(id);
                if (!type) {
                    type = getUnionTypeWorker(types, unionReduction, aliasSymbol, aliasTypeArguments, /*origin*/ void 0);
                    unionOfUnionTypes.set(id, type);
                }
                return type;
            }
            return getUnionTypeWorker(types, unionReduction, aliasSymbol, aliasTypeArguments, origin);
        }
        function getUnionTypeWorker(types, unionReduction, aliasSymbol, aliasTypeArguments, origin) {
            let typeSet = [];
            const includes = addTypesToUnion(typeSet, 0, types);
            if (unionReduction !== 0 /* None */ ) {
                if (includes & 3 /* AnyOrUnknown */ ) return includes & 1 /* Any */  ? includes & 8388608 /* IncludesWildcard */  ? wildcardType : anyType : includes & 65536 /* Null */  || containsType(typeSet, unknownType) ? unknownType : nonNullUnknownType;
                if (includes & 32768 /* Undefined */ ) {
                    if (typeSet.length >= 2 && typeSet[0] === undefinedType && typeSet[1] === missingType) orderedRemoveItemAt(typeSet, 1);
                }
                if (includes & 402664352 /* StringMapping */  || includes & 16384 /* Void */  && includes & 32768 /* Undefined */ ) removeRedundantLiteralTypes(typeSet, includes, !!(unionReduction & 2 /* Subtype */ ));
                if (includes & 128 /* StringLiteral */  && includes & 134217728 /* TemplateLiteral */ ) removeStringLiteralsMatchedByTemplateLiterals(typeSet);
                if (unionReduction === 2 /* Subtype */ ) {
                    typeSet = removeSubtypes(typeSet, !!(includes & 524288 /* Object */ ));
                    if (!typeSet) return errorType;
                }
                if (typeSet.length === 0) return includes & 65536 /* Null */  ? includes & 4194304 /* IncludesNonWideningType */  ? nullType : nullWideningType : includes & 32768 /* Undefined */  ? includes & 4194304 /* IncludesNonWideningType */  ? undefinedType : undefinedWideningType : neverType;
            }
            if (!origin && includes & 1048576 /* Union */ ) {
                const namedUnions = [];
                addNamedUnions(namedUnions, types);
                const reducedTypes = [];
                for (const t of typeSet)if (!some(namedUnions, (union)=>containsType(union.types, t))) reducedTypes.push(t);
                if (!aliasSymbol && namedUnions.length === 1 && reducedTypes.length === 0) return namedUnions[0];
                const namedTypesCount = reduceLeft(namedUnions, (sum, union)=>sum + union.types.length, 0);
                if (namedTypesCount + reducedTypes.length === typeSet.length) {
                    for (const t of namedUnions)insertType(reducedTypes, t);
                    origin = createOriginUnionOrIntersectionType(1048576 /* Union */ , reducedTypes);
                }
            }
            const objectFlags = (includes & 36323331 /* NotPrimitiveUnion */  ? 0 : 32768 /* PrimitiveUnion */ ) | (includes & 2097152 /* Intersection */  ? 16777216 /* ContainsIntersections */  : 0);
            return getUnionTypeFromSortedList(typeSet, objectFlags, aliasSymbol, aliasTypeArguments, origin);
        }
        function getUnionOrIntersectionTypePredicate(signatures, kind) {
            let last2;
            const types = [];
            for (const sig of signatures){
                const pred = getTypePredicateOfSignature(sig);
                if (pred) {
                    if (pred.kind !== 0 /* This */  && pred.kind !== 1 /* Identifier */  || last2 && !typePredicateKindsMatch(last2, pred)) return void 0;
                    last2 = pred;
                    types.push(pred.type);
                } else {
                    const returnType = kind !== 2097152 /* Intersection */  ? getReturnTypeOfSignature(sig) : void 0;
                    if (returnType !== falseType && returnType !== regularFalseType) return void 0;
                }
            }
            if (!last2) return void 0;
            const compositeType = getUnionOrIntersectionType(types, kind);
            return createTypePredicate(last2.kind, last2.parameterName, last2.parameterIndex, compositeType);
        }
        function typePredicateKindsMatch(a, b) {
            return a.kind === b.kind && a.parameterIndex === b.parameterIndex;
        }
        function getUnionTypeFromSortedList(types, precomputedObjectFlags, aliasSymbol, aliasTypeArguments, origin) {
            if (types.length === 0) return neverType;
            if (types.length === 1) return types[0];
            const typeKey = !origin ? getTypeListId(types) : origin.flags & 1048576 /* Union */  ? `|${getTypeListId(origin.types)}` : origin.flags & 2097152 /* Intersection */  ? `&${getTypeListId(origin.types)}` : `#${origin.type.id}|${getTypeListId(types)}`;
            const id = typeKey + getAliasId(aliasSymbol, aliasTypeArguments);
            let type = unionTypes.get(id);
            if (!type) {
                type = createType(1048576 /* Union */ );
                type.objectFlags = precomputedObjectFlags | getPropagatingFlagsOfTypes(types, /*excludeKinds*/ 98304 /* Nullable */ );
                type.types = types;
                type.origin = origin;
                type.aliasSymbol = aliasSymbol;
                type.aliasTypeArguments = aliasTypeArguments;
                if (types.length === 2 && types[0].flags & 512 /* BooleanLiteral */  && types[1].flags & 512 /* BooleanLiteral */ ) {
                    type.flags |= 16 /* Boolean */ ;
                    type.intrinsicName = "boolean";
                }
                unionTypes.set(id, type);
            }
            return type;
        }
        function getTypeFromUnionTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const aliasSymbol = getAliasSymbolForTypeNode(node);
                links.resolvedType = getUnionType(map(node.types, getTypeFromTypeNode), 1 /* Literal */ , aliasSymbol, getTypeArgumentsForAliasSymbol(aliasSymbol));
            }
            return links.resolvedType;
        }
        function addTypeToIntersection(typeSet, includes, type) {
            const flags = type.flags;
            if (flags & 2097152 /* Intersection */ ) return addTypesToIntersection(typeSet, includes, type.types);
            if (isEmptyAnonymousObjectType(type)) {
                if (!(includes & 16777216 /* IncludesEmptyObject */ )) {
                    includes |= 16777216 /* IncludesEmptyObject */ ;
                    typeSet.set(type.id.toString(), type);
                }
            } else {
                if (flags & 3 /* AnyOrUnknown */ ) {
                    if (type === wildcardType) includes |= 8388608 /* IncludesWildcard */ ;
                } else if (strictNullChecks || !(flags & 98304 /* Nullable */ )) {
                    if (type === missingType) {
                        includes |= 262144 /* IncludesMissingType */ ;
                        type = undefinedType;
                    }
                    if (!typeSet.has(type.id.toString())) {
                        if (type.flags & 109472 /* Unit */  && includes & 109472 /* Unit */ ) includes |= 67108864 /* NonPrimitive */ ;
                        typeSet.set(type.id.toString(), type);
                    }
                }
                includes |= flags & 473694207 /* IncludesMask */ ;
            }
            return includes;
        }
        function addTypesToIntersection(typeSet, includes, types) {
            for (const type of types)includes = addTypeToIntersection(typeSet, includes, getRegularTypeOfLiteralType(type));
            return includes;
        }
        function removeRedundantSupertypes(types, includes) {
            let i = types.length;
            while(i > 0){
                i--;
                const t = types[i];
                const remove = t.flags & 4 /* String */  && includes & 402653312 /* StringMapping */  || t.flags & 8 /* Number */  && includes & 256 /* NumberLiteral */  || t.flags & 64 /* BigInt */  && includes & 2048 /* BigIntLiteral */  || t.flags & 4096 /* ESSymbol */  && includes & 8192 /* UniqueESSymbol */  || t.flags & 16384 /* Void */  && includes & 32768 /* Undefined */  || isEmptyAnonymousObjectType(t) && includes & 470302716 /* DefinitelyNonNullable */ ;
                if (remove) orderedRemoveItemAt(types, i);
            }
        }
        function eachUnionContains(unionTypes2, type) {
            for (const u of unionTypes2)if (!containsType(u.types, type)) {
                const primitive = type.flags & 128 /* StringLiteral */  ? stringType : type.flags & 288 /* NumberLiteral */  ? numberType : type.flags & 2048 /* BigIntLiteral */  ? bigintType : type.flags & 8192 /* UniqueESSymbol */  ? esSymbolType : void 0;
                if (!primitive || !containsType(u.types, primitive)) return false;
            }
            return true;
        }
        function extractRedundantTemplateLiterals(types) {
            let i = types.length;
            const literals = filter(types, (t)=>!!(t.flags & 128 /* StringLiteral */ ));
            while(i > 0){
                i--;
                const t = types[i];
                if (!(t.flags & 134217728 /* TemplateLiteral */ )) continue;
                for (const t2 of literals){
                    if (isTypeSubtypeOf(t2, t)) {
                        orderedRemoveItemAt(types, i);
                        break;
                    } else if (isPatternLiteralType(t)) return true;
                }
            }
            return false;
        }
        function removeFromEach(types, flag) {
            for(let i = 0; i < types.length; i++)types[i] = filterType(types[i], (t)=>!(t.flags & flag));
        }
        function intersectUnionsOfPrimitiveTypes(types) {
            let unionTypes2;
            const index = findIndex(types, (t)=>!!(getObjectFlags(t) & 32768 /* PrimitiveUnion */ ));
            if (index < 0) return false;
            let i = index + 1;
            while(i < types.length){
                const t = types[i];
                if (getObjectFlags(t) & 32768 /* PrimitiveUnion */ ) {
                    (unionTypes2 || (unionTypes2 = [
                        types[index]
                    ])).push(t);
                    orderedRemoveItemAt(types, i);
                } else i++;
            }
            if (!unionTypes2) return false;
            const checked = [];
            const result = [];
            for (const u of unionTypes2)for (const t of u.types){
                if (insertType(checked, t)) {
                    if (eachUnionContains(unionTypes2, t)) insertType(result, t);
                }
            }
            types[index] = getUnionTypeFromSortedList(result, 32768 /* PrimitiveUnion */ );
            return true;
        }
        function createIntersectionType(types, aliasSymbol, aliasTypeArguments) {
            const result = createType(2097152 /* Intersection */ );
            result.objectFlags = getPropagatingFlagsOfTypes(types, /*excludeKinds*/ 98304 /* Nullable */ );
            result.types = types;
            result.aliasSymbol = aliasSymbol;
            result.aliasTypeArguments = aliasTypeArguments;
            return result;
        }
        function getIntersectionType(types, aliasSymbol, aliasTypeArguments, noSupertypeReduction) {
            const typeMembershipMap = /* @__PURE__ */ new Map();
            const includes = addTypesToIntersection(typeMembershipMap, 0, types);
            const typeSet = arrayFrom(typeMembershipMap.values());
            if (includes & 131072 /* Never */ ) return contains(typeSet, silentNeverType) ? silentNeverType : neverType;
            if (strictNullChecks && includes & 98304 /* Nullable */  && includes & 84410368 /* IncludesEmptyObject */  || includes & 67108864 /* NonPrimitive */  && includes & 402783228 /* NonPrimitive */  || includes & 402653316 /* StringLike */  && includes & 67238776 /* StringLike */  || includes & 296 /* NumberLike */  && includes & 469891796 /* NumberLike */  || includes & 2112 /* BigIntLike */  && includes & 469889980 /* BigIntLike */  || includes & 12288 /* ESSymbolLike */  && includes & 469879804 /* ESSymbolLike */  || includes & 49152 /* VoidLike */  && includes & 469842940 /* VoidLike */ ) return neverType;
            if (includes & 134217728 /* TemplateLiteral */  && includes & 128 /* StringLiteral */  && extractRedundantTemplateLiterals(typeSet)) return neverType;
            if (includes & 1 /* Any */ ) return includes & 8388608 /* IncludesWildcard */  ? wildcardType : anyType;
            if (!strictNullChecks && includes & 98304 /* Nullable */ ) return includes & 16777216 /* IncludesEmptyObject */  ? neverType : includes & 32768 /* Undefined */  ? undefinedType : nullType;
            if (includes & 4 /* String */  && includes & 402653312 /* StringMapping */  || includes & 8 /* Number */  && includes & 256 /* NumberLiteral */  || includes & 64 /* BigInt */  && includes & 2048 /* BigIntLiteral */  || includes & 4096 /* ESSymbol */  && includes & 8192 /* UniqueESSymbol */  || includes & 16384 /* Void */  && includes & 32768 /* Undefined */  || includes & 16777216 /* IncludesEmptyObject */  && includes & 470302716 /* DefinitelyNonNullable */ ) {
                if (!noSupertypeReduction) removeRedundantSupertypes(typeSet, includes);
            }
            if (includes & 262144 /* IncludesMissingType */ ) typeSet[typeSet.indexOf(undefinedType)] = missingType;
            if (typeSet.length === 0) return unknownType;
            if (typeSet.length === 1) return typeSet[0];
            const id = getTypeListId(typeSet) + getAliasId(aliasSymbol, aliasTypeArguments);
            let result = intersectionTypes.get(id);
            if (!result) {
                if (includes & 1048576 /* Union */ ) {
                    if (intersectUnionsOfPrimitiveTypes(typeSet)) result = getIntersectionType(typeSet, aliasSymbol, aliasTypeArguments);
                    else if (every(typeSet, (t)=>!!(t.flags & 1048576 /* Union */  && t.types[0].flags & 32768 /* Undefined */ ))) {
                        const containedUndefinedType = some(typeSet, containsMissingType) ? missingType : undefinedType;
                        removeFromEach(typeSet, 32768 /* Undefined */ );
                        result = getUnionType([
                            getIntersectionType(typeSet),
                            containedUndefinedType
                        ], 1 /* Literal */ , aliasSymbol, aliasTypeArguments);
                    } else if (every(typeSet, (t)=>!!(t.flags & 1048576 /* Union */  && (t.types[0].flags & 65536 /* Null */  || t.types[1].flags & 65536 /* Null */ )))) {
                        removeFromEach(typeSet, 65536 /* Null */ );
                        result = getUnionType([
                            getIntersectionType(typeSet),
                            nullType
                        ], 1 /* Literal */ , aliasSymbol, aliasTypeArguments);
                    } else {
                        if (!checkCrossProductUnion(typeSet)) return errorType;
                        const constituents = getCrossProductIntersections(typeSet);
                        const origin = some(constituents, (t)=>!!(t.flags & 2097152 /* Intersection */ )) && getConstituentCountOfTypes(constituents) > getConstituentCountOfTypes(typeSet) ? createOriginUnionOrIntersectionType(2097152 /* Intersection */ , typeSet) : void 0;
                        result = getUnionType(constituents, 1 /* Literal */ , aliasSymbol, aliasTypeArguments, origin);
                    }
                } else result = createIntersectionType(typeSet, aliasSymbol, aliasTypeArguments);
                intersectionTypes.set(id, result);
            }
            return result;
        }
        function getCrossProductUnionSize(types) {
            return reduceLeft(types, (n, t)=>t.flags & 1048576 /* Union */  ? n * t.types.length : t.flags & 131072 /* Never */  ? 0 : n, 1);
        }
        function checkCrossProductUnion(types) {
            var _a;
            const size = getCrossProductUnionSize(types);
            if (size >= 1e5) {
                (_a = tracing) == null || _a.instant(tracing.Phase.CheckTypes, "checkCrossProductUnion_DepthLimit", {
                    typeIds: types.map((t)=>t.id),
                    size: size
                });
                error(currentNode, Diagnostics.Expression_produces_a_union_type_that_is_too_complex_to_represent);
                return false;
            }
            return true;
        }
        function getCrossProductIntersections(types) {
            const count = getCrossProductUnionSize(types);
            const intersections = [];
            for(let i = 0; i < count; i++){
                const constituents = types.slice();
                let n = i;
                for(let j = types.length - 1; j >= 0; j--)if (types[j].flags & 1048576 /* Union */ ) {
                    const sourceTypes = types[j].types;
                    const length2 = sourceTypes.length;
                    constituents[j] = sourceTypes[n % length2];
                    n = Math.floor(n / length2);
                }
                const t = getIntersectionType(constituents);
                if (!(t.flags & 131072 /* Never */ )) intersections.push(t);
            }
            return intersections;
        }
        function getConstituentCount(type) {
            return !(type.flags & 3145728 /* UnionOrIntersection */ ) || type.aliasSymbol ? 1 : type.flags & 1048576 /* Union */  && type.origin ? getConstituentCount(type.origin) : getConstituentCountOfTypes(type.types);
        }
        function getConstituentCountOfTypes(types) {
            return reduceLeft(types, (n, t)=>n + getConstituentCount(t), 0);
        }
        function areIntersectedTypesAvoidingPrimitiveReduction(t1, t2) {
            return !!(t1.flags & 76 /* BigInt */ ) && t2 === emptyTypeLiteralType;
        }
        function getTypeFromIntersectionTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const aliasSymbol = getAliasSymbolForTypeNode(node);
                const types = map(node.types, getTypeFromTypeNode);
                const noSupertypeReduction = types.length === 2 && (areIntersectedTypesAvoidingPrimitiveReduction(types[0], types[1]) || areIntersectedTypesAvoidingPrimitiveReduction(types[1], types[0]));
                links.resolvedType = getIntersectionType(types, aliasSymbol, getTypeArgumentsForAliasSymbol(aliasSymbol), noSupertypeReduction);
            }
            return links.resolvedType;
        }
        function createIndexType(type, indexFlags) {
            const result = createType(4194304 /* Index */ );
            result.type = type;
            result.indexFlags = indexFlags;
            return result;
        }
        function createOriginIndexType(type) {
            const result = createOriginType(4194304 /* Index */ );
            result.type = type;
            return result;
        }
        function getIndexTypeForGenericType(type, indexFlags) {
            return indexFlags & 1 /* StringsOnly */  ? type.resolvedStringIndexType || (type.resolvedStringIndexType = createIndexType(type, 1 /* StringsOnly */ )) : type.resolvedIndexType || (type.resolvedIndexType = createIndexType(type, 0 /* None */ ));
        }
        function getIndexTypeForMappedType(type, indexFlags) {
            const typeParameter = getTypeParameterFromMappedType(type);
            const constraintType = getConstraintTypeFromMappedType(type);
            const nameType = getNameTypeFromMappedType(type.target || type);
            if (!nameType && !(indexFlags & 2 /* NoIndexSignatures */ )) return constraintType;
            const keyTypes = [];
            if (isMappedTypeWithKeyofConstraintDeclaration(type)) {
                if (!isGenericIndexType(constraintType)) {
                    const modifiersType = getApparentType(getModifiersTypeFromMappedType(type));
                    forEachMappedTypePropertyKeyTypeAndIndexSignatureKeyType(modifiersType, 8576 /* StringOrNumberLiteralOrUnique */ , !!(indexFlags & 1 /* StringsOnly */ ), addMemberForKeyType);
                } else return getIndexTypeForGenericType(type, indexFlags);
            } else forEachType(getLowerBoundOfKeyType(constraintType), addMemberForKeyType);
            if (isGenericIndexType(constraintType)) forEachType(constraintType, addMemberForKeyType);
            const result = indexFlags & 2 /* NoIndexSignatures */  ? filterType(getUnionType(keyTypes), (t)=>!(t.flags & 5 /* String */ )) : getUnionType(keyTypes);
            if (result.flags & 1048576 /* Union */  && constraintType.flags & 1048576 /* Union */  && getTypeListId(result.types) === getTypeListId(constraintType.types)) return constraintType;
            return result;
            function addMemberForKeyType(keyType) {
                const propNameType = nameType ? instantiateType(nameType, appendTypeMapping(type.mapper, typeParameter, keyType)) : keyType;
                keyTypes.push(propNameType === stringType ? stringOrNumberType : propNameType);
            }
        }
        function hasDistributiveNameType(mappedType) {
            const typeVariable = getTypeParameterFromMappedType(mappedType);
            return isDistributive(getNameTypeFromMappedType(mappedType) || typeVariable);
            function isDistributive(type) {
                return type.flags & 470810623 /* NonPrimitive */  ? true : type.flags & 16777216 /* Conditional */  ? type.root.isDistributive && type.checkType === typeVariable : type.flags & 137363456 /* TemplateLiteral */  ? every(type.types, isDistributive) : type.flags & 8388608 /* IndexedAccess */  ? isDistributive(type.objectType) && isDistributive(type.indexType) : type.flags & 33554432 /* Substitution */  ? isDistributive(type.baseType) && isDistributive(type.constraint) : type.flags & 268435456 /* StringMapping */  ? isDistributive(type.type) : false;
            }
        }
        function getLiteralTypeFromPropertyName(name) {
            if (isPrivateIdentifier(name)) return neverType;
            if (isNumericLiteral(name)) return getRegularTypeOfLiteralType(checkExpression(name));
            if (isComputedPropertyName(name)) return getRegularTypeOfLiteralType(checkComputedPropertyName(name));
            const propertyName = getPropertyNameForPropertyNameNode(name);
            if (propertyName !== void 0) return getStringLiteralType(unescapeLeadingUnderscores(propertyName));
            if (isExpression(name)) return getRegularTypeOfLiteralType(checkExpression(name));
            return neverType;
        }
        function getLiteralTypeFromProperty(prop, include, includeNonPublic) {
            if (includeNonPublic || !(getDeclarationModifierFlagsFromSymbol(prop) & 24 /* NonPublicAccessibilityModifier */ )) {
                let type = getSymbolLinks(getLateBoundSymbol(prop)).nameType;
                if (!type) {
                    const name = getNameOfDeclaration(prop.valueDeclaration);
                    type = prop.escapedName === "default" /* Default */  ? getStringLiteralType("default") : name && getLiteralTypeFromPropertyName(name) || (!isKnownSymbol(prop) ? getStringLiteralType(symbolName(prop)) : void 0);
                }
                if (type && type.flags & include) return type;
            }
            return neverType;
        }
        function isKeyTypeIncluded(keyType, include) {
            return !!(keyType.flags & include || keyType.flags & 2097152 /* Intersection */  && some(keyType.types, (t)=>isKeyTypeIncluded(t, include)));
        }
        function getLiteralTypeFromProperties(type, include, includeOrigin) {
            const origin = includeOrigin && (getObjectFlags(type) & 7 /* Reference */  || type.aliasSymbol) ? createOriginIndexType(type) : void 0;
            const propertyTypes = map(getPropertiesOfType(type), (prop)=>getLiteralTypeFromProperty(prop, include));
            const indexKeyTypes = map(getIndexInfosOfType(type), (info)=>info !== enumNumberIndexInfo && isKeyTypeIncluded(info.keyType, include) ? info.keyType === stringType && include & 8 /* Number */  ? stringOrNumberType : info.keyType : neverType);
            return getUnionType(concatenate(propertyTypes, indexKeyTypes), 1 /* Literal */ , /*aliasSymbol*/ void 0, /*aliasTypeArguments*/ void 0, origin);
        }
        function shouldDeferIndexType(type, indexFlags = 0 /* None */ ) {
            return !!(type.flags & 58982400 /* InstantiableNonPrimitive */  || isGenericTupleType(type) || isGenericMappedType(type) && !hasDistributiveNameType(type) || type.flags & 1048576 /* Union */  && !(indexFlags & 4 /* NoReducibleCheck */ ) && isGenericReducibleType(type) || type.flags & 2097152 /* Intersection */  && maybeTypeOfKind(type, 465829888 /* Instantiable */ ) && some(type.types, isEmptyAnonymousObjectType));
        }
        function getIndexType(type, indexFlags = defaultIndexFlags) {
            type = getReducedType(type);
            return shouldDeferIndexType(type, indexFlags) ? getIndexTypeForGenericType(type, indexFlags) : type.flags & 1048576 /* Union */  ? getIntersectionType(map(type.types, (t)=>getIndexType(t, indexFlags))) : type.flags & 2097152 /* Intersection */  ? getUnionType(map(type.types, (t)=>getIndexType(t, indexFlags))) : getObjectFlags(type) & 32 /* Mapped */  ? getIndexTypeForMappedType(type, indexFlags) : type === wildcardType ? wildcardType : type.flags & 2 /* Unknown */  ? neverType : type.flags & 131073 /* Never */  ? keyofConstraintType : getLiteralTypeFromProperties(type, (indexFlags & 2 /* NoIndexSignatures */  ? 128 /* StringLiteral */  : 402653316 /* StringLike */ ) | (indexFlags & 1 /* StringsOnly */  ? 0 : 12584 /* ESSymbolLike */ ), indexFlags === defaultIndexFlags);
        }
        function getExtractStringType(type) {
            if (keyofStringsOnly) return type;
            const extractTypeAlias = getGlobalExtractSymbol();
            return extractTypeAlias ? getTypeAliasInstantiation(extractTypeAlias, [
                type,
                stringType
            ]) : stringType;
        }
        function getIndexTypeOrString(type) {
            const indexType = getExtractStringType(getIndexType(type));
            return indexType.flags & 131072 /* Never */  ? stringType : indexType;
        }
        function getTypeFromTypeOperatorNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) switch(node.operator){
                case 143 /* KeyOfKeyword */ :
                    links.resolvedType = getIndexType(getTypeFromTypeNode(node.type));
                    break;
                case 158 /* UniqueKeyword */ :
                    links.resolvedType = node.type.kind === 155 /* SymbolKeyword */  ? getESSymbolLikeTypeForNode(walkUpParenthesizedTypes(node.parent)) : errorType;
                    break;
                case 148 /* ReadonlyKeyword */ :
                    links.resolvedType = getTypeFromTypeNode(node.type);
                    break;
                default:
                    Debug.assertNever(node.operator);
            }
            return links.resolvedType;
        }
        function getTypeFromTemplateTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) links.resolvedType = getTemplateLiteralType([
                node.head.text,
                ...map(node.templateSpans, (span)=>span.literal.text)
            ], map(node.templateSpans, (span)=>getTypeFromTypeNode(span.type)));
            return links.resolvedType;
        }
        function getTemplateLiteralType(texts, types) {
            const unionIndex = findIndex(types, (t)=>!!(t.flags & 1179648 /* Union */ ));
            if (unionIndex >= 0) return checkCrossProductUnion(types) ? mapType(types[unionIndex], (t)=>getTemplateLiteralType(texts, replaceElement(types, unionIndex, t))) : errorType;
            if (contains(types, wildcardType)) return wildcardType;
            const newTypes = [];
            const newTexts = [];
            let text = texts[0];
            if (!addSpans(texts, types)) return stringType;
            if (newTypes.length === 0) return getStringLiteralType(text);
            newTexts.push(text);
            if (every(newTexts, (t)=>t === "")) {
                if (every(newTypes, (t)=>!!(t.flags & 4 /* String */ ))) return stringType;
                if (newTypes.length === 1 && isPatternLiteralType(newTypes[0])) return newTypes[0];
            }
            const id = `${getTypeListId(newTypes)}|${map(newTexts, (t)=>t.length).join(",")}|${newTexts.join("")}`;
            let type = templateLiteralTypes.get(id);
            if (!type) templateLiteralTypes.set(id, type = createTemplateLiteralType(newTexts, newTypes));
            return type;
            function addSpans(texts2, types2) {
                for(let i = 0; i < types2.length; i++){
                    const t = types2[i];
                    if (t.flags & 101248 /* Undefined */ ) {
                        text += getTemplateStringForType(t) || "";
                        text += texts2[i + 1];
                    } else if (t.flags & 134217728 /* TemplateLiteral */ ) {
                        text += t.texts[0];
                        if (!addSpans(t.texts, t.types)) return false;
                        text += texts2[i + 1];
                    } else if (isGenericIndexType(t) || isPatternLiteralPlaceholderType(t)) {
                        newTypes.push(t);
                        newTexts.push(text);
                        text = texts2[i + 1];
                    } else return false;
                }
                return true;
            }
        }
        function getTemplateStringForType(type) {
            return type.flags & 128 /* StringLiteral */  ? type.value : type.flags & 256 /* NumberLiteral */  ? "" + type.value : type.flags & 2048 /* BigIntLiteral */  ? pseudoBigIntToString(type.value) : type.flags & 98816 /* Nullable */  ? type.intrinsicName : void 0;
        }
        function createTemplateLiteralType(texts, types) {
            const type = createType(134217728 /* TemplateLiteral */ );
            type.objectFlags = getPropagatingFlagsOfTypes(types, /*excludeKinds*/ 98304 /* Nullable */ );
            type.texts = texts;
            type.types = types;
            return type;
        }
        function getStringMappingType(symbol, type) {
            return type.flags & 1179648 /* Never */  ? mapType(type, (t)=>getStringMappingType(symbol, t)) : type.flags & 128 /* StringLiteral */  ? getStringLiteralType(applyStringMapping(symbol, type.value)) : type.flags & 134217728 /* TemplateLiteral */  ? getTemplateLiteralType(...applyTemplateStringMapping(symbol, type.texts, type.types)) : // Mapping<Mapping<T>> === Mapping<T>
            type.flags & 268435456 /* StringMapping */  && symbol === type.symbol ? type : type.flags & 268435461 /* StringMapping */  || isGenericIndexType(type) ? getStringMappingTypeForGenericType(symbol, type) : // This handles Mapping<`${number}`> and Mapping<`${bigint}`>
            isPatternLiteralPlaceholderType(type) ? getStringMappingTypeForGenericType(symbol, getTemplateLiteralType([
                "",
                ""
            ], [
                type
            ])) : type;
        }
        function applyStringMapping(symbol, str) {
            switch(intrinsicTypeKinds.get(symbol.escapedName)){
                case 0 /* Uppercase */ :
                    return str.toUpperCase();
                case 1 /* Lowercase */ :
                    return str.toLowerCase();
                case 2 /* Capitalize */ :
                    return str.charAt(0).toUpperCase() + str.slice(1);
                case 3 /* Uncapitalize */ :
                    return str.charAt(0).toLowerCase() + str.slice(1);
            }
            return str;
        }
        function applyTemplateStringMapping(symbol, texts, types) {
            switch(intrinsicTypeKinds.get(symbol.escapedName)){
                case 0 /* Uppercase */ :
                    return [
                        texts.map((t)=>t.toUpperCase()),
                        types.map((t)=>getStringMappingType(symbol, t))
                    ];
                case 1 /* Lowercase */ :
                    return [
                        texts.map((t)=>t.toLowerCase()),
                        types.map((t)=>getStringMappingType(symbol, t))
                    ];
                case 2 /* Capitalize */ :
                    return [
                        texts[0] === "" ? texts : [
                            texts[0].charAt(0).toUpperCase() + texts[0].slice(1),
                            ...texts.slice(1)
                        ],
                        texts[0] === "" ? [
                            getStringMappingType(symbol, types[0]),
                            ...types.slice(1)
                        ] : types
                    ];
                case 3 /* Uncapitalize */ :
                    return [
                        texts[0] === "" ? texts : [
                            texts[0].charAt(0).toLowerCase() + texts[0].slice(1),
                            ...texts.slice(1)
                        ],
                        texts[0] === "" ? [
                            getStringMappingType(symbol, types[0]),
                            ...types.slice(1)
                        ] : types
                    ];
            }
            return [
                texts,
                types
            ];
        }
        function getStringMappingTypeForGenericType(symbol, type) {
            const id = `${getSymbolId(symbol)},${getTypeId(type)}`;
            let result = stringMappingTypes.get(id);
            if (!result) stringMappingTypes.set(id, result = createStringMappingType(symbol, type));
            return result;
        }
        function createStringMappingType(symbol, type) {
            const result = createTypeWithSymbol(268435456 /* StringMapping */ , symbol);
            result.type = type;
            return result;
        }
        function createIndexedAccessType(objectType, indexType, accessFlags, aliasSymbol, aliasTypeArguments) {
            const type = createType(8388608 /* IndexedAccess */ );
            type.objectType = objectType;
            type.indexType = indexType;
            type.accessFlags = accessFlags;
            type.aliasSymbol = aliasSymbol;
            type.aliasTypeArguments = aliasTypeArguments;
            return type;
        }
        function isJSLiteralType(type) {
            if (noImplicitAny) return false;
            if (getObjectFlags(type) & 4096 /* JSLiteral */ ) return true;
            if (type.flags & 1048576 /* Union */ ) return every(type.types, isJSLiteralType);
            if (type.flags & 2097152 /* Intersection */ ) return some(type.types, isJSLiteralType);
            if (type.flags & 465829888 /* Instantiable */ ) {
                const constraint = getResolvedBaseConstraint(type);
                return constraint !== type && isJSLiteralType(constraint);
            }
            return false;
        }
        function getPropertyNameFromIndex(indexType, accessNode) {
            return isTypeUsableAsPropertyName(indexType) ? getPropertyNameFromType(indexType) : accessNode && isPropertyName(accessNode) ? // late bound names are handled in the first branch, so here we only need to handle normal names
            getPropertyNameForPropertyNameNode(accessNode) : void 0;
        }
        function isUncalledFunctionReference(node, symbol) {
            if (symbol.flags & 8208 /* Method */ ) {
                const parent2 = findAncestor(node.parent, (n)=>!isAccessExpression(n)) || node.parent;
                if (isCallLikeExpression(parent2)) return isCallOrNewExpression(parent2) && isIdentifier(node) && hasMatchingArgument(parent2, node);
                return every(symbol.declarations, (d)=>!isFunctionLike(d) || !!(getCombinedNodeFlags(d) & 268435456 /* Deprecated */ ));
            }
            return true;
        }
        function getPropertyTypeForIndexType(originalObjectType, objectType, indexType, fullIndexType, accessNode, accessFlags) {
            const accessExpression = accessNode && accessNode.kind === 211 /* ElementAccessExpression */  ? accessNode : void 0;
            const propName = accessNode && isPrivateIdentifier(accessNode) ? void 0 : getPropertyNameFromIndex(indexType, accessNode);
            if (propName !== void 0) {
                if (accessFlags & 256 /* Contextual */ ) return getTypeOfPropertyOfContextualType(objectType, propName) || anyType;
                const prop = getPropertyOfType(objectType, propName);
                if (prop) {
                    if (accessFlags & 64 /* ReportDeprecated */  && accessNode && prop.declarations && isDeprecatedSymbol(prop) && isUncalledFunctionReference(accessNode, prop)) {
                        const deprecatedNode = (accessExpression == null ? void 0 : accessExpression.argumentExpression) ?? (isIndexedAccessTypeNode(accessNode) ? accessNode.indexType : accessNode);
                        addDeprecatedSuggestion(deprecatedNode, prop.declarations, propName);
                    }
                    if (accessExpression) {
                        markPropertyAsReferenced(prop, accessExpression, isSelfTypeAccess(accessExpression.expression, objectType.symbol));
                        if (isAssignmentToReadonlyEntity(accessExpression, prop, getAssignmentTargetKind(accessExpression))) {
                            error(accessExpression.argumentExpression, Diagnostics.Cannot_assign_to_0_because_it_is_a_read_only_property, symbolToString(prop));
                            return void 0;
                        }
                        if (accessFlags & 8 /* CacheSymbol */ ) getNodeLinks(accessNode).resolvedSymbol = prop;
                        if (isThisPropertyAccessInConstructor(accessExpression, prop)) return autoType;
                    }
                    const propType = getTypeOfSymbol(prop);
                    return accessExpression && getAssignmentTargetKind(accessExpression) !== 1 /* Definite */  ? getFlowTypeOfReference(accessExpression, propType) : accessNode && isIndexedAccessTypeNode(accessNode) && containsMissingType(propType) ? getUnionType([
                        propType,
                        undefinedType
                    ]) : propType;
                }
                if (everyType(objectType, isTupleType) && isNumericLiteralName(propName)) {
                    const index = +propName;
                    if (accessNode && everyType(objectType, (t)=>!t.target.hasRestElement) && !(accessFlags & 16 /* NoTupleBoundsCheck */ )) {
                        const indexNode = getIndexNodeForAccessExpression(accessNode);
                        if (isTupleType(objectType)) {
                            if (index < 0) {
                                error(indexNode, Diagnostics.A_tuple_type_cannot_be_indexed_with_a_negative_value);
                                return undefinedType;
                            }
                            error(indexNode, Diagnostics.Tuple_type_0_of_length_1_has_no_element_at_index_2, typeToString(objectType), getTypeReferenceArity(objectType), unescapeLeadingUnderscores(propName));
                        } else error(indexNode, Diagnostics.Property_0_does_not_exist_on_type_1, unescapeLeadingUnderscores(propName), typeToString(objectType));
                    }
                    if (index >= 0) {
                        errorIfWritingToReadonlyIndex(getIndexInfoOfType(objectType, numberType));
                        return mapType(objectType, (t)=>{
                            const restType = getRestTypeOfTupleType(t) || undefinedType;
                            return accessFlags & 1 /* IncludeUndefined */  ? getUnionType([
                                restType,
                                missingType
                            ]) : restType;
                        });
                    }
                }
            }
            if (!(indexType.flags & 98304 /* Nullable */ ) && isTypeAssignableToKind(indexType, 402665900 /* ESSymbolLike */ )) {
                if (objectType.flags & 131073 /* Never */ ) return objectType;
                const indexInfo = getApplicableIndexInfo(objectType, indexType) || getIndexInfoOfType(objectType, stringType);
                if (indexInfo) {
                    if (accessFlags & 2 /* NoIndexSignatures */  && indexInfo.keyType !== numberType) {
                        if (accessExpression) error(accessExpression, Diagnostics.Type_0_cannot_be_used_to_index_type_1, typeToString(indexType), typeToString(originalObjectType));
                        return void 0;
                    }
                    if (accessNode && indexInfo.keyType === stringType && !isTypeAssignableToKind(indexType, 12 /* Number */ )) {
                        const indexNode = getIndexNodeForAccessExpression(accessNode);
                        error(indexNode, Diagnostics.Type_0_cannot_be_used_as_an_index_type, typeToString(indexType));
                        return accessFlags & 1 /* IncludeUndefined */  ? getUnionType([
                            indexInfo.type,
                            missingType
                        ]) : indexInfo.type;
                    }
                    errorIfWritingToReadonlyIndex(indexInfo);
                    if (accessFlags & 1 /* IncludeUndefined */  && !(objectType.symbol && objectType.symbol.flags & 384 /* ConstEnum */  && indexType.symbol && indexType.flags & 1024 /* EnumLiteral */  && getParentOfSymbol(indexType.symbol) === objectType.symbol)) return getUnionType([
                        indexInfo.type,
                        missingType
                    ]);
                    return indexInfo.type;
                }
                if (indexType.flags & 131072 /* Never */ ) return neverType;
                if (isJSLiteralType(objectType)) return anyType;
                if (accessExpression && !isConstEnumObjectType(objectType)) {
                    if (isObjectLiteralType2(objectType)) {
                        if (noImplicitAny && indexType.flags & 384 /* NumberLiteral */ ) {
                            diagnostics.add(createDiagnosticForNode(accessExpression, Diagnostics.Property_0_does_not_exist_on_type_1, indexType.value, typeToString(objectType)));
                            return undefinedType;
                        } else if (indexType.flags & 12 /* String */ ) {
                            const types = map(objectType.properties, (property)=>{
                                return getTypeOfSymbol(property);
                            });
                            return getUnionType(append(types, undefinedType));
                        }
                    }
                    if (objectType.symbol === globalThisSymbol && propName !== void 0 && globalThisSymbol.exports.has(propName) && globalThisSymbol.exports.get(propName).flags & 418 /* BlockScoped */ ) error(accessExpression, Diagnostics.Property_0_does_not_exist_on_type_1, unescapeLeadingUnderscores(propName), typeToString(objectType));
                    else if (noImplicitAny && !compilerOptions.suppressImplicitAnyIndexErrors && !(accessFlags & 128 /* SuppressNoImplicitAnyError */ )) {
                        if (propName !== void 0 && typeHasStaticProperty(propName, objectType)) {
                            const typeName = typeToString(objectType);
                            error(accessExpression, Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_to_access_the_static_member_2_instead, propName, typeName, typeName + "[" + getTextOfNode(accessExpression.argumentExpression) + "]");
                        } else if (getIndexTypeOfType(objectType, numberType)) error(accessExpression.argumentExpression, Diagnostics.Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number);
                        else {
                            let suggestion;
                            if (propName !== void 0 && (suggestion = getSuggestionForNonexistentProperty(propName, objectType))) {
                                if (suggestion !== void 0) error(accessExpression.argumentExpression, Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2, propName, typeToString(objectType), suggestion);
                            } else {
                                const suggestion2 = getSuggestionForNonexistentIndexSignature(objectType, accessExpression, indexType);
                                if (suggestion2 !== void 0) error(accessExpression, Diagnostics.Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature_Did_you_mean_to_call_1, typeToString(objectType), suggestion2);
                                else {
                                    let errorInfo;
                                    if (indexType.flags & 1024 /* EnumLiteral */ ) errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Property_0_does_not_exist_on_type_1, "[" + typeToString(indexType) + "]", typeToString(objectType));
                                    else if (indexType.flags & 8192 /* UniqueESSymbol */ ) {
                                        const symbolName2 = getFullyQualifiedName(indexType.symbol, accessExpression);
                                        errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Property_0_does_not_exist_on_type_1, "[" + symbolName2 + "]", typeToString(objectType));
                                    } else if (indexType.flags & 128 /* StringLiteral */ ) errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Property_0_does_not_exist_on_type_1, indexType.value, typeToString(objectType));
                                    else if (indexType.flags & 256 /* NumberLiteral */ ) errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Property_0_does_not_exist_on_type_1, indexType.value, typeToString(objectType));
                                    else if (indexType.flags & 12 /* String */ ) errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.No_index_signature_with_a_parameter_of_type_0_was_found_on_type_1, typeToString(indexType), typeToString(objectType));
                                    errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Element_implicitly_has_an_any_type_because_expression_of_type_0_can_t_be_used_to_index_type_1, typeToString(fullIndexType), typeToString(objectType));
                                    diagnostics.add(createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(accessExpression), accessExpression, errorInfo));
                                }
                            }
                        }
                    }
                    return void 0;
                }
            }
            if (isJSLiteralType(objectType)) return anyType;
            if (accessNode) {
                const indexNode = getIndexNodeForAccessExpression(accessNode);
                if (indexType.flags & 384 /* NumberLiteral */ ) error(indexNode, Diagnostics.Property_0_does_not_exist_on_type_1, "" + indexType.value, typeToString(objectType));
                else if (indexType.flags & 12 /* Number */ ) error(indexNode, Diagnostics.Type_0_has_no_matching_index_signature_for_type_1, typeToString(objectType), typeToString(indexType));
                else error(indexNode, Diagnostics.Type_0_cannot_be_used_as_an_index_type, typeToString(indexType));
            }
            if (isTypeAny(indexType)) return indexType;
            return void 0;
            function errorIfWritingToReadonlyIndex(indexInfo) {
                if (indexInfo && indexInfo.isReadonly && accessExpression && (isAssignmentTarget(accessExpression) || isDeleteTarget(accessExpression))) error(accessExpression, Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(objectType));
            }
        }
        function getIndexNodeForAccessExpression(accessNode) {
            return accessNode.kind === 211 /* ElementAccessExpression */  ? accessNode.argumentExpression : accessNode.kind === 198 /* IndexedAccessType */  ? accessNode.indexType : accessNode.kind === 166 /* ComputedPropertyName */  ? accessNode.expression : accessNode;
        }
        function isPatternLiteralPlaceholderType(type) {
            if (type.flags & 2097152 /* Intersection */ ) return some(type.types, (t)=>!!(t.flags & 101248 /* Undefined */ ) || isPatternLiteralPlaceholderType(t));
            return !!(type.flags & 77 /* BigInt */ ) || isPatternLiteralType(type);
        }
        function isPatternLiteralType(type) {
            return !!(type.flags & 134217728 /* TemplateLiteral */ ) && every(type.types, isPatternLiteralPlaceholderType) || !!(type.flags & 268435456 /* StringMapping */ ) && isPatternLiteralPlaceholderType(type.type);
        }
        function isGenericType(type) {
            return !!getGenericObjectFlags(type);
        }
        function isGenericObjectType(type) {
            return !!(getGenericObjectFlags(type) & 4194304 /* IsGenericObjectType */ );
        }
        function isGenericIndexType(type) {
            return !!(getGenericObjectFlags(type) & 8388608 /* IsGenericIndexType */ );
        }
        function getGenericObjectFlags(type) {
            if (type.flags & 137363456 /* TemplateLiteral */ ) {
                if (!(type.objectFlags & 2097152 /* IsGenericTypeComputed */ )) type.objectFlags |= 2097152 /* IsGenericTypeComputed */  | reduceLeft(type.types, (flags, t)=>flags | getGenericObjectFlags(t), 0);
                return type.objectFlags & 12582912 /* IsGenericType */ ;
            }
            if (type.flags & 33554432 /* Substitution */ ) {
                if (!(type.objectFlags & 2097152 /* IsGenericTypeComputed */ )) type.objectFlags |= 2097152 /* IsGenericTypeComputed */  | getGenericObjectFlags(type.baseType) | getGenericObjectFlags(type.constraint);
                return type.objectFlags & 12582912 /* IsGenericType */ ;
            }
            return (type.flags & 58982400 /* InstantiableNonPrimitive */  || isGenericMappedType(type) || isGenericTupleType(type) ? 4194304 /* IsGenericObjectType */  : 0) | (type.flags & 331612160 /* StringMapping */  && !isPatternLiteralType(type) ? 8388608 /* IsGenericIndexType */  : 0);
        }
        function getSimplifiedType(type, writing) {
            return type.flags & 8388608 /* IndexedAccess */  ? getSimplifiedIndexedAccessType(type, writing) : type.flags & 16777216 /* Conditional */  ? getSimplifiedConditionalType(type, writing) : type;
        }
        function distributeIndexOverObjectType(objectType, indexType, writing) {
            if (objectType.flags & 1048576 /* Union */  || objectType.flags & 2097152 /* Intersection */  && !shouldDeferIndexType(objectType)) {
                const types = map(objectType.types, (t)=>getSimplifiedType(getIndexedAccessType(t, indexType), writing));
                return objectType.flags & 2097152 /* Intersection */  || writing ? getIntersectionType(types) : getUnionType(types);
            }
        }
        function distributeObjectOverIndexType(objectType, indexType, writing) {
            if (indexType.flags & 1048576 /* Union */ ) {
                const types = map(indexType.types, (t)=>getSimplifiedType(getIndexedAccessType(objectType, t), writing));
                return writing ? getIntersectionType(types) : getUnionType(types);
            }
        }
        function getSimplifiedIndexedAccessType(type, writing) {
            const cache = writing ? "simplifiedForWriting" : "simplifiedForReading";
            if (type[cache]) return type[cache] === circularConstraintType ? type : type[cache];
            type[cache] = circularConstraintType;
            const objectType = getSimplifiedType(type.objectType, writing);
            const indexType = getSimplifiedType(type.indexType, writing);
            const distributedOverIndex = distributeObjectOverIndexType(objectType, indexType, writing);
            if (distributedOverIndex) return type[cache] = distributedOverIndex;
            if (!(indexType.flags & 465829888 /* Instantiable */ )) {
                const distributedOverObject = distributeIndexOverObjectType(objectType, indexType, writing);
                if (distributedOverObject) return type[cache] = distributedOverObject;
            }
            if (isGenericTupleType(objectType) && indexType.flags & 296 /* NumberLike */ ) {
                const elementType = getElementTypeOfSliceOfTupleType(objectType, indexType.flags & 8 /* Number */  ? 0 : objectType.target.fixedLength, /*endSkipCount*/ 0, writing);
                if (elementType) return type[cache] = elementType;
            }
            if (isGenericMappedType(objectType)) {
                if (!getNameTypeFromMappedType(objectType) || isFilteringMappedType(objectType)) return type[cache] = mapType(substituteIndexedMappedType(objectType, type.indexType), (t)=>getSimplifiedType(t, writing));
            }
            return type[cache] = type;
        }
        function getSimplifiedConditionalType(type, writing) {
            const checkType = type.checkType;
            const extendsType = type.extendsType;
            const trueType2 = getTrueTypeFromConditionalType(type);
            const falseType2 = getFalseTypeFromConditionalType(type);
            if (falseType2.flags & 131072 /* Never */  && getActualTypeVariable(trueType2) === getActualTypeVariable(checkType)) {
                if (checkType.flags & 1 /* Any */  || isTypeAssignableTo(getRestrictiveInstantiation(checkType), getRestrictiveInstantiation(extendsType))) return getSimplifiedType(trueType2, writing);
                else if (isIntersectionEmpty(checkType, extendsType)) return neverType;
            } else if (trueType2.flags & 131072 /* Never */  && getActualTypeVariable(falseType2) === getActualTypeVariable(checkType)) {
                if (!(checkType.flags & 1 /* Any */ ) && isTypeAssignableTo(getRestrictiveInstantiation(checkType), getRestrictiveInstantiation(extendsType))) return neverType;
                else if (checkType.flags & 1 /* Any */  || isIntersectionEmpty(checkType, extendsType)) return getSimplifiedType(falseType2, writing);
            }
            return type;
        }
        function isIntersectionEmpty(type1, type2) {
            return !!(getUnionType([
                intersectTypes(type1, type2),
                neverType
            ]).flags & 131072 /* Never */ );
        }
        function substituteIndexedMappedType(objectType, index) {
            const mapper = createTypeMapper([
                getTypeParameterFromMappedType(objectType)
            ], [
                index
            ]);
            const templateMapper = combineTypeMappers(objectType.mapper, mapper);
            return instantiateType(getTemplateTypeFromMappedType(objectType.target || objectType), templateMapper);
        }
        function getIndexedAccessType(objectType, indexType, accessFlags = 0 /* None */ , accessNode, aliasSymbol, aliasTypeArguments) {
            return getIndexedAccessTypeOrUndefined(objectType, indexType, accessFlags, accessNode, aliasSymbol, aliasTypeArguments) || (accessNode ? errorType : unknownType);
        }
        function indexTypeLessThan(indexType, limit) {
            return everyType(indexType, (t)=>{
                if (t.flags & 384 /* StringOrNumberLiteral */ ) {
                    const propName = getPropertyNameFromType(t);
                    if (isNumericLiteralName(propName)) {
                        const index = +propName;
                        return index >= 0 && index < limit;
                    }
                }
                return false;
            });
        }
        function getIndexedAccessTypeOrUndefined(objectType, indexType, accessFlags = 0 /* None */ , accessNode, aliasSymbol, aliasTypeArguments) {
            if (objectType === wildcardType || indexType === wildcardType) return wildcardType;
            objectType = getReducedType(objectType);
            if (isStringIndexSignatureOnlyType(objectType) && !(indexType.flags & 98304 /* Nullable */ ) && isTypeAssignableToKind(indexType, 12 /* Number */ )) indexType = stringType;
            if (compilerOptions.noUncheckedIndexedAccess && accessFlags & 32 /* ExpressionPosition */ ) accessFlags |= 1 /* IncludeUndefined */ ;
            if (isGenericIndexType(indexType) || (accessNode && accessNode.kind !== 198 /* IndexedAccessType */  ? isGenericTupleType(objectType) && !indexTypeLessThan(indexType, objectType.target.fixedLength) : isGenericObjectType(objectType) && !(isTupleType(objectType) && indexTypeLessThan(indexType, objectType.target.fixedLength)) || isGenericReducibleType(objectType))) {
                if (objectType.flags & 3 /* AnyOrUnknown */ ) return objectType;
                const persistentAccessFlags = accessFlags & 1 /* Persistent */ ;
                const id = objectType.id + "," + indexType.id + "," + persistentAccessFlags + getAliasId(aliasSymbol, aliasTypeArguments);
                let type = indexedAccessTypes.get(id);
                if (!type) indexedAccessTypes.set(id, type = createIndexedAccessType(objectType, indexType, persistentAccessFlags, aliasSymbol, aliasTypeArguments));
                return type;
            }
            const apparentObjectType = getReducedApparentType(objectType);
            if (indexType.flags & 1048576 /* Union */  && !(indexType.flags & 16 /* Boolean */ )) {
                const propTypes = [];
                let wasMissingProp = false;
                for (const t of indexType.types){
                    const propType = getPropertyTypeForIndexType(objectType, apparentObjectType, t, indexType, accessNode, accessFlags | (wasMissingProp ? 128 /* SuppressNoImplicitAnyError */  : 0));
                    if (propType) propTypes.push(propType);
                    else if (!accessNode) return void 0;
                    else wasMissingProp = true;
                }
                if (wasMissingProp) return void 0;
                return accessFlags & 4 /* Writing */  ? getIntersectionType(propTypes, aliasSymbol, aliasTypeArguments) : getUnionType(propTypes, 1 /* Literal */ , aliasSymbol, aliasTypeArguments);
            }
            return getPropertyTypeForIndexType(objectType, apparentObjectType, indexType, indexType, accessNode, accessFlags | 72 /* ReportDeprecated */ );
        }
        function getTypeFromIndexedAccessTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const objectType = getTypeFromTypeNode(node.objectType);
                const indexType = getTypeFromTypeNode(node.indexType);
                const potentialAlias = getAliasSymbolForTypeNode(node);
                links.resolvedType = getIndexedAccessType(objectType, indexType, 0 /* None */ , node, potentialAlias, getTypeArgumentsForAliasSymbol(potentialAlias));
            }
            return links.resolvedType;
        }
        function getTypeFromMappedTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const type = createObjectType(32 /* Mapped */ , node.symbol);
                type.declaration = node;
                type.aliasSymbol = getAliasSymbolForTypeNode(node);
                type.aliasTypeArguments = getTypeArgumentsForAliasSymbol(type.aliasSymbol);
                links.resolvedType = type;
                getConstraintTypeFromMappedType(type);
            }
            return links.resolvedType;
        }
        function getActualTypeVariable(type) {
            if (type.flags & 33554432 /* Substitution */ ) return getActualTypeVariable(type.baseType);
            if (type.flags & 8388608 /* IndexedAccess */  && (type.objectType.flags & 33554432 /* Substitution */  || type.indexType.flags & 33554432 /* Substitution */ )) return getIndexedAccessType(getActualTypeVariable(type.objectType), getActualTypeVariable(type.indexType));
            return type;
        }
        function maybeCloneTypeParameter(p) {
            const constraint = getConstraintOfTypeParameter(p);
            return constraint && (isGenericObjectType(constraint) || isGenericIndexType(constraint)) ? cloneTypeParameter(p) : p;
        }
        function isSimpleTupleType(node) {
            return isTupleTypeNode(node) && length(node.elements) > 0 && !some(node.elements, (e)=>isOptionalTypeNode(e) || isRestTypeNode(e) || isNamedTupleMember(e) && !!(e.questionToken || e.dotDotDotToken));
        }
        function isDeferredType(type, checkTuples) {
            return isGenericType(type) || checkTuples && isTupleType(type) && some(getElementTypes(type), isGenericType);
        }
        function getConditionalType(root, mapper, aliasSymbol, aliasTypeArguments) {
            let result;
            let extraTypes;
            let tailCount = 0;
            while(true){
                if (tailCount === 1e3) {
                    error(currentNode, Diagnostics.Type_instantiation_is_excessively_deep_and_possibly_infinite);
                    return errorType;
                }
                const checkType = instantiateType(getActualTypeVariable(root.checkType), mapper);
                const extendsType = instantiateType(root.extendsType, mapper);
                if (checkType === errorType || extendsType === errorType) return errorType;
                if (checkType === wildcardType || extendsType === wildcardType) return wildcardType;
                const checkTuples = isSimpleTupleType(root.node.checkType) && isSimpleTupleType(root.node.extendsType) && length(root.node.checkType.elements) === length(root.node.extendsType.elements);
                const checkTypeDeferred = isDeferredType(checkType, checkTuples);
                let combinedMapper;
                if (root.inferTypeParameters) {
                    const freshParams = sameMap(root.inferTypeParameters, maybeCloneTypeParameter);
                    const freshMapper = freshParams !== root.inferTypeParameters ? createTypeMapper(root.inferTypeParameters, freshParams) : void 0;
                    const context = createInferenceContext(freshParams, /*signature*/ void 0, 0 /* None */ );
                    if (freshMapper) {
                        const freshCombinedMapper = combineTypeMappers(mapper, freshMapper);
                        for (const p of freshParams)if (root.inferTypeParameters.indexOf(p) === -1) p.mapper = freshCombinedMapper;
                    }
                    if (!checkTypeDeferred) inferTypes(context.inferences, checkType, instantiateType(extendsType, freshMapper), 1536 /* AlwaysStrict */ );
                    const innerMapper = combineTypeMappers(freshMapper, context.mapper);
                    combinedMapper = mapper ? combineTypeMappers(innerMapper, mapper) : innerMapper;
                }
                const inferredExtendsType = combinedMapper ? instantiateType(root.extendsType, combinedMapper) : extendsType;
                if (!checkTypeDeferred && !isDeferredType(inferredExtendsType, checkTuples)) {
                    if (!(inferredExtendsType.flags & 3 /* AnyOrUnknown */ ) && (checkType.flags & 1 /* Any */  || !isTypeAssignableTo(getPermissiveInstantiation(checkType), getPermissiveInstantiation(inferredExtendsType)))) {
                        if (checkType.flags & 1 /* Any */ ) (extraTypes || (extraTypes = [])).push(instantiateType(getTypeFromTypeNode(root.node.trueType), combinedMapper || mapper));
                        const falseType2 = getTypeFromTypeNode(root.node.falseType);
                        if (falseType2.flags & 16777216 /* Conditional */ ) {
                            const newRoot = falseType2.root;
                            if (newRoot.node.parent === root.node && (!newRoot.isDistributive || newRoot.checkType === root.checkType)) {
                                root = newRoot;
                                continue;
                            }
                            if (canTailRecurse(falseType2, mapper)) continue;
                        }
                        result = instantiateType(falseType2, mapper);
                        break;
                    }
                    if (inferredExtendsType.flags & 3 /* AnyOrUnknown */  || isTypeAssignableTo(getRestrictiveInstantiation(checkType), getRestrictiveInstantiation(inferredExtendsType))) {
                        const trueType2 = getTypeFromTypeNode(root.node.trueType);
                        const trueMapper = combinedMapper || mapper;
                        if (canTailRecurse(trueType2, trueMapper)) continue;
                        result = instantiateType(trueType2, trueMapper);
                        break;
                    }
                }
                result = createType(16777216 /* Conditional */ );
                result.root = root;
                result.checkType = instantiateType(root.checkType, mapper);
                result.extendsType = instantiateType(root.extendsType, mapper);
                result.mapper = mapper;
                result.combinedMapper = combinedMapper;
                result.aliasSymbol = aliasSymbol || root.aliasSymbol;
                result.aliasTypeArguments = aliasSymbol ? aliasTypeArguments : instantiateTypes(root.aliasTypeArguments, mapper);
                break;
            }
            return extraTypes ? getUnionType(append(extraTypes, result)) : result;
            function canTailRecurse(newType, newMapper) {
                if (newType.flags & 16777216 /* Conditional */  && newMapper) {
                    const newRoot = newType.root;
                    if (newRoot.outerTypeParameters) {
                        const typeParamMapper = combineTypeMappers(newType.mapper, newMapper);
                        const typeArguments = map(newRoot.outerTypeParameters, (t)=>getMappedType(t, typeParamMapper));
                        const newRootMapper = createTypeMapper(newRoot.outerTypeParameters, typeArguments);
                        const newCheckType = newRoot.isDistributive ? getMappedType(newRoot.checkType, newRootMapper) : void 0;
                        if (!newCheckType || newCheckType === newRoot.checkType || !(newCheckType.flags & 1179648 /* Never */ )) {
                            root = newRoot;
                            mapper = newRootMapper;
                            aliasSymbol = void 0;
                            aliasTypeArguments = void 0;
                            if (newRoot.aliasSymbol) tailCount++;
                            return true;
                        }
                    }
                }
                return false;
            }
        }
        function getTrueTypeFromConditionalType(type) {
            return type.resolvedTrueType || (type.resolvedTrueType = instantiateType(getTypeFromTypeNode(type.root.node.trueType), type.mapper));
        }
        function getFalseTypeFromConditionalType(type) {
            return type.resolvedFalseType || (type.resolvedFalseType = instantiateType(getTypeFromTypeNode(type.root.node.falseType), type.mapper));
        }
        function getInferredTrueTypeFromConditionalType(type) {
            return type.resolvedInferredTrueType || (type.resolvedInferredTrueType = type.combinedMapper ? instantiateType(getTypeFromTypeNode(type.root.node.trueType), type.combinedMapper) : getTrueTypeFromConditionalType(type));
        }
        function getInferTypeParameters(node) {
            let result;
            if (node.locals) node.locals.forEach((symbol)=>{
                if (symbol.flags & 262144 /* TypeParameter */ ) result = append(result, getDeclaredTypeOfSymbol(symbol));
            });
            return result;
        }
        function isDistributionDependent(root) {
            return root.isDistributive && (isTypeParameterPossiblyReferenced(root.checkType, root.node.trueType) || isTypeParameterPossiblyReferenced(root.checkType, root.node.falseType));
        }
        function getTypeFromConditionalTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const checkType = getTypeFromTypeNode(node.checkType);
                const aliasSymbol = getAliasSymbolForTypeNode(node);
                const aliasTypeArguments = getTypeArgumentsForAliasSymbol(aliasSymbol);
                const allOuterTypeParameters = getOuterTypeParameters(node, /*includeThisTypes*/ true);
                const outerTypeParameters = aliasTypeArguments ? allOuterTypeParameters : filter(allOuterTypeParameters, (tp)=>isTypeParameterPossiblyReferenced(tp, node));
                const root = {
                    node: node,
                    checkType: checkType,
                    extendsType: getTypeFromTypeNode(node.extendsType),
                    isDistributive: !!(checkType.flags & 262144 /* TypeParameter */ ),
                    inferTypeParameters: getInferTypeParameters(node),
                    outerTypeParameters: outerTypeParameters,
                    instantiations: void 0,
                    aliasSymbol: aliasSymbol,
                    aliasTypeArguments: aliasTypeArguments
                };
                links.resolvedType = getConditionalType(root, /*mapper*/ void 0);
                if (outerTypeParameters) {
                    root.instantiations = /* @__PURE__ */ new Map();
                    root.instantiations.set(getTypeListId(outerTypeParameters), links.resolvedType);
                }
            }
            return links.resolvedType;
        }
        function getTypeFromInferTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) links.resolvedType = getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(node.typeParameter));
            return links.resolvedType;
        }
        function getIdentifierChain(node) {
            if (isIdentifier(node)) return [
                node
            ];
            else return append(getIdentifierChain(node.left), node.right);
        }
        function getTypeFromImportTypeNode(node) {
            var _a;
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                if (!isLiteralImportTypeNode(node)) {
                    error(node.argument, Diagnostics.String_literal_expected);
                    links.resolvedSymbol = unknownSymbol;
                    return links.resolvedType = errorType;
                }
                const targetMeaning = node.isTypeOf ? 111551 /* Value */  : node.flags & 8388608 /* JSDoc */  ? 900095 /* Type */  : 788968 /* Type */ ;
                const innerModuleSymbol = resolveExternalModuleName(node, node.argument.literal);
                if (!innerModuleSymbol) {
                    links.resolvedSymbol = unknownSymbol;
                    return links.resolvedType = errorType;
                }
                const isExportEquals = !!((_a = innerModuleSymbol.exports) == null ? void 0 : _a.get("export=" /* ExportEquals */ ));
                const moduleSymbol = resolveExternalModuleSymbol(innerModuleSymbol, /*dontResolveAlias*/ false);
                if (!nodeIsMissing(node.qualifier)) {
                    const nameStack = getIdentifierChain(node.qualifier);
                    let currentNamespace = moduleSymbol;
                    let current;
                    while(current = nameStack.shift()){
                        const meaning = nameStack.length ? 1920 /* Namespace */  : targetMeaning;
                        const mergedResolvedSymbol = getMergedSymbol(resolveSymbol(currentNamespace));
                        const symbolFromVariable = node.isTypeOf || isInJSFile(node) && isExportEquals ? getPropertyOfType(getTypeOfSymbol(mergedResolvedSymbol), current.escapedText, /*skipObjectFunctionPropertyAugment*/ false, /*includeTypeOnlyMembers*/ true) : void 0;
                        const symbolFromModule = node.isTypeOf ? void 0 : getSymbol2(getExportsOfSymbol(mergedResolvedSymbol), current.escapedText, meaning);
                        const next = symbolFromModule ?? symbolFromVariable;
                        if (!next) {
                            error(current, Diagnostics.Namespace_0_has_no_exported_member_1, getFullyQualifiedName(currentNamespace), declarationNameToString(current));
                            return links.resolvedType = errorType;
                        }
                        getNodeLinks(current).resolvedSymbol = next;
                        getNodeLinks(current.parent).resolvedSymbol = next;
                        currentNamespace = next;
                    }
                    links.resolvedType = resolveImportSymbolType(node, links, currentNamespace, targetMeaning);
                } else if (moduleSymbol.flags & targetMeaning) links.resolvedType = resolveImportSymbolType(node, links, moduleSymbol, targetMeaning);
                else {
                    const errorMessage = targetMeaning === 111551 /* Value */  ? Diagnostics.Module_0_does_not_refer_to_a_value_but_is_used_as_a_value_here : Diagnostics.Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here_Did_you_mean_typeof_import_0;
                    error(node, errorMessage, node.argument.literal.text);
                    links.resolvedSymbol = unknownSymbol;
                    links.resolvedType = errorType;
                }
            }
            return links.resolvedType;
        }
        function resolveImportSymbolType(node, links, symbol, meaning) {
            const resolvedSymbol = resolveSymbol(symbol);
            links.resolvedSymbol = resolvedSymbol;
            if (meaning === 111551 /* Value */ ) return getInstantiationExpressionType(getTypeOfSymbol(symbol), node);
            else return getTypeReferenceType(node, resolvedSymbol);
        }
        function getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const aliasSymbol = getAliasSymbolForTypeNode(node);
                if (getMembersOfSymbol(node.symbol).size === 0 && !aliasSymbol) links.resolvedType = emptyTypeLiteralType;
                else {
                    let type = createObjectType(16 /* Anonymous */ , node.symbol);
                    type.aliasSymbol = aliasSymbol;
                    type.aliasTypeArguments = getTypeArgumentsForAliasSymbol(aliasSymbol);
                    if (isJSDocTypeLiteral(node) && node.isArrayType) type = createArrayType(type);
                    links.resolvedType = type;
                }
            }
            return links.resolvedType;
        }
        function getAliasSymbolForTypeNode(node) {
            let host2 = node.parent;
            while(isParenthesizedTypeNode(host2) || isJSDocTypeExpression(host2) || isTypeOperatorNode(host2) && host2.operator === 148 /* ReadonlyKeyword */ )host2 = host2.parent;
            return isTypeAlias(host2) ? getSymbolOfDeclaration(host2) : void 0;
        }
        function getTypeArgumentsForAliasSymbol(symbol) {
            return symbol ? getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol) : void 0;
        }
        function isNonGenericObjectType(type) {
            return !!(type.flags & 524288 /* Object */ ) && !isGenericMappedType(type);
        }
        function isEmptyObjectTypeOrSpreadsIntoEmptyObject(type) {
            return isEmptyObjectType(type) || !!(type.flags & 474058748 /* Index */ );
        }
        function tryMergeUnionOfObjectTypeAndEmptyObject(type, readonly) {
            if (!(type.flags & 1048576 /* Union */ )) return type;
            if (every(type.types, isEmptyObjectTypeOrSpreadsIntoEmptyObject)) return find(type.types, isEmptyObjectType) || emptyObjectType;
            const firstType = find(type.types, (t)=>!isEmptyObjectTypeOrSpreadsIntoEmptyObject(t));
            if (!firstType) return type;
            const secondType = find(type.types, (t)=>t !== firstType && !isEmptyObjectTypeOrSpreadsIntoEmptyObject(t));
            if (secondType) return type;
            return getAnonymousPartialType(firstType);
            function getAnonymousPartialType(type2) {
                const members = createSymbolTable();
                for (const prop of getPropertiesOfType(type2)){
                    if (getDeclarationModifierFlagsFromSymbol(prop) & 24 /* Protected */ ) ;
                    else if (isSpreadableProperty(prop)) {
                        const isSetonlyAccessor = prop.flags & 65536 /* SetAccessor */  && !(prop.flags & 32768 /* GetAccessor */ );
                        const flags = 16777220 /* Optional */ ;
                        const result = createSymbol(flags, prop.escapedName, getIsLateCheckFlag(prop) | (readonly ? 8 /* Readonly */  : 0));
                        result.links.type = isSetonlyAccessor ? undefinedType : addOptionality(getTypeOfSymbol(prop), /*isProperty*/ true);
                        result.declarations = prop.declarations;
                        result.links.nameType = getSymbolLinks(prop).nameType;
                        result.links.syntheticOrigin = prop;
                        members.set(prop.escapedName, result);
                    }
                }
                const spread = createAnonymousType(type2.symbol, members, emptyArray, emptyArray, getIndexInfosOfType(type2));
                spread.objectFlags |= 131200 /* ContainsObjectOrArrayLiteral */ ;
                return spread;
            }
        }
        function getSpreadType(left, right, symbol, objectFlags, readonly) {
            if (left.flags & 1 /* Any */  || right.flags & 1 /* Any */ ) return anyType;
            if (left.flags & 2 /* Unknown */  || right.flags & 2 /* Unknown */ ) return unknownType;
            if (left.flags & 131072 /* Never */ ) return right;
            if (right.flags & 131072 /* Never */ ) return left;
            left = tryMergeUnionOfObjectTypeAndEmptyObject(left, readonly);
            if (left.flags & 1048576 /* Union */ ) return checkCrossProductUnion([
                left,
                right
            ]) ? mapType(left, (t)=>getSpreadType(t, right, symbol, objectFlags, readonly)) : errorType;
            right = tryMergeUnionOfObjectTypeAndEmptyObject(right, readonly);
            if (right.flags & 1048576 /* Union */ ) return checkCrossProductUnion([
                left,
                right
            ]) ? mapType(right, (t)=>getSpreadType(left, t, symbol, objectFlags, readonly)) : errorType;
            if (right.flags & 473960444 /* Index */ ) return left;
            if (isGenericObjectType(left) || isGenericObjectType(right)) {
                if (isEmptyObjectType(left)) return right;
                if (left.flags & 2097152 /* Intersection */ ) {
                    const types = left.types;
                    const lastLeft = types[types.length - 1];
                    if (isNonGenericObjectType(lastLeft) && isNonGenericObjectType(right)) return getIntersectionType(concatenate(types.slice(0, types.length - 1), [
                        getSpreadType(lastLeft, right, symbol, objectFlags, readonly)
                    ]));
                }
                return getIntersectionType([
                    left,
                    right
                ]);
            }
            const members = createSymbolTable();
            const skippedPrivateMembers = /* @__PURE__ */ new Set();
            const indexInfos = left === emptyObjectType ? getIndexInfosOfType(right) : getUnionIndexInfos([
                left,
                right
            ]);
            for (const rightProp of getPropertiesOfType(right)){
                if (getDeclarationModifierFlagsFromSymbol(rightProp) & 24 /* Protected */ ) skippedPrivateMembers.add(rightProp.escapedName);
                else if (isSpreadableProperty(rightProp)) members.set(rightProp.escapedName, getSpreadSymbol(rightProp, readonly));
            }
            for (const leftProp of getPropertiesOfType(left)){
                if (skippedPrivateMembers.has(leftProp.escapedName) || !isSpreadableProperty(leftProp)) continue;
                if (members.has(leftProp.escapedName)) {
                    const rightProp = members.get(leftProp.escapedName);
                    const rightType = getTypeOfSymbol(rightProp);
                    if (rightProp.flags & 16777216 /* Optional */ ) {
                        const declarations = concatenate(leftProp.declarations, rightProp.declarations);
                        const flags = 4 /* Property */  | leftProp.flags & 16777216 /* Optional */ ;
                        const result = createSymbol(flags, leftProp.escapedName);
                        const leftType = getTypeOfSymbol(leftProp);
                        const leftTypeWithoutUndefined = removeMissingOrUndefinedType(leftType);
                        const rightTypeWithoutUndefined = removeMissingOrUndefinedType(rightType);
                        result.links.type = leftTypeWithoutUndefined === rightTypeWithoutUndefined ? leftType : getUnionType([
                            leftType,
                            rightTypeWithoutUndefined
                        ], 2 /* Subtype */ );
                        result.links.leftSpread = leftProp;
                        result.links.rightSpread = rightProp;
                        result.declarations = declarations;
                        result.links.nameType = getSymbolLinks(leftProp).nameType;
                        members.set(leftProp.escapedName, result);
                    }
                } else members.set(leftProp.escapedName, getSpreadSymbol(leftProp, readonly));
            }
            const spread = createAnonymousType(symbol, members, emptyArray, emptyArray, sameMap(indexInfos, (info)=>getIndexInfoWithReadonly(info, readonly)));
            spread.objectFlags |= 2228352 /* ContainsSpread */  | objectFlags;
            return spread;
        }
        function isSpreadableProperty(prop) {
            var _a;
            return !some(prop.declarations, isPrivateIdentifierClassElementDeclaration) && (!(prop.flags & 106496 /* SetAccessor */ ) || !((_a = prop.declarations) == null ? void 0 : _a.some((decl)=>isClassLike(decl.parent))));
        }
        function getSpreadSymbol(prop, readonly) {
            const isSetonlyAccessor = prop.flags & 65536 /* SetAccessor */  && !(prop.flags & 32768 /* GetAccessor */ );
            if (!isSetonlyAccessor && readonly === isReadonlySymbol(prop)) return prop;
            const flags = 4 /* Property */  | prop.flags & 16777216 /* Optional */ ;
            const result = createSymbol(flags, prop.escapedName, getIsLateCheckFlag(prop) | (readonly ? 8 /* Readonly */  : 0));
            result.links.type = isSetonlyAccessor ? undefinedType : getTypeOfSymbol(prop);
            result.declarations = prop.declarations;
            result.links.nameType = getSymbolLinks(prop).nameType;
            result.links.syntheticOrigin = prop;
            return result;
        }
        function getIndexInfoWithReadonly(info, readonly) {
            return info.isReadonly !== readonly ? createIndexInfo(info.keyType, info.type, readonly, info.declaration) : info;
        }
        function createLiteralType(flags, value1, symbol, regularType) {
            const type = createTypeWithSymbol(flags, symbol);
            type.value = value1;
            type.regularType = regularType || type;
            return type;
        }
        function getFreshTypeOfLiteralType(type) {
            if (type.flags & 2976 /* Freshable */ ) {
                if (!type.freshType) {
                    const freshType = createLiteralType(type.flags, type.value, type.symbol, type);
                    freshType.freshType = freshType;
                    type.freshType = freshType;
                }
                return type.freshType;
            }
            return type;
        }
        function getRegularTypeOfLiteralType(type) {
            return type.flags & 2976 /* Freshable */  ? type.regularType : type.flags & 1048576 /* Union */  ? type.regularType || (type.regularType = mapType(type, getRegularTypeOfLiteralType)) : type;
        }
        function isFreshLiteralType(type) {
            return !!(type.flags & 2976 /* Freshable */ ) && type.freshType === type;
        }
        function getStringLiteralType(value1) {
            let type;
            return stringLiteralTypes.get(value1) || (stringLiteralTypes.set(value1, type = createLiteralType(128 /* StringLiteral */ , value1)), type);
        }
        function getNumberLiteralType(value1) {
            let type;
            return numberLiteralTypes.get(value1) || (numberLiteralTypes.set(value1, type = createLiteralType(256 /* NumberLiteral */ , value1)), type);
        }
        function getBigIntLiteralType(value1) {
            let type;
            const key = pseudoBigIntToString(value1);
            return bigIntLiteralTypes.get(key) || (bigIntLiteralTypes.set(key, type = createLiteralType(2048 /* BigIntLiteral */ , value1)), type);
        }
        function getEnumLiteralType(value1, enumId, symbol) {
            let type;
            const key = `${enumId}${typeof value1 === "string" ? "@" : "#"}${value1}`;
            const flags = 1024 /* EnumLiteral */  | (typeof value1 === "string" ? 128 /* StringLiteral */  : 256 /* NumberLiteral */ );
            return enumLiteralTypes.get(key) || (enumLiteralTypes.set(key, type = createLiteralType(flags, value1, symbol)), type);
        }
        function getTypeFromLiteralTypeNode(node) {
            if (node.literal.kind === 106 /* NullKeyword */ ) return nullType;
            const links = getNodeLinks(node);
            if (!links.resolvedType) links.resolvedType = getRegularTypeOfLiteralType(checkExpression(node.literal));
            return links.resolvedType;
        }
        function createUniqueESSymbolType(symbol) {
            const type = createTypeWithSymbol(8192 /* UniqueESSymbol */ , symbol);
            type.escapedName = `__@${type.symbol.escapedName}@${getSymbolId(type.symbol)}`;
            return type;
        }
        function getESSymbolLikeTypeForNode(node) {
            if (isValidESSymbolDeclaration(node)) {
                const symbol = isCommonJsExportPropertyAssignment(node) ? getSymbolOfNode(node.left) : getSymbolOfNode(node);
                if (symbol) {
                    const links = getSymbolLinks(symbol);
                    return links.uniqueESSymbolType || (links.uniqueESSymbolType = createUniqueESSymbolType(symbol));
                }
            }
            return esSymbolType;
        }
        function getThisType(node) {
            const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            const parent2 = container && container.parent;
            if (parent2 && (isClassLike(parent2) || parent2.kind === 263 /* InterfaceDeclaration */ )) {
                if (!isStatic(container) && (!isConstructorDeclaration(container) || isNodeDescendantOf(node, container.body))) return getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(parent2)).thisType;
            }
            if (parent2 && isObjectLiteralExpression(parent2) && isBinaryExpression(parent2.parent) && getAssignmentDeclarationKind(parent2.parent) === 6 /* Prototype */ ) return getDeclaredTypeOfClassOrInterface(getSymbolOfNode(parent2.parent.left).parent).thisType;
            const host2 = node.flags & 8388608 /* JSDoc */  ? getHostSignatureFromJSDoc(node) : void 0;
            if (host2 && isFunctionExpression(host2) && isBinaryExpression(host2.parent) && getAssignmentDeclarationKind(host2.parent) === 3 /* PrototypeProperty */ ) return getDeclaredTypeOfClassOrInterface(getSymbolOfNode(host2.parent.left).parent).thisType;
            if (isJSConstructor(container) && isNodeDescendantOf(node, container.body)) return getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(container)).thisType;
            error(node, Diagnostics.A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface);
            return errorType;
        }
        function getTypeFromThisTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) links.resolvedType = getThisType(node);
            return links.resolvedType;
        }
        function getTypeFromRestTypeNode(node) {
            return getTypeFromTypeNode(getArrayElementTypeNode(node.type) || node.type);
        }
        function getArrayElementTypeNode(node) {
            switch(node.kind){
                case 195 /* ParenthesizedType */ :
                    return getArrayElementTypeNode(node.type);
                case 188 /* TupleType */ :
                    if (node.elements.length === 1) {
                        node = node.elements[0];
                        if (node.kind === 190 /* RestType */  || node.kind === 201 /* NamedTupleMember */  && node.dotDotDotToken) return getArrayElementTypeNode(node.type);
                    }
                    break;
                case 187 /* ArrayType */ :
                    return node.elementType;
            }
            return void 0;
        }
        function getTypeFromNamedTupleTypeNode(node) {
            const links = getNodeLinks(node);
            return links.resolvedType || (links.resolvedType = node.dotDotDotToken ? getTypeFromRestTypeNode(node) : addOptionality(getTypeFromTypeNode(node.type), /*isProperty*/ true, !!node.questionToken));
        }
        function getTypeFromTypeNode(node) {
            return getConditionalFlowTypeOfType(getTypeFromTypeNodeWorker(node), node);
        }
        function getTypeFromTypeNodeWorker(node) {
            switch(node.kind){
                case 133 /* AnyKeyword */ :
                case 318 /* JSDocAllType */ :
                case 319 /* JSDocUnknownType */ :
                    return anyType;
                case 159 /* UnknownKeyword */ :
                    return unknownType;
                case 154 /* StringKeyword */ :
                    return stringType;
                case 150 /* NumberKeyword */ :
                    return numberType;
                case 162 /* BigIntKeyword */ :
                    return bigintType;
                case 136 /* BooleanKeyword */ :
                    return booleanType;
                case 155 /* SymbolKeyword */ :
                    return esSymbolType;
                case 116 /* VoidKeyword */ :
                    return voidType;
                case 157 /* UndefinedKeyword */ :
                    return undefinedType;
                case 106 /* NullKeyword */ :
                    return nullType;
                case 146 /* NeverKeyword */ :
                    return neverType;
                case 151 /* ObjectKeyword */ :
                    return node.flags & 262144 /* JavaScriptFile */  && !noImplicitAny ? anyType : nonPrimitiveType;
                case 141 /* IntrinsicKeyword */ :
                    return intrinsicMarkerType;
                case 196 /* ThisType */ :
                case 110 /* ThisKeyword */ :
                    return getTypeFromThisTypeNode(node);
                case 200 /* LiteralType */ :
                    return getTypeFromLiteralTypeNode(node);
                case 182 /* TypeReference */ :
                    return getTypeFromTypeReference(node);
                case 181 /* TypePredicate */ :
                    return node.assertsModifier ? voidType : booleanType;
                case 232 /* ExpressionWithTypeArguments */ :
                    return getTypeFromTypeReference(node);
                case 185 /* TypeQuery */ :
                    return getTypeFromTypeQueryNode(node);
                case 187 /* ArrayType */ :
                case 188 /* TupleType */ :
                    return getTypeFromArrayOrTupleTypeNode(node);
                case 189 /* OptionalType */ :
                    return getTypeFromOptionalTypeNode(node);
                case 191 /* UnionType */ :
                    return getTypeFromUnionTypeNode(node);
                case 192 /* IntersectionType */ :
                    return getTypeFromIntersectionTypeNode(node);
                case 320 /* JSDocNullableType */ :
                    return getTypeFromJSDocNullableTypeNode(node);
                case 322 /* JSDocOptionalType */ :
                    return addOptionality(getTypeFromTypeNode(node.type));
                case 201 /* NamedTupleMember */ :
                    return getTypeFromNamedTupleTypeNode(node);
                case 195 /* ParenthesizedType */ :
                case 321 /* JSDocNonNullableType */ :
                case 315 /* JSDocTypeExpression */ :
                    return getTypeFromTypeNode(node.type);
                case 190 /* RestType */ :
                    return getTypeFromRestTypeNode(node);
                case 324 /* JSDocVariadicType */ :
                    return getTypeFromJSDocVariadicType(node);
                case 183 /* FunctionType */ :
                case 184 /* ConstructorType */ :
                case 186 /* TypeLiteral */ :
                case 328 /* JSDocTypeLiteral */ :
                case 323 /* JSDocFunctionType */ :
                case 329 /* JSDocSignature */ :
                    return getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node);
                case 197 /* TypeOperator */ :
                    return getTypeFromTypeOperatorNode(node);
                case 198 /* IndexedAccessType */ :
                    return getTypeFromIndexedAccessTypeNode(node);
                case 199 /* MappedType */ :
                    return getTypeFromMappedTypeNode(node);
                case 193 /* ConditionalType */ :
                    return getTypeFromConditionalTypeNode(node);
                case 194 /* InferType */ :
                    return getTypeFromInferTypeNode(node);
                case 202 /* TemplateLiteralType */ :
                    return getTypeFromTemplateTypeNode(node);
                case 204 /* ImportType */ :
                    return getTypeFromImportTypeNode(node);
                case 80 /* Identifier */ :
                case 165 /* QualifiedName */ :
                case 210 /* PropertyAccessExpression */ :
                    const symbol = getSymbolAtLocation(node);
                    return symbol ? getDeclaredTypeOfSymbol(symbol) : errorType;
                default:
                    return errorType;
            }
        }
        function instantiateList(items, mapper, instantiator) {
            if (items && items.length) for(let i = 0; i < items.length; i++){
                const item = items[i];
                const mapped = instantiator(item, mapper);
                if (item !== mapped) {
                    const result = i === 0 ? [] : items.slice(0, i);
                    result.push(mapped);
                    for(i++; i < items.length; i++)result.push(instantiator(items[i], mapper));
                    return result;
                }
            }
            return items;
        }
        function instantiateTypes(types, mapper) {
            return instantiateList(types, mapper, instantiateType);
        }
        function instantiateSignatures(signatures, mapper) {
            return instantiateList(signatures, mapper, instantiateSignature);
        }
        function instantiateIndexInfos(indexInfos, mapper) {
            return instantiateList(indexInfos, mapper, instantiateIndexInfo);
        }
        function createTypeMapper(sources, targets) {
            return sources.length === 1 ? makeUnaryTypeMapper(sources[0], targets ? targets[0] : anyType) : makeArrayTypeMapper(sources, targets);
        }
        function getMappedType(type, mapper) {
            switch(mapper.kind){
                case 0 /* Simple */ :
                    return type === mapper.source ? mapper.target : type;
                case 1 /* Array */ :
                    {
                        const sources = mapper.sources;
                        const targets = mapper.targets;
                        for(let i = 0; i < sources.length; i++){
                            if (type === sources[i]) return targets ? targets[i] : anyType;
                        }
                        return type;
                    }
                case 2 /* Deferred */ :
                    {
                        const sources = mapper.sources;
                        const targets = mapper.targets;
                        for(let i = 0; i < sources.length; i++){
                            if (type === sources[i]) return targets[i]();
                        }
                        return type;
                    }
                case 3 /* Function */ :
                    return mapper.func(type);
                case 4 /* Composite */ :
                case 5 /* Merged */ :
                    const t1 = getMappedType(type, mapper.mapper1);
                    return t1 !== type && mapper.kind === 4 /* Composite */  ? instantiateType(t1, mapper.mapper2) : getMappedType(t1, mapper.mapper2);
            }
        }
        function makeUnaryTypeMapper(source, target) {
            return Debug.attachDebugPrototypeIfDebug({
                kind: 0 /* Simple */ ,
                source: source,
                target: target
            });
        }
        function makeArrayTypeMapper(sources, targets) {
            return Debug.attachDebugPrototypeIfDebug({
                kind: 1 /* Array */ ,
                sources: sources,
                targets: targets
            });
        }
        function makeFunctionTypeMapper(func, debugInfo) {
            return Debug.attachDebugPrototypeIfDebug({
                kind: 3 /* Function */ ,
                func: func,
                debugInfo: Debug.isDebugging ? debugInfo : void 0
            });
        }
        function makeDeferredTypeMapper(sources, targets) {
            return Debug.attachDebugPrototypeIfDebug({
                kind: 2 /* Deferred */ ,
                sources: sources,
                targets: targets
            });
        }
        function makeCompositeTypeMapper(kind, mapper1, mapper2) {
            return Debug.attachDebugPrototypeIfDebug({
                kind: kind,
                mapper1: mapper1,
                mapper2: mapper2
            });
        }
        function createTypeEraser(sources) {
            return createTypeMapper(sources, /*targets*/ void 0);
        }
        function createBackreferenceMapper(context, index) {
            const forwardInferences = context.inferences.slice(index);
            return createTypeMapper(map(forwardInferences, (i)=>i.typeParameter), map(forwardInferences, ()=>unknownType));
        }
        function combineTypeMappers(mapper1, mapper2) {
            return mapper1 ? makeCompositeTypeMapper(4 /* Composite */ , mapper1, mapper2) : mapper2;
        }
        function mergeTypeMappers(mapper1, mapper2) {
            return mapper1 ? makeCompositeTypeMapper(5 /* Merged */ , mapper1, mapper2) : mapper2;
        }
        function prependTypeMapping(source, target, mapper) {
            return !mapper ? makeUnaryTypeMapper(source, target) : makeCompositeTypeMapper(5 /* Merged */ , makeUnaryTypeMapper(source, target), mapper);
        }
        function appendTypeMapping(mapper, source, target) {
            return !mapper ? makeUnaryTypeMapper(source, target) : makeCompositeTypeMapper(5 /* Merged */ , mapper, makeUnaryTypeMapper(source, target));
        }
        function getRestrictiveTypeParameter(tp) {
            return !tp.constraint && !getConstraintDeclaration(tp) || tp.constraint === noConstraintType ? tp : tp.restrictiveInstantiation || (tp.restrictiveInstantiation = createTypeParameter(tp.symbol), tp.restrictiveInstantiation.constraint = noConstraintType, tp.restrictiveInstantiation);
        }
        function cloneTypeParameter(typeParameter) {
            const result = createTypeParameter(typeParameter.symbol);
            result.target = typeParameter;
            return result;
        }
        function instantiateTypePredicate(predicate, mapper) {
            return createTypePredicate(predicate.kind, predicate.parameterName, predicate.parameterIndex, instantiateType(predicate.type, mapper));
        }
        function instantiateSignature(signature, mapper, eraseTypeParameters) {
            let freshTypeParameters;
            if (signature.typeParameters && !eraseTypeParameters) {
                freshTypeParameters = map(signature.typeParameters, cloneTypeParameter);
                mapper = combineTypeMappers(createTypeMapper(signature.typeParameters, freshTypeParameters), mapper);
                for (const tp of freshTypeParameters)tp.mapper = mapper;
            }
            const result = createSignature(signature.declaration, freshTypeParameters, signature.thisParameter && instantiateSymbol(signature.thisParameter, mapper), instantiateList(signature.parameters, mapper, instantiateSymbol), /*resolvedReturnType*/ void 0, /*resolvedTypePredicate*/ void 0, signature.minArgumentCount, signature.flags & 39 /* PropagatingFlags */ );
            result.target = signature;
            result.mapper = mapper;
            return result;
        }
        function instantiateSymbol(symbol, mapper) {
            const links = getSymbolLinks(symbol);
            if (links.type && !couldContainTypeVariables(links.type)) return symbol;
            if (getCheckFlags(symbol) & 1 /* Instantiated */ ) {
                symbol = links.target;
                mapper = combineTypeMappers(links.mapper, mapper);
            }
            const result = createSymbol(symbol.flags, symbol.escapedName, 1 /* Instantiated */  | getCheckFlags(symbol) & 53256 /* RestParameter */ );
            result.declarations = symbol.declarations;
            result.parent = symbol.parent;
            result.links.target = symbol;
            result.links.mapper = mapper;
            if (symbol.valueDeclaration) result.valueDeclaration = symbol.valueDeclaration;
            if (links.nameType) result.links.nameType = links.nameType;
            return result;
        }
        function getObjectTypeInstantiation(type, mapper, aliasSymbol, aliasTypeArguments) {
            const declaration = type.objectFlags & 4 /* Reference */  ? type.node : type.objectFlags & 8388608 /* InstantiationExpressionType */  ? type.node : type.symbol.declarations[0];
            const links = getNodeLinks(declaration);
            const target = type.objectFlags & 4 /* Reference */  ? links.resolvedType : type.objectFlags & 64 /* Instantiated */  ? type.target : type;
            let typeParameters = links.outerTypeParameters;
            if (!typeParameters) {
                let outerTypeParameters = getOuterTypeParameters(declaration, /*includeThisTypes*/ true);
                if (isJSConstructor(declaration)) {
                    const templateTagParameters = getTypeParametersFromDeclaration(declaration);
                    outerTypeParameters = addRange(outerTypeParameters, templateTagParameters);
                }
                typeParameters = outerTypeParameters || emptyArray;
                const allDeclarations = type.objectFlags & 8388612 /* InstantiationExpressionType */  ? [
                    declaration
                ] : type.symbol.declarations;
                typeParameters = (target.objectFlags & 8388612 /* InstantiationExpressionType */  || target.symbol.flags & 8192 /* Method */  || target.symbol.flags & 2048 /* TypeLiteral */ ) && !target.aliasTypeArguments ? filter(typeParameters, (tp)=>some(allDeclarations, (d)=>isTypeParameterPossiblyReferenced(tp, d))) : typeParameters;
                links.outerTypeParameters = typeParameters;
            }
            if (typeParameters.length) {
                const combinedMapper = combineTypeMappers(type.mapper, mapper);
                const typeArguments = map(typeParameters, (t)=>getMappedType(t, combinedMapper));
                const newAliasSymbol = aliasSymbol || type.aliasSymbol;
                const newAliasTypeArguments = aliasSymbol ? aliasTypeArguments : instantiateTypes(type.aliasTypeArguments, mapper);
                const id = getTypeListId(typeArguments) + getAliasId(newAliasSymbol, newAliasTypeArguments);
                if (!target.instantiations) {
                    target.instantiations = /* @__PURE__ */ new Map();
                    target.instantiations.set(getTypeListId(typeParameters) + getAliasId(target.aliasSymbol, target.aliasTypeArguments), target);
                }
                let result = target.instantiations.get(id);
                if (!result) {
                    const newMapper = createTypeMapper(typeParameters, typeArguments);
                    result = target.objectFlags & 4 /* Reference */  ? createDeferredTypeReference(type.target, type.node, newMapper, newAliasSymbol, newAliasTypeArguments) : target.objectFlags & 32 /* Mapped */  ? instantiateMappedType(target, newMapper, newAliasSymbol, newAliasTypeArguments) : instantiateAnonymousType(target, newMapper, newAliasSymbol, newAliasTypeArguments);
                    if (result.flags & 138117121 /* ObjectFlagsType */  && !(result.objectFlags & 524288 /* CouldContainTypeVariablesComputed */ )) result.objectFlags |= 524288 /* CouldContainTypeVariablesComputed */  | (some(typeArguments, couldContainTypeVariables) ? 1048576 /* CouldContainTypeVariables */  : 0);
                    target.instantiations.set(id, result);
                }
                return result;
            }
            return type;
        }
        function maybeTypeParameterReference(node) {
            return !(node.parent.kind === 182 /* TypeReference */  && node.parent.typeArguments && node === node.parent.typeName || node.parent.kind === 204 /* ImportType */  && node.parent.typeArguments && node === node.parent.qualifier);
        }
        function isTypeParameterPossiblyReferenced(tp, node) {
            if (tp.symbol && tp.symbol.declarations && tp.symbol.declarations.length === 1) {
                const container = tp.symbol.declarations[0].parent;
                for(let n = node; n !== container; n = n.parent){
                    if (!n || n.kind === 240 /* Block */  || n.kind === 193 /* ConditionalType */  && forEachChild(n.extendsType, containsReference)) return true;
                }
                return containsReference(node);
            }
            return true;
            function containsReference(node2) {
                switch(node2.kind){
                    case 196 /* ThisType */ :
                        return !!tp.isThisType;
                    case 80 /* Identifier */ :
                        return !tp.isThisType && isPartOfTypeNode(node2) && maybeTypeParameterReference(node2) && getTypeFromTypeNodeWorker(node2) === tp;
                    case 185 /* TypeQuery */ :
                        const entityName = node2.exprName;
                        const firstIdentifier = getFirstIdentifier(entityName);
                        if (!isThisIdentifier(firstIdentifier)) {
                            const firstIdentifierSymbol = getResolvedSymbol(firstIdentifier);
                            const tpDeclaration = tp.symbol.declarations[0];
                            const tpScope = tpDeclaration.kind === 167 /* TypeParameter */  ? tpDeclaration.parent : // Type parameter is a regular type parameter, e.g. foo<T>
                            tp.isThisType ? tpDeclaration : // Type parameter is the this type, and its declaration is the class declaration.
                            void 0;
                            if (firstIdentifierSymbol.declarations && tpScope) return some(firstIdentifierSymbol.declarations, (idDecl)=>isNodeDescendantOf(idDecl, tpScope)) || some(node2.typeArguments, containsReference);
                        }
                        return true;
                    case 173 /* MethodDeclaration */ :
                    case 172 /* MethodSignature */ :
                        return !node2.type && !!node2.body || some(node2.typeParameters, containsReference) || some(node2.parameters, containsReference) || !!node2.type && containsReference(node2.type);
                }
                return !!forEachChild(node2, containsReference);
            }
        }
        function getHomomorphicTypeVariable(type) {
            const constraintType = getConstraintTypeFromMappedType(type);
            if (constraintType.flags & 4194304 /* Index */ ) {
                const typeVariable = getActualTypeVariable(constraintType.type);
                if (typeVariable.flags & 262144 /* TypeParameter */ ) return typeVariable;
            }
            return void 0;
        }
        function instantiateMappedType(type, mapper, aliasSymbol, aliasTypeArguments) {
            const typeVariable = getHomomorphicTypeVariable(type);
            if (typeVariable) {
                const mappedTypeVariable = instantiateType(typeVariable, mapper);
                if (typeVariable !== mappedTypeVariable) return mapTypeWithAlias(getReducedType(mappedTypeVariable), (t)=>{
                    if (t.flags & 61603843 /* Intersection */  && t !== wildcardType && !isErrorType(t)) {
                        if (!type.declaration.nameType) {
                            let constraint;
                            if (isArrayType(t) || t.flags & 1 /* Any */  && findResolutionCycleStartIndex(typeVariable, 4 /* ImmediateBaseConstraint */ ) < 0 && (constraint = getConstraintOfTypeParameter(typeVariable)) && everyType(constraint, isArrayOrTupleType)) return instantiateMappedArrayType(t, type, prependTypeMapping(typeVariable, t, mapper));
                            if (isGenericTupleType(t)) return instantiateMappedGenericTupleType(t, type, typeVariable, mapper);
                            if (isTupleType(t)) return instantiateMappedTupleType(t, type, prependTypeMapping(typeVariable, t, mapper));
                        }
                        return instantiateAnonymousType(type, prependTypeMapping(typeVariable, t, mapper));
                    }
                    return t;
                }, aliasSymbol, aliasTypeArguments);
            }
            return instantiateType(getConstraintTypeFromMappedType(type), mapper) === wildcardType ? wildcardType : instantiateAnonymousType(type, mapper, aliasSymbol, aliasTypeArguments);
        }
        function getModifiedReadonlyState(state, modifiers) {
            return modifiers & 1 /* IncludeReadonly */  ? true : modifiers & 2 /* ExcludeReadonly */  ? false : state;
        }
        function instantiateMappedGenericTupleType(tupleType, mappedType, typeVariable, mapper) {
            const elementFlags = tupleType.target.elementFlags;
            const elementTypes = map(getElementTypes(tupleType), (t, i)=>{
                const singleton = elementFlags[i] & 8 /* Variadic */  ? t : elementFlags[i] & 4 /* Rest */  ? createArrayType(t) : createTupleType([
                    t
                ], [
                    elementFlags[i]
                ]);
                return instantiateMappedType(mappedType, prependTypeMapping(typeVariable, singleton, mapper));
            });
            const newReadonly = getModifiedReadonlyState(tupleType.target.readonly, getMappedTypeModifiers(mappedType));
            return createTupleType(elementTypes, map(elementTypes, (_)=>8 /* Variadic */ ), newReadonly);
        }
        function instantiateMappedArrayType(arrayType, mappedType, mapper) {
            const elementType = instantiateMappedTypeTemplate(mappedType, numberType, /*isOptional*/ true, mapper);
            return isErrorType(elementType) ? errorType : createArrayType(elementType, getModifiedReadonlyState(isReadonlyArrayType(arrayType), getMappedTypeModifiers(mappedType)));
        }
        function instantiateMappedTupleType(tupleType, mappedType, mapper) {
            const elementFlags = tupleType.target.elementFlags;
            const elementTypes = map(getElementTypes(tupleType), (_, i)=>instantiateMappedTypeTemplate(mappedType, getStringLiteralType("" + i), !!(elementFlags[i] & 2 /* Optional */ ), mapper));
            const modifiers = getMappedTypeModifiers(mappedType);
            const newTupleModifiers = modifiers & 4 /* IncludeOptional */  ? map(elementFlags, (f)=>f & 1 /* Required */  ? 2 /* Optional */  : f) : modifiers & 8 /* ExcludeOptional */  ? map(elementFlags, (f)=>f & 2 /* Optional */  ? 1 /* Required */  : f) : elementFlags;
            const newReadonly = getModifiedReadonlyState(tupleType.target.readonly, modifiers);
            return contains(elementTypes, errorType) ? errorType : createTupleType(elementTypes, newTupleModifiers, newReadonly, tupleType.target.labeledElementDeclarations);
        }
        function instantiateMappedTypeTemplate(type, key, isOptional, mapper) {
            const templateMapper = appendTypeMapping(mapper, getTypeParameterFromMappedType(type), key);
            const propType = instantiateType(getTemplateTypeFromMappedType(type.target || type), templateMapper);
            const modifiers = getMappedTypeModifiers(type);
            return strictNullChecks && modifiers & 4 /* IncludeOptional */  && !maybeTypeOfKind(propType, 49152 /* Void */ ) ? getOptionalType(propType, /*isProperty*/ true) : strictNullChecks && modifiers & 8 /* ExcludeOptional */  && isOptional ? getTypeWithFacts(propType, 524288 /* NEUndefined */ ) : propType;
        }
        function instantiateAnonymousType(type, mapper, aliasSymbol, aliasTypeArguments) {
            const result = createObjectType(type.objectFlags & -1572865 | 64 /* Instantiated */ , type.symbol);
            if (type.objectFlags & 32 /* Mapped */ ) {
                result.declaration = type.declaration;
                const origTypeParameter = getTypeParameterFromMappedType(type);
                const freshTypeParameter = cloneTypeParameter(origTypeParameter);
                result.typeParameter = freshTypeParameter;
                mapper = combineTypeMappers(makeUnaryTypeMapper(origTypeParameter, freshTypeParameter), mapper);
                freshTypeParameter.mapper = mapper;
            }
            if (type.objectFlags & 8388608 /* InstantiationExpressionType */ ) result.node = type.node;
            result.target = type;
            result.mapper = mapper;
            result.aliasSymbol = aliasSymbol || type.aliasSymbol;
            result.aliasTypeArguments = aliasSymbol ? aliasTypeArguments : instantiateTypes(type.aliasTypeArguments, mapper);
            result.objectFlags |= result.aliasTypeArguments ? getPropagatingFlagsOfTypes(result.aliasTypeArguments) : 0;
            return result;
        }
        function getConditionalTypeInstantiation(type, mapper, aliasSymbol, aliasTypeArguments) {
            const root = type.root;
            if (root.outerTypeParameters) {
                const typeArguments = map(root.outerTypeParameters, (t)=>getMappedType(t, mapper));
                const id = getTypeListId(typeArguments) + getAliasId(aliasSymbol, aliasTypeArguments);
                let result = root.instantiations.get(id);
                if (!result) {
                    const newMapper = createTypeMapper(root.outerTypeParameters, typeArguments);
                    const checkType = root.checkType;
                    const distributionType = root.isDistributive ? getMappedType(checkType, newMapper) : void 0;
                    result = distributionType && checkType !== distributionType && distributionType.flags & 1179648 /* Never */  ? mapTypeWithAlias(getReducedType(distributionType), (t)=>getConditionalType(root, prependTypeMapping(checkType, t, newMapper)), aliasSymbol, aliasTypeArguments) : getConditionalType(root, newMapper, aliasSymbol, aliasTypeArguments);
                    root.instantiations.set(id, result);
                }
                return result;
            }
            return type;
        }
        function instantiateType(type, mapper) {
            return type && mapper ? instantiateTypeWithAlias(type, mapper, /*aliasSymbol*/ void 0, /*aliasTypeArguments*/ void 0) : type;
        }
        function instantiateTypeWithAlias(type, mapper, aliasSymbol, aliasTypeArguments) {
            var _a;
            if (!couldContainTypeVariables(type)) return type;
            if (instantiationDepth === 100 || instantiationCount >= 5e6) {
                (_a = tracing) == null || _a.instant(tracing.Phase.CheckTypes, "instantiateType_DepthLimit", {
                    typeId: type.id,
                    instantiationDepth: instantiationDepth,
                    instantiationCount: instantiationCount
                });
                error(currentNode, Diagnostics.Type_instantiation_is_excessively_deep_and_possibly_infinite);
                return errorType;
            }
            totalInstantiationCount++;
            instantiationCount++;
            instantiationDepth++;
            const result = instantiateTypeWorker(type, mapper, aliasSymbol, aliasTypeArguments);
            instantiationDepth--;
            return result;
        }
        function instantiateTypeWorker(type, mapper, aliasSymbol, aliasTypeArguments) {
            const flags = type.flags;
            if (flags & 262144 /* TypeParameter */ ) return getMappedType(type, mapper);
            if (flags & 524288 /* Object */ ) {
                const objectFlags = type.objectFlags;
                if (objectFlags & 52 /* Mapped */ ) {
                    if (objectFlags & 4 /* Reference */  && !type.node) {
                        const resolvedTypeArguments = type.resolvedTypeArguments;
                        const newTypeArguments = instantiateTypes(resolvedTypeArguments, mapper);
                        return newTypeArguments !== resolvedTypeArguments ? createNormalizedTypeReference(type.target, newTypeArguments) : type;
                    }
                    if (objectFlags & 1024 /* ReverseMapped */ ) return instantiateReverseMappedType(type, mapper);
                    return getObjectTypeInstantiation(type, mapper, aliasSymbol, aliasTypeArguments);
                }
                return type;
            }
            if (flags & 3145728 /* UnionOrIntersection */ ) {
                const origin = type.flags & 1048576 /* Union */  ? type.origin : void 0;
                const types = origin && origin.flags & 3145728 /* UnionOrIntersection */  ? origin.types : type.types;
                const newTypes = instantiateTypes(types, mapper);
                if (newTypes === types && aliasSymbol === type.aliasSymbol) return type;
                const newAliasSymbol = aliasSymbol || type.aliasSymbol;
                const newAliasTypeArguments = aliasSymbol ? aliasTypeArguments : instantiateTypes(type.aliasTypeArguments, mapper);
                return flags & 2097152 /* Intersection */  || origin && origin.flags & 2097152 /* Intersection */  ? getIntersectionType(newTypes, newAliasSymbol, newAliasTypeArguments) : getUnionType(newTypes, 1 /* Literal */ , newAliasSymbol, newAliasTypeArguments);
            }
            if (flags & 4194304 /* Index */ ) return getIndexType(instantiateType(type.type, mapper));
            if (flags & 134217728 /* TemplateLiteral */ ) return getTemplateLiteralType(type.texts, instantiateTypes(type.types, mapper));
            if (flags & 268435456 /* StringMapping */ ) return getStringMappingType(type.symbol, instantiateType(type.type, mapper));
            if (flags & 8388608 /* IndexedAccess */ ) {
                const newAliasSymbol = aliasSymbol || type.aliasSymbol;
                const newAliasTypeArguments = aliasSymbol ? aliasTypeArguments : instantiateTypes(type.aliasTypeArguments, mapper);
                return getIndexedAccessType(instantiateType(type.objectType, mapper), instantiateType(type.indexType, mapper), type.accessFlags, /*accessNode*/ void 0, newAliasSymbol, newAliasTypeArguments);
            }
            if (flags & 16777216 /* Conditional */ ) return getConditionalTypeInstantiation(type, combineTypeMappers(type.mapper, mapper), aliasSymbol, aliasTypeArguments);
            if (flags & 33554432 /* Substitution */ ) {
                const newBaseType = instantiateType(type.baseType, mapper);
                const newConstraint = instantiateType(type.constraint, mapper);
                if (newBaseType.flags & 8650752 /* TypeVariable */  && isGenericType(newConstraint)) return getSubstitutionType(newBaseType, newConstraint);
                if (newConstraint.flags & 3 /* AnyOrUnknown */  || isTypeAssignableTo(getRestrictiveInstantiation(newBaseType), getRestrictiveInstantiation(newConstraint))) return newBaseType;
                return newBaseType.flags & 8650752 /* TypeVariable */  ? getSubstitutionType(newBaseType, newConstraint) : getIntersectionType([
                    newConstraint,
                    newBaseType
                ]);
            }
            return type;
        }
        function instantiateReverseMappedType(type, mapper) {
            const innerMappedType = instantiateType(type.mappedType, mapper);
            if (!(getObjectFlags(innerMappedType) & 32 /* Mapped */ )) return type;
            const innerIndexType = instantiateType(type.constraintType, mapper);
            if (!(innerIndexType.flags & 4194304 /* Index */ )) return type;
            const instantiated = inferTypeForHomomorphicMappedType(instantiateType(type.source, mapper), innerMappedType, innerIndexType);
            if (instantiated) return instantiated;
            return type;
        }
        function getPermissiveInstantiation(type) {
            return type.flags & 402915327 /* Never */  ? type : type.permissiveInstantiation || (type.permissiveInstantiation = instantiateType(type, permissiveMapper));
        }
        function getRestrictiveInstantiation(type) {
            if (type.flags & 402915327 /* Never */ ) return type;
            if (type.restrictiveInstantiation) return type.restrictiveInstantiation;
            type.restrictiveInstantiation = instantiateType(type, restrictiveMapper);
            type.restrictiveInstantiation.restrictiveInstantiation = type.restrictiveInstantiation;
            return type.restrictiveInstantiation;
        }
        function instantiateIndexInfo(info, mapper) {
            return createIndexInfo(info.keyType, instantiateType(info.type, mapper), info.isReadonly, info.declaration);
        }
        function isContextSensitive(node) {
            Debug.assert(node.kind !== 173 /* MethodDeclaration */  || isObjectLiteralMethod(node));
            switch(node.kind){
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                case 173 /* MethodDeclaration */ :
                case 261 /* FunctionDeclaration */ :
                    return isContextSensitiveFunctionLikeDeclaration(node);
                case 209 /* ObjectLiteralExpression */ :
                    return some(node.properties, isContextSensitive);
                case 208 /* ArrayLiteralExpression */ :
                    return some(node.elements, isContextSensitive);
                case 226 /* ConditionalExpression */ :
                    return isContextSensitive(node.whenTrue) || isContextSensitive(node.whenFalse);
                case 225 /* BinaryExpression */ :
                    return (node.operatorToken.kind === 57 /* BarBarToken */  || node.operatorToken.kind === 61 /* QuestionQuestionToken */ ) && (isContextSensitive(node.left) || isContextSensitive(node.right));
                case 302 /* PropertyAssignment */ :
                    return isContextSensitive(node.initializer);
                case 216 /* ParenthesizedExpression */ :
                    return isContextSensitive(node.expression);
                case 291 /* JsxAttributes */ :
                    return some(node.properties, isContextSensitive) || isJsxOpeningElement(node.parent) && some(node.parent.parent.children, isContextSensitive);
                case 290 /* JsxAttribute */ :
                    {
                        const { initializer: initializer  } = node;
                        return !!initializer && isContextSensitive(initializer);
                    }
                case 293 /* JsxExpression */ :
                    {
                        const { expression: expression  } = node;
                        return !!expression && isContextSensitive(expression);
                    }
            }
            return false;
        }
        function isContextSensitiveFunctionLikeDeclaration(node) {
            return hasContextSensitiveParameters(node) || hasContextSensitiveReturnExpression(node);
        }
        function hasContextSensitiveReturnExpression(node) {
            if (node.typeParameters || getEffectiveReturnTypeNode(node) || !node.body) return false;
            if (node.body.kind !== 240 /* Block */ ) return isContextSensitive(node.body);
            return !!forEachReturnStatement(node.body, (statement)=>!!statement.expression && isContextSensitive(statement.expression));
        }
        function isContextSensitiveFunctionOrObjectLiteralMethod(func) {
            return (isFunctionExpressionOrArrowFunction(func) || isObjectLiteralMethod(func)) && isContextSensitiveFunctionLikeDeclaration(func);
        }
        function getTypeWithoutSignatures(type) {
            if (type.flags & 524288 /* Object */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                if (resolved.constructSignatures.length || resolved.callSignatures.length) {
                    const result = createObjectType(16 /* Anonymous */ , type.symbol);
                    result.members = resolved.members;
                    result.properties = resolved.properties;
                    result.callSignatures = emptyArray;
                    result.constructSignatures = emptyArray;
                    result.indexInfos = emptyArray;
                    return result;
                }
            } else if (type.flags & 2097152 /* Intersection */ ) return getIntersectionType(map(type.types, getTypeWithoutSignatures));
            return type;
        }
        function isTypeIdenticalTo(source, target) {
            return isTypeRelatedTo(source, target, identityRelation);
        }
        function compareTypesIdentical(source, target) {
            return isTypeRelatedTo(source, target, identityRelation) ? -1 /* True */  : 0 /* False */ ;
        }
        function compareTypesAssignable(source, target) {
            return isTypeRelatedTo(source, target, assignableRelation) ? -1 /* True */  : 0 /* False */ ;
        }
        function compareTypesSubtypeOf(source, target) {
            return isTypeRelatedTo(source, target, subtypeRelation) ? -1 /* True */  : 0 /* False */ ;
        }
        function isTypeSubtypeOf(source, target) {
            return isTypeRelatedTo(source, target, subtypeRelation);
        }
        function isTypeStrictSubtypeOf(source, target) {
            return isTypeRelatedTo(source, target, strictSubtypeRelation);
        }
        function isTypeAssignableTo(source, target) {
            return isTypeRelatedTo(source, target, assignableRelation);
        }
        function isTypeDerivedFrom(source, target) {
            return source.flags & 1048576 /* Union */  ? every(source.types, (t)=>isTypeDerivedFrom(t, target)) : target.flags & 1048576 /* Union */  ? some(target.types, (t)=>isTypeDerivedFrom(source, t)) : source.flags & 2097152 /* Intersection */  ? some(source.types, (t)=>isTypeDerivedFrom(t, target)) : source.flags & 58982400 /* InstantiableNonPrimitive */  ? isTypeDerivedFrom(getBaseConstraintOfType(source) || unknownType, target) : isEmptyAnonymousObjectType(target) ? !!(source.flags & 67633152 /* NonPrimitive */ ) : target === globalObjectType ? !!(source.flags & 67633152 /* NonPrimitive */ ) && !isEmptyAnonymousObjectType(source) : target === globalFunctionType ? !!(source.flags & 524288 /* Object */ ) && isFunctionObjectType(source) : hasBaseType(source, getTargetType(target)) || isArrayType(target) && !isReadonlyArrayType(target) && isTypeDerivedFrom(source, globalReadonlyArrayType);
        }
        function isTypeComparableTo(source, target) {
            return isTypeRelatedTo(source, target, comparableRelation);
        }
        function areTypesComparable(type1, type2) {
            return isTypeComparableTo(type1, type2) || isTypeComparableTo(type2, type1);
        }
        function checkTypeAssignableTo(source, target, errorNode, headMessage, containingMessageChain, errorOutputObject) {
            return checkTypeRelatedTo(source, target, assignableRelation, errorNode, headMessage, containingMessageChain, errorOutputObject);
        }
        function checkTypeAssignableToAndOptionallyElaborate(source, target, errorNode, expr, headMessage, containingMessageChain) {
            return checkTypeRelatedToAndOptionallyElaborate(source, target, assignableRelation, errorNode, expr, headMessage, containingMessageChain, /*errorOutputContainer*/ void 0);
        }
        function checkTypeRelatedToAndOptionallyElaborate(source, target, relation, errorNode, expr, headMessage, containingMessageChain, errorOutputContainer) {
            if (isTypeRelatedTo(source, target, relation)) return true;
            if (!errorNode || !elaborateError(expr, source, target, relation, headMessage, containingMessageChain, errorOutputContainer)) return checkTypeRelatedTo(source, target, relation, errorNode, headMessage, containingMessageChain, errorOutputContainer);
            return false;
        }
        function isOrHasGenericConditional(type) {
            return !!(type.flags & 16777216 /* Conditional */  || type.flags & 2097152 /* Intersection */  && some(type.types, isOrHasGenericConditional));
        }
        function elaborateError(node, source, target, relation, headMessage, containingMessageChain, errorOutputContainer) {
            if (!node || isOrHasGenericConditional(target)) return false;
            if (!checkTypeRelatedTo(source, target, relation, /*errorNode*/ void 0) && elaborateDidYouMeanToCallOrConstruct(node, source, target, relation, headMessage, containingMessageChain, errorOutputContainer)) return true;
            switch(node.kind){
                case 293 /* JsxExpression */ :
                case 216 /* ParenthesizedExpression */ :
                    return elaborateError(node.expression, source, target, relation, headMessage, containingMessageChain, errorOutputContainer);
                case 225 /* BinaryExpression */ :
                    switch(node.operatorToken.kind){
                        case 64 /* EqualsToken */ :
                        case 28 /* CommaToken */ :
                            return elaborateError(node.right, source, target, relation, headMessage, containingMessageChain, errorOutputContainer);
                    }
                    break;
                case 209 /* ObjectLiteralExpression */ :
                    return elaborateObjectLiteral(node, source, target, relation, containingMessageChain, errorOutputContainer);
                case 208 /* ArrayLiteralExpression */ :
                    return elaborateArrayLiteral(node, source, target, relation, containingMessageChain, errorOutputContainer);
                case 291 /* JsxAttributes */ :
                    return elaborateJsxComponents(node, source, target, relation, containingMessageChain, errorOutputContainer);
                case 218 /* ArrowFunction */ :
                    return elaborateArrowFunction(node, source, target, relation, containingMessageChain, errorOutputContainer);
            }
            return false;
        }
        function elaborateDidYouMeanToCallOrConstruct(node, source, target, relation, headMessage, containingMessageChain, errorOutputContainer) {
            const callSignatures = getSignaturesOfType(source, 0 /* Call */ );
            const constructSignatures = getSignaturesOfType(source, 1 /* Construct */ );
            for (const signatures of [
                constructSignatures,
                callSignatures
            ])if (some(signatures, (s)=>{
                const returnType = getReturnTypeOfSignature(s);
                return !(returnType.flags & 131073 /* Never */ ) && checkTypeRelatedTo(returnType, target, relation, /*errorNode*/ void 0);
            })) {
                const resultObj = errorOutputContainer || {};
                checkTypeAssignableTo(source, target, node, headMessage, containingMessageChain, resultObj);
                const diagnostic = resultObj.errors[resultObj.errors.length - 1];
                addRelatedInfo(diagnostic, createDiagnosticForNode(node, signatures === constructSignatures ? Diagnostics.Did_you_mean_to_use_new_with_this_expression : Diagnostics.Did_you_mean_to_call_this_expression));
                return true;
            }
            return false;
        }
        function elaborateArrowFunction(node, source, target, relation, containingMessageChain, errorOutputContainer) {
            if (isBlock(node.body)) return false;
            if (some(node.parameters, hasType)) return false;
            const sourceSig = getSingleCallSignature(source);
            if (!sourceSig) return false;
            const targetSignatures = getSignaturesOfType(target, 0 /* Call */ );
            if (!length(targetSignatures)) return false;
            const returnExpression = node.body;
            const sourceReturn = getReturnTypeOfSignature(sourceSig);
            const targetReturn = getUnionType(map(targetSignatures, getReturnTypeOfSignature));
            if (!checkTypeRelatedTo(sourceReturn, targetReturn, relation, /*errorNode*/ void 0)) {
                const elaborated = returnExpression && elaborateError(returnExpression, sourceReturn, targetReturn, relation, /*headMessage*/ void 0, containingMessageChain, errorOutputContainer);
                if (elaborated) return elaborated;
                const resultObj = errorOutputContainer || {};
                checkTypeRelatedTo(sourceReturn, targetReturn, relation, returnExpression, /*headMessage*/ void 0, containingMessageChain, resultObj);
                if (resultObj.errors) {
                    if (target.symbol && length(target.symbol.declarations)) addRelatedInfo(resultObj.errors[resultObj.errors.length - 1], createDiagnosticForNode(target.symbol.declarations[0], Diagnostics.The_expected_type_comes_from_the_return_type_of_this_signature));
                    if ((getFunctionFlags(node) & 2 /* Async */ ) === 0 && !getTypeOfPropertyOfType(sourceReturn, "then") && checkTypeRelatedTo(createPromiseType(sourceReturn), targetReturn, relation, /*errorNode*/ void 0)) addRelatedInfo(resultObj.errors[resultObj.errors.length - 1], createDiagnosticForNode(node, Diagnostics.Did_you_mean_to_mark_this_function_as_async));
                    return true;
                }
            }
            return false;
        }
        function getBestMatchIndexedAccessTypeOrUndefined(source, target, nameType) {
            const idx = getIndexedAccessTypeOrUndefined(target, nameType);
            if (idx) return idx;
            if (target.flags & 1048576 /* Union */ ) {
                const best = getBestMatchingType(source, target);
                if (best) return getIndexedAccessTypeOrUndefined(best, nameType);
            }
        }
        function checkExpressionForMutableLocationWithContextualType(next, sourcePropType) {
            pushContextualType(next, sourcePropType, /*isCache*/ false);
            const result = checkExpressionForMutableLocation(next, 1 /* Contextual */ );
            popContextualType();
            return result;
        }
        function elaborateElementwise(iterator, source, target, relation, containingMessageChain, errorOutputContainer) {
            let reportedError = false;
            for (const value1 of iterator){
                const { errorNode: prop , innerExpression: next , nameType: nameType , errorMessage: errorMessage  } = value1;
                let targetPropType = getBestMatchIndexedAccessTypeOrUndefined(source, target, nameType);
                if (!targetPropType || targetPropType.flags & 8388608 /* IndexedAccess */ ) continue;
                let sourcePropType = getIndexedAccessTypeOrUndefined(source, nameType);
                if (!sourcePropType) continue;
                const propName = getPropertyNameFromIndex(nameType, /*accessNode*/ void 0);
                if (!checkTypeRelatedTo(sourcePropType, targetPropType, relation, /*errorNode*/ void 0)) {
                    const elaborated = next && elaborateError(next, sourcePropType, targetPropType, relation, /*headMessage*/ void 0, containingMessageChain, errorOutputContainer);
                    reportedError = true;
                    if (!elaborated) {
                        const resultObj = errorOutputContainer || {};
                        const specificSource = next ? checkExpressionForMutableLocationWithContextualType(next, sourcePropType) : sourcePropType;
                        if (exactOptionalPropertyTypes && isExactOptionalPropertyMismatch(specificSource, targetPropType)) {
                            const diag2 = createDiagnosticForNode(prop, Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_type_of_the_target, typeToString(specificSource), typeToString(targetPropType));
                            diagnostics.add(diag2);
                            resultObj.errors = [
                                diag2
                            ];
                        } else {
                            const targetIsOptional = !!(propName && (getPropertyOfType(target, propName) || unknownSymbol).flags & 16777216 /* Optional */ );
                            const sourceIsOptional = !!(propName && (getPropertyOfType(source, propName) || unknownSymbol).flags & 16777216 /* Optional */ );
                            targetPropType = removeMissingType(targetPropType, targetIsOptional);
                            sourcePropType = removeMissingType(sourcePropType, targetIsOptional && sourceIsOptional);
                            const result = checkTypeRelatedTo(specificSource, targetPropType, relation, prop, errorMessage, containingMessageChain, resultObj);
                            if (result && specificSource !== sourcePropType) checkTypeRelatedTo(sourcePropType, targetPropType, relation, prop, errorMessage, containingMessageChain, resultObj);
                        }
                        if (resultObj.errors) {
                            const reportedDiag = resultObj.errors[resultObj.errors.length - 1];
                            const propertyName = isTypeUsableAsPropertyName(nameType) ? getPropertyNameFromType(nameType) : void 0;
                            const targetProp = propertyName !== void 0 ? getPropertyOfType(target, propertyName) : void 0;
                            let issuedElaboration = false;
                            if (!targetProp) {
                                const indexInfo = getApplicableIndexInfo(target, nameType);
                                if (indexInfo && indexInfo.declaration && !getSourceFileOfNode(indexInfo.declaration).hasNoDefaultLib) {
                                    issuedElaboration = true;
                                    addRelatedInfo(reportedDiag, createDiagnosticForNode(indexInfo.declaration, Diagnostics.The_expected_type_comes_from_this_index_signature));
                                }
                            }
                            if (!issuedElaboration && (targetProp && length(targetProp.declarations) || target.symbol && length(target.symbol.declarations))) {
                                const targetNode = targetProp && length(targetProp.declarations) ? targetProp.declarations[0] : target.symbol.declarations[0];
                                if (!getSourceFileOfNode(targetNode).hasNoDefaultLib) addRelatedInfo(reportedDiag, createDiagnosticForNode(targetNode, Diagnostics.The_expected_type_comes_from_property_0_which_is_declared_here_on_type_1, propertyName && !(nameType.flags & 8192 /* UniqueESSymbol */ ) ? unescapeLeadingUnderscores(propertyName) : typeToString(nameType), typeToString(target)));
                            }
                        }
                    }
                }
            }
            return reportedError;
        }
        function elaborateIterableOrArrayLikeTargetElementwise(iterator, source, target, relation, containingMessageChain, errorOutputContainer) {
            const tupleOrArrayLikeTargetParts = filterType(target, isArrayOrTupleLikeType);
            const nonTupleOrArrayLikeTargetParts = filterType(target, (t)=>!isArrayOrTupleLikeType(t));
            const iterationType = nonTupleOrArrayLikeTargetParts !== neverType ? getIterationTypeOfIterable(13 /* ForOf */ , 0 /* Yield */ , nonTupleOrArrayLikeTargetParts, /*errorNode*/ void 0) : void 0;
            let reportedError = false;
            for(let status = iterator.next(); !status.done; status = iterator.next()){
                const { errorNode: prop , innerExpression: next , nameType: nameType , errorMessage: errorMessage  } = status.value;
                let targetPropType = iterationType;
                const targetIndexedPropType = tupleOrArrayLikeTargetParts !== neverType ? getBestMatchIndexedAccessTypeOrUndefined(source, tupleOrArrayLikeTargetParts, nameType) : void 0;
                if (targetIndexedPropType && !(targetIndexedPropType.flags & 8388608 /* IndexedAccess */ )) targetPropType = iterationType ? getUnionType([
                    iterationType,
                    targetIndexedPropType
                ]) : targetIndexedPropType;
                if (!targetPropType) continue;
                let sourcePropType = getIndexedAccessTypeOrUndefined(source, nameType);
                if (!sourcePropType) continue;
                const propName = getPropertyNameFromIndex(nameType, /*accessNode*/ void 0);
                if (!checkTypeRelatedTo(sourcePropType, targetPropType, relation, /*errorNode*/ void 0)) {
                    const elaborated = next && elaborateError(next, sourcePropType, targetPropType, relation, /*headMessage*/ void 0, containingMessageChain, errorOutputContainer);
                    reportedError = true;
                    if (!elaborated) {
                        const resultObj = errorOutputContainer || {};
                        const specificSource = next ? checkExpressionForMutableLocationWithContextualType(next, sourcePropType) : sourcePropType;
                        if (exactOptionalPropertyTypes && isExactOptionalPropertyMismatch(specificSource, targetPropType)) {
                            const diag2 = createDiagnosticForNode(prop, Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_type_of_the_target, typeToString(specificSource), typeToString(targetPropType));
                            diagnostics.add(diag2);
                            resultObj.errors = [
                                diag2
                            ];
                        } else {
                            const targetIsOptional = !!(propName && (getPropertyOfType(tupleOrArrayLikeTargetParts, propName) || unknownSymbol).flags & 16777216 /* Optional */ );
                            const sourceIsOptional = !!(propName && (getPropertyOfType(source, propName) || unknownSymbol).flags & 16777216 /* Optional */ );
                            targetPropType = removeMissingType(targetPropType, targetIsOptional);
                            sourcePropType = removeMissingType(sourcePropType, targetIsOptional && sourceIsOptional);
                            const result = checkTypeRelatedTo(specificSource, targetPropType, relation, prop, errorMessage, containingMessageChain, resultObj);
                            if (result && specificSource !== sourcePropType) checkTypeRelatedTo(sourcePropType, targetPropType, relation, prop, errorMessage, containingMessageChain, resultObj);
                        }
                    }
                }
            }
            return reportedError;
        }
        function* generateJsxAttributes(node) {
            if (!length(node.properties)) return;
            for (const prop of node.properties){
                if (isJsxSpreadAttribute(prop) || isHyphenatedJsxName(getTextOfJsxAttributeName(prop.name))) continue;
                yield {
                    errorNode: prop.name,
                    innerExpression: prop.initializer,
                    nameType: getStringLiteralType(getTextOfJsxAttributeName(prop.name))
                };
            }
        }
        function* generateJsxChildren(node, getInvalidTextDiagnostic) {
            if (!length(node.children)) return;
            let memberOffset = 0;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                const nameType = getNumberLiteralType(i - memberOffset);
                const elem = getElaborationElementForJsxChild(child, nameType, getInvalidTextDiagnostic);
                if (elem) yield elem;
                else memberOffset++;
            }
        }
        function getElaborationElementForJsxChild(child, nameType, getInvalidTextDiagnostic) {
            switch(child.kind){
                case 293 /* JsxExpression */ :
                    return {
                        errorNode: child,
                        innerExpression: child.expression,
                        nameType: nameType
                    };
                case 12 /* JsxText */ :
                    if (child.containsOnlyTriviaWhiteSpaces) break;
                    return {
                        errorNode: child,
                        innerExpression: void 0,
                        nameType: nameType,
                        errorMessage: getInvalidTextDiagnostic()
                    };
                case 283 /* JsxElement */ :
                case 284 /* JsxSelfClosingElement */ :
                case 287 /* JsxFragment */ :
                    return {
                        errorNode: child,
                        innerExpression: child,
                        nameType: nameType
                    };
                default:
                    return Debug.assertNever(child, "Found invalid jsx child");
            }
        }
        function elaborateJsxComponents(node, source, target, relation, containingMessageChain, errorOutputContainer) {
            let result = elaborateElementwise(generateJsxAttributes(node), source, target, relation, containingMessageChain, errorOutputContainer);
            let invalidTextDiagnostic;
            if (isJsxOpeningElement(node.parent) && isJsxElement(node.parent.parent)) {
                const containingElement = node.parent.parent;
                const childPropName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(node));
                const childrenPropName = childPropName === void 0 ? "children" : unescapeLeadingUnderscores(childPropName);
                const childrenNameType = getStringLiteralType(childrenPropName);
                const childrenTargetType = getIndexedAccessType(target, childrenNameType);
                const validChildren = getSemanticJsxChildren(containingElement.children);
                if (!length(validChildren)) return result;
                const moreThanOneRealChildren = length(validChildren) > 1;
                let arrayLikeTargetParts;
                let nonArrayLikeTargetParts;
                const iterableType = getGlobalIterableType(/*reportErrors*/ false);
                if (iterableType !== emptyGenericType) {
                    const anyIterable = createIterableType(anyType);
                    arrayLikeTargetParts = filterType(childrenTargetType, (t)=>isTypeAssignableTo(t, anyIterable));
                    nonArrayLikeTargetParts = filterType(childrenTargetType, (t)=>!isTypeAssignableTo(t, anyIterable));
                } else {
                    arrayLikeTargetParts = filterType(childrenTargetType, isArrayOrTupleLikeType);
                    nonArrayLikeTargetParts = filterType(childrenTargetType, (t)=>!isArrayOrTupleLikeType(t));
                }
                if (moreThanOneRealChildren) {
                    if (arrayLikeTargetParts !== neverType) {
                        const realSource = createTupleType(checkJsxChildren(containingElement, 0 /* Normal */ ));
                        const children = generateJsxChildren(containingElement, getInvalidTextualChildDiagnostic);
                        result = elaborateIterableOrArrayLikeTargetElementwise(children, realSource, arrayLikeTargetParts, relation, containingMessageChain, errorOutputContainer) || result;
                    } else if (!isTypeRelatedTo(getIndexedAccessType(source, childrenNameType), childrenTargetType, relation)) {
                        result = true;
                        const diag2 = error(containingElement.openingElement.tagName, Diagnostics.This_JSX_tag_s_0_prop_expects_a_single_child_of_type_1_but_multiple_children_were_provided, childrenPropName, typeToString(childrenTargetType));
                        if (errorOutputContainer && errorOutputContainer.skipLogging) (errorOutputContainer.errors || (errorOutputContainer.errors = [])).push(diag2);
                    }
                } else {
                    if (nonArrayLikeTargetParts !== neverType) {
                        const child = validChildren[0];
                        const elem = getElaborationElementForJsxChild(child, childrenNameType, getInvalidTextualChildDiagnostic);
                        if (elem) result = elaborateElementwise(function*() {
                            yield elem;
                        }(), source, target, relation, containingMessageChain, errorOutputContainer) || result;
                    } else if (!isTypeRelatedTo(getIndexedAccessType(source, childrenNameType), childrenTargetType, relation)) {
                        result = true;
                        const diag2 = error(containingElement.openingElement.tagName, Diagnostics.This_JSX_tag_s_0_prop_expects_type_1_which_requires_multiple_children_but_only_a_single_child_was_provided, childrenPropName, typeToString(childrenTargetType));
                        if (errorOutputContainer && errorOutputContainer.skipLogging) (errorOutputContainer.errors || (errorOutputContainer.errors = [])).push(diag2);
                    }
                }
            }
            return result;
            function getInvalidTextualChildDiagnostic() {
                if (!invalidTextDiagnostic) {
                    const tagNameText = getTextOfNode(node.parent.tagName);
                    const childPropName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(node));
                    const childrenPropName = childPropName === void 0 ? "children" : unescapeLeadingUnderscores(childPropName);
                    const childrenTargetType = getIndexedAccessType(target, getStringLiteralType(childrenPropName));
                    const diagnostic = Diagnostics._0_components_don_t_accept_text_as_child_elements_Text_in_JSX_has_the_type_string_but_the_expected_type_of_1_is_2;
                    invalidTextDiagnostic = {
                        ...diagnostic,
                        key: "!!ALREADY FORMATTED!!",
                        message: formatMessage(/*dummy*/ void 0, diagnostic, tagNameText, childrenPropName, typeToString(childrenTargetType))
                    };
                }
                return invalidTextDiagnostic;
            }
        }
        function* generateLimitedTupleElements(node, target) {
            const len = length(node.elements);
            if (!len) return;
            for(let i = 0; i < len; i++){
                if (isTupleLikeType(target) && !getPropertyOfType(target, "" + i)) continue;
                const elem = node.elements[i];
                if (isOmittedExpression(elem)) continue;
                const nameType = getNumberLiteralType(i);
                yield {
                    errorNode: elem,
                    innerExpression: elem,
                    nameType: nameType
                };
            }
        }
        function elaborateArrayLiteral(node, source, target, relation, containingMessageChain, errorOutputContainer) {
            if (target.flags & 402915324 /* Never */ ) return false;
            if (isTupleLikeType(source)) return elaborateElementwise(generateLimitedTupleElements(node, target), source, target, relation, containingMessageChain, errorOutputContainer);
            pushContextualType(node, target, /*isCache*/ false);
            const tupleizedType = checkArrayLiteral(node, 1 /* Contextual */ , /*forceTuple*/ true);
            popContextualType();
            if (isTupleLikeType(tupleizedType)) return elaborateElementwise(generateLimitedTupleElements(node, target), tupleizedType, target, relation, containingMessageChain, errorOutputContainer);
            return false;
        }
        function* generateObjectLiteralElements(node) {
            if (!length(node.properties)) return;
            for (const prop of node.properties){
                if (isSpreadAssignment(prop)) continue;
                const type = getLiteralTypeFromProperty(getSymbolOfDeclaration(prop), 8576 /* StringOrNumberLiteralOrUnique */ );
                if (!type || type.flags & 131072 /* Never */ ) continue;
                switch(prop.kind){
                    case 177 /* SetAccessor */ :
                    case 176 /* GetAccessor */ :
                    case 173 /* MethodDeclaration */ :
                    case 303 /* ShorthandPropertyAssignment */ :
                        yield {
                            errorNode: prop.name,
                            innerExpression: void 0,
                            nameType: type
                        };
                        break;
                    case 302 /* PropertyAssignment */ :
                        yield {
                            errorNode: prop.name,
                            innerExpression: prop.initializer,
                            nameType: type,
                            errorMessage: isComputedNonLiteralName(prop.name) ? Diagnostics.Type_of_computed_property_s_value_is_0_which_is_not_assignable_to_type_1 : void 0
                        };
                        break;
                    default:
                        Debug.assertNever(prop);
                }
            }
        }
        function elaborateObjectLiteral(node, source, target, relation, containingMessageChain, errorOutputContainer) {
            if (target.flags & 402915324 /* Never */ ) return false;
            return elaborateElementwise(generateObjectLiteralElements(node), source, target, relation, containingMessageChain, errorOutputContainer);
        }
        function checkTypeComparableTo(source, target, errorNode, headMessage, containingMessageChain) {
            return checkTypeRelatedTo(source, target, comparableRelation, errorNode, headMessage, containingMessageChain);
        }
        function isSignatureAssignableTo(source, target, ignoreReturnTypes) {
            return compareSignaturesRelated(source, target, ignoreReturnTypes ? 4 /* IgnoreReturnTypes */  : 0 /* None */ , /*reportErrors*/ false, /*errorReporter*/ void 0, /*incompatibleErrorReporter*/ void 0, compareTypesAssignable, /*reportUnreliableMarkers*/ void 0) !== 0 /* False */ ;
        }
        function isTopSignature(s) {
            if (!s.typeParameters && (!s.thisParameter || isTypeAny(getTypeOfParameter(s.thisParameter))) && s.parameters.length === 1 && signatureHasRestParameter(s)) {
                const paramType = getTypeOfParameter(s.parameters[0]);
                const restType = isArrayType(paramType) ? getTypeArguments(paramType)[0] : paramType;
                return !!(restType.flags & 131073 /* Never */  && getReturnTypeOfSignature(s).flags & 3 /* AnyOrUnknown */ );
            }
            return false;
        }
        function compareSignaturesRelated(source, target, checkMode, reportErrors2, errorReporter, incompatibleErrorReporter, compareTypes, reportUnreliableMarkers) {
            if (source === target) return -1 /* True */ ;
            if (!(checkMode & 16 /* StrictTopSignature */  && isTopSignature(source)) && isTopSignature(target)) return -1 /* True */ ;
            if (checkMode & 16 /* StrictTopSignature */  && isTopSignature(source) && !isTopSignature(target)) return 0 /* False */ ;
            const targetCount = getParameterCount(target);
            const sourceHasMoreParameters = !hasEffectiveRestParameter(target) && (checkMode & 8 /* StrictArity */  ? hasEffectiveRestParameter(source) || getParameterCount(source) > targetCount : getMinArgumentCount(source) > targetCount);
            if (sourceHasMoreParameters) {
                if (reportErrors2 && !(checkMode & 8 /* StrictArity */ )) errorReporter(Diagnostics.Target_signature_provides_too_few_arguments_Expected_0_or_more_but_got_1, getMinArgumentCount(source), targetCount);
                return 0 /* False */ ;
            }
            if (source.typeParameters && source.typeParameters !== target.typeParameters) {
                target = getCanonicalSignature(target);
                source = instantiateSignatureInContextOf(source, target, /*inferenceContext*/ void 0, compareTypes);
            }
            const sourceCount = getParameterCount(source);
            const sourceRestType = getNonArrayRestType(source);
            const targetRestType = getNonArrayRestType(target);
            if (sourceRestType || targetRestType) instantiateType(sourceRestType || targetRestType, reportUnreliableMarkers);
            const kind = target.declaration ? target.declaration.kind : 0 /* Unknown */ ;
            const strictVariance = !(checkMode & 3 /* Callback */ ) && strictFunctionTypes && kind !== 173 /* MethodDeclaration */  && kind !== 172 /* MethodSignature */  && kind !== 175 /* Constructor */ ;
            let result = -1 /* True */ ;
            const sourceThisType = getThisTypeOfSignature(source);
            if (sourceThisType && sourceThisType !== voidType) {
                const targetThisType = getThisTypeOfSignature(target);
                if (targetThisType) {
                    const related = !strictVariance && compareTypes(sourceThisType, targetThisType, /*reportErrors*/ false) || compareTypes(targetThisType, sourceThisType, reportErrors2);
                    if (!related) {
                        if (reportErrors2) errorReporter(Diagnostics.The_this_types_of_each_signature_are_incompatible);
                        return 0 /* False */ ;
                    }
                    result &= related;
                }
            }
            const paramCount = sourceRestType || targetRestType ? Math.min(sourceCount, targetCount) : Math.max(sourceCount, targetCount);
            const restIndex = sourceRestType || targetRestType ? paramCount - 1 : -1;
            for(let i = 0; i < paramCount; i++){
                const sourceType = i === restIndex ? getRestTypeAtPosition(source, i) : tryGetTypeAtPosition(source, i);
                const targetType = i === restIndex ? getRestTypeAtPosition(target, i) : tryGetTypeAtPosition(target, i);
                if (sourceType && targetType) {
                    const sourceSig = checkMode & 3 /* Callback */  ? void 0 : getSingleCallSignature(getNonNullableType(sourceType));
                    const targetSig = checkMode & 3 /* Callback */  ? void 0 : getSingleCallSignature(getNonNullableType(targetType));
                    const callbacks = sourceSig && targetSig && !getTypePredicateOfSignature(sourceSig) && !getTypePredicateOfSignature(targetSig) && (getTypeFacts(sourceType) & 50331648 /* IsUndefinedOrNull */ ) === (getTypeFacts(targetType) & 50331648 /* IsUndefinedOrNull */ );
                    let related = callbacks ? compareSignaturesRelated(targetSig, sourceSig, checkMode & 8 /* StrictArity */  | (strictVariance ? 2 /* StrictCallback */  : 1 /* BivariantCallback */ ), reportErrors2, errorReporter, incompatibleErrorReporter, compareTypes, reportUnreliableMarkers) : !(checkMode & 3 /* Callback */ ) && !strictVariance && compareTypes(sourceType, targetType, /*reportErrors*/ false) || compareTypes(targetType, sourceType, reportErrors2);
                    if (related && checkMode & 8 /* StrictArity */  && i >= getMinArgumentCount(source) && i < getMinArgumentCount(target) && compareTypes(sourceType, targetType, /*reportErrors*/ false)) related = 0 /* False */ ;
                    if (!related) {
                        if (reportErrors2) errorReporter(Diagnostics.Types_of_parameters_0_and_1_are_incompatible, unescapeLeadingUnderscores(getParameterNameAtPosition(source, i)), unescapeLeadingUnderscores(getParameterNameAtPosition(target, i)));
                        return 0 /* False */ ;
                    }
                    result &= related;
                }
            }
            if (!(checkMode & 4 /* IgnoreReturnTypes */ )) {
                const targetReturnType = isResolvingReturnTypeOfSignature(target) ? anyType : target.declaration && isJSConstructor(target.declaration) ? getDeclaredTypeOfClassOrInterface(getMergedSymbol(target.declaration.symbol)) : getReturnTypeOfSignature(target);
                if (targetReturnType === voidType || targetReturnType === anyType) return result;
                const sourceReturnType = isResolvingReturnTypeOfSignature(source) ? anyType : source.declaration && isJSConstructor(source.declaration) ? getDeclaredTypeOfClassOrInterface(getMergedSymbol(source.declaration.symbol)) : getReturnTypeOfSignature(source);
                const targetTypePredicate = getTypePredicateOfSignature(target);
                if (targetTypePredicate) {
                    const sourceTypePredicate = getTypePredicateOfSignature(source);
                    if (sourceTypePredicate) result &= compareTypePredicateRelatedTo(sourceTypePredicate, targetTypePredicate, reportErrors2, errorReporter, compareTypes);
                    else if (isIdentifierTypePredicate(targetTypePredicate)) {
                        if (reportErrors2) errorReporter(Diagnostics.Signature_0_must_be_a_type_predicate, signatureToString(source));
                        return 0 /* False */ ;
                    }
                } else {
                    result &= checkMode & 1 /* BivariantCallback */  && compareTypes(targetReturnType, sourceReturnType, /*reportErrors*/ false) || compareTypes(sourceReturnType, targetReturnType, reportErrors2);
                    if (!result && reportErrors2 && incompatibleErrorReporter) incompatibleErrorReporter(sourceReturnType, targetReturnType);
                }
            }
            return result;
        }
        function compareTypePredicateRelatedTo(source, target, reportErrors2, errorReporter, compareTypes) {
            if (source.kind !== target.kind) {
                if (reportErrors2) {
                    errorReporter(Diagnostics.A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard);
                    errorReporter(Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
                }
                return 0 /* False */ ;
            }
            if (source.kind === 1 /* Identifier */  || source.kind === 3 /* AssertsIdentifier */ ) {
                if (source.parameterIndex !== target.parameterIndex) {
                    if (reportErrors2) {
                        errorReporter(Diagnostics.Parameter_0_is_not_in_the_same_position_as_parameter_1, source.parameterName, target.parameterName);
                        errorReporter(Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
                    }
                    return 0 /* False */ ;
                }
            }
            const related = source.type === target.type ? -1 /* True */  : source.type && target.type ? compareTypes(source.type, target.type, reportErrors2) : 0 /* False */ ;
            if (related === 0 /* False */  && reportErrors2) errorReporter(Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
            return related;
        }
        function isImplementationCompatibleWithOverload(implementation, overload) {
            const erasedSource = getErasedSignature(implementation);
            const erasedTarget = getErasedSignature(overload);
            const sourceReturnType = getReturnTypeOfSignature(erasedSource);
            const targetReturnType = getReturnTypeOfSignature(erasedTarget);
            if (targetReturnType === voidType || isTypeRelatedTo(targetReturnType, sourceReturnType, assignableRelation) || isTypeRelatedTo(sourceReturnType, targetReturnType, assignableRelation)) return isSignatureAssignableTo(erasedSource, erasedTarget, /*ignoreReturnTypes*/ true);
            return false;
        }
        function isEmptyResolvedType(t) {
            return t !== anyFunctionType && t.properties.length === 0 && t.callSignatures.length === 0 && t.constructSignatures.length === 0 && t.indexInfos.length === 0;
        }
        function isEmptyObjectType(type) {
            return type.flags & 524288 /* Object */  ? !isGenericMappedType(type) && isEmptyResolvedType(resolveStructuredTypeMembers(type)) : type.flags & 67108864 /* NonPrimitive */  ? true : type.flags & 1048576 /* Union */  ? some(type.types, isEmptyObjectType) : type.flags & 2097152 /* Intersection */  ? every(type.types, isEmptyObjectType) : false;
        }
        function isEmptyAnonymousObjectType(type) {
            return !!(getObjectFlags(type) & 16 /* Anonymous */  && (type.members && isEmptyResolvedType(type) || type.symbol && type.symbol.flags & 2048 /* TypeLiteral */  && getMembersOfSymbol(type.symbol).size === 0));
        }
        function isUnknownLikeUnionType(type) {
            if (strictNullChecks && type.flags & 1048576 /* Union */ ) {
                if (!(type.objectFlags & 33554432 /* IsUnknownLikeUnionComputed */ )) {
                    const types = type.types;
                    type.objectFlags |= 33554432 /* IsUnknownLikeUnionComputed */  | (types.length >= 3 && types[0].flags & 32768 /* Undefined */  && types[1].flags & 65536 /* Null */  && some(types, isEmptyAnonymousObjectType) ? 67108864 /* IsUnknownLikeUnion */  : 0);
                }
                return !!(type.objectFlags & 67108864 /* IsUnknownLikeUnion */ );
            }
            return false;
        }
        function containsUndefinedType(type) {
            return !!((type.flags & 1048576 /* Union */  ? type.types[0] : type).flags & 32768 /* Undefined */ );
        }
        function isStringIndexSignatureOnlyType(type) {
            return type.flags & 524288 /* Object */  && !isGenericMappedType(type) && getPropertiesOfType(type).length === 0 && getIndexInfosOfType(type).length === 1 && !!getIndexInfoOfType(type, stringType) || type.flags & 3145728 /* UnionOrIntersection */  && every(type.types, isStringIndexSignatureOnlyType) || false;
        }
        function isEnumTypeRelatedTo(source, target, errorReporter) {
            const sourceSymbol = source.flags & 8 /* EnumMember */  ? getParentOfSymbol(source) : source;
            const targetSymbol = target.flags & 8 /* EnumMember */  ? getParentOfSymbol(target) : target;
            if (sourceSymbol === targetSymbol) return true;
            if (sourceSymbol.escapedName !== targetSymbol.escapedName || !(sourceSymbol.flags & 256 /* RegularEnum */ ) || !(targetSymbol.flags & 256 /* RegularEnum */ )) return false;
            const id = getSymbolId(sourceSymbol) + "," + getSymbolId(targetSymbol);
            const entry = enumRelation.get(id);
            if (entry !== void 0 && !(!(entry & 4 /* Reported */ ) && entry & 2 /* Failed */  && errorReporter)) return !!(entry & 1 /* Succeeded */ );
            const targetEnumType = getTypeOfSymbol(targetSymbol);
            for (const property of getPropertiesOfType(getTypeOfSymbol(sourceSymbol)))if (property.flags & 8 /* EnumMember */ ) {
                const targetProperty = getPropertyOfType(targetEnumType, property.escapedName);
                if (!targetProperty || !(targetProperty.flags & 8 /* EnumMember */ )) {
                    if (errorReporter) {
                        errorReporter(Diagnostics.Property_0_is_missing_in_type_1, symbolName(property), typeToString(getDeclaredTypeOfSymbol(targetSymbol), /*enclosingDeclaration*/ void 0, 64 /* UseFullyQualifiedType */ ));
                        enumRelation.set(id, 6 /* Reported */ );
                    } else enumRelation.set(id, 2 /* Failed */ );
                    return false;
                }
            }
            enumRelation.set(id, 1 /* Succeeded */ );
            return true;
        }
        function isSimpleTypeRelatedTo(source, target, relation, errorReporter) {
            const s = source.flags;
            const t = target.flags;
            if (t & 1 /* Any */  || s & 131072 /* Never */  || source === wildcardType) return true;
            if (t & 2 /* Unknown */  && !(relation === strictSubtypeRelation && s & 1 /* Any */ )) return true;
            if (t & 131072 /* Never */ ) return false;
            if (s & 402653316 /* StringLike */  && t & 4 /* String */ ) return true;
            if (s & 128 /* StringLiteral */  && s & 1024 /* EnumLiteral */  && t & 128 /* StringLiteral */  && !(t & 1024 /* EnumLiteral */ ) && source.value === target.value) return true;
            if (s & 296 /* NumberLike */  && t & 8 /* Number */ ) return true;
            if (s & 256 /* NumberLiteral */  && s & 1024 /* EnumLiteral */  && t & 256 /* NumberLiteral */  && !(t & 1024 /* EnumLiteral */ ) && source.value === target.value) return true;
            if (s & 2112 /* BigIntLike */  && t & 64 /* BigInt */ ) return true;
            if (s & 528 /* BooleanLike */  && t & 16 /* Boolean */ ) return true;
            if (s & 12288 /* ESSymbolLike */  && t & 4096 /* ESSymbol */ ) return true;
            if (s & 32 /* Enum */  && t & 32 /* Enum */  && source.symbol.escapedName === target.symbol.escapedName && isEnumTypeRelatedTo(source.symbol, target.symbol, errorReporter)) return true;
            if (s & 1024 /* EnumLiteral */  && t & 1024 /* EnumLiteral */ ) {
                if (s & 1048576 /* Union */  && t & 1048576 /* Union */  && isEnumTypeRelatedTo(source.symbol, target.symbol, errorReporter)) return true;
                if (s & 2944 /* Literal */  && t & 2944 /* Literal */  && source.value === target.value && isEnumTypeRelatedTo(source.symbol, target.symbol, errorReporter)) return true;
            }
            if (s & 32768 /* Undefined */  && (!strictNullChecks && !(t & 3145728 /* UnionOrIntersection */ ) || t & 49152 /* Void */ )) return true;
            if (s & 65536 /* Null */  && (!strictNullChecks && !(t & 3145728 /* UnionOrIntersection */ ) || t & 65536 /* Null */ )) return true;
            if (s & 524288 /* Object */  && t & 67108864 /* NonPrimitive */  && !(relation === strictSubtypeRelation && isEmptyAnonymousObjectType(source) && !(getObjectFlags(source) & 8192 /* FreshLiteral */ ))) return true;
            if (relation === assignableRelation || relation === comparableRelation) {
                if (s & 1 /* Any */ ) return true;
                if (s & 8 /* Number */  && (t & 32 /* Enum */  || t & 256 /* NumberLiteral */  && t & 1024 /* EnumLiteral */ )) return true;
                if (s & 256 /* NumberLiteral */  && !(s & 1024 /* EnumLiteral */ ) && (t & 32 /* Enum */  || t & 256 /* NumberLiteral */  && t & 1024 /* EnumLiteral */  && source.value === target.value)) return true;
                if (isUnknownLikeUnionType(target)) return true;
            }
            return false;
        }
        function isTypeRelatedTo(source, target, relation) {
            if (isFreshLiteralType(source)) source = source.regularType;
            if (isFreshLiteralType(target)) target = target.regularType;
            if (source === target) return true;
            if (relation !== identityRelation) {
                if (relation === comparableRelation && !(target.flags & 131072 /* Never */ ) && isSimpleTypeRelatedTo(target, source, relation) || isSimpleTypeRelatedTo(source, target, relation)) return true;
            } else if (!((source.flags | target.flags) & 61865984 /* Substitution */ )) {
                if (source.flags !== target.flags) return false;
                if (source.flags & 67358815 /* Singleton */ ) return true;
            }
            if (source.flags & 524288 /* Object */  && target.flags & 524288 /* Object */ ) {
                const related = relation.get(getRelationKey(source, target, 0 /* None */ , relation, /*ignoreConstraints*/ false));
                if (related !== void 0) return !!(related & 1 /* Succeeded */ );
            }
            if (source.flags & 469499904 /* StructuredOrInstantiable */  || target.flags & 469499904 /* StructuredOrInstantiable */ ) return checkTypeRelatedTo(source, target, relation, /*errorNode*/ void 0);
            return false;
        }
        function isIgnoredJsxProperty(source, sourceProp) {
            return getObjectFlags(source) & 2048 /* JsxAttributes */  && isHyphenatedJsxName(sourceProp.escapedName);
        }
        function getNormalizedType(type, writing) {
            while(true){
                const t = isFreshLiteralType(type) ? type.regularType : isGenericTupleType(type) ? getNormalizedTupleType(type, writing) : getObjectFlags(type) & 4 /* Reference */  ? type.node ? createTypeReference(type.target, getTypeArguments(type)) : getSingleBaseForNonAugmentingSubtype(type) || type : type.flags & 3145728 /* UnionOrIntersection */  ? getNormalizedUnionOrIntersectionType(type, writing) : type.flags & 33554432 /* Substitution */  ? writing ? type.baseType : getSubstitutionIntersection(type) : type.flags & 25165824 /* Simplifiable */  ? getSimplifiedType(type, writing) : type;
                if (t === type) return t;
                type = t;
            }
        }
        function getNormalizedUnionOrIntersectionType(type, writing) {
            const reduced = getReducedType(type);
            if (reduced !== type) return reduced;
            if (type.flags & 2097152 /* Intersection */  && some(type.types, isEmptyAnonymousObjectType)) {
                const normalizedTypes = sameMap(type.types, (t)=>getNormalizedType(t, writing));
                if (normalizedTypes !== type.types) return getIntersectionType(normalizedTypes);
            }
            return type;
        }
        function getNormalizedTupleType(type, writing) {
            const elements = getElementTypes(type);
            const normalizedElements = sameMap(elements, (t)=>t.flags & 25165824 /* Simplifiable */  ? getSimplifiedType(t, writing) : t);
            return elements !== normalizedElements ? createNormalizedTupleType(type.target, normalizedElements) : type;
        }
        function checkTypeRelatedTo(source, target, relation, errorNode, headMessage, containingMessageChain, errorOutputContainer) {
            var _a;
            let errorInfo;
            let relatedInfo;
            let maybeKeys;
            let sourceStack;
            let targetStack;
            let maybeCount = 0;
            let sourceDepth = 0;
            let targetDepth = 0;
            let expandingFlags = 0 /* None */ ;
            let overflow = false;
            let overrideNextErrorInfo = 0;
            let lastSkippedInfo;
            let incompatibleStack;
            Debug.assert(relation !== identityRelation || !errorNode, "no error reporting in identity checking");
            const result = isRelatedTo(source, target, 3 /* Both */ , /*reportErrors*/ !!errorNode, headMessage);
            if (incompatibleStack) reportIncompatibleStack();
            if (overflow) {
                (_a = tracing) == null || _a.instant(tracing.Phase.CheckTypes, "checkTypeRelatedTo_DepthLimit", {
                    sourceId: source.id,
                    targetId: target.id,
                    depth: sourceDepth,
                    targetDepth: targetDepth
                });
                const diag2 = error(errorNode || currentNode, Diagnostics.Excessive_stack_depth_comparing_types_0_and_1, typeToString(source), typeToString(target));
                if (errorOutputContainer) (errorOutputContainer.errors || (errorOutputContainer.errors = [])).push(diag2);
            } else if (errorInfo) {
                if (containingMessageChain) {
                    const chain = containingMessageChain();
                    if (chain) {
                        concatenateDiagnosticMessageChains(chain, errorInfo);
                        errorInfo = chain;
                    }
                }
                let relatedInformation;
                if (headMessage && errorNode && !result && source.symbol) {
                    const links = getSymbolLinks(source.symbol);
                    if (links.originatingImport && !isImportCall(links.originatingImport)) {
                        const helpfulRetry = checkTypeRelatedTo(getTypeOfSymbol(links.target), target, relation, /*errorNode*/ void 0);
                        if (helpfulRetry) {
                            const diag3 = createDiagnosticForNode(links.originatingImport, Diagnostics.Type_originates_at_this_import_A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime_Consider_using_a_default_import_or_import_require_here_instead);
                            relatedInformation = append(relatedInformation, diag3);
                        }
                    }
                }
                const diag2 = createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(errorNode), errorNode, errorInfo, relatedInformation);
                if (relatedInfo) addRelatedInfo(diag2, ...relatedInfo);
                if (errorOutputContainer) (errorOutputContainer.errors || (errorOutputContainer.errors = [])).push(diag2);
                if (!errorOutputContainer || !errorOutputContainer.skipLogging) diagnostics.add(diag2);
            }
            if (errorNode && errorOutputContainer && errorOutputContainer.skipLogging && result === 0 /* False */ ) Debug.assert(!!errorOutputContainer.errors, "missed opportunity to interact with error.");
            return result !== 0 /* False */ ;
            function resetErrorInfo(saved) {
                errorInfo = saved.errorInfo;
                lastSkippedInfo = saved.lastSkippedInfo;
                incompatibleStack = saved.incompatibleStack;
                overrideNextErrorInfo = saved.overrideNextErrorInfo;
                relatedInfo = saved.relatedInfo;
            }
            function captureErrorCalculationState() {
                return {
                    errorInfo: errorInfo,
                    lastSkippedInfo: lastSkippedInfo,
                    incompatibleStack: incompatibleStack == null ? void 0 : incompatibleStack.slice(),
                    overrideNextErrorInfo: overrideNextErrorInfo,
                    relatedInfo: relatedInfo == null ? void 0 : relatedInfo.slice()
                };
            }
            function reportIncompatibleError(message, ...args) {
                overrideNextErrorInfo++;
                lastSkippedInfo = void 0;
                (incompatibleStack || (incompatibleStack = [])).push([
                    message,
                    ...args
                ]);
            }
            function reportIncompatibleStack() {
                const stack = incompatibleStack || [];
                incompatibleStack = void 0;
                const info = lastSkippedInfo;
                lastSkippedInfo = void 0;
                if (stack.length === 1) {
                    reportError(...stack[0]);
                    if (info) reportRelationError(/*message*/ void 0, ...info);
                    return;
                }
                let path = "";
                const secondaryRootErrors = [];
                while(stack.length){
                    const [msg, ...args] = stack.pop();
                    switch(msg.code){
                        case Diagnostics.Types_of_property_0_are_incompatible.code:
                            {
                                if (path.indexOf("new ") === 0) path = `(${path})`;
                                const str = "" + args[0];
                                if (path.length === 0) path = `${str}`;
                                else if (isIdentifierText(str, getEmitScriptTarget(compilerOptions))) path = `${path}.${str}`;
                                else if (str[0] === "[" && str[str.length - 1] === "]") path = `${path}${str}`;
                                else path = `${path}[${str}]`;
                                break;
                            }
                        case Diagnostics.Call_signature_return_types_0_and_1_are_incompatible.code:
                        case Diagnostics.Construct_signature_return_types_0_and_1_are_incompatible.code:
                        case Diagnostics.Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code:
                        case Diagnostics.Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code:
                            if (path.length === 0) {
                                let mappedMsg = msg;
                                if (msg.code === Diagnostics.Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code) mappedMsg = Diagnostics.Call_signature_return_types_0_and_1_are_incompatible;
                                else if (msg.code === Diagnostics.Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code) mappedMsg = Diagnostics.Construct_signature_return_types_0_and_1_are_incompatible;
                                secondaryRootErrors.unshift([
                                    mappedMsg,
                                    args[0],
                                    args[1]
                                ]);
                            } else {
                                const prefix = msg.code === Diagnostics.Construct_signature_return_types_0_and_1_are_incompatible.code || msg.code === Diagnostics.Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code ? "new " : "";
                                const params = msg.code === Diagnostics.Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code || msg.code === Diagnostics.Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code ? "" : "...";
                                path = `${prefix}${path}(${params})`;
                            }
                            break;
                        case Diagnostics.Type_at_position_0_in_source_is_not_compatible_with_type_at_position_1_in_target.code:
                            secondaryRootErrors.unshift([
                                Diagnostics.Type_at_position_0_in_source_is_not_compatible_with_type_at_position_1_in_target,
                                args[0],
                                args[1]
                            ]);
                            break;
                        case Diagnostics.Type_at_positions_0_through_1_in_source_is_not_compatible_with_type_at_position_2_in_target.code:
                            secondaryRootErrors.unshift([
                                Diagnostics.Type_at_positions_0_through_1_in_source_is_not_compatible_with_type_at_position_2_in_target,
                                args[0],
                                args[1],
                                args[2]
                            ]);
                            break;
                        default:
                            return Debug.fail(`Unhandled Diagnostic: ${msg.code}`);
                    }
                }
                if (path) reportError(path[path.length - 1] === ")" ? Diagnostics.The_types_returned_by_0_are_incompatible_between_these_types : Diagnostics.The_types_of_0_are_incompatible_between_these_types, path);
                else secondaryRootErrors.shift();
                for (const [msg, ...args] of secondaryRootErrors){
                    const originalValue = msg.elidedInCompatabilityPyramid;
                    msg.elidedInCompatabilityPyramid = false;
                    reportError(msg, ...args);
                    msg.elidedInCompatabilityPyramid = originalValue;
                }
                if (info) reportRelationError(/*message*/ void 0, ...info);
            }
            function reportError(message, ...args) {
                Debug.assert(!!errorNode);
                if (incompatibleStack) reportIncompatibleStack();
                if (message.elidedInCompatabilityPyramid) return;
                errorInfo = chainDiagnosticMessages(errorInfo, message, ...args);
            }
            function associateRelatedInfo(info) {
                Debug.assert(!!errorInfo);
                if (!relatedInfo) relatedInfo = [
                    info
                ];
                else relatedInfo.push(info);
            }
            function reportRelationError(message, source2, target2) {
                if (incompatibleStack) reportIncompatibleStack();
                const [sourceType, targetType] = getTypeNamesForErrorDisplay(source2, target2);
                let generalizedSource = source2;
                let generalizedSourceType = sourceType;
                if (isLiteralType(source2) && !typeCouldHaveTopLevelSingletonTypes(target2)) {
                    generalizedSource = getBaseTypeOfLiteralType(source2);
                    Debug.assert(!isTypeAssignableTo(generalizedSource, target2), "generalized source shouldn't be assignable");
                    generalizedSourceType = getTypeNameForErrorDisplay(generalizedSource);
                }
                const targetFlags = target2.flags & 8388608 /* IndexedAccess */  && !(source2.flags & 8388608 /* IndexedAccess */ ) ? target2.objectType.flags : target2.flags;
                if (targetFlags & 262144 /* TypeParameter */  && target2 !== markerSuperTypeForCheck && target2 !== markerSubTypeForCheck) {
                    const constraint = getBaseConstraintOfType(target2);
                    let needsOriginalSource;
                    if (constraint && (isTypeAssignableTo(generalizedSource, constraint) || (needsOriginalSource = isTypeAssignableTo(source2, constraint)))) reportError(Diagnostics._0_is_assignable_to_the_constraint_of_type_1_but_1_could_be_instantiated_with_a_different_subtype_of_constraint_2, needsOriginalSource ? sourceType : generalizedSourceType, targetType, typeToString(constraint));
                    else {
                        errorInfo = void 0;
                        reportError(Diagnostics._0_could_be_instantiated_with_an_arbitrary_type_which_could_be_unrelated_to_1, targetType, generalizedSourceType);
                    }
                }
                if (!message) {
                    if (relation === comparableRelation) message = Diagnostics.Type_0_is_not_comparable_to_type_1;
                    else if (sourceType === targetType) message = Diagnostics.Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated;
                    else if (exactOptionalPropertyTypes && getExactOptionalUnassignableProperties(source2, target2).length) message = Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties;
                    else {
                        if (source2.flags & 128 /* StringLiteral */  && target2.flags & 1048576 /* Union */ ) {
                            const suggestedType = getSuggestedTypeForNonexistentStringLiteralType(source2, target2);
                            if (suggestedType) {
                                reportError(Diagnostics.Type_0_is_not_assignable_to_type_1_Did_you_mean_2, generalizedSourceType, targetType, typeToString(suggestedType));
                                return;
                            }
                        }
                        message = Diagnostics.Type_0_is_not_assignable_to_type_1;
                    }
                } else if (message === Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1 && exactOptionalPropertyTypes && getExactOptionalUnassignableProperties(source2, target2).length) message = Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties;
                reportError(message, generalizedSourceType, targetType);
            }
            function tryElaborateErrorsForPrimitivesAndObjects(source2, target2) {
                const sourceType = symbolValueDeclarationIsContextSensitive(source2.symbol) ? typeToString(source2, source2.symbol.valueDeclaration) : typeToString(source2);
                const targetType = symbolValueDeclarationIsContextSensitive(target2.symbol) ? typeToString(target2, target2.symbol.valueDeclaration) : typeToString(target2);
                if (globalStringType === source2 && stringType === target2 || globalNumberType === source2 && numberType === target2 || globalBooleanType === source2 && booleanType === target2 || getGlobalESSymbolType() === source2 && esSymbolType === target2) reportError(Diagnostics._0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible, targetType, sourceType);
            }
            function tryElaborateArrayLikeErrors(source2, target2, reportErrors2) {
                if (isTupleType(source2)) {
                    if (source2.target.readonly && isMutableArrayOrTuple(target2)) {
                        if (reportErrors2) reportError(Diagnostics.The_type_0_is_readonly_and_cannot_be_assigned_to_the_mutable_type_1, typeToString(source2), typeToString(target2));
                        return false;
                    }
                    return isArrayOrTupleType(target2);
                }
                if (isReadonlyArrayType(source2) && isMutableArrayOrTuple(target2)) {
                    if (reportErrors2) reportError(Diagnostics.The_type_0_is_readonly_and_cannot_be_assigned_to_the_mutable_type_1, typeToString(source2), typeToString(target2));
                    return false;
                }
                if (isTupleType(target2)) return isArrayType(source2);
                return true;
            }
            function isRelatedToWorker(source2, target2, reportErrors2) {
                return isRelatedTo(source2, target2, 3 /* Both */ , reportErrors2);
            }
            function isRelatedTo(originalSource, originalTarget, recursionFlags = 3 /* Both */ , reportErrors2 = false, headMessage2, intersectionState = 0 /* None */ ) {
                if (originalSource === originalTarget) return -1 /* True */ ;
                if (originalSource.flags & 524288 /* Object */  && originalTarget.flags & 402784252 /* Primitive */ ) {
                    if (relation === comparableRelation && !(originalTarget.flags & 131072 /* Never */ ) && isSimpleTypeRelatedTo(originalTarget, originalSource, relation) || isSimpleTypeRelatedTo(originalSource, originalTarget, relation, reportErrors2 ? reportError : void 0)) return -1 /* True */ ;
                    if (reportErrors2) reportErrorResults(originalSource, originalTarget, originalSource, originalTarget, headMessage2);
                    return 0 /* False */ ;
                }
                const source2 = getNormalizedType(originalSource, /*writing*/ false);
                let target2 = getNormalizedType(originalTarget, /*writing*/ true);
                if (source2 === target2) return -1 /* True */ ;
                if (relation === identityRelation) {
                    if (source2.flags !== target2.flags) return 0 /* False */ ;
                    if (source2.flags & 67358815 /* Singleton */ ) return -1 /* True */ ;
                    traceUnionsOrIntersectionsTooLarge(source2, target2);
                    return recursiveTypeRelatedTo(source2, target2, /*reportErrors*/ false, 0 /* None */ , recursionFlags);
                }
                if (source2.flags & 262144 /* TypeParameter */  && getConstraintOfType(source2) === target2) return -1 /* True */ ;
                if (source2.flags & 470302716 /* DefinitelyNonNullable */  && target2.flags & 1048576 /* Union */ ) {
                    const types = target2.types;
                    const candidate = types.length === 2 && types[0].flags & 98304 /* Nullable */  ? types[1] : types.length === 3 && types[0].flags & 98304 /* Nullable */  && types[1].flags & 98304 /* Nullable */  ? types[2] : void 0;
                    if (candidate && !(candidate.flags & 98304 /* Nullable */ )) {
                        target2 = getNormalizedType(candidate, /*writing*/ true);
                        if (source2 === target2) return -1 /* True */ ;
                    }
                }
                if (relation === comparableRelation && !(target2.flags & 131072 /* Never */ ) && isSimpleTypeRelatedTo(target2, source2, relation) || isSimpleTypeRelatedTo(source2, target2, relation, reportErrors2 ? reportError : void 0)) return -1 /* True */ ;
                if (source2.flags & 469499904 /* StructuredOrInstantiable */  || target2.flags & 469499904 /* StructuredOrInstantiable */ ) {
                    const isPerformingExcessPropertyChecks = !(intersectionState & 2 /* Target */ ) && isObjectLiteralType2(source2) && getObjectFlags(source2) & 8192 /* FreshLiteral */ ;
                    if (isPerformingExcessPropertyChecks) {
                        if (hasExcessProperties(source2, target2, reportErrors2)) {
                            if (reportErrors2) reportRelationError(headMessage2, source2, originalTarget.aliasSymbol ? originalTarget : target2);
                            return 0 /* False */ ;
                        }
                    }
                    const isPerformingCommonPropertyChecks = (relation !== comparableRelation || isUnitType(source2)) && !(intersectionState & 2 /* Target */ ) && source2.flags & 405405692 /* Intersection */  && source2 !== globalObjectType && target2.flags & 2621440 /* Intersection */  && isWeakType(target2) && (getPropertiesOfType(source2).length > 0 || typeHasCallOrConstructSignatures(source2));
                    const isComparingJsxAttributes = !!(getObjectFlags(source2) & 2048 /* JsxAttributes */ );
                    if (isPerformingCommonPropertyChecks && !hasCommonProperties(source2, target2, isComparingJsxAttributes)) {
                        if (reportErrors2) {
                            const sourceString = typeToString(originalSource.aliasSymbol ? originalSource : source2);
                            const targetString = typeToString(originalTarget.aliasSymbol ? originalTarget : target2);
                            const calls = getSignaturesOfType(source2, 0 /* Call */ );
                            const constructs = getSignaturesOfType(source2, 1 /* Construct */ );
                            if (calls.length > 0 && isRelatedTo(getReturnTypeOfSignature(calls[0]), target2, 1 /* Source */ , /*reportErrors*/ false) || constructs.length > 0 && isRelatedTo(getReturnTypeOfSignature(constructs[0]), target2, 1 /* Source */ , /*reportErrors*/ false)) reportError(Diagnostics.Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it, sourceString, targetString);
                            else reportError(Diagnostics.Type_0_has_no_properties_in_common_with_type_1, sourceString, targetString);
                        }
                        return 0 /* False */ ;
                    }
                    traceUnionsOrIntersectionsTooLarge(source2, target2);
                    const skipCaching = source2.flags & 1048576 /* Union */  && source2.types.length < 4 && !(target2.flags & 1048576 /* Union */ ) || target2.flags & 1048576 /* Union */  && target2.types.length < 4 && !(source2.flags & 469499904 /* StructuredOrInstantiable */ );
                    const result2 = skipCaching ? unionOrIntersectionRelatedTo(source2, target2, reportErrors2, intersectionState) : recursiveTypeRelatedTo(source2, target2, reportErrors2, intersectionState, recursionFlags);
                    if (result2) return result2;
                }
                if (reportErrors2) reportErrorResults(originalSource, originalTarget, source2, target2, headMessage2);
                return 0 /* False */ ;
            }
            function reportErrorResults(originalSource, originalTarget, source2, target2, headMessage2) {
                var _a2, _b;
                const sourceHasBase = !!getSingleBaseForNonAugmentingSubtype(originalSource);
                const targetHasBase = !!getSingleBaseForNonAugmentingSubtype(originalTarget);
                source2 = originalSource.aliasSymbol || sourceHasBase ? originalSource : source2;
                target2 = originalTarget.aliasSymbol || targetHasBase ? originalTarget : target2;
                let maybeSuppress = overrideNextErrorInfo > 0;
                if (maybeSuppress) overrideNextErrorInfo--;
                if (source2.flags & 524288 /* Object */  && target2.flags & 524288 /* Object */ ) {
                    const currentError = errorInfo;
                    tryElaborateArrayLikeErrors(source2, target2, /*reportErrors*/ true);
                    if (errorInfo !== currentError) maybeSuppress = !!errorInfo;
                }
                if (source2.flags & 524288 /* Object */  && target2.flags & 402784252 /* Primitive */ ) tryElaborateErrorsForPrimitivesAndObjects(source2, target2);
                else if (source2.symbol && source2.flags & 524288 /* Object */  && globalObjectType === source2) reportError(Diagnostics.The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead);
                else if (getObjectFlags(source2) & 2048 /* JsxAttributes */  && target2.flags & 2097152 /* Intersection */ ) {
                    const targetTypes = target2.types;
                    const intrinsicAttributes = getJsxType(JsxNames.IntrinsicAttributes, errorNode);
                    const intrinsicClassAttributes = getJsxType(JsxNames.IntrinsicClassAttributes, errorNode);
                    if (!isErrorType(intrinsicAttributes) && !isErrorType(intrinsicClassAttributes) && (contains(targetTypes, intrinsicAttributes) || contains(targetTypes, intrinsicClassAttributes))) return;
                } else errorInfo = elaborateNeverIntersection(errorInfo, originalTarget);
                if (!headMessage2 && maybeSuppress) {
                    lastSkippedInfo = [
                        source2,
                        target2
                    ];
                    return;
                }
                reportRelationError(headMessage2, source2, target2);
                if (source2.flags & 262144 /* TypeParameter */  && ((_b = (_a2 = source2.symbol) == null ? void 0 : _a2.declarations) == null ? void 0 : _b[0]) && !getConstraintOfType(source2)) {
                    const syntheticParam = cloneTypeParameter(source2);
                    syntheticParam.constraint = instantiateType(target2, makeUnaryTypeMapper(source2, syntheticParam));
                    if (hasNonCircularBaseConstraint(syntheticParam)) {
                        const targetConstraintString = typeToString(target2, source2.symbol.declarations[0]);
                        associateRelatedInfo(createDiagnosticForNode(source2.symbol.declarations[0], Diagnostics.This_type_parameter_might_need_an_extends_0_constraint, targetConstraintString));
                    }
                }
            }
            function traceUnionsOrIntersectionsTooLarge(source2, target2) {
                if (!tracing) return;
                if (source2.flags & 3145728 /* UnionOrIntersection */  && target2.flags & 3145728 /* UnionOrIntersection */ ) {
                    const sourceUnionOrIntersection = source2;
                    const targetUnionOrIntersection = target2;
                    if (sourceUnionOrIntersection.objectFlags & targetUnionOrIntersection.objectFlags & 32768 /* PrimitiveUnion */ ) return;
                    const sourceSize = sourceUnionOrIntersection.types.length;
                    const targetSize = targetUnionOrIntersection.types.length;
                    if (sourceSize * targetSize > 1e6) tracing.instant(tracing.Phase.CheckTypes, "traceUnionsOrIntersectionsTooLarge_DepthLimit", {
                        sourceId: source2.id,
                        sourceSize: sourceSize,
                        targetId: target2.id,
                        targetSize: targetSize,
                        pos: errorNode == null ? void 0 : errorNode.pos,
                        end: errorNode == null ? void 0 : errorNode.end
                    });
                }
            }
            function getTypeOfPropertyInTypes(types, name) {
                const appendPropType = (propTypes, type)=>{
                    var _a2;
                    type = getApparentType(type);
                    const prop = type.flags & 3145728 /* UnionOrIntersection */  ? getPropertyOfUnionOrIntersectionType(type, name) : getPropertyOfObjectType(type, name);
                    const propType = prop && getTypeOfSymbol(prop) || ((_a2 = getApplicableIndexInfoForName(type, name)) == null ? void 0 : _a2.type) || undefinedType;
                    return append(propTypes, propType);
                };
                return getUnionType(reduceLeft(types, appendPropType, /*initial*/ void 0) || emptyArray);
            }
            function hasExcessProperties(source2, target2, reportErrors2) {
                var _a2;
                if (!isExcessPropertyCheckTarget(target2) || !noImplicitAny && getObjectFlags(target2) & 4096 /* JSLiteral */ ) return false;
                const isComparingJsxAttributes = !!(getObjectFlags(source2) & 2048 /* JsxAttributes */ );
                if ((relation === assignableRelation || relation === comparableRelation) && (isTypeSubsetOf(globalObjectType, target2) || !isComparingJsxAttributes && isEmptyObjectType(target2))) return false;
                let reducedTarget = target2;
                let checkTypes;
                if (target2.flags & 1048576 /* Union */ ) {
                    reducedTarget = findMatchingDiscriminantType(source2, target2, isRelatedTo) || filterPrimitivesIfContainsNonPrimitive(target2);
                    checkTypes = reducedTarget.flags & 1048576 /* Union */  ? reducedTarget.types : [
                        reducedTarget
                    ];
                }
                for (const prop of getPropertiesOfType(source2))if (shouldCheckAsExcessProperty(prop, source2.symbol) && !isIgnoredJsxProperty(source2, prop)) {
                    if (!isKnownProperty(reducedTarget, prop.escapedName, isComparingJsxAttributes)) {
                        if (reportErrors2) {
                            const errorTarget = filterType(reducedTarget, isExcessPropertyCheckTarget);
                            if (!errorNode) return Debug.fail();
                            if (isJsxAttributes(errorNode) || isJsxOpeningLikeElement(errorNode) || isJsxOpeningLikeElement(errorNode.parent)) {
                                if (prop.valueDeclaration && isJsxAttribute(prop.valueDeclaration) && getSourceFileOfNode(errorNode) === getSourceFileOfNode(prop.valueDeclaration.name)) errorNode = prop.valueDeclaration.name;
                                const propName = symbolToString(prop);
                                const suggestionSymbol = getSuggestedSymbolForNonexistentJSXAttribute(propName, errorTarget);
                                const suggestion = suggestionSymbol ? symbolToString(suggestionSymbol) : void 0;
                                if (suggestion) reportError(Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2, propName, typeToString(errorTarget), suggestion);
                                else reportError(Diagnostics.Property_0_does_not_exist_on_type_1, propName, typeToString(errorTarget));
                            } else {
                                const objectLiteralDeclaration = ((_a2 = source2.symbol) == null ? void 0 : _a2.declarations) && firstOrUndefined(source2.symbol.declarations);
                                let suggestion;
                                if (prop.valueDeclaration && findAncestor(prop.valueDeclaration, (d)=>d === objectLiteralDeclaration) && getSourceFileOfNode(objectLiteralDeclaration) === getSourceFileOfNode(errorNode)) {
                                    const propDeclaration = prop.valueDeclaration;
                                    Debug.assertNode(propDeclaration, isObjectLiteralElementLike);
                                    const name = propDeclaration.name;
                                    errorNode = name;
                                    if (isIdentifier(name)) suggestion = getSuggestionForNonexistentProperty(name, errorTarget);
                                }
                                if (suggestion !== void 0) reportError(Diagnostics.Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_write_2, symbolToString(prop), typeToString(errorTarget), suggestion);
                                else reportError(Diagnostics.Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1, symbolToString(prop), typeToString(errorTarget));
                            }
                        }
                        return true;
                    }
                    if (checkTypes && !isRelatedTo(getTypeOfSymbol(prop), getTypeOfPropertyInTypes(checkTypes, prop.escapedName), 3 /* Both */ , reportErrors2)) {
                        if (reportErrors2) reportIncompatibleError(Diagnostics.Types_of_property_0_are_incompatible, symbolToString(prop));
                        return true;
                    }
                }
                return false;
            }
            function shouldCheckAsExcessProperty(prop, container) {
                return prop.valueDeclaration && container.valueDeclaration && prop.valueDeclaration.parent === container.valueDeclaration;
            }
            function unionOrIntersectionRelatedTo(source2, target2, reportErrors2, intersectionState) {
                if (source2.flags & 1048576 /* Union */ ) return relation === comparableRelation ? someTypeRelatedToType(source2, target2, reportErrors2 && !(source2.flags & 402784252 /* Primitive */ ), intersectionState) : eachTypeRelatedToType(source2, target2, reportErrors2 && !(source2.flags & 402784252 /* Primitive */ ), intersectionState);
                if (target2.flags & 1048576 /* Union */ ) return typeRelatedToSomeType(getRegularTypeOfObjectLiteral(source2), target2, reportErrors2 && !(source2.flags & 402784252 /* Primitive */ ) && !(target2.flags & 402784252 /* Primitive */ ));
                if (target2.flags & 2097152 /* Intersection */ ) return typeRelatedToEachType(source2, target2, reportErrors2, 2 /* Target */ );
                if (relation === comparableRelation && target2.flags & 402784252 /* Primitive */ ) {
                    const constraints = sameMap(source2.types, (t)=>t.flags & 465829888 /* Instantiable */  ? getBaseConstraintOfType(t) || unknownType : t);
                    if (constraints !== source2.types) {
                        source2 = getIntersectionType(constraints);
                        if (source2.flags & 131072 /* Never */ ) return 0 /* False */ ;
                        if (!(source2.flags & 2097152 /* Intersection */ )) return isRelatedTo(source2, target2, 1 /* Source */ , /*reportErrors*/ false) || isRelatedTo(target2, source2, 1 /* Source */ , /*reportErrors*/ false);
                    }
                }
                return someTypeRelatedToType(source2, target2, /*reportErrors*/ false, 1 /* Source */ );
            }
            function eachTypeRelatedToSomeType(source2, target2) {
                let result2 = -1 /* True */ ;
                const sourceTypes = source2.types;
                for (const sourceType of sourceTypes){
                    const related = typeRelatedToSomeType(sourceType, target2, /*reportErrors*/ false);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function typeRelatedToSomeType(source2, target2, reportErrors2) {
                const targetTypes = target2.types;
                if (target2.flags & 1048576 /* Union */ ) {
                    if (containsType(targetTypes, source2)) return -1 /* True */ ;
                    if (relation !== comparableRelation && getObjectFlags(target2) & 32768 /* PrimitiveUnion */  && !(source2.flags & 1024 /* EnumLiteral */ ) && (source2.flags & 2688 /* BigIntLiteral */  || (relation === subtypeRelation || relation === strictSubtypeRelation) && source2.flags & 256 /* NumberLiteral */ )) {
                        const alternateForm = source2 === source2.regularType ? source2.freshType : source2.regularType;
                        const primitive = source2.flags & 128 /* StringLiteral */  ? stringType : source2.flags & 256 /* NumberLiteral */  ? numberType : source2.flags & 2048 /* BigIntLiteral */  ? bigintType : void 0;
                        return primitive && containsType(targetTypes, primitive) || alternateForm && containsType(targetTypes, alternateForm) ? -1 /* True */  : 0 /* False */ ;
                    }
                    const match = getMatchingUnionConstituentForType(target2, source2);
                    if (match) {
                        const related = isRelatedTo(source2, match, 2 /* Target */ , /*reportErrors*/ false);
                        if (related) return related;
                    }
                }
                for (const type of targetTypes){
                    const related = isRelatedTo(source2, type, 2 /* Target */ , /*reportErrors*/ false);
                    if (related) return related;
                }
                if (reportErrors2) {
                    const bestMatchingType = getBestMatchingType(source2, target2, isRelatedTo);
                    if (bestMatchingType) isRelatedTo(source2, bestMatchingType, 2 /* Target */ , /*reportErrors*/ true);
                }
                return 0 /* False */ ;
            }
            function typeRelatedToEachType(source2, target2, reportErrors2, intersectionState) {
                let result2 = -1 /* True */ ;
                const targetTypes = target2.types;
                for (const targetType of targetTypes){
                    const related = isRelatedTo(source2, targetType, 2 /* Target */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function someTypeRelatedToType(source2, target2, reportErrors2, intersectionState) {
                const sourceTypes = source2.types;
                if (source2.flags & 1048576 /* Union */  && containsType(sourceTypes, target2)) return -1 /* True */ ;
                const len = sourceTypes.length;
                for(let i = 0; i < len; i++){
                    const related = isRelatedTo(sourceTypes[i], target2, 1 /* Source */ , reportErrors2 && i === len - 1, /*headMessage*/ void 0, intersectionState);
                    if (related) return related;
                }
                return 0 /* False */ ;
            }
            function getUndefinedStrippedTargetIfNeeded(source2, target2) {
                if (source2.flags & 1048576 /* Union */  && target2.flags & 1048576 /* Union */  && !(source2.types[0].flags & 32768 /* Undefined */ ) && target2.types[0].flags & 32768 /* Undefined */ ) return extractTypesOfKind(target2, -32769 /* Undefined */ );
                return target2;
            }
            function eachTypeRelatedToType(source2, target2, reportErrors2, intersectionState) {
                let result2 = -1 /* True */ ;
                const sourceTypes = source2.types;
                const undefinedStrippedTarget = getUndefinedStrippedTargetIfNeeded(source2, target2);
                for(let i = 0; i < sourceTypes.length; i++){
                    const sourceType = sourceTypes[i];
                    if (undefinedStrippedTarget.flags & 1048576 /* Union */  && sourceTypes.length >= undefinedStrippedTarget.types.length && sourceTypes.length % undefinedStrippedTarget.types.length === 0) {
                        const related2 = isRelatedTo(sourceType, undefinedStrippedTarget.types[i % undefinedStrippedTarget.types.length], 3 /* Both */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState);
                        if (related2) {
                            result2 &= related2;
                            continue;
                        }
                    }
                    const related = isRelatedTo(sourceType, target2, 1 /* Source */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function typeArgumentsRelatedTo(sources = emptyArray, targets = emptyArray, variances = emptyArray, reportErrors2, intersectionState) {
                if (sources.length !== targets.length && relation === identityRelation) return 0 /* False */ ;
                const length2 = sources.length <= targets.length ? sources.length : targets.length;
                let result2 = -1 /* True */ ;
                for(let i = 0; i < length2; i++){
                    const varianceFlags = i < variances.length ? variances[i] : 1 /* Covariant */ ;
                    const variance = varianceFlags & 7 /* VarianceMask */ ;
                    if (variance !== 4 /* Independent */ ) {
                        const s = sources[i];
                        const t = targets[i];
                        let related = -1 /* True */ ;
                        if (varianceFlags & 8 /* Unmeasurable */ ) related = relation === identityRelation ? isRelatedTo(s, t, 3 /* Both */ , /*reportErrors*/ false) : compareTypesIdentical(s, t);
                        else if (variance === 1 /* Covariant */ ) related = isRelatedTo(s, t, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                        else if (variance === 2 /* Contravariant */ ) related = isRelatedTo(t, s, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                        else if (variance === 3 /* Bivariant */ ) {
                            related = isRelatedTo(t, s, 3 /* Both */ , /*reportErrors*/ false);
                            if (!related) related = isRelatedTo(s, t, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                        } else {
                            related = isRelatedTo(s, t, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                            if (related) related &= isRelatedTo(t, s, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                        }
                        if (!related) return 0 /* False */ ;
                        result2 &= related;
                    }
                }
                return result2;
            }
            function recursiveTypeRelatedTo(source2, target2, reportErrors2, intersectionState, recursionFlags) {
                var _a2, _b, _c;
                if (overflow) return 0 /* False */ ;
                const id = getRelationKey(source2, target2, intersectionState, relation, /*ignoreConstraints*/ false);
                const entry = relation.get(id);
                if (entry !== void 0) {
                    if (reportErrors2 && entry & 2 /* Failed */  && !(entry & 4 /* Reported */ )) ;
                    else {
                        if (outofbandVarianceMarkerHandler) {
                            const saved = entry & 24 /* ReportsMask */ ;
                            if (saved & 8 /* ReportsUnmeasurable */ ) instantiateType(source2, reportUnmeasurableMapper);
                            if (saved & 16 /* ReportsUnreliable */ ) instantiateType(source2, reportUnreliableMapper);
                        }
                        return entry & 1 /* Succeeded */  ? -1 /* True */  : 0 /* False */ ;
                    }
                }
                if (!maybeKeys) {
                    maybeKeys = [];
                    sourceStack = [];
                    targetStack = [];
                } else {
                    const broadestEquivalentId = id.startsWith("*") ? getRelationKey(source2, target2, intersectionState, relation, /*ignoreConstraints*/ true) : void 0;
                    for(let i = 0; i < maybeCount; i++){
                        if (id === maybeKeys[i] || broadestEquivalentId && broadestEquivalentId === maybeKeys[i]) return 3 /* Maybe */ ;
                    }
                    if (sourceDepth === 100 || targetDepth === 100) {
                        overflow = true;
                        return 0 /* False */ ;
                    }
                }
                const maybeStart = maybeCount;
                maybeKeys[maybeCount] = id;
                maybeCount++;
                const saveExpandingFlags = expandingFlags;
                if (recursionFlags & 1 /* Source */ ) {
                    sourceStack[sourceDepth] = source2;
                    sourceDepth++;
                    if (!(expandingFlags & 1 /* Source */ ) && isDeeplyNestedType(source2, sourceStack, sourceDepth)) expandingFlags |= 1 /* Source */ ;
                }
                if (recursionFlags & 2 /* Target */ ) {
                    targetStack[targetDepth] = target2;
                    targetDepth++;
                    if (!(expandingFlags & 2 /* Target */ ) && isDeeplyNestedType(target2, targetStack, targetDepth)) expandingFlags |= 2 /* Target */ ;
                }
                let originalHandler;
                let propagatingVarianceFlags = 0;
                if (outofbandVarianceMarkerHandler) {
                    originalHandler = outofbandVarianceMarkerHandler;
                    outofbandVarianceMarkerHandler = (onlyUnreliable)=>{
                        propagatingVarianceFlags |= onlyUnreliable ? 16 /* ReportsUnreliable */  : 8 /* ReportsUnmeasurable */ ;
                        return originalHandler(onlyUnreliable);
                    };
                }
                let result2;
                if (expandingFlags === 3 /* Both */ ) {
                    (_a2 = tracing) == null || _a2.instant(tracing.Phase.CheckTypes, "recursiveTypeRelatedTo_DepthLimit", {
                        sourceId: source2.id,
                        sourceIdStack: sourceStack.map((t)=>t.id),
                        targetId: target2.id,
                        targetIdStack: targetStack.map((t)=>t.id),
                        depth: sourceDepth,
                        targetDepth: targetDepth
                    });
                    result2 = 3 /* Maybe */ ;
                } else {
                    (_b = tracing) == null || _b.push(tracing.Phase.CheckTypes, "structuredTypeRelatedTo", {
                        sourceId: source2.id,
                        targetId: target2.id
                    });
                    result2 = structuredTypeRelatedTo(source2, target2, reportErrors2, intersectionState);
                    (_c = tracing) == null || _c.pop();
                }
                if (outofbandVarianceMarkerHandler) outofbandVarianceMarkerHandler = originalHandler;
                if (recursionFlags & 1 /* Source */ ) sourceDepth--;
                if (recursionFlags & 2 /* Target */ ) targetDepth--;
                expandingFlags = saveExpandingFlags;
                if (result2) {
                    if (result2 === -1 /* True */  || sourceDepth === 0 && targetDepth === 0) {
                        if (result2 === -1 /* True */  || result2 === 3 /* Maybe */ ) for(let i = maybeStart; i < maybeCount; i++)relation.set(maybeKeys[i], 1 /* Succeeded */  | propagatingVarianceFlags);
                        maybeCount = maybeStart;
                    }
                } else {
                    relation.set(id, (reportErrors2 ? 4 /* Reported */  : 0) | 2 /* Failed */  | propagatingVarianceFlags);
                    maybeCount = maybeStart;
                }
                return result2;
            }
            function structuredTypeRelatedTo(source2, target2, reportErrors2, intersectionState) {
                const saveErrorInfo = captureErrorCalculationState();
                let result2 = structuredTypeRelatedToWorker(source2, target2, reportErrors2, intersectionState, saveErrorInfo);
                if (relation !== identityRelation) {
                    if (!result2 && (source2.flags & 2097152 /* Intersection */  || source2.flags & 262144 /* TypeParameter */  && target2.flags & 1048576 /* Union */ )) {
                        const constraint = getEffectiveConstraintOfIntersection(source2.flags & 2097152 /* Intersection */  ? source2.types : [
                            source2
                        ], !!(target2.flags & 1048576 /* Union */ ));
                        if (constraint && everyType(constraint, (c)=>c !== source2)) result2 = isRelatedTo(constraint, target2, 1 /* Source */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState);
                    }
                    if (result2 && !(intersectionState & 2 /* Target */ ) && target2.flags & 2097152 /* Intersection */  && !isGenericObjectType(target2) && source2.flags & 2621440 /* Intersection */ ) {
                        result2 &= propertiesRelatedTo(source2, target2, reportErrors2, /*excludedProperties*/ void 0, /*optionalsOnly*/ false, 0 /* None */ );
                        if (result2 && isObjectLiteralType2(source2) && getObjectFlags(source2) & 8192 /* FreshLiteral */ ) result2 &= indexSignaturesRelatedTo(source2, target2, /*sourceIsPrimitive*/ false, reportErrors2, 0 /* None */ );
                    } else if (result2 && isNonGenericObjectType(target2) && !isArrayOrTupleType(target2) && source2.flags & 2097152 /* Intersection */  && getApparentType(source2).flags & 3670016 /* StructuredType */  && !some(source2.types, (t)=>t === target2 || !!(getObjectFlags(t) & 262144 /* NonInferrableType */ ))) result2 &= propertiesRelatedTo(source2, target2, reportErrors2, /*excludedProperties*/ void 0, /*optionalsOnly*/ true, intersectionState);
                }
                if (result2) resetErrorInfo(saveErrorInfo);
                return result2;
            }
            function structuredTypeRelatedToWorker(source2, target2, reportErrors2, intersectionState, saveErrorInfo) {
                let result2;
                let originalErrorInfo;
                let varianceCheckFailed = false;
                let sourceFlags = source2.flags;
                const targetFlags = target2.flags;
                if (relation === identityRelation) {
                    if (sourceFlags & 3145728 /* UnionOrIntersection */ ) {
                        let result3 = eachTypeRelatedToSomeType(source2, target2);
                        if (result3) result3 &= eachTypeRelatedToSomeType(target2, source2);
                        return result3;
                    }
                    if (sourceFlags & 4194304 /* Index */ ) return isRelatedTo(source2.type, target2.type, 3 /* Both */ , /*reportErrors*/ false);
                    if (sourceFlags & 8388608 /* IndexedAccess */ ) {
                        if (result2 = isRelatedTo(source2.objectType, target2.objectType, 3 /* Both */ , /*reportErrors*/ false)) {
                            if (result2 &= isRelatedTo(source2.indexType, target2.indexType, 3 /* Both */ , /*reportErrors*/ false)) return result2;
                        }
                    }
                    if (sourceFlags & 16777216 /* Conditional */ ) {
                        if (source2.root.isDistributive === target2.root.isDistributive) {
                            if (result2 = isRelatedTo(source2.checkType, target2.checkType, 3 /* Both */ , /*reportErrors*/ false)) {
                                if (result2 &= isRelatedTo(source2.extendsType, target2.extendsType, 3 /* Both */ , /*reportErrors*/ false)) {
                                    if (result2 &= isRelatedTo(getTrueTypeFromConditionalType(source2), getTrueTypeFromConditionalType(target2), 3 /* Both */ , /*reportErrors*/ false)) {
                                        if (result2 &= isRelatedTo(getFalseTypeFromConditionalType(source2), getFalseTypeFromConditionalType(target2), 3 /* Both */ , /*reportErrors*/ false)) return result2;
                                    }
                                }
                            }
                        }
                    }
                    if (sourceFlags & 33554432 /* Substitution */ ) {
                        if (result2 = isRelatedTo(source2.baseType, target2.baseType, 3 /* Both */ , /*reportErrors*/ false)) {
                            if (result2 &= isRelatedTo(source2.constraint, target2.constraint, 3 /* Both */ , /*reportErrors*/ false)) return result2;
                        }
                    }
                    if (!(sourceFlags & 524288 /* Object */ )) return 0 /* False */ ;
                } else if (sourceFlags & 3145728 /* UnionOrIntersection */  || targetFlags & 3145728 /* UnionOrIntersection */ ) {
                    if (result2 = unionOrIntersectionRelatedTo(source2, target2, reportErrors2, intersectionState)) return result2;
                    if (!(sourceFlags & 465829888 /* Instantiable */  || sourceFlags & 524288 /* Object */  && targetFlags & 1048576 /* Union */  || sourceFlags & 2097152 /* Intersection */  && targetFlags & 467402752 /* Instantiable */ )) return 0 /* False */ ;
                }
                if (sourceFlags & 17301504 /* Conditional */  && source2.aliasSymbol && source2.aliasTypeArguments && source2.aliasSymbol === target2.aliasSymbol && !(isMarkerType(source2) || isMarkerType(target2))) {
                    const variances = getAliasVariances(source2.aliasSymbol);
                    if (variances === emptyArray) return 1 /* Unknown */ ;
                    const params = getSymbolLinks(source2.aliasSymbol).typeParameters;
                    const minParams = getMinTypeArgumentCount(params);
                    const sourceTypes = fillMissingTypeArguments(source2.aliasTypeArguments, params, minParams, isInJSFile(source2.aliasSymbol.valueDeclaration));
                    const targetTypes = fillMissingTypeArguments(target2.aliasTypeArguments, params, minParams, isInJSFile(source2.aliasSymbol.valueDeclaration));
                    const varianceResult = relateVariances(sourceTypes, targetTypes, variances, intersectionState);
                    if (varianceResult !== void 0) return varianceResult;
                }
                if (isSingleElementGenericTupleType(source2) && !source2.target.readonly && (result2 = isRelatedTo(getTypeArguments(source2)[0], target2, 1 /* Source */ )) || isSingleElementGenericTupleType(target2) && (target2.target.readonly || isMutableArrayOrTuple(getBaseConstraintOfType(source2) || source2)) && (result2 = isRelatedTo(source2, getTypeArguments(target2)[0], 2 /* Target */ ))) return result2;
                if (targetFlags & 262144 /* TypeParameter */ ) {
                    if (getObjectFlags(source2) & 32 /* Mapped */  && !source2.declaration.nameType && isRelatedTo(getIndexType(target2), getConstraintTypeFromMappedType(source2), 3 /* Both */ )) {
                        if (!(getMappedTypeModifiers(source2) & 4 /* IncludeOptional */ )) {
                            const templateType = getTemplateTypeFromMappedType(source2);
                            const indexedAccessType = getIndexedAccessType(target2, getTypeParameterFromMappedType(source2));
                            if (result2 = isRelatedTo(templateType, indexedAccessType, 3 /* Both */ , reportErrors2)) return result2;
                        }
                    }
                    if (relation === comparableRelation && sourceFlags & 262144 /* TypeParameter */ ) {
                        let constraint = getConstraintOfTypeParameter(source2);
                        if (constraint && hasNonCircularBaseConstraint(source2)) while(constraint && someType(constraint, (c)=>!!(c.flags & 262144 /* TypeParameter */ ))){
                            if (result2 = isRelatedTo(constraint, target2, 1 /* Source */ , /*reportErrors*/ false)) return result2;
                            constraint = getConstraintOfTypeParameter(constraint);
                        }
                        return 0 /* False */ ;
                    }
                } else if (targetFlags & 4194304 /* Index */ ) {
                    const targetType = target2.type;
                    if (sourceFlags & 4194304 /* Index */ ) {
                        if (result2 = isRelatedTo(targetType, source2.type, 3 /* Both */ , /*reportErrors*/ false)) return result2;
                    }
                    if (isTupleType(targetType)) {
                        if (result2 = isRelatedTo(source2, getKnownKeysOfTupleType(targetType), 2 /* Target */ , reportErrors2)) return result2;
                    } else {
                        const constraint = getSimplifiedTypeOrConstraint(targetType);
                        if (constraint) {
                            if (isRelatedTo(source2, getIndexType(constraint, target2.indexFlags | 4 /* NoReducibleCheck */ ), 2 /* Target */ , reportErrors2) === -1 /* True */ ) return -1 /* True */ ;
                        } else if (isGenericMappedType(targetType)) {
                            const nameType = getNameTypeFromMappedType(targetType);
                            const constraintType = getConstraintTypeFromMappedType(targetType);
                            let targetKeys;
                            if (nameType && isMappedTypeWithKeyofConstraintDeclaration(targetType)) {
                                const modifiersType = getApparentType(getModifiersTypeFromMappedType(targetType));
                                const mappedKeys = [];
                                forEachMappedTypePropertyKeyTypeAndIndexSignatureKeyType(modifiersType, 8576 /* StringOrNumberLiteralOrUnique */ , /*stringsOnly*/ false, (t)=>void mappedKeys.push(instantiateType(nameType, appendTypeMapping(targetType.mapper, getTypeParameterFromMappedType(targetType), t))));
                                targetKeys = getUnionType([
                                    ...mappedKeys,
                                    nameType
                                ]);
                            } else targetKeys = nameType || constraintType;
                            if (isRelatedTo(source2, targetKeys, 2 /* Target */ , reportErrors2) === -1 /* True */ ) return -1 /* True */ ;
                        }
                    }
                } else if (targetFlags & 8388608 /* IndexedAccess */ ) {
                    if (sourceFlags & 8388608 /* IndexedAccess */ ) {
                        if (result2 = isRelatedTo(source2.objectType, target2.objectType, 3 /* Both */ , reportErrors2)) {
                            instantiateType(source2.objectType, reportUnreliableMapper);
                            result2 &= isRelatedTo(source2.indexType, target2.indexType, 3 /* Both */ , reportErrors2);
                        }
                        if (result2) return result2;
                        if (reportErrors2) originalErrorInfo = errorInfo;
                    }
                    if (relation === assignableRelation || relation === comparableRelation) {
                        const objectType = target2.objectType;
                        const indexType = target2.indexType;
                        const baseObjectType = getBaseConstraintOfType(objectType) || objectType;
                        const baseIndexType = getBaseConstraintOfType(indexType) || indexType;
                        if (!isGenericObjectType(baseObjectType) && !isGenericIndexType(baseIndexType)) {
                            const accessFlags = 4 /* Writing */  | (baseObjectType !== objectType ? 2 /* NoIndexSignatures */  : 0);
                            const constraint = getIndexedAccessTypeOrUndefined(baseObjectType, baseIndexType, accessFlags);
                            if (constraint) {
                                if (reportErrors2 && originalErrorInfo) resetErrorInfo(saveErrorInfo);
                                if (result2 = isRelatedTo(source2, constraint, 2 /* Target */ , reportErrors2, /*headMessage*/ void 0, intersectionState)) return result2;
                                if (reportErrors2 && originalErrorInfo && errorInfo) errorInfo = countMessageChainBreadth([
                                    originalErrorInfo
                                ]) <= countMessageChainBreadth([
                                    errorInfo
                                ]) ? originalErrorInfo : errorInfo;
                            }
                        }
                    }
                    if (reportErrors2) originalErrorInfo = void 0;
                } else if (isGenericMappedType(target2) && relation !== identityRelation) {
                    const keysRemapped = !!target2.declaration.nameType;
                    const templateType = getTemplateTypeFromMappedType(target2);
                    const modifiers = getMappedTypeModifiers(target2);
                    if (!(modifiers & 8 /* ExcludeOptional */ )) {
                        if (!keysRemapped && templateType.flags & 8388608 /* IndexedAccess */  && templateType.objectType === source2 && templateType.indexType === getTypeParameterFromMappedType(target2)) return -1 /* True */ ;
                        if (!isGenericMappedType(source2)) {
                            const targetKeys = keysRemapped ? getNameTypeFromMappedType(target2) : getConstraintTypeFromMappedType(target2);
                            const sourceKeys = getIndexType(source2, 2 /* NoIndexSignatures */ );
                            const includeOptional = modifiers & 4 /* IncludeOptional */ ;
                            const filteredByApplicability = includeOptional ? intersectTypes(targetKeys, sourceKeys) : void 0;
                            if (includeOptional ? !(filteredByApplicability.flags & 131072 /* Never */ ) : isRelatedTo(targetKeys, sourceKeys, 3 /* Both */ )) {
                                const templateType2 = getTemplateTypeFromMappedType(target2);
                                const typeParameter = getTypeParameterFromMappedType(target2);
                                const nonNullComponent = extractTypesOfKind(templateType2, -98305 /* Nullable */ );
                                if (!keysRemapped && nonNullComponent.flags & 8388608 /* IndexedAccess */  && nonNullComponent.indexType === typeParameter) {
                                    if (result2 = isRelatedTo(source2, nonNullComponent.objectType, 2 /* Target */ , reportErrors2)) return result2;
                                } else {
                                    const indexingType = keysRemapped ? filteredByApplicability || targetKeys : filteredByApplicability ? getIntersectionType([
                                        filteredByApplicability,
                                        typeParameter
                                    ]) : typeParameter;
                                    const indexedAccessType = getIndexedAccessType(source2, indexingType);
                                    if (result2 = isRelatedTo(indexedAccessType, templateType2, 3 /* Both */ , reportErrors2)) return result2;
                                }
                            }
                            originalErrorInfo = errorInfo;
                            resetErrorInfo(saveErrorInfo);
                        }
                    }
                } else if (targetFlags & 16777216 /* Conditional */ ) {
                    if (isDeeplyNestedType(target2, targetStack, targetDepth, 10)) return 3 /* Maybe */ ;
                    const c = target2;
                    if (!c.root.inferTypeParameters && !isDistributionDependent(c.root)) {
                        const skipTrue = !isTypeAssignableTo(getPermissiveInstantiation(c.checkType), getPermissiveInstantiation(c.extendsType));
                        const skipFalse = !skipTrue && isTypeAssignableTo(getRestrictiveInstantiation(c.checkType), getRestrictiveInstantiation(c.extendsType));
                        if (result2 = skipTrue ? -1 /* True */  : isRelatedTo(source2, getTrueTypeFromConditionalType(c), 2 /* Target */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState)) {
                            result2 &= skipFalse ? -1 /* True */  : isRelatedTo(source2, getFalseTypeFromConditionalType(c), 2 /* Target */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState);
                            if (result2) return result2;
                        }
                    }
                } else if (targetFlags & 134217728 /* TemplateLiteral */ ) {
                    if (sourceFlags & 134217728 /* TemplateLiteral */ ) {
                        if (relation === comparableRelation) return templateLiteralTypesDefinitelyUnrelated(source2, target2) ? 0 /* False */  : -1 /* True */ ;
                        instantiateType(source2, reportUnreliableMapper);
                    }
                    if (isTypeMatchedByTemplateLiteralType(source2, target2)) return -1 /* True */ ;
                } else if (target2.flags & 268435456 /* StringMapping */ ) {
                    if (!(source2.flags & 268435456 /* StringMapping */ )) {
                        if (isMemberOfStringMapping(source2, target2)) return -1 /* True */ ;
                    }
                }
                if (sourceFlags & 8650752 /* TypeVariable */ ) {
                    if (!(sourceFlags & 8388608 /* IndexedAccess */  && targetFlags & 8388608 /* IndexedAccess */ )) {
                        const constraint = getConstraintOfType(source2) || unknownType;
                        if (result2 = isRelatedTo(constraint, target2, 1 /* Source */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState)) return result2;
                        else if (result2 = isRelatedTo(getTypeWithThisArgument(constraint, source2), target2, 1 /* Source */ , reportErrors2 && constraint !== unknownType && !(targetFlags & sourceFlags & 262144 /* TypeParameter */ ), /*headMessage*/ void 0, intersectionState)) return result2;
                        if (sourceFlags & 8388608 /* IndexedAccess */ ) {
                            const indexType = source2.indexType;
                            if (indexType.flags & 4194304 /* Index */ ) {
                                const unresolvedIndexConstraint = getBaseConstraintOfType(indexType.type);
                                const indexConstraint = unresolvedIndexConstraint && unresolvedIndexConstraint !== noConstraintType ? getIndexType(unresolvedIndexConstraint) : keyofConstraintType;
                                const constraint2 = getIndexedAccessType(source2.objectType, indexConstraint);
                                if (result2 = isRelatedTo(constraint2, target2, 1 /* Source */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState)) return result2;
                            }
                        }
                        if (isMappedTypeGenericIndexedAccess(source2)) {
                            const indexConstraint = getConstraintOfType(source2.indexType);
                            if (indexConstraint) {
                                if (result2 = isRelatedTo(getIndexedAccessType(source2.objectType, indexConstraint), target2, 1 /* Source */ , reportErrors2)) return result2;
                            }
                        }
                    }
                } else if (sourceFlags & 4194304 /* Index */ ) {
                    if (result2 = isRelatedTo(keyofConstraintType, target2, 1 /* Source */ , reportErrors2)) return result2;
                } else if (sourceFlags & 134217728 /* TemplateLiteral */  && !(targetFlags & 524288 /* Object */ )) {
                    if (!(targetFlags & 134217728 /* TemplateLiteral */ )) {
                        const constraint = getBaseConstraintOfType(source2);
                        if (constraint && constraint !== source2 && (result2 = isRelatedTo(constraint, target2, 1 /* Source */ , reportErrors2))) return result2;
                    }
                } else if (sourceFlags & 268435456 /* StringMapping */ ) {
                    if (targetFlags & 268435456 /* StringMapping */ ) {
                        if (source2.symbol !== target2.symbol) return 0 /* False */ ;
                        if (result2 = isRelatedTo(source2.type, target2.type, 3 /* Both */ , reportErrors2)) return result2;
                    } else {
                        const constraint = getBaseConstraintOfType(source2);
                        if (constraint && (result2 = isRelatedTo(constraint, target2, 1 /* Source */ , reportErrors2))) return result2;
                    }
                } else if (sourceFlags & 16777216 /* Conditional */ ) {
                    if (isDeeplyNestedType(source2, sourceStack, sourceDepth, 10)) return 3 /* Maybe */ ;
                    if (targetFlags & 16777216 /* Conditional */ ) {
                        const sourceParams = source2.root.inferTypeParameters;
                        let sourceExtends = source2.extendsType;
                        let mapper;
                        if (sourceParams) {
                            const ctx = createInferenceContext(sourceParams, /*signature*/ void 0, 0 /* None */ , isRelatedToWorker);
                            inferTypes(ctx.inferences, target2.extendsType, sourceExtends, 1536 /* AlwaysStrict */ );
                            sourceExtends = instantiateType(sourceExtends, ctx.mapper);
                            mapper = ctx.mapper;
                        }
                        if (isTypeIdenticalTo(sourceExtends, target2.extendsType) && (isRelatedTo(source2.checkType, target2.checkType, 3 /* Both */ ) || isRelatedTo(target2.checkType, source2.checkType, 3 /* Both */ ))) {
                            if (result2 = isRelatedTo(instantiateType(getTrueTypeFromConditionalType(source2), mapper), getTrueTypeFromConditionalType(target2), 3 /* Both */ , reportErrors2)) result2 &= isRelatedTo(getFalseTypeFromConditionalType(source2), getFalseTypeFromConditionalType(target2), 3 /* Both */ , reportErrors2);
                            if (result2) return result2;
                        }
                    } else {
                        const distributiveConstraint = hasNonCircularBaseConstraint(source2) ? getConstraintOfDistributiveConditionalType(source2) : void 0;
                        if (distributiveConstraint) {
                            if (result2 = isRelatedTo(distributiveConstraint, target2, 1 /* Source */ , reportErrors2)) return result2;
                        }
                    }
                    const defaultConstraint = getDefaultConstraintOfConditionalType(source2);
                    if (defaultConstraint) {
                        if (result2 = isRelatedTo(defaultConstraint, target2, 1 /* Source */ , reportErrors2)) return result2;
                    }
                } else {
                    if (relation !== subtypeRelation && relation !== strictSubtypeRelation && isPartialMappedType(target2) && isEmptyObjectType(source2)) return -1 /* True */ ;
                    if (isGenericMappedType(target2)) {
                        if (isGenericMappedType(source2)) {
                            if (result2 = mappedTypeRelatedTo(source2, target2, reportErrors2)) return result2;
                        }
                        return 0 /* False */ ;
                    }
                    const sourceIsPrimitive = !!(sourceFlags & 402784252 /* Primitive */ );
                    if (relation !== identityRelation) {
                        source2 = getApparentType(source2);
                        sourceFlags = source2.flags;
                    } else if (isGenericMappedType(source2)) return 0 /* False */ ;
                    if (getObjectFlags(source2) & 4 /* Reference */  && getObjectFlags(target2) & 4 /* Reference */  && source2.target === target2.target && !isTupleType(source2) && !(isMarkerType(source2) || isMarkerType(target2))) {
                        if (isEmptyArrayLiteralType(source2)) return -1 /* True */ ;
                        const variances = getVariances(source2.target);
                        if (variances === emptyArray) return 1 /* Unknown */ ;
                        const varianceResult = relateVariances(getTypeArguments(source2), getTypeArguments(target2), variances, intersectionState);
                        if (varianceResult !== void 0) return varianceResult;
                    } else if (isReadonlyArrayType(target2) ? everyType(source2, isArrayOrTupleType) : isArrayType(target2) && everyType(source2, (t)=>isTupleType(t) && !t.target.readonly)) {
                        if (relation !== identityRelation) return isRelatedTo(getIndexTypeOfType(source2, numberType) || anyType, getIndexTypeOfType(target2, numberType) || anyType, 3 /* Both */ , reportErrors2);
                        else return 0 /* False */ ;
                    } else if (isGenericTupleType(source2) && isTupleType(target2) && !isGenericTupleType(target2)) {
                        const constraint = getBaseConstraintOrType(source2);
                        if (constraint !== source2) return isRelatedTo(constraint, target2, 1 /* Source */ , reportErrors2);
                    } else if ((relation === subtypeRelation || relation === strictSubtypeRelation) && isEmptyObjectType(target2) && getObjectFlags(target2) & 8192 /* FreshLiteral */  && !isEmptyObjectType(source2)) return 0 /* False */ ;
                    if (sourceFlags & 2621440 /* Intersection */  && targetFlags & 524288 /* Object */ ) {
                        const reportStructuralErrors = reportErrors2 && errorInfo === saveErrorInfo.errorInfo && !sourceIsPrimitive;
                        result2 = propertiesRelatedTo(source2, target2, reportStructuralErrors, /*excludedProperties*/ void 0, /*optionalsOnly*/ false, intersectionState);
                        if (result2) {
                            result2 &= signaturesRelatedTo(source2, target2, 0 /* Call */ , reportStructuralErrors, intersectionState);
                            if (result2) {
                                result2 &= signaturesRelatedTo(source2, target2, 1 /* Construct */ , reportStructuralErrors, intersectionState);
                                if (result2) result2 &= indexSignaturesRelatedTo(source2, target2, sourceIsPrimitive, reportStructuralErrors, intersectionState);
                            }
                        }
                        if (varianceCheckFailed && result2) errorInfo = originalErrorInfo || errorInfo || saveErrorInfo.errorInfo;
                        else if (result2) return result2;
                    }
                    if (sourceFlags & 2621440 /* Intersection */  && targetFlags & 1048576 /* Union */ ) {
                        const objectOnlyTarget = extractTypesOfKind(target2, 36175872 /* Substitution */ );
                        if (objectOnlyTarget.flags & 1048576 /* Union */ ) {
                            const result3 = typeRelatedToDiscriminatedType(source2, objectOnlyTarget);
                            if (result3) return result3;
                        }
                    }
                }
                return 0 /* False */ ;
                function countMessageChainBreadth(info) {
                    if (!info) return 0;
                    return reduceLeft(info, (value1, chain)=>value1 + 1 + countMessageChainBreadth(chain.next), 0);
                }
                function relateVariances(sourceTypeArguments, targetTypeArguments, variances, intersectionState2) {
                    if (result2 = typeArgumentsRelatedTo(sourceTypeArguments, targetTypeArguments, variances, reportErrors2, intersectionState2)) return result2;
                    if (some(variances, (v)=>!!(v & 24 /* AllowsStructuralFallback */ ))) {
                        originalErrorInfo = void 0;
                        resetErrorInfo(saveErrorInfo);
                        return void 0;
                    }
                    const allowStructuralFallback = targetTypeArguments && hasCovariantVoidArgument(targetTypeArguments, variances);
                    varianceCheckFailed = !allowStructuralFallback;
                    if (variances !== emptyArray && !allowStructuralFallback) {
                        if (varianceCheckFailed && !(reportErrors2 && some(variances, (v)=>(v & 7 /* VarianceMask */ ) === 0 /* Invariant */ ))) return 0 /* False */ ;
                        originalErrorInfo = errorInfo;
                        resetErrorInfo(saveErrorInfo);
                    }
                }
            }
            function mappedTypeRelatedTo(source2, target2, reportErrors2) {
                const modifiersRelated = relation === comparableRelation || (relation === identityRelation ? getMappedTypeModifiers(source2) === getMappedTypeModifiers(target2) : getCombinedMappedTypeOptionality(source2) <= getCombinedMappedTypeOptionality(target2));
                if (modifiersRelated) {
                    let result2;
                    const targetConstraint = getConstraintTypeFromMappedType(target2);
                    const sourceConstraint = instantiateType(getConstraintTypeFromMappedType(source2), getCombinedMappedTypeOptionality(source2) < 0 ? reportUnmeasurableMapper : reportUnreliableMapper);
                    if (result2 = isRelatedTo(targetConstraint, sourceConstraint, 3 /* Both */ , reportErrors2)) {
                        const mapper = createTypeMapper([
                            getTypeParameterFromMappedType(source2)
                        ], [
                            getTypeParameterFromMappedType(target2)
                        ]);
                        if (instantiateType(getNameTypeFromMappedType(source2), mapper) === instantiateType(getNameTypeFromMappedType(target2), mapper)) return result2 & isRelatedTo(instantiateType(getTemplateTypeFromMappedType(source2), mapper), getTemplateTypeFromMappedType(target2), 3 /* Both */ , reportErrors2);
                    }
                }
                return 0 /* False */ ;
            }
            function typeRelatedToDiscriminatedType(source2, target2) {
                var _a2;
                const sourceProperties = getPropertiesOfType(source2);
                const sourcePropertiesFiltered = findDiscriminantProperties(sourceProperties, target2);
                if (!sourcePropertiesFiltered) return 0 /* False */ ;
                let numCombinations = 1;
                for (const sourceProperty of sourcePropertiesFiltered){
                    numCombinations *= countTypes(getNonMissingTypeOfSymbol(sourceProperty));
                    if (numCombinations > 25) {
                        (_a2 = tracing) == null || _a2.instant(tracing.Phase.CheckTypes, "typeRelatedToDiscriminatedType_DepthLimit", {
                            sourceId: source2.id,
                            targetId: target2.id,
                            numCombinations: numCombinations
                        });
                        return 0 /* False */ ;
                    }
                }
                const sourceDiscriminantTypes = new Array(sourcePropertiesFiltered.length);
                const excludedProperties = /* @__PURE__ */ new Set();
                for(let i = 0; i < sourcePropertiesFiltered.length; i++){
                    const sourceProperty = sourcePropertiesFiltered[i];
                    const sourcePropertyType = getNonMissingTypeOfSymbol(sourceProperty);
                    sourceDiscriminantTypes[i] = sourcePropertyType.flags & 1048576 /* Union */  ? sourcePropertyType.types : [
                        sourcePropertyType
                    ];
                    excludedProperties.add(sourceProperty.escapedName);
                }
                const discriminantCombinations = cartesianProduct(sourceDiscriminantTypes);
                const matchingTypes = [];
                for (const combination of discriminantCombinations){
                    let hasMatch = false;
                    outer: for (const type of target2.types){
                        for(let i = 0; i < sourcePropertiesFiltered.length; i++){
                            const sourceProperty = sourcePropertiesFiltered[i];
                            const targetProperty = getPropertyOfType(type, sourceProperty.escapedName);
                            if (!targetProperty) continue outer;
                            if (sourceProperty === targetProperty) continue;
                            const related = propertyRelatedTo(source2, target2, sourceProperty, targetProperty, (_)=>combination[i], /*reportErrors*/ false, 0 /* None */ , /*skipOptional*/ strictNullChecks || relation === comparableRelation);
                            if (!related) continue outer;
                        }
                        pushIfUnique(matchingTypes, type, equateValues);
                        hasMatch = true;
                    }
                    if (!hasMatch) return 0 /* False */ ;
                }
                let result2 = -1 /* True */ ;
                for (const type of matchingTypes){
                    result2 &= propertiesRelatedTo(source2, type, /*reportErrors*/ false, excludedProperties, /*optionalsOnly*/ false, 0 /* None */ );
                    if (result2) {
                        result2 &= signaturesRelatedTo(source2, type, 0 /* Call */ , /*reportErrors*/ false, 0 /* None */ );
                        if (result2) {
                            result2 &= signaturesRelatedTo(source2, type, 1 /* Construct */ , /*reportErrors*/ false, 0 /* None */ );
                            if (result2 && !(isTupleType(source2) && isTupleType(type))) result2 &= indexSignaturesRelatedTo(source2, type, /*sourceIsPrimitive*/ false, /*reportErrors*/ false, 0 /* None */ );
                        }
                    }
                    if (!result2) return result2;
                }
                return result2;
            }
            function excludeProperties(properties, excludedProperties) {
                if (!excludedProperties || properties.length === 0) return properties;
                let result2;
                for(let i = 0; i < properties.length; i++){
                    if (!excludedProperties.has(properties[i].escapedName)) {
                        if (result2) result2.push(properties[i]);
                    } else if (!result2) result2 = properties.slice(0, i);
                }
                return result2 || properties;
            }
            function isPropertySymbolTypeRelated(sourceProp, targetProp, getTypeOfSourceProperty, reportErrors2, intersectionState) {
                const targetIsOptional = strictNullChecks && !!(getCheckFlags(targetProp) & 48 /* Partial */ );
                const effectiveTarget = addOptionality(getNonMissingTypeOfSymbol(targetProp), /*isProperty*/ false, targetIsOptional);
                const effectiveSource = getTypeOfSourceProperty(sourceProp);
                return isRelatedTo(effectiveSource, effectiveTarget, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
            }
            function propertyRelatedTo(source2, target2, sourceProp, targetProp, getTypeOfSourceProperty, reportErrors2, intersectionState, skipOptional) {
                const sourcePropFlags = getDeclarationModifierFlagsFromSymbol(sourceProp);
                const targetPropFlags = getDeclarationModifierFlagsFromSymbol(targetProp);
                if (sourcePropFlags & 8 /* Private */  || targetPropFlags & 8 /* Private */ ) {
                    if (sourceProp.valueDeclaration !== targetProp.valueDeclaration) {
                        if (reportErrors2) {
                            if (sourcePropFlags & 8 /* Private */  && targetPropFlags & 8 /* Private */ ) reportError(Diagnostics.Types_have_separate_declarations_of_a_private_property_0, symbolToString(targetProp));
                            else reportError(Diagnostics.Property_0_is_private_in_type_1_but_not_in_type_2, symbolToString(targetProp), typeToString(sourcePropFlags & 8 /* Private */  ? source2 : target2), typeToString(sourcePropFlags & 8 /* Private */  ? target2 : source2));
                        }
                        return 0 /* False */ ;
                    }
                } else if (targetPropFlags & 16 /* Protected */ ) {
                    if (!isValidOverrideOf(sourceProp, targetProp)) {
                        if (reportErrors2) reportError(Diagnostics.Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2, symbolToString(targetProp), typeToString(getDeclaringClass(sourceProp) || source2), typeToString(getDeclaringClass(targetProp) || target2));
                        return 0 /* False */ ;
                    }
                } else if (sourcePropFlags & 16 /* Protected */ ) {
                    if (reportErrors2) reportError(Diagnostics.Property_0_is_protected_in_type_1_but_public_in_type_2, symbolToString(targetProp), typeToString(source2), typeToString(target2));
                    return 0 /* False */ ;
                }
                if (relation === strictSubtypeRelation && isReadonlySymbol(sourceProp) && !isReadonlySymbol(targetProp)) return 0 /* False */ ;
                const related = isPropertySymbolTypeRelated(sourceProp, targetProp, getTypeOfSourceProperty, reportErrors2, intersectionState);
                if (!related) {
                    if (reportErrors2) reportIncompatibleError(Diagnostics.Types_of_property_0_are_incompatible, symbolToString(targetProp));
                    return 0 /* False */ ;
                }
                if (!skipOptional && sourceProp.flags & 16777216 /* Optional */  && targetProp.flags & 106500 /* ClassMember */  && !(targetProp.flags & 16777216 /* Optional */ )) {
                    if (reportErrors2) reportError(Diagnostics.Property_0_is_optional_in_type_1_but_required_in_type_2, symbolToString(targetProp), typeToString(source2), typeToString(target2));
                    return 0 /* False */ ;
                }
                return related;
            }
            function reportUnmatchedProperty(source2, target2, unmatchedProperty, requireOptionalProperties) {
                let shouldSkipElaboration = false;
                if (unmatchedProperty.valueDeclaration && isNamedDeclaration(unmatchedProperty.valueDeclaration) && isPrivateIdentifier(unmatchedProperty.valueDeclaration.name) && source2.symbol && source2.symbol.flags & 32 /* Class */ ) {
                    const privateIdentifierDescription = unmatchedProperty.valueDeclaration.name.escapedText;
                    const symbolTableKey = getSymbolNameForPrivateIdentifier(source2.symbol, privateIdentifierDescription);
                    if (symbolTableKey && getPropertyOfType(source2, symbolTableKey)) {
                        const sourceName = factory.getDeclarationName(source2.symbol.valueDeclaration);
                        const targetName = factory.getDeclarationName(target2.symbol.valueDeclaration);
                        reportError(Diagnostics.Property_0_in_type_1_refers_to_a_different_member_that_cannot_be_accessed_from_within_type_2, diagnosticName(privateIdentifierDescription), diagnosticName(sourceName.escapedText === "" ? anon : sourceName), diagnosticName(targetName.escapedText === "" ? anon : targetName));
                        return;
                    }
                }
                const props = arrayFrom(getUnmatchedProperties(source2, target2, requireOptionalProperties, /*matchDiscriminantProperties*/ false));
                if (!headMessage || headMessage.code !== Diagnostics.Class_0_incorrectly_implements_interface_1.code && headMessage.code !== Diagnostics.Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass.code) shouldSkipElaboration = true;
                if (props.length === 1) {
                    const propName = symbolToString(unmatchedProperty, /*enclosingDeclaration*/ void 0, 0 /* None */ , 20 /* WriteComputedProps */ );
                    reportError(Diagnostics.Property_0_is_missing_in_type_1_but_required_in_type_2, propName, ...getTypeNamesForErrorDisplay(source2, target2));
                    if (length(unmatchedProperty.declarations)) associateRelatedInfo(createDiagnosticForNode(unmatchedProperty.declarations[0], Diagnostics._0_is_declared_here, propName));
                    if (shouldSkipElaboration && errorInfo) overrideNextErrorInfo++;
                } else if (tryElaborateArrayLikeErrors(source2, target2, /*reportErrors*/ false)) {
                    if (props.length > 5) reportError(Diagnostics.Type_0_is_missing_the_following_properties_from_type_1_Colon_2_and_3_more, typeToString(source2), typeToString(target2), map(props.slice(0, 4), (p)=>symbolToString(p)).join(", "), props.length - 4);
                    else reportError(Diagnostics.Type_0_is_missing_the_following_properties_from_type_1_Colon_2, typeToString(source2), typeToString(target2), map(props, (p)=>symbolToString(p)).join(", "));
                    if (shouldSkipElaboration && errorInfo) overrideNextErrorInfo++;
                }
            }
            function propertiesRelatedTo(source2, target2, reportErrors2, excludedProperties, optionalsOnly, intersectionState) {
                if (relation === identityRelation) return propertiesIdenticalTo(source2, target2, excludedProperties);
                let result2 = -1 /* True */ ;
                if (isTupleType(target2)) {
                    if (isArrayOrTupleType(source2)) {
                        if (!target2.target.readonly && (isReadonlyArrayType(source2) || isTupleType(source2) && source2.target.readonly)) return 0 /* False */ ;
                        const sourceArity = getTypeReferenceArity(source2);
                        const targetArity = getTypeReferenceArity(target2);
                        const sourceRestFlag = isTupleType(source2) ? source2.target.combinedFlags & 4 /* Rest */  : 4 /* Rest */ ;
                        const targetRestFlag = target2.target.combinedFlags & 4 /* Rest */ ;
                        const sourceMinLength = isTupleType(source2) ? source2.target.minLength : 0;
                        const targetMinLength = target2.target.minLength;
                        if (!sourceRestFlag && sourceArity < targetMinLength) {
                            if (reportErrors2) reportError(Diagnostics.Source_has_0_element_s_but_target_requires_1, sourceArity, targetMinLength);
                            return 0 /* False */ ;
                        }
                        if (!targetRestFlag && targetArity < sourceMinLength) {
                            if (reportErrors2) reportError(Diagnostics.Source_has_0_element_s_but_target_allows_only_1, sourceMinLength, targetArity);
                            return 0 /* False */ ;
                        }
                        if (!targetRestFlag && (sourceRestFlag || targetArity < sourceArity)) {
                            if (reportErrors2) {
                                if (sourceMinLength < targetMinLength) reportError(Diagnostics.Target_requires_0_element_s_but_source_may_have_fewer, targetMinLength);
                                else reportError(Diagnostics.Target_allows_only_0_element_s_but_source_may_have_more, targetArity);
                            }
                            return 0 /* False */ ;
                        }
                        const sourceTypeArguments = getTypeArguments(source2);
                        const targetTypeArguments = getTypeArguments(target2);
                        const targetStartCount = getStartElementCount(target2.target, 11 /* NonRest */ );
                        const targetEndCount = getEndElementCount(target2.target, 11 /* NonRest */ );
                        const targetHasRestElement = target2.target.hasRestElement;
                        let canExcludeDiscriminants = !!excludedProperties;
                        for(let sourcePosition = 0; sourcePosition < sourceArity; sourcePosition++){
                            const sourceFlags = isTupleType(source2) ? source2.target.elementFlags[sourcePosition] : 4 /* Rest */ ;
                            const sourcePositionFromEnd = sourceArity - 1 - sourcePosition;
                            const targetPosition = targetHasRestElement && sourcePosition >= targetStartCount ? targetArity - 1 - Math.min(sourcePositionFromEnd, targetEndCount) : sourcePosition;
                            const targetFlags = target2.target.elementFlags[targetPosition];
                            if (targetFlags & 8 /* Variadic */  && !(sourceFlags & 8 /* Variadic */ )) {
                                if (reportErrors2) reportError(Diagnostics.Source_provides_no_match_for_variadic_element_at_position_0_in_target, targetPosition);
                                return 0 /* False */ ;
                            }
                            if (sourceFlags & 8 /* Variadic */  && !(targetFlags & 12 /* Variable */ )) {
                                if (reportErrors2) reportError(Diagnostics.Variadic_element_at_position_0_in_source_does_not_match_element_at_position_1_in_target, sourcePosition, targetPosition);
                                return 0 /* False */ ;
                            }
                            if (targetFlags & 1 /* Required */  && !(sourceFlags & 1 /* Required */ )) {
                                if (reportErrors2) reportError(Diagnostics.Source_provides_no_match_for_required_element_at_position_0_in_target, targetPosition);
                                return 0 /* False */ ;
                            }
                            if (canExcludeDiscriminants) {
                                if (sourceFlags & 12 /* Variable */  || targetFlags & 12 /* Variable */ ) canExcludeDiscriminants = false;
                                if (canExcludeDiscriminants && (excludedProperties == null ? void 0 : excludedProperties.has("" + sourcePosition))) continue;
                            }
                            const sourceType = removeMissingType(sourceTypeArguments[sourcePosition], !!(sourceFlags & targetFlags & 2 /* Optional */ ));
                            const targetType = targetTypeArguments[targetPosition];
                            const targetCheckType = sourceFlags & 8 /* Variadic */  && targetFlags & 4 /* Rest */  ? createArrayType(targetType) : removeMissingType(targetType, !!(targetFlags & 2 /* Optional */ ));
                            const related = isRelatedTo(sourceType, targetCheckType, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                            if (!related) {
                                if (reportErrors2 && (targetArity > 1 || sourceArity > 1)) {
                                    if (targetHasRestElement && sourcePosition >= targetStartCount && sourcePositionFromEnd >= targetEndCount && targetStartCount !== sourceArity - targetEndCount - 1) reportIncompatibleError(Diagnostics.Type_at_positions_0_through_1_in_source_is_not_compatible_with_type_at_position_2_in_target, targetStartCount, sourceArity - targetEndCount - 1, targetPosition);
                                    else reportIncompatibleError(Diagnostics.Type_at_position_0_in_source_is_not_compatible_with_type_at_position_1_in_target, sourcePosition, targetPosition);
                                }
                                return 0 /* False */ ;
                            }
                            result2 &= related;
                        }
                        return result2;
                    }
                    if (target2.target.combinedFlags & 12 /* Variable */ ) return 0 /* False */ ;
                }
                const requireOptionalProperties = (relation === subtypeRelation || relation === strictSubtypeRelation) && !isObjectLiteralType2(source2) && !isEmptyArrayLiteralType(source2) && !isTupleType(source2);
                const unmatchedProperty = getUnmatchedProperty(source2, target2, requireOptionalProperties, /*matchDiscriminantProperties*/ false);
                if (unmatchedProperty) {
                    if (reportErrors2 && shouldReportUnmatchedPropertyError(source2, target2)) reportUnmatchedProperty(source2, target2, unmatchedProperty, requireOptionalProperties);
                    return 0 /* False */ ;
                }
                if (isObjectLiteralType2(target2)) {
                    for (const sourceProp of excludeProperties(getPropertiesOfType(source2), excludedProperties))if (!getPropertyOfObjectType(target2, sourceProp.escapedName)) {
                        const sourceType = getTypeOfSymbol(sourceProp);
                        if (!(sourceType.flags & 32768 /* Undefined */ )) {
                            if (reportErrors2) reportError(Diagnostics.Property_0_does_not_exist_on_type_1, symbolToString(sourceProp), typeToString(target2));
                            return 0 /* False */ ;
                        }
                    }
                }
                const properties = getPropertiesOfType(target2);
                const numericNamesOnly = isTupleType(source2) && isTupleType(target2);
                for (const targetProp of excludeProperties(properties, excludedProperties)){
                    const name = targetProp.escapedName;
                    if (!(targetProp.flags & 4194304 /* Prototype */ ) && (!numericNamesOnly || isNumericLiteralName(name) || name === "length") && (!optionalsOnly || targetProp.flags & 16777216 /* Optional */ )) {
                        const sourceProp = getPropertyOfType(source2, name);
                        if (sourceProp && sourceProp !== targetProp) {
                            const related = propertyRelatedTo(source2, target2, sourceProp, targetProp, getNonMissingTypeOfSymbol, reportErrors2, intersectionState, relation === comparableRelation);
                            if (!related) return 0 /* False */ ;
                            result2 &= related;
                        }
                    }
                }
                return result2;
            }
            function propertiesIdenticalTo(source2, target2, excludedProperties) {
                if (!(source2.flags & 524288 /* Object */  && target2.flags & 524288 /* Object */ )) return 0 /* False */ ;
                const sourceProperties = excludeProperties(getPropertiesOfObjectType(source2), excludedProperties);
                const targetProperties = excludeProperties(getPropertiesOfObjectType(target2), excludedProperties);
                if (sourceProperties.length !== targetProperties.length) return 0 /* False */ ;
                let result2 = -1 /* True */ ;
                for (const sourceProp of sourceProperties){
                    const targetProp = getPropertyOfObjectType(target2, sourceProp.escapedName);
                    if (!targetProp) return 0 /* False */ ;
                    const related = compareProperties2(sourceProp, targetProp, isRelatedTo);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function signaturesRelatedTo(source2, target2, kind, reportErrors2, intersectionState) {
                var _a2, _b;
                if (relation === identityRelation) return signaturesIdenticalTo(source2, target2, kind);
                if (target2 === anyFunctionType || source2 === anyFunctionType) return -1 /* True */ ;
                const sourceIsJSConstructor = source2.symbol && isJSConstructor(source2.symbol.valueDeclaration);
                const targetIsJSConstructor = target2.symbol && isJSConstructor(target2.symbol.valueDeclaration);
                const sourceSignatures = getSignaturesOfType(source2, sourceIsJSConstructor && kind === 1 /* Construct */  ? 0 /* Call */  : kind);
                const targetSignatures = getSignaturesOfType(target2, targetIsJSConstructor && kind === 1 /* Construct */  ? 0 /* Call */  : kind);
                if (kind === 1 /* Construct */  && sourceSignatures.length && targetSignatures.length) {
                    const sourceIsAbstract = !!(sourceSignatures[0].flags & 4 /* Abstract */ );
                    const targetIsAbstract = !!(targetSignatures[0].flags & 4 /* Abstract */ );
                    if (sourceIsAbstract && !targetIsAbstract) {
                        if (reportErrors2) reportError(Diagnostics.Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type);
                        return 0 /* False */ ;
                    }
                    if (!constructorVisibilitiesAreCompatible(sourceSignatures[0], targetSignatures[0], reportErrors2)) return 0 /* False */ ;
                }
                let result2 = -1 /* True */ ;
                const incompatibleReporter = kind === 1 /* Construct */  ? reportIncompatibleConstructSignatureReturn : reportIncompatibleCallSignatureReturn;
                const sourceObjectFlags = getObjectFlags(source2);
                const targetObjectFlags = getObjectFlags(target2);
                if (sourceObjectFlags & 64 /* Instantiated */  && targetObjectFlags & 64 /* Instantiated */  && source2.symbol === target2.symbol || sourceObjectFlags & 4 /* Reference */  && targetObjectFlags & 4 /* Reference */  && source2.target === target2.target) for(let i = 0; i < targetSignatures.length; i++){
                    const related = signatureRelatedTo(sourceSignatures[i], targetSignatures[i], /*erase*/ true, reportErrors2, intersectionState, incompatibleReporter(sourceSignatures[i], targetSignatures[i]));
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                else if (sourceSignatures.length === 1 && targetSignatures.length === 1) {
                    const eraseGenerics = relation === comparableRelation || !!compilerOptions.noStrictGenericChecks;
                    const sourceSignature = first(sourceSignatures);
                    const targetSignature = first(targetSignatures);
                    result2 = signatureRelatedTo(sourceSignature, targetSignature, eraseGenerics, reportErrors2, intersectionState, incompatibleReporter(sourceSignature, targetSignature));
                    if (!result2 && reportErrors2 && kind === 1 /* Construct */  && sourceObjectFlags & targetObjectFlags && (((_a2 = targetSignature.declaration) == null ? void 0 : _a2.kind) === 175 /* Constructor */  || ((_b = sourceSignature.declaration) == null ? void 0 : _b.kind) === 175 /* Constructor */ )) {
                        const constructSignatureToString = (signature)=>signatureToString(signature, /*enclosingDeclaration*/ void 0, 262144 /* WriteArrowStyleSignature */ , kind);
                        reportError(Diagnostics.Type_0_is_not_assignable_to_type_1, constructSignatureToString(sourceSignature), constructSignatureToString(targetSignature));
                        reportError(Diagnostics.Types_of_construct_signatures_are_incompatible);
                        return result2;
                    }
                } else outer: for (const t of targetSignatures){
                    const saveErrorInfo = captureErrorCalculationState();
                    let shouldElaborateErrors = reportErrors2;
                    for (const s of sourceSignatures){
                        const related = signatureRelatedTo(s, t, /*erase*/ true, shouldElaborateErrors, intersectionState, incompatibleReporter(s, t));
                        if (related) {
                            result2 &= related;
                            resetErrorInfo(saveErrorInfo);
                            continue outer;
                        }
                        shouldElaborateErrors = false;
                    }
                    if (shouldElaborateErrors) reportError(Diagnostics.Type_0_provides_no_match_for_the_signature_1, typeToString(source2), signatureToString(t, /*enclosingDeclaration*/ void 0, /*flags*/ void 0, kind));
                    return 0 /* False */ ;
                }
                return result2;
            }
            function shouldReportUnmatchedPropertyError(source2, target2) {
                const typeCallSignatures = getSignaturesOfStructuredType(source2, 0 /* Call */ );
                const typeConstructSignatures = getSignaturesOfStructuredType(source2, 1 /* Construct */ );
                const typeProperties = getPropertiesOfObjectType(source2);
                if ((typeCallSignatures.length || typeConstructSignatures.length) && !typeProperties.length) {
                    if (getSignaturesOfType(target2, 0 /* Call */ ).length && typeCallSignatures.length || getSignaturesOfType(target2, 1 /* Construct */ ).length && typeConstructSignatures.length) return true;
                    return false;
                }
                return true;
            }
            function reportIncompatibleCallSignatureReturn(siga, sigb) {
                if (siga.parameters.length === 0 && sigb.parameters.length === 0) return (source2, target2)=>reportIncompatibleError(Diagnostics.Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1, typeToString(source2), typeToString(target2));
                return (source2, target2)=>reportIncompatibleError(Diagnostics.Call_signature_return_types_0_and_1_are_incompatible, typeToString(source2), typeToString(target2));
            }
            function reportIncompatibleConstructSignatureReturn(siga, sigb) {
                if (siga.parameters.length === 0 && sigb.parameters.length === 0) return (source2, target2)=>reportIncompatibleError(Diagnostics.Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1, typeToString(source2), typeToString(target2));
                return (source2, target2)=>reportIncompatibleError(Diagnostics.Construct_signature_return_types_0_and_1_are_incompatible, typeToString(source2), typeToString(target2));
            }
            function signatureRelatedTo(source2, target2, erase, reportErrors2, intersectionState, incompatibleReporter) {
                const checkMode = relation === subtypeRelation ? 16 /* StrictTopSignature */  : relation === strictSubtypeRelation ? 24 /* StrictArity */  : 0 /* None */ ;
                return compareSignaturesRelated(erase ? getErasedSignature(source2) : source2, erase ? getErasedSignature(target2) : target2, checkMode, reportErrors2, reportError, incompatibleReporter, isRelatedToWorker2, reportUnreliableMapper);
                function isRelatedToWorker2(source3, target3, reportErrors3) {
                    return isRelatedTo(source3, target3, 3 /* Both */ , reportErrors3, /*headMessage*/ void 0, intersectionState);
                }
            }
            function signaturesIdenticalTo(source2, target2, kind) {
                const sourceSignatures = getSignaturesOfType(source2, kind);
                const targetSignatures = getSignaturesOfType(target2, kind);
                if (sourceSignatures.length !== targetSignatures.length) return 0 /* False */ ;
                let result2 = -1 /* True */ ;
                for(let i = 0; i < sourceSignatures.length; i++){
                    const related = compareSignaturesIdentical(sourceSignatures[i], targetSignatures[i], /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ false, isRelatedTo);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function membersRelatedToIndexInfo(source2, targetInfo, reportErrors2, intersectionState) {
                let result2 = -1 /* True */ ;
                const keyType = targetInfo.keyType;
                const props = source2.flags & 2097152 /* Intersection */  ? getPropertiesOfUnionOrIntersectionType(source2) : getPropertiesOfObjectType(source2);
                for (const prop of props){
                    if (isIgnoredJsxProperty(source2, prop)) continue;
                    if (isApplicableIndexType(getLiteralTypeFromProperty(prop, 8576 /* StringOrNumberLiteralOrUnique */ ), keyType)) {
                        const propType = getNonMissingTypeOfSymbol(prop);
                        const type = exactOptionalPropertyTypes || propType.flags & 32768 /* Undefined */  || keyType === numberType || !(prop.flags & 16777216 /* Optional */ ) ? propType : getTypeWithFacts(propType, 524288 /* NEUndefined */ );
                        const related = isRelatedTo(type, targetInfo.type, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                        if (!related) {
                            if (reportErrors2) reportError(Diagnostics.Property_0_is_incompatible_with_index_signature, symbolToString(prop));
                            return 0 /* False */ ;
                        }
                        result2 &= related;
                    }
                }
                for (const info of getIndexInfosOfType(source2))if (isApplicableIndexType(info.keyType, keyType)) {
                    const related = indexInfoRelatedTo(info, targetInfo, reportErrors2, intersectionState);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function indexInfoRelatedTo(sourceInfo, targetInfo, reportErrors2, intersectionState) {
                const related = isRelatedTo(sourceInfo.type, targetInfo.type, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                if (!related && reportErrors2) {
                    if (sourceInfo.keyType === targetInfo.keyType) reportError(Diagnostics._0_index_signatures_are_incompatible, typeToString(sourceInfo.keyType));
                    else reportError(Diagnostics._0_and_1_index_signatures_are_incompatible, typeToString(sourceInfo.keyType), typeToString(targetInfo.keyType));
                }
                return related;
            }
            function indexSignaturesRelatedTo(source2, target2, sourceIsPrimitive, reportErrors2, intersectionState) {
                if (relation === identityRelation) return indexSignaturesIdenticalTo(source2, target2);
                const indexInfos = getIndexInfosOfType(target2);
                const targetHasStringIndex = some(indexInfos, (info)=>info.keyType === stringType);
                let result2 = -1 /* True */ ;
                for (const targetInfo of indexInfos){
                    const related = relation !== strictSubtypeRelation && !sourceIsPrimitive && targetHasStringIndex && targetInfo.type.flags & 1 /* Any */  ? -1 /* True */  : isGenericMappedType(source2) && targetHasStringIndex ? isRelatedTo(getTemplateTypeFromMappedType(source2), targetInfo.type, 3 /* Both */ , reportErrors2) : typeRelatedToIndexInfo(source2, targetInfo, reportErrors2, intersectionState);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function typeRelatedToIndexInfo(source2, targetInfo, reportErrors2, intersectionState) {
                const sourceInfo = getApplicableIndexInfo(source2, targetInfo.keyType);
                if (sourceInfo) return indexInfoRelatedTo(sourceInfo, targetInfo, reportErrors2, intersectionState);
                if (!(intersectionState & 1 /* Source */ ) && (relation !== strictSubtypeRelation || getObjectFlags(source2) & 8192 /* FreshLiteral */ ) && isObjectTypeWithInferableIndex(source2)) return membersRelatedToIndexInfo(source2, targetInfo, reportErrors2, intersectionState);
                if (reportErrors2) reportError(Diagnostics.Index_signature_for_type_0_is_missing_in_type_1, typeToString(targetInfo.keyType), typeToString(source2));
                return 0 /* False */ ;
            }
            function indexSignaturesIdenticalTo(source2, target2) {
                const sourceInfos = getIndexInfosOfType(source2);
                const targetInfos = getIndexInfosOfType(target2);
                if (sourceInfos.length !== targetInfos.length) return 0 /* False */ ;
                for (const targetInfo of targetInfos){
                    const sourceInfo = getIndexInfoOfType(source2, targetInfo.keyType);
                    if (!(sourceInfo && isRelatedTo(sourceInfo.type, targetInfo.type, 3 /* Both */ ) && sourceInfo.isReadonly === targetInfo.isReadonly)) return 0 /* False */ ;
                }
                return -1 /* True */ ;
            }
            function constructorVisibilitiesAreCompatible(sourceSignature, targetSignature, reportErrors2) {
                if (!sourceSignature.declaration || !targetSignature.declaration) return true;
                const sourceAccessibility = getSelectedEffectiveModifierFlags(sourceSignature.declaration, 24 /* NonPublicAccessibilityModifier */ );
                const targetAccessibility = getSelectedEffectiveModifierFlags(targetSignature.declaration, 24 /* NonPublicAccessibilityModifier */ );
                if (targetAccessibility === 8 /* Private */ ) return true;
                if (targetAccessibility === 16 /* Protected */  && sourceAccessibility !== 8 /* Private */ ) return true;
                if (targetAccessibility !== 16 /* Protected */  && !sourceAccessibility) return true;
                if (reportErrors2) reportError(Diagnostics.Cannot_assign_a_0_constructor_type_to_a_1_constructor_type, visibilityToString(sourceAccessibility), visibilityToString(targetAccessibility));
                return false;
            }
        }
        function typeCouldHaveTopLevelSingletonTypes(type) {
            if (type.flags & 16 /* Boolean */ ) return false;
            if (type.flags & 3145728 /* UnionOrIntersection */ ) return !!forEach(type.types, typeCouldHaveTopLevelSingletonTypes);
            if (type.flags & 465829888 /* Instantiable */ ) {
                const constraint = getConstraintOfType(type);
                if (constraint && constraint !== type) return typeCouldHaveTopLevelSingletonTypes(constraint);
            }
            return isUnitType(type) || !!(type.flags & 134217728 /* TemplateLiteral */ ) || !!(type.flags & 268435456 /* StringMapping */ );
        }
        function getExactOptionalUnassignableProperties(source, target) {
            if (isTupleType(source) && isTupleType(target)) return emptyArray;
            return getPropertiesOfType(target).filter((targetProp)=>isExactOptionalPropertyMismatch(getTypeOfPropertyOfType(source, targetProp.escapedName), getTypeOfSymbol(targetProp)));
        }
        function isExactOptionalPropertyMismatch(source, target) {
            return !!source && !!target && maybeTypeOfKind(source, 32768 /* Undefined */ ) && !!containsMissingType(target);
        }
        function getExactOptionalProperties(type) {
            return getPropertiesOfType(type).filter((targetProp)=>containsMissingType(getTypeOfSymbol(targetProp)));
        }
        function getBestMatchingType(source, target, isRelatedTo = compareTypesAssignable) {
            return findMatchingDiscriminantType(source, target, isRelatedTo) || findMatchingTypeReferenceOrTypeAliasReference(source, target) || findBestTypeForObjectLiteral(source, target) || findBestTypeForInvokable(source, target) || findMostOverlappyType(source, target);
        }
        function discriminateTypeByDiscriminableItems(target, discriminators, related) {
            const types = target.types;
            const include = types.map((t)=>t.flags & 402784252 /* Primitive */  ? 0 /* False */  : -1 /* True */ );
            for (const [getDiscriminatingType, propertyName] of discriminators){
                let matched = false;
                for(let i = 0; i < types.length; i++)if (include[i]) {
                    const targetType = getTypeOfPropertyOfType(types[i], propertyName);
                    if (targetType && related(getDiscriminatingType(), targetType)) matched = true;
                    else include[i] = 3 /* Maybe */ ;
                }
                for(let i = 0; i < types.length; i++)if (include[i] === 3 /* Maybe */ ) include[i] = matched ? 0 /* False */  : -1 /* True */ ;
            }
            const filtered = contains(include, 0 /* False */ ) ? getUnionType(types.filter((_, i)=>include[i])) : target;
            return filtered.flags & 131072 /* Never */  ? target : filtered;
        }
        function isWeakType(type) {
            if (type.flags & 524288 /* Object */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                return resolved.callSignatures.length === 0 && resolved.constructSignatures.length === 0 && resolved.indexInfos.length === 0 && resolved.properties.length > 0 && every(resolved.properties, (p)=>!!(p.flags & 16777216 /* Optional */ ));
            }
            if (type.flags & 2097152 /* Intersection */ ) return every(type.types, isWeakType);
            return false;
        }
        function hasCommonProperties(source, target, isComparingJsxAttributes) {
            for (const prop of getPropertiesOfType(source)){
                if (isKnownProperty(target, prop.escapedName, isComparingJsxAttributes)) return true;
            }
            return false;
        }
        function getVariances(type) {
            return type === globalArrayType || type === globalReadonlyArrayType || type.objectFlags & 8 /* Tuple */  ? arrayVariances : getVariancesWorker(type.symbol, type.typeParameters);
        }
        function getAliasVariances(symbol) {
            return getVariancesWorker(symbol, getSymbolLinks(symbol).typeParameters);
        }
        function getVariancesWorker(symbol, typeParameters = emptyArray) {
            var _a, _b;
            const links = getSymbolLinks(symbol);
            if (!links.variances) {
                (_a = tracing) == null || _a.push(tracing.Phase.CheckTypes, "getVariancesWorker", {
                    arity: typeParameters.length,
                    id: getTypeId(getDeclaredTypeOfSymbol(symbol))
                });
                const oldVarianceComputation = inVarianceComputation;
                if (!inVarianceComputation) {
                    inVarianceComputation = true;
                    resolutionStart = resolutionTargets.length;
                }
                links.variances = emptyArray;
                const variances = [];
                for (const tp of typeParameters){
                    const modifiers = getTypeParameterModifiers(tp);
                    let variance = modifiers & 65536 /* Out */  ? modifiers & 32768 /* In */  ? 0 /* Invariant */  : 1 /* Covariant */  : modifiers & 32768 /* In */  ? 2 /* Contravariant */  : void 0;
                    if (variance === void 0) {
                        let unmeasurable = false;
                        let unreliable = false;
                        const oldHandler = outofbandVarianceMarkerHandler;
                        outofbandVarianceMarkerHandler = (onlyUnreliable)=>onlyUnreliable ? unreliable = true : unmeasurable = true;
                        const typeWithSuper = createMarkerType(symbol, tp, markerSuperType);
                        const typeWithSub = createMarkerType(symbol, tp, markerSubType);
                        variance = (isTypeAssignableTo(typeWithSub, typeWithSuper) ? 1 /* Covariant */  : 0) | (isTypeAssignableTo(typeWithSuper, typeWithSub) ? 2 /* Contravariant */  : 0);
                        if (variance === 3 /* Bivariant */  && isTypeAssignableTo(createMarkerType(symbol, tp, markerOtherType), typeWithSuper)) variance = 4 /* Independent */ ;
                        outofbandVarianceMarkerHandler = oldHandler;
                        if (unmeasurable || unreliable) {
                            if (unmeasurable) variance |= 8 /* Unmeasurable */ ;
                            if (unreliable) variance |= 16 /* Unreliable */ ;
                        }
                    }
                    variances.push(variance);
                }
                if (!oldVarianceComputation) {
                    inVarianceComputation = false;
                    resolutionStart = 0;
                }
                links.variances = variances;
                (_b = tracing) == null || _b.pop({
                    variances: variances.map(Debug.formatVariance)
                });
            }
            return links.variances;
        }
        function createMarkerType(symbol, source, target) {
            const mapper = makeUnaryTypeMapper(source, target);
            const type = getDeclaredTypeOfSymbol(symbol);
            if (isErrorType(type)) return type;
            const result = symbol.flags & 524288 /* TypeAlias */  ? getTypeAliasInstantiation(symbol, instantiateTypes(getSymbolLinks(symbol).typeParameters, mapper)) : createTypeReference(type, instantiateTypes(type.typeParameters, mapper));
            markerTypes.add(getTypeId(result));
            return result;
        }
        function isMarkerType(type) {
            return markerTypes.has(getTypeId(type));
        }
        function getTypeParameterModifiers(tp) {
            var _a;
            return reduceLeft((_a = tp.symbol) == null ? void 0 : _a.declarations, (modifiers, d)=>modifiers | getEffectiveModifierFlags(d), 0 /* None */ ) & 100352 /* Const */ ;
        }
        function hasCovariantVoidArgument(typeArguments, variances) {
            for(let i = 0; i < variances.length; i++){
                if ((variances[i] & 7 /* VarianceMask */ ) === 1 /* Covariant */  && typeArguments[i].flags & 16384 /* Void */ ) return true;
            }
            return false;
        }
        function isUnconstrainedTypeParameter(type) {
            return type.flags & 262144 /* TypeParameter */  && !getConstraintOfTypeParameter(type);
        }
        function isNonDeferredTypeReference(type) {
            return !!(getObjectFlags(type) & 4 /* Reference */ ) && !type.node;
        }
        function isTypeReferenceWithGenericArguments(type) {
            return isNonDeferredTypeReference(type) && some(getTypeArguments(type), (t)=>!!(t.flags & 262144 /* TypeParameter */ ) || isTypeReferenceWithGenericArguments(t));
        }
        function getGenericTypeReferenceRelationKey(source, target, postFix, ignoreConstraints) {
            const typeParameters = [];
            let constraintMarker = "";
            const sourceId = getTypeReferenceId(source, 0);
            const targetId = getTypeReferenceId(target, 0);
            return `${constraintMarker}${sourceId},${targetId}${postFix}`;
            function getTypeReferenceId(type, depth = 0) {
                let result = "" + type.target.id;
                for (const t of getTypeArguments(type)){
                    if (t.flags & 262144 /* TypeParameter */ ) {
                        if (ignoreConstraints || isUnconstrainedTypeParameter(t)) {
                            let index = typeParameters.indexOf(t);
                            if (index < 0) {
                                index = typeParameters.length;
                                typeParameters.push(t);
                            }
                            result += "=" + index;
                            continue;
                        }
                        constraintMarker = "*";
                    } else if (depth < 4 && isTypeReferenceWithGenericArguments(t)) {
                        result += "<" + getTypeReferenceId(t, depth + 1) + ">";
                        continue;
                    }
                    result += "-" + t.id;
                }
                return result;
            }
        }
        function getRelationKey(source, target, intersectionState, relation, ignoreConstraints) {
            if (relation === identityRelation && source.id > target.id) {
                const temp = source;
                source = target;
                target = temp;
            }
            const postFix = intersectionState ? ":" + intersectionState : "";
            return isTypeReferenceWithGenericArguments(source) && isTypeReferenceWithGenericArguments(target) ? getGenericTypeReferenceRelationKey(source, target, postFix, ignoreConstraints) : `${source.id},${target.id}${postFix}`;
        }
        function forEachProperty2(prop, callback) {
            if (getCheckFlags(prop) & 6 /* Synthetic */ ) {
                for (const t of prop.links.containingType.types){
                    const p = getPropertyOfType(t, prop.escapedName);
                    const result = p && forEachProperty2(p, callback);
                    if (result) return result;
                }
                return void 0;
            }
            return callback(prop);
        }
        function getDeclaringClass(prop) {
            return prop.parent && prop.parent.flags & 32 /* Class */  ? getDeclaredTypeOfSymbol(getParentOfSymbol(prop)) : void 0;
        }
        function getTypeOfPropertyInBaseClass(property) {
            const classType = getDeclaringClass(property);
            const baseClassType = classType && getBaseTypes(classType)[0];
            return baseClassType && getTypeOfPropertyOfType(baseClassType, property.escapedName);
        }
        function isPropertyInClassDerivedFrom(prop, baseClass) {
            return forEachProperty2(prop, (sp)=>{
                const sourceClass = getDeclaringClass(sp);
                return sourceClass ? hasBaseType(sourceClass, baseClass) : false;
            });
        }
        function isValidOverrideOf(sourceProp, targetProp) {
            return !forEachProperty2(targetProp, (tp)=>getDeclarationModifierFlagsFromSymbol(tp) & 16 /* Protected */  ? !isPropertyInClassDerivedFrom(sourceProp, getDeclaringClass(tp)) : false);
        }
        function isClassDerivedFromDeclaringClasses(checkClass, prop, writing) {
            return forEachProperty2(prop, (p)=>getDeclarationModifierFlagsFromSymbol(p, writing) & 16 /* Protected */  ? !hasBaseType(checkClass, getDeclaringClass(p)) : false) ? void 0 : checkClass;
        }
        function isDeeplyNestedType(type, stack, depth, maxDepth = 3) {
            if (depth >= maxDepth) {
                if (type.flags & 2097152 /* Intersection */ ) return some(type.types, (t)=>isDeeplyNestedType(t, stack, depth, maxDepth));
                const identity2 = getRecursionIdentity(type);
                let count = 0;
                let lastTypeId = 0;
                for(let i = 0; i < depth; i++){
                    const t = stack[i];
                    if (t.flags & 2097152 /* Intersection */  ? some(t.types, (u)=>getRecursionIdentity(u) === identity2) : getRecursionIdentity(t) === identity2) {
                        if (t.id >= lastTypeId) {
                            count++;
                            if (count >= maxDepth) return true;
                        }
                        lastTypeId = t.id;
                    }
                }
            }
            return false;
        }
        function getRecursionIdentity(type) {
            if (type.flags & 524288 /* Object */  && !isObjectOrArrayLiteralType(type)) {
                if (getObjectFlags(type) && 4 /* Reference */  && type.node) return type.node;
                if (type.symbol && !(getObjectFlags(type) & 16 /* Anonymous */  && type.symbol.flags & 32 /* Class */ )) return type.symbol;
                if (isTupleType(type)) return type.target;
            }
            if (type.flags & 262144 /* TypeParameter */ ) return type.symbol;
            if (type.flags & 8388608 /* IndexedAccess */ ) {
                do type = type.objectType;
                while (type.flags & 8388608 /* IndexedAccess */ );
                return type;
            }
            if (type.flags & 16777216 /* Conditional */ ) return type.root;
            return type;
        }
        function isPropertyIdenticalTo(sourceProp, targetProp) {
            return compareProperties2(sourceProp, targetProp, compareTypesIdentical) !== 0 /* False */ ;
        }
        function compareProperties2(sourceProp, targetProp, compareTypes) {
            if (sourceProp === targetProp) return -1 /* True */ ;
            const sourcePropAccessibility = getDeclarationModifierFlagsFromSymbol(sourceProp) & 24 /* NonPublicAccessibilityModifier */ ;
            const targetPropAccessibility = getDeclarationModifierFlagsFromSymbol(targetProp) & 24 /* NonPublicAccessibilityModifier */ ;
            if (sourcePropAccessibility !== targetPropAccessibility) return 0 /* False */ ;
            if (sourcePropAccessibility) {
                if (getTargetSymbol(sourceProp) !== getTargetSymbol(targetProp)) return 0 /* False */ ;
            } else {
                if ((sourceProp.flags & 16777216 /* Optional */ ) !== (targetProp.flags & 16777216 /* Optional */ )) return 0 /* False */ ;
            }
            if (isReadonlySymbol(sourceProp) !== isReadonlySymbol(targetProp)) return 0 /* False */ ;
            return compareTypes(getTypeOfSymbol(sourceProp), getTypeOfSymbol(targetProp));
        }
        function isMatchingSignature(source, target, partialMatch) {
            const sourceParameterCount = getParameterCount(source);
            const targetParameterCount = getParameterCount(target);
            const sourceMinArgumentCount = getMinArgumentCount(source);
            const targetMinArgumentCount = getMinArgumentCount(target);
            const sourceHasRestParameter = hasEffectiveRestParameter(source);
            const targetHasRestParameter = hasEffectiveRestParameter(target);
            if (sourceParameterCount === targetParameterCount && sourceMinArgumentCount === targetMinArgumentCount && sourceHasRestParameter === targetHasRestParameter) return true;
            if (partialMatch && sourceMinArgumentCount <= targetMinArgumentCount) return true;
            return false;
        }
        function compareSignaturesIdentical(source, target, partialMatch, ignoreThisTypes, ignoreReturnTypes, compareTypes) {
            if (source === target) return -1 /* True */ ;
            if (!isMatchingSignature(source, target, partialMatch)) return 0 /* False */ ;
            if (length(source.typeParameters) !== length(target.typeParameters)) return 0 /* False */ ;
            if (target.typeParameters) {
                const mapper = createTypeMapper(source.typeParameters, target.typeParameters);
                for(let i = 0; i < target.typeParameters.length; i++){
                    const s = source.typeParameters[i];
                    const t = target.typeParameters[i];
                    if (!(s === t || compareTypes(instantiateType(getConstraintFromTypeParameter(s), mapper) || unknownType, getConstraintFromTypeParameter(t) || unknownType) && compareTypes(instantiateType(getDefaultFromTypeParameter(s), mapper) || unknownType, getDefaultFromTypeParameter(t) || unknownType))) return 0 /* False */ ;
                }
                source = instantiateSignature(source, mapper, /*eraseTypeParameters*/ true);
            }
            let result = -1 /* True */ ;
            if (!ignoreThisTypes) {
                const sourceThisType = getThisTypeOfSignature(source);
                if (sourceThisType) {
                    const targetThisType = getThisTypeOfSignature(target);
                    if (targetThisType) {
                        const related = compareTypes(sourceThisType, targetThisType);
                        if (!related) return 0 /* False */ ;
                        result &= related;
                    }
                }
            }
            const targetLen = getParameterCount(target);
            for(let i = 0; i < targetLen; i++){
                const s = getTypeAtPosition(source, i);
                const t = getTypeAtPosition(target, i);
                const related = compareTypes(t, s);
                if (!related) return 0 /* False */ ;
                result &= related;
            }
            if (!ignoreReturnTypes) {
                const sourceTypePredicate = getTypePredicateOfSignature(source);
                const targetTypePredicate = getTypePredicateOfSignature(target);
                result &= sourceTypePredicate || targetTypePredicate ? compareTypePredicatesIdentical(sourceTypePredicate, targetTypePredicate, compareTypes) : compareTypes(getReturnTypeOfSignature(source), getReturnTypeOfSignature(target));
            }
            return result;
        }
        function compareTypePredicatesIdentical(source, target, compareTypes) {
            return !(source && target && typePredicateKindsMatch(source, target)) ? 0 /* False */  : source.type === target.type ? -1 /* True */  : source.type && target.type ? compareTypes(source.type, target.type) : 0 /* False */ ;
        }
        function literalTypesWithSameBaseType(types) {
            let commonBaseType;
            for (const t of types)if (!(t.flags & 131072 /* Never */ )) {
                const baseType = getBaseTypeOfLiteralType(t);
                commonBaseType ?? (commonBaseType = baseType);
                if (baseType === t || baseType !== commonBaseType) return false;
            }
            return true;
        }
        function getCombinedTypeFlags(types) {
            return reduceLeft(types, (flags, t)=>flags | (t.flags & 1048576 /* Union */  ? getCombinedTypeFlags(t.types) : t.flags), 0);
        }
        function getCommonSupertype(types) {
            if (types.length === 1) return types[0];
            const primaryTypes = strictNullChecks ? sameMap(types, (t)=>filterType(t, (u)=>!(u.flags & 98304 /* Nullable */ ))) : types;
            const superTypeOrUnion = literalTypesWithSameBaseType(primaryTypes) ? getUnionType(primaryTypes) : reduceLeft(primaryTypes, (s, t)=>isTypeSubtypeOf(s, t) ? t : s);
            return primaryTypes === types ? superTypeOrUnion : getNullableType(superTypeOrUnion, getCombinedTypeFlags(types) & 98304 /* Nullable */ );
        }
        function getCommonSubtype(types) {
            return reduceLeft(types, (s, t)=>isTypeSubtypeOf(t, s) ? t : s);
        }
        function isArrayType(type) {
            return !!(getObjectFlags(type) & 4 /* Reference */ ) && (type.target === globalArrayType || type.target === globalReadonlyArrayType);
        }
        function isReadonlyArrayType(type) {
            return !!(getObjectFlags(type) & 4 /* Reference */ ) && type.target === globalReadonlyArrayType;
        }
        function isArrayOrTupleType(type) {
            return isArrayType(type) || isTupleType(type);
        }
        function isMutableArrayOrTuple(type) {
            return isArrayType(type) && !isReadonlyArrayType(type) || isTupleType(type) && !type.target.readonly;
        }
        function getElementTypeOfArrayType(type) {
            return isArrayType(type) ? getTypeArguments(type)[0] : void 0;
        }
        function isArrayLikeType(type) {
            return isArrayType(type) || !(type.flags & 98304 /* Nullable */ ) && isTypeAssignableTo(type, anyReadonlyArrayType);
        }
        function getSingleBaseForNonAugmentingSubtype(type) {
            if (!(getObjectFlags(type) & 4 /* Reference */ ) || !(getObjectFlags(type.target) & 3 /* ClassOrInterface */ )) return void 0;
            if (getObjectFlags(type) & 33554432 /* IdenticalBaseTypeCalculated */ ) return getObjectFlags(type) & 67108864 /* IdenticalBaseTypeExists */  ? type.cachedEquivalentBaseType : void 0;
            type.objectFlags |= 33554432 /* IdenticalBaseTypeCalculated */ ;
            const target = type.target;
            if (getObjectFlags(target) & 1 /* Class */ ) {
                const baseTypeNode = getBaseTypeNodeOfClass(target);
                if (baseTypeNode && baseTypeNode.expression.kind !== 80 /* Identifier */  && baseTypeNode.expression.kind !== 210 /* PropertyAccessExpression */ ) return void 0;
            }
            const bases = getBaseTypes(target);
            if (bases.length !== 1) return void 0;
            if (getMembersOfSymbol(type.symbol).size) return void 0;
            let instantiatedBase = !length(target.typeParameters) ? bases[0] : instantiateType(bases[0], createTypeMapper(target.typeParameters, getTypeArguments(type).slice(0, target.typeParameters.length)));
            if (length(getTypeArguments(type)) > length(target.typeParameters)) instantiatedBase = getTypeWithThisArgument(instantiatedBase, last(getTypeArguments(type)));
            type.objectFlags |= 67108864 /* IdenticalBaseTypeExists */ ;
            return type.cachedEquivalentBaseType = instantiatedBase;
        }
        function isEmptyLiteralType(type) {
            return strictNullChecks ? type === implicitNeverType : type === undefinedWideningType;
        }
        function isEmptyArrayLiteralType(type) {
            const elementType = getElementTypeOfArrayType(type);
            return !!elementType && isEmptyLiteralType(elementType);
        }
        function isTupleLikeType(type) {
            return isTupleType(type) || !!getPropertyOfType(type, "0");
        }
        function isArrayOrTupleLikeType(type) {
            return isArrayLikeType(type) || isTupleLikeType(type);
        }
        function getTupleElementType(type, index) {
            const propType = getTypeOfPropertyOfType(type, "" + index);
            if (propType) return propType;
            if (everyType(type, isTupleType)) return mapType(type, (t)=>{
                const tupleType = t;
                const restType = getRestTypeOfTupleType(tupleType);
                if (!restType) return undefinedType;
                if (compilerOptions.noUncheckedIndexedAccess && index >= tupleType.target.fixedLength + getEndElementCount(tupleType.target, 3 /* Fixed */ )) return getUnionType([
                    restType,
                    undefinedType
                ]);
                return restType;
            });
            return void 0;
        }
        function isNeitherUnitTypeNorNever(type) {
            return !(type.flags & 240544 /* Never */ );
        }
        function isUnitType(type) {
            return !!(type.flags & 109472 /* Unit */ );
        }
        function isUnitLikeType(type) {
            const t = getBaseConstraintOrType(type);
            return t.flags & 2097152 /* Intersection */  ? some(t.types, isUnitType) : isUnitType(t);
        }
        function extractUnitType(type) {
            return type.flags & 2097152 /* Intersection */  ? find(type.types, isUnitType) || type : type;
        }
        function isLiteralType(type) {
            return type.flags & 16 /* Boolean */  ? true : type.flags & 1048576 /* Union */  ? type.flags & 1024 /* EnumLiteral */  ? true : every(type.types, isUnitType) : isUnitType(type);
        }
        function getBaseTypeOfLiteralType(type) {
            return type.flags & 1056 /* EnumLike */  ? getBaseTypeOfEnumLikeType(type) : type.flags & 402653312 /* StringMapping */  ? stringType : type.flags & 256 /* NumberLiteral */  ? numberType : type.flags & 2048 /* BigIntLiteral */  ? bigintType : type.flags & 512 /* BooleanLiteral */  ? booleanType : type.flags & 1048576 /* Union */  ? getBaseTypeOfLiteralTypeUnion(type) : type;
        }
        function getBaseTypeOfLiteralTypeUnion(type) {
            const key = `B${getTypeId(type)}`;
            return getCachedType(key) ?? setCachedType(key, mapType(type, getBaseTypeOfLiteralType));
        }
        function getBaseTypeOfLiteralTypeForComparison(type) {
            return type.flags & 402653312 /* StringMapping */  ? stringType : type.flags & 288 /* Enum */  ? numberType : type.flags & 2048 /* BigIntLiteral */  ? bigintType : type.flags & 512 /* BooleanLiteral */  ? booleanType : type.flags & 1048576 /* Union */  ? mapType(type, getBaseTypeOfLiteralTypeForComparison) : type;
        }
        function getWidenedLiteralType(type) {
            return type.flags & 1056 /* EnumLike */  && isFreshLiteralType(type) ? getBaseTypeOfEnumLikeType(type) : type.flags & 128 /* StringLiteral */  && isFreshLiteralType(type) ? stringType : type.flags & 256 /* NumberLiteral */  && isFreshLiteralType(type) ? numberType : type.flags & 2048 /* BigIntLiteral */  && isFreshLiteralType(type) ? bigintType : type.flags & 512 /* BooleanLiteral */  && isFreshLiteralType(type) ? booleanType : type.flags & 1048576 /* Union */  ? mapType(type, getWidenedLiteralType) : type;
        }
        function getWidenedUniqueESSymbolType(type) {
            return type.flags & 8192 /* UniqueESSymbol */  ? esSymbolType : type.flags & 1048576 /* Union */  ? mapType(type, getWidenedUniqueESSymbolType) : type;
        }
        function getWidenedLiteralLikeTypeForContextualType(type, contextualType) {
            if (!isLiteralOfContextualType(type, contextualType)) type = getWidenedUniqueESSymbolType(getWidenedLiteralType(type));
            return getRegularTypeOfLiteralType(type);
        }
        function getWidenedLiteralLikeTypeForContextualReturnTypeIfNeeded(type, contextualSignatureReturnType, isAsync) {
            if (type && isUnitType(type)) {
                const contextualType = !contextualSignatureReturnType ? void 0 : isAsync ? getPromisedTypeOfPromise(contextualSignatureReturnType) : contextualSignatureReturnType;
                type = getWidenedLiteralLikeTypeForContextualType(type, contextualType);
            }
            return type;
        }
        function getWidenedLiteralLikeTypeForContextualIterationTypeIfNeeded(type, contextualSignatureReturnType, kind, isAsyncGenerator) {
            if (type && isUnitType(type)) {
                const contextualType = !contextualSignatureReturnType ? void 0 : getIterationTypeOfGeneratorFunctionReturnType(kind, contextualSignatureReturnType, isAsyncGenerator);
                type = getWidenedLiteralLikeTypeForContextualType(type, contextualType);
            }
            return type;
        }
        function isTupleType(type) {
            return !!(getObjectFlags(type) & 4 /* Reference */  && type.target.objectFlags & 8 /* Tuple */ );
        }
        function isGenericTupleType(type) {
            return isTupleType(type) && !!(type.target.combinedFlags & 8 /* Variadic */ );
        }
        function isSingleElementGenericTupleType(type) {
            return isGenericTupleType(type) && type.target.elementFlags.length === 1;
        }
        function getRestTypeOfTupleType(type) {
            return getElementTypeOfSliceOfTupleType(type, type.target.fixedLength);
        }
        function getRestArrayTypeOfTupleType(type) {
            const restType = getRestTypeOfTupleType(type);
            return restType && createArrayType(restType);
        }
        function getElementTypeOfSliceOfTupleType(type, index, endSkipCount = 0, writing = false, noReductions = false) {
            const length2 = getTypeReferenceArity(type) - endSkipCount;
            if (index < length2) {
                const typeArguments = getTypeArguments(type);
                const elementTypes = [];
                for(let i = index; i < length2; i++){
                    const t = typeArguments[i];
                    elementTypes.push(type.target.elementFlags[i] & 8 /* Variadic */  ? getIndexedAccessType(t, numberType) : t);
                }
                return writing ? getIntersectionType(elementTypes) : getUnionType(elementTypes, noReductions ? 0 /* None */  : 1 /* Literal */ );
            }
            return void 0;
        }
        function isTupleTypeStructureMatching(t1, t2) {
            return getTypeReferenceArity(t1) === getTypeReferenceArity(t2) && every(t1.target.elementFlags, (f, i)=>(f & 12 /* Variable */ ) === (t2.target.elementFlags[i] & 12 /* Variable */ ));
        }
        function isZeroBigInt({ value: value1  }) {
            return value1.base10Value === "0";
        }
        function removeDefinitelyFalsyTypes(type) {
            return filterType(type, (t)=>!!(getTypeFacts(t) & 4194304 /* Truthy */ ));
        }
        function extractDefinitelyFalsyTypes(type) {
            return mapType(type, getDefinitelyFalsyPartOfType);
        }
        function getDefinitelyFalsyPartOfType(type) {
            return type.flags & 4 /* String */  ? emptyStringType : type.flags & 8 /* Number */  ? zeroType : type.flags & 64 /* BigInt */  ? zeroBigIntType : type === regularFalseType || type === falseType || type.flags & 114691 /* AnyOrUnknown */  || type.flags & 128 /* StringLiteral */  && type.value === "" || type.flags & 256 /* NumberLiteral */  && type.value === 0 || type.flags & 2048 /* BigIntLiteral */  && isZeroBigInt(type) ? type : neverType;
        }
        function getNullableType(type, flags) {
            const missing = flags & ~type.flags & 98304 /* Null */ ;
            return missing === 0 ? type : missing === 32768 /* Undefined */  ? getUnionType([
                type,
                undefinedType
            ]) : missing === 65536 /* Null */  ? getUnionType([
                type,
                nullType
            ]) : getUnionType([
                type,
                undefinedType,
                nullType
            ]);
        }
        function getOptionalType(type, isProperty = false) {
            Debug.assert(strictNullChecks);
            const missingOrUndefined = isProperty ? undefinedOrMissingType : undefinedType;
            return type === missingOrUndefined || type.flags & 1048576 /* Union */  && type.types[0] === missingOrUndefined ? type : getUnionType([
                type,
                missingOrUndefined
            ]);
        }
        function getGlobalNonNullableTypeInstantiation(type) {
            if (!deferredGlobalNonNullableTypeAlias) deferredGlobalNonNullableTypeAlias = getGlobalSymbol("NonNullable", 524288 /* TypeAlias */ , /*diagnostic*/ void 0) || unknownSymbol;
            return deferredGlobalNonNullableTypeAlias !== unknownSymbol ? getTypeAliasInstantiation(deferredGlobalNonNullableTypeAlias, [
                type
            ]) : getIntersectionType([
                type,
                emptyObjectType
            ]);
        }
        function getNonNullableType(type) {
            return strictNullChecks ? getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ ) : type;
        }
        function addOptionalTypeMarker(type) {
            return strictNullChecks ? getUnionType([
                type,
                optionalType
            ]) : type;
        }
        function removeOptionalTypeMarker(type) {
            return strictNullChecks ? removeType(type, optionalType) : type;
        }
        function propagateOptionalTypeMarker(type, node, wasOptional) {
            return wasOptional ? isOutermostOptionalChain(node) ? getOptionalType(type) : addOptionalTypeMarker(type) : type;
        }
        function getOptionalExpressionType(exprType, expression) {
            return isExpressionOfOptionalChainRoot(expression) ? getNonNullableType(exprType) : isOptionalChain(expression) ? removeOptionalTypeMarker(exprType) : exprType;
        }
        function removeMissingType(type, isOptional) {
            return exactOptionalPropertyTypes && isOptional ? removeType(type, missingType) : type;
        }
        function containsMissingType(type) {
            return type === missingType || !!(type.flags & 1048576 /* Union */ ) && type.types[0] === missingType;
        }
        function removeMissingOrUndefinedType(type) {
            return exactOptionalPropertyTypes ? removeType(type, missingType) : getTypeWithFacts(type, 524288 /* NEUndefined */ );
        }
        function isCoercibleUnderDoubleEquals(source, target) {
            return (source.flags & 524 /* BooleanLiteral */ ) !== 0 && (target.flags & 28 /* Boolean */ ) !== 0;
        }
        function isObjectTypeWithInferableIndex(type) {
            const objectFlags = getObjectFlags(type);
            return type.flags & 2097152 /* Intersection */  ? every(type.types, isObjectTypeWithInferableIndex) : !!(type.symbol && (type.symbol.flags & 7040 /* ValueModule */ ) !== 0 && !(type.symbol.flags & 32 /* Class */ ) && !typeHasCallOrConstructSignatures(type)) || !!(objectFlags & 4194304 /* ObjectRestType */ ) || !!(objectFlags & 1024 /* ReverseMapped */  && isObjectTypeWithInferableIndex(type.source));
        }
        function createSymbolWithType(source, type) {
            const symbol = createSymbol(source.flags, source.escapedName, getCheckFlags(source) & 8 /* Readonly */ );
            symbol.declarations = source.declarations;
            symbol.parent = source.parent;
            symbol.links.type = type;
            symbol.links.target = source;
            if (source.valueDeclaration) symbol.valueDeclaration = source.valueDeclaration;
            const nameType = getSymbolLinks(source).nameType;
            if (nameType) symbol.links.nameType = nameType;
            return symbol;
        }
        function transformTypeOfMembers(type, f) {
            const members = createSymbolTable();
            for (const property of getPropertiesOfObjectType(type)){
                const original = getTypeOfSymbol(property);
                const updated = f(original);
                members.set(property.escapedName, updated === original ? property : createSymbolWithType(property, updated));
            }
            return members;
        }
        function getRegularTypeOfObjectLiteral(type) {
            if (!(isObjectLiteralType2(type) && getObjectFlags(type) & 8192 /* FreshLiteral */ )) return type;
            const regularType = type.regularType;
            if (regularType) return regularType;
            const resolved = type;
            const members = transformTypeOfMembers(type, getRegularTypeOfObjectLiteral);
            const regularNew = createAnonymousType(resolved.symbol, members, resolved.callSignatures, resolved.constructSignatures, resolved.indexInfos);
            regularNew.flags = resolved.flags;
            regularNew.objectFlags |= resolved.objectFlags & -8193 /* FreshLiteral */ ;
            type.regularType = regularNew;
            return regularNew;
        }
        function createWideningContext(parent2, propertyName, siblings) {
            return {
                parent: parent2,
                propertyName: propertyName,
                siblings: siblings,
                resolvedProperties: void 0
            };
        }
        function getSiblingsOfContext(context) {
            if (!context.siblings) {
                const siblings = [];
                for (const type of getSiblingsOfContext(context.parent))if (isObjectLiteralType2(type)) {
                    const prop = getPropertyOfObjectType(type, context.propertyName);
                    if (prop) forEachType(getTypeOfSymbol(prop), (t)=>{
                        siblings.push(t);
                    });
                }
                context.siblings = siblings;
            }
            return context.siblings;
        }
        function getPropertiesOfContext(context) {
            if (!context.resolvedProperties) {
                const names = /* @__PURE__ */ new Map();
                for (const t of getSiblingsOfContext(context)){
                    if (isObjectLiteralType2(t) && !(getObjectFlags(t) & 2097152 /* ContainsSpread */ )) for (const prop of getPropertiesOfType(t))names.set(prop.escapedName, prop);
                }
                context.resolvedProperties = arrayFrom(names.values());
            }
            return context.resolvedProperties;
        }
        function getWidenedProperty(prop, context) {
            if (!(prop.flags & 4 /* Property */ )) return prop;
            const original = getTypeOfSymbol(prop);
            const propContext = context && createWideningContext(context, prop.escapedName, /*siblings*/ void 0);
            const widened = getWidenedTypeWithContext(original, propContext);
            return widened === original ? prop : createSymbolWithType(prop, widened);
        }
        function getUndefinedProperty(prop) {
            const cached = undefinedProperties.get(prop.escapedName);
            if (cached) return cached;
            const result = createSymbolWithType(prop, undefinedOrMissingType);
            result.flags |= 16777216 /* Optional */ ;
            undefinedProperties.set(prop.escapedName, result);
            return result;
        }
        function getWidenedTypeOfObjectLiteral(type, context) {
            const members = createSymbolTable();
            for (const prop of getPropertiesOfObjectType(type))members.set(prop.escapedName, getWidenedProperty(prop, context));
            if (context) {
                for (const prop of getPropertiesOfContext(context))if (!members.has(prop.escapedName)) members.set(prop.escapedName, getUndefinedProperty(prop));
            }
            const result = createAnonymousType(type.symbol, members, emptyArray, emptyArray, sameMap(getIndexInfosOfType(type), (info)=>createIndexInfo(info.keyType, getWidenedType(info.type), info.isReadonly)));
            result.objectFlags |= getObjectFlags(type) & 266240 /* NonInferrableType */ ;
            return result;
        }
        function getWidenedType(type) {
            return getWidenedTypeWithContext(type, /*context*/ void 0);
        }
        function getWidenedTypeWithContext(type, context) {
            if (getObjectFlags(type) & 196608 /* RequiresWidening */ ) {
                if (context === void 0 && type.widened) return type.widened;
                let result;
                if (type.flags & 98305 /* Nullable */ ) result = anyType;
                else if (isObjectLiteralType2(type)) result = getWidenedTypeOfObjectLiteral(type, context);
                else if (type.flags & 1048576 /* Union */ ) {
                    const unionContext = context || createWideningContext(/*parent*/ void 0, /*propertyName*/ void 0, type.types);
                    const widenedTypes = sameMap(type.types, (t)=>t.flags & 98304 /* Nullable */  ? t : getWidenedTypeWithContext(t, unionContext));
                    result = getUnionType(widenedTypes, some(widenedTypes, isEmptyObjectType) ? 2 /* Subtype */  : 1 /* Literal */ );
                } else if (type.flags & 2097152 /* Intersection */ ) result = getIntersectionType(sameMap(type.types, getWidenedType));
                else if (isArrayOrTupleType(type)) result = createTypeReference(type.target, sameMap(getTypeArguments(type), getWidenedType));
                if (result && context === void 0) type.widened = result;
                return result || type;
            }
            return type;
        }
        function reportWideningErrorsInType(type) {
            let errorReported = false;
            if (getObjectFlags(type) & 65536 /* ContainsWideningType */ ) {
                if (type.flags & 1048576 /* Union */ ) {
                    if (some(type.types, isEmptyObjectType)) errorReported = true;
                    else {
                        for (const t of type.types)if (reportWideningErrorsInType(t)) errorReported = true;
                    }
                }
                if (isArrayOrTupleType(type)) {
                    for (const t of getTypeArguments(type))if (reportWideningErrorsInType(t)) errorReported = true;
                }
                if (isObjectLiteralType2(type)) for (const p of getPropertiesOfObjectType(type)){
                    const t = getTypeOfSymbol(p);
                    if (getObjectFlags(t) & 65536 /* ContainsWideningType */ ) {
                        if (!reportWideningErrorsInType(t)) error(p.valueDeclaration, Diagnostics.Object_literal_s_property_0_implicitly_has_an_1_type, symbolToString(p), typeToString(getWidenedType(t)));
                        errorReported = true;
                    }
                }
            }
            return errorReported;
        }
        function reportImplicitAny(declaration, type, wideningKind) {
            const typeAsString = typeToString(getWidenedType(type));
            if (isInJSFile(declaration) && !isCheckJsEnabledForFile(getSourceFileOfNode(declaration), compilerOptions)) return;
            let diagnostic;
            switch(declaration.kind){
                case 225 /* BinaryExpression */ :
                case 171 /* PropertyDeclaration */ :
                case 170 /* PropertySignature */ :
                    diagnostic = noImplicitAny ? Diagnostics.Member_0_implicitly_has_an_1_type : Diagnostics.Member_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage;
                    break;
                case 168 /* Parameter */ :
                    const param = declaration;
                    if (isIdentifier(param.name)) {
                        const originalKeywordKind = identifierToKeywordKind(param.name);
                        if ((isCallSignatureDeclaration(param.parent) || isMethodSignature(param.parent) || isFunctionTypeNode(param.parent)) && param.parent.parameters.indexOf(param) > -1 && (resolveName(param, param.name.escapedText, 788968 /* Type */ , /*nameNotFoundMessage*/ void 0, param.name.escapedText, /*isUse*/ true) || originalKeywordKind && isTypeNodeKind(originalKeywordKind))) {
                            const newName = "arg" + param.parent.parameters.indexOf(param);
                            const typeName = declarationNameToString(param.name) + (param.dotDotDotToken ? "[]" : "");
                            errorOrSuggestion(noImplicitAny, declaration, Diagnostics.Parameter_has_a_name_but_no_type_Did_you_mean_0_Colon_1, newName, typeName);
                            return;
                        }
                    }
                    diagnostic = declaration.dotDotDotToken ? noImplicitAny ? Diagnostics.Rest_parameter_0_implicitly_has_an_any_type : Diagnostics.Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage : noImplicitAny ? Diagnostics.Parameter_0_implicitly_has_an_1_type : Diagnostics.Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage;
                    break;
                case 207 /* BindingElement */ :
                    diagnostic = Diagnostics.Binding_element_0_implicitly_has_an_1_type;
                    if (!noImplicitAny) return;
                    break;
                case 323 /* JSDocFunctionType */ :
                    error(declaration, Diagnostics.Function_type_which_lacks_return_type_annotation_implicitly_has_an_0_return_type, typeAsString);
                    return;
                case 329 /* JSDocSignature */ :
                    if (noImplicitAny && isJSDocOverloadTag(declaration.parent)) error(declaration.parent.tagName, Diagnostics.This_overload_implicitly_returns_the_type_0_because_it_lacks_a_return_type_annotation, typeAsString);
                    return;
                case 261 /* FunctionDeclaration */ :
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                    if (noImplicitAny && !declaration.name) {
                        if (wideningKind === 3 /* GeneratorYield */ ) error(declaration, Diagnostics.Generator_implicitly_has_yield_type_0_because_it_does_not_yield_any_values_Consider_supplying_a_return_type_annotation, typeAsString);
                        else error(declaration, Diagnostics.Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type, typeAsString);
                        return;
                    }
                    diagnostic = !noImplicitAny ? Diagnostics._0_implicitly_has_an_1_return_type_but_a_better_type_may_be_inferred_from_usage : wideningKind === 3 /* GeneratorYield */  ? Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_yield_type : Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type;
                    break;
                case 199 /* MappedType */ :
                    if (noImplicitAny) error(declaration, Diagnostics.Mapped_object_type_implicitly_has_an_any_template_type);
                    return;
                default:
                    diagnostic = noImplicitAny ? Diagnostics.Variable_0_implicitly_has_an_1_type : Diagnostics.Variable_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage;
            }
            errorOrSuggestion(noImplicitAny, declaration, diagnostic, declarationNameToString(getNameOfDeclaration(declaration)), typeAsString);
        }
        function reportErrorsFromWidening(declaration, type, wideningKind) {
            addLazyDiagnostic(()=>{
                if (noImplicitAny && getObjectFlags(type) & 65536 /* ContainsWideningType */  && (!wideningKind || !getContextualSignatureForFunctionLikeDeclaration(declaration))) {
                    if (!reportWideningErrorsInType(type)) reportImplicitAny(declaration, type, wideningKind);
                }
            });
        }
        function applyToParameterTypes(source, target, callback) {
            const sourceCount = getParameterCount(source);
            const targetCount = getParameterCount(target);
            const sourceRestType = getEffectiveRestType(source);
            const targetRestType = getEffectiveRestType(target);
            const targetNonRestCount = targetRestType ? targetCount - 1 : targetCount;
            const paramCount = sourceRestType ? targetNonRestCount : Math.min(sourceCount, targetNonRestCount);
            const sourceThisType = getThisTypeOfSignature(source);
            if (sourceThisType) {
                const targetThisType = getThisTypeOfSignature(target);
                if (targetThisType) callback(sourceThisType, targetThisType);
            }
            for(let i = 0; i < paramCount; i++)callback(getTypeAtPosition(source, i), getTypeAtPosition(target, i));
            if (targetRestType) callback(getRestTypeAtPosition(source, paramCount), targetRestType);
        }
        function applyToReturnTypes(source, target, callback) {
            const sourceTypePredicate = getTypePredicateOfSignature(source);
            const targetTypePredicate = getTypePredicateOfSignature(target);
            if (sourceTypePredicate && targetTypePredicate && typePredicateKindsMatch(sourceTypePredicate, targetTypePredicate) && sourceTypePredicate.type && targetTypePredicate.type) callback(sourceTypePredicate.type, targetTypePredicate.type);
            else callback(getReturnTypeOfSignature(source), getReturnTypeOfSignature(target));
        }
        function createInferenceContext(typeParameters, signature, flags, compareTypes) {
            return createInferenceContextWorker(typeParameters.map(createInferenceInfo), signature, flags, compareTypes || compareTypesAssignable);
        }
        function cloneInferenceContext(context, extraFlags = 0) {
            return context && createInferenceContextWorker(map(context.inferences, cloneInferenceInfo), context.signature, context.flags | extraFlags, context.compareTypes);
        }
        function createInferenceContextWorker(inferences, signature, flags, compareTypes) {
            const context = {
                inferences: inferences,
                signature: signature,
                flags: flags,
                compareTypes: compareTypes,
                mapper: reportUnmeasurableMapper,
                // initialize to a noop mapper so the context object is available, but the underlying object shape is right upon construction
                nonFixingMapper: reportUnmeasurableMapper
            };
            context.mapper = makeFixingMapperForContext(context);
            context.nonFixingMapper = makeNonFixingMapperForContext(context);
            return context;
        }
        function makeFixingMapperForContext(context) {
            return makeDeferredTypeMapper(map(context.inferences, (i)=>i.typeParameter), map(context.inferences, (inference, i)=>()=>{
                    if (!inference.isFixed) {
                        inferFromIntraExpressionSites(context);
                        clearCachedInferences(context.inferences);
                        inference.isFixed = true;
                    }
                    return getInferredType(context, i);
                }));
        }
        function makeNonFixingMapperForContext(context) {
            return makeDeferredTypeMapper(map(context.inferences, (i)=>i.typeParameter), map(context.inferences, (_, i)=>()=>{
                    return getInferredType(context, i);
                }));
        }
        function clearCachedInferences(inferences) {
            for (const inference of inferences)if (!inference.isFixed) inference.inferredType = void 0;
        }
        function addIntraExpressionInferenceSite(context, node, type) {
            (context.intraExpressionInferenceSites ?? (context.intraExpressionInferenceSites = [])).push({
                node: node,
                type: type
            });
        }
        function inferFromIntraExpressionSites(context) {
            if (context.intraExpressionInferenceSites) {
                for (const { node: node , type: type  } of context.intraExpressionInferenceSites){
                    const contextualType = node.kind === 173 /* MethodDeclaration */  ? getContextualTypeForObjectLiteralMethod(node, 2 /* NoConstraints */ ) : getContextualType2(node, 2 /* NoConstraints */ );
                    if (contextualType) inferTypes(context.inferences, type, contextualType);
                }
                context.intraExpressionInferenceSites = void 0;
            }
        }
        function createInferenceInfo(typeParameter) {
            return {
                typeParameter: typeParameter,
                candidates: void 0,
                contraCandidates: void 0,
                inferredType: void 0,
                priority: void 0,
                topLevel: true,
                isFixed: false,
                impliedArity: void 0
            };
        }
        function cloneInferenceInfo(inference) {
            return {
                typeParameter: inference.typeParameter,
                candidates: inference.candidates && inference.candidates.slice(),
                contraCandidates: inference.contraCandidates && inference.contraCandidates.slice(),
                inferredType: inference.inferredType,
                priority: inference.priority,
                topLevel: inference.topLevel,
                isFixed: inference.isFixed,
                impliedArity: inference.impliedArity
            };
        }
        function cloneInferredPartOfContext(context) {
            const inferences = filter(context.inferences, hasInferenceCandidates);
            return inferences.length ? createInferenceContextWorker(map(inferences, cloneInferenceInfo), context.signature, context.flags, context.compareTypes) : void 0;
        }
        function getMapperFromContext(context) {
            return context && context.mapper;
        }
        function couldContainTypeVariables(type) {
            const objectFlags = getObjectFlags(type);
            if (objectFlags & 524288 /* CouldContainTypeVariablesComputed */ ) return !!(objectFlags & 1048576 /* CouldContainTypeVariables */ );
            const result = !!(type.flags & 465829888 /* Instantiable */  || type.flags & 524288 /* Object */  && !isNonGenericTopLevelType(type) && (objectFlags & 4 /* Reference */  && (type.node || some(getTypeArguments(type), couldContainTypeVariables)) || objectFlags & 16 /* Anonymous */  && type.symbol && type.symbol.flags & 14384 /* ObjectLiteral */  && type.symbol.declarations || objectFlags & 12583968 /* InstantiationExpressionType */ ) || type.flags & 137363456 /* TemplateLiteral */  && !(type.flags & 1024 /* EnumLiteral */ ) && !isNonGenericTopLevelType(type) && some(type.types, couldContainTypeVariables));
            if (type.flags & 138117121 /* ObjectFlagsType */ ) type.objectFlags |= 524288 /* CouldContainTypeVariablesComputed */  | (result ? 1048576 /* CouldContainTypeVariables */  : 0);
            return result;
        }
        function isNonGenericTopLevelType(type) {
            if (type.aliasSymbol && !type.aliasTypeArguments) {
                const declaration = getDeclarationOfKind(type.aliasSymbol, 264 /* TypeAliasDeclaration */ );
                return !!(declaration && findAncestor(declaration.parent, (n)=>n.kind === 311 /* SourceFile */  ? true : n.kind === 266 /* ModuleDeclaration */  ? false : "quit"));
            }
            return false;
        }
        function isTypeParameterAtTopLevel(type, tp, depth = 0) {
            return !!(type === tp || type.flags & 3145728 /* UnionOrIntersection */  && some(type.types, (t)=>isTypeParameterAtTopLevel(t, tp, depth)) || depth < 3 && type.flags & 16777216 /* Conditional */  && (isTypeParameterAtTopLevel(getTrueTypeFromConditionalType(type), tp, depth + 1) || isTypeParameterAtTopLevel(getFalseTypeFromConditionalType(type), tp, depth + 1)));
        }
        function isTypeParameterAtTopLevelInReturnType(signature, typeParameter) {
            const typePredicate = getTypePredicateOfSignature(signature);
            return typePredicate ? !!typePredicate.type && isTypeParameterAtTopLevel(typePredicate.type, typeParameter) : isTypeParameterAtTopLevel(getReturnTypeOfSignature(signature), typeParameter);
        }
        function createEmptyObjectTypeFromStringLiteral(type) {
            const members = createSymbolTable();
            forEachType(type, (t)=>{
                if (!(t.flags & 128 /* StringLiteral */ )) return;
                const name = escapeLeadingUnderscores(t.value);
                const literalProp = createSymbol(4 /* Property */ , name);
                literalProp.links.type = anyType;
                if (t.symbol) {
                    literalProp.declarations = t.symbol.declarations;
                    literalProp.valueDeclaration = t.symbol.valueDeclaration;
                }
                members.set(name, literalProp);
            });
            const indexInfos = type.flags & 4 /* String */  ? [
                createIndexInfo(stringType, emptyObjectType, /*isReadonly*/ false)
            ] : emptyArray;
            return createAnonymousType(/*symbol*/ void 0, members, emptyArray, emptyArray, indexInfos);
        }
        function inferTypeForHomomorphicMappedType(source, target, constraint) {
            if (inInferTypeForHomomorphicMappedType) return void 0;
            const key = source.id + "," + target.id + "," + constraint.id;
            if (reverseMappedCache.has(key)) return reverseMappedCache.get(key);
            inInferTypeForHomomorphicMappedType = true;
            const type = createReverseMappedType(source, target, constraint);
            inInferTypeForHomomorphicMappedType = false;
            reverseMappedCache.set(key, type);
            return type;
        }
        function isPartiallyInferableType(type) {
            return !(getObjectFlags(type) & 262144 /* NonInferrableType */ ) || isObjectLiteralType2(type) && some(getPropertiesOfType(type), (prop)=>isPartiallyInferableType(getTypeOfSymbol(prop))) || isTupleType(type) && some(getElementTypes(type), isPartiallyInferableType);
        }
        function createReverseMappedType(source, target, constraint) {
            if (!(getIndexInfoOfType(source, stringType) || getPropertiesOfType(source).length !== 0 && isPartiallyInferableType(source))) return void 0;
            if (isArrayType(source)) return createArrayType(inferReverseMappedType(getTypeArguments(source)[0], target, constraint), isReadonlyArrayType(source));
            if (isTupleType(source)) {
                const elementTypes = map(getElementTypes(source), (t)=>inferReverseMappedType(t, target, constraint));
                const elementFlags = getMappedTypeModifiers(target) & 4 /* IncludeOptional */  ? sameMap(source.target.elementFlags, (f)=>f & 2 /* Optional */  ? 1 /* Required */  : f) : source.target.elementFlags;
                return createTupleType(elementTypes, elementFlags, source.target.readonly, source.target.labeledElementDeclarations);
            }
            const reversed = createObjectType(1040 /* Anonymous */ , /*symbol*/ void 0);
            reversed.source = source;
            reversed.mappedType = target;
            reversed.constraintType = constraint;
            return reversed;
        }
        function getTypeOfReverseMappedSymbol(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.type) links.type = inferReverseMappedType(symbol.links.propertyType, symbol.links.mappedType, symbol.links.constraintType);
            return links.type;
        }
        function inferReverseMappedType(sourceType, target, constraint) {
            const typeParameter = getIndexedAccessType(constraint.type, getTypeParameterFromMappedType(target));
            const templateType = getTemplateTypeFromMappedType(target);
            const inference = createInferenceInfo(typeParameter);
            inferTypes([
                inference
            ], sourceType, templateType);
            return getTypeFromInference(inference) || unknownType;
        }
        function* getUnmatchedProperties(source, target, requireOptionalProperties, matchDiscriminantProperties) {
            const properties = getPropertiesOfType(target);
            for (const targetProp of properties){
                if (isStaticPrivateIdentifierProperty(targetProp)) continue;
                if (requireOptionalProperties || !(targetProp.flags & 16777216 /* Optional */  || getCheckFlags(targetProp) & 48 /* Partial */ )) {
                    const sourceProp = getPropertyOfType(source, targetProp.escapedName);
                    if (!sourceProp) yield targetProp;
                    else if (matchDiscriminantProperties) {
                        const targetType = getTypeOfSymbol(targetProp);
                        if (targetType.flags & 109472 /* Unit */ ) {
                            const sourceType = getTypeOfSymbol(sourceProp);
                            if (!(sourceType.flags & 1 /* Any */  || getRegularTypeOfLiteralType(sourceType) === getRegularTypeOfLiteralType(targetType))) yield targetProp;
                        }
                    }
                }
            }
        }
        function getUnmatchedProperty(source, target, requireOptionalProperties, matchDiscriminantProperties) {
            return firstOrUndefinedIterator(getUnmatchedProperties(source, target, requireOptionalProperties, matchDiscriminantProperties));
        }
        function tupleTypesDefinitelyUnrelated(source, target) {
            return !(target.target.combinedFlags & 8 /* Variadic */ ) && target.target.minLength > source.target.minLength || !target.target.hasRestElement && (source.target.hasRestElement || target.target.fixedLength < source.target.fixedLength);
        }
        function typesDefinitelyUnrelated(source, target) {
            return isTupleType(source) && isTupleType(target) ? tupleTypesDefinitelyUnrelated(source, target) : !!getUnmatchedProperty(source, target, /*requireOptionalProperties*/ false, /*matchDiscriminantProperties*/ true) && !!getUnmatchedProperty(target, source, /*requireOptionalProperties*/ false, /*matchDiscriminantProperties*/ false);
        }
        function getTypeFromInference(inference) {
            return inference.candidates ? getUnionType(inference.candidates, 2 /* Subtype */ ) : inference.contraCandidates ? getIntersectionType(inference.contraCandidates) : void 0;
        }
        function hasSkipDirectInferenceFlag(node) {
            return !!getNodeLinks(node).skipDirectInference;
        }
        function isFromInferenceBlockedSource(type) {
            return !!(type.symbol && some(type.symbol.declarations, hasSkipDirectInferenceFlag));
        }
        function templateLiteralTypesDefinitelyUnrelated(source, target) {
            const sourceStart = source.texts[0];
            const targetStart = target.texts[0];
            const sourceEnd = source.texts[source.texts.length - 1];
            const targetEnd = target.texts[target.texts.length - 1];
            const startLen = Math.min(sourceStart.length, targetStart.length);
            const endLen = Math.min(sourceEnd.length, targetEnd.length);
            return sourceStart.slice(0, startLen) !== targetStart.slice(0, startLen) || sourceEnd.slice(sourceEnd.length - endLen) !== targetEnd.slice(targetEnd.length - endLen);
        }
        function isValidNumberString(s, roundTripOnly) {
            if (s === "") return false;
            const n = +s;
            return isFinite(n) && (!roundTripOnly || "" + n === s);
        }
        function parseBigIntLiteralType(text) {
            return getBigIntLiteralType(parseValidBigInt(text));
        }
        function isMemberOfStringMapping(source, target) {
            if (target.flags & 1 /* Any */ ) return true;
            if (target.flags & 134217732 /* TemplateLiteral */ ) return isTypeAssignableTo(source, target);
            if (target.flags & 268435456 /* StringMapping */ ) {
                const mappingStack = [];
                while(target.flags & 268435456 /* StringMapping */ ){
                    mappingStack.unshift(target.symbol);
                    target = target.type;
                }
                const mappedSource = reduceLeft(mappingStack, (memo, value1)=>getStringMappingType(value1, memo), source);
                return mappedSource === source && isMemberOfStringMapping(source, target);
            }
            return false;
        }
        function isValidTypeForTemplateLiteralPlaceholder(source, target) {
            if (source === target || target.flags & 5 /* String */ ) return true;
            if (source.flags & 128 /* StringLiteral */ ) {
                const value1 = source.value;
                return !!(target.flags & 8 /* Number */  && isValidNumberString(value1, /*roundTripOnly*/ false) || target.flags & 64 /* BigInt */  && isValidBigIntString(value1, /*roundTripOnly*/ false) || target.flags & 98816 /* Nullable */  && value1 === target.intrinsicName || target.flags & 268435456 /* StringMapping */  && isMemberOfStringMapping(getStringLiteralType(value1), target));
            }
            if (source.flags & 134217728 /* TemplateLiteral */ ) {
                const texts = source.texts;
                return texts.length === 2 && texts[0] === "" && texts[1] === "" && isTypeAssignableTo(source.types[0], target);
            }
            return isTypeAssignableTo(source, target);
        }
        function inferTypesFromTemplateLiteralType(source, target) {
            return source.flags & 128 /* StringLiteral */  ? inferFromLiteralPartsToTemplateLiteral([
                source.value
            ], emptyArray, target) : source.flags & 134217728 /* TemplateLiteral */  ? arraysEqual(source.texts, target.texts) ? map(source.types, getStringLikeTypeForType) : inferFromLiteralPartsToTemplateLiteral(source.texts, source.types, target) : void 0;
        }
        function isTypeMatchedByTemplateLiteralType(source, target) {
            const inferences = inferTypesFromTemplateLiteralType(source, target);
            return !!inferences && every(inferences, (r, i)=>isValidTypeForTemplateLiteralPlaceholder(r, target.types[i]));
        }
        function getStringLikeTypeForType(type) {
            return type.flags & 402653317 /* StringLike */  ? type : getTemplateLiteralType([
                "",
                ""
            ], [
                type
            ]);
        }
        function inferFromLiteralPartsToTemplateLiteral(sourceTexts, sourceTypes, target) {
            const lastSourceIndex = sourceTexts.length - 1;
            const sourceStartText = sourceTexts[0];
            const sourceEndText = sourceTexts[lastSourceIndex];
            const targetTexts = target.texts;
            const lastTargetIndex = targetTexts.length - 1;
            const targetStartText = targetTexts[0];
            const targetEndText = targetTexts[lastTargetIndex];
            if (lastSourceIndex === 0 && sourceStartText.length < targetStartText.length + targetEndText.length || !sourceStartText.startsWith(targetStartText) || !sourceEndText.endsWith(targetEndText)) return void 0;
            const remainingEndText = sourceEndText.slice(0, sourceEndText.length - targetEndText.length);
            const matches = [];
            let seg = 0;
            let pos = targetStartText.length;
            for(let i = 1; i < lastTargetIndex; i++){
                const delim = targetTexts[i];
                if (delim.length > 0) {
                    let s = seg;
                    let p = pos;
                    while(true){
                        p = getSourceText(s).indexOf(delim, p);
                        if (p >= 0) break;
                        s++;
                        if (s === sourceTexts.length) return void 0;
                        p = 0;
                    }
                    addMatch(s, p);
                    pos += delim.length;
                } else if (pos < getSourceText(seg).length) addMatch(seg, pos + 1);
                else if (seg < lastSourceIndex) addMatch(seg + 1, 0);
                else return void 0;
            }
            addMatch(lastSourceIndex, getSourceText(lastSourceIndex).length);
            return matches;
            function getSourceText(index) {
                return index < lastSourceIndex ? sourceTexts[index] : remainingEndText;
            }
            function addMatch(s, p) {
                const matchType = s === seg ? getStringLiteralType(getSourceText(s).slice(pos, p)) : getTemplateLiteralType([
                    sourceTexts[seg].slice(pos),
                    ...sourceTexts.slice(seg + 1, s),
                    getSourceText(s).slice(0, p)
                ], sourceTypes.slice(seg, s));
                matches.push(matchType);
                seg = s;
                pos = p;
            }
        }
        function inferTypes(inferences, originalSource, originalTarget, priority = 0 /* None */ , contravariant = false) {
            let bivariant = false;
            let propagationType;
            let inferencePriority = 2048 /* MaxValue */ ;
            let allowComplexConstraintInference = true;
            let visited;
            let sourceStack;
            let targetStack;
            let expandingFlags = 0 /* None */ ;
            inferFromTypes(originalSource, originalTarget);
            function inferFromTypes(source, target) {
                if (!couldContainTypeVariables(target)) return;
                if (source === wildcardType) {
                    const savePropagationType = propagationType;
                    propagationType = source;
                    inferFromTypes(target, target);
                    propagationType = savePropagationType;
                    return;
                }
                if (source.aliasSymbol && source.aliasSymbol === target.aliasSymbol) {
                    if (source.aliasTypeArguments) {
                        const params = getSymbolLinks(source.aliasSymbol).typeParameters;
                        const minParams = getMinTypeArgumentCount(params);
                        const sourceTypes = fillMissingTypeArguments(source.aliasTypeArguments, params, minParams, isInJSFile(source.aliasSymbol.valueDeclaration));
                        const targetTypes = fillMissingTypeArguments(target.aliasTypeArguments, params, minParams, isInJSFile(source.aliasSymbol.valueDeclaration));
                        inferFromTypeArguments(sourceTypes, targetTypes, getAliasVariances(source.aliasSymbol));
                    }
                    return;
                }
                if (source === target && source.flags & 3145728 /* UnionOrIntersection */ ) {
                    for (const t of source.types)inferFromTypes(t, t);
                    return;
                }
                if (target.flags & 1048576 /* Union */ ) {
                    const [tempSources, tempTargets] = inferFromMatchingTypes(source.flags & 1048576 /* Union */  ? source.types : [
                        source
                    ], target.types, isTypeOrBaseIdenticalTo);
                    const [sources, targets] = inferFromMatchingTypes(tempSources, tempTargets, isTypeCloselyMatchedBy);
                    if (targets.length === 0) return;
                    target = getUnionType(targets);
                    if (sources.length === 0) {
                        inferWithPriority(source, target, 1 /* NakedTypeVariable */ );
                        return;
                    }
                    source = getUnionType(sources);
                } else if (target.flags & 2097152 /* Intersection */  && !every(target.types, isNonGenericObjectType)) {
                    if (!(source.flags & 1048576 /* Union */ )) {
                        const [sources, targets] = inferFromMatchingTypes(source.flags & 2097152 /* Intersection */  ? source.types : [
                            source
                        ], target.types, isTypeIdenticalTo);
                        if (sources.length === 0 || targets.length === 0) return;
                        source = getIntersectionType(sources);
                        target = getIntersectionType(targets);
                    }
                } else if (target.flags & 41943040 /* Substitution */ ) target = getActualTypeVariable(target);
                if (target.flags & 8650752 /* TypeVariable */ ) {
                    if (isFromInferenceBlockedSource(source)) return;
                    const inference = getInferenceInfoForType(target);
                    if (inference) {
                        if (getObjectFlags(source) & 262144 /* NonInferrableType */  || source === nonInferrableAnyType) return;
                        if (!inference.isFixed) {
                            if (inference.priority === void 0 || priority < inference.priority) {
                                inference.candidates = void 0;
                                inference.contraCandidates = void 0;
                                inference.topLevel = true;
                                inference.priority = priority;
                            }
                            if (priority === inference.priority) {
                                const candidate = propagationType || source;
                                if (contravariant && !bivariant) {
                                    if (!contains(inference.contraCandidates, candidate)) {
                                        inference.contraCandidates = append(inference.contraCandidates, candidate);
                                        clearCachedInferences(inferences);
                                    }
                                } else if (!contains(inference.candidates, candidate)) {
                                    inference.candidates = append(inference.candidates, candidate);
                                    clearCachedInferences(inferences);
                                }
                            }
                            if (!(priority & 128 /* ReturnType */ ) && target.flags & 262144 /* TypeParameter */  && inference.topLevel && !isTypeParameterAtTopLevel(originalTarget, target)) {
                                inference.topLevel = false;
                                clearCachedInferences(inferences);
                            }
                        }
                        inferencePriority = Math.min(inferencePriority, priority);
                        return;
                    }
                    const simplified = getSimplifiedType(target, /*writing*/ false);
                    if (simplified !== target) inferFromTypes(source, simplified);
                    else if (target.flags & 8388608 /* IndexedAccess */ ) {
                        const indexType = getSimplifiedType(target.indexType, /*writing*/ false);
                        if (indexType.flags & 465829888 /* Instantiable */ ) {
                            const simplified2 = distributeIndexOverObjectType(getSimplifiedType(target.objectType, /*writing*/ false), indexType, /*writing*/ false);
                            if (simplified2 && simplified2 !== target) inferFromTypes(source, simplified2);
                        }
                    }
                }
                if (getObjectFlags(source) & 4 /* Reference */  && getObjectFlags(target) & 4 /* Reference */  && (source.target === target.target || isArrayType(source) && isArrayType(target)) && !(source.node && target.node)) inferFromTypeArguments(getTypeArguments(source), getTypeArguments(target), getVariances(source.target));
                else if (source.flags & 4194304 /* Index */  && target.flags & 4194304 /* Index */ ) inferFromContravariantTypes(source.type, target.type);
                else if ((isLiteralType(source) || source.flags & 4 /* String */ ) && target.flags & 4194304 /* Index */ ) {
                    const empty = createEmptyObjectTypeFromStringLiteral(source);
                    inferFromContravariantTypesWithPriority(empty, target.type, 256 /* LiteralKeyof */ );
                } else if (source.flags & 8388608 /* IndexedAccess */  && target.flags & 8388608 /* IndexedAccess */ ) {
                    inferFromTypes(source.objectType, target.objectType);
                    inferFromTypes(source.indexType, target.indexType);
                } else if (source.flags & 268435456 /* StringMapping */  && target.flags & 268435456 /* StringMapping */ ) {
                    if (source.symbol === target.symbol) inferFromTypes(source.type, target.type);
                } else if (source.flags & 33554432 /* Substitution */ ) {
                    inferFromTypes(source.baseType, target);
                    inferWithPriority(getSubstitutionIntersection(source), target, 4 /* SubstituteSource */ );
                } else if (target.flags & 16777216 /* Conditional */ ) invokeOnce(source, target, inferToConditionalType);
                else if (target.flags & 3145728 /* UnionOrIntersection */ ) inferToMultipleTypes(source, target.types, target.flags);
                else if (source.flags & 1048576 /* Union */ ) {
                    const sourceTypes = source.types;
                    for (const sourceType of sourceTypes)inferFromTypes(sourceType, target);
                } else if (target.flags & 134217728 /* TemplateLiteral */ ) inferToTemplateLiteralType(source, target);
                else {
                    source = getReducedType(source);
                    if (!(priority & 512 /* NoConstraints */  && source.flags & 467927040 /* Instantiable */ )) {
                        const apparentSource = getApparentType(source);
                        if (apparentSource !== source && allowComplexConstraintInference && !(apparentSource.flags & 2621440 /* Intersection */ )) {
                            allowComplexConstraintInference = false;
                            return inferFromTypes(apparentSource, target);
                        }
                        source = apparentSource;
                    }
                    if (source.flags & 2621440 /* Intersection */ ) invokeOnce(source, target, inferFromObjectTypes);
                }
            }
            function inferWithPriority(source, target, newPriority) {
                const savePriority = priority;
                priority |= newPriority;
                inferFromTypes(source, target);
                priority = savePriority;
            }
            function inferFromContravariantTypesWithPriority(source, target, newPriority) {
                const savePriority = priority;
                priority |= newPriority;
                inferFromContravariantTypes(source, target);
                priority = savePriority;
            }
            function inferToMultipleTypesWithPriority(source, targets, targetFlags, newPriority) {
                const savePriority = priority;
                priority |= newPriority;
                inferToMultipleTypes(source, targets, targetFlags);
                priority = savePriority;
            }
            function invokeOnce(source, target, action) {
                const key = source.id + "," + target.id;
                const status = visited && visited.get(key);
                if (status !== void 0) {
                    inferencePriority = Math.min(inferencePriority, status);
                    return;
                }
                (visited || (visited = /* @__PURE__ */ new Map())).set(key, -1 /* Circularity */ );
                const saveInferencePriority = inferencePriority;
                inferencePriority = 2048 /* MaxValue */ ;
                const saveExpandingFlags = expandingFlags;
                (sourceStack ?? (sourceStack = [])).push(source);
                (targetStack ?? (targetStack = [])).push(target);
                if (isDeeplyNestedType(source, sourceStack, sourceStack.length, 2)) expandingFlags |= 1 /* Source */ ;
                if (isDeeplyNestedType(target, targetStack, targetStack.length, 2)) expandingFlags |= 2 /* Target */ ;
                if (expandingFlags !== 3 /* Both */ ) action(source, target);
                else inferencePriority = -1 /* Circularity */ ;
                targetStack.pop();
                sourceStack.pop();
                expandingFlags = saveExpandingFlags;
                visited.set(key, inferencePriority);
                inferencePriority = Math.min(inferencePriority, saveInferencePriority);
            }
            function inferFromMatchingTypes(sources, targets, matches) {
                let matchedSources;
                let matchedTargets;
                for (const t of targets){
                    for (const s of sources)if (matches(s, t)) {
                        inferFromTypes(s, t);
                        matchedSources = appendIfUnique(matchedSources, s);
                        matchedTargets = appendIfUnique(matchedTargets, t);
                    }
                }
                return [
                    matchedSources ? filter(sources, (t)=>!contains(matchedSources, t)) : sources,
                    matchedTargets ? filter(targets, (t)=>!contains(matchedTargets, t)) : targets
                ];
            }
            function inferFromTypeArguments(sourceTypes, targetTypes, variances) {
                const count = sourceTypes.length < targetTypes.length ? sourceTypes.length : targetTypes.length;
                for(let i = 0; i < count; i++)if (i < variances.length && (variances[i] & 7 /* VarianceMask */ ) === 2 /* Contravariant */ ) inferFromContravariantTypes(sourceTypes[i], targetTypes[i]);
                else inferFromTypes(sourceTypes[i], targetTypes[i]);
            }
            function inferFromContravariantTypes(source, target) {
                contravariant = !contravariant;
                inferFromTypes(source, target);
                contravariant = !contravariant;
            }
            function inferFromContravariantTypesIfStrictFunctionTypes(source, target) {
                if (strictFunctionTypes || priority & 1024 /* AlwaysStrict */ ) inferFromContravariantTypes(source, target);
                else inferFromTypes(source, target);
            }
            function getInferenceInfoForType(type) {
                if (type.flags & 8650752 /* TypeVariable */ ) for (const inference of inferences){
                    if (type === inference.typeParameter) return inference;
                }
                return void 0;
            }
            function getSingleTypeVariableFromIntersectionTypes(types) {
                let typeVariable;
                for (const type of types){
                    const t = type.flags & 2097152 /* Intersection */  && find(type.types, (t2)=>!!getInferenceInfoForType(t2));
                    if (!t || typeVariable && t !== typeVariable) return void 0;
                    typeVariable = t;
                }
                return typeVariable;
            }
            function inferToMultipleTypes(source, targets, targetFlags) {
                let typeVariableCount = 0;
                if (targetFlags & 1048576 /* Union */ ) {
                    let nakedTypeVariable;
                    const sources = source.flags & 1048576 /* Union */  ? source.types : [
                        source
                    ];
                    const matched = new Array(sources.length);
                    let inferenceCircularity = false;
                    for (const t of targets){
                        if (getInferenceInfoForType(t)) {
                            nakedTypeVariable = t;
                            typeVariableCount++;
                        } else for(let i = 0; i < sources.length; i++){
                            const saveInferencePriority = inferencePriority;
                            inferencePriority = 2048 /* MaxValue */ ;
                            inferFromTypes(sources[i], t);
                            if (inferencePriority === priority) matched[i] = true;
                            inferenceCircularity = inferenceCircularity || inferencePriority === -1 /* Circularity */ ;
                            inferencePriority = Math.min(inferencePriority, saveInferencePriority);
                        }
                    }
                    if (typeVariableCount === 0) {
                        const intersectionTypeVariable = getSingleTypeVariableFromIntersectionTypes(targets);
                        if (intersectionTypeVariable) inferWithPriority(source, intersectionTypeVariable, 1 /* NakedTypeVariable */ );
                        return;
                    }
                    if (typeVariableCount === 1 && !inferenceCircularity) {
                        const unmatched = flatMap(sources, (s, i)=>matched[i] ? void 0 : s);
                        if (unmatched.length) {
                            inferFromTypes(getUnionType(unmatched), nakedTypeVariable);
                            return;
                        }
                    }
                } else {
                    for (const t of targets)if (getInferenceInfoForType(t)) typeVariableCount++;
                    else inferFromTypes(source, t);
                }
                if (targetFlags & 2097152 /* Intersection */  ? typeVariableCount === 1 : typeVariableCount > 0) {
                    for (const t of targets)if (getInferenceInfoForType(t)) inferWithPriority(source, t, 1 /* NakedTypeVariable */ );
                }
            }
            function inferToMappedType(source, target, constraintType) {
                if (constraintType.flags & 1048576 /* Union */ ) {
                    let result = false;
                    for (const type of constraintType.types)result = inferToMappedType(source, target, type) || result;
                    return result;
                }
                if (constraintType.flags & 4194304 /* Index */ ) {
                    const inference = getInferenceInfoForType(constraintType.type);
                    if (inference && !inference.isFixed && !isFromInferenceBlockedSource(source)) {
                        const inferredType = inferTypeForHomomorphicMappedType(source, target, constraintType);
                        if (inferredType) inferWithPriority(inferredType, inference.typeParameter, getObjectFlags(source) & 262144 /* NonInferrableType */  ? 16 /* PartialHomomorphicMappedType */  : 8 /* HomomorphicMappedType */ );
                    }
                    return true;
                }
                if (constraintType.flags & 262144 /* TypeParameter */ ) {
                    inferWithPriority(getIndexType(source, /*indexFlags*/ !!source.pattern ? 2 /* NoIndexSignatures */  : 0 /* None */ ), constraintType, 32 /* MappedTypeConstraint */ );
                    const extendedConstraint = getConstraintOfType(constraintType);
                    if (extendedConstraint && inferToMappedType(source, target, extendedConstraint)) return true;
                    const propTypes = map(getPropertiesOfType(source), getTypeOfSymbol);
                    const indexTypes = map(getIndexInfosOfType(source), (info)=>info !== enumNumberIndexInfo ? info.type : neverType);
                    inferFromTypes(getUnionType(concatenate(propTypes, indexTypes)), getTemplateTypeFromMappedType(target));
                    return true;
                }
                return false;
            }
            function inferToConditionalType(source, target) {
                if (source.flags & 16777216 /* Conditional */ ) {
                    inferFromTypes(source.checkType, target.checkType);
                    inferFromTypes(source.extendsType, target.extendsType);
                    inferFromTypes(getTrueTypeFromConditionalType(source), getTrueTypeFromConditionalType(target));
                    inferFromTypes(getFalseTypeFromConditionalType(source), getFalseTypeFromConditionalType(target));
                } else {
                    const targetTypes = [
                        getTrueTypeFromConditionalType(target),
                        getFalseTypeFromConditionalType(target)
                    ];
                    inferToMultipleTypesWithPriority(source, targetTypes, target.flags, contravariant ? 64 /* ContravariantConditional */  : 0);
                }
            }
            function inferToTemplateLiteralType(source, target) {
                const matches = inferTypesFromTemplateLiteralType(source, target);
                const types = target.types;
                if (matches || every(target.texts, (s)=>s.length === 0)) for(let i = 0; i < types.length; i++){
                    const source2 = matches ? matches[i] : neverType;
                    const target2 = types[i];
                    if (source2.flags & 128 /* StringLiteral */  && target2.flags & 8650752 /* TypeVariable */ ) {
                        const inferenceContext = getInferenceInfoForType(target2);
                        const constraint = inferenceContext ? getBaseConstraintOfType(inferenceContext.typeParameter) : void 0;
                        if (constraint && !isTypeAny(constraint)) {
                            const constraintTypes = constraint.flags & 1048576 /* Union */  ? constraint.types : [
                                constraint
                            ];
                            let allTypeFlags = reduceLeft(constraintTypes, (flags, t)=>flags | t.flags, 0);
                            if (!(allTypeFlags & 4 /* String */ )) {
                                const str = source2.value;
                                if (allTypeFlags & 296 /* NumberLike */  && !isValidNumberString(str, /*roundTripOnly*/ true)) allTypeFlags &= -297 /* NumberLike */ ;
                                if (allTypeFlags & 2112 /* BigIntLike */  && !isValidBigIntString(str, /*roundTripOnly*/ true)) allTypeFlags &= -2113 /* BigIntLike */ ;
                                const matchingType = reduceLeft(constraintTypes, (left, right)=>!(right.flags & allTypeFlags) ? left : left.flags & 4 /* String */  ? left : right.flags & 4 /* String */  ? source2 : left.flags & 134217728 /* TemplateLiteral */  ? left : right.flags & 134217728 /* TemplateLiteral */  && isTypeMatchedByTemplateLiteralType(source2, right) ? source2 : left.flags & 268435456 /* StringMapping */  ? left : right.flags & 268435456 /* StringMapping */  && str === applyStringMapping(right.symbol, str) ? source2 : left.flags & 128 /* StringLiteral */  ? left : right.flags & 128 /* StringLiteral */  && right.value === str ? right : left.flags & 8 /* Number */  ? left : right.flags & 8 /* Number */  ? getNumberLiteralType(+str) : left.flags & 32 /* Enum */  ? left : right.flags & 32 /* Enum */  ? getNumberLiteralType(+str) : left.flags & 256 /* NumberLiteral */  ? left : right.flags & 256 /* NumberLiteral */  && right.value === +str ? right : left.flags & 64 /* BigInt */  ? left : right.flags & 64 /* BigInt */  ? parseBigIntLiteralType(str) : left.flags & 2048 /* BigIntLiteral */  ? left : right.flags & 2048 /* BigIntLiteral */  && pseudoBigIntToString(right.value) === str ? right : left.flags & 16 /* Boolean */  ? left : right.flags & 16 /* Boolean */  ? str === "true" ? trueType : str === "false" ? falseType : booleanType : left.flags & 512 /* BooleanLiteral */  ? left : right.flags & 512 /* BooleanLiteral */  && right.intrinsicName === str ? right : left.flags & 32768 /* Undefined */  ? left : right.flags & 32768 /* Undefined */  && right.intrinsicName === str ? right : left.flags & 65536 /* Null */  ? left : right.flags & 65536 /* Null */  && right.intrinsicName === str ? right : left, neverType);
                                if (!(matchingType.flags & 131072 /* Never */ )) {
                                    inferFromTypes(matchingType, target2);
                                    continue;
                                }
                            }
                        }
                    }
                    inferFromTypes(source2, target2);
                }
            }
            function inferFromObjectTypes(source, target) {
                var _a, _b;
                if (getObjectFlags(source) & 4 /* Reference */  && getObjectFlags(target) & 4 /* Reference */  && (source.target === target.target || isArrayType(source) && isArrayType(target))) {
                    inferFromTypeArguments(getTypeArguments(source), getTypeArguments(target), getVariances(source.target));
                    return;
                }
                if (isGenericMappedType(source) && isGenericMappedType(target)) {
                    inferFromTypes(getConstraintTypeFromMappedType(source), getConstraintTypeFromMappedType(target));
                    inferFromTypes(getTemplateTypeFromMappedType(source), getTemplateTypeFromMappedType(target));
                    const sourceNameType = getNameTypeFromMappedType(source);
                    const targetNameType = getNameTypeFromMappedType(target);
                    if (sourceNameType && targetNameType) inferFromTypes(sourceNameType, targetNameType);
                }
                if (getObjectFlags(target) & 32 /* Mapped */  && !target.declaration.nameType) {
                    const constraintType = getConstraintTypeFromMappedType(target);
                    if (inferToMappedType(source, target, constraintType)) return;
                }
                if (!typesDefinitelyUnrelated(source, target)) {
                    if (isArrayOrTupleType(source)) {
                        if (isTupleType(target)) {
                            const sourceArity = getTypeReferenceArity(source);
                            const targetArity = getTypeReferenceArity(target);
                            const elementTypes = getTypeArguments(target);
                            const elementFlags = target.target.elementFlags;
                            if (isTupleType(source) && isTupleTypeStructureMatching(source, target)) {
                                for(let i = 0; i < targetArity; i++)inferFromTypes(getTypeArguments(source)[i], elementTypes[i]);
                                return;
                            }
                            const startLength = isTupleType(source) ? Math.min(source.target.fixedLength, target.target.fixedLength) : 0;
                            const endLength = Math.min(isTupleType(source) ? getEndElementCount(source.target, 3 /* Fixed */ ) : 0, target.target.hasRestElement ? getEndElementCount(target.target, 3 /* Fixed */ ) : 0);
                            for(let i = 0; i < startLength; i++)inferFromTypes(getTypeArguments(source)[i], elementTypes[i]);
                            if (!isTupleType(source) || sourceArity - startLength - endLength === 1 && source.target.elementFlags[startLength] & 4 /* Rest */ ) {
                                const restType = getTypeArguments(source)[startLength];
                                for(let i = startLength; i < targetArity - endLength; i++)inferFromTypes(elementFlags[i] & 8 /* Variadic */  ? createArrayType(restType) : restType, elementTypes[i]);
                            } else {
                                const middleLength = targetArity - startLength - endLength;
                                if (middleLength === 2) {
                                    if (elementFlags[startLength] & elementFlags[startLength + 1] & 8 /* Variadic */ ) {
                                        const targetInfo = getInferenceInfoForType(elementTypes[startLength]);
                                        if (targetInfo && targetInfo.impliedArity !== void 0) {
                                            inferFromTypes(sliceTupleType(source, startLength, endLength + sourceArity - targetInfo.impliedArity), elementTypes[startLength]);
                                            inferFromTypes(sliceTupleType(source, startLength + targetInfo.impliedArity, endLength), elementTypes[startLength + 1]);
                                        }
                                    } else if (elementFlags[startLength] & 8 /* Variadic */  && elementFlags[startLength + 1] & 4 /* Rest */ ) {
                                        const param = (_a = getInferenceInfoForType(elementTypes[startLength])) == null ? void 0 : _a.typeParameter;
                                        const constraint = param && getBaseConstraintOfType(param);
                                        if (constraint && isTupleType(constraint) && !constraint.target.hasRestElement) {
                                            const impliedArity = constraint.target.fixedLength;
                                            inferFromTypes(sliceTupleType(source, startLength, sourceArity - (startLength + impliedArity)), elementTypes[startLength]);
                                            inferFromTypes(getElementTypeOfSliceOfTupleType(source, startLength + impliedArity, endLength), elementTypes[startLength + 1]);
                                        }
                                    } else if (elementFlags[startLength] & 4 /* Rest */  && elementFlags[startLength + 1] & 8 /* Variadic */ ) {
                                        const param = (_b = getInferenceInfoForType(elementTypes[startLength + 1])) == null ? void 0 : _b.typeParameter;
                                        const constraint = param && getBaseConstraintOfType(param);
                                        if (constraint && isTupleType(constraint) && !constraint.target.hasRestElement) {
                                            const impliedArity = constraint.target.fixedLength;
                                            const endIndex = sourceArity - getEndElementCount(target.target, 3 /* Fixed */ );
                                            const startIndex = endIndex - impliedArity;
                                            const trailingSlice = createTupleType(getTypeArguments(source).slice(startIndex, endIndex), source.target.elementFlags.slice(startIndex, endIndex), /*readonly*/ false, source.target.labeledElementDeclarations && source.target.labeledElementDeclarations.slice(startIndex, endIndex));
                                            inferFromTypes(getElementTypeOfSliceOfTupleType(source, startLength, endLength + impliedArity), elementTypes[startLength]);
                                            inferFromTypes(trailingSlice, elementTypes[startLength + 1]);
                                        }
                                    }
                                } else if (middleLength === 1 && elementFlags[startLength] & 8 /* Variadic */ ) {
                                    const endsInOptional = target.target.elementFlags[targetArity - 1] & 2 /* Optional */ ;
                                    const sourceSlice = sliceTupleType(source, startLength, endLength);
                                    inferWithPriority(sourceSlice, elementTypes[startLength], endsInOptional ? 2 /* SpeculativeTuple */  : 0);
                                } else if (middleLength === 1 && elementFlags[startLength] & 4 /* Rest */ ) {
                                    const restType = getElementTypeOfSliceOfTupleType(source, startLength, endLength);
                                    if (restType) inferFromTypes(restType, elementTypes[startLength]);
                                }
                            }
                            for(let i = 0; i < endLength; i++)inferFromTypes(getTypeArguments(source)[sourceArity - i - 1], elementTypes[targetArity - i - 1]);
                            return;
                        }
                        if (isArrayType(target)) {
                            inferFromIndexTypes(source, target);
                            return;
                        }
                    }
                    inferFromProperties(source, target);
                    inferFromSignatures(source, target, 0 /* Call */ );
                    inferFromSignatures(source, target, 1 /* Construct */ );
                    inferFromIndexTypes(source, target);
                }
            }
            function inferFromProperties(source, target) {
                const properties = getPropertiesOfObjectType(target);
                for (const targetProp of properties){
                    const sourceProp = getPropertyOfType(source, targetProp.escapedName);
                    if (sourceProp && !some(sourceProp.declarations, hasSkipDirectInferenceFlag)) inferFromTypes(getTypeOfSymbol(sourceProp), getTypeOfSymbol(targetProp));
                }
            }
            function inferFromSignatures(source, target, kind) {
                const sourceSignatures = getSignaturesOfType(source, kind);
                const targetSignatures = getSignaturesOfType(target, kind);
                const sourceLen = sourceSignatures.length;
                const targetLen = targetSignatures.length;
                const len = sourceLen < targetLen ? sourceLen : targetLen;
                for(let i = 0; i < len; i++)inferFromSignature(getBaseSignature(sourceSignatures[sourceLen - len + i]), getErasedSignature(targetSignatures[targetLen - len + i]));
            }
            function inferFromSignature(source, target) {
                if (!(source.flags & 64 /* IsNonInferrable */ )) {
                    const saveBivariant = bivariant;
                    const kind = target.declaration ? target.declaration.kind : 0 /* Unknown */ ;
                    bivariant = bivariant || kind === 173 /* MethodDeclaration */  || kind === 172 /* MethodSignature */  || kind === 175 /* Constructor */ ;
                    applyToParameterTypes(source, target, inferFromContravariantTypesIfStrictFunctionTypes);
                    bivariant = saveBivariant;
                }
                applyToReturnTypes(source, target, inferFromTypes);
            }
            function inferFromIndexTypes(source, target) {
                const priority2 = getObjectFlags(source) & getObjectFlags(target) & 32 /* Mapped */  ? 8 /* HomomorphicMappedType */  : 0;
                const indexInfos = getIndexInfosOfType(target);
                if (isObjectTypeWithInferableIndex(source)) for (const targetInfo of indexInfos){
                    const propTypes = [];
                    for (const prop of getPropertiesOfType(source))if (isApplicableIndexType(getLiteralTypeFromProperty(prop, 8576 /* StringOrNumberLiteralOrUnique */ ), targetInfo.keyType)) {
                        const propType = getTypeOfSymbol(prop);
                        propTypes.push(prop.flags & 16777216 /* Optional */  ? removeMissingOrUndefinedType(propType) : propType);
                    }
                    for (const info of getIndexInfosOfType(source))if (isApplicableIndexType(info.keyType, targetInfo.keyType)) propTypes.push(info.type);
                    if (propTypes.length) inferWithPriority(getUnionType(propTypes), targetInfo.type, priority2);
                }
                for (const targetInfo of indexInfos){
                    const sourceInfo = getApplicableIndexInfo(source, targetInfo.keyType);
                    if (sourceInfo) inferWithPriority(sourceInfo.type, targetInfo.type, priority2);
                }
            }
        }
        function isTypeOrBaseIdenticalTo(s, t) {
            return t === missingType ? s === t : isTypeIdenticalTo(s, t) || !!(t.flags & 4 /* String */  && s.flags & 128 /* StringLiteral */  || t.flags & 8 /* Number */  && s.flags & 256 /* NumberLiteral */ );
        }
        function isTypeCloselyMatchedBy(s, t) {
            return !!(s.flags & 524288 /* Object */  && t.flags & 524288 /* Object */  && s.symbol && s.symbol === t.symbol || s.aliasSymbol && s.aliasTypeArguments && s.aliasSymbol === t.aliasSymbol);
        }
        function hasPrimitiveConstraint(type) {
            const constraint = getConstraintOfTypeParameter(type);
            return !!constraint && maybeTypeOfKind(constraint.flags & 16777216 /* Conditional */  ? getDefaultConstraintOfConditionalType(constraint) : constraint, 406978556 /* StringMapping */ );
        }
        function isObjectLiteralType2(type) {
            return !!(getObjectFlags(type) & 128 /* ObjectLiteral */ );
        }
        function isObjectOrArrayLiteralType(type) {
            return !!(getObjectFlags(type) & 16512 /* ArrayLiteral */ );
        }
        function unionObjectAndArrayLiteralCandidates(candidates) {
            if (candidates.length > 1) {
                const objectLiterals = filter(candidates, isObjectOrArrayLiteralType);
                if (objectLiterals.length) {
                    const literalsType = getUnionType(objectLiterals, 2 /* Subtype */ );
                    return concatenate(filter(candidates, (t)=>!isObjectOrArrayLiteralType(t)), [
                        literalsType
                    ]);
                }
            }
            return candidates;
        }
        function getContravariantInference(inference) {
            return inference.priority & 416 /* PriorityImpliesCombination */  ? getIntersectionType(inference.contraCandidates) : getCommonSubtype(inference.contraCandidates);
        }
        function getCovariantInference(inference, signature) {
            const candidates = unionObjectAndArrayLiteralCandidates(inference.candidates);
            const primitiveConstraint = hasPrimitiveConstraint(inference.typeParameter) || isConstTypeVariable(inference.typeParameter);
            const widenLiteralTypes = !primitiveConstraint && inference.topLevel && (inference.isFixed || !isTypeParameterAtTopLevelInReturnType(signature, inference.typeParameter));
            const baseCandidates = primitiveConstraint ? sameMap(candidates, getRegularTypeOfLiteralType) : widenLiteralTypes ? sameMap(candidates, getWidenedLiteralType) : candidates;
            const unwidenedType = inference.priority & 416 /* PriorityImpliesCombination */  ? getUnionType(baseCandidates, 2 /* Subtype */ ) : getCommonSupertype(baseCandidates);
            return getWidenedType(unwidenedType);
        }
        function getInferredType(context, index) {
            const inference = context.inferences[index];
            if (!inference.inferredType) {
                let inferredType;
                let fallbackType;
                if (context.signature) {
                    const inferredCovariantType = inference.candidates ? getCovariantInference(inference, context.signature) : void 0;
                    const inferredContravariantType = inference.contraCandidates ? getContravariantInference(inference) : void 0;
                    if (inferredCovariantType || inferredContravariantType) {
                        const preferCovariantType = inferredCovariantType && (!inferredContravariantType || !(inferredCovariantType.flags & 131072 /* Never */ ) && some(inference.contraCandidates, (t)=>isTypeSubtypeOf(inferredCovariantType, t)) && every(context.inferences, (other)=>other !== inference && getConstraintOfTypeParameter(other.typeParameter) !== inference.typeParameter || every(other.candidates, (t)=>isTypeSubtypeOf(t, inferredCovariantType))));
                        inferredType = preferCovariantType ? inferredCovariantType : inferredContravariantType;
                        fallbackType = preferCovariantType ? inferredContravariantType : inferredCovariantType;
                    } else if (context.flags & 1 /* NoDefault */ ) inferredType = silentNeverType;
                    else {
                        const defaultType = getDefaultFromTypeParameter(inference.typeParameter);
                        if (defaultType) inferredType = instantiateType(defaultType, mergeTypeMappers(createBackreferenceMapper(context, index), context.nonFixingMapper));
                    }
                } else inferredType = getTypeFromInference(inference);
                inference.inferredType = inferredType || getDefaultTypeArgumentType(!!(context.flags & 2 /* AnyDefault */ ));
                const constraint = getConstraintOfTypeParameter(inference.typeParameter);
                if (constraint) {
                    const instantiatedConstraint = instantiateType(constraint, context.nonFixingMapper);
                    if (!inferredType || !context.compareTypes(inferredType, getTypeWithThisArgument(instantiatedConstraint, inferredType))) inference.inferredType = fallbackType && context.compareTypes(fallbackType, getTypeWithThisArgument(instantiatedConstraint, fallbackType)) ? fallbackType : instantiatedConstraint;
                }
            }
            return inference.inferredType;
        }
        function getDefaultTypeArgumentType(isInJavaScriptFile) {
            return isInJavaScriptFile ? anyType : unknownType;
        }
        function getInferredTypes(context) {
            const result = [];
            for(let i = 0; i < context.inferences.length; i++)result.push(getInferredType(context, i));
            return result;
        }
        function getCannotFindNameDiagnosticForName(node) {
            switch(node.escapedText){
                case "document":
                case "console":
                    return Diagnostics.Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_include_dom;
                case "$":
                    return compilerOptions.types ? Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slashjquery_and_then_add_jquery_to_the_types_field_in_your_tsconfig : Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slashjquery;
                case "describe":
                case "suite":
                case "it":
                case "test":
                    return compilerOptions.types ? Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_types_Slashjest_or_npm_i_save_dev_types_Slashmocha_and_then_add_jest_or_mocha_to_the_types_field_in_your_tsconfig : Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_types_Slashjest_or_npm_i_save_dev_types_Slashmocha;
                case "process":
                case "require":
                case "Buffer":
                case "module":
                    return compilerOptions.types ? Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashnode_and_then_add_node_to_the_types_field_in_your_tsconfig : Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashnode;
                case "Map":
                case "Set":
                case "Promise":
                case "Symbol":
                case "WeakMap":
                case "WeakSet":
                case "Iterator":
                case "AsyncIterator":
                case "SharedArrayBuffer":
                case "Atomics":
                case "AsyncIterable":
                case "AsyncIterableIterator":
                case "AsyncGenerator":
                case "AsyncGeneratorFunction":
                case "BigInt":
                case "Reflect":
                case "BigInt64Array":
                case "BigUint64Array":
                    return Diagnostics.Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_1_or_later;
                case "await":
                    if (isCallExpression(node.parent)) return Diagnostics.Cannot_find_name_0_Did_you_mean_to_write_this_in_an_async_function;
                default:
                    if (node.parent.kind === 303 /* ShorthandPropertyAssignment */ ) return Diagnostics.No_value_exists_in_scope_for_the_shorthand_property_0_Either_declare_one_or_provide_an_initializer;
                    else return Diagnostics.Cannot_find_name_0;
            }
        }
        function getResolvedSymbol(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedSymbol) links.resolvedSymbol = !nodeIsMissing(node) && resolveName(node, node.escapedText, 1160127 /* ExportValue */ , getCannotFindNameDiagnosticForName(node), node, !isWriteOnlyAccess(node), /*excludeGlobals*/ false) || unknownSymbol;
            return links.resolvedSymbol;
        }
        function isInTypeQuery(node) {
            return !!findAncestor(node, (n)=>n.kind === 185 /* TypeQuery */  ? true : n.kind === 80 /* Identifier */  || n.kind === 165 /* QualifiedName */  ? false : "quit");
        }
        function isInAmbientOrTypeNode(node) {
            return !!(node.flags & 16777216 /* Ambient */  || findAncestor(node, (n)=>isInterfaceDeclaration(n) || isTypeAliasDeclaration(n) || isTypeLiteralNode(n)));
        }
        function getFlowCacheKey(node, declaredType, initialType, flowContainer) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    if (!isThisInTypeQuery(node)) {
                        const symbol = getResolvedSymbol(node);
                        return symbol !== unknownSymbol ? `${flowContainer ? getNodeId(flowContainer) : "-1"}|${getTypeId(declaredType)}|${getTypeId(initialType)}|${getSymbolId(symbol)}` : void 0;
                    }
                case 110 /* ThisKeyword */ :
                    return `0|${flowContainer ? getNodeId(flowContainer) : "-1"}|${getTypeId(declaredType)}|${getTypeId(initialType)}`;
                case 234 /* NonNullExpression */ :
                case 216 /* ParenthesizedExpression */ :
                    return getFlowCacheKey(node.expression, declaredType, initialType, flowContainer);
                case 165 /* QualifiedName */ :
                    const left = getFlowCacheKey(node.left, declaredType, initialType, flowContainer);
                    return left && left + "." + node.right.escapedText;
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    const propName = getAccessedPropertyName(node);
                    if (propName !== void 0) {
                        const key = getFlowCacheKey(node.expression, declaredType, initialType, flowContainer);
                        return key && key + "." + propName;
                    }
                    break;
                case 205 /* ObjectBindingPattern */ :
                case 206 /* ArrayBindingPattern */ :
                case 261 /* FunctionDeclaration */ :
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                case 173 /* MethodDeclaration */ :
                    return `${getNodeId(node)}#${getTypeId(declaredType)}`;
            }
            return void 0;
        }
        function isMatchingReference(source, target) {
            switch(target.kind){
                case 216 /* ParenthesizedExpression */ :
                case 234 /* NonNullExpression */ :
                    return isMatchingReference(source, target.expression);
                case 225 /* BinaryExpression */ :
                    return isAssignmentExpression(target) && isMatchingReference(source, target.left) || isBinaryExpression(target) && target.operatorToken.kind === 28 /* CommaToken */  && isMatchingReference(source, target.right);
            }
            switch(source.kind){
                case 235 /* MetaProperty */ :
                    return target.kind === 235 /* MetaProperty */  && source.keywordToken === target.keywordToken && source.name.escapedText === target.name.escapedText;
                case 80 /* Identifier */ :
                case 81 /* PrivateIdentifier */ :
                    return isThisInTypeQuery(source) ? target.kind === 110 /* ThisKeyword */  : target.kind === 80 /* Identifier */  && getResolvedSymbol(source) === getResolvedSymbol(target) || (isVariableDeclaration(target) || isBindingElement(target)) && getExportSymbolOfValueSymbolIfExported(getResolvedSymbol(source)) === getSymbolOfDeclaration(target);
                case 110 /* ThisKeyword */ :
                    return target.kind === 110 /* ThisKeyword */ ;
                case 108 /* SuperKeyword */ :
                    return target.kind === 108 /* SuperKeyword */ ;
                case 234 /* NonNullExpression */ :
                case 216 /* ParenthesizedExpression */ :
                    return isMatchingReference(source.expression, target);
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    const sourcePropertyName = getAccessedPropertyName(source);
                    const targetPropertyName = isAccessExpression(target) ? getAccessedPropertyName(target) : void 0;
                    return sourcePropertyName !== void 0 && targetPropertyName !== void 0 && targetPropertyName === sourcePropertyName && isMatchingReference(source.expression, target.expression);
                case 165 /* QualifiedName */ :
                    return isAccessExpression(target) && source.right.escapedText === getAccessedPropertyName(target) && isMatchingReference(source.left, target.expression);
                case 225 /* BinaryExpression */ :
                    return isBinaryExpression(source) && source.operatorToken.kind === 28 /* CommaToken */  && isMatchingReference(source.right, target);
            }
            return false;
        }
        function getAccessedPropertyName(access) {
            if (isPropertyAccessExpression(access)) return access.name.escapedText;
            if (isElementAccessExpression(access)) return tryGetElementAccessExpressionName(access);
            if (isBindingElement(access)) {
                const name = getDestructuringPropertyName(access);
                return name ? escapeLeadingUnderscores(name) : void 0;
            }
            if (isParameter(access)) return "" + access.parent.parameters.indexOf(access);
            return void 0;
        }
        function tryGetNameFromType(type) {
            return type.flags & 8192 /* UniqueESSymbol */  ? type.escapedName : type.flags & 384 /* StringOrNumberLiteral */  ? escapeLeadingUnderscores("" + type.value) : void 0;
        }
        function tryGetElementAccessExpressionName(node) {
            return isStringOrNumericLiteralLike(node.argumentExpression) ? escapeLeadingUnderscores(node.argumentExpression.text) : isEntityNameExpression(node.argumentExpression) ? tryGetNameFromEntityNameExpression(node.argumentExpression) : void 0;
        }
        function tryGetNameFromEntityNameExpression(node) {
            const symbol = resolveEntityName(node, 111551 /* Value */ , /*ignoreErrors*/ true);
            if (!symbol || !(isConstVariable(symbol) || symbol.flags & 8 /* EnumMember */ )) return void 0;
            const declaration = symbol.valueDeclaration;
            if (declaration === void 0) return void 0;
            const type = tryGetTypeFromEffectiveTypeNode(declaration);
            if (type) {
                const name = tryGetNameFromType(type);
                if (name !== void 0) return name;
            }
            if (hasOnlyExpressionInitializer(declaration) && isBlockScopedNameDeclaredBeforeUse(declaration, node)) {
                const initializer = getEffectiveInitializer(declaration);
                if (initializer) return tryGetNameFromType(getTypeOfExpression(initializer));
                if (isEnumMember(declaration)) return getTextOfPropertyName(declaration.name);
            }
            return void 0;
        }
        function containsMatchingReference(source, target) {
            while(isAccessExpression(source)){
                source = source.expression;
                if (isMatchingReference(source, target)) return true;
            }
            return false;
        }
        function optionalChainContainsReference(source, target) {
            while(isOptionalChain(source)){
                source = source.expression;
                if (isMatchingReference(source, target)) return true;
            }
            return false;
        }
        function isDiscriminantProperty(type, name) {
            if (type && type.flags & 1048576 /* Union */ ) {
                const prop = getUnionOrIntersectionProperty(type, name);
                if (prop && getCheckFlags(prop) & 2 /* SyntheticProperty */ ) {
                    if (prop.links.isDiscriminantProperty === void 0) prop.links.isDiscriminantProperty = (prop.links.checkFlags & 192 /* Discriminant */ ) === 192 /* Discriminant */  && !isGenericType(getTypeOfSymbol(prop));
                    return !!prop.links.isDiscriminantProperty;
                }
            }
            return false;
        }
        function findDiscriminantProperties(sourceProperties, target) {
            let result;
            for (const sourceProperty of sourceProperties)if (isDiscriminantProperty(target, sourceProperty.escapedName)) {
                if (result) {
                    result.push(sourceProperty);
                    continue;
                }
                result = [
                    sourceProperty
                ];
            }
            return result;
        }
        function mapTypesByKeyProperty(types, name) {
            const map2 = /* @__PURE__ */ new Map();
            let count = 0;
            for (const type of types)if (type.flags & 61603840 /* InstantiableNonPrimitive */ ) {
                const discriminant = getTypeOfPropertyOfType(type, name);
                if (discriminant) {
                    if (!isLiteralType(discriminant)) return void 0;
                    let duplicate = false;
                    forEachType(discriminant, (t)=>{
                        const id = getTypeId(getRegularTypeOfLiteralType(t));
                        const existing = map2.get(id);
                        if (!existing) map2.set(id, type);
                        else if (existing !== unknownType) {
                            map2.set(id, unknownType);
                            duplicate = true;
                        }
                    });
                    if (!duplicate) count++;
                }
            }
            return count >= 10 && count * 2 >= types.length ? map2 : void 0;
        }
        function getKeyPropertyName(unionType) {
            const types = unionType.types;
            if (types.length < 10 || getObjectFlags(unionType) & 32768 /* PrimitiveUnion */  || countWhere(types, (t)=>!!(t.flags & 59506688 /* InstantiableNonPrimitive */ )) < 10) return void 0;
            if (unionType.keyPropertyName === void 0) {
                const keyPropertyName = forEach(types, (t)=>t.flags & 59506688 /* InstantiableNonPrimitive */  ? forEach(getPropertiesOfType(t), (p)=>isUnitType(getTypeOfSymbol(p)) ? p.escapedName : void 0) : void 0);
                const mapByKeyProperty = keyPropertyName && mapTypesByKeyProperty(types, keyPropertyName);
                unionType.keyPropertyName = mapByKeyProperty ? keyPropertyName : "";
                unionType.constituentMap = mapByKeyProperty;
            }
            return unionType.keyPropertyName.length ? unionType.keyPropertyName : void 0;
        }
        function getConstituentTypeForKeyType(unionType, keyType) {
            var _a;
            const result = (_a = unionType.constituentMap) == null ? void 0 : _a.get(getTypeId(getRegularTypeOfLiteralType(keyType)));
            return result !== unknownType ? result : void 0;
        }
        function getMatchingUnionConstituentForType(unionType, type) {
            const keyPropertyName = getKeyPropertyName(unionType);
            const propType = keyPropertyName && getTypeOfPropertyOfType(type, keyPropertyName);
            return propType && getConstituentTypeForKeyType(unionType, propType);
        }
        function getMatchingUnionConstituentForObjectLiteral(unionType, node) {
            const keyPropertyName = getKeyPropertyName(unionType);
            const propNode = keyPropertyName && find(node.properties, (p)=>p.symbol && p.kind === 302 /* PropertyAssignment */  && p.symbol.escapedName === keyPropertyName && isPossiblyDiscriminantValue(p.initializer));
            const propType = propNode && getContextFreeTypeOfExpression(propNode.initializer);
            return propType && getConstituentTypeForKeyType(unionType, propType);
        }
        function isOrContainsMatchingReference(source, target) {
            return isMatchingReference(source, target) || containsMatchingReference(source, target);
        }
        function hasMatchingArgument(expression, reference) {
            if (expression.arguments) for (const argument of expression.arguments){
                if (isOrContainsMatchingReference(reference, argument)) return true;
            }
            if (expression.expression.kind === 210 /* PropertyAccessExpression */  && isOrContainsMatchingReference(reference, expression.expression.expression)) return true;
            return false;
        }
        function getFlowNodeId(flow) {
            if (!flow.id || flow.id < 0) {
                flow.id = nextFlowId;
                nextFlowId++;
            }
            return flow.id;
        }
        function typeMaybeAssignableTo(source, target) {
            if (!(source.flags & 1048576 /* Union */ )) return isTypeAssignableTo(source, target);
            for (const t of source.types){
                if (isTypeAssignableTo(t, target)) return true;
            }
            return false;
        }
        function getAssignmentReducedType(declaredType, assignedType) {
            if (declaredType === assignedType) return declaredType;
            if (assignedType.flags & 131072 /* Never */ ) return assignedType;
            const key = `A${getTypeId(declaredType)},${getTypeId(assignedType)}`;
            return getCachedType(key) ?? setCachedType(key, getAssignmentReducedTypeWorker(declaredType, assignedType));
        }
        function getAssignmentReducedTypeWorker(declaredType, assignedType) {
            const filteredType = filterType(declaredType, (t)=>typeMaybeAssignableTo(assignedType, t));
            const reducedType = assignedType.flags & 512 /* BooleanLiteral */  && isFreshLiteralType(assignedType) ? mapType(filteredType, getFreshTypeOfLiteralType) : filteredType;
            return isTypeAssignableTo(assignedType, reducedType) ? reducedType : declaredType;
        }
        function isFunctionObjectType(type) {
            const resolved = resolveStructuredTypeMembers(type);
            return !!(resolved.callSignatures.length || resolved.constructSignatures.length || resolved.members.get("bind") && isTypeSubtypeOf(type, globalFunctionType));
        }
        function getTypeFacts(type) {
            if (type.flags & 467927040 /* Instantiable */ ) type = getBaseConstraintOfType(type) || unknownType;
            const flags = type.flags;
            if (flags & 268435460 /* StringMapping */ ) return strictNullChecks ? 16317953 /* StringStrictFacts */  : 16776705 /* StringFacts */ ;
            if (flags & 134217856 /* TemplateLiteral */ ) {
                const isEmpty = flags & 128 /* StringLiteral */  && type.value === "";
                return strictNullChecks ? isEmpty ? 12123649 /* EmptyStringStrictFacts */  : 7929345 /* NonEmptyStringStrictFacts */  : isEmpty ? 12582401 /* EmptyStringFacts */  : 16776705 /* NonEmptyStringFacts */ ;
            }
            if (flags & 40 /* Enum */ ) return strictNullChecks ? 16317698 /* NumberStrictFacts */  : 16776450 /* NumberFacts */ ;
            if (flags & 256 /* NumberLiteral */ ) {
                const isZero = type.value === 0;
                return strictNullChecks ? isZero ? 12123394 /* ZeroNumberStrictFacts */  : 7929090 /* NonZeroNumberStrictFacts */  : isZero ? 12582146 /* ZeroNumberFacts */  : 16776450 /* NonZeroNumberFacts */ ;
            }
            if (flags & 64 /* BigInt */ ) return strictNullChecks ? 16317188 /* BigIntStrictFacts */  : 16775940 /* BigIntFacts */ ;
            if (flags & 2048 /* BigIntLiteral */ ) {
                const isZero = isZeroBigInt(type);
                return strictNullChecks ? isZero ? 12122884 /* ZeroBigIntStrictFacts */  : 7928580 /* NonZeroBigIntStrictFacts */  : isZero ? 12581636 /* ZeroBigIntFacts */  : 16775940 /* NonZeroBigIntFacts */ ;
            }
            if (flags & 16 /* Boolean */ ) return strictNullChecks ? 16316168 /* BooleanStrictFacts */  : 16774920 /* BooleanFacts */ ;
            if (flags & 528 /* BooleanLike */ ) return strictNullChecks ? type === falseType || type === regularFalseType ? 12121864 /* FalseStrictFacts */  : 7927560 /* TrueStrictFacts */  : type === falseType || type === regularFalseType ? 12580616 /* FalseFacts */  : 16774920 /* TrueFacts */ ;
            if (flags & 524288 /* Object */ ) return getObjectFlags(type) & 16 /* Anonymous */  && isEmptyObjectType(type) ? strictNullChecks ? 83427327 /* EmptyObjectStrictFacts */  : 83886079 /* EmptyObjectFacts */  : isFunctionObjectType(type) ? strictNullChecks ? 7880640 /* FunctionStrictFacts */  : 16728e3 /* FunctionFacts */  : strictNullChecks ? 7888800 /* ObjectStrictFacts */  : 16736160 /* ObjectFacts */ ;
            if (flags & 16384 /* Void */ ) return 9830144 /* VoidFacts */ ;
            if (flags & 32768 /* Undefined */ ) return 26607360 /* UndefinedFacts */ ;
            if (flags & 65536 /* Null */ ) return 42917664 /* NullFacts */ ;
            if (flags & 12288 /* ESSymbolLike */ ) return strictNullChecks ? 7925520 /* SymbolStrictFacts */  : 16772880 /* SymbolFacts */ ;
            if (flags & 67108864 /* NonPrimitive */ ) return strictNullChecks ? 7888800 /* ObjectStrictFacts */  : 16736160 /* ObjectFacts */ ;
            if (flags & 131072 /* Never */ ) return 0 /* None */ ;
            if (flags & 1048576 /* Union */ ) return reduceLeft(type.types, (facts, t)=>facts | getTypeFacts(t), 0 /* None */ );
            if (flags & 2097152 /* Intersection */ ) return getIntersectionTypeFacts(type);
            return 83886079 /* UnknownFacts */ ;
        }
        function getIntersectionTypeFacts(type) {
            const ignoreObjects = maybeTypeOfKind(type, 402784252 /* Primitive */ );
            let oredFacts = 0 /* None */ ;
            let andedFacts = 134217727 /* All */ ;
            for (const t of type.types)if (!(ignoreObjects && t.flags & 524288 /* Object */ )) {
                const f = getTypeFacts(t);
                oredFacts |= f;
                andedFacts &= f;
            }
            return oredFacts & 8256 /* OrFactsMask */  | andedFacts & 134209471 /* AndFactsMask */ ;
        }
        function getTypeWithFacts(type, include) {
            return filterType(type, (t)=>(getTypeFacts(t) & include) !== 0);
        }
        function getAdjustedTypeWithFacts(type, facts) {
            const reduced = recombineUnknownType(getTypeWithFacts(strictNullChecks && type.flags & 2 /* Unknown */  ? unknownUnionType : type, facts));
            if (strictNullChecks) switch(facts){
                case 524288 /* NEUndefined */ :
                    return mapType(reduced, (t)=>getTypeFacts(t) & 65536 /* EQUndefined */  ? getIntersectionType([
                            t,
                            getTypeFacts(t) & 131072 /* EQNull */  && !maybeTypeOfKind(reduced, 65536 /* Null */ ) ? getUnionType([
                                emptyObjectType,
                                nullType
                            ]) : emptyObjectType
                        ]) : t);
                case 1048576 /* NENull */ :
                    return mapType(reduced, (t)=>getTypeFacts(t) & 131072 /* EQNull */  ? getIntersectionType([
                            t,
                            getTypeFacts(t) & 65536 /* EQUndefined */  && !maybeTypeOfKind(reduced, 32768 /* Undefined */ ) ? getUnionType([
                                emptyObjectType,
                                undefinedType
                            ]) : emptyObjectType
                        ]) : t);
                case 2097152 /* NEUndefinedOrNull */ :
                case 4194304 /* Truthy */ :
                    return mapType(reduced, (t)=>getTypeFacts(t) & 262144 /* EQUndefinedOrNull */  ? getGlobalNonNullableTypeInstantiation(t) : t);
            }
            return reduced;
        }
        function recombineUnknownType(type) {
            return type === unknownUnionType ? unknownType : type;
        }
        function getTypeWithDefault(type, defaultExpression) {
            return defaultExpression ? getUnionType([
                getNonUndefinedType(type),
                getTypeOfExpression(defaultExpression)
            ]) : type;
        }
        function getTypeOfDestructuredProperty(type, name) {
            var _a;
            const nameType = getLiteralTypeFromPropertyName(name);
            if (!isTypeUsableAsPropertyName(nameType)) return errorType;
            const text = getPropertyNameFromType(nameType);
            return getTypeOfPropertyOfType(type, text) || includeUndefinedInIndexSignature((_a = getApplicableIndexInfoForName(type, text)) == null ? void 0 : _a.type) || errorType;
        }
        function getTypeOfDestructuredArrayElement(type, index) {
            return everyType(type, isTupleLikeType) && getTupleElementType(type, index) || includeUndefinedInIndexSignature(checkIteratedTypeOrElementType(65 /* Destructuring */ , type, undefinedType, /*errorNode*/ void 0)) || errorType;
        }
        function includeUndefinedInIndexSignature(type) {
            if (!type) return type;
            return compilerOptions.noUncheckedIndexedAccess ? getUnionType([
                type,
                missingType
            ]) : type;
        }
        function getTypeOfDestructuredSpreadExpression(type) {
            return createArrayType(checkIteratedTypeOrElementType(65 /* Destructuring */ , type, undefinedType, /*errorNode*/ void 0) || errorType);
        }
        function getAssignedTypeOfBinaryExpression(node) {
            const isDestructuringDefaultAssignment = node.parent.kind === 208 /* ArrayLiteralExpression */  && isDestructuringAssignmentTarget(node.parent) || node.parent.kind === 302 /* PropertyAssignment */  && isDestructuringAssignmentTarget(node.parent.parent);
            return isDestructuringDefaultAssignment ? getTypeWithDefault(getAssignedType(node), node.right) : getTypeOfExpression(node.right);
        }
        function isDestructuringAssignmentTarget(parent2) {
            return parent2.parent.kind === 225 /* BinaryExpression */  && parent2.parent.left === parent2 || parent2.parent.kind === 249 /* ForOfStatement */  && parent2.parent.initializer === parent2;
        }
        function getAssignedTypeOfArrayLiteralElement(node, element) {
            return getTypeOfDestructuredArrayElement(getAssignedType(node), node.elements.indexOf(element));
        }
        function getAssignedTypeOfSpreadExpression(node) {
            return getTypeOfDestructuredSpreadExpression(getAssignedType(node.parent));
        }
        function getAssignedTypeOfPropertyAssignment(node) {
            return getTypeOfDestructuredProperty(getAssignedType(node.parent), node.name);
        }
        function getAssignedTypeOfShorthandPropertyAssignment(node) {
            return getTypeWithDefault(getAssignedTypeOfPropertyAssignment(node), node.objectAssignmentInitializer);
        }
        function getAssignedType(node) {
            const { parent: parent2  } = node;
            switch(parent2.kind){
                case 248 /* ForInStatement */ :
                    return stringType;
                case 249 /* ForOfStatement */ :
                    return checkRightHandSideOfForOf(parent2) || errorType;
                case 225 /* BinaryExpression */ :
                    return getAssignedTypeOfBinaryExpression(parent2);
                case 219 /* DeleteExpression */ :
                    return undefinedType;
                case 208 /* ArrayLiteralExpression */ :
                    return getAssignedTypeOfArrayLiteralElement(parent2, node);
                case 229 /* SpreadElement */ :
                    return getAssignedTypeOfSpreadExpression(parent2);
                case 302 /* PropertyAssignment */ :
                    return getAssignedTypeOfPropertyAssignment(parent2);
                case 303 /* ShorthandPropertyAssignment */ :
                    return getAssignedTypeOfShorthandPropertyAssignment(parent2);
            }
            return errorType;
        }
        function getInitialTypeOfBindingElement(node) {
            const pattern = node.parent;
            const parentType = getInitialType(pattern.parent);
            const type = pattern.kind === 205 /* ObjectBindingPattern */  ? getTypeOfDestructuredProperty(parentType, node.propertyName || node.name) : !node.dotDotDotToken ? getTypeOfDestructuredArrayElement(parentType, pattern.elements.indexOf(node)) : getTypeOfDestructuredSpreadExpression(parentType);
            return getTypeWithDefault(type, node.initializer);
        }
        function getTypeOfInitializer(node) {
            const links = getNodeLinks(node);
            return links.resolvedType || getTypeOfExpression(node);
        }
        function getInitialTypeOfVariableDeclaration(node) {
            if (node.initializer) return getTypeOfInitializer(node.initializer);
            if (node.parent.parent.kind === 248 /* ForInStatement */ ) return stringType;
            if (node.parent.parent.kind === 249 /* ForOfStatement */ ) return checkRightHandSideOfForOf(node.parent.parent) || errorType;
            return errorType;
        }
        function getInitialType(node) {
            return node.kind === 259 /* VariableDeclaration */  ? getInitialTypeOfVariableDeclaration(node) : getInitialTypeOfBindingElement(node);
        }
        function isEmptyArrayAssignment(node) {
            return node.kind === 259 /* VariableDeclaration */  && node.initializer && isEmptyArrayLiteral2(node.initializer) || node.kind !== 207 /* BindingElement */  && node.parent.kind === 225 /* BinaryExpression */  && isEmptyArrayLiteral2(node.parent.right);
        }
        function getReferenceCandidate(node) {
            switch(node.kind){
                case 216 /* ParenthesizedExpression */ :
                    return getReferenceCandidate(node.expression);
                case 225 /* BinaryExpression */ :
                    switch(node.operatorToken.kind){
                        case 64 /* EqualsToken */ :
                        case 76 /* BarBarEqualsToken */ :
                        case 77 /* AmpersandAmpersandEqualsToken */ :
                        case 78 /* QuestionQuestionEqualsToken */ :
                            return getReferenceCandidate(node.left);
                        case 28 /* CommaToken */ :
                            return getReferenceCandidate(node.right);
                    }
            }
            return node;
        }
        function getReferenceRoot(node) {
            const { parent: parent2  } = node;
            return parent2.kind === 216 /* ParenthesizedExpression */  || parent2.kind === 225 /* BinaryExpression */  && parent2.operatorToken.kind === 64 /* EqualsToken */  && parent2.left === node || parent2.kind === 225 /* BinaryExpression */  && parent2.operatorToken.kind === 28 /* CommaToken */  && parent2.right === node ? getReferenceRoot(parent2) : node;
        }
        function getTypeOfSwitchClause(clause) {
            if (clause.kind === 295 /* CaseClause */ ) return getRegularTypeOfLiteralType(getTypeOfExpression(clause.expression));
            return neverType;
        }
        function getSwitchClauseTypes(switchStatement) {
            const links = getNodeLinks(switchStatement);
            if (!links.switchTypes) {
                links.switchTypes = [];
                for (const clause of switchStatement.caseBlock.clauses)links.switchTypes.push(getTypeOfSwitchClause(clause));
            }
            return links.switchTypes;
        }
        function getSwitchClauseTypeOfWitnesses(switchStatement) {
            if (some(switchStatement.caseBlock.clauses, (clause)=>clause.kind === 295 /* CaseClause */  && !isStringLiteralLike(clause.expression))) return void 0;
            const witnesses = [];
            for (const clause of switchStatement.caseBlock.clauses){
                const text = clause.kind === 295 /* CaseClause */  ? clause.expression.text : void 0;
                witnesses.push(text && !contains(witnesses, text) ? text : void 0);
            }
            return witnesses;
        }
        function eachTypeContainedIn(source, types) {
            return source.flags & 1048576 /* Union */  ? !forEach(source.types, (t)=>!contains(types, t)) : contains(types, source);
        }
        function isTypeSubsetOf(source, target) {
            return !!(source === target || source.flags & 131072 /* Never */  || target.flags & 1048576 /* Union */  && isTypeSubsetOfUnion(source, target));
        }
        function isTypeSubsetOfUnion(source, target) {
            if (source.flags & 1048576 /* Union */ ) {
                for (const t of source.types){
                    if (!containsType(target.types, t)) return false;
                }
                return true;
            }
            if (source.flags & 1056 /* EnumLike */  && getBaseTypeOfEnumLikeType(source) === target) return true;
            return containsType(target.types, source);
        }
        function forEachType(type, f) {
            return type.flags & 1048576 /* Union */  ? forEach(type.types, f) : f(type);
        }
        function someType(type, f) {
            return type.flags & 1048576 /* Union */  ? some(type.types, f) : f(type);
        }
        function everyType(type, f) {
            return type.flags & 1048576 /* Union */  ? every(type.types, f) : f(type);
        }
        function everyContainedType(type, f) {
            return type.flags & 3145728 /* UnionOrIntersection */  ? every(type.types, f) : f(type);
        }
        function filterType(type, f) {
            if (type.flags & 1048576 /* Union */ ) {
                const types = type.types;
                const filtered = filter(types, f);
                if (filtered === types) return type;
                const origin = type.origin;
                let newOrigin;
                if (origin && origin.flags & 1048576 /* Union */ ) {
                    const originTypes = origin.types;
                    const originFiltered = filter(originTypes, (t)=>!!(t.flags & 1048576 /* Union */ ) || f(t));
                    if (originTypes.length - originFiltered.length === types.length - filtered.length) {
                        if (originFiltered.length === 1) return originFiltered[0];
                        newOrigin = createOriginUnionOrIntersectionType(1048576 /* Union */ , originFiltered);
                    }
                }
                return getUnionTypeFromSortedList(filtered, type.objectFlags & 16809984 /* ContainsIntersections */ , /*aliasSymbol*/ void 0, /*aliasTypeArguments*/ void 0, newOrigin);
            }
            return type.flags & 131072 /* Never */  || f(type) ? type : neverType;
        }
        function removeType(type, targetType) {
            return filterType(type, (t)=>t !== targetType);
        }
        function countTypes(type) {
            return type.flags & 1048576 /* Union */  ? type.types.length : 1;
        }
        function mapType(type, mapper, noReductions) {
            if (type.flags & 131072 /* Never */ ) return type;
            if (!(type.flags & 1048576 /* Union */ )) return mapper(type);
            const origin = type.origin;
            const types = origin && origin.flags & 1048576 /* Union */  ? origin.types : type.types;
            let mappedTypes;
            let changed = false;
            for (const t of types){
                const mapped = t.flags & 1048576 /* Union */  ? mapType(t, mapper, noReductions) : mapper(t);
                changed || (changed = t !== mapped);
                if (mapped) {
                    if (!mappedTypes) mappedTypes = [
                        mapped
                    ];
                    else mappedTypes.push(mapped);
                }
            }
            return changed ? mappedTypes && getUnionType(mappedTypes, noReductions ? 0 /* None */  : 1 /* Literal */ ) : type;
        }
        function mapTypeWithAlias(type, mapper, aliasSymbol, aliasTypeArguments) {
            return type.flags & 1048576 /* Union */  && aliasSymbol ? getUnionType(map(type.types, mapper), 1 /* Literal */ , aliasSymbol, aliasTypeArguments) : mapType(type, mapper);
        }
        function extractTypesOfKind(type, kind) {
            return filterType(type, (t)=>(t.flags & kind) !== 0);
        }
        function replacePrimitivesWithLiterals(typeWithPrimitives, typeWithLiterals) {
            if (maybeTypeOfKind(typeWithPrimitives, 134217804 /* BigInt */ ) && maybeTypeOfKind(typeWithLiterals, 402655616 /* BigIntLiteral */ )) return mapType(typeWithPrimitives, (t)=>t.flags & 4 /* String */  ? extractTypesOfKind(typeWithLiterals, 402653316 /* StringMapping */ ) : isPatternLiteralType(t) && !maybeTypeOfKind(typeWithLiterals, 402653188 /* StringMapping */ ) ? extractTypesOfKind(typeWithLiterals, 128 /* StringLiteral */ ) : t.flags & 8 /* Number */  ? extractTypesOfKind(typeWithLiterals, 264 /* NumberLiteral */ ) : t.flags & 64 /* BigInt */  ? extractTypesOfKind(typeWithLiterals, 2112 /* BigIntLiteral */ ) : t);
            return typeWithPrimitives;
        }
        function isIncomplete(flowType) {
            return flowType.flags === 0;
        }
        function getTypeFromFlowType(flowType) {
            return flowType.flags === 0 ? flowType.type : flowType;
        }
        function createFlowType(type, incomplete) {
            return incomplete ? {
                flags: 0,
                type: type.flags & 131072 /* Never */  ? silentNeverType : type
            } : type;
        }
        function createEvolvingArrayType(elementType) {
            const result = createObjectType(256 /* EvolvingArray */ );
            result.elementType = elementType;
            return result;
        }
        function getEvolvingArrayType(elementType) {
            return evolvingArrayTypes[elementType.id] || (evolvingArrayTypes[elementType.id] = createEvolvingArrayType(elementType));
        }
        function addEvolvingArrayElementType(evolvingArrayType, node) {
            const elementType = getRegularTypeOfObjectLiteral(getBaseTypeOfLiteralType(getContextFreeTypeOfExpression(node)));
            return isTypeSubsetOf(elementType, evolvingArrayType.elementType) ? evolvingArrayType : getEvolvingArrayType(getUnionType([
                evolvingArrayType.elementType,
                elementType
            ]));
        }
        function createFinalArrayType(elementType) {
            return elementType.flags & 131072 /* Never */  ? autoArrayType : createArrayType(elementType.flags & 1048576 /* Union */  ? getUnionType(elementType.types, 2 /* Subtype */ ) : elementType);
        }
        function getFinalArrayType(evolvingArrayType) {
            return evolvingArrayType.finalArrayType || (evolvingArrayType.finalArrayType = createFinalArrayType(evolvingArrayType.elementType));
        }
        function finalizeEvolvingArrayType(type) {
            return getObjectFlags(type) & 256 /* EvolvingArray */  ? getFinalArrayType(type) : type;
        }
        function getElementTypeOfEvolvingArrayType(type) {
            return getObjectFlags(type) & 256 /* EvolvingArray */  ? type.elementType : neverType;
        }
        function isEvolvingArrayTypeList(types) {
            let hasEvolvingArrayType = false;
            for (const t of types)if (!(t.flags & 131072 /* Never */ )) {
                if (!(getObjectFlags(t) & 256 /* EvolvingArray */ )) return false;
                hasEvolvingArrayType = true;
            }
            return hasEvolvingArrayType;
        }
        function isEvolvingArrayOperationTarget(node) {
            const root = getReferenceRoot(node);
            const parent2 = root.parent;
            const isLengthPushOrUnshift = isPropertyAccessExpression(parent2) && (parent2.name.escapedText === "length" || parent2.parent.kind === 212 /* CallExpression */  && isIdentifier(parent2.name) && isPushOrUnshiftIdentifier(parent2.name));
            const isElementAssignment = parent2.kind === 211 /* ElementAccessExpression */  && parent2.expression === root && parent2.parent.kind === 225 /* BinaryExpression */  && parent2.parent.operatorToken.kind === 64 /* EqualsToken */  && parent2.parent.left === parent2 && !isAssignmentTarget(parent2.parent) && isTypeAssignableToKind(getTypeOfExpression(parent2.argumentExpression), 296 /* NumberLike */ );
            return isLengthPushOrUnshift || isElementAssignment;
        }
        function isDeclarationWithExplicitTypeAnnotation(node) {
            return (isVariableDeclaration(node) || isPropertyDeclaration(node) || isPropertySignature(node) || isParameter(node)) && !!(getEffectiveTypeAnnotationNode(node) || isInJSFile(node) && hasInitializer(node) && node.initializer && isFunctionExpressionOrArrowFunction(node.initializer) && getEffectiveReturnTypeNode(node.initializer));
        }
        function getExplicitTypeOfSymbol(symbol, diagnostic) {
            symbol = resolveSymbol(symbol);
            if (symbol.flags & 8752 /* ValueModule */ ) return getTypeOfSymbol(symbol);
            if (symbol.flags & 7 /* Property */ ) {
                if (getCheckFlags(symbol) & 262144 /* Mapped */ ) {
                    const origin = symbol.links.syntheticOrigin;
                    if (origin && getExplicitTypeOfSymbol(origin)) return getTypeOfSymbol(symbol);
                }
                const declaration = symbol.valueDeclaration;
                if (declaration) {
                    if (isDeclarationWithExplicitTypeAnnotation(declaration)) return getTypeOfSymbol(symbol);
                    if (isVariableDeclaration(declaration) && declaration.parent.parent.kind === 249 /* ForOfStatement */ ) {
                        const statement = declaration.parent.parent;
                        const expressionType = getTypeOfDottedName(statement.expression, /*diagnostic*/ void 0);
                        if (expressionType) {
                            const use = statement.awaitModifier ? 15 /* ForAwaitOf */  : 13 /* ForOf */ ;
                            return checkIteratedTypeOrElementType(use, expressionType, undefinedType, /*errorNode*/ void 0);
                        }
                    }
                    if (diagnostic) addRelatedInfo(diagnostic, createDiagnosticForNode(declaration, Diagnostics._0_needs_an_explicit_type_annotation, symbolToString(symbol)));
                }
            }
        }
        function getTypeOfDottedName(node, diagnostic) {
            if (!(node.flags & 33554432 /* InWithStatement */ )) switch(node.kind){
                case 80 /* Identifier */ :
                    const symbol = getExportSymbolOfValueSymbolIfExported(getResolvedSymbol(node));
                    return getExplicitTypeOfSymbol(symbol, diagnostic);
                case 110 /* ThisKeyword */ :
                    return getExplicitThisType(node);
                case 108 /* SuperKeyword */ :
                    return checkSuperExpression(node);
                case 210 /* PropertyAccessExpression */ :
                    {
                        const type = getTypeOfDottedName(node.expression, diagnostic);
                        if (type) {
                            const name = node.name;
                            let prop;
                            if (isPrivateIdentifier(name)) {
                                if (!type.symbol) return void 0;
                                prop = getPropertyOfType(type, getSymbolNameForPrivateIdentifier(type.symbol, name.escapedText));
                            } else prop = getPropertyOfType(type, name.escapedText);
                            return prop && getExplicitTypeOfSymbol(prop, diagnostic);
                        }
                        return void 0;
                    }
                case 216 /* ParenthesizedExpression */ :
                    return getTypeOfDottedName(node.expression, diagnostic);
            }
        }
        function getEffectsSignature(node) {
            const links = getNodeLinks(node);
            let signature = links.effectsSignature;
            if (signature === void 0) {
                let funcType;
                if (node.parent.kind === 243 /* ExpressionStatement */ ) funcType = getTypeOfDottedName(node.expression, /*diagnostic*/ void 0);
                else if (node.expression.kind !== 108 /* SuperKeyword */ ) {
                    if (isOptionalChain(node)) funcType = checkNonNullType(getOptionalExpressionType(checkExpression(node.expression), node.expression), node.expression);
                    else funcType = checkNonNullExpression(node.expression);
                }
                const signatures = getSignaturesOfType(funcType && getApparentType(funcType) || unknownType, 0 /* Call */ );
                const candidate = signatures.length === 1 && !signatures[0].typeParameters ? signatures[0] : some(signatures, hasTypePredicateOrNeverReturnType) ? getResolvedSignature(node) : void 0;
                signature = links.effectsSignature = candidate && hasTypePredicateOrNeverReturnType(candidate) ? candidate : unknownSignature;
            }
            return signature === unknownSignature ? void 0 : signature;
        }
        function hasTypePredicateOrNeverReturnType(signature) {
            return !!(getTypePredicateOfSignature(signature) || signature.declaration && (getReturnTypeFromAnnotation(signature.declaration) || unknownType).flags & 131072 /* Never */ );
        }
        function getTypePredicateArgument(predicate, callExpression) {
            if (predicate.kind === 1 /* Identifier */  || predicate.kind === 3 /* AssertsIdentifier */ ) return callExpression.arguments[predicate.parameterIndex];
            const invokedExpression = skipParentheses(callExpression.expression);
            return isAccessExpression(invokedExpression) ? skipParentheses(invokedExpression.expression) : void 0;
        }
        function reportFlowControlError(node) {
            const block = findAncestor(node, isFunctionOrModuleBlock);
            const sourceFile = getSourceFileOfNode(node);
            const span = getSpanOfTokenAtPosition(sourceFile, block.statements.pos);
            diagnostics.add(createFileDiagnostic(sourceFile, span.start, span.length, Diagnostics.The_containing_function_or_module_body_is_too_large_for_control_flow_analysis));
        }
        function isReachableFlowNode(flow) {
            const result = isReachableFlowNodeWorker(flow, /*noCacheCheck*/ false);
            lastFlowNode = flow;
            lastFlowNodeReachable = result;
            return result;
        }
        function isFalseExpression(expr) {
            const node = skipParentheses(expr, /*excludeJSDocTypeAssertions*/ true);
            return node.kind === 97 /* FalseKeyword */  || node.kind === 225 /* BinaryExpression */  && (node.operatorToken.kind === 56 /* AmpersandAmpersandToken */  && (isFalseExpression(node.left) || isFalseExpression(node.right)) || node.operatorToken.kind === 57 /* BarBarToken */  && isFalseExpression(node.left) && isFalseExpression(node.right));
        }
        function isReachableFlowNodeWorker(flow, noCacheCheck) {
            while(true){
                if (flow === lastFlowNode) return lastFlowNodeReachable;
                const flags = flow.flags;
                if (flags & 4096 /* Shared */ ) {
                    if (!noCacheCheck) {
                        const id = getFlowNodeId(flow);
                        const reachable = flowNodeReachable[id];
                        return reachable !== void 0 ? reachable : flowNodeReachable[id] = isReachableFlowNodeWorker(flow, /*noCacheCheck*/ true);
                    }
                    noCacheCheck = false;
                }
                if (flags & 368 /* ArrayMutation */ ) flow = flow.antecedent;
                else if (flags & 512 /* Call */ ) {
                    const signature = getEffectsSignature(flow.node);
                    if (signature) {
                        const predicate = getTypePredicateOfSignature(signature);
                        if (predicate && predicate.kind === 3 /* AssertsIdentifier */  && !predicate.type) {
                            const predicateArgument = flow.node.arguments[predicate.parameterIndex];
                            if (predicateArgument && isFalseExpression(predicateArgument)) return false;
                        }
                        if (getReturnTypeOfSignature(signature).flags & 131072 /* Never */ ) return false;
                    }
                    flow = flow.antecedent;
                } else if (flags & 4 /* BranchLabel */ ) return some(flow.antecedents, (f)=>isReachableFlowNodeWorker(f, /*noCacheCheck*/ false));
                else if (flags & 8 /* LoopLabel */ ) {
                    const antecedents = flow.antecedents;
                    if (antecedents === void 0 || antecedents.length === 0) return false;
                    flow = antecedents[0];
                } else if (flags & 128 /* SwitchClause */ ) {
                    if (flow.clauseStart === flow.clauseEnd && isExhaustiveSwitchStatement(flow.switchStatement)) return false;
                    flow = flow.antecedent;
                } else if (flags & 1024 /* ReduceLabel */ ) {
                    lastFlowNode = void 0;
                    const target = flow.target;
                    const saveAntecedents = target.antecedents;
                    target.antecedents = flow.antecedents;
                    const result = isReachableFlowNodeWorker(flow.antecedent, /*noCacheCheck*/ false);
                    target.antecedents = saveAntecedents;
                    return result;
                } else return !(flags & 1 /* Unreachable */ );
            }
        }
        function isPostSuperFlowNode(flow, noCacheCheck) {
            while(true){
                const flags = flow.flags;
                if (flags & 4096 /* Shared */ ) {
                    if (!noCacheCheck) {
                        const id = getFlowNodeId(flow);
                        const postSuper = flowNodePostSuper[id];
                        return postSuper !== void 0 ? postSuper : flowNodePostSuper[id] = isPostSuperFlowNode(flow, /*noCacheCheck*/ true);
                    }
                    noCacheCheck = false;
                }
                if (flags & 496 /* SwitchClause */ ) flow = flow.antecedent;
                else if (flags & 512 /* Call */ ) {
                    if (flow.node.expression.kind === 108 /* SuperKeyword */ ) return true;
                    flow = flow.antecedent;
                } else if (flags & 4 /* BranchLabel */ ) return every(flow.antecedents, (f)=>isPostSuperFlowNode(f, /*noCacheCheck*/ false));
                else if (flags & 8 /* LoopLabel */ ) flow = flow.antecedents[0];
                else if (flags & 1024 /* ReduceLabel */ ) {
                    const target = flow.target;
                    const saveAntecedents = target.antecedents;
                    target.antecedents = flow.antecedents;
                    const result = isPostSuperFlowNode(flow.antecedent, /*noCacheCheck*/ false);
                    target.antecedents = saveAntecedents;
                    return result;
                } else return !!(flags & 1 /* Unreachable */ );
            }
        }
        function isConstantReference(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    if (!isThisInTypeQuery(node)) {
                        const symbol = getResolvedSymbol(node);
                        return isConstVariable(symbol) || isParameterOrCatchClauseVariable(symbol) && !isSymbolAssigned(symbol);
                    }
                    break;
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    return isConstantReference(node.expression) && isReadonlySymbol(getNodeLinks(node).resolvedSymbol || unknownSymbol);
            }
            return false;
        }
        function getFlowTypeOfReference(reference, declaredType, initialType = declaredType, flowContainer, flowNode = ((_a)=>(_a = tryCast(reference, canHaveFlowNode)) == null ? void 0 : _a.flowNode)()) {
            let key;
            let isKeySet = false;
            let flowDepth = 0;
            if (flowAnalysisDisabled) return errorType;
            if (!flowNode) return declaredType;
            flowInvocationCount++;
            const sharedFlowStart = sharedFlowCount;
            const evolvedType = getTypeFromFlowType(getTypeAtFlowNode(flowNode));
            sharedFlowCount = sharedFlowStart;
            const resultType = getObjectFlags(evolvedType) & 256 /* EvolvingArray */  && isEvolvingArrayOperationTarget(reference) ? autoArrayType : finalizeEvolvingArrayType(evolvedType);
            if (resultType === unreachableNeverType || reference.parent && reference.parent.kind === 234 /* NonNullExpression */  && !(resultType.flags & 131072 /* Never */ ) && getTypeWithFacts(resultType, 2097152 /* NEUndefinedOrNull */ ).flags & 131072 /* Never */ ) return declaredType;
            return resultType === nonNullUnknownType ? unknownType : resultType;
            function getOrSetCacheKey() {
                if (isKeySet) return key;
                isKeySet = true;
                return key = getFlowCacheKey(reference, declaredType, initialType, flowContainer);
            }
            function getTypeAtFlowNode(flow) {
                var _a2;
                if (flowDepth === 2e3) {
                    (_a2 = tracing) == null || _a2.instant(tracing.Phase.CheckTypes, "getTypeAtFlowNode_DepthLimit", {
                        flowId: flow.id
                    });
                    flowAnalysisDisabled = true;
                    reportFlowControlError(reference);
                    return errorType;
                }
                flowDepth++;
                let sharedFlow;
                while(true){
                    const flags = flow.flags;
                    if (flags & 4096 /* Shared */ ) {
                        for(let i = sharedFlowStart; i < sharedFlowCount; i++)if (sharedFlowNodes[i] === flow) {
                            flowDepth--;
                            return sharedFlowTypes[i];
                        }
                        sharedFlow = flow;
                    }
                    let type;
                    if (flags & 16 /* Assignment */ ) {
                        type = getTypeAtFlowAssignment(flow);
                        if (!type) {
                            flow = flow.antecedent;
                            continue;
                        }
                    } else if (flags & 512 /* Call */ ) {
                        type = getTypeAtFlowCall(flow);
                        if (!type) {
                            flow = flow.antecedent;
                            continue;
                        }
                    } else if (flags & 96 /* Condition */ ) type = getTypeAtFlowCondition(flow);
                    else if (flags & 128 /* SwitchClause */ ) type = getTypeAtSwitchClause(flow);
                    else if (flags & 12 /* Label */ ) {
                        if (flow.antecedents.length === 1) {
                            flow = flow.antecedents[0];
                            continue;
                        }
                        type = flags & 4 /* BranchLabel */  ? getTypeAtFlowBranchLabel(flow) : getTypeAtFlowLoopLabel(flow);
                    } else if (flags & 256 /* ArrayMutation */ ) {
                        type = getTypeAtFlowArrayMutation(flow);
                        if (!type) {
                            flow = flow.antecedent;
                            continue;
                        }
                    } else if (flags & 1024 /* ReduceLabel */ ) {
                        const target = flow.target;
                        const saveAntecedents = target.antecedents;
                        target.antecedents = flow.antecedents;
                        type = getTypeAtFlowNode(flow.antecedent);
                        target.antecedents = saveAntecedents;
                    } else if (flags & 2 /* Start */ ) {
                        const container = flow.node;
                        if (container && container !== flowContainer && reference.kind !== 210 /* PropertyAccessExpression */  && reference.kind !== 211 /* ElementAccessExpression */  && reference.kind !== 110 /* ThisKeyword */ ) {
                            flow = container.flowNode;
                            continue;
                        }
                        type = initialType;
                    } else type = convertAutoToAny(declaredType);
                    if (sharedFlow) {
                        sharedFlowNodes[sharedFlowCount] = sharedFlow;
                        sharedFlowTypes[sharedFlowCount] = type;
                        sharedFlowCount++;
                    }
                    flowDepth--;
                    return type;
                }
            }
            function getInitialOrAssignedType(flow) {
                const node = flow.node;
                return getNarrowableTypeForReference(node.kind === 259 /* VariableDeclaration */  || node.kind === 207 /* BindingElement */  ? getInitialType(node) : getAssignedType(node), reference);
            }
            function getTypeAtFlowAssignment(flow) {
                const node = flow.node;
                if (isMatchingReference(reference, node)) {
                    if (!isReachableFlowNode(flow)) return unreachableNeverType;
                    if (getAssignmentTargetKind(node) === 2 /* Compound */ ) {
                        const flowType = getTypeAtFlowNode(flow.antecedent);
                        return createFlowType(getBaseTypeOfLiteralType(getTypeFromFlowType(flowType)), isIncomplete(flowType));
                    }
                    if (declaredType === autoType || declaredType === autoArrayType) {
                        if (isEmptyArrayAssignment(node)) return getEvolvingArrayType(neverType);
                        const assignedType = getWidenedLiteralType(getInitialOrAssignedType(flow));
                        return isTypeAssignableTo(assignedType, declaredType) ? assignedType : anyArrayType;
                    }
                    if (declaredType.flags & 1048576 /* Union */ ) return getAssignmentReducedType(declaredType, getInitialOrAssignedType(flow));
                    return declaredType;
                }
                if (containsMatchingReference(reference, node)) {
                    if (!isReachableFlowNode(flow)) return unreachableNeverType;
                    if (isVariableDeclaration(node) && (isInJSFile(node) || isVarConst(node))) {
                        const init = getDeclaredExpandoInitializer(node);
                        if (init && (init.kind === 217 /* FunctionExpression */  || init.kind === 218 /* ArrowFunction */ )) return getTypeAtFlowNode(flow.antecedent);
                    }
                    return declaredType;
                }
                if (isVariableDeclaration(node) && node.parent.parent.kind === 248 /* ForInStatement */  && (isMatchingReference(reference, node.parent.parent.expression) || optionalChainContainsReference(node.parent.parent.expression, reference))) return getNonNullableTypeIfNeeded(finalizeEvolvingArrayType(getTypeFromFlowType(getTypeAtFlowNode(flow.antecedent))));
                return void 0;
            }
            function narrowTypeByAssertion(type, expr) {
                const node = skipParentheses(expr, /*excludeJSDocTypeAssertions*/ true);
                if (node.kind === 97 /* FalseKeyword */ ) return unreachableNeverType;
                if (node.kind === 225 /* BinaryExpression */ ) {
                    if (node.operatorToken.kind === 56 /* AmpersandAmpersandToken */ ) return narrowTypeByAssertion(narrowTypeByAssertion(type, node.left), node.right);
                    if (node.operatorToken.kind === 57 /* BarBarToken */ ) return getUnionType([
                        narrowTypeByAssertion(type, node.left),
                        narrowTypeByAssertion(type, node.right)
                    ]);
                }
                return narrowType(type, node, /*assumeTrue*/ true);
            }
            function getTypeAtFlowCall(flow) {
                const signature = getEffectsSignature(flow.node);
                if (signature) {
                    const predicate = getTypePredicateOfSignature(signature);
                    if (predicate && (predicate.kind === 2 /* AssertsThis */  || predicate.kind === 3 /* AssertsIdentifier */ )) {
                        const flowType = getTypeAtFlowNode(flow.antecedent);
                        const type = finalizeEvolvingArrayType(getTypeFromFlowType(flowType));
                        const narrowedType = predicate.type ? narrowTypeByTypePredicate(type, predicate, flow.node, /*assumeTrue*/ true) : predicate.kind === 3 /* AssertsIdentifier */  && predicate.parameterIndex >= 0 && predicate.parameterIndex < flow.node.arguments.length ? narrowTypeByAssertion(type, flow.node.arguments[predicate.parameterIndex]) : type;
                        return narrowedType === type ? flowType : createFlowType(narrowedType, isIncomplete(flowType));
                    }
                    if (getReturnTypeOfSignature(signature).flags & 131072 /* Never */ ) return unreachableNeverType;
                }
                return void 0;
            }
            function getTypeAtFlowArrayMutation(flow) {
                if (declaredType === autoType || declaredType === autoArrayType) {
                    const node = flow.node;
                    const expr = node.kind === 212 /* CallExpression */  ? node.expression.expression : node.left.expression;
                    if (isMatchingReference(reference, getReferenceCandidate(expr))) {
                        const flowType = getTypeAtFlowNode(flow.antecedent);
                        const type = getTypeFromFlowType(flowType);
                        if (getObjectFlags(type) & 256 /* EvolvingArray */ ) {
                            let evolvedType2 = type;
                            if (node.kind === 212 /* CallExpression */ ) for (const arg of node.arguments)evolvedType2 = addEvolvingArrayElementType(evolvedType2, arg);
                            else {
                                const indexType = getContextFreeTypeOfExpression(node.left.argumentExpression);
                                if (isTypeAssignableToKind(indexType, 296 /* NumberLike */ )) evolvedType2 = addEvolvingArrayElementType(evolvedType2, node.right);
                            }
                            return evolvedType2 === type ? flowType : createFlowType(evolvedType2, isIncomplete(flowType));
                        }
                        return flowType;
                    }
                }
                return void 0;
            }
            function getTypeAtFlowCondition(flow) {
                const flowType = getTypeAtFlowNode(flow.antecedent);
                const type = getTypeFromFlowType(flowType);
                if (type.flags & 131072 /* Never */ ) return flowType;
                const assumeTrue = (flow.flags & 32 /* TrueCondition */ ) !== 0;
                const nonEvolvingType = finalizeEvolvingArrayType(type);
                const narrowedType = narrowType(nonEvolvingType, flow.node, assumeTrue);
                if (narrowedType === nonEvolvingType) return flowType;
                return createFlowType(narrowedType, isIncomplete(flowType));
            }
            function getTypeAtSwitchClause(flow) {
                const expr = flow.switchStatement.expression;
                const flowType = getTypeAtFlowNode(flow.antecedent);
                let type = getTypeFromFlowType(flowType);
                if (isMatchingReference(reference, expr)) type = narrowTypeBySwitchOnDiscriminant(type, flow.switchStatement, flow.clauseStart, flow.clauseEnd);
                else if (expr.kind === 220 /* TypeOfExpression */  && isMatchingReference(reference, expr.expression)) type = narrowTypeBySwitchOnTypeOf(type, flow.switchStatement, flow.clauseStart, flow.clauseEnd);
                else {
                    if (strictNullChecks) {
                        if (optionalChainContainsReference(expr, reference)) type = narrowTypeBySwitchOptionalChainContainment(type, flow.switchStatement, flow.clauseStart, flow.clauseEnd, (t)=>!(t.flags & 163840 /* Never */ ));
                        else if (expr.kind === 220 /* TypeOfExpression */  && optionalChainContainsReference(expr.expression, reference)) type = narrowTypeBySwitchOptionalChainContainment(type, flow.switchStatement, flow.clauseStart, flow.clauseEnd, (t)=>!(t.flags & 131072 /* Never */  || t.flags & 128 /* StringLiteral */  && t.value === "undefined"));
                    }
                    const access = getDiscriminantPropertyAccess(expr, type);
                    if (access) type = narrowTypeBySwitchOnDiscriminantProperty(type, access, flow.switchStatement, flow.clauseStart, flow.clauseEnd);
                }
                return createFlowType(type, isIncomplete(flowType));
            }
            function getTypeAtFlowBranchLabel(flow) {
                const antecedentTypes = [];
                let subtypeReduction = false;
                let seenIncomplete = false;
                let bypassFlow;
                for (const antecedent of flow.antecedents){
                    if (!bypassFlow && antecedent.flags & 128 /* SwitchClause */  && antecedent.clauseStart === antecedent.clauseEnd) {
                        bypassFlow = antecedent;
                        continue;
                    }
                    const flowType = getTypeAtFlowNode(antecedent);
                    const type = getTypeFromFlowType(flowType);
                    if (type === declaredType && declaredType === initialType) return type;
                    pushIfUnique(antecedentTypes, type);
                    if (!isTypeSubsetOf(type, initialType)) subtypeReduction = true;
                    if (isIncomplete(flowType)) seenIncomplete = true;
                }
                if (bypassFlow) {
                    const flowType = getTypeAtFlowNode(bypassFlow);
                    const type = getTypeFromFlowType(flowType);
                    if (!(type.flags & 131072 /* Never */ ) && !contains(antecedentTypes, type) && !isExhaustiveSwitchStatement(bypassFlow.switchStatement)) {
                        if (type === declaredType && declaredType === initialType) return type;
                        antecedentTypes.push(type);
                        if (!isTypeSubsetOf(type, initialType)) subtypeReduction = true;
                        if (isIncomplete(flowType)) seenIncomplete = true;
                    }
                }
                return createFlowType(getUnionOrEvolvingArrayType(antecedentTypes, subtypeReduction ? 2 /* Subtype */  : 1 /* Literal */ ), seenIncomplete);
            }
            function getTypeAtFlowLoopLabel(flow) {
                const id = getFlowNodeId(flow);
                const cache = flowLoopCaches[id] || (flowLoopCaches[id] = /* @__PURE__ */ new Map());
                const key2 = getOrSetCacheKey();
                if (!key2) return declaredType;
                const cached = cache.get(key2);
                if (cached) return cached;
                for(let i = flowLoopStart; i < flowLoopCount; i++){
                    if (flowLoopNodes[i] === flow && flowLoopKeys[i] === key2 && flowLoopTypes[i].length) return createFlowType(getUnionOrEvolvingArrayType(flowLoopTypes[i], 1 /* Literal */ ), /*incomplete*/ true);
                }
                const antecedentTypes = [];
                let subtypeReduction = false;
                let firstAntecedentType;
                for (const antecedent of flow.antecedents){
                    let flowType;
                    if (!firstAntecedentType) flowType = firstAntecedentType = getTypeAtFlowNode(antecedent);
                    else {
                        flowLoopNodes[flowLoopCount] = flow;
                        flowLoopKeys[flowLoopCount] = key2;
                        flowLoopTypes[flowLoopCount] = antecedentTypes;
                        flowLoopCount++;
                        const saveFlowTypeCache = flowTypeCache;
                        flowTypeCache = void 0;
                        flowType = getTypeAtFlowNode(antecedent);
                        flowTypeCache = saveFlowTypeCache;
                        flowLoopCount--;
                        const cached2 = cache.get(key2);
                        if (cached2) return cached2;
                    }
                    const type = getTypeFromFlowType(flowType);
                    pushIfUnique(antecedentTypes, type);
                    if (!isTypeSubsetOf(type, initialType)) subtypeReduction = true;
                    if (type === declaredType) break;
                }
                const result = getUnionOrEvolvingArrayType(antecedentTypes, subtypeReduction ? 2 /* Subtype */  : 1 /* Literal */ );
                if (isIncomplete(firstAntecedentType)) return createFlowType(result, /*incomplete*/ true);
                cache.set(key2, result);
                return result;
            }
            function getUnionOrEvolvingArrayType(types, subtypeReduction) {
                if (isEvolvingArrayTypeList(types)) return getEvolvingArrayType(getUnionType(map(types, getElementTypeOfEvolvingArrayType)));
                const result = recombineUnknownType(getUnionType(sameMap(types, finalizeEvolvingArrayType), subtypeReduction));
                if (result !== declaredType && result.flags & declaredType.flags & 1048576 /* Union */  && arraysEqual(result.types, declaredType.types)) return declaredType;
                return result;
            }
            function getCandidateDiscriminantPropertyAccess(expr) {
                if (isBindingPattern(reference) || isFunctionExpressionOrArrowFunction(reference) || isObjectLiteralMethod(reference)) {
                    if (isIdentifier(expr)) {
                        const symbol = getResolvedSymbol(expr);
                        const declaration = symbol.valueDeclaration;
                        if (declaration && (isBindingElement(declaration) || isParameter(declaration)) && reference === declaration.parent && !declaration.initializer && !declaration.dotDotDotToken) return declaration;
                    }
                } else if (isAccessExpression(expr)) {
                    if (isMatchingReference(reference, expr.expression)) return expr;
                } else if (isIdentifier(expr)) {
                    const symbol = getResolvedSymbol(expr);
                    if (isConstVariable(symbol)) {
                        const declaration = symbol.valueDeclaration;
                        if (isVariableDeclaration(declaration) && !declaration.type && declaration.initializer && isAccessExpression(declaration.initializer) && isMatchingReference(reference, declaration.initializer.expression)) return declaration.initializer;
                        if (isBindingElement(declaration) && !declaration.initializer) {
                            const parent2 = declaration.parent.parent;
                            if (isVariableDeclaration(parent2) && !parent2.type && parent2.initializer && (isIdentifier(parent2.initializer) || isAccessExpression(parent2.initializer)) && isMatchingReference(reference, parent2.initializer)) return declaration;
                        }
                    }
                }
                return void 0;
            }
            function getDiscriminantPropertyAccess(expr, computedType) {
                const type = declaredType.flags & 1048576 /* Union */  ? declaredType : computedType;
                if (type.flags & 1048576 /* Union */ ) {
                    const access = getCandidateDiscriminantPropertyAccess(expr);
                    if (access) {
                        const name = getAccessedPropertyName(access);
                        if (name && isDiscriminantProperty(type, name)) return access;
                    }
                }
                return void 0;
            }
            function narrowTypeByDiscriminant(type, access, narrowType2) {
                const propName = getAccessedPropertyName(access);
                if (propName === void 0) return type;
                const optionalChain = isOptionalChain(access);
                const removeNullable = strictNullChecks && (optionalChain || isNonNullAccess(access)) && maybeTypeOfKind(type, 98304 /* Nullable */ );
                let propType = getTypeOfPropertyOfType(removeNullable ? getTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ ) : type, propName);
                if (!propType) return type;
                propType = removeNullable && optionalChain ? getOptionalType(propType) : propType;
                const narrowedPropType = narrowType2(propType);
                return filterType(type, (t)=>{
                    const discriminantType = getTypeOfPropertyOrIndexSignature(t, propName);
                    return !(discriminantType.flags & 131072 /* Never */ ) && !(narrowedPropType.flags & 131072 /* Never */ ) && areTypesComparable(narrowedPropType, discriminantType);
                });
            }
            function narrowTypeByDiscriminantProperty(type, access, operator, value1, assumeTrue) {
                if ((operator === 37 /* EqualsEqualsEqualsToken */  || operator === 38 /* ExclamationEqualsEqualsToken */ ) && type.flags & 1048576 /* Union */ ) {
                    const keyPropertyName = getKeyPropertyName(type);
                    if (keyPropertyName && keyPropertyName === getAccessedPropertyName(access)) {
                        const candidate = getConstituentTypeForKeyType(type, getTypeOfExpression(value1));
                        if (candidate) return operator === (assumeTrue ? 37 /* EqualsEqualsEqualsToken */  : 38 /* ExclamationEqualsEqualsToken */ ) ? candidate : isUnitType(getTypeOfPropertyOfType(candidate, keyPropertyName) || unknownType) ? removeType(type, candidate) : type;
                    }
                }
                return narrowTypeByDiscriminant(type, access, (t)=>narrowTypeByEquality(t, operator, value1, assumeTrue));
            }
            function narrowTypeBySwitchOnDiscriminantProperty(type, access, switchStatement, clauseStart, clauseEnd) {
                if (clauseStart < clauseEnd && type.flags & 1048576 /* Union */  && getKeyPropertyName(type) === getAccessedPropertyName(access)) {
                    const clauseTypes = getSwitchClauseTypes(switchStatement).slice(clauseStart, clauseEnd);
                    const candidate = getUnionType(map(clauseTypes, (t)=>getConstituentTypeForKeyType(type, t) || unknownType));
                    if (candidate !== unknownType) return candidate;
                }
                return narrowTypeByDiscriminant(type, access, (t)=>narrowTypeBySwitchOnDiscriminant(t, switchStatement, clauseStart, clauseEnd));
            }
            function narrowTypeByTruthiness(type, expr, assumeTrue) {
                if (isMatchingReference(reference, expr)) return getAdjustedTypeWithFacts(type, assumeTrue ? 4194304 /* Truthy */  : 8388608 /* Falsy */ );
                if (strictNullChecks && assumeTrue && optionalChainContainsReference(expr, reference)) type = getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ );
                const access = getDiscriminantPropertyAccess(expr, type);
                if (access) return narrowTypeByDiscriminant(type, access, (t)=>getTypeWithFacts(t, assumeTrue ? 4194304 /* Truthy */  : 8388608 /* Falsy */ ));
                return type;
            }
            function isTypePresencePossible(type, propName, assumeTrue) {
                const prop = getPropertyOfType(type, propName);
                return prop ? !!(prop.flags & 16777216 /* Optional */  || getCheckFlags(prop) & 48 /* Partial */ ) || assumeTrue : !!getApplicableIndexInfoForName(type, propName) || !assumeTrue;
            }
            function narrowTypeByInKeyword(type, nameType, assumeTrue) {
                const name = getPropertyNameFromType(nameType);
                const isKnownProperty2 = someType(type, (t)=>isTypePresencePossible(t, name, /*assumeTrue*/ true));
                if (isKnownProperty2) return filterType(type, (t)=>isTypePresencePossible(t, name, assumeTrue));
                if (assumeTrue) {
                    const recordSymbol = getGlobalRecordSymbol();
                    if (recordSymbol) return getIntersectionType([
                        type,
                        getTypeAliasInstantiation(recordSymbol, [
                            nameType,
                            unknownType
                        ])
                    ]);
                }
                return type;
            }
            function narrowTypeByBinaryExpression(type, expr, assumeTrue) {
                switch(expr.operatorToken.kind){
                    case 64 /* EqualsToken */ :
                    case 76 /* BarBarEqualsToken */ :
                    case 77 /* AmpersandAmpersandEqualsToken */ :
                    case 78 /* QuestionQuestionEqualsToken */ :
                        return narrowTypeByTruthiness(narrowType(type, expr.right, assumeTrue), expr.left, assumeTrue);
                    case 35 /* EqualsEqualsToken */ :
                    case 36 /* ExclamationEqualsToken */ :
                    case 37 /* EqualsEqualsEqualsToken */ :
                    case 38 /* ExclamationEqualsEqualsToken */ :
                        const operator = expr.operatorToken.kind;
                        const left = getReferenceCandidate(expr.left);
                        const right = getReferenceCandidate(expr.right);
                        if (left.kind === 220 /* TypeOfExpression */  && isStringLiteralLike(right)) return narrowTypeByTypeof(type, left, operator, right, assumeTrue);
                        if (right.kind === 220 /* TypeOfExpression */  && isStringLiteralLike(left)) return narrowTypeByTypeof(type, right, operator, left, assumeTrue);
                        if (isMatchingReference(reference, left)) return narrowTypeByEquality(type, operator, right, assumeTrue);
                        if (isMatchingReference(reference, right)) return narrowTypeByEquality(type, operator, left, assumeTrue);
                        if (strictNullChecks) {
                            if (optionalChainContainsReference(left, reference)) type = narrowTypeByOptionalChainContainment(type, operator, right, assumeTrue);
                            else if (optionalChainContainsReference(right, reference)) type = narrowTypeByOptionalChainContainment(type, operator, left, assumeTrue);
                        }
                        const leftAccess = getDiscriminantPropertyAccess(left, type);
                        if (leftAccess) return narrowTypeByDiscriminantProperty(type, leftAccess, operator, right, assumeTrue);
                        const rightAccess = getDiscriminantPropertyAccess(right, type);
                        if (rightAccess) return narrowTypeByDiscriminantProperty(type, rightAccess, operator, left, assumeTrue);
                        if (isMatchingConstructorReference(left)) return narrowTypeByConstructor(type, operator, right, assumeTrue);
                        if (isMatchingConstructorReference(right)) return narrowTypeByConstructor(type, operator, left, assumeTrue);
                        break;
                    case 104 /* InstanceOfKeyword */ :
                        return narrowTypeByInstanceof(type, expr, assumeTrue);
                    case 103 /* InKeyword */ :
                        if (isPrivateIdentifier(expr.left)) return narrowTypeByPrivateIdentifierInInExpression(type, expr, assumeTrue);
                        const target = getReferenceCandidate(expr.right);
                        const leftType = getTypeOfExpression(expr.left);
                        if (leftType.flags & 8576 /* StringOrNumberLiteralOrUnique */ ) {
                            if (containsMissingType(type) && isAccessExpression(reference) && isMatchingReference(reference.expression, target) && getAccessedPropertyName(reference) === getPropertyNameFromType(leftType)) return getTypeWithFacts(type, assumeTrue ? 524288 /* NEUndefined */  : 65536 /* EQUndefined */ );
                            if (isMatchingReference(reference, target)) return narrowTypeByInKeyword(type, leftType, assumeTrue);
                        }
                        break;
                    case 28 /* CommaToken */ :
                        return narrowType(type, expr.right, assumeTrue);
                    case 56 /* AmpersandAmpersandToken */ :
                        return assumeTrue ? narrowType(narrowType(type, expr.left, /*assumeTrue*/ true), expr.right, /*assumeTrue*/ true) : getUnionType([
                            narrowType(type, expr.left, /*assumeTrue*/ false),
                            narrowType(type, expr.right, /*assumeTrue*/ false)
                        ]);
                    case 57 /* BarBarToken */ :
                        return assumeTrue ? getUnionType([
                            narrowType(type, expr.left, /*assumeTrue*/ true),
                            narrowType(type, expr.right, /*assumeTrue*/ true)
                        ]) : narrowType(narrowType(type, expr.left, /*assumeTrue*/ false), expr.right, /*assumeTrue*/ false);
                }
                return type;
            }
            function narrowTypeByPrivateIdentifierInInExpression(type, expr, assumeTrue) {
                const target = getReferenceCandidate(expr.right);
                if (!isMatchingReference(reference, target)) return type;
                Debug.assertNode(expr.left, isPrivateIdentifier);
                const symbol = getSymbolForPrivateIdentifierExpression(expr.left);
                if (symbol === void 0) return type;
                const classSymbol = symbol.parent;
                const targetType = hasStaticModifier(Debug.checkDefined(symbol.valueDeclaration, "should always have a declaration")) ? getTypeOfSymbol(classSymbol) : getDeclaredTypeOfSymbol(classSymbol);
                return getNarrowedType(type, targetType, assumeTrue, /*checkDerived*/ true);
            }
            function narrowTypeByOptionalChainContainment(type, operator, value1, assumeTrue) {
                const equalsOperator = operator === 35 /* EqualsEqualsToken */  || operator === 37 /* EqualsEqualsEqualsToken */ ;
                const nullableFlags = operator === 35 /* EqualsEqualsToken */  || operator === 36 /* ExclamationEqualsToken */  ? 98304 /* Nullable */  : 32768 /* Undefined */ ;
                const valueType = getTypeOfExpression(value1);
                const removeNullable = equalsOperator !== assumeTrue && everyType(valueType, (t)=>!!(t.flags & nullableFlags)) || equalsOperator === assumeTrue && everyType(valueType, (t)=>!(t.flags & (3 /* AnyOrUnknown */  | nullableFlags)));
                return removeNullable ? getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ ) : type;
            }
            function narrowTypeByEquality(type, operator, value1, assumeTrue) {
                if (type.flags & 1 /* Any */ ) return type;
                if (operator === 36 /* ExclamationEqualsToken */  || operator === 38 /* ExclamationEqualsEqualsToken */ ) assumeTrue = !assumeTrue;
                const valueType = getTypeOfExpression(value1);
                const doubleEquals = operator === 35 /* EqualsEqualsToken */  || operator === 36 /* ExclamationEqualsToken */ ;
                if (valueType.flags & 98304 /* Nullable */ ) {
                    if (!strictNullChecks) return type;
                    const facts = doubleEquals ? assumeTrue ? 262144 /* EQUndefinedOrNull */  : 2097152 /* NEUndefinedOrNull */  : valueType.flags & 65536 /* Null */  ? assumeTrue ? 131072 /* EQNull */  : 1048576 /* NENull */  : assumeTrue ? 65536 /* EQUndefined */  : 524288 /* NEUndefined */ ;
                    return getAdjustedTypeWithFacts(type, facts);
                }
                if (assumeTrue) {
                    if (!doubleEquals && (type.flags & 2 /* Unknown */  || someType(type, isEmptyAnonymousObjectType))) {
                        if (valueType.flags & 469893116 /* NonPrimitive */  || isEmptyAnonymousObjectType(valueType)) return valueType;
                        if (valueType.flags & 524288 /* Object */ ) return nonPrimitiveType;
                    }
                    const filteredType = filterType(type, (t)=>areTypesComparable(t, valueType) || doubleEquals && isCoercibleUnderDoubleEquals(t, valueType));
                    return replacePrimitivesWithLiterals(filteredType, valueType);
                }
                if (isUnitType(valueType)) return filterType(type, (t)=>!(isUnitLikeType(t) && areTypesComparable(t, valueType)));
                return type;
            }
            function narrowTypeByTypeof(type, typeOfExpr, operator, literal, assumeTrue) {
                if (operator === 36 /* ExclamationEqualsToken */  || operator === 38 /* ExclamationEqualsEqualsToken */ ) assumeTrue = !assumeTrue;
                const target = getReferenceCandidate(typeOfExpr.expression);
                if (!isMatchingReference(reference, target)) {
                    if (strictNullChecks && optionalChainContainsReference(target, reference) && assumeTrue === (literal.text !== "undefined")) type = getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ );
                    const propertyAccess = getDiscriminantPropertyAccess(target, type);
                    if (propertyAccess) return narrowTypeByDiscriminant(type, propertyAccess, (t)=>narrowTypeByLiteralExpression(t, literal, assumeTrue));
                    return type;
                }
                return narrowTypeByLiteralExpression(type, literal, assumeTrue);
            }
            function narrowTypeByLiteralExpression(type, literal, assumeTrue) {
                return assumeTrue ? narrowTypeByTypeName(type, literal.text) : getAdjustedTypeWithFacts(type, typeofNEFacts.get(literal.text) || 32768 /* TypeofNEHostObject */ );
            }
            function narrowTypeBySwitchOptionalChainContainment(type, switchStatement, clauseStart, clauseEnd, clauseCheck) {
                const everyClauseChecks = clauseStart !== clauseEnd && every(getSwitchClauseTypes(switchStatement).slice(clauseStart, clauseEnd), clauseCheck);
                return everyClauseChecks ? getTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ ) : type;
            }
            function narrowTypeBySwitchOnDiscriminant(type, switchStatement, clauseStart, clauseEnd) {
                const switchTypes = getSwitchClauseTypes(switchStatement);
                if (!switchTypes.length) return type;
                const clauseTypes = switchTypes.slice(clauseStart, clauseEnd);
                const hasDefaultClause = clauseStart === clauseEnd || contains(clauseTypes, neverType);
                if (type.flags & 2 /* Unknown */  && !hasDefaultClause) {
                    let groundClauseTypes;
                    for(let i = 0; i < clauseTypes.length; i += 1){
                        const t = clauseTypes[i];
                        if (t.flags & 469893116 /* NonPrimitive */ ) {
                            if (groundClauseTypes !== void 0) groundClauseTypes.push(t);
                        } else if (t.flags & 524288 /* Object */ ) {
                            if (groundClauseTypes === void 0) groundClauseTypes = clauseTypes.slice(0, i);
                            groundClauseTypes.push(nonPrimitiveType);
                        } else return type;
                    }
                    return getUnionType(groundClauseTypes === void 0 ? clauseTypes : groundClauseTypes);
                }
                const discriminantType = getUnionType(clauseTypes);
                const caseType = discriminantType.flags & 131072 /* Never */  ? neverType : replacePrimitivesWithLiterals(filterType(type, (t)=>areTypesComparable(discriminantType, t)), discriminantType);
                if (!hasDefaultClause) return caseType;
                const defaultType = filterType(type, (t)=>!(isUnitLikeType(t) && contains(switchTypes, getRegularTypeOfLiteralType(extractUnitType(t)))));
                return caseType.flags & 131072 /* Never */  ? defaultType : getUnionType([
                    caseType,
                    defaultType
                ]);
            }
            function narrowTypeByTypeName(type, typeName) {
                switch(typeName){
                    case "string":
                        return narrowTypeByTypeFacts(type, stringType, 1 /* TypeofEQString */ );
                    case "number":
                        return narrowTypeByTypeFacts(type, numberType, 2 /* TypeofEQNumber */ );
                    case "bigint":
                        return narrowTypeByTypeFacts(type, bigintType, 4 /* TypeofEQBigInt */ );
                    case "boolean":
                        return narrowTypeByTypeFacts(type, booleanType, 8 /* TypeofEQBoolean */ );
                    case "symbol":
                        return narrowTypeByTypeFacts(type, esSymbolType, 16 /* TypeofEQSymbol */ );
                    case "object":
                        return type.flags & 1 /* Any */  ? type : getUnionType([
                            narrowTypeByTypeFacts(type, nonPrimitiveType, 32 /* TypeofEQObject */ ),
                            narrowTypeByTypeFacts(type, nullType, 131072 /* EQNull */ )
                        ]);
                    case "function":
                        return type.flags & 1 /* Any */  ? type : narrowTypeByTypeFacts(type, globalFunctionType, 64 /* TypeofEQFunction */ );
                    case "undefined":
                        return narrowTypeByTypeFacts(type, undefinedType, 65536 /* EQUndefined */ );
                }
                return narrowTypeByTypeFacts(type, nonPrimitiveType, 128 /* TypeofEQHostObject */ );
            }
            function narrowTypeByTypeFacts(type, impliedType, facts) {
                return mapType(type, (t)=>// We first check if a constituent is a subtype of the implied type. If so, we either keep or eliminate
                    // the constituent based on its type facts. We use the strict subtype relation because it treats `object`
                    // as a subtype of `{}`, and we need the type facts check because function types are subtypes of `object`,
                    // but are classified as "function" according to `typeof`.
                    isTypeRelatedTo(t, impliedType, strictSubtypeRelation) ? getTypeFacts(t) & facts ? t : neverType : // We next check if the consituent is a supertype of the implied type. If so, we substitute the implied
                    // type. This handles top types like `unknown` and `{}`, and supertypes like `{ toString(): string }`.
                    isTypeSubtypeOf(impliedType, t) ? impliedType : // Neither the constituent nor the implied type is a subtype of the other, however their domains may still
                    // overlap. For example, an unconstrained type parameter and type `string`. If the type facts indicate
                    // possible overlap, we form an intersection. Otherwise, we eliminate the constituent.
                    getTypeFacts(t) & facts ? getIntersectionType([
                        t,
                        impliedType
                    ]) : neverType);
            }
            function narrowTypeBySwitchOnTypeOf(type, switchStatement, clauseStart, clauseEnd) {
                const witnesses = getSwitchClauseTypeOfWitnesses(switchStatement);
                if (!witnesses) return type;
                const defaultIndex = findIndex(switchStatement.caseBlock.clauses, (clause)=>clause.kind === 296 /* DefaultClause */ );
                const hasDefaultClause = clauseStart === clauseEnd || defaultIndex >= clauseStart && defaultIndex < clauseEnd;
                if (hasDefaultClause) {
                    const notEqualFacts = getNotEqualFactsFromTypeofSwitch(clauseStart, clauseEnd, witnesses);
                    return filterType(type, (t)=>(getTypeFacts(t) & notEqualFacts) === notEqualFacts);
                }
                const clauseWitnesses = witnesses.slice(clauseStart, clauseEnd);
                return getUnionType(map(clauseWitnesses, (text)=>text ? narrowTypeByTypeName(type, text) : neverType));
            }
            function isMatchingConstructorReference(expr) {
                return (isPropertyAccessExpression(expr) && idText(expr.name) === "constructor" || isElementAccessExpression(expr) && isStringLiteralLike(expr.argumentExpression) && expr.argumentExpression.text === "constructor") && isMatchingReference(reference, expr.expression);
            }
            function narrowTypeByConstructor(type, operator, identifier, assumeTrue) {
                if (assumeTrue ? operator !== 35 /* EqualsEqualsToken */  && operator !== 37 /* EqualsEqualsEqualsToken */  : operator !== 36 /* ExclamationEqualsToken */  && operator !== 38 /* ExclamationEqualsEqualsToken */ ) return type;
                const identifierType = getTypeOfExpression(identifier);
                if (!isFunctionType(identifierType) && !isConstructorType(identifierType)) return type;
                const prototypeProperty = getPropertyOfType(identifierType, "prototype");
                if (!prototypeProperty) return type;
                const prototypeType = getTypeOfSymbol(prototypeProperty);
                const candidate = !isTypeAny(prototypeType) ? prototypeType : void 0;
                if (!candidate || candidate === globalObjectType || candidate === globalFunctionType) return type;
                if (isTypeAny(type)) return candidate;
                return filterType(type, (t)=>isConstructedBy(t, candidate));
                function isConstructedBy(source, target) {
                    if (source.flags & 524288 /* Object */  && getObjectFlags(source) & 1 /* Class */  || target.flags & 524288 /* Object */  && getObjectFlags(target) & 1 /* Class */ ) return source.symbol === target.symbol;
                    return isTypeSubtypeOf(source, target);
                }
            }
            function narrowTypeByInstanceof(type, expr, assumeTrue) {
                const left = getReferenceCandidate(expr.left);
                if (!isMatchingReference(reference, left)) {
                    if (assumeTrue && strictNullChecks && optionalChainContainsReference(left, reference)) return getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ );
                    return type;
                }
                const rightType = getTypeOfExpression(expr.right);
                if (!isTypeDerivedFrom(rightType, globalFunctionType)) return type;
                const instanceType = mapType(rightType, getInstanceType);
                if (isTypeAny(type) && (instanceType === globalObjectType || instanceType === globalFunctionType) || !assumeTrue && !(instanceType.flags & 524288 /* Object */  && !isEmptyAnonymousObjectType(instanceType))) return type;
                return getNarrowedType(type, instanceType, assumeTrue, /*checkDerived*/ true);
            }
            function getInstanceType(constructorType) {
                const prototypePropertyType = getTypeOfPropertyOfType(constructorType, "prototype");
                if (prototypePropertyType && !isTypeAny(prototypePropertyType)) return prototypePropertyType;
                const constructSignatures = getSignaturesOfType(constructorType, 1 /* Construct */ );
                if (constructSignatures.length) return getUnionType(map(constructSignatures, (signature)=>getReturnTypeOfSignature(getErasedSignature(signature))));
                return emptyObjectType;
            }
            function getNarrowedType(type, candidate, assumeTrue, checkDerived) {
                const key2 = type.flags & 1048576 /* Union */  ? `N${getTypeId(type)},${getTypeId(candidate)},${(assumeTrue ? 1 : 0) | (checkDerived ? 2 : 0)}` : void 0;
                return getCachedType(key2) ?? setCachedType(key2, getNarrowedTypeWorker(type, candidate, assumeTrue, checkDerived));
            }
            function getNarrowedTypeWorker(type, candidate, assumeTrue, checkDerived) {
                if (!assumeTrue) {
                    if (checkDerived) return filterType(type, (t)=>!isTypeDerivedFrom(t, candidate));
                    const trueType2 = getNarrowedType(type, candidate, /*assumeTrue*/ true, /*checkDerived*/ false);
                    return filterType(type, (t)=>!isTypeSubsetOf(t, trueType2));
                }
                if (type.flags & 3 /* AnyOrUnknown */ ) return candidate;
                const isRelated = checkDerived ? isTypeDerivedFrom : isTypeSubtypeOf;
                const keyPropertyName = type.flags & 1048576 /* Union */  ? getKeyPropertyName(type) : void 0;
                const narrowedType = mapType(candidate, (c)=>{
                    const discriminant = keyPropertyName && getTypeOfPropertyOfType(c, keyPropertyName);
                    const matching = discriminant && getConstituentTypeForKeyType(type, discriminant);
                    const directlyRelated = mapType(matching || type, checkDerived ? (t)=>isTypeDerivedFrom(t, c) ? t : isTypeDerivedFrom(c, t) ? c : neverType : (t)=>isTypeStrictSubtypeOf(t, c) ? t : isTypeStrictSubtypeOf(c, t) ? c : isTypeSubtypeOf(t, c) ? t : isTypeSubtypeOf(c, t) ? c : neverType);
                    return directlyRelated.flags & 131072 /* Never */  ? mapType(type, (t)=>maybeTypeOfKind(t, 465829888 /* Instantiable */ ) && isRelated(c, getBaseConstraintOfType(t) || unknownType) ? getIntersectionType([
                            t,
                            c
                        ]) : neverType) : directlyRelated;
                });
                return !(narrowedType.flags & 131072 /* Never */ ) ? narrowedType : isTypeSubtypeOf(candidate, type) ? candidate : isTypeAssignableTo(type, candidate) ? type : isTypeAssignableTo(candidate, type) ? candidate : getIntersectionType([
                    type,
                    candidate
                ]);
            }
            function narrowTypeByCallExpression(type, callExpression, assumeTrue) {
                if (hasMatchingArgument(callExpression, reference)) {
                    const signature = assumeTrue || !isCallChain(callExpression) ? getEffectsSignature(callExpression) : void 0;
                    const predicate = signature && getTypePredicateOfSignature(signature);
                    if (predicate && (predicate.kind === 0 /* This */  || predicate.kind === 1 /* Identifier */ )) return narrowTypeByTypePredicate(type, predicate, callExpression, assumeTrue);
                }
                if (containsMissingType(type) && isAccessExpression(reference) && isPropertyAccessExpression(callExpression.expression)) {
                    const callAccess = callExpression.expression;
                    if (isMatchingReference(reference.expression, getReferenceCandidate(callAccess.expression)) && isIdentifier(callAccess.name) && callAccess.name.escapedText === "hasOwnProperty" && callExpression.arguments.length === 1) {
                        const argument = callExpression.arguments[0];
                        if (isStringLiteralLike(argument) && getAccessedPropertyName(reference) === escapeLeadingUnderscores(argument.text)) return getTypeWithFacts(type, assumeTrue ? 524288 /* NEUndefined */  : 65536 /* EQUndefined */ );
                    }
                }
                return type;
            }
            function narrowTypeByTypePredicate(type, predicate, callExpression, assumeTrue) {
                if (predicate.type && !(isTypeAny(type) && (predicate.type === globalObjectType || predicate.type === globalFunctionType))) {
                    const predicateArgument = getTypePredicateArgument(predicate, callExpression);
                    if (predicateArgument) {
                        if (isMatchingReference(reference, predicateArgument)) return getNarrowedType(type, predicate.type, assumeTrue, /*checkDerived*/ false);
                        if (strictNullChecks && assumeTrue && optionalChainContainsReference(predicateArgument, reference) && !(getTypeFacts(predicate.type) & 65536 /* EQUndefined */ )) type = getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ );
                        const access = getDiscriminantPropertyAccess(predicateArgument, type);
                        if (access) return narrowTypeByDiscriminant(type, access, (t)=>getNarrowedType(t, predicate.type, assumeTrue, /*checkDerived*/ false));
                    }
                }
                return type;
            }
            function narrowType(type, expr, assumeTrue) {
                if (isExpressionOfOptionalChainRoot(expr) || isBinaryExpression(expr.parent) && (expr.parent.operatorToken.kind === 61 /* QuestionQuestionToken */  || expr.parent.operatorToken.kind === 78 /* QuestionQuestionEqualsToken */ ) && expr.parent.left === expr) return narrowTypeByOptionality(type, expr, assumeTrue);
                switch(expr.kind){
                    case 80 /* Identifier */ :
                        if (!isMatchingReference(reference, expr) && inlineLevel < 5) {
                            const symbol = getResolvedSymbol(expr);
                            if (isConstVariable(symbol)) {
                                const declaration = symbol.valueDeclaration;
                                if (declaration && isVariableDeclaration(declaration) && !declaration.type && declaration.initializer && isConstantReference(reference)) {
                                    inlineLevel++;
                                    const result = narrowType(type, declaration.initializer, assumeTrue);
                                    inlineLevel--;
                                    return result;
                                }
                            }
                        }
                    case 110 /* ThisKeyword */ :
                    case 108 /* SuperKeyword */ :
                    case 210 /* PropertyAccessExpression */ :
                    case 211 /* ElementAccessExpression */ :
                        return narrowTypeByTruthiness(type, expr, assumeTrue);
                    case 212 /* CallExpression */ :
                        return narrowTypeByCallExpression(type, expr, assumeTrue);
                    case 216 /* ParenthesizedExpression */ :
                    case 234 /* NonNullExpression */ :
                        return narrowType(type, expr.expression, assumeTrue);
                    case 225 /* BinaryExpression */ :
                        return narrowTypeByBinaryExpression(type, expr, assumeTrue);
                    case 223 /* PrefixUnaryExpression */ :
                        if (expr.operator === 54 /* ExclamationToken */ ) return narrowType(type, expr.operand, !assumeTrue);
                        break;
                }
                return type;
            }
            function narrowTypeByOptionality(type, expr, assumePresent) {
                if (isMatchingReference(reference, expr)) return getAdjustedTypeWithFacts(type, assumePresent ? 2097152 /* NEUndefinedOrNull */  : 262144 /* EQUndefinedOrNull */ );
                const access = getDiscriminantPropertyAccess(expr, type);
                if (access) return narrowTypeByDiscriminant(type, access, (t)=>getTypeWithFacts(t, assumePresent ? 2097152 /* NEUndefinedOrNull */  : 262144 /* EQUndefinedOrNull */ ));
                return type;
            }
        }
        function getTypeOfSymbolAtLocation(symbol, location) {
            symbol = getExportSymbolOfValueSymbolIfExported(symbol);
            if (location.kind === 80 /* Identifier */  || location.kind === 81 /* PrivateIdentifier */ ) {
                if (isRightSideOfQualifiedNameOrPropertyAccess(location)) location = location.parent;
                if (isExpressionNode(location) && (!isAssignmentTarget(location) || isWriteAccess(location))) {
                    const type = getTypeOfExpression(location);
                    if (getExportSymbolOfValueSymbolIfExported(getNodeLinks(location).resolvedSymbol) === symbol) return type;
                }
            }
            if (isDeclarationName(location) && isSetAccessor(location.parent) && getAnnotatedAccessorTypeNode(location.parent)) return getWriteTypeOfAccessors(location.parent.symbol);
            return getNonMissingTypeOfSymbol(symbol);
        }
        function getControlFlowContainer(node) {
            return findAncestor(node.parent, (node2)=>isFunctionLike(node2) && !getImmediatelyInvokedFunctionExpression(node2) || node2.kind === 267 /* ModuleBlock */  || node2.kind === 311 /* SourceFile */  || node2.kind === 171 /* PropertyDeclaration */ );
        }
        function isSymbolAssigned(symbol) {
            if (!symbol.valueDeclaration) return false;
            const parent2 = getRootDeclaration(symbol.valueDeclaration).parent;
            const links = getNodeLinks(parent2);
            if (!(links.flags & 524288 /* AssignmentsMarked */ )) {
                links.flags |= 524288 /* AssignmentsMarked */ ;
                if (!hasParentWithAssignmentsMarked(parent2)) markNodeAssignments(parent2);
            }
            return symbol.isAssigned || false;
        }
        function hasParentWithAssignmentsMarked(node) {
            return !!findAncestor(node.parent, (node2)=>(isFunctionLike(node2) || isCatchClause(node2)) && !!(getNodeLinks(node2).flags & 524288 /* AssignmentsMarked */ ));
        }
        function markNodeAssignments(node) {
            if (node.kind === 80 /* Identifier */ ) {
                if (isAssignmentTarget(node)) {
                    const symbol = getResolvedSymbol(node);
                    if (isParameterOrCatchClauseVariable(symbol)) symbol.isAssigned = true;
                }
            } else forEachChild(node, markNodeAssignments);
        }
        function isConstVariable(symbol) {
            return symbol.flags & 3 /* Variable */  && (getDeclarationNodeFlagsFromSymbol(symbol) & 2 /* Const */ ) !== 0;
        }
        function parameterInitializerContainsUndefined(declaration) {
            const links = getNodeLinks(declaration);
            if (links.parameterInitializerContainsUndefined === void 0) {
                if (!pushTypeResolution(declaration, 9 /* ParameterInitializerContainsUndefined */ )) {
                    reportCircularityError(declaration.symbol);
                    return true;
                }
                const containsUndefined = !!(getTypeFacts(checkDeclarationInitializer(declaration, 0 /* Normal */ )) & 16777216 /* IsUndefined */ );
                if (!popTypeResolution()) {
                    reportCircularityError(declaration.symbol);
                    return true;
                }
                links.parameterInitializerContainsUndefined = containsUndefined;
            }
            return links.parameterInitializerContainsUndefined;
        }
        function removeOptionalityFromDeclaredType(declaredType, declaration) {
            const removeUndefined = strictNullChecks && declaration.kind === 168 /* Parameter */  && declaration.initializer && getTypeFacts(declaredType) & 16777216 /* IsUndefined */  && !parameterInitializerContainsUndefined(declaration);
            return removeUndefined ? getTypeWithFacts(declaredType, 524288 /* NEUndefined */ ) : declaredType;
        }
        function isConstraintPosition(type, node) {
            const parent2 = node.parent;
            return parent2.kind === 210 /* PropertyAccessExpression */  || parent2.kind === 165 /* QualifiedName */  || parent2.kind === 212 /* CallExpression */  && parent2.expression === node || parent2.kind === 211 /* ElementAccessExpression */  && parent2.expression === node && !(someType(type, isGenericTypeWithoutNullableConstraint) && isGenericIndexType(getTypeOfExpression(parent2.argumentExpression)));
        }
        function isGenericTypeWithUnionConstraint(type) {
            return type.flags & 2097152 /* Intersection */  ? some(type.types, isGenericTypeWithUnionConstraint) : !!(type.flags & 465829888 /* Instantiable */  && getBaseConstraintOrType(type).flags & 1146880 /* Union */ );
        }
        function isGenericTypeWithoutNullableConstraint(type) {
            return type.flags & 2097152 /* Intersection */  ? some(type.types, isGenericTypeWithoutNullableConstraint) : !!(type.flags & 465829888 /* Instantiable */  && !maybeTypeOfKind(getBaseConstraintOrType(type), 98304 /* Nullable */ ));
        }
        function hasContextualTypeWithNoGenericTypes(node, checkMode) {
            const contextualType = (isIdentifier(node) || isPropertyAccessExpression(node) || isElementAccessExpression(node)) && !((isJsxOpeningElement(node.parent) || isJsxSelfClosingElement(node.parent)) && node.parent.tagName === node) && (checkMode && checkMode & 64 /* RestBindingElement */  ? getContextualType2(node, 8 /* SkipBindingPatterns */ ) : getContextualType2(node, /*contextFlags*/ void 0));
            return contextualType && !isGenericType(contextualType);
        }
        function getNarrowableTypeForReference(type, reference, checkMode) {
            const substituteConstraints = !(checkMode && checkMode & 2 /* Inferential */ ) && someType(type, isGenericTypeWithUnionConstraint) && (isConstraintPosition(type, reference) || hasContextualTypeWithNoGenericTypes(reference, checkMode));
            return substituteConstraints ? mapType(type, getBaseConstraintOrType) : type;
        }
        function isExportOrExportExpression(location) {
            return !!findAncestor(location, (n)=>{
                const parent2 = n.parent;
                if (parent2 === void 0) return "quit";
                if (isExportAssignment(parent2)) return parent2.expression === n && isEntityNameExpression(n);
                if (isExportSpecifier(parent2)) return parent2.name === n || parent2.propertyName === n;
                return false;
            });
        }
        function markAliasReferenced(symbol, location) {
            if (!canCollectSymbolAliasAccessabilityData) return;
            if (isNonLocalAlias(symbol, /*excludes*/ 111551 /* Value */ ) && !isInTypeQuery(location) && !getTypeOnlyAliasDeclaration(symbol, 111551 /* Value */ )) {
                const target = resolveAlias(symbol);
                if (getAllSymbolFlags(target) & 1160127 /* ExportValue */ ) {
                    if (getIsolatedModules(compilerOptions) || shouldPreserveConstEnums(compilerOptions) && isExportOrExportExpression(location) || !isConstEnumOrConstEnumOnlyModule(getExportSymbolOfValueSymbolIfExported(target))) markAliasSymbolAsReferenced(symbol);
                    else markConstEnumAliasAsReferenced(symbol);
                }
            }
        }
        function getNarrowedTypeOfSymbol(symbol, location) {
            var _a;
            const type = getTypeOfSymbol(symbol);
            const declaration = symbol.valueDeclaration;
            if (declaration) {
                if (isBindingElement(declaration) && !declaration.initializer && !declaration.dotDotDotToken && declaration.parent.elements.length >= 2) {
                    const parent2 = declaration.parent.parent;
                    if (parent2.kind === 259 /* VariableDeclaration */  && getCombinedNodeFlags(declaration) & 2 /* Const */  || parent2.kind === 168 /* Parameter */ ) {
                        const links = getNodeLinks(parent2);
                        if (!(links.flags & 16777216 /* InCheckIdentifier */ )) {
                            links.flags |= 16777216 /* InCheckIdentifier */ ;
                            const parentType = getTypeForBindingElementParent(parent2, 0 /* Normal */ );
                            const parentTypeConstraint = parentType && mapType(parentType, getBaseConstraintOrType);
                            links.flags &= -16777217 /* InCheckIdentifier */ ;
                            if (parentTypeConstraint && parentTypeConstraint.flags & 1048576 /* Union */  && !(parent2.kind === 168 /* Parameter */  && isSymbolAssigned(symbol))) {
                                const pattern = declaration.parent;
                                const narrowedType = getFlowTypeOfReference(pattern, parentTypeConstraint, parentTypeConstraint, /*flowContainer*/ void 0, location.flowNode);
                                if (narrowedType.flags & 131072 /* Never */ ) return neverType;
                                return getBindingElementTypeFromParentType(declaration, narrowedType);
                            }
                        }
                    }
                }
                if (isParameter(declaration) && !declaration.type && !declaration.initializer && !declaration.dotDotDotToken) {
                    const func = declaration.parent;
                    if (func.parameters.length >= 2 && isContextSensitiveFunctionOrObjectLiteralMethod(func)) {
                        const contextualSignature = getContextualSignature(func);
                        if (contextualSignature && contextualSignature.parameters.length === 1 && signatureHasRestParameter(contextualSignature)) {
                            const restType = getReducedApparentType(instantiateType(getTypeOfSymbol(contextualSignature.parameters[0]), (_a = getInferenceContext(func)) == null ? void 0 : _a.nonFixingMapper));
                            if (restType.flags & 1048576 /* Union */  && everyType(restType, isTupleType) && !isSymbolAssigned(symbol)) {
                                const narrowedType = getFlowTypeOfReference(func, restType, restType, /*flowContainer*/ void 0, location.flowNode);
                                const index = func.parameters.indexOf(declaration) - (getThisParameter(func) ? 1 : 0);
                                return getIndexedAccessType(narrowedType, getNumberLiteralType(index));
                            }
                        }
                    }
                }
            }
            return type;
        }
        function checkIdentifier(node, checkMode) {
            if (isThisInTypeQuery(node)) return checkThisExpression(node);
            const symbol = getResolvedSymbol(node);
            if (symbol === unknownSymbol) return errorType;
            if (symbol === argumentsSymbol) {
                if (isInPropertyInitializerOrClassStaticBlock(node)) {
                    error(node, Diagnostics.arguments_cannot_be_referenced_in_property_initializers);
                    return errorType;
                }
                const container = getContainingFunction(node);
                if (languageVersion < 2 /* ES2015 */ ) {
                    if (container.kind === 218 /* ArrowFunction */ ) error(node, Diagnostics.The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES3_and_ES5_Consider_using_a_standard_function_expression);
                    else if (hasSyntacticModifier(container, 512 /* Async */ )) error(node, Diagnostics.The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES3_and_ES5_Consider_using_a_standard_function_or_method);
                }
                getNodeLinks(container).flags |= 512 /* CaptureArguments */ ;
                return getTypeOfSymbol(symbol);
            }
            if (shouldMarkIdentifierAliasReferenced(node)) markAliasReferenced(symbol, node);
            const localOrExportSymbol = getExportSymbolOfValueSymbolIfExported(symbol);
            const targetSymbol = resolveAliasWithDeprecationCheck(localOrExportSymbol, node);
            if (isDeprecatedSymbol(targetSymbol) && isUncalledFunctionReference(node, targetSymbol) && targetSymbol.declarations) addDeprecatedSuggestion(node, targetSymbol.declarations, node.escapedText);
            let declaration = localOrExportSymbol.valueDeclaration;
            if (declaration && localOrExportSymbol.flags & 32 /* Class */ ) {
                if (declaration.kind === 262 /* ClassDeclaration */  && nodeIsDecorated(legacyDecorators, declaration)) {
                    let container = getContainingClass(node);
                    while(container !== void 0){
                        if (container === declaration && container.name !== node) {
                            getNodeLinks(declaration).flags |= 1048576 /* ClassWithConstructorReference */ ;
                            getNodeLinks(node).flags |= 2097152 /* ConstructorReferenceInClass */ ;
                            break;
                        }
                        container = getContainingClass(container);
                    }
                } else if (declaration.kind === 230 /* ClassExpression */ ) {
                    let container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                    while(container.kind !== 311 /* SourceFile */ ){
                        if (container.parent === declaration) {
                            if (isPropertyDeclaration(container) && isStatic(container) || isClassStaticBlockDeclaration(container)) {
                                getNodeLinks(declaration).flags |= 1048576 /* ClassWithConstructorReference */ ;
                                getNodeLinks(node).flags |= 2097152 /* ConstructorReferenceInClass */ ;
                            }
                            break;
                        }
                        container = getThisContainer(container, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                    }
                }
            }
            checkNestedBlockScopedBinding(node, symbol);
            let type = getNarrowedTypeOfSymbol(localOrExportSymbol, node);
            const assignmentKind = getAssignmentTargetKind(node);
            if (assignmentKind) {
                if (!(localOrExportSymbol.flags & 3 /* Variable */ ) && !(isInJSFile(node) && localOrExportSymbol.flags & 512 /* ValueModule */ )) {
                    const assignmentError = localOrExportSymbol.flags & 384 /* Enum */  ? Diagnostics.Cannot_assign_to_0_because_it_is_an_enum : localOrExportSymbol.flags & 32 /* Class */  ? Diagnostics.Cannot_assign_to_0_because_it_is_a_class : localOrExportSymbol.flags & 1536 /* Module */  ? Diagnostics.Cannot_assign_to_0_because_it_is_a_namespace : localOrExportSymbol.flags & 16 /* Function */  ? Diagnostics.Cannot_assign_to_0_because_it_is_a_function : localOrExportSymbol.flags & 2097152 /* Alias */  ? Diagnostics.Cannot_assign_to_0_because_it_is_an_import : Diagnostics.Cannot_assign_to_0_because_it_is_not_a_variable;
                    error(node, assignmentError, symbolToString(symbol));
                    return errorType;
                }
                if (isReadonlySymbol(localOrExportSymbol)) {
                    if (localOrExportSymbol.flags & 3 /* Variable */ ) error(node, Diagnostics.Cannot_assign_to_0_because_it_is_a_constant, symbolToString(symbol));
                    else error(node, Diagnostics.Cannot_assign_to_0_because_it_is_a_read_only_property, symbolToString(symbol));
                    return errorType;
                }
            }
            const isAlias = localOrExportSymbol.flags & 2097152 /* Alias */ ;
            if (localOrExportSymbol.flags & 3 /* Variable */ ) {
                if (assignmentKind === 1 /* Definite */ ) return type;
            } else if (isAlias) declaration = getDeclarationOfAliasSymbol(symbol);
            else return type;
            if (!declaration) return type;
            type = getNarrowableTypeForReference(type, node, checkMode);
            const isParameter2 = getRootDeclaration(declaration).kind === 168 /* Parameter */ ;
            const declarationContainer = getControlFlowContainer(declaration);
            let flowContainer = getControlFlowContainer(node);
            const isOuterVariable = flowContainer !== declarationContainer;
            const isSpreadDestructuringAssignmentTarget = node.parent && node.parent.parent && isSpreadAssignment(node.parent) && isDestructuringAssignmentTarget(node.parent.parent);
            const isModuleExports = symbol.flags & 134217728 /* ModuleExports */ ;
            const typeIsAutomatic = type === autoType || type === autoArrayType;
            const isAutomaticTypeInNonNull = typeIsAutomatic && node.parent.kind === 234 /* NonNullExpression */ ;
            while(flowContainer !== declarationContainer && (flowContainer.kind === 217 /* FunctionExpression */  || flowContainer.kind === 218 /* ArrowFunction */  || isObjectLiteralOrClassExpressionMethodOrAccessor(flowContainer)) && (isConstVariable(localOrExportSymbol) && type !== autoArrayType || isParameter2 && !isSymbolAssigned(localOrExportSymbol)))flowContainer = getControlFlowContainer(flowContainer);
            const assumeInitialized = isParameter2 || isAlias || isOuterVariable || isSpreadDestructuringAssignmentTarget || isModuleExports || isSameScopedBindingElement(node, declaration) || type !== autoType && type !== autoArrayType && (!strictNullChecks || (type.flags & 16387 /* Void */ ) !== 0 || isInTypeQuery(node) || isInAmbientOrTypeNode(node) || node.parent.kind === 280 /* ExportSpecifier */ ) || node.parent.kind === 234 /* NonNullExpression */  || declaration.kind === 259 /* VariableDeclaration */  && declaration.exclamationToken || declaration.flags & 16777216 /* Ambient */ ;
            const initialType = isAutomaticTypeInNonNull ? undefinedType : assumeInitialized ? isParameter2 ? removeOptionalityFromDeclaredType(type, declaration) : type : typeIsAutomatic ? undefinedType : getOptionalType(type);
            const flowType = isAutomaticTypeInNonNull ? getNonNullableType(getFlowTypeOfReference(node, type, initialType, flowContainer)) : getFlowTypeOfReference(node, type, initialType, flowContainer);
            if (!isEvolvingArrayOperationTarget(node) && (type === autoType || type === autoArrayType)) {
                if (flowType === autoType || flowType === autoArrayType) {
                    if (noImplicitAny) {
                        error(getNameOfDeclaration(declaration), Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined, symbolToString(symbol), typeToString(flowType));
                        error(node, Diagnostics.Variable_0_implicitly_has_an_1_type, symbolToString(symbol), typeToString(flowType));
                    }
                    return convertAutoToAny(flowType);
                }
            } else if (!assumeInitialized && !containsUndefinedType(type) && containsUndefinedType(flowType)) {
                error(node, Diagnostics.Variable_0_is_used_before_being_assigned, symbolToString(symbol));
                return type;
            }
            return assignmentKind ? getBaseTypeOfLiteralType(flowType) : flowType;
        }
        function isSameScopedBindingElement(node, declaration) {
            if (isBindingElement(declaration)) {
                const bindingElement = findAncestor(node, isBindingElement);
                return bindingElement && getRootDeclaration(bindingElement) === getRootDeclaration(declaration);
            }
        }
        function shouldMarkIdentifierAliasReferenced(node) {
            var _a;
            const parent2 = node.parent;
            if (parent2) {
                if (isPropertyAccessExpression(parent2) && parent2.expression === node) return false;
                if (isExportSpecifier(parent2) && parent2.isTypeOnly) return false;
                const greatGrandparent = (_a = parent2.parent) == null ? void 0 : _a.parent;
                if (greatGrandparent && isExportDeclaration(greatGrandparent) && greatGrandparent.isTypeOnly) return false;
            }
            return true;
        }
        function isInsideFunctionOrInstancePropertyInitializer(node, threshold) {
            return !!findAncestor(node, (n)=>n === threshold ? "quit" : isFunctionLike(n) || n.parent && isPropertyDeclaration(n.parent) && !hasStaticModifier(n.parent) && n.parent.initializer === n);
        }
        function getPartOfForStatementContainingNode(node, container) {
            return findAncestor(node, (n)=>n === container ? "quit" : n === container.initializer || n === container.condition || n === container.incrementor || n === container.statement);
        }
        function getEnclosingIterationStatement(node) {
            return findAncestor(node, (n)=>!n || nodeStartsNewLexicalEnvironment(n) ? "quit" : isIterationStatement(n, /*lookInLabeledStatements*/ false));
        }
        function checkNestedBlockScopedBinding(node, symbol) {
            if (languageVersion >= 2 /* ES2015 */  || (symbol.flags & 34 /* Class */ ) === 0 || !symbol.valueDeclaration || isSourceFile(symbol.valueDeclaration) || symbol.valueDeclaration.parent.kind === 298 /* CatchClause */ ) return;
            const container = getEnclosingBlockScopeContainer(symbol.valueDeclaration);
            const isCaptured = isInsideFunctionOrInstancePropertyInitializer(node, container);
            const enclosingIterationStatement = getEnclosingIterationStatement(container);
            if (enclosingIterationStatement) {
                if (isCaptured) {
                    let capturesBlockScopeBindingInLoopBody = true;
                    if (isForStatement(container)) {
                        const varDeclList = getAncestor(symbol.valueDeclaration, 260 /* VariableDeclarationList */ );
                        if (varDeclList && varDeclList.parent === container) {
                            const part = getPartOfForStatementContainingNode(node.parent, container);
                            if (part) {
                                const links = getNodeLinks(part);
                                links.flags |= 8192 /* ContainsCapturedBlockScopeBinding */ ;
                                const capturedBindings = links.capturedBlockScopeBindings || (links.capturedBlockScopeBindings = []);
                                pushIfUnique(capturedBindings, symbol);
                                if (part === container.initializer) capturesBlockScopeBindingInLoopBody = false;
                            }
                        }
                    }
                    if (capturesBlockScopeBindingInLoopBody) getNodeLinks(enclosingIterationStatement).flags |= 4096 /* LoopWithCapturedBlockScopedBinding */ ;
                }
                if (isForStatement(container)) {
                    const varDeclList = getAncestor(symbol.valueDeclaration, 260 /* VariableDeclarationList */ );
                    if (varDeclList && varDeclList.parent === container && isAssignedInBodyOfForStatement(node, container)) getNodeLinks(symbol.valueDeclaration).flags |= 262144 /* NeedsLoopOutParameter */ ;
                }
                getNodeLinks(symbol.valueDeclaration).flags |= 32768 /* BlockScopedBindingInLoop */ ;
            }
            if (isCaptured) getNodeLinks(symbol.valueDeclaration).flags |= 16384 /* CapturedBlockScopedBinding */ ;
        }
        function isBindingCapturedByNode(node, decl) {
            const links = getNodeLinks(node);
            return !!links && contains(links.capturedBlockScopeBindings, getSymbolOfDeclaration(decl));
        }
        function isAssignedInBodyOfForStatement(node, container) {
            let current = node;
            while(current.parent.kind === 216 /* ParenthesizedExpression */ )current = current.parent;
            let isAssigned = false;
            if (isAssignmentTarget(current)) isAssigned = true;
            else if (current.parent.kind === 223 /* PrefixUnaryExpression */  || current.parent.kind === 224 /* PostfixUnaryExpression */ ) {
                const expr = current.parent;
                isAssigned = expr.operator === 46 /* PlusPlusToken */  || expr.operator === 47 /* MinusMinusToken */ ;
            }
            if (!isAssigned) return false;
            return !!findAncestor(current, (n)=>n === container ? "quit" : n === container.statement);
        }
        function captureLexicalThis(node, container) {
            getNodeLinks(node).flags |= 2 /* LexicalThis */ ;
            if (container.kind === 171 /* PropertyDeclaration */  || container.kind === 175 /* Constructor */ ) {
                const classNode = container.parent;
                getNodeLinks(classNode).flags |= 4 /* CaptureThis */ ;
            } else getNodeLinks(container).flags |= 4 /* CaptureThis */ ;
        }
        function findFirstSuperCall(node) {
            return isSuperCall(node) ? node : isFunctionLike(node) ? void 0 : forEachChild(node, findFirstSuperCall);
        }
        function classDeclarationExtendsNull(classDecl) {
            const classSymbol = getSymbolOfDeclaration(classDecl);
            const classInstanceType = getDeclaredTypeOfSymbol(classSymbol);
            const baseConstructorType = getBaseConstructorTypeOfClass(classInstanceType);
            return baseConstructorType === nullWideningType;
        }
        function checkThisBeforeSuper(node, container, diagnosticMessage) {
            const containingClassDecl = container.parent;
            const baseTypeNode = getClassExtendsHeritageElement(containingClassDecl);
            if (baseTypeNode && !classDeclarationExtendsNull(containingClassDecl)) {
                if (canHaveFlowNode(node) && node.flowNode && !isPostSuperFlowNode(node.flowNode, /*noCacheCheck*/ false)) error(node, diagnosticMessage);
            }
        }
        function checkThisInStaticClassFieldInitializerInDecoratedClass(thisExpression, container) {
            if (isPropertyDeclaration(container) && hasStaticModifier(container) && legacyDecorators && container.initializer && textRangeContainsPositionInclusive(container.initializer, thisExpression.pos) && hasDecorators(container.parent)) error(thisExpression, Diagnostics.Cannot_use_this_in_a_static_property_initializer_of_a_decorated_class);
        }
        function checkThisExpression(node) {
            const isNodeInTypeQuery = isInTypeQuery(node);
            let container = getThisContainer(node, /*includeArrowFunctions*/ true, /*includeClassComputedPropertyName*/ true);
            let capturedByArrowFunction = false;
            let thisInComputedPropertyName = false;
            if (container.kind === 175 /* Constructor */ ) checkThisBeforeSuper(node, container, Diagnostics.super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class);
            while(true){
                if (container.kind === 218 /* ArrowFunction */ ) {
                    container = getThisContainer(container, /*includeArrowFunctions*/ false, !thisInComputedPropertyName);
                    capturedByArrowFunction = true;
                }
                if (container.kind === 166 /* ComputedPropertyName */ ) {
                    container = getThisContainer(container, !capturedByArrowFunction, /*includeClassComputedPropertyName*/ false);
                    thisInComputedPropertyName = true;
                    continue;
                }
                break;
            }
            checkThisInStaticClassFieldInitializerInDecoratedClass(node, container);
            if (thisInComputedPropertyName) error(node, Diagnostics.this_cannot_be_referenced_in_a_computed_property_name);
            else switch(container.kind){
                case 266 /* ModuleDeclaration */ :
                    error(node, Diagnostics.this_cannot_be_referenced_in_a_module_or_namespace_body);
                    break;
                case 265 /* EnumDeclaration */ :
                    error(node, Diagnostics.this_cannot_be_referenced_in_current_location);
                    break;
                case 175 /* Constructor */ :
                    if (isInConstructorArgumentInitializer(node, container)) error(node, Diagnostics.this_cannot_be_referenced_in_constructor_arguments);
                    break;
            }
            if (!isNodeInTypeQuery && capturedByArrowFunction && languageVersion < 2 /* ES2015 */ ) captureLexicalThis(node, container);
            const type = tryGetThisTypeAt(node, /*includeGlobalThis*/ true, container);
            if (noImplicitThis) {
                const globalThisType2 = getTypeOfSymbol(globalThisSymbol);
                if (type === globalThisType2 && capturedByArrowFunction) error(node, Diagnostics.The_containing_arrow_function_captures_the_global_value_of_this);
                else if (!type) {
                    const diag2 = error(node, Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation);
                    if (!isSourceFile(container)) {
                        const outsideThis = tryGetThisTypeAt(container);
                        if (outsideThis && outsideThis !== globalThisType2) addRelatedInfo(diag2, createDiagnosticForNode(container, Diagnostics.An_outer_value_of_this_is_shadowed_by_this_container));
                    }
                }
            }
            return type || anyType;
        }
        function tryGetThisTypeAt(node, includeGlobalThis = true, container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false)) {
            const isInJS = isInJSFile(node);
            if (isFunctionLike(container) && (!isInParameterInitializerBeforeContainingFunction(node) || getThisParameter(container))) {
                let thisType = getThisTypeOfDeclaration(container) || isInJS && getTypeForThisExpressionFromJSDoc(container);
                if (!thisType) {
                    const className = getClassNameFromPrototypeMethod(container);
                    if (isInJS && className) {
                        const classSymbol = checkExpression(className).symbol;
                        if (classSymbol && classSymbol.members && classSymbol.flags & 16 /* Function */ ) thisType = getDeclaredTypeOfSymbol(classSymbol).thisType;
                    } else if (isJSConstructor(container)) thisType = getDeclaredTypeOfSymbol(getMergedSymbol(container.symbol)).thisType;
                    thisType || (thisType = getContextualThisParameterType(container));
                }
                if (thisType) return getFlowTypeOfReference(node, thisType);
            }
            if (isClassLike(container.parent)) {
                const symbol = getSymbolOfDeclaration(container.parent);
                const type = isStatic(container) ? getTypeOfSymbol(symbol) : getDeclaredTypeOfSymbol(symbol).thisType;
                return getFlowTypeOfReference(node, type);
            }
            if (isSourceFile(container)) {
                if (container.commonJsModuleIndicator) {
                    const fileSymbol = getSymbolOfDeclaration(container);
                    return fileSymbol && getTypeOfSymbol(fileSymbol);
                } else if (container.externalModuleIndicator) return undefinedType;
                else if (includeGlobalThis) return getTypeOfSymbol(globalThisSymbol);
            }
        }
        function getExplicitThisType(node) {
            const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            if (isFunctionLike(container)) {
                const signature = getSignatureFromDeclaration(container);
                if (signature.thisParameter) return getExplicitTypeOfSymbol(signature.thisParameter);
            }
            if (isClassLike(container.parent)) {
                const symbol = getSymbolOfDeclaration(container.parent);
                return isStatic(container) ? getTypeOfSymbol(symbol) : getDeclaredTypeOfSymbol(symbol).thisType;
            }
        }
        function getClassNameFromPrototypeMethod(container) {
            if (container.kind === 217 /* FunctionExpression */  && isBinaryExpression(container.parent) && getAssignmentDeclarationKind(container.parent) === 3 /* PrototypeProperty */ ) return container.parent.left.expression.expression;
            else if (container.kind === 173 /* MethodDeclaration */  && container.parent.kind === 209 /* ObjectLiteralExpression */  && isBinaryExpression(container.parent.parent) && getAssignmentDeclarationKind(container.parent.parent) === 6 /* Prototype */ ) return container.parent.parent.left.expression;
            else if (container.kind === 217 /* FunctionExpression */  && container.parent.kind === 302 /* PropertyAssignment */  && container.parent.parent.kind === 209 /* ObjectLiteralExpression */  && isBinaryExpression(container.parent.parent.parent) && getAssignmentDeclarationKind(container.parent.parent.parent) === 6 /* Prototype */ ) return container.parent.parent.parent.left.expression;
            else if (container.kind === 217 /* FunctionExpression */  && isPropertyAssignment(container.parent) && isIdentifier(container.parent.name) && (container.parent.name.escapedText === "value" || container.parent.name.escapedText === "get" || container.parent.name.escapedText === "set") && isObjectLiteralExpression(container.parent.parent) && isCallExpression(container.parent.parent.parent) && container.parent.parent.parent.arguments[2] === container.parent.parent && getAssignmentDeclarationKind(container.parent.parent.parent) === 9 /* ObjectDefinePrototypeProperty */ ) return container.parent.parent.parent.arguments[0].expression;
            else if (isMethodDeclaration(container) && isIdentifier(container.name) && (container.name.escapedText === "value" || container.name.escapedText === "get" || container.name.escapedText === "set") && isObjectLiteralExpression(container.parent) && isCallExpression(container.parent.parent) && container.parent.parent.arguments[2] === container.parent && getAssignmentDeclarationKind(container.parent.parent) === 9 /* ObjectDefinePrototypeProperty */ ) return container.parent.parent.arguments[0].expression;
        }
        function getTypeForThisExpressionFromJSDoc(node) {
            const jsdocType = getJSDocType(node);
            if (jsdocType && jsdocType.kind === 323 /* JSDocFunctionType */ ) {
                const jsDocFunctionType = jsdocType;
                if (jsDocFunctionType.parameters.length > 0 && jsDocFunctionType.parameters[0].name && jsDocFunctionType.parameters[0].name.escapedText === "this" /* This */ ) return getTypeFromTypeNode(jsDocFunctionType.parameters[0].type);
            }
            const thisTag = getJSDocThisTag(node);
            if (thisTag && thisTag.typeExpression) return getTypeFromTypeNode(thisTag.typeExpression);
        }
        function isInConstructorArgumentInitializer(node, constructorDecl) {
            return !!findAncestor(node, (n)=>isFunctionLikeDeclaration(n) ? "quit" : n.kind === 168 /* Parameter */  && n.parent === constructorDecl);
        }
        function checkSuperExpression(node) {
            const isCallExpression2 = node.parent.kind === 212 /* CallExpression */  && node.parent.expression === node;
            const immediateContainer = getSuperContainer(node, /*stopOnFunctions*/ true);
            let container = immediateContainer;
            let needToCaptureLexicalThis = false;
            let inAsyncFunction = false;
            if (!isCallExpression2) {
                while(container && container.kind === 218 /* ArrowFunction */ ){
                    if (hasSyntacticModifier(container, 512 /* Async */ )) inAsyncFunction = true;
                    container = getSuperContainer(container, /*stopOnFunctions*/ true);
                    needToCaptureLexicalThis = languageVersion < 2 /* ES2015 */ ;
                }
                if (container && hasSyntacticModifier(container, 512 /* Async */ )) inAsyncFunction = true;
            }
            let nodeCheckFlag = 0;
            if (!container || !isLegalUsageOfSuperExpression(container)) {
                const current = findAncestor(node, (n)=>n === container ? "quit" : n.kind === 166 /* ComputedPropertyName */ );
                if (current && current.kind === 166 /* ComputedPropertyName */ ) error(node, Diagnostics.super_cannot_be_referenced_in_a_computed_property_name);
                else if (isCallExpression2) error(node, Diagnostics.Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors);
                else if (!container || !container.parent || !(isClassLike(container.parent) || container.parent.kind === 209 /* ObjectLiteralExpression */ )) error(node, Diagnostics.super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions);
                else error(node, Diagnostics.super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_derived_class);
                return errorType;
            }
            if (!isCallExpression2 && immediateContainer.kind === 175 /* Constructor */ ) checkThisBeforeSuper(node, container, Diagnostics.super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class);
            if (isStatic(container) || isCallExpression2) {
                nodeCheckFlag = 32 /* SuperStatic */ ;
                if (!isCallExpression2 && languageVersion >= 2 /* ES2015 */  && languageVersion <= 8 /* ES2021 */  && (isPropertyDeclaration(container) || isClassStaticBlockDeclaration(container))) forEachEnclosingBlockScopeContainer(node.parent, (current)=>{
                    if (!isSourceFile(current) || isExternalOrCommonJsModule(current)) getNodeLinks(current).flags |= 8388608 /* ContainsSuperPropertyInStaticInitializer */ ;
                });
            } else nodeCheckFlag = 16 /* SuperInstance */ ;
            getNodeLinks(node).flags |= nodeCheckFlag;
            if (container.kind === 173 /* MethodDeclaration */  && inAsyncFunction) {
                if (isSuperProperty(node.parent) && isAssignmentTarget(node.parent)) getNodeLinks(container).flags |= 256 /* MethodWithSuperPropertyAssignmentInAsync */ ;
                else getNodeLinks(container).flags |= 128 /* MethodWithSuperPropertyAccessInAsync */ ;
            }
            if (needToCaptureLexicalThis) captureLexicalThis(node.parent, container);
            if (container.parent.kind === 209 /* ObjectLiteralExpression */ ) {
                if (languageVersion < 2 /* ES2015 */ ) {
                    error(node, Diagnostics.super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_higher);
                    return errorType;
                } else return anyType;
            }
            const classLikeDeclaration = container.parent;
            if (!getClassExtendsHeritageElement(classLikeDeclaration)) {
                error(node, Diagnostics.super_can_only_be_referenced_in_a_derived_class);
                return errorType;
            }
            const classType = getDeclaredTypeOfSymbol(getSymbolOfDeclaration(classLikeDeclaration));
            const baseClassType = classType && getBaseTypes(classType)[0];
            if (!baseClassType) return errorType;
            if (container.kind === 175 /* Constructor */  && isInConstructorArgumentInitializer(node, container)) {
                error(node, Diagnostics.super_cannot_be_referenced_in_constructor_arguments);
                return errorType;
            }
            return nodeCheckFlag === 32 /* SuperStatic */  ? getBaseConstructorTypeOfClass(classType) : getTypeWithThisArgument(baseClassType, classType.thisType);
            function isLegalUsageOfSuperExpression(container2) {
                if (isCallExpression2) return container2.kind === 175 /* Constructor */ ;
                else if (isClassLike(container2.parent) || container2.parent.kind === 209 /* ObjectLiteralExpression */ ) {
                    if (isStatic(container2)) return container2.kind === 173 /* MethodDeclaration */  || container2.kind === 172 /* MethodSignature */  || container2.kind === 176 /* GetAccessor */  || container2.kind === 177 /* SetAccessor */  || container2.kind === 171 /* PropertyDeclaration */  || container2.kind === 174 /* ClassStaticBlockDeclaration */ ;
                    else return container2.kind === 173 /* MethodDeclaration */  || container2.kind === 172 /* MethodSignature */  || container2.kind === 176 /* GetAccessor */  || container2.kind === 177 /* SetAccessor */  || container2.kind === 171 /* PropertyDeclaration */  || container2.kind === 170 /* PropertySignature */  || container2.kind === 175 /* Constructor */ ;
                }
                return false;
            }
        }
        function getContainingObjectLiteral(func) {
            return (func.kind === 173 /* MethodDeclaration */  || func.kind === 176 /* GetAccessor */  || func.kind === 177 /* SetAccessor */ ) && func.parent.kind === 209 /* ObjectLiteralExpression */  ? func.parent : func.kind === 217 /* FunctionExpression */  && func.parent.kind === 302 /* PropertyAssignment */  ? func.parent.parent : void 0;
        }
        function getThisTypeArgument(type) {
            return getObjectFlags(type) & 4 /* Reference */  && type.target === globalThisType ? getTypeArguments(type)[0] : void 0;
        }
        function getThisTypeFromContextualType(type) {
            return mapType(type, (t)=>{
                return t.flags & 2097152 /* Intersection */  ? forEach(t.types, getThisTypeArgument) : getThisTypeArgument(t);
            });
        }
        function getContextualThisParameterType(func) {
            if (func.kind === 218 /* ArrowFunction */ ) return void 0;
            if (isContextSensitiveFunctionOrObjectLiteralMethod(func)) {
                const contextualSignature = getContextualSignature(func);
                if (contextualSignature) {
                    const thisParameter = contextualSignature.thisParameter;
                    if (thisParameter) return getTypeOfSymbol(thisParameter);
                }
            }
            const inJs = isInJSFile(func);
            if (noImplicitThis || inJs) {
                const containingLiteral = getContainingObjectLiteral(func);
                if (containingLiteral) {
                    const contextualType = getApparentTypeOfContextualType(containingLiteral, /*contextFlags*/ void 0);
                    let literal = containingLiteral;
                    let type = contextualType;
                    while(type){
                        const thisType = getThisTypeFromContextualType(type);
                        if (thisType) return instantiateType(thisType, getMapperFromContext(getInferenceContext(containingLiteral)));
                        if (literal.parent.kind !== 302 /* PropertyAssignment */ ) break;
                        literal = literal.parent.parent;
                        type = getApparentTypeOfContextualType(literal, /*contextFlags*/ void 0);
                    }
                    return getWidenedType(contextualType ? getNonNullableType(contextualType) : checkExpressionCached(containingLiteral));
                }
                const parent2 = walkUpParenthesizedExpressions(func.parent);
                if (parent2.kind === 225 /* BinaryExpression */  && parent2.operatorToken.kind === 64 /* EqualsToken */ ) {
                    const target = parent2.left;
                    if (isAccessExpression(target)) {
                        const { expression: expression  } = target;
                        if (inJs && isIdentifier(expression)) {
                            const sourceFile = getSourceFileOfNode(parent2);
                            if (sourceFile.commonJsModuleIndicator && getResolvedSymbol(expression) === sourceFile.symbol) return void 0;
                        }
                        return getWidenedType(checkExpressionCached(expression));
                    }
                }
            }
            return void 0;
        }
        function getContextuallyTypedParameterType(parameter) {
            const func = parameter.parent;
            if (!isContextSensitiveFunctionOrObjectLiteralMethod(func)) return void 0;
            const iife = getImmediatelyInvokedFunctionExpression(func);
            if (iife && iife.arguments) {
                const args = getEffectiveCallArguments(iife);
                const indexOfParameter = func.parameters.indexOf(parameter);
                if (parameter.dotDotDotToken) return getSpreadArgumentType(args, indexOfParameter, args.length, anyType, /*context*/ void 0, 0 /* Normal */ );
                const links = getNodeLinks(iife);
                const cached = links.resolvedSignature;
                links.resolvedSignature = anySignature;
                const type = indexOfParameter < args.length ? getWidenedLiteralType(checkExpression(args[indexOfParameter])) : parameter.initializer ? void 0 : undefinedWideningType;
                links.resolvedSignature = cached;
                return type;
            }
            const contextualSignature = getContextualSignature(func);
            if (contextualSignature) {
                const index = func.parameters.indexOf(parameter) - (getThisParameter(func) ? 1 : 0);
                return parameter.dotDotDotToken && lastOrUndefined(func.parameters) === parameter ? getRestTypeAtPosition(contextualSignature, index) : tryGetTypeAtPosition(contextualSignature, index);
            }
        }
        function getContextualTypeForVariableLikeDeclaration(declaration, contextFlags) {
            const typeNode = getEffectiveTypeAnnotationNode(declaration) || (isInJSFile(declaration) ? tryGetJSDocSatisfiesTypeNode(declaration) : void 0);
            if (typeNode) return getTypeFromTypeNode(typeNode);
            switch(declaration.kind){
                case 168 /* Parameter */ :
                    return getContextuallyTypedParameterType(declaration);
                case 207 /* BindingElement */ :
                    return getContextualTypeForBindingElement(declaration, contextFlags);
                case 171 /* PropertyDeclaration */ :
                    if (isStatic(declaration)) return getContextualTypeForStaticPropertyDeclaration(declaration, contextFlags);
            }
        }
        function getContextualTypeForBindingElement(declaration, contextFlags) {
            const parent2 = declaration.parent.parent;
            const name = declaration.propertyName || declaration.name;
            const parentType = getContextualTypeForVariableLikeDeclaration(parent2, contextFlags) || parent2.kind !== 207 /* BindingElement */  && parent2.initializer && checkDeclarationInitializer(parent2, declaration.dotDotDotToken ? 64 /* RestBindingElement */  : 0 /* Normal */ );
            if (!parentType || isBindingPattern(name) || isComputedNonLiteralName(name)) return void 0;
            if (parent2.name.kind === 206 /* ArrayBindingPattern */ ) {
                const index = indexOfNode(declaration.parent.elements, declaration);
                if (index < 0) return void 0;
                return getContextualTypeForElementExpression(parentType, index);
            }
            const nameType = getLiteralTypeFromPropertyName(name);
            if (isTypeUsableAsPropertyName(nameType)) {
                const text = getPropertyNameFromType(nameType);
                return getTypeOfPropertyOfType(parentType, text);
            }
        }
        function getContextualTypeForStaticPropertyDeclaration(declaration, contextFlags) {
            const parentType = isExpression(declaration.parent) && getContextualType2(declaration.parent, contextFlags);
            if (!parentType) return void 0;
            return getTypeOfPropertyOfContextualType(parentType, getSymbolOfDeclaration(declaration).escapedName);
        }
        function getContextualTypeForInitializerExpression(node, contextFlags) {
            const declaration = node.parent;
            if (hasInitializer(declaration) && node === declaration.initializer) {
                const result = getContextualTypeForVariableLikeDeclaration(declaration, contextFlags);
                if (result) return result;
                if (!(contextFlags & 8 /* SkipBindingPatterns */ ) && isBindingPattern(declaration.name) && declaration.name.elements.length > 0) return getTypeFromBindingPattern(declaration.name, /*includePatternInType*/ true, /*reportErrors*/ false);
            }
            return void 0;
        }
        function getContextualTypeForReturnExpression(node, contextFlags) {
            const func = getContainingFunction(node);
            if (func) {
                let contextualReturnType = getContextualReturnType(func, contextFlags);
                if (contextualReturnType) {
                    const functionFlags = getFunctionFlags(func);
                    if (functionFlags & 1 /* Generator */ ) {
                        const isAsyncGenerator = (functionFlags & 2 /* Async */ ) !== 0;
                        if (contextualReturnType.flags & 1048576 /* Union */ ) contextualReturnType = filterType(contextualReturnType, (type)=>!!getIterationTypeOfGeneratorFunctionReturnType(1 /* Return */ , type, isAsyncGenerator));
                        const iterationReturnType = getIterationTypeOfGeneratorFunctionReturnType(1 /* Return */ , contextualReturnType, (functionFlags & 2 /* Async */ ) !== 0);
                        if (!iterationReturnType) return void 0;
                        contextualReturnType = iterationReturnType;
                    }
                    if (functionFlags & 2 /* Async */ ) {
                        const contextualAwaitedType = mapType(contextualReturnType, getAwaitedTypeNoAlias);
                        return contextualAwaitedType && getUnionType([
                            contextualAwaitedType,
                            createPromiseLikeType(contextualAwaitedType)
                        ]);
                    }
                    return contextualReturnType;
                }
            }
            return void 0;
        }
        function getContextualTypeForAwaitOperand(node, contextFlags) {
            const contextualType = getContextualType2(node, contextFlags);
            if (contextualType) {
                const contextualAwaitedType = getAwaitedTypeNoAlias(contextualType);
                return contextualAwaitedType && getUnionType([
                    contextualAwaitedType,
                    createPromiseLikeType(contextualAwaitedType)
                ]);
            }
            return void 0;
        }
        function getContextualTypeForYieldOperand(node, contextFlags) {
            const func = getContainingFunction(node);
            if (func) {
                const functionFlags = getFunctionFlags(func);
                let contextualReturnType = getContextualReturnType(func, contextFlags);
                if (contextualReturnType) {
                    const isAsyncGenerator = (functionFlags & 2 /* Async */ ) !== 0;
                    if (!node.asteriskToken && contextualReturnType.flags & 1048576 /* Union */ ) contextualReturnType = filterType(contextualReturnType, (type)=>!!getIterationTypeOfGeneratorFunctionReturnType(1 /* Return */ , type, isAsyncGenerator));
                    return node.asteriskToken ? contextualReturnType : getIterationTypeOfGeneratorFunctionReturnType(0 /* Yield */ , contextualReturnType, isAsyncGenerator);
                }
            }
            return void 0;
        }
        function isInParameterInitializerBeforeContainingFunction(node) {
            let inBindingInitializer = false;
            while(node.parent && !isFunctionLike(node.parent)){
                if (isParameter(node.parent) && (inBindingInitializer || node.parent.initializer === node)) return true;
                if (isBindingElement(node.parent) && node.parent.initializer === node) inBindingInitializer = true;
                node = node.parent;
            }
            return false;
        }
        function getContextualIterationType(kind, functionDecl) {
            const isAsync = !!(getFunctionFlags(functionDecl) & 2 /* Async */ );
            const contextualReturnType = getContextualReturnType(functionDecl, /*contextFlags*/ void 0);
            if (contextualReturnType) return getIterationTypeOfGeneratorFunctionReturnType(kind, contextualReturnType, isAsync) || void 0;
            return void 0;
        }
        function getContextualReturnType(functionDecl, contextFlags) {
            const returnType = getReturnTypeFromAnnotation(functionDecl);
            if (returnType) return returnType;
            const signature = getContextualSignatureForFunctionLikeDeclaration(functionDecl);
            if (signature && !isResolvingReturnTypeOfSignature(signature)) return getReturnTypeOfSignature(signature);
            const iife = getImmediatelyInvokedFunctionExpression(functionDecl);
            if (iife) return getContextualType2(iife, contextFlags);
            return void 0;
        }
        function getContextualTypeForArgument(callTarget, arg) {
            const args = getEffectiveCallArguments(callTarget);
            const argIndex = args.indexOf(arg);
            return argIndex === -1 ? void 0 : getContextualTypeForArgumentAtIndex(callTarget, argIndex);
        }
        function getContextualTypeForArgumentAtIndex(callTarget, argIndex) {
            if (isImportCall(callTarget)) return argIndex === 0 ? stringType : argIndex === 1 ? getGlobalImportCallOptionsType(/*reportErrors*/ false) : anyType;
            const signature = getNodeLinks(callTarget).resolvedSignature === resolvingSignature ? resolvingSignature : getResolvedSignature(callTarget);
            if (isJsxOpeningLikeElement(callTarget) && argIndex === 0) return getEffectiveFirstArgumentForJsxSignature(signature, callTarget);
            const restIndex = signature.parameters.length - 1;
            return signatureHasRestParameter(signature) && argIndex >= restIndex ? getIndexedAccessType(getTypeOfSymbol(signature.parameters[restIndex]), getNumberLiteralType(argIndex - restIndex), 256 /* Contextual */ ) : getTypeAtPosition(signature, argIndex);
        }
        function getContextualTypeForDecorator(decorator) {
            const signature = getDecoratorCallSignature(decorator);
            return signature ? getOrCreateTypeFromSignature(signature) : void 0;
        }
        function getContextualTypeForSubstitutionExpression(template, substitutionExpression) {
            if (template.parent.kind === 214 /* TaggedTemplateExpression */ ) return getContextualTypeForArgument(template.parent, substitutionExpression);
            return void 0;
        }
        function getContextualTypeForBinaryOperand(node, contextFlags) {
            const binaryExpression = node.parent;
            const { left: left , operatorToken: operatorToken , right: right  } = binaryExpression;
            switch(operatorToken.kind){
                case 64 /* EqualsToken */ :
                case 77 /* AmpersandAmpersandEqualsToken */ :
                case 76 /* BarBarEqualsToken */ :
                case 78 /* QuestionQuestionEqualsToken */ :
                    return node === right ? getContextualTypeForAssignmentDeclaration(binaryExpression) : void 0;
                case 57 /* BarBarToken */ :
                case 61 /* QuestionQuestionToken */ :
                    const type = getContextualType2(binaryExpression, contextFlags);
                    return node === right && (type && type.pattern || !type && !isDefaultedExpandoInitializer(binaryExpression)) ? getTypeOfExpression(left) : type;
                case 56 /* AmpersandAmpersandToken */ :
                case 28 /* CommaToken */ :
                    return node === right ? getContextualType2(binaryExpression, contextFlags) : void 0;
                default:
                    return void 0;
            }
        }
        function getSymbolForExpression(e) {
            if (canHaveSymbol(e) && e.symbol) return e.symbol;
            if (isIdentifier(e)) return getResolvedSymbol(e);
            if (isPropertyAccessExpression(e)) {
                const lhsType = getTypeOfExpression(e.expression);
                return isPrivateIdentifier(e.name) ? tryGetPrivateIdentifierPropertyOfType(lhsType, e.name) : getPropertyOfType(lhsType, e.name.escapedText);
            }
            if (isElementAccessExpression(e)) {
                const propType = checkExpressionCached(e.argumentExpression);
                if (!isTypeUsableAsPropertyName(propType)) return void 0;
                const lhsType = getTypeOfExpression(e.expression);
                return getPropertyOfType(lhsType, getPropertyNameFromType(propType));
            }
            return void 0;
            function tryGetPrivateIdentifierPropertyOfType(type, id) {
                const lexicallyScopedSymbol = lookupSymbolForPrivateIdentifierDeclaration(id.escapedText, id);
                return lexicallyScopedSymbol && getPrivateIdentifierPropertyOfType(type, lexicallyScopedSymbol);
            }
        }
        function getContextualTypeForAssignmentDeclaration(binaryExpression) {
            var _a, _b;
            const kind = getAssignmentDeclarationKind(binaryExpression);
            switch(kind){
                case 0 /* None */ :
                case 4 /* ThisProperty */ :
                    const lhsSymbol = getSymbolForExpression(binaryExpression.left);
                    const decl = lhsSymbol && lhsSymbol.valueDeclaration;
                    if (decl && (isPropertyDeclaration(decl) || isPropertySignature(decl))) {
                        const overallAnnotation = getEffectiveTypeAnnotationNode(decl);
                        return overallAnnotation && instantiateType(getTypeFromTypeNode(overallAnnotation), getSymbolLinks(lhsSymbol).mapper) || (isPropertyDeclaration(decl) ? decl.initializer && getTypeOfExpression(binaryExpression.left) : void 0);
                    }
                    if (kind === 0 /* None */ ) return getTypeOfExpression(binaryExpression.left);
                    return getContextualTypeForThisPropertyAssignment(binaryExpression);
                case 5 /* Property */ :
                    if (isPossiblyAliasedThisProperty(binaryExpression, kind)) return getContextualTypeForThisPropertyAssignment(binaryExpression);
                    else if (!canHaveSymbol(binaryExpression.left) || !binaryExpression.left.symbol) return getTypeOfExpression(binaryExpression.left);
                    else {
                        const decl2 = binaryExpression.left.symbol.valueDeclaration;
                        if (!decl2) return void 0;
                        const lhs = cast(binaryExpression.left, isAccessExpression);
                        const overallAnnotation = getEffectiveTypeAnnotationNode(decl2);
                        if (overallAnnotation) return getTypeFromTypeNode(overallAnnotation);
                        else if (isIdentifier(lhs.expression)) {
                            const id = lhs.expression;
                            const parentSymbol = resolveName(id, id.escapedText, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, id.escapedText, /*isUse*/ true);
                            if (parentSymbol) {
                                const annotated2 = parentSymbol.valueDeclaration && getEffectiveTypeAnnotationNode(parentSymbol.valueDeclaration);
                                if (annotated2) {
                                    const nameStr = getElementOrPropertyAccessName(lhs);
                                    if (nameStr !== void 0) return getTypeOfPropertyOfContextualType(getTypeFromTypeNode(annotated2), nameStr);
                                }
                                return void 0;
                            }
                        }
                        return isInJSFile(decl2) || decl2 === binaryExpression.left ? void 0 : getTypeOfExpression(binaryExpression.left);
                    }
                case 1 /* ExportsProperty */ :
                case 6 /* Prototype */ :
                case 3 /* PrototypeProperty */ :
                case 2 /* ModuleExports */ :
                    let valueDeclaration;
                    if (kind !== 2 /* ModuleExports */ ) valueDeclaration = canHaveSymbol(binaryExpression.left) ? (_a = binaryExpression.left.symbol) == null ? void 0 : _a.valueDeclaration : void 0;
                    valueDeclaration || (valueDeclaration = (_b = binaryExpression.symbol) == null ? void 0 : _b.valueDeclaration);
                    const annotated = valueDeclaration && getEffectiveTypeAnnotationNode(valueDeclaration);
                    return annotated ? getTypeFromTypeNode(annotated) : void 0;
                case 7 /* ObjectDefinePropertyValue */ :
                case 8 /* ObjectDefinePropertyExports */ :
                case 9 /* ObjectDefinePrototypeProperty */ :
                    return Debug.fail("Does not apply");
                default:
                    return Debug.assertNever(kind);
            }
        }
        function isPossiblyAliasedThisProperty(declaration, kind = getAssignmentDeclarationKind(declaration)) {
            if (kind === 4 /* ThisProperty */ ) return true;
            if (!isInJSFile(declaration) || kind !== 5 /* Property */  || !isIdentifier(declaration.left.expression)) return false;
            const name = declaration.left.expression.escapedText;
            const symbol = resolveName(declaration.left, name, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ true, /*excludeGlobals*/ true);
            return isThisInitializedDeclaration(symbol == null ? void 0 : symbol.valueDeclaration);
        }
        function getContextualTypeForThisPropertyAssignment(binaryExpression) {
            if (!binaryExpression.symbol) return getTypeOfExpression(binaryExpression.left);
            if (binaryExpression.symbol.valueDeclaration) {
                const annotated = getEffectiveTypeAnnotationNode(binaryExpression.symbol.valueDeclaration);
                if (annotated) {
                    const type = getTypeFromTypeNode(annotated);
                    if (type) return type;
                }
            }
            const thisAccess = cast(binaryExpression.left, isAccessExpression);
            if (!isObjectLiteralMethod(getThisContainer(thisAccess.expression, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false))) return void 0;
            const thisType = checkThisExpression(thisAccess.expression);
            const nameStr = getElementOrPropertyAccessName(thisAccess);
            return nameStr !== void 0 && getTypeOfPropertyOfContextualType(thisType, nameStr) || void 0;
        }
        function isCircularMappedProperty(symbol) {
            return !!(getCheckFlags(symbol) & 262144 /* Mapped */  && !symbol.links.type && findResolutionCycleStartIndex(symbol, 0 /* Type */ ) >= 0);
        }
        function getTypeOfPropertyOfContextualType(type, name, nameType) {
            return mapType(type, (t)=>{
                var _a;
                if (isGenericMappedType(t) && !t.declaration.nameType) {
                    const constraint = getConstraintTypeFromMappedType(t);
                    const constraintOfConstraint = getBaseConstraintOfType(constraint) || constraint;
                    const propertyNameType = nameType || getStringLiteralType(unescapeLeadingUnderscores(name));
                    if (isTypeAssignableTo(propertyNameType, constraintOfConstraint)) return substituteIndexedMappedType(t, propertyNameType);
                } else if (t.flags & 3670016 /* StructuredType */ ) {
                    const prop = getPropertyOfType(t, name);
                    if (prop) return isCircularMappedProperty(prop) ? void 0 : getTypeOfSymbol(prop);
                    if (isTupleType(t) && isNumericLiteralName(name) && +name >= 0) {
                        const restType = getElementTypeOfSliceOfTupleType(t, t.target.fixedLength, /*endSkipCount*/ 0, /*writing*/ false, /*noReductions*/ true);
                        if (restType) return restType;
                    }
                    return (_a = findApplicableIndexInfo(getIndexInfosOfStructuredType(t), nameType || getStringLiteralType(unescapeLeadingUnderscores(name)))) == null ? void 0 : _a.type;
                }
                return void 0;
            }, /*noReductions*/ true);
        }
        function getContextualTypeForObjectLiteralMethod(node, contextFlags) {
            Debug.assert(isObjectLiteralMethod(node));
            if (node.flags & 33554432 /* InWithStatement */ ) return void 0;
            return getContextualTypeForObjectLiteralElement(node, contextFlags);
        }
        function getContextualTypeForObjectLiteralElement(element, contextFlags) {
            const objectLiteral = element.parent;
            const propertyAssignmentType = isPropertyAssignment(element) && getContextualTypeForVariableLikeDeclaration(element, contextFlags);
            if (propertyAssignmentType) return propertyAssignmentType;
            const type = getApparentTypeOfContextualType(objectLiteral, contextFlags);
            if (type) {
                if (hasBindableName(element)) {
                    const symbol = getSymbolOfDeclaration(element);
                    return getTypeOfPropertyOfContextualType(type, symbol.escapedName, getSymbolLinks(symbol).nameType);
                }
                if (hasDynamicName(element)) {
                    const name = getNameOfDeclaration(element);
                    if (name && isComputedPropertyName(name)) {
                        const exprType = checkExpression(name.expression);
                        const propType = isTypeUsableAsPropertyName(exprType) && getTypeOfPropertyOfContextualType(type, getPropertyNameFromType(exprType));
                        if (propType) return propType;
                    }
                }
                if (element.name) {
                    const nameType = getLiteralTypeFromPropertyName(element.name);
                    return mapType(type, (t)=>{
                        var _a;
                        return (_a = findApplicableIndexInfo(getIndexInfosOfStructuredType(t), nameType)) == null ? void 0 : _a.type;
                    }, /*noReductions*/ true);
                }
            }
            return void 0;
        }
        function getSpreadIndices(elements) {
            let first2, last2;
            for(let i = 0; i < elements.length; i++)if (isSpreadElement(elements[i])) {
                first2 ?? (first2 = i);
                last2 = i;
            }
            return {
                first: first2,
                last: last2
            };
        }
        function getContextualTypeForElementExpression(type, index, length2, firstSpreadIndex, lastSpreadIndex) {
            return type && mapType(type, (t)=>{
                if (isTupleType(t)) {
                    if ((firstSpreadIndex === void 0 || index < firstSpreadIndex) && index < t.target.fixedLength) return getTypeArguments(t)[index];
                    const offset = length2 !== void 0 && (lastSpreadIndex === void 0 || index > lastSpreadIndex) ? length2 - index : 0;
                    const fixedEndLength = offset > 0 && t.target.hasRestElement ? getEndElementCount(t.target, 3 /* Fixed */ ) : 0;
                    if (offset > 0 && offset <= fixedEndLength) return getTypeArguments(t)[getTypeReferenceArity(t) - offset];
                    return getElementTypeOfSliceOfTupleType(t, firstSpreadIndex === void 0 ? t.target.fixedLength : Math.min(t.target.fixedLength, firstSpreadIndex), length2 === void 0 || lastSpreadIndex === void 0 ? fixedEndLength : Math.min(fixedEndLength, length2 - lastSpreadIndex), /*writing*/ false, /*noReductions*/ true);
                }
                return (!firstSpreadIndex || index < firstSpreadIndex) && getTypeOfPropertyOfContextualType(t, "" + index) || getIteratedTypeOrElementType(1 /* Element */ , t, undefinedType, /*errorNode*/ void 0, /*checkAssignability*/ false);
            }, /*noReductions*/ true);
        }
        function getContextualTypeForConditionalOperand(node, contextFlags) {
            const conditional = node.parent;
            return node === conditional.whenTrue || node === conditional.whenFalse ? getContextualType2(conditional, contextFlags) : void 0;
        }
        function getContextualTypeForChildJsxExpression(node, child, contextFlags) {
            const attributesType = getApparentTypeOfContextualType(node.openingElement.attributes, contextFlags);
            const jsxChildrenPropertyName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(node));
            if (!(attributesType && !isTypeAny(attributesType) && jsxChildrenPropertyName && jsxChildrenPropertyName !== "")) return void 0;
            const realChildren = getSemanticJsxChildren(node.children);
            const childIndex = realChildren.indexOf(child);
            const childFieldType = getTypeOfPropertyOfContextualType(attributesType, jsxChildrenPropertyName);
            return childFieldType && (realChildren.length === 1 ? childFieldType : mapType(childFieldType, (t)=>{
                if (isArrayLikeType(t)) return getIndexedAccessType(t, getNumberLiteralType(childIndex));
                else return t;
            }, /*noReductions*/ true));
        }
        function getContextualTypeForJsxExpression(node, contextFlags) {
            const exprParent = node.parent;
            return isJsxAttributeLike(exprParent) ? getContextualType2(node, contextFlags) : isJsxElement(exprParent) ? getContextualTypeForChildJsxExpression(exprParent, node, contextFlags) : void 0;
        }
        function getContextualTypeForJsxAttribute(attribute, contextFlags) {
            if (isJsxAttribute(attribute)) {
                const attributesType = getApparentTypeOfContextualType(attribute.parent, contextFlags);
                if (!attributesType || isTypeAny(attributesType)) return void 0;
                return getTypeOfPropertyOfContextualType(attributesType, getEscapedTextOfJsxAttributeName(attribute.name));
            } else return getContextualType2(attribute.parent, contextFlags);
        }
        function isPossiblyDiscriminantValue(node) {
            switch(node.kind){
                case 11 /* StringLiteral */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 106 /* NullKeyword */ :
                case 80 /* Identifier */ :
                case 157 /* UndefinedKeyword */ :
                    return true;
                case 210 /* PropertyAccessExpression */ :
                case 216 /* ParenthesizedExpression */ :
                    return isPossiblyDiscriminantValue(node.expression);
                case 293 /* JsxExpression */ :
                    return !node.expression || isPossiblyDiscriminantValue(node.expression);
            }
            return false;
        }
        function discriminateContextualTypeByObjectMembers(node, contextualType) {
            return getMatchingUnionConstituentForObjectLiteral(contextualType, node) || discriminateTypeByDiscriminableItems(contextualType, concatenate(map(filter(node.properties, (p)=>!!p.symbol && p.kind === 302 /* PropertyAssignment */  && isPossiblyDiscriminantValue(p.initializer) && isDiscriminantProperty(contextualType, p.symbol.escapedName)), (prop)=>[
                    ()=>getContextFreeTypeOfExpression(prop.initializer),
                    prop.symbol.escapedName
                ]), map(filter(getPropertiesOfType(contextualType), (s)=>{
                var _a;
                return !!(s.flags & 16777216 /* Optional */ ) && !!((_a = node == null ? void 0 : node.symbol) == null ? void 0 : _a.members) && !node.symbol.members.has(s.escapedName) && isDiscriminantProperty(contextualType, s.escapedName);
            }), (s)=>[
                    ()=>undefinedType,
                    s.escapedName
                ])), isTypeAssignableTo);
        }
        function discriminateContextualTypeByJSXAttributes(node, contextualType) {
            const jsxChildrenPropertyName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(node));
            return discriminateTypeByDiscriminableItems(contextualType, concatenate(map(filter(node.properties, (p)=>!!p.symbol && p.kind === 290 /* JsxAttribute */  && isDiscriminantProperty(contextualType, p.symbol.escapedName) && (!p.initializer || isPossiblyDiscriminantValue(p.initializer))), (prop)=>[
                    !prop.initializer ? ()=>trueType : ()=>getContextFreeTypeOfExpression(prop.initializer),
                    prop.symbol.escapedName
                ]), map(filter(getPropertiesOfType(contextualType), (s)=>{
                var _a;
                if (!(s.flags & 16777216 /* Optional */ ) || !((_a = node == null ? void 0 : node.symbol) == null ? void 0 : _a.members)) return false;
                const element = node.parent.parent;
                if (s.escapedName === jsxChildrenPropertyName && isJsxElement(element) && getSemanticJsxChildren(element.children).length) return false;
                return !node.symbol.members.has(s.escapedName) && isDiscriminantProperty(contextualType, s.escapedName);
            }), (s)=>[
                    ()=>undefinedType,
                    s.escapedName
                ])), isTypeAssignableTo);
        }
        function getApparentTypeOfContextualType(node, contextFlags) {
            const contextualType = isObjectLiteralMethod(node) ? getContextualTypeForObjectLiteralMethod(node, contextFlags) : getContextualType2(node, contextFlags);
            const instantiatedType = instantiateContextualType(contextualType, node, contextFlags);
            if (instantiatedType && !(contextFlags && contextFlags & 2 /* NoConstraints */  && instantiatedType.flags & 8650752 /* TypeVariable */ )) {
                const apparentType = mapType(instantiatedType, // When obtaining apparent type of *contextual* type we don't want to get apparent type of mapped types.
                // That would evaluate mapped types with array or tuple type constraints too eagerly
                // and thus it would prevent `getTypeOfPropertyOfContextualType` from obtaining per-position contextual type for elements of array literal expressions.
                // Apparent type of other mapped types is already the mapped type itself so we can just avoid calling `getApparentType` here for all mapped types.
                (t)=>getObjectFlags(t) & 32 /* Mapped */  ? t : getApparentType(t), /*noReductions*/ true);
                return apparentType.flags & 1048576 /* Union */  && isObjectLiteralExpression(node) ? discriminateContextualTypeByObjectMembers(node, apparentType) : apparentType.flags & 1048576 /* Union */  && isJsxAttributes(node) ? discriminateContextualTypeByJSXAttributes(node, apparentType) : apparentType;
            }
        }
        function instantiateContextualType(contextualType, node, contextFlags) {
            if (contextualType && maybeTypeOfKind(contextualType, 465829888 /* Instantiable */ )) {
                const inferenceContext = getInferenceContext(node);
                if (inferenceContext && contextFlags & 1 /* Signature */  && some(inferenceContext.inferences, hasInferenceCandidatesOrDefault)) return instantiateInstantiableTypes(contextualType, inferenceContext.nonFixingMapper);
                if (inferenceContext == null ? void 0 : inferenceContext.returnMapper) {
                    const type = instantiateInstantiableTypes(contextualType, inferenceContext.returnMapper);
                    return type.flags & 1048576 /* Union */  && containsType(type.types, regularFalseType) && containsType(type.types, regularTrueType) ? filterType(type, (t)=>t !== regularFalseType && t !== regularTrueType) : type;
                }
            }
            return contextualType;
        }
        function instantiateInstantiableTypes(type, mapper) {
            if (type.flags & 465829888 /* Instantiable */ ) return instantiateType(type, mapper);
            if (type.flags & 1048576 /* Union */ ) return getUnionType(map(type.types, (t)=>instantiateInstantiableTypes(t, mapper)), 0 /* None */ );
            if (type.flags & 2097152 /* Intersection */ ) return getIntersectionType(map(type.types, (t)=>instantiateInstantiableTypes(t, mapper)));
            return type;
        }
        function getContextualType2(node, contextFlags) {
            var _a;
            if (node.flags & 33554432 /* InWithStatement */ ) return void 0;
            const index = findContextualNode(node, /*includeCaches*/ !contextFlags);
            if (index >= 0) return contextualTypes[index];
            const { parent: parent2  } = node;
            switch(parent2.kind){
                case 259 /* VariableDeclaration */ :
                case 168 /* Parameter */ :
                case 171 /* PropertyDeclaration */ :
                case 170 /* PropertySignature */ :
                case 207 /* BindingElement */ :
                    return getContextualTypeForInitializerExpression(node, contextFlags);
                case 218 /* ArrowFunction */ :
                case 252 /* ReturnStatement */ :
                    return getContextualTypeForReturnExpression(node, contextFlags);
                case 228 /* YieldExpression */ :
                    return getContextualTypeForYieldOperand(parent2, contextFlags);
                case 222 /* AwaitExpression */ :
                    return getContextualTypeForAwaitOperand(parent2, contextFlags);
                case 212 /* CallExpression */ :
                case 213 /* NewExpression */ :
                    return getContextualTypeForArgument(parent2, node);
                case 169 /* Decorator */ :
                    return getContextualTypeForDecorator(parent2);
                case 215 /* TypeAssertionExpression */ :
                case 233 /* AsExpression */ :
                    return isConstTypeReference(parent2.type) ? getContextualType2(parent2, contextFlags) : getTypeFromTypeNode(parent2.type);
                case 225 /* BinaryExpression */ :
                    return getContextualTypeForBinaryOperand(node, contextFlags);
                case 302 /* PropertyAssignment */ :
                case 303 /* ShorthandPropertyAssignment */ :
                    return getContextualTypeForObjectLiteralElement(parent2, contextFlags);
                case 304 /* SpreadAssignment */ :
                    return getContextualType2(parent2.parent, contextFlags);
                case 208 /* ArrayLiteralExpression */ :
                    {
                        const arrayLiteral = parent2;
                        const type = getApparentTypeOfContextualType(arrayLiteral, contextFlags);
                        const elementIndex = indexOfNode(arrayLiteral.elements, node);
                        const spreadIndices = (_a = getNodeLinks(arrayLiteral)).spreadIndices ?? (_a.spreadIndices = getSpreadIndices(arrayLiteral.elements));
                        return getContextualTypeForElementExpression(type, elementIndex, arrayLiteral.elements.length, spreadIndices.first, spreadIndices.last);
                    }
                case 226 /* ConditionalExpression */ :
                    return getContextualTypeForConditionalOperand(node, contextFlags);
                case 238 /* TemplateSpan */ :
                    Debug.assert(parent2.parent.kind === 227 /* TemplateExpression */ );
                    return getContextualTypeForSubstitutionExpression(parent2.parent, node);
                case 216 /* ParenthesizedExpression */ :
                    if (isInJSFile(parent2)) {
                        if (isJSDocSatisfiesExpression(parent2)) return getTypeFromTypeNode(getJSDocSatisfiesExpressionType(parent2));
                        const typeTag = getJSDocTypeTag(parent2);
                        if (typeTag && !isConstTypeReference(typeTag.typeExpression.type)) return getTypeFromTypeNode(typeTag.typeExpression.type);
                    }
                    return getContextualType2(parent2, contextFlags);
                case 234 /* NonNullExpression */ :
                    return getContextualType2(parent2, contextFlags);
                case 237 /* SatisfiesExpression */ :
                    return getTypeFromTypeNode(parent2.type);
                case 276 /* ExportAssignment */ :
                    return tryGetTypeFromEffectiveTypeNode(parent2);
                case 293 /* JsxExpression */ :
                    return getContextualTypeForJsxExpression(parent2, contextFlags);
                case 290 /* JsxAttribute */ :
                case 292 /* JsxSpreadAttribute */ :
                    return getContextualTypeForJsxAttribute(parent2, contextFlags);
                case 285 /* JsxOpeningElement */ :
                case 284 /* JsxSelfClosingElement */ :
                    return getContextualJsxElementAttributesType(parent2, contextFlags);
            }
            return void 0;
        }
        function pushCachedContextualType(node) {
            pushContextualType(node, getContextualType2(node, /*contextFlags*/ void 0), /*isCache*/ true);
        }
        function pushContextualType(node, type, isCache) {
            contextualTypeNodes[contextualTypeCount] = node;
            contextualTypes[contextualTypeCount] = type;
            contextualIsCache[contextualTypeCount] = isCache;
            contextualTypeCount++;
        }
        function popContextualType() {
            contextualTypeCount--;
        }
        function findContextualNode(node, includeCaches) {
            for(let i = contextualTypeCount - 1; i >= 0; i--){
                if (node === contextualTypeNodes[i] && (includeCaches || !contextualIsCache[i])) return i;
            }
            return -1;
        }
        function pushInferenceContext(node, inferenceContext) {
            inferenceContextNodes[inferenceContextCount] = node;
            inferenceContexts[inferenceContextCount] = inferenceContext;
            inferenceContextCount++;
        }
        function popInferenceContext() {
            inferenceContextCount--;
        }
        function getInferenceContext(node) {
            for(let i = inferenceContextCount - 1; i >= 0; i--){
                if (isNodeDescendantOf(node, inferenceContextNodes[i])) return inferenceContexts[i];
            }
        }
        function getContextualJsxElementAttributesType(node, contextFlags) {
            if (isJsxOpeningElement(node) && contextFlags !== 4 /* Completions */ ) {
                const index = findContextualNode(node.parent, /*includeCaches*/ !contextFlags);
                if (index >= 0) return contextualTypes[index];
            }
            return getContextualTypeForArgumentAtIndex(node, 0);
        }
        function getEffectiveFirstArgumentForJsxSignature(signature, node) {
            return getJsxReferenceKind(node) !== 0 /* Component */  ? getJsxPropsTypeFromCallSignature(signature, node) : getJsxPropsTypeFromClassType(signature, node);
        }
        function getJsxPropsTypeFromCallSignature(sig, context) {
            let propsType = getTypeOfFirstParameterOfSignatureWithFallback(sig, unknownType);
            propsType = getJsxManagedAttributesFromLocatedAttributes(context, getJsxNamespaceAt(context), propsType);
            const intrinsicAttribs = getJsxType(JsxNames.IntrinsicAttributes, context);
            if (!isErrorType(intrinsicAttribs)) propsType = intersectTypes(intrinsicAttribs, propsType);
            return propsType;
        }
        function getJsxPropsTypeForSignatureFromMember(sig, forcedLookupLocation) {
            if (sig.compositeSignatures) {
                const results = [];
                for (const signature of sig.compositeSignatures){
                    const instance = getReturnTypeOfSignature(signature);
                    if (isTypeAny(instance)) return instance;
                    const propType = getTypeOfPropertyOfType(instance, forcedLookupLocation);
                    if (!propType) return;
                    results.push(propType);
                }
                return getIntersectionType(results);
            }
            const instanceType = getReturnTypeOfSignature(sig);
            return isTypeAny(instanceType) ? instanceType : getTypeOfPropertyOfType(instanceType, forcedLookupLocation);
        }
        function getStaticTypeOfReferencedJsxConstructor(context) {
            if (isJsxIntrinsicTagName(context.tagName)) {
                const result = getIntrinsicAttributesTypeFromJsxOpeningLikeElement(context);
                const fakeSignature = createSignatureForJSXIntrinsic(context, result);
                return getOrCreateTypeFromSignature(fakeSignature);
            }
            const tagType = checkExpressionCached(context.tagName);
            if (tagType.flags & 128 /* StringLiteral */ ) {
                const result = getIntrinsicAttributesTypeFromStringLiteralType(tagType, context);
                if (!result) return errorType;
                const fakeSignature = createSignatureForJSXIntrinsic(context, result);
                return getOrCreateTypeFromSignature(fakeSignature);
            }
            return tagType;
        }
        function getJsxManagedAttributesFromLocatedAttributes(context, ns, attributesType) {
            const managedSym = getJsxLibraryManagedAttributes(ns);
            if (managedSym) {
                const ctorType = getStaticTypeOfReferencedJsxConstructor(context);
                const result = instantiateAliasOrInterfaceWithDefaults(managedSym, isInJSFile(context), ctorType, attributesType);
                if (result) return result;
            }
            return attributesType;
        }
        function getJsxPropsTypeFromClassType(sig, context) {
            const ns = getJsxNamespaceAt(context);
            const forcedLookupLocation = getJsxElementPropertiesName(ns);
            let attributesType = forcedLookupLocation === void 0 ? getTypeOfFirstParameterOfSignatureWithFallback(sig, unknownType) : forcedLookupLocation === "" ? getReturnTypeOfSignature(sig) : getJsxPropsTypeForSignatureFromMember(sig, forcedLookupLocation);
            if (!attributesType) {
                if (!!forcedLookupLocation && !!length(context.attributes.properties)) error(context, Diagnostics.JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property, unescapeLeadingUnderscores(forcedLookupLocation));
                return unknownType;
            }
            attributesType = getJsxManagedAttributesFromLocatedAttributes(context, ns, attributesType);
            if (isTypeAny(attributesType)) return attributesType;
            else {
                let apparentAttributesType = attributesType;
                const intrinsicClassAttribs = getJsxType(JsxNames.IntrinsicClassAttributes, context);
                if (!isErrorType(intrinsicClassAttribs)) {
                    const typeParams = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(intrinsicClassAttribs.symbol);
                    const hostClassType = getReturnTypeOfSignature(sig);
                    let libraryManagedAttributeType;
                    if (typeParams) {
                        const inferredArgs = fillMissingTypeArguments([
                            hostClassType
                        ], typeParams, getMinTypeArgumentCount(typeParams), isInJSFile(context));
                        libraryManagedAttributeType = instantiateType(intrinsicClassAttribs, createTypeMapper(typeParams, inferredArgs));
                    } else libraryManagedAttributeType = intrinsicClassAttribs;
                    apparentAttributesType = intersectTypes(libraryManagedAttributeType, apparentAttributesType);
                }
                const intrinsicAttribs = getJsxType(JsxNames.IntrinsicAttributes, context);
                if (!isErrorType(intrinsicAttribs)) apparentAttributesType = intersectTypes(intrinsicAttribs, apparentAttributesType);
                return apparentAttributesType;
            }
        }
        function getIntersectedSignatures(signatures) {
            return getStrictOptionValue(compilerOptions, "noImplicitAny") ? reduceLeft(signatures, (left, right)=>left === right || !left ? left : compareTypeParametersIdentical(left.typeParameters, right.typeParameters) ? combineSignaturesOfIntersectionMembers(left, right) : void 0) : void 0;
        }
        function combineIntersectionThisParam(left, right, mapper) {
            if (!left || !right) return left || right;
            const thisType = getUnionType([
                getTypeOfSymbol(left),
                instantiateType(getTypeOfSymbol(right), mapper)
            ]);
            return createSymbolWithType(left, thisType);
        }
        function combineIntersectionParameters(left, right, mapper) {
            const leftCount = getParameterCount(left);
            const rightCount = getParameterCount(right);
            const longest = leftCount >= rightCount ? left : right;
            const shorter = longest === left ? right : left;
            const longestCount = longest === left ? leftCount : rightCount;
            const eitherHasEffectiveRest = hasEffectiveRestParameter(left) || hasEffectiveRestParameter(right);
            const needsExtraRestElement = eitherHasEffectiveRest && !hasEffectiveRestParameter(longest);
            const params = new Array(longestCount + (needsExtraRestElement ? 1 : 0));
            for(let i = 0; i < longestCount; i++){
                let longestParamType = tryGetTypeAtPosition(longest, i);
                if (longest === right) longestParamType = instantiateType(longestParamType, mapper);
                let shorterParamType = tryGetTypeAtPosition(shorter, i) || unknownType;
                if (shorter === right) shorterParamType = instantiateType(shorterParamType, mapper);
                const unionParamType = getUnionType([
                    longestParamType,
                    shorterParamType
                ]);
                const isRestParam = eitherHasEffectiveRest && !needsExtraRestElement && i === longestCount - 1;
                const isOptional = i >= getMinArgumentCount(longest) && i >= getMinArgumentCount(shorter);
                const leftName = i >= leftCount ? void 0 : getParameterNameAtPosition(left, i);
                const rightName = i >= rightCount ? void 0 : getParameterNameAtPosition(right, i);
                const paramName = leftName === rightName ? leftName : !leftName ? rightName : !rightName ? leftName : void 0;
                const paramSymbol = createSymbol(1 /* FunctionScopedVariable */  | (isOptional && !isRestParam ? 16777216 /* Optional */  : 0), paramName || `arg${i}`);
                paramSymbol.links.type = isRestParam ? createArrayType(unionParamType) : unionParamType;
                params[i] = paramSymbol;
            }
            if (needsExtraRestElement) {
                const restParamSymbol = createSymbol(1 /* FunctionScopedVariable */ , "args");
                restParamSymbol.links.type = createArrayType(getTypeAtPosition(shorter, longestCount));
                if (shorter === right) restParamSymbol.links.type = instantiateType(restParamSymbol.links.type, mapper);
                params[longestCount] = restParamSymbol;
            }
            return params;
        }
        function combineSignaturesOfIntersectionMembers(left, right) {
            const typeParams = left.typeParameters || right.typeParameters;
            let paramMapper;
            if (left.typeParameters && right.typeParameters) paramMapper = createTypeMapper(right.typeParameters, left.typeParameters);
            const declaration = left.declaration;
            const params = combineIntersectionParameters(left, right, paramMapper);
            const thisParam = combineIntersectionThisParam(left.thisParameter, right.thisParameter, paramMapper);
            const minArgCount = Math.max(left.minArgumentCount, right.minArgumentCount);
            const result = createSignature(declaration, typeParams, thisParam, params, /*resolvedReturnType*/ void 0, /*resolvedTypePredicate*/ void 0, minArgCount, (left.flags | right.flags) & 39 /* PropagatingFlags */ );
            result.compositeKind = 2097152 /* Intersection */ ;
            result.compositeSignatures = concatenate(left.compositeKind === 2097152 /* Intersection */  && left.compositeSignatures || [
                left
            ], [
                right
            ]);
            if (paramMapper) result.mapper = left.compositeKind === 2097152 /* Intersection */  && left.mapper && left.compositeSignatures ? combineTypeMappers(left.mapper, paramMapper) : paramMapper;
            return result;
        }
        function getContextualCallSignature(type, node) {
            const signatures = getSignaturesOfType(type, 0 /* Call */ );
            const applicableByArity = filter(signatures, (s)=>!isAritySmaller(s, node));
            return applicableByArity.length === 1 ? applicableByArity[0] : getIntersectedSignatures(applicableByArity);
        }
        function isAritySmaller(signature, target) {
            let targetParameterCount = 0;
            for(; targetParameterCount < target.parameters.length; targetParameterCount++){
                const param = target.parameters[targetParameterCount];
                if (param.initializer || param.questionToken || param.dotDotDotToken || isJSDocOptionalParameter(param)) break;
            }
            if (target.parameters.length && parameterIsThisKeyword(target.parameters[0])) targetParameterCount--;
            return !hasEffectiveRestParameter(signature) && getParameterCount(signature) < targetParameterCount;
        }
        function getContextualSignatureForFunctionLikeDeclaration(node) {
            return isFunctionExpressionOrArrowFunction(node) || isObjectLiteralMethod(node) ? getContextualSignature(node) : void 0;
        }
        function getContextualSignature(node) {
            Debug.assert(node.kind !== 173 /* MethodDeclaration */  || isObjectLiteralMethod(node));
            const typeTagSignature = getSignatureOfTypeTag(node);
            if (typeTagSignature) return typeTagSignature;
            const type = getApparentTypeOfContextualType(node, 1 /* Signature */ );
            if (!type) return void 0;
            if (!(type.flags & 1048576 /* Union */ )) return getContextualCallSignature(type, node);
            let signatureList;
            const types = type.types;
            for (const current of types){
                const signature = getContextualCallSignature(current, node);
                if (signature) {
                    if (!signatureList) signatureList = [
                        signature
                    ];
                    else if (!compareSignaturesIdentical(signatureList[0], signature, /*partialMatch*/ false, /*ignoreThisTypes*/ true, /*ignoreReturnTypes*/ true, compareTypesIdentical)) return void 0;
                    else signatureList.push(signature);
                }
            }
            if (signatureList) return signatureList.length === 1 ? signatureList[0] : createUnionSignature(signatureList[0], signatureList);
        }
        function checkSpreadExpression(node, checkMode) {
            if (languageVersion < 2 /* ES2015 */ ) checkExternalEmitHelpers(node, compilerOptions.downlevelIteration ? 1536 /* SpreadIncludes */  : 1024 /* SpreadArray */ );
            const arrayOrIterableType = checkExpression(node.expression, checkMode);
            return checkIteratedTypeOrElementType(33 /* Spread */ , arrayOrIterableType, undefinedType, node.expression);
        }
        function checkSyntheticExpression(node) {
            return node.isSpread ? getIndexedAccessType(node.type, numberType) : node.type;
        }
        function hasDefaultValue(node) {
            return node.kind === 207 /* BindingElement */  && !!node.initializer || node.kind === 225 /* BinaryExpression */  && node.operatorToken.kind === 64 /* EqualsToken */ ;
        }
        function checkArrayLiteral(node, checkMode, forceTuple) {
            const elements = node.elements;
            const elementCount = elements.length;
            const elementTypes = [];
            const elementFlags = [];
            pushCachedContextualType(node);
            const inDestructuringPattern = isAssignmentTarget(node);
            const isSpreadIntoCallOrNew = isSpreadElement(node.parent) && isCallOrNewExpression(node.parent.parent);
            const inConstContext = isSpreadIntoCallOrNew || isConstContext(node);
            const contextualType = getApparentTypeOfContextualType(node, /*contextFlags*/ void 0);
            const inTupleContext = isSpreadIntoCallOrNew || !!contextualType && someType(contextualType, isTupleLikeType);
            let hasOmittedExpression = false;
            for(let i = 0; i < elementCount; i++){
                const e = elements[i];
                if (e.kind === 229 /* SpreadElement */ ) {
                    if (languageVersion < 2 /* ES2015 */ ) checkExternalEmitHelpers(e, compilerOptions.downlevelIteration ? 1536 /* SpreadIncludes */  : 1024 /* SpreadArray */ );
                    const spreadType = checkExpression(e.expression, checkMode, forceTuple);
                    if (isArrayLikeType(spreadType)) {
                        elementTypes.push(spreadType);
                        elementFlags.push(8 /* Variadic */ );
                    } else if (inDestructuringPattern) {
                        const restElementType = getIndexTypeOfType(spreadType, numberType) || getIteratedTypeOrElementType(65 /* Destructuring */ , spreadType, undefinedType, /*errorNode*/ void 0, /*checkAssignability*/ false) || unknownType;
                        elementTypes.push(restElementType);
                        elementFlags.push(4 /* Rest */ );
                    } else {
                        elementTypes.push(checkIteratedTypeOrElementType(33 /* Spread */ , spreadType, undefinedType, e.expression));
                        elementFlags.push(4 /* Rest */ );
                    }
                } else if (exactOptionalPropertyTypes && e.kind === 231 /* OmittedExpression */ ) {
                    hasOmittedExpression = true;
                    elementTypes.push(undefinedOrMissingType);
                    elementFlags.push(2 /* Optional */ );
                } else {
                    const type = checkExpressionForMutableLocation(e, checkMode, forceTuple);
                    elementTypes.push(addOptionality(type, /*isProperty*/ true, hasOmittedExpression));
                    elementFlags.push(hasOmittedExpression ? 2 /* Optional */  : 1 /* Required */ );
                    if (inTupleContext && checkMode && checkMode & 2 /* Inferential */  && !(checkMode & 4 /* SkipContextSensitive */ ) && isContextSensitive(e)) {
                        const inferenceContext = getInferenceContext(node);
                        Debug.assert(inferenceContext);
                        addIntraExpressionInferenceSite(inferenceContext, e, type);
                    }
                }
            }
            popContextualType();
            if (inDestructuringPattern) return createTupleType(elementTypes, elementFlags);
            if (forceTuple || inConstContext || inTupleContext) return createArrayLiteralType(createTupleType(elementTypes, elementFlags, /*readonly*/ inConstContext));
            return createArrayLiteralType(createArrayType(elementTypes.length ? getUnionType(sameMap(elementTypes, (t, i)=>elementFlags[i] & 8 /* Variadic */  ? getIndexedAccessTypeOrUndefined(t, numberType) || anyType : t), 2 /* Subtype */ ) : strictNullChecks ? implicitNeverType : undefinedWideningType, inConstContext));
        }
        function createArrayLiteralType(type) {
            if (!(getObjectFlags(type) & 4 /* Reference */ )) return type;
            let literalType = type.literalType;
            if (!literalType) {
                literalType = type.literalType = cloneTypeReference(type);
                literalType.objectFlags |= 147456 /* ContainsObjectOrArrayLiteral */ ;
            }
            return literalType;
        }
        function isNumericName(name) {
            switch(name.kind){
                case 166 /* ComputedPropertyName */ :
                    return isNumericComputedName(name);
                case 80 /* Identifier */ :
                    return isNumericLiteralName(name.escapedText);
                case 9 /* NumericLiteral */ :
                case 11 /* StringLiteral */ :
                    return isNumericLiteralName(name.text);
                default:
                    return false;
            }
        }
        function isNumericComputedName(name) {
            return isTypeAssignableToKind(checkComputedPropertyName(name), 296 /* NumberLike */ );
        }
        function checkComputedPropertyName(node) {
            const links = getNodeLinks(node.expression);
            if (!links.resolvedType) {
                if ((isTypeLiteralNode(node.parent.parent) || isClassLike(node.parent.parent) || isInterfaceDeclaration(node.parent.parent)) && isBinaryExpression(node.expression) && node.expression.operatorToken.kind === 103 /* InKeyword */  && node.parent.kind !== 176 /* GetAccessor */  && node.parent.kind !== 177 /* SetAccessor */ ) return links.resolvedType = errorType;
                links.resolvedType = checkExpression(node.expression);
                if (isPropertyDeclaration(node.parent) && !hasStaticModifier(node.parent) && isClassExpression(node.parent.parent)) {
                    const container = getEnclosingBlockScopeContainer(node.parent.parent);
                    const enclosingIterationStatement = getEnclosingIterationStatement(container);
                    if (enclosingIterationStatement) {
                        getNodeLinks(enclosingIterationStatement).flags |= 4096 /* LoopWithCapturedBlockScopedBinding */ ;
                        getNodeLinks(node).flags |= 32768 /* BlockScopedBindingInLoop */ ;
                        getNodeLinks(node.parent.parent).flags |= 32768 /* BlockScopedBindingInLoop */ ;
                    }
                }
                if (links.resolvedType.flags & 98304 /* Nullable */  || !isTypeAssignableToKind(links.resolvedType, 402665900 /* ESSymbolLike */ ) && !isTypeAssignableTo(links.resolvedType, stringNumberSymbolType)) error(node, Diagnostics.A_computed_property_name_must_be_of_type_string_number_symbol_or_any);
            }
            return links.resolvedType;
        }
        function isSymbolWithNumericName(symbol) {
            var _a;
            const firstDecl = (_a = symbol.declarations) == null ? void 0 : _a[0];
            return isNumericLiteralName(symbol.escapedName) || firstDecl && isNamedDeclaration(firstDecl) && isNumericName(firstDecl.name);
        }
        function isSymbolWithSymbolName(symbol) {
            var _a;
            const firstDecl = (_a = symbol.declarations) == null ? void 0 : _a[0];
            return isKnownSymbol(symbol) || firstDecl && isNamedDeclaration(firstDecl) && isComputedPropertyName(firstDecl.name) && isTypeAssignableToKind(checkComputedPropertyName(firstDecl.name), 4096 /* ESSymbol */ );
        }
        function getObjectLiteralIndexInfo(node, offset, properties, keyType) {
            const propTypes = [];
            for(let i = offset; i < properties.length; i++){
                const prop = properties[i];
                if (keyType === stringType && !isSymbolWithSymbolName(prop) || keyType === numberType && isSymbolWithNumericName(prop) || keyType === esSymbolType && isSymbolWithSymbolName(prop)) propTypes.push(getTypeOfSymbol(properties[i]));
            }
            const unionType = propTypes.length ? getUnionType(propTypes, 2 /* Subtype */ ) : undefinedType;
            return createIndexInfo(keyType, unionType, isConstContext(node));
        }
        function getImmediateAliasedSymbol(symbol) {
            Debug.assert((symbol.flags & 2097152 /* Alias */ ) !== 0, "Should only get Alias here.");
            const links = getSymbolLinks(symbol);
            if (!links.immediateTarget) {
                const node = getDeclarationOfAliasSymbol(symbol);
                if (!node) return Debug.fail();
                links.immediateTarget = getTargetOfAliasDeclaration(node, /*dontRecursivelyResolve*/ true);
            }
            return links.immediateTarget;
        }
        function checkObjectLiteral(node, checkMode = 0 /* Normal */ ) {
            var _a;
            const inDestructuringPattern = isAssignmentTarget(node);
            checkGrammarObjectLiteralExpression(node, inDestructuringPattern);
            const allPropertiesTable = strictNullChecks ? createSymbolTable() : void 0;
            let propertiesTable = createSymbolTable();
            let propertiesArray = [];
            let spread = emptyObjectType;
            pushCachedContextualType(node);
            const contextualType = getApparentTypeOfContextualType(node, /*contextFlags*/ void 0);
            const contextualTypeHasPattern = contextualType && contextualType.pattern && (contextualType.pattern.kind === 205 /* ObjectBindingPattern */  || contextualType.pattern.kind === 209 /* ObjectLiteralExpression */ );
            const inConstContext = isConstContext(node);
            const checkFlags = inConstContext ? 8 /* Readonly */  : 0;
            const isInJavascript = isInJSFile(node) && !isInJsonFile(node);
            const enumTag = isInJavascript ? getJSDocEnumTag(node) : void 0;
            const isJSObjectLiteral = !contextualType && isInJavascript && !enumTag;
            let objectFlags = freshObjectLiteralFlag;
            let patternWithComputedProperties = false;
            let hasComputedStringProperty = false;
            let hasComputedNumberProperty = false;
            let hasComputedSymbolProperty = false;
            for (const elem of node.properties)if (elem.name && isComputedPropertyName(elem.name)) checkComputedPropertyName(elem.name);
            let offset = 0;
            for (const memberDecl of node.properties){
                let member = getSymbolOfDeclaration(memberDecl);
                const computedNameType = memberDecl.name && memberDecl.name.kind === 166 /* ComputedPropertyName */  ? checkComputedPropertyName(memberDecl.name) : void 0;
                if (memberDecl.kind === 302 /* PropertyAssignment */  || memberDecl.kind === 303 /* ShorthandPropertyAssignment */  || isObjectLiteralMethod(memberDecl)) {
                    let type = memberDecl.kind === 302 /* PropertyAssignment */  ? checkPropertyAssignment(memberDecl, checkMode) : // avoid resolving the left side of the ShorthandPropertyAssignment outside of the destructuring
                    // for error recovery purposes. For example, if a user wrote `{ a = 100 }` instead of `{ a: 100 }`.
                    // we don't want to say "could not find 'a'".
                    memberDecl.kind === 303 /* ShorthandPropertyAssignment */  ? checkExpressionForMutableLocation(!inDestructuringPattern && memberDecl.objectAssignmentInitializer ? memberDecl.objectAssignmentInitializer : memberDecl.name, checkMode) : checkObjectLiteralMethod(memberDecl, checkMode);
                    if (isInJavascript) {
                        const jsDocType = getTypeForDeclarationFromJSDocComment(memberDecl);
                        if (jsDocType) {
                            checkTypeAssignableTo(type, jsDocType, memberDecl);
                            type = jsDocType;
                        } else if (enumTag && enumTag.typeExpression) checkTypeAssignableTo(type, getTypeFromTypeNode(enumTag.typeExpression), memberDecl);
                    }
                    objectFlags |= getObjectFlags(type) & 458752 /* PropagatingFlags */ ;
                    const nameType = computedNameType && isTypeUsableAsPropertyName(computedNameType) ? computedNameType : void 0;
                    const prop = nameType ? createSymbol(4 /* Property */  | member.flags, getPropertyNameFromType(nameType), checkFlags | 4096 /* Late */ ) : createSymbol(4 /* Property */  | member.flags, member.escapedName, checkFlags);
                    if (nameType) prop.links.nameType = nameType;
                    if (inDestructuringPattern) {
                        const isOptional = memberDecl.kind === 302 /* PropertyAssignment */  && hasDefaultValue(memberDecl.initializer) || memberDecl.kind === 303 /* ShorthandPropertyAssignment */  && memberDecl.objectAssignmentInitializer;
                        if (isOptional) prop.flags |= 16777216 /* Optional */ ;
                    } else if (contextualTypeHasPattern && !(getObjectFlags(contextualType) & 512 /* ObjectLiteralPatternWithComputedProperties */ )) {
                        const impliedProp = getPropertyOfType(contextualType, member.escapedName);
                        if (impliedProp) prop.flags |= impliedProp.flags & 16777216 /* Optional */ ;
                        else if (!compilerOptions.suppressExcessPropertyErrors && !getIndexInfoOfType(contextualType, stringType)) error(memberDecl.name, Diagnostics.Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1, symbolToString(member), typeToString(contextualType));
                    }
                    prop.declarations = member.declarations;
                    prop.parent = member.parent;
                    if (member.valueDeclaration) prop.valueDeclaration = member.valueDeclaration;
                    prop.links.type = type;
                    prop.links.target = member;
                    member = prop;
                    allPropertiesTable == null || allPropertiesTable.set(prop.escapedName, prop);
                    if (contextualType && checkMode & 2 /* Inferential */  && !(checkMode & 4 /* SkipContextSensitive */ ) && (memberDecl.kind === 302 /* PropertyAssignment */  || memberDecl.kind === 173 /* MethodDeclaration */ ) && isContextSensitive(memberDecl)) {
                        const inferenceContext = getInferenceContext(node);
                        Debug.assert(inferenceContext);
                        const inferenceNode = memberDecl.kind === 302 /* PropertyAssignment */  ? memberDecl.initializer : memberDecl;
                        addIntraExpressionInferenceSite(inferenceContext, inferenceNode, type);
                    }
                } else if (memberDecl.kind === 304 /* SpreadAssignment */ ) {
                    if (languageVersion < 2 /* ES2015 */ ) checkExternalEmitHelpers(memberDecl, 2 /* Assign */ );
                    if (propertiesArray.length > 0) {
                        spread = getSpreadType(spread, createObjectLiteralType(), node.symbol, objectFlags, inConstContext);
                        propertiesArray = [];
                        propertiesTable = createSymbolTable();
                        hasComputedStringProperty = false;
                        hasComputedNumberProperty = false;
                        hasComputedSymbolProperty = false;
                    }
                    const type = getReducedType(checkExpression(memberDecl.expression, checkMode & 2 /* Inferential */ ));
                    if (isValidSpreadType(type)) {
                        const mergedType = tryMergeUnionOfObjectTypeAndEmptyObject(type, inConstContext);
                        if (allPropertiesTable) checkSpreadPropOverrides(mergedType, allPropertiesTable, memberDecl);
                        offset = propertiesArray.length;
                        if (isErrorType(spread)) continue;
                        spread = getSpreadType(spread, mergedType, node.symbol, objectFlags, inConstContext);
                    } else {
                        error(memberDecl, Diagnostics.Spread_types_may_only_be_created_from_object_types);
                        spread = errorType;
                    }
                    continue;
                } else {
                    Debug.assert(memberDecl.kind === 176 /* GetAccessor */  || memberDecl.kind === 177 /* SetAccessor */ );
                    checkNodeDeferred(memberDecl);
                }
                if (computedNameType && !(computedNameType.flags & 8576 /* StringOrNumberLiteralOrUnique */ )) {
                    if (isTypeAssignableTo(computedNameType, stringNumberSymbolType)) {
                        if (isTypeAssignableTo(computedNameType, numberType)) hasComputedNumberProperty = true;
                        else if (isTypeAssignableTo(computedNameType, esSymbolType)) hasComputedSymbolProperty = true;
                        else hasComputedStringProperty = true;
                        if (inDestructuringPattern) patternWithComputedProperties = true;
                    }
                } else propertiesTable.set(member.escapedName, member);
                propertiesArray.push(member);
            }
            popContextualType();
            if (contextualTypeHasPattern) {
                const rootPatternParent = findAncestor(contextualType.pattern.parent, (n)=>n.kind === 259 /* VariableDeclaration */  || n.kind === 225 /* BinaryExpression */  || n.kind === 168 /* Parameter */ );
                const spreadOrOutsideRootObject = findAncestor(node, (n)=>n === rootPatternParent || n.kind === 304 /* SpreadAssignment */ );
                if (spreadOrOutsideRootObject.kind !== 304 /* SpreadAssignment */ ) {
                    for (const prop of getPropertiesOfType(contextualType))if (!propertiesTable.get(prop.escapedName) && !getPropertyOfType(spread, prop.escapedName)) {
                        if (!(prop.flags & 16777216 /* Optional */ )) error(prop.valueDeclaration || ((_a = tryCast(prop, isTransientSymbol)) == null ? void 0 : _a.links.bindingElement), Diagnostics.Initializer_provides_no_value_for_this_binding_element_and_the_binding_element_has_no_default_value);
                        propertiesTable.set(prop.escapedName, prop);
                        propertiesArray.push(prop);
                    }
                }
            }
            if (isErrorType(spread)) return errorType;
            if (spread !== emptyObjectType) {
                if (propertiesArray.length > 0) {
                    spread = getSpreadType(spread, createObjectLiteralType(), node.symbol, objectFlags, inConstContext);
                    propertiesArray = [];
                    propertiesTable = createSymbolTable();
                    hasComputedStringProperty = false;
                    hasComputedNumberProperty = false;
                }
                return mapType(spread, (t)=>t === emptyObjectType ? createObjectLiteralType() : t);
            }
            return createObjectLiteralType();
            function createObjectLiteralType() {
                const indexInfos = [];
                if (hasComputedStringProperty) indexInfos.push(getObjectLiteralIndexInfo(node, offset, propertiesArray, stringType));
                if (hasComputedNumberProperty) indexInfos.push(getObjectLiteralIndexInfo(node, offset, propertiesArray, numberType));
                if (hasComputedSymbolProperty) indexInfos.push(getObjectLiteralIndexInfo(node, offset, propertiesArray, esSymbolType));
                const result = createAnonymousType(node.symbol, propertiesTable, emptyArray, emptyArray, indexInfos);
                result.objectFlags |= objectFlags | 131200 /* ContainsObjectOrArrayLiteral */ ;
                if (isJSObjectLiteral) result.objectFlags |= 4096 /* JSLiteral */ ;
                if (patternWithComputedProperties) result.objectFlags |= 512 /* ObjectLiteralPatternWithComputedProperties */ ;
                if (inDestructuringPattern) result.pattern = node;
                return result;
            }
        }
        function isValidSpreadType(type) {
            const t = removeDefinitelyFalsyTypes(mapType(type, getBaseConstraintOrType));
            return !!(t.flags & 126615553 /* InstantiableNonPrimitive */  || t.flags & 3145728 /* UnionOrIntersection */  && every(t.types, isValidSpreadType));
        }
        function checkJsxSelfClosingElementDeferred(node) {
            checkJsxOpeningLikeElementOrOpeningFragment(node);
        }
        function checkJsxSelfClosingElement(node, _checkMode) {
            checkNodeDeferred(node);
            return getJsxElementTypeAt(node) || anyType;
        }
        function checkJsxElementDeferred(node) {
            checkJsxOpeningLikeElementOrOpeningFragment(node.openingElement);
            if (isJsxIntrinsicTagName(node.closingElement.tagName)) getIntrinsicTagSymbol(node.closingElement);
            else checkExpression(node.closingElement.tagName);
            checkJsxChildren(node);
        }
        function checkJsxElement(node, _checkMode) {
            checkNodeDeferred(node);
            return getJsxElementTypeAt(node) || anyType;
        }
        function checkJsxFragment(node) {
            checkJsxOpeningLikeElementOrOpeningFragment(node.openingFragment);
            const nodeSourceFile = getSourceFileOfNode(node);
            if (getJSXTransformEnabled(compilerOptions) && (compilerOptions.jsxFactory || nodeSourceFile.pragmas.has("jsx")) && !compilerOptions.jsxFragmentFactory && !nodeSourceFile.pragmas.has("jsxfrag")) error(node, compilerOptions.jsxFactory ? Diagnostics.The_jsxFragmentFactory_compiler_option_must_be_provided_to_use_JSX_fragments_with_the_jsxFactory_compiler_option : Diagnostics.An_jsxFrag_pragma_is_required_when_using_an_jsx_pragma_with_JSX_fragments);
            checkJsxChildren(node);
            return getJsxElementTypeAt(node) || anyType;
        }
        function isHyphenatedJsxName(name) {
            return stringContains(name, "-");
        }
        function isJsxIntrinsicTagName(tagName) {
            return isIdentifier(tagName) && isIntrinsicJsxName(tagName.escapedText) || isJsxNamespacedName(tagName);
        }
        function checkJsxAttribute(node, checkMode) {
            return node.initializer ? checkExpressionForMutableLocation(node.initializer, checkMode) : trueType;
        }
        function createJsxAttributesTypeFromAttributesProperty(openingLikeElement, checkMode = 0 /* Normal */ ) {
            const attributes = openingLikeElement.attributes;
            const contextualType = getContextualType2(attributes, 0 /* None */ );
            const allAttributesTable = strictNullChecks ? createSymbolTable() : void 0;
            let attributesTable = createSymbolTable();
            let spread = emptyJsxObjectType;
            let hasSpreadAnyType = false;
            let typeToIntersect;
            let explicitlySpecifyChildrenAttribute = false;
            let objectFlags = 2048 /* JsxAttributes */ ;
            const jsxChildrenPropertyName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(openingLikeElement));
            for (const attributeDecl of attributes.properties){
                const member = attributeDecl.symbol;
                if (isJsxAttribute(attributeDecl)) {
                    const exprType = checkJsxAttribute(attributeDecl, checkMode);
                    objectFlags |= getObjectFlags(exprType) & 458752 /* PropagatingFlags */ ;
                    const attributeSymbol = createSymbol(4 /* Property */  | member.flags, member.escapedName);
                    attributeSymbol.declarations = member.declarations;
                    attributeSymbol.parent = member.parent;
                    if (member.valueDeclaration) attributeSymbol.valueDeclaration = member.valueDeclaration;
                    attributeSymbol.links.type = exprType;
                    attributeSymbol.links.target = member;
                    attributesTable.set(attributeSymbol.escapedName, attributeSymbol);
                    allAttributesTable == null || allAttributesTable.set(attributeSymbol.escapedName, attributeSymbol);
                    if (getEscapedTextOfJsxAttributeName(attributeDecl.name) === jsxChildrenPropertyName) explicitlySpecifyChildrenAttribute = true;
                    if (contextualType) {
                        const prop = getPropertyOfType(contextualType, member.escapedName);
                        if (prop && prop.declarations && isDeprecatedSymbol(prop) && isIdentifier(attributeDecl.name)) addDeprecatedSuggestion(attributeDecl.name, prop.declarations, attributeDecl.name.escapedText);
                    }
                    if (contextualType && checkMode & 2 /* Inferential */  && !(checkMode & 4 /* SkipContextSensitive */ ) && isContextSensitive(attributeDecl)) {
                        const inferenceContext = getInferenceContext(attributes);
                        Debug.assert(inferenceContext);
                        const inferenceNode = attributeDecl.initializer.expression;
                        addIntraExpressionInferenceSite(inferenceContext, inferenceNode, exprType);
                    }
                } else {
                    Debug.assert(attributeDecl.kind === 292 /* JsxSpreadAttribute */ );
                    if (attributesTable.size > 0) {
                        spread = getSpreadType(spread, createJsxAttributesType(), attributes.symbol, objectFlags, /*readonly*/ false);
                        attributesTable = createSymbolTable();
                    }
                    const exprType = getReducedType(checkExpression(attributeDecl.expression, checkMode & 2 /* Inferential */ ));
                    if (isTypeAny(exprType)) hasSpreadAnyType = true;
                    if (isValidSpreadType(exprType)) {
                        spread = getSpreadType(spread, exprType, attributes.symbol, objectFlags, /*readonly*/ false);
                        if (allAttributesTable) checkSpreadPropOverrides(exprType, allAttributesTable, attributeDecl);
                    } else {
                        error(attributeDecl.expression, Diagnostics.Spread_types_may_only_be_created_from_object_types);
                        typeToIntersect = typeToIntersect ? getIntersectionType([
                            typeToIntersect,
                            exprType
                        ]) : exprType;
                    }
                }
            }
            if (!hasSpreadAnyType) {
                if (attributesTable.size > 0) spread = getSpreadType(spread, createJsxAttributesType(), attributes.symbol, objectFlags, /*readonly*/ false);
            }
            const parent2 = openingLikeElement.parent.kind === 283 /* JsxElement */  ? openingLikeElement.parent : void 0;
            if (parent2 && parent2.openingElement === openingLikeElement && parent2.children.length > 0) {
                const childrenTypes = checkJsxChildren(parent2, checkMode);
                if (!hasSpreadAnyType && jsxChildrenPropertyName && jsxChildrenPropertyName !== "") {
                    if (explicitlySpecifyChildrenAttribute) error(attributes, Diagnostics._0_are_specified_twice_The_attribute_named_0_will_be_overwritten, unescapeLeadingUnderscores(jsxChildrenPropertyName));
                    const contextualType2 = getApparentTypeOfContextualType(openingLikeElement.attributes, /*contextFlags*/ void 0);
                    const childrenContextualType = contextualType2 && getTypeOfPropertyOfContextualType(contextualType2, jsxChildrenPropertyName);
                    const childrenPropSymbol = createSymbol(4 /* Property */ , jsxChildrenPropertyName);
                    childrenPropSymbol.links.type = childrenTypes.length === 1 ? childrenTypes[0] : childrenContextualType && someType(childrenContextualType, isTupleLikeType) ? createTupleType(childrenTypes) : createArrayType(getUnionType(childrenTypes));
                    childrenPropSymbol.valueDeclaration = factory.createPropertySignature(/*modifiers*/ void 0, unescapeLeadingUnderscores(jsxChildrenPropertyName), /*questionToken*/ void 0, /*type*/ void 0);
                    setParent(childrenPropSymbol.valueDeclaration, attributes);
                    childrenPropSymbol.valueDeclaration.symbol = childrenPropSymbol;
                    const childPropMap = createSymbolTable();
                    childPropMap.set(jsxChildrenPropertyName, childrenPropSymbol);
                    spread = getSpreadType(spread, createAnonymousType(attributes.symbol, childPropMap, emptyArray, emptyArray, emptyArray), attributes.symbol, objectFlags, /*readonly*/ false);
                }
            }
            if (hasSpreadAnyType) return anyType;
            if (typeToIntersect && spread !== emptyJsxObjectType) return getIntersectionType([
                typeToIntersect,
                spread
            ]);
            return typeToIntersect || (spread === emptyJsxObjectType ? createJsxAttributesType() : spread);
            function createJsxAttributesType() {
                objectFlags |= freshObjectLiteralFlag;
                const result = createAnonymousType(attributes.symbol, attributesTable, emptyArray, emptyArray, emptyArray);
                result.objectFlags |= objectFlags | 131200 /* ContainsObjectOrArrayLiteral */ ;
                return result;
            }
        }
        function checkJsxChildren(node, checkMode) {
            const childrenTypes = [];
            for (const child of node.children){
                if (child.kind === 12 /* JsxText */ ) {
                    if (!child.containsOnlyTriviaWhiteSpaces) childrenTypes.push(stringType);
                } else if (child.kind === 293 /* JsxExpression */  && !child.expression) continue;
                else childrenTypes.push(checkExpressionForMutableLocation(child, checkMode));
            }
            return childrenTypes;
        }
        function checkSpreadPropOverrides(type, props, spread) {
            for (const right of getPropertiesOfType(type))if (!(right.flags & 16777216 /* Optional */ )) {
                const left = props.get(right.escapedName);
                if (left) {
                    const diagnostic = error(left.valueDeclaration, Diagnostics._0_is_specified_more_than_once_so_this_usage_will_be_overwritten, unescapeLeadingUnderscores(left.escapedName));
                    addRelatedInfo(diagnostic, createDiagnosticForNode(spread, Diagnostics.This_spread_always_overwrites_this_property));
                }
            }
        }
        function checkJsxAttributes(node, checkMode) {
            return createJsxAttributesTypeFromAttributesProperty(node.parent, checkMode);
        }
        function getJsxType(name, location) {
            const namespace = getJsxNamespaceAt(location);
            const exports = namespace && getExportsOfSymbol(namespace);
            const typeSymbol = exports && getSymbol2(exports, name, 788968 /* Type */ );
            return typeSymbol ? getDeclaredTypeOfSymbol(typeSymbol) : errorType;
        }
        function getIntrinsicTagSymbol(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedSymbol) {
                const intrinsicElementsType = getJsxType(JsxNames.IntrinsicElements, node);
                if (!isErrorType(intrinsicElementsType)) {
                    if (!isIdentifier(node.tagName) && !isJsxNamespacedName(node.tagName)) return Debug.fail();
                    const intrinsicProp = getPropertyOfType(intrinsicElementsType, isJsxNamespacedName(node.tagName) ? getEscapedTextOfJsxNamespacedName(node.tagName) : node.tagName.escapedText);
                    if (intrinsicProp) {
                        links.jsxFlags |= 1 /* IntrinsicNamedElement */ ;
                        return links.resolvedSymbol = intrinsicProp;
                    }
                    const indexSignatureType = getIndexTypeOfType(intrinsicElementsType, stringType);
                    if (indexSignatureType) {
                        links.jsxFlags |= 2 /* IntrinsicIndexedElement */ ;
                        return links.resolvedSymbol = intrinsicElementsType.symbol;
                    }
                    error(node, Diagnostics.Property_0_does_not_exist_on_type_1, intrinsicTagNameToString(node.tagName), "JSX." + JsxNames.IntrinsicElements);
                    return links.resolvedSymbol = unknownSymbol;
                } else {
                    if (noImplicitAny) error(node, Diagnostics.JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists, unescapeLeadingUnderscores(JsxNames.IntrinsicElements));
                    return links.resolvedSymbol = unknownSymbol;
                }
            }
            return links.resolvedSymbol;
        }
        function getJsxNamespaceContainerForImplicitImport(location) {
            const file = location && getSourceFileOfNode(location);
            const links = file && getNodeLinks(file);
            if (links && links.jsxImplicitImportContainer === false) return void 0;
            if (links && links.jsxImplicitImportContainer) return links.jsxImplicitImportContainer;
            const runtimeImportSpecifier = getJSXRuntimeImport(getJSXImplicitImportBase(compilerOptions, file), compilerOptions);
            if (!runtimeImportSpecifier) return void 0;
            const isClassic = getEmitModuleResolutionKind(compilerOptions) === 1 /* Classic */ ;
            const errorMessage = isClassic ? Diagnostics.Cannot_find_module_0_Did_you_mean_to_set_the_moduleResolution_option_to_nodenext_or_to_add_aliases_to_the_paths_option : Diagnostics.Cannot_find_module_0_or_its_corresponding_type_declarations;
            const mod = resolveExternalModule(location, runtimeImportSpecifier, errorMessage, location);
            const result = mod && mod !== unknownSymbol ? getMergedSymbol(resolveSymbol(mod)) : void 0;
            if (links) links.jsxImplicitImportContainer = result || false;
            return result;
        }
        function getJsxNamespaceAt(location) {
            const links = location && getNodeLinks(location);
            if (links && links.jsxNamespace) return links.jsxNamespace;
            if (!links || links.jsxNamespace !== false) {
                let resolvedNamespace = getJsxNamespaceContainerForImplicitImport(location);
                if (!resolvedNamespace || resolvedNamespace === unknownSymbol) {
                    const namespaceName = getJsxNamespace(location);
                    resolvedNamespace = resolveName(location, namespaceName, 1920 /* Namespace */ , /*nameNotFoundMessage*/ void 0, namespaceName, /*isUse*/ false);
                }
                if (resolvedNamespace) {
                    const candidate = resolveSymbol(getSymbol2(getExportsOfSymbol(resolveSymbol(resolvedNamespace)), JsxNames.JSX, 1920 /* Namespace */ ));
                    if (candidate && candidate !== unknownSymbol) {
                        if (links) links.jsxNamespace = candidate;
                        return candidate;
                    }
                }
                if (links) links.jsxNamespace = false;
            }
            const s = resolveSymbol(getGlobalSymbol(JsxNames.JSX, 1920 /* Namespace */ , /*diagnostic*/ void 0));
            if (s === unknownSymbol) return void 0;
            return s;
        }
        function getNameFromJsxElementAttributesContainer(nameOfAttribPropContainer, jsxNamespace) {
            const jsxElementAttribPropInterfaceSym = jsxNamespace && getSymbol2(jsxNamespace.exports, nameOfAttribPropContainer, 788968 /* Type */ );
            const jsxElementAttribPropInterfaceType = jsxElementAttribPropInterfaceSym && getDeclaredTypeOfSymbol(jsxElementAttribPropInterfaceSym);
            const propertiesOfJsxElementAttribPropInterface = jsxElementAttribPropInterfaceType && getPropertiesOfType(jsxElementAttribPropInterfaceType);
            if (propertiesOfJsxElementAttribPropInterface) {
                if (propertiesOfJsxElementAttribPropInterface.length === 0) return "";
                else if (propertiesOfJsxElementAttribPropInterface.length === 1) return propertiesOfJsxElementAttribPropInterface[0].escapedName;
                else if (propertiesOfJsxElementAttribPropInterface.length > 1 && jsxElementAttribPropInterfaceSym.declarations) error(jsxElementAttribPropInterfaceSym.declarations[0], Diagnostics.The_global_type_JSX_0_may_not_have_more_than_one_property, unescapeLeadingUnderscores(nameOfAttribPropContainer));
            }
            return void 0;
        }
        function getJsxLibraryManagedAttributes(jsxNamespace) {
            return jsxNamespace && getSymbol2(jsxNamespace.exports, JsxNames.LibraryManagedAttributes, 788968 /* Type */ );
        }
        function getJsxElementTypeSymbol(jsxNamespace) {
            return jsxNamespace && getSymbol2(jsxNamespace.exports, JsxNames.ElementType, 788968 /* Type */ );
        }
        function getJsxElementPropertiesName(jsxNamespace) {
            return getNameFromJsxElementAttributesContainer(JsxNames.ElementAttributesPropertyNameContainer, jsxNamespace);
        }
        function getJsxElementChildrenPropertyName(jsxNamespace) {
            return getNameFromJsxElementAttributesContainer(JsxNames.ElementChildrenAttributeNameContainer, jsxNamespace);
        }
        function getUninstantiatedJsxSignaturesOfType(elementType, caller) {
            if (elementType.flags & 4 /* String */ ) return [
                anySignature
            ];
            else if (elementType.flags & 128 /* StringLiteral */ ) {
                const intrinsicType = getIntrinsicAttributesTypeFromStringLiteralType(elementType, caller);
                if (!intrinsicType) {
                    error(caller, Diagnostics.Property_0_does_not_exist_on_type_1, elementType.value, "JSX." + JsxNames.IntrinsicElements);
                    return emptyArray;
                } else {
                    const fakeSignature = createSignatureForJSXIntrinsic(caller, intrinsicType);
                    return [
                        fakeSignature
                    ];
                }
            }
            const apparentElemType = getApparentType(elementType);
            let signatures = getSignaturesOfType(apparentElemType, 1 /* Construct */ );
            if (signatures.length === 0) signatures = getSignaturesOfType(apparentElemType, 0 /* Call */ );
            if (signatures.length === 0 && apparentElemType.flags & 1048576 /* Union */ ) signatures = getUnionSignatures(map(apparentElemType.types, (t)=>getUninstantiatedJsxSignaturesOfType(t, caller)));
            return signatures;
        }
        function getIntrinsicAttributesTypeFromStringLiteralType(type, location) {
            const intrinsicElementsType = getJsxType(JsxNames.IntrinsicElements, location);
            if (!isErrorType(intrinsicElementsType)) {
                const stringLiteralTypeName = type.value;
                const intrinsicProp = getPropertyOfType(intrinsicElementsType, escapeLeadingUnderscores(stringLiteralTypeName));
                if (intrinsicProp) return getTypeOfSymbol(intrinsicProp);
                const indexSignatureType = getIndexTypeOfType(intrinsicElementsType, stringType);
                if (indexSignatureType) return indexSignatureType;
                return void 0;
            }
            return anyType;
        }
        function checkJsxReturnAssignableToAppropriateBound(refKind, elemInstanceType, openingLikeElement) {
            if (refKind === 1 /* Function */ ) {
                const sfcReturnConstraint = getJsxStatelessElementTypeAt(openingLikeElement);
                if (sfcReturnConstraint) checkTypeRelatedTo(elemInstanceType, sfcReturnConstraint, assignableRelation, openingLikeElement.tagName, Diagnostics.Its_return_type_0_is_not_a_valid_JSX_element, generateInitialErrorChain);
            } else if (refKind === 0 /* Component */ ) {
                const classConstraint = getJsxElementClassTypeAt(openingLikeElement);
                if (classConstraint) checkTypeRelatedTo(elemInstanceType, classConstraint, assignableRelation, openingLikeElement.tagName, Diagnostics.Its_instance_type_0_is_not_a_valid_JSX_element, generateInitialErrorChain);
            } else {
                const sfcReturnConstraint = getJsxStatelessElementTypeAt(openingLikeElement);
                const classConstraint = getJsxElementClassTypeAt(openingLikeElement);
                if (!sfcReturnConstraint || !classConstraint) return;
                const combined = getUnionType([
                    sfcReturnConstraint,
                    classConstraint
                ]);
                checkTypeRelatedTo(elemInstanceType, combined, assignableRelation, openingLikeElement.tagName, Diagnostics.Its_element_type_0_is_not_a_valid_JSX_element, generateInitialErrorChain);
            }
            function generateInitialErrorChain() {
                const componentName = getTextOfNode(openingLikeElement.tagName);
                return chainDiagnosticMessages(/*details*/ void 0, Diagnostics._0_cannot_be_used_as_a_JSX_component, componentName);
            }
        }
        function getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node) {
            Debug.assert(isJsxIntrinsicTagName(node.tagName));
            const links = getNodeLinks(node);
            if (!links.resolvedJsxElementAttributesType) {
                const symbol = getIntrinsicTagSymbol(node);
                if (links.jsxFlags & 1 /* IntrinsicNamedElement */ ) return links.resolvedJsxElementAttributesType = getTypeOfSymbol(symbol) || errorType;
                else if (links.jsxFlags & 2 /* IntrinsicIndexedElement */ ) return links.resolvedJsxElementAttributesType = getIndexTypeOfType(getJsxType(JsxNames.IntrinsicElements, node), stringType) || errorType;
                else return links.resolvedJsxElementAttributesType = errorType;
            }
            return links.resolvedJsxElementAttributesType;
        }
        function getJsxElementClassTypeAt(location) {
            const type = getJsxType(JsxNames.ElementClass, location);
            if (isErrorType(type)) return void 0;
            return type;
        }
        function getJsxElementTypeAt(location) {
            return getJsxType(JsxNames.Element, location);
        }
        function getJsxStatelessElementTypeAt(location) {
            const jsxElementType = getJsxElementTypeAt(location);
            if (jsxElementType) return getUnionType([
                jsxElementType,
                nullType
            ]);
        }
        function getJsxElementTypeTypeAt(location) {
            const ns = getJsxNamespaceAt(location);
            if (!ns) return void 0;
            const sym = getJsxElementTypeSymbol(ns);
            if (!sym) return void 0;
            const type = instantiateAliasOrInterfaceWithDefaults(sym, isInJSFile(location));
            if (!type || isErrorType(type)) return void 0;
            return type;
        }
        function instantiateAliasOrInterfaceWithDefaults(managedSym, inJs, ...typeArguments) {
            const declaredManagedType = getDeclaredTypeOfSymbol(managedSym);
            if (managedSym.flags & 524288 /* TypeAlias */ ) {
                const params = getSymbolLinks(managedSym).typeParameters;
                if (length(params) >= typeArguments.length) {
                    const args = fillMissingTypeArguments(typeArguments, params, typeArguments.length, inJs);
                    return length(args) === 0 ? declaredManagedType : getTypeAliasInstantiation(managedSym, args);
                }
            }
            if (length(declaredManagedType.typeParameters) >= typeArguments.length) {
                const args = fillMissingTypeArguments(typeArguments, declaredManagedType.typeParameters, typeArguments.length, inJs);
                return createTypeReference(declaredManagedType, args);
            }
            return void 0;
        }
        function getJsxIntrinsicTagNamesAt(location) {
            const intrinsics = getJsxType(JsxNames.IntrinsicElements, location);
            return intrinsics ? getPropertiesOfType(intrinsics) : emptyArray;
        }
        function checkJsxPreconditions(errorNode) {
            if ((compilerOptions.jsx || 0 /* None */ ) === 0 /* None */ ) error(errorNode, Diagnostics.Cannot_use_JSX_unless_the_jsx_flag_is_provided);
            if (getJsxElementTypeAt(errorNode) === void 0) {
                if (noImplicitAny) error(errorNode, Diagnostics.JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist);
            }
        }
        function checkJsxOpeningLikeElementOrOpeningFragment(node) {
            const isNodeOpeningLikeElement = isJsxOpeningLikeElement(node);
            if (isNodeOpeningLikeElement) checkGrammarJsxElement(node);
            checkJsxPreconditions(node);
            if (!getJsxNamespaceContainerForImplicitImport(node)) {
                const jsxFactoryRefErr = diagnostics && compilerOptions.jsx === 2 /* React */  ? Diagnostics.Cannot_find_name_0 : void 0;
                const jsxFactoryNamespace = getJsxNamespace(node);
                const jsxFactoryLocation = isNodeOpeningLikeElement ? node.tagName : node;
                let jsxFactorySym;
                if (!(isJsxOpeningFragment(node) && jsxFactoryNamespace === "null")) jsxFactorySym = resolveName(jsxFactoryLocation, jsxFactoryNamespace, 111551 /* Value */ , jsxFactoryRefErr, jsxFactoryNamespace, /*isUse*/ true);
                if (jsxFactorySym) {
                    jsxFactorySym.isReferenced = 67108863 /* All */ ;
                    if (canCollectSymbolAliasAccessabilityData && jsxFactorySym.flags & 2097152 /* Alias */  && !getTypeOnlyAliasDeclaration(jsxFactorySym)) markAliasSymbolAsReferenced(jsxFactorySym);
                }
                if (isJsxOpeningFragment(node)) {
                    const file = getSourceFileOfNode(node);
                    const localJsxNamespace = getLocalJsxNamespace(file);
                    if (localJsxNamespace) resolveName(jsxFactoryLocation, localJsxNamespace, 111551 /* Value */ , jsxFactoryRefErr, localJsxNamespace, /*isUse*/ true);
                }
            }
            if (isNodeOpeningLikeElement) {
                const jsxOpeningLikeNode = node;
                const sig = getResolvedSignature(jsxOpeningLikeNode);
                checkDeprecatedSignature(sig, node);
                const elementTypeConstraint = getJsxElementTypeTypeAt(jsxOpeningLikeNode);
                if (elementTypeConstraint !== void 0) {
                    const tagName = jsxOpeningLikeNode.tagName;
                    const tagType = isJsxIntrinsicTagName(tagName) ? getStringLiteralType(intrinsicTagNameToString(tagName)) : checkExpression(tagName);
                    checkTypeRelatedTo(tagType, elementTypeConstraint, assignableRelation, tagName, Diagnostics.Its_type_0_is_not_a_valid_JSX_element_type, ()=>{
                        const componentName = getTextOfNode(tagName);
                        return chainDiagnosticMessages(/*details*/ void 0, Diagnostics._0_cannot_be_used_as_a_JSX_component, componentName);
                    });
                } else checkJsxReturnAssignableToAppropriateBound(getJsxReferenceKind(jsxOpeningLikeNode), getReturnTypeOfSignature(sig), jsxOpeningLikeNode);
            }
        }
        function isKnownProperty(targetType, name, isComparingJsxAttributes) {
            if (targetType.flags & 524288 /* Object */ ) {
                if (getPropertyOfObjectType(targetType, name) || getApplicableIndexInfoForName(targetType, name) || isLateBoundName(name) && getIndexInfoOfType(targetType, stringType) || isComparingJsxAttributes && isHyphenatedJsxName(name)) return true;
            } else if (targetType.flags & 3145728 /* UnionOrIntersection */  && isExcessPropertyCheckTarget(targetType)) for (const t of targetType.types){
                if (isKnownProperty(t, name, isComparingJsxAttributes)) return true;
            }
            return false;
        }
        function isExcessPropertyCheckTarget(type) {
            return !!(type.flags & 524288 /* Object */  && !(getObjectFlags(type) & 512 /* ObjectLiteralPatternWithComputedProperties */ ) || type.flags & 67108864 /* NonPrimitive */  || type.flags & 1048576 /* Union */  && some(type.types, isExcessPropertyCheckTarget) || type.flags & 2097152 /* Intersection */  && every(type.types, isExcessPropertyCheckTarget));
        }
        function checkJsxExpression(node, checkMode) {
            checkGrammarJsxExpression(node);
            if (node.expression) {
                const type = checkExpression(node.expression, checkMode);
                if (node.dotDotDotToken && type !== anyType && !isArrayType(type)) error(node, Diagnostics.JSX_spread_child_must_be_an_array_type);
                return type;
            } else return errorType;
        }
        function getDeclarationNodeFlagsFromSymbol(s) {
            return s.valueDeclaration ? getCombinedNodeFlags(s.valueDeclaration) : 0;
        }
        function isPrototypeProperty(symbol) {
            if (symbol.flags & 8192 /* Method */  || getCheckFlags(symbol) & 4 /* SyntheticMethod */ ) return true;
            if (isInJSFile(symbol.valueDeclaration)) {
                const parent2 = symbol.valueDeclaration.parent;
                return parent2 && isBinaryExpression(parent2) && getAssignmentDeclarationKind(parent2) === 3 /* PrototypeProperty */ ;
            }
        }
        function checkPropertyAccessibility(node, isSuper, writing, type, prop, reportError = true) {
            const errorNode = !reportError ? void 0 : node.kind === 165 /* QualifiedName */  ? node.right : node.kind === 204 /* ImportType */  ? node : node.kind === 207 /* BindingElement */  && node.propertyName ? node.propertyName : node.name;
            return checkPropertyAccessibilityAtLocation(node, isSuper, writing, type, prop, errorNode);
        }
        function checkPropertyAccessibilityAtLocation(location, isSuper, writing, containingType, prop, errorNode) {
            const flags = getDeclarationModifierFlagsFromSymbol(prop, writing);
            if (isSuper) {
                if (languageVersion < 2 /* ES2015 */ ) {
                    if (symbolHasNonMethodDeclaration(prop)) {
                        if (errorNode) error(errorNode, Diagnostics.Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword);
                        return false;
                    }
                }
                if (flags & 256 /* Abstract */ ) {
                    if (errorNode) error(errorNode, Diagnostics.Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression, symbolToString(prop), typeToString(getDeclaringClass(prop)));
                    return false;
                }
            }
            if (flags & 256 /* Abstract */  && symbolHasNonMethodDeclaration(prop) && (isThisProperty(location) || isThisInitializedObjectBindingExpression(location) || isObjectBindingPattern(location.parent) && isThisInitializedDeclaration(location.parent.parent))) {
                const declaringClassDeclaration = getClassLikeDeclarationOfSymbol(getParentOfSymbol(prop));
                if (declaringClassDeclaration && isNodeUsedDuringClassInitialization(location)) {
                    if (errorNode) error(errorNode, Diagnostics.Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor, symbolToString(prop), getTextOfIdentifierOrLiteral(declaringClassDeclaration.name));
                    return false;
                }
            }
            if (!(flags & 24 /* NonPublicAccessibilityModifier */ )) return true;
            if (flags & 8 /* Private */ ) {
                const declaringClassDeclaration = getClassLikeDeclarationOfSymbol(getParentOfSymbol(prop));
                if (!isNodeWithinClass(location, declaringClassDeclaration)) {
                    if (errorNode) error(errorNode, Diagnostics.Property_0_is_private_and_only_accessible_within_class_1, symbolToString(prop), typeToString(getDeclaringClass(prop)));
                    return false;
                }
                return true;
            }
            if (isSuper) return true;
            let enclosingClass = forEachEnclosingClass(location, (enclosingDeclaration)=>{
                const enclosingClass2 = getDeclaredTypeOfSymbol(getSymbolOfDeclaration(enclosingDeclaration));
                return isClassDerivedFromDeclaringClasses(enclosingClass2, prop, writing);
            });
            if (!enclosingClass) {
                enclosingClass = getEnclosingClassFromThisParameter(location);
                enclosingClass = enclosingClass && isClassDerivedFromDeclaringClasses(enclosingClass, prop, writing);
                if (flags & 32 /* Static */  || !enclosingClass) {
                    if (errorNode) error(errorNode, Diagnostics.Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses, symbolToString(prop), typeToString(getDeclaringClass(prop) || containingType));
                    return false;
                }
            }
            if (flags & 32 /* Static */ ) return true;
            if (containingType.flags & 262144 /* TypeParameter */ ) containingType = containingType.isThisType ? getConstraintOfTypeParameter(containingType) : getBaseConstraintOfType(containingType);
            if (!containingType || !hasBaseType(containingType, enclosingClass)) {
                if (errorNode) error(errorNode, Diagnostics.Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1_This_is_an_instance_of_class_2, symbolToString(prop), typeToString(enclosingClass), typeToString(containingType));
                return false;
            }
            return true;
        }
        function getEnclosingClassFromThisParameter(node) {
            const thisParameter = getThisParameterFromNodeContext(node);
            let thisType = (thisParameter == null ? void 0 : thisParameter.type) && getTypeFromTypeNode(thisParameter.type);
            if (thisType && thisType.flags & 262144 /* TypeParameter */ ) thisType = getConstraintOfTypeParameter(thisType);
            if (thisType && getObjectFlags(thisType) & 7 /* Reference */ ) return getTargetType(thisType);
            return void 0;
        }
        function getThisParameterFromNodeContext(node) {
            const thisContainer = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            return thisContainer && isFunctionLike(thisContainer) ? getThisParameter(thisContainer) : void 0;
        }
        function symbolHasNonMethodDeclaration(symbol) {
            return !!forEachProperty2(symbol, (prop)=>!(prop.flags & 8192 /* Method */ ));
        }
        function checkNonNullExpression(node) {
            return checkNonNullType(checkExpression(node), node);
        }
        function isNullableType(type) {
            return !!(getTypeFacts(type) & 50331648 /* IsUndefinedOrNull */ );
        }
        function getNonNullableTypeIfNeeded(type) {
            return isNullableType(type) ? getNonNullableType(type) : type;
        }
        function reportObjectPossiblyNullOrUndefinedError(node, facts) {
            const nodeText2 = isEntityNameExpression(node) ? entityNameToString(node) : void 0;
            if (node.kind === 106 /* NullKeyword */ ) {
                error(node, Diagnostics.The_value_0_cannot_be_used_here, "null");
                return;
            }
            if (nodeText2 !== void 0 && nodeText2.length < 100) {
                if (isIdentifier(node) && nodeText2 === "undefined") {
                    error(node, Diagnostics.The_value_0_cannot_be_used_here, "undefined");
                    return;
                }
                error(node, facts & 16777216 /* IsUndefined */  ? facts & 33554432 /* IsNull */  ? Diagnostics._0_is_possibly_null_or_undefined : Diagnostics._0_is_possibly_undefined : Diagnostics._0_is_possibly_null, nodeText2);
            } else error(node, facts & 16777216 /* IsUndefined */  ? facts & 33554432 /* IsNull */  ? Diagnostics.Object_is_possibly_null_or_undefined : Diagnostics.Object_is_possibly_undefined : Diagnostics.Object_is_possibly_null);
        }
        function reportCannotInvokePossiblyNullOrUndefinedError(node, facts) {
            error(node, facts & 16777216 /* IsUndefined */  ? facts & 33554432 /* IsNull */  ? Diagnostics.Cannot_invoke_an_object_which_is_possibly_null_or_undefined : Diagnostics.Cannot_invoke_an_object_which_is_possibly_undefined : Diagnostics.Cannot_invoke_an_object_which_is_possibly_null);
        }
        function checkNonNullTypeWithReporter(type, node, reportError) {
            if (strictNullChecks && type.flags & 2 /* Unknown */ ) {
                if (isEntityNameExpression(node)) {
                    const nodeText2 = entityNameToString(node);
                    if (nodeText2.length < 100) {
                        error(node, Diagnostics._0_is_of_type_unknown, nodeText2);
                        return errorType;
                    }
                }
                error(node, Diagnostics.Object_is_of_type_unknown);
                return errorType;
            }
            const facts = getTypeFacts(type);
            if (facts & 50331648 /* IsUndefinedOrNull */ ) {
                reportError(node, facts);
                const t = getNonNullableType(type);
                return t.flags & 229376 /* Never */  ? errorType : t;
            }
            return type;
        }
        function checkNonNullType(type, node) {
            return checkNonNullTypeWithReporter(type, node, reportObjectPossiblyNullOrUndefinedError);
        }
        function checkNonNullNonVoidType(type, node) {
            const nonNullType = checkNonNullType(type, node);
            if (nonNullType.flags & 16384 /* Void */ ) {
                if (isEntityNameExpression(node)) {
                    const nodeText2 = entityNameToString(node);
                    if (isIdentifier(node) && nodeText2 === "undefined") {
                        error(node, Diagnostics.The_value_0_cannot_be_used_here, nodeText2);
                        return nonNullType;
                    }
                    if (nodeText2.length < 100) {
                        error(node, Diagnostics._0_is_possibly_undefined, nodeText2);
                        return nonNullType;
                    }
                }
                error(node, Diagnostics.Object_is_possibly_undefined);
            }
            return nonNullType;
        }
        function checkPropertyAccessExpression(node, checkMode, writeOnly) {
            return node.flags & 32 /* OptionalChain */  ? checkPropertyAccessChain(node, checkMode) : checkPropertyAccessExpressionOrQualifiedName(node, node.expression, checkNonNullExpression(node.expression), node.name, checkMode, writeOnly);
        }
        function checkPropertyAccessChain(node, checkMode) {
            const leftType = checkExpression(node.expression);
            const nonOptionalType = getOptionalExpressionType(leftType, node.expression);
            return propagateOptionalTypeMarker(checkPropertyAccessExpressionOrQualifiedName(node, node.expression, checkNonNullType(nonOptionalType, node.expression), node.name, checkMode), node, nonOptionalType !== leftType);
        }
        function checkQualifiedName(node, checkMode) {
            const leftType = isPartOfTypeQuery(node) && isThisIdentifier(node.left) ? checkNonNullType(checkThisExpression(node.left), node.left) : checkNonNullExpression(node.left);
            return checkPropertyAccessExpressionOrQualifiedName(node, node.left, leftType, node.right, checkMode);
        }
        function isMethodAccessForCall(node) {
            while(node.parent.kind === 216 /* ParenthesizedExpression */ )node = node.parent;
            return isCallOrNewExpression(node.parent) && node.parent.expression === node;
        }
        function lookupSymbolForPrivateIdentifierDeclaration(propName, location) {
            for(let containingClass = getContainingClass(location); !!containingClass; containingClass = getContainingClass(containingClass)){
                const { symbol: symbol  } = containingClass;
                const name = getSymbolNameForPrivateIdentifier(symbol, propName);
                const prop = symbol.members && symbol.members.get(name) || symbol.exports && symbol.exports.get(name);
                if (prop) return prop;
            }
        }
        function checkGrammarPrivateIdentifierExpression(privId) {
            if (!getContainingClass(privId)) return grammarErrorOnNode(privId, Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
            if (!isForInStatement(privId.parent)) {
                if (!isExpressionNode(privId)) return grammarErrorOnNode(privId, Diagnostics.Private_identifiers_are_only_allowed_in_class_bodies_and_may_only_be_used_as_part_of_a_class_member_declaration_property_access_or_on_the_left_hand_side_of_an_in_expression);
                const isInOperation = isBinaryExpression(privId.parent) && privId.parent.operatorToken.kind === 103 /* InKeyword */ ;
                if (!getSymbolForPrivateIdentifierExpression(privId) && !isInOperation) return grammarErrorOnNode(privId, Diagnostics.Cannot_find_name_0, idText(privId));
            }
            return false;
        }
        function checkPrivateIdentifierExpression(privId) {
            checkGrammarPrivateIdentifierExpression(privId);
            const symbol = getSymbolForPrivateIdentifierExpression(privId);
            if (symbol) markPropertyAsReferenced(symbol, /*nodeForCheckWriteOnly*/ void 0, /*isSelfTypeAccess*/ false);
            return anyType;
        }
        function getSymbolForPrivateIdentifierExpression(privId) {
            if (!isExpressionNode(privId)) return void 0;
            const links = getNodeLinks(privId);
            if (links.resolvedSymbol === void 0) links.resolvedSymbol = lookupSymbolForPrivateIdentifierDeclaration(privId.escapedText, privId);
            return links.resolvedSymbol;
        }
        function getPrivateIdentifierPropertyOfType(leftType, lexicallyScopedIdentifier) {
            return getPropertyOfType(leftType, lexicallyScopedIdentifier.escapedName);
        }
        function checkPrivateIdentifierPropertyAccess(leftType, right, lexicallyScopedIdentifier) {
            let propertyOnType;
            const properties = getPropertiesOfType(leftType);
            if (properties) forEach(properties, (symbol)=>{
                const decl = symbol.valueDeclaration;
                if (decl && isNamedDeclaration(decl) && isPrivateIdentifier(decl.name) && decl.name.escapedText === right.escapedText) {
                    propertyOnType = symbol;
                    return true;
                }
            });
            const diagName = diagnosticName(right);
            if (propertyOnType) {
                const typeValueDecl = Debug.checkDefined(propertyOnType.valueDeclaration);
                const typeClass = Debug.checkDefined(getContainingClass(typeValueDecl));
                if (lexicallyScopedIdentifier == null ? void 0 : lexicallyScopedIdentifier.valueDeclaration) {
                    const lexicalValueDecl = lexicallyScopedIdentifier.valueDeclaration;
                    const lexicalClass = getContainingClass(lexicalValueDecl);
                    Debug.assert(!!lexicalClass);
                    if (findAncestor(lexicalClass, (n)=>typeClass === n)) {
                        const diagnostic = error(right, Diagnostics.The_property_0_cannot_be_accessed_on_type_1_within_this_class_because_it_is_shadowed_by_another_private_identifier_with_the_same_spelling, diagName, typeToString(leftType));
                        addRelatedInfo(diagnostic, createDiagnosticForNode(lexicalValueDecl, Diagnostics.The_shadowing_declaration_of_0_is_defined_here, diagName), createDiagnosticForNode(typeValueDecl, Diagnostics.The_declaration_of_0_that_you_probably_intended_to_use_is_defined_here, diagName));
                        return true;
                    }
                }
                error(right, Diagnostics.Property_0_is_not_accessible_outside_class_1_because_it_has_a_private_identifier, diagName, diagnosticName(typeClass.name || anon));
                return true;
            }
            return false;
        }
        function isThisPropertyAccessInConstructor(node, prop) {
            return (isConstructorDeclaredProperty(prop) || isThisProperty(node) && isAutoTypedProperty(prop)) && getThisContainer(node, /*includeArrowFunctions*/ true, /*includeClassComputedPropertyName*/ false) === getDeclaringConstructor(prop);
        }
        function checkPropertyAccessExpressionOrQualifiedName(node, left, leftType, right, checkMode, writeOnly) {
            const parentSymbol = getNodeLinks(left).resolvedSymbol;
            const assignmentKind = getAssignmentTargetKind(node);
            const apparentType = getApparentType(assignmentKind !== 0 /* None */  || isMethodAccessForCall(node) ? getWidenedType(leftType) : leftType);
            const isAnyLike = isTypeAny(apparentType) || apparentType === silentNeverType;
            let prop;
            if (isPrivateIdentifier(right)) {
                if (languageVersion < 99 /* ESNext */ ) {
                    if (assignmentKind !== 0 /* None */ ) checkExternalEmitHelpers(node, 1048576 /* ClassPrivateFieldSet */ );
                    if (assignmentKind !== 1 /* Definite */ ) checkExternalEmitHelpers(node, 524288 /* ClassPrivateFieldGet */ );
                }
                const lexicallyScopedSymbol = lookupSymbolForPrivateIdentifierDeclaration(right.escapedText, right);
                if (assignmentKind && lexicallyScopedSymbol && lexicallyScopedSymbol.valueDeclaration && isMethodDeclaration(lexicallyScopedSymbol.valueDeclaration)) grammarErrorOnNode(right, Diagnostics.Cannot_assign_to_private_method_0_Private_methods_are_not_writable, idText(right));
                if (isAnyLike) {
                    if (lexicallyScopedSymbol) return isErrorType(apparentType) ? errorType : apparentType;
                    if (!getContainingClass(right)) {
                        grammarErrorOnNode(right, Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
                        return anyType;
                    }
                }
                prop = lexicallyScopedSymbol ? getPrivateIdentifierPropertyOfType(leftType, lexicallyScopedSymbol) : void 0;
                if (!prop && checkPrivateIdentifierPropertyAccess(leftType, right, lexicallyScopedSymbol)) return errorType;
                else {
                    const isSetonlyAccessor = prop && prop.flags & 65536 /* SetAccessor */  && !(prop.flags & 32768 /* GetAccessor */ );
                    if (isSetonlyAccessor && assignmentKind !== 1 /* Definite */ ) error(node, Diagnostics.Private_accessor_was_defined_without_a_getter);
                }
            } else {
                if (isAnyLike) {
                    if (isIdentifier(left) && parentSymbol) markAliasReferenced(parentSymbol, node);
                    return isErrorType(apparentType) ? errorType : apparentType;
                }
                prop = getPropertyOfType(apparentType, right.escapedText, /*skipObjectFunctionPropertyAugment*/ false, /*includeTypeOnlyMembers*/ node.kind === 165 /* QualifiedName */ );
            }
            if (isIdentifier(left) && parentSymbol && (getIsolatedModules(compilerOptions) || !(prop && (isConstEnumOrConstEnumOnlyModule(prop) || prop.flags & 8 /* EnumMember */  && node.parent.kind === 305 /* EnumMember */ )) || shouldPreserveConstEnums(compilerOptions) && isExportOrExportExpression(node))) markAliasReferenced(parentSymbol, node);
            let propType;
            if (!prop) {
                const indexInfo = !isPrivateIdentifier(right) && (assignmentKind === 0 /* None */  || !isGenericObjectType(leftType) || isThisTypeParameter(leftType)) ? getApplicableIndexInfoForName(apparentType, right.escapedText) : void 0;
                if (!(indexInfo && indexInfo.type)) {
                    const isUncheckedJS = isUncheckedJSSuggestion(node, leftType.symbol, /*excludeClasses*/ true);
                    if (!isUncheckedJS && isJSLiteralType(leftType)) return anyType;
                    if (leftType.symbol === globalThisSymbol) {
                        if (globalThisSymbol.exports.has(right.escapedText) && globalThisSymbol.exports.get(right.escapedText).flags & 418 /* BlockScoped */ ) error(right, Diagnostics.Property_0_does_not_exist_on_type_1, unescapeLeadingUnderscores(right.escapedText), typeToString(leftType));
                        else if (noImplicitAny) error(right, Diagnostics.Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature, typeToString(leftType));
                        return anyType;
                    }
                    if (right.escapedText && !checkAndReportErrorForExtendingInterface(node)) reportNonexistentProperty(right, isThisTypeParameter(leftType) ? apparentType : leftType, isUncheckedJS);
                    return errorType;
                }
                if (indexInfo.isReadonly && (isAssignmentTarget(node) || isDeleteTarget(node))) error(node, Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(apparentType));
                propType = compilerOptions.noUncheckedIndexedAccess && !isAssignmentTarget(node) ? getUnionType([
                    indexInfo.type,
                    missingType
                ]) : indexInfo.type;
                if (compilerOptions.noPropertyAccessFromIndexSignature && isPropertyAccessExpression(node)) error(right, Diagnostics.Property_0_comes_from_an_index_signature_so_it_must_be_accessed_with_0, unescapeLeadingUnderscores(right.escapedText));
                if (indexInfo.declaration && getCombinedNodeFlags(indexInfo.declaration) & 268435456 /* Deprecated */ ) addDeprecatedSuggestion(right, [
                    indexInfo.declaration
                ], right.escapedText);
            } else {
                const targetPropSymbol = resolveAliasWithDeprecationCheck(prop, right);
                if (isDeprecatedSymbol(targetPropSymbol) && isUncalledFunctionReference(node, targetPropSymbol) && targetPropSymbol.declarations) addDeprecatedSuggestion(right, targetPropSymbol.declarations, right.escapedText);
                checkPropertyNotUsedBeforeDeclaration(prop, node, right);
                markPropertyAsReferenced(prop, node, isSelfTypeAccess(left, parentSymbol));
                getNodeLinks(node).resolvedSymbol = prop;
                checkPropertyAccessibility(node, left.kind === 108 /* SuperKeyword */ , isWriteAccess(node), apparentType, prop);
                if (isAssignmentToReadonlyEntity(node, prop, assignmentKind)) {
                    error(right, Diagnostics.Cannot_assign_to_0_because_it_is_a_read_only_property, idText(right));
                    return errorType;
                }
                propType = isThisPropertyAccessInConstructor(node, prop) ? autoType : writeOnly || isWriteOnlyAccess(node) ? getWriteTypeOfSymbol(prop) : getTypeOfSymbol(prop);
            }
            return getFlowTypeOfAccessExpression(node, prop, propType, right, checkMode);
        }
        function isUncheckedJSSuggestion(node, suggestion, excludeClasses) {
            const file = getSourceFileOfNode(node);
            if (file) {
                if (compilerOptions.checkJs === void 0 && file.checkJsDirective === void 0 && (file.scriptKind === 1 /* JS */  || file.scriptKind === 2 /* JSX */ )) {
                    const declarationFile = forEach(suggestion == null ? void 0 : suggestion.declarations, getSourceFileOfNode);
                    return !(file !== declarationFile && !!declarationFile && isGlobalSourceFile(declarationFile)) && !(excludeClasses && suggestion && suggestion.flags & 32 /* Class */ ) && !(!!node && excludeClasses && isPropertyAccessExpression(node) && node.expression.kind === 110 /* ThisKeyword */ );
                }
            }
            return false;
        }
        function getFlowTypeOfAccessExpression(node, prop, propType, errorNode, checkMode) {
            const assignmentKind = getAssignmentTargetKind(node);
            if (assignmentKind === 1 /* Definite */ ) return removeMissingType(propType, !!(prop && prop.flags & 16777216 /* Optional */ ));
            if (prop && !(prop.flags & 98311 /* Accessor */ ) && !(prop.flags & 8192 /* Method */  && propType.flags & 1048576 /* Union */ ) && !isDuplicatedCommonJSExport(prop.declarations)) return propType;
            if (propType === autoType) return getFlowTypeOfProperty(node, prop);
            propType = getNarrowableTypeForReference(propType, node, checkMode);
            let assumeUninitialized = false;
            if (strictNullChecks && strictPropertyInitialization && isAccessExpression(node) && node.expression.kind === 110 /* ThisKeyword */ ) {
                const declaration = prop && prop.valueDeclaration;
                if (declaration && isPropertyWithoutInitializer(declaration)) {
                    if (!isStatic(declaration)) {
                        const flowContainer = getControlFlowContainer(node);
                        if (flowContainer.kind === 175 /* Constructor */  && flowContainer.parent === declaration.parent && !(declaration.flags & 16777216 /* Ambient */ )) assumeUninitialized = true;
                    }
                }
            } else if (strictNullChecks && prop && prop.valueDeclaration && isPropertyAccessExpression(prop.valueDeclaration) && getAssignmentDeclarationPropertyAccessKind(prop.valueDeclaration) && getControlFlowContainer(node) === getControlFlowContainer(prop.valueDeclaration)) assumeUninitialized = true;
            const flowType = getFlowTypeOfReference(node, propType, assumeUninitialized ? getOptionalType(propType) : propType);
            if (assumeUninitialized && !containsUndefinedType(propType) && containsUndefinedType(flowType)) {
                error(errorNode, Diagnostics.Property_0_is_used_before_being_assigned, symbolToString(prop));
                return propType;
            }
            return assignmentKind ? getBaseTypeOfLiteralType(flowType) : flowType;
        }
        function checkPropertyNotUsedBeforeDeclaration(prop, node, right) {
            const { valueDeclaration: valueDeclaration  } = prop;
            if (!valueDeclaration || getSourceFileOfNode(node).isDeclarationFile) return;
            let diagnosticMessage;
            const declarationName = idText(right);
            if (isInPropertyInitializerOrClassStaticBlock(node) && !isOptionalPropertyDeclaration(valueDeclaration) && !(isAccessExpression(node) && isAccessExpression(node.expression)) && !isBlockScopedNameDeclaredBeforeUse(valueDeclaration, right) && !(isMethodDeclaration(valueDeclaration) && getCombinedModifierFlags(valueDeclaration) & 32 /* Static */ ) && (compilerOptions.useDefineForClassFields || !isPropertyDeclaredInAncestorClass(prop))) diagnosticMessage = error(right, Diagnostics.Property_0_is_used_before_its_initialization, declarationName);
            else if (valueDeclaration.kind === 262 /* ClassDeclaration */  && node.parent.kind !== 182 /* TypeReference */  && !(valueDeclaration.flags & 16777216 /* Ambient */ ) && !isBlockScopedNameDeclaredBeforeUse(valueDeclaration, right)) diagnosticMessage = error(right, Diagnostics.Class_0_used_before_its_declaration, declarationName);
            if (diagnosticMessage) addRelatedInfo(diagnosticMessage, createDiagnosticForNode(valueDeclaration, Diagnostics._0_is_declared_here, declarationName));
        }
        function isInPropertyInitializerOrClassStaticBlock(node) {
            return !!findAncestor(node, (node2)=>{
                switch(node2.kind){
                    case 171 /* PropertyDeclaration */ :
                        return true;
                    case 302 /* PropertyAssignment */ :
                    case 173 /* MethodDeclaration */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                    case 304 /* SpreadAssignment */ :
                    case 166 /* ComputedPropertyName */ :
                    case 238 /* TemplateSpan */ :
                    case 293 /* JsxExpression */ :
                    case 290 /* JsxAttribute */ :
                    case 291 /* JsxAttributes */ :
                    case 292 /* JsxSpreadAttribute */ :
                    case 285 /* JsxOpeningElement */ :
                    case 232 /* ExpressionWithTypeArguments */ :
                    case 297 /* HeritageClause */ :
                        return false;
                    case 218 /* ArrowFunction */ :
                    case 243 /* ExpressionStatement */ :
                        return isBlock(node2.parent) && isClassStaticBlockDeclaration(node2.parent.parent) ? true : "quit";
                    default:
                        return isExpressionNode(node2) ? false : "quit";
                }
            });
        }
        function isPropertyDeclaredInAncestorClass(prop) {
            if (!(prop.parent.flags & 32 /* Class */ )) return false;
            let classType = getTypeOfSymbol(prop.parent);
            while(true){
                classType = classType.symbol && getSuperClass(classType);
                if (!classType) return false;
                const superProperty = getPropertyOfType(classType, prop.escapedName);
                if (superProperty && superProperty.valueDeclaration) return true;
            }
        }
        function getSuperClass(classType) {
            const x = getBaseTypes(classType);
            if (x.length === 0) return void 0;
            return getIntersectionType(x);
        }
        function reportNonexistentProperty(propNode, containingType, isUncheckedJS) {
            let errorInfo;
            let relatedInfo;
            if (!isPrivateIdentifier(propNode) && containingType.flags & 1048576 /* Union */  && !(containingType.flags & 402784252 /* Primitive */ )) {
                for (const subtype of containingType.types)if (!getPropertyOfType(subtype, propNode.escapedText) && !getApplicableIndexInfoForName(subtype, propNode.escapedText)) {
                    errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Property_0_does_not_exist_on_type_1, declarationNameToString(propNode), typeToString(subtype));
                    break;
                }
            }
            if (typeHasStaticProperty(propNode.escapedText, containingType)) {
                const propName = declarationNameToString(propNode);
                const typeName = typeToString(containingType);
                errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_to_access_the_static_member_2_instead, propName, typeName, typeName + "." + propName);
            } else {
                const promisedType = getPromisedTypeOfPromise(containingType);
                if (promisedType && getPropertyOfType(promisedType, propNode.escapedText)) {
                    errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Property_0_does_not_exist_on_type_1, declarationNameToString(propNode), typeToString(containingType));
                    relatedInfo = createDiagnosticForNode(propNode, Diagnostics.Did_you_forget_to_use_await);
                } else {
                    const missingProperty = declarationNameToString(propNode);
                    const container = typeToString(containingType);
                    const libSuggestion = getSuggestedLibForNonExistentProperty(missingProperty, containingType);
                    if (libSuggestion !== void 0) errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Property_0_does_not_exist_on_type_1_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_2_or_later, missingProperty, container, libSuggestion);
                    else {
                        const suggestion = getSuggestedSymbolForNonexistentProperty(propNode, containingType);
                        if (suggestion !== void 0) {
                            const suggestedName = symbolName(suggestion);
                            const message = isUncheckedJS ? Diagnostics.Property_0_may_not_exist_on_type_1_Did_you_mean_2 : Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2;
                            errorInfo = chainDiagnosticMessages(errorInfo, message, missingProperty, container, suggestedName);
                            relatedInfo = suggestion.valueDeclaration && createDiagnosticForNode(suggestion.valueDeclaration, Diagnostics._0_is_declared_here, suggestedName);
                        } else {
                            const diagnostic = containerSeemsToBeEmptyDomElement(containingType) ? Diagnostics.Property_0_does_not_exist_on_type_1_Try_changing_the_lib_compiler_option_to_include_dom : Diagnostics.Property_0_does_not_exist_on_type_1;
                            errorInfo = chainDiagnosticMessages(elaborateNeverIntersection(errorInfo, containingType), diagnostic, missingProperty, container);
                        }
                    }
                }
            }
            const resultDiagnostic = createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(propNode), propNode, errorInfo);
            if (relatedInfo) addRelatedInfo(resultDiagnostic, relatedInfo);
            addErrorOrSuggestion(!isUncheckedJS || errorInfo.code !== Diagnostics.Property_0_may_not_exist_on_type_1_Did_you_mean_2.code, resultDiagnostic);
        }
        function containerSeemsToBeEmptyDomElement(containingType) {
            return compilerOptions.lib && !compilerOptions.lib.includes("dom") && everyContainedType(containingType, (type)=>type.symbol && /^(EventTarget|Node|((HTML[a-zA-Z]*)?Element))$/.test(unescapeLeadingUnderscores(type.symbol.escapedName))) && isEmptyObjectType(containingType);
        }
        function typeHasStaticProperty(propName, containingType) {
            const prop = containingType.symbol && getPropertyOfType(getTypeOfSymbol(containingType.symbol), propName);
            return prop !== void 0 && !!prop.valueDeclaration && isStatic(prop.valueDeclaration);
        }
        function getSuggestedLibForNonExistentName(name) {
            const missingName = diagnosticName(name);
            const allFeatures = getScriptTargetFeatures();
            const typeFeatures = allFeatures.get(missingName);
            return typeFeatures && firstIterator(typeFeatures.keys());
        }
        function getSuggestedLibForNonExistentProperty(missingProperty, containingType) {
            const container = getApparentType(containingType).symbol;
            if (!container) return void 0;
            const containingTypeName = symbolName(container);
            const allFeatures = getScriptTargetFeatures();
            const typeFeatures = allFeatures.get(containingTypeName);
            if (typeFeatures) for (const [libTarget, featuresOfType] of typeFeatures){
                if (contains(featuresOfType, missingProperty)) return libTarget;
            }
        }
        function getSuggestedSymbolForNonexistentClassMember(name, baseType) {
            return getSpellingSuggestionForName(name, getPropertiesOfType(baseType), 106500 /* ClassMember */ );
        }
        function getSuggestedSymbolForNonexistentProperty(name, containingType) {
            let props = getPropertiesOfType(containingType);
            if (typeof name !== "string") {
                const parent2 = name.parent;
                if (isPropertyAccessExpression(parent2)) props = filter(props, (prop)=>isValidPropertyAccessForCompletions(parent2, containingType, prop));
                name = idText(name);
            }
            return getSpellingSuggestionForName(name, props, 111551 /* Value */ );
        }
        function getSuggestedSymbolForNonexistentJSXAttribute(name, containingType) {
            const strName = isString(name) ? name : idText(name);
            const properties = getPropertiesOfType(containingType);
            const jsxSpecific = strName === "for" ? find(properties, (x)=>symbolName(x) === "htmlFor") : strName === "class" ? find(properties, (x)=>symbolName(x) === "className") : void 0;
            return jsxSpecific ?? getSpellingSuggestionForName(strName, properties, 111551 /* Value */ );
        }
        function getSuggestionForNonexistentProperty(name, containingType) {
            const suggestion = getSuggestedSymbolForNonexistentProperty(name, containingType);
            return suggestion && symbolName(suggestion);
        }
        function getSuggestedSymbolForNonexistentSymbol(location, outerName, meaning) {
            Debug.assert(outerName !== void 0, "outername should always be defined");
            const result = resolveNameHelper(location, outerName, meaning, /*nameNotFoundMessage*/ void 0, outerName, /*isUse*/ false, /*excludeGlobals*/ false, /*getSpellingSuggestions*/ true, (symbols, name, meaning2)=>{
                Debug.assertEqual(outerName, name, "name should equal outerName");
                const symbol = getSymbol2(symbols, name, meaning2);
                if (symbol) return symbol;
                let candidates;
                if (symbols === globals) {
                    const primitives = mapDefined([
                        "string",
                        "number",
                        "boolean",
                        "object",
                        "bigint",
                        "symbol"
                    ], (s)=>symbols.has(s.charAt(0).toUpperCase() + s.slice(1)) ? createSymbol(524288 /* TypeAlias */ , s) : void 0);
                    candidates = primitives.concat(arrayFrom(symbols.values()));
                } else candidates = arrayFrom(symbols.values());
                return getSpellingSuggestionForName(unescapeLeadingUnderscores(name), candidates, meaning2);
            });
            return result;
        }
        function getSuggestionForNonexistentSymbol(location, outerName, meaning) {
            const symbolResult = getSuggestedSymbolForNonexistentSymbol(location, outerName, meaning);
            return symbolResult && symbolName(symbolResult);
        }
        function getSuggestedSymbolForNonexistentModule(name, targetModule) {
            return targetModule.exports && getSpellingSuggestionForName(idText(name), getExportsOfModuleAsArray(targetModule), 2623475 /* ModuleMember */ );
        }
        function getSuggestionForNonexistentExport(name, targetModule) {
            const suggestion = getSuggestedSymbolForNonexistentModule(name, targetModule);
            return suggestion && symbolName(suggestion);
        }
        function getSuggestionForNonexistentIndexSignature(objectType, expr, keyedType) {
            function hasProp(name) {
                const prop = getPropertyOfObjectType(objectType, name);
                if (prop) {
                    const s = getSingleCallSignature(getTypeOfSymbol(prop));
                    return !!s && getMinArgumentCount(s) >= 1 && isTypeAssignableTo(keyedType, getTypeAtPosition(s, 0));
                }
                return false;
            }
            const suggestedMethod = isAssignmentTarget(expr) ? "set" : "get";
            if (!hasProp(suggestedMethod)) return void 0;
            let suggestion = tryGetPropertyAccessOrIdentifierToString(expr.expression);
            if (suggestion === void 0) suggestion = suggestedMethod;
            else suggestion += "." + suggestedMethod;
            return suggestion;
        }
        function getSuggestedTypeForNonexistentStringLiteralType(source, target) {
            const candidates = target.types.filter((type)=>!!(type.flags & 128 /* StringLiteral */ ));
            return getSpellingSuggestion(source.value, candidates, (type)=>type.value);
        }
        function getSpellingSuggestionForName(name, symbols, meaning) {
            return getSpellingSuggestion(name, symbols, getCandidateName);
            function getCandidateName(candidate) {
                const candidateName = symbolName(candidate);
                if (startsWith(candidateName, '"')) return void 0;
                if (candidate.flags & meaning) return candidateName;
                if (candidate.flags & 2097152 /* Alias */ ) {
                    const alias = tryResolveAlias(candidate);
                    if (alias && alias.flags & meaning) return candidateName;
                }
                return void 0;
            }
        }
        function markPropertyAsReferenced(prop, nodeForCheckWriteOnly, isSelfTypeAccess2) {
            const valueDeclaration = prop && prop.flags & 106500 /* ClassMember */  && prop.valueDeclaration;
            if (!valueDeclaration) return;
            const hasPrivateModifier = hasEffectiveModifier(valueDeclaration, 8 /* Private */ );
            const hasPrivateIdentifier = prop.valueDeclaration && isNamedDeclaration(prop.valueDeclaration) && isPrivateIdentifier(prop.valueDeclaration.name);
            if (!hasPrivateModifier && !hasPrivateIdentifier) return;
            if (nodeForCheckWriteOnly && isWriteOnlyAccess(nodeForCheckWriteOnly) && !(prop.flags & 65536 /* SetAccessor */ )) return;
            if (isSelfTypeAccess2) {
                const containingMethod = findAncestor(nodeForCheckWriteOnly, isFunctionLikeDeclaration);
                if (containingMethod && containingMethod.symbol === prop) return;
            }
            (getCheckFlags(prop) & 1 /* Instantiated */  ? getSymbolLinks(prop).target : prop).isReferenced = 67108863 /* All */ ;
        }
        function isSelfTypeAccess(name, parent2) {
            return name.kind === 110 /* ThisKeyword */  || !!parent2 && isEntityNameExpression(name) && parent2 === getResolvedSymbol(getFirstIdentifier(name));
        }
        function isValidPropertyAccess(node, propertyName) {
            switch(node.kind){
                case 210 /* PropertyAccessExpression */ :
                    return isValidPropertyAccessWithType(node, node.expression.kind === 108 /* SuperKeyword */ , propertyName, getWidenedType(checkExpression(node.expression)));
                case 165 /* QualifiedName */ :
                    return isValidPropertyAccessWithType(node, /*isSuper*/ false, propertyName, getWidenedType(checkExpression(node.left)));
                case 204 /* ImportType */ :
                    return isValidPropertyAccessWithType(node, /*isSuper*/ false, propertyName, getTypeFromTypeNode(node));
            }
        }
        function isValidPropertyAccessForCompletions(node, type, property) {
            return isPropertyAccessible(node, node.kind === 210 /* PropertyAccessExpression */  && node.expression.kind === 108 /* SuperKeyword */ , /*isWrite*/ false, type, property);
        }
        function isValidPropertyAccessWithType(node, isSuper, propertyName, type) {
            if (isTypeAny(type)) return true;
            const prop = getPropertyOfType(type, propertyName);
            return !!prop && isPropertyAccessible(node, isSuper, /*isWrite*/ false, type, prop);
        }
        function isPropertyAccessible(node, isSuper, isWrite, containingType, property) {
            if (isTypeAny(containingType)) return true;
            if (property.valueDeclaration && isPrivateIdentifierClassElementDeclaration(property.valueDeclaration)) {
                const declClass = getContainingClass(property.valueDeclaration);
                return !isOptionalChain(node) && !!findAncestor(node, (parent2)=>parent2 === declClass);
            }
            return checkPropertyAccessibilityAtLocation(node, isSuper, isWrite, containingType, property);
        }
        function getForInVariableSymbol(node) {
            const initializer = node.initializer;
            if (initializer.kind === 260 /* VariableDeclarationList */ ) {
                const variable = initializer.declarations[0];
                if (variable && !isBindingPattern(variable.name)) return getSymbolOfDeclaration(variable);
            } else if (initializer.kind === 80 /* Identifier */ ) return getResolvedSymbol(initializer);
            return void 0;
        }
        function hasNumericPropertyNames(type) {
            return getIndexInfosOfType(type).length === 1 && !!getIndexInfoOfType(type, numberType);
        }
        function isForInVariableForNumericPropertyNames(expr) {
            const e = skipParentheses(expr);
            if (e.kind === 80 /* Identifier */ ) {
                const symbol = getResolvedSymbol(e);
                if (symbol.flags & 3 /* Variable */ ) {
                    let child = expr;
                    let node = expr.parent;
                    while(node){
                        if (node.kind === 248 /* ForInStatement */  && child === node.statement && getForInVariableSymbol(node) === symbol && hasNumericPropertyNames(getTypeOfExpression(node.expression))) return true;
                        child = node;
                        node = node.parent;
                    }
                }
            }
            return false;
        }
        function checkIndexedAccess(node, checkMode) {
            return node.flags & 32 /* OptionalChain */  ? checkElementAccessChain(node, checkMode) : checkElementAccessExpression(node, checkNonNullExpression(node.expression), checkMode);
        }
        function checkElementAccessChain(node, checkMode) {
            const exprType = checkExpression(node.expression);
            const nonOptionalType = getOptionalExpressionType(exprType, node.expression);
            return propagateOptionalTypeMarker(checkElementAccessExpression(node, checkNonNullType(nonOptionalType, node.expression), checkMode), node, nonOptionalType !== exprType);
        }
        function checkElementAccessExpression(node, exprType, checkMode) {
            const objectType = getAssignmentTargetKind(node) !== 0 /* None */  || isMethodAccessForCall(node) ? getWidenedType(exprType) : exprType;
            const indexExpression = node.argumentExpression;
            const indexType = checkExpression(indexExpression);
            if (isErrorType(objectType) || objectType === silentNeverType) return objectType;
            if (isConstEnumObjectType(objectType) && !isStringLiteralLike(indexExpression)) {
                error(indexExpression, Diagnostics.A_const_enum_member_can_only_be_accessed_using_a_string_literal);
                return errorType;
            }
            const effectiveIndexType = isForInVariableForNumericPropertyNames(indexExpression) ? numberType : indexType;
            const accessFlags = isAssignmentTarget(node) ? 4 /* Writing */  | (isGenericObjectType(objectType) && !isThisTypeParameter(objectType) ? 2 /* NoIndexSignatures */  : 0) : 32 /* ExpressionPosition */ ;
            const indexedAccessType = getIndexedAccessTypeOrUndefined(objectType, effectiveIndexType, accessFlags, node) || errorType;
            return checkIndexedAccessIndexType(getFlowTypeOfAccessExpression(node, getNodeLinks(node).resolvedSymbol, indexedAccessType, indexExpression, checkMode), node);
        }
        function callLikeExpressionMayHaveTypeArguments(node) {
            return isCallOrNewExpression(node) || isTaggedTemplateExpression(node) || isJsxOpeningLikeElement(node);
        }
        function resolveUntypedCall(node) {
            if (callLikeExpressionMayHaveTypeArguments(node)) forEach(node.typeArguments, checkSourceElement);
            if (node.kind === 214 /* TaggedTemplateExpression */ ) checkExpression(node.template);
            else if (isJsxOpeningLikeElement(node)) checkExpression(node.attributes);
            else if (node.kind !== 169 /* Decorator */ ) forEach(node.arguments, (argument)=>{
                checkExpression(argument);
            });
            return anySignature;
        }
        function resolveErrorCall(node) {
            resolveUntypedCall(node);
            return unknownSignature;
        }
        function reorderCandidates(signatures, result, callChainFlags) {
            let lastParent;
            let lastSymbol;
            let cutoffIndex = 0;
            let index;
            let specializedIndex = -1;
            let spliceIndex;
            Debug.assert(!result.length);
            for (const signature of signatures){
                const symbol = signature.declaration && getSymbolOfDeclaration(signature.declaration);
                const parent2 = signature.declaration && signature.declaration.parent;
                if (!lastSymbol || symbol === lastSymbol) {
                    if (lastParent && parent2 === lastParent) index = index + 1;
                    else {
                        lastParent = parent2;
                        index = cutoffIndex;
                    }
                } else {
                    index = cutoffIndex = result.length;
                    lastParent = parent2;
                }
                lastSymbol = symbol;
                if (signatureHasLiteralTypes(signature)) {
                    specializedIndex++;
                    spliceIndex = specializedIndex;
                    cutoffIndex++;
                } else spliceIndex = index;
                result.splice(spliceIndex, 0, callChainFlags ? getOptionalCallSignature(signature, callChainFlags) : signature);
            }
        }
        function isSpreadArgument(arg) {
            return !!arg && (arg.kind === 229 /* SpreadElement */  || arg.kind === 236 /* SyntheticExpression */  && arg.isSpread);
        }
        function getSpreadArgumentIndex(args) {
            return findIndex(args, isSpreadArgument);
        }
        function acceptsVoid(t) {
            return !!(t.flags & 16384 /* Void */ );
        }
        function acceptsVoidUndefinedUnknownOrAny(t) {
            return !!(t.flags & 49155 /* Any */ );
        }
        function hasCorrectArity(node, args, signature, signatureHelpTrailingComma = false) {
            let argCount;
            let callIsIncomplete = false;
            let effectiveParameterCount = getParameterCount(signature);
            let effectiveMinimumArguments = getMinArgumentCount(signature);
            if (node.kind === 214 /* TaggedTemplateExpression */ ) {
                argCount = args.length;
                if (node.template.kind === 227 /* TemplateExpression */ ) {
                    const lastSpan = last(node.template.templateSpans);
                    callIsIncomplete = nodeIsMissing(lastSpan.literal) || !!lastSpan.literal.isUnterminated;
                } else {
                    const templateLiteral = node.template;
                    Debug.assert(templateLiteral.kind === 15 /* NoSubstitutionTemplateLiteral */ );
                    callIsIncomplete = !!templateLiteral.isUnterminated;
                }
            } else if (node.kind === 169 /* Decorator */ ) argCount = getDecoratorArgumentCount(node, signature);
            else if (isJsxOpeningLikeElement(node)) {
                callIsIncomplete = node.attributes.end === node.end;
                if (callIsIncomplete) return true;
                argCount = effectiveMinimumArguments === 0 ? args.length : 1;
                effectiveParameterCount = args.length === 0 ? effectiveParameterCount : 1;
                effectiveMinimumArguments = Math.min(effectiveMinimumArguments, 1);
            } else if (!node.arguments) {
                Debug.assert(node.kind === 213 /* NewExpression */ );
                return getMinArgumentCount(signature) === 0;
            } else {
                argCount = signatureHelpTrailingComma ? args.length + 1 : args.length;
                callIsIncomplete = node.arguments.end === node.end;
                const spreadArgIndex = getSpreadArgumentIndex(args);
                if (spreadArgIndex >= 0) return spreadArgIndex >= getMinArgumentCount(signature) && (hasEffectiveRestParameter(signature) || spreadArgIndex < getParameterCount(signature));
            }
            if (!hasEffectiveRestParameter(signature) && argCount > effectiveParameterCount) return false;
            if (callIsIncomplete || argCount >= effectiveMinimumArguments) return true;
            for(let i = argCount; i < effectiveMinimumArguments; i++){
                const type = getTypeAtPosition(signature, i);
                if (filterType(type, isInJSFile(node) && !strictNullChecks ? acceptsVoidUndefinedUnknownOrAny : acceptsVoid).flags & 131072 /* Never */ ) return false;
            }
            return true;
        }
        function hasCorrectTypeArgumentArity(signature, typeArguments) {
            const numTypeParameters = length(signature.typeParameters);
            const minTypeArgumentCount = getMinTypeArgumentCount(signature.typeParameters);
            return !some(typeArguments) || typeArguments.length >= minTypeArgumentCount && typeArguments.length <= numTypeParameters;
        }
        function getSingleCallSignature(type) {
            return getSingleSignature(type, 0 /* Call */ , /*allowMembers*/ false);
        }
        function getSingleCallOrConstructSignature(type) {
            return getSingleSignature(type, 0 /* Call */ , /*allowMembers*/ false) || getSingleSignature(type, 1 /* Construct */ , /*allowMembers*/ false);
        }
        function getSingleSignature(type, kind, allowMembers) {
            if (type.flags & 524288 /* Object */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                if (allowMembers || resolved.properties.length === 0 && resolved.indexInfos.length === 0) {
                    if (kind === 0 /* Call */  && resolved.callSignatures.length === 1 && resolved.constructSignatures.length === 0) return resolved.callSignatures[0];
                    if (kind === 1 /* Construct */  && resolved.constructSignatures.length === 1 && resolved.callSignatures.length === 0) return resolved.constructSignatures[0];
                }
            }
            return void 0;
        }
        function instantiateSignatureInContextOf(signature, contextualSignature, inferenceContext, compareTypes) {
            const context = createInferenceContext(signature.typeParameters, signature, 0 /* None */ , compareTypes);
            const restType = getEffectiveRestType(contextualSignature);
            const mapper = inferenceContext && (restType && restType.flags & 262144 /* TypeParameter */  ? inferenceContext.nonFixingMapper : inferenceContext.mapper);
            const sourceSignature = mapper ? instantiateSignature(contextualSignature, mapper) : contextualSignature;
            applyToParameterTypes(sourceSignature, signature, (source, target)=>{
                inferTypes(context.inferences, source, target);
            });
            if (!inferenceContext) applyToReturnTypes(contextualSignature, signature, (source, target)=>{
                inferTypes(context.inferences, source, target, 128 /* ReturnType */ );
            });
            return getSignatureInstantiation(signature, getInferredTypes(context), isInJSFile(contextualSignature.declaration));
        }
        function inferJsxTypeArguments(node, signature, checkMode, context) {
            const paramType = getEffectiveFirstArgumentForJsxSignature(signature, node);
            const checkAttrType = checkExpressionWithContextualType(node.attributes, paramType, context, checkMode);
            inferTypes(context.inferences, checkAttrType, paramType);
            return getInferredTypes(context);
        }
        function getThisArgumentType(thisArgumentNode) {
            if (!thisArgumentNode) return voidType;
            const thisArgumentType = checkExpression(thisArgumentNode);
            return isOptionalChainRoot(thisArgumentNode.parent) ? getNonNullableType(thisArgumentType) : isOptionalChain(thisArgumentNode.parent) ? removeOptionalTypeMarker(thisArgumentType) : thisArgumentType;
        }
        function inferTypeArguments(node, signature, args, checkMode, context) {
            if (isJsxOpeningLikeElement(node)) return inferJsxTypeArguments(node, signature, checkMode, context);
            if (node.kind !== 169 /* Decorator */ ) {
                const skipBindingPatterns = every(signature.typeParameters, (p)=>!!getDefaultFromTypeParameter(p));
                const contextualType = getContextualType2(node, skipBindingPatterns ? 8 /* SkipBindingPatterns */  : 0 /* None */ );
                if (contextualType) {
                    const inferenceTargetType = getReturnTypeOfSignature(signature);
                    if (couldContainTypeVariables(inferenceTargetType)) {
                        const outerContext = getInferenceContext(node);
                        const isFromBindingPattern = !skipBindingPatterns && getContextualType2(node, 8 /* SkipBindingPatterns */ ) !== contextualType;
                        if (!isFromBindingPattern) {
                            const outerMapper = getMapperFromContext(cloneInferenceContext(outerContext, 1 /* NoDefault */ ));
                            const instantiatedType = instantiateType(contextualType, outerMapper);
                            const contextualSignature = getSingleCallSignature(instantiatedType);
                            const inferenceSourceType = contextualSignature && contextualSignature.typeParameters ? getOrCreateTypeFromSignature(getSignatureInstantiationWithoutFillingInTypeArguments(contextualSignature, contextualSignature.typeParameters)) : instantiatedType;
                            inferTypes(context.inferences, inferenceSourceType, inferenceTargetType, 128 /* ReturnType */ );
                        }
                        const returnContext = createInferenceContext(signature.typeParameters, signature, context.flags);
                        const returnSourceType = instantiateType(contextualType, outerContext && outerContext.returnMapper);
                        inferTypes(returnContext.inferences, returnSourceType, inferenceTargetType);
                        context.returnMapper = some(returnContext.inferences, hasInferenceCandidates) ? getMapperFromContext(cloneInferredPartOfContext(returnContext)) : void 0;
                    }
                }
            }
            const restType = getNonArrayRestType(signature);
            const argCount = restType ? Math.min(getParameterCount(signature) - 1, args.length) : args.length;
            if (restType && restType.flags & 262144 /* TypeParameter */ ) {
                const info = find(context.inferences, (info2)=>info2.typeParameter === restType);
                if (info) info.impliedArity = findIndex(args, isSpreadArgument, argCount) < 0 ? args.length - argCount : void 0;
            }
            const thisType = getThisTypeOfSignature(signature);
            if (thisType && couldContainTypeVariables(thisType)) {
                const thisArgumentNode = getThisArgumentOfCall(node);
                inferTypes(context.inferences, getThisArgumentType(thisArgumentNode), thisType);
            }
            for(let i = 0; i < argCount; i++){
                const arg = args[i];
                if (arg.kind !== 231 /* OmittedExpression */  && !(checkMode & 32 /* IsForStringLiteralArgumentCompletions */  && hasSkipDirectInferenceFlag(arg))) {
                    const paramType = getTypeAtPosition(signature, i);
                    if (couldContainTypeVariables(paramType)) {
                        const argType = checkExpressionWithContextualType(arg, paramType, context, checkMode);
                        inferTypes(context.inferences, argType, paramType);
                    }
                }
            }
            if (restType && couldContainTypeVariables(restType)) {
                const spreadType = getSpreadArgumentType(args, argCount, args.length, restType, context, checkMode);
                inferTypes(context.inferences, spreadType, restType);
            }
            return getInferredTypes(context);
        }
        function getMutableArrayOrTupleType(type) {
            return type.flags & 1048576 /* Union */  ? mapType(type, getMutableArrayOrTupleType) : type.flags & 1 /* Any */  || isMutableArrayOrTuple(getBaseConstraintOfType(type) || type) ? type : isTupleType(type) ? createTupleType(getElementTypes(type), type.target.elementFlags, /*readonly*/ false, type.target.labeledElementDeclarations) : createTupleType([
                type
            ], [
                8 /* Variadic */ 
            ]);
        }
        function getSpreadArgumentType(args, index, argCount, restType, context, checkMode) {
            const inConstContext = isConstTypeVariable(restType);
            if (index >= argCount - 1) {
                const arg = args[argCount - 1];
                if (isSpreadArgument(arg)) {
                    const spreadType = arg.kind === 236 /* SyntheticExpression */  ? arg.type : checkExpressionWithContextualType(arg.expression, restType, context, checkMode);
                    if (isArrayLikeType(spreadType)) return getMutableArrayOrTupleType(spreadType);
                    return createArrayType(checkIteratedTypeOrElementType(33 /* Spread */ , spreadType, undefinedType, arg.kind === 229 /* SpreadElement */  ? arg.expression : arg), inConstContext);
                }
            }
            const types = [];
            const flags = [];
            const names = [];
            for(let i = index; i < argCount; i++){
                const arg = args[i];
                if (isSpreadArgument(arg)) {
                    const spreadType = arg.kind === 236 /* SyntheticExpression */  ? arg.type : checkExpression(arg.expression);
                    if (isArrayLikeType(spreadType)) {
                        types.push(spreadType);
                        flags.push(8 /* Variadic */ );
                    } else {
                        types.push(checkIteratedTypeOrElementType(33 /* Spread */ , spreadType, undefinedType, arg.kind === 229 /* SpreadElement */  ? arg.expression : arg));
                        flags.push(4 /* Rest */ );
                    }
                } else {
                    const contextualType = isTupleType(restType) ? getContextualTypeForElementExpression(restType, i - index, argCount - index) || unknownType : getIndexedAccessType(restType, getNumberLiteralType(i - index), 256 /* Contextual */ );
                    const argType = checkExpressionWithContextualType(arg, contextualType, context, checkMode);
                    const hasPrimitiveContextualType = inConstContext || maybeTypeOfKind(contextualType, 406978556 /* StringMapping */ );
                    types.push(hasPrimitiveContextualType ? getRegularTypeOfLiteralType(argType) : getWidenedLiteralType(argType));
                    flags.push(1 /* Required */ );
                }
                if (arg.kind === 236 /* SyntheticExpression */  && arg.tupleNameSource) names.push(arg.tupleNameSource);
            }
            return createTupleType(types, flags, inConstContext, length(names) === length(types) ? names : void 0);
        }
        function checkTypeArguments(signature, typeArgumentNodes, reportErrors2, headMessage) {
            const isJavascript = isInJSFile(signature.declaration);
            const typeParameters = signature.typeParameters;
            const typeArgumentTypes = fillMissingTypeArguments(map(typeArgumentNodes, getTypeFromTypeNode), typeParameters, getMinTypeArgumentCount(typeParameters), isJavascript);
            let mapper;
            for(let i = 0; i < typeArgumentNodes.length; i++){
                Debug.assert(typeParameters[i] !== void 0, "Should not call checkTypeArguments with too many type arguments");
                const constraint = getConstraintOfTypeParameter(typeParameters[i]);
                if (constraint) {
                    const errorInfo = reportErrors2 && headMessage ? ()=>chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Type_0_does_not_satisfy_the_constraint_1) : void 0;
                    const typeArgumentHeadMessage = headMessage || Diagnostics.Type_0_does_not_satisfy_the_constraint_1;
                    if (!mapper) mapper = createTypeMapper(typeParameters, typeArgumentTypes);
                    const typeArgument = typeArgumentTypes[i];
                    if (!checkTypeAssignableTo(typeArgument, getTypeWithThisArgument(instantiateType(constraint, mapper), typeArgument), reportErrors2 ? typeArgumentNodes[i] : void 0, typeArgumentHeadMessage, errorInfo)) return void 0;
                }
            }
            return typeArgumentTypes;
        }
        function getJsxReferenceKind(node) {
            if (isJsxIntrinsicTagName(node.tagName)) return 2 /* Mixed */ ;
            const tagType = getApparentType(checkExpression(node.tagName));
            if (length(getSignaturesOfType(tagType, 1 /* Construct */ ))) return 0 /* Component */ ;
            if (length(getSignaturesOfType(tagType, 0 /* Call */ ))) return 1 /* Function */ ;
            return 2 /* Mixed */ ;
        }
        function checkApplicableSignatureForJsxOpeningLikeElement(node, signature, relation, checkMode, reportErrors2, containingMessageChain, errorOutputContainer) {
            const paramType = getEffectiveFirstArgumentForJsxSignature(signature, node);
            const attributesType = checkExpressionWithContextualType(node.attributes, paramType, /*inferenceContext*/ void 0, checkMode);
            return checkTagNameDoesNotExpectTooManyArguments() && checkTypeRelatedToAndOptionallyElaborate(attributesType, paramType, relation, reportErrors2 ? node.tagName : void 0, node.attributes, /*headMessage*/ void 0, containingMessageChain, errorOutputContainer);
            function checkTagNameDoesNotExpectTooManyArguments() {
                var _a;
                if (getJsxNamespaceContainerForImplicitImport(node)) return true;
                const tagType = (isJsxOpeningElement(node) || isJsxSelfClosingElement(node)) && !(isJsxIntrinsicTagName(node.tagName) || isJsxNamespacedName(node.tagName)) ? checkExpression(node.tagName) : void 0;
                if (!tagType) return true;
                const tagCallSignatures = getSignaturesOfType(tagType, 0 /* Call */ );
                if (!length(tagCallSignatures)) return true;
                const factory2 = getJsxFactoryEntity(node);
                if (!factory2) return true;
                const factorySymbol = resolveEntityName(factory2, 111551 /* Value */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ false, node);
                if (!factorySymbol) return true;
                const factoryType = getTypeOfSymbol(factorySymbol);
                const callSignatures = getSignaturesOfType(factoryType, 0 /* Call */ );
                if (!length(callSignatures)) return true;
                let hasFirstParamSignatures = false;
                let maxParamCount = 0;
                for (const sig of callSignatures){
                    const firstparam = getTypeAtPosition(sig, 0);
                    const signaturesOfParam = getSignaturesOfType(firstparam, 0 /* Call */ );
                    if (!length(signaturesOfParam)) continue;
                    for (const paramSig of signaturesOfParam){
                        hasFirstParamSignatures = true;
                        if (hasEffectiveRestParameter(paramSig)) return true;
                        const paramCount = getParameterCount(paramSig);
                        if (paramCount > maxParamCount) maxParamCount = paramCount;
                    }
                }
                if (!hasFirstParamSignatures) return true;
                let absoluteMinArgCount = Infinity;
                for (const tagSig of tagCallSignatures){
                    const tagRequiredArgCount = getMinArgumentCount(tagSig);
                    if (tagRequiredArgCount < absoluteMinArgCount) absoluteMinArgCount = tagRequiredArgCount;
                }
                if (absoluteMinArgCount <= maxParamCount) return true;
                if (reportErrors2) {
                    const diag2 = createDiagnosticForNode(node.tagName, Diagnostics.Tag_0_expects_at_least_1_arguments_but_the_JSX_factory_2_provides_at_most_3, entityNameToString(node.tagName), absoluteMinArgCount, entityNameToString(factory2), maxParamCount);
                    const tagNameDeclaration = (_a = getSymbolAtLocation(node.tagName)) == null ? void 0 : _a.valueDeclaration;
                    if (tagNameDeclaration) addRelatedInfo(diag2, createDiagnosticForNode(tagNameDeclaration, Diagnostics._0_is_declared_here, entityNameToString(node.tagName)));
                    if (errorOutputContainer && errorOutputContainer.skipLogging) (errorOutputContainer.errors || (errorOutputContainer.errors = [])).push(diag2);
                    if (!errorOutputContainer.skipLogging) diagnostics.add(diag2);
                }
                return false;
            }
        }
        function getSignatureApplicabilityError(node, args, signature, relation, checkMode, reportErrors2, containingMessageChain) {
            const errorOutputContainer = {
                errors: void 0,
                skipLogging: true
            };
            if (isJsxOpeningLikeElement(node)) {
                if (!checkApplicableSignatureForJsxOpeningLikeElement(node, signature, relation, checkMode, reportErrors2, containingMessageChain, errorOutputContainer)) {
                    Debug.assert(!reportErrors2 || !!errorOutputContainer.errors, "jsx should have errors when reporting errors");
                    return errorOutputContainer.errors || emptyArray;
                }
                return void 0;
            }
            const thisType = getThisTypeOfSignature(signature);
            if (thisType && thisType !== voidType && !(isNewExpression(node) || isCallExpression(node) && isSuperProperty(node.expression))) {
                const thisArgumentNode = getThisArgumentOfCall(node);
                const thisArgumentType = getThisArgumentType(thisArgumentNode);
                const errorNode = reportErrors2 ? thisArgumentNode || node : void 0;
                const headMessage2 = Diagnostics.The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1;
                if (!checkTypeRelatedTo(thisArgumentType, thisType, relation, errorNode, headMessage2, containingMessageChain, errorOutputContainer)) {
                    Debug.assert(!reportErrors2 || !!errorOutputContainer.errors, "this parameter should have errors when reporting errors");
                    return errorOutputContainer.errors || emptyArray;
                }
            }
            const headMessage = Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1;
            const restType = getNonArrayRestType(signature);
            const argCount = restType ? Math.min(getParameterCount(signature) - 1, args.length) : args.length;
            for(let i = 0; i < argCount; i++){
                const arg = args[i];
                if (arg.kind !== 231 /* OmittedExpression */ ) {
                    const paramType = getTypeAtPosition(signature, i);
                    const argType = checkExpressionWithContextualType(arg, paramType, /*inferenceContext*/ void 0, checkMode);
                    const checkArgType = checkMode & 4 /* SkipContextSensitive */  ? getRegularTypeOfObjectLiteral(argType) : argType;
                    if (!checkTypeRelatedToAndOptionallyElaborate(checkArgType, paramType, relation, reportErrors2 ? arg : void 0, arg, headMessage, containingMessageChain, errorOutputContainer)) {
                        Debug.assert(!reportErrors2 || !!errorOutputContainer.errors, "parameter should have errors when reporting errors");
                        maybeAddMissingAwaitInfo(arg, checkArgType, paramType);
                        return errorOutputContainer.errors || emptyArray;
                    }
                }
            }
            if (restType) {
                const spreadType = getSpreadArgumentType(args, argCount, args.length, restType, /*context*/ void 0, checkMode);
                const restArgCount = args.length - argCount;
                const errorNode = !reportErrors2 ? void 0 : restArgCount === 0 ? node : restArgCount === 1 ? args[argCount] : setTextRangePosEnd(createSyntheticExpression(node, spreadType), args[argCount].pos, args[args.length - 1].end);
                if (!checkTypeRelatedTo(spreadType, restType, relation, errorNode, headMessage, /*containingMessageChain*/ void 0, errorOutputContainer)) {
                    Debug.assert(!reportErrors2 || !!errorOutputContainer.errors, "rest parameter should have errors when reporting errors");
                    maybeAddMissingAwaitInfo(errorNode, spreadType, restType);
                    return errorOutputContainer.errors || emptyArray;
                }
            }
            return void 0;
            function maybeAddMissingAwaitInfo(errorNode, source, target) {
                if (errorNode && reportErrors2 && errorOutputContainer.errors && errorOutputContainer.errors.length) {
                    if (getAwaitedTypeOfPromise(target)) return;
                    const awaitedTypeOfSource = getAwaitedTypeOfPromise(source);
                    if (awaitedTypeOfSource && isTypeRelatedTo(awaitedTypeOfSource, target, relation)) addRelatedInfo(errorOutputContainer.errors[0], createDiagnosticForNode(errorNode, Diagnostics.Did_you_forget_to_use_await));
                }
            }
        }
        function getThisArgumentOfCall(node) {
            const expression = node.kind === 212 /* CallExpression */  ? node.expression : node.kind === 214 /* TaggedTemplateExpression */  ? node.tag : void 0;
            if (expression) {
                const callee = skipOuterExpressions(expression);
                if (isAccessExpression(callee)) return callee.expression;
            }
        }
        function createSyntheticExpression(parent2, type, isSpread, tupleNameSource) {
            const result = parseNodeFactory.createSyntheticExpression(type, isSpread, tupleNameSource);
            setTextRange(result, parent2);
            setParent(result, parent2);
            return result;
        }
        function getEffectiveCallArguments(node) {
            if (node.kind === 214 /* TaggedTemplateExpression */ ) {
                const template = node.template;
                const args2 = [
                    createSyntheticExpression(template, getGlobalTemplateStringsArrayType())
                ];
                if (template.kind === 227 /* TemplateExpression */ ) forEach(template.templateSpans, (span)=>{
                    args2.push(span.expression);
                });
                return args2;
            }
            if (node.kind === 169 /* Decorator */ ) return getEffectiveDecoratorArguments(node);
            if (isJsxOpeningLikeElement(node)) return node.attributes.properties.length > 0 || isJsxOpeningElement(node) && node.parent.children.length > 0 ? [
                node.attributes
            ] : emptyArray;
            const args = node.arguments || emptyArray;
            const spreadIndex = getSpreadArgumentIndex(args);
            if (spreadIndex >= 0) {
                const effectiveArgs = args.slice(0, spreadIndex);
                for(let i = spreadIndex; i < args.length; i++){
                    const arg = args[i];
                    const spreadType = arg.kind === 229 /* SpreadElement */  && (flowLoopCount ? checkExpression(arg.expression) : checkExpressionCached(arg.expression));
                    if (spreadType && isTupleType(spreadType)) forEach(getElementTypes(spreadType), (t, i2)=>{
                        var _a;
                        const flags = spreadType.target.elementFlags[i2];
                        const syntheticArg = createSyntheticExpression(arg, flags & 4 /* Rest */  ? createArrayType(t) : t, !!(flags & 12 /* Variable */ ), (_a = spreadType.target.labeledElementDeclarations) == null ? void 0 : _a[i2]);
                        effectiveArgs.push(syntheticArg);
                    });
                    else effectiveArgs.push(arg);
                }
                return effectiveArgs;
            }
            return args;
        }
        function getEffectiveDecoratorArguments(node) {
            const expr = node.expression;
            const signature = getDecoratorCallSignature(node);
            if (signature) {
                const args = [];
                for (const param of signature.parameters){
                    const type = getTypeOfSymbol(param);
                    args.push(createSyntheticExpression(expr, type));
                }
                return args;
            }
            return Debug.fail();
        }
        function getDecoratorArgumentCount(node, signature) {
            return compilerOptions.experimentalDecorators ? getLegacyDecoratorArgumentCount(node, signature) : 2;
        }
        function getLegacyDecoratorArgumentCount(node, signature) {
            switch(node.parent.kind){
                case 262 /* ClassDeclaration */ :
                case 230 /* ClassExpression */ :
                    return 1;
                case 171 /* PropertyDeclaration */ :
                    return hasAccessorModifier(node.parent) ? 3 : 2;
                case 173 /* MethodDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    return languageVersion === 0 /* ES3 */  || signature.parameters.length <= 2 ? 2 : 3;
                case 168 /* Parameter */ :
                    return 3;
                default:
                    return Debug.fail();
            }
        }
        function getDiagnosticSpanForCallNode(node, doNotIncludeArguments) {
            let start;
            let length2;
            const sourceFile = getSourceFileOfNode(node);
            if (isPropertyAccessExpression(node.expression)) {
                const nameSpan = getErrorSpanForNode(sourceFile, node.expression.name);
                start = nameSpan.start;
                length2 = doNotIncludeArguments ? nameSpan.length : node.end - start;
            } else {
                const expressionSpan = getErrorSpanForNode(sourceFile, node.expression);
                start = expressionSpan.start;
                length2 = doNotIncludeArguments ? expressionSpan.length : node.end - start;
            }
            return {
                start: start,
                length: length2,
                sourceFile: sourceFile
            };
        }
        function getDiagnosticForCallNode(node, message, ...args) {
            if (isCallExpression(node)) {
                const { sourceFile: sourceFile , start: start , length: length2  } = getDiagnosticSpanForCallNode(node);
                if ("message" in message) return createFileDiagnostic(sourceFile, start, length2, message, ...args);
                return createDiagnosticForFileFromMessageChain(sourceFile, message);
            } else {
                if ("message" in message) return createDiagnosticForNode(node, message, ...args);
                return createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(node), node, message);
            }
        }
        function isPromiseResolveArityError(node) {
            if (!isCallExpression(node) || !isIdentifier(node.expression)) return false;
            const symbol = resolveName(node.expression, node.expression.escapedText, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false);
            const decl = symbol == null ? void 0 : symbol.valueDeclaration;
            if (!decl || !isParameter(decl) || !isFunctionExpressionOrArrowFunction(decl.parent) || !isNewExpression(decl.parent.parent) || !isIdentifier(decl.parent.parent.expression)) return false;
            const globalPromiseSymbol = getGlobalPromiseConstructorSymbol(/*reportErrors*/ false);
            if (!globalPromiseSymbol) return false;
            const constructorSymbol = getSymbolAtLocation(decl.parent.parent.expression, /*ignoreErrors*/ true);
            return constructorSymbol === globalPromiseSymbol;
        }
        function getArgumentArityError(node, signatures, args, headMessage) {
            var _a;
            const spreadIndex = getSpreadArgumentIndex(args);
            if (spreadIndex > -1) return createDiagnosticForNode(args[spreadIndex], Diagnostics.A_spread_argument_must_either_have_a_tuple_type_or_be_passed_to_a_rest_parameter);
            let min2 = Number.POSITIVE_INFINITY;
            let max = Number.NEGATIVE_INFINITY;
            let maxBelow = Number.NEGATIVE_INFINITY;
            let minAbove = Number.POSITIVE_INFINITY;
            let closestSignature;
            for (const sig of signatures){
                const minParameter = getMinArgumentCount(sig);
                const maxParameter = getParameterCount(sig);
                if (minParameter < min2) {
                    min2 = minParameter;
                    closestSignature = sig;
                }
                max = Math.max(max, maxParameter);
                if (minParameter < args.length && minParameter > maxBelow) maxBelow = minParameter;
                if (args.length < maxParameter && maxParameter < minAbove) minAbove = maxParameter;
            }
            const hasRestParameter2 = some(signatures, hasEffectiveRestParameter);
            const parameterRange = hasRestParameter2 ? min2 : min2 < max ? min2 + "-" + max : min2;
            const isVoidPromiseError = !hasRestParameter2 && parameterRange === 1 && args.length === 0 && isPromiseResolveArityError(node);
            if (isVoidPromiseError && isInJSFile(node)) return getDiagnosticForCallNode(node, Diagnostics.Expected_1_argument_but_got_0_new_Promise_needs_a_JSDoc_hint_to_produce_a_resolve_that_can_be_called_without_arguments);
            const error2 = isDecorator(node) ? hasRestParameter2 ? Diagnostics.The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_at_least_0 : Diagnostics.The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_0 : hasRestParameter2 ? Diagnostics.Expected_at_least_0_arguments_but_got_1 : isVoidPromiseError ? Diagnostics.Expected_0_arguments_but_got_1_Did_you_forget_to_include_void_in_your_type_argument_to_Promise : Diagnostics.Expected_0_arguments_but_got_1;
            if (min2 < args.length && args.length < max) {
                if (headMessage) {
                    let chain = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.No_overload_expects_0_arguments_but_overloads_do_exist_that_expect_either_1_or_2_arguments, args.length, maxBelow, minAbove);
                    chain = chainDiagnosticMessages(chain, headMessage);
                    return getDiagnosticForCallNode(node, chain);
                }
                return getDiagnosticForCallNode(node, Diagnostics.No_overload_expects_0_arguments_but_overloads_do_exist_that_expect_either_1_or_2_arguments, args.length, maxBelow, minAbove);
            } else if (args.length < min2) {
                let diagnostic;
                if (headMessage) {
                    let chain = chainDiagnosticMessages(/*details*/ void 0, error2, parameterRange, args.length);
                    chain = chainDiagnosticMessages(chain, headMessage);
                    diagnostic = getDiagnosticForCallNode(node, chain);
                } else diagnostic = getDiagnosticForCallNode(node, error2, parameterRange, args.length);
                const parameter = (_a = closestSignature == null ? void 0 : closestSignature.declaration) == null ? void 0 : _a.parameters[closestSignature.thisParameter ? args.length + 1 : args.length];
                if (parameter) {
                    const messageAndArgs = isBindingPattern(parameter.name) ? [
                        Diagnostics.An_argument_matching_this_binding_pattern_was_not_provided
                    ] : isRestParameter(parameter) ? [
                        Diagnostics.Arguments_for_the_rest_parameter_0_were_not_provided,
                        idText(getFirstIdentifier(parameter.name))
                    ] : [
                        Diagnostics.An_argument_for_0_was_not_provided,
                        !parameter.name ? args.length : idText(getFirstIdentifier(parameter.name))
                    ];
                    const parameterError = createDiagnosticForNode(parameter, ...messageAndArgs);
                    return addRelatedInfo(diagnostic, parameterError);
                }
                return diagnostic;
            } else {
                const errorSpan = factory.createNodeArray(args.slice(max));
                const pos = first(errorSpan).pos;
                let end = last(errorSpan).end;
                if (end === pos) end++;
                setTextRangePosEnd(errorSpan, pos, end);
                if (headMessage) {
                    let chain = chainDiagnosticMessages(/*details*/ void 0, error2, parameterRange, args.length);
                    chain = chainDiagnosticMessages(chain, headMessage);
                    return createDiagnosticForNodeArrayFromMessageChain(getSourceFileOfNode(node), errorSpan, chain);
                }
                return createDiagnosticForNodeArray(getSourceFileOfNode(node), errorSpan, error2, parameterRange, args.length);
            }
        }
        function getTypeArgumentArityError(node, signatures, typeArguments, headMessage) {
            const argCount = typeArguments.length;
            if (signatures.length === 1) {
                const sig = signatures[0];
                const min2 = getMinTypeArgumentCount(sig.typeParameters);
                const max = length(sig.typeParameters);
                if (headMessage) {
                    let chain = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Expected_0_type_arguments_but_got_1, min2 < max ? min2 + "-" + max : min2, argCount);
                    chain = chainDiagnosticMessages(chain, headMessage);
                    return createDiagnosticForNodeArrayFromMessageChain(getSourceFileOfNode(node), typeArguments, chain);
                }
                return createDiagnosticForNodeArray(getSourceFileOfNode(node), typeArguments, Diagnostics.Expected_0_type_arguments_but_got_1, min2 < max ? min2 + "-" + max : min2, argCount);
            }
            let belowArgCount = -Infinity;
            let aboveArgCount = Infinity;
            for (const sig of signatures){
                const min2 = getMinTypeArgumentCount(sig.typeParameters);
                const max = length(sig.typeParameters);
                if (min2 > argCount) aboveArgCount = Math.min(aboveArgCount, min2);
                else if (max < argCount) belowArgCount = Math.max(belowArgCount, max);
            }
            if (belowArgCount !== -Infinity && aboveArgCount !== Infinity) {
                if (headMessage) {
                    let chain = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.No_overload_expects_0_type_arguments_but_overloads_do_exist_that_expect_either_1_or_2_type_arguments, argCount, belowArgCount, aboveArgCount);
                    chain = chainDiagnosticMessages(chain, headMessage);
                    return createDiagnosticForNodeArrayFromMessageChain(getSourceFileOfNode(node), typeArguments, chain);
                }
                return createDiagnosticForNodeArray(getSourceFileOfNode(node), typeArguments, Diagnostics.No_overload_expects_0_type_arguments_but_overloads_do_exist_that_expect_either_1_or_2_type_arguments, argCount, belowArgCount, aboveArgCount);
            }
            if (headMessage) {
                let chain = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Expected_0_type_arguments_but_got_1, belowArgCount === -Infinity ? aboveArgCount : belowArgCount, argCount);
                chain = chainDiagnosticMessages(chain, headMessage);
                return createDiagnosticForNodeArrayFromMessageChain(getSourceFileOfNode(node), typeArguments, chain);
            }
            return createDiagnosticForNodeArray(getSourceFileOfNode(node), typeArguments, Diagnostics.Expected_0_type_arguments_but_got_1, belowArgCount === -Infinity ? aboveArgCount : belowArgCount, argCount);
        }
        function resolveCall(node, signatures, candidatesOutArray, checkMode, callChainFlags, headMessage) {
            const isTaggedTemplate = node.kind === 214 /* TaggedTemplateExpression */ ;
            const isDecorator2 = node.kind === 169 /* Decorator */ ;
            const isJsxOpeningOrSelfClosingElement = isJsxOpeningLikeElement(node);
            const reportErrors2 = !isInferencePartiallyBlocked && !candidatesOutArray;
            let typeArguments;
            if (!isDecorator2 && !isSuperCall(node)) {
                typeArguments = node.typeArguments;
                if (isTaggedTemplate || isJsxOpeningOrSelfClosingElement || node.expression.kind !== 108 /* SuperKeyword */ ) forEach(typeArguments, checkSourceElement);
            }
            const candidates = candidatesOutArray || [];
            reorderCandidates(signatures, candidates, callChainFlags);
            if (!candidates.length) {
                if (reportErrors2) diagnostics.add(getDiagnosticForCallNode(node, Diagnostics.Call_target_does_not_contain_any_signatures));
                return resolveErrorCall(node);
            }
            const args = getEffectiveCallArguments(node);
            const isSingleNonGenericCandidate = candidates.length === 1 && !candidates[0].typeParameters;
            let argCheckMode = !isDecorator2 && !isSingleNonGenericCandidate && some(args, isContextSensitive) ? 4 /* SkipContextSensitive */  : 0 /* Normal */ ;
            argCheckMode |= checkMode & 32 /* IsForStringLiteralArgumentCompletions */ ;
            let candidatesForArgumentError;
            let candidateForArgumentArityError;
            let candidateForTypeArgumentError;
            let result;
            const signatureHelpTrailingComma = !!(checkMode & 16 /* IsForSignatureHelp */ ) && node.kind === 212 /* CallExpression */  && node.arguments.hasTrailingComma;
            if (candidates.length > 1) result = chooseOverload(candidates, subtypeRelation, isSingleNonGenericCandidate, signatureHelpTrailingComma);
            if (!result) result = chooseOverload(candidates, assignableRelation, isSingleNonGenericCandidate, signatureHelpTrailingComma);
            if (result) return result;
            result = getCandidateForOverloadFailure(node, candidates, args, !!candidatesOutArray, checkMode);
            getNodeLinks(node).resolvedSignature = result;
            if (reportErrors2) {
                if (candidatesForArgumentError) {
                    if (candidatesForArgumentError.length === 1 || candidatesForArgumentError.length > 3) {
                        const last2 = candidatesForArgumentError[candidatesForArgumentError.length - 1];
                        let chain;
                        if (candidatesForArgumentError.length > 3) {
                            chain = chainDiagnosticMessages(chain, Diagnostics.The_last_overload_gave_the_following_error);
                            chain = chainDiagnosticMessages(chain, Diagnostics.No_overload_matches_this_call);
                        }
                        if (headMessage) chain = chainDiagnosticMessages(chain, headMessage);
                        const diags = getSignatureApplicabilityError(node, args, last2, assignableRelation, 0 /* Normal */ , /*reportErrors*/ true, ()=>chain);
                        if (diags) for (const d of diags){
                            if (last2.declaration && candidatesForArgumentError.length > 3) addRelatedInfo(d, createDiagnosticForNode(last2.declaration, Diagnostics.The_last_overload_is_declared_here));
                            addImplementationSuccessElaboration(last2, d);
                            diagnostics.add(d);
                        }
                        else Debug.fail("No error for last overload signature");
                    } else {
                        const allDiagnostics = [];
                        let max = 0;
                        let min2 = Number.MAX_VALUE;
                        let minIndex = 0;
                        let i = 0;
                        for (const c of candidatesForArgumentError){
                            const chain2 = ()=>chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Overload_0_of_1_2_gave_the_following_error, i + 1, candidates.length, signatureToString(c));
                            const diags2 = getSignatureApplicabilityError(node, args, c, assignableRelation, 0 /* Normal */ , /*reportErrors*/ true, chain2);
                            if (diags2) {
                                if (diags2.length <= min2) {
                                    min2 = diags2.length;
                                    minIndex = i;
                                }
                                max = Math.max(max, diags2.length);
                                allDiagnostics.push(diags2);
                            } else Debug.fail("No error for 3 or fewer overload signatures");
                            i++;
                        }
                        const diags = max > 1 ? allDiagnostics[minIndex] : flatten(allDiagnostics);
                        Debug.assert(diags.length > 0, "No errors reported for 3 or fewer overload signatures");
                        let chain = chainDiagnosticMessages(map(diags, createDiagnosticMessageChainFromDiagnostic), Diagnostics.No_overload_matches_this_call);
                        if (headMessage) chain = chainDiagnosticMessages(chain, headMessage);
                        const related = [
                            ...flatMap(diags, (d)=>d.relatedInformation)
                        ];
                        let diag2;
                        if (every(diags, (d)=>d.start === diags[0].start && d.length === diags[0].length && d.file === diags[0].file)) {
                            const { file: file , start: start , length: length2  } = diags[0];
                            diag2 = {
                                file: file,
                                start: start,
                                length: length2,
                                code: chain.code,
                                category: chain.category,
                                messageText: chain,
                                relatedInformation: related
                            };
                        } else diag2 = createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(node), node, chain, related);
                        addImplementationSuccessElaboration(candidatesForArgumentError[0], diag2);
                        diagnostics.add(diag2);
                    }
                } else if (candidateForArgumentArityError) diagnostics.add(getArgumentArityError(node, [
                    candidateForArgumentArityError
                ], args, headMessage));
                else if (candidateForTypeArgumentError) checkTypeArguments(candidateForTypeArgumentError, node.typeArguments, /*reportErrors*/ true, headMessage);
                else {
                    const signaturesWithCorrectTypeArgumentArity = filter(signatures, (s)=>hasCorrectTypeArgumentArity(s, typeArguments));
                    if (signaturesWithCorrectTypeArgumentArity.length === 0) diagnostics.add(getTypeArgumentArityError(node, signatures, typeArguments, headMessage));
                    else diagnostics.add(getArgumentArityError(node, signaturesWithCorrectTypeArgumentArity, args, headMessage));
                }
            }
            return result;
            function addImplementationSuccessElaboration(failed, diagnostic) {
                var _a, _b;
                const oldCandidatesForArgumentError = candidatesForArgumentError;
                const oldCandidateForArgumentArityError = candidateForArgumentArityError;
                const oldCandidateForTypeArgumentError = candidateForTypeArgumentError;
                const failedSignatureDeclarations = ((_b = (_a = failed.declaration) == null ? void 0 : _a.symbol) == null ? void 0 : _b.declarations) || emptyArray;
                const isOverload = failedSignatureDeclarations.length > 1;
                const implDecl = isOverload ? find(failedSignatureDeclarations, (d)=>isFunctionLikeDeclaration(d) && nodeIsPresent(d.body)) : void 0;
                if (implDecl) {
                    const candidate = getSignatureFromDeclaration(implDecl);
                    const isSingleNonGenericCandidate2 = !candidate.typeParameters;
                    if (chooseOverload([
                        candidate
                    ], assignableRelation, isSingleNonGenericCandidate2)) addRelatedInfo(diagnostic, createDiagnosticForNode(implDecl, Diagnostics.The_call_would_have_succeeded_against_this_implementation_but_implementation_signatures_of_overloads_are_not_externally_visible));
                }
                candidatesForArgumentError = oldCandidatesForArgumentError;
                candidateForArgumentArityError = oldCandidateForArgumentArityError;
                candidateForTypeArgumentError = oldCandidateForTypeArgumentError;
            }
            function chooseOverload(candidates2, relation, isSingleNonGenericCandidate2, signatureHelpTrailingComma2 = false) {
                candidatesForArgumentError = void 0;
                candidateForArgumentArityError = void 0;
                candidateForTypeArgumentError = void 0;
                if (isSingleNonGenericCandidate2) {
                    const candidate = candidates2[0];
                    if (some(typeArguments) || !hasCorrectArity(node, args, candidate, signatureHelpTrailingComma2)) return void 0;
                    if (getSignatureApplicabilityError(node, args, candidate, relation, 0 /* Normal */ , /*reportErrors*/ false, /*containingMessageChain*/ void 0)) {
                        candidatesForArgumentError = [
                            candidate
                        ];
                        return void 0;
                    }
                    return candidate;
                }
                for(let candidateIndex = 0; candidateIndex < candidates2.length; candidateIndex++){
                    const candidate = candidates2[candidateIndex];
                    if (!hasCorrectTypeArgumentArity(candidate, typeArguments) || !hasCorrectArity(node, args, candidate, signatureHelpTrailingComma2)) continue;
                    let checkCandidate;
                    let inferenceContext;
                    if (candidate.typeParameters) {
                        let typeArgumentTypes;
                        if (some(typeArguments)) {
                            typeArgumentTypes = checkTypeArguments(candidate, typeArguments, /*reportErrors*/ false);
                            if (!typeArgumentTypes) {
                                candidateForTypeArgumentError = candidate;
                                continue;
                            }
                        } else {
                            inferenceContext = createInferenceContext(candidate.typeParameters, candidate, /*flags*/ isInJSFile(node) ? 2 /* AnyDefault */  : 0 /* None */ );
                            typeArgumentTypes = inferTypeArguments(node, candidate, args, argCheckMode | 8 /* SkipGenericFunctions */ , inferenceContext);
                            argCheckMode |= inferenceContext.flags & 4 /* SkippedGenericFunction */  ? 8 /* SkipGenericFunctions */  : 0 /* Normal */ ;
                        }
                        checkCandidate = getSignatureInstantiation(candidate, typeArgumentTypes, isInJSFile(candidate.declaration), inferenceContext && inferenceContext.inferredTypeParameters);
                        if (getNonArrayRestType(candidate) && !hasCorrectArity(node, args, checkCandidate, signatureHelpTrailingComma2)) {
                            candidateForArgumentArityError = checkCandidate;
                            continue;
                        }
                    } else checkCandidate = candidate;
                    if (getSignatureApplicabilityError(node, args, checkCandidate, relation, argCheckMode, /*reportErrors*/ false, /*containingMessageChain*/ void 0)) {
                        (candidatesForArgumentError || (candidatesForArgumentError = [])).push(checkCandidate);
                        continue;
                    }
                    if (argCheckMode) {
                        argCheckMode = checkMode & 32 /* IsForStringLiteralArgumentCompletions */ ;
                        if (inferenceContext) {
                            const typeArgumentTypes = inferTypeArguments(node, candidate, args, argCheckMode, inferenceContext);
                            checkCandidate = getSignatureInstantiation(candidate, typeArgumentTypes, isInJSFile(candidate.declaration), inferenceContext.inferredTypeParameters);
                            if (getNonArrayRestType(candidate) && !hasCorrectArity(node, args, checkCandidate, signatureHelpTrailingComma2)) {
                                candidateForArgumentArityError = checkCandidate;
                                continue;
                            }
                        }
                        if (getSignatureApplicabilityError(node, args, checkCandidate, relation, argCheckMode, /*reportErrors*/ false, /*containingMessageChain*/ void 0)) {
                            (candidatesForArgumentError || (candidatesForArgumentError = [])).push(checkCandidate);
                            continue;
                        }
                    }
                    candidates2[candidateIndex] = checkCandidate;
                    return checkCandidate;
                }
                return void 0;
            }
        }
        function getCandidateForOverloadFailure(node, candidates, args, hasCandidatesOutArray, checkMode) {
            Debug.assert(candidates.length > 0);
            checkNodeDeferred(node);
            return hasCandidatesOutArray || candidates.length === 1 || candidates.some((c)=>!!c.typeParameters) ? pickLongestCandidateSignature(node, candidates, args, checkMode) : createUnionOfSignaturesForOverloadFailure(candidates);
        }
        function createUnionOfSignaturesForOverloadFailure(candidates) {
            const thisParameters = mapDefined(candidates, (c)=>c.thisParameter);
            let thisParameter;
            if (thisParameters.length) thisParameter = createCombinedSymbolFromTypes(thisParameters, thisParameters.map(getTypeOfParameter));
            const { min: minArgumentCount , max: maxNonRestParam  } = minAndMax(candidates, getNumNonRestParameters);
            const parameters = [];
            for(let i = 0; i < maxNonRestParam; i++){
                const symbols = mapDefined(candidates, (s)=>signatureHasRestParameter(s) ? i < s.parameters.length - 1 ? s.parameters[i] : last(s.parameters) : i < s.parameters.length ? s.parameters[i] : void 0);
                Debug.assert(symbols.length !== 0);
                parameters.push(createCombinedSymbolFromTypes(symbols, mapDefined(candidates, (candidate)=>tryGetTypeAtPosition(candidate, i))));
            }
            const restParameterSymbols = mapDefined(candidates, (c)=>signatureHasRestParameter(c) ? last(c.parameters) : void 0);
            let flags = 0 /* None */ ;
            if (restParameterSymbols.length !== 0) {
                const type = createArrayType(getUnionType(mapDefined(candidates, tryGetRestTypeOfSignature), 2 /* Subtype */ ));
                parameters.push(createCombinedSymbolForOverloadFailure(restParameterSymbols, type));
                flags |= 1 /* HasRestParameter */ ;
            }
            if (candidates.some(signatureHasLiteralTypes)) flags |= 2 /* HasLiteralTypes */ ;
            return createSignature(candidates[0].declaration, /*typeParameters*/ void 0, // Before calling this we tested for `!candidates.some(c => !!c.typeParameters)`.
            thisParameter, parameters, /*resolvedReturnType*/ getIntersectionType(candidates.map(getReturnTypeOfSignature)), /*resolvedTypePredicate*/ void 0, minArgumentCount, flags);
        }
        function getNumNonRestParameters(signature) {
            const numParams = signature.parameters.length;
            return signatureHasRestParameter(signature) ? numParams - 1 : numParams;
        }
        function createCombinedSymbolFromTypes(sources, types) {
            return createCombinedSymbolForOverloadFailure(sources, getUnionType(types, 2 /* Subtype */ ));
        }
        function createCombinedSymbolForOverloadFailure(sources, type) {
            return createSymbolWithType(first(sources), type);
        }
        function pickLongestCandidateSignature(node, candidates, args, checkMode) {
            const bestIndex = getLongestCandidateIndex(candidates, apparentArgumentCount === void 0 ? args.length : apparentArgumentCount);
            const candidate = candidates[bestIndex];
            const { typeParameters: typeParameters  } = candidate;
            if (!typeParameters) return candidate;
            const typeArgumentNodes = callLikeExpressionMayHaveTypeArguments(node) ? node.typeArguments : void 0;
            const instantiated = typeArgumentNodes ? createSignatureInstantiation(candidate, getTypeArgumentsFromNodes(typeArgumentNodes, typeParameters, isInJSFile(node))) : inferSignatureInstantiationForOverloadFailure(node, typeParameters, candidate, args, checkMode);
            candidates[bestIndex] = instantiated;
            return instantiated;
        }
        function getTypeArgumentsFromNodes(typeArgumentNodes, typeParameters, isJs) {
            const typeArguments = typeArgumentNodes.map(getTypeOfNode);
            while(typeArguments.length > typeParameters.length)typeArguments.pop();
            while(typeArguments.length < typeParameters.length)typeArguments.push(getDefaultFromTypeParameter(typeParameters[typeArguments.length]) || getConstraintOfTypeParameter(typeParameters[typeArguments.length]) || getDefaultTypeArgumentType(isJs));
            return typeArguments;
        }
        function inferSignatureInstantiationForOverloadFailure(node, typeParameters, candidate, args, checkMode) {
            const inferenceContext = createInferenceContext(typeParameters, candidate, /*flags*/ isInJSFile(node) ? 2 /* AnyDefault */  : 0 /* None */ );
            const typeArgumentTypes = inferTypeArguments(node, candidate, args, checkMode | 12 /* SkipGenericFunctions */ , inferenceContext);
            return createSignatureInstantiation(candidate, typeArgumentTypes);
        }
        function getLongestCandidateIndex(candidates, argsCount) {
            let maxParamsIndex = -1;
            let maxParams = -1;
            for(let i = 0; i < candidates.length; i++){
                const candidate = candidates[i];
                const paramCount = getParameterCount(candidate);
                if (hasEffectiveRestParameter(candidate) || paramCount >= argsCount) return i;
                if (paramCount > maxParams) {
                    maxParams = paramCount;
                    maxParamsIndex = i;
                }
            }
            return maxParamsIndex;
        }
        function resolveCallExpression(node, candidatesOutArray, checkMode) {
            if (node.expression.kind === 108 /* SuperKeyword */ ) {
                const superType = checkSuperExpression(node.expression);
                if (isTypeAny(superType)) {
                    for (const arg of node.arguments)checkExpression(arg);
                    return anySignature;
                }
                if (!isErrorType(superType)) {
                    const baseTypeNode = getEffectiveBaseTypeNode(getContainingClass(node));
                    if (baseTypeNode) {
                        const baseConstructors = getInstantiatedConstructorsForTypeArguments(superType, baseTypeNode.typeArguments, baseTypeNode);
                        return resolveCall(node, baseConstructors, candidatesOutArray, checkMode, 0 /* None */ );
                    }
                }
                return resolveUntypedCall(node);
            }
            let callChainFlags;
            let funcType = checkExpression(node.expression);
            if (isCallChain(node)) {
                const nonOptionalType = getOptionalExpressionType(funcType, node.expression);
                callChainFlags = nonOptionalType === funcType ? 0 /* None */  : isOutermostOptionalChain(node) ? 16 /* IsOuterCallChain */  : 8 /* IsInnerCallChain */ ;
                funcType = nonOptionalType;
            } else callChainFlags = 0 /* None */ ;
            funcType = checkNonNullTypeWithReporter(funcType, node.expression, reportCannotInvokePossiblyNullOrUndefinedError);
            if (funcType === silentNeverType) return silentNeverSignature;
            const apparentType = getApparentType(funcType);
            if (isErrorType(apparentType)) return resolveErrorCall(node);
            const callSignatures = getSignaturesOfType(apparentType, 0 /* Call */ );
            const numConstructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */ ).length;
            if (isUntypedFunctionCall(funcType, apparentType, callSignatures.length, numConstructSignatures)) {
                if (!isErrorType(funcType) && node.typeArguments) error(node, Diagnostics.Untyped_function_calls_may_not_accept_type_arguments);
                return resolveUntypedCall(node);
            }
            if (!callSignatures.length) {
                if (numConstructSignatures) error(node, Diagnostics.Value_of_type_0_is_not_callable_Did_you_mean_to_include_new, typeToString(funcType));
                else {
                    let relatedInformation;
                    if (node.arguments.length === 1) {
                        const text = getSourceFileOfNode(node).text;
                        if (isLineBreak(text.charCodeAt(skipTrivia(text, node.expression.end, /*stopAfterLineBreak*/ true) - 1))) relatedInformation = createDiagnosticForNode(node.expression, Diagnostics.Are_you_missing_a_semicolon);
                    }
                    invocationError(node.expression, apparentType, 0 /* Call */ , relatedInformation);
                }
                return resolveErrorCall(node);
            }
            if (checkMode & 8 /* SkipGenericFunctions */  && !node.typeArguments && callSignatures.some(isGenericFunctionReturningFunction)) {
                skippedGenericFunction(node, checkMode);
                return resolvingSignature;
            }
            if (callSignatures.some((sig)=>isInJSFile(sig.declaration) && !!getJSDocClassTag(sig.declaration))) {
                error(node, Diagnostics.Value_of_type_0_is_not_callable_Did_you_mean_to_include_new, typeToString(funcType));
                return resolveErrorCall(node);
            }
            return resolveCall(node, callSignatures, candidatesOutArray, checkMode, callChainFlags);
        }
        function isGenericFunctionReturningFunction(signature) {
            return !!(signature.typeParameters && isFunctionType(getReturnTypeOfSignature(signature)));
        }
        function isUntypedFunctionCall(funcType, apparentFuncType, numCallSignatures, numConstructSignatures) {
            return isTypeAny(funcType) || isTypeAny(apparentFuncType) && !!(funcType.flags & 262144 /* TypeParameter */ ) || !numCallSignatures && !numConstructSignatures && !(apparentFuncType.flags & 1048576 /* Union */ ) && !(getReducedType(apparentFuncType).flags & 131072 /* Never */ ) && isTypeAssignableTo(funcType, globalFunctionType);
        }
        function resolveNewExpression(node, candidatesOutArray, checkMode) {
            if (node.arguments && languageVersion < 1 /* ES5 */ ) {
                const spreadIndex = getSpreadArgumentIndex(node.arguments);
                if (spreadIndex >= 0) error(node.arguments[spreadIndex], Diagnostics.Spread_operator_in_new_expressions_is_only_available_when_targeting_ECMAScript_5_and_higher);
            }
            let expressionType = checkNonNullExpression(node.expression);
            if (expressionType === silentNeverType) return silentNeverSignature;
            expressionType = getApparentType(expressionType);
            if (isErrorType(expressionType)) return resolveErrorCall(node);
            if (isTypeAny(expressionType)) {
                if (node.typeArguments) error(node, Diagnostics.Untyped_function_calls_may_not_accept_type_arguments);
                return resolveUntypedCall(node);
            }
            const constructSignatures = getSignaturesOfType(expressionType, 1 /* Construct */ );
            if (constructSignatures.length) {
                if (!isConstructorAccessible(node, constructSignatures[0])) return resolveErrorCall(node);
                if (someSignature(constructSignatures, (signature)=>!!(signature.flags & 4 /* Abstract */ ))) {
                    error(node, Diagnostics.Cannot_create_an_instance_of_an_abstract_class);
                    return resolveErrorCall(node);
                }
                const valueDecl = expressionType.symbol && getClassLikeDeclarationOfSymbol(expressionType.symbol);
                if (valueDecl && hasSyntacticModifier(valueDecl, 256 /* Abstract */ )) {
                    error(node, Diagnostics.Cannot_create_an_instance_of_an_abstract_class);
                    return resolveErrorCall(node);
                }
                return resolveCall(node, constructSignatures, candidatesOutArray, checkMode, 0 /* None */ );
            }
            const callSignatures = getSignaturesOfType(expressionType, 0 /* Call */ );
            if (callSignatures.length) {
                const signature = resolveCall(node, callSignatures, candidatesOutArray, checkMode, 0 /* None */ );
                if (!noImplicitAny) {
                    if (signature.declaration && !isJSConstructor(signature.declaration) && getReturnTypeOfSignature(signature) !== voidType) error(node, Diagnostics.Only_a_void_function_can_be_called_with_the_new_keyword);
                    if (getThisTypeOfSignature(signature) === voidType) error(node, Diagnostics.A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void);
                }
                return signature;
            }
            invocationError(node.expression, expressionType, 1 /* Construct */ );
            return resolveErrorCall(node);
        }
        function someSignature(signatures, f) {
            if (isArray(signatures)) return some(signatures, (signature)=>someSignature(signature, f));
            return signatures.compositeKind === 1048576 /* Union */  ? some(signatures.compositeSignatures, f) : f(signatures);
        }
        function typeHasProtectedAccessibleBase(target, type) {
            const baseTypes = getBaseTypes(type);
            if (!length(baseTypes)) return false;
            const firstBase = baseTypes[0];
            if (firstBase.flags & 2097152 /* Intersection */ ) {
                const types = firstBase.types;
                const mixinFlags = findMixins(types);
                let i = 0;
                for (const intersectionMember of firstBase.types){
                    if (!mixinFlags[i]) {
                        if (getObjectFlags(intersectionMember) & 3 /* Interface */ ) {
                            if (intersectionMember.symbol === target) return true;
                            if (typeHasProtectedAccessibleBase(target, intersectionMember)) return true;
                        }
                    }
                    i++;
                }
                return false;
            }
            if (firstBase.symbol === target) return true;
            return typeHasProtectedAccessibleBase(target, firstBase);
        }
        function isConstructorAccessible(node, signature) {
            if (!signature || !signature.declaration) return true;
            const declaration = signature.declaration;
            const modifiers = getSelectedEffectiveModifierFlags(declaration, 24 /* NonPublicAccessibilityModifier */ );
            if (!modifiers || declaration.kind !== 175 /* Constructor */ ) return true;
            const declaringClassDeclaration = getClassLikeDeclarationOfSymbol(declaration.parent.symbol);
            const declaringClass = getDeclaredTypeOfSymbol(declaration.parent.symbol);
            if (!isNodeWithinClass(node, declaringClassDeclaration)) {
                const containingClass = getContainingClass(node);
                if (containingClass && modifiers & 16 /* Protected */ ) {
                    const containingType = getTypeOfNode(containingClass);
                    if (typeHasProtectedAccessibleBase(declaration.parent.symbol, containingType)) return true;
                }
                if (modifiers & 8 /* Private */ ) error(node, Diagnostics.Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration, typeToString(declaringClass));
                if (modifiers & 16 /* Protected */ ) error(node, Diagnostics.Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration, typeToString(declaringClass));
                return false;
            }
            return true;
        }
        function invocationErrorDetails(errorTarget, apparentType, kind) {
            let errorInfo;
            const isCall = kind === 0 /* Call */ ;
            const awaitedType = getAwaitedType(apparentType);
            const maybeMissingAwait = awaitedType && getSignaturesOfType(awaitedType, kind).length > 0;
            if (apparentType.flags & 1048576 /* Union */ ) {
                const types = apparentType.types;
                let hasSignatures = false;
                for (const constituent of types){
                    const signatures = getSignaturesOfType(constituent, kind);
                    if (signatures.length !== 0) {
                        hasSignatures = true;
                        if (errorInfo) break;
                    } else {
                        if (!errorInfo) {
                            errorInfo = chainDiagnosticMessages(errorInfo, isCall ? Diagnostics.Type_0_has_no_call_signatures : Diagnostics.Type_0_has_no_construct_signatures, typeToString(constituent));
                            errorInfo = chainDiagnosticMessages(errorInfo, isCall ? Diagnostics.Not_all_constituents_of_type_0_are_callable : Diagnostics.Not_all_constituents_of_type_0_are_constructable, typeToString(apparentType));
                        }
                        if (hasSignatures) break;
                    }
                }
                if (!hasSignatures) errorInfo = chainDiagnosticMessages(/*details*/ void 0, isCall ? Diagnostics.No_constituent_of_type_0_is_callable : Diagnostics.No_constituent_of_type_0_is_constructable, typeToString(apparentType));
                if (!errorInfo) errorInfo = chainDiagnosticMessages(errorInfo, isCall ? Diagnostics.Each_member_of_the_union_type_0_has_signatures_but_none_of_those_signatures_are_compatible_with_each_other : Diagnostics.Each_member_of_the_union_type_0_has_construct_signatures_but_none_of_those_signatures_are_compatible_with_each_other, typeToString(apparentType));
            } else errorInfo = chainDiagnosticMessages(errorInfo, isCall ? Diagnostics.Type_0_has_no_call_signatures : Diagnostics.Type_0_has_no_construct_signatures, typeToString(apparentType));
            let headMessage = isCall ? Diagnostics.This_expression_is_not_callable : Diagnostics.This_expression_is_not_constructable;
            if (isCallExpression(errorTarget.parent) && errorTarget.parent.arguments.length === 0) {
                const { resolvedSymbol: resolvedSymbol  } = getNodeLinks(errorTarget);
                if (resolvedSymbol && resolvedSymbol.flags & 32768 /* GetAccessor */ ) headMessage = Diagnostics.This_expression_is_not_callable_because_it_is_a_get_accessor_Did_you_mean_to_use_it_without;
            }
            return {
                messageChain: chainDiagnosticMessages(errorInfo, headMessage),
                relatedMessage: maybeMissingAwait ? Diagnostics.Did_you_forget_to_use_await : void 0
            };
        }
        function invocationError(errorTarget, apparentType, kind, relatedInformation) {
            const { messageChain: messageChain , relatedMessage: relatedInfo  } = invocationErrorDetails(errorTarget, apparentType, kind);
            const diagnostic = createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(errorTarget), errorTarget, messageChain);
            if (relatedInfo) addRelatedInfo(diagnostic, createDiagnosticForNode(errorTarget, relatedInfo));
            if (isCallExpression(errorTarget.parent)) {
                const { start: start , length: length2  } = getDiagnosticSpanForCallNode(errorTarget.parent, /*doNotIncludeArguments*/ true);
                diagnostic.start = start;
                diagnostic.length = length2;
            }
            diagnostics.add(diagnostic);
            invocationErrorRecovery(apparentType, kind, relatedInformation ? addRelatedInfo(diagnostic, relatedInformation) : diagnostic);
        }
        function invocationErrorRecovery(apparentType, kind, diagnostic) {
            if (!apparentType.symbol) return;
            const importNode = getSymbolLinks(apparentType.symbol).originatingImport;
            if (importNode && !isImportCall(importNode)) {
                const sigs = getSignaturesOfType(getTypeOfSymbol(getSymbolLinks(apparentType.symbol).target), kind);
                if (!sigs || !sigs.length) return;
                addRelatedInfo(diagnostic, createDiagnosticForNode(importNode, Diagnostics.Type_originates_at_this_import_A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime_Consider_using_a_default_import_or_import_require_here_instead));
            }
        }
        function resolveTaggedTemplateExpression(node, candidatesOutArray, checkMode) {
            const tagType = checkExpression(node.tag);
            const apparentType = getApparentType(tagType);
            if (isErrorType(apparentType)) return resolveErrorCall(node);
            const callSignatures = getSignaturesOfType(apparentType, 0 /* Call */ );
            const numConstructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */ ).length;
            if (isUntypedFunctionCall(tagType, apparentType, callSignatures.length, numConstructSignatures)) return resolveUntypedCall(node);
            if (!callSignatures.length) {
                if (isArrayLiteralExpression(node.parent)) {
                    const diagnostic = createDiagnosticForNode(node.tag, Diagnostics.It_is_likely_that_you_are_missing_a_comma_to_separate_these_two_template_expressions_They_form_a_tagged_template_expression_which_cannot_be_invoked);
                    diagnostics.add(diagnostic);
                    return resolveErrorCall(node);
                }
                invocationError(node.tag, apparentType, 0 /* Call */ );
                return resolveErrorCall(node);
            }
            return resolveCall(node, callSignatures, candidatesOutArray, checkMode, 0 /* None */ );
        }
        function getDiagnosticHeadMessageForDecoratorResolution(node) {
            switch(node.parent.kind){
                case 262 /* ClassDeclaration */ :
                case 230 /* ClassExpression */ :
                    return Diagnostics.Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression;
                case 168 /* Parameter */ :
                    return Diagnostics.Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression;
                case 171 /* PropertyDeclaration */ :
                    return Diagnostics.Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression;
                case 173 /* MethodDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    return Diagnostics.Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression;
                default:
                    return Debug.fail();
            }
        }
        function resolveDecorator(node, candidatesOutArray, checkMode) {
            const funcType = checkExpression(node.expression);
            const apparentType = getApparentType(funcType);
            if (isErrorType(apparentType)) return resolveErrorCall(node);
            const callSignatures = getSignaturesOfType(apparentType, 0 /* Call */ );
            const numConstructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */ ).length;
            if (isUntypedFunctionCall(funcType, apparentType, callSignatures.length, numConstructSignatures)) return resolveUntypedCall(node);
            if (isPotentiallyUncalledDecorator(node, callSignatures) && !isParenthesizedExpression(node.expression)) {
                const nodeStr = getTextOfNode(node.expression, /*includeTrivia*/ false);
                error(node, Diagnostics._0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0, nodeStr);
                return resolveErrorCall(node);
            }
            const headMessage = getDiagnosticHeadMessageForDecoratorResolution(node);
            if (!callSignatures.length) {
                const errorDetails = invocationErrorDetails(node.expression, apparentType, 0 /* Call */ );
                const messageChain = chainDiagnosticMessages(errorDetails.messageChain, headMessage);
                const diag2 = createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(node.expression), node.expression, messageChain);
                if (errorDetails.relatedMessage) addRelatedInfo(diag2, createDiagnosticForNode(node.expression, errorDetails.relatedMessage));
                diagnostics.add(diag2);
                invocationErrorRecovery(apparentType, 0 /* Call */ , diag2);
                return resolveErrorCall(node);
            }
            return resolveCall(node, callSignatures, candidatesOutArray, checkMode, 0 /* None */ , headMessage);
        }
        function createSignatureForJSXIntrinsic(node, result) {
            const namespace = getJsxNamespaceAt(node);
            const exports = namespace && getExportsOfSymbol(namespace);
            const typeSymbol = exports && getSymbol2(exports, JsxNames.Element, 788968 /* Type */ );
            const returnNode = typeSymbol && nodeBuilder.symbolToEntityName(typeSymbol, 788968 /* Type */ , node);
            const declaration = factory.createFunctionTypeNode(/*typeParameters*/ void 0, [
                factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "props", /*questionToken*/ void 0, nodeBuilder.typeToTypeNode(result, node))
            ], returnNode ? factory.createTypeReferenceNode(returnNode, /*typeArguments*/ void 0) : factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
            const parameterSymbol = createSymbol(1 /* FunctionScopedVariable */ , "props");
            parameterSymbol.links.type = result;
            return createSignature(declaration, /*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                parameterSymbol
            ], typeSymbol ? getDeclaredTypeOfSymbol(typeSymbol) : errorType, /*resolvedTypePredicate*/ void 0, 1, 0 /* None */ );
        }
        function resolveJsxOpeningLikeElement(node, candidatesOutArray, checkMode) {
            if (isJsxIntrinsicTagName(node.tagName)) {
                const result = getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node);
                const fakeSignature = createSignatureForJSXIntrinsic(node, result);
                checkTypeAssignableToAndOptionallyElaborate(checkExpressionWithContextualType(node.attributes, getEffectiveFirstArgumentForJsxSignature(fakeSignature, node), /*inferenceContext*/ void 0, 0 /* Normal */ ), result, node.tagName, node.attributes);
                if (length(node.typeArguments)) {
                    forEach(node.typeArguments, checkSourceElement);
                    diagnostics.add(createDiagnosticForNodeArray(getSourceFileOfNode(node), node.typeArguments, Diagnostics.Expected_0_type_arguments_but_got_1, 0, length(node.typeArguments)));
                }
                return fakeSignature;
            }
            const exprTypes = checkExpression(node.tagName);
            const apparentType = getApparentType(exprTypes);
            if (isErrorType(apparentType)) return resolveErrorCall(node);
            const signatures = getUninstantiatedJsxSignaturesOfType(exprTypes, node);
            if (isUntypedFunctionCall(exprTypes, apparentType, signatures.length, /*constructSignatures*/ 0)) return resolveUntypedCall(node);
            if (signatures.length === 0) {
                error(node.tagName, Diagnostics.JSX_element_type_0_does_not_have_any_construct_or_call_signatures, getTextOfNode(node.tagName));
                return resolveErrorCall(node);
            }
            return resolveCall(node, signatures, candidatesOutArray, checkMode, 0 /* None */ );
        }
        function isPotentiallyUncalledDecorator(decorator, signatures) {
            return signatures.length && every(signatures, (signature)=>signature.minArgumentCount === 0 && !signatureHasRestParameter(signature) && signature.parameters.length < getDecoratorArgumentCount(decorator, signature));
        }
        function resolveSignature(node, candidatesOutArray, checkMode) {
            switch(node.kind){
                case 212 /* CallExpression */ :
                    return resolveCallExpression(node, candidatesOutArray, checkMode);
                case 213 /* NewExpression */ :
                    return resolveNewExpression(node, candidatesOutArray, checkMode);
                case 214 /* TaggedTemplateExpression */ :
                    return resolveTaggedTemplateExpression(node, candidatesOutArray, checkMode);
                case 169 /* Decorator */ :
                    return resolveDecorator(node, candidatesOutArray, checkMode);
                case 285 /* JsxOpeningElement */ :
                case 284 /* JsxSelfClosingElement */ :
                    return resolveJsxOpeningLikeElement(node, candidatesOutArray, checkMode);
            }
            Debug.assertNever(node, "Branch in 'resolveSignature' should be unreachable.");
        }
        function getResolvedSignature(node, candidatesOutArray, checkMode) {
            const links = getNodeLinks(node);
            const cached = links.resolvedSignature;
            if (cached && cached !== resolvingSignature && !candidatesOutArray) return cached;
            links.resolvedSignature = resolvingSignature;
            let result = resolveSignature(node, candidatesOutArray, checkMode || 0 /* Normal */ );
            if (result !== resolvingSignature) {
                if (links.resolvedSignature !== resolvingSignature) result = links.resolvedSignature;
                links.resolvedSignature = flowLoopStart === flowLoopCount ? result : cached;
            }
            return result;
        }
        function isJSConstructor(node) {
            var _a;
            if (!node || !isInJSFile(node)) return false;
            const func = isFunctionDeclaration(node) || isFunctionExpression(node) ? node : (isVariableDeclaration(node) || isPropertyAssignment(node)) && node.initializer && isFunctionExpression(node.initializer) ? node.initializer : void 0;
            if (func) {
                if (getJSDocClassTag(node)) return true;
                if (isPropertyAssignment(walkUpParenthesizedExpressions(func.parent))) return false;
                const symbol = getSymbolOfDeclaration(func);
                return !!((_a = symbol == null ? void 0 : symbol.members) == null ? void 0 : _a.size);
            }
            return false;
        }
        function mergeJSSymbols(target, source) {
            var _a, _b;
            if (source) {
                const links = getSymbolLinks(source);
                if (!links.inferredClassSymbol || !links.inferredClassSymbol.has(getSymbolId(target))) {
                    const inferred = isTransientSymbol(target) ? target : cloneSymbol(target);
                    inferred.exports = inferred.exports || createSymbolTable();
                    inferred.members = inferred.members || createSymbolTable();
                    inferred.flags |= source.flags & 32 /* Class */ ;
                    if ((_a = source.exports) == null ? void 0 : _a.size) mergeSymbolTable(inferred.exports, source.exports);
                    if ((_b = source.members) == null ? void 0 : _b.size) mergeSymbolTable(inferred.members, source.members);
                    (links.inferredClassSymbol || (links.inferredClassSymbol = /* @__PURE__ */ new Map())).set(getSymbolId(inferred), inferred);
                    return inferred;
                }
                return links.inferredClassSymbol.get(getSymbolId(target));
            }
        }
        function getAssignedClassSymbol(decl) {
            var _a;
            const assignmentSymbol = decl && getSymbolOfExpando(decl, /*allowDeclaration*/ true);
            const prototype = (_a = assignmentSymbol == null ? void 0 : assignmentSymbol.exports) == null ? void 0 : _a.get("prototype");
            const init = (prototype == null ? void 0 : prototype.valueDeclaration) && getAssignedJSPrototype(prototype.valueDeclaration);
            return init ? getSymbolOfDeclaration(init) : void 0;
        }
        function getSymbolOfExpando(node, allowDeclaration) {
            if (!node.parent) return void 0;
            let name;
            let decl;
            if (isVariableDeclaration(node.parent) && node.parent.initializer === node) {
                if (!isInJSFile(node) && !(isVarConst(node.parent) && isFunctionLikeDeclaration(node))) return void 0;
                name = node.parent.name;
                decl = node.parent;
            } else if (isBinaryExpression(node.parent)) {
                const parentNode = node.parent;
                const parentNodeOperator = node.parent.operatorToken.kind;
                if (parentNodeOperator === 64 /* EqualsToken */  && (allowDeclaration || parentNode.right === node)) {
                    name = parentNode.left;
                    decl = name;
                } else if (parentNodeOperator === 57 /* BarBarToken */  || parentNodeOperator === 61 /* QuestionQuestionToken */ ) {
                    if (isVariableDeclaration(parentNode.parent) && parentNode.parent.initializer === parentNode) {
                        name = parentNode.parent.name;
                        decl = parentNode.parent;
                    } else if (isBinaryExpression(parentNode.parent) && parentNode.parent.operatorToken.kind === 64 /* EqualsToken */  && (allowDeclaration || parentNode.parent.right === parentNode)) {
                        name = parentNode.parent.left;
                        decl = name;
                    }
                    if (!name || !isBindableStaticNameExpression(name) || !isSameEntityName(name, parentNode.left)) return void 0;
                }
            } else if (allowDeclaration && isFunctionDeclaration(node)) {
                name = node.name;
                decl = node;
            }
            if (!decl || !name || !allowDeclaration && !getExpandoInitializer(node, isPrototypeAccess(name))) return void 0;
            return getSymbolOfNode(decl);
        }
        function getAssignedJSPrototype(node) {
            if (!node.parent) return false;
            let parent2 = node.parent;
            while(parent2 && parent2.kind === 210 /* PropertyAccessExpression */ )parent2 = parent2.parent;
            if (parent2 && isBinaryExpression(parent2) && isPrototypeAccess(parent2.left) && parent2.operatorToken.kind === 64 /* EqualsToken */ ) {
                const right = getInitializerOfBinaryExpression(parent2);
                return isObjectLiteralExpression(right) && right;
            }
        }
        function checkCallExpression(node, checkMode) {
            var _a, _b, _c;
            checkGrammarTypeArguments(node, node.typeArguments);
            const signature = getResolvedSignature(node, /*candidatesOutArray*/ void 0, checkMode);
            if (signature === resolvingSignature) return silentNeverType;
            checkDeprecatedSignature(signature, node);
            if (node.expression.kind === 108 /* SuperKeyword */ ) return voidType;
            if (node.kind === 213 /* NewExpression */ ) {
                const declaration = signature.declaration;
                if (declaration && declaration.kind !== 175 /* Constructor */  && declaration.kind !== 179 /* ConstructSignature */  && declaration.kind !== 184 /* ConstructorType */  && !(isJSDocSignature(declaration) && ((_b = (_a = getJSDocRoot(declaration)) == null ? void 0 : _a.parent) == null ? void 0 : _b.kind) === 175 /* Constructor */ ) && !isJSDocConstructSignature(declaration) && !isJSConstructor(declaration)) {
                    if (noImplicitAny) error(node, Diagnostics.new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type);
                    return anyType;
                }
            }
            if (isInJSFile(node) && shouldResolveJsRequire(compilerOptions) && isCommonJsRequire(node)) return resolveExternalModuleTypeByLiteral(node.arguments[0]);
            const returnType = getReturnTypeOfSignature(signature);
            if (returnType.flags & 12288 /* ESSymbolLike */  && isSymbolOrSymbolForCall(node)) return getESSymbolLikeTypeForNode(walkUpParenthesizedExpressions(node.parent));
            if (node.kind === 212 /* CallExpression */  && !node.questionDotToken && node.parent.kind === 243 /* ExpressionStatement */  && returnType.flags & 16384 /* Void */  && getTypePredicateOfSignature(signature)) {
                if (!isDottedName(node.expression)) error(node.expression, Diagnostics.Assertions_require_the_call_target_to_be_an_identifier_or_qualified_name);
                else if (!getEffectsSignature(node)) {
                    const diagnostic = error(node.expression, Diagnostics.Assertions_require_every_name_in_the_call_target_to_be_declared_with_an_explicit_type_annotation);
                    getTypeOfDottedName(node.expression, diagnostic);
                }
            }
            if (isInJSFile(node)) {
                const jsSymbol = getSymbolOfExpando(node, /*allowDeclaration*/ false);
                if ((_c = jsSymbol == null ? void 0 : jsSymbol.exports) == null ? void 0 : _c.size) {
                    const jsAssignmentType = createAnonymousType(jsSymbol, jsSymbol.exports, emptyArray, emptyArray, emptyArray);
                    jsAssignmentType.objectFlags |= 4096 /* JSLiteral */ ;
                    return getIntersectionType([
                        returnType,
                        jsAssignmentType
                    ]);
                }
            }
            return returnType;
        }
        function checkDeprecatedSignature(signature, node) {
            if (signature.declaration && signature.declaration.flags & 268435456 /* Deprecated */ ) {
                const suggestionNode = getDeprecatedSuggestionNode(node);
                const name = tryGetPropertyAccessOrIdentifierToString(getInvokedExpression(node));
                addDeprecatedSuggestionWithSignature(suggestionNode, signature.declaration, name, signatureToString(signature));
            }
        }
        function getDeprecatedSuggestionNode(node) {
            node = skipParentheses(node);
            switch(node.kind){
                case 212 /* CallExpression */ :
                case 169 /* Decorator */ :
                case 213 /* NewExpression */ :
                    return getDeprecatedSuggestionNode(node.expression);
                case 214 /* TaggedTemplateExpression */ :
                    return getDeprecatedSuggestionNode(node.tag);
                case 285 /* JsxOpeningElement */ :
                case 284 /* JsxSelfClosingElement */ :
                    return getDeprecatedSuggestionNode(node.tagName);
                case 211 /* ElementAccessExpression */ :
                    return node.argumentExpression;
                case 210 /* PropertyAccessExpression */ :
                    return node.name;
                case 182 /* TypeReference */ :
                    const typeReference = node;
                    return isQualifiedName(typeReference.typeName) ? typeReference.typeName.right : typeReference;
                default:
                    return node;
            }
        }
        function isSymbolOrSymbolForCall(node) {
            if (!isCallExpression(node)) return false;
            let left = node.expression;
            if (isPropertyAccessExpression(left) && left.name.escapedText === "for") left = left.expression;
            if (!isIdentifier(left) || left.escapedText !== "Symbol") return false;
            const globalESSymbol = getGlobalESSymbolConstructorSymbol(/*reportErrors*/ false);
            if (!globalESSymbol) return false;
            return globalESSymbol === resolveName(left, "Symbol", 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false);
        }
        function checkImportCallExpression(node) {
            checkGrammarImportCallExpression(node);
            if (node.arguments.length === 0) return createPromiseReturnType(node, anyType);
            const specifier = node.arguments[0];
            const specifierType = checkExpressionCached(specifier);
            const optionsType = node.arguments.length > 1 ? checkExpressionCached(node.arguments[1]) : void 0;
            for(let i = 2; i < node.arguments.length; ++i)checkExpressionCached(node.arguments[i]);
            if (specifierType.flags & 32768 /* Undefined */  || specifierType.flags & 65536 /* Null */  || !isTypeAssignableTo(specifierType, stringType)) error(specifier, Diagnostics.Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0, typeToString(specifierType));
            if (optionsType) {
                const importCallOptionsType = getGlobalImportCallOptionsType(/*reportErrors*/ true);
                if (importCallOptionsType !== emptyObjectType) checkTypeAssignableTo(optionsType, getNullableType(importCallOptionsType, 32768 /* Undefined */ ), node.arguments[1]);
            }
            const moduleSymbol = resolveExternalModuleName(node, specifier);
            if (moduleSymbol) {
                const esModuleSymbol = resolveESModuleSymbol(moduleSymbol, specifier, /*dontResolveAlias*/ true, /*suppressInteropError*/ false);
                if (esModuleSymbol) return createPromiseReturnType(node, getTypeWithSyntheticDefaultOnly(getTypeOfSymbol(esModuleSymbol), esModuleSymbol, moduleSymbol, specifier) || getTypeWithSyntheticDefaultImportType(getTypeOfSymbol(esModuleSymbol), esModuleSymbol, moduleSymbol, specifier));
            }
            return createPromiseReturnType(node, anyType);
        }
        function createDefaultPropertyWrapperForModule(symbol, originalSymbol, anonymousSymbol) {
            const memberTable = createSymbolTable();
            const newSymbol = createSymbol(2097152 /* Alias */ , "default" /* Default */ );
            newSymbol.parent = originalSymbol;
            newSymbol.links.nameType = getStringLiteralType("default");
            newSymbol.links.aliasTarget = resolveSymbol(symbol);
            memberTable.set("default" /* Default */ , newSymbol);
            return createAnonymousType(anonymousSymbol, memberTable, emptyArray, emptyArray, emptyArray);
        }
        function getTypeWithSyntheticDefaultOnly(type, symbol, originalSymbol, moduleSpecifier) {
            const hasDefaultOnly = isOnlyImportedAsDefault(moduleSpecifier);
            if (hasDefaultOnly && type && !isErrorType(type)) {
                const synthType = type;
                if (!synthType.defaultOnlyType) {
                    const type2 = createDefaultPropertyWrapperForModule(symbol, originalSymbol);
                    synthType.defaultOnlyType = type2;
                }
                return synthType.defaultOnlyType;
            }
            return void 0;
        }
        function getTypeWithSyntheticDefaultImportType(type, symbol, originalSymbol, moduleSpecifier) {
            var _a;
            if (allowSyntheticDefaultImports && type && !isErrorType(type)) {
                const synthType = type;
                if (!synthType.syntheticType) {
                    const file = (_a = originalSymbol.declarations) == null ? void 0 : _a.find(isSourceFile);
                    const hasSyntheticDefault = canHaveSyntheticDefault(file, originalSymbol, /*dontResolveAlias*/ false, moduleSpecifier);
                    if (hasSyntheticDefault) {
                        const anonymousSymbol = createSymbol(2048 /* TypeLiteral */ , "__type" /* Type */ );
                        const defaultContainingObject = createDefaultPropertyWrapperForModule(symbol, originalSymbol, anonymousSymbol);
                        anonymousSymbol.links.type = defaultContainingObject;
                        synthType.syntheticType = isValidSpreadType(type) ? getSpreadType(type, defaultContainingObject, anonymousSymbol, /*objectFlags*/ 0, /*readonly*/ false) : defaultContainingObject;
                    } else synthType.syntheticType = type;
                }
                return synthType.syntheticType;
            }
            return type;
        }
        function isCommonJsRequire(node) {
            if (!isRequireCall(node, /*requireStringLiteralLikeArgument*/ true)) return false;
            if (!isIdentifier(node.expression)) return Debug.fail();
            const resolvedRequire = resolveName(node.expression, node.expression.escapedText, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ true);
            if (resolvedRequire === requireSymbol) return true;
            if (resolvedRequire.flags & 2097152 /* Alias */ ) return false;
            const targetDeclarationKind = resolvedRequire.flags & 16 /* Function */  ? 261 /* FunctionDeclaration */  : resolvedRequire.flags & 3 /* Variable */  ? 259 /* VariableDeclaration */  : 0 /* Unknown */ ;
            if (targetDeclarationKind !== 0 /* Unknown */ ) {
                const decl = getDeclarationOfKind(resolvedRequire, targetDeclarationKind);
                return !!decl && !!(decl.flags & 16777216 /* Ambient */ );
            }
            return false;
        }
        function checkTaggedTemplateExpression(node) {
            if (!checkGrammarTaggedTemplateChain(node)) checkGrammarTypeArguments(node, node.typeArguments);
            if (languageVersion < 2 /* ES2015 */ ) checkExternalEmitHelpers(node, 262144 /* MakeTemplateObject */ );
            const signature = getResolvedSignature(node);
            checkDeprecatedSignature(signature, node);
            return getReturnTypeOfSignature(signature);
        }
        function checkAssertion(node, checkMode) {
            if (node.kind === 215 /* TypeAssertionExpression */ ) {
                const file = getSourceFileOfNode(node);
                if (file && fileExtensionIsOneOf(file.fileName, [
                    ".cts" /* Cts */ ,
                    ".mts" /* Mts */ 
                ])) grammarErrorOnNode(node, Diagnostics.This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Use_an_as_expression_instead);
            }
            return checkAssertionWorker(node, checkMode);
        }
        function isValidConstAssertionArgument(node) {
            switch(node.kind){
                case 11 /* StringLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 208 /* ArrayLiteralExpression */ :
                case 209 /* ObjectLiteralExpression */ :
                case 227 /* TemplateExpression */ :
                    return true;
                case 216 /* ParenthesizedExpression */ :
                    return isValidConstAssertionArgument(node.expression);
                case 223 /* PrefixUnaryExpression */ :
                    const op = node.operator;
                    const arg = node.operand;
                    return op === 41 /* MinusToken */  && (arg.kind === 9 /* NumericLiteral */  || arg.kind === 10 /* BigIntLiteral */ ) || op === 40 /* PlusToken */  && arg.kind === 9 /* NumericLiteral */ ;
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    const expr = skipParentheses(node.expression);
                    const symbol = isEntityNameExpression(expr) ? resolveEntityName(expr, 111551 /* Value */ , /*ignoreErrors*/ true) : void 0;
                    return !!(symbol && symbol.flags & 384 /* Enum */ );
            }
            return false;
        }
        function checkAssertionWorker(node, checkMode) {
            const { type: type , expression: expression  } = getAssertionTypeAndExpression(node);
            const exprType = checkExpression(expression, checkMode);
            if (isConstTypeReference(type)) {
                if (!isValidConstAssertionArgument(expression)) error(expression, Diagnostics.A_const_assertions_can_only_be_applied_to_references_to_enum_members_or_string_number_boolean_array_or_object_literals);
                return getRegularTypeOfLiteralType(exprType);
            }
            const links = getNodeLinks(node);
            links.assertionExpressionType = exprType;
            checkSourceElement(type);
            checkNodeDeferred(node);
            return getTypeFromTypeNode(type);
        }
        function getAssertionTypeAndExpression(node) {
            let type;
            let expression;
            switch(node.kind){
                case 233 /* AsExpression */ :
                case 215 /* TypeAssertionExpression */ :
                    type = node.type;
                    expression = node.expression;
                    break;
                case 216 /* ParenthesizedExpression */ :
                    type = getJSDocTypeAssertionType(node);
                    expression = node.expression;
                    break;
            }
            return {
                type: type,
                expression: expression
            };
        }
        function checkAssertionDeferred(node) {
            const { type: type  } = getAssertionTypeAndExpression(node);
            const errNode = isParenthesizedExpression(node) ? type : node;
            const links = getNodeLinks(node);
            Debug.assertIsDefined(links.assertionExpressionType);
            const exprType = getRegularTypeOfObjectLiteral(getBaseTypeOfLiteralType(links.assertionExpressionType));
            const targetType = getTypeFromTypeNode(type);
            if (!isErrorType(targetType)) addLazyDiagnostic(()=>{
                const widenedType = getWidenedType(exprType);
                if (!isTypeComparableTo(targetType, widenedType)) checkTypeComparableTo(exprType, targetType, errNode, Diagnostics.Conversion_of_type_0_to_type_1_may_be_a_mistake_because_neither_type_sufficiently_overlaps_with_the_other_If_this_was_intentional_convert_the_expression_to_unknown_first);
            });
        }
        function checkNonNullChain(node) {
            const leftType = checkExpression(node.expression);
            const nonOptionalType = getOptionalExpressionType(leftType, node.expression);
            return propagateOptionalTypeMarker(getNonNullableType(nonOptionalType), node, nonOptionalType !== leftType);
        }
        function checkNonNullAssertion(node) {
            return node.flags & 32 /* OptionalChain */  ? checkNonNullChain(node) : getNonNullableType(checkExpression(node.expression));
        }
        function checkExpressionWithTypeArguments(node) {
            checkGrammarExpressionWithTypeArguments(node);
            forEach(node.typeArguments, checkSourceElement);
            if (node.kind === 232 /* ExpressionWithTypeArguments */ ) {
                const parent2 = walkUpParenthesizedExpressions(node.parent);
                if (parent2.kind === 225 /* BinaryExpression */  && parent2.operatorToken.kind === 104 /* InstanceOfKeyword */  && isNodeDescendantOf(node, parent2.right)) error(node, Diagnostics.The_right_hand_side_of_an_instanceof_expression_must_not_be_an_instantiation_expression);
            }
            const exprType = node.kind === 232 /* ExpressionWithTypeArguments */  ? checkExpression(node.expression) : isThisIdentifier(node.exprName) ? checkThisExpression(node.exprName) : checkExpression(node.exprName);
            return getInstantiationExpressionType(exprType, node);
        }
        function getInstantiationExpressionType(exprType, node) {
            const typeArguments = node.typeArguments;
            if (exprType === silentNeverType || isErrorType(exprType) || !some(typeArguments)) return exprType;
            let hasSomeApplicableSignature = false;
            let nonApplicableType;
            const result = getInstantiatedType(exprType);
            const errorType2 = hasSomeApplicableSignature ? nonApplicableType : exprType;
            if (errorType2) diagnostics.add(createDiagnosticForNodeArray(getSourceFileOfNode(node), typeArguments, Diagnostics.Type_0_has_no_signatures_for_which_the_type_argument_list_is_applicable, typeToString(errorType2)));
            return result;
            function getInstantiatedType(type) {
                let hasSignatures = false;
                let hasApplicableSignature = false;
                const result2 = getInstantiatedTypePart(type);
                hasSomeApplicableSignature || (hasSomeApplicableSignature = hasApplicableSignature);
                if (hasSignatures && !hasApplicableSignature) nonApplicableType ?? (nonApplicableType = type);
                return result2;
                function getInstantiatedTypePart(type2) {
                    if (type2.flags & 524288 /* Object */ ) {
                        const resolved = resolveStructuredTypeMembers(type2);
                        const callSignatures = getInstantiatedSignatures(resolved.callSignatures);
                        const constructSignatures = getInstantiatedSignatures(resolved.constructSignatures);
                        hasSignatures || (hasSignatures = resolved.callSignatures.length !== 0 || resolved.constructSignatures.length !== 0);
                        hasApplicableSignature || (hasApplicableSignature = callSignatures.length !== 0 || constructSignatures.length !== 0);
                        if (callSignatures !== resolved.callSignatures || constructSignatures !== resolved.constructSignatures) {
                            const result3 = createAnonymousType(/*symbol*/ void 0, resolved.members, callSignatures, constructSignatures, resolved.indexInfos);
                            result3.objectFlags |= 8388608 /* InstantiationExpressionType */ ;
                            result3.node = node;
                            return result3;
                        }
                    } else if (type2.flags & 58982400 /* InstantiableNonPrimitive */ ) {
                        const constraint = getBaseConstraintOfType(type2);
                        if (constraint) {
                            const instantiated = getInstantiatedTypePart(constraint);
                            if (instantiated !== constraint) return instantiated;
                        }
                    } else if (type2.flags & 1048576 /* Union */ ) return mapType(type2, getInstantiatedType);
                    else if (type2.flags & 2097152 /* Intersection */ ) return getIntersectionType(sameMap(type2.types, getInstantiatedTypePart));
                    return type2;
                }
            }
            function getInstantiatedSignatures(signatures) {
                const applicableSignatures = filter(signatures, (sig)=>!!sig.typeParameters && hasCorrectTypeArgumentArity(sig, typeArguments));
                return sameMap(applicableSignatures, (sig)=>{
                    const typeArgumentTypes = checkTypeArguments(sig, typeArguments, /*reportErrors*/ true);
                    return typeArgumentTypes ? getSignatureInstantiation(sig, typeArgumentTypes, isInJSFile(sig.declaration)) : sig;
                });
            }
        }
        function checkSatisfiesExpression(node) {
            checkSourceElement(node.type);
            return checkSatisfiesExpressionWorker(node.expression, node.type);
        }
        function checkSatisfiesExpressionWorker(expression, target, checkMode) {
            const exprType = checkExpression(expression, checkMode);
            const targetType = getTypeFromTypeNode(target);
            if (isErrorType(targetType)) return targetType;
            const errorNode = findAncestor(target.parent, (n)=>n.kind === 237 /* SatisfiesExpression */  || n.kind === 356 /* JSDocSatisfiesTag */ );
            checkTypeAssignableToAndOptionallyElaborate(exprType, targetType, errorNode, expression, Diagnostics.Type_0_does_not_satisfy_the_expected_type_1);
            return exprType;
        }
        function checkMetaProperty(node) {
            checkGrammarMetaProperty(node);
            if (node.keywordToken === 105 /* NewKeyword */ ) return checkNewTargetMetaProperty(node);
            if (node.keywordToken === 102 /* ImportKeyword */ ) return checkImportMetaProperty(node);
            return Debug.assertNever(node.keywordToken);
        }
        function checkMetaPropertyKeyword(node) {
            switch(node.keywordToken){
                case 102 /* ImportKeyword */ :
                    return getGlobalImportMetaExpressionType();
                case 105 /* NewKeyword */ :
                    const type = checkNewTargetMetaProperty(node);
                    return isErrorType(type) ? errorType : createNewTargetExpressionType(type);
                default:
                    Debug.assertNever(node.keywordToken);
            }
        }
        function checkNewTargetMetaProperty(node) {
            const container = getNewTargetContainer(node);
            if (!container) {
                error(node, Diagnostics.Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constructor, "new.target");
                return errorType;
            } else if (container.kind === 175 /* Constructor */ ) {
                const symbol = getSymbolOfDeclaration(container.parent);
                return getTypeOfSymbol(symbol);
            } else {
                const symbol = getSymbolOfDeclaration(container);
                return getTypeOfSymbol(symbol);
            }
        }
        function checkImportMetaProperty(node) {
            if (moduleKind === 100 /* Node16 */  || moduleKind === 199 /* NodeNext */ ) {
                if (getSourceFileOfNode(node).impliedNodeFormat !== 99 /* ESNext */ ) error(node, Diagnostics.The_import_meta_meta_property_is_not_allowed_in_files_which_will_build_into_CommonJS_output);
            } else if (moduleKind < 6 /* ES2020 */  && moduleKind !== 4 /* System */ ) error(node, Diagnostics.The_import_meta_meta_property_is_only_allowed_when_the_module_option_is_es2020_es2022_esnext_system_node16_or_nodenext);
            const file = getSourceFileOfNode(node);
            Debug.assert(!!(file.flags & 4194304 /* PossiblyContainsImportMeta */ ), "Containing file is missing import meta node flag.");
            return node.name.escapedText === "meta" ? getGlobalImportMetaType() : errorType;
        }
        function getTypeOfParameter(symbol) {
            const type = getTypeOfSymbol(symbol);
            if (strictNullChecks) {
                const declaration = symbol.valueDeclaration;
                if (declaration && hasInitializer(declaration)) return getOptionalType(type);
            }
            return type;
        }
        function getTupleElementLabel(d) {
            Debug.assert(isIdentifier(d.name));
            return d.name.escapedText;
        }
        function getParameterNameAtPosition(signature, pos, overrideRestType) {
            const paramCount = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            if (pos < paramCount) return signature.parameters[pos].escapedName;
            const restParameter = signature.parameters[paramCount] || unknownSymbol;
            const restType = overrideRestType || getTypeOfSymbol(restParameter);
            if (isTupleType(restType)) {
                const associatedNames = restType.target.labeledElementDeclarations;
                const index = pos - paramCount;
                return associatedNames && getTupleElementLabel(associatedNames[index]) || restParameter.escapedName + "_" + index;
            }
            return restParameter.escapedName;
        }
        function getParameterIdentifierNameAtPosition(signature, pos) {
            var _a;
            if (((_a = signature.declaration) == null ? void 0 : _a.kind) === 323 /* JSDocFunctionType */ ) return void 0;
            const paramCount = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            if (pos < paramCount) {
                const param = signature.parameters[pos];
                return isParameterDeclarationWithIdentifierName(param) ? [
                    param.escapedName,
                    false
                ] : void 0;
            }
            const restParameter = signature.parameters[paramCount] || unknownSymbol;
            if (!isParameterDeclarationWithIdentifierName(restParameter)) return void 0;
            const restType = getTypeOfSymbol(restParameter);
            if (isTupleType(restType)) {
                const associatedNames = restType.target.labeledElementDeclarations;
                const index = pos - paramCount;
                const associatedName = associatedNames == null ? void 0 : associatedNames[index];
                const isRestTupleElement = !!(associatedName == null ? void 0 : associatedName.dotDotDotToken);
                return associatedName ? [
                    getTupleElementLabel(associatedName),
                    isRestTupleElement
                ] : void 0;
            }
            if (pos === paramCount) return [
                restParameter.escapedName,
                true
            ];
            return void 0;
        }
        function isParameterDeclarationWithIdentifierName(symbol) {
            return symbol.valueDeclaration && isParameter(symbol.valueDeclaration) && isIdentifier(symbol.valueDeclaration.name);
        }
        function isValidDeclarationForTupleLabel(d) {
            return d.kind === 201 /* NamedTupleMember */  || isParameter(d) && d.name && isIdentifier(d.name);
        }
        function getNameableDeclarationAtPosition(signature, pos) {
            const paramCount = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            if (pos < paramCount) {
                const decl = signature.parameters[pos].valueDeclaration;
                return decl && isValidDeclarationForTupleLabel(decl) ? decl : void 0;
            }
            const restParameter = signature.parameters[paramCount] || unknownSymbol;
            const restType = getTypeOfSymbol(restParameter);
            if (isTupleType(restType)) {
                const associatedNames = restType.target.labeledElementDeclarations;
                const index = pos - paramCount;
                return associatedNames && associatedNames[index];
            }
            return restParameter.valueDeclaration && isValidDeclarationForTupleLabel(restParameter.valueDeclaration) ? restParameter.valueDeclaration : void 0;
        }
        function getTypeAtPosition(signature, pos) {
            return tryGetTypeAtPosition(signature, pos) || anyType;
        }
        function tryGetTypeAtPosition(signature, pos) {
            const paramCount = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            if (pos < paramCount) return getTypeOfParameter(signature.parameters[pos]);
            if (signatureHasRestParameter(signature)) {
                const restType = getTypeOfSymbol(signature.parameters[paramCount]);
                const index = pos - paramCount;
                if (!isTupleType(restType) || restType.target.hasRestElement || index < restType.target.fixedLength) return getIndexedAccessType(restType, getNumberLiteralType(index));
            }
            return void 0;
        }
        function getRestTypeAtPosition(source, pos) {
            const parameterCount = getParameterCount(source);
            const minArgumentCount = getMinArgumentCount(source);
            const restType = getEffectiveRestType(source);
            if (restType && pos >= parameterCount - 1) return pos === parameterCount - 1 ? restType : createArrayType(getIndexedAccessType(restType, numberType));
            const types = [];
            const flags = [];
            const names = [];
            for(let i = pos; i < parameterCount; i++){
                if (!restType || i < parameterCount - 1) {
                    types.push(getTypeAtPosition(source, i));
                    flags.push(i < minArgumentCount ? 1 /* Required */  : 2 /* Optional */ );
                } else {
                    types.push(restType);
                    flags.push(8 /* Variadic */ );
                }
                const name = getNameableDeclarationAtPosition(source, i);
                if (name) names.push(name);
            }
            return createTupleType(types, flags, /*readonly*/ false, length(names) === length(types) ? names : void 0);
        }
        function getParameterCount(signature) {
            const length2 = signature.parameters.length;
            if (signatureHasRestParameter(signature)) {
                const restType = getTypeOfSymbol(signature.parameters[length2 - 1]);
                if (isTupleType(restType)) return length2 + restType.target.fixedLength - (restType.target.hasRestElement ? 0 : 1);
            }
            return length2;
        }
        function getMinArgumentCount(signature, flags) {
            const strongArityForUntypedJS = flags & 1 /* StrongArityForUntypedJS */ ;
            const voidIsNonOptional = flags & 2 /* VoidIsNonOptional */ ;
            if (voidIsNonOptional || signature.resolvedMinArgumentCount === void 0) {
                let minArgumentCount;
                if (signatureHasRestParameter(signature)) {
                    const restType = getTypeOfSymbol(signature.parameters[signature.parameters.length - 1]);
                    if (isTupleType(restType)) {
                        const firstOptionalIndex = findIndex(restType.target.elementFlags, (f)=>!(f & 1 /* Required */ ));
                        const requiredCount = firstOptionalIndex < 0 ? restType.target.fixedLength : firstOptionalIndex;
                        if (requiredCount > 0) minArgumentCount = signature.parameters.length - 1 + requiredCount;
                    }
                }
                if (minArgumentCount === void 0) {
                    if (!strongArityForUntypedJS && signature.flags & 32 /* IsUntypedSignatureInJSFile */ ) return 0;
                    minArgumentCount = signature.minArgumentCount;
                }
                if (voidIsNonOptional) return minArgumentCount;
                for(let i = minArgumentCount - 1; i >= 0; i--){
                    const type = getTypeAtPosition(signature, i);
                    if (filterType(type, acceptsVoid).flags & 131072 /* Never */ ) break;
                    minArgumentCount = i;
                }
                signature.resolvedMinArgumentCount = minArgumentCount;
            }
            return signature.resolvedMinArgumentCount;
        }
        function hasEffectiveRestParameter(signature) {
            if (signatureHasRestParameter(signature)) {
                const restType = getTypeOfSymbol(signature.parameters[signature.parameters.length - 1]);
                return !isTupleType(restType) || restType.target.hasRestElement;
            }
            return false;
        }
        function getEffectiveRestType(signature) {
            if (signatureHasRestParameter(signature)) {
                const restType = getTypeOfSymbol(signature.parameters[signature.parameters.length - 1]);
                if (!isTupleType(restType)) return restType;
                if (restType.target.hasRestElement) return sliceTupleType(restType, restType.target.fixedLength);
            }
            return void 0;
        }
        function getNonArrayRestType(signature) {
            const restType = getEffectiveRestType(signature);
            return restType && !isArrayType(restType) && !isTypeAny(restType) ? restType : void 0;
        }
        function getTypeOfFirstParameterOfSignature(signature) {
            return getTypeOfFirstParameterOfSignatureWithFallback(signature, neverType);
        }
        function getTypeOfFirstParameterOfSignatureWithFallback(signature, fallbackType) {
            return signature.parameters.length > 0 ? getTypeAtPosition(signature, 0) : fallbackType;
        }
        function inferFromAnnotatedParameters(signature, context, inferenceContext) {
            const len = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            for(let i = 0; i < len; i++){
                const declaration = signature.parameters[i].valueDeclaration;
                if (declaration.type) {
                    const typeNode = getEffectiveTypeAnnotationNode(declaration);
                    if (typeNode) inferTypes(inferenceContext.inferences, getTypeFromTypeNode(typeNode), getTypeAtPosition(context, i));
                }
            }
        }
        function assignContextualParameterTypes(signature, context) {
            if (context.typeParameters) {
                if (!signature.typeParameters) signature.typeParameters = context.typeParameters;
                else return;
            }
            if (context.thisParameter) {
                const parameter = signature.thisParameter;
                if (!parameter || parameter.valueDeclaration && !parameter.valueDeclaration.type) {
                    if (!parameter) signature.thisParameter = createSymbolWithType(context.thisParameter, /*type*/ void 0);
                    assignParameterType(signature.thisParameter, getTypeOfSymbol(context.thisParameter));
                }
            }
            const len = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            for(let i = 0; i < len; i++){
                const parameter = signature.parameters[i];
                if (!getEffectiveTypeAnnotationNode(parameter.valueDeclaration)) {
                    const contextualParameterType = tryGetTypeAtPosition(context, i);
                    assignParameterType(parameter, contextualParameterType);
                }
            }
            if (signatureHasRestParameter(signature)) {
                const parameter = last(signature.parameters);
                if (parameter.valueDeclaration ? !getEffectiveTypeAnnotationNode(parameter.valueDeclaration) : !!(getCheckFlags(parameter) & 65536 /* DeferredType */ )) {
                    const contextualParameterType = getRestTypeAtPosition(context, len);
                    assignParameterType(parameter, contextualParameterType);
                }
            }
        }
        function assignNonContextualParameterTypes(signature) {
            if (signature.thisParameter) assignParameterType(signature.thisParameter);
            for (const parameter of signature.parameters)assignParameterType(parameter);
        }
        function assignParameterType(parameter, type) {
            const links = getSymbolLinks(parameter);
            if (!links.type) {
                const declaration = parameter.valueDeclaration;
                links.type = type || (declaration ? getWidenedTypeForVariableLikeDeclaration(declaration, /*reportErrors*/ true) : getTypeOfSymbol(parameter));
                if (declaration && declaration.name.kind !== 80 /* Identifier */ ) {
                    if (links.type === unknownType) links.type = getTypeFromBindingPattern(declaration.name);
                    assignBindingElementTypes(declaration.name, links.type);
                }
            } else if (type) Debug.assertEqual(links.type, type, "Parameter symbol already has a cached type which differs from newly assigned type");
        }
        function assignBindingElementTypes(pattern, parentType) {
            for (const element of pattern.elements)if (!isOmittedExpression(element)) {
                const type = getBindingElementTypeFromParentType(element, parentType);
                if (element.name.kind === 80 /* Identifier */ ) getSymbolLinks(getSymbolOfDeclaration(element)).type = type;
                else assignBindingElementTypes(element.name, type);
            }
        }
        function createClassDecoratorContextType(classType) {
            return tryCreateTypeReference(getGlobalClassDecoratorContextType(/*reportErrors*/ true), [
                classType
            ]);
        }
        function createClassMethodDecoratorContextType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassMethodDecoratorContextType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassGetterDecoratorContextType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassGetterDecoratorContextType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassSetterDecoratorContextType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassSetterDecoratorContextType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassAccessorDecoratorContextType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassAccessorDecoratorContextType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassFieldDecoratorContextType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassFieldDecoratorContextType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function getClassMemberDecoratorContextOverrideType(nameType, isPrivate, isStatic2) {
            const key = `${isPrivate ? "p" : "P"}${isStatic2 ? "s" : "S"}${nameType.id}`;
            let overrideType = decoratorContextOverrideTypeCache.get(key);
            if (!overrideType) {
                const members = createSymbolTable();
                members.set("name", createProperty("name", nameType));
                members.set("private", createProperty("private", isPrivate ? trueType : falseType));
                members.set("static", createProperty("static", isStatic2 ? trueType : falseType));
                overrideType = createAnonymousType(/*symbol*/ void 0, members, emptyArray, emptyArray, emptyArray);
                decoratorContextOverrideTypeCache.set(key, overrideType);
            }
            return overrideType;
        }
        function createClassMemberDecoratorContextTypeForNode(node, thisType, valueType) {
            const isStatic2 = hasStaticModifier(node);
            const isPrivate = isPrivateIdentifier(node.name);
            const nameType = isPrivate ? getStringLiteralType(idText(node.name)) : getLiteralTypeFromPropertyName(node.name);
            const contextType = isMethodDeclaration(node) ? createClassMethodDecoratorContextType(thisType, valueType) : isGetAccessorDeclaration(node) ? createClassGetterDecoratorContextType(thisType, valueType) : isSetAccessorDeclaration(node) ? createClassSetterDecoratorContextType(thisType, valueType) : isAutoAccessorPropertyDeclaration(node) ? createClassAccessorDecoratorContextType(thisType, valueType) : isPropertyDeclaration(node) ? createClassFieldDecoratorContextType(thisType, valueType) : Debug.failBadSyntaxKind(node);
            const overrideType = getClassMemberDecoratorContextOverrideType(nameType, isPrivate, isStatic2);
            return getIntersectionType([
                contextType,
                overrideType
            ]);
        }
        function createClassAccessorDecoratorTargetType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassAccessorDecoratorTargetType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassAccessorDecoratorResultType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassAccessorDecoratorResultType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassFieldDecoratorInitializerMutatorType(thisType, valueType) {
            const thisParam = createParameter("this", thisType);
            const valueParam = createParameter("value", valueType);
            return createFunctionType(/*typeParameters*/ void 0, thisParam, [
                valueParam
            ], valueType, /*typePredicate*/ void 0, 1);
        }
        function createESDecoratorCallSignature(targetType, contextType, nonOptionalReturnType) {
            const targetParam = createParameter("target", targetType);
            const contextParam = createParameter("context", contextType);
            const returnType = getUnionType([
                nonOptionalReturnType,
                voidType
            ]);
            return createCallSignature(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                targetParam,
                contextParam
            ], returnType);
        }
        function getESDecoratorCallSignature(decorator) {
            const { parent: parent2  } = decorator;
            const links = getNodeLinks(parent2);
            if (!links.decoratorSignature) {
                links.decoratorSignature = anySignature;
                switch(parent2.kind){
                    case 262 /* ClassDeclaration */ :
                    case 230 /* ClassExpression */ :
                        {
                            const node = parent2;
                            const targetType = getTypeOfSymbol(getSymbolOfDeclaration(node));
                            const contextType = createClassDecoratorContextType(targetType);
                            links.decoratorSignature = createESDecoratorCallSignature(targetType, contextType, targetType);
                            break;
                        }
                    case 173 /* MethodDeclaration */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                        {
                            const node = parent2;
                            if (!isClassLike(node.parent)) break;
                            const valueType = isMethodDeclaration(node) ? getOrCreateTypeFromSignature(getSignatureFromDeclaration(node)) : getTypeOfNode(node);
                            const thisType = hasStaticModifier(node) ? getTypeOfSymbol(getSymbolOfDeclaration(node.parent)) : getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(node.parent));
                            const targetType = isGetAccessorDeclaration(node) ? createGetterFunctionType(valueType) : isSetAccessorDeclaration(node) ? createSetterFunctionType(valueType) : valueType;
                            const contextType = createClassMemberDecoratorContextTypeForNode(node, thisType, valueType);
                            const returnType = isGetAccessorDeclaration(node) ? createGetterFunctionType(valueType) : isSetAccessorDeclaration(node) ? createSetterFunctionType(valueType) : valueType;
                            links.decoratorSignature = createESDecoratorCallSignature(targetType, contextType, returnType);
                            break;
                        }
                    case 171 /* PropertyDeclaration */ :
                        {
                            const node = parent2;
                            if (!isClassLike(node.parent)) break;
                            const valueType = getTypeOfNode(node);
                            const thisType = hasStaticModifier(node) ? getTypeOfSymbol(getSymbolOfDeclaration(node.parent)) : getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(node.parent));
                            const targetType = hasAccessorModifier(node) ? createClassAccessorDecoratorTargetType(thisType, valueType) : undefinedType;
                            const contextType = createClassMemberDecoratorContextTypeForNode(node, thisType, valueType);
                            const returnType = hasAccessorModifier(node) ? createClassAccessorDecoratorResultType(thisType, valueType) : createClassFieldDecoratorInitializerMutatorType(thisType, valueType);
                            links.decoratorSignature = createESDecoratorCallSignature(targetType, contextType, returnType);
                            break;
                        }
                }
            }
            return links.decoratorSignature === anySignature ? void 0 : links.decoratorSignature;
        }
        function getLegacyDecoratorCallSignature(decorator) {
            const { parent: parent2  } = decorator;
            const links = getNodeLinks(parent2);
            if (!links.decoratorSignature) {
                links.decoratorSignature = anySignature;
                switch(parent2.kind){
                    case 262 /* ClassDeclaration */ :
                    case 230 /* ClassExpression */ :
                        {
                            const node = parent2;
                            const targetType = getTypeOfSymbol(getSymbolOfDeclaration(node));
                            const targetParam = createParameter("target", targetType);
                            links.decoratorSignature = createCallSignature(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                                targetParam
                            ], getUnionType([
                                targetType,
                                voidType
                            ]));
                            break;
                        }
                    case 168 /* Parameter */ :
                        {
                            const node = parent2;
                            if (!isConstructorDeclaration(node.parent) && !(isMethodDeclaration(node.parent) || isSetAccessorDeclaration(node.parent) && isClassLike(node.parent.parent))) break;
                            if (getThisParameter(node.parent) === node) break;
                            const index = getThisParameter(node.parent) ? node.parent.parameters.indexOf(node) - 1 : node.parent.parameters.indexOf(node);
                            Debug.assert(index >= 0);
                            const targetType = isConstructorDeclaration(node.parent) ? getTypeOfSymbol(getSymbolOfDeclaration(node.parent.parent)) : getParentTypeOfClassElement(node.parent);
                            const keyType = isConstructorDeclaration(node.parent) ? undefinedType : getClassElementPropertyKeyType(node.parent);
                            const indexType = getNumberLiteralType(index);
                            const targetParam = createParameter("target", targetType);
                            const keyParam = createParameter("propertyKey", keyType);
                            const indexParam = createParameter("parameterIndex", indexType);
                            links.decoratorSignature = createCallSignature(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                                targetParam,
                                keyParam,
                                indexParam
                            ], voidType);
                            break;
                        }
                    case 173 /* MethodDeclaration */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                    case 171 /* PropertyDeclaration */ :
                        {
                            const node = parent2;
                            if (!isClassLike(node.parent)) break;
                            const targetType = getParentTypeOfClassElement(node);
                            const targetParam = createParameter("target", targetType);
                            const keyType = getClassElementPropertyKeyType(node);
                            const keyParam = createParameter("propertyKey", keyType);
                            const returnType = isPropertyDeclaration(node) ? voidType : createTypedPropertyDescriptorType(getTypeOfNode(node));
                            const hasPropDesc = languageVersion !== 0 /* ES3 */  && (!isPropertyDeclaration(parent2) || hasAccessorModifier(parent2));
                            if (hasPropDesc) {
                                const descriptorType = createTypedPropertyDescriptorType(getTypeOfNode(node));
                                const descriptorParam = createParameter("descriptor", descriptorType);
                                links.decoratorSignature = createCallSignature(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                                    targetParam,
                                    keyParam,
                                    descriptorParam
                                ], getUnionType([
                                    returnType,
                                    voidType
                                ]));
                            } else links.decoratorSignature = createCallSignature(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                                targetParam,
                                keyParam
                            ], getUnionType([
                                returnType,
                                voidType
                            ]));
                            break;
                        }
                }
            }
            return links.decoratorSignature === anySignature ? void 0 : links.decoratorSignature;
        }
        function getDecoratorCallSignature(decorator) {
            return legacyDecorators ? getLegacyDecoratorCallSignature(decorator) : getESDecoratorCallSignature(decorator);
        }
        function createPromiseType(promisedType) {
            const globalPromiseType = getGlobalPromiseType(/*reportErrors*/ true);
            if (globalPromiseType !== emptyGenericType) {
                promisedType = getAwaitedTypeNoAlias(unwrapAwaitedType(promisedType)) || unknownType;
                return createTypeReference(globalPromiseType, [
                    promisedType
                ]);
            }
            return unknownType;
        }
        function createPromiseLikeType(promisedType) {
            const globalPromiseLikeType = getGlobalPromiseLikeType(/*reportErrors*/ true);
            if (globalPromiseLikeType !== emptyGenericType) {
                promisedType = getAwaitedTypeNoAlias(unwrapAwaitedType(promisedType)) || unknownType;
                return createTypeReference(globalPromiseLikeType, [
                    promisedType
                ]);
            }
            return unknownType;
        }
        function createPromiseReturnType(func, promisedType) {
            const promiseType = createPromiseType(promisedType);
            if (promiseType === unknownType) {
                error(func, isImportCall(func) ? Diagnostics.A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option : Diagnostics.An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option);
                return errorType;
            } else if (!getGlobalPromiseConstructorSymbol(/*reportErrors*/ true)) error(func, isImportCall(func) ? Diagnostics.A_dynamic_import_call_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option : Diagnostics.An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option);
            return promiseType;
        }
        function createNewTargetExpressionType(targetType) {
            const symbol = createSymbol(0 /* None */ , "NewTargetExpression");
            const targetPropertySymbol = createSymbol(4 /* Property */ , "target", 8 /* Readonly */ );
            targetPropertySymbol.parent = symbol;
            targetPropertySymbol.links.type = targetType;
            const members = createSymbolTable([
                targetPropertySymbol
            ]);
            symbol.members = members;
            return createAnonymousType(symbol, members, emptyArray, emptyArray, emptyArray);
        }
        function getReturnTypeFromBody(func, checkMode) {
            if (!func.body) return errorType;
            const functionFlags = getFunctionFlags(func);
            const isAsync = (functionFlags & 2 /* Async */ ) !== 0;
            const isGenerator = (functionFlags & 1 /* Generator */ ) !== 0;
            let returnType;
            let yieldType;
            let nextType;
            let fallbackReturnType = voidType;
            if (func.body.kind !== 240 /* Block */ ) {
                returnType = checkExpressionCached(func.body, checkMode && checkMode & -9 /* SkipGenericFunctions */ );
                if (isAsync) returnType = unwrapAwaitedType(checkAwaitedType(returnType, /*withAlias*/ false, /*errorNode*/ func, Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member));
            } else if (isGenerator) {
                const returnTypes = checkAndAggregateReturnExpressionTypes(func, checkMode);
                if (!returnTypes) fallbackReturnType = neverType;
                else if (returnTypes.length > 0) returnType = getUnionType(returnTypes, 2 /* Subtype */ );
                const { yieldTypes: yieldTypes , nextTypes: nextTypes  } = checkAndAggregateYieldOperandTypes(func, checkMode);
                yieldType = some(yieldTypes) ? getUnionType(yieldTypes, 2 /* Subtype */ ) : void 0;
                nextType = some(nextTypes) ? getIntersectionType(nextTypes) : void 0;
            } else {
                const types = checkAndAggregateReturnExpressionTypes(func, checkMode);
                if (!types) return functionFlags & 2 /* Async */  ? createPromiseReturnType(func, neverType) : neverType;
                if (types.length === 0) {
                    const contextualReturnType = getContextualReturnType(func, /*contextFlags*/ void 0);
                    const returnType2 = contextualReturnType && (unwrapReturnType(contextualReturnType, functionFlags) || voidType).flags & 32768 /* Undefined */  ? undefinedType : voidType;
                    return functionFlags & 2 /* Async */  ? createPromiseReturnType(func, returnType2) : // Async function
                    returnType2;
                }
                returnType = getUnionType(types, 2 /* Subtype */ );
            }
            if (returnType || yieldType || nextType) {
                if (yieldType) reportErrorsFromWidening(func, yieldType, 3 /* GeneratorYield */ );
                if (returnType) reportErrorsFromWidening(func, returnType, 1 /* FunctionReturn */ );
                if (nextType) reportErrorsFromWidening(func, nextType, 2 /* GeneratorNext */ );
                if (returnType && isUnitType(returnType) || yieldType && isUnitType(yieldType) || nextType && isUnitType(nextType)) {
                    const contextualSignature = getContextualSignatureForFunctionLikeDeclaration(func);
                    const contextualType = !contextualSignature ? void 0 : contextualSignature === getSignatureFromDeclaration(func) ? isGenerator ? void 0 : returnType : instantiateContextualType(getReturnTypeOfSignature(contextualSignature), func, /*contextFlags*/ void 0);
                    if (isGenerator) {
                        yieldType = getWidenedLiteralLikeTypeForContextualIterationTypeIfNeeded(yieldType, contextualType, 0 /* Yield */ , isAsync);
                        returnType = getWidenedLiteralLikeTypeForContextualIterationTypeIfNeeded(returnType, contextualType, 1 /* Return */ , isAsync);
                        nextType = getWidenedLiteralLikeTypeForContextualIterationTypeIfNeeded(nextType, contextualType, 2 /* Next */ , isAsync);
                    } else returnType = getWidenedLiteralLikeTypeForContextualReturnTypeIfNeeded(returnType, contextualType, isAsync);
                }
                if (yieldType) yieldType = getWidenedType(yieldType);
                if (returnType) returnType = getWidenedType(returnType);
                if (nextType) nextType = getWidenedType(nextType);
            }
            if (isGenerator) return createGeneratorReturnType(yieldType || neverType, returnType || fallbackReturnType, nextType || getContextualIterationType(2 /* Next */ , func) || unknownType, isAsync);
            else return isAsync ? createPromiseType(returnType || fallbackReturnType) : returnType || fallbackReturnType;
        }
        function createGeneratorReturnType(yieldType, returnType, nextType, isAsyncGenerator) {
            const resolver = isAsyncGenerator ? asyncIterationTypesResolver : syncIterationTypesResolver;
            const globalGeneratorType = resolver.getGlobalGeneratorType(/*reportErrors*/ false);
            yieldType = resolver.resolveIterationType(yieldType, /*errorNode*/ void 0) || unknownType;
            returnType = resolver.resolveIterationType(returnType, /*errorNode*/ void 0) || unknownType;
            nextType = resolver.resolveIterationType(nextType, /*errorNode*/ void 0) || unknownType;
            if (globalGeneratorType === emptyGenericType) {
                const globalType = resolver.getGlobalIterableIteratorType(/*reportErrors*/ false);
                const iterationTypes = globalType !== emptyGenericType ? getIterationTypesOfGlobalIterableType(globalType, resolver) : void 0;
                const iterableIteratorReturnType = iterationTypes ? iterationTypes.returnType : anyType;
                const iterableIteratorNextType = iterationTypes ? iterationTypes.nextType : undefinedType;
                if (isTypeAssignableTo(returnType, iterableIteratorReturnType) && isTypeAssignableTo(iterableIteratorNextType, nextType)) {
                    if (globalType !== emptyGenericType) return createTypeFromGenericGlobalType(globalType, [
                        yieldType
                    ]);
                    resolver.getGlobalIterableIteratorType(/*reportErrors*/ true);
                    return emptyObjectType;
                }
                resolver.getGlobalGeneratorType(/*reportErrors*/ true);
                return emptyObjectType;
            }
            return createTypeFromGenericGlobalType(globalGeneratorType, [
                yieldType,
                returnType,
                nextType
            ]);
        }
        function checkAndAggregateYieldOperandTypes(func, checkMode) {
            const yieldTypes = [];
            const nextTypes = [];
            const isAsync = (getFunctionFlags(func) & 2 /* Async */ ) !== 0;
            forEachYieldExpression(func.body, (yieldExpression)=>{
                const yieldExpressionType = yieldExpression.expression ? checkExpression(yieldExpression.expression, checkMode) : undefinedWideningType;
                pushIfUnique(yieldTypes, getYieldedTypeOfYieldExpression(yieldExpression, yieldExpressionType, anyType, isAsync));
                let nextType;
                if (yieldExpression.asteriskToken) {
                    const iterationTypes = getIterationTypesOfIterable(yieldExpressionType, isAsync ? 19 /* AsyncYieldStar */  : 17 /* YieldStar */ , yieldExpression.expression);
                    nextType = iterationTypes && iterationTypes.nextType;
                } else nextType = getContextualType2(yieldExpression, /*contextFlags*/ void 0);
                if (nextType) pushIfUnique(nextTypes, nextType);
            });
            return {
                yieldTypes: yieldTypes,
                nextTypes: nextTypes
            };
        }
        function getYieldedTypeOfYieldExpression(node, expressionType, sentType, isAsync) {
            const errorNode = node.expression || node;
            const yieldedType = node.asteriskToken ? checkIteratedTypeOrElementType(isAsync ? 19 /* AsyncYieldStar */  : 17 /* YieldStar */ , expressionType, sentType, errorNode) : expressionType;
            return !isAsync ? yieldedType : getAwaitedType(yieldedType, errorNode, node.asteriskToken ? Diagnostics.Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member : Diagnostics.Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
        }
        function getNotEqualFactsFromTypeofSwitch(start, end, witnesses) {
            let facts = 0 /* None */ ;
            for(let i = 0; i < witnesses.length; i++){
                const witness = i < start || i >= end ? witnesses[i] : void 0;
                facts |= witness !== void 0 ? typeofNEFacts.get(witness) || 32768 /* TypeofNEHostObject */  : 0;
            }
            return facts;
        }
        function isExhaustiveSwitchStatement(node) {
            const links = getNodeLinks(node);
            if (links.isExhaustive === void 0) {
                links.isExhaustive = 0;
                const exhaustive = computeExhaustiveSwitchStatement(node);
                if (links.isExhaustive === 0) links.isExhaustive = exhaustive;
            } else if (links.isExhaustive === 0) links.isExhaustive = false;
            return links.isExhaustive;
        }
        function computeExhaustiveSwitchStatement(node) {
            if (node.expression.kind === 220 /* TypeOfExpression */ ) {
                const witnesses = getSwitchClauseTypeOfWitnesses(node);
                if (!witnesses) return false;
                const operandConstraint = getBaseConstraintOrType(checkExpressionCached(node.expression.expression));
                const notEqualFacts = getNotEqualFactsFromTypeofSwitch(0, 0, witnesses);
                if (operandConstraint.flags & 3 /* AnyOrUnknown */ ) return (556800 /* AllTypeofNE */  & notEqualFacts) === 556800 /* AllTypeofNE */ ;
                return !someType(operandConstraint, (t)=>(getTypeFacts(t) & notEqualFacts) === notEqualFacts);
            }
            const type = checkExpressionCached(node.expression);
            if (!isLiteralType(type)) return false;
            const switchTypes = getSwitchClauseTypes(node);
            if (!switchTypes.length || some(switchTypes, isNeitherUnitTypeNorNever)) return false;
            return eachTypeContainedIn(mapType(type, getRegularTypeOfLiteralType), switchTypes);
        }
        function functionHasImplicitReturn(func) {
            return func.endFlowNode && isReachableFlowNode(func.endFlowNode);
        }
        function checkAndAggregateReturnExpressionTypes(func, checkMode) {
            const functionFlags = getFunctionFlags(func);
            const aggregatedTypes = [];
            let hasReturnWithNoExpression = functionHasImplicitReturn(func);
            let hasReturnOfTypeNever = false;
            forEachReturnStatement(func.body, (returnStatement)=>{
                const expr = returnStatement.expression;
                if (expr) {
                    if (expr.kind === 212 /* CallExpression */  && expr.expression.kind === 80 /* Identifier */  && checkExpressionCached(expr.expression).symbol === func.symbol) {
                        hasReturnOfTypeNever = true;
                        return;
                    }
                    let type = checkExpressionCached(expr, checkMode && checkMode & -9 /* SkipGenericFunctions */ );
                    if (functionFlags & 2 /* Async */ ) type = unwrapAwaitedType(checkAwaitedType(type, /*withAlias*/ false, func, Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member));
                    if (type.flags & 131072 /* Never */ ) hasReturnOfTypeNever = true;
                    pushIfUnique(aggregatedTypes, type);
                } else hasReturnWithNoExpression = true;
            });
            if (aggregatedTypes.length === 0 && !hasReturnWithNoExpression && (hasReturnOfTypeNever || mayReturnNever(func))) return void 0;
            if (strictNullChecks && aggregatedTypes.length && hasReturnWithNoExpression && !(isJSConstructor(func) && aggregatedTypes.some((t)=>t.symbol === func.symbol))) pushIfUnique(aggregatedTypes, undefinedType);
            return aggregatedTypes;
        }
        function mayReturnNever(func) {
            switch(func.kind){
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                    return true;
                case 173 /* MethodDeclaration */ :
                    return func.parent.kind === 209 /* ObjectLiteralExpression */ ;
                default:
                    return false;
            }
        }
        function checkAllCodePathsInNonVoidFunctionReturnOrThrow(func, returnType) {
            addLazyDiagnostic(checkAllCodePathsInNonVoidFunctionReturnOrThrowDiagnostics);
            return;
            function checkAllCodePathsInNonVoidFunctionReturnOrThrowDiagnostics() {
                const functionFlags = getFunctionFlags(func);
                const type = returnType && unwrapReturnType(returnType, functionFlags);
                if (type && (maybeTypeOfKind(type, 16384 /* Void */ ) || type.flags & 32769 /* Undefined */ )) return;
                if (func.kind === 172 /* MethodSignature */  || nodeIsMissing(func.body) || func.body.kind !== 240 /* Block */  || !functionHasImplicitReturn(func)) return;
                const hasExplicitReturn = func.flags & 512 /* HasExplicitReturn */ ;
                const errorNode = getEffectiveReturnTypeNode(func) || func;
                if (type && type.flags & 131072 /* Never */ ) error(errorNode, Diagnostics.A_function_returning_never_cannot_have_a_reachable_end_point);
                else if (type && !hasExplicitReturn) error(errorNode, Diagnostics.A_function_whose_declared_type_is_neither_undefined_void_nor_any_must_return_a_value);
                else if (type && strictNullChecks && !isTypeAssignableTo(undefinedType, type)) error(errorNode, Diagnostics.Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined);
                else if (compilerOptions.noImplicitReturns) {
                    if (!type) {
                        if (!hasExplicitReturn) return;
                        const inferredReturnType = getReturnTypeOfSignature(getSignatureFromDeclaration(func));
                        if (isUnwrappedReturnTypeUndefinedVoidOrAny(func, inferredReturnType)) return;
                    }
                    error(errorNode, Diagnostics.Not_all_code_paths_return_a_value);
                }
            }
        }
        function checkFunctionExpressionOrObjectLiteralMethod(node, checkMode) {
            Debug.assert(node.kind !== 173 /* MethodDeclaration */  || isObjectLiteralMethod(node));
            checkNodeDeferred(node);
            if (isFunctionExpression(node)) checkCollisionsForDeclarationName(node, node.name);
            if (checkMode && checkMode & 4 /* SkipContextSensitive */  && isContextSensitive(node)) {
                if (!getEffectiveReturnTypeNode(node) && !hasContextSensitiveParameters(node)) {
                    const contextualSignature = getContextualSignature(node);
                    if (contextualSignature && couldContainTypeVariables(getReturnTypeOfSignature(contextualSignature))) {
                        const links = getNodeLinks(node);
                        if (links.contextFreeType) return links.contextFreeType;
                        const returnType = getReturnTypeFromBody(node, checkMode);
                        const returnOnlySignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, returnType, /*resolvedTypePredicate*/ void 0, 0, 64 /* IsNonInferrable */ );
                        const returnOnlyType = createAnonymousType(node.symbol, emptySymbols, [
                            returnOnlySignature
                        ], emptyArray, emptyArray);
                        returnOnlyType.objectFlags |= 262144 /* NonInferrableType */ ;
                        return links.contextFreeType = returnOnlyType;
                    }
                }
                return anyFunctionType;
            }
            const hasGrammarError = checkGrammarFunctionLikeDeclaration(node);
            if (!hasGrammarError && node.kind === 217 /* FunctionExpression */ ) checkGrammarForGenerator(node);
            contextuallyCheckFunctionExpressionOrObjectLiteralMethod(node, checkMode);
            return getTypeOfSymbol(getSymbolOfDeclaration(node));
        }
        function contextuallyCheckFunctionExpressionOrObjectLiteralMethod(node, checkMode) {
            const links = getNodeLinks(node);
            if (!(links.flags & 64 /* ContextChecked */ )) {
                const contextualSignature = getContextualSignature(node);
                if (!(links.flags & 64 /* ContextChecked */ )) {
                    links.flags |= 64 /* ContextChecked */ ;
                    const signature = firstOrUndefined(getSignaturesOfType(getTypeOfSymbol(getSymbolOfDeclaration(node)), 0 /* Call */ ));
                    if (!signature) return;
                    if (isContextSensitive(node)) {
                        if (contextualSignature) {
                            const inferenceContext = getInferenceContext(node);
                            let instantiatedContextualSignature;
                            if (checkMode && checkMode & 2 /* Inferential */ ) {
                                inferFromAnnotatedParameters(signature, contextualSignature, inferenceContext);
                                const restType = getEffectiveRestType(contextualSignature);
                                if (restType && restType.flags & 262144 /* TypeParameter */ ) instantiatedContextualSignature = instantiateSignature(contextualSignature, inferenceContext.nonFixingMapper);
                            }
                            instantiatedContextualSignature || (instantiatedContextualSignature = inferenceContext ? instantiateSignature(contextualSignature, inferenceContext.mapper) : contextualSignature);
                            assignContextualParameterTypes(signature, instantiatedContextualSignature);
                        } else assignNonContextualParameterTypes(signature);
                    } else if (contextualSignature && !node.typeParameters && contextualSignature.parameters.length > node.parameters.length) {
                        const inferenceContext = getInferenceContext(node);
                        if (checkMode && checkMode & 2 /* Inferential */ ) inferFromAnnotatedParameters(signature, contextualSignature, inferenceContext);
                    }
                    if (contextualSignature && !getReturnTypeFromAnnotation(node) && !signature.resolvedReturnType) {
                        const returnType = getReturnTypeFromBody(node, checkMode);
                        if (!signature.resolvedReturnType) signature.resolvedReturnType = returnType;
                    }
                    checkSignatureDeclaration(node);
                }
            }
        }
        function checkFunctionExpressionOrObjectLiteralMethodDeferred(node) {
            Debug.assert(node.kind !== 173 /* MethodDeclaration */  || isObjectLiteralMethod(node));
            const functionFlags = getFunctionFlags(node);
            const returnType = getReturnTypeFromAnnotation(node);
            checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, returnType);
            if (node.body) {
                if (!getEffectiveReturnTypeNode(node)) getReturnTypeOfSignature(getSignatureFromDeclaration(node));
                if (node.body.kind === 240 /* Block */ ) checkSourceElement(node.body);
                else {
                    const exprType = checkExpression(node.body);
                    const returnOrPromisedType = returnType && unwrapReturnType(returnType, functionFlags);
                    if (returnOrPromisedType) {
                        if ((functionFlags & 3 /* AsyncGenerator */ ) === 2 /* Async */ ) {
                            const awaitedType = checkAwaitedType(exprType, /*withAlias*/ false, node.body, Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
                            checkTypeAssignableToAndOptionallyElaborate(awaitedType, returnOrPromisedType, node.body, node.body);
                        } else checkTypeAssignableToAndOptionallyElaborate(exprType, returnOrPromisedType, node.body, node.body);
                    }
                }
            }
        }
        function checkArithmeticOperandType(operand, type, diagnostic, isAwaitValid = false) {
            if (!isTypeAssignableTo(type, numberOrBigIntType)) {
                const awaitedType = isAwaitValid && getAwaitedTypeOfPromise(type);
                errorAndMaybeSuggestAwait(operand, !!awaitedType && isTypeAssignableTo(awaitedType, numberOrBigIntType), diagnostic);
                return false;
            }
            return true;
        }
        function isReadonlyAssignmentDeclaration(d) {
            if (!isCallExpression(d)) return false;
            if (!isBindableObjectDefinePropertyCall(d)) return false;
            const objectLitType = checkExpressionCached(d.arguments[2]);
            const valueType = getTypeOfPropertyOfType(objectLitType, "value");
            if (valueType) {
                const writableProp = getPropertyOfType(objectLitType, "writable");
                const writableType = writableProp && getTypeOfSymbol(writableProp);
                if (!writableType || writableType === falseType || writableType === regularFalseType) return true;
                if (writableProp && writableProp.valueDeclaration && isPropertyAssignment(writableProp.valueDeclaration)) {
                    const initializer = writableProp.valueDeclaration.initializer;
                    const rawOriginalType = checkExpression(initializer);
                    if (rawOriginalType === falseType || rawOriginalType === regularFalseType) return true;
                }
                return false;
            }
            const setProp = getPropertyOfType(objectLitType, "set");
            return !setProp;
        }
        function isReadonlySymbol(symbol) {
            return !!(getCheckFlags(symbol) & 8 /* Readonly */  || symbol.flags & 4 /* Property */  && getDeclarationModifierFlagsFromSymbol(symbol) & 64 /* Readonly */  || symbol.flags & 3 /* Variable */  && getDeclarationNodeFlagsFromSymbol(symbol) & 2 /* Const */  || symbol.flags & 98304 /* Accessor */  && !(symbol.flags & 65536 /* SetAccessor */ ) || symbol.flags & 8 /* EnumMember */  || some(symbol.declarations, isReadonlyAssignmentDeclaration));
        }
        function isAssignmentToReadonlyEntity(expr, symbol, assignmentKind) {
            var _a, _b;
            if (assignmentKind === 0 /* None */ ) return false;
            if (isReadonlySymbol(symbol)) {
                if (symbol.flags & 4 /* Property */  && isAccessExpression(expr) && expr.expression.kind === 110 /* ThisKeyword */ ) {
                    const ctor = getContainingFunction(expr);
                    if (!(ctor && (ctor.kind === 175 /* Constructor */  || isJSConstructor(ctor)))) return true;
                    if (symbol.valueDeclaration) {
                        const isAssignmentDeclaration2 = isBinaryExpression(symbol.valueDeclaration);
                        const isLocalPropertyDeclaration = ctor.parent === symbol.valueDeclaration.parent;
                        const isLocalParameterProperty = ctor === symbol.valueDeclaration.parent;
                        const isLocalThisPropertyAssignment = isAssignmentDeclaration2 && ((_a = symbol.parent) == null ? void 0 : _a.valueDeclaration) === ctor.parent;
                        const isLocalThisPropertyAssignmentConstructorFunction = isAssignmentDeclaration2 && ((_b = symbol.parent) == null ? void 0 : _b.valueDeclaration) === ctor;
                        const isWriteableSymbol = isLocalPropertyDeclaration || isLocalParameterProperty || isLocalThisPropertyAssignment || isLocalThisPropertyAssignmentConstructorFunction;
                        return !isWriteableSymbol;
                    }
                }
                return true;
            }
            if (isAccessExpression(expr)) {
                const node = skipParentheses(expr.expression);
                if (node.kind === 80 /* Identifier */ ) {
                    const symbol2 = getNodeLinks(node).resolvedSymbol;
                    if (symbol2.flags & 2097152 /* Alias */ ) {
                        const declaration = getDeclarationOfAliasSymbol(symbol2);
                        return !!declaration && declaration.kind === 273 /* NamespaceImport */ ;
                    }
                }
            }
            return false;
        }
        function checkReferenceExpression(expr, invalidReferenceMessage, invalidOptionalChainMessage) {
            const node = skipOuterExpressions(expr, 7 /* Parentheses */ );
            if (node.kind !== 80 /* Identifier */  && !isAccessExpression(node)) {
                error(expr, invalidReferenceMessage);
                return false;
            }
            if (node.flags & 32 /* OptionalChain */ ) {
                error(expr, invalidOptionalChainMessage);
                return false;
            }
            return true;
        }
        function checkDeleteExpression(node) {
            checkExpression(node.expression);
            const expr = skipParentheses(node.expression);
            if (!isAccessExpression(expr)) {
                error(expr, Diagnostics.The_operand_of_a_delete_operator_must_be_a_property_reference);
                return booleanType;
            }
            if (isPropertyAccessExpression(expr) && isPrivateIdentifier(expr.name)) error(expr, Diagnostics.The_operand_of_a_delete_operator_cannot_be_a_private_identifier);
            const links = getNodeLinks(expr);
            const symbol = getExportSymbolOfValueSymbolIfExported(links.resolvedSymbol);
            if (symbol) {
                if (isReadonlySymbol(symbol)) error(expr, Diagnostics.The_operand_of_a_delete_operator_cannot_be_a_read_only_property);
                checkDeleteExpressionMustBeOptional(expr, symbol);
            }
            return booleanType;
        }
        function checkDeleteExpressionMustBeOptional(expr, symbol) {
            const type = getTypeOfSymbol(symbol);
            if (strictNullChecks && !(type.flags & 131075 /* Never */ ) && !(exactOptionalPropertyTypes ? symbol.flags & 16777216 /* Optional */  : getTypeFacts(type) & 16777216 /* IsUndefined */ )) error(expr, Diagnostics.The_operand_of_a_delete_operator_must_be_optional);
        }
        function checkTypeOfExpression(node) {
            checkExpression(node.expression);
            return typeofType;
        }
        function checkVoidExpression(node) {
            checkExpression(node.expression);
            return undefinedWideningType;
        }
        function checkAwaitExpressionGrammar(node) {
            const container = getContainingFunctionOrClassStaticBlock(node);
            if (container && isClassStaticBlockDeclaration(container)) error(node, Diagnostics.Await_expression_cannot_be_used_inside_a_class_static_block);
            else if (!(node.flags & 32768 /* AwaitContext */ )) {
                if (isInTopLevelContext(node)) {
                    const sourceFile = getSourceFileOfNode(node);
                    if (!hasParseDiagnostics(sourceFile)) {
                        let span;
                        if (!isEffectiveExternalModule(sourceFile, compilerOptions)) {
                            span ?? (span = getSpanOfTokenAtPosition(sourceFile, node.pos));
                            const diagnostic = createFileDiagnostic(sourceFile, span.start, span.length, Diagnostics.await_expressions_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module);
                            diagnostics.add(diagnostic);
                        }
                        switch(moduleKind){
                            case 100 /* Node16 */ :
                            case 199 /* NodeNext */ :
                                if (sourceFile.impliedNodeFormat === 1 /* CommonJS */ ) {
                                    span ?? (span = getSpanOfTokenAtPosition(sourceFile, node.pos));
                                    diagnostics.add(createFileDiagnostic(sourceFile, span.start, span.length, Diagnostics.The_current_file_is_a_CommonJS_module_and_cannot_use_await_at_the_top_level));
                                    break;
                                }
                            case 7 /* ES2022 */ :
                            case 99 /* ESNext */ :
                            case 4 /* System */ :
                                if (languageVersion >= 4 /* ES2017 */ ) break;
                            default:
                                span ?? (span = getSpanOfTokenAtPosition(sourceFile, node.pos));
                                diagnostics.add(createFileDiagnostic(sourceFile, span.start, span.length, Diagnostics.Top_level_await_expressions_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_or_nodenext_and_the_target_option_is_set_to_es2017_or_higher));
                                break;
                        }
                    }
                } else {
                    const sourceFile = getSourceFileOfNode(node);
                    if (!hasParseDiagnostics(sourceFile)) {
                        const span = getSpanOfTokenAtPosition(sourceFile, node.pos);
                        const diagnostic = createFileDiagnostic(sourceFile, span.start, span.length, Diagnostics.await_expressions_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules);
                        if (container && container.kind !== 175 /* Constructor */  && (getFunctionFlags(container) & 2 /* Async */ ) === 0) {
                            const relatedInfo = createDiagnosticForNode(container, Diagnostics.Did_you_mean_to_mark_this_function_as_async);
                            addRelatedInfo(diagnostic, relatedInfo);
                        }
                        diagnostics.add(diagnostic);
                    }
                }
            }
            if (isInParameterInitializerBeforeContainingFunction(node)) error(node, Diagnostics.await_expressions_cannot_be_used_in_a_parameter_initializer);
        }
        function checkAwaitExpression(node) {
            addLazyDiagnostic(()=>checkAwaitExpressionGrammar(node));
            const operandType = checkExpression(node.expression);
            const awaitedType = checkAwaitedType(operandType, /*withAlias*/ true, node, Diagnostics.Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
            if (awaitedType === operandType && !isErrorType(awaitedType) && !(operandType.flags & 3 /* AnyOrUnknown */ )) addErrorOrSuggestion(/*isError*/ false, createDiagnosticForNode(node, Diagnostics.await_has_no_effect_on_the_type_of_this_expression));
            return awaitedType;
        }
        function checkPrefixUnaryExpression(node) {
            const operandType = checkExpression(node.operand);
            if (operandType === silentNeverType) return silentNeverType;
            switch(node.operand.kind){
                case 9 /* NumericLiteral */ :
                    switch(node.operator){
                        case 41 /* MinusToken */ :
                            return getFreshTypeOfLiteralType(getNumberLiteralType(-node.operand.text));
                        case 40 /* PlusToken */ :
                            return getFreshTypeOfLiteralType(getNumberLiteralType(+node.operand.text));
                    }
                    break;
                case 10 /* BigIntLiteral */ :
                    if (node.operator === 41 /* MinusToken */ ) return getFreshTypeOfLiteralType(getBigIntLiteralType({
                        negative: true,
                        base10Value: parsePseudoBigInt(node.operand.text)
                    }));
            }
            switch(node.operator){
                case 40 /* PlusToken */ :
                case 41 /* MinusToken */ :
                case 55 /* TildeToken */ :
                    checkNonNullType(operandType, node.operand);
                    if (maybeTypeOfKindConsideringBaseConstraint(operandType, 12288 /* ESSymbolLike */ )) error(node.operand, Diagnostics.The_0_operator_cannot_be_applied_to_type_symbol, tokenToString(node.operator));
                    if (node.operator === 40 /* PlusToken */ ) {
                        if (maybeTypeOfKindConsideringBaseConstraint(operandType, 2112 /* BigIntLike */ )) error(node.operand, Diagnostics.Operator_0_cannot_be_applied_to_type_1, tokenToString(node.operator), typeToString(getBaseTypeOfLiteralType(operandType)));
                        return numberType;
                    }
                    return getUnaryResultType(operandType);
                case 54 /* ExclamationToken */ :
                    checkTruthinessOfType(operandType, node.operand);
                    const facts = getTypeFacts(operandType) & 12582912 /* Falsy */ ;
                    return facts === 4194304 /* Truthy */  ? falseType : facts === 8388608 /* Falsy */  ? trueType : booleanType;
                case 46 /* PlusPlusToken */ :
                case 47 /* MinusMinusToken */ :
                    const ok = checkArithmeticOperandType(node.operand, checkNonNullType(operandType, node.operand), Diagnostics.An_arithmetic_operand_must_be_of_type_any_number_bigint_or_an_enum_type);
                    if (ok) checkReferenceExpression(node.operand, Diagnostics.The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access, Diagnostics.The_operand_of_an_increment_or_decrement_operator_may_not_be_an_optional_property_access);
                    return getUnaryResultType(operandType);
            }
            return errorType;
        }
        function checkPostfixUnaryExpression(node) {
            const operandType = checkExpression(node.operand);
            if (operandType === silentNeverType) return silentNeverType;
            const ok = checkArithmeticOperandType(node.operand, checkNonNullType(operandType, node.operand), Diagnostics.An_arithmetic_operand_must_be_of_type_any_number_bigint_or_an_enum_type);
            if (ok) checkReferenceExpression(node.operand, Diagnostics.The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access, Diagnostics.The_operand_of_an_increment_or_decrement_operator_may_not_be_an_optional_property_access);
            return getUnaryResultType(operandType);
        }
        function getUnaryResultType(operandType) {
            if (maybeTypeOfKind(operandType, 2112 /* BigIntLike */ )) return isTypeAssignableToKind(operandType, 3 /* AnyOrUnknown */ ) || maybeTypeOfKind(operandType, 296 /* NumberLike */ ) ? numberOrBigIntType : bigintType;
            return numberType;
        }
        function maybeTypeOfKindConsideringBaseConstraint(type, kind) {
            if (maybeTypeOfKind(type, kind)) return true;
            const baseConstraint = getBaseConstraintOrType(type);
            return !!baseConstraint && maybeTypeOfKind(baseConstraint, kind);
        }
        function maybeTypeOfKind(type, kind) {
            if (type.flags & kind) return true;
            if (type.flags & 3145728 /* UnionOrIntersection */ ) {
                const types = type.types;
                for (const t of types){
                    if (maybeTypeOfKind(t, kind)) return true;
                }
            }
            return false;
        }
        function isTypeAssignableToKind(source, kind, strict) {
            if (source.flags & kind) return true;
            if (strict && source.flags & 114691 /* Null */ ) return false;
            return !!(kind & 296 /* NumberLike */ ) && isTypeAssignableTo(source, numberType) || !!(kind & 2112 /* BigIntLike */ ) && isTypeAssignableTo(source, bigintType) || !!(kind & 402653316 /* StringLike */ ) && isTypeAssignableTo(source, stringType) || !!(kind & 528 /* BooleanLike */ ) && isTypeAssignableTo(source, booleanType) || !!(kind & 16384 /* Void */ ) && isTypeAssignableTo(source, voidType) || !!(kind & 131072 /* Never */ ) && isTypeAssignableTo(source, neverType) || !!(kind & 65536 /* Null */ ) && isTypeAssignableTo(source, nullType) || !!(kind & 32768 /* Undefined */ ) && isTypeAssignableTo(source, undefinedType) || !!(kind & 4096 /* ESSymbol */ ) && isTypeAssignableTo(source, esSymbolType) || !!(kind & 67108864 /* NonPrimitive */ ) && isTypeAssignableTo(source, nonPrimitiveType);
        }
        function allTypesAssignableToKind(source, kind, strict) {
            return source.flags & 1048576 /* Union */  ? every(source.types, (subType)=>allTypesAssignableToKind(subType, kind, strict)) : isTypeAssignableToKind(source, kind, strict);
        }
        function isConstEnumObjectType(type) {
            return !!(getObjectFlags(type) & 16 /* Anonymous */ ) && !!type.symbol && isConstEnumSymbol(type.symbol);
        }
        function isConstEnumSymbol(symbol) {
            return (symbol.flags & 128 /* ConstEnum */ ) !== 0;
        }
        function checkInstanceOfExpression(left, right, leftType, rightType) {
            if (leftType === silentNeverType || rightType === silentNeverType) return silentNeverType;
            if (!isTypeAny(leftType) && allTypesAssignableToKind(leftType, 402784252 /* Primitive */ )) error(left, Diagnostics.The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_parameter);
            if (!(isTypeAny(rightType) || typeHasCallOrConstructSignatures(rightType) || isTypeSubtypeOf(rightType, globalFunctionType))) error(right, Diagnostics.The_right_hand_side_of_an_instanceof_expression_must_be_of_type_any_or_of_a_type_assignable_to_the_Function_interface_type);
            return booleanType;
        }
        function hasEmptyObjectIntersection(type) {
            return someType(type, (t)=>t === unknownEmptyObjectType || !!(t.flags & 2097152 /* Intersection */ ) && isEmptyAnonymousObjectType(getBaseConstraintOrType(t)));
        }
        function checkInExpression(left, right, leftType, rightType) {
            if (leftType === silentNeverType || rightType === silentNeverType) return silentNeverType;
            if (isPrivateIdentifier(left)) {
                if (languageVersion < 99 /* ESNext */ ) checkExternalEmitHelpers(left, 2097152 /* ClassPrivateFieldIn */ );
                if (!getNodeLinks(left).resolvedSymbol && getContainingClass(left)) {
                    const isUncheckedJS = isUncheckedJSSuggestion(left, rightType.symbol, /*excludeClasses*/ true);
                    reportNonexistentProperty(left, rightType, isUncheckedJS);
                }
            } else checkTypeAssignableTo(checkNonNullType(leftType, left), stringNumberSymbolType, left);
            if (checkTypeAssignableTo(checkNonNullType(rightType, right), nonPrimitiveType, right)) {
                if (hasEmptyObjectIntersection(rightType)) error(right, Diagnostics.Type_0_may_represent_a_primitive_value_which_is_not_permitted_as_the_right_operand_of_the_in_operator, typeToString(rightType));
            }
            return booleanType;
        }
        function checkObjectLiteralAssignment(node, sourceType, rightIsThis) {
            const properties = node.properties;
            if (strictNullChecks && properties.length === 0) return checkNonNullType(sourceType, node);
            for(let i = 0; i < properties.length; i++)checkObjectLiteralDestructuringPropertyAssignment(node, sourceType, i, properties, rightIsThis);
            return sourceType;
        }
        function checkObjectLiteralDestructuringPropertyAssignment(node, objectLiteralType, propertyIndex, allProperties, rightIsThis = false) {
            const properties = node.properties;
            const property = properties[propertyIndex];
            if (property.kind === 302 /* PropertyAssignment */  || property.kind === 303 /* ShorthandPropertyAssignment */ ) {
                const name = property.name;
                const exprType = getLiteralTypeFromPropertyName(name);
                if (isTypeUsableAsPropertyName(exprType)) {
                    const text = getPropertyNameFromType(exprType);
                    const prop = getPropertyOfType(objectLiteralType, text);
                    if (prop) {
                        markPropertyAsReferenced(prop, property, rightIsThis);
                        checkPropertyAccessibility(property, /*isSuper*/ false, /*writing*/ true, objectLiteralType, prop);
                    }
                }
                const elementType = getIndexedAccessType(objectLiteralType, exprType, 32 /* ExpressionPosition */ , name);
                const type = getFlowTypeOfDestructuring(property, elementType);
                return checkDestructuringAssignment(property.kind === 303 /* ShorthandPropertyAssignment */  ? property : property.initializer, type);
            } else if (property.kind === 304 /* SpreadAssignment */ ) {
                if (propertyIndex < properties.length - 1) error(property, Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern);
                else {
                    if (languageVersion < 99 /* ESNext */ ) checkExternalEmitHelpers(property, 4 /* Rest */ );
                    const nonRestNames = [];
                    if (allProperties) {
                        for (const otherProperty of allProperties)if (!isSpreadAssignment(otherProperty)) nonRestNames.push(otherProperty.name);
                    }
                    const type = getRestType(objectLiteralType, nonRestNames, objectLiteralType.symbol);
                    checkGrammarForDisallowedTrailingComma(allProperties, Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
                    return checkDestructuringAssignment(property.expression, type);
                }
            } else error(property, Diagnostics.Property_assignment_expected);
        }
        function checkArrayLiteralAssignment(node, sourceType, checkMode) {
            const elements = node.elements;
            if (languageVersion < 2 /* ES2015 */  && compilerOptions.downlevelIteration) checkExternalEmitHelpers(node, 512 /* Read */ );
            const possiblyOutOfBoundsType = checkIteratedTypeOrElementType(193 /* PossiblyOutOfBounds */ , sourceType, undefinedType, node) || errorType;
            let inBoundsType = compilerOptions.noUncheckedIndexedAccess ? void 0 : possiblyOutOfBoundsType;
            for(let i = 0; i < elements.length; i++){
                let type = possiblyOutOfBoundsType;
                if (node.elements[i].kind === 229 /* SpreadElement */ ) type = inBoundsType = inBoundsType ?? (checkIteratedTypeOrElementType(65 /* Destructuring */ , sourceType, undefinedType, node) || errorType);
                checkArrayLiteralDestructuringElementAssignment(node, sourceType, i, type, checkMode);
            }
            return sourceType;
        }
        function checkArrayLiteralDestructuringElementAssignment(node, sourceType, elementIndex, elementType, checkMode) {
            const elements = node.elements;
            const element = elements[elementIndex];
            if (element.kind !== 231 /* OmittedExpression */ ) {
                if (element.kind !== 229 /* SpreadElement */ ) {
                    const indexType = getNumberLiteralType(elementIndex);
                    if (isArrayLikeType(sourceType)) {
                        const accessFlags = 32 /* ExpressionPosition */  | (hasDefaultValue(element) ? 16 /* NoTupleBoundsCheck */  : 0);
                        const elementType2 = getIndexedAccessTypeOrUndefined(sourceType, indexType, accessFlags, createSyntheticExpression(element, indexType)) || errorType;
                        const assignedType = hasDefaultValue(element) ? getTypeWithFacts(elementType2, 524288 /* NEUndefined */ ) : elementType2;
                        const type = getFlowTypeOfDestructuring(element, assignedType);
                        return checkDestructuringAssignment(element, type, checkMode);
                    }
                    return checkDestructuringAssignment(element, elementType, checkMode);
                }
                if (elementIndex < elements.length - 1) error(element, Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern);
                else {
                    const restExpression = element.expression;
                    if (restExpression.kind === 225 /* BinaryExpression */  && restExpression.operatorToken.kind === 64 /* EqualsToken */ ) error(restExpression.operatorToken, Diagnostics.A_rest_element_cannot_have_an_initializer);
                    else {
                        checkGrammarForDisallowedTrailingComma(node.elements, Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
                        const type = everyType(sourceType, isTupleType) ? mapType(sourceType, (t)=>sliceTupleType(t, elementIndex)) : createArrayType(elementType);
                        return checkDestructuringAssignment(restExpression, type, checkMode);
                    }
                }
            }
            return void 0;
        }
        function checkDestructuringAssignment(exprOrAssignment, sourceType, checkMode, rightIsThis) {
            let target;
            if (exprOrAssignment.kind === 303 /* ShorthandPropertyAssignment */ ) {
                const prop = exprOrAssignment;
                if (prop.objectAssignmentInitializer) {
                    if (strictNullChecks && !(getTypeFacts(checkExpression(prop.objectAssignmentInitializer)) & 16777216 /* IsUndefined */ )) sourceType = getTypeWithFacts(sourceType, 524288 /* NEUndefined */ );
                    checkBinaryLikeExpression(prop.name, prop.equalsToken, prop.objectAssignmentInitializer, checkMode);
                }
                target = exprOrAssignment.name;
            } else target = exprOrAssignment;
            if (target.kind === 225 /* BinaryExpression */  && target.operatorToken.kind === 64 /* EqualsToken */ ) {
                checkBinaryExpression(target, checkMode);
                target = target.left;
                if (strictNullChecks) sourceType = getTypeWithFacts(sourceType, 524288 /* NEUndefined */ );
            }
            if (target.kind === 209 /* ObjectLiteralExpression */ ) return checkObjectLiteralAssignment(target, sourceType, rightIsThis);
            if (target.kind === 208 /* ArrayLiteralExpression */ ) return checkArrayLiteralAssignment(target, sourceType, checkMode);
            return checkReferenceAssignment(target, sourceType, checkMode);
        }
        function checkReferenceAssignment(target, sourceType, checkMode) {
            const targetType = checkExpression(target, checkMode);
            const error2 = target.parent.kind === 304 /* SpreadAssignment */  ? Diagnostics.The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access : Diagnostics.The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access;
            const optionalError = target.parent.kind === 304 /* SpreadAssignment */  ? Diagnostics.The_target_of_an_object_rest_assignment_may_not_be_an_optional_property_access : Diagnostics.The_left_hand_side_of_an_assignment_expression_may_not_be_an_optional_property_access;
            if (checkReferenceExpression(target, error2, optionalError)) checkTypeAssignableToAndOptionallyElaborate(sourceType, targetType, target, target);
            if (isPrivateIdentifierPropertyAccessExpression(target)) checkExternalEmitHelpers(target.parent, 1048576 /* ClassPrivateFieldSet */ );
            return sourceType;
        }
        function isSideEffectFree(node) {
            node = skipParentheses(node);
            switch(node.kind){
                case 80 /* Identifier */ :
                case 11 /* StringLiteral */ :
                case 14 /* RegularExpressionLiteral */ :
                case 214 /* TaggedTemplateExpression */ :
                case 227 /* TemplateExpression */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 106 /* NullKeyword */ :
                case 157 /* UndefinedKeyword */ :
                case 217 /* FunctionExpression */ :
                case 230 /* ClassExpression */ :
                case 218 /* ArrowFunction */ :
                case 208 /* ArrayLiteralExpression */ :
                case 209 /* ObjectLiteralExpression */ :
                case 220 /* TypeOfExpression */ :
                case 234 /* NonNullExpression */ :
                case 284 /* JsxSelfClosingElement */ :
                case 283 /* JsxElement */ :
                    return true;
                case 226 /* ConditionalExpression */ :
                    return isSideEffectFree(node.whenTrue) && isSideEffectFree(node.whenFalse);
                case 225 /* BinaryExpression */ :
                    if (isAssignmentOperator(node.operatorToken.kind)) return false;
                    return isSideEffectFree(node.left) && isSideEffectFree(node.right);
                case 223 /* PrefixUnaryExpression */ :
                case 224 /* PostfixUnaryExpression */ :
                    switch(node.operator){
                        case 54 /* ExclamationToken */ :
                        case 40 /* PlusToken */ :
                        case 41 /* MinusToken */ :
                        case 55 /* TildeToken */ :
                            return true;
                    }
                    return false;
                case 221 /* VoidExpression */ :
                case 215 /* TypeAssertionExpression */ :
                case 233 /* AsExpression */ :
                default:
                    return false;
            }
        }
        function isTypeEqualityComparableTo(source, target) {
            return (target.flags & 98304 /* Nullable */ ) !== 0 || isTypeComparableTo(source, target);
        }
        function createCheckBinaryExpression() {
            const trampoline = createBinaryExpressionTrampoline(onEnter, onLeft, onOperator, onRight, onExit, foldState);
            return (node, checkMode)=>{
                const result = trampoline(node, checkMode);
                Debug.assertIsDefined(result);
                return result;
            };
            function onEnter(node, state, checkMode) {
                if (state) {
                    state.stackIndex++;
                    state.skip = false;
                    setLeftType(state, /*type*/ void 0);
                    setLastResult(state, /*type*/ void 0);
                } else state = {
                    checkMode: checkMode,
                    skip: false,
                    stackIndex: 0,
                    typeStack: [
                        void 0,
                        void 0
                    ]
                };
                if (isInJSFile(node) && getAssignedExpandoInitializer(node)) {
                    state.skip = true;
                    setLastResult(state, checkExpression(node.right, checkMode));
                    return state;
                }
                checkGrammarNullishCoalesceWithLogicalExpression(node);
                const operator = node.operatorToken.kind;
                if (operator === 64 /* EqualsToken */  && (node.left.kind === 209 /* ObjectLiteralExpression */  || node.left.kind === 208 /* ArrayLiteralExpression */ )) {
                    state.skip = true;
                    setLastResult(state, checkDestructuringAssignment(node.left, checkExpression(node.right, checkMode), checkMode, node.right.kind === 110 /* ThisKeyword */ ));
                    return state;
                }
                return state;
            }
            function onLeft(left, state, _node) {
                if (!state.skip) return maybeCheckExpression(state, left);
            }
            function onOperator(operatorToken, state, node) {
                if (!state.skip) {
                    const leftType = getLastResult(state);
                    Debug.assertIsDefined(leftType);
                    setLeftType(state, leftType);
                    setLastResult(state, /*type*/ void 0);
                    const operator = operatorToken.kind;
                    if (isLogicalOrCoalescingBinaryOperator(operator)) {
                        let parent2 = node.parent;
                        while(parent2.kind === 216 /* ParenthesizedExpression */  || isLogicalOrCoalescingBinaryExpression(parent2))parent2 = parent2.parent;
                        if (operator === 56 /* AmpersandAmpersandToken */  || isIfStatement(parent2)) checkTestingKnownTruthyCallableOrAwaitableType(node.left, leftType, isIfStatement(parent2) ? parent2.thenStatement : void 0);
                        checkTruthinessOfType(leftType, node.left);
                    }
                }
            }
            function onRight(right, state, _node) {
                if (!state.skip) return maybeCheckExpression(state, right);
            }
            function onExit(node, state) {
                let result;
                if (state.skip) result = getLastResult(state);
                else {
                    const leftType = getLeftType(state);
                    Debug.assertIsDefined(leftType);
                    const rightType = getLastResult(state);
                    Debug.assertIsDefined(rightType);
                    result = checkBinaryLikeExpressionWorker(node.left, node.operatorToken, node.right, leftType, rightType, node);
                }
                state.skip = false;
                setLeftType(state, /*type*/ void 0);
                setLastResult(state, /*type*/ void 0);
                state.stackIndex--;
                return result;
            }
            function foldState(state, result, _side) {
                setLastResult(state, result);
                return state;
            }
            function maybeCheckExpression(state, node) {
                if (isBinaryExpression(node)) return node;
                setLastResult(state, checkExpression(node, state.checkMode));
            }
            function getLeftType(state) {
                return state.typeStack[state.stackIndex];
            }
            function setLeftType(state, type) {
                state.typeStack[state.stackIndex] = type;
            }
            function getLastResult(state) {
                return state.typeStack[state.stackIndex + 1];
            }
            function setLastResult(state, type) {
                state.typeStack[state.stackIndex + 1] = type;
            }
        }
        function checkGrammarNullishCoalesceWithLogicalExpression(node) {
            const { left: left , operatorToken: operatorToken , right: right  } = node;
            if (operatorToken.kind === 61 /* QuestionQuestionToken */ ) {
                if (isBinaryExpression(left) && (left.operatorToken.kind === 57 /* BarBarToken */  || left.operatorToken.kind === 56 /* AmpersandAmpersandToken */ )) grammarErrorOnNode(left, Diagnostics._0_and_1_operations_cannot_be_mixed_without_parentheses, tokenToString(left.operatorToken.kind), tokenToString(operatorToken.kind));
                if (isBinaryExpression(right) && (right.operatorToken.kind === 57 /* BarBarToken */  || right.operatorToken.kind === 56 /* AmpersandAmpersandToken */ )) grammarErrorOnNode(right, Diagnostics._0_and_1_operations_cannot_be_mixed_without_parentheses, tokenToString(right.operatorToken.kind), tokenToString(operatorToken.kind));
            }
        }
        function checkBinaryLikeExpression(left, operatorToken, right, checkMode, errorNode) {
            const operator = operatorToken.kind;
            if (operator === 64 /* EqualsToken */  && (left.kind === 209 /* ObjectLiteralExpression */  || left.kind === 208 /* ArrayLiteralExpression */ )) return checkDestructuringAssignment(left, checkExpression(right, checkMode), checkMode, right.kind === 110 /* ThisKeyword */ );
            let leftType;
            if (isLogicalOrCoalescingBinaryOperator(operator)) leftType = checkTruthinessExpression(left, checkMode);
            else leftType = checkExpression(left, checkMode);
            const rightType = checkExpression(right, checkMode);
            return checkBinaryLikeExpressionWorker(left, operatorToken, right, leftType, rightType, errorNode);
        }
        function checkBinaryLikeExpressionWorker(left, operatorToken, right, leftType, rightType, errorNode) {
            const operator = operatorToken.kind;
            switch(operator){
                case 42 /* AsteriskToken */ :
                case 43 /* AsteriskAsteriskToken */ :
                case 67 /* AsteriskEqualsToken */ :
                case 68 /* AsteriskAsteriskEqualsToken */ :
                case 44 /* SlashToken */ :
                case 69 /* SlashEqualsToken */ :
                case 45 /* PercentToken */ :
                case 70 /* PercentEqualsToken */ :
                case 41 /* MinusToken */ :
                case 66 /* MinusEqualsToken */ :
                case 48 /* LessThanLessThanToken */ :
                case 71 /* LessThanLessThanEqualsToken */ :
                case 49 /* GreaterThanGreaterThanToken */ :
                case 72 /* GreaterThanGreaterThanEqualsToken */ :
                case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                case 52 /* BarToken */ :
                case 75 /* BarEqualsToken */ :
                case 53 /* CaretToken */ :
                case 79 /* CaretEqualsToken */ :
                case 51 /* AmpersandToken */ :
                case 74 /* AmpersandEqualsToken */ :
                    if (leftType === silentNeverType || rightType === silentNeverType) return silentNeverType;
                    leftType = checkNonNullType(leftType, left);
                    rightType = checkNonNullType(rightType, right);
                    let suggestedOperator;
                    if (leftType.flags & 528 /* BooleanLike */  && rightType.flags & 528 /* BooleanLike */  && (suggestedOperator = getSuggestedBooleanOperator(operatorToken.kind)) !== void 0) {
                        error(errorNode || operatorToken, Diagnostics.The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead, tokenToString(operatorToken.kind), tokenToString(suggestedOperator));
                        return numberType;
                    } else {
                        const leftOk = checkArithmeticOperandType(left, leftType, Diagnostics.The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type, /*isAwaitValid*/ true);
                        const rightOk = checkArithmeticOperandType(right, rightType, Diagnostics.The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type, /*isAwaitValid*/ true);
                        let resultType2;
                        if (isTypeAssignableToKind(leftType, 3 /* AnyOrUnknown */ ) && isTypeAssignableToKind(rightType, 3 /* AnyOrUnknown */ ) || // Or, if neither could be bigint, implicit coercion results in a number result
                        !(maybeTypeOfKind(leftType, 2112 /* BigIntLike */ ) || maybeTypeOfKind(rightType, 2112 /* BigIntLike */ ))) resultType2 = numberType;
                        else if (bothAreBigIntLike(leftType, rightType)) {
                            switch(operator){
                                case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                                case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                                    reportOperatorError();
                                    break;
                                case 43 /* AsteriskAsteriskToken */ :
                                case 68 /* AsteriskAsteriskEqualsToken */ :
                                    if (languageVersion < 3 /* ES2016 */ ) error(errorNode, Diagnostics.Exponentiation_cannot_be_performed_on_bigint_values_unless_the_target_option_is_set_to_es2016_or_later);
                            }
                            resultType2 = bigintType;
                        } else {
                            reportOperatorError(bothAreBigIntLike);
                            resultType2 = errorType;
                        }
                        if (leftOk && rightOk) checkAssignmentOperator(resultType2);
                        return resultType2;
                    }
                case 40 /* PlusToken */ :
                case 65 /* PlusEqualsToken */ :
                    if (leftType === silentNeverType || rightType === silentNeverType) return silentNeverType;
                    if (!isTypeAssignableToKind(leftType, 402653316 /* StringLike */ ) && !isTypeAssignableToKind(rightType, 402653316 /* StringLike */ )) {
                        leftType = checkNonNullType(leftType, left);
                        rightType = checkNonNullType(rightType, right);
                    }
                    let resultType;
                    if (isTypeAssignableToKind(leftType, 296 /* NumberLike */ , /*strict*/ true) && isTypeAssignableToKind(rightType, 296 /* NumberLike */ , /*strict*/ true)) resultType = numberType;
                    else if (isTypeAssignableToKind(leftType, 2112 /* BigIntLike */ , /*strict*/ true) && isTypeAssignableToKind(rightType, 2112 /* BigIntLike */ , /*strict*/ true)) resultType = bigintType;
                    else if (isTypeAssignableToKind(leftType, 402653316 /* StringLike */ , /*strict*/ true) || isTypeAssignableToKind(rightType, 402653316 /* StringLike */ , /*strict*/ true)) resultType = stringType;
                    else if (isTypeAny(leftType) || isTypeAny(rightType)) resultType = isErrorType(leftType) || isErrorType(rightType) ? errorType : anyType;
                    if (resultType && !checkForDisallowedESSymbolOperand(operator)) return resultType;
                    if (!resultType) {
                        const closeEnoughKind = 402655727 /* AnyOrUnknown */ ;
                        reportOperatorError((left2, right2)=>isTypeAssignableToKind(left2, closeEnoughKind) && isTypeAssignableToKind(right2, closeEnoughKind));
                        return anyType;
                    }
                    if (operator === 65 /* PlusEqualsToken */ ) checkAssignmentOperator(resultType);
                    return resultType;
                case 30 /* LessThanToken */ :
                case 32 /* GreaterThanToken */ :
                case 33 /* LessThanEqualsToken */ :
                case 34 /* GreaterThanEqualsToken */ :
                    if (checkForDisallowedESSymbolOperand(operator)) {
                        leftType = getBaseTypeOfLiteralTypeForComparison(checkNonNullType(leftType, left));
                        rightType = getBaseTypeOfLiteralTypeForComparison(checkNonNullType(rightType, right));
                        reportOperatorErrorUnless((left2, right2)=>{
                            if (isTypeAny(left2) || isTypeAny(right2)) return true;
                            const leftAssignableToNumber = isTypeAssignableTo(left2, numberOrBigIntType);
                            const rightAssignableToNumber = isTypeAssignableTo(right2, numberOrBigIntType);
                            return leftAssignableToNumber && rightAssignableToNumber || !leftAssignableToNumber && !rightAssignableToNumber && areTypesComparable(left2, right2);
                        });
                    }
                    return booleanType;
                case 35 /* EqualsEqualsToken */ :
                case 36 /* ExclamationEqualsToken */ :
                case 37 /* EqualsEqualsEqualsToken */ :
                case 38 /* ExclamationEqualsEqualsToken */ :
                    if (isLiteralExpressionOfObject(left) || isLiteralExpressionOfObject(right)) {
                        const eqType = operator === 35 /* EqualsEqualsToken */  || operator === 37 /* EqualsEqualsEqualsToken */ ;
                        error(errorNode, Diagnostics.This_condition_will_always_return_0_since_JavaScript_compares_objects_by_reference_not_value, eqType ? "false" : "true");
                    }
                    checkNaNEquality(errorNode, operator, left, right);
                    reportOperatorErrorUnless((left2, right2)=>isTypeEqualityComparableTo(left2, right2) || isTypeEqualityComparableTo(right2, left2));
                    return booleanType;
                case 104 /* InstanceOfKeyword */ :
                    return checkInstanceOfExpression(left, right, leftType, rightType);
                case 103 /* InKeyword */ :
                    return checkInExpression(left, right, leftType, rightType);
                case 56 /* AmpersandAmpersandToken */ :
                case 77 /* AmpersandAmpersandEqualsToken */ :
                    {
                        const resultType2 = getTypeFacts(leftType) & 4194304 /* Truthy */  ? getUnionType([
                            extractDefinitelyFalsyTypes(strictNullChecks ? leftType : getBaseTypeOfLiteralType(rightType)),
                            rightType
                        ]) : leftType;
                        if (operator === 77 /* AmpersandAmpersandEqualsToken */ ) checkAssignmentOperator(rightType);
                        return resultType2;
                    }
                case 57 /* BarBarToken */ :
                case 76 /* BarBarEqualsToken */ :
                    {
                        const resultType2 = getTypeFacts(leftType) & 8388608 /* Falsy */  ? getUnionType([
                            getNonNullableType(removeDefinitelyFalsyTypes(leftType)),
                            rightType
                        ], 2 /* Subtype */ ) : leftType;
                        if (operator === 76 /* BarBarEqualsToken */ ) checkAssignmentOperator(rightType);
                        return resultType2;
                    }
                case 61 /* QuestionQuestionToken */ :
                case 78 /* QuestionQuestionEqualsToken */ :
                    {
                        const resultType2 = getTypeFacts(leftType) & 262144 /* EQUndefinedOrNull */  ? getUnionType([
                            getNonNullableType(leftType),
                            rightType
                        ], 2 /* Subtype */ ) : leftType;
                        if (operator === 78 /* QuestionQuestionEqualsToken */ ) checkAssignmentOperator(rightType);
                        return resultType2;
                    }
                case 64 /* EqualsToken */ :
                    const declKind = isBinaryExpression(left.parent) ? getAssignmentDeclarationKind(left.parent) : 0 /* None */ ;
                    checkAssignmentDeclaration(declKind, rightType);
                    if (isAssignmentDeclaration2(declKind)) {
                        if (!(rightType.flags & 524288 /* Object */ ) || declKind !== 2 /* ModuleExports */  && declKind !== 6 /* Prototype */  && !isEmptyObjectType(rightType) && !isFunctionObjectType(rightType) && !(getObjectFlags(rightType) & 1 /* Class */ )) checkAssignmentOperator(rightType);
                        return leftType;
                    } else {
                        checkAssignmentOperator(rightType);
                        return rightType;
                    }
                case 28 /* CommaToken */ :
                    if (!compilerOptions.allowUnreachableCode && isSideEffectFree(left) && !isIndirectCall(left.parent)) {
                        const sf = getSourceFileOfNode(left);
                        const sourceText = sf.text;
                        const start = skipTrivia(sourceText, left.pos);
                        const isInDiag2657 = sf.parseDiagnostics.some((diag2)=>{
                            if (diag2.code !== Diagnostics.JSX_expressions_must_have_one_parent_element.code) return false;
                            return textSpanContainsPosition(diag2, start);
                        });
                        if (!isInDiag2657) error(left, Diagnostics.Left_side_of_comma_operator_is_unused_and_has_no_side_effects);
                    }
                    return rightType;
                default:
                    return Debug.fail();
            }
            function bothAreBigIntLike(left2, right2) {
                return isTypeAssignableToKind(left2, 2112 /* BigIntLike */ ) && isTypeAssignableToKind(right2, 2112 /* BigIntLike */ );
            }
            function checkAssignmentDeclaration(kind, rightType2) {
                if (kind === 2 /* ModuleExports */ ) for (const prop of getPropertiesOfObjectType(rightType2)){
                    const propType = getTypeOfSymbol(prop);
                    if (propType.symbol && propType.symbol.flags & 32 /* Class */ ) {
                        const name = prop.escapedName;
                        const symbol = resolveName(prop.valueDeclaration, name, 788968 /* Type */ , /*nameNotFoundMessage*/ void 0, name, /*isUse*/ false);
                        if ((symbol == null ? void 0 : symbol.declarations) && symbol.declarations.some(isJSDocTypedefTag)) {
                            addDuplicateDeclarationErrorsForSymbols(symbol, Diagnostics.Duplicate_identifier_0, unescapeLeadingUnderscores(name), prop);
                            addDuplicateDeclarationErrorsForSymbols(prop, Diagnostics.Duplicate_identifier_0, unescapeLeadingUnderscores(name), symbol);
                        }
                    }
                }
            }
            function isIndirectCall(node) {
                return node.parent.kind === 216 /* ParenthesizedExpression */  && isNumericLiteral(node.left) && node.left.text === "0" && (isCallExpression(node.parent.parent) && node.parent.parent.expression === node.parent || node.parent.parent.kind === 214 /* TaggedTemplateExpression */ ) && // special-case for "eval" because it's the only non-access case where an indirect call actually affects behavior.
                (isAccessExpression(node.right) || isIdentifier(node.right) && node.right.escapedText === "eval");
            }
            function checkForDisallowedESSymbolOperand(operator2) {
                const offendingSymbolOperand = maybeTypeOfKindConsideringBaseConstraint(leftType, 12288 /* ESSymbolLike */ ) ? left : maybeTypeOfKindConsideringBaseConstraint(rightType, 12288 /* ESSymbolLike */ ) ? right : void 0;
                if (offendingSymbolOperand) {
                    error(offendingSymbolOperand, Diagnostics.The_0_operator_cannot_be_applied_to_type_symbol, tokenToString(operator2));
                    return false;
                }
                return true;
            }
            function getSuggestedBooleanOperator(operator2) {
                switch(operator2){
                    case 52 /* BarToken */ :
                    case 75 /* BarEqualsToken */ :
                        return 57 /* BarBarToken */ ;
                    case 53 /* CaretToken */ :
                    case 79 /* CaretEqualsToken */ :
                        return 38 /* ExclamationEqualsEqualsToken */ ;
                    case 51 /* AmpersandToken */ :
                    case 74 /* AmpersandEqualsToken */ :
                        return 56 /* AmpersandAmpersandToken */ ;
                    default:
                        return void 0;
                }
            }
            function checkAssignmentOperator(valueType) {
                if (isAssignmentOperator(operator)) addLazyDiagnostic(checkAssignmentOperatorWorker);
                function checkAssignmentOperatorWorker() {
                    let assigneeType = leftType;
                    if (isCompoundAssignment(operatorToken.kind) && left.kind === 210 /* PropertyAccessExpression */ ) assigneeType = checkPropertyAccessExpression(left, /*checkMode*/ void 0, /*writeOnly*/ true);
                    if (checkReferenceExpression(left, Diagnostics.The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access, Diagnostics.The_left_hand_side_of_an_assignment_expression_may_not_be_an_optional_property_access)) {
                        let headMessage;
                        if (exactOptionalPropertyTypes && isPropertyAccessExpression(left) && maybeTypeOfKind(valueType, 32768 /* Undefined */ )) {
                            const target = getTypeOfPropertyOfType(getTypeOfExpression(left.expression), left.name.escapedText);
                            if (isExactOptionalPropertyMismatch(valueType, target)) headMessage = Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_type_of_the_target;
                        }
                        checkTypeAssignableToAndOptionallyElaborate(valueType, assigneeType, left, right, headMessage);
                    }
                }
            }
            function isAssignmentDeclaration2(kind) {
                var _a;
                switch(kind){
                    case 2 /* ModuleExports */ :
                        return true;
                    case 1 /* ExportsProperty */ :
                    case 5 /* Property */ :
                    case 6 /* Prototype */ :
                    case 3 /* PrototypeProperty */ :
                    case 4 /* ThisProperty */ :
                        const symbol = getSymbolOfNode(left);
                        const init = getAssignedExpandoInitializer(right);
                        return !!init && isObjectLiteralExpression(init) && !!((_a = symbol == null ? void 0 : symbol.exports) == null ? void 0 : _a.size);
                    default:
                        return false;
                }
            }
            function reportOperatorErrorUnless(typesAreCompatible) {
                if (!typesAreCompatible(leftType, rightType)) {
                    reportOperatorError(typesAreCompatible);
                    return true;
                }
                return false;
            }
            function reportOperatorError(isRelated) {
                let wouldWorkWithAwait = false;
                const errNode = errorNode || operatorToken;
                if (isRelated) {
                    const awaitedLeftType = getAwaitedTypeNoAlias(leftType);
                    const awaitedRightType = getAwaitedTypeNoAlias(rightType);
                    wouldWorkWithAwait = !(awaitedLeftType === leftType && awaitedRightType === rightType) && !!(awaitedLeftType && awaitedRightType) && isRelated(awaitedLeftType, awaitedRightType);
                }
                let effectiveLeft = leftType;
                let effectiveRight = rightType;
                if (!wouldWorkWithAwait && isRelated) [effectiveLeft, effectiveRight] = getBaseTypesIfUnrelated(leftType, rightType, isRelated);
                const [leftStr, rightStr] = getTypeNamesForErrorDisplay(effectiveLeft, effectiveRight);
                if (!tryGiveBetterPrimaryError(errNode, wouldWorkWithAwait, leftStr, rightStr)) errorAndMaybeSuggestAwait(errNode, wouldWorkWithAwait, Diagnostics.Operator_0_cannot_be_applied_to_types_1_and_2, tokenToString(operatorToken.kind), leftStr, rightStr);
            }
            function tryGiveBetterPrimaryError(errNode, maybeMissingAwait, leftStr, rightStr) {
                switch(operatorToken.kind){
                    case 37 /* EqualsEqualsEqualsToken */ :
                    case 35 /* EqualsEqualsToken */ :
                    case 38 /* ExclamationEqualsEqualsToken */ :
                    case 36 /* ExclamationEqualsToken */ :
                        return errorAndMaybeSuggestAwait(errNode, maybeMissingAwait, Diagnostics.This_comparison_appears_to_be_unintentional_because_the_types_0_and_1_have_no_overlap, leftStr, rightStr);
                    default:
                        return void 0;
                }
            }
            function checkNaNEquality(errorNode2, operator2, left2, right2) {
                const isLeftNaN = isGlobalNaN(skipParentheses(left2));
                const isRightNaN = isGlobalNaN(skipParentheses(right2));
                if (isLeftNaN || isRightNaN) {
                    const err = error(errorNode2, Diagnostics.This_condition_will_always_return_0, tokenToString(operator2 === 37 /* EqualsEqualsEqualsToken */  || operator2 === 35 /* EqualsEqualsToken */  ? 97 /* FalseKeyword */  : 112 /* TrueKeyword */ ));
                    if (isLeftNaN && isRightNaN) return;
                    const operatorString = operator2 === 38 /* ExclamationEqualsEqualsToken */  || operator2 === 36 /* ExclamationEqualsToken */  ? tokenToString(54 /* ExclamationToken */ ) : "";
                    const location = isLeftNaN ? right2 : left2;
                    const expression = skipParentheses(location);
                    addRelatedInfo(err, createDiagnosticForNode(location, Diagnostics.Did_you_mean_0, `${operatorString}Number.isNaN(${isEntityNameExpression(expression) ? entityNameToString(expression) : "..."})`));
                }
            }
            function isGlobalNaN(expr) {
                if (isIdentifier(expr) && expr.escapedText === "NaN") {
                    const globalNaNSymbol = getGlobalNaNSymbol();
                    return !!globalNaNSymbol && globalNaNSymbol === getResolvedSymbol(expr);
                }
                return false;
            }
        }
        function getBaseTypesIfUnrelated(leftType, rightType, isRelated) {
            let effectiveLeft = leftType;
            let effectiveRight = rightType;
            const leftBase = getBaseTypeOfLiteralType(leftType);
            const rightBase = getBaseTypeOfLiteralType(rightType);
            if (!isRelated(leftBase, rightBase)) {
                effectiveLeft = leftBase;
                effectiveRight = rightBase;
            }
            return [
                effectiveLeft,
                effectiveRight
            ];
        }
        function checkYieldExpression(node) {
            addLazyDiagnostic(checkYieldExpressionGrammar);
            const func = getContainingFunction(node);
            if (!func) return anyType;
            const functionFlags = getFunctionFlags(func);
            if (!(functionFlags & 1 /* Generator */ )) return anyType;
            const isAsync = (functionFlags & 2 /* Async */ ) !== 0;
            if (node.asteriskToken) {
                if (isAsync && languageVersion < 99 /* ESNext */ ) checkExternalEmitHelpers(node, 26624 /* AsyncDelegatorIncludes */ );
                if (!isAsync && languageVersion < 2 /* ES2015 */  && compilerOptions.downlevelIteration) checkExternalEmitHelpers(node, 256 /* Values */ );
            }
            const returnType = getReturnTypeFromAnnotation(func);
            const iterationTypes = returnType && getIterationTypesOfGeneratorFunctionReturnType(returnType, isAsync);
            const signatureYieldType = iterationTypes && iterationTypes.yieldType || anyType;
            const signatureNextType = iterationTypes && iterationTypes.nextType || anyType;
            const resolvedSignatureNextType = isAsync ? getAwaitedType(signatureNextType) || anyType : signatureNextType;
            const yieldExpressionType = node.expression ? checkExpression(node.expression) : undefinedWideningType;
            const yieldedType = getYieldedTypeOfYieldExpression(node, yieldExpressionType, resolvedSignatureNextType, isAsync);
            if (returnType && yieldedType) checkTypeAssignableToAndOptionallyElaborate(yieldedType, signatureYieldType, node.expression || node, node.expression);
            if (node.asteriskToken) {
                const use = isAsync ? 19 /* AsyncYieldStar */  : 17 /* YieldStar */ ;
                return getIterationTypeOfIterable(use, 1 /* Return */ , yieldExpressionType, node.expression) || anyType;
            } else if (returnType) return getIterationTypeOfGeneratorFunctionReturnType(2 /* Next */ , returnType, isAsync) || anyType;
            let type = getContextualIterationType(2 /* Next */ , func);
            if (!type) {
                type = anyType;
                addLazyDiagnostic(()=>{
                    if (noImplicitAny && !expressionResultIsUnused(node)) {
                        const contextualType = getContextualType2(node, /*contextFlags*/ void 0);
                        if (!contextualType || isTypeAny(contextualType)) error(node, Diagnostics.yield_expression_implicitly_results_in_an_any_type_because_its_containing_generator_lacks_a_return_type_annotation);
                    }
                });
            }
            return type;
            function checkYieldExpressionGrammar() {
                if (!(node.flags & 8192 /* YieldContext */ )) grammarErrorOnFirstToken(node, Diagnostics.A_yield_expression_is_only_allowed_in_a_generator_body);
                if (isInParameterInitializerBeforeContainingFunction(node)) error(node, Diagnostics.yield_expressions_cannot_be_used_in_a_parameter_initializer);
            }
        }
        function checkConditionalExpression(node, checkMode) {
            const type = checkTruthinessExpression(node.condition);
            checkTestingKnownTruthyCallableOrAwaitableType(node.condition, type, node.whenTrue);
            const type1 = checkExpression(node.whenTrue, checkMode);
            const type2 = checkExpression(node.whenFalse, checkMode);
            return getUnionType([
                type1,
                type2
            ], 2 /* Subtype */ );
        }
        function isTemplateLiteralContext(node) {
            const parent2 = node.parent;
            return isParenthesizedExpression(parent2) && isTemplateLiteralContext(parent2) || isElementAccessExpression(parent2) && parent2.argumentExpression === node;
        }
        function checkTemplateExpression(node) {
            const texts = [
                node.head.text
            ];
            const types = [];
            for (const span of node.templateSpans){
                const type = checkExpression(span.expression);
                if (maybeTypeOfKindConsideringBaseConstraint(type, 12288 /* ESSymbolLike */ )) error(span.expression, Diagnostics.Implicit_conversion_of_a_symbol_to_a_string_will_fail_at_runtime_Consider_wrapping_this_expression_in_String);
                texts.push(span.literal.text);
                types.push(isTypeAssignableTo(type, templateConstraintType) ? type : stringType);
            }
            return isConstContext(node) || isTemplateLiteralContext(node) || someType(getContextualType2(node, /*contextFlags*/ void 0) || unknownType, isTemplateLiteralContextualType) ? getTemplateLiteralType(texts, types) : stringType;
        }
        function isTemplateLiteralContextualType(type) {
            return !!(type.flags & 134217856 /* TemplateLiteral */  || type.flags & 58982400 /* InstantiableNonPrimitive */  && maybeTypeOfKind(getBaseConstraintOfType(type) || unknownType, 402653316 /* StringLike */ ));
        }
        function getContextNode2(node) {
            if (isJsxAttributes(node) && !isJsxSelfClosingElement(node.parent)) return node.parent.parent;
            return node;
        }
        function checkExpressionWithContextualType(node, contextualType, inferenceContext, checkMode) {
            const contextNode = getContextNode2(node);
            pushContextualType(contextNode, contextualType, /*isCache*/ false);
            pushInferenceContext(contextNode, inferenceContext);
            const type = checkExpression(node, checkMode | 1 /* Contextual */  | (inferenceContext ? 2 /* Inferential */  : 0));
            if (inferenceContext && inferenceContext.intraExpressionInferenceSites) inferenceContext.intraExpressionInferenceSites = void 0;
            const result = maybeTypeOfKind(type, 2944 /* Literal */ ) && isLiteralOfContextualType(type, instantiateContextualType(contextualType, node, /*contextFlags*/ void 0)) ? getRegularTypeOfLiteralType(type) : type;
            popInferenceContext();
            popContextualType();
            return result;
        }
        function checkExpressionCached(node, checkMode) {
            if (checkMode) return checkExpression(node, checkMode);
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const saveFlowLoopStart = flowLoopStart;
                const saveFlowTypeCache = flowTypeCache;
                flowLoopStart = flowLoopCount;
                flowTypeCache = void 0;
                links.resolvedType = checkExpression(node, checkMode);
                flowTypeCache = saveFlowTypeCache;
                flowLoopStart = saveFlowLoopStart;
            }
            return links.resolvedType;
        }
        function isTypeAssertion(node) {
            node = skipParentheses(node, /*excludeJSDocTypeAssertions*/ true);
            return node.kind === 215 /* TypeAssertionExpression */  || node.kind === 233 /* AsExpression */  || isJSDocTypeAssertion(node);
        }
        function checkDeclarationInitializer(declaration, checkMode, contextualType) {
            const initializer = getEffectiveInitializer(declaration);
            if (isInJSFile(declaration)) {
                const typeNode = tryGetJSDocSatisfiesTypeNode(declaration);
                if (typeNode) return checkSatisfiesExpressionWorker(initializer, typeNode, checkMode);
            }
            const type = getQuickTypeOfExpression(initializer) || (contextualType ? checkExpressionWithContextualType(initializer, contextualType, /*inferenceContext*/ void 0, checkMode || 0 /* Normal */ ) : checkExpressionCached(initializer, checkMode));
            return isParameter(declaration) && declaration.name.kind === 206 /* ArrayBindingPattern */  && isTupleType(type) && !type.target.hasRestElement && getTypeReferenceArity(type) < declaration.name.elements.length ? padTupleType(type, declaration.name) : type;
        }
        function padTupleType(type, pattern) {
            const patternElements = pattern.elements;
            const elementTypes = getElementTypes(type).slice();
            const elementFlags = type.target.elementFlags.slice();
            for(let i = getTypeReferenceArity(type); i < patternElements.length; i++){
                const e = patternElements[i];
                if (i < patternElements.length - 1 || !(e.kind === 207 /* BindingElement */  && e.dotDotDotToken)) {
                    elementTypes.push(!isOmittedExpression(e) && hasDefaultValue(e) ? getTypeFromBindingElement(e, /*includePatternInType*/ false, /*reportErrors*/ false) : anyType);
                    elementFlags.push(2 /* Optional */ );
                    if (!isOmittedExpression(e) && !hasDefaultValue(e)) reportImplicitAny(e, anyType);
                }
            }
            return createTupleType(elementTypes, elementFlags, type.target.readonly);
        }
        function widenTypeInferredFromInitializer(declaration, type) {
            const widened = getCombinedNodeFlags(declaration) & 2 /* Const */  || isDeclarationReadonly(declaration) ? type : getWidenedLiteralType(type);
            if (isInJSFile(declaration)) {
                if (isEmptyLiteralType(widened)) {
                    reportImplicitAny(declaration, anyType);
                    return anyType;
                } else if (isEmptyArrayLiteralType(widened)) {
                    reportImplicitAny(declaration, anyArrayType);
                    return anyArrayType;
                }
            }
            return widened;
        }
        function isLiteralOfContextualType(candidateType, contextualType) {
            if (contextualType) {
                if (contextualType.flags & 3145728 /* UnionOrIntersection */ ) {
                    const types = contextualType.types;
                    return some(types, (t)=>isLiteralOfContextualType(candidateType, t));
                }
                if (contextualType.flags & 58982400 /* InstantiableNonPrimitive */ ) {
                    const constraint = getBaseConstraintOfType(contextualType) || unknownType;
                    return maybeTypeOfKind(constraint, 4 /* String */ ) && maybeTypeOfKind(candidateType, 128 /* StringLiteral */ ) || maybeTypeOfKind(constraint, 8 /* Number */ ) && maybeTypeOfKind(candidateType, 256 /* NumberLiteral */ ) || maybeTypeOfKind(constraint, 64 /* BigInt */ ) && maybeTypeOfKind(candidateType, 2048 /* BigIntLiteral */ ) || maybeTypeOfKind(constraint, 4096 /* ESSymbol */ ) && maybeTypeOfKind(candidateType, 8192 /* UniqueESSymbol */ ) || isLiteralOfContextualType(candidateType, constraint);
                }
                return !!(contextualType.flags & 406847616 /* StringMapping */  && maybeTypeOfKind(candidateType, 128 /* StringLiteral */ ) || contextualType.flags & 256 /* NumberLiteral */  && maybeTypeOfKind(candidateType, 256 /* NumberLiteral */ ) || contextualType.flags & 2048 /* BigIntLiteral */  && maybeTypeOfKind(candidateType, 2048 /* BigIntLiteral */ ) || contextualType.flags & 512 /* BooleanLiteral */  && maybeTypeOfKind(candidateType, 512 /* BooleanLiteral */ ) || contextualType.flags & 8192 /* UniqueESSymbol */  && maybeTypeOfKind(candidateType, 8192 /* UniqueESSymbol */ ));
            }
            return false;
        }
        function isConstContext(node) {
            const parent2 = node.parent;
            return isAssertionExpression(parent2) && isConstTypeReference(parent2.type) || isJSDocTypeAssertion(parent2) && isConstTypeReference(getJSDocTypeAssertionType(parent2)) || isValidConstAssertionArgument(node) && isConstTypeVariable(getContextualType2(node, 0 /* None */ )) || (isParenthesizedExpression(parent2) || isArrayLiteralExpression(parent2) || isSpreadElement(parent2)) && isConstContext(parent2) || (isPropertyAssignment(parent2) || isShorthandPropertyAssignment(parent2) || isTemplateSpan(parent2)) && isConstContext(parent2.parent);
        }
        function checkExpressionForMutableLocation(node, checkMode, forceTuple) {
            const type = checkExpression(node, checkMode, forceTuple);
            return isConstContext(node) || isCommonJsExportedExpression(node) ? getRegularTypeOfLiteralType(type) : isTypeAssertion(node) ? type : getWidenedLiteralLikeTypeForContextualType(type, instantiateContextualType(getContextualType2(node, /*contextFlags*/ void 0), node, /*contextFlags*/ void 0));
        }
        function checkPropertyAssignment(node, checkMode) {
            if (node.name.kind === 166 /* ComputedPropertyName */ ) checkComputedPropertyName(node.name);
            return checkExpressionForMutableLocation(node.initializer, checkMode);
        }
        function checkObjectLiteralMethod(node, checkMode) {
            checkGrammarMethod(node);
            if (node.name.kind === 166 /* ComputedPropertyName */ ) checkComputedPropertyName(node.name);
            const uninstantiatedType = checkFunctionExpressionOrObjectLiteralMethod(node, checkMode);
            return instantiateTypeWithSingleGenericCallSignature(node, uninstantiatedType, checkMode);
        }
        function instantiateTypeWithSingleGenericCallSignature(node, type, checkMode) {
            if (checkMode && checkMode & 10 /* SkipGenericFunctions */ ) {
                const callSignature = getSingleSignature(type, 0 /* Call */ , /*allowMembers*/ true);
                const constructSignature = getSingleSignature(type, 1 /* Construct */ , /*allowMembers*/ true);
                const signature = callSignature || constructSignature;
                if (signature && signature.typeParameters) {
                    const contextualType = getApparentTypeOfContextualType(node, 2 /* NoConstraints */ );
                    if (contextualType) {
                        const contextualSignature = getSingleSignature(getNonNullableType(contextualType), callSignature ? 0 /* Call */  : 1 /* Construct */ , /*allowMembers*/ false);
                        if (contextualSignature && !contextualSignature.typeParameters) {
                            if (checkMode & 8 /* SkipGenericFunctions */ ) {
                                skippedGenericFunction(node, checkMode);
                                return anyFunctionType;
                            }
                            const context = getInferenceContext(node);
                            const returnType = context.signature && getReturnTypeOfSignature(context.signature);
                            const returnSignature = returnType && getSingleCallOrConstructSignature(returnType);
                            if (returnSignature && !returnSignature.typeParameters && !every(context.inferences, hasInferenceCandidates)) {
                                const uniqueTypeParameters = getUniqueTypeParameters(context, signature.typeParameters);
                                const instantiatedSignature = getSignatureInstantiationWithoutFillingInTypeArguments(signature, uniqueTypeParameters);
                                const inferences = map(context.inferences, (info)=>createInferenceInfo(info.typeParameter));
                                applyToParameterTypes(instantiatedSignature, contextualSignature, (source, target)=>{
                                    inferTypes(inferences, source, target, /*priority*/ 0, /*contravariant*/ true);
                                });
                                if (some(inferences, hasInferenceCandidates)) {
                                    applyToReturnTypes(instantiatedSignature, contextualSignature, (source, target)=>{
                                        inferTypes(inferences, source, target);
                                    });
                                    if (!hasOverlappingInferences(context.inferences, inferences)) {
                                        mergeInferences(context.inferences, inferences);
                                        context.inferredTypeParameters = concatenate(context.inferredTypeParameters, uniqueTypeParameters);
                                        return getOrCreateTypeFromSignature(instantiatedSignature);
                                    }
                                }
                            }
                            return getOrCreateTypeFromSignature(instantiateSignatureInContextOf(signature, contextualSignature, context));
                        }
                    }
                }
            }
            return type;
        }
        function skippedGenericFunction(node, checkMode) {
            if (checkMode & 2 /* Inferential */ ) {
                const context = getInferenceContext(node);
                context.flags |= 4 /* SkippedGenericFunction */ ;
            }
        }
        function hasInferenceCandidates(info) {
            return !!(info.candidates || info.contraCandidates);
        }
        function hasInferenceCandidatesOrDefault(info) {
            return !!(info.candidates || info.contraCandidates || hasTypeParameterDefault(info.typeParameter));
        }
        function hasOverlappingInferences(a, b) {
            for(let i = 0; i < a.length; i++){
                if (hasInferenceCandidates(a[i]) && hasInferenceCandidates(b[i])) return true;
            }
            return false;
        }
        function mergeInferences(target, source) {
            for(let i = 0; i < target.length; i++)if (!hasInferenceCandidates(target[i]) && hasInferenceCandidates(source[i])) target[i] = source[i];
        }
        function getUniqueTypeParameters(context, typeParameters) {
            const result = [];
            let oldTypeParameters;
            let newTypeParameters;
            for (const tp of typeParameters){
                const name = tp.symbol.escapedName;
                if (hasTypeParameterByName(context.inferredTypeParameters, name) || hasTypeParameterByName(result, name)) {
                    const newName = getUniqueTypeParameterName(concatenate(context.inferredTypeParameters, result), name);
                    const symbol = createSymbol(262144 /* TypeParameter */ , newName);
                    const newTypeParameter = createTypeParameter(symbol);
                    newTypeParameter.target = tp;
                    oldTypeParameters = append(oldTypeParameters, tp);
                    newTypeParameters = append(newTypeParameters, newTypeParameter);
                    result.push(newTypeParameter);
                } else result.push(tp);
            }
            if (newTypeParameters) {
                const mapper = createTypeMapper(oldTypeParameters, newTypeParameters);
                for (const tp of newTypeParameters)tp.mapper = mapper;
            }
            return result;
        }
        function hasTypeParameterByName(typeParameters, name) {
            return some(typeParameters, (tp)=>tp.symbol.escapedName === name);
        }
        function getUniqueTypeParameterName(typeParameters, baseName) {
            let len = baseName.length;
            while(len > 1 && baseName.charCodeAt(len - 1) >= 48 /* _0 */  && baseName.charCodeAt(len - 1) <= 57 /* _9 */ )len--;
            const s = baseName.slice(0, len);
            for(let index = 1;; index++){
                const augmentedName = s + index;
                if (!hasTypeParameterByName(typeParameters, augmentedName)) return augmentedName;
            }
        }
        function getReturnTypeOfSingleNonGenericCallSignature(funcType) {
            const signature = getSingleCallSignature(funcType);
            if (signature && !signature.typeParameters) return getReturnTypeOfSignature(signature);
        }
        function getReturnTypeOfSingleNonGenericSignatureOfCallChain(expr) {
            const funcType = checkExpression(expr.expression);
            const nonOptionalType = getOptionalExpressionType(funcType, expr.expression);
            const returnType = getReturnTypeOfSingleNonGenericCallSignature(funcType);
            return returnType && propagateOptionalTypeMarker(returnType, expr, nonOptionalType !== funcType);
        }
        function getTypeOfExpression(node) {
            const quickType = getQuickTypeOfExpression(node);
            if (quickType) return quickType;
            if (node.flags & 134217728 /* TypeCached */  && flowTypeCache) {
                const cachedType = flowTypeCache[getNodeId(node)];
                if (cachedType) return cachedType;
            }
            const startInvocationCount = flowInvocationCount;
            const type = checkExpression(node);
            if (flowInvocationCount !== startInvocationCount) {
                const cache = flowTypeCache || (flowTypeCache = []);
                cache[getNodeId(node)] = type;
                setNodeFlags(node, node.flags | 134217728 /* TypeCached */ );
            }
            return type;
        }
        function getQuickTypeOfExpression(node) {
            let expr = skipParentheses(node, /*excludeJSDocTypeAssertions*/ true);
            if (isJSDocTypeAssertion(expr)) {
                const type = getJSDocTypeAssertionType(expr);
                if (!isConstTypeReference(type)) return getTypeFromTypeNode(type);
            }
            expr = skipParentheses(node);
            if (isAwaitExpression(expr)) {
                const type = getQuickTypeOfExpression(expr.expression);
                return type ? getAwaitedType(type) : void 0;
            }
            if (isCallExpression(expr) && expr.expression.kind !== 108 /* SuperKeyword */  && !isRequireCall(expr, /*requireStringLiteralLikeArgument*/ true) && !isSymbolOrSymbolForCall(expr)) return isCallChain(expr) ? getReturnTypeOfSingleNonGenericSignatureOfCallChain(expr) : getReturnTypeOfSingleNonGenericCallSignature(checkNonNullExpression(expr.expression));
            else if (isAssertionExpression(expr) && !isConstTypeReference(expr.type)) return getTypeFromTypeNode(expr.type);
            else if (isLiteralExpression(node) || isBooleanLiteral(node)) return checkExpression(node);
            return void 0;
        }
        function getContextFreeTypeOfExpression(node) {
            const links = getNodeLinks(node);
            if (links.contextFreeType) return links.contextFreeType;
            pushContextualType(node, anyType, /*isCache*/ false);
            const type = links.contextFreeType = checkExpression(node, 4 /* SkipContextSensitive */ );
            popContextualType();
            return type;
        }
        function checkExpression(node, checkMode, forceTuple) {
            var _a, _b;
            (_a = tracing) == null || _a.push(tracing.Phase.Check, "checkExpression", {
                kind: node.kind,
                pos: node.pos,
                end: node.end,
                path: node.tracingPath
            });
            const saveCurrentNode = currentNode;
            currentNode = node;
            instantiationCount = 0;
            const uninstantiatedType = checkExpressionWorker(node, checkMode, forceTuple);
            const type = instantiateTypeWithSingleGenericCallSignature(node, uninstantiatedType, checkMode);
            if (isConstEnumObjectType(type)) checkConstEnumAccess(node, type);
            currentNode = saveCurrentNode;
            (_b = tracing) == null || _b.pop();
            return type;
        }
        function checkConstEnumAccess(node, type) {
            const ok = node.parent.kind === 210 /* PropertyAccessExpression */  && node.parent.expression === node || node.parent.kind === 211 /* ElementAccessExpression */  && node.parent.expression === node || (node.kind === 80 /* Identifier */  || node.kind === 165 /* QualifiedName */ ) && isInRightSideOfImportOrExportAssignment(node) || node.parent.kind === 185 /* TypeQuery */  && node.parent.exprName === node || node.parent.kind === 280 /* ExportSpecifier */ ;
            if (!ok) error(node, Diagnostics.const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_import_declaration_or_export_assignment_or_type_query);
            if (getIsolatedModules(compilerOptions)) {
                Debug.assert(!!(type.symbol.flags & 128 /* ConstEnum */ ));
                const constEnumDeclaration = type.symbol.valueDeclaration;
                if (constEnumDeclaration.flags & 16777216 /* Ambient */ ) error(node, Diagnostics.Cannot_access_ambient_const_enums_when_0_is_enabled, isolatedModulesLikeFlagName);
            }
        }
        function checkParenthesizedExpression(node, checkMode) {
            if (hasJSDocNodes(node)) {
                if (isJSDocSatisfiesExpression(node)) return checkSatisfiesExpressionWorker(node.expression, getJSDocSatisfiesExpressionType(node), checkMode);
                if (isJSDocTypeAssertion(node)) return checkAssertionWorker(node, checkMode);
            }
            return checkExpression(node.expression, checkMode);
        }
        function checkExpressionWorker(node, checkMode, forceTuple) {
            const kind = node.kind;
            if (cancellationToken) switch(kind){
                case 230 /* ClassExpression */ :
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                    cancellationToken.throwIfCancellationRequested();
            }
            switch(kind){
                case 80 /* Identifier */ :
                    return checkIdentifier(node, checkMode);
                case 81 /* PrivateIdentifier */ :
                    return checkPrivateIdentifierExpression(node);
                case 110 /* ThisKeyword */ :
                    return checkThisExpression(node);
                case 108 /* SuperKeyword */ :
                    return checkSuperExpression(node);
                case 106 /* NullKeyword */ :
                    return nullWideningType;
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 11 /* StringLiteral */ :
                    return hasSkipDirectInferenceFlag(node) ? anyType : getFreshTypeOfLiteralType(getStringLiteralType(node.text));
                case 9 /* NumericLiteral */ :
                    checkGrammarNumericLiteral(node);
                    return getFreshTypeOfLiteralType(getNumberLiteralType(+node.text));
                case 10 /* BigIntLiteral */ :
                    checkGrammarBigIntLiteral(node);
                    return getFreshTypeOfLiteralType(getBigIntLiteralType({
                        negative: false,
                        base10Value: parsePseudoBigInt(node.text)
                    }));
                case 112 /* TrueKeyword */ :
                    return trueType;
                case 97 /* FalseKeyword */ :
                    return falseType;
                case 227 /* TemplateExpression */ :
                    return checkTemplateExpression(node);
                case 14 /* RegularExpressionLiteral */ :
                    return globalRegExpType;
                case 208 /* ArrayLiteralExpression */ :
                    return checkArrayLiteral(node, checkMode, forceTuple);
                case 209 /* ObjectLiteralExpression */ :
                    return checkObjectLiteral(node, checkMode);
                case 210 /* PropertyAccessExpression */ :
                    return checkPropertyAccessExpression(node, checkMode);
                case 165 /* QualifiedName */ :
                    return checkQualifiedName(node, checkMode);
                case 211 /* ElementAccessExpression */ :
                    return checkIndexedAccess(node, checkMode);
                case 212 /* CallExpression */ :
                    if (node.expression.kind === 102 /* ImportKeyword */ ) return checkImportCallExpression(node);
                case 213 /* NewExpression */ :
                    return checkCallExpression(node, checkMode);
                case 214 /* TaggedTemplateExpression */ :
                    return checkTaggedTemplateExpression(node);
                case 216 /* ParenthesizedExpression */ :
                    return checkParenthesizedExpression(node, checkMode);
                case 230 /* ClassExpression */ :
                    return checkClassExpression(node);
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                    return checkFunctionExpressionOrObjectLiteralMethod(node, checkMode);
                case 220 /* TypeOfExpression */ :
                    return checkTypeOfExpression(node);
                case 215 /* TypeAssertionExpression */ :
                case 233 /* AsExpression */ :
                    return checkAssertion(node, checkMode);
                case 234 /* NonNullExpression */ :
                    return checkNonNullAssertion(node);
                case 232 /* ExpressionWithTypeArguments */ :
                    return checkExpressionWithTypeArguments(node);
                case 237 /* SatisfiesExpression */ :
                    return checkSatisfiesExpression(node);
                case 235 /* MetaProperty */ :
                    return checkMetaProperty(node);
                case 219 /* DeleteExpression */ :
                    return checkDeleteExpression(node);
                case 221 /* VoidExpression */ :
                    return checkVoidExpression(node);
                case 222 /* AwaitExpression */ :
                    return checkAwaitExpression(node);
                case 223 /* PrefixUnaryExpression */ :
                    return checkPrefixUnaryExpression(node);
                case 224 /* PostfixUnaryExpression */ :
                    return checkPostfixUnaryExpression(node);
                case 225 /* BinaryExpression */ :
                    return checkBinaryExpression(node, checkMode);
                case 226 /* ConditionalExpression */ :
                    return checkConditionalExpression(node, checkMode);
                case 229 /* SpreadElement */ :
                    return checkSpreadExpression(node, checkMode);
                case 231 /* OmittedExpression */ :
                    return undefinedWideningType;
                case 228 /* YieldExpression */ :
                    return checkYieldExpression(node);
                case 236 /* SyntheticExpression */ :
                    return checkSyntheticExpression(node);
                case 293 /* JsxExpression */ :
                    return checkJsxExpression(node, checkMode);
                case 283 /* JsxElement */ :
                    return checkJsxElement(node, checkMode);
                case 284 /* JsxSelfClosingElement */ :
                    return checkJsxSelfClosingElement(node, checkMode);
                case 287 /* JsxFragment */ :
                    return checkJsxFragment(node);
                case 291 /* JsxAttributes */ :
                    return checkJsxAttributes(node, checkMode);
                case 285 /* JsxOpeningElement */ :
                    Debug.fail("Shouldn't ever directly check a JsxOpeningElement");
            }
            return errorType;
        }
        function checkTypeParameter(node) {
            checkGrammarModifiers(node);
            if (node.expression) grammarErrorOnFirstToken(node.expression, Diagnostics.Type_expected);
            checkSourceElement(node.constraint);
            checkSourceElement(node.default);
            const typeParameter = getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(node));
            getBaseConstraintOfType(typeParameter);
            if (!hasNonCircularTypeParameterDefault(typeParameter)) error(node.default, Diagnostics.Type_parameter_0_has_a_circular_default, typeToString(typeParameter));
            const constraintType = getConstraintOfTypeParameter(typeParameter);
            const defaultType = getDefaultFromTypeParameter(typeParameter);
            if (constraintType && defaultType) checkTypeAssignableTo(defaultType, getTypeWithThisArgument(instantiateType(constraintType, makeUnaryTypeMapper(typeParameter, defaultType)), defaultType), node.default, Diagnostics.Type_0_does_not_satisfy_the_constraint_1);
            checkNodeDeferred(node);
            addLazyDiagnostic(()=>checkTypeNameIsReserved(node.name, Diagnostics.Type_parameter_name_cannot_be_0));
        }
        function checkTypeParameterDeferred(node) {
            var _a, _b;
            if (isInterfaceDeclaration(node.parent) || isClassLike(node.parent) || isTypeAliasDeclaration(node.parent)) {
                const typeParameter = getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(node));
                const modifiers = getTypeParameterModifiers(typeParameter) & 98304 /* Out */ ;
                if (modifiers) {
                    const symbol = getSymbolOfDeclaration(node.parent);
                    if (isTypeAliasDeclaration(node.parent) && !(getObjectFlags(getDeclaredTypeOfSymbol(symbol)) & 48 /* Mapped */ )) error(node, Diagnostics.Variance_annotations_are_only_supported_in_type_aliases_for_object_function_constructor_and_mapped_types);
                    else if (modifiers === 32768 /* In */  || modifiers === 65536 /* Out */ ) {
                        (_a = tracing) == null || _a.push(tracing.Phase.CheckTypes, "checkTypeParameterDeferred", {
                            parent: getTypeId(getDeclaredTypeOfSymbol(symbol)),
                            id: getTypeId(typeParameter)
                        });
                        const source = createMarkerType(symbol, typeParameter, modifiers === 65536 /* Out */  ? markerSubTypeForCheck : markerSuperTypeForCheck);
                        const target = createMarkerType(symbol, typeParameter, modifiers === 65536 /* Out */  ? markerSuperTypeForCheck : markerSubTypeForCheck);
                        const saveVarianceTypeParameter = typeParameter;
                        varianceTypeParameter = typeParameter;
                        checkTypeAssignableTo(source, target, node, Diagnostics.Type_0_is_not_assignable_to_type_1_as_implied_by_variance_annotation);
                        varianceTypeParameter = saveVarianceTypeParameter;
                        (_b = tracing) == null || _b.pop();
                    }
                }
            }
        }
        function checkParameter(node) {
            checkGrammarModifiers(node);
            checkVariableLikeDeclaration(node);
            const func = getContainingFunction(node);
            if (hasSyntacticModifier(node, 16476 /* ParameterPropertyModifier */ )) {
                if (!(func.kind === 175 /* Constructor */  && nodeIsPresent(func.body))) error(node, Diagnostics.A_parameter_property_is_only_allowed_in_a_constructor_implementation);
                if (func.kind === 175 /* Constructor */  && isIdentifier(node.name) && node.name.escapedText === "constructor") error(node.name, Diagnostics.constructor_cannot_be_used_as_a_parameter_property_name);
            }
            if (!node.initializer && isOptionalDeclaration(node) && isBindingPattern(node.name) && func.body) error(node, Diagnostics.A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature);
            if (node.name && isIdentifier(node.name) && (node.name.escapedText === "this" || node.name.escapedText === "new")) {
                if (func.parameters.indexOf(node) !== 0) error(node, Diagnostics.A_0_parameter_must_be_the_first_parameter, node.name.escapedText);
                if (func.kind === 175 /* Constructor */  || func.kind === 179 /* ConstructSignature */  || func.kind === 184 /* ConstructorType */ ) error(node, Diagnostics.A_constructor_cannot_have_a_this_parameter);
                if (func.kind === 218 /* ArrowFunction */ ) error(node, Diagnostics.An_arrow_function_cannot_have_a_this_parameter);
                if (func.kind === 176 /* GetAccessor */  || func.kind === 177 /* SetAccessor */ ) error(node, Diagnostics.get_and_set_accessors_cannot_declare_this_parameters);
            }
            if (node.dotDotDotToken && !isBindingPattern(node.name) && !isTypeAssignableTo(getReducedType(getTypeOfSymbol(node.symbol)), anyReadonlyArrayType)) error(node, Diagnostics.A_rest_parameter_must_be_of_an_array_type);
        }
        function checkTypePredicate(node) {
            const parent2 = getTypePredicateParent(node);
            if (!parent2) {
                error(node, Diagnostics.A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods);
                return;
            }
            const signature = getSignatureFromDeclaration(parent2);
            const typePredicate = getTypePredicateOfSignature(signature);
            if (!typePredicate) return;
            checkSourceElement(node.type);
            const { parameterName: parameterName  } = node;
            if (typePredicate.kind === 0 /* This */  || typePredicate.kind === 2 /* AssertsThis */ ) getTypeFromThisTypeNode(parameterName);
            else {
                if (typePredicate.parameterIndex >= 0) {
                    if (signatureHasRestParameter(signature) && typePredicate.parameterIndex === signature.parameters.length - 1) error(parameterName, Diagnostics.A_type_predicate_cannot_reference_a_rest_parameter);
                    else if (typePredicate.type) {
                        const leadingError = ()=>chainDiagnosticMessages(/*details*/ void 0, Diagnostics.A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type);
                        checkTypeAssignableTo(typePredicate.type, getTypeOfSymbol(signature.parameters[typePredicate.parameterIndex]), node.type, /*headMessage*/ void 0, leadingError);
                    }
                } else if (parameterName) {
                    let hasReportedError = false;
                    for (const { name: name  } of parent2.parameters)if (isBindingPattern(name) && checkIfTypePredicateVariableIsDeclaredInBindingPattern(name, parameterName, typePredicate.parameterName)) {
                        hasReportedError = true;
                        break;
                    }
                    if (!hasReportedError) error(node.parameterName, Diagnostics.Cannot_find_parameter_0, typePredicate.parameterName);
                }
            }
        }
        function getTypePredicateParent(node) {
            switch(node.parent.kind){
                case 218 /* ArrowFunction */ :
                case 178 /* CallSignature */ :
                case 261 /* FunctionDeclaration */ :
                case 217 /* FunctionExpression */ :
                case 183 /* FunctionType */ :
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                    const parent2 = node.parent;
                    if (node === parent2.type) return parent2;
            }
        }
        function checkIfTypePredicateVariableIsDeclaredInBindingPattern(pattern, predicateVariableNode, predicateVariableName) {
            for (const element of pattern.elements){
                if (isOmittedExpression(element)) continue;
                const name = element.name;
                if (name.kind === 80 /* Identifier */  && name.escapedText === predicateVariableName) {
                    error(predicateVariableNode, Diagnostics.A_type_predicate_cannot_reference_element_0_in_a_binding_pattern, predicateVariableName);
                    return true;
                } else if (name.kind === 206 /* ArrayBindingPattern */  || name.kind === 205 /* ObjectBindingPattern */ ) {
                    if (checkIfTypePredicateVariableIsDeclaredInBindingPattern(name, predicateVariableNode, predicateVariableName)) return true;
                }
            }
        }
        function checkSignatureDeclaration(node) {
            if (node.kind === 180 /* IndexSignature */ ) checkGrammarIndexSignature(node);
            else if (node.kind === 183 /* FunctionType */  || node.kind === 261 /* FunctionDeclaration */  || node.kind === 184 /* ConstructorType */  || node.kind === 178 /* CallSignature */  || node.kind === 175 /* Constructor */  || node.kind === 179 /* ConstructSignature */ ) checkGrammarFunctionLikeDeclaration(node);
            const functionFlags = getFunctionFlags(node);
            if (!(functionFlags & 4 /* Invalid */ )) {
                if ((functionFlags & 3 /* AsyncGenerator */ ) === 3 /* AsyncGenerator */  && languageVersion < 99 /* ESNext */ ) checkExternalEmitHelpers(node, 6144 /* AsyncGeneratorIncludes */ );
                if ((functionFlags & 3 /* AsyncGenerator */ ) === 2 /* Async */  && languageVersion < 4 /* ES2017 */ ) checkExternalEmitHelpers(node, 64 /* Awaiter */ );
                if ((functionFlags & 3 /* AsyncGenerator */ ) !== 0 /* Normal */  && languageVersion < 2 /* ES2015 */ ) checkExternalEmitHelpers(node, 128 /* Generator */ );
            }
            checkTypeParameters(getEffectiveTypeParameterDeclarations(node));
            checkUnmatchedJSDocParameters(node);
            forEach(node.parameters, checkParameter);
            if (node.type) checkSourceElement(node.type);
            addLazyDiagnostic(checkSignatureDeclarationDiagnostics);
            function checkSignatureDeclarationDiagnostics() {
                checkCollisionWithArgumentsInGeneratedCode(node);
                const returnTypeNode = getEffectiveReturnTypeNode(node);
                if (noImplicitAny && !returnTypeNode) switch(node.kind){
                    case 179 /* ConstructSignature */ :
                        error(node, Diagnostics.Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type);
                        break;
                    case 178 /* CallSignature */ :
                        error(node, Diagnostics.Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type);
                        break;
                }
                if (returnTypeNode) {
                    const functionFlags2 = getFunctionFlags(node);
                    if ((functionFlags2 & 5 /* Generator */ ) === 1 /* Generator */ ) {
                        const returnType = getTypeFromTypeNode(returnTypeNode);
                        if (returnType === voidType) error(returnTypeNode, Diagnostics.A_generator_cannot_have_a_void_type_annotation);
                        else {
                            const generatorYieldType = getIterationTypeOfGeneratorFunctionReturnType(0 /* Yield */ , returnType, (functionFlags2 & 2 /* Async */ ) !== 0) || anyType;
                            const generatorReturnType = getIterationTypeOfGeneratorFunctionReturnType(1 /* Return */ , returnType, (functionFlags2 & 2 /* Async */ ) !== 0) || generatorYieldType;
                            const generatorNextType = getIterationTypeOfGeneratorFunctionReturnType(2 /* Next */ , returnType, (functionFlags2 & 2 /* Async */ ) !== 0) || unknownType;
                            const generatorInstantiation = createGeneratorReturnType(generatorYieldType, generatorReturnType, generatorNextType, !!(functionFlags2 & 2 /* Async */ ));
                            checkTypeAssignableTo(generatorInstantiation, returnType, returnTypeNode);
                        }
                    } else if ((functionFlags2 & 3 /* AsyncGenerator */ ) === 2 /* Async */ ) checkAsyncFunctionReturnType(node, returnTypeNode);
                }
                if (node.kind !== 180 /* IndexSignature */  && node.kind !== 323 /* JSDocFunctionType */ ) registerForUnusedIdentifiersCheck(node);
            }
        }
        function checkClassForDuplicateDeclarations(node) {
            const instanceNames = /* @__PURE__ */ new Map();
            const staticNames = /* @__PURE__ */ new Map();
            const privateIdentifiers = /* @__PURE__ */ new Map();
            for (const member of node.members)if (member.kind === 175 /* Constructor */ ) {
                for (const param of member.parameters)if (isParameterPropertyDeclaration(param, member) && !isBindingPattern(param.name)) addName(instanceNames, param.name, param.name.escapedText, 3 /* GetOrSetAccessor */ );
            } else {
                const isStaticMember = isStatic(member);
                const name = member.name;
                if (!name) continue;
                const isPrivate = isPrivateIdentifier(name);
                const privateStaticFlags = isPrivate && isStaticMember ? 16 /* PrivateStatic */  : 0;
                const names = isPrivate ? privateIdentifiers : isStaticMember ? staticNames : instanceNames;
                const memberName = name && getPropertyNameForPropertyNameNode(name);
                if (memberName) switch(member.kind){
                    case 176 /* GetAccessor */ :
                        addName(names, name, memberName, 1 /* GetAccessor */  | privateStaticFlags);
                        break;
                    case 177 /* SetAccessor */ :
                        addName(names, name, memberName, 2 /* SetAccessor */  | privateStaticFlags);
                        break;
                    case 171 /* PropertyDeclaration */ :
                        addName(names, name, memberName, 3 /* GetOrSetAccessor */  | privateStaticFlags);
                        break;
                    case 173 /* MethodDeclaration */ :
                        addName(names, name, memberName, 8 /* Method */  | privateStaticFlags);
                        break;
                }
            }
            function addName(names, location, name, meaning) {
                const prev = names.get(name);
                if (prev) {
                    if ((prev & 16 /* PrivateStatic */ ) !== (meaning & 16 /* PrivateStatic */ )) error(location, Diagnostics.Duplicate_identifier_0_Static_and_instance_elements_cannot_share_the_same_private_name, getTextOfNode(location));
                    else {
                        const prevIsMethod = !!(prev & 8 /* Method */ );
                        const isMethod = !!(meaning & 8 /* Method */ );
                        if (prevIsMethod || isMethod) {
                            if (prevIsMethod !== isMethod) error(location, Diagnostics.Duplicate_identifier_0, getTextOfNode(location));
                        } else if (prev & meaning & -17 /* PrivateStatic */ ) error(location, Diagnostics.Duplicate_identifier_0, getTextOfNode(location));
                        else names.set(name, prev | meaning);
                    }
                } else names.set(name, meaning);
            }
        }
        function checkClassForStaticPropertyNameConflicts(node) {
            for (const member of node.members){
                const memberNameNode = member.name;
                const isStaticMember = isStatic(member);
                if (isStaticMember && memberNameNode) {
                    const memberName = getPropertyNameForPropertyNameNode(memberNameNode);
                    switch(memberName){
                        case "name":
                        case "length":
                        case "caller":
                        case "arguments":
                        case "prototype":
                            const message = Diagnostics.Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1;
                            const className = getNameOfSymbolAsWritten(getSymbolOfDeclaration(node));
                            error(memberNameNode, message, memberName, className);
                            break;
                    }
                }
            }
        }
        function checkObjectTypeForDuplicateDeclarations(node) {
            const names = /* @__PURE__ */ new Map();
            for (const member of node.members)if (member.kind === 170 /* PropertySignature */ ) {
                let memberName;
                const name = member.name;
                switch(name.kind){
                    case 11 /* StringLiteral */ :
                    case 9 /* NumericLiteral */ :
                        memberName = name.text;
                        break;
                    case 80 /* Identifier */ :
                        memberName = idText(name);
                        break;
                    default:
                        continue;
                }
                if (names.get(memberName)) {
                    error(getNameOfDeclaration(member.symbol.valueDeclaration), Diagnostics.Duplicate_identifier_0, memberName);
                    error(member.name, Diagnostics.Duplicate_identifier_0, memberName);
                } else names.set(memberName, true);
            }
        }
        function checkTypeForDuplicateIndexSignatures(node) {
            if (node.kind === 263 /* InterfaceDeclaration */ ) {
                const nodeSymbol = getSymbolOfDeclaration(node);
                if (nodeSymbol.declarations && nodeSymbol.declarations.length > 0 && nodeSymbol.declarations[0] !== node) return;
            }
            const indexSymbol = getIndexSymbol(getSymbolOfDeclaration(node));
            if (indexSymbol == null ? void 0 : indexSymbol.declarations) {
                const indexSignatureMap = /* @__PURE__ */ new Map();
                for (const declaration of indexSymbol.declarations)if (declaration.parameters.length === 1 && declaration.parameters[0].type) forEachType(getTypeFromTypeNode(declaration.parameters[0].type), (type)=>{
                    const entry = indexSignatureMap.get(getTypeId(type));
                    if (entry) entry.declarations.push(declaration);
                    else indexSignatureMap.set(getTypeId(type), {
                        type: type,
                        declarations: [
                            declaration
                        ]
                    });
                });
                indexSignatureMap.forEach((entry)=>{
                    if (entry.declarations.length > 1) for (const declaration of entry.declarations)error(declaration, Diagnostics.Duplicate_index_signature_for_type_0, typeToString(entry.type));
                });
            }
        }
        function checkPropertyDeclaration(node) {
            if (!checkGrammarModifiers(node) && !checkGrammarProperty(node)) checkGrammarComputedPropertyName(node.name);
            checkVariableLikeDeclaration(node);
            setNodeLinksForPrivateIdentifierScope(node);
            if (hasSyntacticModifier(node, 256 /* Abstract */ ) && node.kind === 171 /* PropertyDeclaration */  && node.initializer) error(node, Diagnostics.Property_0_cannot_have_an_initializer_because_it_is_marked_abstract, declarationNameToString(node.name));
        }
        function checkPropertySignature(node) {
            if (isPrivateIdentifier(node.name)) error(node, Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
            return checkPropertyDeclaration(node);
        }
        function checkMethodDeclaration(node) {
            if (!checkGrammarMethod(node)) checkGrammarComputedPropertyName(node.name);
            if (isMethodDeclaration(node) && node.asteriskToken && isIdentifier(node.name) && idText(node.name) === "constructor") error(node.name, Diagnostics.Class_constructor_may_not_be_a_generator);
            checkFunctionOrMethodDeclaration(node);
            if (hasSyntacticModifier(node, 256 /* Abstract */ ) && node.kind === 173 /* MethodDeclaration */  && node.body) error(node, Diagnostics.Method_0_cannot_have_an_implementation_because_it_is_marked_abstract, declarationNameToString(node.name));
            if (isPrivateIdentifier(node.name) && !getContainingClass(node)) error(node, Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
            setNodeLinksForPrivateIdentifierScope(node);
        }
        function setNodeLinksForPrivateIdentifierScope(node) {
            if (isPrivateIdentifier(node.name) && languageVersion < 99 /* ESNext */ ) {
                for(let lexicalScope = getEnclosingBlockScopeContainer(node); !!lexicalScope; lexicalScope = getEnclosingBlockScopeContainer(lexicalScope))getNodeLinks(lexicalScope).flags |= 4194304 /* ContainsClassWithPrivateIdentifiers */ ;
                if (isClassExpression(node.parent)) {
                    const enclosingIterationStatement = getEnclosingIterationStatement(node.parent);
                    if (enclosingIterationStatement) {
                        getNodeLinks(node.name).flags |= 32768 /* BlockScopedBindingInLoop */ ;
                        getNodeLinks(enclosingIterationStatement).flags |= 4096 /* LoopWithCapturedBlockScopedBinding */ ;
                    }
                }
            }
        }
        function checkClassStaticBlockDeclaration(node) {
            checkGrammarModifiers(node);
            forEachChild(node, checkSourceElement);
        }
        function checkConstructorDeclaration(node) {
            checkSignatureDeclaration(node);
            if (!checkGrammarConstructorTypeParameters(node)) checkGrammarConstructorTypeAnnotation(node);
            checkSourceElement(node.body);
            const symbol = getSymbolOfDeclaration(node);
            const firstDeclaration = getDeclarationOfKind(symbol, node.kind);
            if (node === firstDeclaration) checkFunctionOrConstructorSymbol(symbol);
            if (nodeIsMissing(node.body)) return;
            addLazyDiagnostic(checkConstructorDeclarationDiagnostics);
            return;
            function isInstancePropertyWithInitializerOrPrivateIdentifierProperty(n) {
                if (isPrivateIdentifierClassElementDeclaration(n)) return true;
                return n.kind === 171 /* PropertyDeclaration */  && !isStatic(n) && !!n.initializer;
            }
            function checkConstructorDeclarationDiagnostics() {
                const containingClassDecl = node.parent;
                if (getClassExtendsHeritageElement(containingClassDecl)) {
                    captureLexicalThis(node.parent, containingClassDecl);
                    const classExtendsNull = classDeclarationExtendsNull(containingClassDecl);
                    const superCall = findFirstSuperCall(node.body);
                    if (superCall) {
                        if (classExtendsNull) error(superCall, Diagnostics.A_constructor_cannot_contain_a_super_call_when_its_class_extends_null);
                        const superCallShouldBeRootLevel = (getEmitScriptTarget(compilerOptions) !== 99 /* ESNext */  || !useDefineForClassFields) && (some(node.parent.members, isInstancePropertyWithInitializerOrPrivateIdentifierProperty) || some(node.parameters, (p)=>hasSyntacticModifier(p, 16476 /* ParameterPropertyModifier */ )));
                        if (superCallShouldBeRootLevel) {
                            if (!superCallIsRootLevelInConstructor(superCall, node.body)) error(superCall, Diagnostics.A_super_call_must_be_a_root_level_statement_within_a_constructor_of_a_derived_class_that_contains_initialized_properties_parameter_properties_or_private_identifiers);
                            else {
                                let superCallStatement;
                                for (const statement of node.body.statements){
                                    if (isExpressionStatement(statement) && isSuperCall(skipOuterExpressions(statement.expression))) {
                                        superCallStatement = statement;
                                        break;
                                    }
                                    if (nodeImmediatelyReferencesSuperOrThis(statement)) break;
                                }
                                if (superCallStatement === void 0) error(node, Diagnostics.A_super_call_must_be_the_first_statement_in_the_constructor_to_refer_to_super_or_this_when_a_derived_class_contains_initialized_properties_parameter_properties_or_private_identifiers);
                            }
                        }
                    } else if (!classExtendsNull) error(node, Diagnostics.Constructors_for_derived_classes_must_contain_a_super_call);
                }
            }
        }
        function superCallIsRootLevelInConstructor(superCall, body) {
            const superCallParent = walkUpParenthesizedExpressions(superCall.parent);
            return isExpressionStatement(superCallParent) && superCallParent.parent === body;
        }
        function nodeImmediatelyReferencesSuperOrThis(node) {
            if (node.kind === 108 /* SuperKeyword */  || node.kind === 110 /* ThisKeyword */ ) return true;
            if (isThisContainerOrFunctionBlock(node)) return false;
            return !!forEachChild(node, nodeImmediatelyReferencesSuperOrThis);
        }
        function checkAccessorDeclaration(node) {
            if (isIdentifier(node.name) && idText(node.name) === "constructor" && isClassLike(node.parent)) error(node.name, Diagnostics.Class_constructor_may_not_be_an_accessor);
            addLazyDiagnostic(checkAccessorDeclarationDiagnostics);
            checkSourceElement(node.body);
            setNodeLinksForPrivateIdentifierScope(node);
            function checkAccessorDeclarationDiagnostics() {
                if (!checkGrammarFunctionLikeDeclaration(node) && !checkGrammarAccessor(node)) checkGrammarComputedPropertyName(node.name);
                checkDecorators(node);
                checkSignatureDeclaration(node);
                if (node.kind === 176 /* GetAccessor */ ) {
                    if (!(node.flags & 16777216 /* Ambient */ ) && nodeIsPresent(node.body) && node.flags & 256 /* HasImplicitReturn */ ) {
                        if (!(node.flags & 512 /* HasExplicitReturn */ )) error(node.name, Diagnostics.A_get_accessor_must_return_a_value);
                    }
                }
                if (node.name.kind === 166 /* ComputedPropertyName */ ) checkComputedPropertyName(node.name);
                if (hasBindableName(node)) {
                    const symbol = getSymbolOfDeclaration(node);
                    const getter = getDeclarationOfKind(symbol, 176 /* GetAccessor */ );
                    const setter = getDeclarationOfKind(symbol, 177 /* SetAccessor */ );
                    if (getter && setter && !(getNodeCheckFlags(getter) & 1 /* TypeChecked */ )) {
                        getNodeLinks(getter).flags |= 1 /* TypeChecked */ ;
                        const getterFlags = getEffectiveModifierFlags(getter);
                        const setterFlags = getEffectiveModifierFlags(setter);
                        if ((getterFlags & 256 /* Abstract */ ) !== (setterFlags & 256 /* Abstract */ )) {
                            error(getter.name, Diagnostics.Accessors_must_both_be_abstract_or_non_abstract);
                            error(setter.name, Diagnostics.Accessors_must_both_be_abstract_or_non_abstract);
                        }
                        if (getterFlags & 16 /* Protected */  && !(setterFlags & 24 /* Private */ ) || getterFlags & 8 /* Private */  && !(setterFlags & 8 /* Private */ )) {
                            error(getter.name, Diagnostics.A_get_accessor_must_be_at_least_as_accessible_as_the_setter);
                            error(setter.name, Diagnostics.A_get_accessor_must_be_at_least_as_accessible_as_the_setter);
                        }
                    }
                }
                const returnType = getTypeOfAccessors(getSymbolOfDeclaration(node));
                if (node.kind === 176 /* GetAccessor */ ) checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, returnType);
            }
        }
        function checkMissingDeclaration(node) {
            checkDecorators(node);
        }
        function getEffectiveTypeArgumentAtIndex(node, typeParameters, index) {
            if (node.typeArguments && index < node.typeArguments.length) return getTypeFromTypeNode(node.typeArguments[index]);
            return getEffectiveTypeArguments2(node, typeParameters)[index];
        }
        function getEffectiveTypeArguments2(node, typeParameters) {
            return fillMissingTypeArguments(map(node.typeArguments, getTypeFromTypeNode), typeParameters, getMinTypeArgumentCount(typeParameters), isInJSFile(node));
        }
        function checkTypeArgumentConstraints(node, typeParameters) {
            let typeArguments;
            let mapper;
            let result = true;
            for(let i = 0; i < typeParameters.length; i++){
                const constraint = getConstraintOfTypeParameter(typeParameters[i]);
                if (constraint) {
                    if (!typeArguments) {
                        typeArguments = getEffectiveTypeArguments2(node, typeParameters);
                        mapper = createTypeMapper(typeParameters, typeArguments);
                    }
                    result = result && checkTypeAssignableTo(typeArguments[i], instantiateType(constraint, mapper), node.typeArguments[i], Diagnostics.Type_0_does_not_satisfy_the_constraint_1);
                }
            }
            return result;
        }
        function getTypeParametersForTypeAndSymbol(type, symbol) {
            if (!isErrorType(type)) return symbol.flags & 524288 /* TypeAlias */  && getSymbolLinks(symbol).typeParameters || (getObjectFlags(type) & 4 /* Reference */  ? type.target.localTypeParameters : void 0);
            return void 0;
        }
        function getTypeParametersForTypeReferenceOrImport(node) {
            const type = getTypeFromTypeNode(node);
            if (!isErrorType(type)) {
                const symbol = getNodeLinks(node).resolvedSymbol;
                if (symbol) return getTypeParametersForTypeAndSymbol(type, symbol);
            }
            return void 0;
        }
        function checkTypeReferenceNode(node) {
            checkGrammarTypeArguments(node, node.typeArguments);
            if (node.kind === 182 /* TypeReference */  && !isInJSFile(node) && !isInJSDoc(node) && node.typeArguments && node.typeName.end !== node.typeArguments.pos) {
                const sourceFile = getSourceFileOfNode(node);
                if (scanTokenAtPosition(sourceFile, node.typeName.end) === 25 /* DotToken */ ) grammarErrorAtPos(node, skipTrivia(sourceFile.text, node.typeName.end), 1, Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments);
            }
            forEach(node.typeArguments, checkSourceElement);
            checkTypeReferenceOrImport(node);
        }
        function checkTypeReferenceOrImport(node) {
            const type = getTypeFromTypeNode(node);
            if (!isErrorType(type)) {
                if (node.typeArguments) addLazyDiagnostic(()=>{
                    const typeParameters = getTypeParametersForTypeReferenceOrImport(node);
                    if (typeParameters) checkTypeArgumentConstraints(node, typeParameters);
                });
                const symbol = getNodeLinks(node).resolvedSymbol;
                if (symbol) {
                    if (some(symbol.declarations, (d)=>isTypeDeclaration(d) && !!(d.flags & 268435456 /* Deprecated */ ))) addDeprecatedSuggestion(getDeprecatedSuggestionNode(node), symbol.declarations, symbol.escapedName);
                }
            }
        }
        function getTypeArgumentConstraint(node) {
            const typeReferenceNode = tryCast(node.parent, isTypeReferenceType);
            if (!typeReferenceNode) return void 0;
            const typeParameters = getTypeParametersForTypeReferenceOrImport(typeReferenceNode);
            if (!typeParameters) return void 0;
            const constraint = getConstraintOfTypeParameter(typeParameters[typeReferenceNode.typeArguments.indexOf(node)]);
            return constraint && instantiateType(constraint, createTypeMapper(typeParameters, getEffectiveTypeArguments2(typeReferenceNode, typeParameters)));
        }
        function checkTypeQuery(node) {
            getTypeFromTypeQueryNode(node);
        }
        function checkTypeLiteral(node) {
            forEach(node.members, checkSourceElement);
            addLazyDiagnostic(checkTypeLiteralDiagnostics);
            function checkTypeLiteralDiagnostics() {
                const type = getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node);
                checkIndexConstraints(type, type.symbol);
                checkTypeForDuplicateIndexSignatures(node);
                checkObjectTypeForDuplicateDeclarations(node);
            }
        }
        function checkArrayType(node) {
            checkSourceElement(node.elementType);
        }
        function checkTupleType(node) {
            const elementTypes = node.elements;
            let seenOptionalElement = false;
            let seenRestElement = false;
            const hasNamedElement = some(elementTypes, isNamedTupleMember);
            for (const e of elementTypes){
                if (e.kind !== 201 /* NamedTupleMember */  && hasNamedElement) {
                    grammarErrorOnNode(e, Diagnostics.Tuple_members_must_all_have_names_or_all_not_have_names);
                    break;
                }
                const flags = getTupleElementFlags(e);
                if (flags & 8 /* Variadic */ ) {
                    const type = getTypeFromTypeNode(e.type);
                    if (!isArrayLikeType(type)) {
                        error(e, Diagnostics.A_rest_element_type_must_be_an_array_type);
                        break;
                    }
                    if (isArrayType(type) || isTupleType(type) && type.target.combinedFlags & 4 /* Rest */ ) seenRestElement = true;
                } else if (flags & 4 /* Rest */ ) {
                    if (seenRestElement) {
                        grammarErrorOnNode(e, Diagnostics.A_rest_element_cannot_follow_another_rest_element);
                        break;
                    }
                    seenRestElement = true;
                } else if (flags & 2 /* Optional */ ) {
                    if (seenRestElement) {
                        grammarErrorOnNode(e, Diagnostics.An_optional_element_cannot_follow_a_rest_element);
                        break;
                    }
                    seenOptionalElement = true;
                } else if (seenOptionalElement) {
                    grammarErrorOnNode(e, Diagnostics.A_required_element_cannot_follow_an_optional_element);
                    break;
                }
            }
            forEach(node.elements, checkSourceElement);
            getTypeFromTypeNode(node);
        }
        function checkUnionOrIntersectionType(node) {
            forEach(node.types, checkSourceElement);
            getTypeFromTypeNode(node);
        }
        function checkIndexedAccessIndexType(type, accessNode) {
            if (!(type.flags & 8388608 /* IndexedAccess */ )) return type;
            const objectType = type.objectType;
            const indexType = type.indexType;
            if (isTypeAssignableTo(indexType, getIndexType(objectType, 0 /* None */ ))) {
                if (accessNode.kind === 211 /* ElementAccessExpression */  && isAssignmentTarget(accessNode) && getObjectFlags(objectType) & 32 /* Mapped */  && getMappedTypeModifiers(objectType) & 1 /* IncludeReadonly */ ) error(accessNode, Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(objectType));
                return type;
            }
            const apparentObjectType = getApparentType(objectType);
            if (getIndexInfoOfType(apparentObjectType, numberType) && isTypeAssignableToKind(indexType, 296 /* NumberLike */ )) return type;
            if (isGenericObjectType(objectType)) {
                const propertyName = getPropertyNameFromIndex(indexType, accessNode);
                if (propertyName) {
                    const propertySymbol = forEachType(apparentObjectType, (t)=>getPropertyOfType(t, propertyName));
                    if (propertySymbol && getDeclarationModifierFlagsFromSymbol(propertySymbol) & 24 /* NonPublicAccessibilityModifier */ ) {
                        error(accessNode, Diagnostics.Private_or_protected_member_0_cannot_be_accessed_on_a_type_parameter, unescapeLeadingUnderscores(propertyName));
                        return errorType;
                    }
                }
            }
            error(accessNode, Diagnostics.Type_0_cannot_be_used_to_index_type_1, typeToString(indexType), typeToString(objectType));
            return errorType;
        }
        function checkIndexedAccessType(node) {
            checkSourceElement(node.objectType);
            checkSourceElement(node.indexType);
            checkIndexedAccessIndexType(getTypeFromIndexedAccessTypeNode(node), node);
        }
        function checkMappedType(node) {
            checkGrammarMappedType(node);
            checkSourceElement(node.typeParameter);
            checkSourceElement(node.nameType);
            checkSourceElement(node.type);
            if (!node.type) reportImplicitAny(node, anyType);
            const type = getTypeFromMappedTypeNode(node);
            const nameType = getNameTypeFromMappedType(type);
            if (nameType) checkTypeAssignableTo(nameType, keyofConstraintType, node.nameType);
            else {
                const constraintType = getConstraintTypeFromMappedType(type);
                checkTypeAssignableTo(constraintType, keyofConstraintType, getEffectiveConstraintOfTypeParameter(node.typeParameter));
            }
        }
        function checkGrammarMappedType(node) {
            var _a;
            if ((_a = node.members) == null ? void 0 : _a.length) return grammarErrorOnNode(node.members[0], Diagnostics.A_mapped_type_may_not_declare_properties_or_methods);
        }
        function checkThisType(node) {
            getTypeFromThisTypeNode(node);
        }
        function checkTypeOperator(node) {
            checkGrammarTypeOperatorNode(node);
            checkSourceElement(node.type);
        }
        function checkConditionalType(node) {
            forEachChild(node, checkSourceElement);
        }
        function checkInferType(node) {
            if (!findAncestor(node, (n)=>n.parent && n.parent.kind === 193 /* ConditionalType */  && n.parent.extendsType === n)) grammarErrorOnNode(node, Diagnostics.infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type);
            checkSourceElement(node.typeParameter);
            const symbol = getSymbolOfDeclaration(node.typeParameter);
            if (symbol.declarations && symbol.declarations.length > 1) {
                const links = getSymbolLinks(symbol);
                if (!links.typeParametersChecked) {
                    links.typeParametersChecked = true;
                    const typeParameter = getDeclaredTypeOfTypeParameter(symbol);
                    const declarations = getDeclarationsOfKind(symbol, 167 /* TypeParameter */ );
                    if (!areTypeParametersIdentical(declarations, [
                        typeParameter
                    ], (decl)=>[
                            decl
                        ])) {
                        const name = symbolToString(symbol);
                        for (const declaration of declarations)error(declaration.name, Diagnostics.All_declarations_of_0_must_have_identical_constraints, name);
                    }
                }
            }
            registerForUnusedIdentifiersCheck(node);
        }
        function checkTemplateLiteralType(node) {
            for (const span of node.templateSpans){
                checkSourceElement(span.type);
                const type = getTypeFromTypeNode(span.type);
                checkTypeAssignableTo(type, templateConstraintType, span.type);
            }
            getTypeFromTypeNode(node);
        }
        function checkImportType(node) {
            checkSourceElement(node.argument);
            if (node.assertions) {
                const override = getResolutionModeOverrideForClause(node.assertions.assertClause, grammarErrorOnNode);
                if (override) {
                    if (!isNightly()) grammarErrorOnNode(node.assertions.assertClause, Diagnostics.resolution_mode_assertions_are_unstable_Use_nightly_TypeScript_to_silence_this_error_Try_updating_with_npm_install_D_typescript_next);
                    if (getEmitModuleResolutionKind(compilerOptions) !== 3 /* Node16 */  && getEmitModuleResolutionKind(compilerOptions) !== 99 /* NodeNext */ ) grammarErrorOnNode(node.assertions.assertClause, Diagnostics.resolution_mode_assertions_are_only_supported_when_moduleResolution_is_node16_or_nodenext);
                }
            }
            checkTypeReferenceOrImport(node);
        }
        function checkNamedTupleMember(node) {
            if (node.dotDotDotToken && node.questionToken) grammarErrorOnNode(node, Diagnostics.A_tuple_member_cannot_be_both_optional_and_rest);
            if (node.type.kind === 189 /* OptionalType */ ) grammarErrorOnNode(node.type, Diagnostics.A_labeled_tuple_element_is_declared_as_optional_with_a_question_mark_after_the_name_and_before_the_colon_rather_than_after_the_type);
            if (node.type.kind === 190 /* RestType */ ) grammarErrorOnNode(node.type, Diagnostics.A_labeled_tuple_element_is_declared_as_rest_with_a_before_the_name_rather_than_before_the_type);
            checkSourceElement(node.type);
            getTypeFromTypeNode(node);
        }
        function isPrivateWithinAmbient(node) {
            return (hasEffectiveModifier(node, 8 /* Private */ ) || isPrivateIdentifierClassElementDeclaration(node)) && !!(node.flags & 16777216 /* Ambient */ );
        }
        function getEffectiveDeclarationFlags(n, flagsToCheck) {
            let flags = getCombinedModifierFlags(n);
            if (n.parent.kind !== 263 /* InterfaceDeclaration */  && n.parent.kind !== 262 /* ClassDeclaration */  && n.parent.kind !== 230 /* ClassExpression */  && n.flags & 16777216 /* Ambient */ ) {
                if (!(flags & 2 /* Ambient */ ) && !(isModuleBlock(n.parent) && isModuleDeclaration(n.parent.parent) && isGlobalScopeAugmentation(n.parent.parent))) flags |= 1 /* Export */ ;
                flags |= 2 /* Ambient */ ;
            }
            return flags & flagsToCheck;
        }
        function checkFunctionOrConstructorSymbol(symbol) {
            addLazyDiagnostic(()=>checkFunctionOrConstructorSymbolWorker(symbol));
        }
        function checkFunctionOrConstructorSymbolWorker(symbol) {
            function getCanonicalOverload(overloads, implementation) {
                const implementationSharesContainerWithFirstOverload = implementation !== void 0 && implementation.parent === overloads[0].parent;
                return implementationSharesContainerWithFirstOverload ? implementation : overloads[0];
            }
            function checkFlagAgreementBetweenOverloads(overloads, implementation, flagsToCheck2, someOverloadFlags, allOverloadFlags) {
                const someButNotAllOverloadFlags = someOverloadFlags ^ allOverloadFlags;
                if (someButNotAllOverloadFlags !== 0) {
                    const canonicalFlags = getEffectiveDeclarationFlags(getCanonicalOverload(overloads, implementation), flagsToCheck2);
                    forEach(overloads, (o)=>{
                        const deviation = getEffectiveDeclarationFlags(o, flagsToCheck2) ^ canonicalFlags;
                        if (deviation & 1 /* Export */ ) error(getNameOfDeclaration(o), Diagnostics.Overload_signatures_must_all_be_exported_or_non_exported);
                        else if (deviation & 2 /* Ambient */ ) error(getNameOfDeclaration(o), Diagnostics.Overload_signatures_must_all_be_ambient_or_non_ambient);
                        else if (deviation & 24 /* Protected */ ) error(getNameOfDeclaration(o) || o, Diagnostics.Overload_signatures_must_all_be_public_private_or_protected);
                        else if (deviation & 256 /* Abstract */ ) error(getNameOfDeclaration(o), Diagnostics.Overload_signatures_must_all_be_abstract_or_non_abstract);
                    });
                }
            }
            function checkQuestionTokenAgreementBetweenOverloads(overloads, implementation, someHaveQuestionToken2, allHaveQuestionToken2) {
                if (someHaveQuestionToken2 !== allHaveQuestionToken2) {
                    const canonicalHasQuestionToken = hasQuestionToken(getCanonicalOverload(overloads, implementation));
                    forEach(overloads, (o)=>{
                        const deviation = hasQuestionToken(o) !== canonicalHasQuestionToken;
                        if (deviation) error(getNameOfDeclaration(o), Diagnostics.Overload_signatures_must_all_be_optional_or_required);
                    });
                }
            }
            const flagsToCheck = 283 /* Abstract */ ;
            let someNodeFlags = 0 /* None */ ;
            let allNodeFlags = flagsToCheck;
            let someHaveQuestionToken = false;
            let allHaveQuestionToken = true;
            let hasOverloads = false;
            let bodyDeclaration;
            let lastSeenNonAmbientDeclaration;
            let previousDeclaration;
            const declarations = symbol.declarations;
            const isConstructor = (symbol.flags & 16384 /* Constructor */ ) !== 0;
            function reportImplementationExpectedError(node) {
                if (node.name && nodeIsMissing(node.name)) return;
                let seen = false;
                const subsequentNode = forEachChild(node.parent, (c)=>{
                    if (seen) return c;
                    else seen = c === node;
                });
                if (subsequentNode && subsequentNode.pos === node.end) {
                    if (subsequentNode.kind === node.kind) {
                        const errorNode2 = subsequentNode.name || subsequentNode;
                        const subsequentName = subsequentNode.name;
                        if (node.name && subsequentName && // both are private identifiers
                        (isPrivateIdentifier(node.name) && isPrivateIdentifier(subsequentName) && node.name.escapedText === subsequentName.escapedText || // Both are computed property names
                        isComputedPropertyName(node.name) && isComputedPropertyName(subsequentName) && isTypeIdenticalTo(checkComputedPropertyName(node.name), checkComputedPropertyName(subsequentName)) || // Both are literal property names that are the same.
                        isPropertyNameLiteral(node.name) && isPropertyNameLiteral(subsequentName) && getEscapedTextOfIdentifierOrLiteral(node.name) === getEscapedTextOfIdentifierOrLiteral(subsequentName))) {
                            const reportError = (node.kind === 173 /* MethodDeclaration */  || node.kind === 172 /* MethodSignature */ ) && isStatic(node) !== isStatic(subsequentNode);
                            if (reportError) {
                                const diagnostic = isStatic(node) ? Diagnostics.Function_overload_must_be_static : Diagnostics.Function_overload_must_not_be_static;
                                error(errorNode2, diagnostic);
                            }
                            return;
                        }
                        if (nodeIsPresent(subsequentNode.body)) {
                            error(errorNode2, Diagnostics.Function_implementation_name_must_be_0, declarationNameToString(node.name));
                            return;
                        }
                    }
                }
                const errorNode = node.name || node;
                if (isConstructor) error(errorNode, Diagnostics.Constructor_implementation_is_missing);
                else if (hasSyntacticModifier(node, 256 /* Abstract */ )) error(errorNode, Diagnostics.All_declarations_of_an_abstract_method_must_be_consecutive);
                else error(errorNode, Diagnostics.Function_implementation_is_missing_or_not_immediately_following_the_declaration);
            }
            let duplicateFunctionDeclaration = false;
            let multipleConstructorImplementation = false;
            let hasNonAmbientClass = false;
            const functionDeclarations = [];
            if (declarations) for (const current of declarations){
                const node = current;
                const inAmbientContext = node.flags & 16777216 /* Ambient */ ;
                const inAmbientContextOrInterface = node.parent && (node.parent.kind === 263 /* InterfaceDeclaration */  || node.parent.kind === 186 /* TypeLiteral */ ) || inAmbientContext;
                if (inAmbientContextOrInterface) previousDeclaration = void 0;
                if ((node.kind === 262 /* ClassDeclaration */  || node.kind === 230 /* ClassExpression */ ) && !inAmbientContext) hasNonAmbientClass = true;
                if (node.kind === 261 /* FunctionDeclaration */  || node.kind === 173 /* MethodDeclaration */  || node.kind === 172 /* MethodSignature */  || node.kind === 175 /* Constructor */ ) {
                    functionDeclarations.push(node);
                    const currentNodeFlags = getEffectiveDeclarationFlags(node, flagsToCheck);
                    someNodeFlags |= currentNodeFlags;
                    allNodeFlags &= currentNodeFlags;
                    someHaveQuestionToken = someHaveQuestionToken || hasQuestionToken(node);
                    allHaveQuestionToken = allHaveQuestionToken && hasQuestionToken(node);
                    const bodyIsPresent = nodeIsPresent(node.body);
                    if (bodyIsPresent && bodyDeclaration) {
                        if (isConstructor) multipleConstructorImplementation = true;
                        else duplicateFunctionDeclaration = true;
                    } else if ((previousDeclaration == null ? void 0 : previousDeclaration.parent) === node.parent && previousDeclaration.end !== node.pos) reportImplementationExpectedError(previousDeclaration);
                    if (bodyIsPresent) {
                        if (!bodyDeclaration) bodyDeclaration = node;
                    } else hasOverloads = true;
                    previousDeclaration = node;
                    if (!inAmbientContextOrInterface) lastSeenNonAmbientDeclaration = node;
                }
                if (isInJSFile(current) && isFunctionLike(current) && current.jsDoc) {
                    for (const node2 of current.jsDoc)if (node2.tags) {
                        for (const tag of node2.tags)if (isJSDocOverloadTag(tag)) hasOverloads = true;
                    }
                }
            }
            if (multipleConstructorImplementation) forEach(functionDeclarations, (declaration)=>{
                error(declaration, Diagnostics.Multiple_constructor_implementations_are_not_allowed);
            });
            if (duplicateFunctionDeclaration) forEach(functionDeclarations, (declaration)=>{
                error(getNameOfDeclaration(declaration) || declaration, Diagnostics.Duplicate_function_implementation);
            });
            if (hasNonAmbientClass && !isConstructor && symbol.flags & 16 /* Function */  && declarations) {
                const relatedDiagnostics = filter(declarations, (d)=>d.kind === 262 /* ClassDeclaration */ ).map((d)=>createDiagnosticForNode(d, Diagnostics.Consider_adding_a_declare_modifier_to_this_class));
                forEach(declarations, (declaration)=>{
                    const diagnostic = declaration.kind === 262 /* ClassDeclaration */  ? Diagnostics.Class_declaration_cannot_implement_overload_list_for_0 : declaration.kind === 261 /* FunctionDeclaration */  ? Diagnostics.Function_with_bodies_can_only_merge_with_classes_that_are_ambient : void 0;
                    if (diagnostic) addRelatedInfo(error(getNameOfDeclaration(declaration) || declaration, diagnostic, symbolName(symbol)), ...relatedDiagnostics);
                });
            }
            if (lastSeenNonAmbientDeclaration && !lastSeenNonAmbientDeclaration.body && !hasSyntacticModifier(lastSeenNonAmbientDeclaration, 256 /* Abstract */ ) && !lastSeenNonAmbientDeclaration.questionToken) reportImplementationExpectedError(lastSeenNonAmbientDeclaration);
            if (hasOverloads) {
                if (declarations) {
                    checkFlagAgreementBetweenOverloads(declarations, bodyDeclaration, flagsToCheck, someNodeFlags, allNodeFlags);
                    checkQuestionTokenAgreementBetweenOverloads(declarations, bodyDeclaration, someHaveQuestionToken, allHaveQuestionToken);
                }
                if (bodyDeclaration) {
                    const signatures = getSignaturesOfSymbol(symbol);
                    const bodySignature = getSignatureFromDeclaration(bodyDeclaration);
                    for (const signature of signatures)if (!isImplementationCompatibleWithOverload(bodySignature, signature)) {
                        const errorNode = signature.declaration && isJSDocSignature(signature.declaration) ? signature.declaration.parent.tagName : signature.declaration;
                        addRelatedInfo(error(errorNode, Diagnostics.This_overload_signature_is_not_compatible_with_its_implementation_signature), createDiagnosticForNode(bodyDeclaration, Diagnostics.The_implementation_signature_is_declared_here));
                        break;
                    }
                }
            }
        }
        function checkExportsOnMergedDeclarations(node) {
            addLazyDiagnostic(()=>checkExportsOnMergedDeclarationsWorker(node));
        }
        function checkExportsOnMergedDeclarationsWorker(node) {
            let symbol = node.localSymbol;
            if (!symbol) {
                symbol = getSymbolOfDeclaration(node);
                if (!symbol.exportSymbol) return;
            }
            if (getDeclarationOfKind(symbol, node.kind) !== node) return;
            let exportedDeclarationSpaces = 0 /* None */ ;
            let nonExportedDeclarationSpaces = 0 /* None */ ;
            let defaultExportedDeclarationSpaces = 0 /* None */ ;
            for (const d of symbol.declarations){
                const declarationSpaces = getDeclarationSpaces(d);
                const effectiveDeclarationFlags = getEffectiveDeclarationFlags(d, 1025 /* Default */ );
                if (effectiveDeclarationFlags & 1 /* Export */ ) {
                    if (effectiveDeclarationFlags & 1024 /* Default */ ) defaultExportedDeclarationSpaces |= declarationSpaces;
                    else exportedDeclarationSpaces |= declarationSpaces;
                } else nonExportedDeclarationSpaces |= declarationSpaces;
            }
            const nonDefaultExportedDeclarationSpaces = exportedDeclarationSpaces | nonExportedDeclarationSpaces;
            const commonDeclarationSpacesForExportsAndLocals = exportedDeclarationSpaces & nonExportedDeclarationSpaces;
            const commonDeclarationSpacesForDefaultAndNonDefault = defaultExportedDeclarationSpaces & nonDefaultExportedDeclarationSpaces;
            if (commonDeclarationSpacesForExportsAndLocals || commonDeclarationSpacesForDefaultAndNonDefault) for (const d of symbol.declarations){
                const declarationSpaces = getDeclarationSpaces(d);
                const name = getNameOfDeclaration(d);
                if (declarationSpaces & commonDeclarationSpacesForDefaultAndNonDefault) error(name, Diagnostics.Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_default_0_declaration_instead, declarationNameToString(name));
                else if (declarationSpaces & commonDeclarationSpacesForExportsAndLocals) error(name, Diagnostics.Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local, declarationNameToString(name));
            }
            function getDeclarationSpaces(decl) {
                let d = decl;
                switch(d.kind){
                    case 263 /* InterfaceDeclaration */ :
                    case 264 /* TypeAliasDeclaration */ :
                    case 352 /* JSDocTypedefTag */ :
                    case 344 /* JSDocCallbackTag */ :
                    case 346 /* JSDocEnumTag */ :
                        return 2 /* ExportType */ ;
                    case 266 /* ModuleDeclaration */ :
                        return isAmbientModule(d) || getModuleInstanceState(d) !== 0 /* NonInstantiated */  ? 5 /* ExportValue */  : 4 /* ExportNamespace */ ;
                    case 262 /* ClassDeclaration */ :
                    case 265 /* EnumDeclaration */ :
                    case 305 /* EnumMember */ :
                        return 3 /* ExportValue */ ;
                    case 311 /* SourceFile */ :
                        return 7 /* ExportNamespace */ ;
                    case 276 /* ExportAssignment */ :
                    case 225 /* BinaryExpression */ :
                        const node2 = d;
                        const expression = isExportAssignment(node2) ? node2.expression : node2.right;
                        if (!isEntityNameExpression(expression)) return 1 /* ExportValue */ ;
                        d = expression;
                    case 270 /* ImportEqualsDeclaration */ :
                    case 273 /* NamespaceImport */ :
                    case 272 /* ImportClause */ :
                        let result = 0 /* None */ ;
                        const target = resolveAlias(getSymbolOfDeclaration(d));
                        forEach(target.declarations, (d2)=>{
                            result |= getDeclarationSpaces(d2);
                        });
                        return result;
                    case 259 /* VariableDeclaration */ :
                    case 207 /* BindingElement */ :
                    case 261 /* FunctionDeclaration */ :
                    case 275 /* ImportSpecifier */ :
                    case 80 /* Identifier */ :
                        return 1 /* ExportValue */ ;
                    case 172 /* MethodSignature */ :
                    case 170 /* PropertySignature */ :
                        return 2 /* ExportType */ ;
                    default:
                        return Debug.failBadSyntaxKind(d);
                }
            }
        }
        function getAwaitedTypeOfPromise(type, errorNode, diagnosticMessage, ...args) {
            const promisedType = getPromisedTypeOfPromise(type, errorNode);
            return promisedType && getAwaitedType(promisedType, errorNode, diagnosticMessage, ...args);
        }
        function getPromisedTypeOfPromise(type, errorNode, thisTypeForErrorOut) {
            if (isTypeAny(type)) return void 0;
            const typeAsPromise = type;
            if (typeAsPromise.promisedTypeOfPromise) return typeAsPromise.promisedTypeOfPromise;
            if (isReferenceToType2(type, getGlobalPromiseType(/*reportErrors*/ false))) return typeAsPromise.promisedTypeOfPromise = getTypeArguments(type)[0];
            if (allTypesAssignableToKind(getBaseConstraintOrType(type), 402915324 /* Never */ )) return void 0;
            const thenFunction = getTypeOfPropertyOfType(type, "then");
            if (isTypeAny(thenFunction)) return void 0;
            const thenSignatures = thenFunction ? getSignaturesOfType(thenFunction, 0 /* Call */ ) : emptyArray;
            if (thenSignatures.length === 0) {
                if (errorNode) error(errorNode, Diagnostics.A_promise_must_have_a_then_method);
                return void 0;
            }
            let thisTypeForError;
            let candidates;
            for (const thenSignature of thenSignatures){
                const thisType = getThisTypeOfSignature(thenSignature);
                if (thisType && thisType !== voidType && !isTypeRelatedTo(type, thisType, subtypeRelation)) thisTypeForError = thisType;
                else candidates = append(candidates, thenSignature);
            }
            if (!candidates) {
                Debug.assertIsDefined(thisTypeForError);
                if (thisTypeForErrorOut) thisTypeForErrorOut.value = thisTypeForError;
                if (errorNode) error(errorNode, Diagnostics.The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1, typeToString(type), typeToString(thisTypeForError));
                return void 0;
            }
            const onfulfilledParameterType = getTypeWithFacts(getUnionType(map(candidates, getTypeOfFirstParameterOfSignature)), 2097152 /* NEUndefinedOrNull */ );
            if (isTypeAny(onfulfilledParameterType)) return void 0;
            const onfulfilledParameterSignatures = getSignaturesOfType(onfulfilledParameterType, 0 /* Call */ );
            if (onfulfilledParameterSignatures.length === 0) {
                if (errorNode) error(errorNode, Diagnostics.The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback);
                return void 0;
            }
            return typeAsPromise.promisedTypeOfPromise = getUnionType(map(onfulfilledParameterSignatures, getTypeOfFirstParameterOfSignature), 2 /* Subtype */ );
        }
        function checkAwaitedType(type, withAlias, errorNode, diagnosticMessage, ...args) {
            const awaitedType = withAlias ? getAwaitedType(type, errorNode, diagnosticMessage, ...args) : getAwaitedTypeNoAlias(type, errorNode, diagnosticMessage, ...args);
            return awaitedType || errorType;
        }
        function isThenableType(type) {
            if (allTypesAssignableToKind(getBaseConstraintOrType(type), 402915324 /* Never */ )) return false;
            const thenFunction = getTypeOfPropertyOfType(type, "then");
            return !!thenFunction && getSignaturesOfType(getTypeWithFacts(thenFunction, 2097152 /* NEUndefinedOrNull */ ), 0 /* Call */ ).length > 0;
        }
        function isAwaitedTypeInstantiation(type) {
            var _a;
            if (type.flags & 16777216 /* Conditional */ ) {
                const awaitedSymbol = getGlobalAwaitedSymbol(/*reportErrors*/ false);
                return !!awaitedSymbol && type.aliasSymbol === awaitedSymbol && ((_a = type.aliasTypeArguments) == null ? void 0 : _a.length) === 1;
            }
            return false;
        }
        function unwrapAwaitedType(type) {
            return type.flags & 1048576 /* Union */  ? mapType(type, unwrapAwaitedType) : isAwaitedTypeInstantiation(type) ? type.aliasTypeArguments[0] : type;
        }
        function isAwaitedTypeNeeded(type) {
            if (isTypeAny(type) || isAwaitedTypeInstantiation(type)) return false;
            if (isGenericObjectType(type)) {
                const baseConstraint = getBaseConstraintOfType(type);
                if (baseConstraint ? baseConstraint.flags & 3 /* AnyOrUnknown */  || isEmptyObjectType(baseConstraint) || someType(baseConstraint, isThenableType) : maybeTypeOfKind(type, 8650752 /* TypeVariable */ )) return true;
            }
            return false;
        }
        function tryCreateAwaitedType(type) {
            const awaitedSymbol = getGlobalAwaitedSymbol(/*reportErrors*/ true);
            if (awaitedSymbol) return getTypeAliasInstantiation(awaitedSymbol, [
                unwrapAwaitedType(type)
            ]);
            return void 0;
        }
        function createAwaitedTypeIfNeeded(type) {
            if (isAwaitedTypeNeeded(type)) {
                const awaitedType = tryCreateAwaitedType(type);
                if (awaitedType) return awaitedType;
            }
            Debug.assert(isAwaitedTypeInstantiation(type) || getPromisedTypeOfPromise(type) === void 0, "type provided should not be a non-generic 'promise'-like.");
            return type;
        }
        function getAwaitedType(type, errorNode, diagnosticMessage, ...args) {
            const awaitedType = getAwaitedTypeNoAlias(type, errorNode, diagnosticMessage, ...args);
            return awaitedType && createAwaitedTypeIfNeeded(awaitedType);
        }
        function getAwaitedTypeNoAlias(type, errorNode, diagnosticMessage, ...args) {
            if (isTypeAny(type)) return type;
            if (isAwaitedTypeInstantiation(type)) return type;
            const typeAsAwaitable = type;
            if (typeAsAwaitable.awaitedTypeOfType) return typeAsAwaitable.awaitedTypeOfType;
            if (type.flags & 1048576 /* Union */ ) {
                if (awaitedTypeStack.lastIndexOf(type.id) >= 0) {
                    if (errorNode) error(errorNode, Diagnostics.Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method);
                    return void 0;
                }
                const mapper = errorNode ? (constituentType)=>getAwaitedTypeNoAlias(constituentType, errorNode, diagnosticMessage, ...args) : getAwaitedTypeNoAlias;
                awaitedTypeStack.push(type.id);
                const mapped = mapType(type, mapper);
                awaitedTypeStack.pop();
                return typeAsAwaitable.awaitedTypeOfType = mapped;
            }
            if (isAwaitedTypeNeeded(type)) return typeAsAwaitable.awaitedTypeOfType = type;
            const thisTypeForErrorOut = {
                value: void 0
            };
            const promisedType = getPromisedTypeOfPromise(type, /*errorNode*/ void 0, thisTypeForErrorOut);
            if (promisedType) {
                if (type.id === promisedType.id || awaitedTypeStack.lastIndexOf(promisedType.id) >= 0) {
                    if (errorNode) error(errorNode, Diagnostics.Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method);
                    return void 0;
                }
                awaitedTypeStack.push(type.id);
                const awaitedType = getAwaitedTypeNoAlias(promisedType, errorNode, diagnosticMessage, ...args);
                awaitedTypeStack.pop();
                if (!awaitedType) return void 0;
                return typeAsAwaitable.awaitedTypeOfType = awaitedType;
            }
            if (isThenableType(type)) {
                if (errorNode) {
                    Debug.assertIsDefined(diagnosticMessage);
                    let chain;
                    if (thisTypeForErrorOut.value) chain = chainDiagnosticMessages(chain, Diagnostics.The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1, typeToString(type), typeToString(thisTypeForErrorOut.value));
                    chain = chainDiagnosticMessages(chain, diagnosticMessage, ...args);
                    diagnostics.add(createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(errorNode), errorNode, chain));
                }
                return void 0;
            }
            return typeAsAwaitable.awaitedTypeOfType = type;
        }
        function checkAsyncFunctionReturnType(node, returnTypeNode) {
            const returnType = getTypeFromTypeNode(returnTypeNode);
            if (languageVersion >= 2 /* ES2015 */ ) {
                if (isErrorType(returnType)) return;
                const globalPromiseType = getGlobalPromiseType(/*reportErrors*/ true);
                if (globalPromiseType !== emptyGenericType && !isReferenceToType2(returnType, globalPromiseType)) {
                    error(returnTypeNode, Diagnostics.The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type_Did_you_mean_to_write_Promise_0, typeToString(getAwaitedTypeNoAlias(returnType) || voidType));
                    return;
                }
            } else {
                markTypeNodeAsReferenced(returnTypeNode);
                if (isErrorType(returnType)) return;
                const promiseConstructorName = getEntityNameFromTypeNode(returnTypeNode);
                if (promiseConstructorName === void 0) {
                    error(returnTypeNode, Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, typeToString(returnType));
                    return;
                }
                const promiseConstructorSymbol = resolveEntityName(promiseConstructorName, 111551 /* Value */ , /*ignoreErrors*/ true);
                const promiseConstructorType = promiseConstructorSymbol ? getTypeOfSymbol(promiseConstructorSymbol) : errorType;
                if (isErrorType(promiseConstructorType)) {
                    if (promiseConstructorName.kind === 80 /* Identifier */  && promiseConstructorName.escapedText === "Promise" && getTargetType(returnType) === getGlobalPromiseType(/*reportErrors*/ false)) error(returnTypeNode, Diagnostics.An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option);
                    else error(returnTypeNode, Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, entityNameToString(promiseConstructorName));
                    return;
                }
                const globalPromiseConstructorLikeType = getGlobalPromiseConstructorLikeType(/*reportErrors*/ true);
                if (globalPromiseConstructorLikeType === emptyObjectType) {
                    error(returnTypeNode, Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, entityNameToString(promiseConstructorName));
                    return;
                }
                if (!checkTypeAssignableTo(promiseConstructorType, globalPromiseConstructorLikeType, returnTypeNode, Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value)) return;
                const rootName = promiseConstructorName && getFirstIdentifier(promiseConstructorName);
                const collidingSymbol = getSymbol2(node.locals, rootName.escapedText, 111551 /* Value */ );
                if (collidingSymbol) {
                    error(collidingSymbol.valueDeclaration, Diagnostics.Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions, idText(rootName), entityNameToString(promiseConstructorName));
                    return;
                }
            }
            checkAwaitedType(returnType, /*withAlias*/ false, node, Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
        }
        function checkDecorator(node) {
            const signature = getResolvedSignature(node);
            checkDeprecatedSignature(signature, node);
            const returnType = getReturnTypeOfSignature(signature);
            if (returnType.flags & 1 /* Any */ ) return;
            const decoratorSignature = getDecoratorCallSignature(node);
            if (!(decoratorSignature == null ? void 0 : decoratorSignature.resolvedReturnType)) return;
            let headMessage;
            const expectedReturnType = decoratorSignature.resolvedReturnType;
            switch(node.parent.kind){
                case 262 /* ClassDeclaration */ :
                case 230 /* ClassExpression */ :
                    headMessage = Diagnostics.Decorator_function_return_type_0_is_not_assignable_to_type_1;
                    break;
                case 171 /* PropertyDeclaration */ :
                    if (!legacyDecorators) {
                        headMessage = Diagnostics.Decorator_function_return_type_0_is_not_assignable_to_type_1;
                        break;
                    }
                case 168 /* Parameter */ :
                    headMessage = Diagnostics.Decorator_function_return_type_is_0_but_is_expected_to_be_void_or_any;
                    break;
                case 173 /* MethodDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    headMessage = Diagnostics.Decorator_function_return_type_0_is_not_assignable_to_type_1;
                    break;
                default:
                    return Debug.failBadSyntaxKind(node.parent);
            }
            checkTypeAssignableTo(returnType, expectedReturnType, node.expression, headMessage);
        }
        function createCallSignature(typeParameters, thisParameter, parameters, returnType, typePredicate, minArgumentCount = parameters.length, flags = 0 /* None */ ) {
            const decl = factory.createFunctionTypeNode(/*typeParameters*/ void 0, emptyArray, factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
            return createSignature(decl, typeParameters, thisParameter, parameters, returnType, typePredicate, minArgumentCount, flags);
        }
        function createFunctionType(typeParameters, thisParameter, parameters, returnType, typePredicate, minArgumentCount, flags) {
            const signature = createCallSignature(typeParameters, thisParameter, parameters, returnType, typePredicate, minArgumentCount, flags);
            return getOrCreateTypeFromSignature(signature);
        }
        function createGetterFunctionType(type) {
            return createFunctionType(/*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, type);
        }
        function createSetterFunctionType(type) {
            const valueParam = createParameter("value", type);
            return createFunctionType(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                valueParam
            ], voidType);
        }
        function markTypeNodeAsReferenced(node) {
            markEntityNameOrEntityExpressionAsReference(node && getEntityNameFromTypeNode(node), /*forDecoratorMetadata*/ false);
        }
        function markEntityNameOrEntityExpressionAsReference(typeName, forDecoratorMetadata) {
            if (!typeName) return;
            const rootName = getFirstIdentifier(typeName);
            const meaning = (typeName.kind === 80 /* Identifier */  ? 788968 /* Type */  : 1920 /* Namespace */ ) | 2097152 /* Alias */ ;
            const rootSymbol = resolveName(rootName, rootName.escapedText, meaning, /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ true);
            if (rootSymbol && rootSymbol.flags & 2097152 /* Alias */ ) {
                if (canCollectSymbolAliasAccessabilityData && symbolIsValue(rootSymbol) && !isConstEnumOrConstEnumOnlyModule(resolveAlias(rootSymbol)) && !getTypeOnlyAliasDeclaration(rootSymbol)) markAliasSymbolAsReferenced(rootSymbol);
                else if (forDecoratorMetadata && getIsolatedModules(compilerOptions) && getEmitModuleKind(compilerOptions) >= 5 /* ES2015 */  && !symbolIsValue(rootSymbol) && !some(rootSymbol.declarations, isTypeOnlyImportOrExportDeclaration)) {
                    const diag2 = error(typeName, Diagnostics.A_type_referenced_in_a_decorated_signature_must_be_imported_with_import_type_or_a_namespace_import_when_isolatedModules_and_emitDecoratorMetadata_are_enabled);
                    const aliasDeclaration = find(rootSymbol.declarations || emptyArray, isAliasSymbolDeclaration2);
                    if (aliasDeclaration) addRelatedInfo(diag2, createDiagnosticForNode(aliasDeclaration, Diagnostics._0_was_imported_here, idText(rootName)));
                }
            }
        }
        function markDecoratorMedataDataTypeNodeAsReferenced(node) {
            const entityName = getEntityNameForDecoratorMetadata(node);
            if (entityName && isEntityName(entityName)) markEntityNameOrEntityExpressionAsReference(entityName, /*forDecoratorMetadata*/ true);
        }
        function getEntityNameForDecoratorMetadata(node) {
            if (node) switch(node.kind){
                case 192 /* IntersectionType */ :
                case 191 /* UnionType */ :
                    return getEntityNameForDecoratorMetadataFromTypeList(node.types);
                case 193 /* ConditionalType */ :
                    return getEntityNameForDecoratorMetadataFromTypeList([
                        node.trueType,
                        node.falseType
                    ]);
                case 195 /* ParenthesizedType */ :
                case 201 /* NamedTupleMember */ :
                    return getEntityNameForDecoratorMetadata(node.type);
                case 182 /* TypeReference */ :
                    return node.typeName;
            }
        }
        function getEntityNameForDecoratorMetadataFromTypeList(types) {
            let commonEntityName;
            for (let typeNode of types){
                while(typeNode.kind === 195 /* ParenthesizedType */  || typeNode.kind === 201 /* NamedTupleMember */ )typeNode = typeNode.type;
                if (typeNode.kind === 146 /* NeverKeyword */ ) continue;
                if (!strictNullChecks && (typeNode.kind === 200 /* LiteralType */  && typeNode.literal.kind === 106 /* NullKeyword */  || typeNode.kind === 157 /* UndefinedKeyword */ )) continue;
                const individualEntityName = getEntityNameForDecoratorMetadata(typeNode);
                if (!individualEntityName) return void 0;
                if (commonEntityName) {
                    if (!isIdentifier(commonEntityName) || !isIdentifier(individualEntityName) || commonEntityName.escapedText !== individualEntityName.escapedText) return void 0;
                } else commonEntityName = individualEntityName;
            }
            return commonEntityName;
        }
        function getParameterTypeNodeForDecoratorCheck(node) {
            const typeNode = getEffectiveTypeAnnotationNode(node);
            return isRestParameter(node) ? getRestParameterElementType(typeNode) : typeNode;
        }
        function checkDecorators(node) {
            if (!canHaveDecorators(node) || !hasDecorators(node) || !node.modifiers || !nodeCanBeDecorated(legacyDecorators, node, node.parent, node.parent.parent)) return;
            const firstDecorator = find(node.modifiers, isDecorator);
            if (!firstDecorator) return;
            if (legacyDecorators) {
                checkExternalEmitHelpers(firstDecorator, 8 /* Decorate */ );
                if (node.kind === 168 /* Parameter */ ) checkExternalEmitHelpers(firstDecorator, 32 /* Param */ );
            } else if (languageVersion < 99 /* ESNext */ ) {
                checkExternalEmitHelpers(firstDecorator, 8 /* ESDecorateAndRunInitializers */ );
                if (isClassDeclaration(node)) {
                    if (!node.name) checkExternalEmitHelpers(firstDecorator, 8388608 /* SetFunctionName */ );
                    else {
                        const member = getFirstTransformableStaticClassElement(node);
                        if (member) checkExternalEmitHelpers(firstDecorator, 8388608 /* SetFunctionName */ );
                    }
                } else if (!isClassExpression(node)) {
                    if (isPrivateIdentifier(node.name) && (isMethodDeclaration(node) || isAccessor(node) || isAutoAccessorPropertyDeclaration(node))) checkExternalEmitHelpers(firstDecorator, 8388608 /* SetFunctionName */ );
                    if (isComputedPropertyName(node.name)) checkExternalEmitHelpers(firstDecorator, 16777216 /* PropKey */ );
                }
            }
            if (compilerOptions.emitDecoratorMetadata) {
                checkExternalEmitHelpers(firstDecorator, 16 /* Metadata */ );
                switch(node.kind){
                    case 262 /* ClassDeclaration */ :
                        const constructor = getFirstConstructorWithBody(node);
                        if (constructor) for (const parameter of constructor.parameters)markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
                        break;
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                        const otherKind = node.kind === 176 /* GetAccessor */  ? 177 /* SetAccessor */  : 176 /* GetAccessor */ ;
                        const otherAccessor = getDeclarationOfKind(getSymbolOfDeclaration(node), otherKind);
                        markDecoratorMedataDataTypeNodeAsReferenced(getAnnotatedAccessorTypeNode(node) || otherAccessor && getAnnotatedAccessorTypeNode(otherAccessor));
                        break;
                    case 173 /* MethodDeclaration */ :
                        for (const parameter of node.parameters)markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
                        markDecoratorMedataDataTypeNodeAsReferenced(getEffectiveReturnTypeNode(node));
                        break;
                    case 171 /* PropertyDeclaration */ :
                        markDecoratorMedataDataTypeNodeAsReferenced(getEffectiveTypeAnnotationNode(node));
                        break;
                    case 168 /* Parameter */ :
                        markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(node));
                        const containingSignature = node.parent;
                        for (const parameter of containingSignature.parameters)markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
                        break;
                }
            }
            for (const modifier of node.modifiers)if (isDecorator(modifier)) checkDecorator(modifier);
        }
        function checkFunctionDeclaration(node) {
            addLazyDiagnostic(checkFunctionDeclarationDiagnostics);
            function checkFunctionDeclarationDiagnostics() {
                checkFunctionOrMethodDeclaration(node);
                checkGrammarForGenerator(node);
                checkCollisionsForDeclarationName(node, node.name);
            }
        }
        function checkJSDocTypeAliasTag(node) {
            if (!node.typeExpression) error(node.name, Diagnostics.JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags);
            if (node.name) checkTypeNameIsReserved(node.name, Diagnostics.Type_alias_name_cannot_be_0);
            checkSourceElement(node.typeExpression);
            checkTypeParameters(getEffectiveTypeParameterDeclarations(node));
        }
        function checkJSDocTemplateTag(node) {
            checkSourceElement(node.constraint);
            for (const tp of node.typeParameters)checkSourceElement(tp);
        }
        function checkJSDocTypeTag(node) {
            checkSourceElement(node.typeExpression);
        }
        function checkJSDocSatisfiesTag(node) {
            checkSourceElement(node.typeExpression);
            const host2 = getEffectiveJSDocHost(node);
            if (host2) {
                const tags = getAllJSDocTags(host2, isJSDocSatisfiesTag);
                if (length(tags) > 1) for(let i = 1; i < length(tags); i++){
                    const tagName = tags[i].tagName;
                    error(tagName, Diagnostics._0_tag_already_specified, idText(tagName));
                }
            }
        }
        function checkJSDocLinkLikeTag(node) {
            if (node.name) resolveJSDocMemberName(node.name, /*ignoreErrors*/ true);
        }
        function checkJSDocParameterTag(node) {
            checkSourceElement(node.typeExpression);
        }
        function checkJSDocPropertyTag(node) {
            checkSourceElement(node.typeExpression);
        }
        function checkJSDocFunctionType(node) {
            addLazyDiagnostic(checkJSDocFunctionTypeImplicitAny);
            checkSignatureDeclaration(node);
            function checkJSDocFunctionTypeImplicitAny() {
                if (!node.type && !isJSDocConstructSignature(node)) reportImplicitAny(node, anyType);
            }
        }
        function checkJSDocImplementsTag(node) {
            const classLike = getEffectiveJSDocHost(node);
            if (!classLike || !isClassDeclaration(classLike) && !isClassExpression(classLike)) error(classLike, Diagnostics.JSDoc_0_is_not_attached_to_a_class, idText(node.tagName));
        }
        function checkJSDocAugmentsTag(node) {
            const classLike = getEffectiveJSDocHost(node);
            if (!classLike || !isClassDeclaration(classLike) && !isClassExpression(classLike)) {
                error(classLike, Diagnostics.JSDoc_0_is_not_attached_to_a_class, idText(node.tagName));
                return;
            }
            const augmentsTags = getJSDocTags(classLike).filter(isJSDocAugmentsTag);
            Debug.assert(augmentsTags.length > 0);
            if (augmentsTags.length > 1) error(augmentsTags[1], Diagnostics.Class_declarations_cannot_have_more_than_one_augments_or_extends_tag);
            const name = getIdentifierFromEntityNameExpression(node.class.expression);
            const extend2 = getClassExtendsHeritageElement(classLike);
            if (extend2) {
                const className = getIdentifierFromEntityNameExpression(extend2.expression);
                if (className && name.escapedText !== className.escapedText) error(name, Diagnostics.JSDoc_0_1_does_not_match_the_extends_2_clause, idText(node.tagName), idText(name), idText(className));
            }
        }
        function checkJSDocAccessibilityModifiers(node) {
            const host2 = getJSDocHost(node);
            if (host2 && isPrivateIdentifierClassElementDeclaration(host2)) error(node, Diagnostics.An_accessibility_modifier_cannot_be_used_with_a_private_identifier);
        }
        function getIdentifierFromEntityNameExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return node;
                case 210 /* PropertyAccessExpression */ :
                    return node.name;
                default:
                    return void 0;
            }
        }
        function checkFunctionOrMethodDeclaration(node) {
            var _a;
            checkDecorators(node);
            checkSignatureDeclaration(node);
            const functionFlags = getFunctionFlags(node);
            if (node.name && node.name.kind === 166 /* ComputedPropertyName */ ) checkComputedPropertyName(node.name);
            if (hasBindableName(node)) {
                const symbol = getSymbolOfDeclaration(node);
                const localSymbol = node.localSymbol || symbol;
                const firstDeclaration = (_a = localSymbol.declarations) == null ? void 0 : _a.find(// Get first non javascript function declaration
                (declaration)=>declaration.kind === node.kind && !(declaration.flags & 262144 /* JavaScriptFile */ ));
                if (node === firstDeclaration) checkFunctionOrConstructorSymbol(localSymbol);
                if (symbol.parent) checkFunctionOrConstructorSymbol(symbol);
            }
            const body = node.kind === 172 /* MethodSignature */  ? void 0 : node.body;
            checkSourceElement(body);
            checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, getReturnTypeFromAnnotation(node));
            addLazyDiagnostic(checkFunctionOrMethodDeclarationDiagnostics);
            if (isInJSFile(node)) {
                const typeTag = getJSDocTypeTag(node);
                if (typeTag && typeTag.typeExpression && !getContextualCallSignature(getTypeFromTypeNode(typeTag.typeExpression), node)) error(typeTag.typeExpression.type, Diagnostics.The_type_of_a_function_declaration_must_match_the_function_s_signature);
            }
            function checkFunctionOrMethodDeclarationDiagnostics() {
                if (!getEffectiveReturnTypeNode(node)) {
                    if (nodeIsMissing(body) && !isPrivateWithinAmbient(node)) reportImplicitAny(node, anyType);
                    if (functionFlags & 1 /* Generator */  && nodeIsPresent(body)) getReturnTypeOfSignature(getSignatureFromDeclaration(node));
                }
            }
        }
        function registerForUnusedIdentifiersCheck(node) {
            addLazyDiagnostic(registerForUnusedIdentifiersCheckDiagnostics);
            function registerForUnusedIdentifiersCheckDiagnostics() {
                const sourceFile = getSourceFileOfNode(node);
                let potentiallyUnusedIdentifiers = allPotentiallyUnusedIdentifiers.get(sourceFile.path);
                if (!potentiallyUnusedIdentifiers) {
                    potentiallyUnusedIdentifiers = [];
                    allPotentiallyUnusedIdentifiers.set(sourceFile.path, potentiallyUnusedIdentifiers);
                }
                potentiallyUnusedIdentifiers.push(node);
            }
        }
        function checkUnusedIdentifiers(potentiallyUnusedIdentifiers, addDiagnostic) {
            for (const node of potentiallyUnusedIdentifiers)switch(node.kind){
                case 262 /* ClassDeclaration */ :
                case 230 /* ClassExpression */ :
                    checkUnusedClassMembers(node, addDiagnostic);
                    checkUnusedTypeParameters(node, addDiagnostic);
                    break;
                case 311 /* SourceFile */ :
                case 266 /* ModuleDeclaration */ :
                case 240 /* Block */ :
                case 268 /* CaseBlock */ :
                case 247 /* ForStatement */ :
                case 248 /* ForInStatement */ :
                case 249 /* ForOfStatement */ :
                    checkUnusedLocalsAndParameters(node, addDiagnostic);
                    break;
                case 175 /* Constructor */ :
                case 217 /* FunctionExpression */ :
                case 261 /* FunctionDeclaration */ :
                case 218 /* ArrowFunction */ :
                case 173 /* MethodDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    if (node.body) checkUnusedLocalsAndParameters(node, addDiagnostic);
                    checkUnusedTypeParameters(node, addDiagnostic);
                    break;
                case 172 /* MethodSignature */ :
                case 178 /* CallSignature */ :
                case 179 /* ConstructSignature */ :
                case 183 /* FunctionType */ :
                case 184 /* ConstructorType */ :
                case 264 /* TypeAliasDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                    checkUnusedTypeParameters(node, addDiagnostic);
                    break;
                case 194 /* InferType */ :
                    checkUnusedInferTypeParameter(node, addDiagnostic);
                    break;
                default:
                    Debug.assertNever(node, "Node should not have been registered for unused identifiers check");
            }
        }
        function errorUnusedLocal(declaration, name, addDiagnostic) {
            const node = getNameOfDeclaration(declaration) || declaration;
            const message = isTypeDeclaration(declaration) ? Diagnostics._0_is_declared_but_never_used : Diagnostics._0_is_declared_but_its_value_is_never_read;
            addDiagnostic(declaration, 0 /* Local */ , createDiagnosticForNode(node, message, name));
        }
        function isIdentifierThatStartsWithUnderscore(node) {
            return isIdentifier(node) && idText(node).charCodeAt(0) === 95 /* _ */ ;
        }
        function checkUnusedClassMembers(node, addDiagnostic) {
            for (const member of node.members)switch(member.kind){
                case 173 /* MethodDeclaration */ :
                case 171 /* PropertyDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    if (member.kind === 177 /* SetAccessor */  && member.symbol.flags & 32768 /* GetAccessor */ ) break;
                    const symbol = getSymbolOfDeclaration(member);
                    if (!symbol.isReferenced && (hasEffectiveModifier(member, 8 /* Private */ ) || isNamedDeclaration(member) && isPrivateIdentifier(member.name)) && !(member.flags & 16777216 /* Ambient */ )) addDiagnostic(member, 0 /* Local */ , createDiagnosticForNode(member.name, Diagnostics._0_is_declared_but_its_value_is_never_read, symbolToString(symbol)));
                    break;
                case 175 /* Constructor */ :
                    for (const parameter of member.parameters)if (!parameter.symbol.isReferenced && hasSyntacticModifier(parameter, 8 /* Private */ )) addDiagnostic(parameter, 0 /* Local */ , createDiagnosticForNode(parameter.name, Diagnostics.Property_0_is_declared_but_its_value_is_never_read, symbolName(parameter.symbol)));
                    break;
                case 180 /* IndexSignature */ :
                case 239 /* SemicolonClassElement */ :
                case 174 /* ClassStaticBlockDeclaration */ :
                    break;
                default:
                    Debug.fail("Unexpected class member");
            }
        }
        function checkUnusedInferTypeParameter(node, addDiagnostic) {
            const { typeParameter: typeParameter  } = node;
            if (isTypeParameterUnused(typeParameter)) addDiagnostic(node, 1 /* Parameter */ , createDiagnosticForNode(node, Diagnostics._0_is_declared_but_its_value_is_never_read, idText(typeParameter.name)));
        }
        function checkUnusedTypeParameters(node, addDiagnostic) {
            const declarations = getSymbolOfDeclaration(node).declarations;
            if (!declarations || last(declarations) !== node) return;
            const typeParameters = getEffectiveTypeParameterDeclarations(node);
            const seenParentsWithEveryUnused = /* @__PURE__ */ new Set();
            for (const typeParameter of typeParameters){
                if (!isTypeParameterUnused(typeParameter)) continue;
                const name = idText(typeParameter.name);
                const { parent: parent2  } = typeParameter;
                if (parent2.kind !== 194 /* InferType */  && parent2.typeParameters.every(isTypeParameterUnused)) {
                    if (tryAddToSet(seenParentsWithEveryUnused, parent2)) {
                        const sourceFile = getSourceFileOfNode(parent2);
                        const range = isJSDocTemplateTag(parent2) ? rangeOfNode(parent2) : rangeOfTypeParameters(sourceFile, parent2.typeParameters);
                        const only = parent2.typeParameters.length === 1;
                        const messageAndArg = only ? [
                            Diagnostics._0_is_declared_but_its_value_is_never_read,
                            name
                        ] : [
                            Diagnostics.All_type_parameters_are_unused
                        ];
                        addDiagnostic(typeParameter, 1 /* Parameter */ , createFileDiagnostic(sourceFile, range.pos, range.end - range.pos, ...messageAndArg));
                    }
                } else addDiagnostic(typeParameter, 1 /* Parameter */ , createDiagnosticForNode(typeParameter, Diagnostics._0_is_declared_but_its_value_is_never_read, name));
            }
        }
        function isTypeParameterUnused(typeParameter) {
            return !(getMergedSymbol(typeParameter.symbol).isReferenced & 262144 /* TypeParameter */ ) && !isIdentifierThatStartsWithUnderscore(typeParameter.name);
        }
        function addToGroup(map2, key, value1, getKey) {
            const keyString = String(getKey(key));
            const group2 = map2.get(keyString);
            if (group2) group2[1].push(value1);
            else map2.set(keyString, [
                key,
                [
                    value1
                ]
            ]);
        }
        function tryGetRootParameterDeclaration(node) {
            return tryCast(getRootDeclaration(node), isParameter);
        }
        function isValidUnusedLocalDeclaration(declaration) {
            if (isBindingElement(declaration)) {
                if (isObjectBindingPattern(declaration.parent)) return !!(declaration.propertyName && isIdentifierThatStartsWithUnderscore(declaration.name));
                return isIdentifierThatStartsWithUnderscore(declaration.name);
            }
            return isAmbientModule(declaration) || (isVariableDeclaration(declaration) && isForInOrOfStatement(declaration.parent.parent) || isImportedDeclaration(declaration)) && isIdentifierThatStartsWithUnderscore(declaration.name);
        }
        function checkUnusedLocalsAndParameters(nodeWithLocals, addDiagnostic) {
            const unusedImports = /* @__PURE__ */ new Map();
            const unusedDestructures = /* @__PURE__ */ new Map();
            const unusedVariables = /* @__PURE__ */ new Map();
            nodeWithLocals.locals.forEach((local)=>{
                if (local.flags & 262144 /* TypeParameter */  ? !(local.flags & 3 /* Variable */  && !(local.isReferenced & 3 /* Variable */ )) : local.isReferenced || local.exportSymbol) return;
                if (local.declarations) for (const declaration of local.declarations){
                    if (isValidUnusedLocalDeclaration(declaration)) continue;
                    if (isImportedDeclaration(declaration)) addToGroup(unusedImports, importClauseFromImported(declaration), declaration, getNodeId);
                    else if (isBindingElement(declaration) && isObjectBindingPattern(declaration.parent)) {
                        const lastElement = last(declaration.parent.elements);
                        if (declaration === lastElement || !last(declaration.parent.elements).dotDotDotToken) addToGroup(unusedDestructures, declaration.parent, declaration, getNodeId);
                    } else if (isVariableDeclaration(declaration)) addToGroup(unusedVariables, declaration.parent, declaration, getNodeId);
                    else {
                        const parameter = local.valueDeclaration && tryGetRootParameterDeclaration(local.valueDeclaration);
                        const name = local.valueDeclaration && getNameOfDeclaration(local.valueDeclaration);
                        if (parameter && name) {
                            if (!isParameterPropertyDeclaration(parameter, parameter.parent) && !parameterIsThisKeyword(parameter) && !isIdentifierThatStartsWithUnderscore(name)) {
                                if (isBindingElement(declaration) && isArrayBindingPattern(declaration.parent)) addToGroup(unusedDestructures, declaration.parent, declaration, getNodeId);
                                else addDiagnostic(parameter, 1 /* Parameter */ , createDiagnosticForNode(name, Diagnostics._0_is_declared_but_its_value_is_never_read, symbolName(local)));
                            }
                        } else errorUnusedLocal(declaration, symbolName(local), addDiagnostic);
                    }
                }
            });
            unusedImports.forEach(([importClause, unuseds])=>{
                const importDecl = importClause.parent;
                const nDeclarations = (importClause.name ? 1 : 0) + (importClause.namedBindings ? importClause.namedBindings.kind === 273 /* NamespaceImport */  ? 1 : importClause.namedBindings.elements.length : 0);
                if (nDeclarations === unuseds.length) addDiagnostic(importDecl, 0 /* Local */ , unuseds.length === 1 ? createDiagnosticForNode(importDecl, Diagnostics._0_is_declared_but_its_value_is_never_read, idText(first(unuseds).name)) : createDiagnosticForNode(importDecl, Diagnostics.All_imports_in_import_declaration_are_unused));
                else for (const unused of unuseds)errorUnusedLocal(unused, idText(unused.name), addDiagnostic);
            });
            unusedDestructures.forEach(([bindingPattern, bindingElements])=>{
                const kind = tryGetRootParameterDeclaration(bindingPattern.parent) ? 1 /* Parameter */  : 0 /* Local */ ;
                if (bindingPattern.elements.length === bindingElements.length) {
                    if (bindingElements.length === 1 && bindingPattern.parent.kind === 259 /* VariableDeclaration */  && bindingPattern.parent.parent.kind === 260 /* VariableDeclarationList */ ) addToGroup(unusedVariables, bindingPattern.parent.parent, bindingPattern.parent, getNodeId);
                    else addDiagnostic(bindingPattern, kind, bindingElements.length === 1 ? createDiagnosticForNode(bindingPattern, Diagnostics._0_is_declared_but_its_value_is_never_read, bindingNameText(first(bindingElements).name)) : createDiagnosticForNode(bindingPattern, Diagnostics.All_destructured_elements_are_unused));
                } else for (const e of bindingElements)addDiagnostic(e, kind, createDiagnosticForNode(e, Diagnostics._0_is_declared_but_its_value_is_never_read, bindingNameText(e.name)));
            });
            unusedVariables.forEach(([declarationList, declarations])=>{
                if (declarationList.declarations.length === declarations.length) addDiagnostic(declarationList, 0 /* Local */ , declarations.length === 1 ? createDiagnosticForNode(first(declarations).name, Diagnostics._0_is_declared_but_its_value_is_never_read, bindingNameText(first(declarations).name)) : createDiagnosticForNode(declarationList.parent.kind === 242 /* VariableStatement */  ? declarationList.parent : declarationList, Diagnostics.All_variables_are_unused));
                else for (const decl of declarations)addDiagnostic(decl, 0 /* Local */ , createDiagnosticForNode(decl, Diagnostics._0_is_declared_but_its_value_is_never_read, bindingNameText(decl.name)));
            });
        }
        function checkPotentialUncheckedRenamedBindingElementsInTypes() {
            var _a;
            for (const node of potentialUnusedRenamedBindingElementsInTypes)if (!((_a = getSymbolOfDeclaration(node)) == null ? void 0 : _a.isReferenced)) {
                const wrappingDeclaration = walkUpBindingElementsAndPatterns(node);
                Debug.assert(isParameterDeclaration(wrappingDeclaration), "Only parameter declaration should be checked here");
                const diagnostic = createDiagnosticForNode(node.name, Diagnostics._0_is_an_unused_renaming_of_1_Did_you_intend_to_use_it_as_a_type_annotation, declarationNameToString(node.name), declarationNameToString(node.propertyName));
                if (!wrappingDeclaration.type) addRelatedInfo(diagnostic, createFileDiagnostic(getSourceFileOfNode(wrappingDeclaration), wrappingDeclaration.end, 1, Diagnostics.We_can_only_write_a_type_for_0_by_adding_a_type_for_the_entire_parameter_here, declarationNameToString(node.propertyName)));
                diagnostics.add(diagnostic);
            }
        }
        function bindingNameText(name) {
            switch(name.kind){
                case 80 /* Identifier */ :
                    return idText(name);
                case 206 /* ArrayBindingPattern */ :
                case 205 /* ObjectBindingPattern */ :
                    return bindingNameText(cast(first(name.elements), isBindingElement).name);
                default:
                    return Debug.assertNever(name);
            }
        }
        function isImportedDeclaration(node) {
            return node.kind === 272 /* ImportClause */  || node.kind === 275 /* ImportSpecifier */  || node.kind === 273 /* NamespaceImport */ ;
        }
        function importClauseFromImported(decl) {
            return decl.kind === 272 /* ImportClause */  ? decl : decl.kind === 273 /* NamespaceImport */  ? decl.parent : decl.parent.parent;
        }
        function checkBlock(node) {
            if (node.kind === 240 /* Block */ ) checkGrammarStatementInAmbientContext(node);
            if (isFunctionOrModuleBlock(node)) {
                const saveFlowAnalysisDisabled = flowAnalysisDisabled;
                forEach(node.statements, checkSourceElement);
                flowAnalysisDisabled = saveFlowAnalysisDisabled;
            } else forEach(node.statements, checkSourceElement);
            if (node.locals) registerForUnusedIdentifiersCheck(node);
        }
        function checkCollisionWithArgumentsInGeneratedCode(node) {
            if (languageVersion >= 2 /* ES2015 */  || !hasRestParameter(node) || node.flags & 16777216 /* Ambient */  || nodeIsMissing(node.body)) return;
            forEach(node.parameters, (p)=>{
                if (p.name && !isBindingPattern(p.name) && p.name.escapedText === argumentsSymbol.escapedName) errorSkippedOn("noEmit", p, Diagnostics.Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters);
            });
        }
        function needCollisionCheckForIdentifier(node, identifier, name) {
            if ((identifier == null ? void 0 : identifier.escapedText) !== name) return false;
            if (node.kind === 171 /* PropertyDeclaration */  || node.kind === 170 /* PropertySignature */  || node.kind === 173 /* MethodDeclaration */  || node.kind === 172 /* MethodSignature */  || node.kind === 176 /* GetAccessor */  || node.kind === 177 /* SetAccessor */  || node.kind === 302 /* PropertyAssignment */ ) return false;
            if (node.flags & 16777216 /* Ambient */ ) return false;
            if (isImportClause(node) || isImportEqualsDeclaration(node) || isImportSpecifier(node)) {
                if (isTypeOnlyImportOrExportDeclaration(node)) return false;
            }
            const root = getRootDeclaration(node);
            if (isParameter(root) && nodeIsMissing(root.parent.body)) return false;
            return true;
        }
        function checkIfThisIsCapturedInEnclosingScope(node) {
            findAncestor(node, (current)=>{
                if (getNodeCheckFlags(current) & 4 /* CaptureThis */ ) {
                    const isDeclaration2 = node.kind !== 80 /* Identifier */ ;
                    if (isDeclaration2) error(getNameOfDeclaration(node), Diagnostics.Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference);
                    else error(node, Diagnostics.Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference);
                    return true;
                }
                return false;
            });
        }
        function checkIfNewTargetIsCapturedInEnclosingScope(node) {
            findAncestor(node, (current)=>{
                if (getNodeCheckFlags(current) & 8 /* CaptureNewTarget */ ) {
                    const isDeclaration2 = node.kind !== 80 /* Identifier */ ;
                    if (isDeclaration2) error(getNameOfDeclaration(node), Diagnostics.Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_meta_property_reference);
                    else error(node, Diagnostics.Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta_property_reference);
                    return true;
                }
                return false;
            });
        }
        function checkCollisionWithRequireExportsInGeneratedCode(node, name) {
            if (moduleKind >= 5 /* ES2015 */  && !(moduleKind >= 100 /* Node16 */  && getSourceFileOfNode(node).impliedNodeFormat === 1 /* CommonJS */ )) return;
            if (!name || !needCollisionCheckForIdentifier(node, name, "require") && !needCollisionCheckForIdentifier(node, name, "exports")) return;
            if (isModuleDeclaration(node) && getModuleInstanceState(node) !== 1 /* Instantiated */ ) return;
            const parent2 = getDeclarationContainer(node);
            if (parent2.kind === 311 /* SourceFile */  && isExternalOrCommonJsModule(parent2)) errorSkippedOn("noEmit", name, Diagnostics.Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module, declarationNameToString(name), declarationNameToString(name));
        }
        function checkCollisionWithGlobalPromiseInGeneratedCode(node, name) {
            if (!name || languageVersion >= 4 /* ES2017 */  || !needCollisionCheckForIdentifier(node, name, "Promise")) return;
            if (isModuleDeclaration(node) && getModuleInstanceState(node) !== 1 /* Instantiated */ ) return;
            const parent2 = getDeclarationContainer(node);
            if (parent2.kind === 311 /* SourceFile */  && isExternalOrCommonJsModule(parent2) && parent2.flags & 2048 /* HasAsyncFunctions */ ) errorSkippedOn("noEmit", name, Diagnostics.Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_functions, declarationNameToString(name), declarationNameToString(name));
        }
        function recordPotentialCollisionWithWeakMapSetInGeneratedCode(node, name) {
            if (languageVersion <= 8 /* ES2021 */  && (needCollisionCheckForIdentifier(node, name, "WeakMap") || needCollisionCheckForIdentifier(node, name, "WeakSet"))) potentialWeakMapSetCollisions.push(node);
        }
        function checkWeakMapSetCollision(node) {
            const enclosingBlockScope = getEnclosingBlockScopeContainer(node);
            if (getNodeCheckFlags(enclosingBlockScope) & 4194304 /* ContainsClassWithPrivateIdentifiers */ ) {
                Debug.assert(isNamedDeclaration(node) && isIdentifier(node.name) && typeof node.name.escapedText === "string", "The target of a WeakMap/WeakSet collision check should be an identifier");
                errorSkippedOn("noEmit", node, Diagnostics.Compiler_reserves_name_0_when_emitting_private_identifier_downlevel, node.name.escapedText);
            }
        }
        function recordPotentialCollisionWithReflectInGeneratedCode(node, name) {
            if (name && languageVersion >= 2 /* ES2015 */  && languageVersion <= 8 /* ES2021 */  && needCollisionCheckForIdentifier(node, name, "Reflect")) potentialReflectCollisions.push(node);
        }
        function checkReflectCollision(node) {
            let hasCollision = false;
            if (isClassExpression(node)) {
                for (const member of node.members)if (getNodeCheckFlags(member) & 8388608 /* ContainsSuperPropertyInStaticInitializer */ ) {
                    hasCollision = true;
                    break;
                }
            } else if (isFunctionExpression(node)) {
                if (getNodeCheckFlags(node) & 8388608 /* ContainsSuperPropertyInStaticInitializer */ ) hasCollision = true;
            } else {
                const container = getEnclosingBlockScopeContainer(node);
                if (container && getNodeCheckFlags(container) & 8388608 /* ContainsSuperPropertyInStaticInitializer */ ) hasCollision = true;
            }
            if (hasCollision) {
                Debug.assert(isNamedDeclaration(node) && isIdentifier(node.name), "The target of a Reflect collision check should be an identifier");
                errorSkippedOn("noEmit", node, Diagnostics.Duplicate_identifier_0_Compiler_reserves_name_1_when_emitting_super_references_in_static_initializers, declarationNameToString(node.name), "Reflect");
            }
        }
        function checkCollisionsForDeclarationName(node, name) {
            if (!name) return;
            checkCollisionWithRequireExportsInGeneratedCode(node, name);
            checkCollisionWithGlobalPromiseInGeneratedCode(node, name);
            recordPotentialCollisionWithWeakMapSetInGeneratedCode(node, name);
            recordPotentialCollisionWithReflectInGeneratedCode(node, name);
            if (isClassLike(node)) {
                checkTypeNameIsReserved(name, Diagnostics.Class_name_cannot_be_0);
                if (!(node.flags & 16777216 /* Ambient */ )) checkClassNameCollisionWithObject(name);
            } else if (isEnumDeclaration(node)) checkTypeNameIsReserved(name, Diagnostics.Enum_name_cannot_be_0);
        }
        function checkVarDeclaredNamesNotShadowed(node) {
            if ((getCombinedNodeFlags(node) & 3 /* BlockScoped */ ) !== 0 || isParameterDeclaration(node)) return;
            if (node.kind === 259 /* VariableDeclaration */  && !node.initializer) return;
            const symbol = getSymbolOfDeclaration(node);
            if (symbol.flags & 1 /* FunctionScopedVariable */ ) {
                if (!isIdentifier(node.name)) return Debug.fail();
                const localDeclarationSymbol = resolveName(node, node.name.escapedText, 3 /* Variable */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false);
                if (localDeclarationSymbol && localDeclarationSymbol !== symbol && localDeclarationSymbol.flags & 2 /* BlockScopedVariable */ ) {
                    if (getDeclarationNodeFlagsFromSymbol(localDeclarationSymbol) & 3 /* BlockScoped */ ) {
                        const varDeclList = getAncestor(localDeclarationSymbol.valueDeclaration, 260 /* VariableDeclarationList */ );
                        const container = varDeclList.parent.kind === 242 /* VariableStatement */  && varDeclList.parent.parent ? varDeclList.parent.parent : void 0;
                        const namesShareScope = container && (container.kind === 240 /* Block */  && isFunctionLike(container.parent) || container.kind === 267 /* ModuleBlock */  || container.kind === 266 /* ModuleDeclaration */  || container.kind === 311 /* SourceFile */ );
                        if (!namesShareScope) {
                            const name = symbolToString(localDeclarationSymbol);
                            error(node, Diagnostics.Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1, name, name);
                        }
                    }
                }
            }
        }
        function convertAutoToAny(type) {
            return type === autoType ? anyType : type === autoArrayType ? anyArrayType : type;
        }
        function checkVariableLikeDeclaration(node) {
            var _a;
            checkDecorators(node);
            if (!isBindingElement(node)) checkSourceElement(node.type);
            if (!node.name) return;
            if (node.name.kind === 166 /* ComputedPropertyName */ ) {
                checkComputedPropertyName(node.name);
                if (hasOnlyExpressionInitializer(node) && node.initializer) checkExpressionCached(node.initializer);
            }
            if (isBindingElement(node)) {
                if (node.propertyName && isIdentifier(node.name) && isParameterDeclaration(node) && nodeIsMissing(getContainingFunction(node).body)) {
                    potentialUnusedRenamedBindingElementsInTypes.push(node);
                    return;
                }
                if (isObjectBindingPattern(node.parent) && node.dotDotDotToken && languageVersion < 5 /* ES2018 */ ) checkExternalEmitHelpers(node, 4 /* Rest */ );
                if (node.propertyName && node.propertyName.kind === 166 /* ComputedPropertyName */ ) checkComputedPropertyName(node.propertyName);
                const parent2 = node.parent.parent;
                const parentCheckMode = node.dotDotDotToken ? 64 /* RestBindingElement */  : 0 /* Normal */ ;
                const parentType = getTypeForBindingElementParent(parent2, parentCheckMode);
                const name = node.propertyName || node.name;
                if (parentType && !isBindingPattern(name)) {
                    const exprType = getLiteralTypeFromPropertyName(name);
                    if (isTypeUsableAsPropertyName(exprType)) {
                        const nameText = getPropertyNameFromType(exprType);
                        const property = getPropertyOfType(parentType, nameText);
                        if (property) {
                            markPropertyAsReferenced(property, /*nodeForCheckWriteOnly*/ void 0, /*isSelfTypeAccess*/ false);
                            checkPropertyAccessibility(node, !!parent2.initializer && parent2.initializer.kind === 108 /* SuperKeyword */ , /*writing*/ false, parentType, property);
                        }
                    }
                }
            }
            if (isBindingPattern(node.name)) {
                if (node.name.kind === 206 /* ArrayBindingPattern */  && languageVersion < 2 /* ES2015 */  && compilerOptions.downlevelIteration) checkExternalEmitHelpers(node, 512 /* Read */ );
                forEach(node.name.elements, checkSourceElement);
            }
            if (isParameter(node) && node.initializer && nodeIsMissing(getContainingFunction(node).body)) {
                error(node, Diagnostics.A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation);
                return;
            }
            if (isBindingPattern(node.name)) {
                if (isInAmbientOrTypeNode(node)) return;
                const needCheckInitializer = hasOnlyExpressionInitializer(node) && node.initializer && node.parent.parent.kind !== 248 /* ForInStatement */ ;
                const needCheckWidenedType = !some(node.name.elements, not(isOmittedExpression));
                if (needCheckInitializer || needCheckWidenedType) {
                    const widenedType = getWidenedTypeForVariableLikeDeclaration(node);
                    if (needCheckInitializer) {
                        const initializerType = checkExpressionCached(node.initializer);
                        if (strictNullChecks && needCheckWidenedType) checkNonNullNonVoidType(initializerType, node);
                        else checkTypeAssignableToAndOptionallyElaborate(initializerType, getWidenedTypeForVariableLikeDeclaration(node), node, node.initializer);
                    }
                    if (needCheckWidenedType) {
                        if (isArrayBindingPattern(node.name)) checkIteratedTypeOrElementType(65 /* Destructuring */ , widenedType, undefinedType, node);
                        else if (strictNullChecks) checkNonNullNonVoidType(widenedType, node);
                    }
                }
                return;
            }
            const symbol = getSymbolOfDeclaration(node);
            if (symbol.flags & 2097152 /* Alias */  && (isVariableDeclarationInitializedToBareOrAccessedRequire(node) || isBindingElementOfBareOrAccessedRequire(node))) {
                checkAliasSymbol(node);
                return;
            }
            const type = convertAutoToAny(getTypeOfSymbol(symbol));
            if (node === symbol.valueDeclaration) {
                const initializer = hasOnlyExpressionInitializer(node) && getEffectiveInitializer(node);
                if (initializer) {
                    const isJSObjectLiteralInitializer = isInJSFile(node) && isObjectLiteralExpression(initializer) && (initializer.properties.length === 0 || isPrototypeAccess(node.name)) && !!((_a = symbol.exports) == null ? void 0 : _a.size);
                    if (!isJSObjectLiteralInitializer && node.parent.parent.kind !== 248 /* ForInStatement */ ) checkTypeAssignableToAndOptionallyElaborate(checkExpressionCached(initializer), type, node, initializer, /*headMessage*/ void 0);
                }
                if (symbol.declarations && symbol.declarations.length > 1) {
                    if (some(symbol.declarations, (d)=>d !== node && isVariableLike(d) && !areDeclarationFlagsIdentical(d, node))) error(node.name, Diagnostics.All_declarations_of_0_must_have_identical_modifiers, declarationNameToString(node.name));
                }
            } else {
                const declarationType = convertAutoToAny(getWidenedTypeForVariableLikeDeclaration(node));
                if (!isErrorType(type) && !isErrorType(declarationType) && !isTypeIdenticalTo(type, declarationType) && !(symbol.flags & 67108864 /* Assignment */ )) errorNextVariableOrPropertyDeclarationMustHaveSameType(symbol.valueDeclaration, type, node, declarationType);
                if (hasOnlyExpressionInitializer(node) && node.initializer) checkTypeAssignableToAndOptionallyElaborate(checkExpressionCached(node.initializer), declarationType, node, node.initializer, /*headMessage*/ void 0);
                if (symbol.valueDeclaration && !areDeclarationFlagsIdentical(node, symbol.valueDeclaration)) error(node.name, Diagnostics.All_declarations_of_0_must_have_identical_modifiers, declarationNameToString(node.name));
            }
            if (node.kind !== 171 /* PropertyDeclaration */  && node.kind !== 170 /* PropertySignature */ ) {
                checkExportsOnMergedDeclarations(node);
                if (node.kind === 259 /* VariableDeclaration */  || node.kind === 207 /* BindingElement */ ) checkVarDeclaredNamesNotShadowed(node);
                checkCollisionsForDeclarationName(node, node.name);
            }
        }
        function errorNextVariableOrPropertyDeclarationMustHaveSameType(firstDeclaration, firstType, nextDeclaration, nextType) {
            const nextDeclarationName = getNameOfDeclaration(nextDeclaration);
            const message = nextDeclaration.kind === 171 /* PropertyDeclaration */  || nextDeclaration.kind === 170 /* PropertySignature */  ? Diagnostics.Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_type_2 : Diagnostics.Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_type_2;
            const declName = declarationNameToString(nextDeclarationName);
            const err = error(nextDeclarationName, message, declName, typeToString(firstType), typeToString(nextType));
            if (firstDeclaration) addRelatedInfo(err, createDiagnosticForNode(firstDeclaration, Diagnostics._0_was_also_declared_here, declName));
        }
        function areDeclarationFlagsIdentical(left, right) {
            if (left.kind === 168 /* Parameter */  && right.kind === 259 /* VariableDeclaration */  || left.kind === 259 /* VariableDeclaration */  && right.kind === 168 /* Parameter */ ) return true;
            if (hasQuestionToken(left) !== hasQuestionToken(right)) return false;
            const interestingFlags = 888 /* Static */ ;
            return getSelectedEffectiveModifierFlags(left, interestingFlags) === getSelectedEffectiveModifierFlags(right, interestingFlags);
        }
        function checkVariableDeclaration(node) {
            var _a, _b;
            (_a = tracing) == null || _a.push(tracing.Phase.Check, "checkVariableDeclaration", {
                kind: node.kind,
                pos: node.pos,
                end: node.end,
                path: node.tracingPath
            });
            checkGrammarVariableDeclaration(node);
            checkVariableLikeDeclaration(node);
            (_b = tracing) == null || _b.pop();
        }
        function checkBindingElement(node) {
            checkGrammarBindingElement(node);
            return checkVariableLikeDeclaration(node);
        }
        function checkVariableStatement(node) {
            if (!checkGrammarModifiers(node) && !checkGrammarVariableDeclarationList(node.declarationList)) checkGrammarForDisallowedLetOrConstStatement(node);
            forEach(node.declarationList.declarations, checkSourceElement);
        }
        function checkExpressionStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            checkExpression(node.expression);
        }
        function checkIfStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            const type = checkTruthinessExpression(node.expression);
            checkTestingKnownTruthyCallableOrAwaitableType(node.expression, type, node.thenStatement);
            checkSourceElement(node.thenStatement);
            if (node.thenStatement.kind === 241 /* EmptyStatement */ ) error(node.thenStatement, Diagnostics.The_body_of_an_if_statement_cannot_be_the_empty_statement);
            checkSourceElement(node.elseStatement);
        }
        function checkTestingKnownTruthyCallableOrAwaitableType(condExpr, condType, body) {
            if (!strictNullChecks) return;
            bothHelper(condExpr, body);
            function bothHelper(condExpr2, body2) {
                condExpr2 = skipParentheses(condExpr2);
                helper(condExpr2, body2);
                while(isBinaryExpression(condExpr2) && (condExpr2.operatorToken.kind === 57 /* BarBarToken */  || condExpr2.operatorToken.kind === 61 /* QuestionQuestionToken */ )){
                    condExpr2 = skipParentheses(condExpr2.left);
                    helper(condExpr2, body2);
                }
            }
            function helper(condExpr2, body2) {
                const location = isLogicalOrCoalescingBinaryExpression(condExpr2) ? skipParentheses(condExpr2.right) : condExpr2;
                if (isModuleExportsAccessExpression(location)) return;
                if (isLogicalOrCoalescingBinaryExpression(location)) {
                    bothHelper(location, body2);
                    return;
                }
                const type = location === condExpr2 ? condType : checkTruthinessExpression(location);
                const isPropertyExpressionCast = isPropertyAccessExpression(location) && isTypeAssertion(location.expression);
                if (!(getTypeFacts(type) & 4194304 /* Truthy */ ) || isPropertyExpressionCast) return;
                const callSignatures = getSignaturesOfType(type, 0 /* Call */ );
                const isPromise = !!getAwaitedTypeOfPromise(type);
                if (callSignatures.length === 0 && !isPromise) return;
                const testedNode = isIdentifier(location) ? location : isPropertyAccessExpression(location) ? location.name : void 0;
                const testedSymbol = testedNode && getSymbolAtLocation(testedNode);
                if (!testedSymbol && !isPromise) return;
                const isUsed = testedSymbol && isBinaryExpression(condExpr2.parent) && isSymbolUsedInBinaryExpressionChain(condExpr2.parent, testedSymbol) || testedSymbol && body2 && isSymbolUsedInConditionBody(condExpr2, body2, testedNode, testedSymbol);
                if (!isUsed) {
                    if (isPromise) errorAndMaybeSuggestAwait(location, /*maybeMissingAwait*/ true, Diagnostics.This_condition_will_always_return_true_since_this_0_is_always_defined, getTypeNameForErrorDisplay(type));
                    else error(location, Diagnostics.This_condition_will_always_return_true_since_this_function_is_always_defined_Did_you_mean_to_call_it_instead);
                }
            }
        }
        function isSymbolUsedInConditionBody(expr, body, testedNode, testedSymbol) {
            return !!forEachChild(body, function check(childNode) {
                if (isIdentifier(childNode)) {
                    const childSymbol = getSymbolAtLocation(childNode);
                    if (childSymbol && childSymbol === testedSymbol) {
                        if (isIdentifier(expr) || isIdentifier(testedNode) && isBinaryExpression(testedNode.parent)) return true;
                        let testedExpression = testedNode.parent;
                        let childExpression = childNode.parent;
                        while(testedExpression && childExpression){
                            if (isIdentifier(testedExpression) && isIdentifier(childExpression) || testedExpression.kind === 110 /* ThisKeyword */  && childExpression.kind === 110 /* ThisKeyword */ ) return getSymbolAtLocation(testedExpression) === getSymbolAtLocation(childExpression);
                            else if (isPropertyAccessExpression(testedExpression) && isPropertyAccessExpression(childExpression)) {
                                if (getSymbolAtLocation(testedExpression.name) !== getSymbolAtLocation(childExpression.name)) return false;
                                childExpression = childExpression.expression;
                                testedExpression = testedExpression.expression;
                            } else if (isCallExpression(testedExpression) && isCallExpression(childExpression)) {
                                childExpression = childExpression.expression;
                                testedExpression = testedExpression.expression;
                            } else return false;
                        }
                    }
                }
                return forEachChild(childNode, check);
            });
        }
        function isSymbolUsedInBinaryExpressionChain(node, testedSymbol) {
            while(isBinaryExpression(node) && node.operatorToken.kind === 56 /* AmpersandAmpersandToken */ ){
                const isUsed = forEachChild(node.right, function visit(child) {
                    if (isIdentifier(child)) {
                        const symbol = getSymbolAtLocation(child);
                        if (symbol && symbol === testedSymbol) return true;
                    }
                    return forEachChild(child, visit);
                });
                if (isUsed) return true;
                node = node.parent;
            }
            return false;
        }
        function checkDoStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            checkSourceElement(node.statement);
            checkTruthinessExpression(node.expression);
        }
        function checkWhileStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            checkTruthinessExpression(node.expression);
            checkSourceElement(node.statement);
        }
        function checkTruthinessOfType(type, node) {
            if (type.flags & 16384 /* Void */ ) error(node, Diagnostics.An_expression_of_type_void_cannot_be_tested_for_truthiness);
            return type;
        }
        function checkTruthinessExpression(node, checkMode) {
            return checkTruthinessOfType(checkExpression(node, checkMode), node);
        }
        function checkForStatement(node) {
            if (!checkGrammarStatementInAmbientContext(node)) {
                if (node.initializer && node.initializer.kind === 260 /* VariableDeclarationList */ ) checkGrammarVariableDeclarationList(node.initializer);
            }
            if (node.initializer) {
                if (node.initializer.kind === 260 /* VariableDeclarationList */ ) forEach(node.initializer.declarations, checkVariableDeclaration);
                else checkExpression(node.initializer);
            }
            if (node.condition) checkTruthinessExpression(node.condition);
            if (node.incrementor) checkExpression(node.incrementor);
            checkSourceElement(node.statement);
            if (node.locals) registerForUnusedIdentifiersCheck(node);
        }
        function checkForOfStatement(node) {
            checkGrammarForInOrForOfStatement(node);
            const container = getContainingFunctionOrClassStaticBlock(node);
            if (node.awaitModifier) {
                if (container && isClassStaticBlockDeclaration(container)) grammarErrorOnNode(node.awaitModifier, Diagnostics.For_await_loops_cannot_be_used_inside_a_class_static_block);
                else {
                    const functionFlags = getFunctionFlags(container);
                    if ((functionFlags & 6 /* Async */ ) === 2 /* Async */  && languageVersion < 99 /* ESNext */ ) checkExternalEmitHelpers(node, 16384 /* ForAwaitOfIncludes */ );
                }
            } else if (compilerOptions.downlevelIteration && languageVersion < 2 /* ES2015 */ ) checkExternalEmitHelpers(node, 256 /* ForOfIncludes */ );
            if (node.initializer.kind === 260 /* VariableDeclarationList */ ) checkForInOrForOfVariableDeclaration(node);
            else {
                const varExpr = node.initializer;
                const iteratedType = checkRightHandSideOfForOf(node);
                if (varExpr.kind === 208 /* ArrayLiteralExpression */  || varExpr.kind === 209 /* ObjectLiteralExpression */ ) checkDestructuringAssignment(varExpr, iteratedType || errorType);
                else {
                    const leftType = checkExpression(varExpr);
                    checkReferenceExpression(varExpr, Diagnostics.The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access, Diagnostics.The_left_hand_side_of_a_for_of_statement_may_not_be_an_optional_property_access);
                    if (iteratedType) checkTypeAssignableToAndOptionallyElaborate(iteratedType, leftType, varExpr, node.expression);
                }
            }
            checkSourceElement(node.statement);
            if (node.locals) registerForUnusedIdentifiersCheck(node);
        }
        function checkForInStatement(node) {
            checkGrammarForInOrForOfStatement(node);
            const rightType = getNonNullableTypeIfNeeded(checkExpression(node.expression));
            if (node.initializer.kind === 260 /* VariableDeclarationList */ ) {
                const variable = node.initializer.declarations[0];
                if (variable && isBindingPattern(variable.name)) error(variable.name, Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern);
                checkForInOrForOfVariableDeclaration(node);
            } else {
                const varExpr = node.initializer;
                const leftType = checkExpression(varExpr);
                if (varExpr.kind === 208 /* ArrayLiteralExpression */  || varExpr.kind === 209 /* ObjectLiteralExpression */ ) error(varExpr, Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern);
                else if (!isTypeAssignableTo(getIndexTypeOrString(rightType), leftType)) error(varExpr, Diagnostics.The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any);
                else checkReferenceExpression(varExpr, Diagnostics.The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access, Diagnostics.The_left_hand_side_of_a_for_in_statement_may_not_be_an_optional_property_access);
            }
            if (rightType === neverType || !isTypeAssignableToKind(rightType, 126091264 /* InstantiableNonPrimitive */ )) error(node.expression, Diagnostics.The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter_but_here_has_type_0, typeToString(rightType));
            checkSourceElement(node.statement);
            if (node.locals) registerForUnusedIdentifiersCheck(node);
        }
        function checkForInOrForOfVariableDeclaration(iterationStatement) {
            const variableDeclarationList = iterationStatement.initializer;
            if (variableDeclarationList.declarations.length >= 1) {
                const decl = variableDeclarationList.declarations[0];
                checkVariableDeclaration(decl);
            }
        }
        function checkRightHandSideOfForOf(statement) {
            const use = statement.awaitModifier ? 15 /* ForAwaitOf */  : 13 /* ForOf */ ;
            return checkIteratedTypeOrElementType(use, checkNonNullExpression(statement.expression), undefinedType, statement.expression);
        }
        function checkIteratedTypeOrElementType(use, inputType, sentType, errorNode) {
            if (isTypeAny(inputType)) return inputType;
            return getIteratedTypeOrElementType(use, inputType, sentType, errorNode, /*checkAssignability*/ true) || anyType;
        }
        function getIteratedTypeOrElementType(use, inputType, sentType, errorNode, checkAssignability) {
            const allowAsyncIterables = (use & 2 /* AllowsAsyncIterablesFlag */ ) !== 0;
            if (inputType === neverType) {
                reportTypeNotIterableError(errorNode, inputType, allowAsyncIterables);
                return void 0;
            }
            const uplevelIteration = languageVersion >= 2 /* ES2015 */ ;
            const downlevelIteration = !uplevelIteration && compilerOptions.downlevelIteration;
            const possibleOutOfBounds = compilerOptions.noUncheckedIndexedAccess && !!(use & 128 /* PossiblyOutOfBounds */ );
            if (uplevelIteration || downlevelIteration || allowAsyncIterables) {
                const iterationTypes = getIterationTypesOfIterable(inputType, use, uplevelIteration ? errorNode : void 0);
                if (checkAssignability) {
                    if (iterationTypes) {
                        const diagnostic = use & 8 /* ForOfFlag */  ? Diagnostics.Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_for_of_will_always_send_0 : use & 32 /* SpreadFlag */  ? Diagnostics.Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_spread_will_always_send_0 : use & 64 /* DestructuringFlag */  ? Diagnostics.Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_destructuring_will_always_send_0 : use & 16 /* YieldStarFlag */  ? Diagnostics.Cannot_delegate_iteration_to_value_because_the_next_method_of_its_iterator_expects_type_1_but_the_containing_generator_will_always_send_0 : void 0;
                        if (diagnostic) checkTypeAssignableTo(sentType, iterationTypes.nextType, errorNode, diagnostic);
                    }
                }
                if (iterationTypes || uplevelIteration) return possibleOutOfBounds ? includeUndefinedInIndexSignature(iterationTypes && iterationTypes.yieldType) : iterationTypes && iterationTypes.yieldType;
            }
            let arrayType = inputType;
            let reportedError = false;
            let hasStringConstituent = false;
            if (use & 4 /* AllowsStringInputFlag */ ) {
                if (arrayType.flags & 1048576 /* Union */ ) {
                    const arrayTypes = inputType.types;
                    const filteredTypes = filter(arrayTypes, (t)=>!(t.flags & 402653316 /* StringLike */ ));
                    if (filteredTypes !== arrayTypes) arrayType = getUnionType(filteredTypes, 2 /* Subtype */ );
                } else if (arrayType.flags & 402653316 /* StringLike */ ) arrayType = neverType;
                hasStringConstituent = arrayType !== inputType;
                if (hasStringConstituent) {
                    if (languageVersion < 1 /* ES5 */ ) {
                        if (errorNode) {
                            error(errorNode, Diagnostics.Using_a_string_in_a_for_of_statement_is_only_supported_in_ECMAScript_5_and_higher);
                            reportedError = true;
                        }
                    }
                    if (arrayType.flags & 131072 /* Never */ ) return possibleOutOfBounds ? includeUndefinedInIndexSignature(stringType) : stringType;
                }
            }
            if (!isArrayLikeType(arrayType)) {
                if (errorNode && !reportedError) {
                    const allowsStrings = !!(use & 4 /* AllowsStringInputFlag */ ) && !hasStringConstituent;
                    const [defaultDiagnostic, maybeMissingAwait] = getIterationDiagnosticDetails(allowsStrings, downlevelIteration);
                    errorAndMaybeSuggestAwait(errorNode, maybeMissingAwait && !!getAwaitedTypeOfPromise(arrayType), defaultDiagnostic, typeToString(arrayType));
                }
                return hasStringConstituent ? possibleOutOfBounds ? includeUndefinedInIndexSignature(stringType) : stringType : void 0;
            }
            const arrayElementType = getIndexTypeOfType(arrayType, numberType);
            if (hasStringConstituent && arrayElementType) {
                if (arrayElementType.flags & 402653316 /* StringLike */  && !compilerOptions.noUncheckedIndexedAccess) return stringType;
                return getUnionType(possibleOutOfBounds ? [
                    arrayElementType,
                    stringType,
                    undefinedType
                ] : [
                    arrayElementType,
                    stringType
                ], 2 /* Subtype */ );
            }
            return use & 128 /* PossiblyOutOfBounds */  ? includeUndefinedInIndexSignature(arrayElementType) : arrayElementType;
            function getIterationDiagnosticDetails(allowsStrings, downlevelIteration2) {
                var _a;
                if (downlevelIteration2) return allowsStrings ? [
                    Diagnostics.Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator,
                    true
                ] : [
                    Diagnostics.Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator,
                    true
                ];
                const yieldType = getIterationTypeOfIterable(use, 0 /* Yield */ , inputType, /*errorNode*/ void 0);
                if (yieldType) return [
                    Diagnostics.Type_0_can_only_be_iterated_through_when_using_the_downlevelIteration_flag_or_with_a_target_of_es2015_or_higher,
                    false
                ];
                if (isES2015OrLaterIterable((_a = inputType.symbol) == null ? void 0 : _a.escapedName)) return [
                    Diagnostics.Type_0_can_only_be_iterated_through_when_using_the_downlevelIteration_flag_or_with_a_target_of_es2015_or_higher,
                    true
                ];
                return allowsStrings ? [
                    Diagnostics.Type_0_is_not_an_array_type_or_a_string_type,
                    true
                ] : [
                    Diagnostics.Type_0_is_not_an_array_type,
                    true
                ];
            }
        }
        function isES2015OrLaterIterable(n) {
            switch(n){
                case "Float32Array":
                case "Float64Array":
                case "Int16Array":
                case "Int32Array":
                case "Int8Array":
                case "NodeList":
                case "Uint16Array":
                case "Uint32Array":
                case "Uint8Array":
                case "Uint8ClampedArray":
                    return true;
            }
            return false;
        }
        function getIterationTypeOfIterable(use, typeKind, inputType, errorNode) {
            if (isTypeAny(inputType)) return void 0;
            const iterationTypes = getIterationTypesOfIterable(inputType, use, errorNode);
            return iterationTypes && iterationTypes[getIterationTypesKeyFromIterationTypeKind(typeKind)];
        }
        function createIterationTypes(yieldType = neverType, returnType = neverType, nextType = unknownType) {
            if (yieldType.flags & 67359327 /* Intrinsic */  && returnType.flags & 180227 /* Undefined */  && nextType.flags & 180227 /* Undefined */ ) {
                const id = getTypeListId([
                    yieldType,
                    returnType,
                    nextType
                ]);
                let iterationTypes = iterationTypesCache.get(id);
                if (!iterationTypes) {
                    iterationTypes = {
                        yieldType: yieldType,
                        returnType: returnType,
                        nextType: nextType
                    };
                    iterationTypesCache.set(id, iterationTypes);
                }
                return iterationTypes;
            }
            return {
                yieldType: yieldType,
                returnType: returnType,
                nextType: nextType
            };
        }
        function combineIterationTypes(array) {
            let yieldTypes;
            let returnTypes;
            let nextTypes;
            for (const iterationTypes of array){
                if (iterationTypes === void 0 || iterationTypes === noIterationTypes) continue;
                if (iterationTypes === anyIterationTypes) return anyIterationTypes;
                yieldTypes = append(yieldTypes, iterationTypes.yieldType);
                returnTypes = append(returnTypes, iterationTypes.returnType);
                nextTypes = append(nextTypes, iterationTypes.nextType);
            }
            if (yieldTypes || returnTypes || nextTypes) return createIterationTypes(yieldTypes && getUnionType(yieldTypes), returnTypes && getUnionType(returnTypes), nextTypes && getIntersectionType(nextTypes));
            return noIterationTypes;
        }
        function getCachedIterationTypes(type, cacheKey) {
            return type[cacheKey];
        }
        function setCachedIterationTypes(type, cacheKey, cachedTypes2) {
            return type[cacheKey] = cachedTypes2;
        }
        function getIterationTypesOfIterable(type, use, errorNode) {
            var _a, _b;
            if (isTypeAny(type)) return anyIterationTypes;
            if (!(type.flags & 1048576 /* Union */ )) {
                const errorOutputContainer = errorNode ? {
                    errors: void 0
                } : void 0;
                const iterationTypes2 = getIterationTypesOfIterableWorker(type, use, errorNode, errorOutputContainer);
                if (iterationTypes2 === noIterationTypes) {
                    if (errorNode) {
                        const rootDiag = reportTypeNotIterableError(errorNode, type, !!(use & 2 /* AllowsAsyncIterablesFlag */ ));
                        if (errorOutputContainer == null ? void 0 : errorOutputContainer.errors) addRelatedInfo(rootDiag, ...errorOutputContainer.errors);
                    }
                    return void 0;
                } else if ((_a = errorOutputContainer == null ? void 0 : errorOutputContainer.errors) == null ? void 0 : _a.length) for (const diag2 of errorOutputContainer.errors)diagnostics.add(diag2);
                return iterationTypes2;
            }
            const cacheKey = use & 2 /* AllowsAsyncIterablesFlag */  ? "iterationTypesOfAsyncIterable" : "iterationTypesOfIterable";
            const cachedTypes2 = getCachedIterationTypes(type, cacheKey);
            if (cachedTypes2) return cachedTypes2 === noIterationTypes ? void 0 : cachedTypes2;
            let allIterationTypes;
            for (const constituent of type.types){
                const errorOutputContainer = errorNode ? {
                    errors: void 0
                } : void 0;
                const iterationTypes2 = getIterationTypesOfIterableWorker(constituent, use, errorNode, errorOutputContainer);
                if (iterationTypes2 === noIterationTypes) {
                    if (errorNode) {
                        const rootDiag = reportTypeNotIterableError(errorNode, type, !!(use & 2 /* AllowsAsyncIterablesFlag */ ));
                        if (errorOutputContainer == null ? void 0 : errorOutputContainer.errors) addRelatedInfo(rootDiag, ...errorOutputContainer.errors);
                    }
                    setCachedIterationTypes(type, cacheKey, noIterationTypes);
                    return void 0;
                } else if ((_b = errorOutputContainer == null ? void 0 : errorOutputContainer.errors) == null ? void 0 : _b.length) for (const diag2 of errorOutputContainer.errors)diagnostics.add(diag2);
                allIterationTypes = append(allIterationTypes, iterationTypes2);
            }
            const iterationTypes = allIterationTypes ? combineIterationTypes(allIterationTypes) : noIterationTypes;
            setCachedIterationTypes(type, cacheKey, iterationTypes);
            return iterationTypes === noIterationTypes ? void 0 : iterationTypes;
        }
        function getAsyncFromSyncIterationTypes(iterationTypes, errorNode) {
            if (iterationTypes === noIterationTypes) return noIterationTypes;
            if (iterationTypes === anyIterationTypes) return anyIterationTypes;
            const { yieldType: yieldType , returnType: returnType , nextType: nextType  } = iterationTypes;
            if (errorNode) getGlobalAwaitedSymbol(/*reportErrors*/ true);
            return createIterationTypes(getAwaitedType(yieldType, errorNode) || anyType, getAwaitedType(returnType, errorNode) || anyType, nextType);
        }
        function getIterationTypesOfIterableWorker(type, use, errorNode, errorOutputContainer) {
            if (isTypeAny(type)) return anyIterationTypes;
            let noCache = false;
            if (use & 2 /* AllowsAsyncIterablesFlag */ ) {
                const iterationTypes = getIterationTypesOfIterableCached(type, asyncIterationTypesResolver) || getIterationTypesOfIterableFast(type, asyncIterationTypesResolver);
                if (iterationTypes) {
                    if (iterationTypes === noIterationTypes && errorNode) noCache = true;
                    else return use & 8 /* ForOfFlag */  ? getAsyncFromSyncIterationTypes(iterationTypes, errorNode) : iterationTypes;
                }
            }
            if (use & 1 /* AllowsSyncIterablesFlag */ ) {
                let iterationTypes = getIterationTypesOfIterableCached(type, syncIterationTypesResolver) || getIterationTypesOfIterableFast(type, syncIterationTypesResolver);
                if (iterationTypes) {
                    if (iterationTypes === noIterationTypes && errorNode) noCache = true;
                    else {
                        if (use & 2 /* AllowsAsyncIterablesFlag */ ) {
                            if (iterationTypes !== noIterationTypes) {
                                iterationTypes = getAsyncFromSyncIterationTypes(iterationTypes, errorNode);
                                return noCache ? iterationTypes : setCachedIterationTypes(type, "iterationTypesOfAsyncIterable", iterationTypes);
                            }
                        } else return iterationTypes;
                    }
                }
            }
            if (use & 2 /* AllowsAsyncIterablesFlag */ ) {
                const iterationTypes = getIterationTypesOfIterableSlow(type, asyncIterationTypesResolver, errorNode, errorOutputContainer, noCache);
                if (iterationTypes !== noIterationTypes) return iterationTypes;
            }
            if (use & 1 /* AllowsSyncIterablesFlag */ ) {
                let iterationTypes = getIterationTypesOfIterableSlow(type, syncIterationTypesResolver, errorNode, errorOutputContainer, noCache);
                if (iterationTypes !== noIterationTypes) {
                    if (use & 2 /* AllowsAsyncIterablesFlag */ ) {
                        iterationTypes = getAsyncFromSyncIterationTypes(iterationTypes, errorNode);
                        return noCache ? iterationTypes : setCachedIterationTypes(type, "iterationTypesOfAsyncIterable", iterationTypes);
                    } else return iterationTypes;
                }
            }
            return noIterationTypes;
        }
        function getIterationTypesOfIterableCached(type, resolver) {
            return getCachedIterationTypes(type, resolver.iterableCacheKey);
        }
        function getIterationTypesOfGlobalIterableType(globalType, resolver) {
            const globalIterationTypes = getIterationTypesOfIterableCached(globalType, resolver) || getIterationTypesOfIterableSlow(globalType, resolver, /*errorNode*/ void 0, /*errorOutputContainer*/ void 0, /*noCache*/ false);
            return globalIterationTypes === noIterationTypes ? defaultIterationTypes : globalIterationTypes;
        }
        function getIterationTypesOfIterableFast(type, resolver) {
            let globalType;
            if (isReferenceToType2(type, globalType = resolver.getGlobalIterableType(/*reportErrors*/ false)) || isReferenceToType2(type, globalType = resolver.getGlobalIterableIteratorType(/*reportErrors*/ false))) {
                const [yieldType] = getTypeArguments(type);
                const { returnType: returnType , nextType: nextType  } = getIterationTypesOfGlobalIterableType(globalType, resolver);
                return setCachedIterationTypes(type, resolver.iterableCacheKey, createIterationTypes(resolver.resolveIterationType(yieldType, /*errorNode*/ void 0) || yieldType, resolver.resolveIterationType(returnType, /*errorNode*/ void 0) || returnType, nextType));
            }
            if (isReferenceToType2(type, resolver.getGlobalGeneratorType(/*reportErrors*/ false))) {
                const [yieldType, returnType, nextType] = getTypeArguments(type);
                return setCachedIterationTypes(type, resolver.iterableCacheKey, createIterationTypes(resolver.resolveIterationType(yieldType, /*errorNode*/ void 0) || yieldType, resolver.resolveIterationType(returnType, /*errorNode*/ void 0) || returnType, nextType));
            }
        }
        function getPropertyNameForKnownSymbolName(symbolName2) {
            const ctorType = getGlobalESSymbolConstructorSymbol(/*reportErrors*/ false);
            const uniqueType = ctorType && getTypeOfPropertyOfType(getTypeOfSymbol(ctorType), escapeLeadingUnderscores(symbolName2));
            return uniqueType && isTypeUsableAsPropertyName(uniqueType) ? getPropertyNameFromType(uniqueType) : `__@${symbolName2}`;
        }
        function getIterationTypesOfIterableSlow(type, resolver, errorNode, errorOutputContainer, noCache) {
            const method = getPropertyOfType(type, getPropertyNameForKnownSymbolName(resolver.iteratorSymbolName));
            const methodType = method && !(method.flags & 16777216 /* Optional */ ) ? getTypeOfSymbol(method) : void 0;
            if (isTypeAny(methodType)) return noCache ? anyIterationTypes : setCachedIterationTypes(type, resolver.iterableCacheKey, anyIterationTypes);
            const signatures = methodType ? getSignaturesOfType(methodType, 0 /* Call */ ) : void 0;
            if (!some(signatures)) return noCache ? noIterationTypes : setCachedIterationTypes(type, resolver.iterableCacheKey, noIterationTypes);
            const iteratorType = getIntersectionType(map(signatures, getReturnTypeOfSignature));
            const iterationTypes = getIterationTypesOfIteratorWorker(iteratorType, resolver, errorNode, errorOutputContainer, noCache) ?? noIterationTypes;
            return noCache ? iterationTypes : setCachedIterationTypes(type, resolver.iterableCacheKey, iterationTypes);
        }
        function reportTypeNotIterableError(errorNode, type, allowAsyncIterables) {
            const message = allowAsyncIterables ? Diagnostics.Type_0_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator : Diagnostics.Type_0_must_have_a_Symbol_iterator_method_that_returns_an_iterator;
            const suggestAwait = // for (const x of Promise<...>) or [...Promise<...>]
            !!getAwaitedTypeOfPromise(type) || !allowAsyncIterables && isForOfStatement(errorNode.parent) && errorNode.parent.expression === errorNode && getGlobalAsyncIterableType(/*reportErrors*/ false) !== emptyGenericType && isTypeAssignableTo(type, getGlobalAsyncIterableType(/*reportErrors*/ false));
            return errorAndMaybeSuggestAwait(errorNode, suggestAwait, message, typeToString(type));
        }
        function getIterationTypesOfIterator(type, resolver, errorNode, errorOutputContainer) {
            return getIterationTypesOfIteratorWorker(type, resolver, errorNode, errorOutputContainer, /*noCache*/ false);
        }
        function getIterationTypesOfIteratorWorker(type, resolver, errorNode, errorOutputContainer, noCache) {
            if (isTypeAny(type)) return anyIterationTypes;
            let iterationTypes = getIterationTypesOfIteratorCached(type, resolver) || getIterationTypesOfIteratorFast(type, resolver);
            if (iterationTypes === noIterationTypes && errorNode) {
                iterationTypes = void 0;
                noCache = true;
            }
            iterationTypes ?? (iterationTypes = getIterationTypesOfIteratorSlow(type, resolver, errorNode, errorOutputContainer, noCache));
            return iterationTypes === noIterationTypes ? void 0 : iterationTypes;
        }
        function getIterationTypesOfIteratorCached(type, resolver) {
            return getCachedIterationTypes(type, resolver.iteratorCacheKey);
        }
        function getIterationTypesOfIteratorFast(type, resolver) {
            const globalType = resolver.getGlobalIterableIteratorType(/*reportErrors*/ false);
            if (isReferenceToType2(type, globalType)) {
                const [yieldType] = getTypeArguments(type);
                const globalIterationTypes = getIterationTypesOfIteratorCached(globalType, resolver) || getIterationTypesOfIteratorSlow(globalType, resolver, /*errorNode*/ void 0, /*errorOutputContainer*/ void 0, /*noCache*/ false);
                const { returnType: returnType , nextType: nextType  } = globalIterationTypes === noIterationTypes ? defaultIterationTypes : globalIterationTypes;
                return setCachedIterationTypes(type, resolver.iteratorCacheKey, createIterationTypes(yieldType, returnType, nextType));
            }
            if (isReferenceToType2(type, resolver.getGlobalIteratorType(/*reportErrors*/ false)) || isReferenceToType2(type, resolver.getGlobalGeneratorType(/*reportErrors*/ false))) {
                const [yieldType, returnType, nextType] = getTypeArguments(type);
                return setCachedIterationTypes(type, resolver.iteratorCacheKey, createIterationTypes(yieldType, returnType, nextType));
            }
        }
        function isIteratorResult(type, kind) {
            const doneType = getTypeOfPropertyOfType(type, "done") || falseType;
            return isTypeAssignableTo(kind === 0 /* Yield */  ? falseType : trueType, doneType);
        }
        function isYieldIteratorResult(type) {
            return isIteratorResult(type, 0 /* Yield */ );
        }
        function isReturnIteratorResult(type) {
            return isIteratorResult(type, 1 /* Return */ );
        }
        function getIterationTypesOfIteratorResult(type) {
            if (isTypeAny(type)) return anyIterationTypes;
            const cachedTypes2 = getCachedIterationTypes(type, "iterationTypesOfIteratorResult");
            if (cachedTypes2) return cachedTypes2;
            if (isReferenceToType2(type, getGlobalIteratorYieldResultType(/*reportErrors*/ false))) {
                const yieldType2 = getTypeArguments(type)[0];
                return setCachedIterationTypes(type, "iterationTypesOfIteratorResult", createIterationTypes(yieldType2, /*returnType*/ void 0, /*nextType*/ void 0));
            }
            if (isReferenceToType2(type, getGlobalIteratorReturnResultType(/*reportErrors*/ false))) {
                const returnType2 = getTypeArguments(type)[0];
                return setCachedIterationTypes(type, "iterationTypesOfIteratorResult", createIterationTypes(/*yieldType*/ void 0, returnType2, /*nextType*/ void 0));
            }
            const yieldIteratorResult = filterType(type, isYieldIteratorResult);
            const yieldType = yieldIteratorResult !== neverType ? getTypeOfPropertyOfType(yieldIteratorResult, "value") : void 0;
            const returnIteratorResult = filterType(type, isReturnIteratorResult);
            const returnType = returnIteratorResult !== neverType ? getTypeOfPropertyOfType(returnIteratorResult, "value") : void 0;
            if (!yieldType && !returnType) return setCachedIterationTypes(type, "iterationTypesOfIteratorResult", noIterationTypes);
            return setCachedIterationTypes(type, "iterationTypesOfIteratorResult", createIterationTypes(yieldType, returnType || voidType, /*nextType*/ void 0));
        }
        function getIterationTypesOfMethod(type, resolver, methodName, errorNode, errorOutputContainer) {
            var _a, _b, _c, _d;
            const method = getPropertyOfType(type, methodName);
            if (!method && methodName !== "next") return void 0;
            const methodType = method && !(methodName === "next" && method.flags & 16777216 /* Optional */ ) ? methodName === "next" ? getTypeOfSymbol(method) : getTypeWithFacts(getTypeOfSymbol(method), 2097152 /* NEUndefinedOrNull */ ) : void 0;
            if (isTypeAny(methodType)) return methodName === "next" ? anyIterationTypes : anyIterationTypesExceptNext;
            const methodSignatures = methodType ? getSignaturesOfType(methodType, 0 /* Call */ ) : emptyArray;
            if (methodSignatures.length === 0) {
                if (errorNode) {
                    const diagnostic = methodName === "next" ? resolver.mustHaveANextMethodDiagnostic : resolver.mustBeAMethodDiagnostic;
                    if (errorOutputContainer) {
                        errorOutputContainer.errors ?? (errorOutputContainer.errors = []);
                        errorOutputContainer.errors.push(createDiagnosticForNode(errorNode, diagnostic, methodName));
                    } else error(errorNode, diagnostic, methodName);
                }
                return methodName === "next" ? noIterationTypes : void 0;
            }
            if ((methodType == null ? void 0 : methodType.symbol) && methodSignatures.length === 1) {
                const globalGeneratorType = resolver.getGlobalGeneratorType(/*reportErrors*/ false);
                const globalIteratorType = resolver.getGlobalIteratorType(/*reportErrors*/ false);
                const isGeneratorMethod = ((_b = (_a = globalGeneratorType.symbol) == null ? void 0 : _a.members) == null ? void 0 : _b.get(methodName)) === methodType.symbol;
                const isIteratorMethod = !isGeneratorMethod && ((_d = (_c = globalIteratorType.symbol) == null ? void 0 : _c.members) == null ? void 0 : _d.get(methodName)) === methodType.symbol;
                if (isGeneratorMethod || isIteratorMethod) {
                    const globalType = isGeneratorMethod ? globalGeneratorType : globalIteratorType;
                    const { mapper: mapper  } = methodType;
                    return createIterationTypes(getMappedType(globalType.typeParameters[0], mapper), getMappedType(globalType.typeParameters[1], mapper), methodName === "next" ? getMappedType(globalType.typeParameters[2], mapper) : void 0);
                }
            }
            let methodParameterTypes;
            let methodReturnTypes;
            for (const signature of methodSignatures){
                if (methodName !== "throw" && some(signature.parameters)) methodParameterTypes = append(methodParameterTypes, getTypeAtPosition(signature, 0));
                methodReturnTypes = append(methodReturnTypes, getReturnTypeOfSignature(signature));
            }
            let returnTypes;
            let nextType;
            if (methodName !== "throw") {
                const methodParameterType = methodParameterTypes ? getUnionType(methodParameterTypes) : unknownType;
                if (methodName === "next") nextType = methodParameterType;
                else if (methodName === "return") {
                    const resolvedMethodParameterType = resolver.resolveIterationType(methodParameterType, errorNode) || anyType;
                    returnTypes = append(returnTypes, resolvedMethodParameterType);
                }
            }
            let yieldType;
            const methodReturnType = methodReturnTypes ? getIntersectionType(methodReturnTypes) : neverType;
            const resolvedMethodReturnType = resolver.resolveIterationType(methodReturnType, errorNode) || anyType;
            const iterationTypes = getIterationTypesOfIteratorResult(resolvedMethodReturnType);
            if (iterationTypes === noIterationTypes) {
                if (errorNode) {
                    if (errorOutputContainer) {
                        errorOutputContainer.errors ?? (errorOutputContainer.errors = []);
                        errorOutputContainer.errors.push(createDiagnosticForNode(errorNode, resolver.mustHaveAValueDiagnostic, methodName));
                    } else error(errorNode, resolver.mustHaveAValueDiagnostic, methodName);
                }
                yieldType = anyType;
                returnTypes = append(returnTypes, anyType);
            } else {
                yieldType = iterationTypes.yieldType;
                returnTypes = append(returnTypes, iterationTypes.returnType);
            }
            return createIterationTypes(yieldType, getUnionType(returnTypes), nextType);
        }
        function getIterationTypesOfIteratorSlow(type, resolver, errorNode, errorOutputContainer, noCache) {
            const iterationTypes = combineIterationTypes([
                getIterationTypesOfMethod(type, resolver, "next", errorNode, errorOutputContainer),
                getIterationTypesOfMethod(type, resolver, "return", errorNode, errorOutputContainer),
                getIterationTypesOfMethod(type, resolver, "throw", errorNode, errorOutputContainer)
            ]);
            return noCache ? iterationTypes : setCachedIterationTypes(type, resolver.iteratorCacheKey, iterationTypes);
        }
        function getIterationTypeOfGeneratorFunctionReturnType(kind, returnType, isAsyncGenerator) {
            if (isTypeAny(returnType)) return void 0;
            const iterationTypes = getIterationTypesOfGeneratorFunctionReturnType(returnType, isAsyncGenerator);
            return iterationTypes && iterationTypes[getIterationTypesKeyFromIterationTypeKind(kind)];
        }
        function getIterationTypesOfGeneratorFunctionReturnType(type, isAsyncGenerator) {
            if (isTypeAny(type)) return anyIterationTypes;
            const use = isAsyncGenerator ? 2 /* AsyncGeneratorReturnType */  : 1 /* GeneratorReturnType */ ;
            const resolver = isAsyncGenerator ? asyncIterationTypesResolver : syncIterationTypesResolver;
            return getIterationTypesOfIterable(type, use, /*errorNode*/ void 0) || getIterationTypesOfIterator(type, resolver, /*errorNode*/ void 0, /*errorOutputContainer*/ void 0);
        }
        function checkBreakOrContinueStatement(node) {
            if (!checkGrammarStatementInAmbientContext(node)) checkGrammarBreakOrContinueStatement(node);
        }
        function unwrapReturnType(returnType, functionFlags) {
            const isGenerator = !!(functionFlags & 1 /* Generator */ );
            const isAsync = !!(functionFlags & 2 /* Async */ );
            if (isGenerator) {
                const returnIterationType = getIterationTypeOfGeneratorFunctionReturnType(1 /* Return */ , returnType, isAsync);
                if (!returnIterationType) return errorType;
                return isAsync ? getAwaitedTypeNoAlias(unwrapAwaitedType(returnIterationType)) : returnIterationType;
            }
            return isAsync ? getAwaitedTypeNoAlias(returnType) || errorType : returnType;
        }
        function isUnwrappedReturnTypeUndefinedVoidOrAny(func, returnType) {
            const type = unwrapReturnType(returnType, getFunctionFlags(func));
            return !!(type && (maybeTypeOfKind(type, 16384 /* Void */ ) || type.flags & 32769 /* Undefined */ ));
        }
        function checkReturnStatement(node) {
            if (checkGrammarStatementInAmbientContext(node)) return;
            const container = getContainingFunctionOrClassStaticBlock(node);
            if (container && isClassStaticBlockDeclaration(container)) {
                grammarErrorOnFirstToken(node, Diagnostics.A_return_statement_cannot_be_used_inside_a_class_static_block);
                return;
            }
            if (!container) {
                grammarErrorOnFirstToken(node, Diagnostics.A_return_statement_can_only_be_used_within_a_function_body);
                return;
            }
            const signature = getSignatureFromDeclaration(container);
            const returnType = getReturnTypeOfSignature(signature);
            const functionFlags = getFunctionFlags(container);
            if (strictNullChecks || node.expression || returnType.flags & 131072 /* Never */ ) {
                const exprType = node.expression ? checkExpressionCached(node.expression) : undefinedType;
                if (container.kind === 177 /* SetAccessor */ ) {
                    if (node.expression) error(node, Diagnostics.Setters_cannot_return_a_value);
                } else if (container.kind === 175 /* Constructor */ ) {
                    if (node.expression && !checkTypeAssignableToAndOptionallyElaborate(exprType, returnType, node, node.expression)) error(node, Diagnostics.Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class);
                } else if (getReturnTypeFromAnnotation(container)) {
                    const unwrappedReturnType = unwrapReturnType(returnType, functionFlags) ?? returnType;
                    const unwrappedExprType = functionFlags & 2 /* Async */  ? checkAwaitedType(exprType, /*withAlias*/ false, node, Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member) : exprType;
                    if (unwrappedReturnType) checkTypeAssignableToAndOptionallyElaborate(unwrappedExprType, unwrappedReturnType, node, node.expression);
                }
            } else if (container.kind !== 175 /* Constructor */  && compilerOptions.noImplicitReturns && !isUnwrappedReturnTypeUndefinedVoidOrAny(container, returnType)) error(node, Diagnostics.Not_all_code_paths_return_a_value);
        }
        function checkWithStatement(node) {
            if (!checkGrammarStatementInAmbientContext(node)) {
                if (node.flags & 32768 /* AwaitContext */ ) grammarErrorOnFirstToken(node, Diagnostics.with_statements_are_not_allowed_in_an_async_function_block);
            }
            checkExpression(node.expression);
            const sourceFile = getSourceFileOfNode(node);
            if (!hasParseDiagnostics(sourceFile)) {
                const start = getSpanOfTokenAtPosition(sourceFile, node.pos).start;
                const end = node.statement.pos;
                grammarErrorAtPos(sourceFile, start, end - start, Diagnostics.The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any);
            }
        }
        function checkSwitchStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            let firstDefaultClause;
            let hasDuplicateDefaultClause = false;
            const expressionType = checkExpression(node.expression);
            forEach(node.caseBlock.clauses, (clause)=>{
                if (clause.kind === 296 /* DefaultClause */  && !hasDuplicateDefaultClause) {
                    if (firstDefaultClause === void 0) firstDefaultClause = clause;
                    else {
                        grammarErrorOnNode(clause, Diagnostics.A_default_clause_cannot_appear_more_than_once_in_a_switch_statement);
                        hasDuplicateDefaultClause = true;
                    }
                }
                if (clause.kind === 295 /* CaseClause */ ) addLazyDiagnostic(createLazyCaseClauseDiagnostics(clause));
                forEach(clause.statements, checkSourceElement);
                if (compilerOptions.noFallthroughCasesInSwitch && clause.fallthroughFlowNode && isReachableFlowNode(clause.fallthroughFlowNode)) error(clause, Diagnostics.Fallthrough_case_in_switch);
                function createLazyCaseClauseDiagnostics(clause2) {
                    return ()=>{
                        const caseType = checkExpression(clause2.expression);
                        if (!isTypeEqualityComparableTo(expressionType, caseType)) checkTypeComparableTo(caseType, expressionType, clause2.expression, /*headMessage*/ void 0);
                    };
                }
            });
            if (node.caseBlock.locals) registerForUnusedIdentifiersCheck(node.caseBlock);
        }
        function checkLabeledStatement(node) {
            if (!checkGrammarStatementInAmbientContext(node)) findAncestor(node.parent, (current)=>{
                if (isFunctionLike(current)) return "quit";
                if (current.kind === 255 /* LabeledStatement */  && current.label.escapedText === node.label.escapedText) {
                    grammarErrorOnNode(node.label, Diagnostics.Duplicate_label_0, getTextOfNode(node.label));
                    return true;
                }
                return false;
            });
            checkSourceElement(node.statement);
        }
        function checkThrowStatement(node) {
            if (!checkGrammarStatementInAmbientContext(node)) {
                if (isIdentifier(node.expression) && !node.expression.escapedText) grammarErrorAfterFirstToken(node, Diagnostics.Line_break_not_permitted_here);
            }
            if (node.expression) checkExpression(node.expression);
        }
        function checkTryStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            checkBlock(node.tryBlock);
            const catchClause = node.catchClause;
            if (catchClause) {
                if (catchClause.variableDeclaration) {
                    const declaration = catchClause.variableDeclaration;
                    checkVariableLikeDeclaration(declaration);
                    const typeNode = getEffectiveTypeAnnotationNode(declaration);
                    if (typeNode) {
                        const type = getTypeFromTypeNode(typeNode);
                        if (type && !(type.flags & 3 /* AnyOrUnknown */ )) grammarErrorOnFirstToken(typeNode, Diagnostics.Catch_clause_variable_type_annotation_must_be_any_or_unknown_if_specified);
                    } else if (declaration.initializer) grammarErrorOnFirstToken(declaration.initializer, Diagnostics.Catch_clause_variable_cannot_have_an_initializer);
                    else {
                        const blockLocals = catchClause.block.locals;
                        if (blockLocals) forEachKey(catchClause.locals, (caughtName)=>{
                            const blockLocal = blockLocals.get(caughtName);
                            if ((blockLocal == null ? void 0 : blockLocal.valueDeclaration) && (blockLocal.flags & 2 /* BlockScopedVariable */ ) !== 0) grammarErrorOnNode(blockLocal.valueDeclaration, Diagnostics.Cannot_redeclare_identifier_0_in_catch_clause, unescapeLeadingUnderscores(caughtName));
                        });
                    }
                }
                checkBlock(catchClause.block);
            }
            if (node.finallyBlock) checkBlock(node.finallyBlock);
        }
        function checkIndexConstraints(type, symbol, isStaticIndex) {
            const indexInfos = getIndexInfosOfType(type);
            if (indexInfos.length === 0) return;
            for (const prop of getPropertiesOfObjectType(type))if (!(isStaticIndex && prop.flags & 4194304 /* Prototype */ )) checkIndexConstraintForProperty(type, prop, getLiteralTypeFromProperty(prop, 8576 /* StringOrNumberLiteralOrUnique */ , /*includeNonPublic*/ true), getNonMissingTypeOfSymbol(prop));
            const typeDeclaration = symbol.valueDeclaration;
            if (typeDeclaration && isClassLike(typeDeclaration)) {
                for (const member of typeDeclaration.members)if (!isStatic(member) && !hasBindableName(member)) {
                    const symbol2 = getSymbolOfDeclaration(member);
                    checkIndexConstraintForProperty(type, symbol2, getTypeOfExpression(member.name.expression), getNonMissingTypeOfSymbol(symbol2));
                }
            }
            if (indexInfos.length > 1) for (const info of indexInfos)checkIndexConstraintForIndexSignature(type, info);
        }
        function checkIndexConstraintForProperty(type, prop, propNameType, propType) {
            const declaration = prop.valueDeclaration;
            const name = getNameOfDeclaration(declaration);
            if (name && isPrivateIdentifier(name)) return;
            const indexInfos = getApplicableIndexInfos(type, propNameType);
            const interfaceDeclaration = getObjectFlags(type) & 2 /* Interface */  ? getDeclarationOfKind(type.symbol, 263 /* InterfaceDeclaration */ ) : void 0;
            const propDeclaration = declaration && declaration.kind === 225 /* BinaryExpression */  || name && name.kind === 166 /* ComputedPropertyName */  ? declaration : void 0;
            const localPropDeclaration = getParentOfSymbol(prop) === type.symbol ? declaration : void 0;
            for (const info of indexInfos){
                const localIndexDeclaration = info.declaration && getParentOfSymbol(getSymbolOfDeclaration(info.declaration)) === type.symbol ? info.declaration : void 0;
                const errorNode = localPropDeclaration || localIndexDeclaration || (interfaceDeclaration && !some(getBaseTypes(type), (base)=>!!getPropertyOfObjectType(base, prop.escapedName) && !!getIndexTypeOfType(base, info.keyType)) ? interfaceDeclaration : void 0);
                if (errorNode && !isTypeAssignableTo(propType, info.type)) {
                    const diagnostic = createError(errorNode, Diagnostics.Property_0_of_type_1_is_not_assignable_to_2_index_type_3, symbolToString(prop), typeToString(propType), typeToString(info.keyType), typeToString(info.type));
                    if (propDeclaration && errorNode !== propDeclaration) addRelatedInfo(diagnostic, createDiagnosticForNode(propDeclaration, Diagnostics._0_is_declared_here, symbolToString(prop)));
                    diagnostics.add(diagnostic);
                }
            }
        }
        function checkIndexConstraintForIndexSignature(type, checkInfo) {
            const declaration = checkInfo.declaration;
            const indexInfos = getApplicableIndexInfos(type, checkInfo.keyType);
            const interfaceDeclaration = getObjectFlags(type) & 2 /* Interface */  ? getDeclarationOfKind(type.symbol, 263 /* InterfaceDeclaration */ ) : void 0;
            const localCheckDeclaration = declaration && getParentOfSymbol(getSymbolOfDeclaration(declaration)) === type.symbol ? declaration : void 0;
            for (const info of indexInfos){
                if (info === checkInfo) continue;
                const localIndexDeclaration = info.declaration && getParentOfSymbol(getSymbolOfDeclaration(info.declaration)) === type.symbol ? info.declaration : void 0;
                const errorNode = localCheckDeclaration || localIndexDeclaration || (interfaceDeclaration && !some(getBaseTypes(type), (base)=>!!getIndexInfoOfType(base, checkInfo.keyType) && !!getIndexTypeOfType(base, info.keyType)) ? interfaceDeclaration : void 0);
                if (errorNode && !isTypeAssignableTo(checkInfo.type, info.type)) error(errorNode, Diagnostics._0_index_type_1_is_not_assignable_to_2_index_type_3, typeToString(checkInfo.keyType), typeToString(checkInfo.type), typeToString(info.keyType), typeToString(info.type));
            }
        }
        function checkTypeNameIsReserved(name, message) {
            switch(name.escapedText){
                case "any":
                case "unknown":
                case "never":
                case "number":
                case "bigint":
                case "boolean":
                case "string":
                case "symbol":
                case "void":
                case "object":
                    error(name, message, name.escapedText);
            }
        }
        function checkClassNameCollisionWithObject(name) {
            if (languageVersion >= 1 /* ES5 */  && name.escapedText === "Object" && (moduleKind < 5 /* ES2015 */  || getSourceFileOfNode(name).impliedNodeFormat === 1 /* CommonJS */ )) error(name, Diagnostics.Class_name_cannot_be_Object_when_targeting_ES5_with_module_0, ModuleKind[moduleKind]);
        }
        function checkUnmatchedJSDocParameters(node) {
            const jsdocParameters = filter(getJSDocTags(node), isJSDocParameterTag);
            if (!length(jsdocParameters)) return;
            const isJs = isInJSFile(node);
            const parameters = /* @__PURE__ */ new Set();
            const excludedParameters = /* @__PURE__ */ new Set();
            forEach(node.parameters, ({ name: name  }, index)=>{
                if (isIdentifier(name)) parameters.add(name.escapedText);
                if (isBindingPattern(name)) excludedParameters.add(index);
            });
            const containsArguments = containsArgumentsReference(node);
            if (containsArguments) {
                const lastJSDocParamIndex = jsdocParameters.length - 1;
                const lastJSDocParam = jsdocParameters[lastJSDocParamIndex];
                if (isJs && lastJSDocParam && isIdentifier(lastJSDocParam.name) && lastJSDocParam.typeExpression && lastJSDocParam.typeExpression.type && !parameters.has(lastJSDocParam.name.escapedText) && !excludedParameters.has(lastJSDocParamIndex) && !isArrayType(getTypeFromTypeNode(lastJSDocParam.typeExpression.type))) error(lastJSDocParam.name, Diagnostics.JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_It_would_match_arguments_if_it_had_an_array_type, idText(lastJSDocParam.name));
            } else forEach(jsdocParameters, ({ name: name , isNameFirst: isNameFirst  }, index)=>{
                if (excludedParameters.has(index) || isIdentifier(name) && parameters.has(name.escapedText)) return;
                if (isQualifiedName(name)) {
                    if (isJs) error(name, Diagnostics.Qualified_name_0_is_not_allowed_without_a_leading_param_object_1, entityNameToString(name), entityNameToString(name.left));
                } else if (!isNameFirst) errorOrSuggestion(isJs, name, Diagnostics.JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name, idText(name));
            });
        }
        function checkTypeParameters(typeParameterDeclarations) {
            let seenDefault = false;
            if (typeParameterDeclarations) for(let i = 0; i < typeParameterDeclarations.length; i++){
                const node = typeParameterDeclarations[i];
                checkTypeParameter(node);
                addLazyDiagnostic(createCheckTypeParameterDiagnostic(node, i));
            }
            function createCheckTypeParameterDiagnostic(node, i) {
                return ()=>{
                    if (node.default) {
                        seenDefault = true;
                        checkTypeParametersNotReferenced(node.default, typeParameterDeclarations, i);
                    } else if (seenDefault) error(node, Diagnostics.Required_type_parameters_may_not_follow_optional_type_parameters);
                    for(let j = 0; j < i; j++)if (typeParameterDeclarations[j].symbol === node.symbol) error(node.name, Diagnostics.Duplicate_identifier_0, declarationNameToString(node.name));
                };
            }
        }
        function checkTypeParametersNotReferenced(root, typeParameters, index) {
            visit(root);
            function visit(node) {
                if (node.kind === 182 /* TypeReference */ ) {
                    const type = getTypeFromTypeReference(node);
                    if (type.flags & 262144 /* TypeParameter */ ) {
                        for(let i = index; i < typeParameters.length; i++)if (type.symbol === getSymbolOfDeclaration(typeParameters[i])) error(node, Diagnostics.Type_parameter_defaults_can_only_reference_previously_declared_type_parameters);
                    }
                }
                forEachChild(node, visit);
            }
        }
        function checkTypeParameterListsIdentical(symbol) {
            if (symbol.declarations && symbol.declarations.length === 1) return;
            const links = getSymbolLinks(symbol);
            if (!links.typeParametersChecked) {
                links.typeParametersChecked = true;
                const declarations = getClassOrInterfaceDeclarationsOfSymbol(symbol);
                if (!declarations || declarations.length <= 1) return;
                const type = getDeclaredTypeOfSymbol(symbol);
                if (!areTypeParametersIdentical(declarations, type.localTypeParameters, getEffectiveTypeParameterDeclarations)) {
                    const name = symbolToString(symbol);
                    for (const declaration of declarations)error(declaration.name, Diagnostics.All_declarations_of_0_must_have_identical_type_parameters, name);
                }
            }
        }
        function areTypeParametersIdentical(declarations, targetParameters, getTypeParameterDeclarations) {
            const maxTypeArgumentCount = length(targetParameters);
            const minTypeArgumentCount = getMinTypeArgumentCount(targetParameters);
            for (const declaration of declarations){
                const sourceParameters = getTypeParameterDeclarations(declaration);
                const numTypeParameters = sourceParameters.length;
                if (numTypeParameters < minTypeArgumentCount || numTypeParameters > maxTypeArgumentCount) return false;
                for(let i = 0; i < numTypeParameters; i++){
                    const source = sourceParameters[i];
                    const target = targetParameters[i];
                    if (source.name.escapedText !== target.symbol.escapedName) return false;
                    const constraint = getEffectiveConstraintOfTypeParameter(source);
                    const sourceConstraint = constraint && getTypeFromTypeNode(constraint);
                    const targetConstraint = getConstraintOfTypeParameter(target);
                    if (sourceConstraint && targetConstraint && !isTypeIdenticalTo(sourceConstraint, targetConstraint)) return false;
                    const sourceDefault = source.default && getTypeFromTypeNode(source.default);
                    const targetDefault = getDefaultFromTypeParameter(target);
                    if (sourceDefault && targetDefault && !isTypeIdenticalTo(sourceDefault, targetDefault)) return false;
                }
            }
            return true;
        }
        function getFirstTransformableStaticClassElement(node) {
            const willTransformStaticElementsOfDecoratedClass = !legacyDecorators && languageVersion < 99 /* ESNext */  && classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ false, node);
            const willTransformPrivateElementsOrClassStaticBlocks = languageVersion <= 9 /* ES2022 */ ;
            const willTransformInitializers = !useDefineForClassFields || languageVersion < 9 /* ES2022 */ ;
            if (willTransformStaticElementsOfDecoratedClass || willTransformPrivateElementsOrClassStaticBlocks) for (const member of node.members){
                if (willTransformStaticElementsOfDecoratedClass && classElementOrClassElementParameterIsDecorated(/*useLegacyDecorators*/ false, member, node)) return firstOrUndefined(getDecorators(node)) ?? node;
                else if (willTransformPrivateElementsOrClassStaticBlocks) {
                    if (isClassStaticBlockDeclaration(member)) return member;
                    else if (isStatic(member)) {
                        if (isPrivateIdentifierClassElementDeclaration(member) || willTransformInitializers && isInitializedProperty(member)) return member;
                    }
                }
            }
        }
        function checkClassExpressionExternalHelpers(node) {
            if (node.name) return;
            const parent2 = walkUpOuterExpressions(node);
            if (!isNamedEvaluationSource(parent2)) return;
            const willTransformESDecorators = !legacyDecorators && languageVersion < 99 /* ESNext */ ;
            let location;
            if (willTransformESDecorators && classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ false, node)) location = firstOrUndefined(getDecorators(node)) ?? node;
            else location = getFirstTransformableStaticClassElement(node);
            if (location) {
                checkExternalEmitHelpers(location, 8388608 /* SetFunctionName */ );
                if ((isPropertyAssignment(parent2) || isPropertyDeclaration(parent2) || isBindingElement(parent2)) && isComputedPropertyName(parent2.name)) checkExternalEmitHelpers(location, 16777216 /* PropKey */ );
            }
        }
        function checkClassExpression(node) {
            checkClassLikeDeclaration(node);
            checkNodeDeferred(node);
            checkClassExpressionExternalHelpers(node);
            return getTypeOfSymbol(getSymbolOfDeclaration(node));
        }
        function checkClassExpressionDeferred(node) {
            forEach(node.members, checkSourceElement);
            registerForUnusedIdentifiersCheck(node);
        }
        function checkClassDeclaration(node) {
            const firstDecorator = find(node.modifiers, isDecorator);
            if (legacyDecorators && firstDecorator && some(node.members, (p)=>hasStaticModifier(p) && isPrivateIdentifierClassElementDeclaration(p))) grammarErrorOnNode(firstDecorator, Diagnostics.Class_decorators_can_t_be_used_with_static_private_identifier_Consider_removing_the_experimental_decorator);
            if (!node.name && !hasSyntacticModifier(node, 1024 /* Default */ )) grammarErrorOnFirstToken(node, Diagnostics.A_class_declaration_without_the_default_modifier_must_have_a_name);
            checkClassLikeDeclaration(node);
            forEach(node.members, checkSourceElement);
            registerForUnusedIdentifiersCheck(node);
        }
        function checkClassLikeDeclaration(node) {
            checkGrammarClassLikeDeclaration(node);
            checkDecorators(node);
            checkCollisionsForDeclarationName(node, node.name);
            checkTypeParameters(getEffectiveTypeParameterDeclarations(node));
            checkExportsOnMergedDeclarations(node);
            const symbol = getSymbolOfDeclaration(node);
            const type = getDeclaredTypeOfSymbol(symbol);
            const typeWithThis = getTypeWithThisArgument(type);
            const staticType = getTypeOfSymbol(symbol);
            checkTypeParameterListsIdentical(symbol);
            checkFunctionOrConstructorSymbol(symbol);
            checkClassForDuplicateDeclarations(node);
            const nodeInAmbientContext = !!(node.flags & 16777216 /* Ambient */ );
            if (!nodeInAmbientContext) checkClassForStaticPropertyNameConflicts(node);
            const baseTypeNode = getEffectiveBaseTypeNode(node);
            if (baseTypeNode) {
                forEach(baseTypeNode.typeArguments, checkSourceElement);
                if (languageVersion < 2 /* ES2015 */ ) checkExternalEmitHelpers(baseTypeNode.parent, 1 /* Extends */ );
                const extendsNode = getClassExtendsHeritageElement(node);
                if (extendsNode && extendsNode !== baseTypeNode) checkExpression(extendsNode.expression);
                const baseTypes = getBaseTypes(type);
                if (baseTypes.length) addLazyDiagnostic(()=>{
                    const baseType = baseTypes[0];
                    const baseConstructorType = getBaseConstructorTypeOfClass(type);
                    const staticBaseType = getApparentType(baseConstructorType);
                    checkBaseTypeAccessibility(staticBaseType, baseTypeNode);
                    checkSourceElement(baseTypeNode.expression);
                    if (some(baseTypeNode.typeArguments)) {
                        forEach(baseTypeNode.typeArguments, checkSourceElement);
                        for (const constructor of getConstructorsForTypeArguments(staticBaseType, baseTypeNode.typeArguments, baseTypeNode)){
                            if (!checkTypeArgumentConstraints(baseTypeNode, constructor.typeParameters)) break;
                        }
                    }
                    const baseWithThis = getTypeWithThisArgument(baseType, type.thisType);
                    if (!checkTypeAssignableTo(typeWithThis, baseWithThis, /*errorNode*/ void 0)) issueMemberSpecificError(node, typeWithThis, baseWithThis, Diagnostics.Class_0_incorrectly_extends_base_class_1);
                    else checkTypeAssignableTo(staticType, getTypeWithoutSignatures(staticBaseType), node.name || node, Diagnostics.Class_static_side_0_incorrectly_extends_base_class_static_side_1);
                    if (baseConstructorType.flags & 8650752 /* TypeVariable */ ) {
                        if (!isMixinConstructorType(staticType)) error(node.name || node, Diagnostics.A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any);
                        else {
                            const constructSignatures = getSignaturesOfType(baseConstructorType, 1 /* Construct */ );
                            if (constructSignatures.some((signature)=>signature.flags & 4 /* Abstract */ ) && !hasSyntacticModifier(node, 256 /* Abstract */ )) error(node.name || node, Diagnostics.A_mixin_class_that_extends_from_a_type_variable_containing_an_abstract_construct_signature_must_also_be_declared_abstract);
                        }
                    }
                    if (!(staticBaseType.symbol && staticBaseType.symbol.flags & 32 /* Class */ ) && !(baseConstructorType.flags & 8650752 /* TypeVariable */ )) {
                        const constructors = getInstantiatedConstructorsForTypeArguments(staticBaseType, baseTypeNode.typeArguments, baseTypeNode);
                        if (forEach(constructors, (sig)=>!isJSConstructor(sig.declaration) && !isTypeIdenticalTo(getReturnTypeOfSignature(sig), baseType))) error(baseTypeNode.expression, Diagnostics.Base_constructors_must_all_have_the_same_return_type);
                    }
                    checkKindsOfPropertyMemberOverrides(type, baseType);
                });
            }
            checkMembersForOverrideModifier(node, type, typeWithThis, staticType);
            const implementedTypeNodes = getEffectiveImplementsTypeNodes(node);
            if (implementedTypeNodes) for (const typeRefNode of implementedTypeNodes){
                if (!isEntityNameExpression(typeRefNode.expression) || isOptionalChain(typeRefNode.expression)) error(typeRefNode.expression, Diagnostics.A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments);
                checkTypeReferenceNode(typeRefNode);
                addLazyDiagnostic(createImplementsDiagnostics(typeRefNode));
            }
            addLazyDiagnostic(()=>{
                checkIndexConstraints(type, symbol);
                checkIndexConstraints(staticType, symbol, /*isStaticIndex*/ true);
                checkTypeForDuplicateIndexSignatures(node);
                checkPropertyInitialization(node);
            });
            function createImplementsDiagnostics(typeRefNode) {
                return ()=>{
                    const t = getReducedType(getTypeFromTypeNode(typeRefNode));
                    if (!isErrorType(t)) {
                        if (isValidBaseType(t)) {
                            const genericDiag = t.symbol && t.symbol.flags & 32 /* Class */  ? Diagnostics.Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass : Diagnostics.Class_0_incorrectly_implements_interface_1;
                            const baseWithThis = getTypeWithThisArgument(t, type.thisType);
                            if (!checkTypeAssignableTo(typeWithThis, baseWithThis, /*errorNode*/ void 0)) issueMemberSpecificError(node, typeWithThis, baseWithThis, genericDiag);
                        } else error(typeRefNode, Diagnostics.A_class_can_only_implement_an_object_type_or_intersection_of_object_types_with_statically_known_members);
                    }
                };
            }
        }
        function checkMembersForOverrideModifier(node, type, typeWithThis, staticType) {
            const baseTypeNode = getEffectiveBaseTypeNode(node);
            const baseTypes = baseTypeNode && getBaseTypes(type);
            const baseWithThis = (baseTypes == null ? void 0 : baseTypes.length) ? getTypeWithThisArgument(first(baseTypes), type.thisType) : void 0;
            const baseStaticType = getBaseConstructorTypeOfClass(type);
            for (const member of node.members){
                if (hasAmbientModifier(member)) continue;
                if (isConstructorDeclaration(member)) forEach(member.parameters, (param)=>{
                    if (isParameterPropertyDeclaration(param, member)) checkExistingMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, param, /*memberIsParameterProperty*/ true);
                });
                checkExistingMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, member, /*memberIsParameterProperty*/ false);
            }
        }
        function checkExistingMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, member, memberIsParameterProperty, reportErrors2 = true) {
            const declaredProp = member.name && getSymbolAtLocation(member.name) || getSymbolAtLocation(member);
            if (!declaredProp) return 0 /* Ok */ ;
            return checkMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, hasOverrideModifier(member), hasAbstractModifier(member), isStatic(member), memberIsParameterProperty, symbolName(declaredProp), reportErrors2 ? member : void 0);
        }
        function checkMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, memberHasOverrideModifier, memberHasAbstractModifier, memberIsStatic, memberIsParameterProperty, memberName, errorNode) {
            const isJs = isInJSFile(node);
            const nodeInAmbientContext = !!(node.flags & 16777216 /* Ambient */ );
            if (baseWithThis && (memberHasOverrideModifier || compilerOptions.noImplicitOverride)) {
                const memberEscapedName = escapeLeadingUnderscores(memberName);
                const thisType = memberIsStatic ? staticType : typeWithThis;
                const baseType = memberIsStatic ? baseStaticType : baseWithThis;
                const prop = getPropertyOfType(thisType, memberEscapedName);
                const baseProp = getPropertyOfType(baseType, memberEscapedName);
                const baseClassName = typeToString(baseWithThis);
                if (prop && !baseProp && memberHasOverrideModifier) {
                    if (errorNode) {
                        const suggestion = getSuggestedSymbolForNonexistentClassMember(memberName, baseType);
                        suggestion ? error(errorNode, isJs ? Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1 : Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1, baseClassName, symbolToString(suggestion)) : error(errorNode, isJs ? Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0 : Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0, baseClassName);
                    }
                    return 2 /* HasInvalidOverride */ ;
                } else if (prop && (baseProp == null ? void 0 : baseProp.declarations) && compilerOptions.noImplicitOverride && !nodeInAmbientContext) {
                    const baseHasAbstract = some(baseProp.declarations, hasAbstractModifier);
                    if (memberHasOverrideModifier) return 0 /* Ok */ ;
                    if (!baseHasAbstract) {
                        if (errorNode) {
                            const diag2 = memberIsParameterProperty ? isJs ? Diagnostics.This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0 : Diagnostics.This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0 : isJs ? Diagnostics.This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0 : Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0;
                            error(errorNode, diag2, baseClassName);
                        }
                        return 1 /* NeedsOverride */ ;
                    } else if (memberHasAbstractModifier && baseHasAbstract) {
                        if (errorNode) error(errorNode, Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared_in_the_base_class_0, baseClassName);
                        return 1 /* NeedsOverride */ ;
                    }
                }
            } else if (memberHasOverrideModifier) {
                if (errorNode) {
                    const className = typeToString(type);
                    error(errorNode, isJs ? Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_extend_another_class : Diagnostics.This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another_class, className);
                }
                return 2 /* HasInvalidOverride */ ;
            }
            return 0 /* Ok */ ;
        }
        function issueMemberSpecificError(node, typeWithThis, baseWithThis, broadDiag) {
            let issuedMemberError = false;
            for (const member of node.members){
                if (isStatic(member)) continue;
                const declaredProp = member.name && getSymbolAtLocation(member.name) || getSymbolAtLocation(member);
                if (declaredProp) {
                    const prop = getPropertyOfType(typeWithThis, declaredProp.escapedName);
                    const baseProp = getPropertyOfType(baseWithThis, declaredProp.escapedName);
                    if (prop && baseProp) {
                        const rootChain = ()=>chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2, symbolToString(declaredProp), typeToString(typeWithThis), typeToString(baseWithThis));
                        if (!checkTypeAssignableTo(getTypeOfSymbol(prop), getTypeOfSymbol(baseProp), member.name || member, /*headMessage*/ void 0, rootChain)) issuedMemberError = true;
                    }
                }
            }
            if (!issuedMemberError) checkTypeAssignableTo(typeWithThis, baseWithThis, node.name || node, broadDiag);
        }
        function checkBaseTypeAccessibility(type, node) {
            const signatures = getSignaturesOfType(type, 1 /* Construct */ );
            if (signatures.length) {
                const declaration = signatures[0].declaration;
                if (declaration && hasEffectiveModifier(declaration, 8 /* Private */ )) {
                    const typeClassDeclaration = getClassLikeDeclarationOfSymbol(type.symbol);
                    if (!isNodeWithinClass(node, typeClassDeclaration)) error(node, Diagnostics.Cannot_extend_a_class_0_Class_constructor_is_marked_as_private, getFullyQualifiedName(type.symbol));
                }
            }
        }
        function getMemberOverrideModifierStatus(node, member, memberSymbol) {
            if (!member.name) return 0 /* Ok */ ;
            const classSymbol = getSymbolOfDeclaration(node);
            const type = getDeclaredTypeOfSymbol(classSymbol);
            const typeWithThis = getTypeWithThisArgument(type);
            const staticType = getTypeOfSymbol(classSymbol);
            const baseTypeNode = getEffectiveBaseTypeNode(node);
            const baseTypes = baseTypeNode && getBaseTypes(type);
            const baseWithThis = (baseTypes == null ? void 0 : baseTypes.length) ? getTypeWithThisArgument(first(baseTypes), type.thisType) : void 0;
            const baseStaticType = getBaseConstructorTypeOfClass(type);
            const memberHasOverrideModifier = member.parent ? hasOverrideModifier(member) : hasSyntacticModifier(member, 16384 /* Override */ );
            return checkMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, memberHasOverrideModifier, hasAbstractModifier(member), isStatic(member), /*memberIsParameterProperty*/ false, symbolName(memberSymbol));
        }
        function getTargetSymbol(s) {
            return getCheckFlags(s) & 1 /* Instantiated */  ? s.links.target : s;
        }
        function getClassOrInterfaceDeclarationsOfSymbol(symbol) {
            return filter(symbol.declarations, (d)=>d.kind === 262 /* ClassDeclaration */  || d.kind === 263 /* InterfaceDeclaration */ );
        }
        function checkKindsOfPropertyMemberOverrides(type, baseType) {
            var _a, _b, _c, _d;
            const baseProperties = getPropertiesOfType(baseType);
            let inheritedAbstractMemberNotImplementedError;
            basePropertyCheck: for (const baseProperty of baseProperties){
                const base = getTargetSymbol(baseProperty);
                if (base.flags & 4194304 /* Prototype */ ) continue;
                const baseSymbol = getPropertyOfObjectType(type, base.escapedName);
                if (!baseSymbol) continue;
                const derived = getTargetSymbol(baseSymbol);
                const baseDeclarationFlags = getDeclarationModifierFlagsFromSymbol(base);
                Debug.assert(!!derived, "derived should point to something, even if it is the base class' declaration.");
                if (derived === base) {
                    const derivedClassDecl = getClassLikeDeclarationOfSymbol(type.symbol);
                    if (baseDeclarationFlags & 256 /* Abstract */  && (!derivedClassDecl || !hasSyntacticModifier(derivedClassDecl, 256 /* Abstract */ ))) {
                        for (const otherBaseType of getBaseTypes(type)){
                            if (otherBaseType === baseType) continue;
                            const baseSymbol2 = getPropertyOfObjectType(otherBaseType, base.escapedName);
                            const derivedElsewhere = baseSymbol2 && getTargetSymbol(baseSymbol2);
                            if (derivedElsewhere && derivedElsewhere !== base) continue basePropertyCheck;
                        }
                        if (!inheritedAbstractMemberNotImplementedError) inheritedAbstractMemberNotImplementedError = error(derivedClassDecl, Diagnostics.Non_abstract_class_0_does_not_implement_all_abstract_members_of_1, typeToString(type), typeToString(baseType));
                        if (derivedClassDecl.kind === 230 /* ClassExpression */ ) addRelatedInfo(inheritedAbstractMemberNotImplementedError, createDiagnosticForNode(baseProperty.valueDeclaration ?? (baseProperty.declarations && first(baseProperty.declarations)) ?? derivedClassDecl, Diagnostics.Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1, symbolToString(baseProperty), typeToString(baseType)));
                        else addRelatedInfo(inheritedAbstractMemberNotImplementedError, createDiagnosticForNode(baseProperty.valueDeclaration ?? (baseProperty.declarations && first(baseProperty.declarations)) ?? derivedClassDecl, Diagnostics.Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2, typeToString(type), symbolToString(baseProperty), typeToString(baseType)));
                    }
                } else {
                    const derivedDeclarationFlags = getDeclarationModifierFlagsFromSymbol(derived);
                    if (baseDeclarationFlags & 8 /* Private */  || derivedDeclarationFlags & 8 /* Private */ ) continue;
                    let errorMessage;
                    const basePropertyFlags = base.flags & 98308 /* PropertyOrAccessor */ ;
                    const derivedPropertyFlags = derived.flags & 98308 /* PropertyOrAccessor */ ;
                    if (basePropertyFlags && derivedPropertyFlags) {
                        if ((getCheckFlags(base) & 6 /* Synthetic */  ? (_a = base.declarations) == null ? void 0 : _a.some((d)=>isPropertyAbstractOrInterface(d, baseDeclarationFlags)) : (_b = base.declarations) == null ? void 0 : _b.every((d)=>isPropertyAbstractOrInterface(d, baseDeclarationFlags))) || getCheckFlags(base) & 262144 /* Mapped */  || derived.valueDeclaration && isBinaryExpression(derived.valueDeclaration)) continue;
                        const overriddenInstanceProperty = basePropertyFlags !== 4 /* Property */  && derivedPropertyFlags === 4 /* Property */ ;
                        const overriddenInstanceAccessor = basePropertyFlags === 4 /* Property */  && derivedPropertyFlags !== 4 /* Property */ ;
                        if (overriddenInstanceProperty || overriddenInstanceAccessor) {
                            const errorMessage2 = overriddenInstanceProperty ? Diagnostics._0_is_defined_as_an_accessor_in_class_1_but_is_overridden_here_in_2_as_an_instance_property : Diagnostics._0_is_defined_as_a_property_in_class_1_but_is_overridden_here_in_2_as_an_accessor;
                            error(getNameOfDeclaration(derived.valueDeclaration) || derived.valueDeclaration, errorMessage2, symbolToString(base), typeToString(baseType), typeToString(type));
                        } else if (useDefineForClassFields) {
                            const uninitialized = (_c = derived.declarations) == null ? void 0 : _c.find((d)=>d.kind === 171 /* PropertyDeclaration */  && !d.initializer);
                            if (uninitialized && !(derived.flags & 33554432 /* Transient */ ) && !(baseDeclarationFlags & 256 /* Abstract */ ) && !(derivedDeclarationFlags & 256 /* Abstract */ ) && !((_d = derived.declarations) == null ? void 0 : _d.some((d)=>!!(d.flags & 16777216 /* Ambient */ )))) {
                                const constructor = findConstructorDeclaration(getClassLikeDeclarationOfSymbol(type.symbol));
                                const propName = uninitialized.name;
                                if (uninitialized.exclamationToken || !constructor || !isIdentifier(propName) || !strictNullChecks || !isPropertyInitializedInConstructor(propName, type, constructor)) {
                                    const errorMessage2 = Diagnostics.Property_0_will_overwrite_the_base_property_in_1_If_this_is_intentional_add_an_initializer_Otherwise_add_a_declare_modifier_or_remove_the_redundant_declaration;
                                    error(getNameOfDeclaration(derived.valueDeclaration) || derived.valueDeclaration, errorMessage2, symbolToString(base), typeToString(baseType));
                                }
                            }
                        }
                        continue;
                    } else if (isPrototypeProperty(base)) {
                        if (isPrototypeProperty(derived) || derived.flags & 4 /* Property */ ) continue;
                        else {
                            Debug.assert(!!(derived.flags & 98304 /* Accessor */ ));
                            errorMessage = Diagnostics.Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_accessor;
                        }
                    } else if (base.flags & 98304 /* Accessor */ ) errorMessage = Diagnostics.Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_function;
                    else errorMessage = Diagnostics.Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_function;
                    error(getNameOfDeclaration(derived.valueDeclaration) || derived.valueDeclaration, errorMessage, typeToString(baseType), symbolToString(base), typeToString(type));
                }
            }
        }
        function isPropertyAbstractOrInterface(declaration, baseDeclarationFlags) {
            return baseDeclarationFlags & 256 /* Abstract */  && (!isPropertyDeclaration(declaration) || !declaration.initializer) || isInterfaceDeclaration(declaration.parent);
        }
        function getNonInheritedProperties(type, baseTypes, properties) {
            if (!length(baseTypes)) return properties;
            const seen = /* @__PURE__ */ new Map();
            forEach(properties, (p)=>{
                seen.set(p.escapedName, p);
            });
            for (const base of baseTypes){
                const properties2 = getPropertiesOfType(getTypeWithThisArgument(base, type.thisType));
                for (const prop of properties2){
                    const existing = seen.get(prop.escapedName);
                    if (existing && prop.parent === existing.parent) seen.delete(prop.escapedName);
                }
            }
            return arrayFrom(seen.values());
        }
        function checkInheritedPropertiesAreIdentical(type, typeNode) {
            const baseTypes = getBaseTypes(type);
            if (baseTypes.length < 2) return true;
            const seen = /* @__PURE__ */ new Map();
            forEach(resolveDeclaredMembers(type).declaredProperties, (p)=>{
                seen.set(p.escapedName, {
                    prop: p,
                    containingType: type
                });
            });
            let ok = true;
            for (const base of baseTypes){
                const properties = getPropertiesOfType(getTypeWithThisArgument(base, type.thisType));
                for (const prop of properties){
                    const existing = seen.get(prop.escapedName);
                    if (!existing) seen.set(prop.escapedName, {
                        prop: prop,
                        containingType: base
                    });
                    else {
                        const isInheritedProperty = existing.containingType !== type;
                        if (isInheritedProperty && !isPropertyIdenticalTo(existing.prop, prop)) {
                            ok = false;
                            const typeName1 = typeToString(existing.containingType);
                            const typeName2 = typeToString(base);
                            let errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Named_property_0_of_types_1_and_2_are_not_identical, symbolToString(prop), typeName1, typeName2);
                            errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Interface_0_cannot_simultaneously_extend_types_1_and_2, typeToString(type), typeName1, typeName2);
                            diagnostics.add(createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(typeNode), typeNode, errorInfo));
                        }
                    }
                }
            }
            return ok;
        }
        function checkPropertyInitialization(node) {
            if (!strictNullChecks || !strictPropertyInitialization || node.flags & 16777216 /* Ambient */ ) return;
            const constructor = findConstructorDeclaration(node);
            for (const member of node.members){
                if (getEffectiveModifierFlags(member) & 2 /* Ambient */ ) continue;
                if (!isStatic(member) && isPropertyWithoutInitializer(member)) {
                    const propName = member.name;
                    if (isIdentifier(propName) || isPrivateIdentifier(propName) || isComputedPropertyName(propName)) {
                        const type = getTypeOfSymbol(getSymbolOfDeclaration(member));
                        if (!(type.flags & 3 /* AnyOrUnknown */  || containsUndefinedType(type))) {
                            if (!constructor || !isPropertyInitializedInConstructor(propName, type, constructor)) error(member.name, Diagnostics.Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor, declarationNameToString(propName));
                        }
                    }
                }
            }
        }
        function isPropertyWithoutInitializer(node) {
            return node.kind === 171 /* PropertyDeclaration */  && !hasAbstractModifier(node) && !node.exclamationToken && !node.initializer;
        }
        function isPropertyInitializedInStaticBlocks(propName, propType, staticBlocks, startPos, endPos) {
            for (const staticBlock of staticBlocks)if (staticBlock.pos >= startPos && staticBlock.pos <= endPos) {
                const reference = factory.createPropertyAccessExpression(factory.createThis(), propName);
                setParent(reference.expression, reference);
                setParent(reference, staticBlock);
                reference.flowNode = staticBlock.returnFlowNode;
                const flowType = getFlowTypeOfReference(reference, propType, getOptionalType(propType));
                if (!containsUndefinedType(flowType)) return true;
            }
            return false;
        }
        function isPropertyInitializedInConstructor(propName, propType, constructor) {
            const reference = isComputedPropertyName(propName) ? factory.createElementAccessExpression(factory.createThis(), propName.expression) : factory.createPropertyAccessExpression(factory.createThis(), propName);
            setParent(reference.expression, reference);
            setParent(reference, constructor);
            reference.flowNode = constructor.returnFlowNode;
            const flowType = getFlowTypeOfReference(reference, propType, getOptionalType(propType));
            return !containsUndefinedType(flowType);
        }
        function checkInterfaceDeclaration(node) {
            if (!checkGrammarModifiers(node)) checkGrammarInterfaceDeclaration(node);
            checkTypeParameters(node.typeParameters);
            addLazyDiagnostic(()=>{
                checkTypeNameIsReserved(node.name, Diagnostics.Interface_name_cannot_be_0);
                checkExportsOnMergedDeclarations(node);
                const symbol = getSymbolOfDeclaration(node);
                checkTypeParameterListsIdentical(symbol);
                const firstInterfaceDecl = getDeclarationOfKind(symbol, 263 /* InterfaceDeclaration */ );
                if (node === firstInterfaceDecl) {
                    const type = getDeclaredTypeOfSymbol(symbol);
                    const typeWithThis = getTypeWithThisArgument(type);
                    if (checkInheritedPropertiesAreIdentical(type, node.name)) {
                        for (const baseType of getBaseTypes(type))checkTypeAssignableTo(typeWithThis, getTypeWithThisArgument(baseType, type.thisType), node.name, Diagnostics.Interface_0_incorrectly_extends_interface_1);
                        checkIndexConstraints(type, symbol);
                    }
                }
                checkObjectTypeForDuplicateDeclarations(node);
            });
            forEach(getInterfaceBaseTypeNodes(node), (heritageElement)=>{
                if (!isEntityNameExpression(heritageElement.expression) || isOptionalChain(heritageElement.expression)) error(heritageElement.expression, Diagnostics.An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments);
                checkTypeReferenceNode(heritageElement);
            });
            forEach(node.members, checkSourceElement);
            addLazyDiagnostic(()=>{
                checkTypeForDuplicateIndexSignatures(node);
                registerForUnusedIdentifiersCheck(node);
            });
        }
        function checkTypeAliasDeclaration(node) {
            checkGrammarModifiers(node);
            checkTypeNameIsReserved(node.name, Diagnostics.Type_alias_name_cannot_be_0);
            checkExportsOnMergedDeclarations(node);
            checkTypeParameters(node.typeParameters);
            if (node.type.kind === 141 /* IntrinsicKeyword */ ) {
                if (!intrinsicTypeKinds.has(node.name.escapedText) || length(node.typeParameters) !== 1) error(node.type, Diagnostics.The_intrinsic_keyword_can_only_be_used_to_declare_compiler_provided_intrinsic_types);
            } else {
                checkSourceElement(node.type);
                registerForUnusedIdentifiersCheck(node);
            }
        }
        function computeEnumMemberValues(node) {
            const nodeLinks2 = getNodeLinks(node);
            if (!(nodeLinks2.flags & 1024 /* EnumValuesComputed */ )) {
                nodeLinks2.flags |= 1024 /* EnumValuesComputed */ ;
                let autoValue = 0;
                for (const member of node.members){
                    const value1 = computeMemberValue(member, autoValue);
                    getNodeLinks(member).enumMemberValue = value1;
                    autoValue = typeof value1 === "number" ? value1 + 1 : void 0;
                }
            }
        }
        function computeMemberValue(member, autoValue) {
            if (isComputedNonLiteralName(member.name)) error(member.name, Diagnostics.Computed_property_names_are_not_allowed_in_enums);
            else {
                const text = getTextOfPropertyName(member.name);
                if (isNumericLiteralName(text) && !isInfinityOrNaNString(text)) error(member.name, Diagnostics.An_enum_member_cannot_have_a_numeric_name);
            }
            if (member.initializer) return computeConstantValue(member);
            if (member.parent.flags & 16777216 /* Ambient */  && !isEnumConst(member.parent)) return void 0;
            if (autoValue !== void 0) return autoValue;
            error(member.name, Diagnostics.Enum_member_must_have_initializer);
            return void 0;
        }
        function computeConstantValue(member) {
            const isConstEnum = isEnumConst(member.parent);
            const initializer = member.initializer;
            const value1 = evaluate(initializer, member);
            if (value1 !== void 0) {
                if (isConstEnum && typeof value1 === "number" && !isFinite(value1)) error(initializer, isNaN(value1) ? Diagnostics.const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN : Diagnostics.const_enum_member_initializer_was_evaluated_to_a_non_finite_value);
            } else if (isConstEnum) error(initializer, Diagnostics.const_enum_member_initializers_must_be_constant_expressions);
            else if (member.parent.flags & 16777216 /* Ambient */ ) error(initializer, Diagnostics.In_ambient_enum_declarations_member_initializer_must_be_constant_expression);
            else checkTypeAssignableTo(checkExpression(initializer), numberType, initializer, Diagnostics.Type_0_is_not_assignable_to_type_1_as_required_for_computed_enum_member_values);
            return value1;
        }
        function evaluate(expr, location) {
            switch(expr.kind){
                case 223 /* PrefixUnaryExpression */ :
                    const value1 = evaluate(expr.operand, location);
                    if (typeof value1 === "number") switch(expr.operator){
                        case 40 /* PlusToken */ :
                            return value1;
                        case 41 /* MinusToken */ :
                            return -value1;
                        case 55 /* TildeToken */ :
                            return ~value1;
                    }
                    break;
                case 225 /* BinaryExpression */ :
                    const left = evaluate(expr.left, location);
                    const right = evaluate(expr.right, location);
                    if (typeof left === "number" && typeof right === "number") switch(expr.operatorToken.kind){
                        case 52 /* BarToken */ :
                            return left | right;
                        case 51 /* AmpersandToken */ :
                            return left & right;
                        case 49 /* GreaterThanGreaterThanToken */ :
                            return left >> right;
                        case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                            return left >>> right;
                        case 48 /* LessThanLessThanToken */ :
                            return left << right;
                        case 53 /* CaretToken */ :
                            return left ^ right;
                        case 42 /* AsteriskToken */ :
                            return left * right;
                        case 44 /* SlashToken */ :
                            return left / right;
                        case 40 /* PlusToken */ :
                            return left + right;
                        case 41 /* MinusToken */ :
                            return left - right;
                        case 45 /* PercentToken */ :
                            return left % right;
                        case 43 /* AsteriskAsteriskToken */ :
                            return left ** right;
                    }
                    else if ((typeof left === "string" || typeof left === "number") && (typeof right === "string" || typeof right === "number") && expr.operatorToken.kind === 40 /* PlusToken */ ) return "" + left + right;
                    break;
                case 11 /* StringLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    return expr.text;
                case 227 /* TemplateExpression */ :
                    return evaluateTemplateExpression(expr, location);
                case 9 /* NumericLiteral */ :
                    checkGrammarNumericLiteral(expr);
                    return +expr.text;
                case 216 /* ParenthesizedExpression */ :
                    return evaluate(expr.expression, location);
                case 80 /* Identifier */ :
                    if (isInfinityOrNaNString(expr.escapedText)) return +expr.escapedText;
                case 210 /* PropertyAccessExpression */ :
                    if (isEntityNameExpression(expr)) {
                        const symbol = resolveEntityName(expr, 111551 /* Value */ , /*ignoreErrors*/ true);
                        if (symbol) {
                            if (symbol.flags & 8 /* EnumMember */ ) return evaluateEnumMember(expr, symbol, location);
                            if (isConstVariable(symbol)) {
                                const declaration = symbol.valueDeclaration;
                                if (declaration && !declaration.type && declaration.initializer && declaration !== location && isBlockScopedNameDeclaredBeforeUse(declaration, location)) return evaluate(declaration.initializer, declaration);
                            }
                        }
                    }
                    break;
                case 211 /* ElementAccessExpression */ :
                    const root = expr.expression;
                    if (isEntityNameExpression(root) && isStringLiteralLike(expr.argumentExpression)) {
                        const rootSymbol = resolveEntityName(root, 111551 /* Value */ , /*ignoreErrors*/ true);
                        if (rootSymbol && rootSymbol.flags & 384 /* Enum */ ) {
                            const name = escapeLeadingUnderscores(expr.argumentExpression.text);
                            const member = rootSymbol.exports.get(name);
                            if (member) return evaluateEnumMember(expr, member, location);
                        }
                    }
                    break;
            }
            return void 0;
        }
        function evaluateEnumMember(expr, symbol, location) {
            const declaration = symbol.valueDeclaration;
            if (!declaration || declaration === location) {
                error(expr, Diagnostics.Property_0_is_used_before_being_assigned, symbolToString(symbol));
                return void 0;
            }
            if (!isBlockScopedNameDeclaredBeforeUse(declaration, location)) {
                error(expr, Diagnostics.A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_members_defined_in_other_enums);
                return 0;
            }
            return getEnumMemberValue(declaration);
        }
        function evaluateTemplateExpression(expr, location) {
            let result = expr.head.text;
            for (const span of expr.templateSpans){
                const value1 = evaluate(span.expression, location);
                if (value1 === void 0) return void 0;
                result += value1;
                result += span.literal.text;
            }
            return result;
        }
        function checkEnumDeclaration(node) {
            addLazyDiagnostic(()=>checkEnumDeclarationWorker(node));
        }
        function checkEnumDeclarationWorker(node) {
            checkGrammarModifiers(node);
            checkCollisionsForDeclarationName(node, node.name);
            checkExportsOnMergedDeclarations(node);
            node.members.forEach(checkEnumMember);
            computeEnumMemberValues(node);
            const enumSymbol = getSymbolOfDeclaration(node);
            const firstDeclaration = getDeclarationOfKind(enumSymbol, node.kind);
            if (node === firstDeclaration) {
                if (enumSymbol.declarations && enumSymbol.declarations.length > 1) {
                    const enumIsConst = isEnumConst(node);
                    forEach(enumSymbol.declarations, (decl)=>{
                        if (isEnumDeclaration(decl) && isEnumConst(decl) !== enumIsConst) error(getNameOfDeclaration(decl), Diagnostics.Enum_declarations_must_all_be_const_or_non_const);
                    });
                }
                let seenEnumMissingInitialInitializer = false;
                forEach(enumSymbol.declarations, (declaration)=>{
                    if (declaration.kind !== 265 /* EnumDeclaration */ ) return false;
                    const enumDeclaration = declaration;
                    if (!enumDeclaration.members.length) return false;
                    const firstEnumMember = enumDeclaration.members[0];
                    if (!firstEnumMember.initializer) {
                        if (seenEnumMissingInitialInitializer) error(firstEnumMember.name, Diagnostics.In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enum_element);
                        else seenEnumMissingInitialInitializer = true;
                    }
                });
            }
        }
        function checkEnumMember(node) {
            if (isPrivateIdentifier(node.name)) error(node, Diagnostics.An_enum_member_cannot_be_named_with_a_private_identifier);
            if (node.initializer) checkExpression(node.initializer);
        }
        function getFirstNonAmbientClassOrFunctionDeclaration(symbol) {
            const declarations = symbol.declarations;
            if (declarations) for (const declaration of declarations){
                if ((declaration.kind === 262 /* ClassDeclaration */  || declaration.kind === 261 /* FunctionDeclaration */  && nodeIsPresent(declaration.body)) && !(declaration.flags & 16777216 /* Ambient */ )) return declaration;
            }
            return void 0;
        }
        function inSameLexicalScope(node1, node2) {
            const container1 = getEnclosingBlockScopeContainer(node1);
            const container2 = getEnclosingBlockScopeContainer(node2);
            if (isGlobalSourceFile(container1)) return isGlobalSourceFile(container2);
            else if (isGlobalSourceFile(container2)) return false;
            else return container1 === container2;
        }
        function checkModuleDeclaration(node) {
            if (node.body) {
                checkSourceElement(node.body);
                if (!isGlobalScopeAugmentation(node)) registerForUnusedIdentifiersCheck(node);
            }
            addLazyDiagnostic(checkModuleDeclarationDiagnostics);
            function checkModuleDeclarationDiagnostics() {
                var _a, _b;
                const isGlobalAugmentation = isGlobalScopeAugmentation(node);
                const inAmbientContext = node.flags & 16777216 /* Ambient */ ;
                if (isGlobalAugmentation && !inAmbientContext) error(node.name, Diagnostics.Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambient_context);
                const isAmbientExternalModule = isAmbientModule(node);
                const contextErrorMessage = isAmbientExternalModule ? Diagnostics.An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file : Diagnostics.A_namespace_declaration_is_only_allowed_at_the_top_level_of_a_namespace_or_module;
                if (checkGrammarModuleElementContext(node, contextErrorMessage)) return;
                if (!checkGrammarModifiers(node)) {
                    if (!inAmbientContext && node.name.kind === 11 /* StringLiteral */ ) grammarErrorOnNode(node.name, Diagnostics.Only_ambient_modules_can_use_quoted_names);
                }
                if (isIdentifier(node.name)) checkCollisionsForDeclarationName(node, node.name);
                checkExportsOnMergedDeclarations(node);
                const symbol = getSymbolOfDeclaration(node);
                if (symbol.flags & 512 /* ValueModule */  && !inAmbientContext && isInstantiatedModule(node, shouldPreserveConstEnums(compilerOptions))) {
                    if (getIsolatedModules(compilerOptions) && !getSourceFileOfNode(node).externalModuleIndicator) error(node.name, Diagnostics.Namespaces_are_not_allowed_in_global_script_files_when_0_is_enabled_If_this_file_is_not_intended_to_be_a_global_script_set_moduleDetection_to_force_or_add_an_empty_export_statement, isolatedModulesLikeFlagName);
                    if (((_a = symbol.declarations) == null ? void 0 : _a.length) > 1) {
                        const firstNonAmbientClassOrFunc = getFirstNonAmbientClassOrFunctionDeclaration(symbol);
                        if (firstNonAmbientClassOrFunc) {
                            if (getSourceFileOfNode(node) !== getSourceFileOfNode(firstNonAmbientClassOrFunc)) error(node.name, Diagnostics.A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merged);
                            else if (node.pos < firstNonAmbientClassOrFunc.pos) error(node.name, Diagnostics.A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged);
                        }
                        const mergedClass = getDeclarationOfKind(symbol, 262 /* ClassDeclaration */ );
                        if (mergedClass && inSameLexicalScope(node, mergedClass)) getNodeLinks(node).flags |= 2048 /* LexicalModuleMergesWithClass */ ;
                    }
                    if (compilerOptions.verbatimModuleSyntax && node.parent.kind === 311 /* SourceFile */  && (moduleKind === 1 /* CommonJS */  || node.parent.impliedNodeFormat === 1 /* CommonJS */ )) {
                        const exportModifier = (_b = node.modifiers) == null ? void 0 : _b.find((m)=>m.kind === 95 /* ExportKeyword */ );
                        if (exportModifier) error(exportModifier, Diagnostics.A_top_level_export_modifier_cannot_be_used_on_value_declarations_in_a_CommonJS_module_when_verbatimModuleSyntax_is_enabled);
                    }
                }
                if (isAmbientExternalModule) {
                    if (isExternalModuleAugmentation(node)) {
                        const checkBody = isGlobalAugmentation || getSymbolOfDeclaration(node).flags & 33554432 /* Transient */ ;
                        if (checkBody && node.body) for (const statement of node.body.statements)checkModuleAugmentationElement(statement, isGlobalAugmentation);
                    } else if (isGlobalSourceFile(node.parent)) {
                        if (isGlobalAugmentation) error(node.name, Diagnostics.Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations);
                        else if (isExternalModuleNameRelative(getTextOfIdentifierOrLiteral(node.name))) error(node.name, Diagnostics.Ambient_module_declaration_cannot_specify_relative_module_name);
                    } else if (isGlobalAugmentation) error(node.name, Diagnostics.Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations);
                    else error(node.name, Diagnostics.Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces);
                }
            }
        }
        function checkModuleAugmentationElement(node, isGlobalAugmentation) {
            switch(node.kind){
                case 242 /* VariableStatement */ :
                    for (const decl of node.declarationList.declarations)checkModuleAugmentationElement(decl, isGlobalAugmentation);
                    break;
                case 276 /* ExportAssignment */ :
                case 277 /* ExportDeclaration */ :
                    grammarErrorOnFirstToken(node, Diagnostics.Exports_and_export_assignments_are_not_permitted_in_module_augmentations);
                    break;
                case 270 /* ImportEqualsDeclaration */ :
                case 271 /* ImportDeclaration */ :
                    grammarErrorOnFirstToken(node, Diagnostics.Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_module);
                    break;
                case 207 /* BindingElement */ :
                case 259 /* VariableDeclaration */ :
                    const name = node.name;
                    if (isBindingPattern(name)) {
                        for (const el of name.elements)checkModuleAugmentationElement(el, isGlobalAugmentation);
                        break;
                    }
                case 262 /* ClassDeclaration */ :
                case 265 /* EnumDeclaration */ :
                case 261 /* FunctionDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                case 266 /* ModuleDeclaration */ :
                case 264 /* TypeAliasDeclaration */ :
                    if (isGlobalAugmentation) return;
                    break;
            }
        }
        function getFirstNonModuleExportsIdentifier(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return node;
                case 165 /* QualifiedName */ :
                    do node = node.left;
                    while (node.kind !== 80 /* Identifier */ );
                    return node;
                case 210 /* PropertyAccessExpression */ :
                    do {
                        if (isModuleExportsAccessExpression(node.expression) && !isPrivateIdentifier(node.name)) return node.name;
                        node = node.expression;
                    }while (node.kind !== 80 /* Identifier */ );
                    return node;
            }
        }
        function checkExternalImportOrExportDeclaration(node) {
            const moduleName = getExternalModuleName(node);
            if (!moduleName || nodeIsMissing(moduleName)) return false;
            if (!isStringLiteral(moduleName)) {
                error(moduleName, Diagnostics.String_literal_expected);
                return false;
            }
            const inAmbientExternalModule = node.parent.kind === 267 /* ModuleBlock */  && isAmbientModule(node.parent.parent);
            if (node.parent.kind !== 311 /* SourceFile */  && !inAmbientExternalModule) {
                error(moduleName, node.kind === 277 /* ExportDeclaration */  ? Diagnostics.Export_declarations_are_not_permitted_in_a_namespace : Diagnostics.Import_declarations_in_a_namespace_cannot_reference_a_module);
                return false;
            }
            if (inAmbientExternalModule && isExternalModuleNameRelative(moduleName.text)) {
                if (!isTopLevelInExternalModuleAugmentation(node)) {
                    error(node, Diagnostics.Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relative_module_name);
                    return false;
                }
            }
            if (!isImportEqualsDeclaration(node) && node.assertClause) {
                let hasError = false;
                for (const clause of node.assertClause.elements)if (!isStringLiteral(clause.value)) {
                    hasError = true;
                    error(clause.value, Diagnostics.Import_assertion_values_must_be_string_literal_expressions);
                }
                return !hasError;
            }
            return true;
        }
        function checkAliasSymbol(node) {
            var _a, _b, _c, _d;
            let symbol = getSymbolOfDeclaration(node);
            const target = resolveAlias(symbol);
            if (target !== unknownSymbol) {
                symbol = getMergedSymbol(symbol.exportSymbol || symbol);
                if (isInJSFile(node) && !(target.flags & 111551 /* Value */ ) && !isTypeOnlyImportOrExportDeclaration(node)) {
                    const errorNode = isImportOrExportSpecifier(node) ? node.propertyName || node.name : isNamedDeclaration(node) ? node.name : node;
                    Debug.assert(node.kind !== 279 /* NamespaceExport */ );
                    if (node.kind === 280 /* ExportSpecifier */ ) {
                        const diag2 = error(errorNode, Diagnostics.Types_cannot_appear_in_export_declarations_in_JavaScript_files);
                        const alreadyExportedSymbol = (_b = (_a = getSourceFileOfNode(node).symbol) == null ? void 0 : _a.exports) == null ? void 0 : _b.get((node.propertyName || node.name).escapedText);
                        if (alreadyExportedSymbol === target) {
                            const exportingDeclaration = (_c = alreadyExportedSymbol.declarations) == null ? void 0 : _c.find(isJSDocNode);
                            if (exportingDeclaration) addRelatedInfo(diag2, createDiagnosticForNode(exportingDeclaration, Diagnostics._0_is_automatically_exported_here, unescapeLeadingUnderscores(alreadyExportedSymbol.escapedName)));
                        }
                    } else {
                        Debug.assert(node.kind !== 259 /* VariableDeclaration */ );
                        const importDeclaration = findAncestor(node, or(isImportDeclaration, isImportEqualsDeclaration));
                        const moduleSpecifier = (importDeclaration && ((_d = tryGetModuleSpecifierFromDeclaration(importDeclaration)) == null ? void 0 : _d.text)) ?? "...";
                        const importedIdentifier = unescapeLeadingUnderscores(isIdentifier(errorNode) ? errorNode.escapedText : symbol.escapedName);
                        error(errorNode, Diagnostics._0_is_a_type_and_cannot_be_imported_in_JavaScript_files_Use_1_in_a_JSDoc_type_annotation, importedIdentifier, `import("${moduleSpecifier}").${importedIdentifier}`);
                    }
                    return;
                }
                const targetFlags = getAllSymbolFlags(target);
                const excludedMeanings = (symbol.flags & 1160127 /* ExportValue */  ? 111551 /* Value */  : 0) | (symbol.flags & 788968 /* Type */  ? 788968 /* Type */  : 0) | (symbol.flags & 1920 /* Namespace */  ? 1920 /* Namespace */  : 0);
                if (targetFlags & excludedMeanings) {
                    const message = node.kind === 280 /* ExportSpecifier */  ? Diagnostics.Export_declaration_conflicts_with_exported_declaration_of_0 : Diagnostics.Import_declaration_conflicts_with_local_declaration_of_0;
                    error(node, message, symbolToString(symbol));
                }
                if (getIsolatedModules(compilerOptions) && !isTypeOnlyImportOrExportDeclaration(node) && !(node.flags & 16777216 /* Ambient */ )) {
                    const typeOnlyAlias = getTypeOnlyAliasDeclaration(symbol);
                    const isType = !(targetFlags & 111551 /* Value */ );
                    if (isType || typeOnlyAlias) switch(node.kind){
                        case 272 /* ImportClause */ :
                        case 275 /* ImportSpecifier */ :
                        case 270 /* ImportEqualsDeclaration */ :
                            if (compilerOptions.preserveValueImports || compilerOptions.verbatimModuleSyntax) {
                                Debug.assertIsDefined(node.name, "An ImportClause with a symbol should have a name");
                                const message = compilerOptions.verbatimModuleSyntax && isInternalModuleImportEqualsDeclaration(node) ? Diagnostics.An_import_alias_cannot_resolve_to_a_type_or_type_only_declaration_when_verbatimModuleSyntax_is_enabled : isType ? compilerOptions.verbatimModuleSyntax ? Diagnostics._0_is_a_type_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled : Diagnostics._0_is_a_type_and_must_be_imported_using_a_type_only_import_when_preserveValueImports_and_isolatedModules_are_both_enabled : compilerOptions.verbatimModuleSyntax ? Diagnostics._0_resolves_to_a_type_only_declaration_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled : Diagnostics._0_resolves_to_a_type_only_declaration_and_must_be_imported_using_a_type_only_import_when_preserveValueImports_and_isolatedModules_are_both_enabled;
                                const name = idText(node.kind === 275 /* ImportSpecifier */  ? node.propertyName || node.name : node.name);
                                addTypeOnlyDeclarationRelatedInfo(error(node, message, name), isType ? void 0 : typeOnlyAlias, name);
                            }
                            if (isType && node.kind === 270 /* ImportEqualsDeclaration */  && hasEffectiveModifier(node, 1 /* Export */ )) error(node, Diagnostics.Cannot_use_export_import_on_a_type_or_type_only_namespace_when_0_is_enabled, isolatedModulesLikeFlagName);
                            break;
                        case 280 /* ExportSpecifier */ :
                            if (compilerOptions.verbatimModuleSyntax || getSourceFileOfNode(typeOnlyAlias) !== getSourceFileOfNode(node)) {
                                const name = idText(node.propertyName || node.name);
                                const diagnostic = isType ? error(node, Diagnostics.Re_exporting_a_type_when_0_is_enabled_requires_using_export_type, isolatedModulesLikeFlagName) : error(node, Diagnostics._0_resolves_to_a_type_only_declaration_and_must_be_re_exported_using_a_type_only_re_export_when_1_is_enabled, name, isolatedModulesLikeFlagName);
                                addTypeOnlyDeclarationRelatedInfo(diagnostic, isType ? void 0 : typeOnlyAlias, name);
                                break;
                            }
                    }
                    if (compilerOptions.verbatimModuleSyntax && node.kind !== 270 /* ImportEqualsDeclaration */  && !isInJSFile(node) && (moduleKind === 1 /* CommonJS */  || getSourceFileOfNode(node).impliedNodeFormat === 1 /* CommonJS */ )) error(node, Diagnostics.ESM_syntax_is_not_allowed_in_a_CommonJS_module_when_verbatimModuleSyntax_is_enabled);
                }
                if (isImportSpecifier(node)) {
                    const targetSymbol = resolveAliasWithDeprecationCheck(symbol, node);
                    if (isDeprecatedSymbol(targetSymbol) && targetSymbol.declarations) addDeprecatedSuggestion(node, targetSymbol.declarations, targetSymbol.escapedName);
                }
            }
        }
        function resolveAliasWithDeprecationCheck(symbol, location) {
            if (!(symbol.flags & 2097152 /* Alias */ ) || isDeprecatedSymbol(symbol) || !getDeclarationOfAliasSymbol(symbol)) return symbol;
            const targetSymbol = resolveAlias(symbol);
            if (targetSymbol === unknownSymbol) return targetSymbol;
            while(symbol.flags & 2097152 /* Alias */ ){
                const target = getImmediateAliasedSymbol(symbol);
                if (target) {
                    if (target === targetSymbol) break;
                    if (target.declarations && length(target.declarations)) {
                        if (isDeprecatedSymbol(target)) {
                            addDeprecatedSuggestion(location, target.declarations, target.escapedName);
                            break;
                        } else {
                            if (symbol === targetSymbol) break;
                            symbol = target;
                        }
                    }
                } else break;
            }
            return targetSymbol;
        }
        function checkImportBinding(node) {
            checkCollisionsForDeclarationName(node, node.name);
            checkAliasSymbol(node);
            if (node.kind === 275 /* ImportSpecifier */  && idText(node.propertyName || node.name) === "default" && getESModuleInterop(compilerOptions) && moduleKind !== 4 /* System */  && (moduleKind < 5 /* ES2015 */  || getSourceFileOfNode(node).impliedNodeFormat === 1 /* CommonJS */ )) checkExternalEmitHelpers(node, 131072 /* ImportDefault */ );
        }
        function checkAssertClause(declaration) {
            var _a;
            if (declaration.assertClause) {
                const validForTypeAssertions = isExclusivelyTypeOnlyImportOrExport(declaration);
                const override = getResolutionModeOverrideForClause(declaration.assertClause, validForTypeAssertions ? grammarErrorOnNode : void 0);
                if (validForTypeAssertions && override) {
                    if (!isNightly()) grammarErrorOnNode(declaration.assertClause, Diagnostics.resolution_mode_assertions_are_unstable_Use_nightly_TypeScript_to_silence_this_error_Try_updating_with_npm_install_D_typescript_next);
                    if (getEmitModuleResolutionKind(compilerOptions) !== 3 /* Node16 */  && getEmitModuleResolutionKind(compilerOptions) !== 99 /* NodeNext */ ) return grammarErrorOnNode(declaration.assertClause, Diagnostics.resolution_mode_assertions_are_only_supported_when_moduleResolution_is_node16_or_nodenext);
                    return;
                }
                const mode = moduleKind === 199 /* NodeNext */  && declaration.moduleSpecifier && getUsageModeForExpression(declaration.moduleSpecifier);
                if (mode !== 99 /* ESNext */  && moduleKind !== 99 /* ESNext */ ) return grammarErrorOnNode(declaration.assertClause, moduleKind === 199 /* NodeNext */  ? Diagnostics.Import_assertions_are_not_allowed_on_statements_that_transpile_to_commonjs_require_calls : Diagnostics.Import_assertions_are_only_supported_when_the_module_option_is_set_to_esnext_or_nodenext);
                if (isImportDeclaration(declaration) ? (_a = declaration.importClause) == null ? void 0 : _a.isTypeOnly : declaration.isTypeOnly) return grammarErrorOnNode(declaration.assertClause, Diagnostics.Import_assertions_cannot_be_used_with_type_only_imports_or_exports);
                if (override) return grammarErrorOnNode(declaration.assertClause, Diagnostics.resolution_mode_can_only_be_set_for_type_only_imports);
            }
        }
        function checkImportDeclaration(node) {
            if (checkGrammarModuleElementContext(node, isInJSFile(node) ? Diagnostics.An_import_declaration_can_only_be_used_at_the_top_level_of_a_module : Diagnostics.An_import_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module)) return;
            if (!checkGrammarModifiers(node) && hasEffectiveModifiers(node)) grammarErrorOnFirstToken(node, Diagnostics.An_import_declaration_cannot_have_modifiers);
            if (checkExternalImportOrExportDeclaration(node)) {
                const importClause = node.importClause;
                if (importClause && !checkGrammarImportClause(importClause)) {
                    if (importClause.name) checkImportBinding(importClause);
                    if (importClause.namedBindings) {
                        if (importClause.namedBindings.kind === 273 /* NamespaceImport */ ) {
                            checkImportBinding(importClause.namedBindings);
                            if (moduleKind !== 4 /* System */  && (moduleKind < 5 /* ES2015 */  || getSourceFileOfNode(node).impliedNodeFormat === 1 /* CommonJS */ ) && getESModuleInterop(compilerOptions)) checkExternalEmitHelpers(node, 65536 /* ImportStar */ );
                        } else {
                            const moduleExisted = resolveExternalModuleName(node, node.moduleSpecifier);
                            if (moduleExisted) forEach(importClause.namedBindings.elements, checkImportBinding);
                        }
                    }
                }
            }
            checkAssertClause(node);
        }
        function checkImportEqualsDeclaration(node) {
            if (checkGrammarModuleElementContext(node, isInJSFile(node) ? Diagnostics.An_import_declaration_can_only_be_used_at_the_top_level_of_a_module : Diagnostics.An_import_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module)) return;
            checkGrammarModifiers(node);
            if (isInternalModuleImportEqualsDeclaration(node) || checkExternalImportOrExportDeclaration(node)) {
                checkImportBinding(node);
                if (hasSyntacticModifier(node, 1 /* Export */ )) markExportAsReferenced(node);
                if (node.moduleReference.kind !== 282 /* ExternalModuleReference */ ) {
                    const target = resolveAlias(getSymbolOfDeclaration(node));
                    if (target !== unknownSymbol) {
                        const targetFlags = getAllSymbolFlags(target);
                        if (targetFlags & 111551 /* Value */ ) {
                            const moduleName = getFirstIdentifier(node.moduleReference);
                            if (!(resolveEntityName(moduleName, 112575 /* Namespace */ ).flags & 1920 /* Namespace */ )) error(moduleName, Diagnostics.Module_0_is_hidden_by_a_local_declaration_with_the_same_name, declarationNameToString(moduleName));
                        }
                        if (targetFlags & 788968 /* Type */ ) checkTypeNameIsReserved(node.name, Diagnostics.Import_name_cannot_be_0);
                    }
                    if (node.isTypeOnly) grammarErrorOnNode(node, Diagnostics.An_import_alias_cannot_use_import_type);
                } else if (moduleKind >= 5 /* ES2015 */  && getSourceFileOfNode(node).impliedNodeFormat === void 0 && !node.isTypeOnly && !(node.flags & 16777216 /* Ambient */ )) grammarErrorOnNode(node, Diagnostics.Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_ns_from_mod_import_a_from_mod_import_d_from_mod_or_another_module_format_instead);
            }
        }
        function checkExportDeclaration(node) {
            if (checkGrammarModuleElementContext(node, isInJSFile(node) ? Diagnostics.An_export_declaration_can_only_be_used_at_the_top_level_of_a_module : Diagnostics.An_export_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module)) return;
            if (!checkGrammarModifiers(node) && hasSyntacticModifiers(node)) grammarErrorOnFirstToken(node, Diagnostics.An_export_declaration_cannot_have_modifiers);
            if (node.moduleSpecifier && node.exportClause && isNamedExports(node.exportClause) && length(node.exportClause.elements) && languageVersion === 0 /* ES3 */ ) checkExternalEmitHelpers(node, 4194304 /* CreateBinding */ );
            checkGrammarExportDeclaration(node);
            if (!node.moduleSpecifier || checkExternalImportOrExportDeclaration(node)) {
                if (node.exportClause && !isNamespaceExport(node.exportClause)) {
                    forEach(node.exportClause.elements, checkExportSpecifier);
                    const inAmbientExternalModule = node.parent.kind === 267 /* ModuleBlock */  && isAmbientModule(node.parent.parent);
                    const inAmbientNamespaceDeclaration = !inAmbientExternalModule && node.parent.kind === 267 /* ModuleBlock */  && !node.moduleSpecifier && node.flags & 16777216 /* Ambient */ ;
                    if (node.parent.kind !== 311 /* SourceFile */  && !inAmbientExternalModule && !inAmbientNamespaceDeclaration) error(node, Diagnostics.Export_declarations_are_not_permitted_in_a_namespace);
                } else {
                    const moduleSymbol = resolveExternalModuleName(node, node.moduleSpecifier);
                    if (moduleSymbol && hasExportAssignmentSymbol(moduleSymbol)) error(node.moduleSpecifier, Diagnostics.Module_0_uses_export_and_cannot_be_used_with_export_Asterisk, symbolToString(moduleSymbol));
                    else if (node.exportClause) checkAliasSymbol(node.exportClause);
                    if (moduleKind !== 4 /* System */  && (moduleKind < 5 /* ES2015 */  || getSourceFileOfNode(node).impliedNodeFormat === 1 /* CommonJS */ )) {
                        if (node.exportClause) {
                            if (getESModuleInterop(compilerOptions)) checkExternalEmitHelpers(node, 65536 /* ImportStar */ );
                        } else checkExternalEmitHelpers(node, 32768 /* ExportStar */ );
                    }
                }
            }
            checkAssertClause(node);
        }
        function checkGrammarExportDeclaration(node) {
            var _a;
            if (node.isTypeOnly && ((_a = node.exportClause) == null ? void 0 : _a.kind) === 278 /* NamedExports */ ) return checkGrammarNamedImportsOrExports(node.exportClause);
            return false;
        }
        function checkGrammarModuleElementContext(node, errorMessage) {
            const isInAppropriateContext = node.parent.kind === 311 /* SourceFile */  || node.parent.kind === 267 /* ModuleBlock */  || node.parent.kind === 266 /* ModuleDeclaration */ ;
            if (!isInAppropriateContext) grammarErrorOnFirstToken(node, errorMessage);
            return !isInAppropriateContext;
        }
        function importClauseContainsReferencedImport(importClause) {
            return forEachImportClauseDeclaration(importClause, (declaration)=>{
                return !!getSymbolOfDeclaration(declaration).isReferenced;
            });
        }
        function importClauseContainsConstEnumUsedAsValue(importClause) {
            return forEachImportClauseDeclaration(importClause, (declaration)=>{
                return !!getSymbolLinks(getSymbolOfDeclaration(declaration)).constEnumReferenced;
            });
        }
        function canConvertImportDeclarationToTypeOnly(statement) {
            return isImportDeclaration(statement) && statement.importClause && !statement.importClause.isTypeOnly && importClauseContainsReferencedImport(statement.importClause) && !isReferencedAliasDeclaration(statement.importClause, /*checkChildren*/ true) && !importClauseContainsConstEnumUsedAsValue(statement.importClause);
        }
        function canConvertImportEqualsDeclarationToTypeOnly(statement) {
            return isImportEqualsDeclaration(statement) && isExternalModuleReference(statement.moduleReference) && !statement.isTypeOnly && getSymbolOfDeclaration(statement).isReferenced && !isReferencedAliasDeclaration(statement, /*checkChildren*/ false) && !getSymbolLinks(getSymbolOfDeclaration(statement)).constEnumReferenced;
        }
        function checkImportsForTypeOnlyConversion(sourceFile) {
            if (!canCollectSymbolAliasAccessabilityData) return;
            for (const statement of sourceFile.statements)if (canConvertImportDeclarationToTypeOnly(statement) || canConvertImportEqualsDeclarationToTypeOnly(statement)) error(statement, Diagnostics.This_import_is_never_used_as_a_value_and_must_use_import_type_because_importsNotUsedAsValues_is_set_to_error);
        }
        function checkExportSpecifier(node) {
            checkAliasSymbol(node);
            if (getEmitDeclarations(compilerOptions)) collectLinkedAliases(node.propertyName || node.name, /*setVisibility*/ true);
            if (!node.parent.parent.moduleSpecifier) {
                const exportedName = node.propertyName || node.name;
                const symbol = resolveName(exportedName, exportedName.escapedText, 2998271 /* Alias */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ true);
                if (symbol && (symbol === undefinedSymbol || symbol === globalThisSymbol || symbol.declarations && isGlobalSourceFile(getDeclarationContainer(symbol.declarations[0])))) error(exportedName, Diagnostics.Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module, idText(exportedName));
                else {
                    if (!node.isTypeOnly && !node.parent.parent.isTypeOnly) markExportAsReferenced(node);
                    const target = symbol && (symbol.flags & 2097152 /* Alias */  ? resolveAlias(symbol) : symbol);
                    if (!target || getAllSymbolFlags(target) & 111551 /* Value */ ) checkExpressionCached(node.propertyName || node.name);
                }
            } else if (getESModuleInterop(compilerOptions) && moduleKind !== 4 /* System */  && (moduleKind < 5 /* ES2015 */  || getSourceFileOfNode(node).impliedNodeFormat === 1 /* CommonJS */ ) && idText(node.propertyName || node.name) === "default") checkExternalEmitHelpers(node, 131072 /* ImportDefault */ );
        }
        function checkExportAssignment(node) {
            const illegalContextMessage = node.isExportEquals ? Diagnostics.An_export_assignment_must_be_at_the_top_level_of_a_file_or_module_declaration : Diagnostics.A_default_export_must_be_at_the_top_level_of_a_file_or_module_declaration;
            if (checkGrammarModuleElementContext(node, illegalContextMessage)) return;
            const container = node.parent.kind === 311 /* SourceFile */  ? node.parent : node.parent.parent;
            if (container.kind === 266 /* ModuleDeclaration */  && !isAmbientModule(container)) {
                if (node.isExportEquals) error(node, Diagnostics.An_export_assignment_cannot_be_used_in_a_namespace);
                else error(node, Diagnostics.A_default_export_can_only_be_used_in_an_ECMAScript_style_module);
                return;
            }
            if (!checkGrammarModifiers(node) && hasEffectiveModifiers(node)) grammarErrorOnFirstToken(node, Diagnostics.An_export_assignment_cannot_have_modifiers);
            const typeAnnotationNode = getEffectiveTypeAnnotationNode(node);
            if (typeAnnotationNode) checkTypeAssignableTo(checkExpressionCached(node.expression), getTypeFromTypeNode(typeAnnotationNode), node.expression);
            const isIllegalExportDefaultInCJS = !node.isExportEquals && !(node.flags & 16777216 /* Ambient */ ) && compilerOptions.verbatimModuleSyntax && (moduleKind === 1 /* CommonJS */  || getSourceFileOfNode(node).impliedNodeFormat === 1 /* CommonJS */ );
            if (node.expression.kind === 80 /* Identifier */ ) {
                const id = node.expression;
                const sym = getExportSymbolOfValueSymbolIfExported(resolveEntityName(id, 67108863 /* All */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true, node));
                if (sym) {
                    markAliasReferenced(sym, id);
                    if (getAllSymbolFlags(sym) & 111551 /* Value */ ) {
                        checkExpressionCached(id);
                        if (!isIllegalExportDefaultInCJS && !(node.flags & 16777216 /* Ambient */ ) && compilerOptions.verbatimModuleSyntax && getTypeOnlyAliasDeclaration(sym, 111551 /* Value */ )) error(id, node.isExportEquals ? Diagnostics.An_export_declaration_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolves_to_a_type_only_declaration : Diagnostics.An_export_default_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolves_to_a_type_only_declaration, idText(id));
                    } else if (!isIllegalExportDefaultInCJS && !(node.flags & 16777216 /* Ambient */ ) && compilerOptions.verbatimModuleSyntax) error(id, node.isExportEquals ? Diagnostics.An_export_declaration_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers_to_a_type : Diagnostics.An_export_default_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers_to_a_type, idText(id));
                } else checkExpressionCached(id);
                if (getEmitDeclarations(compilerOptions)) collectLinkedAliases(id, /*setVisibility*/ true);
            } else checkExpressionCached(node.expression);
            if (isIllegalExportDefaultInCJS) error(node, Diagnostics.ESM_syntax_is_not_allowed_in_a_CommonJS_module_when_verbatimModuleSyntax_is_enabled);
            checkExternalModuleExports(container);
            if (node.flags & 16777216 /* Ambient */  && !isEntityNameExpression(node.expression)) grammarErrorOnNode(node.expression, Diagnostics.The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context);
            if (node.isExportEquals) {
                if (moduleKind >= 5 /* ES2015 */  && (node.flags & 16777216 /* Ambient */  && getSourceFileOfNode(node).impliedNodeFormat === 99 /* ESNext */  || !(node.flags & 16777216 /* Ambient */ ) && getSourceFileOfNode(node).impliedNodeFormat !== 1 /* CommonJS */ )) grammarErrorOnNode(node, Diagnostics.Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or_another_module_format_instead);
                else if (moduleKind === 4 /* System */  && !(node.flags & 16777216 /* Ambient */ )) grammarErrorOnNode(node, Diagnostics.Export_assignment_is_not_supported_when_module_flag_is_system);
            }
        }
        function hasExportedMembers(moduleSymbol) {
            return forEachEntry(moduleSymbol.exports, (_, id)=>id !== "export=");
        }
        function checkExternalModuleExports(node) {
            const moduleSymbol = getSymbolOfDeclaration(node);
            const links = getSymbolLinks(moduleSymbol);
            if (!links.exportsChecked) {
                const exportEqualsSymbol = moduleSymbol.exports.get("export=");
                if (exportEqualsSymbol && hasExportedMembers(moduleSymbol)) {
                    const declaration = getDeclarationOfAliasSymbol(exportEqualsSymbol) || exportEqualsSymbol.valueDeclaration;
                    if (declaration && !isTopLevelInExternalModuleAugmentation(declaration) && !isInJSFile(declaration)) error(declaration, Diagnostics.An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements);
                }
                const exports = getExportsOfModule(moduleSymbol);
                if (exports) exports.forEach(({ declarations: declarations , flags: flags  }, id)=>{
                    if (id === "__export") return;
                    if (flags & 1920 /* Enum */ ) return;
                    const exportedDeclarationsCount = countWhere(declarations, and(isNotOverloadAndNotAccessor, not(isInterfaceDeclaration)));
                    if (flags & 524288 /* TypeAlias */  && exportedDeclarationsCount <= 2) return;
                    if (exportedDeclarationsCount > 1) {
                        if (!isDuplicatedCommonJSExport(declarations)) {
                            for (const declaration of declarations)if (isNotOverload(declaration)) diagnostics.add(createDiagnosticForNode(declaration, Diagnostics.Cannot_redeclare_exported_variable_0, unescapeLeadingUnderscores(id)));
                        }
                    }
                });
                links.exportsChecked = true;
            }
        }
        function isDuplicatedCommonJSExport(declarations) {
            return declarations && declarations.length > 1 && declarations.every((d)=>isInJSFile(d) && isAccessExpression(d) && (isExportsIdentifier(d.expression) || isModuleExportsAccessExpression(d.expression)));
        }
        function checkSourceElement(node) {
            if (node) {
                const saveCurrentNode = currentNode;
                currentNode = node;
                instantiationCount = 0;
                checkSourceElementWorker(node);
                currentNode = saveCurrentNode;
            }
        }
        function checkSourceElementWorker(node) {
            if (canHaveJSDoc(node)) forEach(node.jsDoc, ({ comment: comment , tags: tags  })=>{
                checkJSDocCommentWorker(comment);
                forEach(tags, (tag)=>{
                    checkJSDocCommentWorker(tag.comment);
                    if (isInJSFile(node)) checkSourceElement(tag);
                });
            });
            const kind = node.kind;
            if (cancellationToken) switch(kind){
                case 266 /* ModuleDeclaration */ :
                case 262 /* ClassDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                case 261 /* FunctionDeclaration */ :
                    cancellationToken.throwIfCancellationRequested();
            }
            if (kind >= 242 /* FirstStatement */  && kind <= 258 /* LastStatement */  && canHaveFlowNode(node) && node.flowNode && !isReachableFlowNode(node.flowNode)) errorOrSuggestion(compilerOptions.allowUnreachableCode === false, node, Diagnostics.Unreachable_code_detected);
            switch(kind){
                case 167 /* TypeParameter */ :
                    return checkTypeParameter(node);
                case 168 /* Parameter */ :
                    return checkParameter(node);
                case 171 /* PropertyDeclaration */ :
                    return checkPropertyDeclaration(node);
                case 170 /* PropertySignature */ :
                    return checkPropertySignature(node);
                case 184 /* ConstructorType */ :
                case 183 /* FunctionType */ :
                case 178 /* CallSignature */ :
                case 179 /* ConstructSignature */ :
                case 180 /* IndexSignature */ :
                    return checkSignatureDeclaration(node);
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                    return checkMethodDeclaration(node);
                case 174 /* ClassStaticBlockDeclaration */ :
                    return checkClassStaticBlockDeclaration(node);
                case 175 /* Constructor */ :
                    return checkConstructorDeclaration(node);
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    return checkAccessorDeclaration(node);
                case 182 /* TypeReference */ :
                    return checkTypeReferenceNode(node);
                case 181 /* TypePredicate */ :
                    return checkTypePredicate(node);
                case 185 /* TypeQuery */ :
                    return checkTypeQuery(node);
                case 186 /* TypeLiteral */ :
                    return checkTypeLiteral(node);
                case 187 /* ArrayType */ :
                    return checkArrayType(node);
                case 188 /* TupleType */ :
                    return checkTupleType(node);
                case 191 /* UnionType */ :
                case 192 /* IntersectionType */ :
                    return checkUnionOrIntersectionType(node);
                case 195 /* ParenthesizedType */ :
                case 189 /* OptionalType */ :
                case 190 /* RestType */ :
                    return checkSourceElement(node.type);
                case 196 /* ThisType */ :
                    return checkThisType(node);
                case 197 /* TypeOperator */ :
                    return checkTypeOperator(node);
                case 193 /* ConditionalType */ :
                    return checkConditionalType(node);
                case 194 /* InferType */ :
                    return checkInferType(node);
                case 202 /* TemplateLiteralType */ :
                    return checkTemplateLiteralType(node);
                case 204 /* ImportType */ :
                    return checkImportType(node);
                case 201 /* NamedTupleMember */ :
                    return checkNamedTupleMember(node);
                case 334 /* JSDocAugmentsTag */ :
                    return checkJSDocAugmentsTag(node);
                case 335 /* JSDocImplementsTag */ :
                    return checkJSDocImplementsTag(node);
                case 352 /* JSDocTypedefTag */ :
                case 344 /* JSDocCallbackTag */ :
                case 346 /* JSDocEnumTag */ :
                    return checkJSDocTypeAliasTag(node);
                case 351 /* JSDocTemplateTag */ :
                    return checkJSDocTemplateTag(node);
                case 350 /* JSDocTypeTag */ :
                    return checkJSDocTypeTag(node);
                case 330 /* JSDocLink */ :
                case 331 /* JSDocLinkCode */ :
                case 332 /* JSDocLinkPlain */ :
                    return checkJSDocLinkLikeTag(node);
                case 347 /* JSDocParameterTag */ :
                    return checkJSDocParameterTag(node);
                case 354 /* JSDocPropertyTag */ :
                    return checkJSDocPropertyTag(node);
                case 323 /* JSDocFunctionType */ :
                    checkJSDocFunctionType(node);
                case 321 /* JSDocNonNullableType */ :
                case 320 /* JSDocNullableType */ :
                case 318 /* JSDocAllType */ :
                case 319 /* JSDocUnknownType */ :
                case 328 /* JSDocTypeLiteral */ :
                    checkJSDocTypeIsInJsFile(node);
                    forEachChild(node, checkSourceElement);
                    return;
                case 324 /* JSDocVariadicType */ :
                    checkJSDocVariadicType(node);
                    return;
                case 315 /* JSDocTypeExpression */ :
                    return checkSourceElement(node.type);
                case 339 /* JSDocPublicTag */ :
                case 341 /* JSDocProtectedTag */ :
                case 340 /* JSDocPrivateTag */ :
                    return checkJSDocAccessibilityModifiers(node);
                case 356 /* JSDocSatisfiesTag */ :
                    return checkJSDocSatisfiesTag(node);
                case 198 /* IndexedAccessType */ :
                    return checkIndexedAccessType(node);
                case 199 /* MappedType */ :
                    return checkMappedType(node);
                case 261 /* FunctionDeclaration */ :
                    return checkFunctionDeclaration(node);
                case 240 /* Block */ :
                case 267 /* ModuleBlock */ :
                    return checkBlock(node);
                case 242 /* VariableStatement */ :
                    return checkVariableStatement(node);
                case 243 /* ExpressionStatement */ :
                    return checkExpressionStatement(node);
                case 244 /* IfStatement */ :
                    return checkIfStatement(node);
                case 245 /* DoStatement */ :
                    return checkDoStatement(node);
                case 246 /* WhileStatement */ :
                    return checkWhileStatement(node);
                case 247 /* ForStatement */ :
                    return checkForStatement(node);
                case 248 /* ForInStatement */ :
                    return checkForInStatement(node);
                case 249 /* ForOfStatement */ :
                    return checkForOfStatement(node);
                case 250 /* ContinueStatement */ :
                case 251 /* BreakStatement */ :
                    return checkBreakOrContinueStatement(node);
                case 252 /* ReturnStatement */ :
                    return checkReturnStatement(node);
                case 253 /* WithStatement */ :
                    return checkWithStatement(node);
                case 254 /* SwitchStatement */ :
                    return checkSwitchStatement(node);
                case 255 /* LabeledStatement */ :
                    return checkLabeledStatement(node);
                case 256 /* ThrowStatement */ :
                    return checkThrowStatement(node);
                case 257 /* TryStatement */ :
                    return checkTryStatement(node);
                case 259 /* VariableDeclaration */ :
                    return checkVariableDeclaration(node);
                case 207 /* BindingElement */ :
                    return checkBindingElement(node);
                case 262 /* ClassDeclaration */ :
                    return checkClassDeclaration(node);
                case 263 /* InterfaceDeclaration */ :
                    return checkInterfaceDeclaration(node);
                case 264 /* TypeAliasDeclaration */ :
                    return checkTypeAliasDeclaration(node);
                case 265 /* EnumDeclaration */ :
                    return checkEnumDeclaration(node);
                case 266 /* ModuleDeclaration */ :
                    return checkModuleDeclaration(node);
                case 271 /* ImportDeclaration */ :
                    return checkImportDeclaration(node);
                case 270 /* ImportEqualsDeclaration */ :
                    return checkImportEqualsDeclaration(node);
                case 277 /* ExportDeclaration */ :
                    return checkExportDeclaration(node);
                case 276 /* ExportAssignment */ :
                    return checkExportAssignment(node);
                case 241 /* EmptyStatement */ :
                case 258 /* DebuggerStatement */ :
                    checkGrammarStatementInAmbientContext(node);
                    return;
                case 281 /* MissingDeclaration */ :
                    return checkMissingDeclaration(node);
            }
        }
        function checkJSDocCommentWorker(node) {
            if (isArray(node)) forEach(node, (tag)=>{
                if (isJSDocLinkLike(tag)) checkSourceElement(tag);
            });
        }
        function checkJSDocTypeIsInJsFile(node) {
            if (!isInJSFile(node)) {
                if (isJSDocNonNullableType(node) || isJSDocNullableType(node)) {
                    const token = tokenToString(isJSDocNonNullableType(node) ? 54 /* ExclamationToken */  : 58 /* QuestionToken */ );
                    const diagnostic = node.postfix ? Diagnostics._0_at_the_end_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1 : Diagnostics._0_at_the_start_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1;
                    const typeNode = node.type;
                    const type = getTypeFromTypeNode(typeNode);
                    grammarErrorOnNode(node, diagnostic, token, typeToString(isJSDocNullableType(node) && !(type === neverType || type === voidType) ? getUnionType(append([
                        type,
                        undefinedType
                    ], node.postfix ? void 0 : nullType)) : type));
                } else grammarErrorOnNode(node, Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments);
            }
        }
        function checkJSDocVariadicType(node) {
            checkJSDocTypeIsInJsFile(node);
            checkSourceElement(node.type);
            const { parent: parent2  } = node;
            if (isParameter(parent2) && isJSDocFunctionType(parent2.parent)) {
                if (last(parent2.parent.parameters) !== parent2) error(node, Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list);
                return;
            }
            if (!isJSDocTypeExpression(parent2)) error(node, Diagnostics.JSDoc_may_only_appear_in_the_last_parameter_of_a_signature);
            const paramTag = node.parent.parent;
            if (!isJSDocParameterTag(paramTag)) {
                error(node, Diagnostics.JSDoc_may_only_appear_in_the_last_parameter_of_a_signature);
                return;
            }
            const param = getParameterSymbolFromJSDoc(paramTag);
            if (!param) return;
            const host2 = getHostSignatureFromJSDoc(paramTag);
            if (!host2 || last(host2.parameters).symbol !== param) error(node, Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list);
        }
        function getTypeFromJSDocVariadicType(node) {
            const type = getTypeFromTypeNode(node.type);
            const { parent: parent2  } = node;
            const paramTag = node.parent.parent;
            if (isJSDocTypeExpression(node.parent) && isJSDocParameterTag(paramTag)) {
                const host2 = getHostSignatureFromJSDoc(paramTag);
                const isCallbackTag = isJSDocCallbackTag(paramTag.parent.parent);
                if (host2 || isCallbackTag) {
                    const lastParamDeclaration = isCallbackTag ? lastOrUndefined(paramTag.parent.parent.typeExpression.parameters) : lastOrUndefined(host2.parameters);
                    const symbol = getParameterSymbolFromJSDoc(paramTag);
                    if (!lastParamDeclaration || symbol && lastParamDeclaration.symbol === symbol && isRestParameter(lastParamDeclaration)) return createArrayType(type);
                }
            }
            if (isParameter(parent2) && isJSDocFunctionType(parent2.parent)) return createArrayType(type);
            return addOptionality(type);
        }
        function checkNodeDeferred(node) {
            const enclosingFile = getSourceFileOfNode(node);
            const links = getNodeLinks(enclosingFile);
            if (!(links.flags & 1 /* TypeChecked */ )) {
                links.deferredNodes || (links.deferredNodes = /* @__PURE__ */ new Set());
                links.deferredNodes.add(node);
            } else Debug.assert(!links.deferredNodes, "A type-checked file should have no deferred nodes.");
        }
        function checkDeferredNodes(context) {
            const links = getNodeLinks(context);
            if (links.deferredNodes) links.deferredNodes.forEach(checkDeferredNode);
            links.deferredNodes = void 0;
        }
        function checkDeferredNode(node) {
            var _a, _b;
            (_a = tracing) == null || _a.push(tracing.Phase.Check, "checkDeferredNode", {
                kind: node.kind,
                pos: node.pos,
                end: node.end,
                path: node.tracingPath
            });
            const saveCurrentNode = currentNode;
            currentNode = node;
            instantiationCount = 0;
            switch(node.kind){
                case 212 /* CallExpression */ :
                case 213 /* NewExpression */ :
                case 214 /* TaggedTemplateExpression */ :
                case 169 /* Decorator */ :
                case 285 /* JsxOpeningElement */ :
                    resolveUntypedCall(node);
                    break;
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                    checkFunctionExpressionOrObjectLiteralMethodDeferred(node);
                    break;
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    checkAccessorDeclaration(node);
                    break;
                case 230 /* ClassExpression */ :
                    checkClassExpressionDeferred(node);
                    break;
                case 167 /* TypeParameter */ :
                    checkTypeParameterDeferred(node);
                    break;
                case 284 /* JsxSelfClosingElement */ :
                    checkJsxSelfClosingElementDeferred(node);
                    break;
                case 283 /* JsxElement */ :
                    checkJsxElementDeferred(node);
                    break;
                case 215 /* TypeAssertionExpression */ :
                case 233 /* AsExpression */ :
                case 216 /* ParenthesizedExpression */ :
                    checkAssertionDeferred(node);
            }
            currentNode = saveCurrentNode;
            (_b = tracing) == null || _b.pop();
        }
        function checkSourceFile(node) {
            var _a, _b;
            (_a = tracing) == null || _a.push(tracing.Phase.Check, "checkSourceFile", {
                path: node.path
            }, /*separateBeginAndEnd*/ true);
            mark("beforeCheck");
            checkSourceFileWorker(node);
            mark("afterCheck");
            measure("Check", "beforeCheck", "afterCheck");
            (_b = tracing) == null || _b.pop();
        }
        function unusedIsError(kind, isAmbient) {
            if (isAmbient) return false;
            switch(kind){
                case 0 /* Local */ :
                    return !!compilerOptions.noUnusedLocals;
                case 1 /* Parameter */ :
                    return !!compilerOptions.noUnusedParameters;
                default:
                    return Debug.assertNever(kind);
            }
        }
        function getPotentiallyUnusedIdentifiers(sourceFile) {
            return allPotentiallyUnusedIdentifiers.get(sourceFile.path) || emptyArray;
        }
        function checkSourceFileWorker(node) {
            const links = getNodeLinks(node);
            if (!(links.flags & 1 /* TypeChecked */ )) {
                if (skipTypeChecking(node, compilerOptions, host)) return;
                checkGrammarSourceFile(node);
                clear(potentialThisCollisions);
                clear(potentialNewTargetCollisions);
                clear(potentialWeakMapSetCollisions);
                clear(potentialReflectCollisions);
                clear(potentialUnusedRenamedBindingElementsInTypes);
                forEach(node.statements, checkSourceElement);
                checkSourceElement(node.endOfFileToken);
                checkDeferredNodes(node);
                if (isExternalOrCommonJsModule(node)) registerForUnusedIdentifiersCheck(node);
                addLazyDiagnostic(()=>{
                    if (!node.isDeclarationFile && (compilerOptions.noUnusedLocals || compilerOptions.noUnusedParameters)) checkUnusedIdentifiers(getPotentiallyUnusedIdentifiers(node), (containingNode, kind, diag2)=>{
                        if (!containsParseError(containingNode) && unusedIsError(kind, !!(containingNode.flags & 16777216 /* Ambient */ ))) diagnostics.add(diag2);
                    });
                    if (!node.isDeclarationFile) checkPotentialUncheckedRenamedBindingElementsInTypes();
                });
                if (compilerOptions.importsNotUsedAsValues === 2 /* Error */  && !node.isDeclarationFile && isExternalModule(node)) checkImportsForTypeOnlyConversion(node);
                if (isExternalOrCommonJsModule(node)) checkExternalModuleExports(node);
                if (potentialThisCollisions.length) {
                    forEach(potentialThisCollisions, checkIfThisIsCapturedInEnclosingScope);
                    clear(potentialThisCollisions);
                }
                if (potentialNewTargetCollisions.length) {
                    forEach(potentialNewTargetCollisions, checkIfNewTargetIsCapturedInEnclosingScope);
                    clear(potentialNewTargetCollisions);
                }
                if (potentialWeakMapSetCollisions.length) {
                    forEach(potentialWeakMapSetCollisions, checkWeakMapSetCollision);
                    clear(potentialWeakMapSetCollisions);
                }
                if (potentialReflectCollisions.length) {
                    forEach(potentialReflectCollisions, checkReflectCollision);
                    clear(potentialReflectCollisions);
                }
                links.flags |= 1 /* TypeChecked */ ;
            }
        }
        function getDiagnostics2(sourceFile, ct) {
            try {
                cancellationToken = ct;
                return getDiagnosticsWorker(sourceFile);
            } finally{
                cancellationToken = void 0;
            }
        }
        function ensurePendingDiagnosticWorkComplete() {
            for (const cb of deferredDiagnosticsCallbacks)cb();
            deferredDiagnosticsCallbacks = [];
        }
        function checkSourceFileWithEagerDiagnostics(sourceFile) {
            ensurePendingDiagnosticWorkComplete();
            const oldAddLazyDiagnostics = addLazyDiagnostic;
            addLazyDiagnostic = (cb)=>cb();
            checkSourceFile(sourceFile);
            addLazyDiagnostic = oldAddLazyDiagnostics;
        }
        function getDiagnosticsWorker(sourceFile) {
            if (sourceFile) {
                ensurePendingDiagnosticWorkComplete();
                const previousGlobalDiagnostics = diagnostics.getGlobalDiagnostics();
                const previousGlobalDiagnosticsSize = previousGlobalDiagnostics.length;
                checkSourceFileWithEagerDiagnostics(sourceFile);
                const semanticDiagnostics = diagnostics.getDiagnostics(sourceFile.fileName);
                const currentGlobalDiagnostics = diagnostics.getGlobalDiagnostics();
                if (currentGlobalDiagnostics !== previousGlobalDiagnostics) {
                    const deferredGlobalDiagnostics = relativeComplement(previousGlobalDiagnostics, currentGlobalDiagnostics, compareDiagnostics);
                    return concatenate(deferredGlobalDiagnostics, semanticDiagnostics);
                } else if (previousGlobalDiagnosticsSize === 0 && currentGlobalDiagnostics.length > 0) return concatenate(currentGlobalDiagnostics, semanticDiagnostics);
                return semanticDiagnostics;
            }
            forEach(host.getSourceFiles(), checkSourceFileWithEagerDiagnostics);
            return diagnostics.getDiagnostics();
        }
        function getGlobalDiagnostics() {
            ensurePendingDiagnosticWorkComplete();
            return diagnostics.getGlobalDiagnostics();
        }
        function getSymbolsInScope(location, meaning) {
            if (location.flags & 33554432 /* InWithStatement */ ) return [];
            const symbols = createSymbolTable();
            let isStaticSymbol = false;
            populateSymbols();
            symbols.delete("this" /* This */ );
            return symbolsToArray(symbols);
            function populateSymbols() {
                while(location){
                    if (canHaveLocals(location) && location.locals && !isGlobalSourceFile(location)) copySymbols(location.locals, meaning);
                    switch(location.kind){
                        case 311 /* SourceFile */ :
                            if (!isExternalModule(location)) break;
                        case 266 /* ModuleDeclaration */ :
                            copyLocallyVisibleExportSymbols(getSymbolOfDeclaration(location).exports, meaning & 2623475 /* ModuleMember */ );
                            break;
                        case 265 /* EnumDeclaration */ :
                            copySymbols(getSymbolOfDeclaration(location).exports, meaning & 8 /* EnumMember */ );
                            break;
                        case 230 /* ClassExpression */ :
                            const className = location.name;
                            if (className) copySymbol(location.symbol, meaning);
                        case 262 /* ClassDeclaration */ :
                        case 263 /* InterfaceDeclaration */ :
                            if (!isStaticSymbol) copySymbols(getMembersOfSymbol(getSymbolOfDeclaration(location)), meaning & 788968 /* Type */ );
                            break;
                        case 217 /* FunctionExpression */ :
                            const funcName = location.name;
                            if (funcName) copySymbol(location.symbol, meaning);
                            break;
                    }
                    if (introducesArgumentsExoticObject(location)) copySymbol(argumentsSymbol, meaning);
                    isStaticSymbol = isStatic(location);
                    location = location.parent;
                }
                copySymbols(globals, meaning);
            }
            function copySymbol(symbol, meaning2) {
                if (getCombinedLocalAndExportSymbolFlags(symbol) & meaning2) {
                    const id = symbol.escapedName;
                    if (!symbols.has(id)) symbols.set(id, symbol);
                }
            }
            function copySymbols(source, meaning2) {
                if (meaning2) source.forEach((symbol)=>{
                    copySymbol(symbol, meaning2);
                });
            }
            function copyLocallyVisibleExportSymbols(source, meaning2) {
                if (meaning2) source.forEach((symbol)=>{
                    if (!getDeclarationOfKind(symbol, 280 /* ExportSpecifier */ ) && !getDeclarationOfKind(symbol, 279 /* NamespaceExport */ )) copySymbol(symbol, meaning2);
                });
            }
        }
        function isTypeDeclarationName(name) {
            return name.kind === 80 /* Identifier */  && isTypeDeclaration(name.parent) && getNameOfDeclaration(name.parent) === name;
        }
        function isTypeReferenceIdentifier(node) {
            while(node.parent.kind === 165 /* QualifiedName */ )node = node.parent;
            return node.parent.kind === 182 /* TypeReference */ ;
        }
        function isInNameOfExpressionWithTypeArguments(node) {
            while(node.parent.kind === 210 /* PropertyAccessExpression */ )node = node.parent;
            return node.parent.kind === 232 /* ExpressionWithTypeArguments */ ;
        }
        function forEachEnclosingClass(node, callback) {
            let result;
            let containingClass = getContainingClass(node);
            while(containingClass){
                if (result = callback(containingClass)) break;
                containingClass = getContainingClass(containingClass);
            }
            return result;
        }
        function isNodeUsedDuringClassInitialization(node) {
            return !!findAncestor(node, (element)=>{
                if (isConstructorDeclaration(element) && nodeIsPresent(element.body) || isPropertyDeclaration(element)) return true;
                else if (isClassLike(element) || isFunctionLikeDeclaration(element)) return "quit";
                return false;
            });
        }
        function isNodeWithinClass(node, classDeclaration) {
            return !!forEachEnclosingClass(node, (n)=>n === classDeclaration);
        }
        function getLeftSideOfImportEqualsOrExportAssignment(nodeOnRightSide) {
            while(nodeOnRightSide.parent.kind === 165 /* QualifiedName */ )nodeOnRightSide = nodeOnRightSide.parent;
            if (nodeOnRightSide.parent.kind === 270 /* ImportEqualsDeclaration */ ) return nodeOnRightSide.parent.moduleReference === nodeOnRightSide ? nodeOnRightSide.parent : void 0;
            if (nodeOnRightSide.parent.kind === 276 /* ExportAssignment */ ) return nodeOnRightSide.parent.expression === nodeOnRightSide ? nodeOnRightSide.parent : void 0;
            return void 0;
        }
        function isInRightSideOfImportOrExportAssignment(node) {
            return getLeftSideOfImportEqualsOrExportAssignment(node) !== void 0;
        }
        function getSpecialPropertyAssignmentSymbolFromEntityName(entityName) {
            const specialPropertyAssignmentKind = getAssignmentDeclarationKind(entityName.parent.parent);
            switch(specialPropertyAssignmentKind){
                case 1 /* ExportsProperty */ :
                case 3 /* PrototypeProperty */ :
                    return getSymbolOfNode(entityName.parent);
                case 4 /* ThisProperty */ :
                case 2 /* ModuleExports */ :
                case 5 /* Property */ :
                    return getSymbolOfDeclaration(entityName.parent.parent);
            }
        }
        function isImportTypeQualifierPart(node) {
            let parent2 = node.parent;
            while(isQualifiedName(parent2)){
                node = parent2;
                parent2 = parent2.parent;
            }
            if (parent2 && parent2.kind === 204 /* ImportType */  && parent2.qualifier === node) return parent2;
            return void 0;
        }
        function isThisPropertyAndThisTyped(node) {
            if (node.expression.kind === 110 /* ThisKeyword */ ) {
                const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                if (isFunctionLike(container)) {
                    const containingLiteral = getContainingObjectLiteral(container);
                    if (containingLiteral) {
                        const contextualType = getApparentTypeOfContextualType(containingLiteral, /*contextFlags*/ void 0);
                        const type = contextualType && getThisTypeFromContextualType(contextualType);
                        return type && !isTypeAny(type);
                    }
                }
            }
        }
        function getSymbolOfNameOrPropertyAccessExpression(name) {
            if (isDeclarationName(name)) return getSymbolOfNode(name.parent);
            if (isInJSFile(name) && name.parent.kind === 210 /* PropertyAccessExpression */  && name.parent === name.parent.parent.left) {
                if (!isPrivateIdentifier(name) && !isJSDocMemberName(name) && !isThisPropertyAndThisTyped(name.parent)) {
                    const specialPropertyAssignmentSymbol = getSpecialPropertyAssignmentSymbolFromEntityName(name);
                    if (specialPropertyAssignmentSymbol) return specialPropertyAssignmentSymbol;
                }
            }
            if (name.parent.kind === 276 /* ExportAssignment */  && isEntityNameExpression(name)) {
                const success = resolveEntityName(name, /*all meanings*/ 2998271 /* Alias */ , /*ignoreErrors*/ true);
                if (success && success !== unknownSymbol) return success;
            } else if (isEntityName(name) && isInRightSideOfImportOrExportAssignment(name)) {
                const importEqualsDeclaration = getAncestor(name, 270 /* ImportEqualsDeclaration */ );
                Debug.assert(importEqualsDeclaration !== void 0);
                return getSymbolOfPartOfRightHandSideOfImportEquals(name, /*dontResolveAlias*/ true);
            }
            if (isEntityName(name)) {
                const possibleImportNode = isImportTypeQualifierPart(name);
                if (possibleImportNode) {
                    getTypeFromTypeNode(possibleImportNode);
                    const sym = getNodeLinks(name).resolvedSymbol;
                    return sym === unknownSymbol ? void 0 : sym;
                }
            }
            while(isRightSideOfQualifiedNameOrPropertyAccessOrJSDocMemberName(name))name = name.parent;
            if (isInNameOfExpressionWithTypeArguments(name)) {
                let meaning = 0 /* None */ ;
                if (name.parent.kind === 232 /* ExpressionWithTypeArguments */ ) {
                    meaning = isPartOfTypeNode(name) ? 788968 /* Type */  : 111551 /* Value */ ;
                    if (isExpressionWithTypeArgumentsInClassExtendsClause(name.parent)) meaning |= 111551 /* Value */ ;
                } else meaning = 1920 /* Namespace */ ;
                meaning |= 2097152 /* Alias */ ;
                const entityNameSymbol = isEntityNameExpression(name) ? resolveEntityName(name, meaning, /*ignoreErrors*/ true) : void 0;
                if (entityNameSymbol) return entityNameSymbol;
            }
            if (name.parent.kind === 347 /* JSDocParameterTag */ ) return getParameterSymbolFromJSDoc(name.parent);
            if (name.parent.kind === 167 /* TypeParameter */  && name.parent.parent.kind === 351 /* JSDocTemplateTag */ ) {
                Debug.assert(!isInJSFile(name));
                const typeParameter = getTypeParameterFromJsDoc(name.parent);
                return typeParameter && typeParameter.symbol;
            }
            if (isExpressionNode(name)) {
                if (nodeIsMissing(name)) return void 0;
                const isJSDoc2 = findAncestor(name, or(isJSDocLinkLike, isJSDocNameReference, isJSDocMemberName));
                const meaning = isJSDoc2 ? 901119 /* Value */  : 111551 /* Value */ ;
                if (name.kind === 80 /* Identifier */ ) {
                    if (isJSXTagName(name) && isJsxIntrinsicTagName(name)) {
                        const symbol = getIntrinsicTagSymbol(name.parent);
                        return symbol === unknownSymbol ? void 0 : symbol;
                    }
                    const result = resolveEntityName(name, meaning, /*ignoreErrors*/ true, /*dontResolveAlias*/ true, getHostSignatureFromJSDoc(name));
                    if (!result && isJSDoc2) {
                        const container = findAncestor(name, or(isClassLike, isInterfaceDeclaration));
                        if (container) return resolveJSDocMemberName(name, /*ignoreErrors*/ true, getSymbolOfDeclaration(container));
                    }
                    if (result && isJSDoc2) {
                        const container = getJSDocHost(name);
                        if (container && isEnumMember(container) && container === result.valueDeclaration) return resolveEntityName(name, meaning, /*ignoreErrors*/ true, /*dontResolveAlias*/ true, getSourceFileOfNode(container)) || result;
                    }
                    return result;
                } else if (isPrivateIdentifier(name)) return getSymbolForPrivateIdentifierExpression(name);
                else if (name.kind === 210 /* PropertyAccessExpression */  || name.kind === 165 /* QualifiedName */ ) {
                    const links = getNodeLinks(name);
                    if (links.resolvedSymbol) return links.resolvedSymbol;
                    if (name.kind === 210 /* PropertyAccessExpression */ ) {
                        checkPropertyAccessExpression(name, 0 /* Normal */ );
                        if (!links.resolvedSymbol) {
                            const expressionType = checkExpressionCached(name.expression);
                            const infos = getApplicableIndexInfos(expressionType, getLiteralTypeFromPropertyName(name.name));
                            if (infos.length && expressionType.members) {
                                const resolved = resolveStructuredTypeMembers(expressionType);
                                const symbol = resolved.members.get("__index" /* Index */ );
                                if (infos === getIndexInfosOfType(expressionType)) links.resolvedSymbol = symbol;
                                else if (symbol) {
                                    const symbolLinks2 = getSymbolLinks(symbol);
                                    const declarationList = mapDefined(infos, (i)=>i.declaration);
                                    const nodeListId = map(declarationList, getNodeId).join(",");
                                    if (!symbolLinks2.filteredIndexSymbolCache) symbolLinks2.filteredIndexSymbolCache = /* @__PURE__ */ new Map();
                                    if (symbolLinks2.filteredIndexSymbolCache.has(nodeListId)) links.resolvedSymbol = symbolLinks2.filteredIndexSymbolCache.get(nodeListId);
                                    else {
                                        const copy = createSymbol(131072 /* Signature */ , "__index" /* Index */ );
                                        copy.declarations = mapDefined(infos, (i)=>i.declaration);
                                        copy.parent = expressionType.aliasSymbol ? expressionType.aliasSymbol : expressionType.symbol ? expressionType.symbol : getSymbolAtLocation(copy.declarations[0].parent);
                                        symbolLinks2.filteredIndexSymbolCache.set(nodeListId, copy);
                                        links.resolvedSymbol = symbolLinks2.filteredIndexSymbolCache.get(nodeListId);
                                    }
                                }
                            }
                        }
                    } else checkQualifiedName(name, 0 /* Normal */ );
                    if (!links.resolvedSymbol && isJSDoc2 && isQualifiedName(name)) return resolveJSDocMemberName(name);
                    return links.resolvedSymbol;
                } else if (isJSDocMemberName(name)) return resolveJSDocMemberName(name);
            } else if (isTypeReferenceIdentifier(name)) {
                const meaning = name.parent.kind === 182 /* TypeReference */  ? 788968 /* Type */  : 1920 /* Namespace */ ;
                const symbol = resolveEntityName(name, meaning, /*ignoreErrors*/ false, /*dontResolveAlias*/ true);
                return symbol && symbol !== unknownSymbol ? symbol : getUnresolvedSymbolForEntityName(name);
            }
            if (name.parent.kind === 181 /* TypePredicate */ ) return resolveEntityName(name, /*meaning*/ 1 /* FunctionScopedVariable */ );
            return void 0;
        }
        function resolveJSDocMemberName(name, ignoreErrors, container) {
            if (isEntityName(name)) {
                const meaning = 901119 /* Value */ ;
                let symbol = resolveEntityName(name, meaning, ignoreErrors, /*dontResolveAlias*/ true, getHostSignatureFromJSDoc(name));
                if (!symbol && isIdentifier(name) && container) symbol = getMergedSymbol(getSymbol2(getExportsOfSymbol(container), name.escapedText, meaning));
                if (symbol) return symbol;
            }
            const left = isIdentifier(name) ? container : resolveJSDocMemberName(name.left, ignoreErrors, container);
            const right = isIdentifier(name) ? name.escapedText : name.right.escapedText;
            if (left) {
                const proto = left.flags & 111551 /* Value */  && getPropertyOfType(getTypeOfSymbol(left), "prototype");
                const t = proto ? getTypeOfSymbol(proto) : getDeclaredTypeOfSymbol(left);
                return getPropertyOfType(t, right);
            }
        }
        function getSymbolAtLocation(node, ignoreErrors) {
            if (isSourceFile(node)) return isExternalModule(node) ? getMergedSymbol(node.symbol) : void 0;
            const { parent: parent2  } = node;
            const grandParent = parent2.parent;
            if (node.flags & 33554432 /* InWithStatement */ ) return void 0;
            if (isDeclarationNameOrImportPropertyName(node)) {
                const parentSymbol = getSymbolOfDeclaration(parent2);
                return isImportOrExportSpecifier(node.parent) && node.parent.propertyName === node ? getImmediateAliasedSymbol(parentSymbol) : parentSymbol;
            } else if (isLiteralComputedPropertyDeclarationName(node)) return getSymbolOfDeclaration(parent2.parent);
            if (node.kind === 80 /* Identifier */ ) {
                if (isInRightSideOfImportOrExportAssignment(node)) return getSymbolOfNameOrPropertyAccessExpression(node);
                else if (parent2.kind === 207 /* BindingElement */  && grandParent.kind === 205 /* ObjectBindingPattern */  && node === parent2.propertyName) {
                    const typeOfPattern = getTypeOfNode(grandParent);
                    const propertyDeclaration = getPropertyOfType(typeOfPattern, node.escapedText);
                    if (propertyDeclaration) return propertyDeclaration;
                } else if (isMetaProperty(parent2) && parent2.name === node) {
                    if (parent2.keywordToken === 105 /* NewKeyword */  && idText(node) === "target") return checkNewTargetMetaProperty(parent2).symbol;
                    if (parent2.keywordToken === 102 /* ImportKeyword */  && idText(node) === "meta") return getGlobalImportMetaExpressionType().members.get("meta");
                    return void 0;
                }
            }
            switch(node.kind){
                case 80 /* Identifier */ :
                case 81 /* PrivateIdentifier */ :
                case 210 /* PropertyAccessExpression */ :
                case 165 /* QualifiedName */ :
                    if (!isThisInTypeQuery(node)) return getSymbolOfNameOrPropertyAccessExpression(node);
                case 110 /* ThisKeyword */ :
                    const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                    if (isFunctionLike(container)) {
                        const sig = getSignatureFromDeclaration(container);
                        if (sig.thisParameter) return sig.thisParameter;
                    }
                    if (isInExpressionContext(node)) return checkExpression(node).symbol;
                case 196 /* ThisType */ :
                    return getTypeFromThisTypeNode(node).symbol;
                case 108 /* SuperKeyword */ :
                    return checkExpression(node).symbol;
                case 137 /* ConstructorKeyword */ :
                    const constructorDeclaration = node.parent;
                    if (constructorDeclaration && constructorDeclaration.kind === 175 /* Constructor */ ) return constructorDeclaration.parent.symbol;
                    return void 0;
                case 11 /* StringLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    if (isExternalModuleImportEqualsDeclaration(node.parent.parent) && getExternalModuleImportEqualsDeclarationExpression(node.parent.parent) === node || (node.parent.kind === 271 /* ImportDeclaration */  || node.parent.kind === 277 /* ExportDeclaration */ ) && node.parent.moduleSpecifier === node || isInJSFile(node) && getEmitModuleResolutionKind(compilerOptions) !== 100 /* Bundler */  && isRequireCall(node.parent, /*requireStringLiteralLikeArgument*/ false) || isImportCall(node.parent) || isLiteralTypeNode(node.parent) && isLiteralImportTypeNode(node.parent.parent) && node.parent.parent.argument === node.parent) return resolveExternalModuleName(node, node, ignoreErrors);
                    if (isCallExpression(parent2) && isBindableObjectDefinePropertyCall(parent2) && parent2.arguments[1] === node) return getSymbolOfDeclaration(parent2);
                case 9 /* NumericLiteral */ :
                    const objectType = isElementAccessExpression(parent2) ? parent2.argumentExpression === node ? getTypeOfExpression(parent2.expression) : void 0 : isLiteralTypeNode(parent2) && isIndexedAccessTypeNode(grandParent) ? getTypeFromTypeNode(grandParent.objectType) : void 0;
                    return objectType && getPropertyOfType(objectType, escapeLeadingUnderscores(node.text));
                case 90 /* DefaultKeyword */ :
                case 100 /* FunctionKeyword */ :
                case 39 /* EqualsGreaterThanToken */ :
                case 86 /* ClassKeyword */ :
                    return getSymbolOfNode(node.parent);
                case 204 /* ImportType */ :
                    return isLiteralImportTypeNode(node) ? getSymbolAtLocation(node.argument.literal, ignoreErrors) : void 0;
                case 95 /* ExportKeyword */ :
                    return isExportAssignment(node.parent) ? Debug.checkDefined(node.parent.symbol) : void 0;
                case 102 /* ImportKeyword */ :
                case 105 /* NewKeyword */ :
                    return isMetaProperty(node.parent) ? checkMetaPropertyKeyword(node.parent).symbol : void 0;
                case 235 /* MetaProperty */ :
                    return checkExpression(node).symbol;
                case 294 /* JsxNamespacedName */ :
                    if (isJSXTagName(node) && isJsxIntrinsicTagName(node)) {
                        const symbol = getIntrinsicTagSymbol(node.parent);
                        return symbol === unknownSymbol ? void 0 : symbol;
                    }
                default:
                    return void 0;
            }
        }
        function getIndexInfosAtLocation(node) {
            if (isIdentifier(node) && isPropertyAccessExpression(node.parent) && node.parent.name === node) {
                const keyType = getLiteralTypeFromPropertyName(node);
                const objectType = getTypeOfExpression(node.parent.expression);
                const objectTypes = objectType.flags & 1048576 /* Union */  ? objectType.types : [
                    objectType
                ];
                return flatMap(objectTypes, (t)=>filter(getIndexInfosOfType(t), (info)=>isApplicableIndexType(keyType, info.keyType)));
            }
            return void 0;
        }
        function getShorthandAssignmentValueSymbol(location) {
            if (location && location.kind === 303 /* ShorthandPropertyAssignment */ ) return resolveEntityName(location.name, 2208703 /* Alias */ );
            return void 0;
        }
        function getExportSpecifierLocalTargetSymbol(node) {
            if (isExportSpecifier(node)) return node.parent.parent.moduleSpecifier ? getExternalModuleMember(node.parent.parent, node) : resolveEntityName(node.propertyName || node.name, 2998271 /* Alias */ );
            else return resolveEntityName(node, 2998271 /* Alias */ );
        }
        function getTypeOfNode(node) {
            if (isSourceFile(node) && !isExternalModule(node)) return errorType;
            if (node.flags & 33554432 /* InWithStatement */ ) return errorType;
            const classDecl = tryGetClassImplementingOrExtendingExpressionWithTypeArguments(node);
            const classType = classDecl && getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(classDecl.class));
            if (isPartOfTypeNode(node)) {
                const typeFromTypeNode = getTypeFromTypeNode(node);
                return classType ? getTypeWithThisArgument(typeFromTypeNode, classType.thisType) : typeFromTypeNode;
            }
            if (isExpressionNode(node)) return getRegularTypeOfExpression(node);
            if (classType && !classDecl.isImplements) {
                const baseType = firstOrUndefined(getBaseTypes(classType));
                return baseType ? getTypeWithThisArgument(baseType, classType.thisType) : errorType;
            }
            if (isTypeDeclaration(node)) {
                const symbol = getSymbolOfDeclaration(node);
                return getDeclaredTypeOfSymbol(symbol);
            }
            if (isTypeDeclarationName(node)) {
                const symbol = getSymbolAtLocation(node);
                return symbol ? getDeclaredTypeOfSymbol(symbol) : errorType;
            }
            if (isBindingElement(node)) return getTypeForVariableLikeDeclaration(node, /*includeOptionality*/ true, 0 /* Normal */ ) || errorType;
            if (isDeclaration(node)) {
                const symbol = getSymbolOfDeclaration(node);
                return symbol ? getTypeOfSymbol(symbol) : errorType;
            }
            if (isDeclarationNameOrImportPropertyName(node)) {
                const symbol = getSymbolAtLocation(node);
                if (symbol) return getTypeOfSymbol(symbol);
                return errorType;
            }
            if (isBindingPattern(node)) return getTypeForVariableLikeDeclaration(node.parent, /*includeOptionality*/ true, 0 /* Normal */ ) || errorType;
            if (isInRightSideOfImportOrExportAssignment(node)) {
                const symbol = getSymbolAtLocation(node);
                if (symbol) {
                    const declaredType = getDeclaredTypeOfSymbol(symbol);
                    return !isErrorType(declaredType) ? declaredType : getTypeOfSymbol(symbol);
                }
            }
            if (isMetaProperty(node.parent) && node.parent.keywordToken === node.kind) return checkMetaPropertyKeyword(node.parent);
            return errorType;
        }
        function getTypeOfAssignmentPattern(expr) {
            Debug.assert(expr.kind === 209 /* ObjectLiteralExpression */  || expr.kind === 208 /* ArrayLiteralExpression */ );
            if (expr.parent.kind === 249 /* ForOfStatement */ ) {
                const iteratedType = checkRightHandSideOfForOf(expr.parent);
                return checkDestructuringAssignment(expr, iteratedType || errorType);
            }
            if (expr.parent.kind === 225 /* BinaryExpression */ ) {
                const iteratedType = getTypeOfExpression(expr.parent.right);
                return checkDestructuringAssignment(expr, iteratedType || errorType);
            }
            if (expr.parent.kind === 302 /* PropertyAssignment */ ) {
                const node2 = cast(expr.parent.parent, isObjectLiteralExpression);
                const typeOfParentObjectLiteral = getTypeOfAssignmentPattern(node2) || errorType;
                const propertyIndex = indexOfNode(node2.properties, expr.parent);
                return checkObjectLiteralDestructuringPropertyAssignment(node2, typeOfParentObjectLiteral, propertyIndex);
            }
            const node = cast(expr.parent, isArrayLiteralExpression);
            const typeOfArrayLiteral = getTypeOfAssignmentPattern(node) || errorType;
            const elementType = checkIteratedTypeOrElementType(65 /* Destructuring */ , typeOfArrayLiteral, undefinedType, expr.parent) || errorType;
            return checkArrayLiteralDestructuringElementAssignment(node, typeOfArrayLiteral, node.elements.indexOf(expr), elementType);
        }
        function getPropertySymbolOfDestructuringAssignment(location) {
            const typeOfObjectLiteral = getTypeOfAssignmentPattern(cast(location.parent.parent, isAssignmentPattern));
            return typeOfObjectLiteral && getPropertyOfType(typeOfObjectLiteral, location.escapedText);
        }
        function getRegularTypeOfExpression(expr) {
            if (isRightSideOfQualifiedNameOrPropertyAccess(expr)) expr = expr.parent;
            return getRegularTypeOfLiteralType(getTypeOfExpression(expr));
        }
        function getParentTypeOfClassElement(node) {
            const classSymbol = getSymbolOfNode(node.parent);
            return isStatic(node) ? getTypeOfSymbol(classSymbol) : getDeclaredTypeOfSymbol(classSymbol);
        }
        function getClassElementPropertyKeyType(element) {
            const name = element.name;
            switch(name.kind){
                case 80 /* Identifier */ :
                    return getStringLiteralType(idText(name));
                case 9 /* NumericLiteral */ :
                case 11 /* StringLiteral */ :
                    return getStringLiteralType(name.text);
                case 166 /* ComputedPropertyName */ :
                    const nameType = checkComputedPropertyName(name);
                    return isTypeAssignableToKind(nameType, 12288 /* ESSymbolLike */ ) ? nameType : stringType;
                default:
                    return Debug.fail("Unsupported property name.");
            }
        }
        function getAugmentedPropertiesOfType(type) {
            type = getApparentType(type);
            const propsByName = createSymbolTable(getPropertiesOfType(type));
            const functionType = getSignaturesOfType(type, 0 /* Call */ ).length ? globalCallableFunctionType : getSignaturesOfType(type, 1 /* Construct */ ).length ? globalNewableFunctionType : void 0;
            if (functionType) forEach(getPropertiesOfType(functionType), (p)=>{
                if (!propsByName.has(p.escapedName)) propsByName.set(p.escapedName, p);
            });
            return getNamedMembers(propsByName);
        }
        function typeHasCallOrConstructSignatures(type) {
            return getSignaturesOfType(type, 0 /* Call */ ).length !== 0 || getSignaturesOfType(type, 1 /* Construct */ ).length !== 0;
        }
        function getRootSymbols(symbol) {
            const roots = getImmediateRootSymbols(symbol);
            return roots ? flatMap(roots, getRootSymbols) : [
                symbol
            ];
        }
        function getImmediateRootSymbols(symbol) {
            if (getCheckFlags(symbol) & 6 /* Synthetic */ ) return mapDefined(getSymbolLinks(symbol).containingType.types, (type)=>getPropertyOfType(type, symbol.escapedName));
            else if (symbol.flags & 33554432 /* Transient */ ) {
                const { links: { leftSpread: leftSpread , rightSpread: rightSpread , syntheticOrigin: syntheticOrigin  }  } = symbol;
                return leftSpread ? [
                    leftSpread,
                    rightSpread
                ] : syntheticOrigin ? [
                    syntheticOrigin
                ] : singleElementArray(tryGetTarget(symbol));
            }
            return void 0;
        }
        function tryGetTarget(symbol) {
            let target;
            let next = symbol;
            while(next = getSymbolLinks(next).target)target = next;
            return target;
        }
        function isArgumentsLocalBinding(nodeIn) {
            if (isGeneratedIdentifier(nodeIn)) return false;
            const node = getParseTreeNode(nodeIn, isIdentifier);
            if (!node) return false;
            const parent2 = node.parent;
            if (!parent2) return false;
            const isPropertyName2 = (isPropertyAccessExpression(parent2) || isPropertyAssignment(parent2)) && parent2.name === node;
            return !isPropertyName2 && getReferencedValueSymbol(node) === argumentsSymbol;
        }
        function moduleExportsSomeValue(moduleReferenceExpression) {
            let moduleSymbol = resolveExternalModuleName(moduleReferenceExpression.parent, moduleReferenceExpression);
            if (!moduleSymbol || isShorthandAmbientModuleSymbol(moduleSymbol)) return true;
            const hasExportAssignment = hasExportAssignmentSymbol(moduleSymbol);
            moduleSymbol = resolveExternalModuleSymbol(moduleSymbol);
            const symbolLinks2 = getSymbolLinks(moduleSymbol);
            if (symbolLinks2.exportsSomeValue === void 0) symbolLinks2.exportsSomeValue = hasExportAssignment ? !!(moduleSymbol.flags & 111551 /* Value */ ) : forEachEntry(getExportsOfModule(moduleSymbol), isValue);
            return symbolLinks2.exportsSomeValue;
            function isValue(s) {
                s = resolveSymbol(s);
                return s && !!(getAllSymbolFlags(s) & 111551 /* Value */ );
            }
        }
        function isNameOfModuleOrEnumDeclaration(node) {
            return isModuleOrEnumDeclaration(node.parent) && node === node.parent.name;
        }
        function getReferencedExportContainer(nodeIn, prefixLocals) {
            var _a;
            const node = getParseTreeNode(nodeIn, isIdentifier);
            if (node) {
                let symbol = getReferencedValueSymbol(node, /*startInDeclarationContainer*/ isNameOfModuleOrEnumDeclaration(node));
                if (symbol) {
                    if (symbol.flags & 1048576 /* ExportValue */ ) {
                        const exportSymbol = getMergedSymbol(symbol.exportSymbol);
                        if (!prefixLocals && exportSymbol.flags & 944 /* ExportHasLocal */  && !(exportSymbol.flags & 3 /* Variable */ )) return void 0;
                        symbol = exportSymbol;
                    }
                    const parentSymbol = getParentOfSymbol(symbol);
                    if (parentSymbol) {
                        if (parentSymbol.flags & 512 /* ValueModule */  && ((_a = parentSymbol.valueDeclaration) == null ? void 0 : _a.kind) === 311 /* SourceFile */ ) {
                            const symbolFile = parentSymbol.valueDeclaration;
                            const referenceFile = getSourceFileOfNode(node);
                            const symbolIsUmdExport = symbolFile !== referenceFile;
                            return symbolIsUmdExport ? void 0 : symbolFile;
                        }
                        return findAncestor(node.parent, (n)=>isModuleOrEnumDeclaration(n) && getSymbolOfDeclaration(n) === parentSymbol);
                    }
                }
            }
        }
        function getReferencedImportDeclaration(nodeIn) {
            const specifier = getIdentifierGeneratedImportReference(nodeIn);
            if (specifier) return specifier;
            const node = getParseTreeNode(nodeIn, isIdentifier);
            if (node) {
                const symbol = getReferencedValueOrAliasSymbol(node);
                if (isNonLocalAlias(symbol, /*excludes*/ 111551 /* Value */ ) && !getTypeOnlyAliasDeclaration(symbol, 111551 /* Value */ )) return getDeclarationOfAliasSymbol(symbol);
            }
            return void 0;
        }
        function isSymbolOfDestructuredElementOfCatchBinding(symbol) {
            return symbol.valueDeclaration && isBindingElement(symbol.valueDeclaration) && walkUpBindingElementsAndPatterns(symbol.valueDeclaration).parent.kind === 298 /* CatchClause */ ;
        }
        function isSymbolOfDeclarationWithCollidingName(symbol) {
            if (symbol.flags & 418 /* BlockScoped */  && symbol.valueDeclaration && !isSourceFile(symbol.valueDeclaration)) {
                const links = getSymbolLinks(symbol);
                if (links.isDeclarationWithCollidingName === void 0) {
                    const container = getEnclosingBlockScopeContainer(symbol.valueDeclaration);
                    if (isStatementWithLocals(container) || isSymbolOfDestructuredElementOfCatchBinding(symbol)) {
                        const nodeLinks2 = getNodeLinks(symbol.valueDeclaration);
                        if (resolveName(container.parent, symbol.escapedName, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ false)) links.isDeclarationWithCollidingName = true;
                        else if (nodeLinks2.flags & 16384 /* CapturedBlockScopedBinding */ ) {
                            const isDeclaredInLoop = nodeLinks2.flags & 32768 /* BlockScopedBindingInLoop */ ;
                            const inLoopInitializer = isIterationStatement(container, /*lookInLabeledStatements*/ false);
                            const inLoopBodyBlock = container.kind === 240 /* Block */  && isIterationStatement(container.parent, /*lookInLabeledStatements*/ false);
                            links.isDeclarationWithCollidingName = !isBlockScopedContainerTopLevel(container) && (!isDeclaredInLoop || !inLoopInitializer && !inLoopBodyBlock);
                        } else links.isDeclarationWithCollidingName = false;
                    }
                }
                return links.isDeclarationWithCollidingName;
            }
            return false;
        }
        function getReferencedDeclarationWithCollidingName(nodeIn) {
            if (!isGeneratedIdentifier(nodeIn)) {
                const node = getParseTreeNode(nodeIn, isIdentifier);
                if (node) {
                    const symbol = getReferencedValueSymbol(node);
                    if (symbol && isSymbolOfDeclarationWithCollidingName(symbol)) return symbol.valueDeclaration;
                }
            }
            return void 0;
        }
        function isDeclarationWithCollidingName(nodeIn) {
            const node = getParseTreeNode(nodeIn, isDeclaration);
            if (node) {
                const symbol = getSymbolOfDeclaration(node);
                if (symbol) return isSymbolOfDeclarationWithCollidingName(symbol);
            }
            return false;
        }
        function isValueAliasDeclaration(node) {
            Debug.assert(canCollectSymbolAliasAccessabilityData);
            switch(node.kind){
                case 270 /* ImportEqualsDeclaration */ :
                    return isAliasResolvedToValue(getSymbolOfDeclaration(node));
                case 272 /* ImportClause */ :
                case 273 /* NamespaceImport */ :
                case 275 /* ImportSpecifier */ :
                case 280 /* ExportSpecifier */ :
                    const symbol = getSymbolOfDeclaration(node);
                    return !!symbol && isAliasResolvedToValue(symbol) && !getTypeOnlyAliasDeclaration(symbol, 111551 /* Value */ );
                case 277 /* ExportDeclaration */ :
                    const exportClause = node.exportClause;
                    return !!exportClause && (isNamespaceExport(exportClause) || some(exportClause.elements, isValueAliasDeclaration));
                case 276 /* ExportAssignment */ :
                    return node.expression && node.expression.kind === 80 /* Identifier */  ? isAliasResolvedToValue(getSymbolOfDeclaration(node)) : true;
            }
            return false;
        }
        function isTopLevelValueImportEqualsWithEntityName(nodeIn) {
            const node = getParseTreeNode(nodeIn, isImportEqualsDeclaration);
            if (node === void 0 || node.parent.kind !== 311 /* SourceFile */  || !isInternalModuleImportEqualsDeclaration(node)) return false;
            const isValue = isAliasResolvedToValue(getSymbolOfDeclaration(node));
            return isValue && node.moduleReference && !nodeIsMissing(node.moduleReference);
        }
        function isAliasResolvedToValue(symbol) {
            if (!symbol) return false;
            const target = getExportSymbolOfValueSymbolIfExported(resolveAlias(symbol));
            if (target === unknownSymbol) return true;
            return !!((getAllSymbolFlags(target) ?? -1) & 111551 /* Value */ ) && (shouldPreserveConstEnums(compilerOptions) || !isConstEnumOrConstEnumOnlyModule(target));
        }
        function isConstEnumOrConstEnumOnlyModule(s) {
            return isConstEnumSymbol(s) || !!s.constEnumOnlyModule;
        }
        function isReferencedAliasDeclaration(node, checkChildren) {
            Debug.assert(canCollectSymbolAliasAccessabilityData);
            if (isAliasSymbolDeclaration2(node)) {
                const symbol = getSymbolOfDeclaration(node);
                const links = symbol && getSymbolLinks(symbol);
                if (links == null ? void 0 : links.referenced) return true;
                const target = getSymbolLinks(symbol).aliasTarget;
                if (target && getEffectiveModifierFlags(node) & 1 /* Export */  && getAllSymbolFlags(target) & 111551 /* Value */  && (shouldPreserveConstEnums(compilerOptions) || !isConstEnumOrConstEnumOnlyModule(target))) return true;
            }
            if (checkChildren) return !!forEachChild(node, (node2)=>isReferencedAliasDeclaration(node2, checkChildren));
            return false;
        }
        function isImplementationOfOverload(node) {
            if (nodeIsPresent(node.body)) {
                if (isGetAccessor(node) || isSetAccessor(node)) return false;
                const symbol = getSymbolOfDeclaration(node);
                const signaturesOfSymbol = getSignaturesOfSymbol(symbol);
                return signaturesOfSymbol.length > 1 || // If there is single signature for the symbol, it is overload if that signature isn't coming from the node
                // e.g.: function foo(a: string): string;
                //       function foo(a: any) { // This is implementation of the overloads
                //           return a;
                //       }
                signaturesOfSymbol.length === 1 && signaturesOfSymbol[0].declaration !== node;
            }
            return false;
        }
        function isRequiredInitializedParameter(parameter) {
            return !!strictNullChecks && !isOptionalParameter(parameter) && !isJSDocParameterTag(parameter) && !!parameter.initializer && !hasSyntacticModifier(parameter, 16476 /* ParameterPropertyModifier */ );
        }
        function isOptionalUninitializedParameterProperty(parameter) {
            return strictNullChecks && isOptionalParameter(parameter) && !parameter.initializer && hasSyntacticModifier(parameter, 16476 /* ParameterPropertyModifier */ );
        }
        function isExpandoFunctionDeclaration(node) {
            const declaration = getParseTreeNode(node, isFunctionDeclaration);
            if (!declaration) return false;
            const symbol = getSymbolOfDeclaration(declaration);
            if (!symbol || !(symbol.flags & 16 /* Function */ )) return false;
            return !!forEachEntry(getExportsOfSymbol(symbol), (p)=>p.flags & 111551 /* Value */  && p.valueDeclaration && isPropertyAccessExpression(p.valueDeclaration));
        }
        function getPropertiesOfContainerFunction(node) {
            const declaration = getParseTreeNode(node, isFunctionDeclaration);
            if (!declaration) return emptyArray;
            const symbol = getSymbolOfDeclaration(declaration);
            return symbol && getPropertiesOfType(getTypeOfSymbol(symbol)) || emptyArray;
        }
        function getNodeCheckFlags(node) {
            var _a;
            const nodeId = node.id || 0;
            if (nodeId < 0 || nodeId >= nodeLinks.length) return 0;
            return ((_a = nodeLinks[nodeId]) == null ? void 0 : _a.flags) || 0;
        }
        function getEnumMemberValue(node) {
            computeEnumMemberValues(node.parent);
            return getNodeLinks(node).enumMemberValue;
        }
        function canHaveConstantValue(node) {
            switch(node.kind){
                case 305 /* EnumMember */ :
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    return true;
            }
            return false;
        }
        function getConstantValue2(node) {
            if (node.kind === 305 /* EnumMember */ ) return getEnumMemberValue(node);
            const symbol = getNodeLinks(node).resolvedSymbol;
            if (symbol && symbol.flags & 8 /* EnumMember */ ) {
                const member = symbol.valueDeclaration;
                if (isEnumConst(member.parent)) return getEnumMemberValue(member);
            }
            return void 0;
        }
        function isFunctionType(type) {
            return !!(type.flags & 524288 /* Object */ ) && getSignaturesOfType(type, 0 /* Call */ ).length > 0;
        }
        function getTypeReferenceSerializationKind(typeNameIn, location) {
            var _a;
            const typeName = getParseTreeNode(typeNameIn, isEntityName);
            if (!typeName) return 0 /* Unknown */ ;
            if (location) {
                location = getParseTreeNode(location);
                if (!location) return 0 /* Unknown */ ;
            }
            let isTypeOnly = false;
            if (isQualifiedName(typeName)) {
                const rootValueSymbol = resolveEntityName(getFirstIdentifier(typeName), 111551 /* Value */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true, location);
                isTypeOnly = !!((_a = rootValueSymbol == null ? void 0 : rootValueSymbol.declarations) == null ? void 0 : _a.every(isTypeOnlyImportOrExportDeclaration));
            }
            const valueSymbol = resolveEntityName(typeName, 111551 /* Value */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true, location);
            const resolvedSymbol = valueSymbol && valueSymbol.flags & 2097152 /* Alias */  ? resolveAlias(valueSymbol) : valueSymbol;
            isTypeOnly || (isTypeOnly = !!(valueSymbol && getTypeOnlyAliasDeclaration(valueSymbol, 111551 /* Value */ )));
            const typeSymbol = resolveEntityName(typeName, 788968 /* Type */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ false, location);
            if (resolvedSymbol && resolvedSymbol === typeSymbol) {
                const globalPromiseSymbol = getGlobalPromiseConstructorSymbol(/*reportErrors*/ false);
                if (globalPromiseSymbol && resolvedSymbol === globalPromiseSymbol) return 9 /* Promise */ ;
                const constructorType = getTypeOfSymbol(resolvedSymbol);
                if (constructorType && isConstructorType(constructorType)) return isTypeOnly ? 10 /* TypeWithCallSignature */  : 1 /* TypeWithConstructSignatureAndValue */ ;
            }
            if (!typeSymbol) return isTypeOnly ? 11 /* ObjectType */  : 0 /* Unknown */ ;
            const type = getDeclaredTypeOfSymbol(typeSymbol);
            if (isErrorType(type)) return isTypeOnly ? 11 /* ObjectType */  : 0 /* Unknown */ ;
            else if (type.flags & 3 /* AnyOrUnknown */ ) return 11 /* ObjectType */ ;
            else if (isTypeAssignableToKind(type, 245760 /* Never */ )) return 2 /* VoidNullableOrNeverType */ ;
            else if (isTypeAssignableToKind(type, 528 /* BooleanLike */ )) return 6 /* BooleanType */ ;
            else if (isTypeAssignableToKind(type, 296 /* NumberLike */ )) return 3 /* NumberLikeType */ ;
            else if (isTypeAssignableToKind(type, 2112 /* BigIntLike */ )) return 4 /* BigIntLikeType */ ;
            else if (isTypeAssignableToKind(type, 402653316 /* StringLike */ )) return 5 /* StringLikeType */ ;
            else if (isTupleType(type)) return 7 /* ArrayLikeType */ ;
            else if (isTypeAssignableToKind(type, 12288 /* ESSymbolLike */ )) return 8 /* ESSymbolType */ ;
            else if (isFunctionType(type)) return 10 /* TypeWithCallSignature */ ;
            else if (isArrayType(type)) return 7 /* ArrayLikeType */ ;
            else return 11 /* ObjectType */ ;
        }
        function createTypeOfDeclaration(declarationIn, enclosingDeclaration, flags, tracker, addUndefined) {
            const declaration = getParseTreeNode(declarationIn, isVariableLikeOrAccessor);
            if (!declaration) return factory.createToken(133 /* AnyKeyword */ );
            const symbol = getSymbolOfDeclaration(declaration);
            let type = symbol && !(symbol.flags & 133120 /* Signature */ ) ? getWidenedLiteralType(getTypeOfSymbol(symbol)) : errorType;
            if (type.flags & 8192 /* UniqueESSymbol */  && type.symbol === symbol) flags |= 1048576 /* AllowUniqueESSymbolType */ ;
            if (addUndefined) type = getOptionalType(type);
            return nodeBuilder.typeToTypeNode(type, enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */ , tracker);
        }
        function createReturnTypeOfSignatureDeclaration(signatureDeclarationIn, enclosingDeclaration, flags, tracker) {
            const signatureDeclaration = getParseTreeNode(signatureDeclarationIn, isFunctionLike);
            if (!signatureDeclaration) return factory.createToken(133 /* AnyKeyword */ );
            const signature = getSignatureFromDeclaration(signatureDeclaration);
            return nodeBuilder.typeToTypeNode(getReturnTypeOfSignature(signature), enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */ , tracker);
        }
        function createTypeOfExpression(exprIn, enclosingDeclaration, flags, tracker) {
            const expr = getParseTreeNode(exprIn, isExpression);
            if (!expr) return factory.createToken(133 /* AnyKeyword */ );
            const type = getWidenedType(getRegularTypeOfExpression(expr));
            return nodeBuilder.typeToTypeNode(type, enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */ , tracker);
        }
        function hasGlobalName(name) {
            return globals.has(escapeLeadingUnderscores(name));
        }
        function getReferencedValueSymbol(reference, startInDeclarationContainer) {
            const resolvedSymbol = getNodeLinks(reference).resolvedSymbol;
            if (resolvedSymbol) return resolvedSymbol;
            let location = reference;
            if (startInDeclarationContainer) {
                const parent2 = reference.parent;
                if (isDeclaration(parent2) && reference === parent2.name) location = getDeclarationContainer(parent2);
            }
            return resolveName(location, reference.escapedText, 3257279 /* Alias */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ true);
        }
        function getReferencedValueOrAliasSymbol(reference) {
            const resolvedSymbol = getNodeLinks(reference).resolvedSymbol;
            if (resolvedSymbol && resolvedSymbol !== unknownSymbol) return resolvedSymbol;
            return resolveName(reference, reference.escapedText, 3257279 /* Alias */ , /*nameNotFoundMessage*/ void 0, /*nameArg*/ void 0, /*isUse*/ true, /*excludeGlobals*/ void 0, /*getSpellingSuggestions*/ void 0);
        }
        function getReferencedValueDeclaration(referenceIn) {
            if (!isGeneratedIdentifier(referenceIn)) {
                const reference = getParseTreeNode(referenceIn, isIdentifier);
                if (reference) {
                    const symbol = getReferencedValueSymbol(reference);
                    if (symbol) return getExportSymbolOfValueSymbolIfExported(symbol).valueDeclaration;
                }
            }
            return void 0;
        }
        function getReferencedValueDeclarations(referenceIn) {
            if (!isGeneratedIdentifier(referenceIn)) {
                const reference = getParseTreeNode(referenceIn, isIdentifier);
                if (reference) {
                    const symbol = getReferencedValueSymbol(reference);
                    if (symbol) return filter(getExportSymbolOfValueSymbolIfExported(symbol).declarations, (declaration)=>{
                        switch(declaration.kind){
                            case 259 /* VariableDeclaration */ :
                            case 168 /* Parameter */ :
                            case 207 /* BindingElement */ :
                            case 171 /* PropertyDeclaration */ :
                            case 302 /* PropertyAssignment */ :
                            case 303 /* ShorthandPropertyAssignment */ :
                            case 305 /* EnumMember */ :
                            case 209 /* ObjectLiteralExpression */ :
                            case 261 /* FunctionDeclaration */ :
                            case 217 /* FunctionExpression */ :
                            case 218 /* ArrowFunction */ :
                            case 262 /* ClassDeclaration */ :
                            case 230 /* ClassExpression */ :
                            case 265 /* EnumDeclaration */ :
                            case 173 /* MethodDeclaration */ :
                            case 176 /* GetAccessor */ :
                            case 177 /* SetAccessor */ :
                            case 266 /* ModuleDeclaration */ :
                                return true;
                        }
                        return false;
                    });
                }
            }
            return void 0;
        }
        function isLiteralConstDeclaration(node) {
            if (isDeclarationReadonly(node) || isVariableDeclaration(node) && isVarConst(node)) return isFreshLiteralType(getTypeOfSymbol(getSymbolOfDeclaration(node)));
            return false;
        }
        function literalTypeToNode(type, enclosing, tracker) {
            const enumResult = type.flags & 1056 /* EnumLike */  ? nodeBuilder.symbolToExpression(type.symbol, 111551 /* Value */ , enclosing, /*flags*/ void 0, tracker) : type === trueType ? factory.createTrue() : type === falseType && factory.createFalse();
            if (enumResult) return enumResult;
            const literalValue = type.value;
            return typeof literalValue === "object" ? factory.createBigIntLiteral(literalValue) : typeof literalValue === "number" ? factory.createNumericLiteral(literalValue) : factory.createStringLiteral(literalValue);
        }
        function createLiteralConstValue(node, tracker) {
            const type = getTypeOfSymbol(getSymbolOfDeclaration(node));
            return literalTypeToNode(type, node, tracker);
        }
        function getJsxFactoryEntity(location) {
            return location ? (getJsxNamespace(location), getSourceFileOfNode(location).localJsxFactory || _jsxFactoryEntity) : _jsxFactoryEntity;
        }
        function getJsxFragmentFactoryEntity(location) {
            if (location) {
                const file = getSourceFileOfNode(location);
                if (file) {
                    if (file.localJsxFragmentFactory) return file.localJsxFragmentFactory;
                    const jsxFragPragmas = file.pragmas.get("jsxfrag");
                    const jsxFragPragma = isArray(jsxFragPragmas) ? jsxFragPragmas[0] : jsxFragPragmas;
                    if (jsxFragPragma) {
                        file.localJsxFragmentFactory = parseIsolatedEntityName(jsxFragPragma.arguments.factory, languageVersion);
                        return file.localJsxFragmentFactory;
                    }
                }
            }
            if (compilerOptions.jsxFragmentFactory) return parseIsolatedEntityName(compilerOptions.jsxFragmentFactory, languageVersion);
        }
        function createResolver() {
            const resolvedTypeReferenceDirectives = host.getResolvedTypeReferenceDirectives();
            let fileToDirective;
            if (resolvedTypeReferenceDirectives) {
                fileToDirective = /* @__PURE__ */ new Map();
                resolvedTypeReferenceDirectives.forEach(({ resolvedTypeReferenceDirective: resolvedTypeReferenceDirective  }, key, mode)=>{
                    if (!(resolvedTypeReferenceDirective == null ? void 0 : resolvedTypeReferenceDirective.resolvedFileName)) return;
                    const file = host.getSourceFile(resolvedTypeReferenceDirective.resolvedFileName);
                    if (file) addReferencedFilesToTypeDirective(file, key, mode);
                });
            }
            return {
                getReferencedExportContainer: getReferencedExportContainer,
                getReferencedImportDeclaration: getReferencedImportDeclaration,
                getReferencedDeclarationWithCollidingName: getReferencedDeclarationWithCollidingName,
                isDeclarationWithCollidingName: isDeclarationWithCollidingName,
                isValueAliasDeclaration: (nodeIn)=>{
                    const node = getParseTreeNode(nodeIn);
                    return node && canCollectSymbolAliasAccessabilityData ? isValueAliasDeclaration(node) : true;
                },
                hasGlobalName: hasGlobalName,
                isReferencedAliasDeclaration: (nodeIn, checkChildren)=>{
                    const node = getParseTreeNode(nodeIn);
                    return node && canCollectSymbolAliasAccessabilityData ? isReferencedAliasDeclaration(node, checkChildren) : true;
                },
                getNodeCheckFlags: (nodeIn)=>{
                    const node = getParseTreeNode(nodeIn);
                    return node ? getNodeCheckFlags(node) : 0;
                },
                isTopLevelValueImportEqualsWithEntityName: isTopLevelValueImportEqualsWithEntityName,
                isDeclarationVisible: isDeclarationVisible,
                isImplementationOfOverload: isImplementationOfOverload,
                isRequiredInitializedParameter: isRequiredInitializedParameter,
                isOptionalUninitializedParameterProperty: isOptionalUninitializedParameterProperty,
                isExpandoFunctionDeclaration: isExpandoFunctionDeclaration,
                getPropertiesOfContainerFunction: getPropertiesOfContainerFunction,
                createTypeOfDeclaration: createTypeOfDeclaration,
                createReturnTypeOfSignatureDeclaration: createReturnTypeOfSignatureDeclaration,
                createTypeOfExpression: createTypeOfExpression,
                createLiteralConstValue: createLiteralConstValue,
                isSymbolAccessible: isSymbolAccessible,
                isEntityNameVisible: isEntityNameVisible,
                getConstantValue: (nodeIn)=>{
                    const node = getParseTreeNode(nodeIn, canHaveConstantValue);
                    return node ? getConstantValue2(node) : void 0;
                },
                collectLinkedAliases: collectLinkedAliases,
                getReferencedValueDeclaration: getReferencedValueDeclaration,
                getReferencedValueDeclarations: getReferencedValueDeclarations,
                getTypeReferenceSerializationKind: getTypeReferenceSerializationKind,
                isOptionalParameter: isOptionalParameter,
                moduleExportsSomeValue: moduleExportsSomeValue,
                isArgumentsLocalBinding: isArgumentsLocalBinding,
                getExternalModuleFileFromDeclaration: (nodeIn)=>{
                    const node = getParseTreeNode(nodeIn, hasPossibleExternalModuleReference);
                    return node && getExternalModuleFileFromDeclaration(node);
                },
                getTypeReferenceDirectivesForEntityName: getTypeReferenceDirectivesForEntityName,
                getTypeReferenceDirectivesForSymbol: getTypeReferenceDirectivesForSymbol,
                isLiteralConstDeclaration: isLiteralConstDeclaration,
                isLateBound: (nodeIn)=>{
                    const node = getParseTreeNode(nodeIn, isDeclaration);
                    const symbol = node && getSymbolOfDeclaration(node);
                    return !!(symbol && getCheckFlags(symbol) & 4096 /* Late */ );
                },
                getJsxFactoryEntity: getJsxFactoryEntity,
                getJsxFragmentFactoryEntity: getJsxFragmentFactoryEntity,
                getAllAccessorDeclarations (accessor) {
                    accessor = getParseTreeNode(accessor, isGetOrSetAccessorDeclaration);
                    const otherKind = accessor.kind === 177 /* SetAccessor */  ? 176 /* GetAccessor */  : 177 /* SetAccessor */ ;
                    const otherAccessor = getDeclarationOfKind(getSymbolOfDeclaration(accessor), otherKind);
                    const firstAccessor = otherAccessor && otherAccessor.pos < accessor.pos ? otherAccessor : accessor;
                    const secondAccessor = otherAccessor && otherAccessor.pos < accessor.pos ? accessor : otherAccessor;
                    const setAccessor = accessor.kind === 177 /* SetAccessor */  ? accessor : otherAccessor;
                    const getAccessor = accessor.kind === 176 /* GetAccessor */  ? accessor : otherAccessor;
                    return {
                        firstAccessor: firstAccessor,
                        secondAccessor: secondAccessor,
                        setAccessor: setAccessor,
                        getAccessor: getAccessor
                    };
                },
                getSymbolOfExternalModuleSpecifier: (moduleName)=>resolveExternalModuleNameWorker(moduleName, moduleName, /*moduleNotFoundError*/ void 0),
                isBindingCapturedByNode: (node, decl)=>{
                    const parseNode = getParseTreeNode(node);
                    const parseDecl = getParseTreeNode(decl);
                    return !!parseNode && !!parseDecl && (isVariableDeclaration(parseDecl) || isBindingElement(parseDecl)) && isBindingCapturedByNode(parseNode, parseDecl);
                },
                getDeclarationStatementsForSourceFile: (node, flags, tracker, bundled)=>{
                    const n = getParseTreeNode(node);
                    Debug.assert(n && n.kind === 311 /* SourceFile */ , "Non-sourcefile node passed into getDeclarationsForSourceFile");
                    const sym = getSymbolOfDeclaration(node);
                    if (!sym) return !node.locals ? [] : nodeBuilder.symbolTableToDeclarationStatements(node.locals, node, flags, tracker, bundled);
                    return !sym.exports ? [] : nodeBuilder.symbolTableToDeclarationStatements(sym.exports, node, flags, tracker, bundled);
                },
                isImportRequiredByAugmentation: isImportRequiredByAugmentation
            };
            function isImportRequiredByAugmentation(node) {
                const file = getSourceFileOfNode(node);
                if (!file.symbol) return false;
                const importTarget = getExternalModuleFileFromDeclaration(node);
                if (!importTarget) return false;
                if (importTarget === file) return false;
                const exports = getExportsOfModule(file.symbol);
                for (const s of arrayFrom(exports.values()))if (s.mergeId) {
                    const merged = getMergedSymbol(s);
                    if (merged.declarations) for (const d of merged.declarations){
                        const declFile = getSourceFileOfNode(d);
                        if (declFile === importTarget) return true;
                    }
                }
                return false;
            }
            function isInHeritageClause(node) {
                return node.parent && node.parent.kind === 232 /* ExpressionWithTypeArguments */  && node.parent.parent && node.parent.parent.kind === 297 /* HeritageClause */ ;
            }
            function getTypeReferenceDirectivesForEntityName(node) {
                if (!fileToDirective) return void 0;
                let meaning;
                if (node.parent.kind === 166 /* ComputedPropertyName */ ) meaning = 1160127 /* ExportValue */ ;
                else {
                    meaning = 790504 /* Namespace */ ;
                    if (node.kind === 80 /* Identifier */  && isInTypeQuery(node) || node.kind === 210 /* PropertyAccessExpression */  && !isInHeritageClause(node)) meaning = 1160127 /* ExportValue */ ;
                }
                const symbol = resolveEntityName(node, meaning, /*ignoreErrors*/ true);
                return symbol && symbol !== unknownSymbol ? getTypeReferenceDirectivesForSymbol(symbol, meaning) : void 0;
            }
            function getTypeReferenceDirectivesForSymbol(symbol, meaning) {
                if (!fileToDirective || !isSymbolFromTypeDeclarationFile(symbol)) return void 0;
                let typeReferenceDirectives;
                for (const decl of symbol.declarations)if (decl.symbol && decl.symbol.flags & meaning) {
                    const file = getSourceFileOfNode(decl);
                    const typeReferenceDirective = fileToDirective.get(file.path);
                    if (typeReferenceDirective) (typeReferenceDirectives || (typeReferenceDirectives = [])).push(typeReferenceDirective);
                    else return void 0;
                }
                return typeReferenceDirectives;
            }
            function isSymbolFromTypeDeclarationFile(symbol) {
                if (!symbol.declarations) return false;
                let current = symbol;
                while(true){
                    const parent2 = getParentOfSymbol(current);
                    if (parent2) current = parent2;
                    else break;
                }
                if (current.valueDeclaration && current.valueDeclaration.kind === 311 /* SourceFile */  && current.flags & 512 /* ValueModule */ ) return false;
                for (const decl of symbol.declarations){
                    const file = getSourceFileOfNode(decl);
                    if (fileToDirective.has(file.path)) return true;
                }
                return false;
            }
            function addReferencedFilesToTypeDirective(file, key, mode) {
                if (fileToDirective.has(file.path)) return;
                fileToDirective.set(file.path, [
                    key,
                    mode
                ]);
                for (const { fileName: fileName , resolutionMode: resolutionMode  } of file.referencedFiles){
                    const resolvedFile = resolveTripleslashReference(fileName, file.fileName);
                    const referencedFile = host.getSourceFile(resolvedFile);
                    if (referencedFile) addReferencedFilesToTypeDirective(referencedFile, key, resolutionMode || file.impliedNodeFormat);
                }
            }
        }
        function getExternalModuleFileFromDeclaration(declaration) {
            const specifier = declaration.kind === 266 /* ModuleDeclaration */  ? tryCast(declaration.name, isStringLiteral) : getExternalModuleName(declaration);
            const moduleSymbol = resolveExternalModuleNameWorker(specifier, specifier, /*moduleNotFoundError*/ void 0);
            if (!moduleSymbol) return void 0;
            return getDeclarationOfKind(moduleSymbol, 311 /* SourceFile */ );
        }
        function initializeTypeChecker() {
            for (const file of host.getSourceFiles())bindSourceFile(file, compilerOptions);
            amalgamatedDuplicates = /* @__PURE__ */ new Map();
            let augmentations;
            for (const file of host.getSourceFiles()){
                if (file.redirectInfo) continue;
                if (!isExternalOrCommonJsModule(file)) {
                    const fileGlobalThisSymbol = file.locals.get("globalThis");
                    if (fileGlobalThisSymbol == null ? void 0 : fileGlobalThisSymbol.declarations) for (const declaration of fileGlobalThisSymbol.declarations)diagnostics.add(createDiagnosticForNode(declaration, Diagnostics.Declaration_name_conflicts_with_built_in_global_identifier_0, "globalThis"));
                    mergeSymbolTable(globals, file.locals);
                }
                if (file.jsGlobalAugmentations) mergeSymbolTable(globals, file.jsGlobalAugmentations);
                if (file.patternAmbientModules && file.patternAmbientModules.length) patternAmbientModules = concatenate(patternAmbientModules, file.patternAmbientModules);
                if (file.moduleAugmentations.length) (augmentations || (augmentations = [])).push(file.moduleAugmentations);
                if (file.symbol && file.symbol.globalExports) {
                    const source = file.symbol.globalExports;
                    source.forEach((sourceSymbol, id)=>{
                        if (!globals.has(id)) globals.set(id, sourceSymbol);
                    });
                }
            }
            if (augmentations) {
                for (const list of augmentations)for (const augmentation of list){
                    if (!isGlobalScopeAugmentation(augmentation.parent)) continue;
                    mergeModuleAugmentation(augmentation);
                }
            }
            addToSymbolTable(globals, builtinGlobals, Diagnostics.Declaration_name_conflicts_with_built_in_global_identifier_0);
            getSymbolLinks(undefinedSymbol).type = undefinedWideningType;
            getSymbolLinks(argumentsSymbol).type = getGlobalType("IArguments", /*arity*/ 0, /*reportErrors*/ true);
            getSymbolLinks(unknownSymbol).type = errorType;
            getSymbolLinks(globalThisSymbol).type = createObjectType(16 /* Anonymous */ , globalThisSymbol);
            globalArrayType = getGlobalType("Array", /*arity*/ 1, /*reportErrors*/ true);
            globalObjectType = getGlobalType("Object", /*arity*/ 0, /*reportErrors*/ true);
            globalFunctionType = getGlobalType("Function", /*arity*/ 0, /*reportErrors*/ true);
            globalCallableFunctionType = strictBindCallApply && getGlobalType("CallableFunction", /*arity*/ 0, /*reportErrors*/ true) || globalFunctionType;
            globalNewableFunctionType = strictBindCallApply && getGlobalType("NewableFunction", /*arity*/ 0, /*reportErrors*/ true) || globalFunctionType;
            globalStringType = getGlobalType("String", /*arity*/ 0, /*reportErrors*/ true);
            globalNumberType = getGlobalType("Number", /*arity*/ 0, /*reportErrors*/ true);
            globalBooleanType = getGlobalType("Boolean", /*arity*/ 0, /*reportErrors*/ true);
            globalRegExpType = getGlobalType("RegExp", /*arity*/ 0, /*reportErrors*/ true);
            anyArrayType = createArrayType(anyType);
            autoArrayType = createArrayType(autoType);
            if (autoArrayType === emptyObjectType) autoArrayType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
            globalReadonlyArrayType = getGlobalTypeOrUndefined("ReadonlyArray", /*arity*/ 1) || globalArrayType;
            anyReadonlyArrayType = globalReadonlyArrayType ? createTypeFromGenericGlobalType(globalReadonlyArrayType, [
                anyType
            ]) : anyArrayType;
            globalThisType = getGlobalTypeOrUndefined("ThisType", /*arity*/ 1);
            if (augmentations) {
                for (const list of augmentations)for (const augmentation of list){
                    if (isGlobalScopeAugmentation(augmentation.parent)) continue;
                    mergeModuleAugmentation(augmentation);
                }
            }
            amalgamatedDuplicates.forEach(({ firstFile: firstFile , secondFile: secondFile , conflictingSymbols: conflictingSymbols  })=>{
                if (conflictingSymbols.size < 8) conflictingSymbols.forEach(({ isBlockScoped: isBlockScoped , firstFileLocations: firstFileLocations , secondFileLocations: secondFileLocations  }, symbolName2)=>{
                    const message = isBlockScoped ? Diagnostics.Cannot_redeclare_block_scoped_variable_0 : Diagnostics.Duplicate_identifier_0;
                    for (const node of firstFileLocations)addDuplicateDeclarationError(node, message, symbolName2, secondFileLocations);
                    for (const node of secondFileLocations)addDuplicateDeclarationError(node, message, symbolName2, firstFileLocations);
                });
                else {
                    const list = arrayFrom(conflictingSymbols.keys()).join(", ");
                    diagnostics.add(addRelatedInfo(createDiagnosticForNode(firstFile, Diagnostics.Definitions_of_the_following_identifiers_conflict_with_those_in_another_file_Colon_0, list), createDiagnosticForNode(secondFile, Diagnostics.Conflicts_are_in_this_file)));
                    diagnostics.add(addRelatedInfo(createDiagnosticForNode(secondFile, Diagnostics.Definitions_of_the_following_identifiers_conflict_with_those_in_another_file_Colon_0, list), createDiagnosticForNode(firstFile, Diagnostics.Conflicts_are_in_this_file)));
                }
            });
            amalgamatedDuplicates = void 0;
        }
        function checkExternalEmitHelpers(location, helpers) {
            if ((requestedExternalEmitHelpers & helpers) !== helpers && compilerOptions.importHelpers) {
                const sourceFile = getSourceFileOfNode(location);
                if (isEffectiveExternalModule(sourceFile, compilerOptions) && !(location.flags & 16777216 /* Ambient */ )) {
                    const helpersModule = resolveHelpersModule(sourceFile, location);
                    if (helpersModule !== unknownSymbol) {
                        const uncheckedHelpers = helpers & ~requestedExternalEmitHelpers;
                        for(let helper = 1 /* FirstEmitHelper */ ; helper <= 16777216 /* LastEmitHelper */ ; helper <<= 1){
                            if (uncheckedHelpers & helper) for (const name of getHelperNames(helper)){
                                if (requestedExternalEmitHelperNames.has(name)) continue;
                                requestedExternalEmitHelperNames.add(name);
                                const symbol = resolveSymbol(getSymbol2(getExportsOfModule(helpersModule), escapeLeadingUnderscores(name), 111551 /* Value */ ));
                                if (!symbol) error(location, Diagnostics.This_syntax_requires_an_imported_helper_named_1_which_does_not_exist_in_0_Consider_upgrading_your_version_of_0, externalHelpersModuleNameText, name);
                                else if (helper & 524288 /* ClassPrivateFieldGet */ ) {
                                    if (!some(getSignaturesOfSymbol(symbol), (signature)=>getParameterCount(signature) > 3)) error(location, Diagnostics.This_syntax_requires_an_imported_helper_named_1_with_2_parameters_which_is_not_compatible_with_the_one_in_0_Consider_upgrading_your_version_of_0, externalHelpersModuleNameText, name, 4);
                                } else if (helper & 1048576 /* ClassPrivateFieldSet */ ) {
                                    if (!some(getSignaturesOfSymbol(symbol), (signature)=>getParameterCount(signature) > 4)) error(location, Diagnostics.This_syntax_requires_an_imported_helper_named_1_with_2_parameters_which_is_not_compatible_with_the_one_in_0_Consider_upgrading_your_version_of_0, externalHelpersModuleNameText, name, 5);
                                } else if (helper & 1024 /* SpreadArray */ ) {
                                    if (!some(getSignaturesOfSymbol(symbol), (signature)=>getParameterCount(signature) > 2)) error(location, Diagnostics.This_syntax_requires_an_imported_helper_named_1_with_2_parameters_which_is_not_compatible_with_the_one_in_0_Consider_upgrading_your_version_of_0, externalHelpersModuleNameText, name, 3);
                                }
                            }
                        }
                    }
                    requestedExternalEmitHelpers |= helpers;
                }
            }
        }
        function getHelperNames(helper) {
            switch(helper){
                case 1 /* Extends */ :
                    return [
                        "__extends"
                    ];
                case 2 /* Assign */ :
                    return [
                        "__assign"
                    ];
                case 4 /* Rest */ :
                    return [
                        "__rest"
                    ];
                case 8 /* Decorate */ :
                    return legacyDecorators ? [
                        "__decorate"
                    ] : [
                        "__esDecorate",
                        "__runInitializers"
                    ];
                case 16 /* Metadata */ :
                    return [
                        "__metadata"
                    ];
                case 32 /* Param */ :
                    return [
                        "__param"
                    ];
                case 64 /* Awaiter */ :
                    return [
                        "__awaiter"
                    ];
                case 128 /* Generator */ :
                    return [
                        "__generator"
                    ];
                case 256 /* Values */ :
                    return [
                        "__values"
                    ];
                case 512 /* Read */ :
                    return [
                        "__read"
                    ];
                case 1024 /* SpreadArray */ :
                    return [
                        "__spreadArray"
                    ];
                case 2048 /* Await */ :
                    return [
                        "__await"
                    ];
                case 4096 /* AsyncGenerator */ :
                    return [
                        "__asyncGenerator"
                    ];
                case 8192 /* AsyncDelegator */ :
                    return [
                        "__asyncDelegator"
                    ];
                case 16384 /* AsyncValues */ :
                    return [
                        "__asyncValues"
                    ];
                case 32768 /* ExportStar */ :
                    return [
                        "__exportStar"
                    ];
                case 65536 /* ImportStar */ :
                    return [
                        "__importStar"
                    ];
                case 131072 /* ImportDefault */ :
                    return [
                        "__importDefault"
                    ];
                case 262144 /* MakeTemplateObject */ :
                    return [
                        "__makeTemplateObject"
                    ];
                case 524288 /* ClassPrivateFieldGet */ :
                    return [
                        "__classPrivateFieldGet"
                    ];
                case 1048576 /* ClassPrivateFieldSet */ :
                    return [
                        "__classPrivateFieldSet"
                    ];
                case 2097152 /* ClassPrivateFieldIn */ :
                    return [
                        "__classPrivateFieldIn"
                    ];
                case 4194304 /* CreateBinding */ :
                    return [
                        "__createBinding"
                    ];
                case 8388608 /* SetFunctionName */ :
                    return [
                        "__setFunctionName"
                    ];
                case 16777216 /* PropKey */ :
                    return [
                        "__propKey"
                    ];
                default:
                    return Debug.fail("Unrecognized helper");
            }
        }
        function resolveHelpersModule(node, errorNode) {
            if (!externalHelpersModule) externalHelpersModule = resolveExternalModule(node, externalHelpersModuleNameText, Diagnostics.This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found, errorNode) || unknownSymbol;
            return externalHelpersModule;
        }
        function checkGrammarModifiers(node) {
            const quickResult = reportObviousDecoratorErrors(node) || reportObviousModifierErrors(node);
            if (quickResult !== void 0) return quickResult;
            if (isParameter(node) && parameterIsThisKeyword(node)) return grammarErrorOnFirstToken(node, Diagnostics.Neither_decorators_nor_modifiers_may_be_applied_to_this_parameters);
            let lastStatic, lastDeclare, lastAsync, lastOverride, firstDecorator;
            let flags = 0 /* None */ ;
            let sawExportBeforeDecorators = false;
            let hasLeadingDecorators = false;
            for (const modifier of node.modifiers)if (isDecorator(modifier)) {
                if (!nodeCanBeDecorated(legacyDecorators, node, node.parent, node.parent.parent)) {
                    if (node.kind === 173 /* MethodDeclaration */  && !nodeIsPresent(node.body)) return grammarErrorOnFirstToken(node, Diagnostics.A_decorator_can_only_decorate_a_method_implementation_not_an_overload);
                    else return grammarErrorOnFirstToken(node, Diagnostics.Decorators_are_not_valid_here);
                } else if (legacyDecorators && (node.kind === 176 /* GetAccessor */  || node.kind === 177 /* SetAccessor */ )) {
                    const accessors = getAllAccessorDeclarations(node.parent.members, node);
                    if (hasDecorators(accessors.firstAccessor) && node === accessors.secondAccessor) return grammarErrorOnFirstToken(node, Diagnostics.Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name);
                }
                if (flags & -132098) return grammarErrorOnNode(modifier, Diagnostics.Decorators_are_not_valid_here);
                if (hasLeadingDecorators && flags & 126975 /* Modifier */ ) {
                    Debug.assertIsDefined(firstDecorator);
                    const sourceFile = getSourceFileOfNode(modifier);
                    if (!hasParseDiagnostics(sourceFile)) {
                        addRelatedInfo(error(modifier, Diagnostics.Decorators_may_not_appear_after_export_or_export_default_if_they_also_appear_before_export), createDiagnosticForNode(firstDecorator, Diagnostics.Decorator_used_before_export_here));
                        return true;
                    }
                    return false;
                }
                flags |= 131072 /* Decorator */ ;
                if (!(flags & 126975 /* Modifier */ )) hasLeadingDecorators = true;
                else if (flags & 1 /* Export */ ) sawExportBeforeDecorators = true;
                firstDecorator ?? (firstDecorator = modifier);
            } else {
                if (modifier.kind !== 148 /* ReadonlyKeyword */ ) {
                    if (node.kind === 170 /* PropertySignature */  || node.kind === 172 /* MethodSignature */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_type_member, tokenToString(modifier.kind));
                    if (node.kind === 180 /* IndexSignature */  && (modifier.kind !== 126 /* StaticKeyword */  || !isClassLike(node.parent))) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_an_index_signature, tokenToString(modifier.kind));
                }
                if (modifier.kind !== 103 /* InKeyword */  && modifier.kind !== 147 /* OutKeyword */  && modifier.kind !== 87 /* ConstKeyword */ ) {
                    if (node.kind === 167 /* TypeParameter */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_type_parameter, tokenToString(modifier.kind));
                }
                switch(modifier.kind){
                    case 87 /* ConstKeyword */ :
                        if (node.kind !== 265 /* EnumDeclaration */  && node.kind !== 167 /* TypeParameter */ ) return grammarErrorOnNode(node, Diagnostics.A_class_member_cannot_have_the_0_keyword, tokenToString(87 /* ConstKeyword */ ));
                        const parent2 = node.parent;
                        if (node.kind === 167 /* TypeParameter */  && !(isFunctionLikeDeclaration(parent2) || isClassLike(parent2) || isFunctionTypeNode(parent2) || isConstructorTypeNode(parent2) || isCallSignatureDeclaration(parent2) || isConstructSignatureDeclaration(parent2) || isMethodSignature(parent2))) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_can_only_appear_on_a_type_parameter_of_a_function_method_or_class, tokenToString(modifier.kind));
                        break;
                    case 163 /* OverrideKeyword */ :
                        if (flags & 16384 /* Override */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "override");
                        else if (flags & 2 /* Ambient */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "override", "declare");
                        else if (flags & 64 /* Readonly */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "override", "readonly");
                        else if (flags & 128 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "override", "accessor");
                        else if (flags & 512 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "override", "async");
                        flags |= 16384 /* Override */ ;
                        lastOverride = modifier;
                        break;
                    case 125 /* PublicKeyword */ :
                    case 124 /* ProtectedKeyword */ :
                    case 123 /* PrivateKeyword */ :
                        const text = visibilityToString(modifierToFlag(modifier.kind));
                        if (flags & 28 /* AccessibilityModifier */ ) return grammarErrorOnNode(modifier, Diagnostics.Accessibility_modifier_already_seen);
                        else if (flags & 16384 /* Override */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "override");
                        else if (flags & 32 /* Static */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "static");
                        else if (flags & 128 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "accessor");
                        else if (flags & 64 /* Readonly */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "readonly");
                        else if (flags & 512 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "async");
                        else if (node.parent.kind === 267 /* ModuleBlock */  || node.parent.kind === 311 /* SourceFile */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_module_or_namespace_element, text);
                        else if (flags & 256 /* Abstract */ ) {
                            if (modifier.kind === 123 /* PrivateKeyword */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, text, "abstract");
                            else return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "abstract");
                        } else if (isPrivateIdentifierClassElementDeclaration(node)) return grammarErrorOnNode(modifier, Diagnostics.An_accessibility_modifier_cannot_be_used_with_a_private_identifier);
                        flags |= modifierToFlag(modifier.kind);
                        break;
                    case 126 /* StaticKeyword */ :
                        if (flags & 32 /* Static */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "static");
                        else if (flags & 64 /* Readonly */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "static", "readonly");
                        else if (flags & 512 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "static", "async");
                        else if (flags & 128 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "static", "accessor");
                        else if (node.parent.kind === 267 /* ModuleBlock */  || node.parent.kind === 311 /* SourceFile */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_module_or_namespace_element, "static");
                        else if (node.kind === 168 /* Parameter */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_parameter, "static");
                        else if (flags & 256 /* Abstract */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "static", "abstract");
                        else if (flags & 16384 /* Override */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "static", "override");
                        flags |= 32 /* Static */ ;
                        lastStatic = modifier;
                        break;
                    case 129 /* AccessorKeyword */ :
                        if (flags & 128 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "accessor");
                        else if (flags & 64 /* Readonly */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "accessor", "readonly");
                        else if (flags & 2 /* Ambient */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "accessor", "declare");
                        else if (node.kind !== 171 /* PropertyDeclaration */ ) return grammarErrorOnNode(modifier, Diagnostics.accessor_modifier_can_only_appear_on_a_property_declaration);
                        flags |= 128 /* Accessor */ ;
                        break;
                    case 148 /* ReadonlyKeyword */ :
                        if (flags & 64 /* Readonly */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "readonly");
                        else if (node.kind !== 171 /* PropertyDeclaration */  && node.kind !== 170 /* PropertySignature */  && node.kind !== 180 /* IndexSignature */  && node.kind !== 168 /* Parameter */ ) return grammarErrorOnNode(modifier, Diagnostics.readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature);
                        else if (flags & 128 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "readonly", "accessor");
                        flags |= 64 /* Readonly */ ;
                        break;
                    case 95 /* ExportKeyword */ :
                        if (compilerOptions.verbatimModuleSyntax && !(node.flags & 16777216 /* Ambient */ ) && node.kind !== 264 /* TypeAliasDeclaration */  && node.kind !== 263 /* InterfaceDeclaration */  && // ModuleDeclaration needs to be checked that it is uninstantiated later
                        node.kind !== 266 /* ModuleDeclaration */  && node.parent.kind === 311 /* SourceFile */  && (moduleKind === 1 /* CommonJS */  || getSourceFileOfNode(node).impliedNodeFormat === 1 /* CommonJS */ )) return grammarErrorOnNode(modifier, Diagnostics.A_top_level_export_modifier_cannot_be_used_on_value_declarations_in_a_CommonJS_module_when_verbatimModuleSyntax_is_enabled);
                        if (flags & 1 /* Export */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "export");
                        else if (flags & 2 /* Ambient */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "export", "declare");
                        else if (flags & 256 /* Abstract */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "export", "abstract");
                        else if (flags & 512 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "export", "async");
                        else if (isClassLike(node.parent)) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_class_elements_of_this_kind, "export");
                        else if (node.kind === 168 /* Parameter */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_parameter, "export");
                        flags |= 1 /* Export */ ;
                        break;
                    case 90 /* DefaultKeyword */ :
                        const container = node.parent.kind === 311 /* SourceFile */  ? node.parent : node.parent.parent;
                        if (container.kind === 266 /* ModuleDeclaration */  && !isAmbientModule(container)) return grammarErrorOnNode(modifier, Diagnostics.A_default_export_can_only_be_used_in_an_ECMAScript_style_module);
                        else if (!(flags & 1 /* Export */ )) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "export", "default");
                        else if (sawExportBeforeDecorators) return grammarErrorOnNode(firstDecorator, Diagnostics.Decorators_are_not_valid_here);
                        flags |= 1024 /* Default */ ;
                        break;
                    case 138 /* DeclareKeyword */ :
                        if (flags & 2 /* Ambient */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "declare");
                        else if (flags & 512 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_in_an_ambient_context, "async");
                        else if (flags & 16384 /* Override */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_in_an_ambient_context, "override");
                        else if (isClassLike(node.parent) && !isPropertyDeclaration(node)) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_class_elements_of_this_kind, "declare");
                        else if (node.kind === 168 /* Parameter */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_parameter, "declare");
                        else if (node.parent.flags & 16777216 /* Ambient */  && node.parent.kind === 267 /* ModuleBlock */ ) return grammarErrorOnNode(modifier, Diagnostics.A_declare_modifier_cannot_be_used_in_an_already_ambient_context);
                        else if (isPrivateIdentifierClassElementDeclaration(node)) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_a_private_identifier, "declare");
                        else if (flags & 128 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "declare", "accessor");
                        flags |= 2 /* Ambient */ ;
                        lastDeclare = modifier;
                        break;
                    case 128 /* AbstractKeyword */ :
                        if (flags & 256 /* Abstract */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "abstract");
                        if (node.kind !== 262 /* ClassDeclaration */  && node.kind !== 184 /* ConstructorType */ ) {
                            if (node.kind !== 173 /* MethodDeclaration */  && node.kind !== 171 /* PropertyDeclaration */  && node.kind !== 176 /* GetAccessor */  && node.kind !== 177 /* SetAccessor */ ) return grammarErrorOnNode(modifier, Diagnostics.abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration);
                            if (!(node.parent.kind === 262 /* ClassDeclaration */  && hasSyntacticModifier(node.parent, 256 /* Abstract */ ))) {
                                const message = node.kind === 171 /* PropertyDeclaration */  ? Diagnostics.Abstract_properties_can_only_appear_within_an_abstract_class : Diagnostics.Abstract_methods_can_only_appear_within_an_abstract_class;
                                return grammarErrorOnNode(modifier, message);
                            }
                            if (flags & 32 /* Static */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "static", "abstract");
                            if (flags & 8 /* Private */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "private", "abstract");
                            if (flags & 512 /* Async */  && lastAsync) return grammarErrorOnNode(lastAsync, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "async", "abstract");
                            if (flags & 16384 /* Override */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "abstract", "override");
                            if (flags & 128 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "abstract", "accessor");
                        }
                        if (isNamedDeclaration(node) && node.name.kind === 81 /* PrivateIdentifier */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_a_private_identifier, "abstract");
                        flags |= 256 /* Abstract */ ;
                        break;
                    case 134 /* AsyncKeyword */ :
                        if (flags & 512 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "async");
                        else if (flags & 2 /* Ambient */  || node.parent.flags & 16777216 /* Ambient */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_in_an_ambient_context, "async");
                        else if (node.kind === 168 /* Parameter */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_parameter, "async");
                        if (flags & 256 /* Abstract */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "async", "abstract");
                        flags |= 512 /* Async */ ;
                        lastAsync = modifier;
                        break;
                    case 103 /* InKeyword */ :
                    case 147 /* OutKeyword */ :
                        const inOutFlag = modifier.kind === 103 /* InKeyword */  ? 32768 /* In */  : 65536 /* Out */ ;
                        const inOutText = modifier.kind === 103 /* InKeyword */  ? "in" : "out";
                        if (node.kind !== 167 /* TypeParameter */  || !(isInterfaceDeclaration(node.parent) || isClassLike(node.parent) || isTypeAliasDeclaration(node.parent))) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_can_only_appear_on_a_type_parameter_of_a_class_interface_or_type_alias, inOutText);
                        if (flags & inOutFlag) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, inOutText);
                        if (inOutFlag & 32768 /* In */  && flags & 65536 /* Out */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "in", "out");
                        flags |= inOutFlag;
                        break;
                }
            }
            if (node.kind === 175 /* Constructor */ ) {
                if (flags & 32 /* Static */ ) return grammarErrorOnNode(lastStatic, Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "static");
                if (flags & 16384 /* Override */ ) return grammarErrorOnNode(lastOverride, Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "override");
                if (flags & 512 /* Async */ ) return grammarErrorOnNode(lastAsync, Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "async");
                return false;
            } else if ((node.kind === 271 /* ImportDeclaration */  || node.kind === 270 /* ImportEqualsDeclaration */ ) && flags & 2 /* Ambient */ ) return grammarErrorOnNode(lastDeclare, Diagnostics.A_0_modifier_cannot_be_used_with_an_import_declaration, "declare");
            else if (node.kind === 168 /* Parameter */  && flags & 16476 /* ParameterPropertyModifier */  && isBindingPattern(node.name)) return grammarErrorOnNode(node, Diagnostics.A_parameter_property_may_not_be_declared_using_a_binding_pattern);
            else if (node.kind === 168 /* Parameter */  && flags & 16476 /* ParameterPropertyModifier */  && node.dotDotDotToken) return grammarErrorOnNode(node, Diagnostics.A_parameter_property_cannot_be_declared_using_a_rest_parameter);
            if (flags & 512 /* Async */ ) return checkGrammarAsyncModifier(node, lastAsync);
            return false;
        }
        function reportObviousModifierErrors(node) {
            if (!node.modifiers) return false;
            const modifier = findFirstIllegalModifier(node);
            return modifier && grammarErrorOnFirstToken(modifier, Diagnostics.Modifiers_cannot_appear_here);
        }
        function findFirstModifierExcept(node, allowedModifier) {
            const modifier = find(node.modifiers, isModifier);
            return modifier && modifier.kind !== allowedModifier ? modifier : void 0;
        }
        function findFirstIllegalModifier(node) {
            switch(node.kind){
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                case 175 /* Constructor */ :
                case 171 /* PropertyDeclaration */ :
                case 170 /* PropertySignature */ :
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                case 180 /* IndexSignature */ :
                case 266 /* ModuleDeclaration */ :
                case 271 /* ImportDeclaration */ :
                case 270 /* ImportEqualsDeclaration */ :
                case 277 /* ExportDeclaration */ :
                case 276 /* ExportAssignment */ :
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                case 168 /* Parameter */ :
                case 167 /* TypeParameter */ :
                    return void 0;
                case 174 /* ClassStaticBlockDeclaration */ :
                case 302 /* PropertyAssignment */ :
                case 303 /* ShorthandPropertyAssignment */ :
                case 269 /* NamespaceExportDeclaration */ :
                case 281 /* MissingDeclaration */ :
                    return find(node.modifiers, isModifier);
                default:
                    if (node.parent.kind === 267 /* ModuleBlock */  || node.parent.kind === 311 /* SourceFile */ ) return void 0;
                    switch(node.kind){
                        case 261 /* FunctionDeclaration */ :
                            return findFirstModifierExcept(node, 134 /* AsyncKeyword */ );
                        case 262 /* ClassDeclaration */ :
                        case 184 /* ConstructorType */ :
                            return findFirstModifierExcept(node, 128 /* AbstractKeyword */ );
                        case 230 /* ClassExpression */ :
                        case 263 /* InterfaceDeclaration */ :
                        case 242 /* VariableStatement */ :
                        case 264 /* TypeAliasDeclaration */ :
                            return find(node.modifiers, isModifier);
                        case 265 /* EnumDeclaration */ :
                            return findFirstModifierExcept(node, 87 /* ConstKeyword */ );
                        default:
                            Debug.assertNever(node);
                    }
            }
        }
        function reportObviousDecoratorErrors(node) {
            const decorator = findFirstIllegalDecorator(node);
            return decorator && grammarErrorOnFirstToken(decorator, Diagnostics.Decorators_are_not_valid_here);
        }
        function findFirstIllegalDecorator(node) {
            return canHaveIllegalDecorators(node) ? find(node.modifiers, isDecorator) : void 0;
        }
        function checkGrammarAsyncModifier(node, asyncModifier) {
            switch(node.kind){
                case 173 /* MethodDeclaration */ :
                case 261 /* FunctionDeclaration */ :
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                    return false;
            }
            return grammarErrorOnNode(asyncModifier, Diagnostics._0_modifier_cannot_be_used_here, "async");
        }
        function checkGrammarForDisallowedTrailingComma(list, diag2 = Diagnostics.Trailing_comma_not_allowed) {
            if (list && list.hasTrailingComma) return grammarErrorAtPos(list[0], list.end - 1, 1, diag2);
            return false;
        }
        function checkGrammarTypeParameterList(typeParameters, file) {
            if (typeParameters && typeParameters.length === 0) {
                const start = typeParameters.pos - 1;
                const end = skipTrivia(file.text, typeParameters.end) + 1;
                return grammarErrorAtPos(file, start, end - start, Diagnostics.Type_parameter_list_cannot_be_empty);
            }
            return false;
        }
        function checkGrammarParameterList(parameters) {
            let seenOptionalParameter = false;
            const parameterCount = parameters.length;
            for(let i = 0; i < parameterCount; i++){
                const parameter = parameters[i];
                if (parameter.dotDotDotToken) {
                    if (i !== parameterCount - 1) return grammarErrorOnNode(parameter.dotDotDotToken, Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list);
                    if (!(parameter.flags & 16777216 /* Ambient */ )) checkGrammarForDisallowedTrailingComma(parameters, Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
                    if (parameter.questionToken) return grammarErrorOnNode(parameter.questionToken, Diagnostics.A_rest_parameter_cannot_be_optional);
                    if (parameter.initializer) return grammarErrorOnNode(parameter.name, Diagnostics.A_rest_parameter_cannot_have_an_initializer);
                } else if (isOptionalParameter(parameter)) {
                    seenOptionalParameter = true;
                    if (parameter.questionToken && parameter.initializer) return grammarErrorOnNode(parameter.name, Diagnostics.Parameter_cannot_have_question_mark_and_initializer);
                } else if (seenOptionalParameter && !parameter.initializer) return grammarErrorOnNode(parameter.name, Diagnostics.A_required_parameter_cannot_follow_an_optional_parameter);
            }
        }
        function getNonSimpleParameters(parameters) {
            return filter(parameters, (parameter)=>!!parameter.initializer || isBindingPattern(parameter.name) || isRestParameter(parameter));
        }
        function checkGrammarForUseStrictSimpleParameterList(node) {
            if (languageVersion >= 3 /* ES2016 */ ) {
                const useStrictDirective = node.body && isBlock(node.body) && findUseStrictPrologue(node.body.statements);
                if (useStrictDirective) {
                    const nonSimpleParameters = getNonSimpleParameters(node.parameters);
                    if (length(nonSimpleParameters)) {
                        forEach(nonSimpleParameters, (parameter)=>{
                            addRelatedInfo(error(parameter, Diagnostics.This_parameter_is_not_allowed_with_use_strict_directive), createDiagnosticForNode(useStrictDirective, Diagnostics.use_strict_directive_used_here));
                        });
                        const diagnostics2 = nonSimpleParameters.map((parameter, index)=>index === 0 ? createDiagnosticForNode(parameter, Diagnostics.Non_simple_parameter_declared_here) : createDiagnosticForNode(parameter, Diagnostics.and_here));
                        addRelatedInfo(error(useStrictDirective, Diagnostics.use_strict_directive_cannot_be_used_with_non_simple_parameter_list), ...diagnostics2);
                        return true;
                    }
                }
            }
            return false;
        }
        function checkGrammarFunctionLikeDeclaration(node) {
            const file = getSourceFileOfNode(node);
            return checkGrammarModifiers(node) || checkGrammarTypeParameterList(node.typeParameters, file) || checkGrammarParameterList(node.parameters) || checkGrammarArrowFunction(node, file) || isFunctionLikeDeclaration(node) && checkGrammarForUseStrictSimpleParameterList(node);
        }
        function checkGrammarClassLikeDeclaration(node) {
            const file = getSourceFileOfNode(node);
            return checkGrammarClassDeclarationHeritageClauses(node) || checkGrammarTypeParameterList(node.typeParameters, file);
        }
        function checkGrammarArrowFunction(node, file) {
            if (!isArrowFunction(node)) return false;
            if (node.typeParameters && !(length(node.typeParameters) > 1 || node.typeParameters.hasTrailingComma || node.typeParameters[0].constraint)) {
                if (file && fileExtensionIsOneOf(file.fileName, [
                    ".mts" /* Mts */ ,
                    ".cts" /* Cts */ 
                ])) grammarErrorOnNode(node.typeParameters[0], Diagnostics.This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Add_a_trailing_comma_or_explicit_constraint);
            }
            const { equalsGreaterThanToken: equalsGreaterThanToken  } = node;
            const startLine = getLineAndCharacterOfPosition(file, equalsGreaterThanToken.pos).line;
            const endLine = getLineAndCharacterOfPosition(file, equalsGreaterThanToken.end).line;
            return startLine !== endLine && grammarErrorOnNode(equalsGreaterThanToken, Diagnostics.Line_terminator_not_permitted_before_arrow);
        }
        function checkGrammarIndexSignatureParameters(node) {
            const parameter = node.parameters[0];
            if (node.parameters.length !== 1) {
                if (parameter) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_must_have_exactly_one_parameter);
                else return grammarErrorOnNode(node, Diagnostics.An_index_signature_must_have_exactly_one_parameter);
            }
            checkGrammarForDisallowedTrailingComma(node.parameters, Diagnostics.An_index_signature_cannot_have_a_trailing_comma);
            if (parameter.dotDotDotToken) return grammarErrorOnNode(parameter.dotDotDotToken, Diagnostics.An_index_signature_cannot_have_a_rest_parameter);
            if (hasEffectiveModifiers(parameter)) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_parameter_cannot_have_an_accessibility_modifier);
            if (parameter.questionToken) return grammarErrorOnNode(parameter.questionToken, Diagnostics.An_index_signature_parameter_cannot_have_a_question_mark);
            if (parameter.initializer) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_parameter_cannot_have_an_initializer);
            if (!parameter.type) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_parameter_must_have_a_type_annotation);
            const type = getTypeFromTypeNode(parameter.type);
            if (someType(type, (t)=>!!(t.flags & 8576 /* StringOrNumberLiteralOrUnique */ )) || isGenericType(type)) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_parameter_type_cannot_be_a_literal_type_or_generic_type_Consider_using_a_mapped_object_type_instead);
            if (!everyType(type, isValidIndexKeyType)) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_parameter_type_must_be_string_number_symbol_or_a_template_literal_type);
            if (!node.type) return grammarErrorOnNode(node, Diagnostics.An_index_signature_must_have_a_type_annotation);
            return false;
        }
        function checkGrammarIndexSignature(node) {
            return checkGrammarModifiers(node) || checkGrammarIndexSignatureParameters(node);
        }
        function checkGrammarForAtLeastOneTypeArgument(node, typeArguments) {
            if (typeArguments && typeArguments.length === 0) {
                const sourceFile = getSourceFileOfNode(node);
                const start = typeArguments.pos - 1;
                const end = skipTrivia(sourceFile.text, typeArguments.end) + 1;
                return grammarErrorAtPos(sourceFile, start, end - start, Diagnostics.Type_argument_list_cannot_be_empty);
            }
            return false;
        }
        function checkGrammarTypeArguments(node, typeArguments) {
            return checkGrammarForDisallowedTrailingComma(typeArguments) || checkGrammarForAtLeastOneTypeArgument(node, typeArguments);
        }
        function checkGrammarTaggedTemplateChain(node) {
            if (node.questionDotToken || node.flags & 32 /* OptionalChain */ ) return grammarErrorOnNode(node.template, Diagnostics.Tagged_template_expressions_are_not_permitted_in_an_optional_chain);
            return false;
        }
        function checkGrammarHeritageClause(node) {
            const types = node.types;
            if (checkGrammarForDisallowedTrailingComma(types)) return true;
            if (types && types.length === 0) {
                const listType = tokenToString(node.token);
                return grammarErrorAtPos(node, types.pos, 0, Diagnostics._0_list_cannot_be_empty, listType);
            }
            return some(types, checkGrammarExpressionWithTypeArguments);
        }
        function checkGrammarExpressionWithTypeArguments(node) {
            if (isExpressionWithTypeArguments(node) && isImportKeyword(node.expression) && node.typeArguments) return grammarErrorOnNode(node, Diagnostics.This_use_of_import_is_invalid_import_calls_can_be_written_but_they_must_have_parentheses_and_cannot_have_type_arguments);
            return checkGrammarTypeArguments(node, node.typeArguments);
        }
        function checkGrammarClassDeclarationHeritageClauses(node) {
            let seenExtendsClause = false;
            let seenImplementsClause = false;
            if (!checkGrammarModifiers(node) && node.heritageClauses) for (const heritageClause of node.heritageClauses){
                if (heritageClause.token === 96 /* ExtendsKeyword */ ) {
                    if (seenExtendsClause) return grammarErrorOnFirstToken(heritageClause, Diagnostics.extends_clause_already_seen);
                    if (seenImplementsClause) return grammarErrorOnFirstToken(heritageClause, Diagnostics.extends_clause_must_precede_implements_clause);
                    if (heritageClause.types.length > 1) return grammarErrorOnFirstToken(heritageClause.types[1], Diagnostics.Classes_can_only_extend_a_single_class);
                    seenExtendsClause = true;
                } else {
                    Debug.assert(heritageClause.token === 119 /* ImplementsKeyword */ );
                    if (seenImplementsClause) return grammarErrorOnFirstToken(heritageClause, Diagnostics.implements_clause_already_seen);
                    seenImplementsClause = true;
                }
                checkGrammarHeritageClause(heritageClause);
            }
        }
        function checkGrammarInterfaceDeclaration(node) {
            let seenExtendsClause = false;
            if (node.heritageClauses) for (const heritageClause of node.heritageClauses){
                if (heritageClause.token === 96 /* ExtendsKeyword */ ) {
                    if (seenExtendsClause) return grammarErrorOnFirstToken(heritageClause, Diagnostics.extends_clause_already_seen);
                    seenExtendsClause = true;
                } else {
                    Debug.assert(heritageClause.token === 119 /* ImplementsKeyword */ );
                    return grammarErrorOnFirstToken(heritageClause, Diagnostics.Interface_declaration_cannot_have_implements_clause);
                }
                checkGrammarHeritageClause(heritageClause);
            }
            return false;
        }
        function checkGrammarComputedPropertyName(node) {
            if (node.kind !== 166 /* ComputedPropertyName */ ) return false;
            const computedPropertyName = node;
            if (computedPropertyName.expression.kind === 225 /* BinaryExpression */  && computedPropertyName.expression.operatorToken.kind === 28 /* CommaToken */ ) return grammarErrorOnNode(computedPropertyName.expression, Diagnostics.A_comma_expression_is_not_allowed_in_a_computed_property_name);
            return false;
        }
        function checkGrammarForGenerator(node) {
            if (node.asteriskToken) {
                Debug.assert(node.kind === 261 /* FunctionDeclaration */  || node.kind === 217 /* FunctionExpression */  || node.kind === 173 /* MethodDeclaration */ );
                if (node.flags & 16777216 /* Ambient */ ) return grammarErrorOnNode(node.asteriskToken, Diagnostics.Generators_are_not_allowed_in_an_ambient_context);
                if (!node.body) return grammarErrorOnNode(node.asteriskToken, Diagnostics.An_overload_signature_cannot_be_declared_as_a_generator);
            }
        }
        function checkGrammarForInvalidQuestionMark(questionToken, message) {
            return !!questionToken && grammarErrorOnNode(questionToken, message);
        }
        function checkGrammarForInvalidExclamationToken(exclamationToken, message) {
            return !!exclamationToken && grammarErrorOnNode(exclamationToken, message);
        }
        function checkGrammarObjectLiteralExpression(node, inDestructuring) {
            const seen = /* @__PURE__ */ new Map();
            for (const prop of node.properties){
                if (prop.kind === 304 /* SpreadAssignment */ ) {
                    if (inDestructuring) {
                        const expression = skipParentheses(prop.expression);
                        if (isArrayLiteralExpression(expression) || isObjectLiteralExpression(expression)) return grammarErrorOnNode(prop.expression, Diagnostics.A_rest_element_cannot_contain_a_binding_pattern);
                    }
                    continue;
                }
                const name = prop.name;
                if (name.kind === 166 /* ComputedPropertyName */ ) checkGrammarComputedPropertyName(name);
                if (prop.kind === 303 /* ShorthandPropertyAssignment */  && !inDestructuring && prop.objectAssignmentInitializer) grammarErrorOnNode(prop.equalsToken, Diagnostics.Did_you_mean_to_use_a_Colon_An_can_only_follow_a_property_name_when_the_containing_object_literal_is_part_of_a_destructuring_pattern);
                if (name.kind === 81 /* PrivateIdentifier */ ) grammarErrorOnNode(name, Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
                if (canHaveModifiers(prop) && prop.modifiers) {
                    for (const mod of prop.modifiers)if (isModifier(mod) && (mod.kind !== 134 /* AsyncKeyword */  || prop.kind !== 173 /* MethodDeclaration */ )) grammarErrorOnNode(mod, Diagnostics._0_modifier_cannot_be_used_here, getTextOfNode(mod));
                } else if (canHaveIllegalModifiers(prop) && prop.modifiers) {
                    for (const mod of prop.modifiers)if (isModifier(mod)) grammarErrorOnNode(mod, Diagnostics._0_modifier_cannot_be_used_here, getTextOfNode(mod));
                }
                let currentKind;
                switch(prop.kind){
                    case 303 /* ShorthandPropertyAssignment */ :
                    case 302 /* PropertyAssignment */ :
                        checkGrammarForInvalidExclamationToken(prop.exclamationToken, Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context);
                        checkGrammarForInvalidQuestionMark(prop.questionToken, Diagnostics.An_object_member_cannot_be_declared_optional);
                        if (name.kind === 9 /* NumericLiteral */ ) checkGrammarNumericLiteral(name);
                        currentKind = 4 /* PropertyAssignment */ ;
                        break;
                    case 173 /* MethodDeclaration */ :
                        currentKind = 8 /* Method */ ;
                        break;
                    case 176 /* GetAccessor */ :
                        currentKind = 1 /* GetAccessor */ ;
                        break;
                    case 177 /* SetAccessor */ :
                        currentKind = 2 /* SetAccessor */ ;
                        break;
                    default:
                        Debug.assertNever(prop, "Unexpected syntax kind:" + prop.kind);
                }
                if (!inDestructuring) {
                    const effectiveName = getEffectivePropertyNameForPropertyNameNode(name);
                    if (effectiveName === void 0) continue;
                    const existingKind = seen.get(effectiveName);
                    if (!existingKind) seen.set(effectiveName, currentKind);
                    else {
                        if (currentKind & 8 /* Method */  && existingKind & 8 /* Method */ ) grammarErrorOnNode(name, Diagnostics.Duplicate_identifier_0, getTextOfNode(name));
                        else if (currentKind & 4 /* PropertyAssignment */  && existingKind & 4 /* PropertyAssignment */ ) grammarErrorOnNode(name, Diagnostics.An_object_literal_cannot_have_multiple_properties_with_the_same_name, getTextOfNode(name));
                        else if (currentKind & 3 /* GetOrSetAccessor */  && existingKind & 3 /* GetOrSetAccessor */ ) {
                            if (existingKind !== 3 /* GetOrSetAccessor */  && currentKind !== existingKind) seen.set(effectiveName, currentKind | existingKind);
                            else return grammarErrorOnNode(name, Diagnostics.An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name);
                        } else return grammarErrorOnNode(name, Diagnostics.An_object_literal_cannot_have_property_and_accessor_with_the_same_name);
                    }
                }
            }
        }
        function checkGrammarJsxElement(node) {
            checkGrammarJsxName(node.tagName);
            checkGrammarTypeArguments(node, node.typeArguments);
            const seen = /* @__PURE__ */ new Map();
            for (const attr of node.attributes.properties){
                if (attr.kind === 292 /* JsxSpreadAttribute */ ) continue;
                const { name: name , initializer: initializer  } = attr;
                const escapedText = getEscapedTextOfJsxAttributeName(name);
                if (!seen.get(escapedText)) seen.set(escapedText, true);
                else return grammarErrorOnNode(name, Diagnostics.JSX_elements_cannot_have_multiple_attributes_with_the_same_name);
                if (initializer && initializer.kind === 293 /* JsxExpression */  && !initializer.expression) return grammarErrorOnNode(initializer, Diagnostics.JSX_attributes_must_only_be_assigned_a_non_empty_expression);
            }
        }
        function checkGrammarJsxName(node) {
            if (isPropertyAccessExpression(node) && isJsxNamespacedName(node.expression)) return grammarErrorOnNode(node.expression, Diagnostics.JSX_property_access_expressions_cannot_include_JSX_namespace_names);
            if (isJsxNamespacedName(node) && getJSXTransformEnabled(compilerOptions) && !isIntrinsicJsxName(node.namespace.escapedText)) return grammarErrorOnNode(node, Diagnostics.React_components_cannot_include_JSX_namespace_names);
        }
        function checkGrammarJsxExpression(node) {
            if (node.expression && isCommaSequence(node.expression)) return grammarErrorOnNode(node.expression, Diagnostics.JSX_expressions_may_not_use_the_comma_operator_Did_you_mean_to_write_an_array);
        }
        function checkGrammarForInOrForOfStatement(forInOrOfStatement) {
            if (checkGrammarStatementInAmbientContext(forInOrOfStatement)) return true;
            if (forInOrOfStatement.kind === 249 /* ForOfStatement */  && forInOrOfStatement.awaitModifier) {
                if (!(forInOrOfStatement.flags & 32768 /* AwaitContext */ )) {
                    const sourceFile = getSourceFileOfNode(forInOrOfStatement);
                    if (isInTopLevelContext(forInOrOfStatement)) {
                        if (!hasParseDiagnostics(sourceFile)) {
                            if (!isEffectiveExternalModule(sourceFile, compilerOptions)) diagnostics.add(createDiagnosticForNode(forInOrOfStatement.awaitModifier, Diagnostics.for_await_loops_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module));
                            switch(moduleKind){
                                case 100 /* Node16 */ :
                                case 199 /* NodeNext */ :
                                    if (sourceFile.impliedNodeFormat === 1 /* CommonJS */ ) {
                                        diagnostics.add(createDiagnosticForNode(forInOrOfStatement.awaitModifier, Diagnostics.The_current_file_is_a_CommonJS_module_and_cannot_use_await_at_the_top_level));
                                        break;
                                    }
                                case 7 /* ES2022 */ :
                                case 99 /* ESNext */ :
                                case 4 /* System */ :
                                    if (languageVersion >= 4 /* ES2017 */ ) break;
                                default:
                                    diagnostics.add(createDiagnosticForNode(forInOrOfStatement.awaitModifier, Diagnostics.Top_level_for_await_loops_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_or_nodenext_and_the_target_option_is_set_to_es2017_or_higher));
                                    break;
                            }
                        }
                    } else if (!hasParseDiagnostics(sourceFile)) {
                        const diagnostic = createDiagnosticForNode(forInOrOfStatement.awaitModifier, Diagnostics.for_await_loops_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules);
                        const func = getContainingFunction(forInOrOfStatement);
                        if (func && func.kind !== 175 /* Constructor */ ) {
                            Debug.assert((getFunctionFlags(func) & 2 /* Async */ ) === 0, "Enclosing function should never be an async function.");
                            const relatedInfo = createDiagnosticForNode(func, Diagnostics.Did_you_mean_to_mark_this_function_as_async);
                            addRelatedInfo(diagnostic, relatedInfo);
                        }
                        diagnostics.add(diagnostic);
                        return true;
                    }
                    return false;
                }
            }
            if (isForOfStatement(forInOrOfStatement) && !(forInOrOfStatement.flags & 32768 /* AwaitContext */ ) && isIdentifier(forInOrOfStatement.initializer) && forInOrOfStatement.initializer.escapedText === "async") {
                grammarErrorOnNode(forInOrOfStatement.initializer, Diagnostics.The_left_hand_side_of_a_for_of_statement_may_not_be_async);
                return false;
            }
            if (forInOrOfStatement.initializer.kind === 260 /* VariableDeclarationList */ ) {
                const variableList = forInOrOfStatement.initializer;
                if (!checkGrammarVariableDeclarationList(variableList)) {
                    const declarations = variableList.declarations;
                    if (!declarations.length) return false;
                    if (declarations.length > 1) {
                        const diagnostic = forInOrOfStatement.kind === 248 /* ForInStatement */  ? Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement : Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement;
                        return grammarErrorOnFirstToken(variableList.declarations[1], diagnostic);
                    }
                    const firstDeclaration = declarations[0];
                    if (firstDeclaration.initializer) {
                        const diagnostic = forInOrOfStatement.kind === 248 /* ForInStatement */  ? Diagnostics.The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer : Diagnostics.The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer;
                        return grammarErrorOnNode(firstDeclaration.name, diagnostic);
                    }
                    if (firstDeclaration.type) {
                        const diagnostic = forInOrOfStatement.kind === 248 /* ForInStatement */  ? Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation : Diagnostics.The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation;
                        return grammarErrorOnNode(firstDeclaration, diagnostic);
                    }
                }
            }
            return false;
        }
        function checkGrammarAccessor(accessor) {
            if (!(accessor.flags & 16777216 /* Ambient */ ) && accessor.parent.kind !== 186 /* TypeLiteral */  && accessor.parent.kind !== 263 /* InterfaceDeclaration */ ) {
                if (languageVersion < 1 /* ES5 */ ) return grammarErrorOnNode(accessor.name, Diagnostics.Accessors_are_only_available_when_targeting_ECMAScript_5_and_higher);
                if (languageVersion < 2 /* ES2015 */  && isPrivateIdentifier(accessor.name)) return grammarErrorOnNode(accessor.name, Diagnostics.Private_identifiers_are_only_available_when_targeting_ECMAScript_2015_and_higher);
                if (accessor.body === void 0 && !hasSyntacticModifier(accessor, 256 /* Abstract */ )) return grammarErrorAtPos(accessor, accessor.end - 1, 1, Diagnostics._0_expected, "{");
            }
            if (accessor.body) {
                if (hasSyntacticModifier(accessor, 256 /* Abstract */ )) return grammarErrorOnNode(accessor, Diagnostics.An_abstract_accessor_cannot_have_an_implementation);
                if (accessor.parent.kind === 186 /* TypeLiteral */  || accessor.parent.kind === 263 /* InterfaceDeclaration */ ) return grammarErrorOnNode(accessor.body, Diagnostics.An_implementation_cannot_be_declared_in_ambient_contexts);
            }
            if (accessor.typeParameters) return grammarErrorOnNode(accessor.name, Diagnostics.An_accessor_cannot_have_type_parameters);
            if (!doesAccessorHaveCorrectParameterCount(accessor)) return grammarErrorOnNode(accessor.name, accessor.kind === 176 /* GetAccessor */  ? Diagnostics.A_get_accessor_cannot_have_parameters : Diagnostics.A_set_accessor_must_have_exactly_one_parameter);
            if (accessor.kind === 177 /* SetAccessor */ ) {
                if (accessor.type) return grammarErrorOnNode(accessor.name, Diagnostics.A_set_accessor_cannot_have_a_return_type_annotation);
                const parameter = Debug.checkDefined(getSetAccessorValueParameter(accessor), "Return value does not match parameter count assertion.");
                if (parameter.dotDotDotToken) return grammarErrorOnNode(parameter.dotDotDotToken, Diagnostics.A_set_accessor_cannot_have_rest_parameter);
                if (parameter.questionToken) return grammarErrorOnNode(parameter.questionToken, Diagnostics.A_set_accessor_cannot_have_an_optional_parameter);
                if (parameter.initializer) return grammarErrorOnNode(accessor.name, Diagnostics.A_set_accessor_parameter_cannot_have_an_initializer);
            }
            return false;
        }
        function doesAccessorHaveCorrectParameterCount(accessor) {
            return getAccessorThisParameter(accessor) || accessor.parameters.length === (accessor.kind === 176 /* GetAccessor */  ? 0 : 1);
        }
        function getAccessorThisParameter(accessor) {
            if (accessor.parameters.length === (accessor.kind === 176 /* GetAccessor */  ? 1 : 2)) return getThisParameter(accessor);
        }
        function checkGrammarTypeOperatorNode(node) {
            if (node.operator === 158 /* UniqueKeyword */ ) {
                if (node.type.kind !== 155 /* SymbolKeyword */ ) return grammarErrorOnNode(node.type, Diagnostics._0_expected, tokenToString(155 /* SymbolKeyword */ ));
                let parent2 = walkUpParenthesizedTypes(node.parent);
                if (isInJSFile(parent2) && isJSDocTypeExpression(parent2)) {
                    const host2 = getJSDocHost(parent2);
                    if (host2) parent2 = getSingleVariableOfVariableStatement(host2) || host2;
                }
                switch(parent2.kind){
                    case 259 /* VariableDeclaration */ :
                        const decl = parent2;
                        if (decl.name.kind !== 80 /* Identifier */ ) return grammarErrorOnNode(node, Diagnostics.unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name);
                        if (!isVariableDeclarationInVariableStatement(decl)) return grammarErrorOnNode(node, Diagnostics.unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement);
                        if (!(decl.parent.flags & 2 /* Const */ )) return grammarErrorOnNode(parent2.name, Diagnostics.A_variable_whose_type_is_a_unique_symbol_type_must_be_const);
                        break;
                    case 171 /* PropertyDeclaration */ :
                        if (!isStatic(parent2) || !hasEffectiveReadonlyModifier(parent2)) return grammarErrorOnNode(parent2.name, Diagnostics.A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly);
                        break;
                    case 170 /* PropertySignature */ :
                        if (!hasSyntacticModifier(parent2, 64 /* Readonly */ )) return grammarErrorOnNode(parent2.name, Diagnostics.A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly);
                        break;
                    default:
                        return grammarErrorOnNode(node, Diagnostics.unique_symbol_types_are_not_allowed_here);
                }
            } else if (node.operator === 148 /* ReadonlyKeyword */ ) {
                if (node.type.kind !== 187 /* ArrayType */  && node.type.kind !== 188 /* TupleType */ ) return grammarErrorOnFirstToken(node, Diagnostics.readonly_type_modifier_is_only_permitted_on_array_and_tuple_literal_types, tokenToString(155 /* SymbolKeyword */ ));
            }
        }
        function checkGrammarForInvalidDynamicName(node, message) {
            if (isNonBindableDynamicName(node)) return grammarErrorOnNode(node, message);
        }
        function checkGrammarMethod(node) {
            if (checkGrammarFunctionLikeDeclaration(node)) return true;
            if (node.kind === 173 /* MethodDeclaration */ ) {
                if (node.parent.kind === 209 /* ObjectLiteralExpression */ ) {
                    if (node.modifiers && !(node.modifiers.length === 1 && first(node.modifiers).kind === 134 /* AsyncKeyword */ )) return grammarErrorOnFirstToken(node, Diagnostics.Modifiers_cannot_appear_here);
                    else if (checkGrammarForInvalidQuestionMark(node.questionToken, Diagnostics.An_object_member_cannot_be_declared_optional)) return true;
                    else if (checkGrammarForInvalidExclamationToken(node.exclamationToken, Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context)) return true;
                    else if (node.body === void 0) return grammarErrorAtPos(node, node.end - 1, 1, Diagnostics._0_expected, "{");
                }
                if (checkGrammarForGenerator(node)) return true;
            }
            if (isClassLike(node.parent)) {
                if (languageVersion < 2 /* ES2015 */  && isPrivateIdentifier(node.name)) return grammarErrorOnNode(node.name, Diagnostics.Private_identifiers_are_only_available_when_targeting_ECMAScript_2015_and_higher);
                if (node.flags & 16777216 /* Ambient */ ) return checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
                else if (node.kind === 173 /* MethodDeclaration */  && !node.body) return checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
            } else if (node.parent.kind === 263 /* InterfaceDeclaration */ ) return checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
            else if (node.parent.kind === 186 /* TypeLiteral */ ) return checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
        }
        function checkGrammarBreakOrContinueStatement(node) {
            let current = node;
            while(current){
                if (isFunctionLikeOrClassStaticBlockDeclaration(current)) return grammarErrorOnNode(node, Diagnostics.Jump_target_cannot_cross_function_boundary);
                switch(current.kind){
                    case 255 /* LabeledStatement */ :
                        if (node.label && current.label.escapedText === node.label.escapedText) {
                            const isMisplacedContinueLabel = node.kind === 250 /* ContinueStatement */  && !isIterationStatement(current.statement, /*lookInLabeledStatements*/ true);
                            if (isMisplacedContinueLabel) return grammarErrorOnNode(node, Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement);
                            return false;
                        }
                        break;
                    case 254 /* SwitchStatement */ :
                        if (node.kind === 251 /* BreakStatement */  && !node.label) return false;
                        break;
                    default:
                        if (isIterationStatement(current, /*lookInLabeledStatements*/ false) && !node.label) return false;
                        break;
                }
                current = current.parent;
            }
            if (node.label) {
                const message = node.kind === 251 /* BreakStatement */  ? Diagnostics.A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement : Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement;
                return grammarErrorOnNode(node, message);
            } else {
                const message = node.kind === 251 /* BreakStatement */  ? Diagnostics.A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement : Diagnostics.A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement;
                return grammarErrorOnNode(node, message);
            }
        }
        function checkGrammarBindingElement(node) {
            if (node.dotDotDotToken) {
                const elements = node.parent.elements;
                if (node !== last(elements)) return grammarErrorOnNode(node, Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern);
                checkGrammarForDisallowedTrailingComma(elements, Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
                if (node.propertyName) return grammarErrorOnNode(node.name, Diagnostics.A_rest_element_cannot_have_a_property_name);
            }
            if (node.dotDotDotToken && node.initializer) return grammarErrorAtPos(node, node.initializer.pos - 1, 1, Diagnostics.A_rest_element_cannot_have_an_initializer);
        }
        function isStringOrNumberLiteralExpression(expr) {
            return isStringOrNumericLiteralLike(expr) || expr.kind === 223 /* PrefixUnaryExpression */  && expr.operator === 41 /* MinusToken */  && expr.operand.kind === 9 /* NumericLiteral */ ;
        }
        function isBigIntLiteralExpression(expr) {
            return expr.kind === 10 /* BigIntLiteral */  || expr.kind === 223 /* PrefixUnaryExpression */  && expr.operator === 41 /* MinusToken */  && expr.operand.kind === 10 /* BigIntLiteral */ ;
        }
        function isSimpleLiteralEnumReference(expr) {
            if ((isPropertyAccessExpression(expr) || isElementAccessExpression(expr) && isStringOrNumberLiteralExpression(expr.argumentExpression)) && isEntityNameExpression(expr.expression)) return !!(checkExpressionCached(expr).flags & 1056 /* EnumLike */ );
        }
        function checkAmbientInitializer(node) {
            const initializer = node.initializer;
            if (initializer) {
                const isInvalidInitializer = !(isStringOrNumberLiteralExpression(initializer) || isSimpleLiteralEnumReference(initializer) || initializer.kind === 112 /* TrueKeyword */  || initializer.kind === 97 /* FalseKeyword */  || isBigIntLiteralExpression(initializer));
                const isConstOrReadonly = isDeclarationReadonly(node) || isVariableDeclaration(node) && isVarConst(node);
                if (isConstOrReadonly && !node.type) {
                    if (isInvalidInitializer) return grammarErrorOnNode(initializer, Diagnostics.A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal_or_literal_enum_reference);
                } else return grammarErrorOnNode(initializer, Diagnostics.Initializers_are_not_allowed_in_ambient_contexts);
            }
        }
        function checkGrammarVariableDeclaration(node) {
            if (node.parent.parent.kind !== 248 /* ForInStatement */  && node.parent.parent.kind !== 249 /* ForOfStatement */ ) {
                if (node.flags & 16777216 /* Ambient */ ) checkAmbientInitializer(node);
                else if (!node.initializer) {
                    if (isBindingPattern(node.name) && !isBindingPattern(node.parent)) return grammarErrorOnNode(node, Diagnostics.A_destructuring_declaration_must_have_an_initializer);
                    if (isVarConst(node)) return grammarErrorOnNode(node, Diagnostics.const_declarations_must_be_initialized);
                }
            }
            if (node.exclamationToken && (node.parent.parent.kind !== 242 /* VariableStatement */  || !node.type || node.initializer || node.flags & 16777216 /* Ambient */ )) {
                const message = node.initializer ? Diagnostics.Declarations_with_initializers_cannot_also_have_definite_assignment_assertions : !node.type ? Diagnostics.Declarations_with_definite_assignment_assertions_must_also_have_type_annotations : Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context;
                return grammarErrorOnNode(node.exclamationToken, message);
            }
            if ((moduleKind < 5 /* ES2015 */  || getSourceFileOfNode(node).impliedNodeFormat === 1 /* CommonJS */ ) && moduleKind !== 4 /* System */  && !(node.parent.parent.flags & 16777216 /* Ambient */ ) && hasSyntacticModifier(node.parent.parent, 1 /* Export */ )) checkESModuleMarker(node.name);
            const checkLetConstNames = isLet(node) || isVarConst(node);
            return checkLetConstNames && checkGrammarNameInLetOrConstDeclarations(node.name);
        }
        function checkESModuleMarker(name) {
            if (name.kind === 80 /* Identifier */ ) {
                if (idText(name) === "__esModule") return grammarErrorOnNodeSkippedOn("noEmit", name, Diagnostics.Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules);
            } else {
                const elements = name.elements;
                for (const element of elements){
                    if (!isOmittedExpression(element)) return checkESModuleMarker(element.name);
                }
            }
            return false;
        }
        function checkGrammarNameInLetOrConstDeclarations(name) {
            if (name.kind === 80 /* Identifier */ ) {
                if (name.escapedText === "let") return grammarErrorOnNode(name, Diagnostics.let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations);
            } else {
                const elements = name.elements;
                for (const element of elements)if (!isOmittedExpression(element)) checkGrammarNameInLetOrConstDeclarations(element.name);
            }
            return false;
        }
        function checkGrammarVariableDeclarationList(declarationList) {
            const declarations = declarationList.declarations;
            if (checkGrammarForDisallowedTrailingComma(declarationList.declarations)) return true;
            if (!declarationList.declarations.length) return grammarErrorAtPos(declarationList, declarations.pos, declarations.end - declarations.pos, Diagnostics.Variable_declaration_list_cannot_be_empty);
            return false;
        }
        function allowLetAndConstDeclarations(parent2) {
            switch(parent2.kind){
                case 244 /* IfStatement */ :
                case 245 /* DoStatement */ :
                case 246 /* WhileStatement */ :
                case 253 /* WithStatement */ :
                case 247 /* ForStatement */ :
                case 248 /* ForInStatement */ :
                case 249 /* ForOfStatement */ :
                    return false;
                case 255 /* LabeledStatement */ :
                    return allowLetAndConstDeclarations(parent2.parent);
            }
            return true;
        }
        function checkGrammarForDisallowedLetOrConstStatement(node) {
            if (!allowLetAndConstDeclarations(node.parent)) {
                if (isLet(node.declarationList)) return grammarErrorOnNode(node, Diagnostics.let_declarations_can_only_be_declared_inside_a_block);
                else if (isVarConst(node.declarationList)) return grammarErrorOnNode(node, Diagnostics.const_declarations_can_only_be_declared_inside_a_block);
            }
        }
        function checkGrammarMetaProperty(node) {
            const escapedText = node.name.escapedText;
            switch(node.keywordToken){
                case 105 /* NewKeyword */ :
                    if (escapedText !== "target") return grammarErrorOnNode(node.name, Diagnostics._0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2, unescapeLeadingUnderscores(node.name.escapedText), tokenToString(node.keywordToken), "target");
                    break;
                case 102 /* ImportKeyword */ :
                    if (escapedText !== "meta") return grammarErrorOnNode(node.name, Diagnostics._0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2, unescapeLeadingUnderscores(node.name.escapedText), tokenToString(node.keywordToken), "meta");
                    break;
            }
        }
        function hasParseDiagnostics(sourceFile) {
            return sourceFile.parseDiagnostics.length > 0;
        }
        function grammarErrorOnFirstToken(node, message, ...args) {
            const sourceFile = getSourceFileOfNode(node);
            if (!hasParseDiagnostics(sourceFile)) {
                const span = getSpanOfTokenAtPosition(sourceFile, node.pos);
                diagnostics.add(createFileDiagnostic(sourceFile, span.start, span.length, message, ...args));
                return true;
            }
            return false;
        }
        function grammarErrorAtPos(nodeForSourceFile, start, length2, message, ...args) {
            const sourceFile = getSourceFileOfNode(nodeForSourceFile);
            if (!hasParseDiagnostics(sourceFile)) {
                diagnostics.add(createFileDiagnostic(sourceFile, start, length2, message, ...args));
                return true;
            }
            return false;
        }
        function grammarErrorOnNodeSkippedOn(key, node, message, ...args) {
            const sourceFile = getSourceFileOfNode(node);
            if (!hasParseDiagnostics(sourceFile)) {
                errorSkippedOn(key, node, message, ...args);
                return true;
            }
            return false;
        }
        function grammarErrorOnNode(node, message, ...args) {
            const sourceFile = getSourceFileOfNode(node);
            if (!hasParseDiagnostics(sourceFile)) {
                diagnostics.add(createDiagnosticForNode(node, message, ...args));
                return true;
            }
            return false;
        }
        function checkGrammarConstructorTypeParameters(node) {
            const jsdocTypeParameters = isInJSFile(node) ? getJSDocTypeParameterDeclarations(node) : void 0;
            const range = node.typeParameters || jsdocTypeParameters && firstOrUndefined(jsdocTypeParameters);
            if (range) {
                const pos = range.pos === range.end ? range.pos : skipTrivia(getSourceFileOfNode(node).text, range.pos);
                return grammarErrorAtPos(node, pos, range.end - pos, Diagnostics.Type_parameters_cannot_appear_on_a_constructor_declaration);
            }
        }
        function checkGrammarConstructorTypeAnnotation(node) {
            const type = node.type || getEffectiveReturnTypeNode(node);
            if (type) return grammarErrorOnNode(type, Diagnostics.Type_annotation_cannot_appear_on_a_constructor_declaration);
        }
        function checkGrammarProperty(node) {
            if (isComputedPropertyName(node.name) && isBinaryExpression(node.name.expression) && node.name.expression.operatorToken.kind === 103 /* InKeyword */ ) return grammarErrorOnNode(node.parent.members[0], Diagnostics.A_mapped_type_may_not_declare_properties_or_methods);
            if (isClassLike(node.parent)) {
                if (isStringLiteral(node.name) && node.name.text === "constructor") return grammarErrorOnNode(node.name, Diagnostics.Classes_may_not_have_a_field_named_constructor);
                if (checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_a_class_property_declaration_must_have_a_simple_literal_type_or_a_unique_symbol_type)) return true;
                if (languageVersion < 2 /* ES2015 */  && isPrivateIdentifier(node.name)) return grammarErrorOnNode(node.name, Diagnostics.Private_identifiers_are_only_available_when_targeting_ECMAScript_2015_and_higher);
                if (languageVersion < 2 /* ES2015 */  && isAutoAccessorPropertyDeclaration(node)) return grammarErrorOnNode(node.name, Diagnostics.Properties_with_the_accessor_modifier_are_only_available_when_targeting_ECMAScript_2015_and_higher);
                if (isAutoAccessorPropertyDeclaration(node) && checkGrammarForInvalidQuestionMark(node.questionToken, Diagnostics.An_accessor_property_cannot_be_declared_optional)) return true;
            } else if (node.parent.kind === 263 /* InterfaceDeclaration */ ) {
                if (checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type)) return true;
                Debug.assertNode(node, isPropertySignature);
                if (node.initializer) return grammarErrorOnNode(node.initializer, Diagnostics.An_interface_property_cannot_have_an_initializer);
            } else if (isTypeLiteralNode(node.parent)) {
                if (checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type)) return true;
                Debug.assertNode(node, isPropertySignature);
                if (node.initializer) return grammarErrorOnNode(node.initializer, Diagnostics.A_type_literal_property_cannot_have_an_initializer);
            }
            if (node.flags & 16777216 /* Ambient */ ) checkAmbientInitializer(node);
            if (isPropertyDeclaration(node) && node.exclamationToken && (!isClassLike(node.parent) || !node.type || node.initializer || node.flags & 16777216 /* Ambient */  || isStatic(node) || hasAbstractModifier(node))) {
                const message = node.initializer ? Diagnostics.Declarations_with_initializers_cannot_also_have_definite_assignment_assertions : !node.type ? Diagnostics.Declarations_with_definite_assignment_assertions_must_also_have_type_annotations : Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context;
                return grammarErrorOnNode(node.exclamationToken, message);
            }
        }
        function checkGrammarTopLevelElementForRequiredDeclareModifier(node) {
            if (node.kind === 263 /* InterfaceDeclaration */  || node.kind === 264 /* TypeAliasDeclaration */  || node.kind === 271 /* ImportDeclaration */  || node.kind === 270 /* ImportEqualsDeclaration */  || node.kind === 277 /* ExportDeclaration */  || node.kind === 276 /* ExportAssignment */  || node.kind === 269 /* NamespaceExportDeclaration */  || hasSyntacticModifier(node, 1027 /* Default */ )) return false;
            return grammarErrorOnFirstToken(node, Diagnostics.Top_level_declarations_in_d_ts_files_must_start_with_either_a_declare_or_export_modifier);
        }
        function checkGrammarTopLevelElementsForRequiredDeclareModifier(file) {
            for (const decl of file.statements)if (isDeclaration(decl) || decl.kind === 242 /* VariableStatement */ ) {
                if (checkGrammarTopLevelElementForRequiredDeclareModifier(decl)) return true;
            }
            return false;
        }
        function checkGrammarSourceFile(node) {
            return !!(node.flags & 16777216 /* Ambient */ ) && checkGrammarTopLevelElementsForRequiredDeclareModifier(node);
        }
        function checkGrammarStatementInAmbientContext(node) {
            if (node.flags & 16777216 /* Ambient */ ) {
                const links = getNodeLinks(node);
                if (!links.hasReportedStatementInAmbientContext && (isFunctionLike(node.parent) || isAccessor(node.parent))) return getNodeLinks(node).hasReportedStatementInAmbientContext = grammarErrorOnFirstToken(node, Diagnostics.An_implementation_cannot_be_declared_in_ambient_contexts);
                if (node.parent.kind === 240 /* Block */  || node.parent.kind === 267 /* ModuleBlock */  || node.parent.kind === 311 /* SourceFile */ ) {
                    const links2 = getNodeLinks(node.parent);
                    if (!links2.hasReportedStatementInAmbientContext) return links2.hasReportedStatementInAmbientContext = grammarErrorOnFirstToken(node, Diagnostics.Statements_are_not_allowed_in_ambient_contexts);
                }
            }
            return false;
        }
        function checkGrammarNumericLiteral(node) {
            const isFractional = getTextOfNode(node).indexOf(".") !== -1;
            const isScientific = node.numericLiteralFlags & 16 /* Scientific */ ;
            if (isFractional || isScientific) return;
            const value1 = +node.text;
            if (value1 <= 2 ** 53 - 1) return;
            addErrorOrSuggestion(/*isError*/ false, createDiagnosticForNode(node, Diagnostics.Numeric_literals_with_absolute_values_equal_to_2_53_or_greater_are_too_large_to_be_represented_accurately_as_integers));
        }
        function checkGrammarBigIntLiteral(node) {
            const literalType = isLiteralTypeNode(node.parent) || isPrefixUnaryExpression(node.parent) && isLiteralTypeNode(node.parent.parent);
            if (!literalType) {
                if (languageVersion < 7 /* ES2020 */ ) {
                    if (grammarErrorOnNode(node, Diagnostics.BigInt_literals_are_not_available_when_targeting_lower_than_ES2020)) return true;
                }
            }
            return false;
        }
        function grammarErrorAfterFirstToken(node, message, ...args) {
            const sourceFile = getSourceFileOfNode(node);
            if (!hasParseDiagnostics(sourceFile)) {
                const span = getSpanOfTokenAtPosition(sourceFile, node.pos);
                diagnostics.add(createFileDiagnostic(sourceFile, textSpanEnd(span), /*length*/ 0, message, ...args));
                return true;
            }
            return false;
        }
        function getAmbientModules() {
            if (!ambientModulesCache) {
                ambientModulesCache = [];
                globals.forEach((global2, sym)=>{
                    if (ambientModuleSymbolRegex.test(sym)) ambientModulesCache.push(global2);
                });
            }
            return ambientModulesCache;
        }
        function checkGrammarImportClause(node) {
            var _a;
            if (node.isTypeOnly && node.name && node.namedBindings) return grammarErrorOnNode(node, Diagnostics.A_type_only_import_can_specify_a_default_import_or_named_bindings_but_not_both);
            if (node.isTypeOnly && ((_a = node.namedBindings) == null ? void 0 : _a.kind) === 274 /* NamedImports */ ) return checkGrammarNamedImportsOrExports(node.namedBindings);
            return false;
        }
        function checkGrammarNamedImportsOrExports(namedBindings) {
            return !!forEach(namedBindings.elements, (specifier)=>{
                if (specifier.isTypeOnly) return grammarErrorOnFirstToken(specifier, specifier.kind === 275 /* ImportSpecifier */  ? Diagnostics.The_type_modifier_cannot_be_used_on_a_named_import_when_import_type_is_used_on_its_import_statement : Diagnostics.The_type_modifier_cannot_be_used_on_a_named_export_when_export_type_is_used_on_its_export_statement);
            });
        }
        function checkGrammarImportCallExpression(node) {
            if (compilerOptions.verbatimModuleSyntax && moduleKind === 1 /* CommonJS */ ) return grammarErrorOnNode(node, Diagnostics.ESM_syntax_is_not_allowed_in_a_CommonJS_module_when_verbatimModuleSyntax_is_enabled);
            if (moduleKind === 5 /* ES2015 */ ) return grammarErrorOnNode(node, Diagnostics.Dynamic_imports_are_only_supported_when_the_module_flag_is_set_to_es2020_es2022_esnext_commonjs_amd_system_umd_node16_or_nodenext);
            if (node.typeArguments) return grammarErrorOnNode(node, Diagnostics.This_use_of_import_is_invalid_import_calls_can_be_written_but_they_must_have_parentheses_and_cannot_have_type_arguments);
            const nodeArguments = node.arguments;
            if (moduleKind !== 99 /* ESNext */  && moduleKind !== 199 /* NodeNext */  && moduleKind !== 100 /* Node16 */ ) {
                checkGrammarForDisallowedTrailingComma(nodeArguments);
                if (nodeArguments.length > 1) {
                    const assertionArgument = nodeArguments[1];
                    return grammarErrorOnNode(assertionArgument, Diagnostics.Dynamic_imports_only_support_a_second_argument_when_the_module_option_is_set_to_esnext_node16_or_nodenext);
                }
            }
            if (nodeArguments.length === 0 || nodeArguments.length > 2) return grammarErrorOnNode(node, Diagnostics.Dynamic_imports_can_only_accept_a_module_specifier_and_an_optional_assertion_as_arguments);
            const spreadElement = find(nodeArguments, isSpreadElement);
            if (spreadElement) return grammarErrorOnNode(spreadElement, Diagnostics.Argument_of_dynamic_import_cannot_be_spread_element);
            return false;
        }
        function findMatchingTypeReferenceOrTypeAliasReference(source, unionTarget) {
            const sourceObjectFlags = getObjectFlags(source);
            if (sourceObjectFlags & 20 /* Anonymous */  && unionTarget.flags & 1048576 /* Union */ ) return find(unionTarget.types, (target)=>{
                if (target.flags & 524288 /* Object */ ) {
                    const overlapObjFlags = sourceObjectFlags & getObjectFlags(target);
                    if (overlapObjFlags & 4 /* Reference */ ) return source.target === target.target;
                    if (overlapObjFlags & 16 /* Anonymous */ ) return !!source.aliasSymbol && source.aliasSymbol === target.aliasSymbol;
                }
                return false;
            });
        }
        function findBestTypeForObjectLiteral(source, unionTarget) {
            if (getObjectFlags(source) & 128 /* ObjectLiteral */  && someType(unionTarget, isArrayLikeType)) return find(unionTarget.types, (t)=>!isArrayLikeType(t));
        }
        function findBestTypeForInvokable(source, unionTarget) {
            let signatureKind = 0 /* Call */ ;
            const hasSignatures = getSignaturesOfType(source, signatureKind).length > 0 || (signatureKind = 1 /* Construct */ , getSignaturesOfType(source, signatureKind).length > 0);
            if (hasSignatures) return find(unionTarget.types, (t)=>getSignaturesOfType(t, signatureKind).length > 0);
        }
        function findMostOverlappyType(source, unionTarget) {
            let bestMatch;
            if (!(source.flags & 406978556 /* InstantiablePrimitive */ )) {
                let matchingCount = 0;
                for (const target of unionTarget.types)if (!(target.flags & 406978556 /* InstantiablePrimitive */ )) {
                    const overlap = getIntersectionType([
                        getIndexType(source),
                        getIndexType(target)
                    ]);
                    if (overlap.flags & 4194304 /* Index */ ) return target;
                    else if (isUnitType(overlap) || overlap.flags & 1048576 /* Union */ ) {
                        const len = overlap.flags & 1048576 /* Union */  ? countWhere(overlap.types, isUnitType) : 1;
                        if (len >= matchingCount) {
                            bestMatch = target;
                            matchingCount = len;
                        }
                    }
                }
            }
            return bestMatch;
        }
        function filterPrimitivesIfContainsNonPrimitive(type) {
            if (maybeTypeOfKind(type, 67108864 /* NonPrimitive */ )) {
                const result = filterType(type, (t)=>!(t.flags & 402784252 /* Primitive */ ));
                if (!(result.flags & 131072 /* Never */ )) return result;
            }
            return type;
        }
        function findMatchingDiscriminantType(source, target, isRelatedTo) {
            if (target.flags & 1048576 /* Union */  && source.flags & 2621440 /* Object */ ) {
                const match = getMatchingUnionConstituentForType(target, source);
                if (match) return match;
                const sourceProperties = getPropertiesOfType(source);
                if (sourceProperties) {
                    const sourcePropertiesFiltered = findDiscriminantProperties(sourceProperties, target);
                    if (sourcePropertiesFiltered) {
                        const discriminated = discriminateTypeByDiscriminableItems(target, map(sourcePropertiesFiltered, (p)=>[
                                ()=>getTypeOfSymbol(p),
                                p.escapedName
                            ]), isRelatedTo);
                        if (discriminated !== target) return discriminated;
                    }
                }
            }
            return void 0;
        }
        function getEffectivePropertyNameForPropertyNameNode(node) {
            const name = getPropertyNameForPropertyNameNode(node);
            return name ? name : isComputedPropertyName(node) && isEntityNameExpression(node.expression) ? tryGetNameFromEntityNameExpression(node.expression) : void 0;
        }
    }
    function isNotAccessor(declaration) {
        return !isAccessor(declaration);
    }
    function isNotOverload(declaration) {
        return declaration.kind !== 261 /* FunctionDeclaration */  && declaration.kind !== 173 /* MethodDeclaration */  || !!declaration.body;
    }
    function isDeclarationNameOrImportPropertyName(name) {
        switch(name.parent.kind){
            case 275 /* ImportSpecifier */ :
            case 280 /* ExportSpecifier */ :
                return isIdentifier(name);
            default:
                return isDeclarationName(name);
        }
    }
    function getIterationTypesKeyFromIterationTypeKind(typeKind) {
        switch(typeKind){
            case 0 /* Yield */ :
                return "yieldType";
            case 1 /* Return */ :
                return "returnType";
            case 2 /* Next */ :
                return "nextType";
        }
    }
    function signatureHasRestParameter(s) {
        return !!(s.flags & 1 /* HasRestParameter */ );
    }
    function signatureHasLiteralTypes(s) {
        return !!(s.flags & 2 /* HasLiteralTypes */ );
    }
    function createBasicNodeBuilderModuleSpecifierResolutionHost(host) {
        return {
            getCommonSourceDirectory: !!host.getCommonSourceDirectory ? ()=>host.getCommonSourceDirectory() : ()=>"",
            getCurrentDirectory: ()=>host.getCurrentDirectory(),
            getSymlinkCache: maybeBind(host, host.getSymlinkCache),
            getPackageJsonInfoCache: ()=>{
                var _a;
                return (_a = host.getPackageJsonInfoCache) == null ? void 0 : _a.call(host);
            },
            useCaseSensitiveFileNames: maybeBind(host, host.useCaseSensitiveFileNames),
            redirectTargetsMap: host.redirectTargetsMap,
            getProjectReferenceRedirect: (fileName)=>host.getProjectReferenceRedirect(fileName),
            isSourceOfProjectReferenceRedirect: (fileName)=>host.isSourceOfProjectReferenceRedirect(fileName),
            fileExists: (fileName)=>host.fileExists(fileName),
            getFileIncludeReasons: ()=>host.getFileIncludeReasons(),
            readFile: host.readFile ? (fileName)=>host.readFile(fileName) : void 0
        };
    }
    var ambientModuleSymbolRegex, anon, nextSymbolId, nextNodeId, nextMergeId, nextFlowId, TypeFacts, typeofNEFacts, CheckMode, SignatureCheckMode, isNotOverloadAndNotAccessor, intrinsicTypeKinds, SymbolLinks, JsxNames, SymbolTrackerImpl;
    var init_checker = __esm({
        "src/compiler/checker.ts" () {
            "use strict";
            init_ts2();
            init_ts_moduleSpecifiers();
            init_ts_performance();
            ambientModuleSymbolRegex = /^".+"$/;
            anon = "(anonymous)";
            nextSymbolId = 1;
            nextNodeId = 1;
            nextMergeId = 1;
            nextFlowId = 1;
            TypeFacts = /* @__PURE__ */ ((TypeFacts3)=>{
                TypeFacts3[TypeFacts3["None"] = 0] = "None";
                TypeFacts3[TypeFacts3["TypeofEQString"] = 1] = "TypeofEQString";
                TypeFacts3[TypeFacts3["TypeofEQNumber"] = 2] = "TypeofEQNumber";
                TypeFacts3[TypeFacts3["TypeofEQBigInt"] = 4] = "TypeofEQBigInt";
                TypeFacts3[TypeFacts3["TypeofEQBoolean"] = 8] = "TypeofEQBoolean";
                TypeFacts3[TypeFacts3["TypeofEQSymbol"] = 16] = "TypeofEQSymbol";
                TypeFacts3[TypeFacts3["TypeofEQObject"] = 32] = "TypeofEQObject";
                TypeFacts3[TypeFacts3["TypeofEQFunction"] = 64] = "TypeofEQFunction";
                TypeFacts3[TypeFacts3["TypeofEQHostObject"] = 128] = "TypeofEQHostObject";
                TypeFacts3[TypeFacts3["TypeofNEString"] = 256] = "TypeofNEString";
                TypeFacts3[TypeFacts3["TypeofNENumber"] = 512] = "TypeofNENumber";
                TypeFacts3[TypeFacts3["TypeofNEBigInt"] = 1024] = "TypeofNEBigInt";
                TypeFacts3[TypeFacts3["TypeofNEBoolean"] = 2048] = "TypeofNEBoolean";
                TypeFacts3[TypeFacts3["TypeofNESymbol"] = 4096] = "TypeofNESymbol";
                TypeFacts3[TypeFacts3["TypeofNEObject"] = 8192] = "TypeofNEObject";
                TypeFacts3[TypeFacts3["TypeofNEFunction"] = 16384] = "TypeofNEFunction";
                TypeFacts3[TypeFacts3["TypeofNEHostObject"] = 32768] = "TypeofNEHostObject";
                TypeFacts3[TypeFacts3["EQUndefined"] = 65536] = "EQUndefined";
                TypeFacts3[TypeFacts3["EQNull"] = 131072] = "EQNull";
                TypeFacts3[TypeFacts3["EQUndefinedOrNull"] = 262144] = "EQUndefinedOrNull";
                TypeFacts3[TypeFacts3["NEUndefined"] = 524288] = "NEUndefined";
                TypeFacts3[TypeFacts3["NENull"] = 1048576] = "NENull";
                TypeFacts3[TypeFacts3["NEUndefinedOrNull"] = 2097152] = "NEUndefinedOrNull";
                TypeFacts3[TypeFacts3["Truthy"] = 4194304] = "Truthy";
                TypeFacts3[TypeFacts3["Falsy"] = 8388608] = "Falsy";
                TypeFacts3[TypeFacts3["IsUndefined"] = 16777216] = "IsUndefined";
                TypeFacts3[TypeFacts3["IsNull"] = 33554432] = "IsNull";
                TypeFacts3[TypeFacts3["IsUndefinedOrNull"] = 50331648] = "IsUndefinedOrNull";
                TypeFacts3[TypeFacts3["All"] = 134217727] = "All";
                TypeFacts3[TypeFacts3["BaseStringStrictFacts"] = 3735041] = "BaseStringStrictFacts";
                TypeFacts3[TypeFacts3["BaseStringFacts"] = 12582401] = "BaseStringFacts";
                TypeFacts3[TypeFacts3["StringStrictFacts"] = 16317953] = "StringStrictFacts";
                TypeFacts3[TypeFacts3["StringFacts"] = 16776705] = "StringFacts";
                TypeFacts3[TypeFacts3["EmptyStringStrictFacts"] = 12123649] = "EmptyStringStrictFacts";
                TypeFacts3[TypeFacts3["EmptyStringFacts"] = 12582401 /* BaseStringFacts */ ] = "EmptyStringFacts";
                TypeFacts3[TypeFacts3["NonEmptyStringStrictFacts"] = 7929345] = "NonEmptyStringStrictFacts";
                TypeFacts3[TypeFacts3["NonEmptyStringFacts"] = 16776705] = "NonEmptyStringFacts";
                TypeFacts3[TypeFacts3["BaseNumberStrictFacts"] = 3734786] = "BaseNumberStrictFacts";
                TypeFacts3[TypeFacts3["BaseNumberFacts"] = 12582146] = "BaseNumberFacts";
                TypeFacts3[TypeFacts3["NumberStrictFacts"] = 16317698] = "NumberStrictFacts";
                TypeFacts3[TypeFacts3["NumberFacts"] = 16776450] = "NumberFacts";
                TypeFacts3[TypeFacts3["ZeroNumberStrictFacts"] = 12123394] = "ZeroNumberStrictFacts";
                TypeFacts3[TypeFacts3["ZeroNumberFacts"] = 12582146 /* BaseNumberFacts */ ] = "ZeroNumberFacts";
                TypeFacts3[TypeFacts3["NonZeroNumberStrictFacts"] = 7929090] = "NonZeroNumberStrictFacts";
                TypeFacts3[TypeFacts3["NonZeroNumberFacts"] = 16776450] = "NonZeroNumberFacts";
                TypeFacts3[TypeFacts3["BaseBigIntStrictFacts"] = 3734276] = "BaseBigIntStrictFacts";
                TypeFacts3[TypeFacts3["BaseBigIntFacts"] = 12581636] = "BaseBigIntFacts";
                TypeFacts3[TypeFacts3["BigIntStrictFacts"] = 16317188] = "BigIntStrictFacts";
                TypeFacts3[TypeFacts3["BigIntFacts"] = 16775940] = "BigIntFacts";
                TypeFacts3[TypeFacts3["ZeroBigIntStrictFacts"] = 12122884] = "ZeroBigIntStrictFacts";
                TypeFacts3[TypeFacts3["ZeroBigIntFacts"] = 12581636 /* BaseBigIntFacts */ ] = "ZeroBigIntFacts";
                TypeFacts3[TypeFacts3["NonZeroBigIntStrictFacts"] = 7928580] = "NonZeroBigIntStrictFacts";
                TypeFacts3[TypeFacts3["NonZeroBigIntFacts"] = 16775940] = "NonZeroBigIntFacts";
                TypeFacts3[TypeFacts3["BaseBooleanStrictFacts"] = 3733256] = "BaseBooleanStrictFacts";
                TypeFacts3[TypeFacts3["BaseBooleanFacts"] = 12580616] = "BaseBooleanFacts";
                TypeFacts3[TypeFacts3["BooleanStrictFacts"] = 16316168] = "BooleanStrictFacts";
                TypeFacts3[TypeFacts3["BooleanFacts"] = 16774920] = "BooleanFacts";
                TypeFacts3[TypeFacts3["FalseStrictFacts"] = 12121864] = "FalseStrictFacts";
                TypeFacts3[TypeFacts3["FalseFacts"] = 12580616 /* BaseBooleanFacts */ ] = "FalseFacts";
                TypeFacts3[TypeFacts3["TrueStrictFacts"] = 7927560] = "TrueStrictFacts";
                TypeFacts3[TypeFacts3["TrueFacts"] = 16774920] = "TrueFacts";
                TypeFacts3[TypeFacts3["SymbolStrictFacts"] = 7925520] = "SymbolStrictFacts";
                TypeFacts3[TypeFacts3["SymbolFacts"] = 16772880] = "SymbolFacts";
                TypeFacts3[TypeFacts3["ObjectStrictFacts"] = 7888800] = "ObjectStrictFacts";
                TypeFacts3[TypeFacts3["ObjectFacts"] = 16736160] = "ObjectFacts";
                TypeFacts3[TypeFacts3["FunctionStrictFacts"] = 7880640] = "FunctionStrictFacts";
                TypeFacts3[TypeFacts3["FunctionFacts"] = 16728e3] = "FunctionFacts";
                TypeFacts3[TypeFacts3["VoidFacts"] = 9830144] = "VoidFacts";
                TypeFacts3[TypeFacts3["UndefinedFacts"] = 26607360] = "UndefinedFacts";
                TypeFacts3[TypeFacts3["NullFacts"] = 42917664] = "NullFacts";
                TypeFacts3[TypeFacts3["EmptyObjectStrictFacts"] = 83427327] = "EmptyObjectStrictFacts";
                TypeFacts3[TypeFacts3["EmptyObjectFacts"] = 83886079] = "EmptyObjectFacts";
                TypeFacts3[TypeFacts3["UnknownFacts"] = 83886079] = "UnknownFacts";
                TypeFacts3[TypeFacts3["AllTypeofNE"] = 556800] = "AllTypeofNE";
                TypeFacts3[TypeFacts3["OrFactsMask"] = 8256] = "OrFactsMask";
                TypeFacts3[TypeFacts3["AndFactsMask"] = 134209471] = "AndFactsMask";
                return TypeFacts3;
            })(TypeFacts || {});
            typeofNEFacts = new Map(Object.entries({
                string: 256 /* TypeofNEString */ ,
                number: 512 /* TypeofNENumber */ ,
                bigint: 1024 /* TypeofNEBigInt */ ,
                boolean: 2048 /* TypeofNEBoolean */ ,
                symbol: 4096 /* TypeofNESymbol */ ,
                undefined: 524288 /* NEUndefined */ ,
                object: 8192 /* TypeofNEObject */ ,
                function: 16384 /* TypeofNEFunction */ 
            }));
            CheckMode = /* @__PURE__ */ ((CheckMode3)=>{
                CheckMode3[CheckMode3["Normal"] = 0] = "Normal";
                CheckMode3[CheckMode3["Contextual"] = 1] = "Contextual";
                CheckMode3[CheckMode3["Inferential"] = 2] = "Inferential";
                CheckMode3[CheckMode3["SkipContextSensitive"] = 4] = "SkipContextSensitive";
                CheckMode3[CheckMode3["SkipGenericFunctions"] = 8] = "SkipGenericFunctions";
                CheckMode3[CheckMode3["IsForSignatureHelp"] = 16] = "IsForSignatureHelp";
                CheckMode3[CheckMode3["IsForStringLiteralArgumentCompletions"] = 32] = "IsForStringLiteralArgumentCompletions";
                CheckMode3[CheckMode3["RestBindingElement"] = 64] = "RestBindingElement";
                return CheckMode3;
            })(CheckMode || {});
            SignatureCheckMode = /* @__PURE__ */ ((SignatureCheckMode3)=>{
                SignatureCheckMode3[SignatureCheckMode3["None"] = 0] = "None";
                SignatureCheckMode3[SignatureCheckMode3["BivariantCallback"] = 1] = "BivariantCallback";
                SignatureCheckMode3[SignatureCheckMode3["StrictCallback"] = 2] = "StrictCallback";
                SignatureCheckMode3[SignatureCheckMode3["IgnoreReturnTypes"] = 4] = "IgnoreReturnTypes";
                SignatureCheckMode3[SignatureCheckMode3["StrictArity"] = 8] = "StrictArity";
                SignatureCheckMode3[SignatureCheckMode3["StrictTopSignature"] = 16] = "StrictTopSignature";
                SignatureCheckMode3[SignatureCheckMode3["Callback"] = 3] = "Callback";
                return SignatureCheckMode3;
            })(SignatureCheckMode || {});
            isNotOverloadAndNotAccessor = and(isNotOverload, isNotAccessor);
            intrinsicTypeKinds = new Map(Object.entries({
                Uppercase: 0 /* Uppercase */ ,
                Lowercase: 1 /* Lowercase */ ,
                Capitalize: 2 /* Capitalize */ ,
                Uncapitalize: 3 /* Uncapitalize */ 
            }));
            SymbolLinks = class {
            };
            ((JsxNames2)=>{
                JsxNames2.JSX = "JSX";
                JsxNames2.IntrinsicElements = "IntrinsicElements";
                JsxNames2.ElementClass = "ElementClass";
                JsxNames2.ElementAttributesPropertyNameContainer = "ElementAttributesProperty";
                JsxNames2.ElementChildrenAttributeNameContainer = "ElementChildrenAttribute";
                JsxNames2.Element = "Element";
                JsxNames2.ElementType = "ElementType";
                JsxNames2.IntrinsicAttributes = "IntrinsicAttributes";
                JsxNames2.IntrinsicClassAttributes = "IntrinsicClassAttributes";
                JsxNames2.LibraryManagedAttributes = "LibraryManagedAttributes";
            })(JsxNames || (JsxNames = {}));
            SymbolTrackerImpl = class {
                constructor(context, tracker, moduleResolverHost){
                    this.moduleResolverHost = void 0;
                    this.inner = void 0;
                    this.disableTrackSymbol = false;
                    var _a;
                    while(tracker instanceof SymbolTrackerImpl)tracker = tracker.inner;
                    this.inner = tracker;
                    this.moduleResolverHost = moduleResolverHost;
                    this.context = context;
                    this.canTrackSymbol = !!((_a = this.inner) == null ? void 0 : _a.trackSymbol);
                }
                trackSymbol(symbol, enclosingDeclaration, meaning) {
                    var _a;
                    if (((_a = this.inner) == null ? void 0 : _a.trackSymbol) && !this.disableTrackSymbol) {
                        if (this.inner.trackSymbol(symbol, enclosingDeclaration, meaning)) {
                            this.onDiagnosticReported();
                            return true;
                        }
                    }
                    return false;
                }
                reportInaccessibleThisError() {
                    var _a;
                    if ((_a = this.inner) == null ? void 0 : _a.reportInaccessibleThisError) {
                        this.onDiagnosticReported();
                        this.inner.reportInaccessibleThisError();
                    }
                }
                reportPrivateInBaseOfClassExpression(propertyName) {
                    var _a;
                    if ((_a = this.inner) == null ? void 0 : _a.reportPrivateInBaseOfClassExpression) {
                        this.onDiagnosticReported();
                        this.inner.reportPrivateInBaseOfClassExpression(propertyName);
                    }
                }
                reportInaccessibleUniqueSymbolError() {
                    var _a;
                    if ((_a = this.inner) == null ? void 0 : _a.reportInaccessibleUniqueSymbolError) {
                        this.onDiagnosticReported();
                        this.inner.reportInaccessibleUniqueSymbolError();
                    }
                }
                reportCyclicStructureError() {
                    var _a;
                    if ((_a = this.inner) == null ? void 0 : _a.reportCyclicStructureError) {
                        this.onDiagnosticReported();
                        this.inner.reportCyclicStructureError();
                    }
                }
                reportLikelyUnsafeImportRequiredError(specifier) {
                    var _a;
                    if ((_a = this.inner) == null ? void 0 : _a.reportLikelyUnsafeImportRequiredError) {
                        this.onDiagnosticReported();
                        this.inner.reportLikelyUnsafeImportRequiredError(specifier);
                    }
                }
                reportTruncationError() {
                    var _a;
                    if ((_a = this.inner) == null ? void 0 : _a.reportTruncationError) {
                        this.onDiagnosticReported();
                        this.inner.reportTruncationError();
                    }
                }
                trackReferencedAmbientModule(decl, symbol) {
                    var _a;
                    if ((_a = this.inner) == null ? void 0 : _a.trackReferencedAmbientModule) {
                        this.onDiagnosticReported();
                        this.inner.trackReferencedAmbientModule(decl, symbol);
                    }
                }
                trackExternalModuleSymbolOfImportTypeNode(symbol) {
                    var _a;
                    if ((_a = this.inner) == null ? void 0 : _a.trackExternalModuleSymbolOfImportTypeNode) {
                        this.onDiagnosticReported();
                        this.inner.trackExternalModuleSymbolOfImportTypeNode(symbol);
                    }
                }
                reportNonlocalAugmentation(containingFile, parentSymbol, augmentingSymbol) {
                    var _a;
                    if ((_a = this.inner) == null ? void 0 : _a.reportNonlocalAugmentation) {
                        this.onDiagnosticReported();
                        this.inner.reportNonlocalAugmentation(containingFile, parentSymbol, augmentingSymbol);
                    }
                }
                reportNonSerializableProperty(propertyName) {
                    var _a;
                    if ((_a = this.inner) == null ? void 0 : _a.reportNonSerializableProperty) {
                        this.onDiagnosticReported();
                        this.inner.reportNonSerializableProperty(propertyName);
                    }
                }
                reportImportTypeNodeResolutionModeOverride() {
                    var _a;
                    if ((_a = this.inner) == null ? void 0 : _a.reportImportTypeNodeResolutionModeOverride) {
                        this.onDiagnosticReported();
                        this.inner.reportImportTypeNodeResolutionModeOverride();
                    }
                }
                onDiagnosticReported() {
                    this.context.reportedDiagnostic = true;
                }
            };
        }
    });
    // src/compiler/visitorPublic.ts
    function visitNode(node, visitor, test, lift) {
        if (node === void 0) return node;
        const visited = visitor(node);
        let visitedNode;
        if (visited === void 0) return void 0;
        else if (isArray(visited)) visitedNode = (lift || extractSingleNode)(visited);
        else visitedNode = visited;
        Debug.assertNode(visitedNode, test);
        return visitedNode;
    }
    function visitNodes2(nodes, visitor, test, start, count) {
        if (nodes === void 0) return nodes;
        const length2 = nodes.length;
        if (start === void 0 || start < 0) start = 0;
        if (count === void 0 || count > length2 - start) count = length2 - start;
        let hasTrailingComma;
        let pos = -1;
        let end = -1;
        if (start > 0 || count < length2) hasTrailingComma = nodes.hasTrailingComma && start + count === length2;
        else {
            pos = nodes.pos;
            end = nodes.end;
            hasTrailingComma = nodes.hasTrailingComma;
        }
        const updated = visitArrayWorker(nodes, visitor, test, start, count);
        if (updated !== nodes) {
            const updatedArray = factory.createNodeArray(updated, hasTrailingComma);
            setTextRangePosEnd(updatedArray, pos, end);
            return updatedArray;
        }
        return nodes;
    }
    function visitArray(nodes, visitor, test, start, count) {
        if (nodes === void 0) return nodes;
        const length2 = nodes.length;
        if (start === void 0 || start < 0) start = 0;
        if (count === void 0 || count > length2 - start) count = length2 - start;
        return visitArrayWorker(nodes, visitor, test, start, count);
    }
    function visitArrayWorker(nodes, visitor, test, start, count) {
        let updated;
        const length2 = nodes.length;
        if (start > 0 || count < length2) updated = [];
        for(let i = 0; i < count; i++){
            const node = nodes[i + start];
            const visited = node !== void 0 ? visitor ? visitor(node) : node : void 0;
            if (updated !== void 0 || visited === void 0 || visited !== node) {
                if (updated === void 0) {
                    updated = nodes.slice(0, i);
                    Debug.assertEachNode(updated, test);
                }
                if (visited) {
                    if (isArray(visited)) for (const visitedNode of visited){
                        Debug.assertNode(visitedNode, test);
                        updated.push(visitedNode);
                    }
                    else {
                        Debug.assertNode(visited, test);
                        updated.push(visited);
                    }
                }
            }
        }
        if (updated) return updated;
        Debug.assertEachNode(nodes, test);
        return nodes;
    }
    function visitLexicalEnvironment(statements, visitor, context, start, ensureUseStrict, nodesVisitor = visitNodes2) {
        context.startLexicalEnvironment();
        statements = nodesVisitor(statements, visitor, isStatement, start);
        if (ensureUseStrict) statements = context.factory.ensureUseStrict(statements);
        return factory.mergeLexicalEnvironment(statements, context.endLexicalEnvironment());
    }
    function visitParameterList(nodes, visitor, context, nodesVisitor = visitNodes2) {
        let updated;
        context.startLexicalEnvironment();
        if (nodes) {
            context.setLexicalEnvironmentFlags(1 /* InParameters */ , true);
            updated = nodesVisitor(nodes, visitor, isParameter);
            if (context.getLexicalEnvironmentFlags() & 2 /* VariablesHoistedInParameters */  && getEmitScriptTarget(context.getCompilerOptions()) >= 2 /* ES2015 */ ) updated = addDefaultValueAssignmentsIfNeeded(updated, context);
            context.setLexicalEnvironmentFlags(1 /* InParameters */ , false);
        }
        context.suspendLexicalEnvironment();
        return updated;
    }
    function addDefaultValueAssignmentsIfNeeded(parameters, context) {
        let result;
        for(let i = 0; i < parameters.length; i++){
            const parameter = parameters[i];
            const updated = addDefaultValueAssignmentIfNeeded(parameter, context);
            if (result || updated !== parameter) {
                if (!result) result = parameters.slice(0, i);
                result[i] = updated;
            }
        }
        if (result) return setTextRange(context.factory.createNodeArray(result, parameters.hasTrailingComma), parameters);
        return parameters;
    }
    function addDefaultValueAssignmentIfNeeded(parameter, context) {
        return parameter.dotDotDotToken ? parameter : isBindingPattern(parameter.name) ? addDefaultValueAssignmentForBindingPattern(parameter, context) : parameter.initializer ? addDefaultValueAssignmentForInitializer(parameter, parameter.name, parameter.initializer, context) : parameter;
    }
    function addDefaultValueAssignmentForBindingPattern(parameter, context) {
        const { factory: factory2  } = context;
        context.addInitializationStatement(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
            factory2.createVariableDeclaration(parameter.name, /*exclamationToken*/ void 0, parameter.type, parameter.initializer ? factory2.createConditionalExpression(factory2.createStrictEquality(factory2.getGeneratedNameForNode(parameter), factory2.createVoidZero()), /*questionToken*/ void 0, parameter.initializer, /*colonToken*/ void 0, factory2.getGeneratedNameForNode(parameter)) : factory2.getGeneratedNameForNode(parameter))
        ])));
        return factory2.updateParameterDeclaration(parameter, parameter.modifiers, parameter.dotDotDotToken, factory2.getGeneratedNameForNode(parameter), parameter.questionToken, parameter.type, /*initializer*/ void 0);
    }
    function addDefaultValueAssignmentForInitializer(parameter, name, initializer, context) {
        const factory2 = context.factory;
        context.addInitializationStatement(factory2.createIfStatement(factory2.createTypeCheck(factory2.cloneNode(name), "undefined"), setEmitFlags(setTextRange(factory2.createBlock([
            factory2.createExpressionStatement(setEmitFlags(setTextRange(factory2.createAssignment(setEmitFlags(factory2.cloneNode(name), 96 /* NoSourceMap */ ), setEmitFlags(initializer, 96 /* NoSourceMap */  | getEmitFlags(initializer) | 3072 /* NoComments */ )), parameter), 3072 /* NoComments */ ))
        ]), parameter), 3905 /* NoComments */ )));
        return factory2.updateParameterDeclaration(parameter, parameter.modifiers, parameter.dotDotDotToken, parameter.name, parameter.questionToken, parameter.type, /*initializer*/ void 0);
    }
    function visitFunctionBody(node, visitor, context, nodeVisitor = visitNode) {
        context.resumeLexicalEnvironment();
        const updated = nodeVisitor(node, visitor, isConciseBody);
        const declarations = context.endLexicalEnvironment();
        if (some(declarations)) {
            if (!updated) return context.factory.createBlock(declarations);
            const block = context.factory.converters.convertToFunctionBlock(updated);
            const statements = factory.mergeLexicalEnvironment(block.statements, declarations);
            return context.factory.updateBlock(block, statements);
        }
        return updated;
    }
    function visitIterationBody(body, visitor, context, nodeVisitor = visitNode) {
        context.startBlockScope();
        const updated = nodeVisitor(body, visitor, isStatement, context.factory.liftToBlock);
        Debug.assert(updated);
        const declarations = context.endBlockScope();
        if (some(declarations)) {
            if (isBlock(updated)) {
                declarations.push(...updated.statements);
                return context.factory.updateBlock(updated, declarations);
            }
            declarations.push(updated);
            return context.factory.createBlock(declarations);
        }
        return updated;
    }
    function visitCommaListElements(elements, visitor, discardVisitor = visitor) {
        if (discardVisitor === visitor || elements.length <= 1) return visitNodes2(elements, visitor, isExpression);
        let i = 0;
        const length2 = elements.length;
        return visitNodes2(elements, (node)=>{
            const discarded = i < length2 - 1;
            i++;
            return discarded ? discardVisitor(node) : visitor(node);
        }, isExpression);
    }
    function visitEachChild(node, visitor, context, nodesVisitor = visitNodes2, tokenVisitor, nodeVisitor = visitNode) {
        if (node === void 0) return void 0;
        const fn = visitEachChildTable[node.kind];
        return fn === void 0 ? node : fn(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor);
    }
    function extractSingleNode(nodes) {
        Debug.assert(nodes.length <= 1, "Too many nodes written to output.");
        return singleOrUndefined(nodes);
    }
    var visitEachChildTable;
    var init_visitorPublic = __esm({
        "src/compiler/visitorPublic.ts" () {
            "use strict";
            init_ts2();
            visitEachChildTable = {
                [165 /* QualifiedName */ ]: function visitEachChildOfQualifiedName(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateQualifiedName(node, Debug.checkDefined(nodeVisitor(node.left, visitor, isEntityName)), Debug.checkDefined(nodeVisitor(node.right, visitor, isIdentifier)));
                },
                [166 /* ComputedPropertyName */ ]: function visitEachChildOfComputedPropertyName(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateComputedPropertyName(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                // Signature elements
                [167 /* TypeParameter */ ]: function visitEachChildOfTypeParameterDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTypeParameterDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifier), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), nodeVisitor(node.constraint, visitor, isTypeNode), nodeVisitor(node.default, visitor, isTypeNode));
                },
                [168 /* Parameter */ ]: function visitEachChildOfParameterDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateParameterDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), tokenVisitor ? nodeVisitor(node.dotDotDotToken, tokenVisitor, isDotDotDotToken) : node.dotDotDotToken, Debug.checkDefined(nodeVisitor(node.name, visitor, isBindingName)), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken) : node.questionToken, nodeVisitor(node.type, visitor, isTypeNode), nodeVisitor(node.initializer, visitor, isExpression));
                },
                [169 /* Decorator */ ]: function visitEachChildOfDecorator(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateDecorator(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                // Type elements
                [170 /* PropertySignature */ ]: function visitEachChildOfPropertySignature(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updatePropertySignature(node, nodesVisitor(node.modifiers, visitor, isModifier), Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken) : node.questionToken, nodeVisitor(node.type, visitor, isTypeNode));
                },
                [171 /* PropertyDeclaration */ ]: function visitEachChildOfPropertyDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updatePropertyDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), // QuestionToken and ExclamationToken are mutually exclusive in PropertyDeclaration
                    tokenVisitor ? nodeVisitor(node.questionToken ?? node.exclamationToken, tokenVisitor, isQuestionOrExclamationToken) : node.questionToken ?? node.exclamationToken, nodeVisitor(node.type, visitor, isTypeNode), nodeVisitor(node.initializer, visitor, isExpression));
                },
                [172 /* MethodSignature */ ]: function visitEachChildOfMethodSignature(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateMethodSignature(node, nodesVisitor(node.modifiers, visitor, isModifier), Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken) : node.questionToken, nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, isParameter), nodeVisitor(node.type, visitor, isTypeNode));
                },
                [173 /* MethodDeclaration */ ]: function visitEachChildOfMethodDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateMethodDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), tokenVisitor ? nodeVisitor(node.asteriskToken, tokenVisitor, isAsteriskToken) : node.asteriskToken, Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken) : node.questionToken, nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), nodeVisitor(node.type, visitor, isTypeNode), visitFunctionBody(node.body, visitor, context, nodeVisitor));
                },
                [175 /* Constructor */ ]: function visitEachChildOfConstructorDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateConstructorDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitFunctionBody(node.body, visitor, context, nodeVisitor));
                },
                [176 /* GetAccessor */ ]: function visitEachChildOfGetAccessorDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateGetAccessorDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), visitParameterList(node.parameters, visitor, context, nodesVisitor), nodeVisitor(node.type, visitor, isTypeNode), visitFunctionBody(node.body, visitor, context, nodeVisitor));
                },
                [177 /* SetAccessor */ ]: function visitEachChildOfSetAccessorDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateSetAccessorDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitFunctionBody(node.body, visitor, context, nodeVisitor));
                },
                [174 /* ClassStaticBlockDeclaration */ ]: function visitEachChildOfClassStaticBlockDeclaration(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    context.startLexicalEnvironment();
                    context.suspendLexicalEnvironment();
                    return context.factory.updateClassStaticBlockDeclaration(node, visitFunctionBody(node.body, visitor, context, nodeVisitor));
                },
                [178 /* CallSignature */ ]: function visitEachChildOfCallSignatureDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateCallSignature(node, nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, isParameter), nodeVisitor(node.type, visitor, isTypeNode));
                },
                [179 /* ConstructSignature */ ]: function visitEachChildOfConstructSignatureDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateConstructSignature(node, nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, isParameter), nodeVisitor(node.type, visitor, isTypeNode));
                },
                [180 /* IndexSignature */ ]: function visitEachChildOfIndexSignatureDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateIndexSignature(node, nodesVisitor(node.modifiers, visitor, isModifierLike), nodesVisitor(node.parameters, visitor, isParameter), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
                },
                // Types
                [181 /* TypePredicate */ ]: function visitEachChildOfTypePredicateNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTypePredicateNode(node, nodeVisitor(node.assertsModifier, visitor, isAssertsKeyword), Debug.checkDefined(nodeVisitor(node.parameterName, visitor, isIdentifierOrThisTypeNode)), nodeVisitor(node.type, visitor, isTypeNode));
                },
                [182 /* TypeReference */ ]: function visitEachChildOfTypeReferenceNode(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTypeReferenceNode(node, Debug.checkDefined(nodeVisitor(node.typeName, visitor, isEntityName)), nodesVisitor(node.typeArguments, visitor, isTypeNode));
                },
                [183 /* FunctionType */ ]: function visitEachChildOfFunctionTypeNode(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateFunctionTypeNode(node, nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, isParameter), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
                },
                [184 /* ConstructorType */ ]: function visitEachChildOfConstructorTypeNode(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateConstructorTypeNode(node, nodesVisitor(node.modifiers, visitor, isModifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, isParameter), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
                },
                [185 /* TypeQuery */ ]: function visitEachChildOfTypeQueryNode(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTypeQueryNode(node, Debug.checkDefined(nodeVisitor(node.exprName, visitor, isEntityName)), nodesVisitor(node.typeArguments, visitor, isTypeNode));
                },
                [186 /* TypeLiteral */ ]: function visitEachChildOfTypeLiteralNode(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTypeLiteralNode(node, nodesVisitor(node.members, visitor, isTypeElement));
                },
                [187 /* ArrayType */ ]: function visitEachChildOfArrayTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateArrayTypeNode(node, Debug.checkDefined(nodeVisitor(node.elementType, visitor, isTypeNode)));
                },
                [188 /* TupleType */ ]: function visitEachChildOfTupleTypeNode(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTupleTypeNode(node, nodesVisitor(node.elements, visitor, isTypeNode));
                },
                [189 /* OptionalType */ ]: function visitEachChildOfOptionalTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateOptionalTypeNode(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
                },
                [190 /* RestType */ ]: function visitEachChildOfRestTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateRestTypeNode(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
                },
                [191 /* UnionType */ ]: function visitEachChildOfUnionTypeNode(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateUnionTypeNode(node, nodesVisitor(node.types, visitor, isTypeNode));
                },
                [192 /* IntersectionType */ ]: function visitEachChildOfIntersectionTypeNode(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateIntersectionTypeNode(node, nodesVisitor(node.types, visitor, isTypeNode));
                },
                [193 /* ConditionalType */ ]: function visitEachChildOfConditionalTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateConditionalTypeNode(node, Debug.checkDefined(nodeVisitor(node.checkType, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.extendsType, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.trueType, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.falseType, visitor, isTypeNode)));
                },
                [194 /* InferType */ ]: function visitEachChildOfInferTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateInferTypeNode(node, Debug.checkDefined(nodeVisitor(node.typeParameter, visitor, isTypeParameterDeclaration)));
                },
                [204 /* ImportType */ ]: function visitEachChildOfImportTypeNode(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateImportTypeNode(node, Debug.checkDefined(nodeVisitor(node.argument, visitor, isTypeNode)), nodeVisitor(node.assertions, visitor, isImportTypeAssertionContainer), nodeVisitor(node.qualifier, visitor, isEntityName), nodesVisitor(node.typeArguments, visitor, isTypeNode), node.isTypeOf);
                },
                [301 /* ImportTypeAssertionContainer */ ]: function visitEachChildOfImportTypeAssertionContainer(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateImportTypeAssertionContainer(node, Debug.checkDefined(nodeVisitor(node.assertClause, visitor, isAssertClause)), node.multiLine);
                },
                [201 /* NamedTupleMember */ ]: function visitEachChildOfNamedTupleMember(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateNamedTupleMember(node, tokenVisitor ? nodeVisitor(node.dotDotDotToken, tokenVisitor, isDotDotDotToken) : node.dotDotDotToken, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken) : node.questionToken, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
                },
                [195 /* ParenthesizedType */ ]: function visitEachChildOfParenthesizedType(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateParenthesizedType(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
                },
                [197 /* TypeOperator */ ]: function visitEachChildOfTypeOperatorNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTypeOperatorNode(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
                },
                [198 /* IndexedAccessType */ ]: function visitEachChildOfIndexedAccessType(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateIndexedAccessTypeNode(node, Debug.checkDefined(nodeVisitor(node.objectType, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.indexType, visitor, isTypeNode)));
                },
                [199 /* MappedType */ ]: function visitEachChildOfMappedType(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateMappedTypeNode(node, tokenVisitor ? nodeVisitor(node.readonlyToken, tokenVisitor, isReadonlyKeywordOrPlusOrMinusToken) : node.readonlyToken, Debug.checkDefined(nodeVisitor(node.typeParameter, visitor, isTypeParameterDeclaration)), nodeVisitor(node.nameType, visitor, isTypeNode), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionOrPlusOrMinusToken) : node.questionToken, nodeVisitor(node.type, visitor, isTypeNode), nodesVisitor(node.members, visitor, isTypeElement));
                },
                [200 /* LiteralType */ ]: function visitEachChildOfLiteralTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateLiteralTypeNode(node, Debug.checkDefined(nodeVisitor(node.literal, visitor, isLiteralTypeLiteral)));
                },
                [202 /* TemplateLiteralType */ ]: function visitEachChildOfTemplateLiteralType(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTemplateLiteralType(node, Debug.checkDefined(nodeVisitor(node.head, visitor, isTemplateHead)), nodesVisitor(node.templateSpans, visitor, isTemplateLiteralTypeSpan));
                },
                [203 /* TemplateLiteralTypeSpan */ ]: function visitEachChildOfTemplateLiteralTypeSpan(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTemplateLiteralTypeSpan(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.literal, visitor, isTemplateMiddleOrTemplateTail)));
                },
                // Binding patterns
                [205 /* ObjectBindingPattern */ ]: function visitEachChildOfObjectBindingPattern(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateObjectBindingPattern(node, nodesVisitor(node.elements, visitor, isBindingElement));
                },
                [206 /* ArrayBindingPattern */ ]: function visitEachChildOfArrayBindingPattern(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateArrayBindingPattern(node, nodesVisitor(node.elements, visitor, isArrayBindingElement));
                },
                [207 /* BindingElement */ ]: function visitEachChildOfBindingElement(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateBindingElement(node, tokenVisitor ? nodeVisitor(node.dotDotDotToken, tokenVisitor, isDotDotDotToken) : node.dotDotDotToken, nodeVisitor(node.propertyName, visitor, isPropertyName), Debug.checkDefined(nodeVisitor(node.name, visitor, isBindingName)), nodeVisitor(node.initializer, visitor, isExpression));
                },
                // Expression
                [208 /* ArrayLiteralExpression */ ]: function visitEachChildOfArrayLiteralExpression(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateArrayLiteralExpression(node, nodesVisitor(node.elements, visitor, isExpression));
                },
                [209 /* ObjectLiteralExpression */ ]: function visitEachChildOfObjectLiteralExpression(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateObjectLiteralExpression(node, nodesVisitor(node.properties, visitor, isObjectLiteralElementLike));
                },
                [210 /* PropertyAccessExpression */ ]: function visitEachChildOfPropertyAccessExpression(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
                    return isPropertyAccessChain(node) ? context.factory.updatePropertyAccessChain(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), tokenVisitor ? nodeVisitor(node.questionDotToken, tokenVisitor, isQuestionDotToken) : node.questionDotToken, Debug.checkDefined(nodeVisitor(node.name, visitor, isMemberName))) : context.factory.updatePropertyAccessExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.name, visitor, isMemberName)));
                },
                [211 /* ElementAccessExpression */ ]: function visitEachChildOfElementAccessExpression(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
                    return isElementAccessChain(node) ? context.factory.updateElementAccessChain(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), tokenVisitor ? nodeVisitor(node.questionDotToken, tokenVisitor, isQuestionDotToken) : node.questionDotToken, Debug.checkDefined(nodeVisitor(node.argumentExpression, visitor, isExpression))) : context.factory.updateElementAccessExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.argumentExpression, visitor, isExpression)));
                },
                [212 /* CallExpression */ ]: function visitEachChildOfCallExpression(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
                    return isCallChain(node) ? context.factory.updateCallChain(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), tokenVisitor ? nodeVisitor(node.questionDotToken, tokenVisitor, isQuestionDotToken) : node.questionDotToken, nodesVisitor(node.typeArguments, visitor, isTypeNode), nodesVisitor(node.arguments, visitor, isExpression)) : context.factory.updateCallExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode), nodesVisitor(node.arguments, visitor, isExpression));
                },
                [213 /* NewExpression */ ]: function visitEachChildOfNewExpression(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateNewExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode), nodesVisitor(node.arguments, visitor, isExpression));
                },
                [214 /* TaggedTemplateExpression */ ]: function visitEachChildOfTaggedTemplateExpression(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTaggedTemplateExpression(node, Debug.checkDefined(nodeVisitor(node.tag, visitor, isExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode), Debug.checkDefined(nodeVisitor(node.template, visitor, isTemplateLiteral)));
                },
                [215 /* TypeAssertionExpression */ ]: function visitEachChildOfTypeAssertionExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTypeAssertion(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [216 /* ParenthesizedExpression */ ]: function visitEachChildOfParenthesizedExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateParenthesizedExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [217 /* FunctionExpression */ ]: function visitEachChildOfFunctionExpression(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateFunctionExpression(node, nodesVisitor(node.modifiers, visitor, isModifier), tokenVisitor ? nodeVisitor(node.asteriskToken, tokenVisitor, isAsteriskToken) : node.asteriskToken, nodeVisitor(node.name, visitor, isIdentifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), nodeVisitor(node.type, visitor, isTypeNode), visitFunctionBody(node.body, visitor, context, nodeVisitor));
                },
                [218 /* ArrowFunction */ ]: function visitEachChildOfArrowFunction(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateArrowFunction(node, nodesVisitor(node.modifiers, visitor, isModifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), nodeVisitor(node.type, visitor, isTypeNode), tokenVisitor ? Debug.checkDefined(nodeVisitor(node.equalsGreaterThanToken, tokenVisitor, isEqualsGreaterThanToken)) : node.equalsGreaterThanToken, visitFunctionBody(node.body, visitor, context, nodeVisitor));
                },
                [219 /* DeleteExpression */ ]: function visitEachChildOfDeleteExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateDeleteExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [220 /* TypeOfExpression */ ]: function visitEachChildOfTypeOfExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTypeOfExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [221 /* VoidExpression */ ]: function visitEachChildOfVoidExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateVoidExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [222 /* AwaitExpression */ ]: function visitEachChildOfAwaitExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateAwaitExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [223 /* PrefixUnaryExpression */ ]: function visitEachChildOfPrefixUnaryExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updatePrefixUnaryExpression(node, Debug.checkDefined(nodeVisitor(node.operand, visitor, isExpression)));
                },
                [224 /* PostfixUnaryExpression */ ]: function visitEachChildOfPostfixUnaryExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updatePostfixUnaryExpression(node, Debug.checkDefined(nodeVisitor(node.operand, visitor, isExpression)));
                },
                [225 /* BinaryExpression */ ]: function visitEachChildOfBinaryExpression(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateBinaryExpression(node, Debug.checkDefined(nodeVisitor(node.left, visitor, isExpression)), tokenVisitor ? Debug.checkDefined(nodeVisitor(node.operatorToken, tokenVisitor, isBinaryOperatorToken)) : node.operatorToken, Debug.checkDefined(nodeVisitor(node.right, visitor, isExpression)));
                },
                [226 /* ConditionalExpression */ ]: function visitEachChildOfConditionalExpression(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateConditionalExpression(node, Debug.checkDefined(nodeVisitor(node.condition, visitor, isExpression)), tokenVisitor ? Debug.checkDefined(nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken)) : node.questionToken, Debug.checkDefined(nodeVisitor(node.whenTrue, visitor, isExpression)), tokenVisitor ? Debug.checkDefined(nodeVisitor(node.colonToken, tokenVisitor, isColonToken)) : node.colonToken, Debug.checkDefined(nodeVisitor(node.whenFalse, visitor, isExpression)));
                },
                [227 /* TemplateExpression */ ]: function visitEachChildOfTemplateExpression(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTemplateExpression(node, Debug.checkDefined(nodeVisitor(node.head, visitor, isTemplateHead)), nodesVisitor(node.templateSpans, visitor, isTemplateSpan));
                },
                [228 /* YieldExpression */ ]: function visitEachChildOfYieldExpression(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateYieldExpression(node, tokenVisitor ? nodeVisitor(node.asteriskToken, tokenVisitor, isAsteriskToken) : node.asteriskToken, nodeVisitor(node.expression, visitor, isExpression));
                },
                [229 /* SpreadElement */ ]: function visitEachChildOfSpreadElement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateSpreadElement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [230 /* ClassExpression */ ]: function visitEachChildOfClassExpression(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateClassExpression(node, nodesVisitor(node.modifiers, visitor, isModifierLike), nodeVisitor(node.name, visitor, isIdentifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, isHeritageClause), nodesVisitor(node.members, visitor, isClassElement));
                },
                [232 /* ExpressionWithTypeArguments */ ]: function visitEachChildOfExpressionWithTypeArguments(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateExpressionWithTypeArguments(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode));
                },
                [233 /* AsExpression */ ]: function visitEachChildOfAsExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateAsExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
                },
                [237 /* SatisfiesExpression */ ]: function visitEachChildOfSatisfiesExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateSatisfiesExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
                },
                [234 /* NonNullExpression */ ]: function visitEachChildOfNonNullExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return isOptionalChain(node) ? context.factory.updateNonNullChain(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression))) : context.factory.updateNonNullExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [235 /* MetaProperty */ ]: function visitEachChildOfMetaProperty(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateMetaProperty(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
                },
                // Misc
                [238 /* TemplateSpan */ ]: function visitEachChildOfTemplateSpan(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTemplateSpan(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.literal, visitor, isTemplateMiddleOrTemplateTail)));
                },
                // Element
                [240 /* Block */ ]: function visitEachChildOfBlock(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateBlock(node, nodesVisitor(node.statements, visitor, isStatement));
                },
                [242 /* VariableStatement */ ]: function visitEachChildOfVariableStatement(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateVariableStatement(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.declarationList, visitor, isVariableDeclarationList)));
                },
                [243 /* ExpressionStatement */ ]: function visitEachChildOfExpressionStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateExpressionStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [244 /* IfStatement */ ]: function visitEachChildOfIfStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateIfStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.thenStatement, visitor, isStatement, context.factory.liftToBlock)), nodeVisitor(node.elseStatement, visitor, isStatement, context.factory.liftToBlock));
                },
                [245 /* DoStatement */ ]: function visitEachChildOfDoStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateDoStatement(node, visitIterationBody(node.statement, visitor, context, nodeVisitor), Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [246 /* WhileStatement */ ]: function visitEachChildOfWhileStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateWhileStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), visitIterationBody(node.statement, visitor, context, nodeVisitor));
                },
                [247 /* ForStatement */ ]: function visitEachChildOfForStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateForStatement(node, nodeVisitor(node.initializer, visitor, isForInitializer), nodeVisitor(node.condition, visitor, isExpression), nodeVisitor(node.incrementor, visitor, isExpression), visitIterationBody(node.statement, visitor, context, nodeVisitor));
                },
                [248 /* ForInStatement */ ]: function visitEachChildOfForInStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateForInStatement(node, Debug.checkDefined(nodeVisitor(node.initializer, visitor, isForInitializer)), Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), visitIterationBody(node.statement, visitor, context, nodeVisitor));
                },
                [249 /* ForOfStatement */ ]: function visitEachChildOfForOfStatement(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateForOfStatement(node, tokenVisitor ? nodeVisitor(node.awaitModifier, tokenVisitor, isAwaitKeyword) : node.awaitModifier, Debug.checkDefined(nodeVisitor(node.initializer, visitor, isForInitializer)), Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), visitIterationBody(node.statement, visitor, context, nodeVisitor));
                },
                [250 /* ContinueStatement */ ]: function visitEachChildOfContinueStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateContinueStatement(node, nodeVisitor(node.label, visitor, isIdentifier));
                },
                [251 /* BreakStatement */ ]: function visitEachChildOfBreakStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateBreakStatement(node, nodeVisitor(node.label, visitor, isIdentifier));
                },
                [252 /* ReturnStatement */ ]: function visitEachChildOfReturnStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateReturnStatement(node, nodeVisitor(node.expression, visitor, isExpression));
                },
                [253 /* WithStatement */ ]: function visitEachChildOfWithStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateWithStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.statement, visitor, isStatement, context.factory.liftToBlock)));
                },
                [254 /* SwitchStatement */ ]: function visitEachChildOfSwitchStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateSwitchStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.caseBlock, visitor, isCaseBlock)));
                },
                [255 /* LabeledStatement */ ]: function visitEachChildOfLabeledStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateLabeledStatement(node, Debug.checkDefined(nodeVisitor(node.label, visitor, isIdentifier)), Debug.checkDefined(nodeVisitor(node.statement, visitor, isStatement, context.factory.liftToBlock)));
                },
                [256 /* ThrowStatement */ ]: function visitEachChildOfThrowStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateThrowStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [257 /* TryStatement */ ]: function visitEachChildOfTryStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTryStatement(node, Debug.checkDefined(nodeVisitor(node.tryBlock, visitor, isBlock)), nodeVisitor(node.catchClause, visitor, isCatchClause), nodeVisitor(node.finallyBlock, visitor, isBlock));
                },
                [259 /* VariableDeclaration */ ]: function visitEachChildOfVariableDeclaration(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateVariableDeclaration(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isBindingName)), tokenVisitor ? nodeVisitor(node.exclamationToken, tokenVisitor, isExclamationToken) : node.exclamationToken, nodeVisitor(node.type, visitor, isTypeNode), nodeVisitor(node.initializer, visitor, isExpression));
                },
                [260 /* VariableDeclarationList */ ]: function visitEachChildOfVariableDeclarationList(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateVariableDeclarationList(node, nodesVisitor(node.declarations, visitor, isVariableDeclaration));
                },
                [261 /* FunctionDeclaration */ ]: function visitEachChildOfFunctionDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
                    return context.factory.updateFunctionDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifier), tokenVisitor ? nodeVisitor(node.asteriskToken, tokenVisitor, isAsteriskToken) : node.asteriskToken, nodeVisitor(node.name, visitor, isIdentifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), nodeVisitor(node.type, visitor, isTypeNode), visitFunctionBody(node.body, visitor, context, nodeVisitor));
                },
                [262 /* ClassDeclaration */ ]: function visitEachChildOfClassDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateClassDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), nodeVisitor(node.name, visitor, isIdentifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, isHeritageClause), nodesVisitor(node.members, visitor, isClassElement));
                },
                [263 /* InterfaceDeclaration */ ]: function visitEachChildOfInterfaceDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateInterfaceDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, isHeritageClause), nodesVisitor(node.members, visitor, isTypeElement));
                },
                [264 /* TypeAliasDeclaration */ ]: function visitEachChildOfTypeAliasDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateTypeAliasDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
                },
                [265 /* EnumDeclaration */ ]: function visitEachChildOfEnumDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateEnumDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), nodesVisitor(node.members, visitor, isEnumMember));
                },
                [266 /* ModuleDeclaration */ ]: function visitEachChildOfModuleDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateModuleDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isModuleName)), nodeVisitor(node.body, visitor, isModuleBody));
                },
                [267 /* ModuleBlock */ ]: function visitEachChildOfModuleBlock(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateModuleBlock(node, nodesVisitor(node.statements, visitor, isStatement));
                },
                [268 /* CaseBlock */ ]: function visitEachChildOfCaseBlock(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateCaseBlock(node, nodesVisitor(node.clauses, visitor, isCaseOrDefaultClause));
                },
                [269 /* NamespaceExportDeclaration */ ]: function visitEachChildOfNamespaceExportDeclaration(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateNamespaceExportDeclaration(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
                },
                [270 /* ImportEqualsDeclaration */ ]: function visitEachChildOfImportEqualsDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateImportEqualsDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), node.isTypeOnly, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), Debug.checkDefined(nodeVisitor(node.moduleReference, visitor, isModuleReference)));
                },
                [271 /* ImportDeclaration */ ]: function visitEachChildOfImportDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateImportDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), nodeVisitor(node.importClause, visitor, isImportClause), Debug.checkDefined(nodeVisitor(node.moduleSpecifier, visitor, isExpression)), nodeVisitor(node.assertClause, visitor, isAssertClause));
                },
                [299 /* AssertClause */ ]: function visitEachChildOfAssertClause(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateAssertClause(node, nodesVisitor(node.elements, visitor, isAssertEntry), node.multiLine);
                },
                [300 /* AssertEntry */ ]: function visitEachChildOfAssertEntry(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateAssertEntry(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isAssertionKey)), Debug.checkDefined(nodeVisitor(node.value, visitor, isExpression)));
                },
                [272 /* ImportClause */ ]: function visitEachChildOfImportClause(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateImportClause(node, node.isTypeOnly, nodeVisitor(node.name, visitor, isIdentifier), nodeVisitor(node.namedBindings, visitor, isNamedImportBindings));
                },
                [273 /* NamespaceImport */ ]: function visitEachChildOfNamespaceImport(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateNamespaceImport(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
                },
                [279 /* NamespaceExport */ ]: function visitEachChildOfNamespaceExport(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateNamespaceExport(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
                },
                [274 /* NamedImports */ ]: function visitEachChildOfNamedImports(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateNamedImports(node, nodesVisitor(node.elements, visitor, isImportSpecifier));
                },
                [275 /* ImportSpecifier */ ]: function visitEachChildOfImportSpecifier(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateImportSpecifier(node, node.isTypeOnly, nodeVisitor(node.propertyName, visitor, isIdentifier), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
                },
                [276 /* ExportAssignment */ ]: function visitEachChildOfExportAssignment(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateExportAssignment(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [277 /* ExportDeclaration */ ]: function visitEachChildOfExportDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateExportDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), node.isTypeOnly, nodeVisitor(node.exportClause, visitor, isNamedExportBindings), nodeVisitor(node.moduleSpecifier, visitor, isExpression), nodeVisitor(node.assertClause, visitor, isAssertClause));
                },
                [278 /* NamedExports */ ]: function visitEachChildOfNamedExports(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateNamedExports(node, nodesVisitor(node.elements, visitor, isExportSpecifier));
                },
                [280 /* ExportSpecifier */ ]: function visitEachChildOfExportSpecifier(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateExportSpecifier(node, node.isTypeOnly, nodeVisitor(node.propertyName, visitor, isIdentifier), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
                },
                // Module references
                [282 /* ExternalModuleReference */ ]: function visitEachChildOfExternalModuleReference(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateExternalModuleReference(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                // JSX
                [283 /* JsxElement */ ]: function visitEachChildOfJsxElement(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateJsxElement(node, Debug.checkDefined(nodeVisitor(node.openingElement, visitor, isJsxOpeningElement)), nodesVisitor(node.children, visitor, isJsxChild), Debug.checkDefined(nodeVisitor(node.closingElement, visitor, isJsxClosingElement)));
                },
                [284 /* JsxSelfClosingElement */ ]: function visitEachChildOfJsxSelfClosingElement(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateJsxSelfClosingElement(node, Debug.checkDefined(nodeVisitor(node.tagName, visitor, isJsxTagNameExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode), Debug.checkDefined(nodeVisitor(node.attributes, visitor, isJsxAttributes)));
                },
                [285 /* JsxOpeningElement */ ]: function visitEachChildOfJsxOpeningElement(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateJsxOpeningElement(node, Debug.checkDefined(nodeVisitor(node.tagName, visitor, isJsxTagNameExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode), Debug.checkDefined(nodeVisitor(node.attributes, visitor, isJsxAttributes)));
                },
                [286 /* JsxClosingElement */ ]: function visitEachChildOfJsxClosingElement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateJsxClosingElement(node, Debug.checkDefined(nodeVisitor(node.tagName, visitor, isJsxTagNameExpression)));
                },
                [294 /* JsxNamespacedName */ ]: function forEachChildInJsxNamespacedName2(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateJsxNamespacedName(node, Debug.checkDefined(nodeVisitor(node.namespace, visitor, isIdentifier)), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
                },
                [287 /* JsxFragment */ ]: function visitEachChildOfJsxFragment(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateJsxFragment(node, Debug.checkDefined(nodeVisitor(node.openingFragment, visitor, isJsxOpeningFragment)), nodesVisitor(node.children, visitor, isJsxChild), Debug.checkDefined(nodeVisitor(node.closingFragment, visitor, isJsxClosingFragment)));
                },
                [290 /* JsxAttribute */ ]: function visitEachChildOfJsxAttribute(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateJsxAttribute(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isJsxAttributeName)), nodeVisitor(node.initializer, visitor, isStringLiteralOrJsxExpression));
                },
                [291 /* JsxAttributes */ ]: function visitEachChildOfJsxAttributes(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateJsxAttributes(node, nodesVisitor(node.properties, visitor, isJsxAttributeLike));
                },
                [292 /* JsxSpreadAttribute */ ]: function visitEachChildOfJsxSpreadAttribute(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateJsxSpreadAttribute(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [293 /* JsxExpression */ ]: function visitEachChildOfJsxExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateJsxExpression(node, nodeVisitor(node.expression, visitor, isExpression));
                },
                // Clauses
                [295 /* CaseClause */ ]: function visitEachChildOfCaseClause(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateCaseClause(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), nodesVisitor(node.statements, visitor, isStatement));
                },
                [296 /* DefaultClause */ ]: function visitEachChildOfDefaultClause(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateDefaultClause(node, nodesVisitor(node.statements, visitor, isStatement));
                },
                [297 /* HeritageClause */ ]: function visitEachChildOfHeritageClause(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateHeritageClause(node, nodesVisitor(node.types, visitor, isExpressionWithTypeArguments));
                },
                [298 /* CatchClause */ ]: function visitEachChildOfCatchClause(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateCatchClause(node, nodeVisitor(node.variableDeclaration, visitor, isVariableDeclaration), Debug.checkDefined(nodeVisitor(node.block, visitor, isBlock)));
                },
                // Property assignments
                [302 /* PropertyAssignment */ ]: function visitEachChildOfPropertyAssignment(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updatePropertyAssignment(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), Debug.checkDefined(nodeVisitor(node.initializer, visitor, isExpression)));
                },
                [303 /* ShorthandPropertyAssignment */ ]: function visitEachChildOfShorthandPropertyAssignment(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateShorthandPropertyAssignment(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), nodeVisitor(node.objectAssignmentInitializer, visitor, isExpression));
                },
                [304 /* SpreadAssignment */ ]: function visitEachChildOfSpreadAssignment(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateSpreadAssignment(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                // Enum
                [305 /* EnumMember */ ]: function visitEachChildOfEnumMember(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updateEnumMember(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), nodeVisitor(node.initializer, visitor, isExpression));
                },
                // Top-level nodes
                [311 /* SourceFile */ ]: function visitEachChildOfSourceFile(node, visitor, context, _nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateSourceFile(node, visitLexicalEnvironment(node.statements, visitor, context));
                },
                // Transformation nodes
                [359 /* PartiallyEmittedExpression */ ]: function visitEachChildOfPartiallyEmittedExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
                    return context.factory.updatePartiallyEmittedExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
                },
                [360 /* CommaListExpression */ ]: function visitEachChildOfCommaListExpression(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
                    return context.factory.updateCommaListExpression(node, nodesVisitor(node.elements, visitor, isExpression));
                }
            };
        }
    });
    // src/compiler/sourcemap.ts
    function createSourceMapGenerator(host, file, sourceRoot, sourcesDirectoryPath, generatorOptions) {
        var { enter: enter , exit: exit  } = generatorOptions.extendedDiagnostics ? createTimer("Source Map", "beforeSourcemap", "afterSourcemap") : nullTimer;
        var rawSources = [];
        var sources = [];
        var sourceToSourceIndexMap = /* @__PURE__ */ new Map();
        var sourcesContent;
        var names = [];
        var nameToNameIndexMap;
        var mappingCharCodes = [];
        var mappings = "";
        var lastGeneratedLine = 0;
        var lastGeneratedCharacter = 0;
        var lastSourceIndex = 0;
        var lastSourceLine = 0;
        var lastSourceCharacter = 0;
        var lastNameIndex = 0;
        var hasLast = false;
        var pendingGeneratedLine = 0;
        var pendingGeneratedCharacter = 0;
        var pendingSourceIndex = 0;
        var pendingSourceLine = 0;
        var pendingSourceCharacter = 0;
        var pendingNameIndex = 0;
        var hasPending = false;
        var hasPendingSource = false;
        var hasPendingName = false;
        return {
            getSources: ()=>rawSources,
            addSource: addSource,
            setSourceContent: setSourceContent,
            addName: addName,
            addMapping: addMapping,
            appendSourceMap: appendSourceMap,
            toJSON: toJSON,
            toString: ()=>JSON.stringify(toJSON())
        };
        function addSource(fileName) {
            enter();
            const source = getRelativePathToDirectoryOrUrl(sourcesDirectoryPath, fileName, host.getCurrentDirectory(), host.getCanonicalFileName, /*isAbsolutePathAnUrl*/ true);
            let sourceIndex = sourceToSourceIndexMap.get(source);
            if (sourceIndex === void 0) {
                sourceIndex = sources.length;
                sources.push(source);
                rawSources.push(fileName);
                sourceToSourceIndexMap.set(source, sourceIndex);
            }
            exit();
            return sourceIndex;
        }
        function setSourceContent(sourceIndex, content) {
            enter();
            if (content !== null) {
                if (!sourcesContent) sourcesContent = [];
                while(sourcesContent.length < sourceIndex)sourcesContent.push(null);
                sourcesContent[sourceIndex] = content;
            }
            exit();
        }
        function addName(name) {
            enter();
            if (!nameToNameIndexMap) nameToNameIndexMap = /* @__PURE__ */ new Map();
            let nameIndex = nameToNameIndexMap.get(name);
            if (nameIndex === void 0) {
                nameIndex = names.length;
                names.push(name);
                nameToNameIndexMap.set(name, nameIndex);
            }
            exit();
            return nameIndex;
        }
        function isNewGeneratedPosition(generatedLine, generatedCharacter) {
            return !hasPending || pendingGeneratedLine !== generatedLine || pendingGeneratedCharacter !== generatedCharacter;
        }
        function isBacktrackingSourcePosition(sourceIndex, sourceLine, sourceCharacter) {
            return sourceIndex !== void 0 && sourceLine !== void 0 && sourceCharacter !== void 0 && pendingSourceIndex === sourceIndex && (pendingSourceLine > sourceLine || pendingSourceLine === sourceLine && pendingSourceCharacter > sourceCharacter);
        }
        function addMapping(generatedLine, generatedCharacter, sourceIndex, sourceLine, sourceCharacter, nameIndex) {
            Debug.assert(generatedLine >= pendingGeneratedLine, "generatedLine cannot backtrack");
            Debug.assert(generatedCharacter >= 0, "generatedCharacter cannot be negative");
            Debug.assert(sourceIndex === void 0 || sourceIndex >= 0, "sourceIndex cannot be negative");
            Debug.assert(sourceLine === void 0 || sourceLine >= 0, "sourceLine cannot be negative");
            Debug.assert(sourceCharacter === void 0 || sourceCharacter >= 0, "sourceCharacter cannot be negative");
            enter();
            if (isNewGeneratedPosition(generatedLine, generatedCharacter) || isBacktrackingSourcePosition(sourceIndex, sourceLine, sourceCharacter)) {
                commitPendingMapping();
                pendingGeneratedLine = generatedLine;
                pendingGeneratedCharacter = generatedCharacter;
                hasPendingSource = false;
                hasPendingName = false;
                hasPending = true;
            }
            if (sourceIndex !== void 0 && sourceLine !== void 0 && sourceCharacter !== void 0) {
                pendingSourceIndex = sourceIndex;
                pendingSourceLine = sourceLine;
                pendingSourceCharacter = sourceCharacter;
                hasPendingSource = true;
                if (nameIndex !== void 0) {
                    pendingNameIndex = nameIndex;
                    hasPendingName = true;
                }
            }
            exit();
        }
        function appendSourceMap(generatedLine, generatedCharacter, map2, sourceMapPath, start, end) {
            Debug.assert(generatedLine >= pendingGeneratedLine, "generatedLine cannot backtrack");
            Debug.assert(generatedCharacter >= 0, "generatedCharacter cannot be negative");
            enter();
            const sourceIndexToNewSourceIndexMap = [];
            let nameIndexToNewNameIndexMap;
            const mappingIterator = decodeMappings(map2.mappings);
            for (const raw of mappingIterator){
                if (end && (raw.generatedLine > end.line || raw.generatedLine === end.line && raw.generatedCharacter > end.character)) break;
                if (start && (raw.generatedLine < start.line || start.line === raw.generatedLine && raw.generatedCharacter < start.character)) continue;
                let newSourceIndex;
                let newSourceLine;
                let newSourceCharacter;
                let newNameIndex;
                if (raw.sourceIndex !== void 0) {
                    newSourceIndex = sourceIndexToNewSourceIndexMap[raw.sourceIndex];
                    if (newSourceIndex === void 0) {
                        const rawPath = map2.sources[raw.sourceIndex];
                        const relativePath = map2.sourceRoot ? combinePaths(map2.sourceRoot, rawPath) : rawPath;
                        const combinedPath = combinePaths(getDirectoryPath(sourceMapPath), relativePath);
                        sourceIndexToNewSourceIndexMap[raw.sourceIndex] = newSourceIndex = addSource(combinedPath);
                        if (map2.sourcesContent && typeof map2.sourcesContent[raw.sourceIndex] === "string") setSourceContent(newSourceIndex, map2.sourcesContent[raw.sourceIndex]);
                    }
                    newSourceLine = raw.sourceLine;
                    newSourceCharacter = raw.sourceCharacter;
                    if (map2.names && raw.nameIndex !== void 0) {
                        if (!nameIndexToNewNameIndexMap) nameIndexToNewNameIndexMap = [];
                        newNameIndex = nameIndexToNewNameIndexMap[raw.nameIndex];
                        if (newNameIndex === void 0) nameIndexToNewNameIndexMap[raw.nameIndex] = newNameIndex = addName(map2.names[raw.nameIndex]);
                    }
                }
                const rawGeneratedLine = raw.generatedLine - (start ? start.line : 0);
                const newGeneratedLine = rawGeneratedLine + generatedLine;
                const rawGeneratedCharacter = start && start.line === raw.generatedLine ? raw.generatedCharacter - start.character : raw.generatedCharacter;
                const newGeneratedCharacter = rawGeneratedLine === 0 ? rawGeneratedCharacter + generatedCharacter : rawGeneratedCharacter;
                addMapping(newGeneratedLine, newGeneratedCharacter, newSourceIndex, newSourceLine, newSourceCharacter, newNameIndex);
            }
            exit();
        }
        function shouldCommitMapping() {
            return !hasLast || lastGeneratedLine !== pendingGeneratedLine || lastGeneratedCharacter !== pendingGeneratedCharacter || lastSourceIndex !== pendingSourceIndex || lastSourceLine !== pendingSourceLine || lastSourceCharacter !== pendingSourceCharacter || lastNameIndex !== pendingNameIndex;
        }
        function appendMappingCharCode(charCode) {
            mappingCharCodes.push(charCode);
            if (mappingCharCodes.length >= 1024) flushMappingBuffer();
        }
        function commitPendingMapping() {
            if (!hasPending || !shouldCommitMapping()) return;
            enter();
            if (lastGeneratedLine < pendingGeneratedLine) {
                do {
                    appendMappingCharCode(59 /* semicolon */ );
                    lastGeneratedLine++;
                }while (lastGeneratedLine < pendingGeneratedLine);
                lastGeneratedCharacter = 0;
            } else {
                Debug.assertEqual(lastGeneratedLine, pendingGeneratedLine, "generatedLine cannot backtrack");
                if (hasLast) appendMappingCharCode(44 /* comma */ );
            }
            appendBase64VLQ(pendingGeneratedCharacter - lastGeneratedCharacter);
            lastGeneratedCharacter = pendingGeneratedCharacter;
            if (hasPendingSource) {
                appendBase64VLQ(pendingSourceIndex - lastSourceIndex);
                lastSourceIndex = pendingSourceIndex;
                appendBase64VLQ(pendingSourceLine - lastSourceLine);
                lastSourceLine = pendingSourceLine;
                appendBase64VLQ(pendingSourceCharacter - lastSourceCharacter);
                lastSourceCharacter = pendingSourceCharacter;
                if (hasPendingName) {
                    appendBase64VLQ(pendingNameIndex - lastNameIndex);
                    lastNameIndex = pendingNameIndex;
                }
            }
            hasLast = true;
            exit();
        }
        function flushMappingBuffer() {
            if (mappingCharCodes.length > 0) {
                mappings += String.fromCharCode.apply(void 0, mappingCharCodes);
                mappingCharCodes.length = 0;
            }
        }
        function toJSON() {
            commitPendingMapping();
            flushMappingBuffer();
            return {
                version: 3,
                file: file,
                sourceRoot: sourceRoot,
                sources: sources,
                names: names,
                mappings: mappings,
                sourcesContent: sourcesContent
            };
        }
        function appendBase64VLQ(inValue) {
            if (inValue < 0) inValue = (-inValue << 1) + 1;
            else inValue = inValue << 1;
            do {
                let currentDigit = inValue & 31;
                inValue = inValue >> 5;
                if (inValue > 0) currentDigit = currentDigit | 32;
                appendMappingCharCode(base64FormatEncode(currentDigit));
            }while (inValue > 0);
        }
    }
    function getLineInfo(text, lineStarts) {
        return {
            getLineCount: ()=>lineStarts.length,
            getLineText: (line)=>text.substring(lineStarts[line], lineStarts[line + 1])
        };
    }
    function tryGetSourceMappingURL(lineInfo) {
        for(let index = lineInfo.getLineCount() - 1; index >= 0; index--){
            const line = lineInfo.getLineText(index);
            const comment = sourceMapCommentRegExp.exec(line);
            if (comment) return trimStringEnd(comment[1]);
            else if (!line.match(whitespaceOrMapCommentRegExp)) break;
        }
    }
    function isStringOrNull(x) {
        return typeof x === "string" || x === null;
    }
    function isRawSourceMap(x) {
        return x !== null && typeof x === "object" && x.version === 3 && typeof x.file === "string" && typeof x.mappings === "string" && isArray(x.sources) && every(x.sources, isString) && (x.sourceRoot === void 0 || x.sourceRoot === null || typeof x.sourceRoot === "string") && (x.sourcesContent === void 0 || x.sourcesContent === null || isArray(x.sourcesContent) && every(x.sourcesContent, isStringOrNull)) && (x.names === void 0 || x.names === null || isArray(x.names) && every(x.names, isString));
    }
    function tryParseRawSourceMap(text) {
        try {
            const parsed = JSON.parse(text);
            if (isRawSourceMap(parsed)) return parsed;
        } catch  {}
        return void 0;
    }
    function decodeMappings(mappings) {
        let done = false;
        let pos = 0;
        let generatedLine = 0;
        let generatedCharacter = 0;
        let sourceIndex = 0;
        let sourceLine = 0;
        let sourceCharacter = 0;
        let nameIndex = 0;
        let error;
        return {
            get pos () {
                return pos;
            },
            get error () {
                return error;
            },
            get state () {
                return captureMapping(/*hasSource*/ true, /*hasName*/ true);
            },
            next () {
                while(!done && pos < mappings.length){
                    const ch = mappings.charCodeAt(pos);
                    if (ch === 59 /* semicolon */ ) {
                        generatedLine++;
                        generatedCharacter = 0;
                        pos++;
                        continue;
                    }
                    if (ch === 44 /* comma */ ) {
                        pos++;
                        continue;
                    }
                    let hasSource = false;
                    let hasName = false;
                    generatedCharacter += base64VLQFormatDecode();
                    if (hasReportedError()) return stopIterating();
                    if (generatedCharacter < 0) return setErrorAndStopIterating("Invalid generatedCharacter found");
                    if (!isSourceMappingSegmentEnd()) {
                        hasSource = true;
                        sourceIndex += base64VLQFormatDecode();
                        if (hasReportedError()) return stopIterating();
                        if (sourceIndex < 0) return setErrorAndStopIterating("Invalid sourceIndex found");
                        if (isSourceMappingSegmentEnd()) return setErrorAndStopIterating("Unsupported Format: No entries after sourceIndex");
                        sourceLine += base64VLQFormatDecode();
                        if (hasReportedError()) return stopIterating();
                        if (sourceLine < 0) return setErrorAndStopIterating("Invalid sourceLine found");
                        if (isSourceMappingSegmentEnd()) return setErrorAndStopIterating("Unsupported Format: No entries after sourceLine");
                        sourceCharacter += base64VLQFormatDecode();
                        if (hasReportedError()) return stopIterating();
                        if (sourceCharacter < 0) return setErrorAndStopIterating("Invalid sourceCharacter found");
                        if (!isSourceMappingSegmentEnd()) {
                            hasName = true;
                            nameIndex += base64VLQFormatDecode();
                            if (hasReportedError()) return stopIterating();
                            if (nameIndex < 0) return setErrorAndStopIterating("Invalid nameIndex found");
                            if (!isSourceMappingSegmentEnd()) return setErrorAndStopIterating("Unsupported Error Format: Entries after nameIndex");
                        }
                    }
                    return {
                        value: captureMapping(hasSource, hasName),
                        done: done
                    };
                }
                return stopIterating();
            },
            [Symbol.iterator] () {
                return this;
            }
        };
        function captureMapping(hasSource, hasName) {
            return {
                generatedLine: generatedLine,
                generatedCharacter: generatedCharacter,
                sourceIndex: hasSource ? sourceIndex : void 0,
                sourceLine: hasSource ? sourceLine : void 0,
                sourceCharacter: hasSource ? sourceCharacter : void 0,
                nameIndex: hasName ? nameIndex : void 0
            };
        }
        function stopIterating() {
            done = true;
            return {
                value: void 0,
                done: true
            };
        }
        function setError(message) {
            if (error === void 0) error = message;
        }
        function setErrorAndStopIterating(message) {
            setError(message);
            return stopIterating();
        }
        function hasReportedError() {
            return error !== void 0;
        }
        function isSourceMappingSegmentEnd() {
            return pos === mappings.length || mappings.charCodeAt(pos) === 44 /* comma */  || mappings.charCodeAt(pos) === 59 /* semicolon */ ;
        }
        function base64VLQFormatDecode() {
            let moreDigits = true;
            let shiftCount = 0;
            let value1 = 0;
            for(; moreDigits; pos++){
                if (pos >= mappings.length) return setError("Error in decoding base64VLQFormatDecode, past the mapping string"), -1;
                const currentByte = base64FormatDecode(mappings.charCodeAt(pos));
                if (currentByte === -1) return setError("Invalid character in VLQ"), -1;
                moreDigits = (currentByte & 32) !== 0;
                value1 = value1 | (currentByte & 31) << shiftCount;
                shiftCount += 5;
            }
            if ((value1 & 1) === 0) value1 = value1 >> 1;
            else {
                value1 = value1 >> 1;
                value1 = -value1;
            }
            return value1;
        }
    }
    function sameMapping(left, right) {
        return left === right || left.generatedLine === right.generatedLine && left.generatedCharacter === right.generatedCharacter && left.sourceIndex === right.sourceIndex && left.sourceLine === right.sourceLine && left.sourceCharacter === right.sourceCharacter && left.nameIndex === right.nameIndex;
    }
    function isSourceMapping(mapping) {
        return mapping.sourceIndex !== void 0 && mapping.sourceLine !== void 0 && mapping.sourceCharacter !== void 0;
    }
    function base64FormatEncode(value1) {
        return value1 >= 0 && value1 < 26 ? 65 /* A */  + value1 : value1 >= 26 && value1 < 52 ? 97 /* a */  + value1 - 26 : value1 >= 52 && value1 < 62 ? 48 /* _0 */  + value1 - 52 : value1 === 62 ? 43 /* plus */  : value1 === 63 ? 47 /* slash */  : Debug.fail(`${value1}: not a base64 value`);
    }
    function base64FormatDecode(ch) {
        return ch >= 65 /* A */  && ch <= 90 /* Z */  ? ch - 65 /* A */  : ch >= 97 /* a */  && ch <= 122 /* z */  ? ch - 97 /* a */  + 26 : ch >= 48 /* _0 */  && ch <= 57 /* _9 */  ? ch - 48 /* _0 */  + 52 : ch === 43 /* plus */  ? 62 : ch === 47 /* slash */  ? 63 : -1;
    }
    function isSourceMappedPosition(value1) {
        return value1.sourceIndex !== void 0 && value1.sourcePosition !== void 0;
    }
    function sameMappedPosition(left, right) {
        return left.generatedPosition === right.generatedPosition && left.sourceIndex === right.sourceIndex && left.sourcePosition === right.sourcePosition;
    }
    function compareSourcePositions(left, right) {
        Debug.assert(left.sourceIndex === right.sourceIndex);
        return compareValues(left.sourcePosition, right.sourcePosition);
    }
    function compareGeneratedPositions(left, right) {
        return compareValues(left.generatedPosition, right.generatedPosition);
    }
    function getSourcePositionOfMapping(value1) {
        return value1.sourcePosition;
    }
    function getGeneratedPositionOfMapping(value1) {
        return value1.generatedPosition;
    }
    function createDocumentPositionMapper(host, map2, mapPath) {
        const mapDirectory = getDirectoryPath(mapPath);
        const sourceRoot = map2.sourceRoot ? getNormalizedAbsolutePath(map2.sourceRoot, mapDirectory) : mapDirectory;
        const generatedAbsoluteFilePath = getNormalizedAbsolutePath(map2.file, mapDirectory);
        const generatedFile = host.getSourceFileLike(generatedAbsoluteFilePath);
        const sourceFileAbsolutePaths = map2.sources.map((source)=>getNormalizedAbsolutePath(source, sourceRoot));
        const sourceToSourceIndexMap = new Map(sourceFileAbsolutePaths.map((source, i)=>[
                host.getCanonicalFileName(source),
                i
            ]));
        let decodedMappings;
        let generatedMappings;
        let sourceMappings;
        return {
            getSourcePosition: getSourcePosition,
            getGeneratedPosition: getGeneratedPosition
        };
        function processMapping(mapping) {
            const generatedPosition = generatedFile !== void 0 ? getPositionOfLineAndCharacter(generatedFile, mapping.generatedLine, mapping.generatedCharacter, /*allowEdits*/ true) : -1;
            let source;
            let sourcePosition;
            if (isSourceMapping(mapping)) {
                const sourceFile = host.getSourceFileLike(sourceFileAbsolutePaths[mapping.sourceIndex]);
                source = map2.sources[mapping.sourceIndex];
                sourcePosition = sourceFile !== void 0 ? getPositionOfLineAndCharacter(sourceFile, mapping.sourceLine, mapping.sourceCharacter, /*allowEdits*/ true) : -1;
            }
            return {
                generatedPosition: generatedPosition,
                source: source,
                sourceIndex: mapping.sourceIndex,
                sourcePosition: sourcePosition,
                nameIndex: mapping.nameIndex
            };
        }
        function getDecodedMappings() {
            if (decodedMappings === void 0) {
                const decoder = decodeMappings(map2.mappings);
                const mappings = arrayFrom(decoder, processMapping);
                if (decoder.error !== void 0) {
                    if (host.log) host.log(`Encountered error while decoding sourcemap: ${decoder.error}`);
                    decodedMappings = emptyArray;
                } else decodedMappings = mappings;
            }
            return decodedMappings;
        }
        function getSourceMappings(sourceIndex) {
            if (sourceMappings === void 0) {
                const lists = [];
                for (const mapping of getDecodedMappings()){
                    if (!isSourceMappedPosition(mapping)) continue;
                    let list = lists[mapping.sourceIndex];
                    if (!list) lists[mapping.sourceIndex] = list = [];
                    list.push(mapping);
                }
                sourceMappings = lists.map((list)=>sortAndDeduplicate(list, compareSourcePositions, sameMappedPosition));
            }
            return sourceMappings[sourceIndex];
        }
        function getGeneratedMappings() {
            if (generatedMappings === void 0) {
                const list = [];
                for (const mapping of getDecodedMappings())list.push(mapping);
                generatedMappings = sortAndDeduplicate(list, compareGeneratedPositions, sameMappedPosition);
            }
            return generatedMappings;
        }
        function getGeneratedPosition(loc) {
            const sourceIndex = sourceToSourceIndexMap.get(host.getCanonicalFileName(loc.fileName));
            if (sourceIndex === void 0) return loc;
            const sourceMappings2 = getSourceMappings(sourceIndex);
            if (!some(sourceMappings2)) return loc;
            let targetIndex = binarySearchKey(sourceMappings2, loc.pos, getSourcePositionOfMapping, compareValues);
            if (targetIndex < 0) targetIndex = ~targetIndex;
            const mapping = sourceMappings2[targetIndex];
            if (mapping === void 0 || mapping.sourceIndex !== sourceIndex) return loc;
            return {
                fileName: generatedAbsoluteFilePath,
                pos: mapping.generatedPosition
            };
        }
        function getSourcePosition(loc) {
            const generatedMappings2 = getGeneratedMappings();
            if (!some(generatedMappings2)) return loc;
            let targetIndex = binarySearchKey(generatedMappings2, loc.pos, getGeneratedPositionOfMapping, compareValues);
            if (targetIndex < 0) targetIndex = ~targetIndex;
            const mapping = generatedMappings2[targetIndex];
            if (mapping === void 0 || !isSourceMappedPosition(mapping)) return loc;
            return {
                fileName: sourceFileAbsolutePaths[mapping.sourceIndex],
                pos: mapping.sourcePosition
            };
        }
    }
    var sourceMapCommentRegExpDontCareLineStart, sourceMapCommentRegExp, whitespaceOrMapCommentRegExp, identitySourceMapConsumer;
    var init_sourcemap = __esm({
        "src/compiler/sourcemap.ts" () {
            "use strict";
            init_ts2();
            init_ts_performance();
            sourceMapCommentRegExpDontCareLineStart = /\/\/[@#] source[M]appingURL=(.+)\r?\n?$/;
            sourceMapCommentRegExp = /^\/\/[@#] source[M]appingURL=(.+)\r?\n?$/;
            whitespaceOrMapCommentRegExp = /^\s*(\/\/[@#] .*)?$/;
            identitySourceMapConsumer = {
                getSourcePosition: identity,
                getGeneratedPosition: identity
            };
        }
    });
    // src/compiler/transformers/utilities.ts
    function getOriginalNodeId(node) {
        node = getOriginalNode(node);
        return node ? getNodeId(node) : 0;
    }
    function containsDefaultReference(node) {
        if (!node) return false;
        if (!isNamedImports(node)) return false;
        return some(node.elements, isNamedDefaultReference);
    }
    function isNamedDefaultReference(e) {
        return e.propertyName !== void 0 && e.propertyName.escapedText === "default" /* Default */ ;
    }
    function chainBundle(context, transformSourceFile) {
        return transformSourceFileOrBundle;
        function transformSourceFileOrBundle(node) {
            return node.kind === 311 /* SourceFile */  ? transformSourceFile(node) : transformBundle(node);
        }
        function transformBundle(node) {
            return context.factory.createBundle(map(node.sourceFiles, transformSourceFile), node.prepends);
        }
    }
    function getExportNeedsImportStarHelper(node) {
        return !!getNamespaceDeclarationNode(node);
    }
    function getImportNeedsImportStarHelper(node) {
        if (!!getNamespaceDeclarationNode(node)) return true;
        const bindings = node.importClause && node.importClause.namedBindings;
        if (!bindings) return false;
        if (!isNamedImports(bindings)) return false;
        let defaultRefCount = 0;
        for (const binding of bindings.elements)if (isNamedDefaultReference(binding)) defaultRefCount++;
        return defaultRefCount > 0 && defaultRefCount !== bindings.elements.length || !!(bindings.elements.length - defaultRefCount) && isDefaultImport(node);
    }
    function getImportNeedsImportDefaultHelper(node) {
        return !getImportNeedsImportStarHelper(node) && (isDefaultImport(node) || !!node.importClause && isNamedImports(node.importClause.namedBindings) && containsDefaultReference(node.importClause.namedBindings));
    }
    function collectExternalModuleInfo(context, sourceFile, resolver, compilerOptions) {
        const externalImports = [];
        const exportSpecifiers = createMultiMap();
        const exportedBindings = [];
        const uniqueExports = /* @__PURE__ */ new Map();
        let exportedNames;
        let hasExportDefault = false;
        let exportEquals;
        let hasExportStarsToExportValues = false;
        let hasImportStar = false;
        let hasImportDefault = false;
        for (const node of sourceFile.statements)switch(node.kind){
            case 271 /* ImportDeclaration */ :
                externalImports.push(node);
                if (!hasImportStar && getImportNeedsImportStarHelper(node)) hasImportStar = true;
                if (!hasImportDefault && getImportNeedsImportDefaultHelper(node)) hasImportDefault = true;
                break;
            case 270 /* ImportEqualsDeclaration */ :
                if (node.moduleReference.kind === 282 /* ExternalModuleReference */ ) externalImports.push(node);
                break;
            case 277 /* ExportDeclaration */ :
                if (node.moduleSpecifier) {
                    if (!node.exportClause) {
                        externalImports.push(node);
                        hasExportStarsToExportValues = true;
                    } else {
                        externalImports.push(node);
                        if (isNamedExports(node.exportClause)) addExportedNamesForExportDeclaration(node);
                        else {
                            const name = node.exportClause.name;
                            if (!uniqueExports.get(idText(name))) {
                                multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), name);
                                uniqueExports.set(idText(name), true);
                                exportedNames = append(exportedNames, name);
                            }
                            hasImportStar = true;
                        }
                    }
                } else addExportedNamesForExportDeclaration(node);
                break;
            case 276 /* ExportAssignment */ :
                if (node.isExportEquals && !exportEquals) exportEquals = node;
                break;
            case 242 /* VariableStatement */ :
                if (hasSyntacticModifier(node, 1 /* Export */ )) for (const decl of node.declarationList.declarations)exportedNames = collectExportedVariableInfo(decl, uniqueExports, exportedNames, exportedBindings);
                break;
            case 261 /* FunctionDeclaration */ :
                if (hasSyntacticModifier(node, 1 /* Export */ )) {
                    if (hasSyntacticModifier(node, 1024 /* Default */ )) {
                        if (!hasExportDefault) {
                            multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), context.factory.getDeclarationName(node));
                            hasExportDefault = true;
                        }
                    } else {
                        const name = node.name;
                        if (!uniqueExports.get(idText(name))) {
                            multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), name);
                            uniqueExports.set(idText(name), true);
                            exportedNames = append(exportedNames, name);
                        }
                    }
                }
                break;
            case 262 /* ClassDeclaration */ :
                if (hasSyntacticModifier(node, 1 /* Export */ )) {
                    if (hasSyntacticModifier(node, 1024 /* Default */ )) {
                        if (!hasExportDefault) {
                            multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), context.factory.getDeclarationName(node));
                            hasExportDefault = true;
                        }
                    } else {
                        const name = node.name;
                        if (name && !uniqueExports.get(idText(name))) {
                            multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), name);
                            uniqueExports.set(idText(name), true);
                            exportedNames = append(exportedNames, name);
                        }
                    }
                }
                break;
        }
        const externalHelpersImportDeclaration = createExternalHelpersImportDeclarationIfNeeded(context.factory, context.getEmitHelperFactory(), sourceFile, compilerOptions, hasExportStarsToExportValues, hasImportStar, hasImportDefault);
        if (externalHelpersImportDeclaration) externalImports.unshift(externalHelpersImportDeclaration);
        return {
            externalImports: externalImports,
            exportSpecifiers: exportSpecifiers,
            exportEquals: exportEquals,
            hasExportStarsToExportValues: hasExportStarsToExportValues,
            exportedBindings: exportedBindings,
            exportedNames: exportedNames,
            externalHelpersImportDeclaration: externalHelpersImportDeclaration
        };
        function addExportedNamesForExportDeclaration(node) {
            for (const specifier of cast(node.exportClause, isNamedExports).elements)if (!uniqueExports.get(idText(specifier.name))) {
                const name = specifier.propertyName || specifier.name;
                if (!node.moduleSpecifier) exportSpecifiers.add(idText(name), specifier);
                const decl = resolver.getReferencedImportDeclaration(name) || resolver.getReferencedValueDeclaration(name);
                if (decl) multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(decl), specifier.name);
                uniqueExports.set(idText(specifier.name), true);
                exportedNames = append(exportedNames, specifier.name);
            }
        }
    }
    function collectExportedVariableInfo(decl, uniqueExports, exportedNames, exportedBindings) {
        if (isBindingPattern(decl.name)) {
            for (const element of decl.name.elements)if (!isOmittedExpression(element)) exportedNames = collectExportedVariableInfo(element, uniqueExports, exportedNames, exportedBindings);
        } else if (!isGeneratedIdentifier(decl.name)) {
            const text = idText(decl.name);
            if (!uniqueExports.get(text)) {
                uniqueExports.set(text, true);
                exportedNames = append(exportedNames, decl.name);
                if (isLocalName(decl.name)) multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(decl), decl.name);
            }
        }
        return exportedNames;
    }
    function multiMapSparseArrayAdd(map2, key, value1) {
        let values = map2[key];
        if (values) values.push(value1);
        else map2[key] = values = [
            value1
        ];
        return values;
    }
    function isSimpleCopiableExpression(expression) {
        return isStringLiteralLike(expression) || expression.kind === 9 /* NumericLiteral */  || isKeyword(expression.kind) || isIdentifier(expression);
    }
    function isSimpleInlineableExpression(expression) {
        return !isIdentifier(expression) && isSimpleCopiableExpression(expression);
    }
    function isCompoundAssignment(kind) {
        return kind >= 65 /* FirstCompoundAssignment */  && kind <= 79 /* LastCompoundAssignment */ ;
    }
    function getNonAssignmentOperatorForCompoundAssignment(kind) {
        switch(kind){
            case 65 /* PlusEqualsToken */ :
                return 40 /* PlusToken */ ;
            case 66 /* MinusEqualsToken */ :
                return 41 /* MinusToken */ ;
            case 67 /* AsteriskEqualsToken */ :
                return 42 /* AsteriskToken */ ;
            case 68 /* AsteriskAsteriskEqualsToken */ :
                return 43 /* AsteriskAsteriskToken */ ;
            case 69 /* SlashEqualsToken */ :
                return 44 /* SlashToken */ ;
            case 70 /* PercentEqualsToken */ :
                return 45 /* PercentToken */ ;
            case 71 /* LessThanLessThanEqualsToken */ :
                return 48 /* LessThanLessThanToken */ ;
            case 72 /* GreaterThanGreaterThanEqualsToken */ :
                return 49 /* GreaterThanGreaterThanToken */ ;
            case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                return 50 /* GreaterThanGreaterThanGreaterThanToken */ ;
            case 74 /* AmpersandEqualsToken */ :
                return 51 /* AmpersandToken */ ;
            case 75 /* BarEqualsToken */ :
                return 52 /* BarToken */ ;
            case 79 /* CaretEqualsToken */ :
                return 53 /* CaretToken */ ;
            case 76 /* BarBarEqualsToken */ :
                return 57 /* BarBarToken */ ;
            case 77 /* AmpersandAmpersandEqualsToken */ :
                return 56 /* AmpersandAmpersandToken */ ;
            case 78 /* QuestionQuestionEqualsToken */ :
                return 61 /* QuestionQuestionToken */ ;
        }
    }
    function getSuperCallFromStatement(statement) {
        if (!isExpressionStatement(statement)) return void 0;
        const expression = skipParentheses(statement.expression);
        return isSuperCall(expression) ? expression : void 0;
    }
    function findSuperStatementIndex(statements, indexAfterLastPrologueStatement) {
        for(let i = indexAfterLastPrologueStatement; i < statements.length; i += 1){
            const statement = statements[i];
            if (getSuperCallFromStatement(statement)) return i;
        }
        return -1;
    }
    function getProperties(node, requireInitializer, isStatic2) {
        return filter(node.members, (m)=>isInitializedOrStaticProperty(m, requireInitializer, isStatic2));
    }
    function isStaticPropertyDeclarationOrClassStaticBlockDeclaration(element) {
        return isStaticPropertyDeclaration(element) || isClassStaticBlockDeclaration(element);
    }
    function getStaticPropertiesAndClassStaticBlock(node) {
        return filter(node.members, isStaticPropertyDeclarationOrClassStaticBlockDeclaration);
    }
    function isInitializedOrStaticProperty(member, requireInitializer, isStatic2) {
        return isPropertyDeclaration(member) && (!!member.initializer || !requireInitializer) && hasStaticModifier(member) === isStatic2;
    }
    function isStaticPropertyDeclaration(member) {
        return isPropertyDeclaration(member) && hasStaticModifier(member);
    }
    function isInitializedProperty(member) {
        return member.kind === 171 /* PropertyDeclaration */  && member.initializer !== void 0;
    }
    function isNonStaticMethodOrAccessorWithPrivateName(member) {
        return !isStatic(member) && (isMethodOrAccessor(member) || isAutoAccessorPropertyDeclaration(member)) && isPrivateIdentifier(member.name);
    }
    function getDecoratorsOfParameters(node) {
        let decorators;
        if (node) {
            const parameters = node.parameters;
            const firstParameterIsThis = parameters.length > 0 && parameterIsThisKeyword(parameters[0]);
            const firstParameterOffset = firstParameterIsThis ? 1 : 0;
            const numParameters = firstParameterIsThis ? parameters.length - 1 : parameters.length;
            for(let i = 0; i < numParameters; i++){
                const parameter = parameters[i + firstParameterOffset];
                if (decorators || hasDecorators(parameter)) {
                    if (!decorators) decorators = new Array(numParameters);
                    decorators[i] = getDecorators(parameter);
                }
            }
        }
        return decorators;
    }
    function getAllDecoratorsOfClass(node) {
        const decorators = getDecorators(node);
        const parameters = getDecoratorsOfParameters(getFirstConstructorWithBody(node));
        if (!some(decorators) && !some(parameters)) return void 0;
        return {
            decorators: decorators,
            parameters: parameters
        };
    }
    function getAllDecoratorsOfClassElement(member, parent2, useLegacyDecorators) {
        switch(member.kind){
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
                if (!useLegacyDecorators) return getAllDecoratorsOfMethod(member);
                return getAllDecoratorsOfAccessors(member, parent2);
            case 173 /* MethodDeclaration */ :
                return getAllDecoratorsOfMethod(member);
            case 171 /* PropertyDeclaration */ :
                return getAllDecoratorsOfProperty(member);
            default:
                return void 0;
        }
    }
    function getAllDecoratorsOfAccessors(accessor, parent2) {
        if (!accessor.body) return void 0;
        const { firstAccessor: firstAccessor , secondAccessor: secondAccessor , getAccessor: getAccessor , setAccessor: setAccessor  } = getAllAccessorDeclarations(parent2.members, accessor);
        const firstAccessorWithDecorators = hasDecorators(firstAccessor) ? firstAccessor : secondAccessor && hasDecorators(secondAccessor) ? secondAccessor : void 0;
        if (!firstAccessorWithDecorators || accessor !== firstAccessorWithDecorators) return void 0;
        const decorators = getDecorators(firstAccessorWithDecorators);
        const parameters = getDecoratorsOfParameters(setAccessor);
        if (!some(decorators) && !some(parameters)) return void 0;
        return {
            decorators: decorators,
            parameters: parameters,
            getDecorators: getAccessor && getDecorators(getAccessor),
            setDecorators: setAccessor && getDecorators(setAccessor)
        };
    }
    function getAllDecoratorsOfMethod(method) {
        if (!method.body) return void 0;
        const decorators = getDecorators(method);
        const parameters = getDecoratorsOfParameters(method);
        if (!some(decorators) && !some(parameters)) return void 0;
        return {
            decorators: decorators,
            parameters: parameters
        };
    }
    function getAllDecoratorsOfProperty(property) {
        const decorators = getDecorators(property);
        if (!some(decorators)) return void 0;
        return {
            decorators: decorators
        };
    }
    function walkUpLexicalEnvironments(env, cb) {
        while(env){
            const result = cb(env);
            if (result !== void 0) return result;
            env = env.previous;
        }
    }
    function newPrivateEnvironment(data) {
        return {
            data: data
        };
    }
    function getPrivateIdentifier(privateEnv, name) {
        var _a, _b;
        return isGeneratedPrivateIdentifier(name) ? (_a = privateEnv == null ? void 0 : privateEnv.generatedIdentifiers) == null ? void 0 : _a.get(getNodeForGeneratedName(name)) : (_b = privateEnv == null ? void 0 : privateEnv.identifiers) == null ? void 0 : _b.get(name.escapedText);
    }
    function setPrivateIdentifier(privateEnv, name, entry) {
        if (isGeneratedPrivateIdentifier(name)) {
            privateEnv.generatedIdentifiers ?? (privateEnv.generatedIdentifiers = /* @__PURE__ */ new Map());
            privateEnv.generatedIdentifiers.set(getNodeForGeneratedName(name), entry);
        } else {
            privateEnv.identifiers ?? (privateEnv.identifiers = /* @__PURE__ */ new Map());
            privateEnv.identifiers.set(name.escapedText, entry);
        }
    }
    function accessPrivateIdentifier(env, name) {
        return walkUpLexicalEnvironments(env, (env2)=>getPrivateIdentifier(env2.privateEnv, name));
    }
    var init_utilities3 = __esm({
        "src/compiler/transformers/utilities.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/destructuring.ts
    function flattenDestructuringAssignment(node, visitor, context, level, needsValue, createAssignmentCallback) {
        let location = node;
        let value1;
        if (isDestructuringAssignment(node)) {
            value1 = node.right;
            while(isEmptyArrayLiteral(node.left) || isEmptyObjectLiteral(node.left)){
                if (isDestructuringAssignment(value1)) {
                    location = node = value1;
                    value1 = node.right;
                } else return Debug.checkDefined(visitNode(value1, visitor, isExpression));
            }
        }
        let expressions;
        const flattenContext = {
            context: context,
            level: level,
            downlevelIteration: !!context.getCompilerOptions().downlevelIteration,
            hoistTempVariables: true,
            emitExpression: emitExpression,
            emitBindingOrAssignment: emitBindingOrAssignment,
            createArrayBindingOrAssignmentPattern: (elements)=>makeArrayAssignmentPattern(context.factory, elements),
            createObjectBindingOrAssignmentPattern: (elements)=>makeObjectAssignmentPattern(context.factory, elements),
            createArrayBindingOrAssignmentElement: makeAssignmentElement,
            visitor: visitor
        };
        if (value1) {
            value1 = visitNode(value1, visitor, isExpression);
            Debug.assert(value1);
            if (isIdentifier(value1) && bindingOrAssignmentElementAssignsToName(node, value1.escapedText) || bindingOrAssignmentElementContainsNonLiteralComputedName(node)) value1 = ensureIdentifier(flattenContext, value1, /*reuseIdentifierExpressions*/ false, location);
            else if (needsValue) value1 = ensureIdentifier(flattenContext, value1, /*reuseIdentifierExpressions*/ true, location);
            else if (nodeIsSynthesized(node)) location = value1;
        }
        flattenBindingOrAssignmentElement(flattenContext, node, value1, location, /*skipInitializer*/ isDestructuringAssignment(node));
        if (value1 && needsValue) {
            if (!some(expressions)) return value1;
            expressions.push(value1);
        }
        return context.factory.inlineExpressions(expressions) || context.factory.createOmittedExpression();
        function emitExpression(expression) {
            expressions = append(expressions, expression);
        }
        function emitBindingOrAssignment(target, value2, location2, original) {
            Debug.assertNode(target, createAssignmentCallback ? isIdentifier : isExpression);
            const expression = createAssignmentCallback ? createAssignmentCallback(target, value2, location2) : setTextRange(context.factory.createAssignment(Debug.checkDefined(visitNode(target, visitor, isExpression)), value2), location2);
            expression.original = original;
            emitExpression(expression);
        }
    }
    function bindingOrAssignmentElementAssignsToName(element, escapedName) {
        const target = getTargetOfBindingOrAssignmentElement(element);
        if (isBindingOrAssignmentPattern(target)) return bindingOrAssignmentPatternAssignsToName(target, escapedName);
        else if (isIdentifier(target)) return target.escapedText === escapedName;
        return false;
    }
    function bindingOrAssignmentPatternAssignsToName(pattern, escapedName) {
        const elements = getElementsOfBindingOrAssignmentPattern(pattern);
        for (const element of elements){
            if (bindingOrAssignmentElementAssignsToName(element, escapedName)) return true;
        }
        return false;
    }
    function bindingOrAssignmentElementContainsNonLiteralComputedName(element) {
        const propertyName = tryGetPropertyNameOfBindingOrAssignmentElement(element);
        if (propertyName && isComputedPropertyName(propertyName) && !isLiteralExpression(propertyName.expression)) return true;
        const target = getTargetOfBindingOrAssignmentElement(element);
        return !!target && isBindingOrAssignmentPattern(target) && bindingOrAssignmentPatternContainsNonLiteralComputedName(target);
    }
    function bindingOrAssignmentPatternContainsNonLiteralComputedName(pattern) {
        return !!forEach(getElementsOfBindingOrAssignmentPattern(pattern), bindingOrAssignmentElementContainsNonLiteralComputedName);
    }
    function flattenDestructuringBinding(node, visitor, context, level, rval, hoistTempVariables = false, skipInitializer) {
        let pendingExpressions;
        const pendingDeclarations = [];
        const declarations = [];
        const flattenContext = {
            context: context,
            level: level,
            downlevelIteration: !!context.getCompilerOptions().downlevelIteration,
            hoistTempVariables: hoistTempVariables,
            emitExpression: emitExpression,
            emitBindingOrAssignment: emitBindingOrAssignment,
            createArrayBindingOrAssignmentPattern: (elements)=>makeArrayBindingPattern(context.factory, elements),
            createObjectBindingOrAssignmentPattern: (elements)=>makeObjectBindingPattern(context.factory, elements),
            createArrayBindingOrAssignmentElement: (name)=>makeBindingElement(context.factory, name),
            visitor: visitor
        };
        if (isVariableDeclaration(node)) {
            let initializer = getInitializerOfBindingOrAssignmentElement(node);
            if (initializer && (isIdentifier(initializer) && bindingOrAssignmentElementAssignsToName(node, initializer.escapedText) || bindingOrAssignmentElementContainsNonLiteralComputedName(node))) {
                initializer = ensureIdentifier(flattenContext, Debug.checkDefined(visitNode(initializer, flattenContext.visitor, isExpression)), /*reuseIdentifierExpressions*/ false, initializer);
                node = context.factory.updateVariableDeclaration(node, node.name, /*exclamationToken*/ void 0, /*type*/ void 0, initializer);
            }
        }
        flattenBindingOrAssignmentElement(flattenContext, node, rval, node, skipInitializer);
        if (pendingExpressions) {
            const temp = context.factory.createTempVariable(/*recordTempVariable*/ void 0);
            if (hoistTempVariables) {
                const value1 = context.factory.inlineExpressions(pendingExpressions);
                pendingExpressions = void 0;
                emitBindingOrAssignment(temp, value1, /*location*/ void 0, /*original*/ void 0);
            } else {
                context.hoistVariableDeclaration(temp);
                const pendingDeclaration = last(pendingDeclarations);
                pendingDeclaration.pendingExpressions = append(pendingDeclaration.pendingExpressions, context.factory.createAssignment(temp, pendingDeclaration.value));
                addRange(pendingDeclaration.pendingExpressions, pendingExpressions);
                pendingDeclaration.value = temp;
            }
        }
        for (const { pendingExpressions: pendingExpressions2 , name: name , value: value1 , location: location , original: original  } of pendingDeclarations){
            const variable = context.factory.createVariableDeclaration(name, /*exclamationToken*/ void 0, /*type*/ void 0, pendingExpressions2 ? context.factory.inlineExpressions(append(pendingExpressions2, value1)) : value1);
            variable.original = original;
            setTextRange(variable, location);
            declarations.push(variable);
        }
        return declarations;
        function emitExpression(value1) {
            pendingExpressions = append(pendingExpressions, value1);
        }
        function emitBindingOrAssignment(target, value1, location, original) {
            Debug.assertNode(target, isBindingName);
            if (pendingExpressions) {
                value1 = context.factory.inlineExpressions(append(pendingExpressions, value1));
                pendingExpressions = void 0;
            }
            pendingDeclarations.push({
                pendingExpressions: pendingExpressions,
                name: target,
                value: value1,
                location: location,
                original: original
            });
        }
    }
    function flattenBindingOrAssignmentElement(flattenContext, element, value1, location, skipInitializer) {
        const bindingTarget = getTargetOfBindingOrAssignmentElement(element);
        if (!skipInitializer) {
            const initializer = visitNode(getInitializerOfBindingOrAssignmentElement(element), flattenContext.visitor, isExpression);
            if (initializer) {
                if (value1) {
                    value1 = createDefaultValueCheck(flattenContext, value1, initializer, location);
                    if (!isSimpleInlineableExpression(initializer) && isBindingOrAssignmentPattern(bindingTarget)) value1 = ensureIdentifier(flattenContext, value1, /*reuseIdentifierExpressions*/ true, location);
                } else value1 = initializer;
            } else if (!value1) value1 = flattenContext.context.factory.createVoidZero();
        }
        if (isObjectBindingOrAssignmentPattern(bindingTarget)) flattenObjectBindingOrAssignmentPattern(flattenContext, element, bindingTarget, value1, location);
        else if (isArrayBindingOrAssignmentPattern(bindingTarget)) flattenArrayBindingOrAssignmentPattern(flattenContext, element, bindingTarget, value1, location);
        else flattenContext.emitBindingOrAssignment(bindingTarget, value1, location, /*original*/ element);
    }
    function flattenObjectBindingOrAssignmentPattern(flattenContext, parent2, pattern, value1, location) {
        const elements = getElementsOfBindingOrAssignmentPattern(pattern);
        const numElements = elements.length;
        if (numElements !== 1) {
            const reuseIdentifierExpressions = !isDeclarationBindingElement(parent2) || numElements !== 0;
            value1 = ensureIdentifier(flattenContext, value1, reuseIdentifierExpressions, location);
        }
        let bindingElements;
        let computedTempVariables;
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            if (!getRestIndicatorOfBindingOrAssignmentElement(element)) {
                const propertyName = getPropertyNameOfBindingOrAssignmentElement(element);
                if (flattenContext.level >= 1 /* ObjectRest */  && !(element.transformFlags & 98304 /* ContainsObjectRestOrSpread */ ) && !(getTargetOfBindingOrAssignmentElement(element).transformFlags & 98304 /* ContainsObjectRestOrSpread */ ) && !isComputedPropertyName(propertyName)) bindingElements = append(bindingElements, visitNode(element, flattenContext.visitor, isBindingOrAssignmentElement));
                else {
                    if (bindingElements) {
                        flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value1, location, pattern);
                        bindingElements = void 0;
                    }
                    const rhsValue = createDestructuringPropertyAccess(flattenContext, value1, propertyName);
                    if (isComputedPropertyName(propertyName)) computedTempVariables = append(computedTempVariables, rhsValue.argumentExpression);
                    flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
                }
            } else if (i === numElements - 1) {
                if (bindingElements) {
                    flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value1, location, pattern);
                    bindingElements = void 0;
                }
                const rhsValue = flattenContext.context.getEmitHelperFactory().createRestHelper(value1, elements, computedTempVariables, pattern);
                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, element);
            }
        }
        if (bindingElements) flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value1, location, pattern);
    }
    function flattenArrayBindingOrAssignmentPattern(flattenContext, parent2, pattern, value1, location) {
        const elements = getElementsOfBindingOrAssignmentPattern(pattern);
        const numElements = elements.length;
        if (flattenContext.level < 1 /* ObjectRest */  && flattenContext.downlevelIteration) value1 = ensureIdentifier(flattenContext, setTextRange(flattenContext.context.getEmitHelperFactory().createReadHelper(value1, numElements > 0 && getRestIndicatorOfBindingOrAssignmentElement(elements[numElements - 1]) ? void 0 : numElements), location), /*reuseIdentifierExpressions*/ false, location);
        else if (numElements !== 1 && (flattenContext.level < 1 /* ObjectRest */  || numElements === 0) || every(elements, isOmittedExpression)) {
            const reuseIdentifierExpressions = !isDeclarationBindingElement(parent2) || numElements !== 0;
            value1 = ensureIdentifier(flattenContext, value1, reuseIdentifierExpressions, location);
        }
        let bindingElements;
        let restContainingElements;
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            if (flattenContext.level >= 1 /* ObjectRest */ ) {
                if (element.transformFlags & 65536 /* ContainsObjectRestOrSpread */  || flattenContext.hasTransformedPriorElement && !isSimpleBindingOrAssignmentElement(element)) {
                    flattenContext.hasTransformedPriorElement = true;
                    const temp = flattenContext.context.factory.createTempVariable(/*recordTempVariable*/ void 0);
                    if (flattenContext.hoistTempVariables) flattenContext.context.hoistVariableDeclaration(temp);
                    restContainingElements = append(restContainingElements, [
                        temp,
                        element
                    ]);
                    bindingElements = append(bindingElements, flattenContext.createArrayBindingOrAssignmentElement(temp));
                } else bindingElements = append(bindingElements, element);
            } else if (isOmittedExpression(element)) continue;
            else if (!getRestIndicatorOfBindingOrAssignmentElement(element)) {
                const rhsValue = flattenContext.context.factory.createElementAccessExpression(value1, i);
                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
            } else if (i === numElements - 1) {
                const rhsValue = flattenContext.context.factory.createArraySliceCall(value1, i);
                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
            }
        }
        if (bindingElements) flattenContext.emitBindingOrAssignment(flattenContext.createArrayBindingOrAssignmentPattern(bindingElements), value1, location, pattern);
        if (restContainingElements) for (const [id, element] of restContainingElements)flattenBindingOrAssignmentElement(flattenContext, element, id, element);
    }
    function isSimpleBindingOrAssignmentElement(element) {
        const target = getTargetOfBindingOrAssignmentElement(element);
        if (!target || isOmittedExpression(target)) return true;
        const propertyName = tryGetPropertyNameOfBindingOrAssignmentElement(element);
        if (propertyName && !isPropertyNameLiteral(propertyName)) return false;
        const initializer = getInitializerOfBindingOrAssignmentElement(element);
        if (initializer && !isSimpleInlineableExpression(initializer)) return false;
        if (isBindingOrAssignmentPattern(target)) return every(getElementsOfBindingOrAssignmentPattern(target), isSimpleBindingOrAssignmentElement);
        return isIdentifier(target);
    }
    function createDefaultValueCheck(flattenContext, value1, defaultValue, location) {
        value1 = ensureIdentifier(flattenContext, value1, /*reuseIdentifierExpressions*/ true, location);
        return flattenContext.context.factory.createConditionalExpression(flattenContext.context.factory.createTypeCheck(value1, "undefined"), /*questionToken*/ void 0, defaultValue, /*colonToken*/ void 0, value1);
    }
    function createDestructuringPropertyAccess(flattenContext, value1, propertyName) {
        const { factory: factory2  } = flattenContext.context;
        if (isComputedPropertyName(propertyName)) {
            const argumentExpression = ensureIdentifier(flattenContext, Debug.checkDefined(visitNode(propertyName.expression, flattenContext.visitor, isExpression)), /*reuseIdentifierExpressions*/ false, /*location*/ propertyName);
            return flattenContext.context.factory.createElementAccessExpression(value1, argumentExpression);
        } else if (isStringOrNumericLiteralLike(propertyName)) {
            const argumentExpression = factory2.cloneNode(propertyName);
            return flattenContext.context.factory.createElementAccessExpression(value1, argumentExpression);
        } else {
            const name = flattenContext.context.factory.createIdentifier(idText(propertyName));
            return flattenContext.context.factory.createPropertyAccessExpression(value1, name);
        }
    }
    function ensureIdentifier(flattenContext, value1, reuseIdentifierExpressions, location) {
        if (isIdentifier(value1) && reuseIdentifierExpressions) return value1;
        else {
            const temp = flattenContext.context.factory.createTempVariable(/*recordTempVariable*/ void 0);
            if (flattenContext.hoistTempVariables) {
                flattenContext.context.hoistVariableDeclaration(temp);
                flattenContext.emitExpression(setTextRange(flattenContext.context.factory.createAssignment(temp, value1), location));
            } else flattenContext.emitBindingOrAssignment(temp, value1, location, /*original*/ void 0);
            return temp;
        }
    }
    function makeArrayBindingPattern(factory2, elements) {
        Debug.assertEachNode(elements, isArrayBindingElement);
        return factory2.createArrayBindingPattern(elements);
    }
    function makeArrayAssignmentPattern(factory2, elements) {
        Debug.assertEachNode(elements, isArrayBindingOrAssignmentElement);
        return factory2.createArrayLiteralExpression(map(elements, factory2.converters.convertToArrayAssignmentElement));
    }
    function makeObjectBindingPattern(factory2, elements) {
        Debug.assertEachNode(elements, isBindingElement);
        return factory2.createObjectBindingPattern(elements);
    }
    function makeObjectAssignmentPattern(factory2, elements) {
        Debug.assertEachNode(elements, isObjectBindingOrAssignmentElement);
        return factory2.createObjectLiteralExpression(map(elements, factory2.converters.convertToObjectAssignmentElement));
    }
    function makeBindingElement(factory2, name) {
        return factory2.createBindingElement(/*dotDotDotToken*/ void 0, /*propertyName*/ void 0, name);
    }
    function makeAssignmentElement(name) {
        return name;
    }
    var FlattenLevel;
    var init_destructuring = __esm({
        "src/compiler/transformers/destructuring.ts" () {
            "use strict";
            init_ts2();
            FlattenLevel = /* @__PURE__ */ ((FlattenLevel2)=>{
                FlattenLevel2[FlattenLevel2["All"] = 0] = "All";
                FlattenLevel2[FlattenLevel2["ObjectRest"] = 1] = "ObjectRest";
                return FlattenLevel2;
            })(FlattenLevel || {});
        }
    });
    // src/compiler/transformers/taggedTemplate.ts
    function processTaggedTemplateExpression(context, node, visitor, currentSourceFile, recordTaggedTemplateString, level) {
        const tag = visitNode(node.tag, visitor, isExpression);
        Debug.assert(tag);
        const templateArguments = [
            void 0
        ];
        const cookedStrings = [];
        const rawStrings = [];
        const template = node.template;
        if (level === 0 /* LiftRestriction */  && !hasInvalidEscape(template)) return visitEachChild(node, visitor, context);
        const { factory: factory2  } = context;
        if (isNoSubstitutionTemplateLiteral(template)) {
            cookedStrings.push(createTemplateCooked(factory2, template));
            rawStrings.push(getRawLiteral(factory2, template, currentSourceFile));
        } else {
            cookedStrings.push(createTemplateCooked(factory2, template.head));
            rawStrings.push(getRawLiteral(factory2, template.head, currentSourceFile));
            for (const templateSpan of template.templateSpans){
                cookedStrings.push(createTemplateCooked(factory2, templateSpan.literal));
                rawStrings.push(getRawLiteral(factory2, templateSpan.literal, currentSourceFile));
                templateArguments.push(Debug.checkDefined(visitNode(templateSpan.expression, visitor, isExpression)));
            }
        }
        const helperCall = context.getEmitHelperFactory().createTemplateObjectHelper(factory2.createArrayLiteralExpression(cookedStrings), factory2.createArrayLiteralExpression(rawStrings));
        if (isExternalModule(currentSourceFile)) {
            const tempVar = factory2.createUniqueName("templateObject");
            recordTaggedTemplateString(tempVar);
            templateArguments[0] = factory2.createLogicalOr(tempVar, factory2.createAssignment(tempVar, helperCall));
        } else templateArguments[0] = helperCall;
        return factory2.createCallExpression(tag, /*typeArguments*/ void 0, templateArguments);
    }
    function createTemplateCooked(factory2, template) {
        return template.templateFlags & 26656 /* IsInvalid */  ? factory2.createVoidZero() : factory2.createStringLiteral(template.text);
    }
    function getRawLiteral(factory2, node, currentSourceFile) {
        let text = node.rawText;
        if (text === void 0) {
            Debug.assertIsDefined(currentSourceFile, "Template literal node is missing 'rawText' and does not have a source file. Possibly bad transform.");
            text = getSourceTextOfNodeFromSourceFile(currentSourceFile, node);
            const isLast = node.kind === 15 /* NoSubstitutionTemplateLiteral */  || node.kind === 18 /* TemplateTail */ ;
            text = text.substring(1, text.length - (isLast ? 1 : 2));
        }
        text = text.replace(/\r\n?/g, "\n");
        return setTextRange(factory2.createStringLiteral(text), node);
    }
    var ProcessLevel;
    var init_taggedTemplate = __esm({
        "src/compiler/transformers/taggedTemplate.ts" () {
            "use strict";
            init_ts2();
            ProcessLevel = /* @__PURE__ */ ((ProcessLevel2)=>{
                ProcessLevel2[ProcessLevel2["LiftRestriction"] = 0] = "LiftRestriction";
                ProcessLevel2[ProcessLevel2["All"] = 1] = "All";
                return ProcessLevel2;
            })(ProcessLevel || {});
        }
    });
    // src/compiler/transformers/ts.ts
    function transformTypeScript(context) {
        const { factory: factory2 , getEmitHelperFactory: emitHelpers , startLexicalEnvironment: startLexicalEnvironment , resumeLexicalEnvironment: resumeLexicalEnvironment , endLexicalEnvironment: endLexicalEnvironment , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const moduleKind = getEmitModuleKind(compilerOptions);
        const legacyDecorators = !!compilerOptions.experimentalDecorators;
        const typeSerializer = compilerOptions.emitDecoratorMetadata ? createRuntimeTypeSerializer(context) : void 0;
        const previousOnEmitNode = context.onEmitNode;
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        context.enableSubstitution(210 /* PropertyAccessExpression */ );
        context.enableSubstitution(211 /* ElementAccessExpression */ );
        let currentSourceFile;
        let currentNamespace;
        let currentNamespaceContainerName;
        let currentLexicalScope;
        let currentScopeFirstDeclarationsOfName;
        let currentClassHasParameterProperties;
        let enabledSubstitutions;
        let applicableSubstitutions;
        return transformSourceFileOrBundle;
        function transformSourceFileOrBundle(node) {
            if (node.kind === 312 /* Bundle */ ) return transformBundle(node);
            return transformSourceFile(node);
        }
        function transformBundle(node) {
            return factory2.createBundle(node.sourceFiles.map(transformSourceFile), mapDefined(node.prepends, (prepend)=>{
                if (prepend.kind === 314 /* InputFiles */ ) return createUnparsedSourceFile(prepend, "js");
                return prepend;
            }));
        }
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            currentSourceFile = node;
            const visited = saveStateAndInvoke(node, visitSourceFile);
            addEmitHelpers(visited, context.readEmitHelpers());
            currentSourceFile = void 0;
            return visited;
        }
        function saveStateAndInvoke(node, f) {
            const savedCurrentScope = currentLexicalScope;
            const savedCurrentScopeFirstDeclarationsOfName = currentScopeFirstDeclarationsOfName;
            const savedCurrentClassHasParameterProperties = currentClassHasParameterProperties;
            onBeforeVisitNode(node);
            const visited = f(node);
            if (currentLexicalScope !== savedCurrentScope) currentScopeFirstDeclarationsOfName = savedCurrentScopeFirstDeclarationsOfName;
            currentLexicalScope = savedCurrentScope;
            currentClassHasParameterProperties = savedCurrentClassHasParameterProperties;
            return visited;
        }
        function onBeforeVisitNode(node) {
            switch(node.kind){
                case 311 /* SourceFile */ :
                case 268 /* CaseBlock */ :
                case 267 /* ModuleBlock */ :
                case 240 /* Block */ :
                    currentLexicalScope = node;
                    currentScopeFirstDeclarationsOfName = void 0;
                    break;
                case 262 /* ClassDeclaration */ :
                case 261 /* FunctionDeclaration */ :
                    if (hasSyntacticModifier(node, 2 /* Ambient */ )) break;
                    if (node.name) recordEmittedDeclarationInScope(node);
                    else Debug.assert(node.kind === 262 /* ClassDeclaration */  || hasSyntacticModifier(node, 1024 /* Default */ ));
                    break;
            }
        }
        function visitor(node) {
            return saveStateAndInvoke(node, visitorWorker);
        }
        function visitorWorker(node) {
            if (node.transformFlags & 1 /* ContainsTypeScript */ ) return visitTypeScript(node);
            return node;
        }
        function sourceElementVisitor(node) {
            return saveStateAndInvoke(node, sourceElementVisitorWorker);
        }
        function sourceElementVisitorWorker(node) {
            switch(node.kind){
                case 271 /* ImportDeclaration */ :
                case 270 /* ImportEqualsDeclaration */ :
                case 276 /* ExportAssignment */ :
                case 277 /* ExportDeclaration */ :
                    return visitElidableStatement(node);
                default:
                    return visitorWorker(node);
            }
        }
        function visitElidableStatement(node) {
            const parsed = getParseTreeNode(node);
            if (parsed !== node) {
                if (node.transformFlags & 1 /* ContainsTypeScript */ ) return visitEachChild(node, visitor, context);
                return node;
            }
            switch(node.kind){
                case 271 /* ImportDeclaration */ :
                    return visitImportDeclaration(node);
                case 270 /* ImportEqualsDeclaration */ :
                    return visitImportEqualsDeclaration(node);
                case 276 /* ExportAssignment */ :
                    return visitExportAssignment(node);
                case 277 /* ExportDeclaration */ :
                    return visitExportDeclaration(node);
                default:
                    Debug.fail("Unhandled ellided statement");
            }
        }
        function namespaceElementVisitor(node) {
            return saveStateAndInvoke(node, namespaceElementVisitorWorker);
        }
        function namespaceElementVisitorWorker(node) {
            if (node.kind === 277 /* ExportDeclaration */  || node.kind === 271 /* ImportDeclaration */  || node.kind === 272 /* ImportClause */  || node.kind === 270 /* ImportEqualsDeclaration */  && node.moduleReference.kind === 282 /* ExternalModuleReference */ ) return void 0;
            else if (node.transformFlags & 1 /* ContainsTypeScript */  || hasSyntacticModifier(node, 1 /* Export */ )) return visitTypeScript(node);
            return node;
        }
        function getClassElementVisitor(parent2) {
            return (node)=>saveStateAndInvoke(node, (n)=>classElementVisitorWorker(n, parent2));
        }
        function classElementVisitorWorker(node, parent2) {
            switch(node.kind){
                case 175 /* Constructor */ :
                    return visitConstructor(node);
                case 171 /* PropertyDeclaration */ :
                    return visitPropertyDeclaration(node, parent2);
                case 176 /* GetAccessor */ :
                    return visitGetAccessor(node, parent2);
                case 177 /* SetAccessor */ :
                    return visitSetAccessor(node, parent2);
                case 173 /* MethodDeclaration */ :
                    return visitMethodDeclaration(node, parent2);
                case 174 /* ClassStaticBlockDeclaration */ :
                    return visitEachChild(node, visitor, context);
                case 239 /* SemicolonClassElement */ :
                    return node;
                case 180 /* IndexSignature */ :
                    return;
                default:
                    return Debug.failBadSyntaxKind(node);
            }
        }
        function getObjectLiteralElementVisitor(parent2) {
            return (node)=>saveStateAndInvoke(node, (n)=>objectLiteralElementVisitorWorker(n, parent2));
        }
        function objectLiteralElementVisitorWorker(node, parent2) {
            switch(node.kind){
                case 302 /* PropertyAssignment */ :
                case 303 /* ShorthandPropertyAssignment */ :
                case 304 /* SpreadAssignment */ :
                    return visitor(node);
                case 176 /* GetAccessor */ :
                    return visitGetAccessor(node, parent2);
                case 177 /* SetAccessor */ :
                    return visitSetAccessor(node, parent2);
                case 173 /* MethodDeclaration */ :
                    return visitMethodDeclaration(node, parent2);
                default:
                    return Debug.failBadSyntaxKind(node);
            }
        }
        function decoratorElidingVisitor(node) {
            return isDecorator(node) ? void 0 : visitor(node);
        }
        function modifierElidingVisitor(node) {
            return isModifier(node) ? void 0 : visitor(node);
        }
        function modifierVisitor(node) {
            if (isDecorator(node)) return void 0;
            if (modifierToFlag(node.kind) & 117086 /* TypeScriptModifier */ ) return void 0;
            else if (currentNamespace && node.kind === 95 /* ExportKeyword */ ) return void 0;
            return node;
        }
        function visitTypeScript(node) {
            if (isStatement(node) && hasSyntacticModifier(node, 2 /* Ambient */ )) return factory2.createNotEmittedStatement(node);
            switch(node.kind){
                case 95 /* ExportKeyword */ :
                case 90 /* DefaultKeyword */ :
                    return currentNamespace ? void 0 : node;
                case 125 /* PublicKeyword */ :
                case 123 /* PrivateKeyword */ :
                case 124 /* ProtectedKeyword */ :
                case 128 /* AbstractKeyword */ :
                case 163 /* OverrideKeyword */ :
                case 87 /* ConstKeyword */ :
                case 138 /* DeclareKeyword */ :
                case 148 /* ReadonlyKeyword */ :
                case 103 /* InKeyword */ :
                case 147 /* OutKeyword */ :
                case 187 /* ArrayType */ :
                case 188 /* TupleType */ :
                case 189 /* OptionalType */ :
                case 190 /* RestType */ :
                case 186 /* TypeLiteral */ :
                case 181 /* TypePredicate */ :
                case 167 /* TypeParameter */ :
                case 133 /* AnyKeyword */ :
                case 159 /* UnknownKeyword */ :
                case 136 /* BooleanKeyword */ :
                case 154 /* StringKeyword */ :
                case 150 /* NumberKeyword */ :
                case 146 /* NeverKeyword */ :
                case 116 /* VoidKeyword */ :
                case 155 /* SymbolKeyword */ :
                case 184 /* ConstructorType */ :
                case 183 /* FunctionType */ :
                case 185 /* TypeQuery */ :
                case 182 /* TypeReference */ :
                case 191 /* UnionType */ :
                case 192 /* IntersectionType */ :
                case 193 /* ConditionalType */ :
                case 195 /* ParenthesizedType */ :
                case 196 /* ThisType */ :
                case 197 /* TypeOperator */ :
                case 198 /* IndexedAccessType */ :
                case 199 /* MappedType */ :
                case 200 /* LiteralType */ :
                case 180 /* IndexSignature */ :
                    return void 0;
                case 264 /* TypeAliasDeclaration */ :
                    return factory2.createNotEmittedStatement(node);
                case 269 /* NamespaceExportDeclaration */ :
                    return void 0;
                case 263 /* InterfaceDeclaration */ :
                    return factory2.createNotEmittedStatement(node);
                case 262 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 230 /* ClassExpression */ :
                    return visitClassExpression(node);
                case 297 /* HeritageClause */ :
                    return visitHeritageClause(node);
                case 232 /* ExpressionWithTypeArguments */ :
                    return visitExpressionWithTypeArguments(node);
                case 209 /* ObjectLiteralExpression */ :
                    return visitObjectLiteralExpression(node);
                case 175 /* Constructor */ :
                case 171 /* PropertyDeclaration */ :
                case 173 /* MethodDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                case 174 /* ClassStaticBlockDeclaration */ :
                    return Debug.fail("Class and object literal elements must be visited with their respective visitors");
                case 261 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 217 /* FunctionExpression */ :
                    return visitFunctionExpression(node);
                case 218 /* ArrowFunction */ :
                    return visitArrowFunction(node);
                case 168 /* Parameter */ :
                    return visitParameter(node);
                case 216 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node);
                case 215 /* TypeAssertionExpression */ :
                case 233 /* AsExpression */ :
                    return visitAssertionExpression(node);
                case 237 /* SatisfiesExpression */ :
                    return visitSatisfiesExpression(node);
                case 212 /* CallExpression */ :
                    return visitCallExpression(node);
                case 213 /* NewExpression */ :
                    return visitNewExpression(node);
                case 214 /* TaggedTemplateExpression */ :
                    return visitTaggedTemplateExpression(node);
                case 234 /* NonNullExpression */ :
                    return visitNonNullExpression(node);
                case 265 /* EnumDeclaration */ :
                    return visitEnumDeclaration(node);
                case 242 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 259 /* VariableDeclaration */ :
                    return visitVariableDeclaration(node);
                case 266 /* ModuleDeclaration */ :
                    return visitModuleDeclaration(node);
                case 270 /* ImportEqualsDeclaration */ :
                    return visitImportEqualsDeclaration(node);
                case 284 /* JsxSelfClosingElement */ :
                    return visitJsxSelfClosingElement(node);
                case 285 /* JsxOpeningElement */ :
                    return visitJsxJsxOpeningElement(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitSourceFile(node) {
            const alwaysStrict = getStrictOptionValue(compilerOptions, "alwaysStrict") && !(isExternalModule(node) && moduleKind >= 5 /* ES2015 */ ) && !isJsonSourceFile(node);
            return factory2.updateSourceFile(node, visitLexicalEnvironment(node.statements, sourceElementVisitor, context, /*start*/ 0, alwaysStrict));
        }
        function visitObjectLiteralExpression(node) {
            return factory2.updateObjectLiteralExpression(node, visitNodes2(node.properties, getObjectLiteralElementVisitor(node), isObjectLiteralElementLike));
        }
        function getClassFacts(node) {
            let facts = 0 /* None */ ;
            if (some(getProperties(node, /*requireInitializer*/ true, /*isStatic*/ true))) facts |= 1 /* HasStaticInitializedProperties */ ;
            const extendsClauseElement = getEffectiveBaseTypeNode(node);
            if (extendsClauseElement && skipOuterExpressions(extendsClauseElement.expression).kind !== 106 /* NullKeyword */ ) facts |= 64 /* IsDerivedClass */ ;
            if (classOrConstructorParameterIsDecorated(legacyDecorators, node)) facts |= 2 /* HasClassOrConstructorParameterDecorators */ ;
            if (childIsDecorated(legacyDecorators, node)) facts |= 4 /* HasMemberDecorators */ ;
            if (isExportOfNamespace(node)) facts |= 8 /* IsExportOfNamespace */ ;
            else if (isDefaultExternalModuleExport(node)) facts |= 32 /* IsDefaultExternalExport */ ;
            else if (isNamedExternalModuleExport(node)) facts |= 16 /* IsNamedExternalExport */ ;
            return facts;
        }
        function hasTypeScriptClassSyntax(node) {
            return !!(node.transformFlags & 8192 /* ContainsTypeScriptClassSyntax */ );
        }
        function isClassLikeDeclarationWithTypeScriptSyntax(node) {
            return hasDecorators(node) || some(node.typeParameters) || some(node.heritageClauses, hasTypeScriptClassSyntax) || some(node.members, hasTypeScriptClassSyntax);
        }
        function visitClassDeclaration(node) {
            const facts = getClassFacts(node);
            const promoteToIIFE = languageVersion <= 1 /* ES5 */  && !!(facts & 7 /* MayNeedImmediatelyInvokedFunctionExpression */ );
            if (!isClassLikeDeclarationWithTypeScriptSyntax(node) && !classOrConstructorParameterIsDecorated(legacyDecorators, node) && !isExportOfNamespace(node)) return factory2.updateClassDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), node.name, /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), visitNodes2(node.members, getClassElementVisitor(node), isClassElement));
            if (promoteToIIFE) context.startLexicalEnvironment();
            const moveModifiers = promoteToIIFE || facts & 8 /* IsExportOfNamespace */ ;
            let modifiers = moveModifiers ? visitNodes2(node.modifiers, modifierElidingVisitor, isModifierLike) : visitNodes2(node.modifiers, visitor, isModifierLike);
            if (facts & 2 /* HasClassOrConstructorParameterDecorators */ ) modifiers = injectClassTypeMetadata(modifiers, node);
            const needsName = moveModifiers && !node.name || facts & 4 /* HasMemberDecorators */  || facts & 1 /* HasStaticInitializedProperties */ ;
            const name = needsName ? node.name ?? factory2.getGeneratedNameForNode(node) : node.name;
            const classDeclaration = factory2.updateClassDeclaration(node, modifiers, name, /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), transformClassMembers(node));
            let emitFlags = getEmitFlags(node);
            if (facts & 1 /* HasStaticInitializedProperties */ ) emitFlags |= 64 /* NoTrailingSourceMap */ ;
            setEmitFlags(classDeclaration, emitFlags);
            let statement;
            if (promoteToIIFE) {
                const statements = [
                    classDeclaration
                ];
                const closingBraceLocation = createTokenRange(skipTrivia(currentSourceFile.text, node.members.end), 20 /* CloseBraceToken */ );
                const localName = factory2.getInternalName(node);
                const outer = factory2.createPartiallyEmittedExpression(localName);
                setTextRangeEnd(outer, closingBraceLocation.end);
                setEmitFlags(outer, 3072 /* NoComments */ );
                const returnStatement = factory2.createReturnStatement(outer);
                setTextRangePos(returnStatement, closingBraceLocation.pos);
                setEmitFlags(returnStatement, 3840 /* NoTokenSourceMaps */ );
                statements.push(returnStatement);
                insertStatementsAfterStandardPrologue(statements, context.endLexicalEnvironment());
                const iife = factory2.createImmediatelyInvokedArrowFunction(statements);
                setInternalEmitFlags(iife, 1 /* TypeScriptClassWrapper */ );
                const modifiers2 = facts & 16 /* IsNamedExternalExport */  ? factory2.createModifiersFromModifierFlags(1 /* Export */ ) : void 0;
                const varStatement = factory2.createVariableStatement(modifiers2, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ false), /*exclamationToken*/ void 0, /*type*/ void 0, iife)
                ], 1 /* Let */ ));
                setOriginalNode(varStatement, node);
                setCommentRange(varStatement, node);
                setSourceMapRange(varStatement, moveRangePastDecorators(node));
                startOnNewLine(varStatement);
                statement = varStatement;
            } else statement = classDeclaration;
            if (moveModifiers) {
                if (facts & 8 /* IsExportOfNamespace */ ) return [
                    statement,
                    createExportMemberAssignmentStatement(node)
                ];
                if (facts & 32 /* IsDefaultExternalExport */ ) return [
                    statement,
                    factory2.createExportDefault(factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true))
                ];
                if (facts & 16 /* IsNamedExternalExport */  && !promoteToIIFE) return [
                    statement,
                    factory2.createExternalModuleExport(factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true))
                ];
            }
            return statement;
        }
        function visitClassExpression(node) {
            let modifiers = visitNodes2(node.modifiers, modifierElidingVisitor, isModifierLike);
            if (classOrConstructorParameterIsDecorated(legacyDecorators, node)) modifiers = injectClassTypeMetadata(modifiers, node);
            return factory2.updateClassExpression(node, modifiers, node.name, /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), transformClassMembers(node));
        }
        function transformClassMembers(node) {
            const members = visitNodes2(node.members, getClassElementVisitor(node), isClassElement);
            let newMembers;
            const constructor = getFirstConstructorWithBody(node);
            const parametersWithPropertyAssignments = constructor && filter(constructor.parameters, (p)=>isParameterPropertyDeclaration(p, constructor));
            if (parametersWithPropertyAssignments) for (const parameter of parametersWithPropertyAssignments){
                const parameterProperty = factory2.createPropertyDeclaration(/*modifiers*/ void 0, parameter.name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
                setOriginalNode(parameterProperty, parameter);
                newMembers = append(newMembers, parameterProperty);
            }
            if (newMembers) {
                newMembers = addRange(newMembers, members);
                return setTextRange(factory2.createNodeArray(newMembers), /*location*/ node.members);
            }
            return members;
        }
        function injectClassTypeMetadata(modifiers, node) {
            const metadata = getTypeMetadata(node, node);
            if (some(metadata)) {
                const modifiersArray = [];
                addRange(modifiersArray, takeWhile(modifiers, isExportOrDefaultModifier));
                addRange(modifiersArray, filter(modifiers, isDecorator));
                addRange(modifiersArray, metadata);
                addRange(modifiersArray, filter(skipWhile(modifiers, isExportOrDefaultModifier), isModifier));
                modifiers = setTextRange(factory2.createNodeArray(modifiersArray), modifiers);
            }
            return modifiers;
        }
        function injectClassElementTypeMetadata(modifiers, node, container) {
            if (isClassLike(container) && classElementOrClassElementParameterIsDecorated(legacyDecorators, node, container)) {
                const metadata = getTypeMetadata(node, container);
                if (some(metadata)) {
                    const modifiersArray = [];
                    addRange(modifiersArray, filter(modifiers, isDecorator));
                    addRange(modifiersArray, metadata);
                    addRange(modifiersArray, filter(modifiers, isModifier));
                    modifiers = setTextRange(factory2.createNodeArray(modifiersArray), modifiers);
                }
            }
            return modifiers;
        }
        function getTypeMetadata(node, container) {
            if (!legacyDecorators) return void 0;
            return USE_NEW_TYPE_METADATA_FORMAT ? getNewTypeMetadata(node, container) : getOldTypeMetadata(node, container);
        }
        function getOldTypeMetadata(node, container) {
            if (typeSerializer) {
                let decorators;
                if (shouldAddTypeMetadata(node)) {
                    const typeMetadata = emitHelpers().createMetadataHelper("design:type", typeSerializer.serializeTypeOfNode({
                        currentLexicalScope: currentLexicalScope,
                        currentNameScope: container
                    }, node));
                    decorators = append(decorators, factory2.createDecorator(typeMetadata));
                }
                if (shouldAddParamTypesMetadata(node)) {
                    const paramTypesMetadata = emitHelpers().createMetadataHelper("design:paramtypes", typeSerializer.serializeParameterTypesOfNode({
                        currentLexicalScope: currentLexicalScope,
                        currentNameScope: container
                    }, node, container));
                    decorators = append(decorators, factory2.createDecorator(paramTypesMetadata));
                }
                if (shouldAddReturnTypeMetadata(node)) {
                    const returnTypeMetadata = emitHelpers().createMetadataHelper("design:returntype", typeSerializer.serializeReturnTypeOfNode({
                        currentLexicalScope: currentLexicalScope,
                        currentNameScope: container
                    }, node));
                    decorators = append(decorators, factory2.createDecorator(returnTypeMetadata));
                }
                return decorators;
            }
        }
        function getNewTypeMetadata(node, container) {
            if (typeSerializer) {
                let properties;
                if (shouldAddTypeMetadata(node)) {
                    const typeProperty = factory2.createPropertyAssignment("type", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [], /*type*/ void 0, factory2.createToken(39 /* EqualsGreaterThanToken */ ), typeSerializer.serializeTypeOfNode({
                        currentLexicalScope: currentLexicalScope,
                        currentNameScope: container
                    }, node)));
                    properties = append(properties, typeProperty);
                }
                if (shouldAddParamTypesMetadata(node)) {
                    const paramTypeProperty = factory2.createPropertyAssignment("paramTypes", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [], /*type*/ void 0, factory2.createToken(39 /* EqualsGreaterThanToken */ ), typeSerializer.serializeParameterTypesOfNode({
                        currentLexicalScope: currentLexicalScope,
                        currentNameScope: container
                    }, node, container)));
                    properties = append(properties, paramTypeProperty);
                }
                if (shouldAddReturnTypeMetadata(node)) {
                    const returnTypeProperty = factory2.createPropertyAssignment("returnType", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [], /*type*/ void 0, factory2.createToken(39 /* EqualsGreaterThanToken */ ), typeSerializer.serializeReturnTypeOfNode({
                        currentLexicalScope: currentLexicalScope,
                        currentNameScope: container
                    }, node)));
                    properties = append(properties, returnTypeProperty);
                }
                if (properties) {
                    const typeInfoMetadata = emitHelpers().createMetadataHelper("design:typeinfo", factory2.createObjectLiteralExpression(properties, /*multiLine*/ true));
                    return [
                        factory2.createDecorator(typeInfoMetadata)
                    ];
                }
            }
        }
        function shouldAddTypeMetadata(node) {
            const kind = node.kind;
            return kind === 173 /* MethodDeclaration */  || kind === 176 /* GetAccessor */  || kind === 177 /* SetAccessor */  || kind === 171 /* PropertyDeclaration */ ;
        }
        function shouldAddReturnTypeMetadata(node) {
            return node.kind === 173 /* MethodDeclaration */ ;
        }
        function shouldAddParamTypesMetadata(node) {
            switch(node.kind){
                case 262 /* ClassDeclaration */ :
                case 230 /* ClassExpression */ :
                    return getFirstConstructorWithBody(node) !== void 0;
                case 173 /* MethodDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    return true;
            }
            return false;
        }
        function getExpressionForPropertyName(member, generateNameForComputedPropertyName) {
            const name = member.name;
            if (isPrivateIdentifier(name)) return factory2.createIdentifier("");
            else if (isComputedPropertyName(name)) return generateNameForComputedPropertyName && !isSimpleInlineableExpression(name.expression) ? factory2.getGeneratedNameForNode(name) : name.expression;
            else if (isIdentifier(name)) return factory2.createStringLiteral(idText(name));
            else return factory2.cloneNode(name);
        }
        function visitPropertyNameOfClassElement(member) {
            const name = member.name;
            if (isComputedPropertyName(name) && (!hasStaticModifier(member) && currentClassHasParameterProperties || hasDecorators(member) && legacyDecorators)) {
                const expression = visitNode(name.expression, visitor, isExpression);
                Debug.assert(expression);
                const innerExpression = skipPartiallyEmittedExpressions(expression);
                if (!isSimpleInlineableExpression(innerExpression)) {
                    const generatedName = factory2.getGeneratedNameForNode(name);
                    hoistVariableDeclaration(generatedName);
                    return factory2.updateComputedPropertyName(name, factory2.createAssignment(generatedName, expression));
                }
            }
            return Debug.checkDefined(visitNode(name, visitor, isPropertyName));
        }
        function visitHeritageClause(node) {
            if (node.token === 119 /* ImplementsKeyword */ ) return void 0;
            return visitEachChild(node, visitor, context);
        }
        function visitExpressionWithTypeArguments(node) {
            return factory2.updateExpressionWithTypeArguments(node, Debug.checkDefined(visitNode(node.expression, visitor, isLeftHandSideExpression)), /*typeArguments*/ void 0);
        }
        function shouldEmitFunctionLikeDeclaration(node) {
            return !nodeIsMissing(node.body);
        }
        function visitPropertyDeclaration(node, parent2) {
            const isAmbient = node.flags & 16777216 /* Ambient */  || hasSyntacticModifier(node, 256 /* Abstract */ );
            if (isAmbient && !(legacyDecorators && hasDecorators(node))) return void 0;
            let modifiers = isClassLike(parent2) ? !isAmbient ? visitNodes2(node.modifiers, visitor, isModifierLike) : visitNodes2(node.modifiers, modifierElidingVisitor, isModifierLike) : visitNodes2(node.modifiers, decoratorElidingVisitor, isModifierLike);
            modifiers = injectClassElementTypeMetadata(modifiers, node, parent2);
            if (isAmbient) return factory2.updatePropertyDeclaration(node, concatenate(modifiers, factory2.createModifiersFromModifierFlags(2 /* Ambient */ )), Debug.checkDefined(visitNode(node.name, visitor, isPropertyName)), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
            return factory2.updatePropertyDeclaration(node, modifiers, visitPropertyNameOfClassElement(node), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
        }
        function visitConstructor(node) {
            if (!shouldEmitFunctionLikeDeclaration(node)) return void 0;
            return factory2.updateConstructorDeclaration(node, /*modifiers*/ void 0, visitParameterList(node.parameters, visitor, context), transformConstructorBody(node.body, node));
        }
        function transformConstructorBody(body, constructor) {
            const parametersWithPropertyAssignments = constructor && filter(constructor.parameters, (p)=>isParameterPropertyDeclaration(p, constructor));
            if (!some(parametersWithPropertyAssignments)) return visitFunctionBody(body, visitor, context);
            let statements = [];
            resumeLexicalEnvironment();
            const prologueStatementCount = factory2.copyPrologue(body.statements, statements, /*ensureUseStrict*/ false, visitor);
            const superStatementIndex = findSuperStatementIndex(body.statements, prologueStatementCount);
            if (superStatementIndex >= 0) addRange(statements, visitNodes2(body.statements, visitor, isStatement, prologueStatementCount, superStatementIndex + 1 - prologueStatementCount));
            const parameterPropertyAssignments = mapDefined(parametersWithPropertyAssignments, transformParameterWithPropertyAssignment);
            if (superStatementIndex >= 0) addRange(statements, parameterPropertyAssignments);
            else statements = [
                ...statements.slice(0, prologueStatementCount),
                ...parameterPropertyAssignments,
                ...statements.slice(prologueStatementCount)
            ];
            const start = superStatementIndex >= 0 ? superStatementIndex + 1 : prologueStatementCount;
            addRange(statements, visitNodes2(body.statements, visitor, isStatement, start));
            statements = factory2.mergeLexicalEnvironment(statements, endLexicalEnvironment());
            const block = factory2.createBlock(setTextRange(factory2.createNodeArray(statements), body.statements), /*multiLine*/ true);
            setTextRange(block, /*location*/ body);
            setOriginalNode(block, body);
            return block;
        }
        function transformParameterWithPropertyAssignment(node) {
            const name = node.name;
            if (!isIdentifier(name)) return void 0;
            const propertyName = setParent(setTextRange(factory2.cloneNode(name), name), name.parent);
            setEmitFlags(propertyName, 3168 /* NoSourceMap */ );
            const localName = setParent(setTextRange(factory2.cloneNode(name), name), name.parent);
            setEmitFlags(localName, 3072 /* NoComments */ );
            return startOnNewLine(removeAllComments(setTextRange(setOriginalNode(factory2.createExpressionStatement(factory2.createAssignment(setTextRange(factory2.createPropertyAccessExpression(factory2.createThis(), propertyName), node.name), localName)), node), moveRangePos(node, -1))));
        }
        function visitMethodDeclaration(node, parent2) {
            if (!(node.transformFlags & 1 /* ContainsTypeScript */ )) return node;
            if (!shouldEmitFunctionLikeDeclaration(node)) return void 0;
            let modifiers = isClassLike(parent2) ? visitNodes2(node.modifiers, visitor, isModifierLike) : visitNodes2(node.modifiers, decoratorElidingVisitor, isModifierLike);
            modifiers = injectClassElementTypeMetadata(modifiers, node, parent2);
            return factory2.updateMethodDeclaration(node, modifiers, node.asteriskToken, visitPropertyNameOfClassElement(node), /*questionToken*/ void 0, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, visitFunctionBody(node.body, visitor, context));
        }
        function shouldEmitAccessorDeclaration(node) {
            return !(nodeIsMissing(node.body) && hasSyntacticModifier(node, 256 /* Abstract */ ));
        }
        function visitGetAccessor(node, parent2) {
            if (!(node.transformFlags & 1 /* ContainsTypeScript */ )) return node;
            if (!shouldEmitAccessorDeclaration(node)) return void 0;
            let modifiers = isClassLike(parent2) ? visitNodes2(node.modifiers, visitor, isModifierLike) : visitNodes2(node.modifiers, decoratorElidingVisitor, isModifierLike);
            modifiers = injectClassElementTypeMetadata(modifiers, node, parent2);
            return factory2.updateGetAccessorDeclaration(node, modifiers, visitPropertyNameOfClassElement(node), visitParameterList(node.parameters, visitor, context), /*type*/ void 0, visitFunctionBody(node.body, visitor, context) || factory2.createBlock([]));
        }
        function visitSetAccessor(node, parent2) {
            if (!(node.transformFlags & 1 /* ContainsTypeScript */ )) return node;
            if (!shouldEmitAccessorDeclaration(node)) return void 0;
            let modifiers = isClassLike(parent2) ? visitNodes2(node.modifiers, visitor, isModifierLike) : visitNodes2(node.modifiers, decoratorElidingVisitor, isModifierLike);
            modifiers = injectClassElementTypeMetadata(modifiers, node, parent2);
            return factory2.updateSetAccessorDeclaration(node, modifiers, visitPropertyNameOfClassElement(node), visitParameterList(node.parameters, visitor, context), visitFunctionBody(node.body, visitor, context) || factory2.createBlock([]));
        }
        function visitFunctionDeclaration(node) {
            if (!shouldEmitFunctionLikeDeclaration(node)) return factory2.createNotEmittedStatement(node);
            const updated = factory2.updateFunctionDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), node.asteriskToken, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, visitFunctionBody(node.body, visitor, context) || factory2.createBlock([]));
            if (isExportOfNamespace(node)) {
                const statements = [
                    updated
                ];
                addExportMemberAssignment(statements, node);
                return statements;
            }
            return updated;
        }
        function visitFunctionExpression(node) {
            if (!shouldEmitFunctionLikeDeclaration(node)) return factory2.createOmittedExpression();
            const updated = factory2.updateFunctionExpression(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), node.asteriskToken, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, visitFunctionBody(node.body, visitor, context) || factory2.createBlock([]));
            return updated;
        }
        function visitArrowFunction(node) {
            const updated = factory2.updateArrowFunction(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, node.equalsGreaterThanToken, visitFunctionBody(node.body, visitor, context));
            return updated;
        }
        function visitParameter(node) {
            if (parameterIsThisKeyword(node)) return void 0;
            const updated = factory2.updateParameterDeclaration(node, visitNodes2(node.modifiers, (node2)=>isDecorator(node2) ? visitor(node2) : void 0, isModifierLike), node.dotDotDotToken, Debug.checkDefined(visitNode(node.name, visitor, isBindingName)), /*questionToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
            if (updated !== node) {
                setCommentRange(updated, node);
                setTextRange(updated, moveRangePastModifiers(node));
                setSourceMapRange(updated, moveRangePastModifiers(node));
                setEmitFlags(updated.name, 64 /* NoTrailingSourceMap */ );
            }
            return updated;
        }
        function visitVariableStatement(node) {
            if (isExportOfNamespace(node)) {
                const variables = getInitializedVariables(node.declarationList);
                if (variables.length === 0) return void 0;
                return setTextRange(factory2.createExpressionStatement(factory2.inlineExpressions(map(variables, transformInitializedVariable))), node);
            } else return visitEachChild(node, visitor, context);
        }
        function transformInitializedVariable(node) {
            const name = node.name;
            if (isBindingPattern(name)) return flattenDestructuringAssignment(node, visitor, context, 0 /* All */ , /*needsValue*/ false, createNamespaceExportExpression);
            else return setTextRange(factory2.createAssignment(getNamespaceMemberNameWithSourceMapsAndWithoutComments(name), Debug.checkDefined(visitNode(node.initializer, visitor, isExpression))), /*location*/ node);
        }
        function visitVariableDeclaration(node) {
            const updated = factory2.updateVariableDeclaration(node, Debug.checkDefined(visitNode(node.name, visitor, isBindingName)), /*exclamationToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
            if (node.type) setTypeNode(updated.name, node.type);
            return updated;
        }
        function visitParenthesizedExpression(node) {
            const innerExpression = skipOuterExpressions(node.expression, -7 /* Assertions */ );
            if (isAssertionExpression(innerExpression)) {
                const expression = visitNode(node.expression, visitor, isExpression);
                Debug.assert(expression);
                return factory2.createPartiallyEmittedExpression(expression, node);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitAssertionExpression(node) {
            const expression = visitNode(node.expression, visitor, isExpression);
            Debug.assert(expression);
            return factory2.createPartiallyEmittedExpression(expression, node);
        }
        function visitNonNullExpression(node) {
            const expression = visitNode(node.expression, visitor, isLeftHandSideExpression);
            Debug.assert(expression);
            return factory2.createPartiallyEmittedExpression(expression, node);
        }
        function visitSatisfiesExpression(node) {
            const expression = visitNode(node.expression, visitor, isExpression);
            Debug.assert(expression);
            return factory2.createPartiallyEmittedExpression(expression, node);
        }
        function visitCallExpression(node) {
            return factory2.updateCallExpression(node, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), /*typeArguments*/ void 0, visitNodes2(node.arguments, visitor, isExpression));
        }
        function visitNewExpression(node) {
            return factory2.updateNewExpression(node, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), /*typeArguments*/ void 0, visitNodes2(node.arguments, visitor, isExpression));
        }
        function visitTaggedTemplateExpression(node) {
            return factory2.updateTaggedTemplateExpression(node, Debug.checkDefined(visitNode(node.tag, visitor, isExpression)), /*typeArguments*/ void 0, Debug.checkDefined(visitNode(node.template, visitor, isTemplateLiteral)));
        }
        function visitJsxSelfClosingElement(node) {
            return factory2.updateJsxSelfClosingElement(node, Debug.checkDefined(visitNode(node.tagName, visitor, isJsxTagNameExpression)), /*typeArguments*/ void 0, Debug.checkDefined(visitNode(node.attributes, visitor, isJsxAttributes)));
        }
        function visitJsxJsxOpeningElement(node) {
            return factory2.updateJsxOpeningElement(node, Debug.checkDefined(visitNode(node.tagName, visitor, isJsxTagNameExpression)), /*typeArguments*/ void 0, Debug.checkDefined(visitNode(node.attributes, visitor, isJsxAttributes)));
        }
        function shouldEmitEnumDeclaration(node) {
            return !isEnumConst(node) || shouldPreserveConstEnums(compilerOptions);
        }
        function visitEnumDeclaration(node) {
            if (!shouldEmitEnumDeclaration(node)) return factory2.createNotEmittedStatement(node);
            const statements = [];
            let emitFlags = 4 /* AdviseOnEmitNode */ ;
            const varAdded = addVarForEnumOrModuleDeclaration(statements, node);
            if (varAdded) {
                if (moduleKind !== 4 /* System */  || currentLexicalScope !== currentSourceFile) emitFlags |= 1024 /* NoLeadingComments */ ;
            }
            const parameterName = getNamespaceParameterName(node);
            const containerName = getNamespaceContainerName(node);
            const exportName = isExportOfNamespace(node) ? factory2.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true) : factory2.getDeclarationName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
            let moduleArg = factory2.createLogicalOr(exportName, factory2.createAssignment(exportName, factory2.createObjectLiteralExpression()));
            if (isExportOfNamespace(node)) {
                const localName = factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
                moduleArg = factory2.createAssignment(localName, moduleArg);
            }
            const enumStatement = factory2.createExpressionStatement(factory2.createCallExpression(factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, parameterName)
            ], /*type*/ void 0, transformEnumBody(node, containerName)), /*typeArguments*/ void 0, [
                moduleArg
            ]));
            setOriginalNode(enumStatement, node);
            if (varAdded) {
                setSyntheticLeadingComments(enumStatement, void 0);
                setSyntheticTrailingComments(enumStatement, void 0);
            }
            setTextRange(enumStatement, node);
            addEmitFlags(enumStatement, emitFlags);
            statements.push(enumStatement);
            return statements;
        }
        function transformEnumBody(node, localName) {
            const savedCurrentNamespaceLocalName = currentNamespaceContainerName;
            currentNamespaceContainerName = localName;
            const statements = [];
            startLexicalEnvironment();
            const members = map(node.members, transformEnumMember);
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            addRange(statements, members);
            currentNamespaceContainerName = savedCurrentNamespaceLocalName;
            return factory2.createBlock(setTextRange(factory2.createNodeArray(statements), /*location*/ node.members), /*multiLine*/ true);
        }
        function transformEnumMember(member) {
            const name = getExpressionForPropertyName(member, /*generateNameForComputedPropertyName*/ false);
            const valueExpression = transformEnumMemberDeclarationValue(member);
            const innerAssignment = factory2.createAssignment(factory2.createElementAccessExpression(currentNamespaceContainerName, name), valueExpression);
            const outerAssignment = valueExpression.kind === 11 /* StringLiteral */  ? innerAssignment : factory2.createAssignment(factory2.createElementAccessExpression(currentNamespaceContainerName, innerAssignment), name);
            return setTextRange(factory2.createExpressionStatement(setTextRange(outerAssignment, member)), member);
        }
        function transformEnumMemberDeclarationValue(member) {
            const value1 = resolver.getConstantValue(member);
            if (value1 !== void 0) return typeof value1 === "string" ? factory2.createStringLiteral(value1) : factory2.createNumericLiteral(value1);
            else {
                enableSubstitutionForNonQualifiedEnumMembers();
                if (member.initializer) return Debug.checkDefined(visitNode(member.initializer, visitor, isExpression));
                else return factory2.createVoidZero();
            }
        }
        function shouldEmitModuleDeclaration(nodeIn) {
            const node = getParseTreeNode(nodeIn, isModuleDeclaration);
            if (!node) return true;
            return isInstantiatedModule(node, shouldPreserveConstEnums(compilerOptions));
        }
        function recordEmittedDeclarationInScope(node) {
            if (!currentScopeFirstDeclarationsOfName) currentScopeFirstDeclarationsOfName = /* @__PURE__ */ new Map();
            const name = declaredNameInScope(node);
            if (!currentScopeFirstDeclarationsOfName.has(name)) currentScopeFirstDeclarationsOfName.set(name, node);
        }
        function isFirstEmittedDeclarationInScope(node) {
            if (currentScopeFirstDeclarationsOfName) {
                const name = declaredNameInScope(node);
                return currentScopeFirstDeclarationsOfName.get(name) === node;
            }
            return true;
        }
        function declaredNameInScope(node) {
            Debug.assertNode(node.name, isIdentifier);
            return node.name.escapedText;
        }
        function addVarForEnumOrModuleDeclaration(statements, node) {
            const varDecl = factory2.createVariableDeclaration(factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true));
            const varFlags = currentLexicalScope.kind === 311 /* SourceFile */  ? 0 /* None */  : 1 /* Let */ ;
            const statement = factory2.createVariableStatement(visitNodes2(node.modifiers, modifierVisitor, isModifier), factory2.createVariableDeclarationList([
                varDecl
            ], varFlags));
            setOriginalNode(varDecl, node);
            setSyntheticLeadingComments(varDecl, void 0);
            setSyntheticTrailingComments(varDecl, void 0);
            setOriginalNode(statement, node);
            recordEmittedDeclarationInScope(node);
            if (isFirstEmittedDeclarationInScope(node)) {
                if (node.kind === 265 /* EnumDeclaration */ ) setSourceMapRange(statement.declarationList, node);
                else setSourceMapRange(statement, node);
                setCommentRange(statement, node);
                addEmitFlags(statement, 2048 /* NoTrailingComments */ );
                statements.push(statement);
                return true;
            }
            return false;
        }
        function visitModuleDeclaration(node) {
            if (!shouldEmitModuleDeclaration(node)) return factory2.createNotEmittedStatement(node);
            Debug.assertNode(node.name, isIdentifier, "A TypeScript namespace should have an Identifier name.");
            enableSubstitutionForNamespaceExports();
            const statements = [];
            let emitFlags = 4 /* AdviseOnEmitNode */ ;
            const varAdded = addVarForEnumOrModuleDeclaration(statements, node);
            if (varAdded) {
                if (moduleKind !== 4 /* System */  || currentLexicalScope !== currentSourceFile) emitFlags |= 1024 /* NoLeadingComments */ ;
            }
            const parameterName = getNamespaceParameterName(node);
            const containerName = getNamespaceContainerName(node);
            const exportName = isExportOfNamespace(node) ? factory2.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true) : factory2.getDeclarationName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
            let moduleArg = factory2.createLogicalOr(exportName, factory2.createAssignment(exportName, factory2.createObjectLiteralExpression()));
            if (isExportOfNamespace(node)) {
                const localName = factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
                moduleArg = factory2.createAssignment(localName, moduleArg);
            }
            const moduleStatement = factory2.createExpressionStatement(factory2.createCallExpression(factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, parameterName)
            ], /*type*/ void 0, transformModuleBody(node, containerName)), /*typeArguments*/ void 0, [
                moduleArg
            ]));
            setOriginalNode(moduleStatement, node);
            if (varAdded) {
                setSyntheticLeadingComments(moduleStatement, void 0);
                setSyntheticTrailingComments(moduleStatement, void 0);
            }
            setTextRange(moduleStatement, node);
            addEmitFlags(moduleStatement, emitFlags);
            statements.push(moduleStatement);
            return statements;
        }
        function transformModuleBody(node, namespaceLocalName) {
            const savedCurrentNamespaceContainerName = currentNamespaceContainerName;
            const savedCurrentNamespace = currentNamespace;
            const savedCurrentScopeFirstDeclarationsOfName = currentScopeFirstDeclarationsOfName;
            currentNamespaceContainerName = namespaceLocalName;
            currentNamespace = node;
            currentScopeFirstDeclarationsOfName = void 0;
            const statements = [];
            startLexicalEnvironment();
            let statementsLocation;
            let blockLocation;
            if (node.body) {
                if (node.body.kind === 267 /* ModuleBlock */ ) {
                    saveStateAndInvoke(node.body, (body)=>addRange(statements, visitNodes2(body.statements, namespaceElementVisitor, isStatement)));
                    statementsLocation = node.body.statements;
                    blockLocation = node.body;
                } else {
                    const result = visitModuleDeclaration(node.body);
                    if (result) {
                        if (isArray(result)) addRange(statements, result);
                        else statements.push(result);
                    }
                    const moduleBlock = getInnerMostModuleDeclarationFromDottedModule(node).body;
                    statementsLocation = moveRangePos(moduleBlock.statements, -1);
                }
            }
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            currentNamespaceContainerName = savedCurrentNamespaceContainerName;
            currentNamespace = savedCurrentNamespace;
            currentScopeFirstDeclarationsOfName = savedCurrentScopeFirstDeclarationsOfName;
            const block = factory2.createBlock(setTextRange(factory2.createNodeArray(statements), /*location*/ statementsLocation), /*multiLine*/ true);
            setTextRange(block, blockLocation);
            if (!node.body || node.body.kind !== 267 /* ModuleBlock */ ) setEmitFlags(block, getEmitFlags(block) | 3072 /* NoComments */ );
            return block;
        }
        function getInnerMostModuleDeclarationFromDottedModule(moduleDeclaration) {
            if (moduleDeclaration.body.kind === 266 /* ModuleDeclaration */ ) {
                const recursiveInnerModule = getInnerMostModuleDeclarationFromDottedModule(moduleDeclaration.body);
                return recursiveInnerModule || moduleDeclaration.body;
            }
        }
        function visitImportDeclaration(node) {
            if (!node.importClause) return node;
            if (node.importClause.isTypeOnly) return void 0;
            const importClause = visitNode(node.importClause, visitImportClause, isImportClause);
            return importClause || compilerOptions.importsNotUsedAsValues === 1 /* Preserve */  || compilerOptions.importsNotUsedAsValues === 2 /* Error */  ? factory2.updateImportDeclaration(node, /*modifiers*/ void 0, importClause, node.moduleSpecifier, node.assertClause) : void 0;
        }
        function visitImportClause(node) {
            Debug.assert(!node.isTypeOnly);
            const name = shouldEmitAliasDeclaration(node) ? node.name : void 0;
            const namedBindings = visitNode(node.namedBindings, visitNamedImportBindings, isNamedImportBindings);
            return name || namedBindings ? factory2.updateImportClause(node, /*isTypeOnly*/ false, name, namedBindings) : void 0;
        }
        function visitNamedImportBindings(node) {
            if (node.kind === 273 /* NamespaceImport */ ) return shouldEmitAliasDeclaration(node) ? node : void 0;
            else {
                const allowEmpty = compilerOptions.verbatimModuleSyntax || compilerOptions.preserveValueImports && (compilerOptions.importsNotUsedAsValues === 1 /* Preserve */  || compilerOptions.importsNotUsedAsValues === 2 /* Error */ );
                const elements = visitNodes2(node.elements, visitImportSpecifier, isImportSpecifier);
                return allowEmpty || some(elements) ? factory2.updateNamedImports(node, elements) : void 0;
            }
        }
        function visitImportSpecifier(node) {
            return !node.isTypeOnly && shouldEmitAliasDeclaration(node) ? node : void 0;
        }
        function visitExportAssignment(node) {
            return compilerOptions.verbatimModuleSyntax || resolver.isValueAliasDeclaration(node) ? visitEachChild(node, visitor, context) : void 0;
        }
        function visitExportDeclaration(node) {
            if (node.isTypeOnly) return void 0;
            if (!node.exportClause || isNamespaceExport(node.exportClause)) return node;
            const allowEmpty = compilerOptions.verbatimModuleSyntax || !!node.moduleSpecifier && (compilerOptions.importsNotUsedAsValues === 1 /* Preserve */  || compilerOptions.importsNotUsedAsValues === 2 /* Error */ );
            const exportClause = visitNode(node.exportClause, (bindings)=>visitNamedExportBindings(bindings, allowEmpty), isNamedExportBindings);
            return exportClause ? factory2.updateExportDeclaration(node, /*modifiers*/ void 0, node.isTypeOnly, exportClause, node.moduleSpecifier, node.assertClause) : void 0;
        }
        function visitNamedExports(node, allowEmpty) {
            const elements = visitNodes2(node.elements, visitExportSpecifier, isExportSpecifier);
            return allowEmpty || some(elements) ? factory2.updateNamedExports(node, elements) : void 0;
        }
        function visitNamespaceExports(node) {
            return factory2.updateNamespaceExport(node, Debug.checkDefined(visitNode(node.name, visitor, isIdentifier)));
        }
        function visitNamedExportBindings(node, allowEmpty) {
            return isNamespaceExport(node) ? visitNamespaceExports(node) : visitNamedExports(node, allowEmpty);
        }
        function visitExportSpecifier(node) {
            return !node.isTypeOnly && (compilerOptions.verbatimModuleSyntax || resolver.isValueAliasDeclaration(node)) ? node : void 0;
        }
        function shouldEmitImportEqualsDeclaration(node) {
            return shouldEmitAliasDeclaration(node) || !isExternalModule(currentSourceFile) && resolver.isTopLevelValueImportEqualsWithEntityName(node);
        }
        function visitImportEqualsDeclaration(node) {
            if (node.isTypeOnly) return void 0;
            if (isExternalModuleImportEqualsDeclaration(node)) {
                const isReferenced = shouldEmitAliasDeclaration(node);
                if (!isReferenced && compilerOptions.importsNotUsedAsValues === 1 /* Preserve */ ) return setOriginalNode(setTextRange(factory2.createImportDeclaration(/*modifiers*/ void 0, /*importClause*/ void 0, node.moduleReference.expression, /*assertClause*/ void 0), node), node);
                return isReferenced ? visitEachChild(node, visitor, context) : void 0;
            }
            if (!shouldEmitImportEqualsDeclaration(node)) return void 0;
            const moduleReference = createExpressionFromEntityName(factory2, node.moduleReference);
            setEmitFlags(moduleReference, 7168 /* NoNestedComments */ );
            if (isNamedExternalModuleExport(node) || !isExportOfNamespace(node)) return setOriginalNode(setTextRange(factory2.createVariableStatement(visitNodes2(node.modifiers, modifierVisitor, isModifier), factory2.createVariableDeclarationList([
                setOriginalNode(factory2.createVariableDeclaration(node.name, /*exclamationToken*/ void 0, /*type*/ void 0, moduleReference), node)
            ])), node), node);
            else return setOriginalNode(createNamespaceExport(node.name, moduleReference, node), node);
        }
        function isExportOfNamespace(node) {
            return currentNamespace !== void 0 && hasSyntacticModifier(node, 1 /* Export */ );
        }
        function isExternalModuleExport(node) {
            return currentNamespace === void 0 && hasSyntacticModifier(node, 1 /* Export */ );
        }
        function isNamedExternalModuleExport(node) {
            return isExternalModuleExport(node) && !hasSyntacticModifier(node, 1024 /* Default */ );
        }
        function isDefaultExternalModuleExport(node) {
            return isExternalModuleExport(node) && hasSyntacticModifier(node, 1024 /* Default */ );
        }
        function createExportMemberAssignmentStatement(node) {
            const expression = factory2.createAssignment(factory2.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true), factory2.getLocalName(node));
            setSourceMapRange(expression, createRange(node.name ? node.name.pos : node.pos, node.end));
            const statement = factory2.createExpressionStatement(expression);
            setSourceMapRange(statement, createRange(-1, node.end));
            return statement;
        }
        function addExportMemberAssignment(statements, node) {
            statements.push(createExportMemberAssignmentStatement(node));
        }
        function createNamespaceExport(exportName, exportValue, location) {
            return setTextRange(factory2.createExpressionStatement(factory2.createAssignment(factory2.getNamespaceMemberName(currentNamespaceContainerName, exportName, /*allowComments*/ false, /*allowSourceMaps*/ true), exportValue)), location);
        }
        function createNamespaceExportExpression(exportName, exportValue, location) {
            return setTextRange(factory2.createAssignment(getNamespaceMemberNameWithSourceMapsAndWithoutComments(exportName), exportValue), location);
        }
        function getNamespaceMemberNameWithSourceMapsAndWithoutComments(name) {
            return factory2.getNamespaceMemberName(currentNamespaceContainerName, name, /*allowComments*/ false, /*allowSourceMaps*/ true);
        }
        function getNamespaceParameterName(node) {
            const name = factory2.getGeneratedNameForNode(node);
            setSourceMapRange(name, node.name);
            return name;
        }
        function getNamespaceContainerName(node) {
            return factory2.getGeneratedNameForNode(node);
        }
        function enableSubstitutionForNonQualifiedEnumMembers() {
            if ((enabledSubstitutions & 8 /* NonQualifiedEnumMembers */ ) === 0) {
                enabledSubstitutions |= 8 /* NonQualifiedEnumMembers */ ;
                context.enableSubstitution(80 /* Identifier */ );
            }
        }
        function enableSubstitutionForNamespaceExports() {
            if ((enabledSubstitutions & 2 /* NamespaceExports */ ) === 0) {
                enabledSubstitutions |= 2 /* NamespaceExports */ ;
                context.enableSubstitution(80 /* Identifier */ );
                context.enableSubstitution(303 /* ShorthandPropertyAssignment */ );
                context.enableEmitNotification(266 /* ModuleDeclaration */ );
            }
        }
        function isTransformedModuleDeclaration(node) {
            return getOriginalNode(node).kind === 266 /* ModuleDeclaration */ ;
        }
        function isTransformedEnumDeclaration(node) {
            return getOriginalNode(node).kind === 265 /* EnumDeclaration */ ;
        }
        function onEmitNode(hint, node, emitCallback) {
            const savedApplicableSubstitutions = applicableSubstitutions;
            const savedCurrentSourceFile = currentSourceFile;
            if (isSourceFile(node)) currentSourceFile = node;
            if (enabledSubstitutions & 2 /* NamespaceExports */  && isTransformedModuleDeclaration(node)) applicableSubstitutions |= 2 /* NamespaceExports */ ;
            if (enabledSubstitutions & 8 /* NonQualifiedEnumMembers */  && isTransformedEnumDeclaration(node)) applicableSubstitutions |= 8 /* NonQualifiedEnumMembers */ ;
            previousOnEmitNode(hint, node, emitCallback);
            applicableSubstitutions = savedApplicableSubstitutions;
            currentSourceFile = savedCurrentSourceFile;
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            else if (isShorthandPropertyAssignment(node)) return substituteShorthandPropertyAssignment(node);
            return node;
        }
        function substituteShorthandPropertyAssignment(node) {
            if (enabledSubstitutions & 2 /* NamespaceExports */ ) {
                const name = node.name;
                const exportedName = trySubstituteNamespaceExportedName(name);
                if (exportedName) {
                    if (node.objectAssignmentInitializer) {
                        const initializer = factory2.createAssignment(exportedName, node.objectAssignmentInitializer);
                        return setTextRange(factory2.createPropertyAssignment(name, initializer), node);
                    }
                    return setTextRange(factory2.createPropertyAssignment(name, exportedName), node);
                }
            }
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
                case 210 /* PropertyAccessExpression */ :
                    return substitutePropertyAccessExpression(node);
                case 211 /* ElementAccessExpression */ :
                    return substituteElementAccessExpression(node);
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            return trySubstituteNamespaceExportedName(node) || node;
        }
        function trySubstituteNamespaceExportedName(node) {
            if (enabledSubstitutions & applicableSubstitutions && !isGeneratedIdentifier(node) && !isLocalName(node)) {
                const container = resolver.getReferencedExportContainer(node, /*prefixLocals*/ false);
                if (container && container.kind !== 311 /* SourceFile */ ) {
                    const substitute = applicableSubstitutions & 2 /* NamespaceExports */  && container.kind === 266 /* ModuleDeclaration */  || applicableSubstitutions & 8 /* NonQualifiedEnumMembers */  && container.kind === 265 /* EnumDeclaration */ ;
                    if (substitute) return setTextRange(factory2.createPropertyAccessExpression(factory2.getGeneratedNameForNode(container), node), /*location*/ node);
                }
            }
            return void 0;
        }
        function substitutePropertyAccessExpression(node) {
            return substituteConstantValue(node);
        }
        function substituteElementAccessExpression(node) {
            return substituteConstantValue(node);
        }
        function safeMultiLineComment(value1) {
            return value1.replace(/\*\//g, "*_/");
        }
        function substituteConstantValue(node) {
            const constantValue = tryGetConstEnumValue(node);
            if (constantValue !== void 0) {
                setConstantValue(node, constantValue);
                const substitute = typeof constantValue === "string" ? factory2.createStringLiteral(constantValue) : factory2.createNumericLiteral(constantValue);
                if (!compilerOptions.removeComments) {
                    const originalNode = getOriginalNode(node, isAccessExpression);
                    addSyntheticTrailingComment(substitute, 3 /* MultiLineCommentTrivia */ , ` ${safeMultiLineComment(getTextOfNode(originalNode))} `);
                }
                return substitute;
            }
            return node;
        }
        function tryGetConstEnumValue(node) {
            if (getIsolatedModules(compilerOptions)) return void 0;
            return isPropertyAccessExpression(node) || isElementAccessExpression(node) ? resolver.getConstantValue(node) : void 0;
        }
        function shouldEmitAliasDeclaration(node) {
            return compilerOptions.verbatimModuleSyntax || isInJSFile(node) || (compilerOptions.preserveValueImports ? resolver.isValueAliasDeclaration(node) : resolver.isReferencedAliasDeclaration(node));
        }
    }
    var USE_NEW_TYPE_METADATA_FORMAT;
    var init_ts = __esm({
        "src/compiler/transformers/ts.ts" () {
            "use strict";
            init_ts2();
            USE_NEW_TYPE_METADATA_FORMAT = false;
        }
    });
    // src/compiler/transformers/classFields.ts
    function transformClassFields(context) {
        const { factory: factory2 , getEmitHelperFactory: emitHelpers , hoistVariableDeclaration: hoistVariableDeclaration , endLexicalEnvironment: endLexicalEnvironment , startLexicalEnvironment: startLexicalEnvironment , resumeLexicalEnvironment: resumeLexicalEnvironment , addBlockScopedVariable: addBlockScopedVariable  } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const useDefineForClassFields = getUseDefineForClassFields(compilerOptions);
        const legacyDecorators = !!compilerOptions.experimentalDecorators;
        const shouldTransformInitializersUsingSet = !useDefineForClassFields;
        const shouldTransformInitializersUsingDefine = useDefineForClassFields && languageVersion < 9 /* ES2022 */ ;
        const shouldTransformInitializers = shouldTransformInitializersUsingSet || shouldTransformInitializersUsingDefine;
        const shouldTransformPrivateElementsOrClassStaticBlocks = languageVersion < 9 /* ES2022 */ ;
        const shouldTransformAutoAccessors = languageVersion < 99 /* ESNext */  ? -1 /* True */  : !useDefineForClassFields ? 3 /* Maybe */  : 0 /* False */ ;
        const shouldTransformThisInStaticInitializers = languageVersion < 9 /* ES2022 */ ;
        const shouldTransformSuperInStaticInitializers = shouldTransformThisInStaticInitializers && languageVersion >= 2 /* ES2015 */ ;
        const shouldTransformAnything = shouldTransformInitializers || shouldTransformPrivateElementsOrClassStaticBlocks || shouldTransformAutoAccessors === -1 /* True */ ;
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onSubstituteNode = onSubstituteNode;
        const previousOnEmitNode = context.onEmitNode;
        context.onEmitNode = onEmitNode;
        let shouldTransformPrivateStaticElementsInFile = false;
        let enabledSubstitutions;
        let classAliases;
        let pendingExpressions;
        let pendingStatements;
        let lexicalEnvironment;
        const lexicalEnvironmentMap = /* @__PURE__ */ new Map();
        let currentClassContainer;
        let currentStaticPropertyDeclarationOrStaticBlock;
        let shouldSubstituteThisWithClassThis = false;
        let previousShouldSubstituteThisWithClassThis = false;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            lexicalEnvironment = void 0;
            shouldTransformPrivateStaticElementsInFile = !!(getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ );
            if (!shouldTransformAnything && !shouldTransformPrivateStaticElementsInFile) return node;
            const visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            return visited;
        }
        function modifierVisitor(node) {
            switch(node.kind){
                case 129 /* AccessorKeyword */ :
                    return shouldTransformAutoAccessorsInCurrentClass() ? void 0 : node;
                default:
                    return tryCast(node, isModifier);
            }
        }
        function visitor(node) {
            if (!(node.transformFlags & 16777216 /* ContainsClassFields */ ) && !(node.transformFlags & 134234112 /* ContainsLexicalThisOrSuper */ )) return node;
            switch(node.kind){
                case 129 /* AccessorKeyword */ :
                    return Debug.fail("Use `modifierVisitor` instead.");
                case 262 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 230 /* ClassExpression */ :
                    return visitClassExpression(node, /*referencedName*/ void 0);
                case 174 /* ClassStaticBlockDeclaration */ :
                case 171 /* PropertyDeclaration */ :
                    return Debug.fail("Use `classElementVisitor` instead.");
                case 302 /* PropertyAssignment */ :
                    return visitPropertyAssignment(node);
                case 242 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 259 /* VariableDeclaration */ :
                    return visitVariableDeclaration(node);
                case 168 /* Parameter */ :
                    return visitParameterDeclaration(node);
                case 207 /* BindingElement */ :
                    return visitBindingElement(node);
                case 276 /* ExportAssignment */ :
                    return visitExportAssignment(node);
                case 81 /* PrivateIdentifier */ :
                    return visitPrivateIdentifier(node);
                case 210 /* PropertyAccessExpression */ :
                    return visitPropertyAccessExpression(node);
                case 211 /* ElementAccessExpression */ :
                    return visitElementAccessExpression(node);
                case 223 /* PrefixUnaryExpression */ :
                case 224 /* PostfixUnaryExpression */ :
                    return visitPreOrPostfixUnaryExpression(node, /*discarded*/ false);
                case 225 /* BinaryExpression */ :
                    return visitBinaryExpression(node, /*discarded*/ false);
                case 216 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, /*discarded*/ false, /*referencedName*/ void 0);
                case 212 /* CallExpression */ :
                    return visitCallExpression(node);
                case 243 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 214 /* TaggedTemplateExpression */ :
                    return visitTaggedTemplateExpression(node);
                case 247 /* ForStatement */ :
                    return visitForStatement(node);
                case 261 /* FunctionDeclaration */ :
                case 217 /* FunctionExpression */ :
                case 175 /* Constructor */ :
                case 173 /* MethodDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    return setCurrentStaticPropertyDeclarationOrStaticBlockAnd(/*current*/ void 0, fallbackVisitor, node);
                default:
                    return fallbackVisitor(node);
            }
        }
        function fallbackVisitor(node) {
            return visitEachChild(node, visitor, context);
        }
        function namedEvaluationVisitor(node, referencedName) {
            switch(node.kind){
                case 359 /* PartiallyEmittedExpression */ :
                    return visitPartiallyEmittedExpression(node, /*discarded*/ false, referencedName);
                case 216 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, /*discarded*/ false, referencedName);
                case 230 /* ClassExpression */ :
                    return visitClassExpression(node, referencedName);
                default:
                    return visitor(node);
            }
        }
        function discardedValueVisitor(node) {
            switch(node.kind){
                case 223 /* PrefixUnaryExpression */ :
                case 224 /* PostfixUnaryExpression */ :
                    return visitPreOrPostfixUnaryExpression(node, /*discarded*/ true);
                case 225 /* BinaryExpression */ :
                    return visitBinaryExpression(node, /*discarded*/ true);
                case 360 /* CommaListExpression */ :
                    return visitCommaListExpression(node, /*discarded*/ true);
                case 216 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, /*discarded*/ true, /*referencedName*/ void 0);
                default:
                    return visitor(node);
            }
        }
        function heritageClauseVisitor(node) {
            switch(node.kind){
                case 297 /* HeritageClause */ :
                    return visitEachChild(node, heritageClauseVisitor, context);
                case 232 /* ExpressionWithTypeArguments */ :
                    return visitExpressionWithTypeArgumentsInHeritageClause(node);
                default:
                    return visitor(node);
            }
        }
        function assignmentTargetVisitor(node) {
            switch(node.kind){
                case 209 /* ObjectLiteralExpression */ :
                case 208 /* ArrayLiteralExpression */ :
                    return visitAssignmentPattern(node);
                default:
                    return visitor(node);
            }
        }
        function classElementVisitor(node) {
            switch(node.kind){
                case 175 /* Constructor */ :
                    return visitConstructorDeclaration(node);
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                case 173 /* MethodDeclaration */ :
                    return setCurrentStaticPropertyDeclarationOrStaticBlockAnd(/*current*/ void 0, visitMethodOrAccessorDeclaration, node);
                case 171 /* PropertyDeclaration */ :
                    return setCurrentStaticPropertyDeclarationOrStaticBlockAnd(/*current*/ void 0, visitPropertyDeclaration, node);
                case 174 /* ClassStaticBlockDeclaration */ :
                    return visitClassStaticBlockDeclaration(node);
                case 166 /* ComputedPropertyName */ :
                    return visitComputedPropertyName(node);
                case 239 /* SemicolonClassElement */ :
                    return node;
                default:
                    return isModifierLike(node) ? modifierVisitor(node) : visitor(node);
            }
        }
        function propertyNameVisitor(node) {
            switch(node.kind){
                case 166 /* ComputedPropertyName */ :
                    return visitComputedPropertyName(node);
                default:
                    return visitor(node);
            }
        }
        function accessorFieldResultVisitor(node) {
            switch(node.kind){
                case 171 /* PropertyDeclaration */ :
                    return transformFieldInitializer(node);
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    return classElementVisitor(node);
                default:
                    Debug.assertMissingNode(node, "Expected node to either be a PropertyDeclaration, GetAccessorDeclaration, or SetAccessorDeclaration");
                    break;
            }
        }
        function visitPrivateIdentifier(node) {
            if (!shouldTransformPrivateElementsOrClassStaticBlocks) return node;
            if (isStatement(node.parent)) return node;
            return setOriginalNode(factory2.createIdentifier(""), node);
        }
        function transformPrivateIdentifierInInExpression(node) {
            const info = accessPrivateIdentifier2(node.left);
            if (info) {
                const receiver = visitNode(node.right, visitor, isExpression);
                return setOriginalNode(emitHelpers().createClassPrivateFieldInHelper(info.brandCheckIdentifier, receiver), node);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitPropertyAssignment(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const { referencedName: referencedName , name: name  } = visitReferencedPropertyName(node.name);
                const initializer = visitNode(node.initializer, (node2)=>namedEvaluationVisitor(node2, referencedName), isExpression);
                return factory2.updatePropertyAssignment(node, name, initializer);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitVariableStatement(node) {
            const savedPendingStatements = pendingStatements;
            pendingStatements = [];
            const visitedNode = visitEachChild(node, visitor, context);
            const statement = some(pendingStatements) ? [
                visitedNode,
                ...pendingStatements
            ] : visitedNode;
            pendingStatements = savedPendingStatements;
            return statement;
        }
        function getAssignedNameOfIdentifier(name, initializer) {
            const originalClass = getOriginalNode(initializer, isClassLike);
            return originalClass && !originalClass.name && hasSyntacticModifier(originalClass, 1024 /* Default */ ) ? factory2.createStringLiteral("default") : factory2.createStringLiteralFromNode(name);
        }
        function visitVariableDeclaration(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const assignedName = getAssignedNameOfIdentifier(node.name, node.initializer);
                const name = visitNode(node.name, visitor, isBindingName);
                const initializer = visitNode(node.initializer, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                return factory2.updateVariableDeclaration(node, name, /*exclamationToken*/ void 0, /*type*/ void 0, initializer);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitParameterDeclaration(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const assignedName = getAssignedNameOfIdentifier(node.name, node.initializer);
                const name = visitNode(node.name, visitor, isBindingName);
                const initializer = visitNode(node.initializer, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                return factory2.updateParameterDeclaration(node, /*modifiers*/ void 0, /*dotDotDotToken*/ void 0, name, /*questionToken*/ void 0, /*type*/ void 0, initializer);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitBindingElement(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const assignedName = getAssignedNameOfIdentifier(node.name, node.initializer);
                const propertyName = visitNode(node.propertyName, visitor, isPropertyName);
                const name = visitNode(node.name, visitor, isBindingName);
                const initializer = visitNode(node.initializer, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                return factory2.updateBindingElement(node, /*dotDotDotToken*/ void 0, propertyName, name, initializer);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitExportAssignment(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const assignedName = factory2.createStringLiteral(node.isExportEquals ? "" : "default");
                const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
                const expression = visitNode(node.expression, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                return factory2.updateExportAssignment(node, modifiers, expression);
            }
            return visitEachChild(node, visitor, context);
        }
        function injectPendingExpressions(expression) {
            if (some(pendingExpressions)) {
                if (isParenthesizedExpression(expression)) {
                    pendingExpressions.push(expression.expression);
                    expression = factory2.updateParenthesizedExpression(expression, factory2.inlineExpressions(pendingExpressions));
                } else {
                    pendingExpressions.push(expression);
                    expression = factory2.inlineExpressions(pendingExpressions);
                }
                pendingExpressions = void 0;
            }
            return expression;
        }
        function visitComputedPropertyName(node) {
            const expression = visitNode(node.expression, visitor, isExpression);
            return factory2.updateComputedPropertyName(node, injectPendingExpressions(expression));
        }
        function visitConstructorDeclaration(node) {
            if (currentClassContainer) return transformConstructor(node, currentClassContainer);
            return fallbackVisitor(node);
        }
        function shouldTransformClassElementToWeakMap(node) {
            if (shouldTransformPrivateElementsOrClassStaticBlocks) return true;
            if (hasStaticModifier(node) && getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ ) return true;
            return false;
        }
        function visitMethodOrAccessorDeclaration(node) {
            Debug.assert(!hasDecorators(node));
            if (!isPrivateIdentifierClassElementDeclaration(node) || !shouldTransformClassElementToWeakMap(node)) return visitEachChild(node, classElementVisitor, context);
            const info = accessPrivateIdentifier2(node.name);
            Debug.assert(info, "Undeclared private name for property declaration.");
            if (!info.isValid) return node;
            const functionName = getHoistedFunctionName(node);
            if (functionName) getPendingExpressions().push(factory2.createAssignment(functionName, factory2.createFunctionExpression(filter(node.modifiers, (m)=>isModifier(m) && !isStaticModifier(m) && !isAccessorModifier(m)), node.asteriskToken, functionName, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, visitFunctionBody(node.body, visitor, context))));
            return void 0;
        }
        function setCurrentStaticPropertyDeclarationOrStaticBlockAnd(current, visitor2, arg) {
            const savedCurrentStaticPropertyDeclarationOrStaticBlock = currentStaticPropertyDeclarationOrStaticBlock;
            currentStaticPropertyDeclarationOrStaticBlock = current;
            const result = visitor2(arg);
            currentStaticPropertyDeclarationOrStaticBlock = savedCurrentStaticPropertyDeclarationOrStaticBlock;
            return result;
        }
        function getHoistedFunctionName(node) {
            Debug.assert(isPrivateIdentifier(node.name));
            const info = accessPrivateIdentifier2(node.name);
            Debug.assert(info, "Undeclared private name for property declaration.");
            if (info.kind === "m" /* Method */ ) return info.methodName;
            if (info.kind === "a" /* Accessor */ ) {
                if (isGetAccessor(node)) return info.getterName;
                if (isSetAccessor(node)) return info.setterName;
            }
        }
        function transformAutoAccessor(node) {
            const commentRange = getCommentRange(node);
            const sourceMapRange = getSourceMapRange(node);
            const name = node.name;
            let getterName = name;
            let setterName = name;
            if (isComputedPropertyName(name) && !isSimpleInlineableExpression(name.expression)) {
                const cacheAssignment = findComputedPropertyNameCacheAssignment(name);
                if (cacheAssignment) {
                    getterName = factory2.updateComputedPropertyName(name, visitNode(name.expression, visitor, isExpression));
                    setterName = factory2.updateComputedPropertyName(name, cacheAssignment.left);
                } else {
                    const temp = factory2.createTempVariable(hoistVariableDeclaration);
                    setSourceMapRange(temp, name.expression);
                    const expression = visitNode(name.expression, visitor, isExpression);
                    const assignment = factory2.createAssignment(temp, expression);
                    setSourceMapRange(assignment, name.expression);
                    getterName = factory2.updateComputedPropertyName(name, assignment);
                    setterName = factory2.updateComputedPropertyName(name, temp);
                }
            }
            const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
            const backingField = createAccessorPropertyBackingField(factory2, node, modifiers, node.initializer);
            setOriginalNode(backingField, node);
            setEmitFlags(backingField, 3072 /* NoComments */ );
            setSourceMapRange(backingField, sourceMapRange);
            const getter = createAccessorPropertyGetRedirector(factory2, node, modifiers, getterName);
            setOriginalNode(getter, node);
            setCommentRange(getter, commentRange);
            setSourceMapRange(getter, sourceMapRange);
            const setter = createAccessorPropertySetRedirector(factory2, node, modifiers, setterName);
            setOriginalNode(setter, node);
            setEmitFlags(setter, 3072 /* NoComments */ );
            setSourceMapRange(setter, sourceMapRange);
            return visitArray([
                backingField,
                getter,
                setter
            ], accessorFieldResultVisitor, isClassElement);
        }
        function transformPrivateFieldInitializer(node) {
            if (shouldTransformClassElementToWeakMap(node)) {
                const info = accessPrivateIdentifier2(node.name);
                Debug.assert(info, "Undeclared private name for property declaration.");
                if (!info.isValid) return node;
                if (info.isStatic && !shouldTransformPrivateElementsOrClassStaticBlocks) {
                    const statement = transformPropertyOrClassStaticBlock(node, factory2.createThis());
                    if (statement) return factory2.createClassStaticBlockDeclaration(factory2.createBlock([
                        statement
                    ], /*multiLine*/ true));
                }
                return void 0;
            }
            if (shouldTransformInitializersUsingSet && !isStatic(node) && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) && lexicalEnvironment.data.facts & 16 /* WillHoistInitializersToConstructor */ ) return factory2.updatePropertyDeclaration(node, visitNodes2(node.modifiers, visitor, isModifierLike), node.name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const { referencedName: referencedName , name: name  } = visitReferencedPropertyName(node.name);
                return factory2.updatePropertyDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, (child)=>namedEvaluationVisitor(child, referencedName), isExpression));
            }
            return factory2.updatePropertyDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), visitNode(node.name, propertyNameVisitor, isPropertyName), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
        }
        function transformPublicFieldInitializer(node) {
            if (shouldTransformInitializers && !isAutoAccessorPropertyDeclaration(node)) {
                const expr = getPropertyNameExpressionIfNeeded(node.name, /*shouldHoist*/ !!node.initializer || useDefineForClassFields, /*captureReferencedName*/ isNamedEvaluation(node, isAnonymousClassNeedingAssignedName));
                if (expr) getPendingExpressions().push(...flattenCommaList(expr));
                if (isStatic(node) && !shouldTransformPrivateElementsOrClassStaticBlocks) {
                    const initializerStatement = transformPropertyOrClassStaticBlock(node, factory2.createThis());
                    if (initializerStatement) {
                        const staticBlock = factory2.createClassStaticBlockDeclaration(factory2.createBlock([
                            initializerStatement
                        ]));
                        setOriginalNode(staticBlock, node);
                        setCommentRange(staticBlock, node);
                        setCommentRange(initializerStatement, {
                            pos: -1,
                            end: -1
                        });
                        setSyntheticLeadingComments(initializerStatement, void 0);
                        setSyntheticTrailingComments(initializerStatement, void 0);
                        return staticBlock;
                    }
                }
                return void 0;
            }
            return factory2.updatePropertyDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), visitNode(node.name, propertyNameVisitor, isPropertyName), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
        }
        function transformFieldInitializer(node) {
            Debug.assert(!hasDecorators(node), "Decorators should already have been transformed and elided.");
            return isPrivateIdentifierClassElementDeclaration(node) ? transformPrivateFieldInitializer(node) : transformPublicFieldInitializer(node);
        }
        function shouldTransformAutoAccessorsInCurrentClass() {
            return shouldTransformAutoAccessors === -1 /* True */  || shouldTransformAutoAccessors === 3 /* Maybe */  && !!(lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) && !!(lexicalEnvironment.data.facts & 16 /* WillHoistInitializersToConstructor */ );
        }
        function visitPropertyDeclaration(node) {
            if (isAutoAccessorPropertyDeclaration(node) && (shouldTransformAutoAccessorsInCurrentClass() || hasStaticModifier(node) && getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ )) return transformAutoAccessor(node);
            return transformFieldInitializer(node);
        }
        function createPrivateIdentifierAccess(info, receiver) {
            return createPrivateIdentifierAccessHelper(info, visitNode(receiver, visitor, isExpression));
        }
        function createPrivateIdentifierAccessHelper(info, receiver) {
            setCommentRange(receiver, moveRangePos(receiver, -1));
            switch(info.kind){
                case "a" /* Accessor */ :
                    return emitHelpers().createClassPrivateFieldGetHelper(receiver, info.brandCheckIdentifier, info.kind, info.getterName);
                case "m" /* Method */ :
                    return emitHelpers().createClassPrivateFieldGetHelper(receiver, info.brandCheckIdentifier, info.kind, info.methodName);
                case "f" /* Field */ :
                    return emitHelpers().createClassPrivateFieldGetHelper(receiver, info.brandCheckIdentifier, info.kind, info.isStatic ? info.variableName : void 0);
                case "untransformed":
                    return Debug.fail("Access helpers should not be created for untransformed private elements");
                default:
                    Debug.assertNever(info, "Unknown private element type");
            }
        }
        function visitPropertyAccessExpression(node) {
            if (isPrivateIdentifier(node.name)) {
                const privateIdentifierInfo = accessPrivateIdentifier2(node.name);
                if (privateIdentifierInfo) return setTextRange(setOriginalNode(createPrivateIdentifierAccess(privateIdentifierInfo, node.expression), node), node);
            }
            if (shouldTransformSuperInStaticInitializers && isSuperProperty(node) && isIdentifier(node.name) && currentStaticPropertyDeclarationOrStaticBlock && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                const { classConstructor: classConstructor , superClassReference: superClassReference , facts: facts  } = lexicalEnvironment.data;
                if (facts & 1 /* ClassWasDecorated */ ) return visitInvalidSuperProperty(node);
                if (classConstructor && superClassReference) {
                    const superProperty = factory2.createReflectGetCall(superClassReference, factory2.createStringLiteralFromNode(node.name), classConstructor);
                    setOriginalNode(superProperty, node.expression);
                    setTextRange(superProperty, node.expression);
                    return superProperty;
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitElementAccessExpression(node) {
            if (shouldTransformSuperInStaticInitializers && isSuperProperty(node) && currentStaticPropertyDeclarationOrStaticBlock && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                const { classConstructor: classConstructor , superClassReference: superClassReference , facts: facts  } = lexicalEnvironment.data;
                if (facts & 1 /* ClassWasDecorated */ ) return visitInvalidSuperProperty(node);
                if (classConstructor && superClassReference) {
                    const superProperty = factory2.createReflectGetCall(superClassReference, visitNode(node.argumentExpression, visitor, isExpression), classConstructor);
                    setOriginalNode(superProperty, node.expression);
                    setTextRange(superProperty, node.expression);
                    return superProperty;
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitPreOrPostfixUnaryExpression(node, discarded) {
            if (node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) {
                const operand = skipParentheses(node.operand);
                if (isPrivateIdentifierPropertyAccessExpression(operand)) {
                    let info;
                    if (info = accessPrivateIdentifier2(operand.name)) {
                        const receiver = visitNode(operand.expression, visitor, isExpression);
                        const { readExpression: readExpression , initializeExpression: initializeExpression  } = createCopiableReceiverExpr(receiver);
                        let expression = createPrivateIdentifierAccess(info, readExpression);
                        const temp = isPrefixUnaryExpression(node) || discarded ? void 0 : factory2.createTempVariable(hoistVariableDeclaration);
                        expression = expandPreOrPostfixIncrementOrDecrementExpression(factory2, node, expression, hoistVariableDeclaration, temp);
                        expression = createPrivateIdentifierAssignment(info, initializeExpression || readExpression, expression, 64 /* EqualsToken */ );
                        setOriginalNode(expression, node);
                        setTextRange(expression, node);
                        if (temp) {
                            expression = factory2.createComma(expression, temp);
                            setTextRange(expression, node);
                        }
                        return expression;
                    }
                } else if (shouldTransformSuperInStaticInitializers && isSuperProperty(operand) && currentStaticPropertyDeclarationOrStaticBlock && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                    const { classConstructor: classConstructor , superClassReference: superClassReference , facts: facts  } = lexicalEnvironment.data;
                    if (facts & 1 /* ClassWasDecorated */ ) {
                        const expression = visitInvalidSuperProperty(operand);
                        return isPrefixUnaryExpression(node) ? factory2.updatePrefixUnaryExpression(node, expression) : factory2.updatePostfixUnaryExpression(node, expression);
                    }
                    if (classConstructor && superClassReference) {
                        let setterName;
                        let getterName;
                        if (isPropertyAccessExpression(operand)) {
                            if (isIdentifier(operand.name)) getterName = setterName = factory2.createStringLiteralFromNode(operand.name);
                        } else if (isSimpleInlineableExpression(operand.argumentExpression)) getterName = setterName = operand.argumentExpression;
                        else {
                            getterName = factory2.createTempVariable(hoistVariableDeclaration);
                            setterName = factory2.createAssignment(getterName, visitNode(operand.argumentExpression, visitor, isExpression));
                        }
                        if (setterName && getterName) {
                            let expression = factory2.createReflectGetCall(superClassReference, getterName, classConstructor);
                            setTextRange(expression, operand);
                            const temp = discarded ? void 0 : factory2.createTempVariable(hoistVariableDeclaration);
                            expression = expandPreOrPostfixIncrementOrDecrementExpression(factory2, node, expression, hoistVariableDeclaration, temp);
                            expression = factory2.createReflectSetCall(superClassReference, setterName, expression, classConstructor);
                            setOriginalNode(expression, node);
                            setTextRange(expression, node);
                            if (temp) {
                                expression = factory2.createComma(expression, temp);
                                setTextRange(expression, node);
                            }
                            return expression;
                        }
                    }
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitForStatement(node) {
            return factory2.updateForStatement(node, visitNode(node.initializer, discardedValueVisitor, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, discardedValueVisitor, isExpression), visitIterationBody(node.statement, visitor, context));
        }
        function visitExpressionStatement(node) {
            return factory2.updateExpressionStatement(node, visitNode(node.expression, discardedValueVisitor, isExpression));
        }
        function createCopiableReceiverExpr(receiver) {
            const clone2 = nodeIsSynthesized(receiver) ? receiver : factory2.cloneNode(receiver);
            if (isSimpleInlineableExpression(receiver)) return {
                readExpression: clone2,
                initializeExpression: void 0
            };
            const readExpression = factory2.createTempVariable(hoistVariableDeclaration);
            const initializeExpression = factory2.createAssignment(readExpression, clone2);
            return {
                readExpression: readExpression,
                initializeExpression: initializeExpression
            };
        }
        function visitCallExpression(node) {
            var _a;
            if (isPrivateIdentifierPropertyAccessExpression(node.expression) && accessPrivateIdentifier2(node.expression.name)) {
                const { thisArg: thisArg , target: target  } = factory2.createCallBinding(node.expression, hoistVariableDeclaration, languageVersion);
                if (isCallChain(node)) return factory2.updateCallChain(node, factory2.createPropertyAccessChain(visitNode(target, visitor, isExpression), node.questionDotToken, "call"), /*questionDotToken*/ void 0, /*typeArguments*/ void 0, [
                    visitNode(thisArg, visitor, isExpression),
                    ...visitNodes2(node.arguments, visitor, isExpression)
                ]);
                return factory2.updateCallExpression(node, factory2.createPropertyAccessExpression(visitNode(target, visitor, isExpression), "call"), /*typeArguments*/ void 0, [
                    visitNode(thisArg, visitor, isExpression),
                    ...visitNodes2(node.arguments, visitor, isExpression)
                ]);
            }
            if (shouldTransformSuperInStaticInitializers && isSuperProperty(node.expression) && currentStaticPropertyDeclarationOrStaticBlock && ((_a = lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) == null ? void 0 : _a.classConstructor)) {
                const invocation = factory2.createFunctionCallCall(visitNode(node.expression, visitor, isExpression), lexicalEnvironment.data.classConstructor, visitNodes2(node.arguments, visitor, isExpression));
                setOriginalNode(invocation, node);
                setTextRange(invocation, node);
                return invocation;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitTaggedTemplateExpression(node) {
            var _a;
            if (isPrivateIdentifierPropertyAccessExpression(node.tag) && accessPrivateIdentifier2(node.tag.name)) {
                const { thisArg: thisArg , target: target  } = factory2.createCallBinding(node.tag, hoistVariableDeclaration, languageVersion);
                return factory2.updateTaggedTemplateExpression(node, factory2.createCallExpression(factory2.createPropertyAccessExpression(visitNode(target, visitor, isExpression), "bind"), /*typeArguments*/ void 0, [
                    visitNode(thisArg, visitor, isExpression)
                ]), /*typeArguments*/ void 0, visitNode(node.template, visitor, isTemplateLiteral));
            }
            if (shouldTransformSuperInStaticInitializers && isSuperProperty(node.tag) && currentStaticPropertyDeclarationOrStaticBlock && ((_a = lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) == null ? void 0 : _a.classConstructor)) {
                const invocation = factory2.createFunctionBindCall(visitNode(node.tag, visitor, isExpression), lexicalEnvironment.data.classConstructor, []);
                setOriginalNode(invocation, node);
                setTextRange(invocation, node);
                return factory2.updateTaggedTemplateExpression(node, invocation, /*typeArguments*/ void 0, visitNode(node.template, visitor, isTemplateLiteral));
            }
            return visitEachChild(node, visitor, context);
        }
        function transformClassStaticBlockDeclaration(node) {
            if (lexicalEnvironment) lexicalEnvironmentMap.set(getOriginalNode(node), lexicalEnvironment);
            if (shouldTransformPrivateElementsOrClassStaticBlocks) {
                startLexicalEnvironment();
                let statements = setCurrentStaticPropertyDeclarationOrStaticBlockAnd(node, (statements2)=>visitNodes2(statements2, visitor, isStatement), node.body.statements);
                statements = factory2.mergeLexicalEnvironment(statements, endLexicalEnvironment());
                const iife = factory2.createImmediatelyInvokedArrowFunction(statements);
                setOriginalNode(iife, node);
                setTextRange(iife, node);
                addEmitFlags(iife, 4 /* AdviseOnEmitNode */ );
                return iife;
            }
        }
        function isAnonymousClassNeedingAssignedName(node) {
            if (isClassExpression(node) && !node.name) {
                const staticPropertiesOrClassStaticBlocks = getStaticPropertiesAndClassStaticBlock(node);
                const classStaticBlock = find(staticPropertiesOrClassStaticBlocks, isClassStaticBlockDeclaration);
                if (classStaticBlock) for (const statement of classStaticBlock.body.statements){
                    if (isExpressionStatement(statement) && isCallToHelper(statement.expression, "___setFunctionName")) return false;
                }
                const hasTransformableStatics = (shouldTransformPrivateElementsOrClassStaticBlocks || !!(getInternalEmitFlags(node) && 32 /* TransformPrivateStaticElements */ )) && some(staticPropertiesOrClassStaticBlocks, (node2)=>isClassStaticBlockDeclaration(node2) || isPrivateIdentifierClassElementDeclaration(node2) || shouldTransformInitializers && isInitializedProperty(node2));
                return hasTransformableStatics;
            }
            return false;
        }
        function visitBinaryExpression(node, discarded) {
            if (isDestructuringAssignment(node)) {
                const savedPendingExpressions = pendingExpressions;
                pendingExpressions = void 0;
                node = factory2.updateBinaryExpression(node, visitNode(node.left, assignmentTargetVisitor, isExpression), node.operatorToken, visitNode(node.right, visitor, isExpression));
                const expr = some(pendingExpressions) ? factory2.inlineExpressions(compact([
                    ...pendingExpressions,
                    node
                ])) : node;
                pendingExpressions = savedPendingExpressions;
                return expr;
            }
            if (isAssignmentExpression(node)) {
                if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                    const assignedName = getAssignedNameOfIdentifier(node.left, node.right);
                    const left2 = visitNode(node.left, visitor, isExpression);
                    const right = visitNode(node.right, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                    return factory2.updateBinaryExpression(node, left2, node.operatorToken, right);
                }
                const left = skipOuterExpressions(node.left, 9 /* Parentheses */ );
                if (isPrivateIdentifierPropertyAccessExpression(left)) {
                    const info = accessPrivateIdentifier2(left.name);
                    if (info) return setTextRange(setOriginalNode(createPrivateIdentifierAssignment(info, left.expression, node.right, node.operatorToken.kind), node), node);
                } else if (shouldTransformSuperInStaticInitializers && isSuperProperty(node.left) && currentStaticPropertyDeclarationOrStaticBlock && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                    const { classConstructor: classConstructor , superClassReference: superClassReference , facts: facts  } = lexicalEnvironment.data;
                    if (facts & 1 /* ClassWasDecorated */ ) return factory2.updateBinaryExpression(node, visitInvalidSuperProperty(node.left), node.operatorToken, visitNode(node.right, visitor, isExpression));
                    if (classConstructor && superClassReference) {
                        let setterName = isElementAccessExpression(node.left) ? visitNode(node.left.argumentExpression, visitor, isExpression) : isIdentifier(node.left.name) ? factory2.createStringLiteralFromNode(node.left.name) : void 0;
                        if (setterName) {
                            let expression = visitNode(node.right, visitor, isExpression);
                            if (isCompoundAssignment(node.operatorToken.kind)) {
                                let getterName = setterName;
                                if (!isSimpleInlineableExpression(setterName)) {
                                    getterName = factory2.createTempVariable(hoistVariableDeclaration);
                                    setterName = factory2.createAssignment(getterName, setterName);
                                }
                                const superPropertyGet = factory2.createReflectGetCall(superClassReference, getterName, classConstructor);
                                setOriginalNode(superPropertyGet, node.left);
                                setTextRange(superPropertyGet, node.left);
                                expression = factory2.createBinaryExpression(superPropertyGet, getNonAssignmentOperatorForCompoundAssignment(node.operatorToken.kind), expression);
                                setTextRange(expression, node);
                            }
                            const temp = discarded ? void 0 : factory2.createTempVariable(hoistVariableDeclaration);
                            if (temp) {
                                expression = factory2.createAssignment(temp, expression);
                                setTextRange(temp, node);
                            }
                            expression = factory2.createReflectSetCall(superClassReference, setterName, expression, classConstructor);
                            setOriginalNode(expression, node);
                            setTextRange(expression, node);
                            if (temp) {
                                expression = factory2.createComma(expression, temp);
                                setTextRange(expression, node);
                            }
                            return expression;
                        }
                    }
                }
            }
            if (isPrivateIdentifierInExpression(node)) return transformPrivateIdentifierInInExpression(node);
            return visitEachChild(node, visitor, context);
        }
        function visitCommaListExpression(node, discarded) {
            const elements = discarded ? visitCommaListElements(node.elements, discardedValueVisitor) : visitCommaListElements(node.elements, visitor, discardedValueVisitor);
            return factory2.updateCommaListExpression(node, elements);
        }
        function visitParenthesizedExpression(node, discarded, referencedName) {
            const visitorFunc = discarded ? discardedValueVisitor : referencedName ? (node2)=>namedEvaluationVisitor(node2, referencedName) : visitor;
            const expression = visitNode(node.expression, visitorFunc, isExpression);
            return factory2.updateParenthesizedExpression(node, expression);
        }
        function visitPartiallyEmittedExpression(node, discarded, referencedName) {
            const visitorFunc = discarded ? discardedValueVisitor : referencedName ? (node2)=>namedEvaluationVisitor(node2, referencedName) : visitor;
            const expression = visitNode(node.expression, visitorFunc, isExpression);
            return factory2.updatePartiallyEmittedExpression(node, expression);
        }
        function visitReferencedPropertyName(node) {
            if (isPropertyNameLiteral(node) || isPrivateIdentifier(node)) {
                const referencedName2 = factory2.createStringLiteralFromNode(node);
                const name2 = visitNode(node, visitor, isPropertyName);
                return {
                    referencedName: referencedName2,
                    name: name2
                };
            }
            if (isPropertyNameLiteral(node.expression) && !isIdentifier(node.expression)) {
                const referencedName2 = factory2.createStringLiteralFromNode(node.expression);
                const name2 = visitNode(node, visitor, isPropertyName);
                return {
                    referencedName: referencedName2,
                    name: name2
                };
            }
            const referencedName = factory2.createTempVariable(hoistVariableDeclaration);
            const key = emitHelpers().createPropKeyHelper(visitNode(node.expression, visitor, isExpression));
            const assignment = factory2.createAssignment(referencedName, key);
            const name = factory2.updateComputedPropertyName(node, injectPendingExpressions(assignment));
            return {
                referencedName: referencedName,
                name: name
            };
        }
        function createPrivateIdentifierAssignment(info, receiver, right, operator) {
            receiver = visitNode(receiver, visitor, isExpression);
            right = visitNode(right, visitor, isExpression);
            if (isCompoundAssignment(operator)) {
                const { readExpression: readExpression , initializeExpression: initializeExpression  } = createCopiableReceiverExpr(receiver);
                receiver = initializeExpression || readExpression;
                right = factory2.createBinaryExpression(createPrivateIdentifierAccessHelper(info, readExpression), getNonAssignmentOperatorForCompoundAssignment(operator), right);
            }
            setCommentRange(receiver, moveRangePos(receiver, -1));
            switch(info.kind){
                case "a" /* Accessor */ :
                    return emitHelpers().createClassPrivateFieldSetHelper(receiver, info.brandCheckIdentifier, right, info.kind, info.setterName);
                case "m" /* Method */ :
                    return emitHelpers().createClassPrivateFieldSetHelper(receiver, info.brandCheckIdentifier, right, info.kind, /*f*/ void 0);
                case "f" /* Field */ :
                    return emitHelpers().createClassPrivateFieldSetHelper(receiver, info.brandCheckIdentifier, right, info.kind, info.isStatic ? info.variableName : void 0);
                case "untransformed":
                    return Debug.fail("Access helpers should not be created for untransformed private elements");
                default:
                    Debug.assertNever(info, "Unknown private element type");
            }
        }
        function getPrivateInstanceMethodsAndAccessors(node) {
            return filter(node.members, isNonStaticMethodOrAccessorWithPrivateName);
        }
        function getClassFacts(node) {
            let facts = 0 /* None */ ;
            const original = getOriginalNode(node);
            if (isClassDeclaration(original) && classOrConstructorParameterIsDecorated(legacyDecorators, original)) facts |= 1 /* ClassWasDecorated */ ;
            let containsPublicInstanceFields = false;
            let containsInitializedPublicInstanceFields = false;
            let containsInstancePrivateElements = false;
            let containsInstanceAutoAccessors = false;
            for (const member of node.members){
                if (isStatic(member)) {
                    if (member.name && (isPrivateIdentifier(member.name) || isAutoAccessorPropertyDeclaration(member)) && shouldTransformPrivateElementsOrClassStaticBlocks) facts |= 2 /* NeedsClassConstructorReference */ ;
                    if (isPropertyDeclaration(member) || isClassStaticBlockDeclaration(member)) {
                        if (shouldTransformThisInStaticInitializers && member.transformFlags & 16384 /* ContainsLexicalThis */ ) {
                            facts |= 8 /* NeedsSubstitutionForThisInClassStaticField */ ;
                            if (!(facts & 1 /* ClassWasDecorated */ )) facts |= 2 /* NeedsClassConstructorReference */ ;
                        }
                        if (shouldTransformSuperInStaticInitializers && member.transformFlags & 134217728 /* ContainsLexicalSuper */ ) {
                            if (!(facts & 1 /* ClassWasDecorated */ )) facts |= 6 /* NeedsClassSuperReference */ ;
                        }
                    }
                } else if (!hasAbstractModifier(getOriginalNode(member))) {
                    if (isAutoAccessorPropertyDeclaration(member)) {
                        containsInstanceAutoAccessors = true;
                        containsInstancePrivateElements || (containsInstancePrivateElements = isPrivateIdentifierClassElementDeclaration(member));
                    } else if (isPrivateIdentifierClassElementDeclaration(member)) containsInstancePrivateElements = true;
                    else if (isPropertyDeclaration(member)) {
                        containsPublicInstanceFields = true;
                        containsInitializedPublicInstanceFields || (containsInitializedPublicInstanceFields = !!member.initializer);
                    }
                }
            }
            const willHoistInitializersToConstructor = shouldTransformInitializersUsingDefine && containsPublicInstanceFields || shouldTransformInitializersUsingSet && containsInitializedPublicInstanceFields || shouldTransformPrivateElementsOrClassStaticBlocks && containsInstancePrivateElements || shouldTransformPrivateElementsOrClassStaticBlocks && containsInstanceAutoAccessors && shouldTransformAutoAccessors === -1 /* True */ ;
            if (willHoistInitializersToConstructor) facts |= 16 /* WillHoistInitializersToConstructor */ ;
            return facts;
        }
        function visitExpressionWithTypeArgumentsInHeritageClause(node) {
            var _a;
            const facts = ((_a = lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) == null ? void 0 : _a.facts) || 0 /* None */ ;
            if (facts & 4 /* NeedsClassSuperReference */ ) {
                const temp = factory2.createTempVariable(hoistVariableDeclaration, /*reservedInNestedScopes*/ true);
                getClassLexicalEnvironment().superClassReference = temp;
                return factory2.updateExpressionWithTypeArguments(node, factory2.createAssignment(temp, visitNode(node.expression, visitor, isExpression)), /*typeArguments*/ void 0);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitInNewClassLexicalEnvironment(node, referencedName, visitor2) {
            const savedCurrentClassContainer = currentClassContainer;
            const savedPendingExpressions = pendingExpressions;
            const savedLexicalEnvironment = lexicalEnvironment;
            currentClassContainer = node;
            pendingExpressions = void 0;
            startClassLexicalEnvironment();
            const shouldAlwaysTransformPrivateStaticElements = getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ ;
            if (shouldTransformPrivateElementsOrClassStaticBlocks || shouldAlwaysTransformPrivateStaticElements) {
                const name = getNameOfDeclaration(node);
                if (name && isIdentifier(name)) getPrivateIdentifierEnvironment().data.className = name;
            }
            if (shouldTransformPrivateElementsOrClassStaticBlocks) {
                const privateInstanceMethodsAndAccessors = getPrivateInstanceMethodsAndAccessors(node);
                if (some(privateInstanceMethodsAndAccessors)) getPrivateIdentifierEnvironment().data.weakSetName = createHoistedVariableForClass("instances", privateInstanceMethodsAndAccessors[0].name);
            }
            const facts = getClassFacts(node);
            if (facts) getClassLexicalEnvironment().facts = facts;
            if (facts & 8 /* NeedsSubstitutionForThisInClassStaticField */ ) enableSubstitutionForClassStaticThisOrSuperReference();
            const result = visitor2(node, facts, referencedName);
            endClassLexicalEnvironment();
            Debug.assert(lexicalEnvironment === savedLexicalEnvironment);
            currentClassContainer = savedCurrentClassContainer;
            pendingExpressions = savedPendingExpressions;
            return result;
        }
        function visitClassDeclaration(node) {
            return visitInNewClassLexicalEnvironment(node, /*referencedName*/ void 0, visitClassDeclarationInNewClassLexicalEnvironment);
        }
        function visitClassDeclarationInNewClassLexicalEnvironment(node, facts) {
            var _a, _b;
            let pendingClassReferenceAssignment;
            if (facts & 2 /* NeedsClassConstructorReference */ ) {
                if (shouldTransformPrivateElementsOrClassStaticBlocks && ((_a = node.emitNode) == null ? void 0 : _a.classThis)) {
                    getClassLexicalEnvironment().classConstructor = node.emitNode.classThis;
                    pendingClassReferenceAssignment = factory2.createAssignment(node.emitNode.classThis, factory2.getInternalName(node));
                } else {
                    const temp = factory2.createTempVariable(hoistVariableDeclaration, /*reservedInNestedScopes*/ true);
                    getClassLexicalEnvironment().classConstructor = factory2.cloneNode(temp);
                    pendingClassReferenceAssignment = factory2.createAssignment(temp, factory2.getInternalName(node));
                }
                if ((_b = node.emitNode) == null ? void 0 : _b.classThis) getClassLexicalEnvironment().classThis = node.emitNode.classThis;
            }
            const isExport = hasSyntacticModifier(node, 1 /* Export */ );
            const isDefault = hasSyntacticModifier(node, 1024 /* Default */ );
            let modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
            const heritageClauses = visitNodes2(node.heritageClauses, heritageClauseVisitor, isHeritageClause);
            const { members: members , prologue: prologue  } = transformClassMembers(node);
            const statements = [];
            if (pendingClassReferenceAssignment) getPendingExpressions().unshift(pendingClassReferenceAssignment);
            if (some(pendingExpressions)) statements.push(factory2.createExpressionStatement(factory2.inlineExpressions(pendingExpressions)));
            if (shouldTransformInitializersUsingSet || shouldTransformPrivateElementsOrClassStaticBlocks || getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ ) {
                const staticProperties = getStaticPropertiesAndClassStaticBlock(node);
                if (some(staticProperties)) addPropertyOrClassStaticBlockStatements(statements, staticProperties, factory2.getInternalName(node));
            }
            if (statements.length > 0 && isExport && isDefault) {
                modifiers = visitNodes2(modifiers, (node2)=>isExportOrDefaultModifier(node2) ? void 0 : node2, isModifier);
                statements.push(factory2.createExportAssignment(/*modifiers*/ void 0, /*isExportEquals*/ false, factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true)));
            }
            const classDecl = factory2.updateClassDeclaration(node, modifiers, node.name, /*typeParameters*/ void 0, heritageClauses, members);
            statements.unshift(classDecl);
            if (prologue) statements.unshift(factory2.createExpressionStatement(prologue));
            return statements;
        }
        function visitClassExpression(node, referencedName) {
            return visitInNewClassLexicalEnvironment(node, referencedName, visitClassExpressionInNewClassLexicalEnvironment);
        }
        function visitClassExpressionInNewClassLexicalEnvironment(node, facts, referencedName) {
            var _a, _b, _c, _d;
            const isDecoratedClassDeclaration = !!(facts & 1 /* ClassWasDecorated */ );
            const staticPropertiesOrClassStaticBlocks = getStaticPropertiesAndClassStaticBlock(node);
            const isClassWithConstructorReference = resolver.getNodeCheckFlags(node) & 1048576 /* ClassWithConstructorReference */ ;
            let temp;
            function createClassTempVar() {
                var _a2;
                if (shouldTransformPrivateElementsOrClassStaticBlocks && ((_a2 = node.emitNode) == null ? void 0 : _a2.classThis)) return getClassLexicalEnvironment().classConstructor = node.emitNode.classThis;
                const classCheckFlags = resolver.getNodeCheckFlags(node);
                const isClassWithConstructorReference2 = classCheckFlags & 1048576 /* ClassWithConstructorReference */ ;
                const requiresBlockScopedVar = classCheckFlags & 32768 /* BlockScopedBindingInLoop */ ;
                const temp2 = factory2.createTempVariable(requiresBlockScopedVar ? addBlockScopedVariable : hoistVariableDeclaration, !!isClassWithConstructorReference2);
                getClassLexicalEnvironment().classConstructor = factory2.cloneNode(temp2);
                return temp2;
            }
            if ((_a = node.emitNode) == null ? void 0 : _a.classThis) getClassLexicalEnvironment().classThis = node.emitNode.classThis;
            if (facts & 2 /* NeedsClassConstructorReference */ ) temp ?? (temp = createClassTempVar());
            const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
            const heritageClauses = visitNodes2(node.heritageClauses, heritageClauseVisitor, isHeritageClause);
            const { members: members , prologue: prologue  } = transformClassMembers(node);
            let classExpression = factory2.updateClassExpression(node, modifiers, node.name, /*typeParameters*/ void 0, heritageClauses, members);
            const expressions = [];
            if (prologue) expressions.push(prologue);
            const hasTransformableStatics = (shouldTransformPrivateElementsOrClassStaticBlocks || getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ ) && some(staticPropertiesOrClassStaticBlocks, (node2)=>isClassStaticBlockDeclaration(node2) || isPrivateIdentifierClassElementDeclaration(node2) || shouldTransformInitializers && isInitializedProperty(node2));
            if (hasTransformableStatics || some(pendingExpressions) || referencedName) {
                if (isDecoratedClassDeclaration) {
                    Debug.assertIsDefined(pendingStatements, "Decorated classes transformed by TypeScript are expected to be within a variable declaration.");
                    if (some(pendingExpressions)) addRange(pendingStatements, map(pendingExpressions, factory2.createExpressionStatement));
                    if (referencedName) {
                        if (shouldTransformPrivateElementsOrClassStaticBlocks) {
                            const setNameExpression = emitHelpers().createSetFunctionNameHelper(temp ?? ((_b = node.emitNode) == null ? void 0 : _b.classThis) ?? factory2.getInternalName(node), referencedName);
                            pendingStatements.push(factory2.createExpressionStatement(setNameExpression));
                        } else {
                            const setNameExpression = emitHelpers().createSetFunctionNameHelper(factory2.createThis(), referencedName);
                            classExpression = factory2.updateClassExpression(classExpression, classExpression.modifiers, classExpression.name, classExpression.typeParameters, classExpression.heritageClauses, [
                                factory2.createClassStaticBlockDeclaration(factory2.createBlock([
                                    factory2.createExpressionStatement(setNameExpression)
                                ])),
                                ...classExpression.members
                            ]);
                        }
                    }
                    if (some(staticPropertiesOrClassStaticBlocks)) addPropertyOrClassStaticBlockStatements(pendingStatements, staticPropertiesOrClassStaticBlocks, ((_c = node.emitNode) == null ? void 0 : _c.classThis) ?? factory2.getInternalName(node));
                    if (temp) expressions.push(factory2.createAssignment(temp, classExpression));
                    else if (shouldTransformPrivateElementsOrClassStaticBlocks && ((_d = node.emitNode) == null ? void 0 : _d.classThis)) expressions.push(factory2.createAssignment(node.emitNode.classThis, classExpression));
                    else expressions.push(classExpression);
                } else {
                    temp ?? (temp = createClassTempVar());
                    if (isClassWithConstructorReference) {
                        enableSubstitutionForClassAliases();
                        const alias = factory2.cloneNode(temp);
                        alias.emitNode.autoGenerate.flags &= -9 /* ReservedInNestedScopes */ ;
                        classAliases[getOriginalNodeId(node)] = alias;
                    }
                    expressions.push(factory2.createAssignment(temp, classExpression));
                    addRange(expressions, pendingExpressions);
                    if (referencedName) expressions.push(emitHelpers().createSetFunctionNameHelper(temp, referencedName));
                    addRange(expressions, generateInitializedPropertyExpressionsOrClassStaticBlock(staticPropertiesOrClassStaticBlocks, temp));
                    expressions.push(factory2.cloneNode(temp));
                }
            } else expressions.push(classExpression);
            if (expressions.length > 1) {
                addEmitFlags(classExpression, 131072 /* Indented */ );
                expressions.forEach(startOnNewLine);
            }
            return factory2.inlineExpressions(expressions);
        }
        function visitClassStaticBlockDeclaration(node) {
            if (!shouldTransformPrivateElementsOrClassStaticBlocks) return visitEachChild(node, visitor, context);
            return void 0;
        }
        function transformClassMembers(node) {
            const shouldTransformPrivateStaticElementsInClass = !!(getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ );
            if (shouldTransformPrivateElementsOrClassStaticBlocks || shouldTransformPrivateStaticElementsInFile) {
                for (const member of node.members)if (isPrivateIdentifierClassElementDeclaration(member)) {
                    if (shouldTransformClassElementToWeakMap(member)) addPrivateIdentifierToEnvironment(member, member.name, addPrivateIdentifierClassElementToEnvironment);
                    else {
                        const privateEnv = getPrivateIdentifierEnvironment();
                        setPrivateIdentifier(privateEnv, member.name, {
                            kind: "untransformed"
                        });
                    }
                }
                if (shouldTransformPrivateElementsOrClassStaticBlocks) {
                    if (some(getPrivateInstanceMethodsAndAccessors(node))) createBrandCheckWeakSetForPrivateMethods();
                }
                if (shouldTransformAutoAccessorsInCurrentClass()) {
                    for (const member of node.members)if (isAutoAccessorPropertyDeclaration(member)) {
                        const storageName = factory2.getGeneratedPrivateNameForNode(member.name, /*prefix*/ void 0, "_accessor_storage");
                        if (shouldTransformPrivateElementsOrClassStaticBlocks || shouldTransformPrivateStaticElementsInClass && hasStaticModifier(member)) addPrivateIdentifierToEnvironment(member, storageName, addPrivateIdentifierPropertyDeclarationToEnvironment);
                        else {
                            const privateEnv = getPrivateIdentifierEnvironment();
                            setPrivateIdentifier(privateEnv, storageName, {
                                kind: "untransformed"
                            });
                        }
                    }
                }
            }
            let members = visitNodes2(node.members, classElementVisitor, isClassElement);
            let syntheticConstructor;
            if (!some(members, isConstructorDeclaration)) syntheticConstructor = transformConstructor(/*constructor*/ void 0, node);
            let prologue;
            let syntheticStaticBlock;
            if (!shouldTransformPrivateElementsOrClassStaticBlocks && some(pendingExpressions)) {
                let statement = factory2.createExpressionStatement(factory2.inlineExpressions(pendingExpressions));
                if (statement.transformFlags & 134234112 /* ContainsLexicalThisOrSuper */ ) {
                    const temp = factory2.createTempVariable(hoistVariableDeclaration);
                    const arrow = factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, /*parameters*/ [], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, factory2.createBlock([
                        statement
                    ]));
                    prologue = factory2.createAssignment(temp, arrow);
                    statement = factory2.createExpressionStatement(factory2.createCallExpression(temp, /*typeArguments*/ void 0, []));
                }
                const block = factory2.createBlock([
                    statement
                ]);
                syntheticStaticBlock = factory2.createClassStaticBlockDeclaration(block);
                pendingExpressions = void 0;
            }
            if (syntheticConstructor || syntheticStaticBlock) {
                let membersArray;
                membersArray = append(membersArray, syntheticConstructor);
                membersArray = append(membersArray, syntheticStaticBlock);
                membersArray = addRange(membersArray, members);
                members = setTextRange(factory2.createNodeArray(membersArray), /*location*/ node.members);
            }
            return {
                members: members,
                prologue: prologue
            };
        }
        function createBrandCheckWeakSetForPrivateMethods() {
            const { weakSetName: weakSetName  } = getPrivateIdentifierEnvironment().data;
            Debug.assert(weakSetName, "weakSetName should be set in private identifier environment");
            getPendingExpressions().push(factory2.createAssignment(weakSetName, factory2.createNewExpression(factory2.createIdentifier("WeakSet"), /*typeArguments*/ void 0, [])));
        }
        function transformConstructor(constructor, container) {
            constructor = visitNode(constructor, visitor, isConstructorDeclaration);
            if (!(lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) || !(lexicalEnvironment.data.facts & 16 /* WillHoistInitializersToConstructor */ )) return constructor;
            const extendsClauseElement = getEffectiveBaseTypeNode(container);
            const isDerivedClass = !!(extendsClauseElement && skipOuterExpressions(extendsClauseElement.expression).kind !== 106 /* NullKeyword */ );
            const parameters = visitParameterList(constructor ? constructor.parameters : void 0, visitor, context);
            const body = transformConstructorBody(container, constructor, isDerivedClass);
            if (!body) return constructor;
            if (constructor) {
                Debug.assert(parameters);
                return factory2.updateConstructorDeclaration(constructor, /*modifiers*/ void 0, parameters, body);
            }
            return startOnNewLine(setOriginalNode(setTextRange(factory2.createConstructorDeclaration(/*modifiers*/ void 0, parameters ?? [], body), constructor || container), constructor));
        }
        function transformConstructorBody(node, constructor, isDerivedClass) {
            var _a;
            const instanceProperties = getProperties(node, /*requireInitializer*/ false, /*isStatic*/ false);
            let properties = instanceProperties;
            if (!useDefineForClassFields) properties = filter(properties, (property)=>!!property.initializer || isPrivateIdentifier(property.name) || hasAccessorModifier(property));
            const privateMethodsAndAccessors = getPrivateInstanceMethodsAndAccessors(node);
            const needsConstructorBody = some(properties) || some(privateMethodsAndAccessors);
            if (!constructor && !needsConstructorBody) return visitFunctionBody(/*node*/ void 0, visitor, context);
            resumeLexicalEnvironment();
            const needsSyntheticConstructor = !constructor && isDerivedClass;
            let indexOfFirstStatementAfterSuperAndPrologue = 0;
            let prologueStatementCount = 0;
            let superStatementIndex = -1;
            let statements = [];
            if ((_a = constructor == null ? void 0 : constructor.body) == null ? void 0 : _a.statements) {
                prologueStatementCount = factory2.copyPrologue(constructor.body.statements, statements, /*ensureUseStrict*/ false, visitor);
                superStatementIndex = findSuperStatementIndex(constructor.body.statements, prologueStatementCount);
                if (superStatementIndex >= 0) {
                    indexOfFirstStatementAfterSuperAndPrologue = superStatementIndex + 1;
                    statements = [
                        ...statements.slice(0, prologueStatementCount),
                        ...visitNodes2(constructor.body.statements, visitor, isStatement, prologueStatementCount, indexOfFirstStatementAfterSuperAndPrologue - prologueStatementCount),
                        ...statements.slice(prologueStatementCount)
                    ];
                } else if (prologueStatementCount >= 0) indexOfFirstStatementAfterSuperAndPrologue = prologueStatementCount;
            }
            if (needsSyntheticConstructor) statements.push(factory2.createExpressionStatement(factory2.createCallExpression(factory2.createSuper(), /*typeArguments*/ void 0, [
                factory2.createSpreadElement(factory2.createIdentifier("arguments"))
            ])));
            let parameterPropertyDeclarationCount = 0;
            if (constructor == null ? void 0 : constructor.body) {
                for(let i = indexOfFirstStatementAfterSuperAndPrologue; i < constructor.body.statements.length; i++){
                    const statement = constructor.body.statements[i];
                    if (isParameterPropertyDeclaration(getOriginalNode(statement), constructor)) parameterPropertyDeclarationCount++;
                    else break;
                }
                if (parameterPropertyDeclarationCount > 0) indexOfFirstStatementAfterSuperAndPrologue += parameterPropertyDeclarationCount;
            }
            const receiver = factory2.createThis();
            addInstanceMethodStatements(statements, privateMethodsAndAccessors, receiver);
            if (constructor) {
                const parameterProperties = filter(instanceProperties, (prop)=>isParameterPropertyDeclaration(getOriginalNode(prop), constructor));
                const nonParameterProperties = filter(properties, (prop)=>!isParameterPropertyDeclaration(getOriginalNode(prop), constructor));
                addPropertyOrClassStaticBlockStatements(statements, parameterProperties, receiver);
                addPropertyOrClassStaticBlockStatements(statements, nonParameterProperties, receiver);
            } else addPropertyOrClassStaticBlockStatements(statements, properties, receiver);
            if (constructor) addRange(statements, visitNodes2(constructor.body.statements, visitor, isStatement, indexOfFirstStatementAfterSuperAndPrologue));
            statements = factory2.mergeLexicalEnvironment(statements, endLexicalEnvironment());
            if (statements.length === 0 && !constructor) return void 0;
            const multiLine = (constructor == null ? void 0 : constructor.body) && constructor.body.statements.length >= statements.length ? constructor.body.multiLine ?? statements.length > 0 : statements.length > 0;
            return setTextRange(factory2.createBlock(setTextRange(factory2.createNodeArray(statements), /*location*/ constructor ? constructor.body.statements : node.members), multiLine), /*location*/ constructor ? constructor.body : void 0);
        }
        function addPropertyOrClassStaticBlockStatements(statements, properties, receiver) {
            for (const property of properties){
                if (isStatic(property) && !shouldTransformPrivateElementsOrClassStaticBlocks) continue;
                const statement = transformPropertyOrClassStaticBlock(property, receiver);
                if (!statement) continue;
                statements.push(statement);
            }
        }
        function transformPropertyOrClassStaticBlock(property, receiver) {
            const expression = isClassStaticBlockDeclaration(property) ? transformClassStaticBlockDeclaration(property) : transformProperty(property, receiver);
            if (!expression) return void 0;
            const statement = factory2.createExpressionStatement(expression);
            setOriginalNode(statement, property);
            addEmitFlags(statement, getEmitFlags(property) & 3072 /* NoComments */ );
            setCommentRange(statement, property);
            const propertyOriginalNode = getOriginalNode(property);
            if (isParameter(propertyOriginalNode)) {
                setSourceMapRange(statement, propertyOriginalNode);
                removeAllComments(statement);
            } else setSourceMapRange(statement, moveRangePastModifiers(property));
            setSyntheticLeadingComments(expression, void 0);
            setSyntheticTrailingComments(expression, void 0);
            if (hasAccessorModifier(propertyOriginalNode)) addEmitFlags(statement, 3072 /* NoComments */ );
            return statement;
        }
        function generateInitializedPropertyExpressionsOrClassStaticBlock(propertiesOrClassStaticBlocks, receiver) {
            const expressions = [];
            for (const property of propertiesOrClassStaticBlocks){
                const expression = isClassStaticBlockDeclaration(property) ? transformClassStaticBlockDeclaration(property) : transformProperty(property, receiver);
                if (!expression) continue;
                startOnNewLine(expression);
                setOriginalNode(expression, property);
                addEmitFlags(expression, getEmitFlags(property) & 3072 /* NoComments */ );
                setSourceMapRange(expression, moveRangePastModifiers(property));
                setCommentRange(expression, property);
                expressions.push(expression);
            }
            return expressions;
        }
        function transformProperty(property, receiver) {
            var _a;
            const savedCurrentStaticPropertyDeclarationOrStaticBlock = currentStaticPropertyDeclarationOrStaticBlock;
            const transformed = transformPropertyWorker(property, receiver);
            if (transformed && hasStaticModifier(property) && ((_a = lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) == null ? void 0 : _a.facts)) {
                setOriginalNode(transformed, property);
                addEmitFlags(transformed, 4 /* AdviseOnEmitNode */ );
                setSourceMapRange(transformed, getSourceMapRange(property.name));
                lexicalEnvironmentMap.set(getOriginalNode(property), lexicalEnvironment);
            }
            currentStaticPropertyDeclarationOrStaticBlock = savedCurrentStaticPropertyDeclarationOrStaticBlock;
            return transformed;
        }
        function transformPropertyWorker(property, receiver) {
            const emitAssignment = !useDefineForClassFields;
            let referencedName;
            if (isNamedEvaluation(property, isAnonymousClassNeedingAssignedName)) {
                if (isPropertyNameLiteral(property.name) || isPrivateIdentifier(property.name)) referencedName = factory2.createStringLiteralFromNode(property.name);
                else if (isPropertyNameLiteral(property.name.expression) && !isIdentifier(property.name.expression)) referencedName = factory2.createStringLiteralFromNode(property.name.expression);
                else referencedName = factory2.getGeneratedNameForNode(property.name);
            }
            const propertyName = hasAccessorModifier(property) ? factory2.getGeneratedPrivateNameForNode(property.name) : isComputedPropertyName(property.name) && !isSimpleInlineableExpression(property.name.expression) ? factory2.updateComputedPropertyName(property.name, factory2.getGeneratedNameForNode(property.name)) : property.name;
            if (hasStaticModifier(property)) currentStaticPropertyDeclarationOrStaticBlock = property;
            const initializerVisitor = referencedName ? (child)=>namedEvaluationVisitor(child, referencedName) : visitor;
            if (isPrivateIdentifier(propertyName) && shouldTransformClassElementToWeakMap(property)) {
                const privateIdentifierInfo = accessPrivateIdentifier2(propertyName);
                if (privateIdentifierInfo) {
                    if (privateIdentifierInfo.kind === "f" /* Field */ ) {
                        if (!privateIdentifierInfo.isStatic) return createPrivateInstanceFieldInitializer(factory2, receiver, visitNode(property.initializer, initializerVisitor, isExpression), privateIdentifierInfo.brandCheckIdentifier);
                        else return createPrivateStaticFieldInitializer(factory2, privateIdentifierInfo.variableName, visitNode(property.initializer, initializerVisitor, isExpression));
                    } else return void 0;
                } else Debug.fail("Undeclared private name for property declaration.");
            }
            if ((isPrivateIdentifier(propertyName) || hasStaticModifier(property)) && !property.initializer) return void 0;
            const propertyOriginalNode = getOriginalNode(property);
            if (hasSyntacticModifier(propertyOriginalNode, 256 /* Abstract */ )) return void 0;
            let initializer = visitNode(property.initializer, initializerVisitor, isExpression);
            if (isParameterPropertyDeclaration(propertyOriginalNode, propertyOriginalNode.parent) && isIdentifier(propertyName)) {
                const localName = factory2.cloneNode(propertyName);
                if (initializer) {
                    if (isParenthesizedExpression(initializer) && isCommaExpression(initializer.expression) && isCallToHelper(initializer.expression.left, "___runInitializers") && isVoidExpression(initializer.expression.right) && isNumericLiteral(initializer.expression.right.expression)) initializer = initializer.expression.left;
                    initializer = factory2.inlineExpressions([
                        initializer,
                        localName
                    ]);
                } else initializer = localName;
                setEmitFlags(propertyName, 3168 /* NoSourceMap */ );
                setSourceMapRange(localName, propertyOriginalNode.name);
                setEmitFlags(localName, 3072 /* NoComments */ );
            } else initializer ?? (initializer = factory2.createVoidZero());
            if (emitAssignment || isPrivateIdentifier(propertyName)) {
                const memberAccess = createMemberAccessForPropertyName(factory2, receiver, propertyName, /*location*/ propertyName);
                addEmitFlags(memberAccess, 1024 /* NoLeadingComments */ );
                const expression = factory2.createAssignment(memberAccess, initializer);
                return expression;
            } else {
                const name = isComputedPropertyName(propertyName) ? propertyName.expression : isIdentifier(propertyName) ? factory2.createStringLiteral(unescapeLeadingUnderscores(propertyName.escapedText)) : propertyName;
                const descriptor = factory2.createPropertyDescriptor({
                    value: initializer,
                    configurable: true,
                    writable: true,
                    enumerable: true
                });
                return factory2.createObjectDefinePropertyCall(receiver, name, descriptor);
            }
        }
        function enableSubstitutionForClassAliases() {
            if ((enabledSubstitutions & 1 /* ClassAliases */ ) === 0) {
                enabledSubstitutions |= 1 /* ClassAliases */ ;
                context.enableSubstitution(80 /* Identifier */ );
                classAliases = [];
            }
        }
        function enableSubstitutionForClassStaticThisOrSuperReference() {
            if ((enabledSubstitutions & 2 /* ClassStaticThisOrSuperReference */ ) === 0) {
                enabledSubstitutions |= 2 /* ClassStaticThisOrSuperReference */ ;
                context.enableSubstitution(110 /* ThisKeyword */ );
                context.enableEmitNotification(261 /* FunctionDeclaration */ );
                context.enableEmitNotification(217 /* FunctionExpression */ );
                context.enableEmitNotification(175 /* Constructor */ );
                context.enableEmitNotification(176 /* GetAccessor */ );
                context.enableEmitNotification(177 /* SetAccessor */ );
                context.enableEmitNotification(173 /* MethodDeclaration */ );
                context.enableEmitNotification(171 /* PropertyDeclaration */ );
                context.enableEmitNotification(166 /* ComputedPropertyName */ );
            }
        }
        function addInstanceMethodStatements(statements, methods, receiver) {
            if (!shouldTransformPrivateElementsOrClassStaticBlocks || !some(methods)) return;
            const { weakSetName: weakSetName  } = getPrivateIdentifierEnvironment().data;
            Debug.assert(weakSetName, "weakSetName should be set in private identifier environment");
            statements.push(factory2.createExpressionStatement(createPrivateInstanceMethodInitializer(factory2, receiver, weakSetName)));
        }
        function visitInvalidSuperProperty(node) {
            return isPropertyAccessExpression(node) ? factory2.updatePropertyAccessExpression(node, factory2.createVoidZero(), node.name) : factory2.updateElementAccessExpression(node, factory2.createVoidZero(), visitNode(node.argumentExpression, visitor, isExpression));
        }
        function getPropertyNameExpressionIfNeeded(name, shouldHoist, captureReferencedName) {
            if (isComputedPropertyName(name)) {
                const cacheAssignment = findComputedPropertyNameCacheAssignment(name);
                let expression = visitNode(name.expression, visitor, isExpression);
                const innerExpression = skipPartiallyEmittedExpressions(expression);
                const inlinable = isSimpleInlineableExpression(innerExpression);
                const alreadyTransformed = !!cacheAssignment || isAssignmentExpression(innerExpression) && isGeneratedIdentifier(innerExpression.left);
                if (!alreadyTransformed && !inlinable && shouldHoist) {
                    const generatedName = factory2.getGeneratedNameForNode(name);
                    if (resolver.getNodeCheckFlags(name) & 32768 /* BlockScopedBindingInLoop */ ) addBlockScopedVariable(generatedName);
                    else hoistVariableDeclaration(generatedName);
                    if (captureReferencedName) expression = emitHelpers().createPropKeyHelper(expression);
                    return factory2.createAssignment(generatedName, expression);
                }
                return inlinable || isIdentifier(innerExpression) ? void 0 : expression;
            }
        }
        function startClassLexicalEnvironment() {
            lexicalEnvironment = {
                previous: lexicalEnvironment,
                data: void 0
            };
        }
        function endClassLexicalEnvironment() {
            lexicalEnvironment = lexicalEnvironment == null ? void 0 : lexicalEnvironment.previous;
        }
        function getClassLexicalEnvironment() {
            Debug.assert(lexicalEnvironment);
            return lexicalEnvironment.data ?? (lexicalEnvironment.data = {
                facts: 0 /* None */ ,
                classConstructor: void 0,
                classThis: void 0,
                superClassReference: void 0
            });
        }
        function getPrivateIdentifierEnvironment() {
            Debug.assert(lexicalEnvironment);
            return lexicalEnvironment.privateEnv ?? (lexicalEnvironment.privateEnv = newPrivateEnvironment({
                className: void 0,
                weakSetName: void 0
            }));
        }
        function getPendingExpressions() {
            return pendingExpressions ?? (pendingExpressions = []);
        }
        function addPrivateIdentifierClassElementToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo) {
            if (isAutoAccessorPropertyDeclaration(node)) addPrivateIdentifierAutoAccessorPropertyDeclarationToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
            else if (isPropertyDeclaration(node)) addPrivateIdentifierPropertyDeclarationToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
            else if (isMethodDeclaration(node)) addPrivateIdentifierMethodDeclarationToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
            else if (isGetAccessorDeclaration(node)) addPrivateIdentifierGetAccessorDeclarationToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
            else if (isSetAccessorDeclaration(node)) addPrivateIdentifierSetAccessorDeclarationToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
        }
        function addPrivateIdentifierPropertyDeclarationToEnvironment(_node, name, lex, privateEnv, isStatic2, isValid, _previousInfo) {
            if (isStatic2) {
                const brandCheckIdentifier = Debug.checkDefined(lex.classThis ?? lex.classConstructor, "classConstructor should be set in private identifier environment");
                const variableName = createHoistedVariableForPrivateName(name);
                setPrivateIdentifier(privateEnv, name, {
                    kind: "f" /* Field */ ,
                    isStatic: true,
                    brandCheckIdentifier: brandCheckIdentifier,
                    variableName: variableName,
                    isValid: isValid
                });
            } else {
                const weakMapName = createHoistedVariableForPrivateName(name);
                setPrivateIdentifier(privateEnv, name, {
                    kind: "f" /* Field */ ,
                    isStatic: false,
                    brandCheckIdentifier: weakMapName,
                    isValid: isValid
                });
                getPendingExpressions().push(factory2.createAssignment(weakMapName, factory2.createNewExpression(factory2.createIdentifier("WeakMap"), /*typeArguments*/ void 0, [])));
            }
        }
        function addPrivateIdentifierMethodDeclarationToEnvironment(_node, name, lex, privateEnv, isStatic2, isValid, _previousInfo) {
            const methodName = createHoistedVariableForPrivateName(name);
            const brandCheckIdentifier = isStatic2 ? Debug.checkDefined(lex.classThis ?? lex.classConstructor, "classConstructor should be set in private identifier environment") : Debug.checkDefined(privateEnv.data.weakSetName, "weakSetName should be set in private identifier environment");
            setPrivateIdentifier(privateEnv, name, {
                kind: "m" /* Method */ ,
                methodName: methodName,
                brandCheckIdentifier: brandCheckIdentifier,
                isStatic: isStatic2,
                isValid: isValid
            });
        }
        function addPrivateIdentifierGetAccessorDeclarationToEnvironment(_node, name, lex, privateEnv, isStatic2, isValid, previousInfo) {
            const getterName = createHoistedVariableForPrivateName(name, "_get");
            const brandCheckIdentifier = isStatic2 ? Debug.checkDefined(lex.classThis ?? lex.classConstructor, "classConstructor should be set in private identifier environment") : Debug.checkDefined(privateEnv.data.weakSetName, "weakSetName should be set in private identifier environment");
            if ((previousInfo == null ? void 0 : previousInfo.kind) === "a" /* Accessor */  && previousInfo.isStatic === isStatic2 && !previousInfo.getterName) previousInfo.getterName = getterName;
            else setPrivateIdentifier(privateEnv, name, {
                kind: "a" /* Accessor */ ,
                getterName: getterName,
                setterName: void 0,
                brandCheckIdentifier: brandCheckIdentifier,
                isStatic: isStatic2,
                isValid: isValid
            });
        }
        function addPrivateIdentifierSetAccessorDeclarationToEnvironment(_node, name, lex, privateEnv, isStatic2, isValid, previousInfo) {
            const setterName = createHoistedVariableForPrivateName(name, "_set");
            const brandCheckIdentifier = isStatic2 ? Debug.checkDefined(lex.classThis ?? lex.classConstructor, "classConstructor should be set in private identifier environment") : Debug.checkDefined(privateEnv.data.weakSetName, "weakSetName should be set in private identifier environment");
            if ((previousInfo == null ? void 0 : previousInfo.kind) === "a" /* Accessor */  && previousInfo.isStatic === isStatic2 && !previousInfo.setterName) previousInfo.setterName = setterName;
            else setPrivateIdentifier(privateEnv, name, {
                kind: "a" /* Accessor */ ,
                getterName: void 0,
                setterName: setterName,
                brandCheckIdentifier: brandCheckIdentifier,
                isStatic: isStatic2,
                isValid: isValid
            });
        }
        function addPrivateIdentifierAutoAccessorPropertyDeclarationToEnvironment(_node, name, lex, privateEnv, isStatic2, isValid, _previousInfo) {
            const getterName = createHoistedVariableForPrivateName(name, "_get");
            const setterName = createHoistedVariableForPrivateName(name, "_set");
            const brandCheckIdentifier = isStatic2 ? Debug.checkDefined(lex.classThis ?? lex.classConstructor, "classConstructor should be set in private identifier environment") : Debug.checkDefined(privateEnv.data.weakSetName, "weakSetName should be set in private identifier environment");
            setPrivateIdentifier(privateEnv, name, {
                kind: "a" /* Accessor */ ,
                getterName: getterName,
                setterName: setterName,
                brandCheckIdentifier: brandCheckIdentifier,
                isStatic: isStatic2,
                isValid: isValid
            });
        }
        function addPrivateIdentifierToEnvironment(node, name, addDeclaration) {
            const lex = getClassLexicalEnvironment();
            const privateEnv = getPrivateIdentifierEnvironment();
            const previousInfo = getPrivateIdentifier(privateEnv, name);
            const isStatic2 = hasStaticModifier(node);
            const isValid = !isReservedPrivateName(name) && previousInfo === void 0;
            addDeclaration(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
        }
        function createHoistedVariableForClass(name, node, suffix) {
            const { className: className  } = getPrivateIdentifierEnvironment().data;
            const prefix = className ? {
                prefix: "_",
                node: className,
                suffix: "_"
            } : "_";
            const identifier = typeof name === "object" ? factory2.getGeneratedNameForNode(name, 24 /* ReservedInNestedScopes */ , prefix, suffix) : typeof name === "string" ? factory2.createUniqueName(name, 16 /* Optimistic */ , prefix, suffix) : factory2.createTempVariable(/*recordTempVariable*/ void 0, /*reservedInNestedScopes*/ true, prefix, suffix);
            if (resolver.getNodeCheckFlags(node) & 32768 /* BlockScopedBindingInLoop */ ) addBlockScopedVariable(identifier);
            else hoistVariableDeclaration(identifier);
            return identifier;
        }
        function createHoistedVariableForPrivateName(name, suffix) {
            const text = tryGetTextOfPropertyName(name);
            return createHoistedVariableForClass((text == null ? void 0 : text.substring(1)) ?? name, name, suffix);
        }
        function accessPrivateIdentifier2(name) {
            const info = accessPrivateIdentifier(lexicalEnvironment, name);
            return (info == null ? void 0 : info.kind) === "untransformed" ? void 0 : info;
        }
        function wrapPrivateIdentifierForDestructuringTarget(node) {
            const parameter = factory2.getGeneratedNameForNode(node);
            const info = accessPrivateIdentifier2(node.name);
            if (!info) return visitEachChild(node, visitor, context);
            let receiver = node.expression;
            if (isThisProperty(node) || isSuperProperty(node) || !isSimpleCopiableExpression(node.expression)) {
                receiver = factory2.createTempVariable(hoistVariableDeclaration, /*reservedInNestedScopes*/ true);
                getPendingExpressions().push(factory2.createBinaryExpression(receiver, 64 /* EqualsToken */ , visitNode(node.expression, visitor, isExpression)));
            }
            return factory2.createAssignmentTargetWrapper(parameter, createPrivateIdentifierAssignment(info, receiver, parameter, 64 /* EqualsToken */ ));
        }
        function visitDestructuringAssignmentTarget(node) {
            if (isObjectLiteralExpression(node) || isArrayLiteralExpression(node)) return visitAssignmentPattern(node);
            if (isPrivateIdentifierPropertyAccessExpression(node)) return wrapPrivateIdentifierForDestructuringTarget(node);
            else if (shouldTransformSuperInStaticInitializers && isSuperProperty(node) && currentStaticPropertyDeclarationOrStaticBlock && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                const { classConstructor: classConstructor , superClassReference: superClassReference , facts: facts  } = lexicalEnvironment.data;
                if (facts & 1 /* ClassWasDecorated */ ) return visitInvalidSuperProperty(node);
                else if (classConstructor && superClassReference) {
                    const name = isElementAccessExpression(node) ? visitNode(node.argumentExpression, visitor, isExpression) : isIdentifier(node.name) ? factory2.createStringLiteralFromNode(node.name) : void 0;
                    if (name) {
                        const temp = factory2.createTempVariable(/*recordTempVariable*/ void 0);
                        return factory2.createAssignmentTargetWrapper(temp, factory2.createReflectSetCall(superClassReference, name, temp, classConstructor));
                    }
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentElement(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const left = visitDestructuringAssignmentTarget(node.left);
                const assignedName = getAssignedNameOfIdentifier(node.left, node.right);
                const right = visitNode(node.right, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                return factory2.updateBinaryExpression(node, left, node.operatorToken, right);
            }
            if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) {
                const left = visitDestructuringAssignmentTarget(node.left);
                const right = visitNode(node.right, visitor, isExpression);
                return factory2.updateBinaryExpression(node, left, node.operatorToken, right);
            }
            return visitDestructuringAssignmentTarget(node);
        }
        function visitAssignmentRestElement(node) {
            if (isLeftHandSideExpression(node.expression)) {
                const expression = visitDestructuringAssignmentTarget(node.expression);
                return factory2.updateSpreadElement(node, expression);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitArrayAssignmentElement(node) {
            if (isArrayBindingOrAssignmentElement(node)) {
                if (isSpreadElement(node)) return visitAssignmentRestElement(node);
                if (!isOmittedExpression(node)) return visitAssignmentElement(node);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentProperty(node) {
            const name = visitNode(node.name, visitor, isPropertyName);
            if (isAssignmentExpression(node.initializer, /*excludeCompoundAssignment*/ true)) {
                const assignmentElement = visitAssignmentElement(node.initializer);
                return factory2.updatePropertyAssignment(node, name, assignmentElement);
            }
            if (isLeftHandSideExpression(node.initializer)) {
                const assignmentElement = visitDestructuringAssignmentTarget(node.initializer);
                return factory2.updatePropertyAssignment(node, name, assignmentElement);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitShorthandAssignmentProperty(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const assignedName = getAssignedNameOfIdentifier(node.name, node.objectAssignmentInitializer);
                const objectAssignmentInitializer = visitNode(node.objectAssignmentInitializer, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                return factory2.updateShorthandPropertyAssignment(node, node.name, objectAssignmentInitializer);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentRestProperty(node) {
            if (isLeftHandSideExpression(node.expression)) {
                const expression = visitDestructuringAssignmentTarget(node.expression);
                return factory2.updateSpreadAssignment(node, expression);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitObjectAssignmentElement(node) {
            Debug.assertNode(node, isObjectBindingOrAssignmentElement);
            if (isSpreadAssignment(node)) return visitAssignmentRestProperty(node);
            if (isShorthandPropertyAssignment(node)) return visitShorthandAssignmentProperty(node);
            if (isPropertyAssignment(node)) return visitAssignmentProperty(node);
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentPattern(node) {
            if (isArrayLiteralExpression(node)) return factory2.updateArrayLiteralExpression(node, visitNodes2(node.elements, visitArrayAssignmentElement, isExpression));
            else return factory2.updateObjectLiteralExpression(node, visitNodes2(node.properties, visitObjectAssignmentElement, isObjectLiteralElementLike));
        }
        function onEmitNode(hint, node, emitCallback) {
            const original = getOriginalNode(node);
            const lex = lexicalEnvironmentMap.get(original);
            if (lex) {
                const savedLexicalEnvironment = lexicalEnvironment;
                const savedPreviousShouldSubstituteThisWithClassThis = previousShouldSubstituteThisWithClassThis;
                lexicalEnvironment = lex;
                previousShouldSubstituteThisWithClassThis = shouldSubstituteThisWithClassThis;
                shouldSubstituteThisWithClassThis = !isClassStaticBlockDeclaration(original) || !(getInternalEmitFlags(original) & 32 /* TransformPrivateStaticElements */ );
                previousOnEmitNode(hint, node, emitCallback);
                shouldSubstituteThisWithClassThis = previousShouldSubstituteThisWithClassThis;
                previousShouldSubstituteThisWithClassThis = savedPreviousShouldSubstituteThisWithClassThis;
                lexicalEnvironment = savedLexicalEnvironment;
                return;
            }
            switch(node.kind){
                case 217 /* FunctionExpression */ :
                    if (isArrowFunction(original) || getEmitFlags(node) & 524288 /* AsyncFunctionBody */ ) break;
                case 261 /* FunctionDeclaration */ :
                case 175 /* Constructor */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                case 173 /* MethodDeclaration */ :
                case 171 /* PropertyDeclaration */ :
                    {
                        const savedLexicalEnvironment = lexicalEnvironment;
                        const savedPreviousShouldSubstituteThisWithClassThis = previousShouldSubstituteThisWithClassThis;
                        lexicalEnvironment = void 0;
                        previousShouldSubstituteThisWithClassThis = shouldSubstituteThisWithClassThis;
                        shouldSubstituteThisWithClassThis = false;
                        previousOnEmitNode(hint, node, emitCallback);
                        shouldSubstituteThisWithClassThis = previousShouldSubstituteThisWithClassThis;
                        previousShouldSubstituteThisWithClassThis = savedPreviousShouldSubstituteThisWithClassThis;
                        lexicalEnvironment = savedLexicalEnvironment;
                        return;
                    }
                case 166 /* ComputedPropertyName */ :
                    {
                        const savedLexicalEnvironment = lexicalEnvironment;
                        const savedShouldSubstituteThisWithClassThis = shouldSubstituteThisWithClassThis;
                        lexicalEnvironment = lexicalEnvironment == null ? void 0 : lexicalEnvironment.previous;
                        shouldSubstituteThisWithClassThis = previousShouldSubstituteThisWithClassThis;
                        previousOnEmitNode(hint, node, emitCallback);
                        shouldSubstituteThisWithClassThis = savedShouldSubstituteThisWithClassThis;
                        lexicalEnvironment = savedLexicalEnvironment;
                        return;
                    }
            }
            previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
                case 110 /* ThisKeyword */ :
                    return substituteThisExpression(node);
            }
            return node;
        }
        function substituteThisExpression(node) {
            if (enabledSubstitutions & 2 /* ClassStaticThisOrSuperReference */  && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                const { facts: facts , classConstructor: classConstructor , classThis: classThis  } = lexicalEnvironment.data;
                if (facts & 1 /* ClassWasDecorated */  && legacyDecorators) return factory2.createParenthesizedExpression(factory2.createVoidZero());
                const substituteThis = shouldSubstituteThisWithClassThis ? classThis ?? classConstructor : classConstructor;
                if (substituteThis) return setTextRange(setOriginalNode(factory2.cloneNode(substituteThis), node), node);
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            return trySubstituteClassAlias(node) || node;
        }
        function trySubstituteClassAlias(node) {
            if (enabledSubstitutions & 1 /* ClassAliases */ ) {
                if (resolver.getNodeCheckFlags(node) & 2097152 /* ConstructorReferenceInClass */ ) {
                    const declaration = resolver.getReferencedValueDeclaration(node);
                    if (declaration) {
                        const classAlias = classAliases[declaration.id];
                        if (classAlias) {
                            const clone2 = factory2.cloneNode(classAlias);
                            setSourceMapRange(clone2, node);
                            setCommentRange(clone2, node);
                            return clone2;
                        }
                    }
                }
            }
            return void 0;
        }
    }
    function createPrivateStaticFieldInitializer(factory2, variableName, initializer) {
        return factory2.createAssignment(variableName, factory2.createObjectLiteralExpression([
            factory2.createPropertyAssignment("value", initializer || factory2.createVoidZero())
        ]));
    }
    function createPrivateInstanceFieldInitializer(factory2, receiver, initializer, weakMapName) {
        return factory2.createCallExpression(factory2.createPropertyAccessExpression(weakMapName, "set"), /*typeArguments*/ void 0, [
            receiver,
            initializer || factory2.createVoidZero()
        ]);
    }
    function createPrivateInstanceMethodInitializer(factory2, receiver, weakSetName) {
        return factory2.createCallExpression(factory2.createPropertyAccessExpression(weakSetName, "add"), /*typeArguments*/ void 0, [
            receiver
        ]);
    }
    function isReservedPrivateName(node) {
        return !isGeneratedPrivateIdentifier(node) && node.escapedText === "#constructor";
    }
    function isPrivateIdentifierInExpression(node) {
        return isPrivateIdentifier(node.left) && node.operatorToken.kind === 103 /* InKeyword */ ;
    }
    var init_classFields = __esm({
        "src/compiler/transformers/classFields.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/typeSerializer.ts
    function createRuntimeTypeSerializer(context) {
        const { factory: factory2 , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const strictNullChecks = getStrictOptionValue(compilerOptions, "strictNullChecks");
        let currentLexicalScope;
        let currentNameScope;
        return {
            serializeTypeNode: (serializerContext, node)=>setSerializerContextAnd(serializerContext, serializeTypeNode, node),
            serializeTypeOfNode: (serializerContext, node)=>setSerializerContextAnd(serializerContext, serializeTypeOfNode, node),
            serializeParameterTypesOfNode: (serializerContext, node, container)=>setSerializerContextAnd(serializerContext, serializeParameterTypesOfNode, node, container),
            serializeReturnTypeOfNode: (serializerContext, node)=>setSerializerContextAnd(serializerContext, serializeReturnTypeOfNode, node)
        };
        function setSerializerContextAnd(serializerContext, cb, node, arg) {
            const savedCurrentLexicalScope = currentLexicalScope;
            const savedCurrentNameScope = currentNameScope;
            currentLexicalScope = serializerContext.currentLexicalScope;
            currentNameScope = serializerContext.currentNameScope;
            const result = arg === void 0 ? cb(node) : cb(node, arg);
            currentLexicalScope = savedCurrentLexicalScope;
            currentNameScope = savedCurrentNameScope;
            return result;
        }
        function getAccessorTypeNode(node) {
            const accessors = resolver.getAllAccessorDeclarations(node);
            return accessors.setAccessor && getSetAccessorTypeAnnotationNode(accessors.setAccessor) || accessors.getAccessor && getEffectiveReturnTypeNode(accessors.getAccessor);
        }
        function serializeTypeOfNode(node) {
            switch(node.kind){
                case 171 /* PropertyDeclaration */ :
                case 168 /* Parameter */ :
                    return serializeTypeNode(node.type);
                case 177 /* SetAccessor */ :
                case 176 /* GetAccessor */ :
                    return serializeTypeNode(getAccessorTypeNode(node));
                case 262 /* ClassDeclaration */ :
                case 230 /* ClassExpression */ :
                case 173 /* MethodDeclaration */ :
                    return factory2.createIdentifier("Function");
                default:
                    return factory2.createVoidZero();
            }
        }
        function serializeParameterTypesOfNode(node, container) {
            const valueDeclaration = isClassLike(node) ? getFirstConstructorWithBody(node) : isFunctionLike(node) && nodeIsPresent(node.body) ? node : void 0;
            const expressions = [];
            if (valueDeclaration) {
                const parameters = getParametersOfDecoratedDeclaration(valueDeclaration, container);
                const numParameters = parameters.length;
                for(let i = 0; i < numParameters; i++){
                    const parameter = parameters[i];
                    if (i === 0 && isIdentifier(parameter.name) && parameter.name.escapedText === "this") continue;
                    if (parameter.dotDotDotToken) expressions.push(serializeTypeNode(getRestParameterElementType(parameter.type)));
                    else expressions.push(serializeTypeOfNode(parameter));
                }
            }
            return factory2.createArrayLiteralExpression(expressions);
        }
        function getParametersOfDecoratedDeclaration(node, container) {
            if (container && node.kind === 176 /* GetAccessor */ ) {
                const { setAccessor: setAccessor  } = getAllAccessorDeclarations(container.members, node);
                if (setAccessor) return setAccessor.parameters;
            }
            return node.parameters;
        }
        function serializeReturnTypeOfNode(node) {
            if (isFunctionLike(node) && node.type) return serializeTypeNode(node.type);
            else if (isAsyncFunction(node)) return factory2.createIdentifier("Promise");
            return factory2.createVoidZero();
        }
        function serializeTypeNode(node) {
            if (node === void 0) return factory2.createIdentifier("Object");
            node = skipTypeParentheses(node);
            switch(node.kind){
                case 116 /* VoidKeyword */ :
                case 157 /* UndefinedKeyword */ :
                case 146 /* NeverKeyword */ :
                    return factory2.createVoidZero();
                case 183 /* FunctionType */ :
                case 184 /* ConstructorType */ :
                    return factory2.createIdentifier("Function");
                case 187 /* ArrayType */ :
                case 188 /* TupleType */ :
                    return factory2.createIdentifier("Array");
                case 181 /* TypePredicate */ :
                    return node.assertsModifier ? factory2.createVoidZero() : factory2.createIdentifier("Boolean");
                case 136 /* BooleanKeyword */ :
                    return factory2.createIdentifier("Boolean");
                case 202 /* TemplateLiteralType */ :
                case 154 /* StringKeyword */ :
                    return factory2.createIdentifier("String");
                case 151 /* ObjectKeyword */ :
                    return factory2.createIdentifier("Object");
                case 200 /* LiteralType */ :
                    return serializeLiteralOfLiteralTypeNode(node.literal);
                case 150 /* NumberKeyword */ :
                    return factory2.createIdentifier("Number");
                case 162 /* BigIntKeyword */ :
                    return getGlobalConstructor("BigInt", 7 /* ES2020 */ );
                case 155 /* SymbolKeyword */ :
                    return getGlobalConstructor("Symbol", 2 /* ES2015 */ );
                case 182 /* TypeReference */ :
                    return serializeTypeReferenceNode(node);
                case 192 /* IntersectionType */ :
                    return serializeUnionOrIntersectionConstituents(node.types, /*isIntersection*/ true);
                case 191 /* UnionType */ :
                    return serializeUnionOrIntersectionConstituents(node.types, /*isIntersection*/ false);
                case 193 /* ConditionalType */ :
                    return serializeUnionOrIntersectionConstituents([
                        node.trueType,
                        node.falseType
                    ], /*isIntersection*/ false);
                case 197 /* TypeOperator */ :
                    if (node.operator === 148 /* ReadonlyKeyword */ ) return serializeTypeNode(node.type);
                    break;
                case 185 /* TypeQuery */ :
                case 198 /* IndexedAccessType */ :
                case 199 /* MappedType */ :
                case 186 /* TypeLiteral */ :
                case 133 /* AnyKeyword */ :
                case 159 /* UnknownKeyword */ :
                case 196 /* ThisType */ :
                case 204 /* ImportType */ :
                    break;
                case 318 /* JSDocAllType */ :
                case 319 /* JSDocUnknownType */ :
                case 323 /* JSDocFunctionType */ :
                case 324 /* JSDocVariadicType */ :
                case 325 /* JSDocNamepathType */ :
                    break;
                case 320 /* JSDocNullableType */ :
                case 321 /* JSDocNonNullableType */ :
                case 322 /* JSDocOptionalType */ :
                    return serializeTypeNode(node.type);
                default:
                    return Debug.failBadSyntaxKind(node);
            }
            return factory2.createIdentifier("Object");
        }
        function serializeLiteralOfLiteralTypeNode(node) {
            switch(node.kind){
                case 11 /* StringLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    return factory2.createIdentifier("String");
                case 223 /* PrefixUnaryExpression */ :
                    {
                        const operand = node.operand;
                        switch(operand.kind){
                            case 9 /* NumericLiteral */ :
                            case 10 /* BigIntLiteral */ :
                                return serializeLiteralOfLiteralTypeNode(operand);
                            default:
                                return Debug.failBadSyntaxKind(operand);
                        }
                    }
                case 9 /* NumericLiteral */ :
                    return factory2.createIdentifier("Number");
                case 10 /* BigIntLiteral */ :
                    return getGlobalConstructor("BigInt", 7 /* ES2020 */ );
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                    return factory2.createIdentifier("Boolean");
                case 106 /* NullKeyword */ :
                    return factory2.createVoidZero();
                default:
                    return Debug.failBadSyntaxKind(node);
            }
        }
        function serializeUnionOrIntersectionConstituents(types, isIntersection) {
            let serializedType;
            for (let typeNode of types){
                typeNode = skipTypeParentheses(typeNode);
                if (typeNode.kind === 146 /* NeverKeyword */ ) {
                    if (isIntersection) return factory2.createVoidZero();
                    continue;
                }
                if (typeNode.kind === 159 /* UnknownKeyword */ ) {
                    if (!isIntersection) return factory2.createIdentifier("Object");
                    continue;
                }
                if (typeNode.kind === 133 /* AnyKeyword */ ) return factory2.createIdentifier("Object");
                if (!strictNullChecks && (isLiteralTypeNode(typeNode) && typeNode.literal.kind === 106 /* NullKeyword */  || typeNode.kind === 157 /* UndefinedKeyword */ )) continue;
                const serializedConstituent = serializeTypeNode(typeNode);
                if (isIdentifier(serializedConstituent) && serializedConstituent.escapedText === "Object") return serializedConstituent;
                if (serializedType) {
                    if (!equateSerializedTypeNodes(serializedType, serializedConstituent)) return factory2.createIdentifier("Object");
                } else serializedType = serializedConstituent;
            }
            return serializedType ?? factory2.createVoidZero();
        }
        function equateSerializedTypeNodes(left, right) {
            return(// temp vars used in fallback
            isGeneratedIdentifier(left) ? isGeneratedIdentifier(right) : // entity names
            isIdentifier(left) ? isIdentifier(right) && left.escapedText === right.escapedText : isPropertyAccessExpression(left) ? isPropertyAccessExpression(right) && equateSerializedTypeNodes(left.expression, right.expression) && equateSerializedTypeNodes(left.name, right.name) : // `void 0`
            isVoidExpression(left) ? isVoidExpression(right) && isNumericLiteral(left.expression) && left.expression.text === "0" && isNumericLiteral(right.expression) && right.expression.text === "0" : // `"undefined"` or `"function"` in `typeof` checks
            isStringLiteral(left) ? isStringLiteral(right) && left.text === right.text : // used in `typeof` checks for fallback
            isTypeOfExpression(left) ? isTypeOfExpression(right) && equateSerializedTypeNodes(left.expression, right.expression) : // parens in `typeof` checks with temps
            isParenthesizedExpression(left) ? isParenthesizedExpression(right) && equateSerializedTypeNodes(left.expression, right.expression) : // conditionals used in fallback
            isConditionalExpression(left) ? isConditionalExpression(right) && equateSerializedTypeNodes(left.condition, right.condition) && equateSerializedTypeNodes(left.whenTrue, right.whenTrue) && equateSerializedTypeNodes(left.whenFalse, right.whenFalse) : // logical binary and assignments used in fallback
            isBinaryExpression(left) ? isBinaryExpression(right) && left.operatorToken.kind === right.operatorToken.kind && equateSerializedTypeNodes(left.left, right.left) && equateSerializedTypeNodes(left.right, right.right) : false);
        }
        function serializeTypeReferenceNode(node) {
            const kind = resolver.getTypeReferenceSerializationKind(node.typeName, currentNameScope ?? currentLexicalScope);
            switch(kind){
                case 0 /* Unknown */ :
                    if (findAncestor(node, (n)=>n.parent && isConditionalTypeNode(n.parent) && (n.parent.trueType === n || n.parent.falseType === n))) return factory2.createIdentifier("Object");
                    const serialized = serializeEntityNameAsExpressionFallback(node.typeName);
                    const temp = factory2.createTempVariable(hoistVariableDeclaration);
                    return factory2.createConditionalExpression(factory2.createTypeCheck(factory2.createAssignment(temp, serialized), "function"), /*questionToken*/ void 0, temp, /*colonToken*/ void 0, factory2.createIdentifier("Object"));
                case 1 /* TypeWithConstructSignatureAndValue */ :
                    return serializeEntityNameAsExpression(node.typeName);
                case 2 /* VoidNullableOrNeverType */ :
                    return factory2.createVoidZero();
                case 4 /* BigIntLikeType */ :
                    return getGlobalConstructor("BigInt", 7 /* ES2020 */ );
                case 6 /* BooleanType */ :
                    return factory2.createIdentifier("Boolean");
                case 3 /* NumberLikeType */ :
                    return factory2.createIdentifier("Number");
                case 5 /* StringLikeType */ :
                    return factory2.createIdentifier("String");
                case 7 /* ArrayLikeType */ :
                    return factory2.createIdentifier("Array");
                case 8 /* ESSymbolType */ :
                    return getGlobalConstructor("Symbol", 2 /* ES2015 */ );
                case 10 /* TypeWithCallSignature */ :
                    return factory2.createIdentifier("Function");
                case 9 /* Promise */ :
                    return factory2.createIdentifier("Promise");
                case 11 /* ObjectType */ :
                    return factory2.createIdentifier("Object");
                default:
                    return Debug.assertNever(kind);
            }
        }
        function createCheckedValue(left, right) {
            return factory2.createLogicalAnd(factory2.createStrictInequality(factory2.createTypeOfExpression(left), factory2.createStringLiteral("undefined")), right);
        }
        function serializeEntityNameAsExpressionFallback(node) {
            if (node.kind === 80 /* Identifier */ ) {
                const copied = serializeEntityNameAsExpression(node);
                return createCheckedValue(copied, copied);
            }
            if (node.left.kind === 80 /* Identifier */ ) return createCheckedValue(serializeEntityNameAsExpression(node.left), serializeEntityNameAsExpression(node));
            const left = serializeEntityNameAsExpressionFallback(node.left);
            const temp = factory2.createTempVariable(hoistVariableDeclaration);
            return factory2.createLogicalAnd(factory2.createLogicalAnd(left.left, factory2.createStrictInequality(factory2.createAssignment(temp, left.right), factory2.createVoidZero())), factory2.createPropertyAccessExpression(temp, node.right));
        }
        function serializeEntityNameAsExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    const name = setParent(setTextRange(parseNodeFactory.cloneNode(node), node), node.parent);
                    name.original = void 0;
                    setParent(name, getParseTreeNode(currentLexicalScope));
                    return name;
                case 165 /* QualifiedName */ :
                    return serializeQualifiedNameAsExpression(node);
            }
        }
        function serializeQualifiedNameAsExpression(node) {
            return factory2.createPropertyAccessExpression(serializeEntityNameAsExpression(node.left), node.right);
        }
        function getGlobalConstructorWithFallback(name) {
            return factory2.createConditionalExpression(factory2.createTypeCheck(factory2.createIdentifier(name), "function"), /*questionToken*/ void 0, factory2.createIdentifier(name), /*colonToken*/ void 0, factory2.createIdentifier("Object"));
        }
        function getGlobalConstructor(name, minLanguageVersion) {
            return languageVersion < minLanguageVersion ? getGlobalConstructorWithFallback(name) : factory2.createIdentifier(name);
        }
    }
    var init_typeSerializer = __esm({
        "src/compiler/transformers/typeSerializer.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/legacyDecorators.ts
    function transformLegacyDecorators(context) {
        const { factory: factory2 , getEmitHelperFactory: emitHelpers , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onSubstituteNode = onSubstituteNode;
        let classAliases;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            const visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            return visited;
        }
        function modifierVisitor(node) {
            return isDecorator(node) ? void 0 : node;
        }
        function visitor(node) {
            if (!(node.transformFlags & 33554432 /* ContainsDecorators */ )) return node;
            switch(node.kind){
                case 169 /* Decorator */ :
                    return void 0;
                case 262 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 230 /* ClassExpression */ :
                    return visitClassExpression(node);
                case 175 /* Constructor */ :
                    return visitConstructorDeclaration(node);
                case 173 /* MethodDeclaration */ :
                    return visitMethodDeclaration(node);
                case 177 /* SetAccessor */ :
                    return visitSetAccessorDeclaration(node);
                case 176 /* GetAccessor */ :
                    return visitGetAccessorDeclaration(node);
                case 171 /* PropertyDeclaration */ :
                    return visitPropertyDeclaration(node);
                case 168 /* Parameter */ :
                    return visitParameterDeclaration(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitClassDeclaration(node) {
            if (!(classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ true, node) || childIsDecorated(/*useLegacyDecorators*/ true, node))) return visitEachChild(node, visitor, context);
            const statements = classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ true, node) ? transformClassDeclarationWithClassDecorators(node, node.name) : transformClassDeclarationWithoutClassDecorators(node, node.name);
            return singleOrMany(statements);
        }
        function decoratorContainsPrivateIdentifierInExpression(decorator) {
            return !!(decorator.transformFlags & 536870912 /* ContainsPrivateIdentifierInExpression */ );
        }
        function parameterDecoratorsContainPrivateIdentifierInExpression(parameterDecorators) {
            return some(parameterDecorators, decoratorContainsPrivateIdentifierInExpression);
        }
        function hasClassElementWithDecoratorContainingPrivateIdentifierInExpression(node) {
            for (const member of node.members){
                if (!canHaveDecorators(member)) continue;
                const allDecorators = getAllDecoratorsOfClassElement(member, node, /*useLegacyDecorators*/ true);
                if (some(allDecorators == null ? void 0 : allDecorators.decorators, decoratorContainsPrivateIdentifierInExpression)) return true;
                if (some(allDecorators == null ? void 0 : allDecorators.parameters, parameterDecoratorsContainPrivateIdentifierInExpression)) return true;
            }
            return false;
        }
        function transformDecoratorsOfClassElements(node, members) {
            let decorationStatements = [];
            addClassElementDecorationStatements(decorationStatements, node, /*isStatic*/ false);
            addClassElementDecorationStatements(decorationStatements, node, /*isStatic*/ true);
            if (hasClassElementWithDecoratorContainingPrivateIdentifierInExpression(node)) {
                members = setTextRange(factory2.createNodeArray([
                    ...members,
                    factory2.createClassStaticBlockDeclaration(factory2.createBlock(decorationStatements, /*multiLine*/ true))
                ]), members);
                decorationStatements = void 0;
            }
            return {
                decorationStatements: decorationStatements,
                members: members
            };
        }
        function transformClassDeclarationWithoutClassDecorators(node, name) {
            const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
            const heritageClauses = visitNodes2(node.heritageClauses, visitor, isHeritageClause);
            let members = visitNodes2(node.members, visitor, isClassElement);
            let decorationStatements = [];
            ({ members: members , decorationStatements: decorationStatements  } = transformDecoratorsOfClassElements(node, members));
            const updated = factory2.updateClassDeclaration(node, modifiers, name, /*typeParameters*/ void 0, heritageClauses, members);
            return addRange([
                updated
            ], decorationStatements);
        }
        function transformClassDeclarationWithClassDecorators(node, name) {
            const isExport = hasSyntacticModifier(node, 1 /* Export */ );
            const isDefault = hasSyntacticModifier(node, 1024 /* Default */ );
            const modifiers = visitNodes2(node.modifiers, (node2)=>isExportOrDefaultModifier(node2) || isDecorator(node2) ? void 0 : node2, isModifierLike);
            const location = moveRangePastModifiers(node);
            const classAlias = getClassAliasIfNeeded(node);
            const declName = languageVersion < 2 /* ES2015 */  ? factory2.getInternalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true) : factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
            const heritageClauses = visitNodes2(node.heritageClauses, visitor, isHeritageClause);
            let members = visitNodes2(node.members, visitor, isClassElement);
            let decorationStatements = [];
            ({ members: members , decorationStatements: decorationStatements  } = transformDecoratorsOfClassElements(node, members));
            const assignClassAliasInStaticBlock = languageVersion >= 9 /* ES2022 */  && !!classAlias && some(members, (member)=>isPropertyDeclaration(member) && hasSyntacticModifier(member, 32 /* Static */ ) || isClassStaticBlockDeclaration(member));
            if (assignClassAliasInStaticBlock) members = setTextRange(factory2.createNodeArray([
                factory2.createClassStaticBlockDeclaration(factory2.createBlock([
                    factory2.createExpressionStatement(factory2.createAssignment(classAlias, factory2.createThis()))
                ])),
                ...members
            ]), members);
            const classExpression = factory2.createClassExpression(modifiers, name && isGeneratedIdentifier(name) ? void 0 : name, /*typeParameters*/ void 0, heritageClauses, members);
            setOriginalNode(classExpression, node);
            setTextRange(classExpression, location);
            const varDecl = factory2.createVariableDeclaration(declName, /*exclamationToken*/ void 0, /*type*/ void 0, classAlias && !assignClassAliasInStaticBlock ? factory2.createAssignment(classAlias, classExpression) : classExpression);
            setOriginalNode(varDecl, node);
            let varModifiers;
            if (isExport && !isDefault) varModifiers = factory2.createModifiersFromModifierFlags(1 /* Export */ );
            const statement = factory2.createVariableStatement(varModifiers, factory2.createVariableDeclarationList([
                varDecl
            ], 1 /* Let */ ));
            setOriginalNode(statement, node);
            setTextRange(statement, location);
            setCommentRange(statement, node);
            const statements = [
                statement
            ];
            addRange(statements, decorationStatements);
            addConstructorDecorationStatement(statements, node);
            if (isExport && isDefault) statements.push(factory2.createExportAssignment(/*modifiers*/ void 0, /*isExportEquals*/ false, declName));
            return statements;
        }
        function visitClassExpression(node) {
            return factory2.updateClassExpression(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), node.name, /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), visitNodes2(node.members, visitor, isClassElement));
        }
        function visitConstructorDeclaration(node) {
            return factory2.updateConstructorDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), visitNodes2(node.parameters, visitor, isParameter), visitNode(node.body, visitor, isBlock));
        }
        function finishClassElement(updated, original) {
            if (updated !== original) {
                setCommentRange(updated, original);
                setSourceMapRange(updated, moveRangePastModifiers(original));
            }
            return updated;
        }
        function visitMethodDeclaration(node) {
            return finishClassElement(factory2.updateMethodDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), node.asteriskToken, Debug.checkDefined(visitNode(node.name, visitor, isPropertyName)), /*questionToken*/ void 0, /*typeParameters*/ void 0, visitNodes2(node.parameters, visitor, isParameter), /*type*/ void 0, visitNode(node.body, visitor, isBlock)), node);
        }
        function visitGetAccessorDeclaration(node) {
            return finishClassElement(factory2.updateGetAccessorDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), Debug.checkDefined(visitNode(node.name, visitor, isPropertyName)), visitNodes2(node.parameters, visitor, isParameter), /*type*/ void 0, visitNode(node.body, visitor, isBlock)), node);
        }
        function visitSetAccessorDeclaration(node) {
            return finishClassElement(factory2.updateSetAccessorDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), Debug.checkDefined(visitNode(node.name, visitor, isPropertyName)), visitNodes2(node.parameters, visitor, isParameter), visitNode(node.body, visitor, isBlock)), node);
        }
        function visitPropertyDeclaration(node) {
            if (node.flags & 16777216 /* Ambient */  || hasSyntacticModifier(node, 2 /* Ambient */ )) return void 0;
            return finishClassElement(factory2.updatePropertyDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), Debug.checkDefined(visitNode(node.name, visitor, isPropertyName)), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression)), node);
        }
        function visitParameterDeclaration(node) {
            const updated = factory2.updateParameterDeclaration(node, elideNodes(factory2, node.modifiers), node.dotDotDotToken, Debug.checkDefined(visitNode(node.name, visitor, isBindingName)), /*questionToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
            if (updated !== node) {
                setCommentRange(updated, node);
                setTextRange(updated, moveRangePastModifiers(node));
                setSourceMapRange(updated, moveRangePastModifiers(node));
                setEmitFlags(updated.name, 64 /* NoTrailingSourceMap */ );
            }
            return updated;
        }
        function isSyntheticMetadataDecorator(node) {
            return isCallToHelper(node.expression, "___metadata");
        }
        function transformAllDecoratorsOfDeclaration(allDecorators) {
            if (!allDecorators) return void 0;
            const { false: decorators , true: metadata  } = groupBy(allDecorators.decorators, isSyntheticMetadataDecorator);
            const decoratorExpressions = [];
            addRange(decoratorExpressions, map(decorators, transformDecorator));
            addRange(decoratorExpressions, flatMap(allDecorators.parameters, transformDecoratorsOfParameter));
            addRange(decoratorExpressions, map(metadata, transformDecorator));
            return decoratorExpressions;
        }
        function addClassElementDecorationStatements(statements, node, isStatic2) {
            addRange(statements, map(generateClassElementDecorationExpressions(node, isStatic2), (expr)=>factory2.createExpressionStatement(expr)));
        }
        function isDecoratedClassElement(member, isStaticElement, parent2) {
            return nodeOrChildIsDecorated(/*useLegacyDecorators*/ true, member, parent2) && isStaticElement === isStatic(member);
        }
        function getDecoratedClassElements(node, isStatic2) {
            return filter(node.members, (m)=>isDecoratedClassElement(m, isStatic2, node));
        }
        function generateClassElementDecorationExpressions(node, isStatic2) {
            const members = getDecoratedClassElements(node, isStatic2);
            let expressions;
            for (const member of members)expressions = append(expressions, generateClassElementDecorationExpression(node, member));
            return expressions;
        }
        function generateClassElementDecorationExpression(node, member) {
            const allDecorators = getAllDecoratorsOfClassElement(member, node, /*useLegacyDecorators*/ true);
            const decoratorExpressions = transformAllDecoratorsOfDeclaration(allDecorators);
            if (!decoratorExpressions) return void 0;
            const prefix = getClassMemberPrefix(node, member);
            const memberName = getExpressionForPropertyName(member, /*generateNameForComputedPropertyName*/ !hasSyntacticModifier(member, 2 /* Ambient */ ));
            const descriptor = languageVersion > 0 /* ES3 */  ? isPropertyDeclaration(member) && !hasAccessorModifier(member) ? factory2.createVoidZero() : factory2.createNull() : void 0;
            const helper = emitHelpers().createDecorateHelper(decoratorExpressions, prefix, memberName, descriptor);
            setEmitFlags(helper, 3072 /* NoComments */ );
            setSourceMapRange(helper, moveRangePastModifiers(member));
            return helper;
        }
        function addConstructorDecorationStatement(statements, node) {
            const expression = generateConstructorDecorationExpression(node);
            if (expression) statements.push(setOriginalNode(factory2.createExpressionStatement(expression), node));
        }
        function generateConstructorDecorationExpression(node) {
            const allDecorators = getAllDecoratorsOfClass(node);
            const decoratorExpressions = transformAllDecoratorsOfDeclaration(allDecorators);
            if (!decoratorExpressions) return void 0;
            const classAlias = classAliases && classAliases[getOriginalNodeId(node)];
            const localName = languageVersion < 2 /* ES2015 */  ? factory2.getInternalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true) : factory2.getDeclarationName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
            const decorate = emitHelpers().createDecorateHelper(decoratorExpressions, localName);
            const expression = factory2.createAssignment(localName, classAlias ? factory2.createAssignment(classAlias, decorate) : decorate);
            setEmitFlags(expression, 3072 /* NoComments */ );
            setSourceMapRange(expression, moveRangePastModifiers(node));
            return expression;
        }
        function transformDecorator(decorator) {
            return Debug.checkDefined(visitNode(decorator.expression, visitor, isExpression));
        }
        function transformDecoratorsOfParameter(decorators, parameterOffset) {
            let expressions;
            if (decorators) {
                expressions = [];
                for (const decorator of decorators){
                    const helper = emitHelpers().createParamHelper(transformDecorator(decorator), parameterOffset);
                    setTextRange(helper, decorator.expression);
                    setEmitFlags(helper, 3072 /* NoComments */ );
                    expressions.push(helper);
                }
            }
            return expressions;
        }
        function getExpressionForPropertyName(member, generateNameForComputedPropertyName) {
            const name = member.name;
            if (isPrivateIdentifier(name)) return factory2.createIdentifier("");
            else if (isComputedPropertyName(name)) return generateNameForComputedPropertyName && !isSimpleInlineableExpression(name.expression) ? factory2.getGeneratedNameForNode(name) : name.expression;
            else if (isIdentifier(name)) return factory2.createStringLiteral(idText(name));
            else return factory2.cloneNode(name);
        }
        function enableSubstitutionForClassAliases() {
            if (!classAliases) {
                context.enableSubstitution(80 /* Identifier */ );
                classAliases = [];
            }
        }
        function getClassAliasIfNeeded(node) {
            if (resolver.getNodeCheckFlags(node) & 1048576 /* ClassWithConstructorReference */ ) {
                enableSubstitutionForClassAliases();
                const classAlias = factory2.createUniqueName(node.name && !isGeneratedIdentifier(node.name) ? idText(node.name) : "default");
                classAliases[getOriginalNodeId(node)] = classAlias;
                hoistVariableDeclaration(classAlias);
                return classAlias;
            }
        }
        function getClassPrototype(node) {
            return factory2.createPropertyAccessExpression(factory2.getDeclarationName(node), "prototype");
        }
        function getClassMemberPrefix(node, member) {
            return isStatic(member) ? factory2.getDeclarationName(node) : getClassPrototype(node);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            return trySubstituteClassAlias(node) ?? node;
        }
        function trySubstituteClassAlias(node) {
            if (classAliases) {
                if (resolver.getNodeCheckFlags(node) & 2097152 /* ConstructorReferenceInClass */ ) {
                    const declaration = resolver.getReferencedValueDeclaration(node);
                    if (declaration) {
                        const classAlias = classAliases[declaration.id];
                        if (classAlias) {
                            const clone2 = factory2.cloneNode(classAlias);
                            setSourceMapRange(clone2, node);
                            setCommentRange(clone2, node);
                            return clone2;
                        }
                    }
                }
            }
            return void 0;
        }
    }
    var init_legacyDecorators = __esm({
        "src/compiler/transformers/legacyDecorators.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/esDecorators.ts
    function transformESDecorators(context) {
        const { factory: factory2 , getEmitHelperFactory: emitHelpers , startLexicalEnvironment: startLexicalEnvironment , endLexicalEnvironment: endLexicalEnvironment , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        let top;
        let classInfo;
        let classThis;
        let classSuper;
        let pendingExpressions;
        let shouldTransformPrivateStaticElementsInFile;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            top = void 0;
            shouldTransformPrivateStaticElementsInFile = false;
            const visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            if (shouldTransformPrivateStaticElementsInFile) {
                addInternalEmitFlags(visited, 32 /* TransformPrivateStaticElements */ );
                shouldTransformPrivateStaticElementsInFile = false;
            }
            return visited;
        }
        function updateState() {
            classInfo = void 0;
            classThis = void 0;
            classSuper = void 0;
            switch(top == null ? void 0 : top.kind){
                case "class":
                    classInfo = top.classInfo;
                    break;
                case "class-element":
                    classInfo = top.next.classInfo;
                    classThis = top.classThis;
                    classSuper = top.classSuper;
                    break;
                case "name":
                    const grandparent = top.next.next.next;
                    if ((grandparent == null ? void 0 : grandparent.kind) === "class-element") {
                        classInfo = grandparent.next.classInfo;
                        classThis = grandparent.classThis;
                        classSuper = grandparent.classSuper;
                    }
                    break;
            }
        }
        function enterClass(classInfo2) {
            top = {
                kind: "class",
                next: top,
                classInfo: classInfo2,
                savedPendingExpressions: pendingExpressions
            };
            pendingExpressions = void 0;
            updateState();
        }
        function exitClass() {
            Debug.assert((top == null ? void 0 : top.kind) === "class", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'class' but got '${top == null ? void 0 : top.kind}' instead.`);
            pendingExpressions = top.savedPendingExpressions;
            top = top.next;
            updateState();
        }
        function enterClassElement(node) {
            var _a, _b;
            Debug.assert((top == null ? void 0 : top.kind) === "class", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'class' but got '${top == null ? void 0 : top.kind}' instead.`);
            top = {
                kind: "class-element",
                next: top
            };
            if (isClassStaticBlockDeclaration(node) || isPropertyDeclaration(node) && hasStaticModifier(node)) {
                top.classThis = (_a = top.next.classInfo) == null ? void 0 : _a.classThis;
                top.classSuper = (_b = top.next.classInfo) == null ? void 0 : _b.classSuper;
            }
            updateState();
        }
        function exitClassElement() {
            var _a;
            Debug.assert((top == null ? void 0 : top.kind) === "class-element", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'class-element' but got '${top == null ? void 0 : top.kind}' instead.`);
            Debug.assert(((_a = top.next) == null ? void 0 : _a.kind) === "class", "Incorrect value for top.next.kind.", ()=>{
                var _a2;
                return `Expected top.next.kind to be 'class' but got '${(_a2 = top.next) == null ? void 0 : _a2.kind}' instead.`;
            });
            top = top.next;
            updateState();
        }
        function enterName() {
            Debug.assert((top == null ? void 0 : top.kind) === "class-element", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'class-element' but got '${top == null ? void 0 : top.kind}' instead.`);
            top = {
                kind: "name",
                next: top
            };
            updateState();
        }
        function exitName() {
            Debug.assert((top == null ? void 0 : top.kind) === "name", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'name' but got '${top == null ? void 0 : top.kind}' instead.`);
            top = top.next;
            updateState();
        }
        function enterOther() {
            if ((top == null ? void 0 : top.kind) === "other") {
                Debug.assert(!pendingExpressions);
                top.depth++;
            } else {
                top = {
                    kind: "other",
                    next: top,
                    depth: 0,
                    savedPendingExpressions: pendingExpressions
                };
                pendingExpressions = void 0;
                updateState();
            }
        }
        function exitOther() {
            Debug.assert((top == null ? void 0 : top.kind) === "other", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'other' but got '${top == null ? void 0 : top.kind}' instead.`);
            if (top.depth > 0) {
                Debug.assert(!pendingExpressions);
                top.depth--;
            } else {
                pendingExpressions = top.savedPendingExpressions;
                top = top.next;
                updateState();
            }
        }
        function shouldVisitNode(node) {
            return !!(node.transformFlags & 33554432 /* ContainsDecorators */ ) || !!classThis && !!(node.transformFlags & 16384 /* ContainsLexicalThis */ ) || !!classThis && !!classSuper && !!(node.transformFlags & 134217728 /* ContainsLexicalSuper */ );
        }
        function visitor(node) {
            if (!shouldVisitNode(node)) return node;
            switch(node.kind){
                case 169 /* Decorator */ :
                    return Debug.fail("Use `modifierVisitor` instead.");
                case 262 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 230 /* ClassExpression */ :
                    return visitClassExpression(node, /*referencedName*/ void 0);
                case 175 /* Constructor */ :
                case 171 /* PropertyDeclaration */ :
                case 174 /* ClassStaticBlockDeclaration */ :
                    return Debug.fail("Not supported outside of a class. Use 'classElementVisitor' instead.");
                case 168 /* Parameter */ :
                    return visitParameterDeclaration(node);
                case 225 /* BinaryExpression */ :
                    return visitBinaryExpression(node, /*discarded*/ false);
                case 302 /* PropertyAssignment */ :
                    return visitPropertyAssignment(node);
                case 259 /* VariableDeclaration */ :
                    return visitVariableDeclaration(node);
                case 207 /* BindingElement */ :
                    return visitBindingElement(node);
                case 276 /* ExportAssignment */ :
                    return visitExportAssignment(node);
                case 110 /* ThisKeyword */ :
                    return visitThisExpression(node);
                case 247 /* ForStatement */ :
                    return visitForStatement(node);
                case 243 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 360 /* CommaListExpression */ :
                    return visitCommaListExpression(node, /*discarded*/ false);
                case 216 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, /*discarded*/ false, /*referencedName*/ void 0);
                case 359 /* PartiallyEmittedExpression */ :
                    return visitPartiallyEmittedExpression(node, /*discarded*/ false, /*referencedName*/ void 0);
                case 212 /* CallExpression */ :
                    return visitCallExpression(node);
                case 214 /* TaggedTemplateExpression */ :
                    return visitTaggedTemplateExpression(node);
                case 223 /* PrefixUnaryExpression */ :
                case 224 /* PostfixUnaryExpression */ :
                    return visitPreOrPostfixUnaryExpression(node, /*discarded*/ false);
                case 210 /* PropertyAccessExpression */ :
                    return visitPropertyAccessExpression(node);
                case 211 /* ElementAccessExpression */ :
                    return visitElementAccessExpression(node);
                case 166 /* ComputedPropertyName */ :
                    return visitComputedPropertyName(node);
                case 173 /* MethodDeclaration */ :
                case 177 /* SetAccessor */ :
                case 176 /* GetAccessor */ :
                case 217 /* FunctionExpression */ :
                case 261 /* FunctionDeclaration */ :
                    {
                        enterOther();
                        const result = visitEachChild(node, fallbackVisitor, context);
                        exitOther();
                        return result;
                    }
                default:
                    return visitEachChild(node, fallbackVisitor, context);
            }
        }
        function fallbackVisitor(node) {
            switch(node.kind){
                case 169 /* Decorator */ :
                    return void 0;
                default:
                    return visitor(node);
            }
        }
        function modifierVisitor(node) {
            switch(node.kind){
                case 169 /* Decorator */ :
                    return void 0;
                default:
                    return node;
            }
        }
        function classElementVisitor(node) {
            switch(node.kind){
                case 175 /* Constructor */ :
                    return visitConstructorDeclaration(node);
                case 173 /* MethodDeclaration */ :
                    return visitMethodDeclaration(node);
                case 176 /* GetAccessor */ :
                    return visitGetAccessorDeclaration(node);
                case 177 /* SetAccessor */ :
                    return visitSetAccessorDeclaration(node);
                case 171 /* PropertyDeclaration */ :
                    return visitPropertyDeclaration(node);
                case 174 /* ClassStaticBlockDeclaration */ :
                    return visitClassStaticBlockDeclaration(node);
                default:
                    return visitor(node);
            }
        }
        function namedEvaluationVisitor(node, referencedName) {
            switch(node.kind){
                case 359 /* PartiallyEmittedExpression */ :
                    return visitPartiallyEmittedExpression(node, /*discarded*/ false, referencedName);
                case 216 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, /*discarded*/ false, referencedName);
                case 230 /* ClassExpression */ :
                    return visitClassExpression(node, referencedName);
                default:
                    return visitor(node);
            }
        }
        function discardedValueVisitor(node) {
            switch(node.kind){
                case 223 /* PrefixUnaryExpression */ :
                case 224 /* PostfixUnaryExpression */ :
                    return visitPreOrPostfixUnaryExpression(node, /*discarded*/ true);
                case 225 /* BinaryExpression */ :
                    return visitBinaryExpression(node, /*discarded*/ true);
                case 360 /* CommaListExpression */ :
                    return visitCommaListExpression(node, /*discarded*/ true);
                case 216 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, /*discarded*/ true, /*referencedName*/ void 0);
                default:
                    return visitor(node);
            }
        }
        function getHelperVariableName(node) {
            let declarationName = node.name && isIdentifier(node.name) && !isGeneratedIdentifier(node.name) ? idText(node.name) : node.name && isPrivateIdentifier(node.name) && !isGeneratedIdentifier(node.name) ? idText(node.name).slice(1) : node.name && isStringLiteral(node.name) && isIdentifierText(node.name.text, 99 /* ESNext */ ) ? node.name.text : isClassLike(node) ? "class" : "member";
            if (isGetAccessor(node)) declarationName = `get_${declarationName}`;
            if (isSetAccessor(node)) declarationName = `set_${declarationName}`;
            if (node.name && isPrivateIdentifier(node.name)) declarationName = `private_${declarationName}`;
            if (isStatic(node)) declarationName = `static_${declarationName}`;
            return "_" + declarationName;
        }
        function createHelperVariable(node, suffix) {
            return factory2.createUniqueName(`${getHelperVariableName(node)}_${suffix}`, 24 /* ReservedInNestedScopes */ );
        }
        function createLet(name, initializer) {
            return factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(name, /*exclamationToken*/ void 0, /*type*/ void 0, initializer)
            ], 1 /* Let */ ));
        }
        function createClassInfo(node) {
            let instanceExtraInitializersName;
            let staticExtraInitializersName;
            let hasStaticInitializers = false;
            let hasNonAmbientInstanceFields = false;
            let hasStaticPrivateClassElements = false;
            for (const member of node.members){
                if (isNamedClassElement(member) && nodeOrChildIsDecorated(/*useLegacyDecorators*/ false, member, node)) {
                    if (hasStaticModifier(member)) staticExtraInitializersName ?? (staticExtraInitializersName = factory2.createUniqueName("_staticExtraInitializers", 16 /* Optimistic */ ));
                    else instanceExtraInitializersName ?? (instanceExtraInitializersName = factory2.createUniqueName("_instanceExtraInitializers", 16 /* Optimistic */ ));
                }
                if (isClassStaticBlockDeclaration(member)) hasStaticInitializers = true;
                else if (isPropertyDeclaration(member)) {
                    if (hasStaticModifier(member)) hasStaticInitializers || (hasStaticInitializers = !!member.initializer || hasDecorators(member));
                    else hasNonAmbientInstanceFields || (hasNonAmbientInstanceFields = !isAmbientPropertyDeclaration(member));
                }
                if ((isPrivateIdentifierClassElementDeclaration(member) || isAutoAccessorPropertyDeclaration(member)) && hasStaticModifier(member)) hasStaticPrivateClassElements = true;
                if (staticExtraInitializersName && instanceExtraInitializersName && hasStaticInitializers && hasNonAmbientInstanceFields && hasStaticPrivateClassElements) break;
            }
            return {
                class: node,
                instanceExtraInitializersName: instanceExtraInitializersName,
                staticExtraInitializersName: staticExtraInitializersName,
                hasStaticInitializers: hasStaticInitializers,
                hasNonAmbientInstanceFields: hasNonAmbientInstanceFields,
                hasStaticPrivateClassElements: hasStaticPrivateClassElements
            };
        }
        function containsLexicalSuperInStaticInitializer(node) {
            for (const member of node.members)if (isClassStaticBlockDeclaration(member) || isPropertyDeclaration(member) && hasStaticModifier(member)) {
                if (member.transformFlags & 134217728 /* ContainsLexicalSuper */ ) return true;
            }
            return false;
        }
        function transformClassLike(node, className) {
            var _a;
            startLexicalEnvironment();
            const classReference = factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ false, /*ignoreAssignedName*/ true);
            const classInfo2 = createClassInfo(node);
            const classDefinitionStatements = [];
            let leadingBlockStatements;
            let trailingBlockStatements;
            let syntheticConstructor;
            let heritageClauses;
            let shouldTransformPrivateStaticElementsInClass = false;
            const classDecorators = transformAllDecoratorsOfDeclaration(getAllDecoratorsOfClass(node));
            if (classDecorators) {
                classInfo2.classDecoratorsName = factory2.createUniqueName("_classDecorators", 16 /* Optimistic */ );
                classInfo2.classDescriptorName = factory2.createUniqueName("_classDescriptor", 16 /* Optimistic */ );
                classInfo2.classExtraInitializersName = factory2.createUniqueName("_classExtraInitializers", 16 /* Optimistic */ );
                classInfo2.classThis = factory2.createUniqueName("_classThis", 16 /* Optimistic */ );
                classDefinitionStatements.push(createLet(classInfo2.classDecoratorsName, factory2.createArrayLiteralExpression(classDecorators)), createLet(classInfo2.classDescriptorName), createLet(classInfo2.classExtraInitializersName, factory2.createArrayLiteralExpression()), createLet(classInfo2.classThis));
                if (classInfo2.hasStaticPrivateClassElements) {
                    shouldTransformPrivateStaticElementsInClass = true;
                    shouldTransformPrivateStaticElementsInFile = true;
                }
            }
            if (classDecorators && containsLexicalSuperInStaticInitializer(node)) {
                const extendsClause = getHeritageClause(node.heritageClauses, 96 /* ExtendsKeyword */ );
                const extendsElement = extendsClause && firstOrUndefined(extendsClause.types);
                const extendsExpression = extendsElement && visitNode(extendsElement.expression, visitor, isExpression);
                if (extendsExpression) {
                    classInfo2.classSuper = factory2.createUniqueName("_classSuper", 16 /* Optimistic */ );
                    const unwrapped = skipOuterExpressions(extendsExpression);
                    const safeExtendsExpression = isClassExpression(unwrapped) && !unwrapped.name || isFunctionExpression(unwrapped) && !unwrapped.name || isArrowFunction(unwrapped) ? factory2.createComma(factory2.createNumericLiteral(0), extendsExpression) : extendsExpression;
                    classDefinitionStatements.push(createLet(classInfo2.classSuper, safeExtendsExpression));
                    const updatedExtendsElement = factory2.updateExpressionWithTypeArguments(extendsElement, classInfo2.classSuper, /*typeArguments*/ void 0);
                    const updatedExtendsClause = factory2.updateHeritageClause(extendsClause, [
                        updatedExtendsElement
                    ]);
                    heritageClauses = factory2.createNodeArray([
                        updatedExtendsClause
                    ]);
                }
            } else heritageClauses = visitNodes2(node.heritageClauses, visitor, isHeritageClause);
            const renamedClassThis = classInfo2.classThis ?? factory2.createThis();
            const needsSetNameHelper = !((_a = getOriginalNode(node, isClassLike)) == null ? void 0 : _a.name) && (classDecorators || !isStringLiteral(className) || !isEmptyStringLiteral(className));
            if (needsSetNameHelper) {
                const setNameExpr = emitHelpers().createSetFunctionNameHelper(factory2.createThis(), className);
                leadingBlockStatements = append(leadingBlockStatements, factory2.createExpressionStatement(setNameExpr));
            }
            enterClass(classInfo2);
            let members = visitNodes2(node.members, classElementVisitor, isClassElement);
            if (pendingExpressions) {
                let outerThis;
                for (let expression of pendingExpressions){
                    expression = visitNode(expression, function thisVisitor(node2) {
                        if (!(node2.transformFlags & 16384 /* ContainsLexicalThis */ )) return node2;
                        switch(node2.kind){
                            case 110 /* ThisKeyword */ :
                                if (!outerThis) {
                                    outerThis = factory2.createUniqueName("_outerThis", 16 /* Optimistic */ );
                                    classDefinitionStatements.unshift(createLet(outerThis, factory2.createThis()));
                                }
                                return outerThis;
                            default:
                                return visitEachChild(node2, thisVisitor, context);
                        }
                    }, isExpression);
                    const statement = factory2.createExpressionStatement(expression);
                    leadingBlockStatements = append(leadingBlockStatements, statement);
                }
                pendingExpressions = void 0;
            }
            exitClass();
            if (classInfo2.instanceExtraInitializersName && !getFirstConstructorWithBody(node)) {
                const initializerStatements = prepareConstructor(node, classInfo2);
                if (initializerStatements) {
                    const extendsClauseElement = getEffectiveBaseTypeNode(node);
                    const isDerivedClass = !!(extendsClauseElement && skipOuterExpressions(extendsClauseElement.expression).kind !== 106 /* NullKeyword */ );
                    const constructorStatements = [];
                    if (isDerivedClass) {
                        const spreadArguments = factory2.createSpreadElement(factory2.createIdentifier("arguments"));
                        const superCall = factory2.createCallExpression(factory2.createSuper(), /*typeArguments*/ void 0, [
                            spreadArguments
                        ]);
                        constructorStatements.push(factory2.createExpressionStatement(superCall));
                    }
                    addRange(constructorStatements, initializerStatements);
                    const constructorBody = factory2.createBlock(constructorStatements, /*multiLine*/ true);
                    syntheticConstructor = factory2.createConstructorDeclaration(/*modifiers*/ void 0, [], constructorBody);
                }
            }
            if (classInfo2.staticExtraInitializersName) classDefinitionStatements.push(createLet(classInfo2.staticExtraInitializersName, factory2.createArrayLiteralExpression()));
            if (classInfo2.instanceExtraInitializersName) classDefinitionStatements.push(createLet(classInfo2.instanceExtraInitializersName, factory2.createArrayLiteralExpression()));
            if (classInfo2.memberInfos) forEachEntry(classInfo2.memberInfos, (memberInfo, member)=>{
                if (isStatic(member)) {
                    classDefinitionStatements.push(createLet(memberInfo.memberDecoratorsName));
                    if (memberInfo.memberInitializersName) classDefinitionStatements.push(createLet(memberInfo.memberInitializersName, factory2.createArrayLiteralExpression()));
                    if (memberInfo.memberDescriptorName) classDefinitionStatements.push(createLet(memberInfo.memberDescriptorName));
                }
            });
            if (classInfo2.memberInfos) forEachEntry(classInfo2.memberInfos, (memberInfo, member)=>{
                if (!isStatic(member)) {
                    classDefinitionStatements.push(createLet(memberInfo.memberDecoratorsName));
                    if (memberInfo.memberInitializersName) classDefinitionStatements.push(createLet(memberInfo.memberInitializersName, factory2.createArrayLiteralExpression()));
                    if (memberInfo.memberDescriptorName) classDefinitionStatements.push(createLet(memberInfo.memberDescriptorName));
                }
            });
            leadingBlockStatements = addRange(leadingBlockStatements, classInfo2.staticNonFieldDecorationStatements);
            leadingBlockStatements = addRange(leadingBlockStatements, classInfo2.nonStaticNonFieldDecorationStatements);
            leadingBlockStatements = addRange(leadingBlockStatements, classInfo2.staticFieldDecorationStatements);
            leadingBlockStatements = addRange(leadingBlockStatements, classInfo2.nonStaticFieldDecorationStatements);
            if (classInfo2.classDescriptorName && classInfo2.classDecoratorsName && classInfo2.classExtraInitializersName && classInfo2.classThis) {
                leadingBlockStatements ?? (leadingBlockStatements = []);
                const valueProperty = factory2.createPropertyAssignment("value", factory2.createThis());
                const classDescriptor = factory2.createObjectLiteralExpression([
                    valueProperty
                ]);
                const classDescriptorAssignment = factory2.createAssignment(classInfo2.classDescriptorName, classDescriptor);
                const classNameReference = factory2.createPropertyAccessExpression(factory2.createThis(), "name");
                const esDecorateHelper2 = emitHelpers().createESDecorateHelper(factory2.createNull(), classDescriptorAssignment, classInfo2.classDecoratorsName, {
                    kind: "class",
                    name: classNameReference
                }, factory2.createNull(), classInfo2.classExtraInitializersName);
                const esDecorateStatement = factory2.createExpressionStatement(esDecorateHelper2);
                setSourceMapRange(esDecorateStatement, moveRangePastDecorators(node));
                leadingBlockStatements.push(esDecorateStatement);
                const classDescriptorValueReference = factory2.createPropertyAccessExpression(classInfo2.classDescriptorName, "value");
                const classThisAssignment = factory2.createAssignment(classInfo2.classThis, classDescriptorValueReference);
                const classReferenceAssignment = factory2.createAssignment(classReference, classThisAssignment);
                leadingBlockStatements.push(factory2.createExpressionStatement(classReferenceAssignment));
            }
            if (classInfo2.staticExtraInitializersName) {
                const runStaticInitializersHelper = emitHelpers().createRunInitializersHelper(renamedClassThis, classInfo2.staticExtraInitializersName);
                const runStaticInitializersStatement = factory2.createExpressionStatement(runStaticInitializersHelper);
                setSourceMapRange(runStaticInitializersStatement, node.name ?? moveRangePastDecorators(node));
                leadingBlockStatements = append(leadingBlockStatements, runStaticInitializersStatement);
            }
            if (classInfo2.classExtraInitializersName) {
                const runClassInitializersHelper = emitHelpers().createRunInitializersHelper(renamedClassThis, classInfo2.classExtraInitializersName);
                const runClassInitializersStatement = factory2.createExpressionStatement(runClassInitializersHelper);
                setSourceMapRange(runClassInitializersStatement, node.name ?? moveRangePastDecorators(node));
                trailingBlockStatements = append(trailingBlockStatements, runClassInitializersStatement);
            }
            if (leadingBlockStatements && trailingBlockStatements && !classInfo2.hasStaticInitializers) {
                addRange(leadingBlockStatements, trailingBlockStatements);
                trailingBlockStatements = void 0;
            }
            let newMembers = members;
            if (leadingBlockStatements) {
                const leadingStaticBlockBody = factory2.createBlock(leadingBlockStatements, /*multiLine*/ true);
                const leadingStaticBlock = factory2.createClassStaticBlockDeclaration(leadingStaticBlockBody);
                if (shouldTransformPrivateStaticElementsInClass) setInternalEmitFlags(leadingStaticBlock, 32 /* TransformPrivateStaticElements */ );
                newMembers = [
                    leadingStaticBlock,
                    ...newMembers
                ];
            }
            if (syntheticConstructor) newMembers = [
                ...newMembers,
                syntheticConstructor
            ];
            if (trailingBlockStatements) {
                const trailingStaticBlockBody = factory2.createBlock(trailingBlockStatements, /*multiLine*/ true);
                const trailingStaticBlock = factory2.createClassStaticBlockDeclaration(trailingStaticBlockBody);
                newMembers = [
                    ...newMembers,
                    trailingStaticBlock
                ];
            }
            if (newMembers !== members) members = setTextRange(factory2.createNodeArray(newMembers), members);
            const lexicalEnvironment = endLexicalEnvironment();
            let classExpression;
            if (classDecorators) {
                classExpression = factory2.createClassExpression(/*modifiers*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, heritageClauses, members);
                const classReferenceDeclaration = factory2.createVariableDeclaration(classReference, /*exclamationToken*/ void 0, /*type*/ void 0, classExpression);
                const classReferenceVarDeclList = factory2.createVariableDeclarationList([
                    classReferenceDeclaration
                ]);
                const returnExpr = classInfo2.classThis ? factory2.createAssignment(classReference, classInfo2.classThis) : classReference;
                classDefinitionStatements.push(factory2.createVariableStatement(/*modifiers*/ void 0, classReferenceVarDeclList), factory2.createReturnStatement(returnExpr));
            } else {
                classExpression = factory2.createClassExpression(/*modifiers*/ void 0, node.name, /*typeParameters*/ void 0, heritageClauses, members);
                classDefinitionStatements.push(factory2.createReturnStatement(classExpression));
            }
            if (shouldTransformPrivateStaticElementsInClass) {
                addInternalEmitFlags(classExpression, 32 /* TransformPrivateStaticElements */ );
                for (const member of classExpression.members)if ((isPrivateIdentifierClassElementDeclaration(member) || isAutoAccessorPropertyDeclaration(member)) && hasStaticModifier(member)) addInternalEmitFlags(member, 32 /* TransformPrivateStaticElements */ );
            }
            setOriginalNode(classExpression, node);
            getOrCreateEmitNode(classExpression).classThis = classInfo2.classThis;
            return factory2.createImmediatelyInvokedArrowFunction(factory2.mergeLexicalEnvironment(classDefinitionStatements, lexicalEnvironment));
        }
        function isDecoratedClassLike(node) {
            return classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ false, node) || childIsDecorated(/*useLegacyDecorators*/ false, node);
        }
        function visitClassDeclaration(node) {
            if (isDecoratedClassLike(node)) {
                if (hasSyntacticModifier(node, 1 /* Export */ ) && hasSyntacticModifier(node, 1024 /* Default */ )) {
                    const originalClass = getOriginalNode(node, isClassLike) ?? node;
                    const className = originalClass.name ? factory2.createStringLiteralFromNode(originalClass.name) : factory2.createStringLiteral("default");
                    const iife = transformClassLike(node, className);
                    const statement = factory2.createExportDefault(iife);
                    setOriginalNode(statement, node);
                    setCommentRange(statement, getCommentRange(node));
                    setSourceMapRange(statement, moveRangePastDecorators(node));
                    return statement;
                } else {
                    Debug.assertIsDefined(node.name, "A class declaration that is not a default export must have a name.");
                    const iife = transformClassLike(node, factory2.createStringLiteralFromNode(node.name));
                    const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
                    const declName = languageVersion <= 2 /* ES2015 */  ? factory2.getInternalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true) : factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
                    const varDecl = factory2.createVariableDeclaration(declName, /*exclamationToken*/ void 0, /*type*/ void 0, iife);
                    setOriginalNode(varDecl, node);
                    const varDecls = factory2.createVariableDeclarationList([
                        varDecl
                    ], 1 /* Let */ );
                    const statement = factory2.createVariableStatement(modifiers, varDecls);
                    setOriginalNode(statement, node);
                    setCommentRange(statement, getCommentRange(node));
                    return statement;
                }
            } else {
                const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
                const heritageClauses = visitNodes2(node.heritageClauses, visitor, isHeritageClause);
                enterClass(/*classInfo*/ void 0);
                const members = visitNodes2(node.members, classElementVisitor, isClassElement);
                exitClass();
                return factory2.updateClassDeclaration(node, modifiers, node.name, /*typeParameters*/ void 0, heritageClauses, members);
            }
        }
        function visitClassExpression(node, referencedName) {
            if (isDecoratedClassLike(node)) {
                const className = node.name ? factory2.createStringLiteralFromNode(node.name) : referencedName ?? factory2.createStringLiteral("");
                const iife = transformClassLike(node, className);
                setOriginalNode(iife, node);
                return iife;
            } else {
                const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
                const heritageClauses = visitNodes2(node.heritageClauses, visitor, isHeritageClause);
                enterClass(/*classInfo*/ void 0);
                const members = visitNodes2(node.members, classElementVisitor, isClassElement);
                exitClass();
                return factory2.updateClassExpression(node, modifiers, node.name, /*typeParameters*/ void 0, heritageClauses, members);
            }
        }
        function prepareConstructor(_parent, classInfo2) {
            if (classInfo2.instanceExtraInitializersName && !classInfo2.hasNonAmbientInstanceFields) {
                const statements = [];
                statements.push(factory2.createExpressionStatement(emitHelpers().createRunInitializersHelper(factory2.createThis(), classInfo2.instanceExtraInitializersName)));
                return statements;
            }
        }
        function visitConstructorDeclaration(node) {
            enterClassElement(node);
            const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
            const parameters = visitNodes2(node.parameters, visitor, isParameter);
            let body;
            if (node.body && classInfo) {
                const initializerStatements = prepareConstructor(classInfo.class, classInfo);
                if (initializerStatements) {
                    const statements = [];
                    const nonPrologueStart = factory2.copyPrologue(node.body.statements, statements, /*ensureUseStrict*/ false, visitor);
                    const superStatementIndex = findSuperStatementIndex(node.body.statements, nonPrologueStart);
                    if (superStatementIndex >= 0) {
                        addRange(statements, visitNodes2(node.body.statements, visitor, isStatement, nonPrologueStart, superStatementIndex + 1 - nonPrologueStart));
                        addRange(statements, initializerStatements);
                        addRange(statements, visitNodes2(node.body.statements, visitor, isStatement, superStatementIndex + 1));
                    } else {
                        addRange(statements, initializerStatements);
                        addRange(statements, visitNodes2(node.body.statements, visitor, isStatement));
                    }
                    body = factory2.createBlock(statements, /*multiLine*/ true);
                    setOriginalNode(body, node.body);
                    setTextRange(body, node.body);
                }
            }
            body ?? (body = visitNode(node.body, visitor, isBlock));
            exitClassElement();
            return factory2.updateConstructorDeclaration(node, modifiers, parameters, body);
        }
        function finishClassElement(updated, original) {
            if (updated !== original) {
                setCommentRange(updated, original);
                setSourceMapRange(updated, moveRangePastDecorators(original));
            }
            return updated;
        }
        function partialTransformClassElement(member, useNamedEvaluation, classInfo2, createDescriptor) {
            let referencedName;
            let name;
            let initializersName;
            let thisArg;
            let descriptorName;
            if (!classInfo2) {
                const modifiers2 = visitNodes2(member.modifiers, modifierVisitor, isModifier);
                enterName();
                if (useNamedEvaluation) ({ referencedName: referencedName , name: name  } = visitReferencedPropertyName(member.name));
                else name = visitPropertyName(member.name);
                exitName();
                return {
                    modifiers: modifiers2,
                    referencedName: referencedName,
                    name: name,
                    initializersName: initializersName,
                    descriptorName: descriptorName,
                    thisArg: thisArg
                };
            }
            const memberDecorators = transformAllDecoratorsOfDeclaration(getAllDecoratorsOfClassElement(member, classInfo2.class, /*useLegacyDecorators*/ false));
            const modifiers = visitNodes2(member.modifiers, modifierVisitor, isModifier);
            if (memberDecorators) {
                const memberDecoratorsName = createHelperVariable(member, "decorators");
                const memberDecoratorsArray = factory2.createArrayLiteralExpression(memberDecorators);
                const memberDecoratorsAssignment = factory2.createAssignment(memberDecoratorsName, memberDecoratorsArray);
                const memberInfo = {
                    memberDecoratorsName: memberDecoratorsName
                };
                classInfo2.memberInfos ?? (classInfo2.memberInfos = /* @__PURE__ */ new Map());
                classInfo2.memberInfos.set(member, memberInfo);
                pendingExpressions ?? (pendingExpressions = []);
                pendingExpressions.push(memberDecoratorsAssignment);
                const statements = isMethodOrAccessor(member) || isAutoAccessorPropertyDeclaration(member) ? isStatic(member) ? classInfo2.staticNonFieldDecorationStatements ?? (classInfo2.staticNonFieldDecorationStatements = []) : classInfo2.nonStaticNonFieldDecorationStatements ?? (classInfo2.nonStaticNonFieldDecorationStatements = []) : isPropertyDeclaration(member) && !isAutoAccessorPropertyDeclaration(member) ? isStatic(member) ? classInfo2.staticFieldDecorationStatements ?? (classInfo2.staticFieldDecorationStatements = []) : classInfo2.nonStaticFieldDecorationStatements ?? (classInfo2.nonStaticFieldDecorationStatements = []) : Debug.fail();
                const kind = isGetAccessorDeclaration(member) ? "getter" : isSetAccessorDeclaration(member) ? "setter" : isMethodDeclaration(member) ? "method" : isAutoAccessorPropertyDeclaration(member) ? "accessor" : isPropertyDeclaration(member) ? "field" : Debug.fail();
                let propertyName;
                if (isIdentifier(member.name) || isPrivateIdentifier(member.name)) propertyName = {
                    computed: false,
                    name: member.name
                };
                else if (isPropertyNameLiteral(member.name)) propertyName = {
                    computed: true,
                    name: factory2.createStringLiteralFromNode(member.name)
                };
                else {
                    const expression = member.name.expression;
                    if (isPropertyNameLiteral(expression) && !isIdentifier(expression)) propertyName = {
                        computed: true,
                        name: factory2.createStringLiteralFromNode(expression)
                    };
                    else {
                        enterName();
                        ({ referencedName: referencedName , name: name  } = visitReferencedPropertyName(member.name));
                        propertyName = {
                            computed: true,
                            name: referencedName
                        };
                        exitName();
                    }
                }
                const context2 = {
                    kind: kind,
                    name: propertyName,
                    static: isStatic(member),
                    private: isPrivateIdentifier(member.name),
                    access: {
                        // 15.7.3 CreateDecoratorAccessObject (kind, name)
                        // 2. If _kind_ is ~field~, ~method~, ~accessor~, or ~getter~, then ...
                        get: isPropertyDeclaration(member) || isGetAccessorDeclaration(member) || isMethodDeclaration(member),
                        // 3. If _kind_ is ~field~, ~accessor~, or ~setter~, then ...
                        set: isPropertyDeclaration(member) || isSetAccessorDeclaration(member)
                    }
                };
                const extraInitializers = isStatic(member) ? classInfo2.staticExtraInitializersName ?? (classInfo2.staticExtraInitializersName = factory2.createUniqueName("_staticExtraInitializers", 16 /* Optimistic */ )) : classInfo2.instanceExtraInitializersName ?? (classInfo2.instanceExtraInitializersName = factory2.createUniqueName("_instanceExtraInitializers", 16 /* Optimistic */ ));
                if (isMethodOrAccessor(member)) {
                    let descriptor;
                    if (isPrivateIdentifierClassElementDeclaration(member) && createDescriptor) {
                        descriptor = createDescriptor(member, visitNodes2(modifiers, (node)=>tryCast(node, isAsyncModifier), isModifier));
                        memberInfo.memberDescriptorName = descriptorName = createHelperVariable(member, "descriptor");
                        descriptor = factory2.createAssignment(descriptorName, descriptor);
                    }
                    const esDecorateExpression = emitHelpers().createESDecorateHelper(factory2.createThis(), descriptor ?? factory2.createNull(), memberDecoratorsName, context2, factory2.createNull(), extraInitializers);
                    const esDecorateStatement = factory2.createExpressionStatement(esDecorateExpression);
                    setSourceMapRange(esDecorateStatement, moveRangePastDecorators(member));
                    statements.push(esDecorateStatement);
                } else if (isPropertyDeclaration(member)) {
                    initializersName = memberInfo.memberInitializersName ?? (memberInfo.memberInitializersName = createHelperVariable(member, "initializers"));
                    if (isStatic(member)) thisArg = classInfo2.classThis;
                    let descriptor;
                    if (isPrivateIdentifierClassElementDeclaration(member) && hasAccessorModifier(member) && createDescriptor) {
                        descriptor = createDescriptor(member, /*modifiers*/ void 0);
                        memberInfo.memberDescriptorName = descriptorName = createHelperVariable(member, "descriptor");
                        descriptor = factory2.createAssignment(descriptorName, descriptor);
                    }
                    const esDecorateExpression = emitHelpers().createESDecorateHelper(isAutoAccessorPropertyDeclaration(member) ? factory2.createThis() : factory2.createNull(), descriptor ?? factory2.createNull(), memberDecoratorsName, context2, initializersName, extraInitializers);
                    const esDecorateStatement = factory2.createExpressionStatement(esDecorateExpression);
                    setSourceMapRange(esDecorateStatement, moveRangePastDecorators(member));
                    statements.push(esDecorateStatement);
                }
            }
            if (name === void 0) {
                enterName();
                if (useNamedEvaluation) ({ referencedName: referencedName , name: name  } = visitReferencedPropertyName(member.name));
                else name = visitPropertyName(member.name);
                exitName();
            }
            if (!some(modifiers) && (isMethodDeclaration(member) || isPropertyDeclaration(member))) setEmitFlags(name, 1024 /* NoLeadingComments */ );
            return {
                modifiers: modifiers,
                referencedName: referencedName,
                name: name,
                initializersName: initializersName,
                descriptorName: descriptorName,
                thisArg: thisArg
            };
        }
        function visitMethodDeclaration(node) {
            enterClassElement(node);
            const { modifiers: modifiers , name: name , descriptorName: descriptorName  } = partialTransformClassElement(node, /*useNamedEvaluation*/ false, classInfo, createMethodDescriptorObject);
            if (descriptorName) {
                exitClassElement();
                return finishClassElement(createMethodDescriptorForwarder(modifiers, name, descriptorName), node);
            } else {
                const parameters = visitNodes2(node.parameters, visitor, isParameter);
                const body = visitNode(node.body, visitor, isBlock);
                exitClassElement();
                return finishClassElement(factory2.updateMethodDeclaration(node, modifiers, node.asteriskToken, name, /*questionToken*/ void 0, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body), node);
            }
        }
        function visitGetAccessorDeclaration(node) {
            enterClassElement(node);
            const { modifiers: modifiers , name: name , descriptorName: descriptorName  } = partialTransformClassElement(node, /*useNamedEvaluation*/ false, classInfo, createGetAccessorDescriptorObject);
            if (descriptorName) {
                exitClassElement();
                return finishClassElement(createGetAccessorDescriptorForwarder(modifiers, name, descriptorName), node);
            } else {
                const parameters = visitNodes2(node.parameters, visitor, isParameter);
                const body = visitNode(node.body, visitor, isBlock);
                exitClassElement();
                return finishClassElement(factory2.updateGetAccessorDeclaration(node, modifiers, name, parameters, /*type*/ void 0, body), node);
            }
        }
        function visitSetAccessorDeclaration(node) {
            enterClassElement(node);
            const { modifiers: modifiers , name: name , descriptorName: descriptorName  } = partialTransformClassElement(node, /*useNamedEvaluation*/ false, classInfo, createSetAccessorDescriptorObject);
            if (descriptorName) {
                exitClassElement();
                return finishClassElement(createSetAccessorDescriptorForwarder(modifiers, name, descriptorName), node);
            } else {
                const parameters = visitNodes2(node.parameters, visitor, isParameter);
                const body = visitNode(node.body, visitor, isBlock);
                exitClassElement();
                return finishClassElement(factory2.updateSetAccessorDeclaration(node, modifiers, name, parameters, body), node);
            }
        }
        function visitClassStaticBlockDeclaration(node) {
            enterClassElement(node);
            if (classInfo) classInfo.hasStaticInitializers = true;
            const result = visitEachChild(node, visitor, context);
            exitClassElement();
            return result;
        }
        function visitPropertyDeclaration(node) {
            enterClassElement(node);
            Debug.assert(!isAmbientPropertyDeclaration(node), "Not yet implemented.");
            const useNamedEvaluation = isNamedEvaluation(node, isAnonymousClassNeedingAssignedName);
            const { modifiers: modifiers , name: name , referencedName: referencedName , initializersName: initializersName , descriptorName: descriptorName , thisArg: thisArg  } = partialTransformClassElement(node, useNamedEvaluation, classInfo, hasAccessorModifier(node) ? createAccessorPropertyDescriptorObject : void 0);
            startLexicalEnvironment();
            let initializer = referencedName ? visitNode(node.initializer, (node2)=>namedEvaluationVisitor(node2, referencedName), isExpression) : visitNode(node.initializer, visitor, isExpression);
            if (initializersName) initializer = emitHelpers().createRunInitializersHelper(thisArg ?? factory2.createThis(), initializersName, initializer ?? factory2.createVoidZero());
            if (!isStatic(node) && (classInfo == null ? void 0 : classInfo.instanceExtraInitializersName) && !(classInfo == null ? void 0 : classInfo.hasInjectedInstanceInitializers)) {
                classInfo.hasInjectedInstanceInitializers = true;
                initializer ?? (initializer = factory2.createVoidZero());
                initializer = factory2.createParenthesizedExpression(factory2.createComma(emitHelpers().createRunInitializersHelper(factory2.createThis(), classInfo.instanceExtraInitializersName), initializer));
            }
            if (isStatic(node) && classInfo && initializer) classInfo.hasStaticInitializers = true;
            const declarations = endLexicalEnvironment();
            if (some(declarations)) initializer = factory2.createImmediatelyInvokedArrowFunction([
                ...declarations,
                factory2.createReturnStatement(initializer)
            ]);
            exitClassElement();
            if (hasAccessorModifier(node) && descriptorName) {
                const commentRange = getCommentRange(node);
                const sourceMapRange = getSourceMapRange(node);
                const name2 = node.name;
                let getterName = name2;
                let setterName = name2;
                if (isComputedPropertyName(name2) && !isSimpleInlineableExpression(name2.expression)) {
                    const cacheAssignment = findComputedPropertyNameCacheAssignment(name2);
                    if (cacheAssignment) {
                        getterName = factory2.updateComputedPropertyName(name2, visitNode(name2.expression, visitor, isExpression));
                        setterName = factory2.updateComputedPropertyName(name2, cacheAssignment.left);
                    } else {
                        const temp = factory2.createTempVariable(hoistVariableDeclaration);
                        setSourceMapRange(temp, name2.expression);
                        const expression = visitNode(name2.expression, visitor, isExpression);
                        const assignment = factory2.createAssignment(temp, expression);
                        setSourceMapRange(assignment, name2.expression);
                        getterName = factory2.updateComputedPropertyName(name2, assignment);
                        setterName = factory2.updateComputedPropertyName(name2, temp);
                    }
                }
                const modifiersWithoutAccessor = visitNodes2(modifiers, (node2)=>node2.kind !== 129 /* AccessorKeyword */  ? node2 : void 0, isModifier);
                const backingField = createAccessorPropertyBackingField(factory2, node, modifiersWithoutAccessor, initializer);
                setOriginalNode(backingField, node);
                setEmitFlags(backingField, 3072 /* NoComments */ );
                setSourceMapRange(backingField, sourceMapRange);
                setSourceMapRange(backingField.name, node.name);
                const getter = createGetAccessorDescriptorForwarder(modifiersWithoutAccessor, getterName, descriptorName);
                setOriginalNode(getter, node);
                setCommentRange(getter, commentRange);
                setSourceMapRange(getter, sourceMapRange);
                const setter = createSetAccessorDescriptorForwarder(modifiersWithoutAccessor, setterName, descriptorName);
                setOriginalNode(setter, node);
                setEmitFlags(setter, 3072 /* NoComments */ );
                setSourceMapRange(setter, sourceMapRange);
                return [
                    backingField,
                    getter,
                    setter
                ];
            }
            return finishClassElement(factory2.updatePropertyDeclaration(node, modifiers, name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, initializer), node);
        }
        function visitThisExpression(node) {
            return classThis ?? node;
        }
        function visitCallExpression(node) {
            if (isSuperProperty(node.expression) && classThis) {
                const expression = visitNode(node.expression, visitor, isExpression);
                const argumentsList = visitNodes2(node.arguments, visitor, isExpression);
                const invocation = factory2.createFunctionCallCall(expression, classThis, argumentsList);
                setOriginalNode(invocation, node);
                setTextRange(invocation, node);
                return invocation;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitTaggedTemplateExpression(node) {
            if (isSuperProperty(node.tag) && classThis) {
                const tag = visitNode(node.tag, visitor, isExpression);
                const boundTag = factory2.createFunctionBindCall(tag, classThis, []);
                setOriginalNode(boundTag, node);
                setTextRange(boundTag, node);
                const template = visitNode(node.template, visitor, isTemplateLiteral);
                return factory2.updateTaggedTemplateExpression(node, boundTag, /*typeArguments*/ void 0, template);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitPropertyAccessExpression(node) {
            if (isSuperProperty(node) && isIdentifier(node.name) && classThis && classSuper) {
                const propertyName = factory2.createStringLiteralFromNode(node.name);
                const superProperty = factory2.createReflectGetCall(classSuper, propertyName, classThis);
                setOriginalNode(superProperty, node.expression);
                setTextRange(superProperty, node.expression);
                return superProperty;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitElementAccessExpression(node) {
            if (isSuperProperty(node) && classThis && classSuper) {
                const propertyName = visitNode(node.argumentExpression, visitor, isExpression);
                const superProperty = factory2.createReflectGetCall(classSuper, propertyName, classThis);
                setOriginalNode(superProperty, node.expression);
                setTextRange(superProperty, node.expression);
                return superProperty;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitParameterDeclaration(node) {
            let updated;
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const assignedName = getAssignedNameOfIdentifier(node.name, node.initializer);
                const name = visitNode(node.name, visitor, isBindingName);
                const initializer = visitNode(node.initializer, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                updated = factory2.updateParameterDeclaration(node, /*modifiers*/ void 0, /*dotDotDotToken*/ void 0, name, /*questionToken*/ void 0, /*type*/ void 0, initializer);
            } else updated = factory2.updateParameterDeclaration(node, /*modifiers*/ void 0, node.dotDotDotToken, visitNode(node.name, visitor, isBindingName), /*questionToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
            if (updated !== node) {
                setCommentRange(updated, node);
                setTextRange(updated, moveRangePastModifiers(node));
                setSourceMapRange(updated, moveRangePastModifiers(node));
                setEmitFlags(updated.name, 64 /* NoTrailingSourceMap */ );
            }
            return updated;
        }
        function isAnonymousClassNeedingAssignedName(node) {
            return isClassExpression(node) && !node.name && isDecoratedClassLike(node);
        }
        function visitForStatement(node) {
            return factory2.updateForStatement(node, visitNode(node.initializer, discardedValueVisitor, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, discardedValueVisitor, isExpression), visitIterationBody(node.statement, visitor, context));
        }
        function visitExpressionStatement(node) {
            return visitEachChild(node, discardedValueVisitor, context);
        }
        function visitBinaryExpression(node, discarded) {
            if (isDestructuringAssignment(node)) {
                const left = visitAssignmentPattern(node.left);
                const right = visitNode(node.right, visitor, isExpression);
                return factory2.updateBinaryExpression(node, left, node.operatorToken, right);
            }
            if (isAssignmentExpression(node)) {
                if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                    const assignedName = getAssignedNameOfIdentifier(node.left, node.right);
                    const left = visitNode(node.left, visitor, isExpression);
                    const right = visitNode(node.right, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                    return factory2.updateBinaryExpression(node, left, node.operatorToken, right);
                }
                if (isSuperProperty(node.left) && classThis && classSuper) {
                    let setterName = isElementAccessExpression(node.left) ? visitNode(node.left.argumentExpression, visitor, isExpression) : isIdentifier(node.left.name) ? factory2.createStringLiteralFromNode(node.left.name) : void 0;
                    if (setterName) {
                        let expression = visitNode(node.right, visitor, isExpression);
                        if (isCompoundAssignment(node.operatorToken.kind)) {
                            let getterName = setterName;
                            if (!isSimpleInlineableExpression(setterName)) {
                                getterName = factory2.createTempVariable(hoistVariableDeclaration);
                                setterName = factory2.createAssignment(getterName, setterName);
                            }
                            const superPropertyGet = factory2.createReflectGetCall(classSuper, getterName, classThis);
                            setOriginalNode(superPropertyGet, node.left);
                            setTextRange(superPropertyGet, node.left);
                            expression = factory2.createBinaryExpression(superPropertyGet, getNonAssignmentOperatorForCompoundAssignment(node.operatorToken.kind), expression);
                            setTextRange(expression, node);
                        }
                        const temp = discarded ? void 0 : factory2.createTempVariable(hoistVariableDeclaration);
                        if (temp) {
                            expression = factory2.createAssignment(temp, expression);
                            setTextRange(temp, node);
                        }
                        expression = factory2.createReflectSetCall(classSuper, setterName, expression, classThis);
                        setOriginalNode(expression, node);
                        setTextRange(expression, node);
                        if (temp) {
                            expression = factory2.createComma(expression, temp);
                            setTextRange(expression, node);
                        }
                        return expression;
                    }
                }
            }
            if (node.operatorToken.kind === 28 /* CommaToken */ ) {
                const left = visitNode(node.left, discardedValueVisitor, isExpression);
                const right = visitNode(node.right, discarded ? discardedValueVisitor : visitor, isExpression);
                return factory2.updateBinaryExpression(node, left, node.operatorToken, right);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitPreOrPostfixUnaryExpression(node, discarded) {
            if (node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) {
                const operand = skipParentheses(node.operand);
                if (isSuperProperty(operand) && classThis && classSuper) {
                    let setterName = isElementAccessExpression(operand) ? visitNode(operand.argumentExpression, visitor, isExpression) : isIdentifier(operand.name) ? factory2.createStringLiteralFromNode(operand.name) : void 0;
                    if (setterName) {
                        let getterName = setterName;
                        if (!isSimpleInlineableExpression(setterName)) {
                            getterName = factory2.createTempVariable(hoistVariableDeclaration);
                            setterName = factory2.createAssignment(getterName, setterName);
                        }
                        let expression = factory2.createReflectGetCall(classSuper, getterName, classThis);
                        setOriginalNode(expression, node);
                        setTextRange(expression, node);
                        const temp = discarded ? void 0 : factory2.createTempVariable(hoistVariableDeclaration);
                        expression = expandPreOrPostfixIncrementOrDecrementExpression(factory2, node, expression, hoistVariableDeclaration, temp);
                        expression = factory2.createReflectSetCall(classSuper, setterName, expression, classThis);
                        setOriginalNode(expression, node);
                        setTextRange(expression, node);
                        if (temp) {
                            expression = factory2.createComma(expression, temp);
                            setTextRange(expression, node);
                        }
                        return expression;
                    }
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitCommaListExpression(node, discarded) {
            const elements = discarded ? visitCommaListElements(node.elements, discardedValueVisitor) : visitCommaListElements(node.elements, visitor, discardedValueVisitor);
            return factory2.updateCommaListExpression(node, elements);
        }
        function visitReferencedPropertyName(node) {
            if (isPropertyNameLiteral(node) || isPrivateIdentifier(node)) {
                const referencedName2 = factory2.createStringLiteralFromNode(node);
                const name2 = visitNode(node, visitor, isPropertyName);
                return {
                    referencedName: referencedName2,
                    name: name2
                };
            }
            if (isPropertyNameLiteral(node.expression) && !isIdentifier(node.expression)) {
                const referencedName2 = factory2.createStringLiteralFromNode(node.expression);
                const name2 = visitNode(node, visitor, isPropertyName);
                return {
                    referencedName: referencedName2,
                    name: name2
                };
            }
            const referencedName = factory2.getGeneratedNameForNode(node);
            hoistVariableDeclaration(referencedName);
            const key = emitHelpers().createPropKeyHelper(visitNode(node.expression, visitor, isExpression));
            const assignment = factory2.createAssignment(referencedName, key);
            const name = factory2.updateComputedPropertyName(node, injectPendingExpressions(assignment));
            return {
                referencedName: referencedName,
                name: name
            };
        }
        function visitPropertyName(node) {
            if (isComputedPropertyName(node)) return visitComputedPropertyName(node);
            return visitNode(node, visitor, isPropertyName);
        }
        function visitComputedPropertyName(node) {
            let expression = visitNode(node.expression, visitor, isExpression);
            if (!isSimpleInlineableExpression(expression)) expression = injectPendingExpressions(expression);
            return factory2.updateComputedPropertyName(node, expression);
        }
        function visitPropertyAssignment(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const { referencedName: referencedName , name: name  } = visitReferencedPropertyName(node.name);
                const initializer = visitNode(node.initializer, (node2)=>namedEvaluationVisitor(node2, referencedName), isExpression);
                return factory2.updatePropertyAssignment(node, name, initializer);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitVariableDeclaration(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const assignedName = getAssignedNameOfIdentifier(node.name, node.initializer);
                const name = visitNode(node.name, visitor, isBindingName);
                const initializer = visitNode(node.initializer, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                return factory2.updateVariableDeclaration(node, name, /*exclamationToken*/ void 0, /*type*/ void 0, initializer);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitBindingElement(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const assignedName = getAssignedNameOfIdentifier(node.name, node.initializer);
                const propertyName = visitNode(node.propertyName, visitor, isPropertyName);
                const name = visitNode(node.name, visitor, isBindingName);
                const initializer = visitNode(node.initializer, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                return factory2.updateBindingElement(node, /*dotDotDotToken*/ void 0, propertyName, name, initializer);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitDestructuringAssignmentTarget(node) {
            if (isObjectLiteralExpression(node) || isArrayLiteralExpression(node)) return visitAssignmentPattern(node);
            if (isSuperProperty(node) && classThis && classSuper) {
                const propertyName = isElementAccessExpression(node) ? visitNode(node.argumentExpression, visitor, isExpression) : isIdentifier(node.name) ? factory2.createStringLiteralFromNode(node.name) : void 0;
                if (propertyName) {
                    const paramName = factory2.createTempVariable(/*recordTempVariable*/ void 0);
                    const expression = factory2.createAssignmentTargetWrapper(paramName, factory2.createReflectSetCall(classSuper, propertyName, paramName, classThis));
                    setOriginalNode(expression, node);
                    setTextRange(expression, node);
                    return expression;
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentElement(node) {
            if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) {
                const assignmentTarget = visitDestructuringAssignmentTarget(node.left);
                let initializer;
                if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                    const assignedName = getAssignedNameOfIdentifier(node.left, node.right);
                    initializer = visitNode(node.right, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                } else initializer = visitNode(node.right, visitor, isExpression);
                return factory2.updateBinaryExpression(node, assignmentTarget, node.operatorToken, initializer);
            } else return visitDestructuringAssignmentTarget(node);
        }
        function visitAssignmentRestElement(node) {
            if (isLeftHandSideExpression(node.expression)) {
                const expression = visitDestructuringAssignmentTarget(node.expression);
                return factory2.updateSpreadElement(node, expression);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitArrayAssignmentElement(node) {
            Debug.assertNode(node, isArrayBindingOrAssignmentElement);
            if (isSpreadElement(node)) return visitAssignmentRestElement(node);
            if (!isOmittedExpression(node)) return visitAssignmentElement(node);
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentProperty(node) {
            const name = visitNode(node.name, visitor, isPropertyName);
            if (isAssignmentExpression(node.initializer, /*excludeCompoundAssignment*/ true)) {
                const assignmentElement = visitAssignmentElement(node.initializer);
                return factory2.updatePropertyAssignment(node, name, assignmentElement);
            }
            if (isLeftHandSideExpression(node.initializer)) {
                const assignmentElement = visitDestructuringAssignmentTarget(node.initializer);
                return factory2.updatePropertyAssignment(node, name, assignmentElement);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitShorthandAssignmentProperty(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const assignedName = getAssignedNameOfIdentifier(node.name, node.objectAssignmentInitializer);
                const name = visitNode(node.name, visitor, isIdentifier);
                const objectAssignmentInitializer = visitNode(node.objectAssignmentInitializer, (node2)=>namedEvaluationVisitor(node2, assignedName), isExpression);
                return factory2.updateShorthandPropertyAssignment(node, name, objectAssignmentInitializer);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentRestProperty(node) {
            if (isLeftHandSideExpression(node.expression)) {
                const expression = visitDestructuringAssignmentTarget(node.expression);
                return factory2.updateSpreadAssignment(node, expression);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitObjectAssignmentElement(node) {
            Debug.assertNode(node, isObjectBindingOrAssignmentElement);
            if (isSpreadAssignment(node)) return visitAssignmentRestProperty(node);
            if (isShorthandPropertyAssignment(node)) return visitShorthandAssignmentProperty(node);
            if (isPropertyAssignment(node)) return visitAssignmentProperty(node);
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentPattern(node) {
            if (isArrayLiteralExpression(node)) {
                const elements = visitNodes2(node.elements, visitArrayAssignmentElement, isExpression);
                return factory2.updateArrayLiteralExpression(node, elements);
            } else {
                const properties = visitNodes2(node.properties, visitObjectAssignmentElement, isObjectLiteralElementLike);
                return factory2.updateObjectLiteralExpression(node, properties);
            }
        }
        function visitExportAssignment(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                const referencedName = factory2.createStringLiteral(node.isExportEquals ? "" : "default");
                const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
                const expression = visitNode(node.expression, (node2)=>namedEvaluationVisitor(node2, referencedName), isExpression);
                return factory2.updateExportAssignment(node, modifiers, expression);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitParenthesizedExpression(node, discarded, referencedName) {
            const visitorFunc = discarded ? discardedValueVisitor : referencedName ? (node2)=>namedEvaluationVisitor(node2, referencedName) : visitor;
            const expression = visitNode(node.expression, visitorFunc, isExpression);
            return factory2.updateParenthesizedExpression(node, expression);
        }
        function visitPartiallyEmittedExpression(node, discarded, referencedName) {
            const visitorFunc = discarded ? discardedValueVisitor : referencedName ? (node2)=>namedEvaluationVisitor(node2, referencedName) : visitor;
            const expression = visitNode(node.expression, visitorFunc, isExpression);
            return factory2.updatePartiallyEmittedExpression(node, expression);
        }
        function injectPendingExpressions(expression) {
            if (some(pendingExpressions)) {
                if (isParenthesizedExpression(expression)) {
                    pendingExpressions.push(expression.expression);
                    expression = factory2.updateParenthesizedExpression(expression, factory2.inlineExpressions(pendingExpressions));
                } else {
                    pendingExpressions.push(expression);
                    expression = factory2.inlineExpressions(pendingExpressions);
                }
                pendingExpressions = void 0;
            }
            return expression;
        }
        function transformAllDecoratorsOfDeclaration(allDecorators) {
            if (!allDecorators) return void 0;
            const decoratorExpressions = [];
            addRange(decoratorExpressions, map(allDecorators.decorators, transformDecorator));
            return decoratorExpressions;
        }
        function transformDecorator(decorator) {
            const expression = visitNode(decorator.expression, visitor, isExpression);
            setEmitFlags(expression, 3072 /* NoComments */ );
            return expression;
        }
        function createDescriptorMethod(original, name, modifiers, asteriskToken, kind, parameters, body) {
            const func = factory2.createFunctionExpression(modifiers, asteriskToken, /*name*/ void 0, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body ?? factory2.createBlock([]));
            setOriginalNode(func, original);
            setSourceMapRange(func, moveRangePastDecorators(original));
            setEmitFlags(func, 3072 /* NoComments */ );
            const prefix = kind === "get" || kind === "set" ? kind : void 0;
            const functionName = factory2.createStringLiteralFromNode(name, /*isSingleQuote*/ void 0);
            const namedFunction = emitHelpers().createSetFunctionNameHelper(func, functionName, prefix);
            const method = factory2.createPropertyAssignment(factory2.createIdentifier(kind), namedFunction);
            setOriginalNode(method, original);
            setSourceMapRange(method, moveRangePastDecorators(original));
            setEmitFlags(method, 3072 /* NoComments */ );
            return method;
        }
        function createMethodDescriptorObject(node, modifiers) {
            return factory2.createObjectLiteralExpression([
                createDescriptorMethod(node, node.name, modifiers, node.asteriskToken, "value", visitNodes2(node.parameters, visitor, isParameter), visitNode(node.body, visitor, isBlock))
            ]);
        }
        function createGetAccessorDescriptorObject(node, modifiers) {
            return factory2.createObjectLiteralExpression([
                createDescriptorMethod(node, node.name, modifiers, /*asteriskToken*/ void 0, "get", [], visitNode(node.body, visitor, isBlock))
            ]);
        }
        function createSetAccessorDescriptorObject(node, modifiers) {
            return factory2.createObjectLiteralExpression([
                createDescriptorMethod(node, node.name, modifiers, /*asteriskToken*/ void 0, "set", visitNodes2(node.parameters, visitor, isParameter), visitNode(node.body, visitor, isBlock))
            ]);
        }
        function createAccessorPropertyDescriptorObject(node, modifiers) {
            return factory2.createObjectLiteralExpression([
                createDescriptorMethod(node, node.name, modifiers, /*asteriskToken*/ void 0, "get", [], factory2.createBlock([
                    factory2.createReturnStatement(factory2.createPropertyAccessExpression(factory2.createThis(), factory2.getGeneratedPrivateNameForNode(node.name)))
                ])),
                createDescriptorMethod(node, node.name, modifiers, /*asteriskToken*/ void 0, "set", [
                    factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "value")
                ], factory2.createBlock([
                    factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createThis(), factory2.getGeneratedPrivateNameForNode(node.name)), factory2.createIdentifier("value")))
                ]))
            ]);
        }
        function createMethodDescriptorForwarder(modifiers, name, descriptorName) {
            modifiers = visitNodes2(modifiers, (node)=>isStaticModifier(node) ? node : void 0, isModifier);
            return factory2.createGetAccessorDeclaration(modifiers, name, [], /*type*/ void 0, factory2.createBlock([
                factory2.createReturnStatement(factory2.createPropertyAccessExpression(descriptorName, factory2.createIdentifier("value")))
            ]));
        }
        function createGetAccessorDescriptorForwarder(modifiers, name, descriptorName) {
            modifiers = visitNodes2(modifiers, (node)=>isStaticModifier(node) ? node : void 0, isModifier);
            return factory2.createGetAccessorDeclaration(modifiers, name, [], /*type*/ void 0, factory2.createBlock([
                factory2.createReturnStatement(factory2.createFunctionCallCall(factory2.createPropertyAccessExpression(descriptorName, factory2.createIdentifier("get")), factory2.createThis(), []))
            ]));
        }
        function createSetAccessorDescriptorForwarder(modifiers, name, descriptorName) {
            modifiers = visitNodes2(modifiers, (node)=>isStaticModifier(node) ? node : void 0, isModifier);
            return factory2.createSetAccessorDeclaration(modifiers, name, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "value")
            ], factory2.createBlock([
                factory2.createReturnStatement(factory2.createFunctionCallCall(factory2.createPropertyAccessExpression(descriptorName, factory2.createIdentifier("set")), factory2.createThis(), [
                    factory2.createIdentifier("value")
                ]))
            ]));
        }
        function getAssignedNameOfIdentifier(name, initializer) {
            const originalClass = getOriginalNode(initializer, isClassLike);
            return originalClass && !originalClass.name && hasSyntacticModifier(originalClass, 1024 /* Default */ ) ? factory2.createStringLiteral("default") : factory2.createStringLiteralFromNode(name);
        }
    }
    var init_esDecorators = __esm({
        "src/compiler/transformers/esDecorators.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/es2017.ts
    function transformES2017(context) {
        const { factory: factory2 , getEmitHelperFactory: emitHelpers , resumeLexicalEnvironment: resumeLexicalEnvironment , endLexicalEnvironment: endLexicalEnvironment , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        let enabledSubstitutions;
        let enclosingSuperContainerFlags = 0;
        let enclosingFunctionParameterNames;
        let capturedSuperProperties;
        let hasSuperElementAccess;
        const substitutedSuperAccessors = [];
        let contextFlags = 0 /* None */ ;
        const previousOnEmitNode = context.onEmitNode;
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            setContextFlag(1 /* NonTopLevel */ , false);
            setContextFlag(2 /* HasLexicalThis */ , !isEffectiveStrictModeSourceFile(node, compilerOptions));
            const visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            return visited;
        }
        function setContextFlag(flag, val) {
            contextFlags = val ? contextFlags | flag : contextFlags & ~flag;
        }
        function inContext(flags) {
            return (contextFlags & flags) !== 0;
        }
        function inTopLevelContext() {
            return !inContext(1 /* NonTopLevel */ );
        }
        function inHasLexicalThisContext() {
            return inContext(2 /* HasLexicalThis */ );
        }
        function doWithContext(flags, cb, value1) {
            const contextFlagsToSet = flags & ~contextFlags;
            if (contextFlagsToSet) {
                setContextFlag(contextFlagsToSet, /*val*/ true);
                const result = cb(value1);
                setContextFlag(contextFlagsToSet, /*val*/ false);
                return result;
            }
            return cb(value1);
        }
        function visitDefault(node) {
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            if ((node.transformFlags & 256 /* ContainsES2017 */ ) === 0) return node;
            switch(node.kind){
                case 134 /* AsyncKeyword */ :
                    return void 0;
                case 222 /* AwaitExpression */ :
                    return visitAwaitExpression(node);
                case 173 /* MethodDeclaration */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitMethodDeclaration, node);
                case 261 /* FunctionDeclaration */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitFunctionDeclaration, node);
                case 217 /* FunctionExpression */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitFunctionExpression, node);
                case 218 /* ArrowFunction */ :
                    return doWithContext(1 /* NonTopLevel */ , visitArrowFunction, node);
                case 210 /* PropertyAccessExpression */ :
                    if (capturedSuperProperties && isPropertyAccessExpression(node) && node.expression.kind === 108 /* SuperKeyword */ ) capturedSuperProperties.add(node.name.escapedText);
                    return visitEachChild(node, visitor, context);
                case 211 /* ElementAccessExpression */ :
                    if (capturedSuperProperties && node.expression.kind === 108 /* SuperKeyword */ ) hasSuperElementAccess = true;
                    return visitEachChild(node, visitor, context);
                case 176 /* GetAccessor */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitGetAccessorDeclaration, node);
                case 177 /* SetAccessor */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitSetAccessorDeclaration, node);
                case 175 /* Constructor */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitConstructorDeclaration, node);
                case 262 /* ClassDeclaration */ :
                case 230 /* ClassExpression */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitDefault, node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function asyncBodyVisitor(node) {
            if (isNodeWithPossibleHoistedDeclaration(node)) switch(node.kind){
                case 242 /* VariableStatement */ :
                    return visitVariableStatementInAsyncBody(node);
                case 247 /* ForStatement */ :
                    return visitForStatementInAsyncBody(node);
                case 248 /* ForInStatement */ :
                    return visitForInStatementInAsyncBody(node);
                case 249 /* ForOfStatement */ :
                    return visitForOfStatementInAsyncBody(node);
                case 298 /* CatchClause */ :
                    return visitCatchClauseInAsyncBody(node);
                case 240 /* Block */ :
                case 254 /* SwitchStatement */ :
                case 268 /* CaseBlock */ :
                case 295 /* CaseClause */ :
                case 296 /* DefaultClause */ :
                case 257 /* TryStatement */ :
                case 245 /* DoStatement */ :
                case 246 /* WhileStatement */ :
                case 244 /* IfStatement */ :
                case 253 /* WithStatement */ :
                case 255 /* LabeledStatement */ :
                    return visitEachChild(node, asyncBodyVisitor, context);
                default:
                    return Debug.assertNever(node, "Unhandled node.");
            }
            return visitor(node);
        }
        function visitCatchClauseInAsyncBody(node) {
            const catchClauseNames = /* @__PURE__ */ new Set();
            recordDeclarationName(node.variableDeclaration, catchClauseNames);
            let catchClauseUnshadowedNames;
            catchClauseNames.forEach((_, escapedName)=>{
                if (enclosingFunctionParameterNames.has(escapedName)) {
                    if (!catchClauseUnshadowedNames) catchClauseUnshadowedNames = new Set(enclosingFunctionParameterNames);
                    catchClauseUnshadowedNames.delete(escapedName);
                }
            });
            if (catchClauseUnshadowedNames) {
                const savedEnclosingFunctionParameterNames = enclosingFunctionParameterNames;
                enclosingFunctionParameterNames = catchClauseUnshadowedNames;
                const result = visitEachChild(node, asyncBodyVisitor, context);
                enclosingFunctionParameterNames = savedEnclosingFunctionParameterNames;
                return result;
            } else return visitEachChild(node, asyncBodyVisitor, context);
        }
        function visitVariableStatementInAsyncBody(node) {
            if (isVariableDeclarationListWithCollidingName(node.declarationList)) {
                const expression = visitVariableDeclarationListWithCollidingNames(node.declarationList, /*hasReceiver*/ false);
                return expression ? factory2.createExpressionStatement(expression) : void 0;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitForInStatementInAsyncBody(node) {
            return factory2.updateForInStatement(node, isVariableDeclarationListWithCollidingName(node.initializer) ? visitVariableDeclarationListWithCollidingNames(node.initializer, /*hasReceiver*/ true) : Debug.checkDefined(visitNode(node.initializer, visitor, isForInitializer)), Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), visitIterationBody(node.statement, asyncBodyVisitor, context));
        }
        function visitForOfStatementInAsyncBody(node) {
            return factory2.updateForOfStatement(node, visitNode(node.awaitModifier, visitor, isAwaitKeyword), isVariableDeclarationListWithCollidingName(node.initializer) ? visitVariableDeclarationListWithCollidingNames(node.initializer, /*hasReceiver*/ true) : Debug.checkDefined(visitNode(node.initializer, visitor, isForInitializer)), Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), visitIterationBody(node.statement, asyncBodyVisitor, context));
        }
        function visitForStatementInAsyncBody(node) {
            const initializer = node.initializer;
            return factory2.updateForStatement(node, isVariableDeclarationListWithCollidingName(initializer) ? visitVariableDeclarationListWithCollidingNames(initializer, /*hasReceiver*/ false) : visitNode(node.initializer, visitor, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, visitor, isExpression), visitIterationBody(node.statement, asyncBodyVisitor, context));
        }
        function visitAwaitExpression(node) {
            if (inTopLevelContext()) return visitEachChild(node, visitor, context);
            return setOriginalNode(setTextRange(factory2.createYieldExpression(/*asteriskToken*/ void 0, visitNode(node.expression, visitor, isExpression)), node), node);
        }
        function visitConstructorDeclaration(node) {
            return factory2.updateConstructorDeclaration(node, visitNodes2(node.modifiers, visitor, isModifier), visitParameterList(node.parameters, visitor, context), transformMethodBody(node));
        }
        function visitMethodDeclaration(node) {
            return factory2.updateMethodDeclaration(node, visitNodes2(node.modifiers, visitor, isModifierLike), node.asteriskToken, node.name, /*questionToken*/ void 0, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, getFunctionFlags(node) & 2 /* Async */  ? transformAsyncFunctionBody(node) : transformMethodBody(node));
        }
        function visitGetAccessorDeclaration(node) {
            return factory2.updateGetAccessorDeclaration(node, visitNodes2(node.modifiers, visitor, isModifierLike), node.name, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, transformMethodBody(node));
        }
        function visitSetAccessorDeclaration(node) {
            return factory2.updateSetAccessorDeclaration(node, visitNodes2(node.modifiers, visitor, isModifierLike), node.name, visitParameterList(node.parameters, visitor, context), transformMethodBody(node));
        }
        function visitFunctionDeclaration(node) {
            return factory2.updateFunctionDeclaration(node, visitNodes2(node.modifiers, visitor, isModifierLike), node.asteriskToken, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, getFunctionFlags(node) & 2 /* Async */  ? transformAsyncFunctionBody(node) : visitFunctionBody(node.body, visitor, context));
        }
        function visitFunctionExpression(node) {
            return factory2.updateFunctionExpression(node, visitNodes2(node.modifiers, visitor, isModifier), node.asteriskToken, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, getFunctionFlags(node) & 2 /* Async */  ? transformAsyncFunctionBody(node) : visitFunctionBody(node.body, visitor, context));
        }
        function visitArrowFunction(node) {
            return factory2.updateArrowFunction(node, visitNodes2(node.modifiers, visitor, isModifier), /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, node.equalsGreaterThanToken, getFunctionFlags(node) & 2 /* Async */  ? transformAsyncFunctionBody(node) : visitFunctionBody(node.body, visitor, context));
        }
        function recordDeclarationName({ name: name  }, names) {
            if (isIdentifier(name)) names.add(name.escapedText);
            else {
                for (const element of name.elements)if (!isOmittedExpression(element)) recordDeclarationName(element, names);
            }
        }
        function isVariableDeclarationListWithCollidingName(node) {
            return !!node && isVariableDeclarationList(node) && !(node.flags & 3 /* BlockScoped */ ) && node.declarations.some(collidesWithParameterName);
        }
        function visitVariableDeclarationListWithCollidingNames(node, hasReceiver) {
            hoistVariableDeclarationList(node);
            const variables = getInitializedVariables(node);
            if (variables.length === 0) {
                if (hasReceiver) return visitNode(factory2.converters.convertToAssignmentElementTarget(node.declarations[0].name), visitor, isExpression);
                return void 0;
            }
            return factory2.inlineExpressions(map(variables, transformInitializedVariable));
        }
        function hoistVariableDeclarationList(node) {
            forEach(node.declarations, hoistVariable);
        }
        function hoistVariable({ name: name  }) {
            if (isIdentifier(name)) hoistVariableDeclaration(name);
            else {
                for (const element of name.elements)if (!isOmittedExpression(element)) hoistVariable(element);
            }
        }
        function transformInitializedVariable(node) {
            const converted = setSourceMapRange(factory2.createAssignment(factory2.converters.convertToAssignmentElementTarget(node.name), node.initializer), node);
            return Debug.checkDefined(visitNode(converted, visitor, isExpression));
        }
        function collidesWithParameterName({ name: name  }) {
            if (isIdentifier(name)) return enclosingFunctionParameterNames.has(name.escapedText);
            else for (const element of name.elements){
                if (!isOmittedExpression(element) && collidesWithParameterName(element)) return true;
            }
            return false;
        }
        function transformMethodBody(node) {
            Debug.assertIsDefined(node.body);
            const savedCapturedSuperProperties = capturedSuperProperties;
            const savedHasSuperElementAccess = hasSuperElementAccess;
            capturedSuperProperties = /* @__PURE__ */ new Set();
            hasSuperElementAccess = false;
            let updated = visitFunctionBody(node.body, visitor, context);
            const originalMethod = getOriginalNode(node, isFunctionLikeDeclaration);
            const emitSuperHelpers = languageVersion >= 2 /* ES2015 */  && resolver.getNodeCheckFlags(node) & 384 /* MethodWithSuperPropertyAccessInAsync */  && (getFunctionFlags(originalMethod) & 3 /* AsyncGenerator */ ) !== 3 /* AsyncGenerator */ ;
            if (emitSuperHelpers) {
                enableSubstitutionForAsyncMethodsWithSuper();
                if (capturedSuperProperties.size) {
                    const variableStatement = createSuperAccessVariableStatement(factory2, resolver, node, capturedSuperProperties);
                    substitutedSuperAccessors[getNodeId(variableStatement)] = true;
                    const statements = updated.statements.slice();
                    insertStatementsAfterStandardPrologue(statements, [
                        variableStatement
                    ]);
                    updated = factory2.updateBlock(updated, statements);
                }
                if (hasSuperElementAccess) {
                    if (resolver.getNodeCheckFlags(node) & 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) addEmitHelper(updated, advancedAsyncSuperHelper);
                    else if (resolver.getNodeCheckFlags(node) & 128 /* MethodWithSuperPropertyAccessInAsync */ ) addEmitHelper(updated, asyncSuperHelper);
                }
            }
            capturedSuperProperties = savedCapturedSuperProperties;
            hasSuperElementAccess = savedHasSuperElementAccess;
            return updated;
        }
        function transformAsyncFunctionBody(node) {
            resumeLexicalEnvironment();
            const original = getOriginalNode(node, isFunctionLike);
            const nodeType = original.type;
            const promiseConstructor = languageVersion < 2 /* ES2015 */  ? getPromiseConstructor(nodeType) : void 0;
            const isArrowFunction2 = node.kind === 218 /* ArrowFunction */ ;
            const hasLexicalArguments = (resolver.getNodeCheckFlags(node) & 512 /* CaptureArguments */ ) !== 0;
            const savedEnclosingFunctionParameterNames = enclosingFunctionParameterNames;
            enclosingFunctionParameterNames = /* @__PURE__ */ new Set();
            for (const parameter of node.parameters)recordDeclarationName(parameter, enclosingFunctionParameterNames);
            const savedCapturedSuperProperties = capturedSuperProperties;
            const savedHasSuperElementAccess = hasSuperElementAccess;
            if (!isArrowFunction2) {
                capturedSuperProperties = /* @__PURE__ */ new Set();
                hasSuperElementAccess = false;
            }
            let result;
            if (!isArrowFunction2) {
                const statements = [];
                const statementOffset = factory2.copyPrologue(node.body.statements, statements, /*ensureUseStrict*/ false, visitor);
                statements.push(factory2.createReturnStatement(emitHelpers().createAwaiterHelper(inHasLexicalThisContext(), hasLexicalArguments, promiseConstructor, transformAsyncFunctionBodyWorker(node.body, statementOffset))));
                insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
                const emitSuperHelpers = languageVersion >= 2 /* ES2015 */  && resolver.getNodeCheckFlags(node) & 384 /* MethodWithSuperPropertyAccessInAsync */ ;
                if (emitSuperHelpers) {
                    enableSubstitutionForAsyncMethodsWithSuper();
                    if (capturedSuperProperties.size) {
                        const variableStatement = createSuperAccessVariableStatement(factory2, resolver, node, capturedSuperProperties);
                        substitutedSuperAccessors[getNodeId(variableStatement)] = true;
                        insertStatementsAfterStandardPrologue(statements, [
                            variableStatement
                        ]);
                    }
                }
                const block = factory2.createBlock(statements, /*multiLine*/ true);
                setTextRange(block, node.body);
                if (emitSuperHelpers && hasSuperElementAccess) {
                    if (resolver.getNodeCheckFlags(node) & 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) addEmitHelper(block, advancedAsyncSuperHelper);
                    else if (resolver.getNodeCheckFlags(node) & 128 /* MethodWithSuperPropertyAccessInAsync */ ) addEmitHelper(block, asyncSuperHelper);
                }
                result = block;
            } else {
                const expression = emitHelpers().createAwaiterHelper(inHasLexicalThisContext(), hasLexicalArguments, promiseConstructor, transformAsyncFunctionBodyWorker(node.body));
                const declarations = endLexicalEnvironment();
                if (some(declarations)) {
                    const block = factory2.converters.convertToFunctionBlock(expression);
                    result = factory2.updateBlock(block, setTextRange(factory2.createNodeArray(concatenate(declarations, block.statements)), block.statements));
                } else result = expression;
            }
            enclosingFunctionParameterNames = savedEnclosingFunctionParameterNames;
            if (!isArrowFunction2) {
                capturedSuperProperties = savedCapturedSuperProperties;
                hasSuperElementAccess = savedHasSuperElementAccess;
            }
            return result;
        }
        function transformAsyncFunctionBodyWorker(body, start) {
            if (isBlock(body)) return factory2.updateBlock(body, visitNodes2(body.statements, asyncBodyVisitor, isStatement, start));
            else return factory2.converters.convertToFunctionBlock(Debug.checkDefined(visitNode(body, asyncBodyVisitor, isConciseBody)));
        }
        function getPromiseConstructor(type) {
            const typeName = type && getEntityNameFromTypeNode(type);
            if (typeName && isEntityName(typeName)) {
                const serializationKind = resolver.getTypeReferenceSerializationKind(typeName);
                if (serializationKind === 1 /* TypeWithConstructSignatureAndValue */  || serializationKind === 0 /* Unknown */ ) return typeName;
            }
            return void 0;
        }
        function enableSubstitutionForAsyncMethodsWithSuper() {
            if ((enabledSubstitutions & 1 /* AsyncMethodsWithSuper */ ) === 0) {
                enabledSubstitutions |= 1 /* AsyncMethodsWithSuper */ ;
                context.enableSubstitution(212 /* CallExpression */ );
                context.enableSubstitution(210 /* PropertyAccessExpression */ );
                context.enableSubstitution(211 /* ElementAccessExpression */ );
                context.enableEmitNotification(262 /* ClassDeclaration */ );
                context.enableEmitNotification(173 /* MethodDeclaration */ );
                context.enableEmitNotification(176 /* GetAccessor */ );
                context.enableEmitNotification(177 /* SetAccessor */ );
                context.enableEmitNotification(175 /* Constructor */ );
                context.enableEmitNotification(242 /* VariableStatement */ );
            }
        }
        function onEmitNode(hint, node, emitCallback) {
            if (enabledSubstitutions & 1 /* AsyncMethodsWithSuper */  && isSuperContainer(node)) {
                const superContainerFlags = resolver.getNodeCheckFlags(node) & 384 /* MethodWithSuperPropertyAssignmentInAsync */ ;
                if (superContainerFlags !== enclosingSuperContainerFlags) {
                    const savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
                    enclosingSuperContainerFlags = superContainerFlags;
                    previousOnEmitNode(hint, node, emitCallback);
                    enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
                    return;
                }
            } else if (enabledSubstitutions && substitutedSuperAccessors[getNodeId(node)]) {
                const savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
                enclosingSuperContainerFlags = 0;
                previousOnEmitNode(hint, node, emitCallback);
                enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
                return;
            }
            previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */  && enclosingSuperContainerFlags) return substituteExpression(node);
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 210 /* PropertyAccessExpression */ :
                    return substitutePropertyAccessExpression(node);
                case 211 /* ElementAccessExpression */ :
                    return substituteElementAccessExpression(node);
                case 212 /* CallExpression */ :
                    return substituteCallExpression(node);
            }
            return node;
        }
        function substitutePropertyAccessExpression(node) {
            if (node.expression.kind === 108 /* SuperKeyword */ ) return setTextRange(factory2.createPropertyAccessExpression(factory2.createUniqueName("_super", 48 /* FileLevel */ ), node.name), node);
            return node;
        }
        function substituteElementAccessExpression(node) {
            if (node.expression.kind === 108 /* SuperKeyword */ ) return createSuperElementAccessInAsyncMethod(node.argumentExpression, node);
            return node;
        }
        function substituteCallExpression(node) {
            const expression = node.expression;
            if (isSuperProperty(expression)) {
                const argumentExpression = isPropertyAccessExpression(expression) ? substitutePropertyAccessExpression(expression) : substituteElementAccessExpression(expression);
                return factory2.createCallExpression(factory2.createPropertyAccessExpression(argumentExpression, "call"), /*typeArguments*/ void 0, [
                    factory2.createThis(),
                    ...node.arguments
                ]);
            }
            return node;
        }
        function isSuperContainer(node) {
            const kind = node.kind;
            return kind === 262 /* ClassDeclaration */  || kind === 175 /* Constructor */  || kind === 173 /* MethodDeclaration */  || kind === 176 /* GetAccessor */  || kind === 177 /* SetAccessor */ ;
        }
        function createSuperElementAccessInAsyncMethod(argumentExpression, location) {
            if (enclosingSuperContainerFlags & 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) return setTextRange(factory2.createPropertyAccessExpression(factory2.createCallExpression(factory2.createUniqueName("_superIndex", 48 /* FileLevel */ ), /*typeArguments*/ void 0, [
                argumentExpression
            ]), "value"), location);
            else return setTextRange(factory2.createCallExpression(factory2.createUniqueName("_superIndex", 48 /* FileLevel */ ), /*typeArguments*/ void 0, [
                argumentExpression
            ]), location);
        }
    }
    function createSuperAccessVariableStatement(factory2, resolver, node, names) {
        const hasBinding = (resolver.getNodeCheckFlags(node) & 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) !== 0;
        const accessors = [];
        names.forEach((_, key)=>{
            const name = unescapeLeadingUnderscores(key);
            const getterAndSetter = [];
            getterAndSetter.push(factory2.createPropertyAssignment("get", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, /* parameters */ [], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, setEmitFlags(factory2.createPropertyAccessExpression(setEmitFlags(factory2.createSuper(), 8 /* NoSubstitution */ ), name), 8 /* NoSubstitution */ ))));
            if (hasBinding) getterAndSetter.push(factory2.createPropertyAssignment("set", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, /* parameters */ [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "v", /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0)
            ], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, factory2.createAssignment(setEmitFlags(factory2.createPropertyAccessExpression(setEmitFlags(factory2.createSuper(), 8 /* NoSubstitution */ ), name), 8 /* NoSubstitution */ ), factory2.createIdentifier("v")))));
            accessors.push(factory2.createPropertyAssignment(name, factory2.createObjectLiteralExpression(getterAndSetter)));
        });
        return factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
            factory2.createVariableDeclaration(factory2.createUniqueName("_super", 48 /* FileLevel */ ), /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Object"), "create"), /*typeArguments*/ void 0, [
                factory2.createNull(),
                factory2.createObjectLiteralExpression(accessors, /*multiLine*/ true)
            ]))
        ], 2 /* Const */ ));
    }
    var init_es2017 = __esm({
        "src/compiler/transformers/es2017.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/es2018.ts
    function transformES2018(context) {
        const { factory: factory2 , getEmitHelperFactory: emitHelpers , resumeLexicalEnvironment: resumeLexicalEnvironment , endLexicalEnvironment: endLexicalEnvironment , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const previousOnEmitNode = context.onEmitNode;
        context.onEmitNode = onEmitNode;
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onSubstituteNode = onSubstituteNode;
        let exportedVariableStatement = false;
        let enabledSubstitutions;
        let enclosingFunctionFlags;
        let parametersWithPrecedingObjectRestOrSpread;
        let enclosingSuperContainerFlags = 0;
        let hierarchyFacts = 0;
        let currentSourceFile;
        let taggedTemplateStringDeclarations;
        let capturedSuperProperties;
        let hasSuperElementAccess;
        const substitutedSuperAccessors = [];
        return chainBundle(context, transformSourceFile);
        function affectsSubtree(excludeFacts, includeFacts) {
            return hierarchyFacts !== (hierarchyFacts & ~excludeFacts | includeFacts);
        }
        function enterSubtree(excludeFacts, includeFacts) {
            const ancestorFacts = hierarchyFacts;
            hierarchyFacts = (hierarchyFacts & ~excludeFacts | includeFacts) & 3 /* AncestorFactsMask */ ;
            return ancestorFacts;
        }
        function exitSubtree(ancestorFacts) {
            hierarchyFacts = ancestorFacts;
        }
        function recordTaggedTemplateString(temp) {
            taggedTemplateStringDeclarations = append(taggedTemplateStringDeclarations, factory2.createVariableDeclaration(temp));
        }
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            currentSourceFile = node;
            const visited = visitSourceFile(node);
            addEmitHelpers(visited, context.readEmitHelpers());
            currentSourceFile = void 0;
            taggedTemplateStringDeclarations = void 0;
            return visited;
        }
        function visitor(node) {
            return visitorWorker(node, /*expressionResultIsUnused*/ false);
        }
        function visitorWithUnusedExpressionResult(node) {
            return visitorWorker(node, /*expressionResultIsUnused*/ true);
        }
        function visitorNoAsyncModifier(node) {
            if (node.kind === 134 /* AsyncKeyword */ ) return void 0;
            return node;
        }
        function doWithHierarchyFacts(cb, value1, excludeFacts, includeFacts) {
            if (affectsSubtree(excludeFacts, includeFacts)) {
                const ancestorFacts = enterSubtree(excludeFacts, includeFacts);
                const result = cb(value1);
                exitSubtree(ancestorFacts);
                return result;
            }
            return cb(value1);
        }
        function visitDefault(node) {
            return visitEachChild(node, visitor, context);
        }
        function visitorWorker(node, expressionResultIsUnused2) {
            if ((node.transformFlags & 128 /* ContainsES2018 */ ) === 0) return node;
            switch(node.kind){
                case 222 /* AwaitExpression */ :
                    return visitAwaitExpression(node);
                case 228 /* YieldExpression */ :
                    return visitYieldExpression(node);
                case 252 /* ReturnStatement */ :
                    return visitReturnStatement(node);
                case 255 /* LabeledStatement */ :
                    return visitLabeledStatement(node);
                case 209 /* ObjectLiteralExpression */ :
                    return visitObjectLiteralExpression(node);
                case 225 /* BinaryExpression */ :
                    return visitBinaryExpression(node, expressionResultIsUnused2);
                case 360 /* CommaListExpression */ :
                    return visitCommaListExpression(node, expressionResultIsUnused2);
                case 298 /* CatchClause */ :
                    return visitCatchClause(node);
                case 242 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 259 /* VariableDeclaration */ :
                    return visitVariableDeclaration(node);
                case 245 /* DoStatement */ :
                case 246 /* WhileStatement */ :
                case 248 /* ForInStatement */ :
                    return doWithHierarchyFacts(visitDefault, node, 0 /* IterationStatementExcludes */ , 2 /* IterationStatementIncludes */ );
                case 249 /* ForOfStatement */ :
                    return visitForOfStatement(node, /*outermostLabeledStatement*/ void 0);
                case 247 /* ForStatement */ :
                    return doWithHierarchyFacts(visitForStatement, node, 0 /* IterationStatementExcludes */ , 2 /* IterationStatementIncludes */ );
                case 221 /* VoidExpression */ :
                    return visitVoidExpression(node);
                case 175 /* Constructor */ :
                    return doWithHierarchyFacts(visitConstructorDeclaration, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 173 /* MethodDeclaration */ :
                    return doWithHierarchyFacts(visitMethodDeclaration, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 176 /* GetAccessor */ :
                    return doWithHierarchyFacts(visitGetAccessorDeclaration, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 177 /* SetAccessor */ :
                    return doWithHierarchyFacts(visitSetAccessorDeclaration, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 261 /* FunctionDeclaration */ :
                    return doWithHierarchyFacts(visitFunctionDeclaration, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 217 /* FunctionExpression */ :
                    return doWithHierarchyFacts(visitFunctionExpression, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 218 /* ArrowFunction */ :
                    return doWithHierarchyFacts(visitArrowFunction, node, 2 /* ArrowFunctionExcludes */ , 0 /* ArrowFunctionIncludes */ );
                case 168 /* Parameter */ :
                    return visitParameter(node);
                case 243 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 216 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, expressionResultIsUnused2);
                case 214 /* TaggedTemplateExpression */ :
                    return visitTaggedTemplateExpression(node);
                case 210 /* PropertyAccessExpression */ :
                    if (capturedSuperProperties && isPropertyAccessExpression(node) && node.expression.kind === 108 /* SuperKeyword */ ) capturedSuperProperties.add(node.name.escapedText);
                    return visitEachChild(node, visitor, context);
                case 211 /* ElementAccessExpression */ :
                    if (capturedSuperProperties && node.expression.kind === 108 /* SuperKeyword */ ) hasSuperElementAccess = true;
                    return visitEachChild(node, visitor, context);
                case 262 /* ClassDeclaration */ :
                case 230 /* ClassExpression */ :
                    return doWithHierarchyFacts(visitDefault, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitAwaitExpression(node) {
            if (enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */ ) return setOriginalNode(setTextRange(factory2.createYieldExpression(/*asteriskToken*/ void 0, emitHelpers().createAwaitHelper(visitNode(node.expression, visitor, isExpression))), /*location*/ node), node);
            return visitEachChild(node, visitor, context);
        }
        function visitYieldExpression(node) {
            if (enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */ ) {
                if (node.asteriskToken) {
                    const expression = visitNode(Debug.checkDefined(node.expression), visitor, isExpression);
                    return setOriginalNode(setTextRange(factory2.createYieldExpression(/*asteriskToken*/ void 0, emitHelpers().createAwaitHelper(factory2.updateYieldExpression(node, node.asteriskToken, setTextRange(emitHelpers().createAsyncDelegatorHelper(setTextRange(emitHelpers().createAsyncValuesHelper(expression), expression)), expression)))), node), node);
                }
                return setOriginalNode(setTextRange(factory2.createYieldExpression(/*asteriskToken*/ void 0, createDownlevelAwait(node.expression ? visitNode(node.expression, visitor, isExpression) : factory2.createVoidZero())), node), node);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitReturnStatement(node) {
            if (enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */ ) return factory2.updateReturnStatement(node, createDownlevelAwait(node.expression ? visitNode(node.expression, visitor, isExpression) : factory2.createVoidZero()));
            return visitEachChild(node, visitor, context);
        }
        function visitLabeledStatement(node) {
            if (enclosingFunctionFlags & 2 /* Async */ ) {
                const statement = unwrapInnermostStatementOfLabel(node);
                if (statement.kind === 249 /* ForOfStatement */  && statement.awaitModifier) return visitForOfStatement(statement, node);
                return factory2.restoreEnclosingLabel(visitNode(statement, visitor, isStatement, factory2.liftToBlock), node);
            }
            return visitEachChild(node, visitor, context);
        }
        function chunkObjectLiteralElements(elements) {
            let chunkObject;
            const objects = [];
            for (const e of elements)if (e.kind === 304 /* SpreadAssignment */ ) {
                if (chunkObject) {
                    objects.push(factory2.createObjectLiteralExpression(chunkObject));
                    chunkObject = void 0;
                }
                const target = e.expression;
                objects.push(visitNode(target, visitor, isExpression));
            } else chunkObject = append(chunkObject, e.kind === 302 /* PropertyAssignment */  ? factory2.createPropertyAssignment(e.name, visitNode(e.initializer, visitor, isExpression)) : visitNode(e, visitor, isObjectLiteralElementLike));
            if (chunkObject) objects.push(factory2.createObjectLiteralExpression(chunkObject));
            return objects;
        }
        function visitObjectLiteralExpression(node) {
            if (node.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) {
                const objects = chunkObjectLiteralElements(node.properties);
                if (objects.length && objects[0].kind !== 209 /* ObjectLiteralExpression */ ) objects.unshift(factory2.createObjectLiteralExpression());
                let expression = objects[0];
                if (objects.length > 1) {
                    for(let i = 1; i < objects.length; i++)expression = emitHelpers().createAssignHelper([
                        expression,
                        objects[i]
                    ]);
                    return expression;
                } else return emitHelpers().createAssignHelper(objects);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitExpressionStatement(node) {
            return visitEachChild(node, visitorWithUnusedExpressionResult, context);
        }
        function visitParenthesizedExpression(node, expressionResultIsUnused2) {
            return visitEachChild(node, expressionResultIsUnused2 ? visitorWithUnusedExpressionResult : visitor, context);
        }
        function visitSourceFile(node) {
            const ancestorFacts = enterSubtree(2 /* SourceFileExcludes */ , isEffectiveStrictModeSourceFile(node, compilerOptions) ? 0 /* StrictModeSourceFileIncludes */  : 1 /* SourceFileIncludes */ );
            exportedVariableStatement = false;
            const visited = visitEachChild(node, visitor, context);
            const statement = concatenate(visited.statements, taggedTemplateStringDeclarations && [
                factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(taggedTemplateStringDeclarations))
            ]);
            const result = factory2.updateSourceFile(visited, setTextRange(factory2.createNodeArray(statement), node.statements));
            exitSubtree(ancestorFacts);
            return result;
        }
        function visitTaggedTemplateExpression(node) {
            return processTaggedTemplateExpression(context, node, visitor, currentSourceFile, recordTaggedTemplateString, 0 /* LiftRestriction */ );
        }
        function visitBinaryExpression(node, expressionResultIsUnused2) {
            if (isDestructuringAssignment(node) && containsObjectRestOrSpread(node.left)) return flattenDestructuringAssignment(node, visitor, context, 1 /* ObjectRest */ , !expressionResultIsUnused2);
            if (node.operatorToken.kind === 28 /* CommaToken */ ) return factory2.updateBinaryExpression(node, visitNode(node.left, visitorWithUnusedExpressionResult, isExpression), node.operatorToken, visitNode(node.right, expressionResultIsUnused2 ? visitorWithUnusedExpressionResult : visitor, isExpression));
            return visitEachChild(node, visitor, context);
        }
        function visitCommaListExpression(node, expressionResultIsUnused2) {
            if (expressionResultIsUnused2) return visitEachChild(node, visitorWithUnusedExpressionResult, context);
            let result;
            for(let i = 0; i < node.elements.length; i++){
                const element = node.elements[i];
                const visited = visitNode(element, i < node.elements.length - 1 ? visitorWithUnusedExpressionResult : visitor, isExpression);
                if (result || visited !== element) {
                    result || (result = node.elements.slice(0, i));
                    result.push(visited);
                }
            }
            const elements = result ? setTextRange(factory2.createNodeArray(result), node.elements) : node.elements;
            return factory2.updateCommaListExpression(node, elements);
        }
        function visitCatchClause(node) {
            if (node.variableDeclaration && isBindingPattern(node.variableDeclaration.name) && node.variableDeclaration.name.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) {
                const name = factory2.getGeneratedNameForNode(node.variableDeclaration.name);
                const updatedDecl = factory2.updateVariableDeclaration(node.variableDeclaration, node.variableDeclaration.name, /*exclamationToken*/ void 0, /*type*/ void 0, name);
                const visitedBindings = flattenDestructuringBinding(updatedDecl, visitor, context, 1 /* ObjectRest */ );
                let block = visitNode(node.block, visitor, isBlock);
                if (some(visitedBindings)) block = factory2.updateBlock(block, [
                    factory2.createVariableStatement(/*modifiers*/ void 0, visitedBindings),
                    ...block.statements
                ]);
                return factory2.updateCatchClause(node, factory2.updateVariableDeclaration(node.variableDeclaration, name, /*exclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0), block);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitVariableStatement(node) {
            if (hasSyntacticModifier(node, 1 /* Export */ )) {
                const savedExportedVariableStatement = exportedVariableStatement;
                exportedVariableStatement = true;
                const visited = visitEachChild(node, visitor, context);
                exportedVariableStatement = savedExportedVariableStatement;
                return visited;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitVariableDeclaration(node) {
            if (exportedVariableStatement) {
                const savedExportedVariableStatement = exportedVariableStatement;
                exportedVariableStatement = false;
                const visited = visitVariableDeclarationWorker(node, /*exportedVariableStatement*/ true);
                exportedVariableStatement = savedExportedVariableStatement;
                return visited;
            }
            return visitVariableDeclarationWorker(node, /*exportedVariableStatement*/ false);
        }
        function visitVariableDeclarationWorker(node, exportedVariableStatement2) {
            if (isBindingPattern(node.name) && node.name.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) return flattenDestructuringBinding(node, visitor, context, 1 /* ObjectRest */ , /*rval*/ void 0, exportedVariableStatement2);
            return visitEachChild(node, visitor, context);
        }
        function visitForStatement(node) {
            return factory2.updateForStatement(node, visitNode(node.initializer, visitorWithUnusedExpressionResult, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, visitorWithUnusedExpressionResult, isExpression), visitIterationBody(node.statement, visitor, context));
        }
        function visitVoidExpression(node) {
            return visitEachChild(node, visitorWithUnusedExpressionResult, context);
        }
        function visitForOfStatement(node, outermostLabeledStatement) {
            const ancestorFacts = enterSubtree(0 /* IterationStatementExcludes */ , 2 /* IterationStatementIncludes */ );
            if (node.initializer.transformFlags & 65536 /* ContainsObjectRestOrSpread */  || isAssignmentPattern(node.initializer) && containsObjectRestOrSpread(node.initializer)) node = transformForOfStatementWithObjectRest(node);
            const result = node.awaitModifier ? transformForAwaitOfStatement(node, outermostLabeledStatement, ancestorFacts) : factory2.restoreEnclosingLabel(visitEachChild(node, visitor, context), outermostLabeledStatement);
            exitSubtree(ancestorFacts);
            return result;
        }
        function transformForOfStatementWithObjectRest(node) {
            const initializerWithoutParens = skipParentheses(node.initializer);
            if (isVariableDeclarationList(initializerWithoutParens) || isAssignmentPattern(initializerWithoutParens)) {
                let bodyLocation;
                let statementsLocation;
                const temp = factory2.createTempVariable(/*recordTempVariable*/ void 0);
                const statements = [
                    createForOfBindingStatement(factory2, initializerWithoutParens, temp)
                ];
                if (isBlock(node.statement)) {
                    addRange(statements, node.statement.statements);
                    bodyLocation = node.statement;
                    statementsLocation = node.statement.statements;
                } else if (node.statement) {
                    append(statements, node.statement);
                    bodyLocation = node.statement;
                    statementsLocation = node.statement;
                }
                return factory2.updateForOfStatement(node, node.awaitModifier, setTextRange(factory2.createVariableDeclarationList([
                    setTextRange(factory2.createVariableDeclaration(temp), node.initializer)
                ], 1 /* Let */ ), node.initializer), node.expression, setTextRange(factory2.createBlock(setTextRange(factory2.createNodeArray(statements), statementsLocation), /*multiLine*/ true), bodyLocation));
            }
            return node;
        }
        function convertForOfStatementHead(node, boundValue, nonUserCode) {
            const value1 = factory2.createTempVariable(hoistVariableDeclaration);
            const iteratorValueExpression = factory2.createAssignment(value1, boundValue);
            const iteratorValueStatement = factory2.createExpressionStatement(iteratorValueExpression);
            setSourceMapRange(iteratorValueStatement, node.expression);
            const exitNonUserCodeExpression = factory2.createAssignment(nonUserCode, factory2.createFalse());
            const exitNonUserCodeStatement = factory2.createExpressionStatement(exitNonUserCodeExpression);
            setSourceMapRange(exitNonUserCodeStatement, node.expression);
            const statements = [
                iteratorValueStatement,
                exitNonUserCodeStatement
            ];
            const binding = createForOfBindingStatement(factory2, node.initializer, value1);
            statements.push(visitNode(binding, visitor, isStatement));
            let bodyLocation;
            let statementsLocation;
            const statement = visitIterationBody(node.statement, visitor, context);
            if (isBlock(statement)) {
                addRange(statements, statement.statements);
                bodyLocation = statement;
                statementsLocation = statement.statements;
            } else statements.push(statement);
            return setTextRange(factory2.createBlock(setTextRange(factory2.createNodeArray(statements), statementsLocation), /*multiLine*/ true), bodyLocation);
        }
        function createDownlevelAwait(expression) {
            return enclosingFunctionFlags & 1 /* Generator */  ? factory2.createYieldExpression(/*asteriskToken*/ void 0, emitHelpers().createAwaitHelper(expression)) : factory2.createAwaitExpression(expression);
        }
        function transformForAwaitOfStatement(node, outermostLabeledStatement, ancestorFacts) {
            const expression = visitNode(node.expression, visitor, isExpression);
            const iterator = isIdentifier(expression) ? factory2.getGeneratedNameForNode(expression) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const result = isIdentifier(expression) ? factory2.getGeneratedNameForNode(iterator) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const nonUserCode = factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const done = factory2.createTempVariable(hoistVariableDeclaration);
            const errorRecord = factory2.createUniqueName("e");
            const catchVariable = factory2.getGeneratedNameForNode(errorRecord);
            const returnMethod = factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const callValues = setTextRange(emitHelpers().createAsyncValuesHelper(expression), node.expression);
            const callNext = factory2.createCallExpression(factory2.createPropertyAccessExpression(iterator, "next"), /*typeArguments*/ void 0, []);
            const getDone = factory2.createPropertyAccessExpression(result, "done");
            const getValue = factory2.createPropertyAccessExpression(result, "value");
            const callReturn = factory2.createFunctionCallCall(returnMethod, iterator, []);
            hoistVariableDeclaration(errorRecord);
            hoistVariableDeclaration(returnMethod);
            const initializer = ancestorFacts & 2 /* IterationContainer */  ? factory2.inlineExpressions([
                factory2.createAssignment(errorRecord, factory2.createVoidZero()),
                callValues
            ]) : callValues;
            const forStatement = setEmitFlags(setTextRange(factory2.createForStatement(/*initializer*/ setEmitFlags(setTextRange(factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(nonUserCode, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createTrue()),
                setTextRange(factory2.createVariableDeclaration(iterator, /*exclamationToken*/ void 0, /*type*/ void 0, initializer), node.expression),
                factory2.createVariableDeclaration(result)
            ]), node.expression), 4194304 /* NoHoisting */ ), /*condition*/ factory2.inlineExpressions([
                factory2.createAssignment(result, createDownlevelAwait(callNext)),
                factory2.createAssignment(done, getDone),
                factory2.createLogicalNot(done)
            ]), /*incrementor*/ factory2.createAssignment(nonUserCode, factory2.createTrue()), /*statement*/ convertForOfStatementHead(node, getValue, nonUserCode)), /*location*/ node), 512 /* NoTokenTrailingSourceMaps */ );
            setOriginalNode(forStatement, node);
            return factory2.createTryStatement(factory2.createBlock([
                factory2.restoreEnclosingLabel(forStatement, outermostLabeledStatement)
            ]), factory2.createCatchClause(factory2.createVariableDeclaration(catchVariable), setEmitFlags(factory2.createBlock([
                factory2.createExpressionStatement(factory2.createAssignment(errorRecord, factory2.createObjectLiteralExpression([
                    factory2.createPropertyAssignment("error", catchVariable)
                ])))
            ]), 1 /* SingleLine */ )), factory2.createBlock([
                factory2.createTryStatement(/*tryBlock*/ factory2.createBlock([
                    setEmitFlags(factory2.createIfStatement(factory2.createLogicalAnd(factory2.createLogicalAnd(factory2.createLogicalNot(nonUserCode), factory2.createLogicalNot(done)), factory2.createAssignment(returnMethod, factory2.createPropertyAccessExpression(iterator, "return"))), factory2.createExpressionStatement(createDownlevelAwait(callReturn))), 1 /* SingleLine */ )
                ]), /*catchClause*/ void 0, /*finallyBlock*/ setEmitFlags(factory2.createBlock([
                    setEmitFlags(factory2.createIfStatement(errorRecord, factory2.createThrowStatement(factory2.createPropertyAccessExpression(errorRecord, "error"))), 1 /* SingleLine */ )
                ]), 1 /* SingleLine */ ))
            ]));
        }
        function parameterVisitor(node) {
            Debug.assertNode(node, isParameter);
            return visitParameter(node);
        }
        function visitParameter(node) {
            if (parametersWithPrecedingObjectRestOrSpread == null ? void 0 : parametersWithPrecedingObjectRestOrSpread.has(node)) return factory2.updateParameterDeclaration(node, /*modifiers*/ void 0, node.dotDotDotToken, isBindingPattern(node.name) ? factory2.getGeneratedNameForNode(node) : node.name, /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
            if (node.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) return factory2.updateParameterDeclaration(node, /*modifiers*/ void 0, node.dotDotDotToken, factory2.getGeneratedNameForNode(node), /*questionToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
            return visitEachChild(node, visitor, context);
        }
        function collectParametersWithPrecedingObjectRestOrSpread(node) {
            let parameters;
            for (const parameter of node.parameters){
                if (parameters) parameters.add(parameter);
                else if (parameter.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) parameters = /* @__PURE__ */ new Set();
            }
            return parameters;
        }
        function visitConstructorDeclaration(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateConstructorDeclaration(node, node.modifiers, visitParameterList(node.parameters, parameterVisitor, context), transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitGetAccessorDeclaration(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateGetAccessorDeclaration(node, node.modifiers, visitNode(node.name, visitor, isPropertyName), visitParameterList(node.parameters, parameterVisitor, context), /*type*/ void 0, transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitSetAccessorDeclaration(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateSetAccessorDeclaration(node, node.modifiers, visitNode(node.name, visitor, isPropertyName), visitParameterList(node.parameters, parameterVisitor, context), transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitMethodDeclaration(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateMethodDeclaration(node, enclosingFunctionFlags & 1 /* Generator */  ? visitNodes2(node.modifiers, visitorNoAsyncModifier, isModifierLike) : node.modifiers, enclosingFunctionFlags & 2 /* Async */  ? void 0 : node.asteriskToken, visitNode(node.name, visitor, isPropertyName), visitNode(/*node*/ void 0, visitor, isQuestionToken), /*typeParameters*/ void 0, visitParameterList(node.parameters, parameterVisitor, context), /*type*/ void 0, enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */  ? transformAsyncGeneratorFunctionBody(node) : transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitFunctionDeclaration(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateFunctionDeclaration(node, enclosingFunctionFlags & 1 /* Generator */  ? visitNodes2(node.modifiers, visitorNoAsyncModifier, isModifier) : node.modifiers, enclosingFunctionFlags & 2 /* Async */  ? void 0 : node.asteriskToken, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, parameterVisitor, context), /*type*/ void 0, enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */  ? transformAsyncGeneratorFunctionBody(node) : transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitArrowFunction(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateArrowFunction(node, node.modifiers, /*typeParameters*/ void 0, visitParameterList(node.parameters, parameterVisitor, context), /*type*/ void 0, node.equalsGreaterThanToken, transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitFunctionExpression(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateFunctionExpression(node, enclosingFunctionFlags & 1 /* Generator */  ? visitNodes2(node.modifiers, visitorNoAsyncModifier, isModifier) : node.modifiers, enclosingFunctionFlags & 2 /* Async */  ? void 0 : node.asteriskToken, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, parameterVisitor, context), /*type*/ void 0, enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */  ? transformAsyncGeneratorFunctionBody(node) : transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function transformAsyncGeneratorFunctionBody(node) {
            resumeLexicalEnvironment();
            const statements = [];
            const statementOffset = factory2.copyPrologue(node.body.statements, statements, /*ensureUseStrict*/ false, visitor);
            appendObjectRestAssignmentsIfNeeded(statements, node);
            const savedCapturedSuperProperties = capturedSuperProperties;
            const savedHasSuperElementAccess = hasSuperElementAccess;
            capturedSuperProperties = /* @__PURE__ */ new Set();
            hasSuperElementAccess = false;
            const returnStatement = factory2.createReturnStatement(emitHelpers().createAsyncGeneratorHelper(factory2.createFunctionExpression(/*modifiers*/ void 0, factory2.createToken(42 /* AsteriskToken */ ), node.name && factory2.getGeneratedNameForNode(node.name), /*typeParameters*/ void 0, /*parameters*/ [], /*type*/ void 0, factory2.updateBlock(node.body, visitLexicalEnvironment(node.body.statements, visitor, context, statementOffset))), !!(hierarchyFacts & 1 /* HasLexicalThis */ )));
            const emitSuperHelpers = languageVersion >= 2 /* ES2015 */  && resolver.getNodeCheckFlags(node) & 384 /* MethodWithSuperPropertyAccessInAsync */ ;
            if (emitSuperHelpers) {
                enableSubstitutionForAsyncMethodsWithSuper();
                const variableStatement = createSuperAccessVariableStatement(factory2, resolver, node, capturedSuperProperties);
                substitutedSuperAccessors[getNodeId(variableStatement)] = true;
                insertStatementsAfterStandardPrologue(statements, [
                    variableStatement
                ]);
            }
            statements.push(returnStatement);
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            const block = factory2.updateBlock(node.body, statements);
            if (emitSuperHelpers && hasSuperElementAccess) {
                if (resolver.getNodeCheckFlags(node) & 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) addEmitHelper(block, advancedAsyncSuperHelper);
                else if (resolver.getNodeCheckFlags(node) & 128 /* MethodWithSuperPropertyAccessInAsync */ ) addEmitHelper(block, asyncSuperHelper);
            }
            capturedSuperProperties = savedCapturedSuperProperties;
            hasSuperElementAccess = savedHasSuperElementAccess;
            return block;
        }
        function transformFunctionBody2(node) {
            resumeLexicalEnvironment();
            let statementOffset = 0;
            const statements = [];
            const body = visitNode(node.body, visitor, isConciseBody) ?? factory2.createBlock([]);
            if (isBlock(body)) statementOffset = factory2.copyPrologue(body.statements, statements, /*ensureUseStrict*/ false, visitor);
            addRange(statements, appendObjectRestAssignmentsIfNeeded(/*statements*/ void 0, node));
            const leadingStatements = endLexicalEnvironment();
            if (statementOffset > 0 || some(statements) || some(leadingStatements)) {
                const block = factory2.converters.convertToFunctionBlock(body, /*multiLine*/ true);
                insertStatementsAfterStandardPrologue(statements, leadingStatements);
                addRange(statements, block.statements.slice(statementOffset));
                return factory2.updateBlock(block, setTextRange(factory2.createNodeArray(statements), block.statements));
            }
            return body;
        }
        function appendObjectRestAssignmentsIfNeeded(statements, node) {
            let containsPrecedingObjectRestOrSpread = false;
            for (const parameter of node.parameters){
                if (containsPrecedingObjectRestOrSpread) {
                    if (isBindingPattern(parameter.name)) {
                        if (parameter.name.elements.length > 0) {
                            const declarations = flattenDestructuringBinding(parameter, visitor, context, 0 /* All */ , factory2.getGeneratedNameForNode(parameter));
                            if (some(declarations)) {
                                const declarationList = factory2.createVariableDeclarationList(declarations);
                                const statement = factory2.createVariableStatement(/*modifiers*/ void 0, declarationList);
                                setEmitFlags(statement, 2097152 /* CustomPrologue */ );
                                statements = append(statements, statement);
                            }
                        } else if (parameter.initializer) {
                            const name = factory2.getGeneratedNameForNode(parameter);
                            const initializer = visitNode(parameter.initializer, visitor, isExpression);
                            const assignment = factory2.createAssignment(name, initializer);
                            const statement = factory2.createExpressionStatement(assignment);
                            setEmitFlags(statement, 2097152 /* CustomPrologue */ );
                            statements = append(statements, statement);
                        }
                    } else if (parameter.initializer) {
                        const name = factory2.cloneNode(parameter.name);
                        setTextRange(name, parameter.name);
                        setEmitFlags(name, 96 /* NoSourceMap */ );
                        const initializer = visitNode(parameter.initializer, visitor, isExpression);
                        addEmitFlags(initializer, 3168 /* NoComments */ );
                        const assignment = factory2.createAssignment(name, initializer);
                        setTextRange(assignment, parameter);
                        setEmitFlags(assignment, 3072 /* NoComments */ );
                        const block = factory2.createBlock([
                            factory2.createExpressionStatement(assignment)
                        ]);
                        setTextRange(block, parameter);
                        setEmitFlags(block, 3905 /* NoComments */ );
                        const typeCheck = factory2.createTypeCheck(factory2.cloneNode(parameter.name), "undefined");
                        const statement = factory2.createIfStatement(typeCheck, block);
                        startOnNewLine(statement);
                        setTextRange(statement, parameter);
                        setEmitFlags(statement, 2101056 /* NoComments */ );
                        statements = append(statements, statement);
                    }
                } else if (parameter.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) {
                    containsPrecedingObjectRestOrSpread = true;
                    const declarations = flattenDestructuringBinding(parameter, visitor, context, 1 /* ObjectRest */ , factory2.getGeneratedNameForNode(parameter), /*hoistTempVariables*/ false, /*skipInitializer*/ true);
                    if (some(declarations)) {
                        const declarationList = factory2.createVariableDeclarationList(declarations);
                        const statement = factory2.createVariableStatement(/*modifiers*/ void 0, declarationList);
                        setEmitFlags(statement, 2097152 /* CustomPrologue */ );
                        statements = append(statements, statement);
                    }
                }
            }
            return statements;
        }
        function enableSubstitutionForAsyncMethodsWithSuper() {
            if ((enabledSubstitutions & 1 /* AsyncMethodsWithSuper */ ) === 0) {
                enabledSubstitutions |= 1 /* AsyncMethodsWithSuper */ ;
                context.enableSubstitution(212 /* CallExpression */ );
                context.enableSubstitution(210 /* PropertyAccessExpression */ );
                context.enableSubstitution(211 /* ElementAccessExpression */ );
                context.enableEmitNotification(262 /* ClassDeclaration */ );
                context.enableEmitNotification(173 /* MethodDeclaration */ );
                context.enableEmitNotification(176 /* GetAccessor */ );
                context.enableEmitNotification(177 /* SetAccessor */ );
                context.enableEmitNotification(175 /* Constructor */ );
                context.enableEmitNotification(242 /* VariableStatement */ );
            }
        }
        function onEmitNode(hint, node, emitCallback) {
            if (enabledSubstitutions & 1 /* AsyncMethodsWithSuper */  && isSuperContainer(node)) {
                const superContainerFlags = resolver.getNodeCheckFlags(node) & 384 /* MethodWithSuperPropertyAssignmentInAsync */ ;
                if (superContainerFlags !== enclosingSuperContainerFlags) {
                    const savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
                    enclosingSuperContainerFlags = superContainerFlags;
                    previousOnEmitNode(hint, node, emitCallback);
                    enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
                    return;
                }
            } else if (enabledSubstitutions && substitutedSuperAccessors[getNodeId(node)]) {
                const savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
                enclosingSuperContainerFlags = 0;
                previousOnEmitNode(hint, node, emitCallback);
                enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
                return;
            }
            previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */  && enclosingSuperContainerFlags) return substituteExpression(node);
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 210 /* PropertyAccessExpression */ :
                    return substitutePropertyAccessExpression(node);
                case 211 /* ElementAccessExpression */ :
                    return substituteElementAccessExpression(node);
                case 212 /* CallExpression */ :
                    return substituteCallExpression(node);
            }
            return node;
        }
        function substitutePropertyAccessExpression(node) {
            if (node.expression.kind === 108 /* SuperKeyword */ ) return setTextRange(factory2.createPropertyAccessExpression(factory2.createUniqueName("_super", 48 /* FileLevel */ ), node.name), node);
            return node;
        }
        function substituteElementAccessExpression(node) {
            if (node.expression.kind === 108 /* SuperKeyword */ ) return createSuperElementAccessInAsyncMethod(node.argumentExpression, node);
            return node;
        }
        function substituteCallExpression(node) {
            const expression = node.expression;
            if (isSuperProperty(expression)) {
                const argumentExpression = isPropertyAccessExpression(expression) ? substitutePropertyAccessExpression(expression) : substituteElementAccessExpression(expression);
                return factory2.createCallExpression(factory2.createPropertyAccessExpression(argumentExpression, "call"), /*typeArguments*/ void 0, [
                    factory2.createThis(),
                    ...node.arguments
                ]);
            }
            return node;
        }
        function isSuperContainer(node) {
            const kind = node.kind;
            return kind === 262 /* ClassDeclaration */  || kind === 175 /* Constructor */  || kind === 173 /* MethodDeclaration */  || kind === 176 /* GetAccessor */  || kind === 177 /* SetAccessor */ ;
        }
        function createSuperElementAccessInAsyncMethod(argumentExpression, location) {
            if (enclosingSuperContainerFlags & 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) return setTextRange(factory2.createPropertyAccessExpression(factory2.createCallExpression(factory2.createIdentifier("_superIndex"), /*typeArguments*/ void 0, [
                argumentExpression
            ]), "value"), location);
            else return setTextRange(factory2.createCallExpression(factory2.createIdentifier("_superIndex"), /*typeArguments*/ void 0, [
                argumentExpression
            ]), location);
        }
    }
    var init_es2018 = __esm({
        "src/compiler/transformers/es2018.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/es2019.ts
    function transformES2019(context) {
        const factory2 = context.factory;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            if ((node.transformFlags & 64 /* ContainsES2019 */ ) === 0) return node;
            switch(node.kind){
                case 298 /* CatchClause */ :
                    return visitCatchClause(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitCatchClause(node) {
            if (!node.variableDeclaration) return factory2.updateCatchClause(node, factory2.createVariableDeclaration(factory2.createTempVariable(/*recordTempVariable*/ void 0)), visitNode(node.block, visitor, isBlock));
            return visitEachChild(node, visitor, context);
        }
    }
    var init_es2019 = __esm({
        "src/compiler/transformers/es2019.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/es2020.ts
    function transformES2020(context) {
        const { factory: factory2 , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            if ((node.transformFlags & 32 /* ContainsES2020 */ ) === 0) return node;
            switch(node.kind){
                case 212 /* CallExpression */ :
                    {
                        const updated = visitNonOptionalCallExpression(node, /*captureThisArg*/ false);
                        Debug.assertNotNode(updated, isSyntheticReference);
                        return updated;
                    }
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    if (isOptionalChain(node)) {
                        const updated = visitOptionalExpression(node, /*captureThisArg*/ false, /*isDelete*/ false);
                        Debug.assertNotNode(updated, isSyntheticReference);
                        return updated;
                    }
                    return visitEachChild(node, visitor, context);
                case 225 /* BinaryExpression */ :
                    if (node.operatorToken.kind === 61 /* QuestionQuestionToken */ ) return transformNullishCoalescingExpression(node);
                    return visitEachChild(node, visitor, context);
                case 219 /* DeleteExpression */ :
                    return visitDeleteExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function flattenChain(chain) {
            Debug.assertNotNode(chain, isNonNullChain);
            const links = [
                chain
            ];
            while(!chain.questionDotToken && !isTaggedTemplateExpression(chain)){
                chain = cast(skipPartiallyEmittedExpressions(chain.expression), isOptionalChain);
                Debug.assertNotNode(chain, isNonNullChain);
                links.unshift(chain);
            }
            return {
                expression: chain.expression,
                chain: links
            };
        }
        function visitNonOptionalParenthesizedExpression(node, captureThisArg, isDelete) {
            const expression = visitNonOptionalExpression(node.expression, captureThisArg, isDelete);
            if (isSyntheticReference(expression)) return factory2.createSyntheticReferenceExpression(factory2.updateParenthesizedExpression(node, expression.expression), expression.thisArg);
            return factory2.updateParenthesizedExpression(node, expression);
        }
        function visitNonOptionalPropertyOrElementAccessExpression(node, captureThisArg, isDelete) {
            if (isOptionalChain(node)) return visitOptionalExpression(node, captureThisArg, isDelete);
            let expression = visitNode(node.expression, visitor, isExpression);
            Debug.assertNotNode(expression, isSyntheticReference);
            let thisArg;
            if (captureThisArg) {
                if (!isSimpleCopiableExpression(expression)) {
                    thisArg = factory2.createTempVariable(hoistVariableDeclaration);
                    expression = factory2.createAssignment(thisArg, expression);
                } else thisArg = expression;
            }
            expression = node.kind === 210 /* PropertyAccessExpression */  ? factory2.updatePropertyAccessExpression(node, expression, visitNode(node.name, visitor, isIdentifier)) : factory2.updateElementAccessExpression(node, expression, visitNode(node.argumentExpression, visitor, isExpression));
            return thisArg ? factory2.createSyntheticReferenceExpression(expression, thisArg) : expression;
        }
        function visitNonOptionalCallExpression(node, captureThisArg) {
            if (isOptionalChain(node)) return visitOptionalExpression(node, captureThisArg, /*isDelete*/ false);
            if (isParenthesizedExpression(node.expression) && isOptionalChain(skipParentheses(node.expression))) {
                const expression = visitNonOptionalParenthesizedExpression(node.expression, /*captureThisArg*/ true, /*isDelete*/ false);
                const args = visitNodes2(node.arguments, visitor, isExpression);
                if (isSyntheticReference(expression)) return setTextRange(factory2.createFunctionCallCall(expression.expression, expression.thisArg, args), node);
                return factory2.updateCallExpression(node, expression, /*typeArguments*/ void 0, args);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitNonOptionalExpression(node, captureThisArg, isDelete) {
            switch(node.kind){
                case 216 /* ParenthesizedExpression */ :
                    return visitNonOptionalParenthesizedExpression(node, captureThisArg, isDelete);
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    return visitNonOptionalPropertyOrElementAccessExpression(node, captureThisArg, isDelete);
                case 212 /* CallExpression */ :
                    return visitNonOptionalCallExpression(node, captureThisArg);
                default:
                    return visitNode(node, visitor, isExpression);
            }
        }
        function visitOptionalExpression(node, captureThisArg, isDelete) {
            const { expression: expression , chain: chain  } = flattenChain(node);
            const left = visitNonOptionalExpression(skipPartiallyEmittedExpressions(expression), isCallChain(chain[0]), /*isDelete*/ false);
            let leftThisArg = isSyntheticReference(left) ? left.thisArg : void 0;
            let capturedLeft = isSyntheticReference(left) ? left.expression : left;
            let leftExpression = factory2.restoreOuterExpressions(expression, capturedLeft, 8 /* PartiallyEmittedExpressions */ );
            if (!isSimpleCopiableExpression(capturedLeft)) {
                capturedLeft = factory2.createTempVariable(hoistVariableDeclaration);
                leftExpression = factory2.createAssignment(capturedLeft, leftExpression);
            }
            let rightExpression = capturedLeft;
            let thisArg;
            for(let i = 0; i < chain.length; i++){
                const segment = chain[i];
                switch(segment.kind){
                    case 210 /* PropertyAccessExpression */ :
                    case 211 /* ElementAccessExpression */ :
                        if (i === chain.length - 1 && captureThisArg) {
                            if (!isSimpleCopiableExpression(rightExpression)) {
                                thisArg = factory2.createTempVariable(hoistVariableDeclaration);
                                rightExpression = factory2.createAssignment(thisArg, rightExpression);
                            } else thisArg = rightExpression;
                        }
                        rightExpression = segment.kind === 210 /* PropertyAccessExpression */  ? factory2.createPropertyAccessExpression(rightExpression, visitNode(segment.name, visitor, isIdentifier)) : factory2.createElementAccessExpression(rightExpression, visitNode(segment.argumentExpression, visitor, isExpression));
                        break;
                    case 212 /* CallExpression */ :
                        if (i === 0 && leftThisArg) {
                            if (!isGeneratedIdentifier(leftThisArg)) {
                                leftThisArg = factory2.cloneNode(leftThisArg);
                                addEmitFlags(leftThisArg, 3072 /* NoComments */ );
                            }
                            rightExpression = factory2.createFunctionCallCall(rightExpression, leftThisArg.kind === 108 /* SuperKeyword */  ? factory2.createThis() : leftThisArg, visitNodes2(segment.arguments, visitor, isExpression));
                        } else rightExpression = factory2.createCallExpression(rightExpression, /*typeArguments*/ void 0, visitNodes2(segment.arguments, visitor, isExpression));
                        break;
                }
                setOriginalNode(rightExpression, segment);
            }
            const target = isDelete ? factory2.createConditionalExpression(createNotNullCondition(leftExpression, capturedLeft, /*invert*/ true), /*questionToken*/ void 0, factory2.createTrue(), /*colonToken*/ void 0, factory2.createDeleteExpression(rightExpression)) : factory2.createConditionalExpression(createNotNullCondition(leftExpression, capturedLeft, /*invert*/ true), /*questionToken*/ void 0, factory2.createVoidZero(), /*colonToken*/ void 0, rightExpression);
            setTextRange(target, node);
            return thisArg ? factory2.createSyntheticReferenceExpression(target, thisArg) : target;
        }
        function createNotNullCondition(left, right, invert) {
            return factory2.createBinaryExpression(factory2.createBinaryExpression(left, factory2.createToken(invert ? 37 /* EqualsEqualsEqualsToken */  : 38 /* ExclamationEqualsEqualsToken */ ), factory2.createNull()), factory2.createToken(invert ? 57 /* BarBarToken */  : 56 /* AmpersandAmpersandToken */ ), factory2.createBinaryExpression(right, factory2.createToken(invert ? 37 /* EqualsEqualsEqualsToken */  : 38 /* ExclamationEqualsEqualsToken */ ), factory2.createVoidZero()));
        }
        function transformNullishCoalescingExpression(node) {
            let left = visitNode(node.left, visitor, isExpression);
            let right = left;
            if (!isSimpleCopiableExpression(left)) {
                right = factory2.createTempVariable(hoistVariableDeclaration);
                left = factory2.createAssignment(right, left);
            }
            return setTextRange(factory2.createConditionalExpression(createNotNullCondition(left, right), /*questionToken*/ void 0, right, /*colonToken*/ void 0, visitNode(node.right, visitor, isExpression)), node);
        }
        function visitDeleteExpression(node) {
            return isOptionalChain(skipParentheses(node.expression)) ? setOriginalNode(visitNonOptionalExpression(node.expression, /*captureThisArg*/ false, /*isDelete*/ true), node) : factory2.updateDeleteExpression(node, visitNode(node.expression, visitor, isExpression));
        }
    }
    var init_es2020 = __esm({
        "src/compiler/transformers/es2020.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/es2021.ts
    function transformES2021(context) {
        const { hoistVariableDeclaration: hoistVariableDeclaration , factory: factory2  } = context;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            if ((node.transformFlags & 16 /* ContainsES2021 */ ) === 0) return node;
            if (isLogicalOrCoalescingAssignmentExpression(node)) return transformLogicalAssignment(node);
            return visitEachChild(node, visitor, context);
        }
        function transformLogicalAssignment(binaryExpression) {
            const operator = binaryExpression.operatorToken;
            const nonAssignmentOperator = getNonAssignmentOperatorForCompoundAssignment(operator.kind);
            let left = skipParentheses(visitNode(binaryExpression.left, visitor, isLeftHandSideExpression));
            let assignmentTarget = left;
            const right = skipParentheses(visitNode(binaryExpression.right, visitor, isExpression));
            if (isAccessExpression(left)) {
                const propertyAccessTargetSimpleCopiable = isSimpleCopiableExpression(left.expression);
                const propertyAccessTarget = propertyAccessTargetSimpleCopiable ? left.expression : factory2.createTempVariable(hoistVariableDeclaration);
                const propertyAccessTargetAssignment = propertyAccessTargetSimpleCopiable ? left.expression : factory2.createAssignment(propertyAccessTarget, left.expression);
                if (isPropertyAccessExpression(left)) {
                    assignmentTarget = factory2.createPropertyAccessExpression(propertyAccessTarget, left.name);
                    left = factory2.createPropertyAccessExpression(propertyAccessTargetAssignment, left.name);
                } else {
                    const elementAccessArgumentSimpleCopiable = isSimpleCopiableExpression(left.argumentExpression);
                    const elementAccessArgument = elementAccessArgumentSimpleCopiable ? left.argumentExpression : factory2.createTempVariable(hoistVariableDeclaration);
                    assignmentTarget = factory2.createElementAccessExpression(propertyAccessTarget, elementAccessArgument);
                    left = factory2.createElementAccessExpression(propertyAccessTargetAssignment, elementAccessArgumentSimpleCopiable ? left.argumentExpression : factory2.createAssignment(elementAccessArgument, left.argumentExpression));
                }
            }
            return factory2.createBinaryExpression(left, nonAssignmentOperator, factory2.createParenthesizedExpression(factory2.createAssignment(assignmentTarget, right)));
        }
    }
    var init_es2021 = __esm({
        "src/compiler/transformers/es2021.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/esnext.ts
    function transformESNext(context) {
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            if ((node.transformFlags & 4 /* ContainsESNext */ ) === 0) return node;
            node.kind;
            return visitEachChild(node, visitor, context);
        }
    }
    var init_esnext = __esm({
        "src/compiler/transformers/esnext.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/jsx.ts
    function transformJsx(context) {
        const { factory: factory2 , getEmitHelperFactory: emitHelpers  } = context;
        const compilerOptions = context.getCompilerOptions();
        let currentSourceFile;
        let currentFileState;
        return chainBundle(context, transformSourceFile);
        function getCurrentFileNameExpression() {
            if (currentFileState.filenameDeclaration) return currentFileState.filenameDeclaration.name;
            const declaration = factory2.createVariableDeclaration(factory2.createUniqueName("_jsxFileName", 48 /* FileLevel */ ), /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createStringLiteral(currentSourceFile.fileName));
            currentFileState.filenameDeclaration = declaration;
            return currentFileState.filenameDeclaration.name;
        }
        function getJsxFactoryCalleePrimitive(isStaticChildren) {
            return compilerOptions.jsx === 5 /* ReactJSXDev */  ? "jsxDEV" : isStaticChildren ? "jsxs" : "jsx";
        }
        function getJsxFactoryCallee(isStaticChildren) {
            const type = getJsxFactoryCalleePrimitive(isStaticChildren);
            return getImplicitImportForName(type);
        }
        function getImplicitJsxFragmentReference() {
            return getImplicitImportForName("Fragment");
        }
        function getImplicitImportForName(name) {
            var _a, _b;
            const importSource = name === "createElement" ? currentFileState.importSpecifier : getJSXRuntimeImport(currentFileState.importSpecifier, compilerOptions);
            const existing = (_b = (_a = currentFileState.utilizedImplicitRuntimeImports) == null ? void 0 : _a.get(importSource)) == null ? void 0 : _b.get(name);
            if (existing) return existing.name;
            if (!currentFileState.utilizedImplicitRuntimeImports) currentFileState.utilizedImplicitRuntimeImports = /* @__PURE__ */ new Map();
            let specifierSourceImports = currentFileState.utilizedImplicitRuntimeImports.get(importSource);
            if (!specifierSourceImports) {
                specifierSourceImports = /* @__PURE__ */ new Map();
                currentFileState.utilizedImplicitRuntimeImports.set(importSource, specifierSourceImports);
            }
            const generatedName = factory2.createUniqueName(`_${name}`, 112 /* AllowNameSubstitution */ );
            const specifier = factory2.createImportSpecifier(/*isTypeOnly*/ false, factory2.createIdentifier(name), generatedName);
            setIdentifierGeneratedImportReference(generatedName, specifier);
            specifierSourceImports.set(name, specifier);
            return generatedName;
        }
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            currentSourceFile = node;
            currentFileState = {};
            currentFileState.importSpecifier = getJSXImplicitImportBase(compilerOptions, node);
            let visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            let statements = visited.statements;
            if (currentFileState.filenameDeclaration) statements = insertStatementAfterCustomPrologue(statements.slice(), factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                currentFileState.filenameDeclaration
            ], 2 /* Const */ )));
            if (currentFileState.utilizedImplicitRuntimeImports) for (const [importSource, importSpecifiersMap] of arrayFrom(currentFileState.utilizedImplicitRuntimeImports.entries())){
                if (isExternalModule(node)) {
                    const importStatement = factory2.createImportDeclaration(/*modifiers*/ void 0, factory2.createImportClause(/*isTypeOnly*/ false, /*name*/ void 0, factory2.createNamedImports(arrayFrom(importSpecifiersMap.values()))), factory2.createStringLiteral(importSource), /*assertClause*/ void 0);
                    setParentRecursive(importStatement, /*incremental*/ false);
                    statements = insertStatementAfterCustomPrologue(statements.slice(), importStatement);
                } else if (isExternalOrCommonJsModule(node)) {
                    const requireStatement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                        factory2.createVariableDeclaration(factory2.createObjectBindingPattern(arrayFrom(importSpecifiersMap.values(), (s)=>factory2.createBindingElement(/*dotDotDotToken*/ void 0, s.propertyName, s.name))), /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createCallExpression(factory2.createIdentifier("require"), /*typeArguments*/ void 0, [
                            factory2.createStringLiteral(importSource)
                        ]))
                    ], 2 /* Const */ ));
                    setParentRecursive(requireStatement, /*incremental*/ false);
                    statements = insertStatementAfterCustomPrologue(statements.slice(), requireStatement);
                }
            }
            if (statements !== visited.statements) visited = factory2.updateSourceFile(visited, statements);
            currentFileState = void 0;
            return visited;
        }
        function visitor(node) {
            if (node.transformFlags & 2 /* ContainsJsx */ ) return visitorWorker(node);
            else return node;
        }
        function visitorWorker(node) {
            switch(node.kind){
                case 283 /* JsxElement */ :
                    return visitJsxElement(node, /*isChild*/ false);
                case 284 /* JsxSelfClosingElement */ :
                    return visitJsxSelfClosingElement(node, /*isChild*/ false);
                case 287 /* JsxFragment */ :
                    return visitJsxFragment(node, /*isChild*/ false);
                case 293 /* JsxExpression */ :
                    return visitJsxExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function transformJsxChildToExpression(node) {
            switch(node.kind){
                case 12 /* JsxText */ :
                    return visitJsxText(node);
                case 293 /* JsxExpression */ :
                    return visitJsxExpression(node);
                case 283 /* JsxElement */ :
                    return visitJsxElement(node, /*isChild*/ true);
                case 284 /* JsxSelfClosingElement */ :
                    return visitJsxSelfClosingElement(node, /*isChild*/ true);
                case 287 /* JsxFragment */ :
                    return visitJsxFragment(node, /*isChild*/ true);
                default:
                    return Debug.failBadSyntaxKind(node);
            }
        }
        function hasProto(obj) {
            return obj.properties.some((p)=>isPropertyAssignment(p) && (isIdentifier(p.name) && idText(p.name) === "__proto__" || isStringLiteral(p.name) && p.name.text === "__proto__"));
        }
        function hasKeyAfterPropsSpread(node) {
            let spread = false;
            for (const elem of node.attributes.properties){
                if (isJsxSpreadAttribute(elem) && (!isObjectLiteralExpression(elem.expression) || elem.expression.properties.some(isSpreadAssignment))) spread = true;
                else if (spread && isJsxAttribute(elem) && isIdentifier(elem.name) && elem.name.escapedText === "key") return true;
            }
            return false;
        }
        function shouldUseCreateElement(node) {
            return currentFileState.importSpecifier === void 0 || hasKeyAfterPropsSpread(node);
        }
        function visitJsxElement(node, isChild) {
            const tagTransform = shouldUseCreateElement(node.openingElement) ? visitJsxOpeningLikeElementCreateElement : visitJsxOpeningLikeElementJSX;
            return tagTransform(node.openingElement, node.children, isChild, /*location*/ node);
        }
        function visitJsxSelfClosingElement(node, isChild) {
            const tagTransform = shouldUseCreateElement(node) ? visitJsxOpeningLikeElementCreateElement : visitJsxOpeningLikeElementJSX;
            return tagTransform(node, /*children*/ void 0, isChild, /*location*/ node);
        }
        function visitJsxFragment(node, isChild) {
            const tagTransform = currentFileState.importSpecifier === void 0 ? visitJsxOpeningFragmentCreateElement : visitJsxOpeningFragmentJSX;
            return tagTransform(node.openingFragment, node.children, isChild, /*location*/ node);
        }
        function convertJsxChildrenToChildrenPropObject(children) {
            const prop = convertJsxChildrenToChildrenPropAssignment(children);
            return prop && factory2.createObjectLiteralExpression([
                prop
            ]);
        }
        function convertJsxChildrenToChildrenPropAssignment(children) {
            const nonWhitespaceChildren = getSemanticJsxChildren(children);
            if (length(nonWhitespaceChildren) === 1 && !nonWhitespaceChildren[0].dotDotDotToken) {
                const result2 = transformJsxChildToExpression(nonWhitespaceChildren[0]);
                return result2 && factory2.createPropertyAssignment("children", result2);
            }
            const result = mapDefined(children, transformJsxChildToExpression);
            return length(result) ? factory2.createPropertyAssignment("children", factory2.createArrayLiteralExpression(result)) : void 0;
        }
        function visitJsxOpeningLikeElementJSX(node, children, isChild, location) {
            const tagName = getTagName(node);
            const childrenProp = children && children.length ? convertJsxChildrenToChildrenPropAssignment(children) : void 0;
            const keyAttr = find(node.attributes.properties, (p)=>!!p.name && isIdentifier(p.name) && p.name.escapedText === "key");
            const attrs = keyAttr ? filter(node.attributes.properties, (p)=>p !== keyAttr) : node.attributes.properties;
            const objectProperties = length(attrs) ? transformJsxAttributesToObjectProps(attrs, childrenProp) : factory2.createObjectLiteralExpression(childrenProp ? [
                childrenProp
            ] : emptyArray);
            return visitJsxOpeningLikeElementOrFragmentJSX(tagName, objectProperties, keyAttr, children || emptyArray, isChild, location);
        }
        function visitJsxOpeningLikeElementOrFragmentJSX(tagName, objectProperties, keyAttr, children, isChild, location) {
            var _a;
            const nonWhitespaceChildren = getSemanticJsxChildren(children);
            const isStaticChildren = length(nonWhitespaceChildren) > 1 || !!((_a = nonWhitespaceChildren[0]) == null ? void 0 : _a.dotDotDotToken);
            const args = [
                tagName,
                objectProperties
            ];
            if (keyAttr) args.push(transformJsxAttributeInitializer(keyAttr.initializer));
            if (compilerOptions.jsx === 5 /* ReactJSXDev */ ) {
                const originalFile = getOriginalNode(currentSourceFile);
                if (originalFile && isSourceFile(originalFile)) {
                    if (keyAttr === void 0) args.push(factory2.createVoidZero());
                    args.push(isStaticChildren ? factory2.createTrue() : factory2.createFalse());
                    const lineCol = getLineAndCharacterOfPosition(originalFile, location.pos);
                    args.push(factory2.createObjectLiteralExpression([
                        factory2.createPropertyAssignment("fileName", getCurrentFileNameExpression()),
                        factory2.createPropertyAssignment("lineNumber", factory2.createNumericLiteral(lineCol.line + 1)),
                        factory2.createPropertyAssignment("columnNumber", factory2.createNumericLiteral(lineCol.character + 1))
                    ]));
                    args.push(factory2.createThis());
                }
            }
            const element = setTextRange(factory2.createCallExpression(getJsxFactoryCallee(isStaticChildren), /*typeArguments*/ void 0, args), location);
            if (isChild) startOnNewLine(element);
            return element;
        }
        function visitJsxOpeningLikeElementCreateElement(node, children, isChild, location) {
            const tagName = getTagName(node);
            const attrs = node.attributes.properties;
            const objectProperties = length(attrs) ? transformJsxAttributesToObjectProps(attrs) : factory2.createNull();
            const callee = currentFileState.importSpecifier === void 0 ? createJsxFactoryExpression(factory2, context.getEmitResolver().getJsxFactoryEntity(currentSourceFile), compilerOptions.reactNamespace, // TODO: GH#18217
            node) : getImplicitImportForName("createElement");
            const element = createExpressionForJsxElement(factory2, callee, tagName, objectProperties, mapDefined(children, transformJsxChildToExpression), location);
            if (isChild) startOnNewLine(element);
            return element;
        }
        function visitJsxOpeningFragmentJSX(_node, children, isChild, location) {
            let childrenProps;
            if (children && children.length) {
                const result = convertJsxChildrenToChildrenPropObject(children);
                if (result) childrenProps = result;
            }
            return visitJsxOpeningLikeElementOrFragmentJSX(getImplicitJsxFragmentReference(), childrenProps || factory2.createObjectLiteralExpression([]), /*keyAttr*/ void 0, children, isChild, location);
        }
        function visitJsxOpeningFragmentCreateElement(node, children, isChild, location) {
            const element = createExpressionForJsxFragment(factory2, context.getEmitResolver().getJsxFactoryEntity(currentSourceFile), context.getEmitResolver().getJsxFragmentFactoryEntity(currentSourceFile), compilerOptions.reactNamespace, // TODO: GH#18217
            mapDefined(children, transformJsxChildToExpression), node, location);
            if (isChild) startOnNewLine(element);
            return element;
        }
        function transformJsxSpreadAttributeToProps(node) {
            if (isObjectLiteralExpression(node.expression) && !hasProto(node.expression)) return node.expression.properties;
            return factory2.createSpreadAssignment(Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
        }
        function transformJsxAttributesToObjectProps(attrs, children) {
            const target = getEmitScriptTarget(compilerOptions);
            return target && target >= 5 /* ES2018 */  ? factory2.createObjectLiteralExpression(transformJsxAttributesToProps(attrs, children)) : transformJsxAttributesToExpression(attrs, children);
        }
        function transformJsxAttributesToProps(attrs, children) {
            const props = flatten(spanMap(attrs, isJsxSpreadAttribute, (attrs2, isSpread)=>flatten(map(attrs2, (attr)=>isSpread ? transformJsxSpreadAttributeToProps(attr) : transformJsxAttributeToObjectLiteralElement(attr)))));
            if (children) props.push(children);
            return props;
        }
        function transformJsxAttributesToExpression(attrs, children) {
            const expressions = [];
            let properties = [];
            for (const attr of attrs){
                if (isJsxSpreadAttribute(attr)) {
                    if (isObjectLiteralExpression(attr.expression) && !hasProto(attr.expression)) {
                        for (const prop of attr.expression.properties){
                            if (isSpreadAssignment(prop)) {
                                finishObjectLiteralIfNeeded();
                                expressions.push(prop.expression);
                                continue;
                            }
                            properties.push(prop);
                        }
                        continue;
                    }
                    finishObjectLiteralIfNeeded();
                    expressions.push(attr.expression);
                    continue;
                }
                properties.push(transformJsxAttributeToObjectLiteralElement(attr));
            }
            if (children) properties.push(children);
            finishObjectLiteralIfNeeded();
            if (expressions.length && !isObjectLiteralExpression(expressions[0])) expressions.unshift(factory2.createObjectLiteralExpression());
            return singleOrUndefined(expressions) || emitHelpers().createAssignHelper(expressions);
            function finishObjectLiteralIfNeeded() {
                if (properties.length) {
                    expressions.push(factory2.createObjectLiteralExpression(properties));
                    properties = [];
                }
            }
        }
        function transformJsxAttributeToObjectLiteralElement(node) {
            const name = getAttributeName(node);
            const expression = transformJsxAttributeInitializer(node.initializer);
            return factory2.createPropertyAssignment(name, expression);
        }
        function transformJsxAttributeInitializer(node) {
            if (node === void 0) return factory2.createTrue();
            if (node.kind === 11 /* StringLiteral */ ) {
                const singleQuote = node.singleQuote !== void 0 ? node.singleQuote : !isStringDoubleQuoted(node, currentSourceFile);
                const literal = factory2.createStringLiteral(tryDecodeEntities(node.text) || node.text, singleQuote);
                return setTextRange(literal, node);
            }
            if (node.kind === 293 /* JsxExpression */ ) {
                if (node.expression === void 0) return factory2.createTrue();
                return Debug.checkDefined(visitNode(node.expression, visitor, isExpression));
            }
            if (isJsxElement(node)) return visitJsxElement(node, /*isChild*/ false);
            if (isJsxSelfClosingElement(node)) return visitJsxSelfClosingElement(node, /*isChild*/ false);
            if (isJsxFragment(node)) return visitJsxFragment(node, /*isChild*/ false);
            return Debug.failBadSyntaxKind(node);
        }
        function visitJsxText(node) {
            const fixed = fixupWhitespaceAndDecodeEntities(node.text);
            return fixed === void 0 ? void 0 : factory2.createStringLiteral(fixed);
        }
        function fixupWhitespaceAndDecodeEntities(text) {
            let acc;
            let firstNonWhitespace = 0;
            let lastNonWhitespace = -1;
            for(let i = 0; i < text.length; i++){
                const c = text.charCodeAt(i);
                if (isLineBreak(c)) {
                    if (firstNonWhitespace !== -1 && lastNonWhitespace !== -1) acc = addLineOfJsxText(acc, text.substr(firstNonWhitespace, lastNonWhitespace - firstNonWhitespace + 1));
                    firstNonWhitespace = -1;
                } else if (!isWhiteSpaceSingleLine(c)) {
                    lastNonWhitespace = i;
                    if (firstNonWhitespace === -1) firstNonWhitespace = i;
                }
            }
            return firstNonWhitespace !== -1 ? addLineOfJsxText(acc, text.substr(firstNonWhitespace)) : acc;
        }
        function addLineOfJsxText(acc, trimmedLine) {
            const decoded = decodeEntities(trimmedLine);
            return acc === void 0 ? decoded : acc + " " + decoded;
        }
        function decodeEntities(text) {
            return text.replace(/&((#((\d+)|x([\da-fA-F]+)))|(\w+));/g, (match, _all, _number, _digits, decimal, hex, word)=>{
                if (decimal) return utf16EncodeAsString(parseInt(decimal, 10));
                else if (hex) return utf16EncodeAsString(parseInt(hex, 16));
                else {
                    const ch = entities.get(word);
                    return ch ? utf16EncodeAsString(ch) : match;
                }
            });
        }
        function tryDecodeEntities(text) {
            const decoded = decodeEntities(text);
            return decoded === text ? void 0 : decoded;
        }
        function getTagName(node) {
            if (node.kind === 283 /* JsxElement */ ) return getTagName(node.openingElement);
            else {
                const tagName = node.tagName;
                if (isIdentifier(tagName) && isIntrinsicJsxName(tagName.escapedText)) return factory2.createStringLiteral(idText(tagName));
                else if (isJsxNamespacedName(tagName)) return factory2.createStringLiteral(idText(tagName.namespace) + ":" + idText(tagName.name));
                else return createExpressionFromEntityName(factory2, tagName);
            }
        }
        function getAttributeName(node) {
            const name = node.name;
            if (isIdentifier(name)) {
                const text = idText(name);
                return /^[A-Za-z_]\w*$/.test(text) ? name : factory2.createStringLiteral(text);
            }
            return factory2.createStringLiteral(idText(name.namespace) + ":" + idText(name.name));
        }
        function visitJsxExpression(node) {
            const expression = visitNode(node.expression, visitor, isExpression);
            return node.dotDotDotToken ? factory2.createSpreadElement(expression) : expression;
        }
    }
    var entities;
    var init_jsx = __esm({
        "src/compiler/transformers/jsx.ts" () {
            "use strict";
            init_ts2();
            entities = new Map(Object.entries({
                quot: 34,
                amp: 38,
                apos: 39,
                lt: 60,
                gt: 62,
                nbsp: 160,
                iexcl: 161,
                cent: 162,
                pound: 163,
                curren: 164,
                yen: 165,
                brvbar: 166,
                sect: 167,
                uml: 168,
                copy: 169,
                ordf: 170,
                laquo: 171,
                not: 172,
                shy: 173,
                reg: 174,
                macr: 175,
                deg: 176,
                plusmn: 177,
                sup2: 178,
                sup3: 179,
                acute: 180,
                micro: 181,
                para: 182,
                middot: 183,
                cedil: 184,
                sup1: 185,
                ordm: 186,
                raquo: 187,
                frac14: 188,
                frac12: 189,
                frac34: 190,
                iquest: 191,
                Agrave: 192,
                Aacute: 193,
                Acirc: 194,
                Atilde: 195,
                Auml: 196,
                Aring: 197,
                AElig: 198,
                Ccedil: 199,
                Egrave: 200,
                Eacute: 201,
                Ecirc: 202,
                Euml: 203,
                Igrave: 204,
                Iacute: 205,
                Icirc: 206,
                Iuml: 207,
                ETH: 208,
                Ntilde: 209,
                Ograve: 210,
                Oacute: 211,
                Ocirc: 212,
                Otilde: 213,
                Ouml: 214,
                times: 215,
                Oslash: 216,
                Ugrave: 217,
                Uacute: 218,
                Ucirc: 219,
                Uuml: 220,
                Yacute: 221,
                THORN: 222,
                szlig: 223,
                agrave: 224,
                aacute: 225,
                acirc: 226,
                atilde: 227,
                auml: 228,
                aring: 229,
                aelig: 230,
                ccedil: 231,
                egrave: 232,
                eacute: 233,
                ecirc: 234,
                euml: 235,
                igrave: 236,
                iacute: 237,
                icirc: 238,
                iuml: 239,
                eth: 240,
                ntilde: 241,
                ograve: 242,
                oacute: 243,
                ocirc: 244,
                otilde: 245,
                ouml: 246,
                divide: 247,
                oslash: 248,
                ugrave: 249,
                uacute: 250,
                ucirc: 251,
                uuml: 252,
                yacute: 253,
                thorn: 254,
                yuml: 255,
                OElig: 338,
                oelig: 339,
                Scaron: 352,
                scaron: 353,
                Yuml: 376,
                fnof: 402,
                circ: 710,
                tilde: 732,
                Alpha: 913,
                Beta: 914,
                Gamma: 915,
                Delta: 916,
                Epsilon: 917,
                Zeta: 918,
                Eta: 919,
                Theta: 920,
                Iota: 921,
                Kappa: 922,
                Lambda: 923,
                Mu: 924,
                Nu: 925,
                Xi: 926,
                Omicron: 927,
                Pi: 928,
                Rho: 929,
                Sigma: 931,
                Tau: 932,
                Upsilon: 933,
                Phi: 934,
                Chi: 935,
                Psi: 936,
                Omega: 937,
                alpha: 945,
                beta: 946,
                gamma: 947,
                delta: 948,
                epsilon: 949,
                zeta: 950,
                eta: 951,
                theta: 952,
                iota: 953,
                kappa: 954,
                lambda: 955,
                mu: 956,
                nu: 957,
                xi: 958,
                omicron: 959,
                pi: 960,
                rho: 961,
                sigmaf: 962,
                sigma: 963,
                tau: 964,
                upsilon: 965,
                phi: 966,
                chi: 967,
                psi: 968,
                omega: 969,
                thetasym: 977,
                upsih: 978,
                piv: 982,
                ensp: 8194,
                emsp: 8195,
                thinsp: 8201,
                zwnj: 8204,
                zwj: 8205,
                lrm: 8206,
                rlm: 8207,
                ndash: 8211,
                mdash: 8212,
                lsquo: 8216,
                rsquo: 8217,
                sbquo: 8218,
                ldquo: 8220,
                rdquo: 8221,
                bdquo: 8222,
                dagger: 8224,
                Dagger: 8225,
                bull: 8226,
                hellip: 8230,
                permil: 8240,
                prime: 8242,
                Prime: 8243,
                lsaquo: 8249,
                rsaquo: 8250,
                oline: 8254,
                frasl: 8260,
                euro: 8364,
                image: 8465,
                weierp: 8472,
                real: 8476,
                trade: 8482,
                alefsym: 8501,
                larr: 8592,
                uarr: 8593,
                rarr: 8594,
                darr: 8595,
                harr: 8596,
                crarr: 8629,
                lArr: 8656,
                uArr: 8657,
                rArr: 8658,
                dArr: 8659,
                hArr: 8660,
                forall: 8704,
                part: 8706,
                exist: 8707,
                empty: 8709,
                nabla: 8711,
                isin: 8712,
                notin: 8713,
                ni: 8715,
                prod: 8719,
                sum: 8721,
                minus: 8722,
                lowast: 8727,
                radic: 8730,
                prop: 8733,
                infin: 8734,
                ang: 8736,
                and: 8743,
                or: 8744,
                cap: 8745,
                cup: 8746,
                int: 8747,
                there4: 8756,
                sim: 8764,
                cong: 8773,
                asymp: 8776,
                ne: 8800,
                equiv: 8801,
                le: 8804,
                ge: 8805,
                sub: 8834,
                sup: 8835,
                nsub: 8836,
                sube: 8838,
                supe: 8839,
                oplus: 8853,
                otimes: 8855,
                perp: 8869,
                sdot: 8901,
                lceil: 8968,
                rceil: 8969,
                lfloor: 8970,
                rfloor: 8971,
                lang: 9001,
                rang: 9002,
                loz: 9674,
                spades: 9824,
                clubs: 9827,
                hearts: 9829,
                diams: 9830
            }));
        }
    });
    // src/compiler/transformers/es2016.ts
    function transformES2016(context) {
        const { factory: factory2 , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            if ((node.transformFlags & 512 /* ContainsES2016 */ ) === 0) return node;
            switch(node.kind){
                case 225 /* BinaryExpression */ :
                    return visitBinaryExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitBinaryExpression(node) {
            switch(node.operatorToken.kind){
                case 68 /* AsteriskAsteriskEqualsToken */ :
                    return visitExponentiationAssignmentExpression(node);
                case 43 /* AsteriskAsteriskToken */ :
                    return visitExponentiationExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitExponentiationAssignmentExpression(node) {
            let target;
            let value1;
            const left = visitNode(node.left, visitor, isExpression);
            const right = visitNode(node.right, visitor, isExpression);
            if (isElementAccessExpression(left)) {
                const expressionTemp = factory2.createTempVariable(hoistVariableDeclaration);
                const argumentExpressionTemp = factory2.createTempVariable(hoistVariableDeclaration);
                target = setTextRange(factory2.createElementAccessExpression(setTextRange(factory2.createAssignment(expressionTemp, left.expression), left.expression), setTextRange(factory2.createAssignment(argumentExpressionTemp, left.argumentExpression), left.argumentExpression)), left);
                value1 = setTextRange(factory2.createElementAccessExpression(expressionTemp, argumentExpressionTemp), left);
            } else if (isPropertyAccessExpression(left)) {
                const expressionTemp = factory2.createTempVariable(hoistVariableDeclaration);
                target = setTextRange(factory2.createPropertyAccessExpression(setTextRange(factory2.createAssignment(expressionTemp, left.expression), left.expression), left.name), left);
                value1 = setTextRange(factory2.createPropertyAccessExpression(expressionTemp, left.name), left);
            } else {
                target = left;
                value1 = left;
            }
            return setTextRange(factory2.createAssignment(target, setTextRange(factory2.createGlobalMethodCall("Math", "pow", [
                value1,
                right
            ]), node)), node);
        }
        function visitExponentiationExpression(node) {
            const left = visitNode(node.left, visitor, isExpression);
            const right = visitNode(node.right, visitor, isExpression);
            return setTextRange(factory2.createGlobalMethodCall("Math", "pow", [
                left,
                right
            ]), node);
        }
    }
    var init_es2016 = __esm({
        "src/compiler/transformers/es2016.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/es2015.ts
    function createSpreadSegment(kind, expression) {
        return {
            kind: kind,
            expression: expression
        };
    }
    function transformES2015(context) {
        const { factory: factory2 , getEmitHelperFactory: emitHelpers , startLexicalEnvironment: startLexicalEnvironment , resumeLexicalEnvironment: resumeLexicalEnvironment , endLexicalEnvironment: endLexicalEnvironment , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        const compilerOptions = context.getCompilerOptions();
        const resolver = context.getEmitResolver();
        const previousOnSubstituteNode = context.onSubstituteNode;
        const previousOnEmitNode = context.onEmitNode;
        context.onEmitNode = onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        let currentSourceFile;
        let currentText;
        let hierarchyFacts;
        let taggedTemplateStringDeclarations;
        function recordTaggedTemplateString(temp) {
            taggedTemplateStringDeclarations = append(taggedTemplateStringDeclarations, factory2.createVariableDeclaration(temp));
        }
        let convertedLoopState;
        let enabledSubstitutions;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            currentSourceFile = node;
            currentText = node.text;
            const visited = visitSourceFile(node);
            addEmitHelpers(visited, context.readEmitHelpers());
            currentSourceFile = void 0;
            currentText = void 0;
            taggedTemplateStringDeclarations = void 0;
            hierarchyFacts = 0 /* None */ ;
            return visited;
        }
        function enterSubtree(excludeFacts, includeFacts) {
            const ancestorFacts = hierarchyFacts;
            hierarchyFacts = (hierarchyFacts & ~excludeFacts | includeFacts) & 32767 /* AncestorFactsMask */ ;
            return ancestorFacts;
        }
        function exitSubtree(ancestorFacts, excludeFacts, includeFacts) {
            hierarchyFacts = (hierarchyFacts & ~excludeFacts | includeFacts) & -32768 /* SubtreeFactsMask */  | ancestorFacts;
        }
        function isReturnVoidStatementInConstructorWithCapturedSuper(node) {
            return (hierarchyFacts & 8192 /* ConstructorWithCapturedSuper */ ) !== 0 && node.kind === 252 /* ReturnStatement */  && !node.expression;
        }
        function isOrMayContainReturnCompletion(node) {
            return node.transformFlags & 4194304 /* ContainsHoistedDeclarationOrCompletion */  && (isReturnStatement(node) || isIfStatement(node) || isWithStatement(node) || isSwitchStatement(node) || isCaseBlock(node) || isCaseClause(node) || isDefaultClause(node) || isTryStatement(node) || isCatchClause(node) || isLabeledStatement(node) || isIterationStatement(node, /*lookInLabeledStatements*/ false) || isBlock(node));
        }
        function shouldVisitNode(node) {
            return (node.transformFlags & 1024 /* ContainsES2015 */ ) !== 0 || convertedLoopState !== void 0 || hierarchyFacts & 8192 /* ConstructorWithCapturedSuper */  && isOrMayContainReturnCompletion(node) || isIterationStatement(node, /*lookInLabeledStatements*/ false) && shouldConvertIterationStatement(node) || (getInternalEmitFlags(node) & 1 /* TypeScriptClassWrapper */ ) !== 0;
        }
        function visitor(node) {
            return shouldVisitNode(node) ? visitorWorker(node, /*expressionResultIsUnused*/ false) : node;
        }
        function visitorWithUnusedExpressionResult(node) {
            return shouldVisitNode(node) ? visitorWorker(node, /*expressionResultIsUnused*/ true) : node;
        }
        function classWrapperStatementVisitor(node) {
            if (shouldVisitNode(node)) {
                const original = getOriginalNode(node);
                if (isPropertyDeclaration(original) && hasStaticModifier(original)) {
                    const ancestorFacts = enterSubtree(32670 /* StaticInitializerExcludes */ , 16449 /* StaticInitializerIncludes */ );
                    const result = visitorWorker(node, /*expressionResultIsUnused*/ false);
                    exitSubtree(ancestorFacts, 98304 /* FunctionSubtreeExcludes */ , 0 /* None */ );
                    return result;
                }
                return visitorWorker(node, /*expressionResultIsUnused*/ false);
            }
            return node;
        }
        function callExpressionVisitor(node) {
            if (node.kind === 108 /* SuperKeyword */ ) return visitSuperKeyword(/*isExpressionOfCall*/ true);
            return visitor(node);
        }
        function visitorWorker(node, expressionResultIsUnused2) {
            switch(node.kind){
                case 126 /* StaticKeyword */ :
                    return void 0;
                case 262 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 230 /* ClassExpression */ :
                    return visitClassExpression(node);
                case 168 /* Parameter */ :
                    return visitParameter(node);
                case 261 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 218 /* ArrowFunction */ :
                    return visitArrowFunction(node);
                case 217 /* FunctionExpression */ :
                    return visitFunctionExpression(node);
                case 259 /* VariableDeclaration */ :
                    return visitVariableDeclaration(node);
                case 80 /* Identifier */ :
                    return visitIdentifier(node);
                case 260 /* VariableDeclarationList */ :
                    return visitVariableDeclarationList(node);
                case 254 /* SwitchStatement */ :
                    return visitSwitchStatement(node);
                case 268 /* CaseBlock */ :
                    return visitCaseBlock(node);
                case 240 /* Block */ :
                    return visitBlock(node, /*isFunctionBody*/ false);
                case 251 /* BreakStatement */ :
                case 250 /* ContinueStatement */ :
                    return visitBreakOrContinueStatement(node);
                case 255 /* LabeledStatement */ :
                    return visitLabeledStatement(node);
                case 245 /* DoStatement */ :
                case 246 /* WhileStatement */ :
                    return visitDoOrWhileStatement(node, /*outermostLabeledStatement*/ void 0);
                case 247 /* ForStatement */ :
                    return visitForStatement(node, /*outermostLabeledStatement*/ void 0);
                case 248 /* ForInStatement */ :
                    return visitForInStatement(node, /*outermostLabeledStatement*/ void 0);
                case 249 /* ForOfStatement */ :
                    return visitForOfStatement(node, /*outermostLabeledStatement*/ void 0);
                case 243 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 209 /* ObjectLiteralExpression */ :
                    return visitObjectLiteralExpression(node);
                case 298 /* CatchClause */ :
                    return visitCatchClause(node);
                case 303 /* ShorthandPropertyAssignment */ :
                    return visitShorthandPropertyAssignment(node);
                case 166 /* ComputedPropertyName */ :
                    return visitComputedPropertyName(node);
                case 208 /* ArrayLiteralExpression */ :
                    return visitArrayLiteralExpression(node);
                case 212 /* CallExpression */ :
                    return visitCallExpression(node);
                case 213 /* NewExpression */ :
                    return visitNewExpression(node);
                case 216 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, expressionResultIsUnused2);
                case 225 /* BinaryExpression */ :
                    return visitBinaryExpression(node, expressionResultIsUnused2);
                case 360 /* CommaListExpression */ :
                    return visitCommaListExpression(node, expressionResultIsUnused2);
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 16 /* TemplateHead */ :
                case 17 /* TemplateMiddle */ :
                case 18 /* TemplateTail */ :
                    return visitTemplateLiteral(node);
                case 11 /* StringLiteral */ :
                    return visitStringLiteral(node);
                case 9 /* NumericLiteral */ :
                    return visitNumericLiteral(node);
                case 214 /* TaggedTemplateExpression */ :
                    return visitTaggedTemplateExpression(node);
                case 227 /* TemplateExpression */ :
                    return visitTemplateExpression(node);
                case 228 /* YieldExpression */ :
                    return visitYieldExpression(node);
                case 229 /* SpreadElement */ :
                    return visitSpreadElement(node);
                case 108 /* SuperKeyword */ :
                    return visitSuperKeyword(/*isExpressionOfCall*/ false);
                case 110 /* ThisKeyword */ :
                    return visitThisKeyword(node);
                case 235 /* MetaProperty */ :
                    return visitMetaProperty(node);
                case 173 /* MethodDeclaration */ :
                    return visitMethodDeclaration(node);
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    return visitAccessorDeclaration(node);
                case 242 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 252 /* ReturnStatement */ :
                    return visitReturnStatement(node);
                case 221 /* VoidExpression */ :
                    return visitVoidExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitSourceFile(node) {
            const ancestorFacts = enterSubtree(8064 /* SourceFileExcludes */ , 64 /* SourceFileIncludes */ );
            const prologue = [];
            const statements = [];
            startLexicalEnvironment();
            const statementOffset = factory2.copyPrologue(node.statements, prologue, /*ensureUseStrict*/ false, visitor);
            addRange(statements, visitNodes2(node.statements, visitor, isStatement, statementOffset));
            if (taggedTemplateStringDeclarations) statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(taggedTemplateStringDeclarations)));
            factory2.mergeLexicalEnvironment(prologue, endLexicalEnvironment());
            insertCaptureThisForNodeIfNeeded(prologue, node);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray(concatenate(prologue, statements)), node.statements));
        }
        function visitSwitchStatement(node) {
            if (convertedLoopState !== void 0) {
                const savedAllowedNonLabeledJumps = convertedLoopState.allowedNonLabeledJumps;
                convertedLoopState.allowedNonLabeledJumps |= 2 /* Break */ ;
                const result = visitEachChild(node, visitor, context);
                convertedLoopState.allowedNonLabeledJumps = savedAllowedNonLabeledJumps;
                return result;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitCaseBlock(node) {
            const ancestorFacts = enterSubtree(7104 /* BlockScopeExcludes */ , 0 /* BlockScopeIncludes */ );
            const updated = visitEachChild(node, visitor, context);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function returnCapturedThis(node) {
            return setOriginalNode(factory2.createReturnStatement(factory2.createUniqueName("_this", 48 /* FileLevel */ )), node);
        }
        function visitReturnStatement(node) {
            if (convertedLoopState) {
                convertedLoopState.nonLocalJumps |= 8 /* Return */ ;
                if (isReturnVoidStatementInConstructorWithCapturedSuper(node)) node = returnCapturedThis(node);
                return factory2.createReturnStatement(factory2.createObjectLiteralExpression([
                    factory2.createPropertyAssignment(factory2.createIdentifier("value"), node.expression ? Debug.checkDefined(visitNode(node.expression, visitor, isExpression)) : factory2.createVoidZero())
                ]));
            } else if (isReturnVoidStatementInConstructorWithCapturedSuper(node)) return returnCapturedThis(node);
            return visitEachChild(node, visitor, context);
        }
        function visitThisKeyword(node) {
            if (hierarchyFacts & 2 /* ArrowFunction */  && !(hierarchyFacts & 16384 /* StaticInitializer */ )) hierarchyFacts |= 65536 /* CapturedLexicalThis */ ;
            if (convertedLoopState) {
                if (hierarchyFacts & 2 /* ArrowFunction */ ) {
                    convertedLoopState.containsLexicalThis = true;
                    return node;
                }
                return convertedLoopState.thisName || (convertedLoopState.thisName = factory2.createUniqueName("this"));
            }
            return node;
        }
        function visitVoidExpression(node) {
            return visitEachChild(node, visitorWithUnusedExpressionResult, context);
        }
        function visitIdentifier(node) {
            if (convertedLoopState) {
                if (resolver.isArgumentsLocalBinding(node)) return convertedLoopState.argumentsName || (convertedLoopState.argumentsName = factory2.createUniqueName("arguments"));
            }
            if (node.flags & 128 /* IdentifierHasExtendedUnicodeEscape */ ) return setOriginalNode(setTextRange(factory2.createIdentifier(unescapeLeadingUnderscores(node.escapedText)), node), node);
            return node;
        }
        function visitBreakOrContinueStatement(node) {
            if (convertedLoopState) {
                const jump = node.kind === 251 /* BreakStatement */  ? 2 /* Break */  : 4 /* Continue */ ;
                const canUseBreakOrContinue = node.label && convertedLoopState.labels && convertedLoopState.labels.get(idText(node.label)) || !node.label && convertedLoopState.allowedNonLabeledJumps & jump;
                if (!canUseBreakOrContinue) {
                    let labelMarker;
                    const label = node.label;
                    if (!label) {
                        if (node.kind === 251 /* BreakStatement */ ) {
                            convertedLoopState.nonLocalJumps |= 2 /* Break */ ;
                            labelMarker = "break";
                        } else {
                            convertedLoopState.nonLocalJumps |= 4 /* Continue */ ;
                            labelMarker = "continue";
                        }
                    } else if (node.kind === 251 /* BreakStatement */ ) {
                        labelMarker = `break-${label.escapedText}`;
                        setLabeledJump(convertedLoopState, /*isBreak*/ true, idText(label), labelMarker);
                    } else {
                        labelMarker = `continue-${label.escapedText}`;
                        setLabeledJump(convertedLoopState, /*isBreak*/ false, idText(label), labelMarker);
                    }
                    let returnExpression = factory2.createStringLiteral(labelMarker);
                    if (convertedLoopState.loopOutParameters.length) {
                        const outParams = convertedLoopState.loopOutParameters;
                        let expr;
                        for(let i = 0; i < outParams.length; i++){
                            const copyExpr = copyOutParameter(outParams[i], 1 /* ToOutParameter */ );
                            if (i === 0) expr = copyExpr;
                            else expr = factory2.createBinaryExpression(expr, 28 /* CommaToken */ , copyExpr);
                        }
                        returnExpression = factory2.createBinaryExpression(expr, 28 /* CommaToken */ , returnExpression);
                    }
                    return factory2.createReturnStatement(returnExpression);
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitClassDeclaration(node) {
            const variable = factory2.createVariableDeclaration(factory2.getLocalName(node, /*allowComments*/ true), /*exclamationToken*/ void 0, /*type*/ void 0, transformClassLikeDeclarationToExpression(node));
            setOriginalNode(variable, node);
            const statements = [];
            const statement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                variable
            ]));
            setOriginalNode(statement, node);
            setTextRange(statement, node);
            startOnNewLine(statement);
            statements.push(statement);
            if (hasSyntacticModifier(node, 1 /* Export */ )) {
                const exportStatement = hasSyntacticModifier(node, 1024 /* Default */ ) ? factory2.createExportDefault(factory2.getLocalName(node)) : factory2.createExternalModuleExport(factory2.getLocalName(node));
                setOriginalNode(exportStatement, statement);
                statements.push(exportStatement);
            }
            return singleOrMany(statements);
        }
        function visitClassExpression(node) {
            return transformClassLikeDeclarationToExpression(node);
        }
        function transformClassLikeDeclarationToExpression(node) {
            if (node.name) enableSubstitutionsForBlockScopedBindings();
            const extendsClauseElement = getClassExtendsHeritageElement(node);
            const classFunction = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, extendsClauseElement ? [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.createUniqueName("_super", 48 /* FileLevel */ ))
            ] : [], /*type*/ void 0, transformClassBody(node, extendsClauseElement));
            setEmitFlags(classFunction, getEmitFlags(node) & 131072 /* Indented */  | 1048576 /* ReuseTempVariableScope */ );
            const inner = factory2.createPartiallyEmittedExpression(classFunction);
            setTextRangeEnd(inner, node.end);
            setEmitFlags(inner, 3072 /* NoComments */ );
            const outer = factory2.createPartiallyEmittedExpression(inner);
            setTextRangeEnd(outer, skipTrivia(currentText, node.pos));
            setEmitFlags(outer, 3072 /* NoComments */ );
            const result = factory2.createParenthesizedExpression(factory2.createCallExpression(outer, /*typeArguments*/ void 0, extendsClauseElement ? [
                Debug.checkDefined(visitNode(extendsClauseElement.expression, visitor, isExpression))
            ] : []));
            addSyntheticLeadingComment(result, 3 /* MultiLineCommentTrivia */ , "* @class ");
            return result;
        }
        function transformClassBody(node, extendsClauseElement) {
            const statements = [];
            const name = factory2.getInternalName(node);
            const constructorLikeName = isIdentifierANonContextualKeyword(name) ? factory2.getGeneratedNameForNode(name) : name;
            startLexicalEnvironment();
            addExtendsHelperIfNeeded(statements, node, extendsClauseElement);
            addConstructor(statements, node, constructorLikeName, extendsClauseElement);
            addClassMembers(statements, node);
            const closingBraceLocation = createTokenRange(skipTrivia(currentText, node.members.end), 20 /* CloseBraceToken */ );
            const outer = factory2.createPartiallyEmittedExpression(constructorLikeName);
            setTextRangeEnd(outer, closingBraceLocation.end);
            setEmitFlags(outer, 3072 /* NoComments */ );
            const statement = factory2.createReturnStatement(outer);
            setTextRangePos(statement, closingBraceLocation.pos);
            setEmitFlags(statement, 3840 /* NoTokenSourceMaps */ );
            statements.push(statement);
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            const block = factory2.createBlock(setTextRange(factory2.createNodeArray(statements), /*location*/ node.members), /*multiLine*/ true);
            setEmitFlags(block, 3072 /* NoComments */ );
            return block;
        }
        function addExtendsHelperIfNeeded(statements, node, extendsClauseElement) {
            if (extendsClauseElement) statements.push(setTextRange(factory2.createExpressionStatement(emitHelpers().createExtendsHelper(factory2.getInternalName(node))), /*location*/ extendsClauseElement));
        }
        function addConstructor(statements, node, name, extendsClauseElement) {
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const ancestorFacts = enterSubtree(32662 /* ConstructorExcludes */ , 73 /* ConstructorIncludes */ );
            const constructor = getFirstConstructorWithBody(node);
            const hasSynthesizedSuper = hasSynthesizedDefaultSuperCall(constructor, extendsClauseElement !== void 0);
            const constructorFunction = factory2.createFunctionDeclaration(/*modifiers*/ void 0, /*asteriskToken*/ void 0, name, /*typeParameters*/ void 0, transformConstructorParameters(constructor, hasSynthesizedSuper), /*type*/ void 0, transformConstructorBody(constructor, node, extendsClauseElement, hasSynthesizedSuper));
            setTextRange(constructorFunction, constructor || node);
            if (extendsClauseElement) setEmitFlags(constructorFunction, 16 /* CapturesThis */ );
            statements.push(constructorFunction);
            exitSubtree(ancestorFacts, 98304 /* FunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
        }
        function transformConstructorParameters(constructor, hasSynthesizedSuper) {
            return visitParameterList(constructor && !hasSynthesizedSuper ? constructor.parameters : void 0, visitor, context) || [];
        }
        function createDefaultConstructorBody(node, isDerivedClass) {
            const statements = [];
            resumeLexicalEnvironment();
            factory2.mergeLexicalEnvironment(statements, endLexicalEnvironment());
            if (isDerivedClass) statements.push(factory2.createReturnStatement(createDefaultSuperCallOrThis()));
            const statementsArray = factory2.createNodeArray(statements);
            setTextRange(statementsArray, node.members);
            const block = factory2.createBlock(statementsArray, /*multiLine*/ true);
            setTextRange(block, node);
            setEmitFlags(block, 3072 /* NoComments */ );
            return block;
        }
        function transformConstructorBody(constructor, node, extendsClauseElement, hasSynthesizedSuper) {
            const isDerivedClass = !!extendsClauseElement && skipOuterExpressions(extendsClauseElement.expression).kind !== 106 /* NullKeyword */ ;
            if (!constructor) return createDefaultConstructorBody(node, isDerivedClass);
            const prologue = [];
            const statements = [];
            resumeLexicalEnvironment();
            const existingPrologue = takeWhile(constructor.body.statements, isPrologueDirective);
            const { superCall: superCall , superStatementIndex: superStatementIndex  } = findSuperCallAndStatementIndex(constructor.body.statements, existingPrologue);
            const postSuperStatementsStart = superStatementIndex === -1 ? existingPrologue.length : superStatementIndex + 1;
            let statementOffset = postSuperStatementsStart;
            if (!hasSynthesizedSuper) statementOffset = factory2.copyStandardPrologue(constructor.body.statements, prologue, statementOffset, /*ensureUseStrict*/ false);
            if (!hasSynthesizedSuper) statementOffset = factory2.copyCustomPrologue(constructor.body.statements, statements, statementOffset, visitor, /*filter*/ void 0);
            let superCallExpression;
            if (hasSynthesizedSuper) superCallExpression = createDefaultSuperCallOrThis();
            else if (superCall) superCallExpression = visitSuperCallInBody(superCall);
            if (superCallExpression) hierarchyFacts |= 8192 /* ConstructorWithCapturedSuper */ ;
            addDefaultValueAssignmentsIfNeeded2(prologue, constructor);
            addRestParameterIfNeeded(prologue, constructor, hasSynthesizedSuper);
            addRange(statements, visitNodes2(constructor.body.statements, visitor, isStatement, /*start*/ statementOffset));
            factory2.mergeLexicalEnvironment(prologue, endLexicalEnvironment());
            insertCaptureNewTargetIfNeeded(prologue, constructor, /*copyOnWrite*/ false);
            if (isDerivedClass || superCallExpression) {
                if (superCallExpression && postSuperStatementsStart === constructor.body.statements.length && !(constructor.body.transformFlags & 16384 /* ContainsLexicalThis */ )) {
                    const superCall2 = cast(cast(superCallExpression, isBinaryExpression).left, isCallExpression);
                    const returnStatement = factory2.createReturnStatement(superCallExpression);
                    setCommentRange(returnStatement, getCommentRange(superCall2));
                    setEmitFlags(superCall2, 3072 /* NoComments */ );
                    statements.push(returnStatement);
                } else {
                    if (superStatementIndex <= existingPrologue.length) insertCaptureThisForNode(statements, constructor, superCallExpression || createActualThis());
                    else {
                        insertCaptureThisForNode(prologue, constructor, createActualThis());
                        if (superCallExpression) insertSuperThisCaptureThisForNode(statements, superCallExpression);
                    }
                    if (!isSufficientlyCoveredByReturnStatements(constructor.body)) statements.push(factory2.createReturnStatement(factory2.createUniqueName("_this", 48 /* FileLevel */ )));
                }
            } else insertCaptureThisForNodeIfNeeded(prologue, constructor);
            const body = factory2.createBlock(setTextRange(factory2.createNodeArray([
                ...existingPrologue,
                ...prologue,
                ...superStatementIndex <= existingPrologue.length ? emptyArray : visitNodes2(constructor.body.statements, visitor, isStatement, existingPrologue.length, superStatementIndex - existingPrologue.length),
                ...statements
            ]), /*location*/ constructor.body.statements), /*multiLine*/ true);
            setTextRange(body, constructor.body);
            return body;
        }
        function findSuperCallAndStatementIndex(originalBodyStatements, existingPrologue) {
            for(let i = existingPrologue.length; i < originalBodyStatements.length; i += 1){
                const superCall = getSuperCallFromStatement(originalBodyStatements[i]);
                if (superCall) return {
                    superCall: superCall,
                    superStatementIndex: i
                };
            }
            return {
                superStatementIndex: -1
            };
        }
        function isSufficientlyCoveredByReturnStatements(statement) {
            if (statement.kind === 252 /* ReturnStatement */ ) return true;
            else if (statement.kind === 244 /* IfStatement */ ) {
                const ifStatement = statement;
                if (ifStatement.elseStatement) return isSufficientlyCoveredByReturnStatements(ifStatement.thenStatement) && isSufficientlyCoveredByReturnStatements(ifStatement.elseStatement);
            } else if (statement.kind === 240 /* Block */ ) {
                const lastStatement = lastOrUndefined(statement.statements);
                if (lastStatement && isSufficientlyCoveredByReturnStatements(lastStatement)) return true;
            }
            return false;
        }
        function createActualThis() {
            return setEmitFlags(factory2.createThis(), 8 /* NoSubstitution */ );
        }
        function createDefaultSuperCallOrThis() {
            return factory2.createLogicalOr(factory2.createLogicalAnd(factory2.createStrictInequality(factory2.createUniqueName("_super", 48 /* FileLevel */ ), factory2.createNull()), factory2.createFunctionApplyCall(factory2.createUniqueName("_super", 48 /* FileLevel */ ), createActualThis(), factory2.createIdentifier("arguments"))), createActualThis());
        }
        function visitParameter(node) {
            if (node.dotDotDotToken) return void 0;
            else if (isBindingPattern(node.name)) return setOriginalNode(setTextRange(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.getGeneratedNameForNode(node), /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0), /*location*/ node), /*original*/ node);
            else if (node.initializer) return setOriginalNode(setTextRange(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, node.name, /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0), /*location*/ node), /*original*/ node);
            else return node;
        }
        function hasDefaultValueOrBindingPattern(node) {
            return node.initializer !== void 0 || isBindingPattern(node.name);
        }
        function addDefaultValueAssignmentsIfNeeded2(statements, node) {
            if (!some(node.parameters, hasDefaultValueOrBindingPattern)) return false;
            let added = false;
            for (const parameter of node.parameters){
                const { name: name , initializer: initializer , dotDotDotToken: dotDotDotToken  } = parameter;
                if (dotDotDotToken) continue;
                if (isBindingPattern(name)) added = insertDefaultValueAssignmentForBindingPattern(statements, parameter, name, initializer) || added;
                else if (initializer) {
                    insertDefaultValueAssignmentForInitializer(statements, parameter, name, initializer);
                    added = true;
                }
            }
            return added;
        }
        function insertDefaultValueAssignmentForBindingPattern(statements, parameter, name, initializer) {
            if (name.elements.length > 0) {
                insertStatementAfterCustomPrologue(statements, setEmitFlags(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(flattenDestructuringBinding(parameter, visitor, context, 0 /* All */ , factory2.getGeneratedNameForNode(parameter)))), 2097152 /* CustomPrologue */ ));
                return true;
            } else if (initializer) {
                insertStatementAfterCustomPrologue(statements, setEmitFlags(factory2.createExpressionStatement(factory2.createAssignment(factory2.getGeneratedNameForNode(parameter), Debug.checkDefined(visitNode(initializer, visitor, isExpression)))), 2097152 /* CustomPrologue */ ));
                return true;
            }
            return false;
        }
        function insertDefaultValueAssignmentForInitializer(statements, parameter, name, initializer) {
            initializer = Debug.checkDefined(visitNode(initializer, visitor, isExpression));
            const statement = factory2.createIfStatement(factory2.createTypeCheck(factory2.cloneNode(name), "undefined"), setEmitFlags(setTextRange(factory2.createBlock([
                factory2.createExpressionStatement(setEmitFlags(setTextRange(factory2.createAssignment(// TODO(rbuckton): Does this need to be parented?
                setEmitFlags(setParent(setTextRange(factory2.cloneNode(name), name), name.parent), 96 /* NoSourceMap */ ), setEmitFlags(initializer, 96 /* NoSourceMap */  | getEmitFlags(initializer) | 3072 /* NoComments */ )), parameter), 3072 /* NoComments */ ))
            ]), parameter), 3905 /* NoComments */ ));
            startOnNewLine(statement);
            setTextRange(statement, parameter);
            setEmitFlags(statement, 2101056 /* NoComments */ );
            insertStatementAfterCustomPrologue(statements, statement);
        }
        function shouldAddRestParameter(node, inConstructorWithSynthesizedSuper) {
            return !!(node && node.dotDotDotToken && !inConstructorWithSynthesizedSuper);
        }
        function addRestParameterIfNeeded(statements, node, inConstructorWithSynthesizedSuper) {
            const prologueStatements = [];
            const parameter = lastOrUndefined(node.parameters);
            if (!shouldAddRestParameter(parameter, inConstructorWithSynthesizedSuper)) return false;
            const declarationName = parameter.name.kind === 80 /* Identifier */  ? setParent(setTextRange(factory2.cloneNode(parameter.name), parameter.name), parameter.name.parent) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            setEmitFlags(declarationName, 96 /* NoSourceMap */ );
            const expressionName = parameter.name.kind === 80 /* Identifier */  ? factory2.cloneNode(parameter.name) : declarationName;
            const restIndex = node.parameters.length - 1;
            const temp = factory2.createLoopVariable();
            prologueStatements.push(setEmitFlags(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(declarationName, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createArrayLiteralExpression([]))
            ])), /*location*/ parameter), 2097152 /* CustomPrologue */ ));
            const forStatement = factory2.createForStatement(setTextRange(factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(temp, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createNumericLiteral(restIndex))
            ]), parameter), setTextRange(factory2.createLessThan(temp, factory2.createPropertyAccessExpression(factory2.createIdentifier("arguments"), "length")), parameter), setTextRange(factory2.createPostfixIncrement(temp), parameter), factory2.createBlock([
                startOnNewLine(setTextRange(factory2.createExpressionStatement(factory2.createAssignment(factory2.createElementAccessExpression(expressionName, restIndex === 0 ? temp : factory2.createSubtract(temp, factory2.createNumericLiteral(restIndex))), factory2.createElementAccessExpression(factory2.createIdentifier("arguments"), temp))), /*location*/ parameter))
            ]));
            setEmitFlags(forStatement, 2097152 /* CustomPrologue */ );
            startOnNewLine(forStatement);
            prologueStatements.push(forStatement);
            if (parameter.name.kind !== 80 /* Identifier */ ) prologueStatements.push(setEmitFlags(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(flattenDestructuringBinding(parameter, visitor, context, 0 /* All */ , expressionName))), parameter), 2097152 /* CustomPrologue */ ));
            insertStatementsAfterCustomPrologue(statements, prologueStatements);
            return true;
        }
        function insertCaptureThisForNodeIfNeeded(statements, node) {
            if (hierarchyFacts & 65536 /* CapturedLexicalThis */  && node.kind !== 218 /* ArrowFunction */ ) {
                insertCaptureThisForNode(statements, node, factory2.createThis());
                return true;
            }
            return false;
        }
        function insertSuperThisCaptureThisForNode(statements, superExpression) {
            enableSubstitutionsForCapturedThis();
            const assignSuperExpression = factory2.createExpressionStatement(factory2.createBinaryExpression(factory2.createThis(), 64 /* EqualsToken */ , superExpression));
            insertStatementAfterCustomPrologue(statements, assignSuperExpression);
            setCommentRange(assignSuperExpression, getOriginalNode(superExpression).parent);
        }
        function insertCaptureThisForNode(statements, node, initializer) {
            enableSubstitutionsForCapturedThis();
            const captureThisStatement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(factory2.createUniqueName("_this", 48 /* FileLevel */ ), /*exclamationToken*/ void 0, /*type*/ void 0, initializer)
            ]));
            setEmitFlags(captureThisStatement, 2100224 /* CustomPrologue */ );
            setSourceMapRange(captureThisStatement, node);
            insertStatementAfterCustomPrologue(statements, captureThisStatement);
        }
        function insertCaptureNewTargetIfNeeded(statements, node, copyOnWrite) {
            if (hierarchyFacts & 32768 /* NewTarget */ ) {
                let newTarget;
                switch(node.kind){
                    case 218 /* ArrowFunction */ :
                        return statements;
                    case 173 /* MethodDeclaration */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                        newTarget = factory2.createVoidZero();
                        break;
                    case 175 /* Constructor */ :
                        newTarget = factory2.createPropertyAccessExpression(setEmitFlags(factory2.createThis(), 8 /* NoSubstitution */ ), "constructor");
                        break;
                    case 261 /* FunctionDeclaration */ :
                    case 217 /* FunctionExpression */ :
                        newTarget = factory2.createConditionalExpression(factory2.createLogicalAnd(setEmitFlags(factory2.createThis(), 8 /* NoSubstitution */ ), factory2.createBinaryExpression(setEmitFlags(factory2.createThis(), 8 /* NoSubstitution */ ), 104 /* InstanceOfKeyword */ , factory2.getLocalName(node))), /*questionToken*/ void 0, factory2.createPropertyAccessExpression(setEmitFlags(factory2.createThis(), 8 /* NoSubstitution */ ), "constructor"), /*colonToken*/ void 0, factory2.createVoidZero());
                        break;
                    default:
                        return Debug.failBadSyntaxKind(node);
                }
                const captureNewTargetStatement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(factory2.createUniqueName("_newTarget", 48 /* FileLevel */ ), /*exclamationToken*/ void 0, /*type*/ void 0, newTarget)
                ]));
                setEmitFlags(captureNewTargetStatement, 2100224 /* CustomPrologue */ );
                if (copyOnWrite) statements = statements.slice();
                insertStatementAfterCustomPrologue(statements, captureNewTargetStatement);
            }
            return statements;
        }
        function addClassMembers(statements, node) {
            for (const member of node.members)switch(member.kind){
                case 239 /* SemicolonClassElement */ :
                    statements.push(transformSemicolonClassElementToStatement(member));
                    break;
                case 173 /* MethodDeclaration */ :
                    statements.push(transformClassMethodDeclarationToStatement(getClassMemberPrefix(node, member), member, node));
                    break;
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    const accessors = getAllAccessorDeclarations(node.members, member);
                    if (member === accessors.firstAccessor) statements.push(transformAccessorsToStatement(getClassMemberPrefix(node, member), accessors, node));
                    break;
                case 175 /* Constructor */ :
                case 174 /* ClassStaticBlockDeclaration */ :
                    break;
                default:
                    Debug.failBadSyntaxKind(member, currentSourceFile && currentSourceFile.fileName);
                    break;
            }
        }
        function transformSemicolonClassElementToStatement(member) {
            return setTextRange(factory2.createEmptyStatement(), member);
        }
        function transformClassMethodDeclarationToStatement(receiver, member, container) {
            const commentRange = getCommentRange(member);
            const sourceMapRange = getSourceMapRange(member);
            const memberFunction = transformFunctionLikeToExpression(member, /*location*/ member, /*name*/ void 0, container);
            const propertyName = visitNode(member.name, visitor, isPropertyName);
            Debug.assert(propertyName);
            let e;
            if (!isPrivateIdentifier(propertyName) && getUseDefineForClassFields(context.getCompilerOptions())) {
                const name = isComputedPropertyName(propertyName) ? propertyName.expression : isIdentifier(propertyName) ? factory2.createStringLiteral(unescapeLeadingUnderscores(propertyName.escapedText)) : propertyName;
                e = factory2.createObjectDefinePropertyCall(receiver, name, factory2.createPropertyDescriptor({
                    value: memberFunction,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }));
            } else {
                const memberName = createMemberAccessForPropertyName(factory2, receiver, propertyName, /*location*/ member.name);
                e = factory2.createAssignment(memberName, memberFunction);
            }
            setEmitFlags(memberFunction, 3072 /* NoComments */ );
            setSourceMapRange(memberFunction, sourceMapRange);
            const statement = setTextRange(factory2.createExpressionStatement(e), /*location*/ member);
            setOriginalNode(statement, member);
            setCommentRange(statement, commentRange);
            setEmitFlags(statement, 96 /* NoSourceMap */ );
            return statement;
        }
        function transformAccessorsToStatement(receiver, accessors, container) {
            const statement = factory2.createExpressionStatement(transformAccessorsToExpression(receiver, accessors, container, /*startsOnNewLine*/ false));
            setEmitFlags(statement, 3072 /* NoComments */ );
            setSourceMapRange(statement, getSourceMapRange(accessors.firstAccessor));
            return statement;
        }
        function transformAccessorsToExpression(receiver, { firstAccessor: firstAccessor , getAccessor: getAccessor , setAccessor: setAccessor  }, container, startsOnNewLine) {
            const target = setParent(setTextRange(factory2.cloneNode(receiver), receiver), receiver.parent);
            setEmitFlags(target, 3136 /* NoTrailingSourceMap */ );
            setSourceMapRange(target, firstAccessor.name);
            const visitedAccessorName = visitNode(firstAccessor.name, visitor, isPropertyName);
            Debug.assert(visitedAccessorName);
            if (isPrivateIdentifier(visitedAccessorName)) return Debug.failBadSyntaxKind(visitedAccessorName, "Encountered unhandled private identifier while transforming ES2015.");
            const propertyName = createExpressionForPropertyName(factory2, visitedAccessorName);
            setEmitFlags(propertyName, 3104 /* NoLeadingSourceMap */ );
            setSourceMapRange(propertyName, firstAccessor.name);
            const properties = [];
            if (getAccessor) {
                const getterFunction = transformFunctionLikeToExpression(getAccessor, /*location*/ void 0, /*name*/ void 0, container);
                setSourceMapRange(getterFunction, getSourceMapRange(getAccessor));
                setEmitFlags(getterFunction, 1024 /* NoLeadingComments */ );
                const getter = factory2.createPropertyAssignment("get", getterFunction);
                setCommentRange(getter, getCommentRange(getAccessor));
                properties.push(getter);
            }
            if (setAccessor) {
                const setterFunction = transformFunctionLikeToExpression(setAccessor, /*location*/ void 0, /*name*/ void 0, container);
                setSourceMapRange(setterFunction, getSourceMapRange(setAccessor));
                setEmitFlags(setterFunction, 1024 /* NoLeadingComments */ );
                const setter = factory2.createPropertyAssignment("set", setterFunction);
                setCommentRange(setter, getCommentRange(setAccessor));
                properties.push(setter);
            }
            properties.push(factory2.createPropertyAssignment("enumerable", getAccessor || setAccessor ? factory2.createFalse() : factory2.createTrue()), factory2.createPropertyAssignment("configurable", factory2.createTrue()));
            const call = factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Object"), "defineProperty"), /*typeArguments*/ void 0, [
                target,
                propertyName,
                factory2.createObjectLiteralExpression(properties, /*multiLine*/ true)
            ]);
            if (startsOnNewLine) startOnNewLine(call);
            return call;
        }
        function visitArrowFunction(node) {
            if (node.transformFlags & 16384 /* ContainsLexicalThis */  && !(hierarchyFacts & 16384 /* StaticInitializer */ )) hierarchyFacts |= 65536 /* CapturedLexicalThis */ ;
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const ancestorFacts = enterSubtree(15232 /* ArrowFunctionExcludes */ , 66 /* ArrowFunctionIncludes */ );
            const func = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, transformFunctionBody2(node));
            setTextRange(func, node);
            setOriginalNode(func, node);
            setEmitFlags(func, 16 /* CapturesThis */ );
            exitSubtree(ancestorFacts, 0 /* ArrowFunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
            return func;
        }
        function visitFunctionExpression(node) {
            const ancestorFacts = getEmitFlags(node) & 524288 /* AsyncFunctionBody */  ? enterSubtree(32662 /* AsyncFunctionBodyExcludes */ , 69 /* AsyncFunctionBodyIncludes */ ) : enterSubtree(32670 /* FunctionExcludes */ , 65 /* FunctionIncludes */ );
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const parameters = visitParameterList(node.parameters, visitor, context);
            const body = transformFunctionBody2(node);
            const name = hierarchyFacts & 32768 /* NewTarget */  ? factory2.getLocalName(node) : node.name;
            exitSubtree(ancestorFacts, 98304 /* FunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
            return factory2.updateFunctionExpression(node, /*modifiers*/ void 0, node.asteriskToken, name, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body);
        }
        function visitFunctionDeclaration(node) {
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const ancestorFacts = enterSubtree(32670 /* FunctionExcludes */ , 65 /* FunctionIncludes */ );
            const parameters = visitParameterList(node.parameters, visitor, context);
            const body = transformFunctionBody2(node);
            const name = hierarchyFacts & 32768 /* NewTarget */  ? factory2.getLocalName(node) : node.name;
            exitSubtree(ancestorFacts, 98304 /* FunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
            return factory2.updateFunctionDeclaration(node, visitNodes2(node.modifiers, visitor, isModifier), node.asteriskToken, name, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body);
        }
        function transformFunctionLikeToExpression(node, location, name, container) {
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const ancestorFacts = container && isClassLike(container) && !isStatic(node) ? enterSubtree(32670 /* FunctionExcludes */ , 73 /* NonStaticClassElement */ ) : enterSubtree(32670 /* FunctionExcludes */ , 65 /* FunctionIncludes */ );
            const parameters = visitParameterList(node.parameters, visitor, context);
            const body = transformFunctionBody2(node);
            if (hierarchyFacts & 32768 /* NewTarget */  && !name && (node.kind === 261 /* FunctionDeclaration */  || node.kind === 217 /* FunctionExpression */ )) name = factory2.getGeneratedNameForNode(node);
            exitSubtree(ancestorFacts, 98304 /* FunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
            return setOriginalNode(setTextRange(factory2.createFunctionExpression(/*modifiers*/ void 0, node.asteriskToken, name, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body), location), /*original*/ node);
        }
        function transformFunctionBody2(node) {
            let multiLine = false;
            let singleLine = false;
            let statementsLocation;
            let closeBraceLocation;
            const prologue = [];
            const statements = [];
            const body = node.body;
            let statementOffset;
            resumeLexicalEnvironment();
            if (isBlock(body)) {
                statementOffset = factory2.copyStandardPrologue(body.statements, prologue, 0, /*ensureUseStrict*/ false);
                statementOffset = factory2.copyCustomPrologue(body.statements, statements, statementOffset, visitor, isHoistedFunction);
                statementOffset = factory2.copyCustomPrologue(body.statements, statements, statementOffset, visitor, isHoistedVariableStatement);
            }
            multiLine = addDefaultValueAssignmentsIfNeeded2(statements, node) || multiLine;
            multiLine = addRestParameterIfNeeded(statements, node, /*inConstructorWithSynthesizedSuper*/ false) || multiLine;
            if (isBlock(body)) {
                statementOffset = factory2.copyCustomPrologue(body.statements, statements, statementOffset, visitor);
                statementsLocation = body.statements;
                addRange(statements, visitNodes2(body.statements, visitor, isStatement, statementOffset));
                if (!multiLine && body.multiLine) multiLine = true;
            } else {
                Debug.assert(node.kind === 218 /* ArrowFunction */ );
                statementsLocation = moveRangeEnd(body, -1);
                const equalsGreaterThanToken = node.equalsGreaterThanToken;
                if (!nodeIsSynthesized(equalsGreaterThanToken) && !nodeIsSynthesized(body)) {
                    if (rangeEndIsOnSameLineAsRangeStart(equalsGreaterThanToken, body, currentSourceFile)) singleLine = true;
                    else multiLine = true;
                }
                const expression = visitNode(body, visitor, isExpression);
                const returnStatement = factory2.createReturnStatement(expression);
                setTextRange(returnStatement, body);
                moveSyntheticComments(returnStatement, body);
                setEmitFlags(returnStatement, 2880 /* NoTrailingComments */ );
                statements.push(returnStatement);
                closeBraceLocation = body;
            }
            factory2.mergeLexicalEnvironment(prologue, endLexicalEnvironment());
            insertCaptureNewTargetIfNeeded(prologue, node, /*copyOnWrite*/ false);
            insertCaptureThisForNodeIfNeeded(prologue, node);
            if (some(prologue)) multiLine = true;
            statements.unshift(...prologue);
            if (isBlock(body) && arrayIsEqualTo(statements, body.statements)) return body;
            const block = factory2.createBlock(setTextRange(factory2.createNodeArray(statements), statementsLocation), multiLine);
            setTextRange(block, node.body);
            if (!multiLine && singleLine) setEmitFlags(block, 1 /* SingleLine */ );
            if (closeBraceLocation) setTokenSourceMapRange(block, 20 /* CloseBraceToken */ , closeBraceLocation);
            setOriginalNode(block, node.body);
            return block;
        }
        function visitBlock(node, isFunctionBody2) {
            if (isFunctionBody2) return visitEachChild(node, visitor, context);
            const ancestorFacts = hierarchyFacts & 256 /* IterationStatement */  ? enterSubtree(7104 /* IterationStatementBlockExcludes */ , 512 /* IterationStatementBlockIncludes */ ) : enterSubtree(6976 /* BlockExcludes */ , 128 /* BlockIncludes */ );
            const updated = visitEachChild(node, visitor, context);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function visitExpressionStatement(node) {
            return visitEachChild(node, visitorWithUnusedExpressionResult, context);
        }
        function visitParenthesizedExpression(node, expressionResultIsUnused2) {
            return visitEachChild(node, expressionResultIsUnused2 ? visitorWithUnusedExpressionResult : visitor, context);
        }
        function visitBinaryExpression(node, expressionResultIsUnused2) {
            if (isDestructuringAssignment(node)) return flattenDestructuringAssignment(node, visitor, context, 0 /* All */ , !expressionResultIsUnused2);
            if (node.operatorToken.kind === 28 /* CommaToken */ ) return factory2.updateBinaryExpression(node, Debug.checkDefined(visitNode(node.left, visitorWithUnusedExpressionResult, isExpression)), node.operatorToken, Debug.checkDefined(visitNode(node.right, expressionResultIsUnused2 ? visitorWithUnusedExpressionResult : visitor, isExpression)));
            return visitEachChild(node, visitor, context);
        }
        function visitCommaListExpression(node, expressionResultIsUnused2) {
            if (expressionResultIsUnused2) return visitEachChild(node, visitorWithUnusedExpressionResult, context);
            let result;
            for(let i = 0; i < node.elements.length; i++){
                const element = node.elements[i];
                const visited = visitNode(element, i < node.elements.length - 1 ? visitorWithUnusedExpressionResult : visitor, isExpression);
                if (result || visited !== element) {
                    result || (result = node.elements.slice(0, i));
                    Debug.assert(visited);
                    result.push(visited);
                }
            }
            const elements = result ? setTextRange(factory2.createNodeArray(result), node.elements) : node.elements;
            return factory2.updateCommaListExpression(node, elements);
        }
        function isVariableStatementOfTypeScriptClassWrapper(node) {
            return node.declarationList.declarations.length === 1 && !!node.declarationList.declarations[0].initializer && !!(getInternalEmitFlags(node.declarationList.declarations[0].initializer) & 1 /* TypeScriptClassWrapper */ );
        }
        function visitVariableStatement(node) {
            const ancestorFacts = enterSubtree(0 /* None */ , hasSyntacticModifier(node, 1 /* Export */ ) ? 32 /* ExportedVariableStatement */  : 0 /* None */ );
            let updated;
            if (convertedLoopState && (node.declarationList.flags & 3 /* BlockScoped */ ) === 0 && !isVariableStatementOfTypeScriptClassWrapper(node)) {
                let assignments;
                for (const decl of node.declarationList.declarations){
                    hoistVariableDeclarationDeclaredInConvertedLoop(convertedLoopState, decl);
                    if (decl.initializer) {
                        let assignment;
                        if (isBindingPattern(decl.name)) assignment = flattenDestructuringAssignment(decl, visitor, context, 0 /* All */ );
                        else {
                            assignment = factory2.createBinaryExpression(decl.name, 64 /* EqualsToken */ , Debug.checkDefined(visitNode(decl.initializer, visitor, isExpression)));
                            setTextRange(assignment, decl);
                        }
                        assignments = append(assignments, assignment);
                    }
                }
                if (assignments) updated = setTextRange(factory2.createExpressionStatement(factory2.inlineExpressions(assignments)), node);
                else updated = void 0;
            } else updated = visitEachChild(node, visitor, context);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function visitVariableDeclarationList(node) {
            if (node.flags & 3 /* BlockScoped */  || node.transformFlags & 524288 /* ContainsBindingPattern */ ) {
                if (node.flags & 3 /* BlockScoped */ ) enableSubstitutionsForBlockScopedBindings();
                const declarations = visitNodes2(node.declarations, node.flags & 1 /* Let */  ? visitVariableDeclarationInLetDeclarationList : visitVariableDeclaration, isVariableDeclaration);
                const declarationList = factory2.createVariableDeclarationList(declarations);
                setOriginalNode(declarationList, node);
                setTextRange(declarationList, node);
                setCommentRange(declarationList, node);
                if (node.transformFlags & 524288 /* ContainsBindingPattern */  && (isBindingPattern(node.declarations[0].name) || isBindingPattern(last(node.declarations).name))) setSourceMapRange(declarationList, getRangeUnion(declarations));
                return declarationList;
            }
            return visitEachChild(node, visitor, context);
        }
        function getRangeUnion(declarations) {
            let pos = -1, end = -1;
            for (const node of declarations){
                pos = pos === -1 ? node.pos : node.pos === -1 ? pos : Math.min(pos, node.pos);
                end = Math.max(end, node.end);
            }
            return createRange(pos, end);
        }
        function shouldEmitExplicitInitializerForLetDeclaration(node) {
            const flags = resolver.getNodeCheckFlags(node);
            const isCapturedInFunction = flags & 16384 /* CapturedBlockScopedBinding */ ;
            const isDeclaredInLoop = flags & 32768 /* BlockScopedBindingInLoop */ ;
            const emittedAsTopLevel = (hierarchyFacts & 64 /* TopLevel */ ) !== 0 || isCapturedInFunction && isDeclaredInLoop && (hierarchyFacts & 512 /* IterationStatementBlock */ ) !== 0;
            const emitExplicitInitializer = !emittedAsTopLevel && (hierarchyFacts & 4096 /* ForInOrForOfStatement */ ) === 0 && (!resolver.isDeclarationWithCollidingName(node) || isDeclaredInLoop && !isCapturedInFunction && (hierarchyFacts & 6144 /* ForInOrForOfStatement */ ) === 0);
            return emitExplicitInitializer;
        }
        function visitVariableDeclarationInLetDeclarationList(node) {
            const name = node.name;
            if (isBindingPattern(name)) return visitVariableDeclaration(node);
            if (!node.initializer && shouldEmitExplicitInitializerForLetDeclaration(node)) return factory2.updateVariableDeclaration(node, node.name, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createVoidZero());
            return visitEachChild(node, visitor, context);
        }
        function visitVariableDeclaration(node) {
            const ancestorFacts = enterSubtree(32 /* ExportedVariableStatement */ , 0 /* None */ );
            let updated;
            if (isBindingPattern(node.name)) updated = flattenDestructuringBinding(node, visitor, context, 0 /* All */ , /*rval*/ void 0, (ancestorFacts & 32 /* ExportedVariableStatement */ ) !== 0);
            else updated = visitEachChild(node, visitor, context);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function recordLabel(node) {
            convertedLoopState.labels.set(idText(node.label), true);
        }
        function resetLabel(node) {
            convertedLoopState.labels.set(idText(node.label), false);
        }
        function visitLabeledStatement(node) {
            if (convertedLoopState && !convertedLoopState.labels) convertedLoopState.labels = /* @__PURE__ */ new Map();
            const statement = unwrapInnermostStatementOfLabel(node, convertedLoopState && recordLabel);
            return isIterationStatement(statement, /*lookInLabeledStatements*/ false) ? visitIterationStatement(statement, /*outermostLabeledStatement*/ node) : factory2.restoreEnclosingLabel(Debug.checkDefined(visitNode(statement, visitor, isStatement, factory2.liftToBlock)), node, convertedLoopState && resetLabel);
        }
        function visitIterationStatement(node, outermostLabeledStatement) {
            switch(node.kind){
                case 245 /* DoStatement */ :
                case 246 /* WhileStatement */ :
                    return visitDoOrWhileStatement(node, outermostLabeledStatement);
                case 247 /* ForStatement */ :
                    return visitForStatement(node, outermostLabeledStatement);
                case 248 /* ForInStatement */ :
                    return visitForInStatement(node, outermostLabeledStatement);
                case 249 /* ForOfStatement */ :
                    return visitForOfStatement(node, outermostLabeledStatement);
            }
        }
        function visitIterationStatementWithFacts(excludeFacts, includeFacts, node, outermostLabeledStatement, convert) {
            const ancestorFacts = enterSubtree(excludeFacts, includeFacts);
            const updated = convertIterationStatementBodyIfNecessary(node, outermostLabeledStatement, ancestorFacts, convert);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function visitDoOrWhileStatement(node, outermostLabeledStatement) {
            return visitIterationStatementWithFacts(0 /* DoOrWhileStatementExcludes */ , 1280 /* DoOrWhileStatementIncludes */ , node, outermostLabeledStatement);
        }
        function visitForStatement(node, outermostLabeledStatement) {
            return visitIterationStatementWithFacts(5056 /* ForStatementExcludes */ , 3328 /* ForStatementIncludes */ , node, outermostLabeledStatement);
        }
        function visitEachChildOfForStatement2(node) {
            return factory2.updateForStatement(node, visitNode(node.initializer, visitorWithUnusedExpressionResult, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, visitorWithUnusedExpressionResult, isExpression), Debug.checkDefined(visitNode(node.statement, visitor, isStatement, factory2.liftToBlock)));
        }
        function visitForInStatement(node, outermostLabeledStatement) {
            return visitIterationStatementWithFacts(3008 /* ForInOrForOfStatementExcludes */ , 5376 /* ForInOrForOfStatementIncludes */ , node, outermostLabeledStatement);
        }
        function visitForOfStatement(node, outermostLabeledStatement) {
            return visitIterationStatementWithFacts(3008 /* ForInOrForOfStatementExcludes */ , 5376 /* ForInOrForOfStatementIncludes */ , node, outermostLabeledStatement, compilerOptions.downlevelIteration ? convertForOfStatementForIterable : convertForOfStatementForArray);
        }
        function convertForOfStatementHead(node, boundValue, convertedLoopBodyStatements) {
            const statements = [];
            const initializer = node.initializer;
            if (isVariableDeclarationList(initializer)) {
                if (node.initializer.flags & 3 /* BlockScoped */ ) enableSubstitutionsForBlockScopedBindings();
                const firstOriginalDeclaration = firstOrUndefined(initializer.declarations);
                if (firstOriginalDeclaration && isBindingPattern(firstOriginalDeclaration.name)) {
                    const declarations = flattenDestructuringBinding(firstOriginalDeclaration, visitor, context, 0 /* All */ , boundValue);
                    const declarationList = setTextRange(factory2.createVariableDeclarationList(declarations), node.initializer);
                    setOriginalNode(declarationList, node.initializer);
                    setSourceMapRange(declarationList, createRange(declarations[0].pos, last(declarations).end));
                    statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, declarationList));
                } else statements.push(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, setOriginalNode(setTextRange(factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(firstOriginalDeclaration ? firstOriginalDeclaration.name : factory2.createTempVariable(/*recordTempVariable*/ void 0), /*exclamationToken*/ void 0, /*type*/ void 0, boundValue)
                ]), moveRangePos(initializer, -1)), initializer)), moveRangeEnd(initializer, -1)));
            } else {
                const assignment = factory2.createAssignment(initializer, boundValue);
                if (isDestructuringAssignment(assignment)) statements.push(factory2.createExpressionStatement(visitBinaryExpression(assignment, /*expressionResultIsUnused*/ true)));
                else {
                    setTextRangeEnd(assignment, initializer.end);
                    statements.push(setTextRange(factory2.createExpressionStatement(Debug.checkDefined(visitNode(assignment, visitor, isExpression))), moveRangeEnd(initializer, -1)));
                }
            }
            if (convertedLoopBodyStatements) return createSyntheticBlockForConvertedStatements(addRange(statements, convertedLoopBodyStatements));
            else {
                const statement = visitNode(node.statement, visitor, isStatement, factory2.liftToBlock);
                Debug.assert(statement);
                if (isBlock(statement)) return factory2.updateBlock(statement, setTextRange(factory2.createNodeArray(concatenate(statements, statement.statements)), statement.statements));
                else {
                    statements.push(statement);
                    return createSyntheticBlockForConvertedStatements(statements);
                }
            }
        }
        function createSyntheticBlockForConvertedStatements(statements) {
            return setEmitFlags(factory2.createBlock(factory2.createNodeArray(statements), /*multiLine*/ true), 864 /* NoTokenSourceMaps */ );
        }
        function convertForOfStatementForArray(node, outermostLabeledStatement, convertedLoopBodyStatements) {
            const expression = visitNode(node.expression, visitor, isExpression);
            Debug.assert(expression);
            const counter = factory2.createLoopVariable();
            const rhsReference = isIdentifier(expression) ? factory2.getGeneratedNameForNode(expression) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            setEmitFlags(expression, 96 /* NoSourceMap */  | getEmitFlags(expression));
            const forStatement = setTextRange(factory2.createForStatement(/*initializer*/ setEmitFlags(setTextRange(factory2.createVariableDeclarationList([
                setTextRange(factory2.createVariableDeclaration(counter, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createNumericLiteral(0)), moveRangePos(node.expression, -1)),
                setTextRange(factory2.createVariableDeclaration(rhsReference, /*exclamationToken*/ void 0, /*type*/ void 0, expression), node.expression)
            ]), node.expression), 4194304 /* NoHoisting */ ), /*condition*/ setTextRange(factory2.createLessThan(counter, factory2.createPropertyAccessExpression(rhsReference, "length")), node.expression), /*incrementor*/ setTextRange(factory2.createPostfixIncrement(counter), node.expression), /*statement*/ convertForOfStatementHead(node, factory2.createElementAccessExpression(rhsReference, counter), convertedLoopBodyStatements)), /*location*/ node);
            setEmitFlags(forStatement, 512 /* NoTokenTrailingSourceMaps */ );
            setTextRange(forStatement, node);
            return factory2.restoreEnclosingLabel(forStatement, outermostLabeledStatement, convertedLoopState && resetLabel);
        }
        function convertForOfStatementForIterable(node, outermostLabeledStatement, convertedLoopBodyStatements, ancestorFacts) {
            const expression = visitNode(node.expression, visitor, isExpression);
            Debug.assert(expression);
            const iterator = isIdentifier(expression) ? factory2.getGeneratedNameForNode(expression) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const result = isIdentifier(expression) ? factory2.getGeneratedNameForNode(iterator) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const errorRecord = factory2.createUniqueName("e");
            const catchVariable = factory2.getGeneratedNameForNode(errorRecord);
            const returnMethod = factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const values = setTextRange(emitHelpers().createValuesHelper(expression), node.expression);
            const next = factory2.createCallExpression(factory2.createPropertyAccessExpression(iterator, "next"), /*typeArguments*/ void 0, []);
            hoistVariableDeclaration(errorRecord);
            hoistVariableDeclaration(returnMethod);
            const initializer = ancestorFacts & 1024 /* IterationContainer */  ? factory2.inlineExpressions([
                factory2.createAssignment(errorRecord, factory2.createVoidZero()),
                values
            ]) : values;
            const forStatement = setEmitFlags(setTextRange(factory2.createForStatement(/*initializer*/ setEmitFlags(setTextRange(factory2.createVariableDeclarationList([
                setTextRange(factory2.createVariableDeclaration(iterator, /*exclamationToken*/ void 0, /*type*/ void 0, initializer), node.expression),
                factory2.createVariableDeclaration(result, /*exclamationToken*/ void 0, /*type*/ void 0, next)
            ]), node.expression), 4194304 /* NoHoisting */ ), /*condition*/ factory2.createLogicalNot(factory2.createPropertyAccessExpression(result, "done")), /*incrementor*/ factory2.createAssignment(result, next), /*statement*/ convertForOfStatementHead(node, factory2.createPropertyAccessExpression(result, "value"), convertedLoopBodyStatements)), /*location*/ node), 512 /* NoTokenTrailingSourceMaps */ );
            return factory2.createTryStatement(factory2.createBlock([
                factory2.restoreEnclosingLabel(forStatement, outermostLabeledStatement, convertedLoopState && resetLabel)
            ]), factory2.createCatchClause(factory2.createVariableDeclaration(catchVariable), setEmitFlags(factory2.createBlock([
                factory2.createExpressionStatement(factory2.createAssignment(errorRecord, factory2.createObjectLiteralExpression([
                    factory2.createPropertyAssignment("error", catchVariable)
                ])))
            ]), 1 /* SingleLine */ )), factory2.createBlock([
                factory2.createTryStatement(/*tryBlock*/ factory2.createBlock([
                    setEmitFlags(factory2.createIfStatement(factory2.createLogicalAnd(factory2.createLogicalAnd(result, factory2.createLogicalNot(factory2.createPropertyAccessExpression(result, "done"))), factory2.createAssignment(returnMethod, factory2.createPropertyAccessExpression(iterator, "return"))), factory2.createExpressionStatement(factory2.createFunctionCallCall(returnMethod, iterator, []))), 1 /* SingleLine */ )
                ]), /*catchClause*/ void 0, /*finallyBlock*/ setEmitFlags(factory2.createBlock([
                    setEmitFlags(factory2.createIfStatement(errorRecord, factory2.createThrowStatement(factory2.createPropertyAccessExpression(errorRecord, "error"))), 1 /* SingleLine */ )
                ]), 1 /* SingleLine */ ))
            ]));
        }
        function visitObjectLiteralExpression(node) {
            const properties = node.properties;
            let numInitialProperties = -1, hasComputed = false;
            for(let i = 0; i < properties.length; i++){
                const property = properties[i];
                if (property.transformFlags & 1048576 /* ContainsYield */  && hierarchyFacts & 4 /* AsyncFunctionBody */  || (hasComputed = Debug.checkDefined(property.name).kind === 166 /* ComputedPropertyName */ )) {
                    numInitialProperties = i;
                    break;
                }
            }
            if (numInitialProperties < 0) return visitEachChild(node, visitor, context);
            const temp = factory2.createTempVariable(hoistVariableDeclaration);
            const expressions = [];
            const assignment = factory2.createAssignment(temp, setEmitFlags(factory2.createObjectLiteralExpression(visitNodes2(properties, visitor, isObjectLiteralElementLike, 0, numInitialProperties), node.multiLine), hasComputed ? 131072 /* Indented */  : 0));
            if (node.multiLine) startOnNewLine(assignment);
            expressions.push(assignment);
            addObjectLiteralMembers(expressions, node, temp, numInitialProperties);
            expressions.push(node.multiLine ? startOnNewLine(setParent(setTextRange(factory2.cloneNode(temp), temp), temp.parent)) : temp);
            return factory2.inlineExpressions(expressions);
        }
        function shouldConvertPartOfIterationStatement(node) {
            return (resolver.getNodeCheckFlags(node) & 8192 /* ContainsCapturedBlockScopeBinding */ ) !== 0;
        }
        function shouldConvertInitializerOfForStatement(node) {
            return isForStatement(node) && !!node.initializer && shouldConvertPartOfIterationStatement(node.initializer);
        }
        function shouldConvertConditionOfForStatement(node) {
            return isForStatement(node) && !!node.condition && shouldConvertPartOfIterationStatement(node.condition);
        }
        function shouldConvertIncrementorOfForStatement(node) {
            return isForStatement(node) && !!node.incrementor && shouldConvertPartOfIterationStatement(node.incrementor);
        }
        function shouldConvertIterationStatement(node) {
            return shouldConvertBodyOfIterationStatement(node) || shouldConvertInitializerOfForStatement(node);
        }
        function shouldConvertBodyOfIterationStatement(node) {
            return (resolver.getNodeCheckFlags(node) & 4096 /* LoopWithCapturedBlockScopedBinding */ ) !== 0;
        }
        function hoistVariableDeclarationDeclaredInConvertedLoop(state, node) {
            if (!state.hoistedLocalVariables) state.hoistedLocalVariables = [];
            visit(node.name);
            function visit(node2) {
                if (node2.kind === 80 /* Identifier */ ) state.hoistedLocalVariables.push(node2);
                else {
                    for (const element of node2.elements)if (!isOmittedExpression(element)) visit(element.name);
                }
            }
        }
        function convertIterationStatementBodyIfNecessary(node, outermostLabeledStatement, ancestorFacts, convert) {
            if (!shouldConvertIterationStatement(node)) {
                let saveAllowedNonLabeledJumps;
                if (convertedLoopState) {
                    saveAllowedNonLabeledJumps = convertedLoopState.allowedNonLabeledJumps;
                    convertedLoopState.allowedNonLabeledJumps = 6 /* Continue */ ;
                }
                const result = convert ? convert(node, outermostLabeledStatement, /*convertedLoopBodyStatements*/ void 0, ancestorFacts) : factory2.restoreEnclosingLabel(isForStatement(node) ? visitEachChildOfForStatement2(node) : visitEachChild(node, visitor, context), outermostLabeledStatement, convertedLoopState && resetLabel);
                if (convertedLoopState) convertedLoopState.allowedNonLabeledJumps = saveAllowedNonLabeledJumps;
                return result;
            }
            const currentState = createConvertedLoopState(node);
            const statements = [];
            const outerConvertedLoopState = convertedLoopState;
            convertedLoopState = currentState;
            const initializerFunction = shouldConvertInitializerOfForStatement(node) ? createFunctionForInitializerOfForStatement(node, currentState) : void 0;
            const bodyFunction = shouldConvertBodyOfIterationStatement(node) ? createFunctionForBodyOfIterationStatement(node, currentState, outerConvertedLoopState) : void 0;
            convertedLoopState = outerConvertedLoopState;
            if (initializerFunction) statements.push(initializerFunction.functionDeclaration);
            if (bodyFunction) statements.push(bodyFunction.functionDeclaration);
            addExtraDeclarationsForConvertedLoop(statements, currentState, outerConvertedLoopState);
            if (initializerFunction) statements.push(generateCallToConvertedLoopInitializer(initializerFunction.functionName, initializerFunction.containsYield));
            let loop;
            if (bodyFunction) {
                if (convert) loop = convert(node, outermostLabeledStatement, bodyFunction.part, ancestorFacts);
                else {
                    const clone2 = convertIterationStatementCore(node, initializerFunction, factory2.createBlock(bodyFunction.part, /*multiLine*/ true));
                    loop = factory2.restoreEnclosingLabel(clone2, outermostLabeledStatement, convertedLoopState && resetLabel);
                }
            } else {
                const clone2 = convertIterationStatementCore(node, initializerFunction, Debug.checkDefined(visitNode(node.statement, visitor, isStatement, factory2.liftToBlock)));
                loop = factory2.restoreEnclosingLabel(clone2, outermostLabeledStatement, convertedLoopState && resetLabel);
            }
            statements.push(loop);
            return statements;
        }
        function convertIterationStatementCore(node, initializerFunction, convertedLoopBody) {
            switch(node.kind){
                case 247 /* ForStatement */ :
                    return convertForStatement(node, initializerFunction, convertedLoopBody);
                case 248 /* ForInStatement */ :
                    return convertForInStatement(node, convertedLoopBody);
                case 249 /* ForOfStatement */ :
                    return convertForOfStatement(node, convertedLoopBody);
                case 245 /* DoStatement */ :
                    return convertDoStatement(node, convertedLoopBody);
                case 246 /* WhileStatement */ :
                    return convertWhileStatement(node, convertedLoopBody);
                default:
                    return Debug.failBadSyntaxKind(node, "IterationStatement expected");
            }
        }
        function convertForStatement(node, initializerFunction, convertedLoopBody) {
            const shouldConvertCondition = node.condition && shouldConvertPartOfIterationStatement(node.condition);
            const shouldConvertIncrementor = shouldConvertCondition || node.incrementor && shouldConvertPartOfIterationStatement(node.incrementor);
            return factory2.updateForStatement(node, visitNode(initializerFunction ? initializerFunction.part : node.initializer, visitorWithUnusedExpressionResult, isForInitializer), visitNode(shouldConvertCondition ? void 0 : node.condition, visitor, isExpression), visitNode(shouldConvertIncrementor ? void 0 : node.incrementor, visitorWithUnusedExpressionResult, isExpression), convertedLoopBody);
        }
        function convertForOfStatement(node, convertedLoopBody) {
            return factory2.updateForOfStatement(node, /*awaitModifier*/ void 0, Debug.checkDefined(visitNode(node.initializer, visitor, isForInitializer)), Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), convertedLoopBody);
        }
        function convertForInStatement(node, convertedLoopBody) {
            return factory2.updateForInStatement(node, Debug.checkDefined(visitNode(node.initializer, visitor, isForInitializer)), Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), convertedLoopBody);
        }
        function convertDoStatement(node, convertedLoopBody) {
            return factory2.updateDoStatement(node, convertedLoopBody, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
        }
        function convertWhileStatement(node, convertedLoopBody) {
            return factory2.updateWhileStatement(node, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), convertedLoopBody);
        }
        function createConvertedLoopState(node) {
            let loopInitializer;
            switch(node.kind){
                case 247 /* ForStatement */ :
                case 248 /* ForInStatement */ :
                case 249 /* ForOfStatement */ :
                    const initializer = node.initializer;
                    if (initializer && initializer.kind === 260 /* VariableDeclarationList */ ) loopInitializer = initializer;
                    break;
            }
            const loopParameters = [];
            const loopOutParameters = [];
            if (loopInitializer && getCombinedNodeFlags(loopInitializer) & 3 /* BlockScoped */ ) {
                const hasCapturedBindingsInForHead = shouldConvertInitializerOfForStatement(node) || shouldConvertConditionOfForStatement(node) || shouldConvertIncrementorOfForStatement(node);
                for (const decl of loopInitializer.declarations)processLoopVariableDeclaration(node, decl, loopParameters, loopOutParameters, hasCapturedBindingsInForHead);
            }
            const currentState = {
                loopParameters: loopParameters,
                loopOutParameters: loopOutParameters
            };
            if (convertedLoopState) {
                if (convertedLoopState.argumentsName) currentState.argumentsName = convertedLoopState.argumentsName;
                if (convertedLoopState.thisName) currentState.thisName = convertedLoopState.thisName;
                if (convertedLoopState.hoistedLocalVariables) currentState.hoistedLocalVariables = convertedLoopState.hoistedLocalVariables;
            }
            return currentState;
        }
        function addExtraDeclarationsForConvertedLoop(statements, state, outerState) {
            let extraVariableDeclarations;
            if (state.argumentsName) {
                if (outerState) outerState.argumentsName = state.argumentsName;
                else (extraVariableDeclarations || (extraVariableDeclarations = [])).push(factory2.createVariableDeclaration(state.argumentsName, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createIdentifier("arguments")));
            }
            if (state.thisName) {
                if (outerState) outerState.thisName = state.thisName;
                else (extraVariableDeclarations || (extraVariableDeclarations = [])).push(factory2.createVariableDeclaration(state.thisName, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createIdentifier("this")));
            }
            if (state.hoistedLocalVariables) {
                if (outerState) outerState.hoistedLocalVariables = state.hoistedLocalVariables;
                else {
                    if (!extraVariableDeclarations) extraVariableDeclarations = [];
                    for (const identifier of state.hoistedLocalVariables)extraVariableDeclarations.push(factory2.createVariableDeclaration(identifier));
                }
            }
            if (state.loopOutParameters.length) {
                if (!extraVariableDeclarations) extraVariableDeclarations = [];
                for (const outParam of state.loopOutParameters)extraVariableDeclarations.push(factory2.createVariableDeclaration(outParam.outParamName));
            }
            if (state.conditionVariable) {
                if (!extraVariableDeclarations) extraVariableDeclarations = [];
                extraVariableDeclarations.push(factory2.createVariableDeclaration(state.conditionVariable, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createFalse()));
            }
            if (extraVariableDeclarations) statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(extraVariableDeclarations)));
        }
        function createOutVariable(p) {
            return factory2.createVariableDeclaration(p.originalName, /*exclamationToken*/ void 0, /*type*/ void 0, p.outParamName);
        }
        function createFunctionForInitializerOfForStatement(node, currentState) {
            const functionName = factory2.createUniqueName("_loop_init");
            const containsYield = (node.initializer.transformFlags & 1048576 /* ContainsYield */ ) !== 0;
            let emitFlags = 0 /* None */ ;
            if (currentState.containsLexicalThis) emitFlags |= 16 /* CapturesThis */ ;
            if (containsYield && hierarchyFacts & 4 /* AsyncFunctionBody */ ) emitFlags |= 524288 /* AsyncFunctionBody */ ;
            const statements = [];
            statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, node.initializer));
            copyOutParameters(currentState.loopOutParameters, 2 /* Initializer */ , 1 /* ToOutParameter */ , statements);
            const functionDeclaration = factory2.createVariableStatement(/*modifiers*/ void 0, setEmitFlags(factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(functionName, /*exclamationToken*/ void 0, /*type*/ void 0, setEmitFlags(factory2.createFunctionExpression(/*modifiers*/ void 0, containsYield ? factory2.createToken(42 /* AsteriskToken */ ) : void 0, /*name*/ void 0, /*typeParameters*/ void 0, /*parameters*/ void 0, /*type*/ void 0, Debug.checkDefined(visitNode(factory2.createBlock(statements, /*multiLine*/ true), visitor, isBlock))), emitFlags))
            ]), 4194304 /* NoHoisting */ ));
            const part = factory2.createVariableDeclarationList(map(currentState.loopOutParameters, createOutVariable));
            return {
                functionName: functionName,
                containsYield: containsYield,
                functionDeclaration: functionDeclaration,
                part: part
            };
        }
        function createFunctionForBodyOfIterationStatement(node, currentState, outerState) {
            const functionName = factory2.createUniqueName("_loop");
            startLexicalEnvironment();
            const statement = visitNode(node.statement, visitor, isStatement, factory2.liftToBlock);
            const lexicalEnvironment = endLexicalEnvironment();
            const statements = [];
            if (shouldConvertConditionOfForStatement(node) || shouldConvertIncrementorOfForStatement(node)) {
                currentState.conditionVariable = factory2.createUniqueName("inc");
                if (node.incrementor) statements.push(factory2.createIfStatement(currentState.conditionVariable, factory2.createExpressionStatement(Debug.checkDefined(visitNode(node.incrementor, visitor, isExpression))), factory2.createExpressionStatement(factory2.createAssignment(currentState.conditionVariable, factory2.createTrue()))));
                else statements.push(factory2.createIfStatement(factory2.createLogicalNot(currentState.conditionVariable), factory2.createExpressionStatement(factory2.createAssignment(currentState.conditionVariable, factory2.createTrue()))));
                if (shouldConvertConditionOfForStatement(node)) statements.push(factory2.createIfStatement(factory2.createPrefixUnaryExpression(54 /* ExclamationToken */ , Debug.checkDefined(visitNode(node.condition, visitor, isExpression))), Debug.checkDefined(visitNode(factory2.createBreakStatement(), visitor, isStatement))));
            }
            Debug.assert(statement);
            if (isBlock(statement)) addRange(statements, statement.statements);
            else statements.push(statement);
            copyOutParameters(currentState.loopOutParameters, 1 /* Body */ , 1 /* ToOutParameter */ , statements);
            insertStatementsAfterStandardPrologue(statements, lexicalEnvironment);
            const loopBody = factory2.createBlock(statements, /*multiLine*/ true);
            if (isBlock(statement)) setOriginalNode(loopBody, statement);
            const containsYield = (node.statement.transformFlags & 1048576 /* ContainsYield */ ) !== 0;
            let emitFlags = 1048576 /* ReuseTempVariableScope */ ;
            if (currentState.containsLexicalThis) emitFlags |= 16 /* CapturesThis */ ;
            if (containsYield && (hierarchyFacts & 4 /* AsyncFunctionBody */ ) !== 0) emitFlags |= 524288 /* AsyncFunctionBody */ ;
            const functionDeclaration = factory2.createVariableStatement(/*modifiers*/ void 0, setEmitFlags(factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(functionName, /*exclamationToken*/ void 0, /*type*/ void 0, setEmitFlags(factory2.createFunctionExpression(/*modifiers*/ void 0, containsYield ? factory2.createToken(42 /* AsteriskToken */ ) : void 0, /*name*/ void 0, /*typeParameters*/ void 0, currentState.loopParameters, /*type*/ void 0, loopBody), emitFlags))
            ]), 4194304 /* NoHoisting */ ));
            const part = generateCallToConvertedLoop(functionName, currentState, outerState, containsYield);
            return {
                functionName: functionName,
                containsYield: containsYield,
                functionDeclaration: functionDeclaration,
                part: part
            };
        }
        function copyOutParameter(outParam, copyDirection) {
            const source = copyDirection === 0 /* ToOriginal */  ? outParam.outParamName : outParam.originalName;
            const target = copyDirection === 0 /* ToOriginal */  ? outParam.originalName : outParam.outParamName;
            return factory2.createBinaryExpression(target, 64 /* EqualsToken */ , source);
        }
        function copyOutParameters(outParams, partFlags, copyDirection, statements) {
            for (const outParam of outParams)if (outParam.flags & partFlags) statements.push(factory2.createExpressionStatement(copyOutParameter(outParam, copyDirection)));
        }
        function generateCallToConvertedLoopInitializer(initFunctionExpressionName, containsYield) {
            const call = factory2.createCallExpression(initFunctionExpressionName, /*typeArguments*/ void 0, []);
            const callResult = containsYield ? factory2.createYieldExpression(factory2.createToken(42 /* AsteriskToken */ ), setEmitFlags(call, 8388608 /* Iterator */ )) : call;
            return factory2.createExpressionStatement(callResult);
        }
        function generateCallToConvertedLoop(loopFunctionExpressionName, state, outerState, containsYield) {
            const statements = [];
            const isSimpleLoop = !(state.nonLocalJumps & -5 /* Continue */ ) && !state.labeledNonLocalBreaks && !state.labeledNonLocalContinues;
            const call = factory2.createCallExpression(loopFunctionExpressionName, /*typeArguments*/ void 0, map(state.loopParameters, (p)=>p.name));
            const callResult = containsYield ? factory2.createYieldExpression(factory2.createToken(42 /* AsteriskToken */ ), setEmitFlags(call, 8388608 /* Iterator */ )) : call;
            if (isSimpleLoop) {
                statements.push(factory2.createExpressionStatement(callResult));
                copyOutParameters(state.loopOutParameters, 1 /* Body */ , 0 /* ToOriginal */ , statements);
            } else {
                const loopResultName = factory2.createUniqueName("state");
                const stateVariable = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(loopResultName, /*exclamationToken*/ void 0, /*type*/ void 0, callResult)
                ]));
                statements.push(stateVariable);
                copyOutParameters(state.loopOutParameters, 1 /* Body */ , 0 /* ToOriginal */ , statements);
                if (state.nonLocalJumps & 8 /* Return */ ) {
                    let returnStatement;
                    if (outerState) {
                        outerState.nonLocalJumps |= 8 /* Return */ ;
                        returnStatement = factory2.createReturnStatement(loopResultName);
                    } else returnStatement = factory2.createReturnStatement(factory2.createPropertyAccessExpression(loopResultName, "value"));
                    statements.push(factory2.createIfStatement(factory2.createTypeCheck(loopResultName, "object"), returnStatement));
                }
                if (state.nonLocalJumps & 2 /* Break */ ) statements.push(factory2.createIfStatement(factory2.createStrictEquality(loopResultName, factory2.createStringLiteral("break")), factory2.createBreakStatement()));
                if (state.labeledNonLocalBreaks || state.labeledNonLocalContinues) {
                    const caseClauses = [];
                    processLabeledJumps(state.labeledNonLocalBreaks, /*isBreak*/ true, loopResultName, outerState, caseClauses);
                    processLabeledJumps(state.labeledNonLocalContinues, /*isBreak*/ false, loopResultName, outerState, caseClauses);
                    statements.push(factory2.createSwitchStatement(loopResultName, factory2.createCaseBlock(caseClauses)));
                }
            }
            return statements;
        }
        function setLabeledJump(state, isBreak, labelText, labelMarker) {
            if (isBreak) {
                if (!state.labeledNonLocalBreaks) state.labeledNonLocalBreaks = /* @__PURE__ */ new Map();
                state.labeledNonLocalBreaks.set(labelText, labelMarker);
            } else {
                if (!state.labeledNonLocalContinues) state.labeledNonLocalContinues = /* @__PURE__ */ new Map();
                state.labeledNonLocalContinues.set(labelText, labelMarker);
            }
        }
        function processLabeledJumps(table, isBreak, loopResultName, outerLoop, caseClauses) {
            if (!table) return;
            table.forEach((labelMarker, labelText)=>{
                const statements = [];
                if (!outerLoop || outerLoop.labels && outerLoop.labels.get(labelText)) {
                    const label = factory2.createIdentifier(labelText);
                    statements.push(isBreak ? factory2.createBreakStatement(label) : factory2.createContinueStatement(label));
                } else {
                    setLabeledJump(outerLoop, isBreak, labelText, labelMarker);
                    statements.push(factory2.createReturnStatement(loopResultName));
                }
                caseClauses.push(factory2.createCaseClause(factory2.createStringLiteral(labelMarker), statements));
            });
        }
        function processLoopVariableDeclaration(container, decl, loopParameters, loopOutParameters, hasCapturedBindingsInForHead) {
            const name = decl.name;
            if (isBindingPattern(name)) {
                for (const element of name.elements)if (!isOmittedExpression(element)) processLoopVariableDeclaration(container, element, loopParameters, loopOutParameters, hasCapturedBindingsInForHead);
            } else {
                loopParameters.push(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, name));
                const checkFlags = resolver.getNodeCheckFlags(decl);
                if (checkFlags & 262144 /* NeedsLoopOutParameter */  || hasCapturedBindingsInForHead) {
                    const outParamName = factory2.createUniqueName("out_" + idText(name));
                    let flags = 0 /* None */ ;
                    if (checkFlags & 262144 /* NeedsLoopOutParameter */ ) flags |= 1 /* Body */ ;
                    if (isForStatement(container)) {
                        if (container.initializer && resolver.isBindingCapturedByNode(container.initializer, decl)) flags |= 2 /* Initializer */ ;
                        if (container.condition && resolver.isBindingCapturedByNode(container.condition, decl) || container.incrementor && resolver.isBindingCapturedByNode(container.incrementor, decl)) flags |= 1 /* Body */ ;
                    }
                    loopOutParameters.push({
                        flags: flags,
                        originalName: name,
                        outParamName: outParamName
                    });
                }
            }
        }
        function addObjectLiteralMembers(expressions, node, receiver, start) {
            const properties = node.properties;
            const numProperties = properties.length;
            for(let i = start; i < numProperties; i++){
                const property = properties[i];
                switch(property.kind){
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                        const accessors = getAllAccessorDeclarations(node.properties, property);
                        if (property === accessors.firstAccessor) expressions.push(transformAccessorsToExpression(receiver, accessors, node, !!node.multiLine));
                        break;
                    case 173 /* MethodDeclaration */ :
                        expressions.push(transformObjectLiteralMethodDeclarationToExpression(property, receiver, node, node.multiLine));
                        break;
                    case 302 /* PropertyAssignment */ :
                        expressions.push(transformPropertyAssignmentToExpression(property, receiver, node.multiLine));
                        break;
                    case 303 /* ShorthandPropertyAssignment */ :
                        expressions.push(transformShorthandPropertyAssignmentToExpression(property, receiver, node.multiLine));
                        break;
                    default:
                        Debug.failBadSyntaxKind(node);
                        break;
                }
            }
        }
        function transformPropertyAssignmentToExpression(property, receiver, startsOnNewLine) {
            const expression = factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, Debug.checkDefined(visitNode(property.name, visitor, isPropertyName))), Debug.checkDefined(visitNode(property.initializer, visitor, isExpression)));
            setTextRange(expression, property);
            if (startsOnNewLine) startOnNewLine(expression);
            return expression;
        }
        function transformShorthandPropertyAssignmentToExpression(property, receiver, startsOnNewLine) {
            const expression = factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, Debug.checkDefined(visitNode(property.name, visitor, isPropertyName))), factory2.cloneNode(property.name));
            setTextRange(expression, property);
            if (startsOnNewLine) startOnNewLine(expression);
            return expression;
        }
        function transformObjectLiteralMethodDeclarationToExpression(method, receiver, container, startsOnNewLine) {
            const expression = factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, Debug.checkDefined(visitNode(method.name, visitor, isPropertyName))), transformFunctionLikeToExpression(method, /*location*/ method, /*name*/ void 0, container));
            setTextRange(expression, method);
            if (startsOnNewLine) startOnNewLine(expression);
            return expression;
        }
        function visitCatchClause(node) {
            const ancestorFacts = enterSubtree(7104 /* BlockScopeExcludes */ , 0 /* BlockScopeIncludes */ );
            let updated;
            Debug.assert(!!node.variableDeclaration, "Catch clause variable should always be present when downleveling ES2015.");
            if (isBindingPattern(node.variableDeclaration.name)) {
                const temp = factory2.createTempVariable(/*recordTempVariable*/ void 0);
                const newVariableDeclaration = factory2.createVariableDeclaration(temp);
                setTextRange(newVariableDeclaration, node.variableDeclaration);
                const vars = flattenDestructuringBinding(node.variableDeclaration, visitor, context, 0 /* All */ , temp);
                const list = factory2.createVariableDeclarationList(vars);
                setTextRange(list, node.variableDeclaration);
                const destructure = factory2.createVariableStatement(/*modifiers*/ void 0, list);
                updated = factory2.updateCatchClause(node, newVariableDeclaration, addStatementToStartOfBlock(node.block, destructure));
            } else updated = visitEachChild(node, visitor, context);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function addStatementToStartOfBlock(block, statement) {
            const transformedStatements = visitNodes2(block.statements, visitor, isStatement);
            return factory2.updateBlock(block, [
                statement,
                ...transformedStatements
            ]);
        }
        function visitMethodDeclaration(node) {
            Debug.assert(!isComputedPropertyName(node.name));
            const functionExpression = transformFunctionLikeToExpression(node, /*location*/ moveRangePos(node, -1), /*name*/ void 0, /*container*/ void 0);
            setEmitFlags(functionExpression, 1024 /* NoLeadingComments */  | getEmitFlags(functionExpression));
            return setTextRange(factory2.createPropertyAssignment(node.name, functionExpression), /*location*/ node);
        }
        function visitAccessorDeclaration(node) {
            Debug.assert(!isComputedPropertyName(node.name));
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const ancestorFacts = enterSubtree(32670 /* FunctionExcludes */ , 65 /* FunctionIncludes */ );
            let updated;
            const parameters = visitParameterList(node.parameters, visitor, context);
            const body = transformFunctionBody2(node);
            if (node.kind === 176 /* GetAccessor */ ) updated = factory2.updateGetAccessorDeclaration(node, node.modifiers, node.name, parameters, node.type, body);
            else updated = factory2.updateSetAccessorDeclaration(node, node.modifiers, node.name, parameters, body);
            exitSubtree(ancestorFacts, 98304 /* FunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
            return updated;
        }
        function visitShorthandPropertyAssignment(node) {
            return setTextRange(factory2.createPropertyAssignment(node.name, visitIdentifier(factory2.cloneNode(node.name))), /*location*/ node);
        }
        function visitComputedPropertyName(node) {
            return visitEachChild(node, visitor, context);
        }
        function visitYieldExpression(node) {
            return visitEachChild(node, visitor, context);
        }
        function visitArrayLiteralExpression(node) {
            if (some(node.elements, isSpreadElement)) return transformAndSpreadElements(node.elements, /*isArgumentList*/ false, !!node.multiLine, /*hasTrailingComma*/ !!node.elements.hasTrailingComma);
            return visitEachChild(node, visitor, context);
        }
        function visitCallExpression(node) {
            if (getInternalEmitFlags(node) & 1 /* TypeScriptClassWrapper */ ) return visitTypeScriptClassWrapper(node);
            const expression = skipOuterExpressions(node.expression);
            if (expression.kind === 108 /* SuperKeyword */  || isSuperProperty(expression) || some(node.arguments, isSpreadElement)) return visitCallExpressionWithPotentialCapturedThisAssignment(node, /*assignToCapturedThis*/ true);
            return factory2.updateCallExpression(node, Debug.checkDefined(visitNode(node.expression, callExpressionVisitor, isExpression)), /*typeArguments*/ void 0, visitNodes2(node.arguments, visitor, isExpression));
        }
        function visitTypeScriptClassWrapper(node) {
            const body = cast(cast(skipOuterExpressions(node.expression), isArrowFunction).body, isBlock);
            const isVariableStatementWithInitializer = (stmt)=>isVariableStatement(stmt) && !!first(stmt.declarationList.declarations).initializer;
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const bodyStatements = visitNodes2(body.statements, classWrapperStatementVisitor, isStatement);
            convertedLoopState = savedConvertedLoopState;
            const classStatements = filter(bodyStatements, isVariableStatementWithInitializer);
            const remainingStatements = filter(bodyStatements, (stmt)=>!isVariableStatementWithInitializer(stmt));
            const varStatement = cast(first(classStatements), isVariableStatement);
            const variable = varStatement.declarationList.declarations[0];
            const initializer = skipOuterExpressions(variable.initializer);
            let aliasAssignment = tryCast(initializer, isAssignmentExpression);
            if (!aliasAssignment && isBinaryExpression(initializer) && initializer.operatorToken.kind === 28 /* CommaToken */ ) aliasAssignment = tryCast(initializer.left, isAssignmentExpression);
            const call = cast(aliasAssignment ? skipOuterExpressions(aliasAssignment.right) : initializer, isCallExpression);
            const func = cast(skipOuterExpressions(call.expression), isFunctionExpression);
            const funcStatements = func.body.statements;
            let classBodyStart = 0;
            let classBodyEnd = -1;
            const statements = [];
            if (aliasAssignment) {
                const extendsCall = tryCast(funcStatements[classBodyStart], isExpressionStatement);
                if (extendsCall) {
                    statements.push(extendsCall);
                    classBodyStart++;
                }
                statements.push(funcStatements[classBodyStart]);
                classBodyStart++;
                statements.push(factory2.createExpressionStatement(factory2.createAssignment(aliasAssignment.left, cast(variable.name, isIdentifier))));
            }
            while(!isReturnStatement(elementAt(funcStatements, classBodyEnd)))classBodyEnd--;
            addRange(statements, funcStatements, classBodyStart, classBodyEnd);
            if (classBodyEnd < -1) addRange(statements, funcStatements, classBodyEnd + 1);
            const returnStatement = tryCast(elementAt(funcStatements, classBodyEnd), isReturnStatement);
            for (const statement of remainingStatements)if (isReturnStatement(statement) && (returnStatement == null ? void 0 : returnStatement.expression) && !isIdentifier(returnStatement.expression)) statements.push(returnStatement);
            else statements.push(statement);
            addRange(statements, classStatements, /*start*/ 1);
            return factory2.restoreOuterExpressions(node.expression, factory2.restoreOuterExpressions(variable.initializer, factory2.restoreOuterExpressions(aliasAssignment && aliasAssignment.right, factory2.updateCallExpression(call, factory2.restoreOuterExpressions(call.expression, factory2.updateFunctionExpression(func, /*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, func.parameters, /*type*/ void 0, factory2.updateBlock(func.body, statements))), /*typeArguments*/ void 0, call.arguments))));
        }
        function visitSuperCallInBody(node) {
            return visitCallExpressionWithPotentialCapturedThisAssignment(node, /*assignToCapturedThis*/ false);
        }
        function visitCallExpressionWithPotentialCapturedThisAssignment(node, assignToCapturedThis) {
            if (node.transformFlags & 32768 /* ContainsRestOrSpread */  || node.expression.kind === 108 /* SuperKeyword */  || isSuperProperty(skipOuterExpressions(node.expression))) {
                const { target: target , thisArg: thisArg  } = factory2.createCallBinding(node.expression, hoistVariableDeclaration);
                if (node.expression.kind === 108 /* SuperKeyword */ ) setEmitFlags(thisArg, 8 /* NoSubstitution */ );
                let resultingCall;
                if (node.transformFlags & 32768 /* ContainsRestOrSpread */ ) resultingCall = factory2.createFunctionApplyCall(Debug.checkDefined(visitNode(target, callExpressionVisitor, isExpression)), node.expression.kind === 108 /* SuperKeyword */  ? thisArg : Debug.checkDefined(visitNode(thisArg, visitor, isExpression)), transformAndSpreadElements(node.arguments, /*isArgumentList*/ true, /*multiLine*/ false, /*hasTrailingComma*/ false));
                else resultingCall = setTextRange(factory2.createFunctionCallCall(Debug.checkDefined(visitNode(target, callExpressionVisitor, isExpression)), node.expression.kind === 108 /* SuperKeyword */  ? thisArg : Debug.checkDefined(visitNode(thisArg, visitor, isExpression)), visitNodes2(node.arguments, visitor, isExpression)), node);
                if (node.expression.kind === 108 /* SuperKeyword */ ) {
                    const initializer = factory2.createLogicalOr(resultingCall, createActualThis());
                    resultingCall = assignToCapturedThis ? factory2.createAssignment(factory2.createUniqueName("_this", 48 /* FileLevel */ ), initializer) : initializer;
                }
                return setOriginalNode(resultingCall, node);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitNewExpression(node) {
            if (some(node.arguments, isSpreadElement)) {
                const { target: target , thisArg: thisArg  } = factory2.createCallBinding(factory2.createPropertyAccessExpression(node.expression, "bind"), hoistVariableDeclaration);
                return factory2.createNewExpression(factory2.createFunctionApplyCall(Debug.checkDefined(visitNode(target, visitor, isExpression)), thisArg, transformAndSpreadElements(factory2.createNodeArray([
                    factory2.createVoidZero(),
                    ...node.arguments
                ]), /*isArgumentList*/ true, /*multiLine*/ false, /*hasTrailingComma*/ false)), /*typeArguments*/ void 0, []);
            }
            return visitEachChild(node, visitor, context);
        }
        function transformAndSpreadElements(elements, isArgumentList, multiLine, hasTrailingComma) {
            const numElements = elements.length;
            const segments = flatten(// As we visit each element, we return one of two functions to use as the "key":
            // - `visitSpanOfSpreads` for one or more contiguous `...` spread expressions, i.e. `...a, ...b` in `[1, 2, ...a, ...b]`
            // - `visitSpanOfNonSpreads` for one or more contiguous non-spread elements, i.e. `1, 2`, in `[1, 2, ...a, ...b]`
            spanMap(elements, partitionSpread, (partition, visitPartition, _start, end)=>visitPartition(partition, multiLine, hasTrailingComma && end === numElements)));
            if (segments.length === 1) {
                const firstSegment = segments[0];
                if (isArgumentList && !compilerOptions.downlevelIteration || isPackedArrayLiteral(firstSegment.expression) || isCallToHelper(firstSegment.expression, "___spreadArray")) return firstSegment.expression;
            }
            const helpers = emitHelpers();
            const startsWithSpread = segments[0].kind !== 0 /* None */ ;
            let expression = startsWithSpread ? factory2.createArrayLiteralExpression() : segments[0].expression;
            for(let i = startsWithSpread ? 0 : 1; i < segments.length; i++){
                const segment = segments[i];
                expression = helpers.createSpreadArrayHelper(expression, segment.expression, segment.kind === 1 /* UnpackedSpread */  && !isArgumentList);
            }
            return expression;
        }
        function partitionSpread(node) {
            return isSpreadElement(node) ? visitSpanOfSpreads : visitSpanOfNonSpreads;
        }
        function visitSpanOfSpreads(chunk) {
            return map(chunk, visitExpressionOfSpread);
        }
        function visitExpressionOfSpread(node) {
            Debug.assertNode(node, isSpreadElement);
            let expression = visitNode(node.expression, visitor, isExpression);
            Debug.assert(expression);
            const isCallToReadHelper = isCallToHelper(expression, "___read");
            let kind = isCallToReadHelper || isPackedArrayLiteral(expression) ? 2 /* PackedSpread */  : 1 /* UnpackedSpread */ ;
            if (compilerOptions.downlevelIteration && kind === 1 /* UnpackedSpread */  && !isArrayLiteralExpression(expression) && !isCallToReadHelper) {
                expression = emitHelpers().createReadHelper(expression, /*count*/ void 0);
                kind = 2 /* PackedSpread */ ;
            }
            return createSpreadSegment(kind, expression);
        }
        function visitSpanOfNonSpreads(chunk, multiLine, hasTrailingComma) {
            const expression = factory2.createArrayLiteralExpression(visitNodes2(factory2.createNodeArray(chunk, hasTrailingComma), visitor, isExpression), multiLine);
            return createSpreadSegment(0 /* None */ , expression);
        }
        function visitSpreadElement(node) {
            return visitNode(node.expression, visitor, isExpression);
        }
        function visitTemplateLiteral(node) {
            return setTextRange(factory2.createStringLiteral(node.text), node);
        }
        function visitStringLiteral(node) {
            if (node.hasExtendedUnicodeEscape) return setTextRange(factory2.createStringLiteral(node.text), node);
            return node;
        }
        function visitNumericLiteral(node) {
            if (node.numericLiteralFlags & 384 /* BinaryOrOctalSpecifier */ ) return setTextRange(factory2.createNumericLiteral(node.text), node);
            return node;
        }
        function visitTaggedTemplateExpression(node) {
            return processTaggedTemplateExpression(context, node, visitor, currentSourceFile, recordTaggedTemplateString, 1 /* All */ );
        }
        function visitTemplateExpression(node) {
            let expression = factory2.createStringLiteral(node.head.text);
            for (const span of node.templateSpans){
                const args = [
                    Debug.checkDefined(visitNode(span.expression, visitor, isExpression))
                ];
                if (span.literal.text.length > 0) args.push(factory2.createStringLiteral(span.literal.text));
                expression = factory2.createCallExpression(factory2.createPropertyAccessExpression(expression, "concat"), /*typeArguments*/ void 0, args);
            }
            return setTextRange(expression, node);
        }
        function visitSuperKeyword(isExpressionOfCall) {
            return hierarchyFacts & 8 /* NonStaticClassElement */  && !isExpressionOfCall ? factory2.createPropertyAccessExpression(factory2.createUniqueName("_super", 48 /* FileLevel */ ), "prototype") : factory2.createUniqueName("_super", 48 /* FileLevel */ );
        }
        function visitMetaProperty(node) {
            if (node.keywordToken === 105 /* NewKeyword */  && node.name.escapedText === "target") {
                hierarchyFacts |= 32768 /* NewTarget */ ;
                return factory2.createUniqueName("_newTarget", 48 /* FileLevel */ );
            }
            return node;
        }
        function onEmitNode(hint, node, emitCallback) {
            if (enabledSubstitutions & 1 /* CapturedThis */  && isFunctionLike(node)) {
                const ancestorFacts = enterSubtree(32670 /* FunctionExcludes */ , getEmitFlags(node) & 16 /* CapturesThis */  ? 81 /* CapturesThis */  : 65 /* FunctionIncludes */ );
                previousOnEmitNode(hint, node, emitCallback);
                exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
                return;
            }
            previousOnEmitNode(hint, node, emitCallback);
        }
        function enableSubstitutionsForBlockScopedBindings() {
            if ((enabledSubstitutions & 2 /* BlockScopedBindings */ ) === 0) {
                enabledSubstitutions |= 2 /* BlockScopedBindings */ ;
                context.enableSubstitution(80 /* Identifier */ );
            }
        }
        function enableSubstitutionsForCapturedThis() {
            if ((enabledSubstitutions & 1 /* CapturedThis */ ) === 0) {
                enabledSubstitutions |= 1 /* CapturedThis */ ;
                context.enableSubstitution(110 /* ThisKeyword */ );
                context.enableEmitNotification(175 /* Constructor */ );
                context.enableEmitNotification(173 /* MethodDeclaration */ );
                context.enableEmitNotification(176 /* GetAccessor */ );
                context.enableEmitNotification(177 /* SetAccessor */ );
                context.enableEmitNotification(218 /* ArrowFunction */ );
                context.enableEmitNotification(217 /* FunctionExpression */ );
                context.enableEmitNotification(261 /* FunctionDeclaration */ );
            }
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            if (isIdentifier(node)) return substituteIdentifier(node);
            return node;
        }
        function substituteIdentifier(node) {
            if (enabledSubstitutions & 2 /* BlockScopedBindings */  && !isInternalName(node)) {
                const original = getParseTreeNode(node, isIdentifier);
                if (original && isNameOfDeclarationWithCollidingName(original)) return setTextRange(factory2.getGeneratedNameForNode(original), node);
            }
            return node;
        }
        function isNameOfDeclarationWithCollidingName(node) {
            switch(node.parent.kind){
                case 207 /* BindingElement */ :
                case 262 /* ClassDeclaration */ :
                case 265 /* EnumDeclaration */ :
                case 259 /* VariableDeclaration */ :
                    return node.parent.name === node && resolver.isDeclarationWithCollidingName(node.parent);
            }
            return false;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
                case 110 /* ThisKeyword */ :
                    return substituteThisKeyword(node);
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            if (enabledSubstitutions & 2 /* BlockScopedBindings */  && !isInternalName(node)) {
                const declaration = resolver.getReferencedDeclarationWithCollidingName(node);
                if (declaration && !(isClassLike(declaration) && isPartOfClassBody(declaration, node))) return setTextRange(factory2.getGeneratedNameForNode(getNameOfDeclaration(declaration)), node);
            }
            return node;
        }
        function isPartOfClassBody(declaration, node) {
            let currentNode = getParseTreeNode(node);
            if (!currentNode || currentNode === declaration || currentNode.end <= declaration.pos || currentNode.pos >= declaration.end) return false;
            const blockScope = getEnclosingBlockScopeContainer(declaration);
            while(currentNode){
                if (currentNode === blockScope || currentNode === declaration) return false;
                if (isClassElement(currentNode) && currentNode.parent === declaration) return true;
                currentNode = currentNode.parent;
            }
            return false;
        }
        function substituteThisKeyword(node) {
            if (enabledSubstitutions & 1 /* CapturedThis */  && hierarchyFacts & 16 /* CapturesThis */ ) return setTextRange(factory2.createUniqueName("_this", 48 /* FileLevel */ ), node);
            return node;
        }
        function getClassMemberPrefix(node, member) {
            return isStatic(member) ? factory2.getInternalName(node) : factory2.createPropertyAccessExpression(factory2.getInternalName(node), "prototype");
        }
        function hasSynthesizedDefaultSuperCall(constructor, hasExtendsClause) {
            if (!constructor || !hasExtendsClause) return false;
            if (some(constructor.parameters)) return false;
            const statement = firstOrUndefined(constructor.body.statements);
            if (!statement || !nodeIsSynthesized(statement) || statement.kind !== 243 /* ExpressionStatement */ ) return false;
            const statementExpression = statement.expression;
            if (!nodeIsSynthesized(statementExpression) || statementExpression.kind !== 212 /* CallExpression */ ) return false;
            const callTarget = statementExpression.expression;
            if (!nodeIsSynthesized(callTarget) || callTarget.kind !== 108 /* SuperKeyword */ ) return false;
            const callArgument = singleOrUndefined(statementExpression.arguments);
            if (!callArgument || !nodeIsSynthesized(callArgument) || callArgument.kind !== 229 /* SpreadElement */ ) return false;
            const expression = callArgument.expression;
            return isIdentifier(expression) && expression.escapedText === "arguments";
        }
    }
    var init_es2015 = __esm({
        "src/compiler/transformers/es2015.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/es5.ts
    function transformES5(context) {
        const { factory: factory2  } = context;
        const compilerOptions = context.getCompilerOptions();
        let previousOnEmitNode;
        let noSubstitution;
        if (compilerOptions.jsx === 1 /* Preserve */  || compilerOptions.jsx === 3 /* ReactNative */ ) {
            previousOnEmitNode = context.onEmitNode;
            context.onEmitNode = onEmitNode;
            context.enableEmitNotification(285 /* JsxOpeningElement */ );
            context.enableEmitNotification(286 /* JsxClosingElement */ );
            context.enableEmitNotification(284 /* JsxSelfClosingElement */ );
            noSubstitution = [];
        }
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onSubstituteNode = onSubstituteNode;
        context.enableSubstitution(210 /* PropertyAccessExpression */ );
        context.enableSubstitution(302 /* PropertyAssignment */ );
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            return node;
        }
        function onEmitNode(hint, node, emitCallback) {
            switch(node.kind){
                case 285 /* JsxOpeningElement */ :
                case 286 /* JsxClosingElement */ :
                case 284 /* JsxSelfClosingElement */ :
                    const tagName = node.tagName;
                    noSubstitution[getOriginalNodeId(tagName)] = true;
                    break;
            }
            previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            if (node.id && noSubstitution && noSubstitution[node.id]) return previousOnSubstituteNode(hint, node);
            node = previousOnSubstituteNode(hint, node);
            if (isPropertyAccessExpression(node)) return substitutePropertyAccessExpression(node);
            else if (isPropertyAssignment(node)) return substitutePropertyAssignment(node);
            return node;
        }
        function substitutePropertyAccessExpression(node) {
            if (isPrivateIdentifier(node.name)) return node;
            const literalName = trySubstituteReservedName(node.name);
            if (literalName) return setTextRange(factory2.createElementAccessExpression(node.expression, literalName), node);
            return node;
        }
        function substitutePropertyAssignment(node) {
            const literalName = isIdentifier(node.name) && trySubstituteReservedName(node.name);
            if (literalName) return factory2.updatePropertyAssignment(node, literalName, node.initializer);
            return node;
        }
        function trySubstituteReservedName(name) {
            const token = identifierToKeywordKind(name);
            if (token !== void 0 && token >= 83 /* FirstReservedWord */  && token <= 118 /* LastReservedWord */ ) return setTextRange(factory2.createStringLiteralFromNode(name), name);
            return void 0;
        }
    }
    var init_es5 = __esm({
        "src/compiler/transformers/es5.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/generators.ts
    function getInstructionName(instruction) {
        switch(instruction){
            case 2 /* Return */ :
                return "return";
            case 3 /* Break */ :
                return "break";
            case 4 /* Yield */ :
                return "yield";
            case 5 /* YieldStar */ :
                return "yield*";
            case 7 /* Endfinally */ :
                return "endfinally";
            default:
                return void 0;
        }
    }
    function transformGenerators(context) {
        const { factory: factory2 , getEmitHelperFactory: emitHelpers , resumeLexicalEnvironment: resumeLexicalEnvironment , endLexicalEnvironment: endLexicalEnvironment , hoistFunctionDeclaration: hoistFunctionDeclaration , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const resolver = context.getEmitResolver();
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onSubstituteNode = onSubstituteNode;
        let renamedCatchVariables;
        let renamedCatchVariableDeclarations;
        let inGeneratorFunctionBody;
        let inStatementContainingYield;
        let blocks;
        let blockOffsets;
        let blockActions;
        let blockStack;
        let labelOffsets;
        let labelExpressions;
        let nextLabelId = 1;
        let operations;
        let operationArguments;
        let operationLocations;
        let state;
        let blockIndex = 0;
        let labelNumber = 0;
        let labelNumbers;
        let lastOperationWasAbrupt;
        let lastOperationWasCompletion;
        let clauses;
        let statements;
        let exceptionBlockStack;
        let currentExceptionBlock;
        let withBlockStack;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile || (node.transformFlags & 2048 /* ContainsGenerator */ ) === 0) return node;
            const visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            return visited;
        }
        function visitor(node) {
            const transformFlags = node.transformFlags;
            if (inStatementContainingYield) return visitJavaScriptInStatementContainingYield(node);
            else if (inGeneratorFunctionBody) return visitJavaScriptInGeneratorFunctionBody(node);
            else if (isFunctionLikeDeclaration(node) && node.asteriskToken) return visitGenerator(node);
            else if (transformFlags & 2048 /* ContainsGenerator */ ) return visitEachChild(node, visitor, context);
            else return node;
        }
        function visitJavaScriptInStatementContainingYield(node) {
            switch(node.kind){
                case 245 /* DoStatement */ :
                    return visitDoStatement(node);
                case 246 /* WhileStatement */ :
                    return visitWhileStatement(node);
                case 254 /* SwitchStatement */ :
                    return visitSwitchStatement(node);
                case 255 /* LabeledStatement */ :
                    return visitLabeledStatement(node);
                default:
                    return visitJavaScriptInGeneratorFunctionBody(node);
            }
        }
        function visitJavaScriptInGeneratorFunctionBody(node) {
            switch(node.kind){
                case 261 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 217 /* FunctionExpression */ :
                    return visitFunctionExpression(node);
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    return visitAccessorDeclaration(node);
                case 242 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 247 /* ForStatement */ :
                    return visitForStatement(node);
                case 248 /* ForInStatement */ :
                    return visitForInStatement(node);
                case 251 /* BreakStatement */ :
                    return visitBreakStatement(node);
                case 250 /* ContinueStatement */ :
                    return visitContinueStatement(node);
                case 252 /* ReturnStatement */ :
                    return visitReturnStatement(node);
                default:
                    if (node.transformFlags & 1048576 /* ContainsYield */ ) return visitJavaScriptContainingYield(node);
                    else if (node.transformFlags & 4196352 /* ContainsHoistedDeclarationOrCompletion */ ) return visitEachChild(node, visitor, context);
                    else return node;
            }
        }
        function visitJavaScriptContainingYield(node) {
            switch(node.kind){
                case 225 /* BinaryExpression */ :
                    return visitBinaryExpression(node);
                case 360 /* CommaListExpression */ :
                    return visitCommaListExpression(node);
                case 226 /* ConditionalExpression */ :
                    return visitConditionalExpression(node);
                case 228 /* YieldExpression */ :
                    return visitYieldExpression(node);
                case 208 /* ArrayLiteralExpression */ :
                    return visitArrayLiteralExpression(node);
                case 209 /* ObjectLiteralExpression */ :
                    return visitObjectLiteralExpression(node);
                case 211 /* ElementAccessExpression */ :
                    return visitElementAccessExpression(node);
                case 212 /* CallExpression */ :
                    return visitCallExpression(node);
                case 213 /* NewExpression */ :
                    return visitNewExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitGenerator(node) {
            switch(node.kind){
                case 261 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 217 /* FunctionExpression */ :
                    return visitFunctionExpression(node);
                default:
                    return Debug.failBadSyntaxKind(node);
            }
        }
        function visitFunctionDeclaration(node) {
            if (node.asteriskToken) node = setOriginalNode(setTextRange(factory2.createFunctionDeclaration(node.modifiers, /*asteriskToken*/ void 0, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, transformGeneratorFunctionBody(node.body)), /*location*/ node), node);
            else {
                const savedInGeneratorFunctionBody = inGeneratorFunctionBody;
                const savedInStatementContainingYield = inStatementContainingYield;
                inGeneratorFunctionBody = false;
                inStatementContainingYield = false;
                node = visitEachChild(node, visitor, context);
                inGeneratorFunctionBody = savedInGeneratorFunctionBody;
                inStatementContainingYield = savedInStatementContainingYield;
            }
            if (inGeneratorFunctionBody) {
                hoistFunctionDeclaration(node);
                return void 0;
            } else return node;
        }
        function visitFunctionExpression(node) {
            if (node.asteriskToken) node = setOriginalNode(setTextRange(factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, transformGeneratorFunctionBody(node.body)), /*location*/ node), node);
            else {
                const savedInGeneratorFunctionBody = inGeneratorFunctionBody;
                const savedInStatementContainingYield = inStatementContainingYield;
                inGeneratorFunctionBody = false;
                inStatementContainingYield = false;
                node = visitEachChild(node, visitor, context);
                inGeneratorFunctionBody = savedInGeneratorFunctionBody;
                inStatementContainingYield = savedInStatementContainingYield;
            }
            return node;
        }
        function visitAccessorDeclaration(node) {
            const savedInGeneratorFunctionBody = inGeneratorFunctionBody;
            const savedInStatementContainingYield = inStatementContainingYield;
            inGeneratorFunctionBody = false;
            inStatementContainingYield = false;
            node = visitEachChild(node, visitor, context);
            inGeneratorFunctionBody = savedInGeneratorFunctionBody;
            inStatementContainingYield = savedInStatementContainingYield;
            return node;
        }
        function transformGeneratorFunctionBody(body) {
            const statements2 = [];
            const savedInGeneratorFunctionBody = inGeneratorFunctionBody;
            const savedInStatementContainingYield = inStatementContainingYield;
            const savedBlocks = blocks;
            const savedBlockOffsets = blockOffsets;
            const savedBlockActions = blockActions;
            const savedBlockStack = blockStack;
            const savedLabelOffsets = labelOffsets;
            const savedLabelExpressions = labelExpressions;
            const savedNextLabelId = nextLabelId;
            const savedOperations = operations;
            const savedOperationArguments = operationArguments;
            const savedOperationLocations = operationLocations;
            const savedState = state;
            inGeneratorFunctionBody = true;
            inStatementContainingYield = false;
            blocks = void 0;
            blockOffsets = void 0;
            blockActions = void 0;
            blockStack = void 0;
            labelOffsets = void 0;
            labelExpressions = void 0;
            nextLabelId = 1;
            operations = void 0;
            operationArguments = void 0;
            operationLocations = void 0;
            state = factory2.createTempVariable(/*recordTempVariable*/ void 0);
            resumeLexicalEnvironment();
            const statementOffset = factory2.copyPrologue(body.statements, statements2, /*ensureUseStrict*/ false, visitor);
            transformAndEmitStatements(body.statements, statementOffset);
            const buildResult = build2();
            insertStatementsAfterStandardPrologue(statements2, endLexicalEnvironment());
            statements2.push(factory2.createReturnStatement(buildResult));
            inGeneratorFunctionBody = savedInGeneratorFunctionBody;
            inStatementContainingYield = savedInStatementContainingYield;
            blocks = savedBlocks;
            blockOffsets = savedBlockOffsets;
            blockActions = savedBlockActions;
            blockStack = savedBlockStack;
            labelOffsets = savedLabelOffsets;
            labelExpressions = savedLabelExpressions;
            nextLabelId = savedNextLabelId;
            operations = savedOperations;
            operationArguments = savedOperationArguments;
            operationLocations = savedOperationLocations;
            state = savedState;
            return setTextRange(factory2.createBlock(statements2, body.multiLine), body);
        }
        function visitVariableStatement(node) {
            if (node.transformFlags & 1048576 /* ContainsYield */ ) {
                transformAndEmitVariableDeclarationList(node.declarationList);
                return void 0;
            } else {
                if (getEmitFlags(node) & 2097152 /* CustomPrologue */ ) return node;
                for (const variable of node.declarationList.declarations)hoistVariableDeclaration(variable.name);
                const variables = getInitializedVariables(node.declarationList);
                if (variables.length === 0) return void 0;
                return setSourceMapRange(factory2.createExpressionStatement(factory2.inlineExpressions(map(variables, transformInitializedVariable))), node);
            }
        }
        function visitBinaryExpression(node) {
            const assoc = getExpressionAssociativity(node);
            switch(assoc){
                case 0 /* Left */ :
                    return visitLeftAssociativeBinaryExpression(node);
                case 1 /* Right */ :
                    return visitRightAssociativeBinaryExpression(node);
                default:
                    return Debug.assertNever(assoc);
            }
        }
        function visitRightAssociativeBinaryExpression(node) {
            const { left: left , right: right  } = node;
            if (containsYield(right)) {
                let target;
                switch(left.kind){
                    case 210 /* PropertyAccessExpression */ :
                        target = factory2.updatePropertyAccessExpression(left, cacheExpression(Debug.checkDefined(visitNode(left.expression, visitor, isLeftHandSideExpression))), left.name);
                        break;
                    case 211 /* ElementAccessExpression */ :
                        target = factory2.updateElementAccessExpression(left, cacheExpression(Debug.checkDefined(visitNode(left.expression, visitor, isLeftHandSideExpression))), cacheExpression(Debug.checkDefined(visitNode(left.argumentExpression, visitor, isExpression))));
                        break;
                    default:
                        target = Debug.checkDefined(visitNode(left, visitor, isExpression));
                        break;
                }
                const operator = node.operatorToken.kind;
                if (isCompoundAssignment(operator)) return setTextRange(factory2.createAssignment(target, setTextRange(factory2.createBinaryExpression(cacheExpression(target), getNonAssignmentOperatorForCompoundAssignment(operator), Debug.checkDefined(visitNode(right, visitor, isExpression))), node)), node);
                else return factory2.updateBinaryExpression(node, target, node.operatorToken, Debug.checkDefined(visitNode(right, visitor, isExpression)));
            }
            return visitEachChild(node, visitor, context);
        }
        function visitLeftAssociativeBinaryExpression(node) {
            if (containsYield(node.right)) {
                if (isLogicalOperator(node.operatorToken.kind)) return visitLogicalBinaryExpression(node);
                else if (node.operatorToken.kind === 28 /* CommaToken */ ) return visitCommaExpression(node);
                return factory2.updateBinaryExpression(node, cacheExpression(Debug.checkDefined(visitNode(node.left, visitor, isExpression))), node.operatorToken, Debug.checkDefined(visitNode(node.right, visitor, isExpression)));
            }
            return visitEachChild(node, visitor, context);
        }
        function visitCommaExpression(node) {
            let pendingExpressions = [];
            visit(node.left);
            visit(node.right);
            return factory2.inlineExpressions(pendingExpressions);
            function visit(node2) {
                if (isBinaryExpression(node2) && node2.operatorToken.kind === 28 /* CommaToken */ ) {
                    visit(node2.left);
                    visit(node2.right);
                } else {
                    if (containsYield(node2) && pendingExpressions.length > 0) {
                        emitWorker(1 /* Statement */ , [
                            factory2.createExpressionStatement(factory2.inlineExpressions(pendingExpressions))
                        ]);
                        pendingExpressions = [];
                    }
                    pendingExpressions.push(Debug.checkDefined(visitNode(node2, visitor, isExpression)));
                }
            }
        }
        function visitCommaListExpression(node) {
            let pendingExpressions = [];
            for (const elem of node.elements)if (isBinaryExpression(elem) && elem.operatorToken.kind === 28 /* CommaToken */ ) pendingExpressions.push(visitCommaExpression(elem));
            else {
                if (containsYield(elem) && pendingExpressions.length > 0) {
                    emitWorker(1 /* Statement */ , [
                        factory2.createExpressionStatement(factory2.inlineExpressions(pendingExpressions))
                    ]);
                    pendingExpressions = [];
                }
                pendingExpressions.push(Debug.checkDefined(visitNode(elem, visitor, isExpression)));
            }
            return factory2.inlineExpressions(pendingExpressions);
        }
        function visitLogicalBinaryExpression(node) {
            const resultLabel = defineLabel();
            const resultLocal = declareLocal();
            emitAssignment(resultLocal, Debug.checkDefined(visitNode(node.left, visitor, isExpression)), /*location*/ node.left);
            if (node.operatorToken.kind === 56 /* AmpersandAmpersandToken */ ) emitBreakWhenFalse(resultLabel, resultLocal, /*location*/ node.left);
            else emitBreakWhenTrue(resultLabel, resultLocal, /*location*/ node.left);
            emitAssignment(resultLocal, Debug.checkDefined(visitNode(node.right, visitor, isExpression)), /*location*/ node.right);
            markLabel(resultLabel);
            return resultLocal;
        }
        function visitConditionalExpression(node) {
            if (containsYield(node.whenTrue) || containsYield(node.whenFalse)) {
                const whenFalseLabel = defineLabel();
                const resultLabel = defineLabel();
                const resultLocal = declareLocal();
                emitBreakWhenFalse(whenFalseLabel, Debug.checkDefined(visitNode(node.condition, visitor, isExpression)), /*location*/ node.condition);
                emitAssignment(resultLocal, Debug.checkDefined(visitNode(node.whenTrue, visitor, isExpression)), /*location*/ node.whenTrue);
                emitBreak(resultLabel);
                markLabel(whenFalseLabel);
                emitAssignment(resultLocal, Debug.checkDefined(visitNode(node.whenFalse, visitor, isExpression)), /*location*/ node.whenFalse);
                markLabel(resultLabel);
                return resultLocal;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitYieldExpression(node) {
            const resumeLabel = defineLabel();
            const expression = visitNode(node.expression, visitor, isExpression);
            if (node.asteriskToken) {
                const iterator = (getEmitFlags(node.expression) & 8388608 /* Iterator */ ) === 0 ? setTextRange(emitHelpers().createValuesHelper(expression), node) : expression;
                emitYieldStar(iterator, /*location*/ node);
            } else emitYield(expression, /*location*/ node);
            markLabel(resumeLabel);
            return createGeneratorResume(/*location*/ node);
        }
        function visitArrayLiteralExpression(node) {
            return visitElements(node.elements, /*leadingElement*/ void 0, /*location*/ void 0, node.multiLine);
        }
        function visitElements(elements, leadingElement, location, multiLine) {
            const numInitialElements = countInitialNodesWithoutYield(elements);
            let temp;
            if (numInitialElements > 0) {
                temp = declareLocal();
                const initialElements = visitNodes2(elements, visitor, isExpression, 0, numInitialElements);
                emitAssignment(temp, factory2.createArrayLiteralExpression(leadingElement ? [
                    leadingElement,
                    ...initialElements
                ] : initialElements));
                leadingElement = void 0;
            }
            const expressions = reduceLeft(elements, reduceElement, [], numInitialElements);
            return temp ? factory2.createArrayConcatCall(temp, [
                factory2.createArrayLiteralExpression(expressions, multiLine)
            ]) : setTextRange(factory2.createArrayLiteralExpression(leadingElement ? [
                leadingElement,
                ...expressions
            ] : expressions, multiLine), location);
            function reduceElement(expressions2, element) {
                if (containsYield(element) && expressions2.length > 0) {
                    const hasAssignedTemp = temp !== void 0;
                    if (!temp) temp = declareLocal();
                    emitAssignment(temp, hasAssignedTemp ? factory2.createArrayConcatCall(temp, [
                        factory2.createArrayLiteralExpression(expressions2, multiLine)
                    ]) : factory2.createArrayLiteralExpression(leadingElement ? [
                        leadingElement,
                        ...expressions2
                    ] : expressions2, multiLine));
                    leadingElement = void 0;
                    expressions2 = [];
                }
                expressions2.push(Debug.checkDefined(visitNode(element, visitor, isExpression)));
                return expressions2;
            }
        }
        function visitObjectLiteralExpression(node) {
            const properties = node.properties;
            const multiLine = node.multiLine;
            const numInitialProperties = countInitialNodesWithoutYield(properties);
            const temp = declareLocal();
            emitAssignment(temp, factory2.createObjectLiteralExpression(visitNodes2(properties, visitor, isObjectLiteralElementLike, 0, numInitialProperties), multiLine));
            const expressions = reduceLeft(properties, reduceProperty, [], numInitialProperties);
            expressions.push(multiLine ? startOnNewLine(setParent(setTextRange(factory2.cloneNode(temp), temp), temp.parent)) : temp);
            return factory2.inlineExpressions(expressions);
            function reduceProperty(expressions2, property) {
                if (containsYield(property) && expressions2.length > 0) {
                    emitStatement(factory2.createExpressionStatement(factory2.inlineExpressions(expressions2)));
                    expressions2 = [];
                }
                const expression = createExpressionForObjectLiteralElementLike(factory2, node, property, temp);
                const visited = visitNode(expression, visitor, isExpression);
                if (visited) {
                    if (multiLine) startOnNewLine(visited);
                    expressions2.push(visited);
                }
                return expressions2;
            }
        }
        function visitElementAccessExpression(node) {
            if (containsYield(node.argumentExpression)) return factory2.updateElementAccessExpression(node, cacheExpression(Debug.checkDefined(visitNode(node.expression, visitor, isLeftHandSideExpression))), Debug.checkDefined(visitNode(node.argumentExpression, visitor, isExpression)));
            return visitEachChild(node, visitor, context);
        }
        function visitCallExpression(node) {
            if (!isImportCall(node) && forEach(node.arguments, containsYield)) {
                const { target: target , thisArg: thisArg  } = factory2.createCallBinding(node.expression, hoistVariableDeclaration, languageVersion, /*cacheIdentifiers*/ true);
                return setOriginalNode(setTextRange(factory2.createFunctionApplyCall(cacheExpression(Debug.checkDefined(visitNode(target, visitor, isLeftHandSideExpression))), thisArg, visitElements(node.arguments)), node), node);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitNewExpression(node) {
            if (forEach(node.arguments, containsYield)) {
                const { target: target , thisArg: thisArg  } = factory2.createCallBinding(factory2.createPropertyAccessExpression(node.expression, "bind"), hoistVariableDeclaration);
                return setOriginalNode(setTextRange(factory2.createNewExpression(factory2.createFunctionApplyCall(cacheExpression(Debug.checkDefined(visitNode(target, visitor, isExpression))), thisArg, visitElements(node.arguments, /*leadingElement*/ factory2.createVoidZero())), /*typeArguments*/ void 0, []), node), node);
            }
            return visitEachChild(node, visitor, context);
        }
        function transformAndEmitStatements(statements2, start = 0) {
            const numStatements = statements2.length;
            for(let i = start; i < numStatements; i++)transformAndEmitStatement(statements2[i]);
        }
        function transformAndEmitEmbeddedStatement(node) {
            if (isBlock(node)) transformAndEmitStatements(node.statements);
            else transformAndEmitStatement(node);
        }
        function transformAndEmitStatement(node) {
            const savedInStatementContainingYield = inStatementContainingYield;
            if (!inStatementContainingYield) inStatementContainingYield = containsYield(node);
            transformAndEmitStatementWorker(node);
            inStatementContainingYield = savedInStatementContainingYield;
        }
        function transformAndEmitStatementWorker(node) {
            switch(node.kind){
                case 240 /* Block */ :
                    return transformAndEmitBlock(node);
                case 243 /* ExpressionStatement */ :
                    return transformAndEmitExpressionStatement(node);
                case 244 /* IfStatement */ :
                    return transformAndEmitIfStatement(node);
                case 245 /* DoStatement */ :
                    return transformAndEmitDoStatement(node);
                case 246 /* WhileStatement */ :
                    return transformAndEmitWhileStatement(node);
                case 247 /* ForStatement */ :
                    return transformAndEmitForStatement(node);
                case 248 /* ForInStatement */ :
                    return transformAndEmitForInStatement(node);
                case 250 /* ContinueStatement */ :
                    return transformAndEmitContinueStatement(node);
                case 251 /* BreakStatement */ :
                    return transformAndEmitBreakStatement(node);
                case 252 /* ReturnStatement */ :
                    return transformAndEmitReturnStatement(node);
                case 253 /* WithStatement */ :
                    return transformAndEmitWithStatement(node);
                case 254 /* SwitchStatement */ :
                    return transformAndEmitSwitchStatement(node);
                case 255 /* LabeledStatement */ :
                    return transformAndEmitLabeledStatement(node);
                case 256 /* ThrowStatement */ :
                    return transformAndEmitThrowStatement(node);
                case 257 /* TryStatement */ :
                    return transformAndEmitTryStatement(node);
                default:
                    return emitStatement(visitNode(node, visitor, isStatement));
            }
        }
        function transformAndEmitBlock(node) {
            if (containsYield(node)) transformAndEmitStatements(node.statements);
            else emitStatement(visitNode(node, visitor, isStatement));
        }
        function transformAndEmitExpressionStatement(node) {
            emitStatement(visitNode(node, visitor, isStatement));
        }
        function transformAndEmitVariableDeclarationList(node) {
            for (const variable of node.declarations){
                const name = factory2.cloneNode(variable.name);
                setCommentRange(name, variable.name);
                hoistVariableDeclaration(name);
            }
            const variables = getInitializedVariables(node);
            const numVariables = variables.length;
            let variablesWritten = 0;
            let pendingExpressions = [];
            while(variablesWritten < numVariables){
                for(let i = variablesWritten; i < numVariables; i++){
                    const variable = variables[i];
                    if (containsYield(variable.initializer) && pendingExpressions.length > 0) break;
                    pendingExpressions.push(transformInitializedVariable(variable));
                }
                if (pendingExpressions.length) {
                    emitStatement(factory2.createExpressionStatement(factory2.inlineExpressions(pendingExpressions)));
                    variablesWritten += pendingExpressions.length;
                    pendingExpressions = [];
                }
            }
            return void 0;
        }
        function transformInitializedVariable(node) {
            return setSourceMapRange(factory2.createAssignment(setSourceMapRange(factory2.cloneNode(node.name), node.name), Debug.checkDefined(visitNode(node.initializer, visitor, isExpression))), node);
        }
        function transformAndEmitIfStatement(node) {
            if (containsYield(node)) {
                if (containsYield(node.thenStatement) || containsYield(node.elseStatement)) {
                    const endLabel = defineLabel();
                    const elseLabel = node.elseStatement ? defineLabel() : void 0;
                    emitBreakWhenFalse(node.elseStatement ? elseLabel : endLabel, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), /*location*/ node.expression);
                    transformAndEmitEmbeddedStatement(node.thenStatement);
                    if (node.elseStatement) {
                        emitBreak(endLabel);
                        markLabel(elseLabel);
                        transformAndEmitEmbeddedStatement(node.elseStatement);
                    }
                    markLabel(endLabel);
                } else emitStatement(visitNode(node, visitor, isStatement));
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function transformAndEmitDoStatement(node) {
            if (containsYield(node)) {
                const conditionLabel = defineLabel();
                const loopLabel = defineLabel();
                beginLoopBlock(/*continueLabel*/ conditionLabel);
                markLabel(loopLabel);
                transformAndEmitEmbeddedStatement(node.statement);
                markLabel(conditionLabel);
                emitBreakWhenTrue(loopLabel, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
                endLoopBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitDoStatement(node) {
            if (inStatementContainingYield) {
                beginScriptLoopBlock();
                node = visitEachChild(node, visitor, context);
                endLoopBlock();
                return node;
            } else return visitEachChild(node, visitor, context);
        }
        function transformAndEmitWhileStatement(node) {
            if (containsYield(node)) {
                const loopLabel = defineLabel();
                const endLabel = beginLoopBlock(loopLabel);
                markLabel(loopLabel);
                emitBreakWhenFalse(endLabel, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
                transformAndEmitEmbeddedStatement(node.statement);
                emitBreak(loopLabel);
                endLoopBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitWhileStatement(node) {
            if (inStatementContainingYield) {
                beginScriptLoopBlock();
                node = visitEachChild(node, visitor, context);
                endLoopBlock();
                return node;
            } else return visitEachChild(node, visitor, context);
        }
        function transformAndEmitForStatement(node) {
            if (containsYield(node)) {
                const conditionLabel = defineLabel();
                const incrementLabel = defineLabel();
                const endLabel = beginLoopBlock(incrementLabel);
                if (node.initializer) {
                    const initializer = node.initializer;
                    if (isVariableDeclarationList(initializer)) transformAndEmitVariableDeclarationList(initializer);
                    else emitStatement(setTextRange(factory2.createExpressionStatement(Debug.checkDefined(visitNode(initializer, visitor, isExpression))), initializer));
                }
                markLabel(conditionLabel);
                if (node.condition) emitBreakWhenFalse(endLabel, Debug.checkDefined(visitNode(node.condition, visitor, isExpression)));
                transformAndEmitEmbeddedStatement(node.statement);
                markLabel(incrementLabel);
                if (node.incrementor) emitStatement(setTextRange(factory2.createExpressionStatement(Debug.checkDefined(visitNode(node.incrementor, visitor, isExpression))), node.incrementor));
                emitBreak(conditionLabel);
                endLoopBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitForStatement(node) {
            if (inStatementContainingYield) beginScriptLoopBlock();
            const initializer = node.initializer;
            if (initializer && isVariableDeclarationList(initializer)) {
                for (const variable of initializer.declarations)hoistVariableDeclaration(variable.name);
                const variables = getInitializedVariables(initializer);
                node = factory2.updateForStatement(node, variables.length > 0 ? factory2.inlineExpressions(map(variables, transformInitializedVariable)) : void 0, visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, visitor, isExpression), visitIterationBody(node.statement, visitor, context));
            } else node = visitEachChild(node, visitor, context);
            if (inStatementContainingYield) endLoopBlock();
            return node;
        }
        function transformAndEmitForInStatement(node) {
            if (containsYield(node)) {
                const obj = declareLocal();
                const keysArray = declareLocal();
                const key = declareLocal();
                const keysIndex = factory2.createLoopVariable();
                const initializer = node.initializer;
                hoistVariableDeclaration(keysIndex);
                emitAssignment(obj, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
                emitAssignment(keysArray, factory2.createArrayLiteralExpression());
                emitStatement(factory2.createForInStatement(key, obj, factory2.createExpressionStatement(factory2.createCallExpression(factory2.createPropertyAccessExpression(keysArray, "push"), /*typeArguments*/ void 0, [
                    key
                ]))));
                emitAssignment(keysIndex, factory2.createNumericLiteral(0));
                const conditionLabel = defineLabel();
                const incrementLabel = defineLabel();
                const endLoopLabel = beginLoopBlock(incrementLabel);
                markLabel(conditionLabel);
                emitBreakWhenFalse(endLoopLabel, factory2.createLessThan(keysIndex, factory2.createPropertyAccessExpression(keysArray, "length")));
                emitAssignment(key, factory2.createElementAccessExpression(keysArray, keysIndex));
                emitBreakWhenFalse(incrementLabel, factory2.createBinaryExpression(key, 103 /* InKeyword */ , obj));
                let variable;
                if (isVariableDeclarationList(initializer)) {
                    for (const variable2 of initializer.declarations)hoistVariableDeclaration(variable2.name);
                    variable = factory2.cloneNode(initializer.declarations[0].name);
                } else {
                    variable = Debug.checkDefined(visitNode(initializer, visitor, isExpression));
                    Debug.assert(isLeftHandSideExpression(variable));
                }
                emitAssignment(variable, key);
                transformAndEmitEmbeddedStatement(node.statement);
                markLabel(incrementLabel);
                emitStatement(factory2.createExpressionStatement(factory2.createPostfixIncrement(keysIndex)));
                emitBreak(conditionLabel);
                endLoopBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitForInStatement(node) {
            if (inStatementContainingYield) beginScriptLoopBlock();
            const initializer = node.initializer;
            if (isVariableDeclarationList(initializer)) {
                for (const variable of initializer.declarations)hoistVariableDeclaration(variable.name);
                node = factory2.updateForInStatement(node, initializer.declarations[0].name, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), Debug.checkDefined(visitNode(node.statement, visitor, isStatement, factory2.liftToBlock)));
            } else node = visitEachChild(node, visitor, context);
            if (inStatementContainingYield) endLoopBlock();
            return node;
        }
        function transformAndEmitContinueStatement(node) {
            const label = findContinueTarget(node.label ? idText(node.label) : void 0);
            if (label > 0) emitBreak(label, /*location*/ node);
            else emitStatement(node);
        }
        function visitContinueStatement(node) {
            if (inStatementContainingYield) {
                const label = findContinueTarget(node.label && idText(node.label));
                if (label > 0) return createInlineBreak(label, /*location*/ node);
            }
            return visitEachChild(node, visitor, context);
        }
        function transformAndEmitBreakStatement(node) {
            const label = findBreakTarget(node.label ? idText(node.label) : void 0);
            if (label > 0) emitBreak(label, /*location*/ node);
            else emitStatement(node);
        }
        function visitBreakStatement(node) {
            if (inStatementContainingYield) {
                const label = findBreakTarget(node.label && idText(node.label));
                if (label > 0) return createInlineBreak(label, /*location*/ node);
            }
            return visitEachChild(node, visitor, context);
        }
        function transformAndEmitReturnStatement(node) {
            emitReturn(visitNode(node.expression, visitor, isExpression), /*location*/ node);
        }
        function visitReturnStatement(node) {
            return createInlineReturn(visitNode(node.expression, visitor, isExpression), /*location*/ node);
        }
        function transformAndEmitWithStatement(node) {
            if (containsYield(node)) {
                beginWithBlock(cacheExpression(Debug.checkDefined(visitNode(node.expression, visitor, isExpression))));
                transformAndEmitEmbeddedStatement(node.statement);
                endWithBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function transformAndEmitSwitchStatement(node) {
            if (containsYield(node.caseBlock)) {
                const caseBlock = node.caseBlock;
                const numClauses = caseBlock.clauses.length;
                const endLabel = beginSwitchBlock();
                const expression = cacheExpression(Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
                const clauseLabels = [];
                let defaultClauseIndex = -1;
                for(let i = 0; i < numClauses; i++){
                    const clause = caseBlock.clauses[i];
                    clauseLabels.push(defineLabel());
                    if (clause.kind === 296 /* DefaultClause */  && defaultClauseIndex === -1) defaultClauseIndex = i;
                }
                let clausesWritten = 0;
                let pendingClauses = [];
                while(clausesWritten < numClauses){
                    let defaultClausesSkipped = 0;
                    for(let i = clausesWritten; i < numClauses; i++){
                        const clause = caseBlock.clauses[i];
                        if (clause.kind === 295 /* CaseClause */ ) {
                            if (containsYield(clause.expression) && pendingClauses.length > 0) break;
                            pendingClauses.push(factory2.createCaseClause(Debug.checkDefined(visitNode(clause.expression, visitor, isExpression)), [
                                createInlineBreak(clauseLabels[i], /*location*/ clause.expression)
                            ]));
                        } else defaultClausesSkipped++;
                    }
                    if (pendingClauses.length) {
                        emitStatement(factory2.createSwitchStatement(expression, factory2.createCaseBlock(pendingClauses)));
                        clausesWritten += pendingClauses.length;
                        pendingClauses = [];
                    }
                    if (defaultClausesSkipped > 0) {
                        clausesWritten += defaultClausesSkipped;
                        defaultClausesSkipped = 0;
                    }
                }
                if (defaultClauseIndex >= 0) emitBreak(clauseLabels[defaultClauseIndex]);
                else emitBreak(endLabel);
                for(let i = 0; i < numClauses; i++){
                    markLabel(clauseLabels[i]);
                    transformAndEmitStatements(caseBlock.clauses[i].statements);
                }
                endSwitchBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitSwitchStatement(node) {
            if (inStatementContainingYield) beginScriptSwitchBlock();
            node = visitEachChild(node, visitor, context);
            if (inStatementContainingYield) endSwitchBlock();
            return node;
        }
        function transformAndEmitLabeledStatement(node) {
            if (containsYield(node)) {
                beginLabeledBlock(idText(node.label));
                transformAndEmitEmbeddedStatement(node.statement);
                endLabeledBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitLabeledStatement(node) {
            if (inStatementContainingYield) beginScriptLabeledBlock(idText(node.label));
            node = visitEachChild(node, visitor, context);
            if (inStatementContainingYield) endLabeledBlock();
            return node;
        }
        function transformAndEmitThrowStatement(node) {
            emitThrow(Debug.checkDefined(visitNode(node.expression ?? factory2.createVoidZero(), visitor, isExpression)), /*location*/ node);
        }
        function transformAndEmitTryStatement(node) {
            if (containsYield(node)) {
                beginExceptionBlock();
                transformAndEmitEmbeddedStatement(node.tryBlock);
                if (node.catchClause) {
                    beginCatchBlock(node.catchClause.variableDeclaration);
                    transformAndEmitEmbeddedStatement(node.catchClause.block);
                }
                if (node.finallyBlock) {
                    beginFinallyBlock();
                    transformAndEmitEmbeddedStatement(node.finallyBlock);
                }
                endExceptionBlock();
            } else emitStatement(visitEachChild(node, visitor, context));
        }
        function containsYield(node) {
            return !!node && (node.transformFlags & 1048576 /* ContainsYield */ ) !== 0;
        }
        function countInitialNodesWithoutYield(nodes) {
            const numNodes = nodes.length;
            for(let i = 0; i < numNodes; i++){
                if (containsYield(nodes[i])) return i;
            }
            return -1;
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            return node;
        }
        function substituteExpression(node) {
            if (isIdentifier(node)) return substituteExpressionIdentifier(node);
            return node;
        }
        function substituteExpressionIdentifier(node) {
            if (!isGeneratedIdentifier(node) && renamedCatchVariables && renamedCatchVariables.has(idText(node))) {
                const original = getOriginalNode(node);
                if (isIdentifier(original) && original.parent) {
                    const declaration = resolver.getReferencedValueDeclaration(original);
                    if (declaration) {
                        const name = renamedCatchVariableDeclarations[getOriginalNodeId(declaration)];
                        if (name) {
                            const clone2 = setParent(setTextRange(factory2.cloneNode(name), name), name.parent);
                            setSourceMapRange(clone2, node);
                            setCommentRange(clone2, node);
                            return clone2;
                        }
                    }
                }
            }
            return node;
        }
        function cacheExpression(node) {
            if (isGeneratedIdentifier(node) || getEmitFlags(node) & 8192 /* HelperName */ ) return node;
            const temp = factory2.createTempVariable(hoistVariableDeclaration);
            emitAssignment(temp, node, /*location*/ node);
            return temp;
        }
        function declareLocal(name) {
            const temp = name ? factory2.createUniqueName(name) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            hoistVariableDeclaration(temp);
            return temp;
        }
        function defineLabel() {
            if (!labelOffsets) labelOffsets = [];
            const label = nextLabelId;
            nextLabelId++;
            labelOffsets[label] = -1;
            return label;
        }
        function markLabel(label) {
            Debug.assert(labelOffsets !== void 0, "No labels were defined.");
            labelOffsets[label] = operations ? operations.length : 0;
        }
        function beginBlock(block) {
            if (!blocks) {
                blocks = [];
                blockActions = [];
                blockOffsets = [];
                blockStack = [];
            }
            const index = blockActions.length;
            blockActions[index] = 0 /* Open */ ;
            blockOffsets[index] = operations ? operations.length : 0;
            blocks[index] = block;
            blockStack.push(block);
            return index;
        }
        function endBlock() {
            const block = peekBlock();
            if (block === void 0) return Debug.fail("beginBlock was never called.");
            const index = blockActions.length;
            blockActions[index] = 1 /* Close */ ;
            blockOffsets[index] = operations ? operations.length : 0;
            blocks[index] = block;
            blockStack.pop();
            return block;
        }
        function peekBlock() {
            return lastOrUndefined(blockStack);
        }
        function peekBlockKind() {
            const block = peekBlock();
            return block && block.kind;
        }
        function beginWithBlock(expression) {
            const startLabel = defineLabel();
            const endLabel = defineLabel();
            markLabel(startLabel);
            beginBlock({
                kind: 1 /* With */ ,
                expression: expression,
                startLabel: startLabel,
                endLabel: endLabel
            });
        }
        function endWithBlock() {
            Debug.assert(peekBlockKind() === 1 /* With */ );
            const block = endBlock();
            markLabel(block.endLabel);
        }
        function beginExceptionBlock() {
            const startLabel = defineLabel();
            const endLabel = defineLabel();
            markLabel(startLabel);
            beginBlock({
                kind: 0 /* Exception */ ,
                state: 0 /* Try */ ,
                startLabel: startLabel,
                endLabel: endLabel
            });
            emitNop();
            return endLabel;
        }
        function beginCatchBlock(variable) {
            Debug.assert(peekBlockKind() === 0 /* Exception */ );
            let name;
            if (isGeneratedIdentifier(variable.name)) {
                name = variable.name;
                hoistVariableDeclaration(variable.name);
            } else {
                const text = idText(variable.name);
                name = declareLocal(text);
                if (!renamedCatchVariables) {
                    renamedCatchVariables = /* @__PURE__ */ new Map();
                    renamedCatchVariableDeclarations = [];
                    context.enableSubstitution(80 /* Identifier */ );
                }
                renamedCatchVariables.set(text, true);
                renamedCatchVariableDeclarations[getOriginalNodeId(variable)] = name;
            }
            const exception = peekBlock();
            Debug.assert(exception.state < 1 /* Catch */ );
            const endLabel = exception.endLabel;
            emitBreak(endLabel);
            const catchLabel = defineLabel();
            markLabel(catchLabel);
            exception.state = 1 /* Catch */ ;
            exception.catchVariable = name;
            exception.catchLabel = catchLabel;
            emitAssignment(name, factory2.createCallExpression(factory2.createPropertyAccessExpression(state, "sent"), /*typeArguments*/ void 0, []));
            emitNop();
        }
        function beginFinallyBlock() {
            Debug.assert(peekBlockKind() === 0 /* Exception */ );
            const exception = peekBlock();
            Debug.assert(exception.state < 2 /* Finally */ );
            const endLabel = exception.endLabel;
            emitBreak(endLabel);
            const finallyLabel = defineLabel();
            markLabel(finallyLabel);
            exception.state = 2 /* Finally */ ;
            exception.finallyLabel = finallyLabel;
        }
        function endExceptionBlock() {
            Debug.assert(peekBlockKind() === 0 /* Exception */ );
            const exception = endBlock();
            const state2 = exception.state;
            if (state2 < 2 /* Finally */ ) emitBreak(exception.endLabel);
            else emitEndfinally();
            markLabel(exception.endLabel);
            emitNop();
            exception.state = 3 /* Done */ ;
        }
        function beginScriptLoopBlock() {
            beginBlock({
                kind: 3 /* Loop */ ,
                isScript: true,
                breakLabel: -1,
                continueLabel: -1
            });
        }
        function beginLoopBlock(continueLabel) {
            const breakLabel = defineLabel();
            beginBlock({
                kind: 3 /* Loop */ ,
                isScript: false,
                breakLabel: breakLabel,
                continueLabel: continueLabel
            });
            return breakLabel;
        }
        function endLoopBlock() {
            Debug.assert(peekBlockKind() === 3 /* Loop */ );
            const block = endBlock();
            const breakLabel = block.breakLabel;
            if (!block.isScript) markLabel(breakLabel);
        }
        function beginScriptSwitchBlock() {
            beginBlock({
                kind: 2 /* Switch */ ,
                isScript: true,
                breakLabel: -1
            });
        }
        function beginSwitchBlock() {
            const breakLabel = defineLabel();
            beginBlock({
                kind: 2 /* Switch */ ,
                isScript: false,
                breakLabel: breakLabel
            });
            return breakLabel;
        }
        function endSwitchBlock() {
            Debug.assert(peekBlockKind() === 2 /* Switch */ );
            const block = endBlock();
            const breakLabel = block.breakLabel;
            if (!block.isScript) markLabel(breakLabel);
        }
        function beginScriptLabeledBlock(labelText) {
            beginBlock({
                kind: 4 /* Labeled */ ,
                isScript: true,
                labelText: labelText,
                breakLabel: -1
            });
        }
        function beginLabeledBlock(labelText) {
            const breakLabel = defineLabel();
            beginBlock({
                kind: 4 /* Labeled */ ,
                isScript: false,
                labelText: labelText,
                breakLabel: breakLabel
            });
        }
        function endLabeledBlock() {
            Debug.assert(peekBlockKind() === 4 /* Labeled */ );
            const block = endBlock();
            if (!block.isScript) markLabel(block.breakLabel);
        }
        function supportsUnlabeledBreak(block) {
            return block.kind === 2 /* Switch */  || block.kind === 3 /* Loop */ ;
        }
        function supportsLabeledBreakOrContinue(block) {
            return block.kind === 4 /* Labeled */ ;
        }
        function supportsUnlabeledContinue(block) {
            return block.kind === 3 /* Loop */ ;
        }
        function hasImmediateContainingLabeledBlock(labelText, start) {
            for(let j = start; j >= 0; j--){
                const containingBlock = blockStack[j];
                if (supportsLabeledBreakOrContinue(containingBlock)) {
                    if (containingBlock.labelText === labelText) return true;
                } else break;
            }
            return false;
        }
        function findBreakTarget(labelText) {
            if (blockStack) {
                if (labelText) for(let i = blockStack.length - 1; i >= 0; i--){
                    const block = blockStack[i];
                    if (supportsLabeledBreakOrContinue(block) && block.labelText === labelText) return block.breakLabel;
                    else if (supportsUnlabeledBreak(block) && hasImmediateContainingLabeledBlock(labelText, i - 1)) return block.breakLabel;
                }
                else for(let i = blockStack.length - 1; i >= 0; i--){
                    const block = blockStack[i];
                    if (supportsUnlabeledBreak(block)) return block.breakLabel;
                }
            }
            return 0;
        }
        function findContinueTarget(labelText) {
            if (blockStack) {
                if (labelText) for(let i = blockStack.length - 1; i >= 0; i--){
                    const block = blockStack[i];
                    if (supportsUnlabeledContinue(block) && hasImmediateContainingLabeledBlock(labelText, i - 1)) return block.continueLabel;
                }
                else for(let i = blockStack.length - 1; i >= 0; i--){
                    const block = blockStack[i];
                    if (supportsUnlabeledContinue(block)) return block.continueLabel;
                }
            }
            return 0;
        }
        function createLabel(label) {
            if (label !== void 0 && label > 0) {
                if (labelExpressions === void 0) labelExpressions = [];
                const expression = factory2.createNumericLiteral(-1);
                if (labelExpressions[label] === void 0) labelExpressions[label] = [
                    expression
                ];
                else labelExpressions[label].push(expression);
                return expression;
            }
            return factory2.createOmittedExpression();
        }
        function createInstruction(instruction) {
            const literal = factory2.createNumericLiteral(instruction);
            addSyntheticTrailingComment(literal, 3 /* MultiLineCommentTrivia */ , getInstructionName(instruction));
            return literal;
        }
        function createInlineBreak(label, location) {
            Debug.assertLessThan(0, label, "Invalid label");
            return setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(3 /* Break */ ),
                createLabel(label)
            ])), location);
        }
        function createInlineReturn(expression, location) {
            return setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression(expression ? [
                createInstruction(2 /* Return */ ),
                expression
            ] : [
                createInstruction(2 /* Return */ )
            ])), location);
        }
        function createGeneratorResume(location) {
            return setTextRange(factory2.createCallExpression(factory2.createPropertyAccessExpression(state, "sent"), /*typeArguments*/ void 0, []), location);
        }
        function emitNop() {
            emitWorker(0 /* Nop */ );
        }
        function emitStatement(node) {
            if (node) emitWorker(1 /* Statement */ , [
                node
            ]);
            else emitNop();
        }
        function emitAssignment(left, right, location) {
            emitWorker(2 /* Assign */ , [
                left,
                right
            ], location);
        }
        function emitBreak(label, location) {
            emitWorker(3 /* Break */ , [
                label
            ], location);
        }
        function emitBreakWhenTrue(label, condition, location) {
            emitWorker(4 /* BreakWhenTrue */ , [
                label,
                condition
            ], location);
        }
        function emitBreakWhenFalse(label, condition, location) {
            emitWorker(5 /* BreakWhenFalse */ , [
                label,
                condition
            ], location);
        }
        function emitYieldStar(expression, location) {
            emitWorker(7 /* YieldStar */ , [
                expression
            ], location);
        }
        function emitYield(expression, location) {
            emitWorker(6 /* Yield */ , [
                expression
            ], location);
        }
        function emitReturn(expression, location) {
            emitWorker(8 /* Return */ , [
                expression
            ], location);
        }
        function emitThrow(expression, location) {
            emitWorker(9 /* Throw */ , [
                expression
            ], location);
        }
        function emitEndfinally() {
            emitWorker(10 /* Endfinally */ );
        }
        function emitWorker(code, args, location) {
            if (operations === void 0) {
                operations = [];
                operationArguments = [];
                operationLocations = [];
            }
            if (labelOffsets === void 0) markLabel(defineLabel());
            const operationIndex = operations.length;
            operations[operationIndex] = code;
            operationArguments[operationIndex] = args;
            operationLocations[operationIndex] = location;
        }
        function build2() {
            blockIndex = 0;
            labelNumber = 0;
            labelNumbers = void 0;
            lastOperationWasAbrupt = false;
            lastOperationWasCompletion = false;
            clauses = void 0;
            statements = void 0;
            exceptionBlockStack = void 0;
            currentExceptionBlock = void 0;
            withBlockStack = void 0;
            const buildResult = buildStatements();
            return emitHelpers().createGeneratorHelper(setEmitFlags(factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, state)
            ], /*type*/ void 0, factory2.createBlock(buildResult, /*multiLine*/ buildResult.length > 0)), 1048576 /* ReuseTempVariableScope */ ));
        }
        function buildStatements() {
            if (operations) {
                for(let operationIndex = 0; operationIndex < operations.length; operationIndex++)writeOperation(operationIndex);
                flushFinalLabel(operations.length);
            } else flushFinalLabel(0);
            if (clauses) {
                const labelExpression = factory2.createPropertyAccessExpression(state, "label");
                const switchStatement = factory2.createSwitchStatement(labelExpression, factory2.createCaseBlock(clauses));
                return [
                    startOnNewLine(switchStatement)
                ];
            }
            if (statements) return statements;
            return [];
        }
        function flushLabel() {
            if (!statements) return;
            appendLabel(/*markLabelEnd*/ !lastOperationWasAbrupt);
            lastOperationWasAbrupt = false;
            lastOperationWasCompletion = false;
            labelNumber++;
        }
        function flushFinalLabel(operationIndex) {
            if (isFinalLabelReachable(operationIndex)) {
                tryEnterLabel(operationIndex);
                withBlockStack = void 0;
                writeReturn(/*expression*/ void 0, /*operationLocation*/ void 0);
            }
            if (statements && clauses) appendLabel(/*markLabelEnd*/ false);
            updateLabelExpressions();
        }
        function isFinalLabelReachable(operationIndex) {
            if (!lastOperationWasCompletion) return true;
            if (!labelOffsets || !labelExpressions) return false;
            for(let label = 0; label < labelOffsets.length; label++){
                if (labelOffsets[label] === operationIndex && labelExpressions[label]) return true;
            }
            return false;
        }
        function appendLabel(markLabelEnd) {
            if (!clauses) clauses = [];
            if (statements) {
                if (withBlockStack) for(let i = withBlockStack.length - 1; i >= 0; i--){
                    const withBlock = withBlockStack[i];
                    statements = [
                        factory2.createWithStatement(withBlock.expression, factory2.createBlock(statements))
                    ];
                }
                if (currentExceptionBlock) {
                    const { startLabel: startLabel , catchLabel: catchLabel , finallyLabel: finallyLabel , endLabel: endLabel  } = currentExceptionBlock;
                    statements.unshift(factory2.createExpressionStatement(factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createPropertyAccessExpression(state, "trys"), "push"), /*typeArguments*/ void 0, [
                        factory2.createArrayLiteralExpression([
                            createLabel(startLabel),
                            createLabel(catchLabel),
                            createLabel(finallyLabel),
                            createLabel(endLabel)
                        ])
                    ])));
                    currentExceptionBlock = void 0;
                }
                if (markLabelEnd) statements.push(factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(state, "label"), factory2.createNumericLiteral(labelNumber + 1))));
            }
            clauses.push(factory2.createCaseClause(factory2.createNumericLiteral(labelNumber), statements || []));
            statements = void 0;
        }
        function tryEnterLabel(operationIndex) {
            if (!labelOffsets) return;
            for(let label = 0; label < labelOffsets.length; label++)if (labelOffsets[label] === operationIndex) {
                flushLabel();
                if (labelNumbers === void 0) labelNumbers = [];
                if (labelNumbers[labelNumber] === void 0) labelNumbers[labelNumber] = [
                    label
                ];
                else labelNumbers[labelNumber].push(label);
            }
        }
        function updateLabelExpressions() {
            if (labelExpressions !== void 0 && labelNumbers !== void 0) for(let labelNumber2 = 0; labelNumber2 < labelNumbers.length; labelNumber2++){
                const labels = labelNumbers[labelNumber2];
                if (labels !== void 0) for (const label of labels){
                    const expressions = labelExpressions[label];
                    if (expressions !== void 0) for (const expression of expressions)expression.text = String(labelNumber2);
                }
            }
        }
        function tryEnterOrLeaveBlock(operationIndex) {
            if (blocks) for(; blockIndex < blockActions.length && blockOffsets[blockIndex] <= operationIndex; blockIndex++){
                const block = blocks[blockIndex];
                const blockAction = blockActions[blockIndex];
                switch(block.kind){
                    case 0 /* Exception */ :
                        if (blockAction === 0 /* Open */ ) {
                            if (!exceptionBlockStack) exceptionBlockStack = [];
                            if (!statements) statements = [];
                            exceptionBlockStack.push(currentExceptionBlock);
                            currentExceptionBlock = block;
                        } else if (blockAction === 1 /* Close */ ) currentExceptionBlock = exceptionBlockStack.pop();
                        break;
                    case 1 /* With */ :
                        if (blockAction === 0 /* Open */ ) {
                            if (!withBlockStack) withBlockStack = [];
                            withBlockStack.push(block);
                        } else if (blockAction === 1 /* Close */ ) withBlockStack.pop();
                        break;
                }
            }
        }
        function writeOperation(operationIndex) {
            tryEnterLabel(operationIndex);
            tryEnterOrLeaveBlock(operationIndex);
            if (lastOperationWasAbrupt) return;
            lastOperationWasAbrupt = false;
            lastOperationWasCompletion = false;
            const opcode = operations[operationIndex];
            if (opcode === 0 /* Nop */ ) return;
            else if (opcode === 10 /* Endfinally */ ) return writeEndfinally();
            const args = operationArguments[operationIndex];
            if (opcode === 1 /* Statement */ ) return writeStatement(args[0]);
            const location = operationLocations[operationIndex];
            switch(opcode){
                case 2 /* Assign */ :
                    return writeAssign(args[0], args[1], location);
                case 3 /* Break */ :
                    return writeBreak(args[0], location);
                case 4 /* BreakWhenTrue */ :
                    return writeBreakWhenTrue(args[0], args[1], location);
                case 5 /* BreakWhenFalse */ :
                    return writeBreakWhenFalse(args[0], args[1], location);
                case 6 /* Yield */ :
                    return writeYield(args[0], location);
                case 7 /* YieldStar */ :
                    return writeYieldStar(args[0], location);
                case 8 /* Return */ :
                    return writeReturn(args[0], location);
                case 9 /* Throw */ :
                    return writeThrow(args[0], location);
            }
        }
        function writeStatement(statement) {
            if (statement) {
                if (!statements) statements = [
                    statement
                ];
                else statements.push(statement);
            }
        }
        function writeAssign(left, right, operationLocation) {
            writeStatement(setTextRange(factory2.createExpressionStatement(factory2.createAssignment(left, right)), operationLocation));
        }
        function writeThrow(expression, operationLocation) {
            lastOperationWasAbrupt = true;
            lastOperationWasCompletion = true;
            writeStatement(setTextRange(factory2.createThrowStatement(expression), operationLocation));
        }
        function writeReturn(expression, operationLocation) {
            lastOperationWasAbrupt = true;
            lastOperationWasCompletion = true;
            writeStatement(setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression(expression ? [
                createInstruction(2 /* Return */ ),
                expression
            ] : [
                createInstruction(2 /* Return */ )
            ])), operationLocation), 768 /* NoTokenSourceMaps */ ));
        }
        function writeBreak(label, operationLocation) {
            lastOperationWasAbrupt = true;
            writeStatement(setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(3 /* Break */ ),
                createLabel(label)
            ])), operationLocation), 768 /* NoTokenSourceMaps */ ));
        }
        function writeBreakWhenTrue(label, condition, operationLocation) {
            writeStatement(setEmitFlags(factory2.createIfStatement(condition, setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(3 /* Break */ ),
                createLabel(label)
            ])), operationLocation), 768 /* NoTokenSourceMaps */ )), 1 /* SingleLine */ ));
        }
        function writeBreakWhenFalse(label, condition, operationLocation) {
            writeStatement(setEmitFlags(factory2.createIfStatement(factory2.createLogicalNot(condition), setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(3 /* Break */ ),
                createLabel(label)
            ])), operationLocation), 768 /* NoTokenSourceMaps */ )), 1 /* SingleLine */ ));
        }
        function writeYield(expression, operationLocation) {
            lastOperationWasAbrupt = true;
            writeStatement(setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression(expression ? [
                createInstruction(4 /* Yield */ ),
                expression
            ] : [
                createInstruction(4 /* Yield */ )
            ])), operationLocation), 768 /* NoTokenSourceMaps */ ));
        }
        function writeYieldStar(expression, operationLocation) {
            lastOperationWasAbrupt = true;
            writeStatement(setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(5 /* YieldStar */ ),
                expression
            ])), operationLocation), 768 /* NoTokenSourceMaps */ ));
        }
        function writeEndfinally() {
            lastOperationWasAbrupt = true;
            writeStatement(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(7 /* Endfinally */ )
            ])));
        }
    }
    var init_generators = __esm({
        "src/compiler/transformers/generators.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/module/module.ts
    function transformModule(context) {
        function getTransformModuleDelegate(moduleKind2) {
            switch(moduleKind2){
                case 2 /* AMD */ :
                    return transformAMDModule;
                case 3 /* UMD */ :
                    return transformUMDModule;
                default:
                    return transformCommonJSModule;
            }
        }
        const { factory: factory2 , getEmitHelperFactory: emitHelpers , startLexicalEnvironment: startLexicalEnvironment , endLexicalEnvironment: endLexicalEnvironment , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        const compilerOptions = context.getCompilerOptions();
        const resolver = context.getEmitResolver();
        const host = context.getEmitHost();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const moduleKind = getEmitModuleKind(compilerOptions);
        const previousOnSubstituteNode = context.onSubstituteNode;
        const previousOnEmitNode = context.onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.enableSubstitution(212 /* CallExpression */ );
        context.enableSubstitution(214 /* TaggedTemplateExpression */ );
        context.enableSubstitution(80 /* Identifier */ );
        context.enableSubstitution(225 /* BinaryExpression */ );
        context.enableSubstitution(303 /* ShorthandPropertyAssignment */ );
        context.enableEmitNotification(311 /* SourceFile */ );
        const moduleInfoMap = [];
        let currentSourceFile;
        let currentModuleInfo;
        const noSubstitution = [];
        let needUMDDynamicImportHelper;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile || !(isEffectiveExternalModule(node, compilerOptions) || node.transformFlags & 8388608 /* ContainsDynamicImport */  || isJsonSourceFile(node) && hasJsonModuleEmitEnabled(compilerOptions) && outFile(compilerOptions))) return node;
            currentSourceFile = node;
            currentModuleInfo = collectExternalModuleInfo(context, node, resolver, compilerOptions);
            moduleInfoMap[getOriginalNodeId(node)] = currentModuleInfo;
            const transformModule2 = getTransformModuleDelegate(moduleKind);
            const updated = transformModule2(node);
            currentSourceFile = void 0;
            currentModuleInfo = void 0;
            needUMDDynamicImportHelper = false;
            return updated;
        }
        function shouldEmitUnderscoreUnderscoreESModule() {
            if (!currentModuleInfo.exportEquals && isExternalModule(currentSourceFile)) return true;
            return false;
        }
        function transformCommonJSModule(node) {
            startLexicalEnvironment();
            const statements = [];
            const ensureUseStrict = getStrictOptionValue(compilerOptions, "alwaysStrict") || !compilerOptions.noImplicitUseStrict && isExternalModule(currentSourceFile);
            const statementOffset = factory2.copyPrologue(node.statements, statements, ensureUseStrict && !isJsonSourceFile(node), topLevelVisitor);
            if (shouldEmitUnderscoreUnderscoreESModule()) append(statements, createUnderscoreUnderscoreESModule());
            if (length(currentModuleInfo.exportedNames)) {
                const chunkSize = 50;
                for(let i = 0; i < currentModuleInfo.exportedNames.length; i += chunkSize)append(statements, factory2.createExpressionStatement(reduceLeft(currentModuleInfo.exportedNames.slice(i, i + chunkSize), (prev, nextId)=>factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), factory2.createIdentifier(idText(nextId))), prev), factory2.createVoidZero())));
            }
            append(statements, visitNode(currentModuleInfo.externalHelpersImportDeclaration, topLevelVisitor, isStatement));
            addRange(statements, visitNodes2(node.statements, topLevelVisitor, isStatement, statementOffset));
            addExportEqualsIfNeeded(statements, /*emitAsReturn*/ false);
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            const updated = factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray(statements), node.statements));
            addEmitHelpers(updated, context.readEmitHelpers());
            return updated;
        }
        function transformAMDModule(node) {
            const define = factory2.createIdentifier("define");
            const moduleName = tryGetModuleNameFromFile(factory2, node, host, compilerOptions);
            const jsonSourceFile = isJsonSourceFile(node) && node;
            const { aliasedModuleNames: aliasedModuleNames , unaliasedModuleNames: unaliasedModuleNames , importAliasNames: importAliasNames  } = collectAsynchronousDependencies(node, /*includeNonAmdDependencies*/ true);
            const updated = factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray([
                factory2.createExpressionStatement(factory2.createCallExpression(define, /*typeArguments*/ void 0, [
                    // Add the module name (if provided).
                    ...moduleName ? [
                        moduleName
                    ] : [],
                    // Add the dependency array argument:
                    //
                    //     ["require", "exports", module1", "module2", ...]
                    factory2.createArrayLiteralExpression(jsonSourceFile ? emptyArray : [
                        factory2.createStringLiteral("require"),
                        factory2.createStringLiteral("exports"),
                        ...aliasedModuleNames,
                        ...unaliasedModuleNames
                    ]),
                    // Add the module body function argument:
                    //
                    //     function (require, exports, module1, module2) ...
                    jsonSourceFile ? jsonSourceFile.statements.length ? jsonSourceFile.statements[0].expression : factory2.createObjectLiteralExpression() : factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                        factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "require"),
                        factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "exports"),
                        ...importAliasNames
                    ], /*type*/ void 0, transformAsynchronousModuleBody(node))
                ]))
            ]), /*location*/ node.statements));
            addEmitHelpers(updated, context.readEmitHelpers());
            return updated;
        }
        function transformUMDModule(node) {
            const { aliasedModuleNames: aliasedModuleNames , unaliasedModuleNames: unaliasedModuleNames , importAliasNames: importAliasNames  } = collectAsynchronousDependencies(node, /*includeNonAmdDependencies*/ false);
            const moduleName = tryGetModuleNameFromFile(factory2, node, host, compilerOptions);
            const umdHeader = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "factory")
            ], /*type*/ void 0, setTextRange(factory2.createBlock([
                factory2.createIfStatement(factory2.createLogicalAnd(factory2.createTypeCheck(factory2.createIdentifier("module"), "object"), factory2.createTypeCheck(factory2.createPropertyAccessExpression(factory2.createIdentifier("module"), "exports"), "object")), factory2.createBlock([
                    factory2.createVariableStatement(/*modifiers*/ void 0, [
                        factory2.createVariableDeclaration("v", /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createCallExpression(factory2.createIdentifier("factory"), /*typeArguments*/ void 0, [
                            factory2.createIdentifier("require"),
                            factory2.createIdentifier("exports")
                        ]))
                    ]),
                    setEmitFlags(factory2.createIfStatement(factory2.createStrictInequality(factory2.createIdentifier("v"), factory2.createIdentifier("undefined")), factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createIdentifier("module"), "exports"), factory2.createIdentifier("v")))), 1 /* SingleLine */ )
                ]), factory2.createIfStatement(factory2.createLogicalAnd(factory2.createTypeCheck(factory2.createIdentifier("define"), "function"), factory2.createPropertyAccessExpression(factory2.createIdentifier("define"), "amd")), factory2.createBlock([
                    factory2.createExpressionStatement(factory2.createCallExpression(factory2.createIdentifier("define"), /*typeArguments*/ void 0, [
                        // Add the module name (if provided).
                        ...moduleName ? [
                            moduleName
                        ] : [],
                        factory2.createArrayLiteralExpression([
                            factory2.createStringLiteral("require"),
                            factory2.createStringLiteral("exports"),
                            ...aliasedModuleNames,
                            ...unaliasedModuleNames
                        ]),
                        factory2.createIdentifier("factory")
                    ]))
                ])))
            ], /*multiLine*/ true), /*location*/ void 0));
            const updated = factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray([
                factory2.createExpressionStatement(factory2.createCallExpression(umdHeader, /*typeArguments*/ void 0, [
                    // Add the module body function argument:
                    //
                    //     function (require, exports) ...
                    factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                        factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "require"),
                        factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "exports"),
                        ...importAliasNames
                    ], /*type*/ void 0, transformAsynchronousModuleBody(node))
                ]))
            ]), /*location*/ node.statements));
            addEmitHelpers(updated, context.readEmitHelpers());
            return updated;
        }
        function collectAsynchronousDependencies(node, includeNonAmdDependencies) {
            const aliasedModuleNames = [];
            const unaliasedModuleNames = [];
            const importAliasNames = [];
            for (const amdDependency of node.amdDependencies)if (amdDependency.name) {
                aliasedModuleNames.push(factory2.createStringLiteral(amdDependency.path));
                importAliasNames.push(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, amdDependency.name));
            } else unaliasedModuleNames.push(factory2.createStringLiteral(amdDependency.path));
            for (const importNode of currentModuleInfo.externalImports){
                const externalModuleName = getExternalModuleNameLiteral(factory2, importNode, currentSourceFile, host, resolver, compilerOptions);
                const importAliasName = getLocalNameForExternalImport(factory2, importNode, currentSourceFile);
                if (externalModuleName) {
                    if (includeNonAmdDependencies && importAliasName) {
                        setEmitFlags(importAliasName, 8 /* NoSubstitution */ );
                        aliasedModuleNames.push(externalModuleName);
                        importAliasNames.push(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, importAliasName));
                    } else unaliasedModuleNames.push(externalModuleName);
                }
            }
            return {
                aliasedModuleNames: aliasedModuleNames,
                unaliasedModuleNames: unaliasedModuleNames,
                importAliasNames: importAliasNames
            };
        }
        function getAMDImportExpressionForImport(node) {
            if (isImportEqualsDeclaration(node) || isExportDeclaration(node) || !getExternalModuleNameLiteral(factory2, node, currentSourceFile, host, resolver, compilerOptions)) return void 0;
            const name = getLocalNameForExternalImport(factory2, node, currentSourceFile);
            const expr = getHelperExpressionForImport(node, name);
            if (expr === name) return void 0;
            return factory2.createExpressionStatement(factory2.createAssignment(name, expr));
        }
        function transformAsynchronousModuleBody(node) {
            startLexicalEnvironment();
            const statements = [];
            const statementOffset = factory2.copyPrologue(node.statements, statements, /*ensureUseStrict*/ !compilerOptions.noImplicitUseStrict, topLevelVisitor);
            if (shouldEmitUnderscoreUnderscoreESModule()) append(statements, createUnderscoreUnderscoreESModule());
            if (length(currentModuleInfo.exportedNames)) append(statements, factory2.createExpressionStatement(reduceLeft(currentModuleInfo.exportedNames, (prev, nextId)=>factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), factory2.createIdentifier(idText(nextId))), prev), factory2.createVoidZero())));
            append(statements, visitNode(currentModuleInfo.externalHelpersImportDeclaration, topLevelVisitor, isStatement));
            if (moduleKind === 2 /* AMD */ ) addRange(statements, mapDefined(currentModuleInfo.externalImports, getAMDImportExpressionForImport));
            addRange(statements, visitNodes2(node.statements, topLevelVisitor, isStatement, statementOffset));
            addExportEqualsIfNeeded(statements, /*emitAsReturn*/ true);
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            const body = factory2.createBlock(statements, /*multiLine*/ true);
            if (needUMDDynamicImportHelper) addEmitHelper(body, dynamicImportUMDHelper);
            return body;
        }
        function addExportEqualsIfNeeded(statements, emitAsReturn) {
            if (currentModuleInfo.exportEquals) {
                const expressionResult = visitNode(currentModuleInfo.exportEquals.expression, visitor, isExpression);
                if (expressionResult) {
                    if (emitAsReturn) {
                        const statement = factory2.createReturnStatement(expressionResult);
                        setTextRange(statement, currentModuleInfo.exportEquals);
                        setEmitFlags(statement, 3840 /* NoComments */ );
                        statements.push(statement);
                    } else {
                        const statement = factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createIdentifier("module"), "exports"), expressionResult));
                        setTextRange(statement, currentModuleInfo.exportEquals);
                        setEmitFlags(statement, 3072 /* NoComments */ );
                        statements.push(statement);
                    }
                }
            }
        }
        function topLevelVisitor(node) {
            switch(node.kind){
                case 271 /* ImportDeclaration */ :
                    return visitImportDeclaration(node);
                case 270 /* ImportEqualsDeclaration */ :
                    return visitImportEqualsDeclaration(node);
                case 277 /* ExportDeclaration */ :
                    return visitExportDeclaration(node);
                case 276 /* ExportAssignment */ :
                    return visitExportAssignment(node);
                case 261 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 262 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                default:
                    return topLevelNestedVisitor(node);
            }
        }
        function topLevelNestedVisitor(node) {
            switch(node.kind){
                case 242 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 261 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 262 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 247 /* ForStatement */ :
                    return visitForStatement(node, /*isTopLevel*/ true);
                case 248 /* ForInStatement */ :
                    return visitForInStatement(node);
                case 249 /* ForOfStatement */ :
                    return visitForOfStatement(node);
                case 245 /* DoStatement */ :
                    return visitDoStatement(node);
                case 246 /* WhileStatement */ :
                    return visitWhileStatement(node);
                case 255 /* LabeledStatement */ :
                    return visitLabeledStatement(node);
                case 253 /* WithStatement */ :
                    return visitWithStatement(node);
                case 244 /* IfStatement */ :
                    return visitIfStatement(node);
                case 254 /* SwitchStatement */ :
                    return visitSwitchStatement(node);
                case 268 /* CaseBlock */ :
                    return visitCaseBlock(node);
                case 295 /* CaseClause */ :
                    return visitCaseClause(node);
                case 296 /* DefaultClause */ :
                    return visitDefaultClause(node);
                case 257 /* TryStatement */ :
                    return visitTryStatement(node);
                case 298 /* CatchClause */ :
                    return visitCatchClause(node);
                case 240 /* Block */ :
                    return visitBlock(node);
                default:
                    return visitor(node);
            }
        }
        function visitorWorker(node, valueIsDiscarded) {
            if (!(node.transformFlags & 276828160 /* ContainsUpdateExpressionForIdentifier */ )) return node;
            switch(node.kind){
                case 247 /* ForStatement */ :
                    return visitForStatement(node, /*isTopLevel*/ false);
                case 243 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 216 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, valueIsDiscarded);
                case 359 /* PartiallyEmittedExpression */ :
                    return visitPartiallyEmittedExpression(node, valueIsDiscarded);
                case 212 /* CallExpression */ :
                    if (isImportCall(node) && currentSourceFile.impliedNodeFormat === void 0) return visitImportCallExpression(node);
                    break;
                case 225 /* BinaryExpression */ :
                    if (isDestructuringAssignment(node)) return visitDestructuringAssignment(node, valueIsDiscarded);
                    break;
                case 223 /* PrefixUnaryExpression */ :
                case 224 /* PostfixUnaryExpression */ :
                    return visitPreOrPostfixUnaryExpression(node, valueIsDiscarded);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            return visitorWorker(node, /*valueIsDiscarded*/ false);
        }
        function discardedValueVisitor(node) {
            return visitorWorker(node, /*valueIsDiscarded*/ true);
        }
        function destructuringNeedsFlattening(node) {
            if (isObjectLiteralExpression(node)) for (const elem of node.properties)switch(elem.kind){
                case 302 /* PropertyAssignment */ :
                    if (destructuringNeedsFlattening(elem.initializer)) return true;
                    break;
                case 303 /* ShorthandPropertyAssignment */ :
                    if (destructuringNeedsFlattening(elem.name)) return true;
                    break;
                case 304 /* SpreadAssignment */ :
                    if (destructuringNeedsFlattening(elem.expression)) return true;
                    break;
                case 173 /* MethodDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    return false;
                default:
                    Debug.assertNever(elem, "Unhandled object member kind");
            }
            else if (isArrayLiteralExpression(node)) for (const elem of node.elements){
                if (isSpreadElement(elem)) {
                    if (destructuringNeedsFlattening(elem.expression)) return true;
                } else if (destructuringNeedsFlattening(elem)) return true;
            }
            else if (isIdentifier(node)) return length(getExports(node)) > (isExportName(node) ? 1 : 0);
            return false;
        }
        function visitDestructuringAssignment(node, valueIsDiscarded) {
            if (destructuringNeedsFlattening(node.left)) return flattenDestructuringAssignment(node, visitor, context, 0 /* All */ , !valueIsDiscarded, createAllExportExpressions);
            return visitEachChild(node, visitor, context);
        }
        function visitForStatement(node, isTopLevel) {
            if (isTopLevel && node.initializer && isVariableDeclarationList(node.initializer) && !(node.initializer.flags & 3 /* BlockScoped */ )) {
                const exportStatements = appendExportsOfVariableDeclarationList(/*statements*/ void 0, node.initializer, /*isForInOrOfInitializer*/ false);
                if (exportStatements) {
                    const statements = [];
                    const varDeclList = visitNode(node.initializer, discardedValueVisitor, isVariableDeclarationList);
                    const varStatement = factory2.createVariableStatement(/*modifiers*/ void 0, varDeclList);
                    statements.push(varStatement);
                    addRange(statements, exportStatements);
                    const condition = visitNode(node.condition, visitor, isExpression);
                    const incrementor = visitNode(node.incrementor, discardedValueVisitor, isExpression);
                    const body = visitIterationBody(node.statement, isTopLevel ? topLevelNestedVisitor : visitor, context);
                    statements.push(factory2.updateForStatement(node, /*initializer*/ void 0, condition, incrementor, body));
                    return statements;
                }
            }
            return factory2.updateForStatement(node, visitNode(node.initializer, discardedValueVisitor, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, discardedValueVisitor, isExpression), visitIterationBody(node.statement, isTopLevel ? topLevelNestedVisitor : visitor, context));
        }
        function visitForInStatement(node) {
            if (isVariableDeclarationList(node.initializer) && !(node.initializer.flags & 3 /* BlockScoped */ )) {
                const exportStatements = appendExportsOfVariableDeclarationList(/*statements*/ void 0, node.initializer, /*isForInOrOfInitializer*/ true);
                if (some(exportStatements)) {
                    const initializer = visitNode(node.initializer, discardedValueVisitor, isForInitializer);
                    const expression = visitNode(node.expression, visitor, isExpression);
                    const body = visitIterationBody(node.statement, topLevelNestedVisitor, context);
                    const mergedBody = isBlock(body) ? factory2.updateBlock(body, [
                        ...exportStatements,
                        ...body.statements
                    ]) : factory2.createBlock([
                        ...exportStatements,
                        body
                    ], /*multiLine*/ true);
                    return factory2.updateForInStatement(node, initializer, expression, mergedBody);
                }
            }
            return factory2.updateForInStatement(node, visitNode(node.initializer, discardedValueVisitor, isForInitializer), visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
        }
        function visitForOfStatement(node) {
            if (isVariableDeclarationList(node.initializer) && !(node.initializer.flags & 3 /* BlockScoped */ )) {
                const exportStatements = appendExportsOfVariableDeclarationList(/*statements*/ void 0, node.initializer, /*isForInOrOfInitializer*/ true);
                const initializer = visitNode(node.initializer, discardedValueVisitor, isForInitializer);
                const expression = visitNode(node.expression, visitor, isExpression);
                let body = visitIterationBody(node.statement, topLevelNestedVisitor, context);
                if (some(exportStatements)) body = isBlock(body) ? factory2.updateBlock(body, [
                    ...exportStatements,
                    ...body.statements
                ]) : factory2.createBlock([
                    ...exportStatements,
                    body
                ], /*multiLine*/ true);
                return factory2.updateForOfStatement(node, node.awaitModifier, initializer, expression, body);
            }
            return factory2.updateForOfStatement(node, node.awaitModifier, visitNode(node.initializer, discardedValueVisitor, isForInitializer), visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
        }
        function visitDoStatement(node) {
            return factory2.updateDoStatement(node, visitIterationBody(node.statement, topLevelNestedVisitor, context), visitNode(node.expression, visitor, isExpression));
        }
        function visitWhileStatement(node) {
            return factory2.updateWhileStatement(node, visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
        }
        function visitLabeledStatement(node) {
            return factory2.updateLabeledStatement(node, node.label, Debug.checkDefined(visitNode(node.statement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)));
        }
        function visitWithStatement(node) {
            return factory2.updateWithStatement(node, visitNode(node.expression, visitor, isExpression), Debug.checkDefined(visitNode(node.statement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)));
        }
        function visitIfStatement(node) {
            return factory2.updateIfStatement(node, visitNode(node.expression, visitor, isExpression), Debug.checkDefined(visitNode(node.thenStatement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)), visitNode(node.elseStatement, topLevelNestedVisitor, isStatement, factory2.liftToBlock));
        }
        function visitSwitchStatement(node) {
            return factory2.updateSwitchStatement(node, visitNode(node.expression, visitor, isExpression), Debug.checkDefined(visitNode(node.caseBlock, topLevelNestedVisitor, isCaseBlock)));
        }
        function visitCaseBlock(node) {
            return factory2.updateCaseBlock(node, visitNodes2(node.clauses, topLevelNestedVisitor, isCaseOrDefaultClause));
        }
        function visitCaseClause(node) {
            return factory2.updateCaseClause(node, visitNode(node.expression, visitor, isExpression), visitNodes2(node.statements, topLevelNestedVisitor, isStatement));
        }
        function visitDefaultClause(node) {
            return visitEachChild(node, topLevelNestedVisitor, context);
        }
        function visitTryStatement(node) {
            return visitEachChild(node, topLevelNestedVisitor, context);
        }
        function visitCatchClause(node) {
            return factory2.updateCatchClause(node, node.variableDeclaration, Debug.checkDefined(visitNode(node.block, topLevelNestedVisitor, isBlock)));
        }
        function visitBlock(node) {
            node = visitEachChild(node, topLevelNestedVisitor, context);
            return node;
        }
        function visitExpressionStatement(node) {
            return factory2.updateExpressionStatement(node, visitNode(node.expression, discardedValueVisitor, isExpression));
        }
        function visitParenthesizedExpression(node, valueIsDiscarded) {
            return factory2.updateParenthesizedExpression(node, visitNode(node.expression, valueIsDiscarded ? discardedValueVisitor : visitor, isExpression));
        }
        function visitPartiallyEmittedExpression(node, valueIsDiscarded) {
            return factory2.updatePartiallyEmittedExpression(node, visitNode(node.expression, valueIsDiscarded ? discardedValueVisitor : visitor, isExpression));
        }
        function visitPreOrPostfixUnaryExpression(node, valueIsDiscarded) {
            if ((node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) && isIdentifier(node.operand) && !isGeneratedIdentifier(node.operand) && !isLocalName(node.operand) && !isDeclarationNameOfEnumOrNamespace(node.operand)) {
                const exportedNames = getExports(node.operand);
                if (exportedNames) {
                    let temp;
                    let expression = visitNode(node.operand, visitor, isExpression);
                    if (isPrefixUnaryExpression(node)) expression = factory2.updatePrefixUnaryExpression(node, expression);
                    else {
                        expression = factory2.updatePostfixUnaryExpression(node, expression);
                        if (!valueIsDiscarded) {
                            temp = factory2.createTempVariable(hoistVariableDeclaration);
                            expression = factory2.createAssignment(temp, expression);
                            setTextRange(expression, node);
                        }
                        expression = factory2.createComma(expression, factory2.cloneNode(node.operand));
                        setTextRange(expression, node);
                    }
                    for (const exportName of exportedNames){
                        noSubstitution[getNodeId(expression)] = true;
                        expression = createExportExpression(exportName, expression);
                        setTextRange(expression, node);
                    }
                    if (temp) {
                        noSubstitution[getNodeId(expression)] = true;
                        expression = factory2.createComma(expression, temp);
                        setTextRange(expression, node);
                    }
                    return expression;
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitImportCallExpression(node) {
            if (moduleKind === 0 /* None */  && languageVersion >= 7 /* ES2020 */ ) return visitEachChild(node, visitor, context);
            const externalModuleName = getExternalModuleNameLiteral(factory2, node, currentSourceFile, host, resolver, compilerOptions);
            const firstArgument = visitNode(firstOrUndefined(node.arguments), visitor, isExpression);
            const argument = externalModuleName && (!firstArgument || !isStringLiteral(firstArgument) || firstArgument.text !== externalModuleName.text) ? externalModuleName : firstArgument;
            const containsLexicalThis = !!(node.transformFlags & 16384 /* ContainsLexicalThis */ );
            switch(compilerOptions.module){
                case 2 /* AMD */ :
                    return createImportCallExpressionAMD(argument, containsLexicalThis);
                case 3 /* UMD */ :
                    return createImportCallExpressionUMD(argument ?? factory2.createVoidZero(), containsLexicalThis);
                case 1 /* CommonJS */ :
                default:
                    return createImportCallExpressionCommonJS(argument);
            }
        }
        function createImportCallExpressionUMD(arg, containsLexicalThis) {
            needUMDDynamicImportHelper = true;
            if (isSimpleCopiableExpression(arg)) {
                const argClone = isGeneratedIdentifier(arg) ? arg : isStringLiteral(arg) ? factory2.createStringLiteralFromNode(arg) : setEmitFlags(setTextRange(factory2.cloneNode(arg), arg), 3072 /* NoComments */ );
                return factory2.createConditionalExpression(/*condition*/ factory2.createIdentifier("__syncRequire"), /*questionToken*/ void 0, /*whenTrue*/ createImportCallExpressionCommonJS(arg), /*colonToken*/ void 0, /*whenFalse*/ createImportCallExpressionAMD(argClone, containsLexicalThis));
            } else {
                const temp = factory2.createTempVariable(hoistVariableDeclaration);
                return factory2.createComma(factory2.createAssignment(temp, arg), factory2.createConditionalExpression(/*condition*/ factory2.createIdentifier("__syncRequire"), /*questionToken*/ void 0, /*whenTrue*/ createImportCallExpressionCommonJS(temp, /*isInlineable*/ true), /*colonToken*/ void 0, /*whenFalse*/ createImportCallExpressionAMD(temp, containsLexicalThis)));
            }
        }
        function createImportCallExpressionAMD(arg, containsLexicalThis) {
            const resolve = factory2.createUniqueName("resolve");
            const reject = factory2.createUniqueName("reject");
            const parameters = [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ resolve),
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ reject)
            ];
            const body = factory2.createBlock([
                factory2.createExpressionStatement(factory2.createCallExpression(factory2.createIdentifier("require"), /*typeArguments*/ void 0, [
                    factory2.createArrayLiteralExpression([
                        arg || factory2.createOmittedExpression()
                    ]),
                    resolve,
                    reject
                ]))
            ]);
            let func;
            if (languageVersion >= 2 /* ES2015 */ ) func = factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, parameters, /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, body);
            else {
                func = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body);
                if (containsLexicalThis) setEmitFlags(func, 16 /* CapturesThis */ );
            }
            const promise = factory2.createNewExpression(factory2.createIdentifier("Promise"), /*typeArguments*/ void 0, [
                func
            ]);
            if (getESModuleInterop(compilerOptions)) return factory2.createCallExpression(factory2.createPropertyAccessExpression(promise, factory2.createIdentifier("then")), /*typeArguments*/ void 0, [
                emitHelpers().createImportStarCallbackHelper()
            ]);
            return promise;
        }
        function createImportCallExpressionCommonJS(arg, isInlineable) {
            const needSyncEval = arg && !isSimpleInlineableExpression(arg) && !isInlineable;
            const promiseResolveCall = factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Promise"), "resolve"), /*typeArguments*/ void 0, /*argumentsArray*/ needSyncEval ? languageVersion >= 2 /* ES2015 */  ? [
                factory2.createTemplateExpression(factory2.createTemplateHead(""), [
                    factory2.createTemplateSpan(arg, factory2.createTemplateTail(""))
                ])
            ] : [
                factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createStringLiteral(""), "concat"), /*typeArguments*/ void 0, [
                    arg
                ])
            ] : []);
            let requireCall = factory2.createCallExpression(factory2.createIdentifier("require"), /*typeArguments*/ void 0, needSyncEval ? [
                factory2.createIdentifier("s")
            ] : arg ? [
                arg
            ] : []);
            if (getESModuleInterop(compilerOptions)) requireCall = emitHelpers().createImportStarHelper(requireCall);
            const parameters = needSyncEval ? [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ "s")
            ] : [];
            let func;
            if (languageVersion >= 2 /* ES2015 */ ) func = factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, /*parameters*/ parameters, /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, requireCall);
            else func = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, /*parameters*/ parameters, /*type*/ void 0, factory2.createBlock([
                factory2.createReturnStatement(requireCall)
            ]));
            const downleveledImport = factory2.createCallExpression(factory2.createPropertyAccessExpression(promiseResolveCall, "then"), /*typeArguments*/ void 0, [
                func
            ]);
            return downleveledImport;
        }
        function getHelperExpressionForExport(node, innerExpr) {
            if (!getESModuleInterop(compilerOptions) || getInternalEmitFlags(node) & 2 /* NeverApplyImportHelper */ ) return innerExpr;
            if (getExportNeedsImportStarHelper(node)) return emitHelpers().createImportStarHelper(innerExpr);
            return innerExpr;
        }
        function getHelperExpressionForImport(node, innerExpr) {
            if (!getESModuleInterop(compilerOptions) || getInternalEmitFlags(node) & 2 /* NeverApplyImportHelper */ ) return innerExpr;
            if (getImportNeedsImportStarHelper(node)) return emitHelpers().createImportStarHelper(innerExpr);
            if (getImportNeedsImportDefaultHelper(node)) return emitHelpers().createImportDefaultHelper(innerExpr);
            return innerExpr;
        }
        function visitImportDeclaration(node) {
            let statements;
            const namespaceDeclaration = getNamespaceDeclarationNode(node);
            if (moduleKind !== 2 /* AMD */ ) {
                if (!node.importClause) return setOriginalNode(setTextRange(factory2.createExpressionStatement(createRequireCall2(node)), node), node);
                else {
                    const variables = [];
                    if (namespaceDeclaration && !isDefaultImport(node)) variables.push(factory2.createVariableDeclaration(factory2.cloneNode(namespaceDeclaration.name), /*exclamationToken*/ void 0, /*type*/ void 0, getHelperExpressionForImport(node, createRequireCall2(node))));
                    else {
                        variables.push(factory2.createVariableDeclaration(factory2.getGeneratedNameForNode(node), /*exclamationToken*/ void 0, /*type*/ void 0, getHelperExpressionForImport(node, createRequireCall2(node))));
                        if (namespaceDeclaration && isDefaultImport(node)) variables.push(factory2.createVariableDeclaration(factory2.cloneNode(namespaceDeclaration.name), /*exclamationToken*/ void 0, /*type*/ void 0, factory2.getGeneratedNameForNode(node)));
                    }
                    statements = append(statements, setOriginalNode(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(variables, languageVersion >= 2 /* ES2015 */  ? 2 /* Const */  : 0 /* None */ )), /*location*/ node), /*original*/ node));
                }
            } else if (namespaceDeclaration && isDefaultImport(node)) statements = append(statements, factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                setOriginalNode(setTextRange(factory2.createVariableDeclaration(factory2.cloneNode(namespaceDeclaration.name), /*exclamationToken*/ void 0, /*type*/ void 0, factory2.getGeneratedNameForNode(node)), /*location*/ node), /*original*/ node)
            ], languageVersion >= 2 /* ES2015 */  ? 2 /* Const */  : 0 /* None */ )));
            statements = appendExportsOfImportDeclaration(statements, node);
            return singleOrMany(statements);
        }
        function createRequireCall2(importNode) {
            const moduleName = getExternalModuleNameLiteral(factory2, importNode, currentSourceFile, host, resolver, compilerOptions);
            const args = [];
            if (moduleName) args.push(moduleName);
            return factory2.createCallExpression(factory2.createIdentifier("require"), /*typeArguments*/ void 0, args);
        }
        function visitImportEqualsDeclaration(node) {
            Debug.assert(isExternalModuleImportEqualsDeclaration(node), "import= for internal module references should be handled in an earlier transformer.");
            let statements;
            if (moduleKind !== 2 /* AMD */ ) {
                if (hasSyntacticModifier(node, 1 /* Export */ )) statements = append(statements, setOriginalNode(setTextRange(factory2.createExpressionStatement(createExportExpression(node.name, createRequireCall2(node))), node), node));
                else statements = append(statements, setOriginalNode(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(factory2.cloneNode(node.name), /*exclamationToken*/ void 0, /*type*/ void 0, createRequireCall2(node))
                ], /*flags*/ languageVersion >= 2 /* ES2015 */  ? 2 /* Const */  : 0 /* None */ )), node), node));
            } else if (hasSyntacticModifier(node, 1 /* Export */ )) statements = append(statements, setOriginalNode(setTextRange(factory2.createExpressionStatement(createExportExpression(factory2.getExportName(node), factory2.getLocalName(node))), node), node));
            statements = appendExportsOfImportEqualsDeclaration(statements, node);
            return singleOrMany(statements);
        }
        function visitExportDeclaration(node) {
            if (!node.moduleSpecifier) return void 0;
            const generatedName = factory2.getGeneratedNameForNode(node);
            if (node.exportClause && isNamedExports(node.exportClause)) {
                const statements = [];
                if (moduleKind !== 2 /* AMD */ ) statements.push(setOriginalNode(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(generatedName, /*exclamationToken*/ void 0, /*type*/ void 0, createRequireCall2(node))
                ])), /*location*/ node), /* original */ node));
                for (const specifier of node.exportClause.elements)if (languageVersion === 0 /* ES3 */ ) statements.push(setOriginalNode(setTextRange(factory2.createExpressionStatement(emitHelpers().createCreateBindingHelper(generatedName, factory2.createStringLiteralFromNode(specifier.propertyName || specifier.name), specifier.propertyName ? factory2.createStringLiteralFromNode(specifier.name) : void 0)), specifier), specifier));
                else {
                    const exportNeedsImportDefault = !!getESModuleInterop(compilerOptions) && !(getInternalEmitFlags(node) & 2 /* NeverApplyImportHelper */ ) && idText(specifier.propertyName || specifier.name) === "default";
                    const exportedValue = factory2.createPropertyAccessExpression(exportNeedsImportDefault ? emitHelpers().createImportDefaultHelper(generatedName) : generatedName, specifier.propertyName || specifier.name);
                    statements.push(setOriginalNode(setTextRange(factory2.createExpressionStatement(createExportExpression(factory2.getExportName(specifier), exportedValue, /*location*/ void 0, /*liveBinding*/ true)), specifier), specifier));
                }
                return singleOrMany(statements);
            } else if (node.exportClause) {
                const statements = [];
                statements.push(setOriginalNode(setTextRange(factory2.createExpressionStatement(createExportExpression(factory2.cloneNode(node.exportClause.name), getHelperExpressionForExport(node, moduleKind !== 2 /* AMD */  ? createRequireCall2(node) : isExportNamespaceAsDefaultDeclaration(node) ? generatedName : factory2.createIdentifier(idText(node.exportClause.name))))), node), node));
                return singleOrMany(statements);
            } else return setOriginalNode(setTextRange(factory2.createExpressionStatement(emitHelpers().createExportStarHelper(moduleKind !== 2 /* AMD */  ? createRequireCall2(node) : generatedName)), node), node);
        }
        function visitExportAssignment(node) {
            if (node.isExportEquals) return void 0;
            return createExportStatement(factory2.createIdentifier("default"), visitNode(node.expression, visitor, isExpression), /*location*/ node, /*allowComments*/ true);
        }
        function visitFunctionDeclaration(node) {
            let statements;
            if (hasSyntacticModifier(node, 1 /* Export */ )) statements = append(statements, setOriginalNode(setTextRange(factory2.createFunctionDeclaration(visitNodes2(node.modifiers, modifierVisitor, isModifier), node.asteriskToken, factory2.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), /*typeParameters*/ void 0, visitNodes2(node.parameters, visitor, isParameter), /*type*/ void 0, visitEachChild(node.body, visitor, context)), /*location*/ node), /*original*/ node));
            else statements = append(statements, visitEachChild(node, visitor, context));
            statements = appendExportsOfHoistedDeclaration(statements, node);
            return singleOrMany(statements);
        }
        function visitClassDeclaration(node) {
            let statements;
            if (hasSyntacticModifier(node, 1 /* Export */ )) statements = append(statements, setOriginalNode(setTextRange(factory2.createClassDeclaration(visitNodes2(node.modifiers, modifierVisitor, isModifierLike), factory2.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), visitNodes2(node.members, visitor, isClassElement)), node), node));
            else statements = append(statements, visitEachChild(node, visitor, context));
            statements = appendExportsOfHoistedDeclaration(statements, node);
            return singleOrMany(statements);
        }
        function visitVariableStatement(node) {
            let statements;
            let variables;
            let expressions;
            if (hasSyntacticModifier(node, 1 /* Export */ )) {
                let modifiers;
                let removeCommentsOnExpressions = false;
                for (const variable of node.declarationList.declarations){
                    if (isIdentifier(variable.name) && isLocalName(variable.name)) {
                        if (!modifiers) modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
                        if (variable.initializer) {
                            const updatedVariable = factory2.updateVariableDeclaration(variable, variable.name, /*exclamationToken*/ void 0, /*type*/ void 0, createExportExpression(variable.name, visitNode(variable.initializer, visitor, isExpression)));
                            variables = append(variables, updatedVariable);
                        } else variables = append(variables, variable);
                    } else if (variable.initializer) {
                        if (!isBindingPattern(variable.name) && (isArrowFunction(variable.initializer) || isFunctionExpression(variable.initializer) || isClassExpression(variable.initializer))) {
                            const expression = factory2.createAssignment(setTextRange(factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), variable.name), /*location*/ variable.name), factory2.createIdentifier(getTextOfIdentifierOrLiteral(variable.name)));
                            const updatedVariable = factory2.createVariableDeclaration(variable.name, variable.exclamationToken, variable.type, visitNode(variable.initializer, visitor, isExpression));
                            variables = append(variables, updatedVariable);
                            expressions = append(expressions, expression);
                            removeCommentsOnExpressions = true;
                        } else expressions = append(expressions, transformInitializedVariable(variable));
                    }
                }
                if (variables) statements = append(statements, factory2.updateVariableStatement(node, modifiers, factory2.updateVariableDeclarationList(node.declarationList, variables)));
                if (expressions) {
                    const statement = setOriginalNode(setTextRange(factory2.createExpressionStatement(factory2.inlineExpressions(expressions)), node), node);
                    if (removeCommentsOnExpressions) removeAllComments(statement);
                    statements = append(statements, statement);
                }
            } else statements = append(statements, visitEachChild(node, visitor, context));
            statements = appendExportsOfVariableStatement(statements, node);
            return singleOrMany(statements);
        }
        function createAllExportExpressions(name, value1, location) {
            const exportedNames = getExports(name);
            if (exportedNames) {
                let expression = isExportName(name) ? value1 : factory2.createAssignment(name, value1);
                for (const exportName of exportedNames){
                    setEmitFlags(expression, 8 /* NoSubstitution */ );
                    expression = createExportExpression(exportName, expression, /*location*/ location);
                }
                return expression;
            }
            return factory2.createAssignment(name, value1);
        }
        function transformInitializedVariable(node) {
            if (isBindingPattern(node.name)) return flattenDestructuringAssignment(visitNode(node, visitor, isInitializedVariable), visitor, context, 0 /* All */ , /*needsValue*/ false, createAllExportExpressions);
            else return factory2.createAssignment(setTextRange(factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), node.name), /*location*/ node.name), node.initializer ? visitNode(node.initializer, visitor, isExpression) : factory2.createVoidZero());
        }
        function appendExportsOfImportDeclaration(statements, decl) {
            if (currentModuleInfo.exportEquals) return statements;
            const importClause = decl.importClause;
            if (!importClause) return statements;
            if (importClause.name) statements = appendExportsOfDeclaration(statements, importClause);
            const namedBindings = importClause.namedBindings;
            if (namedBindings) switch(namedBindings.kind){
                case 273 /* NamespaceImport */ :
                    statements = appendExportsOfDeclaration(statements, namedBindings);
                    break;
                case 274 /* NamedImports */ :
                    for (const importBinding of namedBindings.elements)statements = appendExportsOfDeclaration(statements, importBinding, /*liveBinding*/ true);
                    break;
            }
            return statements;
        }
        function appendExportsOfImportEqualsDeclaration(statements, decl) {
            if (currentModuleInfo.exportEquals) return statements;
            return appendExportsOfDeclaration(statements, decl);
        }
        function appendExportsOfVariableStatement(statements, node) {
            return appendExportsOfVariableDeclarationList(statements, node.declarationList, /*isForInOrOfInitializer*/ false);
        }
        function appendExportsOfVariableDeclarationList(statements, node, isForInOrOfInitializer) {
            if (currentModuleInfo.exportEquals) return statements;
            for (const decl of node.declarations)statements = appendExportsOfBindingElement(statements, decl, isForInOrOfInitializer);
            return statements;
        }
        function appendExportsOfBindingElement(statements, decl, isForInOrOfInitializer) {
            if (currentModuleInfo.exportEquals) return statements;
            if (isBindingPattern(decl.name)) {
                for (const element of decl.name.elements)if (!isOmittedExpression(element)) statements = appendExportsOfBindingElement(statements, element, isForInOrOfInitializer);
            } else if (!isGeneratedIdentifier(decl.name) && (!isVariableDeclaration(decl) || decl.initializer || isForInOrOfInitializer)) statements = appendExportsOfDeclaration(statements, decl);
            return statements;
        }
        function appendExportsOfHoistedDeclaration(statements, decl) {
            if (currentModuleInfo.exportEquals) return statements;
            if (hasSyntacticModifier(decl, 1 /* Export */ )) {
                const exportName = hasSyntacticModifier(decl, 1024 /* Default */ ) ? factory2.createIdentifier("default") : factory2.getDeclarationName(decl);
                statements = appendExportStatement(statements, exportName, factory2.getLocalName(decl), /*location*/ decl);
            }
            if (decl.name) statements = appendExportsOfDeclaration(statements, decl);
            return statements;
        }
        function appendExportsOfDeclaration(statements, decl, liveBinding) {
            const name = factory2.getDeclarationName(decl);
            const exportSpecifiers = currentModuleInfo.exportSpecifiers.get(idText(name));
            if (exportSpecifiers) for (const exportSpecifier of exportSpecifiers)statements = appendExportStatement(statements, exportSpecifier.name, name, /*location*/ exportSpecifier.name, /*allowComments*/ void 0, liveBinding);
            return statements;
        }
        function appendExportStatement(statements, exportName, expression, location, allowComments, liveBinding) {
            statements = append(statements, createExportStatement(exportName, expression, location, allowComments, liveBinding));
            return statements;
        }
        function createUnderscoreUnderscoreESModule() {
            let statement;
            if (languageVersion === 0 /* ES3 */ ) statement = factory2.createExpressionStatement(createExportExpression(factory2.createIdentifier("__esModule"), factory2.createTrue()));
            else statement = factory2.createExpressionStatement(factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Object"), "defineProperty"), /*typeArguments*/ void 0, [
                factory2.createIdentifier("exports"),
                factory2.createStringLiteral("__esModule"),
                factory2.createObjectLiteralExpression([
                    factory2.createPropertyAssignment("value", factory2.createTrue())
                ])
            ]));
            setEmitFlags(statement, 2097152 /* CustomPrologue */ );
            return statement;
        }
        function createExportStatement(name, value1, location, allowComments, liveBinding) {
            const statement = setTextRange(factory2.createExpressionStatement(createExportExpression(name, value1, /*location*/ void 0, liveBinding)), location);
            startOnNewLine(statement);
            if (!allowComments) setEmitFlags(statement, 3072 /* NoComments */ );
            return statement;
        }
        function createExportExpression(name, value1, location, liveBinding) {
            return setTextRange(liveBinding && languageVersion !== 0 /* ES3 */  ? factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Object"), "defineProperty"), /*typeArguments*/ void 0, [
                factory2.createIdentifier("exports"),
                factory2.createStringLiteralFromNode(name),
                factory2.createObjectLiteralExpression([
                    factory2.createPropertyAssignment("enumerable", factory2.createTrue()),
                    factory2.createPropertyAssignment("get", factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, /*parameters*/ [], /*type*/ void 0, factory2.createBlock([
                        factory2.createReturnStatement(value1)
                    ])))
                ])
            ]) : factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), factory2.cloneNode(name)), value1), location);
        }
        function modifierVisitor(node) {
            switch(node.kind){
                case 95 /* ExportKeyword */ :
                case 90 /* DefaultKeyword */ :
                    return void 0;
            }
            return node;
        }
        function onEmitNode(hint, node, emitCallback) {
            if (node.kind === 311 /* SourceFile */ ) {
                currentSourceFile = node;
                currentModuleInfo = moduleInfoMap[getOriginalNodeId(currentSourceFile)];
                previousOnEmitNode(hint, node, emitCallback);
                currentSourceFile = void 0;
                currentModuleInfo = void 0;
            } else previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (node.id && noSubstitution[node.id]) return node;
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            else if (isShorthandPropertyAssignment(node)) return substituteShorthandPropertyAssignment(node);
            return node;
        }
        function substituteShorthandPropertyAssignment(node) {
            const name = node.name;
            const exportedOrImportedName = substituteExpressionIdentifier(name);
            if (exportedOrImportedName !== name) {
                if (node.objectAssignmentInitializer) {
                    const initializer = factory2.createAssignment(exportedOrImportedName, node.objectAssignmentInitializer);
                    return setTextRange(factory2.createPropertyAssignment(name, initializer), node);
                }
                return setTextRange(factory2.createPropertyAssignment(name, exportedOrImportedName), node);
            }
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
                case 212 /* CallExpression */ :
                    return substituteCallExpression(node);
                case 214 /* TaggedTemplateExpression */ :
                    return substituteTaggedTemplateExpression(node);
                case 225 /* BinaryExpression */ :
                    return substituteBinaryExpression(node);
            }
            return node;
        }
        function substituteCallExpression(node) {
            if (isIdentifier(node.expression)) {
                const expression = substituteExpressionIdentifier(node.expression);
                noSubstitution[getNodeId(expression)] = true;
                if (!isIdentifier(expression) && !(getEmitFlags(node.expression) & 8192 /* HelperName */ )) return addInternalEmitFlags(factory2.updateCallExpression(node, expression, /*typeArguments*/ void 0, node.arguments), 16 /* IndirectCall */ );
            }
            return node;
        }
        function substituteTaggedTemplateExpression(node) {
            if (isIdentifier(node.tag)) {
                const tag = substituteExpressionIdentifier(node.tag);
                noSubstitution[getNodeId(tag)] = true;
                if (!isIdentifier(tag) && !(getEmitFlags(node.tag) & 8192 /* HelperName */ )) return addInternalEmitFlags(factory2.updateTaggedTemplateExpression(node, tag, /*typeArguments*/ void 0, node.template), 16 /* IndirectCall */ );
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            var _a, _b;
            if (getEmitFlags(node) & 8192 /* HelperName */ ) {
                const externalHelpersModuleName = getExternalHelpersModuleName(currentSourceFile);
                if (externalHelpersModuleName) return factory2.createPropertyAccessExpression(externalHelpersModuleName, node);
                return node;
            } else if (!(isGeneratedIdentifier(node) && !(node.emitNode.autoGenerate.flags & 64 /* AllowNameSubstitution */ )) && !isLocalName(node)) {
                const exportContainer = resolver.getReferencedExportContainer(node, isExportName(node));
                if (exportContainer && exportContainer.kind === 311 /* SourceFile */ ) return setTextRange(factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), factory2.cloneNode(node)), /*location*/ node);
                const importDeclaration = resolver.getReferencedImportDeclaration(node);
                if (importDeclaration) {
                    if (isImportClause(importDeclaration)) return setTextRange(factory2.createPropertyAccessExpression(factory2.getGeneratedNameForNode(importDeclaration.parent), factory2.createIdentifier("default")), /*location*/ node);
                    else if (isImportSpecifier(importDeclaration)) {
                        const name = importDeclaration.propertyName || importDeclaration.name;
                        return setTextRange(factory2.createPropertyAccessExpression(factory2.getGeneratedNameForNode(((_b = (_a = importDeclaration.parent) == null ? void 0 : _a.parent) == null ? void 0 : _b.parent) || importDeclaration), factory2.cloneNode(name)), /*location*/ node);
                    }
                }
            }
            return node;
        }
        function substituteBinaryExpression(node) {
            if (isAssignmentOperator(node.operatorToken.kind) && isIdentifier(node.left) && !isGeneratedIdentifier(node.left) && !isLocalName(node.left)) {
                const exportedNames = getExports(node.left);
                if (exportedNames) {
                    let expression = node;
                    for (const exportName of exportedNames){
                        noSubstitution[getNodeId(expression)] = true;
                        expression = createExportExpression(exportName, expression, /*location*/ node);
                    }
                    return expression;
                }
            }
            return node;
        }
        function getExports(name) {
            if (!isGeneratedIdentifier(name)) {
                const importDeclaration = resolver.getReferencedImportDeclaration(name);
                if (importDeclaration) return currentModuleInfo == null ? void 0 : currentModuleInfo.exportedBindings[getOriginalNodeId(importDeclaration)];
                const bindingsSet = /* @__PURE__ */ new Set();
                const declarations = resolver.getReferencedValueDeclarations(name);
                if (declarations) {
                    for (const declaration of declarations){
                        const bindings = currentModuleInfo == null ? void 0 : currentModuleInfo.exportedBindings[getOriginalNodeId(declaration)];
                        if (bindings) for (const binding of bindings)bindingsSet.add(binding);
                    }
                    if (bindingsSet.size) return arrayFrom(bindingsSet);
                }
            }
        }
    }
    var dynamicImportUMDHelper;
    var init_module = __esm({
        "src/compiler/transformers/module/module.ts" () {
            "use strict";
            init_ts2();
            dynamicImportUMDHelper = {
                name: "typescript:dynamicimport-sync-require",
                scoped: true,
                text: `
            var __syncRequire = typeof module === "object" && typeof module.exports === "object";`
            };
        }
    });
    // src/compiler/transformers/module/system.ts
    function transformSystemModule(context) {
        const { factory: factory2 , startLexicalEnvironment: startLexicalEnvironment , endLexicalEnvironment: endLexicalEnvironment , hoistVariableDeclaration: hoistVariableDeclaration  } = context;
        const compilerOptions = context.getCompilerOptions();
        const resolver = context.getEmitResolver();
        const host = context.getEmitHost();
        const previousOnSubstituteNode = context.onSubstituteNode;
        const previousOnEmitNode = context.onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.enableSubstitution(80 /* Identifier */ );
        context.enableSubstitution(303 /* ShorthandPropertyAssignment */ );
        context.enableSubstitution(225 /* BinaryExpression */ );
        context.enableSubstitution(235 /* MetaProperty */ );
        context.enableEmitNotification(311 /* SourceFile */ );
        const moduleInfoMap = [];
        const exportFunctionsMap = [];
        const noSubstitutionMap = [];
        const contextObjectMap = [];
        let currentSourceFile;
        let moduleInfo;
        let exportFunction;
        let contextObject;
        let hoistedStatements;
        let enclosingBlockScopedContainer;
        let noSubstitution;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile || !(isEffectiveExternalModule(node, compilerOptions) || node.transformFlags & 8388608 /* ContainsDynamicImport */ )) return node;
            const id = getOriginalNodeId(node);
            currentSourceFile = node;
            enclosingBlockScopedContainer = node;
            moduleInfo = moduleInfoMap[id] = collectExternalModuleInfo(context, node, resolver, compilerOptions);
            exportFunction = factory2.createUniqueName("exports");
            exportFunctionsMap[id] = exportFunction;
            contextObject = contextObjectMap[id] = factory2.createUniqueName("context");
            const dependencyGroups = collectDependencyGroups(moduleInfo.externalImports);
            const moduleBodyBlock = createSystemModuleBody(node, dependencyGroups);
            const moduleBodyFunction = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, exportFunction),
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, contextObject)
            ], /*type*/ void 0, moduleBodyBlock);
            const moduleName = tryGetModuleNameFromFile(factory2, node, host, compilerOptions);
            const dependencies = factory2.createArrayLiteralExpression(map(dependencyGroups, (dependencyGroup)=>dependencyGroup.name));
            const updated = setEmitFlags(factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray([
                factory2.createExpressionStatement(factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("System"), "register"), /*typeArguments*/ void 0, moduleName ? [
                    moduleName,
                    dependencies,
                    moduleBodyFunction
                ] : [
                    dependencies,
                    moduleBodyFunction
                ]))
            ]), node.statements)), 2048 /* NoTrailingComments */ );
            if (!outFile(compilerOptions)) moveEmitHelpers(updated, moduleBodyBlock, (helper)=>!helper.scoped);
            if (noSubstitution) {
                noSubstitutionMap[id] = noSubstitution;
                noSubstitution = void 0;
            }
            currentSourceFile = void 0;
            moduleInfo = void 0;
            exportFunction = void 0;
            contextObject = void 0;
            hoistedStatements = void 0;
            enclosingBlockScopedContainer = void 0;
            return updated;
        }
        function collectDependencyGroups(externalImports) {
            const groupIndices = /* @__PURE__ */ new Map();
            const dependencyGroups = [];
            for (const externalImport of externalImports){
                const externalModuleName = getExternalModuleNameLiteral(factory2, externalImport, currentSourceFile, host, resolver, compilerOptions);
                if (externalModuleName) {
                    const text = externalModuleName.text;
                    const groupIndex = groupIndices.get(text);
                    if (groupIndex !== void 0) dependencyGroups[groupIndex].externalImports.push(externalImport);
                    else {
                        groupIndices.set(text, dependencyGroups.length);
                        dependencyGroups.push({
                            name: externalModuleName,
                            externalImports: [
                                externalImport
                            ]
                        });
                    }
                }
            }
            return dependencyGroups;
        }
        function createSystemModuleBody(node, dependencyGroups) {
            const statements = [];
            startLexicalEnvironment();
            const ensureUseStrict = getStrictOptionValue(compilerOptions, "alwaysStrict") || !compilerOptions.noImplicitUseStrict && isExternalModule(currentSourceFile);
            const statementOffset = factory2.copyPrologue(node.statements, statements, ensureUseStrict, topLevelVisitor);
            statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration("__moduleName", /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createLogicalAnd(contextObject, factory2.createPropertyAccessExpression(contextObject, "id")))
            ])));
            visitNode(moduleInfo.externalHelpersImportDeclaration, topLevelVisitor, isStatement);
            const executeStatements = visitNodes2(node.statements, topLevelVisitor, isStatement, statementOffset);
            addRange(statements, hoistedStatements);
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            const exportStarFunction = addExportStarIfNeeded(statements);
            const modifiers = node.transformFlags & 2097152 /* ContainsAwait */  ? factory2.createModifiersFromModifierFlags(512 /* Async */ ) : void 0;
            const moduleObject = factory2.createObjectLiteralExpression([
                factory2.createPropertyAssignment("setters", createSettersArray(exportStarFunction, dependencyGroups)),
                factory2.createPropertyAssignment("execute", factory2.createFunctionExpression(modifiers, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, /*parameters*/ [], /*type*/ void 0, factory2.createBlock(executeStatements, /*multiLine*/ true)))
            ], /*multiLine*/ true);
            statements.push(factory2.createReturnStatement(moduleObject));
            return factory2.createBlock(statements, /*multiLine*/ true);
        }
        function addExportStarIfNeeded(statements) {
            if (!moduleInfo.hasExportStarsToExportValues) return;
            if (!moduleInfo.exportedNames && moduleInfo.exportSpecifiers.size === 0) {
                let hasExportDeclarationWithExportClause = false;
                for (const externalImport of moduleInfo.externalImports)if (externalImport.kind === 277 /* ExportDeclaration */  && externalImport.exportClause) {
                    hasExportDeclarationWithExportClause = true;
                    break;
                }
                if (!hasExportDeclarationWithExportClause) {
                    const exportStarFunction2 = createExportStarFunction(/*localNames*/ void 0);
                    statements.push(exportStarFunction2);
                    return exportStarFunction2.name;
                }
            }
            const exportedNames = [];
            if (moduleInfo.exportedNames) for (const exportedLocalName of moduleInfo.exportedNames){
                if (exportedLocalName.escapedText === "default") continue;
                exportedNames.push(factory2.createPropertyAssignment(factory2.createStringLiteralFromNode(exportedLocalName), factory2.createTrue()));
            }
            const exportedNamesStorageRef = factory2.createUniqueName("exportedNames");
            statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(exportedNamesStorageRef, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createObjectLiteralExpression(exportedNames, /*multiLine*/ true))
            ])));
            const exportStarFunction = createExportStarFunction(exportedNamesStorageRef);
            statements.push(exportStarFunction);
            return exportStarFunction.name;
        }
        function createExportStarFunction(localNames) {
            const exportStarFunction = factory2.createUniqueName("exportStar");
            const m = factory2.createIdentifier("m");
            const n = factory2.createIdentifier("n");
            const exports = factory2.createIdentifier("exports");
            let condition = factory2.createStrictInequality(n, factory2.createStringLiteral("default"));
            if (localNames) condition = factory2.createLogicalAnd(condition, factory2.createLogicalNot(factory2.createCallExpression(factory2.createPropertyAccessExpression(localNames, "hasOwnProperty"), /*typeArguments*/ void 0, [
                n
            ])));
            return factory2.createFunctionDeclaration(/*modifiers*/ void 0, /*asteriskToken*/ void 0, exportStarFunction, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, m)
            ], /*type*/ void 0, factory2.createBlock([
                factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(exports, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createObjectLiteralExpression([]))
                ])),
                factory2.createForInStatement(factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(n)
                ]), m, factory2.createBlock([
                    setEmitFlags(factory2.createIfStatement(condition, factory2.createExpressionStatement(factory2.createAssignment(factory2.createElementAccessExpression(exports, n), factory2.createElementAccessExpression(m, n)))), 1 /* SingleLine */ )
                ])),
                factory2.createExpressionStatement(factory2.createCallExpression(exportFunction, /*typeArguments*/ void 0, [
                    exports
                ]))
            ], /*multiLine*/ true));
        }
        function createSettersArray(exportStarFunction, dependencyGroups) {
            const setters = [];
            for (const group2 of dependencyGroups){
                const localName = forEach(group2.externalImports, (i)=>getLocalNameForExternalImport(factory2, i, currentSourceFile));
                const parameterName = localName ? factory2.getGeneratedNameForNode(localName) : factory2.createUniqueName("");
                const statements = [];
                for (const entry of group2.externalImports){
                    const importVariableName = getLocalNameForExternalImport(factory2, entry, currentSourceFile);
                    switch(entry.kind){
                        case 271 /* ImportDeclaration */ :
                            if (!entry.importClause) break;
                        case 270 /* ImportEqualsDeclaration */ :
                            Debug.assert(importVariableName !== void 0);
                            statements.push(factory2.createExpressionStatement(factory2.createAssignment(importVariableName, parameterName)));
                            if (hasSyntacticModifier(entry, 1 /* Export */ )) statements.push(factory2.createExpressionStatement(factory2.createCallExpression(exportFunction, /*typeArguments*/ void 0, [
                                factory2.createStringLiteral(idText(importVariableName)),
                                parameterName
                            ])));
                            break;
                        case 277 /* ExportDeclaration */ :
                            Debug.assert(importVariableName !== void 0);
                            if (entry.exportClause) {
                                if (isNamedExports(entry.exportClause)) {
                                    const properties = [];
                                    for (const e of entry.exportClause.elements)properties.push(factory2.createPropertyAssignment(factory2.createStringLiteral(idText(e.name)), factory2.createElementAccessExpression(parameterName, factory2.createStringLiteral(idText(e.propertyName || e.name)))));
                                    statements.push(factory2.createExpressionStatement(factory2.createCallExpression(exportFunction, /*typeArguments*/ void 0, [
                                        factory2.createObjectLiteralExpression(properties, /*multiLine*/ true)
                                    ])));
                                } else statements.push(factory2.createExpressionStatement(factory2.createCallExpression(exportFunction, /*typeArguments*/ void 0, [
                                    factory2.createStringLiteral(idText(entry.exportClause.name)),
                                    parameterName
                                ])));
                            } else statements.push(factory2.createExpressionStatement(factory2.createCallExpression(exportStarFunction, /*typeArguments*/ void 0, [
                                parameterName
                            ])));
                            break;
                    }
                }
                setters.push(factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                    factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, parameterName)
                ], /*type*/ void 0, factory2.createBlock(statements, /*multiLine*/ true)));
            }
            return factory2.createArrayLiteralExpression(setters, /*multiLine*/ true);
        }
        function topLevelVisitor(node) {
            switch(node.kind){
                case 271 /* ImportDeclaration */ :
                    return visitImportDeclaration(node);
                case 270 /* ImportEqualsDeclaration */ :
                    return visitImportEqualsDeclaration(node);
                case 277 /* ExportDeclaration */ :
                    return visitExportDeclaration(node);
                case 276 /* ExportAssignment */ :
                    return visitExportAssignment(node);
                default:
                    return topLevelNestedVisitor(node);
            }
        }
        function visitImportDeclaration(node) {
            let statements;
            if (node.importClause) hoistVariableDeclaration(getLocalNameForExternalImport(factory2, node, currentSourceFile));
            return singleOrMany(appendExportsOfImportDeclaration(statements, node));
        }
        function visitExportDeclaration(node) {
            Debug.assertIsDefined(node);
            return void 0;
        }
        function visitImportEqualsDeclaration(node) {
            Debug.assert(isExternalModuleImportEqualsDeclaration(node), "import= for internal module references should be handled in an earlier transformer.");
            let statements;
            hoistVariableDeclaration(getLocalNameForExternalImport(factory2, node, currentSourceFile));
            return singleOrMany(appendExportsOfImportEqualsDeclaration(statements, node));
        }
        function visitExportAssignment(node) {
            if (node.isExportEquals) return void 0;
            const expression = visitNode(node.expression, visitor, isExpression);
            return createExportStatement(factory2.createIdentifier("default"), expression, /*allowComments*/ true);
        }
        function visitFunctionDeclaration(node) {
            if (hasSyntacticModifier(node, 1 /* Export */ )) hoistedStatements = append(hoistedStatements, factory2.updateFunctionDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifierLike), node.asteriskToken, factory2.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), /*typeParameters*/ void 0, visitNodes2(node.parameters, visitor, isParameter), /*type*/ void 0, visitNode(node.body, visitor, isBlock)));
            else hoistedStatements = append(hoistedStatements, visitEachChild(node, visitor, context));
            hoistedStatements = appendExportsOfHoistedDeclaration(hoistedStatements, node);
            return void 0;
        }
        function visitClassDeclaration(node) {
            let statements;
            const name = factory2.getLocalName(node);
            hoistVariableDeclaration(name);
            statements = append(statements, setTextRange(factory2.createExpressionStatement(factory2.createAssignment(name, setTextRange(factory2.createClassExpression(visitNodes2(node.modifiers, modifierVisitor, isModifierLike), node.name, /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), visitNodes2(node.members, visitor, isClassElement)), node))), node));
            statements = appendExportsOfHoistedDeclaration(statements, node);
            return singleOrMany(statements);
        }
        function visitVariableStatement(node) {
            if (!shouldHoistVariableDeclarationList(node.declarationList)) return visitNode(node, visitor, isStatement);
            let expressions;
            const isExportedDeclaration = hasSyntacticModifier(node, 1 /* Export */ );
            for (const variable of node.declarationList.declarations)if (variable.initializer) expressions = append(expressions, transformInitializedVariable(variable, isExportedDeclaration));
            else hoistBindingElement(variable);
            let statements;
            if (expressions) statements = append(statements, setTextRange(factory2.createExpressionStatement(factory2.inlineExpressions(expressions)), node));
            statements = appendExportsOfVariableStatement(statements, node, /*exportSelf*/ false);
            return singleOrMany(statements);
        }
        function hoistBindingElement(node) {
            if (isBindingPattern(node.name)) {
                for (const element of node.name.elements)if (!isOmittedExpression(element)) hoistBindingElement(element);
            } else hoistVariableDeclaration(factory2.cloneNode(node.name));
        }
        function shouldHoistVariableDeclarationList(node) {
            return (getEmitFlags(node) & 4194304 /* NoHoisting */ ) === 0 && (enclosingBlockScopedContainer.kind === 311 /* SourceFile */  || (getOriginalNode(node).flags & 3 /* BlockScoped */ ) === 0);
        }
        function transformInitializedVariable(node, isExportedDeclaration) {
            const createAssignment = isExportedDeclaration ? createExportedVariableAssignment : createNonExportedVariableAssignment;
            return isBindingPattern(node.name) ? flattenDestructuringAssignment(node, visitor, context, 0 /* All */ , /*needsValue*/ false, createAssignment) : node.initializer ? createAssignment(node.name, visitNode(node.initializer, visitor, isExpression)) : node.name;
        }
        function createExportedVariableAssignment(name, value1, location) {
            return createVariableAssignment(name, value1, location, /*isExportedDeclaration*/ true);
        }
        function createNonExportedVariableAssignment(name, value1, location) {
            return createVariableAssignment(name, value1, location, /*isExportedDeclaration*/ false);
        }
        function createVariableAssignment(name, value1, location, isExportedDeclaration) {
            hoistVariableDeclaration(factory2.cloneNode(name));
            return isExportedDeclaration ? createExportExpression(name, preventSubstitution(setTextRange(factory2.createAssignment(name, value1), location))) : preventSubstitution(setTextRange(factory2.createAssignment(name, value1), location));
        }
        function appendExportsOfImportDeclaration(statements, decl) {
            if (moduleInfo.exportEquals) return statements;
            const importClause = decl.importClause;
            if (!importClause) return statements;
            if (importClause.name) statements = appendExportsOfDeclaration(statements, importClause);
            const namedBindings = importClause.namedBindings;
            if (namedBindings) switch(namedBindings.kind){
                case 273 /* NamespaceImport */ :
                    statements = appendExportsOfDeclaration(statements, namedBindings);
                    break;
                case 274 /* NamedImports */ :
                    for (const importBinding of namedBindings.elements)statements = appendExportsOfDeclaration(statements, importBinding);
                    break;
            }
            return statements;
        }
        function appendExportsOfImportEqualsDeclaration(statements, decl) {
            if (moduleInfo.exportEquals) return statements;
            return appendExportsOfDeclaration(statements, decl);
        }
        function appendExportsOfVariableStatement(statements, node, exportSelf) {
            if (moduleInfo.exportEquals) return statements;
            for (const decl of node.declarationList.declarations)if (decl.initializer || exportSelf) statements = appendExportsOfBindingElement(statements, decl, exportSelf);
            return statements;
        }
        function appendExportsOfBindingElement(statements, decl, exportSelf) {
            if (moduleInfo.exportEquals) return statements;
            if (isBindingPattern(decl.name)) {
                for (const element of decl.name.elements)if (!isOmittedExpression(element)) statements = appendExportsOfBindingElement(statements, element, exportSelf);
            } else if (!isGeneratedIdentifier(decl.name)) {
                let excludeName;
                if (exportSelf) {
                    statements = appendExportStatement(statements, decl.name, factory2.getLocalName(decl));
                    excludeName = idText(decl.name);
                }
                statements = appendExportsOfDeclaration(statements, decl, excludeName);
            }
            return statements;
        }
        function appendExportsOfHoistedDeclaration(statements, decl) {
            if (moduleInfo.exportEquals) return statements;
            let excludeName;
            if (hasSyntacticModifier(decl, 1 /* Export */ )) {
                const exportName = hasSyntacticModifier(decl, 1024 /* Default */ ) ? factory2.createStringLiteral("default") : decl.name;
                statements = appendExportStatement(statements, exportName, factory2.getLocalName(decl));
                excludeName = getTextOfIdentifierOrLiteral(exportName);
            }
            if (decl.name) statements = appendExportsOfDeclaration(statements, decl, excludeName);
            return statements;
        }
        function appendExportsOfDeclaration(statements, decl, excludeName) {
            if (moduleInfo.exportEquals) return statements;
            const name = factory2.getDeclarationName(decl);
            const exportSpecifiers = moduleInfo.exportSpecifiers.get(idText(name));
            if (exportSpecifiers) {
                for (const exportSpecifier of exportSpecifiers)if (exportSpecifier.name.escapedText !== excludeName) statements = appendExportStatement(statements, exportSpecifier.name, name);
            }
            return statements;
        }
        function appendExportStatement(statements, exportName, expression, allowComments) {
            statements = append(statements, createExportStatement(exportName, expression, allowComments));
            return statements;
        }
        function createExportStatement(name, value1, allowComments) {
            const statement = factory2.createExpressionStatement(createExportExpression(name, value1));
            startOnNewLine(statement);
            if (!allowComments) setEmitFlags(statement, 3072 /* NoComments */ );
            return statement;
        }
        function createExportExpression(name, value1) {
            const exportName = isIdentifier(name) ? factory2.createStringLiteralFromNode(name) : name;
            setEmitFlags(value1, getEmitFlags(value1) | 3072 /* NoComments */ );
            return setCommentRange(factory2.createCallExpression(exportFunction, /*typeArguments*/ void 0, [
                exportName,
                value1
            ]), value1);
        }
        function topLevelNestedVisitor(node) {
            switch(node.kind){
                case 242 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 261 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 262 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 247 /* ForStatement */ :
                    return visitForStatement(node, /*isTopLevel*/ true);
                case 248 /* ForInStatement */ :
                    return visitForInStatement(node);
                case 249 /* ForOfStatement */ :
                    return visitForOfStatement(node);
                case 245 /* DoStatement */ :
                    return visitDoStatement(node);
                case 246 /* WhileStatement */ :
                    return visitWhileStatement(node);
                case 255 /* LabeledStatement */ :
                    return visitLabeledStatement(node);
                case 253 /* WithStatement */ :
                    return visitWithStatement(node);
                case 244 /* IfStatement */ :
                    return visitIfStatement(node);
                case 254 /* SwitchStatement */ :
                    return visitSwitchStatement(node);
                case 268 /* CaseBlock */ :
                    return visitCaseBlock(node);
                case 295 /* CaseClause */ :
                    return visitCaseClause(node);
                case 296 /* DefaultClause */ :
                    return visitDefaultClause(node);
                case 257 /* TryStatement */ :
                    return visitTryStatement(node);
                case 298 /* CatchClause */ :
                    return visitCatchClause(node);
                case 240 /* Block */ :
                    return visitBlock(node);
                default:
                    return visitor(node);
            }
        }
        function visitForStatement(node, isTopLevel) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = factory2.updateForStatement(node, visitNode(node.initializer, isTopLevel ? visitForInitializer : discardedValueVisitor, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, discardedValueVisitor, isExpression), visitIterationBody(node.statement, isTopLevel ? topLevelNestedVisitor : visitor, context));
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function visitForInStatement(node) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = factory2.updateForInStatement(node, visitForInitializer(node.initializer), visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function visitForOfStatement(node) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = factory2.updateForOfStatement(node, node.awaitModifier, visitForInitializer(node.initializer), visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function shouldHoistForInitializer(node) {
            return isVariableDeclarationList(node) && shouldHoistVariableDeclarationList(node);
        }
        function visitForInitializer(node) {
            if (shouldHoistForInitializer(node)) {
                let expressions;
                for (const variable of node.declarations){
                    expressions = append(expressions, transformInitializedVariable(variable, /*isExportedDeclaration*/ false));
                    if (!variable.initializer) hoistBindingElement(variable);
                }
                return expressions ? factory2.inlineExpressions(expressions) : factory2.createOmittedExpression();
            } else return visitNode(node, discardedValueVisitor, isForInitializer);
        }
        function visitDoStatement(node) {
            return factory2.updateDoStatement(node, visitIterationBody(node.statement, topLevelNestedVisitor, context), visitNode(node.expression, visitor, isExpression));
        }
        function visitWhileStatement(node) {
            return factory2.updateWhileStatement(node, visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
        }
        function visitLabeledStatement(node) {
            return factory2.updateLabeledStatement(node, node.label, Debug.checkDefined(visitNode(node.statement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)));
        }
        function visitWithStatement(node) {
            return factory2.updateWithStatement(node, visitNode(node.expression, visitor, isExpression), Debug.checkDefined(visitNode(node.statement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)));
        }
        function visitIfStatement(node) {
            return factory2.updateIfStatement(node, visitNode(node.expression, visitor, isExpression), Debug.checkDefined(visitNode(node.thenStatement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)), visitNode(node.elseStatement, topLevelNestedVisitor, isStatement, factory2.liftToBlock));
        }
        function visitSwitchStatement(node) {
            return factory2.updateSwitchStatement(node, visitNode(node.expression, visitor, isExpression), Debug.checkDefined(visitNode(node.caseBlock, topLevelNestedVisitor, isCaseBlock)));
        }
        function visitCaseBlock(node) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = factory2.updateCaseBlock(node, visitNodes2(node.clauses, topLevelNestedVisitor, isCaseOrDefaultClause));
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function visitCaseClause(node) {
            return factory2.updateCaseClause(node, visitNode(node.expression, visitor, isExpression), visitNodes2(node.statements, topLevelNestedVisitor, isStatement));
        }
        function visitDefaultClause(node) {
            return visitEachChild(node, topLevelNestedVisitor, context);
        }
        function visitTryStatement(node) {
            return visitEachChild(node, topLevelNestedVisitor, context);
        }
        function visitCatchClause(node) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = factory2.updateCatchClause(node, node.variableDeclaration, Debug.checkDefined(visitNode(node.block, topLevelNestedVisitor, isBlock)));
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function visitBlock(node) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = visitEachChild(node, topLevelNestedVisitor, context);
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function visitorWorker(node, valueIsDiscarded) {
            if (!(node.transformFlags & 276828160 /* ContainsUpdateExpressionForIdentifier */ )) return node;
            switch(node.kind){
                case 247 /* ForStatement */ :
                    return visitForStatement(node, /*isTopLevel*/ false);
                case 243 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 216 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, valueIsDiscarded);
                case 359 /* PartiallyEmittedExpression */ :
                    return visitPartiallyEmittedExpression(node, valueIsDiscarded);
                case 225 /* BinaryExpression */ :
                    if (isDestructuringAssignment(node)) return visitDestructuringAssignment(node, valueIsDiscarded);
                    break;
                case 212 /* CallExpression */ :
                    if (isImportCall(node)) return visitImportCallExpression(node);
                    break;
                case 223 /* PrefixUnaryExpression */ :
                case 224 /* PostfixUnaryExpression */ :
                    return visitPrefixOrPostfixUnaryExpression(node, valueIsDiscarded);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            return visitorWorker(node, /*valueIsDiscarded*/ false);
        }
        function discardedValueVisitor(node) {
            return visitorWorker(node, /*valueIsDiscarded*/ true);
        }
        function visitExpressionStatement(node) {
            return factory2.updateExpressionStatement(node, visitNode(node.expression, discardedValueVisitor, isExpression));
        }
        function visitParenthesizedExpression(node, valueIsDiscarded) {
            return factory2.updateParenthesizedExpression(node, visitNode(node.expression, valueIsDiscarded ? discardedValueVisitor : visitor, isExpression));
        }
        function visitPartiallyEmittedExpression(node, valueIsDiscarded) {
            return factory2.updatePartiallyEmittedExpression(node, visitNode(node.expression, valueIsDiscarded ? discardedValueVisitor : visitor, isExpression));
        }
        function visitImportCallExpression(node) {
            const externalModuleName = getExternalModuleNameLiteral(factory2, node, currentSourceFile, host, resolver, compilerOptions);
            const firstArgument = visitNode(firstOrUndefined(node.arguments), visitor, isExpression);
            const argument = externalModuleName && (!firstArgument || !isStringLiteral(firstArgument) || firstArgument.text !== externalModuleName.text) ? externalModuleName : firstArgument;
            return factory2.createCallExpression(factory2.createPropertyAccessExpression(contextObject, factory2.createIdentifier("import")), /*typeArguments*/ void 0, argument ? [
                argument
            ] : []);
        }
        function visitDestructuringAssignment(node, valueIsDiscarded) {
            if (hasExportedReferenceInDestructuringTarget(node.left)) return flattenDestructuringAssignment(node, visitor, context, 0 /* All */ , !valueIsDiscarded);
            return visitEachChild(node, visitor, context);
        }
        function hasExportedReferenceInDestructuringTarget(node) {
            if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) return hasExportedReferenceInDestructuringTarget(node.left);
            else if (isSpreadElement(node)) return hasExportedReferenceInDestructuringTarget(node.expression);
            else if (isObjectLiteralExpression(node)) return some(node.properties, hasExportedReferenceInDestructuringTarget);
            else if (isArrayLiteralExpression(node)) return some(node.elements, hasExportedReferenceInDestructuringTarget);
            else if (isShorthandPropertyAssignment(node)) return hasExportedReferenceInDestructuringTarget(node.name);
            else if (isPropertyAssignment(node)) return hasExportedReferenceInDestructuringTarget(node.initializer);
            else if (isIdentifier(node)) {
                const container = resolver.getReferencedExportContainer(node);
                return container !== void 0 && container.kind === 311 /* SourceFile */ ;
            } else return false;
        }
        function visitPrefixOrPostfixUnaryExpression(node, valueIsDiscarded) {
            if ((node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) && isIdentifier(node.operand) && !isGeneratedIdentifier(node.operand) && !isLocalName(node.operand) && !isDeclarationNameOfEnumOrNamespace(node.operand)) {
                const exportedNames = getExports(node.operand);
                if (exportedNames) {
                    let temp;
                    let expression = visitNode(node.operand, visitor, isExpression);
                    if (isPrefixUnaryExpression(node)) expression = factory2.updatePrefixUnaryExpression(node, expression);
                    else {
                        expression = factory2.updatePostfixUnaryExpression(node, expression);
                        if (!valueIsDiscarded) {
                            temp = factory2.createTempVariable(hoistVariableDeclaration);
                            expression = factory2.createAssignment(temp, expression);
                            setTextRange(expression, node);
                        }
                        expression = factory2.createComma(expression, factory2.cloneNode(node.operand));
                        setTextRange(expression, node);
                    }
                    for (const exportName of exportedNames)expression = createExportExpression(exportName, preventSubstitution(expression));
                    if (temp) {
                        expression = factory2.createComma(expression, temp);
                        setTextRange(expression, node);
                    }
                    return expression;
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function modifierVisitor(node) {
            switch(node.kind){
                case 95 /* ExportKeyword */ :
                case 90 /* DefaultKeyword */ :
                    return void 0;
            }
            return node;
        }
        function onEmitNode(hint, node, emitCallback) {
            if (node.kind === 311 /* SourceFile */ ) {
                const id = getOriginalNodeId(node);
                currentSourceFile = node;
                moduleInfo = moduleInfoMap[id];
                exportFunction = exportFunctionsMap[id];
                noSubstitution = noSubstitutionMap[id];
                contextObject = contextObjectMap[id];
                if (noSubstitution) delete noSubstitutionMap[id];
                previousOnEmitNode(hint, node, emitCallback);
                currentSourceFile = void 0;
                moduleInfo = void 0;
                exportFunction = void 0;
                contextObject = void 0;
                noSubstitution = void 0;
            } else previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (isSubstitutionPrevented(node)) return node;
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            else if (hint === 4 /* Unspecified */ ) return substituteUnspecified(node);
            return node;
        }
        function substituteUnspecified(node) {
            switch(node.kind){
                case 303 /* ShorthandPropertyAssignment */ :
                    return substituteShorthandPropertyAssignment(node);
            }
            return node;
        }
        function substituteShorthandPropertyAssignment(node) {
            var _a, _b;
            const name = node.name;
            if (!isGeneratedIdentifier(name) && !isLocalName(name)) {
                const importDeclaration = resolver.getReferencedImportDeclaration(name);
                if (importDeclaration) {
                    if (isImportClause(importDeclaration)) return setTextRange(factory2.createPropertyAssignment(factory2.cloneNode(name), factory2.createPropertyAccessExpression(factory2.getGeneratedNameForNode(importDeclaration.parent), factory2.createIdentifier("default"))), /*location*/ node);
                    else if (isImportSpecifier(importDeclaration)) return setTextRange(factory2.createPropertyAssignment(factory2.cloneNode(name), factory2.createPropertyAccessExpression(factory2.getGeneratedNameForNode(((_b = (_a = importDeclaration.parent) == null ? void 0 : _a.parent) == null ? void 0 : _b.parent) || importDeclaration), factory2.cloneNode(importDeclaration.propertyName || importDeclaration.name))), /*location*/ node);
                }
            }
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
                case 225 /* BinaryExpression */ :
                    return substituteBinaryExpression(node);
                case 235 /* MetaProperty */ :
                    return substituteMetaProperty(node);
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            var _a, _b;
            if (getEmitFlags(node) & 8192 /* HelperName */ ) {
                const externalHelpersModuleName = getExternalHelpersModuleName(currentSourceFile);
                if (externalHelpersModuleName) return factory2.createPropertyAccessExpression(externalHelpersModuleName, node);
                return node;
            }
            if (!isGeneratedIdentifier(node) && !isLocalName(node)) {
                const importDeclaration = resolver.getReferencedImportDeclaration(node);
                if (importDeclaration) {
                    if (isImportClause(importDeclaration)) return setTextRange(factory2.createPropertyAccessExpression(factory2.getGeneratedNameForNode(importDeclaration.parent), factory2.createIdentifier("default")), /*location*/ node);
                    else if (isImportSpecifier(importDeclaration)) return setTextRange(factory2.createPropertyAccessExpression(factory2.getGeneratedNameForNode(((_b = (_a = importDeclaration.parent) == null ? void 0 : _a.parent) == null ? void 0 : _b.parent) || importDeclaration), factory2.cloneNode(importDeclaration.propertyName || importDeclaration.name)), /*location*/ node);
                }
            }
            return node;
        }
        function substituteBinaryExpression(node) {
            if (isAssignmentOperator(node.operatorToken.kind) && isIdentifier(node.left) && !isGeneratedIdentifier(node.left) && !isLocalName(node.left)) {
                const exportedNames = getExports(node.left);
                if (exportedNames) {
                    let expression = node;
                    for (const exportName of exportedNames)expression = createExportExpression(exportName, preventSubstitution(expression));
                    return expression;
                }
            }
            return node;
        }
        function substituteMetaProperty(node) {
            if (isImportMeta(node)) return factory2.createPropertyAccessExpression(contextObject, factory2.createIdentifier("meta"));
            return node;
        }
        function getExports(name) {
            let exportedNames;
            const valueDeclaration = getReferencedDeclaration(name);
            if (valueDeclaration) {
                const exportContainer = resolver.getReferencedExportContainer(name, /*prefixLocals*/ false);
                if (exportContainer && exportContainer.kind === 311 /* SourceFile */ ) exportedNames = append(exportedNames, factory2.getDeclarationName(valueDeclaration));
                exportedNames = addRange(exportedNames, moduleInfo == null ? void 0 : moduleInfo.exportedBindings[getOriginalNodeId(valueDeclaration)]);
            }
            return exportedNames;
        }
        function getReferencedDeclaration(name) {
            if (!isGeneratedIdentifier(name)) {
                const importDeclaration = resolver.getReferencedImportDeclaration(name);
                if (importDeclaration) return importDeclaration;
                const valueDeclaration = resolver.getReferencedValueDeclaration(name);
                if (valueDeclaration && (moduleInfo == null ? void 0 : moduleInfo.exportedBindings[getOriginalNodeId(valueDeclaration)])) return valueDeclaration;
                const declarations = resolver.getReferencedValueDeclarations(name);
                if (declarations) for (const declaration of declarations){
                    if (declaration !== valueDeclaration && (moduleInfo == null ? void 0 : moduleInfo.exportedBindings[getOriginalNodeId(declaration)])) return declaration;
                }
                return valueDeclaration;
            }
        }
        function preventSubstitution(node) {
            if (noSubstitution === void 0) noSubstitution = [];
            noSubstitution[getNodeId(node)] = true;
            return node;
        }
        function isSubstitutionPrevented(node) {
            return noSubstitution && node.id && noSubstitution[node.id];
        }
    }
    var init_system = __esm({
        "src/compiler/transformers/module/system.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/module/esnextAnd2015.ts
    function transformECMAScriptModule(context) {
        const { factory: factory2 , getEmitHelperFactory: emitHelpers  } = context;
        const host = context.getEmitHost();
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const previousOnEmitNode = context.onEmitNode;
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        context.enableEmitNotification(311 /* SourceFile */ );
        context.enableSubstitution(80 /* Identifier */ );
        let helperNameSubstitutions;
        let currentSourceFile;
        let importRequireStatements;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            if (isExternalModule(node) || getIsolatedModules(compilerOptions)) {
                currentSourceFile = node;
                importRequireStatements = void 0;
                let result = updateExternalModule(node);
                currentSourceFile = void 0;
                if (importRequireStatements) result = factory2.updateSourceFile(result, setTextRange(factory2.createNodeArray(insertStatementsAfterCustomPrologue(result.statements.slice(), importRequireStatements)), result.statements));
                if (!isExternalModule(node) || some(result.statements, isExternalModuleIndicator)) return result;
                return factory2.updateSourceFile(result, setTextRange(factory2.createNodeArray([
                    ...result.statements,
                    createEmptyExports(factory2)
                ]), result.statements));
            }
            return node;
        }
        function updateExternalModule(node) {
            const externalHelpersImportDeclaration = createExternalHelpersImportDeclarationIfNeeded(factory2, emitHelpers(), node, compilerOptions);
            if (externalHelpersImportDeclaration) {
                const statements = [];
                const statementOffset = factory2.copyPrologue(node.statements, statements);
                append(statements, externalHelpersImportDeclaration);
                addRange(statements, visitNodes2(node.statements, visitor, isStatement, statementOffset));
                return factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray(statements), node.statements));
            } else return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            switch(node.kind){
                case 270 /* ImportEqualsDeclaration */ :
                    return getEmitModuleKind(compilerOptions) >= 100 /* Node16 */  ? visitImportEqualsDeclaration(node) : void 0;
                case 276 /* ExportAssignment */ :
                    return visitExportAssignment(node);
                case 277 /* ExportDeclaration */ :
                    const exportDecl = node;
                    return visitExportDeclaration(exportDecl);
            }
            return node;
        }
        function createRequireCall2(importNode) {
            const moduleName = getExternalModuleNameLiteral(factory2, importNode, Debug.checkDefined(currentSourceFile), host, resolver, compilerOptions);
            const args = [];
            if (moduleName) args.push(moduleName);
            if (!importRequireStatements) {
                const createRequireName = factory2.createUniqueName("_createRequire", 48 /* FileLevel */ );
                const importStatement = factory2.createImportDeclaration(/*modifiers*/ void 0, factory2.createImportClause(/*isTypeOnly*/ false, /*name*/ void 0, factory2.createNamedImports([
                    factory2.createImportSpecifier(/*isTypeOnly*/ false, factory2.createIdentifier("createRequire"), createRequireName)
                ])), factory2.createStringLiteral("module"));
                const requireHelperName = factory2.createUniqueName("__require", 48 /* FileLevel */ );
                const requireStatement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(requireHelperName, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createCallExpression(factory2.cloneNode(createRequireName), /*typeArguments*/ void 0, [
                        factory2.createPropertyAccessExpression(factory2.createMetaProperty(102 /* ImportKeyword */ , factory2.createIdentifier("meta")), factory2.createIdentifier("url"))
                    ]))
                ], /*flags*/ languageVersion >= 2 /* ES2015 */  ? 2 /* Const */  : 0 /* None */ ));
                importRequireStatements = [
                    importStatement,
                    requireStatement
                ];
            }
            const name = importRequireStatements[1].declarationList.declarations[0].name;
            Debug.assertNode(name, isIdentifier);
            return factory2.createCallExpression(factory2.cloneNode(name), /*typeArguments*/ void 0, args);
        }
        function visitImportEqualsDeclaration(node) {
            Debug.assert(isExternalModuleImportEqualsDeclaration(node), "import= for internal module references should be handled in an earlier transformer.");
            let statements;
            statements = append(statements, setOriginalNode(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(factory2.cloneNode(node.name), /*exclamationToken*/ void 0, /*type*/ void 0, createRequireCall2(node))
            ], /*flags*/ languageVersion >= 2 /* ES2015 */  ? 2 /* Const */  : 0 /* None */ )), node), node));
            statements = appendExportsOfImportEqualsDeclaration(statements, node);
            return singleOrMany(statements);
        }
        function appendExportsOfImportEqualsDeclaration(statements, node) {
            if (hasSyntacticModifier(node, 1 /* Export */ )) statements = append(statements, factory2.createExportDeclaration(/*modifiers*/ void 0, node.isTypeOnly, factory2.createNamedExports([
                factory2.createExportSpecifier(/*isTypeOnly*/ false, /*propertyName*/ void 0, idText(node.name))
            ])));
            return statements;
        }
        function visitExportAssignment(node) {
            return node.isExportEquals ? void 0 : node;
        }
        function visitExportDeclaration(node) {
            if (compilerOptions.module !== void 0 && compilerOptions.module > 5 /* ES2015 */ ) return node;
            if (!node.exportClause || !isNamespaceExport(node.exportClause) || !node.moduleSpecifier) return node;
            const oldIdentifier = node.exportClause.name;
            const synthName = factory2.getGeneratedNameForNode(oldIdentifier);
            const importDecl = factory2.createImportDeclaration(/*modifiers*/ void 0, factory2.createImportClause(/*isTypeOnly*/ false, /*name*/ void 0, factory2.createNamespaceImport(synthName)), node.moduleSpecifier, node.assertClause);
            setOriginalNode(importDecl, node.exportClause);
            const exportDecl = isExportNamespaceAsDefaultDeclaration(node) ? factory2.createExportDefault(synthName) : factory2.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory2.createNamedExports([
                factory2.createExportSpecifier(/*isTypeOnly*/ false, synthName, oldIdentifier)
            ]));
            setOriginalNode(exportDecl, node);
            return [
                importDecl,
                exportDecl
            ];
        }
        function onEmitNode(hint, node, emitCallback) {
            if (isSourceFile(node)) {
                if ((isExternalModule(node) || getIsolatedModules(compilerOptions)) && compilerOptions.importHelpers) helperNameSubstitutions = /* @__PURE__ */ new Map();
                previousOnEmitNode(hint, node, emitCallback);
                helperNameSubstitutions = void 0;
            } else previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (helperNameSubstitutions && isIdentifier(node) && getEmitFlags(node) & 8192 /* HelperName */ ) return substituteHelperName(node);
            return node;
        }
        function substituteHelperName(node) {
            const name = idText(node);
            let substitution = helperNameSubstitutions.get(name);
            if (!substitution) helperNameSubstitutions.set(name, substitution = factory2.createUniqueName(name, 48 /* FileLevel */ ));
            return substitution;
        }
    }
    var init_esnextAnd2015 = __esm({
        "src/compiler/transformers/module/esnextAnd2015.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/module/node.ts
    function transformNodeModule(context) {
        const previousOnSubstituteNode = context.onSubstituteNode;
        const previousOnEmitNode = context.onEmitNode;
        const esmTransform = transformECMAScriptModule(context);
        const esmOnSubstituteNode = context.onSubstituteNode;
        const esmOnEmitNode = context.onEmitNode;
        context.onSubstituteNode = previousOnSubstituteNode;
        context.onEmitNode = previousOnEmitNode;
        const cjsTransform = transformModule(context);
        const cjsOnSubstituteNode = context.onSubstituteNode;
        const cjsOnEmitNode = context.onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.enableSubstitution(311 /* SourceFile */ );
        context.enableEmitNotification(311 /* SourceFile */ );
        let currentSourceFile;
        return transformSourceFileOrBundle;
        function onSubstituteNode(hint, node) {
            if (isSourceFile(node)) {
                currentSourceFile = node;
                return previousOnSubstituteNode(hint, node);
            } else {
                if (!currentSourceFile) return previousOnSubstituteNode(hint, node);
                if (currentSourceFile.impliedNodeFormat === 99 /* ESNext */ ) return esmOnSubstituteNode(hint, node);
                return cjsOnSubstituteNode(hint, node);
            }
        }
        function onEmitNode(hint, node, emitCallback) {
            if (isSourceFile(node)) currentSourceFile = node;
            if (!currentSourceFile) return previousOnEmitNode(hint, node, emitCallback);
            if (currentSourceFile.impliedNodeFormat === 99 /* ESNext */ ) return esmOnEmitNode(hint, node, emitCallback);
            return cjsOnEmitNode(hint, node, emitCallback);
        }
        function getModuleTransformForFile(file) {
            return file.impliedNodeFormat === 99 /* ESNext */  ? esmTransform : cjsTransform;
        }
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            currentSourceFile = node;
            const result = getModuleTransformForFile(node)(node);
            currentSourceFile = void 0;
            Debug.assert(isSourceFile(result));
            return result;
        }
        function transformSourceFileOrBundle(node) {
            return node.kind === 311 /* SourceFile */  ? transformSourceFile(node) : transformBundle(node);
        }
        function transformBundle(node) {
            return context.factory.createBundle(map(node.sourceFiles, transformSourceFile), node.prepends);
        }
    }
    var init_node = __esm({
        "src/compiler/transformers/module/node.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/declarations/diagnostics.ts
    function canProduceDiagnostics(node) {
        return isVariableDeclaration(node) || isPropertyDeclaration(node) || isPropertySignature(node) || isBindingElement(node) || isSetAccessor(node) || isGetAccessor(node) || isConstructSignatureDeclaration(node) || isCallSignatureDeclaration(node) || isMethodDeclaration(node) || isMethodSignature(node) || isFunctionDeclaration(node) || isParameter(node) || isTypeParameterDeclaration(node) || isExpressionWithTypeArguments(node) || isImportEqualsDeclaration(node) || isTypeAliasDeclaration(node) || isConstructorDeclaration(node) || isIndexSignatureDeclaration(node) || isPropertyAccessExpression(node) || isElementAccessExpression(node) || isBinaryExpression(node) || isJSDocTypeAlias(node);
    }
    function createGetSymbolAccessibilityDiagnosticForNodeName(node) {
        if (isSetAccessor(node) || isGetAccessor(node)) return getAccessorNameVisibilityError;
        else if (isMethodSignature(node) || isMethodDeclaration(node)) return getMethodNameVisibilityError;
        else return createGetSymbolAccessibilityDiagnosticForNode(node);
        function getAccessorNameVisibilityError(symbolAccessibilityResult) {
            const diagnosticMessage = getAccessorNameVisibilityDiagnosticMessage(symbolAccessibilityResult);
            return diagnosticMessage !== void 0 ? {
                diagnosticMessage: diagnosticMessage,
                errorNode: node,
                typeName: node.name
            } : void 0;
        }
        function getAccessorNameVisibilityDiagnosticMessage(symbolAccessibilityResult) {
            if (isStatic(node)) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_private_name_1;
            else if (node.parent.kind === 262 /* ClassDeclaration */ ) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_property_0_of_exported_class_has_or_is_using_private_name_1;
            else return symbolAccessibilityResult.errorModuleName ? Diagnostics.Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Property_0_of_exported_interface_has_or_is_using_private_name_1;
        }
        function getMethodNameVisibilityError(symbolAccessibilityResult) {
            const diagnosticMessage = getMethodNameVisibilityDiagnosticMessage(symbolAccessibilityResult);
            return diagnosticMessage !== void 0 ? {
                diagnosticMessage: diagnosticMessage,
                errorNode: node,
                typeName: node.name
            } : void 0;
        }
        function getMethodNameVisibilityDiagnosticMessage(symbolAccessibilityResult) {
            if (isStatic(node)) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_private_name_1;
            else if (node.parent.kind === 262 /* ClassDeclaration */ ) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_method_0_of_exported_class_has_or_is_using_private_name_1;
            else return symbolAccessibilityResult.errorModuleName ? Diagnostics.Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Method_0_of_exported_interface_has_or_is_using_private_name_1;
        }
    }
    function createGetSymbolAccessibilityDiagnosticForNode(node) {
        if (isVariableDeclaration(node) || isPropertyDeclaration(node) || isPropertySignature(node) || isPropertyAccessExpression(node) || isElementAccessExpression(node) || isBinaryExpression(node) || isBindingElement(node) || isConstructorDeclaration(node)) return getVariableDeclarationTypeVisibilityError;
        else if (isSetAccessor(node) || isGetAccessor(node)) return getAccessorDeclarationTypeVisibilityError;
        else if (isConstructSignatureDeclaration(node) || isCallSignatureDeclaration(node) || isMethodDeclaration(node) || isMethodSignature(node) || isFunctionDeclaration(node) || isIndexSignatureDeclaration(node)) return getReturnTypeVisibilityError;
        else if (isParameter(node)) {
            if (isParameterPropertyDeclaration(node, node.parent) && hasSyntacticModifier(node.parent, 8 /* Private */ )) return getVariableDeclarationTypeVisibilityError;
            return getParameterDeclarationTypeVisibilityError;
        } else if (isTypeParameterDeclaration(node)) return getTypeParameterConstraintVisibilityError;
        else if (isExpressionWithTypeArguments(node)) return getHeritageClauseVisibilityError;
        else if (isImportEqualsDeclaration(node)) return getImportEntityNameVisibilityError;
        else if (isTypeAliasDeclaration(node) || isJSDocTypeAlias(node)) return getTypeAliasDeclarationVisibilityError;
        else return Debug.assertNever(node, `Attempted to set a declaration diagnostic context for unhandled node kind: ${Debug.formatSyntaxKind(node.kind)}`);
        function getVariableDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult) {
            if (node.kind === 259 /* VariableDeclaration */  || node.kind === 207 /* BindingElement */ ) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Exported_variable_0_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Exported_variable_0_has_or_is_using_private_name_1;
            else if (node.kind === 171 /* PropertyDeclaration */  || node.kind === 210 /* PropertyAccessExpression */  || node.kind === 211 /* ElementAccessExpression */  || node.kind === 225 /* BinaryExpression */  || node.kind === 170 /* PropertySignature */  || node.kind === 168 /* Parameter */  && hasSyntacticModifier(node.parent, 8 /* Private */ )) {
                if (isStatic(node)) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_private_name_1;
                else if (node.parent.kind === 262 /* ClassDeclaration */  || node.kind === 168 /* Parameter */ ) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_property_0_of_exported_class_has_or_is_using_private_name_1;
                else return symbolAccessibilityResult.errorModuleName ? Diagnostics.Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Property_0_of_exported_interface_has_or_is_using_private_name_1;
            }
        }
        function getVariableDeclarationTypeVisibilityError(symbolAccessibilityResult) {
            const diagnosticMessage = getVariableDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult);
            return diagnosticMessage !== void 0 ? {
                diagnosticMessage: diagnosticMessage,
                errorNode: node,
                typeName: node.name
            } : void 0;
        }
        function getAccessorDeclarationTypeVisibilityError(symbolAccessibilityResult) {
            let diagnosticMessage;
            if (node.kind === 177 /* SetAccessor */ ) {
                if (isStatic(node)) diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1;
                else diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1;
            } else if (isStatic(node)) diagnosticMessage = symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1;
            else diagnosticMessage = symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1;
            return {
                diagnosticMessage: diagnosticMessage,
                errorNode: node.name,
                typeName: node.name
            };
        }
        function getReturnTypeVisibilityError(symbolAccessibilityResult) {
            let diagnosticMessage;
            switch(node.kind){
                case 179 /* ConstructSignature */ :
                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0;
                    break;
                case 178 /* CallSignature */ :
                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0;
                    break;
                case 180 /* IndexSignature */ :
                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0;
                    break;
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                    if (isStatic(node)) diagnosticMessage = symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named : Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0;
                    else if (node.parent.kind === 262 /* ClassDeclaration */ ) diagnosticMessage = symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named : Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0;
                    else diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0;
                    break;
                case 261 /* FunctionDeclaration */ :
                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named : Diagnostics.Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_exported_function_has_or_is_using_private_name_0;
                    break;
                default:
                    return Debug.fail("This is unknown kind for signature: " + node.kind);
            }
            return {
                diagnosticMessage: diagnosticMessage,
                errorNode: node.name || node
            };
        }
        function getParameterDeclarationTypeVisibilityError(symbolAccessibilityResult) {
            const diagnosticMessage = getParameterDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult);
            return diagnosticMessage !== void 0 ? {
                diagnosticMessage: diagnosticMessage,
                errorNode: node,
                typeName: node.name
            } : void 0;
        }
        function getParameterDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult) {
            switch(node.parent.kind){
                case 175 /* Constructor */ :
                    return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1;
                case 179 /* ConstructSignature */ :
                case 184 /* ConstructorType */ :
                    return symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1;
                case 178 /* CallSignature */ :
                    return symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1;
                case 180 /* IndexSignature */ :
                    return symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1;
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                    if (isStatic(node.parent)) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1;
                    else if (node.parent.parent.kind === 262 /* ClassDeclaration */ ) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1;
                    else return symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1;
                case 261 /* FunctionDeclaration */ :
                case 183 /* FunctionType */ :
                    return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_exported_function_has_or_is_using_private_name_1;
                case 177 /* SetAccessor */ :
                case 176 /* GetAccessor */ :
                    return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Parameter_0_of_accessor_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Parameter_0_of_accessor_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_accessor_has_or_is_using_private_name_1;
                default:
                    return Debug.fail(`Unknown parent for parameter: ${Debug.formatSyntaxKind(node.parent.kind)}`);
            }
        }
        function getTypeParameterConstraintVisibilityError() {
            let diagnosticMessage;
            switch(node.parent.kind){
                case 262 /* ClassDeclaration */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_exported_class_has_or_is_using_private_name_1;
                    break;
                case 263 /* InterfaceDeclaration */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1;
                    break;
                case 199 /* MappedType */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_exported_mapped_object_type_is_using_private_name_1;
                    break;
                case 184 /* ConstructorType */ :
                case 179 /* ConstructSignature */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1;
                    break;
                case 178 /* CallSignature */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1;
                    break;
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                    if (isStatic(node.parent)) diagnosticMessage = Diagnostics.Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1;
                    else if (node.parent.parent.kind === 262 /* ClassDeclaration */ ) diagnosticMessage = Diagnostics.Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1;
                    else diagnosticMessage = Diagnostics.Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1;
                    break;
                case 183 /* FunctionType */ :
                case 261 /* FunctionDeclaration */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_exported_function_has_or_is_using_private_name_1;
                    break;
                case 194 /* InferType */ :
                    diagnosticMessage = Diagnostics.Extends_clause_for_inferred_type_0_has_or_is_using_private_name_1;
                    break;
                case 264 /* TypeAliasDeclaration */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1;
                    break;
                default:
                    return Debug.fail("This is unknown parent for type parameter: " + node.parent.kind);
            }
            return {
                diagnosticMessage: diagnosticMessage,
                errorNode: node,
                typeName: node.name
            };
        }
        function getHeritageClauseVisibilityError() {
            let diagnosticMessage;
            if (isClassDeclaration(node.parent.parent)) diagnosticMessage = isHeritageClause(node.parent) && node.parent.token === 119 /* ImplementsKeyword */  ? Diagnostics.Implements_clause_of_exported_class_0_has_or_is_using_private_name_1 : node.parent.parent.name ? Diagnostics.extends_clause_of_exported_class_0_has_or_is_using_private_name_1 : Diagnostics.extends_clause_of_exported_class_has_or_is_using_private_name_0;
            else diagnosticMessage = Diagnostics.extends_clause_of_exported_interface_0_has_or_is_using_private_name_1;
            return {
                diagnosticMessage: diagnosticMessage,
                errorNode: node,
                typeName: getNameOfDeclaration(node.parent.parent)
            };
        }
        function getImportEntityNameVisibilityError() {
            return {
                diagnosticMessage: Diagnostics.Import_declaration_0_is_using_private_name_1,
                errorNode: node,
                typeName: node.name
            };
        }
        function getTypeAliasDeclarationVisibilityError(symbolAccessibilityResult) {
            return {
                diagnosticMessage: symbolAccessibilityResult.errorModuleName ? Diagnostics.Exported_type_alias_0_has_or_is_using_private_name_1_from_module_2 : Diagnostics.Exported_type_alias_0_has_or_is_using_private_name_1,
                errorNode: isJSDocTypeAlias(node) ? Debug.checkDefined(node.typeExpression) : node.type,
                typeName: isJSDocTypeAlias(node) ? getNameOfDeclaration(node) : node.name
            };
        }
    }
    var init_diagnostics = __esm({
        "src/compiler/transformers/declarations/diagnostics.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/transformers/declarations.ts
    function getDeclarationDiagnostics(host, resolver, file) {
        const compilerOptions = host.getCompilerOptions();
        const result = transformNodes(resolver, host, factory, compilerOptions, file ? [
            file
        ] : filter(host.getSourceFiles(), isSourceFileNotJson), [
            transformDeclarations
        ], /*allowDtsFiles*/ false);
        return result.diagnostics;
    }
    function hasInternalAnnotation(range, currentSourceFile) {
        const comment = currentSourceFile.text.substring(range.pos, range.end);
        return stringContains(comment, "@internal");
    }
    function isInternalDeclaration(node, currentSourceFile) {
        const parseTreeNode = getParseTreeNode(node);
        if (parseTreeNode && parseTreeNode.kind === 168 /* Parameter */ ) {
            const paramIdx = parseTreeNode.parent.parameters.indexOf(parseTreeNode);
            const previousSibling = paramIdx > 0 ? parseTreeNode.parent.parameters[paramIdx - 1] : void 0;
            const text = currentSourceFile.text;
            const commentRanges = previousSibling ? concatenate(// to handle
            // ... parameters, /** @internal */
            // public param: string
            getTrailingCommentRanges(text, skipTrivia(text, previousSibling.end + 1, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true)), getLeadingCommentRanges(text, node.pos)) : getTrailingCommentRanges(text, skipTrivia(text, node.pos, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true));
            return commentRanges && commentRanges.length && hasInternalAnnotation(last(commentRanges), currentSourceFile);
        }
        const leadingCommentRanges = parseTreeNode && getLeadingCommentRangesOfNode(parseTreeNode, currentSourceFile);
        return !!forEach(leadingCommentRanges, (range)=>{
            return hasInternalAnnotation(range, currentSourceFile);
        });
    }
    function transformDeclarations(context) {
        const throwDiagnostic = ()=>Debug.fail("Diagnostic emitted without context");
        let getSymbolAccessibilityDiagnostic = throwDiagnostic;
        let needsDeclare = true;
        let isBundledEmit = false;
        let resultHasExternalModuleIndicator = false;
        let needsScopeFixMarker = false;
        let resultHasScopeMarker = false;
        let enclosingDeclaration;
        let necessaryTypeReferences;
        let lateMarkedStatements;
        let lateStatementReplacementMap;
        let suppressNewDiagnosticContexts;
        let exportedModulesFromDeclarationEmit;
        const { factory: factory2  } = context;
        const host = context.getEmitHost();
        const symbolTracker = {
            trackSymbol: trackSymbol,
            reportInaccessibleThisError: reportInaccessibleThisError,
            reportInaccessibleUniqueSymbolError: reportInaccessibleUniqueSymbolError,
            reportCyclicStructureError: reportCyclicStructureError,
            reportPrivateInBaseOfClassExpression: reportPrivateInBaseOfClassExpression,
            reportLikelyUnsafeImportRequiredError: reportLikelyUnsafeImportRequiredError,
            reportTruncationError: reportTruncationError,
            moduleResolverHost: host,
            trackReferencedAmbientModule: trackReferencedAmbientModule,
            trackExternalModuleSymbolOfImportTypeNode: trackExternalModuleSymbolOfImportTypeNode,
            reportNonlocalAugmentation: reportNonlocalAugmentation,
            reportNonSerializableProperty: reportNonSerializableProperty,
            reportImportTypeNodeResolutionModeOverride: reportImportTypeNodeResolutionModeOverride
        };
        let errorNameNode;
        let errorFallbackNode;
        let currentSourceFile;
        let refs;
        let libs2;
        let emittedImports;
        const resolver = context.getEmitResolver();
        const options = context.getCompilerOptions();
        const { noResolve: noResolve , stripInternal: stripInternal  } = options;
        return transformRoot;
        function recordTypeReferenceDirectivesIfNecessary(typeReferenceDirectives) {
            if (!typeReferenceDirectives) return;
            necessaryTypeReferences = necessaryTypeReferences || /* @__PURE__ */ new Set();
            for (const ref of typeReferenceDirectives)necessaryTypeReferences.add(ref);
        }
        function trackReferencedAmbientModule(node, symbol) {
            const directives = resolver.getTypeReferenceDirectivesForSymbol(symbol, 67108863 /* All */ );
            if (length(directives)) return recordTypeReferenceDirectivesIfNecessary(directives);
            const container = getSourceFileOfNode(node);
            refs.set(getOriginalNodeId(container), container);
        }
        function handleSymbolAccessibilityError(symbolAccessibilityResult) {
            if (symbolAccessibilityResult.accessibility === 0 /* Accessible */ ) {
                if (symbolAccessibilityResult && symbolAccessibilityResult.aliasesToMakeVisible) {
                    if (!lateMarkedStatements) lateMarkedStatements = symbolAccessibilityResult.aliasesToMakeVisible;
                    else for (const ref of symbolAccessibilityResult.aliasesToMakeVisible)pushIfUnique(lateMarkedStatements, ref);
                }
            } else {
                const errorInfo = getSymbolAccessibilityDiagnostic(symbolAccessibilityResult);
                if (errorInfo) {
                    if (errorInfo.typeName) context.addDiagnostic(createDiagnosticForNode(symbolAccessibilityResult.errorNode || errorInfo.errorNode, errorInfo.diagnosticMessage, getTextOfNode(errorInfo.typeName), symbolAccessibilityResult.errorSymbolName, symbolAccessibilityResult.errorModuleName));
                    else context.addDiagnostic(createDiagnosticForNode(symbolAccessibilityResult.errorNode || errorInfo.errorNode, errorInfo.diagnosticMessage, symbolAccessibilityResult.errorSymbolName, symbolAccessibilityResult.errorModuleName));
                    return true;
                }
            }
            return false;
        }
        function trackExternalModuleSymbolOfImportTypeNode(symbol) {
            if (!isBundledEmit) (exportedModulesFromDeclarationEmit || (exportedModulesFromDeclarationEmit = [])).push(symbol);
        }
        function trackSymbol(symbol, enclosingDeclaration2, meaning) {
            if (symbol.flags & 262144 /* TypeParameter */ ) return false;
            const issuedDiagnostic = handleSymbolAccessibilityError(resolver.isSymbolAccessible(symbol, enclosingDeclaration2, meaning, /*shouldComputeAliasToMarkVisible*/ true));
            recordTypeReferenceDirectivesIfNecessary(resolver.getTypeReferenceDirectivesForSymbol(symbol, meaning));
            return issuedDiagnostic;
        }
        function reportPrivateInBaseOfClassExpression(propertyName) {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.Property_0_of_exported_class_expression_may_not_be_private_or_protected, propertyName));
        }
        function errorDeclarationNameWithFallback() {
            return errorNameNode ? declarationNameToString(errorNameNode) : errorFallbackNode && getNameOfDeclaration(errorFallbackNode) ? declarationNameToString(getNameOfDeclaration(errorFallbackNode)) : errorFallbackNode && isExportAssignment(errorFallbackNode) ? errorFallbackNode.isExportEquals ? "export=" : "default" : "(Missing)";
        }
        function reportInaccessibleUniqueSymbolError() {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary, errorDeclarationNameWithFallback(), "unique symbol"));
        }
        function reportCyclicStructureError() {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_inferred_type_of_0_references_a_type_with_a_cyclic_structure_which_cannot_be_trivially_serialized_A_type_annotation_is_necessary, errorDeclarationNameWithFallback()));
        }
        function reportInaccessibleThisError() {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary, errorDeclarationNameWithFallback(), "this"));
        }
        function reportLikelyUnsafeImportRequiredError(specifier) {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_inferred_type_of_0_cannot_be_named_without_a_reference_to_1_This_is_likely_not_portable_A_type_annotation_is_necessary, errorDeclarationNameWithFallback(), specifier));
        }
        function reportTruncationError() {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_inferred_type_of_this_node_exceeds_the_maximum_length_the_compiler_will_serialize_An_explicit_type_annotation_is_needed));
        }
        function reportNonlocalAugmentation(containingFile, parentSymbol, symbol) {
            var _a;
            const primaryDeclaration = (_a = parentSymbol.declarations) == null ? void 0 : _a.find((d)=>getSourceFileOfNode(d) === containingFile);
            const augmentingDeclarations = filter(symbol.declarations, (d)=>getSourceFileOfNode(d) !== containingFile);
            if (primaryDeclaration && augmentingDeclarations) for (const augmentations of augmentingDeclarations)context.addDiagnostic(addRelatedInfo(createDiagnosticForNode(augmentations, Diagnostics.Declaration_augments_declaration_in_another_file_This_cannot_be_serialized), createDiagnosticForNode(primaryDeclaration, Diagnostics.This_is_the_declaration_being_augmented_Consider_moving_the_augmenting_declaration_into_the_same_file)));
        }
        function reportNonSerializableProperty(propertyName) {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_type_of_this_node_cannot_be_serialized_because_its_property_0_cannot_be_serialized, propertyName));
        }
        function reportImportTypeNodeResolutionModeOverride() {
            if (!isNightly() && (errorNameNode || errorFallbackNode)) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_type_of_this_expression_cannot_be_named_without_a_resolution_mode_assertion_which_is_an_unstable_feature_Use_nightly_TypeScript_to_silence_this_error_Try_updating_with_npm_install_D_typescript_next));
        }
        function transformDeclarationsForJS(sourceFile, bundled) {
            const oldDiag = getSymbolAccessibilityDiagnostic;
            getSymbolAccessibilityDiagnostic = (s)=>s.errorNode && canProduceDiagnostics(s.errorNode) ? createGetSymbolAccessibilityDiagnosticForNode(s.errorNode)(s) : {
                    diagnosticMessage: s.errorModuleName ? Diagnostics.Declaration_emit_for_this_file_requires_using_private_name_0_from_module_1_An_explicit_type_annotation_may_unblock_declaration_emit : Diagnostics.Declaration_emit_for_this_file_requires_using_private_name_0_An_explicit_type_annotation_may_unblock_declaration_emit,
                    errorNode: s.errorNode || sourceFile
                };
            const result = resolver.getDeclarationStatementsForSourceFile(sourceFile, declarationEmitNodeBuilderFlags, symbolTracker, bundled);
            getSymbolAccessibilityDiagnostic = oldDiag;
            return result;
        }
        function transformRoot(node) {
            if (node.kind === 311 /* SourceFile */  && node.isDeclarationFile) return node;
            if (node.kind === 312 /* Bundle */ ) {
                isBundledEmit = true;
                refs = /* @__PURE__ */ new Map();
                libs2 = /* @__PURE__ */ new Map();
                let hasNoDefaultLib = false;
                const bundle = factory2.createBundle(map(node.sourceFiles, (sourceFile)=>{
                    if (sourceFile.isDeclarationFile) return void 0;
                    hasNoDefaultLib = hasNoDefaultLib || sourceFile.hasNoDefaultLib;
                    currentSourceFile = sourceFile;
                    enclosingDeclaration = sourceFile;
                    lateMarkedStatements = void 0;
                    suppressNewDiagnosticContexts = false;
                    lateStatementReplacementMap = /* @__PURE__ */ new Map();
                    getSymbolAccessibilityDiagnostic = throwDiagnostic;
                    needsScopeFixMarker = false;
                    resultHasScopeMarker = false;
                    collectReferences(sourceFile, refs);
                    collectLibs(sourceFile, libs2);
                    if (isExternalOrCommonJsModule(sourceFile) || isJsonSourceFile(sourceFile)) {
                        resultHasExternalModuleIndicator = false;
                        needsDeclare = false;
                        const statements = isSourceFileJS(sourceFile) ? factory2.createNodeArray(transformDeclarationsForJS(sourceFile, /*bundled*/ true)) : visitNodes2(sourceFile.statements, visitDeclarationStatements, isStatement);
                        const newFile = factory2.updateSourceFile(sourceFile, [
                            factory2.createModuleDeclaration([
                                factory2.createModifier(138 /* DeclareKeyword */ )
                            ], factory2.createStringLiteral(getResolvedExternalModuleName(context.getEmitHost(), sourceFile)), factory2.createModuleBlock(setTextRange(factory2.createNodeArray(transformAndReplaceLatePaintedStatements(statements)), sourceFile.statements)))
                        ], /*isDeclarationFile*/ true, /*referencedFiles*/ [], /*typeReferences*/ [], /*hasNoDefaultLib*/ false, /*libReferences*/ []);
                        return newFile;
                    }
                    needsDeclare = true;
                    const updated2 = isSourceFileJS(sourceFile) ? factory2.createNodeArray(transformDeclarationsForJS(sourceFile)) : visitNodes2(sourceFile.statements, visitDeclarationStatements, isStatement);
                    return factory2.updateSourceFile(sourceFile, transformAndReplaceLatePaintedStatements(updated2), /*isDeclarationFile*/ true, /*referencedFiles*/ [], /*typeReferences*/ [], /*hasNoDefaultLib*/ false, /*libReferences*/ []);
                }), mapDefined(node.prepends, (prepend)=>{
                    if (prepend.kind === 314 /* InputFiles */ ) {
                        const sourceFile = createUnparsedSourceFile(prepend, "dts", stripInternal);
                        hasNoDefaultLib = hasNoDefaultLib || !!sourceFile.hasNoDefaultLib;
                        collectReferences(sourceFile, refs);
                        recordTypeReferenceDirectivesIfNecessary(map(sourceFile.typeReferenceDirectives, (ref)=>[
                                ref.fileName,
                                ref.resolutionMode
                            ]));
                        collectLibs(sourceFile, libs2);
                        return sourceFile;
                    }
                    return prepend;
                }));
                bundle.syntheticFileReferences = [];
                bundle.syntheticTypeReferences = getFileReferencesForUsedTypeReferences();
                bundle.syntheticLibReferences = getLibReferences();
                bundle.hasNoDefaultLib = hasNoDefaultLib;
                const outputFilePath2 = getDirectoryPath(normalizeSlashes(getOutputPathsFor(node, host, /*forceDtsPaths*/ true).declarationFilePath));
                const referenceVisitor2 = mapReferencesIntoArray(bundle.syntheticFileReferences, outputFilePath2);
                refs.forEach(referenceVisitor2);
                return bundle;
            }
            needsDeclare = true;
            needsScopeFixMarker = false;
            resultHasScopeMarker = false;
            enclosingDeclaration = node;
            currentSourceFile = node;
            getSymbolAccessibilityDiagnostic = throwDiagnostic;
            isBundledEmit = false;
            resultHasExternalModuleIndicator = false;
            suppressNewDiagnosticContexts = false;
            lateMarkedStatements = void 0;
            lateStatementReplacementMap = /* @__PURE__ */ new Map();
            necessaryTypeReferences = void 0;
            refs = collectReferences(currentSourceFile, /* @__PURE__ */ new Map());
            libs2 = collectLibs(currentSourceFile, /* @__PURE__ */ new Map());
            const references = [];
            const outputFilePath = getDirectoryPath(normalizeSlashes(getOutputPathsFor(node, host, /*forceDtsPaths*/ true).declarationFilePath));
            const referenceVisitor = mapReferencesIntoArray(references, outputFilePath);
            let combinedStatements;
            if (isSourceFileJS(currentSourceFile)) {
                combinedStatements = factory2.createNodeArray(transformDeclarationsForJS(node));
                refs.forEach(referenceVisitor);
                emittedImports = filter(combinedStatements, isAnyImportSyntax);
            } else {
                const statements = visitNodes2(node.statements, visitDeclarationStatements, isStatement);
                combinedStatements = setTextRange(factory2.createNodeArray(transformAndReplaceLatePaintedStatements(statements)), node.statements);
                refs.forEach(referenceVisitor);
                emittedImports = filter(combinedStatements, isAnyImportSyntax);
                if (isExternalModule(node) && (!resultHasExternalModuleIndicator || needsScopeFixMarker && !resultHasScopeMarker)) combinedStatements = setTextRange(factory2.createNodeArray([
                    ...combinedStatements,
                    createEmptyExports(factory2)
                ]), combinedStatements);
            }
            const updated = factory2.updateSourceFile(node, combinedStatements, /*isDeclarationFile*/ true, references, getFileReferencesForUsedTypeReferences(), node.hasNoDefaultLib, getLibReferences());
            updated.exportedModulesFromDeclarationEmit = exportedModulesFromDeclarationEmit;
            return updated;
            function getLibReferences() {
                return arrayFrom(libs2.keys(), (lib)=>({
                        fileName: lib,
                        pos: -1,
                        end: -1
                    }));
            }
            function getFileReferencesForUsedTypeReferences() {
                return necessaryTypeReferences ? mapDefined(arrayFrom(necessaryTypeReferences.keys()), getFileReferenceForSpecifierModeTuple) : [];
            }
            function getFileReferenceForSpecifierModeTuple([typeName, mode]) {
                if (emittedImports) for (const importStatement of emittedImports){
                    if (isImportEqualsDeclaration(importStatement) && isExternalModuleReference(importStatement.moduleReference)) {
                        const expr = importStatement.moduleReference.expression;
                        if (isStringLiteralLike(expr) && expr.text === typeName) return void 0;
                    } else if (isImportDeclaration(importStatement) && isStringLiteral(importStatement.moduleSpecifier) && importStatement.moduleSpecifier.text === typeName) return void 0;
                }
                return {
                    fileName: typeName,
                    pos: -1,
                    end: -1,
                    ...mode ? {
                        resolutionMode: mode
                    } : void 0
                };
            }
            function mapReferencesIntoArray(references2, outputFilePath2) {
                return (file)=>{
                    let declFileName;
                    if (file.isDeclarationFile) declFileName = file.fileName;
                    else {
                        if (isBundledEmit && contains(node.sourceFiles, file)) return;
                        const paths = getOutputPathsFor(file, host, /*forceDtsPaths*/ true);
                        declFileName = paths.declarationFilePath || paths.jsFilePath || file.fileName;
                    }
                    if (declFileName) {
                        const specifier = getModuleSpecifier(options, currentSourceFile, toPath(outputFilePath2, host.getCurrentDirectory(), host.getCanonicalFileName), toPath(declFileName, host.getCurrentDirectory(), host.getCanonicalFileName), host);
                        if (!pathIsRelative(specifier)) {
                            recordTypeReferenceDirectivesIfNecessary([
                                [
                                    specifier,
                                    /*mode*/ void 0
                                ]
                            ]);
                            return;
                        }
                        let fileName = getRelativePathToDirectoryOrUrl(outputFilePath2, declFileName, host.getCurrentDirectory(), host.getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
                        if (startsWith(fileName, "./") && hasExtension(fileName)) fileName = fileName.substring(2);
                        if (startsWith(fileName, "node_modules/") || pathContainsNodeModules(fileName)) return;
                        references2.push({
                            pos: -1,
                            end: -1,
                            fileName: fileName
                        });
                    }
                };
            }
        }
        function collectReferences(sourceFile, ret) {
            if (noResolve || !isUnparsedSource(sourceFile) && isSourceFileJS(sourceFile)) return ret;
            forEach(sourceFile.referencedFiles, (f)=>{
                const elem = host.getSourceFileFromReference(sourceFile, f);
                if (elem) ret.set(getOriginalNodeId(elem), elem);
            });
            return ret;
        }
        function collectLibs(sourceFile, ret) {
            forEach(sourceFile.libReferenceDirectives, (ref)=>{
                const lib = host.getLibFileFromReference(ref);
                if (lib) ret.set(toFileNameLowerCase(ref.fileName), true);
            });
            return ret;
        }
        function filterBindingPatternInitializersAndRenamings(name) {
            if (name.kind === 80 /* Identifier */ ) return name;
            else {
                if (name.kind === 206 /* ArrayBindingPattern */ ) return factory2.updateArrayBindingPattern(name, visitNodes2(name.elements, visitBindingElement, isArrayBindingElement));
                else return factory2.updateObjectBindingPattern(name, visitNodes2(name.elements, visitBindingElement, isBindingElement));
            }
            function visitBindingElement(elem) {
                if (elem.kind === 231 /* OmittedExpression */ ) return elem;
                if (elem.propertyName && isIdentifier(elem.propertyName) && isIdentifier(elem.name) && !elem.symbol.isReferenced && !isIdentifierANonContextualKeyword(elem.propertyName)) return factory2.updateBindingElement(elem, elem.dotDotDotToken, /*propertyName*/ void 0, elem.propertyName, shouldPrintWithInitializer(elem) ? elem.initializer : void 0);
                return factory2.updateBindingElement(elem, elem.dotDotDotToken, elem.propertyName, filterBindingPatternInitializersAndRenamings(elem.name), shouldPrintWithInitializer(elem) ? elem.initializer : void 0);
            }
        }
        function ensureParameter(p, modifierMask, type) {
            let oldDiag;
            if (!suppressNewDiagnosticContexts) {
                oldDiag = getSymbolAccessibilityDiagnostic;
                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(p);
            }
            const newParam = factory2.updateParameterDeclaration(p, maskModifiers(factory2, p, modifierMask), p.dotDotDotToken, filterBindingPatternInitializersAndRenamings(p.name), resolver.isOptionalParameter(p) ? p.questionToken || factory2.createToken(58 /* QuestionToken */ ) : void 0, ensureType(p, type || p.type, /*ignorePrivate*/ true), // Ignore private param props, since this type is going straight back into a param
            ensureNoInitializer(p));
            if (!suppressNewDiagnosticContexts) getSymbolAccessibilityDiagnostic = oldDiag;
            return newParam;
        }
        function shouldPrintWithInitializer(node) {
            return canHaveLiteralInitializer(node) && resolver.isLiteralConstDeclaration(getParseTreeNode(node));
        }
        function ensureNoInitializer(node) {
            if (shouldPrintWithInitializer(node)) return resolver.createLiteralConstValue(getParseTreeNode(node), symbolTracker);
            return void 0;
        }
        function ensureType(node, type, ignorePrivate) {
            if (!ignorePrivate && hasEffectiveModifier(node, 8 /* Private */ )) return;
            if (shouldPrintWithInitializer(node)) return;
            const shouldUseResolverType = node.kind === 168 /* Parameter */  && (resolver.isRequiredInitializedParameter(node) || resolver.isOptionalUninitializedParameterProperty(node));
            if (type && !shouldUseResolverType) return visitNode(type, visitDeclarationSubtree, isTypeNode);
            if (!getParseTreeNode(node)) return type ? visitNode(type, visitDeclarationSubtree, isTypeNode) : factory2.createKeywordTypeNode(133 /* AnyKeyword */ );
            if (node.kind === 177 /* SetAccessor */ ) return factory2.createKeywordTypeNode(133 /* AnyKeyword */ );
            errorNameNode = node.name;
            let oldDiag;
            if (!suppressNewDiagnosticContexts) {
                oldDiag = getSymbolAccessibilityDiagnostic;
                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(node);
            }
            if (node.kind === 259 /* VariableDeclaration */  || node.kind === 207 /* BindingElement */ ) return cleanup(resolver.createTypeOfDeclaration(node, enclosingDeclaration, declarationEmitNodeBuilderFlags, symbolTracker));
            if (node.kind === 168 /* Parameter */  || node.kind === 171 /* PropertyDeclaration */  || node.kind === 170 /* PropertySignature */ ) {
                if (isPropertySignature(node) || !node.initializer) return cleanup(resolver.createTypeOfDeclaration(node, enclosingDeclaration, declarationEmitNodeBuilderFlags, symbolTracker, shouldUseResolverType));
                return cleanup(resolver.createTypeOfDeclaration(node, enclosingDeclaration, declarationEmitNodeBuilderFlags, symbolTracker, shouldUseResolverType) || resolver.createTypeOfExpression(node.initializer, enclosingDeclaration, declarationEmitNodeBuilderFlags, symbolTracker));
            }
            return cleanup(resolver.createReturnTypeOfSignatureDeclaration(node, enclosingDeclaration, declarationEmitNodeBuilderFlags, symbolTracker));
            function cleanup(returnValue) {
                errorNameNode = void 0;
                if (!suppressNewDiagnosticContexts) getSymbolAccessibilityDiagnostic = oldDiag;
                return returnValue || factory2.createKeywordTypeNode(133 /* AnyKeyword */ );
            }
        }
        function isDeclarationAndNotVisible(node) {
            node = getParseTreeNode(node);
            switch(node.kind){
                case 261 /* FunctionDeclaration */ :
                case 266 /* ModuleDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                case 262 /* ClassDeclaration */ :
                case 264 /* TypeAliasDeclaration */ :
                case 265 /* EnumDeclaration */ :
                    return !resolver.isDeclarationVisible(node);
                case 259 /* VariableDeclaration */ :
                    return !getBindingNameVisible(node);
                case 270 /* ImportEqualsDeclaration */ :
                case 271 /* ImportDeclaration */ :
                case 277 /* ExportDeclaration */ :
                case 276 /* ExportAssignment */ :
                    return false;
                case 174 /* ClassStaticBlockDeclaration */ :
                    return true;
            }
            return false;
        }
        function shouldEmitFunctionProperties(input) {
            var _a;
            if (input.body) return true;
            const overloadSignatures = (_a = input.symbol.declarations) == null ? void 0 : _a.filter((decl)=>isFunctionDeclaration(decl) && !decl.body);
            return !overloadSignatures || overloadSignatures.indexOf(input) === overloadSignatures.length - 1;
        }
        function getBindingNameVisible(elem) {
            if (isOmittedExpression(elem)) return false;
            if (isBindingPattern(elem.name)) return some(elem.name.elements, getBindingNameVisible);
            else return resolver.isDeclarationVisible(elem);
        }
        function updateParamsList(node, params, modifierMask) {
            if (hasEffectiveModifier(node, 8 /* Private */ )) return factory2.createNodeArray();
            const newParams = map(params, (p)=>ensureParameter(p, modifierMask));
            if (!newParams) return factory2.createNodeArray();
            return factory2.createNodeArray(newParams, params.hasTrailingComma);
        }
        function updateAccessorParamsList(input, isPrivate) {
            let newParams;
            if (!isPrivate) {
                const thisParameter = getThisParameter(input);
                if (thisParameter) newParams = [
                    ensureParameter(thisParameter)
                ];
            }
            if (isSetAccessorDeclaration(input)) {
                let newValueParameter;
                if (!isPrivate) {
                    const valueParameter = getSetAccessorValueParameter(input);
                    if (valueParameter) {
                        const accessorType = getTypeAnnotationFromAllAccessorDeclarations(input, resolver.getAllAccessorDeclarations(input));
                        newValueParameter = ensureParameter(valueParameter, /*modifierMask*/ void 0, accessorType);
                    }
                }
                if (!newValueParameter) newValueParameter = factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "value");
                newParams = append(newParams, newValueParameter);
            }
            return factory2.createNodeArray(newParams || emptyArray);
        }
        function ensureTypeParams(node, params) {
            return hasEffectiveModifier(node, 8 /* Private */ ) ? void 0 : visitNodes2(params, visitDeclarationSubtree, isTypeParameterDeclaration);
        }
        function isEnclosingDeclaration(node) {
            return isSourceFile(node) || isTypeAliasDeclaration(node) || isModuleDeclaration(node) || isClassDeclaration(node) || isInterfaceDeclaration(node) || isFunctionLike(node) || isIndexSignatureDeclaration(node) || isMappedTypeNode(node);
        }
        function checkEntityNameVisibility(entityName, enclosingDeclaration2) {
            const visibilityResult = resolver.isEntityNameVisible(entityName, enclosingDeclaration2);
            handleSymbolAccessibilityError(visibilityResult);
            recordTypeReferenceDirectivesIfNecessary(resolver.getTypeReferenceDirectivesForEntityName(entityName));
        }
        function preserveJsDoc(updated, original) {
            if (hasJSDocNodes(updated) && hasJSDocNodes(original)) updated.jsDoc = original.jsDoc;
            return setCommentRange(updated, getCommentRange(original));
        }
        function rewriteModuleSpecifier(parent2, input) {
            if (!input) return void 0;
            resultHasExternalModuleIndicator = resultHasExternalModuleIndicator || parent2.kind !== 266 /* ModuleDeclaration */  && parent2.kind !== 204 /* ImportType */ ;
            if (isStringLiteralLike(input)) {
                if (isBundledEmit) {
                    const newName = getExternalModuleNameFromDeclaration(context.getEmitHost(), resolver, parent2);
                    if (newName) return factory2.createStringLiteral(newName);
                } else {
                    const symbol = resolver.getSymbolOfExternalModuleSpecifier(input);
                    if (symbol) (exportedModulesFromDeclarationEmit || (exportedModulesFromDeclarationEmit = [])).push(symbol);
                }
            }
            return input;
        }
        function transformImportEqualsDeclaration(decl) {
            if (!resolver.isDeclarationVisible(decl)) return;
            if (decl.moduleReference.kind === 282 /* ExternalModuleReference */ ) {
                const specifier = getExternalModuleImportEqualsDeclarationExpression(decl);
                return factory2.updateImportEqualsDeclaration(decl, decl.modifiers, decl.isTypeOnly, decl.name, factory2.updateExternalModuleReference(decl.moduleReference, rewriteModuleSpecifier(decl, specifier)));
            } else {
                const oldDiag = getSymbolAccessibilityDiagnostic;
                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(decl);
                checkEntityNameVisibility(decl.moduleReference, enclosingDeclaration);
                getSymbolAccessibilityDiagnostic = oldDiag;
                return decl;
            }
        }
        function transformImportDeclaration(decl) {
            if (!decl.importClause) return factory2.updateImportDeclaration(decl, decl.modifiers, decl.importClause, rewriteModuleSpecifier(decl, decl.moduleSpecifier), getResolutionModeOverrideForClauseInNightly(decl.assertClause));
            const visibleDefaultBinding = decl.importClause && decl.importClause.name && resolver.isDeclarationVisible(decl.importClause) ? decl.importClause.name : void 0;
            if (!decl.importClause.namedBindings) return visibleDefaultBinding && factory2.updateImportDeclaration(decl, decl.modifiers, factory2.updateImportClause(decl.importClause, decl.importClause.isTypeOnly, visibleDefaultBinding, /*namedBindings*/ void 0), rewriteModuleSpecifier(decl, decl.moduleSpecifier), getResolutionModeOverrideForClauseInNightly(decl.assertClause));
            if (decl.importClause.namedBindings.kind === 273 /* NamespaceImport */ ) {
                const namedBindings = resolver.isDeclarationVisible(decl.importClause.namedBindings) ? decl.importClause.namedBindings : /*namedBindings*/ void 0;
                return visibleDefaultBinding || namedBindings ? factory2.updateImportDeclaration(decl, decl.modifiers, factory2.updateImportClause(decl.importClause, decl.importClause.isTypeOnly, visibleDefaultBinding, namedBindings), rewriteModuleSpecifier(decl, decl.moduleSpecifier), getResolutionModeOverrideForClauseInNightly(decl.assertClause)) : void 0;
            }
            const bindingList = mapDefined(decl.importClause.namedBindings.elements, (b)=>resolver.isDeclarationVisible(b) ? b : void 0);
            if (bindingList && bindingList.length || visibleDefaultBinding) return factory2.updateImportDeclaration(decl, decl.modifiers, factory2.updateImportClause(decl.importClause, decl.importClause.isTypeOnly, visibleDefaultBinding, bindingList && bindingList.length ? factory2.updateNamedImports(decl.importClause.namedBindings, bindingList) : void 0), rewriteModuleSpecifier(decl, decl.moduleSpecifier), getResolutionModeOverrideForClauseInNightly(decl.assertClause));
            if (resolver.isImportRequiredByAugmentation(decl)) return factory2.updateImportDeclaration(decl, decl.modifiers, /*importClause*/ void 0, rewriteModuleSpecifier(decl, decl.moduleSpecifier), getResolutionModeOverrideForClauseInNightly(decl.assertClause));
        }
        function getResolutionModeOverrideForClauseInNightly(assertClause) {
            const mode = getResolutionModeOverrideForClause(assertClause);
            if (mode !== void 0) {
                if (!isNightly()) context.addDiagnostic(createDiagnosticForNode(assertClause, Diagnostics.resolution_mode_assertions_are_unstable_Use_nightly_TypeScript_to_silence_this_error_Try_updating_with_npm_install_D_typescript_next));
                return assertClause;
            }
            return void 0;
        }
        function transformAndReplaceLatePaintedStatements(statements) {
            while(length(lateMarkedStatements)){
                const i = lateMarkedStatements.shift();
                if (!isLateVisibilityPaintedStatement(i)) return Debug.fail(`Late replaced statement was found which is not handled by the declaration transformer!: ${Debug.formatSyntaxKind(i.kind)}`);
                const priorNeedsDeclare = needsDeclare;
                needsDeclare = i.parent && isSourceFile(i.parent) && !(isExternalModule(i.parent) && isBundledEmit);
                const result = transformTopLevelDeclaration(i);
                needsDeclare = priorNeedsDeclare;
                lateStatementReplacementMap.set(getOriginalNodeId(i), result);
            }
            return visitNodes2(statements, visitLateVisibilityMarkedStatements, isStatement);
            function visitLateVisibilityMarkedStatements(statement) {
                if (isLateVisibilityPaintedStatement(statement)) {
                    const key = getOriginalNodeId(statement);
                    if (lateStatementReplacementMap.has(key)) {
                        const result = lateStatementReplacementMap.get(key);
                        lateStatementReplacementMap.delete(key);
                        if (result) {
                            if (isArray(result) ? some(result, needsScopeMarker) : needsScopeMarker(result)) needsScopeFixMarker = true;
                            if (isSourceFile(statement.parent) && (isArray(result) ? some(result, isExternalModuleIndicator) : isExternalModuleIndicator(result))) resultHasExternalModuleIndicator = true;
                        }
                        return result;
                    }
                }
                return statement;
            }
        }
        function visitDeclarationSubtree(input) {
            if (shouldStripInternal(input)) return;
            if (isDeclaration(input)) {
                if (isDeclarationAndNotVisible(input)) return;
                if (hasDynamicName(input) && !resolver.isLateBound(getParseTreeNode(input))) return;
            }
            if (isFunctionLike(input) && resolver.isImplementationOfOverload(input)) return;
            if (isSemicolonClassElement(input)) return;
            let previousEnclosingDeclaration;
            if (isEnclosingDeclaration(input)) {
                previousEnclosingDeclaration = enclosingDeclaration;
                enclosingDeclaration = input;
            }
            const oldDiag = getSymbolAccessibilityDiagnostic;
            const canProduceDiagnostic = canProduceDiagnostics(input);
            const oldWithinObjectLiteralType = suppressNewDiagnosticContexts;
            let shouldEnterSuppressNewDiagnosticsContextContext = (input.kind === 186 /* TypeLiteral */  || input.kind === 199 /* MappedType */ ) && input.parent.kind !== 264 /* TypeAliasDeclaration */ ;
            if (isMethodDeclaration(input) || isMethodSignature(input)) {
                if (hasEffectiveModifier(input, 8 /* Private */ )) {
                    if (input.symbol && input.symbol.declarations && input.symbol.declarations[0] !== input) return;
                    return cleanup(factory2.createPropertyDeclaration(ensureModifiers(input), input.name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0));
                }
            }
            if (canProduceDiagnostic && !suppressNewDiagnosticContexts) getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(input);
            if (isTypeQueryNode(input)) checkEntityNameVisibility(input.exprName, enclosingDeclaration);
            if (shouldEnterSuppressNewDiagnosticsContextContext) suppressNewDiagnosticContexts = true;
            if (isProcessedComponent(input)) switch(input.kind){
                case 232 /* ExpressionWithTypeArguments */ :
                    {
                        if (isEntityName(input.expression) || isEntityNameExpression(input.expression)) checkEntityNameVisibility(input.expression, enclosingDeclaration);
                        const node = visitEachChild(input, visitDeclarationSubtree, context);
                        return cleanup(factory2.updateExpressionWithTypeArguments(node, node.expression, node.typeArguments));
                    }
                case 182 /* TypeReference */ :
                    {
                        checkEntityNameVisibility(input.typeName, enclosingDeclaration);
                        const node = visitEachChild(input, visitDeclarationSubtree, context);
                        return cleanup(factory2.updateTypeReferenceNode(node, node.typeName, node.typeArguments));
                    }
                case 179 /* ConstructSignature */ :
                    return cleanup(factory2.updateConstructSignature(input, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input, input.type)));
                case 175 /* Constructor */ :
                    {
                        const ctor = factory2.createConstructorDeclaration(/*modifiers*/ ensureModifiers(input), updateParamsList(input, input.parameters, 0 /* None */ ), /*body*/ void 0);
                        return cleanup(ctor);
                    }
                case 173 /* MethodDeclaration */ :
                    {
                        if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                        const sig = factory2.createMethodDeclaration(ensureModifiers(input), /*asteriskToken*/ void 0, input.name, input.questionToken, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input, input.type), /*body*/ void 0);
                        return cleanup(sig);
                    }
                case 176 /* GetAccessor */ :
                    {
                        if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                        const accessorType = getTypeAnnotationFromAllAccessorDeclarations(input, resolver.getAllAccessorDeclarations(input));
                        return cleanup(factory2.updateGetAccessorDeclaration(input, ensureModifiers(input), input.name, updateAccessorParamsList(input, hasEffectiveModifier(input, 8 /* Private */ )), ensureType(input, accessorType), /*body*/ void 0));
                    }
                case 177 /* SetAccessor */ :
                    if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                    return cleanup(factory2.updateSetAccessorDeclaration(input, ensureModifiers(input), input.name, updateAccessorParamsList(input, hasEffectiveModifier(input, 8 /* Private */ )), /*body*/ void 0));
                case 171 /* PropertyDeclaration */ :
                    if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                    return cleanup(factory2.updatePropertyDeclaration(input, ensureModifiers(input), input.name, input.questionToken, ensureType(input, input.type), ensureNoInitializer(input)));
                case 170 /* PropertySignature */ :
                    if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                    return cleanup(factory2.updatePropertySignature(input, ensureModifiers(input), input.name, input.questionToken, ensureType(input, input.type)));
                case 172 /* MethodSignature */ :
                    if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                    return cleanup(factory2.updateMethodSignature(input, ensureModifiers(input), input.name, input.questionToken, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input, input.type)));
                case 178 /* CallSignature */ :
                    return cleanup(factory2.updateCallSignature(input, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input, input.type)));
                case 180 /* IndexSignature */ :
                    return cleanup(factory2.updateIndexSignature(input, ensureModifiers(input), updateParamsList(input, input.parameters), visitNode(input.type, visitDeclarationSubtree, isTypeNode) || factory2.createKeywordTypeNode(133 /* AnyKeyword */ )));
                case 259 /* VariableDeclaration */ :
                    if (isBindingPattern(input.name)) return recreateBindingPattern(input.name);
                    shouldEnterSuppressNewDiagnosticsContextContext = true;
                    suppressNewDiagnosticContexts = true;
                    return cleanup(factory2.updateVariableDeclaration(input, input.name, /*exclamationToken*/ void 0, ensureType(input, input.type), ensureNoInitializer(input)));
                case 167 /* TypeParameter */ :
                    if (isPrivateMethodTypeParameter(input) && (input.default || input.constraint)) return cleanup(factory2.updateTypeParameterDeclaration(input, input.modifiers, input.name, /*constraint*/ void 0, /*defaultType*/ void 0));
                    return cleanup(visitEachChild(input, visitDeclarationSubtree, context));
                case 193 /* ConditionalType */ :
                    {
                        const checkType = visitNode(input.checkType, visitDeclarationSubtree, isTypeNode);
                        const extendsType = visitNode(input.extendsType, visitDeclarationSubtree, isTypeNode);
                        const oldEnclosingDecl = enclosingDeclaration;
                        enclosingDeclaration = input.trueType;
                        const trueType = visitNode(input.trueType, visitDeclarationSubtree, isTypeNode);
                        enclosingDeclaration = oldEnclosingDecl;
                        const falseType = visitNode(input.falseType, visitDeclarationSubtree, isTypeNode);
                        Debug.assert(checkType);
                        Debug.assert(extendsType);
                        Debug.assert(trueType);
                        Debug.assert(falseType);
                        return cleanup(factory2.updateConditionalTypeNode(input, checkType, extendsType, trueType, falseType));
                    }
                case 183 /* FunctionType */ :
                    return cleanup(factory2.updateFunctionTypeNode(input, visitNodes2(input.typeParameters, visitDeclarationSubtree, isTypeParameterDeclaration), updateParamsList(input, input.parameters), Debug.checkDefined(visitNode(input.type, visitDeclarationSubtree, isTypeNode))));
                case 184 /* ConstructorType */ :
                    return cleanup(factory2.updateConstructorTypeNode(input, ensureModifiers(input), visitNodes2(input.typeParameters, visitDeclarationSubtree, isTypeParameterDeclaration), updateParamsList(input, input.parameters), Debug.checkDefined(visitNode(input.type, visitDeclarationSubtree, isTypeNode))));
                case 204 /* ImportType */ :
                    if (!isLiteralImportTypeNode(input)) return cleanup(input);
                    return cleanup(factory2.updateImportTypeNode(input, factory2.updateLiteralTypeNode(input.argument, rewriteModuleSpecifier(input, input.argument.literal)), input.assertions, input.qualifier, visitNodes2(input.typeArguments, visitDeclarationSubtree, isTypeNode), input.isTypeOf));
                default:
                    Debug.assertNever(input, `Attempted to process unhandled node kind: ${Debug.formatSyntaxKind(input.kind)}`);
            }
            if (isTupleTypeNode(input) && getLineAndCharacterOfPosition(currentSourceFile, input.pos).line === getLineAndCharacterOfPosition(currentSourceFile, input.end).line) setEmitFlags(input, 1 /* SingleLine */ );
            return cleanup(visitEachChild(input, visitDeclarationSubtree, context));
            function cleanup(returnValue) {
                if (returnValue && canProduceDiagnostic && hasDynamicName(input)) checkName(input);
                if (isEnclosingDeclaration(input)) enclosingDeclaration = previousEnclosingDeclaration;
                if (canProduceDiagnostic && !suppressNewDiagnosticContexts) getSymbolAccessibilityDiagnostic = oldDiag;
                if (shouldEnterSuppressNewDiagnosticsContextContext) suppressNewDiagnosticContexts = oldWithinObjectLiteralType;
                if (returnValue === input) return returnValue;
                return returnValue && setOriginalNode(preserveJsDoc(returnValue, input), input);
            }
        }
        function isPrivateMethodTypeParameter(node) {
            return node.parent.kind === 173 /* MethodDeclaration */  && hasEffectiveModifier(node.parent, 8 /* Private */ );
        }
        function visitDeclarationStatements(input) {
            if (!isPreservedDeclarationStatement(input)) return;
            if (shouldStripInternal(input)) return;
            switch(input.kind){
                case 277 /* ExportDeclaration */ :
                    if (isSourceFile(input.parent)) resultHasExternalModuleIndicator = true;
                    resultHasScopeMarker = true;
                    return factory2.updateExportDeclaration(input, input.modifiers, input.isTypeOnly, input.exportClause, rewriteModuleSpecifier(input, input.moduleSpecifier), getResolutionModeOverrideForClause(input.assertClause) ? input.assertClause : void 0);
                case 276 /* ExportAssignment */ :
                    if (isSourceFile(input.parent)) resultHasExternalModuleIndicator = true;
                    resultHasScopeMarker = true;
                    if (input.expression.kind === 80 /* Identifier */ ) return input;
                    else {
                        const newId = factory2.createUniqueName("_default", 16 /* Optimistic */ );
                        getSymbolAccessibilityDiagnostic = ()=>({
                                diagnosticMessage: Diagnostics.Default_export_of_the_module_has_or_is_using_private_name_0,
                                errorNode: input
                            });
                        errorFallbackNode = input;
                        const varDecl = factory2.createVariableDeclaration(newId, /*exclamationToken*/ void 0, resolver.createTypeOfExpression(input.expression, input, declarationEmitNodeBuilderFlags, symbolTracker), /*initializer*/ void 0);
                        errorFallbackNode = void 0;
                        const statement = factory2.createVariableStatement(needsDeclare ? [
                            factory2.createModifier(138 /* DeclareKeyword */ )
                        ] : [], factory2.createVariableDeclarationList([
                            varDecl
                        ], 2 /* Const */ ));
                        preserveJsDoc(statement, input);
                        removeAllComments(input);
                        return [
                            statement,
                            factory2.updateExportAssignment(input, input.modifiers, newId)
                        ];
                    }
            }
            const result = transformTopLevelDeclaration(input);
            lateStatementReplacementMap.set(getOriginalNodeId(input), result);
            return input;
        }
        function stripExportModifiers(statement) {
            if (isImportEqualsDeclaration(statement) || hasEffectiveModifier(statement, 1024 /* Default */ ) || !canHaveModifiers(statement)) return statement;
            const modifiers = factory2.createModifiersFromModifierFlags(getEffectiveModifierFlags(statement) & 258046 /* Export */ );
            return factory2.updateModifiers(statement, modifiers);
        }
        function transformTopLevelDeclaration(input) {
            if (lateMarkedStatements) {
                while(orderedRemoveItem(lateMarkedStatements, input));
            }
            if (shouldStripInternal(input)) return;
            switch(input.kind){
                case 270 /* ImportEqualsDeclaration */ :
                    return transformImportEqualsDeclaration(input);
                case 271 /* ImportDeclaration */ :
                    return transformImportDeclaration(input);
            }
            if (isDeclaration(input) && isDeclarationAndNotVisible(input)) return;
            if (isFunctionLike(input) && resolver.isImplementationOfOverload(input)) return;
            let previousEnclosingDeclaration;
            if (isEnclosingDeclaration(input)) {
                previousEnclosingDeclaration = enclosingDeclaration;
                enclosingDeclaration = input;
            }
            const canProdiceDiagnostic = canProduceDiagnostics(input);
            const oldDiag = getSymbolAccessibilityDiagnostic;
            if (canProdiceDiagnostic) getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(input);
            const previousNeedsDeclare = needsDeclare;
            switch(input.kind){
                case 264 /* TypeAliasDeclaration */ :
                    {
                        needsDeclare = false;
                        const clean2 = cleanup(factory2.updateTypeAliasDeclaration(input, ensureModifiers(input), input.name, visitNodes2(input.typeParameters, visitDeclarationSubtree, isTypeParameterDeclaration), Debug.checkDefined(visitNode(input.type, visitDeclarationSubtree, isTypeNode))));
                        needsDeclare = previousNeedsDeclare;
                        return clean2;
                    }
                case 263 /* InterfaceDeclaration */ :
                    return cleanup(factory2.updateInterfaceDeclaration(input, ensureModifiers(input), input.name, ensureTypeParams(input, input.typeParameters), transformHeritageClauses(input.heritageClauses), visitNodes2(input.members, visitDeclarationSubtree, isTypeElement)));
                case 261 /* FunctionDeclaration */ :
                    {
                        const clean2 = cleanup(factory2.updateFunctionDeclaration(input, ensureModifiers(input), /*asteriskToken*/ void 0, input.name, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input, input.type), /*body*/ void 0));
                        if (clean2 && resolver.isExpandoFunctionDeclaration(input) && shouldEmitFunctionProperties(input)) {
                            const props = resolver.getPropertiesOfContainerFunction(input);
                            const fakespace = parseNodeFactory.createModuleDeclaration(/*modifiers*/ void 0, clean2.name || factory2.createIdentifier("_default"), factory2.createModuleBlock([]), 16 /* Namespace */ );
                            setParent(fakespace, enclosingDeclaration);
                            fakespace.locals = createSymbolTable(props);
                            fakespace.symbol = props[0].parent;
                            const exportMappings = [];
                            let declarations = mapDefined(props, (p)=>{
                                if (!p.valueDeclaration || !(isPropertyAccessExpression(p.valueDeclaration) || isElementAccessExpression(p.valueDeclaration) || isBinaryExpression(p.valueDeclaration))) return void 0;
                                const nameStr = unescapeLeadingUnderscores(p.escapedName);
                                if (!isIdentifierText(nameStr, 99 /* ESNext */ )) return void 0;
                                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(p.valueDeclaration);
                                const type = resolver.createTypeOfDeclaration(p.valueDeclaration, fakespace, declarationEmitNodeBuilderFlags, symbolTracker);
                                getSymbolAccessibilityDiagnostic = oldDiag;
                                const isNonContextualKeywordName = isStringANonContextualKeyword(nameStr);
                                const name = isNonContextualKeywordName ? factory2.getGeneratedNameForNode(p.valueDeclaration) : factory2.createIdentifier(nameStr);
                                if (isNonContextualKeywordName) exportMappings.push([
                                    name,
                                    nameStr
                                ]);
                                const varDecl = factory2.createVariableDeclaration(name, /*exclamationToken*/ void 0, type, /*initializer*/ void 0);
                                return factory2.createVariableStatement(isNonContextualKeywordName ? void 0 : [
                                    factory2.createToken(95 /* ExportKeyword */ )
                                ], factory2.createVariableDeclarationList([
                                    varDecl
                                ]));
                            });
                            if (!exportMappings.length) declarations = mapDefined(declarations, (declaration)=>factory2.updateModifiers(declaration, 0 /* None */ ));
                            else declarations.push(factory2.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory2.createNamedExports(map(exportMappings, ([gen, exp])=>{
                                return factory2.createExportSpecifier(/*isTypeOnly*/ false, gen, exp);
                            }))));
                            const namespaceDecl = factory2.createModuleDeclaration(ensureModifiers(input), input.name, factory2.createModuleBlock(declarations), 16 /* Namespace */ );
                            if (!hasEffectiveModifier(clean2, 1024 /* Default */ )) return [
                                clean2,
                                namespaceDecl
                            ];
                            const modifiers = factory2.createModifiersFromModifierFlags(getEffectiveModifierFlags(clean2) & -1026 /* ExportDefault */  | 2 /* Ambient */ );
                            const cleanDeclaration = factory2.updateFunctionDeclaration(clean2, modifiers, /*asteriskToken*/ void 0, clean2.name, clean2.typeParameters, clean2.parameters, clean2.type, /*body*/ void 0);
                            const namespaceDeclaration = factory2.updateModuleDeclaration(namespaceDecl, modifiers, namespaceDecl.name, namespaceDecl.body);
                            const exportDefaultDeclaration = factory2.createExportAssignment(/*modifiers*/ void 0, /*isExportEquals*/ false, namespaceDecl.name);
                            if (isSourceFile(input.parent)) resultHasExternalModuleIndicator = true;
                            resultHasScopeMarker = true;
                            return [
                                cleanDeclaration,
                                namespaceDeclaration,
                                exportDefaultDeclaration
                            ];
                        } else return clean2;
                    }
                case 266 /* ModuleDeclaration */ :
                    {
                        needsDeclare = false;
                        const inner = input.body;
                        if (inner && inner.kind === 267 /* ModuleBlock */ ) {
                            const oldNeedsScopeFix = needsScopeFixMarker;
                            const oldHasScopeFix = resultHasScopeMarker;
                            resultHasScopeMarker = false;
                            needsScopeFixMarker = false;
                            const statements = visitNodes2(inner.statements, visitDeclarationStatements, isStatement);
                            let lateStatements = transformAndReplaceLatePaintedStatements(statements);
                            if (input.flags & 16777216 /* Ambient */ ) needsScopeFixMarker = false;
                            if (!isGlobalScopeAugmentation(input) && !hasScopeMarker2(lateStatements) && !resultHasScopeMarker) {
                                if (needsScopeFixMarker) lateStatements = factory2.createNodeArray([
                                    ...lateStatements,
                                    createEmptyExports(factory2)
                                ]);
                                else lateStatements = visitNodes2(lateStatements, stripExportModifiers, isStatement);
                            }
                            const body = factory2.updateModuleBlock(inner, lateStatements);
                            needsDeclare = previousNeedsDeclare;
                            needsScopeFixMarker = oldNeedsScopeFix;
                            resultHasScopeMarker = oldHasScopeFix;
                            const mods = ensureModifiers(input);
                            return cleanup(factory2.updateModuleDeclaration(input, mods, isExternalModuleAugmentation(input) ? rewriteModuleSpecifier(input, input.name) : input.name, body));
                        } else {
                            needsDeclare = previousNeedsDeclare;
                            const mods = ensureModifiers(input);
                            needsDeclare = false;
                            visitNode(inner, visitDeclarationStatements);
                            const id = getOriginalNodeId(inner);
                            const body = lateStatementReplacementMap.get(id);
                            lateStatementReplacementMap.delete(id);
                            return cleanup(factory2.updateModuleDeclaration(input, mods, input.name, body));
                        }
                    }
                case 262 /* ClassDeclaration */ :
                    {
                        errorNameNode = input.name;
                        errorFallbackNode = input;
                        const modifiers = factory2.createNodeArray(ensureModifiers(input));
                        const typeParameters = ensureTypeParams(input, input.typeParameters);
                        const ctor = getFirstConstructorWithBody(input);
                        let parameterProperties;
                        if (ctor) {
                            const oldDiag2 = getSymbolAccessibilityDiagnostic;
                            parameterProperties = compact(flatMap(ctor.parameters, (param)=>{
                                if (!hasSyntacticModifier(param, 16476 /* ParameterPropertyModifier */ ) || shouldStripInternal(param)) return;
                                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(param);
                                if (param.name.kind === 80 /* Identifier */ ) return preserveJsDoc(factory2.createPropertyDeclaration(ensureModifiers(param), param.name, param.questionToken, ensureType(param, param.type), ensureNoInitializer(param)), param);
                                else return walkBindingPattern(param.name);
                                function walkBindingPattern(pattern) {
                                    let elems;
                                    for (const elem of pattern.elements){
                                        if (isOmittedExpression(elem)) continue;
                                        if (isBindingPattern(elem.name)) elems = concatenate(elems, walkBindingPattern(elem.name));
                                        elems = elems || [];
                                        elems.push(factory2.createPropertyDeclaration(ensureModifiers(param), elem.name, /*questionOrExclamationToken*/ void 0, ensureType(elem, /*type*/ void 0), /*initializer*/ void 0));
                                    }
                                    return elems;
                                }
                            }));
                            getSymbolAccessibilityDiagnostic = oldDiag2;
                        }
                        const hasPrivateIdentifier = some(input.members, (member)=>!!member.name && isPrivateIdentifier(member.name));
                        const privateIdentifier = hasPrivateIdentifier ? [
                            factory2.createPropertyDeclaration(/*modifiers*/ void 0, factory2.createPrivateIdentifier("#private"), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0)
                        ] : void 0;
                        const memberNodes = concatenate(concatenate(privateIdentifier, parameterProperties), visitNodes2(input.members, visitDeclarationSubtree, isClassElement));
                        const members = factory2.createNodeArray(memberNodes);
                        const extendsClause = getEffectiveBaseTypeNode(input);
                        if (extendsClause && !isEntityNameExpression(extendsClause.expression) && extendsClause.expression.kind !== 106 /* NullKeyword */ ) {
                            const oldId = input.name ? unescapeLeadingUnderscores(input.name.escapedText) : "default";
                            const newId = factory2.createUniqueName(`${oldId}_base`, 16 /* Optimistic */ );
                            getSymbolAccessibilityDiagnostic = ()=>({
                                    diagnosticMessage: Diagnostics.extends_clause_of_exported_class_0_has_or_is_using_private_name_1,
                                    errorNode: extendsClause,
                                    typeName: input.name
                                });
                            const varDecl = factory2.createVariableDeclaration(newId, /*exclamationToken*/ void 0, resolver.createTypeOfExpression(extendsClause.expression, input, declarationEmitNodeBuilderFlags, symbolTracker), /*initializer*/ void 0);
                            const statement = factory2.createVariableStatement(needsDeclare ? [
                                factory2.createModifier(138 /* DeclareKeyword */ )
                            ] : [], factory2.createVariableDeclarationList([
                                varDecl
                            ], 2 /* Const */ ));
                            const heritageClauses = factory2.createNodeArray(map(input.heritageClauses, (clause)=>{
                                if (clause.token === 96 /* ExtendsKeyword */ ) {
                                    const oldDiag2 = getSymbolAccessibilityDiagnostic;
                                    getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(clause.types[0]);
                                    const newClause = factory2.updateHeritageClause(clause, map(clause.types, (t)=>factory2.updateExpressionWithTypeArguments(t, newId, visitNodes2(t.typeArguments, visitDeclarationSubtree, isTypeNode))));
                                    getSymbolAccessibilityDiagnostic = oldDiag2;
                                    return newClause;
                                }
                                return factory2.updateHeritageClause(clause, visitNodes2(factory2.createNodeArray(filter(clause.types, (t)=>isEntityNameExpression(t.expression) || t.expression.kind === 106 /* NullKeyword */ )), visitDeclarationSubtree, isExpressionWithTypeArguments));
                            }));
                            return [
                                statement,
                                cleanup(factory2.updateClassDeclaration(input, modifiers, input.name, typeParameters, heritageClauses, members))
                            ];
                        } else {
                            const heritageClauses = transformHeritageClauses(input.heritageClauses);
                            return cleanup(factory2.updateClassDeclaration(input, modifiers, input.name, typeParameters, heritageClauses, members));
                        }
                    }
                case 242 /* VariableStatement */ :
                    return cleanup(transformVariableStatement(input));
                case 265 /* EnumDeclaration */ :
                    return cleanup(factory2.updateEnumDeclaration(input, factory2.createNodeArray(ensureModifiers(input)), input.name, factory2.createNodeArray(mapDefined(input.members, (m)=>{
                        if (shouldStripInternal(m)) return;
                        const constValue = resolver.getConstantValue(m);
                        return preserveJsDoc(factory2.updateEnumMember(m, m.name, constValue !== void 0 ? typeof constValue === "string" ? factory2.createStringLiteral(constValue) : factory2.createNumericLiteral(constValue) : void 0), m);
                    }))));
            }
            return Debug.assertNever(input, `Unhandled top-level node in declaration emit: ${Debug.formatSyntaxKind(input.kind)}`);
            function cleanup(node) {
                if (isEnclosingDeclaration(input)) enclosingDeclaration = previousEnclosingDeclaration;
                if (canProdiceDiagnostic) getSymbolAccessibilityDiagnostic = oldDiag;
                if (input.kind === 266 /* ModuleDeclaration */ ) needsDeclare = previousNeedsDeclare;
                if (node === input) return node;
                errorFallbackNode = void 0;
                errorNameNode = void 0;
                return node && setOriginalNode(preserveJsDoc(node, input), input);
            }
        }
        function transformVariableStatement(input) {
            if (!forEach(input.declarationList.declarations, getBindingNameVisible)) return;
            const nodes = visitNodes2(input.declarationList.declarations, visitDeclarationSubtree, isVariableDeclaration);
            if (!length(nodes)) return;
            return factory2.updateVariableStatement(input, factory2.createNodeArray(ensureModifiers(input)), factory2.updateVariableDeclarationList(input.declarationList, nodes));
        }
        function recreateBindingPattern(d) {
            return flatten(mapDefined(d.elements, (e)=>recreateBindingElement(e)));
        }
        function recreateBindingElement(e) {
            if (e.kind === 231 /* OmittedExpression */ ) return;
            if (e.name) {
                if (!getBindingNameVisible(e)) return;
                if (isBindingPattern(e.name)) return recreateBindingPattern(e.name);
                else return factory2.createVariableDeclaration(e.name, /*exclamationToken*/ void 0, ensureType(e, /*type*/ void 0), /*initializer*/ void 0);
            }
        }
        function checkName(node) {
            let oldDiag;
            if (!suppressNewDiagnosticContexts) {
                oldDiag = getSymbolAccessibilityDiagnostic;
                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNodeName(node);
            }
            errorNameNode = node.name;
            Debug.assert(resolver.isLateBound(getParseTreeNode(node)));
            const decl = node;
            const entityName = decl.name.expression;
            checkEntityNameVisibility(entityName, enclosingDeclaration);
            if (!suppressNewDiagnosticContexts) getSymbolAccessibilityDiagnostic = oldDiag;
            errorNameNode = void 0;
        }
        function shouldStripInternal(node) {
            return !!stripInternal && !!node && isInternalDeclaration(node, currentSourceFile);
        }
        function isScopeMarker2(node) {
            return isExportAssignment(node) || isExportDeclaration(node);
        }
        function hasScopeMarker2(statements) {
            return some(statements, isScopeMarker2);
        }
        function ensureModifiers(node) {
            const currentFlags = getEffectiveModifierFlags(node);
            const newFlags = ensureModifierFlags(node);
            if (currentFlags === newFlags) return visitArray(node.modifiers, (n)=>tryCast(n, isModifier), isModifier);
            return factory2.createModifiersFromModifierFlags(newFlags);
        }
        function ensureModifierFlags(node) {
            let mask2 = 241147;
            let additions = needsDeclare && !isAlwaysType(node) ? 2 /* Ambient */  : 0 /* None */ ;
            const parentIsFile = node.parent.kind === 311 /* SourceFile */ ;
            if (!parentIsFile || isBundledEmit && parentIsFile && isExternalModule(node.parent)) {
                mask2 ^= 2 /* Ambient */ ;
                additions = 0 /* None */ ;
            }
            return maskModifierFlags(node, mask2, additions);
        }
        function getTypeAnnotationFromAllAccessorDeclarations(node, accessors) {
            let accessorType = getTypeAnnotationFromAccessor(node);
            if (!accessorType && node !== accessors.firstAccessor) {
                accessorType = getTypeAnnotationFromAccessor(accessors.firstAccessor);
                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(accessors.firstAccessor);
            }
            if (!accessorType && accessors.secondAccessor && node !== accessors.secondAccessor) {
                accessorType = getTypeAnnotationFromAccessor(accessors.secondAccessor);
                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(accessors.secondAccessor);
            }
            return accessorType;
        }
        function transformHeritageClauses(nodes) {
            return factory2.createNodeArray(filter(map(nodes, (clause)=>factory2.updateHeritageClause(clause, visitNodes2(factory2.createNodeArray(filter(clause.types, (t)=>{
                    return isEntityNameExpression(t.expression) || clause.token === 96 /* ExtendsKeyword */  && t.expression.kind === 106 /* NullKeyword */ ;
                })), visitDeclarationSubtree, isExpressionWithTypeArguments))), (clause)=>clause.types && !!clause.types.length));
        }
    }
    function isAlwaysType(node) {
        if (node.kind === 263 /* InterfaceDeclaration */ ) return true;
        return false;
    }
    function maskModifiers(factory2, node, modifierMask, modifierAdditions) {
        return factory2.createModifiersFromModifierFlags(maskModifierFlags(node, modifierMask, modifierAdditions));
    }
    function maskModifierFlags(node, modifierMask = 258043 /* Public */ , modifierAdditions = 0 /* None */ ) {
        let flags = getEffectiveModifierFlags(node) & modifierMask | modifierAdditions;
        if (flags & 1024 /* Default */  && !(flags & 1 /* Export */ )) flags ^= 1 /* Export */ ;
        if (flags & 1024 /* Default */  && flags & 2 /* Ambient */ ) flags ^= 2 /* Ambient */ ;
        return flags;
    }
    function getTypeAnnotationFromAccessor(accessor) {
        if (accessor) return accessor.kind === 176 /* GetAccessor */  ? accessor.type : accessor.parameters.length > 0 ? accessor.parameters[0].type : void 0;
    }
    function canHaveLiteralInitializer(node) {
        switch(node.kind){
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
                return !hasEffectiveModifier(node, 8 /* Private */ );
            case 168 /* Parameter */ :
            case 259 /* VariableDeclaration */ :
                return true;
        }
        return false;
    }
    function isPreservedDeclarationStatement(node) {
        switch(node.kind){
            case 261 /* FunctionDeclaration */ :
            case 266 /* ModuleDeclaration */ :
            case 270 /* ImportEqualsDeclaration */ :
            case 263 /* InterfaceDeclaration */ :
            case 262 /* ClassDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 242 /* VariableStatement */ :
            case 271 /* ImportDeclaration */ :
            case 277 /* ExportDeclaration */ :
            case 276 /* ExportAssignment */ :
                return true;
        }
        return false;
    }
    function isProcessedComponent(node) {
        switch(node.kind){
            case 179 /* ConstructSignature */ :
            case 175 /* Constructor */ :
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
            case 172 /* MethodSignature */ :
            case 178 /* CallSignature */ :
            case 180 /* IndexSignature */ :
            case 259 /* VariableDeclaration */ :
            case 167 /* TypeParameter */ :
            case 232 /* ExpressionWithTypeArguments */ :
            case 182 /* TypeReference */ :
            case 193 /* ConditionalType */ :
            case 183 /* FunctionType */ :
            case 184 /* ConstructorType */ :
            case 204 /* ImportType */ :
                return true;
        }
        return false;
    }
    var declarationEmitNodeBuilderFlags;
    var init_declarations = __esm({
        "src/compiler/transformers/declarations.ts" () {
            "use strict";
            init_ts2();
            init_ts_moduleSpecifiers();
            declarationEmitNodeBuilderFlags = 531469 /* NoTruncation */ ;
        }
    });
    // src/compiler/transformer.ts
    function getModuleTransformer(moduleKind) {
        switch(moduleKind){
            case 99 /* ESNext */ :
            case 7 /* ES2022 */ :
            case 6 /* ES2020 */ :
            case 5 /* ES2015 */ :
                return transformECMAScriptModule;
            case 4 /* System */ :
                return transformSystemModule;
            case 100 /* Node16 */ :
            case 199 /* NodeNext */ :
                return transformNodeModule;
            default:
                return transformModule;
        }
    }
    function getTransformers(compilerOptions, customTransformers, emitOnly) {
        return {
            scriptTransformers: getScriptTransformers(compilerOptions, customTransformers, emitOnly),
            declarationTransformers: getDeclarationTransformers(customTransformers)
        };
    }
    function getScriptTransformers(compilerOptions, customTransformers, emitOnly) {
        if (emitOnly) return emptyArray;
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const moduleKind = getEmitModuleKind(compilerOptions);
        const useDefineForClassFields = getUseDefineForClassFields(compilerOptions);
        const transformers = [];
        addRange(transformers, customTransformers && map(customTransformers.before, wrapScriptTransformerFactory));
        transformers.push(transformTypeScript);
        if (compilerOptions.experimentalDecorators) transformers.push(transformLegacyDecorators);
        else if (languageVersion < 99 /* ESNext */  || !useDefineForClassFields) transformers.push(transformESDecorators);
        transformers.push(transformClassFields);
        if (getJSXTransformEnabled(compilerOptions)) transformers.push(transformJsx);
        if (languageVersion < 99 /* ESNext */ ) transformers.push(transformESNext);
        if (languageVersion < 8 /* ES2021 */ ) transformers.push(transformES2021);
        if (languageVersion < 7 /* ES2020 */ ) transformers.push(transformES2020);
        if (languageVersion < 6 /* ES2019 */ ) transformers.push(transformES2019);
        if (languageVersion < 5 /* ES2018 */ ) transformers.push(transformES2018);
        if (languageVersion < 4 /* ES2017 */ ) transformers.push(transformES2017);
        if (languageVersion < 3 /* ES2016 */ ) transformers.push(transformES2016);
        if (languageVersion < 2 /* ES2015 */ ) {
            transformers.push(transformES2015);
            transformers.push(transformGenerators);
        }
        transformers.push(getModuleTransformer(moduleKind));
        if (languageVersion < 1 /* ES5 */ ) transformers.push(transformES5);
        addRange(transformers, customTransformers && map(customTransformers.after, wrapScriptTransformerFactory));
        return transformers;
    }
    function getDeclarationTransformers(customTransformers) {
        const transformers = [];
        transformers.push(transformDeclarations);
        addRange(transformers, customTransformers && map(customTransformers.afterDeclarations, wrapDeclarationTransformerFactory));
        return transformers;
    }
    function wrapCustomTransformer(transformer) {
        return (node)=>isBundle(node) ? transformer.transformBundle(node) : transformer.transformSourceFile(node);
    }
    function wrapCustomTransformerFactory(transformer, handleDefault) {
        return (context)=>{
            const customTransformer = transformer(context);
            return typeof customTransformer === "function" ? handleDefault(context, customTransformer) : wrapCustomTransformer(customTransformer);
        };
    }
    function wrapScriptTransformerFactory(transformer) {
        return wrapCustomTransformerFactory(transformer, chainBundle);
    }
    function wrapDeclarationTransformerFactory(transformer) {
        return wrapCustomTransformerFactory(transformer, (_, node)=>node);
    }
    function noEmitSubstitution(_hint, node) {
        return node;
    }
    function noEmitNotification(hint, node, callback) {
        callback(hint, node);
    }
    function transformNodes(resolver, host, factory2, options, nodes, transformers, allowDtsFiles) {
        var _a, _b;
        const enabledSyntaxKindFeatures = new Array(362 /* Count */ );
        let lexicalEnvironmentVariableDeclarations;
        let lexicalEnvironmentFunctionDeclarations;
        let lexicalEnvironmentStatements;
        let lexicalEnvironmentFlags = 0 /* None */ ;
        let lexicalEnvironmentVariableDeclarationsStack = [];
        let lexicalEnvironmentFunctionDeclarationsStack = [];
        let lexicalEnvironmentStatementsStack = [];
        let lexicalEnvironmentFlagsStack = [];
        let lexicalEnvironmentStackOffset = 0;
        let lexicalEnvironmentSuspended = false;
        let blockScopedVariableDeclarationsStack = [];
        let blockScopeStackOffset = 0;
        let blockScopedVariableDeclarations;
        let emitHelpers;
        let onSubstituteNode = noEmitSubstitution;
        let onEmitNode = noEmitNotification;
        let state = 0 /* Uninitialized */ ;
        const diagnostics = [];
        const context = {
            factory: factory2,
            getCompilerOptions: ()=>options,
            getEmitResolver: ()=>resolver,
            // TODO: GH#18217
            getEmitHost: ()=>host,
            // TODO: GH#18217
            getEmitHelperFactory: memoize(()=>createEmitHelperFactory(context)),
            startLexicalEnvironment: startLexicalEnvironment,
            suspendLexicalEnvironment: suspendLexicalEnvironment,
            resumeLexicalEnvironment: resumeLexicalEnvironment,
            endLexicalEnvironment: endLexicalEnvironment,
            setLexicalEnvironmentFlags: setLexicalEnvironmentFlags,
            getLexicalEnvironmentFlags: getLexicalEnvironmentFlags,
            hoistVariableDeclaration: hoistVariableDeclaration,
            hoistFunctionDeclaration: hoistFunctionDeclaration,
            addInitializationStatement: addInitializationStatement,
            startBlockScope: startBlockScope,
            endBlockScope: endBlockScope,
            addBlockScopedVariable: addBlockScopedVariable,
            requestEmitHelper: requestEmitHelper,
            readEmitHelpers: readEmitHelpers,
            enableSubstitution: enableSubstitution,
            enableEmitNotification: enableEmitNotification,
            isSubstitutionEnabled: isSubstitutionEnabled,
            isEmitNotificationEnabled: isEmitNotificationEnabled,
            get onSubstituteNode () {
                return onSubstituteNode;
            },
            set onSubstituteNode (value){
                Debug.assert(state < 1 /* Initialized */ , "Cannot modify transformation hooks after initialization has completed.");
                Debug.assert(value !== void 0, "Value must not be 'undefined'");
                onSubstituteNode = value;
            },
            get onEmitNode () {
                return onEmitNode;
            },
            set onEmitNode (value){
                Debug.assert(state < 1 /* Initialized */ , "Cannot modify transformation hooks after initialization has completed.");
                Debug.assert(value !== void 0, "Value must not be 'undefined'");
                onEmitNode = value;
            },
            addDiagnostic (diag2) {
                diagnostics.push(diag2);
            }
        };
        for (const node of nodes)disposeEmitNodes(getSourceFileOfNode(getParseTreeNode(node)));
        mark("beforeTransform");
        const transformersWithContext = transformers.map((t)=>t(context));
        const transformation = (node)=>{
            for (const transform2 of transformersWithContext)node = transform2(node);
            return node;
        };
        state = 1 /* Initialized */ ;
        const transformed = [];
        for (const node of nodes){
            (_a = tracing) == null || _a.push(tracing.Phase.Emit, "transformNodes", node.kind === 311 /* SourceFile */  ? {
                path: node.path
            } : {
                kind: node.kind,
                pos: node.pos,
                end: node.end
            });
            transformed.push((allowDtsFiles ? transformation : transformRoot)(node));
            (_b = tracing) == null || _b.pop();
        }
        state = 2 /* Completed */ ;
        mark("afterTransform");
        measure("transformTime", "beforeTransform", "afterTransform");
        return {
            transformed: transformed,
            substituteNode: substituteNode,
            emitNodeWithNotification: emitNodeWithNotification,
            isEmitNotificationEnabled: isEmitNotificationEnabled,
            dispose: dispose,
            diagnostics: diagnostics
        };
        function transformRoot(node) {
            return node && (!isSourceFile(node) || !node.isDeclarationFile) ? transformation(node) : node;
        }
        function enableSubstitution(kind) {
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the transformation context after transformation has completed.");
            enabledSyntaxKindFeatures[kind] |= 1 /* Substitution */ ;
        }
        function isSubstitutionEnabled(node) {
            return (enabledSyntaxKindFeatures[node.kind] & 1 /* Substitution */ ) !== 0 && (getEmitFlags(node) & 8 /* NoSubstitution */ ) === 0;
        }
        function substituteNode(hint, node) {
            Debug.assert(state < 3 /* Disposed */ , "Cannot substitute a node after the result is disposed.");
            return node && isSubstitutionEnabled(node) && onSubstituteNode(hint, node) || node;
        }
        function enableEmitNotification(kind) {
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the transformation context after transformation has completed.");
            enabledSyntaxKindFeatures[kind] |= 2 /* EmitNotifications */ ;
        }
        function isEmitNotificationEnabled(node) {
            return (enabledSyntaxKindFeatures[node.kind] & 2 /* EmitNotifications */ ) !== 0 || (getEmitFlags(node) & 4 /* AdviseOnEmitNode */ ) !== 0;
        }
        function emitNodeWithNotification(hint, node, emitCallback) {
            Debug.assert(state < 3 /* Disposed */ , "Cannot invoke TransformationResult callbacks after the result is disposed.");
            if (node) {
                if (isEmitNotificationEnabled(node)) onEmitNode(hint, node, emitCallback);
                else emitCallback(hint, node);
            }
        }
        function hoistVariableDeclaration(name) {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            const decl = setEmitFlags(factory2.createVariableDeclaration(name), 128 /* NoNestedSourceMaps */ );
            if (!lexicalEnvironmentVariableDeclarations) lexicalEnvironmentVariableDeclarations = [
                decl
            ];
            else lexicalEnvironmentVariableDeclarations.push(decl);
            if (lexicalEnvironmentFlags & 1 /* InParameters */ ) lexicalEnvironmentFlags |= 2 /* VariablesHoistedInParameters */ ;
        }
        function hoistFunctionDeclaration(func) {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            setEmitFlags(func, 2097152 /* CustomPrologue */ );
            if (!lexicalEnvironmentFunctionDeclarations) lexicalEnvironmentFunctionDeclarations = [
                func
            ];
            else lexicalEnvironmentFunctionDeclarations.push(func);
        }
        function addInitializationStatement(node) {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            setEmitFlags(node, 2097152 /* CustomPrologue */ );
            if (!lexicalEnvironmentStatements) lexicalEnvironmentStatements = [
                node
            ];
            else lexicalEnvironmentStatements.push(node);
        }
        function startLexicalEnvironment() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is suspended.");
            lexicalEnvironmentVariableDeclarationsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentVariableDeclarations;
            lexicalEnvironmentFunctionDeclarationsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentFunctionDeclarations;
            lexicalEnvironmentStatementsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentStatements;
            lexicalEnvironmentFlagsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentFlags;
            lexicalEnvironmentStackOffset++;
            lexicalEnvironmentVariableDeclarations = void 0;
            lexicalEnvironmentFunctionDeclarations = void 0;
            lexicalEnvironmentStatements = void 0;
            lexicalEnvironmentFlags = 0 /* None */ ;
        }
        function suspendLexicalEnvironment() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is already suspended.");
            lexicalEnvironmentSuspended = true;
        }
        function resumeLexicalEnvironment() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            Debug.assert(lexicalEnvironmentSuspended, "Lexical environment is not suspended.");
            lexicalEnvironmentSuspended = false;
        }
        function endLexicalEnvironment() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is suspended.");
            let statements;
            if (lexicalEnvironmentVariableDeclarations || lexicalEnvironmentFunctionDeclarations || lexicalEnvironmentStatements) {
                if (lexicalEnvironmentFunctionDeclarations) statements = [
                    ...lexicalEnvironmentFunctionDeclarations
                ];
                if (lexicalEnvironmentVariableDeclarations) {
                    const statement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(lexicalEnvironmentVariableDeclarations));
                    setEmitFlags(statement, 2097152 /* CustomPrologue */ );
                    if (!statements) statements = [
                        statement
                    ];
                    else statements.push(statement);
                }
                if (lexicalEnvironmentStatements) {
                    if (!statements) statements = [
                        ...lexicalEnvironmentStatements
                    ];
                    else statements = [
                        ...statements,
                        ...lexicalEnvironmentStatements
                    ];
                }
            }
            lexicalEnvironmentStackOffset--;
            lexicalEnvironmentVariableDeclarations = lexicalEnvironmentVariableDeclarationsStack[lexicalEnvironmentStackOffset];
            lexicalEnvironmentFunctionDeclarations = lexicalEnvironmentFunctionDeclarationsStack[lexicalEnvironmentStackOffset];
            lexicalEnvironmentStatements = lexicalEnvironmentStatementsStack[lexicalEnvironmentStackOffset];
            lexicalEnvironmentFlags = lexicalEnvironmentFlagsStack[lexicalEnvironmentStackOffset];
            if (lexicalEnvironmentStackOffset === 0) {
                lexicalEnvironmentVariableDeclarationsStack = [];
                lexicalEnvironmentFunctionDeclarationsStack = [];
                lexicalEnvironmentStatementsStack = [];
                lexicalEnvironmentFlagsStack = [];
            }
            return statements;
        }
        function setLexicalEnvironmentFlags(flags, value1) {
            lexicalEnvironmentFlags = value1 ? lexicalEnvironmentFlags | flags : lexicalEnvironmentFlags & ~flags;
        }
        function getLexicalEnvironmentFlags() {
            return lexicalEnvironmentFlags;
        }
        function startBlockScope() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot start a block scope during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot start a block scope after transformation has completed.");
            blockScopedVariableDeclarationsStack[blockScopeStackOffset] = blockScopedVariableDeclarations;
            blockScopeStackOffset++;
            blockScopedVariableDeclarations = void 0;
        }
        function endBlockScope() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot end a block scope during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot end a block scope after transformation has completed.");
            const statements = some(blockScopedVariableDeclarations) ? [
                factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(blockScopedVariableDeclarations.map((identifier)=>factory2.createVariableDeclaration(identifier)), 1 /* Let */ ))
            ] : void 0;
            blockScopeStackOffset--;
            blockScopedVariableDeclarations = blockScopedVariableDeclarationsStack[blockScopeStackOffset];
            if (blockScopeStackOffset === 0) blockScopedVariableDeclarationsStack = [];
            return statements;
        }
        function addBlockScopedVariable(name) {
            Debug.assert(blockScopeStackOffset > 0, "Cannot add a block scoped variable outside of an iteration body.");
            (blockScopedVariableDeclarations || (blockScopedVariableDeclarations = [])).push(name);
        }
        function requestEmitHelper(helper) {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the transformation context during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the transformation context after transformation has completed.");
            Debug.assert(!helper.scoped, "Cannot request a scoped emit helper.");
            if (helper.dependencies) for (const h of helper.dependencies)requestEmitHelper(h);
            emitHelpers = append(emitHelpers, helper);
        }
        function readEmitHelpers() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the transformation context during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the transformation context after transformation has completed.");
            const helpers = emitHelpers;
            emitHelpers = void 0;
            return helpers;
        }
        function dispose() {
            if (state < 3 /* Disposed */ ) {
                for (const node of nodes)disposeEmitNodes(getSourceFileOfNode(getParseTreeNode(node)));
                lexicalEnvironmentVariableDeclarations = void 0;
                lexicalEnvironmentVariableDeclarationsStack = void 0;
                lexicalEnvironmentFunctionDeclarations = void 0;
                lexicalEnvironmentFunctionDeclarationsStack = void 0;
                onSubstituteNode = void 0;
                onEmitNode = void 0;
                emitHelpers = void 0;
                state = 3 /* Disposed */ ;
            }
        }
    }
    var noTransformers, nullTransformationContext;
    var init_transformer = __esm({
        "src/compiler/transformer.ts" () {
            "use strict";
            init_ts2();
            init_ts_performance();
            noTransformers = {
                scriptTransformers: emptyArray,
                declarationTransformers: emptyArray
            };
            nullTransformationContext = {
                factory: factory,
                // eslint-disable-line object-shorthand
                getCompilerOptions: ()=>({}),
                getEmitResolver: notImplemented,
                getEmitHost: notImplemented,
                getEmitHelperFactory: notImplemented,
                startLexicalEnvironment: noop,
                resumeLexicalEnvironment: noop,
                suspendLexicalEnvironment: noop,
                endLexicalEnvironment: returnUndefined,
                setLexicalEnvironmentFlags: noop,
                getLexicalEnvironmentFlags: ()=>0,
                hoistVariableDeclaration: noop,
                hoistFunctionDeclaration: noop,
                addInitializationStatement: noop,
                startBlockScope: noop,
                endBlockScope: returnUndefined,
                addBlockScopedVariable: noop,
                requestEmitHelper: noop,
                readEmitHelpers: notImplemented,
                enableSubstitution: noop,
                enableEmitNotification: noop,
                isSubstitutionEnabled: notImplemented,
                isEmitNotificationEnabled: notImplemented,
                onSubstituteNode: noEmitSubstitution,
                onEmitNode: noEmitNotification,
                addDiagnostic: noop
            };
        }
    });
    // src/compiler/emitter.ts
    function isBuildInfoFile(file) {
        return fileExtensionIs(file, ".tsbuildinfo" /* TsBuildInfo */ );
    }
    function forEachEmittedFile(host, action, sourceFilesOrTargetSourceFile, forceDtsEmit = false, onlyBuildInfo, includeBuildInfo) {
        const sourceFiles = isArray(sourceFilesOrTargetSourceFile) ? sourceFilesOrTargetSourceFile : getSourceFilesToEmit(host, sourceFilesOrTargetSourceFile, forceDtsEmit);
        const options = host.getCompilerOptions();
        if (outFile(options)) {
            const prepends = host.getPrependNodes();
            if (sourceFiles.length || prepends.length) {
                const bundle = factory.createBundle(sourceFiles, prepends);
                const result = action(getOutputPathsFor(bundle, host, forceDtsEmit), bundle);
                if (result) return result;
            }
        } else {
            if (!onlyBuildInfo) for (const sourceFile of sourceFiles){
                const result = action(getOutputPathsFor(sourceFile, host, forceDtsEmit), sourceFile);
                if (result) return result;
            }
            if (includeBuildInfo) {
                const buildInfoPath = getTsBuildInfoEmitOutputFilePath(options);
                if (buildInfoPath) return action({
                    buildInfoPath: buildInfoPath
                }, /*sourceFileOrBundle*/ void 0);
            }
        }
    }
    function getTsBuildInfoEmitOutputFilePath(options) {
        const configFile = options.configFilePath;
        if (!isIncrementalCompilation(options)) return void 0;
        if (options.tsBuildInfoFile) return options.tsBuildInfoFile;
        const outPath = outFile(options);
        let buildInfoExtensionLess;
        if (outPath) buildInfoExtensionLess = removeFileExtension(outPath);
        else {
            if (!configFile) return void 0;
            const configFileExtensionLess = removeFileExtension(configFile);
            buildInfoExtensionLess = options.outDir ? options.rootDir ? resolvePath(options.outDir, getRelativePathFromDirectory(options.rootDir, configFileExtensionLess, /*ignoreCase*/ true)) : combinePaths(options.outDir, getBaseFileName(configFileExtensionLess)) : configFileExtensionLess;
        }
        return buildInfoExtensionLess + ".tsbuildinfo" /* TsBuildInfo */ ;
    }
    function getOutputPathsForBundle(options, forceDtsPaths) {
        const outPath = outFile(options);
        const jsFilePath = options.emitDeclarationOnly ? void 0 : outPath;
        const sourceMapFilePath = jsFilePath && getSourceMapFilePath(jsFilePath, options);
        const declarationFilePath = forceDtsPaths || getEmitDeclarations(options) ? removeFileExtension(outPath) + ".d.ts" /* Dts */  : void 0;
        const declarationMapPath = declarationFilePath && getAreDeclarationMapsEnabled(options) ? declarationFilePath + ".map" : void 0;
        const buildInfoPath = getTsBuildInfoEmitOutputFilePath(options);
        return {
            jsFilePath: jsFilePath,
            sourceMapFilePath: sourceMapFilePath,
            declarationFilePath: declarationFilePath,
            declarationMapPath: declarationMapPath,
            buildInfoPath: buildInfoPath
        };
    }
    function getOutputPathsFor(sourceFile, host, forceDtsPaths) {
        const options = host.getCompilerOptions();
        if (sourceFile.kind === 312 /* Bundle */ ) return getOutputPathsForBundle(options, forceDtsPaths);
        else {
            const ownOutputFilePath = getOwnEmitOutputFilePath(sourceFile.fileName, host, getOutputExtension(sourceFile.fileName, options));
            const isJsonFile = isJsonSourceFile(sourceFile);
            const isJsonEmittedToSameLocation = isJsonFile && comparePaths(sourceFile.fileName, ownOutputFilePath, host.getCurrentDirectory(), !host.useCaseSensitiveFileNames()) === 0 /* EqualTo */ ;
            const jsFilePath = options.emitDeclarationOnly || isJsonEmittedToSameLocation ? void 0 : ownOutputFilePath;
            const sourceMapFilePath = !jsFilePath || isJsonSourceFile(sourceFile) ? void 0 : getSourceMapFilePath(jsFilePath, options);
            const declarationFilePath = forceDtsPaths || getEmitDeclarations(options) && !isJsonFile ? getDeclarationEmitOutputFilePath(sourceFile.fileName, host) : void 0;
            const declarationMapPath = declarationFilePath && getAreDeclarationMapsEnabled(options) ? declarationFilePath + ".map" : void 0;
            return {
                jsFilePath: jsFilePath,
                sourceMapFilePath: sourceMapFilePath,
                declarationFilePath: declarationFilePath,
                declarationMapPath: declarationMapPath,
                buildInfoPath: void 0
            };
        }
    }
    function getSourceMapFilePath(jsFilePath, options) {
        return options.sourceMap && !options.inlineSourceMap ? jsFilePath + ".map" : void 0;
    }
    function getOutputExtension(fileName, options) {
        return fileExtensionIs(fileName, ".json" /* Json */ ) ? ".json" /* Json */  : options.jsx === 1 /* Preserve */  && fileExtensionIsOneOf(fileName, [
            ".jsx" /* Jsx */ ,
            ".tsx" /* Tsx */ 
        ]) ? ".jsx" /* Jsx */  : fileExtensionIsOneOf(fileName, [
            ".mts" /* Mts */ ,
            ".mjs" /* Mjs */ 
        ]) ? ".mjs" /* Mjs */  : fileExtensionIsOneOf(fileName, [
            ".cts" /* Cts */ ,
            ".cjs" /* Cjs */ 
        ]) ? ".cjs" /* Cjs */  : ".js" /* Js */ ;
    }
    function getOutputPathWithoutChangingExt(inputFileName, configFile, ignoreCase, outputDir, getCommonSourceDirectory2) {
        return outputDir ? resolvePath(outputDir, getRelativePathFromDirectory(getCommonSourceDirectory2 ? getCommonSourceDirectory2() : getCommonSourceDirectoryOfConfig(configFile, ignoreCase), inputFileName, ignoreCase)) : inputFileName;
    }
    function getOutputDeclarationFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2) {
        return changeExtension(getOutputPathWithoutChangingExt(inputFileName, configFile, ignoreCase, configFile.options.declarationDir || configFile.options.outDir, getCommonSourceDirectory2), getDeclarationEmitExtensionForPath(inputFileName));
    }
    function getOutputJSFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2) {
        if (configFile.options.emitDeclarationOnly) return void 0;
        const isJsonFile = fileExtensionIs(inputFileName, ".json" /* Json */ );
        const outputFileName = changeExtension(getOutputPathWithoutChangingExt(inputFileName, configFile, ignoreCase, configFile.options.outDir, getCommonSourceDirectory2), getOutputExtension(inputFileName, configFile.options));
        return !isJsonFile || comparePaths(inputFileName, outputFileName, Debug.checkDefined(configFile.options.configFilePath), ignoreCase) !== 0 /* EqualTo */  ? outputFileName : void 0;
    }
    function createAddOutput() {
        let outputs;
        return {
            addOutput: addOutput,
            getOutputs: getOutputs
        };
        function addOutput(path) {
            if (path) (outputs || (outputs = [])).push(path);
        }
        function getOutputs() {
            return outputs || emptyArray;
        }
    }
    function getSingleOutputFileNames(configFile, addOutput) {
        const { jsFilePath: jsFilePath , sourceMapFilePath: sourceMapFilePath , declarationFilePath: declarationFilePath , declarationMapPath: declarationMapPath , buildInfoPath: buildInfoPath  } = getOutputPathsForBundle(configFile.options, /*forceDtsPaths*/ false);
        addOutput(jsFilePath);
        addOutput(sourceMapFilePath);
        addOutput(declarationFilePath);
        addOutput(declarationMapPath);
        addOutput(buildInfoPath);
    }
    function getOwnOutputFileNames(configFile, inputFileName, ignoreCase, addOutput, getCommonSourceDirectory2) {
        if (isDeclarationFileName(inputFileName)) return;
        const js = getOutputJSFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2);
        addOutput(js);
        if (fileExtensionIs(inputFileName, ".json" /* Json */ )) return;
        if (js && configFile.options.sourceMap) addOutput(`${js}.map`);
        if (getEmitDeclarations(configFile.options)) {
            const dts = getOutputDeclarationFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2);
            addOutput(dts);
            if (configFile.options.declarationMap) addOutput(`${dts}.map`);
        }
    }
    function getCommonSourceDirectory(options, emittedFiles, currentDirectory, getCanonicalFileName, checkSourceFilesBelongToPath) {
        let commonSourceDirectory;
        if (options.rootDir) {
            commonSourceDirectory = getNormalizedAbsolutePath(options.rootDir, currentDirectory);
            checkSourceFilesBelongToPath == null || checkSourceFilesBelongToPath(options.rootDir);
        } else if (options.composite && options.configFilePath) {
            commonSourceDirectory = getDirectoryPath(normalizeSlashes(options.configFilePath));
            checkSourceFilesBelongToPath == null || checkSourceFilesBelongToPath(commonSourceDirectory);
        } else commonSourceDirectory = computeCommonSourceDirectoryOfFilenames(emittedFiles(), currentDirectory, getCanonicalFileName);
        if (commonSourceDirectory && commonSourceDirectory[commonSourceDirectory.length - 1] !== directorySeparator) commonSourceDirectory += directorySeparator;
        return commonSourceDirectory;
    }
    function getCommonSourceDirectoryOfConfig({ options: options , fileNames: fileNames  }, ignoreCase) {
        return getCommonSourceDirectory(options, ()=>filter(fileNames, (file)=>!(options.noEmitForJsFiles && fileExtensionIsOneOf(file, supportedJSExtensionsFlat)) && !isDeclarationFileName(file)), getDirectoryPath(normalizeSlashes(Debug.checkDefined(options.configFilePath))), createGetCanonicalFileName(!ignoreCase));
    }
    function getAllProjectOutputs(configFile, ignoreCase) {
        const { addOutput: addOutput , getOutputs: getOutputs  } = createAddOutput();
        if (outFile(configFile.options)) getSingleOutputFileNames(configFile, addOutput);
        else {
            const getCommonSourceDirectory2 = memoize(()=>getCommonSourceDirectoryOfConfig(configFile, ignoreCase));
            for (const inputFileName of configFile.fileNames)getOwnOutputFileNames(configFile, inputFileName, ignoreCase, addOutput, getCommonSourceDirectory2);
            addOutput(getTsBuildInfoEmitOutputFilePath(configFile.options));
        }
        return getOutputs();
    }
    function getOutputFileNames(commandLine, inputFileName, ignoreCase) {
        inputFileName = normalizePath(inputFileName);
        Debug.assert(contains(commandLine.fileNames, inputFileName), `Expected fileName to be present in command line`);
        const { addOutput: addOutput , getOutputs: getOutputs  } = createAddOutput();
        if (outFile(commandLine.options)) getSingleOutputFileNames(commandLine, addOutput);
        else getOwnOutputFileNames(commandLine, inputFileName, ignoreCase, addOutput);
        return getOutputs();
    }
    function getFirstProjectOutput(configFile, ignoreCase) {
        if (outFile(configFile.options)) {
            const { jsFilePath: jsFilePath , declarationFilePath: declarationFilePath  } = getOutputPathsForBundle(configFile.options, /*forceDtsPaths*/ false);
            return Debug.checkDefined(jsFilePath || declarationFilePath, `project ${configFile.options.configFilePath} expected to have at least one output`);
        }
        const getCommonSourceDirectory2 = memoize(()=>getCommonSourceDirectoryOfConfig(configFile, ignoreCase));
        for (const inputFileName of configFile.fileNames){
            if (isDeclarationFileName(inputFileName)) continue;
            const jsFilePath = getOutputJSFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2);
            if (jsFilePath) return jsFilePath;
            if (fileExtensionIs(inputFileName, ".json" /* Json */ )) continue;
            if (getEmitDeclarations(configFile.options)) return getOutputDeclarationFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2);
        }
        const buildInfoPath = getTsBuildInfoEmitOutputFilePath(configFile.options);
        if (buildInfoPath) return buildInfoPath;
        return Debug.fail(`project ${configFile.options.configFilePath} expected to have at least one output`);
    }
    function emitFiles(resolver, host, targetSourceFile, { scriptTransformers: scriptTransformers , declarationTransformers: declarationTransformers  }, emitOnly, onlyBuildInfo, forceDtsEmit) {
        var compilerOptions = host.getCompilerOptions();
        var sourceMapDataList = compilerOptions.sourceMap || compilerOptions.inlineSourceMap || getAreDeclarationMapsEnabled(compilerOptions) ? [] : void 0;
        var emittedFilesList = compilerOptions.listEmittedFiles ? [] : void 0;
        var emitterDiagnostics = createDiagnosticCollection();
        var newLine = getNewLineCharacter(compilerOptions);
        var writer = createTextWriter(newLine);
        var { enter: enter , exit: exit  } = createTimer("printTime", "beforePrint", "afterPrint");
        var bundleBuildInfo;
        var emitSkipped = false;
        enter();
        forEachEmittedFile(host, emitSourceFileOrBundle, getSourceFilesToEmit(host, targetSourceFile, forceDtsEmit), forceDtsEmit, onlyBuildInfo, !targetSourceFile);
        exit();
        return {
            emitSkipped: emitSkipped,
            diagnostics: emitterDiagnostics.getDiagnostics(),
            emittedFiles: emittedFilesList,
            sourceMaps: sourceMapDataList
        };
        function emitSourceFileOrBundle({ jsFilePath: jsFilePath , sourceMapFilePath: sourceMapFilePath , declarationFilePath: declarationFilePath , declarationMapPath: declarationMapPath , buildInfoPath: buildInfoPath  }, sourceFileOrBundle) {
            var _a, _b, _c, _d, _e, _f;
            let buildInfoDirectory;
            if (buildInfoPath && sourceFileOrBundle && isBundle(sourceFileOrBundle)) {
                buildInfoDirectory = getDirectoryPath(getNormalizedAbsolutePath(buildInfoPath, host.getCurrentDirectory()));
                bundleBuildInfo = {
                    commonSourceDirectory: relativeToBuildInfo(host.getCommonSourceDirectory()),
                    sourceFiles: sourceFileOrBundle.sourceFiles.map((file)=>relativeToBuildInfo(getNormalizedAbsolutePath(file.fileName, host.getCurrentDirectory())))
                };
            }
            (_a = tracing) == null || _a.push(tracing.Phase.Emit, "emitJsFileOrBundle", {
                jsFilePath: jsFilePath
            });
            emitJsFileOrBundle(sourceFileOrBundle, jsFilePath, sourceMapFilePath, relativeToBuildInfo);
            (_b = tracing) == null || _b.pop();
            (_c = tracing) == null || _c.push(tracing.Phase.Emit, "emitDeclarationFileOrBundle", {
                declarationFilePath: declarationFilePath
            });
            emitDeclarationFileOrBundle(sourceFileOrBundle, declarationFilePath, declarationMapPath, relativeToBuildInfo);
            (_d = tracing) == null || _d.pop();
            (_e = tracing) == null || _e.push(tracing.Phase.Emit, "emitBuildInfo", {
                buildInfoPath: buildInfoPath
            });
            emitBuildInfo(bundleBuildInfo, buildInfoPath);
            (_f = tracing) == null || _f.pop();
            if (!emitSkipped && emittedFilesList) {
                if (!emitOnly) {
                    if (jsFilePath) emittedFilesList.push(jsFilePath);
                    if (sourceMapFilePath) emittedFilesList.push(sourceMapFilePath);
                    if (buildInfoPath) emittedFilesList.push(buildInfoPath);
                }
                if (emitOnly !== 0 /* Js */ ) {
                    if (declarationFilePath) emittedFilesList.push(declarationFilePath);
                    if (declarationMapPath) emittedFilesList.push(declarationMapPath);
                }
            }
            function relativeToBuildInfo(path) {
                return ensurePathIsNonModuleName(getRelativePathFromDirectory(buildInfoDirectory, path, host.getCanonicalFileName));
            }
        }
        function emitBuildInfo(bundle, buildInfoPath) {
            if (!buildInfoPath || targetSourceFile || emitSkipped) return;
            if (host.isEmitBlocked(buildInfoPath)) {
                emitSkipped = true;
                return;
            }
            const buildInfo = host.getBuildInfo(bundle) || createBuildInfo(/*program*/ void 0, bundle);
            writeFile(host, emitterDiagnostics, buildInfoPath, getBuildInfoText(buildInfo), /*writeByteOrderMark*/ false, /*sourceFiles*/ void 0, {
                buildInfo: buildInfo
            });
        }
        function emitJsFileOrBundle(sourceFileOrBundle, jsFilePath, sourceMapFilePath, relativeToBuildInfo) {
            if (!sourceFileOrBundle || emitOnly || !jsFilePath) return;
            if (host.isEmitBlocked(jsFilePath) || compilerOptions.noEmit) {
                emitSkipped = true;
                return;
            }
            const transform2 = transformNodes(resolver, host, factory, compilerOptions, [
                sourceFileOrBundle
            ], scriptTransformers, /*allowDtsFiles*/ false);
            const printerOptions = {
                removeComments: compilerOptions.removeComments,
                newLine: compilerOptions.newLine,
                noEmitHelpers: compilerOptions.noEmitHelpers,
                module: compilerOptions.module,
                target: compilerOptions.target,
                sourceMap: compilerOptions.sourceMap,
                inlineSourceMap: compilerOptions.inlineSourceMap,
                inlineSources: compilerOptions.inlineSources,
                extendedDiagnostics: compilerOptions.extendedDiagnostics,
                writeBundleFileInfo: !!bundleBuildInfo,
                relativeToBuildInfo: relativeToBuildInfo
            };
            const printer = createPrinter(printerOptions, {
                // resolver hooks
                hasGlobalName: resolver.hasGlobalName,
                // transform hooks
                onEmitNode: transform2.emitNodeWithNotification,
                isEmitNotificationEnabled: transform2.isEmitNotificationEnabled,
                substituteNode: transform2.substituteNode
            });
            Debug.assert(transform2.transformed.length === 1, "Should only see one output from the transform");
            printSourceFileOrBundle(jsFilePath, sourceMapFilePath, transform2, printer, compilerOptions);
            transform2.dispose();
            if (bundleBuildInfo) bundleBuildInfo.js = printer.bundleFileInfo;
        }
        function emitDeclarationFileOrBundle(sourceFileOrBundle, declarationFilePath, declarationMapPath, relativeToBuildInfo) {
            if (!sourceFileOrBundle || emitOnly === 0 /* Js */ ) return;
            if (!declarationFilePath) {
                if (emitOnly || compilerOptions.emitDeclarationOnly) emitSkipped = true;
                return;
            }
            const sourceFiles = isSourceFile(sourceFileOrBundle) ? [
                sourceFileOrBundle
            ] : sourceFileOrBundle.sourceFiles;
            const filesForEmit = forceDtsEmit ? sourceFiles : filter(sourceFiles, isSourceFileNotJson);
            const inputListOrBundle = outFile(compilerOptions) ? [
                factory.createBundle(filesForEmit, !isSourceFile(sourceFileOrBundle) ? sourceFileOrBundle.prepends : void 0)
            ] : filesForEmit;
            if (emitOnly && !getEmitDeclarations(compilerOptions)) filesForEmit.forEach(collectLinkedAliases);
            const declarationTransform = transformNodes(resolver, host, factory, compilerOptions, inputListOrBundle, declarationTransformers, /*allowDtsFiles*/ false);
            if (length(declarationTransform.diagnostics)) for (const diagnostic of declarationTransform.diagnostics)emitterDiagnostics.add(diagnostic);
            const printerOptions = {
                removeComments: compilerOptions.removeComments,
                newLine: compilerOptions.newLine,
                noEmitHelpers: true,
                module: compilerOptions.module,
                target: compilerOptions.target,
                sourceMap: !forceDtsEmit && compilerOptions.declarationMap,
                inlineSourceMap: compilerOptions.inlineSourceMap,
                extendedDiagnostics: compilerOptions.extendedDiagnostics,
                onlyPrintJsDocStyle: true,
                writeBundleFileInfo: !!bundleBuildInfo,
                recordInternalSection: !!bundleBuildInfo,
                relativeToBuildInfo: relativeToBuildInfo
            };
            const declarationPrinter = createPrinter(printerOptions, {
                // resolver hooks
                hasGlobalName: resolver.hasGlobalName,
                // transform hooks
                onEmitNode: declarationTransform.emitNodeWithNotification,
                isEmitNotificationEnabled: declarationTransform.isEmitNotificationEnabled,
                substituteNode: declarationTransform.substituteNode
            });
            const declBlocked = !!declarationTransform.diagnostics && !!declarationTransform.diagnostics.length || !!host.isEmitBlocked(declarationFilePath) || !!compilerOptions.noEmit;
            emitSkipped = emitSkipped || declBlocked;
            if (!declBlocked || forceDtsEmit) {
                Debug.assert(declarationTransform.transformed.length === 1, "Should only see one output from the decl transform");
                printSourceFileOrBundle(declarationFilePath, declarationMapPath, declarationTransform, declarationPrinter, {
                    sourceMap: printerOptions.sourceMap,
                    sourceRoot: compilerOptions.sourceRoot,
                    mapRoot: compilerOptions.mapRoot,
                    extendedDiagnostics: compilerOptions.extendedDiagnostics
                });
            }
            declarationTransform.dispose();
            if (bundleBuildInfo) bundleBuildInfo.dts = declarationPrinter.bundleFileInfo;
        }
        function collectLinkedAliases(node) {
            if (isExportAssignment(node)) {
                if (node.expression.kind === 80 /* Identifier */ ) resolver.collectLinkedAliases(node.expression, /*setVisibility*/ true);
                return;
            } else if (isExportSpecifier(node)) {
                resolver.collectLinkedAliases(node.propertyName || node.name, /*setVisibility*/ true);
                return;
            }
            forEachChild(node, collectLinkedAliases);
        }
        function printSourceFileOrBundle(jsFilePath, sourceMapFilePath, transform2, printer, mapOptions) {
            const sourceFileOrBundle = transform2.transformed[0];
            const bundle = sourceFileOrBundle.kind === 312 /* Bundle */  ? sourceFileOrBundle : void 0;
            const sourceFile = sourceFileOrBundle.kind === 311 /* SourceFile */  ? sourceFileOrBundle : void 0;
            const sourceFiles = bundle ? bundle.sourceFiles : [
                sourceFile
            ];
            let sourceMapGenerator;
            if (shouldEmitSourceMaps(mapOptions, sourceFileOrBundle)) sourceMapGenerator = createSourceMapGenerator(host, getBaseFileName(normalizeSlashes(jsFilePath)), getSourceRoot(mapOptions), getSourceMapDirectory(mapOptions, jsFilePath, sourceFile), mapOptions);
            if (bundle) printer.writeBundle(bundle, writer, sourceMapGenerator);
            else printer.writeFile(sourceFile, writer, sourceMapGenerator);
            let sourceMapUrlPos;
            if (sourceMapGenerator) {
                if (sourceMapDataList) sourceMapDataList.push({
                    inputSourceFileNames: sourceMapGenerator.getSources(),
                    sourceMap: sourceMapGenerator.toJSON()
                });
                const sourceMappingURL = getSourceMappingURL(mapOptions, sourceMapGenerator, jsFilePath, sourceMapFilePath, sourceFile);
                if (sourceMappingURL) {
                    if (!writer.isAtStartOfLine()) writer.rawWrite(newLine);
                    sourceMapUrlPos = writer.getTextPos();
                    writer.writeComment(`//# ${"sourceMappingURL"}=${sourceMappingURL}`);
                }
                if (sourceMapFilePath) {
                    const sourceMap = sourceMapGenerator.toString();
                    writeFile(host, emitterDiagnostics, sourceMapFilePath, sourceMap, /*writeByteOrderMark*/ false, sourceFiles);
                    if (printer.bundleFileInfo) printer.bundleFileInfo.mapHash = computeSignature(sourceMap, host);
                }
            } else writer.writeLine();
            const text = writer.getText();
            writeFile(host, emitterDiagnostics, jsFilePath, text, !!compilerOptions.emitBOM, sourceFiles, {
                sourceMapUrlPos: sourceMapUrlPos,
                diagnostics: transform2.diagnostics
            });
            if (printer.bundleFileInfo) printer.bundleFileInfo.hash = computeSignature(text, host);
            writer.clear();
        }
        function shouldEmitSourceMaps(mapOptions, sourceFileOrBundle) {
            return (mapOptions.sourceMap || mapOptions.inlineSourceMap) && (sourceFileOrBundle.kind !== 311 /* SourceFile */  || !fileExtensionIs(sourceFileOrBundle.fileName, ".json" /* Json */ ));
        }
        function getSourceRoot(mapOptions) {
            const sourceRoot = normalizeSlashes(mapOptions.sourceRoot || "");
            return sourceRoot ? ensureTrailingDirectorySeparator(sourceRoot) : sourceRoot;
        }
        function getSourceMapDirectory(mapOptions, filePath, sourceFile) {
            if (mapOptions.sourceRoot) return host.getCommonSourceDirectory();
            if (mapOptions.mapRoot) {
                let sourceMapDir = normalizeSlashes(mapOptions.mapRoot);
                if (sourceFile) sourceMapDir = getDirectoryPath(getSourceFilePathInNewDir(sourceFile.fileName, host, sourceMapDir));
                if (getRootLength(sourceMapDir) === 0) sourceMapDir = combinePaths(host.getCommonSourceDirectory(), sourceMapDir);
                return sourceMapDir;
            }
            return getDirectoryPath(normalizePath(filePath));
        }
        function getSourceMappingURL(mapOptions, sourceMapGenerator, filePath, sourceMapFilePath, sourceFile) {
            if (mapOptions.inlineSourceMap) {
                const sourceMapText = sourceMapGenerator.toString();
                const base64SourceMapText = base64encode(sys, sourceMapText);
                return `data:application/json;base64,${base64SourceMapText}`;
            }
            const sourceMapFile = getBaseFileName(normalizeSlashes(Debug.checkDefined(sourceMapFilePath)));
            if (mapOptions.mapRoot) {
                let sourceMapDir = normalizeSlashes(mapOptions.mapRoot);
                if (sourceFile) sourceMapDir = getDirectoryPath(getSourceFilePathInNewDir(sourceFile.fileName, host, sourceMapDir));
                if (getRootLength(sourceMapDir) === 0) {
                    sourceMapDir = combinePaths(host.getCommonSourceDirectory(), sourceMapDir);
                    return encodeURI(getRelativePathToDirectoryOrUrl(getDirectoryPath(normalizePath(filePath)), // get the relative sourceMapDir path based on jsFilePath
                    combinePaths(sourceMapDir, sourceMapFile), // this is where user expects to see sourceMap
                    host.getCurrentDirectory(), host.getCanonicalFileName, /*isAbsolutePathAnUrl*/ true));
                } else return encodeURI(combinePaths(sourceMapDir, sourceMapFile));
            }
            return encodeURI(sourceMapFile);
        }
    }
    function createBuildInfo(program, bundle) {
        return {
            bundle: bundle,
            program: program,
            version: version
        };
    }
    function getBuildInfoText(buildInfo) {
        return JSON.stringify(buildInfo);
    }
    function getBuildInfo(buildInfoFile, buildInfoText) {
        return readJsonOrUndefined(buildInfoFile, buildInfoText);
    }
    function createSourceFilesFromBundleBuildInfo(bundle, buildInfoDirectory, host) {
        var _a;
        const jsBundle = Debug.checkDefined(bundle.js);
        const prologueMap = ((_a = jsBundle.sources) == null ? void 0 : _a.prologues) && arrayToMap(jsBundle.sources.prologues, (prologueInfo)=>prologueInfo.file);
        return bundle.sourceFiles.map((fileName, index)=>{
            const prologueInfo = prologueMap == null ? void 0 : prologueMap.get(index);
            const statements = prologueInfo == null ? void 0 : prologueInfo.directives.map((directive)=>{
                const literal = setTextRange(factory.createStringLiteral(directive.expression.text), directive.expression);
                const statement = setTextRange(factory.createExpressionStatement(literal), directive);
                setParent(literal, statement);
                return statement;
            });
            const eofToken = factory.createToken(1 /* EndOfFileToken */ );
            const sourceFile = factory.createSourceFile(statements ?? [], eofToken, 0 /* None */ );
            sourceFile.fileName = getRelativePathFromDirectory(host.getCurrentDirectory(), getNormalizedAbsolutePath(fileName, buildInfoDirectory), !host.useCaseSensitiveFileNames());
            sourceFile.text = (prologueInfo == null ? void 0 : prologueInfo.text) ?? "";
            setTextRangePosWidth(sourceFile, 0, (prologueInfo == null ? void 0 : prologueInfo.text.length) ?? 0);
            setEachParent(sourceFile.statements, sourceFile);
            setTextRangePosWidth(eofToken, sourceFile.end, 0);
            setParent(eofToken, sourceFile);
            return sourceFile;
        });
    }
    function emitUsingBuildInfo(config, host, getCommandLine, customTransformers) {
        var _a, _b;
        (_a = tracing) == null || _a.push(tracing.Phase.Emit, "emitUsingBuildInfo", {}, /*separateBeginAndEnd*/ true);
        mark("beforeEmit");
        const result = emitUsingBuildInfoWorker(config, host, getCommandLine, customTransformers);
        mark("afterEmit");
        measure("Emit", "beforeEmit", "afterEmit");
        (_b = tracing) == null || _b.pop();
        return result;
    }
    function emitUsingBuildInfoWorker(config, host, getCommandLine, customTransformers) {
        const { buildInfoPath: buildInfoPath , jsFilePath: jsFilePath , sourceMapFilePath: sourceMapFilePath , declarationFilePath: declarationFilePath , declarationMapPath: declarationMapPath  } = getOutputPathsForBundle(config.options, /*forceDtsPaths*/ false);
        const buildInfo = host.getBuildInfo(buildInfoPath, config.options.configFilePath);
        if (!buildInfo) return buildInfoPath;
        if (!buildInfo.bundle || !buildInfo.bundle.js || declarationFilePath && !buildInfo.bundle.dts) return buildInfoPath;
        const jsFileText = host.readFile(Debug.checkDefined(jsFilePath));
        if (!jsFileText) return jsFilePath;
        if (computeSignature(jsFileText, host) !== buildInfo.bundle.js.hash) return jsFilePath;
        const sourceMapText = sourceMapFilePath && host.readFile(sourceMapFilePath);
        if (sourceMapFilePath && !sourceMapText || config.options.inlineSourceMap) return sourceMapFilePath || "inline sourcemap decoding";
        if (sourceMapFilePath && computeSignature(sourceMapText, host) !== buildInfo.bundle.js.mapHash) return sourceMapFilePath;
        const declarationText = declarationFilePath && host.readFile(declarationFilePath);
        if (declarationFilePath && !declarationText) return declarationFilePath;
        if (declarationFilePath && computeSignature(declarationText, host) !== buildInfo.bundle.dts.hash) return declarationFilePath;
        const declarationMapText = declarationMapPath && host.readFile(declarationMapPath);
        if (declarationMapPath && !declarationMapText || config.options.inlineSourceMap) return declarationMapPath || "inline sourcemap decoding";
        if (declarationMapPath && computeSignature(declarationMapText, host) !== buildInfo.bundle.dts.mapHash) return declarationMapPath;
        const buildInfoDirectory = getDirectoryPath(getNormalizedAbsolutePath(buildInfoPath, host.getCurrentDirectory()));
        const ownPrependInput = createInputFilesWithFileTexts(jsFilePath, jsFileText, sourceMapFilePath, sourceMapText, declarationFilePath, declarationText, declarationMapPath, declarationMapText, buildInfoPath, buildInfo, /*oldFileOfCurrentEmit*/ true);
        const outputFiles = [];
        const prependNodes = createPrependNodes(config.projectReferences, getCommandLine, (f)=>host.readFile(f), host);
        const sourceFilesForJsEmit = createSourceFilesFromBundleBuildInfo(buildInfo.bundle, buildInfoDirectory, host);
        let changedDtsText;
        let changedDtsData;
        const emitHost = {
            getPrependNodes: memoize(()=>[
                    ...prependNodes,
                    ownPrependInput
                ]),
            getCanonicalFileName: host.getCanonicalFileName,
            getCommonSourceDirectory: ()=>getNormalizedAbsolutePath(buildInfo.bundle.commonSourceDirectory, buildInfoDirectory),
            getCompilerOptions: ()=>config.options,
            getCurrentDirectory: ()=>host.getCurrentDirectory(),
            getSourceFile: returnUndefined,
            getSourceFileByPath: returnUndefined,
            getSourceFiles: ()=>sourceFilesForJsEmit,
            getLibFileFromReference: notImplemented,
            isSourceFileFromExternalLibrary: returnFalse,
            getResolvedProjectReferenceToRedirect: returnUndefined,
            getProjectReferenceRedirect: returnUndefined,
            isSourceOfProjectReferenceRedirect: returnFalse,
            writeFile: (name, text, writeByteOrderMark, _onError, _sourceFiles, data)=>{
                switch(name){
                    case jsFilePath:
                        if (jsFileText === text) return;
                        break;
                    case sourceMapFilePath:
                        if (sourceMapText === text) return;
                        break;
                    case buildInfoPath:
                        break;
                    case declarationFilePath:
                        if (declarationText === text) return;
                        changedDtsText = text;
                        changedDtsData = data;
                        break;
                    case declarationMapPath:
                        if (declarationMapText === text) return;
                        break;
                    default:
                        Debug.fail(`Unexpected path: ${name}`);
                }
                outputFiles.push({
                    name: name,
                    text: text,
                    writeByteOrderMark: writeByteOrderMark,
                    data: data
                });
            },
            isEmitBlocked: returnFalse,
            readFile: (f)=>host.readFile(f),
            fileExists: (f)=>host.fileExists(f),
            useCaseSensitiveFileNames: ()=>host.useCaseSensitiveFileNames(),
            getBuildInfo: (bundle)=>{
                const program = buildInfo.program;
                if (program && changedDtsText !== void 0 && config.options.composite) program.outSignature = computeSignature(changedDtsText, host, changedDtsData);
                const { js: js , dts: dts , sourceFiles: sourceFiles  } = buildInfo.bundle;
                bundle.js.sources = js.sources;
                if (dts) bundle.dts.sources = dts.sources;
                bundle.sourceFiles = sourceFiles;
                return createBuildInfo(program, bundle);
            },
            getSourceFileFromReference: returnUndefined,
            redirectTargetsMap: createMultiMap(),
            getFileIncludeReasons: notImplemented,
            createHash: maybeBind(host, host.createHash)
        };
        emitFiles(notImplementedResolver, emitHost, /*targetSourceFile*/ void 0, getTransformers(config.options, customTransformers));
        return outputFiles;
    }
    function createPrinter(printerOptions = {}, handlers = {}) {
        var { hasGlobalName: hasGlobalName , onEmitNode: onEmitNode = noEmitNotification , isEmitNotificationEnabled: isEmitNotificationEnabled , substituteNode: substituteNode = noEmitSubstitution , onBeforeEmitNode: onBeforeEmitNode , onAfterEmitNode: onAfterEmitNode , onBeforeEmitNodeArray: onBeforeEmitNodeArray , onAfterEmitNodeArray: onAfterEmitNodeArray , onBeforeEmitToken: onBeforeEmitToken , onAfterEmitToken: onAfterEmitToken  } = handlers;
        var extendedDiagnostics = !!printerOptions.extendedDiagnostics;
        var newLine = getNewLineCharacter(printerOptions);
        var moduleKind = getEmitModuleKind(printerOptions);
        var bundledHelpers = /* @__PURE__ */ new Map();
        var currentSourceFile;
        var nodeIdToGeneratedName;
        var nodeIdToGeneratedPrivateName;
        var autoGeneratedIdToGeneratedName;
        var generatedNames;
        var formattedNameTempFlagsStack;
        var formattedNameTempFlags;
        var privateNameTempFlagsStack;
        var privateNameTempFlags;
        var tempFlagsStack;
        var tempFlags;
        var reservedNamesStack;
        var reservedNames;
        var reservedPrivateNamesStack;
        var reservedPrivateNames;
        var preserveSourceNewlines = printerOptions.preserveSourceNewlines;
        var nextListElementPos;
        var writer;
        var ownWriter;
        var write = writeBase;
        var isOwnFileEmit;
        var bundleFileInfo = printerOptions.writeBundleFileInfo ? {
            sections: []
        } : void 0;
        var relativeToBuildInfo = bundleFileInfo ? Debug.checkDefined(printerOptions.relativeToBuildInfo) : void 0;
        var recordInternalSection = printerOptions.recordInternalSection;
        var sourceFileTextPos = 0;
        var sourceFileTextKind = "text" /* Text */ ;
        var sourceMapsDisabled = true;
        var sourceMapGenerator;
        var sourceMapSource;
        var sourceMapSourceIndex = -1;
        var mostRecentlyAddedSourceMapSource;
        var mostRecentlyAddedSourceMapSourceIndex = -1;
        var containerPos = -1;
        var containerEnd = -1;
        var declarationListContainerEnd = -1;
        var currentLineMap;
        var detachedCommentsInfo;
        var hasWrittenComment = false;
        var commentsDisabled = !!printerOptions.removeComments;
        var lastSubstitution;
        var currentParenthesizerRule;
        var { enter: enterComment , exit: exitComment  } = createTimerIf(extendedDiagnostics, "commentTime", "beforeComment", "afterComment");
        var parenthesizer = factory.parenthesizer;
        var typeArgumentParenthesizerRuleSelector = {
            select: (index)=>index === 0 ? parenthesizer.parenthesizeLeadingTypeArgument : void 0
        };
        var emitBinaryExpression = createEmitBinaryExpression();
        reset2();
        return {
            printNode: // public API
            printNode,
            printList: printList,
            printFile: printFile,
            printBundle: printBundle,
            writeNode: // internal API
            writeNode,
            writeList: writeList,
            writeFile: writeFile2,
            writeBundle: writeBundle,
            bundleFileInfo: bundleFileInfo
        };
        function printNode(hint, node, sourceFile) {
            switch(hint){
                case 0 /* SourceFile */ :
                    Debug.assert(isSourceFile(node), "Expected a SourceFile node.");
                    break;
                case 2 /* IdentifierName */ :
                    Debug.assert(isIdentifier(node), "Expected an Identifier node.");
                    break;
                case 1 /* Expression */ :
                    Debug.assert(isExpression(node), "Expected an Expression node.");
                    break;
            }
            switch(node.kind){
                case 311 /* SourceFile */ :
                    return printFile(node);
                case 312 /* Bundle */ :
                    return printBundle(node);
                case 313 /* UnparsedSource */ :
                    return printUnparsedSource(node);
            }
            writeNode(hint, node, sourceFile, beginPrint());
            return endPrint();
        }
        function printList(format, nodes, sourceFile) {
            writeList(format, nodes, sourceFile, beginPrint());
            return endPrint();
        }
        function printBundle(bundle) {
            writeBundle(bundle, beginPrint(), /*sourceMapGenerator*/ void 0);
            return endPrint();
        }
        function printFile(sourceFile) {
            writeFile2(sourceFile, beginPrint(), /*sourceMapGenerator*/ void 0);
            return endPrint();
        }
        function printUnparsedSource(unparsed) {
            writeUnparsedSource(unparsed, beginPrint());
            return endPrint();
        }
        function writeNode(hint, node, sourceFile, output) {
            const previousWriter = writer;
            setWriter(output, /*_sourceMapGenerator*/ void 0);
            print(hint, node, sourceFile);
            reset2();
            writer = previousWriter;
        }
        function writeList(format, nodes, sourceFile, output) {
            const previousWriter = writer;
            setWriter(output, /*_sourceMapGenerator*/ void 0);
            if (sourceFile) setSourceFile(sourceFile);
            emitList(/*parentNode*/ void 0, nodes, format);
            reset2();
            writer = previousWriter;
        }
        function getTextPosWithWriteLine() {
            return writer.getTextPosWithWriteLine ? writer.getTextPosWithWriteLine() : writer.getTextPos();
        }
        function updateOrPushBundleFileTextLike(pos, end, kind) {
            const last2 = lastOrUndefined(bundleFileInfo.sections);
            if (last2 && last2.kind === kind) last2.end = end;
            else bundleFileInfo.sections.push({
                pos: pos,
                end: end,
                kind: kind
            });
        }
        function recordBundleFileInternalSectionStart(node) {
            if (recordInternalSection && bundleFileInfo && currentSourceFile && (isDeclaration(node) || isVariableStatement(node)) && isInternalDeclaration(node, currentSourceFile) && sourceFileTextKind !== "internal" /* Internal */ ) {
                const prevSourceFileTextKind = sourceFileTextKind;
                recordBundleFileTextLikeSection(writer.getTextPos());
                sourceFileTextPos = getTextPosWithWriteLine();
                sourceFileTextKind = "internal" /* Internal */ ;
                return prevSourceFileTextKind;
            }
            return void 0;
        }
        function recordBundleFileInternalSectionEnd(prevSourceFileTextKind) {
            if (prevSourceFileTextKind) {
                recordBundleFileTextLikeSection(writer.getTextPos());
                sourceFileTextPos = getTextPosWithWriteLine();
                sourceFileTextKind = prevSourceFileTextKind;
            }
        }
        function recordBundleFileTextLikeSection(end) {
            if (sourceFileTextPos < end) {
                updateOrPushBundleFileTextLike(sourceFileTextPos, end, sourceFileTextKind);
                return true;
            }
            return false;
        }
        function writeBundle(bundle, output, sourceMapGenerator2) {
            isOwnFileEmit = false;
            const previousWriter = writer;
            setWriter(output, sourceMapGenerator2);
            emitShebangIfNeeded(bundle);
            emitPrologueDirectivesIfNeeded(bundle);
            emitHelpers(bundle);
            emitSyntheticTripleSlashReferencesIfNeeded(bundle);
            for (const prepend of bundle.prepends){
                writeLine();
                const pos = writer.getTextPos();
                const savedSections = bundleFileInfo && bundleFileInfo.sections;
                if (savedSections) bundleFileInfo.sections = [];
                print(4 /* Unspecified */ , prepend, /*sourceFile*/ void 0);
                if (bundleFileInfo) {
                    const newSections = bundleFileInfo.sections;
                    bundleFileInfo.sections = savedSections;
                    if (prepend.oldFileOfCurrentEmit) bundleFileInfo.sections.push(...newSections);
                    else {
                        newSections.forEach((section)=>Debug.assert(isBundleFileTextLike(section)));
                        bundleFileInfo.sections.push({
                            pos: pos,
                            end: writer.getTextPos(),
                            kind: "prepend" /* Prepend */ ,
                            data: relativeToBuildInfo(prepend.fileName),
                            texts: newSections
                        });
                    }
                }
            }
            sourceFileTextPos = getTextPosWithWriteLine();
            for (const sourceFile of bundle.sourceFiles)print(0 /* SourceFile */ , sourceFile, sourceFile);
            if (bundleFileInfo && bundle.sourceFiles.length) {
                const end = writer.getTextPos();
                if (recordBundleFileTextLikeSection(end)) {
                    const prologues = getPrologueDirectivesFromBundledSourceFiles(bundle);
                    if (prologues) {
                        if (!bundleFileInfo.sources) bundleFileInfo.sources = {};
                        bundleFileInfo.sources.prologues = prologues;
                    }
                    const helpers = getHelpersFromBundledSourceFiles(bundle);
                    if (helpers) {
                        if (!bundleFileInfo.sources) bundleFileInfo.sources = {};
                        bundleFileInfo.sources.helpers = helpers;
                    }
                }
            }
            reset2();
            writer = previousWriter;
        }
        function writeUnparsedSource(unparsed, output) {
            const previousWriter = writer;
            setWriter(output, /*_sourceMapGenerator*/ void 0);
            print(4 /* Unspecified */ , unparsed, /*sourceFile*/ void 0);
            reset2();
            writer = previousWriter;
        }
        function writeFile2(sourceFile, output, sourceMapGenerator2) {
            isOwnFileEmit = true;
            const previousWriter = writer;
            setWriter(output, sourceMapGenerator2);
            emitShebangIfNeeded(sourceFile);
            emitPrologueDirectivesIfNeeded(sourceFile);
            print(0 /* SourceFile */ , sourceFile, sourceFile);
            reset2();
            writer = previousWriter;
        }
        function beginPrint() {
            return ownWriter || (ownWriter = createTextWriter(newLine));
        }
        function endPrint() {
            const text = ownWriter.getText();
            ownWriter.clear();
            return text;
        }
        function print(hint, node, sourceFile) {
            if (sourceFile) setSourceFile(sourceFile);
            pipelineEmit(hint, node, /*parenthesizerRule*/ void 0);
        }
        function setSourceFile(sourceFile) {
            currentSourceFile = sourceFile;
            currentLineMap = void 0;
            detachedCommentsInfo = void 0;
            if (sourceFile) setSourceMapSource(sourceFile);
        }
        function setWriter(_writer, _sourceMapGenerator) {
            if (_writer && printerOptions.omitTrailingSemicolon) _writer = getTrailingSemicolonDeferringWriter(_writer);
            writer = _writer;
            sourceMapGenerator = _sourceMapGenerator;
            sourceMapsDisabled = !writer || !sourceMapGenerator;
        }
        function reset2() {
            nodeIdToGeneratedName = [];
            nodeIdToGeneratedPrivateName = [];
            autoGeneratedIdToGeneratedName = [];
            generatedNames = /* @__PURE__ */ new Set();
            formattedNameTempFlagsStack = [];
            formattedNameTempFlags = /* @__PURE__ */ new Map();
            privateNameTempFlagsStack = [];
            privateNameTempFlags = 0 /* Auto */ ;
            tempFlagsStack = [];
            tempFlags = 0 /* Auto */ ;
            reservedNamesStack = [];
            reservedNames = void 0;
            reservedPrivateNamesStack = [];
            reservedPrivateNames = void 0;
            currentSourceFile = void 0;
            currentLineMap = void 0;
            detachedCommentsInfo = void 0;
            setWriter(/*output*/ void 0, /*_sourceMapGenerator*/ void 0);
        }
        function getCurrentLineMap() {
            return currentLineMap || (currentLineMap = getLineStarts(Debug.checkDefined(currentSourceFile)));
        }
        function emit(node, parenthesizerRule) {
            if (node === void 0) return;
            const prevSourceFileTextKind = recordBundleFileInternalSectionStart(node);
            pipelineEmit(4 /* Unspecified */ , node, parenthesizerRule);
            recordBundleFileInternalSectionEnd(prevSourceFileTextKind);
        }
        function emitIdentifierName(node) {
            if (node === void 0) return;
            pipelineEmit(2 /* IdentifierName */ , node, /*parenthesizerRule*/ void 0);
        }
        function emitExpression(node, parenthesizerRule) {
            if (node === void 0) return;
            pipelineEmit(1 /* Expression */ , node, parenthesizerRule);
        }
        function emitJsxAttributeValue(node) {
            pipelineEmit(isStringLiteral(node) ? 6 /* JsxAttributeValue */  : 4 /* Unspecified */ , node);
        }
        function beforeEmitNode(node) {
            if (preserveSourceNewlines && getInternalEmitFlags(node) & 4 /* IgnoreSourceNewlines */ ) preserveSourceNewlines = false;
        }
        function afterEmitNode(savedPreserveSourceNewlines) {
            preserveSourceNewlines = savedPreserveSourceNewlines;
        }
        function pipelineEmit(emitHint, node, parenthesizerRule) {
            currentParenthesizerRule = parenthesizerRule;
            const pipelinePhase = getPipelinePhase(0 /* Notification */ , emitHint, node);
            pipelinePhase(emitHint, node);
            currentParenthesizerRule = void 0;
        }
        function shouldEmitComments(node) {
            return !commentsDisabled && !isSourceFile(node);
        }
        function shouldEmitSourceMaps(node) {
            return !sourceMapsDisabled && !isSourceFile(node) && !isInJsonFile(node) && !isUnparsedSource(node) && !isUnparsedPrepend(node);
        }
        function getPipelinePhase(phase, emitHint, node) {
            switch(phase){
                case 0 /* Notification */ :
                    if (onEmitNode !== noEmitNotification && (!isEmitNotificationEnabled || isEmitNotificationEnabled(node))) return pipelineEmitWithNotification;
                case 1 /* Substitution */ :
                    if (substituteNode !== noEmitSubstitution && (lastSubstitution = substituteNode(emitHint, node) || node) !== node) {
                        if (currentParenthesizerRule) lastSubstitution = currentParenthesizerRule(lastSubstitution);
                        return pipelineEmitWithSubstitution;
                    }
                case 2 /* Comments */ :
                    if (shouldEmitComments(node)) return pipelineEmitWithComments;
                case 3 /* SourceMaps */ :
                    if (shouldEmitSourceMaps(node)) return pipelineEmitWithSourceMaps;
                case 4 /* Emit */ :
                    return pipelineEmitWithHint;
                default:
                    return Debug.assertNever(phase);
            }
        }
        function getNextPipelinePhase(currentPhase, emitHint, node) {
            return getPipelinePhase(currentPhase + 1, emitHint, node);
        }
        function pipelineEmitWithNotification(hint, node) {
            const pipelinePhase = getNextPipelinePhase(0 /* Notification */ , hint, node);
            onEmitNode(hint, node, pipelinePhase);
        }
        function pipelineEmitWithHint(hint, node) {
            onBeforeEmitNode == null || onBeforeEmitNode(node);
            if (preserveSourceNewlines) {
                const savedPreserveSourceNewlines = preserveSourceNewlines;
                beforeEmitNode(node);
                pipelineEmitWithHintWorker(hint, node);
                afterEmitNode(savedPreserveSourceNewlines);
            } else pipelineEmitWithHintWorker(hint, node);
            onAfterEmitNode == null || onAfterEmitNode(node);
            currentParenthesizerRule = void 0;
        }
        function pipelineEmitWithHintWorker(hint, node, allowSnippets = true) {
            if (allowSnippets) {
                const snippet = getSnippetElement(node);
                if (snippet) return emitSnippetNode(hint, node, snippet);
            }
            if (hint === 0 /* SourceFile */ ) return emitSourceFile(cast(node, isSourceFile));
            if (hint === 2 /* IdentifierName */ ) return emitIdentifier(cast(node, isIdentifier));
            if (hint === 6 /* JsxAttributeValue */ ) return emitLiteral(cast(node, isStringLiteral), /*jsxAttributeEscape*/ true);
            if (hint === 3 /* MappedTypeParameter */ ) return emitMappedTypeParameter(cast(node, isTypeParameterDeclaration));
            if (hint === 5 /* EmbeddedStatement */ ) {
                Debug.assertNode(node, isEmptyStatement);
                return emitEmptyStatement(/*isEmbeddedStatement*/ true);
            }
            if (hint === 4 /* Unspecified */ ) {
                switch(node.kind){
                    case 16 /* TemplateHead */ :
                    case 17 /* TemplateMiddle */ :
                    case 18 /* TemplateTail */ :
                        return emitLiteral(node, /*jsxAttributeEscape*/ false);
                    case 80 /* Identifier */ :
                        return emitIdentifier(node);
                    case 81 /* PrivateIdentifier */ :
                        return emitPrivateIdentifier(node);
                    case 165 /* QualifiedName */ :
                        return emitQualifiedName(node);
                    case 166 /* ComputedPropertyName */ :
                        return emitComputedPropertyName(node);
                    case 167 /* TypeParameter */ :
                        return emitTypeParameter(node);
                    case 168 /* Parameter */ :
                        return emitParameter(node);
                    case 169 /* Decorator */ :
                        return emitDecorator(node);
                    case 170 /* PropertySignature */ :
                        return emitPropertySignature(node);
                    case 171 /* PropertyDeclaration */ :
                        return emitPropertyDeclaration(node);
                    case 172 /* MethodSignature */ :
                        return emitMethodSignature(node);
                    case 173 /* MethodDeclaration */ :
                        return emitMethodDeclaration(node);
                    case 174 /* ClassStaticBlockDeclaration */ :
                        return emitClassStaticBlockDeclaration(node);
                    case 175 /* Constructor */ :
                        return emitConstructor(node);
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                        return emitAccessorDeclaration(node);
                    case 178 /* CallSignature */ :
                        return emitCallSignature(node);
                    case 179 /* ConstructSignature */ :
                        return emitConstructSignature(node);
                    case 180 /* IndexSignature */ :
                        return emitIndexSignature(node);
                    case 181 /* TypePredicate */ :
                        return emitTypePredicate(node);
                    case 182 /* TypeReference */ :
                        return emitTypeReference(node);
                    case 183 /* FunctionType */ :
                        return emitFunctionType(node);
                    case 184 /* ConstructorType */ :
                        return emitConstructorType(node);
                    case 185 /* TypeQuery */ :
                        return emitTypeQuery(node);
                    case 186 /* TypeLiteral */ :
                        return emitTypeLiteral(node);
                    case 187 /* ArrayType */ :
                        return emitArrayType(node);
                    case 188 /* TupleType */ :
                        return emitTupleType(node);
                    case 189 /* OptionalType */ :
                        return emitOptionalType(node);
                    case 191 /* UnionType */ :
                        return emitUnionType(node);
                    case 192 /* IntersectionType */ :
                        return emitIntersectionType(node);
                    case 193 /* ConditionalType */ :
                        return emitConditionalType(node);
                    case 194 /* InferType */ :
                        return emitInferType(node);
                    case 195 /* ParenthesizedType */ :
                        return emitParenthesizedType(node);
                    case 232 /* ExpressionWithTypeArguments */ :
                        return emitExpressionWithTypeArguments(node);
                    case 196 /* ThisType */ :
                        return emitThisType();
                    case 197 /* TypeOperator */ :
                        return emitTypeOperator(node);
                    case 198 /* IndexedAccessType */ :
                        return emitIndexedAccessType(node);
                    case 199 /* MappedType */ :
                        return emitMappedType(node);
                    case 200 /* LiteralType */ :
                        return emitLiteralType(node);
                    case 201 /* NamedTupleMember */ :
                        return emitNamedTupleMember(node);
                    case 202 /* TemplateLiteralType */ :
                        return emitTemplateType(node);
                    case 203 /* TemplateLiteralTypeSpan */ :
                        return emitTemplateTypeSpan(node);
                    case 204 /* ImportType */ :
                        return emitImportTypeNode(node);
                    case 205 /* ObjectBindingPattern */ :
                        return emitObjectBindingPattern(node);
                    case 206 /* ArrayBindingPattern */ :
                        return emitArrayBindingPattern(node);
                    case 207 /* BindingElement */ :
                        return emitBindingElement(node);
                    case 238 /* TemplateSpan */ :
                        return emitTemplateSpan(node);
                    case 239 /* SemicolonClassElement */ :
                        return emitSemicolonClassElement();
                    case 240 /* Block */ :
                        return emitBlock(node);
                    case 242 /* VariableStatement */ :
                        return emitVariableStatement(node);
                    case 241 /* EmptyStatement */ :
                        return emitEmptyStatement(/*isEmbeddedStatement*/ false);
                    case 243 /* ExpressionStatement */ :
                        return emitExpressionStatement(node);
                    case 244 /* IfStatement */ :
                        return emitIfStatement(node);
                    case 245 /* DoStatement */ :
                        return emitDoStatement(node);
                    case 246 /* WhileStatement */ :
                        return emitWhileStatement(node);
                    case 247 /* ForStatement */ :
                        return emitForStatement(node);
                    case 248 /* ForInStatement */ :
                        return emitForInStatement(node);
                    case 249 /* ForOfStatement */ :
                        return emitForOfStatement(node);
                    case 250 /* ContinueStatement */ :
                        return emitContinueStatement(node);
                    case 251 /* BreakStatement */ :
                        return emitBreakStatement(node);
                    case 252 /* ReturnStatement */ :
                        return emitReturnStatement(node);
                    case 253 /* WithStatement */ :
                        return emitWithStatement(node);
                    case 254 /* SwitchStatement */ :
                        return emitSwitchStatement(node);
                    case 255 /* LabeledStatement */ :
                        return emitLabeledStatement(node);
                    case 256 /* ThrowStatement */ :
                        return emitThrowStatement(node);
                    case 257 /* TryStatement */ :
                        return emitTryStatement(node);
                    case 258 /* DebuggerStatement */ :
                        return emitDebuggerStatement(node);
                    case 259 /* VariableDeclaration */ :
                        return emitVariableDeclaration(node);
                    case 260 /* VariableDeclarationList */ :
                        return emitVariableDeclarationList(node);
                    case 261 /* FunctionDeclaration */ :
                        return emitFunctionDeclaration(node);
                    case 262 /* ClassDeclaration */ :
                        return emitClassDeclaration(node);
                    case 263 /* InterfaceDeclaration */ :
                        return emitInterfaceDeclaration(node);
                    case 264 /* TypeAliasDeclaration */ :
                        return emitTypeAliasDeclaration(node);
                    case 265 /* EnumDeclaration */ :
                        return emitEnumDeclaration(node);
                    case 266 /* ModuleDeclaration */ :
                        return emitModuleDeclaration(node);
                    case 267 /* ModuleBlock */ :
                        return emitModuleBlock(node);
                    case 268 /* CaseBlock */ :
                        return emitCaseBlock(node);
                    case 269 /* NamespaceExportDeclaration */ :
                        return emitNamespaceExportDeclaration(node);
                    case 270 /* ImportEqualsDeclaration */ :
                        return emitImportEqualsDeclaration(node);
                    case 271 /* ImportDeclaration */ :
                        return emitImportDeclaration(node);
                    case 272 /* ImportClause */ :
                        return emitImportClause(node);
                    case 273 /* NamespaceImport */ :
                        return emitNamespaceImport(node);
                    case 279 /* NamespaceExport */ :
                        return emitNamespaceExport(node);
                    case 274 /* NamedImports */ :
                        return emitNamedImports(node);
                    case 275 /* ImportSpecifier */ :
                        return emitImportSpecifier(node);
                    case 276 /* ExportAssignment */ :
                        return emitExportAssignment(node);
                    case 277 /* ExportDeclaration */ :
                        return emitExportDeclaration(node);
                    case 278 /* NamedExports */ :
                        return emitNamedExports(node);
                    case 280 /* ExportSpecifier */ :
                        return emitExportSpecifier(node);
                    case 299 /* AssertClause */ :
                        return emitAssertClause(node);
                    case 300 /* AssertEntry */ :
                        return emitAssertEntry(node);
                    case 281 /* MissingDeclaration */ :
                        return;
                    case 282 /* ExternalModuleReference */ :
                        return emitExternalModuleReference(node);
                    case 12 /* JsxText */ :
                        return emitJsxText(node);
                    case 285 /* JsxOpeningElement */ :
                    case 288 /* JsxOpeningFragment */ :
                        return emitJsxOpeningElementOrFragment(node);
                    case 286 /* JsxClosingElement */ :
                    case 289 /* JsxClosingFragment */ :
                        return emitJsxClosingElementOrFragment(node);
                    case 290 /* JsxAttribute */ :
                        return emitJsxAttribute(node);
                    case 291 /* JsxAttributes */ :
                        return emitJsxAttributes(node);
                    case 292 /* JsxSpreadAttribute */ :
                        return emitJsxSpreadAttribute(node);
                    case 293 /* JsxExpression */ :
                        return emitJsxExpression(node);
                    case 294 /* JsxNamespacedName */ :
                        return emitJsxNamespacedName(node);
                    case 295 /* CaseClause */ :
                        return emitCaseClause(node);
                    case 296 /* DefaultClause */ :
                        return emitDefaultClause(node);
                    case 297 /* HeritageClause */ :
                        return emitHeritageClause(node);
                    case 298 /* CatchClause */ :
                        return emitCatchClause(node);
                    case 302 /* PropertyAssignment */ :
                        return emitPropertyAssignment(node);
                    case 303 /* ShorthandPropertyAssignment */ :
                        return emitShorthandPropertyAssignment(node);
                    case 304 /* SpreadAssignment */ :
                        return emitSpreadAssignment(node);
                    case 305 /* EnumMember */ :
                        return emitEnumMember(node);
                    case 306 /* UnparsedPrologue */ :
                        return writeUnparsedNode(node);
                    case 313 /* UnparsedSource */ :
                    case 307 /* UnparsedPrepend */ :
                        return emitUnparsedSourceOrPrepend(node);
                    case 308 /* UnparsedText */ :
                    case 309 /* UnparsedInternalText */ :
                        return emitUnparsedTextLike(node);
                    case 310 /* UnparsedSyntheticReference */ :
                        return emitUnparsedSyntheticReference(node);
                    case 311 /* SourceFile */ :
                        return emitSourceFile(node);
                    case 312 /* Bundle */ :
                        return Debug.fail("Bundles should be printed using printBundle");
                    case 314 /* InputFiles */ :
                        return Debug.fail("InputFiles should not be printed");
                    case 315 /* JSDocTypeExpression */ :
                        return emitJSDocTypeExpression(node);
                    case 316 /* JSDocNameReference */ :
                        return emitJSDocNameReference(node);
                    case 318 /* JSDocAllType */ :
                        return writePunctuation("*");
                    case 319 /* JSDocUnknownType */ :
                        return writePunctuation("?");
                    case 320 /* JSDocNullableType */ :
                        return emitJSDocNullableType(node);
                    case 321 /* JSDocNonNullableType */ :
                        return emitJSDocNonNullableType(node);
                    case 322 /* JSDocOptionalType */ :
                        return emitJSDocOptionalType(node);
                    case 323 /* JSDocFunctionType */ :
                        return emitJSDocFunctionType(node);
                    case 190 /* RestType */ :
                    case 324 /* JSDocVariadicType */ :
                        return emitRestOrJSDocVariadicType(node);
                    case 325 /* JSDocNamepathType */ :
                        return;
                    case 326 /* JSDoc */ :
                        return emitJSDoc(node);
                    case 328 /* JSDocTypeLiteral */ :
                        return emitJSDocTypeLiteral(node);
                    case 329 /* JSDocSignature */ :
                        return emitJSDocSignature(node);
                    case 333 /* JSDocTag */ :
                    case 338 /* JSDocClassTag */ :
                    case 343 /* JSDocOverrideTag */ :
                        return emitJSDocSimpleTag(node);
                    case 334 /* JSDocAugmentsTag */ :
                    case 335 /* JSDocImplementsTag */ :
                        return emitJSDocHeritageTag(node);
                    case 336 /* JSDocAuthorTag */ :
                    case 337 /* JSDocDeprecatedTag */ :
                        return;
                    case 339 /* JSDocPublicTag */ :
                    case 340 /* JSDocPrivateTag */ :
                    case 341 /* JSDocProtectedTag */ :
                    case 342 /* JSDocReadonlyTag */ :
                        return;
                    case 344 /* JSDocCallbackTag */ :
                        return emitJSDocCallbackTag(node);
                    case 345 /* JSDocOverloadTag */ :
                        return emitJSDocOverloadTag(node);
                    case 347 /* JSDocParameterTag */ :
                    case 354 /* JSDocPropertyTag */ :
                        return emitJSDocPropertyLikeTag(node);
                    case 346 /* JSDocEnumTag */ :
                    case 348 /* JSDocReturnTag */ :
                    case 349 /* JSDocThisTag */ :
                    case 350 /* JSDocTypeTag */ :
                    case 355 /* JSDocThrowsTag */ :
                    case 356 /* JSDocSatisfiesTag */ :
                        return emitJSDocSimpleTypedTag(node);
                    case 351 /* JSDocTemplateTag */ :
                        return emitJSDocTemplateTag(node);
                    case 352 /* JSDocTypedefTag */ :
                        return emitJSDocTypedefTag(node);
                    case 353 /* JSDocSeeTag */ :
                        return emitJSDocSeeTag(node);
                    case 358 /* NotEmittedStatement */ :
                        return;
                }
                if (isExpression(node)) {
                    hint = 1 /* Expression */ ;
                    if (substituteNode !== noEmitSubstitution) {
                        const substitute = substituteNode(hint, node) || node;
                        if (substitute !== node) {
                            node = substitute;
                            if (currentParenthesizerRule) node = currentParenthesizerRule(node);
                        }
                    }
                }
            }
            if (hint === 1 /* Expression */ ) switch(node.kind){
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                    return emitNumericOrBigIntLiteral(node);
                case 11 /* StringLiteral */ :
                case 14 /* RegularExpressionLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    return emitLiteral(node, /*jsxAttributeEscape*/ false);
                case 80 /* Identifier */ :
                    return emitIdentifier(node);
                case 81 /* PrivateIdentifier */ :
                    return emitPrivateIdentifier(node);
                case 208 /* ArrayLiteralExpression */ :
                    return emitArrayLiteralExpression(node);
                case 209 /* ObjectLiteralExpression */ :
                    return emitObjectLiteralExpression(node);
                case 210 /* PropertyAccessExpression */ :
                    return emitPropertyAccessExpression(node);
                case 211 /* ElementAccessExpression */ :
                    return emitElementAccessExpression(node);
                case 212 /* CallExpression */ :
                    return emitCallExpression(node);
                case 213 /* NewExpression */ :
                    return emitNewExpression(node);
                case 214 /* TaggedTemplateExpression */ :
                    return emitTaggedTemplateExpression(node);
                case 215 /* TypeAssertionExpression */ :
                    return emitTypeAssertionExpression(node);
                case 216 /* ParenthesizedExpression */ :
                    return emitParenthesizedExpression(node);
                case 217 /* FunctionExpression */ :
                    return emitFunctionExpression(node);
                case 218 /* ArrowFunction */ :
                    return emitArrowFunction(node);
                case 219 /* DeleteExpression */ :
                    return emitDeleteExpression(node);
                case 220 /* TypeOfExpression */ :
                    return emitTypeOfExpression(node);
                case 221 /* VoidExpression */ :
                    return emitVoidExpression(node);
                case 222 /* AwaitExpression */ :
                    return emitAwaitExpression(node);
                case 223 /* PrefixUnaryExpression */ :
                    return emitPrefixUnaryExpression(node);
                case 224 /* PostfixUnaryExpression */ :
                    return emitPostfixUnaryExpression(node);
                case 225 /* BinaryExpression */ :
                    return emitBinaryExpression(node);
                case 226 /* ConditionalExpression */ :
                    return emitConditionalExpression(node);
                case 227 /* TemplateExpression */ :
                    return emitTemplateExpression(node);
                case 228 /* YieldExpression */ :
                    return emitYieldExpression(node);
                case 229 /* SpreadElement */ :
                    return emitSpreadElement(node);
                case 230 /* ClassExpression */ :
                    return emitClassExpression(node);
                case 231 /* OmittedExpression */ :
                    return;
                case 233 /* AsExpression */ :
                    return emitAsExpression(node);
                case 234 /* NonNullExpression */ :
                    return emitNonNullExpression(node);
                case 232 /* ExpressionWithTypeArguments */ :
                    return emitExpressionWithTypeArguments(node);
                case 237 /* SatisfiesExpression */ :
                    return emitSatisfiesExpression(node);
                case 235 /* MetaProperty */ :
                    return emitMetaProperty(node);
                case 236 /* SyntheticExpression */ :
                    return Debug.fail("SyntheticExpression should never be printed.");
                case 281 /* MissingDeclaration */ :
                    return;
                case 283 /* JsxElement */ :
                    return emitJsxElement(node);
                case 284 /* JsxSelfClosingElement */ :
                    return emitJsxSelfClosingElement(node);
                case 287 /* JsxFragment */ :
                    return emitJsxFragment(node);
                case 357 /* SyntaxList */ :
                    return Debug.fail("SyntaxList should not be printed");
                case 358 /* NotEmittedStatement */ :
                    return;
                case 359 /* PartiallyEmittedExpression */ :
                    return emitPartiallyEmittedExpression(node);
                case 360 /* CommaListExpression */ :
                    return emitCommaList(node);
                case 361 /* SyntheticReferenceExpression */ :
                    return Debug.fail("SyntheticReferenceExpression should not be printed");
            }
            if (isKeyword(node.kind)) return writeTokenNode(node, writeKeyword);
            if (isTokenKind(node.kind)) return writeTokenNode(node, writePunctuation);
            Debug.fail(`Unhandled SyntaxKind: ${Debug.formatSyntaxKind(node.kind)}.`);
        }
        function emitMappedTypeParameter(node) {
            emit(node.name);
            writeSpace();
            writeKeyword("in");
            writeSpace();
            emit(node.constraint);
        }
        function pipelineEmitWithSubstitution(hint, node) {
            const pipelinePhase = getNextPipelinePhase(1 /* Substitution */ , hint, node);
            Debug.assertIsDefined(lastSubstitution);
            node = lastSubstitution;
            lastSubstitution = void 0;
            pipelinePhase(hint, node);
        }
        function getHelpersFromBundledSourceFiles(bundle) {
            let result;
            if (moduleKind === 0 /* None */  || printerOptions.noEmitHelpers) return void 0;
            const bundledHelpers2 = /* @__PURE__ */ new Map();
            for (const sourceFile of bundle.sourceFiles){
                const shouldSkip = getExternalHelpersModuleName(sourceFile) !== void 0;
                const helpers = getSortedEmitHelpers(sourceFile);
                if (!helpers) continue;
                for (const helper of helpers)if (!helper.scoped && !shouldSkip && !bundledHelpers2.get(helper.name)) {
                    bundledHelpers2.set(helper.name, true);
                    (result || (result = [])).push(helper.name);
                }
            }
            return result;
        }
        function emitHelpers(node) {
            let helpersEmitted = false;
            const bundle = node.kind === 312 /* Bundle */  ? node : void 0;
            if (bundle && moduleKind === 0 /* None */ ) return;
            const numPrepends = bundle ? bundle.prepends.length : 0;
            const numNodes = bundle ? bundle.sourceFiles.length + numPrepends : 1;
            for(let i = 0; i < numNodes; i++){
                const currentNode = bundle ? i < numPrepends ? bundle.prepends[i] : bundle.sourceFiles[i - numPrepends] : node;
                const sourceFile = isSourceFile(currentNode) ? currentNode : isUnparsedSource(currentNode) ? void 0 : currentSourceFile;
                const shouldSkip = printerOptions.noEmitHelpers || !!sourceFile && hasRecordedExternalHelpers(sourceFile);
                const shouldBundle = (isSourceFile(currentNode) || isUnparsedSource(currentNode)) && !isOwnFileEmit;
                const helpers = isUnparsedSource(currentNode) ? currentNode.helpers : getSortedEmitHelpers(currentNode);
                if (helpers) for (const helper of helpers){
                    if (!helper.scoped) {
                        if (shouldSkip) continue;
                        if (shouldBundle) {
                            if (bundledHelpers.get(helper.name)) continue;
                            bundledHelpers.set(helper.name, true);
                        }
                    } else if (bundle) continue;
                    const pos = getTextPosWithWriteLine();
                    if (typeof helper.text === "string") writeLines(helper.text);
                    else writeLines(helper.text(makeFileLevelOptimisticUniqueName));
                    if (bundleFileInfo) bundleFileInfo.sections.push({
                        pos: pos,
                        end: writer.getTextPos(),
                        kind: "emitHelpers" /* EmitHelpers */ ,
                        data: helper.name
                    });
                    helpersEmitted = true;
                }
            }
            return helpersEmitted;
        }
        function getSortedEmitHelpers(node) {
            const helpers = getEmitHelpers(node);
            return helpers && stableSort(helpers, compareEmitHelpers);
        }
        function emitNumericOrBigIntLiteral(node) {
            emitLiteral(node, /*jsxAttributeEscape*/ false);
        }
        function emitLiteral(node, jsxAttributeEscape) {
            const text = getLiteralTextOfNode(node, printerOptions.neverAsciiEscape, jsxAttributeEscape);
            if ((printerOptions.sourceMap || printerOptions.inlineSourceMap) && (node.kind === 11 /* StringLiteral */  || isTemplateLiteralKind(node.kind))) writeLiteral(text);
            else writeStringLiteral(text);
        }
        function emitUnparsedSourceOrPrepend(unparsed) {
            for (const text of unparsed.texts){
                writeLine();
                emit(text);
            }
        }
        function writeUnparsedNode(unparsed) {
            writer.rawWrite(unparsed.parent.text.substring(unparsed.pos, unparsed.end));
        }
        function emitUnparsedTextLike(unparsed) {
            const pos = getTextPosWithWriteLine();
            writeUnparsedNode(unparsed);
            if (bundleFileInfo) updateOrPushBundleFileTextLike(pos, writer.getTextPos(), unparsed.kind === 308 /* UnparsedText */  ? "text" /* Text */  : "internal" /* Internal */ );
        }
        function emitUnparsedSyntheticReference(unparsed) {
            const pos = getTextPosWithWriteLine();
            writeUnparsedNode(unparsed);
            if (bundleFileInfo) {
                const section = clone(unparsed.section);
                section.pos = pos;
                section.end = writer.getTextPos();
                bundleFileInfo.sections.push(section);
            }
        }
        function emitSnippetNode(hint, node, snippet) {
            switch(snippet.kind){
                case 1 /* Placeholder */ :
                    emitPlaceholder(hint, node, snippet);
                    break;
                case 0 /* TabStop */ :
                    emitTabStop(hint, node, snippet);
                    break;
            }
        }
        function emitPlaceholder(hint, node, snippet) {
            nonEscapingWrite(`\${${snippet.order}:`);
            pipelineEmitWithHintWorker(hint, node, /*allowSnippets*/ false);
            nonEscapingWrite(`}`);
        }
        function emitTabStop(hint, node, snippet) {
            Debug.assert(node.kind === 241 /* EmptyStatement */ , `A tab stop cannot be attached to a node of kind ${Debug.formatSyntaxKind(node.kind)}.`);
            Debug.assert(hint !== 5 /* EmbeddedStatement */ , `A tab stop cannot be attached to an embedded statement.`);
            nonEscapingWrite(`$${snippet.order}`);
        }
        function emitIdentifier(node) {
            const writeText = node.symbol ? writeSymbol : write;
            writeText(getTextOfNode2(node, /*includeTrivia*/ false), node.symbol);
            emitList(node, getIdentifierTypeArguments(node), 53776 /* TypeParameters */ );
        }
        function emitPrivateIdentifier(node) {
            write(getTextOfNode2(node, /*includeTrivia*/ false));
        }
        function emitQualifiedName(node) {
            emitEntityName(node.left);
            writePunctuation(".");
            emit(node.right);
        }
        function emitEntityName(node) {
            if (node.kind === 80 /* Identifier */ ) emitExpression(node);
            else emit(node);
        }
        function emitComputedPropertyName(node) {
            const savedPrivateNameTempFlags = privateNameTempFlags;
            const savedReservedMemberNames = reservedPrivateNames;
            popPrivateNameGenerationScope();
            writePunctuation("[");
            emitExpression(node.expression, parenthesizer.parenthesizeExpressionOfComputedPropertyName);
            writePunctuation("]");
            pushPrivateNameGenerationScope(savedPrivateNameTempFlags, savedReservedMemberNames);
        }
        function emitTypeParameter(node) {
            emitModifierList(node, node.modifiers);
            emit(node.name);
            if (node.constraint) {
                writeSpace();
                writeKeyword("extends");
                writeSpace();
                emit(node.constraint);
            }
            if (node.default) {
                writeSpace();
                writeOperator("=");
                writeSpace();
                emit(node.default);
            }
        }
        function emitParameter(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ true);
            emit(node.dotDotDotToken);
            emitNodeWithWriter(node.name, writeParameter);
            emit(node.questionToken);
            if (node.parent && node.parent.kind === 323 /* JSDocFunctionType */  && !node.name) emit(node.type);
            else emitTypeAnnotation(node.type);
            emitInitializer(node.initializer, node.type ? node.type.end : node.questionToken ? node.questionToken.end : node.name ? node.name.end : node.modifiers ? node.modifiers.end : node.pos, node, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitDecorator(decorator) {
            writePunctuation("@");
            emitExpression(decorator.expression, parenthesizer.parenthesizeLeftSideOfAccess);
        }
        function emitPropertySignature(node) {
            emitModifierList(node, node.modifiers);
            emitNodeWithWriter(node.name, writeProperty);
            emit(node.questionToken);
            emitTypeAnnotation(node.type);
            writeTrailingSemicolon();
        }
        function emitPropertyDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ true);
            emit(node.name);
            emit(node.questionToken);
            emit(node.exclamationToken);
            emitTypeAnnotation(node.type);
            emitInitializer(node.initializer, node.type ? node.type.end : node.questionToken ? node.questionToken.end : node.name.end, node);
            writeTrailingSemicolon();
        }
        function emitMethodSignature(node) {
            pushNameGenerationScope(node);
            emitModifierList(node, node.modifiers);
            emit(node.name);
            emit(node.questionToken);
            emitTypeParameters(node, node.typeParameters);
            emitParameters(node, node.parameters);
            emitTypeAnnotation(node.type);
            writeTrailingSemicolon();
            popNameGenerationScope(node);
        }
        function emitMethodDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ true);
            emit(node.asteriskToken);
            emit(node.name);
            emit(node.questionToken);
            emitSignatureAndBody(node, emitSignatureHead);
        }
        function emitClassStaticBlockDeclaration(node) {
            writeKeyword("static");
            emitBlockFunctionBody(node.body);
        }
        function emitConstructor(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            writeKeyword("constructor");
            emitSignatureAndBody(node, emitSignatureHead);
        }
        function emitAccessorDeclaration(node) {
            const pos = emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ true);
            const token = node.kind === 176 /* GetAccessor */  ? 139 /* GetKeyword */  : 153 /* SetKeyword */ ;
            emitTokenWithComment(token, pos, writeKeyword, node);
            writeSpace();
            emit(node.name);
            emitSignatureAndBody(node, emitSignatureHead);
        }
        function emitCallSignature(node) {
            pushNameGenerationScope(node);
            emitTypeParameters(node, node.typeParameters);
            emitParameters(node, node.parameters);
            emitTypeAnnotation(node.type);
            writeTrailingSemicolon();
            popNameGenerationScope(node);
        }
        function emitConstructSignature(node) {
            pushNameGenerationScope(node);
            writeKeyword("new");
            writeSpace();
            emitTypeParameters(node, node.typeParameters);
            emitParameters(node, node.parameters);
            emitTypeAnnotation(node.type);
            writeTrailingSemicolon();
            popNameGenerationScope(node);
        }
        function emitIndexSignature(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            emitParametersForIndexSignature(node, node.parameters);
            emitTypeAnnotation(node.type);
            writeTrailingSemicolon();
        }
        function emitTemplateTypeSpan(node) {
            emit(node.type);
            emit(node.literal);
        }
        function emitSemicolonClassElement() {
            writeTrailingSemicolon();
        }
        function emitTypePredicate(node) {
            if (node.assertsModifier) {
                emit(node.assertsModifier);
                writeSpace();
            }
            emit(node.parameterName);
            if (node.type) {
                writeSpace();
                writeKeyword("is");
                writeSpace();
                emit(node.type);
            }
        }
        function emitTypeReference(node) {
            emit(node.typeName);
            emitTypeArguments(node, node.typeArguments);
        }
        function emitFunctionType(node) {
            pushNameGenerationScope(node);
            emitTypeParameters(node, node.typeParameters);
            emitParametersForArrow(node, node.parameters);
            writeSpace();
            writePunctuation("=>");
            writeSpace();
            emit(node.type);
            popNameGenerationScope(node);
        }
        function emitJSDocFunctionType(node) {
            writeKeyword("function");
            emitParameters(node, node.parameters);
            writePunctuation(":");
            emit(node.type);
        }
        function emitJSDocNullableType(node) {
            writePunctuation("?");
            emit(node.type);
        }
        function emitJSDocNonNullableType(node) {
            writePunctuation("!");
            emit(node.type);
        }
        function emitJSDocOptionalType(node) {
            emit(node.type);
            writePunctuation("=");
        }
        function emitConstructorType(node) {
            pushNameGenerationScope(node);
            emitModifierList(node, node.modifiers);
            writeKeyword("new");
            writeSpace();
            emitTypeParameters(node, node.typeParameters);
            emitParameters(node, node.parameters);
            writeSpace();
            writePunctuation("=>");
            writeSpace();
            emit(node.type);
            popNameGenerationScope(node);
        }
        function emitTypeQuery(node) {
            writeKeyword("typeof");
            writeSpace();
            emit(node.exprName);
            emitTypeArguments(node, node.typeArguments);
        }
        function emitTypeLiteral(node) {
            pushPrivateNameGenerationScope(0 /* Auto */ , /*newReservedMemberNames*/ void 0);
            writePunctuation("{");
            const flags = getEmitFlags(node) & 1 /* SingleLine */  ? 768 /* SingleLineTypeLiteralMembers */  : 32897 /* MultiLineTypeLiteralMembers */ ;
            emitList(node, node.members, flags | 524288 /* NoSpaceIfEmpty */ );
            writePunctuation("}");
            popPrivateNameGenerationScope();
        }
        function emitArrayType(node) {
            emit(node.elementType, parenthesizer.parenthesizeNonArrayTypeOfPostfixType);
            writePunctuation("[");
            writePunctuation("]");
        }
        function emitRestOrJSDocVariadicType(node) {
            writePunctuation("...");
            emit(node.type);
        }
        function emitTupleType(node) {
            emitTokenWithComment(23 /* OpenBracketToken */ , node.pos, writePunctuation, node);
            const flags = getEmitFlags(node) & 1 /* SingleLine */  ? 528 /* SingleLineTupleTypeElements */  : 657 /* MultiLineTupleTypeElements */ ;
            emitList(node, node.elements, flags | 524288 /* NoSpaceIfEmpty */ , parenthesizer.parenthesizeElementTypeOfTupleType);
            emitTokenWithComment(24 /* CloseBracketToken */ , node.elements.end, writePunctuation, node);
        }
        function emitNamedTupleMember(node) {
            emit(node.dotDotDotToken);
            emit(node.name);
            emit(node.questionToken);
            emitTokenWithComment(59 /* ColonToken */ , node.name.end, writePunctuation, node);
            writeSpace();
            emit(node.type);
        }
        function emitOptionalType(node) {
            emit(node.type, parenthesizer.parenthesizeTypeOfOptionalType);
            writePunctuation("?");
        }
        function emitUnionType(node) {
            emitList(node, node.types, 516 /* UnionTypeConstituents */ , parenthesizer.parenthesizeConstituentTypeOfUnionType);
        }
        function emitIntersectionType(node) {
            emitList(node, node.types, 520 /* IntersectionTypeConstituents */ , parenthesizer.parenthesizeConstituentTypeOfIntersectionType);
        }
        function emitConditionalType(node) {
            emit(node.checkType, parenthesizer.parenthesizeCheckTypeOfConditionalType);
            writeSpace();
            writeKeyword("extends");
            writeSpace();
            emit(node.extendsType, parenthesizer.parenthesizeExtendsTypeOfConditionalType);
            writeSpace();
            writePunctuation("?");
            writeSpace();
            emit(node.trueType);
            writeSpace();
            writePunctuation(":");
            writeSpace();
            emit(node.falseType);
        }
        function emitInferType(node) {
            writeKeyword("infer");
            writeSpace();
            emit(node.typeParameter);
        }
        function emitParenthesizedType(node) {
            writePunctuation("(");
            emit(node.type);
            writePunctuation(")");
        }
        function emitThisType() {
            writeKeyword("this");
        }
        function emitTypeOperator(node) {
            writeTokenText(node.operator, writeKeyword);
            writeSpace();
            const parenthesizerRule = node.operator === 148 /* ReadonlyKeyword */  ? parenthesizer.parenthesizeOperandOfReadonlyTypeOperator : parenthesizer.parenthesizeOperandOfTypeOperator;
            emit(node.type, parenthesizerRule);
        }
        function emitIndexedAccessType(node) {
            emit(node.objectType, parenthesizer.parenthesizeNonArrayTypeOfPostfixType);
            writePunctuation("[");
            emit(node.indexType);
            writePunctuation("]");
        }
        function emitMappedType(node) {
            const emitFlags = getEmitFlags(node);
            writePunctuation("{");
            if (emitFlags & 1 /* SingleLine */ ) writeSpace();
            else {
                writeLine();
                increaseIndent();
            }
            if (node.readonlyToken) {
                emit(node.readonlyToken);
                if (node.readonlyToken.kind !== 148 /* ReadonlyKeyword */ ) writeKeyword("readonly");
                writeSpace();
            }
            writePunctuation("[");
            pipelineEmit(3 /* MappedTypeParameter */ , node.typeParameter);
            if (node.nameType) {
                writeSpace();
                writeKeyword("as");
                writeSpace();
                emit(node.nameType);
            }
            writePunctuation("]");
            if (node.questionToken) {
                emit(node.questionToken);
                if (node.questionToken.kind !== 58 /* QuestionToken */ ) writePunctuation("?");
            }
            writePunctuation(":");
            writeSpace();
            emit(node.type);
            writeTrailingSemicolon();
            if (emitFlags & 1 /* SingleLine */ ) writeSpace();
            else {
                writeLine();
                decreaseIndent();
            }
            emitList(node, node.members, 2 /* PreserveLines */ );
            writePunctuation("}");
        }
        function emitLiteralType(node) {
            emitExpression(node.literal);
        }
        function emitTemplateType(node) {
            emit(node.head);
            emitList(node, node.templateSpans, 262144 /* TemplateExpressionSpans */ );
        }
        function emitImportTypeNode(node) {
            if (node.isTypeOf) {
                writeKeyword("typeof");
                writeSpace();
            }
            writeKeyword("import");
            writePunctuation("(");
            emit(node.argument);
            if (node.assertions) {
                writePunctuation(",");
                writeSpace();
                writePunctuation("{");
                writeSpace();
                writeKeyword("assert");
                writePunctuation(":");
                writeSpace();
                const elements = node.assertions.assertClause.elements;
                emitList(node.assertions.assertClause, elements, 526226 /* ImportClauseEntries */ );
                writeSpace();
                writePunctuation("}");
            }
            writePunctuation(")");
            if (node.qualifier) {
                writePunctuation(".");
                emit(node.qualifier);
            }
            emitTypeArguments(node, node.typeArguments);
        }
        function emitObjectBindingPattern(node) {
            writePunctuation("{");
            emitList(node, node.elements, 525136 /* ObjectBindingPatternElements */ );
            writePunctuation("}");
        }
        function emitArrayBindingPattern(node) {
            writePunctuation("[");
            emitList(node, node.elements, 524880 /* ArrayBindingPatternElements */ );
            writePunctuation("]");
        }
        function emitBindingElement(node) {
            emit(node.dotDotDotToken);
            if (node.propertyName) {
                emit(node.propertyName);
                writePunctuation(":");
                writeSpace();
            }
            emit(node.name);
            emitInitializer(node.initializer, node.name.end, node, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitArrayLiteralExpression(node) {
            const elements = node.elements;
            const preferNewLine = node.multiLine ? 65536 /* PreferNewLine */  : 0 /* None */ ;
            emitExpressionList(node, elements, 8914 /* ArrayLiteralExpressionElements */  | preferNewLine, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitObjectLiteralExpression(node) {
            pushPrivateNameGenerationScope(0 /* Auto */ , /*newReservedMemberNames*/ void 0);
            forEach(node.properties, generateMemberNames);
            const indentedFlag = getEmitFlags(node) & 131072 /* Indented */ ;
            if (indentedFlag) increaseIndent();
            const preferNewLine = node.multiLine ? 65536 /* PreferNewLine */  : 0 /* None */ ;
            const allowTrailingComma = currentSourceFile && currentSourceFile.languageVersion >= 1 /* ES5 */  && !isJsonSourceFile(currentSourceFile) ? 64 /* AllowTrailingComma */  : 0 /* None */ ;
            emitList(node, node.properties, 526226 /* ObjectLiteralExpressionProperties */  | allowTrailingComma | preferNewLine);
            if (indentedFlag) decreaseIndent();
            popPrivateNameGenerationScope();
        }
        function emitPropertyAccessExpression(node) {
            emitExpression(node.expression, parenthesizer.parenthesizeLeftSideOfAccess);
            const token = node.questionDotToken || setTextRangePosEnd(factory.createToken(25 /* DotToken */ ), node.expression.end, node.name.pos);
            const linesBeforeDot = getLinesBetweenNodes(node, node.expression, token);
            const linesAfterDot = getLinesBetweenNodes(node, token, node.name);
            writeLinesAndIndent(linesBeforeDot, /*writeSpaceIfNotIndenting*/ false);
            const shouldEmitDotDot = token.kind !== 29 /* QuestionDotToken */  && mayNeedDotDotForPropertyAccess(node.expression) && !writer.hasTrailingComment() && !writer.hasTrailingWhitespace();
            if (shouldEmitDotDot) writePunctuation(".");
            if (node.questionDotToken) emit(token);
            else emitTokenWithComment(token.kind, node.expression.end, writePunctuation, node);
            writeLinesAndIndent(linesAfterDot, /*writeSpaceIfNotIndenting*/ false);
            emit(node.name);
            decreaseIndentIf(linesBeforeDot, linesAfterDot);
        }
        function mayNeedDotDotForPropertyAccess(expression) {
            expression = skipPartiallyEmittedExpressions(expression);
            if (isNumericLiteral(expression)) {
                const text = getLiteralTextOfNode(expression, /*neverAsciiEscape*/ true, /*jsxAttributeEscape*/ false);
                return !(expression.numericLiteralFlags & 448 /* WithSpecifier */ ) && !stringContains(text, tokenToString(25 /* DotToken */ )) && !stringContains(text, String.fromCharCode(69 /* E */ )) && !stringContains(text, String.fromCharCode(101 /* e */ ));
            } else if (isAccessExpression(expression)) {
                const constantValue = getConstantValue(expression);
                return typeof constantValue === "number" && isFinite(constantValue) && Math.floor(constantValue) === constantValue;
            }
        }
        function emitElementAccessExpression(node) {
            emitExpression(node.expression, parenthesizer.parenthesizeLeftSideOfAccess);
            emit(node.questionDotToken);
            emitTokenWithComment(23 /* OpenBracketToken */ , node.expression.end, writePunctuation, node);
            emitExpression(node.argumentExpression);
            emitTokenWithComment(24 /* CloseBracketToken */ , node.argumentExpression.end, writePunctuation, node);
        }
        function emitCallExpression(node) {
            const indirectCall = getInternalEmitFlags(node) & 16 /* IndirectCall */ ;
            if (indirectCall) {
                writePunctuation("(");
                writeLiteral("0");
                writePunctuation(",");
                writeSpace();
            }
            emitExpression(node.expression, parenthesizer.parenthesizeLeftSideOfAccess);
            if (indirectCall) writePunctuation(")");
            emit(node.questionDotToken);
            emitTypeArguments(node, node.typeArguments);
            emitExpressionList(node, node.arguments, 2576 /* CallExpressionArguments */ , parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitNewExpression(node) {
            emitTokenWithComment(105 /* NewKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeExpressionOfNew);
            emitTypeArguments(node, node.typeArguments);
            emitExpressionList(node, node.arguments, 18960 /* NewExpressionArguments */ , parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitTaggedTemplateExpression(node) {
            const indirectCall = getInternalEmitFlags(node) & 16 /* IndirectCall */ ;
            if (indirectCall) {
                writePunctuation("(");
                writeLiteral("0");
                writePunctuation(",");
                writeSpace();
            }
            emitExpression(node.tag, parenthesizer.parenthesizeLeftSideOfAccess);
            if (indirectCall) writePunctuation(")");
            emitTypeArguments(node, node.typeArguments);
            writeSpace();
            emitExpression(node.template);
        }
        function emitTypeAssertionExpression(node) {
            writePunctuation("<");
            emit(node.type);
            writePunctuation(">");
            emitExpression(node.expression, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function emitParenthesizedExpression(node) {
            const openParenPos = emitTokenWithComment(21 /* OpenParenToken */ , node.pos, writePunctuation, node);
            const indented = writeLineSeparatorsAndIndentBefore(node.expression, node);
            emitExpression(node.expression, /*parenthesizerRule*/ void 0);
            writeLineSeparatorsAfter(node.expression, node);
            decreaseIndentIf(indented);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression ? node.expression.end : openParenPos, writePunctuation, node);
        }
        function emitFunctionExpression(node) {
            generateNameIfNeeded(node.name);
            emitFunctionDeclarationOrExpression(node);
        }
        function emitArrowFunction(node) {
            emitModifierList(node, node.modifiers);
            emitSignatureAndBody(node, emitArrowFunctionHead);
        }
        function emitArrowFunctionHead(node) {
            emitTypeParameters(node, node.typeParameters);
            emitParametersForArrow(node, node.parameters);
            emitTypeAnnotation(node.type);
            writeSpace();
            emit(node.equalsGreaterThanToken);
        }
        function emitDeleteExpression(node) {
            emitTokenWithComment(91 /* DeleteKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function emitTypeOfExpression(node) {
            emitTokenWithComment(114 /* TypeOfKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function emitVoidExpression(node) {
            emitTokenWithComment(116 /* VoidKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function emitAwaitExpression(node) {
            emitTokenWithComment(135 /* AwaitKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function emitPrefixUnaryExpression(node) {
            writeTokenText(node.operator, writeOperator);
            if (shouldEmitWhitespaceBeforeOperand(node)) writeSpace();
            emitExpression(node.operand, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function shouldEmitWhitespaceBeforeOperand(node) {
            const operand = node.operand;
            return operand.kind === 223 /* PrefixUnaryExpression */  && (node.operator === 40 /* PlusToken */  && (operand.operator === 40 /* PlusToken */  || operand.operator === 46 /* PlusPlusToken */ ) || node.operator === 41 /* MinusToken */  && (operand.operator === 41 /* MinusToken */  || operand.operator === 47 /* MinusMinusToken */ ));
        }
        function emitPostfixUnaryExpression(node) {
            emitExpression(node.operand, parenthesizer.parenthesizeOperandOfPostfixUnary);
            writeTokenText(node.operator, writeOperator);
        }
        function createEmitBinaryExpression() {
            return createBinaryExpressionTrampoline(onEnter, onLeft, onOperator, onRight, onExit, /*foldState*/ void 0);
            function onEnter(node, state) {
                if (state) {
                    state.stackIndex++;
                    state.preserveSourceNewlinesStack[state.stackIndex] = preserveSourceNewlines;
                    state.containerPosStack[state.stackIndex] = containerPos;
                    state.containerEndStack[state.stackIndex] = containerEnd;
                    state.declarationListContainerEndStack[state.stackIndex] = declarationListContainerEnd;
                    const emitComments2 = state.shouldEmitCommentsStack[state.stackIndex] = shouldEmitComments(node);
                    const emitSourceMaps = state.shouldEmitSourceMapsStack[state.stackIndex] = shouldEmitSourceMaps(node);
                    onBeforeEmitNode == null || onBeforeEmitNode(node);
                    if (emitComments2) emitCommentsBeforeNode(node);
                    if (emitSourceMaps) emitSourceMapsBeforeNode(node);
                    beforeEmitNode(node);
                } else state = {
                    stackIndex: 0,
                    preserveSourceNewlinesStack: [
                        void 0
                    ],
                    containerPosStack: [
                        -1
                    ],
                    containerEndStack: [
                        -1
                    ],
                    declarationListContainerEndStack: [
                        -1
                    ],
                    shouldEmitCommentsStack: [
                        false
                    ],
                    shouldEmitSourceMapsStack: [
                        false
                    ]
                };
                return state;
            }
            function onLeft(next, _workArea, parent2) {
                return maybeEmitExpression(next, parent2, "left");
            }
            function onOperator(operatorToken, _state, node) {
                const isCommaOperator = operatorToken.kind !== 28 /* CommaToken */ ;
                const linesBeforeOperator = getLinesBetweenNodes(node, node.left, operatorToken);
                const linesAfterOperator = getLinesBetweenNodes(node, operatorToken, node.right);
                writeLinesAndIndent(linesBeforeOperator, isCommaOperator);
                emitLeadingCommentsOfPosition(operatorToken.pos);
                writeTokenNode(operatorToken, operatorToken.kind === 103 /* InKeyword */  ? writeKeyword : writeOperator);
                emitTrailingCommentsOfPosition(operatorToken.end, /*prefixSpace*/ true);
                writeLinesAndIndent(linesAfterOperator, /*writeSpaceIfNotIndenting*/ true);
            }
            function onRight(next, _workArea, parent2) {
                return maybeEmitExpression(next, parent2, "right");
            }
            function onExit(node, state) {
                const linesBeforeOperator = getLinesBetweenNodes(node, node.left, node.operatorToken);
                const linesAfterOperator = getLinesBetweenNodes(node, node.operatorToken, node.right);
                decreaseIndentIf(linesBeforeOperator, linesAfterOperator);
                if (state.stackIndex > 0) {
                    const savedPreserveSourceNewlines = state.preserveSourceNewlinesStack[state.stackIndex];
                    const savedContainerPos = state.containerPosStack[state.stackIndex];
                    const savedContainerEnd = state.containerEndStack[state.stackIndex];
                    const savedDeclarationListContainerEnd = state.declarationListContainerEndStack[state.stackIndex];
                    const shouldEmitComments2 = state.shouldEmitCommentsStack[state.stackIndex];
                    const shouldEmitSourceMaps2 = state.shouldEmitSourceMapsStack[state.stackIndex];
                    afterEmitNode(savedPreserveSourceNewlines);
                    if (shouldEmitSourceMaps2) emitSourceMapsAfterNode(node);
                    if (shouldEmitComments2) emitCommentsAfterNode(node, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd);
                    onAfterEmitNode == null || onAfterEmitNode(node);
                    state.stackIndex--;
                }
            }
            function maybeEmitExpression(next, parent2, side) {
                const parenthesizerRule = side === "left" ? parenthesizer.getParenthesizeLeftSideOfBinaryForOperator(parent2.operatorToken.kind) : parenthesizer.getParenthesizeRightSideOfBinaryForOperator(parent2.operatorToken.kind);
                let pipelinePhase = getPipelinePhase(0 /* Notification */ , 1 /* Expression */ , next);
                if (pipelinePhase === pipelineEmitWithSubstitution) {
                    Debug.assertIsDefined(lastSubstitution);
                    next = parenthesizerRule(cast(lastSubstitution, isExpression));
                    pipelinePhase = getNextPipelinePhase(1 /* Substitution */ , 1 /* Expression */ , next);
                    lastSubstitution = void 0;
                }
                if (pipelinePhase === pipelineEmitWithComments || pipelinePhase === pipelineEmitWithSourceMaps || pipelinePhase === pipelineEmitWithHint) {
                    if (isBinaryExpression(next)) return next;
                }
                currentParenthesizerRule = parenthesizerRule;
                pipelinePhase(1 /* Expression */ , next);
            }
        }
        function emitConditionalExpression(node) {
            const linesBeforeQuestion = getLinesBetweenNodes(node, node.condition, node.questionToken);
            const linesAfterQuestion = getLinesBetweenNodes(node, node.questionToken, node.whenTrue);
            const linesBeforeColon = getLinesBetweenNodes(node, node.whenTrue, node.colonToken);
            const linesAfterColon = getLinesBetweenNodes(node, node.colonToken, node.whenFalse);
            emitExpression(node.condition, parenthesizer.parenthesizeConditionOfConditionalExpression);
            writeLinesAndIndent(linesBeforeQuestion, /*writeSpaceIfNotIndenting*/ true);
            emit(node.questionToken);
            writeLinesAndIndent(linesAfterQuestion, /*writeSpaceIfNotIndenting*/ true);
            emitExpression(node.whenTrue, parenthesizer.parenthesizeBranchOfConditionalExpression);
            decreaseIndentIf(linesBeforeQuestion, linesAfterQuestion);
            writeLinesAndIndent(linesBeforeColon, /*writeSpaceIfNotIndenting*/ true);
            emit(node.colonToken);
            writeLinesAndIndent(linesAfterColon, /*writeSpaceIfNotIndenting*/ true);
            emitExpression(node.whenFalse, parenthesizer.parenthesizeBranchOfConditionalExpression);
            decreaseIndentIf(linesBeforeColon, linesAfterColon);
        }
        function emitTemplateExpression(node) {
            emit(node.head);
            emitList(node, node.templateSpans, 262144 /* TemplateExpressionSpans */ );
        }
        function emitYieldExpression(node) {
            emitTokenWithComment(127 /* YieldKeyword */ , node.pos, writeKeyword, node);
            emit(node.asteriskToken);
            emitExpressionWithLeadingSpace(node.expression && parenthesizeExpressionForNoAsi(node.expression), parenthesizeExpressionForNoAsiAndDisallowedComma);
        }
        function emitSpreadElement(node) {
            emitTokenWithComment(26 /* DotDotDotToken */ , node.pos, writePunctuation, node);
            emitExpression(node.expression, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitClassExpression(node) {
            generateNameIfNeeded(node.name);
            emitClassDeclarationOrExpression(node);
        }
        function emitExpressionWithTypeArguments(node) {
            emitExpression(node.expression, parenthesizer.parenthesizeLeftSideOfAccess);
            emitTypeArguments(node, node.typeArguments);
        }
        function emitAsExpression(node) {
            emitExpression(node.expression, /*parenthesizerRule*/ void 0);
            if (node.type) {
                writeSpace();
                writeKeyword("as");
                writeSpace();
                emit(node.type);
            }
        }
        function emitNonNullExpression(node) {
            emitExpression(node.expression, parenthesizer.parenthesizeLeftSideOfAccess);
            writeOperator("!");
        }
        function emitSatisfiesExpression(node) {
            emitExpression(node.expression, /*parenthesizerRule*/ void 0);
            if (node.type) {
                writeSpace();
                writeKeyword("satisfies");
                writeSpace();
                emit(node.type);
            }
        }
        function emitMetaProperty(node) {
            writeToken(node.keywordToken, node.pos, writePunctuation);
            writePunctuation(".");
            emit(node.name);
        }
        function emitTemplateSpan(node) {
            emitExpression(node.expression);
            emit(node.literal);
        }
        function emitBlock(node) {
            emitBlockStatements(node, /*forceSingleLine*/ !node.multiLine && isEmptyBlock(node));
        }
        function emitBlockStatements(node, forceSingleLine) {
            emitTokenWithComment(19 /* OpenBraceToken */ , node.pos, writePunctuation, /*contextNode*/ node);
            const format = forceSingleLine || getEmitFlags(node) & 1 /* SingleLine */  ? 768 /* SingleLineBlockStatements */  : 129 /* MultiLineBlockStatements */ ;
            emitList(node, node.statements, format);
            emitTokenWithComment(20 /* CloseBraceToken */ , node.statements.end, writePunctuation, /*contextNode*/ node, /*indentLeading*/ !!(format & 1 /* MultiLine */ ));
        }
        function emitVariableStatement(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            emit(node.declarationList);
            writeTrailingSemicolon();
        }
        function emitEmptyStatement(isEmbeddedStatement) {
            if (isEmbeddedStatement) writePunctuation(";");
            else writeTrailingSemicolon();
        }
        function emitExpressionStatement(node) {
            emitExpression(node.expression, parenthesizer.parenthesizeExpressionOfExpressionStatement);
            if (!currentSourceFile || !isJsonSourceFile(currentSourceFile) || nodeIsSynthesized(node.expression)) writeTrailingSemicolon();
        }
        function emitIfStatement(node) {
            const openParenPos = emitTokenWithComment(101 /* IfKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
            emitEmbeddedStatement(node, node.thenStatement);
            if (node.elseStatement) {
                writeLineOrSpace(node, node.thenStatement, node.elseStatement);
                emitTokenWithComment(93 /* ElseKeyword */ , node.thenStatement.end, writeKeyword, node);
                if (node.elseStatement.kind === 244 /* IfStatement */ ) {
                    writeSpace();
                    emit(node.elseStatement);
                } else emitEmbeddedStatement(node, node.elseStatement);
            }
        }
        function emitWhileClause(node, startPos) {
            const openParenPos = emitTokenWithComment(117 /* WhileKeyword */ , startPos, writeKeyword, node);
            writeSpace();
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
        }
        function emitDoStatement(node) {
            emitTokenWithComment(92 /* DoKeyword */ , node.pos, writeKeyword, node);
            emitEmbeddedStatement(node, node.statement);
            if (isBlock(node.statement) && !preserveSourceNewlines) writeSpace();
            else writeLineOrSpace(node, node.statement, node.expression);
            emitWhileClause(node, node.statement.end);
            writeTrailingSemicolon();
        }
        function emitWhileStatement(node) {
            emitWhileClause(node, node.pos);
            emitEmbeddedStatement(node, node.statement);
        }
        function emitForStatement(node) {
            const openParenPos = emitTokenWithComment(99 /* ForKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            let pos = emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, /*contextNode*/ node);
            emitForBinding(node.initializer);
            pos = emitTokenWithComment(27 /* SemicolonToken */ , node.initializer ? node.initializer.end : pos, writePunctuation, node);
            emitExpressionWithLeadingSpace(node.condition);
            pos = emitTokenWithComment(27 /* SemicolonToken */ , node.condition ? node.condition.end : pos, writePunctuation, node);
            emitExpressionWithLeadingSpace(node.incrementor);
            emitTokenWithComment(22 /* CloseParenToken */ , node.incrementor ? node.incrementor.end : pos, writePunctuation, node);
            emitEmbeddedStatement(node, node.statement);
        }
        function emitForInStatement(node) {
            const openParenPos = emitTokenWithComment(99 /* ForKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitForBinding(node.initializer);
            writeSpace();
            emitTokenWithComment(103 /* InKeyword */ , node.initializer.end, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
            emitEmbeddedStatement(node, node.statement);
        }
        function emitForOfStatement(node) {
            const openParenPos = emitTokenWithComment(99 /* ForKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitWithTrailingSpace(node.awaitModifier);
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitForBinding(node.initializer);
            writeSpace();
            emitTokenWithComment(164 /* OfKeyword */ , node.initializer.end, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
            emitEmbeddedStatement(node, node.statement);
        }
        function emitForBinding(node) {
            if (node !== void 0) {
                if (node.kind === 260 /* VariableDeclarationList */ ) emit(node);
                else emitExpression(node);
            }
        }
        function emitContinueStatement(node) {
            emitTokenWithComment(88 /* ContinueKeyword */ , node.pos, writeKeyword, node);
            emitWithLeadingSpace(node.label);
            writeTrailingSemicolon();
        }
        function emitBreakStatement(node) {
            emitTokenWithComment(83 /* BreakKeyword */ , node.pos, writeKeyword, node);
            emitWithLeadingSpace(node.label);
            writeTrailingSemicolon();
        }
        function emitTokenWithComment(token, pos, writer2, contextNode, indentLeading) {
            const node = getParseTreeNode(contextNode);
            const isSimilarNode = node && node.kind === contextNode.kind;
            const startPos = pos;
            if (isSimilarNode && currentSourceFile) pos = skipTrivia(currentSourceFile.text, pos);
            if (isSimilarNode && contextNode.pos !== startPos) {
                const needsIndent = indentLeading && currentSourceFile && !positionsAreOnSameLine(startPos, pos, currentSourceFile);
                if (needsIndent) increaseIndent();
                emitLeadingCommentsOfPosition(startPos);
                if (needsIndent) decreaseIndent();
            }
            pos = writeTokenText(token, writer2, pos);
            if (isSimilarNode && contextNode.end !== pos) {
                const isJsxExprContext = contextNode.kind === 293 /* JsxExpression */ ;
                emitTrailingCommentsOfPosition(pos, /*prefixSpace*/ !isJsxExprContext, /*forceNoNewline*/ isJsxExprContext);
            }
            return pos;
        }
        function commentWillEmitNewLine(node) {
            return node.kind === 2 /* SingleLineCommentTrivia */  || !!node.hasTrailingNewLine;
        }
        function willEmitLeadingNewLine(node) {
            if (!currentSourceFile) return false;
            if (some(getLeadingCommentRanges(currentSourceFile.text, node.pos), commentWillEmitNewLine)) return true;
            if (some(getSyntheticLeadingComments(node), commentWillEmitNewLine)) return true;
            if (isPartiallyEmittedExpression(node)) {
                if (node.pos !== node.expression.pos) {
                    if (some(getTrailingCommentRanges(currentSourceFile.text, node.expression.pos), commentWillEmitNewLine)) return true;
                }
                return willEmitLeadingNewLine(node.expression);
            }
            return false;
        }
        function parenthesizeExpressionForNoAsi(node) {
            if (!commentsDisabled && isPartiallyEmittedExpression(node) && willEmitLeadingNewLine(node)) {
                const parseNode = getParseTreeNode(node);
                if (parseNode && isParenthesizedExpression(parseNode)) {
                    const parens = factory.createParenthesizedExpression(node.expression);
                    setOriginalNode(parens, node);
                    setTextRange(parens, parseNode);
                    return parens;
                }
                return factory.createParenthesizedExpression(node);
            }
            return node;
        }
        function parenthesizeExpressionForNoAsiAndDisallowedComma(node) {
            return parenthesizeExpressionForNoAsi(parenthesizer.parenthesizeExpressionForDisallowedComma(node));
        }
        function emitReturnStatement(node) {
            emitTokenWithComment(107 /* ReturnKeyword */ , node.pos, writeKeyword, /*contextNode*/ node);
            emitExpressionWithLeadingSpace(node.expression && parenthesizeExpressionForNoAsi(node.expression), parenthesizeExpressionForNoAsi);
            writeTrailingSemicolon();
        }
        function emitWithStatement(node) {
            const openParenPos = emitTokenWithComment(118 /* WithKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
            emitEmbeddedStatement(node, node.statement);
        }
        function emitSwitchStatement(node) {
            const openParenPos = emitTokenWithComment(109 /* SwitchKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
            writeSpace();
            emit(node.caseBlock);
        }
        function emitLabeledStatement(node) {
            emit(node.label);
            emitTokenWithComment(59 /* ColonToken */ , node.label.end, writePunctuation, node);
            writeSpace();
            emit(node.statement);
        }
        function emitThrowStatement(node) {
            emitTokenWithComment(111 /* ThrowKeyword */ , node.pos, writeKeyword, node);
            emitExpressionWithLeadingSpace(parenthesizeExpressionForNoAsi(node.expression), parenthesizeExpressionForNoAsi);
            writeTrailingSemicolon();
        }
        function emitTryStatement(node) {
            emitTokenWithComment(113 /* TryKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emit(node.tryBlock);
            if (node.catchClause) {
                writeLineOrSpace(node, node.tryBlock, node.catchClause);
                emit(node.catchClause);
            }
            if (node.finallyBlock) {
                writeLineOrSpace(node, node.catchClause || node.tryBlock, node.finallyBlock);
                emitTokenWithComment(98 /* FinallyKeyword */ , (node.catchClause || node.tryBlock).end, writeKeyword, node);
                writeSpace();
                emit(node.finallyBlock);
            }
        }
        function emitDebuggerStatement(node) {
            writeToken(89 /* DebuggerKeyword */ , node.pos, writeKeyword);
            writeTrailingSemicolon();
        }
        function emitVariableDeclaration(node) {
            var _a, _b, _c;
            emit(node.name);
            emit(node.exclamationToken);
            emitTypeAnnotation(node.type);
            emitInitializer(node.initializer, ((_a = node.type) == null ? void 0 : _a.end) ?? ((_c = (_b = node.name.emitNode) == null ? void 0 : _b.typeNode) == null ? void 0 : _c.end) ?? node.name.end, node, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitVariableDeclarationList(node) {
            writeKeyword(isLet(node) ? "let" : isVarConst(node) ? "const" : "var");
            writeSpace();
            emitList(node, node.declarations, 528 /* VariableDeclarationList */ );
        }
        function emitFunctionDeclaration(node) {
            emitFunctionDeclarationOrExpression(node);
        }
        function emitFunctionDeclarationOrExpression(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            writeKeyword("function");
            emit(node.asteriskToken);
            writeSpace();
            emitIdentifierName(node.name);
            emitSignatureAndBody(node, emitSignatureHead);
        }
        function emitSignatureAndBody(node, emitSignatureHead2) {
            const body = node.body;
            if (body) {
                if (isBlock(body)) {
                    const indentedFlag = getEmitFlags(node) & 131072 /* Indented */ ;
                    if (indentedFlag) increaseIndent();
                    pushNameGenerationScope(node);
                    forEach(node.parameters, generateNames);
                    generateNames(node.body);
                    emitSignatureHead2(node);
                    emitBlockFunctionBody(body);
                    popNameGenerationScope(node);
                    if (indentedFlag) decreaseIndent();
                } else {
                    emitSignatureHead2(node);
                    writeSpace();
                    emitExpression(body, parenthesizer.parenthesizeConciseBodyOfArrowFunction);
                }
            } else {
                emitSignatureHead2(node);
                writeTrailingSemicolon();
            }
        }
        function emitSignatureHead(node) {
            emitTypeParameters(node, node.typeParameters);
            emitParameters(node, node.parameters);
            emitTypeAnnotation(node.type);
        }
        function shouldEmitBlockFunctionBodyOnSingleLine(body) {
            if (getEmitFlags(body) & 1 /* SingleLine */ ) return true;
            if (body.multiLine) return false;
            if (!nodeIsSynthesized(body) && currentSourceFile && !rangeIsOnSingleLine(body, currentSourceFile)) return false;
            if (getLeadingLineTerminatorCount(body, firstOrUndefined(body.statements), 2 /* PreserveLines */ ) || getClosingLineTerminatorCount(body, lastOrUndefined(body.statements), 2 /* PreserveLines */ , body.statements)) return false;
            let previousStatement;
            for (const statement of body.statements){
                if (getSeparatingLineTerminatorCount(previousStatement, statement, 2 /* PreserveLines */ ) > 0) return false;
                previousStatement = statement;
            }
            return true;
        }
        function emitBlockFunctionBody(body) {
            onBeforeEmitNode == null || onBeforeEmitNode(body);
            writeSpace();
            writePunctuation("{");
            increaseIndent();
            const emitBlockFunctionBody2 = shouldEmitBlockFunctionBodyOnSingleLine(body) ? emitBlockFunctionBodyOnSingleLine : emitBlockFunctionBodyWorker;
            emitBodyWithDetachedComments(body, body.statements, emitBlockFunctionBody2);
            decreaseIndent();
            writeToken(20 /* CloseBraceToken */ , body.statements.end, writePunctuation, body);
            onAfterEmitNode == null || onAfterEmitNode(body);
        }
        function emitBlockFunctionBodyOnSingleLine(body) {
            emitBlockFunctionBodyWorker(body, /*emitBlockFunctionBodyOnSingleLine*/ true);
        }
        function emitBlockFunctionBodyWorker(body, emitBlockFunctionBodyOnSingleLine2) {
            const statementOffset = emitPrologueDirectives(body.statements);
            const pos = writer.getTextPos();
            emitHelpers(body);
            if (statementOffset === 0 && pos === writer.getTextPos() && emitBlockFunctionBodyOnSingleLine2) {
                decreaseIndent();
                emitList(body, body.statements, 768 /* SingleLineFunctionBodyStatements */ );
                increaseIndent();
            } else emitList(body, body.statements, 1 /* MultiLineFunctionBodyStatements */ , /*parenthesizerRule*/ void 0, statementOffset);
        }
        function emitClassDeclaration(node) {
            emitClassDeclarationOrExpression(node);
        }
        function emitClassDeclarationOrExpression(node) {
            pushPrivateNameGenerationScope(0 /* Auto */ , /*newReservedMemberNames*/ void 0);
            forEach(node.members, generateMemberNames);
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ true);
            emitTokenWithComment(86 /* ClassKeyword */ , moveRangePastModifiers(node).pos, writeKeyword, node);
            if (node.name) {
                writeSpace();
                emitIdentifierName(node.name);
            }
            const indentedFlag = getEmitFlags(node) & 131072 /* Indented */ ;
            if (indentedFlag) increaseIndent();
            emitTypeParameters(node, node.typeParameters);
            emitList(node, node.heritageClauses, 0 /* ClassHeritageClauses */ );
            writeSpace();
            writePunctuation("{");
            emitList(node, node.members, 129 /* ClassMembers */ );
            writePunctuation("}");
            if (indentedFlag) decreaseIndent();
            popPrivateNameGenerationScope();
        }
        function emitInterfaceDeclaration(node) {
            pushPrivateNameGenerationScope(0 /* Auto */ , /*newReservedMemberNames*/ void 0);
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            writeKeyword("interface");
            writeSpace();
            emit(node.name);
            emitTypeParameters(node, node.typeParameters);
            emitList(node, node.heritageClauses, 512 /* HeritageClauses */ );
            writeSpace();
            writePunctuation("{");
            emitList(node, node.members, 129 /* InterfaceMembers */ );
            writePunctuation("}");
            popPrivateNameGenerationScope();
        }
        function emitTypeAliasDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            writeKeyword("type");
            writeSpace();
            emit(node.name);
            emitTypeParameters(node, node.typeParameters);
            writeSpace();
            writePunctuation("=");
            writeSpace();
            emit(node.type);
            writeTrailingSemicolon();
        }
        function emitEnumDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            writeKeyword("enum");
            writeSpace();
            emit(node.name);
            writeSpace();
            writePunctuation("{");
            emitList(node, node.members, 145 /* EnumMembers */ );
            writePunctuation("}");
        }
        function emitModuleDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            if (~node.flags & 1024 /* GlobalAugmentation */ ) {
                writeKeyword(node.flags & 16 /* Namespace */  ? "namespace" : "module");
                writeSpace();
            }
            emit(node.name);
            let body = node.body;
            if (!body) return writeTrailingSemicolon();
            while(body && isModuleDeclaration(body)){
                writePunctuation(".");
                emit(body.name);
                body = body.body;
            }
            writeSpace();
            emit(body);
        }
        function emitModuleBlock(node) {
            pushNameGenerationScope(node);
            forEach(node.statements, generateNames);
            emitBlockStatements(node, /*forceSingleLine*/ isEmptyBlock(node));
            popNameGenerationScope(node);
        }
        function emitCaseBlock(node) {
            emitTokenWithComment(19 /* OpenBraceToken */ , node.pos, writePunctuation, node);
            emitList(node, node.clauses, 129 /* CaseBlockClauses */ );
            emitTokenWithComment(20 /* CloseBraceToken */ , node.clauses.end, writePunctuation, node, /*indentLeading*/ true);
        }
        function emitImportEqualsDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            emitTokenWithComment(102 /* ImportKeyword */ , node.modifiers ? node.modifiers.end : node.pos, writeKeyword, node);
            writeSpace();
            if (node.isTypeOnly) {
                emitTokenWithComment(156 /* TypeKeyword */ , node.pos, writeKeyword, node);
                writeSpace();
            }
            emit(node.name);
            writeSpace();
            emitTokenWithComment(64 /* EqualsToken */ , node.name.end, writePunctuation, node);
            writeSpace();
            emitModuleReference(node.moduleReference);
            writeTrailingSemicolon();
        }
        function emitModuleReference(node) {
            if (node.kind === 80 /* Identifier */ ) emitExpression(node);
            else emit(node);
        }
        function emitImportDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            emitTokenWithComment(102 /* ImportKeyword */ , node.modifiers ? node.modifiers.end : node.pos, writeKeyword, node);
            writeSpace();
            if (node.importClause) {
                emit(node.importClause);
                writeSpace();
                emitTokenWithComment(160 /* FromKeyword */ , node.importClause.end, writeKeyword, node);
                writeSpace();
            }
            emitExpression(node.moduleSpecifier);
            if (node.assertClause) emitWithLeadingSpace(node.assertClause);
            writeTrailingSemicolon();
        }
        function emitImportClause(node) {
            if (node.isTypeOnly) {
                emitTokenWithComment(156 /* TypeKeyword */ , node.pos, writeKeyword, node);
                writeSpace();
            }
            emit(node.name);
            if (node.name && node.namedBindings) {
                emitTokenWithComment(28 /* CommaToken */ , node.name.end, writePunctuation, node);
                writeSpace();
            }
            emit(node.namedBindings);
        }
        function emitNamespaceImport(node) {
            const asPos = emitTokenWithComment(42 /* AsteriskToken */ , node.pos, writePunctuation, node);
            writeSpace();
            emitTokenWithComment(130 /* AsKeyword */ , asPos, writeKeyword, node);
            writeSpace();
            emit(node.name);
        }
        function emitNamedImports(node) {
            emitNamedImportsOrExports(node);
        }
        function emitImportSpecifier(node) {
            emitImportOrExportSpecifier(node);
        }
        function emitExportAssignment(node) {
            const nextPos = emitTokenWithComment(95 /* ExportKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            if (node.isExportEquals) emitTokenWithComment(64 /* EqualsToken */ , nextPos, writeOperator, node);
            else emitTokenWithComment(90 /* DefaultKeyword */ , nextPos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, node.isExportEquals ? parenthesizer.getParenthesizeRightSideOfBinaryForOperator(64 /* EqualsToken */ ) : parenthesizer.parenthesizeExpressionOfExportDefault);
            writeTrailingSemicolon();
        }
        function emitExportDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            let nextPos = emitTokenWithComment(95 /* ExportKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            if (node.isTypeOnly) {
                nextPos = emitTokenWithComment(156 /* TypeKeyword */ , nextPos, writeKeyword, node);
                writeSpace();
            }
            if (node.exportClause) emit(node.exportClause);
            else nextPos = emitTokenWithComment(42 /* AsteriskToken */ , nextPos, writePunctuation, node);
            if (node.moduleSpecifier) {
                writeSpace();
                const fromPos = node.exportClause ? node.exportClause.end : nextPos;
                emitTokenWithComment(160 /* FromKeyword */ , fromPos, writeKeyword, node);
                writeSpace();
                emitExpression(node.moduleSpecifier);
            }
            if (node.assertClause) emitWithLeadingSpace(node.assertClause);
            writeTrailingSemicolon();
        }
        function emitAssertClause(node) {
            emitTokenWithComment(132 /* AssertKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            const elements = node.elements;
            emitList(node, elements, 526226 /* ImportClauseEntries */ );
        }
        function emitAssertEntry(node) {
            emit(node.name);
            writePunctuation(":");
            writeSpace();
            const value1 = node.value;
            if ((getEmitFlags(value1) & 1024 /* NoLeadingComments */ ) === 0) {
                const commentRange = getCommentRange(value1);
                emitTrailingCommentsOfPosition(commentRange.pos);
            }
            emit(value1);
        }
        function emitNamespaceExportDeclaration(node) {
            let nextPos = emitTokenWithComment(95 /* ExportKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            nextPos = emitTokenWithComment(130 /* AsKeyword */ , nextPos, writeKeyword, node);
            writeSpace();
            nextPos = emitTokenWithComment(145 /* NamespaceKeyword */ , nextPos, writeKeyword, node);
            writeSpace();
            emit(node.name);
            writeTrailingSemicolon();
        }
        function emitNamespaceExport(node) {
            const asPos = emitTokenWithComment(42 /* AsteriskToken */ , node.pos, writePunctuation, node);
            writeSpace();
            emitTokenWithComment(130 /* AsKeyword */ , asPos, writeKeyword, node);
            writeSpace();
            emit(node.name);
        }
        function emitNamedExports(node) {
            emitNamedImportsOrExports(node);
        }
        function emitExportSpecifier(node) {
            emitImportOrExportSpecifier(node);
        }
        function emitNamedImportsOrExports(node) {
            writePunctuation("{");
            emitList(node, node.elements, 525136 /* NamedImportsOrExportsElements */ );
            writePunctuation("}");
        }
        function emitImportOrExportSpecifier(node) {
            if (node.isTypeOnly) {
                writeKeyword("type");
                writeSpace();
            }
            if (node.propertyName) {
                emit(node.propertyName);
                writeSpace();
                emitTokenWithComment(130 /* AsKeyword */ , node.propertyName.end, writeKeyword, node);
                writeSpace();
            }
            emit(node.name);
        }
        function emitExternalModuleReference(node) {
            writeKeyword("require");
            writePunctuation("(");
            emitExpression(node.expression);
            writePunctuation(")");
        }
        function emitJsxElement(node) {
            emit(node.openingElement);
            emitList(node, node.children, 262144 /* JsxElementOrFragmentChildren */ );
            emit(node.closingElement);
        }
        function emitJsxSelfClosingElement(node) {
            writePunctuation("<");
            emitJsxTagName(node.tagName);
            emitTypeArguments(node, node.typeArguments);
            writeSpace();
            emit(node.attributes);
            writePunctuation("/>");
        }
        function emitJsxFragment(node) {
            emit(node.openingFragment);
            emitList(node, node.children, 262144 /* JsxElementOrFragmentChildren */ );
            emit(node.closingFragment);
        }
        function emitJsxOpeningElementOrFragment(node) {
            writePunctuation("<");
            if (isJsxOpeningElement(node)) {
                const indented = writeLineSeparatorsAndIndentBefore(node.tagName, node);
                emitJsxTagName(node.tagName);
                emitTypeArguments(node, node.typeArguments);
                if (node.attributes.properties && node.attributes.properties.length > 0) writeSpace();
                emit(node.attributes);
                writeLineSeparatorsAfter(node.attributes, node);
                decreaseIndentIf(indented);
            }
            writePunctuation(">");
        }
        function emitJsxText(node) {
            writer.writeLiteral(node.text);
        }
        function emitJsxClosingElementOrFragment(node) {
            writePunctuation("</");
            if (isJsxClosingElement(node)) emitJsxTagName(node.tagName);
            writePunctuation(">");
        }
        function emitJsxAttributes(node) {
            emitList(node, node.properties, 262656 /* JsxElementAttributes */ );
        }
        function emitJsxAttribute(node) {
            emit(node.name);
            emitNodeWithPrefix("=", writePunctuation, node.initializer, emitJsxAttributeValue);
        }
        function emitJsxSpreadAttribute(node) {
            writePunctuation("{...");
            emitExpression(node.expression);
            writePunctuation("}");
        }
        function hasTrailingCommentsAtPosition(pos) {
            let result = false;
            forEachTrailingCommentRange((currentSourceFile == null ? void 0 : currentSourceFile.text) || "", pos + 1, ()=>result = true);
            return result;
        }
        function hasLeadingCommentsAtPosition(pos) {
            let result = false;
            forEachLeadingCommentRange((currentSourceFile == null ? void 0 : currentSourceFile.text) || "", pos + 1, ()=>result = true);
            return result;
        }
        function hasCommentsAtPosition(pos) {
            return hasTrailingCommentsAtPosition(pos) || hasLeadingCommentsAtPosition(pos);
        }
        function emitJsxExpression(node) {
            var _a;
            if (node.expression || !commentsDisabled && !nodeIsSynthesized(node) && hasCommentsAtPosition(node.pos)) {
                const isMultiline = currentSourceFile && !nodeIsSynthesized(node) && getLineAndCharacterOfPosition(currentSourceFile, node.pos).line !== getLineAndCharacterOfPosition(currentSourceFile, node.end).line;
                if (isMultiline) writer.increaseIndent();
                const end = emitTokenWithComment(19 /* OpenBraceToken */ , node.pos, writePunctuation, node);
                emit(node.dotDotDotToken);
                emitExpression(node.expression);
                emitTokenWithComment(20 /* CloseBraceToken */ , ((_a = node.expression) == null ? void 0 : _a.end) || end, writePunctuation, node);
                if (isMultiline) writer.decreaseIndent();
            }
        }
        function emitJsxNamespacedName(node) {
            emitIdentifierName(node.namespace);
            writePunctuation(":");
            emitIdentifierName(node.name);
        }
        function emitJsxTagName(node) {
            if (node.kind === 80 /* Identifier */ ) emitExpression(node);
            else emit(node);
        }
        function emitCaseClause(node) {
            emitTokenWithComment(84 /* CaseKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeExpressionForDisallowedComma);
            emitCaseOrDefaultClauseRest(node, node.statements, node.expression.end);
        }
        function emitDefaultClause(node) {
            const pos = emitTokenWithComment(90 /* DefaultKeyword */ , node.pos, writeKeyword, node);
            emitCaseOrDefaultClauseRest(node, node.statements, pos);
        }
        function emitCaseOrDefaultClauseRest(parentNode, statements, colonPos) {
            const emitAsSingleStatement = statements.length === 1 && // treat synthesized nodes as located on the same line for emit purposes
            (!currentSourceFile || nodeIsSynthesized(parentNode) || nodeIsSynthesized(statements[0]) || rangeStartPositionsAreOnSameLine(parentNode, statements[0], currentSourceFile));
            let format = 163969 /* CaseOrDefaultClauseStatements */ ;
            if (emitAsSingleStatement) {
                writeToken(59 /* ColonToken */ , colonPos, writePunctuation, parentNode);
                writeSpace();
                format &= -130;
            } else emitTokenWithComment(59 /* ColonToken */ , colonPos, writePunctuation, parentNode);
            emitList(parentNode, statements, format);
        }
        function emitHeritageClause(node) {
            writeSpace();
            writeTokenText(node.token, writeKeyword);
            writeSpace();
            emitList(node, node.types, 528 /* HeritageClauseTypes */ );
        }
        function emitCatchClause(node) {
            const openParenPos = emitTokenWithComment(85 /* CatchKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            if (node.variableDeclaration) {
                emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
                emit(node.variableDeclaration);
                emitTokenWithComment(22 /* CloseParenToken */ , node.variableDeclaration.end, writePunctuation, node);
                writeSpace();
            }
            emit(node.block);
        }
        function emitPropertyAssignment(node) {
            emit(node.name);
            writePunctuation(":");
            writeSpace();
            const initializer = node.initializer;
            if ((getEmitFlags(initializer) & 1024 /* NoLeadingComments */ ) === 0) {
                const commentRange = getCommentRange(initializer);
                emitTrailingCommentsOfPosition(commentRange.pos);
            }
            emitExpression(initializer, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitShorthandPropertyAssignment(node) {
            emit(node.name);
            if (node.objectAssignmentInitializer) {
                writeSpace();
                writePunctuation("=");
                writeSpace();
                emitExpression(node.objectAssignmentInitializer, parenthesizer.parenthesizeExpressionForDisallowedComma);
            }
        }
        function emitSpreadAssignment(node) {
            if (node.expression) {
                emitTokenWithComment(26 /* DotDotDotToken */ , node.pos, writePunctuation, node);
                emitExpression(node.expression, parenthesizer.parenthesizeExpressionForDisallowedComma);
            }
        }
        function emitEnumMember(node) {
            emit(node.name);
            emitInitializer(node.initializer, node.name.end, node, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitJSDoc(node) {
            write("/**");
            if (node.comment) {
                const text = getTextOfJSDocComment(node.comment);
                if (text) {
                    const lines = text.split(/\r\n?|\n/g);
                    for (const line of lines){
                        writeLine();
                        writeSpace();
                        writePunctuation("*");
                        writeSpace();
                        write(line);
                    }
                }
            }
            if (node.tags) {
                if (node.tags.length === 1 && node.tags[0].kind === 350 /* JSDocTypeTag */  && !node.comment) {
                    writeSpace();
                    emit(node.tags[0]);
                } else emitList(node, node.tags, 33 /* JSDocComment */ );
            }
            writeSpace();
            write("*/");
        }
        function emitJSDocSimpleTypedTag(tag) {
            emitJSDocTagName(tag.tagName);
            emitJSDocTypeExpression(tag.typeExpression);
            emitJSDocComment(tag.comment);
        }
        function emitJSDocSeeTag(tag) {
            emitJSDocTagName(tag.tagName);
            emit(tag.name);
            emitJSDocComment(tag.comment);
        }
        function emitJSDocNameReference(node) {
            writeSpace();
            writePunctuation("{");
            emit(node.name);
            writePunctuation("}");
        }
        function emitJSDocHeritageTag(tag) {
            emitJSDocTagName(tag.tagName);
            writeSpace();
            writePunctuation("{");
            emit(tag.class);
            writePunctuation("}");
            emitJSDocComment(tag.comment);
        }
        function emitJSDocTemplateTag(tag) {
            emitJSDocTagName(tag.tagName);
            emitJSDocTypeExpression(tag.constraint);
            writeSpace();
            emitList(tag, tag.typeParameters, 528 /* CommaListElements */ );
            emitJSDocComment(tag.comment);
        }
        function emitJSDocTypedefTag(tag) {
            emitJSDocTagName(tag.tagName);
            if (tag.typeExpression) {
                if (tag.typeExpression.kind === 315 /* JSDocTypeExpression */ ) emitJSDocTypeExpression(tag.typeExpression);
                else {
                    writeSpace();
                    writePunctuation("{");
                    write("Object");
                    if (tag.typeExpression.isArrayType) {
                        writePunctuation("[");
                        writePunctuation("]");
                    }
                    writePunctuation("}");
                }
            }
            if (tag.fullName) {
                writeSpace();
                emit(tag.fullName);
            }
            emitJSDocComment(tag.comment);
            if (tag.typeExpression && tag.typeExpression.kind === 328 /* JSDocTypeLiteral */ ) emitJSDocTypeLiteral(tag.typeExpression);
        }
        function emitJSDocCallbackTag(tag) {
            emitJSDocTagName(tag.tagName);
            if (tag.name) {
                writeSpace();
                emit(tag.name);
            }
            emitJSDocComment(tag.comment);
            emitJSDocSignature(tag.typeExpression);
        }
        function emitJSDocOverloadTag(tag) {
            emitJSDocComment(tag.comment);
            emitJSDocSignature(tag.typeExpression);
        }
        function emitJSDocSimpleTag(tag) {
            emitJSDocTagName(tag.tagName);
            emitJSDocComment(tag.comment);
        }
        function emitJSDocTypeLiteral(lit) {
            emitList(lit, factory.createNodeArray(lit.jsDocPropertyTags), 33 /* JSDocComment */ );
        }
        function emitJSDocSignature(sig) {
            if (sig.typeParameters) emitList(sig, factory.createNodeArray(sig.typeParameters), 33 /* JSDocComment */ );
            if (sig.parameters) emitList(sig, factory.createNodeArray(sig.parameters), 33 /* JSDocComment */ );
            if (sig.type) {
                writeLine();
                writeSpace();
                writePunctuation("*");
                writeSpace();
                emit(sig.type);
            }
        }
        function emitJSDocPropertyLikeTag(param) {
            emitJSDocTagName(param.tagName);
            emitJSDocTypeExpression(param.typeExpression);
            writeSpace();
            if (param.isBracketed) writePunctuation("[");
            emit(param.name);
            if (param.isBracketed) writePunctuation("]");
            emitJSDocComment(param.comment);
        }
        function emitJSDocTagName(tagName) {
            writePunctuation("@");
            emit(tagName);
        }
        function emitJSDocComment(comment) {
            const text = getTextOfJSDocComment(comment);
            if (text) {
                writeSpace();
                write(text);
            }
        }
        function emitJSDocTypeExpression(typeExpression) {
            if (typeExpression) {
                writeSpace();
                writePunctuation("{");
                emit(typeExpression.type);
                writePunctuation("}");
            }
        }
        function emitSourceFile(node) {
            writeLine();
            const statements = node.statements;
            const shouldEmitDetachedComment = statements.length === 0 || !isPrologueDirective(statements[0]) || nodeIsSynthesized(statements[0]);
            if (shouldEmitDetachedComment) {
                emitBodyWithDetachedComments(node, statements, emitSourceFileWorker);
                return;
            }
            emitSourceFileWorker(node);
        }
        function emitSyntheticTripleSlashReferencesIfNeeded(node) {
            emitTripleSlashDirectives(!!node.hasNoDefaultLib, node.syntheticFileReferences || [], node.syntheticTypeReferences || [], node.syntheticLibReferences || []);
            for (const prepend of node.prepends){
                if (isUnparsedSource(prepend) && prepend.syntheticReferences) for (const ref of prepend.syntheticReferences){
                    emit(ref);
                    writeLine();
                }
            }
        }
        function emitTripleSlashDirectivesIfNeeded(node) {
            if (node.isDeclarationFile) emitTripleSlashDirectives(node.hasNoDefaultLib, node.referencedFiles, node.typeReferenceDirectives, node.libReferenceDirectives);
        }
        function emitTripleSlashDirectives(hasNoDefaultLib, files, types, libs2) {
            if (hasNoDefaultLib) {
                const pos = writer.getTextPos();
                writeComment(`/// <reference no-default-lib="true"/>`);
                if (bundleFileInfo) bundleFileInfo.sections.push({
                    pos: pos,
                    end: writer.getTextPos(),
                    kind: "no-default-lib" /* NoDefaultLib */ 
                });
                writeLine();
            }
            if (currentSourceFile && currentSourceFile.moduleName) {
                writeComment(`/// <amd-module name="${currentSourceFile.moduleName}" />`);
                writeLine();
            }
            if (currentSourceFile && currentSourceFile.amdDependencies) for (const dep of currentSourceFile.amdDependencies){
                if (dep.name) writeComment(`/// <amd-dependency name="${dep.name}" path="${dep.path}" />`);
                else writeComment(`/// <amd-dependency path="${dep.path}" />`);
                writeLine();
            }
            for (const directive of files){
                const pos = writer.getTextPos();
                writeComment(`/// <reference path="${directive.fileName}" />`);
                if (bundleFileInfo) bundleFileInfo.sections.push({
                    pos: pos,
                    end: writer.getTextPos(),
                    kind: "reference" /* Reference */ ,
                    data: directive.fileName
                });
                writeLine();
            }
            for (const directive of types){
                const pos = writer.getTextPos();
                const resolutionMode = directive.resolutionMode && directive.resolutionMode !== (currentSourceFile == null ? void 0 : currentSourceFile.impliedNodeFormat) ? `resolution-mode="${directive.resolutionMode === 99 /* ESNext */  ? "import" : "require"}"` : "";
                writeComment(`/// <reference types="${directive.fileName}" ${resolutionMode}/>`);
                if (bundleFileInfo) bundleFileInfo.sections.push({
                    pos: pos,
                    end: writer.getTextPos(),
                    kind: !directive.resolutionMode ? "type" /* Type */  : directive.resolutionMode === 99 /* ESNext */  ? "type-import" /* TypeResolutionModeImport */  : "type-require" /* TypeResolutionModeRequire */ ,
                    data: directive.fileName
                });
                writeLine();
            }
            for (const directive of libs2){
                const pos = writer.getTextPos();
                writeComment(`/// <reference lib="${directive.fileName}" />`);
                if (bundleFileInfo) bundleFileInfo.sections.push({
                    pos: pos,
                    end: writer.getTextPos(),
                    kind: "lib" /* Lib */ ,
                    data: directive.fileName
                });
                writeLine();
            }
        }
        function emitSourceFileWorker(node) {
            const statements = node.statements;
            pushNameGenerationScope(node);
            forEach(node.statements, generateNames);
            emitHelpers(node);
            const index = findIndex(statements, (statement)=>!isPrologueDirective(statement));
            emitTripleSlashDirectivesIfNeeded(node);
            emitList(node, statements, 1 /* MultiLine */ , /*parenthesizerRule*/ void 0, index === -1 ? statements.length : index);
            popNameGenerationScope(node);
        }
        function emitPartiallyEmittedExpression(node) {
            const emitFlags = getEmitFlags(node);
            if (!(emitFlags & 1024 /* NoLeadingComments */ ) && node.pos !== node.expression.pos) emitTrailingCommentsOfPosition(node.expression.pos);
            emitExpression(node.expression);
            if (!(emitFlags & 2048 /* NoTrailingComments */ ) && node.end !== node.expression.end) emitLeadingCommentsOfPosition(node.expression.end);
        }
        function emitCommaList(node) {
            emitExpressionList(node, node.elements, 528 /* CommaListElements */ , /*parenthesizerRule*/ void 0);
        }
        function emitPrologueDirectives(statements, sourceFile, seenPrologueDirectives, recordBundleFileSection) {
            let needsToSetSourceFile = !!sourceFile;
            for(let i = 0; i < statements.length; i++){
                const statement = statements[i];
                if (isPrologueDirective(statement)) {
                    const shouldEmitPrologueDirective = seenPrologueDirectives ? !seenPrologueDirectives.has(statement.expression.text) : true;
                    if (shouldEmitPrologueDirective) {
                        if (needsToSetSourceFile) {
                            needsToSetSourceFile = false;
                            setSourceFile(sourceFile);
                        }
                        writeLine();
                        const pos = writer.getTextPos();
                        emit(statement);
                        if (recordBundleFileSection && bundleFileInfo) bundleFileInfo.sections.push({
                            pos: pos,
                            end: writer.getTextPos(),
                            kind: "prologue" /* Prologue */ ,
                            data: statement.expression.text
                        });
                        if (seenPrologueDirectives) seenPrologueDirectives.add(statement.expression.text);
                    }
                } else return i;
            }
            return statements.length;
        }
        function emitUnparsedPrologues(prologues, seenPrologueDirectives) {
            for (const prologue of prologues)if (!seenPrologueDirectives.has(prologue.data)) {
                writeLine();
                const pos = writer.getTextPos();
                emit(prologue);
                if (bundleFileInfo) bundleFileInfo.sections.push({
                    pos: pos,
                    end: writer.getTextPos(),
                    kind: "prologue" /* Prologue */ ,
                    data: prologue.data
                });
                if (seenPrologueDirectives) seenPrologueDirectives.add(prologue.data);
            }
        }
        function emitPrologueDirectivesIfNeeded(sourceFileOrBundle) {
            if (isSourceFile(sourceFileOrBundle)) emitPrologueDirectives(sourceFileOrBundle.statements, sourceFileOrBundle);
            else {
                const seenPrologueDirectives = /* @__PURE__ */ new Set();
                for (const prepend of sourceFileOrBundle.prepends)emitUnparsedPrologues(prepend.prologues, seenPrologueDirectives);
                for (const sourceFile of sourceFileOrBundle.sourceFiles)emitPrologueDirectives(sourceFile.statements, sourceFile, seenPrologueDirectives, /*recordBundleFileSection*/ true);
                setSourceFile(void 0);
            }
        }
        function getPrologueDirectivesFromBundledSourceFiles(bundle) {
            const seenPrologueDirectives = /* @__PURE__ */ new Set();
            let prologues;
            for(let index = 0; index < bundle.sourceFiles.length; index++){
                const sourceFile = bundle.sourceFiles[index];
                let directives;
                let end = 0;
                for (const statement of sourceFile.statements){
                    if (!isPrologueDirective(statement)) break;
                    if (seenPrologueDirectives.has(statement.expression.text)) continue;
                    seenPrologueDirectives.add(statement.expression.text);
                    (directives || (directives = [])).push({
                        pos: statement.pos,
                        end: statement.end,
                        expression: {
                            pos: statement.expression.pos,
                            end: statement.expression.end,
                            text: statement.expression.text
                        }
                    });
                    end = end < statement.end ? statement.end : end;
                }
                if (directives) (prologues || (prologues = [])).push({
                    file: index,
                    text: sourceFile.text.substring(0, end),
                    directives: directives
                });
            }
            return prologues;
        }
        function emitShebangIfNeeded(sourceFileOrBundle) {
            if (isSourceFile(sourceFileOrBundle) || isUnparsedSource(sourceFileOrBundle)) {
                const shebang = getShebang(sourceFileOrBundle.text);
                if (shebang) {
                    writeComment(shebang);
                    writeLine();
                    return true;
                }
            } else {
                for (const prepend of sourceFileOrBundle.prepends){
                    Debug.assertNode(prepend, isUnparsedSource);
                    if (emitShebangIfNeeded(prepend)) return true;
                }
                for (const sourceFile of sourceFileOrBundle.sourceFiles){
                    if (emitShebangIfNeeded(sourceFile)) return true;
                }
            }
        }
        function emitNodeWithWriter(node, writer2) {
            if (!node) return;
            const savedWrite = write;
            write = writer2;
            emit(node);
            write = savedWrite;
        }
        function emitDecoratorsAndModifiers(node, modifiers, allowDecorators) {
            if (modifiers == null ? void 0 : modifiers.length) {
                if (every(modifiers, isModifier)) return emitModifierList(node, modifiers);
                if (every(modifiers, isDecorator)) {
                    if (allowDecorators) return emitDecoratorList(node, modifiers);
                    return node.pos;
                }
                onBeforeEmitNodeArray == null || onBeforeEmitNodeArray(modifiers);
                let lastMode;
                let mode;
                let start = 0;
                let pos = 0;
                let lastModifier;
                while(start < modifiers.length){
                    while(pos < modifiers.length){
                        lastModifier = modifiers[pos];
                        mode = isDecorator(lastModifier) ? "decorators" : "modifiers";
                        if (lastMode === void 0) lastMode = mode;
                        else if (mode !== lastMode) break;
                        pos++;
                    }
                    const textRange = {
                        pos: -1,
                        end: -1
                    };
                    if (start === 0) textRange.pos = modifiers.pos;
                    if (pos === modifiers.length - 1) textRange.end = modifiers.end;
                    if (lastMode === "modifiers" || allowDecorators) emitNodeListItems(emit, node, modifiers, lastMode === "modifiers" ? 2359808 /* Modifiers */  : 2146305 /* Decorators */ , /*parenthesizerRule*/ void 0, start, pos - start, /*hasTrailingComma*/ false, textRange);
                    start = pos;
                    lastMode = mode;
                    pos++;
                }
                onAfterEmitNodeArray == null || onAfterEmitNodeArray(modifiers);
                if (lastModifier && !positionIsSynthesized(lastModifier.end)) return lastModifier.end;
            }
            return node.pos;
        }
        function emitModifierList(node, modifiers) {
            emitList(node, modifiers, 2359808 /* Modifiers */ );
            const lastModifier = lastOrUndefined(modifiers);
            return lastModifier && !positionIsSynthesized(lastModifier.end) ? lastModifier.end : node.pos;
        }
        function emitTypeAnnotation(node) {
            if (node) {
                writePunctuation(":");
                writeSpace();
                emit(node);
            }
        }
        function emitInitializer(node, equalCommentStartPos, container, parenthesizerRule) {
            if (node) {
                writeSpace();
                emitTokenWithComment(64 /* EqualsToken */ , equalCommentStartPos, writeOperator, container);
                writeSpace();
                emitExpression(node, parenthesizerRule);
            }
        }
        function emitNodeWithPrefix(prefix, prefixWriter, node, emit2) {
            if (node) {
                prefixWriter(prefix);
                emit2(node);
            }
        }
        function emitWithLeadingSpace(node) {
            if (node) {
                writeSpace();
                emit(node);
            }
        }
        function emitExpressionWithLeadingSpace(node, parenthesizerRule) {
            if (node) {
                writeSpace();
                emitExpression(node, parenthesizerRule);
            }
        }
        function emitWithTrailingSpace(node) {
            if (node) {
                emit(node);
                writeSpace();
            }
        }
        function emitEmbeddedStatement(parent2, node) {
            if (isBlock(node) || getEmitFlags(parent2) & 1 /* SingleLine */  || preserveSourceNewlines && !getLeadingLineTerminatorCount(parent2, node, 0 /* None */ )) {
                writeSpace();
                emit(node);
            } else {
                writeLine();
                increaseIndent();
                if (isEmptyStatement(node)) pipelineEmit(5 /* EmbeddedStatement */ , node);
                else emit(node);
                decreaseIndent();
            }
        }
        function emitDecoratorList(parentNode, decorators) {
            emitList(parentNode, decorators, 2146305 /* Decorators */ );
            const lastDecorator = lastOrUndefined(decorators);
            return lastDecorator && !positionIsSynthesized(lastDecorator.end) ? lastDecorator.end : parentNode.pos;
        }
        function emitTypeArguments(parentNode, typeArguments) {
            emitList(parentNode, typeArguments, 53776 /* TypeArguments */ , typeArgumentParenthesizerRuleSelector);
        }
        function emitTypeParameters(parentNode, typeParameters) {
            if (isFunctionLike(parentNode) && parentNode.typeArguments) return emitTypeArguments(parentNode, parentNode.typeArguments);
            emitList(parentNode, typeParameters, 53776 /* TypeParameters */ );
        }
        function emitParameters(parentNode, parameters) {
            emitList(parentNode, parameters, 2576 /* Parameters */ );
        }
        function canEmitSimpleArrowHead(parentNode, parameters) {
            const parameter = singleOrUndefined(parameters);
            return parameter && parameter.pos === parentNode.pos && isArrowFunction(parentNode) && !parentNode.type && !some(parentNode.modifiers) && !some(parentNode.typeParameters) && !some(parameter.modifiers) && !parameter.dotDotDotToken && !parameter.questionToken && !parameter.type && !parameter.initializer && isIdentifier(parameter.name);
        }
        function emitParametersForArrow(parentNode, parameters) {
            if (canEmitSimpleArrowHead(parentNode, parameters)) emitList(parentNode, parameters, 528 /* Parenthesis */ );
            else emitParameters(parentNode, parameters);
        }
        function emitParametersForIndexSignature(parentNode, parameters) {
            emitList(parentNode, parameters, 8848 /* IndexSignatureParameters */ );
        }
        function writeDelimiter(format) {
            switch(format & 60 /* DelimitersMask */ ){
                case 0 /* None */ :
                    break;
                case 16 /* CommaDelimited */ :
                    writePunctuation(",");
                    break;
                case 4 /* BarDelimited */ :
                    writeSpace();
                    writePunctuation("|");
                    break;
                case 32 /* AsteriskDelimited */ :
                    writeSpace();
                    writePunctuation("*");
                    writeSpace();
                    break;
                case 8 /* AmpersandDelimited */ :
                    writeSpace();
                    writePunctuation("&");
                    break;
            }
        }
        function emitList(parentNode, children, format, parenthesizerRule, start, count) {
            emitNodeList(emit, parentNode, children, format | (parentNode && getEmitFlags(parentNode) & 2 /* MultiLine */  ? 65536 /* PreferNewLine */  : 0), parenthesizerRule, start, count);
        }
        function emitExpressionList(parentNode, children, format, parenthesizerRule, start, count) {
            emitNodeList(emitExpression, parentNode, children, format, parenthesizerRule, start, count);
        }
        function emitNodeList(emit2, parentNode, children, format, parenthesizerRule, start = 0, count = children ? children.length - start : 0) {
            const isUndefined = children === void 0;
            if (isUndefined && format & 16384 /* OptionalIfUndefined */ ) return;
            const isEmpty = children === void 0 || start >= children.length || count === 0;
            if (isEmpty && format & 32768 /* OptionalIfEmpty */ ) {
                onBeforeEmitNodeArray == null || onBeforeEmitNodeArray(children);
                onAfterEmitNodeArray == null || onAfterEmitNodeArray(children);
                return;
            }
            if (format & 15360 /* BracketsMask */ ) {
                writePunctuation(getOpeningBracket(format));
                if (isEmpty && children) emitTrailingCommentsOfPosition(children.pos, /*prefixSpace*/ true);
            }
            onBeforeEmitNodeArray == null || onBeforeEmitNodeArray(children);
            if (isEmpty) {
                if (format & 1 /* MultiLine */  && !(preserveSourceNewlines && (!parentNode || currentSourceFile && rangeIsOnSingleLine(parentNode, currentSourceFile)))) writeLine();
                else if (format & 256 /* SpaceBetweenBraces */  && !(format & 524288 /* NoSpaceIfEmpty */ )) writeSpace();
            } else emitNodeListItems(emit2, parentNode, children, format, parenthesizerRule, start, count, children.hasTrailingComma, children);
            onAfterEmitNodeArray == null || onAfterEmitNodeArray(children);
            if (format & 15360 /* BracketsMask */ ) {
                if (isEmpty && children) emitLeadingCommentsOfPosition(children.end);
                writePunctuation(getClosingBracket(format));
            }
        }
        function emitNodeListItems(emit2, parentNode, children, format, parenthesizerRule, start, count, hasTrailingComma, childrenTextRange) {
            const mayEmitInterveningComments = (format & 262144 /* NoInterveningComments */ ) === 0;
            let shouldEmitInterveningComments = mayEmitInterveningComments;
            const leadingLineTerminatorCount = getLeadingLineTerminatorCount(parentNode, children[start], format);
            if (leadingLineTerminatorCount) {
                writeLine(leadingLineTerminatorCount);
                shouldEmitInterveningComments = false;
            } else if (format & 256 /* SpaceBetweenBraces */ ) writeSpace();
            if (format & 128 /* Indented */ ) increaseIndent();
            const emitListItem = getEmitListItem(emit2, parenthesizerRule);
            let previousSibling;
            let previousSourceFileTextKind;
            let shouldDecreaseIndentAfterEmit = false;
            for(let i = 0; i < count; i++){
                const child = children[start + i];
                if (format & 32 /* AsteriskDelimited */ ) {
                    writeLine();
                    writeDelimiter(format);
                } else if (previousSibling) {
                    if (format & 60 /* DelimitersMask */  && previousSibling.end !== (parentNode ? parentNode.end : -1)) {
                        const previousSiblingEmitFlags = getEmitFlags(previousSibling);
                        if (!(previousSiblingEmitFlags & 2048 /* NoTrailingComments */ )) emitLeadingCommentsOfPosition(previousSibling.end);
                    }
                    writeDelimiter(format);
                    recordBundleFileInternalSectionEnd(previousSourceFileTextKind);
                    const separatingLineTerminatorCount = getSeparatingLineTerminatorCount(previousSibling, child, format);
                    if (separatingLineTerminatorCount > 0) {
                        if ((format & 131 /* Indented */ ) === 0 /* SingleLine */ ) {
                            increaseIndent();
                            shouldDecreaseIndentAfterEmit = true;
                        }
                        writeLine(separatingLineTerminatorCount);
                        shouldEmitInterveningComments = false;
                    } else if (previousSibling && format & 512 /* SpaceBetweenSiblings */ ) writeSpace();
                }
                previousSourceFileTextKind = recordBundleFileInternalSectionStart(child);
                if (shouldEmitInterveningComments) {
                    const commentRange = getCommentRange(child);
                    emitTrailingCommentsOfPosition(commentRange.pos);
                } else shouldEmitInterveningComments = mayEmitInterveningComments;
                nextListElementPos = child.pos;
                emitListItem(child, emit2, parenthesizerRule, i);
                if (shouldDecreaseIndentAfterEmit) {
                    decreaseIndent();
                    shouldDecreaseIndentAfterEmit = false;
                }
                previousSibling = child;
            }
            const emitFlags = previousSibling ? getEmitFlags(previousSibling) : 0;
            const skipTrailingComments = commentsDisabled || !!(emitFlags & 2048 /* NoTrailingComments */ );
            const emitTrailingComma = hasTrailingComma && format & 64 /* AllowTrailingComma */  && format & 16 /* CommaDelimited */ ;
            if (emitTrailingComma) {
                if (previousSibling && !skipTrailingComments) emitTokenWithComment(28 /* CommaToken */ , previousSibling.end, writePunctuation, previousSibling);
                else writePunctuation(",");
            }
            if (previousSibling && (parentNode ? parentNode.end : -1) !== previousSibling.end && format & 60 /* DelimitersMask */  && !skipTrailingComments) emitLeadingCommentsOfPosition(emitTrailingComma && (childrenTextRange == null ? void 0 : childrenTextRange.end) ? childrenTextRange.end : previousSibling.end);
            if (format & 128 /* Indented */ ) decreaseIndent();
            recordBundleFileInternalSectionEnd(previousSourceFileTextKind);
            const closingLineTerminatorCount = getClosingLineTerminatorCount(parentNode, children[start + count - 1], format, childrenTextRange);
            if (closingLineTerminatorCount) writeLine(closingLineTerminatorCount);
            else if (format & 2097408 /* SpaceBetweenBraces */ ) writeSpace();
        }
        function writeLiteral(s) {
            writer.writeLiteral(s);
        }
        function writeStringLiteral(s) {
            writer.writeStringLiteral(s);
        }
        function writeBase(s) {
            writer.write(s);
        }
        function writeSymbol(s, sym) {
            writer.writeSymbol(s, sym);
        }
        function writePunctuation(s) {
            writer.writePunctuation(s);
        }
        function writeTrailingSemicolon() {
            writer.writeTrailingSemicolon(";");
        }
        function writeKeyword(s) {
            writer.writeKeyword(s);
        }
        function writeOperator(s) {
            writer.writeOperator(s);
        }
        function writeParameter(s) {
            writer.writeParameter(s);
        }
        function writeComment(s) {
            writer.writeComment(s);
        }
        function writeSpace() {
            writer.writeSpace(" ");
        }
        function writeProperty(s) {
            writer.writeProperty(s);
        }
        function nonEscapingWrite(s) {
            if (writer.nonEscapingWrite) writer.nonEscapingWrite(s);
            else writer.write(s);
        }
        function writeLine(count = 1) {
            for(let i = 0; i < count; i++)writer.writeLine(i > 0);
        }
        function increaseIndent() {
            writer.increaseIndent();
        }
        function decreaseIndent() {
            writer.decreaseIndent();
        }
        function writeToken(token, pos, writer2, contextNode) {
            return !sourceMapsDisabled ? emitTokenWithSourceMap(contextNode, token, writer2, pos, writeTokenText) : writeTokenText(token, writer2, pos);
        }
        function writeTokenNode(node, writer2) {
            if (onBeforeEmitToken) onBeforeEmitToken(node);
            writer2(tokenToString(node.kind));
            if (onAfterEmitToken) onAfterEmitToken(node);
        }
        function writeTokenText(token, writer2, pos) {
            const tokenString = tokenToString(token);
            writer2(tokenString);
            return pos < 0 ? pos : pos + tokenString.length;
        }
        function writeLineOrSpace(parentNode, prevChildNode, nextChildNode) {
            if (getEmitFlags(parentNode) & 1 /* SingleLine */ ) writeSpace();
            else if (preserveSourceNewlines) {
                const lines = getLinesBetweenNodes(parentNode, prevChildNode, nextChildNode);
                if (lines) writeLine(lines);
                else writeSpace();
            } else writeLine();
        }
        function writeLines(text) {
            const lines = text.split(/\r\n?|\n/g);
            const indentation = guessIndentation(lines);
            for (const lineText of lines){
                const line = indentation ? lineText.slice(indentation) : lineText;
                if (line.length) {
                    writeLine();
                    write(line);
                }
            }
        }
        function writeLinesAndIndent(lineCount, writeSpaceIfNotIndenting) {
            if (lineCount) {
                increaseIndent();
                writeLine(lineCount);
            } else if (writeSpaceIfNotIndenting) writeSpace();
        }
        function decreaseIndentIf(value1, value2) {
            if (value1) decreaseIndent();
            if (value2) decreaseIndent();
        }
        function getLeadingLineTerminatorCount(parentNode, firstChild, format) {
            if (format & 2 /* PreserveLines */  || preserveSourceNewlines) {
                if (format & 65536 /* PreferNewLine */ ) return 1;
                if (firstChild === void 0) return !parentNode || currentSourceFile && rangeIsOnSingleLine(parentNode, currentSourceFile) ? 0 : 1;
                if (firstChild.pos === nextListElementPos) return 0;
                if (firstChild.kind === 12 /* JsxText */ ) return 0;
                if (currentSourceFile && parentNode && !positionIsSynthesized(parentNode.pos) && !nodeIsSynthesized(firstChild) && (!firstChild.parent || getOriginalNode(firstChild.parent) === getOriginalNode(parentNode))) {
                    if (preserveSourceNewlines) return getEffectiveLines((includeComments)=>getLinesBetweenPositionAndPrecedingNonWhitespaceCharacter(firstChild.pos, parentNode.pos, currentSourceFile, includeComments));
                    return rangeStartPositionsAreOnSameLine(parentNode, firstChild, currentSourceFile) ? 0 : 1;
                }
                if (synthesizedNodeStartsOnNewLine(firstChild, format)) return 1;
            }
            return format & 1 /* MultiLine */  ? 1 : 0;
        }
        function getSeparatingLineTerminatorCount(previousNode, nextNode, format) {
            if (format & 2 /* PreserveLines */  || preserveSourceNewlines) {
                if (previousNode === void 0 || nextNode === void 0) return 0;
                if (nextNode.kind === 12 /* JsxText */ ) return 0;
                else if (currentSourceFile && !nodeIsSynthesized(previousNode) && !nodeIsSynthesized(nextNode)) {
                    if (preserveSourceNewlines && siblingNodePositionsAreComparable(previousNode, nextNode)) return getEffectiveLines((includeComments)=>getLinesBetweenRangeEndAndRangeStart(previousNode, nextNode, currentSourceFile, includeComments));
                    else if (!preserveSourceNewlines && originalNodesHaveSameParent(previousNode, nextNode)) return rangeEndIsOnSameLineAsRangeStart(previousNode, nextNode, currentSourceFile) ? 0 : 1;
                    return format & 65536 /* PreferNewLine */  ? 1 : 0;
                } else if (synthesizedNodeStartsOnNewLine(previousNode, format) || synthesizedNodeStartsOnNewLine(nextNode, format)) return 1;
            } else if (getStartsOnNewLine(nextNode)) return 1;
            return format & 1 /* MultiLine */  ? 1 : 0;
        }
        function getClosingLineTerminatorCount(parentNode, lastChild, format, childrenTextRange) {
            if (format & 2 /* PreserveLines */  || preserveSourceNewlines) {
                if (format & 65536 /* PreferNewLine */ ) return 1;
                if (lastChild === void 0) return !parentNode || currentSourceFile && rangeIsOnSingleLine(parentNode, currentSourceFile) ? 0 : 1;
                if (currentSourceFile && parentNode && !positionIsSynthesized(parentNode.pos) && !nodeIsSynthesized(lastChild) && (!lastChild.parent || lastChild.parent === parentNode)) {
                    if (preserveSourceNewlines) {
                        const end = childrenTextRange && !positionIsSynthesized(childrenTextRange.end) ? childrenTextRange.end : lastChild.end;
                        return getEffectiveLines((includeComments)=>getLinesBetweenPositionAndNextNonWhitespaceCharacter(end, parentNode.end, currentSourceFile, includeComments));
                    }
                    return rangeEndPositionsAreOnSameLine(parentNode, lastChild, currentSourceFile) ? 0 : 1;
                }
                if (synthesizedNodeStartsOnNewLine(lastChild, format)) return 1;
            }
            if (format & 1 /* MultiLine */  && !(format & 131072 /* NoTrailingNewLine */ )) return 1;
            return 0;
        }
        function getEffectiveLines(getLineDifference) {
            Debug.assert(!!preserveSourceNewlines);
            const lines = getLineDifference(/*includeComments*/ true);
            if (lines === 0) return getLineDifference(/*includeComments*/ false);
            return lines;
        }
        function writeLineSeparatorsAndIndentBefore(node, parent2) {
            const leadingNewlines = preserveSourceNewlines && getLeadingLineTerminatorCount(parent2, node, 0 /* None */ );
            if (leadingNewlines) writeLinesAndIndent(leadingNewlines, /*writeSpaceIfNotIndenting*/ false);
            return !!leadingNewlines;
        }
        function writeLineSeparatorsAfter(node, parent2) {
            const trailingNewlines = preserveSourceNewlines && getClosingLineTerminatorCount(parent2, node, 0 /* None */ , /*childrenTextRange*/ void 0);
            if (trailingNewlines) writeLine(trailingNewlines);
        }
        function synthesizedNodeStartsOnNewLine(node, format) {
            if (nodeIsSynthesized(node)) {
                const startsOnNewLine = getStartsOnNewLine(node);
                if (startsOnNewLine === void 0) return (format & 65536 /* PreferNewLine */ ) !== 0;
                return startsOnNewLine;
            }
            return (format & 65536 /* PreferNewLine */ ) !== 0;
        }
        function getLinesBetweenNodes(parent2, node1, node2) {
            if (getEmitFlags(parent2) & 262144 /* NoIndentation */ ) return 0;
            parent2 = skipSynthesizedParentheses(parent2);
            node1 = skipSynthesizedParentheses(node1);
            node2 = skipSynthesizedParentheses(node2);
            if (getStartsOnNewLine(node2)) return 1;
            if (currentSourceFile && !nodeIsSynthesized(parent2) && !nodeIsSynthesized(node1) && !nodeIsSynthesized(node2)) {
                if (preserveSourceNewlines) return getEffectiveLines((includeComments)=>getLinesBetweenRangeEndAndRangeStart(node1, node2, currentSourceFile, includeComments));
                return rangeEndIsOnSameLineAsRangeStart(node1, node2, currentSourceFile) ? 0 : 1;
            }
            return 0;
        }
        function isEmptyBlock(block) {
            return block.statements.length === 0 && (!currentSourceFile || rangeEndIsOnSameLineAsRangeStart(block, block, currentSourceFile));
        }
        function skipSynthesizedParentheses(node) {
            while(node.kind === 216 /* ParenthesizedExpression */  && nodeIsSynthesized(node))node = node.expression;
            return node;
        }
        function getTextOfNode2(node, includeTrivia) {
            if (isGeneratedIdentifier(node) || isGeneratedPrivateIdentifier(node)) return generateName(node);
            if (isStringLiteral(node) && node.textSourceNode) return getTextOfNode2(node.textSourceNode, includeTrivia);
            const sourceFile = currentSourceFile;
            const canUseSourceFile = !!sourceFile && !!node.parent && !nodeIsSynthesized(node);
            if (isMemberName(node)) {
                if (!canUseSourceFile || getSourceFileOfNode(node) !== getOriginalNode(sourceFile)) return idText(node);
            } else if (isJsxNamespacedName(node)) {
                if (!canUseSourceFile || getSourceFileOfNode(node) !== getOriginalNode(sourceFile)) return getTextOfJsxNamespacedName(node);
            } else {
                Debug.assertNode(node, isLiteralExpression);
                if (!canUseSourceFile) return node.text;
            }
            return getSourceTextOfNodeFromSourceFile(sourceFile, node, includeTrivia);
        }
        function getLiteralTextOfNode(node, neverAsciiEscape, jsxAttributeEscape) {
            if (node.kind === 11 /* StringLiteral */  && node.textSourceNode) {
                const textSourceNode = node.textSourceNode;
                if (isIdentifier(textSourceNode) || isPrivateIdentifier(textSourceNode) || isNumericLiteral(textSourceNode) || isJsxNamespacedName(textSourceNode)) {
                    const text = isNumericLiteral(textSourceNode) ? textSourceNode.text : getTextOfNode2(textSourceNode);
                    return jsxAttributeEscape ? `"${escapeJsxAttributeString(text)}"` : neverAsciiEscape || getEmitFlags(node) & 16777216 /* NoAsciiEscaping */  ? `"${escapeString(text)}"` : `"${escapeNonAsciiString(text)}"`;
                } else return getLiteralTextOfNode(textSourceNode, neverAsciiEscape, jsxAttributeEscape);
            }
            const flags = (neverAsciiEscape ? 1 /* NeverAsciiEscape */  : 0) | (jsxAttributeEscape ? 2 /* JsxAttributeEscape */  : 0) | (printerOptions.terminateUnterminatedLiterals ? 4 /* TerminateUnterminatedLiterals */  : 0) | (printerOptions.target && printerOptions.target === 99 /* ESNext */  ? 8 /* AllowNumericSeparator */  : 0);
            return getLiteralText(node, currentSourceFile, flags);
        }
        function pushNameGenerationScope(node) {
            if (node && getEmitFlags(node) & 1048576 /* ReuseTempVariableScope */ ) return;
            tempFlagsStack.push(tempFlags);
            tempFlags = 0 /* Auto */ ;
            formattedNameTempFlagsStack.push(formattedNameTempFlags);
            formattedNameTempFlags = void 0;
            reservedNamesStack.push(reservedNames);
        }
        function popNameGenerationScope(node) {
            if (node && getEmitFlags(node) & 1048576 /* ReuseTempVariableScope */ ) return;
            tempFlags = tempFlagsStack.pop();
            formattedNameTempFlags = formattedNameTempFlagsStack.pop();
            reservedNames = reservedNamesStack.pop();
        }
        function reserveNameInNestedScopes(name) {
            if (!reservedNames || reservedNames === lastOrUndefined(reservedNamesStack)) reservedNames = /* @__PURE__ */ new Set();
            reservedNames.add(name);
        }
        function pushPrivateNameGenerationScope(newPrivateNameTempFlags, newReservedMemberNames) {
            privateNameTempFlagsStack.push(privateNameTempFlags);
            privateNameTempFlags = newPrivateNameTempFlags;
            reservedPrivateNamesStack.push(reservedNames);
            reservedPrivateNames = newReservedMemberNames;
        }
        function popPrivateNameGenerationScope() {
            privateNameTempFlags = privateNameTempFlagsStack.pop();
            reservedPrivateNames = reservedPrivateNamesStack.pop();
        }
        function reservePrivateNameInNestedScopes(name) {
            if (!reservedPrivateNames || reservedPrivateNames === lastOrUndefined(reservedPrivateNamesStack)) reservedPrivateNames = /* @__PURE__ */ new Set();
            reservedPrivateNames.add(name);
        }
        function generateNames(node) {
            if (!node) return;
            switch(node.kind){
                case 240 /* Block */ :
                    forEach(node.statements, generateNames);
                    break;
                case 255 /* LabeledStatement */ :
                case 253 /* WithStatement */ :
                case 245 /* DoStatement */ :
                case 246 /* WhileStatement */ :
                    generateNames(node.statement);
                    break;
                case 244 /* IfStatement */ :
                    generateNames(node.thenStatement);
                    generateNames(node.elseStatement);
                    break;
                case 247 /* ForStatement */ :
                case 249 /* ForOfStatement */ :
                case 248 /* ForInStatement */ :
                    generateNames(node.initializer);
                    generateNames(node.statement);
                    break;
                case 254 /* SwitchStatement */ :
                    generateNames(node.caseBlock);
                    break;
                case 268 /* CaseBlock */ :
                    forEach(node.clauses, generateNames);
                    break;
                case 295 /* CaseClause */ :
                case 296 /* DefaultClause */ :
                    forEach(node.statements, generateNames);
                    break;
                case 257 /* TryStatement */ :
                    generateNames(node.tryBlock);
                    generateNames(node.catchClause);
                    generateNames(node.finallyBlock);
                    break;
                case 298 /* CatchClause */ :
                    generateNames(node.variableDeclaration);
                    generateNames(node.block);
                    break;
                case 242 /* VariableStatement */ :
                    generateNames(node.declarationList);
                    break;
                case 260 /* VariableDeclarationList */ :
                    forEach(node.declarations, generateNames);
                    break;
                case 259 /* VariableDeclaration */ :
                case 168 /* Parameter */ :
                case 207 /* BindingElement */ :
                case 262 /* ClassDeclaration */ :
                    generateNameIfNeeded(node.name);
                    break;
                case 261 /* FunctionDeclaration */ :
                    generateNameIfNeeded(node.name);
                    if (getEmitFlags(node) & 1048576 /* ReuseTempVariableScope */ ) {
                        forEach(node.parameters, generateNames);
                        generateNames(node.body);
                    }
                    break;
                case 205 /* ObjectBindingPattern */ :
                case 206 /* ArrayBindingPattern */ :
                    forEach(node.elements, generateNames);
                    break;
                case 271 /* ImportDeclaration */ :
                    generateNames(node.importClause);
                    break;
                case 272 /* ImportClause */ :
                    generateNameIfNeeded(node.name);
                    generateNames(node.namedBindings);
                    break;
                case 273 /* NamespaceImport */ :
                    generateNameIfNeeded(node.name);
                    break;
                case 279 /* NamespaceExport */ :
                    generateNameIfNeeded(node.name);
                    break;
                case 274 /* NamedImports */ :
                    forEach(node.elements, generateNames);
                    break;
                case 275 /* ImportSpecifier */ :
                    generateNameIfNeeded(node.propertyName || node.name);
                    break;
            }
        }
        function generateMemberNames(node) {
            if (!node) return;
            switch(node.kind){
                case 302 /* PropertyAssignment */ :
                case 303 /* ShorthandPropertyAssignment */ :
                case 171 /* PropertyDeclaration */ :
                case 173 /* MethodDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    generateNameIfNeeded(node.name);
                    break;
            }
        }
        function generateNameIfNeeded(name) {
            if (name) {
                if (isGeneratedIdentifier(name) || isGeneratedPrivateIdentifier(name)) generateName(name);
                else if (isBindingPattern(name)) generateNames(name);
            }
        }
        function generateName(name) {
            const autoGenerate = name.emitNode.autoGenerate;
            if ((autoGenerate.flags & 7 /* KindMask */ ) === 4 /* Node */ ) return generateNameCached(getNodeForGeneratedName(name), isPrivateIdentifier(name), autoGenerate.flags, autoGenerate.prefix, autoGenerate.suffix);
            else {
                const autoGenerateId = autoGenerate.id;
                return autoGeneratedIdToGeneratedName[autoGenerateId] || (autoGeneratedIdToGeneratedName[autoGenerateId] = makeName(name));
            }
        }
        function generateNameCached(node, privateName, flags, prefix, suffix) {
            const nodeId = getNodeId(node);
            const cache = privateName ? nodeIdToGeneratedPrivateName : nodeIdToGeneratedName;
            return cache[nodeId] || (cache[nodeId] = generateNameForNode(node, privateName, flags ?? 0 /* None */ , formatGeneratedNamePart(prefix, generateName), formatGeneratedNamePart(suffix)));
        }
        function isUniqueName(name, privateName) {
            return isFileLevelUniqueNameInCurrentFile(name, privateName) && !isReservedName(name, privateName) && !generatedNames.has(name);
        }
        function isReservedName(name, privateName) {
            return privateName ? !!(reservedPrivateNames == null ? void 0 : reservedPrivateNames.has(name)) : !!(reservedNames == null ? void 0 : reservedNames.has(name));
        }
        function isFileLevelUniqueNameInCurrentFile(name, _isPrivate) {
            return currentSourceFile ? isFileLevelUniqueName(currentSourceFile, name, hasGlobalName) : true;
        }
        function isUniqueLocalName(name, container) {
            for(let node = container; node && isNodeDescendantOf(node, container); node = node.nextContainer)if (canHaveLocals(node) && node.locals) {
                const local = node.locals.get(escapeLeadingUnderscores(name));
                if (local && local.flags & 3257279 /* Alias */ ) return false;
            }
            return true;
        }
        function getTempFlags(formattedNameKey) {
            switch(formattedNameKey){
                case "":
                    return tempFlags;
                case "#":
                    return privateNameTempFlags;
                default:
                    return (formattedNameTempFlags == null ? void 0 : formattedNameTempFlags.get(formattedNameKey)) ?? 0 /* Auto */ ;
            }
        }
        function setTempFlags(formattedNameKey, flags) {
            switch(formattedNameKey){
                case "":
                    tempFlags = flags;
                    break;
                case "#":
                    privateNameTempFlags = flags;
                    break;
                default:
                    formattedNameTempFlags ?? (formattedNameTempFlags = /* @__PURE__ */ new Map());
                    formattedNameTempFlags.set(formattedNameKey, flags);
                    break;
            }
        }
        function makeTempVariableName(flags, reservedInNestedScopes, privateName, prefix, suffix) {
            if (prefix.length > 0 && prefix.charCodeAt(0) === 35 /* hash */ ) prefix = prefix.slice(1);
            const key = formatGeneratedName(privateName, prefix, "", suffix);
            let tempFlags2 = getTempFlags(key);
            if (flags && !(tempFlags2 & flags)) {
                const name = flags === 268435456 /* _i */  ? "_i" : "_n";
                const fullName = formatGeneratedName(privateName, prefix, name, suffix);
                if (isUniqueName(fullName, privateName)) {
                    tempFlags2 |= flags;
                    if (privateName) reservePrivateNameInNestedScopes(fullName);
                    else if (reservedInNestedScopes) reserveNameInNestedScopes(fullName);
                    setTempFlags(key, tempFlags2);
                    return fullName;
                }
            }
            while(true){
                const count = tempFlags2 & 268435455 /* CountMask */ ;
                tempFlags2++;
                if (count !== 8 && count !== 13) {
                    const name = count < 26 ? "_" + String.fromCharCode(97 /* a */  + count) : "_" + (count - 26);
                    const fullName = formatGeneratedName(privateName, prefix, name, suffix);
                    if (isUniqueName(fullName, privateName)) {
                        if (privateName) reservePrivateNameInNestedScopes(fullName);
                        else if (reservedInNestedScopes) reserveNameInNestedScopes(fullName);
                        setTempFlags(key, tempFlags2);
                        return fullName;
                    }
                }
            }
        }
        function makeUniqueName2(baseName, checkFn = isUniqueName, optimistic, scoped, privateName, prefix, suffix) {
            if (baseName.length > 0 && baseName.charCodeAt(0) === 35 /* hash */ ) baseName = baseName.slice(1);
            if (prefix.length > 0 && prefix.charCodeAt(0) === 35 /* hash */ ) prefix = prefix.slice(1);
            if (optimistic) {
                const fullName = formatGeneratedName(privateName, prefix, baseName, suffix);
                if (checkFn(fullName, privateName)) {
                    if (privateName) reservePrivateNameInNestedScopes(fullName);
                    else if (scoped) reserveNameInNestedScopes(fullName);
                    else generatedNames.add(fullName);
                    return fullName;
                }
            }
            if (baseName.charCodeAt(baseName.length - 1) !== 95 /* _ */ ) baseName += "_";
            let i = 1;
            while(true){
                const fullName = formatGeneratedName(privateName, prefix, baseName + i, suffix);
                if (checkFn(fullName, privateName)) {
                    if (privateName) reservePrivateNameInNestedScopes(fullName);
                    else if (scoped) reserveNameInNestedScopes(fullName);
                    else generatedNames.add(fullName);
                    return fullName;
                }
                i++;
            }
        }
        function makeFileLevelOptimisticUniqueName(name) {
            return makeUniqueName2(name, isFileLevelUniqueNameInCurrentFile, /*optimistic*/ true, /*scoped*/ false, /*privateName*/ false, /*prefix*/ "", /*suffix*/ "");
        }
        function generateNameForModuleOrEnum(node) {
            const name = getTextOfNode2(node.name);
            return isUniqueLocalName(name, tryCast(node, canHaveLocals)) ? name : makeUniqueName2(name, isUniqueName, /*optimistic*/ false, /*scoped*/ false, /*privateName*/ false, /*prefix*/ "", /*suffix*/ "");
        }
        function generateNameForImportOrExportDeclaration(node) {
            const expr = getExternalModuleName(node);
            const baseName = isStringLiteral(expr) ? makeIdentifierFromModuleName(expr.text) : "module";
            return makeUniqueName2(baseName, isUniqueName, /*optimistic*/ false, /*scoped*/ false, /*privateName*/ false, /*prefix*/ "", /*suffix*/ "");
        }
        function generateNameForExportDefault() {
            return makeUniqueName2("default", isUniqueName, /*optimistic*/ false, /*scoped*/ false, /*privateName*/ false, /*prefix*/ "", /*suffix*/ "");
        }
        function generateNameForClassExpression() {
            return makeUniqueName2("class", isUniqueName, /*optimistic*/ false, /*scoped*/ false, /*privateName*/ false, /*prefix*/ "", /*suffix*/ "");
        }
        function generateNameForMethodOrAccessor(node, privateName, prefix, suffix) {
            if (isIdentifier(node.name)) return generateNameCached(node.name, privateName);
            return makeTempVariableName(0 /* Auto */ , /*reservedInNestedScopes*/ false, privateName, prefix, suffix);
        }
        function generateNameForNode(node, privateName, flags, prefix, suffix) {
            switch(node.kind){
                case 80 /* Identifier */ :
                case 81 /* PrivateIdentifier */ :
                    return makeUniqueName2(getTextOfNode2(node), isUniqueName, !!(flags & 16 /* Optimistic */ ), !!(flags & 8 /* ReservedInNestedScopes */ ), privateName, prefix, suffix);
                case 266 /* ModuleDeclaration */ :
                case 265 /* EnumDeclaration */ :
                    Debug.assert(!prefix && !suffix && !privateName);
                    return generateNameForModuleOrEnum(node);
                case 271 /* ImportDeclaration */ :
                case 277 /* ExportDeclaration */ :
                    Debug.assert(!prefix && !suffix && !privateName);
                    return generateNameForImportOrExportDeclaration(node);
                case 261 /* FunctionDeclaration */ :
                case 262 /* ClassDeclaration */ :
                    {
                        Debug.assert(!prefix && !suffix && !privateName);
                        const name = node.name;
                        if (name && !isGeneratedIdentifier(name)) return generateNameForNode(name, /*privateName*/ false, flags, prefix, suffix);
                        return generateNameForExportDefault();
                    }
                case 276 /* ExportAssignment */ :
                    Debug.assert(!prefix && !suffix && !privateName);
                    return generateNameForExportDefault();
                case 230 /* ClassExpression */ :
                    Debug.assert(!prefix && !suffix && !privateName);
                    return generateNameForClassExpression();
                case 173 /* MethodDeclaration */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                    return generateNameForMethodOrAccessor(node, privateName, prefix, suffix);
                case 166 /* ComputedPropertyName */ :
                    return makeTempVariableName(0 /* Auto */ , /*reservedInNestedScopes*/ true, privateName, prefix, suffix);
                default:
                    return makeTempVariableName(0 /* Auto */ , /*reservedInNestedScopes*/ false, privateName, prefix, suffix);
            }
        }
        function makeName(name) {
            const autoGenerate = name.emitNode.autoGenerate;
            const prefix = formatGeneratedNamePart(autoGenerate.prefix, generateName);
            const suffix = formatGeneratedNamePart(autoGenerate.suffix);
            switch(autoGenerate.flags & 7 /* KindMask */ ){
                case 1 /* Auto */ :
                    return makeTempVariableName(0 /* Auto */ , !!(autoGenerate.flags & 8 /* ReservedInNestedScopes */ ), isPrivateIdentifier(name), prefix, suffix);
                case 2 /* Loop */ :
                    Debug.assertNode(name, isIdentifier);
                    return makeTempVariableName(268435456 /* _i */ , !!(autoGenerate.flags & 8 /* ReservedInNestedScopes */ ), /*privateName*/ false, prefix, suffix);
                case 3 /* Unique */ :
                    return makeUniqueName2(idText(name), autoGenerate.flags & 32 /* FileLevel */  ? isFileLevelUniqueNameInCurrentFile : isUniqueName, !!(autoGenerate.flags & 16 /* Optimistic */ ), !!(autoGenerate.flags & 8 /* ReservedInNestedScopes */ ), isPrivateIdentifier(name), prefix, suffix);
            }
            return Debug.fail(`Unsupported GeneratedIdentifierKind: ${Debug.formatEnum(autoGenerate.flags & 7 /* KindMask */ , GeneratedIdentifierFlags, /*isFlags*/ true)}.`);
        }
        function pipelineEmitWithComments(hint, node) {
            const pipelinePhase = getNextPipelinePhase(2 /* Comments */ , hint, node);
            const savedContainerPos = containerPos;
            const savedContainerEnd = containerEnd;
            const savedDeclarationListContainerEnd = declarationListContainerEnd;
            emitCommentsBeforeNode(node);
            pipelinePhase(hint, node);
            emitCommentsAfterNode(node, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd);
        }
        function emitCommentsBeforeNode(node) {
            const emitFlags = getEmitFlags(node);
            const commentRange = getCommentRange(node);
            emitLeadingCommentsOfNode(node, emitFlags, commentRange.pos, commentRange.end);
            if (emitFlags & 4096 /* NoNestedComments */ ) commentsDisabled = true;
        }
        function emitCommentsAfterNode(node, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd) {
            const emitFlags = getEmitFlags(node);
            const commentRange = getCommentRange(node);
            if (emitFlags & 4096 /* NoNestedComments */ ) commentsDisabled = false;
            emitTrailingCommentsOfNode(node, emitFlags, commentRange.pos, commentRange.end, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd);
            const typeNode = getTypeNode(node);
            if (typeNode) emitTrailingCommentsOfNode(node, emitFlags, typeNode.pos, typeNode.end, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd);
        }
        function emitLeadingCommentsOfNode(node, emitFlags, pos, end) {
            enterComment();
            hasWrittenComment = false;
            const skipLeadingComments = pos < 0 || (emitFlags & 1024 /* NoLeadingComments */ ) !== 0 || node.kind === 12 /* JsxText */ ;
            const skipTrailingComments = end < 0 || (emitFlags & 2048 /* NoTrailingComments */ ) !== 0 || node.kind === 12 /* JsxText */ ;
            if ((pos > 0 || end > 0) && pos !== end) {
                if (!skipLeadingComments) emitLeadingComments(pos, /*isEmittedNode*/ node.kind !== 358 /* NotEmittedStatement */ );
                if (!skipLeadingComments || pos >= 0 && (emitFlags & 1024 /* NoLeadingComments */ ) !== 0) containerPos = pos;
                if (!skipTrailingComments || end >= 0 && (emitFlags & 2048 /* NoTrailingComments */ ) !== 0) {
                    containerEnd = end;
                    if (node.kind === 260 /* VariableDeclarationList */ ) declarationListContainerEnd = end;
                }
            }
            forEach(getSyntheticLeadingComments(node), emitLeadingSynthesizedComment);
            exitComment();
        }
        function emitTrailingCommentsOfNode(node, emitFlags, pos, end, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd) {
            enterComment();
            const skipTrailingComments = end < 0 || (emitFlags & 2048 /* NoTrailingComments */ ) !== 0 || node.kind === 12 /* JsxText */ ;
            forEach(getSyntheticTrailingComments(node), emitTrailingSynthesizedComment);
            if ((pos > 0 || end > 0) && pos !== end) {
                containerPos = savedContainerPos;
                containerEnd = savedContainerEnd;
                declarationListContainerEnd = savedDeclarationListContainerEnd;
                if (!skipTrailingComments && node.kind !== 358 /* NotEmittedStatement */ ) emitTrailingComments(end);
            }
            exitComment();
        }
        function emitLeadingSynthesizedComment(comment) {
            if (comment.hasLeadingNewline || comment.kind === 2 /* SingleLineCommentTrivia */ ) writer.writeLine();
            writeSynthesizedComment(comment);
            if (comment.hasTrailingNewLine || comment.kind === 2 /* SingleLineCommentTrivia */ ) writer.writeLine();
            else writer.writeSpace(" ");
        }
        function emitTrailingSynthesizedComment(comment) {
            if (!writer.isAtStartOfLine()) writer.writeSpace(" ");
            writeSynthesizedComment(comment);
            if (comment.hasTrailingNewLine) writer.writeLine();
        }
        function writeSynthesizedComment(comment) {
            const text = formatSynthesizedComment(comment);
            const lineMap = comment.kind === 3 /* MultiLineCommentTrivia */  ? computeLineStarts(text) : void 0;
            writeCommentRange(text, lineMap, writer, 0, text.length, newLine);
        }
        function formatSynthesizedComment(comment) {
            return comment.kind === 3 /* MultiLineCommentTrivia */  ? `/*${comment.text}*/` : `//${comment.text}`;
        }
        function emitBodyWithDetachedComments(node, detachedRange, emitCallback) {
            enterComment();
            const { pos: pos , end: end  } = detachedRange;
            const emitFlags = getEmitFlags(node);
            const skipLeadingComments = pos < 0 || (emitFlags & 1024 /* NoLeadingComments */ ) !== 0;
            const skipTrailingComments = commentsDisabled || end < 0 || (emitFlags & 2048 /* NoTrailingComments */ ) !== 0;
            if (!skipLeadingComments) emitDetachedCommentsAndUpdateCommentsInfo(detachedRange);
            exitComment();
            if (emitFlags & 4096 /* NoNestedComments */  && !commentsDisabled) {
                commentsDisabled = true;
                emitCallback(node);
                commentsDisabled = false;
            } else emitCallback(node);
            enterComment();
            if (!skipTrailingComments) {
                emitLeadingComments(detachedRange.end, /*isEmittedNode*/ true);
                if (hasWrittenComment && !writer.isAtStartOfLine()) writer.writeLine();
            }
            exitComment();
        }
        function originalNodesHaveSameParent(nodeA, nodeB) {
            nodeA = getOriginalNode(nodeA);
            return nodeA.parent && nodeA.parent === getOriginalNode(nodeB).parent;
        }
        function siblingNodePositionsAreComparable(previousNode, nextNode) {
            if (nextNode.pos < previousNode.end) return false;
            previousNode = getOriginalNode(previousNode);
            nextNode = getOriginalNode(nextNode);
            const parent2 = previousNode.parent;
            if (!parent2 || parent2 !== nextNode.parent) return false;
            const parentNodeArray = getContainingNodeArray(previousNode);
            const prevNodeIndex = parentNodeArray == null ? void 0 : parentNodeArray.indexOf(previousNode);
            return prevNodeIndex !== void 0 && prevNodeIndex > -1 && parentNodeArray.indexOf(nextNode) === prevNodeIndex + 1;
        }
        function emitLeadingComments(pos, isEmittedNode) {
            hasWrittenComment = false;
            if (isEmittedNode) {
                if (pos === 0 && (currentSourceFile == null ? void 0 : currentSourceFile.isDeclarationFile)) forEachLeadingCommentToEmit(pos, emitNonTripleSlashLeadingComment);
                else forEachLeadingCommentToEmit(pos, emitLeadingComment);
            } else if (pos === 0) forEachLeadingCommentToEmit(pos, emitTripleSlashLeadingComment);
        }
        function emitTripleSlashLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos) {
            if (isTripleSlashComment(commentPos, commentEnd)) emitLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos);
        }
        function emitNonTripleSlashLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos) {
            if (!isTripleSlashComment(commentPos, commentEnd)) emitLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos);
        }
        function shouldWriteComment(text, pos) {
            if (printerOptions.onlyPrintJsDocStyle) return isJSDocLikeText(text, pos) || isPinnedComment(text, pos);
            return true;
        }
        function emitLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos) {
            if (!currentSourceFile || !shouldWriteComment(currentSourceFile.text, commentPos)) return;
            if (!hasWrittenComment) {
                emitNewLineBeforeLeadingCommentOfPosition(getCurrentLineMap(), writer, rangePos, commentPos);
                hasWrittenComment = true;
            }
            emitPos(commentPos);
            writeCommentRange(currentSourceFile.text, getCurrentLineMap(), writer, commentPos, commentEnd, newLine);
            emitPos(commentEnd);
            if (hasTrailingNewLine) writer.writeLine();
            else if (kind === 3 /* MultiLineCommentTrivia */ ) writer.writeSpace(" ");
        }
        function emitLeadingCommentsOfPosition(pos) {
            if (commentsDisabled || pos === -1) return;
            emitLeadingComments(pos, /*isEmittedNode*/ true);
        }
        function emitTrailingComments(pos) {
            forEachTrailingCommentToEmit(pos, emitTrailingComment);
        }
        function emitTrailingComment(commentPos, commentEnd, _kind, hasTrailingNewLine) {
            if (!currentSourceFile || !shouldWriteComment(currentSourceFile.text, commentPos)) return;
            if (!writer.isAtStartOfLine()) writer.writeSpace(" ");
            emitPos(commentPos);
            writeCommentRange(currentSourceFile.text, getCurrentLineMap(), writer, commentPos, commentEnd, newLine);
            emitPos(commentEnd);
            if (hasTrailingNewLine) writer.writeLine();
        }
        function emitTrailingCommentsOfPosition(pos, prefixSpace, forceNoNewline) {
            if (commentsDisabled) return;
            enterComment();
            forEachTrailingCommentToEmit(pos, prefixSpace ? emitTrailingComment : forceNoNewline ? emitTrailingCommentOfPositionNoNewline : emitTrailingCommentOfPosition);
            exitComment();
        }
        function emitTrailingCommentOfPositionNoNewline(commentPos, commentEnd, kind) {
            if (!currentSourceFile) return;
            emitPos(commentPos);
            writeCommentRange(currentSourceFile.text, getCurrentLineMap(), writer, commentPos, commentEnd, newLine);
            emitPos(commentEnd);
            if (kind === 2 /* SingleLineCommentTrivia */ ) writer.writeLine();
        }
        function emitTrailingCommentOfPosition(commentPos, commentEnd, _kind, hasTrailingNewLine) {
            if (!currentSourceFile) return;
            emitPos(commentPos);
            writeCommentRange(currentSourceFile.text, getCurrentLineMap(), writer, commentPos, commentEnd, newLine);
            emitPos(commentEnd);
            if (hasTrailingNewLine) writer.writeLine();
            else writer.writeSpace(" ");
        }
        function forEachLeadingCommentToEmit(pos, cb) {
            if (currentSourceFile && (containerPos === -1 || pos !== containerPos)) {
                if (hasDetachedComments(pos)) forEachLeadingCommentWithoutDetachedComments(cb);
                else forEachLeadingCommentRange(currentSourceFile.text, pos, cb, /*state*/ pos);
            }
        }
        function forEachTrailingCommentToEmit(end, cb) {
            if (currentSourceFile && (containerEnd === -1 || end !== containerEnd && end !== declarationListContainerEnd)) forEachTrailingCommentRange(currentSourceFile.text, end, cb);
        }
        function hasDetachedComments(pos) {
            return detachedCommentsInfo !== void 0 && last(detachedCommentsInfo).nodePos === pos;
        }
        function forEachLeadingCommentWithoutDetachedComments(cb) {
            if (!currentSourceFile) return;
            const pos = last(detachedCommentsInfo).detachedCommentEndPos;
            if (detachedCommentsInfo.length - 1) detachedCommentsInfo.pop();
            else detachedCommentsInfo = void 0;
            forEachLeadingCommentRange(currentSourceFile.text, pos, cb, /*state*/ pos);
        }
        function emitDetachedCommentsAndUpdateCommentsInfo(range) {
            const currentDetachedCommentInfo = currentSourceFile && emitDetachedComments(currentSourceFile.text, getCurrentLineMap(), writer, emitComment, range, newLine, commentsDisabled);
            if (currentDetachedCommentInfo) {
                if (detachedCommentsInfo) detachedCommentsInfo.push(currentDetachedCommentInfo);
                else detachedCommentsInfo = [
                    currentDetachedCommentInfo
                ];
            }
        }
        function emitComment(text, lineMap, writer2, commentPos, commentEnd, newLine2) {
            if (!currentSourceFile || !shouldWriteComment(currentSourceFile.text, commentPos)) return;
            emitPos(commentPos);
            writeCommentRange(text, lineMap, writer2, commentPos, commentEnd, newLine2);
            emitPos(commentEnd);
        }
        function isTripleSlashComment(commentPos, commentEnd) {
            return !!currentSourceFile && isRecognizedTripleSlashComment(currentSourceFile.text, commentPos, commentEnd);
        }
        function getParsedSourceMap(node) {
            if (node.parsedSourceMap === void 0 && node.sourceMapText !== void 0) node.parsedSourceMap = tryParseRawSourceMap(node.sourceMapText) || false;
            return node.parsedSourceMap || void 0;
        }
        function pipelineEmitWithSourceMaps(hint, node) {
            const pipelinePhase = getNextPipelinePhase(3 /* SourceMaps */ , hint, node);
            emitSourceMapsBeforeNode(node);
            pipelinePhase(hint, node);
            emitSourceMapsAfterNode(node);
        }
        function emitSourceMapsBeforeNode(node) {
            const emitFlags = getEmitFlags(node);
            const sourceMapRange = getSourceMapRange(node);
            if (isUnparsedNode(node)) {
                Debug.assertIsDefined(node.parent, "UnparsedNodes must have parent pointers");
                const parsed = getParsedSourceMap(node.parent);
                if (parsed && sourceMapGenerator) sourceMapGenerator.appendSourceMap(writer.getLine(), writer.getColumn(), parsed, node.parent.sourceMapPath, node.parent.getLineAndCharacterOfPosition(node.pos), node.parent.getLineAndCharacterOfPosition(node.end));
            } else {
                const source = sourceMapRange.source || sourceMapSource;
                if (node.kind !== 358 /* NotEmittedStatement */  && (emitFlags & 32 /* NoLeadingSourceMap */ ) === 0 && sourceMapRange.pos >= 0) emitSourcePos(sourceMapRange.source || sourceMapSource, skipSourceTrivia(source, sourceMapRange.pos));
                if (emitFlags & 128 /* NoNestedSourceMaps */ ) sourceMapsDisabled = true;
            }
        }
        function emitSourceMapsAfterNode(node) {
            const emitFlags = getEmitFlags(node);
            const sourceMapRange = getSourceMapRange(node);
            if (!isUnparsedNode(node)) {
                if (emitFlags & 128 /* NoNestedSourceMaps */ ) sourceMapsDisabled = false;
                if (node.kind !== 358 /* NotEmittedStatement */  && (emitFlags & 64 /* NoTrailingSourceMap */ ) === 0 && sourceMapRange.end >= 0) emitSourcePos(sourceMapRange.source || sourceMapSource, sourceMapRange.end);
            }
        }
        function skipSourceTrivia(source, pos) {
            return source.skipTrivia ? source.skipTrivia(pos) : skipTrivia(source.text, pos);
        }
        function emitPos(pos) {
            if (sourceMapsDisabled || positionIsSynthesized(pos) || isJsonSourceMapSource(sourceMapSource)) return;
            const { line: sourceLine , character: sourceCharacter  } = getLineAndCharacterOfPosition(sourceMapSource, pos);
            sourceMapGenerator.addMapping(writer.getLine(), writer.getColumn(), sourceMapSourceIndex, sourceLine, sourceCharacter, /*nameIndex*/ void 0);
        }
        function emitSourcePos(source, pos) {
            if (source !== sourceMapSource) {
                const savedSourceMapSource = sourceMapSource;
                const savedSourceMapSourceIndex = sourceMapSourceIndex;
                setSourceMapSource(source);
                emitPos(pos);
                resetSourceMapSource(savedSourceMapSource, savedSourceMapSourceIndex);
            } else emitPos(pos);
        }
        function emitTokenWithSourceMap(node, token, writer2, tokenPos, emitCallback) {
            if (sourceMapsDisabled || node && isInJsonFile(node)) return emitCallback(token, writer2, tokenPos);
            const emitNode = node && node.emitNode;
            const emitFlags = emitNode && emitNode.flags || 0 /* None */ ;
            const range = emitNode && emitNode.tokenSourceMapRanges && emitNode.tokenSourceMapRanges[token];
            const source = range && range.source || sourceMapSource;
            tokenPos = skipSourceTrivia(source, range ? range.pos : tokenPos);
            if ((emitFlags & 256 /* NoTokenLeadingSourceMaps */ ) === 0 && tokenPos >= 0) emitSourcePos(source, tokenPos);
            tokenPos = emitCallback(token, writer2, tokenPos);
            if (range) tokenPos = range.end;
            if ((emitFlags & 512 /* NoTokenTrailingSourceMaps */ ) === 0 && tokenPos >= 0) emitSourcePos(source, tokenPos);
            return tokenPos;
        }
        function setSourceMapSource(source) {
            if (sourceMapsDisabled) return;
            sourceMapSource = source;
            if (source === mostRecentlyAddedSourceMapSource) {
                sourceMapSourceIndex = mostRecentlyAddedSourceMapSourceIndex;
                return;
            }
            if (isJsonSourceMapSource(source)) return;
            sourceMapSourceIndex = sourceMapGenerator.addSource(source.fileName);
            if (printerOptions.inlineSources) sourceMapGenerator.setSourceContent(sourceMapSourceIndex, source.text);
            mostRecentlyAddedSourceMapSource = source;
            mostRecentlyAddedSourceMapSourceIndex = sourceMapSourceIndex;
        }
        function resetSourceMapSource(source, sourceIndex) {
            sourceMapSource = source;
            sourceMapSourceIndex = sourceIndex;
        }
        function isJsonSourceMapSource(sourceFile) {
            return fileExtensionIs(sourceFile.fileName, ".json" /* Json */ );
        }
    }
    function createBracketsMap() {
        const brackets2 = [];
        brackets2[1024 /* Braces */ ] = [
            "{",
            "}"
        ];
        brackets2[2048 /* Parenthesis */ ] = [
            "(",
            ")"
        ];
        brackets2[4096 /* AngleBrackets */ ] = [
            "<",
            ">"
        ];
        brackets2[8192 /* SquareBrackets */ ] = [
            "[",
            "]"
        ];
        return brackets2;
    }
    function getOpeningBracket(format) {
        return brackets[format & 15360 /* BracketsMask */ ][0];
    }
    function getClosingBracket(format) {
        return brackets[format & 15360 /* BracketsMask */ ][1];
    }
    function emitListItemNoParenthesizer(node, emit, _parenthesizerRule, _index) {
        emit(node);
    }
    function emitListItemWithParenthesizerRuleSelector(node, emit, parenthesizerRuleSelector, index) {
        emit(node, parenthesizerRuleSelector.select(index));
    }
    function emitListItemWithParenthesizerRule(node, emit, parenthesizerRule, _index) {
        emit(node, parenthesizerRule);
    }
    function getEmitListItem(emit, parenthesizerRule) {
        return emit.length === 1 ? emitListItemNoParenthesizer : typeof parenthesizerRule === "object" ? emitListItemWithParenthesizerRuleSelector : emitListItemWithParenthesizerRule;
    }
    var brackets, notImplementedResolver, createPrinterWithDefaults, createPrinterWithRemoveComments, createPrinterWithRemoveCommentsNeverAsciiEscape, createPrinterWithRemoveCommentsOmitTrailingSemicolon;
    var init_emitter = __esm({
        "src/compiler/emitter.ts" () {
            "use strict";
            init_ts2();
            init_ts2();
            init_ts_performance();
            brackets = createBracketsMap();
            notImplementedResolver = {
                hasGlobalName: notImplemented,
                getReferencedExportContainer: notImplemented,
                getReferencedImportDeclaration: notImplemented,
                getReferencedDeclarationWithCollidingName: notImplemented,
                isDeclarationWithCollidingName: notImplemented,
                isValueAliasDeclaration: notImplemented,
                isReferencedAliasDeclaration: notImplemented,
                isTopLevelValueImportEqualsWithEntityName: notImplemented,
                getNodeCheckFlags: notImplemented,
                isDeclarationVisible: notImplemented,
                isLateBound: (_node)=>false,
                collectLinkedAliases: notImplemented,
                isImplementationOfOverload: notImplemented,
                isRequiredInitializedParameter: notImplemented,
                isOptionalUninitializedParameterProperty: notImplemented,
                isExpandoFunctionDeclaration: notImplemented,
                getPropertiesOfContainerFunction: notImplemented,
                createTypeOfDeclaration: notImplemented,
                createReturnTypeOfSignatureDeclaration: notImplemented,
                createTypeOfExpression: notImplemented,
                createLiteralConstValue: notImplemented,
                isSymbolAccessible: notImplemented,
                isEntityNameVisible: notImplemented,
                // Returns the constant value this property access resolves to: notImplemented, or 'undefined' for a non-constant
                getConstantValue: notImplemented,
                getReferencedValueDeclaration: notImplemented,
                getReferencedValueDeclarations: notImplemented,
                getTypeReferenceSerializationKind: notImplemented,
                isOptionalParameter: notImplemented,
                moduleExportsSomeValue: notImplemented,
                isArgumentsLocalBinding: notImplemented,
                getExternalModuleFileFromDeclaration: notImplemented,
                getTypeReferenceDirectivesForEntityName: notImplemented,
                getTypeReferenceDirectivesForSymbol: notImplemented,
                isLiteralConstDeclaration: notImplemented,
                getJsxFactoryEntity: notImplemented,
                getJsxFragmentFactoryEntity: notImplemented,
                getAllAccessorDeclarations: notImplemented,
                getSymbolOfExternalModuleSpecifier: notImplemented,
                isBindingCapturedByNode: notImplemented,
                getDeclarationStatementsForSourceFile: notImplemented,
                isImportRequiredByAugmentation: notImplemented
            };
            createPrinterWithDefaults = /* @__PURE__ */ memoize(()=>createPrinter({}));
            createPrinterWithRemoveComments = /* @__PURE__ */ memoize(()=>createPrinter({
                    removeComments: true
                }));
            createPrinterWithRemoveCommentsNeverAsciiEscape = /* @__PURE__ */ memoize(()=>createPrinter({
                    removeComments: true,
                    neverAsciiEscape: true
                }));
            createPrinterWithRemoveCommentsOmitTrailingSemicolon = /* @__PURE__ */ memoize(()=>createPrinter({
                    removeComments: true,
                    omitTrailingSemicolon: true
                }));
        }
    });
    // src/compiler/watchUtilities.ts
    function createCachedDirectoryStructureHost(host, currentDirectory, useCaseSensitiveFileNames) {
        if (!host.getDirectories || !host.readDirectory) return void 0;
        const cachedReadDirectoryResult = /* @__PURE__ */ new Map();
        const getCanonicalFileName = createGetCanonicalFileName(useCaseSensitiveFileNames);
        return {
            useCaseSensitiveFileNames: useCaseSensitiveFileNames,
            fileExists: fileExists,
            readFile: (path, encoding)=>host.readFile(path, encoding),
            directoryExists: host.directoryExists && directoryExists,
            getDirectories: getDirectories,
            readDirectory: readDirectory,
            createDirectory: host.createDirectory && createDirectory,
            writeFile: host.writeFile && writeFile2,
            addOrDeleteFileOrDirectory: addOrDeleteFileOrDirectory,
            addOrDeleteFile: addOrDeleteFile,
            clearCache: clearCache,
            realpath: host.realpath && realpath
        };
        function toPath3(fileName) {
            return toPath(fileName, currentDirectory, getCanonicalFileName);
        }
        function getCachedFileSystemEntries(rootDirPath) {
            return cachedReadDirectoryResult.get(ensureTrailingDirectorySeparator(rootDirPath));
        }
        function getCachedFileSystemEntriesForBaseDir(path) {
            const entries = getCachedFileSystemEntries(getDirectoryPath(path));
            if (!entries) return entries;
            if (!entries.sortedAndCanonicalizedFiles) {
                entries.sortedAndCanonicalizedFiles = entries.files.map(getCanonicalFileName).sort();
                entries.sortedAndCanonicalizedDirectories = entries.directories.map(getCanonicalFileName).sort();
            }
            return entries;
        }
        function getBaseNameOfFileName(fileName) {
            return getBaseFileName(normalizePath(fileName));
        }
        function createCachedFileSystemEntries(rootDir, rootDirPath) {
            var _a;
            if (!host.realpath || ensureTrailingDirectorySeparator(toPath3(host.realpath(rootDir))) === rootDirPath) {
                const resultFromHost = {
                    files: map(host.readDirectory(rootDir, /*extensions*/ void 0, /*exclude*/ void 0, /*include*/ [
                        "*.*"
                    ]), getBaseNameOfFileName) || [],
                    directories: host.getDirectories(rootDir) || []
                };
                cachedReadDirectoryResult.set(ensureTrailingDirectorySeparator(rootDirPath), resultFromHost);
                return resultFromHost;
            }
            if ((_a = host.directoryExists) == null ? void 0 : _a.call(host, rootDir)) {
                cachedReadDirectoryResult.set(rootDirPath, false);
                return false;
            }
            return void 0;
        }
        function tryReadDirectory2(rootDir, rootDirPath) {
            rootDirPath = ensureTrailingDirectorySeparator(rootDirPath);
            const cachedResult = getCachedFileSystemEntries(rootDirPath);
            if (cachedResult) return cachedResult;
            try {
                return createCachedFileSystemEntries(rootDir, rootDirPath);
            } catch (_e) {
                Debug.assert(!cachedReadDirectoryResult.has(ensureTrailingDirectorySeparator(rootDirPath)));
                return void 0;
            }
        }
        function hasEntry(entries, name) {
            const index = binarySearch(entries, name, identity, compareStringsCaseSensitive);
            return index >= 0;
        }
        function writeFile2(fileName, data, writeByteOrderMark) {
            const path = toPath3(fileName);
            const result = getCachedFileSystemEntriesForBaseDir(path);
            if (result) updateFilesOfFileSystemEntry(result, getBaseNameOfFileName(fileName), /*fileExists*/ true);
            return host.writeFile(fileName, data, writeByteOrderMark);
        }
        function fileExists(fileName) {
            const path = toPath3(fileName);
            const result = getCachedFileSystemEntriesForBaseDir(path);
            return result && hasEntry(result.sortedAndCanonicalizedFiles, getCanonicalFileName(getBaseNameOfFileName(fileName))) || host.fileExists(fileName);
        }
        function directoryExists(dirPath) {
            const path = toPath3(dirPath);
            return cachedReadDirectoryResult.has(ensureTrailingDirectorySeparator(path)) || host.directoryExists(dirPath);
        }
        function createDirectory(dirPath) {
            const path = toPath3(dirPath);
            const result = getCachedFileSystemEntriesForBaseDir(path);
            if (result) {
                const baseName = getBaseNameOfFileName(dirPath);
                const canonicalizedBaseName = getCanonicalFileName(baseName);
                const canonicalizedDirectories = result.sortedAndCanonicalizedDirectories;
                if (insertSorted(canonicalizedDirectories, canonicalizedBaseName, compareStringsCaseSensitive)) result.directories.push(baseName);
            }
            host.createDirectory(dirPath);
        }
        function getDirectories(rootDir) {
            const rootDirPath = toPath3(rootDir);
            const result = tryReadDirectory2(rootDir, rootDirPath);
            if (result) return result.directories.slice();
            return host.getDirectories(rootDir);
        }
        function readDirectory(rootDir, extensions, excludes, includes, depth) {
            const rootDirPath = toPath3(rootDir);
            const rootResult = tryReadDirectory2(rootDir, rootDirPath);
            let rootSymLinkResult;
            if (rootResult !== void 0) return matchFiles(rootDir, extensions, excludes, includes, useCaseSensitiveFileNames, currentDirectory, depth, getFileSystemEntries, realpath);
            return host.readDirectory(rootDir, extensions, excludes, includes, depth);
            function getFileSystemEntries(dir) {
                const path = toPath3(dir);
                if (path === rootDirPath) return rootResult || getFileSystemEntriesFromHost(dir, path);
                const result = tryReadDirectory2(dir, path);
                return result !== void 0 ? result || getFileSystemEntriesFromHost(dir, path) : emptyFileSystemEntries;
            }
            function getFileSystemEntriesFromHost(dir, path) {
                if (rootSymLinkResult && path === rootDirPath) return rootSymLinkResult;
                const result = {
                    files: map(host.readDirectory(dir, /*extensions*/ void 0, /*exclude*/ void 0, /*include*/ [
                        "*.*"
                    ]), getBaseNameOfFileName) || emptyArray,
                    directories: host.getDirectories(dir) || emptyArray
                };
                if (path === rootDirPath) rootSymLinkResult = result;
                return result;
            }
        }
        function realpath(s) {
            return host.realpath ? host.realpath(s) : s;
        }
        function addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath) {
            const existingResult = getCachedFileSystemEntries(fileOrDirectoryPath);
            if (existingResult !== void 0) {
                clearCache();
                return void 0;
            }
            const parentResult = getCachedFileSystemEntriesForBaseDir(fileOrDirectoryPath);
            if (!parentResult) return void 0;
            if (!host.directoryExists) {
                clearCache();
                return void 0;
            }
            const baseName = getBaseNameOfFileName(fileOrDirectory);
            const fsQueryResult = {
                fileExists: host.fileExists(fileOrDirectoryPath),
                directoryExists: host.directoryExists(fileOrDirectoryPath)
            };
            if (fsQueryResult.directoryExists || hasEntry(parentResult.sortedAndCanonicalizedDirectories, getCanonicalFileName(baseName))) clearCache();
            else updateFilesOfFileSystemEntry(parentResult, baseName, fsQueryResult.fileExists);
            return fsQueryResult;
        }
        function addOrDeleteFile(fileName, filePath, eventKind) {
            if (eventKind === 1 /* Changed */ ) return;
            const parentResult = getCachedFileSystemEntriesForBaseDir(filePath);
            if (parentResult) updateFilesOfFileSystemEntry(parentResult, getBaseNameOfFileName(fileName), eventKind === 0 /* Created */ );
        }
        function updateFilesOfFileSystemEntry(parentResult, baseName, fileExists2) {
            const canonicalizedFiles = parentResult.sortedAndCanonicalizedFiles;
            const canonicalizedBaseName = getCanonicalFileName(baseName);
            if (fileExists2) {
                if (insertSorted(canonicalizedFiles, canonicalizedBaseName, compareStringsCaseSensitive)) parentResult.files.push(baseName);
            } else {
                const sortedIndex = binarySearch(canonicalizedFiles, canonicalizedBaseName, identity, compareStringsCaseSensitive);
                if (sortedIndex >= 0) {
                    canonicalizedFiles.splice(sortedIndex, 1);
                    const unsortedIndex = parentResult.files.findIndex((entry)=>getCanonicalFileName(entry) === canonicalizedBaseName);
                    parentResult.files.splice(unsortedIndex, 1);
                }
            }
        }
        function clearCache() {
            cachedReadDirectoryResult.clear();
        }
    }
    function updateSharedExtendedConfigFileWatcher(projectPath, options, extendedConfigFilesMap, createExtendedConfigFileWatch, toPath3) {
        var _a;
        const extendedConfigs = arrayToMap(((_a = options == null ? void 0 : options.configFile) == null ? void 0 : _a.extendedSourceFiles) || emptyArray, toPath3);
        extendedConfigFilesMap.forEach((watcher, extendedConfigFilePath)=>{
            if (!extendedConfigs.has(extendedConfigFilePath)) {
                watcher.projects.delete(projectPath);
                watcher.close();
            }
        });
        extendedConfigs.forEach((extendedConfigFileName, extendedConfigFilePath)=>{
            const existing = extendedConfigFilesMap.get(extendedConfigFilePath);
            if (existing) existing.projects.add(projectPath);
            else extendedConfigFilesMap.set(extendedConfigFilePath, {
                projects: /* @__PURE__ */ new Set([
                    projectPath
                ]),
                watcher: createExtendedConfigFileWatch(extendedConfigFileName, extendedConfigFilePath),
                close: ()=>{
                    const existing2 = extendedConfigFilesMap.get(extendedConfigFilePath);
                    if (!existing2 || existing2.projects.size !== 0) return;
                    existing2.watcher.close();
                    extendedConfigFilesMap.delete(extendedConfigFilePath);
                }
            });
        });
    }
    function clearSharedExtendedConfigFileWatcher(projectPath, extendedConfigFilesMap) {
        extendedConfigFilesMap.forEach((watcher)=>{
            if (watcher.projects.delete(projectPath)) watcher.close();
        });
    }
    function cleanExtendedConfigCache(extendedConfigCache, extendedConfigFilePath, toPath3) {
        if (!extendedConfigCache.delete(extendedConfigFilePath)) return;
        extendedConfigCache.forEach(({ extendedResult: extendedResult  }, key)=>{
            var _a;
            if ((_a = extendedResult.extendedSourceFiles) == null ? void 0 : _a.some((extendedFile)=>toPath3(extendedFile) === extendedConfigFilePath)) cleanExtendedConfigCache(extendedConfigCache, key, toPath3);
        });
    }
    function updatePackageJsonWatch(lookups, packageJsonWatches, createPackageJsonWatch) {
        const newMap = new Map(lookups);
        mutateMap(packageJsonWatches, newMap, {
            createNewValue: createPackageJsonWatch,
            onDeleteValue: closeFileWatcher
        });
    }
    function updateMissingFilePathsWatch(program, missingFileWatches, createMissingFileWatch) {
        const missingFilePaths = program.getMissingFilePaths();
        const newMissingFilePathMap = arrayToMap(missingFilePaths, identity, returnTrue);
        mutateMap(missingFileWatches, newMissingFilePathMap, {
            // Watch the missing files
            createNewValue: createMissingFileWatch,
            // Files that are no longer missing (e.g. because they are no longer required)
            // should no longer be watched.
            onDeleteValue: closeFileWatcher
        });
    }
    function updateWatchingWildcardDirectories(existingWatchedForWildcards, wildcardDirectories, watchDirectory) {
        mutateMap(existingWatchedForWildcards, wildcardDirectories, {
            // Create new watch and recursive info
            createNewValue: createWildcardDirectoryWatcher,
            // Close existing watch thats not needed any more
            onDeleteValue: closeFileWatcherOf,
            // Close existing watch that doesnt match in the flags
            onExistingValue: updateWildcardDirectoryWatcher
        });
        function createWildcardDirectoryWatcher(directory, flags) {
            return {
                watcher: watchDirectory(directory, flags),
                flags: flags
            };
        }
        function updateWildcardDirectoryWatcher(existingWatcher, flags, directory) {
            if (existingWatcher.flags === flags) return;
            existingWatcher.watcher.close();
            existingWatchedForWildcards.set(directory, createWildcardDirectoryWatcher(directory, flags));
        }
    }
    function isIgnoredFileFromWildCardWatching({ watchedDirPath: watchedDirPath , fileOrDirectory: fileOrDirectory , fileOrDirectoryPath: fileOrDirectoryPath , configFileName: configFileName , options: options , program: program , extraFileExtensions: extraFileExtensions , currentDirectory: currentDirectory , useCaseSensitiveFileNames: useCaseSensitiveFileNames , writeLog: writeLog , toPath: toPath3  }) {
        const newPath = removeIgnoredPath(fileOrDirectoryPath);
        if (!newPath) {
            writeLog(`Project: ${configFileName} Detected ignored path: ${fileOrDirectory}`);
            return true;
        }
        fileOrDirectoryPath = newPath;
        if (fileOrDirectoryPath === watchedDirPath) return false;
        if (hasExtension(fileOrDirectoryPath) && !isSupportedSourceFileName(fileOrDirectory, options, extraFileExtensions)) {
            writeLog(`Project: ${configFileName} Detected file add/remove of non supported extension: ${fileOrDirectory}`);
            return true;
        }
        if (isExcludedFile(fileOrDirectory, options.configFile.configFileSpecs, getNormalizedAbsolutePath(getDirectoryPath(configFileName), currentDirectory), useCaseSensitiveFileNames, currentDirectory)) {
            writeLog(`Project: ${configFileName} Detected excluded file: ${fileOrDirectory}`);
            return true;
        }
        if (!program) return false;
        if (outFile(options) || options.outDir) return false;
        if (isDeclarationFileName(fileOrDirectoryPath)) {
            if (options.declarationDir) return false;
        } else if (!fileExtensionIsOneOf(fileOrDirectoryPath, supportedJSExtensionsFlat)) return false;
        const filePathWithoutExtension = removeFileExtension(fileOrDirectoryPath);
        const realProgram = isArray(program) ? void 0 : isBuilderProgram(program) ? program.getProgramOrUndefined() : program;
        const builderProgram = !realProgram && !isArray(program) ? program : void 0;
        if (hasSourceFile(filePathWithoutExtension + ".ts" /* Ts */ ) || hasSourceFile(filePathWithoutExtension + ".tsx" /* Tsx */ )) {
            writeLog(`Project: ${configFileName} Detected output file: ${fileOrDirectory}`);
            return true;
        }
        return false;
        function hasSourceFile(file) {
            return realProgram ? !!realProgram.getSourceFileByPath(file) : builderProgram ? builderProgram.getState().fileInfos.has(file) : !!find(program, (rootFile)=>toPath3(rootFile) === file);
        }
    }
    function isBuilderProgram(program) {
        return !!program.getState;
    }
    function isEmittedFileOfProgram(program, file) {
        if (!program) return false;
        return program.isEmittedFile(file);
    }
    function getWatchFactory(host, watchLogLevel, log, getDetailWatchInfo) {
        setSysLog(watchLogLevel === 2 /* Verbose */  ? log : noop);
        const plainInvokeFactory = {
            watchFile: (file, callback, pollingInterval, options)=>host.watchFile(file, callback, pollingInterval, options),
            watchDirectory: (directory, callback, flags, options)=>host.watchDirectory(directory, callback, (flags & 1 /* Recursive */ ) !== 0, options)
        };
        const triggerInvokingFactory = watchLogLevel !== 0 /* None */  ? {
            watchFile: createTriggerLoggingAddWatch("watchFile"),
            watchDirectory: createTriggerLoggingAddWatch("watchDirectory")
        } : void 0;
        const factory2 = watchLogLevel === 2 /* Verbose */  ? {
            watchFile: createFileWatcherWithLogging,
            watchDirectory: createDirectoryWatcherWithLogging
        } : triggerInvokingFactory || plainInvokeFactory;
        const excludeWatcherFactory = watchLogLevel === 2 /* Verbose */  ? createExcludeWatcherWithLogging : returnNoopFileWatcher;
        return {
            watchFile: createExcludeHandlingAddWatch("watchFile"),
            watchDirectory: createExcludeHandlingAddWatch("watchDirectory")
        };
        function createExcludeHandlingAddWatch(key) {
            return (file, cb, flags, options, detailInfo1, detailInfo2)=>{
                var _a;
                return !matchesExclude(file, key === "watchFile" ? options == null ? void 0 : options.excludeFiles : options == null ? void 0 : options.excludeDirectories, useCaseSensitiveFileNames(), ((_a = host.getCurrentDirectory) == null ? void 0 : _a.call(host)) || "") ? factory2[key].call(/*thisArgs*/ void 0, file, cb, flags, options, detailInfo1, detailInfo2) : excludeWatcherFactory(file, flags, options, detailInfo1, detailInfo2);
            };
        }
        function useCaseSensitiveFileNames() {
            return typeof host.useCaseSensitiveFileNames === "boolean" ? host.useCaseSensitiveFileNames : host.useCaseSensitiveFileNames();
        }
        function createExcludeWatcherWithLogging(file, flags, options, detailInfo1, detailInfo2) {
            log(`ExcludeWatcher:: Added:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo)}`);
            return {
                close: ()=>log(`ExcludeWatcher:: Close:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo)}`)
            };
        }
        function createFileWatcherWithLogging(file, cb, flags, options, detailInfo1, detailInfo2) {
            log(`FileWatcher:: Added:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo)}`);
            const watcher = triggerInvokingFactory.watchFile(file, cb, flags, options, detailInfo1, detailInfo2);
            return {
                close: ()=>{
                    log(`FileWatcher:: Close:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo)}`);
                    watcher.close();
                }
            };
        }
        function createDirectoryWatcherWithLogging(file, cb, flags, options, detailInfo1, detailInfo2) {
            const watchInfo = `DirectoryWatcher:: Added:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo)}`;
            log(watchInfo);
            const start = timestamp();
            const watcher = triggerInvokingFactory.watchDirectory(file, cb, flags, options, detailInfo1, detailInfo2);
            const elapsed = timestamp() - start;
            log(`Elapsed:: ${elapsed}ms ${watchInfo}`);
            return {
                close: ()=>{
                    const watchInfo2 = `DirectoryWatcher:: Close:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo)}`;
                    log(watchInfo2);
                    const start2 = timestamp();
                    watcher.close();
                    const elapsed2 = timestamp() - start2;
                    log(`Elapsed:: ${elapsed2}ms ${watchInfo2}`);
                }
            };
        }
        function createTriggerLoggingAddWatch(key) {
            return (file, cb, flags, options, detailInfo1, detailInfo2)=>plainInvokeFactory[key].call(/*thisArgs*/ void 0, file, (...args)=>{
                    const triggerredInfo = `${key === "watchFile" ? "FileWatcher" : "DirectoryWatcher"}:: Triggered with ${args[0]} ${args[1] !== void 0 ? args[1] : ""}:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo)}`;
                    log(triggerredInfo);
                    const start = timestamp();
                    cb.call(/*thisArg*/ void 0, ...args);
                    const elapsed = timestamp() - start;
                    log(`Elapsed:: ${elapsed}ms ${triggerredInfo}`);
                }, flags, options, detailInfo1, detailInfo2);
        }
        function getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo2) {
            return `WatchInfo: ${file} ${flags} ${JSON.stringify(options)} ${getDetailWatchInfo2 ? getDetailWatchInfo2(detailInfo1, detailInfo2) : detailInfo2 === void 0 ? detailInfo1 : `${detailInfo1} ${detailInfo2}`}`;
        }
    }
    function getFallbackOptions(options) {
        const fallbackPolling = options == null ? void 0 : options.fallbackPolling;
        return {
            watchFile: fallbackPolling !== void 0 ? fallbackPolling : 1 /* PriorityPollingInterval */ 
        };
    }
    function closeFileWatcherOf(objWithWatcher) {
        objWithWatcher.watcher.close();
    }
    var ConfigFileProgramReloadLevel, WatchLogLevel;
    var init_watchUtilities = __esm({
        "src/compiler/watchUtilities.ts" () {
            "use strict";
            init_ts2();
            ConfigFileProgramReloadLevel = /* @__PURE__ */ ((ConfigFileProgramReloadLevel2)=>{
                ConfigFileProgramReloadLevel2[ConfigFileProgramReloadLevel2["None"] = 0] = "None";
                ConfigFileProgramReloadLevel2[ConfigFileProgramReloadLevel2["Partial"] = 1] = "Partial";
                ConfigFileProgramReloadLevel2[ConfigFileProgramReloadLevel2["Full"] = 2] = "Full";
                return ConfigFileProgramReloadLevel2;
            })(ConfigFileProgramReloadLevel || {});
            WatchLogLevel = /* @__PURE__ */ ((WatchLogLevel2)=>{
                WatchLogLevel2[WatchLogLevel2["None"] = 0] = "None";
                WatchLogLevel2[WatchLogLevel2["TriggerOnly"] = 1] = "TriggerOnly";
                WatchLogLevel2[WatchLogLevel2["Verbose"] = 2] = "Verbose";
                return WatchLogLevel2;
            })(WatchLogLevel || {});
        }
    });
    // src/compiler/program.ts
    function findConfigFile(searchPath, fileExists, configName = "tsconfig.json") {
        return forEachAncestorDirectory(searchPath, (ancestor)=>{
            const fileName = combinePaths(ancestor, configName);
            return fileExists(fileName) ? fileName : void 0;
        });
    }
    function resolveTripleslashReference(moduleName, containingFile) {
        const basePath = getDirectoryPath(containingFile);
        const referencedFileName = isRootedDiskPath(moduleName) ? moduleName : combinePaths(basePath, moduleName);
        return normalizePath(referencedFileName);
    }
    function computeCommonSourceDirectoryOfFilenames(fileNames, currentDirectory, getCanonicalFileName) {
        let commonPathComponents;
        const failed = forEach(fileNames, (sourceFile)=>{
            const sourcePathComponents = getNormalizedPathComponents(sourceFile, currentDirectory);
            sourcePathComponents.pop();
            if (!commonPathComponents) {
                commonPathComponents = sourcePathComponents;
                return;
            }
            const n = Math.min(commonPathComponents.length, sourcePathComponents.length);
            for(let i = 0; i < n; i++)if (getCanonicalFileName(commonPathComponents[i]) !== getCanonicalFileName(sourcePathComponents[i])) {
                if (i === 0) return true;
                commonPathComponents.length = i;
                break;
            }
            if (sourcePathComponents.length < commonPathComponents.length) commonPathComponents.length = sourcePathComponents.length;
        });
        if (failed) return "";
        if (!commonPathComponents) return currentDirectory;
        return getPathFromPathComponents(commonPathComponents);
    }
    function createCompilerHost(options, setParentNodes) {
        return createCompilerHostWorker(options, setParentNodes);
    }
    function createGetSourceFile(readFile, getCompilerOptions, setParentNodes) {
        return (fileName, languageVersionOrOptions, onError)=>{
            let text;
            try {
                mark("beforeIORead");
                text = readFile(fileName, getCompilerOptions().charset);
                mark("afterIORead");
                measure("I/O Read", "beforeIORead", "afterIORead");
            } catch (e) {
                if (onError) onError(e.message);
                text = "";
            }
            return text !== void 0 ? createSourceFile(fileName, text, languageVersionOrOptions, setParentNodes) : void 0;
        };
    }
    function createWriteFileMeasuringIO(actualWriteFile, createDirectory, directoryExists) {
        return (fileName, data, writeByteOrderMark, onError)=>{
            try {
                mark("beforeIOWrite");
                writeFileEnsuringDirectories(fileName, data, writeByteOrderMark, actualWriteFile, createDirectory, directoryExists);
                mark("afterIOWrite");
                measure("I/O Write", "beforeIOWrite", "afterIOWrite");
            } catch (e) {
                if (onError) onError(e.message);
            }
        };
    }
    function createCompilerHostWorker(options, setParentNodes, system = sys) {
        const existingDirectories = /* @__PURE__ */ new Map();
        const getCanonicalFileName = createGetCanonicalFileName(system.useCaseSensitiveFileNames);
        function directoryExists(directoryPath) {
            if (existingDirectories.has(directoryPath)) return true;
            if ((compilerHost.directoryExists || system.directoryExists)(directoryPath)) {
                existingDirectories.set(directoryPath, true);
                return true;
            }
            return false;
        }
        function getDefaultLibLocation() {
            return getDirectoryPath(normalizePath(system.getExecutingFilePath()));
        }
        const newLine = getNewLineCharacter(options);
        const realpath = system.realpath && ((path)=>system.realpath(path));
        const compilerHost = {
            getSourceFile: createGetSourceFile((fileName)=>compilerHost.readFile(fileName), ()=>options, setParentNodes),
            getDefaultLibLocation: getDefaultLibLocation,
            getDefaultLibFileName: (options2)=>combinePaths(getDefaultLibLocation(), getDefaultLibFileName(options2)),
            writeFile: createWriteFileMeasuringIO((path, data, writeByteOrderMark)=>system.writeFile(path, data, writeByteOrderMark), (path)=>(compilerHost.createDirectory || system.createDirectory)(path), (path)=>directoryExists(path)),
            getCurrentDirectory: memoize(()=>system.getCurrentDirectory()),
            useCaseSensitiveFileNames: ()=>system.useCaseSensitiveFileNames,
            getCanonicalFileName: getCanonicalFileName,
            getNewLine: ()=>newLine,
            fileExists: (fileName)=>system.fileExists(fileName),
            readFile: (fileName)=>system.readFile(fileName),
            trace: (s)=>system.write(s + newLine),
            directoryExists: (directoryName)=>system.directoryExists(directoryName),
            getEnvironmentVariable: (name)=>system.getEnvironmentVariable ? system.getEnvironmentVariable(name) : "",
            getDirectories: (path)=>system.getDirectories(path),
            realpath: realpath,
            readDirectory: (path, extensions, include, exclude, depth)=>system.readDirectory(path, extensions, include, exclude, depth),
            createDirectory: (d)=>system.createDirectory(d),
            createHash: maybeBind(system, system.createHash)
        };
        return compilerHost;
    }
    function changeCompilerHostLikeToUseCache(host, toPath3, getSourceFile) {
        const originalReadFile = host.readFile;
        const originalFileExists = host.fileExists;
        const originalDirectoryExists = host.directoryExists;
        const originalCreateDirectory = host.createDirectory;
        const originalWriteFile = host.writeFile;
        const readFileCache = /* @__PURE__ */ new Map();
        const fileExistsCache = /* @__PURE__ */ new Map();
        const directoryExistsCache = /* @__PURE__ */ new Map();
        const sourceFileCache = /* @__PURE__ */ new Map();
        const readFileWithCache = (fileName)=>{
            const key = toPath3(fileName);
            const value1 = readFileCache.get(key);
            if (value1 !== void 0) return value1 !== false ? value1 : void 0;
            return setReadFileCache(key, fileName);
        };
        const setReadFileCache = (key, fileName)=>{
            const newValue = originalReadFile.call(host, fileName);
            readFileCache.set(key, newValue !== void 0 ? newValue : false);
            return newValue;
        };
        host.readFile = (fileName)=>{
            const key = toPath3(fileName);
            const value1 = readFileCache.get(key);
            if (value1 !== void 0) return value1 !== false ? value1 : void 0;
            if (!fileExtensionIs(fileName, ".json" /* Json */ ) && !isBuildInfoFile(fileName)) return originalReadFile.call(host, fileName);
            return setReadFileCache(key, fileName);
        };
        const getSourceFileWithCache = getSourceFile ? (fileName, languageVersionOrOptions, onError, shouldCreateNewSourceFile)=>{
            const key = toPath3(fileName);
            const impliedNodeFormat = typeof languageVersionOrOptions === "object" ? languageVersionOrOptions.impliedNodeFormat : void 0;
            const forImpliedNodeFormat = sourceFileCache.get(impliedNodeFormat);
            const value1 = forImpliedNodeFormat == null ? void 0 : forImpliedNodeFormat.get(key);
            if (value1) return value1;
            const sourceFile = getSourceFile(fileName, languageVersionOrOptions, onError, shouldCreateNewSourceFile);
            if (sourceFile && (isDeclarationFileName(fileName) || fileExtensionIs(fileName, ".json" /* Json */ ))) sourceFileCache.set(impliedNodeFormat, (forImpliedNodeFormat || /* @__PURE__ */ new Map()).set(key, sourceFile));
            return sourceFile;
        } : void 0;
        host.fileExists = (fileName)=>{
            const key = toPath3(fileName);
            const value1 = fileExistsCache.get(key);
            if (value1 !== void 0) return value1;
            const newValue = originalFileExists.call(host, fileName);
            fileExistsCache.set(key, !!newValue);
            return newValue;
        };
        if (originalWriteFile) host.writeFile = (fileName, data, ...rest)=>{
            const key = toPath3(fileName);
            fileExistsCache.delete(key);
            const value1 = readFileCache.get(key);
            if (value1 !== void 0 && value1 !== data) {
                readFileCache.delete(key);
                sourceFileCache.forEach((map2)=>map2.delete(key));
            } else if (getSourceFileWithCache) sourceFileCache.forEach((map2)=>{
                const sourceFile = map2.get(key);
                if (sourceFile && sourceFile.text !== data) map2.delete(key);
            });
            originalWriteFile.call(host, fileName, data, ...rest);
        };
        if (originalDirectoryExists) {
            host.directoryExists = (directory)=>{
                const key = toPath3(directory);
                const value1 = directoryExistsCache.get(key);
                if (value1 !== void 0) return value1;
                const newValue = originalDirectoryExists.call(host, directory);
                directoryExistsCache.set(key, !!newValue);
                return newValue;
            };
            if (originalCreateDirectory) host.createDirectory = (directory)=>{
                const key = toPath3(directory);
                directoryExistsCache.delete(key);
                originalCreateDirectory.call(host, directory);
            };
        }
        return {
            originalReadFile: originalReadFile,
            originalFileExists: originalFileExists,
            originalDirectoryExists: originalDirectoryExists,
            originalCreateDirectory: originalCreateDirectory,
            originalWriteFile: originalWriteFile,
            getSourceFileWithCache: getSourceFileWithCache,
            readFileWithCache: readFileWithCache
        };
    }
    function getPreEmitDiagnostics(program, sourceFile, cancellationToken) {
        let diagnostics;
        diagnostics = addRange(diagnostics, program.getConfigFileParsingDiagnostics());
        diagnostics = addRange(diagnostics, program.getOptionsDiagnostics(cancellationToken));
        diagnostics = addRange(diagnostics, program.getSyntacticDiagnostics(sourceFile, cancellationToken));
        diagnostics = addRange(diagnostics, program.getGlobalDiagnostics(cancellationToken));
        diagnostics = addRange(diagnostics, program.getSemanticDiagnostics(sourceFile, cancellationToken));
        if (getEmitDeclarations(program.getCompilerOptions())) diagnostics = addRange(diagnostics, program.getDeclarationDiagnostics(sourceFile, cancellationToken));
        return sortAndDeduplicateDiagnostics(diagnostics || emptyArray);
    }
    function formatDiagnostics(diagnostics, host) {
        let output = "";
        for (const diagnostic of diagnostics)output += formatDiagnostic(diagnostic, host);
        return output;
    }
    function formatDiagnostic(diagnostic, host) {
        const errorMessage = `${diagnosticCategoryName(diagnostic)} TS${diagnostic.code}: ${flattenDiagnosticMessageText(diagnostic.messageText, host.getNewLine())}${host.getNewLine()}`;
        if (diagnostic.file) {
            const { line: line , character: character  } = getLineAndCharacterOfPosition(diagnostic.file, diagnostic.start);
            const fileName = diagnostic.file.fileName;
            const relativeFileName = convertToRelativePath(fileName, host.getCurrentDirectory(), (fileName2)=>host.getCanonicalFileName(fileName2));
            return `${relativeFileName}(${line + 1},${character + 1}): ` + errorMessage;
        }
        return errorMessage;
    }
    function getCategoryFormat(category) {
        switch(category){
            case 1 /* Error */ :
                return "\x1b[91m" /* Red */ ;
            case 0 /* Warning */ :
                return "\x1b[93m" /* Yellow */ ;
            case 2 /* Suggestion */ :
                return Debug.fail("Should never get an Info diagnostic on the command line.");
            case 3 /* Message */ :
                return "\x1b[94m" /* Blue */ ;
        }
    }
    function formatColorAndReset(text, formatStyle) {
        return formatStyle + text + resetEscapeSequence;
    }
    function formatCodeSpan(file, start, length2, indent2, squiggleColor, host) {
        const { line: firstLine , character: firstLineChar  } = getLineAndCharacterOfPosition(file, start);
        const { line: lastLine , character: lastLineChar  } = getLineAndCharacterOfPosition(file, start + length2);
        const lastLineInFile = getLineAndCharacterOfPosition(file, file.text.length).line;
        const hasMoreThanFiveLines = lastLine - firstLine >= 4;
        let gutterWidth = (lastLine + 1 + "").length;
        if (hasMoreThanFiveLines) gutterWidth = Math.max(ellipsis.length, gutterWidth);
        let context = "";
        for(let i = firstLine; i <= lastLine; i++){
            context += host.getNewLine();
            if (hasMoreThanFiveLines && firstLine + 1 < i && i < lastLine - 1) {
                context += indent2 + formatColorAndReset(padLeft(ellipsis, gutterWidth), gutterStyleSequence) + gutterSeparator + host.getNewLine();
                i = lastLine - 1;
            }
            const lineStart = getPositionOfLineAndCharacter(file, i, 0);
            const lineEnd = i < lastLineInFile ? getPositionOfLineAndCharacter(file, i + 1, 0) : file.text.length;
            let lineContent = file.text.slice(lineStart, lineEnd);
            lineContent = trimStringEnd(lineContent);
            lineContent = lineContent.replace(/\t/g, " ");
            context += indent2 + formatColorAndReset(padLeft(i + 1 + "", gutterWidth), gutterStyleSequence) + gutterSeparator;
            context += lineContent + host.getNewLine();
            context += indent2 + formatColorAndReset(padLeft("", gutterWidth), gutterStyleSequence) + gutterSeparator;
            context += squiggleColor;
            if (i === firstLine) {
                const lastCharForLine = i === lastLine ? lastLineChar : void 0;
                context += lineContent.slice(0, firstLineChar).replace(/\S/g, " ");
                context += lineContent.slice(firstLineChar, lastCharForLine).replace(/./g, "~");
            } else if (i === lastLine) context += lineContent.slice(0, lastLineChar).replace(/./g, "~");
            else context += lineContent.replace(/./g, "~");
            context += resetEscapeSequence;
        }
        return context;
    }
    function formatLocation(file, start, host, color = formatColorAndReset) {
        const { line: firstLine , character: firstLineChar  } = getLineAndCharacterOfPosition(file, start);
        const relativeFileName = host ? convertToRelativePath(file.fileName, host.getCurrentDirectory(), (fileName)=>host.getCanonicalFileName(fileName)) : file.fileName;
        let output = "";
        output += color(relativeFileName, "\x1b[96m" /* Cyan */ );
        output += ":";
        output += color(`${firstLine + 1}`, "\x1b[93m" /* Yellow */ );
        output += ":";
        output += color(`${firstLineChar + 1}`, "\x1b[93m" /* Yellow */ );
        return output;
    }
    function formatDiagnosticsWithColorAndContext(diagnostics, host) {
        let output = "";
        for (const diagnostic of diagnostics){
            if (diagnostic.file) {
                const { file: file , start: start  } = diagnostic;
                output += formatLocation(file, start, host);
                output += " - ";
            }
            output += formatColorAndReset(diagnosticCategoryName(diagnostic), getCategoryFormat(diagnostic.category));
            output += formatColorAndReset(` TS${diagnostic.code}: `, "\x1b[90m" /* Grey */ );
            output += flattenDiagnosticMessageText(diagnostic.messageText, host.getNewLine());
            if (diagnostic.file && diagnostic.code !== Diagnostics.File_appears_to_be_binary.code) {
                output += host.getNewLine();
                output += formatCodeSpan(diagnostic.file, diagnostic.start, diagnostic.length, "", getCategoryFormat(diagnostic.category), host);
            }
            if (diagnostic.relatedInformation) {
                output += host.getNewLine();
                for (const { file: file , start: start , length: length2 , messageText: messageText  } of diagnostic.relatedInformation){
                    if (file) {
                        output += host.getNewLine();
                        output += halfIndent + formatLocation(file, start, host);
                        output += formatCodeSpan(file, start, length2, indent, "\x1b[96m" /* Cyan */ , host);
                    }
                    output += host.getNewLine();
                    output += indent + flattenDiagnosticMessageText(messageText, host.getNewLine());
                }
            }
            output += host.getNewLine();
        }
        return output;
    }
    function flattenDiagnosticMessageText(diag2, newLine, indent2 = 0) {
        if (isString(diag2)) return diag2;
        else if (diag2 === void 0) return "";
        let result = "";
        if (indent2) {
            result += newLine;
            for(let i = 0; i < indent2; i++)result += "  ";
        }
        result += diag2.messageText;
        indent2++;
        if (diag2.next) for (const kid of diag2.next)result += flattenDiagnosticMessageText(kid, newLine, indent2);
        return result;
    }
    function getModeForFileReference(ref, containingFileMode) {
        return (isString(ref) ? containingFileMode : ref.resolutionMode) || containingFileMode;
    }
    function getModeForResolutionAtIndex(file, index) {
        if (file.impliedNodeFormat === void 0) return void 0;
        return getModeForUsageLocation(file, getModuleNameStringLiteralAt(file, index));
    }
    function isExclusivelyTypeOnlyImportOrExport(decl) {
        var _a;
        if (isExportDeclaration(decl)) return decl.isTypeOnly;
        if ((_a = decl.importClause) == null ? void 0 : _a.isTypeOnly) return true;
        return false;
    }
    function getModeForUsageLocation(file, usage) {
        var _a, _b;
        if (file.impliedNodeFormat === void 0) return void 0;
        if (isImportDeclaration(usage.parent) || isExportDeclaration(usage.parent)) {
            const isTypeOnly = isExclusivelyTypeOnlyImportOrExport(usage.parent);
            if (isTypeOnly) {
                const override = getResolutionModeOverrideForClause(usage.parent.assertClause);
                if (override) return override;
            }
        }
        if (usage.parent.parent && isImportTypeNode(usage.parent.parent)) {
            const override = getResolutionModeOverrideForClause((_a = usage.parent.parent.assertions) == null ? void 0 : _a.assertClause);
            if (override) return override;
        }
        if (file.impliedNodeFormat !== 99 /* ESNext */ ) return isImportCall(walkUpParenthesizedExpressions(usage.parent)) ? 99 /* ESNext */  : 1 /* CommonJS */ ;
        const exprParentParent = (_b = walkUpParenthesizedExpressions(usage.parent)) == null ? void 0 : _b.parent;
        return exprParentParent && isImportEqualsDeclaration(exprParentParent) ? 1 /* CommonJS */  : 99 /* ESNext */ ;
    }
    function getResolutionModeOverrideForClause(clause, grammarErrorOnNode) {
        if (!clause) return void 0;
        if (length(clause.elements) !== 1) {
            grammarErrorOnNode == null || grammarErrorOnNode(clause, Diagnostics.Type_import_assertions_should_have_exactly_one_key_resolution_mode_with_value_import_or_require);
            return void 0;
        }
        const elem = clause.elements[0];
        if (!isStringLiteralLike(elem.name)) return void 0;
        if (elem.name.text !== "resolution-mode") {
            grammarErrorOnNode == null || grammarErrorOnNode(elem.name, Diagnostics.resolution_mode_is_the_only_valid_key_for_type_import_assertions);
            return void 0;
        }
        if (!isStringLiteralLike(elem.value)) return void 0;
        if (elem.value.text !== "import" && elem.value.text !== "require") {
            grammarErrorOnNode == null || grammarErrorOnNode(elem.value, Diagnostics.resolution_mode_should_be_either_require_or_import);
            return void 0;
        }
        return elem.value.text === "import" ? 99 /* ESNext */  : 1 /* CommonJS */ ;
    }
    function getModuleResolutionName(literal) {
        return literal.text;
    }
    function createModuleResolutionLoader(containingFile, redirectedReference, options, host, cache) {
        return {
            nameAndMode: moduleResolutionNameAndModeGetter,
            resolve: (moduleName, resolutionMode)=>resolveModuleName(moduleName, containingFile, options, host, cache, redirectedReference, resolutionMode)
        };
    }
    function getTypeReferenceResolutionName(entry) {
        return !isString(entry) ? toFileNameLowerCase(entry.fileName) : entry;
    }
    function createTypeReferenceResolutionLoader(containingFile, redirectedReference, options, host, cache) {
        return {
            nameAndMode: typeReferenceResolutionNameAndModeGetter,
            resolve: (typeRef, resoluionMode)=>resolveTypeReferenceDirective(typeRef, containingFile, options, host, redirectedReference, cache, resoluionMode)
        };
    }
    function loadWithModeAwareCache(entries, containingFile, redirectedReference, options, containingSourceFile, host, resolutionCache, createLoader) {
        if (entries.length === 0) return emptyArray;
        const resolutions = [];
        const cache = /* @__PURE__ */ new Map();
        const loader = createLoader(containingFile, redirectedReference, options, host, resolutionCache);
        for (const entry of entries){
            const name = loader.nameAndMode.getName(entry);
            const mode = loader.nameAndMode.getMode(entry, containingSourceFile);
            const key = createModeAwareCacheKey(name, mode);
            let result = cache.get(key);
            if (!result) cache.set(key, result = loader.resolve(name, mode));
            resolutions.push(result);
        }
        return resolutions;
    }
    function forEachResolvedProjectReference(resolvedProjectReferences, cb) {
        return forEachProjectReference(/*projectReferences*/ void 0, resolvedProjectReferences, (resolvedRef, parent2)=>resolvedRef && cb(resolvedRef, parent2));
    }
    function forEachProjectReference(projectReferences, resolvedProjectReferences, cbResolvedRef, cbRef) {
        let seenResolvedRefs;
        return worker(projectReferences, resolvedProjectReferences, /*parent*/ void 0);
        function worker(projectReferences2, resolvedProjectReferences2, parent2) {
            if (cbRef) {
                const result = cbRef(projectReferences2, parent2);
                if (result) return result;
            }
            return forEach(resolvedProjectReferences2, (resolvedRef, index)=>{
                if (resolvedRef && (seenResolvedRefs == null ? void 0 : seenResolvedRefs.has(resolvedRef.sourceFile.path))) return void 0;
                const result = cbResolvedRef(resolvedRef, parent2, index);
                if (result || !resolvedRef) return result;
                (seenResolvedRefs || (seenResolvedRefs = /* @__PURE__ */ new Set())).add(resolvedRef.sourceFile.path);
                return worker(resolvedRef.commandLine.projectReferences, resolvedRef.references, resolvedRef);
            });
        }
    }
    function getInferredLibraryNameResolveFrom(options, currentDirectory, libFileName) {
        const containingDirectory = options.configFilePath ? getDirectoryPath(options.configFilePath) : currentDirectory;
        return combinePaths(containingDirectory, `__lib_node_modules_lookup_${libFileName}__.ts`);
    }
    function getLibraryNameFromLibFileName(libFileName) {
        const components = libFileName.split(".");
        let path = components[1];
        let i = 2;
        while(components[i] && components[i] !== "d"){
            path += (i === 2 ? "/" : "-") + components[i];
            i++;
        }
        return "@typescript/lib-" + path;
    }
    function getLibFileNameFromLibReference(libReference) {
        const libName = toFileNameLowerCase(libReference.fileName);
        const libFileName = libMap.get(libName);
        return {
            libName: libName,
            libFileName: libFileName
        };
    }
    function isReferencedFile(reason) {
        switch(reason == null ? void 0 : reason.kind){
            case 3 /* Import */ :
            case 4 /* ReferenceFile */ :
            case 5 /* TypeReferenceDirective */ :
            case 7 /* LibReferenceDirective */ :
                return true;
            default:
                return false;
        }
    }
    function isReferenceFileLocation(location) {
        return location.pos !== void 0;
    }
    function getReferencedFileLocation(getSourceFileByPath, ref) {
        var _a, _b, _c, _d, _e, _f;
        const file = Debug.checkDefined(getSourceFileByPath(ref.file));
        const { kind: kind , index: index  } = ref;
        let pos, end, packageId, resolutionMode;
        switch(kind){
            case 3 /* Import */ :
                const importLiteral = getModuleNameStringLiteralAt(file, index);
                packageId = (_c = (_b = (_a = file.resolvedModules) == null ? void 0 : _a.get(importLiteral.text, getModeForResolutionAtIndex(file, index))) == null ? void 0 : _b.resolvedModule) == null ? void 0 : _c.packageId;
                if (importLiteral.pos === -1) return {
                    file: file,
                    packageId: packageId,
                    text: importLiteral.text
                };
                pos = skipTrivia(file.text, importLiteral.pos);
                end = importLiteral.end;
                break;
            case 4 /* ReferenceFile */ :
                ({ pos: pos , end: end  } = file.referencedFiles[index]);
                break;
            case 5 /* TypeReferenceDirective */ :
                ({ pos: pos , end: end , resolutionMode: resolutionMode  } = file.typeReferenceDirectives[index]);
                packageId = (_f = (_e = (_d = file.resolvedTypeReferenceDirectiveNames) == null ? void 0 : _d.get(toFileNameLowerCase(file.typeReferenceDirectives[index].fileName), resolutionMode || file.impliedNodeFormat)) == null ? void 0 : _e.resolvedTypeReferenceDirective) == null ? void 0 : _f.packageId;
                break;
            case 7 /* LibReferenceDirective */ :
                ({ pos: pos , end: end  } = file.libReferenceDirectives[index]);
                break;
            default:
                return Debug.assertNever(kind);
        }
        return {
            file: file,
            pos: pos,
            end: end,
            packageId: packageId
        };
    }
    function isProgramUptoDate(program, rootFileNames, newOptions, getSourceVersion, fileExists, hasInvalidatedResolutions, hasInvalidatedLibResolutions, hasChangedAutomaticTypeDirectiveNames, getParsedCommandLine, projectReferences) {
        if (!program || (hasChangedAutomaticTypeDirectiveNames == null ? void 0 : hasChangedAutomaticTypeDirectiveNames())) return false;
        if (!arrayIsEqualTo(program.getRootFileNames(), rootFileNames)) return false;
        let seenResolvedRefs;
        if (!arrayIsEqualTo(program.getProjectReferences(), projectReferences, projectReferenceUptoDate)) return false;
        if (program.getSourceFiles().some(sourceFileNotUptoDate)) return false;
        if (program.getMissingFilePaths().some(fileExists)) return false;
        const currentOptions = program.getCompilerOptions();
        if (!compareDataObjects(currentOptions, newOptions)) return false;
        if (program.resolvedLibReferences && forEachEntry(program.resolvedLibReferences, (_value, libFileName)=>hasInvalidatedLibResolutions(libFileName))) return false;
        if (currentOptions.configFile && newOptions.configFile) return currentOptions.configFile.text === newOptions.configFile.text;
        return true;
        function sourceFileNotUptoDate(sourceFile) {
            return !sourceFileVersionUptoDate(sourceFile) || hasInvalidatedResolutions(sourceFile.path);
        }
        function sourceFileVersionUptoDate(sourceFile) {
            return sourceFile.version === getSourceVersion(sourceFile.resolvedPath, sourceFile.fileName);
        }
        function projectReferenceUptoDate(oldRef, newRef, index) {
            return projectReferenceIsEqualTo(oldRef, newRef) && resolvedProjectReferenceUptoDate(program.getResolvedProjectReferences()[index], oldRef);
        }
        function resolvedProjectReferenceUptoDate(oldResolvedRef, oldRef) {
            if (oldResolvedRef) {
                if (contains(seenResolvedRefs, oldResolvedRef)) return true;
                const refPath2 = resolveProjectReferencePath(oldRef);
                const newParsedCommandLine = getParsedCommandLine(refPath2);
                if (!newParsedCommandLine) return false;
                if (oldResolvedRef.commandLine.options.configFile !== newParsedCommandLine.options.configFile) return false;
                if (!arrayIsEqualTo(oldResolvedRef.commandLine.fileNames, newParsedCommandLine.fileNames)) return false;
                (seenResolvedRefs || (seenResolvedRefs = [])).push(oldResolvedRef);
                return !forEach(oldResolvedRef.references, (childResolvedRef, index)=>!resolvedProjectReferenceUptoDate(childResolvedRef, oldResolvedRef.commandLine.projectReferences[index]));
            }
            const refPath = resolveProjectReferencePath(oldRef);
            return !getParsedCommandLine(refPath);
        }
    }
    function getConfigFileParsingDiagnostics(configFileParseResult) {
        return configFileParseResult.options.configFile ? [
            ...configFileParseResult.options.configFile.parseDiagnostics,
            ...configFileParseResult.errors
        ] : configFileParseResult.errors;
    }
    function getImpliedNodeFormatForFile(fileName, packageJsonInfoCache, host, options) {
        const result = getImpliedNodeFormatForFileWorker(fileName, packageJsonInfoCache, host, options);
        return typeof result === "object" ? result.impliedNodeFormat : result;
    }
    function getImpliedNodeFormatForFileWorker(fileName, packageJsonInfoCache, host, options) {
        switch(getEmitModuleResolutionKind(options)){
            case 3 /* Node16 */ :
            case 99 /* NodeNext */ :
                return fileExtensionIsOneOf(fileName, [
                    ".d.mts" /* Dmts */ ,
                    ".mts" /* Mts */ ,
                    ".mjs" /* Mjs */ 
                ]) ? 99 /* ESNext */  : fileExtensionIsOneOf(fileName, [
                    ".d.cts" /* Dcts */ ,
                    ".cts" /* Cts */ ,
                    ".cjs" /* Cjs */ 
                ]) ? 1 /* CommonJS */  : fileExtensionIsOneOf(fileName, [
                    ".d.ts" /* Dts */ ,
                    ".ts" /* Ts */ ,
                    ".tsx" /* Tsx */ ,
                    ".js" /* Js */ ,
                    ".jsx" /* Jsx */ 
                ]) ? lookupFromPackageJson() : void 0;
            default:
                return void 0;
        }
        function lookupFromPackageJson() {
            const state = getTemporaryModuleResolutionState(packageJsonInfoCache, host, options);
            const packageJsonLocations = [];
            state.failedLookupLocations = packageJsonLocations;
            state.affectingLocations = packageJsonLocations;
            const packageJsonScope = getPackageScopeForPath(fileName, state);
            const impliedNodeFormat = (packageJsonScope == null ? void 0 : packageJsonScope.contents.packageJsonContent.type) === "module" ? 99 /* ESNext */  : 1 /* CommonJS */ ;
            return {
                impliedNodeFormat: impliedNodeFormat,
                packageJsonLocations: packageJsonLocations,
                packageJsonScope: packageJsonScope
            };
        }
    }
    function shouldProgramCreateNewSourceFiles(program, newOptions) {
        if (!program) return false;
        return optionsHaveChanges(program.getCompilerOptions(), newOptions, sourceFileAffectingCompilerOptions);
    }
    function createCreateProgramOptions(rootNames, options, host, oldProgram, configFileParsingDiagnostics, typeScriptVersion3) {
        return {
            rootNames: rootNames,
            options: options,
            host: host,
            oldProgram: oldProgram,
            configFileParsingDiagnostics: configFileParsingDiagnostics,
            typeScriptVersion: typeScriptVersion3
        };
    }
    function createProgram(rootNamesOrOptions, _options, _host, _oldProgram, _configFileParsingDiagnostics) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
        const createProgramOptions = isArray(rootNamesOrOptions) ? createCreateProgramOptions(rootNamesOrOptions, _options, _host, _oldProgram, _configFileParsingDiagnostics) : rootNamesOrOptions;
        const { rootNames: rootNames , options: options , configFileParsingDiagnostics: configFileParsingDiagnostics , projectReferences: projectReferences , typeScriptVersion: typeScriptVersion3  } = createProgramOptions;
        let { oldProgram: oldProgram  } = createProgramOptions;
        const reportInvalidIgnoreDeprecations = memoize(()=>createOptionValueDiagnostic("ignoreDeprecations", Diagnostics.Invalid_value_for_ignoreDeprecations));
        let processingDefaultLibFiles;
        let processingOtherFiles;
        let files;
        let symlinks;
        let commonSourceDirectory;
        let typeChecker;
        let classifiableNames;
        const ambientModuleNameToUnmodifiedFileName = /* @__PURE__ */ new Map();
        let fileReasons = createMultiMap();
        const cachedBindAndCheckDiagnosticsForFile = {};
        const cachedDeclarationDiagnosticsForFile = {};
        let resolvedTypeReferenceDirectives = createModeAwareCache();
        let fileProcessingDiagnostics;
        let automaticTypeDirectiveNames;
        let automaticTypeDirectiveResolutions;
        let resolvedLibReferences;
        let resolvedLibProcessing;
        let packageMap;
        const maxNodeModuleJsDepth = typeof options.maxNodeModuleJsDepth === "number" ? options.maxNodeModuleJsDepth : 0;
        let currentNodeModulesDepth = 0;
        const modulesWithElidedImports = /* @__PURE__ */ new Map();
        const sourceFilesFoundSearchingNodeModules = /* @__PURE__ */ new Map();
        (_a = tracing) == null || _a.push(tracing.Phase.Program, "createProgram", {
            configFilePath: options.configFilePath,
            rootDir: options.rootDir
        }, /*separateBeginAndEnd*/ true);
        mark("beforeProgram");
        const host = createProgramOptions.host || createCompilerHost(options);
        const configParsingHost = parseConfigHostFromCompilerHostLike(host);
        let skipDefaultLib = options.noLib;
        const getDefaultLibraryFileName = memoize(()=>host.getDefaultLibFileName(options));
        const defaultLibraryPath = host.getDefaultLibLocation ? host.getDefaultLibLocation() : getDirectoryPath(getDefaultLibraryFileName());
        const programDiagnostics = createDiagnosticCollection();
        const currentDirectory = host.getCurrentDirectory();
        const supportedExtensions = getSupportedExtensions(options);
        const supportedExtensionsWithJsonIfResolveJsonModule = getSupportedExtensionsWithJsonIfResolveJsonModule(options, supportedExtensions);
        const hasEmitBlockingDiagnostics = /* @__PURE__ */ new Map();
        let _compilerOptionsObjectLiteralSyntax;
        let moduleResolutionCache;
        let actualResolveModuleNamesWorker;
        const hasInvalidatedResolutions = host.hasInvalidatedResolutions || returnFalse;
        if (host.resolveModuleNameLiterals) {
            actualResolveModuleNamesWorker = host.resolveModuleNameLiterals.bind(host);
            moduleResolutionCache = (_b = host.getModuleResolutionCache) == null ? void 0 : _b.call(host);
        } else if (host.resolveModuleNames) {
            actualResolveModuleNamesWorker = (moduleNames, containingFile, redirectedReference, options2, containingSourceFile, reusedNames)=>host.resolveModuleNames(moduleNames.map(getModuleResolutionName), containingFile, reusedNames == null ? void 0 : reusedNames.map(getModuleResolutionName), redirectedReference, options2, containingSourceFile).map((resolved)=>resolved ? resolved.extension !== void 0 ? {
                        resolvedModule: resolved
                    } : // An older host may have omitted extension, in which case we should infer it from the file extension of resolvedFileName.
                    {
                        resolvedModule: {
                            ...resolved,
                            extension: extensionFromPath(resolved.resolvedFileName)
                        }
                    } : emptyResolution);
            moduleResolutionCache = (_c = host.getModuleResolutionCache) == null ? void 0 : _c.call(host);
        } else {
            moduleResolutionCache = createModuleResolutionCache(currentDirectory, getCanonicalFileName, options);
            actualResolveModuleNamesWorker = (moduleNames, containingFile, redirectedReference, options2, containingSourceFile)=>loadWithModeAwareCache(moduleNames, containingFile, redirectedReference, options2, containingSourceFile, host, moduleResolutionCache, createModuleResolutionLoader);
        }
        let actualResolveTypeReferenceDirectiveNamesWorker;
        if (host.resolveTypeReferenceDirectiveReferences) actualResolveTypeReferenceDirectiveNamesWorker = host.resolveTypeReferenceDirectiveReferences.bind(host);
        else if (host.resolveTypeReferenceDirectives) actualResolveTypeReferenceDirectiveNamesWorker = (typeDirectiveNames, containingFile, redirectedReference, options2, containingSourceFile)=>host.resolveTypeReferenceDirectives(typeDirectiveNames.map(getTypeReferenceResolutionName), containingFile, redirectedReference, options2, containingSourceFile == null ? void 0 : containingSourceFile.impliedNodeFormat).map((resolvedTypeReferenceDirective)=>({
                    resolvedTypeReferenceDirective: resolvedTypeReferenceDirective
                }));
        else {
            const typeReferenceDirectiveResolutionCache = createTypeReferenceDirectiveResolutionCache(currentDirectory, getCanonicalFileName, /*options*/ void 0, moduleResolutionCache == null ? void 0 : moduleResolutionCache.getPackageJsonInfoCache());
            actualResolveTypeReferenceDirectiveNamesWorker = (typeDirectiveNames, containingFile, redirectedReference, options2, containingSourceFile)=>loadWithModeAwareCache(typeDirectiveNames, containingFile, redirectedReference, options2, containingSourceFile, host, typeReferenceDirectiveResolutionCache, createTypeReferenceResolutionLoader);
        }
        const hasInvalidatedLibResolutions = host.hasInvalidatedLibResolutions || returnFalse;
        let actualResolveLibrary;
        if (host.resolveLibrary) actualResolveLibrary = host.resolveLibrary.bind(host);
        else {
            const libraryResolutionCache = createModuleResolutionCache(currentDirectory, getCanonicalFileName, options, moduleResolutionCache == null ? void 0 : moduleResolutionCache.getPackageJsonInfoCache());
            actualResolveLibrary = (libraryName, resolveFrom, options2)=>resolveLibrary(libraryName, resolveFrom, options2, host, libraryResolutionCache);
        }
        const packageIdToSourceFile = /* @__PURE__ */ new Map();
        let sourceFileToPackageName = /* @__PURE__ */ new Map();
        let redirectTargetsMap = createMultiMap();
        let usesUriStyleNodeCoreModules = false;
        const filesByName = /* @__PURE__ */ new Map();
        let missingFilePaths;
        const filesByNameIgnoreCase = host.useCaseSensitiveFileNames() ? /* @__PURE__ */ new Map() : void 0;
        let resolvedProjectReferences;
        let projectReferenceRedirects;
        let mapFromFileToProjectReferenceRedirects;
        let mapFromToProjectReferenceRedirectSource;
        const useSourceOfProjectReferenceRedirect = !!((_d = host.useSourceOfProjectReferenceRedirect) == null ? void 0 : _d.call(host)) && !options.disableSourceOfProjectReferenceRedirect;
        const { onProgramCreateComplete: onProgramCreateComplete , fileExists: fileExists , directoryExists: directoryExists  } = updateHostForUseSourceOfProjectReferenceRedirect({
            compilerHost: host,
            getSymlinkCache: getSymlinkCache,
            useSourceOfProjectReferenceRedirect: useSourceOfProjectReferenceRedirect,
            toPath: toPath3,
            getResolvedProjectReferences: getResolvedProjectReferences,
            getSourceOfProjectReferenceRedirect: getSourceOfProjectReferenceRedirect,
            forEachResolvedProjectReference: forEachResolvedProjectReference2
        });
        const readFile = host.readFile.bind(host);
        (_e = tracing) == null || _e.push(tracing.Phase.Program, "shouldProgramCreateNewSourceFiles", {
            hasOldProgram: !!oldProgram
        });
        const shouldCreateNewSourceFile = shouldProgramCreateNewSourceFiles(oldProgram, options);
        (_f = tracing) == null || _f.pop();
        let structureIsReused;
        (_g = tracing) == null || _g.push(tracing.Phase.Program, "tryReuseStructureFromOldProgram", {});
        structureIsReused = tryReuseStructureFromOldProgram();
        (_h = tracing) == null || _h.pop();
        if (structureIsReused !== 2 /* Completely */ ) {
            processingDefaultLibFiles = [];
            processingOtherFiles = [];
            if (projectReferences) {
                if (!resolvedProjectReferences) resolvedProjectReferences = projectReferences.map(parseProjectReferenceConfigFile);
                if (rootNames.length) resolvedProjectReferences == null || resolvedProjectReferences.forEach((parsedRef, index)=>{
                    if (!parsedRef) return;
                    const out = outFile(parsedRef.commandLine.options);
                    if (useSourceOfProjectReferenceRedirect) {
                        if (out || getEmitModuleKind(parsedRef.commandLine.options) === 0 /* None */ ) for (const fileName of parsedRef.commandLine.fileNames)processProjectReferenceFile(fileName, {
                            kind: 1 /* SourceFromProjectReference */ ,
                            index: index
                        });
                    } else {
                        if (out) processProjectReferenceFile(changeExtension(out, ".d.ts"), {
                            kind: 2 /* OutputFromProjectReference */ ,
                            index: index
                        });
                        else if (getEmitModuleKind(parsedRef.commandLine.options) === 0 /* None */ ) {
                            const getCommonSourceDirectory3 = memoize(()=>getCommonSourceDirectoryOfConfig(parsedRef.commandLine, !host.useCaseSensitiveFileNames()));
                            for (const fileName of parsedRef.commandLine.fileNames)if (!isDeclarationFileName(fileName) && !fileExtensionIs(fileName, ".json" /* Json */ )) processProjectReferenceFile(getOutputDeclarationFileName(fileName, parsedRef.commandLine, !host.useCaseSensitiveFileNames(), getCommonSourceDirectory3), {
                                kind: 2 /* OutputFromProjectReference */ ,
                                index: index
                            });
                        }
                    }
                });
            }
            (_i = tracing) == null || _i.push(tracing.Phase.Program, "processRootFiles", {
                count: rootNames.length
            });
            forEach(rootNames, (name, index)=>processRootFile(name, /*isDefaultLib*/ false, /*ignoreNoDefaultLib*/ false, {
                    kind: 0 /* RootFile */ ,
                    index: index
                }));
            (_j = tracing) == null || _j.pop();
            automaticTypeDirectiveNames ?? (automaticTypeDirectiveNames = rootNames.length ? getAutomaticTypeDirectiveNames(options, host) : emptyArray);
            automaticTypeDirectiveResolutions = createModeAwareCache();
            if (automaticTypeDirectiveNames.length) {
                (_k = tracing) == null || _k.push(tracing.Phase.Program, "processTypeReferences", {
                    count: automaticTypeDirectiveNames.length
                });
                const containingDirectory = options.configFilePath ? getDirectoryPath(options.configFilePath) : currentDirectory;
                const containingFilename = combinePaths(containingDirectory, inferredTypesContainingFile);
                const resolutions = resolveTypeReferenceDirectiveNamesReusingOldState(automaticTypeDirectiveNames, containingFilename);
                for(let i = 0; i < automaticTypeDirectiveNames.length; i++){
                    automaticTypeDirectiveResolutions.set(automaticTypeDirectiveNames[i], /*mode*/ void 0, resolutions[i]);
                    processTypeReferenceDirective(automaticTypeDirectiveNames[i], /*mode*/ void 0, resolutions[i], {
                        kind: 8 /* AutomaticTypeDirectiveFile */ ,
                        typeReference: automaticTypeDirectiveNames[i],
                        packageId: (_m = (_l = resolutions[i]) == null ? void 0 : _l.resolvedTypeReferenceDirective) == null ? void 0 : _m.packageId
                    });
                }
                (_n = tracing) == null || _n.pop();
            }
            if (rootNames.length && !skipDefaultLib) {
                const defaultLibraryFileName = getDefaultLibraryFileName();
                if (!options.lib && defaultLibraryFileName) processRootFile(defaultLibraryFileName, /*isDefaultLib*/ true, /*ignoreNoDefaultLib*/ false, {
                    kind: 6 /* LibFile */ 
                });
                else forEach(options.lib, (libFileName, index)=>{
                    processRootFile(pathForLibFile(libFileName), /*isDefaultLib*/ true, /*ignoreNoDefaultLib*/ false, {
                        kind: 6 /* LibFile */ ,
                        index: index
                    });
                });
            }
            missingFilePaths = arrayFrom(mapDefinedIterator(filesByName.entries(), ([path, file])=>file === void 0 ? path : void 0));
            files = stableSort(processingDefaultLibFiles, compareDefaultLibFiles).concat(processingOtherFiles);
            processingDefaultLibFiles = void 0;
            processingOtherFiles = void 0;
        }
        Debug.assert(!!missingFilePaths);
        if (oldProgram && host.onReleaseOldSourceFile) {
            const oldSourceFiles = oldProgram.getSourceFiles();
            for (const oldSourceFile of oldSourceFiles){
                const newFile = getSourceFileByPath(oldSourceFile.resolvedPath);
                if (shouldCreateNewSourceFile || !newFile || newFile.impliedNodeFormat !== oldSourceFile.impliedNodeFormat || // old file wasn't redirect but new file is
                oldSourceFile.resolvedPath === oldSourceFile.path && newFile.resolvedPath !== oldSourceFile.path) host.onReleaseOldSourceFile(oldSourceFile, oldProgram.getCompilerOptions(), !!getSourceFileByPath(oldSourceFile.path));
            }
            if (!host.getParsedCommandLine) oldProgram.forEachResolvedProjectReference((resolvedProjectReference)=>{
                if (!getResolvedProjectReferenceByPath(resolvedProjectReference.sourceFile.path)) host.onReleaseOldSourceFile(resolvedProjectReference.sourceFile, oldProgram.getCompilerOptions(), /*hasSourceFileByPath*/ false);
            });
        }
        if (oldProgram && host.onReleaseParsedCommandLine) forEachProjectReference(oldProgram.getProjectReferences(), oldProgram.getResolvedProjectReferences(), (oldResolvedRef, parent2, index)=>{
            const oldReference = (parent2 == null ? void 0 : parent2.commandLine.projectReferences[index]) || oldProgram.getProjectReferences()[index];
            const oldRefPath = resolveProjectReferencePath(oldReference);
            if (!(projectReferenceRedirects == null ? void 0 : projectReferenceRedirects.has(toPath3(oldRefPath)))) host.onReleaseParsedCommandLine(oldRefPath, oldResolvedRef, oldProgram.getCompilerOptions());
        });
        oldProgram = void 0;
        resolvedLibProcessing = void 0;
        const program = {
            getRootFileNames: ()=>rootNames,
            getSourceFile: getSourceFile,
            getSourceFileByPath: getSourceFileByPath,
            getSourceFiles: ()=>files,
            getMissingFilePaths: ()=>missingFilePaths,
            // TODO: GH#18217
            getModuleResolutionCache: ()=>moduleResolutionCache,
            getFilesByNameMap: ()=>filesByName,
            getCompilerOptions: ()=>options,
            getSyntacticDiagnostics: getSyntacticDiagnostics,
            getOptionsDiagnostics: getOptionsDiagnostics,
            getGlobalDiagnostics: getGlobalDiagnostics,
            getSemanticDiagnostics: getSemanticDiagnostics,
            getCachedSemanticDiagnostics: getCachedSemanticDiagnostics,
            getSuggestionDiagnostics: getSuggestionDiagnostics,
            getDeclarationDiagnostics: getDeclarationDiagnostics2,
            getBindAndCheckDiagnostics: getBindAndCheckDiagnostics,
            getProgramDiagnostics: getProgramDiagnostics,
            getTypeChecker: getTypeChecker,
            getClassifiableNames: getClassifiableNames,
            getCommonSourceDirectory: getCommonSourceDirectory2,
            emit: emit,
            getCurrentDirectory: ()=>currentDirectory,
            getNodeCount: ()=>getTypeChecker().getNodeCount(),
            getIdentifierCount: ()=>getTypeChecker().getIdentifierCount(),
            getSymbolCount: ()=>getTypeChecker().getSymbolCount(),
            getTypeCount: ()=>getTypeChecker().getTypeCount(),
            getInstantiationCount: ()=>getTypeChecker().getInstantiationCount(),
            getRelationCacheSizes: ()=>getTypeChecker().getRelationCacheSizes(),
            getFileProcessingDiagnostics: ()=>fileProcessingDiagnostics,
            getResolvedTypeReferenceDirectives: ()=>resolvedTypeReferenceDirectives,
            getAutomaticTypeDirectiveNames: ()=>automaticTypeDirectiveNames,
            getAutomaticTypeDirectiveResolutions: ()=>automaticTypeDirectiveResolutions,
            isSourceFileFromExternalLibrary: isSourceFileFromExternalLibrary,
            isSourceFileDefaultLibrary: isSourceFileDefaultLibrary,
            getSourceFileFromReference: getSourceFileFromReference,
            getLibFileFromReference: getLibFileFromReference,
            sourceFileToPackageName: sourceFileToPackageName,
            redirectTargetsMap: redirectTargetsMap,
            usesUriStyleNodeCoreModules: usesUriStyleNodeCoreModules,
            resolvedLibReferences: resolvedLibReferences,
            getCurrentPackagesMap: ()=>packageMap,
            typesPackageExists: typesPackageExists,
            packageBundlesTypes: packageBundlesTypes,
            isEmittedFile: isEmittedFile,
            getConfigFileParsingDiagnostics: getConfigFileParsingDiagnostics2,
            getProjectReferences: getProjectReferences,
            getResolvedProjectReferences: getResolvedProjectReferences,
            getProjectReferenceRedirect: getProjectReferenceRedirect,
            getResolvedProjectReferenceToRedirect: getResolvedProjectReferenceToRedirect,
            getResolvedProjectReferenceByPath: getResolvedProjectReferenceByPath,
            forEachResolvedProjectReference: forEachResolvedProjectReference2,
            isSourceOfProjectReferenceRedirect: isSourceOfProjectReferenceRedirect,
            emitBuildInfo: emitBuildInfo,
            fileExists: fileExists,
            readFile: readFile,
            directoryExists: directoryExists,
            getSymlinkCache: getSymlinkCache,
            realpath: (_o = host.realpath) == null ? void 0 : _o.bind(host),
            useCaseSensitiveFileNames: ()=>host.useCaseSensitiveFileNames(),
            getCanonicalFileName: getCanonicalFileName,
            getFileIncludeReasons: ()=>fileReasons,
            structureIsReused: structureIsReused,
            writeFile: writeFile2
        };
        onProgramCreateComplete();
        fileProcessingDiagnostics == null || fileProcessingDiagnostics.forEach((diagnostic)=>{
            switch(diagnostic.kind){
                case 1 /* FilePreprocessingFileExplainingDiagnostic */ :
                    return programDiagnostics.add(createDiagnosticExplainingFile(diagnostic.file && getSourceFileByPath(diagnostic.file), diagnostic.fileProcessingReason, diagnostic.diagnostic, diagnostic.args || emptyArray));
                case 0 /* FilePreprocessingReferencedDiagnostic */ :
                    const { file: file , pos: pos , end: end  } = getReferencedFileLocation(getSourceFileByPath, diagnostic.reason);
                    return programDiagnostics.add(createFileDiagnostic(file, Debug.checkDefined(pos), Debug.checkDefined(end) - pos, diagnostic.diagnostic, ...diagnostic.args || emptyArray));
                case 2 /* ResolutionDiagnostics */ :
                    return diagnostic.diagnostics.forEach((d)=>programDiagnostics.add(d));
                default:
                    Debug.assertNever(diagnostic);
            }
        });
        verifyCompilerOptions();
        mark("afterProgram");
        measure("Program", "beforeProgram", "afterProgram");
        (_p = tracing) == null || _p.pop();
        return program;
        function getPackagesMap() {
            if (packageMap) return packageMap;
            packageMap = /* @__PURE__ */ new Map();
            files.forEach((sf)=>{
                if (!sf.resolvedModules) return;
                sf.resolvedModules.forEach(({ resolvedModule: resolvedModule  })=>{
                    if (resolvedModule == null ? void 0 : resolvedModule.packageId) packageMap.set(resolvedModule.packageId.name, resolvedModule.extension === ".d.ts" /* Dts */  || !!packageMap.get(resolvedModule.packageId.name));
                });
            });
            return packageMap;
        }
        function typesPackageExists(packageName) {
            return getPackagesMap().has(getTypesPackageName(packageName));
        }
        function packageBundlesTypes(packageName) {
            return !!getPackagesMap().get(packageName);
        }
        function addResolutionDiagnostics(resolution) {
            var _a2;
            if (!((_a2 = resolution.resolutionDiagnostics) == null ? void 0 : _a2.length)) return;
            (fileProcessingDiagnostics ?? (fileProcessingDiagnostics = [])).push({
                kind: 2 /* ResolutionDiagnostics */ ,
                diagnostics: resolution.resolutionDiagnostics
            });
        }
        function addResolutionDiagnosticsFromResolutionOrCache(containingFile, name, resolution, mode) {
            if (host.resolveModuleNameLiterals || !host.resolveModuleNames) return addResolutionDiagnostics(resolution);
            if (!moduleResolutionCache || isExternalModuleNameRelative(name)) return;
            const containingFileName = getNormalizedAbsolutePath(containingFile.originalFileName, currentDirectory);
            const containingDir = getDirectoryPath(containingFileName);
            const redirectedReference = getRedirectReferenceForResolution(containingFile);
            const fromCache = moduleResolutionCache.getFromNonRelativeNameCache(name, mode, containingDir, redirectedReference);
            if (fromCache) addResolutionDiagnostics(fromCache);
        }
        function resolveModuleNamesWorker(moduleNames, containingFile, reusedNames) {
            var _a2, _b2;
            if (!moduleNames.length) return emptyArray;
            const containingFileName = getNormalizedAbsolutePath(containingFile.originalFileName, currentDirectory);
            const redirectedReference = getRedirectReferenceForResolution(containingFile);
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Program, "resolveModuleNamesWorker", {
                containingFileName: containingFileName
            });
            mark("beforeResolveModule");
            const result = actualResolveModuleNamesWorker(moduleNames, containingFileName, redirectedReference, options, containingFile, reusedNames);
            mark("afterResolveModule");
            measure("ResolveModule", "beforeResolveModule", "afterResolveModule");
            (_b2 = tracing) == null || _b2.pop();
            return result;
        }
        function resolveTypeReferenceDirectiveNamesWorker(typeDirectiveNames, containingFile, reusedNames) {
            var _a2, _b2;
            if (!typeDirectiveNames.length) return [];
            const containingSourceFile = !isString(containingFile) ? containingFile : void 0;
            const containingFileName = !isString(containingFile) ? getNormalizedAbsolutePath(containingFile.originalFileName, currentDirectory) : containingFile;
            const redirectedReference = containingSourceFile && getRedirectReferenceForResolution(containingSourceFile);
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Program, "resolveTypeReferenceDirectiveNamesWorker", {
                containingFileName: containingFileName
            });
            mark("beforeResolveTypeReference");
            const result = actualResolveTypeReferenceDirectiveNamesWorker(typeDirectiveNames, containingFileName, redirectedReference, options, containingSourceFile, reusedNames);
            mark("afterResolveTypeReference");
            measure("ResolveTypeReference", "beforeResolveTypeReference", "afterResolveTypeReference");
            (_b2 = tracing) == null || _b2.pop();
            return result;
        }
        function getRedirectReferenceForResolution(file) {
            const redirect = getResolvedProjectReferenceToRedirect(file.originalFileName);
            if (redirect || !isDeclarationFileName(file.originalFileName)) return redirect;
            const resultFromDts = getRedirectReferenceForResolutionFromSourceOfProject(file.path);
            if (resultFromDts) return resultFromDts;
            if (!host.realpath || !options.preserveSymlinks || !stringContains(file.originalFileName, nodeModulesPathPart)) return void 0;
            const realDeclarationPath = toPath3(host.realpath(file.originalFileName));
            return realDeclarationPath === file.path ? void 0 : getRedirectReferenceForResolutionFromSourceOfProject(realDeclarationPath);
        }
        function getRedirectReferenceForResolutionFromSourceOfProject(filePath) {
            const source = getSourceOfProjectReferenceRedirect(filePath);
            if (isString(source)) return getResolvedProjectReferenceToRedirect(source);
            if (!source) return void 0;
            return forEachResolvedProjectReference2((resolvedRef)=>{
                const out = outFile(resolvedRef.commandLine.options);
                if (!out) return void 0;
                return toPath3(out) === filePath ? resolvedRef : void 0;
            });
        }
        function compareDefaultLibFiles(a, b) {
            return compareValues(getDefaultLibFilePriority(a), getDefaultLibFilePriority(b));
        }
        function getDefaultLibFilePriority(a) {
            if (containsPath(defaultLibraryPath, a.fileName, /*ignoreCase*/ false)) {
                const basename = getBaseFileName(a.fileName);
                if (basename === "lib.d.ts" || basename === "lib.es6.d.ts") return 0;
                const name = removeSuffix(removePrefix(basename, "lib."), ".d.ts");
                const index = libs.indexOf(name);
                if (index !== -1) return index + 1;
            }
            return libs.length + 2;
        }
        function toPath3(fileName) {
            return toPath(fileName, currentDirectory, getCanonicalFileName);
        }
        function getCommonSourceDirectory2() {
            if (commonSourceDirectory === void 0) {
                const emittedFiles = filter(files, (file)=>sourceFileMayBeEmitted(file, program));
                commonSourceDirectory = getCommonSourceDirectory(options, ()=>mapDefined(emittedFiles, (file)=>file.isDeclarationFile ? void 0 : file.fileName), currentDirectory, getCanonicalFileName, (commonSourceDirectory2)=>checkSourceFilesBelongToPath(emittedFiles, commonSourceDirectory2));
            }
            return commonSourceDirectory;
        }
        function getClassifiableNames() {
            var _a2;
            if (!classifiableNames) {
                getTypeChecker();
                classifiableNames = /* @__PURE__ */ new Set();
                for (const sourceFile of files)(_a2 = sourceFile.classifiableNames) == null || _a2.forEach((value1)=>classifiableNames.add(value1));
            }
            return classifiableNames;
        }
        function resolveModuleNamesReusingOldState(moduleNames, file) {
            var _a2;
            if (structureIsReused === 0 /* Not */  && !file.ambientModuleNames.length) return resolveModuleNamesWorker(moduleNames, file, /*reusedNames*/ void 0);
            const oldSourceFile = oldProgram && oldProgram.getSourceFile(file.fileName);
            if (oldSourceFile !== file && file.resolvedModules) {
                const result2 = [];
                for (const moduleName of moduleNames){
                    const resolvedModule = file.resolvedModules.get(moduleName.text, getModeForUsageLocation(file, moduleName));
                    result2.push(resolvedModule);
                }
                return result2;
            }
            let unknownModuleNames;
            let result;
            let reusedNames;
            const predictedToResolveToAmbientModuleMarker = emptyResolution;
            for(let i = 0; i < moduleNames.length; i++){
                const moduleName = moduleNames[i];
                if (file === oldSourceFile && !hasInvalidatedResolutions(oldSourceFile.path)) {
                    const mode = getModeForUsageLocation(file, moduleName);
                    const oldResolution = (_a2 = oldSourceFile.resolvedModules) == null ? void 0 : _a2.get(moduleName.text, mode);
                    if (oldResolution == null ? void 0 : oldResolution.resolvedModule) {
                        if (isTraceEnabled(options, host)) trace(host, oldResolution.resolvedModule.packageId ? Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2, moduleName.text, getNormalizedAbsolutePath(file.originalFileName, currentDirectory), oldResolution.resolvedModule.resolvedFileName, oldResolution.resolvedModule.packageId && packageIdToString(oldResolution.resolvedModule.packageId));
                        (result ?? (result = new Array(moduleNames.length)))[i] = oldResolution;
                        (reusedNames ?? (reusedNames = [])).push(moduleName);
                        continue;
                    }
                }
                let resolvesToAmbientModuleInNonModifiedFile = false;
                if (contains(file.ambientModuleNames, moduleName.text)) {
                    resolvesToAmbientModuleInNonModifiedFile = true;
                    if (isTraceEnabled(options, host)) trace(host, Diagnostics.Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1, moduleName.text, getNormalizedAbsolutePath(file.originalFileName, currentDirectory));
                } else resolvesToAmbientModuleInNonModifiedFile = moduleNameResolvesToAmbientModuleInNonModifiedFile(moduleName);
                if (resolvesToAmbientModuleInNonModifiedFile) (result || (result = new Array(moduleNames.length)))[i] = predictedToResolveToAmbientModuleMarker;
                else (unknownModuleNames ?? (unknownModuleNames = [])).push(moduleName);
            }
            const resolutions = unknownModuleNames && unknownModuleNames.length ? resolveModuleNamesWorker(unknownModuleNames, file, reusedNames) : emptyArray;
            if (!result) {
                Debug.assert(resolutions.length === moduleNames.length);
                return resolutions;
            }
            let j = 0;
            for(let i = 0; i < result.length; i++)if (!result[i]) {
                result[i] = resolutions[j];
                j++;
            }
            Debug.assert(j === resolutions.length);
            return result;
            function moduleNameResolvesToAmbientModuleInNonModifiedFile(moduleName) {
                const resolutionToFile = getResolvedModule(oldSourceFile, moduleName.text, getModeForUsageLocation(file, moduleName));
                const resolvedFile = resolutionToFile && oldProgram.getSourceFile(resolutionToFile.resolvedFileName);
                if (resolutionToFile && resolvedFile) return false;
                const unmodifiedFile = ambientModuleNameToUnmodifiedFileName.get(moduleName.text);
                if (!unmodifiedFile) return false;
                if (isTraceEnabled(options, host)) trace(host, Diagnostics.Module_0_was_resolved_as_ambient_module_declared_in_1_since_this_file_was_not_modified, moduleName.text, unmodifiedFile);
                return true;
            }
        }
        function resolveTypeReferenceDirectiveNamesReusingOldState(typeDirectiveNames, containingFile) {
            var _a2;
            if (structureIsReused === 0 /* Not */ ) return resolveTypeReferenceDirectiveNamesWorker(typeDirectiveNames, containingFile, /*reusedNames*/ void 0);
            const oldSourceFile = !isString(containingFile) ? oldProgram && oldProgram.getSourceFile(containingFile.fileName) : void 0;
            if (!isString(containingFile)) {
                if (oldSourceFile !== containingFile && containingFile.resolvedTypeReferenceDirectiveNames) {
                    const result2 = [];
                    for (const typeDirectiveName of typeDirectiveNames){
                        const resolvedTypeReferenceDirective = containingFile.resolvedTypeReferenceDirectiveNames.get(getTypeReferenceResolutionName(typeDirectiveName), getModeForFileReference(typeDirectiveName, containingFile.impliedNodeFormat));
                        result2.push(resolvedTypeReferenceDirective);
                    }
                    return result2;
                }
            }
            let unknownTypeReferenceDirectiveNames;
            let result;
            let reusedNames;
            const containingSourceFile = !isString(containingFile) ? containingFile : void 0;
            const canReuseResolutions = !isString(containingFile) ? containingFile === oldSourceFile && !hasInvalidatedResolutions(oldSourceFile.path) : !hasInvalidatedResolutions(toPath3(containingFile));
            for(let i = 0; i < typeDirectiveNames.length; i++){
                const entry = typeDirectiveNames[i];
                if (canReuseResolutions) {
                    const typeDirectiveName = getTypeReferenceResolutionName(entry);
                    const mode = getModeForFileReference(entry, containingSourceFile == null ? void 0 : containingSourceFile.impliedNodeFormat);
                    const oldResolution = (_a2 = !isString(containingFile) ? oldSourceFile == null ? void 0 : oldSourceFile.resolvedTypeReferenceDirectiveNames : oldProgram == null ? void 0 : oldProgram.getAutomaticTypeDirectiveResolutions()) == null ? void 0 : _a2.get(typeDirectiveName, mode);
                    if (oldResolution == null ? void 0 : oldResolution.resolvedTypeReferenceDirective) {
                        if (isTraceEnabled(options, host)) trace(host, oldResolution.resolvedTypeReferenceDirective.packageId ? Diagnostics.Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2, typeDirectiveName, !isString(containingFile) ? getNormalizedAbsolutePath(containingFile.originalFileName, currentDirectory) : containingFile, oldResolution.resolvedTypeReferenceDirective.resolvedFileName, oldResolution.resolvedTypeReferenceDirective.packageId && packageIdToString(oldResolution.resolvedTypeReferenceDirective.packageId));
                        (result ?? (result = new Array(typeDirectiveNames.length)))[i] = oldResolution;
                        (reusedNames ?? (reusedNames = [])).push(entry);
                        continue;
                    }
                }
                (unknownTypeReferenceDirectiveNames ?? (unknownTypeReferenceDirectiveNames = [])).push(entry);
            }
            if (!unknownTypeReferenceDirectiveNames) return result || emptyArray;
            const resolutions = resolveTypeReferenceDirectiveNamesWorker(unknownTypeReferenceDirectiveNames, containingFile, reusedNames);
            if (!result) {
                Debug.assert(resolutions.length === typeDirectiveNames.length);
                return resolutions;
            }
            let j = 0;
            for(let i = 0; i < result.length; i++)if (!result[i]) {
                result[i] = resolutions[j];
                j++;
            }
            Debug.assert(j === resolutions.length);
            return result;
        }
        function canReuseProjectReferences() {
            return !forEachProjectReference(oldProgram.getProjectReferences(), oldProgram.getResolvedProjectReferences(), (oldResolvedRef, parent2, index)=>{
                const newRef = (parent2 ? parent2.commandLine.projectReferences : projectReferences)[index];
                const newResolvedRef = parseProjectReferenceConfigFile(newRef);
                if (oldResolvedRef) return !newResolvedRef || newResolvedRef.sourceFile !== oldResolvedRef.sourceFile || !arrayIsEqualTo(oldResolvedRef.commandLine.fileNames, newResolvedRef.commandLine.fileNames);
                else return newResolvedRef !== void 0;
            }, (oldProjectReferences, parent2)=>{
                const newReferences = parent2 ? getResolvedProjectReferenceByPath(parent2.sourceFile.path).commandLine.projectReferences : projectReferences;
                return !arrayIsEqualTo(oldProjectReferences, newReferences, projectReferenceIsEqualTo);
            });
        }
        function tryReuseStructureFromOldProgram() {
            var _a2;
            if (!oldProgram) return 0 /* Not */ ;
            const oldOptions = oldProgram.getCompilerOptions();
            if (changesAffectModuleResolution(oldOptions, options)) return 0 /* Not */ ;
            const oldRootNames = oldProgram.getRootFileNames();
            if (!arrayIsEqualTo(oldRootNames, rootNames)) return 0 /* Not */ ;
            if (!canReuseProjectReferences()) return 0 /* Not */ ;
            if (projectReferences) resolvedProjectReferences = projectReferences.map(parseProjectReferenceConfigFile);
            const newSourceFiles = [];
            const modifiedSourceFiles = [];
            structureIsReused = 2 /* Completely */ ;
            if (oldProgram.getMissingFilePaths().some((missingFilePath)=>host.fileExists(missingFilePath))) return 0 /* Not */ ;
            const oldSourceFiles = oldProgram.getSourceFiles();
            let SeenPackageName;
            ((SeenPackageName2)=>{
                SeenPackageName2[SeenPackageName2["Exists"] = 0] = "Exists";
                SeenPackageName2[SeenPackageName2["Modified"] = 1] = "Modified";
            })(SeenPackageName || (SeenPackageName = {}));
            const seenPackageNames = /* @__PURE__ */ new Map();
            for (const oldSourceFile of oldSourceFiles){
                const sourceFileOptions = getCreateSourceFileOptions(oldSourceFile.fileName, moduleResolutionCache, host, options);
                let newSourceFile = host.getSourceFileByPath ? host.getSourceFileByPath(oldSourceFile.fileName, oldSourceFile.resolvedPath, sourceFileOptions, /*onError*/ void 0, shouldCreateNewSourceFile || sourceFileOptions.impliedNodeFormat !== oldSourceFile.impliedNodeFormat) : host.getSourceFile(oldSourceFile.fileName, sourceFileOptions, /*onError*/ void 0, shouldCreateNewSourceFile || sourceFileOptions.impliedNodeFormat !== oldSourceFile.impliedNodeFormat);
                if (!newSourceFile) return 0 /* Not */ ;
                newSourceFile.packageJsonLocations = ((_a2 = sourceFileOptions.packageJsonLocations) == null ? void 0 : _a2.length) ? sourceFileOptions.packageJsonLocations : void 0;
                newSourceFile.packageJsonScope = sourceFileOptions.packageJsonScope;
                Debug.assert(!newSourceFile.redirectInfo, "Host should not return a redirect source file from `getSourceFile`");
                let fileChanged;
                if (oldSourceFile.redirectInfo) {
                    if (newSourceFile !== oldSourceFile.redirectInfo.unredirected) return 0 /* Not */ ;
                    fileChanged = false;
                    newSourceFile = oldSourceFile;
                } else if (oldProgram.redirectTargetsMap.has(oldSourceFile.path)) {
                    if (newSourceFile !== oldSourceFile) return 0 /* Not */ ;
                    fileChanged = false;
                } else fileChanged = newSourceFile !== oldSourceFile;
                newSourceFile.path = oldSourceFile.path;
                newSourceFile.originalFileName = oldSourceFile.originalFileName;
                newSourceFile.resolvedPath = oldSourceFile.resolvedPath;
                newSourceFile.fileName = oldSourceFile.fileName;
                const packageName = oldProgram.sourceFileToPackageName.get(oldSourceFile.path);
                if (packageName !== void 0) {
                    const prevKind = seenPackageNames.get(packageName);
                    const newKind = fileChanged ? 1 /* Modified */  : 0 /* Exists */ ;
                    if (prevKind !== void 0 && newKind === 1 /* Modified */  || prevKind === 1 /* Modified */ ) return 0 /* Not */ ;
                    seenPackageNames.set(packageName, newKind);
                }
                if (fileChanged) {
                    if (oldSourceFile.impliedNodeFormat !== newSourceFile.impliedNodeFormat) structureIsReused = 1 /* SafeModules */ ;
                    else if (!arrayIsEqualTo(oldSourceFile.libReferenceDirectives, newSourceFile.libReferenceDirectives, fileReferenceIsEqualTo)) structureIsReused = 1 /* SafeModules */ ;
                    else if (oldSourceFile.hasNoDefaultLib !== newSourceFile.hasNoDefaultLib) structureIsReused = 1 /* SafeModules */ ;
                    else if (!arrayIsEqualTo(oldSourceFile.referencedFiles, newSourceFile.referencedFiles, fileReferenceIsEqualTo)) structureIsReused = 1 /* SafeModules */ ;
                    else {
                        collectExternalModuleReferences(newSourceFile);
                        if (!arrayIsEqualTo(oldSourceFile.imports, newSourceFile.imports, moduleNameIsEqualTo)) structureIsReused = 1 /* SafeModules */ ;
                        else if (!arrayIsEqualTo(oldSourceFile.moduleAugmentations, newSourceFile.moduleAugmentations, moduleNameIsEqualTo)) structureIsReused = 1 /* SafeModules */ ;
                        else if ((oldSourceFile.flags & 6291456 /* PermanentlySetIncrementalFlags */ ) !== (newSourceFile.flags & 6291456 /* PermanentlySetIncrementalFlags */ )) structureIsReused = 1 /* SafeModules */ ;
                        else if (!arrayIsEqualTo(oldSourceFile.typeReferenceDirectives, newSourceFile.typeReferenceDirectives, fileReferenceIsEqualTo)) structureIsReused = 1 /* SafeModules */ ;
                    }
                    modifiedSourceFiles.push({
                        oldFile: oldSourceFile,
                        newFile: newSourceFile
                    });
                } else if (hasInvalidatedResolutions(oldSourceFile.path)) {
                    structureIsReused = 1 /* SafeModules */ ;
                    modifiedSourceFiles.push({
                        oldFile: oldSourceFile,
                        newFile: newSourceFile
                    });
                }
                newSourceFiles.push(newSourceFile);
            }
            if (structureIsReused !== 2 /* Completely */ ) return structureIsReused;
            const modifiedFiles = modifiedSourceFiles.map((f)=>f.oldFile);
            for (const oldFile of oldSourceFiles){
                if (!contains(modifiedFiles, oldFile)) for (const moduleName of oldFile.ambientModuleNames)ambientModuleNameToUnmodifiedFileName.set(moduleName, oldFile.fileName);
            }
            for (const { oldFile: oldSourceFile , newFile: newSourceFile  } of modifiedSourceFiles){
                const moduleNames = getModuleNames(newSourceFile);
                const resolutions = resolveModuleNamesReusingOldState(moduleNames, newSourceFile);
                const resolutionsChanged = hasChangesInResolutions(moduleNames, newSourceFile, resolutions, oldSourceFile.resolvedModules, moduleResolutionIsEqualTo, moduleResolutionNameAndModeGetter);
                if (resolutionsChanged) {
                    structureIsReused = 1 /* SafeModules */ ;
                    newSourceFile.resolvedModules = zipToModeAwareCache(newSourceFile, moduleNames, resolutions, moduleResolutionNameAndModeGetter);
                } else newSourceFile.resolvedModules = oldSourceFile.resolvedModules;
                const typesReferenceDirectives = newSourceFile.typeReferenceDirectives;
                const typeReferenceResolutions = resolveTypeReferenceDirectiveNamesReusingOldState(typesReferenceDirectives, newSourceFile);
                const typeReferenceResolutionsChanged = hasChangesInResolutions(typesReferenceDirectives, newSourceFile, typeReferenceResolutions, oldSourceFile.resolvedTypeReferenceDirectiveNames, typeDirectiveIsEqualTo, typeReferenceResolutionNameAndModeGetter);
                if (typeReferenceResolutionsChanged) {
                    structureIsReused = 1 /* SafeModules */ ;
                    newSourceFile.resolvedTypeReferenceDirectiveNames = zipToModeAwareCache(newSourceFile, typesReferenceDirectives, typeReferenceResolutions, typeReferenceResolutionNameAndModeGetter);
                } else newSourceFile.resolvedTypeReferenceDirectiveNames = oldSourceFile.resolvedTypeReferenceDirectiveNames;
            }
            if (structureIsReused !== 2 /* Completely */ ) return structureIsReused;
            if (changesAffectingProgramStructure(oldOptions, options)) return 1 /* SafeModules */ ;
            if (oldProgram.resolvedLibReferences && forEachEntry(oldProgram.resolvedLibReferences, (resolution, libFileName)=>pathForLibFileWorker(libFileName).actual !== resolution.actual)) return 1 /* SafeModules */ ;
            if (host.hasChangedAutomaticTypeDirectiveNames) {
                if (host.hasChangedAutomaticTypeDirectiveNames()) return 1 /* SafeModules */ ;
            } else {
                automaticTypeDirectiveNames = getAutomaticTypeDirectiveNames(options, host);
                if (!arrayIsEqualTo(oldProgram.getAutomaticTypeDirectiveNames(), automaticTypeDirectiveNames)) return 1 /* SafeModules */ ;
            }
            missingFilePaths = oldProgram.getMissingFilePaths();
            Debug.assert(newSourceFiles.length === oldProgram.getSourceFiles().length);
            for (const newSourceFile of newSourceFiles)filesByName.set(newSourceFile.path, newSourceFile);
            const oldFilesByNameMap = oldProgram.getFilesByNameMap();
            oldFilesByNameMap.forEach((oldFile, path)=>{
                if (!oldFile) {
                    filesByName.set(path, oldFile);
                    return;
                }
                if (oldFile.path === path) {
                    if (oldProgram.isSourceFileFromExternalLibrary(oldFile)) sourceFilesFoundSearchingNodeModules.set(oldFile.path, true);
                    return;
                }
                filesByName.set(path, filesByName.get(oldFile.path));
            });
            files = newSourceFiles;
            fileReasons = oldProgram.getFileIncludeReasons();
            fileProcessingDiagnostics = oldProgram.getFileProcessingDiagnostics();
            resolvedTypeReferenceDirectives = oldProgram.getResolvedTypeReferenceDirectives();
            automaticTypeDirectiveNames = oldProgram.getAutomaticTypeDirectiveNames();
            automaticTypeDirectiveResolutions = oldProgram.getAutomaticTypeDirectiveResolutions();
            sourceFileToPackageName = oldProgram.sourceFileToPackageName;
            redirectTargetsMap = oldProgram.redirectTargetsMap;
            usesUriStyleNodeCoreModules = oldProgram.usesUriStyleNodeCoreModules;
            resolvedLibReferences = oldProgram.resolvedLibReferences;
            packageMap = oldProgram.getCurrentPackagesMap();
            return 2 /* Completely */ ;
        }
        function getEmitHost(writeFileCallback) {
            return {
                getPrependNodes: getPrependNodes,
                getCanonicalFileName: getCanonicalFileName,
                getCommonSourceDirectory: program.getCommonSourceDirectory,
                getCompilerOptions: program.getCompilerOptions,
                getCurrentDirectory: ()=>currentDirectory,
                getSourceFile: program.getSourceFile,
                getSourceFileByPath: program.getSourceFileByPath,
                getSourceFiles: program.getSourceFiles,
                getLibFileFromReference: program.getLibFileFromReference,
                isSourceFileFromExternalLibrary: isSourceFileFromExternalLibrary,
                getResolvedProjectReferenceToRedirect: getResolvedProjectReferenceToRedirect,
                getProjectReferenceRedirect: getProjectReferenceRedirect,
                isSourceOfProjectReferenceRedirect: isSourceOfProjectReferenceRedirect,
                getSymlinkCache: getSymlinkCache,
                writeFile: writeFileCallback || writeFile2,
                isEmitBlocked: isEmitBlocked,
                readFile: (f)=>host.readFile(f),
                fileExists: (f)=>{
                    const path = toPath3(f);
                    if (getSourceFileByPath(path)) return true;
                    if (contains(missingFilePaths, path)) return false;
                    return host.fileExists(f);
                },
                useCaseSensitiveFileNames: ()=>host.useCaseSensitiveFileNames(),
                getBuildInfo: (bundle)=>{
                    var _a2;
                    return (_a2 = program.getBuildInfo) == null ? void 0 : _a2.call(program, bundle);
                },
                getSourceFileFromReference: (file, ref)=>program.getSourceFileFromReference(file, ref),
                redirectTargetsMap: redirectTargetsMap,
                getFileIncludeReasons: program.getFileIncludeReasons,
                createHash: maybeBind(host, host.createHash)
            };
        }
        function writeFile2(fileName, text, writeByteOrderMark, onError, sourceFiles, data) {
            host.writeFile(fileName, text, writeByteOrderMark, onError, sourceFiles, data);
        }
        function emitBuildInfo(writeFileCallback) {
            var _a2, _b2;
            Debug.assert(!outFile(options));
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Emit, "emitBuildInfo", {}, /*separateBeginAndEnd*/ true);
            mark("beforeEmit");
            const emitResult = emitFiles(notImplementedResolver, getEmitHost(writeFileCallback), /*targetSourceFile*/ void 0, /*transformers*/ noTransformers, /*emitOnly*/ false, /*onlyBuildInfo*/ true);
            mark("afterEmit");
            measure("Emit", "beforeEmit", "afterEmit");
            (_b2 = tracing) == null || _b2.pop();
            return emitResult;
        }
        function getResolvedProjectReferences() {
            return resolvedProjectReferences;
        }
        function getProjectReferences() {
            return projectReferences;
        }
        function getPrependNodes() {
            return createPrependNodes(projectReferences, (_ref, index)=>{
                var _a2;
                return (_a2 = resolvedProjectReferences[index]) == null ? void 0 : _a2.commandLine;
            }, (fileName)=>{
                const path = toPath3(fileName);
                const sourceFile = getSourceFileByPath(path);
                return sourceFile ? sourceFile.text : filesByName.has(path) ? void 0 : host.readFile(path);
            }, host);
        }
        function isSourceFileFromExternalLibrary(file) {
            return !!sourceFilesFoundSearchingNodeModules.get(file.path);
        }
        function isSourceFileDefaultLibrary(file) {
            if (!file.isDeclarationFile) return false;
            if (file.hasNoDefaultLib) return true;
            if (!options.noLib) return false;
            const equalityComparer = host.useCaseSensitiveFileNames() ? equateStringsCaseSensitive : equateStringsCaseInsensitive;
            if (!options.lib) return equalityComparer(file.fileName, getDefaultLibraryFileName());
            else return some(options.lib, (libFileName)=>equalityComparer(file.fileName, resolvedLibReferences.get(libFileName).actual));
        }
        function getTypeChecker() {
            return typeChecker || (typeChecker = createTypeChecker(program));
        }
        function emit(sourceFile, writeFileCallback, cancellationToken, emitOnly, transformers, forceDtsEmit) {
            var _a2, _b2;
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Emit, "emit", {
                path: sourceFile == null ? void 0 : sourceFile.path
            }, /*separateBeginAndEnd*/ true);
            const result = runWithCancellationToken(()=>emitWorker(program, sourceFile, writeFileCallback, cancellationToken, emitOnly, transformers, forceDtsEmit));
            (_b2 = tracing) == null || _b2.pop();
            return result;
        }
        function isEmitBlocked(emitFileName) {
            return hasEmitBlockingDiagnostics.has(toPath3(emitFileName));
        }
        function emitWorker(program2, sourceFile, writeFileCallback, cancellationToken, emitOnly, customTransformers, forceDtsEmit) {
            if (!forceDtsEmit) {
                const result = handleNoEmitOptions(program2, sourceFile, writeFileCallback, cancellationToken);
                if (result) return result;
            }
            const emitResolver = getTypeChecker().getEmitResolver(outFile(options) ? void 0 : sourceFile, cancellationToken);
            mark("beforeEmit");
            const emitResult = emitFiles(emitResolver, getEmitHost(writeFileCallback), sourceFile, getTransformers(options, customTransformers, emitOnly), emitOnly, /*onlyBuildInfo*/ false, forceDtsEmit);
            mark("afterEmit");
            measure("Emit", "beforeEmit", "afterEmit");
            return emitResult;
        }
        function getSourceFile(fileName) {
            return getSourceFileByPath(toPath3(fileName));
        }
        function getSourceFileByPath(path) {
            return filesByName.get(path) || void 0;
        }
        function getDiagnosticsHelper(sourceFile, getDiagnostics2, cancellationToken) {
            if (sourceFile) return sortAndDeduplicateDiagnostics(getDiagnostics2(sourceFile, cancellationToken));
            return sortAndDeduplicateDiagnostics(flatMap(program.getSourceFiles(), (sourceFile2)=>{
                if (cancellationToken) cancellationToken.throwIfCancellationRequested();
                return getDiagnostics2(sourceFile2, cancellationToken);
            }));
        }
        function getSyntacticDiagnostics(sourceFile, cancellationToken) {
            return getDiagnosticsHelper(sourceFile, getSyntacticDiagnosticsForFile, cancellationToken);
        }
        function getSemanticDiagnostics(sourceFile, cancellationToken) {
            return getDiagnosticsHelper(sourceFile, getSemanticDiagnosticsForFile, cancellationToken);
        }
        function getCachedSemanticDiagnostics(sourceFile) {
            var _a2;
            return sourceFile ? (_a2 = cachedBindAndCheckDiagnosticsForFile.perFile) == null ? void 0 : _a2.get(sourceFile.path) : cachedBindAndCheckDiagnosticsForFile.allDiagnostics;
        }
        function getBindAndCheckDiagnostics(sourceFile, cancellationToken) {
            return getBindAndCheckDiagnosticsForFile(sourceFile, cancellationToken);
        }
        function getProgramDiagnostics(sourceFile) {
            var _a2;
            if (skipTypeChecking(sourceFile, options, program)) return emptyArray;
            const programDiagnosticsInFile = programDiagnostics.getDiagnostics(sourceFile.fileName);
            if (!((_a2 = sourceFile.commentDirectives) == null ? void 0 : _a2.length)) return programDiagnosticsInFile;
            return getDiagnosticsWithPrecedingDirectives(sourceFile, sourceFile.commentDirectives, programDiagnosticsInFile).diagnostics;
        }
        function getDeclarationDiagnostics2(sourceFile, cancellationToken) {
            const options2 = program.getCompilerOptions();
            if (!sourceFile || outFile(options2)) return getDeclarationDiagnosticsWorker(sourceFile, cancellationToken);
            else return getDiagnosticsHelper(sourceFile, getDeclarationDiagnosticsForFile, cancellationToken);
        }
        function getSyntacticDiagnosticsForFile(sourceFile) {
            if (isSourceFileJS(sourceFile)) {
                if (!sourceFile.additionalSyntacticDiagnostics) sourceFile.additionalSyntacticDiagnostics = getJSSyntacticDiagnosticsForFile(sourceFile);
                return concatenate(sourceFile.additionalSyntacticDiagnostics, sourceFile.parseDiagnostics);
            }
            return sourceFile.parseDiagnostics;
        }
        function runWithCancellationToken(func) {
            try {
                return func();
            } catch (e) {
                if (e instanceof OperationCanceledException) typeChecker = void 0;
                throw e;
            }
        }
        function getSemanticDiagnosticsForFile(sourceFile, cancellationToken) {
            return concatenate(filterSemanticDiagnostics(getBindAndCheckDiagnosticsForFile(sourceFile, cancellationToken), options), getProgramDiagnostics(sourceFile));
        }
        function getBindAndCheckDiagnosticsForFile(sourceFile, cancellationToken) {
            return getAndCacheDiagnostics(sourceFile, cancellationToken, cachedBindAndCheckDiagnosticsForFile, getBindAndCheckDiagnosticsForFileNoCache);
        }
        function getBindAndCheckDiagnosticsForFileNoCache(sourceFile, cancellationToken) {
            return runWithCancellationToken(()=>{
                if (skipTypeChecking(sourceFile, options, program)) return emptyArray;
                const typeChecker2 = getTypeChecker();
                Debug.assert(!!sourceFile.bindDiagnostics);
                const isJs = sourceFile.scriptKind === 1 /* JS */  || sourceFile.scriptKind === 2 /* JSX */ ;
                const isCheckJs = isJs && isCheckJsEnabledForFile(sourceFile, options);
                const isPlainJs = isPlainJsFile(sourceFile, options.checkJs);
                const isTsNoCheck = !!sourceFile.checkJsDirective && sourceFile.checkJsDirective.enabled === false;
                const includeBindAndCheckDiagnostics = !isTsNoCheck && (sourceFile.scriptKind === 3 /* TS */  || sourceFile.scriptKind === 4 /* TSX */  || sourceFile.scriptKind === 5 /* External */  || isPlainJs || isCheckJs || sourceFile.scriptKind === 7 /* Deferred */ );
                let bindDiagnostics = includeBindAndCheckDiagnostics ? sourceFile.bindDiagnostics : emptyArray;
                let checkDiagnostics = includeBindAndCheckDiagnostics ? typeChecker2.getDiagnostics(sourceFile, cancellationToken) : emptyArray;
                if (isPlainJs) {
                    bindDiagnostics = filter(bindDiagnostics, (d)=>plainJSErrors.has(d.code));
                    checkDiagnostics = filter(checkDiagnostics, (d)=>plainJSErrors.has(d.code));
                }
                return getMergedBindAndCheckDiagnostics(sourceFile, includeBindAndCheckDiagnostics && !isPlainJs, bindDiagnostics, checkDiagnostics, isCheckJs ? sourceFile.jsDocDiagnostics : void 0);
            });
        }
        function getMergedBindAndCheckDiagnostics(sourceFile, includeBindAndCheckDiagnostics, ...allDiagnostics) {
            var _a2;
            const flatDiagnostics = flatten(allDiagnostics);
            if (!includeBindAndCheckDiagnostics || !((_a2 = sourceFile.commentDirectives) == null ? void 0 : _a2.length)) return flatDiagnostics;
            const { diagnostics: diagnostics , directives: directives  } = getDiagnosticsWithPrecedingDirectives(sourceFile, sourceFile.commentDirectives, flatDiagnostics);
            for (const errorExpectation of directives.getUnusedExpectations())diagnostics.push(createDiagnosticForRange(sourceFile, errorExpectation.range, Diagnostics.Unused_ts_expect_error_directive));
            return diagnostics;
        }
        function getDiagnosticsWithPrecedingDirectives(sourceFile, commentDirectives, flatDiagnostics) {
            const directives = createCommentDirectivesMap(sourceFile, commentDirectives);
            const diagnostics = flatDiagnostics.filter((diagnostic)=>markPrecedingCommentDirectiveLine(diagnostic, directives) === -1);
            return {
                diagnostics: diagnostics,
                directives: directives
            };
        }
        function getSuggestionDiagnostics(sourceFile, cancellationToken) {
            return runWithCancellationToken(()=>{
                return getTypeChecker().getSuggestionDiagnostics(sourceFile, cancellationToken);
            });
        }
        function markPrecedingCommentDirectiveLine(diagnostic, directives) {
            const { file: file , start: start  } = diagnostic;
            if (!file) return -1;
            const lineStarts = getLineStarts(file);
            let line = computeLineAndCharacterOfPosition(lineStarts, start).line - 1;
            while(line >= 0){
                if (directives.markUsed(line)) return line;
                const lineText = file.text.slice(lineStarts[line], lineStarts[line + 1]).trim();
                if (lineText !== "" && !/^(\s*)\/\/(.*)$/.test(lineText)) return -1;
                line--;
            }
            return -1;
        }
        function getJSSyntacticDiagnosticsForFile(sourceFile) {
            return runWithCancellationToken(()=>{
                const diagnostics = [];
                walk(sourceFile, sourceFile);
                forEachChildRecursively(sourceFile, walk, walkArray);
                return diagnostics;
                function walk(node, parent2) {
                    switch(parent2.kind){
                        case 168 /* Parameter */ :
                        case 171 /* PropertyDeclaration */ :
                        case 173 /* MethodDeclaration */ :
                            if (parent2.questionToken === node) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics.The_0_modifier_can_only_be_used_in_TypeScript_files, "?"));
                                return "skip";
                            }
                        case 172 /* MethodSignature */ :
                        case 175 /* Constructor */ :
                        case 176 /* GetAccessor */ :
                        case 177 /* SetAccessor */ :
                        case 217 /* FunctionExpression */ :
                        case 261 /* FunctionDeclaration */ :
                        case 218 /* ArrowFunction */ :
                        case 259 /* VariableDeclaration */ :
                            if (parent2.type === node) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics.Type_annotations_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                    }
                    switch(node.kind){
                        case 272 /* ImportClause */ :
                            if (node.isTypeOnly) {
                                diagnostics.push(createDiagnosticForNode2(parent2, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, "import type"));
                                return "skip";
                            }
                            break;
                        case 277 /* ExportDeclaration */ :
                            if (node.isTypeOnly) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, "export type"));
                                return "skip";
                            }
                            break;
                        case 275 /* ImportSpecifier */ :
                        case 280 /* ExportSpecifier */ :
                            if (node.isTypeOnly) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, isImportSpecifier(node) ? "import...type" : "export...type"));
                                return "skip";
                            }
                            break;
                        case 270 /* ImportEqualsDeclaration */ :
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics.import_can_only_be_used_in_TypeScript_files));
                            return "skip";
                        case 276 /* ExportAssignment */ :
                            if (node.isExportEquals) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics.export_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                            break;
                        case 297 /* HeritageClause */ :
                            const heritageClause = node;
                            if (heritageClause.token === 119 /* ImplementsKeyword */ ) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics.implements_clauses_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                            break;
                        case 263 /* InterfaceDeclaration */ :
                            const interfaceKeyword = tokenToString(120 /* InterfaceKeyword */ );
                            Debug.assertIsDefined(interfaceKeyword);
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, interfaceKeyword));
                            return "skip";
                        case 266 /* ModuleDeclaration */ :
                            const moduleKeyword = node.flags & 16 /* Namespace */  ? tokenToString(145 /* NamespaceKeyword */ ) : tokenToString(144 /* ModuleKeyword */ );
                            Debug.assertIsDefined(moduleKeyword);
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, moduleKeyword));
                            return "skip";
                        case 264 /* TypeAliasDeclaration */ :
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics.Type_aliases_can_only_be_used_in_TypeScript_files));
                            return "skip";
                        case 265 /* EnumDeclaration */ :
                            const enumKeyword = Debug.checkDefined(tokenToString(94 /* EnumKeyword */ ));
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, enumKeyword));
                            return "skip";
                        case 234 /* NonNullExpression */ :
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics.Non_null_assertions_can_only_be_used_in_TypeScript_files));
                            return "skip";
                        case 233 /* AsExpression */ :
                            diagnostics.push(createDiagnosticForNode2(node.type, Diagnostics.Type_assertion_expressions_can_only_be_used_in_TypeScript_files));
                            return "skip";
                        case 237 /* SatisfiesExpression */ :
                            diagnostics.push(createDiagnosticForNode2(node.type, Diagnostics.Type_satisfaction_expressions_can_only_be_used_in_TypeScript_files));
                            return "skip";
                        case 215 /* TypeAssertionExpression */ :
                            Debug.fail();
                    }
                }
                function walkArray(nodes, parent2) {
                    if (canHaveIllegalDecorators(parent2)) {
                        const decorator = find(parent2.modifiers, isDecorator);
                        if (decorator) diagnostics.push(createDiagnosticForNode2(decorator, Diagnostics.Decorators_are_not_valid_here));
                    } else if (canHaveDecorators(parent2) && parent2.modifiers) {
                        const decoratorIndex = findIndex(parent2.modifiers, isDecorator);
                        if (decoratorIndex >= 0) {
                            if (isParameter(parent2) && !options.experimentalDecorators) diagnostics.push(createDiagnosticForNode2(parent2.modifiers[decoratorIndex], Diagnostics.Decorators_are_not_valid_here));
                            else if (isClassDeclaration(parent2)) {
                                const exportIndex = findIndex(parent2.modifiers, isExportModifier);
                                if (exportIndex >= 0) {
                                    const defaultIndex = findIndex(parent2.modifiers, isDefaultModifier);
                                    if (decoratorIndex > exportIndex && defaultIndex >= 0 && decoratorIndex < defaultIndex) diagnostics.push(createDiagnosticForNode2(parent2.modifiers[decoratorIndex], Diagnostics.Decorators_are_not_valid_here));
                                    else if (exportIndex >= 0 && decoratorIndex < exportIndex) {
                                        const trailingDecoratorIndex = findIndex(parent2.modifiers, isDecorator, exportIndex);
                                        if (trailingDecoratorIndex >= 0) diagnostics.push(addRelatedInfo(createDiagnosticForNode2(parent2.modifiers[trailingDecoratorIndex], Diagnostics.Decorators_may_not_appear_after_export_or_export_default_if_they_also_appear_before_export), createDiagnosticForNode2(parent2.modifiers[decoratorIndex], Diagnostics.Decorator_used_before_export_here)));
                                    }
                                }
                            }
                        }
                    }
                    switch(parent2.kind){
                        case 262 /* ClassDeclaration */ :
                        case 230 /* ClassExpression */ :
                        case 173 /* MethodDeclaration */ :
                        case 175 /* Constructor */ :
                        case 176 /* GetAccessor */ :
                        case 177 /* SetAccessor */ :
                        case 217 /* FunctionExpression */ :
                        case 261 /* FunctionDeclaration */ :
                        case 218 /* ArrowFunction */ :
                            if (nodes === parent2.typeParameters) {
                                diagnostics.push(createDiagnosticForNodeArray2(nodes, Diagnostics.Type_parameter_declarations_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                        case 242 /* VariableStatement */ :
                            if (nodes === parent2.modifiers) {
                                checkModifiers(parent2.modifiers, parent2.kind === 242 /* VariableStatement */ );
                                return "skip";
                            }
                            break;
                        case 171 /* PropertyDeclaration */ :
                            if (nodes === parent2.modifiers) {
                                for (const modifier of nodes)if (isModifier(modifier) && modifier.kind !== 126 /* StaticKeyword */  && modifier.kind !== 129 /* AccessorKeyword */ ) diagnostics.push(createDiagnosticForNode2(modifier, Diagnostics.The_0_modifier_can_only_be_used_in_TypeScript_files, tokenToString(modifier.kind)));
                                return "skip";
                            }
                            break;
                        case 168 /* Parameter */ :
                            if (nodes === parent2.modifiers && some(nodes, isModifier)) {
                                diagnostics.push(createDiagnosticForNodeArray2(nodes, Diagnostics.Parameter_modifiers_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                            break;
                        case 212 /* CallExpression */ :
                        case 213 /* NewExpression */ :
                        case 232 /* ExpressionWithTypeArguments */ :
                        case 284 /* JsxSelfClosingElement */ :
                        case 285 /* JsxOpeningElement */ :
                        case 214 /* TaggedTemplateExpression */ :
                            if (nodes === parent2.typeArguments) {
                                diagnostics.push(createDiagnosticForNodeArray2(nodes, Diagnostics.Type_arguments_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                            break;
                    }
                }
                function checkModifiers(modifiers, isConstValid) {
                    for (const modifier of modifiers)switch(modifier.kind){
                        case 87 /* ConstKeyword */ :
                            if (isConstValid) continue;
                        case 125 /* PublicKeyword */ :
                        case 123 /* PrivateKeyword */ :
                        case 124 /* ProtectedKeyword */ :
                        case 148 /* ReadonlyKeyword */ :
                        case 138 /* DeclareKeyword */ :
                        case 128 /* AbstractKeyword */ :
                        case 163 /* OverrideKeyword */ :
                        case 103 /* InKeyword */ :
                        case 147 /* OutKeyword */ :
                            diagnostics.push(createDiagnosticForNode2(modifier, Diagnostics.The_0_modifier_can_only_be_used_in_TypeScript_files, tokenToString(modifier.kind)));
                            break;
                        case 126 /* StaticKeyword */ :
                        case 95 /* ExportKeyword */ :
                        case 90 /* DefaultKeyword */ :
                        case 129 /* AccessorKeyword */ :
                    }
                }
                function createDiagnosticForNodeArray2(nodes, message, ...args) {
                    const start = nodes.pos;
                    return createFileDiagnostic(sourceFile, start, nodes.end - start, message, ...args);
                }
                function createDiagnosticForNode2(node, message, ...args) {
                    return createDiagnosticForNodeInSourceFile(sourceFile, node, message, ...args);
                }
            });
        }
        function getDeclarationDiagnosticsWorker(sourceFile, cancellationToken) {
            return getAndCacheDiagnostics(sourceFile, cancellationToken, cachedDeclarationDiagnosticsForFile, getDeclarationDiagnosticsForFileNoCache);
        }
        function getDeclarationDiagnosticsForFileNoCache(sourceFile, cancellationToken) {
            return runWithCancellationToken(()=>{
                const resolver = getTypeChecker().getEmitResolver(sourceFile, cancellationToken);
                return getDeclarationDiagnostics(getEmitHost(noop), resolver, sourceFile) || emptyArray;
            });
        }
        function getAndCacheDiagnostics(sourceFile, cancellationToken, cache, getDiagnostics2) {
            var _a2;
            const cachedResult = sourceFile ? (_a2 = cache.perFile) == null ? void 0 : _a2.get(sourceFile.path) : cache.allDiagnostics;
            if (cachedResult) return cachedResult;
            const result = getDiagnostics2(sourceFile, cancellationToken);
            if (sourceFile) (cache.perFile || (cache.perFile = /* @__PURE__ */ new Map())).set(sourceFile.path, result);
            else cache.allDiagnostics = result;
            return result;
        }
        function getDeclarationDiagnosticsForFile(sourceFile, cancellationToken) {
            return sourceFile.isDeclarationFile ? [] : getDeclarationDiagnosticsWorker(sourceFile, cancellationToken);
        }
        function getOptionsDiagnostics() {
            return sortAndDeduplicateDiagnostics(concatenate(programDiagnostics.getGlobalDiagnostics(), getOptionsDiagnosticsOfConfigFile()));
        }
        function getOptionsDiagnosticsOfConfigFile() {
            if (!options.configFile) return emptyArray;
            let diagnostics = programDiagnostics.getDiagnostics(options.configFile.fileName);
            forEachResolvedProjectReference2((resolvedRef)=>{
                diagnostics = concatenate(diagnostics, programDiagnostics.getDiagnostics(resolvedRef.sourceFile.fileName));
            });
            return diagnostics;
        }
        function getGlobalDiagnostics() {
            return rootNames.length ? sortAndDeduplicateDiagnostics(getTypeChecker().getGlobalDiagnostics().slice()) : emptyArray;
        }
        function getConfigFileParsingDiagnostics2() {
            return configFileParsingDiagnostics || emptyArray;
        }
        function processRootFile(fileName, isDefaultLib, ignoreNoDefaultLib, reason) {
            processSourceFile(normalizePath(fileName), isDefaultLib, ignoreNoDefaultLib, /*packageId*/ void 0, reason);
        }
        function fileReferenceIsEqualTo(a, b) {
            return a.fileName === b.fileName;
        }
        function moduleNameIsEqualTo(a, b) {
            return a.kind === 80 /* Identifier */  ? b.kind === 80 /* Identifier */  && a.escapedText === b.escapedText : b.kind === 11 /* StringLiteral */  && a.text === b.text;
        }
        function createSyntheticImport(text, file) {
            const externalHelpersModuleReference = factory.createStringLiteral(text);
            const importDecl = factory.createImportDeclaration(/*modifiers*/ void 0, /*importClause*/ void 0, externalHelpersModuleReference, /*assertClause*/ void 0);
            addInternalEmitFlags(importDecl, 2 /* NeverApplyImportHelper */ );
            setParent(externalHelpersModuleReference, importDecl);
            setParent(importDecl, file);
            externalHelpersModuleReference.flags &= -9 /* Synthesized */ ;
            importDecl.flags &= -9 /* Synthesized */ ;
            return externalHelpersModuleReference;
        }
        function collectExternalModuleReferences(file) {
            if (file.imports) return;
            const isJavaScriptFile = isSourceFileJS(file);
            const isExternalModuleFile = isExternalModule(file);
            let imports;
            let moduleAugmentations;
            let ambientModules;
            if ((getIsolatedModules(options) || isExternalModuleFile) && !file.isDeclarationFile) {
                if (options.importHelpers) imports = [
                    createSyntheticImport(externalHelpersModuleNameText, file)
                ];
                const jsxImport = getJSXRuntimeImport(getJSXImplicitImportBase(options, file), options);
                if (jsxImport) (imports || (imports = [])).push(createSyntheticImport(jsxImport, file));
            }
            for (const node of file.statements)collectModuleReferences(node, /*inAmbientModule*/ false);
            const shouldProcessRequires = isJavaScriptFile && shouldResolveJsRequire(options);
            if (file.flags & 2097152 /* PossiblyContainsDynamicImport */  || shouldProcessRequires) collectDynamicImportOrRequireCalls(file);
            file.imports = imports || emptyArray;
            file.moduleAugmentations = moduleAugmentations || emptyArray;
            file.ambientModuleNames = ambientModules || emptyArray;
            return;
            function collectModuleReferences(node, inAmbientModule) {
                if (isAnyImportOrReExport(node)) {
                    const moduleNameExpr = getExternalModuleName(node);
                    if (moduleNameExpr && isStringLiteral(moduleNameExpr) && moduleNameExpr.text && (!inAmbientModule || !isExternalModuleNameRelative(moduleNameExpr.text))) {
                        setParentRecursive(node, /*incremental*/ false);
                        imports = append(imports, moduleNameExpr);
                        if (!usesUriStyleNodeCoreModules && currentNodeModulesDepth === 0 && !file.isDeclarationFile) usesUriStyleNodeCoreModules = startsWith(moduleNameExpr.text, "node:");
                    }
                } else if (isModuleDeclaration(node)) {
                    if (isAmbientModule(node) && (inAmbientModule || hasSyntacticModifier(node, 2 /* Ambient */ ) || file.isDeclarationFile)) {
                        node.name.parent = node;
                        const nameText = getTextOfIdentifierOrLiteral(node.name);
                        if (isExternalModuleFile || inAmbientModule && !isExternalModuleNameRelative(nameText)) (moduleAugmentations || (moduleAugmentations = [])).push(node.name);
                        else if (!inAmbientModule) {
                            if (file.isDeclarationFile) (ambientModules || (ambientModules = [])).push(nameText);
                            const body = node.body;
                            if (body) for (const statement of body.statements)collectModuleReferences(statement, /*inAmbientModule*/ true);
                        }
                    }
                }
            }
            function collectDynamicImportOrRequireCalls(file2) {
                const r = /import|require/g;
                while(r.exec(file2.text) !== null){
                    const node = getNodeAtPosition(file2, r.lastIndex);
                    if (shouldProcessRequires && isRequireCall(node, /*requireStringLiteralLikeArgument*/ true)) {
                        setParentRecursive(node, /*incremental*/ false);
                        imports = append(imports, node.arguments[0]);
                    } else if (isImportCall(node) && node.arguments.length >= 1 && isStringLiteralLike(node.arguments[0])) {
                        setParentRecursive(node, /*incremental*/ false);
                        imports = append(imports, node.arguments[0]);
                    } else if (isLiteralImportTypeNode(node)) {
                        setParentRecursive(node, /*incremental*/ false);
                        imports = append(imports, node.argument.literal);
                    }
                }
            }
            function getNodeAtPosition(sourceFile, position) {
                let current = sourceFile;
                const getContainingChild = (child)=>{
                    if (child.pos <= position && (position < child.end || position === child.end && child.kind === 1 /* EndOfFileToken */ )) return child;
                };
                while(true){
                    const child = isJavaScriptFile && hasJSDocNodes(current) && forEach(current.jsDoc, getContainingChild) || forEachChild(current, getContainingChild);
                    if (!child) return current;
                    current = child;
                }
            }
        }
        function getLibFileFromReference(ref) {
            var _a2;
            const { libFileName: libFileName  } = getLibFileNameFromLibReference(ref);
            const actualFileName = libFileName && ((_a2 = resolvedLibReferences == null ? void 0 : resolvedLibReferences.get(libFileName)) == null ? void 0 : _a2.actual);
            return actualFileName !== void 0 ? getSourceFile(actualFileName) : void 0;
        }
        function getSourceFileFromReference(referencingFile, ref) {
            return getSourceFileFromReferenceWorker(resolveTripleslashReference(ref.fileName, referencingFile.fileName), getSourceFile);
        }
        function getSourceFileFromReferenceWorker(fileName, getSourceFile2, fail, reason) {
            if (hasExtension(fileName)) {
                const canonicalFileName = host.getCanonicalFileName(fileName);
                if (!options.allowNonTsExtensions && !forEach(flatten(supportedExtensionsWithJsonIfResolveJsonModule), (extension)=>fileExtensionIs(canonicalFileName, extension))) {
                    if (fail) {
                        if (hasJSFileExtension(canonicalFileName)) fail(Diagnostics.File_0_is_a_JavaScript_file_Did_you_mean_to_enable_the_allowJs_option, fileName);
                        else fail(Diagnostics.File_0_has_an_unsupported_extension_The_only_supported_extensions_are_1, fileName, "'" + flatten(supportedExtensions).join("', '") + "'");
                    }
                    return void 0;
                }
                const sourceFile = getSourceFile2(fileName);
                if (fail) {
                    if (!sourceFile) {
                        const redirect = getProjectReferenceRedirect(fileName);
                        if (redirect) fail(Diagnostics.Output_file_0_has_not_been_built_from_source_file_1, redirect, fileName);
                        else fail(Diagnostics.File_0_not_found, fileName);
                    } else if (isReferencedFile(reason) && canonicalFileName === host.getCanonicalFileName(getSourceFileByPath(reason.file).fileName)) fail(Diagnostics.A_file_cannot_have_a_reference_to_itself);
                }
                return sourceFile;
            } else {
                const sourceFileNoExtension = options.allowNonTsExtensions && getSourceFile2(fileName);
                if (sourceFileNoExtension) return sourceFileNoExtension;
                if (fail && options.allowNonTsExtensions) {
                    fail(Diagnostics.File_0_not_found, fileName);
                    return void 0;
                }
                const sourceFileWithAddedExtension = forEach(supportedExtensions[0], (extension)=>getSourceFile2(fileName + extension));
                if (fail && !sourceFileWithAddedExtension) fail(Diagnostics.Could_not_resolve_the_path_0_with_the_extensions_Colon_1, fileName, "'" + flatten(supportedExtensions).join("', '") + "'");
                return sourceFileWithAddedExtension;
            }
        }
        function processSourceFile(fileName, isDefaultLib, ignoreNoDefaultLib, packageId, reason) {
            getSourceFileFromReferenceWorker(fileName, (fileName2)=>findSourceFile(fileName2, isDefaultLib, ignoreNoDefaultLib, reason, packageId), // TODO: GH#18217
            (diagnostic, ...args)=>addFilePreprocessingFileExplainingDiagnostic(/*file*/ void 0, reason, diagnostic, args), reason);
        }
        function processProjectReferenceFile(fileName, reason) {
            return processSourceFile(fileName, /*isDefaultLib*/ false, /*ignoreNoDefaultLib*/ false, /*packageId*/ void 0, reason);
        }
        function reportFileNamesDifferOnlyInCasingError(fileName, existingFile, reason) {
            const hasExistingReasonToReportErrorOn = !isReferencedFile(reason) && some(fileReasons.get(existingFile.path), isReferencedFile);
            if (hasExistingReasonToReportErrorOn) addFilePreprocessingFileExplainingDiagnostic(existingFile, reason, Diagnostics.Already_included_file_name_0_differs_from_file_name_1_only_in_casing, [
                existingFile.fileName,
                fileName
            ]);
            else addFilePreprocessingFileExplainingDiagnostic(existingFile, reason, Diagnostics.File_name_0_differs_from_already_included_file_name_1_only_in_casing, [
                fileName,
                existingFile.fileName
            ]);
        }
        function createRedirectedSourceFile(redirectTarget, unredirected, fileName, path, resolvedPath, originalFileName, sourceFileOptions) {
            var _a2;
            const redirect = parseNodeFactory.createRedirectedSourceFile({
                redirectTarget: redirectTarget,
                unredirected: unredirected
            });
            redirect.fileName = fileName;
            redirect.path = path;
            redirect.resolvedPath = resolvedPath;
            redirect.originalFileName = originalFileName;
            redirect.packageJsonLocations = ((_a2 = sourceFileOptions.packageJsonLocations) == null ? void 0 : _a2.length) ? sourceFileOptions.packageJsonLocations : void 0;
            redirect.packageJsonScope = sourceFileOptions.packageJsonScope;
            sourceFilesFoundSearchingNodeModules.set(path, currentNodeModulesDepth > 0);
            return redirect;
        }
        function findSourceFile(fileName, isDefaultLib, ignoreNoDefaultLib, reason, packageId) {
            var _a2, _b2;
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Program, "findSourceFile", {
                fileName: fileName,
                isDefaultLib: isDefaultLib || void 0,
                fileIncludeKind: FileIncludeKind[reason.kind]
            });
            const result = findSourceFileWorker(fileName, isDefaultLib, ignoreNoDefaultLib, reason, packageId);
            (_b2 = tracing) == null || _b2.pop();
            return result;
        }
        function getCreateSourceFileOptions(fileName, moduleResolutionCache2, host2, options2) {
            const result = getImpliedNodeFormatForFileWorker(getNormalizedAbsolutePath(fileName, currentDirectory), moduleResolutionCache2 == null ? void 0 : moduleResolutionCache2.getPackageJsonInfoCache(), host2, options2);
            const languageVersion = getEmitScriptTarget(options2);
            const setExternalModuleIndicator2 = getSetExternalModuleIndicator(options2);
            return typeof result === "object" ? {
                ...result,
                languageVersion: languageVersion,
                setExternalModuleIndicator: setExternalModuleIndicator2
            } : {
                languageVersion: languageVersion,
                impliedNodeFormat: result,
                setExternalModuleIndicator: setExternalModuleIndicator2
            };
        }
        function findSourceFileWorker(fileName, isDefaultLib, ignoreNoDefaultLib, reason, packageId) {
            var _a2, _b2;
            const path = toPath3(fileName);
            if (useSourceOfProjectReferenceRedirect) {
                let source = getSourceOfProjectReferenceRedirect(path);
                if (!source && host.realpath && options.preserveSymlinks && isDeclarationFileName(fileName) && stringContains(fileName, nodeModulesPathPart)) {
                    const realPath2 = toPath3(host.realpath(fileName));
                    if (realPath2 !== path) source = getSourceOfProjectReferenceRedirect(realPath2);
                }
                if (source) {
                    const file2 = isString(source) ? findSourceFile(source, isDefaultLib, ignoreNoDefaultLib, reason, packageId) : void 0;
                    if (file2) addFileToFilesByName(file2, path, /*redirectedPath*/ void 0);
                    return file2;
                }
            }
            const originalFileName = fileName;
            if (filesByName.has(path)) {
                const file2 = filesByName.get(path);
                addFileIncludeReason(file2 || void 0, reason);
                if (file2 && !(options.forceConsistentCasingInFileNames === false)) {
                    const checkedName = file2.fileName;
                    const isRedirect = toPath3(checkedName) !== toPath3(fileName);
                    if (isRedirect) fileName = getProjectReferenceRedirect(fileName) || fileName;
                    const checkedAbsolutePath = getNormalizedAbsolutePathWithoutRoot(checkedName, currentDirectory);
                    const inputAbsolutePath = getNormalizedAbsolutePathWithoutRoot(fileName, currentDirectory);
                    if (checkedAbsolutePath !== inputAbsolutePath) reportFileNamesDifferOnlyInCasingError(fileName, file2, reason);
                }
                if (file2 && sourceFilesFoundSearchingNodeModules.get(file2.path) && currentNodeModulesDepth === 0) {
                    sourceFilesFoundSearchingNodeModules.set(file2.path, false);
                    if (!options.noResolve) {
                        processReferencedFiles(file2, isDefaultLib);
                        processTypeReferenceDirectives(file2);
                    }
                    if (!options.noLib) processLibReferenceDirectives(file2);
                    modulesWithElidedImports.set(file2.path, false);
                    processImportedModules(file2);
                } else if (file2 && modulesWithElidedImports.get(file2.path)) {
                    if (currentNodeModulesDepth < maxNodeModuleJsDepth) {
                        modulesWithElidedImports.set(file2.path, false);
                        processImportedModules(file2);
                    }
                }
                return file2 || void 0;
            }
            let redirectedPath;
            if (isReferencedFile(reason) && !useSourceOfProjectReferenceRedirect) {
                const redirectProject = getProjectReferenceRedirectProject(fileName);
                if (redirectProject) {
                    if (outFile(redirectProject.commandLine.options)) return void 0;
                    const redirect = getProjectReferenceOutputName(redirectProject, fileName);
                    fileName = redirect;
                    redirectedPath = toPath3(redirect);
                }
            }
            const sourceFileOptions = getCreateSourceFileOptions(fileName, moduleResolutionCache, host, options);
            const file = host.getSourceFile(fileName, sourceFileOptions, (hostErrorMessage)=>addFilePreprocessingFileExplainingDiagnostic(/*file*/ void 0, reason, Diagnostics.Cannot_read_file_0_Colon_1, [
                    fileName,
                    hostErrorMessage
                ]), shouldCreateNewSourceFile || ((_a2 = oldProgram == null ? void 0 : oldProgram.getSourceFileByPath(toPath3(fileName))) == null ? void 0 : _a2.impliedNodeFormat) !== sourceFileOptions.impliedNodeFormat);
            if (packageId) {
                const packageIdKey = packageIdToString(packageId);
                const fileFromPackageId = packageIdToSourceFile.get(packageIdKey);
                if (fileFromPackageId) {
                    const dupFile = createRedirectedSourceFile(fileFromPackageId, file, fileName, path, toPath3(fileName), originalFileName, sourceFileOptions);
                    redirectTargetsMap.add(fileFromPackageId.path, fileName);
                    addFileToFilesByName(dupFile, path, redirectedPath);
                    addFileIncludeReason(dupFile, reason);
                    sourceFileToPackageName.set(path, packageIdToPackageName(packageId));
                    processingOtherFiles.push(dupFile);
                    return dupFile;
                } else if (file) {
                    packageIdToSourceFile.set(packageIdKey, file);
                    sourceFileToPackageName.set(path, packageIdToPackageName(packageId));
                }
            }
            addFileToFilesByName(file, path, redirectedPath);
            if (file) {
                sourceFilesFoundSearchingNodeModules.set(path, currentNodeModulesDepth > 0);
                file.fileName = fileName;
                file.path = path;
                file.resolvedPath = toPath3(fileName);
                file.originalFileName = originalFileName;
                file.packageJsonLocations = ((_b2 = sourceFileOptions.packageJsonLocations) == null ? void 0 : _b2.length) ? sourceFileOptions.packageJsonLocations : void 0;
                file.packageJsonScope = sourceFileOptions.packageJsonScope;
                addFileIncludeReason(file, reason);
                if (host.useCaseSensitiveFileNames()) {
                    const pathLowerCase = toFileNameLowerCase(path);
                    const existingFile = filesByNameIgnoreCase.get(pathLowerCase);
                    if (existingFile) reportFileNamesDifferOnlyInCasingError(fileName, existingFile, reason);
                    else filesByNameIgnoreCase.set(pathLowerCase, file);
                }
                skipDefaultLib = skipDefaultLib || file.hasNoDefaultLib && !ignoreNoDefaultLib;
                if (!options.noResolve) {
                    processReferencedFiles(file, isDefaultLib);
                    processTypeReferenceDirectives(file);
                }
                if (!options.noLib) processLibReferenceDirectives(file);
                processImportedModules(file);
                if (isDefaultLib) processingDefaultLibFiles.push(file);
                else processingOtherFiles.push(file);
            }
            return file;
        }
        function addFileIncludeReason(file, reason) {
            if (file) fileReasons.add(file.path, reason);
        }
        function addFileToFilesByName(file, path, redirectedPath) {
            if (redirectedPath) {
                filesByName.set(redirectedPath, file);
                filesByName.set(path, file || false);
            } else filesByName.set(path, file);
        }
        function getProjectReferenceRedirect(fileName) {
            const referencedProject = getProjectReferenceRedirectProject(fileName);
            return referencedProject && getProjectReferenceOutputName(referencedProject, fileName);
        }
        function getProjectReferenceRedirectProject(fileName) {
            if (!resolvedProjectReferences || !resolvedProjectReferences.length || isDeclarationFileName(fileName) || fileExtensionIs(fileName, ".json" /* Json */ )) return void 0;
            return getResolvedProjectReferenceToRedirect(fileName);
        }
        function getProjectReferenceOutputName(referencedProject, fileName) {
            const out = outFile(referencedProject.commandLine.options);
            return out ? changeExtension(out, ".d.ts" /* Dts */ ) : getOutputDeclarationFileName(fileName, referencedProject.commandLine, !host.useCaseSensitiveFileNames());
        }
        function getResolvedProjectReferenceToRedirect(fileName) {
            if (mapFromFileToProjectReferenceRedirects === void 0) {
                mapFromFileToProjectReferenceRedirects = /* @__PURE__ */ new Map();
                forEachResolvedProjectReference2((referencedProject)=>{
                    if (toPath3(options.configFilePath) !== referencedProject.sourceFile.path) referencedProject.commandLine.fileNames.forEach((f)=>mapFromFileToProjectReferenceRedirects.set(toPath3(f), referencedProject.sourceFile.path));
                });
            }
            const referencedProjectPath = mapFromFileToProjectReferenceRedirects.get(toPath3(fileName));
            return referencedProjectPath && getResolvedProjectReferenceByPath(referencedProjectPath);
        }
        function forEachResolvedProjectReference2(cb) {
            return forEachResolvedProjectReference(resolvedProjectReferences, cb);
        }
        function getSourceOfProjectReferenceRedirect(path) {
            if (!isDeclarationFileName(path)) return void 0;
            if (mapFromToProjectReferenceRedirectSource === void 0) {
                mapFromToProjectReferenceRedirectSource = /* @__PURE__ */ new Map();
                forEachResolvedProjectReference2((resolvedRef)=>{
                    const out = outFile(resolvedRef.commandLine.options);
                    if (out) {
                        const outputDts = changeExtension(out, ".d.ts" /* Dts */ );
                        mapFromToProjectReferenceRedirectSource.set(toPath3(outputDts), true);
                    } else {
                        const getCommonSourceDirectory3 = memoize(()=>getCommonSourceDirectoryOfConfig(resolvedRef.commandLine, !host.useCaseSensitiveFileNames()));
                        forEach(resolvedRef.commandLine.fileNames, (fileName)=>{
                            if (!isDeclarationFileName(fileName) && !fileExtensionIs(fileName, ".json" /* Json */ )) {
                                const outputDts = getOutputDeclarationFileName(fileName, resolvedRef.commandLine, !host.useCaseSensitiveFileNames(), getCommonSourceDirectory3);
                                mapFromToProjectReferenceRedirectSource.set(toPath3(outputDts), fileName);
                            }
                        });
                    }
                });
            }
            return mapFromToProjectReferenceRedirectSource.get(path);
        }
        function isSourceOfProjectReferenceRedirect(fileName) {
            return useSourceOfProjectReferenceRedirect && !!getResolvedProjectReferenceToRedirect(fileName);
        }
        function getResolvedProjectReferenceByPath(projectReferencePath) {
            if (!projectReferenceRedirects) return void 0;
            return projectReferenceRedirects.get(projectReferencePath) || void 0;
        }
        function processReferencedFiles(file, isDefaultLib) {
            forEach(file.referencedFiles, (ref, index)=>{
                processSourceFile(resolveTripleslashReference(ref.fileName, file.fileName), isDefaultLib, /*ignoreNoDefaultLib*/ false, /*packageId*/ void 0, {
                    kind: 4 /* ReferenceFile */ ,
                    file: file.path,
                    index: index
                });
            });
        }
        function processTypeReferenceDirectives(file) {
            const typeDirectives = file.typeReferenceDirectives;
            if (!typeDirectives.length) {
                file.resolvedTypeReferenceDirectiveNames = void 0;
                return;
            }
            const resolutions = resolveTypeReferenceDirectiveNamesReusingOldState(typeDirectives, file);
            for(let index = 0; index < typeDirectives.length; index++){
                const ref = file.typeReferenceDirectives[index];
                const resolvedTypeReferenceDirective = resolutions[index];
                const fileName = toFileNameLowerCase(ref.fileName);
                setResolvedTypeReferenceDirective(file, fileName, resolvedTypeReferenceDirective, getModeForFileReference(ref, file.impliedNodeFormat));
                const mode = ref.resolutionMode || file.impliedNodeFormat;
                if (mode && getEmitModuleResolutionKind(options) !== 3 /* Node16 */  && getEmitModuleResolutionKind(options) !== 99 /* NodeNext */ ) (fileProcessingDiagnostics ?? (fileProcessingDiagnostics = [])).push({
                    kind: 2 /* ResolutionDiagnostics */ ,
                    diagnostics: [
                        createDiagnosticForRange(file, ref, Diagnostics.resolution_mode_assertions_are_only_supported_when_moduleResolution_is_node16_or_nodenext)
                    ]
                });
                processTypeReferenceDirective(fileName, mode, resolvedTypeReferenceDirective, {
                    kind: 5 /* TypeReferenceDirective */ ,
                    file: file.path,
                    index: index
                });
            }
        }
        function processTypeReferenceDirective(typeReferenceDirective, mode, resolution, reason) {
            var _a2, _b2;
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Program, "processTypeReferenceDirective", {
                directive: typeReferenceDirective,
                hasResolved: !!resolution.resolvedTypeReferenceDirective,
                refKind: reason.kind,
                refPath: isReferencedFile(reason) ? reason.file : void 0
            });
            processTypeReferenceDirectiveWorker(typeReferenceDirective, mode, resolution, reason);
            (_b2 = tracing) == null || _b2.pop();
        }
        function processTypeReferenceDirectiveWorker(typeReferenceDirective, mode, resolution, reason) {
            var _a2;
            addResolutionDiagnostics(resolution);
            const previousResolution = (_a2 = resolvedTypeReferenceDirectives.get(typeReferenceDirective, mode)) == null ? void 0 : _a2.resolvedTypeReferenceDirective;
            if (previousResolution && previousResolution.primary) return;
            let saveResolution = true;
            const { resolvedTypeReferenceDirective: resolvedTypeReferenceDirective  } = resolution;
            if (resolvedTypeReferenceDirective) {
                if (resolvedTypeReferenceDirective.isExternalLibraryImport) currentNodeModulesDepth++;
                if (resolvedTypeReferenceDirective.primary) processSourceFile(resolvedTypeReferenceDirective.resolvedFileName, /*isDefaultLib*/ false, /*ignoreNoDefaultLib*/ false, resolvedTypeReferenceDirective.packageId, reason);
                else if (previousResolution) {
                    if (resolvedTypeReferenceDirective.resolvedFileName !== previousResolution.resolvedFileName) {
                        const otherFileText = host.readFile(resolvedTypeReferenceDirective.resolvedFileName);
                        const existingFile = getSourceFile(previousResolution.resolvedFileName);
                        if (otherFileText !== existingFile.text) addFilePreprocessingFileExplainingDiagnostic(existingFile, reason, Diagnostics.Conflicting_definitions_for_0_found_at_1_and_2_Consider_installing_a_specific_version_of_this_library_to_resolve_the_conflict, [
                            typeReferenceDirective,
                            resolvedTypeReferenceDirective.resolvedFileName,
                            previousResolution.resolvedFileName
                        ]);
                    }
                    saveResolution = false;
                } else processSourceFile(resolvedTypeReferenceDirective.resolvedFileName, /*isDefaultLib*/ false, /*ignoreNoDefaultLib*/ false, resolvedTypeReferenceDirective.packageId, reason);
                if (resolvedTypeReferenceDirective.isExternalLibraryImport) currentNodeModulesDepth--;
            } else addFilePreprocessingFileExplainingDiagnostic(/*file*/ void 0, reason, Diagnostics.Cannot_find_type_definition_file_for_0, [
                typeReferenceDirective
            ]);
            if (saveResolution) resolvedTypeReferenceDirectives.set(typeReferenceDirective, mode, resolution);
        }
        function pathForLibFile(libFileName) {
            const existing = resolvedLibReferences == null ? void 0 : resolvedLibReferences.get(libFileName);
            if (existing) return existing.actual;
            const result = pathForLibFileWorker(libFileName);
            (resolvedLibReferences ?? (resolvedLibReferences = /* @__PURE__ */ new Map())).set(libFileName, result);
            return result.actual;
        }
        function pathForLibFileWorker(libFileName) {
            var _a2, _b2, _c2, _d2, _e2;
            const existing = resolvedLibProcessing == null ? void 0 : resolvedLibProcessing.get(libFileName);
            if (existing) return existing;
            if (structureIsReused !== 0 /* Not */  && oldProgram && !hasInvalidatedLibResolutions(libFileName)) {
                const oldResolution = (_a2 = oldProgram.resolvedLibReferences) == null ? void 0 : _a2.get(libFileName);
                if (oldResolution) {
                    if (oldResolution.resolution && isTraceEnabled(options, host)) {
                        const libraryName2 = getLibraryNameFromLibFileName(libFileName);
                        const resolveFrom2 = getInferredLibraryNameResolveFrom(options, currentDirectory, libFileName);
                        trace(host, oldResolution.resolution.resolvedModule ? oldResolution.resolution.resolvedModule.packageId ? Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_not_resolved, libraryName2, getNormalizedAbsolutePath(resolveFrom2, currentDirectory), (_b2 = oldResolution.resolution.resolvedModule) == null ? void 0 : _b2.resolvedFileName, ((_c2 = oldResolution.resolution.resolvedModule) == null ? void 0 : _c2.packageId) && packageIdToString(oldResolution.resolution.resolvedModule.packageId));
                    }
                    (resolvedLibProcessing ?? (resolvedLibProcessing = /* @__PURE__ */ new Map())).set(libFileName, oldResolution);
                    return oldResolution;
                }
            }
            const libraryName = getLibraryNameFromLibFileName(libFileName);
            const resolveFrom = getInferredLibraryNameResolveFrom(options, currentDirectory, libFileName);
            (_d2 = tracing) == null || _d2.push(tracing.Phase.Program, "resolveLibrary", {
                resolveFrom: resolveFrom
            });
            mark("beforeResolveLibrary");
            const resolution = actualResolveLibrary(libraryName, resolveFrom, options, libFileName);
            mark("afterResolveLibrary");
            measure("ResolveLibrary", "beforeResolveLibrary", "afterResolveLibrary");
            (_e2 = tracing) == null || _e2.pop();
            const result = {
                resolution: resolution,
                actual: resolution.resolvedModule ? resolution.resolvedModule.resolvedFileName : combinePaths(defaultLibraryPath, libFileName)
            };
            (resolvedLibProcessing ?? (resolvedLibProcessing = /* @__PURE__ */ new Map())).set(libFileName, result);
            return result;
        }
        function processLibReferenceDirectives(file) {
            forEach(file.libReferenceDirectives, (libReference, index)=>{
                const { libName: libName , libFileName: libFileName  } = getLibFileNameFromLibReference(libReference);
                if (libFileName) processRootFile(pathForLibFile(libFileName), /*isDefaultLib*/ true, /*ignoreNoDefaultLib*/ true, {
                    kind: 7 /* LibReferenceDirective */ ,
                    file: file.path,
                    index: index
                });
                else {
                    const unqualifiedLibName = removeSuffix(removePrefix(libName, "lib."), ".d.ts");
                    const suggestion = getSpellingSuggestion(unqualifiedLibName, libs, identity);
                    const diagnostic = suggestion ? Diagnostics.Cannot_find_lib_definition_for_0_Did_you_mean_1 : Diagnostics.Cannot_find_lib_definition_for_0;
                    const args = suggestion ? [
                        libName,
                        suggestion
                    ] : [
                        libName
                    ];
                    (fileProcessingDiagnostics || (fileProcessingDiagnostics = [])).push({
                        kind: 0 /* FilePreprocessingReferencedDiagnostic */ ,
                        reason: {
                            kind: 7 /* LibReferenceDirective */ ,
                            file: file.path,
                            index: index
                        },
                        diagnostic: diagnostic,
                        args: args
                    });
                }
            });
        }
        function getCanonicalFileName(fileName) {
            return host.getCanonicalFileName(fileName);
        }
        function processImportedModules(file) {
            var _a2;
            collectExternalModuleReferences(file);
            if (file.imports.length || file.moduleAugmentations.length) {
                const moduleNames = getModuleNames(file);
                const resolutions = resolveModuleNamesReusingOldState(moduleNames, file);
                Debug.assert(resolutions.length === moduleNames.length);
                const optionsForFile = (useSourceOfProjectReferenceRedirect ? (_a2 = getRedirectReferenceForResolution(file)) == null ? void 0 : _a2.commandLine.options : void 0) || options;
                for(let index = 0; index < moduleNames.length; index++){
                    const resolution = resolutions[index].resolvedModule;
                    const moduleName = moduleNames[index].text;
                    const mode = getModeForUsageLocation(file, moduleNames[index]);
                    setResolvedModule(file, moduleName, resolutions[index], mode);
                    addResolutionDiagnosticsFromResolutionOrCache(file, moduleName, resolutions[index], mode);
                    if (!resolution) continue;
                    const isFromNodeModulesSearch = resolution.isExternalLibraryImport;
                    const isJsFile = !resolutionExtensionIsTSOrJson(resolution.extension);
                    const isJsFileFromNodeModules = isFromNodeModulesSearch && isJsFile;
                    const resolvedFileName = resolution.resolvedFileName;
                    if (isFromNodeModulesSearch) currentNodeModulesDepth++;
                    const elideImport = isJsFileFromNodeModules && currentNodeModulesDepth > maxNodeModuleJsDepth;
                    const shouldAddFile = resolvedFileName && !getResolutionDiagnostic(optionsForFile, resolution, file) && !optionsForFile.noResolve && index < file.imports.length && !elideImport && !(isJsFile && !getAllowJSCompilerOption(optionsForFile)) && (isInJSFile(file.imports[index]) || !(file.imports[index].flags & 8388608 /* JSDoc */ ));
                    if (elideImport) modulesWithElidedImports.set(file.path, true);
                    else if (shouldAddFile) findSourceFile(resolvedFileName, /*isDefaultLib*/ false, /*ignoreNoDefaultLib*/ false, {
                        kind: 3 /* Import */ ,
                        file: file.path,
                        index: index
                    }, resolution.packageId);
                    if (isFromNodeModulesSearch) currentNodeModulesDepth--;
                }
            } else file.resolvedModules = void 0;
        }
        function checkSourceFilesBelongToPath(sourceFiles, rootDirectory) {
            let allFilesBelongToPath = true;
            const absoluteRootDirectoryPath = host.getCanonicalFileName(getNormalizedAbsolutePath(rootDirectory, currentDirectory));
            for (const sourceFile of sourceFiles)if (!sourceFile.isDeclarationFile) {
                const absoluteSourceFilePath = host.getCanonicalFileName(getNormalizedAbsolutePath(sourceFile.fileName, currentDirectory));
                if (absoluteSourceFilePath.indexOf(absoluteRootDirectoryPath) !== 0) {
                    addProgramDiagnosticExplainingFile(sourceFile, Diagnostics.File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files, [
                        sourceFile.fileName,
                        rootDirectory
                    ]);
                    allFilesBelongToPath = false;
                }
            }
            return allFilesBelongToPath;
        }
        function parseProjectReferenceConfigFile(ref) {
            if (!projectReferenceRedirects) projectReferenceRedirects = /* @__PURE__ */ new Map();
            const refPath = resolveProjectReferencePath(ref);
            const sourceFilePath = toPath3(refPath);
            const fromCache = projectReferenceRedirects.get(sourceFilePath);
            if (fromCache !== void 0) return fromCache || void 0;
            let commandLine;
            let sourceFile;
            if (host.getParsedCommandLine) {
                commandLine = host.getParsedCommandLine(refPath);
                if (!commandLine) {
                    addFileToFilesByName(/*file*/ void 0, sourceFilePath, /*redirectedPath*/ void 0);
                    projectReferenceRedirects.set(sourceFilePath, false);
                    return void 0;
                }
                sourceFile = Debug.checkDefined(commandLine.options.configFile);
                Debug.assert(!sourceFile.path || sourceFile.path === sourceFilePath);
                addFileToFilesByName(sourceFile, sourceFilePath, /*redirectedPath*/ void 0);
            } else {
                const basePath = getNormalizedAbsolutePath(getDirectoryPath(refPath), currentDirectory);
                sourceFile = host.getSourceFile(refPath, 100 /* JSON */ );
                addFileToFilesByName(sourceFile, sourceFilePath, /*redirectedPath*/ void 0);
                if (sourceFile === void 0) {
                    projectReferenceRedirects.set(sourceFilePath, false);
                    return void 0;
                }
                commandLine = parseJsonSourceFileConfigFileContent(sourceFile, configParsingHost, basePath, /*existingOptions*/ void 0, refPath);
            }
            sourceFile.fileName = refPath;
            sourceFile.path = sourceFilePath;
            sourceFile.resolvedPath = sourceFilePath;
            sourceFile.originalFileName = refPath;
            const resolvedRef = {
                commandLine: commandLine,
                sourceFile: sourceFile
            };
            projectReferenceRedirects.set(sourceFilePath, resolvedRef);
            if (commandLine.projectReferences) resolvedRef.references = commandLine.projectReferences.map(parseProjectReferenceConfigFile);
            return resolvedRef;
        }
        function verifyCompilerOptions() {
            if (options.strictPropertyInitialization && !getStrictOptionValue(options, "strictNullChecks")) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "strictPropertyInitialization", "strictNullChecks");
            if (options.exactOptionalPropertyTypes && !getStrictOptionValue(options, "strictNullChecks")) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "exactOptionalPropertyTypes", "strictNullChecks");
            if (options.isolatedModules || options.verbatimModuleSyntax) {
                if (options.out) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "out", options.verbatimModuleSyntax ? "verbatimModuleSyntax" : "isolatedModules");
                if (options.outFile) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "outFile", options.verbatimModuleSyntax ? "verbatimModuleSyntax" : "isolatedModules");
            }
            if (options.inlineSourceMap) {
                if (options.sourceMap) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "sourceMap", "inlineSourceMap");
                if (options.mapRoot) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "mapRoot", "inlineSourceMap");
            }
            if (options.composite) {
                if (options.declaration === false) createDiagnosticForOptionName(Diagnostics.Composite_projects_may_not_disable_declaration_emit, "declaration");
                if (options.incremental === false) createDiagnosticForOptionName(Diagnostics.Composite_projects_may_not_disable_incremental_compilation, "declaration");
            }
            const outputFile = outFile(options);
            if (options.tsBuildInfoFile) {
                if (!isIncrementalCompilation(options)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1_or_option_2, "tsBuildInfoFile", "incremental", "composite");
            } else if (options.incremental && !outputFile && !options.configFilePath) programDiagnostics.add(createCompilerDiagnostic(Diagnostics.Option_incremental_can_only_be_specified_using_tsconfig_emitting_to_single_file_or_when_option_tsBuildInfoFile_is_specified));
            verifyDeprecatedCompilerOptions();
            verifyProjectReferences();
            if (options.composite) {
                const rootPaths = new Set(rootNames.map(toPath3));
                for (const file of files)if (sourceFileMayBeEmitted(file, program) && !rootPaths.has(file.path)) addProgramDiagnosticExplainingFile(file, Diagnostics.File_0_is_not_listed_within_the_file_list_of_project_1_Projects_must_list_all_files_or_use_an_include_pattern, [
                    file.fileName,
                    options.configFilePath || ""
                ]);
            }
            if (options.paths) for(const key in options.paths){
                if (!hasProperty(options.paths, key)) continue;
                if (!hasZeroOrOneAsteriskCharacter(key)) createDiagnosticForOptionPaths(/*onKey*/ true, key, Diagnostics.Pattern_0_can_have_at_most_one_Asterisk_character, key);
                if (isArray(options.paths[key])) {
                    const len = options.paths[key].length;
                    if (len === 0) createDiagnosticForOptionPaths(/*onKey*/ false, key, Diagnostics.Substitutions_for_pattern_0_shouldn_t_be_an_empty_array, key);
                    for(let i = 0; i < len; i++){
                        const subst = options.paths[key][i];
                        const typeOfSubst = typeof subst;
                        if (typeOfSubst === "string") {
                            if (!hasZeroOrOneAsteriskCharacter(subst)) createDiagnosticForOptionPathKeyValue(key, i, Diagnostics.Substitution_0_in_pattern_1_can_have_at_most_one_Asterisk_character, subst, key);
                            if (!options.baseUrl && !pathIsRelative(subst) && !pathIsAbsolute(subst)) createDiagnosticForOptionPathKeyValue(key, i, Diagnostics.Non_relative_paths_are_not_allowed_when_baseUrl_is_not_set_Did_you_forget_a_leading_Slash);
                        } else createDiagnosticForOptionPathKeyValue(key, i, Diagnostics.Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2, subst, key, typeOfSubst);
                    }
                } else createDiagnosticForOptionPaths(/*onKey*/ false, key, Diagnostics.Substitutions_for_pattern_0_should_be_an_array, key);
            }
            if (!options.sourceMap && !options.inlineSourceMap) {
                if (options.inlineSources) createDiagnosticForOptionName(Diagnostics.Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided, "inlineSources");
                if (options.sourceRoot) createDiagnosticForOptionName(Diagnostics.Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided, "sourceRoot");
            }
            if (options.out && options.outFile) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "out", "outFile");
            if (options.mapRoot && !(options.sourceMap || options.declarationMap)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1_or_option_2, "mapRoot", "sourceMap", "declarationMap");
            if (options.declarationDir) {
                if (!getEmitDeclarations(options)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1_or_option_2, "declarationDir", "declaration", "composite");
                if (outputFile) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "declarationDir", options.out ? "out" : "outFile");
            }
            if (options.declarationMap && !getEmitDeclarations(options)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1_or_option_2, "declarationMap", "declaration", "composite");
            if (options.lib && options.noLib) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "lib", "noLib");
            if (options.noImplicitUseStrict && getStrictOptionValue(options, "alwaysStrict")) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "noImplicitUseStrict", "alwaysStrict");
            const languageVersion = getEmitScriptTarget(options);
            const firstNonAmbientExternalModuleSourceFile = find(files, (f)=>isExternalModule(f) && !f.isDeclarationFile);
            if (options.isolatedModules || options.verbatimModuleSyntax) {
                if (options.module === 0 /* None */  && languageVersion < 2 /* ES2015 */  && options.isolatedModules) createDiagnosticForOptionName(Diagnostics.Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES2015_or_higher, "isolatedModules", "target");
                if (options.preserveConstEnums === false) createDiagnosticForOptionName(Diagnostics.Option_preserveConstEnums_cannot_be_disabled_when_0_is_enabled, options.verbatimModuleSyntax ? "verbatimModuleSyntax" : "isolatedModules", "preserveConstEnums");
            } else if (firstNonAmbientExternalModuleSourceFile && languageVersion < 2 /* ES2015 */  && options.module === 0 /* None */ ) {
                const span = getErrorSpanForNode(firstNonAmbientExternalModuleSourceFile, typeof firstNonAmbientExternalModuleSourceFile.externalModuleIndicator === "boolean" ? firstNonAmbientExternalModuleSourceFile : firstNonAmbientExternalModuleSourceFile.externalModuleIndicator);
                programDiagnostics.add(createFileDiagnostic(firstNonAmbientExternalModuleSourceFile, span.start, span.length, Diagnostics.Cannot_use_imports_exports_or_module_augmentations_when_module_is_none));
            }
            if (outputFile && !options.emitDeclarationOnly) {
                if (options.module && !(options.module === 2 /* AMD */  || options.module === 4 /* System */ )) createDiagnosticForOptionName(Diagnostics.Only_amd_and_system_modules_are_supported_alongside_0, options.out ? "out" : "outFile", "module");
                else if (options.module === void 0 && firstNonAmbientExternalModuleSourceFile) {
                    const span = getErrorSpanForNode(firstNonAmbientExternalModuleSourceFile, typeof firstNonAmbientExternalModuleSourceFile.externalModuleIndicator === "boolean" ? firstNonAmbientExternalModuleSourceFile : firstNonAmbientExternalModuleSourceFile.externalModuleIndicator);
                    programDiagnostics.add(createFileDiagnostic(firstNonAmbientExternalModuleSourceFile, span.start, span.length, Diagnostics.Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system, options.out ? "out" : "outFile"));
                }
            }
            if (getResolveJsonModule(options)) {
                if (getEmitModuleResolutionKind(options) === 1 /* Classic */ ) createDiagnosticForOptionName(Diagnostics.Option_resolveJsonModule_cannot_be_specified_when_moduleResolution_is_set_to_classic, "resolveJsonModule");
                else if (!hasJsonModuleEmitEnabled(options)) createDiagnosticForOptionName(Diagnostics.Option_resolveJsonModule_can_only_be_specified_when_module_code_generation_is_commonjs_amd_es2015_or_esNext, "resolveJsonModule", "module");
            }
            if (options.outDir || // there is --outDir specified
            options.rootDir || // there is --rootDir specified
            options.sourceRoot || // there is --sourceRoot specified
            options.mapRoot) {
                const dir = getCommonSourceDirectory2();
                if (options.outDir && dir === "" && files.some((file)=>getRootLength(file.fileName) > 1)) createDiagnosticForOptionName(Diagnostics.Cannot_find_the_common_subdirectory_path_for_the_input_files, "outDir");
            }
            if (options.useDefineForClassFields && languageVersion === 0 /* ES3 */ ) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_when_option_target_is_ES3, "useDefineForClassFields");
            if (options.checkJs && !getAllowJSCompilerOption(options)) programDiagnostics.add(createCompilerDiagnostic(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "checkJs", "allowJs"));
            if (options.emitDeclarationOnly) {
                if (!getEmitDeclarations(options)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1_or_option_2, "emitDeclarationOnly", "declaration", "composite");
                if (options.noEmit) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "emitDeclarationOnly", "noEmit");
            }
            if (options.emitDecoratorMetadata && !options.experimentalDecorators) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "emitDecoratorMetadata", "experimentalDecorators");
            if (options.jsxFactory) {
                if (options.reactNamespace) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "reactNamespace", "jsxFactory");
                if (options.jsx === 4 /* ReactJSX */  || options.jsx === 5 /* ReactJSXDev */ ) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_when_option_jsx_is_1, "jsxFactory", inverseJsxOptionMap.get("" + options.jsx));
                if (!parseIsolatedEntityName(options.jsxFactory, languageVersion)) createOptionValueDiagnostic("jsxFactory", Diagnostics.Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name, options.jsxFactory);
            } else if (options.reactNamespace && !isIdentifierText(options.reactNamespace, languageVersion)) createOptionValueDiagnostic("reactNamespace", Diagnostics.Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier, options.reactNamespace);
            if (options.jsxFragmentFactory) {
                if (!options.jsxFactory) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "jsxFragmentFactory", "jsxFactory");
                if (options.jsx === 4 /* ReactJSX */  || options.jsx === 5 /* ReactJSXDev */ ) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_when_option_jsx_is_1, "jsxFragmentFactory", inverseJsxOptionMap.get("" + options.jsx));
                if (!parseIsolatedEntityName(options.jsxFragmentFactory, languageVersion)) createOptionValueDiagnostic("jsxFragmentFactory", Diagnostics.Invalid_value_for_jsxFragmentFactory_0_is_not_a_valid_identifier_or_qualified_name, options.jsxFragmentFactory);
            }
            if (options.reactNamespace) {
                if (options.jsx === 4 /* ReactJSX */  || options.jsx === 5 /* ReactJSXDev */ ) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_when_option_jsx_is_1, "reactNamespace", inverseJsxOptionMap.get("" + options.jsx));
            }
            if (options.jsxImportSource) {
                if (options.jsx === 2 /* React */ ) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_when_option_jsx_is_1, "jsxImportSource", inverseJsxOptionMap.get("" + options.jsx));
            }
            if (options.preserveValueImports && getEmitModuleKind(options) < 5 /* ES2015 */ ) createDiagnosticForOptionName(Diagnostics.Option_0_can_only_be_used_when_module_is_set_to_es2015_or_later, "preserveValueImports");
            const moduleKind = getEmitModuleKind(options);
            if (options.verbatimModuleSyntax) {
                if (moduleKind === 2 /* AMD */  || moduleKind === 3 /* UMD */  || moduleKind === 4 /* System */ ) createDiagnosticForOptionName(Diagnostics.Option_verbatimModuleSyntax_cannot_be_used_when_module_is_set_to_UMD_AMD_or_System, "verbatimModuleSyntax");
                if (options.preserveValueImports) createRedundantOptionDiagnostic("preserveValueImports", "verbatimModuleSyntax");
                if (options.importsNotUsedAsValues) createRedundantOptionDiagnostic("importsNotUsedAsValues", "verbatimModuleSyntax");
            }
            if (options.allowImportingTsExtensions && !(options.noEmit || options.emitDeclarationOnly)) createOptionValueDiagnostic("allowImportingTsExtensions", Diagnostics.Option_allowImportingTsExtensions_can_only_be_used_when_either_noEmit_or_emitDeclarationOnly_is_set);
            const moduleResolution = getEmitModuleResolutionKind(options);
            if (options.resolvePackageJsonExports && !moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution)) createDiagnosticForOptionName(Diagnostics.Option_0_can_only_be_used_when_moduleResolution_is_set_to_node16_nodenext_or_bundler, "resolvePackageJsonExports");
            if (options.resolvePackageJsonImports && !moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution)) createDiagnosticForOptionName(Diagnostics.Option_0_can_only_be_used_when_moduleResolution_is_set_to_node16_nodenext_or_bundler, "resolvePackageJsonImports");
            if (options.customConditions && !moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution)) createDiagnosticForOptionName(Diagnostics.Option_0_can_only_be_used_when_moduleResolution_is_set_to_node16_nodenext_or_bundler, "customConditions");
            if (moduleResolution === 100 /* Bundler */  && !emitModuleKindIsNonNodeESM(moduleKind)) createOptionValueDiagnostic("moduleResolution", Diagnostics.Option_0_can_only_be_used_when_module_is_set_to_es2015_or_later, "bundler");
            if (!options.noEmit && !options.suppressOutputPathCheck) {
                const emitHost = getEmitHost();
                const emitFilesSeen = /* @__PURE__ */ new Set();
                forEachEmittedFile(emitHost, (emitFileNames)=>{
                    if (!options.emitDeclarationOnly) verifyEmitFilePath(emitFileNames.jsFilePath, emitFilesSeen);
                    verifyEmitFilePath(emitFileNames.declarationFilePath, emitFilesSeen);
                });
            }
            function verifyEmitFilePath(emitFileName, emitFilesSeen) {
                if (emitFileName) {
                    const emitFilePath = toPath3(emitFileName);
                    if (filesByName.has(emitFilePath)) {
                        let chain;
                        if (!options.configFilePath) chain = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript_files_Learn_more_at_https_Colon_Slash_Slashaka_ms_Slashtsconfig);
                        chain = chainDiagnosticMessages(chain, Diagnostics.Cannot_write_file_0_because_it_would_overwrite_input_file, emitFileName);
                        blockEmittingOfFile(emitFileName, createCompilerDiagnosticFromMessageChain(chain));
                    }
                    const emitFileKey = !host.useCaseSensitiveFileNames() ? toFileNameLowerCase(emitFilePath) : emitFilePath;
                    if (emitFilesSeen.has(emitFileKey)) blockEmittingOfFile(emitFileName, createCompilerDiagnostic(Diagnostics.Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files, emitFileName));
                    else emitFilesSeen.add(emitFileKey);
                }
            }
        }
        function getIgnoreDeprecationsVersion() {
            const ignoreDeprecations = options.ignoreDeprecations;
            if (ignoreDeprecations) {
                if (ignoreDeprecations === "5.0") return new Version(ignoreDeprecations);
                reportInvalidIgnoreDeprecations();
            }
            return Version.zero;
        }
        function checkDeprecations(deprecatedIn, removedIn, createDiagnostic, fn) {
            const deprecatedInVersion = new Version(deprecatedIn);
            const removedInVersion = new Version(removedIn);
            const typescriptVersion = new Version(typeScriptVersion3 || versionMajorMinor);
            const ignoreDeprecationsVersion = getIgnoreDeprecationsVersion();
            const mustBeRemoved = !(removedInVersion.compareTo(typescriptVersion) === 1 /* GreaterThan */ );
            const canBeSilenced = !mustBeRemoved && ignoreDeprecationsVersion.compareTo(deprecatedInVersion) === -1 /* LessThan */ ;
            if (mustBeRemoved || canBeSilenced) fn((name, value1, useInstead)=>{
                if (mustBeRemoved) {
                    if (value1 === void 0) createDiagnostic(name, value1, useInstead, Diagnostics.Option_0_has_been_removed_Please_remove_it_from_your_configuration, name);
                    else createDiagnostic(name, value1, useInstead, Diagnostics.Option_0_1_has_been_removed_Please_remove_it_from_your_configuration, name, value1);
                } else if (value1 === void 0) createDiagnostic(name, value1, useInstead, Diagnostics.Option_0_is_deprecated_and_will_stop_functioning_in_TypeScript_1_Specify_compilerOption_ignoreDeprecations_Colon_2_to_silence_this_error, name, removedIn, deprecatedIn);
                else createDiagnostic(name, value1, useInstead, Diagnostics.Option_0_1_is_deprecated_and_will_stop_functioning_in_TypeScript_2_Specify_compilerOption_ignoreDeprecations_Colon_3_to_silence_this_error, name, value1, removedIn, deprecatedIn);
            });
        }
        function verifyDeprecatedCompilerOptions() {
            function createDiagnostic(name, value1, useInstead, message, ...args) {
                if (useInstead) {
                    const details = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Use_0_instead, useInstead);
                    const chain = chainDiagnosticMessages(details, message, ...args);
                    createDiagnosticForOption(/*onKey*/ !value1, name, /*option2*/ void 0, chain);
                } else createDiagnosticForOption(/*onKey*/ !value1, name, /*option2*/ void 0, message, ...args);
            }
            checkDeprecations("5.0", "5.5", createDiagnostic, (createDeprecatedDiagnostic)=>{
                if (options.target === 0 /* ES3 */ ) createDeprecatedDiagnostic("target", "ES3");
                if (options.noImplicitUseStrict) createDeprecatedDiagnostic("noImplicitUseStrict");
                if (options.keyofStringsOnly) createDeprecatedDiagnostic("keyofStringsOnly");
                if (options.suppressExcessPropertyErrors) createDeprecatedDiagnostic("suppressExcessPropertyErrors");
                if (options.suppressImplicitAnyIndexErrors) createDeprecatedDiagnostic("suppressImplicitAnyIndexErrors");
                if (options.noStrictGenericChecks) createDeprecatedDiagnostic("noStrictGenericChecks");
                if (options.charset) createDeprecatedDiagnostic("charset");
                if (options.out) createDeprecatedDiagnostic("out", /*value*/ void 0, "outFile");
                if (options.importsNotUsedAsValues) createDeprecatedDiagnostic("importsNotUsedAsValues", /*value*/ void 0, "verbatimModuleSyntax");
                if (options.preserveValueImports) createDeprecatedDiagnostic("preserveValueImports", /*value*/ void 0, "verbatimModuleSyntax");
            });
        }
        function verifyDeprecatedProjectReference(ref, parentFile, index) {
            function createDiagnostic(_name, _value, _useInstead, message, ...args) {
                createDiagnosticForReference(parentFile, index, message, ...args);
            }
            checkDeprecations("5.0", "5.5", createDiagnostic, (createDeprecatedDiagnostic)=>{
                if (ref.prepend) createDeprecatedDiagnostic("prepend");
            });
        }
        function createDiagnosticExplainingFile(file, fileProcessingReason, diagnostic, args) {
            var _a2;
            let fileIncludeReasons;
            let relatedInfo;
            let locationReason = isReferencedFile(fileProcessingReason) ? fileProcessingReason : void 0;
            if (file) (_a2 = fileReasons.get(file.path)) == null || _a2.forEach(processReason);
            if (fileProcessingReason) processReason(fileProcessingReason);
            if (locationReason && (fileIncludeReasons == null ? void 0 : fileIncludeReasons.length) === 1) fileIncludeReasons = void 0;
            const location = locationReason && getReferencedFileLocation(getSourceFileByPath, locationReason);
            const fileIncludeReasonDetails = fileIncludeReasons && chainDiagnosticMessages(fileIncludeReasons, Diagnostics.The_file_is_in_the_program_because_Colon);
            const redirectInfo = file && explainIfFileIsRedirectAndImpliedFormat(file);
            const chain = chainDiagnosticMessages(redirectInfo ? fileIncludeReasonDetails ? [
                fileIncludeReasonDetails,
                ...redirectInfo
            ] : redirectInfo : fileIncludeReasonDetails, diagnostic, ...args || emptyArray);
            return location && isReferenceFileLocation(location) ? createFileDiagnosticFromMessageChain(location.file, location.pos, location.end - location.pos, chain, relatedInfo) : createCompilerDiagnosticFromMessageChain(chain, relatedInfo);
            function processReason(reason) {
                (fileIncludeReasons || (fileIncludeReasons = [])).push(fileIncludeReasonToDiagnostics(program, reason));
                if (!locationReason && isReferencedFile(reason)) locationReason = reason;
                else if (locationReason !== reason) relatedInfo = append(relatedInfo, fileIncludeReasonToRelatedInformation(reason));
                if (reason === fileProcessingReason) fileProcessingReason = void 0;
            }
        }
        function addFilePreprocessingFileExplainingDiagnostic(file, fileProcessingReason, diagnostic, args) {
            (fileProcessingDiagnostics || (fileProcessingDiagnostics = [])).push({
                kind: 1 /* FilePreprocessingFileExplainingDiagnostic */ ,
                file: file && file.path,
                fileProcessingReason: fileProcessingReason,
                diagnostic: diagnostic,
                args: args
            });
        }
        function addProgramDiagnosticExplainingFile(file, diagnostic, args) {
            programDiagnostics.add(createDiagnosticExplainingFile(file, /*fileProcessingReason*/ void 0, diagnostic, args));
        }
        function fileIncludeReasonToRelatedInformation(reason) {
            if (isReferencedFile(reason)) {
                const referenceLocation = getReferencedFileLocation(getSourceFileByPath, reason);
                let message2;
                switch(reason.kind){
                    case 3 /* Import */ :
                        message2 = Diagnostics.File_is_included_via_import_here;
                        break;
                    case 4 /* ReferenceFile */ :
                        message2 = Diagnostics.File_is_included_via_reference_here;
                        break;
                    case 5 /* TypeReferenceDirective */ :
                        message2 = Diagnostics.File_is_included_via_type_library_reference_here;
                        break;
                    case 7 /* LibReferenceDirective */ :
                        message2 = Diagnostics.File_is_included_via_library_reference_here;
                        break;
                    default:
                        Debug.assertNever(reason);
                }
                return isReferenceFileLocation(referenceLocation) ? createFileDiagnostic(referenceLocation.file, referenceLocation.pos, referenceLocation.end - referenceLocation.pos, message2) : void 0;
            }
            if (!options.configFile) return void 0;
            let configFileNode;
            let message;
            switch(reason.kind){
                case 0 /* RootFile */ :
                    if (!options.configFile.configFileSpecs) return void 0;
                    const fileName = getNormalizedAbsolutePath(rootNames[reason.index], currentDirectory);
                    const matchedByFiles = getMatchedFileSpec(program, fileName);
                    if (matchedByFiles) {
                        configFileNode = getTsConfigPropArrayElementValue(options.configFile, "files", matchedByFiles);
                        message = Diagnostics.File_is_matched_by_files_list_specified_here;
                        break;
                    }
                    const matchedByInclude = getMatchedIncludeSpec(program, fileName);
                    if (!matchedByInclude || !isString(matchedByInclude)) return void 0;
                    configFileNode = getTsConfigPropArrayElementValue(options.configFile, "include", matchedByInclude);
                    message = Diagnostics.File_is_matched_by_include_pattern_specified_here;
                    break;
                case 1 /* SourceFromProjectReference */ :
                case 2 /* OutputFromProjectReference */ :
                    const referencedResolvedRef = Debug.checkDefined(resolvedProjectReferences == null ? void 0 : resolvedProjectReferences[reason.index]);
                    const referenceInfo = forEachProjectReference(projectReferences, resolvedProjectReferences, (resolvedRef, parent2, index2)=>resolvedRef === referencedResolvedRef ? {
                            sourceFile: (parent2 == null ? void 0 : parent2.sourceFile) || options.configFile,
                            index: index2
                        } : void 0);
                    if (!referenceInfo) return void 0;
                    const { sourceFile: sourceFile , index: index  } = referenceInfo;
                    const referencesSyntax = forEachTsConfigPropArray(sourceFile, "references", (property)=>isArrayLiteralExpression(property.initializer) ? property.initializer : void 0);
                    return referencesSyntax && referencesSyntax.elements.length > index ? createDiagnosticForNodeInSourceFile(sourceFile, referencesSyntax.elements[index], reason.kind === 2 /* OutputFromProjectReference */  ? Diagnostics.File_is_output_from_referenced_project_specified_here : Diagnostics.File_is_source_from_referenced_project_specified_here) : void 0;
                case 8 /* AutomaticTypeDirectiveFile */ :
                    if (!options.types) return void 0;
                    configFileNode = getOptionsSyntaxByArrayElementValue("types", reason.typeReference);
                    message = Diagnostics.File_is_entry_point_of_type_library_specified_here;
                    break;
                case 6 /* LibFile */ :
                    if (reason.index !== void 0) {
                        configFileNode = getOptionsSyntaxByArrayElementValue("lib", options.lib[reason.index]);
                        message = Diagnostics.File_is_library_specified_here;
                        break;
                    }
                    const target = forEachEntry(targetOptionDeclaration.type, (value1, key)=>value1 === getEmitScriptTarget(options) ? key : void 0);
                    configFileNode = target ? getOptionsSyntaxByValue("target", target) : void 0;
                    message = Diagnostics.File_is_default_library_for_target_specified_here;
                    break;
                default:
                    Debug.assertNever(reason);
            }
            return configFileNode && createDiagnosticForNodeInSourceFile(options.configFile, configFileNode, message);
        }
        function verifyProjectReferences() {
            const buildInfoPath = !options.suppressOutputPathCheck ? getTsBuildInfoEmitOutputFilePath(options) : void 0;
            forEachProjectReference(projectReferences, resolvedProjectReferences, (resolvedRef, parent2, index)=>{
                const ref = (parent2 ? parent2.commandLine.projectReferences : projectReferences)[index];
                const parentFile = parent2 && parent2.sourceFile;
                verifyDeprecatedProjectReference(ref, parentFile, index);
                if (!resolvedRef) {
                    createDiagnosticForReference(parentFile, index, Diagnostics.File_0_not_found, ref.path);
                    return;
                }
                const options2 = resolvedRef.commandLine.options;
                if (!options2.composite || options2.noEmit) {
                    const inputs = parent2 ? parent2.commandLine.fileNames : rootNames;
                    if (inputs.length) {
                        if (!options2.composite) createDiagnosticForReference(parentFile, index, Diagnostics.Referenced_project_0_must_have_setting_composite_Colon_true, ref.path);
                        if (options2.noEmit) createDiagnosticForReference(parentFile, index, Diagnostics.Referenced_project_0_may_not_disable_emit, ref.path);
                    }
                }
                if (ref.prepend) {
                    const out = outFile(options2);
                    if (out) {
                        if (!host.fileExists(out)) createDiagnosticForReference(parentFile, index, Diagnostics.Output_file_0_from_project_1_does_not_exist, out, ref.path);
                    } else createDiagnosticForReference(parentFile, index, Diagnostics.Cannot_prepend_project_0_because_it_does_not_have_outFile_set, ref.path);
                }
                if (!parent2 && buildInfoPath && buildInfoPath === getTsBuildInfoEmitOutputFilePath(options2)) {
                    createDiagnosticForReference(parentFile, index, Diagnostics.Cannot_write_file_0_because_it_will_overwrite_tsbuildinfo_file_generated_by_referenced_project_1, buildInfoPath, ref.path);
                    hasEmitBlockingDiagnostics.set(toPath3(buildInfoPath), true);
                }
            });
        }
        function createDiagnosticForOptionPathKeyValue(key, valueIndex, message, ...args) {
            let needCompilerDiagnostic = true;
            forEachOptionPathsSyntax((pathProp)=>{
                if (isObjectLiteralExpression(pathProp.initializer)) forEachPropertyAssignment(pathProp.initializer, key, (keyProps)=>{
                    const initializer = keyProps.initializer;
                    if (isArrayLiteralExpression(initializer) && initializer.elements.length > valueIndex) {
                        programDiagnostics.add(createDiagnosticForNodeInSourceFile(options.configFile, initializer.elements[valueIndex], message, ...args));
                        needCompilerDiagnostic = false;
                    }
                });
            });
            if (needCompilerDiagnostic) programDiagnostics.add(createCompilerDiagnostic(message, ...args));
        }
        function createDiagnosticForOptionPaths(onKey, key, message, ...args) {
            let needCompilerDiagnostic = true;
            forEachOptionPathsSyntax((pathProp)=>{
                if (isObjectLiteralExpression(pathProp.initializer) && createOptionDiagnosticInObjectLiteralSyntax(pathProp.initializer, onKey, key, /*key2*/ void 0, message, ...args)) needCompilerDiagnostic = false;
            });
            if (needCompilerDiagnostic) programDiagnostics.add(createCompilerDiagnostic(message, ...args));
        }
        function forEachOptionsSyntaxByName(name, callback) {
            return forEachPropertyAssignment(getCompilerOptionsObjectLiteralSyntax(), name, callback);
        }
        function forEachOptionPathsSyntax(callback) {
            return forEachOptionsSyntaxByName("paths", callback);
        }
        function getOptionsSyntaxByValue(name, value1) {
            return forEachOptionsSyntaxByName(name, (property)=>isStringLiteral(property.initializer) && property.initializer.text === value1 ? property.initializer : void 0);
        }
        function getOptionsSyntaxByArrayElementValue(name, value1) {
            const compilerOptionsObjectLiteralSyntax = getCompilerOptionsObjectLiteralSyntax();
            return compilerOptionsObjectLiteralSyntax && getPropertyArrayElementValue(compilerOptionsObjectLiteralSyntax, name, value1);
        }
        function createDiagnosticForOptionName(message, option1, option2, option3) {
            createDiagnosticForOption(/*onKey*/ true, option1, option2, message, option1, option2, option3);
        }
        function createOptionValueDiagnostic(option1, message, ...args) {
            createDiagnosticForOption(/*onKey*/ false, option1, /*option2*/ void 0, message, ...args);
        }
        function createDiagnosticForReference(sourceFile, index, message, ...args) {
            const referencesSyntax = forEachTsConfigPropArray(sourceFile || options.configFile, "references", (property)=>isArrayLiteralExpression(property.initializer) ? property.initializer : void 0);
            if (referencesSyntax && referencesSyntax.elements.length > index) programDiagnostics.add(createDiagnosticForNodeInSourceFile(sourceFile || options.configFile, referencesSyntax.elements[index], message, ...args));
            else programDiagnostics.add(createCompilerDiagnostic(message, ...args));
        }
        function createDiagnosticForOption(onKey, option1, option2, message, ...args) {
            const compilerOptionsObjectLiteralSyntax = getCompilerOptionsObjectLiteralSyntax();
            const needCompilerDiagnostic = !compilerOptionsObjectLiteralSyntax || !createOptionDiagnosticInObjectLiteralSyntax(compilerOptionsObjectLiteralSyntax, onKey, option1, option2, message, ...args);
            if (needCompilerDiagnostic) {
                if ("messageText" in message) programDiagnostics.add(createCompilerDiagnosticFromMessageChain(message));
                else programDiagnostics.add(createCompilerDiagnostic(message, ...args));
            }
        }
        function getCompilerOptionsObjectLiteralSyntax() {
            if (_compilerOptionsObjectLiteralSyntax === void 0) _compilerOptionsObjectLiteralSyntax = forEachPropertyAssignment(getTsConfigObjectLiteralExpression(options.configFile), "compilerOptions", (prop)=>isObjectLiteralExpression(prop.initializer) ? prop.initializer : void 0) || false;
            return _compilerOptionsObjectLiteralSyntax || void 0;
        }
        function createOptionDiagnosticInObjectLiteralSyntax(objectLiteral, onKey, key1, key2, message, ...args) {
            let needsCompilerDiagnostic = false;
            forEachPropertyAssignment(objectLiteral, key1, (prop)=>{
                if ("messageText" in message) programDiagnostics.add(createDiagnosticForNodeFromMessageChain(options.configFile, onKey ? prop.name : prop.initializer, message));
                else programDiagnostics.add(createDiagnosticForNodeInSourceFile(options.configFile, onKey ? prop.name : prop.initializer, message, ...args));
                needsCompilerDiagnostic = true;
            }, key2);
            return needsCompilerDiagnostic;
        }
        function createRedundantOptionDiagnostic(errorOnOption, redundantWithOption) {
            const compilerOptionsObjectLiteralSyntax = getCompilerOptionsObjectLiteralSyntax();
            if (compilerOptionsObjectLiteralSyntax) createOptionDiagnosticInObjectLiteralSyntax(compilerOptionsObjectLiteralSyntax, /*onKey*/ true, errorOnOption, /*key2*/ void 0, Diagnostics.Option_0_is_redundant_and_cannot_be_specified_with_option_1, errorOnOption, redundantWithOption);
            else createDiagnosticForOptionName(Diagnostics.Option_0_is_redundant_and_cannot_be_specified_with_option_1, errorOnOption, redundantWithOption);
        }
        function blockEmittingOfFile(emitFileName, diag2) {
            hasEmitBlockingDiagnostics.set(toPath3(emitFileName), true);
            programDiagnostics.add(diag2);
        }
        function isEmittedFile(file) {
            if (options.noEmit) return false;
            const filePath = toPath3(file);
            if (getSourceFileByPath(filePath)) return false;
            const out = outFile(options);
            if (out) return isSameFile(filePath, out) || isSameFile(filePath, removeFileExtension(out) + ".d.ts" /* Dts */ );
            if (options.declarationDir && containsPath(options.declarationDir, filePath, currentDirectory, !host.useCaseSensitiveFileNames())) return true;
            if (options.outDir) return containsPath(options.outDir, filePath, currentDirectory, !host.useCaseSensitiveFileNames());
            if (fileExtensionIsOneOf(filePath, supportedJSExtensionsFlat) || isDeclarationFileName(filePath)) {
                const filePathWithoutExtension = removeFileExtension(filePath);
                return !!getSourceFileByPath(filePathWithoutExtension + ".ts" /* Ts */ ) || !!getSourceFileByPath(filePathWithoutExtension + ".tsx" /* Tsx */ );
            }
            return false;
        }
        function isSameFile(file1, file2) {
            return comparePaths(file1, file2, currentDirectory, !host.useCaseSensitiveFileNames()) === 0 /* EqualTo */ ;
        }
        function getSymlinkCache() {
            if (host.getSymlinkCache) return host.getSymlinkCache();
            if (!symlinks) symlinks = createSymlinkCache(currentDirectory, getCanonicalFileName);
            if (files && automaticTypeDirectiveResolutions && !symlinks.hasProcessedResolutions()) symlinks.setSymlinksFromResolutions(files, automaticTypeDirectiveResolutions);
            return symlinks;
        }
    }
    function updateHostForUseSourceOfProjectReferenceRedirect(host) {
        let setOfDeclarationDirectories;
        const originalFileExists = host.compilerHost.fileExists;
        const originalDirectoryExists = host.compilerHost.directoryExists;
        const originalGetDirectories = host.compilerHost.getDirectories;
        const originalRealpath = host.compilerHost.realpath;
        if (!host.useSourceOfProjectReferenceRedirect) return {
            onProgramCreateComplete: noop,
            fileExists: fileExists
        };
        host.compilerHost.fileExists = fileExists;
        let directoryExists;
        if (originalDirectoryExists) directoryExists = host.compilerHost.directoryExists = (path)=>{
            if (originalDirectoryExists.call(host.compilerHost, path)) {
                handleDirectoryCouldBeSymlink(path);
                return true;
            }
            if (!host.getResolvedProjectReferences()) return false;
            if (!setOfDeclarationDirectories) {
                setOfDeclarationDirectories = /* @__PURE__ */ new Set();
                host.forEachResolvedProjectReference((ref)=>{
                    const out = outFile(ref.commandLine.options);
                    if (out) setOfDeclarationDirectories.add(getDirectoryPath(host.toPath(out)));
                    else {
                        const declarationDir = ref.commandLine.options.declarationDir || ref.commandLine.options.outDir;
                        if (declarationDir) setOfDeclarationDirectories.add(host.toPath(declarationDir));
                    }
                });
            }
            return fileOrDirectoryExistsUsingSource(path, /*isFile*/ false);
        };
        if (originalGetDirectories) host.compilerHost.getDirectories = (path)=>!host.getResolvedProjectReferences() || originalDirectoryExists && originalDirectoryExists.call(host.compilerHost, path) ? originalGetDirectories.call(host.compilerHost, path) : [];
        if (originalRealpath) host.compilerHost.realpath = (s)=>{
            var _a;
            return ((_a = host.getSymlinkCache().getSymlinkedFiles()) == null ? void 0 : _a.get(host.toPath(s))) || originalRealpath.call(host.compilerHost, s);
        };
        return {
            onProgramCreateComplete: onProgramCreateComplete,
            fileExists: fileExists,
            directoryExists: directoryExists
        };
        function onProgramCreateComplete() {
            host.compilerHost.fileExists = originalFileExists;
            host.compilerHost.directoryExists = originalDirectoryExists;
            host.compilerHost.getDirectories = originalGetDirectories;
        }
        function fileExists(file) {
            if (originalFileExists.call(host.compilerHost, file)) return true;
            if (!host.getResolvedProjectReferences()) return false;
            if (!isDeclarationFileName(file)) return false;
            return fileOrDirectoryExistsUsingSource(file, /*isFile*/ true);
        }
        function fileExistsIfProjectReferenceDts(file) {
            const source = host.getSourceOfProjectReferenceRedirect(host.toPath(file));
            return source !== void 0 ? isString(source) ? originalFileExists.call(host.compilerHost, source) : true : void 0;
        }
        function directoryExistsIfProjectReferenceDeclDir(dir) {
            const dirPath = host.toPath(dir);
            const dirPathWithTrailingDirectorySeparator = `${dirPath}${directorySeparator}`;
            return forEachKey(setOfDeclarationDirectories, (declDirPath)=>dirPath === declDirPath || // Any parent directory of declaration dir
                startsWith(declDirPath, dirPathWithTrailingDirectorySeparator) || // Any directory inside declaration dir
                startsWith(dirPath, `${declDirPath}/`));
        }
        function handleDirectoryCouldBeSymlink(directory) {
            var _a;
            if (!host.getResolvedProjectReferences() || containsIgnoredPath(directory)) return;
            if (!originalRealpath || !stringContains(directory, nodeModulesPathPart)) return;
            const symlinkCache = host.getSymlinkCache();
            const directoryPath = ensureTrailingDirectorySeparator(host.toPath(directory));
            if ((_a = symlinkCache.getSymlinkedDirectories()) == null ? void 0 : _a.has(directoryPath)) return;
            const real = normalizePath(originalRealpath.call(host.compilerHost, directory));
            let realPath2;
            if (real === directory || (realPath2 = ensureTrailingDirectorySeparator(host.toPath(real))) === directoryPath) {
                symlinkCache.setSymlinkedDirectory(directoryPath, false);
                return;
            }
            symlinkCache.setSymlinkedDirectory(directory, {
                real: ensureTrailingDirectorySeparator(real),
                realPath: realPath2
            });
        }
        function fileOrDirectoryExistsUsingSource(fileOrDirectory, isFile) {
            var _a;
            const fileOrDirectoryExistsUsingSource2 = isFile ? (file)=>fileExistsIfProjectReferenceDts(file) : (dir)=>directoryExistsIfProjectReferenceDeclDir(dir);
            const result = fileOrDirectoryExistsUsingSource2(fileOrDirectory);
            if (result !== void 0) return result;
            const symlinkCache = host.getSymlinkCache();
            const symlinkedDirectories = symlinkCache.getSymlinkedDirectories();
            if (!symlinkedDirectories) return false;
            const fileOrDirectoryPath = host.toPath(fileOrDirectory);
            if (!stringContains(fileOrDirectoryPath, nodeModulesPathPart)) return false;
            if (isFile && ((_a = symlinkCache.getSymlinkedFiles()) == null ? void 0 : _a.has(fileOrDirectoryPath))) return true;
            return firstDefinedIterator(symlinkedDirectories.entries(), ([directoryPath, symlinkedDirectory])=>{
                if (!symlinkedDirectory || !startsWith(fileOrDirectoryPath, directoryPath)) return void 0;
                const result2 = fileOrDirectoryExistsUsingSource2(fileOrDirectoryPath.replace(directoryPath, symlinkedDirectory.realPath));
                if (isFile && result2) {
                    const absolutePath = getNormalizedAbsolutePath(fileOrDirectory, host.compilerHost.getCurrentDirectory());
                    symlinkCache.setSymlinkedFile(fileOrDirectoryPath, `${symlinkedDirectory.real}${absolutePath.replace(new RegExp(directoryPath, "i"), "")}`);
                }
                return result2;
            }) || false;
        }
    }
    function handleNoEmitOptions(program, sourceFile, writeFile2, cancellationToken) {
        const options = program.getCompilerOptions();
        if (options.noEmit) {
            program.getSemanticDiagnostics(sourceFile, cancellationToken);
            return sourceFile || outFile(options) ? emitSkippedWithNoDiagnostics : program.emitBuildInfo(writeFile2, cancellationToken);
        }
        if (!options.noEmitOnError) return void 0;
        let diagnostics = [
            ...program.getOptionsDiagnostics(cancellationToken),
            ...program.getSyntacticDiagnostics(sourceFile, cancellationToken),
            ...program.getGlobalDiagnostics(cancellationToken),
            ...program.getSemanticDiagnostics(sourceFile, cancellationToken)
        ];
        if (diagnostics.length === 0 && getEmitDeclarations(program.getCompilerOptions())) diagnostics = program.getDeclarationDiagnostics(/*sourceFile*/ void 0, cancellationToken);
        if (!diagnostics.length) return void 0;
        let emittedFiles;
        if (!sourceFile && !outFile(options)) {
            const emitResult = program.emitBuildInfo(writeFile2, cancellationToken);
            if (emitResult.diagnostics) diagnostics = [
                ...diagnostics,
                ...emitResult.diagnostics
            ];
            emittedFiles = emitResult.emittedFiles;
        }
        return {
            diagnostics: diagnostics,
            sourceMaps: void 0,
            emittedFiles: emittedFiles,
            emitSkipped: true
        };
    }
    function filterSemanticDiagnostics(diagnostic, option) {
        return filter(diagnostic, (d)=>!d.skippedOn || !option[d.skippedOn]);
    }
    function parseConfigHostFromCompilerHostLike(host, directoryStructureHost = host) {
        return {
            fileExists: (f)=>directoryStructureHost.fileExists(f),
            readDirectory (root, extensions, excludes, includes, depth) {
                Debug.assertIsDefined(directoryStructureHost.readDirectory, "'CompilerHost.readDirectory' must be implemented to correctly process 'projectReferences'");
                return directoryStructureHost.readDirectory(root, extensions, excludes, includes, depth);
            },
            readFile: (f)=>directoryStructureHost.readFile(f),
            useCaseSensitiveFileNames: host.useCaseSensitiveFileNames(),
            getCurrentDirectory: ()=>host.getCurrentDirectory(),
            onUnRecoverableConfigFileDiagnostic: host.onUnRecoverableConfigFileDiagnostic || returnUndefined,
            trace: host.trace ? (s)=>host.trace(s) : void 0
        };
    }
    function createPrependNodes(projectReferences, getCommandLine, readFile, host) {
        if (!projectReferences) return emptyArray;
        let nodes;
        for(let i = 0; i < projectReferences.length; i++){
            const ref = projectReferences[i];
            const resolvedRefOpts = getCommandLine(ref, i);
            if (ref.prepend && resolvedRefOpts && resolvedRefOpts.options) {
                const out = outFile(resolvedRefOpts.options);
                if (!out) continue;
                const { jsFilePath: jsFilePath , sourceMapFilePath: sourceMapFilePath , declarationFilePath: declarationFilePath , declarationMapPath: declarationMapPath , buildInfoPath: buildInfoPath  } = getOutputPathsForBundle(resolvedRefOpts.options, /*forceDtsPaths*/ true);
                const node = createInputFilesWithFilePaths(readFile, jsFilePath, sourceMapFilePath, declarationFilePath, declarationMapPath, buildInfoPath, host, resolvedRefOpts.options);
                (nodes || (nodes = [])).push(node);
            }
        }
        return nodes || emptyArray;
    }
    function resolveProjectReferencePath(ref) {
        return resolveConfigFileProjectName(ref.path);
    }
    function getResolutionDiagnostic(options, { extension: extension  }, { isDeclarationFile: isDeclarationFile  }) {
        switch(extension){
            case ".ts" /* Ts */ :
            case ".d.ts" /* Dts */ :
            case ".mts" /* Mts */ :
            case ".d.mts" /* Dmts */ :
            case ".cts" /* Cts */ :
            case ".d.cts" /* Dcts */ :
                return void 0;
            case ".tsx" /* Tsx */ :
                return needJsx();
            case ".jsx" /* Jsx */ :
                return needJsx() || needAllowJs();
            case ".js" /* Js */ :
            case ".mjs" /* Mjs */ :
            case ".cjs" /* Cjs */ :
                return needAllowJs();
            case ".json" /* Json */ :
                return needResolveJsonModule();
            default:
                return needAllowArbitraryExtensions();
        }
        function needJsx() {
            return options.jsx ? void 0 : Diagnostics.Module_0_was_resolved_to_1_but_jsx_is_not_set;
        }
        function needAllowJs() {
            return getAllowJSCompilerOption(options) || !getStrictOptionValue(options, "noImplicitAny") ? void 0 : Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type;
        }
        function needResolveJsonModule() {
            return getResolveJsonModule(options) ? void 0 : Diagnostics.Module_0_was_resolved_to_1_but_resolveJsonModule_is_not_used;
        }
        function needAllowArbitraryExtensions() {
            return isDeclarationFile || options.allowArbitraryExtensions ? void 0 : Diagnostics.Module_0_was_resolved_to_1_but_allowArbitraryExtensions_is_not_set;
        }
    }
    function getModuleNames({ imports: imports , moduleAugmentations: moduleAugmentations  }) {
        const res = imports.map((i)=>i);
        for (const aug of moduleAugmentations)if (aug.kind === 11 /* StringLiteral */ ) res.push(aug);
        return res;
    }
    function getModuleNameStringLiteralAt({ imports: imports , moduleAugmentations: moduleAugmentations  }, index) {
        if (index < imports.length) return imports[index];
        let augIndex = imports.length;
        for (const aug of moduleAugmentations)if (aug.kind === 11 /* StringLiteral */ ) {
            if (index === augIndex) return aug;
            augIndex++;
        }
        Debug.fail("should never ask for module name at index higher than possible module name");
    }
    var ForegroundColorEscapeSequences, gutterStyleSequence, gutterSeparator, resetEscapeSequence, ellipsis, halfIndent, indent, emptyResolution, moduleResolutionNameAndModeGetter, typeReferenceResolutionNameAndModeGetter, inferredTypesContainingFile, plainJSErrors, emitSkippedWithNoDiagnostics;
    var init_program = __esm({
        "src/compiler/program.ts" () {
            "use strict";
            init_ts2();
            init_ts_performance();
            ForegroundColorEscapeSequences = /* @__PURE__ */ ((ForegroundColorEscapeSequences2)=>{
                ForegroundColorEscapeSequences2["Grey"] = "\x1b[90m";
                ForegroundColorEscapeSequences2["Red"] = "\x1b[91m";
                ForegroundColorEscapeSequences2["Yellow"] = "\x1b[93m";
                ForegroundColorEscapeSequences2["Blue"] = "\x1b[94m";
                ForegroundColorEscapeSequences2["Cyan"] = "\x1b[96m";
                return ForegroundColorEscapeSequences2;
            })(ForegroundColorEscapeSequences || {});
            gutterStyleSequence = "\x1b[7m";
            gutterSeparator = " ";
            resetEscapeSequence = "\x1b[0m";
            ellipsis = "...";
            halfIndent = "  ";
            indent = "    ";
            emptyResolution = {
                resolvedModule: void 0,
                resolvedTypeReferenceDirective: void 0
            };
            moduleResolutionNameAndModeGetter = {
                getName: getModuleResolutionName,
                getMode: (entry, file)=>getModeForUsageLocation(file, entry)
            };
            typeReferenceResolutionNameAndModeGetter = {
                getName: getTypeReferenceResolutionName,
                getMode: (entry, file)=>getModeForFileReference(entry, file == null ? void 0 : file.impliedNodeFormat)
            };
            inferredTypesContainingFile = "__inferred type names__.ts";
            plainJSErrors = /* @__PURE__ */ new Set([
                // binder errors
                Diagnostics.Cannot_redeclare_block_scoped_variable_0.code,
                Diagnostics.A_module_cannot_have_multiple_default_exports.code,
                Diagnostics.Another_export_default_is_here.code,
                Diagnostics.The_first_export_default_is_here.code,
                Diagnostics.Identifier_expected_0_is_a_reserved_word_at_the_top_level_of_a_module.code,
                Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode.code,
                Diagnostics.Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here.code,
                Diagnostics.constructor_is_a_reserved_word.code,
                Diagnostics.delete_cannot_be_called_on_an_identifier_in_strict_mode.code,
                Diagnostics.Code_contained_in_a_class_is_evaluated_in_JavaScript_s_strict_mode_which_does_not_allow_this_use_of_0_For_more_information_see_https_Colon_Slash_Slashdeveloper_mozilla_org_Slashen_US_Slashdocs_SlashWeb_SlashJavaScript_SlashReference_SlashStrict_mode.code,
                Diagnostics.Invalid_use_of_0_Modules_are_automatically_in_strict_mode.code,
                Diagnostics.Invalid_use_of_0_in_strict_mode.code,
                Diagnostics.A_label_is_not_allowed_here.code,
                Diagnostics.with_statements_are_not_allowed_in_strict_mode.code,
                // grammar errors
                Diagnostics.A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement.code,
                Diagnostics.A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement.code,
                Diagnostics.A_class_declaration_without_the_default_modifier_must_have_a_name.code,
                Diagnostics.A_class_member_cannot_have_the_0_keyword.code,
                Diagnostics.A_comma_expression_is_not_allowed_in_a_computed_property_name.code,
                Diagnostics.A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement.code,
                Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement.code,
                Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement.code,
                Diagnostics.A_default_clause_cannot_appear_more_than_once_in_a_switch_statement.code,
                Diagnostics.A_default_export_must_be_at_the_top_level_of_a_file_or_module_declaration.code,
                Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context.code,
                Diagnostics.A_destructuring_declaration_must_have_an_initializer.code,
                Diagnostics.A_get_accessor_cannot_have_parameters.code,
                Diagnostics.A_rest_element_cannot_contain_a_binding_pattern.code,
                Diagnostics.A_rest_element_cannot_have_a_property_name.code,
                Diagnostics.A_rest_element_cannot_have_an_initializer.code,
                Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern.code,
                Diagnostics.A_rest_parameter_cannot_have_an_initializer.code,
                Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list.code,
                Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma.code,
                Diagnostics.A_return_statement_cannot_be_used_inside_a_class_static_block.code,
                Diagnostics.A_set_accessor_cannot_have_rest_parameter.code,
                Diagnostics.A_set_accessor_must_have_exactly_one_parameter.code,
                Diagnostics.An_export_declaration_can_only_be_used_at_the_top_level_of_a_module.code,
                Diagnostics.An_export_declaration_cannot_have_modifiers.code,
                Diagnostics.An_import_declaration_can_only_be_used_at_the_top_level_of_a_module.code,
                Diagnostics.An_import_declaration_cannot_have_modifiers.code,
                Diagnostics.An_object_member_cannot_be_declared_optional.code,
                Diagnostics.Argument_of_dynamic_import_cannot_be_spread_element.code,
                Diagnostics.Cannot_assign_to_private_method_0_Private_methods_are_not_writable.code,
                Diagnostics.Cannot_redeclare_identifier_0_in_catch_clause.code,
                Diagnostics.Catch_clause_variable_cannot_have_an_initializer.code,
                Diagnostics.Class_decorators_can_t_be_used_with_static_private_identifier_Consider_removing_the_experimental_decorator.code,
                Diagnostics.Classes_can_only_extend_a_single_class.code,
                Diagnostics.Classes_may_not_have_a_field_named_constructor.code,
                Diagnostics.Did_you_mean_to_use_a_Colon_An_can_only_follow_a_property_name_when_the_containing_object_literal_is_part_of_a_destructuring_pattern.code,
                Diagnostics.Duplicate_label_0.code,
                Diagnostics.Dynamic_imports_can_only_accept_a_module_specifier_and_an_optional_assertion_as_arguments.code,
                Diagnostics.For_await_loops_cannot_be_used_inside_a_class_static_block.code,
                Diagnostics.JSX_attributes_must_only_be_assigned_a_non_empty_expression.code,
                Diagnostics.JSX_elements_cannot_have_multiple_attributes_with_the_same_name.code,
                Diagnostics.JSX_expressions_may_not_use_the_comma_operator_Did_you_mean_to_write_an_array.code,
                Diagnostics.JSX_property_access_expressions_cannot_include_JSX_namespace_names.code,
                Diagnostics.Jump_target_cannot_cross_function_boundary.code,
                Diagnostics.Line_terminator_not_permitted_before_arrow.code,
                Diagnostics.Modifiers_cannot_appear_here.code,
                Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement.code,
                Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement.code,
                Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies.code,
                Diagnostics.Private_identifiers_are_only_allowed_in_class_bodies_and_may_only_be_used_as_part_of_a_class_member_declaration_property_access_or_on_the_left_hand_side_of_an_in_expression.code,
                Diagnostics.Property_0_is_not_accessible_outside_class_1_because_it_has_a_private_identifier.code,
                Diagnostics.Tagged_template_expressions_are_not_permitted_in_an_optional_chain.code,
                Diagnostics.The_left_hand_side_of_a_for_of_statement_may_not_be_async.code,
                Diagnostics.The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer.code,
                Diagnostics.The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer.code,
                Diagnostics.Trailing_comma_not_allowed.code,
                Diagnostics.Variable_declaration_list_cannot_be_empty.code,
                Diagnostics._0_and_1_operations_cannot_be_mixed_without_parentheses.code,
                Diagnostics._0_expected.code,
                Diagnostics._0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2.code,
                Diagnostics._0_list_cannot_be_empty.code,
                Diagnostics._0_modifier_already_seen.code,
                Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration.code,
                Diagnostics._0_modifier_cannot_appear_on_a_module_or_namespace_element.code,
                Diagnostics._0_modifier_cannot_appear_on_a_parameter.code,
                Diagnostics._0_modifier_cannot_appear_on_class_elements_of_this_kind.code,
                Diagnostics._0_modifier_cannot_be_used_here.code,
                Diagnostics._0_modifier_must_precede_1_modifier.code,
                Diagnostics.const_declarations_can_only_be_declared_inside_a_block.code,
                Diagnostics.const_declarations_must_be_initialized.code,
                Diagnostics.extends_clause_already_seen.code,
                Diagnostics.let_declarations_can_only_be_declared_inside_a_block.code,
                Diagnostics.let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations.code,
                Diagnostics.Class_constructor_may_not_be_a_generator.code,
                Diagnostics.Class_constructor_may_not_be_an_accessor.code,
                Diagnostics.await_expressions_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules.code
            ]);
            emitSkippedWithNoDiagnostics = {
                diagnostics: emptyArray,
                sourceMaps: void 0,
                emittedFiles: void 0,
                emitSkipped: true
            };
        }
    });
    // src/compiler/builderStatePublic.ts
    var init_builderStatePublic = __esm({
        "src/compiler/builderStatePublic.ts" () {
            "use strict";
        }
    });
    // src/compiler/builderState.ts
    function getFileEmitOutput(program, sourceFile, emitOnlyDtsFiles, cancellationToken, customTransformers, forceDtsEmit) {
        const outputFiles = [];
        const { emitSkipped: emitSkipped , diagnostics: diagnostics  } = program.emit(sourceFile, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers, forceDtsEmit);
        return {
            outputFiles: outputFiles,
            emitSkipped: emitSkipped,
            diagnostics: diagnostics
        };
        function writeFile2(fileName, text, writeByteOrderMark) {
            outputFiles.push({
                name: fileName,
                writeByteOrderMark: writeByteOrderMark,
                text: text
            });
        }
    }
    var BuilderState;
    var init_builderState = __esm({
        "src/compiler/builderState.ts" () {
            "use strict";
            init_ts2();
            ((BuilderState2)=>{
                function createManyToManyPathMap() {
                    function create2(forward, reverse, deleted) {
                        const map2 = {
                            getKeys: (v)=>reverse.get(v),
                            getValues: (k)=>forward.get(k),
                            keys: ()=>forward.keys(),
                            deleteKey: (k)=>{
                                (deleted || (deleted = /* @__PURE__ */ new Set())).add(k);
                                const set = forward.get(k);
                                if (!set) return false;
                                set.forEach((v)=>deleteFromMultimap(reverse, v, k));
                                forward.delete(k);
                                return true;
                            },
                            set: (k, vSet)=>{
                                deleted == null || deleted.delete(k);
                                const existingVSet = forward.get(k);
                                forward.set(k, vSet);
                                existingVSet == null || existingVSet.forEach((v)=>{
                                    if (!vSet.has(v)) deleteFromMultimap(reverse, v, k);
                                });
                                vSet.forEach((v)=>{
                                    if (!(existingVSet == null ? void 0 : existingVSet.has(v))) addToMultimap(reverse, v, k);
                                });
                                return map2;
                            }
                        };
                        return map2;
                    }
                    return create2(/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map(), /*deleted*/ void 0);
                }
                BuilderState2.createManyToManyPathMap = createManyToManyPathMap;
                function addToMultimap(map2, k, v) {
                    let set = map2.get(k);
                    if (!set) {
                        set = /* @__PURE__ */ new Set();
                        map2.set(k, set);
                    }
                    set.add(v);
                }
                function deleteFromMultimap(map2, k, v) {
                    const set = map2.get(k);
                    if (set == null ? void 0 : set.delete(v)) {
                        if (!set.size) map2.delete(k);
                        return true;
                    }
                    return false;
                }
                function getReferencedFilesFromImportedModuleSymbol(symbol) {
                    return mapDefined(symbol.declarations, (declaration)=>{
                        var _a;
                        return (_a = getSourceFileOfNode(declaration)) == null ? void 0 : _a.resolvedPath;
                    });
                }
                function getReferencedFilesFromImportLiteral(checker, importName) {
                    const symbol = checker.getSymbolAtLocation(importName);
                    return symbol && getReferencedFilesFromImportedModuleSymbol(symbol);
                }
                function getReferencedFileFromFileName(program, fileName, sourceFileDirectory, getCanonicalFileName) {
                    return toPath(program.getProjectReferenceRedirect(fileName) || fileName, sourceFileDirectory, getCanonicalFileName);
                }
                function getReferencedFiles(program, sourceFile, getCanonicalFileName) {
                    let referencedFiles;
                    if (sourceFile.imports && sourceFile.imports.length > 0) {
                        const checker = program.getTypeChecker();
                        for (const importName of sourceFile.imports){
                            const declarationSourceFilePaths = getReferencedFilesFromImportLiteral(checker, importName);
                            declarationSourceFilePaths == null || declarationSourceFilePaths.forEach(addReferencedFile);
                        }
                    }
                    const sourceFileDirectory = getDirectoryPath(sourceFile.resolvedPath);
                    if (sourceFile.referencedFiles && sourceFile.referencedFiles.length > 0) for (const referencedFile of sourceFile.referencedFiles){
                        const referencedPath = getReferencedFileFromFileName(program, referencedFile.fileName, sourceFileDirectory, getCanonicalFileName);
                        addReferencedFile(referencedPath);
                    }
                    if (sourceFile.resolvedTypeReferenceDirectiveNames) sourceFile.resolvedTypeReferenceDirectiveNames.forEach(({ resolvedTypeReferenceDirective: resolvedTypeReferenceDirective  })=>{
                        if (!resolvedTypeReferenceDirective) return;
                        const fileName = resolvedTypeReferenceDirective.resolvedFileName;
                        const typeFilePath = getReferencedFileFromFileName(program, fileName, sourceFileDirectory, getCanonicalFileName);
                        addReferencedFile(typeFilePath);
                    });
                    if (sourceFile.moduleAugmentations.length) {
                        const checker = program.getTypeChecker();
                        for (const moduleName of sourceFile.moduleAugmentations){
                            if (!isStringLiteral(moduleName)) continue;
                            const symbol = checker.getSymbolAtLocation(moduleName);
                            if (!symbol) continue;
                            addReferenceFromAmbientModule(symbol);
                        }
                    }
                    for (const ambientModule of program.getTypeChecker().getAmbientModules())if (ambientModule.declarations && ambientModule.declarations.length > 1) addReferenceFromAmbientModule(ambientModule);
                    return referencedFiles;
                    function addReferenceFromAmbientModule(symbol) {
                        if (!symbol.declarations) return;
                        for (const declaration of symbol.declarations){
                            const declarationSourceFile = getSourceFileOfNode(declaration);
                            if (declarationSourceFile && declarationSourceFile !== sourceFile) addReferencedFile(declarationSourceFile.resolvedPath);
                        }
                    }
                    function addReferencedFile(referencedPath) {
                        (referencedFiles || (referencedFiles = /* @__PURE__ */ new Set())).add(referencedPath);
                    }
                }
                function canReuseOldState(newReferencedMap, oldState) {
                    return oldState && !oldState.referencedMap === !newReferencedMap;
                }
                BuilderState2.canReuseOldState = canReuseOldState;
                function create(newProgram, oldState, disableUseFileVersionAsSignature) {
                    var _a, _b, _c;
                    const fileInfos = /* @__PURE__ */ new Map();
                    const options = newProgram.getCompilerOptions();
                    const isOutFile = outFile(options);
                    const referencedMap = options.module !== 0 /* None */  && !isOutFile ? createManyToManyPathMap() : void 0;
                    const exportedModulesMap = referencedMap ? createManyToManyPathMap() : void 0;
                    const useOldState = canReuseOldState(referencedMap, oldState);
                    newProgram.getTypeChecker();
                    for (const sourceFile of newProgram.getSourceFiles()){
                        const version2 = Debug.checkDefined(sourceFile.version, "Program intended to be used with Builder should have source files with versions set");
                        const oldUncommittedSignature = useOldState ? (_a = oldState.oldSignatures) == null ? void 0 : _a.get(sourceFile.resolvedPath) : void 0;
                        const signature = oldUncommittedSignature === void 0 ? useOldState ? (_b = oldState.fileInfos.get(sourceFile.resolvedPath)) == null ? void 0 : _b.signature : void 0 : oldUncommittedSignature || void 0;
                        if (referencedMap) {
                            const newReferences = getReferencedFiles(newProgram, sourceFile, newProgram.getCanonicalFileName);
                            if (newReferences) referencedMap.set(sourceFile.resolvedPath, newReferences);
                            if (useOldState) {
                                const oldUncommittedExportedModules = (_c = oldState.oldExportedModulesMap) == null ? void 0 : _c.get(sourceFile.resolvedPath);
                                const exportedModules = oldUncommittedExportedModules === void 0 ? oldState.exportedModulesMap.getValues(sourceFile.resolvedPath) : oldUncommittedExportedModules || void 0;
                                if (exportedModules) exportedModulesMap.set(sourceFile.resolvedPath, exportedModules);
                            }
                        }
                        fileInfos.set(sourceFile.resolvedPath, {
                            version: version2,
                            signature: signature,
                            // No need to calculate affectsGlobalScope with --out since its not used at all
                            affectsGlobalScope: !isOutFile ? isFileAffectingGlobalScope(sourceFile) || void 0 : void 0,
                            impliedFormat: sourceFile.impliedNodeFormat
                        });
                    }
                    return {
                        fileInfos: fileInfos,
                        referencedMap: referencedMap,
                        exportedModulesMap: exportedModulesMap,
                        useFileVersionAsSignature: !disableUseFileVersionAsSignature && !useOldState
                    };
                }
                BuilderState2.create = create;
                function releaseCache2(state) {
                    state.allFilesExcludingDefaultLibraryFile = void 0;
                    state.allFileNames = void 0;
                }
                BuilderState2.releaseCache = releaseCache2;
                function getFilesAffectedBy(state, programOfThisState, path, cancellationToken, host) {
                    var _a, _b;
                    const result = getFilesAffectedByWithOldState(state, programOfThisState, path, cancellationToken, host);
                    (_a = state.oldSignatures) == null || _a.clear();
                    (_b = state.oldExportedModulesMap) == null || _b.clear();
                    return result;
                }
                BuilderState2.getFilesAffectedBy = getFilesAffectedBy;
                function getFilesAffectedByWithOldState(state, programOfThisState, path, cancellationToken, host) {
                    const sourceFile = programOfThisState.getSourceFileByPath(path);
                    if (!sourceFile) return emptyArray;
                    if (!updateShapeSignature(state, programOfThisState, sourceFile, cancellationToken, host)) return [
                        sourceFile
                    ];
                    return (state.referencedMap ? getFilesAffectedByUpdatedShapeWhenModuleEmit : getFilesAffectedByUpdatedShapeWhenNonModuleEmit)(state, programOfThisState, sourceFile, cancellationToken, host);
                }
                BuilderState2.getFilesAffectedByWithOldState = getFilesAffectedByWithOldState;
                function updateSignatureOfFile(state, signature, path) {
                    state.fileInfos.get(path).signature = signature;
                    (state.hasCalledUpdateShapeSignature || (state.hasCalledUpdateShapeSignature = /* @__PURE__ */ new Set())).add(path);
                }
                BuilderState2.updateSignatureOfFile = updateSignatureOfFile;
                function computeDtsSignature(programOfThisState, sourceFile, cancellationToken, host, onNewSignature) {
                    programOfThisState.emit(sourceFile, (fileName, text, _writeByteOrderMark, _onError, sourceFiles, data)=>{
                        Debug.assert(isDeclarationFileName(fileName), `File extension for signature expected to be dts: Got:: ${fileName}`);
                        onNewSignature(computeSignatureWithDiagnostics(programOfThisState, sourceFile, text, host, data), sourceFiles);
                    }, cancellationToken, /*emitOnly*/ true, /*customTransformers*/ void 0, /*forceDtsEmit*/ true);
                }
                BuilderState2.computeDtsSignature = computeDtsSignature;
                function updateShapeSignature(state, programOfThisState, sourceFile, cancellationToken, host, useFileVersionAsSignature = state.useFileVersionAsSignature) {
                    var _a;
                    if ((_a = state.hasCalledUpdateShapeSignature) == null ? void 0 : _a.has(sourceFile.resolvedPath)) return false;
                    const info = state.fileInfos.get(sourceFile.resolvedPath);
                    const prevSignature = info.signature;
                    let latestSignature;
                    if (!sourceFile.isDeclarationFile && !useFileVersionAsSignature) computeDtsSignature(programOfThisState, sourceFile, cancellationToken, host, (signature, sourceFiles)=>{
                        latestSignature = signature;
                        if (latestSignature !== prevSignature) updateExportedModules(state, sourceFile, sourceFiles[0].exportedModulesFromDeclarationEmit);
                    });
                    if (latestSignature === void 0) {
                        latestSignature = sourceFile.version;
                        if (state.exportedModulesMap && latestSignature !== prevSignature) {
                            (state.oldExportedModulesMap || (state.oldExportedModulesMap = /* @__PURE__ */ new Map())).set(sourceFile.resolvedPath, state.exportedModulesMap.getValues(sourceFile.resolvedPath) || false);
                            const references = state.referencedMap ? state.referencedMap.getValues(sourceFile.resolvedPath) : void 0;
                            if (references) state.exportedModulesMap.set(sourceFile.resolvedPath, references);
                            else state.exportedModulesMap.deleteKey(sourceFile.resolvedPath);
                        }
                    }
                    (state.oldSignatures || (state.oldSignatures = /* @__PURE__ */ new Map())).set(sourceFile.resolvedPath, prevSignature || false);
                    (state.hasCalledUpdateShapeSignature || (state.hasCalledUpdateShapeSignature = /* @__PURE__ */ new Set())).add(sourceFile.resolvedPath);
                    info.signature = latestSignature;
                    return latestSignature !== prevSignature;
                }
                BuilderState2.updateShapeSignature = updateShapeSignature;
                function updateExportedModules(state, sourceFile, exportedModulesFromDeclarationEmit) {
                    if (!state.exportedModulesMap) return;
                    (state.oldExportedModulesMap || (state.oldExportedModulesMap = /* @__PURE__ */ new Map())).set(sourceFile.resolvedPath, state.exportedModulesMap.getValues(sourceFile.resolvedPath) || false);
                    const exportedModules = getExportedModules(exportedModulesFromDeclarationEmit);
                    if (exportedModules) state.exportedModulesMap.set(sourceFile.resolvedPath, exportedModules);
                    else state.exportedModulesMap.deleteKey(sourceFile.resolvedPath);
                }
                BuilderState2.updateExportedModules = updateExportedModules;
                function getExportedModules(exportedModulesFromDeclarationEmit) {
                    let exportedModules;
                    exportedModulesFromDeclarationEmit == null || exportedModulesFromDeclarationEmit.forEach((symbol)=>getReferencedFilesFromImportedModuleSymbol(symbol).forEach((path)=>(exportedModules ?? (exportedModules = /* @__PURE__ */ new Set())).add(path)));
                    return exportedModules;
                }
                BuilderState2.getExportedModules = getExportedModules;
                function getAllDependencies(state, programOfThisState, sourceFile) {
                    const compilerOptions = programOfThisState.getCompilerOptions();
                    if (outFile(compilerOptions)) return getAllFileNames(state, programOfThisState);
                    if (!state.referencedMap || isFileAffectingGlobalScope(sourceFile)) return getAllFileNames(state, programOfThisState);
                    const seenMap = /* @__PURE__ */ new Set();
                    const queue = [
                        sourceFile.resolvedPath
                    ];
                    while(queue.length){
                        const path = queue.pop();
                        if (!seenMap.has(path)) {
                            seenMap.add(path);
                            const references = state.referencedMap.getValues(path);
                            if (references) for (const key of references.keys())queue.push(key);
                        }
                    }
                    return arrayFrom(mapDefinedIterator(seenMap.keys(), (path)=>{
                        var _a;
                        return ((_a = programOfThisState.getSourceFileByPath(path)) == null ? void 0 : _a.fileName) ?? path;
                    }));
                }
                BuilderState2.getAllDependencies = getAllDependencies;
                function getAllFileNames(state, programOfThisState) {
                    if (!state.allFileNames) {
                        const sourceFiles = programOfThisState.getSourceFiles();
                        state.allFileNames = sourceFiles === emptyArray ? emptyArray : sourceFiles.map((file)=>file.fileName);
                    }
                    return state.allFileNames;
                }
                function getReferencedByPaths(state, referencedFilePath) {
                    const keys = state.referencedMap.getKeys(referencedFilePath);
                    return keys ? arrayFrom(keys.keys()) : [];
                }
                BuilderState2.getReferencedByPaths = getReferencedByPaths;
                function containsOnlyAmbientModules(sourceFile) {
                    for (const statement of sourceFile.statements){
                        if (!isModuleWithStringLiteralName(statement)) return false;
                    }
                    return true;
                }
                function containsGlobalScopeAugmentation(sourceFile) {
                    return some(sourceFile.moduleAugmentations, (augmentation)=>isGlobalScopeAugmentation(augmentation.parent));
                }
                function isFileAffectingGlobalScope(sourceFile) {
                    return containsGlobalScopeAugmentation(sourceFile) || !isExternalOrCommonJsModule(sourceFile) && !isJsonSourceFile(sourceFile) && !containsOnlyAmbientModules(sourceFile);
                }
                function getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, firstSourceFile) {
                    if (state.allFilesExcludingDefaultLibraryFile) return state.allFilesExcludingDefaultLibraryFile;
                    let result;
                    if (firstSourceFile) addSourceFile(firstSourceFile);
                    for (const sourceFile of programOfThisState.getSourceFiles())if (sourceFile !== firstSourceFile) addSourceFile(sourceFile);
                    state.allFilesExcludingDefaultLibraryFile = result || emptyArray;
                    return state.allFilesExcludingDefaultLibraryFile;
                    function addSourceFile(sourceFile) {
                        if (!programOfThisState.isSourceFileDefaultLibrary(sourceFile)) (result || (result = [])).push(sourceFile);
                    }
                }
                BuilderState2.getAllFilesExcludingDefaultLibraryFile = getAllFilesExcludingDefaultLibraryFile;
                function getFilesAffectedByUpdatedShapeWhenNonModuleEmit(state, programOfThisState, sourceFileWithUpdatedShape) {
                    const compilerOptions = programOfThisState.getCompilerOptions();
                    if (compilerOptions && outFile(compilerOptions)) return [
                        sourceFileWithUpdatedShape
                    ];
                    return getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, sourceFileWithUpdatedShape);
                }
                function getFilesAffectedByUpdatedShapeWhenModuleEmit(state, programOfThisState, sourceFileWithUpdatedShape, cancellationToken, host) {
                    if (isFileAffectingGlobalScope(sourceFileWithUpdatedShape)) return getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, sourceFileWithUpdatedShape);
                    const compilerOptions = programOfThisState.getCompilerOptions();
                    if (compilerOptions && (getIsolatedModules(compilerOptions) || outFile(compilerOptions))) return [
                        sourceFileWithUpdatedShape
                    ];
                    const seenFileNamesMap = /* @__PURE__ */ new Map();
                    seenFileNamesMap.set(sourceFileWithUpdatedShape.resolvedPath, sourceFileWithUpdatedShape);
                    const queue = getReferencedByPaths(state, sourceFileWithUpdatedShape.resolvedPath);
                    while(queue.length > 0){
                        const currentPath = queue.pop();
                        if (!seenFileNamesMap.has(currentPath)) {
                            const currentSourceFile = programOfThisState.getSourceFileByPath(currentPath);
                            seenFileNamesMap.set(currentPath, currentSourceFile);
                            if (currentSourceFile && updateShapeSignature(state, programOfThisState, currentSourceFile, cancellationToken, host)) queue.push(...getReferencedByPaths(state, currentSourceFile.resolvedPath));
                        }
                    }
                    return arrayFrom(mapDefinedIterator(seenFileNamesMap.values(), (value1)=>value1));
                }
            })(BuilderState || (BuilderState = {}));
        }
    });
    // src/compiler/builder.ts
    function getBuilderFileEmit(options) {
        let result = 1 /* Js */ ;
        if (options.sourceMap) result = result | 2 /* JsMap */ ;
        if (options.inlineSourceMap) result = result | 4 /* JsInlineMap */ ;
        if (getEmitDeclarations(options)) result = result | 8 /* Dts */ ;
        if (options.declarationMap) result = result | 16 /* DtsMap */ ;
        if (options.emitDeclarationOnly) result = result & 24 /* AllDts */ ;
        return result;
    }
    function getPendingEmitKind(optionsOrEmitKind, oldOptionsOrEmitKind) {
        const oldEmitKind = oldOptionsOrEmitKind && (isNumber(oldOptionsOrEmitKind) ? oldOptionsOrEmitKind : getBuilderFileEmit(oldOptionsOrEmitKind));
        const emitKind = isNumber(optionsOrEmitKind) ? optionsOrEmitKind : getBuilderFileEmit(optionsOrEmitKind);
        if (oldEmitKind === emitKind) return 0 /* None */ ;
        if (!oldEmitKind || !emitKind) return emitKind;
        const diff = oldEmitKind ^ emitKind;
        let result = 0 /* None */ ;
        if (diff & 7 /* AllJs */ ) result = emitKind & 7 /* AllJs */ ;
        if (diff & 24 /* AllDts */ ) result = result | emitKind & 24 /* AllDts */ ;
        return result;
    }
    function hasSameKeys(map1, map2) {
        return map1 === map2 || map1 !== void 0 && map2 !== void 0 && map1.size === map2.size && !forEachKey(map1, (key)=>!map2.has(key));
    }
    function createBuilderProgramState(newProgram, oldState) {
        var _a, _b;
        const state = BuilderState.create(newProgram, oldState, /*disableUseFileVersionAsSignature*/ false);
        state.program = newProgram;
        const compilerOptions = newProgram.getCompilerOptions();
        state.compilerOptions = compilerOptions;
        const outFilePath = outFile(compilerOptions);
        if (!outFilePath) state.semanticDiagnosticsPerFile = /* @__PURE__ */ new Map();
        else if (compilerOptions.composite && (oldState == null ? void 0 : oldState.outSignature) && outFilePath === outFile(oldState == null ? void 0 : oldState.compilerOptions)) state.outSignature = oldState.outSignature && getEmitSignatureFromOldSignature(compilerOptions, oldState.compilerOptions, oldState.outSignature);
        state.changedFilesSet = /* @__PURE__ */ new Set();
        state.latestChangedDtsFile = compilerOptions.composite ? oldState == null ? void 0 : oldState.latestChangedDtsFile : void 0;
        const useOldState = BuilderState.canReuseOldState(state.referencedMap, oldState);
        const oldCompilerOptions = useOldState ? oldState.compilerOptions : void 0;
        const canCopySemanticDiagnostics = useOldState && oldState.semanticDiagnosticsPerFile && !!state.semanticDiagnosticsPerFile && !compilerOptionsAffectSemanticDiagnostics(compilerOptions, oldCompilerOptions);
        const canCopyEmitSignatures = compilerOptions.composite && (oldState == null ? void 0 : oldState.emitSignatures) && !outFilePath && !compilerOptionsAffectDeclarationPath(compilerOptions, oldState.compilerOptions);
        if (useOldState) {
            (_a = oldState.changedFilesSet) == null || _a.forEach((value1)=>state.changedFilesSet.add(value1));
            if (!outFilePath && ((_b = oldState.affectedFilesPendingEmit) == null ? void 0 : _b.size)) {
                state.affectedFilesPendingEmit = new Map(oldState.affectedFilesPendingEmit);
                state.seenAffectedFiles = /* @__PURE__ */ new Set();
            }
            state.programEmitPending = oldState.programEmitPending;
        } else state.buildInfoEmitPending = true;
        const referencedMap = state.referencedMap;
        const oldReferencedMap = useOldState ? oldState.referencedMap : void 0;
        const copyDeclarationFileDiagnostics = canCopySemanticDiagnostics && !compilerOptions.skipLibCheck === !oldCompilerOptions.skipLibCheck;
        const copyLibFileDiagnostics = copyDeclarationFileDiagnostics && !compilerOptions.skipDefaultLibCheck === !oldCompilerOptions.skipDefaultLibCheck;
        state.fileInfos.forEach((info, sourceFilePath)=>{
            let oldInfo;
            let newReferences;
            if (!useOldState || // File wasn't present in old state
            !(oldInfo = oldState.fileInfos.get(sourceFilePath)) || // versions dont match
            oldInfo.version !== info.version || // Implied formats dont match
            oldInfo.impliedFormat !== info.impliedFormat || // Referenced files changed
            !hasSameKeys(newReferences = referencedMap && referencedMap.getValues(sourceFilePath), oldReferencedMap && oldReferencedMap.getValues(sourceFilePath)) || // Referenced file was deleted in the new program
            newReferences && forEachKey(newReferences, (path)=>!state.fileInfos.has(path) && oldState.fileInfos.has(path))) addFileToChangeSet(state, sourceFilePath);
            else if (canCopySemanticDiagnostics) {
                const sourceFile = newProgram.getSourceFileByPath(sourceFilePath);
                if (sourceFile.isDeclarationFile && !copyDeclarationFileDiagnostics) return;
                if (sourceFile.hasNoDefaultLib && !copyLibFileDiagnostics) return;
                const diagnostics = oldState.semanticDiagnosticsPerFile.get(sourceFilePath);
                if (diagnostics) {
                    state.semanticDiagnosticsPerFile.set(sourceFilePath, oldState.hasReusableDiagnostic ? convertToDiagnostics(diagnostics, newProgram) : repopulateDiagnostics(diagnostics, newProgram));
                    if (!state.semanticDiagnosticsFromOldState) state.semanticDiagnosticsFromOldState = /* @__PURE__ */ new Set();
                    state.semanticDiagnosticsFromOldState.add(sourceFilePath);
                }
            }
            if (canCopyEmitSignatures) {
                const oldEmitSignature = oldState.emitSignatures.get(sourceFilePath);
                if (oldEmitSignature) (state.emitSignatures ?? (state.emitSignatures = /* @__PURE__ */ new Map())).set(sourceFilePath, getEmitSignatureFromOldSignature(compilerOptions, oldState.compilerOptions, oldEmitSignature));
            }
        });
        if (useOldState && forEachEntry(oldState.fileInfos, (info, sourceFilePath)=>{
            if (state.fileInfos.has(sourceFilePath)) return false;
            if (outFilePath || info.affectsGlobalScope) return true;
            state.buildInfoEmitPending = true;
            return false;
        })) BuilderState.getAllFilesExcludingDefaultLibraryFile(state, newProgram, /*firstSourceFile*/ void 0).forEach((file)=>addFileToChangeSet(state, file.resolvedPath));
        else if (oldCompilerOptions) {
            const pendingEmitKind = compilerOptionsAffectEmit(compilerOptions, oldCompilerOptions) ? getBuilderFileEmit(compilerOptions) : getPendingEmitKind(compilerOptions, oldCompilerOptions);
            if (pendingEmitKind !== 0 /* None */ ) {
                if (!outFilePath) {
                    newProgram.getSourceFiles().forEach((f)=>{
                        if (!state.changedFilesSet.has(f.resolvedPath)) addToAffectedFilesPendingEmit(state, f.resolvedPath, pendingEmitKind);
                    });
                    Debug.assert(!state.seenAffectedFiles || !state.seenAffectedFiles.size);
                    state.seenAffectedFiles = state.seenAffectedFiles || /* @__PURE__ */ new Set();
                    state.buildInfoEmitPending = true;
                } else state.programEmitPending = state.programEmitPending ? state.programEmitPending | pendingEmitKind : pendingEmitKind;
            }
        }
        if (outFilePath && !state.changedFilesSet.size) {
            if (useOldState) state.bundle = oldState.bundle;
            if (some(newProgram.getProjectReferences(), (ref)=>!!ref.prepend)) state.programEmitPending = getBuilderFileEmit(compilerOptions);
        }
        return state;
    }
    function addFileToChangeSet(state, path) {
        state.changedFilesSet.add(path);
        state.buildInfoEmitPending = true;
        state.programEmitPending = void 0;
    }
    function getEmitSignatureFromOldSignature(options, oldOptions, oldEmitSignature) {
        return !!options.declarationMap === !!oldOptions.declarationMap ? // Use same format of signature
        oldEmitSignature : // Convert to different format
        isString(oldEmitSignature) ? [
            oldEmitSignature
        ] : oldEmitSignature[0];
    }
    function repopulateDiagnostics(diagnostics, newProgram) {
        if (!diagnostics.length) return diagnostics;
        return sameMap(diagnostics, (diag2)=>{
            if (isString(diag2.messageText)) return diag2;
            const repopulatedChain = convertOrRepopulateDiagnosticMessageChain(diag2.messageText, diag2.file, newProgram, (chain)=>{
                var _a;
                return (_a = chain.repopulateInfo) == null ? void 0 : _a.call(chain);
            });
            return repopulatedChain === diag2.messageText ? diag2 : {
                ...diag2,
                messageText: repopulatedChain
            };
        });
    }
    function convertOrRepopulateDiagnosticMessageChain(chain, sourceFile, newProgram, repopulateInfo) {
        const info = repopulateInfo(chain);
        if (info) return {
            ...createModuleNotFoundChain(sourceFile, newProgram, info.moduleReference, info.mode, info.packageName || info.moduleReference),
            next: convertOrRepopulateDiagnosticMessageChainArray(chain.next, sourceFile, newProgram, repopulateInfo)
        };
        const next = convertOrRepopulateDiagnosticMessageChainArray(chain.next, sourceFile, newProgram, repopulateInfo);
        return next === chain.next ? chain : {
            ...chain,
            next: next
        };
    }
    function convertOrRepopulateDiagnosticMessageChainArray(array, sourceFile, newProgram, repopulateInfo) {
        return sameMap(array, (chain)=>convertOrRepopulateDiagnosticMessageChain(chain, sourceFile, newProgram, repopulateInfo));
    }
    function convertToDiagnostics(diagnostics, newProgram) {
        if (!diagnostics.length) return emptyArray;
        let buildInfoDirectory;
        return diagnostics.map((diagnostic)=>{
            const result = convertToDiagnosticRelatedInformation(diagnostic, newProgram, toPathInBuildInfoDirectory);
            result.reportsUnnecessary = diagnostic.reportsUnnecessary;
            result.reportsDeprecated = diagnostic.reportDeprecated;
            result.source = diagnostic.source;
            result.skippedOn = diagnostic.skippedOn;
            const { relatedInformation: relatedInformation  } = diagnostic;
            result.relatedInformation = relatedInformation ? relatedInformation.length ? relatedInformation.map((r)=>convertToDiagnosticRelatedInformation(r, newProgram, toPathInBuildInfoDirectory)) : [] : void 0;
            return result;
        });
        function toPathInBuildInfoDirectory(path) {
            buildInfoDirectory ?? (buildInfoDirectory = getDirectoryPath(getNormalizedAbsolutePath(getTsBuildInfoEmitOutputFilePath(newProgram.getCompilerOptions()), newProgram.getCurrentDirectory())));
            return toPath(path, buildInfoDirectory, newProgram.getCanonicalFileName);
        }
    }
    function convertToDiagnosticRelatedInformation(diagnostic, newProgram, toPath3) {
        const { file: file  } = diagnostic;
        const sourceFile = file ? newProgram.getSourceFileByPath(toPath3(file)) : void 0;
        return {
            ...diagnostic,
            file: sourceFile,
            messageText: isString(diagnostic.messageText) ? diagnostic.messageText : convertOrRepopulateDiagnosticMessageChain(diagnostic.messageText, sourceFile, newProgram, (chain)=>chain.info)
        };
    }
    function releaseCache(state) {
        BuilderState.releaseCache(state);
        state.program = void 0;
    }
    function backupBuilderProgramEmitState(state) {
        const outFilePath = outFile(state.compilerOptions);
        Debug.assert(!state.changedFilesSet.size || outFilePath);
        return {
            affectedFilesPendingEmit: state.affectedFilesPendingEmit && new Map(state.affectedFilesPendingEmit),
            seenEmittedFiles: state.seenEmittedFiles && new Map(state.seenEmittedFiles),
            programEmitPending: state.programEmitPending,
            emitSignatures: state.emitSignatures && new Map(state.emitSignatures),
            outSignature: state.outSignature,
            latestChangedDtsFile: state.latestChangedDtsFile,
            hasChangedEmitSignature: state.hasChangedEmitSignature,
            changedFilesSet: outFilePath ? new Set(state.changedFilesSet) : void 0
        };
    }
    function restoreBuilderProgramEmitState(state, savedEmitState) {
        state.affectedFilesPendingEmit = savedEmitState.affectedFilesPendingEmit;
        state.seenEmittedFiles = savedEmitState.seenEmittedFiles;
        state.programEmitPending = savedEmitState.programEmitPending;
        state.emitSignatures = savedEmitState.emitSignatures;
        state.outSignature = savedEmitState.outSignature;
        state.latestChangedDtsFile = savedEmitState.latestChangedDtsFile;
        state.hasChangedEmitSignature = savedEmitState.hasChangedEmitSignature;
        if (savedEmitState.changedFilesSet) state.changedFilesSet = savedEmitState.changedFilesSet;
    }
    function assertSourceFileOkWithoutNextAffectedCall(state, sourceFile) {
        Debug.assert(!sourceFile || !state.affectedFiles || state.affectedFiles[state.affectedFilesIndex - 1] !== sourceFile || !state.semanticDiagnosticsPerFile.has(sourceFile.resolvedPath));
    }
    function getNextAffectedFile(state, cancellationToken, host) {
        var _a, _b;
        while(true){
            const { affectedFiles: affectedFiles  } = state;
            if (affectedFiles) {
                const seenAffectedFiles = state.seenAffectedFiles;
                let affectedFilesIndex = state.affectedFilesIndex;
                while(affectedFilesIndex < affectedFiles.length){
                    const affectedFile = affectedFiles[affectedFilesIndex];
                    if (!seenAffectedFiles.has(affectedFile.resolvedPath)) {
                        state.affectedFilesIndex = affectedFilesIndex;
                        addToAffectedFilesPendingEmit(state, affectedFile.resolvedPath, getBuilderFileEmit(state.compilerOptions));
                        handleDtsMayChangeOfAffectedFile(state, affectedFile, cancellationToken, host);
                        return affectedFile;
                    }
                    affectedFilesIndex++;
                }
                state.changedFilesSet.delete(state.currentChangedFilePath);
                state.currentChangedFilePath = void 0;
                (_a = state.oldSignatures) == null || _a.clear();
                (_b = state.oldExportedModulesMap) == null || _b.clear();
                state.affectedFiles = void 0;
            }
            const nextKey = state.changedFilesSet.keys().next();
            if (nextKey.done) return void 0;
            const program = Debug.checkDefined(state.program);
            const compilerOptions = program.getCompilerOptions();
            if (outFile(compilerOptions)) {
                Debug.assert(!state.semanticDiagnosticsPerFile);
                return program;
            }
            state.affectedFiles = BuilderState.getFilesAffectedByWithOldState(state, program, nextKey.value, cancellationToken, host);
            state.currentChangedFilePath = nextKey.value;
            state.affectedFilesIndex = 0;
            if (!state.seenAffectedFiles) state.seenAffectedFiles = /* @__PURE__ */ new Set();
        }
    }
    function clearAffectedFilesPendingEmit(state, emitOnlyDtsFiles) {
        var _a;
        if (!((_a = state.affectedFilesPendingEmit) == null ? void 0 : _a.size)) return;
        if (!emitOnlyDtsFiles) return state.affectedFilesPendingEmit = void 0;
        state.affectedFilesPendingEmit.forEach((emitKind, path)=>{
            const pending = emitKind & 7 /* AllJs */ ;
            if (!pending) state.affectedFilesPendingEmit.delete(path);
            else state.affectedFilesPendingEmit.set(path, pending);
        });
    }
    function getNextAffectedFilePendingEmit(state, emitOnlyDtsFiles) {
        var _a;
        if (!((_a = state.affectedFilesPendingEmit) == null ? void 0 : _a.size)) return void 0;
        return forEachEntry(state.affectedFilesPendingEmit, (emitKind, path)=>{
            var _a2;
            const affectedFile = state.program.getSourceFileByPath(path);
            if (!affectedFile || !sourceFileMayBeEmitted(affectedFile, state.program)) {
                state.affectedFilesPendingEmit.delete(path);
                return void 0;
            }
            const seenKind = (_a2 = state.seenEmittedFiles) == null ? void 0 : _a2.get(affectedFile.resolvedPath);
            let pendingKind = getPendingEmitKind(emitKind, seenKind);
            if (emitOnlyDtsFiles) pendingKind = pendingKind & 24 /* AllDts */ ;
            if (pendingKind) return {
                affectedFile: affectedFile,
                emitKind: pendingKind
            };
        });
    }
    function removeDiagnosticsOfLibraryFiles(state) {
        if (!state.cleanedDiagnosticsOfLibFiles) {
            state.cleanedDiagnosticsOfLibFiles = true;
            const program = Debug.checkDefined(state.program);
            const options = program.getCompilerOptions();
            forEach(program.getSourceFiles(), (f)=>program.isSourceFileDefaultLibrary(f) && !skipTypeChecking(f, options, program) && removeSemanticDiagnosticsOf(state, f.resolvedPath));
        }
    }
    function handleDtsMayChangeOfAffectedFile(state, affectedFile, cancellationToken, host) {
        removeSemanticDiagnosticsOf(state, affectedFile.resolvedPath);
        if (state.allFilesExcludingDefaultLibraryFile === state.affectedFiles) {
            removeDiagnosticsOfLibraryFiles(state);
            BuilderState.updateShapeSignature(state, Debug.checkDefined(state.program), affectedFile, cancellationToken, host);
            return;
        }
        if (state.compilerOptions.assumeChangesOnlyAffectDirectDependencies) return;
        handleDtsMayChangeOfReferencingExportOfAffectedFile(state, affectedFile, cancellationToken, host);
    }
    function handleDtsMayChangeOf(state, path, cancellationToken, host) {
        removeSemanticDiagnosticsOf(state, path);
        if (!state.changedFilesSet.has(path)) {
            const program = Debug.checkDefined(state.program);
            const sourceFile = program.getSourceFileByPath(path);
            if (sourceFile) {
                BuilderState.updateShapeSignature(state, program, sourceFile, cancellationToken, host, /*useFileVersionAsSignature*/ true);
                if (getEmitDeclarations(state.compilerOptions)) addToAffectedFilesPendingEmit(state, path, state.compilerOptions.declarationMap ? 24 /* AllDts */  : 8 /* Dts */ );
            }
        }
    }
    function removeSemanticDiagnosticsOf(state, path) {
        if (!state.semanticDiagnosticsFromOldState) return true;
        state.semanticDiagnosticsFromOldState.delete(path);
        state.semanticDiagnosticsPerFile.delete(path);
        return !state.semanticDiagnosticsFromOldState.size;
    }
    function isChangedSignature(state, path) {
        const oldSignature = Debug.checkDefined(state.oldSignatures).get(path) || void 0;
        const newSignature = Debug.checkDefined(state.fileInfos.get(path)).signature;
        return newSignature !== oldSignature;
    }
    function handleDtsMayChangeOfGlobalScope(state, filePath, cancellationToken, host) {
        var _a;
        if (!((_a = state.fileInfos.get(filePath)) == null ? void 0 : _a.affectsGlobalScope)) return false;
        BuilderState.getAllFilesExcludingDefaultLibraryFile(state, state.program, /*firstSourceFile*/ void 0).forEach((file)=>handleDtsMayChangeOf(state, file.resolvedPath, cancellationToken, host));
        removeDiagnosticsOfLibraryFiles(state);
        return true;
    }
    function handleDtsMayChangeOfReferencingExportOfAffectedFile(state, affectedFile, cancellationToken, host) {
        var _a;
        if (!state.exportedModulesMap || !state.changedFilesSet.has(affectedFile.resolvedPath)) return;
        if (!isChangedSignature(state, affectedFile.resolvedPath)) return;
        if (getIsolatedModules(state.compilerOptions)) {
            const seenFileNamesMap = /* @__PURE__ */ new Map();
            seenFileNamesMap.set(affectedFile.resolvedPath, true);
            const queue = BuilderState.getReferencedByPaths(state, affectedFile.resolvedPath);
            while(queue.length > 0){
                const currentPath = queue.pop();
                if (!seenFileNamesMap.has(currentPath)) {
                    seenFileNamesMap.set(currentPath, true);
                    if (handleDtsMayChangeOfGlobalScope(state, currentPath, cancellationToken, host)) return;
                    handleDtsMayChangeOf(state, currentPath, cancellationToken, host);
                    if (isChangedSignature(state, currentPath)) {
                        const currentSourceFile = Debug.checkDefined(state.program).getSourceFileByPath(currentPath);
                        queue.push(...BuilderState.getReferencedByPaths(state, currentSourceFile.resolvedPath));
                    }
                }
            }
        }
        const seenFileAndExportsOfFile = /* @__PURE__ */ new Set();
        (_a = state.exportedModulesMap.getKeys(affectedFile.resolvedPath)) == null || _a.forEach((exportedFromPath)=>{
            if (handleDtsMayChangeOfGlobalScope(state, exportedFromPath, cancellationToken, host)) return true;
            const references = state.referencedMap.getKeys(exportedFromPath);
            return references && forEachKey(references, (filePath)=>handleDtsMayChangeOfFileAndExportsOfFile(state, filePath, seenFileAndExportsOfFile, cancellationToken, host));
        });
    }
    function handleDtsMayChangeOfFileAndExportsOfFile(state, filePath, seenFileAndExportsOfFile, cancellationToken, host) {
        var _a, _b;
        if (!tryAddToSet(seenFileAndExportsOfFile, filePath)) return void 0;
        if (handleDtsMayChangeOfGlobalScope(state, filePath, cancellationToken, host)) return true;
        handleDtsMayChangeOf(state, filePath, cancellationToken, host);
        (_a = state.exportedModulesMap.getKeys(filePath)) == null || _a.forEach((exportedFromPath)=>handleDtsMayChangeOfFileAndExportsOfFile(state, exportedFromPath, seenFileAndExportsOfFile, cancellationToken, host));
        (_b = state.referencedMap.getKeys(filePath)) == null || _b.forEach((referencingFilePath)=>!seenFileAndExportsOfFile.has(referencingFilePath) && // Not already removed diagnostic file
            handleDtsMayChangeOf(// Dont add to seen since this is not yet done with the export removal
            state, referencingFilePath, cancellationToken, host));
        return void 0;
    }
    function getSemanticDiagnosticsOfFile(state, sourceFile, cancellationToken) {
        return concatenate(getBinderAndCheckerDiagnosticsOfFile(state, sourceFile, cancellationToken), Debug.checkDefined(state.program).getProgramDiagnostics(sourceFile));
    }
    function getBinderAndCheckerDiagnosticsOfFile(state, sourceFile, cancellationToken) {
        const path = sourceFile.resolvedPath;
        if (state.semanticDiagnosticsPerFile) {
            const cachedDiagnostics = state.semanticDiagnosticsPerFile.get(path);
            if (cachedDiagnostics) return filterSemanticDiagnostics(cachedDiagnostics, state.compilerOptions);
        }
        const diagnostics = Debug.checkDefined(state.program).getBindAndCheckDiagnostics(sourceFile, cancellationToken);
        if (state.semanticDiagnosticsPerFile) state.semanticDiagnosticsPerFile.set(path, diagnostics);
        return filterSemanticDiagnostics(diagnostics, state.compilerOptions);
    }
    function isProgramBundleEmitBuildInfo(info) {
        return !!outFile(info.options || {});
    }
    function getBuildInfo2(state, bundle) {
        var _a, _b, _c;
        const currentDirectory = Debug.checkDefined(state.program).getCurrentDirectory();
        const buildInfoDirectory = getDirectoryPath(getNormalizedAbsolutePath(getTsBuildInfoEmitOutputFilePath(state.compilerOptions), currentDirectory));
        const latestChangedDtsFile = state.latestChangedDtsFile ? relativeToBuildInfoEnsuringAbsolutePath(state.latestChangedDtsFile) : void 0;
        const fileNames = [];
        const fileNameToFileId = /* @__PURE__ */ new Map();
        const root = [];
        if (outFile(state.compilerOptions)) {
            const fileInfos2 = arrayFrom(state.fileInfos.entries(), ([key, value1])=>{
                const fileId = toFileId(key);
                tryAddRoot(key, fileId);
                return value1.impliedFormat ? {
                    version: value1.version,
                    impliedFormat: value1.impliedFormat,
                    signature: void 0,
                    affectsGlobalScope: void 0
                } : value1.version;
            });
            const program2 = {
                fileNames: fileNames,
                fileInfos: fileInfos2,
                root: root,
                options: convertToProgramBuildInfoCompilerOptions(state.compilerOptions),
                outSignature: state.outSignature,
                latestChangedDtsFile: latestChangedDtsFile,
                pendingEmit: !state.programEmitPending ? void 0 : // Pending is undefined or None is encoded as undefined
                state.programEmitPending === getBuilderFileEmit(state.compilerOptions) ? false : // Pending emit is same as deteremined by compilerOptions
                state.programEmitPending
            };
            const { js: js , dts: dts , commonSourceDirectory: commonSourceDirectory , sourceFiles: sourceFiles  } = bundle;
            state.bundle = bundle = {
                commonSourceDirectory: commonSourceDirectory,
                sourceFiles: sourceFiles,
                js: js || (!state.compilerOptions.emitDeclarationOnly ? (_a = state.bundle) == null ? void 0 : _a.js : void 0),
                dts: dts || (getEmitDeclarations(state.compilerOptions) ? (_b = state.bundle) == null ? void 0 : _b.dts : void 0)
            };
            return createBuildInfo(program2, bundle);
        }
        let fileIdsList;
        let fileNamesToFileIdListId;
        let emitSignatures;
        const fileInfos = arrayFrom(state.fileInfos.entries(), ([key, value1])=>{
            var _a2, _b2;
            const fileId = toFileId(key);
            tryAddRoot(key, fileId);
            Debug.assert(fileNames[fileId - 1] === relativeToBuildInfo(key));
            const oldSignature = (_a2 = state.oldSignatures) == null ? void 0 : _a2.get(key);
            const actualSignature = oldSignature !== void 0 ? oldSignature || void 0 : value1.signature;
            if (state.compilerOptions.composite) {
                const file = state.program.getSourceFileByPath(key);
                if (!isJsonSourceFile(file) && sourceFileMayBeEmitted(file, state.program)) {
                    const emitSignature = (_b2 = state.emitSignatures) == null ? void 0 : _b2.get(key);
                    if (emitSignature !== actualSignature) (emitSignatures || (emitSignatures = [])).push(emitSignature === void 0 ? fileId : // There is no emit, encode as false
                    // fileId, signature: emptyArray if signature only differs in dtsMap option than our own compilerOptions otherwise EmitSignature
                    [
                        fileId,
                        !isString(emitSignature) && emitSignature[0] === actualSignature ? emptyArray : emitSignature
                    ]);
                }
            }
            return value1.version === actualSignature ? value1.affectsGlobalScope || value1.impliedFormat ? // If file version is same as signature, dont serialize signature
            {
                version: value1.version,
                signature: void 0,
                affectsGlobalScope: value1.affectsGlobalScope,
                impliedFormat: value1.impliedFormat
            } : // If file info only contains version and signature and both are same we can just write string
            value1.version : actualSignature !== void 0 ? // If signature is not same as version, encode signature in the fileInfo
            oldSignature === void 0 ? // If we havent computed signature, use fileInfo as is
            value1 : // Serialize fileInfo with new updated signature
            {
                version: value1.version,
                signature: actualSignature,
                affectsGlobalScope: value1.affectsGlobalScope,
                impliedFormat: value1.impliedFormat
            } : // Signature of the FileInfo is undefined, serialize it as false
            {
                version: value1.version,
                signature: false,
                affectsGlobalScope: value1.affectsGlobalScope,
                impliedFormat: value1.impliedFormat
            };
        });
        let referencedMap;
        if (state.referencedMap) referencedMap = arrayFrom(state.referencedMap.keys()).sort(compareStringsCaseSensitive).map((key)=>[
                toFileId(key),
                toFileIdListId(state.referencedMap.getValues(key))
            ]);
        let exportedModulesMap;
        if (state.exportedModulesMap) exportedModulesMap = mapDefined(arrayFrom(state.exportedModulesMap.keys()).sort(compareStringsCaseSensitive), (key)=>{
            var _a2;
            const oldValue = (_a2 = state.oldExportedModulesMap) == null ? void 0 : _a2.get(key);
            if (oldValue === void 0) return [
                toFileId(key),
                toFileIdListId(state.exportedModulesMap.getValues(key))
            ];
            if (oldValue) return [
                toFileId(key),
                toFileIdListId(oldValue)
            ];
            return void 0;
        });
        let semanticDiagnosticsPerFile;
        if (state.semanticDiagnosticsPerFile) for (const key of arrayFrom(state.semanticDiagnosticsPerFile.keys()).sort(compareStringsCaseSensitive)){
            const value1 = state.semanticDiagnosticsPerFile.get(key);
            (semanticDiagnosticsPerFile || (semanticDiagnosticsPerFile = [])).push(value1.length ? [
                toFileId(key),
                convertToReusableDiagnostics(value1, relativeToBuildInfo)
            ] : toFileId(key));
        }
        let affectedFilesPendingEmit;
        if ((_c = state.affectedFilesPendingEmit) == null ? void 0 : _c.size) {
            const fullEmitForOptions = getBuilderFileEmit(state.compilerOptions);
            const seenFiles = /* @__PURE__ */ new Set();
            for (const path of arrayFrom(state.affectedFilesPendingEmit.keys()).sort(compareStringsCaseSensitive))if (tryAddToSet(seenFiles, path)) {
                const file = state.program.getSourceFileByPath(path);
                if (!file || !sourceFileMayBeEmitted(file, state.program)) continue;
                const fileId = toFileId(path), pendingEmit = state.affectedFilesPendingEmit.get(path);
                (affectedFilesPendingEmit || (affectedFilesPendingEmit = [])).push(pendingEmit === fullEmitForOptions ? fileId : // Pending full emit per options
                pendingEmit === 8 /* Dts */  ? [
                    fileId
                ] : // Pending on Dts only
                [
                    fileId,
                    pendingEmit
                ]);
            }
        }
        let changeFileSet;
        if (state.changedFilesSet.size) for (const path of arrayFrom(state.changedFilesSet.keys()).sort(compareStringsCaseSensitive))(changeFileSet || (changeFileSet = [])).push(toFileId(path));
        const program = {
            fileNames: fileNames,
            fileInfos: fileInfos,
            root: root,
            options: convertToProgramBuildInfoCompilerOptions(state.compilerOptions),
            fileIdsList: fileIdsList,
            referencedMap: referencedMap,
            exportedModulesMap: exportedModulesMap,
            semanticDiagnosticsPerFile: semanticDiagnosticsPerFile,
            affectedFilesPendingEmit: affectedFilesPendingEmit,
            changeFileSet: changeFileSet,
            emitSignatures: emitSignatures,
            latestChangedDtsFile: latestChangedDtsFile
        };
        return createBuildInfo(program, bundle);
        function relativeToBuildInfoEnsuringAbsolutePath(path) {
            return relativeToBuildInfo(getNormalizedAbsolutePath(path, currentDirectory));
        }
        function relativeToBuildInfo(path) {
            return ensurePathIsNonModuleName(getRelativePathFromDirectory(buildInfoDirectory, path, state.program.getCanonicalFileName));
        }
        function toFileId(path) {
            let fileId = fileNameToFileId.get(path);
            if (fileId === void 0) {
                fileNames.push(relativeToBuildInfo(path));
                fileNameToFileId.set(path, fileId = fileNames.length);
            }
            return fileId;
        }
        function toFileIdListId(set) {
            const fileIds = arrayFrom(set.keys(), toFileId).sort(compareValues);
            const key = fileIds.join();
            let fileIdListId = fileNamesToFileIdListId == null ? void 0 : fileNamesToFileIdListId.get(key);
            if (fileIdListId === void 0) {
                (fileIdsList || (fileIdsList = [])).push(fileIds);
                (fileNamesToFileIdListId || (fileNamesToFileIdListId = /* @__PURE__ */ new Map())).set(key, fileIdListId = fileIdsList.length);
            }
            return fileIdListId;
        }
        function tryAddRoot(path, fileId) {
            const file = state.program.getSourceFile(path);
            if (!state.program.getFileIncludeReasons().get(file.path).some((r)=>r.kind === 0 /* RootFile */ )) return;
            if (!root.length) return root.push(fileId);
            const last2 = root[root.length - 1];
            const isLastStartEnd = isArray(last2);
            if (isLastStartEnd && last2[1] === fileId - 1) return last2[1] = fileId;
            if (isLastStartEnd || root.length === 1 || last2 !== fileId - 1) return root.push(fileId);
            const lastButOne = root[root.length - 2];
            if (!isNumber(lastButOne) || lastButOne !== last2 - 1) return root.push(fileId);
            root[root.length - 2] = [
                lastButOne,
                fileId
            ];
            return root.length = root.length - 1;
        }
        function convertToProgramBuildInfoCompilerOptions(options) {
            let result;
            const { optionsNameMap: optionsNameMap  } = getOptionsNameMap();
            for (const name of getOwnKeys(options).sort(compareStringsCaseSensitive)){
                const optionInfo = optionsNameMap.get(name.toLowerCase());
                if (optionInfo == null ? void 0 : optionInfo.affectsBuildInfo) (result || (result = {}))[name] = convertToReusableCompilerOptionValue(optionInfo, options[name], relativeToBuildInfoEnsuringAbsolutePath);
            }
            return result;
        }
    }
    function convertToReusableCompilerOptionValue(option, value1, relativeToBuildInfo) {
        if (option) {
            Debug.assert(option.type !== "listOrElement");
            if (option.type === "list") {
                const values = value1;
                if (option.element.isFilePath && values.length) return values.map(relativeToBuildInfo);
            } else if (option.isFilePath) return relativeToBuildInfo(value1);
        }
        return value1;
    }
    function convertToReusableDiagnostics(diagnostics, relativeToBuildInfo) {
        Debug.assert(!!diagnostics.length);
        return diagnostics.map((diagnostic)=>{
            const result = convertToReusableDiagnosticRelatedInformation(diagnostic, relativeToBuildInfo);
            result.reportsUnnecessary = diagnostic.reportsUnnecessary;
            result.reportDeprecated = diagnostic.reportsDeprecated;
            result.source = diagnostic.source;
            result.skippedOn = diagnostic.skippedOn;
            const { relatedInformation: relatedInformation  } = diagnostic;
            result.relatedInformation = relatedInformation ? relatedInformation.length ? relatedInformation.map((r)=>convertToReusableDiagnosticRelatedInformation(r, relativeToBuildInfo)) : [] : void 0;
            return result;
        });
    }
    function convertToReusableDiagnosticRelatedInformation(diagnostic, relativeToBuildInfo) {
        const { file: file  } = diagnostic;
        return {
            ...diagnostic,
            file: file ? relativeToBuildInfo(file.resolvedPath) : void 0,
            messageText: isString(diagnostic.messageText) ? diagnostic.messageText : convertToReusableDiagnosticMessageChain(diagnostic.messageText)
        };
    }
    function convertToReusableDiagnosticMessageChain(chain) {
        if (chain.repopulateInfo) return {
            info: chain.repopulateInfo(),
            next: convertToReusableDiagnosticMessageChainArray(chain.next)
        };
        const next = convertToReusableDiagnosticMessageChainArray(chain.next);
        return next === chain.next ? chain : {
            ...chain,
            next: next
        };
    }
    function convertToReusableDiagnosticMessageChainArray(array) {
        if (!array) return array;
        return forEach(array, (chain, index)=>{
            const reusable = convertToReusableDiagnosticMessageChain(chain);
            if (chain === reusable) return void 0;
            const result = index > 0 ? array.slice(0, index - 1) : [];
            result.push(reusable);
            for(let i = index + 1; i < array.length; i++)result.push(convertToReusableDiagnosticMessageChain(array[i]));
            return result;
        }) || array;
    }
    function getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences) {
        let host;
        let newProgram;
        let oldProgram;
        if (newProgramOrRootNames === void 0) {
            Debug.assert(hostOrOptions === void 0);
            host = oldProgramOrHost;
            oldProgram = configFileParsingDiagnosticsOrOldProgram;
            Debug.assert(!!oldProgram);
            newProgram = oldProgram.getProgram();
        } else if (isArray(newProgramOrRootNames)) {
            oldProgram = configFileParsingDiagnosticsOrOldProgram;
            newProgram = createProgram({
                rootNames: newProgramOrRootNames,
                options: hostOrOptions,
                host: oldProgramOrHost,
                oldProgram: oldProgram && oldProgram.getProgramOrUndefined(),
                configFileParsingDiagnostics: configFileParsingDiagnostics,
                projectReferences: projectReferences
            });
            host = oldProgramOrHost;
        } else {
            newProgram = newProgramOrRootNames;
            host = hostOrOptions;
            oldProgram = oldProgramOrHost;
            configFileParsingDiagnostics = configFileParsingDiagnosticsOrOldProgram;
        }
        return {
            host: host,
            newProgram: newProgram,
            oldProgram: oldProgram,
            configFileParsingDiagnostics: configFileParsingDiagnostics || emptyArray
        };
    }
    function getTextHandlingSourceMapForSignature(text, data) {
        return (data == null ? void 0 : data.sourceMapUrlPos) !== void 0 ? text.substring(0, data.sourceMapUrlPos) : text;
    }
    function computeSignatureWithDiagnostics(program, sourceFile, text, host, data) {
        var _a;
        text = getTextHandlingSourceMapForSignature(text, data);
        let sourceFileDirectory;
        if ((_a = data == null ? void 0 : data.diagnostics) == null ? void 0 : _a.length) text += data.diagnostics.map((diagnostic)=>`${locationInfo(diagnostic)}${DiagnosticCategory[diagnostic.category]}${diagnostic.code}: ${flattenDiagnosticMessageText2(diagnostic.messageText)}`).join("\n");
        return (host.createHash ?? generateDjb2Hash)(text);
        function flattenDiagnosticMessageText2(diagnostic) {
            return isString(diagnostic) ? diagnostic : diagnostic === void 0 ? "" : !diagnostic.next ? diagnostic.messageText : diagnostic.messageText + diagnostic.next.map(flattenDiagnosticMessageText2).join("\n");
        }
        function locationInfo(diagnostic) {
            if (diagnostic.file.resolvedPath === sourceFile.resolvedPath) return `(${diagnostic.start},${diagnostic.length})`;
            if (sourceFileDirectory === void 0) sourceFileDirectory = getDirectoryPath(sourceFile.resolvedPath);
            return `${ensurePathIsNonModuleName(getRelativePathFromDirectory(sourceFileDirectory, diagnostic.file.resolvedPath, program.getCanonicalFileName))}(${diagnostic.start},${diagnostic.length})`;
        }
    }
    function computeSignature(text, host, data) {
        return (host.createHash ?? generateDjb2Hash)(getTextHandlingSourceMapForSignature(text, data));
    }
    function createBuilderProgram(kind, { newProgram: newProgram , host: host , oldProgram: oldProgram , configFileParsingDiagnostics: configFileParsingDiagnostics  }) {
        let oldState = oldProgram && oldProgram.getState();
        if (oldState && newProgram === oldState.program && configFileParsingDiagnostics === newProgram.getConfigFileParsingDiagnostics()) {
            newProgram = void 0;
            oldState = void 0;
            return oldProgram;
        }
        const state = createBuilderProgramState(newProgram, oldState);
        newProgram.getBuildInfo = (bundle)=>getBuildInfo2(state, bundle);
        newProgram = void 0;
        oldProgram = void 0;
        oldState = void 0;
        const getState = ()=>state;
        const builderProgram = createRedirectedBuilderProgram(getState, configFileParsingDiagnostics);
        builderProgram.getState = getState;
        builderProgram.saveEmitState = ()=>backupBuilderProgramEmitState(state);
        builderProgram.restoreEmitState = (saved)=>restoreBuilderProgramEmitState(state, saved);
        builderProgram.hasChangedEmitSignature = ()=>!!state.hasChangedEmitSignature;
        builderProgram.getAllDependencies = (sourceFile)=>BuilderState.getAllDependencies(state, Debug.checkDefined(state.program), sourceFile);
        builderProgram.getSemanticDiagnostics = getSemanticDiagnostics;
        builderProgram.emit = emit;
        builderProgram.releaseProgram = ()=>releaseCache(state);
        if (kind === 0 /* SemanticDiagnosticsBuilderProgram */ ) builderProgram.getSemanticDiagnosticsOfNextAffectedFile = getSemanticDiagnosticsOfNextAffectedFile;
        else if (kind === 1 /* EmitAndSemanticDiagnosticsBuilderProgram */ ) {
            builderProgram.getSemanticDiagnosticsOfNextAffectedFile = getSemanticDiagnosticsOfNextAffectedFile;
            builderProgram.emitNextAffectedFile = emitNextAffectedFile;
            builderProgram.emitBuildInfo = emitBuildInfo;
        } else notImplemented();
        return builderProgram;
        function emitBuildInfo(writeFile2, cancellationToken) {
            if (state.buildInfoEmitPending) {
                const result = Debug.checkDefined(state.program).emitBuildInfo(writeFile2 || maybeBind(host, host.writeFile), cancellationToken);
                state.buildInfoEmitPending = false;
                return result;
            }
            return emitSkippedWithNoDiagnostics;
        }
        function emitNextAffectedFile(writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers) {
            var _a, _b, _c;
            let affected = getNextAffectedFile(state, cancellationToken, host);
            const programEmitKind = getBuilderFileEmit(state.compilerOptions);
            let emitKind = emitOnlyDtsFiles ? programEmitKind & 24 /* AllDts */  : programEmitKind;
            if (!affected) {
                if (!outFile(state.compilerOptions)) {
                    const pendingAffectedFile = getNextAffectedFilePendingEmit(state, emitOnlyDtsFiles);
                    if (!pendingAffectedFile) {
                        if (!state.buildInfoEmitPending) return void 0;
                        const affected2 = state.program;
                        const result2 = affected2.emitBuildInfo(writeFile2 || maybeBind(host, host.writeFile), cancellationToken);
                        state.buildInfoEmitPending = false;
                        return {
                            result: result2,
                            affected: affected2
                        };
                    }
                    ({ affectedFile: affected , emitKind: emitKind  } = pendingAffectedFile);
                } else {
                    if (!state.programEmitPending) return void 0;
                    emitKind = state.programEmitPending;
                    if (emitOnlyDtsFiles) emitKind = emitKind & 24 /* AllDts */ ;
                    if (!emitKind) return void 0;
                    affected = state.program;
                }
            }
            let emitOnly;
            if (emitKind & 7 /* AllJs */ ) emitOnly = 0 /* Js */ ;
            if (emitKind & 24 /* AllDts */ ) emitOnly = emitOnly === void 0 ? 1 /* Dts */  : void 0;
            if (affected === state.program) state.programEmitPending = state.changedFilesSet.size ? getPendingEmitKind(programEmitKind, emitKind) : state.programEmitPending ? getPendingEmitKind(state.programEmitPending, emitKind) : void 0;
            const result = state.program.emit(affected === state.program ? void 0 : affected, getWriteFileCallback(writeFile2, customTransformers), cancellationToken, emitOnly, customTransformers);
            if (affected !== state.program) {
                const affectedSourceFile = affected;
                state.seenAffectedFiles.add(affectedSourceFile.resolvedPath);
                if (state.affectedFilesIndex !== void 0) state.affectedFilesIndex++;
                state.buildInfoEmitPending = true;
                const existing = ((_a = state.seenEmittedFiles) == null ? void 0 : _a.get(affectedSourceFile.resolvedPath)) || 0 /* None */ ;
                (state.seenEmittedFiles ?? (state.seenEmittedFiles = /* @__PURE__ */ new Map())).set(affectedSourceFile.resolvedPath, emitKind | existing);
                const existingPending = ((_b = state.affectedFilesPendingEmit) == null ? void 0 : _b.get(affectedSourceFile.resolvedPath)) || programEmitKind;
                const pendingKind = getPendingEmitKind(existingPending, emitKind | existing);
                if (pendingKind) (state.affectedFilesPendingEmit ?? (state.affectedFilesPendingEmit = /* @__PURE__ */ new Map())).set(affectedSourceFile.resolvedPath, pendingKind);
                else (_c = state.affectedFilesPendingEmit) == null || _c.delete(affectedSourceFile.resolvedPath);
            } else state.changedFilesSet.clear();
            return {
                result: result,
                affected: affected
            };
        }
        function getWriteFileCallback(writeFile2, customTransformers) {
            if (!getEmitDeclarations(state.compilerOptions)) return writeFile2 || maybeBind(host, host.writeFile);
            return (fileName, text, writeByteOrderMark, onError, sourceFiles, data)=>{
                var _a, _b, _c, _d;
                if (isDeclarationFileName(fileName)) {
                    if (!outFile(state.compilerOptions)) {
                        Debug.assert((sourceFiles == null ? void 0 : sourceFiles.length) === 1);
                        let emitSignature;
                        if (!customTransformers) {
                            const file = sourceFiles[0];
                            const info = state.fileInfos.get(file.resolvedPath);
                            if (info.signature === file.version) {
                                const signature = computeSignatureWithDiagnostics(state.program, file, text, host, data);
                                if (!((_a = data == null ? void 0 : data.diagnostics) == null ? void 0 : _a.length)) emitSignature = signature;
                                if (signature !== file.version) {
                                    if (host.storeFilesChangingSignatureDuringEmit) (state.filesChangingSignature ?? (state.filesChangingSignature = /* @__PURE__ */ new Set())).add(file.resolvedPath);
                                    if (state.exportedModulesMap) BuilderState.updateExportedModules(state, file, file.exportedModulesFromDeclarationEmit);
                                    if (state.affectedFiles) {
                                        const existing = (_b = state.oldSignatures) == null ? void 0 : _b.get(file.resolvedPath);
                                        if (existing === void 0) (state.oldSignatures ?? (state.oldSignatures = /* @__PURE__ */ new Map())).set(file.resolvedPath, info.signature || false);
                                        info.signature = signature;
                                    } else {
                                        info.signature = signature;
                                        (_c = state.oldExportedModulesMap) == null || _c.clear();
                                    }
                                }
                            }
                        }
                        if (state.compilerOptions.composite) {
                            const filePath = sourceFiles[0].resolvedPath;
                            emitSignature = handleNewSignature((_d = state.emitSignatures) == null ? void 0 : _d.get(filePath), emitSignature);
                            if (!emitSignature) return;
                            (state.emitSignatures ?? (state.emitSignatures = /* @__PURE__ */ new Map())).set(filePath, emitSignature);
                        }
                    } else if (state.compilerOptions.composite) {
                        const newSignature = handleNewSignature(state.outSignature, /*newSignature*/ void 0);
                        if (!newSignature) return;
                        state.outSignature = newSignature;
                    }
                }
                if (writeFile2) writeFile2(fileName, text, writeByteOrderMark, onError, sourceFiles, data);
                else if (host.writeFile) host.writeFile(fileName, text, writeByteOrderMark, onError, sourceFiles, data);
                else state.program.writeFile(fileName, text, writeByteOrderMark, onError, sourceFiles, data);
                function handleNewSignature(oldSignatureFormat, newSignature) {
                    const oldSignature = !oldSignatureFormat || isString(oldSignatureFormat) ? oldSignatureFormat : oldSignatureFormat[0];
                    newSignature ?? (newSignature = computeSignature(text, host, data));
                    if (newSignature === oldSignature) {
                        if (oldSignatureFormat === oldSignature) return void 0;
                        else if (data) data.differsOnlyInMap = true;
                        else data = {
                            differsOnlyInMap: true
                        };
                    } else {
                        state.hasChangedEmitSignature = true;
                        state.latestChangedDtsFile = fileName;
                    }
                    return newSignature;
                }
            };
        }
        function emit(targetSourceFile, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers) {
            if (kind === 1 /* EmitAndSemanticDiagnosticsBuilderProgram */ ) assertSourceFileOkWithoutNextAffectedCall(state, targetSourceFile);
            const result = handleNoEmitOptions(builderProgram, targetSourceFile, writeFile2, cancellationToken);
            if (result) return result;
            if (!targetSourceFile) {
                if (kind === 1 /* EmitAndSemanticDiagnosticsBuilderProgram */ ) {
                    let sourceMaps = [];
                    let emitSkipped = false;
                    let diagnostics;
                    let emittedFiles = [];
                    let affectedEmitResult;
                    while(affectedEmitResult = emitNextAffectedFile(writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers)){
                        emitSkipped = emitSkipped || affectedEmitResult.result.emitSkipped;
                        diagnostics = addRange(diagnostics, affectedEmitResult.result.diagnostics);
                        emittedFiles = addRange(emittedFiles, affectedEmitResult.result.emittedFiles);
                        sourceMaps = addRange(sourceMaps, affectedEmitResult.result.sourceMaps);
                    }
                    return {
                        emitSkipped: emitSkipped,
                        diagnostics: diagnostics || emptyArray,
                        emittedFiles: emittedFiles,
                        sourceMaps: sourceMaps
                    };
                } else clearAffectedFilesPendingEmit(state, emitOnlyDtsFiles);
            }
            return Debug.checkDefined(state.program).emit(targetSourceFile, getWriteFileCallback(writeFile2, customTransformers), cancellationToken, emitOnlyDtsFiles, customTransformers);
        }
        function getSemanticDiagnosticsOfNextAffectedFile(cancellationToken, ignoreSourceFile) {
            while(true){
                const affected = getNextAffectedFile(state, cancellationToken, host);
                let result;
                if (!affected) return void 0;
                else if (affected !== state.program) {
                    const affectedSourceFile = affected;
                    if (!ignoreSourceFile || !ignoreSourceFile(affectedSourceFile)) result = getSemanticDiagnosticsOfFile(state, affectedSourceFile, cancellationToken);
                    state.seenAffectedFiles.add(affectedSourceFile.resolvedPath);
                    state.affectedFilesIndex++;
                    state.buildInfoEmitPending = true;
                    if (!result) continue;
                } else {
                    result = state.program.getSemanticDiagnostics(/*sourceFile*/ void 0, cancellationToken);
                    state.changedFilesSet.clear();
                    state.programEmitPending = getBuilderFileEmit(state.compilerOptions);
                }
                return {
                    result: result,
                    affected: affected
                };
            }
        }
        function getSemanticDiagnostics(sourceFile, cancellationToken) {
            assertSourceFileOkWithoutNextAffectedCall(state, sourceFile);
            const compilerOptions = Debug.checkDefined(state.program).getCompilerOptions();
            if (outFile(compilerOptions)) {
                Debug.assert(!state.semanticDiagnosticsPerFile);
                return Debug.checkDefined(state.program).getSemanticDiagnostics(sourceFile, cancellationToken);
            }
            if (sourceFile) return getSemanticDiagnosticsOfFile(state, sourceFile, cancellationToken);
            while(getSemanticDiagnosticsOfNextAffectedFile(cancellationToken));
            let diagnostics;
            for (const sourceFile2 of Debug.checkDefined(state.program).getSourceFiles())diagnostics = addRange(diagnostics, getSemanticDiagnosticsOfFile(state, sourceFile2, cancellationToken));
            return diagnostics || emptyArray;
        }
    }
    function addToAffectedFilesPendingEmit(state, affectedFilePendingEmit, kind) {
        var _a;
        const existingKind = ((_a = state.affectedFilesPendingEmit) == null ? void 0 : _a.get(affectedFilePendingEmit)) || 0 /* None */ ;
        (state.affectedFilesPendingEmit ?? (state.affectedFilesPendingEmit = /* @__PURE__ */ new Map())).set(affectedFilePendingEmit, existingKind | kind);
    }
    function toBuilderStateFileInfoForMultiEmit(fileInfo) {
        return isString(fileInfo) ? {
            version: fileInfo,
            signature: fileInfo,
            affectsGlobalScope: void 0,
            impliedFormat: void 0
        } : isString(fileInfo.signature) ? fileInfo : {
            version: fileInfo.version,
            signature: fileInfo.signature === false ? void 0 : fileInfo.version,
            affectsGlobalScope: fileInfo.affectsGlobalScope,
            impliedFormat: fileInfo.impliedFormat
        };
    }
    function toBuilderFileEmit(value1, fullEmitForOptions) {
        return isNumber(value1) ? fullEmitForOptions : value1[1] || 8 /* Dts */ ;
    }
    function toProgramEmitPending(value1, options) {
        return !value1 ? getBuilderFileEmit(options || {}) : value1;
    }
    function createBuilderProgramUsingProgramBuildInfo(buildInfo, buildInfoPath, host) {
        var _a, _b, _c, _d;
        const program = buildInfo.program;
        const buildInfoDirectory = getDirectoryPath(getNormalizedAbsolutePath(buildInfoPath, host.getCurrentDirectory()));
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames());
        let state;
        const filePaths = (_a = program.fileNames) == null ? void 0 : _a.map(toPathInBuildInfoDirectory);
        let filePathsSetList;
        const latestChangedDtsFile = program.latestChangedDtsFile ? toAbsolutePath(program.latestChangedDtsFile) : void 0;
        if (isProgramBundleEmitBuildInfo(program)) {
            const fileInfos = /* @__PURE__ */ new Map();
            program.fileInfos.forEach((fileInfo, index)=>{
                const path = toFilePath(index + 1);
                fileInfos.set(path, isString(fileInfo) ? {
                    version: fileInfo,
                    signature: void 0,
                    affectsGlobalScope: void 0,
                    impliedFormat: void 0
                } : fileInfo);
            });
            state = {
                fileInfos: fileInfos,
                compilerOptions: program.options ? convertToOptionsWithAbsolutePaths(program.options, toAbsolutePath) : {},
                latestChangedDtsFile: latestChangedDtsFile,
                outSignature: program.outSignature,
                programEmitPending: program.pendingEmit === void 0 ? void 0 : toProgramEmitPending(program.pendingEmit, program.options),
                bundle: buildInfo.bundle
            };
        } else {
            filePathsSetList = (_b = program.fileIdsList) == null ? void 0 : _b.map((fileIds)=>new Set(fileIds.map(toFilePath)));
            const fileInfos = /* @__PURE__ */ new Map();
            const emitSignatures = ((_c = program.options) == null ? void 0 : _c.composite) && !outFile(program.options) ? /* @__PURE__ */ new Map() : void 0;
            program.fileInfos.forEach((fileInfo, index)=>{
                const path = toFilePath(index + 1);
                const stateFileInfo = toBuilderStateFileInfoForMultiEmit(fileInfo);
                fileInfos.set(path, stateFileInfo);
                if (emitSignatures && stateFileInfo.signature) emitSignatures.set(path, stateFileInfo.signature);
            });
            (_d = program.emitSignatures) == null || _d.forEach((value1)=>{
                if (isNumber(value1)) emitSignatures.delete(toFilePath(value1));
                else {
                    const key = toFilePath(value1[0]);
                    emitSignatures.set(key, !isString(value1[1]) && !value1[1].length ? // File signature is emit signature but differs in map
                    [
                        emitSignatures.get(key)
                    ] : value1[1]);
                }
            });
            const fullEmitForOptions = program.affectedFilesPendingEmit ? getBuilderFileEmit(program.options || {}) : void 0;
            state = {
                fileInfos: fileInfos,
                compilerOptions: program.options ? convertToOptionsWithAbsolutePaths(program.options, toAbsolutePath) : {},
                referencedMap: toManyToManyPathMap(program.referencedMap),
                exportedModulesMap: toManyToManyPathMap(program.exportedModulesMap),
                semanticDiagnosticsPerFile: program.semanticDiagnosticsPerFile && arrayToMap(program.semanticDiagnosticsPerFile, (value1)=>toFilePath(isNumber(value1) ? value1 : value1[0]), (value1)=>isNumber(value1) ? emptyArray : value1[1]),
                hasReusableDiagnostic: true,
                affectedFilesPendingEmit: program.affectedFilesPendingEmit && arrayToMap(program.affectedFilesPendingEmit, (value1)=>toFilePath(isNumber(value1) ? value1 : value1[0]), (value1)=>toBuilderFileEmit(value1, fullEmitForOptions)),
                changedFilesSet: new Set(map(program.changeFileSet, toFilePath)),
                latestChangedDtsFile: latestChangedDtsFile,
                emitSignatures: (emitSignatures == null ? void 0 : emitSignatures.size) ? emitSignatures : void 0
            };
        }
        return {
            getState: ()=>state,
            saveEmitState: noop,
            restoreEmitState: noop,
            getProgram: notImplemented,
            getProgramOrUndefined: returnUndefined,
            releaseProgram: noop,
            getCompilerOptions: ()=>state.compilerOptions,
            getSourceFile: notImplemented,
            getSourceFiles: notImplemented,
            getOptionsDiagnostics: notImplemented,
            getGlobalDiagnostics: notImplemented,
            getConfigFileParsingDiagnostics: notImplemented,
            getSyntacticDiagnostics: notImplemented,
            getDeclarationDiagnostics: notImplemented,
            getSemanticDiagnostics: notImplemented,
            emit: notImplemented,
            getAllDependencies: notImplemented,
            getCurrentDirectory: notImplemented,
            emitNextAffectedFile: notImplemented,
            getSemanticDiagnosticsOfNextAffectedFile: notImplemented,
            emitBuildInfo: notImplemented,
            close: noop,
            hasChangedEmitSignature: returnFalse
        };
        function toPathInBuildInfoDirectory(path) {
            return toPath(path, buildInfoDirectory, getCanonicalFileName);
        }
        function toAbsolutePath(path) {
            return getNormalizedAbsolutePath(path, buildInfoDirectory);
        }
        function toFilePath(fileId) {
            return filePaths[fileId - 1];
        }
        function toFilePathsSet(fileIdsListId) {
            return filePathsSetList[fileIdsListId - 1];
        }
        function toManyToManyPathMap(referenceMap) {
            if (!referenceMap) return void 0;
            const map2 = BuilderState.createManyToManyPathMap();
            referenceMap.forEach(([fileId, fileIdListId])=>map2.set(toFilePath(fileId), toFilePathsSet(fileIdListId)));
            return map2;
        }
    }
    function getBuildInfoFileVersionMap(program, buildInfoPath, host) {
        const buildInfoDirectory = getDirectoryPath(getNormalizedAbsolutePath(buildInfoPath, host.getCurrentDirectory()));
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames());
        const fileInfos = /* @__PURE__ */ new Map();
        let rootIndex = 0;
        const roots = [];
        program.fileInfos.forEach((fileInfo, index)=>{
            const path = toPath(program.fileNames[index], buildInfoDirectory, getCanonicalFileName);
            const version2 = isString(fileInfo) ? fileInfo : fileInfo.version;
            fileInfos.set(path, version2);
            if (rootIndex < program.root.length) {
                const current = program.root[rootIndex];
                const fileId = index + 1;
                if (isArray(current)) {
                    if (current[0] <= fileId && fileId <= current[1]) {
                        roots.push(path);
                        if (current[1] === fileId) rootIndex++;
                    }
                } else if (current === fileId) {
                    roots.push(path);
                    rootIndex++;
                }
            }
        });
        return {
            fileInfos: fileInfos,
            roots: roots
        };
    }
    function createRedirectedBuilderProgram(getState, configFileParsingDiagnostics) {
        return {
            getState: notImplemented,
            saveEmitState: noop,
            restoreEmitState: noop,
            getProgram: getProgram,
            getProgramOrUndefined: ()=>getState().program,
            releaseProgram: ()=>getState().program = void 0,
            getCompilerOptions: ()=>getState().compilerOptions,
            getSourceFile: (fileName)=>getProgram().getSourceFile(fileName),
            getSourceFiles: ()=>getProgram().getSourceFiles(),
            getOptionsDiagnostics: (cancellationToken)=>getProgram().getOptionsDiagnostics(cancellationToken),
            getGlobalDiagnostics: (cancellationToken)=>getProgram().getGlobalDiagnostics(cancellationToken),
            getConfigFileParsingDiagnostics: ()=>configFileParsingDiagnostics,
            getSyntacticDiagnostics: (sourceFile, cancellationToken)=>getProgram().getSyntacticDiagnostics(sourceFile, cancellationToken),
            getDeclarationDiagnostics: (sourceFile, cancellationToken)=>getProgram().getDeclarationDiagnostics(sourceFile, cancellationToken),
            getSemanticDiagnostics: (sourceFile, cancellationToken)=>getProgram().getSemanticDiagnostics(sourceFile, cancellationToken),
            emit: (sourceFile, writeFile2, cancellationToken, emitOnlyDts, customTransformers)=>getProgram().emit(sourceFile, writeFile2, cancellationToken, emitOnlyDts, customTransformers),
            emitBuildInfo: (writeFile2, cancellationToken)=>getProgram().emitBuildInfo(writeFile2, cancellationToken),
            getAllDependencies: notImplemented,
            getCurrentDirectory: ()=>getProgram().getCurrentDirectory(),
            close: noop
        };
        function getProgram() {
            return Debug.checkDefined(getState().program);
        }
    }
    var BuilderFileEmit, BuilderProgramKind;
    var init_builder = __esm({
        "src/compiler/builder.ts" () {
            "use strict";
            init_ts2();
            BuilderFileEmit = /* @__PURE__ */ ((BuilderFileEmit2)=>{
                BuilderFileEmit2[BuilderFileEmit2["None"] = 0] = "None";
                BuilderFileEmit2[BuilderFileEmit2["Js"] = 1] = "Js";
                BuilderFileEmit2[BuilderFileEmit2["JsMap"] = 2] = "JsMap";
                BuilderFileEmit2[BuilderFileEmit2["JsInlineMap"] = 4] = "JsInlineMap";
                BuilderFileEmit2[BuilderFileEmit2["Dts"] = 8] = "Dts";
                BuilderFileEmit2[BuilderFileEmit2["DtsMap"] = 16] = "DtsMap";
                BuilderFileEmit2[BuilderFileEmit2["AllJs"] = 7] = "AllJs";
                BuilderFileEmit2[BuilderFileEmit2["AllDts"] = 24] = "AllDts";
                BuilderFileEmit2[BuilderFileEmit2["All"] = 31] = "All";
                return BuilderFileEmit2;
            })(BuilderFileEmit || {});
            BuilderProgramKind = /* @__PURE__ */ ((BuilderProgramKind2)=>{
                BuilderProgramKind2[BuilderProgramKind2["SemanticDiagnosticsBuilderProgram"] = 0] = "SemanticDiagnosticsBuilderProgram";
                BuilderProgramKind2[BuilderProgramKind2["EmitAndSemanticDiagnosticsBuilderProgram"] = 1] = "EmitAndSemanticDiagnosticsBuilderProgram";
                return BuilderProgramKind2;
            })(BuilderProgramKind || {});
        }
    });
    // src/compiler/builderPublic.ts
    function createSemanticDiagnosticsBuilderProgram(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences) {
        return createBuilderProgram(0 /* SemanticDiagnosticsBuilderProgram */ , getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences));
    }
    function createEmitAndSemanticDiagnosticsBuilderProgram(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences) {
        return createBuilderProgram(1 /* EmitAndSemanticDiagnosticsBuilderProgram */ , getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences));
    }
    function createAbstractBuilder(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences) {
        const { newProgram: newProgram , configFileParsingDiagnostics: newConfigFileParsingDiagnostics  } = getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences);
        return createRedirectedBuilderProgram(()=>({
                program: newProgram,
                compilerOptions: newProgram.getCompilerOptions()
            }), newConfigFileParsingDiagnostics);
    }
    var init_builderPublic = __esm({
        "src/compiler/builderPublic.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/resolutionCache.ts
    function removeIgnoredPath(path) {
        if (endsWith(path, "/node_modules/.staging")) return removeSuffix(path, "/.staging");
        return some(ignoredPaths, (searchPath)=>stringContains(path, searchPath)) ? void 0 : path;
    }
    function perceivedOsRootLengthForWatching(pathComponents2, length2) {
        if (length2 <= 1) return 1;
        let userCheckIndex = 1;
        let isDosStyle = pathComponents2[0].search(/[a-zA-Z]:/) === 0;
        if (pathComponents2[0] !== directorySeparator && !isDosStyle && // Non dos style paths
        pathComponents2[1].search(/[a-zA-Z]\$$/) === 0) {
            if (length2 === 2) return 2;
            userCheckIndex = 2;
            isDosStyle = true;
        }
        if (isDosStyle && !pathComponents2[userCheckIndex].match(/^users$/i)) return userCheckIndex;
        return userCheckIndex + 2;
    }
    function canWatchDirectoryOrFile(pathComponents2, length2) {
        if (length2 === void 0) length2 = pathComponents2.length;
        if (length2 <= 2) return false;
        const perceivedOsRootLength = perceivedOsRootLengthForWatching(pathComponents2, length2);
        return length2 > perceivedOsRootLength + 1;
    }
    function canWatchAtTypes(atTypes) {
        return canWatchAffectedPackageJsonOrNodeModulesOfAtTypes(getDirectoryPath(atTypes));
    }
    function isInDirectoryPath(dirComponents, fileOrDirComponents) {
        if (fileOrDirComponents.length < fileOrDirComponents.length) return false;
        for(let i = 0; i < dirComponents.length; i++){
            if (fileOrDirComponents[i] !== dirComponents[i]) return false;
        }
        return true;
    }
    function canWatchAffectedPackageJsonOrNodeModulesOfAtTypes(fileOrDirPath) {
        return canWatchDirectoryOrFile(getPathComponents(fileOrDirPath));
    }
    function canWatchAffectingLocation(filePath) {
        return canWatchAffectedPackageJsonOrNodeModulesOfAtTypes(filePath);
    }
    function getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath, rootDir, rootPath, rootPathComponents, getCurrentDirectory) {
        const failedLookupPathComponents = getPathComponents(failedLookupLocationPath);
        failedLookupLocation = isRootedDiskPath(failedLookupLocation) ? normalizePath(failedLookupLocation) : getNormalizedAbsolutePath(failedLookupLocation, getCurrentDirectory());
        const failedLookupComponents = getPathComponents(failedLookupLocation);
        const perceivedOsRootLength = perceivedOsRootLengthForWatching(failedLookupPathComponents, failedLookupPathComponents.length);
        if (failedLookupPathComponents.length <= perceivedOsRootLength + 1) return void 0;
        const nodeModulesIndex = failedLookupPathComponents.indexOf("node_modules");
        if (nodeModulesIndex !== -1 && nodeModulesIndex + 1 <= perceivedOsRootLength + 1) return void 0;
        if (isInDirectoryPath(rootPathComponents, failedLookupPathComponents)) {
            if (failedLookupPathComponents.length > rootPathComponents.length + 1) return getDirectoryOfFailedLookupWatch(failedLookupComponents, failedLookupPathComponents, Math.max(rootPathComponents.length + 1, perceivedOsRootLength + 1));
            else return {
                dir: rootDir,
                dirPath: rootPath,
                nonRecursive: true
            };
        }
        return getDirectoryToWatchFromFailedLookupLocationDirectory(failedLookupComponents, failedLookupPathComponents, failedLookupPathComponents.length - 1, perceivedOsRootLength, nodeModulesIndex, rootPathComponents);
    }
    function getDirectoryToWatchFromFailedLookupLocationDirectory(dirComponents, dirPathComponents, dirPathComponentsLength, perceivedOsRootLength, nodeModulesIndex, rootPathComponents) {
        if (nodeModulesIndex !== -1) return getDirectoryOfFailedLookupWatch(dirComponents, dirPathComponents, nodeModulesIndex + 1);
        let nonRecursive = true;
        let length2 = dirPathComponentsLength;
        for(let i = 0; i < dirPathComponentsLength; i++)if (dirPathComponents[i] !== rootPathComponents[i]) {
            nonRecursive = false;
            length2 = Math.max(i + 1, perceivedOsRootLength + 1);
            break;
        }
        return getDirectoryOfFailedLookupWatch(dirComponents, dirPathComponents, length2, nonRecursive);
    }
    function getDirectoryOfFailedLookupWatch(dirComponents, dirPathComponents, length2, nonRecursive) {
        return {
            dir: getPathFromPathComponents(dirComponents, length2),
            dirPath: getPathFromPathComponents(dirPathComponents, length2),
            nonRecursive: nonRecursive
        };
    }
    function getDirectoryToWatchFailedLookupLocationFromTypeRoot(typeRoot, typeRootPath, rootPath, rootPathComponents, getCurrentDirectory, filterCustomPath) {
        const typeRootPathComponents = getPathComponents(typeRootPath);
        if (isInDirectoryPath(rootPathComponents, typeRootPathComponents)) return rootPath;
        typeRoot = isRootedDiskPath(typeRoot) ? normalizePath(typeRoot) : getNormalizedAbsolutePath(typeRoot, getCurrentDirectory());
        const toWatch = getDirectoryToWatchFromFailedLookupLocationDirectory(getPathComponents(typeRoot), typeRootPathComponents, typeRootPathComponents.length, perceivedOsRootLengthForWatching(typeRootPathComponents, typeRootPathComponents.length), typeRootPathComponents.indexOf("node_modules"), rootPathComponents);
        return toWatch && filterCustomPath(toWatch.dirPath) ? toWatch.dirPath : void 0;
    }
    function getRootDirectoryOfResolutionCache(rootDirForResolution, getCurrentDirectory) {
        const normalized = getNormalizedAbsolutePath(rootDirForResolution, getCurrentDirectory());
        return !isDiskPathRoot(normalized) ? removeTrailingDirectorySeparator(normalized) : normalized;
    }
    function getRootPathSplitLength(rootPath) {
        return rootPath.split(directorySeparator).length - (hasTrailingDirectorySeparator(rootPath) ? 1 : 0);
    }
    function createResolutionCache(resolutionHost, rootDirForResolution, logChangesWhenResolvingModule) {
        let filesWithChangedSetOfUnresolvedImports;
        let filesWithInvalidatedResolutions;
        let filesWithInvalidatedNonRelativeUnresolvedImports;
        const nonRelativeExternalModuleResolutions = createMultiMap();
        const resolutionsWithFailedLookups = /* @__PURE__ */ new Set();
        const resolutionsWithOnlyAffectingLocations = /* @__PURE__ */ new Set();
        const resolvedFileToResolution = /* @__PURE__ */ new Map();
        const impliedFormatPackageJsons = /* @__PURE__ */ new Map();
        let hasChangedAutomaticTypeDirectiveNames = false;
        let affectingPathChecksForFile;
        let affectingPathChecks;
        let failedLookupChecks;
        let startsWithPathChecks;
        let isInDirectoryChecks;
        let allModuleAndTypeResolutionsAreInvalidated = false;
        const getCurrentDirectory = memoize(()=>resolutionHost.getCurrentDirectory());
        const cachedDirectoryStructureHost = resolutionHost.getCachedDirectoryStructureHost();
        const resolvedModuleNames = /* @__PURE__ */ new Map();
        const moduleResolutionCache = createModuleResolutionCache(getCurrentDirectory(), resolutionHost.getCanonicalFileName, resolutionHost.getCompilationSettings());
        const resolvedTypeReferenceDirectives = /* @__PURE__ */ new Map();
        const typeReferenceDirectiveResolutionCache = createTypeReferenceDirectiveResolutionCache(getCurrentDirectory(), resolutionHost.getCanonicalFileName, resolutionHost.getCompilationSettings(), moduleResolutionCache.getPackageJsonInfoCache());
        const resolvedLibraries = /* @__PURE__ */ new Map();
        const libraryResolutionCache = createModuleResolutionCache(getCurrentDirectory(), resolutionHost.getCanonicalFileName, getOptionsForLibraryResolution(resolutionHost.getCompilationSettings()), moduleResolutionCache.getPackageJsonInfoCache());
        const directoryWatchesOfFailedLookups = /* @__PURE__ */ new Map();
        const fileWatchesOfAffectingLocations = /* @__PURE__ */ new Map();
        const rootDir = getRootDirectoryOfResolutionCache(rootDirForResolution, getCurrentDirectory);
        const rootPath = resolutionHost.toPath(rootDir);
        const rootPathComponents = getPathComponents(rootPath);
        const typeRootsWatches = /* @__PURE__ */ new Map();
        return {
            getModuleResolutionCache: ()=>moduleResolutionCache,
            startRecordingFilesWithChangedResolutions: startRecordingFilesWithChangedResolutions,
            finishRecordingFilesWithChangedResolutions: finishRecordingFilesWithChangedResolutions,
            startCachingPerDirectoryResolution: // perDirectoryResolvedModuleNames and perDirectoryResolvedTypeReferenceDirectives could be non empty if there was exception during program update
            // (between startCachingPerDirectoryResolution and finishCachingPerDirectoryResolution)
            startCachingPerDirectoryResolution,
            finishCachingPerDirectoryResolution: finishCachingPerDirectoryResolution,
            resolveModuleNameLiterals: resolveModuleNameLiterals,
            resolveTypeReferenceDirectiveReferences: resolveTypeReferenceDirectiveReferences,
            resolveLibrary: resolveLibrary2,
            resolveSingleModuleNameWithoutWatching: resolveSingleModuleNameWithoutWatching,
            removeResolutionsFromProjectReferenceRedirects: removeResolutionsFromProjectReferenceRedirects,
            removeResolutionsOfFile: removeResolutionsOfFile,
            hasChangedAutomaticTypeDirectiveNames: ()=>hasChangedAutomaticTypeDirectiveNames,
            invalidateResolutionOfFile: invalidateResolutionOfFile,
            invalidateResolutionsOfFailedLookupLocations: invalidateResolutionsOfFailedLookupLocations,
            setFilesWithInvalidatedNonRelativeUnresolvedImports: setFilesWithInvalidatedNonRelativeUnresolvedImports,
            createHasInvalidatedResolutions: createHasInvalidatedResolutions,
            isFileWithInvalidatedNonRelativeUnresolvedImports: isFileWithInvalidatedNonRelativeUnresolvedImports,
            updateTypeRootsWatch: updateTypeRootsWatch,
            closeTypeRootsWatch: closeTypeRootsWatch,
            clear: clear2,
            onChangesAffectModuleResolution: onChangesAffectModuleResolution
        };
        function getResolvedModule2(resolution) {
            return resolution.resolvedModule;
        }
        function getResolvedTypeReferenceDirective2(resolution) {
            return resolution.resolvedTypeReferenceDirective;
        }
        function clear2() {
            clearMap(directoryWatchesOfFailedLookups, closeFileWatcherOf);
            clearMap(fileWatchesOfAffectingLocations, closeFileWatcherOf);
            nonRelativeExternalModuleResolutions.clear();
            closeTypeRootsWatch();
            resolvedModuleNames.clear();
            resolvedTypeReferenceDirectives.clear();
            resolvedFileToResolution.clear();
            resolutionsWithFailedLookups.clear();
            resolutionsWithOnlyAffectingLocations.clear();
            failedLookupChecks = void 0;
            startsWithPathChecks = void 0;
            isInDirectoryChecks = void 0;
            affectingPathChecks = void 0;
            affectingPathChecksForFile = void 0;
            allModuleAndTypeResolutionsAreInvalidated = false;
            moduleResolutionCache.clear();
            typeReferenceDirectiveResolutionCache.clear();
            moduleResolutionCache.update(resolutionHost.getCompilationSettings());
            typeReferenceDirectiveResolutionCache.update(resolutionHost.getCompilationSettings());
            libraryResolutionCache.clear();
            impliedFormatPackageJsons.clear();
            resolvedLibraries.clear();
            hasChangedAutomaticTypeDirectiveNames = false;
        }
        function onChangesAffectModuleResolution() {
            allModuleAndTypeResolutionsAreInvalidated = true;
            moduleResolutionCache.clearAllExceptPackageJsonInfoCache();
            typeReferenceDirectiveResolutionCache.clearAllExceptPackageJsonInfoCache();
            moduleResolutionCache.update(resolutionHost.getCompilationSettings());
            typeReferenceDirectiveResolutionCache.update(resolutionHost.getCompilationSettings());
        }
        function startRecordingFilesWithChangedResolutions() {
            filesWithChangedSetOfUnresolvedImports = [];
        }
        function finishRecordingFilesWithChangedResolutions() {
            const collected = filesWithChangedSetOfUnresolvedImports;
            filesWithChangedSetOfUnresolvedImports = void 0;
            return collected;
        }
        function isFileWithInvalidatedNonRelativeUnresolvedImports(path) {
            if (!filesWithInvalidatedNonRelativeUnresolvedImports) return false;
            const value1 = filesWithInvalidatedNonRelativeUnresolvedImports.get(path);
            return !!value1 && !!value1.length;
        }
        function createHasInvalidatedResolutions(customHasInvalidatedResolutions, customHasInvalidatedLibResolutions) {
            invalidateResolutionsOfFailedLookupLocations();
            const collected = filesWithInvalidatedResolutions;
            filesWithInvalidatedResolutions = void 0;
            return {
                hasInvalidatedResolutions: (path)=>customHasInvalidatedResolutions(path) || allModuleAndTypeResolutionsAreInvalidated || !!(collected == null ? void 0 : collected.has(path)) || isFileWithInvalidatedNonRelativeUnresolvedImports(path),
                hasInvalidatedLibResolutions: (libFileName)=>{
                    var _a;
                    return customHasInvalidatedLibResolutions(libFileName) || !!((_a = resolvedLibraries == null ? void 0 : resolvedLibraries.get(libFileName)) == null ? void 0 : _a.isInvalidated);
                }
            };
        }
        function startCachingPerDirectoryResolution() {
            moduleResolutionCache.clearAllExceptPackageJsonInfoCache();
            typeReferenceDirectiveResolutionCache.clearAllExceptPackageJsonInfoCache();
            libraryResolutionCache.clearAllExceptPackageJsonInfoCache();
            nonRelativeExternalModuleResolutions.forEach(watchFailedLookupLocationOfNonRelativeModuleResolutions);
            nonRelativeExternalModuleResolutions.clear();
        }
        function cleanupLibResolutionWatching(newProgram) {
            resolvedLibraries.forEach((resolution, libFileName)=>{
                var _a;
                if (!((_a = newProgram == null ? void 0 : newProgram.resolvedLibReferences) == null ? void 0 : _a.has(libFileName))) {
                    stopWatchFailedLookupLocationOfResolution(resolution, resolutionHost.toPath(getInferredLibraryNameResolveFrom(newProgram.getCompilerOptions(), getCurrentDirectory(), libFileName)), getResolvedModule2);
                    resolvedLibraries.delete(libFileName);
                }
            });
        }
        function finishCachingPerDirectoryResolution(newProgram, oldProgram) {
            filesWithInvalidatedNonRelativeUnresolvedImports = void 0;
            allModuleAndTypeResolutionsAreInvalidated = false;
            nonRelativeExternalModuleResolutions.forEach(watchFailedLookupLocationOfNonRelativeModuleResolutions);
            nonRelativeExternalModuleResolutions.clear();
            if (newProgram !== oldProgram) {
                cleanupLibResolutionWatching(newProgram);
                newProgram == null || newProgram.getSourceFiles().forEach((newFile)=>{
                    var _a;
                    const expected = isExternalOrCommonJsModule(newFile) ? ((_a = newFile.packageJsonLocations) == null ? void 0 : _a.length) ?? 0 : 0;
                    const existing = impliedFormatPackageJsons.get(newFile.path) ?? emptyArray;
                    for(let i = existing.length; i < expected; i++)createFileWatcherOfAffectingLocation(newFile.packageJsonLocations[i], /*forResolution*/ false);
                    if (existing.length > expected) for(let i = expected; i < existing.length; i++)fileWatchesOfAffectingLocations.get(existing[i]).files--;
                    if (expected) impliedFormatPackageJsons.set(newFile.path, newFile.packageJsonLocations);
                    else impliedFormatPackageJsons.delete(newFile.path);
                });
                impliedFormatPackageJsons.forEach((existing, path)=>{
                    if (!(newProgram == null ? void 0 : newProgram.getSourceFileByPath(path))) {
                        existing.forEach((location)=>fileWatchesOfAffectingLocations.get(location).files--);
                        impliedFormatPackageJsons.delete(path);
                    }
                });
            }
            directoryWatchesOfFailedLookups.forEach((watcher, path)=>{
                if (watcher.refCount === 0) {
                    directoryWatchesOfFailedLookups.delete(path);
                    watcher.watcher.close();
                }
            });
            fileWatchesOfAffectingLocations.forEach((watcher, path)=>{
                if (watcher.files === 0 && watcher.resolutions === 0) {
                    fileWatchesOfAffectingLocations.delete(path);
                    watcher.watcher.close();
                }
            });
            hasChangedAutomaticTypeDirectiveNames = false;
        }
        function resolveModuleName2(moduleName, containingFile, compilerOptions, redirectedReference, mode) {
            var _a;
            const host = ((_a = resolutionHost.getCompilerHost) == null ? void 0 : _a.call(resolutionHost)) || resolutionHost;
            const primaryResult = resolveModuleName(moduleName, containingFile, compilerOptions, host, moduleResolutionCache, redirectedReference, mode);
            if (!resolutionHost.getGlobalCache) return primaryResult;
            const globalCache = resolutionHost.getGlobalCache();
            if (globalCache !== void 0 && !isExternalModuleNameRelative(moduleName) && !(primaryResult.resolvedModule && extensionIsTS(primaryResult.resolvedModule.extension))) {
                const { resolvedModule: resolvedModule , failedLookupLocations: failedLookupLocations , affectingLocations: affectingLocations , resolutionDiagnostics: resolutionDiagnostics  } = loadModuleFromGlobalCache(Debug.checkDefined(resolutionHost.globalCacheResolutionModuleName)(moduleName), resolutionHost.projectName, compilerOptions, host, globalCache, moduleResolutionCache);
                if (resolvedModule) {
                    primaryResult.resolvedModule = resolvedModule;
                    primaryResult.failedLookupLocations = updateResolutionField(primaryResult.failedLookupLocations, failedLookupLocations);
                    primaryResult.affectingLocations = updateResolutionField(primaryResult.affectingLocations, affectingLocations);
                    primaryResult.resolutionDiagnostics = updateResolutionField(primaryResult.resolutionDiagnostics, resolutionDiagnostics);
                    return primaryResult;
                }
            }
            return primaryResult;
        }
        function createModuleResolutionLoader2(containingFile, redirectedReference, options) {
            return {
                nameAndMode: moduleResolutionNameAndModeGetter,
                resolve: (moduleName, resoluionMode)=>resolveModuleName2(moduleName, containingFile, options, redirectedReference, resoluionMode)
            };
        }
        function resolveNamesWithLocalCache({ entries: entries , containingFile: containingFile , containingSourceFile: containingSourceFile , redirectedReference: redirectedReference , options: options , perFileCache: perFileCache , reusedNames: reusedNames , loader: loader , getResolutionWithResolvedFileName: getResolutionWithResolvedFileName , deferWatchingNonRelativeResolution: deferWatchingNonRelativeResolution , shouldRetryResolution: shouldRetryResolution , logChanges: logChanges  }) {
            var _a;
            const path = resolutionHost.toPath(containingFile);
            const resolutionsInFile = perFileCache.get(path) || perFileCache.set(path, createModeAwareCache()).get(path);
            const resolvedModules = [];
            const hasInvalidatedNonRelativeUnresolvedImport = logChanges && isFileWithInvalidatedNonRelativeUnresolvedImports(path);
            const program = resolutionHost.getCurrentProgram();
            const oldRedirect = program && program.getResolvedProjectReferenceToRedirect(containingFile);
            const unmatchedRedirects = oldRedirect ? !redirectedReference || redirectedReference.sourceFile.path !== oldRedirect.sourceFile.path : !!redirectedReference;
            const seenNamesInFile = createModeAwareCache();
            for (const entry of entries){
                const name = loader.nameAndMode.getName(entry);
                const mode = loader.nameAndMode.getMode(entry, containingSourceFile);
                let resolution = resolutionsInFile.get(name, mode);
                if (!seenNamesInFile.has(name, mode) && (allModuleAndTypeResolutionsAreInvalidated || unmatchedRedirects || !resolution || resolution.isInvalidated || // If the name is unresolved import that was invalidated, recalculate
                hasInvalidatedNonRelativeUnresolvedImport && !isExternalModuleNameRelative(name) && shouldRetryResolution(resolution))) {
                    const existingResolution = resolution;
                    resolution = loader.resolve(name, mode);
                    if (resolutionHost.onDiscoveredSymlink && resolutionIsSymlink(resolution)) resolutionHost.onDiscoveredSymlink();
                    resolutionsInFile.set(name, mode, resolution);
                    watchFailedLookupLocationsOfExternalModuleResolutions(name, resolution, path, getResolutionWithResolvedFileName, deferWatchingNonRelativeResolution);
                    if (existingResolution) stopWatchFailedLookupLocationOfResolution(existingResolution, path, getResolutionWithResolvedFileName);
                    if (logChanges && filesWithChangedSetOfUnresolvedImports && !resolutionIsEqualTo(existingResolution, resolution)) {
                        filesWithChangedSetOfUnresolvedImports.push(path);
                        logChanges = false;
                    }
                } else {
                    const host = ((_a = resolutionHost.getCompilerHost) == null ? void 0 : _a.call(resolutionHost)) || resolutionHost;
                    if (isTraceEnabled(options, host) && !seenNamesInFile.has(name, mode)) {
                        const resolved = getResolutionWithResolvedFileName(resolution);
                        trace(host, perFileCache === resolvedModuleNames ? (resolved == null ? void 0 : resolved.resolvedFileName) ? resolved.packageId ? Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_not_resolved : (resolved == null ? void 0 : resolved.resolvedFileName) ? resolved.packageId ? Diagnostics.Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2 : Diagnostics.Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_not_resolved, name, containingFile, resolved == null ? void 0 : resolved.resolvedFileName, (resolved == null ? void 0 : resolved.packageId) && packageIdToString(resolved.packageId));
                    }
                }
                Debug.assert(resolution !== void 0 && !resolution.isInvalidated);
                seenNamesInFile.set(name, mode, true);
                resolvedModules.push(resolution);
            }
            reusedNames == null || reusedNames.forEach((entry)=>seenNamesInFile.set(loader.nameAndMode.getName(entry), loader.nameAndMode.getMode(entry, containingSourceFile), true));
            if (resolutionsInFile.size() !== seenNamesInFile.size()) resolutionsInFile.forEach((resolution, name, mode)=>{
                if (!seenNamesInFile.has(name, mode)) {
                    stopWatchFailedLookupLocationOfResolution(resolution, path, getResolutionWithResolvedFileName);
                    resolutionsInFile.delete(name, mode);
                }
            });
            return resolvedModules;
            function resolutionIsEqualTo(oldResolution, newResolution) {
                if (oldResolution === newResolution) return true;
                if (!oldResolution || !newResolution) return false;
                const oldResult = getResolutionWithResolvedFileName(oldResolution);
                const newResult = getResolutionWithResolvedFileName(newResolution);
                if (oldResult === newResult) return true;
                if (!oldResult || !newResult) return false;
                return oldResult.resolvedFileName === newResult.resolvedFileName;
            }
        }
        function resolveTypeReferenceDirectiveReferences(typeDirectiveReferences, containingFile, redirectedReference, options, containingSourceFile, reusedNames) {
            var _a;
            return resolveNamesWithLocalCache({
                entries: typeDirectiveReferences,
                containingFile: containingFile,
                containingSourceFile: containingSourceFile,
                redirectedReference: redirectedReference,
                options: options,
                reusedNames: reusedNames,
                perFileCache: resolvedTypeReferenceDirectives,
                loader: createTypeReferenceResolutionLoader(containingFile, redirectedReference, options, ((_a = resolutionHost.getCompilerHost) == null ? void 0 : _a.call(resolutionHost)) || resolutionHost, typeReferenceDirectiveResolutionCache),
                getResolutionWithResolvedFileName: getResolvedTypeReferenceDirective2,
                shouldRetryResolution: (resolution)=>resolution.resolvedTypeReferenceDirective === void 0,
                deferWatchingNonRelativeResolution: false
            });
        }
        function resolveModuleNameLiterals(moduleLiterals, containingFile, redirectedReference, options, containingSourceFile, reusedNames) {
            return resolveNamesWithLocalCache({
                entries: moduleLiterals,
                containingFile: containingFile,
                containingSourceFile: containingSourceFile,
                redirectedReference: redirectedReference,
                options: options,
                reusedNames: reusedNames,
                perFileCache: resolvedModuleNames,
                loader: createModuleResolutionLoader2(containingFile, redirectedReference, options),
                getResolutionWithResolvedFileName: getResolvedModule2,
                shouldRetryResolution: (resolution)=>!resolution.resolvedModule || !resolutionExtensionIsTSOrJson(resolution.resolvedModule.extension),
                logChanges: logChangesWhenResolvingModule,
                deferWatchingNonRelativeResolution: true
            });
        }
        function resolveLibrary2(libraryName, resolveFrom, options, libFileName) {
            var _a;
            const host = ((_a = resolutionHost.getCompilerHost) == null ? void 0 : _a.call(resolutionHost)) || resolutionHost;
            let resolution = resolvedLibraries == null ? void 0 : resolvedLibraries.get(libFileName);
            if (!resolution || resolution.isInvalidated) {
                const existingResolution = resolution;
                resolution = resolveLibrary(libraryName, resolveFrom, options, host, libraryResolutionCache);
                const path = resolutionHost.toPath(resolveFrom);
                watchFailedLookupLocationsOfExternalModuleResolutions(libraryName, resolution, path, getResolvedModule2, /*deferWatchingNonRelativeResolution*/ false);
                resolvedLibraries.set(libFileName, resolution);
                if (existingResolution) stopWatchFailedLookupLocationOfResolution(existingResolution, path, getResolvedModule2);
            } else if (isTraceEnabled(options, host)) {
                const resolved = getResolvedModule2(resolution);
                trace(host, (resolved == null ? void 0 : resolved.resolvedFileName) ? resolved.packageId ? Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_not_resolved, libraryName, resolveFrom, resolved == null ? void 0 : resolved.resolvedFileName, (resolved == null ? void 0 : resolved.packageId) && packageIdToString(resolved.packageId));
            }
            return resolution;
        }
        function resolveSingleModuleNameWithoutWatching(moduleName, containingFile) {
            const path = resolutionHost.toPath(containingFile);
            const resolutionsInFile = resolvedModuleNames.get(path);
            const resolution = resolutionsInFile == null ? void 0 : resolutionsInFile.get(moduleName, /*mode*/ void 0);
            if (resolution && !resolution.isInvalidated) return resolution;
            return resolveModuleName2(moduleName, containingFile, resolutionHost.getCompilationSettings());
        }
        function isNodeModulesAtTypesDirectory(dirPath) {
            return endsWith(dirPath, "/node_modules/@types");
        }
        function watchFailedLookupLocationsOfExternalModuleResolutions(name, resolution, filePath, getResolutionWithResolvedFileName, deferWatchingNonRelativeResolution) {
            var _a;
            if (resolution.refCount) {
                resolution.refCount++;
                Debug.assertIsDefined(resolution.files);
            } else {
                resolution.refCount = 1;
                Debug.assert(!((_a = resolution.files) == null ? void 0 : _a.size));
                if (!deferWatchingNonRelativeResolution || isExternalModuleNameRelative(name)) watchFailedLookupLocationOfResolution(resolution);
                else nonRelativeExternalModuleResolutions.add(name, resolution);
                const resolved = getResolutionWithResolvedFileName(resolution);
                if (resolved && resolved.resolvedFileName) {
                    const key = resolutionHost.toPath(resolved.resolvedFileName);
                    let resolutions = resolvedFileToResolution.get(key);
                    if (!resolutions) resolvedFileToResolution.set(key, resolutions = /* @__PURE__ */ new Set());
                    resolutions.add(resolution);
                }
            }
            (resolution.files ?? (resolution.files = /* @__PURE__ */ new Set())).add(filePath);
        }
        function watchFailedLookupLocation(failedLookupLocation, setAtRoot) {
            const failedLookupLocationPath = resolutionHost.toPath(failedLookupLocation);
            const toWatch = getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath, rootDir, rootPath, rootPathComponents, getCurrentDirectory);
            if (toWatch) {
                const { dir: dir , dirPath: dirPath , nonRecursive: nonRecursive  } = toWatch;
                if (dirPath === rootPath) {
                    Debug.assert(nonRecursive);
                    setAtRoot = true;
                } else setDirectoryWatcher(dir, dirPath, nonRecursive);
            }
            return setAtRoot;
        }
        function watchFailedLookupLocationOfResolution(resolution) {
            Debug.assert(!!resolution.refCount);
            const { failedLookupLocations: failedLookupLocations , affectingLocations: affectingLocations , node10Result: node10Result  } = resolution;
            if (!(failedLookupLocations == null ? void 0 : failedLookupLocations.length) && !(affectingLocations == null ? void 0 : affectingLocations.length) && !node10Result) return;
            if ((failedLookupLocations == null ? void 0 : failedLookupLocations.length) || node10Result) resolutionsWithFailedLookups.add(resolution);
            let setAtRoot = false;
            if (failedLookupLocations) for (const failedLookupLocation of failedLookupLocations)setAtRoot = watchFailedLookupLocation(failedLookupLocation, setAtRoot);
            if (node10Result) setAtRoot = watchFailedLookupLocation(node10Result, setAtRoot);
            if (setAtRoot) setDirectoryWatcher(rootDir, rootPath, /*nonRecursive*/ true);
            watchAffectingLocationsOfResolution(resolution, !(failedLookupLocations == null ? void 0 : failedLookupLocations.length) && !node10Result);
        }
        function watchAffectingLocationsOfResolution(resolution, addToResolutionsWithOnlyAffectingLocations) {
            Debug.assert(!!resolution.refCount);
            const { affectingLocations: affectingLocations  } = resolution;
            if (!(affectingLocations == null ? void 0 : affectingLocations.length)) return;
            if (addToResolutionsWithOnlyAffectingLocations) resolutionsWithOnlyAffectingLocations.add(resolution);
            for (const affectingLocation of affectingLocations)createFileWatcherOfAffectingLocation(affectingLocation, /*forResolution*/ true);
        }
        function createFileWatcherOfAffectingLocation(affectingLocation, forResolution) {
            const fileWatcher = fileWatchesOfAffectingLocations.get(affectingLocation);
            if (fileWatcher) {
                if (forResolution) fileWatcher.resolutions++;
                else fileWatcher.files++;
                return;
            }
            let locationToWatch = affectingLocation;
            if (resolutionHost.realpath) {
                locationToWatch = resolutionHost.realpath(affectingLocation);
                if (affectingLocation !== locationToWatch) {
                    const fileWatcher2 = fileWatchesOfAffectingLocations.get(locationToWatch);
                    if (fileWatcher2) {
                        if (forResolution) fileWatcher2.resolutions++;
                        else fileWatcher2.files++;
                        fileWatcher2.paths.add(affectingLocation);
                        fileWatchesOfAffectingLocations.set(affectingLocation, fileWatcher2);
                        return;
                    }
                }
            }
            const paths = /* @__PURE__ */ new Set();
            paths.add(locationToWatch);
            let actualWatcher = canWatchAffectingLocation(resolutionHost.toPath(locationToWatch)) ? resolutionHost.watchAffectingFileLocation(locationToWatch, (fileName, eventKind)=>{
                cachedDirectoryStructureHost == null || cachedDirectoryStructureHost.addOrDeleteFile(fileName, resolutionHost.toPath(locationToWatch), eventKind);
                const packageJsonMap = moduleResolutionCache.getPackageJsonInfoCache().getInternalMap();
                paths.forEach((path)=>{
                    if (watcher.resolutions) (affectingPathChecks ?? (affectingPathChecks = /* @__PURE__ */ new Set())).add(path);
                    if (watcher.files) (affectingPathChecksForFile ?? (affectingPathChecksForFile = /* @__PURE__ */ new Set())).add(path);
                    packageJsonMap == null || packageJsonMap.delete(resolutionHost.toPath(path));
                });
                resolutionHost.scheduleInvalidateResolutionsOfFailedLookupLocations();
            }) : noopFileWatcher;
            const watcher = {
                watcher: actualWatcher !== noopFileWatcher ? {
                    close: ()=>{
                        actualWatcher.close();
                        actualWatcher = noopFileWatcher;
                    }
                } : actualWatcher,
                resolutions: forResolution ? 1 : 0,
                files: forResolution ? 0 : 1,
                paths: paths
            };
            fileWatchesOfAffectingLocations.set(locationToWatch, watcher);
            if (affectingLocation !== locationToWatch) {
                fileWatchesOfAffectingLocations.set(affectingLocation, watcher);
                paths.add(affectingLocation);
            }
        }
        function watchFailedLookupLocationOfNonRelativeModuleResolutions(resolutions, name) {
            const program = resolutionHost.getCurrentProgram();
            if (!program || !program.getTypeChecker().tryFindAmbientModuleWithoutAugmentations(name)) resolutions.forEach(watchFailedLookupLocationOfResolution);
            else resolutions.forEach((resolution)=>watchAffectingLocationsOfResolution(resolution, /*addToResolutionsWithOnlyAffectingLocations*/ true));
        }
        function setDirectoryWatcher(dir, dirPath, nonRecursive) {
            const dirWatcher = directoryWatchesOfFailedLookups.get(dirPath);
            if (dirWatcher) {
                Debug.assert(!!nonRecursive === !!dirWatcher.nonRecursive);
                dirWatcher.refCount++;
            } else directoryWatchesOfFailedLookups.set(dirPath, {
                watcher: createDirectoryWatcher(dir, dirPath, nonRecursive),
                refCount: 1,
                nonRecursive: nonRecursive
            });
        }
        function stopWatchFailedLookupLocation(failedLookupLocation, removeAtRoot) {
            const failedLookupLocationPath = resolutionHost.toPath(failedLookupLocation);
            const toWatch = getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath, rootDir, rootPath, rootPathComponents, getCurrentDirectory);
            if (toWatch) {
                const { dirPath: dirPath  } = toWatch;
                if (dirPath === rootPath) removeAtRoot = true;
                else removeDirectoryWatcher(dirPath);
            }
            return removeAtRoot;
        }
        function stopWatchFailedLookupLocationOfResolution(resolution, filePath, getResolutionWithResolvedFileName) {
            Debug.checkDefined(resolution.files).delete(filePath);
            resolution.refCount--;
            if (resolution.refCount) return;
            const resolved = getResolutionWithResolvedFileName(resolution);
            if (resolved && resolved.resolvedFileName) {
                const key = resolutionHost.toPath(resolved.resolvedFileName);
                const resolutions = resolvedFileToResolution.get(key);
                if ((resolutions == null ? void 0 : resolutions.delete(resolution)) && !resolutions.size) resolvedFileToResolution.delete(key);
            }
            const { failedLookupLocations: failedLookupLocations , affectingLocations: affectingLocations , node10Result: node10Result  } = resolution;
            if (resolutionsWithFailedLookups.delete(resolution)) {
                let removeAtRoot = false;
                if (failedLookupLocations) for (const failedLookupLocation of failedLookupLocations)removeAtRoot = stopWatchFailedLookupLocation(failedLookupLocation, removeAtRoot);
                if (node10Result) removeAtRoot = stopWatchFailedLookupLocation(node10Result, removeAtRoot);
                if (removeAtRoot) removeDirectoryWatcher(rootPath);
            } else if (affectingLocations == null ? void 0 : affectingLocations.length) resolutionsWithOnlyAffectingLocations.delete(resolution);
            if (affectingLocations) for (const affectingLocation of affectingLocations){
                const watcher = fileWatchesOfAffectingLocations.get(affectingLocation);
                watcher.resolutions--;
            }
        }
        function removeDirectoryWatcher(dirPath) {
            const dirWatcher = directoryWatchesOfFailedLookups.get(dirPath);
            dirWatcher.refCount--;
        }
        function createDirectoryWatcher(directory, dirPath, nonRecursive) {
            return resolutionHost.watchDirectoryOfFailedLookupLocation(directory, (fileOrDirectory)=>{
                const fileOrDirectoryPath = resolutionHost.toPath(fileOrDirectory);
                if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
                scheduleInvalidateResolutionOfFailedLookupLocation(fileOrDirectoryPath, dirPath === fileOrDirectoryPath);
            }, nonRecursive ? 0 /* None */  : 1 /* Recursive */ );
        }
        function removeResolutionsOfFileFromCache(cache, filePath, getResolutionWithResolvedFileName) {
            const resolutions = cache.get(filePath);
            if (resolutions) {
                resolutions.forEach((resolution)=>stopWatchFailedLookupLocationOfResolution(resolution, filePath, getResolutionWithResolvedFileName));
                cache.delete(filePath);
            }
        }
        function removeResolutionsFromProjectReferenceRedirects(filePath) {
            if (!fileExtensionIs(filePath, ".json" /* Json */ )) return;
            const program = resolutionHost.getCurrentProgram();
            if (!program) return;
            const resolvedProjectReference = program.getResolvedProjectReferenceByPath(filePath);
            if (!resolvedProjectReference) return;
            resolvedProjectReference.commandLine.fileNames.forEach((f)=>removeResolutionsOfFile(resolutionHost.toPath(f)));
        }
        function removeResolutionsOfFile(filePath) {
            removeResolutionsOfFileFromCache(resolvedModuleNames, filePath, getResolvedModule2);
            removeResolutionsOfFileFromCache(resolvedTypeReferenceDirectives, filePath, getResolvedTypeReferenceDirective2);
        }
        function invalidateResolutions(resolutions, canInvalidate) {
            if (!resolutions) return false;
            let invalidated = false;
            resolutions.forEach((resolution)=>{
                if (resolution.isInvalidated || !canInvalidate(resolution)) return;
                resolution.isInvalidated = invalidated = true;
                for (const containingFilePath of Debug.checkDefined(resolution.files)){
                    (filesWithInvalidatedResolutions ?? (filesWithInvalidatedResolutions = /* @__PURE__ */ new Set())).add(containingFilePath);
                    hasChangedAutomaticTypeDirectiveNames = hasChangedAutomaticTypeDirectiveNames || endsWith(containingFilePath, inferredTypesContainingFile);
                }
            });
            return invalidated;
        }
        function invalidateResolutionOfFile(filePath) {
            removeResolutionsOfFile(filePath);
            const prevHasChangedAutomaticTypeDirectiveNames = hasChangedAutomaticTypeDirectiveNames;
            if (invalidateResolutions(resolvedFileToResolution.get(filePath), returnTrue) && hasChangedAutomaticTypeDirectiveNames && !prevHasChangedAutomaticTypeDirectiveNames) resolutionHost.onChangedAutomaticTypeDirectiveNames();
        }
        function setFilesWithInvalidatedNonRelativeUnresolvedImports(filesMap) {
            Debug.assert(filesWithInvalidatedNonRelativeUnresolvedImports === filesMap || filesWithInvalidatedNonRelativeUnresolvedImports === void 0);
            filesWithInvalidatedNonRelativeUnresolvedImports = filesMap;
        }
        function scheduleInvalidateResolutionOfFailedLookupLocation(fileOrDirectoryPath, isCreatingWatchedDirectory) {
            if (isCreatingWatchedDirectory) (isInDirectoryChecks || (isInDirectoryChecks = /* @__PURE__ */ new Set())).add(fileOrDirectoryPath);
            else {
                const updatedPath = removeIgnoredPath(fileOrDirectoryPath);
                if (!updatedPath) return false;
                fileOrDirectoryPath = updatedPath;
                if (resolutionHost.fileIsOpen(fileOrDirectoryPath)) return false;
                const dirOfFileOrDirectory = getDirectoryPath(fileOrDirectoryPath);
                if (isNodeModulesAtTypesDirectory(fileOrDirectoryPath) || isNodeModulesDirectory(fileOrDirectoryPath) || isNodeModulesAtTypesDirectory(dirOfFileOrDirectory) || isNodeModulesDirectory(dirOfFileOrDirectory)) {
                    (failedLookupChecks || (failedLookupChecks = /* @__PURE__ */ new Set())).add(fileOrDirectoryPath);
                    (startsWithPathChecks || (startsWithPathChecks = /* @__PURE__ */ new Set())).add(fileOrDirectoryPath);
                } else {
                    if (isEmittedFileOfProgram(resolutionHost.getCurrentProgram(), fileOrDirectoryPath)) return false;
                    if (fileExtensionIs(fileOrDirectoryPath, ".map")) return false;
                    (failedLookupChecks || (failedLookupChecks = /* @__PURE__ */ new Set())).add(fileOrDirectoryPath);
                    const packagePath = parseNodeModuleFromPath(fileOrDirectoryPath, /*isFolder*/ true);
                    if (packagePath) (startsWithPathChecks || (startsWithPathChecks = /* @__PURE__ */ new Set())).add(packagePath);
                }
            }
            resolutionHost.scheduleInvalidateResolutionsOfFailedLookupLocations();
        }
        function invalidatePackageJsonMap() {
            const packageJsonMap = moduleResolutionCache.getPackageJsonInfoCache().getInternalMap();
            if (packageJsonMap && (failedLookupChecks || startsWithPathChecks || isInDirectoryChecks)) packageJsonMap.forEach((_value, path)=>isInvalidatedFailedLookup(path) ? packageJsonMap.delete(path) : void 0);
        }
        function invalidateResolutionsOfFailedLookupLocations() {
            var _a;
            if (allModuleAndTypeResolutionsAreInvalidated) {
                affectingPathChecksForFile = void 0;
                invalidatePackageJsonMap();
                if (failedLookupChecks || startsWithPathChecks || isInDirectoryChecks || affectingPathChecks) invalidateResolutions(resolvedLibraries, canInvalidateFailedLookupResolution);
                failedLookupChecks = void 0;
                startsWithPathChecks = void 0;
                isInDirectoryChecks = void 0;
                affectingPathChecks = void 0;
                return true;
            }
            let invalidated = false;
            if (affectingPathChecksForFile) {
                (_a = resolutionHost.getCurrentProgram()) == null || _a.getSourceFiles().forEach((f)=>{
                    if (some(f.packageJsonLocations, (location)=>affectingPathChecksForFile.has(location))) {
                        (filesWithInvalidatedResolutions ?? (filesWithInvalidatedResolutions = /* @__PURE__ */ new Set())).add(f.path);
                        invalidated = true;
                    }
                });
                affectingPathChecksForFile = void 0;
            }
            if (!failedLookupChecks && !startsWithPathChecks && !isInDirectoryChecks && !affectingPathChecks) return invalidated;
            invalidated = invalidateResolutions(resolutionsWithFailedLookups, canInvalidateFailedLookupResolution) || invalidated;
            invalidatePackageJsonMap();
            failedLookupChecks = void 0;
            startsWithPathChecks = void 0;
            isInDirectoryChecks = void 0;
            invalidated = invalidateResolutions(resolutionsWithOnlyAffectingLocations, canInvalidatedFailedLookupResolutionWithAffectingLocation) || invalidated;
            affectingPathChecks = void 0;
            return invalidated;
        }
        function canInvalidateFailedLookupResolution(resolution) {
            var _a;
            if (canInvalidatedFailedLookupResolutionWithAffectingLocation(resolution)) return true;
            if (!failedLookupChecks && !startsWithPathChecks && !isInDirectoryChecks) return false;
            return ((_a = resolution.failedLookupLocations) == null ? void 0 : _a.some((location)=>isInvalidatedFailedLookup(resolutionHost.toPath(location)))) || !!resolution.node10Result && isInvalidatedFailedLookup(resolutionHost.toPath(resolution.node10Result));
        }
        function isInvalidatedFailedLookup(locationPath) {
            return (failedLookupChecks == null ? void 0 : failedLookupChecks.has(locationPath)) || firstDefinedIterator((startsWithPathChecks == null ? void 0 : startsWithPathChecks.keys()) || [], (fileOrDirectoryPath)=>startsWith(locationPath, fileOrDirectoryPath) ? true : void 0) || firstDefinedIterator((isInDirectoryChecks == null ? void 0 : isInDirectoryChecks.keys()) || [], (dirPath)=>locationPath.length > dirPath.length && startsWith(locationPath, dirPath) && (isDiskPathRoot(dirPath) || locationPath[dirPath.length] === directorySeparator) ? true : void 0);
        }
        function canInvalidatedFailedLookupResolutionWithAffectingLocation(resolution) {
            var _a;
            return !!affectingPathChecks && ((_a = resolution.affectingLocations) == null ? void 0 : _a.some((location)=>affectingPathChecks.has(location)));
        }
        function closeTypeRootsWatch() {
            clearMap(typeRootsWatches, closeFileWatcher);
        }
        function createTypeRootsWatch(typeRootPath, typeRoot) {
            return canWatchTypeRootPath(typeRootPath) ? resolutionHost.watchTypeRootsDirectory(typeRoot, (fileOrDirectory)=>{
                const fileOrDirectoryPath = resolutionHost.toPath(fileOrDirectory);
                if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
                hasChangedAutomaticTypeDirectiveNames = true;
                resolutionHost.onChangedAutomaticTypeDirectiveNames();
                const dirPath = getDirectoryToWatchFailedLookupLocationFromTypeRoot(typeRoot, typeRootPath, rootPath, rootPathComponents, getCurrentDirectory, (dirPath2)=>directoryWatchesOfFailedLookups.has(dirPath2));
                if (dirPath) scheduleInvalidateResolutionOfFailedLookupLocation(fileOrDirectoryPath, dirPath === fileOrDirectoryPath);
            }, 1 /* Recursive */ ) : noopFileWatcher;
        }
        function updateTypeRootsWatch() {
            const options = resolutionHost.getCompilationSettings();
            if (options.types) {
                closeTypeRootsWatch();
                return;
            }
            const typeRoots = getEffectiveTypeRoots(options, {
                getCurrentDirectory: getCurrentDirectory
            });
            if (typeRoots) mutateMap(typeRootsWatches, arrayToMap(typeRoots, (tr)=>resolutionHost.toPath(tr)), {
                createNewValue: createTypeRootsWatch,
                onDeleteValue: closeFileWatcher
            });
            else closeTypeRootsWatch();
        }
        function canWatchTypeRootPath(typeRoot) {
            if (resolutionHost.getCompilationSettings().typeRoots) return true;
            return canWatchAtTypes(resolutionHost.toPath(typeRoot));
        }
    }
    function resolutionIsSymlink(resolution) {
        var _a, _b;
        return !!(((_a = resolution.resolvedModule) == null ? void 0 : _a.originalPath) || ((_b = resolution.resolvedTypeReferenceDirective) == null ? void 0 : _b.originalPath));
    }
    var init_resolutionCache = __esm({
        "src/compiler/resolutionCache.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/watch.ts
    function createDiagnosticReporter(system, pretty) {
        const host = system === sys && sysFormatDiagnosticsHost ? sysFormatDiagnosticsHost : {
            getCurrentDirectory: ()=>system.getCurrentDirectory(),
            getNewLine: ()=>system.newLine,
            getCanonicalFileName: createGetCanonicalFileName(system.useCaseSensitiveFileNames)
        };
        if (!pretty) return (diagnostic)=>system.write(formatDiagnostic(diagnostic, host));
        const diagnostics = new Array(1);
        return (diagnostic)=>{
            diagnostics[0] = diagnostic;
            system.write(formatDiagnosticsWithColorAndContext(diagnostics, host) + host.getNewLine());
            diagnostics[0] = void 0;
        };
    }
    function clearScreenIfNotWatchingForFileChanges(system, diagnostic, options) {
        if (system.clearScreen && !options.preserveWatchOutput && !options.extendedDiagnostics && !options.diagnostics && contains(screenStartingMessageCodes, diagnostic.code)) {
            system.clearScreen();
            return true;
        }
        return false;
    }
    function getPlainDiagnosticFollowingNewLines(diagnostic, newLine) {
        return contains(screenStartingMessageCodes, diagnostic.code) ? newLine + newLine : newLine;
    }
    function getLocaleTimeString(system) {
        return !system.now ? /* @__PURE__ */ new Date().toLocaleTimeString() : // On some systems / builds of Node, there's a non-breaking space between the time and AM/PM.
        // This branch is solely for testing, so just switch it to a normal space for baseline stability.
        // See:
        //     - https://github.com/nodejs/node/issues/45171
        //     - https://github.com/nodejs/node/issues/45753
        system.now().toLocaleTimeString("en-US", {
            timeZone: "UTC"
        }).replace(" ", " ");
    }
    function createWatchStatusReporter(system, pretty) {
        return pretty ? (diagnostic, newLine, options)=>{
            clearScreenIfNotWatchingForFileChanges(system, diagnostic, options);
            let output = `[${formatColorAndReset(getLocaleTimeString(system), "\x1b[90m" /* Grey */ )}] `;
            output += `${flattenDiagnosticMessageText(diagnostic.messageText, system.newLine)}${newLine + newLine}`;
            system.write(output);
        } : (diagnostic, newLine, options)=>{
            let output = "";
            if (!clearScreenIfNotWatchingForFileChanges(system, diagnostic, options)) output += newLine;
            output += `${getLocaleTimeString(system)} - `;
            output += `${flattenDiagnosticMessageText(diagnostic.messageText, system.newLine)}${getPlainDiagnosticFollowingNewLines(diagnostic, newLine)}`;
            system.write(output);
        };
    }
    function parseConfigFileWithSystem(configFileName, optionsToExtend, extendedConfigCache, watchOptionsToExtend, system, reportDiagnostic) {
        const host = system;
        host.onUnRecoverableConfigFileDiagnostic = (diagnostic)=>reportUnrecoverableDiagnostic(system, reportDiagnostic, diagnostic);
        const result = getParsedCommandLineOfConfigFile(configFileName, optionsToExtend, host, extendedConfigCache, watchOptionsToExtend);
        host.onUnRecoverableConfigFileDiagnostic = void 0;
        return result;
    }
    function getErrorCountForSummary(diagnostics) {
        return countWhere(diagnostics, (diagnostic)=>diagnostic.category === 1 /* Error */ );
    }
    function getFilesInErrorForSummary(diagnostics) {
        const filesInError = filter(diagnostics, (diagnostic)=>diagnostic.category === 1 /* Error */ ).map((errorDiagnostic)=>{
            if (errorDiagnostic.file === void 0) return;
            return `${errorDiagnostic.file.fileName}`;
        });
        return filesInError.map((fileName)=>{
            if (fileName === void 0) return void 0;
            const diagnosticForFileName = find(diagnostics, (diagnostic)=>diagnostic.file !== void 0 && diagnostic.file.fileName === fileName);
            if (diagnosticForFileName !== void 0) {
                const { line: line  } = getLineAndCharacterOfPosition(diagnosticForFileName.file, diagnosticForFileName.start);
                return {
                    fileName: fileName,
                    line: line + 1
                };
            }
        });
    }
    function getWatchErrorSummaryDiagnosticMessage(errorCount) {
        return errorCount === 1 ? Diagnostics.Found_1_error_Watching_for_file_changes : Diagnostics.Found_0_errors_Watching_for_file_changes;
    }
    function prettyPathForFileError(error, cwd) {
        const line = formatColorAndReset(":" + error.line, "\x1b[90m" /* Grey */ );
        if (pathIsAbsolute(error.fileName) && pathIsAbsolute(cwd)) return getRelativePathFromDirectory(cwd, error.fileName, /*ignoreCase*/ false) + line;
        return error.fileName + line;
    }
    function getErrorSummaryText(errorCount, filesInError, newLine, host) {
        if (errorCount === 0) return "";
        const nonNilFiles = filesInError.filter((fileInError)=>fileInError !== void 0);
        const distinctFileNamesWithLines = nonNilFiles.map((fileInError)=>`${fileInError.fileName}:${fileInError.line}`).filter((value1, index, self)=>self.indexOf(value1) === index);
        const firstFileReference = nonNilFiles[0] && prettyPathForFileError(nonNilFiles[0], host.getCurrentDirectory());
        let messageAndArgs;
        if (errorCount === 1) messageAndArgs = filesInError[0] !== void 0 ? [
            Diagnostics.Found_1_error_in_0,
            firstFileReference
        ] : [
            Diagnostics.Found_1_error
        ];
        else messageAndArgs = distinctFileNamesWithLines.length === 0 ? [
            Diagnostics.Found_0_errors,
            errorCount
        ] : distinctFileNamesWithLines.length === 1 ? [
            Diagnostics.Found_0_errors_in_the_same_file_starting_at_Colon_1,
            errorCount,
            firstFileReference
        ] : [
            Diagnostics.Found_0_errors_in_1_files,
            errorCount,
            distinctFileNamesWithLines.length
        ];
        const d = createCompilerDiagnostic(...messageAndArgs);
        const suffix = distinctFileNamesWithLines.length > 1 ? createTabularErrorsDisplay(nonNilFiles, host) : "";
        return `${newLine}${flattenDiagnosticMessageText(d.messageText, newLine)}${newLine}${newLine}${suffix}`;
    }
    function createTabularErrorsDisplay(filesInError, host) {
        const distinctFiles = filesInError.filter((value1, index, self)=>index === self.findIndex((file)=>(file == null ? void 0 : file.fileName) === (value1 == null ? void 0 : value1.fileName)));
        if (distinctFiles.length === 0) return "";
        const numberLength = (num)=>Math.log(num) * Math.LOG10E + 1;
        const fileToErrorCount = distinctFiles.map((file)=>[
                file,
                countWhere(filesInError, (fileInError)=>fileInError.fileName === file.fileName)
            ]);
        const maxErrors = fileToErrorCount.reduce((acc, value1)=>Math.max(acc, value1[1] || 0), 0);
        const headerRow = Diagnostics.Errors_Files.message;
        const leftColumnHeadingLength = headerRow.split(" ")[0].length;
        const leftPaddingGoal = Math.max(leftColumnHeadingLength, numberLength(maxErrors));
        const headerPadding = Math.max(numberLength(maxErrors) - leftColumnHeadingLength, 0);
        let tabularData = "";
        tabularData += " ".repeat(headerPadding) + headerRow + "\n";
        fileToErrorCount.forEach((row)=>{
            const [file, errorCount] = row;
            const errorCountDigitsLength = Math.log(errorCount) * Math.LOG10E + 1 | 0;
            const leftPadding = errorCountDigitsLength < leftPaddingGoal ? " ".repeat(leftPaddingGoal - errorCountDigitsLength) : "";
            const fileRef = prettyPathForFileError(file, host.getCurrentDirectory());
            tabularData += `${leftPadding}${errorCount}  ${fileRef}
`;
        });
        return tabularData;
    }
    function isBuilderProgram2(program) {
        return !!program.getState;
    }
    function listFiles(program, write) {
        const options = program.getCompilerOptions();
        if (options.explainFiles) explainFiles(isBuilderProgram2(program) ? program.getProgram() : program, write);
        else if (options.listFiles || options.listFilesOnly) forEach(program.getSourceFiles(), (file)=>{
            write(file.fileName);
        });
    }
    function explainFiles(program, write) {
        var _a, _b;
        const reasons = program.getFileIncludeReasons();
        const relativeFileName = (fileName)=>convertToRelativePath(fileName, program.getCurrentDirectory(), program.getCanonicalFileName);
        for (const file of program.getSourceFiles()){
            write(`${toFileName(file, relativeFileName)}`);
            (_a = reasons.get(file.path)) == null || _a.forEach((reason)=>write(`  ${fileIncludeReasonToDiagnostics(program, reason, relativeFileName).messageText}`));
            (_b = explainIfFileIsRedirectAndImpliedFormat(file, relativeFileName)) == null || _b.forEach((d)=>write(`  ${d.messageText}`));
        }
    }
    function explainIfFileIsRedirectAndImpliedFormat(file, fileNameConvertor) {
        var _a;
        let result;
        if (file.path !== file.resolvedPath) (result ?? (result = [])).push(chainDiagnosticMessages(/*details*/ void 0, Diagnostics.File_is_output_of_project_reference_source_0, toFileName(file.originalFileName, fileNameConvertor)));
        if (file.redirectInfo) (result ?? (result = [])).push(chainDiagnosticMessages(/*details*/ void 0, Diagnostics.File_redirects_to_file_0, toFileName(file.redirectInfo.redirectTarget, fileNameConvertor)));
        if (isExternalOrCommonJsModule(file)) switch(file.impliedNodeFormat){
            case 99 /* ESNext */ :
                if (file.packageJsonScope) (result ?? (result = [])).push(chainDiagnosticMessages(/*details*/ void 0, Diagnostics.File_is_ECMAScript_module_because_0_has_field_type_with_value_module, toFileName(last(file.packageJsonLocations), fileNameConvertor)));
                break;
            case 1 /* CommonJS */ :
                if (file.packageJsonScope) (result ?? (result = [])).push(chainDiagnosticMessages(/*details*/ void 0, file.packageJsonScope.contents.packageJsonContent.type ? Diagnostics.File_is_CommonJS_module_because_0_has_field_type_whose_value_is_not_module : Diagnostics.File_is_CommonJS_module_because_0_does_not_have_field_type, toFileName(last(file.packageJsonLocations), fileNameConvertor)));
                else if ((_a = file.packageJsonLocations) == null ? void 0 : _a.length) (result ?? (result = [])).push(chainDiagnosticMessages(/*details*/ void 0, Diagnostics.File_is_CommonJS_module_because_package_json_was_not_found));
                break;
        }
        return result;
    }
    function getMatchedFileSpec(program, fileName) {
        var _a;
        const configFile = program.getCompilerOptions().configFile;
        if (!((_a = configFile == null ? void 0 : configFile.configFileSpecs) == null ? void 0 : _a.validatedFilesSpec)) return void 0;
        const filePath = program.getCanonicalFileName(fileName);
        const basePath = getDirectoryPath(getNormalizedAbsolutePath(configFile.fileName, program.getCurrentDirectory()));
        return find(configFile.configFileSpecs.validatedFilesSpec, (fileSpec)=>program.getCanonicalFileName(getNormalizedAbsolutePath(fileSpec, basePath)) === filePath);
    }
    function getMatchedIncludeSpec(program, fileName) {
        var _a, _b;
        const configFile = program.getCompilerOptions().configFile;
        if (!((_a = configFile == null ? void 0 : configFile.configFileSpecs) == null ? void 0 : _a.validatedIncludeSpecs)) return void 0;
        if (configFile.configFileSpecs.isDefaultIncludeSpec) return true;
        const isJsonFile = fileExtensionIs(fileName, ".json" /* Json */ );
        const basePath = getDirectoryPath(getNormalizedAbsolutePath(configFile.fileName, program.getCurrentDirectory()));
        const useCaseSensitiveFileNames = program.useCaseSensitiveFileNames();
        return find((_b = configFile == null ? void 0 : configFile.configFileSpecs) == null ? void 0 : _b.validatedIncludeSpecs, (includeSpec)=>{
            if (isJsonFile && !endsWith(includeSpec, ".json" /* Json */ )) return false;
            const pattern = getPatternFromSpec(includeSpec, basePath, "files");
            return !!pattern && getRegexFromPattern(`(${pattern})$`, useCaseSensitiveFileNames).test(fileName);
        });
    }
    function fileIncludeReasonToDiagnostics(program, reason, fileNameConvertor) {
        var _a, _b;
        const options = program.getCompilerOptions();
        if (isReferencedFile(reason)) {
            const referenceLocation = getReferencedFileLocation((path)=>program.getSourceFileByPath(path), reason);
            const referenceText = isReferenceFileLocation(referenceLocation) ? referenceLocation.file.text.substring(referenceLocation.pos, referenceLocation.end) : `"${referenceLocation.text}"`;
            let message;
            Debug.assert(isReferenceFileLocation(referenceLocation) || reason.kind === 3 /* Import */ , "Only synthetic references are imports");
            switch(reason.kind){
                case 3 /* Import */ :
                    if (isReferenceFileLocation(referenceLocation)) message = referenceLocation.packageId ? Diagnostics.Imported_via_0_from_file_1_with_packageId_2 : Diagnostics.Imported_via_0_from_file_1;
                    else if (referenceLocation.text === externalHelpersModuleNameText) message = referenceLocation.packageId ? Diagnostics.Imported_via_0_from_file_1_with_packageId_2_to_import_importHelpers_as_specified_in_compilerOptions : Diagnostics.Imported_via_0_from_file_1_to_import_importHelpers_as_specified_in_compilerOptions;
                    else message = referenceLocation.packageId ? Diagnostics.Imported_via_0_from_file_1_with_packageId_2_to_import_jsx_and_jsxs_factory_functions : Diagnostics.Imported_via_0_from_file_1_to_import_jsx_and_jsxs_factory_functions;
                    break;
                case 4 /* ReferenceFile */ :
                    Debug.assert(!referenceLocation.packageId);
                    message = Diagnostics.Referenced_via_0_from_file_1;
                    break;
                case 5 /* TypeReferenceDirective */ :
                    message = referenceLocation.packageId ? Diagnostics.Type_library_referenced_via_0_from_file_1_with_packageId_2 : Diagnostics.Type_library_referenced_via_0_from_file_1;
                    break;
                case 7 /* LibReferenceDirective */ :
                    Debug.assert(!referenceLocation.packageId);
                    message = Diagnostics.Library_referenced_via_0_from_file_1;
                    break;
                default:
                    Debug.assertNever(reason);
            }
            return chainDiagnosticMessages(/*details*/ void 0, message, referenceText, toFileName(referenceLocation.file, fileNameConvertor), referenceLocation.packageId && packageIdToString(referenceLocation.packageId));
        }
        switch(reason.kind){
            case 0 /* RootFile */ :
                if (!((_a = options.configFile) == null ? void 0 : _a.configFileSpecs)) return chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Root_file_specified_for_compilation);
                const fileName = getNormalizedAbsolutePath(program.getRootFileNames()[reason.index], program.getCurrentDirectory());
                const matchedByFiles = getMatchedFileSpec(program, fileName);
                if (matchedByFiles) return chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Part_of_files_list_in_tsconfig_json);
                const matchedByInclude = getMatchedIncludeSpec(program, fileName);
                return isString(matchedByInclude) ? chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Matched_by_include_pattern_0_in_1, matchedByInclude, toFileName(options.configFile, fileNameConvertor)) : // Could be additional files specified as roots or matched by default include
                chainDiagnosticMessages(/*details*/ void 0, matchedByInclude ? Diagnostics.Matched_by_default_include_pattern_Asterisk_Asterisk_Slash_Asterisk : Diagnostics.Root_file_specified_for_compilation);
            case 1 /* SourceFromProjectReference */ :
            case 2 /* OutputFromProjectReference */ :
                const isOutput = reason.kind === 2 /* OutputFromProjectReference */ ;
                const referencedResolvedRef = Debug.checkDefined((_b = program.getResolvedProjectReferences()) == null ? void 0 : _b[reason.index]);
                return chainDiagnosticMessages(/*details*/ void 0, outFile(options) ? isOutput ? Diagnostics.Output_from_referenced_project_0_included_because_1_specified : Diagnostics.Source_from_referenced_project_0_included_because_1_specified : isOutput ? Diagnostics.Output_from_referenced_project_0_included_because_module_is_specified_as_none : Diagnostics.Source_from_referenced_project_0_included_because_module_is_specified_as_none, toFileName(referencedResolvedRef.sourceFile.fileName, fileNameConvertor), options.outFile ? "--outFile" : "--out");
            case 8 /* AutomaticTypeDirectiveFile */ :
                {
                    const messageAndArgs = options.types ? reason.packageId ? [
                        Diagnostics.Entry_point_of_type_library_0_specified_in_compilerOptions_with_packageId_1,
                        reason.typeReference,
                        packageIdToString(reason.packageId)
                    ] : [
                        Diagnostics.Entry_point_of_type_library_0_specified_in_compilerOptions,
                        reason.typeReference
                    ] : reason.packageId ? [
                        Diagnostics.Entry_point_for_implicit_type_library_0_with_packageId_1,
                        reason.typeReference,
                        packageIdToString(reason.packageId)
                    ] : [
                        Diagnostics.Entry_point_for_implicit_type_library_0,
                        reason.typeReference
                    ];
                    return chainDiagnosticMessages(/*details*/ void 0, ...messageAndArgs);
                }
            case 6 /* LibFile */ :
                {
                    if (reason.index !== void 0) return chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Library_0_specified_in_compilerOptions, options.lib[reason.index]);
                    const target = forEachEntry(targetOptionDeclaration.type, (value1, key)=>value1 === getEmitScriptTarget(options) ? key : void 0);
                    const messageAndArgs = target ? [
                        Diagnostics.Default_library_for_target_0,
                        target
                    ] : [
                        Diagnostics.Default_library
                    ];
                    return chainDiagnosticMessages(/*details*/ void 0, ...messageAndArgs);
                }
            default:
                Debug.assertNever(reason);
        }
    }
    function toFileName(file, fileNameConvertor) {
        const fileName = isString(file) ? file : file.fileName;
        return fileNameConvertor ? fileNameConvertor(fileName) : fileName;
    }
    function emitFilesAndReportErrors(program, reportDiagnostic, write, reportSummary, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers) {
        const isListFilesOnly = !!program.getCompilerOptions().listFilesOnly;
        const allDiagnostics = program.getConfigFileParsingDiagnostics().slice();
        const configFileParsingDiagnosticsLength = allDiagnostics.length;
        addRange(allDiagnostics, program.getSyntacticDiagnostics(/*sourceFile*/ void 0, cancellationToken));
        if (allDiagnostics.length === configFileParsingDiagnosticsLength) {
            addRange(allDiagnostics, program.getOptionsDiagnostics(cancellationToken));
            if (!isListFilesOnly) {
                addRange(allDiagnostics, program.getGlobalDiagnostics(cancellationToken));
                if (allDiagnostics.length === configFileParsingDiagnosticsLength) addRange(allDiagnostics, program.getSemanticDiagnostics(/*sourceFile*/ void 0, cancellationToken));
            }
        }
        const emitResult = isListFilesOnly ? {
            emitSkipped: true,
            diagnostics: emptyArray
        } : program.emit(/*targetSourceFile*/ void 0, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers);
        const { emittedFiles: emittedFiles , diagnostics: emitDiagnostics  } = emitResult;
        addRange(allDiagnostics, emitDiagnostics);
        const diagnostics = sortAndDeduplicateDiagnostics(allDiagnostics);
        diagnostics.forEach(reportDiagnostic);
        if (write) {
            const currentDir = program.getCurrentDirectory();
            forEach(emittedFiles, (file)=>{
                const filepath = getNormalizedAbsolutePath(file, currentDir);
                write(`TSFILE: ${filepath}`);
            });
            listFiles(program, write);
        }
        if (reportSummary) reportSummary(getErrorCountForSummary(diagnostics), getFilesInErrorForSummary(diagnostics));
        return {
            emitResult: emitResult,
            diagnostics: diagnostics
        };
    }
    function emitFilesAndReportErrorsAndGetExitStatus(program, reportDiagnostic, write, reportSummary, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers) {
        const { emitResult: emitResult , diagnostics: diagnostics  } = emitFilesAndReportErrors(program, reportDiagnostic, write, reportSummary, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers);
        if (emitResult.emitSkipped && diagnostics.length > 0) return 1 /* DiagnosticsPresent_OutputsSkipped */ ;
        else if (diagnostics.length > 0) return 2 /* DiagnosticsPresent_OutputsGenerated */ ;
        return 0 /* Success */ ;
    }
    function createWatchHost(system = sys, reportWatchStatus2) {
        const onWatchStatusChange = reportWatchStatus2 || createWatchStatusReporter(system);
        return {
            onWatchStatusChange: onWatchStatusChange,
            watchFile: maybeBind(system, system.watchFile) || returnNoopFileWatcher,
            watchDirectory: maybeBind(system, system.watchDirectory) || returnNoopFileWatcher,
            setTimeout: maybeBind(system, system.setTimeout) || noop,
            clearTimeout: maybeBind(system, system.clearTimeout) || noop
        };
    }
    function createWatchFactory(host, options) {
        const watchLogLevel = host.trace ? options.extendedDiagnostics ? 2 /* Verbose */  : options.diagnostics ? 1 /* TriggerOnly */  : 0 /* None */  : 0 /* None */ ;
        const writeLog = watchLogLevel !== 0 /* None */  ? (s)=>host.trace(s) : noop;
        const result = getWatchFactory(host, watchLogLevel, writeLog);
        result.writeLog = writeLog;
        return result;
    }
    function createCompilerHostFromProgramHost(host, getCompilerOptions, directoryStructureHost = host) {
        const useCaseSensitiveFileNames = host.useCaseSensitiveFileNames();
        const compilerHost = {
            getSourceFile: createGetSourceFile((fileName, encoding)=>!encoding ? compilerHost.readFile(fileName) : host.readFile(fileName, encoding), getCompilerOptions, /*setParentNodes*/ void 0),
            getDefaultLibLocation: maybeBind(host, host.getDefaultLibLocation),
            getDefaultLibFileName: (options)=>host.getDefaultLibFileName(options),
            writeFile: createWriteFileMeasuringIO((path, data, writeByteOrderMark)=>host.writeFile(path, data, writeByteOrderMark), (path)=>host.createDirectory(path), (path)=>host.directoryExists(path)),
            getCurrentDirectory: memoize(()=>host.getCurrentDirectory()),
            useCaseSensitiveFileNames: ()=>useCaseSensitiveFileNames,
            getCanonicalFileName: createGetCanonicalFileName(useCaseSensitiveFileNames),
            getNewLine: ()=>getNewLineCharacter(getCompilerOptions()),
            fileExists: (f)=>host.fileExists(f),
            readFile: (f)=>host.readFile(f),
            trace: maybeBind(host, host.trace),
            directoryExists: maybeBind(directoryStructureHost, directoryStructureHost.directoryExists),
            getDirectories: maybeBind(directoryStructureHost, directoryStructureHost.getDirectories),
            realpath: maybeBind(host, host.realpath),
            getEnvironmentVariable: maybeBind(host, host.getEnvironmentVariable) || (()=>""),
            createHash: maybeBind(host, host.createHash),
            readDirectory: maybeBind(host, host.readDirectory),
            storeFilesChangingSignatureDuringEmit: host.storeFilesChangingSignatureDuringEmit
        };
        return compilerHost;
    }
    function getSourceFileVersionAsHashFromText(host, text) {
        if (text.match(sourceMapCommentRegExpDontCareLineStart)) {
            let lineEnd = text.length;
            let lineStart = lineEnd;
            for(let pos = lineEnd - 1; pos >= 0; pos--){
                const ch = text.charCodeAt(pos);
                switch(ch){
                    case 10 /* lineFeed */ :
                        if (pos && text.charCodeAt(pos - 1) === 13 /* carriageReturn */ ) pos--;
                    case 13 /* carriageReturn */ :
                        break;
                    default:
                        if (ch < 127 /* maxAsciiCharacter */  || !isLineBreak(ch)) {
                            lineStart = pos;
                            continue;
                        }
                        break;
                }
                const line = text.substring(lineStart, lineEnd);
                if (line.match(sourceMapCommentRegExp)) {
                    text = text.substring(0, lineStart);
                    break;
                } else if (!line.match(whitespaceOrMapCommentRegExp)) break;
                lineEnd = lineStart;
            }
        }
        return (host.createHash || generateDjb2Hash)(text);
    }
    function setGetSourceFileAsHashVersioned(compilerHost) {
        const originalGetSourceFile = compilerHost.getSourceFile;
        compilerHost.getSourceFile = (...args)=>{
            const result = originalGetSourceFile.call(compilerHost, ...args);
            if (result) result.version = getSourceFileVersionAsHashFromText(compilerHost, result.text);
            return result;
        };
    }
    function createProgramHost(system, createProgram2) {
        const getDefaultLibLocation = memoize(()=>getDirectoryPath(normalizePath(system.getExecutingFilePath())));
        return {
            useCaseSensitiveFileNames: ()=>system.useCaseSensitiveFileNames,
            getNewLine: ()=>system.newLine,
            getCurrentDirectory: memoize(()=>system.getCurrentDirectory()),
            getDefaultLibLocation: getDefaultLibLocation,
            getDefaultLibFileName: (options)=>combinePaths(getDefaultLibLocation(), getDefaultLibFileName(options)),
            fileExists: (path)=>system.fileExists(path),
            readFile: (path, encoding)=>system.readFile(path, encoding),
            directoryExists: (path)=>system.directoryExists(path),
            getDirectories: (path)=>system.getDirectories(path),
            readDirectory: (path, extensions, exclude, include, depth)=>system.readDirectory(path, extensions, exclude, include, depth),
            realpath: maybeBind(system, system.realpath),
            getEnvironmentVariable: maybeBind(system, system.getEnvironmentVariable),
            trace: (s)=>system.write(s + system.newLine),
            createDirectory: (path)=>system.createDirectory(path),
            writeFile: (path, data, writeByteOrderMark)=>system.writeFile(path, data, writeByteOrderMark),
            createHash: maybeBind(system, system.createHash),
            createProgram: createProgram2 || createEmitAndSemanticDiagnosticsBuilderProgram,
            storeFilesChangingSignatureDuringEmit: system.storeFilesChangingSignatureDuringEmit,
            now: maybeBind(system, system.now)
        };
    }
    function createWatchCompilerHost(system = sys, createProgram2, reportDiagnostic, reportWatchStatus2) {
        const write = (s)=>system.write(s + system.newLine);
        const result = createProgramHost(system, createProgram2);
        copyProperties(result, createWatchHost(system, reportWatchStatus2));
        result.afterProgramCreate = (builderProgram)=>{
            const compilerOptions = builderProgram.getCompilerOptions();
            const newLine = getNewLineCharacter(compilerOptions);
            emitFilesAndReportErrors(builderProgram, reportDiagnostic, write, (errorCount)=>result.onWatchStatusChange(createCompilerDiagnostic(getWatchErrorSummaryDiagnosticMessage(errorCount), errorCount), newLine, compilerOptions, errorCount));
        };
        return result;
    }
    function reportUnrecoverableDiagnostic(system, reportDiagnostic, diagnostic) {
        reportDiagnostic(diagnostic);
        system.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
    }
    function createWatchCompilerHostOfConfigFile({ configFileName: configFileName , optionsToExtend: optionsToExtend , watchOptionsToExtend: watchOptionsToExtend , extraFileExtensions: extraFileExtensions , system: system , createProgram: createProgram2 , reportDiagnostic: reportDiagnostic , reportWatchStatus: reportWatchStatus2  }) {
        const diagnosticReporter = reportDiagnostic || createDiagnosticReporter(system);
        const host = createWatchCompilerHost(system, createProgram2, diagnosticReporter, reportWatchStatus2);
        host.onUnRecoverableConfigFileDiagnostic = (diagnostic)=>reportUnrecoverableDiagnostic(system, diagnosticReporter, diagnostic);
        host.configFileName = configFileName;
        host.optionsToExtend = optionsToExtend;
        host.watchOptionsToExtend = watchOptionsToExtend;
        host.extraFileExtensions = extraFileExtensions;
        return host;
    }
    function createWatchCompilerHostOfFilesAndCompilerOptions({ rootFiles: rootFiles , options: options , watchOptions: watchOptions , projectReferences: projectReferences , system: system , createProgram: createProgram2 , reportDiagnostic: reportDiagnostic , reportWatchStatus: reportWatchStatus2  }) {
        const host = createWatchCompilerHost(system, createProgram2, reportDiagnostic || createDiagnosticReporter(system), reportWatchStatus2);
        host.rootFiles = rootFiles;
        host.options = options;
        host.watchOptions = watchOptions;
        host.projectReferences = projectReferences;
        return host;
    }
    function performIncrementalCompilation(input) {
        const system = input.system || sys;
        const host = input.host || (input.host = createIncrementalCompilerHost(input.options, system));
        const builderProgram = createIncrementalProgram(input);
        const exitStatus = emitFilesAndReportErrorsAndGetExitStatus(builderProgram, input.reportDiagnostic || createDiagnosticReporter(system), (s)=>host.trace && host.trace(s), input.reportErrorSummary || input.options.pretty ? (errorCount, filesInError)=>system.write(getErrorSummaryText(errorCount, filesInError, system.newLine, host)) : void 0);
        if (input.afterProgramEmitAndDiagnostics) input.afterProgramEmitAndDiagnostics(builderProgram);
        return exitStatus;
    }
    var sysFormatDiagnosticsHost, screenStartingMessageCodes, noopFileWatcher, returnNoopFileWatcher, WatchType;
    var init_watch = __esm({
        "src/compiler/watch.ts" () {
            "use strict";
            init_ts2();
            sysFormatDiagnosticsHost = sys ? {
                getCurrentDirectory: ()=>sys.getCurrentDirectory(),
                getNewLine: ()=>sys.newLine,
                getCanonicalFileName: createGetCanonicalFileName(sys.useCaseSensitiveFileNames)
            } : void 0;
            screenStartingMessageCodes = [
                Diagnostics.Starting_compilation_in_watch_mode.code,
                Diagnostics.File_change_detected_Starting_incremental_compilation.code
            ];
            noopFileWatcher = {
                close: noop
            };
            returnNoopFileWatcher = ()=>noopFileWatcher;
            WatchType = {
                ConfigFile: "Config file",
                ExtendedConfigFile: "Extended config file",
                SourceFile: "Source file",
                MissingFile: "Missing file",
                WildcardDirectory: "Wild card directory",
                FailedLookupLocations: "Failed Lookup Locations",
                AffectingFileLocation: "File location affecting resolution",
                TypeRoots: "Type roots",
                ConfigFileOfReferencedProject: "Config file of referened project",
                ExtendedConfigOfReferencedProject: "Extended config file of referenced project",
                WildcardDirectoryOfReferencedProject: "Wild card directory of referenced project",
                PackageJson: "package.json file",
                ClosedScriptInfo: "Closed Script info",
                ConfigFileForInferredRoot: "Config file for the inferred project root",
                NodeModules: "node_modules for closed script infos and package.jsons affecting module specifier cache",
                MissingSourceMapFile: "Missing source map file",
                NoopConfigFileForInferredRoot: "Noop Config file for the inferred project root",
                MissingGeneratedFile: "Missing generated file",
                NodeModulesForModuleSpecifierCache: "node_modules for module specifier cache invalidation",
                TypingInstallerLocationFile: "File location for typing installer",
                TypingInstallerLocationDirectory: "Directory location for typing installer"
            };
        }
    });
    // src/compiler/watchPublic.ts
    function readBuilderProgram(compilerOptions, host) {
        const buildInfoPath = getTsBuildInfoEmitOutputFilePath(compilerOptions);
        if (!buildInfoPath) return void 0;
        let buildInfo;
        if (host.getBuildInfo) buildInfo = host.getBuildInfo(buildInfoPath, compilerOptions.configFilePath);
        else {
            const content = host.readFile(buildInfoPath);
            if (!content) return void 0;
            buildInfo = getBuildInfo(buildInfoPath, content);
        }
        if (!buildInfo || buildInfo.version !== version || !buildInfo.program) return void 0;
        return createBuilderProgramUsingProgramBuildInfo(buildInfo, buildInfoPath, host);
    }
    function createIncrementalCompilerHost(options, system = sys) {
        const host = createCompilerHostWorker(options, /*setParentNodes*/ void 0, system);
        host.createHash = maybeBind(system, system.createHash);
        host.storeFilesChangingSignatureDuringEmit = system.storeFilesChangingSignatureDuringEmit;
        setGetSourceFileAsHashVersioned(host);
        changeCompilerHostLikeToUseCache(host, (fileName)=>toPath(fileName, host.getCurrentDirectory(), host.getCanonicalFileName));
        return host;
    }
    function createIncrementalProgram({ rootNames: rootNames , options: options , configFileParsingDiagnostics: configFileParsingDiagnostics , projectReferences: projectReferences , host: host , createProgram: createProgram2  }) {
        host = host || createIncrementalCompilerHost(options);
        createProgram2 = createProgram2 || createEmitAndSemanticDiagnosticsBuilderProgram;
        const oldProgram = readBuilderProgram(options, host);
        return createProgram2(rootNames, options, host, oldProgram, configFileParsingDiagnostics, projectReferences);
    }
    function createWatchCompilerHost2(rootFilesOrConfigFileName, options, system, createProgram2, reportDiagnostic, reportWatchStatus2, projectReferencesOrWatchOptionsToExtend, watchOptionsOrExtraFileExtensions) {
        if (isArray(rootFilesOrConfigFileName)) return createWatchCompilerHostOfFilesAndCompilerOptions({
            rootFiles: rootFilesOrConfigFileName,
            options: options,
            watchOptions: watchOptionsOrExtraFileExtensions,
            projectReferences: projectReferencesOrWatchOptionsToExtend,
            system: system,
            createProgram: createProgram2,
            reportDiagnostic: reportDiagnostic,
            reportWatchStatus: reportWatchStatus2
        });
        else return createWatchCompilerHostOfConfigFile({
            configFileName: rootFilesOrConfigFileName,
            optionsToExtend: options,
            watchOptionsToExtend: projectReferencesOrWatchOptionsToExtend,
            extraFileExtensions: watchOptionsOrExtraFileExtensions,
            system: system,
            createProgram: createProgram2,
            reportDiagnostic: reportDiagnostic,
            reportWatchStatus: reportWatchStatus2
        });
    }
    function createWatchProgram(host) {
        let builderProgram;
        let reloadLevel;
        let missingFilesMap;
        let watchedWildcardDirectories;
        let timerToUpdateProgram;
        let timerToInvalidateFailedLookupResolutions;
        let parsedConfigs;
        let sharedExtendedConfigFileWatchers;
        let extendedConfigCache = host.extendedConfigCache;
        let reportFileChangeDetectedOnCreateProgram = false;
        const sourceFilesCache = /* @__PURE__ */ new Map();
        let missingFilePathsRequestedForRelease;
        let hasChangedCompilerOptions = false;
        const useCaseSensitiveFileNames = host.useCaseSensitiveFileNames();
        const currentDirectory = host.getCurrentDirectory();
        const { configFileName: configFileName , optionsToExtend: optionsToExtendForConfigFile = {} , watchOptionsToExtend: watchOptionsToExtend , extraFileExtensions: extraFileExtensions , createProgram: createProgram2  } = host;
        let { rootFiles: rootFileNames , options: compilerOptions , watchOptions: watchOptions , projectReferences: projectReferences  } = host;
        let wildcardDirectories;
        let configFileParsingDiagnostics;
        let canConfigFileJsonReportNoInputFiles = false;
        let hasChangedConfigFileParsingErrors = false;
        const cachedDirectoryStructureHost = configFileName === void 0 ? void 0 : createCachedDirectoryStructureHost(host, currentDirectory, useCaseSensitiveFileNames);
        const directoryStructureHost = cachedDirectoryStructureHost || host;
        const parseConfigFileHost = parseConfigHostFromCompilerHostLike(host, directoryStructureHost);
        let newLine = updateNewLine();
        if (configFileName && host.configFileParsingResult) {
            setConfigFileParsingResult(host.configFileParsingResult);
            newLine = updateNewLine();
        }
        reportWatchDiagnostic(Diagnostics.Starting_compilation_in_watch_mode);
        if (configFileName && !host.configFileParsingResult) {
            newLine = getNewLineCharacter(optionsToExtendForConfigFile);
            Debug.assert(!rootFileNames);
            parseConfigFile2();
            newLine = updateNewLine();
        }
        Debug.assert(compilerOptions);
        Debug.assert(rootFileNames);
        const { watchFile: watchFile2 , watchDirectory: watchDirectory , writeLog: writeLog  } = createWatchFactory(host, compilerOptions);
        const getCanonicalFileName = createGetCanonicalFileName(useCaseSensitiveFileNames);
        writeLog(`Current directory: ${currentDirectory} CaseSensitiveFileNames: ${useCaseSensitiveFileNames}`);
        let configFileWatcher;
        if (configFileName) configFileWatcher = watchFile2(configFileName, scheduleProgramReload, 2e3 /* High */ , watchOptions, WatchType.ConfigFile);
        const compilerHost = createCompilerHostFromProgramHost(host, ()=>compilerOptions, directoryStructureHost);
        setGetSourceFileAsHashVersioned(compilerHost);
        const getNewSourceFile = compilerHost.getSourceFile;
        compilerHost.getSourceFile = (fileName, ...args)=>getVersionedSourceFileByPath(fileName, toPath3(fileName), ...args);
        compilerHost.getSourceFileByPath = getVersionedSourceFileByPath;
        compilerHost.getNewLine = ()=>newLine;
        compilerHost.fileExists = fileExists;
        compilerHost.onReleaseOldSourceFile = onReleaseOldSourceFile;
        compilerHost.onReleaseParsedCommandLine = onReleaseParsedCommandLine;
        compilerHost.toPath = toPath3;
        compilerHost.getCompilationSettings = ()=>compilerOptions;
        compilerHost.useSourceOfProjectReferenceRedirect = maybeBind(host, host.useSourceOfProjectReferenceRedirect);
        compilerHost.watchDirectoryOfFailedLookupLocation = (dir, cb, flags)=>watchDirectory(dir, cb, flags, watchOptions, WatchType.FailedLookupLocations);
        compilerHost.watchAffectingFileLocation = (file, cb)=>watchFile2(file, cb, 2e3 /* High */ , watchOptions, WatchType.AffectingFileLocation);
        compilerHost.watchTypeRootsDirectory = (dir, cb, flags)=>watchDirectory(dir, cb, flags, watchOptions, WatchType.TypeRoots);
        compilerHost.getCachedDirectoryStructureHost = ()=>cachedDirectoryStructureHost;
        compilerHost.scheduleInvalidateResolutionsOfFailedLookupLocations = scheduleInvalidateResolutionsOfFailedLookupLocations;
        compilerHost.onInvalidatedResolution = scheduleProgramUpdate;
        compilerHost.onChangedAutomaticTypeDirectiveNames = scheduleProgramUpdate;
        compilerHost.fileIsOpen = returnFalse;
        compilerHost.getCurrentProgram = getCurrentProgram;
        compilerHost.writeLog = writeLog;
        compilerHost.getParsedCommandLine = getParsedCommandLine;
        const resolutionCache = createResolutionCache(compilerHost, configFileName ? getDirectoryPath(getNormalizedAbsolutePath(configFileName, currentDirectory)) : currentDirectory, /*logChangesWhenResolvingModule*/ false);
        compilerHost.resolveModuleNameLiterals = maybeBind(host, host.resolveModuleNameLiterals);
        compilerHost.resolveModuleNames = maybeBind(host, host.resolveModuleNames);
        if (!compilerHost.resolveModuleNameLiterals && !compilerHost.resolveModuleNames) compilerHost.resolveModuleNameLiterals = resolutionCache.resolveModuleNameLiterals.bind(resolutionCache);
        compilerHost.resolveTypeReferenceDirectiveReferences = maybeBind(host, host.resolveTypeReferenceDirectiveReferences);
        compilerHost.resolveTypeReferenceDirectives = maybeBind(host, host.resolveTypeReferenceDirectives);
        if (!compilerHost.resolveTypeReferenceDirectiveReferences && !compilerHost.resolveTypeReferenceDirectives) compilerHost.resolveTypeReferenceDirectiveReferences = resolutionCache.resolveTypeReferenceDirectiveReferences.bind(resolutionCache);
        compilerHost.resolveLibrary = !host.resolveLibrary ? resolutionCache.resolveLibrary.bind(resolutionCache) : host.resolveLibrary.bind(host);
        compilerHost.getModuleResolutionCache = host.resolveModuleNameLiterals || host.resolveModuleNames ? maybeBind(host, host.getModuleResolutionCache) : ()=>resolutionCache.getModuleResolutionCache();
        const userProvidedResolution = !!host.resolveModuleNameLiterals || !!host.resolveTypeReferenceDirectiveReferences || !!host.resolveModuleNames || !!host.resolveTypeReferenceDirectives;
        const customHasInvalidatedResolutions = userProvidedResolution ? maybeBind(host, host.hasInvalidatedResolutions) || returnTrue : returnFalse;
        const customHasInvalidLibResolutions = host.resolveLibrary ? maybeBind(host, host.hasInvalidatedLibResolutions) || returnTrue : returnFalse;
        builderProgram = readBuilderProgram(compilerOptions, compilerHost);
        synchronizeProgram();
        watchConfigFileWildCardDirectories();
        if (configFileName) updateExtendedConfigFilesWatches(toPath3(configFileName), compilerOptions, watchOptions, WatchType.ExtendedConfigFile);
        return configFileName ? {
            getCurrentProgram: getCurrentBuilderProgram,
            getProgram: updateProgram,
            close: close
        } : {
            getCurrentProgram: getCurrentBuilderProgram,
            getProgram: updateProgram,
            updateRootFileNames: updateRootFileNames,
            close: close
        };
        function close() {
            clearInvalidateResolutionsOfFailedLookupLocations();
            resolutionCache.clear();
            clearMap(sourceFilesCache, (value1)=>{
                if (value1 && value1.fileWatcher) {
                    value1.fileWatcher.close();
                    value1.fileWatcher = void 0;
                }
            });
            if (configFileWatcher) {
                configFileWatcher.close();
                configFileWatcher = void 0;
            }
            extendedConfigCache == null || extendedConfigCache.clear();
            extendedConfigCache = void 0;
            if (sharedExtendedConfigFileWatchers) {
                clearMap(sharedExtendedConfigFileWatchers, closeFileWatcherOf);
                sharedExtendedConfigFileWatchers = void 0;
            }
            if (watchedWildcardDirectories) {
                clearMap(watchedWildcardDirectories, closeFileWatcherOf);
                watchedWildcardDirectories = void 0;
            }
            if (missingFilesMap) {
                clearMap(missingFilesMap, closeFileWatcher);
                missingFilesMap = void 0;
            }
            if (parsedConfigs) {
                clearMap(parsedConfigs, (config)=>{
                    var _a;
                    (_a = config.watcher) == null || _a.close();
                    config.watcher = void 0;
                    if (config.watchedDirectories) clearMap(config.watchedDirectories, closeFileWatcherOf);
                    config.watchedDirectories = void 0;
                });
                parsedConfigs = void 0;
            }
        }
        function getCurrentBuilderProgram() {
            return builderProgram;
        }
        function getCurrentProgram() {
            return builderProgram && builderProgram.getProgramOrUndefined();
        }
        function synchronizeProgram() {
            writeLog(`Synchronizing program`);
            Debug.assert(compilerOptions);
            Debug.assert(rootFileNames);
            clearInvalidateResolutionsOfFailedLookupLocations();
            const program = getCurrentBuilderProgram();
            if (hasChangedCompilerOptions) {
                newLine = updateNewLine();
                if (program && changesAffectModuleResolution(program.getCompilerOptions(), compilerOptions)) {
                    debugger;
                    resolutionCache.onChangesAffectModuleResolution();
                }
            }
            const { hasInvalidatedResolutions: hasInvalidatedResolutions , hasInvalidatedLibResolutions: hasInvalidatedLibResolutions  } = resolutionCache.createHasInvalidatedResolutions(customHasInvalidatedResolutions, customHasInvalidLibResolutions);
            const { originalReadFile: originalReadFile , originalFileExists: originalFileExists , originalDirectoryExists: originalDirectoryExists , originalCreateDirectory: originalCreateDirectory , originalWriteFile: originalWriteFile , readFileWithCache: readFileWithCache  } = changeCompilerHostLikeToUseCache(compilerHost, toPath3);
            if (isProgramUptoDate(getCurrentProgram(), rootFileNames, compilerOptions, (path)=>getSourceVersion(path, readFileWithCache), (fileName)=>compilerHost.fileExists(fileName), hasInvalidatedResolutions, hasInvalidatedLibResolutions, hasChangedAutomaticTypeDirectiveNames, getParsedCommandLine, projectReferences)) {
                if (hasChangedConfigFileParsingErrors) {
                    if (reportFileChangeDetectedOnCreateProgram) reportWatchDiagnostic(Diagnostics.File_change_detected_Starting_incremental_compilation);
                    builderProgram = createProgram2(/*rootNames*/ void 0, /*options*/ void 0, compilerHost, builderProgram, configFileParsingDiagnostics, projectReferences);
                    hasChangedConfigFileParsingErrors = false;
                }
            } else {
                if (reportFileChangeDetectedOnCreateProgram) reportWatchDiagnostic(Diagnostics.File_change_detected_Starting_incremental_compilation);
                createNewProgram(hasInvalidatedResolutions, hasInvalidatedLibResolutions);
            }
            reportFileChangeDetectedOnCreateProgram = false;
            if (host.afterProgramCreate && program !== builderProgram) host.afterProgramCreate(builderProgram);
            compilerHost.readFile = originalReadFile;
            compilerHost.fileExists = originalFileExists;
            compilerHost.directoryExists = originalDirectoryExists;
            compilerHost.createDirectory = originalCreateDirectory;
            compilerHost.writeFile = originalWriteFile;
            return builderProgram;
        }
        function createNewProgram(hasInvalidatedResolutions, hasInvalidatedLibResolutions) {
            writeLog("CreatingProgramWith::");
            writeLog(`  roots: ${JSON.stringify(rootFileNames)}`);
            writeLog(`  options: ${JSON.stringify(compilerOptions)}`);
            if (projectReferences) writeLog(`  projectReferences: ${JSON.stringify(projectReferences)}`);
            const needsUpdateInTypeRootWatch = hasChangedCompilerOptions || !getCurrentProgram();
            hasChangedCompilerOptions = false;
            hasChangedConfigFileParsingErrors = false;
            resolutionCache.startCachingPerDirectoryResolution();
            compilerHost.hasInvalidatedResolutions = hasInvalidatedResolutions;
            compilerHost.hasInvalidatedLibResolutions = hasInvalidatedLibResolutions;
            compilerHost.hasChangedAutomaticTypeDirectiveNames = hasChangedAutomaticTypeDirectiveNames;
            const oldProgram = getCurrentProgram();
            builderProgram = createProgram2(rootFileNames, compilerOptions, compilerHost, builderProgram, configFileParsingDiagnostics, projectReferences);
            resolutionCache.finishCachingPerDirectoryResolution(builderProgram.getProgram(), oldProgram);
            updateMissingFilePathsWatch(builderProgram.getProgram(), missingFilesMap || (missingFilesMap = /* @__PURE__ */ new Map()), watchMissingFilePath);
            if (needsUpdateInTypeRootWatch) resolutionCache.updateTypeRootsWatch();
            if (missingFilePathsRequestedForRelease) {
                for (const missingFilePath of missingFilePathsRequestedForRelease)if (!missingFilesMap.has(missingFilePath)) sourceFilesCache.delete(missingFilePath);
                missingFilePathsRequestedForRelease = void 0;
            }
        }
        function updateRootFileNames(files) {
            Debug.assert(!configFileName, "Cannot update root file names with config file watch mode");
            rootFileNames = files;
            scheduleProgramUpdate();
        }
        function updateNewLine() {
            return getNewLineCharacter(compilerOptions || optionsToExtendForConfigFile);
        }
        function toPath3(fileName) {
            return toPath(fileName, currentDirectory, getCanonicalFileName);
        }
        function isFileMissingOnHost(hostSourceFile) {
            return typeof hostSourceFile === "boolean";
        }
        function isFilePresenceUnknownOnHost(hostSourceFile) {
            return typeof hostSourceFile.version === "boolean";
        }
        function fileExists(fileName) {
            const path = toPath3(fileName);
            if (isFileMissingOnHost(sourceFilesCache.get(path))) return false;
            return directoryStructureHost.fileExists(fileName);
        }
        function getVersionedSourceFileByPath(fileName, path, languageVersionOrOptions, onError, shouldCreateNewSourceFile) {
            const hostSourceFile = sourceFilesCache.get(path);
            if (isFileMissingOnHost(hostSourceFile)) return void 0;
            if (hostSourceFile === void 0 || shouldCreateNewSourceFile || isFilePresenceUnknownOnHost(hostSourceFile)) {
                const sourceFile = getNewSourceFile(fileName, languageVersionOrOptions, onError);
                if (hostSourceFile) {
                    if (sourceFile) {
                        hostSourceFile.sourceFile = sourceFile;
                        hostSourceFile.version = sourceFile.version;
                        if (!hostSourceFile.fileWatcher) hostSourceFile.fileWatcher = watchFilePath(path, fileName, onSourceFileChange, 250 /* Low */ , watchOptions, WatchType.SourceFile);
                    } else {
                        if (hostSourceFile.fileWatcher) hostSourceFile.fileWatcher.close();
                        sourceFilesCache.set(path, false);
                    }
                } else if (sourceFile) {
                    const fileWatcher = watchFilePath(path, fileName, onSourceFileChange, 250 /* Low */ , watchOptions, WatchType.SourceFile);
                    sourceFilesCache.set(path, {
                        sourceFile: sourceFile,
                        version: sourceFile.version,
                        fileWatcher: fileWatcher
                    });
                } else sourceFilesCache.set(path, false);
                return sourceFile;
            }
            return hostSourceFile.sourceFile;
        }
        function nextSourceFileVersion(path) {
            const hostSourceFile = sourceFilesCache.get(path);
            if (hostSourceFile !== void 0) {
                if (isFileMissingOnHost(hostSourceFile)) sourceFilesCache.set(path, {
                    version: false
                });
                else hostSourceFile.version = false;
            }
        }
        function getSourceVersion(path, readFileWithCache) {
            const hostSourceFile = sourceFilesCache.get(path);
            if (!hostSourceFile) return void 0;
            if (hostSourceFile.version) return hostSourceFile.version;
            const text = readFileWithCache(path);
            return text !== void 0 ? getSourceFileVersionAsHashFromText(compilerHost, text) : void 0;
        }
        function onReleaseOldSourceFile(oldSourceFile, _oldOptions, hasSourceFileByPath) {
            const hostSourceFileInfo = sourceFilesCache.get(oldSourceFile.resolvedPath);
            if (hostSourceFileInfo !== void 0) {
                if (isFileMissingOnHost(hostSourceFileInfo)) (missingFilePathsRequestedForRelease || (missingFilePathsRequestedForRelease = [])).push(oldSourceFile.path);
                else if (hostSourceFileInfo.sourceFile === oldSourceFile) {
                    if (hostSourceFileInfo.fileWatcher) hostSourceFileInfo.fileWatcher.close();
                    sourceFilesCache.delete(oldSourceFile.resolvedPath);
                    if (!hasSourceFileByPath) resolutionCache.removeResolutionsOfFile(oldSourceFile.path);
                }
            }
        }
        function reportWatchDiagnostic(message) {
            if (host.onWatchStatusChange) host.onWatchStatusChange(createCompilerDiagnostic(message), newLine, compilerOptions || optionsToExtendForConfigFile);
        }
        function hasChangedAutomaticTypeDirectiveNames() {
            return resolutionCache.hasChangedAutomaticTypeDirectiveNames();
        }
        function clearInvalidateResolutionsOfFailedLookupLocations() {
            if (!timerToInvalidateFailedLookupResolutions) return false;
            host.clearTimeout(timerToInvalidateFailedLookupResolutions);
            timerToInvalidateFailedLookupResolutions = void 0;
            return true;
        }
        function scheduleInvalidateResolutionsOfFailedLookupLocations() {
            if (!host.setTimeout || !host.clearTimeout) return resolutionCache.invalidateResolutionsOfFailedLookupLocations();
            const pending = clearInvalidateResolutionsOfFailedLookupLocations();
            writeLog(`Scheduling invalidateFailedLookup${pending ? ", Cancelled earlier one" : ""}`);
            timerToInvalidateFailedLookupResolutions = host.setTimeout(invalidateResolutionsOfFailedLookup, 250, "timerToInvalidateFailedLookupResolutions");
        }
        function invalidateResolutionsOfFailedLookup() {
            timerToInvalidateFailedLookupResolutions = void 0;
            if (resolutionCache.invalidateResolutionsOfFailedLookupLocations()) scheduleProgramUpdate();
        }
        function scheduleProgramUpdate() {
            if (!host.setTimeout || !host.clearTimeout) return;
            if (timerToUpdateProgram) host.clearTimeout(timerToUpdateProgram);
            writeLog("Scheduling update");
            timerToUpdateProgram = host.setTimeout(updateProgramWithWatchStatus, 250, "timerToUpdateProgram");
        }
        function scheduleProgramReload() {
            Debug.assert(!!configFileName);
            reloadLevel = 2 /* Full */ ;
            scheduleProgramUpdate();
        }
        function updateProgramWithWatchStatus() {
            timerToUpdateProgram = void 0;
            reportFileChangeDetectedOnCreateProgram = true;
            updateProgram();
        }
        function updateProgram() {
            var _a, _b, _c, _d;
            switch(reloadLevel){
                case 1 /* Partial */ :
                    (_a = perfLogger) == null || _a.logStartUpdateProgram("PartialConfigReload");
                    reloadFileNamesFromConfigFile();
                    break;
                case 2 /* Full */ :
                    (_b = perfLogger) == null || _b.logStartUpdateProgram("FullConfigReload");
                    reloadConfigFile();
                    break;
                default:
                    (_c = perfLogger) == null || _c.logStartUpdateProgram("SynchronizeProgram");
                    synchronizeProgram();
                    break;
            }
            (_d = perfLogger) == null || _d.logStopUpdateProgram("Done");
            return getCurrentBuilderProgram();
        }
        function reloadFileNamesFromConfigFile() {
            writeLog("Reloading new file names and options");
            Debug.assert(compilerOptions);
            Debug.assert(configFileName);
            reloadLevel = 0 /* None */ ;
            rootFileNames = getFileNamesFromConfigSpecs(compilerOptions.configFile.configFileSpecs, getNormalizedAbsolutePath(getDirectoryPath(configFileName), currentDirectory), compilerOptions, parseConfigFileHost, extraFileExtensions);
            if (updateErrorForNoInputFiles(rootFileNames, getNormalizedAbsolutePath(configFileName, currentDirectory), compilerOptions.configFile.configFileSpecs, configFileParsingDiagnostics, canConfigFileJsonReportNoInputFiles)) hasChangedConfigFileParsingErrors = true;
            synchronizeProgram();
        }
        function reloadConfigFile() {
            Debug.assert(configFileName);
            writeLog(`Reloading config file: ${configFileName}`);
            reloadLevel = 0 /* None */ ;
            if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.clearCache();
            parseConfigFile2();
            hasChangedCompilerOptions = true;
            synchronizeProgram();
            watchConfigFileWildCardDirectories();
            updateExtendedConfigFilesWatches(toPath3(configFileName), compilerOptions, watchOptions, WatchType.ExtendedConfigFile);
        }
        function parseConfigFile2() {
            Debug.assert(configFileName);
            setConfigFileParsingResult(getParsedCommandLineOfConfigFile(configFileName, optionsToExtendForConfigFile, parseConfigFileHost, extendedConfigCache || (extendedConfigCache = /* @__PURE__ */ new Map()), watchOptionsToExtend, extraFileExtensions));
        }
        function setConfigFileParsingResult(configFileParseResult) {
            rootFileNames = configFileParseResult.fileNames;
            compilerOptions = configFileParseResult.options;
            watchOptions = configFileParseResult.watchOptions;
            projectReferences = configFileParseResult.projectReferences;
            wildcardDirectories = configFileParseResult.wildcardDirectories;
            configFileParsingDiagnostics = getConfigFileParsingDiagnostics(configFileParseResult).slice();
            canConfigFileJsonReportNoInputFiles = canJsonReportNoInputFiles(configFileParseResult.raw);
            hasChangedConfigFileParsingErrors = true;
        }
        function getParsedCommandLine(configFileName2) {
            const configPath = toPath3(configFileName2);
            let config = parsedConfigs == null ? void 0 : parsedConfigs.get(configPath);
            if (config) {
                if (!config.reloadLevel) return config.parsedCommandLine;
                if (config.parsedCommandLine && config.reloadLevel === 1 /* Partial */  && !host.getParsedCommandLine) {
                    writeLog("Reloading new file names and options");
                    Debug.assert(compilerOptions);
                    const fileNames = getFileNamesFromConfigSpecs(config.parsedCommandLine.options.configFile.configFileSpecs, getNormalizedAbsolutePath(getDirectoryPath(configFileName2), currentDirectory), compilerOptions, parseConfigFileHost);
                    config.parsedCommandLine = {
                        ...config.parsedCommandLine,
                        fileNames: fileNames
                    };
                    config.reloadLevel = void 0;
                    return config.parsedCommandLine;
                }
            }
            writeLog(`Loading config file: ${configFileName2}`);
            const parsedCommandLine = host.getParsedCommandLine ? host.getParsedCommandLine(configFileName2) : getParsedCommandLineFromConfigFileHost(configFileName2);
            if (config) {
                config.parsedCommandLine = parsedCommandLine;
                config.reloadLevel = void 0;
            } else (parsedConfigs || (parsedConfigs = /* @__PURE__ */ new Map())).set(configPath, config = {
                parsedCommandLine: parsedCommandLine
            });
            watchReferencedProject(configFileName2, configPath, config);
            return parsedCommandLine;
        }
        function getParsedCommandLineFromConfigFileHost(configFileName2) {
            const onUnRecoverableConfigFileDiagnostic = parseConfigFileHost.onUnRecoverableConfigFileDiagnostic;
            parseConfigFileHost.onUnRecoverableConfigFileDiagnostic = noop;
            const parsedCommandLine = getParsedCommandLineOfConfigFile(configFileName2, /*optionsToExtend*/ void 0, parseConfigFileHost, extendedConfigCache || (extendedConfigCache = /* @__PURE__ */ new Map()), watchOptionsToExtend);
            parseConfigFileHost.onUnRecoverableConfigFileDiagnostic = onUnRecoverableConfigFileDiagnostic;
            return parsedCommandLine;
        }
        function onReleaseParsedCommandLine(fileName) {
            var _a;
            const path = toPath3(fileName);
            const config = parsedConfigs == null ? void 0 : parsedConfigs.get(path);
            if (!config) return;
            parsedConfigs.delete(path);
            if (config.watchedDirectories) clearMap(config.watchedDirectories, closeFileWatcherOf);
            (_a = config.watcher) == null || _a.close();
            clearSharedExtendedConfigFileWatcher(path, sharedExtendedConfigFileWatchers);
        }
        function watchFilePath(path, file, callback, pollingInterval, options, watchType) {
            return watchFile2(file, (fileName, eventKind)=>callback(fileName, eventKind, path), pollingInterval, options, watchType);
        }
        function onSourceFileChange(fileName, eventKind, path) {
            updateCachedSystemWithFile(fileName, path, eventKind);
            if (eventKind === 2 /* Deleted */  && sourceFilesCache.has(path)) resolutionCache.invalidateResolutionOfFile(path);
            nextSourceFileVersion(path);
            scheduleProgramUpdate();
        }
        function updateCachedSystemWithFile(fileName, path, eventKind) {
            if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.addOrDeleteFile(fileName, path, eventKind);
        }
        function watchMissingFilePath(missingFilePath) {
            return (parsedConfigs == null ? void 0 : parsedConfigs.has(missingFilePath)) ? noopFileWatcher : watchFilePath(missingFilePath, missingFilePath, onMissingFileChange, 500 /* Medium */ , watchOptions, WatchType.MissingFile);
        }
        function onMissingFileChange(fileName, eventKind, missingFilePath) {
            updateCachedSystemWithFile(fileName, missingFilePath, eventKind);
            if (eventKind === 0 /* Created */  && missingFilesMap.has(missingFilePath)) {
                missingFilesMap.get(missingFilePath).close();
                missingFilesMap.delete(missingFilePath);
                nextSourceFileVersion(missingFilePath);
                scheduleProgramUpdate();
            }
        }
        function watchConfigFileWildCardDirectories() {
            if (wildcardDirectories) updateWatchingWildcardDirectories(watchedWildcardDirectories || (watchedWildcardDirectories = /* @__PURE__ */ new Map()), new Map(Object.entries(wildcardDirectories)), watchWildcardDirectory);
            else if (watchedWildcardDirectories) clearMap(watchedWildcardDirectories, closeFileWatcherOf);
        }
        function watchWildcardDirectory(directory, flags) {
            return watchDirectory(directory, (fileOrDirectory)=>{
                Debug.assert(configFileName);
                Debug.assert(compilerOptions);
                const fileOrDirectoryPath = toPath3(fileOrDirectory);
                if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
                nextSourceFileVersion(fileOrDirectoryPath);
                if (isIgnoredFileFromWildCardWatching({
                    watchedDirPath: toPath3(directory),
                    fileOrDirectory: fileOrDirectory,
                    fileOrDirectoryPath: fileOrDirectoryPath,
                    configFileName: configFileName,
                    extraFileExtensions: extraFileExtensions,
                    options: compilerOptions,
                    program: getCurrentBuilderProgram() || rootFileNames,
                    currentDirectory: currentDirectory,
                    useCaseSensitiveFileNames: useCaseSensitiveFileNames,
                    writeLog: writeLog,
                    toPath: toPath3
                })) return;
                if (reloadLevel !== 2 /* Full */ ) {
                    reloadLevel = 1 /* Partial */ ;
                    scheduleProgramUpdate();
                }
            }, flags, watchOptions, WatchType.WildcardDirectory);
        }
        function updateExtendedConfigFilesWatches(forProjectPath, options, watchOptions2, watchType) {
            updateSharedExtendedConfigFileWatcher(forProjectPath, options, sharedExtendedConfigFileWatchers || (sharedExtendedConfigFileWatchers = /* @__PURE__ */ new Map()), (extendedConfigFileName, extendedConfigFilePath)=>watchFile2(extendedConfigFileName, (_fileName, eventKind)=>{
                    var _a;
                    updateCachedSystemWithFile(extendedConfigFileName, extendedConfigFilePath, eventKind);
                    if (extendedConfigCache) cleanExtendedConfigCache(extendedConfigCache, extendedConfigFilePath, toPath3);
                    const projects = (_a = sharedExtendedConfigFileWatchers.get(extendedConfigFilePath)) == null ? void 0 : _a.projects;
                    if (!(projects == null ? void 0 : projects.size)) return;
                    projects.forEach((projectPath)=>{
                        if (configFileName && toPath3(configFileName) === projectPath) reloadLevel = 2 /* Full */ ;
                        else {
                            const config = parsedConfigs == null ? void 0 : parsedConfigs.get(projectPath);
                            if (config) config.reloadLevel = 2 /* Full */ ;
                            resolutionCache.removeResolutionsFromProjectReferenceRedirects(projectPath);
                        }
                        scheduleProgramUpdate();
                    });
                }, 2e3 /* High */ , watchOptions2, watchType), toPath3);
        }
        function watchReferencedProject(configFileName2, configPath, commandLine) {
            var _a, _b, _c, _d, _e;
            commandLine.watcher || (commandLine.watcher = watchFile2(configFileName2, (_fileName, eventKind)=>{
                updateCachedSystemWithFile(configFileName2, configPath, eventKind);
                const config = parsedConfigs == null ? void 0 : parsedConfigs.get(configPath);
                if (config) config.reloadLevel = 2 /* Full */ ;
                resolutionCache.removeResolutionsFromProjectReferenceRedirects(configPath);
                scheduleProgramUpdate();
            }, 2e3 /* High */ , ((_a = commandLine.parsedCommandLine) == null ? void 0 : _a.watchOptions) || watchOptions, WatchType.ConfigFileOfReferencedProject));
            if ((_b = commandLine.parsedCommandLine) == null ? void 0 : _b.wildcardDirectories) updateWatchingWildcardDirectories(commandLine.watchedDirectories || (commandLine.watchedDirectories = /* @__PURE__ */ new Map()), new Map(Object.entries((_c = commandLine.parsedCommandLine) == null ? void 0 : _c.wildcardDirectories)), (directory, flags)=>{
                var _a2;
                return watchDirectory(directory, (fileOrDirectory)=>{
                    const fileOrDirectoryPath = toPath3(fileOrDirectory);
                    if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
                    nextSourceFileVersion(fileOrDirectoryPath);
                    const config = parsedConfigs == null ? void 0 : parsedConfigs.get(configPath);
                    if (!(config == null ? void 0 : config.parsedCommandLine)) return;
                    if (isIgnoredFileFromWildCardWatching({
                        watchedDirPath: toPath3(directory),
                        fileOrDirectory: fileOrDirectory,
                        fileOrDirectoryPath: fileOrDirectoryPath,
                        configFileName: configFileName2,
                        options: config.parsedCommandLine.options,
                        program: config.parsedCommandLine.fileNames,
                        currentDirectory: currentDirectory,
                        useCaseSensitiveFileNames: useCaseSensitiveFileNames,
                        writeLog: writeLog,
                        toPath: toPath3
                    })) return;
                    if (config.reloadLevel !== 2 /* Full */ ) {
                        config.reloadLevel = 1 /* Partial */ ;
                        scheduleProgramUpdate();
                    }
                }, flags, ((_a2 = commandLine.parsedCommandLine) == null ? void 0 : _a2.watchOptions) || watchOptions, WatchType.WildcardDirectoryOfReferencedProject);
            });
            else if (commandLine.watchedDirectories) {
                clearMap(commandLine.watchedDirectories, closeFileWatcherOf);
                commandLine.watchedDirectories = void 0;
            }
            updateExtendedConfigFilesWatches(configPath, (_d = commandLine.parsedCommandLine) == null ? void 0 : _d.options, ((_e = commandLine.parsedCommandLine) == null ? void 0 : _e.watchOptions) || watchOptions, WatchType.ExtendedConfigOfReferencedProject);
        }
    }
    var init_watchPublic = __esm({
        "src/compiler/watchPublic.ts" () {
            "use strict";
            init_ts2();
        }
    });
    // src/compiler/tsbuild.ts
    function resolveConfigFileProjectName(project) {
        if (fileExtensionIs(project, ".json" /* Json */ )) return project;
        return combinePaths(project, "tsconfig.json");
    }
    var UpToDateStatusType;
    var init_tsbuild = __esm({
        "src/compiler/tsbuild.ts" () {
            "use strict";
            init_ts2();
            UpToDateStatusType = /* @__PURE__ */ ((UpToDateStatusType2)=>{
                UpToDateStatusType2[UpToDateStatusType2["Unbuildable"] = 0] = "Unbuildable";
                UpToDateStatusType2[UpToDateStatusType2["UpToDate"] = 1] = "UpToDate";
                UpToDateStatusType2[UpToDateStatusType2["UpToDateWithUpstreamTypes"] = 2] = "UpToDateWithUpstreamTypes";
                UpToDateStatusType2[UpToDateStatusType2["OutOfDateWithPrepend"] = 3] = "OutOfDateWithPrepend";
                UpToDateStatusType2[UpToDateStatusType2["OutputMissing"] = 4] = "OutputMissing";
                UpToDateStatusType2[UpToDateStatusType2["ErrorReadingFile"] = 5] = "ErrorReadingFile";
                UpToDateStatusType2[UpToDateStatusType2["OutOfDateWithSelf"] = 6] = "OutOfDateWithSelf";
                UpToDateStatusType2[UpToDateStatusType2["OutOfDateWithUpstream"] = 7] = "OutOfDateWithUpstream";
                UpToDateStatusType2[UpToDateStatusType2["OutOfDateBuildInfo"] = 8] = "OutOfDateBuildInfo";
                UpToDateStatusType2[UpToDateStatusType2["OutOfDateOptions"] = 9] = "OutOfDateOptions";
                UpToDateStatusType2[UpToDateStatusType2["OutOfDateRoots"] = 10] = "OutOfDateRoots";
                UpToDateStatusType2[UpToDateStatusType2["UpstreamOutOfDate"] = 11] = "UpstreamOutOfDate";
                UpToDateStatusType2[UpToDateStatusType2["UpstreamBlocked"] = 12] = "UpstreamBlocked";
                UpToDateStatusType2[UpToDateStatusType2["ComputingUpstream"] = 13] = "ComputingUpstream";
                UpToDateStatusType2[UpToDateStatusType2["TsVersionOutputOfDate"] = 14] = "TsVersionOutputOfDate";
                UpToDateStatusType2[UpToDateStatusType2["UpToDateWithInputFileText"] = 15] = "UpToDateWithInputFileText";
                UpToDateStatusType2[UpToDateStatusType2["ContainerOnly"] = 16] = "ContainerOnly";
                UpToDateStatusType2[UpToDateStatusType2["ForceBuild"] = 17] = "ForceBuild";
                return UpToDateStatusType2;
            })(UpToDateStatusType || {});
        }
    });
    // src/compiler/tsbuildPublic.ts
    function getOrCreateValueFromConfigFileMap(configFileMap, resolved, createT) {
        const existingValue = configFileMap.get(resolved);
        let newValue;
        if (!existingValue) {
            newValue = createT();
            configFileMap.set(resolved, newValue);
        }
        return existingValue || newValue;
    }
    function getOrCreateValueMapFromConfigFileMap(configFileMap, resolved) {
        return getOrCreateValueFromConfigFileMap(configFileMap, resolved, ()=>/* @__PURE__ */ new Map());
    }
    function getCurrentTime(host) {
        return host.now ? host.now() : /* @__PURE__ */ new Date();
    }
    function isCircularBuildOrder(buildOrder) {
        return !!buildOrder && !!buildOrder.buildOrder;
    }
    function getBuildOrderFromAnyBuildOrder(anyBuildOrder) {
        return isCircularBuildOrder(anyBuildOrder) ? anyBuildOrder.buildOrder : anyBuildOrder;
    }
    function createBuilderStatusReporter(system, pretty) {
        return (diagnostic)=>{
            let output = pretty ? `[${formatColorAndReset(getLocaleTimeString(system), "\x1b[90m" /* Grey */ )}] ` : `${getLocaleTimeString(system)} - `;
            output += `${flattenDiagnosticMessageText(diagnostic.messageText, system.newLine)}${system.newLine + system.newLine}`;
            system.write(output);
        };
    }
    function createSolutionBuilderHostBase(system, createProgram2, reportDiagnostic, reportSolutionBuilderStatus) {
        const host = createProgramHost(system, createProgram2);
        host.getModifiedTime = system.getModifiedTime ? (path)=>system.getModifiedTime(path) : returnUndefined;
        host.setModifiedTime = system.setModifiedTime ? (path, date)=>system.setModifiedTime(path, date) : noop;
        host.deleteFile = system.deleteFile ? (path)=>system.deleteFile(path) : noop;
        host.reportDiagnostic = reportDiagnostic || createDiagnosticReporter(system);
        host.reportSolutionBuilderStatus = reportSolutionBuilderStatus || createBuilderStatusReporter(system);
        host.now = maybeBind(system, system.now);
        return host;
    }
    function createSolutionBuilderHost(system = sys, createProgram2, reportDiagnostic, reportSolutionBuilderStatus, reportErrorSummary2) {
        const host = createSolutionBuilderHostBase(system, createProgram2, reportDiagnostic, reportSolutionBuilderStatus);
        host.reportErrorSummary = reportErrorSummary2;
        return host;
    }
    function createSolutionBuilderWithWatchHost(system = sys, createProgram2, reportDiagnostic, reportSolutionBuilderStatus, reportWatchStatus2) {
        const host = createSolutionBuilderHostBase(system, createProgram2, reportDiagnostic, reportSolutionBuilderStatus);
        const watchHost = createWatchHost(system, reportWatchStatus2);
        copyProperties(host, watchHost);
        return host;
    }
    function getCompilerOptionsOfBuildOptions(buildOptions) {
        const result = {};
        commonOptionsWithBuild.forEach((option)=>{
            if (hasProperty(buildOptions, option.name)) result[option.name] = buildOptions[option.name];
        });
        return result;
    }
    function createSolutionBuilder(host, rootNames, defaultOptions) {
        return createSolutionBuilderWorker(/*watch*/ false, host, rootNames, defaultOptions);
    }
    function createSolutionBuilderWithWatch(host, rootNames, defaultOptions, baseWatchOptions) {
        return createSolutionBuilderWorker(/*watch*/ true, host, rootNames, defaultOptions, baseWatchOptions);
    }
    function createSolutionBuilderState(watch, hostOrHostWithWatch, rootNames, options, baseWatchOptions) {
        const host = hostOrHostWithWatch;
        const hostWithWatch = hostOrHostWithWatch;
        const baseCompilerOptions = getCompilerOptionsOfBuildOptions(options);
        const compilerHost = createCompilerHostFromProgramHost(host, ()=>state.projectCompilerOptions);
        setGetSourceFileAsHashVersioned(compilerHost);
        compilerHost.getParsedCommandLine = (fileName)=>parseConfigFile(state, fileName, toResolvedConfigFilePath(state, fileName));
        compilerHost.resolveModuleNameLiterals = maybeBind(host, host.resolveModuleNameLiterals);
        compilerHost.resolveTypeReferenceDirectiveReferences = maybeBind(host, host.resolveTypeReferenceDirectiveReferences);
        compilerHost.resolveLibrary = maybeBind(host, host.resolveLibrary);
        compilerHost.resolveModuleNames = maybeBind(host, host.resolveModuleNames);
        compilerHost.resolveTypeReferenceDirectives = maybeBind(host, host.resolveTypeReferenceDirectives);
        compilerHost.getModuleResolutionCache = maybeBind(host, host.getModuleResolutionCache);
        let moduleResolutionCache, typeReferenceDirectiveResolutionCache;
        if (!compilerHost.resolveModuleNameLiterals && !compilerHost.resolveModuleNames) {
            moduleResolutionCache = createModuleResolutionCache(compilerHost.getCurrentDirectory(), compilerHost.getCanonicalFileName);
            compilerHost.resolveModuleNameLiterals = (moduleNames, containingFile, redirectedReference, options2, containingSourceFile)=>loadWithModeAwareCache(moduleNames, containingFile, redirectedReference, options2, containingSourceFile, host, moduleResolutionCache, createModuleResolutionLoader);
            compilerHost.getModuleResolutionCache = ()=>moduleResolutionCache;
        }
        if (!compilerHost.resolveTypeReferenceDirectiveReferences && !compilerHost.resolveTypeReferenceDirectives) {
            typeReferenceDirectiveResolutionCache = createTypeReferenceDirectiveResolutionCache(compilerHost.getCurrentDirectory(), compilerHost.getCanonicalFileName, /*options*/ void 0, moduleResolutionCache == null ? void 0 : moduleResolutionCache.getPackageJsonInfoCache());
            compilerHost.resolveTypeReferenceDirectiveReferences = (typeDirectiveNames, containingFile, redirectedReference, options2, containingSourceFile)=>loadWithModeAwareCache(typeDirectiveNames, containingFile, redirectedReference, options2, containingSourceFile, host, typeReferenceDirectiveResolutionCache, createTypeReferenceResolutionLoader);
        }
        let libraryResolutionCache;
        if (!compilerHost.resolveLibrary) {
            libraryResolutionCache = createModuleResolutionCache(compilerHost.getCurrentDirectory(), compilerHost.getCanonicalFileName, /*options*/ void 0, moduleResolutionCache == null ? void 0 : moduleResolutionCache.getPackageJsonInfoCache());
            compilerHost.resolveLibrary = (libraryName, resolveFrom, options2)=>resolveLibrary(libraryName, resolveFrom, options2, host, libraryResolutionCache);
        }
        compilerHost.getBuildInfo = (fileName, configFilePath)=>getBuildInfo3(state, fileName, toResolvedConfigFilePath(state, configFilePath), /*modifiedTime*/ void 0);
        const { watchFile: watchFile2 , watchDirectory: watchDirectory , writeLog: writeLog  } = createWatchFactory(hostWithWatch, options);
        const state = {
            host: host,
            hostWithWatch: hostWithWatch,
            parseConfigFileHost: parseConfigHostFromCompilerHostLike(host),
            write: maybeBind(host, host.trace),
            options: // State of solution
            options,
            baseCompilerOptions: baseCompilerOptions,
            rootNames: rootNames,
            baseWatchOptions: baseWatchOptions,
            resolvedConfigFilePaths: /* @__PURE__ */ new Map(),
            configFileCache: /* @__PURE__ */ new Map(),
            projectStatus: /* @__PURE__ */ new Map(),
            extendedConfigCache: /* @__PURE__ */ new Map(),
            buildInfoCache: /* @__PURE__ */ new Map(),
            outputTimeStamps: /* @__PURE__ */ new Map(),
            builderPrograms: /* @__PURE__ */ new Map(),
            diagnostics: /* @__PURE__ */ new Map(),
            projectPendingBuild: /* @__PURE__ */ new Map(),
            projectErrorsReported: /* @__PURE__ */ new Map(),
            compilerHost: compilerHost,
            moduleResolutionCache: moduleResolutionCache,
            typeReferenceDirectiveResolutionCache: typeReferenceDirectiveResolutionCache,
            libraryResolutionCache: libraryResolutionCache,
            // Mutable state
            buildOrder: void 0,
            readFileWithCache: (f)=>host.readFile(f),
            projectCompilerOptions: baseCompilerOptions,
            cache: void 0,
            allProjectBuildPending: true,
            needsSummary: true,
            watchAllProjectsPending: watch,
            watch: // Watch state
            watch,
            allWatchedWildcardDirectories: /* @__PURE__ */ new Map(),
            allWatchedInputFiles: /* @__PURE__ */ new Map(),
            allWatchedConfigFiles: /* @__PURE__ */ new Map(),
            allWatchedExtendedConfigFiles: /* @__PURE__ */ new Map(),
            allWatchedPackageJsonFiles: /* @__PURE__ */ new Map(),
            filesWatched: /* @__PURE__ */ new Map(),
            lastCachedPackageJsonLookups: /* @__PURE__ */ new Map(),
            timerToBuildInvalidatedProject: void 0,
            reportFileChangeDetected: false,
            watchFile: watchFile2,
            watchDirectory: watchDirectory,
            writeLog: writeLog
        };
        return state;
    }
    function toPath2(state, fileName) {
        return toPath(fileName, state.compilerHost.getCurrentDirectory(), state.compilerHost.getCanonicalFileName);
    }
    function toResolvedConfigFilePath(state, fileName) {
        const { resolvedConfigFilePaths: resolvedConfigFilePaths  } = state;
        const path = resolvedConfigFilePaths.get(fileName);
        if (path !== void 0) return path;
        const resolvedPath = toPath2(state, fileName);
        resolvedConfigFilePaths.set(fileName, resolvedPath);
        return resolvedPath;
    }
    function isParsedCommandLine(entry) {
        return !!entry.options;
    }
    function getCachedParsedConfigFile(state, configFilePath) {
        const value1 = state.configFileCache.get(configFilePath);
        return value1 && isParsedCommandLine(value1) ? value1 : void 0;
    }
    function parseConfigFile(state, configFileName, configFilePath) {
        const { configFileCache: configFileCache  } = state;
        const value1 = configFileCache.get(configFilePath);
        if (value1) return isParsedCommandLine(value1) ? value1 : void 0;
        mark("SolutionBuilder::beforeConfigFileParsing");
        let diagnostic;
        const { parseConfigFileHost: parseConfigFileHost , baseCompilerOptions: baseCompilerOptions , baseWatchOptions: baseWatchOptions , extendedConfigCache: extendedConfigCache , host: host  } = state;
        let parsed;
        if (host.getParsedCommandLine) {
            parsed = host.getParsedCommandLine(configFileName);
            if (!parsed) diagnostic = createCompilerDiagnostic(Diagnostics.File_0_not_found, configFileName);
        } else {
            parseConfigFileHost.onUnRecoverableConfigFileDiagnostic = (d)=>diagnostic = d;
            parsed = getParsedCommandLineOfConfigFile(configFileName, baseCompilerOptions, parseConfigFileHost, extendedConfigCache, baseWatchOptions);
            parseConfigFileHost.onUnRecoverableConfigFileDiagnostic = noop;
        }
        configFileCache.set(configFilePath, parsed || diagnostic);
        mark("SolutionBuilder::afterConfigFileParsing");
        measure("SolutionBuilder::Config file parsing", "SolutionBuilder::beforeConfigFileParsing", "SolutionBuilder::afterConfigFileParsing");
        return parsed;
    }
    function resolveProjectName(state, name) {
        return resolveConfigFileProjectName(resolvePath(state.compilerHost.getCurrentDirectory(), name));
    }
    function createBuildOrder(state, roots) {
        const temporaryMarks = /* @__PURE__ */ new Map();
        const permanentMarks = /* @__PURE__ */ new Map();
        const circularityReportStack = [];
        let buildOrder;
        let circularDiagnostics;
        for (const root of roots)visit(root);
        return circularDiagnostics ? {
            buildOrder: buildOrder || emptyArray,
            circularDiagnostics: circularDiagnostics
        } : buildOrder || emptyArray;
        function visit(configFileName, inCircularContext) {
            const projPath = toResolvedConfigFilePath(state, configFileName);
            if (permanentMarks.has(projPath)) return;
            if (temporaryMarks.has(projPath)) {
                if (!inCircularContext) (circularDiagnostics || (circularDiagnostics = [])).push(createCompilerDiagnostic(Diagnostics.Project_references_may_not_form_a_circular_graph_Cycle_detected_Colon_0, circularityReportStack.join("\r\n")));
                return;
            }
            temporaryMarks.set(projPath, true);
            circularityReportStack.push(configFileName);
            const parsed = parseConfigFile(state, configFileName, projPath);
            if (parsed && parsed.projectReferences) for (const ref of parsed.projectReferences){
                const resolvedRefPath = resolveProjectName(state, ref.path);
                visit(resolvedRefPath, inCircularContext || ref.circular);
            }
            circularityReportStack.pop();
            permanentMarks.set(projPath, true);
            (buildOrder || (buildOrder = [])).push(configFileName);
        }
    }
    function getBuildOrder(state) {
        return state.buildOrder || createStateBuildOrder(state);
    }
    function createStateBuildOrder(state) {
        const buildOrder = createBuildOrder(state, state.rootNames.map((f)=>resolveProjectName(state, f)));
        state.resolvedConfigFilePaths.clear();
        const currentProjects = new Map(getBuildOrderFromAnyBuildOrder(buildOrder).map((resolved)=>[
                toResolvedConfigFilePath(state, resolved),
                true
            ]));
        const noopOnDelete = {
            onDeleteValue: noop
        };
        mutateMapSkippingNewValues(state.configFileCache, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.projectStatus, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.builderPrograms, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.diagnostics, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.projectPendingBuild, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.projectErrorsReported, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.buildInfoCache, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.outputTimeStamps, currentProjects, noopOnDelete);
        if (state.watch) {
            mutateMapSkippingNewValues(state.allWatchedConfigFiles, currentProjects, {
                onDeleteValue: closeFileWatcher
            });
            state.allWatchedExtendedConfigFiles.forEach((watcher)=>{
                watcher.projects.forEach((project)=>{
                    if (!currentProjects.has(project)) watcher.projects.delete(project);
                });
                watcher.close();
            });
            mutateMapSkippingNewValues(state.allWatchedWildcardDirectories, currentProjects, {
                onDeleteValue: (existingMap)=>existingMap.forEach(closeFileWatcherOf)
            });
            mutateMapSkippingNewValues(state.allWatchedInputFiles, currentProjects, {
                onDeleteValue: (existingMap)=>existingMap.forEach(closeFileWatcher)
            });
            mutateMapSkippingNewValues(state.allWatchedPackageJsonFiles, currentProjects, {
                onDeleteValue: (existingMap)=>existingMap.forEach(closeFileWatcher)
            });
        }
        return state.buildOrder = buildOrder;
    }
    function getBuildOrderFor(state, project, onlyReferences) {
        const resolvedProject = project && resolveProjectName(state, project);
        const buildOrderFromState = getBuildOrder(state);
        if (isCircularBuildOrder(buildOrderFromState)) return buildOrderFromState;
        if (resolvedProject) {
            const projectPath = toResolvedConfigFilePath(state, resolvedProject);
            const projectIndex = findIndex(buildOrderFromState, (configFileName)=>toResolvedConfigFilePath(state, configFileName) === projectPath);
            if (projectIndex === -1) return void 0;
        }
        const buildOrder = resolvedProject ? createBuildOrder(state, [
            resolvedProject
        ]) : buildOrderFromState;
        Debug.assert(!isCircularBuildOrder(buildOrder));
        Debug.assert(!onlyReferences || resolvedProject !== void 0);
        Debug.assert(!onlyReferences || buildOrder[buildOrder.length - 1] === resolvedProject);
        return onlyReferences ? buildOrder.slice(0, buildOrder.length - 1) : buildOrder;
    }
    function enableCache(state) {
        if (state.cache) disableCache(state);
        const { compilerHost: compilerHost , host: host  } = state;
        const originalReadFileWithCache = state.readFileWithCache;
        const originalGetSourceFile = compilerHost.getSourceFile;
        const { originalReadFile: originalReadFile , originalFileExists: originalFileExists , originalDirectoryExists: originalDirectoryExists , originalCreateDirectory: originalCreateDirectory , originalWriteFile: originalWriteFile , getSourceFileWithCache: getSourceFileWithCache , readFileWithCache: readFileWithCache  } = changeCompilerHostLikeToUseCache(host, (fileName)=>toPath2(state, fileName), (...args)=>originalGetSourceFile.call(compilerHost, ...args));
        state.readFileWithCache = readFileWithCache;
        compilerHost.getSourceFile = getSourceFileWithCache;
        state.cache = {
            originalReadFile: originalReadFile,
            originalFileExists: originalFileExists,
            originalDirectoryExists: originalDirectoryExists,
            originalCreateDirectory: originalCreateDirectory,
            originalWriteFile: originalWriteFile,
            originalReadFileWithCache: originalReadFileWithCache,
            originalGetSourceFile: originalGetSourceFile
        };
    }
    function disableCache(state) {
        if (!state.cache) return;
        const { cache: cache , host: host , compilerHost: compilerHost , extendedConfigCache: extendedConfigCache , moduleResolutionCache: moduleResolutionCache , typeReferenceDirectiveResolutionCache: typeReferenceDirectiveResolutionCache , libraryResolutionCache: libraryResolutionCache  } = state;
        host.readFile = cache.originalReadFile;
        host.fileExists = cache.originalFileExists;
        host.directoryExists = cache.originalDirectoryExists;
        host.createDirectory = cache.originalCreateDirectory;
        host.writeFile = cache.originalWriteFile;
        compilerHost.getSourceFile = cache.originalGetSourceFile;
        state.readFileWithCache = cache.originalReadFileWithCache;
        extendedConfigCache.clear();
        moduleResolutionCache == null || moduleResolutionCache.clear();
        typeReferenceDirectiveResolutionCache == null || typeReferenceDirectiveResolutionCache.clear();
        libraryResolutionCache == null || libraryResolutionCache.clear();
        state.cache = void 0;
    }
    function clearProjectStatus(state, resolved) {
        state.projectStatus.delete(resolved);
        state.diagnostics.delete(resolved);
    }
    function addProjToQueue({ projectPendingBuild: projectPendingBuild  }, proj, reloadLevel) {
        const value1 = projectPendingBuild.get(proj);
        if (value1 === void 0) projectPendingBuild.set(proj, reloadLevel);
        else if (value1 < reloadLevel) projectPendingBuild.set(proj, reloadLevel);
    }
    function setupInitialBuild(state, cancellationToken) {
        if (!state.allProjectBuildPending) return;
        state.allProjectBuildPending = false;
        if (state.options.watch) reportWatchStatus(state, Diagnostics.Starting_compilation_in_watch_mode);
        enableCache(state);
        const buildOrder = getBuildOrderFromAnyBuildOrder(getBuildOrder(state));
        buildOrder.forEach((configFileName)=>state.projectPendingBuild.set(toResolvedConfigFilePath(state, configFileName), 0 /* None */ ));
        if (cancellationToken) cancellationToken.throwIfCancellationRequested();
    }
    function doneInvalidatedProject(state, projectPath) {
        state.projectPendingBuild.delete(projectPath);
        return state.diagnostics.has(projectPath) ? 1 /* DiagnosticsPresent_OutputsSkipped */  : 0 /* Success */ ;
    }
    function createUpdateOutputFileStampsProject(state, project, projectPath, config, buildOrder) {
        let updateOutputFileStampsPending = true;
        return {
            kind: 2 /* UpdateOutputFileStamps */ ,
            project: project,
            projectPath: projectPath,
            buildOrder: buildOrder,
            getCompilerOptions: ()=>config.options,
            getCurrentDirectory: ()=>state.compilerHost.getCurrentDirectory(),
            updateOutputFileStatmps: ()=>{
                updateOutputTimestamps(state, config, projectPath);
                updateOutputFileStampsPending = false;
            },
            done: ()=>{
                if (updateOutputFileStampsPending) updateOutputTimestamps(state, config, projectPath);
                mark("SolutionBuilder::Timestamps only updates");
                return doneInvalidatedProject(state, projectPath);
            }
        };
    }
    function createBuildOrUpdateInvalidedProject(kind, state, project, projectPath, projectIndex, config, buildOrder) {
        let step = kind === 0 /* Build */  ? 0 /* CreateProgram */  : 4 /* EmitBundle */ ;
        let program;
        let buildResult;
        let invalidatedProjectOfBundle;
        return kind === 0 /* Build */  ? {
            kind: kind,
            project: project,
            projectPath: projectPath,
            buildOrder: buildOrder,
            getCompilerOptions: ()=>config.options,
            getCurrentDirectory: ()=>state.compilerHost.getCurrentDirectory(),
            getBuilderProgram: ()=>withProgramOrUndefined(identity),
            getProgram: ()=>withProgramOrUndefined((program2)=>program2.getProgramOrUndefined()),
            getSourceFile: (fileName)=>withProgramOrUndefined((program2)=>program2.getSourceFile(fileName)),
            getSourceFiles: ()=>withProgramOrEmptyArray((program2)=>program2.getSourceFiles()),
            getOptionsDiagnostics: (cancellationToken)=>withProgramOrEmptyArray((program2)=>program2.getOptionsDiagnostics(cancellationToken)),
            getGlobalDiagnostics: (cancellationToken)=>withProgramOrEmptyArray((program2)=>program2.getGlobalDiagnostics(cancellationToken)),
            getConfigFileParsingDiagnostics: ()=>withProgramOrEmptyArray((program2)=>program2.getConfigFileParsingDiagnostics()),
            getSyntacticDiagnostics: (sourceFile, cancellationToken)=>withProgramOrEmptyArray((program2)=>program2.getSyntacticDiagnostics(sourceFile, cancellationToken)),
            getAllDependencies: (sourceFile)=>withProgramOrEmptyArray((program2)=>program2.getAllDependencies(sourceFile)),
            getSemanticDiagnostics: (sourceFile, cancellationToken)=>withProgramOrEmptyArray((program2)=>program2.getSemanticDiagnostics(sourceFile, cancellationToken)),
            getSemanticDiagnosticsOfNextAffectedFile: (cancellationToken, ignoreSourceFile)=>withProgramOrUndefined((program2)=>program2.getSemanticDiagnosticsOfNextAffectedFile && program2.getSemanticDiagnosticsOfNextAffectedFile(cancellationToken, ignoreSourceFile)),
            emit: (targetSourceFile, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers)=>{
                if (targetSourceFile || emitOnlyDtsFiles) return withProgramOrUndefined((program2)=>{
                    var _a, _b;
                    return program2.emit(targetSourceFile, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers || ((_b = (_a = state.host).getCustomTransformers) == null ? void 0 : _b.call(_a, project)));
                });
                executeSteps(2 /* SemanticDiagnostics */ , cancellationToken);
                if (step === 5 /* EmitBuildInfo */ ) return emitBuildInfo(writeFile2, cancellationToken);
                if (step !== 3 /* Emit */ ) return void 0;
                return emit(writeFile2, cancellationToken, customTransformers);
            },
            done: done
        } : {
            kind: kind,
            project: project,
            projectPath: projectPath,
            buildOrder: buildOrder,
            getCompilerOptions: ()=>config.options,
            getCurrentDirectory: ()=>state.compilerHost.getCurrentDirectory(),
            emit: (writeFile2, customTransformers)=>{
                if (step !== 4 /* EmitBundle */ ) return invalidatedProjectOfBundle;
                return emitBundle(writeFile2, customTransformers);
            },
            done: done
        };
        function done(cancellationToken, writeFile2, customTransformers) {
            executeSteps(8 /* Done */ , cancellationToken, writeFile2, customTransformers);
            if (kind === 0 /* Build */ ) mark("SolutionBuilder::Projects built");
            else mark("SolutionBuilder::Bundles updated");
            return doneInvalidatedProject(state, projectPath);
        }
        function withProgramOrUndefined(action) {
            executeSteps(0 /* CreateProgram */ );
            return program && action(program);
        }
        function withProgramOrEmptyArray(action) {
            return withProgramOrUndefined(action) || emptyArray;
        }
        function createProgram2() {
            var _a, _b;
            Debug.assert(program === void 0);
            if (state.options.dry) {
                reportStatus(state, Diagnostics.A_non_dry_build_would_build_project_0, project);
                buildResult = 1 /* Success */ ;
                step = 7 /* QueueReferencingProjects */ ;
                return;
            }
            if (state.options.verbose) reportStatus(state, Diagnostics.Building_project_0, project);
            if (config.fileNames.length === 0) {
                reportAndStoreErrors(state, projectPath, getConfigFileParsingDiagnostics(config));
                buildResult = 0 /* None */ ;
                step = 7 /* QueueReferencingProjects */ ;
                return;
            }
            const { host: host , compilerHost: compilerHost  } = state;
            state.projectCompilerOptions = config.options;
            (_a = state.moduleResolutionCache) == null || _a.update(config.options);
            (_b = state.typeReferenceDirectiveResolutionCache) == null || _b.update(config.options);
            program = host.createProgram(config.fileNames, config.options, compilerHost, getOldProgram(state, projectPath, config), getConfigFileParsingDiagnostics(config), config.projectReferences);
            if (state.watch) {
                state.lastCachedPackageJsonLookups.set(projectPath, state.moduleResolutionCache && map(state.moduleResolutionCache.getPackageJsonInfoCache().entries(), ([path, data])=>[
                        state.host.realpath && data ? toPath2(state, state.host.realpath(path)) : path,
                        data
                    ]));
                state.builderPrograms.set(projectPath, program);
            }
            step++;
        }
        function handleDiagnostics(diagnostics, errorFlags, errorType) {
            if (diagnostics.length) ({ buildResult: buildResult , step: step  } = buildErrors(state, projectPath, program, config, diagnostics, errorFlags, errorType));
            else step++;
        }
        function getSyntaxDiagnostics(cancellationToken) {
            Debug.assertIsDefined(program);
            handleDiagnostics([
                ...program.getConfigFileParsingDiagnostics(),
                ...program.getOptionsDiagnostics(cancellationToken),
                ...program.getGlobalDiagnostics(cancellationToken),
                ...program.getSyntacticDiagnostics(/*sourceFile*/ void 0, cancellationToken)
            ], 8 /* SyntaxErrors */ , "Syntactic");
        }
        function getSemanticDiagnostics(cancellationToken) {
            handleDiagnostics(Debug.checkDefined(program).getSemanticDiagnostics(/*sourceFile*/ void 0, cancellationToken), 16 /* TypeErrors */ , "Semantic");
        }
        function emit(writeFileCallback, cancellationToken, customTransformers) {
            var _a, _b, _c;
            Debug.assertIsDefined(program);
            Debug.assert(step === 3 /* Emit */ );
            const saved = program.saveEmitState();
            let declDiagnostics;
            const reportDeclarationDiagnostics = (d)=>(declDiagnostics || (declDiagnostics = [])).push(d);
            const outputFiles = [];
            const { emitResult: emitResult  } = emitFilesAndReportErrors(program, reportDeclarationDiagnostics, /*write*/ void 0, /*reportSummary*/ void 0, (name, text, writeByteOrderMark, _onError, _sourceFiles, data)=>outputFiles.push({
                    name: name,
                    text: text,
                    writeByteOrderMark: writeByteOrderMark,
                    data: data
                }), cancellationToken, /*emitOnlyDtsFiles*/ false, customTransformers || ((_b = (_a = state.host).getCustomTransformers) == null ? void 0 : _b.call(_a, project)));
            if (declDiagnostics) {
                program.restoreEmitState(saved);
                ({ buildResult: buildResult , step: step  } = buildErrors(state, projectPath, program, config, declDiagnostics, 32 /* DeclarationEmitErrors */ , "Declaration file"));
                return {
                    emitSkipped: true,
                    diagnostics: emitResult.diagnostics
                };
            }
            const { host: host , compilerHost: compilerHost  } = state;
            const resultFlags = ((_c = program.hasChangedEmitSignature) == null ? void 0 : _c.call(program)) ? 0 /* None */  : 2 /* DeclarationOutputUnchanged */ ;
            const emitterDiagnostics = createDiagnosticCollection();
            const emittedOutputs = /* @__PURE__ */ new Map();
            const options = program.getCompilerOptions();
            const isIncremental = isIncrementalCompilation(options);
            let outputTimeStampMap;
            let now;
            outputFiles.forEach(({ name: name , text: text , writeByteOrderMark: writeByteOrderMark , data: data  })=>{
                const path = toPath2(state, name);
                emittedOutputs.set(toPath2(state, name), name);
                if (data == null ? void 0 : data.buildInfo) setBuildInfo(state, data.buildInfo, projectPath, options, resultFlags);
                const modifiedTime = (data == null ? void 0 : data.differsOnlyInMap) ? getModifiedTime(state.host, name) : void 0;
                writeFile(writeFileCallback ? {
                    writeFile: writeFileCallback
                } : compilerHost, emitterDiagnostics, name, text, writeByteOrderMark);
                if (data == null ? void 0 : data.differsOnlyInMap) state.host.setModifiedTime(name, modifiedTime);
                else if (!isIncremental && state.watch) (outputTimeStampMap || (outputTimeStampMap = getOutputTimeStampMap(state, projectPath))).set(path, now || (now = getCurrentTime(state.host)));
            });
            finishEmit(emitterDiagnostics, emittedOutputs, outputFiles.length ? outputFiles[0].name : getFirstProjectOutput(config, !host.useCaseSensitiveFileNames()), resultFlags);
            return emitResult;
        }
        function emitBuildInfo(writeFileCallback, cancellationToken) {
            Debug.assertIsDefined(program);
            Debug.assert(step === 5 /* EmitBuildInfo */ );
            const emitResult = program.emitBuildInfo((name, text, writeByteOrderMark, onError, sourceFiles, data)=>{
                if (data == null ? void 0 : data.buildInfo) setBuildInfo(state, data.buildInfo, projectPath, program.getCompilerOptions(), 2 /* DeclarationOutputUnchanged */ );
                if (writeFileCallback) writeFileCallback(name, text, writeByteOrderMark, onError, sourceFiles, data);
                else state.compilerHost.writeFile(name, text, writeByteOrderMark, onError, sourceFiles, data);
            }, cancellationToken);
            if (emitResult.diagnostics.length) {
                reportErrors(state, emitResult.diagnostics);
                state.diagnostics.set(projectPath, [
                    ...state.diagnostics.get(projectPath),
                    ...emitResult.diagnostics
                ]);
                buildResult = 64 /* EmitErrors */  & buildResult;
            }
            if (emitResult.emittedFiles && state.write) emitResult.emittedFiles.forEach((name)=>listEmittedFile(state, config, name));
            afterProgramDone(state, program, config);
            step = 7 /* QueueReferencingProjects */ ;
            return emitResult;
        }
        function finishEmit(emitterDiagnostics, emittedOutputs, oldestOutputFileName, resultFlags) {
            const emitDiagnostics = emitterDiagnostics.getDiagnostics();
            if (emitDiagnostics.length) {
                ({ buildResult: buildResult , step: step  } = buildErrors(state, projectPath, program, config, emitDiagnostics, 64 /* EmitErrors */ , "Emit"));
                return emitDiagnostics;
            }
            if (state.write) emittedOutputs.forEach((name)=>listEmittedFile(state, config, name));
            updateOutputTimestampsWorker(state, config, projectPath, Diagnostics.Updating_unchanged_output_timestamps_of_project_0, emittedOutputs);
            state.diagnostics.delete(projectPath);
            state.projectStatus.set(projectPath, {
                type: 1 /* UpToDate */ ,
                oldestOutputFileName: oldestOutputFileName
            });
            afterProgramDone(state, program, config);
            step = 7 /* QueueReferencingProjects */ ;
            buildResult = resultFlags;
            return emitDiagnostics;
        }
        function emitBundle(writeFileCallback, customTransformers) {
            var _a, _b, _c, _d;
            Debug.assert(kind === 1 /* UpdateBundle */ );
            if (state.options.dry) {
                reportStatus(state, Diagnostics.A_non_dry_build_would_update_output_of_project_0, project);
                buildResult = 1 /* Success */ ;
                step = 7 /* QueueReferencingProjects */ ;
                return void 0;
            }
            if (state.options.verbose) reportStatus(state, Diagnostics.Updating_output_of_project_0, project);
            const { compilerHost: compilerHost  } = state;
            state.projectCompilerOptions = config.options;
            (_b = (_a = state.host).beforeEmitBundle) == null || _b.call(_a, config);
            const outputFiles = emitUsingBuildInfo(config, compilerHost, (ref)=>{
                const refName = resolveProjectName(state, ref.path);
                return parseConfigFile(state, refName, toResolvedConfigFilePath(state, refName));
            }, customTransformers || ((_d = (_c = state.host).getCustomTransformers) == null ? void 0 : _d.call(_c, project)));
            if (isString(outputFiles)) {
                reportStatus(state, Diagnostics.Cannot_update_output_of_project_0_because_there_was_error_reading_file_1, project, relName(state, outputFiles));
                step = 6 /* BuildInvalidatedProjectOfBundle */ ;
                return invalidatedProjectOfBundle = createBuildOrUpdateInvalidedProject(0 /* Build */ , state, project, projectPath, projectIndex, config, buildOrder);
            }
            Debug.assert(!!outputFiles.length);
            const emitterDiagnostics = createDiagnosticCollection();
            const emittedOutputs = /* @__PURE__ */ new Map();
            let resultFlags = 2 /* DeclarationOutputUnchanged */ ;
            const existingBuildInfo = state.buildInfoCache.get(projectPath).buildInfo || void 0;
            outputFiles.forEach(({ name: name , text: text , writeByteOrderMark: writeByteOrderMark , data: data  })=>{
                var _a2, _b2;
                emittedOutputs.set(toPath2(state, name), name);
                if (data == null ? void 0 : data.buildInfo) {
                    if (((_a2 = data.buildInfo.program) == null ? void 0 : _a2.outSignature) !== ((_b2 = existingBuildInfo == null ? void 0 : existingBuildInfo.program) == null ? void 0 : _b2.outSignature)) resultFlags &= -3 /* DeclarationOutputUnchanged */ ;
                    setBuildInfo(state, data.buildInfo, projectPath, config.options, resultFlags);
                }
                writeFile(writeFileCallback ? {
                    writeFile: writeFileCallback
                } : compilerHost, emitterDiagnostics, name, text, writeByteOrderMark);
            });
            const emitDiagnostics = finishEmit(emitterDiagnostics, emittedOutputs, outputFiles[0].name, resultFlags);
            return {
                emitSkipped: false,
                diagnostics: emitDiagnostics
            };
        }
        function executeSteps(till, cancellationToken, writeFile2, customTransformers) {
            while(step <= till && step < 8 /* Done */ ){
                const currentStep = step;
                switch(step){
                    case 0 /* CreateProgram */ :
                        createProgram2();
                        break;
                    case 1 /* SyntaxDiagnostics */ :
                        getSyntaxDiagnostics(cancellationToken);
                        break;
                    case 2 /* SemanticDiagnostics */ :
                        getSemanticDiagnostics(cancellationToken);
                        break;
                    case 3 /* Emit */ :
                        emit(writeFile2, cancellationToken, customTransformers);
                        break;
                    case 5 /* EmitBuildInfo */ :
                        emitBuildInfo(writeFile2, cancellationToken);
                        break;
                    case 4 /* EmitBundle */ :
                        emitBundle(writeFile2, customTransformers);
                        break;
                    case 6 /* BuildInvalidatedProjectOfBundle */ :
                        Debug.checkDefined(invalidatedProjectOfBundle).done(cancellationToken, writeFile2, customTransformers);
                        step = 8 /* Done */ ;
                        break;
                    case 7 /* QueueReferencingProjects */ :
                        queueReferencingProjects(state, project, projectPath, projectIndex, config, buildOrder, Debug.checkDefined(buildResult));
                        step++;
                        break;
                    case 8 /* Done */ :
                    default:
                        assertType(step);
                }
                Debug.assert(step > currentStep);
            }
        }
    }
    function needsBuild({ options: options  }, status, config) {
        if (status.type !== 3 /* OutOfDateWithPrepend */  || options.force) return true;
        return config.fileNames.length === 0 || !!getConfigFileParsingDiagnostics(config).length || !isIncrementalCompilation(config.options);
    }
    function getNextInvalidatedProjectCreateInfo(state, buildOrder, reportQueue) {
        if (!state.projectPendingBuild.size) return void 0;
        if (isCircularBuildOrder(buildOrder)) return void 0;
        const { options: options , projectPendingBuild: projectPendingBuild  } = state;
        for(let projectIndex = 0; projectIndex < buildOrder.length; projectIndex++){
            const project = buildOrder[projectIndex];
            const projectPath = toResolvedConfigFilePath(state, project);
            const reloadLevel = state.projectPendingBuild.get(projectPath);
            if (reloadLevel === void 0) continue;
            if (reportQueue) {
                reportQueue = false;
                reportBuildQueue(state, buildOrder);
            }
            const config = parseConfigFile(state, project, projectPath);
            if (!config) {
                reportParseConfigFileDiagnostic(state, projectPath);
                projectPendingBuild.delete(projectPath);
                continue;
            }
            if (reloadLevel === 2 /* Full */ ) {
                watchConfigFile(state, project, projectPath, config);
                watchExtendedConfigFiles(state, projectPath, config);
                watchWildCardDirectories(state, project, projectPath, config);
                watchInputFiles(state, project, projectPath, config);
                watchPackageJsonFiles(state, project, projectPath, config);
            } else if (reloadLevel === 1 /* Partial */ ) {
                config.fileNames = getFileNamesFromConfigSpecs(config.options.configFile.configFileSpecs, getDirectoryPath(project), config.options, state.parseConfigFileHost);
                updateErrorForNoInputFiles(config.fileNames, project, config.options.configFile.configFileSpecs, config.errors, canJsonReportNoInputFiles(config.raw));
                watchInputFiles(state, project, projectPath, config);
                watchPackageJsonFiles(state, project, projectPath, config);
            }
            const status = getUpToDateStatus(state, config, projectPath);
            if (!options.force) {
                if (status.type === 1 /* UpToDate */ ) {
                    verboseReportProjectStatus(state, project, status);
                    reportAndStoreErrors(state, projectPath, getConfigFileParsingDiagnostics(config));
                    projectPendingBuild.delete(projectPath);
                    if (options.dry) reportStatus(state, Diagnostics.Project_0_is_up_to_date, project);
                    continue;
                }
                if (status.type === 2 /* UpToDateWithUpstreamTypes */  || status.type === 15 /* UpToDateWithInputFileText */ ) {
                    reportAndStoreErrors(state, projectPath, getConfigFileParsingDiagnostics(config));
                    return {
                        kind: 2 /* UpdateOutputFileStamps */ ,
                        status: status,
                        project: project,
                        projectPath: projectPath,
                        projectIndex: projectIndex,
                        config: config
                    };
                }
            }
            if (status.type === 12 /* UpstreamBlocked */ ) {
                verboseReportProjectStatus(state, project, status);
                reportAndStoreErrors(state, projectPath, getConfigFileParsingDiagnostics(config));
                projectPendingBuild.delete(projectPath);
                if (options.verbose) reportStatus(state, status.upstreamProjectBlocked ? Diagnostics.Skipping_build_of_project_0_because_its_dependency_1_was_not_built : Diagnostics.Skipping_build_of_project_0_because_its_dependency_1_has_errors, project, status.upstreamProjectName);
                continue;
            }
            if (status.type === 16 /* ContainerOnly */ ) {
                verboseReportProjectStatus(state, project, status);
                reportAndStoreErrors(state, projectPath, getConfigFileParsingDiagnostics(config));
                projectPendingBuild.delete(projectPath);
                continue;
            }
            return {
                kind: needsBuild(state, status, config) ? 0 /* Build */  : 1 /* UpdateBundle */ ,
                status: status,
                project: project,
                projectPath: projectPath,
                projectIndex: projectIndex,
                config: config
            };
        }
        return void 0;
    }
    function createInvalidatedProjectWithInfo(state, info, buildOrder) {
        verboseReportProjectStatus(state, info.project, info.status);
        return info.kind !== 2 /* UpdateOutputFileStamps */  ? createBuildOrUpdateInvalidedProject(info.kind, state, info.project, info.projectPath, info.projectIndex, info.config, buildOrder) : createUpdateOutputFileStampsProject(state, info.project, info.projectPath, info.config, buildOrder);
    }
    function getNextInvalidatedProject(state, buildOrder, reportQueue) {
        const info = getNextInvalidatedProjectCreateInfo(state, buildOrder, reportQueue);
        if (!info) return info;
        return createInvalidatedProjectWithInfo(state, info, buildOrder);
    }
    function listEmittedFile({ write: write  }, proj, file) {
        if (write && proj.options.listEmittedFiles) write(`TSFILE: ${file}`);
    }
    function getOldProgram({ options: options , builderPrograms: builderPrograms , compilerHost: compilerHost  }, proj, parsed) {
        if (options.force) return void 0;
        const value1 = builderPrograms.get(proj);
        if (value1) return value1;
        return readBuilderProgram(parsed.options, compilerHost);
    }
    function afterProgramDone(state, program, config) {
        if (program) {
            if (state.write) listFiles(program, state.write);
            if (state.host.afterProgramEmitAndDiagnostics) state.host.afterProgramEmitAndDiagnostics(program);
            program.releaseProgram();
        } else if (state.host.afterEmitBundle) state.host.afterEmitBundle(config);
        state.projectCompilerOptions = state.baseCompilerOptions;
    }
    function buildErrors(state, resolvedPath, program, config, diagnostics, buildResult, errorType) {
        const canEmitBuildInfo = program && !outFile(program.getCompilerOptions());
        reportAndStoreErrors(state, resolvedPath, diagnostics);
        state.projectStatus.set(resolvedPath, {
            type: 0 /* Unbuildable */ ,
            reason: `${errorType} errors`
        });
        if (canEmitBuildInfo) return {
            buildResult: buildResult,
            step: 5 /* EmitBuildInfo */ 
        };
        afterProgramDone(state, program, config);
        return {
            buildResult: buildResult,
            step: 7 /* QueueReferencingProjects */ 
        };
    }
    function isFileWatcherWithModifiedTime(value1) {
        return !!value1.watcher;
    }
    function getModifiedTime2(state, fileName) {
        const path = toPath2(state, fileName);
        const existing = state.filesWatched.get(path);
        if (state.watch && !!existing) {
            if (!isFileWatcherWithModifiedTime(existing)) return existing;
            if (existing.modifiedTime) return existing.modifiedTime;
        }
        const result = getModifiedTime(state.host, fileName);
        if (state.watch) {
            if (existing) existing.modifiedTime = result;
            else state.filesWatched.set(path, result);
        }
        return result;
    }
    function watchFile(state, file, callback, pollingInterval, options, watchType, project) {
        const path = toPath2(state, file);
        const existing = state.filesWatched.get(path);
        if (existing && isFileWatcherWithModifiedTime(existing)) existing.callbacks.push(callback);
        else {
            const watcher = state.watchFile(file, (fileName, eventKind, modifiedTime)=>{
                const existing2 = Debug.checkDefined(state.filesWatched.get(path));
                Debug.assert(isFileWatcherWithModifiedTime(existing2));
                existing2.modifiedTime = modifiedTime;
                existing2.callbacks.forEach((cb)=>cb(fileName, eventKind, modifiedTime));
            }, pollingInterval, options, watchType, project);
            state.filesWatched.set(path, {
                callbacks: [
                    callback
                ],
                watcher: watcher,
                modifiedTime: existing
            });
        }
        return {
            close: ()=>{
                const existing2 = Debug.checkDefined(state.filesWatched.get(path));
                Debug.assert(isFileWatcherWithModifiedTime(existing2));
                if (existing2.callbacks.length === 1) {
                    state.filesWatched.delete(path);
                    closeFileWatcherOf(existing2);
                } else unorderedRemoveItem(existing2.callbacks, callback);
            }
        };
    }
    function getOutputTimeStampMap(state, resolvedConfigFilePath) {
        if (!state.watch) return void 0;
        let result = state.outputTimeStamps.get(resolvedConfigFilePath);
        if (!result) state.outputTimeStamps.set(resolvedConfigFilePath, result = /* @__PURE__ */ new Map());
        return result;
    }
    function setBuildInfo(state, buildInfo, resolvedConfigPath, options, resultFlags) {
        const buildInfoPath = getTsBuildInfoEmitOutputFilePath(options);
        const existing = getBuildInfoCacheEntry(state, buildInfoPath, resolvedConfigPath);
        const modifiedTime = getCurrentTime(state.host);
        if (existing) {
            existing.buildInfo = buildInfo;
            existing.modifiedTime = modifiedTime;
            if (!(resultFlags & 2 /* DeclarationOutputUnchanged */ )) existing.latestChangedDtsTime = modifiedTime;
        } else state.buildInfoCache.set(resolvedConfigPath, {
            path: toPath2(state, buildInfoPath),
            buildInfo: buildInfo,
            modifiedTime: modifiedTime,
            latestChangedDtsTime: resultFlags & 2 /* DeclarationOutputUnchanged */  ? void 0 : modifiedTime
        });
    }
    function getBuildInfoCacheEntry(state, buildInfoPath, resolvedConfigPath) {
        const path = toPath2(state, buildInfoPath);
        const existing = state.buildInfoCache.get(resolvedConfigPath);
        return (existing == null ? void 0 : existing.path) === path ? existing : void 0;
    }
    function getBuildInfo3(state, buildInfoPath, resolvedConfigPath, modifiedTime) {
        const path = toPath2(state, buildInfoPath);
        const existing = state.buildInfoCache.get(resolvedConfigPath);
        if (existing !== void 0 && existing.path === path) return existing.buildInfo || void 0;
        const value1 = state.readFileWithCache(buildInfoPath);
        const buildInfo = value1 ? getBuildInfo(buildInfoPath, value1) : void 0;
        state.buildInfoCache.set(resolvedConfigPath, {
            path: path,
            buildInfo: buildInfo || false,
            modifiedTime: modifiedTime || missingFileModifiedTime
        });
        return buildInfo;
    }
    function checkConfigFileUpToDateStatus(state, configFile, oldestOutputFileTime, oldestOutputFileName) {
        const tsconfigTime = getModifiedTime2(state, configFile);
        if (oldestOutputFileTime < tsconfigTime) return {
            type: 6 /* OutOfDateWithSelf */ ,
            outOfDateOutputFileName: oldestOutputFileName,
            newerInputFileName: configFile
        };
    }
    function getUpToDateStatusWorker(state, project, resolvedPath) {
        var _a, _b;
        if (!project.fileNames.length && !canJsonReportNoInputFiles(project.raw)) return {
            type: 16 /* ContainerOnly */ 
        };
        let referenceStatuses;
        const force = !!state.options.force;
        if (project.projectReferences) {
            state.projectStatus.set(resolvedPath, {
                type: 13 /* ComputingUpstream */ 
            });
            for (const ref of project.projectReferences){
                const resolvedRef = resolveProjectReferencePath(ref);
                const resolvedRefPath = toResolvedConfigFilePath(state, resolvedRef);
                const resolvedConfig = parseConfigFile(state, resolvedRef, resolvedRefPath);
                const refStatus = getUpToDateStatus(state, resolvedConfig, resolvedRefPath);
                if (refStatus.type === 13 /* ComputingUpstream */  || refStatus.type === 16 /* ContainerOnly */ ) continue;
                if (refStatus.type === 0 /* Unbuildable */  || refStatus.type === 12 /* UpstreamBlocked */ ) return {
                    type: 12 /* UpstreamBlocked */ ,
                    upstreamProjectName: ref.path,
                    upstreamProjectBlocked: refStatus.type === 12 /* UpstreamBlocked */ 
                };
                if (refStatus.type !== 1 /* UpToDate */ ) return {
                    type: 11 /* UpstreamOutOfDate */ ,
                    upstreamProjectName: ref.path
                };
                if (!force) (referenceStatuses || (referenceStatuses = [])).push({
                    ref: ref,
                    refStatus: refStatus,
                    resolvedRefPath: resolvedRefPath,
                    resolvedConfig: resolvedConfig
                });
            }
        }
        if (force) return {
            type: 17 /* ForceBuild */ 
        };
        const { host: host  } = state;
        const buildInfoPath = getTsBuildInfoEmitOutputFilePath(project.options);
        let oldestOutputFileName;
        let oldestOutputFileTime = maximumDate;
        let buildInfoTime;
        let buildInfoProgram;
        let buildInfoVersionMap;
        if (buildInfoPath) {
            const buildInfoCacheEntry2 = getBuildInfoCacheEntry(state, buildInfoPath, resolvedPath);
            buildInfoTime = (buildInfoCacheEntry2 == null ? void 0 : buildInfoCacheEntry2.modifiedTime) || getModifiedTime(host, buildInfoPath);
            if (buildInfoTime === missingFileModifiedTime) {
                if (!buildInfoCacheEntry2) state.buildInfoCache.set(resolvedPath, {
                    path: toPath2(state, buildInfoPath),
                    buildInfo: false,
                    modifiedTime: buildInfoTime
                });
                return {
                    type: 4 /* OutputMissing */ ,
                    missingOutputFileName: buildInfoPath
                };
            }
            const buildInfo = getBuildInfo3(state, buildInfoPath, resolvedPath, buildInfoTime);
            if (!buildInfo) return {
                type: 5 /* ErrorReadingFile */ ,
                fileName: buildInfoPath
            };
            if ((buildInfo.bundle || buildInfo.program) && buildInfo.version !== version) return {
                type: 14 /* TsVersionOutputOfDate */ ,
                version: buildInfo.version
            };
            if (buildInfo.program) {
                if (((_a = buildInfo.program.changeFileSet) == null ? void 0 : _a.length) || (!project.options.noEmit ? (_b = buildInfo.program.affectedFilesPendingEmit) == null ? void 0 : _b.length : some(buildInfo.program.semanticDiagnosticsPerFile, isArray))) return {
                    type: 8 /* OutOfDateBuildInfo */ ,
                    buildInfoFile: buildInfoPath
                };
                if (!project.options.noEmit && getPendingEmitKind(project.options, buildInfo.program.options || {})) return {
                    type: 9 /* OutOfDateOptions */ ,
                    buildInfoFile: buildInfoPath
                };
                buildInfoProgram = buildInfo.program;
            }
            oldestOutputFileTime = buildInfoTime;
            oldestOutputFileName = buildInfoPath;
        }
        let newestInputFileName = void 0;
        let newestInputFileTime = minimumDate;
        let pseudoInputUpToDate = false;
        const seenRoots = /* @__PURE__ */ new Set();
        for (const inputFile of project.fileNames){
            const inputTime = getModifiedTime2(state, inputFile);
            if (inputTime === missingFileModifiedTime) return {
                type: 0 /* Unbuildable */ ,
                reason: `${inputFile} does not exist`
            };
            if (buildInfoTime && buildInfoTime < inputTime) {
                let version2;
                let currentVersion;
                if (buildInfoProgram) {
                    if (!buildInfoVersionMap) buildInfoVersionMap = getBuildInfoFileVersionMap(buildInfoProgram, buildInfoPath, host);
                    version2 = buildInfoVersionMap.fileInfos.get(toPath2(state, inputFile));
                    const text = version2 ? state.readFileWithCache(inputFile) : void 0;
                    currentVersion = text !== void 0 ? getSourceFileVersionAsHashFromText(host, text) : void 0;
                    if (version2 && version2 === currentVersion) pseudoInputUpToDate = true;
                }
                if (!version2 || version2 !== currentVersion) return {
                    type: 6 /* OutOfDateWithSelf */ ,
                    outOfDateOutputFileName: buildInfoPath,
                    newerInputFileName: inputFile
                };
            }
            if (inputTime > newestInputFileTime) {
                newestInputFileName = inputFile;
                newestInputFileTime = inputTime;
            }
            if (buildInfoProgram) seenRoots.add(toPath2(state, inputFile));
        }
        if (buildInfoProgram) {
            if (!buildInfoVersionMap) buildInfoVersionMap = getBuildInfoFileVersionMap(buildInfoProgram, buildInfoPath, host);
            for (const existingRoot of buildInfoVersionMap.roots){
                if (!seenRoots.has(existingRoot)) return {
                    type: 10 /* OutOfDateRoots */ ,
                    buildInfoFile: buildInfoPath,
                    inputFile: existingRoot
                };
            }
        }
        if (!buildInfoPath) {
            const outputs = getAllProjectOutputs(project, !host.useCaseSensitiveFileNames());
            const outputTimeStampMap = getOutputTimeStampMap(state, resolvedPath);
            for (const output of outputs){
                const path = toPath2(state, output);
                let outputTime = outputTimeStampMap == null ? void 0 : outputTimeStampMap.get(path);
                if (!outputTime) {
                    outputTime = getModifiedTime(state.host, output);
                    outputTimeStampMap == null || outputTimeStampMap.set(path, outputTime);
                }
                if (outputTime === missingFileModifiedTime) return {
                    type: 4 /* OutputMissing */ ,
                    missingOutputFileName: output
                };
                if (outputTime < newestInputFileTime) return {
                    type: 6 /* OutOfDateWithSelf */ ,
                    outOfDateOutputFileName: output,
                    newerInputFileName: newestInputFileName
                };
                if (outputTime < oldestOutputFileTime) {
                    oldestOutputFileTime = outputTime;
                    oldestOutputFileName = output;
                }
            }
        }
        const buildInfoCacheEntry = state.buildInfoCache.get(resolvedPath);
        let pseudoUpToDate = false;
        let usesPrepend = false;
        let upstreamChangedProject;
        if (referenceStatuses) for (const { ref: ref , refStatus: refStatus , resolvedConfig: resolvedConfig , resolvedRefPath: resolvedRefPath  } of referenceStatuses){
            usesPrepend = usesPrepend || !!ref.prepend;
            if (refStatus.newestInputFileTime && refStatus.newestInputFileTime <= oldestOutputFileTime) continue;
            if (buildInfoCacheEntry && hasSameBuildInfo(state, buildInfoCacheEntry, resolvedRefPath)) return {
                type: 7 /* OutOfDateWithUpstream */ ,
                outOfDateOutputFileName: buildInfoPath,
                newerProjectName: ref.path
            };
            const newestDeclarationFileContentChangedTime = getLatestChangedDtsTime(state, resolvedConfig.options, resolvedRefPath);
            if (newestDeclarationFileContentChangedTime && newestDeclarationFileContentChangedTime <= oldestOutputFileTime) {
                pseudoUpToDate = true;
                upstreamChangedProject = ref.path;
                continue;
            }
            Debug.assert(oldestOutputFileName !== void 0, "Should have an oldest output filename here");
            return {
                type: 7 /* OutOfDateWithUpstream */ ,
                outOfDateOutputFileName: oldestOutputFileName,
                newerProjectName: ref.path
            };
        }
        const configStatus = checkConfigFileUpToDateStatus(state, project.options.configFilePath, oldestOutputFileTime, oldestOutputFileName);
        if (configStatus) return configStatus;
        const extendedConfigStatus = forEach(project.options.configFile.extendedSourceFiles || emptyArray, (configFile)=>checkConfigFileUpToDateStatus(state, configFile, oldestOutputFileTime, oldestOutputFileName));
        if (extendedConfigStatus) return extendedConfigStatus;
        const dependentPackageFileStatus = forEach(state.lastCachedPackageJsonLookups.get(resolvedPath) || emptyArray, ([path])=>checkConfigFileUpToDateStatus(state, path, oldestOutputFileTime, oldestOutputFileName));
        if (dependentPackageFileStatus) return dependentPackageFileStatus;
        if (usesPrepend && pseudoUpToDate) return {
            type: 3 /* OutOfDateWithPrepend */ ,
            outOfDateOutputFileName: oldestOutputFileName,
            newerProjectName: upstreamChangedProject
        };
        return {
            type: pseudoUpToDate ? 2 /* UpToDateWithUpstreamTypes */  : pseudoInputUpToDate ? 15 /* UpToDateWithInputFileText */  : 1 /* UpToDate */ ,
            newestInputFileTime: newestInputFileTime,
            newestInputFileName: newestInputFileName,
            oldestOutputFileName: oldestOutputFileName
        };
    }
    function hasSameBuildInfo(state, buildInfoCacheEntry, resolvedRefPath) {
        const refBuildInfo = state.buildInfoCache.get(resolvedRefPath);
        return refBuildInfo.path === buildInfoCacheEntry.path;
    }
    function getUpToDateStatus(state, project, resolvedPath) {
        if (project === void 0) return {
            type: 0 /* Unbuildable */ ,
            reason: "File deleted mid-build"
        };
        const prior = state.projectStatus.get(resolvedPath);
        if (prior !== void 0) return prior;
        mark("SolutionBuilder::beforeUpToDateCheck");
        const actual = getUpToDateStatusWorker(state, project, resolvedPath);
        mark("SolutionBuilder::afterUpToDateCheck");
        measure("SolutionBuilder::Up-to-date check", "SolutionBuilder::beforeUpToDateCheck", "SolutionBuilder::afterUpToDateCheck");
        state.projectStatus.set(resolvedPath, actual);
        return actual;
    }
    function updateOutputTimestampsWorker(state, proj, projectPath, verboseMessage, skipOutputs) {
        if (proj.options.noEmit) return;
        let now;
        const buildInfoPath = getTsBuildInfoEmitOutputFilePath(proj.options);
        if (buildInfoPath) {
            if (!(skipOutputs == null ? void 0 : skipOutputs.has(toPath2(state, buildInfoPath)))) {
                if (!!state.options.verbose) reportStatus(state, verboseMessage, proj.options.configFilePath);
                state.host.setModifiedTime(buildInfoPath, now = getCurrentTime(state.host));
                getBuildInfoCacheEntry(state, buildInfoPath, projectPath).modifiedTime = now;
            }
            state.outputTimeStamps.delete(projectPath);
            return;
        }
        const { host: host  } = state;
        const outputs = getAllProjectOutputs(proj, !host.useCaseSensitiveFileNames());
        const outputTimeStampMap = getOutputTimeStampMap(state, projectPath);
        const modifiedOutputs = outputTimeStampMap ? /* @__PURE__ */ new Set() : void 0;
        if (!skipOutputs || outputs.length !== skipOutputs.size) {
            let reportVerbose = !!state.options.verbose;
            for (const file of outputs){
                const path = toPath2(state, file);
                if (skipOutputs == null ? void 0 : skipOutputs.has(path)) continue;
                if (reportVerbose) {
                    reportVerbose = false;
                    reportStatus(state, verboseMessage, proj.options.configFilePath);
                }
                host.setModifiedTime(file, now || (now = getCurrentTime(state.host)));
                if (outputTimeStampMap) {
                    outputTimeStampMap.set(path, now);
                    modifiedOutputs.add(path);
                }
            }
        }
        outputTimeStampMap == null || outputTimeStampMap.forEach((_value, key)=>{
            if (!(skipOutputs == null ? void 0 : skipOutputs.has(key)) && !modifiedOutputs.has(key)) outputTimeStampMap.delete(key);
        });
    }
    function getLatestChangedDtsTime(state, options, resolvedConfigPath) {
        if (!options.composite) return void 0;
        const entry = Debug.checkDefined(state.buildInfoCache.get(resolvedConfigPath));
        if (entry.latestChangedDtsTime !== void 0) return entry.latestChangedDtsTime || void 0;
        const latestChangedDtsTime = entry.buildInfo && entry.buildInfo.program && entry.buildInfo.program.latestChangedDtsFile ? state.host.getModifiedTime(getNormalizedAbsolutePath(entry.buildInfo.program.latestChangedDtsFile, getDirectoryPath(entry.path))) : void 0;
        entry.latestChangedDtsTime = latestChangedDtsTime || false;
        return latestChangedDtsTime;
    }
    function updateOutputTimestamps(state, proj, resolvedPath) {
        if (state.options.dry) return reportStatus(state, Diagnostics.A_non_dry_build_would_update_timestamps_for_output_of_project_0, proj.options.configFilePath);
        updateOutputTimestampsWorker(state, proj, resolvedPath, Diagnostics.Updating_output_timestamps_of_project_0);
        state.projectStatus.set(resolvedPath, {
            type: 1 /* UpToDate */ ,
            oldestOutputFileName: getFirstProjectOutput(proj, !state.host.useCaseSensitiveFileNames())
        });
    }
    function queueReferencingProjects(state, project, projectPath, projectIndex, config, buildOrder, buildResult) {
        if (buildResult & 124 /* AnyErrors */ ) return;
        if (!config.options.composite) return;
        for(let index = projectIndex + 1; index < buildOrder.length; index++){
            const nextProject = buildOrder[index];
            const nextProjectPath = toResolvedConfigFilePath(state, nextProject);
            if (state.projectPendingBuild.has(nextProjectPath)) continue;
            const nextProjectConfig = parseConfigFile(state, nextProject, nextProjectPath);
            if (!nextProjectConfig || !nextProjectConfig.projectReferences) continue;
            for (const ref of nextProjectConfig.projectReferences){
                const resolvedRefPath = resolveProjectName(state, ref.path);
                if (toResolvedConfigFilePath(state, resolvedRefPath) !== projectPath) continue;
                const status = state.projectStatus.get(nextProjectPath);
                if (status) switch(status.type){
                    case 1 /* UpToDate */ :
                        if (buildResult & 2 /* DeclarationOutputUnchanged */ ) {
                            if (ref.prepend) state.projectStatus.set(nextProjectPath, {
                                type: 3 /* OutOfDateWithPrepend */ ,
                                outOfDateOutputFileName: status.oldestOutputFileName,
                                newerProjectName: project
                            });
                            else status.type = 2 /* UpToDateWithUpstreamTypes */ ;
                            break;
                        }
                    case 15 /* UpToDateWithInputFileText */ :
                    case 2 /* UpToDateWithUpstreamTypes */ :
                    case 3 /* OutOfDateWithPrepend */ :
                        if (!(buildResult & 2 /* DeclarationOutputUnchanged */ )) state.projectStatus.set(nextProjectPath, {
                            type: 7 /* OutOfDateWithUpstream */ ,
                            outOfDateOutputFileName: status.type === 3 /* OutOfDateWithPrepend */  ? status.outOfDateOutputFileName : status.oldestOutputFileName,
                            newerProjectName: project
                        });
                        break;
                    case 12 /* UpstreamBlocked */ :
                        if (toResolvedConfigFilePath(state, resolveProjectName(state, status.upstreamProjectName)) === projectPath) clearProjectStatus(state, nextProjectPath);
                        break;
                }
                addProjToQueue(state, nextProjectPath, 0 /* None */ );
                break;
            }
        }
    }
    function build(state, project, cancellationToken, writeFile2, getCustomTransformers, onlyReferences) {
        mark("SolutionBuilder::beforeBuild");
        const result = buildWorker(state, project, cancellationToken, writeFile2, getCustomTransformers, onlyReferences);
        mark("SolutionBuilder::afterBuild");
        measure("SolutionBuilder::Build", "SolutionBuilder::beforeBuild", "SolutionBuilder::afterBuild");
        return result;
    }
    function buildWorker(state, project, cancellationToken, writeFile2, getCustomTransformers, onlyReferences) {
        const buildOrder = getBuildOrderFor(state, project, onlyReferences);
        if (!buildOrder) return 3 /* InvalidProject_OutputsSkipped */ ;
        setupInitialBuild(state, cancellationToken);
        let reportQueue = true;
        let successfulProjects = 0;
        while(true){
            const invalidatedProject = getNextInvalidatedProject(state, buildOrder, reportQueue);
            if (!invalidatedProject) break;
            reportQueue = false;
            invalidatedProject.done(cancellationToken, writeFile2, getCustomTransformers == null ? void 0 : getCustomTransformers(invalidatedProject.project));
            if (!state.diagnostics.has(invalidatedProject.projectPath)) successfulProjects++;
        }
        disableCache(state);
        reportErrorSummary(state, buildOrder);
        startWatching(state, buildOrder);
        return isCircularBuildOrder(buildOrder) ? 4 /* ProjectReferenceCycle_OutputsSkipped */  : !buildOrder.some((p)=>state.diagnostics.has(toResolvedConfigFilePath(state, p))) ? 0 /* Success */  : successfulProjects ? 2 /* DiagnosticsPresent_OutputsGenerated */  : 1 /* DiagnosticsPresent_OutputsSkipped */ ;
    }
    function clean(state, project, onlyReferences) {
        mark("SolutionBuilder::beforeClean");
        const result = cleanWorker(state, project, onlyReferences);
        mark("SolutionBuilder::afterClean");
        measure("SolutionBuilder::Clean", "SolutionBuilder::beforeClean", "SolutionBuilder::afterClean");
        return result;
    }
    function cleanWorker(state, project, onlyReferences) {
        const buildOrder = getBuildOrderFor(state, project, onlyReferences);
        if (!buildOrder) return 3 /* InvalidProject_OutputsSkipped */ ;
        if (isCircularBuildOrder(buildOrder)) {
            reportErrors(state, buildOrder.circularDiagnostics);
            return 4 /* ProjectReferenceCycle_OutputsSkipped */ ;
        }
        const { options: options , host: host  } = state;
        const filesToDelete = options.dry ? [] : void 0;
        for (const proj of buildOrder){
            const resolvedPath = toResolvedConfigFilePath(state, proj);
            const parsed = parseConfigFile(state, proj, resolvedPath);
            if (parsed === void 0) {
                reportParseConfigFileDiagnostic(state, resolvedPath);
                continue;
            }
            const outputs = getAllProjectOutputs(parsed, !host.useCaseSensitiveFileNames());
            if (!outputs.length) continue;
            const inputFileNames = new Set(parsed.fileNames.map((f)=>toPath2(state, f)));
            for (const output of outputs){
                if (inputFileNames.has(toPath2(state, output))) continue;
                if (host.fileExists(output)) {
                    if (filesToDelete) filesToDelete.push(output);
                    else {
                        host.deleteFile(output);
                        invalidateProject(state, resolvedPath, 0 /* None */ );
                    }
                }
            }
        }
        if (filesToDelete) reportStatus(state, Diagnostics.A_non_dry_build_would_delete_the_following_files_Colon_0, filesToDelete.map((f)=>`\r
 * ${f}`).join(""));
        return 0 /* Success */ ;
    }
    function invalidateProject(state, resolved, reloadLevel) {
        if (state.host.getParsedCommandLine && reloadLevel === 1 /* Partial */ ) reloadLevel = 2 /* Full */ ;
        if (reloadLevel === 2 /* Full */ ) {
            state.configFileCache.delete(resolved);
            state.buildOrder = void 0;
        }
        state.needsSummary = true;
        clearProjectStatus(state, resolved);
        addProjToQueue(state, resolved, reloadLevel);
        enableCache(state);
    }
    function invalidateProjectAndScheduleBuilds(state, resolvedPath, reloadLevel) {
        state.reportFileChangeDetected = true;
        invalidateProject(state, resolvedPath, reloadLevel);
        scheduleBuildInvalidatedProject(state, 250, /*changeDetected*/ true);
    }
    function scheduleBuildInvalidatedProject(state, time, changeDetected) {
        const { hostWithWatch: hostWithWatch  } = state;
        if (!hostWithWatch.setTimeout || !hostWithWatch.clearTimeout) return;
        if (state.timerToBuildInvalidatedProject) hostWithWatch.clearTimeout(state.timerToBuildInvalidatedProject);
        state.timerToBuildInvalidatedProject = hostWithWatch.setTimeout(buildNextInvalidatedProject, time, "timerToBuildInvalidatedProject", state, changeDetected);
    }
    function buildNextInvalidatedProject(_timeoutType, state, changeDetected) {
        mark("SolutionBuilder::beforeBuild");
        const buildOrder = buildNextInvalidatedProjectWorker(state, changeDetected);
        mark("SolutionBuilder::afterBuild");
        measure("SolutionBuilder::Build", "SolutionBuilder::beforeBuild", "SolutionBuilder::afterBuild");
        if (buildOrder) reportErrorSummary(state, buildOrder);
    }
    function buildNextInvalidatedProjectWorker(state, changeDetected) {
        state.timerToBuildInvalidatedProject = void 0;
        if (state.reportFileChangeDetected) {
            state.reportFileChangeDetected = false;
            state.projectErrorsReported.clear();
            reportWatchStatus(state, Diagnostics.File_change_detected_Starting_incremental_compilation);
        }
        let projectsBuilt = 0;
        const buildOrder = getBuildOrder(state);
        const invalidatedProject = getNextInvalidatedProject(state, buildOrder, /*reportQueue*/ false);
        if (invalidatedProject) {
            invalidatedProject.done();
            projectsBuilt++;
            while(state.projectPendingBuild.size){
                if (state.timerToBuildInvalidatedProject) return;
                const info = getNextInvalidatedProjectCreateInfo(state, buildOrder, /*reportQueue*/ false);
                if (!info) break;
                if (info.kind !== 2 /* UpdateOutputFileStamps */  && (changeDetected || projectsBuilt === 5)) {
                    scheduleBuildInvalidatedProject(state, 100, /*changeDetected*/ false);
                    return;
                }
                const project = createInvalidatedProjectWithInfo(state, info, buildOrder);
                project.done();
                if (info.kind !== 2 /* UpdateOutputFileStamps */ ) projectsBuilt++;
            }
        }
        disableCache(state);
        return buildOrder;
    }
    function watchConfigFile(state, resolved, resolvedPath, parsed) {
        if (!state.watch || state.allWatchedConfigFiles.has(resolvedPath)) return;
        state.allWatchedConfigFiles.set(resolvedPath, watchFile(state, resolved, ()=>invalidateProjectAndScheduleBuilds(state, resolvedPath, 2 /* Full */ ), 2e3 /* High */ , parsed == null ? void 0 : parsed.watchOptions, WatchType.ConfigFile, resolved));
    }
    function watchExtendedConfigFiles(state, resolvedPath, parsed) {
        updateSharedExtendedConfigFileWatcher(resolvedPath, parsed == null ? void 0 : parsed.options, state.allWatchedExtendedConfigFiles, (extendedConfigFileName, extendedConfigFilePath)=>watchFile(state, extendedConfigFileName, ()=>{
                var _a;
                return (_a = state.allWatchedExtendedConfigFiles.get(extendedConfigFilePath)) == null ? void 0 : _a.projects.forEach((projectConfigFilePath)=>invalidateProjectAndScheduleBuilds(state, projectConfigFilePath, 2 /* Full */ ));
            }, 2e3 /* High */ , parsed == null ? void 0 : parsed.watchOptions, WatchType.ExtendedConfigFile), (fileName)=>toPath2(state, fileName));
    }
    function watchWildCardDirectories(state, resolved, resolvedPath, parsed) {
        if (!state.watch) return;
        updateWatchingWildcardDirectories(getOrCreateValueMapFromConfigFileMap(state.allWatchedWildcardDirectories, resolvedPath), new Map(Object.entries(parsed.wildcardDirectories)), (dir, flags)=>state.watchDirectory(dir, (fileOrDirectory)=>{
                var _a;
                if (isIgnoredFileFromWildCardWatching({
                    watchedDirPath: toPath2(state, dir),
                    fileOrDirectory: fileOrDirectory,
                    fileOrDirectoryPath: toPath2(state, fileOrDirectory),
                    configFileName: resolved,
                    currentDirectory: state.compilerHost.getCurrentDirectory(),
                    options: parsed.options,
                    program: state.builderPrograms.get(resolvedPath) || ((_a = getCachedParsedConfigFile(state, resolvedPath)) == null ? void 0 : _a.fileNames),
                    useCaseSensitiveFileNames: state.parseConfigFileHost.useCaseSensitiveFileNames,
                    writeLog: (s)=>state.writeLog(s),
                    toPath: (fileName)=>toPath2(state, fileName)
                })) return;
                invalidateProjectAndScheduleBuilds(state, resolvedPath, 1 /* Partial */ );
            }, flags, parsed == null ? void 0 : parsed.watchOptions, WatchType.WildcardDirectory, resolved));
    }
    function watchInputFiles(state, resolved, resolvedPath, parsed) {
        if (!state.watch) return;
        mutateMap(getOrCreateValueMapFromConfigFileMap(state.allWatchedInputFiles, resolvedPath), arrayToMap(parsed.fileNames, (fileName)=>toPath2(state, fileName)), {
            createNewValue: (_path, input)=>watchFile(state, input, ()=>invalidateProjectAndScheduleBuilds(state, resolvedPath, 0 /* None */ ), 250 /* Low */ , parsed == null ? void 0 : parsed.watchOptions, WatchType.SourceFile, resolved),
            onDeleteValue: closeFileWatcher
        });
    }
    function watchPackageJsonFiles(state, resolved, resolvedPath, parsed) {
        if (!state.watch || !state.lastCachedPackageJsonLookups) return;
        mutateMap(getOrCreateValueMapFromConfigFileMap(state.allWatchedPackageJsonFiles, resolvedPath), new Map(state.lastCachedPackageJsonLookups.get(resolvedPath)), {
            createNewValue: (path, _input)=>watchFile(state, path, ()=>invalidateProjectAndScheduleBuilds(state, resolvedPath, 0 /* None */ ), 2e3 /* High */ , parsed == null ? void 0 : parsed.watchOptions, WatchType.PackageJson, resolved),
            onDeleteValue: closeFileWatcher
        });
    }
    function startWatching(state, buildOrder) {
        if (!state.watchAllProjectsPending) return;
        mark("SolutionBuilder::beforeWatcherCreation");
        state.watchAllProjectsPending = false;
        for (const resolved of getBuildOrderFromAnyBuildOrder(buildOrder)){
            const resolvedPath = toResolvedConfigFilePath(state, resolved);
            const cfg = parseConfigFile(state, resolved, resolvedPath);
            watchConfigFile(state, resolved, resolvedPath, cfg);
            watchExtendedConfigFiles(state, resolvedPath, cfg);
            if (cfg) {
                watchWildCardDirectories(state, resolved, resolvedPath, cfg);
                watchInputFiles(state, resolved, resolvedPath, cfg);
                watchPackageJsonFiles(state, resolved, resolvedPath, cfg);
            }
        }
        mark("SolutionBuilder::afterWatcherCreation");
        measure("SolutionBuilder::Watcher creation", "SolutionBuilder::beforeWatcherCreation", "SolutionBuilder::afterWatcherCreation");
    }
    function stopWatching(state) {
        clearMap(state.allWatchedConfigFiles, closeFileWatcher);
        clearMap(state.allWatchedExtendedConfigFiles, closeFileWatcherOf);
        clearMap(state.allWatchedWildcardDirectories, (watchedWildcardDirectories)=>clearMap(watchedWildcardDirectories, closeFileWatcherOf));
        clearMap(state.allWatchedInputFiles, (watchedWildcardDirectories)=>clearMap(watchedWildcardDirectories, closeFileWatcher));
        clearMap(state.allWatchedPackageJsonFiles, (watchedPacageJsonFiles)=>clearMap(watchedPacageJsonFiles, closeFileWatcher));
    }
    function createSolutionBuilderWorker(watch, hostOrHostWithWatch, rootNames, options, baseWatchOptions) {
        const state = createSolutionBuilderState(watch, hostOrHostWithWatch, rootNames, options, baseWatchOptions);
        return {
            build: (project, cancellationToken, writeFile2, getCustomTransformers)=>build(state, project, cancellationToken, writeFile2, getCustomTransformers),
            clean: (project)=>clean(state, project),
            buildReferences: (project, cancellationToken, writeFile2, getCustomTransformers)=>build(state, project, cancellationToken, writeFile2, getCustomTransformers, /*onlyReferences*/ true),
            cleanReferences: (project)=>clean(state, project, /*onlyReferences*/ true),
            getNextInvalidatedProject: (cancellationToken)=>{
                setupInitialBuild(state, cancellationToken);
                return getNextInvalidatedProject(state, getBuildOrder(state), /*reportQueue*/ false);
            },
            getBuildOrder: ()=>getBuildOrder(state),
            getUpToDateStatusOfProject: (project)=>{
                const configFileName = resolveProjectName(state, project);
                const configFilePath = toResolvedConfigFilePath(state, configFileName);
                return getUpToDateStatus(state, parseConfigFile(state, configFileName, configFilePath), configFilePath);
            },
            invalidateProject: (configFilePath, reloadLevel)=>invalidateProject(state, configFilePath, reloadLevel || 0 /* None */ ),
            close: ()=>stopWatching(state)
        };
    }
    function relName(state, path) {
        return convertToRelativePath(path, state.compilerHost.getCurrentDirectory(), state.compilerHost.getCanonicalFileName);
    }
    function reportStatus(state, message, ...args) {
        state.host.reportSolutionBuilderStatus(createCompilerDiagnostic(message, ...args));
    }
    function reportWatchStatus(state, message, ...args) {
        var _a, _b;
        (_b = (_a = state.hostWithWatch).onWatchStatusChange) == null || _b.call(_a, createCompilerDiagnostic(message, ...args), state.host.getNewLine(), state.baseCompilerOptions);
    }
    function reportErrors({ host: host  }, errors) {
        errors.forEach((err)=>host.reportDiagnostic(err));
    }
    function reportAndStoreErrors(state, proj, errors) {
        reportErrors(state, errors);
        state.projectErrorsReported.set(proj, true);
        if (errors.length) state.diagnostics.set(proj, errors);
    }
    function reportParseConfigFileDiagnostic(state, proj) {
        reportAndStoreErrors(state, proj, [
            state.configFileCache.get(proj)
        ]);
    }
    function reportErrorSummary(state, buildOrder) {
        if (!state.needsSummary) return;
        state.needsSummary = false;
        const canReportSummary = state.watch || !!state.host.reportErrorSummary;
        const { diagnostics: diagnostics  } = state;
        let totalErrors = 0;
        let filesInError = [];
        if (isCircularBuildOrder(buildOrder)) {
            reportBuildQueue(state, buildOrder.buildOrder);
            reportErrors(state, buildOrder.circularDiagnostics);
            if (canReportSummary) totalErrors += getErrorCountForSummary(buildOrder.circularDiagnostics);
            if (canReportSummary) filesInError = [
                ...filesInError,
                ...getFilesInErrorForSummary(buildOrder.circularDiagnostics)
            ];
        } else {
            buildOrder.forEach((project)=>{
                const projectPath = toResolvedConfigFilePath(state, project);
                if (!state.projectErrorsReported.has(projectPath)) reportErrors(state, diagnostics.get(projectPath) || emptyArray);
            });
            if (canReportSummary) diagnostics.forEach((singleProjectErrors)=>totalErrors += getErrorCountForSummary(singleProjectErrors));
            if (canReportSummary) diagnostics.forEach((singleProjectErrors)=>[
                    ...filesInError,
                    ...getFilesInErrorForSummary(singleProjectErrors)
                ]);
        }
        if (state.watch) reportWatchStatus(state, getWatchErrorSummaryDiagnosticMessage(totalErrors), totalErrors);
        else if (state.host.reportErrorSummary) state.host.reportErrorSummary(totalErrors, filesInError);
    }
    function reportBuildQueue(state, buildQueue) {
        if (state.options.verbose) reportStatus(state, Diagnostics.Projects_in_this_build_Colon_0, buildQueue.map((s)=>"\r\n    * " + relName(state, s)).join(""));
    }
    function reportUpToDateStatus(state, configFileName, status) {
        switch(status.type){
            case 6 /* OutOfDateWithSelf */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_output_1_is_older_than_input_2, relName(state, configFileName), relName(state, status.outOfDateOutputFileName), relName(state, status.newerInputFileName));
            case 7 /* OutOfDateWithUpstream */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_output_1_is_older_than_input_2, relName(state, configFileName), relName(state, status.outOfDateOutputFileName), relName(state, status.newerProjectName));
            case 4 /* OutputMissing */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_output_file_1_does_not_exist, relName(state, configFileName), relName(state, status.missingOutputFileName));
            case 5 /* ErrorReadingFile */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_there_was_error_reading_file_1, relName(state, configFileName), relName(state, status.fileName));
            case 8 /* OutOfDateBuildInfo */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_some_of_the_changes_were_not_emitted, relName(state, configFileName), relName(state, status.buildInfoFile));
            case 9 /* OutOfDateOptions */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_buildinfo_file_1_indicates_there_is_change_in_compilerOptions, relName(state, configFileName), relName(state, status.buildInfoFile));
            case 10 /* OutOfDateRoots */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_file_2_was_root_file_of_compilation_but_not_any_more, relName(state, configFileName), relName(state, status.buildInfoFile), relName(state, status.inputFile));
            case 1 /* UpToDate */ :
                if (status.newestInputFileTime !== void 0) return reportStatus(state, Diagnostics.Project_0_is_up_to_date_because_newest_input_1_is_older_than_output_2, relName(state, configFileName), relName(state, status.newestInputFileName || ""), relName(state, status.oldestOutputFileName || ""));
                break;
            case 3 /* OutOfDateWithPrepend */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_output_of_its_dependency_1_has_changed, relName(state, configFileName), relName(state, status.newerProjectName));
            case 2 /* UpToDateWithUpstreamTypes */ :
                return reportStatus(state, Diagnostics.Project_0_is_up_to_date_with_d_ts_files_from_its_dependencies, relName(state, configFileName));
            case 15 /* UpToDateWithInputFileText */ :
                return reportStatus(state, Diagnostics.Project_0_is_up_to_date_but_needs_to_update_timestamps_of_output_files_that_are_older_than_input_files, relName(state, configFileName));
            case 11 /* UpstreamOutOfDate */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_its_dependency_1_is_out_of_date, relName(state, configFileName), relName(state, status.upstreamProjectName));
            case 12 /* UpstreamBlocked */ :
                return reportStatus(state, status.upstreamProjectBlocked ? Diagnostics.Project_0_can_t_be_built_because_its_dependency_1_was_not_built : Diagnostics.Project_0_can_t_be_built_because_its_dependency_1_has_errors, relName(state, configFileName), relName(state, status.upstreamProjectName));
            case 0 /* Unbuildable */ :
                return reportStatus(state, Diagnostics.Failed_to_parse_file_0_Colon_1, relName(state, configFileName), status.reason);
            case 14 /* TsVersionOutputOfDate */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_output_for_it_was_generated_with_version_1_that_differs_with_current_version_2, relName(state, configFileName), status.version, version);
            case 17 /* ForceBuild */ :
                return reportStatus(state, Diagnostics.Project_0_is_being_forcibly_rebuilt, relName(state, configFileName));
            case 16 /* ContainerOnly */ :
            case 13 /* ComputingUpstream */ :
                break;
            default:
                assertType(status);
        }
    }
    function verboseReportProjectStatus(state, configFileName, status) {
        if (state.options.verbose) reportUpToDateStatus(state, configFileName, status);
    }
    var minimumDate, maximumDate, InvalidatedProjectKind;
    var init_tsbuildPublic = __esm({
        "src/compiler/tsbuildPublic.ts" () {
            "use strict";
            init_ts2();
            init_ts_performance();
            minimumDate = /* @__PURE__ */ new Date(-8640000000000000);
            maximumDate = /* @__PURE__ */ new Date(864e13);
            InvalidatedProjectKind = /* @__PURE__ */ ((InvalidatedProjectKind2)=>{
                InvalidatedProjectKind2[InvalidatedProjectKind2["Build"] = 0] = "Build";
                InvalidatedProjectKind2[InvalidatedProjectKind2["UpdateBundle"] = 1] = "UpdateBundle";
                InvalidatedProjectKind2[InvalidatedProjectKind2["UpdateOutputFileStamps"] = 2] = "UpdateOutputFileStamps";
                return InvalidatedProjectKind2;
            })(InvalidatedProjectKind || {});
        }
    });
    // src/compiler/_namespaces/ts.ts
    var init_ts2 = __esm({
        "src/compiler/_namespaces/ts.ts" () {
            "use strict";
            init_corePublic();
            init_core();
            init_debug();
            init_semver();
            init_performanceCore();
            init_perfLogger();
            init_tracing();
            init_types();
            init_sys();
            init_path();
            init_diagnosticInformationMap_generated();
            init_scanner();
            init_utilitiesPublic();
            init_utilities();
            init_baseNodeFactory();
            init_parenthesizerRules();
            init_nodeConverters();
            init_nodeFactory();
            init_emitNode();
            init_emitHelpers();
            init_nodeTests();
            init_utilities2();
            init_utilitiesPublic2();
            init_parser();
            init_commandLineParser();
            init_moduleNameResolver();
            init_binder();
            init_symbolWalker();
            init_checker();
            init_visitorPublic();
            init_sourcemap();
            init_utilities3();
            init_destructuring();
            init_taggedTemplate();
            init_ts();
            init_classFields();
            init_typeSerializer();
            init_legacyDecorators();
            init_esDecorators();
            init_es2017();
            init_es2018();
            init_es2019();
            init_es2020();
            init_es2021();
            init_esnext();
            init_jsx();
            init_es2016();
            init_es2015();
            init_es5();
            init_generators();
            init_module();
            init_system();
            init_esnextAnd2015();
            init_node();
            init_diagnostics();
            init_declarations();
            init_transformer();
            init_emitter();
            init_watchUtilities();
            init_program();
            init_builderStatePublic();
            init_builderState();
            init_builder();
            init_builderPublic();
            init_resolutionCache();
            init_watch();
            init_watchPublic();
            init_tsbuild();
            init_tsbuildPublic();
            init_ts_moduleSpecifiers();
            init_ts_performance();
        }
    });
    // src/jsTyping/jsTyping.ts
    function isTypingUpToDate(cachedTyping, availableTypingVersions) {
        const availableVersion = new Version(getProperty(availableTypingVersions, `ts${versionMajorMinor}`) || getProperty(availableTypingVersions, "latest"));
        return availableVersion.compareTo(cachedTyping.version) <= 0;
    }
    function nonRelativeModuleNameForTypingCache(moduleName) {
        return nodeCoreModules.has(moduleName) ? "node" : moduleName;
    }
    function loadSafeList(host, safeListPath) {
        const result = readConfigFile(safeListPath, (path)=>host.readFile(path));
        return new Map(Object.entries(result.config));
    }
    function loadTypesMap(host, typesMapPath) {
        var _a;
        const result = readConfigFile(typesMapPath, (path)=>host.readFile(path));
        if ((_a = result.config) == null ? void 0 : _a.simpleMap) return new Map(Object.entries(result.config.simpleMap));
        return void 0;
    }
    function discoverTypings(host, log, fileNames, projectRootPath, safeList, packageNameToTypingLocation, typeAcquisition, unresolvedImports, typesRegistry, compilerOptions) {
        if (!typeAcquisition || !typeAcquisition.enable) return {
            cachedTypingPaths: [],
            newTypingNames: [],
            filesToWatch: []
        };
        const inferredTypings = /* @__PURE__ */ new Map();
        fileNames = mapDefined(fileNames, (fileName)=>{
            const path = normalizePath(fileName);
            if (hasJSFileExtension(path)) return path;
        });
        const filesToWatch = [];
        if (typeAcquisition.include) addInferredTypings(typeAcquisition.include, "Explicitly included types");
        const exclude = typeAcquisition.exclude || [];
        if (!compilerOptions.types) {
            const possibleSearchDirs = new Set(fileNames.map(getDirectoryPath));
            possibleSearchDirs.add(projectRootPath);
            possibleSearchDirs.forEach((searchDir)=>{
                getTypingNames(searchDir, "bower.json", "bower_components", filesToWatch);
                getTypingNames(searchDir, "package.json", "node_modules", filesToWatch);
            });
        }
        if (!typeAcquisition.disableFilenameBasedTypeAcquisition) getTypingNamesFromSourceFileNames(fileNames);
        if (unresolvedImports) {
            const module2 = deduplicate(unresolvedImports.map(nonRelativeModuleNameForTypingCache), equateStringsCaseSensitive, compareStringsCaseSensitive);
            addInferredTypings(module2, "Inferred typings from unresolved imports");
        }
        packageNameToTypingLocation.forEach((typing, name)=>{
            const registryEntry = typesRegistry.get(name);
            if (inferredTypings.has(name) && inferredTypings.get(name) === void 0 && registryEntry !== void 0 && isTypingUpToDate(typing, registryEntry)) inferredTypings.set(name, typing.typingLocation);
        });
        for (const excludeTypingName of exclude){
            const didDelete = inferredTypings.delete(excludeTypingName);
            if (didDelete && log) log(`Typing for ${excludeTypingName} is in exclude list, will be ignored.`);
        }
        const newTypingNames = [];
        const cachedTypingPaths = [];
        inferredTypings.forEach((inferred, typing)=>{
            if (inferred !== void 0) cachedTypingPaths.push(inferred);
            else newTypingNames.push(typing);
        });
        const result = {
            cachedTypingPaths: cachedTypingPaths,
            newTypingNames: newTypingNames,
            filesToWatch: filesToWatch
        };
        if (log) log(`Result: ${JSON.stringify(result)}`);
        return result;
        function addInferredTyping(typingName) {
            if (!inferredTypings.has(typingName)) inferredTypings.set(typingName, void 0);
        }
        function addInferredTypings(typingNames, message) {
            if (log) log(`${message}: ${JSON.stringify(typingNames)}`);
            forEach(typingNames, addInferredTyping);
        }
        function getTypingNames(projectRootPath2, manifestName, modulesDirName, filesToWatch2) {
            const manifestPath = combinePaths(projectRootPath2, manifestName);
            let manifest;
            let manifestTypingNames;
            if (host.fileExists(manifestPath)) {
                filesToWatch2.push(manifestPath);
                manifest = readConfigFile(manifestPath, (path)=>host.readFile(path)).config;
                manifestTypingNames = flatMap([
                    manifest.dependencies,
                    manifest.devDependencies,
                    manifest.optionalDependencies,
                    manifest.peerDependencies
                ], getOwnKeys);
                addInferredTypings(manifestTypingNames, `Typing names in '${manifestPath}' dependencies`);
            }
            const packagesFolderPath = combinePaths(projectRootPath2, modulesDirName);
            filesToWatch2.push(packagesFolderPath);
            if (!host.directoryExists(packagesFolderPath)) return;
            const packageNames = [];
            const dependencyManifestNames = manifestTypingNames ? manifestTypingNames.map((typingName)=>combinePaths(packagesFolderPath, typingName, manifestName)) : host.readDirectory(packagesFolderPath, [
                ".json" /* Json */ 
            ], /*excludes*/ void 0, /*includes*/ void 0, /*depth*/ 3).filter((manifestPath2)=>{
                if (getBaseFileName(manifestPath2) !== manifestName) return false;
                const pathComponents2 = getPathComponents(normalizePath(manifestPath2));
                const isScoped = pathComponents2[pathComponents2.length - 3][0] === "@";
                return isScoped && toFileNameLowerCase(pathComponents2[pathComponents2.length - 4]) === modulesDirName || // `node_modules/@foo/bar`
                !isScoped && toFileNameLowerCase(pathComponents2[pathComponents2.length - 3]) === modulesDirName;
            });
            if (log) log(`Searching for typing names in ${packagesFolderPath}; all files: ${JSON.stringify(dependencyManifestNames)}`);
            for (const manifestPath2 of dependencyManifestNames){
                const normalizedFileName = normalizePath(manifestPath2);
                const result2 = readConfigFile(normalizedFileName, (path)=>host.readFile(path));
                const manifest2 = result2.config;
                if (!manifest2.name) continue;
                const ownTypes = manifest2.types || manifest2.typings;
                if (ownTypes) {
                    const absolutePath = getNormalizedAbsolutePath(ownTypes, getDirectoryPath(normalizedFileName));
                    if (host.fileExists(absolutePath)) {
                        if (log) log(`    Package '${manifest2.name}' provides its own types.`);
                        inferredTypings.set(manifest2.name, absolutePath);
                    } else if (log) log(`    Package '${manifest2.name}' provides its own types but they are missing.`);
                } else packageNames.push(manifest2.name);
            }
            addInferredTypings(packageNames, "    Found package names");
        }
        function getTypingNamesFromSourceFileNames(fileNames2) {
            const fromFileNames = mapDefined(fileNames2, (j)=>{
                if (!hasJSFileExtension(j)) return void 0;
                const inferredTypingName = removeFileExtension(toFileNameLowerCase(getBaseFileName(j)));
                const cleanedTypingName = removeMinAndVersionNumbers(inferredTypingName);
                return safeList.get(cleanedTypingName);
            });
            if (fromFileNames.length) addInferredTypings(fromFileNames, "Inferred typings from file names");
            const hasJsxFile = some(fileNames2, (f)=>fileExtensionIs(f, ".jsx" /* Jsx */ ));
            if (hasJsxFile) {
                if (log) log(`Inferred 'react' typings due to presence of '.jsx' extension`);
                addInferredTyping("react");
            }
        }
    }
    function validatePackageName(packageName) {
        return validatePackageNameWorker(packageName, /*supportScopedPackage*/ true);
    }
    function validatePackageNameWorker(packageName, supportScopedPackage) {
        if (!packageName) return 1 /* EmptyName */ ;
        if (packageName.length > maxPackageNameLength) return 2 /* NameTooLong */ ;
        if (packageName.charCodeAt(0) === 46 /* dot */ ) return 3 /* NameStartsWithDot */ ;
        if (packageName.charCodeAt(0) === 95 /* _ */ ) return 4 /* NameStartsWithUnderscore */ ;
        if (supportScopedPackage) {
            const matches = /^@([^/]+)\/([^/]+)$/.exec(packageName);
            if (matches) {
                const scopeResult = validatePackageNameWorker(matches[1], /*supportScopedPackage*/ false);
                if (scopeResult !== 0 /* Ok */ ) return {
                    name: matches[1],
                    isScopeName: true,
                    result: scopeResult
                };
                const packageResult = validatePackageNameWorker(matches[2], /*supportScopedPackage*/ false);
                if (packageResult !== 0 /* Ok */ ) return {
                    name: matches[2],
                    isScopeName: false,
                    result: packageResult
                };
                return 0 /* Ok */ ;
            }
        }
        if (encodeURIComponent(packageName) !== packageName) return 5 /* NameContainsNonURISafeCharacters */ ;
        return 0 /* Ok */ ;
    }
    function renderPackageNameValidationFailure(result, typing) {
        return typeof result === "object" ? renderPackageNameValidationFailureWorker(typing, result.result, result.name, result.isScopeName) : renderPackageNameValidationFailureWorker(typing, result, typing, /*isScopeName*/ false);
    }
    function renderPackageNameValidationFailureWorker(typing, result, name, isScopeName) {
        const kind = isScopeName ? "Scope" : "Package";
        switch(result){
            case 1 /* EmptyName */ :
                return `'${typing}':: ${kind} name '${name}' cannot be empty`;
            case 2 /* NameTooLong */ :
                return `'${typing}':: ${kind} name '${name}' should be less than ${maxPackageNameLength} characters`;
            case 3 /* NameStartsWithDot */ :
                return `'${typing}':: ${kind} name '${name}' cannot start with '.'`;
            case 4 /* NameStartsWithUnderscore */ :
                return `'${typing}':: ${kind} name '${name}' cannot start with '_'`;
            case 5 /* NameContainsNonURISafeCharacters */ :
                return `'${typing}':: ${kind} name '${name}' contains non URI safe characters`;
            case 0 /* Ok */ :
                return Debug.fail();
            default:
                Debug.assertNever(result);
        }
    }
    var unprefixedNodeCoreModuleList, prefixedNodeCoreModuleList, nodeCoreModuleList, nodeCoreModules, NameValidationResult, maxPackageNameLength;
    var init_jsTyping = __esm({
        "src/jsTyping/jsTyping.ts" () {
            "use strict";
            init_ts3();
            unprefixedNodeCoreModuleList = [
                "assert",
                "assert/strict",
                "async_hooks",
                "buffer",
                "child_process",
                "cluster",
                "console",
                "constants",
                "crypto",
                "dgram",
                "diagnostics_channel",
                "dns",
                "dns/promises",
                "domain",
                "events",
                "fs",
                "fs/promises",
                "http",
                "https",
                "http2",
                "inspector",
                "module",
                "net",
                "os",
                "path",
                "perf_hooks",
                "process",
                "punycode",
                "querystring",
                "readline",
                "repl",
                "stream",
                "stream/promises",
                "string_decoder",
                "timers",
                "timers/promises",
                "tls",
                "trace_events",
                "tty",
                "url",
                "util",
                "util/types",
                "v8",
                "vm",
                "wasi",
                "worker_threads",
                "zlib"
            ];
            prefixedNodeCoreModuleList = unprefixedNodeCoreModuleList.map((name)=>`node:${name}`);
            nodeCoreModuleList = [
                ...unprefixedNodeCoreModuleList,
                ...prefixedNodeCoreModuleList
            ];
            nodeCoreModules = new Set(nodeCoreModuleList);
            NameValidationResult = /* @__PURE__ */ ((NameValidationResult2)=>{
                NameValidationResult2[NameValidationResult2["Ok"] = 0] = "Ok";
                NameValidationResult2[NameValidationResult2["EmptyName"] = 1] = "EmptyName";
                NameValidationResult2[NameValidationResult2["NameTooLong"] = 2] = "NameTooLong";
                NameValidationResult2[NameValidationResult2["NameStartsWithDot"] = 3] = "NameStartsWithDot";
                NameValidationResult2[NameValidationResult2["NameStartsWithUnderscore"] = 4] = "NameStartsWithUnderscore";
                NameValidationResult2[NameValidationResult2["NameContainsNonURISafeCharacters"] = 5] = "NameContainsNonURISafeCharacters";
                return NameValidationResult2;
            })(NameValidationResult || {});
            maxPackageNameLength = 214;
        }
    });
    // src/jsTyping/_namespaces/ts.JsTyping.ts
    var ts_JsTyping_exports = {};
    __export(ts_JsTyping_exports, {
        NameValidationResult: ()=>NameValidationResult,
        discoverTypings: ()=>discoverTypings,
        isTypingUpToDate: ()=>isTypingUpToDate,
        loadSafeList: ()=>loadSafeList,
        loadTypesMap: ()=>loadTypesMap,
        nodeCoreModuleList: ()=>nodeCoreModuleList,
        nodeCoreModules: ()=>nodeCoreModules,
        nonRelativeModuleNameForTypingCache: ()=>nonRelativeModuleNameForTypingCache,
        prefixedNodeCoreModuleList: ()=>prefixedNodeCoreModuleList,
        renderPackageNameValidationFailure: ()=>renderPackageNameValidationFailure,
        validatePackageName: ()=>validatePackageName
    });
    var init_ts_JsTyping = __esm({
        "src/jsTyping/_namespaces/ts.JsTyping.ts" () {
            "use strict";
            init_jsTyping();
        }
    });
    // src/jsTyping/shared.ts
    function hasArgument(argumentName) {
        return sys.args.indexOf(argumentName) >= 0;
    }
    function findArgument(argumentName) {
        const index = sys.args.indexOf(argumentName);
        return index >= 0 && index < sys.args.length - 1 ? sys.args[index + 1] : void 0;
    }
    function nowString() {
        const d = /* @__PURE__ */ new Date();
        return `${padLeft(d.getHours().toString(), 2, "0")}:${padLeft(d.getMinutes().toString(), 2, "0")}:${padLeft(d.getSeconds().toString(), 2, "0")}.${padLeft(d.getMilliseconds().toString(), 3, "0")}`;
    }
    var ActionSet, ActionInvalidate, ActionPackageInstalled, EventTypesRegistry, EventBeginInstallTypes, EventEndInstallTypes, EventInitializationFailed, ActionWatchTypingLocations, Arguments;
    var init_shared = __esm({
        "src/jsTyping/shared.ts" () {
            "use strict";
            init_ts3();
            ActionSet = "action::set";
            ActionInvalidate = "action::invalidate";
            ActionPackageInstalled = "action::packageInstalled";
            EventTypesRegistry = "event::typesRegistry";
            EventBeginInstallTypes = "event::beginInstallTypes";
            EventEndInstallTypes = "event::endInstallTypes";
            EventInitializationFailed = "event::initializationFailed";
            ActionWatchTypingLocations = "action::watchTypingLocations";
            ((Arguments2)=>{
                Arguments2.GlobalCacheLocation = "--globalTypingsCacheLocation";
                Arguments2.LogFile = "--logFile";
                Arguments2.EnableTelemetry = "--enableTelemetry";
                Arguments2.TypingSafeListLocation = "--typingSafeListLocation";
                Arguments2.TypesMapLocation = "--typesMapLocation";
                Arguments2.NpmLocation = "--npmLocation";
                Arguments2.ValidateDefaultNpmLocation = "--validateDefaultNpmLocation";
            })(Arguments || (Arguments = {}));
        }
    });
    // src/jsTyping/types.ts
    var init_types2 = __esm({
        "src/jsTyping/types.ts" () {
            "use strict";
        }
    });
    // src/jsTyping/_namespaces/ts.server.ts
    var ts_server_exports = {};
    __export(ts_server_exports, {
        ActionInvalidate: ()=>ActionInvalidate,
        ActionPackageInstalled: ()=>ActionPackageInstalled,
        ActionSet: ()=>ActionSet,
        ActionWatchTypingLocations: ()=>ActionWatchTypingLocations,
        Arguments: ()=>Arguments,
        EventBeginInstallTypes: ()=>EventBeginInstallTypes,
        EventEndInstallTypes: ()=>EventEndInstallTypes,
        EventInitializationFailed: ()=>EventInitializationFailed,
        EventTypesRegistry: ()=>EventTypesRegistry,
        findArgument: ()=>findArgument,
        hasArgument: ()=>hasArgument,
        nowString: ()=>nowString
    });
    var init_ts_server = __esm({
        "src/jsTyping/_namespaces/ts.server.ts" () {
            "use strict";
            init_shared();
            init_types2();
        }
    });
    // src/jsTyping/_namespaces/ts.ts
    var init_ts3 = __esm({
        "src/jsTyping/_namespaces/ts.ts" () {
            "use strict";
            init_ts2();
            init_ts_JsTyping();
            init_ts_server();
        }
    });
    // src/services/types.ts
    function getDefaultFormatCodeSettings(newLineCharacter) {
        return {
            indentSize: 4,
            tabSize: 4,
            newLineCharacter: newLineCharacter || "\n",
            convertTabsToSpaces: true,
            indentStyle: 2 /* Smart */ ,
            insertSpaceAfterConstructor: false,
            insertSpaceAfterCommaDelimiter: true,
            insertSpaceAfterSemicolonInForStatements: true,
            insertSpaceBeforeAndAfterBinaryOperators: true,
            insertSpaceAfterKeywordsInControlFlowStatements: true,
            insertSpaceAfterFunctionKeywordForAnonymousFunctions: false,
            insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis: false,
            insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets: false,
            insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces: true,
            insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces: false,
            insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces: false,
            insertSpaceBeforeFunctionParenthesis: false,
            placeOpenBraceOnNewLineForFunctions: false,
            placeOpenBraceOnNewLineForControlBlocks: false,
            semicolons: "ignore" /* Ignore */ ,
            trimTrailingWhitespace: true,
            indentSwitchCase: true
        };
    }
    var ScriptSnapshot, PackageJsonDependencyGroup, PackageJsonAutoImportPreference, LanguageServiceMode, emptyOptions, SemanticClassificationFormat, OrganizeImportsMode, CompletionTriggerKind, InlayHintKind, HighlightSpanKind, IndentStyle, SemicolonPreference, testFormatSettings, SymbolDisplayPartKind, CompletionInfoFlags, OutliningSpanKind, OutputFileType, EndOfLineState, TokenClass, ScriptElementKind, ScriptElementKindModifier, ClassificationTypeNames, ClassificationType;
    var init_types3 = __esm({
        "src/services/types.ts" () {
            "use strict";
            ((ScriptSnapshot2)=>{
                class StringScriptSnapshot {
                    constructor(text){
                        this.text = text;
                    }
                    getText(start, end) {
                        return start === 0 && end === this.text.length ? this.text : this.text.substring(start, end);
                    }
                    getLength() {
                        return this.text.length;
                    }
                    getChangeRange() {
                        return void 0;
                    }
                }
                function fromString(text) {
                    return new StringScriptSnapshot(text);
                }
                ScriptSnapshot2.fromString = fromString;
            })(ScriptSnapshot || (ScriptSnapshot = {}));
            PackageJsonDependencyGroup = /* @__PURE__ */ ((PackageJsonDependencyGroup2)=>{
                PackageJsonDependencyGroup2[PackageJsonDependencyGroup2["Dependencies"] = 1] = "Dependencies";
                PackageJsonDependencyGroup2[PackageJsonDependencyGroup2["DevDependencies"] = 2] = "DevDependencies";
                PackageJsonDependencyGroup2[PackageJsonDependencyGroup2["PeerDependencies"] = 4] = "PeerDependencies";
                PackageJsonDependencyGroup2[PackageJsonDependencyGroup2["OptionalDependencies"] = 8] = "OptionalDependencies";
                PackageJsonDependencyGroup2[PackageJsonDependencyGroup2["All"] = 15] = "All";
                return PackageJsonDependencyGroup2;
            })(PackageJsonDependencyGroup || {});
            PackageJsonAutoImportPreference = /* @__PURE__ */ ((PackageJsonAutoImportPreference2)=>{
                PackageJsonAutoImportPreference2[PackageJsonAutoImportPreference2["Off"] = 0] = "Off";
                PackageJsonAutoImportPreference2[PackageJsonAutoImportPreference2["On"] = 1] = "On";
                PackageJsonAutoImportPreference2[PackageJsonAutoImportPreference2["Auto"] = 2] = "Auto";
                return PackageJsonAutoImportPreference2;
            })(PackageJsonAutoImportPreference || {});
            LanguageServiceMode = /* @__PURE__ */ ((LanguageServiceMode2)=>{
                LanguageServiceMode2[LanguageServiceMode2["Semantic"] = 0] = "Semantic";
                LanguageServiceMode2[LanguageServiceMode2["PartialSemantic"] = 1] = "PartialSemantic";
                LanguageServiceMode2[LanguageServiceMode2["Syntactic"] = 2] = "Syntactic";
                return LanguageServiceMode2;
            })(LanguageServiceMode || {});
            emptyOptions = {};
            SemanticClassificationFormat = /* @__PURE__ */ ((SemanticClassificationFormat3)=>{
                SemanticClassificationFormat3["Original"] = "original";
                SemanticClassificationFormat3["TwentyTwenty"] = "2020";
                return SemanticClassificationFormat3;
            })(SemanticClassificationFormat || {});
            OrganizeImportsMode = /* @__PURE__ */ ((OrganizeImportsMode2)=>{
                OrganizeImportsMode2["All"] = "All";
                OrganizeImportsMode2["SortAndCombine"] = "SortAndCombine";
                OrganizeImportsMode2["RemoveUnused"] = "RemoveUnused";
                return OrganizeImportsMode2;
            })(OrganizeImportsMode || {});
            CompletionTriggerKind = /* @__PURE__ */ ((CompletionTriggerKind2)=>{
                CompletionTriggerKind2[CompletionTriggerKind2["Invoked"] = 1] = "Invoked";
                CompletionTriggerKind2[CompletionTriggerKind2["TriggerCharacter"] = 2] = "TriggerCharacter";
                CompletionTriggerKind2[CompletionTriggerKind2["TriggerForIncompleteCompletions"] = 3] = "TriggerForIncompleteCompletions";
                return CompletionTriggerKind2;
            })(CompletionTriggerKind || {});
            InlayHintKind = /* @__PURE__ */ ((InlayHintKind2)=>{
                InlayHintKind2["Type"] = "Type";
                InlayHintKind2["Parameter"] = "Parameter";
                InlayHintKind2["Enum"] = "Enum";
                return InlayHintKind2;
            })(InlayHintKind || {});
            HighlightSpanKind = /* @__PURE__ */ ((HighlightSpanKind2)=>{
                HighlightSpanKind2["none"] = "none";
                HighlightSpanKind2["definition"] = "definition";
                HighlightSpanKind2["reference"] = "reference";
                HighlightSpanKind2["writtenReference"] = "writtenReference";
                return HighlightSpanKind2;
            })(HighlightSpanKind || {});
            IndentStyle = /* @__PURE__ */ ((IndentStyle2)=>{
                IndentStyle2[IndentStyle2["None"] = 0] = "None";
                IndentStyle2[IndentStyle2["Block"] = 1] = "Block";
                IndentStyle2[IndentStyle2["Smart"] = 2] = "Smart";
                return IndentStyle2;
            })(IndentStyle || {});
            SemicolonPreference = /* @__PURE__ */ ((SemicolonPreference2)=>{
                SemicolonPreference2["Ignore"] = "ignore";
                SemicolonPreference2["Insert"] = "insert";
                SemicolonPreference2["Remove"] = "remove";
                return SemicolonPreference2;
            })(SemicolonPreference || {});
            testFormatSettings = getDefaultFormatCodeSettings("\n");
            SymbolDisplayPartKind = /* @__PURE__ */ ((SymbolDisplayPartKind2)=>{
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["aliasName"] = 0] = "aliasName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["className"] = 1] = "className";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["enumName"] = 2] = "enumName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["fieldName"] = 3] = "fieldName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["interfaceName"] = 4] = "interfaceName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["keyword"] = 5] = "keyword";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["lineBreak"] = 6] = "lineBreak";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["numericLiteral"] = 7] = "numericLiteral";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["stringLiteral"] = 8] = "stringLiteral";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["localName"] = 9] = "localName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["methodName"] = 10] = "methodName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["moduleName"] = 11] = "moduleName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["operator"] = 12] = "operator";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["parameterName"] = 13] = "parameterName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["propertyName"] = 14] = "propertyName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["punctuation"] = 15] = "punctuation";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["space"] = 16] = "space";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["text"] = 17] = "text";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["typeParameterName"] = 18] = "typeParameterName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["enumMemberName"] = 19] = "enumMemberName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["functionName"] = 20] = "functionName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["regularExpressionLiteral"] = 21] = "regularExpressionLiteral";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["link"] = 22] = "link";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["linkName"] = 23] = "linkName";
                SymbolDisplayPartKind2[SymbolDisplayPartKind2["linkText"] = 24] = "linkText";
                return SymbolDisplayPartKind2;
            })(SymbolDisplayPartKind || {});
            CompletionInfoFlags = /* @__PURE__ */ ((CompletionInfoFlags2)=>{
                CompletionInfoFlags2[CompletionInfoFlags2["None"] = 0] = "None";
                CompletionInfoFlags2[CompletionInfoFlags2["MayIncludeAutoImports"] = 1] = "MayIncludeAutoImports";
                CompletionInfoFlags2[CompletionInfoFlags2["IsImportStatementCompletion"] = 2] = "IsImportStatementCompletion";
                CompletionInfoFlags2[CompletionInfoFlags2["IsContinuation"] = 4] = "IsContinuation";
                CompletionInfoFlags2[CompletionInfoFlags2["ResolvedModuleSpecifiers"] = 8] = "ResolvedModuleSpecifiers";
                CompletionInfoFlags2[CompletionInfoFlags2["ResolvedModuleSpecifiersBeyondLimit"] = 16] = "ResolvedModuleSpecifiersBeyondLimit";
                CompletionInfoFlags2[CompletionInfoFlags2["MayIncludeMethodSnippets"] = 32] = "MayIncludeMethodSnippets";
                return CompletionInfoFlags2;
            })(CompletionInfoFlags || {});
            OutliningSpanKind = /* @__PURE__ */ ((OutliningSpanKind2)=>{
                OutliningSpanKind2["Comment"] = "comment";
                OutliningSpanKind2["Region"] = "region";
                OutliningSpanKind2["Code"] = "code";
                OutliningSpanKind2["Imports"] = "imports";
                return OutliningSpanKind2;
            })(OutliningSpanKind || {});
            OutputFileType = /* @__PURE__ */ ((OutputFileType2)=>{
                OutputFileType2[OutputFileType2["JavaScript"] = 0] = "JavaScript";
                OutputFileType2[OutputFileType2["SourceMap"] = 1] = "SourceMap";
                OutputFileType2[OutputFileType2["Declaration"] = 2] = "Declaration";
                return OutputFileType2;
            })(OutputFileType || {});
            EndOfLineState = /* @__PURE__ */ ((EndOfLineState3)=>{
                EndOfLineState3[EndOfLineState3["None"] = 0] = "None";
                EndOfLineState3[EndOfLineState3["InMultiLineCommentTrivia"] = 1] = "InMultiLineCommentTrivia";
                EndOfLineState3[EndOfLineState3["InSingleQuoteStringLiteral"] = 2] = "InSingleQuoteStringLiteral";
                EndOfLineState3[EndOfLineState3["InDoubleQuoteStringLiteral"] = 3] = "InDoubleQuoteStringLiteral";
                EndOfLineState3[EndOfLineState3["InTemplateHeadOrNoSubstitutionTemplate"] = 4] = "InTemplateHeadOrNoSubstitutionTemplate";
                EndOfLineState3[EndOfLineState3["InTemplateMiddleOrTail"] = 5] = "InTemplateMiddleOrTail";
                EndOfLineState3[EndOfLineState3["InTemplateSubstitutionPosition"] = 6] = "InTemplateSubstitutionPosition";
                return EndOfLineState3;
            })(EndOfLineState || {});
            TokenClass = /* @__PURE__ */ ((TokenClass2)=>{
                TokenClass2[TokenClass2["Punctuation"] = 0] = "Punctuation";
                TokenClass2[TokenClass2["Keyword"] = 1] = "Keyword";
                TokenClass2[TokenClass2["Operator"] = 2] = "Operator";
                TokenClass2[TokenClass2["Comment"] = 3] = "Comment";
                TokenClass2[TokenClass2["Whitespace"] = 4] = "Whitespace";
                TokenClass2[TokenClass2["Identifier"] = 5] = "Identifier";
                TokenClass2[TokenClass2["NumberLiteral"] = 6] = "NumberLiteral";
                TokenClass2[TokenClass2["BigIntLiteral"] = 7] = "BigIntLiteral";
                TokenClass2[TokenClass2["StringLiteral"] = 8] = "StringLiteral";
                TokenClass2[TokenClass2["RegExpLiteral"] = 9] = "RegExpLiteral";
                return TokenClass2;
            })(TokenClass || {});
            ScriptElementKind = /* @__PURE__ */ ((ScriptElementKind2)=>{
                ScriptElementKind2["unknown"] = "";
                ScriptElementKind2["warning"] = "warning";
                ScriptElementKind2["keyword"] = "keyword";
                ScriptElementKind2["scriptElement"] = "script";
                ScriptElementKind2["moduleElement"] = "module";
                ScriptElementKind2["classElement"] = "class";
                ScriptElementKind2["localClassElement"] = "local class";
                ScriptElementKind2["interfaceElement"] = "interface";
                ScriptElementKind2["typeElement"] = "type";
                ScriptElementKind2["enumElement"] = "enum";
                ScriptElementKind2["enumMemberElement"] = "enum member";
                ScriptElementKind2["variableElement"] = "var";
                ScriptElementKind2["localVariableElement"] = "local var";
                ScriptElementKind2["functionElement"] = "function";
                ScriptElementKind2["localFunctionElement"] = "local function";
                ScriptElementKind2["memberFunctionElement"] = "method";
                ScriptElementKind2["memberGetAccessorElement"] = "getter";
                ScriptElementKind2["memberSetAccessorElement"] = "setter";
                ScriptElementKind2["memberVariableElement"] = "property";
                ScriptElementKind2["memberAccessorVariableElement"] = "accessor";
                ScriptElementKind2["constructorImplementationElement"] = "constructor";
                ScriptElementKind2["callSignatureElement"] = "call";
                ScriptElementKind2["indexSignatureElement"] = "index";
                ScriptElementKind2["constructSignatureElement"] = "construct";
                ScriptElementKind2["parameterElement"] = "parameter";
                ScriptElementKind2["typeParameterElement"] = "type parameter";
                ScriptElementKind2["primitiveType"] = "primitive type";
                ScriptElementKind2["label"] = "label";
                ScriptElementKind2["alias"] = "alias";
                ScriptElementKind2["constElement"] = "const";
                ScriptElementKind2["letElement"] = "let";
                ScriptElementKind2["directory"] = "directory";
                ScriptElementKind2["externalModuleName"] = "external module name";
                ScriptElementKind2["jsxAttribute"] = "JSX attribute";
                ScriptElementKind2["string"] = "string";
                ScriptElementKind2["link"] = "link";
                ScriptElementKind2["linkName"] = "link name";
                ScriptElementKind2["linkText"] = "link text";
                return ScriptElementKind2;
            })(ScriptElementKind || {});
            ScriptElementKindModifier = /* @__PURE__ */ ((ScriptElementKindModifier2)=>{
                ScriptElementKindModifier2["none"] = "";
                ScriptElementKindModifier2["publicMemberModifier"] = "public";
                ScriptElementKindModifier2["privateMemberModifier"] = "private";
                ScriptElementKindModifier2["protectedMemberModifier"] = "protected";
                ScriptElementKindModifier2["exportedModifier"] = "export";
                ScriptElementKindModifier2["ambientModifier"] = "declare";
                ScriptElementKindModifier2["staticModifier"] = "static";
                ScriptElementKindModifier2["abstractModifier"] = "abstract";
                ScriptElementKindModifier2["optionalModifier"] = "optional";
                ScriptElementKindModifier2["deprecatedModifier"] = "deprecated";
                ScriptElementKindModifier2["dtsModifier"] = ".d.ts";
                ScriptElementKindModifier2["tsModifier"] = ".ts";
                ScriptElementKindModifier2["tsxModifier"] = ".tsx";
                ScriptElementKindModifier2["jsModifier"] = ".js";
                ScriptElementKindModifier2["jsxModifier"] = ".jsx";
                ScriptElementKindModifier2["jsonModifier"] = ".json";
                ScriptElementKindModifier2["dmtsModifier"] = ".d.mts";
                ScriptElementKindModifier2["mtsModifier"] = ".mts";
                ScriptElementKindModifier2["mjsModifier"] = ".mjs";
                ScriptElementKindModifier2["dctsModifier"] = ".d.cts";
                ScriptElementKindModifier2["ctsModifier"] = ".cts";
                ScriptElementKindModifier2["cjsModifier"] = ".cjs";
                return ScriptElementKindModifier2;
            })(ScriptElementKindModifier || {});
            ClassificationTypeNames = /* @__PURE__ */ ((ClassificationTypeNames2)=>{
                ClassificationTypeNames2["comment"] = "comment";
                ClassificationTypeNames2["identifier"] = "identifier";
                ClassificationTypeNames2["keyword"] = "keyword";
                ClassificationTypeNames2["numericLiteral"] = "number";
                ClassificationTypeNames2["bigintLiteral"] = "bigint";
                ClassificationTypeNames2["operator"] = "operator";
                ClassificationTypeNames2["stringLiteral"] = "string";
                ClassificationTypeNames2["whiteSpace"] = "whitespace";
                ClassificationTypeNames2["text"] = "text";
                ClassificationTypeNames2["punctuation"] = "punctuation";
                ClassificationTypeNames2["className"] = "class name";
                ClassificationTypeNames2["enumName"] = "enum name";
                ClassificationTypeNames2["interfaceName"] = "interface name";
                ClassificationTypeNames2["moduleName"] = "module name";
                ClassificationTypeNames2["typeParameterName"] = "type parameter name";
                ClassificationTypeNames2["typeAliasName"] = "type alias name";
                ClassificationTypeNames2["parameterName"] = "parameter name";
                ClassificationTypeNames2["docCommentTagName"] = "doc comment tag name";
                ClassificationTypeNames2["jsxOpenTagName"] = "jsx open tag name";
                ClassificationTypeNames2["jsxCloseTagName"] = "jsx close tag name";
                ClassificationTypeNames2["jsxSelfClosingTagName"] = "jsx self closing tag name";
                ClassificationTypeNames2["jsxAttribute"] = "jsx attribute";
                ClassificationTypeNames2["jsxText"] = "jsx text";
                ClassificationTypeNames2["jsxAttributeStringLiteralValue"] = "jsx attribute string literal value";
                return ClassificationTypeNames2;
            })(ClassificationTypeNames || {});
            ClassificationType = /* @__PURE__ */ ((ClassificationType2)=>{
                ClassificationType2[ClassificationType2["comment"] = 1] = "comment";
                ClassificationType2[ClassificationType2["identifier"] = 2] = "identifier";
                ClassificationType2[ClassificationType2["keyword"] = 3] = "keyword";
                ClassificationType2[ClassificationType2["numericLiteral"] = 4] = "numericLiteral";
                ClassificationType2[ClassificationType2["operator"] = 5] = "operator";
                ClassificationType2[ClassificationType2["stringLiteral"] = 6] = "stringLiteral";
                ClassificationType2[ClassificationType2["regularExpressionLiteral"] = 7] = "regularExpressionLiteral";
                ClassificationType2[ClassificationType2["whiteSpace"] = 8] = "whiteSpace";
                ClassificationType2[ClassificationType2["text"] = 9] = "text";
                ClassificationType2[ClassificationType2["punctuation"] = 10] = "punctuation";
                ClassificationType2[ClassificationType2["className"] = 11] = "className";
                ClassificationType2[ClassificationType2["enumName"] = 12] = "enumName";
                ClassificationType2[ClassificationType2["interfaceName"] = 13] = "interfaceName";
                ClassificationType2[ClassificationType2["moduleName"] = 14] = "moduleName";
                ClassificationType2[ClassificationType2["typeParameterName"] = 15] = "typeParameterName";
                ClassificationType2[ClassificationType2["typeAliasName"] = 16] = "typeAliasName";
                ClassificationType2[ClassificationType2["parameterName"] = 17] = "parameterName";
                ClassificationType2[ClassificationType2["docCommentTagName"] = 18] = "docCommentTagName";
                ClassificationType2[ClassificationType2["jsxOpenTagName"] = 19] = "jsxOpenTagName";
                ClassificationType2[ClassificationType2["jsxCloseTagName"] = 20] = "jsxCloseTagName";
                ClassificationType2[ClassificationType2["jsxSelfClosingTagName"] = 21] = "jsxSelfClosingTagName";
                ClassificationType2[ClassificationType2["jsxAttribute"] = 22] = "jsxAttribute";
                ClassificationType2[ClassificationType2["jsxText"] = 23] = "jsxText";
                ClassificationType2[ClassificationType2["jsxAttributeStringLiteralValue"] = 24] = "jsxAttributeStringLiteralValue";
                ClassificationType2[ClassificationType2["bigintLiteral"] = 25] = "bigintLiteral";
                return ClassificationType2;
            })(ClassificationType || {});
        }
    });
    // src/services/utilities.ts
    function getMeaningFromDeclaration(node) {
        switch(node.kind){
            case 259 /* VariableDeclaration */ :
                return isInJSFile(node) && getJSDocEnumTag(node) ? 7 /* All */  : 1 /* Value */ ;
            case 168 /* Parameter */ :
            case 207 /* BindingElement */ :
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
            case 302 /* PropertyAssignment */ :
            case 303 /* ShorthandPropertyAssignment */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 175 /* Constructor */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
            case 298 /* CatchClause */ :
            case 290 /* JsxAttribute */ :
                return 1 /* Value */ ;
            case 167 /* TypeParameter */ :
            case 263 /* InterfaceDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
            case 186 /* TypeLiteral */ :
                return 2 /* Type */ ;
            case 352 /* JSDocTypedefTag */ :
                return node.name === void 0 ? 3 /* Type */  : 2 /* Type */ ;
            case 305 /* EnumMember */ :
            case 262 /* ClassDeclaration */ :
                return 3 /* Type */ ;
            case 266 /* ModuleDeclaration */ :
                if (isAmbientModule(node)) return 5 /* Value */ ;
                else if (getModuleInstanceState(node) === 1 /* Instantiated */ ) return 5 /* Value */ ;
                else return 4 /* Namespace */ ;
            case 265 /* EnumDeclaration */ :
            case 274 /* NamedImports */ :
            case 275 /* ImportSpecifier */ :
            case 270 /* ImportEqualsDeclaration */ :
            case 271 /* ImportDeclaration */ :
            case 276 /* ExportAssignment */ :
            case 277 /* ExportDeclaration */ :
                return 7 /* All */ ;
            case 311 /* SourceFile */ :
                return 5 /* Value */ ;
        }
        return 7 /* All */ ;
    }
    function getMeaningFromLocation(node) {
        node = getAdjustedReferenceLocation(node);
        const parent2 = node.parent;
        if (node.kind === 311 /* SourceFile */ ) return 1 /* Value */ ;
        else if (isExportAssignment(parent2) || isExportSpecifier(parent2) || isExternalModuleReference(parent2) || isImportSpecifier(parent2) || isImportClause(parent2) || isImportEqualsDeclaration(parent2) && node === parent2.name) return 7 /* All */ ;
        else if (isInRightSideOfInternalImportEqualsDeclaration(node)) return getMeaningFromRightHandSideOfImportEquals(node);
        else if (isDeclarationName(node)) return getMeaningFromDeclaration(parent2);
        else if (isEntityName(node) && findAncestor(node, or(isJSDocNameReference, isJSDocLinkLike, isJSDocMemberName))) return 7 /* All */ ;
        else if (isTypeReference(node)) return 2 /* Type */ ;
        else if (isNamespaceReference(node)) return 4 /* Namespace */ ;
        else if (isTypeParameterDeclaration(parent2)) {
            Debug.assert(isJSDocTemplateTag(parent2.parent));
            return 2 /* Type */ ;
        } else if (isLiteralTypeNode(parent2)) return 3 /* Value */ ;
        else return 1 /* Value */ ;
    }
    function getMeaningFromRightHandSideOfImportEquals(node) {
        const name = node.kind === 165 /* QualifiedName */  ? node : isQualifiedName(node.parent) && node.parent.right === node ? node.parent : void 0;
        return name && name.parent.kind === 270 /* ImportEqualsDeclaration */  ? 7 /* All */  : 4 /* Namespace */ ;
    }
    function isInRightSideOfInternalImportEqualsDeclaration(node) {
        while(node.parent.kind === 165 /* QualifiedName */ )node = node.parent;
        return isInternalModuleImportEqualsDeclaration(node.parent) && node.parent.moduleReference === node;
    }
    function isNamespaceReference(node) {
        return isQualifiedNameNamespaceReference(node) || isPropertyAccessNamespaceReference(node);
    }
    function isQualifiedNameNamespaceReference(node) {
        let root = node;
        let isLastClause = true;
        if (root.parent.kind === 165 /* QualifiedName */ ) {
            while(root.parent && root.parent.kind === 165 /* QualifiedName */ )root = root.parent;
            isLastClause = root.right === node;
        }
        return root.parent.kind === 182 /* TypeReference */  && !isLastClause;
    }
    function isPropertyAccessNamespaceReference(node) {
        let root = node;
        let isLastClause = true;
        if (root.parent.kind === 210 /* PropertyAccessExpression */ ) {
            while(root.parent && root.parent.kind === 210 /* PropertyAccessExpression */ )root = root.parent;
            isLastClause = root.name === node;
        }
        if (!isLastClause && root.parent.kind === 232 /* ExpressionWithTypeArguments */  && root.parent.parent.kind === 297 /* HeritageClause */ ) {
            const decl = root.parent.parent.parent;
            return decl.kind === 262 /* ClassDeclaration */  && root.parent.parent.token === 119 /* ImplementsKeyword */  || decl.kind === 263 /* InterfaceDeclaration */  && root.parent.parent.token === 96 /* ExtendsKeyword */ ;
        }
        return false;
    }
    function isTypeReference(node) {
        if (isRightSideOfQualifiedNameOrPropertyAccess(node)) node = node.parent;
        switch(node.kind){
            case 110 /* ThisKeyword */ :
                return !isExpressionNode(node);
            case 196 /* ThisType */ :
                return true;
        }
        switch(node.parent.kind){
            case 182 /* TypeReference */ :
                return true;
            case 204 /* ImportType */ :
                return !node.parent.isTypeOf;
            case 232 /* ExpressionWithTypeArguments */ :
                return isPartOfTypeNode(node.parent);
        }
        return false;
    }
    function isCallExpressionTarget(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isCallExpression, selectExpressionOfCallOrNewExpressionOrDecorator, includeElementAccess, skipPastOuterExpressions);
    }
    function isNewExpressionTarget(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isNewExpression, selectExpressionOfCallOrNewExpressionOrDecorator, includeElementAccess, skipPastOuterExpressions);
    }
    function isCallOrNewExpressionTarget(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isCallOrNewExpression, selectExpressionOfCallOrNewExpressionOrDecorator, includeElementAccess, skipPastOuterExpressions);
    }
    function isTaggedTemplateTag(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isTaggedTemplateExpression, selectTagOfTaggedTemplateExpression, includeElementAccess, skipPastOuterExpressions);
    }
    function isDecoratorTarget(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isDecorator, selectExpressionOfCallOrNewExpressionOrDecorator, includeElementAccess, skipPastOuterExpressions);
    }
    function isJsxOpeningLikeElementTagName(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isJsxOpeningLikeElement, selectTagNameOfJsxOpeningLikeElement, includeElementAccess, skipPastOuterExpressions);
    }
    function selectExpressionOfCallOrNewExpressionOrDecorator(node) {
        return node.expression;
    }
    function selectTagOfTaggedTemplateExpression(node) {
        return node.tag;
    }
    function selectTagNameOfJsxOpeningLikeElement(node) {
        return node.tagName;
    }
    function isCalleeWorker(node, pred, calleeSelector, includeElementAccess, skipPastOuterExpressions) {
        let target = includeElementAccess ? climbPastPropertyOrElementAccess(node) : climbPastPropertyAccess(node);
        if (skipPastOuterExpressions) target = skipOuterExpressions(target);
        return !!target && !!target.parent && pred(target.parent) && calleeSelector(target.parent) === target;
    }
    function climbPastPropertyAccess(node) {
        return isRightSideOfPropertyAccess(node) ? node.parent : node;
    }
    function climbPastPropertyOrElementAccess(node) {
        return isRightSideOfPropertyAccess(node) || isArgumentExpressionOfElementAccess(node) ? node.parent : node;
    }
    function getTargetLabel(referenceNode, labelName) {
        while(referenceNode){
            if (referenceNode.kind === 255 /* LabeledStatement */  && referenceNode.label.escapedText === labelName) return referenceNode.label;
            referenceNode = referenceNode.parent;
        }
        return void 0;
    }
    function hasPropertyAccessExpressionWithName(node, funcName) {
        if (!isPropertyAccessExpression(node.expression)) return false;
        return node.expression.name.text === funcName;
    }
    function isJumpStatementTarget(node) {
        var _a;
        return isIdentifier(node) && ((_a = tryCast(node.parent, isBreakOrContinueStatement)) == null ? void 0 : _a.label) === node;
    }
    function isLabelOfLabeledStatement(node) {
        var _a;
        return isIdentifier(node) && ((_a = tryCast(node.parent, isLabeledStatement)) == null ? void 0 : _a.label) === node;
    }
    function isLabelName(node) {
        return isLabelOfLabeledStatement(node) || isJumpStatementTarget(node);
    }
    function isTagName(node) {
        var _a;
        return ((_a = tryCast(node.parent, isJSDocTag)) == null ? void 0 : _a.tagName) === node;
    }
    function isRightSideOfQualifiedName(node) {
        var _a;
        return ((_a = tryCast(node.parent, isQualifiedName)) == null ? void 0 : _a.right) === node;
    }
    function isRightSideOfPropertyAccess(node) {
        var _a;
        return ((_a = tryCast(node.parent, isPropertyAccessExpression)) == null ? void 0 : _a.name) === node;
    }
    function isArgumentExpressionOfElementAccess(node) {
        var _a;
        return ((_a = tryCast(node.parent, isElementAccessExpression)) == null ? void 0 : _a.argumentExpression) === node;
    }
    function isNameOfModuleDeclaration(node) {
        var _a;
        return ((_a = tryCast(node.parent, isModuleDeclaration)) == null ? void 0 : _a.name) === node;
    }
    function isNameOfFunctionDeclaration(node) {
        var _a;
        return isIdentifier(node) && ((_a = tryCast(node.parent, isFunctionLike)) == null ? void 0 : _a.name) === node;
    }
    function isLiteralNameOfPropertyDeclarationOrIndexAccess(node) {
        switch(node.parent.kind){
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
            case 302 /* PropertyAssignment */ :
            case 305 /* EnumMember */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 266 /* ModuleDeclaration */ :
                return getNameOfDeclaration(node.parent) === node;
            case 211 /* ElementAccessExpression */ :
                return node.parent.argumentExpression === node;
            case 166 /* ComputedPropertyName */ :
                return true;
            case 200 /* LiteralType */ :
                return node.parent.parent.kind === 198 /* IndexedAccessType */ ;
            default:
                return false;
        }
    }
    function isExpressionOfExternalModuleImportEqualsDeclaration(node) {
        return isExternalModuleImportEqualsDeclaration(node.parent.parent) && getExternalModuleImportEqualsDeclarationExpression(node.parent.parent) === node;
    }
    function getContainerNode(node) {
        if (isJSDocTypeAlias(node)) node = node.parent.parent;
        while(true){
            node = node.parent;
            if (!node) return void 0;
            switch(node.kind){
                case 311 /* SourceFile */ :
                case 173 /* MethodDeclaration */ :
                case 172 /* MethodSignature */ :
                case 261 /* FunctionDeclaration */ :
                case 217 /* FunctionExpression */ :
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                case 262 /* ClassDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                case 265 /* EnumDeclaration */ :
                case 266 /* ModuleDeclaration */ :
                    return node;
            }
        }
    }
    function getNodeKind(node) {
        switch(node.kind){
            case 311 /* SourceFile */ :
                return isExternalModule(node) ? "module" /* moduleElement */  : "script" /* scriptElement */ ;
            case 266 /* ModuleDeclaration */ :
                return "module" /* moduleElement */ ;
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
                return "class" /* classElement */ ;
            case 263 /* InterfaceDeclaration */ :
                return "interface" /* interfaceElement */ ;
            case 264 /* TypeAliasDeclaration */ :
            case 344 /* JSDocCallbackTag */ :
            case 352 /* JSDocTypedefTag */ :
                return "type" /* typeElement */ ;
            case 265 /* EnumDeclaration */ :
                return "enum" /* enumElement */ ;
            case 259 /* VariableDeclaration */ :
                return getKindOfVariableDeclaration(node);
            case 207 /* BindingElement */ :
                return getKindOfVariableDeclaration(getRootDeclaration(node));
            case 218 /* ArrowFunction */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
                return "function" /* functionElement */ ;
            case 176 /* GetAccessor */ :
                return "getter" /* memberGetAccessorElement */ ;
            case 177 /* SetAccessor */ :
                return "setter" /* memberSetAccessorElement */ ;
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
                return "method" /* memberFunctionElement */ ;
            case 302 /* PropertyAssignment */ :
                const { initializer: initializer  } = node;
                return isFunctionLike(initializer) ? "method" /* memberFunctionElement */  : "property" /* memberVariableElement */ ;
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
            case 303 /* ShorthandPropertyAssignment */ :
            case 304 /* SpreadAssignment */ :
                return "property" /* memberVariableElement */ ;
            case 180 /* IndexSignature */ :
                return "index" /* indexSignatureElement */ ;
            case 179 /* ConstructSignature */ :
                return "construct" /* constructSignatureElement */ ;
            case 178 /* CallSignature */ :
                return "call" /* callSignatureElement */ ;
            case 175 /* Constructor */ :
            case 174 /* ClassStaticBlockDeclaration */ :
                return "constructor" /* constructorImplementationElement */ ;
            case 167 /* TypeParameter */ :
                return "type parameter" /* typeParameterElement */ ;
            case 305 /* EnumMember */ :
                return "enum member" /* enumMemberElement */ ;
            case 168 /* Parameter */ :
                return hasSyntacticModifier(node, 16476 /* ParameterPropertyModifier */ ) ? "property" /* memberVariableElement */  : "parameter" /* parameterElement */ ;
            case 270 /* ImportEqualsDeclaration */ :
            case 275 /* ImportSpecifier */ :
            case 280 /* ExportSpecifier */ :
            case 273 /* NamespaceImport */ :
            case 279 /* NamespaceExport */ :
                return "alias" /* alias */ ;
            case 225 /* BinaryExpression */ :
                const kind = getAssignmentDeclarationKind(node);
                const { right: right  } = node;
                switch(kind){
                    case 7 /* ObjectDefinePropertyValue */ :
                    case 8 /* ObjectDefinePropertyExports */ :
                    case 9 /* ObjectDefinePrototypeProperty */ :
                    case 0 /* None */ :
                        return "" /* unknown */ ;
                    case 1 /* ExportsProperty */ :
                    case 2 /* ModuleExports */ :
                        const rightKind = getNodeKind(right);
                        return rightKind === "" /* unknown */  ? "const" /* constElement */  : rightKind;
                    case 3 /* PrototypeProperty */ :
                        return isFunctionExpression(right) ? "method" /* memberFunctionElement */  : "property" /* memberVariableElement */ ;
                    case 4 /* ThisProperty */ :
                        return "property" /* memberVariableElement */ ;
                    case 5 /* Property */ :
                        return isFunctionExpression(right) ? "method" /* memberFunctionElement */  : "property" /* memberVariableElement */ ;
                    case 6 /* Prototype */ :
                        return "local class" /* localClassElement */ ;
                    default:
                        assertType(kind);
                        return "" /* unknown */ ;
                }
            case 80 /* Identifier */ :
                return isImportClause(node.parent) ? "alias" /* alias */  : "" /* unknown */ ;
            case 276 /* ExportAssignment */ :
                const scriptKind = getNodeKind(node.expression);
                return scriptKind === "" /* unknown */  ? "const" /* constElement */  : scriptKind;
            default:
                return "" /* unknown */ ;
        }
        function getKindOfVariableDeclaration(v) {
            return isVarConst(v) ? "const" /* constElement */  : isLet(v) ? "let" /* letElement */  : "var" /* variableElement */ ;
        }
    }
    function isThis(node) {
        switch(node.kind){
            case 110 /* ThisKeyword */ :
                return true;
            case 80 /* Identifier */ :
                return identifierIsThisKeyword(node) && node.parent.kind === 168 /* Parameter */ ;
            default:
                return false;
        }
    }
    function getLineStartPositionForPosition(position, sourceFile) {
        const lineStarts = getLineStarts(sourceFile);
        const line = sourceFile.getLineAndCharacterOfPosition(position).line;
        return lineStarts[line];
    }
    function rangeContainsRange(r1, r2) {
        return startEndContainsRange(r1.pos, r1.end, r2);
    }
    function rangeContainsRangeExclusive(r1, r2) {
        return rangeContainsPositionExclusive(r1, r2.pos) && rangeContainsPositionExclusive(r1, r2.end);
    }
    function rangeContainsPosition(r, pos) {
        return r.pos <= pos && pos <= r.end;
    }
    function rangeContainsPositionExclusive(r, pos) {
        return r.pos < pos && pos < r.end;
    }
    function startEndContainsRange(start, end, range) {
        return start <= range.pos && end >= range.end;
    }
    function rangeContainsStartEnd(range, start, end) {
        return range.pos <= start && range.end >= end;
    }
    function rangeOverlapsWithStartEnd(r1, start, end) {
        return startEndOverlapsWithStartEnd(r1.pos, r1.end, start, end);
    }
    function nodeOverlapsWithStartEnd(node, sourceFile, start, end) {
        return startEndOverlapsWithStartEnd(node.getStart(sourceFile), node.end, start, end);
    }
    function startEndOverlapsWithStartEnd(start1, end1, start2, end2) {
        const start = Math.max(start1, start2);
        const end = Math.min(end1, end2);
        return start < end;
    }
    function positionBelongsToNode(candidate, position, sourceFile) {
        Debug.assert(candidate.pos <= position);
        return position < candidate.end || !isCompletedNode(candidate, sourceFile);
    }
    function isCompletedNode(n, sourceFile) {
        if (n === void 0 || nodeIsMissing(n)) return false;
        switch(n.kind){
            case 262 /* ClassDeclaration */ :
            case 263 /* InterfaceDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 209 /* ObjectLiteralExpression */ :
            case 205 /* ObjectBindingPattern */ :
            case 186 /* TypeLiteral */ :
            case 240 /* Block */ :
            case 267 /* ModuleBlock */ :
            case 268 /* CaseBlock */ :
            case 274 /* NamedImports */ :
            case 278 /* NamedExports */ :
                return nodeEndsWith(n, 20 /* CloseBraceToken */ , sourceFile);
            case 298 /* CatchClause */ :
                return isCompletedNode(n.block, sourceFile);
            case 213 /* NewExpression */ :
                if (!n.arguments) return true;
            case 212 /* CallExpression */ :
            case 216 /* ParenthesizedExpression */ :
            case 195 /* ParenthesizedType */ :
                return nodeEndsWith(n, 22 /* CloseParenToken */ , sourceFile);
            case 183 /* FunctionType */ :
            case 184 /* ConstructorType */ :
                return isCompletedNode(n.type, sourceFile);
            case 175 /* Constructor */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 179 /* ConstructSignature */ :
            case 178 /* CallSignature */ :
            case 218 /* ArrowFunction */ :
                if (n.body) return isCompletedNode(n.body, sourceFile);
                if (n.type) return isCompletedNode(n.type, sourceFile);
                return hasChildOfKind(n, 22 /* CloseParenToken */ , sourceFile);
            case 266 /* ModuleDeclaration */ :
                return !!n.body && isCompletedNode(n.body, sourceFile);
            case 244 /* IfStatement */ :
                if (n.elseStatement) return isCompletedNode(n.elseStatement, sourceFile);
                return isCompletedNode(n.thenStatement, sourceFile);
            case 243 /* ExpressionStatement */ :
                return isCompletedNode(n.expression, sourceFile) || hasChildOfKind(n, 27 /* SemicolonToken */ , sourceFile);
            case 208 /* ArrayLiteralExpression */ :
            case 206 /* ArrayBindingPattern */ :
            case 211 /* ElementAccessExpression */ :
            case 166 /* ComputedPropertyName */ :
            case 188 /* TupleType */ :
                return nodeEndsWith(n, 24 /* CloseBracketToken */ , sourceFile);
            case 180 /* IndexSignature */ :
                if (n.type) return isCompletedNode(n.type, sourceFile);
                return hasChildOfKind(n, 24 /* CloseBracketToken */ , sourceFile);
            case 295 /* CaseClause */ :
            case 296 /* DefaultClause */ :
                return false;
            case 247 /* ForStatement */ :
            case 248 /* ForInStatement */ :
            case 249 /* ForOfStatement */ :
            case 246 /* WhileStatement */ :
                return isCompletedNode(n.statement, sourceFile);
            case 245 /* DoStatement */ :
                return hasChildOfKind(n, 117 /* WhileKeyword */ , sourceFile) ? nodeEndsWith(n, 22 /* CloseParenToken */ , sourceFile) : isCompletedNode(n.statement, sourceFile);
            case 185 /* TypeQuery */ :
                return isCompletedNode(n.exprName, sourceFile);
            case 220 /* TypeOfExpression */ :
            case 219 /* DeleteExpression */ :
            case 221 /* VoidExpression */ :
            case 228 /* YieldExpression */ :
            case 229 /* SpreadElement */ :
                const unaryWordExpression = n;
                return isCompletedNode(unaryWordExpression.expression, sourceFile);
            case 214 /* TaggedTemplateExpression */ :
                return isCompletedNode(n.template, sourceFile);
            case 227 /* TemplateExpression */ :
                const lastSpan = lastOrUndefined(n.templateSpans);
                return isCompletedNode(lastSpan, sourceFile);
            case 238 /* TemplateSpan */ :
                return nodeIsPresent(n.literal);
            case 277 /* ExportDeclaration */ :
            case 271 /* ImportDeclaration */ :
                return nodeIsPresent(n.moduleSpecifier);
            case 223 /* PrefixUnaryExpression */ :
                return isCompletedNode(n.operand, sourceFile);
            case 225 /* BinaryExpression */ :
                return isCompletedNode(n.right, sourceFile);
            case 226 /* ConditionalExpression */ :
                return isCompletedNode(n.whenFalse, sourceFile);
            default:
                return true;
        }
    }
    function nodeEndsWith(n, expectedLastToken, sourceFile) {
        const children = n.getChildren(sourceFile);
        if (children.length) {
            const lastChild = last(children);
            if (lastChild.kind === expectedLastToken) return true;
            else if (lastChild.kind === 27 /* SemicolonToken */  && children.length !== 1) return children[children.length - 2].kind === expectedLastToken;
        }
        return false;
    }
    function findListItemInfo(node) {
        const list = findContainingList(node);
        if (!list) return void 0;
        const children = list.getChildren();
        const listItemIndex = indexOfNode(children, node);
        return {
            listItemIndex: listItemIndex,
            list: list
        };
    }
    function hasChildOfKind(n, kind, sourceFile) {
        return !!findChildOfKind(n, kind, sourceFile);
    }
    function findChildOfKind(n, kind, sourceFile) {
        return find(n.getChildren(sourceFile), (c)=>c.kind === kind);
    }
    function findContainingList(node) {
        const syntaxList = find(node.parent.getChildren(), (c)=>isSyntaxList(c) && rangeContainsRange(c, node));
        Debug.assert(!syntaxList || contains(syntaxList.getChildren(), node));
        return syntaxList;
    }
    function isDefaultModifier2(node) {
        return node.kind === 90 /* DefaultKeyword */ ;
    }
    function isClassKeyword(node) {
        return node.kind === 86 /* ClassKeyword */ ;
    }
    function isFunctionKeyword(node) {
        return node.kind === 100 /* FunctionKeyword */ ;
    }
    function getAdjustedLocationForClass(node) {
        if (isNamedDeclaration(node)) return node.name;
        if (isClassDeclaration(node)) {
            const defaultModifier = node.modifiers && find(node.modifiers, isDefaultModifier2);
            if (defaultModifier) return defaultModifier;
        }
        if (isClassExpression(node)) {
            const classKeyword = find(node.getChildren(), isClassKeyword);
            if (classKeyword) return classKeyword;
        }
    }
    function getAdjustedLocationForFunction(node) {
        if (isNamedDeclaration(node)) return node.name;
        if (isFunctionDeclaration(node)) {
            const defaultModifier = find(node.modifiers, isDefaultModifier2);
            if (defaultModifier) return defaultModifier;
        }
        if (isFunctionExpression(node)) {
            const functionKeyword = find(node.getChildren(), isFunctionKeyword);
            if (functionKeyword) return functionKeyword;
        }
    }
    function getAncestorTypeNode(node) {
        let lastTypeNode;
        findAncestor(node, (a)=>{
            if (isTypeNode(a)) lastTypeNode = a;
            return !isQualifiedName(a.parent) && !isTypeNode(a.parent) && !isTypeElement(a.parent);
        });
        return lastTypeNode;
    }
    function getContextualTypeFromParentOrAncestorTypeNode(node, checker) {
        if (node.flags & 8388608 /* JavaScriptFile */ ) return void 0;
        const contextualType = getContextualTypeFromParent(node, checker);
        if (contextualType) return contextualType;
        const ancestorTypeNode = getAncestorTypeNode(node);
        return ancestorTypeNode && checker.getTypeAtLocation(ancestorTypeNode);
    }
    function getAdjustedLocationForDeclaration(node, forRename) {
        if (!forRename) switch(node.kind){
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
                return getAdjustedLocationForClass(node);
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
                return getAdjustedLocationForFunction(node);
            case 175 /* Constructor */ :
                return node;
        }
        if (isNamedDeclaration(node)) return node.name;
    }
    function getAdjustedLocationForImportDeclaration(node, forRename) {
        if (node.importClause) {
            if (node.importClause.name && node.importClause.namedBindings) return;
            if (node.importClause.name) return node.importClause.name;
            if (node.importClause.namedBindings) {
                if (isNamedImports(node.importClause.namedBindings)) {
                    const onlyBinding = singleOrUndefined(node.importClause.namedBindings.elements);
                    if (!onlyBinding) return;
                    return onlyBinding.name;
                } else if (isNamespaceImport(node.importClause.namedBindings)) return node.importClause.namedBindings.name;
            }
        }
        if (!forRename) return node.moduleSpecifier;
    }
    function getAdjustedLocationForExportDeclaration(node, forRename) {
        if (node.exportClause) {
            if (isNamedExports(node.exportClause)) {
                const onlyBinding = singleOrUndefined(node.exportClause.elements);
                if (!onlyBinding) return;
                return node.exportClause.elements[0].name;
            } else if (isNamespaceExport(node.exportClause)) return node.exportClause.name;
        }
        if (!forRename) return node.moduleSpecifier;
    }
    function getAdjustedLocationForHeritageClause(node) {
        if (node.types.length === 1) return node.types[0].expression;
    }
    function getAdjustedLocation(node, forRename) {
        const { parent: parent2  } = node;
        if (isModifier(node) && (forRename || node.kind !== 90 /* DefaultKeyword */ ) ? canHaveModifiers(parent2) && contains(parent2.modifiers, node) : node.kind === 86 /* ClassKeyword */  ? isClassDeclaration(parent2) || isClassExpression(node) : node.kind === 100 /* FunctionKeyword */  ? isFunctionDeclaration(parent2) || isFunctionExpression(node) : node.kind === 120 /* InterfaceKeyword */  ? isInterfaceDeclaration(parent2) : node.kind === 94 /* EnumKeyword */  ? isEnumDeclaration(parent2) : node.kind === 156 /* TypeKeyword */  ? isTypeAliasDeclaration(parent2) : node.kind === 145 /* NamespaceKeyword */  || node.kind === 144 /* ModuleKeyword */  ? isModuleDeclaration(parent2) : node.kind === 102 /* ImportKeyword */  ? isImportEqualsDeclaration(parent2) : node.kind === 139 /* GetKeyword */  ? isGetAccessorDeclaration(parent2) : node.kind === 153 /* SetKeyword */  && isSetAccessorDeclaration(parent2)) {
            const location = getAdjustedLocationForDeclaration(parent2, forRename);
            if (location) return location;
        }
        if ((node.kind === 115 /* VarKeyword */  || node.kind === 87 /* ConstKeyword */  || node.kind === 121 /* LetKeyword */ ) && isVariableDeclarationList(parent2) && parent2.declarations.length === 1) {
            const decl = parent2.declarations[0];
            if (isIdentifier(decl.name)) return decl.name;
        }
        if (node.kind === 156 /* TypeKeyword */ ) {
            if (isImportClause(parent2) && parent2.isTypeOnly) {
                const location = getAdjustedLocationForImportDeclaration(parent2.parent, forRename);
                if (location) return location;
            }
            if (isExportDeclaration(parent2) && parent2.isTypeOnly) {
                const location = getAdjustedLocationForExportDeclaration(parent2, forRename);
                if (location) return location;
            }
        }
        if (node.kind === 130 /* AsKeyword */ ) {
            if (isImportSpecifier(parent2) && parent2.propertyName || isExportSpecifier(parent2) && parent2.propertyName || isNamespaceImport(parent2) || isNamespaceExport(parent2)) return parent2.name;
            if (isExportDeclaration(parent2) && parent2.exportClause && isNamespaceExport(parent2.exportClause)) return parent2.exportClause.name;
        }
        if (node.kind === 102 /* ImportKeyword */  && isImportDeclaration(parent2)) {
            const location = getAdjustedLocationForImportDeclaration(parent2, forRename);
            if (location) return location;
        }
        if (node.kind === 95 /* ExportKeyword */ ) {
            if (isExportDeclaration(parent2)) {
                const location = getAdjustedLocationForExportDeclaration(parent2, forRename);
                if (location) return location;
            }
            if (isExportAssignment(parent2)) return skipOuterExpressions(parent2.expression);
        }
        if (node.kind === 149 /* RequireKeyword */  && isExternalModuleReference(parent2)) return parent2.expression;
        if (node.kind === 160 /* FromKeyword */  && (isImportDeclaration(parent2) || isExportDeclaration(parent2)) && parent2.moduleSpecifier) return parent2.moduleSpecifier;
        if ((node.kind === 96 /* ExtendsKeyword */  || node.kind === 119 /* ImplementsKeyword */ ) && isHeritageClause(parent2) && parent2.token === node.kind) {
            const location = getAdjustedLocationForHeritageClause(parent2);
            if (location) return location;
        }
        if (node.kind === 96 /* ExtendsKeyword */ ) {
            if (isTypeParameterDeclaration(parent2) && parent2.constraint && isTypeReferenceNode(parent2.constraint)) return parent2.constraint.typeName;
            if (isConditionalTypeNode(parent2) && isTypeReferenceNode(parent2.extendsType)) return parent2.extendsType.typeName;
        }
        if (node.kind === 140 /* InferKeyword */  && isInferTypeNode(parent2)) return parent2.typeParameter.name;
        if (node.kind === 103 /* InKeyword */  && isTypeParameterDeclaration(parent2) && isMappedTypeNode(parent2.parent)) return parent2.name;
        if (node.kind === 143 /* KeyOfKeyword */  && isTypeOperatorNode(parent2) && parent2.operator === 143 /* KeyOfKeyword */  && isTypeReferenceNode(parent2.type)) return parent2.type.typeName;
        if (node.kind === 148 /* ReadonlyKeyword */  && isTypeOperatorNode(parent2) && parent2.operator === 148 /* ReadonlyKeyword */  && isArrayTypeNode(parent2.type) && isTypeReferenceNode(parent2.type.elementType)) return parent2.type.elementType.typeName;
        if (!forRename) {
            if (node.kind === 105 /* NewKeyword */  && isNewExpression(parent2) || node.kind === 116 /* VoidKeyword */  && isVoidExpression(parent2) || node.kind === 114 /* TypeOfKeyword */  && isTypeOfExpression(parent2) || node.kind === 135 /* AwaitKeyword */  && isAwaitExpression(parent2) || node.kind === 127 /* YieldKeyword */  && isYieldExpression(parent2) || node.kind === 91 /* DeleteKeyword */  && isDeleteExpression(parent2)) {
                if (parent2.expression) return skipOuterExpressions(parent2.expression);
            }
            if ((node.kind === 103 /* InKeyword */  || node.kind === 104 /* InstanceOfKeyword */ ) && isBinaryExpression(parent2) && parent2.operatorToken === node) return skipOuterExpressions(parent2.right);
            if (node.kind === 130 /* AsKeyword */  && isAsExpression(parent2) && isTypeReferenceNode(parent2.type)) return parent2.type.typeName;
            if (node.kind === 103 /* InKeyword */  && isForInStatement(parent2) || node.kind === 164 /* OfKeyword */  && isForOfStatement(parent2)) return skipOuterExpressions(parent2.expression);
        }
        return node;
    }
    function getAdjustedReferenceLocation(node) {
        return getAdjustedLocation(node, /*forRename*/ false);
    }
    function getAdjustedRenameLocation(node) {
        return getAdjustedLocation(node, /*forRename*/ true);
    }
    function getTouchingPropertyName(sourceFile, position) {
        return getTouchingToken(sourceFile, position, (n)=>isPropertyNameLiteral(n) || isKeyword(n.kind) || isPrivateIdentifier(n));
    }
    function getTouchingToken(sourceFile, position, includePrecedingTokenAtEndPosition) {
        return getTokenAtPositionWorker(sourceFile, position, /*allowPositionInLeadingTrivia*/ false, includePrecedingTokenAtEndPosition, /*includeEndPosition*/ false);
    }
    function getTokenAtPosition(sourceFile, position) {
        return getTokenAtPositionWorker(sourceFile, position, /*allowPositionInLeadingTrivia*/ true, /*includePrecedingTokenAtEndPosition*/ void 0, /*includeEndPosition*/ false);
    }
    function getTokenAtPositionWorker(sourceFile, position, allowPositionInLeadingTrivia, includePrecedingTokenAtEndPosition, includeEndPosition) {
        let current = sourceFile;
        let foundToken;
        outer: while(true){
            const children = current.getChildren(sourceFile);
            const i = binarySearchKey(children, position, (_, i2)=>i2, (middle, _)=>{
                const end = children[middle].getEnd();
                if (end < position) return -1 /* LessThan */ ;
                const start = allowPositionInLeadingTrivia ? children[middle].getFullStart() : children[middle].getStart(sourceFile, /*includeJsDocComment*/ true);
                if (start > position) return 1 /* GreaterThan */ ;
                if (nodeContainsPosition(children[middle], start, end)) {
                    if (children[middle - 1]) {
                        if (nodeContainsPosition(children[middle - 1])) return 1 /* GreaterThan */ ;
                    }
                    return 0 /* EqualTo */ ;
                }
                if (includePrecedingTokenAtEndPosition && start === position && children[middle - 1] && children[middle - 1].getEnd() === position && nodeContainsPosition(children[middle - 1])) return 1 /* GreaterThan */ ;
                return -1 /* LessThan */ ;
            });
            if (foundToken) return foundToken;
            if (i >= 0 && children[i]) {
                current = children[i];
                continue outer;
            }
            return current;
        }
        function nodeContainsPosition(node, start, end) {
            end ?? (end = node.getEnd());
            if (end < position) return false;
            start ?? (start = allowPositionInLeadingTrivia ? node.getFullStart() : node.getStart(sourceFile, /*includeJsDocComment*/ true));
            if (start > position) return false;
            if (position < end || position === end && (node.kind === 1 /* EndOfFileToken */  || includeEndPosition)) return true;
            else if (includePrecedingTokenAtEndPosition && end === position) {
                const previousToken = findPrecedingToken(position, sourceFile, node);
                if (previousToken && includePrecedingTokenAtEndPosition(previousToken)) {
                    foundToken = previousToken;
                    return true;
                }
            }
            return false;
        }
    }
    function findFirstNonJsxWhitespaceToken(sourceFile, position) {
        let tokenAtPosition = getTokenAtPosition(sourceFile, position);
        while(isWhiteSpaceOnlyJsxText(tokenAtPosition)){
            const nextToken = findNextToken(tokenAtPosition, tokenAtPosition.parent, sourceFile);
            if (!nextToken) return;
            tokenAtPosition = nextToken;
        }
        return tokenAtPosition;
    }
    function findTokenOnLeftOfPosition(file, position) {
        const tokenAtPosition = getTokenAtPosition(file, position);
        if (isToken(tokenAtPosition) && position > tokenAtPosition.getStart(file) && position < tokenAtPosition.getEnd()) return tokenAtPosition;
        return findPrecedingToken(position, file);
    }
    function findNextToken(previousToken, parent2, sourceFile) {
        return find2(parent2);
        function find2(n) {
            if (isToken(n) && n.pos === previousToken.end) return n;
            return firstDefined(n.getChildren(sourceFile), (child)=>{
                const shouldDiveInChildNode = // previous token is enclosed somewhere in the child
                child.pos <= previousToken.pos && child.end > previousToken.end || // previous token ends exactly at the beginning of child
                child.pos === previousToken.end;
                return shouldDiveInChildNode && nodeHasTokens(child, sourceFile) ? find2(child) : void 0;
            });
        }
    }
    function findPrecedingToken(position, sourceFile, startNode2, excludeJsdoc) {
        const result = find2(startNode2 || sourceFile);
        Debug.assert(!(result && isWhiteSpaceOnlyJsxText(result)));
        return result;
        function find2(n) {
            if (isNonWhitespaceToken(n) && n.kind !== 1 /* EndOfFileToken */ ) return n;
            const children = n.getChildren(sourceFile);
            const i = binarySearchKey(children, position, (_, i2)=>i2, (middle, _)=>{
                if (position < children[middle].end) {
                    if (!children[middle - 1] || position >= children[middle - 1].end) return 0 /* EqualTo */ ;
                    return 1 /* GreaterThan */ ;
                }
                return -1 /* LessThan */ ;
            });
            if (i >= 0 && children[i]) {
                const child = children[i];
                if (position < child.end) {
                    const start = child.getStart(sourceFile, /*includeJsDoc*/ !excludeJsdoc);
                    const lookInPreviousChild = start >= position || // cursor in the leading trivia
                    !nodeHasTokens(child, sourceFile) || isWhiteSpaceOnlyJsxText(child);
                    if (lookInPreviousChild) {
                        const candidate2 = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ i, sourceFile, n.kind);
                        if (candidate2) {
                            if (!excludeJsdoc && isJSDocCommentContainingNode(candidate2) && candidate2.getChildren(sourceFile).length) return find2(candidate2);
                            return findRightmostToken(candidate2, sourceFile);
                        }
                        return void 0;
                    } else return find2(child);
                }
            }
            Debug.assert(startNode2 !== void 0 || n.kind === 311 /* SourceFile */  || n.kind === 1 /* EndOfFileToken */  || isJSDocCommentContainingNode(n));
            const candidate = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ children.length, sourceFile, n.kind);
            return candidate && findRightmostToken(candidate, sourceFile);
        }
    }
    function isNonWhitespaceToken(n) {
        return isToken(n) && !isWhiteSpaceOnlyJsxText(n);
    }
    function findRightmostToken(n, sourceFile) {
        if (isNonWhitespaceToken(n)) return n;
        const children = n.getChildren(sourceFile);
        if (children.length === 0) return n;
        const candidate = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ children.length, sourceFile, n.kind);
        return candidate && findRightmostToken(candidate, sourceFile);
    }
    function findRightmostChildNodeWithTokens(children, exclusiveStartPosition, sourceFile, parentKind) {
        for(let i = exclusiveStartPosition - 1; i >= 0; i--){
            const child = children[i];
            if (isWhiteSpaceOnlyJsxText(child)) {
                if (i === 0 && (parentKind === 12 /* JsxText */  || parentKind === 284 /* JsxSelfClosingElement */ )) Debug.fail("`JsxText` tokens should not be the first child of `JsxElement | JsxSelfClosingElement`");
            } else if (nodeHasTokens(children[i], sourceFile)) return children[i];
        }
    }
    function isInString(sourceFile, position, previousToken = findPrecedingToken(position, sourceFile)) {
        if (previousToken && isStringTextContainingNode(previousToken)) {
            const start = previousToken.getStart(sourceFile);
            const end = previousToken.getEnd();
            if (start < position && position < end) return true;
            if (position === end) return !!previousToken.isUnterminated;
        }
        return false;
    }
    function isInsideJsxElementOrAttribute(sourceFile, position) {
        const token = getTokenAtPosition(sourceFile, position);
        if (!token) return false;
        if (token.kind === 12 /* JsxText */ ) return true;
        if (token.kind === 30 /* LessThanToken */  && token.parent.kind === 12 /* JsxText */ ) return true;
        if (token.kind === 30 /* LessThanToken */  && token.parent.kind === 293 /* JsxExpression */ ) return true;
        if (token && token.kind === 20 /* CloseBraceToken */  && token.parent.kind === 293 /* JsxExpression */ ) return true;
        if (token.kind === 30 /* LessThanToken */  && token.parent.kind === 286 /* JsxClosingElement */ ) return true;
        return false;
    }
    function isWhiteSpaceOnlyJsxText(node) {
        return isJsxText(node) && node.containsOnlyTriviaWhiteSpaces;
    }
    function isInTemplateString(sourceFile, position) {
        const token = getTokenAtPosition(sourceFile, position);
        return isTemplateLiteralKind(token.kind) && position > token.getStart(sourceFile);
    }
    function isInJSXText(sourceFile, position) {
        const token = getTokenAtPosition(sourceFile, position);
        if (isJsxText(token)) return true;
        if (token.kind === 19 /* OpenBraceToken */  && isJsxExpression(token.parent) && isJsxElement(token.parent.parent)) return true;
        if (token.kind === 30 /* LessThanToken */  && isJsxOpeningLikeElement(token.parent) && isJsxElement(token.parent.parent)) return true;
        return false;
    }
    function isInsideJsxElement(sourceFile, position) {
        function isInsideJsxElementTraversal(node) {
            while(node){
                if (node.kind >= 284 /* JsxSelfClosingElement */  && node.kind <= 293 /* JsxExpression */  || node.kind === 12 /* JsxText */  || node.kind === 30 /* LessThanToken */  || node.kind === 32 /* GreaterThanToken */  || node.kind === 80 /* Identifier */  || node.kind === 20 /* CloseBraceToken */  || node.kind === 19 /* OpenBraceToken */  || node.kind === 44 /* SlashToken */ ) node = node.parent;
                else if (node.kind === 283 /* JsxElement */ ) {
                    if (position > node.getStart(sourceFile)) return true;
                    node = node.parent;
                } else return false;
            }
            return false;
        }
        return isInsideJsxElementTraversal(getTokenAtPosition(sourceFile, position));
    }
    function findPrecedingMatchingToken(token, matchingTokenKind, sourceFile) {
        const closeTokenText = tokenToString(token.kind);
        const matchingTokenText = tokenToString(matchingTokenKind);
        const tokenFullStart = token.getFullStart();
        const bestGuessIndex = sourceFile.text.lastIndexOf(matchingTokenText, tokenFullStart);
        if (bestGuessIndex === -1) return void 0;
        if (sourceFile.text.lastIndexOf(closeTokenText, tokenFullStart - 1) < bestGuessIndex) {
            const nodeAtGuess = findPrecedingToken(bestGuessIndex + 1, sourceFile);
            if (nodeAtGuess && nodeAtGuess.kind === matchingTokenKind) return nodeAtGuess;
        }
        const tokenKind = token.kind;
        let remainingMatchingTokens = 0;
        while(true){
            const preceding = findPrecedingToken(token.getFullStart(), sourceFile);
            if (!preceding) return void 0;
            token = preceding;
            if (token.kind === matchingTokenKind) {
                if (remainingMatchingTokens === 0) return token;
                remainingMatchingTokens--;
            } else if (token.kind === tokenKind) remainingMatchingTokens++;
        }
    }
    function removeOptionality(type, isOptionalExpression, isOptionalChain2) {
        return isOptionalExpression ? type.getNonNullableType() : isOptionalChain2 ? type.getNonOptionalType() : type;
    }
    function isPossiblyTypeArgumentPosition(token, sourceFile, checker) {
        const info = getPossibleTypeArgumentsInfo(token, sourceFile);
        return info !== void 0 && (isPartOfTypeNode(info.called) || getPossibleGenericSignatures(info.called, info.nTypeArguments, checker).length !== 0 || isPossiblyTypeArgumentPosition(info.called, sourceFile, checker));
    }
    function getPossibleGenericSignatures(called, typeArgumentCount, checker) {
        let type = checker.getTypeAtLocation(called);
        if (isOptionalChain(called.parent)) type = removeOptionality(type, isOptionalChainRoot(called.parent), /*isOptionalChain*/ true);
        const signatures = isNewExpression(called.parent) ? type.getConstructSignatures() : type.getCallSignatures();
        return signatures.filter((candidate)=>!!candidate.typeParameters && candidate.typeParameters.length >= typeArgumentCount);
    }
    function getPossibleTypeArgumentsInfo(tokenIn, sourceFile) {
        if (sourceFile.text.lastIndexOf("<", tokenIn ? tokenIn.pos : sourceFile.text.length) === -1) return void 0;
        let token = tokenIn;
        let remainingLessThanTokens = 0;
        let nTypeArguments = 0;
        while(token){
            switch(token.kind){
                case 30 /* LessThanToken */ :
                    token = findPrecedingToken(token.getFullStart(), sourceFile);
                    if (token && token.kind === 29 /* QuestionDotToken */ ) token = findPrecedingToken(token.getFullStart(), sourceFile);
                    if (!token || !isIdentifier(token)) return void 0;
                    if (!remainingLessThanTokens) return isDeclarationName(token) ? void 0 : {
                        called: token,
                        nTypeArguments: nTypeArguments
                    };
                    remainingLessThanTokens--;
                    break;
                case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                    remainingLessThanTokens = 3;
                    break;
                case 49 /* GreaterThanGreaterThanToken */ :
                    remainingLessThanTokens = 2;
                    break;
                case 32 /* GreaterThanToken */ :
                    remainingLessThanTokens++;
                    break;
                case 20 /* CloseBraceToken */ :
                    token = findPrecedingMatchingToken(token, 19 /* OpenBraceToken */ , sourceFile);
                    if (!token) return void 0;
                    break;
                case 22 /* CloseParenToken */ :
                    token = findPrecedingMatchingToken(token, 21 /* OpenParenToken */ , sourceFile);
                    if (!token) return void 0;
                    break;
                case 24 /* CloseBracketToken */ :
                    token = findPrecedingMatchingToken(token, 23 /* OpenBracketToken */ , sourceFile);
                    if (!token) return void 0;
                    break;
                case 28 /* CommaToken */ :
                    nTypeArguments++;
                    break;
                case 39 /* EqualsGreaterThanToken */ :
                case 80 /* Identifier */ :
                case 11 /* StringLiteral */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 114 /* TypeOfKeyword */ :
                case 96 /* ExtendsKeyword */ :
                case 143 /* KeyOfKeyword */ :
                case 25 /* DotToken */ :
                case 52 /* BarToken */ :
                case 58 /* QuestionToken */ :
                case 59 /* ColonToken */ :
                    break;
                default:
                    if (isTypeNode(token)) break;
                    return void 0;
            }
            token = findPrecedingToken(token.getFullStart(), sourceFile);
        }
        return void 0;
    }
    function isInComment(sourceFile, position, tokenAtPosition) {
        return ts_formatting_exports.getRangeOfEnclosingComment(sourceFile, position, /*precedingToken*/ void 0, tokenAtPosition);
    }
    function hasDocComment(sourceFile, position) {
        const token = getTokenAtPosition(sourceFile, position);
        return !!findAncestor(token, isJSDoc);
    }
    function nodeHasTokens(n, sourceFile) {
        return n.kind === 1 /* EndOfFileToken */  ? !!n.jsDoc : n.getWidth(sourceFile) !== 0;
    }
    function getNodeModifiers(node, excludeFlags = 0 /* None */ ) {
        const result = [];
        const flags = isDeclaration(node) ? getCombinedNodeFlagsAlwaysIncludeJSDoc(node) & ~excludeFlags : 0 /* None */ ;
        if (flags & 8 /* Private */ ) result.push("private" /* privateMemberModifier */ );
        if (flags & 16 /* Protected */ ) result.push("protected" /* protectedMemberModifier */ );
        if (flags & 4 /* Public */ ) result.push("public" /* publicMemberModifier */ );
        if (flags & 32 /* Static */  || isClassStaticBlockDeclaration(node)) result.push("static" /* staticModifier */ );
        if (flags & 256 /* Abstract */ ) result.push("abstract" /* abstractModifier */ );
        if (flags & 1 /* Export */ ) result.push("export" /* exportedModifier */ );
        if (flags & 8192 /* Deprecated */ ) result.push("deprecated" /* deprecatedModifier */ );
        if (node.flags & 16777216 /* Ambient */ ) result.push("declare" /* ambientModifier */ );
        if (node.kind === 276 /* ExportAssignment */ ) result.push("export" /* exportedModifier */ );
        return result.length > 0 ? result.join(",") : "" /* none */ ;
    }
    function getTypeArgumentOrTypeParameterList(node) {
        if (node.kind === 182 /* TypeReference */  || node.kind === 212 /* CallExpression */ ) return node.typeArguments;
        if (isFunctionLike(node) || node.kind === 262 /* ClassDeclaration */  || node.kind === 263 /* InterfaceDeclaration */ ) return node.typeParameters;
        return void 0;
    }
    function isComment(kind) {
        return kind === 2 /* SingleLineCommentTrivia */  || kind === 3 /* MultiLineCommentTrivia */ ;
    }
    function isStringOrRegularExpressionOrTemplateLiteral(kind) {
        if (kind === 11 /* StringLiteral */  || kind === 14 /* RegularExpressionLiteral */  || isTemplateLiteralKind(kind)) return true;
        return false;
    }
    function areIntersectedTypesAvoidingStringReduction(checker, t1, t2) {
        return !!(t1.flags & 4 /* String */ ) && checker.isEmptyAnonymousObjectType(t2);
    }
    function isStringAndEmptyAnonymousObjectIntersection(type) {
        if (!type.isIntersection()) return false;
        const { types: types , checker: checker  } = type;
        return types.length === 2 && (areIntersectedTypesAvoidingStringReduction(checker, types[0], types[1]) || areIntersectedTypesAvoidingStringReduction(checker, types[1], types[0]));
    }
    function isInsideTemplateLiteral(node, position, sourceFile) {
        return isTemplateLiteralKind(node.kind) && node.getStart(sourceFile) < position && position < node.end || !!node.isUnterminated && position === node.end;
    }
    function isAccessibilityModifier(kind) {
        switch(kind){
            case 125 /* PublicKeyword */ :
            case 123 /* PrivateKeyword */ :
            case 124 /* ProtectedKeyword */ :
                return true;
        }
        return false;
    }
    function cloneCompilerOptions(options) {
        const result = clone(options);
        setConfigFileInOptions(result, options && options.configFile);
        return result;
    }
    function isArrayLiteralOrObjectLiteralDestructuringPattern(node) {
        if (node.kind === 208 /* ArrayLiteralExpression */  || node.kind === 209 /* ObjectLiteralExpression */ ) {
            if (node.parent.kind === 225 /* BinaryExpression */  && node.parent.left === node && node.parent.operatorToken.kind === 64 /* EqualsToken */ ) return true;
            if (node.parent.kind === 249 /* ForOfStatement */  && node.parent.initializer === node) return true;
            if (isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent.kind === 302 /* PropertyAssignment */  ? node.parent.parent : node.parent)) return true;
        }
        return false;
    }
    function isInReferenceComment(sourceFile, position) {
        return isInReferenceCommentWorker(sourceFile, position, /*shouldBeReference*/ true);
    }
    function isInNonReferenceComment(sourceFile, position) {
        return isInReferenceCommentWorker(sourceFile, position, /*shouldBeReference*/ false);
    }
    function isInReferenceCommentWorker(sourceFile, position, shouldBeReference) {
        const range = isInComment(sourceFile, position, /*tokenAtPosition*/ void 0);
        return !!range && shouldBeReference === tripleSlashDirectivePrefixRegex.test(sourceFile.text.substring(range.pos, range.end));
    }
    function getReplacementSpanForContextToken(contextToken) {
        if (!contextToken) return void 0;
        switch(contextToken.kind){
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
                return createTextSpanFromStringLiteralLikeContent(contextToken);
            default:
                return createTextSpanFromNode(contextToken);
        }
    }
    function createTextSpanFromNode(node, sourceFile, endNode2) {
        return createTextSpanFromBounds(node.getStart(sourceFile), (endNode2 || node).getEnd());
    }
    function createTextSpanFromStringLiteralLikeContent(node) {
        if (node.isUnterminated) return void 0;
        return createTextSpanFromBounds(node.getStart() + 1, node.getEnd() - 1);
    }
    function createTextRangeFromNode(node, sourceFile) {
        return createRange(node.getStart(sourceFile), node.end);
    }
    function createTextSpanFromRange(range) {
        return createTextSpanFromBounds(range.pos, range.end);
    }
    function createTextRangeFromSpan(span) {
        return createRange(span.start, span.start + span.length);
    }
    function createTextChangeFromStartLength(start, length2, newText) {
        return createTextChange(createTextSpan(start, length2), newText);
    }
    function createTextChange(span, newText) {
        return {
            span: span,
            newText: newText
        };
    }
    function isTypeKeyword(kind) {
        return contains(typeKeywords, kind);
    }
    function isTypeKeywordToken(node) {
        return node.kind === 156 /* TypeKeyword */ ;
    }
    function isTypeKeywordTokenOrIdentifier(node) {
        return isTypeKeywordToken(node) || isIdentifier(node) && node.text === "type";
    }
    function isExternalModuleSymbol(moduleSymbol) {
        return !!(moduleSymbol.flags & 1536 /* Module */ ) && moduleSymbol.name.charCodeAt(0) === 34 /* doubleQuote */ ;
    }
    function nodeSeenTracker() {
        const seen = [];
        return (node)=>{
            const id = getNodeId(node);
            return !seen[id] && (seen[id] = true);
        };
    }
    function getSnapshotText(snap) {
        return snap.getText(0, snap.getLength());
    }
    function repeatString(str, count) {
        let result = "";
        for(let i = 0; i < count; i++)result += str;
        return result;
    }
    function skipConstraint(type) {
        return type.isTypeParameter() ? type.getConstraint() || type : type;
    }
    function getNameFromPropertyName(name) {
        return name.kind === 166 /* ComputedPropertyName */  ? isStringOrNumericLiteralLike(name.expression) ? name.expression.text : void 0 : isPrivateIdentifier(name) ? idText(name) : getTextOfIdentifierOrLiteral(name);
    }
    function programContainsModules(program) {
        return program.getSourceFiles().some((s)=>!s.isDeclarationFile && !program.isSourceFileFromExternalLibrary(s) && !!(s.externalModuleIndicator || s.commonJsModuleIndicator));
    }
    function programContainsEsModules(program) {
        return program.getSourceFiles().some((s)=>!s.isDeclarationFile && !program.isSourceFileFromExternalLibrary(s) && !!s.externalModuleIndicator);
    }
    function compilerOptionsIndicateEsModules(compilerOptions) {
        return !!compilerOptions.module || getEmitScriptTarget(compilerOptions) >= 2 /* ES2015 */  || !!compilerOptions.noEmit;
    }
    function createModuleSpecifierResolutionHost(program, host) {
        return {
            fileExists: (fileName)=>program.fileExists(fileName),
            getCurrentDirectory: ()=>host.getCurrentDirectory(),
            readFile: maybeBind(host, host.readFile),
            useCaseSensitiveFileNames: maybeBind(host, host.useCaseSensitiveFileNames),
            getSymlinkCache: maybeBind(host, host.getSymlinkCache) || program.getSymlinkCache,
            getModuleSpecifierCache: maybeBind(host, host.getModuleSpecifierCache),
            getPackageJsonInfoCache: ()=>{
                var _a;
                return (_a = program.getModuleResolutionCache()) == null ? void 0 : _a.getPackageJsonInfoCache();
            },
            getGlobalTypingsCacheLocation: maybeBind(host, host.getGlobalTypingsCacheLocation),
            redirectTargetsMap: program.redirectTargetsMap,
            getProjectReferenceRedirect: (fileName)=>program.getProjectReferenceRedirect(fileName),
            isSourceOfProjectReferenceRedirect: (fileName)=>program.isSourceOfProjectReferenceRedirect(fileName),
            getNearestAncestorDirectoryWithPackageJson: maybeBind(host, host.getNearestAncestorDirectoryWithPackageJson),
            getFileIncludeReasons: ()=>program.getFileIncludeReasons()
        };
    }
    function getModuleSpecifierResolverHost(program, host) {
        return {
            ...createModuleSpecifierResolutionHost(program, host),
            getCommonSourceDirectory: ()=>program.getCommonSourceDirectory()
        };
    }
    function moduleResolutionUsesNodeModules(moduleResolution) {
        return moduleResolution === 2 /* Node10 */  || moduleResolution >= 3 /* Node16 */  && moduleResolution <= 99 /* NodeNext */  || moduleResolution === 100 /* Bundler */ ;
    }
    function makeImportIfNecessary(defaultImport, namedImports, moduleSpecifier, quotePreference) {
        return defaultImport || namedImports && namedImports.length ? makeImport(defaultImport, namedImports, moduleSpecifier, quotePreference) : void 0;
    }
    function makeImport(defaultImport, namedImports, moduleSpecifier, quotePreference, isTypeOnly) {
        return factory.createImportDeclaration(/*modifiers*/ void 0, defaultImport || namedImports ? factory.createImportClause(!!isTypeOnly, defaultImport, namedImports && namedImports.length ? factory.createNamedImports(namedImports) : void 0) : void 0, typeof moduleSpecifier === "string" ? makeStringLiteral(moduleSpecifier, quotePreference) : moduleSpecifier, /*assertClause*/ void 0);
    }
    function makeStringLiteral(text, quotePreference) {
        return factory.createStringLiteral(text, quotePreference === 0 /* Single */ );
    }
    function quotePreferenceFromString(str, sourceFile) {
        return isStringDoubleQuoted(str, sourceFile) ? 1 /* Double */  : 0 /* Single */ ;
    }
    function getQuotePreference(sourceFile, preferences) {
        if (preferences.quotePreference && preferences.quotePreference !== "auto") return preferences.quotePreference === "single" ? 0 /* Single */  : 1 /* Double */ ;
        else {
            const firstModuleSpecifier = sourceFile.imports && find(sourceFile.imports, (n)=>isStringLiteral(n) && !nodeIsSynthesized(n.parent));
            return firstModuleSpecifier ? quotePreferenceFromString(firstModuleSpecifier, sourceFile) : 1 /* Double */ ;
        }
    }
    function getQuoteFromPreference(qp) {
        switch(qp){
            case 0 /* Single */ :
                return "'";
            case 1 /* Double */ :
                return '"';
            default:
                return Debug.assertNever(qp);
        }
    }
    function symbolNameNoDefault(symbol) {
        const escaped = symbolEscapedNameNoDefault(symbol);
        return escaped === void 0 ? void 0 : unescapeLeadingUnderscores(escaped);
    }
    function symbolEscapedNameNoDefault(symbol) {
        if (symbol.escapedName !== "default" /* Default */ ) return symbol.escapedName;
        return firstDefined(symbol.declarations, (decl)=>{
            const name = getNameOfDeclaration(decl);
            return name && name.kind === 80 /* Identifier */  ? name.escapedText : void 0;
        });
    }
    function isModuleSpecifierLike(node) {
        return isStringLiteralLike(node) && (isExternalModuleReference(node.parent) || isImportDeclaration(node.parent) || isRequireCall(node.parent, /*requireStringLiteralLikeArgument*/ false) && node.parent.arguments[0] === node || isImportCall(node.parent) && node.parent.arguments[0] === node);
    }
    function isObjectBindingElementWithoutPropertyName(bindingElement) {
        return isBindingElement(bindingElement) && isObjectBindingPattern(bindingElement.parent) && isIdentifier(bindingElement.name) && !bindingElement.propertyName;
    }
    function getPropertySymbolFromBindingElement(checker, bindingElement) {
        const typeOfPattern = checker.getTypeAtLocation(bindingElement.parent);
        return typeOfPattern && checker.getPropertyOfType(typeOfPattern, bindingElement.name.text);
    }
    function getParentNodeInSpan(node, file, span) {
        if (!node) return void 0;
        while(node.parent){
            if (isSourceFile(node.parent) || !spanContainsNode(span, node.parent, file)) return node;
            node = node.parent;
        }
    }
    function spanContainsNode(span, node, file) {
        return textSpanContainsPosition(span, node.getStart(file)) && node.getEnd() <= textSpanEnd(span);
    }
    function findModifier(node, kind) {
        return canHaveModifiers(node) ? find(node.modifiers, (m)=>m.kind === kind) : void 0;
    }
    function insertImports(changes, sourceFile, imports, blankLineBetween, preferences) {
        const decl = isArray(imports) ? imports[0] : imports;
        const importKindPredicate = decl.kind === 242 /* VariableStatement */  ? isRequireVariableStatement : isAnyImportSyntax;
        const existingImportStatements = filter(sourceFile.statements, importKindPredicate);
        let sortKind = isArray(imports) ? ts_OrganizeImports_exports.detectImportDeclarationSorting(imports, preferences) : 3 /* Both */ ;
        const comparer = ts_OrganizeImports_exports.getOrganizeImportsComparer(preferences, sortKind === 2 /* CaseInsensitive */ );
        const sortedNewImports = isArray(imports) ? stableSort(imports, (a, b)=>ts_OrganizeImports_exports.compareImportsOrRequireStatements(a, b, comparer)) : [
            imports
        ];
        if (!existingImportStatements.length) changes.insertNodesAtTopOfFile(sourceFile, sortedNewImports, blankLineBetween);
        else if (existingImportStatements && (sortKind = ts_OrganizeImports_exports.detectImportDeclarationSorting(existingImportStatements, preferences))) {
            const comparer2 = ts_OrganizeImports_exports.getOrganizeImportsComparer(preferences, sortKind === 2 /* CaseInsensitive */ );
            for (const newImport of sortedNewImports){
                const insertionIndex = ts_OrganizeImports_exports.getImportDeclarationInsertionIndex(existingImportStatements, newImport, comparer2);
                if (insertionIndex === 0) {
                    const options = existingImportStatements[0] === sourceFile.statements[0] ? {
                        leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude
                    } : {};
                    changes.insertNodeBefore(sourceFile, existingImportStatements[0], newImport, /*blankLineBetween*/ false, options);
                } else {
                    const prevImport = existingImportStatements[insertionIndex - 1];
                    changes.insertNodeAfter(sourceFile, prevImport, newImport);
                }
            }
        } else {
            const lastExistingImport = lastOrUndefined(existingImportStatements);
            if (lastExistingImport) changes.insertNodesAfter(sourceFile, lastExistingImport, sortedNewImports);
            else changes.insertNodesAtTopOfFile(sourceFile, sortedNewImports, blankLineBetween);
        }
    }
    function getTypeKeywordOfTypeOnlyImport(importClause, sourceFile) {
        Debug.assert(importClause.isTypeOnly);
        return cast(importClause.getChildAt(0, sourceFile), isTypeKeywordToken);
    }
    function textSpansEqual(a, b) {
        return !!a && !!b && a.start === b.start && a.length === b.length;
    }
    function documentSpansEqual(a, b) {
        return a.fileName === b.fileName && textSpansEqual(a.textSpan, b.textSpan);
    }
    function forEachUnique(array, callback) {
        if (array) {
            for(let i = 0; i < array.length; i++)if (array.indexOf(array[i]) === i) {
                const result = callback(array[i], i);
                if (result) return result;
            }
        }
        return void 0;
    }
    function isTextWhiteSpaceLike(text, startPos, endPos) {
        for(let i = startPos; i < endPos; i++){
            if (!isWhiteSpaceLike(text.charCodeAt(i))) return false;
        }
        return true;
    }
    function getMappedLocation(location, sourceMapper, fileExists) {
        const mapsTo = sourceMapper.tryGetSourcePosition(location);
        return mapsTo && (!fileExists || fileExists(normalizePath(mapsTo.fileName)) ? mapsTo : void 0);
    }
    function getMappedDocumentSpan(documentSpan, sourceMapper, fileExists) {
        const { fileName: fileName , textSpan: textSpan  } = documentSpan;
        const newPosition = getMappedLocation({
            fileName: fileName,
            pos: textSpan.start
        }, sourceMapper, fileExists);
        if (!newPosition) return void 0;
        const newEndPosition = getMappedLocation({
            fileName: fileName,
            pos: textSpan.start + textSpan.length
        }, sourceMapper, fileExists);
        const newLength = newEndPosition ? newEndPosition.pos - newPosition.pos : textSpan.length;
        return {
            fileName: newPosition.fileName,
            textSpan: {
                start: newPosition.pos,
                length: newLength
            },
            originalFileName: documentSpan.fileName,
            originalTextSpan: documentSpan.textSpan,
            contextSpan: getMappedContextSpan(documentSpan, sourceMapper, fileExists),
            originalContextSpan: documentSpan.contextSpan
        };
    }
    function getMappedContextSpan(documentSpan, sourceMapper, fileExists) {
        const contextSpanStart = documentSpan.contextSpan && getMappedLocation({
            fileName: documentSpan.fileName,
            pos: documentSpan.contextSpan.start
        }, sourceMapper, fileExists);
        const contextSpanEnd = documentSpan.contextSpan && getMappedLocation({
            fileName: documentSpan.fileName,
            pos: documentSpan.contextSpan.start + documentSpan.contextSpan.length
        }, sourceMapper, fileExists);
        return contextSpanStart && contextSpanEnd ? {
            start: contextSpanStart.pos,
            length: contextSpanEnd.pos - contextSpanStart.pos
        } : void 0;
    }
    function isFirstDeclarationOfSymbolParameter(symbol) {
        const declaration = symbol.declarations ? firstOrUndefined(symbol.declarations) : void 0;
        return !!findAncestor(declaration, (n)=>isParameter(n) ? true : isBindingElement(n) || isObjectBindingPattern(n) || isArrayBindingPattern(n) ? false : "quit");
    }
    function getDisplayPartWriter() {
        const absoluteMaximumLength = defaultMaximumTruncationLength * 10;
        let displayParts;
        let lineStart;
        let indent2;
        let length2;
        resetWriter();
        const unknownWrite = (text)=>writeKind(text, 17 /* text */ );
        return {
            displayParts: ()=>{
                const finalText = displayParts.length && displayParts[displayParts.length - 1].text;
                if (length2 > absoluteMaximumLength && finalText && finalText !== "...") {
                    if (!isWhiteSpaceLike(finalText.charCodeAt(finalText.length - 1))) displayParts.push(displayPart(" ", 16 /* space */ ));
                    displayParts.push(displayPart("...", 15 /* punctuation */ ));
                }
                return displayParts;
            },
            writeKeyword: (text)=>writeKind(text, 5 /* keyword */ ),
            writeOperator: (text)=>writeKind(text, 12 /* operator */ ),
            writePunctuation: (text)=>writeKind(text, 15 /* punctuation */ ),
            writeTrailingSemicolon: (text)=>writeKind(text, 15 /* punctuation */ ),
            writeSpace: (text)=>writeKind(text, 16 /* space */ ),
            writeStringLiteral: (text)=>writeKind(text, 8 /* stringLiteral */ ),
            writeParameter: (text)=>writeKind(text, 13 /* parameterName */ ),
            writeProperty: (text)=>writeKind(text, 14 /* propertyName */ ),
            writeLiteral: (text)=>writeKind(text, 8 /* stringLiteral */ ),
            writeSymbol: writeSymbol,
            writeLine: writeLine,
            write: unknownWrite,
            writeComment: unknownWrite,
            getText: ()=>"",
            getTextPos: ()=>0,
            getColumn: ()=>0,
            getLine: ()=>0,
            isAtStartOfLine: ()=>false,
            hasTrailingWhitespace: ()=>false,
            hasTrailingComment: ()=>false,
            rawWrite: notImplemented,
            getIndent: ()=>indent2,
            increaseIndent: ()=>{
                indent2++;
            },
            decreaseIndent: ()=>{
                indent2--;
            },
            clear: resetWriter
        };
        function writeIndent() {
            if (length2 > absoluteMaximumLength) return;
            if (lineStart) {
                const indentString = getIndentString(indent2);
                if (indentString) {
                    length2 += indentString.length;
                    displayParts.push(displayPart(indentString, 16 /* space */ ));
                }
                lineStart = false;
            }
        }
        function writeKind(text, kind) {
            if (length2 > absoluteMaximumLength) return;
            writeIndent();
            length2 += text.length;
            displayParts.push(displayPart(text, kind));
        }
        function writeSymbol(text, symbol) {
            if (length2 > absoluteMaximumLength) return;
            writeIndent();
            length2 += text.length;
            displayParts.push(symbolPart(text, symbol));
        }
        function writeLine() {
            if (length2 > absoluteMaximumLength) return;
            length2 += 1;
            displayParts.push(lineBreakPart());
            lineStart = true;
        }
        function resetWriter() {
            displayParts = [];
            lineStart = true;
            indent2 = 0;
            length2 = 0;
        }
    }
    function symbolPart(text, symbol) {
        return displayPart(text, displayPartKind(symbol));
        function displayPartKind(symbol2) {
            const flags = symbol2.flags;
            if (flags & 3 /* Variable */ ) return isFirstDeclarationOfSymbolParameter(symbol2) ? 13 /* parameterName */  : 9 /* localName */ ;
            if (flags & 4 /* Property */ ) return 14 /* propertyName */ ;
            if (flags & 32768 /* GetAccessor */ ) return 14 /* propertyName */ ;
            if (flags & 65536 /* SetAccessor */ ) return 14 /* propertyName */ ;
            if (flags & 8 /* EnumMember */ ) return 19 /* enumMemberName */ ;
            if (flags & 16 /* Function */ ) return 20 /* functionName */ ;
            if (flags & 32 /* Class */ ) return 1 /* className */ ;
            if (flags & 64 /* Interface */ ) return 4 /* interfaceName */ ;
            if (flags & 384 /* Enum */ ) return 2 /* enumName */ ;
            if (flags & 1536 /* Module */ ) return 11 /* moduleName */ ;
            if (flags & 8192 /* Method */ ) return 10 /* methodName */ ;
            if (flags & 262144 /* TypeParameter */ ) return 18 /* typeParameterName */ ;
            if (flags & 524288 /* TypeAlias */ ) return 0 /* aliasName */ ;
            if (flags & 2097152 /* Alias */ ) return 0 /* aliasName */ ;
            return 17 /* text */ ;
        }
    }
    function displayPart(text, kind) {
        return {
            text: text,
            kind: SymbolDisplayPartKind[kind]
        };
    }
    function spacePart() {
        return displayPart(" ", 16 /* space */ );
    }
    function keywordPart(kind) {
        return displayPart(tokenToString(kind), 5 /* keyword */ );
    }
    function punctuationPart(kind) {
        return displayPart(tokenToString(kind), 15 /* punctuation */ );
    }
    function operatorPart(kind) {
        return displayPart(tokenToString(kind), 12 /* operator */ );
    }
    function parameterNamePart(text) {
        return displayPart(text, 13 /* parameterName */ );
    }
    function propertyNamePart(text) {
        return displayPart(text, 14 /* propertyName */ );
    }
    function textOrKeywordPart(text) {
        const kind = stringToToken(text);
        return kind === void 0 ? textPart(text) : keywordPart(kind);
    }
    function textPart(text) {
        return displayPart(text, 17 /* text */ );
    }
    function typeAliasNamePart(text) {
        return displayPart(text, 0 /* aliasName */ );
    }
    function typeParameterNamePart(text) {
        return displayPart(text, 18 /* typeParameterName */ );
    }
    function linkTextPart(text) {
        return displayPart(text, 24 /* linkText */ );
    }
    function linkNamePart(text, target) {
        return {
            text: text,
            kind: SymbolDisplayPartKind[23 /* linkName */ ],
            target: {
                fileName: getSourceFileOfNode(target).fileName,
                textSpan: createTextSpanFromNode(target)
            }
        };
    }
    function linkPart(text) {
        return displayPart(text, 22 /* link */ );
    }
    function buildLinkParts(link, checker) {
        var _a;
        const prefix = isJSDocLink(link) ? "link" : isJSDocLinkCode(link) ? "linkcode" : "linkplain";
        const parts = [
            linkPart(`{@${prefix} `)
        ];
        if (!link.name) {
            if (link.text) parts.push(linkTextPart(link.text));
        } else {
            const symbol = checker == null ? void 0 : checker.getSymbolAtLocation(link.name);
            const suffix = findLinkNameEnd(link.text);
            const name = getTextOfNode(link.name) + link.text.slice(0, suffix);
            const text = skipSeparatorFromLinkText(link.text.slice(suffix));
            const decl = (symbol == null ? void 0 : symbol.valueDeclaration) || ((_a = symbol == null ? void 0 : symbol.declarations) == null ? void 0 : _a[0]);
            if (decl) {
                parts.push(linkNamePart(name, decl));
                if (text) parts.push(linkTextPart(text));
            } else parts.push(linkTextPart(name + (suffix ? "" : " ") + text));
        }
        parts.push(linkPart("}"));
        return parts;
    }
    function skipSeparatorFromLinkText(text) {
        let pos = 0;
        if (text.charCodeAt(pos++) === 124 /* bar */ ) {
            while(pos < text.length && text.charCodeAt(pos) === 32 /* space */ )pos++;
            return text.slice(pos);
        }
        return text;
    }
    function findLinkNameEnd(text) {
        let pos = text.indexOf("://");
        if (pos === 0) {
            while(pos < text.length && text.charCodeAt(pos) !== 124 /* bar */ )pos++;
            return pos;
        }
        if (text.indexOf("()") === 0) return 2;
        if (text.charAt(0) === "<") {
            let brackets2 = 0;
            let i = 0;
            while(i < text.length){
                if (text[i] === "<") brackets2++;
                if (text[i] === ">") brackets2--;
                i++;
                if (!brackets2) return i;
            }
        }
        return 0;
    }
    function getNewLineOrDefaultFromHost(host, formatSettings) {
        var _a;
        return (formatSettings == null ? void 0 : formatSettings.newLineCharacter) || ((_a = host.getNewLine) == null ? void 0 : _a.call(host)) || lineFeed2;
    }
    function lineBreakPart() {
        return displayPart("\n", 6 /* lineBreak */ );
    }
    function mapToDisplayParts(writeDisplayParts) {
        try {
            writeDisplayParts(displayPartWriter);
            return displayPartWriter.displayParts();
        } finally{
            displayPartWriter.clear();
        }
    }
    function typeToDisplayParts(typechecker, type, enclosingDeclaration, flags = 0 /* None */ ) {
        return mapToDisplayParts((writer)=>{
            typechecker.writeType(type, enclosingDeclaration, flags | 17408 /* UseAliasDefinedOutsideCurrentScope */ , writer);
        });
    }
    function symbolToDisplayParts(typeChecker, symbol, enclosingDeclaration, meaning, flags = 0 /* None */ ) {
        return mapToDisplayParts((writer)=>{
            typeChecker.writeSymbol(symbol, enclosingDeclaration, meaning, flags | 8 /* UseAliasDefinedOutsideCurrentScope */ , writer);
        });
    }
    function signatureToDisplayParts(typechecker, signature, enclosingDeclaration, flags = 0 /* None */ ) {
        flags |= 25632 /* OmitParameterModifiers */ ;
        return mapToDisplayParts((writer)=>{
            typechecker.writeSignature(signature, enclosingDeclaration, flags, /*kind*/ void 0, writer);
        });
    }
    function nodeToDisplayParts(node, enclosingDeclaration) {
        const file = enclosingDeclaration.getSourceFile();
        return mapToDisplayParts((writer)=>{
            const printer = createPrinterWithRemoveCommentsOmitTrailingSemicolon();
            printer.writeNode(4 /* Unspecified */ , node, file, writer);
        });
    }
    function isImportOrExportSpecifierName(location) {
        return !!location.parent && isImportOrExportSpecifier(location.parent) && location.parent.propertyName === location;
    }
    function getScriptKind(fileName, host) {
        return ensureScriptKind(fileName, host.getScriptKind && host.getScriptKind(fileName));
    }
    function getSymbolTarget(symbol, checker) {
        let next = symbol;
        while(isAliasSymbol(next) || isTransientSymbol(next) && next.links.target)if (isTransientSymbol(next) && next.links.target) next = next.links.target;
        else next = skipAlias(next, checker);
        return next;
    }
    function isAliasSymbol(symbol) {
        return (symbol.flags & 2097152 /* Alias */ ) !== 0;
    }
    function getUniqueSymbolId(symbol, checker) {
        return getSymbolId(skipAlias(symbol, checker));
    }
    function getFirstNonSpaceCharacterPosition(text, position) {
        while(isWhiteSpaceLike(text.charCodeAt(position)))position += 1;
        return position;
    }
    function getPrecedingNonSpaceCharacterPosition(text, position) {
        while(position > -1 && isWhiteSpaceSingleLine(text.charCodeAt(position)))position -= 1;
        return position + 1;
    }
    function getSynthesizedDeepClone(node, includeTrivia = true) {
        const clone2 = node && getSynthesizedDeepCloneWorker(node);
        if (clone2 && !includeTrivia) suppressLeadingAndTrailingTrivia(clone2);
        return clone2;
    }
    function getSynthesizedDeepCloneWithReplacements(node, includeTrivia, replaceNode) {
        let clone2 = replaceNode(node);
        if (clone2) setOriginalNode(clone2, node);
        else clone2 = getSynthesizedDeepCloneWorker(node, replaceNode);
        if (clone2 && !includeTrivia) suppressLeadingAndTrailingTrivia(clone2);
        return clone2;
    }
    function getSynthesizedDeepCloneWorker(node, replaceNode) {
        const nodeClone = replaceNode ? (n)=>getSynthesizedDeepCloneWithReplacements(n, /*includeTrivia*/ true, replaceNode) : getSynthesizedDeepClone;
        const nodesClone = replaceNode ? (ns)=>ns && getSynthesizedDeepClonesWithReplacements(ns, /*includeTrivia*/ true, replaceNode) : (ns)=>ns && getSynthesizedDeepClones(ns);
        const visited = visitEachChild(node, nodeClone, nullTransformationContext, nodesClone, nodeClone);
        if (visited === node) {
            const clone2 = isStringLiteral(node) ? setOriginalNode(factory.createStringLiteralFromNode(node), node) : isNumericLiteral(node) ? setOriginalNode(factory.createNumericLiteral(node.text, node.numericLiteralFlags), node) : factory.cloneNode(node);
            return setTextRange(clone2, node);
        }
        visited.parent = void 0;
        return visited;
    }
    function getSynthesizedDeepClones(nodes, includeTrivia = true) {
        if (nodes) {
            const cloned = factory.createNodeArray(nodes.map((n)=>getSynthesizedDeepClone(n, includeTrivia)), nodes.hasTrailingComma);
            setTextRange(cloned, nodes);
            return cloned;
        }
        return nodes;
    }
    function getSynthesizedDeepClonesWithReplacements(nodes, includeTrivia, replaceNode) {
        return factory.createNodeArray(nodes.map((n)=>getSynthesizedDeepCloneWithReplacements(n, includeTrivia, replaceNode)), nodes.hasTrailingComma);
    }
    function suppressLeadingAndTrailingTrivia(node) {
        suppressLeadingTrivia(node);
        suppressTrailingTrivia(node);
    }
    function suppressLeadingTrivia(node) {
        addEmitFlagsRecursively(node, 1024 /* NoLeadingComments */ , getFirstChild);
    }
    function suppressTrailingTrivia(node) {
        addEmitFlagsRecursively(node, 2048 /* NoTrailingComments */ , getLastChild);
    }
    function copyComments(sourceNode, targetNode) {
        const sourceFile = sourceNode.getSourceFile();
        const text = sourceFile.text;
        if (hasLeadingLineBreak(sourceNode, text)) copyLeadingComments(sourceNode, targetNode, sourceFile);
        else copyTrailingAsLeadingComments(sourceNode, targetNode, sourceFile);
        copyTrailingComments(sourceNode, targetNode, sourceFile);
    }
    function hasLeadingLineBreak(node, text) {
        const start = node.getFullStart();
        const end = node.getStart();
        for(let i = start; i < end; i++){
            if (text.charCodeAt(i) === 10 /* lineFeed */ ) return true;
        }
        return false;
    }
    function addEmitFlagsRecursively(node, flag, getChild) {
        addEmitFlags(node, flag);
        const child = getChild(node);
        if (child) addEmitFlagsRecursively(child, flag, getChild);
    }
    function getFirstChild(node) {
        return node.forEachChild((child)=>child);
    }
    function getUniqueName(baseName, sourceFile) {
        let nameText = baseName;
        for(let i = 1; !isFileLevelUniqueName(sourceFile, nameText); i++)nameText = `${baseName}_${i}`;
        return nameText;
    }
    function getRenameLocation(edits, renameFilename, name, preferLastLocation) {
        let delta = 0;
        let lastPos = -1;
        for (const { fileName: fileName , textChanges: textChanges2  } of edits){
            Debug.assert(fileName === renameFilename);
            for (const change of textChanges2){
                const { span: span , newText: newText  } = change;
                const index = indexInTextChange(newText, escapeString(name));
                if (index !== -1) {
                    lastPos = span.start + delta + index;
                    if (!preferLastLocation) return lastPos;
                }
                delta += newText.length - span.length;
            }
        }
        Debug.assert(preferLastLocation);
        Debug.assert(lastPos >= 0);
        return lastPos;
    }
    function copyLeadingComments(sourceNode, targetNode, sourceFile, commentKind, hasTrailingNewLine) {
        forEachLeadingCommentRange(sourceFile.text, sourceNode.pos, getAddCommentsFunction(targetNode, sourceFile, commentKind, hasTrailingNewLine, addSyntheticLeadingComment));
    }
    function copyTrailingComments(sourceNode, targetNode, sourceFile, commentKind, hasTrailingNewLine) {
        forEachTrailingCommentRange(sourceFile.text, sourceNode.end, getAddCommentsFunction(targetNode, sourceFile, commentKind, hasTrailingNewLine, addSyntheticTrailingComment));
    }
    function copyTrailingAsLeadingComments(sourceNode, targetNode, sourceFile, commentKind, hasTrailingNewLine) {
        forEachTrailingCommentRange(sourceFile.text, sourceNode.pos, getAddCommentsFunction(targetNode, sourceFile, commentKind, hasTrailingNewLine, addSyntheticLeadingComment));
    }
    function getAddCommentsFunction(targetNode, sourceFile, commentKind, hasTrailingNewLine, cb) {
        return (pos, end, kind, htnl)=>{
            if (kind === 3 /* MultiLineCommentTrivia */ ) {
                pos += 2;
                end -= 2;
            } else pos += 2;
            cb(targetNode, commentKind || kind, sourceFile.text.slice(pos, end), hasTrailingNewLine !== void 0 ? hasTrailingNewLine : htnl);
        };
    }
    function indexInTextChange(change, name) {
        if (startsWith(change, name)) return 0;
        let idx = change.indexOf(" " + name);
        if (idx === -1) idx = change.indexOf("." + name);
        if (idx === -1) idx = change.indexOf('"' + name);
        return idx === -1 ? -1 : idx + 1;
    }
    function needsParentheses(expression) {
        return isBinaryExpression(expression) && expression.operatorToken.kind === 28 /* CommaToken */  || isObjectLiteralExpression(expression) || isAsExpression(expression) && isObjectLiteralExpression(expression.expression);
    }
    function getContextualTypeFromParent(node, checker, contextFlags) {
        const parent2 = walkUpParenthesizedExpressions(node.parent);
        switch(parent2.kind){
            case 213 /* NewExpression */ :
                return checker.getContextualType(parent2, contextFlags);
            case 225 /* BinaryExpression */ :
                {
                    const { left: left , operatorToken: operatorToken , right: right  } = parent2;
                    return isEqualityOperatorKind(operatorToken.kind) ? checker.getTypeAtLocation(node === right ? left : right) : checker.getContextualType(node, contextFlags);
                }
            case 295 /* CaseClause */ :
                return getSwitchedType(parent2, checker);
            default:
                return checker.getContextualType(node, contextFlags);
        }
    }
    function quote(sourceFile, preferences, text) {
        const quotePreference = getQuotePreference(sourceFile, preferences);
        const quoted = JSON.stringify(text);
        return quotePreference === 0 /* Single */  ? `'${stripQuotes(quoted).replace(/'/g, "\\'").replace(/\\"/g, '"')}'` : quoted;
    }
    function isEqualityOperatorKind(kind) {
        switch(kind){
            case 37 /* EqualsEqualsEqualsToken */ :
            case 35 /* EqualsEqualsToken */ :
            case 38 /* ExclamationEqualsEqualsToken */ :
            case 36 /* ExclamationEqualsToken */ :
                return true;
            default:
                return false;
        }
    }
    function isStringLiteralOrTemplate(node) {
        switch(node.kind){
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 227 /* TemplateExpression */ :
            case 214 /* TaggedTemplateExpression */ :
                return true;
            default:
                return false;
        }
    }
    function hasIndexSignature(type) {
        return !!type.getStringIndexType() || !!type.getNumberIndexType();
    }
    function getSwitchedType(caseClause, checker) {
        return checker.getTypeAtLocation(caseClause.parent.parent.expression);
    }
    function getTypeNodeIfAccessible(type, enclosingScope, program, host) {
        const checker = program.getTypeChecker();
        let typeIsAccessible = true;
        const notAccessible = ()=>typeIsAccessible = false;
        const res = checker.typeToTypeNode(type, enclosingScope, 1 /* NoTruncation */ , {
            trackSymbol: (symbol, declaration, meaning)=>{
                typeIsAccessible = typeIsAccessible && checker.isSymbolAccessible(symbol, declaration, meaning, /*shouldComputeAliasToMarkVisible*/ false).accessibility === 0 /* Accessible */ ;
                return !typeIsAccessible;
            },
            reportInaccessibleThisError: notAccessible,
            reportPrivateInBaseOfClassExpression: notAccessible,
            reportInaccessibleUniqueSymbolError: notAccessible,
            moduleResolverHost: getModuleSpecifierResolverHost(program, host)
        });
        return typeIsAccessible ? res : void 0;
    }
    function syntaxRequiresTrailingCommaOrSemicolonOrASI(kind) {
        return kind === 178 /* CallSignature */  || kind === 179 /* ConstructSignature */  || kind === 180 /* IndexSignature */  || kind === 170 /* PropertySignature */  || kind === 172 /* MethodSignature */ ;
    }
    function syntaxRequiresTrailingFunctionBlockOrSemicolonOrASI(kind) {
        return kind === 261 /* FunctionDeclaration */  || kind === 175 /* Constructor */  || kind === 173 /* MethodDeclaration */  || kind === 176 /* GetAccessor */  || kind === 177 /* SetAccessor */ ;
    }
    function syntaxRequiresTrailingModuleBlockOrSemicolonOrASI(kind) {
        return kind === 266 /* ModuleDeclaration */ ;
    }
    function syntaxRequiresTrailingSemicolonOrASI(kind) {
        return kind === 242 /* VariableStatement */  || kind === 243 /* ExpressionStatement */  || kind === 245 /* DoStatement */  || kind === 250 /* ContinueStatement */  || kind === 251 /* BreakStatement */  || kind === 252 /* ReturnStatement */  || kind === 256 /* ThrowStatement */  || kind === 258 /* DebuggerStatement */  || kind === 171 /* PropertyDeclaration */  || kind === 264 /* TypeAliasDeclaration */  || kind === 271 /* ImportDeclaration */  || kind === 270 /* ImportEqualsDeclaration */  || kind === 277 /* ExportDeclaration */  || kind === 269 /* NamespaceExportDeclaration */  || kind === 276 /* ExportAssignment */ ;
    }
    function nodeIsASICandidate(node, sourceFile) {
        const lastToken = node.getLastToken(sourceFile);
        if (lastToken && lastToken.kind === 27 /* SemicolonToken */ ) return false;
        if (syntaxRequiresTrailingCommaOrSemicolonOrASI(node.kind)) {
            if (lastToken && lastToken.kind === 28 /* CommaToken */ ) return false;
        } else if (syntaxRequiresTrailingModuleBlockOrSemicolonOrASI(node.kind)) {
            const lastChild = last(node.getChildren(sourceFile));
            if (lastChild && isModuleBlock(lastChild)) return false;
        } else if (syntaxRequiresTrailingFunctionBlockOrSemicolonOrASI(node.kind)) {
            const lastChild = last(node.getChildren(sourceFile));
            if (lastChild && isFunctionBlock(lastChild)) return false;
        } else if (!syntaxRequiresTrailingSemicolonOrASI(node.kind)) return false;
        if (node.kind === 245 /* DoStatement */ ) return true;
        const topNode = findAncestor(node, (ancestor)=>!ancestor.parent);
        const nextToken = findNextToken(node, topNode, sourceFile);
        if (!nextToken || nextToken.kind === 20 /* CloseBraceToken */ ) return true;
        const startLine = sourceFile.getLineAndCharacterOfPosition(node.getEnd()).line;
        const endLine = sourceFile.getLineAndCharacterOfPosition(nextToken.getStart(sourceFile)).line;
        return startLine !== endLine;
    }
    function positionIsASICandidate(pos, context, sourceFile) {
        const contextAncestor = findAncestor(context, (ancestor)=>{
            if (ancestor.end !== pos) return "quit";
            return syntaxMayBeASICandidate(ancestor.kind);
        });
        return !!contextAncestor && nodeIsASICandidate(contextAncestor, sourceFile);
    }
    function probablyUsesSemicolons(sourceFile) {
        let withSemicolon = 0;
        let withoutSemicolon = 0;
        const nStatementsToObserve = 5;
        forEachChild(sourceFile, function visit(node) {
            if (syntaxRequiresTrailingSemicolonOrASI(node.kind)) {
                const lastToken = node.getLastToken(sourceFile);
                if ((lastToken == null ? void 0 : lastToken.kind) === 27 /* SemicolonToken */ ) withSemicolon++;
                else withoutSemicolon++;
            } else if (syntaxRequiresTrailingCommaOrSemicolonOrASI(node.kind)) {
                const lastToken = node.getLastToken(sourceFile);
                if ((lastToken == null ? void 0 : lastToken.kind) === 27 /* SemicolonToken */ ) withSemicolon++;
                else if (lastToken && lastToken.kind !== 28 /* CommaToken */ ) {
                    const lastTokenLine = getLineAndCharacterOfPosition(sourceFile, lastToken.getStart(sourceFile)).line;
                    const nextTokenLine = getLineAndCharacterOfPosition(sourceFile, getSpanOfTokenAtPosition(sourceFile, lastToken.end).start).line;
                    if (lastTokenLine !== nextTokenLine) withoutSemicolon++;
                }
            }
            if (withSemicolon + withoutSemicolon >= nStatementsToObserve) return true;
            return forEachChild(node, visit);
        });
        if (withSemicolon === 0 && withoutSemicolon <= 1) return true;
        return withSemicolon / withoutSemicolon > 1 / nStatementsToObserve;
    }
    function tryGetDirectories(host, directoryName) {
        return tryIOAndConsumeErrors(host, host.getDirectories, directoryName) || [];
    }
    function tryReadDirectory(host, path, extensions, exclude, include) {
        return tryIOAndConsumeErrors(host, host.readDirectory, path, extensions, exclude, include) || emptyArray;
    }
    function tryFileExists(host, path) {
        return tryIOAndConsumeErrors(host, host.fileExists, path);
    }
    function tryDirectoryExists(host, path) {
        return tryAndIgnoreErrors(()=>directoryProbablyExists(path, host)) || false;
    }
    function tryAndIgnoreErrors(cb) {
        try {
            return cb();
        } catch  {
            return void 0;
        }
    }
    function tryIOAndConsumeErrors(host, toApply, ...args) {
        return tryAndIgnoreErrors(()=>toApply && toApply.apply(host, args));
    }
    function findPackageJsons(startDirectory, host, stopDirectory) {
        const paths = [];
        forEachAncestorDirectory(startDirectory, (ancestor)=>{
            if (ancestor === stopDirectory) return true;
            const currentConfigPath = combinePaths(ancestor, "package.json");
            if (tryFileExists(host, currentConfigPath)) paths.push(currentConfigPath);
        });
        return paths;
    }
    function findPackageJson(directory, host) {
        let packageJson;
        forEachAncestorDirectory(directory, (ancestor)=>{
            if (ancestor === "node_modules") return true;
            packageJson = findConfigFile(ancestor, (f)=>tryFileExists(host, f), "package.json");
            if (packageJson) return true;
        });
        return packageJson;
    }
    function getPackageJsonsVisibleToFile(fileName, host) {
        if (!host.fileExists) return [];
        const packageJsons = [];
        forEachAncestorDirectory(getDirectoryPath(fileName), (ancestor)=>{
            const packageJsonFileName = combinePaths(ancestor, "package.json");
            if (host.fileExists(packageJsonFileName)) {
                const info = createPackageJsonInfo(packageJsonFileName, host);
                if (info) packageJsons.push(info);
            }
        });
        return packageJsons;
    }
    function createPackageJsonInfo(fileName, host) {
        if (!host.readFile) return void 0;
        const dependencyKeys = [
            "dependencies",
            "devDependencies",
            "optionalDependencies",
            "peerDependencies"
        ];
        const stringContent = host.readFile(fileName) || "";
        const content = tryParseJson(stringContent);
        const info = {};
        if (content) for (const key of dependencyKeys){
            const dependencies = content[key];
            if (!dependencies) continue;
            const dependencyMap = /* @__PURE__ */ new Map();
            for(const packageName in dependencies)dependencyMap.set(packageName, dependencies[packageName]);
            info[key] = dependencyMap;
        }
        const dependencyGroups = [
            [
                1 /* Dependencies */ ,
                info.dependencies
            ],
            [
                2 /* DevDependencies */ ,
                info.devDependencies
            ],
            [
                8 /* OptionalDependencies */ ,
                info.optionalDependencies
            ],
            [
                4 /* PeerDependencies */ ,
                info.peerDependencies
            ]
        ];
        return {
            ...info,
            parseable: !!content,
            fileName: fileName,
            get: get,
            has (dependencyName, inGroups) {
                return !!get(dependencyName, inGroups);
            }
        };
        function get(dependencyName, inGroups = 15 /* All */ ) {
            for (const [group2, deps] of dependencyGroups)if (deps && inGroups & group2) {
                const dep = deps.get(dependencyName);
                if (dep !== void 0) return dep;
            }
        }
    }
    function createPackageJsonImportFilter(fromFile, preferences, host) {
        const packageJsons = (host.getPackageJsonsVisibleToFile && host.getPackageJsonsVisibleToFile(fromFile.fileName) || getPackageJsonsVisibleToFile(fromFile.fileName, host)).filter((p)=>p.parseable);
        let usesNodeCoreModules;
        let ambientModuleCache;
        let sourceFileCache;
        return {
            allowsImportingAmbientModule: allowsImportingAmbientModule,
            allowsImportingSourceFile: allowsImportingSourceFile,
            allowsImportingSpecifier: allowsImportingSpecifier
        };
        function moduleSpecifierIsCoveredByPackageJson(specifier) {
            const packageName = getNodeModuleRootSpecifier(specifier);
            for (const packageJson of packageJsons){
                if (packageJson.has(packageName) || packageJson.has(getTypesPackageName(packageName))) return true;
            }
            return false;
        }
        function allowsImportingAmbientModule(moduleSymbol, moduleSpecifierResolutionHost) {
            if (!packageJsons.length || !moduleSymbol.valueDeclaration) return true;
            if (!ambientModuleCache) ambientModuleCache = /* @__PURE__ */ new Map();
            else {
                const cached = ambientModuleCache.get(moduleSymbol);
                if (cached !== void 0) return cached;
            }
            const declaredModuleSpecifier = stripQuotes(moduleSymbol.getName());
            if (isAllowedCoreNodeModulesImport(declaredModuleSpecifier)) {
                ambientModuleCache.set(moduleSymbol, true);
                return true;
            }
            const declaringSourceFile = moduleSymbol.valueDeclaration.getSourceFile();
            const declaringNodeModuleName = getNodeModulesPackageNameFromFileName(declaringSourceFile.fileName, moduleSpecifierResolutionHost);
            if (typeof declaringNodeModuleName === "undefined") {
                ambientModuleCache.set(moduleSymbol, true);
                return true;
            }
            const result = moduleSpecifierIsCoveredByPackageJson(declaringNodeModuleName) || moduleSpecifierIsCoveredByPackageJson(declaredModuleSpecifier);
            ambientModuleCache.set(moduleSymbol, result);
            return result;
        }
        function allowsImportingSourceFile(sourceFile, moduleSpecifierResolutionHost) {
            if (!packageJsons.length) return true;
            if (!sourceFileCache) sourceFileCache = /* @__PURE__ */ new Map();
            else {
                const cached = sourceFileCache.get(sourceFile);
                if (cached !== void 0) return cached;
            }
            const moduleSpecifier = getNodeModulesPackageNameFromFileName(sourceFile.fileName, moduleSpecifierResolutionHost);
            if (!moduleSpecifier) {
                sourceFileCache.set(sourceFile, true);
                return true;
            }
            const result = moduleSpecifierIsCoveredByPackageJson(moduleSpecifier);
            sourceFileCache.set(sourceFile, result);
            return result;
        }
        function allowsImportingSpecifier(moduleSpecifier) {
            if (!packageJsons.length || isAllowedCoreNodeModulesImport(moduleSpecifier)) return true;
            if (pathIsRelative(moduleSpecifier) || isRootedDiskPath(moduleSpecifier)) return true;
            return moduleSpecifierIsCoveredByPackageJson(moduleSpecifier);
        }
        function isAllowedCoreNodeModulesImport(moduleSpecifier) {
            if (isSourceFileJS(fromFile) && ts_JsTyping_exports.nodeCoreModules.has(moduleSpecifier)) {
                if (usesNodeCoreModules === void 0) usesNodeCoreModules = consumesNodeCoreModules(fromFile);
                if (usesNodeCoreModules) return true;
            }
            return false;
        }
        function getNodeModulesPackageNameFromFileName(importedFileName, moduleSpecifierResolutionHost) {
            if (!stringContains(importedFileName, "node_modules")) return void 0;
            const specifier = ts_moduleSpecifiers_exports.getNodeModulesPackageName(host.getCompilationSettings(), fromFile, importedFileName, moduleSpecifierResolutionHost, preferences);
            if (!specifier) return void 0;
            if (!pathIsRelative(specifier) && !isRootedDiskPath(specifier)) return getNodeModuleRootSpecifier(specifier);
        }
        function getNodeModuleRootSpecifier(fullSpecifier) {
            const components = getPathComponents(getPackageNameFromTypesPackageName(fullSpecifier)).slice(1);
            if (startsWith(components[0], "@")) return `${components[0]}/${components[1]}`;
            return components[0];
        }
    }
    function tryParseJson(text) {
        try {
            return JSON.parse(text);
        } catch  {
            return void 0;
        }
    }
    function consumesNodeCoreModules(sourceFile) {
        return some(sourceFile.imports, ({ text: text  })=>ts_JsTyping_exports.nodeCoreModules.has(text));
    }
    function isInsideNodeModules(fileOrDirectory) {
        return contains(getPathComponents(fileOrDirectory), "node_modules");
    }
    function isDiagnosticWithLocation(diagnostic) {
        return diagnostic.file !== void 0 && diagnostic.start !== void 0 && diagnostic.length !== void 0;
    }
    function findDiagnosticForNode(node, sortedFileDiagnostics) {
        const span = createTextSpanFromNode(node);
        const index = binarySearchKey(sortedFileDiagnostics, span, identity, compareTextSpans);
        if (index >= 0) {
            const diagnostic = sortedFileDiagnostics[index];
            Debug.assertEqual(diagnostic.file, node.getSourceFile(), "Diagnostics proided to 'findDiagnosticForNode' must be from a single SourceFile");
            return cast(diagnostic, isDiagnosticWithLocation);
        }
    }
    function getDiagnosticsWithinSpan(span, sortedFileDiagnostics) {
        var _a;
        let index = binarySearchKey(sortedFileDiagnostics, span.start, (diag2)=>diag2.start, compareValues);
        if (index < 0) index = ~index;
        while(((_a = sortedFileDiagnostics[index - 1]) == null ? void 0 : _a.start) === span.start)index--;
        const result = [];
        const end = textSpanEnd(span);
        while(true){
            const diagnostic = tryCast(sortedFileDiagnostics[index], isDiagnosticWithLocation);
            if (!diagnostic || diagnostic.start > end) break;
            if (textSpanContainsTextSpan(span, diagnostic)) result.push(diagnostic);
            index++;
        }
        return result;
    }
    function getRefactorContextSpan({ startPosition: startPosition , endPosition: endPosition  }) {
        return createTextSpanFromBounds(startPosition, endPosition === void 0 ? startPosition : endPosition);
    }
    function getFixableErrorSpanExpression(sourceFile, span) {
        const token = getTokenAtPosition(sourceFile, span.start);
        const expression = findAncestor(token, (node)=>{
            if (node.getStart(sourceFile) < span.start || node.getEnd() > textSpanEnd(span)) return "quit";
            return isExpression(node) && textSpansEqual(span, createTextSpanFromNode(node, sourceFile));
        });
        return expression;
    }
    function mapOneOrMany(valueOrArray, f, resultSelector = identity) {
        return valueOrArray ? isArray(valueOrArray) ? resultSelector(map(valueOrArray, f)) : f(valueOrArray, 0) : void 0;
    }
    function firstOrOnly(valueOrArray) {
        return isArray(valueOrArray) ? first(valueOrArray) : valueOrArray;
    }
    function getNamesForExportedSymbol(symbol, scriptTarget) {
        if (needsNameFromDeclaration(symbol)) {
            const fromDeclaration = getDefaultLikeExportNameFromDeclaration(symbol);
            if (fromDeclaration) return fromDeclaration;
            const fileNameCase = ts_codefix_exports.moduleSymbolToValidIdentifier(getSymbolParentOrFail(symbol), scriptTarget, /*forceCapitalize*/ false);
            const capitalized = ts_codefix_exports.moduleSymbolToValidIdentifier(getSymbolParentOrFail(symbol), scriptTarget, /*forceCapitalize*/ true);
            if (fileNameCase === capitalized) return fileNameCase;
            return [
                fileNameCase,
                capitalized
            ];
        }
        return symbol.name;
    }
    function getNameForExportedSymbol(symbol, scriptTarget, preferCapitalized) {
        if (needsNameFromDeclaration(symbol)) return getDefaultLikeExportNameFromDeclaration(symbol) || ts_codefix_exports.moduleSymbolToValidIdentifier(getSymbolParentOrFail(symbol), scriptTarget, !!preferCapitalized);
        return symbol.name;
    }
    function needsNameFromDeclaration(symbol) {
        return !(symbol.flags & 33554432 /* Transient */ ) && (symbol.escapedName === "export=" /* ExportEquals */  || symbol.escapedName === "default" /* Default */ );
    }
    function getDefaultLikeExportNameFromDeclaration(symbol) {
        return firstDefined(symbol.declarations, (d)=>{
            var _a, _b;
            return isExportAssignment(d) ? (_a = tryCast(skipOuterExpressions(d.expression), isIdentifier)) == null ? void 0 : _a.text : (_b = tryCast(getNameOfDeclaration(d), isIdentifier)) == null ? void 0 : _b.text;
        });
    }
    function getSymbolParentOrFail(symbol) {
        var _a;
        return Debug.checkDefined(symbol.parent, `Symbol parent was undefined. Flags: ${Debug.formatSymbolFlags(symbol.flags)}. Declarations: ${(_a = symbol.declarations) == null ? void 0 : _a.map((d)=>{
            const kind = Debug.formatSyntaxKind(d.kind);
            const inJS = isInJSFile(d);
            const { expression: expression  } = d;
            return (inJS ? "[JS]" : "") + kind + (expression ? ` (expression: ${Debug.formatSyntaxKind(expression.kind)})` : "");
        }).join(", ")}.`);
    }
    function stringContainsAt(haystack, needle, startIndex) {
        const needleLength = needle.length;
        if (needleLength + startIndex > haystack.length) return false;
        for(let i = 0; i < needleLength; i++){
            if (needle.charCodeAt(i) !== haystack.charCodeAt(i + startIndex)) return false;
        }
        return true;
    }
    function startsWithUnderscore(name) {
        return name.charCodeAt(0) === 95 /* _ */ ;
    }
    function isGlobalDeclaration(declaration) {
        return !isNonGlobalDeclaration(declaration);
    }
    function isNonGlobalDeclaration(declaration) {
        const sourceFile = declaration.getSourceFile();
        if (!sourceFile.externalModuleIndicator && !sourceFile.commonJsModuleIndicator) return false;
        return isInJSFile(declaration) || !findAncestor(declaration, (d)=>isModuleDeclaration(d) && isGlobalScopeAugmentation(d));
    }
    function isDeprecatedDeclaration(decl) {
        return !!(getCombinedNodeFlagsAlwaysIncludeJSDoc(decl) & 8192 /* Deprecated */ );
    }
    function shouldUseUriStyleNodeCoreModules(file, program) {
        const decisionFromFile = firstDefined(file.imports, (node)=>{
            if (ts_JsTyping_exports.nodeCoreModules.has(node.text)) return startsWith(node.text, "node:");
        });
        return decisionFromFile ?? program.usesUriStyleNodeCoreModules;
    }
    function getNewLineKind(newLineCharacter) {
        return newLineCharacter === "\n" ? 1 /* LineFeed */  : 0 /* CarriageReturnLineFeed */ ;
    }
    function diagnosticToString(diag2) {
        return isArray(diag2) ? formatStringFromArgs(getLocaleSpecificMessage(diag2[0]), diag2.slice(1)) : getLocaleSpecificMessage(diag2);
    }
    function getFormatCodeSettingsForWriting({ options: options  }, sourceFile) {
        const shouldAutoDetectSemicolonPreference = !options.semicolons || options.semicolons === "ignore" /* Ignore */ ;
        const shouldRemoveSemicolons = options.semicolons === "remove" /* Remove */  || shouldAutoDetectSemicolonPreference && !probablyUsesSemicolons(sourceFile);
        return {
            ...options,
            semicolons: shouldRemoveSemicolons ? "remove" /* Remove */  : "ignore" /* Ignore */ 
        };
    }
    function jsxModeNeedsExplicitImport(jsx) {
        return jsx === 2 /* React */  || jsx === 3 /* ReactNative */ ;
    }
    function isSourceFileFromLibrary(program, node) {
        return program.isSourceFileFromExternalLibrary(node) || program.isSourceFileDefaultLibrary(node);
    }
    function newCaseClauseTracker(checker, clauses) {
        const existingStrings = /* @__PURE__ */ new Set();
        const existingNumbers = /* @__PURE__ */ new Set();
        const existingBigInts = /* @__PURE__ */ new Set();
        for (const clause of clauses)if (!isDefaultClause(clause)) {
            const expression = skipParentheses(clause.expression);
            if (isLiteralExpression(expression)) switch(expression.kind){
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 11 /* StringLiteral */ :
                    existingStrings.add(expression.text);
                    break;
                case 9 /* NumericLiteral */ :
                    existingNumbers.add(parseInt(expression.text));
                    break;
                case 10 /* BigIntLiteral */ :
                    const parsedBigInt = parseBigInt(endsWith(expression.text, "n") ? expression.text.slice(0, -1) : expression.text);
                    if (parsedBigInt) existingBigInts.add(pseudoBigIntToString(parsedBigInt));
                    break;
            }
            else {
                const symbol = checker.getSymbolAtLocation(clause.expression);
                if (symbol && symbol.valueDeclaration && isEnumMember(symbol.valueDeclaration)) {
                    const enumValue = checker.getConstantValue(symbol.valueDeclaration);
                    if (enumValue !== void 0) addValue(enumValue);
                }
            }
        }
        return {
            addValue: addValue,
            hasValue: hasValue
        };
        function addValue(value1) {
            switch(typeof value1){
                case "string":
                    existingStrings.add(value1);
                    break;
                case "number":
                    existingNumbers.add(value1);
            }
        }
        function hasValue(value1) {
            switch(typeof value1){
                case "string":
                    return existingStrings.has(value1);
                case "number":
                    return existingNumbers.has(value1);
                case "object":
                    return existingBigInts.has(pseudoBigIntToString(value1));
            }
        }
    }
    function fileShouldUseJavaScriptRequire(file, program, host, preferRequire) {
        var _a;
        const fileName = typeof file === "string" ? file : file.fileName;
        if (!hasJSFileExtension(fileName)) return false;
        const compilerOptions = program.getCompilerOptions();
        const moduleKind = getEmitModuleKind(compilerOptions);
        const impliedNodeFormat = typeof file === "string" ? getImpliedNodeFormatForFile(toPath(file, host.getCurrentDirectory(), hostGetCanonicalFileName(host)), (_a = program.getPackageJsonInfoCache) == null ? void 0 : _a.call(program), host, compilerOptions) : file.impliedNodeFormat;
        if (impliedNodeFormat === 99 /* ESNext */ ) return false;
        if (impliedNodeFormat === 1 /* CommonJS */ ) return true;
        if (compilerOptions.verbatimModuleSyntax && moduleKind === 1 /* CommonJS */ ) return true;
        if (compilerOptions.verbatimModuleSyntax && emitModuleKindIsNonNodeESM(moduleKind)) return false;
        if (typeof file === "object") {
            if (file.commonJsModuleIndicator) return true;
            if (file.externalModuleIndicator) return false;
        }
        return preferRequire;
    }
    var scanner, SemanticMeaning, tripleSlashDirectivePrefixRegex, typeKeywords, QuotePreference, displayPartWriter, lineFeed2, ANONYMOUS, syntaxMayBeASICandidate;
    var init_utilities4 = __esm({
        "src/services/utilities.ts" () {
            "use strict";
            init_ts4();
            scanner = createScanner(99 /* Latest */ , /*skipTrivia*/ true);
            SemanticMeaning = /* @__PURE__ */ ((SemanticMeaning3)=>{
                SemanticMeaning3[SemanticMeaning3["None"] = 0] = "None";
                SemanticMeaning3[SemanticMeaning3["Value"] = 1] = "Value";
                SemanticMeaning3[SemanticMeaning3["Type"] = 2] = "Type";
                SemanticMeaning3[SemanticMeaning3["Namespace"] = 4] = "Namespace";
                SemanticMeaning3[SemanticMeaning3["All"] = 7] = "All";
                return SemanticMeaning3;
            })(SemanticMeaning || {});
            tripleSlashDirectivePrefixRegex = /^\/\/\/\s*</;
            typeKeywords = [
                133 /* AnyKeyword */ ,
                131 /* AssertsKeyword */ ,
                162 /* BigIntKeyword */ ,
                136 /* BooleanKeyword */ ,
                97 /* FalseKeyword */ ,
                140 /* InferKeyword */ ,
                143 /* KeyOfKeyword */ ,
                146 /* NeverKeyword */ ,
                106 /* NullKeyword */ ,
                150 /* NumberKeyword */ ,
                151 /* ObjectKeyword */ ,
                148 /* ReadonlyKeyword */ ,
                154 /* StringKeyword */ ,
                155 /* SymbolKeyword */ ,
                114 /* TypeOfKeyword */ ,
                112 /* TrueKeyword */ ,
                116 /* VoidKeyword */ ,
                157 /* UndefinedKeyword */ ,
                158 /* UniqueKeyword */ ,
                159 /* UnknownKeyword */ 
            ];
            QuotePreference = /* @__PURE__ */ ((QuotePreference7)=>{
                QuotePreference7[QuotePreference7["Single"] = 0] = "Single";
                QuotePreference7[QuotePreference7["Double"] = 1] = "Double";
                return QuotePreference7;
            })(QuotePreference || {});
            displayPartWriter = getDisplayPartWriter();
            lineFeed2 = "\n";
            ANONYMOUS = "anonymous function";
            syntaxMayBeASICandidate = or(syntaxRequiresTrailingCommaOrSemicolonOrASI, syntaxRequiresTrailingFunctionBlockOrSemicolonOrASI, syntaxRequiresTrailingModuleBlockOrSemicolonOrASI, syntaxRequiresTrailingSemicolonOrASI);
        }
    });
    // src/services/exportInfoMap.ts
    function createCacheableExportInfoMap(host) {
        let exportInfoId = 1;
        const exportInfo = createMultiMap();
        const symbols = /* @__PURE__ */ new Map();
        const packages = /* @__PURE__ */ new Map();
        let usableByFileName;
        const cache = {
            isUsableByFile: (importingFile)=>importingFile === usableByFileName,
            isEmpty: ()=>!exportInfo.size,
            clear: ()=>{
                exportInfo.clear();
                symbols.clear();
                usableByFileName = void 0;
            },
            add: (importingFile, symbol, symbolTableKey, moduleSymbol, moduleFile, exportKind, isFromPackageJson, checker)=>{
                if (importingFile !== usableByFileName) {
                    cache.clear();
                    usableByFileName = importingFile;
                }
                let packageName;
                if (moduleFile) {
                    const nodeModulesPathParts = getNodeModulePathParts(moduleFile.fileName);
                    if (nodeModulesPathParts) {
                        const { topLevelNodeModulesIndex: topLevelNodeModulesIndex , topLevelPackageNameIndex: topLevelPackageNameIndex , packageRootIndex: packageRootIndex  } = nodeModulesPathParts;
                        packageName = unmangleScopedPackageName(getPackageNameFromTypesPackageName(moduleFile.fileName.substring(topLevelPackageNameIndex + 1, packageRootIndex)));
                        if (startsWith(importingFile, moduleFile.path.substring(0, topLevelNodeModulesIndex))) {
                            const prevDeepestNodeModulesPath = packages.get(packageName);
                            const nodeModulesPath = moduleFile.fileName.substring(0, topLevelPackageNameIndex + 1);
                            if (prevDeepestNodeModulesPath) {
                                const prevDeepestNodeModulesIndex = prevDeepestNodeModulesPath.indexOf(nodeModulesPathPart);
                                if (topLevelNodeModulesIndex > prevDeepestNodeModulesIndex) packages.set(packageName, nodeModulesPath);
                            } else packages.set(packageName, nodeModulesPath);
                        }
                    }
                }
                const isDefault = exportKind === 1 /* Default */ ;
                const namedSymbol = isDefault && getLocalSymbolForExportDefault(symbol) || symbol;
                const names = exportKind === 0 /* Named */  || isExternalModuleSymbol(namedSymbol) ? unescapeLeadingUnderscores(symbolTableKey) : getNamesForExportedSymbol(namedSymbol, /*scriptTarget*/ void 0);
                const symbolName2 = typeof names === "string" ? names : names[0];
                const capitalizedSymbolName = typeof names === "string" ? void 0 : names[1];
                const moduleName = stripQuotes(moduleSymbol.name);
                const id = exportInfoId++;
                const target = skipAlias(symbol, checker);
                const storedSymbol = symbol.flags & 33554432 /* Transient */  ? void 0 : symbol;
                const storedModuleSymbol = moduleSymbol.flags & 33554432 /* Transient */  ? void 0 : moduleSymbol;
                if (!storedSymbol || !storedModuleSymbol) symbols.set(id, [
                    symbol,
                    moduleSymbol
                ]);
                exportInfo.add(key(symbolName2, symbol, isExternalModuleNameRelative(moduleName) ? void 0 : moduleName, checker), {
                    id: id,
                    symbolTableKey: symbolTableKey,
                    symbolName: symbolName2,
                    capitalizedSymbolName: capitalizedSymbolName,
                    moduleName: moduleName,
                    moduleFile: moduleFile,
                    moduleFileName: moduleFile == null ? void 0 : moduleFile.fileName,
                    packageName: packageName,
                    exportKind: exportKind,
                    targetFlags: target.flags,
                    isFromPackageJson: isFromPackageJson,
                    symbol: storedSymbol,
                    moduleSymbol: storedModuleSymbol
                });
            },
            get: (importingFile, key2)=>{
                if (importingFile !== usableByFileName) return;
                const result = exportInfo.get(key2);
                return result == null ? void 0 : result.map(rehydrateCachedInfo);
            },
            search: (importingFile, preferCapitalized, matches, action)=>{
                if (importingFile !== usableByFileName) return;
                return forEachEntry(exportInfo, (info, key2)=>{
                    const { symbolName: symbolName2 , ambientModuleName: ambientModuleName  } = parseKey(key2);
                    const name = preferCapitalized && info[0].capitalizedSymbolName || symbolName2;
                    if (matches(name, info[0].targetFlags)) {
                        const rehydrated = info.map(rehydrateCachedInfo);
                        const filtered = rehydrated.filter((r, i)=>isNotShadowedByDeeperNodeModulesPackage(r, info[i].packageName));
                        if (filtered.length) {
                            const res = action(filtered, name, !!ambientModuleName, key2);
                            if (res !== void 0) return res;
                        }
                    }
                });
            },
            releaseSymbols: ()=>{
                symbols.clear();
            },
            onFileChanged: (oldSourceFile, newSourceFile, typeAcquisitionEnabled)=>{
                if (fileIsGlobalOnly(oldSourceFile) && fileIsGlobalOnly(newSourceFile)) return false;
                if (usableByFileName && usableByFileName !== newSourceFile.path || // If ATA is enabled, auto-imports uses existing imports to guess whether you want auto-imports from node.
                // Adding or removing imports from node could change the outcome of that guess, so could change the suggestions list.
                typeAcquisitionEnabled && consumesNodeCoreModules(oldSourceFile) !== consumesNodeCoreModules(newSourceFile) || // Module agumentation and ambient module changes can add or remove exports available to be auto-imported.
                // Changes elsewhere in the file can change the *type* of an export in a module augmentation,
                // but type info is gathered in getCompletionEntryDetails, which doesn't use the cache.
                !arrayIsEqualTo(oldSourceFile.moduleAugmentations, newSourceFile.moduleAugmentations) || !ambientModuleDeclarationsAreEqual(oldSourceFile, newSourceFile)) {
                    cache.clear();
                    return true;
                }
                usableByFileName = newSourceFile.path;
                return false;
            }
        };
        if (Debug.isDebugging) Object.defineProperty(cache, "__cache", {
            get: ()=>exportInfo
        });
        return cache;
        function rehydrateCachedInfo(info) {
            if (info.symbol && info.moduleSymbol) return info;
            const { id: id , exportKind: exportKind , targetFlags: targetFlags , isFromPackageJson: isFromPackageJson , moduleFileName: moduleFileName  } = info;
            const [cachedSymbol, cachedModuleSymbol] = symbols.get(id) || emptyArray;
            if (cachedSymbol && cachedModuleSymbol) return {
                symbol: cachedSymbol,
                moduleSymbol: cachedModuleSymbol,
                moduleFileName: moduleFileName,
                exportKind: exportKind,
                targetFlags: targetFlags,
                isFromPackageJson: isFromPackageJson
            };
            const checker = (isFromPackageJson ? host.getPackageJsonAutoImportProvider() : host.getCurrentProgram()).getTypeChecker();
            const moduleSymbol = info.moduleSymbol || cachedModuleSymbol || Debug.checkDefined(info.moduleFile ? checker.getMergedSymbol(info.moduleFile.symbol) : checker.tryFindAmbientModule(info.moduleName));
            const symbol = info.symbol || cachedSymbol || Debug.checkDefined(exportKind === 2 /* ExportEquals */  ? checker.resolveExternalModuleSymbol(moduleSymbol) : checker.tryGetMemberInModuleExportsAndProperties(unescapeLeadingUnderscores(info.symbolTableKey), moduleSymbol), `Could not find symbol '${info.symbolName}' by key '${info.symbolTableKey}' in module ${moduleSymbol.name}`);
            symbols.set(id, [
                symbol,
                moduleSymbol
            ]);
            return {
                symbol: symbol,
                moduleSymbol: moduleSymbol,
                moduleFileName: moduleFileName,
                exportKind: exportKind,
                targetFlags: targetFlags,
                isFromPackageJson: isFromPackageJson
            };
        }
        function key(importedName, symbol, ambientModuleName, checker) {
            const moduleKey = ambientModuleName || "";
            return `${importedName}|${getSymbolId(skipAlias(symbol, checker))}|${moduleKey}`;
        }
        function parseKey(key2) {
            const symbolName2 = key2.substring(0, key2.indexOf("|"));
            const moduleKey = key2.substring(key2.lastIndexOf("|") + 1);
            const ambientModuleName = moduleKey === "" ? void 0 : moduleKey;
            return {
                symbolName: symbolName2,
                ambientModuleName: ambientModuleName
            };
        }
        function fileIsGlobalOnly(file) {
            return !file.commonJsModuleIndicator && !file.externalModuleIndicator && !file.moduleAugmentations && !file.ambientModuleNames;
        }
        function ambientModuleDeclarationsAreEqual(oldSourceFile, newSourceFile) {
            if (!arrayIsEqualTo(oldSourceFile.ambientModuleNames, newSourceFile.ambientModuleNames)) return false;
            let oldFileStatementIndex = -1;
            let newFileStatementIndex = -1;
            for (const ambientModuleName of newSourceFile.ambientModuleNames){
                const isMatchingModuleDeclaration = (node)=>isNonGlobalAmbientModule(node) && node.name.text === ambientModuleName;
                oldFileStatementIndex = findIndex(oldSourceFile.statements, isMatchingModuleDeclaration, oldFileStatementIndex + 1);
                newFileStatementIndex = findIndex(newSourceFile.statements, isMatchingModuleDeclaration, newFileStatementIndex + 1);
                if (oldSourceFile.statements[oldFileStatementIndex] !== newSourceFile.statements[newFileStatementIndex]) return false;
            }
            return true;
        }
        function isNotShadowedByDeeperNodeModulesPackage(info, packageName) {
            if (!packageName || !info.moduleFileName) return true;
            const typingsCacheLocation = host.getGlobalTypingsCacheLocation();
            if (typingsCacheLocation && startsWith(info.moduleFileName, typingsCacheLocation)) return true;
            const packageDeepestNodeModulesPath = packages.get(packageName);
            return !packageDeepestNodeModulesPath || startsWith(info.moduleFileName, packageDeepestNodeModulesPath);
        }
    }
    function isImportableFile(program, from, to, preferences, packageJsonFilter, moduleSpecifierResolutionHost, moduleSpecifierCache) {
        var _a;
        if (from === to) return false;
        const cachedResult = moduleSpecifierCache == null ? void 0 : moduleSpecifierCache.get(from.path, to.path, preferences, {});
        if ((cachedResult == null ? void 0 : cachedResult.isBlockedByPackageJsonDependencies) !== void 0) return !cachedResult.isBlockedByPackageJsonDependencies;
        const getCanonicalFileName = hostGetCanonicalFileName(moduleSpecifierResolutionHost);
        const globalTypingsCache = (_a = moduleSpecifierResolutionHost.getGlobalTypingsCacheLocation) == null ? void 0 : _a.call(moduleSpecifierResolutionHost);
        const hasImportablePath = !!ts_moduleSpecifiers_exports.forEachFileNameOfModule(from.fileName, to.fileName, moduleSpecifierResolutionHost, /*preferSymlinks*/ false, (toPath3)=>{
            const toFile = program.getSourceFile(toPath3);
            return (toFile === to || !toFile) && isImportablePath(from.fileName, toPath3, getCanonicalFileName, globalTypingsCache);
        });
        if (packageJsonFilter) {
            const isAutoImportable = hasImportablePath && packageJsonFilter.allowsImportingSourceFile(to, moduleSpecifierResolutionHost);
            moduleSpecifierCache == null || moduleSpecifierCache.setBlockedByPackageJsonDependencies(from.path, to.path, preferences, {}, !isAutoImportable);
            return isAutoImportable;
        }
        return hasImportablePath;
    }
    function isImportablePath(fromPath, toPath3, getCanonicalFileName, globalCachePath) {
        const toNodeModules = forEachAncestorDirectory(toPath3, (ancestor)=>getBaseFileName(ancestor) === "node_modules" ? ancestor : void 0);
        const toNodeModulesParent = toNodeModules && getDirectoryPath(getCanonicalFileName(toNodeModules));
        return toNodeModulesParent === void 0 || startsWith(getCanonicalFileName(fromPath), toNodeModulesParent) || !!globalCachePath && startsWith(getCanonicalFileName(globalCachePath), toNodeModulesParent);
    }
    function forEachExternalModuleToImportFrom(program, host, preferences, useAutoImportProvider, cb) {
        var _a, _b;
        const useCaseSensitiveFileNames = hostUsesCaseSensitiveFileNames(host);
        const excludePatterns = preferences.autoImportFileExcludePatterns && mapDefined(preferences.autoImportFileExcludePatterns, (spec)=>{
            const pattern = getPatternFromSpec(spec, "", "exclude");
            return pattern ? getRegexFromPattern(pattern, useCaseSensitiveFileNames) : void 0;
        });
        forEachExternalModule(program.getTypeChecker(), program.getSourceFiles(), excludePatterns, (module2, file)=>cb(module2, file, program, /*isFromPackageJson*/ false));
        const autoImportProvider = useAutoImportProvider && ((_a = host.getPackageJsonAutoImportProvider) == null ? void 0 : _a.call(host));
        if (autoImportProvider) {
            const start = timestamp();
            const checker = program.getTypeChecker();
            forEachExternalModule(autoImportProvider.getTypeChecker(), autoImportProvider.getSourceFiles(), excludePatterns, (module2, file)=>{
                if (file && !program.getSourceFile(file.fileName) || !file && !checker.resolveName(module2.name, /*location*/ void 0, 1536 /* Module */ , /*excludeGlobals*/ false)) cb(module2, file, autoImportProvider, /*isFromPackageJson*/ true);
            });
            (_b = host.log) == null || _b.call(host, `forEachExternalModuleToImportFrom autoImportProvider: ${timestamp() - start}`);
        }
    }
    function forEachExternalModule(checker, allSourceFiles, excludePatterns, cb) {
        var _a;
        const isExcluded = excludePatterns && ((fileName)=>excludePatterns.some((p)=>p.test(fileName)));
        for (const ambient of checker.getAmbientModules())if (!stringContains(ambient.name, "*") && !(excludePatterns && ((_a = ambient.declarations) == null ? void 0 : _a.every((d)=>isExcluded(d.getSourceFile().fileName))))) cb(ambient, /*sourceFile*/ void 0);
        for (const sourceFile of allSourceFiles)if (isExternalOrCommonJsModule(sourceFile) && !(isExcluded == null ? void 0 : isExcluded(sourceFile.fileName))) cb(checker.getMergedSymbol(sourceFile.symbol), sourceFile);
    }
    function getExportInfoMap(importingFile, host, program, preferences, cancellationToken) {
        var _a, _b, _c, _d, _e;
        const start = timestamp();
        (_a = host.getPackageJsonAutoImportProvider) == null || _a.call(host);
        const cache = ((_b = host.getCachedExportInfoMap) == null ? void 0 : _b.call(host)) || createCacheableExportInfoMap({
            getCurrentProgram: ()=>program,
            getPackageJsonAutoImportProvider: ()=>{
                var _a2;
                return (_a2 = host.getPackageJsonAutoImportProvider) == null ? void 0 : _a2.call(host);
            },
            getGlobalTypingsCacheLocation: ()=>{
                var _a2;
                return (_a2 = host.getGlobalTypingsCacheLocation) == null ? void 0 : _a2.call(host);
            }
        });
        if (cache.isUsableByFile(importingFile.path)) {
            (_c = host.log) == null || _c.call(host, "getExportInfoMap: cache hit");
            return cache;
        }
        (_d = host.log) == null || _d.call(host, "getExportInfoMap: cache miss or empty; calculating new results");
        const compilerOptions = program.getCompilerOptions();
        let moduleCount = 0;
        try {
            forEachExternalModuleToImportFrom(program, host, preferences, /*useAutoImportProvider*/ true, (moduleSymbol, moduleFile, program2, isFromPackageJson)=>{
                if (++moduleCount % 100 === 0) cancellationToken == null || cancellationToken.throwIfCancellationRequested();
                const seenExports = /* @__PURE__ */ new Map();
                const checker = program2.getTypeChecker();
                const defaultInfo = getDefaultLikeExportInfo(moduleSymbol, checker, compilerOptions);
                if (defaultInfo && isImportableSymbol(defaultInfo.symbol, checker)) cache.add(importingFile.path, defaultInfo.symbol, defaultInfo.exportKind === 1 /* Default */  ? "default" /* Default */  : "export=" /* ExportEquals */ , moduleSymbol, moduleFile, defaultInfo.exportKind, isFromPackageJson, checker);
                checker.forEachExportAndPropertyOfModule(moduleSymbol, (exported, key)=>{
                    if (exported !== (defaultInfo == null ? void 0 : defaultInfo.symbol) && isImportableSymbol(exported, checker) && addToSeen(seenExports, key)) cache.add(importingFile.path, exported, key, moduleSymbol, moduleFile, 0 /* Named */ , isFromPackageJson, checker);
                });
            });
        } catch (err) {
            cache.clear();
            throw err;
        }
        (_e = host.log) == null || _e.call(host, `getExportInfoMap: done in ${timestamp() - start} ms`);
        return cache;
    }
    function getDefaultLikeExportInfo(moduleSymbol, checker, compilerOptions) {
        const exported = getDefaultLikeExportWorker(moduleSymbol, checker);
        if (!exported) return void 0;
        const { symbol: symbol , exportKind: exportKind  } = exported;
        const info = getDefaultExportInfoWorker(symbol, checker, compilerOptions);
        return info && {
            symbol: symbol,
            exportKind: exportKind,
            ...info
        };
    }
    function isImportableSymbol(symbol, checker) {
        return !checker.isUndefinedSymbol(symbol) && !checker.isUnknownSymbol(symbol) && !isKnownSymbol(symbol) && !isPrivateIdentifierSymbol(symbol);
    }
    function getDefaultLikeExportWorker(moduleSymbol, checker) {
        const exportEquals = checker.resolveExternalModuleSymbol(moduleSymbol);
        if (exportEquals !== moduleSymbol) return {
            symbol: exportEquals,
            exportKind: 2 /* ExportEquals */ 
        };
        const defaultExport = checker.tryGetMemberInModuleExports("default" /* Default */ , moduleSymbol);
        if (defaultExport) return {
            symbol: defaultExport,
            exportKind: 1 /* Default */ 
        };
    }
    function getDefaultExportInfoWorker(defaultExport, checker, compilerOptions) {
        const localSymbol = getLocalSymbolForExportDefault(defaultExport);
        if (localSymbol) return {
            resolvedSymbol: localSymbol,
            name: localSymbol.name
        };
        const name = getNameForExportDefault(defaultExport);
        if (name !== void 0) return {
            resolvedSymbol: defaultExport,
            name: name
        };
        if (defaultExport.flags & 2097152 /* Alias */ ) {
            const aliased = checker.getImmediateAliasedSymbol(defaultExport);
            if (aliased && aliased.parent) return getDefaultExportInfoWorker(aliased, checker, compilerOptions);
        }
        if (defaultExport.escapedName !== "default" /* Default */  && defaultExport.escapedName !== "export=" /* ExportEquals */ ) return {
            resolvedSymbol: defaultExport,
            name: defaultExport.getName()
        };
        return {
            resolvedSymbol: defaultExport,
            name: getNameForExportedSymbol(defaultExport, compilerOptions.target)
        };
    }
    function getNameForExportDefault(symbol) {
        return symbol.declarations && firstDefined(symbol.declarations, (declaration)=>{
            var _a;
            if (isExportAssignment(declaration)) return (_a = tryCast(skipOuterExpressions(declaration.expression), isIdentifier)) == null ? void 0 : _a.text;
            else if (isExportSpecifier(declaration)) {
                Debug.assert(declaration.name.text === "default" /* Default */ , "Expected the specifier to be a default export");
                return declaration.propertyName && declaration.propertyName.text;
            }
        });
    }
    var ImportKind, ExportKind;
    var init_exportInfoMap = __esm({
        "src/services/exportInfoMap.ts" () {
            "use strict";
            init_ts4();
            ImportKind = /* @__PURE__ */ ((ImportKind2)=>{
                ImportKind2[ImportKind2["Named"] = 0] = "Named";
                ImportKind2[ImportKind2["Default"] = 1] = "Default";
                ImportKind2[ImportKind2["Namespace"] = 2] = "Namespace";
                ImportKind2[ImportKind2["CommonJS"] = 3] = "CommonJS";
                return ImportKind2;
            })(ImportKind || {});
            ExportKind = /* @__PURE__ */ ((ExportKind3)=>{
                ExportKind3[ExportKind3["Named"] = 0] = "Named";
                ExportKind3[ExportKind3["Default"] = 1] = "Default";
                ExportKind3[ExportKind3["ExportEquals"] = 2] = "ExportEquals";
                ExportKind3[ExportKind3["UMD"] = 3] = "UMD";
                return ExportKind3;
            })(ExportKind || {});
        }
    });
    // src/services/classifier.ts
    function createClassifier() {
        const scanner2 = createScanner(99 /* Latest */ , /*skipTrivia*/ false);
        function getClassificationsForLine(text, lexState, syntacticClassifierAbsent) {
            return convertClassificationsToResult(getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent), text);
        }
        function getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent) {
            let token = 0 /* Unknown */ ;
            let lastNonTriviaToken = 0 /* Unknown */ ;
            const templateStack = [];
            const { prefix: prefix , pushTemplate: pushTemplate  } = getPrefixFromLexState(lexState);
            text = prefix + text;
            const offset = prefix.length;
            if (pushTemplate) templateStack.push(16 /* TemplateHead */ );
            scanner2.setText(text);
            let endOfLineState = 0 /* None */ ;
            const spans = [];
            let angleBracketStack = 0;
            do {
                token = scanner2.scan();
                if (!isTrivia(token)) {
                    handleToken();
                    lastNonTriviaToken = token;
                }
                const end = scanner2.getTokenEnd();
                pushEncodedClassification(scanner2.getTokenStart(), end, offset, classFromKind(token), spans);
                if (end >= text.length) {
                    const end2 = getNewEndOfLineState(scanner2, token, lastOrUndefined(templateStack));
                    if (end2 !== void 0) endOfLineState = end2;
                }
            }while (token !== 1 /* EndOfFileToken */ );
            function handleToken() {
                switch(token){
                    case 44 /* SlashToken */ :
                    case 69 /* SlashEqualsToken */ :
                        if (!noRegexTable[lastNonTriviaToken] && scanner2.reScanSlashToken() === 14 /* RegularExpressionLiteral */ ) token = 14 /* RegularExpressionLiteral */ ;
                        break;
                    case 30 /* LessThanToken */ :
                        if (lastNonTriviaToken === 80 /* Identifier */ ) angleBracketStack++;
                        break;
                    case 32 /* GreaterThanToken */ :
                        if (angleBracketStack > 0) angleBracketStack--;
                        break;
                    case 133 /* AnyKeyword */ :
                    case 154 /* StringKeyword */ :
                    case 150 /* NumberKeyword */ :
                    case 136 /* BooleanKeyword */ :
                    case 155 /* SymbolKeyword */ :
                        if (angleBracketStack > 0 && !syntacticClassifierAbsent) token = 80 /* Identifier */ ;
                        break;
                    case 16 /* TemplateHead */ :
                        templateStack.push(token);
                        break;
                    case 19 /* OpenBraceToken */ :
                        if (templateStack.length > 0) templateStack.push(token);
                        break;
                    case 20 /* CloseBraceToken */ :
                        if (templateStack.length > 0) {
                            const lastTemplateStackToken = lastOrUndefined(templateStack);
                            if (lastTemplateStackToken === 16 /* TemplateHead */ ) {
                                token = scanner2.reScanTemplateToken(/*isTaggedTemplate*/ false);
                                if (token === 18 /* TemplateTail */ ) templateStack.pop();
                                else Debug.assertEqual(token, 17 /* TemplateMiddle */ , "Should have been a template middle.");
                            } else {
                                Debug.assertEqual(lastTemplateStackToken, 19 /* OpenBraceToken */ , "Should have been an open brace");
                                templateStack.pop();
                            }
                        }
                        break;
                    default:
                        if (!isKeyword(token)) break;
                        if (lastNonTriviaToken === 25 /* DotToken */ ) token = 80 /* Identifier */ ;
                        else if (isKeyword(lastNonTriviaToken) && isKeyword(token) && !canFollow(lastNonTriviaToken, token)) token = 80 /* Identifier */ ;
                }
            }
            return {
                endOfLineState: endOfLineState,
                spans: spans
            };
        }
        return {
            getClassificationsForLine: getClassificationsForLine,
            getEncodedLexicalClassifications: getEncodedLexicalClassifications
        };
    }
    function getNewEndOfLineState(scanner2, token, lastOnTemplateStack) {
        switch(token){
            case 11 /* StringLiteral */ :
                {
                    if (!scanner2.isUnterminated()) return void 0;
                    const tokenText = scanner2.getTokenText();
                    const lastCharIndex = tokenText.length - 1;
                    let numBackslashes = 0;
                    while(tokenText.charCodeAt(lastCharIndex - numBackslashes) === 92 /* backslash */ )numBackslashes++;
                    if ((numBackslashes & 1) === 0) return void 0;
                    return tokenText.charCodeAt(0) === 34 /* doubleQuote */  ? 3 /* InDoubleQuoteStringLiteral */  : 2 /* InSingleQuoteStringLiteral */ ;
                }
            case 3 /* MultiLineCommentTrivia */ :
                return scanner2.isUnterminated() ? 1 /* InMultiLineCommentTrivia */  : void 0;
            default:
                if (isTemplateLiteralKind(token)) {
                    if (!scanner2.isUnterminated()) return void 0;
                    switch(token){
                        case 18 /* TemplateTail */ :
                            return 5 /* InTemplateMiddleOrTail */ ;
                        case 15 /* NoSubstitutionTemplateLiteral */ :
                            return 4 /* InTemplateHeadOrNoSubstitutionTemplate */ ;
                        default:
                            return Debug.fail("Only 'NoSubstitutionTemplateLiteral's and 'TemplateTail's can be unterminated; got SyntaxKind #" + token);
                    }
                }
                return lastOnTemplateStack === 16 /* TemplateHead */  ? 6 /* InTemplateSubstitutionPosition */  : void 0;
        }
    }
    function pushEncodedClassification(start, end, offset, classification, result) {
        if (classification === 8 /* whiteSpace */ ) return;
        if (start === 0 && offset > 0) start += offset;
        const length2 = end - start;
        if (length2 > 0) result.push(start - offset, length2, classification);
    }
    function convertClassificationsToResult(classifications, text) {
        const entries = [];
        const dense = classifications.spans;
        let lastEnd = 0;
        for(let i = 0; i < dense.length; i += 3){
            const start = dense[i];
            const length2 = dense[i + 1];
            const type = dense[i + 2];
            if (lastEnd >= 0) {
                const whitespaceLength2 = start - lastEnd;
                if (whitespaceLength2 > 0) entries.push({
                    length: whitespaceLength2,
                    classification: 4 /* Whitespace */ 
                });
            }
            entries.push({
                length: length2,
                classification: convertClassification(type)
            });
            lastEnd = start + length2;
        }
        const whitespaceLength = text.length - lastEnd;
        if (whitespaceLength > 0) entries.push({
            length: whitespaceLength,
            classification: 4 /* Whitespace */ 
        });
        return {
            entries: entries,
            finalLexState: classifications.endOfLineState
        };
    }
    function convertClassification(type) {
        switch(type){
            case 1 /* comment */ :
                return 3 /* Comment */ ;
            case 3 /* keyword */ :
                return 1 /* Keyword */ ;
            case 4 /* numericLiteral */ :
                return 6 /* NumberLiteral */ ;
            case 25 /* bigintLiteral */ :
                return 7 /* BigIntLiteral */ ;
            case 5 /* operator */ :
                return 2 /* Operator */ ;
            case 6 /* stringLiteral */ :
                return 8 /* StringLiteral */ ;
            case 8 /* whiteSpace */ :
                return 4 /* Whitespace */ ;
            case 10 /* punctuation */ :
                return 0 /* Punctuation */ ;
            case 2 /* identifier */ :
            case 11 /* className */ :
            case 12 /* enumName */ :
            case 13 /* interfaceName */ :
            case 14 /* moduleName */ :
            case 15 /* typeParameterName */ :
            case 16 /* typeAliasName */ :
            case 9 /* text */ :
            case 17 /* parameterName */ :
                return 5 /* Identifier */ ;
            default:
                return void 0;
        }
    }
    function canFollow(keyword1, keyword2) {
        if (!isAccessibilityModifier(keyword1)) return true;
        switch(keyword2){
            case 139 /* GetKeyword */ :
            case 153 /* SetKeyword */ :
            case 137 /* ConstructorKeyword */ :
            case 126 /* StaticKeyword */ :
            case 129 /* AccessorKeyword */ :
                return true;
            default:
                return false;
        }
    }
    function getPrefixFromLexState(lexState) {
        switch(lexState){
            case 3 /* InDoubleQuoteStringLiteral */ :
                return {
                    prefix: '"\\\n'
                };
            case 2 /* InSingleQuoteStringLiteral */ :
                return {
                    prefix: "'\\\n"
                };
            case 1 /* InMultiLineCommentTrivia */ :
                return {
                    prefix: "/*\n"
                };
            case 4 /* InTemplateHeadOrNoSubstitutionTemplate */ :
                return {
                    prefix: "`\n"
                };
            case 5 /* InTemplateMiddleOrTail */ :
                return {
                    prefix: "}\n",
                    pushTemplate: true
                };
            case 6 /* InTemplateSubstitutionPosition */ :
                return {
                    prefix: "",
                    pushTemplate: true
                };
            case 0 /* None */ :
                return {
                    prefix: ""
                };
            default:
                return Debug.assertNever(lexState);
        }
    }
    function isBinaryExpressionOperatorToken(token) {
        switch(token){
            case 42 /* AsteriskToken */ :
            case 44 /* SlashToken */ :
            case 45 /* PercentToken */ :
            case 40 /* PlusToken */ :
            case 41 /* MinusToken */ :
            case 48 /* LessThanLessThanToken */ :
            case 49 /* GreaterThanGreaterThanToken */ :
            case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
            case 30 /* LessThanToken */ :
            case 32 /* GreaterThanToken */ :
            case 33 /* LessThanEqualsToken */ :
            case 34 /* GreaterThanEqualsToken */ :
            case 104 /* InstanceOfKeyword */ :
            case 103 /* InKeyword */ :
            case 130 /* AsKeyword */ :
            case 152 /* SatisfiesKeyword */ :
            case 35 /* EqualsEqualsToken */ :
            case 36 /* ExclamationEqualsToken */ :
            case 37 /* EqualsEqualsEqualsToken */ :
            case 38 /* ExclamationEqualsEqualsToken */ :
            case 51 /* AmpersandToken */ :
            case 53 /* CaretToken */ :
            case 52 /* BarToken */ :
            case 56 /* AmpersandAmpersandToken */ :
            case 57 /* BarBarToken */ :
            case 75 /* BarEqualsToken */ :
            case 74 /* AmpersandEqualsToken */ :
            case 79 /* CaretEqualsToken */ :
            case 71 /* LessThanLessThanEqualsToken */ :
            case 72 /* GreaterThanGreaterThanEqualsToken */ :
            case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
            case 65 /* PlusEqualsToken */ :
            case 66 /* MinusEqualsToken */ :
            case 67 /* AsteriskEqualsToken */ :
            case 69 /* SlashEqualsToken */ :
            case 70 /* PercentEqualsToken */ :
            case 64 /* EqualsToken */ :
            case 28 /* CommaToken */ :
            case 61 /* QuestionQuestionToken */ :
            case 76 /* BarBarEqualsToken */ :
            case 77 /* AmpersandAmpersandEqualsToken */ :
            case 78 /* QuestionQuestionEqualsToken */ :
                return true;
            default:
                return false;
        }
    }
    function isPrefixUnaryExpressionOperatorToken(token) {
        switch(token){
            case 40 /* PlusToken */ :
            case 41 /* MinusToken */ :
            case 55 /* TildeToken */ :
            case 54 /* ExclamationToken */ :
            case 46 /* PlusPlusToken */ :
            case 47 /* MinusMinusToken */ :
                return true;
            default:
                return false;
        }
    }
    function classFromKind(token) {
        if (isKeyword(token)) return 3 /* keyword */ ;
        else if (isBinaryExpressionOperatorToken(token) || isPrefixUnaryExpressionOperatorToken(token)) return 5 /* operator */ ;
        else if (token >= 19 /* FirstPunctuation */  && token <= 79 /* LastPunctuation */ ) return 10 /* punctuation */ ;
        switch(token){
            case 9 /* NumericLiteral */ :
                return 4 /* numericLiteral */ ;
            case 10 /* BigIntLiteral */ :
                return 25 /* bigintLiteral */ ;
            case 11 /* StringLiteral */ :
                return 6 /* stringLiteral */ ;
            case 14 /* RegularExpressionLiteral */ :
                return 7 /* regularExpressionLiteral */ ;
            case 7 /* ConflictMarkerTrivia */ :
            case 3 /* MultiLineCommentTrivia */ :
            case 2 /* SingleLineCommentTrivia */ :
                return 1 /* comment */ ;
            case 5 /* WhitespaceTrivia */ :
            case 4 /* NewLineTrivia */ :
                return 8 /* whiteSpace */ ;
            case 80 /* Identifier */ :
            default:
                if (isTemplateLiteralKind(token)) return 6 /* stringLiteral */ ;
                return 2 /* identifier */ ;
        }
    }
    function getSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span) {
        return convertClassificationsToSpans(getEncodedSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span));
    }
    function checkForClassificationCancellation(cancellationToken, kind) {
        switch(kind){
            case 266 /* ModuleDeclaration */ :
            case 262 /* ClassDeclaration */ :
            case 263 /* InterfaceDeclaration */ :
            case 261 /* FunctionDeclaration */ :
            case 230 /* ClassExpression */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
                cancellationToken.throwIfCancellationRequested();
        }
    }
    function getEncodedSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span) {
        const spans = [];
        sourceFile.forEachChild(function cb(node) {
            if (!node || !textSpanIntersectsWith(span, node.pos, node.getFullWidth())) return;
            checkForClassificationCancellation(cancellationToken, node.kind);
            if (isIdentifier(node) && !nodeIsMissing(node) && classifiableNames.has(node.escapedText)) {
                const symbol = typeChecker.getSymbolAtLocation(node);
                const type = symbol && classifySymbol(symbol, getMeaningFromLocation(node), typeChecker);
                if (type) pushClassification(node.getStart(sourceFile), node.getEnd(), type);
            }
            node.forEachChild(cb);
        });
        return {
            spans: spans,
            endOfLineState: 0 /* None */ 
        };
        function pushClassification(start, end, type) {
            const length2 = end - start;
            Debug.assert(length2 > 0, `Classification had non-positive length of ${length2}`);
            spans.push(start);
            spans.push(length2);
            spans.push(type);
        }
    }
    function classifySymbol(symbol, meaningAtPosition, checker) {
        const flags = symbol.getFlags();
        if ((flags & 2885600 /* Classifiable */ ) === 0 /* None */ ) return void 0;
        else if (flags & 32 /* Class */ ) return 11 /* className */ ;
        else if (flags & 384 /* Enum */ ) return 12 /* enumName */ ;
        else if (flags & 524288 /* TypeAlias */ ) return 16 /* typeAliasName */ ;
        else if (flags & 1536 /* Module */ ) return meaningAtPosition & 4 /* Namespace */  || meaningAtPosition & 1 /* Value */  && hasValueSideModule(symbol) ? 14 /* moduleName */  : void 0;
        else if (flags & 2097152 /* Alias */ ) return classifySymbol(checker.getAliasedSymbol(symbol), meaningAtPosition, checker);
        else if (meaningAtPosition & 2 /* Type */ ) return flags & 64 /* Interface */  ? 13 /* interfaceName */  : flags & 262144 /* TypeParameter */  ? 15 /* typeParameterName */  : void 0;
        else return void 0;
    }
    function hasValueSideModule(symbol) {
        return some(symbol.declarations, (declaration)=>isModuleDeclaration(declaration) && getModuleInstanceState(declaration) === 1 /* Instantiated */ );
    }
    function getClassificationTypeName(type) {
        switch(type){
            case 1 /* comment */ :
                return "comment" /* comment */ ;
            case 2 /* identifier */ :
                return "identifier" /* identifier */ ;
            case 3 /* keyword */ :
                return "keyword" /* keyword */ ;
            case 4 /* numericLiteral */ :
                return "number" /* numericLiteral */ ;
            case 25 /* bigintLiteral */ :
                return "bigint" /* bigintLiteral */ ;
            case 5 /* operator */ :
                return "operator" /* operator */ ;
            case 6 /* stringLiteral */ :
                return "string" /* stringLiteral */ ;
            case 8 /* whiteSpace */ :
                return "whitespace" /* whiteSpace */ ;
            case 9 /* text */ :
                return "text" /* text */ ;
            case 10 /* punctuation */ :
                return "punctuation" /* punctuation */ ;
            case 11 /* className */ :
                return "class name" /* className */ ;
            case 12 /* enumName */ :
                return "enum name" /* enumName */ ;
            case 13 /* interfaceName */ :
                return "interface name" /* interfaceName */ ;
            case 14 /* moduleName */ :
                return "module name" /* moduleName */ ;
            case 15 /* typeParameterName */ :
                return "type parameter name" /* typeParameterName */ ;
            case 16 /* typeAliasName */ :
                return "type alias name" /* typeAliasName */ ;
            case 17 /* parameterName */ :
                return "parameter name" /* parameterName */ ;
            case 18 /* docCommentTagName */ :
                return "doc comment tag name" /* docCommentTagName */ ;
            case 19 /* jsxOpenTagName */ :
                return "jsx open tag name" /* jsxOpenTagName */ ;
            case 20 /* jsxCloseTagName */ :
                return "jsx close tag name" /* jsxCloseTagName */ ;
            case 21 /* jsxSelfClosingTagName */ :
                return "jsx self closing tag name" /* jsxSelfClosingTagName */ ;
            case 22 /* jsxAttribute */ :
                return "jsx attribute" /* jsxAttribute */ ;
            case 23 /* jsxText */ :
                return "jsx text" /* jsxText */ ;
            case 24 /* jsxAttributeStringLiteralValue */ :
                return "jsx attribute string literal value" /* jsxAttributeStringLiteralValue */ ;
            default:
                return void 0;
        }
    }
    function convertClassificationsToSpans(classifications) {
        Debug.assert(classifications.spans.length % 3 === 0);
        const dense = classifications.spans;
        const result = [];
        for(let i = 0; i < dense.length; i += 3)result.push({
            textSpan: createTextSpan(dense[i], dense[i + 1]),
            classificationType: getClassificationTypeName(dense[i + 2])
        });
        return result;
    }
    function getSyntacticClassifications(cancellationToken, sourceFile, span) {
        return convertClassificationsToSpans(getEncodedSyntacticClassifications(cancellationToken, sourceFile, span));
    }
    function getEncodedSyntacticClassifications(cancellationToken, sourceFile, span) {
        const spanStart = span.start;
        const spanLength = span.length;
        const triviaScanner = createScanner(99 /* Latest */ , /*skipTrivia*/ false, sourceFile.languageVariant, sourceFile.text);
        const mergeConflictScanner = createScanner(99 /* Latest */ , /*skipTrivia*/ false, sourceFile.languageVariant, sourceFile.text);
        const result = [];
        processElement(sourceFile);
        return {
            spans: result,
            endOfLineState: 0 /* None */ 
        };
        function pushClassification(start, length2, type) {
            result.push(start);
            result.push(length2);
            result.push(type);
        }
        function classifyLeadingTriviaAndGetTokenStart(token) {
            triviaScanner.resetTokenState(token.pos);
            while(true){
                const start = triviaScanner.getTokenEnd();
                if (!couldStartTrivia(sourceFile.text, start)) return start;
                const kind = triviaScanner.scan();
                const end = triviaScanner.getTokenEnd();
                const width = end - start;
                if (!isTrivia(kind)) return start;
                switch(kind){
                    case 4 /* NewLineTrivia */ :
                    case 5 /* WhitespaceTrivia */ :
                        continue;
                    case 2 /* SingleLineCommentTrivia */ :
                    case 3 /* MultiLineCommentTrivia */ :
                        classifyComment(token, kind, start, width);
                        triviaScanner.resetTokenState(end);
                        continue;
                    case 7 /* ConflictMarkerTrivia */ :
                        const text = sourceFile.text;
                        const ch = text.charCodeAt(start);
                        if (ch === 60 /* lessThan */  || ch === 62 /* greaterThan */ ) {
                            pushClassification(start, width, 1 /* comment */ );
                            continue;
                        }
                        Debug.assert(ch === 124 /* bar */  || ch === 61 /* equals */ );
                        classifyDisabledMergeCode(text, start, end);
                        break;
                    case 6 /* ShebangTrivia */ :
                        break;
                    default:
                        Debug.assertNever(kind);
                }
            }
        }
        function classifyComment(token, kind, start, width) {
            if (kind === 3 /* MultiLineCommentTrivia */ ) {
                const docCommentAndDiagnostics = parseIsolatedJSDocComment(sourceFile.text, start, width);
                if (docCommentAndDiagnostics && docCommentAndDiagnostics.jsDoc) {
                    setParent(docCommentAndDiagnostics.jsDoc, token);
                    classifyJSDocComment(docCommentAndDiagnostics.jsDoc);
                    return;
                }
            } else if (kind === 2 /* SingleLineCommentTrivia */ ) {
                if (tryClassifyTripleSlashComment(start, width)) return;
            }
            pushCommentRange(start, width);
        }
        function pushCommentRange(start, width) {
            pushClassification(start, width, 1 /* comment */ );
        }
        function classifyJSDocComment(docComment) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            let pos = docComment.pos;
            if (docComment.tags) for (const tag of docComment.tags){
                if (tag.pos !== pos) pushCommentRange(pos, tag.pos - pos);
                pushClassification(tag.pos, 1, 10 /* punctuation */ );
                pushClassification(tag.tagName.pos, tag.tagName.end - tag.tagName.pos, 18 /* docCommentTagName */ );
                pos = tag.tagName.end;
                let commentStart = tag.tagName.end;
                switch(tag.kind){
                    case 347 /* JSDocParameterTag */ :
                        const param = tag;
                        processJSDocParameterTag(param);
                        commentStart = param.isNameFirst && ((_a = param.typeExpression) == null ? void 0 : _a.end) || param.name.end;
                        break;
                    case 354 /* JSDocPropertyTag */ :
                        const prop = tag;
                        commentStart = prop.isNameFirst && ((_b = prop.typeExpression) == null ? void 0 : _b.end) || prop.name.end;
                        break;
                    case 351 /* JSDocTemplateTag */ :
                        processJSDocTemplateTag(tag);
                        pos = tag.end;
                        commentStart = tag.typeParameters.end;
                        break;
                    case 352 /* JSDocTypedefTag */ :
                        const type = tag;
                        commentStart = ((_c = type.typeExpression) == null ? void 0 : _c.kind) === 315 /* JSDocTypeExpression */  && ((_d = type.fullName) == null ? void 0 : _d.end) || ((_e = type.typeExpression) == null ? void 0 : _e.end) || commentStart;
                        break;
                    case 344 /* JSDocCallbackTag */ :
                        commentStart = tag.typeExpression.end;
                        break;
                    case 350 /* JSDocTypeTag */ :
                        processElement(tag.typeExpression);
                        pos = tag.end;
                        commentStart = tag.typeExpression.end;
                        break;
                    case 349 /* JSDocThisTag */ :
                    case 346 /* JSDocEnumTag */ :
                        commentStart = tag.typeExpression.end;
                        break;
                    case 348 /* JSDocReturnTag */ :
                        processElement(tag.typeExpression);
                        pos = tag.end;
                        commentStart = ((_f = tag.typeExpression) == null ? void 0 : _f.end) || commentStart;
                        break;
                    case 353 /* JSDocSeeTag */ :
                        commentStart = ((_g = tag.name) == null ? void 0 : _g.end) || commentStart;
                        break;
                    case 334 /* JSDocAugmentsTag */ :
                    case 335 /* JSDocImplementsTag */ :
                        commentStart = tag.class.end;
                        break;
                    case 355 /* JSDocThrowsTag */ :
                        processElement(tag.typeExpression);
                        pos = tag.end;
                        commentStart = ((_h = tag.typeExpression) == null ? void 0 : _h.end) || commentStart;
                        break;
                }
                if (typeof tag.comment === "object") pushCommentRange(tag.comment.pos, tag.comment.end - tag.comment.pos);
                else if (typeof tag.comment === "string") pushCommentRange(commentStart, tag.end - commentStart);
            }
            if (pos !== docComment.end) pushCommentRange(pos, docComment.end - pos);
            return;
            function processJSDocParameterTag(tag) {
                if (tag.isNameFirst) {
                    pushCommentRange(pos, tag.name.pos - pos);
                    pushClassification(tag.name.pos, tag.name.end - tag.name.pos, 17 /* parameterName */ );
                    pos = tag.name.end;
                }
                if (tag.typeExpression) {
                    pushCommentRange(pos, tag.typeExpression.pos - pos);
                    processElement(tag.typeExpression);
                    pos = tag.typeExpression.end;
                }
                if (!tag.isNameFirst) {
                    pushCommentRange(pos, tag.name.pos - pos);
                    pushClassification(tag.name.pos, tag.name.end - tag.name.pos, 17 /* parameterName */ );
                    pos = tag.name.end;
                }
            }
        }
        function tryClassifyTripleSlashComment(start, width) {
            const tripleSlashXMLCommentRegEx = /^(\/\/\/\s*)(<)(?:(\S+)((?:[^/]|\/[^>])*)(\/>)?)?/im;
            const attributeRegex = /(\s)(\S+)(\s*)(=)(\s*)('[^']+'|"[^"]+")/img;
            const text = sourceFile.text.substr(start, width);
            const match = tripleSlashXMLCommentRegEx.exec(text);
            if (!match) return false;
            if (!match[3] || !(match[3] in commentPragmas)) return false;
            let pos = start;
            pushCommentRange(pos, match[1].length);
            pos += match[1].length;
            pushClassification(pos, match[2].length, 10 /* punctuation */ );
            pos += match[2].length;
            pushClassification(pos, match[3].length, 21 /* jsxSelfClosingTagName */ );
            pos += match[3].length;
            const attrText = match[4];
            let attrPos = pos;
            while(true){
                const attrMatch = attributeRegex.exec(attrText);
                if (!attrMatch) break;
                const newAttrPos = pos + attrMatch.index + attrMatch[1].length;
                if (newAttrPos > attrPos) {
                    pushCommentRange(attrPos, newAttrPos - attrPos);
                    attrPos = newAttrPos;
                }
                pushClassification(attrPos, attrMatch[2].length, 22 /* jsxAttribute */ );
                attrPos += attrMatch[2].length;
                if (attrMatch[3].length) {
                    pushCommentRange(attrPos, attrMatch[3].length);
                    attrPos += attrMatch[3].length;
                }
                pushClassification(attrPos, attrMatch[4].length, 5 /* operator */ );
                attrPos += attrMatch[4].length;
                if (attrMatch[5].length) {
                    pushCommentRange(attrPos, attrMatch[5].length);
                    attrPos += attrMatch[5].length;
                }
                pushClassification(attrPos, attrMatch[6].length, 24 /* jsxAttributeStringLiteralValue */ );
                attrPos += attrMatch[6].length;
            }
            pos += match[4].length;
            if (pos > attrPos) pushCommentRange(attrPos, pos - attrPos);
            if (match[5]) {
                pushClassification(pos, match[5].length, 10 /* punctuation */ );
                pos += match[5].length;
            }
            const end = start + width;
            if (pos < end) pushCommentRange(pos, end - pos);
            return true;
        }
        function processJSDocTemplateTag(tag) {
            for (const child of tag.getChildren())processElement(child);
        }
        function classifyDisabledMergeCode(text, start, end) {
            let i;
            for(i = start; i < end; i++){
                if (isLineBreak(text.charCodeAt(i))) break;
            }
            pushClassification(start, i - start, 1 /* comment */ );
            mergeConflictScanner.resetTokenState(i);
            while(mergeConflictScanner.getTokenEnd() < end)classifyDisabledCodeToken();
        }
        function classifyDisabledCodeToken() {
            const start = mergeConflictScanner.getTokenEnd();
            const tokenKind = mergeConflictScanner.scan();
            const end = mergeConflictScanner.getTokenEnd();
            const type = classifyTokenType(tokenKind);
            if (type) pushClassification(start, end - start, type);
        }
        function tryClassifyNode(node) {
            if (isJSDoc(node)) return true;
            if (nodeIsMissing(node)) return true;
            const classifiedElementName = tryClassifyJsxElementName(node);
            if (!isToken(node) && node.kind !== 12 /* JsxText */  && classifiedElementName === void 0) return false;
            const tokenStart = node.kind === 12 /* JsxText */  ? node.pos : classifyLeadingTriviaAndGetTokenStart(node);
            const tokenWidth = node.end - tokenStart;
            Debug.assert(tokenWidth >= 0);
            if (tokenWidth > 0) {
                const type = classifiedElementName || classifyTokenType(node.kind, node);
                if (type) pushClassification(tokenStart, tokenWidth, type);
            }
            return true;
        }
        function tryClassifyJsxElementName(token) {
            switch(token.parent && token.parent.kind){
                case 285 /* JsxOpeningElement */ :
                    if (token.parent.tagName === token) return 19 /* jsxOpenTagName */ ;
                    break;
                case 286 /* JsxClosingElement */ :
                    if (token.parent.tagName === token) return 20 /* jsxCloseTagName */ ;
                    break;
                case 284 /* JsxSelfClosingElement */ :
                    if (token.parent.tagName === token) return 21 /* jsxSelfClosingTagName */ ;
                    break;
                case 290 /* JsxAttribute */ :
                    if (token.parent.name === token) return 22 /* jsxAttribute */ ;
                    break;
            }
            return void 0;
        }
        function classifyTokenType(tokenKind, token) {
            if (isKeyword(tokenKind)) return 3 /* keyword */ ;
            if (tokenKind === 30 /* LessThanToken */  || tokenKind === 32 /* GreaterThanToken */ ) {
                if (token && getTypeArgumentOrTypeParameterList(token.parent)) return 10 /* punctuation */ ;
            }
            if (isPunctuation(tokenKind)) {
                if (token) {
                    const parent2 = token.parent;
                    if (tokenKind === 64 /* EqualsToken */ ) {
                        if (parent2.kind === 259 /* VariableDeclaration */  || parent2.kind === 171 /* PropertyDeclaration */  || parent2.kind === 168 /* Parameter */  || parent2.kind === 290 /* JsxAttribute */ ) return 5 /* operator */ ;
                    }
                    if (parent2.kind === 225 /* BinaryExpression */  || parent2.kind === 223 /* PrefixUnaryExpression */  || parent2.kind === 224 /* PostfixUnaryExpression */  || parent2.kind === 226 /* ConditionalExpression */ ) return 5 /* operator */ ;
                }
                return 10 /* punctuation */ ;
            } else if (tokenKind === 9 /* NumericLiteral */ ) return 4 /* numericLiteral */ ;
            else if (tokenKind === 10 /* BigIntLiteral */ ) return 25 /* bigintLiteral */ ;
            else if (tokenKind === 11 /* StringLiteral */ ) return token && token.parent.kind === 290 /* JsxAttribute */  ? 24 /* jsxAttributeStringLiteralValue */  : 6 /* stringLiteral */ ;
            else if (tokenKind === 14 /* RegularExpressionLiteral */ ) return 6 /* stringLiteral */ ;
            else if (isTemplateLiteralKind(tokenKind)) return 6 /* stringLiteral */ ;
            else if (tokenKind === 12 /* JsxText */ ) return 23 /* jsxText */ ;
            else if (tokenKind === 80 /* Identifier */ ) {
                if (token) {
                    switch(token.parent.kind){
                        case 262 /* ClassDeclaration */ :
                            if (token.parent.name === token) return 11 /* className */ ;
                            return;
                        case 167 /* TypeParameter */ :
                            if (token.parent.name === token) return 15 /* typeParameterName */ ;
                            return;
                        case 263 /* InterfaceDeclaration */ :
                            if (token.parent.name === token) return 13 /* interfaceName */ ;
                            return;
                        case 265 /* EnumDeclaration */ :
                            if (token.parent.name === token) return 12 /* enumName */ ;
                            return;
                        case 266 /* ModuleDeclaration */ :
                            if (token.parent.name === token) return 14 /* moduleName */ ;
                            return;
                        case 168 /* Parameter */ :
                            if (token.parent.name === token) return isThisIdentifier(token) ? 3 /* keyword */  : 17 /* parameterName */ ;
                            return;
                    }
                    if (isConstTypeReference(token.parent)) return 3 /* keyword */ ;
                }
                return 2 /* identifier */ ;
            }
        }
        function processElement(element) {
            if (!element) return;
            if (decodedTextSpanIntersectsWith(spanStart, spanLength, element.pos, element.getFullWidth())) {
                checkForClassificationCancellation(cancellationToken, element.kind);
                for (const child of element.getChildren(sourceFile))if (!tryClassifyNode(child)) processElement(child);
            }
        }
    }
    var noRegexTable;
    var init_classifier = __esm({
        "src/services/classifier.ts" () {
            "use strict";
            init_ts4();
            noRegexTable = arrayToNumericMap([
                80 /* Identifier */ ,
                11 /* StringLiteral */ ,
                9 /* NumericLiteral */ ,
                10 /* BigIntLiteral */ ,
                14 /* RegularExpressionLiteral */ ,
                110 /* ThisKeyword */ ,
                46 /* PlusPlusToken */ ,
                47 /* MinusMinusToken */ ,
                22 /* CloseParenToken */ ,
                24 /* CloseBracketToken */ ,
                20 /* CloseBraceToken */ ,
                112 /* TrueKeyword */ ,
                97 /* FalseKeyword */ 
            ], (token)=>token, ()=>true);
        }
    });
    // src/services/documentHighlights.ts
    var DocumentHighlights;
    var init_documentHighlights = __esm({
        "src/services/documentHighlights.ts" () {
            "use strict";
            init_ts4();
            ((DocumentHighlights2)=>{
                function getDocumentHighlights(program, cancellationToken, sourceFile, position, sourceFilesToSearch) {
                    const node = getTouchingPropertyName(sourceFile, position);
                    if (node.parent && (isJsxOpeningElement(node.parent) && node.parent.tagName === node || isJsxClosingElement(node.parent))) {
                        const { openingElement: openingElement , closingElement: closingElement  } = node.parent.parent;
                        const highlightSpans = [
                            openingElement,
                            closingElement
                        ].map(({ tagName: tagName  })=>getHighlightSpanForNode(tagName, sourceFile));
                        return [
                            {
                                fileName: sourceFile.fileName,
                                highlightSpans: highlightSpans
                            }
                        ];
                    }
                    return getSemanticDocumentHighlights(position, node, program, cancellationToken, sourceFilesToSearch) || getSyntacticDocumentHighlights(node, sourceFile);
                }
                DocumentHighlights2.getDocumentHighlights = getDocumentHighlights;
                function getHighlightSpanForNode(node, sourceFile) {
                    return {
                        fileName: sourceFile.fileName,
                        textSpan: createTextSpanFromNode(node, sourceFile),
                        kind: "none" /* none */ 
                    };
                }
                function getSemanticDocumentHighlights(position, node, program, cancellationToken, sourceFilesToSearch) {
                    const sourceFilesSet = new Set(sourceFilesToSearch.map((f)=>f.fileName));
                    const referenceEntries = ts_FindAllReferences_exports.getReferenceEntriesForNode(position, node, program, sourceFilesToSearch, cancellationToken, /*options*/ void 0, sourceFilesSet);
                    if (!referenceEntries) return void 0;
                    const map2 = arrayToMultiMap(referenceEntries.map(ts_FindAllReferences_exports.toHighlightSpan), (e)=>e.fileName, (e)=>e.span);
                    const getCanonicalFileName = createGetCanonicalFileName(program.useCaseSensitiveFileNames());
                    return arrayFrom(mapDefinedIterator(map2.entries(), ([fileName, highlightSpans])=>{
                        if (!sourceFilesSet.has(fileName)) {
                            if (!program.redirectTargetsMap.has(toPath(fileName, program.getCurrentDirectory(), getCanonicalFileName))) return void 0;
                            const redirectTarget = program.getSourceFile(fileName);
                            const redirect = find(sourceFilesToSearch, (f)=>!!f.redirectInfo && f.redirectInfo.redirectTarget === redirectTarget);
                            fileName = redirect.fileName;
                            Debug.assert(sourceFilesSet.has(fileName));
                        }
                        return {
                            fileName: fileName,
                            highlightSpans: highlightSpans
                        };
                    }));
                }
                function getSyntacticDocumentHighlights(node, sourceFile) {
                    const highlightSpans = getHighlightSpans(node, sourceFile);
                    return highlightSpans && [
                        {
                            fileName: sourceFile.fileName,
                            highlightSpans: highlightSpans
                        }
                    ];
                }
                function getHighlightSpans(node, sourceFile) {
                    switch(node.kind){
                        case 101 /* IfKeyword */ :
                        case 93 /* ElseKeyword */ :
                            return isIfStatement(node.parent) ? getIfElseOccurrences(node.parent, sourceFile) : void 0;
                        case 107 /* ReturnKeyword */ :
                            return useParent(node.parent, isReturnStatement, getReturnOccurrences);
                        case 111 /* ThrowKeyword */ :
                            return useParent(node.parent, isThrowStatement, getThrowOccurrences);
                        case 113 /* TryKeyword */ :
                        case 85 /* CatchKeyword */ :
                        case 98 /* FinallyKeyword */ :
                            const tryStatement = node.kind === 85 /* CatchKeyword */  ? node.parent.parent : node.parent;
                            return useParent(tryStatement, isTryStatement, getTryCatchFinallyOccurrences);
                        case 109 /* SwitchKeyword */ :
                            return useParent(node.parent, isSwitchStatement, getSwitchCaseDefaultOccurrences);
                        case 84 /* CaseKeyword */ :
                        case 90 /* DefaultKeyword */ :
                            if (isDefaultClause(node.parent) || isCaseClause(node.parent)) return useParent(node.parent.parent.parent, isSwitchStatement, getSwitchCaseDefaultOccurrences);
                            return void 0;
                        case 83 /* BreakKeyword */ :
                        case 88 /* ContinueKeyword */ :
                            return useParent(node.parent, isBreakOrContinueStatement, getBreakOrContinueStatementOccurrences);
                        case 99 /* ForKeyword */ :
                        case 117 /* WhileKeyword */ :
                        case 92 /* DoKeyword */ :
                            return useParent(node.parent, (n)=>isIterationStatement(n, /*lookInLabeledStatements*/ true), getLoopBreakContinueOccurrences);
                        case 137 /* ConstructorKeyword */ :
                            return getFromAllDeclarations(isConstructorDeclaration, [
                                137 /* ConstructorKeyword */ 
                            ]);
                        case 139 /* GetKeyword */ :
                        case 153 /* SetKeyword */ :
                            return getFromAllDeclarations(isAccessor, [
                                139 /* GetKeyword */ ,
                                153 /* SetKeyword */ 
                            ]);
                        case 135 /* AwaitKeyword */ :
                            return useParent(node.parent, isAwaitExpression, getAsyncAndAwaitOccurrences);
                        case 134 /* AsyncKeyword */ :
                            return highlightSpans(getAsyncAndAwaitOccurrences(node));
                        case 127 /* YieldKeyword */ :
                            return highlightSpans(getYieldOccurrences(node));
                        case 103 /* InKeyword */ :
                            return void 0;
                        default:
                            return isModifierKind(node.kind) && (isDeclaration(node.parent) || isVariableStatement(node.parent)) ? highlightSpans(getModifierOccurrences(node.kind, node.parent)) : void 0;
                    }
                    function getFromAllDeclarations(nodeTest, keywords) {
                        return useParent(node.parent, nodeTest, (decl)=>{
                            var _a;
                            return mapDefined((_a = tryCast(decl, canHaveSymbol)) == null ? void 0 : _a.symbol.declarations, (d)=>nodeTest(d) ? find(d.getChildren(sourceFile), (c)=>contains(keywords, c.kind)) : void 0);
                        });
                    }
                    function useParent(node2, nodeTest, getNodes4) {
                        return nodeTest(node2) ? highlightSpans(getNodes4(node2, sourceFile)) : void 0;
                    }
                    function highlightSpans(nodes) {
                        return nodes && nodes.map((node2)=>getHighlightSpanForNode(node2, sourceFile));
                    }
                }
                function aggregateOwnedThrowStatements(node) {
                    if (isThrowStatement(node)) return [
                        node
                    ];
                    else if (isTryStatement(node)) return concatenate(node.catchClause ? aggregateOwnedThrowStatements(node.catchClause) : node.tryBlock && aggregateOwnedThrowStatements(node.tryBlock), node.finallyBlock && aggregateOwnedThrowStatements(node.finallyBlock));
                    return isFunctionLike(node) ? void 0 : flatMapChildren(node, aggregateOwnedThrowStatements);
                }
                function getThrowStatementOwner(throwStatement) {
                    let child = throwStatement;
                    while(child.parent){
                        const parent2 = child.parent;
                        if (isFunctionBlock(parent2) || parent2.kind === 311 /* SourceFile */ ) return parent2;
                        if (isTryStatement(parent2) && parent2.tryBlock === child && parent2.catchClause) return child;
                        child = parent2;
                    }
                    return void 0;
                }
                function aggregateAllBreakAndContinueStatements(node) {
                    return isBreakOrContinueStatement(node) ? [
                        node
                    ] : isFunctionLike(node) ? void 0 : flatMapChildren(node, aggregateAllBreakAndContinueStatements);
                }
                function flatMapChildren(node, cb) {
                    const result = [];
                    node.forEachChild((child)=>{
                        const value1 = cb(child);
                        if (value1 !== void 0) result.push(...toArray(value1));
                    });
                    return result;
                }
                function ownsBreakOrContinueStatement(owner, statement) {
                    const actualOwner = getBreakOrContinueOwner(statement);
                    return !!actualOwner && actualOwner === owner;
                }
                function getBreakOrContinueOwner(statement) {
                    return findAncestor(statement, (node)=>{
                        switch(node.kind){
                            case 254 /* SwitchStatement */ :
                                if (statement.kind === 250 /* ContinueStatement */ ) return false;
                            case 247 /* ForStatement */ :
                            case 248 /* ForInStatement */ :
                            case 249 /* ForOfStatement */ :
                            case 246 /* WhileStatement */ :
                            case 245 /* DoStatement */ :
                                return !statement.label || isLabeledBy(node, statement.label.escapedText);
                            default:
                                return isFunctionLike(node) && "quit";
                        }
                    });
                }
                function getModifierOccurrences(modifier, declaration) {
                    return mapDefined(getNodesToSearchForModifier(declaration, modifierToFlag(modifier)), (node)=>findModifier(node, modifier));
                }
                function getNodesToSearchForModifier(declaration, modifierFlag) {
                    const container = declaration.parent;
                    switch(container.kind){
                        case 267 /* ModuleBlock */ :
                        case 311 /* SourceFile */ :
                        case 240 /* Block */ :
                        case 295 /* CaseClause */ :
                        case 296 /* DefaultClause */ :
                            if (modifierFlag & 256 /* Abstract */  && isClassDeclaration(declaration)) return [
                                ...declaration.members,
                                declaration
                            ];
                            else return container.statements;
                        case 175 /* Constructor */ :
                        case 173 /* MethodDeclaration */ :
                        case 261 /* FunctionDeclaration */ :
                            return [
                                ...container.parameters,
                                ...isClassLike(container.parent) ? container.parent.members : []
                            ];
                        case 262 /* ClassDeclaration */ :
                        case 230 /* ClassExpression */ :
                        case 263 /* InterfaceDeclaration */ :
                        case 186 /* TypeLiteral */ :
                            const nodes = container.members;
                            if (modifierFlag & 92 /* Readonly */ ) {
                                const constructor = find(container.members, isConstructorDeclaration);
                                if (constructor) return [
                                    ...nodes,
                                    ...constructor.parameters
                                ];
                            } else if (modifierFlag & 256 /* Abstract */ ) return [
                                ...nodes,
                                container
                            ];
                            return nodes;
                        case 209 /* ObjectLiteralExpression */ :
                            return void 0;
                        default:
                            Debug.assertNever(container, "Invalid container kind.");
                    }
                }
                function pushKeywordIf(keywordList, token, ...expected) {
                    if (token && contains(expected, token.kind)) {
                        keywordList.push(token);
                        return true;
                    }
                    return false;
                }
                function getLoopBreakContinueOccurrences(loopNode) {
                    const keywords = [];
                    if (pushKeywordIf(keywords, loopNode.getFirstToken(), 99 /* ForKeyword */ , 117 /* WhileKeyword */ , 92 /* DoKeyword */ )) {
                        if (loopNode.kind === 245 /* DoStatement */ ) {
                            const loopTokens = loopNode.getChildren();
                            for(let i = loopTokens.length - 1; i >= 0; i--){
                                if (pushKeywordIf(keywords, loopTokens[i], 117 /* WhileKeyword */ )) break;
                            }
                        }
                    }
                    forEach(aggregateAllBreakAndContinueStatements(loopNode.statement), (statement)=>{
                        if (ownsBreakOrContinueStatement(loopNode, statement)) pushKeywordIf(keywords, statement.getFirstToken(), 83 /* BreakKeyword */ , 88 /* ContinueKeyword */ );
                    });
                    return keywords;
                }
                function getBreakOrContinueStatementOccurrences(breakOrContinueStatement) {
                    const owner = getBreakOrContinueOwner(breakOrContinueStatement);
                    if (owner) switch(owner.kind){
                        case 247 /* ForStatement */ :
                        case 248 /* ForInStatement */ :
                        case 249 /* ForOfStatement */ :
                        case 245 /* DoStatement */ :
                        case 246 /* WhileStatement */ :
                            return getLoopBreakContinueOccurrences(owner);
                        case 254 /* SwitchStatement */ :
                            return getSwitchCaseDefaultOccurrences(owner);
                    }
                    return void 0;
                }
                function getSwitchCaseDefaultOccurrences(switchStatement) {
                    const keywords = [];
                    pushKeywordIf(keywords, switchStatement.getFirstToken(), 109 /* SwitchKeyword */ );
                    forEach(switchStatement.caseBlock.clauses, (clause)=>{
                        pushKeywordIf(keywords, clause.getFirstToken(), 84 /* CaseKeyword */ , 90 /* DefaultKeyword */ );
                        forEach(aggregateAllBreakAndContinueStatements(clause), (statement)=>{
                            if (ownsBreakOrContinueStatement(switchStatement, statement)) pushKeywordIf(keywords, statement.getFirstToken(), 83 /* BreakKeyword */ );
                        });
                    });
                    return keywords;
                }
                function getTryCatchFinallyOccurrences(tryStatement, sourceFile) {
                    const keywords = [];
                    pushKeywordIf(keywords, tryStatement.getFirstToken(), 113 /* TryKeyword */ );
                    if (tryStatement.catchClause) pushKeywordIf(keywords, tryStatement.catchClause.getFirstToken(), 85 /* CatchKeyword */ );
                    if (tryStatement.finallyBlock) {
                        const finallyKeyword = findChildOfKind(tryStatement, 98 /* FinallyKeyword */ , sourceFile);
                        pushKeywordIf(keywords, finallyKeyword, 98 /* FinallyKeyword */ );
                    }
                    return keywords;
                }
                function getThrowOccurrences(throwStatement, sourceFile) {
                    const owner = getThrowStatementOwner(throwStatement);
                    if (!owner) return void 0;
                    const keywords = [];
                    forEach(aggregateOwnedThrowStatements(owner), (throwStatement2)=>{
                        keywords.push(findChildOfKind(throwStatement2, 111 /* ThrowKeyword */ , sourceFile));
                    });
                    if (isFunctionBlock(owner)) forEachReturnStatement(owner, (returnStatement)=>{
                        keywords.push(findChildOfKind(returnStatement, 107 /* ReturnKeyword */ , sourceFile));
                    });
                    return keywords;
                }
                function getReturnOccurrences(returnStatement, sourceFile) {
                    const func = getContainingFunction(returnStatement);
                    if (!func) return void 0;
                    const keywords = [];
                    forEachReturnStatement(cast(func.body, isBlock), (returnStatement2)=>{
                        keywords.push(findChildOfKind(returnStatement2, 107 /* ReturnKeyword */ , sourceFile));
                    });
                    forEach(aggregateOwnedThrowStatements(func.body), (throwStatement)=>{
                        keywords.push(findChildOfKind(throwStatement, 111 /* ThrowKeyword */ , sourceFile));
                    });
                    return keywords;
                }
                function getAsyncAndAwaitOccurrences(node) {
                    const func = getContainingFunction(node);
                    if (!func) return void 0;
                    const keywords = [];
                    if (func.modifiers) func.modifiers.forEach((modifier)=>{
                        pushKeywordIf(keywords, modifier, 134 /* AsyncKeyword */ );
                    });
                    forEachChild(func, (child)=>{
                        traverseWithoutCrossingFunction(child, (node2)=>{
                            if (isAwaitExpression(node2)) pushKeywordIf(keywords, node2.getFirstToken(), 135 /* AwaitKeyword */ );
                        });
                    });
                    return keywords;
                }
                function getYieldOccurrences(node) {
                    const func = getContainingFunction(node);
                    if (!func) return void 0;
                    const keywords = [];
                    forEachChild(func, (child)=>{
                        traverseWithoutCrossingFunction(child, (node2)=>{
                            if (isYieldExpression(node2)) pushKeywordIf(keywords, node2.getFirstToken(), 127 /* YieldKeyword */ );
                        });
                    });
                    return keywords;
                }
                function traverseWithoutCrossingFunction(node, cb) {
                    cb(node);
                    if (!isFunctionLike(node) && !isClassLike(node) && !isInterfaceDeclaration(node) && !isModuleDeclaration(node) && !isTypeAliasDeclaration(node) && !isTypeNode(node)) forEachChild(node, (child)=>traverseWithoutCrossingFunction(child, cb));
                }
                function getIfElseOccurrences(ifStatement, sourceFile) {
                    const keywords = getIfElseKeywords(ifStatement, sourceFile);
                    const result = [];
                    for(let i = 0; i < keywords.length; i++){
                        if (keywords[i].kind === 93 /* ElseKeyword */  && i < keywords.length - 1) {
                            const elseKeyword = keywords[i];
                            const ifKeyword = keywords[i + 1];
                            let shouldCombineElseAndIf = true;
                            for(let j = ifKeyword.getStart(sourceFile) - 1; j >= elseKeyword.end; j--)if (!isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(j))) {
                                shouldCombineElseAndIf = false;
                                break;
                            }
                            if (shouldCombineElseAndIf) {
                                result.push({
                                    fileName: sourceFile.fileName,
                                    textSpan: createTextSpanFromBounds(elseKeyword.getStart(), ifKeyword.end),
                                    kind: "reference" /* reference */ 
                                });
                                i++;
                                continue;
                            }
                        }
                        result.push(getHighlightSpanForNode(keywords[i], sourceFile));
                    }
                    return result;
                }
                function getIfElseKeywords(ifStatement, sourceFile) {
                    const keywords = [];
                    while(isIfStatement(ifStatement.parent) && ifStatement.parent.elseStatement === ifStatement)ifStatement = ifStatement.parent;
                    while(true){
                        const children = ifStatement.getChildren(sourceFile);
                        pushKeywordIf(keywords, children[0], 101 /* IfKeyword */ );
                        for(let i = children.length - 1; i >= 0; i--){
                            if (pushKeywordIf(keywords, children[i], 93 /* ElseKeyword */ )) break;
                        }
                        if (!ifStatement.elseStatement || !isIfStatement(ifStatement.elseStatement)) break;
                        ifStatement = ifStatement.elseStatement;
                    }
                    return keywords;
                }
                function isLabeledBy(node, labelName) {
                    return !!findAncestor(node.parent, (owner)=>!isLabeledStatement(owner) ? "quit" : owner.label.escapedText === labelName);
                }
            })(DocumentHighlights || (DocumentHighlights = {}));
        }
    });
    // src/services/documentRegistry.ts
    function isDocumentRegistryEntry(entry) {
        return !!entry.sourceFile;
    }
    function createDocumentRegistry(useCaseSensitiveFileNames, currentDirectory) {
        return createDocumentRegistryInternal(useCaseSensitiveFileNames, currentDirectory);
    }
    function createDocumentRegistryInternal(useCaseSensitiveFileNames, currentDirectory = "", externalCache) {
        const buckets = /* @__PURE__ */ new Map();
        const getCanonicalFileName = createGetCanonicalFileName(!!useCaseSensitiveFileNames);
        function reportStats() {
            const bucketInfoArray = arrayFrom(buckets.keys()).filter((name)=>name && name.charAt(0) === "_").map((name)=>{
                const entries = buckets.get(name);
                const sourceFiles = [];
                entries.forEach((entry, name2)=>{
                    if (isDocumentRegistryEntry(entry)) sourceFiles.push({
                        name: name2,
                        scriptKind: entry.sourceFile.scriptKind,
                        refCount: entry.languageServiceRefCount
                    });
                    else entry.forEach((value1, scriptKind)=>sourceFiles.push({
                            name: name2,
                            scriptKind: scriptKind,
                            refCount: value1.languageServiceRefCount
                        }));
                });
                sourceFiles.sort((x, y)=>y.refCount - x.refCount);
                return {
                    bucket: name,
                    sourceFiles: sourceFiles
                };
            });
            return JSON.stringify(bucketInfoArray, void 0, 2);
        }
        function getCompilationSettings(settingsOrHost) {
            if (typeof settingsOrHost.getCompilationSettings === "function") return settingsOrHost.getCompilationSettings();
            return settingsOrHost;
        }
        function acquireDocument(fileName, compilationSettings, scriptSnapshot, version2, scriptKind, languageVersionOrOptions) {
            const path = toPath(fileName, currentDirectory, getCanonicalFileName);
            const key = getKeyForCompilationSettings(getCompilationSettings(compilationSettings));
            return acquireDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version2, scriptKind, languageVersionOrOptions);
        }
        function acquireDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version2, scriptKind, languageVersionOrOptions) {
            return acquireOrUpdateDocument(fileName, path, compilationSettings, key, scriptSnapshot, version2, /*acquiring*/ true, scriptKind, languageVersionOrOptions);
        }
        function updateDocument(fileName, compilationSettings, scriptSnapshot, version2, scriptKind, languageVersionOrOptions) {
            const path = toPath(fileName, currentDirectory, getCanonicalFileName);
            const key = getKeyForCompilationSettings(getCompilationSettings(compilationSettings));
            return updateDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version2, scriptKind, languageVersionOrOptions);
        }
        function updateDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version2, scriptKind, languageVersionOrOptions) {
            return acquireOrUpdateDocument(fileName, path, getCompilationSettings(compilationSettings), key, scriptSnapshot, version2, /*acquiring*/ false, scriptKind, languageVersionOrOptions);
        }
        function getDocumentRegistryEntry(bucketEntry, scriptKind) {
            const entry = isDocumentRegistryEntry(bucketEntry) ? bucketEntry : bucketEntry.get(Debug.checkDefined(scriptKind, "If there are more than one scriptKind's for same document the scriptKind should be provided"));
            Debug.assert(scriptKind === void 0 || !entry || entry.sourceFile.scriptKind === scriptKind, `Script kind should match provided ScriptKind:${scriptKind} and sourceFile.scriptKind: ${entry == null ? void 0 : entry.sourceFile.scriptKind}, !entry: ${!entry}`);
            return entry;
        }
        function acquireOrUpdateDocument(fileName, path, compilationSettingsOrHost, key, scriptSnapshot, version2, acquiring, scriptKind, languageVersionOrOptions) {
            var _a, _b, _c, _d;
            scriptKind = ensureScriptKind(fileName, scriptKind);
            const compilationSettings = getCompilationSettings(compilationSettingsOrHost);
            const host = compilationSettingsOrHost === compilationSettings ? void 0 : compilationSettingsOrHost;
            const scriptTarget = scriptKind === 6 /* JSON */  ? 100 /* JSON */  : getEmitScriptTarget(compilationSettings);
            const sourceFileOptions = typeof languageVersionOrOptions === "object" ? languageVersionOrOptions : {
                languageVersion: scriptTarget,
                impliedNodeFormat: host && getImpliedNodeFormatForFile(path, (_d = (_c = (_b = (_a = host.getCompilerHost) == null ? void 0 : _a.call(host)) == null ? void 0 : _b.getModuleResolutionCache) == null ? void 0 : _c.call(_b)) == null ? void 0 : _d.getPackageJsonInfoCache(), host, compilationSettings),
                setExternalModuleIndicator: getSetExternalModuleIndicator(compilationSettings)
            };
            sourceFileOptions.languageVersion = scriptTarget;
            const oldBucketCount = buckets.size;
            const keyWithMode = getDocumentRegistryBucketKeyWithMode(key, sourceFileOptions.impliedNodeFormat);
            const bucket = getOrUpdate(buckets, keyWithMode, ()=>/* @__PURE__ */ new Map());
            if (tracing) {
                if (buckets.size > oldBucketCount) tracing.instant(tracing.Phase.Session, "createdDocumentRegistryBucket", {
                    configFilePath: compilationSettings.configFilePath,
                    key: keyWithMode
                });
                const otherBucketKey = !isDeclarationFileName(path) && forEachEntry(buckets, (bucket2, bucketKey)=>bucketKey !== keyWithMode && bucket2.has(path) && bucketKey);
                if (otherBucketKey) tracing.instant(tracing.Phase.Session, "documentRegistryBucketOverlap", {
                    path: path,
                    key1: otherBucketKey,
                    key2: keyWithMode
                });
            }
            const bucketEntry = bucket.get(path);
            let entry = bucketEntry && getDocumentRegistryEntry(bucketEntry, scriptKind);
            if (!entry && externalCache) {
                const sourceFile = externalCache.getDocument(keyWithMode, path);
                if (sourceFile) {
                    Debug.assert(acquiring);
                    entry = {
                        sourceFile: sourceFile,
                        languageServiceRefCount: 0
                    };
                    setBucketEntry();
                }
            }
            if (!entry) {
                const sourceFile = createLanguageServiceSourceFile(fileName, scriptSnapshot, sourceFileOptions, version2, /*setNodeParents*/ false, scriptKind);
                if (externalCache) externalCache.setDocument(keyWithMode, path, sourceFile);
                entry = {
                    sourceFile: sourceFile,
                    languageServiceRefCount: 1
                };
                setBucketEntry();
            } else {
                if (entry.sourceFile.version !== version2) {
                    entry.sourceFile = updateLanguageServiceSourceFile(entry.sourceFile, scriptSnapshot, version2, scriptSnapshot.getChangeRange(entry.sourceFile.scriptSnapshot));
                    if (externalCache) externalCache.setDocument(keyWithMode, path, entry.sourceFile);
                }
                if (acquiring) entry.languageServiceRefCount++;
            }
            Debug.assert(entry.languageServiceRefCount !== 0);
            return entry.sourceFile;
            function setBucketEntry() {
                if (!bucketEntry) bucket.set(path, entry);
                else if (isDocumentRegistryEntry(bucketEntry)) {
                    const scriptKindMap = /* @__PURE__ */ new Map();
                    scriptKindMap.set(bucketEntry.sourceFile.scriptKind, bucketEntry);
                    scriptKindMap.set(scriptKind, entry);
                    bucket.set(path, scriptKindMap);
                } else bucketEntry.set(scriptKind, entry);
            }
        }
        function releaseDocument(fileName, compilationSettings, scriptKind, impliedNodeFormat) {
            const path = toPath(fileName, currentDirectory, getCanonicalFileName);
            const key = getKeyForCompilationSettings(compilationSettings);
            return releaseDocumentWithKey(path, key, scriptKind, impliedNodeFormat);
        }
        function releaseDocumentWithKey(path, key, scriptKind, impliedNodeFormat) {
            const bucket = Debug.checkDefined(buckets.get(getDocumentRegistryBucketKeyWithMode(key, impliedNodeFormat)));
            const bucketEntry = bucket.get(path);
            const entry = getDocumentRegistryEntry(bucketEntry, scriptKind);
            entry.languageServiceRefCount--;
            Debug.assert(entry.languageServiceRefCount >= 0);
            if (entry.languageServiceRefCount === 0) {
                if (isDocumentRegistryEntry(bucketEntry)) bucket.delete(path);
                else {
                    bucketEntry.delete(scriptKind);
                    if (bucketEntry.size === 1) bucket.set(path, firstDefinedIterator(bucketEntry.values(), identity));
                }
            }
        }
        function getLanguageServiceRefCounts(path, scriptKind) {
            return arrayFrom(buckets.entries(), ([key, bucket])=>{
                const bucketEntry = bucket.get(path);
                const entry = bucketEntry && getDocumentRegistryEntry(bucketEntry, scriptKind);
                return [
                    key,
                    entry && entry.languageServiceRefCount
                ];
            });
        }
        return {
            acquireDocument: acquireDocument,
            acquireDocumentWithKey: acquireDocumentWithKey,
            updateDocument: updateDocument,
            updateDocumentWithKey: updateDocumentWithKey,
            releaseDocument: releaseDocument,
            releaseDocumentWithKey: releaseDocumentWithKey,
            getLanguageServiceRefCounts: getLanguageServiceRefCounts,
            reportStats: reportStats,
            getKeyForCompilationSettings: getKeyForCompilationSettings
        };
    }
    function getKeyForCompilationSettings(settings) {
        return getKeyForCompilerOptions(settings, sourceFileAffectingCompilerOptions);
    }
    function getDocumentRegistryBucketKeyWithMode(key, mode) {
        return mode ? `${key}|${mode}` : key;
    }
    var init_documentRegistry = __esm({
        "src/services/documentRegistry.ts" () {
            "use strict";
            init_ts4();
        }
    });
    // src/services/getEditsForFileRename.ts
    function getEditsForFileRename(program, oldFileOrDirPath, newFileOrDirPath, host, formatContext, preferences, sourceMapper) {
        const useCaseSensitiveFileNames = hostUsesCaseSensitiveFileNames(host);
        const getCanonicalFileName = createGetCanonicalFileName(useCaseSensitiveFileNames);
        const oldToNew = getPathUpdater(oldFileOrDirPath, newFileOrDirPath, getCanonicalFileName, sourceMapper);
        const newToOld = getPathUpdater(newFileOrDirPath, oldFileOrDirPath, getCanonicalFileName, sourceMapper);
        return ts_textChanges_exports.ChangeTracker.with({
            host: host,
            formatContext: formatContext,
            preferences: preferences
        }, (changeTracker)=>{
            updateTsconfigFiles(program, changeTracker, oldToNew, oldFileOrDirPath, newFileOrDirPath, host.getCurrentDirectory(), useCaseSensitiveFileNames);
            updateImports(program, changeTracker, oldToNew, newToOld, host, getCanonicalFileName);
        });
    }
    function getPathUpdater(oldFileOrDirPath, newFileOrDirPath, getCanonicalFileName, sourceMapper) {
        const canonicalOldPath = getCanonicalFileName(oldFileOrDirPath);
        return (path)=>{
            const originalPath = sourceMapper && sourceMapper.tryGetSourcePosition({
                fileName: path,
                pos: 0
            });
            const updatedPath = getUpdatedPath(originalPath ? originalPath.fileName : path);
            return originalPath ? updatedPath === void 0 ? void 0 : makeCorrespondingRelativeChange(originalPath.fileName, updatedPath, path, getCanonicalFileName) : updatedPath;
        };
        function getUpdatedPath(pathToUpdate) {
            if (getCanonicalFileName(pathToUpdate) === canonicalOldPath) return newFileOrDirPath;
            const suffix = tryRemoveDirectoryPrefix(pathToUpdate, canonicalOldPath, getCanonicalFileName);
            return suffix === void 0 ? void 0 : newFileOrDirPath + "/" + suffix;
        }
    }
    function makeCorrespondingRelativeChange(a0, b0, a1, getCanonicalFileName) {
        const rel = getRelativePathFromFile(a0, b0, getCanonicalFileName);
        return combinePathsSafe(getDirectoryPath(a1), rel);
    }
    function updateTsconfigFiles(program, changeTracker, oldToNew, oldFileOrDirPath, newFileOrDirPath, currentDirectory, useCaseSensitiveFileNames) {
        const { configFile: configFile  } = program.getCompilerOptions();
        if (!configFile) return;
        const configDir = getDirectoryPath(configFile.fileName);
        const jsonObjectLiteral = getTsConfigObjectLiteralExpression(configFile);
        if (!jsonObjectLiteral) return;
        forEachProperty(jsonObjectLiteral, (property, propertyName)=>{
            switch(propertyName){
                case "files":
                case "include":
                case "exclude":
                    {
                        const foundExactMatch = updatePaths(property);
                        if (foundExactMatch || propertyName !== "include" || !isArrayLiteralExpression(property.initializer)) return;
                        const includes = mapDefined(property.initializer.elements, (e)=>isStringLiteral(e) ? e.text : void 0);
                        if (includes.length === 0) return;
                        const matchers = getFileMatcherPatterns(configDir, /*excludes*/ [], includes, useCaseSensitiveFileNames, currentDirectory);
                        if (getRegexFromPattern(Debug.checkDefined(matchers.includeFilePattern), useCaseSensitiveFileNames).test(oldFileOrDirPath) && !getRegexFromPattern(Debug.checkDefined(matchers.includeFilePattern), useCaseSensitiveFileNames).test(newFileOrDirPath)) changeTracker.insertNodeAfter(configFile, last(property.initializer.elements), factory.createStringLiteral(relativePath(newFileOrDirPath)));
                        return;
                    }
                case "compilerOptions":
                    forEachProperty(property.initializer, (property2, propertyName2)=>{
                        const option = getOptionFromName(propertyName2);
                        Debug.assert((option == null ? void 0 : option.type) !== "listOrElement");
                        if (option && (option.isFilePath || option.type === "list" && option.element.isFilePath)) updatePaths(property2);
                        else if (propertyName2 === "paths") forEachProperty(property2.initializer, (pathsProperty)=>{
                            if (!isArrayLiteralExpression(pathsProperty.initializer)) return;
                            for (const e of pathsProperty.initializer.elements)tryUpdateString(e);
                        });
                    });
                    return;
            }
        });
        function updatePaths(property) {
            const elements = isArrayLiteralExpression(property.initializer) ? property.initializer.elements : [
                property.initializer
            ];
            let foundExactMatch = false;
            for (const element of elements)foundExactMatch = tryUpdateString(element) || foundExactMatch;
            return foundExactMatch;
        }
        function tryUpdateString(element) {
            if (!isStringLiteral(element)) return false;
            const elementFileName = combinePathsSafe(configDir, element.text);
            const updated = oldToNew(elementFileName);
            if (updated !== void 0) {
                changeTracker.replaceRangeWithText(configFile, createStringRange(element, configFile), relativePath(updated));
                return true;
            }
            return false;
        }
        function relativePath(path) {
            return getRelativePathFromDirectory(configDir, path, /*ignoreCase*/ !useCaseSensitiveFileNames);
        }
    }
    function updateImports(program, changeTracker, oldToNew, newToOld, host, getCanonicalFileName) {
        const allFiles = program.getSourceFiles();
        for (const sourceFile of allFiles){
            const newFromOld = oldToNew(sourceFile.fileName);
            const newImportFromPath = newFromOld ?? sourceFile.fileName;
            const newImportFromDirectory = getDirectoryPath(newImportFromPath);
            const oldFromNew = newToOld(sourceFile.fileName);
            const oldImportFromPath = oldFromNew || sourceFile.fileName;
            const oldImportFromDirectory = getDirectoryPath(oldImportFromPath);
            const importingSourceFileMoved = newFromOld !== void 0 || oldFromNew !== void 0;
            updateImportsWorker(sourceFile, changeTracker, (referenceText)=>{
                if (!pathIsRelative(referenceText)) return void 0;
                const oldAbsolute = combinePathsSafe(oldImportFromDirectory, referenceText);
                const newAbsolute = oldToNew(oldAbsolute);
                return newAbsolute === void 0 ? void 0 : ensurePathIsNonModuleName(getRelativePathFromDirectory(newImportFromDirectory, newAbsolute, getCanonicalFileName));
            }, (importLiteral)=>{
                const importedModuleSymbol = program.getTypeChecker().getSymbolAtLocation(importLiteral);
                if ((importedModuleSymbol == null ? void 0 : importedModuleSymbol.declarations) && importedModuleSymbol.declarations.some((d)=>isAmbientModule(d))) return void 0;
                const toImport = oldFromNew !== void 0 ? getSourceFileToImportFromResolved(importLiteral, resolveModuleName(importLiteral.text, oldImportFromPath, program.getCompilerOptions(), host), oldToNew, allFiles) : getSourceFileToImport(importedModuleSymbol, importLiteral, sourceFile, program, host, oldToNew);
                return toImport !== void 0 && (toImport.updated || importingSourceFileMoved && pathIsRelative(importLiteral.text)) ? ts_moduleSpecifiers_exports.updateModuleSpecifier(program.getCompilerOptions(), sourceFile, getCanonicalFileName(newImportFromPath), toImport.newFileName, createModuleSpecifierResolutionHost(program, host), importLiteral.text) : void 0;
            });
        }
    }
    function combineNormal(pathA, pathB) {
        return normalizePath(combinePaths(pathA, pathB));
    }
    function combinePathsSafe(pathA, pathB) {
        return ensurePathIsNonModuleName(combineNormal(pathA, pathB));
    }
    function getSourceFileToImport(importedModuleSymbol, importLiteral, importingSourceFile, program, host, oldToNew) {
        var _a;
        if (importedModuleSymbol) {
            const oldFileName = find(importedModuleSymbol.declarations, isSourceFile).fileName;
            const newFileName = oldToNew(oldFileName);
            return newFileName === void 0 ? {
                newFileName: oldFileName,
                updated: false
            } : {
                newFileName: newFileName,
                updated: true
            };
        } else {
            const mode = getModeForUsageLocation(importingSourceFile, importLiteral);
            const resolved = host.resolveModuleNameLiterals || !host.resolveModuleNames ? (_a = importingSourceFile.resolvedModules) == null ? void 0 : _a.get(importLiteral.text, mode) : host.getResolvedModuleWithFailedLookupLocationsFromCache && host.getResolvedModuleWithFailedLookupLocationsFromCache(importLiteral.text, importingSourceFile.fileName, mode);
            return getSourceFileToImportFromResolved(importLiteral, resolved, oldToNew, program.getSourceFiles());
        }
    }
    function getSourceFileToImportFromResolved(importLiteral, resolved, oldToNew, sourceFiles) {
        if (!resolved) return void 0;
        if (resolved.resolvedModule) {
            const result2 = tryChange(resolved.resolvedModule.resolvedFileName);
            if (result2) return result2;
        }
        const result = forEach(resolved.failedLookupLocations, tryChangeWithIgnoringPackageJsonExisting) || pathIsRelative(importLiteral.text) && forEach(resolved.failedLookupLocations, tryChangeWithIgnoringPackageJson);
        if (result) return result;
        return resolved.resolvedModule && {
            newFileName: resolved.resolvedModule.resolvedFileName,
            updated: false
        };
        function tryChangeWithIgnoringPackageJsonExisting(oldFileName) {
            const newFileName = oldToNew(oldFileName);
            return newFileName && find(sourceFiles, (src)=>src.fileName === newFileName) ? tryChangeWithIgnoringPackageJson(oldFileName) : void 0;
        }
        function tryChangeWithIgnoringPackageJson(oldFileName) {
            return !endsWith(oldFileName, "/package.json") ? tryChange(oldFileName) : void 0;
        }
        function tryChange(oldFileName) {
            const newFileName = oldToNew(oldFileName);
            return newFileName && {
                newFileName: newFileName,
                updated: true
            };
        }
    }
    function updateImportsWorker(sourceFile, changeTracker, updateRef, updateImport2) {
        for (const ref of sourceFile.referencedFiles || emptyArray){
            const updated = updateRef(ref.fileName);
            if (updated !== void 0 && updated !== sourceFile.text.slice(ref.pos, ref.end)) changeTracker.replaceRangeWithText(sourceFile, ref, updated);
        }
        for (const importStringLiteral of sourceFile.imports){
            const updated = updateImport2(importStringLiteral);
            if (updated !== void 0 && updated !== importStringLiteral.text) changeTracker.replaceRangeWithText(sourceFile, createStringRange(importStringLiteral, sourceFile), updated);
        }
    }
    function createStringRange(node, sourceFile) {
        return createRange(node.getStart(sourceFile) + 1, node.end - 1);
    }
    function forEachProperty(objectLiteral, cb) {
        if (!isObjectLiteralExpression(objectLiteral)) return;
        for (const property of objectLiteral.properties)if (isPropertyAssignment(property) && isStringLiteral(property.name)) cb(property, property.name.text);
    }
    var init_getEditsForFileRename = __esm({
        "src/services/getEditsForFileRename.ts" () {
            "use strict";
            init_ts4();
        }
    });
    // src/services/patternMatcher.ts
    function createPatternMatch(kind, isCaseSensitive) {
        return {
            kind: kind,
            isCaseSensitive: isCaseSensitive
        };
    }
    function createPatternMatcher(pattern) {
        const stringToWordSpans = /* @__PURE__ */ new Map();
        const dotSeparatedSegments = pattern.trim().split(".").map((p)=>createSegment(p.trim()));
        if (dotSeparatedSegments.some((segment)=>!segment.subWordTextChunks.length)) return void 0;
        return {
            getFullMatch: (containers, candidate)=>getFullMatch(containers, candidate, dotSeparatedSegments, stringToWordSpans),
            getMatchForLastSegmentOfPattern: (candidate)=>matchSegment(candidate, last(dotSeparatedSegments), stringToWordSpans),
            patternContainsDots: dotSeparatedSegments.length > 1
        };
    }
    function getFullMatch(candidateContainers, candidate, dotSeparatedSegments, stringToWordSpans) {
        const candidateMatch = matchSegment(candidate, last(dotSeparatedSegments), stringToWordSpans);
        if (!candidateMatch) return void 0;
        if (dotSeparatedSegments.length - 1 > candidateContainers.length) return void 0;
        let bestMatch;
        for(let i = dotSeparatedSegments.length - 2, j = candidateContainers.length - 1; i >= 0; i -= 1, j -= 1)bestMatch = betterMatch(bestMatch, matchSegment(candidateContainers[j], dotSeparatedSegments[i], stringToWordSpans));
        return bestMatch;
    }
    function getWordSpans(word, stringToWordSpans) {
        let spans = stringToWordSpans.get(word);
        if (!spans) stringToWordSpans.set(word, spans = breakIntoWordSpans(word));
        return spans;
    }
    function matchTextChunk(candidate, chunk, stringToWordSpans) {
        const index = indexOfIgnoringCase(candidate, chunk.textLowerCase);
        if (index === 0) return createPatternMatch(chunk.text.length === candidate.length ? 0 /* exact */  : 1 /* prefix */ , /*isCaseSensitive:*/ startsWith(candidate, chunk.text));
        if (chunk.isLowerCase) {
            if (index === -1) return void 0;
            const wordSpans = getWordSpans(candidate, stringToWordSpans);
            for (const span of wordSpans){
                if (partStartsWith(candidate, span, chunk.text, /*ignoreCase*/ true)) return createPatternMatch(2 /* substring */ , /*isCaseSensitive:*/ partStartsWith(candidate, span, chunk.text, /*ignoreCase*/ false));
            }
            if (chunk.text.length < candidate.length && isUpperCaseLetter(candidate.charCodeAt(index))) return createPatternMatch(2 /* substring */ , /*isCaseSensitive*/ false);
        } else {
            if (candidate.indexOf(chunk.text) > 0) return createPatternMatch(2 /* substring */ , /*isCaseSensitive*/ true);
            if (chunk.characterSpans.length > 0) {
                const candidateParts = getWordSpans(candidate, stringToWordSpans);
                const isCaseSensitive = tryCamelCaseMatch(candidate, candidateParts, chunk, /*ignoreCase*/ false) ? true : tryCamelCaseMatch(candidate, candidateParts, chunk, /*ignoreCase*/ true) ? false : void 0;
                if (isCaseSensitive !== void 0) return createPatternMatch(3 /* camelCase */ , isCaseSensitive);
            }
        }
    }
    function matchSegment(candidate, segment, stringToWordSpans) {
        if (every2(segment.totalTextChunk.text, (ch)=>ch !== 32 /* space */  && ch !== 42 /* asterisk */ )) {
            const match = matchTextChunk(candidate, segment.totalTextChunk, stringToWordSpans);
            if (match) return match;
        }
        const subWordTextChunks = segment.subWordTextChunks;
        let bestMatch;
        for (const subWordTextChunk of subWordTextChunks)bestMatch = betterMatch(bestMatch, matchTextChunk(candidate, subWordTextChunk, stringToWordSpans));
        return bestMatch;
    }
    function betterMatch(a, b) {
        return min([
            a,
            b
        ], compareMatches);
    }
    function compareMatches(a, b) {
        return a === void 0 ? 1 /* GreaterThan */  : b === void 0 ? -1 /* LessThan */  : compareValues(a.kind, b.kind) || compareBooleans(!a.isCaseSensitive, !b.isCaseSensitive);
    }
    function partStartsWith(candidate, candidateSpan, pattern, ignoreCase, patternSpan = {
        start: 0,
        length: pattern.length
    }) {
        return patternSpan.length <= candidateSpan.length && everyInRange(0, patternSpan.length, (i)=>equalChars(pattern.charCodeAt(patternSpan.start + i), candidate.charCodeAt(candidateSpan.start + i), ignoreCase));
    }
    function equalChars(ch1, ch2, ignoreCase) {
        return ignoreCase ? toLowerCase2(ch1) === toLowerCase2(ch2) : ch1 === ch2;
    }
    function tryCamelCaseMatch(candidate, candidateParts, chunk, ignoreCase) {
        const chunkCharacterSpans = chunk.characterSpans;
        let currentCandidate = 0;
        let currentChunkSpan = 0;
        let firstMatch;
        let contiguous;
        while(true){
            if (currentChunkSpan === chunkCharacterSpans.length) return true;
            else if (currentCandidate === candidateParts.length) return false;
            let candidatePart = candidateParts[currentCandidate];
            let gotOneMatchThisCandidate = false;
            for(; currentChunkSpan < chunkCharacterSpans.length; currentChunkSpan++){
                const chunkCharacterSpan = chunkCharacterSpans[currentChunkSpan];
                if (gotOneMatchThisCandidate) {
                    if (!isUpperCaseLetter(chunk.text.charCodeAt(chunkCharacterSpans[currentChunkSpan - 1].start)) || !isUpperCaseLetter(chunk.text.charCodeAt(chunkCharacterSpans[currentChunkSpan].start))) break;
                }
                if (!partStartsWith(candidate, candidatePart, chunk.text, ignoreCase, chunkCharacterSpan)) break;
                gotOneMatchThisCandidate = true;
                firstMatch = firstMatch === void 0 ? currentCandidate : firstMatch;
                contiguous = contiguous === void 0 ? true : contiguous;
                candidatePart = createTextSpan(candidatePart.start + chunkCharacterSpan.length, candidatePart.length - chunkCharacterSpan.length);
            }
            if (!gotOneMatchThisCandidate && contiguous !== void 0) contiguous = false;
            currentCandidate++;
        }
    }
    function createSegment(text) {
        return {
            totalTextChunk: createTextChunk(text),
            subWordTextChunks: breakPatternIntoTextChunks(text)
        };
    }
    function isUpperCaseLetter(ch) {
        if (ch >= 65 /* A */  && ch <= 90 /* Z */ ) return true;
        if (ch < 127 /* maxAsciiCharacter */  || !isUnicodeIdentifierStart(ch, 99 /* Latest */ )) return false;
        const str = String.fromCharCode(ch);
        return str === str.toUpperCase();
    }
    function isLowerCaseLetter(ch) {
        if (ch >= 97 /* a */  && ch <= 122 /* z */ ) return true;
        if (ch < 127 /* maxAsciiCharacter */  || !isUnicodeIdentifierStart(ch, 99 /* Latest */ )) return false;
        const str = String.fromCharCode(ch);
        return str === str.toLowerCase();
    }
    function indexOfIgnoringCase(str, value1) {
        const n = str.length - value1.length;
        for(let start = 0; start <= n; start++){
            if (every2(value1, (valueChar, i)=>toLowerCase2(str.charCodeAt(i + start)) === valueChar)) return start;
        }
        return -1;
    }
    function toLowerCase2(ch) {
        if (ch >= 65 /* A */  && ch <= 90 /* Z */ ) return 97 /* a */  + (ch - 65 /* A */ );
        if (ch < 127 /* maxAsciiCharacter */ ) return ch;
        return String.fromCharCode(ch).toLowerCase().charCodeAt(0);
    }
    function isDigit2(ch) {
        return ch >= 48 /* _0 */  && ch <= 57 /* _9 */ ;
    }
    function isWordChar(ch) {
        return isUpperCaseLetter(ch) || isLowerCaseLetter(ch) || isDigit2(ch) || ch === 95 /* _ */  || ch === 36 /* $ */ ;
    }
    function breakPatternIntoTextChunks(pattern) {
        const result = [];
        let wordStart = 0;
        let wordLength = 0;
        for(let i = 0; i < pattern.length; i++){
            const ch = pattern.charCodeAt(i);
            if (isWordChar(ch)) {
                if (wordLength === 0) wordStart = i;
                wordLength++;
            } else if (wordLength > 0) {
                result.push(createTextChunk(pattern.substr(wordStart, wordLength)));
                wordLength = 0;
            }
        }
        if (wordLength > 0) result.push(createTextChunk(pattern.substr(wordStart, wordLength)));
        return result;
    }
    function createTextChunk(text) {
        const textLowerCase = text.toLowerCase();
        return {
            text: text,
            textLowerCase: textLowerCase,
            isLowerCase: text === textLowerCase,
            characterSpans: breakIntoCharacterSpans(text)
        };
    }
    function breakIntoCharacterSpans(identifier) {
        return breakIntoSpans(identifier, /*word*/ false);
    }
    function breakIntoWordSpans(identifier) {
        return breakIntoSpans(identifier, /*word*/ true);
    }
    function breakIntoSpans(identifier, word) {
        const result = [];
        let wordStart = 0;
        for(let i = 1; i < identifier.length; i++){
            const lastIsDigit = isDigit2(identifier.charCodeAt(i - 1));
            const currentIsDigit = isDigit2(identifier.charCodeAt(i));
            const hasTransitionFromLowerToUpper = transitionFromLowerToUpper(identifier, word, i);
            const hasTransitionFromUpperToLower = word && transitionFromUpperToLower(identifier, i, wordStart);
            if (charIsPunctuation(identifier.charCodeAt(i - 1)) || charIsPunctuation(identifier.charCodeAt(i)) || lastIsDigit !== currentIsDigit || hasTransitionFromLowerToUpper || hasTransitionFromUpperToLower) {
                if (!isAllPunctuation(identifier, wordStart, i)) result.push(createTextSpan(wordStart, i - wordStart));
                wordStart = i;
            }
        }
        if (!isAllPunctuation(identifier, wordStart, identifier.length)) result.push(createTextSpan(wordStart, identifier.length - wordStart));
        return result;
    }
    function charIsPunctuation(ch) {
        switch(ch){
            case 33 /* exclamation */ :
            case 34 /* doubleQuote */ :
            case 35 /* hash */ :
            case 37 /* percent */ :
            case 38 /* ampersand */ :
            case 39 /* singleQuote */ :
            case 40 /* openParen */ :
            case 41 /* closeParen */ :
            case 42 /* asterisk */ :
            case 44 /* comma */ :
            case 45 /* minus */ :
            case 46 /* dot */ :
            case 47 /* slash */ :
            case 58 /* colon */ :
            case 59 /* semicolon */ :
            case 63 /* question */ :
            case 64 /* at */ :
            case 91 /* openBracket */ :
            case 92 /* backslash */ :
            case 93 /* closeBracket */ :
            case 95 /* _ */ :
            case 123 /* openBrace */ :
            case 125 /* closeBrace */ :
                return true;
        }
        return false;
    }
    function isAllPunctuation(identifier, start, end) {
        return every2(identifier, (ch)=>charIsPunctuation(ch) && ch !== 95 /* _ */ , start, end);
    }
    function transitionFromUpperToLower(identifier, index, wordStart) {
        return index !== wordStart && index + 1 < identifier.length && isUpperCaseLetter(identifier.charCodeAt(index)) && isLowerCaseLetter(identifier.charCodeAt(index + 1)) && every2(identifier, isUpperCaseLetter, wordStart, index);
    }
    function transitionFromLowerToUpper(identifier, word, index) {
        const lastIsUpper = isUpperCaseLetter(identifier.charCodeAt(index - 1));
        const currentIsUpper = isUpperCaseLetter(identifier.charCodeAt(index));
        return currentIsUpper && (!word || !lastIsUpper);
    }
    function everyInRange(start, end, pred) {
        for(let i = start; i < end; i++){
            if (!pred(i)) return false;
        }
        return true;
    }
    function every2(s, pred, start = 0, end = s.length) {
        return everyInRange(start, end, (i)=>pred(s.charCodeAt(i), i));
    }
    var PatternMatchKind;
    var init_patternMatcher = __esm({
        "src/services/patternMatcher.ts" () {
            "use strict";
            init_ts4();
            PatternMatchKind = /* @__PURE__ */ ((PatternMatchKind2)=>{
                PatternMatchKind2[PatternMatchKind2["exact"] = 0] = "exact";
                PatternMatchKind2[PatternMatchKind2["prefix"] = 1] = "prefix";
                PatternMatchKind2[PatternMatchKind2["substring"] = 2] = "substring";
                PatternMatchKind2[PatternMatchKind2["camelCase"] = 3] = "camelCase";
                return PatternMatchKind2;
            })(PatternMatchKind || {});
        }
    });
    // src/services/preProcess.ts
    function preProcessFile(sourceText, readImportFiles = true, detectJavaScriptImports = false) {
        const pragmaContext = {
            languageVersion: 1 /* ES5 */ ,
            // controls whether the token scanner considers unicode identifiers or not - shouldn't matter, since we're only using it for trivia
            pragmas: void 0,
            checkJsDirective: void 0,
            referencedFiles: [],
            typeReferenceDirectives: [],
            libReferenceDirectives: [],
            amdDependencies: [],
            hasNoDefaultLib: void 0,
            moduleName: void 0
        };
        const importedFiles = [];
        let ambientExternalModules;
        let lastToken;
        let currentToken;
        let braceNesting = 0;
        let externalModule = false;
        function nextToken() {
            lastToken = currentToken;
            currentToken = scanner.scan();
            if (currentToken === 19 /* OpenBraceToken */ ) braceNesting++;
            else if (currentToken === 20 /* CloseBraceToken */ ) braceNesting--;
            return currentToken;
        }
        function getFileReference() {
            const fileName = scanner.getTokenValue();
            const pos = scanner.getTokenStart();
            return {
                fileName: fileName,
                pos: pos,
                end: pos + fileName.length
            };
        }
        function recordAmbientExternalModule() {
            if (!ambientExternalModules) ambientExternalModules = [];
            ambientExternalModules.push({
                ref: getFileReference(),
                depth: braceNesting
            });
        }
        function recordModuleName() {
            importedFiles.push(getFileReference());
            markAsExternalModuleIfTopLevel();
        }
        function markAsExternalModuleIfTopLevel() {
            if (braceNesting === 0) externalModule = true;
        }
        function tryConsumeDeclare() {
            let token = scanner.getToken();
            if (token === 138 /* DeclareKeyword */ ) {
                token = nextToken();
                if (token === 144 /* ModuleKeyword */ ) {
                    token = nextToken();
                    if (token === 11 /* StringLiteral */ ) recordAmbientExternalModule();
                }
                return true;
            }
            return false;
        }
        function tryConsumeImport() {
            if (lastToken === 25 /* DotToken */ ) return false;
            let token = scanner.getToken();
            if (token === 102 /* ImportKeyword */ ) {
                token = nextToken();
                if (token === 21 /* OpenParenToken */ ) {
                    token = nextToken();
                    if (token === 11 /* StringLiteral */  || token === 15 /* NoSubstitutionTemplateLiteral */ ) {
                        recordModuleName();
                        return true;
                    }
                } else if (token === 11 /* StringLiteral */ ) {
                    recordModuleName();
                    return true;
                } else {
                    if (token === 156 /* TypeKeyword */ ) {
                        const skipTypeKeyword = scanner.lookAhead(()=>{
                            const token2 = scanner.scan();
                            return token2 !== 160 /* FromKeyword */  && (token2 === 42 /* AsteriskToken */  || token2 === 19 /* OpenBraceToken */  || token2 === 80 /* Identifier */  || isKeyword(token2));
                        });
                        if (skipTypeKeyword) token = nextToken();
                    }
                    if (token === 80 /* Identifier */  || isKeyword(token)) {
                        token = nextToken();
                        if (token === 160 /* FromKeyword */ ) {
                            token = nextToken();
                            if (token === 11 /* StringLiteral */ ) {
                                recordModuleName();
                                return true;
                            }
                        } else if (token === 64 /* EqualsToken */ ) {
                            if (tryConsumeRequireCall(/*skipCurrentToken*/ true)) return true;
                        } else if (token === 28 /* CommaToken */ ) token = nextToken();
                        else return true;
                    }
                    if (token === 19 /* OpenBraceToken */ ) {
                        token = nextToken();
                        while(token !== 20 /* CloseBraceToken */  && token !== 1 /* EndOfFileToken */ )token = nextToken();
                        if (token === 20 /* CloseBraceToken */ ) {
                            token = nextToken();
                            if (token === 160 /* FromKeyword */ ) {
                                token = nextToken();
                                if (token === 11 /* StringLiteral */ ) recordModuleName();
                            }
                        }
                    } else if (token === 42 /* AsteriskToken */ ) {
                        token = nextToken();
                        if (token === 130 /* AsKeyword */ ) {
                            token = nextToken();
                            if (token === 80 /* Identifier */  || isKeyword(token)) {
                                token = nextToken();
                                if (token === 160 /* FromKeyword */ ) {
                                    token = nextToken();
                                    if (token === 11 /* StringLiteral */ ) recordModuleName();
                                }
                            }
                        }
                    }
                }
                return true;
            }
            return false;
        }
        function tryConsumeExport() {
            let token = scanner.getToken();
            if (token === 95 /* ExportKeyword */ ) {
                markAsExternalModuleIfTopLevel();
                token = nextToken();
                if (token === 156 /* TypeKeyword */ ) {
                    const skipTypeKeyword = scanner.lookAhead(()=>{
                        const token2 = scanner.scan();
                        return token2 === 42 /* AsteriskToken */  || token2 === 19 /* OpenBraceToken */ ;
                    });
                    if (skipTypeKeyword) token = nextToken();
                }
                if (token === 19 /* OpenBraceToken */ ) {
                    token = nextToken();
                    while(token !== 20 /* CloseBraceToken */  && token !== 1 /* EndOfFileToken */ )token = nextToken();
                    if (token === 20 /* CloseBraceToken */ ) {
                        token = nextToken();
                        if (token === 160 /* FromKeyword */ ) {
                            token = nextToken();
                            if (token === 11 /* StringLiteral */ ) recordModuleName();
                        }
                    }
                } else if (token === 42 /* AsteriskToken */ ) {
                    token = nextToken();
                    if (token === 160 /* FromKeyword */ ) {
                        token = nextToken();
                        if (token === 11 /* StringLiteral */ ) recordModuleName();
                    }
                } else if (token === 102 /* ImportKeyword */ ) {
                    token = nextToken();
                    if (token === 156 /* TypeKeyword */ ) {
                        const skipTypeKeyword = scanner.lookAhead(()=>{
                            const token2 = scanner.scan();
                            return token2 === 80 /* Identifier */  || isKeyword(token2);
                        });
                        if (skipTypeKeyword) token = nextToken();
                    }
                    if (token === 80 /* Identifier */  || isKeyword(token)) {
                        token = nextToken();
                        if (token === 64 /* EqualsToken */ ) {
                            if (tryConsumeRequireCall(/*skipCurrentToken*/ true)) return true;
                        }
                    }
                }
                return true;
            }
            return false;
        }
        function tryConsumeRequireCall(skipCurrentToken, allowTemplateLiterals = false) {
            let token = skipCurrentToken ? nextToken() : scanner.getToken();
            if (token === 149 /* RequireKeyword */ ) {
                token = nextToken();
                if (token === 21 /* OpenParenToken */ ) {
                    token = nextToken();
                    if (token === 11 /* StringLiteral */  || allowTemplateLiterals && token === 15 /* NoSubstitutionTemplateLiteral */ ) recordModuleName();
                }
                return true;
            }
            return false;
        }
        function tryConsumeDefine() {
            let token = scanner.getToken();
            if (token === 80 /* Identifier */  && scanner.getTokenValue() === "define") {
                token = nextToken();
                if (token !== 21 /* OpenParenToken */ ) return true;
                token = nextToken();
                if (token === 11 /* StringLiteral */  || token === 15 /* NoSubstitutionTemplateLiteral */ ) {
                    token = nextToken();
                    if (token === 28 /* CommaToken */ ) token = nextToken();
                    else return true;
                }
                if (token !== 23 /* OpenBracketToken */ ) return true;
                token = nextToken();
                while(token !== 24 /* CloseBracketToken */  && token !== 1 /* EndOfFileToken */ ){
                    if (token === 11 /* StringLiteral */  || token === 15 /* NoSubstitutionTemplateLiteral */ ) recordModuleName();
                    token = nextToken();
                }
                return true;
            }
            return false;
        }
        function processImports() {
            scanner.setText(sourceText);
            nextToken();
            while(true){
                if (scanner.getToken() === 1 /* EndOfFileToken */ ) break;
                if (scanner.getToken() === 16 /* TemplateHead */ ) {
                    const stack = [
                        scanner.getToken()
                    ];
                    loop: while(length(stack)){
                        const token = scanner.scan();
                        switch(token){
                            case 1 /* EndOfFileToken */ :
                                break loop;
                            case 102 /* ImportKeyword */ :
                                tryConsumeImport();
                                break;
                            case 16 /* TemplateHead */ :
                                stack.push(token);
                                break;
                            case 19 /* OpenBraceToken */ :
                                if (length(stack)) stack.push(token);
                                break;
                            case 20 /* CloseBraceToken */ :
                                if (length(stack)) {
                                    if (lastOrUndefined(stack) === 16 /* TemplateHead */ ) {
                                        if (scanner.reScanTemplateToken(/*isTaggedTemplate*/ false) === 18 /* TemplateTail */ ) stack.pop();
                                    } else stack.pop();
                                }
                                break;
                        }
                    }
                    nextToken();
                }
                if (tryConsumeDeclare() || tryConsumeImport() || tryConsumeExport() || detectJavaScriptImports && (tryConsumeRequireCall(/*skipCurrentToken*/ false, /*allowTemplateLiterals*/ true) || tryConsumeDefine())) continue;
                else nextToken();
            }
            scanner.setText(void 0);
        }
        if (readImportFiles) processImports();
        processCommentPragmas(pragmaContext, sourceText);
        processPragmasIntoFields(pragmaContext, noop);
        if (externalModule) {
            if (ambientExternalModules) for (const decl of ambientExternalModules)importedFiles.push(decl.ref);
            return {
                referencedFiles: pragmaContext.referencedFiles,
                typeReferenceDirectives: pragmaContext.typeReferenceDirectives,
                libReferenceDirectives: pragmaContext.libReferenceDirectives,
                importedFiles: importedFiles,
                isLibFile: !!pragmaContext.hasNoDefaultLib,
                ambientExternalModules: void 0
            };
        } else {
            let ambientModuleNames;
            if (ambientExternalModules) {
                for (const decl of ambientExternalModules)if (decl.depth === 0) {
                    if (!ambientModuleNames) ambientModuleNames = [];
                    ambientModuleNames.push(decl.ref.fileName);
                } else importedFiles.push(decl.ref);
            }
            return {
                referencedFiles: pragmaContext.referencedFiles,
                typeReferenceDirectives: pragmaContext.typeReferenceDirectives,
                libReferenceDirectives: pragmaContext.libReferenceDirectives,
                importedFiles: importedFiles,
                isLibFile: !!pragmaContext.hasNoDefaultLib,
                ambientExternalModules: ambientModuleNames
            };
        }
    }
    var init_preProcess = __esm({
        "src/services/preProcess.ts" () {
            "use strict";
            init_ts4();
        }
    });
    // src/services/sourcemaps.ts
    function getSourceMapper(host) {
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames());
        const currentDirectory = host.getCurrentDirectory();
        const sourceFileLike = /* @__PURE__ */ new Map();
        const documentPositionMappers = /* @__PURE__ */ new Map();
        return {
            tryGetSourcePosition: tryGetSourcePosition,
            tryGetGeneratedPosition: tryGetGeneratedPosition,
            toLineColumnOffset: toLineColumnOffset,
            clearCache: clearCache
        };
        function toPath3(fileName) {
            return toPath(fileName, currentDirectory, getCanonicalFileName);
        }
        function getDocumentPositionMapper2(generatedFileName, sourceFileName) {
            const path = toPath3(generatedFileName);
            const value1 = documentPositionMappers.get(path);
            if (value1) return value1;
            let mapper;
            if (host.getDocumentPositionMapper) mapper = host.getDocumentPositionMapper(generatedFileName, sourceFileName);
            else if (host.readFile) {
                const file = getSourceFileLike(generatedFileName);
                mapper = file && getDocumentPositionMapper({
                    getSourceFileLike: getSourceFileLike,
                    getCanonicalFileName: getCanonicalFileName,
                    log: (s)=>host.log(s)
                }, generatedFileName, getLineInfo(file.text, getLineStarts(file)), (f)=>!host.fileExists || host.fileExists(f) ? host.readFile(f) : void 0);
            }
            documentPositionMappers.set(path, mapper || identitySourceMapConsumer);
            return mapper || identitySourceMapConsumer;
        }
        function tryGetSourcePosition(info) {
            if (!isDeclarationFileName(info.fileName)) return void 0;
            const file = getSourceFile(info.fileName);
            if (!file) return void 0;
            const newLoc = getDocumentPositionMapper2(info.fileName).getSourcePosition(info);
            return !newLoc || newLoc === info ? void 0 : tryGetSourcePosition(newLoc) || newLoc;
        }
        function tryGetGeneratedPosition(info) {
            if (isDeclarationFileName(info.fileName)) return void 0;
            const sourceFile = getSourceFile(info.fileName);
            if (!sourceFile) return void 0;
            const program = host.getProgram();
            if (program.isSourceOfProjectReferenceRedirect(sourceFile.fileName)) return void 0;
            const options = program.getCompilerOptions();
            const outPath = outFile(options);
            const declarationPath = outPath ? removeFileExtension(outPath) + ".d.ts" /* Dts */  : getDeclarationEmitOutputFilePathWorker(info.fileName, program.getCompilerOptions(), currentDirectory, program.getCommonSourceDirectory(), getCanonicalFileName);
            if (declarationPath === void 0) return void 0;
            const newLoc = getDocumentPositionMapper2(declarationPath, info.fileName).getGeneratedPosition(info);
            return newLoc === info ? void 0 : newLoc;
        }
        function getSourceFile(fileName) {
            const program = host.getProgram();
            if (!program) return void 0;
            const path = toPath3(fileName);
            const file = program.getSourceFileByPath(path);
            return file && file.resolvedPath === path ? file : void 0;
        }
        function getOrCreateSourceFileLike(fileName) {
            const path = toPath3(fileName);
            const fileFromCache = sourceFileLike.get(path);
            if (fileFromCache !== void 0) return fileFromCache ? fileFromCache : void 0;
            if (!host.readFile || host.fileExists && !host.fileExists(path)) {
                sourceFileLike.set(path, false);
                return void 0;
            }
            const text = host.readFile(path);
            const file = text ? createSourceFileLike(text) : false;
            sourceFileLike.set(path, file);
            return file ? file : void 0;
        }
        function getSourceFileLike(fileName) {
            return !host.getSourceFileLike ? getSourceFile(fileName) || getOrCreateSourceFileLike(fileName) : host.getSourceFileLike(fileName);
        }
        function toLineColumnOffset(fileName, position) {
            const file = getSourceFileLike(fileName);
            return file.getLineAndCharacterOfPosition(position);
        }
        function clearCache() {
            sourceFileLike.clear();
            documentPositionMappers.clear();
        }
    }
    function getDocumentPositionMapper(host, generatedFileName, generatedFileLineInfo, readMapFile) {
        let mapFileName = tryGetSourceMappingURL(generatedFileLineInfo);
        if (mapFileName) {
            const match = base64UrlRegExp.exec(mapFileName);
            if (match) {
                if (match[1]) {
                    const base64Object = match[1];
                    return convertDocumentToSourceMapper(host, base64decode(sys, base64Object), generatedFileName);
                }
                mapFileName = void 0;
            }
        }
        const possibleMapLocations = [];
        if (mapFileName) possibleMapLocations.push(mapFileName);
        possibleMapLocations.push(generatedFileName + ".map");
        const originalMapFileName = mapFileName && getNormalizedAbsolutePath(mapFileName, getDirectoryPath(generatedFileName));
        for (const location of possibleMapLocations){
            const mapFileName2 = getNormalizedAbsolutePath(location, getDirectoryPath(generatedFileName));
            const mapFileContents = readMapFile(mapFileName2, originalMapFileName);
            if (isString(mapFileContents)) return convertDocumentToSourceMapper(host, mapFileContents, mapFileName2);
            if (mapFileContents !== void 0) return mapFileContents || void 0;
        }
        return void 0;
    }
    function convertDocumentToSourceMapper(host, contents, mapFileName) {
        const map2 = tryParseRawSourceMap(contents);
        if (!map2 || !map2.sources || !map2.file || !map2.mappings) return void 0;
        if (map2.sourcesContent && map2.sourcesContent.some(isString)) return void 0;
        return createDocumentPositionMapper(host, map2, mapFileName);
    }
    function createSourceFileLike(text, lineMap) {
        return {
            text: text,
            lineMap: lineMap,
            getLineAndCharacterOfPosition (pos) {
                return computeLineAndCharacterOfPosition(getLineStarts(this), pos);
            }
        };
    }
    var base64UrlRegExp;
    var init_sourcemaps = __esm({
        "src/services/sourcemaps.ts" () {
            "use strict";
            init_ts4();
            base64UrlRegExp = /^data:(?:application\/json(?:;charset=[uU][tT][fF]-8);base64,([A-Za-z0-9+\/=]+)$)?/;
        }
    });
    // src/services/suggestionDiagnostics.ts
    function computeSuggestionDiagnostics(sourceFile, program, cancellationToken) {
        program.getSemanticDiagnostics(sourceFile, cancellationToken);
        const diags = [];
        const checker = program.getTypeChecker();
        const isCommonJSFile = sourceFile.impliedNodeFormat === 1 /* CommonJS */  || fileExtensionIsOneOf(sourceFile.fileName, [
            ".cts" /* Cts */ ,
            ".cjs" /* Cjs */ 
        ]);
        if (!isCommonJSFile && sourceFile.commonJsModuleIndicator && (programContainsEsModules(program) || compilerOptionsIndicateEsModules(program.getCompilerOptions())) && containsTopLevelCommonjs(sourceFile)) diags.push(createDiagnosticForNode(getErrorNodeFromCommonJsIndicator(sourceFile.commonJsModuleIndicator), Diagnostics.File_is_a_CommonJS_module_it_may_be_converted_to_an_ES_module));
        const isJsFile = isSourceFileJS(sourceFile);
        visitedNestedConvertibleFunctions.clear();
        check(sourceFile);
        if (getAllowSyntheticDefaultImports(program.getCompilerOptions())) for (const moduleSpecifier of sourceFile.imports){
            const importNode = importFromModuleSpecifier(moduleSpecifier);
            const name = importNameForConvertToDefaultImport(importNode);
            if (!name) continue;
            const module2 = getResolvedModule(sourceFile, moduleSpecifier.text, getModeForUsageLocation(sourceFile, moduleSpecifier));
            const resolvedFile = module2 && program.getSourceFile(module2.resolvedFileName);
            if (resolvedFile && resolvedFile.externalModuleIndicator && resolvedFile.externalModuleIndicator !== true && isExportAssignment(resolvedFile.externalModuleIndicator) && resolvedFile.externalModuleIndicator.isExportEquals) diags.push(createDiagnosticForNode(name, Diagnostics.Import_may_be_converted_to_a_default_import));
        }
        addRange(diags, sourceFile.bindSuggestionDiagnostics);
        addRange(diags, program.getSuggestionDiagnostics(sourceFile, cancellationToken));
        return diags.sort((d1, d2)=>d1.start - d2.start);
        function check(node) {
            if (isJsFile) {
                if (canBeConvertedToClass(node, checker)) diags.push(createDiagnosticForNode(isVariableDeclaration(node.parent) ? node.parent.name : node, Diagnostics.This_constructor_function_may_be_converted_to_a_class_declaration));
            } else {
                if (isVariableStatement(node) && node.parent === sourceFile && node.declarationList.flags & 2 /* Const */  && node.declarationList.declarations.length === 1) {
                    const init = node.declarationList.declarations[0].initializer;
                    if (init && isRequireCall(init, /*requireStringLiteralLikeArgument*/ true)) diags.push(createDiagnosticForNode(init, Diagnostics.require_call_may_be_converted_to_an_import));
                }
                const jsdocTypedefNode = ts_codefix_exports.getJSDocTypedefNode(node);
                if (jsdocTypedefNode) diags.push(createDiagnosticForNode(jsdocTypedefNode, Diagnostics.JSDoc_typedef_may_be_converted_to_TypeScript_type));
                if (ts_codefix_exports.parameterShouldGetTypeFromJSDoc(node)) diags.push(createDiagnosticForNode(node.name || node, Diagnostics.JSDoc_types_may_be_moved_to_TypeScript_types));
            }
            if (canBeConvertedToAsync(node)) addConvertToAsyncFunctionDiagnostics(node, checker, diags);
            node.forEachChild(check);
        }
    }
    function containsTopLevelCommonjs(sourceFile) {
        return sourceFile.statements.some((statement)=>{
            switch(statement.kind){
                case 242 /* VariableStatement */ :
                    return statement.declarationList.declarations.some((decl)=>!!decl.initializer && isRequireCall(propertyAccessLeftHandSide(decl.initializer), /*requireStringLiteralLikeArgument*/ true));
                case 243 /* ExpressionStatement */ :
                    {
                        const { expression: expression  } = statement;
                        if (!isBinaryExpression(expression)) return isRequireCall(expression, /*requireStringLiteralLikeArgument*/ true);
                        const kind = getAssignmentDeclarationKind(expression);
                        return kind === 1 /* ExportsProperty */  || kind === 2 /* ModuleExports */ ;
                    }
                default:
                    return false;
            }
        });
    }
    function propertyAccessLeftHandSide(node) {
        return isPropertyAccessExpression(node) ? propertyAccessLeftHandSide(node.expression) : node;
    }
    function importNameForConvertToDefaultImport(node) {
        switch(node.kind){
            case 271 /* ImportDeclaration */ :
                const { importClause: importClause , moduleSpecifier: moduleSpecifier  } = node;
                return importClause && !importClause.name && importClause.namedBindings && importClause.namedBindings.kind === 273 /* NamespaceImport */  && isStringLiteral(moduleSpecifier) ? importClause.namedBindings.name : void 0;
            case 270 /* ImportEqualsDeclaration */ :
                return node.name;
            default:
                return void 0;
        }
    }
    function addConvertToAsyncFunctionDiagnostics(node, checker, diags) {
        if (isConvertibleFunction(node, checker) && !visitedNestedConvertibleFunctions.has(getKeyFromNode(node))) diags.push(createDiagnosticForNode(!node.name && isVariableDeclaration(node.parent) && isIdentifier(node.parent.name) ? node.parent.name : node, Diagnostics.This_may_be_converted_to_an_async_function));
    }
    function isConvertibleFunction(node, checker) {
        return !isAsyncFunction(node) && node.body && isBlock(node.body) && hasReturnStatementWithPromiseHandler(node.body, checker) && returnsPromise(node, checker);
    }
    function returnsPromise(node, checker) {
        const signature = checker.getSignatureFromDeclaration(node);
        const returnType = signature ? checker.getReturnTypeOfSignature(signature) : void 0;
        return !!returnType && !!checker.getPromisedTypeOfPromise(returnType);
    }
    function getErrorNodeFromCommonJsIndicator(commonJsModuleIndicator) {
        return isBinaryExpression(commonJsModuleIndicator) ? commonJsModuleIndicator.left : commonJsModuleIndicator;
    }
    function hasReturnStatementWithPromiseHandler(body, checker) {
        return !!forEachReturnStatement(body, (statement)=>isReturnStatementWithFixablePromiseHandler(statement, checker));
    }
    function isReturnStatementWithFixablePromiseHandler(node, checker) {
        return isReturnStatement(node) && !!node.expression && isFixablePromiseHandler(node.expression, checker);
    }
    function isFixablePromiseHandler(node, checker) {
        if (!isPromiseHandler(node) || !hasSupportedNumberOfArguments(node) || !node.arguments.every((arg)=>isFixablePromiseArgument(arg, checker))) return false;
        let currentNode = node.expression.expression;
        while(isPromiseHandler(currentNode) || isPropertyAccessExpression(currentNode))if (isCallExpression(currentNode)) {
            if (!hasSupportedNumberOfArguments(currentNode) || !currentNode.arguments.every((arg)=>isFixablePromiseArgument(arg, checker))) return false;
            currentNode = currentNode.expression.expression;
        } else currentNode = currentNode.expression;
        return true;
    }
    function isPromiseHandler(node) {
        return isCallExpression(node) && (hasPropertyAccessExpressionWithName(node, "then") || hasPropertyAccessExpressionWithName(node, "catch") || hasPropertyAccessExpressionWithName(node, "finally"));
    }
    function hasSupportedNumberOfArguments(node) {
        const name = node.expression.name.text;
        const maxArguments = name === "then" ? 2 : name === "catch" ? 1 : name === "finally" ? 1 : 0;
        if (node.arguments.length > maxArguments) return false;
        if (node.arguments.length < maxArguments) return true;
        return maxArguments === 1 || some(node.arguments, (arg)=>{
            return arg.kind === 106 /* NullKeyword */  || isIdentifier(arg) && arg.text === "undefined";
        });
    }
    function isFixablePromiseArgument(arg, checker) {
        switch(arg.kind){
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
                const functionFlags = getFunctionFlags(arg);
                if (functionFlags & 1 /* Generator */ ) return false;
            case 218 /* ArrowFunction */ :
                visitedNestedConvertibleFunctions.set(getKeyFromNode(arg), true);
            case 106 /* NullKeyword */ :
                return true;
            case 80 /* Identifier */ :
            case 210 /* PropertyAccessExpression */ :
                {
                    const symbol = checker.getSymbolAtLocation(arg);
                    if (!symbol) return false;
                    return checker.isUndefinedSymbol(symbol) || some(skipAlias(symbol, checker).declarations, (d)=>isFunctionLike(d) || hasInitializer(d) && !!d.initializer && isFunctionLike(d.initializer));
                }
            default:
                return false;
        }
    }
    function getKeyFromNode(exp) {
        return `${exp.pos.toString()}:${exp.end.toString()}`;
    }
    function canBeConvertedToClass(node, checker) {
        var _a, _b, _c, _d;
        if (isFunctionExpression(node)) {
            if (isVariableDeclaration(node.parent) && ((_a = node.symbol.members) == null ? void 0 : _a.size)) return true;
            const symbol = checker.getSymbolOfExpando(node, /*allowDeclaration*/ false);
            return !!(symbol && (((_b = symbol.exports) == null ? void 0 : _b.size) || ((_c = symbol.members) == null ? void 0 : _c.size)));
        }
        if (isFunctionDeclaration(node)) return !!((_d = node.symbol.members) == null ? void 0 : _d.size);
        return false;
    }
    function canBeConvertedToAsync(node) {
        switch(node.kind){
            case 261 /* FunctionDeclaration */ :
            case 173 /* MethodDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
                return true;
            default:
                return false;
        }
    }
    var visitedNestedConvertibleFunctions;
    var init_suggestionDiagnostics = __esm({
        "src/services/suggestionDiagnostics.ts" () {
            "use strict";
            init_ts4();
            visitedNestedConvertibleFunctions = /* @__PURE__ */ new Map();
        }
    });
    // src/services/transpile.ts
    function transpileModule(input, transpileOptions) {
        const diagnostics = [];
        const options = transpileOptions.compilerOptions ? fixupCompilerOptions(transpileOptions.compilerOptions, diagnostics) : {};
        const defaultOptions = getDefaultCompilerOptions2();
        for(const key in defaultOptions)if (hasProperty(defaultOptions, key) && options[key] === void 0) options[key] = defaultOptions[key];
        for (const option of transpileOptionValueCompilerOptions){
            if (options.verbatimModuleSyntax && optionsRedundantWithVerbatimModuleSyntax.has(option.name)) continue;
            options[option.name] = option.transpileOptionValue;
        }
        options.suppressOutputPathCheck = true;
        options.allowNonTsExtensions = true;
        const newLine = getNewLineCharacter(options);
        const compilerHost = {
            getSourceFile: (fileName)=>fileName === normalizePath(inputFileName) ? sourceFile : void 0,
            writeFile: (name, text)=>{
                if (fileExtensionIs(name, ".map")) {
                    Debug.assertEqual(sourceMapText, void 0, "Unexpected multiple source map outputs, file:", name);
                    sourceMapText = text;
                } else {
                    Debug.assertEqual(outputText, void 0, "Unexpected multiple outputs, file:", name);
                    outputText = text;
                }
            },
            getDefaultLibFileName: ()=>"lib.d.ts",
            useCaseSensitiveFileNames: ()=>false,
            getCanonicalFileName: (fileName)=>fileName,
            getCurrentDirectory: ()=>"",
            getNewLine: ()=>newLine,
            fileExists: (fileName)=>fileName === inputFileName,
            readFile: ()=>"",
            directoryExists: ()=>true,
            getDirectories: ()=>[]
        };
        const inputFileName = transpileOptions.fileName || (transpileOptions.compilerOptions && transpileOptions.compilerOptions.jsx ? "module.tsx" : "module.ts");
        const sourceFile = createSourceFile(inputFileName, input, {
            languageVersion: getEmitScriptTarget(options),
            impliedNodeFormat: getImpliedNodeFormatForFile(toPath(inputFileName, "", compilerHost.getCanonicalFileName), /*packageJsonInfoCache*/ void 0, compilerHost, options),
            setExternalModuleIndicator: getSetExternalModuleIndicator(options)
        });
        if (transpileOptions.moduleName) sourceFile.moduleName = transpileOptions.moduleName;
        if (transpileOptions.renamedDependencies) sourceFile.renamedDependencies = new Map(Object.entries(transpileOptions.renamedDependencies));
        let outputText;
        let sourceMapText;
        const program = createProgram([
            inputFileName
        ], options, compilerHost);
        if (transpileOptions.reportDiagnostics) {
            addRange(/*to*/ diagnostics, /*from*/ program.getSyntacticDiagnostics(sourceFile));
            addRange(/*to*/ diagnostics, /*from*/ program.getOptionsDiagnostics());
        }
        program.emit(/*targetSourceFile*/ void 0, /*writeFile*/ void 0, /*cancellationToken*/ void 0, /*emitOnlyDtsFiles*/ void 0, transpileOptions.transformers);
        if (outputText === void 0) return Debug.fail("Output generation failed");
        return {
            outputText: outputText,
            diagnostics: diagnostics,
            sourceMapText: sourceMapText
        };
    }
    function transpile(input, compilerOptions, fileName, diagnostics, moduleName) {
        const output = transpileModule(input, {
            compilerOptions: compilerOptions,
            fileName: fileName,
            reportDiagnostics: !!diagnostics,
            moduleName: moduleName
        });
        addRange(diagnostics, output.diagnostics);
        return output.outputText;
    }
    function fixupCompilerOptions(options, diagnostics) {
        commandLineOptionsStringToEnum = commandLineOptionsStringToEnum || filter(optionDeclarations, (o)=>typeof o.type === "object" && !forEachEntry(o.type, (v)=>typeof v !== "number"));
        options = cloneCompilerOptions(options);
        for (const opt of commandLineOptionsStringToEnum){
            if (!hasProperty(options, opt.name)) continue;
            const value1 = options[opt.name];
            if (isString(value1)) options[opt.name] = parseCustomTypeOption(opt, value1, diagnostics);
            else if (!forEachEntry(opt.type, (v)=>v === value1)) diagnostics.push(createCompilerDiagnosticForInvalidCustomType(opt));
        }
        return options;
    }
    var optionsRedundantWithVerbatimModuleSyntax, commandLineOptionsStringToEnum;
    var init_transpile = __esm({
        "src/services/transpile.ts" () {
            "use strict";
            init_ts4();
            optionsRedundantWithVerbatimModuleSyntax = /* @__PURE__ */ new Set([
                "isolatedModules",
                "preserveValueImports",
                "importsNotUsedAsValues"
            ]);
        }
    });
    // src/services/navigateTo.ts
    function getNavigateToItems(sourceFiles, checker, cancellationToken, searchValue, maxResultCount, excludeDtsFiles) {
        const patternMatcher = createPatternMatcher(searchValue);
        if (!patternMatcher) return emptyArray;
        const rawItems = [];
        for (const sourceFile of sourceFiles){
            cancellationToken.throwIfCancellationRequested();
            if (excludeDtsFiles && sourceFile.isDeclarationFile) continue;
            sourceFile.getNamedDeclarations().forEach((declarations, name)=>{
                getItemsFromNamedDeclaration(patternMatcher, name, declarations, checker, sourceFile.fileName, rawItems);
            });
        }
        rawItems.sort(compareNavigateToItems);
        return (maxResultCount === void 0 ? rawItems : rawItems.slice(0, maxResultCount)).map(createNavigateToItem);
    }
    function getItemsFromNamedDeclaration(patternMatcher, name, declarations, checker, fileName, rawItems) {
        const match = patternMatcher.getMatchForLastSegmentOfPattern(name);
        if (!match) return;
        for (const declaration of declarations){
            if (!shouldKeepItem(declaration, checker)) continue;
            if (patternMatcher.patternContainsDots) {
                const fullMatch = patternMatcher.getFullMatch(getContainers(declaration), name);
                if (fullMatch) rawItems.push({
                    name: name,
                    fileName: fileName,
                    matchKind: fullMatch.kind,
                    isCaseSensitive: fullMatch.isCaseSensitive,
                    declaration: declaration
                });
            } else rawItems.push({
                name: name,
                fileName: fileName,
                matchKind: match.kind,
                isCaseSensitive: match.isCaseSensitive,
                declaration: declaration
            });
        }
    }
    function shouldKeepItem(declaration, checker) {
        switch(declaration.kind){
            case 272 /* ImportClause */ :
            case 275 /* ImportSpecifier */ :
            case 270 /* ImportEqualsDeclaration */ :
                const importer = checker.getSymbolAtLocation(declaration.name);
                const imported = checker.getAliasedSymbol(importer);
                return importer.escapedName !== imported.escapedName;
            default:
                return true;
        }
    }
    function tryAddSingleDeclarationName(declaration, containers) {
        const name = getNameOfDeclaration(declaration);
        return !!name && (pushLiteral(name, containers) || name.kind === 166 /* ComputedPropertyName */  && tryAddComputedPropertyName(name.expression, containers));
    }
    function tryAddComputedPropertyName(expression, containers) {
        return pushLiteral(expression, containers) || isPropertyAccessExpression(expression) && (containers.push(expression.name.text), true) && tryAddComputedPropertyName(expression.expression, containers);
    }
    function pushLiteral(node, containers) {
        return isPropertyNameLiteral(node) && (containers.push(getTextOfIdentifierOrLiteral(node)), true);
    }
    function getContainers(declaration) {
        const containers = [];
        const name = getNameOfDeclaration(declaration);
        if (name && name.kind === 166 /* ComputedPropertyName */  && !tryAddComputedPropertyName(name.expression, containers)) return emptyArray;
        containers.shift();
        let container = getContainerNode(declaration);
        while(container){
            if (!tryAddSingleDeclarationName(container, containers)) return emptyArray;
            container = getContainerNode(container);
        }
        return containers.reverse();
    }
    function compareNavigateToItems(i1, i2) {
        return compareValues(i1.matchKind, i2.matchKind) || compareStringsCaseSensitiveUI(i1.name, i2.name);
    }
    function createNavigateToItem(rawItem) {
        const declaration = rawItem.declaration;
        const container = getContainerNode(declaration);
        const containerName = container && getNameOfDeclaration(container);
        return {
            name: rawItem.name,
            kind: getNodeKind(declaration),
            kindModifiers: getNodeModifiers(declaration),
            matchKind: PatternMatchKind[rawItem.matchKind],
            isCaseSensitive: rawItem.isCaseSensitive,
            fileName: rawItem.fileName,
            textSpan: createTextSpanFromNode(declaration),
            // TODO(jfreeman): What should be the containerName when the container has a computed name?
            containerName: containerName ? containerName.text : "",
            containerKind: containerName ? getNodeKind(container) : "" /* unknown */ 
        };
    }
    var init_navigateTo = __esm({
        "src/services/navigateTo.ts" () {
            "use strict";
            init_ts4();
        }
    });
    // src/services/_namespaces/ts.NavigateTo.ts
    var ts_NavigateTo_exports = {};
    __export(ts_NavigateTo_exports, {
        getNavigateToItems: ()=>getNavigateToItems
    });
    var init_ts_NavigateTo = __esm({
        "src/services/_namespaces/ts.NavigateTo.ts" () {
            "use strict";
            init_navigateTo();
        }
    });
    // src/services/navigationBar.ts
    function getNavigationBarItems(sourceFile, cancellationToken) {
        curCancellationToken = cancellationToken;
        curSourceFile = sourceFile;
        try {
            return map(primaryNavBarMenuItems(rootNavigationBarNode(sourceFile)), convertToPrimaryNavBarMenuItem);
        } finally{
            reset();
        }
    }
    function getNavigationTree(sourceFile, cancellationToken) {
        curCancellationToken = cancellationToken;
        curSourceFile = sourceFile;
        try {
            return convertToTree(rootNavigationBarNode(sourceFile));
        } finally{
            reset();
        }
    }
    function reset() {
        curSourceFile = void 0;
        curCancellationToken = void 0;
        parentsStack = [];
        parent = void 0;
        emptyChildItemArray = [];
    }
    function nodeText(node) {
        return cleanText(node.getText(curSourceFile));
    }
    function navigationBarNodeKind(n) {
        return n.node.kind;
    }
    function pushChild(parent2, child) {
        if (parent2.children) parent2.children.push(child);
        else parent2.children = [
            child
        ];
    }
    function rootNavigationBarNode(sourceFile) {
        Debug.assert(!parentsStack.length);
        const root = {
            node: sourceFile,
            name: void 0,
            additionalNodes: void 0,
            parent: void 0,
            children: void 0,
            indent: 0
        };
        parent = root;
        for (const statement of sourceFile.statements)addChildrenRecursively(statement);
        endNode();
        Debug.assert(!parent && !parentsStack.length);
        return root;
    }
    function addLeafNode(node, name) {
        pushChild(parent, emptyNavigationBarNode(node, name));
    }
    function emptyNavigationBarNode(node, name) {
        return {
            node: node,
            name: name || (isDeclaration(node) || isExpression(node) ? getNameOfDeclaration(node) : void 0),
            additionalNodes: void 0,
            parent: parent,
            children: void 0,
            indent: parent.indent + 1
        };
    }
    function addTrackedEs5Class(name) {
        if (!trackedEs5Classes) trackedEs5Classes = /* @__PURE__ */ new Map();
        trackedEs5Classes.set(name, true);
    }
    function endNestedNodes(depth) {
        for(let i = 0; i < depth; i++)endNode();
    }
    function startNestedNodes(targetNode, entityName) {
        const names = [];
        while(!isPropertyNameLiteral(entityName)){
            const name = getNameOrArgument(entityName);
            const nameText = getElementOrPropertyAccessName(entityName);
            entityName = entityName.expression;
            if (nameText === "prototype" || isPrivateIdentifier(name)) continue;
            names.push(name);
        }
        names.push(entityName);
        for(let i = names.length - 1; i > 0; i--){
            const name = names[i];
            startNode(targetNode, name);
        }
        return [
            names.length - 1,
            names[0]
        ];
    }
    function startNode(node, name) {
        const navNode = emptyNavigationBarNode(node, name);
        pushChild(parent, navNode);
        parentsStack.push(parent);
        trackedEs5ClassesStack.push(trackedEs5Classes);
        trackedEs5Classes = void 0;
        parent = navNode;
    }
    function endNode() {
        if (parent.children) {
            mergeChildren(parent.children, parent);
            sortChildren(parent.children);
        }
        parent = parentsStack.pop();
        trackedEs5Classes = trackedEs5ClassesStack.pop();
    }
    function addNodeWithRecursiveChild(node, child, name) {
        startNode(node, name);
        addChildrenRecursively(child);
        endNode();
    }
    function addNodeWithRecursiveInitializer(node) {
        if (node.initializer && isFunctionOrClassExpression(node.initializer)) {
            startNode(node);
            forEachChild(node.initializer, addChildrenRecursively);
            endNode();
        } else addNodeWithRecursiveChild(node, node.initializer);
    }
    function hasNavigationBarName(node) {
        return !hasDynamicName(node) || node.kind !== 225 /* BinaryExpression */  && isPropertyAccessExpression(node.name.expression) && isIdentifier(node.name.expression.expression) && idText(node.name.expression.expression) === "Symbol";
    }
    function addChildrenRecursively(node) {
        curCancellationToken.throwIfCancellationRequested();
        if (!node || isToken(node)) return;
        switch(node.kind){
            case 175 /* Constructor */ :
                const ctr = node;
                addNodeWithRecursiveChild(ctr, ctr.body);
                for (const param of ctr.parameters)if (isParameterPropertyDeclaration(param, ctr)) addLeafNode(param);
                break;
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 172 /* MethodSignature */ :
                if (hasNavigationBarName(node)) addNodeWithRecursiveChild(node, node.body);
                break;
            case 171 /* PropertyDeclaration */ :
                if (hasNavigationBarName(node)) addNodeWithRecursiveInitializer(node);
                break;
            case 170 /* PropertySignature */ :
                if (hasNavigationBarName(node)) addLeafNode(node);
                break;
            case 272 /* ImportClause */ :
                const importClause = node;
                if (importClause.name) addLeafNode(importClause.name);
                const { namedBindings: namedBindings  } = importClause;
                if (namedBindings) {
                    if (namedBindings.kind === 273 /* NamespaceImport */ ) addLeafNode(namedBindings);
                    else for (const element of namedBindings.elements)addLeafNode(element);
                }
                break;
            case 303 /* ShorthandPropertyAssignment */ :
                addNodeWithRecursiveChild(node, node.name);
                break;
            case 304 /* SpreadAssignment */ :
                const { expression: expression  } = node;
                isIdentifier(expression) ? addLeafNode(node, expression) : addLeafNode(node);
                break;
            case 207 /* BindingElement */ :
            case 302 /* PropertyAssignment */ :
            case 259 /* VariableDeclaration */ :
                {
                    const child = node;
                    if (isBindingPattern(child.name)) addChildrenRecursively(child.name);
                    else addNodeWithRecursiveInitializer(child);
                    break;
                }
            case 261 /* FunctionDeclaration */ :
                const nameNode = node.name;
                if (nameNode && isIdentifier(nameNode)) addTrackedEs5Class(nameNode.text);
                addNodeWithRecursiveChild(node, node.body);
                break;
            case 218 /* ArrowFunction */ :
            case 217 /* FunctionExpression */ :
                addNodeWithRecursiveChild(node, node.body);
                break;
            case 265 /* EnumDeclaration */ :
                startNode(node);
                for (const member of node.members)if (!isComputedProperty(member)) addLeafNode(member);
                endNode();
                break;
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
            case 263 /* InterfaceDeclaration */ :
                startNode(node);
                for (const member of node.members)addChildrenRecursively(member);
                endNode();
                break;
            case 266 /* ModuleDeclaration */ :
                addNodeWithRecursiveChild(node, getInteriorModule(node).body);
                break;
            case 276 /* ExportAssignment */ :
                {
                    const expression2 = node.expression;
                    const child = isObjectLiteralExpression(expression2) || isCallExpression(expression2) ? expression2 : isArrowFunction(expression2) || isFunctionExpression(expression2) ? expression2.body : void 0;
                    if (child) {
                        startNode(node);
                        addChildrenRecursively(child);
                        endNode();
                    } else addLeafNode(node);
                    break;
                }
            case 280 /* ExportSpecifier */ :
            case 270 /* ImportEqualsDeclaration */ :
            case 180 /* IndexSignature */ :
            case 178 /* CallSignature */ :
            case 179 /* ConstructSignature */ :
            case 264 /* TypeAliasDeclaration */ :
                addLeafNode(node);
                break;
            case 212 /* CallExpression */ :
            case 225 /* BinaryExpression */ :
                {
                    const special = getAssignmentDeclarationKind(node);
                    switch(special){
                        case 1 /* ExportsProperty */ :
                        case 2 /* ModuleExports */ :
                            addNodeWithRecursiveChild(node, node.right);
                            return;
                        case 6 /* Prototype */ :
                        case 3 /* PrototypeProperty */ :
                            {
                                const binaryExpression = node;
                                const assignmentTarget = binaryExpression.left;
                                const prototypeAccess = special === 3 /* PrototypeProperty */  ? assignmentTarget.expression : assignmentTarget;
                                let depth = 0;
                                let className;
                                if (isIdentifier(prototypeAccess.expression)) {
                                    addTrackedEs5Class(prototypeAccess.expression.text);
                                    className = prototypeAccess.expression;
                                } else [depth, className] = startNestedNodes(binaryExpression, prototypeAccess.expression);
                                if (special === 6 /* Prototype */ ) {
                                    if (isObjectLiteralExpression(binaryExpression.right)) {
                                        if (binaryExpression.right.properties.length > 0) {
                                            startNode(binaryExpression, className);
                                            forEachChild(binaryExpression.right, addChildrenRecursively);
                                            endNode();
                                        }
                                    }
                                } else if (isFunctionExpression(binaryExpression.right) || isArrowFunction(binaryExpression.right)) addNodeWithRecursiveChild(node, binaryExpression.right, className);
                                else {
                                    startNode(binaryExpression, className);
                                    addNodeWithRecursiveChild(node, binaryExpression.right, assignmentTarget.name);
                                    endNode();
                                }
                                endNestedNodes(depth);
                                return;
                            }
                        case 7 /* ObjectDefinePropertyValue */ :
                        case 9 /* ObjectDefinePrototypeProperty */ :
                            {
                                const defineCall = node;
                                const className = special === 7 /* ObjectDefinePropertyValue */  ? defineCall.arguments[0] : defineCall.arguments[0].expression;
                                const memberName = defineCall.arguments[1];
                                const [depth, classNameIdentifier] = startNestedNodes(node, className);
                                startNode(node, classNameIdentifier);
                                startNode(node, setTextRange(factory.createIdentifier(memberName.text), memberName));
                                addChildrenRecursively(node.arguments[2]);
                                endNode();
                                endNode();
                                endNestedNodes(depth);
                                return;
                            }
                        case 5 /* Property */ :
                            {
                                const binaryExpression = node;
                                const assignmentTarget = binaryExpression.left;
                                const targetFunction = assignmentTarget.expression;
                                if (isIdentifier(targetFunction) && getElementOrPropertyAccessName(assignmentTarget) !== "prototype" && trackedEs5Classes && trackedEs5Classes.has(targetFunction.text)) {
                                    if (isFunctionExpression(binaryExpression.right) || isArrowFunction(binaryExpression.right)) addNodeWithRecursiveChild(node, binaryExpression.right, targetFunction);
                                    else if (isBindableStaticAccessExpression(assignmentTarget)) {
                                        startNode(binaryExpression, targetFunction);
                                        addNodeWithRecursiveChild(binaryExpression.left, binaryExpression.right, getNameOrArgument(assignmentTarget));
                                        endNode();
                                    }
                                    return;
                                }
                                break;
                            }
                        case 4 /* ThisProperty */ :
                        case 0 /* None */ :
                        case 8 /* ObjectDefinePropertyExports */ :
                            break;
                        default:
                            Debug.assertNever(special);
                    }
                }
            default:
                if (hasJSDocNodes(node)) forEach(node.jsDoc, (jsDoc)=>{
                    forEach(jsDoc.tags, (tag)=>{
                        if (isJSDocTypeAlias(tag)) addLeafNode(tag);
                    });
                });
                forEachChild(node, addChildrenRecursively);
        }
    }
    function mergeChildren(children, node) {
        const nameToItems = /* @__PURE__ */ new Map();
        filterMutate(children, (child, index)=>{
            const declName = child.name || getNameOfDeclaration(child.node);
            const name = declName && nodeText(declName);
            if (!name) return true;
            const itemsWithSameName = nameToItems.get(name);
            if (!itemsWithSameName) {
                nameToItems.set(name, child);
                return true;
            }
            if (itemsWithSameName instanceof Array) {
                for (const itemWithSameName of itemsWithSameName){
                    if (tryMerge(itemWithSameName, child, index, node)) return false;
                }
                itemsWithSameName.push(child);
                return true;
            } else {
                const itemWithSameName = itemsWithSameName;
                if (tryMerge(itemWithSameName, child, index, node)) return false;
                nameToItems.set(name, [
                    itemWithSameName,
                    child
                ]);
                return true;
            }
        });
    }
    function tryMergeEs5Class(a, b, bIndex, parent2) {
        function isPossibleConstructor(node) {
            return isFunctionExpression(node) || isFunctionDeclaration(node) || isVariableDeclaration(node);
        }
        const bAssignmentDeclarationKind = isBinaryExpression(b.node) || isCallExpression(b.node) ? getAssignmentDeclarationKind(b.node) : 0 /* None */ ;
        const aAssignmentDeclarationKind = isBinaryExpression(a.node) || isCallExpression(a.node) ? getAssignmentDeclarationKind(a.node) : 0 /* None */ ;
        if (isEs5ClassMember[bAssignmentDeclarationKind] && isEs5ClassMember[aAssignmentDeclarationKind] || isPossibleConstructor(a.node) && isEs5ClassMember[bAssignmentDeclarationKind] || isPossibleConstructor(b.node) && isEs5ClassMember[aAssignmentDeclarationKind] || isClassDeclaration(a.node) && isSynthesized(a.node) && isEs5ClassMember[bAssignmentDeclarationKind] || isClassDeclaration(b.node) && isEs5ClassMember[aAssignmentDeclarationKind] || isClassDeclaration(a.node) && isSynthesized(a.node) && isPossibleConstructor(b.node) || isClassDeclaration(b.node) && isPossibleConstructor(a.node) && isSynthesized(a.node)) {
            let lastANode = a.additionalNodes && lastOrUndefined(a.additionalNodes) || a.node;
            if (!isClassDeclaration(a.node) && !isClassDeclaration(b.node) || isPossibleConstructor(a.node) || isPossibleConstructor(b.node)) {
                const ctorFunction = isPossibleConstructor(a.node) ? a.node : isPossibleConstructor(b.node) ? b.node : void 0;
                if (ctorFunction !== void 0) {
                    const ctorNode = setTextRange(factory.createConstructorDeclaration(/*modifiers*/ void 0, [], /*body*/ void 0), ctorFunction);
                    const ctor = emptyNavigationBarNode(ctorNode);
                    ctor.indent = a.indent + 1;
                    ctor.children = a.node === ctorFunction ? a.children : b.children;
                    a.children = a.node === ctorFunction ? concatenate([
                        ctor
                    ], b.children || [
                        b
                    ]) : concatenate(a.children || [
                        {
                            ...a
                        }
                    ], [
                        ctor
                    ]);
                } else if (a.children || b.children) {
                    a.children = concatenate(a.children || [
                        {
                            ...a
                        }
                    ], b.children || [
                        b
                    ]);
                    if (a.children) {
                        mergeChildren(a.children, a);
                        sortChildren(a.children);
                    }
                }
                lastANode = a.node = setTextRange(factory.createClassDeclaration(/*modifiers*/ void 0, a.name || factory.createIdentifier("__class__"), /*typeParameters*/ void 0, /*heritageClauses*/ void 0, []), a.node);
            } else {
                a.children = concatenate(a.children, b.children);
                if (a.children) mergeChildren(a.children, a);
            }
            const bNode = b.node;
            if (parent2.children[bIndex - 1].node.end === lastANode.end) setTextRange(lastANode, {
                pos: lastANode.pos,
                end: bNode.end
            });
            else {
                if (!a.additionalNodes) a.additionalNodes = [];
                a.additionalNodes.push(setTextRange(factory.createClassDeclaration(/*modifiers*/ void 0, a.name || factory.createIdentifier("__class__"), /*typeParameters*/ void 0, /*heritageClauses*/ void 0, []), b.node));
            }
            return true;
        }
        return bAssignmentDeclarationKind === 0 /* None */  ? false : true;
    }
    function tryMerge(a, b, bIndex, parent2) {
        if (tryMergeEs5Class(a, b, bIndex, parent2)) return true;
        if (shouldReallyMerge(a.node, b.node, parent2)) {
            merge(a, b);
            return true;
        }
        return false;
    }
    function shouldReallyMerge(a, b, parent2) {
        if (a.kind !== b.kind || a.parent !== b.parent && !(isOwnChild(a, parent2) && isOwnChild(b, parent2))) return false;
        switch(a.kind){
            case 171 /* PropertyDeclaration */ :
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
                return isStatic(a) === isStatic(b);
            case 266 /* ModuleDeclaration */ :
                return areSameModule(a, b) && getFullyQualifiedModuleName(a) === getFullyQualifiedModuleName(b);
            default:
                return true;
        }
    }
    function isSynthesized(node) {
        return !!(node.flags & 8 /* Synthesized */ );
    }
    function isOwnChild(n, parent2) {
        const par = isModuleBlock(n.parent) ? n.parent.parent : n.parent;
        return par === parent2.node || contains(parent2.additionalNodes, par);
    }
    function areSameModule(a, b) {
        if (!a.body || !b.body) return a.body === b.body;
        return a.body.kind === b.body.kind && (a.body.kind !== 266 /* ModuleDeclaration */  || areSameModule(a.body, b.body));
    }
    function merge(target, source) {
        target.additionalNodes = target.additionalNodes || [];
        target.additionalNodes.push(source.node);
        if (source.additionalNodes) target.additionalNodes.push(...source.additionalNodes);
        target.children = concatenate(target.children, source.children);
        if (target.children) {
            mergeChildren(target.children, target);
            sortChildren(target.children);
        }
    }
    function sortChildren(children) {
        children.sort(compareChildren);
    }
    function compareChildren(child1, child2) {
        return compareStringsCaseSensitiveUI(tryGetName(child1.node), tryGetName(child2.node)) || compareValues(navigationBarNodeKind(child1), navigationBarNodeKind(child2));
    }
    function tryGetName(node) {
        if (node.kind === 266 /* ModuleDeclaration */ ) return getModuleName(node);
        const declName = getNameOfDeclaration(node);
        if (declName && isPropertyName(declName)) {
            const propertyName = getPropertyNameForPropertyNameNode(declName);
            return propertyName && unescapeLeadingUnderscores(propertyName);
        }
        switch(node.kind){
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
            case 230 /* ClassExpression */ :
                return getFunctionOrClassName(node);
            default:
                return void 0;
        }
    }
    function getItemName(node, name) {
        if (node.kind === 266 /* ModuleDeclaration */ ) return cleanText(getModuleName(node));
        if (name) {
            const text = isIdentifier(name) ? name.text : isElementAccessExpression(name) ? `[${nodeText(name.argumentExpression)}]` : nodeText(name);
            if (text.length > 0) return cleanText(text);
        }
        switch(node.kind){
            case 311 /* SourceFile */ :
                const sourceFile = node;
                return isExternalModule(sourceFile) ? `"${escapeString(getBaseFileName(removeFileExtension(normalizePath(sourceFile.fileName))))}"` : "<global>";
            case 276 /* ExportAssignment */ :
                return isExportAssignment(node) && node.isExportEquals ? "export=" /* ExportEquals */  : "default" /* Default */ ;
            case 218 /* ArrowFunction */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
                if (getSyntacticModifierFlags(node) & 1024 /* Default */ ) return "default";
                return getFunctionOrClassName(node);
            case 175 /* Constructor */ :
                return "constructor";
            case 179 /* ConstructSignature */ :
                return "new()";
            case 178 /* CallSignature */ :
                return "()";
            case 180 /* IndexSignature */ :
                return "[]";
            default:
                return "<unknown>";
        }
    }
    function primaryNavBarMenuItems(root) {
        const primaryNavBarMenuItems2 = [];
        function recur(item) {
            if (shouldAppearInPrimaryNavBarMenu(item)) {
                primaryNavBarMenuItems2.push(item);
                if (item.children) for (const child of item.children)recur(child);
            }
        }
        recur(root);
        return primaryNavBarMenuItems2;
        function shouldAppearInPrimaryNavBarMenu(item) {
            if (item.children) return true;
            switch(navigationBarNodeKind(item)){
                case 262 /* ClassDeclaration */ :
                case 230 /* ClassExpression */ :
                case 265 /* EnumDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                case 266 /* ModuleDeclaration */ :
                case 311 /* SourceFile */ :
                case 264 /* TypeAliasDeclaration */ :
                case 352 /* JSDocTypedefTag */ :
                case 344 /* JSDocCallbackTag */ :
                    return true;
                case 218 /* ArrowFunction */ :
                case 261 /* FunctionDeclaration */ :
                case 217 /* FunctionExpression */ :
                    return isTopLevelFunctionDeclaration(item);
                default:
                    return false;
            }
            function isTopLevelFunctionDeclaration(item2) {
                if (!item2.node.body) return false;
                switch(navigationBarNodeKind(item2.parent)){
                    case 267 /* ModuleBlock */ :
                    case 311 /* SourceFile */ :
                    case 173 /* MethodDeclaration */ :
                    case 175 /* Constructor */ :
                        return true;
                    default:
                        return false;
                }
            }
        }
    }
    function convertToTree(n) {
        return {
            text: getItemName(n.node, n.name),
            kind: getNodeKind(n.node),
            kindModifiers: getModifiers2(n.node),
            spans: getSpans(n),
            nameSpan: n.name && getNodeSpan(n.name),
            childItems: map(n.children, convertToTree)
        };
    }
    function convertToPrimaryNavBarMenuItem(n) {
        return {
            text: getItemName(n.node, n.name),
            kind: getNodeKind(n.node),
            kindModifiers: getModifiers2(n.node),
            spans: getSpans(n),
            childItems: map(n.children, convertToSecondaryNavBarMenuItem) || emptyChildItemArray,
            indent: n.indent,
            bolded: false,
            grayed: false
        };
        function convertToSecondaryNavBarMenuItem(n2) {
            return {
                text: getItemName(n2.node, n2.name),
                kind: getNodeKind(n2.node),
                kindModifiers: getNodeModifiers(n2.node),
                spans: getSpans(n2),
                childItems: emptyChildItemArray,
                indent: 0,
                bolded: false,
                grayed: false
            };
        }
    }
    function getSpans(n) {
        const spans = [
            getNodeSpan(n.node)
        ];
        if (n.additionalNodes) for (const node of n.additionalNodes)spans.push(getNodeSpan(node));
        return spans;
    }
    function getModuleName(moduleDeclaration) {
        if (isAmbientModule(moduleDeclaration)) return getTextOfNode(moduleDeclaration.name);
        return getFullyQualifiedModuleName(moduleDeclaration);
    }
    function getFullyQualifiedModuleName(moduleDeclaration) {
        const result = [
            getTextOfIdentifierOrLiteral(moduleDeclaration.name)
        ];
        while(moduleDeclaration.body && moduleDeclaration.body.kind === 266 /* ModuleDeclaration */ ){
            moduleDeclaration = moduleDeclaration.body;
            result.push(getTextOfIdentifierOrLiteral(moduleDeclaration.name));
        }
        return result.join(".");
    }
    function getInteriorModule(decl) {
        return decl.body && isModuleDeclaration(decl.body) ? getInteriorModule(decl.body) : decl;
    }
    function isComputedProperty(member) {
        return !member.name || member.name.kind === 166 /* ComputedPropertyName */ ;
    }
    function getNodeSpan(node) {
        return node.kind === 311 /* SourceFile */  ? createTextSpanFromRange(node) : createTextSpanFromNode(node, curSourceFile);
    }
    function getModifiers2(node) {
        if (node.parent && node.parent.kind === 259 /* VariableDeclaration */ ) node = node.parent;
        return getNodeModifiers(node);
    }
    function getFunctionOrClassName(node) {
        const { parent: parent2  } = node;
        if (node.name && getFullWidth(node.name) > 0) return cleanText(declarationNameToString(node.name));
        else if (isVariableDeclaration(parent2)) return cleanText(declarationNameToString(parent2.name));
        else if (isBinaryExpression(parent2) && parent2.operatorToken.kind === 64 /* EqualsToken */ ) return nodeText(parent2.left).replace(whiteSpaceRegex, "");
        else if (isPropertyAssignment(parent2)) return nodeText(parent2.name);
        else if (getSyntacticModifierFlags(node) & 1024 /* Default */ ) return "default";
        else if (isClassLike(node)) return "<class>";
        else if (isCallExpression(parent2)) {
            let name = getCalledExpressionName(parent2.expression);
            if (name !== void 0) {
                name = cleanText(name);
                if (name.length > maxLength) return `${name} callback`;
                const args = cleanText(mapDefined(parent2.arguments, (a)=>isStringLiteralLike(a) ? a.getText(curSourceFile) : void 0).join(", "));
                return `${name}(${args}) callback`;
            }
        }
        return "<function>";
    }
    function getCalledExpressionName(expr) {
        if (isIdentifier(expr)) return expr.text;
        else if (isPropertyAccessExpression(expr)) {
            const left = getCalledExpressionName(expr.expression);
            const right = expr.name.text;
            return left === void 0 ? right : `${left}.${right}`;
        } else return void 0;
    }
    function isFunctionOrClassExpression(node) {
        switch(node.kind){
            case 218 /* ArrowFunction */ :
            case 217 /* FunctionExpression */ :
            case 230 /* ClassExpression */ :
                return true;
            default:
                return false;
        }
    }
    function cleanText(text) {
        text = text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
        return text.replace(/\\?(\r?\n|\r|\u2028|\u2029)/g, "");
    }
    var whiteSpaceRegex, maxLength, curCancellationToken, curSourceFile, parentsStack, parent, trackedEs5ClassesStack, trackedEs5Classes, emptyChildItemArray, isEs5ClassMember;
    var init_navigationBar = __esm({
        "src/services/navigationBar.ts" () {
            "use strict";
            init_ts4();
            whiteSpaceRegex = /\s+/g;
            maxLength = 150;
            parentsStack = [];
            trackedEs5ClassesStack = [];
            emptyChildItemArray = [];
            isEs5ClassMember = {
                [5 /* Property */ ]: true,
                [3 /* PrototypeProperty */ ]: true,
                [7 /* ObjectDefinePropertyValue */ ]: true,
                [9 /* ObjectDefinePrototypeProperty */ ]: true,
                [0 /* None */ ]: false,
                [1 /* ExportsProperty */ ]: false,
                [2 /* ModuleExports */ ]: false,
                [8 /* ObjectDefinePropertyExports */ ]: false,
                [6 /* Prototype */ ]: true,
                [4 /* ThisProperty */ ]: false
            };
        }
    });
    // src/services/_namespaces/ts.NavigationBar.ts
    var ts_NavigationBar_exports = {};
    __export(ts_NavigationBar_exports, {
        getNavigationBarItems: ()=>getNavigationBarItems,
        getNavigationTree: ()=>getNavigationTree
    });
    var init_ts_NavigationBar = __esm({
        "src/services/_namespaces/ts.NavigationBar.ts" () {
            "use strict";
            init_navigationBar();
        }
    });
    // src/services/refactorProvider.ts
    function registerRefactor(name, refactor) {
        refactors.set(name, refactor);
    }
    function getApplicableRefactors(context, includeInteractiveActions) {
        return arrayFrom(flatMapIterator(refactors.values(), (refactor)=>{
            var _a;
            return context.cancellationToken && context.cancellationToken.isCancellationRequested() || !((_a = refactor.kinds) == null ? void 0 : _a.some((kind)=>refactorKindBeginsWith(kind, context.kind))) ? void 0 : refactor.getAvailableActions(context, includeInteractiveActions);
        }));
    }
    function getEditsForRefactor(context, refactorName13, actionName2, interactiveRefactorArguments) {
        const refactor = refactors.get(refactorName13);
        return refactor && refactor.getEditsForAction(context, actionName2, interactiveRefactorArguments);
    }
    var refactors;
    var init_refactorProvider = __esm({
        "src/services/refactorProvider.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactors = /* @__PURE__ */ new Map();
        }
    });
    // src/services/refactors/convertExport.ts
    function getInfo2(context, considerPartialSpans = true) {
        const { file: file , program: program  } = context;
        const span = getRefactorContextSpan(context);
        const token = getTokenAtPosition(file, span.start);
        const exportNode = !!(token.parent && getSyntacticModifierFlags(token.parent) & 1 /* Export */ ) && considerPartialSpans ? token.parent : getParentNodeInSpan(token, file, span);
        if (!exportNode || !isSourceFile(exportNode.parent) && !(isModuleBlock(exportNode.parent) && isAmbientModule(exportNode.parent.parent))) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_export_statement)
        };
        const checker = program.getTypeChecker();
        const exportingModuleSymbol = getExportingModuleSymbol(exportNode.parent, checker);
        const flags = getSyntacticModifierFlags(exportNode) || (isExportAssignment(exportNode) && !exportNode.isExportEquals ? 1025 /* ExportDefault */  : 0 /* None */ );
        const wasDefault = !!(flags & 1024 /* Default */ );
        if (!(flags & 1 /* Export */ ) || !wasDefault && exportingModuleSymbol.exports.has("default" /* Default */ )) return {
            error: getLocaleSpecificMessage(Diagnostics.This_file_already_has_a_default_export)
        };
        const noSymbolError = (id)=>isIdentifier(id) && checker.getSymbolAtLocation(id) ? void 0 : {
                error: getLocaleSpecificMessage(Diagnostics.Can_only_convert_named_export)
            };
        switch(exportNode.kind){
            case 261 /* FunctionDeclaration */ :
            case 262 /* ClassDeclaration */ :
            case 263 /* InterfaceDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
            case 266 /* ModuleDeclaration */ :
                {
                    const node = exportNode;
                    if (!node.name) return void 0;
                    return noSymbolError(node.name) || {
                        exportNode: node,
                        exportName: node.name,
                        wasDefault: wasDefault,
                        exportingModuleSymbol: exportingModuleSymbol
                    };
                }
            case 242 /* VariableStatement */ :
                {
                    const vs = exportNode;
                    if (!(vs.declarationList.flags & 2 /* Const */ ) || vs.declarationList.declarations.length !== 1) return void 0;
                    const decl = first(vs.declarationList.declarations);
                    if (!decl.initializer) return void 0;
                    Debug.assert(!wasDefault, "Can't have a default flag here");
                    return noSymbolError(decl.name) || {
                        exportNode: vs,
                        exportName: decl.name,
                        wasDefault: wasDefault,
                        exportingModuleSymbol: exportingModuleSymbol
                    };
                }
            case 276 /* ExportAssignment */ :
                {
                    const node = exportNode;
                    if (node.isExportEquals) return void 0;
                    return noSymbolError(node.expression) || {
                        exportNode: node,
                        exportName: node.expression,
                        wasDefault: wasDefault,
                        exportingModuleSymbol: exportingModuleSymbol
                    };
                }
            default:
                return void 0;
        }
    }
    function doChange(exportingSourceFile, program, info, changes, cancellationToken) {
        changeExport(exportingSourceFile, info, changes, program.getTypeChecker());
        changeImports(program, info, changes, cancellationToken);
    }
    function changeExport(exportingSourceFile, { wasDefault: wasDefault , exportNode: exportNode , exportName: exportName  }, changes, checker) {
        if (wasDefault) {
            if (isExportAssignment(exportNode) && !exportNode.isExportEquals) {
                const exp = exportNode.expression;
                const spec = makeExportSpecifier(exp.text, exp.text);
                changes.replaceNode(exportingSourceFile, exportNode, factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                    spec
                ])));
            } else changes.delete(exportingSourceFile, Debug.checkDefined(findModifier(exportNode, 90 /* DefaultKeyword */ ), "Should find a default keyword in modifier list"));
        } else {
            const exportKeyword = Debug.checkDefined(findModifier(exportNode, 95 /* ExportKeyword */ ), "Should find an export keyword in modifier list");
            switch(exportNode.kind){
                case 261 /* FunctionDeclaration */ :
                case 262 /* ClassDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                    changes.insertNodeAfter(exportingSourceFile, exportKeyword, factory.createToken(90 /* DefaultKeyword */ ));
                    break;
                case 242 /* VariableStatement */ :
                    const decl = first(exportNode.declarationList.declarations);
                    if (!ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(exportName, checker, exportingSourceFile) && !decl.type) {
                        changes.replaceNode(exportingSourceFile, exportNode, factory.createExportDefault(Debug.checkDefined(decl.initializer, "Initializer was previously known to be present")));
                        break;
                    }
                case 265 /* EnumDeclaration */ :
                case 264 /* TypeAliasDeclaration */ :
                case 266 /* ModuleDeclaration */ :
                    changes.deleteModifier(exportingSourceFile, exportKeyword);
                    changes.insertNodeAfter(exportingSourceFile, exportNode, factory.createExportDefault(factory.createIdentifier(exportName.text)));
                    break;
                default:
                    Debug.fail(`Unexpected exportNode kind ${exportNode.kind}`);
            }
        }
    }
    function changeImports(program, { wasDefault: wasDefault , exportName: exportName , exportingModuleSymbol: exportingModuleSymbol  }, changes, cancellationToken) {
        const checker = program.getTypeChecker();
        const exportSymbol = Debug.checkDefined(checker.getSymbolAtLocation(exportName), "Export name should resolve to a symbol");
        ts_FindAllReferences_exports.Core.eachExportReference(program.getSourceFiles(), checker, cancellationToken, exportSymbol, exportingModuleSymbol, exportName.text, wasDefault, (ref)=>{
            if (exportName === ref) return;
            const importingSourceFile = ref.getSourceFile();
            if (wasDefault) changeDefaultToNamedImport(importingSourceFile, ref, changes, exportName.text);
            else changeNamedToDefaultImport(importingSourceFile, ref, changes);
        });
    }
    function changeDefaultToNamedImport(importingSourceFile, ref, changes, exportName) {
        const { parent: parent2  } = ref;
        switch(parent2.kind){
            case 210 /* PropertyAccessExpression */ :
                changes.replaceNode(importingSourceFile, ref, factory.createIdentifier(exportName));
                break;
            case 275 /* ImportSpecifier */ :
            case 280 /* ExportSpecifier */ :
                {
                    const spec = parent2;
                    changes.replaceNode(importingSourceFile, spec, makeImportSpecifier(exportName, spec.name.text));
                    break;
                }
            case 272 /* ImportClause */ :
                {
                    const clause = parent2;
                    Debug.assert(clause.name === ref, "Import clause name should match provided ref");
                    const spec = makeImportSpecifier(exportName, ref.text);
                    const { namedBindings: namedBindings  } = clause;
                    if (!namedBindings) changes.replaceNode(importingSourceFile, ref, factory.createNamedImports([
                        spec
                    ]));
                    else if (namedBindings.kind === 273 /* NamespaceImport */ ) {
                        changes.deleteRange(importingSourceFile, {
                            pos: ref.getStart(importingSourceFile),
                            end: namedBindings.getStart(importingSourceFile)
                        });
                        const quotePreference = isStringLiteral(clause.parent.moduleSpecifier) ? quotePreferenceFromString(clause.parent.moduleSpecifier, importingSourceFile) : 1 /* Double */ ;
                        const newImport = makeImport(/*defaultImport*/ void 0, [
                            makeImportSpecifier(exportName, ref.text)
                        ], clause.parent.moduleSpecifier, quotePreference);
                        changes.insertNodeAfter(importingSourceFile, clause.parent, newImport);
                    } else {
                        changes.delete(importingSourceFile, ref);
                        changes.insertNodeAtEndOfList(importingSourceFile, namedBindings.elements, spec);
                    }
                    break;
                }
            case 204 /* ImportType */ :
                const importTypeNode = parent2;
                changes.replaceNode(importingSourceFile, parent2, factory.createImportTypeNode(importTypeNode.argument, importTypeNode.assertions, factory.createIdentifier(exportName), importTypeNode.typeArguments, importTypeNode.isTypeOf));
                break;
            default:
                Debug.failBadSyntaxKind(parent2);
        }
    }
    function changeNamedToDefaultImport(importingSourceFile, ref, changes) {
        const parent2 = ref.parent;
        switch(parent2.kind){
            case 210 /* PropertyAccessExpression */ :
                changes.replaceNode(importingSourceFile, ref, factory.createIdentifier("default"));
                break;
            case 275 /* ImportSpecifier */ :
                {
                    const defaultImport = factory.createIdentifier(parent2.name.text);
                    if (parent2.parent.elements.length === 1) changes.replaceNode(importingSourceFile, parent2.parent, defaultImport);
                    else {
                        changes.delete(importingSourceFile, parent2);
                        changes.insertNodeBefore(importingSourceFile, parent2.parent, defaultImport);
                    }
                    break;
                }
            case 280 /* ExportSpecifier */ :
                changes.replaceNode(importingSourceFile, parent2, makeExportSpecifier("default", parent2.name.text));
                break;
            default:
                Debug.assertNever(parent2, `Unexpected parent kind ${parent2.kind}`);
        }
    }
    function makeImportSpecifier(propertyName, name) {
        return factory.createImportSpecifier(/*isTypeOnly*/ false, propertyName === name ? void 0 : factory.createIdentifier(propertyName), factory.createIdentifier(name));
    }
    function makeExportSpecifier(propertyName, name) {
        return factory.createExportSpecifier(/*isTypeOnly*/ false, propertyName === name ? void 0 : factory.createIdentifier(propertyName), factory.createIdentifier(name));
    }
    function getExportingModuleSymbol(parent2, checker) {
        if (isSourceFile(parent2)) return parent2.symbol;
        const symbol = parent2.parent.symbol;
        if (symbol.valueDeclaration && isExternalModuleAugmentation(symbol.valueDeclaration)) return checker.getMergedSymbol(symbol);
        return symbol;
    }
    var refactorName, defaultToNamedAction, namedToDefaultAction;
    var init_convertExport = __esm({
        "src/services/refactors/convertExport.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName = "Convert export";
            defaultToNamedAction = {
                name: "Convert default export to named export",
                description: Diagnostics.Convert_default_export_to_named_export.message,
                kind: "refactor.rewrite.export.named"
            };
            namedToDefaultAction = {
                name: "Convert named export to default export",
                description: Diagnostics.Convert_named_export_to_default_export.message,
                kind: "refactor.rewrite.export.default"
            };
            registerRefactor(refactorName, {
                kinds: [
                    defaultToNamedAction.kind,
                    namedToDefaultAction.kind
                ],
                getAvailableActions: function getRefactorActionsToConvertBetweenNamedAndDefaultExports(context) {
                    const info = getInfo2(context, context.triggerReason === "invoked");
                    if (!info) return emptyArray;
                    if (!isRefactorErrorInfo(info)) {
                        const action = info.wasDefault ? defaultToNamedAction : namedToDefaultAction;
                        return [
                            {
                                name: refactorName,
                                description: action.description,
                                actions: [
                                    action
                                ]
                            }
                        ];
                    }
                    if (context.preferences.provideRefactorNotApplicableReason) return [
                        {
                            name: refactorName,
                            description: Diagnostics.Convert_default_export_to_named_export.message,
                            actions: [
                                {
                                    ...defaultToNamedAction,
                                    notApplicableReason: info.error
                                },
                                {
                                    ...namedToDefaultAction,
                                    notApplicableReason: info.error
                                }
                            ]
                        }
                    ];
                    return emptyArray;
                },
                getEditsForAction: function getRefactorEditsToConvertBetweenNamedAndDefaultExports(context, actionName2) {
                    Debug.assert(actionName2 === defaultToNamedAction.name || actionName2 === namedToDefaultAction.name, "Unexpected action name");
                    const info = getInfo2(context);
                    Debug.assert(info && !isRefactorErrorInfo(info), "Expected applicable refactor info");
                    const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange(context.file, context.program, info, t, context.cancellationToken));
                    return {
                        edits: edits,
                        renameFilename: void 0,
                        renameLocation: void 0
                    };
                }
            });
        }
    });
    // src/services/refactors/convertImport.ts
    function getImportConversionInfo(context, considerPartialSpans = true) {
        const { file: file  } = context;
        const span = getRefactorContextSpan(context);
        const token = getTokenAtPosition(file, span.start);
        const importDecl = considerPartialSpans ? findAncestor(token, isImportDeclaration) : getParentNodeInSpan(token, file, span);
        if (!importDecl || !isImportDeclaration(importDecl)) return {
            error: "Selection is not an import declaration."
        };
        const end = span.start + span.length;
        const nextToken = findNextToken(importDecl, importDecl.parent, file);
        if (nextToken && end > nextToken.getStart()) return void 0;
        const { importClause: importClause  } = importDecl;
        if (!importClause) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_import_clause)
        };
        if (!importClause.namedBindings) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_namespace_import_or_named_imports)
        };
        if (importClause.namedBindings.kind === 273 /* NamespaceImport */ ) return {
            convertTo: 0 /* Named */ ,
            import: importClause.namedBindings
        };
        const shouldUseDefault = getShouldUseDefault(context.program, importClause);
        return shouldUseDefault ? {
            convertTo: 1 /* Default */ ,
            import: importClause.namedBindings
        } : {
            convertTo: 2 /* Namespace */ ,
            import: importClause.namedBindings
        };
    }
    function getShouldUseDefault(program, importClause) {
        return getAllowSyntheticDefaultImports(program.getCompilerOptions()) && isExportEqualsModule(importClause.parent.moduleSpecifier, program.getTypeChecker());
    }
    function doChange2(sourceFile, program, changes, info) {
        const checker = program.getTypeChecker();
        if (info.convertTo === 0 /* Named */ ) doChangeNamespaceToNamed(sourceFile, checker, changes, info.import, getAllowSyntheticDefaultImports(program.getCompilerOptions()));
        else doChangeNamedToNamespaceOrDefault(sourceFile, program, changes, info.import, info.convertTo === 1 /* Default */ );
    }
    function doChangeNamespaceToNamed(sourceFile, checker, changes, toConvert, allowSyntheticDefaultImports) {
        let usedAsNamespaceOrDefault = false;
        const nodesToReplace = [];
        const conflictingNames = /* @__PURE__ */ new Map();
        ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(toConvert.name, checker, sourceFile, (id)=>{
            if (!isPropertyAccessOrQualifiedName(id.parent)) usedAsNamespaceOrDefault = true;
            else {
                const exportName = getRightOfPropertyAccessOrQualifiedName(id.parent).text;
                if (checker.resolveName(exportName, id, 67108863 /* All */ , /*excludeGlobals*/ true)) conflictingNames.set(exportName, true);
                Debug.assert(getLeftOfPropertyAccessOrQualifiedName(id.parent) === id, "Parent expression should match id");
                nodesToReplace.push(id.parent);
            }
        });
        const exportNameToImportName = /* @__PURE__ */ new Map();
        for (const propertyAccessOrQualifiedName of nodesToReplace){
            const exportName = getRightOfPropertyAccessOrQualifiedName(propertyAccessOrQualifiedName).text;
            let importName = exportNameToImportName.get(exportName);
            if (importName === void 0) exportNameToImportName.set(exportName, importName = conflictingNames.has(exportName) ? getUniqueName(exportName, sourceFile) : exportName);
            changes.replaceNode(sourceFile, propertyAccessOrQualifiedName, factory.createIdentifier(importName));
        }
        const importSpecifiers = [];
        exportNameToImportName.forEach((name, propertyName)=>{
            importSpecifiers.push(factory.createImportSpecifier(/*isTypeOnly*/ false, name === propertyName ? void 0 : factory.createIdentifier(propertyName), factory.createIdentifier(name)));
        });
        const importDecl = toConvert.parent.parent;
        if (usedAsNamespaceOrDefault && !allowSyntheticDefaultImports) changes.insertNodeAfter(sourceFile, importDecl, updateImport(importDecl, /*defaultImportName*/ void 0, importSpecifiers));
        else changes.replaceNode(sourceFile, importDecl, updateImport(importDecl, usedAsNamespaceOrDefault ? factory.createIdentifier(toConvert.name.text) : void 0, importSpecifiers));
    }
    function getRightOfPropertyAccessOrQualifiedName(propertyAccessOrQualifiedName) {
        return isPropertyAccessExpression(propertyAccessOrQualifiedName) ? propertyAccessOrQualifiedName.name : propertyAccessOrQualifiedName.right;
    }
    function getLeftOfPropertyAccessOrQualifiedName(propertyAccessOrQualifiedName) {
        return isPropertyAccessExpression(propertyAccessOrQualifiedName) ? propertyAccessOrQualifiedName.expression : propertyAccessOrQualifiedName.left;
    }
    function doChangeNamedToNamespaceOrDefault(sourceFile, program, changes, toConvert, shouldUseDefault = getShouldUseDefault(program, toConvert.parent)) {
        const checker = program.getTypeChecker();
        const importDecl = toConvert.parent.parent;
        const { moduleSpecifier: moduleSpecifier  } = importDecl;
        const toConvertSymbols = /* @__PURE__ */ new Set();
        toConvert.elements.forEach((namedImport)=>{
            const symbol = checker.getSymbolAtLocation(namedImport.name);
            if (symbol) toConvertSymbols.add(symbol);
        });
        const preferredName = moduleSpecifier && isStringLiteral(moduleSpecifier) ? ts_codefix_exports.moduleSpecifierToValidIdentifier(moduleSpecifier.text, 99 /* ESNext */ ) : "module";
        function hasNamespaceNameConflict(namedImport) {
            return !!ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(namedImport.name, checker, sourceFile, (id)=>{
                const symbol = checker.resolveName(preferredName, id, 67108863 /* All */ , /*excludeGlobals*/ true);
                if (symbol) {
                    if (toConvertSymbols.has(symbol)) return isExportSpecifier(id.parent);
                    return true;
                }
                return false;
            });
        }
        const namespaceNameConflicts = toConvert.elements.some(hasNamespaceNameConflict);
        const namespaceImportName = namespaceNameConflicts ? getUniqueName(preferredName, sourceFile) : preferredName;
        const neededNamedImports = /* @__PURE__ */ new Set();
        for (const element of toConvert.elements){
            const propertyName = (element.propertyName || element.name).text;
            ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(element.name, checker, sourceFile, (id)=>{
                const access = factory.createPropertyAccessExpression(factory.createIdentifier(namespaceImportName), propertyName);
                if (isShorthandPropertyAssignment(id.parent)) changes.replaceNode(sourceFile, id.parent, factory.createPropertyAssignment(id.text, access));
                else if (isExportSpecifier(id.parent)) neededNamedImports.add(element);
                else changes.replaceNode(sourceFile, id, access);
            });
        }
        changes.replaceNode(sourceFile, toConvert, shouldUseDefault ? factory.createIdentifier(namespaceImportName) : factory.createNamespaceImport(factory.createIdentifier(namespaceImportName)));
        if (neededNamedImports.size) {
            const newNamedImports = arrayFrom(neededNamedImports.values(), (element)=>factory.createImportSpecifier(element.isTypeOnly, element.propertyName && factory.createIdentifier(element.propertyName.text), factory.createIdentifier(element.name.text)));
            changes.insertNodeAfter(sourceFile, toConvert.parent.parent, updateImport(importDecl, /*defaultImportName*/ void 0, newNamedImports));
        }
    }
    function isExportEqualsModule(moduleSpecifier, checker) {
        const externalModule = checker.resolveExternalModuleName(moduleSpecifier);
        if (!externalModule) return false;
        const exportEquals = checker.resolveExternalModuleSymbol(externalModule);
        return externalModule !== exportEquals;
    }
    function updateImport(old, defaultImportName, elements) {
        return factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/*isTypeOnly*/ false, defaultImportName, elements && elements.length ? factory.createNamedImports(elements) : void 0), old.moduleSpecifier, /*assertClause*/ void 0);
    }
    var refactorName2, actions;
    var init_convertImport = __esm({
        "src/services/refactors/convertImport.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName2 = "Convert import";
            actions = {
                [0 /* Named */ ]: {
                    name: "Convert namespace import to named imports",
                    description: Diagnostics.Convert_namespace_import_to_named_imports.message,
                    kind: "refactor.rewrite.import.named"
                },
                [2 /* Namespace */ ]: {
                    name: "Convert named imports to namespace import",
                    description: Diagnostics.Convert_named_imports_to_namespace_import.message,
                    kind: "refactor.rewrite.import.namespace"
                },
                [1 /* Default */ ]: {
                    name: "Convert named imports to default import",
                    description: Diagnostics.Convert_named_imports_to_default_import.message,
                    kind: "refactor.rewrite.import.default"
                }
            };
            registerRefactor(refactorName2, {
                kinds: getOwnValues(actions).map((a)=>a.kind),
                getAvailableActions: function getRefactorActionsToConvertBetweenNamedAndNamespacedImports(context) {
                    const info = getImportConversionInfo(context, context.triggerReason === "invoked");
                    if (!info) return emptyArray;
                    if (!isRefactorErrorInfo(info)) {
                        const action = actions[info.convertTo];
                        return [
                            {
                                name: refactorName2,
                                description: action.description,
                                actions: [
                                    action
                                ]
                            }
                        ];
                    }
                    if (context.preferences.provideRefactorNotApplicableReason) return getOwnValues(actions).map((action)=>({
                            name: refactorName2,
                            description: action.description,
                            actions: [
                                {
                                    ...action,
                                    notApplicableReason: info.error
                                }
                            ]
                        }));
                    return emptyArray;
                },
                getEditsForAction: function getRefactorEditsToConvertBetweenNamedAndNamespacedImports(context, actionName2) {
                    Debug.assert(some(getOwnValues(actions), (action)=>action.name === actionName2), "Unexpected action name");
                    const info = getImportConversionInfo(context);
                    Debug.assert(info && !isRefactorErrorInfo(info), "Expected applicable refactor info");
                    const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange2(context.file, context.program, t, info));
                    return {
                        edits: edits,
                        renameFilename: void 0,
                        renameLocation: void 0
                    };
                }
            });
        }
    });
    // src/services/refactors/extractType.ts
    function getRangeToExtract(context, considerEmptySpans = true) {
        const { file: file , startPosition: startPosition  } = context;
        const isJS = isSourceFileJS(file);
        const current = getTokenAtPosition(file, startPosition);
        const range = createTextRangeFromSpan(getRefactorContextSpan(context));
        const cursorRequest = range.pos === range.end && considerEmptySpans;
        const selection = findAncestor(current, (node)=>node.parent && isTypeNode(node) && !rangeContainsSkipTrivia(range, node.parent, file) && (cursorRequest || nodeOverlapsWithStartEnd(current, file, range.pos, range.end)));
        if (!selection || !isTypeNode(selection)) return {
            error: getLocaleSpecificMessage(Diagnostics.Selection_is_not_a_valid_type_node)
        };
        const checker = context.program.getTypeChecker();
        const enclosingNode = getEnclosingNode(selection, isJS);
        if (enclosingNode === void 0) return {
            error: getLocaleSpecificMessage(Diagnostics.No_type_could_be_extracted_from_this_type_node)
        };
        const typeParameters = collectTypeParameters(checker, selection, enclosingNode, file);
        if (!typeParameters) return {
            error: getLocaleSpecificMessage(Diagnostics.No_type_could_be_extracted_from_this_type_node)
        };
        const typeElements = flattenTypeLiteralNodeReference(checker, selection);
        return {
            isJS: isJS,
            selection: selection,
            enclosingNode: enclosingNode,
            typeParameters: typeParameters,
            typeElements: typeElements
        };
    }
    function flattenTypeLiteralNodeReference(checker, node) {
        if (!node) return void 0;
        if (isIntersectionTypeNode(node)) {
            const result = [];
            const seen = /* @__PURE__ */ new Map();
            for (const type of node.types){
                const flattenedTypeMembers = flattenTypeLiteralNodeReference(checker, type);
                if (!flattenedTypeMembers || !flattenedTypeMembers.every((type2)=>type2.name && addToSeen(seen, getNameFromPropertyName(type2.name)))) return void 0;
                addRange(result, flattenedTypeMembers);
            }
            return result;
        } else if (isParenthesizedTypeNode(node)) return flattenTypeLiteralNodeReference(checker, node.type);
        else if (isTypeLiteralNode(node)) return node.members;
        return void 0;
    }
    function rangeContainsSkipTrivia(r1, node, file) {
        return rangeContainsStartEnd(r1, skipTrivia(file.text, node.pos), node.end);
    }
    function collectTypeParameters(checker, selection, enclosingNode, file) {
        const result = [];
        return visitor(selection) ? void 0 : result;
        function visitor(node) {
            if (isTypeReferenceNode(node)) {
                if (isIdentifier(node.typeName)) {
                    const typeName = node.typeName;
                    const symbol = checker.resolveName(typeName.text, typeName, 262144 /* TypeParameter */ , /*excludeGlobals*/ true);
                    for (const decl of (symbol == null ? void 0 : symbol.declarations) || emptyArray)if (isTypeParameterDeclaration(decl) && decl.getSourceFile() === file) {
                        if (decl.name.escapedText === typeName.escapedText && rangeContainsSkipTrivia(decl, selection, file)) return true;
                        if (rangeContainsSkipTrivia(enclosingNode, decl, file) && !rangeContainsSkipTrivia(selection, decl, file)) {
                            pushIfUnique(result, decl);
                            break;
                        }
                    }
                }
            } else if (isInferTypeNode(node)) {
                const conditionalTypeNode = findAncestor(node, (n)=>isConditionalTypeNode(n) && rangeContainsSkipTrivia(n.extendsType, node, file));
                if (!conditionalTypeNode || !rangeContainsSkipTrivia(selection, conditionalTypeNode, file)) return true;
            } else if (isTypePredicateNode(node) || isThisTypeNode(node)) {
                const functionLikeNode = findAncestor(node.parent, isFunctionLike);
                if (functionLikeNode && functionLikeNode.type && rangeContainsSkipTrivia(functionLikeNode.type, node, file) && !rangeContainsSkipTrivia(selection, functionLikeNode, file)) return true;
            } else if (isTypeQueryNode(node)) {
                if (isIdentifier(node.exprName)) {
                    const symbol = checker.resolveName(node.exprName.text, node.exprName, 111551 /* Value */ , /*excludeGlobals*/ false);
                    if ((symbol == null ? void 0 : symbol.valueDeclaration) && rangeContainsSkipTrivia(enclosingNode, symbol.valueDeclaration, file) && !rangeContainsSkipTrivia(selection, symbol.valueDeclaration, file)) return true;
                } else {
                    if (isThisIdentifier(node.exprName.left) && !rangeContainsSkipTrivia(selection, node.parent, file)) return true;
                }
            }
            if (file && isTupleTypeNode(node) && getLineAndCharacterOfPosition(file, node.pos).line === getLineAndCharacterOfPosition(file, node.end).line) setEmitFlags(node, 1 /* SingleLine */ );
            return forEachChild(node, visitor);
        }
    }
    function doTypeAliasChange(changes, file, name, info) {
        const { enclosingNode: enclosingNode , selection: selection , typeParameters: typeParameters  } = info;
        const newTypeNode = factory.createTypeAliasDeclaration(/*modifiers*/ void 0, name, typeParameters.map((id)=>factory.updateTypeParameterDeclaration(id, id.modifiers, id.name, id.constraint, /*defaultType*/ void 0)), selection);
        changes.insertNodeBefore(file, enclosingNode, ignoreSourceNewlines(newTypeNode), /*blankLineBetween*/ true);
        changes.replaceNode(file, selection, factory.createTypeReferenceNode(name, typeParameters.map((id)=>factory.createTypeReferenceNode(id.name, /*typeArguments*/ void 0))), {
            leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
            trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.ExcludeWhitespace
        });
    }
    function doInterfaceChange(changes, file, name, info) {
        var _a;
        const { enclosingNode: enclosingNode , selection: selection , typeParameters: typeParameters , typeElements: typeElements  } = info;
        const newTypeNode = factory.createInterfaceDeclaration(/*modifiers*/ void 0, name, typeParameters, /*heritageClauses*/ void 0, typeElements);
        setTextRange(newTypeNode, (_a = typeElements[0]) == null ? void 0 : _a.parent);
        changes.insertNodeBefore(file, enclosingNode, ignoreSourceNewlines(newTypeNode), /*blankLineBetween*/ true);
        changes.replaceNode(file, selection, factory.createTypeReferenceNode(name, typeParameters.map((id)=>factory.createTypeReferenceNode(id.name, /*typeArguments*/ void 0))), {
            leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
            trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.ExcludeWhitespace
        });
    }
    function doTypedefChange(changes, context, file, name, info) {
        var _a;
        const { enclosingNode: enclosingNode , selection: selection , typeParameters: typeParameters  } = info;
        setEmitFlags(selection, 7168 /* NoNestedComments */ );
        const node = factory.createJSDocTypedefTag(factory.createIdentifier("typedef"), factory.createJSDocTypeExpression(selection), factory.createIdentifier(name));
        const templates = [];
        forEach(typeParameters, (typeParameter)=>{
            const constraint = getEffectiveConstraintOfTypeParameter(typeParameter);
            const parameter = factory.createTypeParameterDeclaration(/*modifiers*/ void 0, typeParameter.name);
            const template = factory.createJSDocTemplateTag(factory.createIdentifier("template"), constraint && cast(constraint, isJSDocTypeExpression), [
                parameter
            ]);
            templates.push(template);
        });
        const jsDoc = factory.createJSDocComment(/*comment*/ void 0, factory.createNodeArray(concatenate(templates, [
            node
        ])));
        if (isJSDoc(enclosingNode)) {
            const pos = enclosingNode.getStart(file);
            const newLineCharacter = getNewLineOrDefaultFromHost(context.host, (_a = context.formatContext) == null ? void 0 : _a.options);
            changes.insertNodeAt(file, enclosingNode.getStart(file), jsDoc, {
                suffix: newLineCharacter + newLineCharacter + file.text.slice(getPrecedingNonSpaceCharacterPosition(file.text, pos - 1), pos)
            });
        } else changes.insertNodeBefore(file, enclosingNode, jsDoc, /*blankLineBetween*/ true);
        changes.replaceNode(file, selection, factory.createTypeReferenceNode(name, typeParameters.map((id)=>factory.createTypeReferenceNode(id.name, /*typeArguments*/ void 0))));
    }
    function getEnclosingNode(node, isJS) {
        return findAncestor(node, isStatement) || (isJS ? findAncestor(node, isJSDoc) : void 0);
    }
    var refactorName3, extractToTypeAliasAction, extractToInterfaceAction, extractToTypeDefAction;
    var init_extractType = __esm({
        "src/services/refactors/extractType.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName3 = "Extract type";
            extractToTypeAliasAction = {
                name: "Extract to type alias",
                description: getLocaleSpecificMessage(Diagnostics.Extract_to_type_alias),
                kind: "refactor.extract.type"
            };
            extractToInterfaceAction = {
                name: "Extract to interface",
                description: getLocaleSpecificMessage(Diagnostics.Extract_to_interface),
                kind: "refactor.extract.interface"
            };
            extractToTypeDefAction = {
                name: "Extract to typedef",
                description: getLocaleSpecificMessage(Diagnostics.Extract_to_typedef),
                kind: "refactor.extract.typedef"
            };
            registerRefactor(refactorName3, {
                kinds: [
                    extractToTypeAliasAction.kind,
                    extractToInterfaceAction.kind,
                    extractToTypeDefAction.kind
                ],
                getAvailableActions: function getRefactorActionsToExtractType(context) {
                    const info = getRangeToExtract(context, context.triggerReason === "invoked");
                    if (!info) return emptyArray;
                    if (!isRefactorErrorInfo(info)) return [
                        {
                            name: refactorName3,
                            description: getLocaleSpecificMessage(Diagnostics.Extract_type),
                            actions: info.isJS ? [
                                extractToTypeDefAction
                            ] : append([
                                extractToTypeAliasAction
                            ], info.typeElements && extractToInterfaceAction)
                        }
                    ];
                    if (context.preferences.provideRefactorNotApplicableReason) return [
                        {
                            name: refactorName3,
                            description: getLocaleSpecificMessage(Diagnostics.Extract_type),
                            actions: [
                                {
                                    ...extractToTypeDefAction,
                                    notApplicableReason: info.error
                                },
                                {
                                    ...extractToTypeAliasAction,
                                    notApplicableReason: info.error
                                },
                                {
                                    ...extractToInterfaceAction,
                                    notApplicableReason: info.error
                                }
                            ]
                        }
                    ];
                    return emptyArray;
                },
                getEditsForAction: function getRefactorEditsToExtractType(context, actionName2) {
                    const { file: file  } = context;
                    const info = getRangeToExtract(context);
                    Debug.assert(info && !isRefactorErrorInfo(info), "Expected to find a range to extract");
                    const name = getUniqueName("NewType", file);
                    const edits = ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                        switch(actionName2){
                            case extractToTypeAliasAction.name:
                                Debug.assert(!info.isJS, "Invalid actionName/JS combo");
                                return doTypeAliasChange(changes, file, name, info);
                            case extractToTypeDefAction.name:
                                Debug.assert(info.isJS, "Invalid actionName/JS combo");
                                return doTypedefChange(changes, context, file, name, info);
                            case extractToInterfaceAction.name:
                                Debug.assert(!info.isJS && !!info.typeElements, "Invalid actionName/JS combo");
                                return doInterfaceChange(changes, file, name, info);
                            default:
                                Debug.fail("Unexpected action name");
                        }
                    });
                    const renameFilename = file.fileName;
                    const renameLocation = getRenameLocation(edits, renameFilename, name, /*preferLastLocation*/ false);
                    return {
                        edits: edits,
                        renameFilename: renameFilename,
                        renameLocation: renameLocation
                    };
                }
            });
        }
    });
    // src/services/refactors/helpers.ts
    function isRefactorErrorInfo(info) {
        return info.error !== void 0;
    }
    function refactorKindBeginsWith(known, requested) {
        if (!requested) return true;
        return known.substr(0, requested.length) === requested;
    }
    var init_helpers = __esm({
        "src/services/refactors/helpers.ts" () {
            "use strict";
        }
    });
    // src/services/refactors/moveToNewFile.ts
    function doChange3(oldFile, program, toMove, changes, host, preferences, context) {
        const checker = program.getTypeChecker();
        const usage = getUsageInfo(oldFile, toMove.all, checker);
        const newFilename = createNewFileName(oldFile, program, context, host);
        changes.createNewFile(oldFile, newFilename, getNewStatementsAndRemoveFromOldFile(oldFile, usage, changes, toMove, program, host, newFilename, preferences));
        addNewFileToTsconfig(program, changes, oldFile.fileName, newFilename, hostGetCanonicalFileName(host));
    }
    function getNewStatementsAndRemoveFromOldFile(oldFile, usage, changes, toMove, program, host, newFilename, preferences) {
        const checker = program.getTypeChecker();
        const prologueDirectives = takeWhile(oldFile.statements, isPrologueDirective);
        if (oldFile.externalModuleIndicator === void 0 && oldFile.commonJsModuleIndicator === void 0 && usage.oldImportsNeededByTargetFile.size === 0) {
            deleteMovedStatements(oldFile, toMove.ranges, changes);
            return [
                ...prologueDirectives,
                ...toMove.all
            ];
        }
        const useEsModuleSyntax = !fileShouldUseJavaScriptRequire(newFilename, program, host, !!oldFile.commonJsModuleIndicator);
        const quotePreference = getQuotePreference(oldFile, preferences);
        const importsFromNewFile = createOldFileImportsFromTargetFile(oldFile, usage.oldFileImportsFromTargetFile, newFilename, program, host, useEsModuleSyntax, quotePreference);
        if (importsFromNewFile) insertImports(changes, oldFile, importsFromNewFile, /*blankLineBetween*/ true, preferences);
        deleteUnusedOldImports(oldFile, toMove.all, changes, usage.unusedImportsFromOldFile, checker);
        deleteMovedStatements(oldFile, toMove.ranges, changes);
        updateImportsInOtherFiles(changes, program, host, oldFile, usage.movedSymbols, newFilename, quotePreference);
        const imports = getNewFileImportsAndAddExportInOldFile(oldFile, usage.oldImportsNeededByTargetFile, usage.targetFileImportsFromOldFile, changes, checker, program, host, useEsModuleSyntax, quotePreference);
        const body = addExports(oldFile, toMove.all, usage.oldFileImportsFromTargetFile, useEsModuleSyntax);
        if (imports.length && body.length) return [
            ...prologueDirectives,
            ...imports,
            4 /* NewLineTrivia */ ,
            ...body
        ];
        return [
            ...prologueDirectives,
            ...imports,
            ...body
        ];
    }
    function getNewFileImportsAndAddExportInOldFile(oldFile, importsToCopy, newFileImportsFromOldFile, changes, checker, program, host, useEsModuleSyntax, quotePreference) {
        const copiedOldImports = [];
        for (const oldStatement of oldFile.statements)forEachImportInStatement(oldStatement, (i)=>{
            append(copiedOldImports, filterImport(i, moduleSpecifierFromImport(i), (name)=>importsToCopy.has(checker.getSymbolAtLocation(name))));
        });
        let oldFileDefault;
        const oldFileNamedImports = [];
        const markSeenTop = nodeSeenTracker();
        newFileImportsFromOldFile.forEach((symbol)=>{
            if (!symbol.declarations) return;
            for (const decl of symbol.declarations){
                if (!isTopLevelDeclaration(decl)) continue;
                const name = nameOfTopLevelDeclaration(decl);
                if (!name) continue;
                const top = getTopLevelDeclarationStatement(decl);
                if (markSeenTop(top)) addExportToChanges(oldFile, top, name, changes, useEsModuleSyntax);
                if (hasSyntacticModifier(decl, 1024 /* Default */ )) oldFileDefault = name;
                else oldFileNamedImports.push(name.text);
            }
        });
        append(copiedOldImports, makeImportOrRequire(oldFile, oldFileDefault, oldFileNamedImports, getBaseFileName(oldFile.fileName), program, host, useEsModuleSyntax, quotePreference));
        return copiedOldImports;
    }
    var refactorName4, description, moveToNewFileAction;
    var init_moveToNewFile = __esm({
        "src/services/refactors/moveToNewFile.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName4 = "Move to a new file";
            description = getLocaleSpecificMessage(Diagnostics.Move_to_a_new_file);
            moveToNewFileAction = {
                name: refactorName4,
                description: description,
                kind: "refactor.move.newFile"
            };
            registerRefactor(refactorName4, {
                kinds: [
                    moveToNewFileAction.kind
                ],
                getAvailableActions: function getRefactorActionsToMoveToNewFile(context) {
                    const statements = getStatementsToMove(context);
                    if (context.preferences.allowTextChangesInNewFiles && statements) return [
                        {
                            name: refactorName4,
                            description: description,
                            actions: [
                                moveToNewFileAction
                            ]
                        }
                    ];
                    if (context.preferences.provideRefactorNotApplicableReason) return [
                        {
                            name: refactorName4,
                            description: description,
                            actions: [
                                {
                                    ...moveToNewFileAction,
                                    notApplicableReason: getLocaleSpecificMessage(Diagnostics.Selection_is_not_a_valid_statement_or_statements)
                                }
                            ]
                        }
                    ];
                    return emptyArray;
                },
                getEditsForAction: function getRefactorEditsToMoveToNewFile(context, actionName2) {
                    Debug.assert(actionName2 === refactorName4, "Wrong refactor invoked");
                    const statements = Debug.checkDefined(getStatementsToMove(context));
                    const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange3(context.file, context.program, statements, t, context.host, context.preferences, context));
                    return {
                        edits: edits,
                        renameFilename: void 0,
                        renameLocation: void 0
                    };
                }
            });
        }
    });
    // src/services/refactors/moveToFile.ts
    function doChange4(context, oldFile, targetFile, program, toMove, changes, host, preferences) {
        const checker = program.getTypeChecker();
        const usage = getUsageInfo(oldFile, toMove.all, checker);
        if (!host.fileExists(targetFile)) {
            changes.createNewFile(oldFile, targetFile, getNewStatementsAndRemoveFromOldFile2(oldFile, targetFile, usage, changes, toMove, program, host, preferences));
            addNewFileToTsconfig(program, changes, oldFile.fileName, targetFile, hostGetCanonicalFileName(host));
        } else {
            const targetSourceFile = Debug.checkDefined(program.getSourceFile(targetFile));
            const importAdder = ts_codefix_exports.createImportAdder(targetSourceFile, context.program, context.preferences, context.host);
            getNewStatementsAndRemoveFromOldFile2(oldFile, targetSourceFile, usage, changes, toMove, program, host, preferences, importAdder);
        }
    }
    function getNewStatementsAndRemoveFromOldFile2(oldFile, targetFile, usage, changes, toMove, program, host, preferences, importAdder) {
        const checker = program.getTypeChecker();
        const prologueDirectives = takeWhile(oldFile.statements, isPrologueDirective);
        if (oldFile.externalModuleIndicator === void 0 && oldFile.commonJsModuleIndicator === void 0 && usage.oldImportsNeededByTargetFile.size === 0 && usage.targetFileImportsFromOldFile.size === 0 && typeof targetFile === "string") {
            deleteMovedStatements(oldFile, toMove.ranges, changes);
            return [
                ...prologueDirectives,
                ...toMove.all
            ];
        }
        const targetFileName = typeof targetFile === "string" ? targetFile : targetFile.fileName;
        const useEsModuleSyntax = !fileShouldUseJavaScriptRequire(targetFileName, program, host, !!oldFile.commonJsModuleIndicator);
        const quotePreference = getQuotePreference(oldFile, preferences);
        const importsFromTargetFile = createOldFileImportsFromTargetFile(oldFile, usage.oldFileImportsFromTargetFile, targetFileName, program, host, useEsModuleSyntax, quotePreference);
        if (importsFromTargetFile) insertImports(changes, oldFile, importsFromTargetFile, /*blankLineBetween*/ true, preferences);
        deleteUnusedOldImports(oldFile, toMove.all, changes, usage.unusedImportsFromOldFile, checker);
        deleteMovedStatements(oldFile, toMove.ranges, changes);
        updateImportsInOtherFiles(changes, program, host, oldFile, usage.movedSymbols, targetFileName, quotePreference);
        const imports = getTargetFileImportsAndAddExportInOldFile(oldFile, targetFileName, usage.oldImportsNeededByTargetFile, usage.targetFileImportsFromOldFile, changes, checker, program, host, useEsModuleSyntax, quotePreference, importAdder);
        const body = addExports(oldFile, toMove.all, usage.oldFileImportsFromTargetFile, useEsModuleSyntax);
        if (typeof targetFile !== "string") {
            if (targetFile.statements.length > 0) changes.insertNodesAfter(targetFile, targetFile.statements[targetFile.statements.length - 1], body);
            else changes.insertNodesAtEndOfFile(targetFile, body, /*blankLineBetween*/ false);
            if (imports.length > 0) insertImports(changes, targetFile, imports, /*blankLineBetween*/ true, preferences);
        }
        if (importAdder) importAdder.writeFixes(changes);
        if (imports.length && body.length) return [
            ...prologueDirectives,
            ...imports,
            4 /* NewLineTrivia */ ,
            ...body
        ];
        return [
            ...prologueDirectives,
            ...imports,
            ...body
        ];
    }
    function getTargetFileImportsAndAddExportInOldFile(oldFile, targetFile, importsToCopy, targetFileImportsFromOldFile, changes, checker, program, host, useEsModuleSyntax, quotePreference, importAdder) {
        const copiedOldImports = [];
        if (importAdder) importsToCopy.forEach((isValidTypeOnlyUseSite, symbol)=>{
            try {
                importAdder.addImportFromExportedSymbol(skipAlias(symbol, checker), isValidTypeOnlyUseSite);
            } catch  {
                for (const oldStatement of oldFile.statements)forEachImportInStatement(oldStatement, (i)=>{
                    append(copiedOldImports, filterImport(i, factory.createStringLiteral(moduleSpecifierFromImport(i).text), (name)=>importsToCopy.has(checker.getSymbolAtLocation(name))));
                });
            }
        });
        else {
            const targetSourceFile = program.getSourceFile(targetFile);
            for (const oldStatement of oldFile.statements)forEachImportInStatement(oldStatement, (i)=>{
                var _a, _b;
                const moduleSpecifier = moduleSpecifierFromImport(i);
                const resolved = (_a = oldFile.resolvedModules) == null ? void 0 : _a.get(moduleSpecifier.text, getModeForUsageLocation(oldFile, moduleSpecifier));
                const fileName = (_b = resolved == null ? void 0 : resolved.resolvedModule) == null ? void 0 : _b.resolvedFileName;
                if (fileName && targetSourceFile) {
                    const newModuleSpecifier = getModuleSpecifier(program.getCompilerOptions(), targetSourceFile, targetSourceFile.path, fileName, createModuleSpecifierResolutionHost(program, host));
                    append(copiedOldImports, filterImport(i, makeStringLiteral(newModuleSpecifier, quotePreference), (name)=>importsToCopy.has(checker.getSymbolAtLocation(name))));
                } else append(copiedOldImports, filterImport(i, factory.createStringLiteral(moduleSpecifierFromImport(i).text), (name)=>importsToCopy.has(checker.getSymbolAtLocation(name))));
            });
        }
        const targetFileSourceFile = program.getSourceFile(targetFile);
        let oldFileDefault;
        const oldFileNamedImports = [];
        const markSeenTop = nodeSeenTracker();
        targetFileImportsFromOldFile.forEach((symbol)=>{
            if (!symbol.declarations) return;
            for (const decl of symbol.declarations){
                if (!isTopLevelDeclaration(decl)) continue;
                const name = nameOfTopLevelDeclaration(decl);
                if (!name) continue;
                const top = getTopLevelDeclarationStatement(decl);
                if (markSeenTop(top)) addExportToChanges(oldFile, top, name, changes, useEsModuleSyntax);
                if (importAdder && checker.isUnknownSymbol(symbol)) importAdder.addImportFromExportedSymbol(skipAlias(symbol, checker));
                else if (hasSyntacticModifier(decl, 1024 /* Default */ )) oldFileDefault = name;
                else oldFileNamedImports.push(name.text);
            }
        });
        return targetFileSourceFile ? append(copiedOldImports, makeImportOrRequire(targetFileSourceFile, oldFileDefault, oldFileNamedImports, oldFile.fileName, program, host, useEsModuleSyntax, quotePreference)) : append(copiedOldImports, makeImportOrRequire(oldFile, oldFileDefault, oldFileNamedImports, oldFile.fileName, program, host, useEsModuleSyntax, quotePreference));
    }
    function addNewFileToTsconfig(program, changes, oldFileName, newFileNameWithExtension, getCanonicalFileName) {
        const cfg = program.getCompilerOptions().configFile;
        if (!cfg) return;
        const newFileAbsolutePath = normalizePath(combinePaths(oldFileName, "..", newFileNameWithExtension));
        const newFilePath = getRelativePathFromFile(cfg.fileName, newFileAbsolutePath, getCanonicalFileName);
        const cfgObject = cfg.statements[0] && tryCast(cfg.statements[0].expression, isObjectLiteralExpression);
        const filesProp = cfgObject && find(cfgObject.properties, (prop)=>isPropertyAssignment(prop) && isStringLiteral(prop.name) && prop.name.text === "files");
        if (filesProp && isArrayLiteralExpression(filesProp.initializer)) changes.insertNodeInListAfter(cfg, last(filesProp.initializer.elements), factory.createStringLiteral(newFilePath), filesProp.initializer.elements);
    }
    function deleteMovedStatements(sourceFile, moved, changes) {
        for (const { first: first2 , afterLast: afterLast  } of moved)changes.deleteNodeRangeExcludingEnd(sourceFile, first2, afterLast);
    }
    function deleteUnusedOldImports(oldFile, toMove, changes, toDelete, checker) {
        for (const statement of oldFile.statements){
            if (contains(toMove, statement)) continue;
            forEachImportInStatement(statement, (i)=>deleteUnusedImports(oldFile, i, changes, (name)=>toDelete.has(checker.getSymbolAtLocation(name))));
        }
    }
    function updateImportsInOtherFiles(changes, program, host, oldFile, movedSymbols, targetFileName, quotePreference) {
        const checker = program.getTypeChecker();
        for (const sourceFile of program.getSourceFiles()){
            if (sourceFile === oldFile) continue;
            for (const statement of sourceFile.statements)forEachImportInStatement(statement, (importNode)=>{
                if (checker.getSymbolAtLocation(moduleSpecifierFromImport(importNode)) !== oldFile.symbol) return;
                const shouldMove = (name)=>{
                    const symbol = isBindingElement(name.parent) ? getPropertySymbolFromBindingElement(checker, name.parent) : skipAlias(checker.getSymbolAtLocation(name), checker);
                    return !!symbol && movedSymbols.has(symbol);
                };
                deleteUnusedImports(sourceFile, importNode, changes, shouldMove);
                const pathToTargetFileWithExtension = resolvePath(getDirectoryPath(oldFile.path), targetFileName);
                const newModuleSpecifier = getModuleSpecifier(program.getCompilerOptions(), sourceFile, sourceFile.path, pathToTargetFileWithExtension, createModuleSpecifierResolutionHost(program, host));
                const newImportDeclaration = filterImport(importNode, makeStringLiteral(newModuleSpecifier, quotePreference), shouldMove);
                if (newImportDeclaration) changes.insertNodeAfter(sourceFile, statement, newImportDeclaration);
                const ns = getNamespaceLikeImport(importNode);
                if (ns) updateNamespaceLikeImport(changes, sourceFile, checker, movedSymbols, newModuleSpecifier, ns, importNode, quotePreference);
            });
        }
    }
    function getNamespaceLikeImport(node) {
        switch(node.kind){
            case 271 /* ImportDeclaration */ :
                return node.importClause && node.importClause.namedBindings && node.importClause.namedBindings.kind === 273 /* NamespaceImport */  ? node.importClause.namedBindings.name : void 0;
            case 270 /* ImportEqualsDeclaration */ :
                return node.name;
            case 259 /* VariableDeclaration */ :
                return tryCast(node.name, isIdentifier);
            default:
                return Debug.assertNever(node, `Unexpected node kind ${node.kind}`);
        }
    }
    function updateNamespaceLikeImport(changes, sourceFile, checker, movedSymbols, newModuleSpecifier, oldImportId, oldImportNode, quotePreference) {
        const preferredNewNamespaceName = ts_codefix_exports.moduleSpecifierToValidIdentifier(newModuleSpecifier, 99 /* ESNext */ );
        let needUniqueName = false;
        const toChange = [];
        ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(oldImportId, checker, sourceFile, (ref)=>{
            if (!isPropertyAccessExpression(ref.parent)) return;
            needUniqueName = needUniqueName || !!checker.resolveName(preferredNewNamespaceName, ref, 67108863 /* All */ , /*excludeGlobals*/ true);
            if (movedSymbols.has(checker.getSymbolAtLocation(ref.parent.name))) toChange.push(ref);
        });
        if (toChange.length) {
            const newNamespaceName = needUniqueName ? getUniqueName(preferredNewNamespaceName, sourceFile) : preferredNewNamespaceName;
            for (const ref of toChange)changes.replaceNode(sourceFile, ref, factory.createIdentifier(newNamespaceName));
            changes.insertNodeAfter(sourceFile, oldImportNode, updateNamespaceLikeImportNode(oldImportNode, preferredNewNamespaceName, newModuleSpecifier, quotePreference));
        }
    }
    function updateNamespaceLikeImportNode(node, newNamespaceName, newModuleSpecifier, quotePreference) {
        const newNamespaceId = factory.createIdentifier(newNamespaceName);
        const newModuleString = makeStringLiteral(newModuleSpecifier, quotePreference);
        switch(node.kind){
            case 271 /* ImportDeclaration */ :
                return factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/*isTypeOnly*/ false, /*name*/ void 0, factory.createNamespaceImport(newNamespaceId)), newModuleString, /*assertClause*/ void 0);
            case 270 /* ImportEqualsDeclaration */ :
                return factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, newNamespaceId, factory.createExternalModuleReference(newModuleString));
            case 259 /* VariableDeclaration */ :
                return factory.createVariableDeclaration(newNamespaceId, /*exclamationToken*/ void 0, /*type*/ void 0, createRequireCall(newModuleString));
            default:
                return Debug.assertNever(node, `Unexpected node kind ${node.kind}`);
        }
    }
    function createRequireCall(moduleSpecifier) {
        return factory.createCallExpression(factory.createIdentifier("require"), /*typeArguments*/ void 0, [
            moduleSpecifier
        ]);
    }
    function moduleSpecifierFromImport(i) {
        return i.kind === 271 /* ImportDeclaration */  ? i.moduleSpecifier : i.kind === 270 /* ImportEqualsDeclaration */  ? i.moduleReference.expression : i.initializer.arguments[0];
    }
    function forEachImportInStatement(statement, cb) {
        if (isImportDeclaration(statement)) {
            if (isStringLiteral(statement.moduleSpecifier)) cb(statement);
        } else if (isImportEqualsDeclaration(statement)) {
            if (isExternalModuleReference(statement.moduleReference) && isStringLiteralLike(statement.moduleReference.expression)) cb(statement);
        } else if (isVariableStatement(statement)) {
            for (const decl of statement.declarationList.declarations)if (decl.initializer && isRequireCall(decl.initializer, /*requireStringLiteralLikeArgument*/ true)) cb(decl);
        }
    }
    function createOldFileImportsFromTargetFile(sourceFile, targetFileNeedExport, targetFileNameWithExtension, program, host, useEs6Imports, quotePreference) {
        let defaultImport;
        const imports = [];
        targetFileNeedExport.forEach((symbol)=>{
            if (symbol.escapedName === "default" /* Default */ ) defaultImport = factory.createIdentifier(symbolNameNoDefault(symbol));
            else imports.push(symbol.name);
        });
        return makeImportOrRequire(sourceFile, defaultImport, imports, targetFileNameWithExtension, program, host, useEs6Imports, quotePreference);
    }
    function makeImportOrRequire(sourceFile, defaultImport, imports, targetFileNameWithExtension, program, host, useEs6Imports, quotePreference) {
        const pathToTargetFile = resolvePath(getDirectoryPath(sourceFile.path), targetFileNameWithExtension);
        const pathToTargetFileWithCorrectExtension = getModuleSpecifier(program.getCompilerOptions(), sourceFile, sourceFile.path, pathToTargetFile, createModuleSpecifierResolutionHost(program, host));
        if (useEs6Imports) {
            const specifiers = imports.map((i)=>factory.createImportSpecifier(/*isTypeOnly*/ false, /*propertyName*/ void 0, factory.createIdentifier(i)));
            return makeImportIfNecessary(defaultImport, specifiers, pathToTargetFileWithCorrectExtension, quotePreference);
        } else {
            Debug.assert(!defaultImport, "No default import should exist");
            const bindingElements = imports.map((i)=>factory.createBindingElement(/*dotDotDotToken*/ void 0, /*propertyName*/ void 0, i));
            return bindingElements.length ? makeVariableStatement(factory.createObjectBindingPattern(bindingElements), /*type*/ void 0, createRequireCall(makeStringLiteral(pathToTargetFileWithCorrectExtension, quotePreference))) : void 0;
        }
    }
    function makeVariableStatement(name, type, initializer, flags = 2 /* Const */ ) {
        return factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(name, /*exclamationToken*/ void 0, type, initializer)
        ], flags));
    }
    function addExports(sourceFile, toMove, needExport, useEs6Exports) {
        return flatMap(toMove, (statement)=>{
            if (isTopLevelDeclarationStatement(statement) && !isExported(sourceFile, statement, useEs6Exports) && forEachTopLevelDeclaration(statement, (d)=>{
                var _a;
                return needExport.has(Debug.checkDefined((_a = tryCast(d, canHaveSymbol)) == null ? void 0 : _a.symbol));
            })) {
                const exports = addExport(getSynthesizedDeepClone(statement), useEs6Exports);
                if (exports) return exports;
            }
            return getSynthesizedDeepClone(statement);
        });
    }
    function isExported(sourceFile, decl, useEs6Exports, name) {
        var _a;
        if (useEs6Exports) return !isExpressionStatement(decl) && hasSyntacticModifier(decl, 1 /* Export */ ) || !!(name && sourceFile.symbol && ((_a = sourceFile.symbol.exports) == null ? void 0 : _a.has(name.escapedText)));
        return !!sourceFile.symbol && !!sourceFile.symbol.exports && getNamesToExportInCommonJS(decl).some((name2)=>sourceFile.symbol.exports.has(escapeLeadingUnderscores(name2)));
    }
    function deleteUnusedImports(sourceFile, importDecl, changes, isUnused) {
        switch(importDecl.kind){
            case 271 /* ImportDeclaration */ :
                deleteUnusedImportsInDeclaration(sourceFile, importDecl, changes, isUnused);
                break;
            case 270 /* ImportEqualsDeclaration */ :
                if (isUnused(importDecl.name)) changes.delete(sourceFile, importDecl);
                break;
            case 259 /* VariableDeclaration */ :
                deleteUnusedImportsInVariableDeclaration(sourceFile, importDecl, changes, isUnused);
                break;
            default:
                Debug.assertNever(importDecl, `Unexpected import decl kind ${importDecl.kind}`);
        }
    }
    function deleteUnusedImportsInDeclaration(sourceFile, importDecl, changes, isUnused) {
        if (!importDecl.importClause) return;
        const { name: name , namedBindings: namedBindings  } = importDecl.importClause;
        const defaultUnused = !name || isUnused(name);
        const namedBindingsUnused = !namedBindings || (namedBindings.kind === 273 /* NamespaceImport */  ? isUnused(namedBindings.name) : namedBindings.elements.length !== 0 && namedBindings.elements.every((e)=>isUnused(e.name)));
        if (defaultUnused && namedBindingsUnused) changes.delete(sourceFile, importDecl);
        else {
            if (name && defaultUnused) changes.delete(sourceFile, name);
            if (namedBindings) {
                if (namedBindingsUnused) changes.replaceNode(sourceFile, importDecl.importClause, factory.updateImportClause(importDecl.importClause, importDecl.importClause.isTypeOnly, name, /*namedBindings*/ void 0));
                else if (namedBindings.kind === 274 /* NamedImports */ ) {
                    for (const element of namedBindings.elements)if (isUnused(element.name)) changes.delete(sourceFile, element);
                }
            }
        }
    }
    function deleteUnusedImportsInVariableDeclaration(sourceFile, varDecl, changes, isUnused) {
        const { name: name  } = varDecl;
        switch(name.kind){
            case 80 /* Identifier */ :
                if (isUnused(name)) {
                    if (varDecl.initializer && isRequireCall(varDecl.initializer, /*requireStringLiteralLikeArgument*/ true)) changes.delete(sourceFile, isVariableDeclarationList(varDecl.parent) && length(varDecl.parent.declarations) === 1 ? varDecl.parent.parent : varDecl);
                    else changes.delete(sourceFile, name);
                }
                break;
            case 206 /* ArrayBindingPattern */ :
                break;
            case 205 /* ObjectBindingPattern */ :
                if (name.elements.every((e)=>isIdentifier(e.name) && isUnused(e.name))) changes.delete(sourceFile, isVariableDeclarationList(varDecl.parent) && varDecl.parent.declarations.length === 1 ? varDecl.parent.parent : varDecl);
                else {
                    for (const element of name.elements)if (isIdentifier(element.name) && isUnused(element.name)) changes.delete(sourceFile, element.name);
                }
                break;
        }
    }
    function isTopLevelDeclarationStatement(node) {
        Debug.assert(isSourceFile(node.parent), "Node parent should be a SourceFile");
        return isNonVariableTopLevelDeclaration(node) || isVariableStatement(node);
    }
    function addExport(decl, useEs6Exports) {
        return useEs6Exports ? [
            addEs6Export(decl)
        ] : addCommonjsExport(decl);
    }
    function addEs6Export(d) {
        const modifiers = canHaveModifiers(d) ? concatenate([
            factory.createModifier(95 /* ExportKeyword */ )
        ], getModifiers(d)) : void 0;
        switch(d.kind){
            case 261 /* FunctionDeclaration */ :
                return factory.updateFunctionDeclaration(d, modifiers, d.asteriskToken, d.name, d.typeParameters, d.parameters, d.type, d.body);
            case 262 /* ClassDeclaration */ :
                const decorators = canHaveDecorators(d) ? getDecorators(d) : void 0;
                return factory.updateClassDeclaration(d, concatenate(decorators, modifiers), d.name, d.typeParameters, d.heritageClauses, d.members);
            case 242 /* VariableStatement */ :
                return factory.updateVariableStatement(d, modifiers, d.declarationList);
            case 266 /* ModuleDeclaration */ :
                return factory.updateModuleDeclaration(d, modifiers, d.name, d.body);
            case 265 /* EnumDeclaration */ :
                return factory.updateEnumDeclaration(d, modifiers, d.name, d.members);
            case 264 /* TypeAliasDeclaration */ :
                return factory.updateTypeAliasDeclaration(d, modifiers, d.name, d.typeParameters, d.type);
            case 263 /* InterfaceDeclaration */ :
                return factory.updateInterfaceDeclaration(d, modifiers, d.name, d.typeParameters, d.heritageClauses, d.members);
            case 270 /* ImportEqualsDeclaration */ :
                return factory.updateImportEqualsDeclaration(d, modifiers, d.isTypeOnly, d.name, d.moduleReference);
            case 243 /* ExpressionStatement */ :
                return Debug.fail();
            default:
                return Debug.assertNever(d, `Unexpected declaration kind ${d.kind}`);
        }
    }
    function addCommonjsExport(decl) {
        return [
            decl,
            ...getNamesToExportInCommonJS(decl).map(createExportAssignment)
        ];
    }
    function createExportAssignment(name) {
        return factory.createExpressionStatement(factory.createBinaryExpression(factory.createPropertyAccessExpression(factory.createIdentifier("exports"), factory.createIdentifier(name)), 64 /* EqualsToken */ , factory.createIdentifier(name)));
    }
    function getNamesToExportInCommonJS(decl) {
        switch(decl.kind){
            case 261 /* FunctionDeclaration */ :
            case 262 /* ClassDeclaration */ :
                return [
                    decl.name.text
                ];
            case 242 /* VariableStatement */ :
                return mapDefined(decl.declarationList.declarations, (d)=>isIdentifier(d.name) ? d.name.text : void 0);
            case 266 /* ModuleDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
            case 263 /* InterfaceDeclaration */ :
            case 270 /* ImportEqualsDeclaration */ :
                return emptyArray;
            case 243 /* ExpressionStatement */ :
                return Debug.fail("Can't export an ExpressionStatement");
            default:
                return Debug.assertNever(decl, `Unexpected decl kind ${decl.kind}`);
        }
    }
    function filterImport(i, moduleSpecifier, keep) {
        switch(i.kind){
            case 271 /* ImportDeclaration */ :
                {
                    const clause = i.importClause;
                    if (!clause) return void 0;
                    const defaultImport = clause.name && keep(clause.name) ? clause.name : void 0;
                    const namedBindings = clause.namedBindings && filterNamedBindings(clause.namedBindings, keep);
                    return defaultImport || namedBindings ? factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(clause.isTypeOnly, defaultImport, namedBindings), getSynthesizedDeepClone(moduleSpecifier), /*assertClause*/ void 0) : void 0;
                }
            case 270 /* ImportEqualsDeclaration */ :
                return keep(i.name) ? i : void 0;
            case 259 /* VariableDeclaration */ :
                {
                    const name = filterBindingName(i.name, keep);
                    return name ? makeVariableStatement(name, i.type, createRequireCall(moduleSpecifier), i.parent.flags) : void 0;
                }
            default:
                return Debug.assertNever(i, `Unexpected import kind ${i.kind}`);
        }
    }
    function filterNamedBindings(namedBindings, keep) {
        if (namedBindings.kind === 273 /* NamespaceImport */ ) return keep(namedBindings.name) ? namedBindings : void 0;
        else {
            const newElements = namedBindings.elements.filter((e)=>keep(e.name));
            return newElements.length ? factory.createNamedImports(newElements) : void 0;
        }
    }
    function filterBindingName(name, keep) {
        switch(name.kind){
            case 80 /* Identifier */ :
                return keep(name) ? name : void 0;
            case 206 /* ArrayBindingPattern */ :
                return name;
            case 205 /* ObjectBindingPattern */ :
                {
                    const newElements = name.elements.filter((prop)=>prop.propertyName || !isIdentifier(prop.name) || keep(prop.name));
                    return newElements.length ? factory.createObjectBindingPattern(newElements) : void 0;
                }
        }
    }
    function nameOfTopLevelDeclaration(d) {
        return isExpressionStatement(d) ? tryCast(d.expression.left.name, isIdentifier) : tryCast(d.name, isIdentifier);
    }
    function getTopLevelDeclarationStatement(d) {
        switch(d.kind){
            case 259 /* VariableDeclaration */ :
                return d.parent.parent;
            case 207 /* BindingElement */ :
                return getTopLevelDeclarationStatement(cast(d.parent.parent, (p)=>isVariableDeclaration(p) || isBindingElement(p)));
            default:
                return d;
        }
    }
    function addExportToChanges(sourceFile, decl, name, changes, useEs6Exports) {
        if (isExported(sourceFile, decl, useEs6Exports, name)) return;
        if (useEs6Exports) {
            if (!isExpressionStatement(decl)) changes.insertExportModifier(sourceFile, decl);
        } else {
            const names = getNamesToExportInCommonJS(decl);
            if (names.length !== 0) changes.insertNodesAfter(sourceFile, decl, names.map(createExportAssignment));
        }
    }
    function createNewFileName(oldFile, program, context, host) {
        const checker = program.getTypeChecker();
        const toMove = getStatementsToMove(context);
        let usage;
        if (toMove) {
            usage = getUsageInfo(oldFile, toMove.all, checker);
            const currentDirectory = getDirectoryPath(oldFile.fileName);
            const extension = extensionFromPath(oldFile.fileName);
            const newFileName = combinePaths(// new file is always placed in the same directory as the old file
            currentDirectory, // ensures the filename computed below isn't already taken
            makeUniqueFilename(// infers a name for the new file from the symbols being moved
            inferNewFileName(usage.oldFileImportsFromTargetFile, usage.movedSymbols), extension, currentDirectory, host)) + extension;
            return newFileName;
        }
        return "";
    }
    function getRangeToMove(context) {
        const { file: file  } = context;
        const range = createTextRangeFromSpan(getRefactorContextSpan(context));
        const { statements: statements  } = file;
        const startNodeIndex = findIndex(statements, (s)=>s.end > range.pos);
        if (startNodeIndex === -1) return void 0;
        const startStatement = statements[startNodeIndex];
        if (isNamedDeclaration(startStatement) && startStatement.name && rangeContainsRange(startStatement.name, range)) return {
            toMove: [
                statements[startNodeIndex]
            ],
            afterLast: statements[startNodeIndex + 1]
        };
        if (range.pos > startStatement.getStart(file)) return void 0;
        const afterEndNodeIndex = findIndex(statements, (s)=>s.end > range.end, startNodeIndex);
        if (afterEndNodeIndex !== -1 && (afterEndNodeIndex === 0 || statements[afterEndNodeIndex].getStart(file) < range.end)) return void 0;
        return {
            toMove: statements.slice(startNodeIndex, afterEndNodeIndex === -1 ? statements.length : afterEndNodeIndex),
            afterLast: afterEndNodeIndex === -1 ? void 0 : statements[afterEndNodeIndex]
        };
    }
    function getStatementsToMove(context) {
        const rangeToMove = getRangeToMove(context);
        if (rangeToMove === void 0) return void 0;
        const all = [];
        const ranges = [];
        const { toMove: toMove , afterLast: afterLast  } = rangeToMove;
        getRangesWhere(toMove, isAllowedStatementToMove, (start, afterEndIndex)=>{
            for(let i = start; i < afterEndIndex; i++)all.push(toMove[i]);
            ranges.push({
                first: toMove[start],
                afterLast: afterLast
            });
        });
        return all.length === 0 ? void 0 : {
            all: all,
            ranges: ranges
        };
    }
    function isAllowedStatementToMove(statement) {
        return !isPureImport(statement) && !isPrologueDirective(statement);
    }
    function isPureImport(node) {
        switch(node.kind){
            case 271 /* ImportDeclaration */ :
                return true;
            case 270 /* ImportEqualsDeclaration */ :
                return !hasSyntacticModifier(node, 1 /* Export */ );
            case 242 /* VariableStatement */ :
                return node.declarationList.declarations.every((d)=>!!d.initializer && isRequireCall(d.initializer, /*requireStringLiteralLikeArgument*/ true));
            default:
                return false;
        }
    }
    function getUsageInfo(oldFile, toMove, checker) {
        const movedSymbols = /* @__PURE__ */ new Set();
        const oldImportsNeededByTargetFile = /* @__PURE__ */ new Map();
        const targetFileImportsFromOldFile = /* @__PURE__ */ new Set();
        const containsJsx = find(toMove, (statement)=>!!(statement.transformFlags & 2 /* ContainsJsx */ ));
        const jsxNamespaceSymbol = getJsxNamespaceSymbol(containsJsx);
        if (jsxNamespaceSymbol) oldImportsNeededByTargetFile.set(jsxNamespaceSymbol, false);
        for (const statement of toMove)forEachTopLevelDeclaration(statement, (decl)=>{
            movedSymbols.add(Debug.checkDefined(isExpressionStatement(decl) ? checker.getSymbolAtLocation(decl.expression.left) : decl.symbol, "Need a symbol here"));
        });
        for (const statement of toMove)forEachReference(statement, checker, (symbol, isValidTypeOnlyUseSite)=>{
            if (!symbol.declarations) return;
            for (const decl of symbol.declarations){
                if (isInImport(decl)) {
                    const prevIsTypeOnly = oldImportsNeededByTargetFile.get(symbol);
                    oldImportsNeededByTargetFile.set(symbol, prevIsTypeOnly === void 0 ? isValidTypeOnlyUseSite : prevIsTypeOnly && isValidTypeOnlyUseSite);
                } else if (isTopLevelDeclaration(decl) && sourceFileOfTopLevelDeclaration(decl) === oldFile && !movedSymbols.has(symbol)) targetFileImportsFromOldFile.add(symbol);
            }
        });
        const unusedImportsFromOldFile = new Set(oldImportsNeededByTargetFile.keys());
        const oldFileImportsFromTargetFile = /* @__PURE__ */ new Set();
        for (const statement of oldFile.statements){
            if (contains(toMove, statement)) continue;
            if (jsxNamespaceSymbol && !!(statement.transformFlags & 2 /* ContainsJsx */ )) unusedImportsFromOldFile.delete(jsxNamespaceSymbol);
            forEachReference(statement, checker, (symbol)=>{
                if (movedSymbols.has(symbol)) oldFileImportsFromTargetFile.add(symbol);
                unusedImportsFromOldFile.delete(symbol);
            });
        }
        return {
            movedSymbols: movedSymbols,
            targetFileImportsFromOldFile: targetFileImportsFromOldFile,
            oldFileImportsFromTargetFile: oldFileImportsFromTargetFile,
            oldImportsNeededByTargetFile: oldImportsNeededByTargetFile,
            unusedImportsFromOldFile: unusedImportsFromOldFile
        };
        function getJsxNamespaceSymbol(containsJsx2) {
            if (containsJsx2 === void 0) return void 0;
            const jsxNamespace = checker.getJsxNamespace(containsJsx2);
            const jsxNamespaceSymbol2 = checker.resolveName(jsxNamespace, containsJsx2, 1920 /* Namespace */ , /*excludeGlobals*/ true);
            return !!jsxNamespaceSymbol2 && some(jsxNamespaceSymbol2.declarations, isInImport) ? jsxNamespaceSymbol2 : void 0;
        }
    }
    function makeUniqueFilename(proposedFilename, extension, inDirectory, host) {
        let newFilename = proposedFilename;
        for(let i = 1;; i++){
            const name = combinePaths(inDirectory, newFilename + extension);
            if (!host.fileExists(name)) return newFilename;
            newFilename = `${proposedFilename}.${i}`;
        }
    }
    function inferNewFileName(importsFromNewFile, movedSymbols) {
        return forEachKey(importsFromNewFile, symbolNameNoDefault) || forEachKey(movedSymbols, symbolNameNoDefault) || "newFile";
    }
    function forEachReference(node, checker, onReference) {
        node.forEachChild(function cb(node2) {
            if (isIdentifier(node2) && !isDeclarationName(node2)) {
                const sym = checker.getSymbolAtLocation(node2);
                if (sym) onReference(sym, isValidTypeOnlyAliasUseSite(node2));
            } else node2.forEachChild(cb);
        });
    }
    function forEachTopLevelDeclaration(statement, cb) {
        switch(statement.kind){
            case 261 /* FunctionDeclaration */ :
            case 262 /* ClassDeclaration */ :
            case 266 /* ModuleDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
            case 263 /* InterfaceDeclaration */ :
            case 270 /* ImportEqualsDeclaration */ :
                return cb(statement);
            case 242 /* VariableStatement */ :
                return firstDefined(statement.declarationList.declarations, (decl)=>forEachTopLevelDeclarationInBindingName(decl.name, cb));
            case 243 /* ExpressionStatement */ :
                {
                    const { expression: expression  } = statement;
                    return isBinaryExpression(expression) && getAssignmentDeclarationKind(expression) === 1 /* ExportsProperty */  ? cb(statement) : void 0;
                }
        }
    }
    function isInImport(decl) {
        switch(decl.kind){
            case 270 /* ImportEqualsDeclaration */ :
            case 275 /* ImportSpecifier */ :
            case 272 /* ImportClause */ :
            case 273 /* NamespaceImport */ :
                return true;
            case 259 /* VariableDeclaration */ :
                return isVariableDeclarationInImport(decl);
            case 207 /* BindingElement */ :
                return isVariableDeclaration(decl.parent.parent) && isVariableDeclarationInImport(decl.parent.parent);
            default:
                return false;
        }
    }
    function isVariableDeclarationInImport(decl) {
        return isSourceFile(decl.parent.parent.parent) && !!decl.initializer && isRequireCall(decl.initializer, /*requireStringLiteralLikeArgument*/ true);
    }
    function isTopLevelDeclaration(node) {
        return isNonVariableTopLevelDeclaration(node) && isSourceFile(node.parent) || isVariableDeclaration(node) && isSourceFile(node.parent.parent.parent);
    }
    function sourceFileOfTopLevelDeclaration(node) {
        return isVariableDeclaration(node) ? node.parent.parent.parent : node.parent;
    }
    function forEachTopLevelDeclarationInBindingName(name, cb) {
        switch(name.kind){
            case 80 /* Identifier */ :
                return cb(cast(name.parent, (x)=>isVariableDeclaration(x) || isBindingElement(x)));
            case 206 /* ArrayBindingPattern */ :
            case 205 /* ObjectBindingPattern */ :
                return firstDefined(name.elements, (em)=>isOmittedExpression(em) ? void 0 : forEachTopLevelDeclarationInBindingName(em.name, cb));
            default:
                return Debug.assertNever(name, `Unexpected name kind ${name.kind}`);
        }
    }
    function isNonVariableTopLevelDeclaration(node) {
        switch(node.kind){
            case 261 /* FunctionDeclaration */ :
            case 262 /* ClassDeclaration */ :
            case 266 /* ModuleDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
            case 263 /* InterfaceDeclaration */ :
            case 270 /* ImportEqualsDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    var refactorNameForMoveToFile, description2, moveToFileAction;
    var init_moveToFile = __esm({
        "src/services/refactors/moveToFile.ts" () {
            "use strict";
            init_moduleSpecifiers();
            init_ts4();
            init_refactorProvider();
            refactorNameForMoveToFile = "Move to file";
            description2 = getLocaleSpecificMessage(Diagnostics.Move_to_file);
            moveToFileAction = {
                name: "Move to file",
                description: description2,
                kind: "refactor.move.file"
            };
            registerRefactor(refactorNameForMoveToFile, {
                kinds: [
                    moveToFileAction.kind
                ],
                getAvailableActions: function getRefactorActionsToMoveToFile(context, interactiveRefactorArguments) {
                    const statements = getStatementsToMove(context);
                    if (!interactiveRefactorArguments) return emptyArray;
                    if (context.preferences.allowTextChangesInNewFiles && statements) return [
                        {
                            name: refactorNameForMoveToFile,
                            description: description2,
                            actions: [
                                moveToFileAction
                            ]
                        }
                    ];
                    if (context.preferences.provideRefactorNotApplicableReason) return [
                        {
                            name: refactorNameForMoveToFile,
                            description: description2,
                            actions: [
                                {
                                    ...moveToFileAction,
                                    notApplicableReason: getLocaleSpecificMessage(Diagnostics.Selection_is_not_a_valid_statement_or_statements)
                                }
                            ]
                        }
                    ];
                    return emptyArray;
                },
                getEditsForAction: function getRefactorEditsToMoveToFile(context, actionName2, interactiveRefactorArguments) {
                    Debug.assert(actionName2 === refactorNameForMoveToFile, "Wrong refactor invoked");
                    const statements = Debug.checkDefined(getStatementsToMove(context));
                    Debug.assert(interactiveRefactorArguments, "No interactive refactor arguments available");
                    const targetFile = interactiveRefactorArguments.targetFile;
                    if (hasJSFileExtension(targetFile) || hasTSFileExtension(targetFile)) {
                        const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange4(context, context.file, interactiveRefactorArguments.targetFile, context.program, statements, t, context.host, context.preferences));
                        return {
                            edits: edits,
                            renameFilename: void 0,
                            renameLocation: void 0
                        };
                    }
                    return {
                        edits: [],
                        renameFilename: void 0,
                        renameLocation: void 0,
                        notApplicableReason: getLocaleSpecificMessage(Diagnostics.Cannot_move_to_file_selected_file_is_invalid)
                    };
                }
            });
        }
    });
    // src/services/refactors/convertOverloadListToSingleSignature.ts
    function getRefactorActionsToConvertOverloadsToOneSignature(context) {
        const { file: file , startPosition: startPosition , program: program  } = context;
        const info = getConvertableOverloadListAtPosition(file, startPosition, program);
        if (!info) return emptyArray;
        return [
            {
                name: refactorName5,
                description: refactorDescription,
                actions: [
                    functionOverloadAction
                ]
            }
        ];
    }
    function getRefactorEditsToConvertOverloadsToOneSignature(context) {
        const { file: file , startPosition: startPosition , program: program  } = context;
        const signatureDecls = getConvertableOverloadListAtPosition(file, startPosition, program);
        if (!signatureDecls) return void 0;
        const checker = program.getTypeChecker();
        const lastDeclaration = signatureDecls[signatureDecls.length - 1];
        let updated = lastDeclaration;
        switch(lastDeclaration.kind){
            case 172 /* MethodSignature */ :
                updated = factory.updateMethodSignature(lastDeclaration, lastDeclaration.modifiers, lastDeclaration.name, lastDeclaration.questionToken, lastDeclaration.typeParameters, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.type);
                break;
            case 173 /* MethodDeclaration */ :
                updated = factory.updateMethodDeclaration(lastDeclaration, lastDeclaration.modifiers, lastDeclaration.asteriskToken, lastDeclaration.name, lastDeclaration.questionToken, lastDeclaration.typeParameters, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.type, lastDeclaration.body);
                break;
            case 178 /* CallSignature */ :
                updated = factory.updateCallSignature(lastDeclaration, lastDeclaration.typeParameters, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.type);
                break;
            case 175 /* Constructor */ :
                updated = factory.updateConstructorDeclaration(lastDeclaration, lastDeclaration.modifiers, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.body);
                break;
            case 179 /* ConstructSignature */ :
                updated = factory.updateConstructSignature(lastDeclaration, lastDeclaration.typeParameters, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.type);
                break;
            case 261 /* FunctionDeclaration */ :
                updated = factory.updateFunctionDeclaration(lastDeclaration, lastDeclaration.modifiers, lastDeclaration.asteriskToken, lastDeclaration.name, lastDeclaration.typeParameters, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.type, lastDeclaration.body);
                break;
            default:
                return Debug.failBadSyntaxKind(lastDeclaration, "Unhandled signature kind in overload list conversion refactoring");
        }
        if (updated === lastDeclaration) return;
        const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
            t.replaceNodeRange(file, signatureDecls[0], signatureDecls[signatureDecls.length - 1], updated);
        });
        return {
            renameFilename: void 0,
            renameLocation: void 0,
            edits: edits
        };
        function getNewParametersForCombinedSignature(signatureDeclarations) {
            const lastSig = signatureDeclarations[signatureDeclarations.length - 1];
            if (isFunctionLikeDeclaration(lastSig) && lastSig.body) signatureDeclarations = signatureDeclarations.slice(0, signatureDeclarations.length - 1);
            return factory.createNodeArray([
                factory.createParameterDeclaration(/*modifiers*/ void 0, factory.createToken(26 /* DotDotDotToken */ ), "args", /*questionToken*/ void 0, factory.createUnionTypeNode(map(signatureDeclarations, convertSignatureParametersToTuple)))
            ]);
        }
        function convertSignatureParametersToTuple(decl) {
            const members = map(decl.parameters, convertParameterToNamedTupleMember);
            return setEmitFlags(factory.createTupleTypeNode(members), some(members, (m)=>!!length(getSyntheticLeadingComments(m))) ? 0 /* None */  : 1 /* SingleLine */ );
        }
        function convertParameterToNamedTupleMember(p) {
            Debug.assert(isIdentifier(p.name));
            const result = setTextRange(factory.createNamedTupleMember(p.dotDotDotToken, p.name, p.questionToken, p.type || factory.createKeywordTypeNode(133 /* AnyKeyword */ )), p);
            const parameterDocComment = p.symbol && p.symbol.getDocumentationComment(checker);
            if (parameterDocComment) {
                const newComment = displayPartsToString(parameterDocComment);
                if (newComment.length) setSyntheticLeadingComments(result, [
                    {
                        text: `*
${newComment.split("\n").map((c)=>` * ${c}`).join("\n")}
 `,
                        kind: 3 /* MultiLineCommentTrivia */ ,
                        pos: -1,
                        end: -1,
                        hasTrailingNewLine: true,
                        hasLeadingNewline: true
                    }
                ]);
            }
            return result;
        }
    }
    function isConvertableSignatureDeclaration(d) {
        switch(d.kind){
            case 172 /* MethodSignature */ :
            case 173 /* MethodDeclaration */ :
            case 178 /* CallSignature */ :
            case 175 /* Constructor */ :
            case 179 /* ConstructSignature */ :
            case 261 /* FunctionDeclaration */ :
                return true;
        }
        return false;
    }
    function getConvertableOverloadListAtPosition(file, startPosition, program) {
        const node = getTokenAtPosition(file, startPosition);
        const containingDecl = findAncestor(node, isConvertableSignatureDeclaration);
        if (!containingDecl) return;
        if (isFunctionLikeDeclaration(containingDecl) && containingDecl.body && rangeContainsPosition(containingDecl.body, startPosition)) return;
        const checker = program.getTypeChecker();
        const signatureSymbol = containingDecl.symbol;
        if (!signatureSymbol) return;
        const decls = signatureSymbol.declarations;
        if (length(decls) <= 1) return;
        if (!every(decls, (d)=>getSourceFileOfNode(d) === file)) return;
        if (!isConvertableSignatureDeclaration(decls[0])) return;
        const kindOne = decls[0].kind;
        if (!every(decls, (d)=>d.kind === kindOne)) return;
        const signatureDecls = decls;
        if (some(signatureDecls, (d)=>!!d.typeParameters || some(d.parameters, (p)=>!!p.modifiers || !isIdentifier(p.name)))) return;
        const signatures = mapDefined(signatureDecls, (d)=>checker.getSignatureFromDeclaration(d));
        if (length(signatures) !== length(decls)) return;
        const returnOne = checker.getReturnTypeOfSignature(signatures[0]);
        if (!every(signatures, (s)=>checker.getReturnTypeOfSignature(s) === returnOne)) return;
        return signatureDecls;
    }
    var refactorName5, refactorDescription, functionOverloadAction;
    var init_convertOverloadListToSingleSignature = __esm({
        "src/services/refactors/convertOverloadListToSingleSignature.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName5 = "Convert overload list to single signature";
            refactorDescription = Diagnostics.Convert_overload_list_to_single_signature.message;
            functionOverloadAction = {
                name: refactorName5,
                description: refactorDescription,
                kind: "refactor.rewrite.function.overloadList"
            };
            registerRefactor(refactorName5, {
                kinds: [
                    functionOverloadAction.kind
                ],
                getEditsForAction: getRefactorEditsToConvertOverloadsToOneSignature,
                getAvailableActions: getRefactorActionsToConvertOverloadsToOneSignature
            });
        }
    });
    // src/services/refactors/addOrRemoveBracesToArrowFunction.ts
    function getRefactorActionsToRemoveFunctionBraces(context) {
        const { file: file , startPosition: startPosition , triggerReason: triggerReason  } = context;
        const info = getConvertibleArrowFunctionAtPosition(file, startPosition, triggerReason === "invoked");
        if (!info) return emptyArray;
        if (!isRefactorErrorInfo(info)) return [
            {
                name: refactorName6,
                description: refactorDescription2,
                actions: [
                    info.addBraces ? addBracesAction : removeBracesAction
                ]
            }
        ];
        if (context.preferences.provideRefactorNotApplicableReason) return [
            {
                name: refactorName6,
                description: refactorDescription2,
                actions: [
                    {
                        ...addBracesAction,
                        notApplicableReason: info.error
                    },
                    {
                        ...removeBracesAction,
                        notApplicableReason: info.error
                    }
                ]
            }
        ];
        return emptyArray;
    }
    function getRefactorEditsToRemoveFunctionBraces(context, actionName2) {
        const { file: file , startPosition: startPosition  } = context;
        const info = getConvertibleArrowFunctionAtPosition(file, startPosition);
        Debug.assert(info && !isRefactorErrorInfo(info), "Expected applicable refactor info");
        const { expression: expression , returnStatement: returnStatement , func: func  } = info;
        let body;
        if (actionName2 === addBracesAction.name) {
            const returnStatement2 = factory.createReturnStatement(expression);
            body = factory.createBlock([
                returnStatement2
            ], /*multiLine*/ true);
            copyLeadingComments(expression, returnStatement2, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ true);
        } else if (actionName2 === removeBracesAction.name && returnStatement) {
            const actualExpression = expression || factory.createVoidZero();
            body = needsParentheses(actualExpression) ? factory.createParenthesizedExpression(actualExpression) : actualExpression;
            copyTrailingAsLeadingComments(returnStatement, body, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
            copyLeadingComments(returnStatement, body, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
            copyTrailingComments(returnStatement, body, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
        } else Debug.fail("invalid action");
        const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
            t.replaceNode(file, func.body, body);
        });
        return {
            renameFilename: void 0,
            renameLocation: void 0,
            edits: edits
        };
    }
    function getConvertibleArrowFunctionAtPosition(file, startPosition, considerFunctionBodies = true, kind) {
        const node = getTokenAtPosition(file, startPosition);
        const func = getContainingFunction(node);
        if (!func) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_a_containing_arrow_function)
        };
        if (!isArrowFunction(func)) return {
            error: getLocaleSpecificMessage(Diagnostics.Containing_function_is_not_an_arrow_function)
        };
        if (!rangeContainsRange(func, node) || rangeContainsRange(func.body, node) && !considerFunctionBodies) return void 0;
        if (refactorKindBeginsWith(addBracesAction.kind, kind) && isExpression(func.body)) return {
            func: func,
            addBraces: true,
            expression: func.body
        };
        else if (refactorKindBeginsWith(removeBracesAction.kind, kind) && isBlock(func.body) && func.body.statements.length === 1) {
            const firstStatement = first(func.body.statements);
            if (isReturnStatement(firstStatement)) return {
                func: func,
                addBraces: false,
                expression: firstStatement.expression,
                returnStatement: firstStatement
            };
        }
        return void 0;
    }
    var refactorName6, refactorDescription2, addBracesAction, removeBracesAction;
    var init_addOrRemoveBracesToArrowFunction = __esm({
        "src/services/refactors/addOrRemoveBracesToArrowFunction.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName6 = "Add or remove braces in an arrow function";
            refactorDescription2 = Diagnostics.Add_or_remove_braces_in_an_arrow_function.message;
            addBracesAction = {
                name: "Add braces to arrow function",
                description: Diagnostics.Add_braces_to_arrow_function.message,
                kind: "refactor.rewrite.arrow.braces.add"
            };
            removeBracesAction = {
                name: "Remove braces from arrow function",
                description: Diagnostics.Remove_braces_from_arrow_function.message,
                kind: "refactor.rewrite.arrow.braces.remove"
            };
            registerRefactor(refactorName6, {
                kinds: [
                    removeBracesAction.kind
                ],
                getEditsForAction: getRefactorEditsToRemoveFunctionBraces,
                getAvailableActions: getRefactorActionsToRemoveFunctionBraces
            });
        }
    });
    // src/services/_namespaces/ts.refactor.addOrRemoveBracesToArrowFunction.ts
    var ts_refactor_addOrRemoveBracesToArrowFunction_exports = {};
    var init_ts_refactor_addOrRemoveBracesToArrowFunction = __esm({
        "src/services/_namespaces/ts.refactor.addOrRemoveBracesToArrowFunction.ts" () {
            "use strict";
            init_convertOverloadListToSingleSignature();
            init_addOrRemoveBracesToArrowFunction();
        }
    });
    // src/services/refactors/convertArrowFunctionOrFunctionExpression.ts
    function getRefactorActionsToConvertFunctionExpressions(context) {
        const { file: file , startPosition: startPosition , program: program , kind: kind  } = context;
        const info = getFunctionInfo(file, startPosition, program);
        if (!info) return emptyArray;
        const { selectedVariableDeclaration: selectedVariableDeclaration , func: func  } = info;
        const possibleActions = [];
        const errors = [];
        if (refactorKindBeginsWith(toNamedFunctionAction.kind, kind)) {
            const error = selectedVariableDeclaration || isArrowFunction(func) && isVariableDeclaration(func.parent) ? void 0 : getLocaleSpecificMessage(Diagnostics.Could_not_convert_to_named_function);
            if (error) errors.push({
                ...toNamedFunctionAction,
                notApplicableReason: error
            });
            else possibleActions.push(toNamedFunctionAction);
        }
        if (refactorKindBeginsWith(toAnonymousFunctionAction.kind, kind)) {
            const error = !selectedVariableDeclaration && isArrowFunction(func) ? void 0 : getLocaleSpecificMessage(Diagnostics.Could_not_convert_to_anonymous_function);
            if (error) errors.push({
                ...toAnonymousFunctionAction,
                notApplicableReason: error
            });
            else possibleActions.push(toAnonymousFunctionAction);
        }
        if (refactorKindBeginsWith(toArrowFunctionAction.kind, kind)) {
            const error = isFunctionExpression(func) ? void 0 : getLocaleSpecificMessage(Diagnostics.Could_not_convert_to_arrow_function);
            if (error) errors.push({
                ...toArrowFunctionAction,
                notApplicableReason: error
            });
            else possibleActions.push(toArrowFunctionAction);
        }
        return [
            {
                name: refactorName7,
                description: refactorDescription3,
                actions: possibleActions.length === 0 && context.preferences.provideRefactorNotApplicableReason ? errors : possibleActions
            }
        ];
    }
    function getRefactorEditsToConvertFunctionExpressions(context, actionName2) {
        const { file: file , startPosition: startPosition , program: program  } = context;
        const info = getFunctionInfo(file, startPosition, program);
        if (!info) return void 0;
        const { func: func  } = info;
        const edits = [];
        switch(actionName2){
            case toAnonymousFunctionAction.name:
                edits.push(...getEditInfoForConvertToAnonymousFunction(context, func));
                break;
            case toNamedFunctionAction.name:
                const variableInfo = getVariableInfo(func);
                if (!variableInfo) return void 0;
                edits.push(...getEditInfoForConvertToNamedFunction(context, func, variableInfo));
                break;
            case toArrowFunctionAction.name:
                if (!isFunctionExpression(func)) return void 0;
                edits.push(...getEditInfoForConvertToArrowFunction(context, func));
                break;
            default:
                return Debug.fail("invalid action");
        }
        return {
            renameFilename: void 0,
            renameLocation: void 0,
            edits: edits
        };
    }
    function containingThis(node) {
        let containsThis = false;
        node.forEachChild(function checkThis(child) {
            if (isThis(child)) {
                containsThis = true;
                return;
            }
            if (!isClassLike(child) && !isFunctionDeclaration(child) && !isFunctionExpression(child)) forEachChild(child, checkThis);
        });
        return containsThis;
    }
    function getFunctionInfo(file, startPosition, program) {
        const token = getTokenAtPosition(file, startPosition);
        const typeChecker = program.getTypeChecker();
        const func = tryGetFunctionFromVariableDeclaration(file, typeChecker, token.parent);
        if (func && !containingThis(func.body) && !typeChecker.containsArgumentsReference(func)) return {
            selectedVariableDeclaration: true,
            func: func
        };
        const maybeFunc = getContainingFunction(token);
        if (maybeFunc && (isFunctionExpression(maybeFunc) || isArrowFunction(maybeFunc)) && !rangeContainsRange(maybeFunc.body, token) && !containingThis(maybeFunc.body) && !typeChecker.containsArgumentsReference(maybeFunc)) {
            if (isFunctionExpression(maybeFunc) && isFunctionReferencedInFile(file, typeChecker, maybeFunc)) return void 0;
            return {
                selectedVariableDeclaration: false,
                func: maybeFunc
            };
        }
        return void 0;
    }
    function isSingleVariableDeclaration(parent2) {
        return isVariableDeclaration(parent2) || isVariableDeclarationList(parent2) && parent2.declarations.length === 1;
    }
    function tryGetFunctionFromVariableDeclaration(sourceFile, typeChecker, parent2) {
        if (!isSingleVariableDeclaration(parent2)) return void 0;
        const variableDeclaration = isVariableDeclaration(parent2) ? parent2 : first(parent2.declarations);
        const initializer = variableDeclaration.initializer;
        if (initializer && (isArrowFunction(initializer) || isFunctionExpression(initializer) && !isFunctionReferencedInFile(sourceFile, typeChecker, initializer))) return initializer;
        return void 0;
    }
    function convertToBlock(body) {
        if (isExpression(body)) {
            const returnStatement = factory.createReturnStatement(body);
            const file = body.getSourceFile();
            setTextRange(returnStatement, body);
            suppressLeadingAndTrailingTrivia(returnStatement);
            copyTrailingAsLeadingComments(body, returnStatement, file, /*commentKind*/ void 0, /*hasTrailingNewLine*/ true);
            return factory.createBlock([
                returnStatement
            ], /*multiLine*/ true);
        } else return body;
    }
    function getVariableInfo(func) {
        const variableDeclaration = func.parent;
        if (!isVariableDeclaration(variableDeclaration) || !isVariableDeclarationInVariableStatement(variableDeclaration)) return void 0;
        const variableDeclarationList = variableDeclaration.parent;
        const statement = variableDeclarationList.parent;
        if (!isVariableDeclarationList(variableDeclarationList) || !isVariableStatement(statement) || !isIdentifier(variableDeclaration.name)) return void 0;
        return {
            variableDeclaration: variableDeclaration,
            variableDeclarationList: variableDeclarationList,
            statement: statement,
            name: variableDeclaration.name
        };
    }
    function getEditInfoForConvertToAnonymousFunction(context, func) {
        const { file: file  } = context;
        const body = convertToBlock(func.body);
        const newNode = factory.createFunctionExpression(func.modifiers, func.asteriskToken, /*name*/ void 0, func.typeParameters, func.parameters, func.type, body);
        return ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(file, func, newNode));
    }
    function getEditInfoForConvertToNamedFunction(context, func, variableInfo) {
        const { file: file  } = context;
        const body = convertToBlock(func.body);
        const { variableDeclaration: variableDeclaration , variableDeclarationList: variableDeclarationList , statement: statement , name: name  } = variableInfo;
        suppressLeadingTrivia(statement);
        const modifiersFlags = getCombinedModifierFlags(variableDeclaration) & 1 /* Export */  | getEffectiveModifierFlags(func);
        const modifiers = factory.createModifiersFromModifierFlags(modifiersFlags);
        const newNode = factory.createFunctionDeclaration(length(modifiers) ? modifiers : void 0, func.asteriskToken, name, func.typeParameters, func.parameters, func.type, body);
        if (variableDeclarationList.declarations.length === 1) return ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(file, statement, newNode));
        else return ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
            t.delete(file, variableDeclaration);
            t.insertNodeAfter(file, statement, newNode);
        });
    }
    function getEditInfoForConvertToArrowFunction(context, func) {
        const { file: file  } = context;
        const statements = func.body.statements;
        const head = statements[0];
        let body;
        if (canBeConvertedToExpression(func.body, head)) {
            body = head.expression;
            suppressLeadingAndTrailingTrivia(body);
            copyComments(head, body);
        } else body = func.body;
        const newNode = factory.createArrowFunction(func.modifiers, func.typeParameters, func.parameters, func.type, factory.createToken(39 /* EqualsGreaterThanToken */ ), body);
        return ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(file, func, newNode));
    }
    function canBeConvertedToExpression(body, head) {
        return body.statements.length === 1 && isReturnStatement(head) && !!head.expression;
    }
    function isFunctionReferencedInFile(sourceFile, typeChecker, node) {
        return !!node.name && ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(node.name, typeChecker, sourceFile);
    }
    var refactorName7, refactorDescription3, toAnonymousFunctionAction, toNamedFunctionAction, toArrowFunctionAction;
    var init_convertArrowFunctionOrFunctionExpression = __esm({
        "src/services/refactors/convertArrowFunctionOrFunctionExpression.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName7 = "Convert arrow function or function expression";
            refactorDescription3 = getLocaleSpecificMessage(Diagnostics.Convert_arrow_function_or_function_expression);
            toAnonymousFunctionAction = {
                name: "Convert to anonymous function",
                description: getLocaleSpecificMessage(Diagnostics.Convert_to_anonymous_function),
                kind: "refactor.rewrite.function.anonymous"
            };
            toNamedFunctionAction = {
                name: "Convert to named function",
                description: getLocaleSpecificMessage(Diagnostics.Convert_to_named_function),
                kind: "refactor.rewrite.function.named"
            };
            toArrowFunctionAction = {
                name: "Convert to arrow function",
                description: getLocaleSpecificMessage(Diagnostics.Convert_to_arrow_function),
                kind: "refactor.rewrite.function.arrow"
            };
            registerRefactor(refactorName7, {
                kinds: [
                    toAnonymousFunctionAction.kind,
                    toNamedFunctionAction.kind,
                    toArrowFunctionAction.kind
                ],
                getEditsForAction: getRefactorEditsToConvertFunctionExpressions,
                getAvailableActions: getRefactorActionsToConvertFunctionExpressions
            });
        }
    });
    // src/services/_namespaces/ts.refactor.convertArrowFunctionOrFunctionExpression.ts
    var ts_refactor_convertArrowFunctionOrFunctionExpression_exports = {};
    var init_ts_refactor_convertArrowFunctionOrFunctionExpression = __esm({
        "src/services/_namespaces/ts.refactor.convertArrowFunctionOrFunctionExpression.ts" () {
            "use strict";
            init_convertArrowFunctionOrFunctionExpression();
        }
    });
    // src/services/refactors/convertParamsToDestructuredObject.ts
    function getRefactorActionsToConvertParametersToDestructuredObject(context) {
        const { file: file , startPosition: startPosition  } = context;
        const isJSFile = isSourceFileJS(file);
        if (isJSFile) return emptyArray;
        const functionDeclaration = getFunctionDeclarationAtPosition(file, startPosition, context.program.getTypeChecker());
        if (!functionDeclaration) return emptyArray;
        return [
            {
                name: refactorName8,
                description: refactorDescription4,
                actions: [
                    toDestructuredAction
                ]
            }
        ];
    }
    function getRefactorEditsToConvertParametersToDestructuredObject(context, actionName2) {
        Debug.assert(actionName2 === refactorName8, "Unexpected action name");
        const { file: file , startPosition: startPosition , program: program , cancellationToken: cancellationToken , host: host  } = context;
        const functionDeclaration = getFunctionDeclarationAtPosition(file, startPosition, program.getTypeChecker());
        if (!functionDeclaration || !cancellationToken) return void 0;
        const groupedReferences = getGroupedReferences(functionDeclaration, program, cancellationToken);
        if (groupedReferences.valid) {
            const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange5(file, program, host, t, functionDeclaration, groupedReferences));
            return {
                renameFilename: void 0,
                renameLocation: void 0,
                edits: edits
            };
        }
        return {
            edits: []
        };
    }
    function doChange5(sourceFile, program, host, changes, functionDeclaration, groupedReferences) {
        const signature = groupedReferences.signature;
        const newFunctionDeclarationParams = map(createNewParameters(functionDeclaration, program, host), (param)=>getSynthesizedDeepClone(param));
        if (signature) {
            const newSignatureParams = map(createNewParameters(signature, program, host), (param)=>getSynthesizedDeepClone(param));
            replaceParameters(signature, newSignatureParams);
        }
        replaceParameters(functionDeclaration, newFunctionDeclarationParams);
        const functionCalls = sortAndDeduplicate(groupedReferences.functionCalls, /*comparer*/ (a, b)=>compareValues(a.pos, b.pos));
        for (const call of functionCalls)if (call.arguments && call.arguments.length) {
            const newArgument = getSynthesizedDeepClone(createNewArgument(functionDeclaration, call.arguments), /*includeTrivia*/ true);
            changes.replaceNodeRange(getSourceFileOfNode(call), first(call.arguments), last(call.arguments), newArgument, {
                leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.IncludeAll,
                trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Include
            });
        }
        function replaceParameters(declarationOrSignature, parameterDeclarations) {
            changes.replaceNodeRangeWithNodes(sourceFile, first(declarationOrSignature.parameters), last(declarationOrSignature.parameters), parameterDeclarations, {
                joiner: ", ",
                // indentation is set to 0 because otherwise the object parameter will be indented if there is a `this` parameter
                indentation: 0,
                leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.IncludeAll,
                trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Include
            });
        }
    }
    function getGroupedReferences(functionDeclaration, program, cancellationToken) {
        const functionNames = getFunctionNames(functionDeclaration);
        const classNames = isConstructorDeclaration(functionDeclaration) ? getClassNames(functionDeclaration) : [];
        const names = deduplicate([
            ...functionNames,
            ...classNames
        ], equateValues);
        const checker = program.getTypeChecker();
        const references = flatMap(names, /*mapfn*/ (name)=>ts_FindAllReferences_exports.getReferenceEntriesForNode(-1, name, program, program.getSourceFiles(), cancellationToken));
        const groupedReferences = groupReferences(references);
        if (!every(groupedReferences.declarations, /*callback*/ (decl)=>contains(names, decl))) groupedReferences.valid = false;
        return groupedReferences;
        function groupReferences(referenceEntries) {
            const classReferences = {
                accessExpressions: [],
                typeUsages: []
            };
            const groupedReferences2 = {
                functionCalls: [],
                declarations: [],
                classReferences: classReferences,
                valid: true
            };
            const functionSymbols = map(functionNames, getSymbolTargetAtLocation);
            const classSymbols = map(classNames, getSymbolTargetAtLocation);
            const isConstructor = isConstructorDeclaration(functionDeclaration);
            const contextualSymbols = map(functionNames, (name)=>getSymbolForContextualType(name, checker));
            for (const entry of referenceEntries){
                if (entry.kind === ts_FindAllReferences_exports.EntryKind.Span) {
                    groupedReferences2.valid = false;
                    continue;
                }
                if (contains(contextualSymbols, getSymbolTargetAtLocation(entry.node))) {
                    if (isValidMethodSignature(entry.node.parent)) {
                        groupedReferences2.signature = entry.node.parent;
                        continue;
                    }
                    const call = entryToFunctionCall(entry);
                    if (call) {
                        groupedReferences2.functionCalls.push(call);
                        continue;
                    }
                }
                const contextualSymbol = getSymbolForContextualType(entry.node, checker);
                if (contextualSymbol && contains(contextualSymbols, contextualSymbol)) {
                    const decl = entryToDeclaration(entry);
                    if (decl) {
                        groupedReferences2.declarations.push(decl);
                        continue;
                    }
                }
                if (contains(functionSymbols, getSymbolTargetAtLocation(entry.node)) || isNewExpressionTarget(entry.node)) {
                    const importOrExportReference = entryToImportOrExport(entry);
                    if (importOrExportReference) continue;
                    const decl = entryToDeclaration(entry);
                    if (decl) {
                        groupedReferences2.declarations.push(decl);
                        continue;
                    }
                    const call = entryToFunctionCall(entry);
                    if (call) {
                        groupedReferences2.functionCalls.push(call);
                        continue;
                    }
                }
                if (isConstructor && contains(classSymbols, getSymbolTargetAtLocation(entry.node))) {
                    const importOrExportReference = entryToImportOrExport(entry);
                    if (importOrExportReference) continue;
                    const decl = entryToDeclaration(entry);
                    if (decl) {
                        groupedReferences2.declarations.push(decl);
                        continue;
                    }
                    const accessExpression = entryToAccessExpression(entry);
                    if (accessExpression) {
                        classReferences.accessExpressions.push(accessExpression);
                        continue;
                    }
                    if (isClassDeclaration(functionDeclaration.parent)) {
                        const type = entryToType(entry);
                        if (type) {
                            classReferences.typeUsages.push(type);
                            continue;
                        }
                    }
                }
                groupedReferences2.valid = false;
            }
            return groupedReferences2;
        }
        function getSymbolTargetAtLocation(node) {
            const symbol = checker.getSymbolAtLocation(node);
            return symbol && getSymbolTarget(symbol, checker);
        }
    }
    function getSymbolForContextualType(node, checker) {
        const element = getContainingObjectLiteralElement(node);
        if (element) {
            const contextualType = checker.getContextualTypeForObjectLiteralElement(element);
            const symbol = contextualType == null ? void 0 : contextualType.getSymbol();
            if (symbol && !(getCheckFlags(symbol) & 6 /* Synthetic */ )) return symbol;
        }
    }
    function entryToImportOrExport(entry) {
        const node = entry.node;
        if (isImportSpecifier(node.parent) || isImportClause(node.parent) || isImportEqualsDeclaration(node.parent) || isNamespaceImport(node.parent)) return node;
        if (isExportSpecifier(node.parent) || isExportAssignment(node.parent)) return node;
        return void 0;
    }
    function entryToDeclaration(entry) {
        if (isDeclaration(entry.node.parent)) return entry.node;
        return void 0;
    }
    function entryToFunctionCall(entry) {
        if (entry.node.parent) {
            const functionReference = entry.node;
            const parent2 = functionReference.parent;
            switch(parent2.kind){
                case 212 /* CallExpression */ :
                case 213 /* NewExpression */ :
                    const callOrNewExpression = tryCast(parent2, isCallOrNewExpression);
                    if (callOrNewExpression && callOrNewExpression.expression === functionReference) return callOrNewExpression;
                    break;
                case 210 /* PropertyAccessExpression */ :
                    const propertyAccessExpression = tryCast(parent2, isPropertyAccessExpression);
                    if (propertyAccessExpression && propertyAccessExpression.parent && propertyAccessExpression.name === functionReference) {
                        const callOrNewExpression2 = tryCast(propertyAccessExpression.parent, isCallOrNewExpression);
                        if (callOrNewExpression2 && callOrNewExpression2.expression === propertyAccessExpression) return callOrNewExpression2;
                    }
                    break;
                case 211 /* ElementAccessExpression */ :
                    const elementAccessExpression = tryCast(parent2, isElementAccessExpression);
                    if (elementAccessExpression && elementAccessExpression.parent && elementAccessExpression.argumentExpression === functionReference) {
                        const callOrNewExpression2 = tryCast(elementAccessExpression.parent, isCallOrNewExpression);
                        if (callOrNewExpression2 && callOrNewExpression2.expression === elementAccessExpression) return callOrNewExpression2;
                    }
                    break;
            }
        }
        return void 0;
    }
    function entryToAccessExpression(entry) {
        if (entry.node.parent) {
            const reference = entry.node;
            const parent2 = reference.parent;
            switch(parent2.kind){
                case 210 /* PropertyAccessExpression */ :
                    const propertyAccessExpression = tryCast(parent2, isPropertyAccessExpression);
                    if (propertyAccessExpression && propertyAccessExpression.expression === reference) return propertyAccessExpression;
                    break;
                case 211 /* ElementAccessExpression */ :
                    const elementAccessExpression = tryCast(parent2, isElementAccessExpression);
                    if (elementAccessExpression && elementAccessExpression.expression === reference) return elementAccessExpression;
                    break;
            }
        }
        return void 0;
    }
    function entryToType(entry) {
        const reference = entry.node;
        if (getMeaningFromLocation(reference) === 2 /* Type */  || isExpressionWithTypeArgumentsInClassExtendsClause(reference.parent)) return reference;
        return void 0;
    }
    function getFunctionDeclarationAtPosition(file, startPosition, checker) {
        const node = getTouchingToken(file, startPosition);
        const functionDeclaration = getContainingFunctionDeclaration(node);
        if (isTopLevelJSDoc(node)) return void 0;
        if (functionDeclaration && isValidFunctionDeclaration(functionDeclaration, checker) && rangeContainsRange(functionDeclaration, node) && !(functionDeclaration.body && rangeContainsRange(functionDeclaration.body, node))) return functionDeclaration;
        return void 0;
    }
    function isTopLevelJSDoc(node) {
        const containingJSDoc = findAncestor(node, isJSDocNode);
        if (containingJSDoc) {
            const containingNonJSDoc = findAncestor(containingJSDoc, (n)=>!isJSDocNode(n));
            return !!containingNonJSDoc && isFunctionLikeDeclaration(containingNonJSDoc);
        }
        return false;
    }
    function isValidMethodSignature(node) {
        return isMethodSignature(node) && (isInterfaceDeclaration(node.parent) || isTypeLiteralNode(node.parent));
    }
    function isValidFunctionDeclaration(functionDeclaration, checker) {
        var _a;
        if (!isValidParameterNodeArray(functionDeclaration.parameters, checker)) return false;
        switch(functionDeclaration.kind){
            case 261 /* FunctionDeclaration */ :
                return hasNameOrDefault(functionDeclaration) && isSingleImplementation(functionDeclaration, checker);
            case 173 /* MethodDeclaration */ :
                if (isObjectLiteralExpression(functionDeclaration.parent)) {
                    const contextualSymbol = getSymbolForContextualType(functionDeclaration.name, checker);
                    return ((_a = contextualSymbol == null ? void 0 : contextualSymbol.declarations) == null ? void 0 : _a.length) === 1 && isSingleImplementation(functionDeclaration, checker);
                }
                return isSingleImplementation(functionDeclaration, checker);
            case 175 /* Constructor */ :
                if (isClassDeclaration(functionDeclaration.parent)) return hasNameOrDefault(functionDeclaration.parent) && isSingleImplementation(functionDeclaration, checker);
                else return isValidVariableDeclaration(functionDeclaration.parent.parent) && isSingleImplementation(functionDeclaration, checker);
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
                return isValidVariableDeclaration(functionDeclaration.parent);
        }
        return false;
    }
    function isSingleImplementation(functionDeclaration, checker) {
        return !!functionDeclaration.body && !checker.isImplementationOfOverload(functionDeclaration);
    }
    function hasNameOrDefault(functionOrClassDeclaration) {
        if (!functionOrClassDeclaration.name) {
            const defaultKeyword = findModifier(functionOrClassDeclaration, 90 /* DefaultKeyword */ );
            return !!defaultKeyword;
        }
        return true;
    }
    function isValidParameterNodeArray(parameters, checker) {
        return getRefactorableParametersLength(parameters) >= minimumParameterLength && every(parameters, /*callback*/ (paramDecl)=>isValidParameterDeclaration(paramDecl, checker));
    }
    function isValidParameterDeclaration(parameterDeclaration, checker) {
        if (isRestParameter(parameterDeclaration)) {
            const type = checker.getTypeAtLocation(parameterDeclaration);
            if (!checker.isArrayType(type) && !checker.isTupleType(type)) return false;
        }
        return !parameterDeclaration.modifiers && isIdentifier(parameterDeclaration.name);
    }
    function isValidVariableDeclaration(node) {
        return isVariableDeclaration(node) && isVarConst(node) && isIdentifier(node.name) && !node.type;
    }
    function hasThisParameter(parameters) {
        return parameters.length > 0 && isThis(parameters[0].name);
    }
    function getRefactorableParametersLength(parameters) {
        if (hasThisParameter(parameters)) return parameters.length - 1;
        return parameters.length;
    }
    function getRefactorableParameters(parameters) {
        if (hasThisParameter(parameters)) parameters = factory.createNodeArray(parameters.slice(1), parameters.hasTrailingComma);
        return parameters;
    }
    function createPropertyOrShorthandAssignment(name, initializer) {
        if (isIdentifier(initializer) && getTextOfIdentifierOrLiteral(initializer) === name) return factory.createShorthandPropertyAssignment(name);
        return factory.createPropertyAssignment(name, initializer);
    }
    function createNewArgument(functionDeclaration, functionArguments) {
        const parameters = getRefactorableParameters(functionDeclaration.parameters);
        const hasRestParameter2 = isRestParameter(last(parameters));
        const nonRestArguments = hasRestParameter2 ? functionArguments.slice(0, parameters.length - 1) : functionArguments;
        const properties = map(nonRestArguments, (arg, i)=>{
            const parameterName = getParameterName(parameters[i]);
            const property = createPropertyOrShorthandAssignment(parameterName, arg);
            suppressLeadingAndTrailingTrivia(property.name);
            if (isPropertyAssignment(property)) suppressLeadingAndTrailingTrivia(property.initializer);
            copyComments(arg, property);
            return property;
        });
        if (hasRestParameter2 && functionArguments.length >= parameters.length) {
            const restArguments = functionArguments.slice(parameters.length - 1);
            const restProperty = factory.createPropertyAssignment(getParameterName(last(parameters)), factory.createArrayLiteralExpression(restArguments));
            properties.push(restProperty);
        }
        const objectLiteral = factory.createObjectLiteralExpression(properties, /*multiLine*/ false);
        return objectLiteral;
    }
    function createNewParameters(functionDeclaration, program, host) {
        const checker = program.getTypeChecker();
        const refactorableParameters = getRefactorableParameters(functionDeclaration.parameters);
        const bindingElements = map(refactorableParameters, createBindingElementFromParameterDeclaration);
        const objectParameterName = factory.createObjectBindingPattern(bindingElements);
        const objectParameterType = createParameterTypeNode(refactorableParameters);
        let objectInitializer;
        if (every(refactorableParameters, isOptionalParameter)) objectInitializer = factory.createObjectLiteralExpression();
        const objectParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, objectParameterName, /*questionToken*/ void 0, objectParameterType, objectInitializer);
        if (hasThisParameter(functionDeclaration.parameters)) {
            const thisParameter = functionDeclaration.parameters[0];
            const newThisParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, thisParameter.name, /*questionToken*/ void 0, thisParameter.type);
            suppressLeadingAndTrailingTrivia(newThisParameter.name);
            copyComments(thisParameter.name, newThisParameter.name);
            if (thisParameter.type) {
                suppressLeadingAndTrailingTrivia(newThisParameter.type);
                copyComments(thisParameter.type, newThisParameter.type);
            }
            return factory.createNodeArray([
                newThisParameter,
                objectParameter
            ]);
        }
        return factory.createNodeArray([
            objectParameter
        ]);
        function createBindingElementFromParameterDeclaration(parameterDeclaration) {
            const element = factory.createBindingElement(/*dotDotDotToken*/ void 0, /*propertyName*/ void 0, getParameterName(parameterDeclaration), isRestParameter(parameterDeclaration) && isOptionalParameter(parameterDeclaration) ? factory.createArrayLiteralExpression() : parameterDeclaration.initializer);
            suppressLeadingAndTrailingTrivia(element);
            if (parameterDeclaration.initializer && element.initializer) copyComments(parameterDeclaration.initializer, element.initializer);
            return element;
        }
        function createParameterTypeNode(parameters) {
            const members = map(parameters, createPropertySignatureFromParameterDeclaration);
            const typeNode = addEmitFlags(factory.createTypeLiteralNode(members), 1 /* SingleLine */ );
            return typeNode;
        }
        function createPropertySignatureFromParameterDeclaration(parameterDeclaration) {
            let parameterType = parameterDeclaration.type;
            if (!parameterType && (parameterDeclaration.initializer || isRestParameter(parameterDeclaration))) parameterType = getTypeNode3(parameterDeclaration);
            const propertySignature = factory.createPropertySignature(/*modifiers*/ void 0, getParameterName(parameterDeclaration), isOptionalParameter(parameterDeclaration) ? factory.createToken(58 /* QuestionToken */ ) : parameterDeclaration.questionToken, parameterType);
            suppressLeadingAndTrailingTrivia(propertySignature);
            copyComments(parameterDeclaration.name, propertySignature.name);
            if (parameterDeclaration.type && propertySignature.type) copyComments(parameterDeclaration.type, propertySignature.type);
            return propertySignature;
        }
        function getTypeNode3(node) {
            const type = checker.getTypeAtLocation(node);
            return getTypeNodeIfAccessible(type, node, program, host);
        }
        function isOptionalParameter(parameterDeclaration) {
            if (isRestParameter(parameterDeclaration)) {
                const type = checker.getTypeAtLocation(parameterDeclaration);
                return !checker.isTupleType(type);
            }
            return checker.isOptionalParameter(parameterDeclaration);
        }
    }
    function getParameterName(paramDeclaration) {
        return getTextOfIdentifierOrLiteral(paramDeclaration.name);
    }
    function getClassNames(constructorDeclaration) {
        switch(constructorDeclaration.parent.kind){
            case 262 /* ClassDeclaration */ :
                const classDeclaration = constructorDeclaration.parent;
                if (classDeclaration.name) return [
                    classDeclaration.name
                ];
                const defaultModifier = Debug.checkDefined(findModifier(classDeclaration, 90 /* DefaultKeyword */ ), "Nameless class declaration should be a default export");
                return [
                    defaultModifier
                ];
            case 230 /* ClassExpression */ :
                const classExpression = constructorDeclaration.parent;
                const variableDeclaration = constructorDeclaration.parent.parent;
                const className = classExpression.name;
                if (className) return [
                    className,
                    variableDeclaration.name
                ];
                return [
                    variableDeclaration.name
                ];
        }
    }
    function getFunctionNames(functionDeclaration) {
        switch(functionDeclaration.kind){
            case 261 /* FunctionDeclaration */ :
                if (functionDeclaration.name) return [
                    functionDeclaration.name
                ];
                const defaultModifier = Debug.checkDefined(findModifier(functionDeclaration, 90 /* DefaultKeyword */ ), "Nameless function declaration should be a default export");
                return [
                    defaultModifier
                ];
            case 173 /* MethodDeclaration */ :
                return [
                    functionDeclaration.name
                ];
            case 175 /* Constructor */ :
                const ctrKeyword = Debug.checkDefined(findChildOfKind(functionDeclaration, 137 /* ConstructorKeyword */ , functionDeclaration.getSourceFile()), "Constructor declaration should have constructor keyword");
                if (functionDeclaration.parent.kind === 230 /* ClassExpression */ ) {
                    const variableDeclaration = functionDeclaration.parent.parent;
                    return [
                        variableDeclaration.name,
                        ctrKeyword
                    ];
                }
                return [
                    ctrKeyword
                ];
            case 218 /* ArrowFunction */ :
                return [
                    functionDeclaration.parent.name
                ];
            case 217 /* FunctionExpression */ :
                if (functionDeclaration.name) return [
                    functionDeclaration.name,
                    functionDeclaration.parent.name
                ];
                return [
                    functionDeclaration.parent.name
                ];
            default:
                return Debug.assertNever(functionDeclaration, `Unexpected function declaration kind ${functionDeclaration.kind}`);
        }
    }
    var refactorName8, minimumParameterLength, refactorDescription4, toDestructuredAction;
    var init_convertParamsToDestructuredObject = __esm({
        "src/services/refactors/convertParamsToDestructuredObject.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName8 = "Convert parameters to destructured object";
            minimumParameterLength = 1;
            refactorDescription4 = getLocaleSpecificMessage(Diagnostics.Convert_parameters_to_destructured_object);
            toDestructuredAction = {
                name: refactorName8,
                description: refactorDescription4,
                kind: "refactor.rewrite.parameters.toDestructured"
            };
            registerRefactor(refactorName8, {
                kinds: [
                    toDestructuredAction.kind
                ],
                getEditsForAction: getRefactorEditsToConvertParametersToDestructuredObject,
                getAvailableActions: getRefactorActionsToConvertParametersToDestructuredObject
            });
        }
    });
    // src/services/_namespaces/ts.refactor.convertParamsToDestructuredObject.ts
    var ts_refactor_convertParamsToDestructuredObject_exports = {};
    var init_ts_refactor_convertParamsToDestructuredObject = __esm({
        "src/services/_namespaces/ts.refactor.convertParamsToDestructuredObject.ts" () {
            "use strict";
            init_convertParamsToDestructuredObject();
        }
    });
    // src/services/refactors/convertStringOrTemplateLiteral.ts
    function getRefactorActionsToConvertToTemplateString(context) {
        const { file: file , startPosition: startPosition  } = context;
        const node = getNodeOrParentOfParentheses(file, startPosition);
        const maybeBinary = getParentBinaryExpression(node);
        const refactorInfo = {
            name: refactorName9,
            description: refactorDescription5,
            actions: []
        };
        if (isBinaryExpression(maybeBinary) && treeToArray(maybeBinary).isValidConcatenation) {
            refactorInfo.actions.push(convertStringAction);
            return [
                refactorInfo
            ];
        } else if (context.preferences.provideRefactorNotApplicableReason) {
            refactorInfo.actions.push({
                ...convertStringAction,
                notApplicableReason: getLocaleSpecificMessage(Diagnostics.Can_only_convert_string_concatenation)
            });
            return [
                refactorInfo
            ];
        }
        return emptyArray;
    }
    function getNodeOrParentOfParentheses(file, startPosition) {
        const node = getTokenAtPosition(file, startPosition);
        const nestedBinary = getParentBinaryExpression(node);
        const isNonStringBinary = !treeToArray(nestedBinary).isValidConcatenation;
        if (isNonStringBinary && isParenthesizedExpression(nestedBinary.parent) && isBinaryExpression(nestedBinary.parent.parent)) return nestedBinary.parent.parent;
        return node;
    }
    function getRefactorEditsToConvertToTemplateString(context, actionName2) {
        const { file: file , startPosition: startPosition  } = context;
        const node = getNodeOrParentOfParentheses(file, startPosition);
        switch(actionName2){
            case refactorDescription5:
                return {
                    edits: getEditsForToTemplateLiteral(context, node)
                };
            default:
                return Debug.fail("invalid action");
        }
    }
    function getEditsForToTemplateLiteral(context, node) {
        const maybeBinary = getParentBinaryExpression(node);
        const file = context.file;
        const templateLiteral = nodesToTemplate(treeToArray(maybeBinary), file);
        const trailingCommentRanges = getTrailingCommentRanges(file.text, maybeBinary.end);
        if (trailingCommentRanges) {
            const lastComment = trailingCommentRanges[trailingCommentRanges.length - 1];
            const trailingRange = {
                pos: trailingCommentRanges[0].pos,
                end: lastComment.end
            };
            return ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
                t.deleteRange(file, trailingRange);
                t.replaceNode(file, maybeBinary, templateLiteral);
            });
        } else return ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(file, maybeBinary, templateLiteral));
    }
    function isNotEqualsOperator(node) {
        return node.operatorToken.kind !== 64 /* EqualsToken */ ;
    }
    function getParentBinaryExpression(expr) {
        const container = findAncestor(expr.parent, (n)=>{
            switch(n.kind){
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    return false;
                case 227 /* TemplateExpression */ :
                case 225 /* BinaryExpression */ :
                    return !(isBinaryExpression(n.parent) && isNotEqualsOperator(n.parent));
                default:
                    return "quit";
            }
        });
        return container || expr;
    }
    function treeToArray(current) {
        const loop = (current2)=>{
            if (!isBinaryExpression(current2)) return {
                nodes: [
                    current2
                ],
                operators: [],
                validOperators: true,
                hasString: isStringLiteral(current2) || isNoSubstitutionTemplateLiteral(current2)
            };
            const { nodes: nodes2 , operators: operators2 , hasString: leftHasString , validOperators: leftOperatorValid  } = loop(current2.left);
            if (!(leftHasString || isStringLiteral(current2.right) || isTemplateExpression(current2.right))) return {
                nodes: [
                    current2
                ],
                operators: [],
                hasString: false,
                validOperators: true
            };
            const currentOperatorValid = current2.operatorToken.kind === 40 /* PlusToken */ ;
            const validOperators2 = leftOperatorValid && currentOperatorValid;
            nodes2.push(current2.right);
            operators2.push(current2.operatorToken);
            return {
                nodes: nodes2,
                operators: operators2,
                hasString: true,
                validOperators: validOperators2
            };
        };
        const { nodes: nodes , operators: operators , validOperators: validOperators , hasString: hasString  } = loop(current);
        return {
            nodes: nodes,
            operators: operators,
            isValidConcatenation: validOperators && hasString
        };
    }
    function escapeRawStringForTemplate(s) {
        return s.replace(/\\.|[$`]/g, (m)=>m[0] === "\\" ? m : "\\" + m);
    }
    function getRawTextOfTemplate(node) {
        const rightShaving = isTemplateHead(node) || isTemplateMiddle(node) ? -2 : -1;
        return getTextOfNode(node).slice(1, rightShaving);
    }
    function concatConsecutiveString(index, nodes) {
        const indexes = [];
        let text = "", rawText = "";
        while(index < nodes.length){
            const node = nodes[index];
            if (isStringLiteralLike(node)) {
                text += node.text;
                rawText += escapeRawStringForTemplate(getTextOfNode(node).slice(1, -1));
                indexes.push(index);
                index++;
            } else if (isTemplateExpression(node)) {
                text += node.head.text;
                rawText += getRawTextOfTemplate(node.head);
                break;
            } else break;
        }
        return [
            index,
            text,
            rawText,
            indexes
        ];
    }
    function nodesToTemplate({ nodes: nodes , operators: operators  }, file) {
        const copyOperatorComments = copyTrailingOperatorComments(operators, file);
        const copyCommentFromStringLiterals = copyCommentFromMultiNode(nodes, file, copyOperatorComments);
        const [begin, headText, rawHeadText, headIndexes] = concatConsecutiveString(0, nodes);
        if (begin === nodes.length) {
            const noSubstitutionTemplateLiteral = factory.createNoSubstitutionTemplateLiteral(headText, rawHeadText);
            copyCommentFromStringLiterals(headIndexes, noSubstitutionTemplateLiteral);
            return noSubstitutionTemplateLiteral;
        }
        const templateSpans = [];
        const templateHead = factory.createTemplateHead(headText, rawHeadText);
        copyCommentFromStringLiterals(headIndexes, templateHead);
        for(let i = begin; i < nodes.length; i++){
            const currentNode = getExpressionFromParenthesesOrExpression(nodes[i]);
            copyOperatorComments(i, currentNode);
            const [newIndex, subsequentText, rawSubsequentText, stringIndexes] = concatConsecutiveString(i + 1, nodes);
            i = newIndex - 1;
            const isLast = i === nodes.length - 1;
            if (isTemplateExpression(currentNode)) {
                const spans = map(currentNode.templateSpans, (span, index)=>{
                    copyExpressionComments(span);
                    const isLastSpan = index === currentNode.templateSpans.length - 1;
                    const text = span.literal.text + (isLastSpan ? subsequentText : "");
                    const rawText = getRawTextOfTemplate(span.literal) + (isLastSpan ? rawSubsequentText : "");
                    return factory.createTemplateSpan(span.expression, isLast && isLastSpan ? factory.createTemplateTail(text, rawText) : factory.createTemplateMiddle(text, rawText));
                });
                templateSpans.push(...spans);
            } else {
                const templatePart = isLast ? factory.createTemplateTail(subsequentText, rawSubsequentText) : factory.createTemplateMiddle(subsequentText, rawSubsequentText);
                copyCommentFromStringLiterals(stringIndexes, templatePart);
                templateSpans.push(factory.createTemplateSpan(currentNode, templatePart));
            }
        }
        return factory.createTemplateExpression(templateHead, templateSpans);
    }
    function copyExpressionComments(node) {
        const file = node.getSourceFile();
        copyTrailingComments(node, node.expression, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
        copyTrailingAsLeadingComments(node.expression, node.expression, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
    }
    function getExpressionFromParenthesesOrExpression(node) {
        if (isParenthesizedExpression(node)) {
            copyExpressionComments(node);
            node = node.expression;
        }
        return node;
    }
    var refactorName9, refactorDescription5, convertStringAction, copyTrailingOperatorComments, copyCommentFromMultiNode;
    var init_convertStringOrTemplateLiteral = __esm({
        "src/services/refactors/convertStringOrTemplateLiteral.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName9 = "Convert to template string";
            refactorDescription5 = getLocaleSpecificMessage(Diagnostics.Convert_to_template_string);
            convertStringAction = {
                name: refactorName9,
                description: refactorDescription5,
                kind: "refactor.rewrite.string"
            };
            registerRefactor(refactorName9, {
                kinds: [
                    convertStringAction.kind
                ],
                getEditsForAction: getRefactorEditsToConvertToTemplateString,
                getAvailableActions: getRefactorActionsToConvertToTemplateString
            });
            copyTrailingOperatorComments = (operators, file)=>(index, targetNode)=>{
                    if (index < operators.length) copyTrailingComments(operators[index], targetNode, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
                };
            copyCommentFromMultiNode = (nodes, file, copyOperatorComments)=>(indexes, targetNode)=>{
                    while(indexes.length > 0){
                        const index = indexes.shift();
                        copyTrailingComments(nodes[index], targetNode, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
                        copyOperatorComments(index, targetNode);
                    }
                };
        }
    });
    // src/services/_namespaces/ts.refactor.convertStringOrTemplateLiteral.ts
    var ts_refactor_convertStringOrTemplateLiteral_exports = {};
    var init_ts_refactor_convertStringOrTemplateLiteral = __esm({
        "src/services/_namespaces/ts.refactor.convertStringOrTemplateLiteral.ts" () {
            "use strict";
            init_convertStringOrTemplateLiteral();
        }
    });
    // src/services/refactors/convertToOptionalChainExpression.ts
    function getRefactorActionsToConvertToOptionalChain(context) {
        const info = getInfo3(context, context.triggerReason === "invoked");
        if (!info) return emptyArray;
        if (!isRefactorErrorInfo(info)) return [
            {
                name: refactorName10,
                description: convertToOptionalChainExpressionMessage,
                actions: [
                    toOptionalChainAction
                ]
            }
        ];
        if (context.preferences.provideRefactorNotApplicableReason) return [
            {
                name: refactorName10,
                description: convertToOptionalChainExpressionMessage,
                actions: [
                    {
                        ...toOptionalChainAction,
                        notApplicableReason: info.error
                    }
                ]
            }
        ];
        return emptyArray;
    }
    function getRefactorEditsToConvertToOptionalChain(context, actionName2) {
        const info = getInfo3(context);
        Debug.assert(info && !isRefactorErrorInfo(info), "Expected applicable refactor info");
        const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange6(context.file, context.program.getTypeChecker(), t, info, actionName2));
        return {
            edits: edits,
            renameFilename: void 0,
            renameLocation: void 0
        };
    }
    function isValidExpression(node) {
        return isBinaryExpression(node) || isConditionalExpression(node);
    }
    function isValidStatement(node) {
        return isExpressionStatement(node) || isReturnStatement(node) || isVariableStatement(node);
    }
    function isValidExpressionOrStatement(node) {
        return isValidExpression(node) || isValidStatement(node);
    }
    function getInfo3(context, considerEmptySpans = true) {
        const { file: file , program: program  } = context;
        const span = getRefactorContextSpan(context);
        const forEmptySpan = span.length === 0;
        if (forEmptySpan && !considerEmptySpans) return void 0;
        const startToken = getTokenAtPosition(file, span.start);
        const endToken = findTokenOnLeftOfPosition(file, span.start + span.length);
        const adjustedSpan = createTextSpanFromBounds(startToken.pos, endToken && endToken.end >= startToken.pos ? endToken.getEnd() : startToken.getEnd());
        const parent2 = forEmptySpan ? getValidParentNodeOfEmptySpan(startToken) : getValidParentNodeContainingSpan(startToken, adjustedSpan);
        const expression = parent2 && isValidExpressionOrStatement(parent2) ? getExpression(parent2) : void 0;
        if (!expression) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_convertible_access_expression)
        };
        const checker = program.getTypeChecker();
        return isConditionalExpression(expression) ? getConditionalInfo(expression, checker) : getBinaryInfo(expression);
    }
    function getConditionalInfo(expression, checker) {
        const condition = expression.condition;
        const finalExpression = getFinalExpressionInChain(expression.whenTrue);
        if (!finalExpression || checker.isNullableType(checker.getTypeAtLocation(finalExpression))) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_convertible_access_expression)
        };
        if ((isPropertyAccessExpression(condition) || isIdentifier(condition)) && getMatchingStart(condition, finalExpression.expression)) return {
            finalExpression: finalExpression,
            occurrences: [
                condition
            ],
            expression: expression
        };
        else if (isBinaryExpression(condition)) {
            const occurrences = getOccurrencesInExpression(finalExpression.expression, condition);
            return occurrences ? {
                finalExpression: finalExpression,
                occurrences: occurrences,
                expression: expression
            } : {
                error: getLocaleSpecificMessage(Diagnostics.Could_not_find_matching_access_expressions)
            };
        }
    }
    function getBinaryInfo(expression) {
        if (expression.operatorToken.kind !== 56 /* AmpersandAmpersandToken */ ) return {
            error: getLocaleSpecificMessage(Diagnostics.Can_only_convert_logical_AND_access_chains)
        };
        const finalExpression = getFinalExpressionInChain(expression.right);
        if (!finalExpression) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_convertible_access_expression)
        };
        const occurrences = getOccurrencesInExpression(finalExpression.expression, expression.left);
        return occurrences ? {
            finalExpression: finalExpression,
            occurrences: occurrences,
            expression: expression
        } : {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_matching_access_expressions)
        };
    }
    function getOccurrencesInExpression(matchTo, expression) {
        const occurrences = [];
        while(isBinaryExpression(expression) && expression.operatorToken.kind === 56 /* AmpersandAmpersandToken */ ){
            const match = getMatchingStart(skipParentheses(matchTo), skipParentheses(expression.right));
            if (!match) break;
            occurrences.push(match);
            matchTo = match;
            expression = expression.left;
        }
        const finalMatch = getMatchingStart(matchTo, expression);
        if (finalMatch) occurrences.push(finalMatch);
        return occurrences.length > 0 ? occurrences : void 0;
    }
    function getMatchingStart(chain, subchain) {
        if (!isIdentifier(subchain) && !isPropertyAccessExpression(subchain) && !isElementAccessExpression(subchain)) return void 0;
        return chainStartsWith(chain, subchain) ? subchain : void 0;
    }
    function chainStartsWith(chain, subchain) {
        while(isCallExpression(chain) || isPropertyAccessExpression(chain) || isElementAccessExpression(chain)){
            if (getTextOfChainNode(chain) === getTextOfChainNode(subchain)) break;
            chain = chain.expression;
        }
        while(isPropertyAccessExpression(chain) && isPropertyAccessExpression(subchain) || isElementAccessExpression(chain) && isElementAccessExpression(subchain)){
            if (getTextOfChainNode(chain) !== getTextOfChainNode(subchain)) return false;
            chain = chain.expression;
            subchain = subchain.expression;
        }
        return isIdentifier(chain) && isIdentifier(subchain) && chain.getText() === subchain.getText();
    }
    function getTextOfChainNode(node) {
        if (isIdentifier(node) || isStringOrNumericLiteralLike(node)) return node.getText();
        if (isPropertyAccessExpression(node)) return getTextOfChainNode(node.name);
        if (isElementAccessExpression(node)) return getTextOfChainNode(node.argumentExpression);
        return void 0;
    }
    function getValidParentNodeContainingSpan(node, span) {
        while(node.parent){
            if (isValidExpressionOrStatement(node) && span.length !== 0 && node.end >= span.start + span.length) return node;
            node = node.parent;
        }
        return void 0;
    }
    function getValidParentNodeOfEmptySpan(node) {
        while(node.parent){
            if (isValidExpressionOrStatement(node) && !isValidExpressionOrStatement(node.parent)) return node;
            node = node.parent;
        }
        return void 0;
    }
    function getExpression(node) {
        if (isValidExpression(node)) return node;
        if (isVariableStatement(node)) {
            const variable = getSingleVariableOfVariableStatement(node);
            const initializer = variable == null ? void 0 : variable.initializer;
            return initializer && isValidExpression(initializer) ? initializer : void 0;
        }
        return node.expression && isValidExpression(node.expression) ? node.expression : void 0;
    }
    function getFinalExpressionInChain(node) {
        node = skipParentheses(node);
        if (isBinaryExpression(node)) return getFinalExpressionInChain(node.left);
        else if ((isPropertyAccessExpression(node) || isElementAccessExpression(node) || isCallExpression(node)) && !isOptionalChain(node)) return node;
        return void 0;
    }
    function convertOccurrences(checker, toConvert, occurrences) {
        if (isPropertyAccessExpression(toConvert) || isElementAccessExpression(toConvert) || isCallExpression(toConvert)) {
            const chain = convertOccurrences(checker, toConvert.expression, occurrences);
            const lastOccurrence = occurrences.length > 0 ? occurrences[occurrences.length - 1] : void 0;
            const isOccurrence = (lastOccurrence == null ? void 0 : lastOccurrence.getText()) === toConvert.expression.getText();
            if (isOccurrence) occurrences.pop();
            if (isCallExpression(toConvert)) return isOccurrence ? factory.createCallChain(chain, factory.createToken(29 /* QuestionDotToken */ ), toConvert.typeArguments, toConvert.arguments) : factory.createCallChain(chain, toConvert.questionDotToken, toConvert.typeArguments, toConvert.arguments);
            else if (isPropertyAccessExpression(toConvert)) return isOccurrence ? factory.createPropertyAccessChain(chain, factory.createToken(29 /* QuestionDotToken */ ), toConvert.name) : factory.createPropertyAccessChain(chain, toConvert.questionDotToken, toConvert.name);
            else if (isElementAccessExpression(toConvert)) return isOccurrence ? factory.createElementAccessChain(chain, factory.createToken(29 /* QuestionDotToken */ ), toConvert.argumentExpression) : factory.createElementAccessChain(chain, toConvert.questionDotToken, toConvert.argumentExpression);
        }
        return toConvert;
    }
    function doChange6(sourceFile, checker, changes, info, _actionName) {
        const { finalExpression: finalExpression , occurrences: occurrences , expression: expression  } = info;
        const firstOccurrence = occurrences[occurrences.length - 1];
        const convertedChain = convertOccurrences(checker, finalExpression, occurrences);
        if (convertedChain && (isPropertyAccessExpression(convertedChain) || isElementAccessExpression(convertedChain) || isCallExpression(convertedChain))) {
            if (isBinaryExpression(expression)) changes.replaceNodeRange(sourceFile, firstOccurrence, finalExpression, convertedChain);
            else if (isConditionalExpression(expression)) changes.replaceNode(sourceFile, expression, factory.createBinaryExpression(convertedChain, factory.createToken(61 /* QuestionQuestionToken */ ), expression.whenFalse));
        }
    }
    var refactorName10, convertToOptionalChainExpressionMessage, toOptionalChainAction;
    var init_convertToOptionalChainExpression = __esm({
        "src/services/refactors/convertToOptionalChainExpression.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName10 = "Convert to optional chain expression";
            convertToOptionalChainExpressionMessage = getLocaleSpecificMessage(Diagnostics.Convert_to_optional_chain_expression);
            toOptionalChainAction = {
                name: refactorName10,
                description: convertToOptionalChainExpressionMessage,
                kind: "refactor.rewrite.expression.optionalChain"
            };
            registerRefactor(refactorName10, {
                kinds: [
                    toOptionalChainAction.kind
                ],
                getEditsForAction: getRefactorEditsToConvertToOptionalChain,
                getAvailableActions: getRefactorActionsToConvertToOptionalChain
            });
        }
    });
    // src/services/_namespaces/ts.refactor.convertToOptionalChainExpression.ts
    var ts_refactor_convertToOptionalChainExpression_exports = {};
    var init_ts_refactor_convertToOptionalChainExpression = __esm({
        "src/services/_namespaces/ts.refactor.convertToOptionalChainExpression.ts" () {
            "use strict";
            init_convertToOptionalChainExpression();
        }
    });
    // src/services/refactors/extractSymbol.ts
    function getRefactorActionsToExtractSymbol(context) {
        const requestedRefactor = context.kind;
        const rangeToExtract = getRangeToExtract2(context.file, getRefactorContextSpan(context), context.triggerReason === "invoked");
        const targetRange = rangeToExtract.targetRange;
        if (targetRange === void 0) {
            if (!rangeToExtract.errors || rangeToExtract.errors.length === 0 || !context.preferences.provideRefactorNotApplicableReason) return emptyArray;
            const errors = [];
            if (refactorKindBeginsWith(extractFunctionAction.kind, requestedRefactor)) errors.push({
                name: refactorName11,
                description: extractFunctionAction.description,
                actions: [
                    {
                        ...extractFunctionAction,
                        notApplicableReason: getStringError(rangeToExtract.errors)
                    }
                ]
            });
            if (refactorKindBeginsWith(extractConstantAction.kind, requestedRefactor)) errors.push({
                name: refactorName11,
                description: extractConstantAction.description,
                actions: [
                    {
                        ...extractConstantAction,
                        notApplicableReason: getStringError(rangeToExtract.errors)
                    }
                ]
            });
            return errors;
        }
        const extractions = getPossibleExtractions(targetRange, context);
        if (extractions === void 0) return emptyArray;
        const functionActions = [];
        const usedFunctionNames = /* @__PURE__ */ new Map();
        let innermostErrorFunctionAction;
        const constantActions = [];
        const usedConstantNames = /* @__PURE__ */ new Map();
        let innermostErrorConstantAction;
        let i = 0;
        for (const { functionExtraction: functionExtraction , constantExtraction: constantExtraction  } of extractions){
            if (refactorKindBeginsWith(extractFunctionAction.kind, requestedRefactor)) {
                const description3 = functionExtraction.description;
                if (functionExtraction.errors.length === 0) {
                    if (!usedFunctionNames.has(description3)) {
                        usedFunctionNames.set(description3, true);
                        functionActions.push({
                            description: description3,
                            name: `function_scope_${i}`,
                            kind: extractFunctionAction.kind
                        });
                    }
                } else if (!innermostErrorFunctionAction) innermostErrorFunctionAction = {
                    description: description3,
                    name: `function_scope_${i}`,
                    notApplicableReason: getStringError(functionExtraction.errors),
                    kind: extractFunctionAction.kind
                };
            }
            if (refactorKindBeginsWith(extractConstantAction.kind, requestedRefactor)) {
                const description3 = constantExtraction.description;
                if (constantExtraction.errors.length === 0) {
                    if (!usedConstantNames.has(description3)) {
                        usedConstantNames.set(description3, true);
                        constantActions.push({
                            description: description3,
                            name: `constant_scope_${i}`,
                            kind: extractConstantAction.kind
                        });
                    }
                } else if (!innermostErrorConstantAction) innermostErrorConstantAction = {
                    description: description3,
                    name: `constant_scope_${i}`,
                    notApplicableReason: getStringError(constantExtraction.errors),
                    kind: extractConstantAction.kind
                };
            }
            i++;
        }
        const infos = [];
        if (functionActions.length) infos.push({
            name: refactorName11,
            description: getLocaleSpecificMessage(Diagnostics.Extract_function),
            actions: functionActions
        });
        else if (context.preferences.provideRefactorNotApplicableReason && innermostErrorFunctionAction) infos.push({
            name: refactorName11,
            description: getLocaleSpecificMessage(Diagnostics.Extract_function),
            actions: [
                innermostErrorFunctionAction
            ]
        });
        if (constantActions.length) infos.push({
            name: refactorName11,
            description: getLocaleSpecificMessage(Diagnostics.Extract_constant),
            actions: constantActions
        });
        else if (context.preferences.provideRefactorNotApplicableReason && innermostErrorConstantAction) infos.push({
            name: refactorName11,
            description: getLocaleSpecificMessage(Diagnostics.Extract_constant),
            actions: [
                innermostErrorConstantAction
            ]
        });
        return infos.length ? infos : emptyArray;
        function getStringError(errors) {
            let error = errors[0].messageText;
            if (typeof error !== "string") error = error.messageText;
            return error;
        }
    }
    function getRefactorEditsToExtractSymbol(context, actionName2) {
        const rangeToExtract = getRangeToExtract2(context.file, getRefactorContextSpan(context));
        const targetRange = rangeToExtract.targetRange;
        const parsedFunctionIndexMatch = /^function_scope_(\d+)$/.exec(actionName2);
        if (parsedFunctionIndexMatch) {
            const index = +parsedFunctionIndexMatch[1];
            Debug.assert(isFinite(index), "Expected to parse a finite number from the function scope index");
            return getFunctionExtractionAtIndex(targetRange, context, index);
        }
        const parsedConstantIndexMatch = /^constant_scope_(\d+)$/.exec(actionName2);
        if (parsedConstantIndexMatch) {
            const index = +parsedConstantIndexMatch[1];
            Debug.assert(isFinite(index), "Expected to parse a finite number from the constant scope index");
            return getConstantExtractionAtIndex(targetRange, context, index);
        }
        Debug.fail("Unrecognized action name");
    }
    function getRangeToExtract2(sourceFile, span, invoked = true) {
        const { length: length2  } = span;
        if (length2 === 0 && !invoked) return {
            errors: [
                createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractEmpty)
            ]
        };
        const cursorRequest = length2 === 0 && invoked;
        const startToken = findFirstNonJsxWhitespaceToken(sourceFile, span.start);
        const endToken = findTokenOnLeftOfPosition(sourceFile, textSpanEnd(span));
        const adjustedSpan = startToken && endToken && invoked ? getAdjustedSpanFromNodes(startToken, endToken, sourceFile) : span;
        const start = cursorRequest ? getExtractableParent(startToken) : getParentNodeInSpan(startToken, sourceFile, adjustedSpan);
        const end = cursorRequest ? start : getParentNodeInSpan(endToken, sourceFile, adjustedSpan);
        let rangeFacts = 0 /* None */ ;
        let thisNode;
        if (!start || !end) return {
            errors: [
                createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractRange)
            ]
        };
        if (start.flags & 8388608 /* JSDoc */ ) return {
            errors: [
                createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractJSDoc)
            ]
        };
        if (start.parent !== end.parent) return {
            errors: [
                createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractRange)
            ]
        };
        if (start !== end) {
            if (!isBlockLike(start.parent)) return {
                errors: [
                    createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractRange)
                ]
            };
            const statements = [];
            for (const statement of start.parent.statements){
                if (statement === start || statements.length) {
                    const errors2 = checkNode(statement);
                    if (errors2) return {
                        errors: errors2
                    };
                    statements.push(statement);
                }
                if (statement === end) break;
            }
            if (!statements.length) return {
                errors: [
                    createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractRange)
                ]
            };
            return {
                targetRange: {
                    range: statements,
                    facts: rangeFacts,
                    thisNode: thisNode
                }
            };
        }
        if (isReturnStatement(start) && !start.expression) return {
            errors: [
                createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractRange)
            ]
        };
        const node = refineNode(start);
        const errors = checkRootNode(node) || checkNode(node);
        if (errors) return {
            errors: errors
        };
        return {
            targetRange: {
                range: getStatementOrExpressionRange(node),
                facts: rangeFacts,
                thisNode: thisNode
            }
        };
        function refineNode(node2) {
            if (isReturnStatement(node2)) {
                if (node2.expression) return node2.expression;
            } else if (isVariableStatement(node2) || isVariableDeclarationList(node2)) {
                const declarations = isVariableStatement(node2) ? node2.declarationList.declarations : node2.declarations;
                let numInitializers = 0;
                let lastInitializer;
                for (const declaration of declarations)if (declaration.initializer) {
                    numInitializers++;
                    lastInitializer = declaration.initializer;
                }
                if (numInitializers === 1) return lastInitializer;
            } else if (isVariableDeclaration(node2)) {
                if (node2.initializer) return node2.initializer;
            }
            return node2;
        }
        function checkRootNode(node2) {
            if (isIdentifier(isExpressionStatement(node2) ? node2.expression : node2)) return [
                createDiagnosticForNode(node2, Messages.cannotExtractIdentifier)
            ];
            return void 0;
        }
        function checkForStaticContext(nodeToCheck, containingClass) {
            let current = nodeToCheck;
            while(current !== containingClass){
                if (current.kind === 171 /* PropertyDeclaration */ ) {
                    if (isStatic(current)) rangeFacts |= 32 /* InStaticRegion */ ;
                    break;
                } else if (current.kind === 168 /* Parameter */ ) {
                    const ctorOrMethod = getContainingFunction(current);
                    if (ctorOrMethod.kind === 175 /* Constructor */ ) rangeFacts |= 32 /* InStaticRegion */ ;
                    break;
                } else if (current.kind === 173 /* MethodDeclaration */ ) {
                    if (isStatic(current)) rangeFacts |= 32 /* InStaticRegion */ ;
                }
                current = current.parent;
            }
        }
        function checkNode(nodeToCheck) {
            let PermittedJumps;
            ((PermittedJumps2)=>{
                PermittedJumps2[PermittedJumps2["None"] = 0] = "None";
                PermittedJumps2[PermittedJumps2["Break"] = 1] = "Break";
                PermittedJumps2[PermittedJumps2["Continue"] = 2] = "Continue";
                PermittedJumps2[PermittedJumps2["Return"] = 4] = "Return";
            })(PermittedJumps || (PermittedJumps = {}));
            Debug.assert(nodeToCheck.pos <= nodeToCheck.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809 (1)");
            Debug.assert(!positionIsSynthesized(nodeToCheck.pos), "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809 (2)");
            if (!isStatement(nodeToCheck) && !(isExpressionNode(nodeToCheck) && isExtractableExpression(nodeToCheck)) && !isStringLiteralJsxAttribute(nodeToCheck)) return [
                createDiagnosticForNode(nodeToCheck, Messages.statementOrExpressionExpected)
            ];
            if (nodeToCheck.flags & 16777216 /* Ambient */ ) return [
                createDiagnosticForNode(nodeToCheck, Messages.cannotExtractAmbientBlock)
            ];
            const containingClass = getContainingClass(nodeToCheck);
            if (containingClass) checkForStaticContext(nodeToCheck, containingClass);
            let errors2;
            let permittedJumps = 4 /* Return */ ;
            let seenLabels;
            visit(nodeToCheck);
            if (rangeFacts & 8 /* UsesThis */ ) {
                const container = getThisContainer(nodeToCheck, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                if (container.kind === 261 /* FunctionDeclaration */  || container.kind === 173 /* MethodDeclaration */  && container.parent.kind === 209 /* ObjectLiteralExpression */  || container.kind === 217 /* FunctionExpression */ ) rangeFacts |= 16 /* UsesThisInFunction */ ;
            }
            return errors2;
            function visit(node2) {
                if (errors2) return true;
                if (isDeclaration(node2)) {
                    const declaringNode = node2.kind === 259 /* VariableDeclaration */  ? node2.parent.parent : node2;
                    if (hasSyntacticModifier(declaringNode, 1 /* Export */ )) {
                        (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractExportedEntity));
                        return true;
                    }
                }
                switch(node2.kind){
                    case 271 /* ImportDeclaration */ :
                        (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractImport));
                        return true;
                    case 276 /* ExportAssignment */ :
                        (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractExportedEntity));
                        return true;
                    case 108 /* SuperKeyword */ :
                        if (node2.parent.kind === 212 /* CallExpression */ ) {
                            const containingClass2 = getContainingClass(node2);
                            if (containingClass2 === void 0 || containingClass2.pos < span.start || containingClass2.end >= span.start + span.length) {
                                (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractSuper));
                                return true;
                            }
                        } else {
                            rangeFacts |= 8 /* UsesThis */ ;
                            thisNode = node2;
                        }
                        break;
                    case 218 /* ArrowFunction */ :
                        forEachChild(node2, function check(n) {
                            if (isThis(n)) {
                                rangeFacts |= 8 /* UsesThis */ ;
                                thisNode = node2;
                            } else if (isClassLike(n) || isFunctionLike(n) && !isArrowFunction(n)) return false;
                            else forEachChild(n, check);
                        });
                    case 262 /* ClassDeclaration */ :
                    case 261 /* FunctionDeclaration */ :
                        if (isSourceFile(node2.parent) && node2.parent.externalModuleIndicator === void 0) (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.functionWillNotBeVisibleInTheNewScope));
                    case 230 /* ClassExpression */ :
                    case 217 /* FunctionExpression */ :
                    case 173 /* MethodDeclaration */ :
                    case 175 /* Constructor */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                        return false;
                }
                const savedPermittedJumps = permittedJumps;
                switch(node2.kind){
                    case 244 /* IfStatement */ :
                        permittedJumps &= -5 /* Return */ ;
                        break;
                    case 257 /* TryStatement */ :
                        permittedJumps = 0 /* None */ ;
                        break;
                    case 240 /* Block */ :
                        if (node2.parent && node2.parent.kind === 257 /* TryStatement */  && node2.parent.finallyBlock === node2) permittedJumps = 4 /* Return */ ;
                        break;
                    case 296 /* DefaultClause */ :
                    case 295 /* CaseClause */ :
                        permittedJumps |= 1 /* Break */ ;
                        break;
                    default:
                        if (isIterationStatement(node2, /*lookInLabeledStatements*/ false)) permittedJumps |= 3 /* Continue */ ;
                        break;
                }
                switch(node2.kind){
                    case 196 /* ThisType */ :
                    case 110 /* ThisKeyword */ :
                        rangeFacts |= 8 /* UsesThis */ ;
                        thisNode = node2;
                        break;
                    case 255 /* LabeledStatement */ :
                        {
                            const label = node2.label;
                            (seenLabels || (seenLabels = [])).push(label.escapedText);
                            forEachChild(node2, visit);
                            seenLabels.pop();
                            break;
                        }
                    case 251 /* BreakStatement */ :
                    case 250 /* ContinueStatement */ :
                        {
                            const label = node2.label;
                            if (label) {
                                if (!contains(seenLabels, label.escapedText)) (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractRangeContainingLabeledBreakOrContinueStatementWithTargetOutsideOfTheRange));
                            } else if (!(permittedJumps & (node2.kind === 251 /* BreakStatement */  ? 1 /* Break */  : 2 /* Continue */ ))) (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractRangeContainingConditionalBreakOrContinueStatements));
                            break;
                        }
                    case 222 /* AwaitExpression */ :
                        rangeFacts |= 4 /* IsAsyncFunction */ ;
                        break;
                    case 228 /* YieldExpression */ :
                        rangeFacts |= 2 /* IsGenerator */ ;
                        break;
                    case 252 /* ReturnStatement */ :
                        if (permittedJumps & 4 /* Return */ ) rangeFacts |= 1 /* HasReturn */ ;
                        else (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractRangeContainingConditionalReturnStatement));
                        break;
                    default:
                        forEachChild(node2, visit);
                        break;
                }
                permittedJumps = savedPermittedJumps;
            }
        }
    }
    function getAdjustedSpanFromNodes(startNode2, endNode2, sourceFile) {
        const start = startNode2.getStart(sourceFile);
        let end = endNode2.getEnd();
        if (sourceFile.text.charCodeAt(end) === 59 /* semicolon */ ) end++;
        return {
            start: start,
            length: end - start
        };
    }
    function getStatementOrExpressionRange(node) {
        if (isStatement(node)) return [
            node
        ];
        if (isExpressionNode(node)) return isExpressionStatement(node.parent) ? [
            node.parent
        ] : node;
        if (isStringLiteralJsxAttribute(node)) return node;
        return void 0;
    }
    function isScope(node) {
        return isArrowFunction(node) ? isFunctionBody(node.body) : isFunctionLikeDeclaration(node) || isSourceFile(node) || isModuleBlock(node) || isClassLike(node);
    }
    function collectEnclosingScopes(range) {
        let current = isReadonlyArray(range.range) ? first(range.range) : range.range;
        if (range.facts & 8 /* UsesThis */  && !(range.facts & 16 /* UsesThisInFunction */ )) {
            const containingClass = getContainingClass(current);
            if (containingClass) {
                const containingFunction = findAncestor(current, isFunctionLikeDeclaration);
                return containingFunction ? [
                    containingFunction,
                    containingClass
                ] : [
                    containingClass
                ];
            }
        }
        const scopes = [];
        while(true){
            current = current.parent;
            if (current.kind === 168 /* Parameter */ ) current = findAncestor(current, (parent2)=>isFunctionLikeDeclaration(parent2)).parent;
            if (isScope(current)) {
                scopes.push(current);
                if (current.kind === 311 /* SourceFile */ ) return scopes;
            }
        }
    }
    function getFunctionExtractionAtIndex(targetRange, context, requestedChangesIndex) {
        const { scopes: scopes , readsAndWrites: { target: target , usagesPerScope: usagesPerScope , functionErrorsPerScope: functionErrorsPerScope , exposedVariableDeclarations: exposedVariableDeclarations  }  } = getPossibleExtractionsWorker(targetRange, context);
        Debug.assert(!functionErrorsPerScope[requestedChangesIndex].length, "The extraction went missing? How?");
        context.cancellationToken.throwIfCancellationRequested();
        return extractFunctionInScope(target, scopes[requestedChangesIndex], usagesPerScope[requestedChangesIndex], exposedVariableDeclarations, targetRange, context);
    }
    function getConstantExtractionAtIndex(targetRange, context, requestedChangesIndex) {
        const { scopes: scopes , readsAndWrites: { target: target , usagesPerScope: usagesPerScope , constantErrorsPerScope: constantErrorsPerScope , exposedVariableDeclarations: exposedVariableDeclarations  }  } = getPossibleExtractionsWorker(targetRange, context);
        Debug.assert(!constantErrorsPerScope[requestedChangesIndex].length, "The extraction went missing? How?");
        Debug.assert(exposedVariableDeclarations.length === 0, "Extract constant accepted a range containing a variable declaration?");
        context.cancellationToken.throwIfCancellationRequested();
        const expression = isExpression(target) ? target : target.statements[0].expression;
        return extractConstantInScope(expression, scopes[requestedChangesIndex], usagesPerScope[requestedChangesIndex], targetRange.facts, context);
    }
    function getPossibleExtractions(targetRange, context) {
        const { scopes: scopes , readsAndWrites: { functionErrorsPerScope: functionErrorsPerScope , constantErrorsPerScope: constantErrorsPerScope  }  } = getPossibleExtractionsWorker(targetRange, context);
        const extractions = scopes.map((scope, i)=>{
            const functionDescriptionPart = getDescriptionForFunctionInScope(scope);
            const constantDescriptionPart = getDescriptionForConstantInScope(scope);
            const scopeDescription = isFunctionLikeDeclaration(scope) ? getDescriptionForFunctionLikeDeclaration(scope) : isClassLike(scope) ? getDescriptionForClassLikeDeclaration(scope) : getDescriptionForModuleLikeDeclaration(scope);
            let functionDescription;
            let constantDescription;
            if (scopeDescription === 1 /* Global */ ) {
                functionDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1_scope), [
                    functionDescriptionPart,
                    "global"
                ]);
                constantDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1_scope), [
                    constantDescriptionPart,
                    "global"
                ]);
            } else if (scopeDescription === 0 /* Module */ ) {
                functionDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1_scope), [
                    functionDescriptionPart,
                    "module"
                ]);
                constantDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1_scope), [
                    constantDescriptionPart,
                    "module"
                ]);
            } else {
                functionDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1), [
                    functionDescriptionPart,
                    scopeDescription
                ]);
                constantDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1), [
                    constantDescriptionPart,
                    scopeDescription
                ]);
            }
            if (i === 0 && !isClassLike(scope)) constantDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_enclosing_scope), [
                constantDescriptionPart
            ]);
            return {
                functionExtraction: {
                    description: functionDescription,
                    errors: functionErrorsPerScope[i]
                },
                constantExtraction: {
                    description: constantDescription,
                    errors: constantErrorsPerScope[i]
                }
            };
        });
        return extractions;
    }
    function getPossibleExtractionsWorker(targetRange, context) {
        const { file: sourceFile  } = context;
        const scopes = collectEnclosingScopes(targetRange);
        const enclosingTextRange = getEnclosingTextRange(targetRange, sourceFile);
        const readsAndWrites = collectReadsAndWrites(targetRange, scopes, enclosingTextRange, sourceFile, context.program.getTypeChecker(), context.cancellationToken);
        return {
            scopes: scopes,
            readsAndWrites: readsAndWrites
        };
    }
    function getDescriptionForFunctionInScope(scope) {
        return isFunctionLikeDeclaration(scope) ? "inner function" : isClassLike(scope) ? "method" : "function";
    }
    function getDescriptionForConstantInScope(scope) {
        return isClassLike(scope) ? "readonly field" : "constant";
    }
    function getDescriptionForFunctionLikeDeclaration(scope) {
        switch(scope.kind){
            case 175 /* Constructor */ :
                return "constructor";
            case 217 /* FunctionExpression */ :
            case 261 /* FunctionDeclaration */ :
                return scope.name ? `function '${scope.name.text}'` : ANONYMOUS;
            case 218 /* ArrowFunction */ :
                return "arrow function";
            case 173 /* MethodDeclaration */ :
                return `method '${scope.name.getText()}'`;
            case 176 /* GetAccessor */ :
                return `'get ${scope.name.getText()}'`;
            case 177 /* SetAccessor */ :
                return `'set ${scope.name.getText()}'`;
            default:
                Debug.assertNever(scope, `Unexpected scope kind ${scope.kind}`);
        }
    }
    function getDescriptionForClassLikeDeclaration(scope) {
        return scope.kind === 262 /* ClassDeclaration */  ? scope.name ? `class '${scope.name.text}'` : "anonymous class declaration" : scope.name ? `class expression '${scope.name.text}'` : "anonymous class expression";
    }
    function getDescriptionForModuleLikeDeclaration(scope) {
        return scope.kind === 267 /* ModuleBlock */  ? `namespace '${scope.parent.name.getText()}'` : scope.externalModuleIndicator ? 0 /* Module */  : 1 /* Global */ ;
    }
    function extractFunctionInScope(node, scope, { usages: usagesInScope , typeParameterUsages: typeParameterUsages , substitutions: substitutions  }, exposedVariableDeclarations, range, context) {
        const checker = context.program.getTypeChecker();
        const scriptTarget = getEmitScriptTarget(context.program.getCompilerOptions());
        const importAdder = ts_codefix_exports.createImportAdder(context.file, context.program, context.preferences, context.host);
        const file = scope.getSourceFile();
        const functionNameText = getUniqueName(isClassLike(scope) ? "newMethod" : "newFunction", file);
        const isJS = isInJSFile(scope);
        const functionName = factory.createIdentifier(functionNameText);
        let returnType;
        const parameters = [];
        const callArguments = [];
        let writes;
        usagesInScope.forEach((usage, name)=>{
            let typeNode;
            if (!isJS) {
                let type = checker.getTypeOfSymbolAtLocation(usage.symbol, usage.node);
                type = checker.getBaseTypeOfLiteralType(type);
                typeNode = ts_codefix_exports.typeToAutoImportableTypeNode(checker, importAdder, type, scope, scriptTarget, 1 /* NoTruncation */ );
            }
            const paramDecl = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ name, /*questionToken*/ void 0, typeNode);
            parameters.push(paramDecl);
            if (usage.usage === 2 /* Write */ ) (writes || (writes = [])).push(usage);
            callArguments.push(factory.createIdentifier(name));
        });
        const typeParametersAndDeclarations = arrayFrom(typeParameterUsages.values(), (type)=>({
                type: type,
                declaration: getFirstDeclarationBeforePosition(type, context.startPosition)
            }));
        const sortedTypeParametersAndDeclarations = typeParametersAndDeclarations.sort(compareTypesByDeclarationOrder);
        const typeParameters = sortedTypeParametersAndDeclarations.length === 0 ? void 0 : mapDefined(sortedTypeParametersAndDeclarations, ({ declaration: declaration  })=>declaration);
        const callTypeArguments = typeParameters !== void 0 ? typeParameters.map((decl)=>factory.createTypeReferenceNode(decl.name, /*typeArguments*/ void 0)) : void 0;
        if (isExpression(node) && !isJS) {
            const contextualType = checker.getContextualType(node);
            returnType = checker.typeToTypeNode(contextualType, scope, 1 /* NoTruncation */ );
        }
        const { body: body , returnValueProperty: returnValueProperty  } = transformFunctionBody(node, exposedVariableDeclarations, writes, substitutions, !!(range.facts & 1 /* HasReturn */ ));
        suppressLeadingAndTrailingTrivia(body);
        let newFunction;
        const callThis = !!(range.facts & 16 /* UsesThisInFunction */ );
        if (isClassLike(scope)) {
            const modifiers = isJS ? [] : [
                factory.createModifier(123 /* PrivateKeyword */ )
            ];
            if (range.facts & 32 /* InStaticRegion */ ) modifiers.push(factory.createModifier(126 /* StaticKeyword */ ));
            if (range.facts & 4 /* IsAsyncFunction */ ) modifiers.push(factory.createModifier(134 /* AsyncKeyword */ ));
            newFunction = factory.createMethodDeclaration(modifiers.length ? modifiers : void 0, range.facts & 2 /* IsGenerator */  ? factory.createToken(42 /* AsteriskToken */ ) : void 0, functionName, /*questionToken*/ void 0, typeParameters, parameters, returnType, body);
        } else {
            if (callThis) parameters.unshift(factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ "this", /*questionToken*/ void 0, checker.typeToTypeNode(checker.getTypeAtLocation(range.thisNode), scope, 1 /* NoTruncation */ ), /*initializer*/ void 0));
            newFunction = factory.createFunctionDeclaration(range.facts & 4 /* IsAsyncFunction */  ? [
                factory.createToken(134 /* AsyncKeyword */ )
            ] : void 0, range.facts & 2 /* IsGenerator */  ? factory.createToken(42 /* AsteriskToken */ ) : void 0, functionName, typeParameters, parameters, returnType, body);
        }
        const changeTracker = ts_textChanges_exports.ChangeTracker.fromContext(context);
        const minInsertionPos = (isReadonlyArray(range.range) ? last(range.range) : range.range).end;
        const nodeToInsertBefore = getNodeToInsertFunctionBefore(minInsertionPos, scope);
        if (nodeToInsertBefore) changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newFunction, /*blankLineBetween*/ true);
        else changeTracker.insertNodeAtEndOfScope(context.file, scope, newFunction);
        importAdder.writeFixes(changeTracker);
        const newNodes = [];
        const called = getCalledExpression(scope, range, functionNameText);
        if (callThis) callArguments.unshift(factory.createIdentifier("this"));
        let call = factory.createCallExpression(callThis ? factory.createPropertyAccessExpression(called, "call") : called, callTypeArguments, // Note that no attempt is made to take advantage of type argument inference
        callArguments);
        if (range.facts & 2 /* IsGenerator */ ) call = factory.createYieldExpression(factory.createToken(42 /* AsteriskToken */ ), call);
        if (range.facts & 4 /* IsAsyncFunction */ ) call = factory.createAwaitExpression(call);
        if (isInJSXContent(node)) call = factory.createJsxExpression(/*dotDotDotToken*/ void 0, call);
        if (exposedVariableDeclarations.length && !writes) {
            Debug.assert(!returnValueProperty, "Expected no returnValueProperty");
            Debug.assert(!(range.facts & 1 /* HasReturn */ ), "Expected RangeFacts.HasReturn flag to be unset");
            if (exposedVariableDeclarations.length === 1) {
                const variableDeclaration = exposedVariableDeclarations[0];
                newNodes.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    factory.createVariableDeclaration(getSynthesizedDeepClone(variableDeclaration.name), /*exclamationToken*/ void 0, /*type*/ getSynthesizedDeepClone(variableDeclaration.type), /*initializer*/ call)
                ], variableDeclaration.parent.flags)));
            } else {
                const bindingElements = [];
                const typeElements = [];
                let commonNodeFlags = exposedVariableDeclarations[0].parent.flags;
                let sawExplicitType = false;
                for (const variableDeclaration of exposedVariableDeclarations){
                    bindingElements.push(factory.createBindingElement(/*dotDotDotToken*/ void 0, /*propertyName*/ void 0, /*name*/ getSynthesizedDeepClone(variableDeclaration.name)));
                    const variableType = checker.typeToTypeNode(checker.getBaseTypeOfLiteralType(checker.getTypeAtLocation(variableDeclaration)), scope, 1 /* NoTruncation */ );
                    typeElements.push(factory.createPropertySignature(/*modifiers*/ void 0, /*name*/ variableDeclaration.symbol.name, /*questionToken*/ void 0, /*type*/ variableType));
                    sawExplicitType = sawExplicitType || variableDeclaration.type !== void 0;
                    commonNodeFlags = commonNodeFlags & variableDeclaration.parent.flags;
                }
                const typeLiteral = sawExplicitType ? factory.createTypeLiteralNode(typeElements) : void 0;
                if (typeLiteral) setEmitFlags(typeLiteral, 1 /* SingleLine */ );
                newNodes.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    factory.createVariableDeclaration(factory.createObjectBindingPattern(bindingElements), /*exclamationToken*/ void 0, /*type*/ typeLiteral, /*initializer*/ call)
                ], commonNodeFlags)));
            }
        } else if (exposedVariableDeclarations.length || writes) {
            if (exposedVariableDeclarations.length) for (const variableDeclaration of exposedVariableDeclarations){
                let flags = variableDeclaration.parent.flags;
                if (flags & 2 /* Const */ ) flags = flags & -3 /* Const */  | 1 /* Let */ ;
                newNodes.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    factory.createVariableDeclaration(variableDeclaration.symbol.name, /*exclamationToken*/ void 0, getTypeDeepCloneUnionUndefined(variableDeclaration.type))
                ], flags)));
            }
            if (returnValueProperty) newNodes.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                factory.createVariableDeclaration(returnValueProperty, /*exclamationToken*/ void 0, getTypeDeepCloneUnionUndefined(returnType))
            ], 1 /* Let */ )));
            const assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
            if (returnValueProperty) assignments.unshift(factory.createShorthandPropertyAssignment(returnValueProperty));
            if (assignments.length === 1) {
                Debug.assert(!returnValueProperty, "Shouldn't have returnValueProperty here");
                newNodes.push(factory.createExpressionStatement(factory.createAssignment(assignments[0].name, call)));
                if (range.facts & 1 /* HasReturn */ ) newNodes.push(factory.createReturnStatement());
            } else {
                newNodes.push(factory.createExpressionStatement(factory.createAssignment(factory.createObjectLiteralExpression(assignments), call)));
                if (returnValueProperty) newNodes.push(factory.createReturnStatement(factory.createIdentifier(returnValueProperty)));
            }
        } else {
            if (range.facts & 1 /* HasReturn */ ) newNodes.push(factory.createReturnStatement(call));
            else if (isReadonlyArray(range.range)) newNodes.push(factory.createExpressionStatement(call));
            else newNodes.push(call);
        }
        if (isReadonlyArray(range.range)) changeTracker.replaceNodeRangeWithNodes(context.file, first(range.range), last(range.range), newNodes);
        else changeTracker.replaceNodeWithNodes(context.file, range.range, newNodes);
        const edits = changeTracker.getChanges();
        const renameRange = isReadonlyArray(range.range) ? first(range.range) : range.range;
        const renameFilename = renameRange.getSourceFile().fileName;
        const renameLocation = getRenameLocation(edits, renameFilename, functionNameText, /*preferLastLocation*/ false);
        return {
            renameFilename: renameFilename,
            renameLocation: renameLocation,
            edits: edits
        };
        function getTypeDeepCloneUnionUndefined(typeNode) {
            if (typeNode === void 0) return void 0;
            const clone2 = getSynthesizedDeepClone(typeNode);
            let withoutParens = clone2;
            while(isParenthesizedTypeNode(withoutParens))withoutParens = withoutParens.type;
            return isUnionTypeNode(withoutParens) && find(withoutParens.types, (t)=>t.kind === 157 /* UndefinedKeyword */ ) ? clone2 : factory.createUnionTypeNode([
                clone2,
                factory.createKeywordTypeNode(157 /* UndefinedKeyword */ )
            ]);
        }
    }
    function extractConstantInScope(node, scope, { substitutions: substitutions  }, rangeFacts, context) {
        const checker = context.program.getTypeChecker();
        const file = scope.getSourceFile();
        const localNameText = isPropertyAccessExpression(node) && !isClassLike(scope) && !checker.resolveName(node.name.text, node, 111551 /* Value */ , /*excludeGlobals*/ false) && !isPrivateIdentifier(node.name) && !identifierToKeywordKind(node.name) ? node.name.text : getUniqueName(isClassLike(scope) ? "newProperty" : "newLocal", file);
        const isJS = isInJSFile(scope);
        let variableType = isJS || !checker.isContextSensitive(node) ? void 0 : checker.typeToTypeNode(checker.getContextualType(node), scope, 1 /* NoTruncation */ );
        let initializer = transformConstantInitializer(skipParentheses(node), substitutions);
        ({ variableType: variableType , initializer: initializer  } = transformFunctionInitializerAndType(variableType, initializer));
        suppressLeadingAndTrailingTrivia(initializer);
        const changeTracker = ts_textChanges_exports.ChangeTracker.fromContext(context);
        if (isClassLike(scope)) {
            Debug.assert(!isJS, "Cannot extract to a JS class");
            const modifiers = [];
            modifiers.push(factory.createModifier(123 /* PrivateKeyword */ ));
            if (rangeFacts & 32 /* InStaticRegion */ ) modifiers.push(factory.createModifier(126 /* StaticKeyword */ ));
            modifiers.push(factory.createModifier(148 /* ReadonlyKeyword */ ));
            const newVariable = factory.createPropertyDeclaration(modifiers, localNameText, /*questionOrExclamationToken*/ void 0, variableType, initializer);
            let localReference = factory.createPropertyAccessExpression(rangeFacts & 32 /* InStaticRegion */  ? factory.createIdentifier(scope.name.getText()) : factory.createThis(), factory.createIdentifier(localNameText));
            if (isInJSXContent(node)) localReference = factory.createJsxExpression(/*dotDotDotToken*/ void 0, localReference);
            const maxInsertionPos = node.pos;
            const nodeToInsertBefore = getNodeToInsertPropertyBefore(maxInsertionPos, scope);
            changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newVariable, /*blankLineBetween*/ true);
            changeTracker.replaceNode(context.file, node, localReference);
        } else {
            const newVariableDeclaration = factory.createVariableDeclaration(localNameText, /*exclamationToken*/ void 0, variableType, initializer);
            const oldVariableDeclaration = getContainingVariableDeclarationIfInList(node, scope);
            if (oldVariableDeclaration) {
                changeTracker.insertNodeBefore(context.file, oldVariableDeclaration, newVariableDeclaration);
                const localReference = factory.createIdentifier(localNameText);
                changeTracker.replaceNode(context.file, node, localReference);
            } else if (node.parent.kind === 243 /* ExpressionStatement */  && scope === findAncestor(node, isScope)) {
                const newVariableStatement = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    newVariableDeclaration
                ], 2 /* Const */ ));
                changeTracker.replaceNode(context.file, node.parent, newVariableStatement);
            } else {
                const newVariableStatement = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    newVariableDeclaration
                ], 2 /* Const */ ));
                const nodeToInsertBefore = getNodeToInsertConstantBefore(node, scope);
                if (nodeToInsertBefore.pos === 0) changeTracker.insertNodeAtTopOfFile(context.file, newVariableStatement, /*blankLineBetween*/ false);
                else changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newVariableStatement, /*blankLineBetween*/ false);
                if (node.parent.kind === 243 /* ExpressionStatement */ ) changeTracker.delete(context.file, node.parent);
                else {
                    let localReference = factory.createIdentifier(localNameText);
                    if (isInJSXContent(node)) localReference = factory.createJsxExpression(/*dotDotDotToken*/ void 0, localReference);
                    changeTracker.replaceNode(context.file, node, localReference);
                }
            }
        }
        const edits = changeTracker.getChanges();
        const renameFilename = node.getSourceFile().fileName;
        const renameLocation = getRenameLocation(edits, renameFilename, localNameText, /*preferLastLocation*/ true);
        return {
            renameFilename: renameFilename,
            renameLocation: renameLocation,
            edits: edits
        };
        function transformFunctionInitializerAndType(variableType2, initializer2) {
            if (variableType2 === void 0) return {
                variableType: variableType2,
                initializer: initializer2
            };
            if (!isFunctionExpression(initializer2) && !isArrowFunction(initializer2) || !!initializer2.typeParameters) return {
                variableType: variableType2,
                initializer: initializer2
            };
            const functionType = checker.getTypeAtLocation(node);
            const functionSignature = singleOrUndefined(checker.getSignaturesOfType(functionType, 0 /* Call */ ));
            if (!functionSignature) return {
                variableType: variableType2,
                initializer: initializer2
            };
            if (!!functionSignature.getTypeParameters()) return {
                variableType: variableType2,
                initializer: initializer2
            };
            const parameters = [];
            let hasAny = false;
            for (const p of initializer2.parameters)if (p.type) parameters.push(p);
            else {
                const paramType = checker.getTypeAtLocation(p);
                if (paramType === checker.getAnyType()) hasAny = true;
                parameters.push(factory.updateParameterDeclaration(p, p.modifiers, p.dotDotDotToken, p.name, p.questionToken, p.type || checker.typeToTypeNode(paramType, scope, 1 /* NoTruncation */ ), p.initializer));
            }
            if (hasAny) return {
                variableType: variableType2,
                initializer: initializer2
            };
            variableType2 = void 0;
            if (isArrowFunction(initializer2)) initializer2 = factory.updateArrowFunction(initializer2, canHaveModifiers(node) ? getModifiers(node) : void 0, initializer2.typeParameters, parameters, initializer2.type || checker.typeToTypeNode(functionSignature.getReturnType(), scope, 1 /* NoTruncation */ ), initializer2.equalsGreaterThanToken, initializer2.body);
            else {
                if (functionSignature && !!functionSignature.thisParameter) {
                    const firstParameter = firstOrUndefined(parameters);
                    if (!firstParameter || isIdentifier(firstParameter.name) && firstParameter.name.escapedText !== "this") {
                        const thisType = checker.getTypeOfSymbolAtLocation(functionSignature.thisParameter, node);
                        parameters.splice(0, 0, factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "this", /*questionToken*/ void 0, checker.typeToTypeNode(thisType, scope, 1 /* NoTruncation */ )));
                    }
                }
                initializer2 = factory.updateFunctionExpression(initializer2, canHaveModifiers(node) ? getModifiers(node) : void 0, initializer2.asteriskToken, initializer2.name, initializer2.typeParameters, parameters, initializer2.type || checker.typeToTypeNode(functionSignature.getReturnType(), scope, 1 /* NoTruncation */ ), initializer2.body);
            }
            return {
                variableType: variableType2,
                initializer: initializer2
            };
        }
    }
    function getContainingVariableDeclarationIfInList(node, scope) {
        let prevNode;
        while(node !== void 0 && node !== scope){
            if (isVariableDeclaration(node) && node.initializer === prevNode && isVariableDeclarationList(node.parent) && node.parent.declarations.length > 1) return node;
            prevNode = node;
            node = node.parent;
        }
    }
    function getFirstDeclarationBeforePosition(type, position) {
        let firstDeclaration;
        const symbol = type.symbol;
        if (symbol && symbol.declarations) {
            for (const declaration of symbol.declarations)if ((firstDeclaration === void 0 || declaration.pos < firstDeclaration.pos) && declaration.pos < position) firstDeclaration = declaration;
        }
        return firstDeclaration;
    }
    function compareTypesByDeclarationOrder({ type: type1 , declaration: declaration1  }, { type: type2 , declaration: declaration2  }) {
        return compareProperties(declaration1, declaration2, "pos", compareValues) || compareStringsCaseSensitive(type1.symbol ? type1.symbol.getName() : "", type2.symbol ? type2.symbol.getName() : "") || compareValues(type1.id, type2.id);
    }
    function getCalledExpression(scope, range, functionNameText) {
        const functionReference = factory.createIdentifier(functionNameText);
        if (isClassLike(scope)) {
            const lhs = range.facts & 32 /* InStaticRegion */  ? factory.createIdentifier(scope.name.text) : factory.createThis();
            return factory.createPropertyAccessExpression(lhs, functionReference);
        } else return functionReference;
    }
    function transformFunctionBody(body, exposedVariableDeclarations, writes, substitutions, hasReturn2) {
        const hasWritesOrVariableDeclarations = writes !== void 0 || exposedVariableDeclarations.length > 0;
        if (isBlock(body) && !hasWritesOrVariableDeclarations && substitutions.size === 0) return {
            body: factory.createBlock(body.statements, /*multiLine*/ true),
            returnValueProperty: void 0
        };
        let returnValueProperty;
        let ignoreReturns = false;
        const statements = factory.createNodeArray(isBlock(body) ? body.statements.slice(0) : [
            isStatement(body) ? body : factory.createReturnStatement(skipParentheses(body))
        ]);
        if (hasWritesOrVariableDeclarations || substitutions.size) {
            const rewrittenStatements = visitNodes2(statements, visitor, isStatement).slice();
            if (hasWritesOrVariableDeclarations && !hasReturn2 && isStatement(body)) {
                const assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
                if (assignments.length === 1) rewrittenStatements.push(factory.createReturnStatement(assignments[0].name));
                else rewrittenStatements.push(factory.createReturnStatement(factory.createObjectLiteralExpression(assignments)));
            }
            return {
                body: factory.createBlock(rewrittenStatements, /*multiLine*/ true),
                returnValueProperty: returnValueProperty
            };
        } else return {
            body: factory.createBlock(statements, /*multiLine*/ true),
            returnValueProperty: void 0
        };
        function visitor(node) {
            if (!ignoreReturns && isReturnStatement(node) && hasWritesOrVariableDeclarations) {
                const assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
                if (node.expression) {
                    if (!returnValueProperty) returnValueProperty = "__return";
                    assignments.unshift(factory.createPropertyAssignment(returnValueProperty, visitNode(node.expression, visitor, isExpression)));
                }
                if (assignments.length === 1) return factory.createReturnStatement(assignments[0].name);
                else return factory.createReturnStatement(factory.createObjectLiteralExpression(assignments));
            } else {
                const oldIgnoreReturns = ignoreReturns;
                ignoreReturns = ignoreReturns || isFunctionLikeDeclaration(node) || isClassLike(node);
                const substitution = substitutions.get(getNodeId(node).toString());
                const result = substitution ? getSynthesizedDeepClone(substitution) : visitEachChild(node, visitor, nullTransformationContext);
                ignoreReturns = oldIgnoreReturns;
                return result;
            }
        }
    }
    function transformConstantInitializer(initializer, substitutions) {
        return substitutions.size ? visitor(initializer) : initializer;
        function visitor(node) {
            const substitution = substitutions.get(getNodeId(node).toString());
            return substitution ? getSynthesizedDeepClone(substitution) : visitEachChild(node, visitor, nullTransformationContext);
        }
    }
    function getStatementsOrClassElements(scope) {
        if (isFunctionLikeDeclaration(scope)) {
            const body = scope.body;
            if (isBlock(body)) return body.statements;
        } else if (isModuleBlock(scope) || isSourceFile(scope)) return scope.statements;
        else if (isClassLike(scope)) return scope.members;
        else assertType(scope);
        return emptyArray;
    }
    function getNodeToInsertFunctionBefore(minPos, scope) {
        return find(getStatementsOrClassElements(scope), (child)=>child.pos >= minPos && isFunctionLikeDeclaration(child) && !isConstructorDeclaration(child));
    }
    function getNodeToInsertPropertyBefore(maxPos, scope) {
        const members = scope.members;
        Debug.assert(members.length > 0, "Found no members");
        let prevMember;
        let allProperties = true;
        for (const member of members){
            if (member.pos > maxPos) return prevMember || members[0];
            if (allProperties && !isPropertyDeclaration(member)) {
                if (prevMember !== void 0) return member;
                allProperties = false;
            }
            prevMember = member;
        }
        if (prevMember === void 0) return Debug.fail();
        return prevMember;
    }
    function getNodeToInsertConstantBefore(node, scope) {
        Debug.assert(!isClassLike(scope));
        let prevScope;
        for(let curr = node; curr !== scope; curr = curr.parent)if (isScope(curr)) prevScope = curr;
        for(let curr = (prevScope || node).parent;; curr = curr.parent){
            if (isBlockLike(curr)) {
                let prevStatement;
                for (const statement of curr.statements){
                    if (statement.pos > node.pos) break;
                    prevStatement = statement;
                }
                if (!prevStatement && isCaseClause(curr)) {
                    Debug.assert(isSwitchStatement(curr.parent.parent), "Grandparent isn't a switch statement");
                    return curr.parent.parent;
                }
                return Debug.checkDefined(prevStatement, "prevStatement failed to get set");
            }
            Debug.assert(curr !== scope, "Didn't encounter a block-like before encountering scope");
        }
    }
    function getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes) {
        const variableAssignments = map(exposedVariableDeclarations, (v)=>factory.createShorthandPropertyAssignment(v.symbol.name));
        const writeAssignments = map(writes, (w)=>factory.createShorthandPropertyAssignment(w.symbol.name));
        return variableAssignments === void 0 ? writeAssignments : writeAssignments === void 0 ? variableAssignments : variableAssignments.concat(writeAssignments);
    }
    function isReadonlyArray(v) {
        return isArray(v);
    }
    function getEnclosingTextRange(targetRange, sourceFile) {
        return isReadonlyArray(targetRange.range) ? {
            pos: first(targetRange.range).getStart(sourceFile),
            end: last(targetRange.range).getEnd()
        } : targetRange.range;
    }
    function collectReadsAndWrites(targetRange, scopes, enclosingTextRange, sourceFile, checker, cancellationToken) {
        const allTypeParameterUsages = /* @__PURE__ */ new Map();
        const usagesPerScope = [];
        const substitutionsPerScope = [];
        const functionErrorsPerScope = [];
        const constantErrorsPerScope = [];
        const visibleDeclarationsInExtractedRange = [];
        const exposedVariableSymbolSet = /* @__PURE__ */ new Map();
        const exposedVariableDeclarations = [];
        let firstExposedNonVariableDeclaration;
        const expression = !isReadonlyArray(targetRange.range) ? targetRange.range : targetRange.range.length === 1 && isExpressionStatement(targetRange.range[0]) ? targetRange.range[0].expression : void 0;
        let expressionDiagnostic;
        if (expression === void 0) {
            const statements = targetRange.range;
            const start = first(statements).getStart();
            const end = last(statements).end;
            expressionDiagnostic = createFileDiagnostic(sourceFile, start, end - start, Messages.expressionExpected);
        } else if (checker.getTypeAtLocation(expression).flags & 147456 /* Never */ ) expressionDiagnostic = createDiagnosticForNode(expression, Messages.uselessConstantType);
        for (const scope of scopes){
            usagesPerScope.push({
                usages: /* @__PURE__ */ new Map(),
                typeParameterUsages: /* @__PURE__ */ new Map(),
                substitutions: /* @__PURE__ */ new Map()
            });
            substitutionsPerScope.push(/* @__PURE__ */ new Map());
            functionErrorsPerScope.push([]);
            const constantErrors = [];
            if (expressionDiagnostic) constantErrors.push(expressionDiagnostic);
            if (isClassLike(scope) && isInJSFile(scope)) constantErrors.push(createDiagnosticForNode(scope, Messages.cannotExtractToJSClass));
            if (isArrowFunction(scope) && !isBlock(scope.body)) constantErrors.push(createDiagnosticForNode(scope, Messages.cannotExtractToExpressionArrowFunction));
            constantErrorsPerScope.push(constantErrors);
        }
        const seenUsages = /* @__PURE__ */ new Map();
        const target = isReadonlyArray(targetRange.range) ? factory.createBlock(targetRange.range) : targetRange.range;
        const unmodifiedNode = isReadonlyArray(targetRange.range) ? first(targetRange.range) : targetRange.range;
        const inGenericContext = isInGenericContext(unmodifiedNode);
        collectUsages(target);
        if (inGenericContext && !isReadonlyArray(targetRange.range) && !isJsxAttribute(targetRange.range)) {
            const contextualType = checker.getContextualType(targetRange.range);
            recordTypeParameterUsages(contextualType);
        }
        if (allTypeParameterUsages.size > 0) {
            const seenTypeParameterUsages = /* @__PURE__ */ new Map();
            let i = 0;
            for(let curr = unmodifiedNode; curr !== void 0 && i < scopes.length; curr = curr.parent){
                if (curr === scopes[i]) {
                    seenTypeParameterUsages.forEach((typeParameter, id)=>{
                        usagesPerScope[i].typeParameterUsages.set(id, typeParameter);
                    });
                    i++;
                }
                if (isDeclarationWithTypeParameters(curr)) for (const typeParameterDecl of getEffectiveTypeParameterDeclarations(curr)){
                    const typeParameter = checker.getTypeAtLocation(typeParameterDecl);
                    if (allTypeParameterUsages.has(typeParameter.id.toString())) seenTypeParameterUsages.set(typeParameter.id.toString(), typeParameter);
                }
            }
            Debug.assert(i === scopes.length, "Should have iterated all scopes");
        }
        if (visibleDeclarationsInExtractedRange.length) {
            const containingLexicalScopeOfExtraction = isBlockScope(scopes[0], scopes[0].parent) ? scopes[0] : getEnclosingBlockScopeContainer(scopes[0]);
            forEachChild(containingLexicalScopeOfExtraction, checkForUsedDeclarations);
        }
        for(let i = 0; i < scopes.length; i++){
            const scopeUsages = usagesPerScope[i];
            if (i > 0 && (scopeUsages.usages.size > 0 || scopeUsages.typeParameterUsages.size > 0)) {
                const errorNode = isReadonlyArray(targetRange.range) ? targetRange.range[0] : targetRange.range;
                constantErrorsPerScope[i].push(createDiagnosticForNode(errorNode, Messages.cannotAccessVariablesFromNestedScopes));
            }
            if (targetRange.facts & 16 /* UsesThisInFunction */  && isClassLike(scopes[i])) functionErrorsPerScope[i].push(createDiagnosticForNode(targetRange.thisNode, Messages.cannotExtractFunctionsContainingThisToMethod));
            let hasWrite = false;
            let readonlyClassPropertyWrite;
            usagesPerScope[i].usages.forEach((value1)=>{
                if (value1.usage === 2 /* Write */ ) {
                    hasWrite = true;
                    if (value1.symbol.flags & 106500 /* ClassMember */  && value1.symbol.valueDeclaration && hasEffectiveModifier(value1.symbol.valueDeclaration, 64 /* Readonly */ )) readonlyClassPropertyWrite = value1.symbol.valueDeclaration;
                }
            });
            Debug.assert(isReadonlyArray(targetRange.range) || exposedVariableDeclarations.length === 0, "No variable declarations expected if something was extracted");
            if (hasWrite && !isReadonlyArray(targetRange.range)) {
                const diag2 = createDiagnosticForNode(targetRange.range, Messages.cannotWriteInExpression);
                functionErrorsPerScope[i].push(diag2);
                constantErrorsPerScope[i].push(diag2);
            } else if (readonlyClassPropertyWrite && i > 0) {
                const diag2 = createDiagnosticForNode(readonlyClassPropertyWrite, Messages.cannotExtractReadonlyPropertyInitializerOutsideConstructor);
                functionErrorsPerScope[i].push(diag2);
                constantErrorsPerScope[i].push(diag2);
            } else if (firstExposedNonVariableDeclaration) {
                const diag2 = createDiagnosticForNode(firstExposedNonVariableDeclaration, Messages.cannotExtractExportedEntity);
                functionErrorsPerScope[i].push(diag2);
                constantErrorsPerScope[i].push(diag2);
            }
        }
        return {
            target: target,
            usagesPerScope: usagesPerScope,
            functionErrorsPerScope: functionErrorsPerScope,
            constantErrorsPerScope: constantErrorsPerScope,
            exposedVariableDeclarations: exposedVariableDeclarations
        };
        function isInGenericContext(node) {
            return !!findAncestor(node, (n)=>isDeclarationWithTypeParameters(n) && getEffectiveTypeParameterDeclarations(n).length !== 0);
        }
        function recordTypeParameterUsages(type) {
            const symbolWalker = checker.getSymbolWalker(()=>(cancellationToken.throwIfCancellationRequested(), true));
            const { visitedTypes: visitedTypes  } = symbolWalker.walkType(type);
            for (const visitedType of visitedTypes)if (visitedType.isTypeParameter()) allTypeParameterUsages.set(visitedType.id.toString(), visitedType);
        }
        function collectUsages(node, valueUsage = 1 /* Read */ ) {
            if (inGenericContext) {
                const type = checker.getTypeAtLocation(node);
                recordTypeParameterUsages(type);
            }
            if (isDeclaration(node) && node.symbol) visibleDeclarationsInExtractedRange.push(node);
            if (isAssignmentExpression(node)) {
                collectUsages(node.left, 2 /* Write */ );
                collectUsages(node.right);
            } else if (isUnaryExpressionWithWrite(node)) collectUsages(node.operand, 2 /* Write */ );
            else if (isPropertyAccessExpression(node) || isElementAccessExpression(node)) forEachChild(node, collectUsages);
            else if (isIdentifier(node)) {
                if (!node.parent) return;
                if (isQualifiedName(node.parent) && node !== node.parent.left) return;
                if (isPropertyAccessExpression(node.parent) && node !== node.parent.expression) return;
                recordUsage(node, valueUsage, /*isTypeNode*/ isPartOfTypeNode(node));
            } else forEachChild(node, collectUsages);
        }
        function recordUsage(n, usage, isTypeNode2) {
            const symbolId = recordUsagebySymbol(n, usage, isTypeNode2);
            if (symbolId) for(let i = 0; i < scopes.length; i++){
                const substitution = substitutionsPerScope[i].get(symbolId);
                if (substitution) usagesPerScope[i].substitutions.set(getNodeId(n).toString(), substitution);
            }
        }
        function recordUsagebySymbol(identifier, usage, isTypeName) {
            const symbol = getSymbolReferencedByIdentifier(identifier);
            if (!symbol) return void 0;
            const symbolId = getSymbolId(symbol).toString();
            const lastUsage = seenUsages.get(symbolId);
            if (lastUsage && lastUsage >= usage) return symbolId;
            seenUsages.set(symbolId, usage);
            if (lastUsage) {
                for (const perScope of usagesPerScope){
                    const prevEntry = perScope.usages.get(identifier.text);
                    if (prevEntry) perScope.usages.set(identifier.text, {
                        usage: usage,
                        symbol: symbol,
                        node: identifier
                    });
                }
                return symbolId;
            }
            const decls = symbol.getDeclarations();
            const declInFile = decls && find(decls, (d)=>d.getSourceFile() === sourceFile);
            if (!declInFile) return void 0;
            if (rangeContainsStartEnd(enclosingTextRange, declInFile.getStart(), declInFile.end)) return void 0;
            if (targetRange.facts & 2 /* IsGenerator */  && usage === 2 /* Write */ ) {
                const diag2 = createDiagnosticForNode(identifier, Messages.cannotExtractRangeThatContainsWritesToReferencesLocatedOutsideOfTheTargetRangeInGenerators);
                for (const errors of functionErrorsPerScope)errors.push(diag2);
                for (const errors of constantErrorsPerScope)errors.push(diag2);
            }
            for(let i = 0; i < scopes.length; i++){
                const scope = scopes[i];
                const resolvedSymbol = checker.resolveName(symbol.name, scope, symbol.flags, /*excludeGlobals*/ false);
                if (resolvedSymbol === symbol) continue;
                if (!substitutionsPerScope[i].has(symbolId)) {
                    const substitution = tryReplaceWithQualifiedNameOrPropertyAccess(symbol.exportSymbol || symbol, scope, isTypeName);
                    if (substitution) substitutionsPerScope[i].set(symbolId, substitution);
                    else if (isTypeName) {
                        if (!(symbol.flags & 262144 /* TypeParameter */ )) {
                            const diag2 = createDiagnosticForNode(identifier, Messages.typeWillNotBeVisibleInTheNewScope);
                            functionErrorsPerScope[i].push(diag2);
                            constantErrorsPerScope[i].push(diag2);
                        }
                    } else usagesPerScope[i].usages.set(identifier.text, {
                        usage: usage,
                        symbol: symbol,
                        node: identifier
                    });
                }
            }
            return symbolId;
        }
        function checkForUsedDeclarations(node) {
            if (node === targetRange.range || isReadonlyArray(targetRange.range) && targetRange.range.indexOf(node) >= 0) return;
            const sym = isIdentifier(node) ? getSymbolReferencedByIdentifier(node) : checker.getSymbolAtLocation(node);
            if (sym) {
                const decl = find(visibleDeclarationsInExtractedRange, (d)=>d.symbol === sym);
                if (decl) {
                    if (isVariableDeclaration(decl)) {
                        const idString = decl.symbol.id.toString();
                        if (!exposedVariableSymbolSet.has(idString)) {
                            exposedVariableDeclarations.push(decl);
                            exposedVariableSymbolSet.set(idString, true);
                        }
                    } else firstExposedNonVariableDeclaration = firstExposedNonVariableDeclaration || decl;
                }
            }
            forEachChild(node, checkForUsedDeclarations);
        }
        function getSymbolReferencedByIdentifier(identifier) {
            return identifier.parent && isShorthandPropertyAssignment(identifier.parent) && identifier.parent.name === identifier ? checker.getShorthandAssignmentValueSymbol(identifier.parent) : checker.getSymbolAtLocation(identifier);
        }
        function tryReplaceWithQualifiedNameOrPropertyAccess(symbol, scopeDecl, isTypeNode2) {
            if (!symbol) return void 0;
            const decls = symbol.getDeclarations();
            if (decls && decls.some((d)=>d.parent === scopeDecl)) return factory.createIdentifier(symbol.name);
            const prefix = tryReplaceWithQualifiedNameOrPropertyAccess(symbol.parent, scopeDecl, isTypeNode2);
            if (prefix === void 0) return void 0;
            return isTypeNode2 ? factory.createQualifiedName(prefix, factory.createIdentifier(symbol.name)) : factory.createPropertyAccessExpression(prefix, symbol.name);
        }
    }
    function getExtractableParent(node) {
        return findAncestor(node, (node2)=>node2.parent && isExtractableExpression(node2) && !isBinaryExpression(node2.parent));
    }
    function isExtractableExpression(node) {
        const { parent: parent2  } = node;
        switch(parent2.kind){
            case 305 /* EnumMember */ :
                return false;
        }
        switch(node.kind){
            case 11 /* StringLiteral */ :
                return parent2.kind !== 271 /* ImportDeclaration */  && parent2.kind !== 275 /* ImportSpecifier */ ;
            case 229 /* SpreadElement */ :
            case 205 /* ObjectBindingPattern */ :
            case 207 /* BindingElement */ :
                return false;
            case 80 /* Identifier */ :
                return parent2.kind !== 207 /* BindingElement */  && parent2.kind !== 275 /* ImportSpecifier */  && parent2.kind !== 280 /* ExportSpecifier */ ;
        }
        return true;
    }
    function isBlockLike(node) {
        switch(node.kind){
            case 240 /* Block */ :
            case 311 /* SourceFile */ :
            case 267 /* ModuleBlock */ :
            case 295 /* CaseClause */ :
                return true;
            default:
                return false;
        }
    }
    function isInJSXContent(node) {
        return isStringLiteralJsxAttribute(node) || (isJsxElement(node) || isJsxSelfClosingElement(node) || isJsxFragment(node)) && (isJsxElement(node.parent) || isJsxFragment(node.parent));
    }
    function isStringLiteralJsxAttribute(node) {
        return isStringLiteral(node) && node.parent && isJsxAttribute(node.parent);
    }
    var refactorName11, extractConstantAction, extractFunctionAction, Messages, RangeFacts;
    var init_extractSymbol = __esm({
        "src/services/refactors/extractSymbol.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName11 = "Extract Symbol";
            extractConstantAction = {
                name: "Extract Constant",
                description: getLocaleSpecificMessage(Diagnostics.Extract_constant),
                kind: "refactor.extract.constant"
            };
            extractFunctionAction = {
                name: "Extract Function",
                description: getLocaleSpecificMessage(Diagnostics.Extract_function),
                kind: "refactor.extract.function"
            };
            registerRefactor(refactorName11, {
                kinds: [
                    extractConstantAction.kind,
                    extractFunctionAction.kind
                ],
                getEditsForAction: getRefactorEditsToExtractSymbol,
                getAvailableActions: getRefactorActionsToExtractSymbol
            });
            ((Messages2)=>{
                function createMessage(message) {
                    return {
                        message: message,
                        code: 0,
                        category: 3 /* Message */ ,
                        key: message
                    };
                }
                Messages2.cannotExtractRange = createMessage("Cannot extract range.");
                Messages2.cannotExtractImport = createMessage("Cannot extract import statement.");
                Messages2.cannotExtractSuper = createMessage("Cannot extract super call.");
                Messages2.cannotExtractJSDoc = createMessage("Cannot extract JSDoc.");
                Messages2.cannotExtractEmpty = createMessage("Cannot extract empty range.");
                Messages2.expressionExpected = createMessage("expression expected.");
                Messages2.uselessConstantType = createMessage("No reason to extract constant of type.");
                Messages2.statementOrExpressionExpected = createMessage("Statement or expression expected.");
                Messages2.cannotExtractRangeContainingConditionalBreakOrContinueStatements = createMessage("Cannot extract range containing conditional break or continue statements.");
                Messages2.cannotExtractRangeContainingConditionalReturnStatement = createMessage("Cannot extract range containing conditional return statement.");
                Messages2.cannotExtractRangeContainingLabeledBreakOrContinueStatementWithTargetOutsideOfTheRange = createMessage("Cannot extract range containing labeled break or continue with target outside of the range.");
                Messages2.cannotExtractRangeThatContainsWritesToReferencesLocatedOutsideOfTheTargetRangeInGenerators = createMessage("Cannot extract range containing writes to references located outside of the target range in generators.");
                Messages2.typeWillNotBeVisibleInTheNewScope = createMessage("Type will not visible in the new scope.");
                Messages2.functionWillNotBeVisibleInTheNewScope = createMessage("Function will not visible in the new scope.");
                Messages2.cannotExtractIdentifier = createMessage("Select more than a single identifier.");
                Messages2.cannotExtractExportedEntity = createMessage("Cannot extract exported declaration");
                Messages2.cannotWriteInExpression = createMessage("Cannot write back side-effects when extracting an expression");
                Messages2.cannotExtractReadonlyPropertyInitializerOutsideConstructor = createMessage("Cannot move initialization of read-only class property outside of the constructor");
                Messages2.cannotExtractAmbientBlock = createMessage("Cannot extract code from ambient contexts");
                Messages2.cannotAccessVariablesFromNestedScopes = createMessage("Cannot access variables from nested scopes");
                Messages2.cannotExtractToJSClass = createMessage("Cannot extract constant to a class scope in JS");
                Messages2.cannotExtractToExpressionArrowFunction = createMessage("Cannot extract constant to an arrow function without a block");
                Messages2.cannotExtractFunctionsContainingThisToMethod = createMessage("Cannot extract functions containing this to method");
            })(Messages || (Messages = {}));
            RangeFacts = /* @__PURE__ */ ((RangeFacts2)=>{
                RangeFacts2[RangeFacts2["None"] = 0] = "None";
                RangeFacts2[RangeFacts2["HasReturn"] = 1] = "HasReturn";
                RangeFacts2[RangeFacts2["IsGenerator"] = 2] = "IsGenerator";
                RangeFacts2[RangeFacts2["IsAsyncFunction"] = 4] = "IsAsyncFunction";
                RangeFacts2[RangeFacts2["UsesThis"] = 8] = "UsesThis";
                RangeFacts2[RangeFacts2["UsesThisInFunction"] = 16] = "UsesThisInFunction";
                RangeFacts2[RangeFacts2["InStaticRegion"] = 32] = "InStaticRegion";
                return RangeFacts2;
            })(RangeFacts || {});
        }
    });
    // src/services/_namespaces/ts.refactor.extractSymbol.ts
    var ts_refactor_extractSymbol_exports = {};
    __export(ts_refactor_extractSymbol_exports, {
        Messages: ()=>Messages,
        RangeFacts: ()=>RangeFacts,
        getRangeToExtract: ()=>getRangeToExtract2,
        getRefactorActionsToExtractSymbol: ()=>getRefactorActionsToExtractSymbol,
        getRefactorEditsToExtractSymbol: ()=>getRefactorEditsToExtractSymbol
    });
    var init_ts_refactor_extractSymbol = __esm({
        "src/services/_namespaces/ts.refactor.extractSymbol.ts" () {
            "use strict";
            init_extractSymbol();
        }
    });
    // src/services/refactors/generateGetAccessorAndSetAccessor.ts
    var actionName, actionDescription, generateGetSetAction;
    var init_generateGetAccessorAndSetAccessor = __esm({
        "src/services/refactors/generateGetAccessorAndSetAccessor.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            actionName = "Generate 'get' and 'set' accessors";
            actionDescription = Diagnostics.Generate_get_and_set_accessors.message;
            generateGetSetAction = {
                name: actionName,
                description: actionDescription,
                kind: "refactor.rewrite.property.generateAccessors"
            };
            registerRefactor(actionName, {
                kinds: [
                    generateGetSetAction.kind
                ],
                getEditsForAction: function getRefactorActionsToGenerateGetAndSetAccessors(context, actionName2) {
                    if (!context.endPosition) return void 0;
                    const info = ts_codefix_exports.getAccessorConvertiblePropertyAtPosition(context.file, context.program, context.startPosition, context.endPosition);
                    Debug.assert(info && !isRefactorErrorInfo(info), "Expected applicable refactor info");
                    const edits = ts_codefix_exports.generateAccessorFromProperty(context.file, context.program, context.startPosition, context.endPosition, context, actionName2);
                    if (!edits) return void 0;
                    const renameFilename = context.file.fileName;
                    const nameNeedRename = info.renameAccessor ? info.accessorName : info.fieldName;
                    const renameLocationOffset = isIdentifier(nameNeedRename) ? 0 : -1;
                    const renameLocation = renameLocationOffset + getRenameLocation(edits, renameFilename, nameNeedRename.text, /*preferLastLocation*/ isParameter(info.declaration));
                    return {
                        renameFilename: renameFilename,
                        renameLocation: renameLocation,
                        edits: edits
                    };
                },
                getAvailableActions (context) {
                    if (!context.endPosition) return emptyArray;
                    const info = ts_codefix_exports.getAccessorConvertiblePropertyAtPosition(context.file, context.program, context.startPosition, context.endPosition, context.triggerReason === "invoked");
                    if (!info) return emptyArray;
                    if (!isRefactorErrorInfo(info)) return [
                        {
                            name: actionName,
                            description: actionDescription,
                            actions: [
                                generateGetSetAction
                            ]
                        }
                    ];
                    if (context.preferences.provideRefactorNotApplicableReason) return [
                        {
                            name: actionName,
                            description: actionDescription,
                            actions: [
                                {
                                    ...generateGetSetAction,
                                    notApplicableReason: info.error
                                }
                            ]
                        }
                    ];
                    return emptyArray;
                }
            });
        }
    });
    // src/services/_namespaces/ts.refactor.generateGetAccessorAndSetAccessor.ts
    var ts_refactor_generateGetAccessorAndSetAccessor_exports = {};
    var init_ts_refactor_generateGetAccessorAndSetAccessor = __esm({
        "src/services/_namespaces/ts.refactor.generateGetAccessorAndSetAccessor.ts" () {
            "use strict";
            init_generateGetAccessorAndSetAccessor();
        }
    });
    // src/services/refactors/inferFunctionReturnType.ts
    function getRefactorEditsToInferReturnType(context) {
        const info = getInfo4(context);
        if (info && !isRefactorErrorInfo(info)) {
            const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange7(context.file, t, info.declaration, info.returnTypeNode));
            return {
                renameFilename: void 0,
                renameLocation: void 0,
                edits: edits
            };
        }
        return void 0;
    }
    function getRefactorActionsToInferReturnType(context) {
        const info = getInfo4(context);
        if (!info) return emptyArray;
        if (!isRefactorErrorInfo(info)) return [
            {
                name: refactorName12,
                description: refactorDescription6,
                actions: [
                    inferReturnTypeAction
                ]
            }
        ];
        if (context.preferences.provideRefactorNotApplicableReason) return [
            {
                name: refactorName12,
                description: refactorDescription6,
                actions: [
                    {
                        ...inferReturnTypeAction,
                        notApplicableReason: info.error
                    }
                ]
            }
        ];
        return emptyArray;
    }
    function doChange7(sourceFile, changes, declaration, typeNode) {
        const closeParen = findChildOfKind(declaration, 22 /* CloseParenToken */ , sourceFile);
        const needParens = isArrowFunction(declaration) && closeParen === void 0;
        const endNode2 = needParens ? first(declaration.parameters) : closeParen;
        if (endNode2) {
            if (needParens) {
                changes.insertNodeBefore(sourceFile, endNode2, factory.createToken(21 /* OpenParenToken */ ));
                changes.insertNodeAfter(sourceFile, endNode2, factory.createToken(22 /* CloseParenToken */ ));
            }
            changes.insertNodeAt(sourceFile, endNode2.end, typeNode, {
                prefix: ": "
            });
        }
    }
    function getInfo4(context) {
        if (isInJSFile(context.file) || !refactorKindBeginsWith(inferReturnTypeAction.kind, context.kind)) return;
        const token = getTokenAtPosition(context.file, context.startPosition);
        const declaration = findAncestor(token, (n)=>isBlock(n) || n.parent && isArrowFunction(n.parent) && (n.kind === 39 /* EqualsGreaterThanToken */  || n.parent.body === n) ? "quit" : isConvertibleDeclaration(n));
        if (!declaration || !declaration.body || declaration.type) return {
            error: getLocaleSpecificMessage(Diagnostics.Return_type_must_be_inferred_from_a_function)
        };
        const typeChecker = context.program.getTypeChecker();
        const returnType = tryGetReturnType(typeChecker, declaration);
        if (!returnType) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_determine_function_return_type)
        };
        const returnTypeNode = typeChecker.typeToTypeNode(returnType, declaration, 1 /* NoTruncation */ );
        if (returnTypeNode) return {
            declaration: declaration,
            returnTypeNode: returnTypeNode
        };
    }
    function isConvertibleDeclaration(node) {
        switch(node.kind){
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
            case 173 /* MethodDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function tryGetReturnType(typeChecker, node) {
        if (typeChecker.isImplementationOfOverload(node)) {
            const signatures = typeChecker.getTypeAtLocation(node).getCallSignatures();
            if (signatures.length > 1) return typeChecker.getUnionType(mapDefined(signatures, (s)=>s.getReturnType()));
        }
        const signature = typeChecker.getSignatureFromDeclaration(node);
        if (signature) return typeChecker.getReturnTypeOfSignature(signature);
    }
    var refactorName12, refactorDescription6, inferReturnTypeAction;
    var init_inferFunctionReturnType = __esm({
        "src/services/refactors/inferFunctionReturnType.ts" () {
            "use strict";
            init_ts4();
            init_ts_refactor();
            refactorName12 = "Infer function return type";
            refactorDescription6 = Diagnostics.Infer_function_return_type.message;
            inferReturnTypeAction = {
                name: refactorName12,
                description: refactorDescription6,
                kind: "refactor.rewrite.function.returnType"
            };
            registerRefactor(refactorName12, {
                kinds: [
                    inferReturnTypeAction.kind
                ],
                getEditsForAction: getRefactorEditsToInferReturnType,
                getAvailableActions: getRefactorActionsToInferReturnType
            });
        }
    });
    // src/services/_namespaces/ts.refactor.inferFunctionReturnType.ts
    var ts_refactor_inferFunctionReturnType_exports = {};
    var init_ts_refactor_inferFunctionReturnType = __esm({
        "src/services/_namespaces/ts.refactor.inferFunctionReturnType.ts" () {
            "use strict";
            init_inferFunctionReturnType();
        }
    });
    // src/services/_namespaces/ts.refactor.ts
    var ts_refactor_exports = {};
    __export(ts_refactor_exports, {
        addExportToChanges: ()=>addExportToChanges,
        addExports: ()=>addExports,
        addNewFileToTsconfig: ()=>addNewFileToTsconfig,
        addOrRemoveBracesToArrowFunction: ()=>ts_refactor_addOrRemoveBracesToArrowFunction_exports,
        convertArrowFunctionOrFunctionExpression: ()=>ts_refactor_convertArrowFunctionOrFunctionExpression_exports,
        convertParamsToDestructuredObject: ()=>ts_refactor_convertParamsToDestructuredObject_exports,
        convertStringOrTemplateLiteral: ()=>ts_refactor_convertStringOrTemplateLiteral_exports,
        convertToOptionalChainExpression: ()=>ts_refactor_convertToOptionalChainExpression_exports,
        createNewFileName: ()=>createNewFileName,
        createOldFileImportsFromTargetFile: ()=>createOldFileImportsFromTargetFile,
        deleteMovedStatements: ()=>deleteMovedStatements,
        deleteUnusedImports: ()=>deleteUnusedImports,
        deleteUnusedOldImports: ()=>deleteUnusedOldImports,
        doChangeNamedToNamespaceOrDefault: ()=>doChangeNamedToNamespaceOrDefault,
        extractSymbol: ()=>ts_refactor_extractSymbol_exports,
        filterImport: ()=>filterImport,
        forEachImportInStatement: ()=>forEachImportInStatement,
        generateGetAccessorAndSetAccessor: ()=>ts_refactor_generateGetAccessorAndSetAccessor_exports,
        getApplicableRefactors: ()=>getApplicableRefactors,
        getEditsForRefactor: ()=>getEditsForRefactor,
        getStatementsToMove: ()=>getStatementsToMove,
        getTopLevelDeclarationStatement: ()=>getTopLevelDeclarationStatement,
        getUsageInfo: ()=>getUsageInfo,
        inferFunctionReturnType: ()=>ts_refactor_inferFunctionReturnType_exports,
        isRefactorErrorInfo: ()=>isRefactorErrorInfo,
        isTopLevelDeclaration: ()=>isTopLevelDeclaration,
        makeImportOrRequire: ()=>makeImportOrRequire,
        moduleSpecifierFromImport: ()=>moduleSpecifierFromImport,
        nameOfTopLevelDeclaration: ()=>nameOfTopLevelDeclaration,
        refactorKindBeginsWith: ()=>refactorKindBeginsWith,
        registerRefactor: ()=>registerRefactor,
        updateImportsInOtherFiles: ()=>updateImportsInOtherFiles
    });
    var init_ts_refactor = __esm({
        "src/services/_namespaces/ts.refactor.ts" () {
            "use strict";
            init_refactorProvider();
            init_convertExport();
            init_convertImport();
            init_extractType();
            init_helpers();
            init_moveToNewFile();
            init_moveToFile();
            init_ts_refactor_addOrRemoveBracesToArrowFunction();
            init_ts_refactor_convertArrowFunctionOrFunctionExpression();
            init_ts_refactor_convertParamsToDestructuredObject();
            init_ts_refactor_convertStringOrTemplateLiteral();
            init_ts_refactor_convertToOptionalChainExpression();
            init_ts_refactor_extractSymbol();
            init_ts_refactor_generateGetAccessorAndSetAccessor();
            init_ts_refactor_inferFunctionReturnType();
        }
    });
    // src/services/classifier2020.ts
    function getSemanticClassifications2(program, cancellationToken, sourceFile, span) {
        const classifications = getEncodedSemanticClassifications2(program, cancellationToken, sourceFile, span);
        Debug.assert(classifications.spans.length % 3 === 0);
        const dense = classifications.spans;
        const result = [];
        for(let i = 0; i < dense.length; i += 3)result.push({
            textSpan: createTextSpan(dense[i], dense[i + 1]),
            classificationType: dense[i + 2]
        });
        return result;
    }
    function getEncodedSemanticClassifications2(program, cancellationToken, sourceFile, span) {
        return {
            spans: getSemanticTokens(program, sourceFile, span, cancellationToken),
            endOfLineState: 0 /* None */ 
        };
    }
    function getSemanticTokens(program, sourceFile, span, cancellationToken) {
        const resultTokens = [];
        const collector = (node, typeIdx, modifierSet)=>{
            resultTokens.push(node.getStart(sourceFile), node.getWidth(sourceFile), (typeIdx + 1 << 8 /* typeOffset */ ) + modifierSet);
        };
        if (program && sourceFile) collectTokens(program, sourceFile, span, collector, cancellationToken);
        return resultTokens;
    }
    function collectTokens(program, sourceFile, span, collector, cancellationToken) {
        const typeChecker = program.getTypeChecker();
        let inJSXElement = false;
        function visit(node) {
            switch(node.kind){
                case 266 /* ModuleDeclaration */ :
                case 262 /* ClassDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                case 261 /* FunctionDeclaration */ :
                case 230 /* ClassExpression */ :
                case 217 /* FunctionExpression */ :
                case 218 /* ArrowFunction */ :
                    cancellationToken.throwIfCancellationRequested();
            }
            if (!node || !textSpanIntersectsWith(span, node.pos, node.getFullWidth()) || node.getFullWidth() === 0) return;
            const prevInJSXElement = inJSXElement;
            if (isJsxElement(node) || isJsxSelfClosingElement(node)) inJSXElement = true;
            if (isJsxExpression(node)) inJSXElement = false;
            if (isIdentifier(node) && !inJSXElement && !inImportClause(node) && !isInfinityOrNaNString(node.escapedText)) {
                let symbol = typeChecker.getSymbolAtLocation(node);
                if (symbol) {
                    if (symbol.flags & 2097152 /* Alias */ ) symbol = typeChecker.getAliasedSymbol(symbol);
                    let typeIdx = classifySymbol2(symbol, getMeaningFromLocation(node));
                    if (typeIdx !== void 0) {
                        let modifierSet = 0;
                        if (node.parent) {
                            const parentIsDeclaration = isBindingElement(node.parent) || tokenFromDeclarationMapping.get(node.parent.kind) === typeIdx;
                            if (parentIsDeclaration && node.parent.name === node) modifierSet = 1 /* declaration */ ;
                        }
                        if (typeIdx === 6 /* parameter */  && isRightSideOfQualifiedNameOrPropertyAccess2(node)) typeIdx = 9 /* property */ ;
                        typeIdx = reclassifyByType(typeChecker, node, typeIdx);
                        const decl = symbol.valueDeclaration;
                        if (decl) {
                            const modifiers = getCombinedModifierFlags(decl);
                            const nodeFlags = getCombinedNodeFlags(decl);
                            if (modifiers & 32 /* Static */ ) modifierSet |= 2 /* static */ ;
                            if (modifiers & 512 /* Async */ ) modifierSet |= 4 /* async */ ;
                            if (typeIdx !== 0 /* class */  && typeIdx !== 2 /* interface */ ) {
                                if (modifiers & 64 /* Readonly */  || nodeFlags & 2 /* Const */  || symbol.getFlags() & 8 /* EnumMember */ ) modifierSet |= 8 /* readonly */ ;
                            }
                            if ((typeIdx === 7 /* variable */  || typeIdx === 10 /* function */ ) && isLocalDeclaration(decl, sourceFile)) modifierSet |= 32 /* local */ ;
                            if (program.isSourceFileDefaultLibrary(decl.getSourceFile())) modifierSet |= 16 /* defaultLibrary */ ;
                        } else if (symbol.declarations && symbol.declarations.some((d)=>program.isSourceFileDefaultLibrary(d.getSourceFile()))) modifierSet |= 16 /* defaultLibrary */ ;
                        collector(node, typeIdx, modifierSet);
                    }
                }
            }
            forEachChild(node, visit);
            inJSXElement = prevInJSXElement;
        }
        visit(sourceFile);
    }
    function classifySymbol2(symbol, meaning) {
        const flags = symbol.getFlags();
        if (flags & 32 /* Class */ ) return 0 /* class */ ;
        else if (flags & 384 /* Enum */ ) return 1 /* enum */ ;
        else if (flags & 524288 /* TypeAlias */ ) return 5 /* type */ ;
        else if (flags & 64 /* Interface */ ) {
            if (meaning & 2 /* Type */ ) return 2 /* interface */ ;
        } else if (flags & 262144 /* TypeParameter */ ) return 4 /* typeParameter */ ;
        let decl = symbol.valueDeclaration || symbol.declarations && symbol.declarations[0];
        if (decl && isBindingElement(decl)) decl = getDeclarationForBindingElement(decl);
        return decl && tokenFromDeclarationMapping.get(decl.kind);
    }
    function reclassifyByType(typeChecker, node, typeIdx) {
        if (typeIdx === 7 /* variable */  || typeIdx === 9 /* property */  || typeIdx === 6 /* parameter */ ) {
            const type = typeChecker.getTypeAtLocation(node);
            if (type) {
                const test = (condition)=>{
                    return condition(type) || type.isUnion() && type.types.some(condition);
                };
                if (typeIdx !== 6 /* parameter */  && test((t)=>t.getConstructSignatures().length > 0)) return 0 /* class */ ;
                if (test((t)=>t.getCallSignatures().length > 0) && !test((t)=>t.getProperties().length > 0) || isExpressionInCallExpression(node)) return typeIdx === 9 /* property */  ? 11 /* member */  : 10 /* function */ ;
            }
        }
        return typeIdx;
    }
    function isLocalDeclaration(decl, sourceFile) {
        if (isBindingElement(decl)) decl = getDeclarationForBindingElement(decl);
        if (isVariableDeclaration(decl)) return (!isSourceFile(decl.parent.parent.parent) || isCatchClause(decl.parent)) && decl.getSourceFile() === sourceFile;
        else if (isFunctionDeclaration(decl)) return !isSourceFile(decl.parent) && decl.getSourceFile() === sourceFile;
        return false;
    }
    function getDeclarationForBindingElement(element) {
        while(true){
            if (isBindingElement(element.parent.parent)) element = element.parent.parent;
            else return element.parent.parent;
        }
    }
    function inImportClause(node) {
        const parent2 = node.parent;
        return parent2 && (isImportClause(parent2) || isImportSpecifier(parent2) || isNamespaceImport(parent2));
    }
    function isExpressionInCallExpression(node) {
        while(isRightSideOfQualifiedNameOrPropertyAccess2(node))node = node.parent;
        return isCallExpression(node.parent) && node.parent.expression === node;
    }
    function isRightSideOfQualifiedNameOrPropertyAccess2(node) {
        return isQualifiedName(node.parent) && node.parent.right === node || isPropertyAccessExpression(node.parent) && node.parent.name === node;
    }
    var TokenEncodingConsts, TokenType, TokenModifier, tokenFromDeclarationMapping;
    var init_classifier2020 = __esm({
        "src/services/classifier2020.ts" () {
            "use strict";
            init_ts4();
            TokenEncodingConsts = /* @__PURE__ */ ((TokenEncodingConsts2)=>{
                TokenEncodingConsts2[TokenEncodingConsts2["typeOffset"] = 8] = "typeOffset";
                TokenEncodingConsts2[TokenEncodingConsts2["modifierMask"] = 255] = "modifierMask";
                return TokenEncodingConsts2;
            })(TokenEncodingConsts || {});
            TokenType = /* @__PURE__ */ ((TokenType2)=>{
                TokenType2[TokenType2["class"] = 0] = "class";
                TokenType2[TokenType2["enum"] = 1] = "enum";
                TokenType2[TokenType2["interface"] = 2] = "interface";
                TokenType2[TokenType2["namespace"] = 3] = "namespace";
                TokenType2[TokenType2["typeParameter"] = 4] = "typeParameter";
                TokenType2[TokenType2["type"] = 5] = "type";
                TokenType2[TokenType2["parameter"] = 6] = "parameter";
                TokenType2[TokenType2["variable"] = 7] = "variable";
                TokenType2[TokenType2["enumMember"] = 8] = "enumMember";
                TokenType2[TokenType2["property"] = 9] = "property";
                TokenType2[TokenType2["function"] = 10] = "function";
                TokenType2[TokenType2["member"] = 11] = "member";
                return TokenType2;
            })(TokenType || {});
            TokenModifier = /* @__PURE__ */ ((TokenModifier2)=>{
                TokenModifier2[TokenModifier2["declaration"] = 0] = "declaration";
                TokenModifier2[TokenModifier2["static"] = 1] = "static";
                TokenModifier2[TokenModifier2["async"] = 2] = "async";
                TokenModifier2[TokenModifier2["readonly"] = 3] = "readonly";
                TokenModifier2[TokenModifier2["defaultLibrary"] = 4] = "defaultLibrary";
                TokenModifier2[TokenModifier2["local"] = 5] = "local";
                return TokenModifier2;
            })(TokenModifier || {});
            tokenFromDeclarationMapping = /* @__PURE__ */ new Map([
                [
                    259 /* VariableDeclaration */ ,
                    7 /* variable */ 
                ],
                [
                    168 /* Parameter */ ,
                    6 /* parameter */ 
                ],
                [
                    171 /* PropertyDeclaration */ ,
                    9 /* property */ 
                ],
                [
                    266 /* ModuleDeclaration */ ,
                    3 /* namespace */ 
                ],
                [
                    265 /* EnumDeclaration */ ,
                    1 /* enum */ 
                ],
                [
                    305 /* EnumMember */ ,
                    8 /* enumMember */ 
                ],
                [
                    262 /* ClassDeclaration */ ,
                    0 /* class */ 
                ],
                [
                    173 /* MethodDeclaration */ ,
                    11 /* member */ 
                ],
                [
                    261 /* FunctionDeclaration */ ,
                    10 /* function */ 
                ],
                [
                    217 /* FunctionExpression */ ,
                    10 /* function */ 
                ],
                [
                    172 /* MethodSignature */ ,
                    11 /* member */ 
                ],
                [
                    176 /* GetAccessor */ ,
                    9 /* property */ 
                ],
                [
                    177 /* SetAccessor */ ,
                    9 /* property */ 
                ],
                [
                    170 /* PropertySignature */ ,
                    9 /* property */ 
                ],
                [
                    263 /* InterfaceDeclaration */ ,
                    2 /* interface */ 
                ],
                [
                    264 /* TypeAliasDeclaration */ ,
                    5 /* type */ 
                ],
                [
                    167 /* TypeParameter */ ,
                    4 /* typeParameter */ 
                ],
                [
                    302 /* PropertyAssignment */ ,
                    9 /* property */ 
                ],
                [
                    303 /* ShorthandPropertyAssignment */ ,
                    9 /* property */ 
                ]
            ]);
        }
    });
    // src/services/services.ts
    function createNode(kind, pos, end, parent2) {
        const node = isNodeKind(kind) ? new NodeObject(kind, pos, end) : kind === 80 /* Identifier */  ? new IdentifierObject(80 /* Identifier */ , pos, end) : kind === 81 /* PrivateIdentifier */  ? new PrivateIdentifierObject(81 /* PrivateIdentifier */ , pos, end) : new TokenObject(kind, pos, end);
        node.parent = parent2;
        node.flags = parent2.flags & 50720768 /* ContextFlags */ ;
        return node;
    }
    function createChildren(node, sourceFile) {
        if (!isNodeKind(node.kind)) return emptyArray;
        const children = [];
        if (isJSDocCommentContainingNode(node)) {
            node.forEachChild((child)=>{
                children.push(child);
            });
            return children;
        }
        scanner.setText((sourceFile || node.getSourceFile()).text);
        let pos = node.pos;
        const processNode = (child)=>{
            addSyntheticNodes(children, pos, child.pos, node);
            children.push(child);
            pos = child.end;
        };
        const processNodes = (nodes)=>{
            addSyntheticNodes(children, pos, nodes.pos, node);
            children.push(createSyntaxList(nodes, node));
            pos = nodes.end;
        };
        forEach(node.jsDoc, processNode);
        pos = node.pos;
        node.forEachChild(processNode, processNodes);
        addSyntheticNodes(children, pos, node.end, node);
        scanner.setText(void 0);
        return children;
    }
    function addSyntheticNodes(nodes, pos, end, parent2) {
        scanner.resetTokenState(pos);
        while(pos < end){
            const token = scanner.scan();
            const textPos = scanner.getTokenEnd();
            if (textPos <= end) {
                if (token === 80 /* Identifier */ ) {
                    if (hasTabstop(parent2)) continue;
                    Debug.fail(`Did not expect ${Debug.formatSyntaxKind(parent2.kind)} to have an Identifier in its trivia`);
                }
                nodes.push(createNode(token, pos, textPos, parent2));
            }
            pos = textPos;
            if (token === 1 /* EndOfFileToken */ ) break;
        }
    }
    function createSyntaxList(nodes, parent2) {
        const list = createNode(357 /* SyntaxList */ , nodes.pos, nodes.end, parent2);
        list._children = [];
        let pos = nodes.pos;
        for (const node of nodes){
            addSyntheticNodes(list._children, pos, node.pos, parent2);
            list._children.push(node);
            pos = node.end;
        }
        addSyntheticNodes(list._children, pos, nodes.end, parent2);
        return list;
    }
    function hasJSDocInheritDocTag(node) {
        return getJSDocTags(node).some((tag)=>tag.tagName.text === "inheritDoc" || tag.tagName.text === "inheritdoc");
    }
    function getJsDocTagsOfDeclarations(declarations, checker) {
        if (!declarations) return emptyArray;
        let tags = ts_JsDoc_exports.getJsDocTagsFromDeclarations(declarations, checker);
        if (checker && (tags.length === 0 || declarations.some(hasJSDocInheritDocTag))) {
            const seenSymbols = /* @__PURE__ */ new Set();
            for (const declaration of declarations){
                const inheritedTags = findBaseOfDeclaration(checker, declaration, (symbol)=>{
                    var _a;
                    if (!seenSymbols.has(symbol)) {
                        seenSymbols.add(symbol);
                        if (declaration.kind === 176 /* GetAccessor */  || declaration.kind === 177 /* SetAccessor */ ) return symbol.getContextualJsDocTags(declaration, checker);
                        return ((_a = symbol.declarations) == null ? void 0 : _a.length) === 1 ? symbol.getJsDocTags() : void 0;
                    }
                });
                if (inheritedTags) tags = [
                    ...inheritedTags,
                    ...tags
                ];
            }
        }
        return tags;
    }
    function getDocumentationComment(declarations, checker) {
        if (!declarations) return emptyArray;
        let doc = ts_JsDoc_exports.getJsDocCommentsFromDeclarations(declarations, checker);
        if (checker && (doc.length === 0 || declarations.some(hasJSDocInheritDocTag))) {
            const seenSymbols = /* @__PURE__ */ new Set();
            for (const declaration of declarations){
                const inheritedDocs = findBaseOfDeclaration(checker, declaration, (symbol)=>{
                    if (!seenSymbols.has(symbol)) {
                        seenSymbols.add(symbol);
                        if (declaration.kind === 176 /* GetAccessor */  || declaration.kind === 177 /* SetAccessor */ ) return symbol.getContextualDocumentationComment(declaration, checker);
                        return symbol.getDocumentationComment(checker);
                    }
                });
                if (inheritedDocs) doc = doc.length === 0 ? inheritedDocs.slice() : inheritedDocs.concat(lineBreakPart(), doc);
            }
        }
        return doc;
    }
    function findBaseOfDeclaration(checker, declaration, cb) {
        var _a;
        const classOrInterfaceDeclaration = ((_a = declaration.parent) == null ? void 0 : _a.kind) === 175 /* Constructor */  ? declaration.parent.parent : declaration.parent;
        if (!classOrInterfaceDeclaration) return;
        const isStaticMember = hasStaticModifier(declaration);
        return firstDefined(getAllSuperTypeNodes(classOrInterfaceDeclaration), (superTypeNode)=>{
            const baseType = checker.getTypeAtLocation(superTypeNode);
            const type = isStaticMember && baseType.symbol ? checker.getTypeOfSymbol(baseType.symbol) : baseType;
            const symbol = checker.getPropertyOfType(type, declaration.symbol.name);
            return symbol ? cb(symbol) : void 0;
        });
    }
    function getServicesObjectAllocator() {
        return {
            getNodeConstructor: ()=>NodeObject,
            getTokenConstructor: ()=>TokenObject,
            getIdentifierConstructor: ()=>IdentifierObject,
            getPrivateIdentifierConstructor: ()=>PrivateIdentifierObject,
            getSourceFileConstructor: ()=>SourceFileObject,
            getSymbolConstructor: ()=>SymbolObject,
            getTypeConstructor: ()=>TypeObject,
            getSignatureConstructor: ()=>SignatureObject,
            getSourceMapSourceConstructor: ()=>SourceMapSourceObject
        };
    }
    function toEditorSettings(optionsAsMap) {
        let allPropertiesAreCamelCased = true;
        for(const key in optionsAsMap)if (hasProperty(optionsAsMap, key) && !isCamelCase(key)) {
            allPropertiesAreCamelCased = false;
            break;
        }
        if (allPropertiesAreCamelCased) return optionsAsMap;
        const settings = {};
        for(const key in optionsAsMap)if (hasProperty(optionsAsMap, key)) {
            const newKey = isCamelCase(key) ? key : key.charAt(0).toLowerCase() + key.substr(1);
            settings[newKey] = optionsAsMap[key];
        }
        return settings;
    }
    function isCamelCase(s) {
        return !s.length || s.charAt(0) === s.charAt(0).toLowerCase();
    }
    function displayPartsToString(displayParts) {
        if (displayParts) return map(displayParts, (displayPart2)=>displayPart2.text).join("");
        return "";
    }
    function getDefaultCompilerOptions2() {
        return {
            target: 1 /* ES5 */ ,
            jsx: 1 /* Preserve */ 
        };
    }
    function getSupportedCodeFixes() {
        return ts_codefix_exports.getSupportedErrorCodes();
    }
    function setSourceFileFields(sourceFile, scriptSnapshot, version2) {
        sourceFile.version = version2;
        sourceFile.scriptSnapshot = scriptSnapshot;
    }
    function createLanguageServiceSourceFile(fileName, scriptSnapshot, scriptTargetOrOptions, version2, setNodeParents, scriptKind) {
        const sourceFile = createSourceFile(fileName, getSnapshotText(scriptSnapshot), scriptTargetOrOptions, setNodeParents, scriptKind);
        setSourceFileFields(sourceFile, scriptSnapshot, version2);
        return sourceFile;
    }
    function updateLanguageServiceSourceFile(sourceFile, scriptSnapshot, version2, textChangeRange, aggressiveChecks) {
        if (textChangeRange) {
            if (version2 !== sourceFile.version) {
                let newText;
                const prefix = textChangeRange.span.start !== 0 ? sourceFile.text.substr(0, textChangeRange.span.start) : "";
                const suffix = textSpanEnd(textChangeRange.span) !== sourceFile.text.length ? sourceFile.text.substr(textSpanEnd(textChangeRange.span)) : "";
                if (textChangeRange.newLength === 0) newText = prefix && suffix ? prefix + suffix : prefix || suffix;
                else {
                    const changedText = scriptSnapshot.getText(textChangeRange.span.start, textChangeRange.span.start + textChangeRange.newLength);
                    newText = prefix && suffix ? prefix + changedText + suffix : prefix ? prefix + changedText : changedText + suffix;
                }
                const newSourceFile = updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks);
                setSourceFileFields(newSourceFile, scriptSnapshot, version2);
                newSourceFile.nameTable = void 0;
                if (sourceFile !== newSourceFile && sourceFile.scriptSnapshot) {
                    if (sourceFile.scriptSnapshot.dispose) sourceFile.scriptSnapshot.dispose();
                    sourceFile.scriptSnapshot = void 0;
                }
                return newSourceFile;
            }
        }
        const options = {
            languageVersion: sourceFile.languageVersion,
            impliedNodeFormat: sourceFile.impliedNodeFormat,
            setExternalModuleIndicator: sourceFile.setExternalModuleIndicator
        };
        return createLanguageServiceSourceFile(sourceFile.fileName, scriptSnapshot, options, version2, /*setNodeParents*/ true, sourceFile.scriptKind);
    }
    function createLanguageService(host, documentRegistry = createDocumentRegistry(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames(), host.getCurrentDirectory()), syntaxOnlyOrLanguageServiceMode) {
        var _a;
        let languageServiceMode;
        if (syntaxOnlyOrLanguageServiceMode === void 0) languageServiceMode = 0 /* Semantic */ ;
        else if (typeof syntaxOnlyOrLanguageServiceMode === "boolean") languageServiceMode = syntaxOnlyOrLanguageServiceMode ? 2 /* Syntactic */  : 0 /* Semantic */ ;
        else languageServiceMode = syntaxOnlyOrLanguageServiceMode;
        const syntaxTreeCache = new SyntaxTreeCache(host);
        let program;
        let lastProjectVersion;
        let lastTypesRootVersion = 0;
        const cancellationToken = host.getCancellationToken ? new CancellationTokenObject(host.getCancellationToken()) : NoopCancellationToken;
        const currentDirectory = host.getCurrentDirectory();
        maybeSetLocalizedDiagnosticMessages((_a = host.getLocalizedDiagnosticMessages) == null ? void 0 : _a.bind(host));
        function log(message) {
            if (host.log) host.log(message);
        }
        const useCaseSensitiveFileNames = hostUsesCaseSensitiveFileNames(host);
        const getCanonicalFileName = createGetCanonicalFileName(useCaseSensitiveFileNames);
        const sourceMapper = getSourceMapper({
            useCaseSensitiveFileNames: ()=>useCaseSensitiveFileNames,
            getCurrentDirectory: ()=>currentDirectory,
            getProgram: getProgram,
            fileExists: maybeBind(host, host.fileExists),
            readFile: maybeBind(host, host.readFile),
            getDocumentPositionMapper: maybeBind(host, host.getDocumentPositionMapper),
            getSourceFileLike: maybeBind(host, host.getSourceFileLike),
            log: log
        });
        function getValidSourceFile(fileName) {
            const sourceFile = program.getSourceFile(fileName);
            if (!sourceFile) {
                const error = new Error(`Could not find source file: '${fileName}'.`);
                error.ProgramFiles = program.getSourceFiles().map((f)=>f.fileName);
                throw error;
            }
            return sourceFile;
        }
        function synchronizeHostData() {
            var _a2, _b, _c;
            Debug.assert(languageServiceMode !== 2 /* Syntactic */ );
            if (host.getProjectVersion) {
                const hostProjectVersion = host.getProjectVersion();
                if (hostProjectVersion) {
                    if (lastProjectVersion === hostProjectVersion && !((_a2 = host.hasChangedAutomaticTypeDirectiveNames) == null ? void 0 : _a2.call(host))) return;
                    lastProjectVersion = hostProjectVersion;
                }
            }
            const typeRootsVersion = host.getTypeRootsVersion ? host.getTypeRootsVersion() : 0;
            if (lastTypesRootVersion !== typeRootsVersion) {
                log("TypeRoots version has changed; provide new program");
                program = void 0;
                lastTypesRootVersion = typeRootsVersion;
            }
            const rootFileNames = host.getScriptFileNames().slice();
            const newSettings = host.getCompilationSettings() || getDefaultCompilerOptions2();
            const hasInvalidatedResolutions = host.hasInvalidatedResolutions || returnFalse;
            const hasInvalidatedLibResolutions = maybeBind(host, host.hasInvalidatedLibResolutions) || returnFalse;
            const hasChangedAutomaticTypeDirectiveNames = maybeBind(host, host.hasChangedAutomaticTypeDirectiveNames);
            const projectReferences = (_b = host.getProjectReferences) == null ? void 0 : _b.call(host);
            let parsedCommandLines;
            let compilerHost = {
                getSourceFile: getOrCreateSourceFile,
                getSourceFileByPath: getOrCreateSourceFileByPath,
                getCancellationToken: ()=>cancellationToken,
                getCanonicalFileName: getCanonicalFileName,
                useCaseSensitiveFileNames: ()=>useCaseSensitiveFileNames,
                getNewLine: ()=>getNewLineCharacter(newSettings),
                getDefaultLibFileName: (options2)=>host.getDefaultLibFileName(options2),
                writeFile: noop,
                getCurrentDirectory: ()=>currentDirectory,
                fileExists: (fileName)=>host.fileExists(fileName),
                readFile: (fileName)=>host.readFile && host.readFile(fileName),
                getSymlinkCache: maybeBind(host, host.getSymlinkCache),
                realpath: maybeBind(host, host.realpath),
                directoryExists: (directoryName)=>{
                    return directoryProbablyExists(directoryName, host);
                },
                getDirectories: (path)=>{
                    return host.getDirectories ? host.getDirectories(path) : [];
                },
                readDirectory: (path, extensions, exclude, include, depth)=>{
                    Debug.checkDefined(host.readDirectory, "'LanguageServiceHost.readDirectory' must be implemented to correctly process 'projectReferences'");
                    return host.readDirectory(path, extensions, exclude, include, depth);
                },
                onReleaseOldSourceFile: onReleaseOldSourceFile,
                onReleaseParsedCommandLine: onReleaseParsedCommandLine,
                hasInvalidatedResolutions: hasInvalidatedResolutions,
                hasInvalidatedLibResolutions: hasInvalidatedLibResolutions,
                hasChangedAutomaticTypeDirectiveNames: hasChangedAutomaticTypeDirectiveNames,
                trace: maybeBind(host, host.trace),
                resolveModuleNames: maybeBind(host, host.resolveModuleNames),
                getModuleResolutionCache: maybeBind(host, host.getModuleResolutionCache),
                createHash: maybeBind(host, host.createHash),
                resolveTypeReferenceDirectives: maybeBind(host, host.resolveTypeReferenceDirectives),
                resolveModuleNameLiterals: maybeBind(host, host.resolveModuleNameLiterals),
                resolveTypeReferenceDirectiveReferences: maybeBind(host, host.resolveTypeReferenceDirectiveReferences),
                resolveLibrary: maybeBind(host, host.resolveLibrary),
                useSourceOfProjectReferenceRedirect: maybeBind(host, host.useSourceOfProjectReferenceRedirect),
                getParsedCommandLine: getParsedCommandLine
            };
            const originalGetSourceFile = compilerHost.getSourceFile;
            const { getSourceFileWithCache: getSourceFileWithCache  } = changeCompilerHostLikeToUseCache(compilerHost, (fileName)=>toPath(fileName, currentDirectory, getCanonicalFileName), (...args)=>originalGetSourceFile.call(compilerHost, ...args));
            compilerHost.getSourceFile = getSourceFileWithCache;
            (_c = host.setCompilerHost) == null || _c.call(host, compilerHost);
            const parseConfigHost = {
                useCaseSensitiveFileNames: useCaseSensitiveFileNames,
                fileExists: (fileName)=>compilerHost.fileExists(fileName),
                readFile: (fileName)=>compilerHost.readFile(fileName),
                readDirectory: (...args)=>compilerHost.readDirectory(...args),
                trace: compilerHost.trace,
                getCurrentDirectory: compilerHost.getCurrentDirectory,
                onUnRecoverableConfigFileDiagnostic: noop
            };
            const documentRegistryBucketKey = documentRegistry.getKeyForCompilationSettings(newSettings);
            let releasedScriptKinds = /* @__PURE__ */ new Set();
            if (isProgramUptoDate(program, rootFileNames, newSettings, (_path, fileName)=>host.getScriptVersion(fileName), (fileName)=>compilerHost.fileExists(fileName), hasInvalidatedResolutions, hasInvalidatedLibResolutions, hasChangedAutomaticTypeDirectiveNames, getParsedCommandLine, projectReferences)) {
                compilerHost = void 0;
                parsedCommandLines = void 0;
                releasedScriptKinds = void 0;
                return;
            }
            const options = {
                rootNames: rootFileNames,
                options: newSettings,
                host: compilerHost,
                oldProgram: program,
                projectReferences: projectReferences
            };
            program = createProgram(options);
            compilerHost = void 0;
            parsedCommandLines = void 0;
            releasedScriptKinds = void 0;
            sourceMapper.clearCache();
            program.getTypeChecker();
            return;
            function getParsedCommandLine(fileName) {
                const path = toPath(fileName, currentDirectory, getCanonicalFileName);
                const existing = parsedCommandLines == null ? void 0 : parsedCommandLines.get(path);
                if (existing !== void 0) return existing || void 0;
                const result = host.getParsedCommandLine ? host.getParsedCommandLine(fileName) : getParsedCommandLineOfConfigFileUsingSourceFile(fileName);
                (parsedCommandLines || (parsedCommandLines = /* @__PURE__ */ new Map())).set(path, result || false);
                return result;
            }
            function getParsedCommandLineOfConfigFileUsingSourceFile(configFileName) {
                const result = getOrCreateSourceFile(configFileName, 100 /* JSON */ );
                if (!result) return void 0;
                result.path = toPath(configFileName, currentDirectory, getCanonicalFileName);
                result.resolvedPath = result.path;
                result.originalFileName = result.fileName;
                return parseJsonSourceFileConfigFileContent(result, parseConfigHost, getNormalizedAbsolutePath(getDirectoryPath(configFileName), currentDirectory), /*existingOptions*/ void 0, getNormalizedAbsolutePath(configFileName, currentDirectory));
            }
            function onReleaseParsedCommandLine(configFileName, oldResolvedRef, oldOptions) {
                var _a3;
                if (host.getParsedCommandLine) (_a3 = host.onReleaseParsedCommandLine) == null || _a3.call(host, configFileName, oldResolvedRef, oldOptions);
                else if (oldResolvedRef) onReleaseOldSourceFile(oldResolvedRef.sourceFile, oldOptions);
            }
            function onReleaseOldSourceFile(oldSourceFile, oldOptions) {
                const oldSettingsKey = documentRegistry.getKeyForCompilationSettings(oldOptions);
                documentRegistry.releaseDocumentWithKey(oldSourceFile.resolvedPath, oldSettingsKey, oldSourceFile.scriptKind, oldSourceFile.impliedNodeFormat);
            }
            function getOrCreateSourceFile(fileName, languageVersionOrOptions, onError, shouldCreateNewSourceFile) {
                return getOrCreateSourceFileByPath(fileName, toPath(fileName, currentDirectory, getCanonicalFileName), languageVersionOrOptions, onError, shouldCreateNewSourceFile);
            }
            function getOrCreateSourceFileByPath(fileName, path, languageVersionOrOptions, _onError, shouldCreateNewSourceFile) {
                Debug.assert(compilerHost, "getOrCreateSourceFileByPath called after typical CompilerHost lifetime, check the callstack something with a reference to an old host.");
                const scriptSnapshot = host.getScriptSnapshot(fileName);
                if (!scriptSnapshot) return void 0;
                const scriptKind = getScriptKind(fileName, host);
                const scriptVersion = host.getScriptVersion(fileName);
                if (!shouldCreateNewSourceFile) {
                    const oldSourceFile = program && program.getSourceFileByPath(path);
                    if (oldSourceFile) {
                        if (scriptKind === oldSourceFile.scriptKind || releasedScriptKinds.has(oldSourceFile.resolvedPath)) return documentRegistry.updateDocumentWithKey(fileName, path, host, documentRegistryBucketKey, scriptSnapshot, scriptVersion, scriptKind, languageVersionOrOptions);
                        else {
                            documentRegistry.releaseDocumentWithKey(oldSourceFile.resolvedPath, documentRegistry.getKeyForCompilationSettings(program.getCompilerOptions()), oldSourceFile.scriptKind, oldSourceFile.impliedNodeFormat);
                            releasedScriptKinds.add(oldSourceFile.resolvedPath);
                        }
                    }
                }
                return documentRegistry.acquireDocumentWithKey(fileName, path, host, documentRegistryBucketKey, scriptSnapshot, scriptVersion, scriptKind, languageVersionOrOptions);
            }
        }
        function getProgram() {
            if (languageServiceMode === 2 /* Syntactic */ ) {
                Debug.assert(program === void 0);
                return void 0;
            }
            synchronizeHostData();
            return program;
        }
        function getAutoImportProvider() {
            var _a2;
            return (_a2 = host.getPackageJsonAutoImportProvider) == null ? void 0 : _a2.call(host);
        }
        function updateIsDefinitionOfReferencedSymbols(referencedSymbols, knownSymbolSpans) {
            const checker = program.getTypeChecker();
            const symbol = getSymbolForProgram();
            if (!symbol) return false;
            for (const referencedSymbol of referencedSymbols)for (const ref of referencedSymbol.references){
                const refNode = getNodeForSpan(ref);
                Debug.assertIsDefined(refNode);
                if (knownSymbolSpans.has(ref) || ts_FindAllReferences_exports.isDeclarationOfSymbol(refNode, symbol)) {
                    knownSymbolSpans.add(ref);
                    ref.isDefinition = true;
                    const mappedSpan = getMappedDocumentSpan(ref, sourceMapper, maybeBind(host, host.fileExists));
                    if (mappedSpan) knownSymbolSpans.add(mappedSpan);
                } else ref.isDefinition = false;
            }
            return true;
            function getSymbolForProgram() {
                for (const referencedSymbol of referencedSymbols)for (const ref of referencedSymbol.references){
                    if (knownSymbolSpans.has(ref)) {
                        const refNode = getNodeForSpan(ref);
                        Debug.assertIsDefined(refNode);
                        return checker.getSymbolAtLocation(refNode);
                    }
                    const mappedSpan = getMappedDocumentSpan(ref, sourceMapper, maybeBind(host, host.fileExists));
                    if (mappedSpan && knownSymbolSpans.has(mappedSpan)) {
                        const refNode = getNodeForSpan(mappedSpan);
                        if (refNode) return checker.getSymbolAtLocation(refNode);
                    }
                }
                return void 0;
            }
            function getNodeForSpan(docSpan) {
                const sourceFile = program.getSourceFile(docSpan.fileName);
                if (!sourceFile) return void 0;
                const rawNode = getTouchingPropertyName(sourceFile, docSpan.textSpan.start);
                const adjustedNode = ts_FindAllReferences_exports.Core.getAdjustedNode(rawNode, {
                    use: ts_FindAllReferences_exports.FindReferencesUse.References
                });
                return adjustedNode;
            }
        }
        function cleanupSemanticCache() {
            program = void 0;
        }
        function dispose() {
            if (program) {
                const key = documentRegistry.getKeyForCompilationSettings(program.getCompilerOptions());
                forEach(program.getSourceFiles(), (f)=>documentRegistry.releaseDocumentWithKey(f.resolvedPath, key, f.scriptKind, f.impliedNodeFormat));
                program = void 0;
            }
            host = void 0;
        }
        function getSyntacticDiagnostics(fileName) {
            synchronizeHostData();
            return program.getSyntacticDiagnostics(getValidSourceFile(fileName), cancellationToken).slice();
        }
        function getSemanticDiagnostics(fileName) {
            synchronizeHostData();
            const targetSourceFile = getValidSourceFile(fileName);
            const semanticDiagnostics = program.getSemanticDiagnostics(targetSourceFile, cancellationToken);
            if (!getEmitDeclarations(program.getCompilerOptions())) return semanticDiagnostics.slice();
            const declarationDiagnostics = program.getDeclarationDiagnostics(targetSourceFile, cancellationToken);
            return [
                ...semanticDiagnostics,
                ...declarationDiagnostics
            ];
        }
        function getSuggestionDiagnostics(fileName) {
            synchronizeHostData();
            return computeSuggestionDiagnostics(getValidSourceFile(fileName), program, cancellationToken);
        }
        function getCompilerOptionsDiagnostics() {
            synchronizeHostData();
            return [
                ...program.getOptionsDiagnostics(cancellationToken),
                ...program.getGlobalDiagnostics(cancellationToken)
            ];
        }
        function getCompletionsAtPosition2(fileName, position, options = emptyOptions, formattingSettings) {
            const fullPreferences = {
                ...identity(options),
                // avoid excess property check
                includeCompletionsForModuleExports: options.includeCompletionsForModuleExports || options.includeExternalModuleExports,
                includeCompletionsWithInsertText: options.includeCompletionsWithInsertText || options.includeInsertTextCompletions
            };
            synchronizeHostData();
            return ts_Completions_exports.getCompletionsAtPosition(host, program, log, getValidSourceFile(fileName), position, fullPreferences, options.triggerCharacter, options.triggerKind, cancellationToken, formattingSettings && ts_formatting_exports.getFormatContext(formattingSettings, host), options.includeSymbol);
        }
        function getCompletionEntryDetails2(fileName, position, name, formattingOptions, source, preferences = emptyOptions, data) {
            synchronizeHostData();
            return ts_Completions_exports.getCompletionEntryDetails(program, log, getValidSourceFile(fileName), position, {
                name: name,
                source: source,
                data: data
            }, host, formattingOptions && ts_formatting_exports.getFormatContext(formattingOptions, host), // TODO: GH#18217
            preferences, cancellationToken);
        }
        function getCompletionEntrySymbol2(fileName, position, name, source, preferences = emptyOptions) {
            synchronizeHostData();
            return ts_Completions_exports.getCompletionEntrySymbol(program, log, getValidSourceFile(fileName), position, {
                name: name,
                source: source
            }, host, preferences);
        }
        function getQuickInfoAtPosition(fileName, position) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const node = getTouchingPropertyName(sourceFile, position);
            if (node === sourceFile) return void 0;
            const typeChecker = program.getTypeChecker();
            const nodeForQuickInfo = getNodeForQuickInfo(node);
            const symbol = getSymbolAtLocationForQuickInfo(nodeForQuickInfo, typeChecker);
            if (!symbol || typeChecker.isUnknownSymbol(symbol)) {
                const type = shouldGetType(sourceFile, nodeForQuickInfo, position) ? typeChecker.getTypeAtLocation(nodeForQuickInfo) : void 0;
                return type && {
                    kind: "" /* unknown */ ,
                    kindModifiers: "" /* none */ ,
                    textSpan: createTextSpanFromNode(nodeForQuickInfo, sourceFile),
                    displayParts: typeChecker.runWithCancellationToken(cancellationToken, (typeChecker2)=>typeToDisplayParts(typeChecker2, type, getContainerNode(nodeForQuickInfo))),
                    documentation: type.symbol ? type.symbol.getDocumentationComment(typeChecker) : void 0,
                    tags: type.symbol ? type.symbol.getJsDocTags(typeChecker) : void 0
                };
            }
            const { symbolKind: symbolKind , displayParts: displayParts , documentation: documentation , tags: tags  } = typeChecker.runWithCancellationToken(cancellationToken, (typeChecker2)=>ts_SymbolDisplay_exports.getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker2, symbol, sourceFile, getContainerNode(nodeForQuickInfo), nodeForQuickInfo));
            return {
                kind: symbolKind,
                kindModifiers: ts_SymbolDisplay_exports.getSymbolModifiers(typeChecker, symbol),
                textSpan: createTextSpanFromNode(nodeForQuickInfo, sourceFile),
                displayParts: displayParts,
                documentation: documentation,
                tags: tags
            };
        }
        function getNodeForQuickInfo(node) {
            if (isNewExpression(node.parent) && node.pos === node.parent.pos) return node.parent.expression;
            if (isNamedTupleMember(node.parent) && node.pos === node.parent.pos) return node.parent;
            if (isImportMeta(node.parent) && node.parent.name === node) return node.parent;
            if (isJsxNamespacedName(node.parent)) return node.parent;
            return node;
        }
        function shouldGetType(sourceFile, node, position) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return !isLabelName(node) && !isTagName(node) && !isConstTypeReference(node.parent);
                case 210 /* PropertyAccessExpression */ :
                case 165 /* QualifiedName */ :
                    return !isInComment(sourceFile, position);
                case 110 /* ThisKeyword */ :
                case 196 /* ThisType */ :
                case 108 /* SuperKeyword */ :
                case 201 /* NamedTupleMember */ :
                    return true;
                case 235 /* MetaProperty */ :
                    return isImportMeta(node);
                default:
                    return false;
            }
        }
        function getDefinitionAtPosition2(fileName, position, searchOtherFilesOnly, stopAtAlias) {
            synchronizeHostData();
            return ts_GoToDefinition_exports.getDefinitionAtPosition(program, getValidSourceFile(fileName), position, searchOtherFilesOnly, stopAtAlias);
        }
        function getDefinitionAndBoundSpan2(fileName, position) {
            synchronizeHostData();
            return ts_GoToDefinition_exports.getDefinitionAndBoundSpan(program, getValidSourceFile(fileName), position);
        }
        function getTypeDefinitionAtPosition2(fileName, position) {
            synchronizeHostData();
            return ts_GoToDefinition_exports.getTypeDefinitionAtPosition(program.getTypeChecker(), getValidSourceFile(fileName), position);
        }
        function getImplementationAtPosition(fileName, position) {
            synchronizeHostData();
            return ts_FindAllReferences_exports.getImplementationsAtPosition(program, cancellationToken, program.getSourceFiles(), getValidSourceFile(fileName), position);
        }
        function getDocumentHighlights(fileName, position, filesToSearch) {
            const normalizedFileName = normalizePath(fileName);
            Debug.assert(filesToSearch.some((f)=>normalizePath(f) === normalizedFileName));
            synchronizeHostData();
            const sourceFilesToSearch = mapDefined(filesToSearch, (fileName2)=>program.getSourceFile(fileName2));
            const sourceFile = getValidSourceFile(fileName);
            return DocumentHighlights.getDocumentHighlights(program, cancellationToken, sourceFile, position, sourceFilesToSearch);
        }
        function findRenameLocations(fileName, position, findInStrings, findInComments, preferences) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const node = getAdjustedRenameLocation(getTouchingPropertyName(sourceFile, position));
            if (!ts_Rename_exports.nodeIsEligibleForRename(node)) return void 0;
            if (isIdentifier(node) && (isJsxOpeningElement(node.parent) || isJsxClosingElement(node.parent)) && isIntrinsicJsxName(node.escapedText)) {
                const { openingElement: openingElement , closingElement: closingElement  } = node.parent.parent;
                return [
                    openingElement,
                    closingElement
                ].map((node2)=>{
                    const textSpan = createTextSpanFromNode(node2.tagName, sourceFile);
                    return {
                        fileName: sourceFile.fileName,
                        textSpan: textSpan,
                        ...ts_FindAllReferences_exports.toContextSpan(textSpan, sourceFile, node2.parent)
                    };
                });
            } else {
                const quotePreference = getQuotePreference(sourceFile, preferences ?? emptyOptions);
                const providePrefixAndSuffixTextForRename = typeof preferences === "boolean" ? preferences : preferences == null ? void 0 : preferences.providePrefixAndSuffixTextForRename;
                return getReferencesWorker(node, position, {
                    findInStrings: findInStrings,
                    findInComments: findInComments,
                    providePrefixAndSuffixTextForRename: providePrefixAndSuffixTextForRename,
                    use: ts_FindAllReferences_exports.FindReferencesUse.Rename
                }, (entry, originalNode, checker)=>ts_FindAllReferences_exports.toRenameLocation(entry, originalNode, checker, providePrefixAndSuffixTextForRename || false, quotePreference));
            }
        }
        function getReferencesAtPosition(fileName, position) {
            synchronizeHostData();
            return getReferencesWorker(getTouchingPropertyName(getValidSourceFile(fileName), position), position, {
                use: ts_FindAllReferences_exports.FindReferencesUse.References
            }, ts_FindAllReferences_exports.toReferenceEntry);
        }
        function getReferencesWorker(node, position, options, cb) {
            synchronizeHostData();
            const sourceFiles = options && options.use === ts_FindAllReferences_exports.FindReferencesUse.Rename ? program.getSourceFiles().filter((sourceFile)=>!program.isSourceFileDefaultLibrary(sourceFile)) : program.getSourceFiles();
            return ts_FindAllReferences_exports.findReferenceOrRenameEntries(program, cancellationToken, sourceFiles, node, position, options, cb);
        }
        function findReferences(fileName, position) {
            synchronizeHostData();
            return ts_FindAllReferences_exports.findReferencedSymbols(program, cancellationToken, program.getSourceFiles(), getValidSourceFile(fileName), position);
        }
        function getFileReferences(fileName) {
            synchronizeHostData();
            return ts_FindAllReferences_exports.Core.getReferencesForFileName(fileName, program, program.getSourceFiles()).map(ts_FindAllReferences_exports.toReferenceEntry);
        }
        function getNavigateToItems2(searchValue, maxResultCount, fileName, excludeDtsFiles = false) {
            synchronizeHostData();
            const sourceFiles = fileName ? [
                getValidSourceFile(fileName)
            ] : program.getSourceFiles();
            return getNavigateToItems(sourceFiles, program.getTypeChecker(), cancellationToken, searchValue, maxResultCount, excludeDtsFiles);
        }
        function getEmitOutput(fileName, emitOnlyDtsFiles, forceDtsEmit) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const customTransformers = host.getCustomTransformers && host.getCustomTransformers();
            return getFileEmitOutput(program, sourceFile, !!emitOnlyDtsFiles, cancellationToken, customTransformers, forceDtsEmit);
        }
        function getSignatureHelpItems2(fileName, position, { triggerReason: triggerReason  } = emptyOptions) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            return ts_SignatureHelp_exports.getSignatureHelpItems(program, sourceFile, position, triggerReason, cancellationToken);
        }
        function getNonBoundSourceFile(fileName) {
            return syntaxTreeCache.getCurrentSourceFile(fileName);
        }
        function getNameOrDottedNameSpan(fileName, startPos, _endPos) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const node = getTouchingPropertyName(sourceFile, startPos);
            if (node === sourceFile) return void 0;
            switch(node.kind){
                case 210 /* PropertyAccessExpression */ :
                case 165 /* QualifiedName */ :
                case 11 /* StringLiteral */ :
                case 97 /* FalseKeyword */ :
                case 112 /* TrueKeyword */ :
                case 106 /* NullKeyword */ :
                case 108 /* SuperKeyword */ :
                case 110 /* ThisKeyword */ :
                case 196 /* ThisType */ :
                case 80 /* Identifier */ :
                    break;
                default:
                    return void 0;
            }
            let nodeForStartPos = node;
            while(true){
                if (isRightSideOfPropertyAccess(nodeForStartPos) || isRightSideOfQualifiedName(nodeForStartPos)) nodeForStartPos = nodeForStartPos.parent;
                else if (isNameOfModuleDeclaration(nodeForStartPos)) {
                    if (nodeForStartPos.parent.parent.kind === 266 /* ModuleDeclaration */  && nodeForStartPos.parent.parent.body === nodeForStartPos.parent) nodeForStartPos = nodeForStartPos.parent.parent.name;
                    else break;
                } else break;
            }
            return createTextSpanFromBounds(nodeForStartPos.getStart(), node.getEnd());
        }
        function getBreakpointStatementAtPosition(fileName, position) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            return ts_BreakpointResolver_exports.spanInSourceFileAtLocation(sourceFile, position);
        }
        function getNavigationBarItems2(fileName) {
            return getNavigationBarItems(syntaxTreeCache.getCurrentSourceFile(fileName), cancellationToken);
        }
        function getNavigationTree2(fileName) {
            return getNavigationTree(syntaxTreeCache.getCurrentSourceFile(fileName), cancellationToken);
        }
        function getSemanticClassifications3(fileName, span, format) {
            synchronizeHostData();
            const responseFormat = format || "original" /* Original */ ;
            if (responseFormat === "2020" /* TwentyTwenty */ ) return getSemanticClassifications2(program, cancellationToken, getValidSourceFile(fileName), span);
            else return getSemanticClassifications(program.getTypeChecker(), cancellationToken, getValidSourceFile(fileName), program.getClassifiableNames(), span);
        }
        function getEncodedSemanticClassifications3(fileName, span, format) {
            synchronizeHostData();
            const responseFormat = format || "original" /* Original */ ;
            if (responseFormat === "original" /* Original */ ) return getEncodedSemanticClassifications(program.getTypeChecker(), cancellationToken, getValidSourceFile(fileName), program.getClassifiableNames(), span);
            else return getEncodedSemanticClassifications2(program, cancellationToken, getValidSourceFile(fileName), span);
        }
        function getSyntacticClassifications2(fileName, span) {
            return getSyntacticClassifications(cancellationToken, syntaxTreeCache.getCurrentSourceFile(fileName), span);
        }
        function getEncodedSyntacticClassifications2(fileName, span) {
            return getEncodedSyntacticClassifications(cancellationToken, syntaxTreeCache.getCurrentSourceFile(fileName), span);
        }
        function getOutliningSpans(fileName) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            return ts_OutliningElementsCollector_exports.collectElements(sourceFile, cancellationToken);
        }
        const braceMatching = new Map(Object.entries({
            [19 /* OpenBraceToken */ ]: 20 /* CloseBraceToken */ ,
            [21 /* OpenParenToken */ ]: 22 /* CloseParenToken */ ,
            [23 /* OpenBracketToken */ ]: 24 /* CloseBracketToken */ ,
            [32 /* GreaterThanToken */ ]: 30 /* LessThanToken */ 
        }));
        braceMatching.forEach((value1, key)=>braceMatching.set(value1.toString(), Number(key)));
        function getBraceMatchingAtPosition(fileName, position) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const token = getTouchingToken(sourceFile, position);
            const matchKind = token.getStart(sourceFile) === position ? braceMatching.get(token.kind.toString()) : void 0;
            const match = matchKind && findChildOfKind(token.parent, matchKind, sourceFile);
            return match ? [
                createTextSpanFromNode(token, sourceFile),
                createTextSpanFromNode(match, sourceFile)
            ].sort((a, b)=>a.start - b.start) : emptyArray;
        }
        function getIndentationAtPosition(fileName, position, editorOptions) {
            let start = timestamp();
            const settings = toEditorSettings(editorOptions);
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            log("getIndentationAtPosition: getCurrentSourceFile: " + (timestamp() - start));
            start = timestamp();
            const result = ts_formatting_exports.SmartIndenter.getIndentation(position, sourceFile, settings);
            log("getIndentationAtPosition: computeIndentation  : " + (timestamp() - start));
            return result;
        }
        function getFormattingEditsForRange(fileName, start, end, options) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            return ts_formatting_exports.formatSelection(start, end, sourceFile, ts_formatting_exports.getFormatContext(toEditorSettings(options), host));
        }
        function getFormattingEditsForDocument(fileName, options) {
            return ts_formatting_exports.formatDocument(syntaxTreeCache.getCurrentSourceFile(fileName), ts_formatting_exports.getFormatContext(toEditorSettings(options), host));
        }
        function getFormattingEditsAfterKeystroke(fileName, position, key, options) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const formatContext = ts_formatting_exports.getFormatContext(toEditorSettings(options), host);
            if (!isInComment(sourceFile, position)) switch(key){
                case "{":
                    return ts_formatting_exports.formatOnOpeningCurly(position, sourceFile, formatContext);
                case "}":
                    return ts_formatting_exports.formatOnClosingCurly(position, sourceFile, formatContext);
                case ";":
                    return ts_formatting_exports.formatOnSemicolon(position, sourceFile, formatContext);
                case "\n":
                    return ts_formatting_exports.formatOnEnter(position, sourceFile, formatContext);
            }
            return [];
        }
        function getCodeFixesAtPosition(fileName, start, end, errorCodes64, formatOptions, preferences = emptyOptions) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const span = createTextSpanFromBounds(start, end);
            const formatContext = ts_formatting_exports.getFormatContext(formatOptions, host);
            return flatMap(deduplicate(errorCodes64, equateValues, compareValues), (errorCode)=>{
                cancellationToken.throwIfCancellationRequested();
                return ts_codefix_exports.getFixes({
                    errorCode: errorCode,
                    sourceFile: sourceFile,
                    span: span,
                    program: program,
                    host: host,
                    cancellationToken: cancellationToken,
                    formatContext: formatContext,
                    preferences: preferences
                });
            });
        }
        function getCombinedCodeFix(scope, fixId52, formatOptions, preferences = emptyOptions) {
            synchronizeHostData();
            Debug.assert(scope.type === "file");
            const sourceFile = getValidSourceFile(scope.fileName);
            const formatContext = ts_formatting_exports.getFormatContext(formatOptions, host);
            return ts_codefix_exports.getAllFixes({
                fixId: fixId52,
                sourceFile: sourceFile,
                program: program,
                host: host,
                cancellationToken: cancellationToken,
                formatContext: formatContext,
                preferences: preferences
            });
        }
        function organizeImports2(args, formatOptions, preferences = emptyOptions) {
            synchronizeHostData();
            Debug.assert(args.type === "file");
            const sourceFile = getValidSourceFile(args.fileName);
            const formatContext = ts_formatting_exports.getFormatContext(formatOptions, host);
            const mode = args.mode ?? (args.skipDestructiveCodeActions ? "SortAndCombine" /* SortAndCombine */  : "All" /* All */ );
            return ts_OrganizeImports_exports.organizeImports(sourceFile, formatContext, host, program, preferences, mode);
        }
        function getEditsForFileRename2(oldFilePath, newFilePath, formatOptions, preferences = emptyOptions) {
            return getEditsForFileRename(getProgram(), oldFilePath, newFilePath, host, ts_formatting_exports.getFormatContext(formatOptions, host), preferences, sourceMapper);
        }
        function applyCodeActionCommand(fileName, actionOrFormatSettingsOrUndefined) {
            const action = typeof fileName === "string" ? actionOrFormatSettingsOrUndefined : fileName;
            return isArray(action) ? Promise.all(action.map((a)=>applySingleCodeActionCommand(a))) : applySingleCodeActionCommand(action);
        }
        function applySingleCodeActionCommand(action) {
            const getPath = (path)=>toPath(path, currentDirectory, getCanonicalFileName);
            Debug.assertEqual(action.type, "install package");
            return host.installPackage ? host.installPackage({
                fileName: getPath(action.file),
                packageName: action.packageName
            }) : Promise.reject("Host does not implement `installPackage`");
        }
        function getDocCommentTemplateAtPosition2(fileName, position, options, formatOptions) {
            const formatSettings = formatOptions ? ts_formatting_exports.getFormatContext(formatOptions, host).options : void 0;
            return ts_JsDoc_exports.getDocCommentTemplateAtPosition(getNewLineOrDefaultFromHost(host, formatSettings), syntaxTreeCache.getCurrentSourceFile(fileName), position, options);
        }
        function isValidBraceCompletionAtPosition(fileName, position, openingBrace) {
            if (openingBrace === 60 /* lessThan */ ) return false;
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            if (isInString(sourceFile, position)) return false;
            if (isInsideJsxElementOrAttribute(sourceFile, position)) return openingBrace === 123 /* openBrace */ ;
            if (isInTemplateString(sourceFile, position)) return false;
            switch(openingBrace){
                case 39 /* singleQuote */ :
                case 34 /* doubleQuote */ :
                case 96 /* backtick */ :
                    return !isInComment(sourceFile, position);
            }
            return true;
        }
        function getJsxClosingTagAtPosition(fileName, position) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const token = findPrecedingToken(position, sourceFile);
            if (!token) return void 0;
            const element = token.kind === 32 /* GreaterThanToken */  && isJsxOpeningElement(token.parent) ? token.parent.parent : isJsxText(token) && isJsxElement(token.parent) ? token.parent : void 0;
            if (element && isUnclosedTag(element)) return {
                newText: `</${element.openingElement.tagName.getText(sourceFile)}>`
            };
            const fragment = token.kind === 32 /* GreaterThanToken */  && isJsxOpeningFragment(token.parent) ? token.parent.parent : isJsxText(token) && isJsxFragment(token.parent) ? token.parent : void 0;
            if (fragment && isUnclosedFragment(fragment)) return {
                newText: "</>"
            };
        }
        function getLinkedEditingRangeAtPosition(fileName, position) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const token = findPrecedingToken(position, sourceFile);
            if (!token || token.parent.kind === 311 /* SourceFile */ ) return void 0;
            const jsxTagWordPattern = "[a-zA-Z0-9:\\-\\._$]*";
            if (isJsxFragment(token.parent.parent)) {
                const openFragment = token.parent.parent.openingFragment;
                const closeFragment = token.parent.parent.closingFragment;
                if (containsParseError(openFragment) || containsParseError(closeFragment)) return void 0;
                const openPos = openFragment.getStart(sourceFile) + 1;
                const closePos = closeFragment.getStart(sourceFile) + 2;
                if (position !== openPos && position !== closePos) return void 0;
                return {
                    ranges: [
                        {
                            start: openPos,
                            length: 0
                        },
                        {
                            start: closePos,
                            length: 0
                        }
                    ],
                    wordPattern: jsxTagWordPattern
                };
            } else {
                const tag = findAncestor(token.parent, (n)=>{
                    if (isJsxOpeningElement(n) || isJsxClosingElement(n)) return true;
                    return false;
                });
                if (!tag) return void 0;
                Debug.assert(isJsxOpeningElement(tag) || isJsxClosingElement(tag), "tag should be opening or closing element");
                const openTag = tag.parent.openingElement;
                const closeTag = tag.parent.closingElement;
                const openTagStart = openTag.tagName.getStart(sourceFile);
                const openTagEnd = openTag.tagName.end;
                const closeTagStart = closeTag.tagName.getStart(sourceFile);
                const closeTagEnd = closeTag.tagName.end;
                if (!(openTagStart <= position && position <= openTagEnd || closeTagStart <= position && position <= closeTagEnd)) return void 0;
                const openingTagText = openTag.tagName.getText(sourceFile);
                if (openingTagText !== closeTag.tagName.getText(sourceFile)) return void 0;
                return {
                    ranges: [
                        {
                            start: openTagStart,
                            length: openTagEnd - openTagStart
                        },
                        {
                            start: closeTagStart,
                            length: closeTagEnd - closeTagStart
                        }
                    ],
                    wordPattern: jsxTagWordPattern
                };
            }
        }
        function getLinesForRange(sourceFile, textRange) {
            return {
                lineStarts: sourceFile.getLineStarts(),
                firstLine: sourceFile.getLineAndCharacterOfPosition(textRange.pos).line,
                lastLine: sourceFile.getLineAndCharacterOfPosition(textRange.end).line
            };
        }
        function toggleLineComment(fileName, textRange, insertComment) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const textChanges2 = [];
            const { lineStarts: lineStarts , firstLine: firstLine , lastLine: lastLine  } = getLinesForRange(sourceFile, textRange);
            let isCommenting = insertComment || false;
            let leftMostPosition = Number.MAX_VALUE;
            const lineTextStarts = /* @__PURE__ */ new Map();
            const firstNonWhitespaceCharacterRegex = new RegExp(/\S/);
            const isJsx = isInsideJsxElement(sourceFile, lineStarts[firstLine]);
            const openComment = isJsx ? "{/*" : "//";
            for(let i = firstLine; i <= lastLine; i++){
                const lineText = sourceFile.text.substring(lineStarts[i], sourceFile.getLineEndOfPosition(lineStarts[i]));
                const regExec = firstNonWhitespaceCharacterRegex.exec(lineText);
                if (regExec) {
                    leftMostPosition = Math.min(leftMostPosition, regExec.index);
                    lineTextStarts.set(i.toString(), regExec.index);
                    if (lineText.substr(regExec.index, openComment.length) !== openComment) isCommenting = insertComment === void 0 || insertComment;
                }
            }
            for(let i = firstLine; i <= lastLine; i++){
                if (firstLine !== lastLine && lineStarts[i] === textRange.end) continue;
                const lineTextStart = lineTextStarts.get(i.toString());
                if (lineTextStart !== void 0) {
                    if (isJsx) textChanges2.push.apply(textChanges2, toggleMultilineComment(fileName, {
                        pos: lineStarts[i] + leftMostPosition,
                        end: sourceFile.getLineEndOfPosition(lineStarts[i])
                    }, isCommenting, isJsx));
                    else if (isCommenting) textChanges2.push({
                        newText: openComment,
                        span: {
                            length: 0,
                            start: lineStarts[i] + leftMostPosition
                        }
                    });
                    else if (sourceFile.text.substr(lineStarts[i] + lineTextStart, openComment.length) === openComment) textChanges2.push({
                        newText: "",
                        span: {
                            length: openComment.length,
                            start: lineStarts[i] + lineTextStart
                        }
                    });
                }
            }
            return textChanges2;
        }
        function toggleMultilineComment(fileName, textRange, insertComment, isInsideJsx) {
            var _a2;
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const textChanges2 = [];
            const { text: text  } = sourceFile;
            let hasComment = false;
            let isCommenting = insertComment || false;
            const positions = [];
            let { pos: pos  } = textRange;
            const isJsx = isInsideJsx !== void 0 ? isInsideJsx : isInsideJsxElement(sourceFile, pos);
            const openMultiline = isJsx ? "{/*" : "/*";
            const closeMultiline = isJsx ? "*/}" : "*/";
            const openMultilineRegex = isJsx ? "\\{\\/\\*" : "\\/\\*";
            const closeMultilineRegex = isJsx ? "\\*\\/\\}" : "\\*\\/";
            while(pos <= textRange.end){
                const offset = text.substr(pos, openMultiline.length) === openMultiline ? openMultiline.length : 0;
                const commentRange = isInComment(sourceFile, pos + offset);
                if (commentRange) {
                    if (isJsx) {
                        commentRange.pos--;
                        commentRange.end++;
                    }
                    positions.push(commentRange.pos);
                    if (commentRange.kind === 3 /* MultiLineCommentTrivia */ ) positions.push(commentRange.end);
                    hasComment = true;
                    pos = commentRange.end + 1;
                } else {
                    const newPos = text.substring(pos, textRange.end).search(`(${openMultilineRegex})|(${closeMultilineRegex})`);
                    isCommenting = insertComment !== void 0 ? insertComment : isCommenting || !isTextWhiteSpaceLike(text, pos, newPos === -1 ? textRange.end : pos + newPos);
                    pos = newPos === -1 ? textRange.end + 1 : pos + newPos + closeMultiline.length;
                }
            }
            if (isCommenting || !hasComment) {
                if (((_a2 = isInComment(sourceFile, textRange.pos)) == null ? void 0 : _a2.kind) !== 2 /* SingleLineCommentTrivia */ ) insertSorted(positions, textRange.pos, compareValues);
                insertSorted(positions, textRange.end, compareValues);
                const firstPos = positions[0];
                if (text.substr(firstPos, openMultiline.length) !== openMultiline) textChanges2.push({
                    newText: openMultiline,
                    span: {
                        length: 0,
                        start: firstPos
                    }
                });
                for(let i = 1; i < positions.length - 1; i++){
                    if (text.substr(positions[i] - closeMultiline.length, closeMultiline.length) !== closeMultiline) textChanges2.push({
                        newText: closeMultiline,
                        span: {
                            length: 0,
                            start: positions[i]
                        }
                    });
                    if (text.substr(positions[i], openMultiline.length) !== openMultiline) textChanges2.push({
                        newText: openMultiline,
                        span: {
                            length: 0,
                            start: positions[i]
                        }
                    });
                }
                if (textChanges2.length % 2 !== 0) textChanges2.push({
                    newText: closeMultiline,
                    span: {
                        length: 0,
                        start: positions[positions.length - 1]
                    }
                });
            } else for (const pos2 of positions){
                const from = pos2 - closeMultiline.length > 0 ? pos2 - closeMultiline.length : 0;
                const offset = text.substr(from, closeMultiline.length) === closeMultiline ? closeMultiline.length : 0;
                textChanges2.push({
                    newText: "",
                    span: {
                        length: openMultiline.length,
                        start: pos2 - offset
                    }
                });
            }
            return textChanges2;
        }
        function commentSelection(fileName, textRange) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const { firstLine: firstLine , lastLine: lastLine  } = getLinesForRange(sourceFile, textRange);
            return firstLine === lastLine && textRange.pos !== textRange.end ? toggleMultilineComment(fileName, textRange, /*insertComment*/ true) : toggleLineComment(fileName, textRange, /*insertComment*/ true);
        }
        function uncommentSelection(fileName, textRange) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const textChanges2 = [];
            const { pos: pos  } = textRange;
            let { end: end  } = textRange;
            if (pos === end) end += isInsideJsxElement(sourceFile, pos) ? 2 : 1;
            for(let i = pos; i <= end; i++){
                const commentRange = isInComment(sourceFile, i);
                if (commentRange) {
                    switch(commentRange.kind){
                        case 2 /* SingleLineCommentTrivia */ :
                            textChanges2.push.apply(textChanges2, toggleLineComment(fileName, {
                                end: commentRange.end,
                                pos: commentRange.pos + 1
                            }, /*insertComment*/ false));
                            break;
                        case 3 /* MultiLineCommentTrivia */ :
                            textChanges2.push.apply(textChanges2, toggleMultilineComment(fileName, {
                                end: commentRange.end,
                                pos: commentRange.pos + 1
                            }, /*insertComment*/ false));
                    }
                    i = commentRange.end + 1;
                }
            }
            return textChanges2;
        }
        function isUnclosedTag({ openingElement: openingElement , closingElement: closingElement , parent: parent2  }) {
            return !tagNamesAreEquivalent(openingElement.tagName, closingElement.tagName) || isJsxElement(parent2) && tagNamesAreEquivalent(openingElement.tagName, parent2.openingElement.tagName) && isUnclosedTag(parent2);
        }
        function isUnclosedFragment({ closingFragment: closingFragment , parent: parent2  }) {
            return !!(closingFragment.flags & 131072 /* ThisNodeHasError */ ) || isJsxFragment(parent2) && isUnclosedFragment(parent2);
        }
        function getSpanOfEnclosingComment(fileName, position, onlyMultiLine) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const range = ts_formatting_exports.getRangeOfEnclosingComment(sourceFile, position);
            return range && (!onlyMultiLine || range.kind === 3 /* MultiLineCommentTrivia */ ) ? createTextSpanFromRange(range) : void 0;
        }
        function getTodoComments(fileName, descriptors) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            cancellationToken.throwIfCancellationRequested();
            const fileContents = sourceFile.text;
            const result = [];
            if (descriptors.length > 0 && !isNodeModulesFile(sourceFile.fileName)) {
                const regExp = getTodoCommentsRegExp();
                let matchArray;
                while(matchArray = regExp.exec(fileContents)){
                    cancellationToken.throwIfCancellationRequested();
                    const firstDescriptorCaptureIndex = 3;
                    Debug.assert(matchArray.length === descriptors.length + firstDescriptorCaptureIndex);
                    const preamble = matchArray[1];
                    const matchPosition = matchArray.index + preamble.length;
                    if (!isInComment(sourceFile, matchPosition)) continue;
                    let descriptor;
                    for(let i = 0; i < descriptors.length; i++)if (matchArray[i + firstDescriptorCaptureIndex]) descriptor = descriptors[i];
                    if (descriptor === void 0) return Debug.fail();
                    if (isLetterOrDigit(fileContents.charCodeAt(matchPosition + descriptor.text.length))) continue;
                    const message = matchArray[2];
                    result.push({
                        descriptor: descriptor,
                        message: message,
                        position: matchPosition
                    });
                }
            }
            return result;
            function escapeRegExp(str) {
                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            }
            function getTodoCommentsRegExp() {
                const singleLineCommentStart = /(?:\/\/+\s*)/.source;
                const multiLineCommentStart = /(?:\/\*+\s*)/.source;
                const anyNumberOfSpacesAndAsterisksAtStartOfLine = /(?:^(?:\s|\*)*)/.source;
                const preamble = "(" + anyNumberOfSpacesAndAsterisksAtStartOfLine + "|" + singleLineCommentStart + "|" + multiLineCommentStart + ")";
                const literals = "(?:" + map(descriptors, (d)=>"(" + escapeRegExp(d.text) + ")").join("|") + ")";
                const endOfLineOrEndOfComment = /(?:$|\*\/)/.source;
                const messageRemainder = /(?:.*?)/.source;
                const messagePortion = "(" + literals + messageRemainder + ")";
                const regExpString = preamble + messagePortion + endOfLineOrEndOfComment;
                return new RegExp(regExpString, "gim");
            }
            function isLetterOrDigit(char) {
                return char >= 97 /* a */  && char <= 122 /* z */  || char >= 65 /* A */  && char <= 90 /* Z */  || char >= 48 /* _0 */  && char <= 57 /* _9 */ ;
            }
            function isNodeModulesFile(path) {
                return stringContains(path, "/node_modules/");
            }
        }
        function getRenameInfo2(fileName, position, preferences) {
            synchronizeHostData();
            return ts_Rename_exports.getRenameInfo(program, getValidSourceFile(fileName), position, preferences || {});
        }
        function getRefactorContext(file, positionOrRange, preferences, formatOptions, triggerReason, kind) {
            const [startPosition, endPosition] = typeof positionOrRange === "number" ? [
                positionOrRange,
                void 0
            ] : [
                positionOrRange.pos,
                positionOrRange.end
            ];
            return {
                file: file,
                startPosition: startPosition,
                endPosition: endPosition,
                program: getProgram(),
                host: host,
                formatContext: ts_formatting_exports.getFormatContext(formatOptions, host),
                cancellationToken: // TODO: GH#18217
                cancellationToken,
                preferences: preferences,
                triggerReason: triggerReason,
                kind: kind
            };
        }
        function getInlayHintsContext(file, span, preferences) {
            return {
                file: file,
                program: getProgram(),
                host: host,
                span: span,
                preferences: preferences,
                cancellationToken: cancellationToken
            };
        }
        function getSmartSelectionRange2(fileName, position) {
            return ts_SmartSelectionRange_exports.getSmartSelectionRange(position, syntaxTreeCache.getCurrentSourceFile(fileName));
        }
        function getApplicableRefactors2(fileName, positionOrRange, preferences = emptyOptions, triggerReason, kind, includeInteractiveActions) {
            synchronizeHostData();
            const file = getValidSourceFile(fileName);
            return ts_refactor_exports.getApplicableRefactors(getRefactorContext(file, positionOrRange, preferences, emptyOptions, triggerReason, kind), includeInteractiveActions);
        }
        function getMoveToRefactoringFileSuggestions(fileName, positionOrRange, preferences = emptyOptions) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const allFiles = Debug.checkDefined(program.getSourceFiles());
            const extension = extensionFromPath(fileName);
            const files = mapDefined(allFiles, (file)=>!(program == null ? void 0 : program.isSourceFileFromExternalLibrary(sourceFile)) && !(sourceFile === getValidSourceFile(file.fileName) || extension === ".ts" /* Ts */  && extensionFromPath(file.fileName) === ".d.ts" /* Dts */  || extension === ".d.ts" /* Dts */  && startsWith(getBaseFileName(file.fileName), "lib.") && extensionFromPath(file.fileName) === ".d.ts" /* Dts */ ) && extension === extensionFromPath(file.fileName) ? file.fileName : void 0);
            const newFileName = createNewFileName(sourceFile, program, getRefactorContext(sourceFile, positionOrRange, preferences, emptyOptions), host);
            return {
                newFileName: newFileName,
                files: files
            };
        }
        function getEditsForRefactor2(fileName, formatOptions, positionOrRange, refactorName13, actionName2, preferences = emptyOptions, interactiveRefactorArguments) {
            synchronizeHostData();
            const file = getValidSourceFile(fileName);
            return ts_refactor_exports.getEditsForRefactor(getRefactorContext(file, positionOrRange, preferences, formatOptions), refactorName13, actionName2, interactiveRefactorArguments);
        }
        function toLineColumnOffset(fileName, position) {
            if (position === 0) return {
                line: 0,
                character: 0
            };
            return sourceMapper.toLineColumnOffset(fileName, position);
        }
        function prepareCallHierarchy(fileName, position) {
            synchronizeHostData();
            const declarations = ts_CallHierarchy_exports.resolveCallHierarchyDeclaration(program, getTouchingPropertyName(getValidSourceFile(fileName), position));
            return declarations && mapOneOrMany(declarations, (declaration)=>ts_CallHierarchy_exports.createCallHierarchyItem(program, declaration));
        }
        function provideCallHierarchyIncomingCalls(fileName, position) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const declaration = firstOrOnly(ts_CallHierarchy_exports.resolveCallHierarchyDeclaration(program, position === 0 ? sourceFile : getTouchingPropertyName(sourceFile, position)));
            return declaration ? ts_CallHierarchy_exports.getIncomingCalls(program, declaration, cancellationToken) : [];
        }
        function provideCallHierarchyOutgoingCalls(fileName, position) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const declaration = firstOrOnly(ts_CallHierarchy_exports.resolveCallHierarchyDeclaration(program, position === 0 ? sourceFile : getTouchingPropertyName(sourceFile, position)));
            return declaration ? ts_CallHierarchy_exports.getOutgoingCalls(program, declaration) : [];
        }
        function provideInlayHints2(fileName, span, preferences = emptyOptions) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            return ts_InlayHints_exports.provideInlayHints(getInlayHintsContext(sourceFile, span, preferences));
        }
        const ls = {
            dispose: dispose,
            cleanupSemanticCache: cleanupSemanticCache,
            getSyntacticDiagnostics: getSyntacticDiagnostics,
            getSemanticDiagnostics: getSemanticDiagnostics,
            getSuggestionDiagnostics: getSuggestionDiagnostics,
            getCompilerOptionsDiagnostics: getCompilerOptionsDiagnostics,
            getSyntacticClassifications: getSyntacticClassifications2,
            getSemanticClassifications: getSemanticClassifications3,
            getEncodedSyntacticClassifications: getEncodedSyntacticClassifications2,
            getEncodedSemanticClassifications: getEncodedSemanticClassifications3,
            getCompletionsAtPosition: getCompletionsAtPosition2,
            getCompletionEntryDetails: getCompletionEntryDetails2,
            getCompletionEntrySymbol: getCompletionEntrySymbol2,
            getSignatureHelpItems: getSignatureHelpItems2,
            getQuickInfoAtPosition: getQuickInfoAtPosition,
            getDefinitionAtPosition: getDefinitionAtPosition2,
            getDefinitionAndBoundSpan: getDefinitionAndBoundSpan2,
            getImplementationAtPosition: getImplementationAtPosition,
            getTypeDefinitionAtPosition: getTypeDefinitionAtPosition2,
            getReferencesAtPosition: getReferencesAtPosition,
            findReferences: findReferences,
            getFileReferences: getFileReferences,
            getDocumentHighlights: getDocumentHighlights,
            getNameOrDottedNameSpan: getNameOrDottedNameSpan,
            getBreakpointStatementAtPosition: getBreakpointStatementAtPosition,
            getNavigateToItems: getNavigateToItems2,
            getRenameInfo: getRenameInfo2,
            getSmartSelectionRange: getSmartSelectionRange2,
            findRenameLocations: findRenameLocations,
            getNavigationBarItems: getNavigationBarItems2,
            getNavigationTree: getNavigationTree2,
            getOutliningSpans: getOutliningSpans,
            getTodoComments: getTodoComments,
            getBraceMatchingAtPosition: getBraceMatchingAtPosition,
            getIndentationAtPosition: getIndentationAtPosition,
            getFormattingEditsForRange: getFormattingEditsForRange,
            getFormattingEditsForDocument: getFormattingEditsForDocument,
            getFormattingEditsAfterKeystroke: getFormattingEditsAfterKeystroke,
            getDocCommentTemplateAtPosition: getDocCommentTemplateAtPosition2,
            isValidBraceCompletionAtPosition: isValidBraceCompletionAtPosition,
            getJsxClosingTagAtPosition: getJsxClosingTagAtPosition,
            getLinkedEditingRangeAtPosition: getLinkedEditingRangeAtPosition,
            getSpanOfEnclosingComment: getSpanOfEnclosingComment,
            getCodeFixesAtPosition: getCodeFixesAtPosition,
            getCombinedCodeFix: getCombinedCodeFix,
            applyCodeActionCommand: applyCodeActionCommand,
            organizeImports: organizeImports2,
            getEditsForFileRename: getEditsForFileRename2,
            getEmitOutput: getEmitOutput,
            getNonBoundSourceFile: getNonBoundSourceFile,
            getProgram: getProgram,
            getCurrentProgram: ()=>program,
            getAutoImportProvider: getAutoImportProvider,
            updateIsDefinitionOfReferencedSymbols: updateIsDefinitionOfReferencedSymbols,
            getApplicableRefactors: getApplicableRefactors2,
            getEditsForRefactor: getEditsForRefactor2,
            getMoveToRefactoringFileSuggestions: getMoveToRefactoringFileSuggestions,
            toLineColumnOffset: toLineColumnOffset,
            getSourceMapper: ()=>sourceMapper,
            clearSourceMapperCache: ()=>sourceMapper.clearCache(),
            prepareCallHierarchy: prepareCallHierarchy,
            provideCallHierarchyIncomingCalls: provideCallHierarchyIncomingCalls,
            provideCallHierarchyOutgoingCalls: provideCallHierarchyOutgoingCalls,
            toggleLineComment: toggleLineComment,
            toggleMultilineComment: toggleMultilineComment,
            commentSelection: commentSelection,
            uncommentSelection: uncommentSelection,
            provideInlayHints: provideInlayHints2,
            getSupportedCodeFixes: getSupportedCodeFixes
        };
        switch(languageServiceMode){
            case 0 /* Semantic */ :
                break;
            case 1 /* PartialSemantic */ :
                invalidOperationsInPartialSemanticMode.forEach((key)=>ls[key] = ()=>{
                        throw new Error(`LanguageService Operation: ${key} not allowed in LanguageServiceMode.PartialSemantic`);
                    });
                break;
            case 2 /* Syntactic */ :
                invalidOperationsInSyntacticMode.forEach((key)=>ls[key] = ()=>{
                        throw new Error(`LanguageService Operation: ${key} not allowed in LanguageServiceMode.Syntactic`);
                    });
                break;
            default:
                Debug.assertNever(languageServiceMode);
        }
        return ls;
    }
    function getNameTable(sourceFile) {
        if (!sourceFile.nameTable) initializeNameTable(sourceFile);
        return sourceFile.nameTable;
    }
    function initializeNameTable(sourceFile) {
        const nameTable = sourceFile.nameTable = /* @__PURE__ */ new Map();
        sourceFile.forEachChild(function walk(node) {
            if (isIdentifier(node) && !isTagName(node) && node.escapedText || isStringOrNumericLiteralLike(node) && literalIsName(node)) {
                const text = getEscapedTextOfIdentifierOrLiteral(node);
                nameTable.set(text, nameTable.get(text) === void 0 ? node.pos : -1);
            } else if (isPrivateIdentifier(node)) {
                const text = node.escapedText;
                nameTable.set(text, nameTable.get(text) === void 0 ? node.pos : -1);
            }
            forEachChild(node, walk);
            if (hasJSDocNodes(node)) for (const jsDoc of node.jsDoc)forEachChild(jsDoc, walk);
        });
    }
    function literalIsName(node) {
        return isDeclarationName(node) || node.parent.kind === 282 /* ExternalModuleReference */  || isArgumentOfElementAccessExpression(node) || isLiteralComputedPropertyDeclarationName(node);
    }
    function getContainingObjectLiteralElement(node) {
        const element = getContainingObjectLiteralElementWorker(node);
        return element && (isObjectLiteralExpression(element.parent) || isJsxAttributes(element.parent)) ? element : void 0;
    }
    function getContainingObjectLiteralElementWorker(node) {
        switch(node.kind){
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 9 /* NumericLiteral */ :
                if (node.parent.kind === 166 /* ComputedPropertyName */ ) return isObjectLiteralElement(node.parent.parent) ? node.parent.parent : void 0;
            case 80 /* Identifier */ :
                return isObjectLiteralElement(node.parent) && (node.parent.parent.kind === 209 /* ObjectLiteralExpression */  || node.parent.parent.kind === 291 /* JsxAttributes */ ) && node.parent.name === node ? node.parent : void 0;
        }
        return void 0;
    }
    function getSymbolAtLocationForQuickInfo(node, checker) {
        const object = getContainingObjectLiteralElement(node);
        if (object) {
            const contextualType = checker.getContextualType(object.parent);
            const properties = contextualType && getPropertySymbolsFromContextualType(object, checker, contextualType, /*unionSymbolOk*/ false);
            if (properties && properties.length === 1) return first(properties);
        }
        return checker.getSymbolAtLocation(node);
    }
    function getPropertySymbolsFromContextualType(node, checker, contextualType, unionSymbolOk) {
        const name = getNameFromPropertyName(node.name);
        if (!name) return emptyArray;
        if (!contextualType.isUnion()) {
            const symbol = contextualType.getProperty(name);
            return symbol ? [
                symbol
            ] : emptyArray;
        }
        const discriminatedPropertySymbols = mapDefined(contextualType.types, (t)=>(isObjectLiteralExpression(node.parent) || isJsxAttributes(node.parent)) && checker.isTypeInvalidDueToUnionDiscriminant(t, node.parent) ? void 0 : t.getProperty(name));
        if (unionSymbolOk && (discriminatedPropertySymbols.length === 0 || discriminatedPropertySymbols.length === contextualType.types.length)) {
            const symbol = contextualType.getProperty(name);
            if (symbol) return [
                symbol
            ];
        }
        if (discriminatedPropertySymbols.length === 0) return mapDefined(contextualType.types, (t)=>t.getProperty(name));
        return discriminatedPropertySymbols;
    }
    function isArgumentOfElementAccessExpression(node) {
        return node && node.parent && node.parent.kind === 211 /* ElementAccessExpression */  && node.parent.argumentExpression === node;
    }
    function getDefaultLibFilePath(options) {
        if (sys) return combinePaths(getDirectoryPath(normalizePath(sys.getExecutingFilePath())), getDefaultLibFileName(options));
        throw new Error("getDefaultLibFilePath is only supported when consumed as a node module. ");
    }
    var servicesVersion, NodeObject, TokenOrIdentifierObject, SymbolObject, TokenObject, IdentifierObject, PrivateIdentifierObject, TypeObject, SignatureObject, SourceFileObject, SourceMapSourceObject, SyntaxTreeCache, NoopCancellationToken, CancellationTokenObject, ThrottledCancellationToken, invalidOperationsInPartialSemanticMode, invalidOperationsInSyntacticMode;
    var init_services = __esm({
        "src/services/services.ts" () {
            "use strict";
            init_ts4();
            init_ts_NavigateTo();
            init_ts_NavigationBar();
            init_ts_refactor();
            init_classifier();
            init_classifier2020();
            servicesVersion = "0.8";
            NodeObject = class {
                constructor(kind, pos, end){
                    this.pos = pos;
                    this.end = end;
                    this.flags = 0 /* None */ ;
                    this.modifierFlagsCache = 0 /* None */ ;
                    this.transformFlags = 0 /* None */ ;
                    this.parent = void 0;
                    this.kind = kind;
                }
                assertHasRealPosition(message) {
                    Debug.assert(!positionIsSynthesized(this.pos) && !positionIsSynthesized(this.end), message || "Node must have a real position for this operation");
                }
                getSourceFile() {
                    return getSourceFileOfNode(this);
                }
                getStart(sourceFile, includeJsDocComment) {
                    this.assertHasRealPosition();
                    return getTokenPosOfNode(this, sourceFile, includeJsDocComment);
                }
                getFullStart() {
                    this.assertHasRealPosition();
                    return this.pos;
                }
                getEnd() {
                    this.assertHasRealPosition();
                    return this.end;
                }
                getWidth(sourceFile) {
                    this.assertHasRealPosition();
                    return this.getEnd() - this.getStart(sourceFile);
                }
                getFullWidth() {
                    this.assertHasRealPosition();
                    return this.end - this.pos;
                }
                getLeadingTriviaWidth(sourceFile) {
                    this.assertHasRealPosition();
                    return this.getStart(sourceFile) - this.pos;
                }
                getFullText(sourceFile) {
                    this.assertHasRealPosition();
                    return (sourceFile || this.getSourceFile()).text.substring(this.pos, this.end);
                }
                getText(sourceFile) {
                    this.assertHasRealPosition();
                    if (!sourceFile) sourceFile = this.getSourceFile();
                    return sourceFile.text.substring(this.getStart(sourceFile), this.getEnd());
                }
                getChildCount(sourceFile) {
                    return this.getChildren(sourceFile).length;
                }
                getChildAt(index, sourceFile) {
                    return this.getChildren(sourceFile)[index];
                }
                getChildren(sourceFile) {
                    this.assertHasRealPosition("Node without a real position cannot be scanned and thus has no token nodes - use forEachChild and collect the result if that's fine");
                    return this._children || (this._children = createChildren(this, sourceFile));
                }
                getFirstToken(sourceFile) {
                    this.assertHasRealPosition();
                    const children = this.getChildren(sourceFile);
                    if (!children.length) return void 0;
                    const child = find(children, (kid)=>kid.kind < 315 /* FirstJSDocNode */  || kid.kind > 356 /* LastJSDocNode */ );
                    return child.kind < 165 /* FirstNode */  ? child : child.getFirstToken(sourceFile);
                }
                getLastToken(sourceFile) {
                    this.assertHasRealPosition();
                    const children = this.getChildren(sourceFile);
                    const child = lastOrUndefined(children);
                    if (!child) return void 0;
                    return child.kind < 165 /* FirstNode */  ? child : child.getLastToken(sourceFile);
                }
                forEachChild(cbNode, cbNodeArray) {
                    return forEachChild(this, cbNode, cbNodeArray);
                }
            };
            TokenOrIdentifierObject = class {
                constructor(pos, end){
                    this.pos = pos;
                    this.end = end;
                    this.flags = 0 /* None */ ;
                    this.modifierFlagsCache = 0 /* None */ ;
                    this.transformFlags = 0 /* None */ ;
                    this.parent = void 0;
                }
                getSourceFile() {
                    return getSourceFileOfNode(this);
                }
                getStart(sourceFile, includeJsDocComment) {
                    return getTokenPosOfNode(this, sourceFile, includeJsDocComment);
                }
                getFullStart() {
                    return this.pos;
                }
                getEnd() {
                    return this.end;
                }
                getWidth(sourceFile) {
                    return this.getEnd() - this.getStart(sourceFile);
                }
                getFullWidth() {
                    return this.end - this.pos;
                }
                getLeadingTriviaWidth(sourceFile) {
                    return this.getStart(sourceFile) - this.pos;
                }
                getFullText(sourceFile) {
                    return (sourceFile || this.getSourceFile()).text.substring(this.pos, this.end);
                }
                getText(sourceFile) {
                    if (!sourceFile) sourceFile = this.getSourceFile();
                    return sourceFile.text.substring(this.getStart(sourceFile), this.getEnd());
                }
                getChildCount() {
                    return this.getChildren().length;
                }
                getChildAt(index) {
                    return this.getChildren()[index];
                }
                getChildren() {
                    return this.kind === 1 /* EndOfFileToken */  ? this.jsDoc || emptyArray : emptyArray;
                }
                getFirstToken() {
                    return void 0;
                }
                getLastToken() {
                    return void 0;
                }
                forEachChild() {
                    return void 0;
                }
            };
            SymbolObject = class {
                constructor(flags, name){
                    this.id = 0;
                    this.mergeId = 0;
                    this.flags = flags;
                    this.escapedName = name;
                }
                getFlags() {
                    return this.flags;
                }
                get name() {
                    return symbolName(this);
                }
                getEscapedName() {
                    return this.escapedName;
                }
                getName() {
                    return this.name;
                }
                getDeclarations() {
                    return this.declarations;
                }
                getDocumentationComment(checker) {
                    if (!this.documentationComment) {
                        this.documentationComment = emptyArray;
                        if (!this.declarations && isTransientSymbol(this) && this.links.target && isTransientSymbol(this.links.target) && this.links.target.links.tupleLabelDeclaration) {
                            const labelDecl = this.links.target.links.tupleLabelDeclaration;
                            this.documentationComment = getDocumentationComment([
                                labelDecl
                            ], checker);
                        } else this.documentationComment = getDocumentationComment(this.declarations, checker);
                    }
                    return this.documentationComment;
                }
                getContextualDocumentationComment(context, checker) {
                    if (context) {
                        if (isGetAccessor(context)) {
                            if (!this.contextualGetAccessorDocumentationComment) this.contextualGetAccessorDocumentationComment = getDocumentationComment(filter(this.declarations, isGetAccessor), checker);
                            if (length(this.contextualGetAccessorDocumentationComment)) return this.contextualGetAccessorDocumentationComment;
                        }
                        if (isSetAccessor(context)) {
                            if (!this.contextualSetAccessorDocumentationComment) this.contextualSetAccessorDocumentationComment = getDocumentationComment(filter(this.declarations, isSetAccessor), checker);
                            if (length(this.contextualSetAccessorDocumentationComment)) return this.contextualSetAccessorDocumentationComment;
                        }
                    }
                    return this.getDocumentationComment(checker);
                }
                getJsDocTags(checker) {
                    if (this.tags === void 0) this.tags = getJsDocTagsOfDeclarations(this.declarations, checker);
                    return this.tags;
                }
                getContextualJsDocTags(context, checker) {
                    if (context) {
                        if (isGetAccessor(context)) {
                            if (!this.contextualGetAccessorTags) this.contextualGetAccessorTags = getJsDocTagsOfDeclarations(filter(this.declarations, isGetAccessor), checker);
                            if (length(this.contextualGetAccessorTags)) return this.contextualGetAccessorTags;
                        }
                        if (isSetAccessor(context)) {
                            if (!this.contextualSetAccessorTags) this.contextualSetAccessorTags = getJsDocTagsOfDeclarations(filter(this.declarations, isSetAccessor), checker);
                            if (length(this.contextualSetAccessorTags)) return this.contextualSetAccessorTags;
                        }
                    }
                    return this.getJsDocTags(checker);
                }
            };
            TokenObject = class extends TokenOrIdentifierObject {
                constructor(kind, pos, end){
                    super(pos, end);
                    this.kind = kind;
                }
            };
            IdentifierObject = class extends TokenOrIdentifierObject {
                constructor(_kind, pos, end){
                    super(pos, end);
                    this.kind = 80 /* Identifier */ ;
                }
                get text() {
                    return idText(this);
                }
            };
            IdentifierObject.prototype.kind = 80 /* Identifier */ ;
            PrivateIdentifierObject = class extends TokenOrIdentifierObject {
                constructor(_kind, pos, end){
                    super(pos, end);
                    this.kind = 81 /* PrivateIdentifier */ ;
                }
                get text() {
                    return idText(this);
                }
            };
            PrivateIdentifierObject.prototype.kind = 81 /* PrivateIdentifier */ ;
            TypeObject = class {
                constructor(checker, flags){
                    this.checker = checker;
                    this.flags = flags;
                }
                getFlags() {
                    return this.flags;
                }
                getSymbol() {
                    return this.symbol;
                }
                getProperties() {
                    return this.checker.getPropertiesOfType(this);
                }
                getProperty(propertyName) {
                    return this.checker.getPropertyOfType(this, propertyName);
                }
                getApparentProperties() {
                    return this.checker.getAugmentedPropertiesOfType(this);
                }
                getCallSignatures() {
                    return this.checker.getSignaturesOfType(this, 0 /* Call */ );
                }
                getConstructSignatures() {
                    return this.checker.getSignaturesOfType(this, 1 /* Construct */ );
                }
                getStringIndexType() {
                    return this.checker.getIndexTypeOfType(this, 0 /* String */ );
                }
                getNumberIndexType() {
                    return this.checker.getIndexTypeOfType(this, 1 /* Number */ );
                }
                getBaseTypes() {
                    return this.isClassOrInterface() ? this.checker.getBaseTypes(this) : void 0;
                }
                isNullableType() {
                    return this.checker.isNullableType(this);
                }
                getNonNullableType() {
                    return this.checker.getNonNullableType(this);
                }
                getNonOptionalType() {
                    return this.checker.getNonOptionalType(this);
                }
                getConstraint() {
                    return this.checker.getBaseConstraintOfType(this);
                }
                getDefault() {
                    return this.checker.getDefaultFromTypeParameter(this);
                }
                isUnion() {
                    return !!(this.flags & 1048576 /* Union */ );
                }
                isIntersection() {
                    return !!(this.flags & 2097152 /* Intersection */ );
                }
                isUnionOrIntersection() {
                    return !!(this.flags & 3145728 /* UnionOrIntersection */ );
                }
                isLiteral() {
                    return !!(this.flags & 2432 /* BigIntLiteral */ );
                }
                isStringLiteral() {
                    return !!(this.flags & 128 /* StringLiteral */ );
                }
                isNumberLiteral() {
                    return !!(this.flags & 256 /* NumberLiteral */ );
                }
                isTypeParameter() {
                    return !!(this.flags & 262144 /* TypeParameter */ );
                }
                isClassOrInterface() {
                    return !!(getObjectFlags(this) & 3 /* ClassOrInterface */ );
                }
                isClass() {
                    return !!(getObjectFlags(this) & 1 /* Class */ );
                }
                isIndexType() {
                    return !!(this.flags & 4194304 /* Index */ );
                }
                /**
         * This polyfills `referenceType.typeArguments` for API consumers
         */ get typeArguments() {
                    if (getObjectFlags(this) & 4 /* Reference */ ) return this.checker.getTypeArguments(this);
                    return void 0;
                }
            };
            SignatureObject = class {
                // same
                constructor(checker, flags){
                    this.checker = checker;
                    this.flags = flags;
                }
                getDeclaration() {
                    return this.declaration;
                }
                getTypeParameters() {
                    return this.typeParameters;
                }
                getParameters() {
                    return this.parameters;
                }
                getReturnType() {
                    return this.checker.getReturnTypeOfSignature(this);
                }
                getTypeParameterAtPosition(pos) {
                    const type = this.checker.getParameterType(this, pos);
                    if (type.isIndexType() && isThisTypeParameter(type.type)) {
                        const constraint = type.type.getConstraint();
                        if (constraint) return this.checker.getIndexType(constraint);
                    }
                    return type;
                }
                getDocumentationComment() {
                    return this.documentationComment || (this.documentationComment = getDocumentationComment(singleElementArray(this.declaration), this.checker));
                }
                getJsDocTags() {
                    return this.jsDocTags || (this.jsDocTags = getJsDocTagsOfDeclarations(singleElementArray(this.declaration), this.checker));
                }
            };
            SourceFileObject = class extends NodeObject {
                constructor(kind, pos, end){
                    super(kind, pos, end);
                    this.kind = 311 /* SourceFile */ ;
                }
                update(newText, textChangeRange) {
                    return updateSourceFile(this, newText, textChangeRange);
                }
                getLineAndCharacterOfPosition(position) {
                    return getLineAndCharacterOfPosition(this, position);
                }
                getLineStarts() {
                    return getLineStarts(this);
                }
                getPositionOfLineAndCharacter(line, character, allowEdits) {
                    return computePositionOfLineAndCharacter(getLineStarts(this), line, character, this.text, allowEdits);
                }
                getLineEndOfPosition(pos) {
                    const { line: line  } = this.getLineAndCharacterOfPosition(pos);
                    const lineStarts = this.getLineStarts();
                    let lastCharPos;
                    if (line + 1 >= lineStarts.length) lastCharPos = this.getEnd();
                    if (!lastCharPos) lastCharPos = lineStarts[line + 1] - 1;
                    const fullText = this.getFullText();
                    return fullText[lastCharPos] === "\n" && fullText[lastCharPos - 1] === "\r" ? lastCharPos - 1 : lastCharPos;
                }
                getNamedDeclarations() {
                    if (!this.namedDeclarations) this.namedDeclarations = this.computeNamedDeclarations();
                    return this.namedDeclarations;
                }
                computeNamedDeclarations() {
                    const result = createMultiMap();
                    this.forEachChild(visit);
                    return result;
                    function addDeclaration(declaration) {
                        const name = getDeclarationName(declaration);
                        if (name) result.add(name, declaration);
                    }
                    function getDeclarations(name) {
                        let declarations = result.get(name);
                        if (!declarations) result.set(name, declarations = []);
                        return declarations;
                    }
                    function getDeclarationName(declaration) {
                        const name = getNonAssignedNameOfDeclaration(declaration);
                        return name && (isComputedPropertyName(name) && isPropertyAccessExpression(name.expression) ? name.expression.name.text : isPropertyName(name) ? getNameFromPropertyName(name) : void 0);
                    }
                    function visit(node) {
                        switch(node.kind){
                            case 261 /* FunctionDeclaration */ :
                            case 217 /* FunctionExpression */ :
                            case 173 /* MethodDeclaration */ :
                            case 172 /* MethodSignature */ :
                                const functionDeclaration = node;
                                const declarationName = getDeclarationName(functionDeclaration);
                                if (declarationName) {
                                    const declarations = getDeclarations(declarationName);
                                    const lastDeclaration = lastOrUndefined(declarations);
                                    if (lastDeclaration && functionDeclaration.parent === lastDeclaration.parent && functionDeclaration.symbol === lastDeclaration.symbol) {
                                        if (functionDeclaration.body && !lastDeclaration.body) declarations[declarations.length - 1] = functionDeclaration;
                                    } else declarations.push(functionDeclaration);
                                }
                                forEachChild(node, visit);
                                break;
                            case 262 /* ClassDeclaration */ :
                            case 230 /* ClassExpression */ :
                            case 263 /* InterfaceDeclaration */ :
                            case 264 /* TypeAliasDeclaration */ :
                            case 265 /* EnumDeclaration */ :
                            case 266 /* ModuleDeclaration */ :
                            case 270 /* ImportEqualsDeclaration */ :
                            case 280 /* ExportSpecifier */ :
                            case 275 /* ImportSpecifier */ :
                            case 272 /* ImportClause */ :
                            case 273 /* NamespaceImport */ :
                            case 176 /* GetAccessor */ :
                            case 177 /* SetAccessor */ :
                            case 186 /* TypeLiteral */ :
                                addDeclaration(node);
                                forEachChild(node, visit);
                                break;
                            case 168 /* Parameter */ :
                                if (!hasSyntacticModifier(node, 16476 /* ParameterPropertyModifier */ )) break;
                            case 259 /* VariableDeclaration */ :
                            case 207 /* BindingElement */ :
                                {
                                    const decl = node;
                                    if (isBindingPattern(decl.name)) {
                                        forEachChild(decl.name, visit);
                                        break;
                                    }
                                    if (decl.initializer) visit(decl.initializer);
                                }
                            case 305 /* EnumMember */ :
                            case 171 /* PropertyDeclaration */ :
                            case 170 /* PropertySignature */ :
                                addDeclaration(node);
                                break;
                            case 277 /* ExportDeclaration */ :
                                const exportDeclaration = node;
                                if (exportDeclaration.exportClause) {
                                    if (isNamedExports(exportDeclaration.exportClause)) forEach(exportDeclaration.exportClause.elements, visit);
                                    else visit(exportDeclaration.exportClause.name);
                                }
                                break;
                            case 271 /* ImportDeclaration */ :
                                const importClause = node.importClause;
                                if (importClause) {
                                    if (importClause.name) addDeclaration(importClause.name);
                                    if (importClause.namedBindings) {
                                        if (importClause.namedBindings.kind === 273 /* NamespaceImport */ ) addDeclaration(importClause.namedBindings);
                                        else forEach(importClause.namedBindings.elements, visit);
                                    }
                                }
                                break;
                            case 225 /* BinaryExpression */ :
                                if (getAssignmentDeclarationKind(node) !== 0 /* None */ ) addDeclaration(node);
                            default:
                                forEachChild(node, visit);
                        }
                    }
                }
            };
            SourceMapSourceObject = class {
                constructor(fileName, text, skipTrivia2){
                    this.fileName = fileName;
                    this.text = text;
                    this.skipTrivia = skipTrivia2;
                }
                getLineAndCharacterOfPosition(pos) {
                    return getLineAndCharacterOfPosition(this, pos);
                }
            };
            SyntaxTreeCache = class {
                constructor(host){
                    this.host = host;
                }
                getCurrentSourceFile(fileName) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    const scriptSnapshot = this.host.getScriptSnapshot(fileName);
                    if (!scriptSnapshot) throw new Error("Could not find file: '" + fileName + "'.");
                    const scriptKind = getScriptKind(fileName, this.host);
                    const version2 = this.host.getScriptVersion(fileName);
                    let sourceFile;
                    if (this.currentFileName !== fileName) {
                        const options = {
                            languageVersion: 99 /* Latest */ ,
                            impliedNodeFormat: getImpliedNodeFormatForFile(toPath(fileName, this.host.getCurrentDirectory(), ((_c = (_b = (_a = this.host).getCompilerHost) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.getCanonicalFileName) || hostGetCanonicalFileName(this.host)), (_h = (_g = (_f = (_e = (_d = this.host).getCompilerHost) == null ? void 0 : _e.call(_d)) == null ? void 0 : _f.getModuleResolutionCache) == null ? void 0 : _g.call(_f)) == null ? void 0 : _h.getPackageJsonInfoCache(), this.host, this.host.getCompilationSettings()),
                            setExternalModuleIndicator: getSetExternalModuleIndicator(this.host.getCompilationSettings())
                        };
                        sourceFile = createLanguageServiceSourceFile(fileName, scriptSnapshot, options, version2, /*setNodeParents*/ true, scriptKind);
                    } else if (this.currentFileVersion !== version2) {
                        const editRange = scriptSnapshot.getChangeRange(this.currentFileScriptSnapshot);
                        sourceFile = updateLanguageServiceSourceFile(this.currentSourceFile, scriptSnapshot, version2, editRange);
                    }
                    if (sourceFile) {
                        this.currentFileVersion = version2;
                        this.currentFileName = fileName;
                        this.currentFileScriptSnapshot = scriptSnapshot;
                        this.currentSourceFile = sourceFile;
                    }
                    return this.currentSourceFile;
                }
            };
            NoopCancellationToken = {
                isCancellationRequested: returnFalse,
                throwIfCancellationRequested: noop
            };
            CancellationTokenObject = class {
                constructor(cancellationToken){
                    this.cancellationToken = cancellationToken;
                }
                isCancellationRequested() {
                    return this.cancellationToken.isCancellationRequested();
                }
                throwIfCancellationRequested() {
                    var _a;
                    if (this.isCancellationRequested()) {
                        (_a = tracing) == null || _a.instant(tracing.Phase.Session, "cancellationThrown", {
                            kind: "CancellationTokenObject"
                        });
                        throw new OperationCanceledException();
                    }
                }
            };
            ThrottledCancellationToken = class {
                constructor(hostCancellationToken, throttleWaitMilliseconds = 20){
                    this.hostCancellationToken = hostCancellationToken;
                    this.throttleWaitMilliseconds = throttleWaitMilliseconds;
                    // Store when we last tried to cancel.  Checking cancellation can be expensive (as we have
                    // to marshall over to the host layer).  So we only bother actually checking once enough
                    // time has passed.
                    this.lastCancellationCheckTime = 0;
                }
                isCancellationRequested() {
                    const time = timestamp();
                    const duration = Math.abs(time - this.lastCancellationCheckTime);
                    if (duration >= this.throttleWaitMilliseconds) {
                        this.lastCancellationCheckTime = time;
                        return this.hostCancellationToken.isCancellationRequested();
                    }
                    return false;
                }
                throwIfCancellationRequested() {
                    var _a;
                    if (this.isCancellationRequested()) {
                        (_a = tracing) == null || _a.instant(tracing.Phase.Session, "cancellationThrown", {
                            kind: "ThrottledCancellationToken"
                        });
                        throw new OperationCanceledException();
                    }
                }
            };
            invalidOperationsInPartialSemanticMode = [
                "getSemanticDiagnostics",
                "getSuggestionDiagnostics",
                "getCompilerOptionsDiagnostics",
                "getSemanticClassifications",
                "getEncodedSemanticClassifications",
                "getCodeFixesAtPosition",
                "getCombinedCodeFix",
                "applyCodeActionCommand",
                "organizeImports",
                "getEditsForFileRename",
                "getEmitOutput",
                "getApplicableRefactors",
                "getEditsForRefactor",
                "prepareCallHierarchy",
                "provideCallHierarchyIncomingCalls",
                "provideCallHierarchyOutgoingCalls",
                "provideInlayHints",
                "getSupportedCodeFixes"
            ];
            invalidOperationsInSyntacticMode = [
                ...invalidOperationsInPartialSemanticMode,
                "getCompletionsAtPosition",
                "getCompletionEntryDetails",
                "getCompletionEntrySymbol",
                "getSignatureHelpItems",
                "getQuickInfoAtPosition",
                "getDefinitionAtPosition",
                "getDefinitionAndBoundSpan",
                "getImplementationAtPosition",
                "getTypeDefinitionAtPosition",
                "getReferencesAtPosition",
                "findReferences",
                "getDocumentHighlights",
                "getNavigateToItems",
                "getRenameInfo",
                "findRenameLocations",
                "getApplicableRefactors"
            ];
            setObjectAllocator(getServicesObjectAllocator());
        }
    });
    // src/services/transform.ts
    function transform(source, transformers, compilerOptions) {
        const diagnostics = [];
        compilerOptions = fixupCompilerOptions(compilerOptions, diagnostics);
        const nodes = isArray(source) ? source : [
            source
        ];
        const result = transformNodes(/*resolver*/ void 0, /*host*/ void 0, factory, compilerOptions, nodes, transformers, /*allowDtsFiles*/ true);
        result.diagnostics = concatenate(result.diagnostics, diagnostics);
        return result;
    }
    var init_transform = __esm({
        "src/services/transform.ts" () {
            "use strict";
            init_ts4();
        }
    });
    // src/services/shims.ts
    function logInternalError(logger, err) {
        if (logger) logger.log("*INTERNAL ERROR* - Exception in typescript services: " + err.message);
    }
    function simpleForwardCall(logger, actionDescription2, action, logPerformance) {
        let start;
        if (logPerformance) {
            logger.log(actionDescription2);
            start = timestamp();
        }
        const result = action();
        if (logPerformance) {
            const end = timestamp();
            logger.log(`${actionDescription2} completed in ${end - start} msec`);
            if (isString(result)) {
                let str = result;
                if (str.length > 128) str = str.substring(0, 128) + "...";
                logger.log(`  result.length=${str.length}, result='${JSON.stringify(str)}'`);
            }
        }
        return result;
    }
    function forwardJSONCall(logger, actionDescription2, action, logPerformance) {
        return forwardCall(logger, actionDescription2, /*returnJson*/ true, action, logPerformance);
    }
    function forwardCall(logger, actionDescription2, returnJson, action, logPerformance) {
        try {
            const result = simpleForwardCall(logger, actionDescription2, action, logPerformance);
            return returnJson ? JSON.stringify({
                result: result
            }) : result;
        } catch (err) {
            if (err instanceof OperationCanceledException) return JSON.stringify({
                canceled: true
            });
            logInternalError(logger, err);
            err.description = actionDescription2;
            return JSON.stringify({
                error: err
            });
        }
    }
    function realizeDiagnostics(diagnostics, newLine) {
        return diagnostics.map((d)=>realizeDiagnostic(d, newLine));
    }
    function realizeDiagnostic(diagnostic, newLine) {
        return {
            message: flattenDiagnosticMessageText(diagnostic.messageText, newLine),
            start: diagnostic.start,
            // TODO: GH#18217
            length: diagnostic.length,
            // TODO: GH#18217
            category: diagnosticCategoryName(diagnostic),
            code: diagnostic.code,
            reportsUnnecessary: diagnostic.reportsUnnecessary,
            reportsDeprecated: diagnostic.reportsDeprecated
        };
    }
    function convertClassifications(classifications) {
        return {
            spans: classifications.spans.join(","),
            endOfLineState: classifications.endOfLineState
        };
    }
    var debugObjectHost, ScriptSnapshotShimAdapter, LanguageServiceShimHostAdapter, CoreServicesShimHostAdapter, ShimBase, LanguageServiceShimObject, ClassifierShimObject, CoreServicesShimObject, TypeScriptServicesFactory;
    var init_shims = __esm({
        "src/services/shims.ts" () {
            "use strict";
            init_ts4();
            debugObjectHost = function() {
                return this;
            }();
            ScriptSnapshotShimAdapter = class {
                constructor(scriptSnapshotShim){
                    this.scriptSnapshotShim = scriptSnapshotShim;
                }
                getText(start, end) {
                    return this.scriptSnapshotShim.getText(start, end);
                }
                getLength() {
                    return this.scriptSnapshotShim.getLength();
                }
                getChangeRange(oldSnapshot) {
                    const oldSnapshotShim = oldSnapshot;
                    const encoded = this.scriptSnapshotShim.getChangeRange(oldSnapshotShim.scriptSnapshotShim);
                    if (encoded === null) return null;
                    const decoded = JSON.parse(encoded);
                    return createTextChangeRange(createTextSpan(decoded.span.start, decoded.span.length), decoded.newLength);
                }
                dispose() {
                    if ("dispose" in this.scriptSnapshotShim) this.scriptSnapshotShim.dispose();
                }
            };
            LanguageServiceShimHostAdapter = class {
                constructor(shimHost){
                    this.shimHost = shimHost;
                    this.loggingEnabled = false;
                    this.tracingEnabled = false;
                    if ("getModuleResolutionsForFile" in this.shimHost) this.resolveModuleNames = (moduleNames, containingFile)=>{
                        const resolutionsInFile = JSON.parse(this.shimHost.getModuleResolutionsForFile(containingFile));
                        return map(moduleNames, (name)=>{
                            const result = getProperty(resolutionsInFile, name);
                            return result ? {
                                resolvedFileName: result,
                                extension: extensionFromPath(result),
                                isExternalLibraryImport: false
                            } : void 0;
                        });
                    };
                    if ("directoryExists" in this.shimHost) this.directoryExists = (directoryName)=>this.shimHost.directoryExists(directoryName);
                    if ("getTypeReferenceDirectiveResolutionsForFile" in this.shimHost) this.resolveTypeReferenceDirectives = (typeDirectiveNames, containingFile)=>{
                        const typeDirectivesForFile = JSON.parse(this.shimHost.getTypeReferenceDirectiveResolutionsForFile(containingFile));
                        return map(typeDirectiveNames, (name)=>getProperty(typeDirectivesForFile, isString(name) ? name : toFileNameLowerCase(name.fileName)));
                    };
                }
                log(s) {
                    if (this.loggingEnabled) this.shimHost.log(s);
                }
                trace(s) {
                    if (this.tracingEnabled) this.shimHost.trace(s);
                }
                error(s) {
                    this.shimHost.error(s);
                }
                getProjectVersion() {
                    if (!this.shimHost.getProjectVersion) return void 0;
                    return this.shimHost.getProjectVersion();
                }
                getTypeRootsVersion() {
                    if (!this.shimHost.getTypeRootsVersion) return 0;
                    return this.shimHost.getTypeRootsVersion();
                }
                useCaseSensitiveFileNames() {
                    return this.shimHost.useCaseSensitiveFileNames ? this.shimHost.useCaseSensitiveFileNames() : false;
                }
                getCompilationSettings() {
                    const settingsJson = this.shimHost.getCompilationSettings();
                    if (settingsJson === null || settingsJson === "") throw Error("LanguageServiceShimHostAdapter.getCompilationSettings: empty compilationSettings");
                    const compilerOptions = JSON.parse(settingsJson);
                    compilerOptions.allowNonTsExtensions = true;
                    return compilerOptions;
                }
                getScriptFileNames() {
                    const encoded = this.shimHost.getScriptFileNames();
                    return JSON.parse(encoded);
                }
                getScriptSnapshot(fileName) {
                    const scriptSnapshot = this.shimHost.getScriptSnapshot(fileName);
                    return scriptSnapshot && new ScriptSnapshotShimAdapter(scriptSnapshot);
                }
                getScriptKind(fileName) {
                    if ("getScriptKind" in this.shimHost) return this.shimHost.getScriptKind(fileName);
                    else return 0 /* Unknown */ ;
                }
                getScriptVersion(fileName) {
                    return this.shimHost.getScriptVersion(fileName);
                }
                getLocalizedDiagnosticMessages() {
                    const diagnosticMessagesJson = this.shimHost.getLocalizedDiagnosticMessages();
                    if (diagnosticMessagesJson === null || diagnosticMessagesJson === "") return null;
                    try {
                        return JSON.parse(diagnosticMessagesJson);
                    } catch (e) {
                        this.log(e.description || "diagnosticMessages.generated.json has invalid JSON format");
                        return null;
                    }
                }
                getCancellationToken() {
                    const hostCancellationToken = this.shimHost.getCancellationToken();
                    return new ThrottledCancellationToken(hostCancellationToken);
                }
                getCurrentDirectory() {
                    return this.shimHost.getCurrentDirectory();
                }
                getDirectories(path) {
                    return JSON.parse(this.shimHost.getDirectories(path));
                }
                getDefaultLibFileName(options) {
                    return this.shimHost.getDefaultLibFileName(JSON.stringify(options));
                }
                readDirectory(path, extensions, exclude, include, depth) {
                    const pattern = getFileMatcherPatterns(path, exclude, include, this.shimHost.useCaseSensitiveFileNames(), this.shimHost.getCurrentDirectory());
                    return JSON.parse(this.shimHost.readDirectory(path, JSON.stringify(extensions), JSON.stringify(pattern.basePaths), pattern.excludePattern, pattern.includeFilePattern, pattern.includeDirectoryPattern, depth));
                }
                readFile(path, encoding) {
                    return this.shimHost.readFile(path, encoding);
                }
                fileExists(path) {
                    return this.shimHost.fileExists(path);
                }
            };
            CoreServicesShimHostAdapter = class {
                constructor(shimHost){
                    this.shimHost = shimHost;
                    this.useCaseSensitiveFileNames = this.shimHost.useCaseSensitiveFileNames ? this.shimHost.useCaseSensitiveFileNames() : false;
                    if ("directoryExists" in this.shimHost) this.directoryExists = (directoryName)=>this.shimHost.directoryExists(directoryName);
                    else this.directoryExists = void 0;
                    if ("realpath" in this.shimHost) this.realpath = (path)=>this.shimHost.realpath(path);
                    else this.realpath = void 0;
                }
                readDirectory(rootDir, extensions, exclude, include, depth) {
                    const pattern = getFileMatcherPatterns(rootDir, exclude, include, this.shimHost.useCaseSensitiveFileNames(), this.shimHost.getCurrentDirectory());
                    return JSON.parse(this.shimHost.readDirectory(rootDir, JSON.stringify(extensions), JSON.stringify(pattern.basePaths), pattern.excludePattern, pattern.includeFilePattern, pattern.includeDirectoryPattern, depth));
                }
                fileExists(fileName) {
                    return this.shimHost.fileExists(fileName);
                }
                readFile(fileName) {
                    return this.shimHost.readFile(fileName);
                }
                getDirectories(path) {
                    return JSON.parse(this.shimHost.getDirectories(path));
                }
            };
            ShimBase = class {
                constructor(factory2){
                    this.factory = factory2;
                    factory2.registerShim(this);
                }
                dispose(_dummy) {
                    this.factory.unregisterShim(this);
                }
            };
            LanguageServiceShimObject = class extends ShimBase {
                constructor(factory2, host, languageService){
                    super(factory2);
                    this.host = host;
                    this.languageService = languageService;
                    this.logPerformance = false;
                    this.logger = this.host;
                }
                forwardJSONCall(actionDescription2, action) {
                    return forwardJSONCall(this.logger, actionDescription2, action, this.logPerformance);
                }
                /// DISPOSE
                /**
         * Ensure (almost) deterministic release of internal Javascript resources when
         * some external native objects holds onto us (e.g. Com/Interop).
         */ dispose(dummy) {
                    this.logger.log("dispose()");
                    this.languageService.dispose();
                    this.languageService = null;
                    if (debugObjectHost && debugObjectHost.CollectGarbage) {
                        debugObjectHost.CollectGarbage();
                        this.logger.log("CollectGarbage()");
                    }
                    this.logger = null;
                    super.dispose(dummy);
                }
                /// REFRESH
                /**
         * Update the list of scripts known to the compiler
         */ refresh(throwOnError) {
                    this.forwardJSONCall(`refresh(${throwOnError})`, ()=>null);
                }
                cleanupSemanticCache() {
                    this.forwardJSONCall("cleanupSemanticCache()", ()=>{
                        this.languageService.cleanupSemanticCache();
                        return null;
                    });
                }
                realizeDiagnostics(diagnostics) {
                    const newLine = getNewLineOrDefaultFromHost(this.host, /*formatSettings*/ void 0);
                    return realizeDiagnostics(diagnostics, newLine);
                }
                getSyntacticClassifications(fileName, start, length2) {
                    return this.forwardJSONCall(`getSyntacticClassifications('${fileName}', ${start}, ${length2})`, ()=>this.languageService.getSyntacticClassifications(fileName, createTextSpan(start, length2)));
                }
                getSemanticClassifications(fileName, start, length2) {
                    return this.forwardJSONCall(`getSemanticClassifications('${fileName}', ${start}, ${length2})`, ()=>this.languageService.getSemanticClassifications(fileName, createTextSpan(start, length2)));
                }
                getEncodedSyntacticClassifications(fileName, start, length2) {
                    return this.forwardJSONCall(`getEncodedSyntacticClassifications('${fileName}', ${start}, ${length2})`, // directly serialize the spans out to a string.  This is much faster to decode
                    // on the managed side versus a full JSON array.
                    ()=>convertClassifications(this.languageService.getEncodedSyntacticClassifications(fileName, createTextSpan(start, length2))));
                }
                getEncodedSemanticClassifications(fileName, start, length2) {
                    return this.forwardJSONCall(`getEncodedSemanticClassifications('${fileName}', ${start}, ${length2})`, // directly serialize the spans out to a string.  This is much faster to decode
                    // on the managed side versus a full JSON array.
                    ()=>convertClassifications(this.languageService.getEncodedSemanticClassifications(fileName, createTextSpan(start, length2))));
                }
                getSyntacticDiagnostics(fileName) {
                    return this.forwardJSONCall(`getSyntacticDiagnostics('${fileName}')`, ()=>{
                        const diagnostics = this.languageService.getSyntacticDiagnostics(fileName);
                        return this.realizeDiagnostics(diagnostics);
                    });
                }
                getSemanticDiagnostics(fileName) {
                    return this.forwardJSONCall(`getSemanticDiagnostics('${fileName}')`, ()=>{
                        const diagnostics = this.languageService.getSemanticDiagnostics(fileName);
                        return this.realizeDiagnostics(diagnostics);
                    });
                }
                getSuggestionDiagnostics(fileName) {
                    return this.forwardJSONCall(`getSuggestionDiagnostics('${fileName}')`, ()=>this.realizeDiagnostics(this.languageService.getSuggestionDiagnostics(fileName)));
                }
                getCompilerOptionsDiagnostics() {
                    return this.forwardJSONCall("getCompilerOptionsDiagnostics()", ()=>{
                        const diagnostics = this.languageService.getCompilerOptionsDiagnostics();
                        return this.realizeDiagnostics(diagnostics);
                    });
                }
                /// QUICKINFO
                /**
         * Computes a string representation of the type at the requested position
         * in the active file.
         */ getQuickInfoAtPosition(fileName, position) {
                    return this.forwardJSONCall(`getQuickInfoAtPosition('${fileName}', ${position})`, ()=>this.languageService.getQuickInfoAtPosition(fileName, position));
                }
                /// NAMEORDOTTEDNAMESPAN
                /**
         * Computes span information of the name or dotted name at the requested position
         * in the active file.
         */ getNameOrDottedNameSpan(fileName, startPos, endPos) {
                    return this.forwardJSONCall(`getNameOrDottedNameSpan('${fileName}', ${startPos}, ${endPos})`, ()=>this.languageService.getNameOrDottedNameSpan(fileName, startPos, endPos));
                }
                /**
         * STATEMENTSPAN
         * Computes span information of statement at the requested position in the active file.
         */ getBreakpointStatementAtPosition(fileName, position) {
                    return this.forwardJSONCall(`getBreakpointStatementAtPosition('${fileName}', ${position})`, ()=>this.languageService.getBreakpointStatementAtPosition(fileName, position));
                }
                /// SIGNATUREHELP
                getSignatureHelpItems(fileName, position, options) {
                    return this.forwardJSONCall(`getSignatureHelpItems('${fileName}', ${position})`, ()=>this.languageService.getSignatureHelpItems(fileName, position, options));
                }
                /// GOTO DEFINITION
                /**
         * Computes the definition location and file for the symbol
         * at the requested position.
         */ getDefinitionAtPosition(fileName, position) {
                    return this.forwardJSONCall(`getDefinitionAtPosition('${fileName}', ${position})`, ()=>this.languageService.getDefinitionAtPosition(fileName, position));
                }
                /**
         * Computes the definition location and file for the symbol
         * at the requested position.
         */ getDefinitionAndBoundSpan(fileName, position) {
                    return this.forwardJSONCall(`getDefinitionAndBoundSpan('${fileName}', ${position})`, ()=>this.languageService.getDefinitionAndBoundSpan(fileName, position));
                }
                /// GOTO Type
                /**
         * Computes the definition location of the type of the symbol
         * at the requested position.
         */ getTypeDefinitionAtPosition(fileName, position) {
                    return this.forwardJSONCall(`getTypeDefinitionAtPosition('${fileName}', ${position})`, ()=>this.languageService.getTypeDefinitionAtPosition(fileName, position));
                }
                /// GOTO Implementation
                /**
         * Computes the implementation location of the symbol
         * at the requested position.
         */ getImplementationAtPosition(fileName, position) {
                    return this.forwardJSONCall(`getImplementationAtPosition('${fileName}', ${position})`, ()=>this.languageService.getImplementationAtPosition(fileName, position));
                }
                getRenameInfo(fileName, position, preferences) {
                    return this.forwardJSONCall(`getRenameInfo('${fileName}', ${position})`, ()=>this.languageService.getRenameInfo(fileName, position, preferences));
                }
                getSmartSelectionRange(fileName, position) {
                    return this.forwardJSONCall(`getSmartSelectionRange('${fileName}', ${position})`, ()=>this.languageService.getSmartSelectionRange(fileName, position));
                }
                findRenameLocations(fileName, position, findInStrings, findInComments, preferences) {
                    return this.forwardJSONCall(`findRenameLocations('${fileName}', ${position}, ${findInStrings}, ${findInComments})`, ()=>this.languageService.findRenameLocations(fileName, position, findInStrings, findInComments, preferences));
                }
                /// GET BRACE MATCHING
                getBraceMatchingAtPosition(fileName, position) {
                    return this.forwardJSONCall(`getBraceMatchingAtPosition('${fileName}', ${position})`, ()=>this.languageService.getBraceMatchingAtPosition(fileName, position));
                }
                isValidBraceCompletionAtPosition(fileName, position, openingBrace) {
                    return this.forwardJSONCall(`isValidBraceCompletionAtPosition('${fileName}', ${position}, ${openingBrace})`, ()=>this.languageService.isValidBraceCompletionAtPosition(fileName, position, openingBrace));
                }
                getSpanOfEnclosingComment(fileName, position, onlyMultiLine) {
                    return this.forwardJSONCall(`getSpanOfEnclosingComment('${fileName}', ${position})`, ()=>this.languageService.getSpanOfEnclosingComment(fileName, position, onlyMultiLine));
                }
                /// GET SMART INDENT
                getIndentationAtPosition(fileName, position, options) {
                    return this.forwardJSONCall(`getIndentationAtPosition('${fileName}', ${position})`, ()=>{
                        const localOptions = JSON.parse(options);
                        return this.languageService.getIndentationAtPosition(fileName, position, localOptions);
                    });
                }
                /// GET REFERENCES
                getReferencesAtPosition(fileName, position) {
                    return this.forwardJSONCall(`getReferencesAtPosition('${fileName}', ${position})`, ()=>this.languageService.getReferencesAtPosition(fileName, position));
                }
                findReferences(fileName, position) {
                    return this.forwardJSONCall(`findReferences('${fileName}', ${position})`, ()=>this.languageService.findReferences(fileName, position));
                }
                getFileReferences(fileName) {
                    return this.forwardJSONCall(`getFileReferences('${fileName})`, ()=>this.languageService.getFileReferences(fileName));
                }
                getDocumentHighlights(fileName, position, filesToSearch) {
                    return this.forwardJSONCall(`getDocumentHighlights('${fileName}', ${position})`, ()=>{
                        const results = this.languageService.getDocumentHighlights(fileName, position, JSON.parse(filesToSearch));
                        const normalizedName = toFileNameLowerCase(normalizeSlashes(fileName));
                        return filter(results, (r)=>toFileNameLowerCase(normalizeSlashes(r.fileName)) === normalizedName);
                    });
                }
                /// COMPLETION LISTS
                /**
         * Get a string based representation of the completions
         * to provide at the given source position and providing a member completion
         * list if requested.
         */ getCompletionsAtPosition(fileName, position, preferences, formattingSettings) {
                    return this.forwardJSONCall(`getCompletionsAtPosition('${fileName}', ${position}, ${preferences}, ${formattingSettings})`, ()=>this.languageService.getCompletionsAtPosition(fileName, position, preferences, formattingSettings));
                }
                /** Get a string based representation of a completion list entry details */ getCompletionEntryDetails(fileName, position, entryName, formatOptions, source, preferences, data) {
                    return this.forwardJSONCall(`getCompletionEntryDetails('${fileName}', ${position}, '${entryName}')`, ()=>{
                        const localOptions = formatOptions === void 0 ? void 0 : JSON.parse(formatOptions);
                        return this.languageService.getCompletionEntryDetails(fileName, position, entryName, localOptions, source, preferences, data);
                    });
                }
                getFormattingEditsForRange(fileName, start, end, options) {
                    return this.forwardJSONCall(`getFormattingEditsForRange('${fileName}', ${start}, ${end})`, ()=>{
                        const localOptions = JSON.parse(options);
                        return this.languageService.getFormattingEditsForRange(fileName, start, end, localOptions);
                    });
                }
                getFormattingEditsForDocument(fileName, options) {
                    return this.forwardJSONCall(`getFormattingEditsForDocument('${fileName}')`, ()=>{
                        const localOptions = JSON.parse(options);
                        return this.languageService.getFormattingEditsForDocument(fileName, localOptions);
                    });
                }
                getFormattingEditsAfterKeystroke(fileName, position, key, options) {
                    return this.forwardJSONCall(`getFormattingEditsAfterKeystroke('${fileName}', ${position}, '${key}')`, ()=>{
                        const localOptions = JSON.parse(options);
                        return this.languageService.getFormattingEditsAfterKeystroke(fileName, position, key, localOptions);
                    });
                }
                getDocCommentTemplateAtPosition(fileName, position, options, formatOptions) {
                    return this.forwardJSONCall(`getDocCommentTemplateAtPosition('${fileName}', ${position})`, ()=>this.languageService.getDocCommentTemplateAtPosition(fileName, position, options, formatOptions));
                }
                /// NAVIGATE TO
                /** Return a list of symbols that are interesting to navigate to */ getNavigateToItems(searchValue, maxResultCount, fileName) {
                    return this.forwardJSONCall(`getNavigateToItems('${searchValue}', ${maxResultCount}, ${fileName})`, ()=>this.languageService.getNavigateToItems(searchValue, maxResultCount, fileName));
                }
                getNavigationBarItems(fileName) {
                    return this.forwardJSONCall(`getNavigationBarItems('${fileName}')`, ()=>this.languageService.getNavigationBarItems(fileName));
                }
                getNavigationTree(fileName) {
                    return this.forwardJSONCall(`getNavigationTree('${fileName}')`, ()=>this.languageService.getNavigationTree(fileName));
                }
                getOutliningSpans(fileName) {
                    return this.forwardJSONCall(`getOutliningSpans('${fileName}')`, ()=>this.languageService.getOutliningSpans(fileName));
                }
                getTodoComments(fileName, descriptors) {
                    return this.forwardJSONCall(`getTodoComments('${fileName}')`, ()=>this.languageService.getTodoComments(fileName, JSON.parse(descriptors)));
                }
                /// CALL HIERARCHY
                prepareCallHierarchy(fileName, position) {
                    return this.forwardJSONCall(`prepareCallHierarchy('${fileName}', ${position})`, ()=>this.languageService.prepareCallHierarchy(fileName, position));
                }
                provideCallHierarchyIncomingCalls(fileName, position) {
                    return this.forwardJSONCall(`provideCallHierarchyIncomingCalls('${fileName}', ${position})`, ()=>this.languageService.provideCallHierarchyIncomingCalls(fileName, position));
                }
                provideCallHierarchyOutgoingCalls(fileName, position) {
                    return this.forwardJSONCall(`provideCallHierarchyOutgoingCalls('${fileName}', ${position})`, ()=>this.languageService.provideCallHierarchyOutgoingCalls(fileName, position));
                }
                provideInlayHints(fileName, span, preference) {
                    return this.forwardJSONCall(`provideInlayHints('${fileName}', '${JSON.stringify(span)}', ${JSON.stringify(preference)})`, ()=>this.languageService.provideInlayHints(fileName, span, preference));
                }
                /// Emit
                getEmitOutput(fileName) {
                    return this.forwardJSONCall(`getEmitOutput('${fileName}')`, ()=>{
                        const { diagnostics: diagnostics , ...rest } = this.languageService.getEmitOutput(fileName);
                        return {
                            ...rest,
                            diagnostics: this.realizeDiagnostics(diagnostics)
                        };
                    });
                }
                getEmitOutputObject(fileName) {
                    return forwardCall(this.logger, `getEmitOutput('${fileName}')`, /*returnJson*/ false, ()=>this.languageService.getEmitOutput(fileName), this.logPerformance);
                }
                toggleLineComment(fileName, textRange) {
                    return this.forwardJSONCall(`toggleLineComment('${fileName}', '${JSON.stringify(textRange)}')`, ()=>this.languageService.toggleLineComment(fileName, textRange));
                }
                toggleMultilineComment(fileName, textRange) {
                    return this.forwardJSONCall(`toggleMultilineComment('${fileName}', '${JSON.stringify(textRange)}')`, ()=>this.languageService.toggleMultilineComment(fileName, textRange));
                }
                commentSelection(fileName, textRange) {
                    return this.forwardJSONCall(`commentSelection('${fileName}', '${JSON.stringify(textRange)}')`, ()=>this.languageService.commentSelection(fileName, textRange));
                }
                uncommentSelection(fileName, textRange) {
                    return this.forwardJSONCall(`uncommentSelection('${fileName}', '${JSON.stringify(textRange)}')`, ()=>this.languageService.uncommentSelection(fileName, textRange));
                }
            };
            ClassifierShimObject = class extends ShimBase {
                constructor(factory2, logger){
                    super(factory2);
                    this.logger = logger;
                    this.logPerformance = false;
                    this.classifier = createClassifier();
                }
                getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent = false) {
                    return forwardJSONCall(this.logger, "getEncodedLexicalClassifications", ()=>convertClassifications(this.classifier.getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent)), this.logPerformance);
                }
                /// COLORIZATION
                getClassificationsForLine(text, lexState, classifyKeywordsInGenerics = false) {
                    const classification = this.classifier.getClassificationsForLine(text, lexState, classifyKeywordsInGenerics);
                    let result = "";
                    for (const item of classification.entries){
                        result += item.length + "\n";
                        result += item.classification + "\n";
                    }
                    result += classification.finalLexState;
                    return result;
                }
            };
            CoreServicesShimObject = class extends ShimBase {
                constructor(factory2, logger, host){
                    super(factory2);
                    this.logger = logger;
                    this.host = host;
                    this.logPerformance = false;
                }
                forwardJSONCall(actionDescription2, action) {
                    return forwardJSONCall(this.logger, actionDescription2, action, this.logPerformance);
                }
                resolveModuleName(fileName, moduleName, compilerOptionsJson) {
                    return this.forwardJSONCall(`resolveModuleName('${fileName}')`, ()=>{
                        const compilerOptions = JSON.parse(compilerOptionsJson);
                        const result = resolveModuleName(moduleName, normalizeSlashes(fileName), compilerOptions, this.host);
                        let resolvedFileName = result.resolvedModule ? result.resolvedModule.resolvedFileName : void 0;
                        if (result.resolvedModule && result.resolvedModule.extension !== ".ts" /* Ts */  && result.resolvedModule.extension !== ".tsx" /* Tsx */  && result.resolvedModule.extension !== ".d.ts" /* Dts */ ) resolvedFileName = void 0;
                        return {
                            resolvedFileName: resolvedFileName,
                            failedLookupLocations: result.failedLookupLocations,
                            affectingLocations: result.affectingLocations
                        };
                    });
                }
                resolveTypeReferenceDirective(fileName, typeReferenceDirective, compilerOptionsJson) {
                    return this.forwardJSONCall(`resolveTypeReferenceDirective(${fileName})`, ()=>{
                        const compilerOptions = JSON.parse(compilerOptionsJson);
                        const result = resolveTypeReferenceDirective(typeReferenceDirective, normalizeSlashes(fileName), compilerOptions, this.host);
                        return {
                            resolvedFileName: result.resolvedTypeReferenceDirective ? result.resolvedTypeReferenceDirective.resolvedFileName : void 0,
                            primary: result.resolvedTypeReferenceDirective ? result.resolvedTypeReferenceDirective.primary : true,
                            failedLookupLocations: result.failedLookupLocations
                        };
                    });
                }
                getPreProcessedFileInfo(fileName, sourceTextSnapshot) {
                    return this.forwardJSONCall(`getPreProcessedFileInfo('${fileName}')`, ()=>{
                        const result = preProcessFile(getSnapshotText(sourceTextSnapshot), /*readImportFiles*/ true, /*detectJavaScriptImports*/ true);
                        return {
                            referencedFiles: this.convertFileReferences(result.referencedFiles),
                            importedFiles: this.convertFileReferences(result.importedFiles),
                            ambientExternalModules: result.ambientExternalModules,
                            isLibFile: result.isLibFile,
                            typeReferenceDirectives: this.convertFileReferences(result.typeReferenceDirectives),
                            libReferenceDirectives: this.convertFileReferences(result.libReferenceDirectives)
                        };
                    });
                }
                getAutomaticTypeDirectiveNames(compilerOptionsJson) {
                    return this.forwardJSONCall(`getAutomaticTypeDirectiveNames('${compilerOptionsJson}')`, ()=>{
                        const compilerOptions = JSON.parse(compilerOptionsJson);
                        return getAutomaticTypeDirectiveNames(compilerOptions, this.host);
                    });
                }
                convertFileReferences(refs) {
                    if (!refs) return void 0;
                    const result = [];
                    for (const ref of refs)result.push({
                        path: normalizeSlashes(ref.fileName),
                        position: ref.pos,
                        length: ref.end - ref.pos
                    });
                    return result;
                }
                getTSConfigFileInfo(fileName, sourceTextSnapshot) {
                    return this.forwardJSONCall(`getTSConfigFileInfo('${fileName}')`, ()=>{
                        const result = parseJsonText(fileName, getSnapshotText(sourceTextSnapshot));
                        const normalizedFileName = normalizeSlashes(fileName);
                        const configFile = parseJsonSourceFileConfigFileContent(result, this.host, getDirectoryPath(normalizedFileName), /*existingOptions*/ {}, normalizedFileName);
                        return {
                            options: configFile.options,
                            typeAcquisition: configFile.typeAcquisition,
                            files: configFile.fileNames,
                            raw: configFile.raw,
                            errors: realizeDiagnostics([
                                ...result.parseDiagnostics,
                                ...configFile.errors
                            ], "\r\n")
                        };
                    });
                }
                getDefaultCompilationSettings() {
                    return this.forwardJSONCall("getDefaultCompilationSettings()", ()=>getDefaultCompilerOptions2());
                }
                discoverTypings(discoverTypingsJson) {
                    const getCanonicalFileName = createGetCanonicalFileName(/*useCaseSensitiveFileNames*/ false);
                    return this.forwardJSONCall("discoverTypings()", ()=>{
                        const info = JSON.parse(discoverTypingsJson);
                        if (this.safeList === void 0) this.safeList = ts_JsTyping_exports.loadSafeList(this.host, toPath(info.safeListPath, info.safeListPath, getCanonicalFileName));
                        return ts_JsTyping_exports.discoverTypings(this.host, (msg)=>this.logger.log(msg), info.fileNames, toPath(info.projectRootPath, info.projectRootPath, getCanonicalFileName), this.safeList, info.packageNameToTypingLocation, info.typeAcquisition, info.unresolvedImports, info.typesRegistry, emptyOptions);
                    });
                }
            };
            TypeScriptServicesFactory = class {
                constructor(){
                    this._shims = [];
                }
                /*
         * Returns script API version.
         */ getServicesVersion() {
                    return servicesVersion;
                }
                createLanguageServiceShim(host) {
                    try {
                        if (this.documentRegistry === void 0) this.documentRegistry = createDocumentRegistry(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames(), host.getCurrentDirectory());
                        const hostAdapter = new LanguageServiceShimHostAdapter(host);
                        const languageService = createLanguageService(hostAdapter, this.documentRegistry, /*syntaxOnlyOrLanguageServiceMode*/ false);
                        return new LanguageServiceShimObject(this, host, languageService);
                    } catch (err) {
                        logInternalError(host, err);
                        throw err;
                    }
                }
                createClassifierShim(logger) {
                    try {
                        return new ClassifierShimObject(this, logger);
                    } catch (err) {
                        logInternalError(logger, err);
                        throw err;
                    }
                }
                createCoreServicesShim(host) {
                    try {
                        const adapter = new CoreServicesShimHostAdapter(host);
                        return new CoreServicesShimObject(this, host, adapter);
                    } catch (err) {
                        logInternalError(host, err);
                        throw err;
                    }
                }
                close() {
                    clear(this._shims);
                    this.documentRegistry = void 0;
                }
                registerShim(shim) {
                    this._shims.push(shim);
                }
                unregisterShim(shim) {
                    for(let i = 0; i < this._shims.length; i++)if (this._shims[i] === shim) {
                        delete this._shims[i];
                        return;
                    }
                    throw new Error("Invalid operation");
                }
            };
        }
    });
    // src/services/breakpoints.ts
    function spanInSourceFileAtLocation(sourceFile, position) {
        if (sourceFile.isDeclarationFile) return void 0;
        let tokenAtLocation = getTokenAtPosition(sourceFile, position);
        const lineOfPosition = sourceFile.getLineAndCharacterOfPosition(position).line;
        if (sourceFile.getLineAndCharacterOfPosition(tokenAtLocation.getStart(sourceFile)).line > lineOfPosition) {
            const preceding = findPrecedingToken(tokenAtLocation.pos, sourceFile);
            if (!preceding || sourceFile.getLineAndCharacterOfPosition(preceding.getEnd()).line !== lineOfPosition) return void 0;
            tokenAtLocation = preceding;
        }
        if (tokenAtLocation.flags & 16777216 /* Ambient */ ) return void 0;
        return spanInNode(tokenAtLocation);
        function textSpan(startNode2, endNode2) {
            const lastDecorator = canHaveDecorators(startNode2) ? findLast(startNode2.modifiers, isDecorator) : void 0;
            const start = lastDecorator ? skipTrivia(sourceFile.text, lastDecorator.end) : startNode2.getStart(sourceFile);
            return createTextSpanFromBounds(start, (endNode2 || startNode2).getEnd());
        }
        function textSpanEndingAtNextToken(startNode2, previousTokenToFindNextEndToken) {
            return textSpan(startNode2, findNextToken(previousTokenToFindNextEndToken, previousTokenToFindNextEndToken.parent, sourceFile));
        }
        function spanInNodeIfStartsOnSameLine(node, otherwiseOnNode) {
            if (node && lineOfPosition === sourceFile.getLineAndCharacterOfPosition(node.getStart(sourceFile)).line) return spanInNode(node);
            return spanInNode(otherwiseOnNode);
        }
        function spanInNodeArray(nodeArray, node, match) {
            if (nodeArray) {
                const index = nodeArray.indexOf(node);
                if (index >= 0) {
                    let start = index;
                    let end = index + 1;
                    while(start > 0 && match(nodeArray[start - 1]))start--;
                    while(end < nodeArray.length && match(nodeArray[end]))end++;
                    return createTextSpanFromBounds(skipTrivia(sourceFile.text, nodeArray[start].pos), nodeArray[end - 1].end);
                }
            }
            return textSpan(node);
        }
        function spanInPreviousNode(node) {
            return spanInNode(findPrecedingToken(node.pos, sourceFile));
        }
        function spanInNextNode(node) {
            return spanInNode(findNextToken(node, node.parent, sourceFile));
        }
        function spanInNode(node) {
            if (node) {
                const { parent: parent2  } = node;
                switch(node.kind){
                    case 242 /* VariableStatement */ :
                        return spanInVariableDeclaration(node.declarationList.declarations[0]);
                    case 259 /* VariableDeclaration */ :
                    case 171 /* PropertyDeclaration */ :
                    case 170 /* PropertySignature */ :
                        return spanInVariableDeclaration(node);
                    case 168 /* Parameter */ :
                        return spanInParameterDeclaration(node);
                    case 261 /* FunctionDeclaration */ :
                    case 173 /* MethodDeclaration */ :
                    case 172 /* MethodSignature */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                    case 175 /* Constructor */ :
                    case 217 /* FunctionExpression */ :
                    case 218 /* ArrowFunction */ :
                        return spanInFunctionDeclaration(node);
                    case 240 /* Block */ :
                        if (isFunctionBlock(node)) return spanInFunctionBlock(node);
                    case 267 /* ModuleBlock */ :
                        return spanInBlock(node);
                    case 298 /* CatchClause */ :
                        return spanInBlock(node.block);
                    case 243 /* ExpressionStatement */ :
                        return textSpan(node.expression);
                    case 252 /* ReturnStatement */ :
                        return textSpan(node.getChildAt(0), node.expression);
                    case 246 /* WhileStatement */ :
                        return textSpanEndingAtNextToken(node, node.expression);
                    case 245 /* DoStatement */ :
                        return spanInNode(node.statement);
                    case 258 /* DebuggerStatement */ :
                        return textSpan(node.getChildAt(0));
                    case 244 /* IfStatement */ :
                        return textSpanEndingAtNextToken(node, node.expression);
                    case 255 /* LabeledStatement */ :
                        return spanInNode(node.statement);
                    case 251 /* BreakStatement */ :
                    case 250 /* ContinueStatement */ :
                        return textSpan(node.getChildAt(0), node.label);
                    case 247 /* ForStatement */ :
                        return spanInForStatement(node);
                    case 248 /* ForInStatement */ :
                        return textSpanEndingAtNextToken(node, node.expression);
                    case 249 /* ForOfStatement */ :
                        return spanInInitializerOfForLike(node);
                    case 254 /* SwitchStatement */ :
                        return textSpanEndingAtNextToken(node, node.expression);
                    case 295 /* CaseClause */ :
                    case 296 /* DefaultClause */ :
                        return spanInNode(node.statements[0]);
                    case 257 /* TryStatement */ :
                        return spanInBlock(node.tryBlock);
                    case 256 /* ThrowStatement */ :
                        return textSpan(node, node.expression);
                    case 276 /* ExportAssignment */ :
                        return textSpan(node, node.expression);
                    case 270 /* ImportEqualsDeclaration */ :
                        return textSpan(node, node.moduleReference);
                    case 271 /* ImportDeclaration */ :
                        return textSpan(node, node.moduleSpecifier);
                    case 277 /* ExportDeclaration */ :
                        return textSpan(node, node.moduleSpecifier);
                    case 266 /* ModuleDeclaration */ :
                        if (getModuleInstanceState(node) !== 1 /* Instantiated */ ) return void 0;
                    case 262 /* ClassDeclaration */ :
                    case 265 /* EnumDeclaration */ :
                    case 305 /* EnumMember */ :
                    case 207 /* BindingElement */ :
                        return textSpan(node);
                    case 253 /* WithStatement */ :
                        return spanInNode(node.statement);
                    case 169 /* Decorator */ :
                        return spanInNodeArray(parent2.modifiers, node, isDecorator);
                    case 205 /* ObjectBindingPattern */ :
                    case 206 /* ArrayBindingPattern */ :
                        return spanInBindingPattern(node);
                    case 263 /* InterfaceDeclaration */ :
                    case 264 /* TypeAliasDeclaration */ :
                        return void 0;
                    case 27 /* SemicolonToken */ :
                    case 1 /* EndOfFileToken */ :
                        return spanInNodeIfStartsOnSameLine(findPrecedingToken(node.pos, sourceFile));
                    case 28 /* CommaToken */ :
                        return spanInPreviousNode(node);
                    case 19 /* OpenBraceToken */ :
                        return spanInOpenBraceToken(node);
                    case 20 /* CloseBraceToken */ :
                        return spanInCloseBraceToken(node);
                    case 24 /* CloseBracketToken */ :
                        return spanInCloseBracketToken(node);
                    case 21 /* OpenParenToken */ :
                        return spanInOpenParenToken(node);
                    case 22 /* CloseParenToken */ :
                        return spanInCloseParenToken(node);
                    case 59 /* ColonToken */ :
                        return spanInColonToken(node);
                    case 32 /* GreaterThanToken */ :
                    case 30 /* LessThanToken */ :
                        return spanInGreaterThanOrLessThanToken(node);
                    case 117 /* WhileKeyword */ :
                        return spanInWhileKeyword(node);
                    case 93 /* ElseKeyword */ :
                    case 85 /* CatchKeyword */ :
                    case 98 /* FinallyKeyword */ :
                        return spanInNextNode(node);
                    case 164 /* OfKeyword */ :
                        return spanInOfKeyword(node);
                    default:
                        if (isArrayLiteralOrObjectLiteralDestructuringPattern(node)) return spanInArrayLiteralOrObjectLiteralDestructuringPattern(node);
                        if ((node.kind === 80 /* Identifier */  || node.kind === 229 /* SpreadElement */  || node.kind === 302 /* PropertyAssignment */  || node.kind === 303 /* ShorthandPropertyAssignment */ ) && isArrayLiteralOrObjectLiteralDestructuringPattern(parent2)) return textSpan(node);
                        if (node.kind === 225 /* BinaryExpression */ ) {
                            const { left: left , operatorToken: operatorToken  } = node;
                            if (isArrayLiteralOrObjectLiteralDestructuringPattern(left)) return spanInArrayLiteralOrObjectLiteralDestructuringPattern(left);
                            if (operatorToken.kind === 64 /* EqualsToken */  && isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent)) return textSpan(node);
                            if (operatorToken.kind === 28 /* CommaToken */ ) return spanInNode(left);
                        }
                        if (isExpressionNode(node)) switch(parent2.kind){
                            case 245 /* DoStatement */ :
                                return spanInPreviousNode(node);
                            case 169 /* Decorator */ :
                                return spanInNode(node.parent);
                            case 247 /* ForStatement */ :
                            case 249 /* ForOfStatement */ :
                                return textSpan(node);
                            case 225 /* BinaryExpression */ :
                                if (node.parent.operatorToken.kind === 28 /* CommaToken */ ) return textSpan(node);
                                break;
                            case 218 /* ArrowFunction */ :
                                if (node.parent.body === node) return textSpan(node);
                                break;
                        }
                        switch(node.parent.kind){
                            case 302 /* PropertyAssignment */ :
                                if (node.parent.name === node && !isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent.parent)) return spanInNode(node.parent.initializer);
                                break;
                            case 215 /* TypeAssertionExpression */ :
                                if (node.parent.type === node) return spanInNextNode(node.parent.type);
                                break;
                            case 259 /* VariableDeclaration */ :
                            case 168 /* Parameter */ :
                                {
                                    const { initializer: initializer , type: type  } = node.parent;
                                    if (initializer === node || type === node || isAssignmentOperator(node.kind)) return spanInPreviousNode(node);
                                    break;
                                }
                            case 225 /* BinaryExpression */ :
                                {
                                    const { left: left  } = node.parent;
                                    if (isArrayLiteralOrObjectLiteralDestructuringPattern(left) && node !== left) return spanInPreviousNode(node);
                                    break;
                                }
                            default:
                                if (isFunctionLike(node.parent) && node.parent.type === node) return spanInPreviousNode(node);
                        }
                        return spanInNode(node.parent);
                }
            }
            function textSpanFromVariableDeclaration(variableDeclaration) {
                if (isVariableDeclarationList(variableDeclaration.parent) && variableDeclaration.parent.declarations[0] === variableDeclaration) return textSpan(findPrecedingToken(variableDeclaration.pos, sourceFile, variableDeclaration.parent), variableDeclaration);
                else return textSpan(variableDeclaration);
            }
            function spanInVariableDeclaration(variableDeclaration) {
                if (variableDeclaration.parent.parent.kind === 248 /* ForInStatement */ ) return spanInNode(variableDeclaration.parent.parent);
                const parent2 = variableDeclaration.parent;
                if (isBindingPattern(variableDeclaration.name)) return spanInBindingPattern(variableDeclaration.name);
                if (hasOnlyExpressionInitializer(variableDeclaration) && variableDeclaration.initializer || hasSyntacticModifier(variableDeclaration, 1 /* Export */ ) || parent2.parent.kind === 249 /* ForOfStatement */ ) return textSpanFromVariableDeclaration(variableDeclaration);
                if (isVariableDeclarationList(variableDeclaration.parent) && variableDeclaration.parent.declarations[0] !== variableDeclaration) return spanInNode(findPrecedingToken(variableDeclaration.pos, sourceFile, variableDeclaration.parent));
            }
            function canHaveSpanInParameterDeclaration(parameter) {
                return !!parameter.initializer || parameter.dotDotDotToken !== void 0 || hasSyntacticModifier(parameter, 12 /* Private */ );
            }
            function spanInParameterDeclaration(parameter) {
                if (isBindingPattern(parameter.name)) return spanInBindingPattern(parameter.name);
                else if (canHaveSpanInParameterDeclaration(parameter)) return textSpan(parameter);
                else {
                    const functionDeclaration = parameter.parent;
                    const indexOfParameter = functionDeclaration.parameters.indexOf(parameter);
                    Debug.assert(indexOfParameter !== -1);
                    if (indexOfParameter !== 0) return spanInParameterDeclaration(functionDeclaration.parameters[indexOfParameter - 1]);
                    else return spanInNode(functionDeclaration.body);
                }
            }
            function canFunctionHaveSpanInWholeDeclaration(functionDeclaration) {
                return hasSyntacticModifier(functionDeclaration, 1 /* Export */ ) || functionDeclaration.parent.kind === 262 /* ClassDeclaration */  && functionDeclaration.kind !== 175 /* Constructor */ ;
            }
            function spanInFunctionDeclaration(functionDeclaration) {
                if (!functionDeclaration.body) return void 0;
                if (canFunctionHaveSpanInWholeDeclaration(functionDeclaration)) return textSpan(functionDeclaration);
                return spanInNode(functionDeclaration.body);
            }
            function spanInFunctionBlock(block) {
                const nodeForSpanInBlock = block.statements.length ? block.statements[0] : block.getLastToken();
                if (canFunctionHaveSpanInWholeDeclaration(block.parent)) return spanInNodeIfStartsOnSameLine(block.parent, nodeForSpanInBlock);
                return spanInNode(nodeForSpanInBlock);
            }
            function spanInBlock(block) {
                switch(block.parent.kind){
                    case 266 /* ModuleDeclaration */ :
                        if (getModuleInstanceState(block.parent) !== 1 /* Instantiated */ ) return void 0;
                    case 246 /* WhileStatement */ :
                    case 244 /* IfStatement */ :
                    case 248 /* ForInStatement */ :
                        return spanInNodeIfStartsOnSameLine(block.parent, block.statements[0]);
                    case 247 /* ForStatement */ :
                    case 249 /* ForOfStatement */ :
                        return spanInNodeIfStartsOnSameLine(findPrecedingToken(block.pos, sourceFile, block.parent), block.statements[0]);
                }
                return spanInNode(block.statements[0]);
            }
            function spanInInitializerOfForLike(forLikeStatement) {
                if (forLikeStatement.initializer.kind === 260 /* VariableDeclarationList */ ) {
                    const variableDeclarationList = forLikeStatement.initializer;
                    if (variableDeclarationList.declarations.length > 0) return spanInNode(variableDeclarationList.declarations[0]);
                } else return spanInNode(forLikeStatement.initializer);
            }
            function spanInForStatement(forStatement) {
                if (forStatement.initializer) return spanInInitializerOfForLike(forStatement);
                if (forStatement.condition) return textSpan(forStatement.condition);
                if (forStatement.incrementor) return textSpan(forStatement.incrementor);
            }
            function spanInBindingPattern(bindingPattern) {
                const firstBindingElement = forEach(bindingPattern.elements, (element)=>element.kind !== 231 /* OmittedExpression */  ? element : void 0);
                if (firstBindingElement) return spanInNode(firstBindingElement);
                if (bindingPattern.parent.kind === 207 /* BindingElement */ ) return textSpan(bindingPattern.parent);
                return textSpanFromVariableDeclaration(bindingPattern.parent);
            }
            function spanInArrayLiteralOrObjectLiteralDestructuringPattern(node2) {
                Debug.assert(node2.kind !== 206 /* ArrayBindingPattern */  && node2.kind !== 205 /* ObjectBindingPattern */ );
                const elements = node2.kind === 208 /* ArrayLiteralExpression */  ? node2.elements : node2.properties;
                const firstBindingElement = forEach(elements, (element)=>element.kind !== 231 /* OmittedExpression */  ? element : void 0);
                if (firstBindingElement) return spanInNode(firstBindingElement);
                return textSpan(node2.parent.kind === 225 /* BinaryExpression */  ? node2.parent : node2);
            }
            function spanInOpenBraceToken(node2) {
                switch(node2.parent.kind){
                    case 265 /* EnumDeclaration */ :
                        const enumDeclaration = node2.parent;
                        return spanInNodeIfStartsOnSameLine(findPrecedingToken(node2.pos, sourceFile, node2.parent), enumDeclaration.members.length ? enumDeclaration.members[0] : enumDeclaration.getLastToken(sourceFile));
                    case 262 /* ClassDeclaration */ :
                        const classDeclaration = node2.parent;
                        return spanInNodeIfStartsOnSameLine(findPrecedingToken(node2.pos, sourceFile, node2.parent), classDeclaration.members.length ? classDeclaration.members[0] : classDeclaration.getLastToken(sourceFile));
                    case 268 /* CaseBlock */ :
                        return spanInNodeIfStartsOnSameLine(node2.parent.parent, node2.parent.clauses[0]);
                }
                return spanInNode(node2.parent);
            }
            function spanInCloseBraceToken(node2) {
                switch(node2.parent.kind){
                    case 267 /* ModuleBlock */ :
                        if (getModuleInstanceState(node2.parent.parent) !== 1 /* Instantiated */ ) return void 0;
                    case 265 /* EnumDeclaration */ :
                    case 262 /* ClassDeclaration */ :
                        return textSpan(node2);
                    case 240 /* Block */ :
                        if (isFunctionBlock(node2.parent)) return textSpan(node2);
                    case 298 /* CatchClause */ :
                        return spanInNode(lastOrUndefined(node2.parent.statements));
                    case 268 /* CaseBlock */ :
                        const caseBlock = node2.parent;
                        const lastClause = lastOrUndefined(caseBlock.clauses);
                        if (lastClause) return spanInNode(lastOrUndefined(lastClause.statements));
                        return void 0;
                    case 205 /* ObjectBindingPattern */ :
                        const bindingPattern = node2.parent;
                        return spanInNode(lastOrUndefined(bindingPattern.elements) || bindingPattern);
                    default:
                        if (isArrayLiteralOrObjectLiteralDestructuringPattern(node2.parent)) {
                            const objectLiteral = node2.parent;
                            return textSpan(lastOrUndefined(objectLiteral.properties) || objectLiteral);
                        }
                        return spanInNode(node2.parent);
                }
            }
            function spanInCloseBracketToken(node2) {
                switch(node2.parent.kind){
                    case 206 /* ArrayBindingPattern */ :
                        const bindingPattern = node2.parent;
                        return textSpan(lastOrUndefined(bindingPattern.elements) || bindingPattern);
                    default:
                        if (isArrayLiteralOrObjectLiteralDestructuringPattern(node2.parent)) {
                            const arrayLiteral = node2.parent;
                            return textSpan(lastOrUndefined(arrayLiteral.elements) || arrayLiteral);
                        }
                        return spanInNode(node2.parent);
                }
            }
            function spanInOpenParenToken(node2) {
                if (node2.parent.kind === 245 /* DoStatement */  || // Go to while keyword and do action instead
                node2.parent.kind === 212 /* CallExpression */  || node2.parent.kind === 213 /* NewExpression */ ) return spanInPreviousNode(node2);
                if (node2.parent.kind === 216 /* ParenthesizedExpression */ ) return spanInNextNode(node2);
                return spanInNode(node2.parent);
            }
            function spanInCloseParenToken(node2) {
                switch(node2.parent.kind){
                    case 217 /* FunctionExpression */ :
                    case 261 /* FunctionDeclaration */ :
                    case 218 /* ArrowFunction */ :
                    case 173 /* MethodDeclaration */ :
                    case 172 /* MethodSignature */ :
                    case 176 /* GetAccessor */ :
                    case 177 /* SetAccessor */ :
                    case 175 /* Constructor */ :
                    case 246 /* WhileStatement */ :
                    case 245 /* DoStatement */ :
                    case 247 /* ForStatement */ :
                    case 249 /* ForOfStatement */ :
                    case 212 /* CallExpression */ :
                    case 213 /* NewExpression */ :
                    case 216 /* ParenthesizedExpression */ :
                        return spanInPreviousNode(node2);
                    default:
                        return spanInNode(node2.parent);
                }
            }
            function spanInColonToken(node2) {
                if (isFunctionLike(node2.parent) || node2.parent.kind === 302 /* PropertyAssignment */  || node2.parent.kind === 168 /* Parameter */ ) return spanInPreviousNode(node2);
                return spanInNode(node2.parent);
            }
            function spanInGreaterThanOrLessThanToken(node2) {
                if (node2.parent.kind === 215 /* TypeAssertionExpression */ ) return spanInNextNode(node2);
                return spanInNode(node2.parent);
            }
            function spanInWhileKeyword(node2) {
                if (node2.parent.kind === 245 /* DoStatement */ ) return textSpanEndingAtNextToken(node2, node2.parent.expression);
                return spanInNode(node2.parent);
            }
            function spanInOfKeyword(node2) {
                if (node2.parent.kind === 249 /* ForOfStatement */ ) return spanInNextNode(node2);
                return spanInNode(node2.parent);
            }
        }
    }
    var init_breakpoints = __esm({
        "src/services/breakpoints.ts" () {
            "use strict";
            init_ts4();
        }
    });
    // src/services/_namespaces/ts.BreakpointResolver.ts
    var ts_BreakpointResolver_exports = {};
    __export(ts_BreakpointResolver_exports, {
        spanInSourceFileAtLocation: ()=>spanInSourceFileAtLocation
    });
    var init_ts_BreakpointResolver = __esm({
        "src/services/_namespaces/ts.BreakpointResolver.ts" () {
            "use strict";
            init_breakpoints();
        }
    });
    // src/services/callHierarchy.ts
    function isNamedExpression(node) {
        return (isFunctionExpression(node) || isClassExpression(node)) && isNamedDeclaration(node);
    }
    function isConstNamedExpression(node) {
        return (isFunctionExpression(node) || isArrowFunction(node) || isClassExpression(node)) && isVariableDeclaration(node.parent) && node === node.parent.initializer && isIdentifier(node.parent.name) && !!(getCombinedNodeFlags(node.parent) & 2 /* Const */ );
    }
    function isPossibleCallHierarchyDeclaration(node) {
        return isSourceFile(node) || isModuleDeclaration(node) || isFunctionDeclaration(node) || isFunctionExpression(node) || isClassDeclaration(node) || isClassExpression(node) || isClassStaticBlockDeclaration(node) || isMethodDeclaration(node) || isMethodSignature(node) || isGetAccessorDeclaration(node) || isSetAccessorDeclaration(node);
    }
    function isValidCallHierarchyDeclaration(node) {
        return isSourceFile(node) || isModuleDeclaration(node) && isIdentifier(node.name) || isFunctionDeclaration(node) || isClassDeclaration(node) || isClassStaticBlockDeclaration(node) || isMethodDeclaration(node) || isMethodSignature(node) || isGetAccessorDeclaration(node) || isSetAccessorDeclaration(node) || isNamedExpression(node) || isConstNamedExpression(node);
    }
    function getCallHierarchyDeclarationReferenceNode(node) {
        if (isSourceFile(node)) return node;
        if (isNamedDeclaration(node)) return node.name;
        if (isConstNamedExpression(node)) return node.parent.name;
        return Debug.checkDefined(node.modifiers && find(node.modifiers, isDefaultModifier3));
    }
    function isDefaultModifier3(node) {
        return node.kind === 90 /* DefaultKeyword */ ;
    }
    function getSymbolOfCallHierarchyDeclaration(typeChecker, node) {
        const location = getCallHierarchyDeclarationReferenceNode(node);
        return location && typeChecker.getSymbolAtLocation(location);
    }
    function getCallHierarchyItemName(program, node) {
        if (isSourceFile(node)) return {
            text: node.fileName,
            pos: 0,
            end: 0
        };
        if ((isFunctionDeclaration(node) || isClassDeclaration(node)) && !isNamedDeclaration(node)) {
            const defaultModifier = node.modifiers && find(node.modifiers, isDefaultModifier3);
            if (defaultModifier) return {
                text: "default",
                pos: defaultModifier.getStart(),
                end: defaultModifier.getEnd()
            };
        }
        if (isClassStaticBlockDeclaration(node)) {
            const sourceFile = node.getSourceFile();
            const pos = skipTrivia(sourceFile.text, moveRangePastModifiers(node).pos);
            const end = pos + 6;
            const typeChecker = program.getTypeChecker();
            const symbol = typeChecker.getSymbolAtLocation(node.parent);
            const prefix = symbol ? `${typeChecker.symbolToString(symbol, node.parent)} ` : "";
            return {
                text: `${prefix}static {}`,
                pos: pos,
                end: end
            };
        }
        const declName = isConstNamedExpression(node) ? node.parent.name : Debug.checkDefined(getNameOfDeclaration(node), "Expected call hierarchy item to have a name");
        let text = isIdentifier(declName) ? idText(declName) : isStringOrNumericLiteralLike(declName) ? declName.text : isComputedPropertyName(declName) ? isStringOrNumericLiteralLike(declName.expression) ? declName.expression.text : void 0 : void 0;
        if (text === void 0) {
            const typeChecker = program.getTypeChecker();
            const symbol = typeChecker.getSymbolAtLocation(declName);
            if (symbol) text = typeChecker.symbolToString(symbol, node);
        }
        if (text === void 0) {
            const printer = createPrinterWithRemoveCommentsOmitTrailingSemicolon();
            text = usingSingleLineStringWriter((writer)=>printer.writeNode(4 /* Unspecified */ , node, node.getSourceFile(), writer));
        }
        return {
            text: text,
            pos: declName.getStart(),
            end: declName.getEnd()
        };
    }
    function getCallHierarchItemContainerName(node) {
        var _a, _b;
        if (isConstNamedExpression(node)) {
            if (isModuleBlock(node.parent.parent.parent.parent) && isIdentifier(node.parent.parent.parent.parent.parent.name)) return node.parent.parent.parent.parent.parent.name.getText();
            return;
        }
        switch(node.kind){
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 173 /* MethodDeclaration */ :
                if (node.parent.kind === 209 /* ObjectLiteralExpression */ ) return (_a = getAssignedName(node.parent)) == null ? void 0 : _a.getText();
                return (_b = getNameOfDeclaration(node.parent)) == null ? void 0 : _b.getText();
            case 261 /* FunctionDeclaration */ :
            case 262 /* ClassDeclaration */ :
            case 266 /* ModuleDeclaration */ :
                if (isModuleBlock(node.parent) && isIdentifier(node.parent.parent.name)) return node.parent.parent.name.getText();
        }
    }
    function findImplementation(typeChecker, node) {
        if (node.body) return node;
        if (isConstructorDeclaration(node)) return getFirstConstructorWithBody(node.parent);
        if (isFunctionDeclaration(node) || isMethodDeclaration(node)) {
            const symbol = getSymbolOfCallHierarchyDeclaration(typeChecker, node);
            if (symbol && symbol.valueDeclaration && isFunctionLikeDeclaration(symbol.valueDeclaration) && symbol.valueDeclaration.body) return symbol.valueDeclaration;
            return void 0;
        }
        return node;
    }
    function findAllInitialDeclarations(typeChecker, node) {
        const symbol = getSymbolOfCallHierarchyDeclaration(typeChecker, node);
        let declarations;
        if (symbol && symbol.declarations) {
            const indices = indicesOf(symbol.declarations);
            const keys = map(symbol.declarations, (decl)=>({
                    file: decl.getSourceFile().fileName,
                    pos: decl.pos
                }));
            indices.sort((a, b)=>compareStringsCaseSensitive(keys[a].file, keys[b].file) || keys[a].pos - keys[b].pos);
            const sortedDeclarations = map(indices, (i)=>symbol.declarations[i]);
            let lastDecl;
            for (const decl of sortedDeclarations)if (isValidCallHierarchyDeclaration(decl)) {
                if (!lastDecl || lastDecl.parent !== decl.parent || lastDecl.end !== decl.pos) declarations = append(declarations, decl);
                lastDecl = decl;
            }
        }
        return declarations;
    }
    function findImplementationOrAllInitialDeclarations(typeChecker, node) {
        if (isClassStaticBlockDeclaration(node)) return node;
        if (isFunctionLikeDeclaration(node)) return findImplementation(typeChecker, node) ?? findAllInitialDeclarations(typeChecker, node) ?? node;
        return findAllInitialDeclarations(typeChecker, node) ?? node;
    }
    function resolveCallHierarchyDeclaration(program, location) {
        const typeChecker = program.getTypeChecker();
        let followingSymbol = false;
        while(true){
            if (isValidCallHierarchyDeclaration(location)) return findImplementationOrAllInitialDeclarations(typeChecker, location);
            if (isPossibleCallHierarchyDeclaration(location)) {
                const ancestor = findAncestor(location, isValidCallHierarchyDeclaration);
                return ancestor && findImplementationOrAllInitialDeclarations(typeChecker, ancestor);
            }
            if (isDeclarationName(location)) {
                if (isValidCallHierarchyDeclaration(location.parent)) return findImplementationOrAllInitialDeclarations(typeChecker, location.parent);
                if (isPossibleCallHierarchyDeclaration(location.parent)) {
                    const ancestor = findAncestor(location.parent, isValidCallHierarchyDeclaration);
                    return ancestor && findImplementationOrAllInitialDeclarations(typeChecker, ancestor);
                }
                if (isVariableDeclaration(location.parent) && location.parent.initializer && isConstNamedExpression(location.parent.initializer)) return location.parent.initializer;
                return void 0;
            }
            if (isConstructorDeclaration(location)) {
                if (isValidCallHierarchyDeclaration(location.parent)) return location.parent;
                return void 0;
            }
            if (location.kind === 126 /* StaticKeyword */  && isClassStaticBlockDeclaration(location.parent)) {
                location = location.parent;
                continue;
            }
            if (isVariableDeclaration(location) && location.initializer && isConstNamedExpression(location.initializer)) return location.initializer;
            if (!followingSymbol) {
                let symbol = typeChecker.getSymbolAtLocation(location);
                if (symbol) {
                    if (symbol.flags & 2097152 /* Alias */ ) symbol = typeChecker.getAliasedSymbol(symbol);
                    if (symbol.valueDeclaration) {
                        followingSymbol = true;
                        location = symbol.valueDeclaration;
                        continue;
                    }
                }
            }
            return void 0;
        }
    }
    function createCallHierarchyItem(program, node) {
        const sourceFile = node.getSourceFile();
        const name = getCallHierarchyItemName(program, node);
        const containerName = getCallHierarchItemContainerName(node);
        const kind = getNodeKind(node);
        const kindModifiers = getNodeModifiers(node);
        const span = createTextSpanFromBounds(skipTrivia(sourceFile.text, node.getFullStart(), /*stopAfterLineBreak*/ false, /*stopAtComments*/ true), node.getEnd());
        const selectionSpan = createTextSpanFromBounds(name.pos, name.end);
        return {
            file: sourceFile.fileName,
            kind: kind,
            kindModifiers: kindModifiers,
            name: name.text,
            containerName: containerName,
            span: span,
            selectionSpan: selectionSpan
        };
    }
    function isDefined(x) {
        return x !== void 0;
    }
    function convertEntryToCallSite(entry) {
        if (entry.kind === ts_FindAllReferences_exports.EntryKind.Node) {
            const { node: node  } = entry;
            if (isCallOrNewExpressionTarget(node, /*includeElementAccess*/ true, /*skipPastOuterExpressions*/ true) || isTaggedTemplateTag(node, /*includeElementAccess*/ true, /*skipPastOuterExpressions*/ true) || isDecoratorTarget(node, /*includeElementAccess*/ true, /*skipPastOuterExpressions*/ true) || isJsxOpeningLikeElementTagName(node, /*includeElementAccess*/ true, /*skipPastOuterExpressions*/ true) || isRightSideOfPropertyAccess(node) || isArgumentExpressionOfElementAccess(node)) {
                const sourceFile = node.getSourceFile();
                const ancestor = findAncestor(node, isValidCallHierarchyDeclaration) || sourceFile;
                return {
                    declaration: ancestor,
                    range: createTextRangeFromNode(node, sourceFile)
                };
            }
        }
    }
    function getCallSiteGroupKey(entry) {
        return getNodeId(entry.declaration);
    }
    function createCallHierarchyIncomingCall(from, fromSpans) {
        return {
            from: from,
            fromSpans: fromSpans
        };
    }
    function convertCallSiteGroupToIncomingCall(program, entries) {
        return createCallHierarchyIncomingCall(createCallHierarchyItem(program, entries[0].declaration), map(entries, (entry)=>createTextSpanFromRange(entry.range)));
    }
    function getIncomingCalls(program, declaration, cancellationToken) {
        if (isSourceFile(declaration) || isModuleDeclaration(declaration) || isClassStaticBlockDeclaration(declaration)) return [];
        const location = getCallHierarchyDeclarationReferenceNode(declaration);
        const calls = filter(ts_FindAllReferences_exports.findReferenceOrRenameEntries(program, cancellationToken, program.getSourceFiles(), location, /*position*/ 0, {
            use: ts_FindAllReferences_exports.FindReferencesUse.References
        }, convertEntryToCallSite), isDefined);
        return calls ? group(calls, getCallSiteGroupKey, (entries)=>convertCallSiteGroupToIncomingCall(program, entries)) : [];
    }
    function createCallSiteCollector(program, callSites) {
        function recordCallSite(node) {
            const target = isTaggedTemplateExpression(node) ? node.tag : isJsxOpeningLikeElement(node) ? node.tagName : isAccessExpression(node) ? node : isClassStaticBlockDeclaration(node) ? node : node.expression;
            const declaration = resolveCallHierarchyDeclaration(program, target);
            if (declaration) {
                const range = createTextRangeFromNode(target, node.getSourceFile());
                if (isArray(declaration)) for (const decl of declaration)callSites.push({
                    declaration: decl,
                    range: range
                });
                else callSites.push({
                    declaration: declaration,
                    range: range
                });
            }
        }
        function collect(node) {
            if (!node) return;
            if (node.flags & 16777216 /* Ambient */ ) return;
            if (isValidCallHierarchyDeclaration(node)) {
                if (isClassLike(node)) {
                    for (const member of node.members)if (member.name && isComputedPropertyName(member.name)) collect(member.name.expression);
                }
                return;
            }
            switch(node.kind){
                case 80 /* Identifier */ :
                case 270 /* ImportEqualsDeclaration */ :
                case 271 /* ImportDeclaration */ :
                case 277 /* ExportDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                case 264 /* TypeAliasDeclaration */ :
                    return;
                case 174 /* ClassStaticBlockDeclaration */ :
                    recordCallSite(node);
                    return;
                case 215 /* TypeAssertionExpression */ :
                case 233 /* AsExpression */ :
                    collect(node.expression);
                    return;
                case 259 /* VariableDeclaration */ :
                case 168 /* Parameter */ :
                    collect(node.name);
                    collect(node.initializer);
                    return;
                case 212 /* CallExpression */ :
                    recordCallSite(node);
                    collect(node.expression);
                    forEach(node.arguments, collect);
                    return;
                case 213 /* NewExpression */ :
                    recordCallSite(node);
                    collect(node.expression);
                    forEach(node.arguments, collect);
                    return;
                case 214 /* TaggedTemplateExpression */ :
                    recordCallSite(node);
                    collect(node.tag);
                    collect(node.template);
                    return;
                case 285 /* JsxOpeningElement */ :
                case 284 /* JsxSelfClosingElement */ :
                    recordCallSite(node);
                    collect(node.tagName);
                    collect(node.attributes);
                    return;
                case 169 /* Decorator */ :
                    recordCallSite(node);
                    collect(node.expression);
                    return;
                case 210 /* PropertyAccessExpression */ :
                case 211 /* ElementAccessExpression */ :
                    recordCallSite(node);
                    forEachChild(node, collect);
                    break;
                case 237 /* SatisfiesExpression */ :
                    collect(node.expression);
                    return;
            }
            if (isPartOfTypeNode(node)) return;
            forEachChild(node, collect);
        }
        return collect;
    }
    function collectCallSitesOfSourceFile(node, collect) {
        forEach(node.statements, collect);
    }
    function collectCallSitesOfModuleDeclaration(node, collect) {
        if (!hasSyntacticModifier(node, 2 /* Ambient */ ) && node.body && isModuleBlock(node.body)) forEach(node.body.statements, collect);
    }
    function collectCallSitesOfFunctionLikeDeclaration(typeChecker, node, collect) {
        const implementation = findImplementation(typeChecker, node);
        if (implementation) {
            forEach(implementation.parameters, collect);
            collect(implementation.body);
        }
    }
    function collectCallSitesOfClassStaticBlockDeclaration(node, collect) {
        collect(node.body);
    }
    function collectCallSitesOfClassLikeDeclaration(node, collect) {
        forEach(node.modifiers, collect);
        const heritage = getClassExtendsHeritageElement(node);
        if (heritage) collect(heritage.expression);
        for (const member of node.members){
            if (canHaveModifiers(member)) forEach(member.modifiers, collect);
            if (isPropertyDeclaration(member)) collect(member.initializer);
            else if (isConstructorDeclaration(member) && member.body) {
                forEach(member.parameters, collect);
                collect(member.body);
            } else if (isClassStaticBlockDeclaration(member)) collect(member);
        }
    }
    function collectCallSites(program, node) {
        const callSites = [];
        const collect = createCallSiteCollector(program, callSites);
        switch(node.kind){
            case 311 /* SourceFile */ :
                collectCallSitesOfSourceFile(node, collect);
                break;
            case 266 /* ModuleDeclaration */ :
                collectCallSitesOfModuleDeclaration(node, collect);
                break;
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
                collectCallSitesOfFunctionLikeDeclaration(program.getTypeChecker(), node, collect);
                break;
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
                collectCallSitesOfClassLikeDeclaration(node, collect);
                break;
            case 174 /* ClassStaticBlockDeclaration */ :
                collectCallSitesOfClassStaticBlockDeclaration(node, collect);
                break;
            default:
                Debug.assertNever(node);
        }
        return callSites;
    }
    function createCallHierarchyOutgoingCall(to, fromSpans) {
        return {
            to: to,
            fromSpans: fromSpans
        };
    }
    function convertCallSiteGroupToOutgoingCall(program, entries) {
        return createCallHierarchyOutgoingCall(createCallHierarchyItem(program, entries[0].declaration), map(entries, (entry)=>createTextSpanFromRange(entry.range)));
    }
    function getOutgoingCalls(program, declaration) {
        if (declaration.flags & 16777216 /* Ambient */  || isMethodSignature(declaration)) return [];
        return group(collectCallSites(program, declaration), getCallSiteGroupKey, (entries)=>convertCallSiteGroupToOutgoingCall(program, entries));
    }
    var init_callHierarchy = __esm({
        "src/services/callHierarchy.ts" () {
            "use strict";
            init_ts4();
        }
    });
    // src/services/_namespaces/ts.CallHierarchy.ts
    var ts_CallHierarchy_exports = {};
    __export(ts_CallHierarchy_exports, {
        createCallHierarchyItem: ()=>createCallHierarchyItem,
        getIncomingCalls: ()=>getIncomingCalls,
        getOutgoingCalls: ()=>getOutgoingCalls,
        resolveCallHierarchyDeclaration: ()=>resolveCallHierarchyDeclaration
    });
    var init_ts_CallHierarchy = __esm({
        "src/services/_namespaces/ts.CallHierarchy.ts" () {
            "use strict";
            init_callHierarchy();
        }
    });
    // src/services/_namespaces/ts.classifier.v2020.ts
    var ts_classifier_v2020_exports = {};
    __export(ts_classifier_v2020_exports, {
        TokenEncodingConsts: ()=>TokenEncodingConsts,
        TokenModifier: ()=>TokenModifier,
        TokenType: ()=>TokenType,
        getEncodedSemanticClassifications: ()=>getEncodedSemanticClassifications2,
        getSemanticClassifications: ()=>getSemanticClassifications2
    });
    var init_ts_classifier_v2020 = __esm({
        "src/services/_namespaces/ts.classifier.v2020.ts" () {
            "use strict";
            init_classifier2020();
        }
    });
    // src/services/_namespaces/ts.classifier.ts
    var ts_classifier_exports = {};
    __export(ts_classifier_exports, {
        v2020: ()=>ts_classifier_v2020_exports
    });
    var init_ts_classifier = __esm({
        "src/services/_namespaces/ts.classifier.ts" () {
            "use strict";
            init_ts_classifier_v2020();
        }
    });
    // src/services/codeFixProvider.ts
    function createCodeFixActionWithoutFixAll(fixName8, changes, description3) {
        return createCodeFixActionWorker(fixName8, diagnosticToString(description3), changes, /*fixId*/ void 0, /*fixAllDescription*/ void 0);
    }
    function createCodeFixAction(fixName8, changes, description3, fixId52, fixAllDescription, command) {
        return createCodeFixActionWorker(fixName8, diagnosticToString(description3), changes, fixId52, diagnosticToString(fixAllDescription), command);
    }
    function createCodeFixActionMaybeFixAll(fixName8, changes, description3, fixId52, fixAllDescription, command) {
        return createCodeFixActionWorker(fixName8, diagnosticToString(description3), changes, fixId52, fixAllDescription && diagnosticToString(fixAllDescription), command);
    }
    function createCodeFixActionWorker(fixName8, description3, changes, fixId52, fixAllDescription, command) {
        return {
            fixName: fixName8,
            description: description3,
            changes: changes,
            fixId: fixId52,
            fixAllDescription: fixAllDescription,
            commands: command ? [
                command
            ] : void 0
        };
    }
    function registerCodeFix(reg) {
        for (const error of reg.errorCodes){
            errorCodeToFixesArray = void 0;
            errorCodeToFixes.add(String(error), reg);
        }
        if (reg.fixIds) for (const fixId52 of reg.fixIds){
            Debug.assert(!fixIdToRegistration.has(fixId52));
            fixIdToRegistration.set(fixId52, reg);
        }
    }
    function getSupportedErrorCodes() {
        return errorCodeToFixesArray ?? (errorCodeToFixesArray = arrayFrom(errorCodeToFixes.keys()));
    }
    function removeFixIdIfFixAllUnavailable(registration, diagnostics) {
        const { errorCodes: errorCodes64  } = registration;
        let maybeFixableDiagnostics = 0;
        for (const diag2 of diagnostics){
            if (contains(errorCodes64, diag2.code)) maybeFixableDiagnostics++;
            if (maybeFixableDiagnostics > 1) break;
        }
        const fixAllUnavailable = maybeFixableDiagnostics < 2;
        return ({ fixId: fixId52 , fixAllDescription: fixAllDescription , ...action })=>{
            return fixAllUnavailable ? action : {
                ...action,
                fixId: fixId52,
                fixAllDescription: fixAllDescription
            };
        };
    }
    function getFixes(context) {
        const diagnostics = getDiagnostics(context);
        const registrations = errorCodeToFixes.get(String(context.errorCode));
        return flatMap(registrations, (f)=>map(f.getCodeActions(context), removeFixIdIfFixAllUnavailable(f, diagnostics)));
    }
    function getAllFixes(context) {
        return fixIdToRegistration.get(cast(context.fixId, isString)).getAllCodeActions(context);
    }
    function createCombinedCodeActions(changes, commands) {
        return {
            changes: changes,
            commands: commands
        };
    }
    function createFileTextChanges(fileName, textChanges2) {
        return {
            fileName: fileName,
            textChanges: textChanges2
        };
    }
    function codeFixAll(context, errorCodes64, use) {
        const commands = [];
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>eachDiagnostic(context, errorCodes64, (diag2)=>use(t, diag2, commands)));
        return createCombinedCodeActions(changes, commands.length === 0 ? void 0 : commands);
    }
    function eachDiagnostic(context, errorCodes64, cb) {
        for (const diag2 of getDiagnostics(context))if (contains(errorCodes64, diag2.code)) cb(diag2);
    }
    function getDiagnostics({ program: program , sourceFile: sourceFile , cancellationToken: cancellationToken  }) {
        return [
            ...program.getSemanticDiagnostics(sourceFile, cancellationToken),
            ...program.getSyntacticDiagnostics(sourceFile, cancellationToken),
            ...computeSuggestionDiagnostics(sourceFile, program, cancellationToken)
        ];
    }
    var errorCodeToFixes, fixIdToRegistration, errorCodeToFixesArray;
    var init_codeFixProvider = __esm({
        "src/services/codeFixProvider.ts" () {
            "use strict";
            init_ts4();
            errorCodeToFixes = createMultiMap();
            fixIdToRegistration = /* @__PURE__ */ new Map();
        }
    });
    // src/services/codefixes/addConvertToUnknownForNonOverlappingTypes.ts
    function makeChange(changeTracker, sourceFile, assertion) {
        const replacement = isAsExpression(assertion) ? factory.createAsExpression(assertion.expression, factory.createKeywordTypeNode(159 /* UnknownKeyword */ )) : factory.createTypeAssertion(factory.createKeywordTypeNode(159 /* UnknownKeyword */ ), assertion.expression);
        changeTracker.replaceNode(sourceFile, assertion.expression, replacement);
    }
    function getAssertion(sourceFile, pos) {
        if (isInJSFile(sourceFile)) return void 0;
        return findAncestor(getTokenAtPosition(sourceFile, pos), (n)=>isAsExpression(n) || isTypeAssertionExpression(n));
    }
    var fixId, errorCodes;
    var init_addConvertToUnknownForNonOverlappingTypes = __esm({
        "src/services/codefixes/addConvertToUnknownForNonOverlappingTypes.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId = "addConvertToUnknownForNonOverlappingTypes";
            errorCodes = [
                Diagnostics.Conversion_of_type_0_to_type_1_may_be_a_mistake_because_neither_type_sufficiently_overlaps_with_the_other_If_this_was_intentional_convert_the_expression_to_unknown_first.code
            ];
            registerCodeFix({
                errorCodes: errorCodes,
                getCodeActions: function getCodeActionsToAddConvertToUnknownForNonOverlappingTypes(context) {
                    const assertion = getAssertion(context.sourceFile, context.span.start);
                    if (assertion === void 0) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange(t, context.sourceFile, assertion));
                    return [
                        createCodeFixAction(fixId, changes, Diagnostics.Add_unknown_conversion_for_non_overlapping_types, fixId, Diagnostics.Add_unknown_to_all_conversions_of_non_overlapping_types)
                    ];
                },
                fixIds: [
                    fixId
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes, (changes, diag2)=>{
                        const assertion = getAssertion(diag2.file, diag2.start);
                        if (assertion) makeChange(changes, diag2.file, assertion);
                    })
            });
        }
    });
    // src/services/codefixes/addEmptyExportDeclaration.ts
    var init_addEmptyExportDeclaration = __esm({
        "src/services/codefixes/addEmptyExportDeclaration.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            registerCodeFix({
                errorCodes: [
                    Diagnostics.await_expressions_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module.code,
                    Diagnostics.for_await_loops_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module.code
                ],
                getCodeActions: function getCodeActionsToAddEmptyExportDeclaration(context) {
                    const { sourceFile: sourceFile  } = context;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (changes2)=>{
                        const exportDeclaration = factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([]), /*moduleSpecifier*/ void 0);
                        changes2.insertNodeAtEndOfScope(sourceFile, sourceFile, exportDeclaration);
                    });
                    return [
                        createCodeFixActionWithoutFixAll("addEmptyExportDeclaration", changes, Diagnostics.Add_export_to_make_this_file_into_a_module)
                    ];
                }
            });
        }
    });
    // src/services/codefixes/addMissingAsync.ts
    function getFix(context, decl, trackChanges, fixedDeclarations) {
        const changes = trackChanges((t)=>makeChange2(t, context.sourceFile, decl, fixedDeclarations));
        return createCodeFixAction(fixId2, changes, Diagnostics.Add_async_modifier_to_containing_function, fixId2, Diagnostics.Add_all_missing_async_modifiers);
    }
    function makeChange2(changeTracker, sourceFile, insertionSite, fixedDeclarations) {
        if (fixedDeclarations) {
            if (fixedDeclarations.has(getNodeId(insertionSite))) return;
        }
        fixedDeclarations == null || fixedDeclarations.add(getNodeId(insertionSite));
        const cloneWithModifier = factory.updateModifiers(getSynthesizedDeepClone(insertionSite, /*includeTrivia*/ true), factory.createNodeArray(factory.createModifiersFromModifierFlags(getSyntacticModifierFlags(insertionSite) | 512 /* Async */ )));
        changeTracker.replaceNode(sourceFile, insertionSite, cloneWithModifier);
    }
    function getFixableErrorSpanDeclaration(sourceFile, span) {
        if (!span) return void 0;
        const token = getTokenAtPosition(sourceFile, span.start);
        const decl = findAncestor(token, (node)=>{
            if (node.getStart(sourceFile) < span.start || node.getEnd() > textSpanEnd(span)) return "quit";
            return (isArrowFunction(node) || isMethodDeclaration(node) || isFunctionExpression(node) || isFunctionDeclaration(node)) && textSpansEqual(span, createTextSpanFromNode(node, sourceFile));
        });
        return decl;
    }
    function getIsMatchingAsyncError(span, errorCode) {
        return ({ start: start , length: length2 , relatedInformation: relatedInformation , code: code  })=>isNumber(start) && isNumber(length2) && textSpansEqual({
                start: start,
                length: length2
            }, span) && code === errorCode && !!relatedInformation && some(relatedInformation, (related)=>related.code === Diagnostics.Did_you_mean_to_mark_this_function_as_async.code);
    }
    var fixId2, errorCodes2;
    var init_addMissingAsync = __esm({
        "src/services/codefixes/addMissingAsync.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId2 = "addMissingAsync";
            errorCodes2 = [
                Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code,
                Diagnostics.Type_0_is_not_assignable_to_type_1.code,
                Diagnostics.Type_0_is_not_comparable_to_type_1.code
            ];
            registerCodeFix({
                fixIds: [
                    fixId2
                ],
                errorCodes: errorCodes2,
                getCodeActions: function getCodeActionsToAddMissingAsync(context) {
                    const { sourceFile: sourceFile , errorCode: errorCode , cancellationToken: cancellationToken , program: program , span: span  } = context;
                    const diagnostic = find(program.getTypeChecker().getDiagnostics(sourceFile, cancellationToken), getIsMatchingAsyncError(span, errorCode));
                    const directSpan = diagnostic && diagnostic.relatedInformation && find(diagnostic.relatedInformation, (r)=>r.code === Diagnostics.Did_you_mean_to_mark_this_function_as_async.code);
                    const decl = getFixableErrorSpanDeclaration(sourceFile, directSpan);
                    if (!decl) return;
                    const trackChanges = (cb)=>ts_textChanges_exports.ChangeTracker.with(context, cb);
                    return [
                        getFix(context, decl, trackChanges)
                    ];
                },
                getAllCodeActions: (context)=>{
                    const { sourceFile: sourceFile  } = context;
                    const fixedDeclarations = /* @__PURE__ */ new Set();
                    return codeFixAll(context, errorCodes2, (t, diagnostic)=>{
                        const span = diagnostic.relatedInformation && find(diagnostic.relatedInformation, (r)=>r.code === Diagnostics.Did_you_mean_to_mark_this_function_as_async.code);
                        const decl = getFixableErrorSpanDeclaration(sourceFile, span);
                        if (!decl) return;
                        const trackChanges = (cb)=>(cb(t), []);
                        return getFix(context, decl, trackChanges, fixedDeclarations);
                    });
                }
            });
        }
    });
    // src/services/codefixes/addMissingAwait.ts
    function getAwaitErrorSpanExpression(sourceFile, errorCode, span, cancellationToken, program) {
        const expression = getFixableErrorSpanExpression(sourceFile, span);
        return expression && isMissingAwaitError(sourceFile, errorCode, span, cancellationToken, program) && isInsideAwaitableBody(expression) ? expression : void 0;
    }
    function getDeclarationSiteFix(context, expression, errorCode, checker, trackChanges, fixedDeclarations) {
        const { sourceFile: sourceFile , program: program , cancellationToken: cancellationToken  } = context;
        const awaitableInitializers = findAwaitableInitializers(expression, sourceFile, cancellationToken, program, checker);
        if (awaitableInitializers) {
            const initializerChanges = trackChanges((t)=>{
                forEach(awaitableInitializers.initializers, ({ expression: expression2  })=>makeChange3(t, errorCode, sourceFile, checker, expression2, fixedDeclarations));
                if (fixedDeclarations && awaitableInitializers.needsSecondPassForFixAll) makeChange3(t, errorCode, sourceFile, checker, expression, fixedDeclarations);
            });
            return createCodeFixActionWithoutFixAll("addMissingAwaitToInitializer", initializerChanges, awaitableInitializers.initializers.length === 1 ? [
                Diagnostics.Add_await_to_initializer_for_0,
                awaitableInitializers.initializers[0].declarationSymbol.name
            ] : Diagnostics.Add_await_to_initializers);
        }
    }
    function getUseSiteFix(context, expression, errorCode, checker, trackChanges, fixedDeclarations) {
        const changes = trackChanges((t)=>makeChange3(t, errorCode, context.sourceFile, checker, expression, fixedDeclarations));
        return createCodeFixAction(fixId3, changes, Diagnostics.Add_await, fixId3, Diagnostics.Fix_all_expressions_possibly_missing_await);
    }
    function isMissingAwaitError(sourceFile, errorCode, span, cancellationToken, program) {
        const checker = program.getTypeChecker();
        const diagnostics = checker.getDiagnostics(sourceFile, cancellationToken);
        return some(diagnostics, ({ start: start , length: length2 , relatedInformation: relatedInformation , code: code  })=>isNumber(start) && isNumber(length2) && textSpansEqual({
                start: start,
                length: length2
            }, span) && code === errorCode && !!relatedInformation && some(relatedInformation, (related)=>related.code === Diagnostics.Did_you_forget_to_use_await.code));
    }
    function findAwaitableInitializers(expression, sourceFile, cancellationToken, program, checker) {
        const identifiers = getIdentifiersFromErrorSpanExpression(expression, checker);
        if (!identifiers) return;
        let isCompleteFix = identifiers.isCompleteFix;
        let initializers;
        for (const identifier of identifiers.identifiers){
            const symbol = checker.getSymbolAtLocation(identifier);
            if (!symbol) continue;
            const declaration = tryCast(symbol.valueDeclaration, isVariableDeclaration);
            const variableName = declaration && tryCast(declaration.name, isIdentifier);
            const variableStatement = getAncestor(declaration, 242 /* VariableStatement */ );
            if (!declaration || !variableStatement || declaration.type || !declaration.initializer || variableStatement.getSourceFile() !== sourceFile || hasSyntacticModifier(variableStatement, 1 /* Export */ ) || !variableName || !isInsideAwaitableBody(declaration.initializer)) {
                isCompleteFix = false;
                continue;
            }
            const diagnostics = program.getSemanticDiagnostics(sourceFile, cancellationToken);
            const isUsedElsewhere = ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(variableName, checker, sourceFile, (reference)=>{
                return identifier !== reference && !symbolReferenceIsAlsoMissingAwait(reference, diagnostics, sourceFile, checker);
            });
            if (isUsedElsewhere) {
                isCompleteFix = false;
                continue;
            }
            (initializers || (initializers = [])).push({
                expression: declaration.initializer,
                declarationSymbol: symbol
            });
        }
        return initializers && {
            initializers: initializers,
            needsSecondPassForFixAll: !isCompleteFix
        };
    }
    function getIdentifiersFromErrorSpanExpression(expression, checker) {
        if (isPropertyAccessExpression(expression.parent) && isIdentifier(expression.parent.expression)) return {
            identifiers: [
                expression.parent.expression
            ],
            isCompleteFix: true
        };
        if (isIdentifier(expression)) return {
            identifiers: [
                expression
            ],
            isCompleteFix: true
        };
        if (isBinaryExpression(expression)) {
            let sides;
            let isCompleteFix = true;
            for (const side of [
                expression.left,
                expression.right
            ]){
                const type = checker.getTypeAtLocation(side);
                if (checker.getPromisedTypeOfPromise(type)) {
                    if (!isIdentifier(side)) {
                        isCompleteFix = false;
                        continue;
                    }
                    (sides || (sides = [])).push(side);
                }
            }
            return sides && {
                identifiers: sides,
                isCompleteFix: isCompleteFix
            };
        }
    }
    function symbolReferenceIsAlsoMissingAwait(reference, diagnostics, sourceFile, checker) {
        const errorNode = isPropertyAccessExpression(reference.parent) ? reference.parent.name : isBinaryExpression(reference.parent) ? reference.parent : reference;
        const diagnostic = find(diagnostics, (diagnostic2)=>diagnostic2.start === errorNode.getStart(sourceFile) && diagnostic2.start + diagnostic2.length === errorNode.getEnd());
        return diagnostic && contains(errorCodes3, diagnostic.code) || // A Promise is usually not correct in a binary expression (it's not valid
        // in an arithmetic expression and an equality comparison seems unusual),
        // but if the other side of the binary expression has an error, the side
        // is typed `any` which will squash the error that would identify this
        // Promise as an invalid operand. So if the whole binary expression is
        // typed `any` as a result, there is a strong likelihood that this Promise
        // is accidentally missing `await`.
        checker.getTypeAtLocation(errorNode).flags & 1 /* Any */ ;
    }
    function isInsideAwaitableBody(node) {
        return node.kind & 32768 /* AwaitContext */  || !!findAncestor(node, (ancestor)=>ancestor.parent && isArrowFunction(ancestor.parent) && ancestor.parent.body === ancestor || isBlock(ancestor) && (ancestor.parent.kind === 261 /* FunctionDeclaration */  || ancestor.parent.kind === 217 /* FunctionExpression */  || ancestor.parent.kind === 218 /* ArrowFunction */  || ancestor.parent.kind === 173 /* MethodDeclaration */ ));
    }
    function makeChange3(changeTracker, errorCode, sourceFile, checker, insertionSite, fixedDeclarations) {
        if (isForOfStatement(insertionSite.parent) && !insertionSite.parent.awaitModifier) {
            const exprType = checker.getTypeAtLocation(insertionSite);
            const asyncIter = checker.getAsyncIterableType();
            if (asyncIter && checker.isTypeAssignableTo(exprType, asyncIter)) {
                const forOf = insertionSite.parent;
                changeTracker.replaceNode(sourceFile, forOf, factory.updateForOfStatement(forOf, factory.createToken(135 /* AwaitKeyword */ ), forOf.initializer, forOf.expression, forOf.statement));
                return;
            }
        }
        if (isBinaryExpression(insertionSite)) for (const side of [
            insertionSite.left,
            insertionSite.right
        ]){
            if (fixedDeclarations && isIdentifier(side)) {
                const symbol = checker.getSymbolAtLocation(side);
                if (symbol && fixedDeclarations.has(getSymbolId(symbol))) continue;
            }
            const type = checker.getTypeAtLocation(side);
            const newNode = checker.getPromisedTypeOfPromise(type) ? factory.createAwaitExpression(side) : side;
            changeTracker.replaceNode(sourceFile, side, newNode);
        }
        else if (errorCode === propertyAccessCode && isPropertyAccessExpression(insertionSite.parent)) {
            if (fixedDeclarations && isIdentifier(insertionSite.parent.expression)) {
                const symbol = checker.getSymbolAtLocation(insertionSite.parent.expression);
                if (symbol && fixedDeclarations.has(getSymbolId(symbol))) return;
            }
            changeTracker.replaceNode(sourceFile, insertionSite.parent.expression, factory.createParenthesizedExpression(factory.createAwaitExpression(insertionSite.parent.expression)));
            insertLeadingSemicolonIfNeeded(changeTracker, insertionSite.parent.expression, sourceFile);
        } else if (contains(callableConstructableErrorCodes, errorCode) && isCallOrNewExpression(insertionSite.parent)) {
            if (fixedDeclarations && isIdentifier(insertionSite)) {
                const symbol = checker.getSymbolAtLocation(insertionSite);
                if (symbol && fixedDeclarations.has(getSymbolId(symbol))) return;
            }
            changeTracker.replaceNode(sourceFile, insertionSite, factory.createParenthesizedExpression(factory.createAwaitExpression(insertionSite)));
            insertLeadingSemicolonIfNeeded(changeTracker, insertionSite, sourceFile);
        } else {
            if (fixedDeclarations && isVariableDeclaration(insertionSite.parent) && isIdentifier(insertionSite.parent.name)) {
                const symbol = checker.getSymbolAtLocation(insertionSite.parent.name);
                if (symbol && !tryAddToSet(fixedDeclarations, getSymbolId(symbol))) return;
            }
            changeTracker.replaceNode(sourceFile, insertionSite, factory.createAwaitExpression(insertionSite));
        }
    }
    function insertLeadingSemicolonIfNeeded(changeTracker, beforeNode, sourceFile) {
        const precedingToken = findPrecedingToken(beforeNode.pos, sourceFile);
        if (precedingToken && positionIsASICandidate(precedingToken.end, precedingToken.parent, sourceFile)) changeTracker.insertText(sourceFile, beforeNode.getStart(sourceFile), ";");
    }
    var fixId3, propertyAccessCode, callableConstructableErrorCodes, errorCodes3;
    var init_addMissingAwait = __esm({
        "src/services/codefixes/addMissingAwait.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId3 = "addMissingAwait";
            propertyAccessCode = Diagnostics.Property_0_does_not_exist_on_type_1.code;
            callableConstructableErrorCodes = [
                Diagnostics.This_expression_is_not_callable.code,
                Diagnostics.This_expression_is_not_constructable.code
            ];
            errorCodes3 = [
                Diagnostics.An_arithmetic_operand_must_be_of_type_any_number_bigint_or_an_enum_type.code,
                Diagnostics.The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type.code,
                Diagnostics.The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type.code,
                Diagnostics.Operator_0_cannot_be_applied_to_type_1.code,
                Diagnostics.Operator_0_cannot_be_applied_to_types_1_and_2.code,
                Diagnostics.This_comparison_appears_to_be_unintentional_because_the_types_0_and_1_have_no_overlap.code,
                Diagnostics.This_condition_will_always_return_true_since_this_0_is_always_defined.code,
                Diagnostics.Type_0_is_not_an_array_type.code,
                Diagnostics.Type_0_is_not_an_array_type_or_a_string_type.code,
                Diagnostics.Type_0_can_only_be_iterated_through_when_using_the_downlevelIteration_flag_or_with_a_target_of_es2015_or_higher.code,
                Diagnostics.Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator.code,
                Diagnostics.Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator.code,
                Diagnostics.Type_0_must_have_a_Symbol_iterator_method_that_returns_an_iterator.code,
                Diagnostics.Type_0_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator.code,
                Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code,
                propertyAccessCode,
                ...callableConstructableErrorCodes
            ];
            registerCodeFix({
                fixIds: [
                    fixId3
                ],
                errorCodes: errorCodes3,
                getCodeActions: function getCodeActionsToAddMissingAwait(context) {
                    const { sourceFile: sourceFile , errorCode: errorCode , span: span , cancellationToken: cancellationToken , program: program  } = context;
                    const expression = getAwaitErrorSpanExpression(sourceFile, errorCode, span, cancellationToken, program);
                    if (!expression) return;
                    const checker = context.program.getTypeChecker();
                    const trackChanges = (cb)=>ts_textChanges_exports.ChangeTracker.with(context, cb);
                    return compact([
                        getDeclarationSiteFix(context, expression, errorCode, checker, trackChanges),
                        getUseSiteFix(context, expression, errorCode, checker, trackChanges)
                    ]);
                },
                getAllCodeActions: (context)=>{
                    const { sourceFile: sourceFile , program: program , cancellationToken: cancellationToken  } = context;
                    const checker = context.program.getTypeChecker();
                    const fixedDeclarations = /* @__PURE__ */ new Set();
                    return codeFixAll(context, errorCodes3, (t, diagnostic)=>{
                        const expression = getAwaitErrorSpanExpression(sourceFile, diagnostic.code, diagnostic, cancellationToken, program);
                        if (!expression) return;
                        const trackChanges = (cb)=>(cb(t), []);
                        return getDeclarationSiteFix(context, expression, diagnostic.code, checker, trackChanges, fixedDeclarations) || getUseSiteFix(context, expression, diagnostic.code, checker, trackChanges, fixedDeclarations);
                    });
                }
            });
        }
    });
    // src/services/codefixes/addMissingConst.ts
    function makeChange4(changeTracker, sourceFile, pos, program, fixedNodes) {
        const token = getTokenAtPosition(sourceFile, pos);
        const forInitializer = findAncestor(token, (node)=>isForInOrOfStatement(node.parent) ? node.parent.initializer === node : isPossiblyPartOfDestructuring(node) ? false : "quit");
        if (forInitializer) return applyChange(changeTracker, forInitializer, sourceFile, fixedNodes);
        const parent2 = token.parent;
        if (isBinaryExpression(parent2) && parent2.operatorToken.kind === 64 /* EqualsToken */  && isExpressionStatement(parent2.parent)) return applyChange(changeTracker, token, sourceFile, fixedNodes);
        if (isArrayLiteralExpression(parent2)) {
            const checker = program.getTypeChecker();
            if (!every(parent2.elements, (element)=>arrayElementCouldBeVariableDeclaration(element, checker))) return;
            return applyChange(changeTracker, parent2, sourceFile, fixedNodes);
        }
        const commaExpression = findAncestor(token, (node)=>isExpressionStatement(node.parent) ? true : isPossiblyPartOfCommaSeperatedInitializer(node) ? false : "quit");
        if (commaExpression) {
            const checker = program.getTypeChecker();
            if (!expressionCouldBeVariableDeclaration(commaExpression, checker)) return;
            return applyChange(changeTracker, commaExpression, sourceFile, fixedNodes);
        }
    }
    function applyChange(changeTracker, initializer, sourceFile, fixedNodes) {
        if (!fixedNodes || tryAddToSet(fixedNodes, initializer)) changeTracker.insertModifierBefore(sourceFile, 87 /* ConstKeyword */ , initializer);
    }
    function isPossiblyPartOfDestructuring(node) {
        switch(node.kind){
            case 80 /* Identifier */ :
            case 208 /* ArrayLiteralExpression */ :
            case 209 /* ObjectLiteralExpression */ :
            case 302 /* PropertyAssignment */ :
            case 303 /* ShorthandPropertyAssignment */ :
                return true;
            default:
                return false;
        }
    }
    function arrayElementCouldBeVariableDeclaration(expression, checker) {
        const identifier = isIdentifier(expression) ? expression : isAssignmentExpression(expression, /*excludeCompoundAssignment*/ true) && isIdentifier(expression.left) ? expression.left : void 0;
        return !!identifier && !checker.getSymbolAtLocation(identifier);
    }
    function isPossiblyPartOfCommaSeperatedInitializer(node) {
        switch(node.kind){
            case 80 /* Identifier */ :
            case 225 /* BinaryExpression */ :
            case 28 /* CommaToken */ :
                return true;
            default:
                return false;
        }
    }
    function expressionCouldBeVariableDeclaration(expression, checker) {
        if (!isBinaryExpression(expression)) return false;
        if (expression.operatorToken.kind === 28 /* CommaToken */ ) return every([
            expression.left,
            expression.right
        ], (expression2)=>expressionCouldBeVariableDeclaration(expression2, checker));
        return expression.operatorToken.kind === 64 /* EqualsToken */  && isIdentifier(expression.left) && !checker.getSymbolAtLocation(expression.left);
    }
    var fixId4, errorCodes4;
    var init_addMissingConst = __esm({
        "src/services/codefixes/addMissingConst.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId4 = "addMissingConst";
            errorCodes4 = [
                Diagnostics.Cannot_find_name_0.code,
                Diagnostics.No_value_exists_in_scope_for_the_shorthand_property_0_Either_declare_one_or_provide_an_initializer.code
            ];
            registerCodeFix({
                errorCodes: errorCodes4,
                getCodeActions: function getCodeActionsToAddMissingConst(context) {
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange4(t, context.sourceFile, context.span.start, context.program));
                    if (changes.length > 0) return [
                        createCodeFixAction(fixId4, changes, Diagnostics.Add_const_to_unresolved_variable, fixId4, Diagnostics.Add_const_to_all_unresolved_variables)
                    ];
                },
                fixIds: [
                    fixId4
                ],
                getAllCodeActions: (context)=>{
                    const fixedNodes = /* @__PURE__ */ new Set();
                    return codeFixAll(context, errorCodes4, (changes, diag2)=>makeChange4(changes, diag2.file, diag2.start, context.program, fixedNodes));
                }
            });
        }
    });
    // src/services/codefixes/addMissingDeclareProperty.ts
    function makeChange5(changeTracker, sourceFile, pos, fixedNodes) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (!isIdentifier(token)) return;
        const declaration = token.parent;
        if (declaration.kind === 171 /* PropertyDeclaration */  && (!fixedNodes || tryAddToSet(fixedNodes, declaration))) changeTracker.insertModifierBefore(sourceFile, 138 /* DeclareKeyword */ , declaration);
    }
    var fixId5, errorCodes5;
    var init_addMissingDeclareProperty = __esm({
        "src/services/codefixes/addMissingDeclareProperty.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId5 = "addMissingDeclareProperty";
            errorCodes5 = [
                Diagnostics.Property_0_will_overwrite_the_base_property_in_1_If_this_is_intentional_add_an_initializer_Otherwise_add_a_declare_modifier_or_remove_the_redundant_declaration.code
            ];
            registerCodeFix({
                errorCodes: errorCodes5,
                getCodeActions: function getCodeActionsToAddMissingDeclareOnProperty(context) {
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange5(t, context.sourceFile, context.span.start));
                    if (changes.length > 0) return [
                        createCodeFixAction(fixId5, changes, Diagnostics.Prefix_with_declare, fixId5, Diagnostics.Prefix_all_incorrect_property_declarations_with_declare)
                    ];
                },
                fixIds: [
                    fixId5
                ],
                getAllCodeActions: (context)=>{
                    const fixedNodes = /* @__PURE__ */ new Set();
                    return codeFixAll(context, errorCodes5, (changes, diag2)=>makeChange5(changes, diag2.file, diag2.start, fixedNodes));
                }
            });
        }
    });
    // src/services/codefixes/addMissingInvocationForDecorator.ts
    function makeChange6(changeTracker, sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        const decorator = findAncestor(token, isDecorator);
        Debug.assert(!!decorator, "Expected position to be owned by a decorator.");
        const replacement = factory.createCallExpression(decorator.expression, /*typeArguments*/ void 0, /*argumentsArray*/ void 0);
        changeTracker.replaceNode(sourceFile, decorator.expression, replacement);
    }
    var fixId6, errorCodes6;
    var init_addMissingInvocationForDecorator = __esm({
        "src/services/codefixes/addMissingInvocationForDecorator.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId6 = "addMissingInvocationForDecorator";
            errorCodes6 = [
                Diagnostics._0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0.code
            ];
            registerCodeFix({
                errorCodes: errorCodes6,
                getCodeActions: function getCodeActionsToAddMissingInvocationForDecorator(context) {
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange6(t, context.sourceFile, context.span.start));
                    return [
                        createCodeFixAction(fixId6, changes, Diagnostics.Call_decorator_expression, fixId6, Diagnostics.Add_to_all_uncalled_decorators)
                    ];
                },
                fixIds: [
                    fixId6
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes6, (changes, diag2)=>makeChange6(changes, diag2.file, diag2.start))
            });
        }
    });
    // src/services/codefixes/addNameToNamelessParameter.ts
    function makeChange7(changeTracker, sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        const param = token.parent;
        if (!isParameter(param)) return Debug.fail("Tried to add a parameter name to a non-parameter: " + Debug.formatSyntaxKind(token.kind));
        const i = param.parent.parameters.indexOf(param);
        Debug.assert(!param.type, "Tried to add a parameter name to a parameter that already had one.");
        Debug.assert(i > -1, "Parameter not found in parent parameter list.");
        const typeNode = factory.createTypeReferenceNode(param.name, /*typeArguments*/ void 0);
        const replacement = factory.createParameterDeclaration(param.modifiers, param.dotDotDotToken, "arg" + i, param.questionToken, param.dotDotDotToken ? factory.createArrayTypeNode(typeNode) : typeNode, param.initializer);
        changeTracker.replaceNode(sourceFile, param, replacement);
    }
    var fixId7, errorCodes7;
    var init_addNameToNamelessParameter = __esm({
        "src/services/codefixes/addNameToNamelessParameter.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId7 = "addNameToNamelessParameter";
            errorCodes7 = [
                Diagnostics.Parameter_has_a_name_but_no_type_Did_you_mean_0_Colon_1.code
            ];
            registerCodeFix({
                errorCodes: errorCodes7,
                getCodeActions: function getCodeActionsToAddNameToNamelessParameter(context) {
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange7(t, context.sourceFile, context.span.start));
                    return [
                        createCodeFixAction(fixId7, changes, Diagnostics.Add_parameter_name, fixId7, Diagnostics.Add_names_to_all_parameters_without_names)
                    ];
                },
                fixIds: [
                    fixId7
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes7, (changes, diag2)=>makeChange7(changes, diag2.file, diag2.start))
            });
        }
    });
    // src/services/codefixes/addOptionalPropertyUndefined.ts
    function getPropertiesToAdd(file, span, checker) {
        var _a, _b;
        const sourceTarget = getSourceTarget(getFixableErrorSpanExpression(file, span), checker);
        if (!sourceTarget) return emptyArray;
        const { source: sourceNode , target: targetNode  } = sourceTarget;
        const target = shouldUseParentTypeOfProperty(sourceNode, targetNode, checker) ? checker.getTypeAtLocation(targetNode.expression) : checker.getTypeAtLocation(targetNode);
        if ((_b = (_a = target.symbol) == null ? void 0 : _a.declarations) == null ? void 0 : _b.some((d)=>getSourceFileOfNode(d).fileName.match(/\.d\.ts$/))) return emptyArray;
        return checker.getExactOptionalProperties(target);
    }
    function shouldUseParentTypeOfProperty(sourceNode, targetNode, checker) {
        return isPropertyAccessExpression(targetNode) && !!checker.getExactOptionalProperties(checker.getTypeAtLocation(targetNode.expression)).length && checker.getTypeAtLocation(sourceNode) === checker.getUndefinedType();
    }
    function getSourceTarget(errorNode, checker) {
        var _a;
        if (!errorNode) return void 0;
        else if (isBinaryExpression(errorNode.parent) && errorNode.parent.operatorToken.kind === 64 /* EqualsToken */ ) return {
            source: errorNode.parent.right,
            target: errorNode.parent.left
        };
        else if (isVariableDeclaration(errorNode.parent) && errorNode.parent.initializer) return {
            source: errorNode.parent.initializer,
            target: errorNode.parent.name
        };
        else if (isCallExpression(errorNode.parent)) {
            const n = checker.getSymbolAtLocation(errorNode.parent.expression);
            if (!(n == null ? void 0 : n.valueDeclaration) || !isFunctionLikeKind(n.valueDeclaration.kind)) return void 0;
            if (!isExpression(errorNode)) return void 0;
            const i = errorNode.parent.arguments.indexOf(errorNode);
            if (i === -1) return void 0;
            const name = n.valueDeclaration.parameters[i].name;
            if (isIdentifier(name)) return {
                source: errorNode,
                target: name
            };
        } else if (isPropertyAssignment(errorNode.parent) && isIdentifier(errorNode.parent.name) || isShorthandPropertyAssignment(errorNode.parent)) {
            const parentTarget = getSourceTarget(errorNode.parent.parent, checker);
            if (!parentTarget) return void 0;
            const prop = checker.getPropertyOfType(checker.getTypeAtLocation(parentTarget.target), errorNode.parent.name.text);
            const declaration = (_a = prop == null ? void 0 : prop.declarations) == null ? void 0 : _a[0];
            if (!declaration) return void 0;
            return {
                source: isPropertyAssignment(errorNode.parent) ? errorNode.parent.initializer : errorNode.parent.name,
                target: declaration
            };
        }
        return void 0;
    }
    function addUndefinedToOptionalProperty(changes, toAdd) {
        for (const add of toAdd){
            const d = add.valueDeclaration;
            if (d && (isPropertySignature(d) || isPropertyDeclaration(d)) && d.type) {
                const t = factory.createUnionTypeNode([
                    ...d.type.kind === 191 /* UnionType */  ? d.type.types : [
                        d.type
                    ],
                    factory.createTypeReferenceNode("undefined")
                ]);
                changes.replaceNode(d.getSourceFile(), d.type, t);
            }
        }
    }
    var addOptionalPropertyUndefined, errorCodes8;
    var init_addOptionalPropertyUndefined = __esm({
        "src/services/codefixes/addOptionalPropertyUndefined.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            addOptionalPropertyUndefined = "addOptionalPropertyUndefined";
            errorCodes8 = [
                Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_type_of_the_target.code,
                Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties.code,
                Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties.code
            ];
            registerCodeFix({
                errorCodes: errorCodes8,
                getCodeActions (context) {
                    const typeChecker = context.program.getTypeChecker();
                    const toAdd = getPropertiesToAdd(context.sourceFile, context.span, typeChecker);
                    if (!toAdd.length) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addUndefinedToOptionalProperty(t, toAdd));
                    return [
                        createCodeFixActionWithoutFixAll(addOptionalPropertyUndefined, changes, Diagnostics.Add_undefined_to_optional_property_type)
                    ];
                },
                fixIds: [
                    addOptionalPropertyUndefined
                ]
            });
        }
    });
    // src/services/codefixes/annotateWithTypeFromJSDoc.ts
    function getDeclaration(file, pos) {
        const name = getTokenAtPosition(file, pos);
        return tryCast(isParameter(name.parent) ? name.parent.parent : name.parent, parameterShouldGetTypeFromJSDoc);
    }
    function parameterShouldGetTypeFromJSDoc(node) {
        return isDeclarationWithType(node) && hasUsableJSDoc(node);
    }
    function hasUsableJSDoc(decl) {
        return isFunctionLikeDeclaration(decl) ? decl.parameters.some(hasUsableJSDoc) || !decl.type && !!getJSDocReturnType(decl) : !decl.type && !!getJSDocType(decl);
    }
    function doChange8(changes, sourceFile, decl) {
        if (isFunctionLikeDeclaration(decl) && (getJSDocReturnType(decl) || decl.parameters.some((p)=>!!getJSDocType(p)))) {
            if (!decl.typeParameters) {
                const typeParameters = getJSDocTypeParameterDeclarations(decl);
                if (typeParameters.length) changes.insertTypeParameters(sourceFile, decl, typeParameters);
            }
            const needParens = isArrowFunction(decl) && !findChildOfKind(decl, 21 /* OpenParenToken */ , sourceFile);
            if (needParens) changes.insertNodeBefore(sourceFile, first(decl.parameters), factory.createToken(21 /* OpenParenToken */ ));
            for (const param of decl.parameters)if (!param.type) {
                const paramType = getJSDocType(param);
                if (paramType) changes.tryInsertTypeAnnotation(sourceFile, param, visitNode(paramType, transformJSDocType, isTypeNode));
            }
            if (needParens) changes.insertNodeAfter(sourceFile, last(decl.parameters), factory.createToken(22 /* CloseParenToken */ ));
            if (!decl.type) {
                const returnType = getJSDocReturnType(decl);
                if (returnType) changes.tryInsertTypeAnnotation(sourceFile, decl, visitNode(returnType, transformJSDocType, isTypeNode));
            }
        } else {
            const jsdocType = Debug.checkDefined(getJSDocType(decl), "A JSDocType for this declaration should exist");
            Debug.assert(!decl.type, "The JSDocType decl should have a type");
            changes.tryInsertTypeAnnotation(sourceFile, decl, visitNode(jsdocType, transformJSDocType, isTypeNode));
        }
    }
    function isDeclarationWithType(node) {
        return isFunctionLikeDeclaration(node) || node.kind === 259 /* VariableDeclaration */  || node.kind === 170 /* PropertySignature */  || node.kind === 171 /* PropertyDeclaration */ ;
    }
    function transformJSDocType(node) {
        switch(node.kind){
            case 318 /* JSDocAllType */ :
            case 319 /* JSDocUnknownType */ :
                return factory.createTypeReferenceNode("any", emptyArray);
            case 322 /* JSDocOptionalType */ :
                return transformJSDocOptionalType(node);
            case 321 /* JSDocNonNullableType */ :
                return transformJSDocType(node.type);
            case 320 /* JSDocNullableType */ :
                return transformJSDocNullableType(node);
            case 324 /* JSDocVariadicType */ :
                return transformJSDocVariadicType(node);
            case 323 /* JSDocFunctionType */ :
                return transformJSDocFunctionType(node);
            case 182 /* TypeReference */ :
                return transformJSDocTypeReference(node);
            case 328 /* JSDocTypeLiteral */ :
                return transformJSDocTypeLiteral(node);
            default:
                const visited = visitEachChild(node, transformJSDocType, nullTransformationContext);
                setEmitFlags(visited, 1 /* SingleLine */ );
                return visited;
        }
    }
    function transformJSDocTypeLiteral(node) {
        const typeNode = factory.createTypeLiteralNode(map(node.jsDocPropertyTags, (tag)=>factory.createPropertySignature(/*modifiers*/ void 0, isIdentifier(tag.name) ? tag.name : tag.name.right, isOptionalJSDocPropertyLikeTag(tag) ? factory.createToken(58 /* QuestionToken */ ) : void 0, tag.typeExpression && visitNode(tag.typeExpression.type, transformJSDocType, isTypeNode) || factory.createKeywordTypeNode(133 /* AnyKeyword */ ))));
        setEmitFlags(typeNode, 1 /* SingleLine */ );
        return typeNode;
    }
    function transformJSDocOptionalType(node) {
        return factory.createUnionTypeNode([
            visitNode(node.type, transformJSDocType, isTypeNode),
            factory.createTypeReferenceNode("undefined", emptyArray)
        ]);
    }
    function transformJSDocNullableType(node) {
        return factory.createUnionTypeNode([
            visitNode(node.type, transformJSDocType, isTypeNode),
            factory.createTypeReferenceNode("null", emptyArray)
        ]);
    }
    function transformJSDocVariadicType(node) {
        return factory.createArrayTypeNode(visitNode(node.type, transformJSDocType, isTypeNode));
    }
    function transformJSDocFunctionType(node) {
        return factory.createFunctionTypeNode(emptyArray, node.parameters.map(transformJSDocParameter), node.type ?? factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
    }
    function transformJSDocParameter(node) {
        const index = node.parent.parameters.indexOf(node);
        const isRest = node.type.kind === 324 /* JSDocVariadicType */  && index === node.parent.parameters.length - 1;
        const name = node.name || (isRest ? "rest" : "arg" + index);
        const dotdotdot = isRest ? factory.createToken(26 /* DotDotDotToken */ ) : node.dotDotDotToken;
        return factory.createParameterDeclaration(node.modifiers, dotdotdot, name, node.questionToken, visitNode(node.type, transformJSDocType, isTypeNode), node.initializer);
    }
    function transformJSDocTypeReference(node) {
        let name = node.typeName;
        let args = node.typeArguments;
        if (isIdentifier(node.typeName)) {
            if (isJSDocIndexSignature(node)) return transformJSDocIndexSignature(node);
            let text = node.typeName.text;
            switch(node.typeName.text){
                case "String":
                case "Boolean":
                case "Object":
                case "Number":
                    text = text.toLowerCase();
                    break;
                case "array":
                case "date":
                case "promise":
                    text = text[0].toUpperCase() + text.slice(1);
                    break;
            }
            name = factory.createIdentifier(text);
            if ((text === "Array" || text === "Promise") && !node.typeArguments) args = factory.createNodeArray([
                factory.createTypeReferenceNode("any", emptyArray)
            ]);
            else args = visitNodes2(node.typeArguments, transformJSDocType, isTypeNode);
        }
        return factory.createTypeReferenceNode(name, args);
    }
    function transformJSDocIndexSignature(node) {
        const index = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, node.typeArguments[0].kind === 150 /* NumberKeyword */  ? "n" : "s", /*questionToken*/ void 0, factory.createTypeReferenceNode(node.typeArguments[0].kind === 150 /* NumberKeyword */  ? "number" : "string", []), /*initializer*/ void 0);
        const indexSignature = factory.createTypeLiteralNode([
            factory.createIndexSignature(/*modifiers*/ void 0, [
                index
            ], node.typeArguments[1])
        ]);
        setEmitFlags(indexSignature, 1 /* SingleLine */ );
        return indexSignature;
    }
    var fixId8, errorCodes9;
    var init_annotateWithTypeFromJSDoc = __esm({
        "src/services/codefixes/annotateWithTypeFromJSDoc.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId8 = "annotateWithTypeFromJSDoc";
            errorCodes9 = [
                Diagnostics.JSDoc_types_may_be_moved_to_TypeScript_types.code
            ];
            registerCodeFix({
                errorCodes: errorCodes9,
                getCodeActions (context) {
                    const decl = getDeclaration(context.sourceFile, context.span.start);
                    if (!decl) return;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange8(t, context.sourceFile, decl));
                    return [
                        createCodeFixAction(fixId8, changes, Diagnostics.Annotate_with_type_from_JSDoc, fixId8, Diagnostics.Annotate_everything_with_types_from_JSDoc)
                    ];
                },
                fixIds: [
                    fixId8
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes9, (changes, diag2)=>{
                        const decl = getDeclaration(diag2.file, diag2.start);
                        if (decl) doChange8(changes, diag2.file, decl);
                    })
            });
        }
    });
    // src/services/codefixes/convertFunctionToEs6Class.ts
    function doChange9(changes, sourceFile, position, checker, preferences, compilerOptions) {
        const ctorSymbol = checker.getSymbolAtLocation(getTokenAtPosition(sourceFile, position));
        if (!ctorSymbol || !ctorSymbol.valueDeclaration || !(ctorSymbol.flags & 19 /* Variable */ )) return void 0;
        const ctorDeclaration = ctorSymbol.valueDeclaration;
        if (isFunctionDeclaration(ctorDeclaration) || isFunctionExpression(ctorDeclaration)) changes.replaceNode(sourceFile, ctorDeclaration, createClassFromFunction(ctorDeclaration));
        else if (isVariableDeclaration(ctorDeclaration)) {
            const classDeclaration = createClassFromVariableDeclaration(ctorDeclaration);
            if (!classDeclaration) return void 0;
            const ancestor = ctorDeclaration.parent.parent;
            if (isVariableDeclarationList(ctorDeclaration.parent) && ctorDeclaration.parent.declarations.length > 1) {
                changes.delete(sourceFile, ctorDeclaration);
                changes.insertNodeAfter(sourceFile, ancestor, classDeclaration);
            } else changes.replaceNode(sourceFile, ancestor, classDeclaration);
        }
        function createClassElementsFromSymbol(symbol) {
            const memberElements = [];
            if (symbol.exports) symbol.exports.forEach((member)=>{
                if (member.name === "prototype" && member.declarations) {
                    const firstDeclaration = member.declarations[0];
                    if (member.declarations.length === 1 && isPropertyAccessExpression(firstDeclaration) && isBinaryExpression(firstDeclaration.parent) && firstDeclaration.parent.operatorToken.kind === 64 /* EqualsToken */  && isObjectLiteralExpression(firstDeclaration.parent.right)) {
                        const prototypes = firstDeclaration.parent.right;
                        createClassElement(prototypes.symbol, /*modifiers*/ void 0, memberElements);
                    }
                } else createClassElement(member, [
                    factory.createToken(126 /* StaticKeyword */ )
                ], memberElements);
            });
            if (symbol.members) symbol.members.forEach((member, key)=>{
                var _a, _b, _c, _d;
                if (key === "constructor" && member.valueDeclaration) {
                    const prototypeAssignment = (_d = (_c = (_b = (_a = symbol.exports) == null ? void 0 : _a.get("prototype")) == null ? void 0 : _b.declarations) == null ? void 0 : _c[0]) == null ? void 0 : _d.parent;
                    if (prototypeAssignment && isBinaryExpression(prototypeAssignment) && isObjectLiteralExpression(prototypeAssignment.right) && some(prototypeAssignment.right.properties, isConstructorAssignment)) ;
                    else changes.delete(sourceFile, member.valueDeclaration.parent);
                    return;
                }
                createClassElement(member, /*modifiers*/ void 0, memberElements);
            });
            return memberElements;
            function shouldConvertDeclaration(_target, source) {
                if (isAccessExpression(_target)) {
                    if (isPropertyAccessExpression(_target) && isConstructorAssignment(_target)) return true;
                    return isFunctionLike(source);
                } else return every(_target.properties, (property)=>{
                    if (isMethodDeclaration(property) || isGetOrSetAccessorDeclaration(property)) return true;
                    if (isPropertyAssignment(property) && isFunctionExpression(property.initializer) && !!property.name) return true;
                    if (isConstructorAssignment(property)) return true;
                    return false;
                });
            }
            function createClassElement(symbol2, modifiers, members) {
                if (!(symbol2.flags & 8192 /* Method */ ) && !(symbol2.flags & 4096 /* ObjectLiteral */ )) return;
                const memberDeclaration = symbol2.valueDeclaration;
                const assignmentBinaryExpression = memberDeclaration.parent;
                const assignmentExpr = assignmentBinaryExpression.right;
                if (!shouldConvertDeclaration(memberDeclaration, assignmentExpr)) return;
                if (some(members, (m)=>{
                    const name = getNameOfDeclaration(m);
                    if (name && isIdentifier(name) && idText(name) === symbolName(symbol2)) return true;
                    return false;
                })) return;
                const nodeToDelete = assignmentBinaryExpression.parent && assignmentBinaryExpression.parent.kind === 243 /* ExpressionStatement */  ? assignmentBinaryExpression.parent : assignmentBinaryExpression;
                changes.delete(sourceFile, nodeToDelete);
                if (!assignmentExpr) {
                    members.push(factory.createPropertyDeclaration(modifiers, symbol2.name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0));
                    return;
                }
                if (isAccessExpression(memberDeclaration) && (isFunctionExpression(assignmentExpr) || isArrowFunction(assignmentExpr))) {
                    const quotePreference = getQuotePreference(sourceFile, preferences);
                    const name = tryGetPropertyName(memberDeclaration, compilerOptions, quotePreference);
                    if (name) createFunctionLikeExpressionMember(members, assignmentExpr, name);
                    return;
                } else if (isObjectLiteralExpression(assignmentExpr)) {
                    forEach(assignmentExpr.properties, (property)=>{
                        if (isMethodDeclaration(property) || isGetOrSetAccessorDeclaration(property)) members.push(property);
                        if (isPropertyAssignment(property) && isFunctionExpression(property.initializer)) createFunctionLikeExpressionMember(members, property.initializer, property.name);
                        if (isConstructorAssignment(property)) return;
                        return;
                    });
                    return;
                } else {
                    if (isSourceFileJS(sourceFile)) return;
                    if (!isPropertyAccessExpression(memberDeclaration)) return;
                    const prop = factory.createPropertyDeclaration(modifiers, memberDeclaration.name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, assignmentExpr);
                    copyLeadingComments(assignmentBinaryExpression.parent, prop, sourceFile);
                    members.push(prop);
                    return;
                }
                function createFunctionLikeExpressionMember(members2, expression, name) {
                    if (isFunctionExpression(expression)) return createFunctionExpressionMember(members2, expression, name);
                    else return createArrowFunctionExpressionMember(members2, expression, name);
                }
                function createFunctionExpressionMember(members2, functionExpression, name) {
                    const fullModifiers = concatenate(modifiers, getModifierKindFromSource(functionExpression, 134 /* AsyncKeyword */ ));
                    const method = factory.createMethodDeclaration(fullModifiers, /*asteriskToken*/ void 0, name, /*questionToken*/ void 0, /*typeParameters*/ void 0, functionExpression.parameters, /*type*/ void 0, functionExpression.body);
                    copyLeadingComments(assignmentBinaryExpression, method, sourceFile);
                    members2.push(method);
                    return;
                }
                function createArrowFunctionExpressionMember(members2, arrowFunction, name) {
                    const arrowFunctionBody = arrowFunction.body;
                    let bodyBlock;
                    if (arrowFunctionBody.kind === 240 /* Block */ ) bodyBlock = arrowFunctionBody;
                    else bodyBlock = factory.createBlock([
                        factory.createReturnStatement(arrowFunctionBody)
                    ]);
                    const fullModifiers = concatenate(modifiers, getModifierKindFromSource(arrowFunction, 134 /* AsyncKeyword */ ));
                    const method = factory.createMethodDeclaration(fullModifiers, /*asteriskToken*/ void 0, name, /*questionToken*/ void 0, /*typeParameters*/ void 0, arrowFunction.parameters, /*type*/ void 0, bodyBlock);
                    copyLeadingComments(assignmentBinaryExpression, method, sourceFile);
                    members2.push(method);
                }
            }
        }
        function createClassFromVariableDeclaration(node) {
            const initializer = node.initializer;
            if (!initializer || !isFunctionExpression(initializer) || !isIdentifier(node.name)) return void 0;
            const memberElements = createClassElementsFromSymbol(node.symbol);
            if (initializer.body) memberElements.unshift(factory.createConstructorDeclaration(/*modifiers*/ void 0, initializer.parameters, initializer.body));
            const modifiers = getModifierKindFromSource(node.parent.parent, 95 /* ExportKeyword */ );
            const cls = factory.createClassDeclaration(modifiers, node.name, /*typeParameters*/ void 0, /*heritageClauses*/ void 0, memberElements);
            return cls;
        }
        function createClassFromFunction(node) {
            const memberElements = createClassElementsFromSymbol(ctorSymbol);
            if (node.body) memberElements.unshift(factory.createConstructorDeclaration(/*modifiers*/ void 0, node.parameters, node.body));
            const modifiers = getModifierKindFromSource(node, 95 /* ExportKeyword */ );
            const cls = factory.createClassDeclaration(modifiers, node.name, /*typeParameters*/ void 0, /*heritageClauses*/ void 0, memberElements);
            return cls;
        }
    }
    function getModifierKindFromSource(source, kind) {
        return canHaveModifiers(source) ? filter(source.modifiers, (modifier)=>modifier.kind === kind) : void 0;
    }
    function isConstructorAssignment(x) {
        if (!x.name) return false;
        if (isIdentifier(x.name) && x.name.text === "constructor") return true;
        return false;
    }
    function tryGetPropertyName(node, compilerOptions, quotePreference) {
        if (isPropertyAccessExpression(node)) return node.name;
        const propName = node.argumentExpression;
        if (isNumericLiteral(propName)) return propName;
        if (isStringLiteralLike(propName)) return isIdentifierText(propName.text, getEmitScriptTarget(compilerOptions)) ? factory.createIdentifier(propName.text) : isNoSubstitutionTemplateLiteral(propName) ? factory.createStringLiteral(propName.text, quotePreference === 0 /* Single */ ) : propName;
        return void 0;
    }
    var fixId9, errorCodes10;
    var init_convertFunctionToEs6Class = __esm({
        "src/services/codefixes/convertFunctionToEs6Class.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId9 = "convertFunctionToEs6Class";
            errorCodes10 = [
                Diagnostics.This_constructor_function_may_be_converted_to_a_class_declaration.code
            ];
            registerCodeFix({
                errorCodes: errorCodes10,
                getCodeActions (context) {
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange9(t, context.sourceFile, context.span.start, context.program.getTypeChecker(), context.preferences, context.program.getCompilerOptions()));
                    return [
                        createCodeFixAction(fixId9, changes, Diagnostics.Convert_function_to_an_ES2015_class, fixId9, Diagnostics.Convert_all_constructor_functions_to_classes)
                    ];
                },
                fixIds: [
                    fixId9
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes10, (changes, err)=>doChange9(changes, err.file, err.start, context.program.getTypeChecker(), context.preferences, context.program.getCompilerOptions()))
            });
        }
    });
    // src/services/codefixes/convertToAsyncFunction.ts
    function convertToAsyncFunction(changes, sourceFile, position, checker) {
        const tokenAtPosition = getTokenAtPosition(sourceFile, position);
        let functionToConvert;
        if (isIdentifier(tokenAtPosition) && isVariableDeclaration(tokenAtPosition.parent) && tokenAtPosition.parent.initializer && isFunctionLikeDeclaration(tokenAtPosition.parent.initializer)) functionToConvert = tokenAtPosition.parent.initializer;
        else functionToConvert = tryCast(getContainingFunction(getTokenAtPosition(sourceFile, position)), canBeConvertedToAsync);
        if (!functionToConvert) return;
        const synthNamesMap = /* @__PURE__ */ new Map();
        const isInJavascript = isInJSFile(functionToConvert);
        const setOfExpressionsToReturn = getAllPromiseExpressionsToReturn(functionToConvert, checker);
        const functionToConvertRenamed = renameCollidingVarNames(functionToConvert, checker, synthNamesMap);
        if (!returnsPromise(functionToConvertRenamed, checker)) return;
        const returnStatements = functionToConvertRenamed.body && isBlock(functionToConvertRenamed.body) ? getReturnStatementsWithPromiseHandlers(functionToConvertRenamed.body, checker) : emptyArray;
        const transformer = {
            checker: checker,
            synthNamesMap: synthNamesMap,
            setOfExpressionsToReturn: setOfExpressionsToReturn,
            isInJSFile: isInJavascript
        };
        if (!returnStatements.length) return;
        const pos = skipTrivia(sourceFile.text, moveRangePastModifiers(functionToConvert).pos);
        changes.insertModifierAt(sourceFile, pos, 134 /* AsyncKeyword */ , {
            suffix: " "
        });
        for (const returnStatement of returnStatements){
            forEachChild(returnStatement, function visit(node) {
                if (isCallExpression(node)) {
                    const newNodes = transformExpression(node, node, transformer, /*hasContinuation*/ false);
                    if (hasFailed()) return true;
                    changes.replaceNodeWithNodes(sourceFile, returnStatement, newNodes);
                } else if (!isFunctionLike(node)) {
                    forEachChild(node, visit);
                    if (hasFailed()) return true;
                }
            });
            if (hasFailed()) return;
        }
    }
    function getReturnStatementsWithPromiseHandlers(body, checker) {
        const res = [];
        forEachReturnStatement(body, (ret)=>{
            if (isReturnStatementWithFixablePromiseHandler(ret, checker)) res.push(ret);
        });
        return res;
    }
    function getAllPromiseExpressionsToReturn(func, checker) {
        if (!func.body) return /* @__PURE__ */ new Set();
        const setOfExpressionsToReturn = /* @__PURE__ */ new Set();
        forEachChild(func.body, function visit(node) {
            if (isPromiseReturningCallExpression(node, checker, "then")) {
                setOfExpressionsToReturn.add(getNodeId(node));
                forEach(node.arguments, visit);
            } else if (isPromiseReturningCallExpression(node, checker, "catch") || isPromiseReturningCallExpression(node, checker, "finally")) {
                setOfExpressionsToReturn.add(getNodeId(node));
                forEachChild(node, visit);
            } else if (isPromiseTypedExpression(node, checker)) setOfExpressionsToReturn.add(getNodeId(node));
            else forEachChild(node, visit);
        });
        return setOfExpressionsToReturn;
    }
    function isPromiseReturningCallExpression(node, checker, name) {
        if (!isCallExpression(node)) return false;
        const isExpressionOfName = hasPropertyAccessExpressionWithName(node, name);
        const nodeType = isExpressionOfName && checker.getTypeAtLocation(node);
        return !!(nodeType && checker.getPromisedTypeOfPromise(nodeType));
    }
    function isReferenceToType(type, target) {
        return (getObjectFlags(type) & 4 /* Reference */ ) !== 0 && type.target === target;
    }
    function getExplicitPromisedTypeOfPromiseReturningCallExpression(node, callback, checker) {
        if (node.expression.name.escapedText === "finally") return void 0;
        const promiseType = checker.getTypeAtLocation(node.expression.expression);
        if (isReferenceToType(promiseType, checker.getPromiseType()) || isReferenceToType(promiseType, checker.getPromiseLikeType())) {
            if (node.expression.name.escapedText === "then") {
                if (callback === elementAt(node.arguments, 0)) return elementAt(node.typeArguments, 0);
                else if (callback === elementAt(node.arguments, 1)) return elementAt(node.typeArguments, 1);
            } else return elementAt(node.typeArguments, 0);
        }
    }
    function isPromiseTypedExpression(node, checker) {
        if (!isExpression(node)) return false;
        return !!checker.getPromisedTypeOfPromise(checker.getTypeAtLocation(node));
    }
    function renameCollidingVarNames(nodeToRename, checker, synthNamesMap) {
        const identsToRenameMap = /* @__PURE__ */ new Map();
        const collidingSymbolMap = createMultiMap();
        forEachChild(nodeToRename, function visit(node) {
            if (!isIdentifier(node)) {
                forEachChild(node, visit);
                return;
            }
            const symbol = checker.getSymbolAtLocation(node);
            if (symbol) {
                const type = checker.getTypeAtLocation(node);
                const lastCallSignature = getLastCallSignature(type, checker);
                const symbolIdString = getSymbolId(symbol).toString();
                if (lastCallSignature && !isParameter(node.parent) && !isFunctionLikeDeclaration(node.parent) && !synthNamesMap.has(symbolIdString)) {
                    const firstParameter = firstOrUndefined(lastCallSignature.parameters);
                    const ident = (firstParameter == null ? void 0 : firstParameter.valueDeclaration) && isParameter(firstParameter.valueDeclaration) && tryCast(firstParameter.valueDeclaration.name, isIdentifier) || factory.createUniqueName("result", 16 /* Optimistic */ );
                    const synthName = getNewNameIfConflict(ident, collidingSymbolMap);
                    synthNamesMap.set(symbolIdString, synthName);
                    collidingSymbolMap.add(ident.text, symbol);
                } else if (node.parent && (isParameter(node.parent) || isVariableDeclaration(node.parent) || isBindingElement(node.parent))) {
                    const originalName = node.text;
                    const collidingSymbols = collidingSymbolMap.get(originalName);
                    if (collidingSymbols && collidingSymbols.some((prevSymbol)=>prevSymbol !== symbol)) {
                        const newName = getNewNameIfConflict(node, collidingSymbolMap);
                        identsToRenameMap.set(symbolIdString, newName.identifier);
                        synthNamesMap.set(symbolIdString, newName);
                        collidingSymbolMap.add(originalName, symbol);
                    } else {
                        const identifier = getSynthesizedDeepClone(node);
                        synthNamesMap.set(symbolIdString, createSynthIdentifier(identifier));
                        collidingSymbolMap.add(originalName, symbol);
                    }
                }
            }
        });
        return getSynthesizedDeepCloneWithReplacements(nodeToRename, /*includeTrivia*/ true, (original)=>{
            if (isBindingElement(original) && isIdentifier(original.name) && isObjectBindingPattern(original.parent)) {
                const symbol = checker.getSymbolAtLocation(original.name);
                const renameInfo = symbol && identsToRenameMap.get(String(getSymbolId(symbol)));
                if (renameInfo && renameInfo.text !== (original.name || original.propertyName).getText()) return factory.createBindingElement(original.dotDotDotToken, original.propertyName || original.name, renameInfo, original.initializer);
            } else if (isIdentifier(original)) {
                const symbol = checker.getSymbolAtLocation(original);
                const renameInfo = symbol && identsToRenameMap.get(String(getSymbolId(symbol)));
                if (renameInfo) return factory.createIdentifier(renameInfo.text);
            }
        });
    }
    function getNewNameIfConflict(name, originalNames) {
        const numVarsSameName = (originalNames.get(name.text) || emptyArray).length;
        const identifier = numVarsSameName === 0 ? name : factory.createIdentifier(name.text + "_" + numVarsSameName);
        return createSynthIdentifier(identifier);
    }
    function hasFailed() {
        return !codeActionSucceeded;
    }
    function silentFail() {
        codeActionSucceeded = false;
        return emptyArray;
    }
    function transformExpression(returnContextNode, node, transformer, hasContinuation, continuationArgName) {
        if (isPromiseReturningCallExpression(node, transformer.checker, "then")) return transformThen(node, elementAt(node.arguments, 0), elementAt(node.arguments, 1), transformer, hasContinuation, continuationArgName);
        if (isPromiseReturningCallExpression(node, transformer.checker, "catch")) return transformCatch(node, elementAt(node.arguments, 0), transformer, hasContinuation, continuationArgName);
        if (isPromiseReturningCallExpression(node, transformer.checker, "finally")) return transformFinally(node, elementAt(node.arguments, 0), transformer, hasContinuation, continuationArgName);
        if (isPropertyAccessExpression(node)) return transformExpression(returnContextNode, node.expression, transformer, hasContinuation, continuationArgName);
        const nodeType = transformer.checker.getTypeAtLocation(node);
        if (nodeType && transformer.checker.getPromisedTypeOfPromise(nodeType)) {
            Debug.assertNode(getOriginalNode(node).parent, isPropertyAccessExpression);
            return transformPromiseExpressionOfPropertyAccess(returnContextNode, node, transformer, hasContinuation, continuationArgName);
        }
        return silentFail();
    }
    function isNullOrUndefined2({ checker: checker  }, node) {
        if (node.kind === 106 /* NullKeyword */ ) return true;
        if (isIdentifier(node) && !isGeneratedIdentifier(node) && idText(node) === "undefined") {
            const symbol = checker.getSymbolAtLocation(node);
            return !symbol || checker.isUndefinedSymbol(symbol);
        }
        return false;
    }
    function createUniqueSynthName(prevArgName) {
        const renamedPrevArg = factory.createUniqueName(prevArgName.identifier.text, 16 /* Optimistic */ );
        return createSynthIdentifier(renamedPrevArg);
    }
    function getPossibleNameForVarDecl(node, transformer, continuationArgName) {
        let possibleNameForVarDecl;
        if (continuationArgName && !shouldReturn(node, transformer)) {
            if (isSynthIdentifier(continuationArgName)) {
                possibleNameForVarDecl = continuationArgName;
                transformer.synthNamesMap.forEach((val, key)=>{
                    if (val.identifier.text === continuationArgName.identifier.text) {
                        const newSynthName = createUniqueSynthName(continuationArgName);
                        transformer.synthNamesMap.set(key, newSynthName);
                    }
                });
            } else possibleNameForVarDecl = createSynthIdentifier(factory.createUniqueName("result", 16 /* Optimistic */ ), continuationArgName.types);
            declareSynthIdentifier(possibleNameForVarDecl);
        }
        return possibleNameForVarDecl;
    }
    function finishCatchOrFinallyTransform(node, transformer, tryStatement, possibleNameForVarDecl, continuationArgName) {
        const statements = [];
        let varDeclIdentifier;
        if (possibleNameForVarDecl && !shouldReturn(node, transformer)) {
            varDeclIdentifier = getSynthesizedDeepClone(declareSynthIdentifier(possibleNameForVarDecl));
            const typeArray = possibleNameForVarDecl.types;
            const unionType = transformer.checker.getUnionType(typeArray, 2 /* Subtype */ );
            const unionTypeNode = transformer.isInJSFile ? void 0 : transformer.checker.typeToTypeNode(unionType, /*enclosingDeclaration*/ void 0, /*flags*/ void 0);
            const varDecl = [
                factory.createVariableDeclaration(varDeclIdentifier, /*exclamationToken*/ void 0, unionTypeNode)
            ];
            const varDeclList = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList(varDecl, 1 /* Let */ ));
            statements.push(varDeclList);
        }
        statements.push(tryStatement);
        if (continuationArgName && varDeclIdentifier && isSynthBindingPattern(continuationArgName)) statements.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(getSynthesizedDeepClone(declareSynthBindingPattern(continuationArgName)), /*exclamationToken*/ void 0, /*type*/ void 0, varDeclIdentifier)
        ], 2 /* Const */ )));
        return statements;
    }
    function transformFinally(node, onFinally, transformer, hasContinuation, continuationArgName) {
        if (!onFinally || isNullOrUndefined2(transformer, onFinally)) return transformExpression(/* returnContextNode */ node, node.expression.expression, transformer, hasContinuation, continuationArgName);
        const possibleNameForVarDecl = getPossibleNameForVarDecl(node, transformer, continuationArgName);
        const inlinedLeftHandSide = transformExpression(/*returnContextNode*/ node, node.expression.expression, transformer, /*hasContinuation*/ true, possibleNameForVarDecl);
        if (hasFailed()) return silentFail();
        const inlinedCallback = transformCallbackArgument(onFinally, hasContinuation, /*continuationArgName*/ void 0, /*inputArgName*/ void 0, node, transformer);
        if (hasFailed()) return silentFail();
        const tryBlock = factory.createBlock(inlinedLeftHandSide);
        const finallyBlock = factory.createBlock(inlinedCallback);
        const tryStatement = factory.createTryStatement(tryBlock, /*catchClause*/ void 0, finallyBlock);
        return finishCatchOrFinallyTransform(node, transformer, tryStatement, possibleNameForVarDecl, continuationArgName);
    }
    function transformCatch(node, onRejected, transformer, hasContinuation, continuationArgName) {
        if (!onRejected || isNullOrUndefined2(transformer, onRejected)) return transformExpression(/* returnContextNode */ node, node.expression.expression, transformer, hasContinuation, continuationArgName);
        const inputArgName = getArgBindingName(onRejected, transformer);
        const possibleNameForVarDecl = getPossibleNameForVarDecl(node, transformer, continuationArgName);
        const inlinedLeftHandSide = transformExpression(/*returnContextNode*/ node, node.expression.expression, transformer, /*hasContinuation*/ true, possibleNameForVarDecl);
        if (hasFailed()) return silentFail();
        const inlinedCallback = transformCallbackArgument(onRejected, hasContinuation, possibleNameForVarDecl, inputArgName, node, transformer);
        if (hasFailed()) return silentFail();
        const tryBlock = factory.createBlock(inlinedLeftHandSide);
        const catchClause = factory.createCatchClause(inputArgName && getSynthesizedDeepClone(declareSynthBindingName(inputArgName)), factory.createBlock(inlinedCallback));
        const tryStatement = factory.createTryStatement(tryBlock, catchClause, /*finallyBlock*/ void 0);
        return finishCatchOrFinallyTransform(node, transformer, tryStatement, possibleNameForVarDecl, continuationArgName);
    }
    function transformThen(node, onFulfilled, onRejected, transformer, hasContinuation, continuationArgName) {
        if (!onFulfilled || isNullOrUndefined2(transformer, onFulfilled)) return transformCatch(node, onRejected, transformer, hasContinuation, continuationArgName);
        if (onRejected && !isNullOrUndefined2(transformer, onRejected)) return silentFail();
        const inputArgName = getArgBindingName(onFulfilled, transformer);
        const inlinedLeftHandSide = transformExpression(node.expression.expression, node.expression.expression, transformer, /*hasContinuation*/ true, inputArgName);
        if (hasFailed()) return silentFail();
        const inlinedCallback = transformCallbackArgument(onFulfilled, hasContinuation, continuationArgName, inputArgName, node, transformer);
        if (hasFailed()) return silentFail();
        return concatenate(inlinedLeftHandSide, inlinedCallback);
    }
    function transformPromiseExpressionOfPropertyAccess(returnContextNode, node, transformer, hasContinuation, continuationArgName) {
        if (shouldReturn(returnContextNode, transformer)) {
            let returnValue = getSynthesizedDeepClone(node);
            if (hasContinuation) returnValue = factory.createAwaitExpression(returnValue);
            return [
                factory.createReturnStatement(returnValue)
            ];
        }
        return createVariableOrAssignmentOrExpressionStatement(continuationArgName, factory.createAwaitExpression(node), /*typeAnnotation*/ void 0);
    }
    function createVariableOrAssignmentOrExpressionStatement(variableName, rightHandSide, typeAnnotation) {
        if (!variableName || isEmptyBindingName(variableName)) return [
            factory.createExpressionStatement(rightHandSide)
        ];
        if (isSynthIdentifier(variableName) && variableName.hasBeenDeclared) return [
            factory.createExpressionStatement(factory.createAssignment(getSynthesizedDeepClone(referenceSynthIdentifier(variableName)), rightHandSide))
        ];
        return [
            factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                factory.createVariableDeclaration(getSynthesizedDeepClone(declareSynthBindingName(variableName)), /*exclamationToken*/ void 0, typeAnnotation, rightHandSide)
            ], 2 /* Const */ ))
        ];
    }
    function maybeAnnotateAndReturn(expressionToReturn, typeAnnotation) {
        if (typeAnnotation && expressionToReturn) {
            const name = factory.createUniqueName("result", 16 /* Optimistic */ );
            return [
                ...createVariableOrAssignmentOrExpressionStatement(createSynthIdentifier(name), expressionToReturn, typeAnnotation),
                factory.createReturnStatement(name)
            ];
        }
        return [
            factory.createReturnStatement(expressionToReturn)
        ];
    }
    function transformCallbackArgument(func, hasContinuation, continuationArgName, inputArgName, parent2, transformer) {
        var _a;
        switch(func.kind){
            case 106 /* NullKeyword */ :
                break;
            case 210 /* PropertyAccessExpression */ :
            case 80 /* Identifier */ :
                if (!inputArgName) break;
                const synthCall = factory.createCallExpression(getSynthesizedDeepClone(func), /*typeArguments*/ void 0, isSynthIdentifier(inputArgName) ? [
                    referenceSynthIdentifier(inputArgName)
                ] : []);
                if (shouldReturn(parent2, transformer)) return maybeAnnotateAndReturn(synthCall, getExplicitPromisedTypeOfPromiseReturningCallExpression(parent2, func, transformer.checker));
                const type = transformer.checker.getTypeAtLocation(func);
                const callSignatures = transformer.checker.getSignaturesOfType(type, 0 /* Call */ );
                if (!callSignatures.length) return silentFail();
                const returnType = callSignatures[0].getReturnType();
                const varDeclOrAssignment = createVariableOrAssignmentOrExpressionStatement(continuationArgName, factory.createAwaitExpression(synthCall), getExplicitPromisedTypeOfPromiseReturningCallExpression(parent2, func, transformer.checker));
                if (continuationArgName) continuationArgName.types.push(transformer.checker.getAwaitedType(returnType) || returnType);
                return varDeclOrAssignment;
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
                {
                    const funcBody = func.body;
                    const returnType2 = (_a = getLastCallSignature(transformer.checker.getTypeAtLocation(func), transformer.checker)) == null ? void 0 : _a.getReturnType();
                    if (isBlock(funcBody)) {
                        let refactoredStmts = [];
                        let seenReturnStatement = false;
                        for (const statement of funcBody.statements){
                            if (isReturnStatement(statement)) {
                                seenReturnStatement = true;
                                if (isReturnStatementWithFixablePromiseHandler(statement, transformer.checker)) refactoredStmts = refactoredStmts.concat(transformReturnStatementWithFixablePromiseHandler(transformer, statement, hasContinuation, continuationArgName));
                                else {
                                    const possiblyAwaitedRightHandSide = returnType2 && statement.expression ? getPossiblyAwaitedRightHandSide(transformer.checker, returnType2, statement.expression) : statement.expression;
                                    refactoredStmts.push(...maybeAnnotateAndReturn(possiblyAwaitedRightHandSide, getExplicitPromisedTypeOfPromiseReturningCallExpression(parent2, func, transformer.checker)));
                                }
                            } else if (hasContinuation && forEachReturnStatement(statement, returnTrue)) return silentFail();
                            else refactoredStmts.push(statement);
                        }
                        return shouldReturn(parent2, transformer) ? refactoredStmts.map((s)=>getSynthesizedDeepClone(s)) : removeReturns(refactoredStmts, continuationArgName, transformer, seenReturnStatement);
                    } else {
                        const inlinedStatements = isFixablePromiseHandler(funcBody, transformer.checker) ? transformReturnStatementWithFixablePromiseHandler(transformer, factory.createReturnStatement(funcBody), hasContinuation, continuationArgName) : emptyArray;
                        if (inlinedStatements.length > 0) return inlinedStatements;
                        if (returnType2) {
                            const possiblyAwaitedRightHandSide = getPossiblyAwaitedRightHandSide(transformer.checker, returnType2, funcBody);
                            if (!shouldReturn(parent2, transformer)) {
                                const transformedStatement = createVariableOrAssignmentOrExpressionStatement(continuationArgName, possiblyAwaitedRightHandSide, /*typeAnnotation*/ void 0);
                                if (continuationArgName) continuationArgName.types.push(transformer.checker.getAwaitedType(returnType2) || returnType2);
                                return transformedStatement;
                            } else return maybeAnnotateAndReturn(possiblyAwaitedRightHandSide, getExplicitPromisedTypeOfPromiseReturningCallExpression(parent2, func, transformer.checker));
                        } else return silentFail();
                    }
                }
            default:
                return silentFail();
        }
        return emptyArray;
    }
    function getPossiblyAwaitedRightHandSide(checker, type, expr) {
        const rightHandSide = getSynthesizedDeepClone(expr);
        return !!checker.getPromisedTypeOfPromise(type) ? factory.createAwaitExpression(rightHandSide) : rightHandSide;
    }
    function getLastCallSignature(type, checker) {
        const callSignatures = checker.getSignaturesOfType(type, 0 /* Call */ );
        return lastOrUndefined(callSignatures);
    }
    function removeReturns(stmts, prevArgName, transformer, seenReturnStatement) {
        const ret = [];
        for (const stmt of stmts){
            if (isReturnStatement(stmt)) {
                if (stmt.expression) {
                    const possiblyAwaitedExpression = isPromiseTypedExpression(stmt.expression, transformer.checker) ? factory.createAwaitExpression(stmt.expression) : stmt.expression;
                    if (prevArgName === void 0) ret.push(factory.createExpressionStatement(possiblyAwaitedExpression));
                    else if (isSynthIdentifier(prevArgName) && prevArgName.hasBeenDeclared) ret.push(factory.createExpressionStatement(factory.createAssignment(referenceSynthIdentifier(prevArgName), possiblyAwaitedExpression)));
                    else ret.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                        factory.createVariableDeclaration(declareSynthBindingName(prevArgName), /*exclamationToken*/ void 0, /*type*/ void 0, possiblyAwaitedExpression)
                    ], 2 /* Const */ )));
                }
            } else ret.push(getSynthesizedDeepClone(stmt));
        }
        if (!seenReturnStatement && prevArgName !== void 0) ret.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(declareSynthBindingName(prevArgName), /*exclamationToken*/ void 0, /*type*/ void 0, factory.createIdentifier("undefined"))
        ], 2 /* Const */ )));
        return ret;
    }
    function transformReturnStatementWithFixablePromiseHandler(transformer, innerRetStmt, hasContinuation, continuationArgName) {
        let innerCbBody = [];
        forEachChild(innerRetStmt, function visit(node) {
            if (isCallExpression(node)) {
                const temp = transformExpression(node, node, transformer, hasContinuation, continuationArgName);
                innerCbBody = innerCbBody.concat(temp);
                if (innerCbBody.length > 0) return;
            } else if (!isFunctionLike(node)) forEachChild(node, visit);
        });
        return innerCbBody;
    }
    function getArgBindingName(funcNode, transformer) {
        const types = [];
        let name;
        if (isFunctionLikeDeclaration(funcNode)) {
            if (funcNode.parameters.length > 0) {
                const param = funcNode.parameters[0].name;
                name = getMappedBindingNameOrDefault(param);
            }
        } else if (isIdentifier(funcNode)) name = getMapEntryOrDefault(funcNode);
        else if (isPropertyAccessExpression(funcNode) && isIdentifier(funcNode.name)) name = getMapEntryOrDefault(funcNode.name);
        if (!name || "identifier" in name && name.identifier.text === "undefined") return void 0;
        return name;
        function getMappedBindingNameOrDefault(bindingName) {
            if (isIdentifier(bindingName)) return getMapEntryOrDefault(bindingName);
            const elements = flatMap(bindingName.elements, (element)=>{
                if (isOmittedExpression(element)) return [];
                return [
                    getMappedBindingNameOrDefault(element.name)
                ];
            });
            return createSynthBindingPattern(bindingName, elements);
        }
        function getMapEntryOrDefault(identifier) {
            const originalNode = getOriginalNode2(identifier);
            const symbol = getSymbol2(originalNode);
            if (!symbol) return createSynthIdentifier(identifier, types);
            const mapEntry = transformer.synthNamesMap.get(getSymbolId(symbol).toString());
            return mapEntry || createSynthIdentifier(identifier, types);
        }
        function getSymbol2(node) {
            var _a;
            return ((_a = tryCast(node, canHaveSymbol)) == null ? void 0 : _a.symbol) ?? transformer.checker.getSymbolAtLocation(node);
        }
        function getOriginalNode2(node) {
            return node.original ? node.original : node;
        }
    }
    function isEmptyBindingName(bindingName) {
        if (!bindingName) return true;
        if (isSynthIdentifier(bindingName)) return !bindingName.identifier.text;
        return every(bindingName.elements, isEmptyBindingName);
    }
    function createSynthIdentifier(identifier, types = []) {
        return {
            kind: 0 /* Identifier */ ,
            identifier: identifier,
            types: types,
            hasBeenDeclared: false,
            hasBeenReferenced: false
        };
    }
    function createSynthBindingPattern(bindingPattern, elements = emptyArray, types = []) {
        return {
            kind: 1 /* BindingPattern */ ,
            bindingPattern: bindingPattern,
            elements: elements,
            types: types
        };
    }
    function referenceSynthIdentifier(synthId) {
        synthId.hasBeenReferenced = true;
        return synthId.identifier;
    }
    function declareSynthBindingName(synthName) {
        return isSynthIdentifier(synthName) ? declareSynthIdentifier(synthName) : declareSynthBindingPattern(synthName);
    }
    function declareSynthBindingPattern(synthPattern) {
        for (const element of synthPattern.elements)declareSynthBindingName(element);
        return synthPattern.bindingPattern;
    }
    function declareSynthIdentifier(synthId) {
        synthId.hasBeenDeclared = true;
        return synthId.identifier;
    }
    function isSynthIdentifier(bindingName) {
        return bindingName.kind === 0 /* Identifier */ ;
    }
    function isSynthBindingPattern(bindingName) {
        return bindingName.kind === 1 /* BindingPattern */ ;
    }
    function shouldReturn(expression, transformer) {
        return !!expression.original && transformer.setOfExpressionsToReturn.has(getNodeId(expression.original));
    }
    var fixId10, errorCodes11, codeActionSucceeded;
    var init_convertToAsyncFunction = __esm({
        "src/services/codefixes/convertToAsyncFunction.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId10 = "convertToAsyncFunction";
            errorCodes11 = [
                Diagnostics.This_may_be_converted_to_an_async_function.code
            ];
            codeActionSucceeded = true;
            registerCodeFix({
                errorCodes: errorCodes11,
                getCodeActions (context) {
                    codeActionSucceeded = true;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>convertToAsyncFunction(t, context.sourceFile, context.span.start, context.program.getTypeChecker()));
                    return codeActionSucceeded ? [
                        createCodeFixAction(fixId10, changes, Diagnostics.Convert_to_async_function, fixId10, Diagnostics.Convert_all_to_async_functions)
                    ] : [];
                },
                fixIds: [
                    fixId10
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes11, (changes, err)=>convertToAsyncFunction(changes, err.file, err.start, context.program.getTypeChecker()))
            });
        }
    });
    // src/services/codefixes/convertToEsModule.ts
    function fixImportOfModuleExports(importingFile, exportingFile, changes, quotePreference) {
        for (const moduleSpecifier of importingFile.imports){
            const imported = getResolvedModule(importingFile, moduleSpecifier.text, getModeForUsageLocation(importingFile, moduleSpecifier));
            if (!imported || imported.resolvedFileName !== exportingFile.fileName) continue;
            const importNode = importFromModuleSpecifier(moduleSpecifier);
            switch(importNode.kind){
                case 270 /* ImportEqualsDeclaration */ :
                    changes.replaceNode(importingFile, importNode, makeImport(importNode.name, /*namedImports*/ void 0, moduleSpecifier, quotePreference));
                    break;
                case 212 /* CallExpression */ :
                    if (isRequireCall(importNode, /*requireStringLiteralLikeArgument*/ false)) changes.replaceNode(importingFile, importNode, factory.createPropertyAccessExpression(getSynthesizedDeepClone(importNode), "default"));
                    break;
            }
        }
    }
    function convertFileToEsModule(sourceFile, checker, changes, target, quotePreference) {
        const identifiers = {
            original: collectFreeIdentifiers(sourceFile),
            additional: /* @__PURE__ */ new Set()
        };
        const exports = collectExportRenames(sourceFile, checker, identifiers);
        convertExportsAccesses(sourceFile, exports, changes);
        let moduleExportsChangedToDefault = false;
        let useSitesToUnqualify;
        for (const statement of filter(sourceFile.statements, isVariableStatement)){
            const newUseSites = convertVariableStatement(sourceFile, statement, changes, checker, identifiers, target, quotePreference);
            if (newUseSites) copyEntries(newUseSites, useSitesToUnqualify ?? (useSitesToUnqualify = /* @__PURE__ */ new Map()));
        }
        for (const statement of filter(sourceFile.statements, (s)=>!isVariableStatement(s))){
            const moduleExportsChanged = convertStatement(sourceFile, statement, checker, changes, identifiers, target, exports, useSitesToUnqualify, quotePreference);
            moduleExportsChangedToDefault = moduleExportsChangedToDefault || moduleExportsChanged;
        }
        useSitesToUnqualify == null || useSitesToUnqualify.forEach((replacement, original)=>{
            changes.replaceNode(sourceFile, original, replacement);
        });
        return moduleExportsChangedToDefault;
    }
    function collectExportRenames(sourceFile, checker, identifiers) {
        const res = /* @__PURE__ */ new Map();
        forEachExportReference(sourceFile, (node)=>{
            const { text: text  } = node.name;
            if (!res.has(text) && (isIdentifierANonContextualKeyword(node.name) || checker.resolveName(text, node, 111551 /* Value */ , /*excludeGlobals*/ true))) res.set(text, makeUniqueName(`_${text}`, identifiers));
        });
        return res;
    }
    function convertExportsAccesses(sourceFile, exports, changes) {
        forEachExportReference(sourceFile, (node, isAssignmentLhs)=>{
            if (isAssignmentLhs) return;
            const { text: text  } = node.name;
            changes.replaceNode(sourceFile, node, factory.createIdentifier(exports.get(text) || text));
        });
    }
    function forEachExportReference(sourceFile, cb) {
        sourceFile.forEachChild(function recur(node) {
            if (isPropertyAccessExpression(node) && isExportsOrModuleExportsOrAlias(sourceFile, node.expression) && isIdentifier(node.name)) {
                const { parent: parent2  } = node;
                cb(node, isBinaryExpression(parent2) && parent2.left === node && parent2.operatorToken.kind === 64 /* EqualsToken */ );
            }
            node.forEachChild(recur);
        });
    }
    function convertStatement(sourceFile, statement, checker, changes, identifiers, target, exports, useSitesToUnqualify, quotePreference) {
        switch(statement.kind){
            case 242 /* VariableStatement */ :
                convertVariableStatement(sourceFile, statement, changes, checker, identifiers, target, quotePreference);
                return false;
            case 243 /* ExpressionStatement */ :
                {
                    const { expression: expression  } = statement;
                    switch(expression.kind){
                        case 212 /* CallExpression */ :
                            if (isRequireCall(expression, /*requireStringLiteralLikeArgument*/ true)) changes.replaceNode(sourceFile, statement, makeImport(/*defaultImport*/ void 0, /*namedImports*/ void 0, expression.arguments[0], quotePreference));
                            return false;
                        case 225 /* BinaryExpression */ :
                            {
                                const { operatorToken: operatorToken  } = expression;
                                return operatorToken.kind === 64 /* EqualsToken */  && convertAssignment(sourceFile, checker, expression, changes, exports, useSitesToUnqualify);
                            }
                    }
                }
            default:
                return false;
        }
    }
    function convertVariableStatement(sourceFile, statement, changes, checker, identifiers, target, quotePreference) {
        const { declarationList: declarationList  } = statement;
        let foundImport = false;
        const converted = map(declarationList.declarations, (decl)=>{
            const { name: name , initializer: initializer  } = decl;
            if (initializer) {
                if (isExportsOrModuleExportsOrAlias(sourceFile, initializer)) {
                    foundImport = true;
                    return convertedImports([]);
                } else if (isRequireCall(initializer, /*requireStringLiteralLikeArgument*/ true)) {
                    foundImport = true;
                    return convertSingleImport(name, initializer.arguments[0], checker, identifiers, target, quotePreference);
                } else if (isPropertyAccessExpression(initializer) && isRequireCall(initializer.expression, /*requireStringLiteralLikeArgument*/ true)) {
                    foundImport = true;
                    return convertPropertyAccessImport(name, initializer.name.text, initializer.expression.arguments[0], identifiers, quotePreference);
                }
            }
            return convertedImports([
                factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    decl
                ], declarationList.flags))
            ]);
        });
        if (foundImport) {
            changes.replaceNodeWithNodes(sourceFile, statement, flatMap(converted, (c)=>c.newImports));
            let combinedUseSites;
            forEach(converted, (c)=>{
                if (c.useSitesToUnqualify) copyEntries(c.useSitesToUnqualify, combinedUseSites ?? (combinedUseSites = /* @__PURE__ */ new Map()));
            });
            return combinedUseSites;
        }
    }
    function convertPropertyAccessImport(name, propertyName, moduleSpecifier, identifiers, quotePreference) {
        switch(name.kind){
            case 205 /* ObjectBindingPattern */ :
            case 206 /* ArrayBindingPattern */ :
                {
                    const tmp = makeUniqueName(propertyName, identifiers);
                    return convertedImports([
                        makeSingleImport(tmp, propertyName, moduleSpecifier, quotePreference),
                        makeConst(/*modifiers*/ void 0, name, factory.createIdentifier(tmp))
                    ]);
                }
            case 80 /* Identifier */ :
                return convertedImports([
                    makeSingleImport(name.text, propertyName, moduleSpecifier, quotePreference)
                ]);
            default:
                return Debug.assertNever(name, `Convert to ES module got invalid syntax form ${name.kind}`);
        }
    }
    function convertAssignment(sourceFile, checker, assignment, changes, exports, useSitesToUnqualify) {
        const { left: left , right: right  } = assignment;
        if (!isPropertyAccessExpression(left)) return false;
        if (isExportsOrModuleExportsOrAlias(sourceFile, left)) {
            if (isExportsOrModuleExportsOrAlias(sourceFile, right)) changes.delete(sourceFile, assignment.parent);
            else {
                const replacement = isObjectLiteralExpression(right) ? tryChangeModuleExportsObject(right, useSitesToUnqualify) : isRequireCall(right, /*requireStringLiteralLikeArgument*/ true) ? convertReExportAll(right.arguments[0], checker) : void 0;
                if (replacement) {
                    changes.replaceNodeWithNodes(sourceFile, assignment.parent, replacement[0]);
                    return replacement[1];
                } else {
                    changes.replaceRangeWithText(sourceFile, createRange(left.getStart(sourceFile), right.pos), "export default");
                    return true;
                }
            }
        } else if (isExportsOrModuleExportsOrAlias(sourceFile, left.expression)) convertNamedExport(sourceFile, assignment, changes, exports);
        return false;
    }
    function tryChangeModuleExportsObject(object, useSitesToUnqualify) {
        const statements = mapAllOrFail(object.properties, (prop)=>{
            switch(prop.kind){
                case 176 /* GetAccessor */ :
                case 177 /* SetAccessor */ :
                case 303 /* ShorthandPropertyAssignment */ :
                case 304 /* SpreadAssignment */ :
                    return void 0;
                case 302 /* PropertyAssignment */ :
                    return !isIdentifier(prop.name) ? void 0 : convertExportsDotXEquals_replaceNode(prop.name.text, prop.initializer, useSitesToUnqualify);
                case 173 /* MethodDeclaration */ :
                    return !isIdentifier(prop.name) ? void 0 : functionExpressionToDeclaration(prop.name.text, [
                        factory.createToken(95 /* ExportKeyword */ )
                    ], prop, useSitesToUnqualify);
                default:
                    Debug.assertNever(prop, `Convert to ES6 got invalid prop kind ${prop.kind}`);
            }
        });
        return statements && [
            statements,
            false
        ];
    }
    function convertNamedExport(sourceFile, assignment, changes, exports) {
        const { text: text  } = assignment.left.name;
        const rename = exports.get(text);
        if (rename !== void 0) {
            const newNodes = [
                makeConst(/*modifiers*/ void 0, rename, assignment.right),
                makeExportDeclaration([
                    factory.createExportSpecifier(/*isTypeOnly*/ false, rename, text)
                ])
            ];
            changes.replaceNodeWithNodes(sourceFile, assignment.parent, newNodes);
        } else convertExportsPropertyAssignment(assignment, sourceFile, changes);
    }
    function convertReExportAll(reExported, checker) {
        const moduleSpecifier = reExported.text;
        const moduleSymbol = checker.getSymbolAtLocation(reExported);
        const exports = moduleSymbol ? moduleSymbol.exports : emptyMap;
        return exports.has("export=" /* ExportEquals */ ) ? [
            [
                reExportDefault(moduleSpecifier)
            ],
            true
        ] : !exports.has("default" /* Default */ ) ? [
            [
                reExportStar(moduleSpecifier)
            ],
            false
        ] : // If there's some non-default export, must include both `export *` and `export default`.
        exports.size > 1 ? [
            [
                reExportStar(moduleSpecifier),
                reExportDefault(moduleSpecifier)
            ],
            true
        ] : [
            [
                reExportDefault(moduleSpecifier)
            ],
            true
        ];
    }
    function reExportStar(moduleSpecifier) {
        return makeExportDeclaration(/*exportSpecifiers*/ void 0, moduleSpecifier);
    }
    function reExportDefault(moduleSpecifier) {
        return makeExportDeclaration([
            factory.createExportSpecifier(/*isTypeOnly*/ false, /*propertyName*/ void 0, "default")
        ], moduleSpecifier);
    }
    function convertExportsPropertyAssignment({ left: left , right: right , parent: parent2  }, sourceFile, changes) {
        const name = left.name.text;
        if ((isFunctionExpression(right) || isArrowFunction(right) || isClassExpression(right)) && (!right.name || right.name.text === name)) {
            changes.replaceRange(sourceFile, {
                pos: left.getStart(sourceFile),
                end: right.getStart(sourceFile)
            }, factory.createToken(95 /* ExportKeyword */ ), {
                suffix: " "
            });
            if (!right.name) changes.insertName(sourceFile, right, name);
            const semi = findChildOfKind(parent2, 27 /* SemicolonToken */ , sourceFile);
            if (semi) changes.delete(sourceFile, semi);
        } else changes.replaceNodeRangeWithNodes(sourceFile, left.expression, findChildOfKind(left, 25 /* DotToken */ , sourceFile), [
            factory.createToken(95 /* ExportKeyword */ ),
            factory.createToken(87 /* ConstKeyword */ )
        ], {
            joiner: " ",
            suffix: " "
        });
    }
    function convertExportsDotXEquals_replaceNode(name, exported, useSitesToUnqualify) {
        const modifiers = [
            factory.createToken(95 /* ExportKeyword */ )
        ];
        switch(exported.kind){
            case 217 /* FunctionExpression */ :
                {
                    const { name: expressionName  } = exported;
                    if (expressionName && expressionName.text !== name) return exportConst();
                }
            case 218 /* ArrowFunction */ :
                return functionExpressionToDeclaration(name, modifiers, exported, useSitesToUnqualify);
            case 230 /* ClassExpression */ :
                return classExpressionToDeclaration(name, modifiers, exported, useSitesToUnqualify);
            default:
                return exportConst();
        }
        function exportConst() {
            return makeConst(modifiers, factory.createIdentifier(name), replaceImportUseSites(exported, useSitesToUnqualify));
        }
    }
    function replaceImportUseSites(nodeOrNodes, useSitesToUnqualify) {
        if (!useSitesToUnqualify || !some(arrayFrom(useSitesToUnqualify.keys()), (original)=>rangeContainsRange(nodeOrNodes, original))) return nodeOrNodes;
        return isArray(nodeOrNodes) ? getSynthesizedDeepClonesWithReplacements(nodeOrNodes, /*includeTrivia*/ true, replaceNode) : getSynthesizedDeepCloneWithReplacements(nodeOrNodes, /*includeTrivia*/ true, replaceNode);
        function replaceNode(original) {
            if (original.kind === 210 /* PropertyAccessExpression */ ) {
                const replacement = useSitesToUnqualify.get(original);
                useSitesToUnqualify.delete(original);
                return replacement;
            }
        }
    }
    function convertSingleImport(name, moduleSpecifier, checker, identifiers, target, quotePreference) {
        switch(name.kind){
            case 205 /* ObjectBindingPattern */ :
                {
                    const importSpecifiers = mapAllOrFail(name.elements, (e)=>e.dotDotDotToken || e.initializer || e.propertyName && !isIdentifier(e.propertyName) || !isIdentifier(e.name) ? void 0 : makeImportSpecifier2(e.propertyName && e.propertyName.text, e.name.text));
                    if (importSpecifiers) return convertedImports([
                        makeImport(/*defaultImport*/ void 0, importSpecifiers, moduleSpecifier, quotePreference)
                    ]);
                }
            case 206 /* ArrayBindingPattern */ :
                {
                    const tmp = makeUniqueName(moduleSpecifierToValidIdentifier(moduleSpecifier.text, target), identifiers);
                    return convertedImports([
                        makeImport(factory.createIdentifier(tmp), /*namedImports*/ void 0, moduleSpecifier, quotePreference),
                        makeConst(/*modifiers*/ void 0, getSynthesizedDeepClone(name), factory.createIdentifier(tmp))
                    ]);
                }
            case 80 /* Identifier */ :
                return convertSingleIdentifierImport(name, moduleSpecifier, checker, identifiers, quotePreference);
            default:
                return Debug.assertNever(name, `Convert to ES module got invalid name kind ${name.kind}`);
        }
    }
    function convertSingleIdentifierImport(name, moduleSpecifier, checker, identifiers, quotePreference) {
        const nameSymbol = checker.getSymbolAtLocation(name);
        const namedBindingsNames = /* @__PURE__ */ new Map();
        let needDefaultImport = false;
        let useSitesToUnqualify;
        for (const use of identifiers.original.get(name.text)){
            if (checker.getSymbolAtLocation(use) !== nameSymbol || use === name) continue;
            const { parent: parent2  } = use;
            if (isPropertyAccessExpression(parent2)) {
                const { name: { text: propertyName  }  } = parent2;
                if (propertyName === "default") {
                    needDefaultImport = true;
                    const importDefaultName = use.getText();
                    (useSitesToUnqualify ?? (useSitesToUnqualify = /* @__PURE__ */ new Map())).set(parent2, factory.createIdentifier(importDefaultName));
                } else {
                    Debug.assert(parent2.expression === use, "Didn't expect expression === use");
                    let idName = namedBindingsNames.get(propertyName);
                    if (idName === void 0) {
                        idName = makeUniqueName(propertyName, identifiers);
                        namedBindingsNames.set(propertyName, idName);
                    }
                    (useSitesToUnqualify ?? (useSitesToUnqualify = /* @__PURE__ */ new Map())).set(parent2, factory.createIdentifier(idName));
                }
            } else needDefaultImport = true;
        }
        const namedBindings = namedBindingsNames.size === 0 ? void 0 : arrayFrom(mapIterator(namedBindingsNames.entries(), ([propertyName, idName])=>factory.createImportSpecifier(/*isTypeOnly*/ false, propertyName === idName ? void 0 : factory.createIdentifier(propertyName), factory.createIdentifier(idName))));
        if (!namedBindings) needDefaultImport = true;
        return convertedImports([
            makeImport(needDefaultImport ? getSynthesizedDeepClone(name) : void 0, namedBindings, moduleSpecifier, quotePreference)
        ], useSitesToUnqualify);
    }
    function makeUniqueName(name, identifiers) {
        while(identifiers.original.has(name) || identifiers.additional.has(name))name = `_${name}`;
        identifiers.additional.add(name);
        return name;
    }
    function collectFreeIdentifiers(file) {
        const map2 = createMultiMap();
        forEachFreeIdentifier(file, (id)=>map2.add(id.text, id));
        return map2;
    }
    function forEachFreeIdentifier(node, cb) {
        if (isIdentifier(node) && isFreeIdentifier(node)) cb(node);
        node.forEachChild((child)=>forEachFreeIdentifier(child, cb));
    }
    function isFreeIdentifier(node) {
        const { parent: parent2  } = node;
        switch(parent2.kind){
            case 210 /* PropertyAccessExpression */ :
                return parent2.name !== node;
            case 207 /* BindingElement */ :
                return parent2.propertyName !== node;
            case 275 /* ImportSpecifier */ :
                return parent2.propertyName !== node;
            default:
                return true;
        }
    }
    function functionExpressionToDeclaration(name, additionalModifiers, fn, useSitesToUnqualify) {
        return factory.createFunctionDeclaration(concatenate(additionalModifiers, getSynthesizedDeepClones(fn.modifiers)), getSynthesizedDeepClone(fn.asteriskToken), name, getSynthesizedDeepClones(fn.typeParameters), getSynthesizedDeepClones(fn.parameters), getSynthesizedDeepClone(fn.type), factory.converters.convertToFunctionBlock(replaceImportUseSites(fn.body, useSitesToUnqualify)));
    }
    function classExpressionToDeclaration(name, additionalModifiers, cls, useSitesToUnqualify) {
        return factory.createClassDeclaration(concatenate(additionalModifiers, getSynthesizedDeepClones(cls.modifiers)), name, getSynthesizedDeepClones(cls.typeParameters), getSynthesizedDeepClones(cls.heritageClauses), replaceImportUseSites(cls.members, useSitesToUnqualify));
    }
    function makeSingleImport(localName, propertyName, moduleSpecifier, quotePreference) {
        return propertyName === "default" ? makeImport(factory.createIdentifier(localName), /*namedImports*/ void 0, moduleSpecifier, quotePreference) : makeImport(/*defaultImport*/ void 0, [
            makeImportSpecifier2(propertyName, localName)
        ], moduleSpecifier, quotePreference);
    }
    function makeImportSpecifier2(propertyName, name) {
        return factory.createImportSpecifier(/*isTypeOnly*/ false, propertyName !== void 0 && propertyName !== name ? factory.createIdentifier(propertyName) : void 0, factory.createIdentifier(name));
    }
    function makeConst(modifiers, name, init) {
        return factory.createVariableStatement(modifiers, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(name, /*exclamationToken*/ void 0, /*type*/ void 0, init)
        ], 2 /* Const */ ));
    }
    function makeExportDeclaration(exportSpecifiers, moduleSpecifier) {
        return factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, exportSpecifiers && factory.createNamedExports(exportSpecifiers), moduleSpecifier === void 0 ? void 0 : factory.createStringLiteral(moduleSpecifier));
    }
    function convertedImports(newImports, useSitesToUnqualify) {
        return {
            newImports: newImports,
            useSitesToUnqualify: useSitesToUnqualify
        };
    }
    var init_convertToEsModule = __esm({
        "src/services/codefixes/convertToEsModule.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            registerCodeFix({
                errorCodes: [
                    Diagnostics.File_is_a_CommonJS_module_it_may_be_converted_to_an_ES_module.code
                ],
                getCodeActions (context) {
                    const { sourceFile: sourceFile , program: program , preferences: preferences  } = context;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (changes2)=>{
                        const moduleExportsChangedToDefault = convertFileToEsModule(sourceFile, program.getTypeChecker(), changes2, getEmitScriptTarget(program.getCompilerOptions()), getQuotePreference(sourceFile, preferences));
                        if (moduleExportsChangedToDefault) for (const importingFile of program.getSourceFiles())fixImportOfModuleExports(importingFile, sourceFile, changes2, getQuotePreference(importingFile, preferences));
                    });
                    return [
                        createCodeFixActionWithoutFixAll("convertToEsModule", changes, Diagnostics.Convert_to_ES_module)
                    ];
                }
            });
        }
    });
    // src/services/codefixes/correctQualifiedNameToIndexedAccessType.ts
    function getQualifiedName(sourceFile, pos) {
        const qualifiedName = findAncestor(getTokenAtPosition(sourceFile, pos), isQualifiedName);
        Debug.assert(!!qualifiedName, "Expected position to be owned by a qualified name.");
        return isIdentifier(qualifiedName.left) ? qualifiedName : void 0;
    }
    function doChange10(changeTracker, sourceFile, qualifiedName) {
        const rightText = qualifiedName.right.text;
        const replacement = factory.createIndexedAccessTypeNode(factory.createTypeReferenceNode(qualifiedName.left, /*typeArguments*/ void 0), factory.createLiteralTypeNode(factory.createStringLiteral(rightText)));
        changeTracker.replaceNode(sourceFile, qualifiedName, replacement);
    }
    var fixId11, errorCodes12;
    var init_correctQualifiedNameToIndexedAccessType = __esm({
        "src/services/codefixes/correctQualifiedNameToIndexedAccessType.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId11 = "correctQualifiedNameToIndexedAccessType";
            errorCodes12 = [
                Diagnostics.Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1.code
            ];
            registerCodeFix({
                errorCodes: errorCodes12,
                getCodeActions (context) {
                    const qualifiedName = getQualifiedName(context.sourceFile, context.span.start);
                    if (!qualifiedName) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange10(t, context.sourceFile, qualifiedName));
                    const newText = `${qualifiedName.left.text}["${qualifiedName.right.text}"]`;
                    return [
                        createCodeFixAction(fixId11, changes, [
                            Diagnostics.Rewrite_as_the_indexed_access_type_0,
                            newText
                        ], fixId11, Diagnostics.Rewrite_all_as_indexed_access_types)
                    ];
                },
                fixIds: [
                    fixId11
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes12, (changes, diag2)=>{
                        const q = getQualifiedName(diag2.file, diag2.start);
                        if (q) doChange10(changes, diag2.file, q);
                    })
            });
        }
    });
    // src/services/codefixes/convertToTypeOnlyExport.ts
    function getExportSpecifierForDiagnosticSpan(span, sourceFile) {
        return tryCast(getTokenAtPosition(sourceFile, span.start).parent, isExportSpecifier);
    }
    function fixSingleExportDeclaration(changes, exportSpecifier, context) {
        if (!exportSpecifier) return;
        const exportClause = exportSpecifier.parent;
        const exportDeclaration = exportClause.parent;
        const typeExportSpecifiers = getTypeExportSpecifiers(exportSpecifier, context);
        if (typeExportSpecifiers.length === exportClause.elements.length) changes.insertModifierBefore(context.sourceFile, 156 /* TypeKeyword */ , exportClause);
        else {
            const valueExportDeclaration = factory.updateExportDeclaration(exportDeclaration, exportDeclaration.modifiers, /*isTypeOnly*/ false, factory.updateNamedExports(exportClause, filter(exportClause.elements, (e)=>!contains(typeExportSpecifiers, e))), exportDeclaration.moduleSpecifier, /*assertClause*/ void 0);
            const typeExportDeclaration = factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ true, factory.createNamedExports(typeExportSpecifiers), exportDeclaration.moduleSpecifier, /*assertClause*/ void 0);
            changes.replaceNode(context.sourceFile, exportDeclaration, valueExportDeclaration, {
                leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.IncludeAll,
                trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Exclude
            });
            changes.insertNodeAfter(context.sourceFile, exportDeclaration, typeExportDeclaration);
        }
    }
    function getTypeExportSpecifiers(originExportSpecifier, context) {
        const exportClause = originExportSpecifier.parent;
        if (exportClause.elements.length === 1) return exportClause.elements;
        const diagnostics = getDiagnosticsWithinSpan(createTextSpanFromNode(exportClause), context.program.getSemanticDiagnostics(context.sourceFile, context.cancellationToken));
        return filter(exportClause.elements, (element)=>{
            var _a;
            return element === originExportSpecifier || ((_a = findDiagnosticForNode(element, diagnostics)) == null ? void 0 : _a.code) === errorCodes13[0];
        });
    }
    var errorCodes13, fixId12;
    var init_convertToTypeOnlyExport = __esm({
        "src/services/codefixes/convertToTypeOnlyExport.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            errorCodes13 = [
                Diagnostics.Re_exporting_a_type_when_0_is_enabled_requires_using_export_type.code
            ];
            fixId12 = "convertToTypeOnlyExport";
            registerCodeFix({
                errorCodes: errorCodes13,
                getCodeActions: function getCodeActionsToConvertToTypeOnlyExport(context) {
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>fixSingleExportDeclaration(t, getExportSpecifierForDiagnosticSpan(context.span, context.sourceFile), context));
                    if (changes.length) return [
                        createCodeFixAction(fixId12, changes, Diagnostics.Convert_to_type_only_export, fixId12, Diagnostics.Convert_all_re_exported_types_to_type_only_exports)
                    ];
                },
                fixIds: [
                    fixId12
                ],
                getAllCodeActions: function getAllCodeActionsToConvertToTypeOnlyExport(context) {
                    const fixedExportDeclarations = /* @__PURE__ */ new Map();
                    return codeFixAll(context, errorCodes13, (changes, diag2)=>{
                        const exportSpecifier = getExportSpecifierForDiagnosticSpan(diag2, context.sourceFile);
                        if (exportSpecifier && addToSeen(fixedExportDeclarations, getNodeId(exportSpecifier.parent.parent))) fixSingleExportDeclaration(changes, exportSpecifier, context);
                    });
                }
            });
        }
    });
    // src/services/codefixes/convertToTypeOnlyImport.ts
    function getDeclaration2(sourceFile, pos) {
        const { parent: parent2  } = getTokenAtPosition(sourceFile, pos);
        return isImportSpecifier(parent2) || isImportDeclaration(parent2) && parent2.importClause ? parent2 : void 0;
    }
    function doChange11(changes, sourceFile, declaration) {
        if (isImportSpecifier(declaration)) changes.replaceNode(sourceFile, declaration, factory.updateImportSpecifier(declaration, /*isTypeOnly*/ true, declaration.propertyName, declaration.name));
        else {
            const importClause = declaration.importClause;
            if (importClause.name && importClause.namedBindings) changes.replaceNodeWithNodes(sourceFile, declaration, [
                factory.createImportDeclaration(getSynthesizedDeepClones(declaration.modifiers, /*includeTrivia*/ true), factory.createImportClause(/*isTypeOnly*/ true, getSynthesizedDeepClone(importClause.name, /*includeTrivia*/ true), /*namedBindings*/ void 0), getSynthesizedDeepClone(declaration.moduleSpecifier, /*includeTrivia*/ true), getSynthesizedDeepClone(declaration.assertClause, /*includeTrivia*/ true)),
                factory.createImportDeclaration(getSynthesizedDeepClones(declaration.modifiers, /*includeTrivia*/ true), factory.createImportClause(/*isTypeOnly*/ true, /*name*/ void 0, getSynthesizedDeepClone(importClause.namedBindings, /*includeTrivia*/ true)), getSynthesizedDeepClone(declaration.moduleSpecifier, /*includeTrivia*/ true), getSynthesizedDeepClone(declaration.assertClause, /*includeTrivia*/ true))
            ]);
            else {
                const importDeclaration = factory.updateImportDeclaration(declaration, declaration.modifiers, factory.updateImportClause(importClause, /*isTypeOnly*/ true, importClause.name, importClause.namedBindings), declaration.moduleSpecifier, declaration.assertClause);
                changes.replaceNode(sourceFile, declaration, importDeclaration);
            }
        }
    }
    var errorCodes14, fixId13;
    var init_convertToTypeOnlyImport = __esm({
        "src/services/codefixes/convertToTypeOnlyImport.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            errorCodes14 = [
                Diagnostics.This_import_is_never_used_as_a_value_and_must_use_import_type_because_importsNotUsedAsValues_is_set_to_error.code,
                Diagnostics._0_is_a_type_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled.code
            ];
            fixId13 = "convertToTypeOnlyImport";
            registerCodeFix({
                errorCodes: errorCodes14,
                getCodeActions: function getCodeActionsToConvertToTypeOnlyImport(context) {
                    const declaration = getDeclaration2(context.sourceFile, context.span.start);
                    if (declaration) {
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange11(t, context.sourceFile, declaration));
                        return [
                            createCodeFixAction(fixId13, changes, Diagnostics.Convert_to_type_only_import, fixId13, Diagnostics.Convert_all_imports_not_used_as_a_value_to_type_only_imports)
                        ];
                    }
                    return void 0;
                },
                fixIds: [
                    fixId13
                ],
                getAllCodeActions: function getAllCodeActionsToConvertToTypeOnlyImport(context) {
                    return codeFixAll(context, errorCodes14, (changes, diag2)=>{
                        const declaration = getDeclaration2(diag2.file, diag2.start);
                        if (declaration) doChange11(changes, diag2.file, declaration);
                    });
                }
            });
        }
    });
    // src/services/codefixes/convertTypedefToType.ts
    function doChange12(changes, node, sourceFile) {
        if (isJSDocTypedefTag(node)) fixSingleTypeDef(changes, node, sourceFile);
    }
    function fixSingleTypeDef(changes, typeDefNode, sourceFile) {
        if (!typeDefNode) return;
        const declaration = createDeclaration(typeDefNode);
        if (!declaration) return;
        const comment = typeDefNode.parent;
        changes.replaceNode(sourceFile, comment, declaration);
    }
    function createDeclaration(tag) {
        var _a;
        const { typeExpression: typeExpression  } = tag;
        if (!typeExpression) return;
        const typeName = (_a = tag.name) == null ? void 0 : _a.getText();
        if (!typeName) return;
        if (typeExpression.kind === 328 /* JSDocTypeLiteral */ ) return createInterfaceForTypeLiteral(typeName, typeExpression);
        if (typeExpression.kind === 315 /* JSDocTypeExpression */ ) return createTypeAliasForTypeExpression(typeName, typeExpression);
    }
    function createInterfaceForTypeLiteral(typeName, typeLiteral) {
        const propertySignatures = createSignatureFromTypeLiteral(typeLiteral);
        if (!some(propertySignatures)) return;
        const interfaceDeclaration = factory.createInterfaceDeclaration(/*modifiers*/ void 0, typeName, /*typeParameters*/ void 0, /*heritageClauses*/ void 0, propertySignatures);
        return interfaceDeclaration;
    }
    function createTypeAliasForTypeExpression(typeName, typeExpression) {
        const typeReference = getSynthesizedDeepClone(typeExpression.type);
        if (!typeReference) return;
        const declaration = factory.createTypeAliasDeclaration(/*modifiers*/ void 0, factory.createIdentifier(typeName), /*typeParameters*/ void 0, typeReference);
        return declaration;
    }
    function createSignatureFromTypeLiteral(typeLiteral) {
        const propertyTags = typeLiteral.jsDocPropertyTags;
        if (!some(propertyTags)) return;
        const getSignature = (tag)=>{
            var _a;
            const name = getPropertyName(tag);
            const type = (_a = tag.typeExpression) == null ? void 0 : _a.type;
            const isOptional = tag.isBracketed;
            let typeReference;
            if (type && isJSDocTypeLiteral(type)) {
                const signatures = createSignatureFromTypeLiteral(type);
                typeReference = factory.createTypeLiteralNode(signatures);
            } else if (type) typeReference = getSynthesizedDeepClone(type);
            if (typeReference && name) {
                const questionToken = isOptional ? factory.createToken(58 /* QuestionToken */ ) : void 0;
                const prop = factory.createPropertySignature(/*modifiers*/ void 0, name, questionToken, typeReference);
                return prop;
            }
        };
        const props = mapDefined(propertyTags, getSignature);
        return props;
    }
    function getPropertyName(tag) {
        return tag.name.kind === 80 /* Identifier */  ? tag.name.text : tag.name.right.text;
    }
    function getJSDocTypedefNode(node) {
        if (hasJSDocNodes(node)) return forEach(node.jsDoc, (node2)=>{
            var _a;
            return (_a = node2.tags) == null ? void 0 : _a.find(isJSDocTypedefTag);
        });
        return void 0;
    }
    var fixId14, errorCodes15;
    var init_convertTypedefToType = __esm({
        "src/services/codefixes/convertTypedefToType.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId14 = "convertTypedefToType";
            errorCodes15 = [
                Diagnostics.JSDoc_typedef_may_be_converted_to_TypeScript_type.code
            ];
            registerCodeFix({
                fixIds: [
                    fixId14
                ],
                errorCodes: errorCodes15,
                getCodeActions (context) {
                    const node = getTokenAtPosition(context.sourceFile, context.span.start);
                    if (!node) return;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange12(t, node, context.sourceFile));
                    if (changes.length > 0) return [
                        createCodeFixAction(fixId14, changes, Diagnostics.Convert_typedef_to_TypeScript_type, fixId14, Diagnostics.Convert_all_typedef_to_TypeScript_types)
                    ];
                },
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes15, (changes, diag2)=>{
                        const node = getTokenAtPosition(diag2.file, diag2.start);
                        if (node) doChange12(changes, node, diag2.file);
                    })
            });
        }
    });
    // src/services/codefixes/convertLiteralTypeToMappedType.ts
    function getInfo5(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (isIdentifier(token)) {
            const propertySignature = cast(token.parent.parent, isPropertySignature);
            const propertyName = token.getText(sourceFile);
            return {
                container: cast(propertySignature.parent, isTypeLiteralNode),
                typeNode: propertySignature.type,
                constraint: propertyName,
                name: propertyName === "K" ? "P" : "K"
            };
        }
        return void 0;
    }
    function doChange13(changes, sourceFile, { container: container , typeNode: typeNode , constraint: constraint , name: name  }) {
        changes.replaceNode(sourceFile, container, factory.createMappedTypeNode(/*readonlyToken*/ void 0, factory.createTypeParameterDeclaration(/*modifiers*/ void 0, name, factory.createTypeReferenceNode(constraint)), /*nameType*/ void 0, /*questionToken*/ void 0, typeNode, /*members*/ void 0));
    }
    var fixId15, errorCodes16;
    var init_convertLiteralTypeToMappedType = __esm({
        "src/services/codefixes/convertLiteralTypeToMappedType.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId15 = "convertLiteralTypeToMappedType";
            errorCodes16 = [
                Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Did_you_mean_to_use_1_in_0.code
            ];
            registerCodeFix({
                errorCodes: errorCodes16,
                getCodeActions: function getCodeActionsToConvertLiteralTypeToMappedType(context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const info = getInfo5(sourceFile, span.start);
                    if (!info) return void 0;
                    const { name: name , constraint: constraint  } = info;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange13(t, sourceFile, info));
                    return [
                        createCodeFixAction(fixId15, changes, [
                            Diagnostics.Convert_0_to_1_in_0,
                            constraint,
                            name
                        ], fixId15, Diagnostics.Convert_all_type_literals_to_mapped_type)
                    ];
                },
                fixIds: [
                    fixId15
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes16, (changes, diag2)=>{
                        const info = getInfo5(diag2.file, diag2.start);
                        if (info) doChange13(changes, diag2.file, info);
                    })
            });
        }
    });
    // src/services/codefixes/fixClassIncorrectlyImplementsInterface.ts
    function getClass(sourceFile, pos) {
        return Debug.checkDefined(getContainingClass(getTokenAtPosition(sourceFile, pos)), "There should be a containing class");
    }
    function symbolPointsToNonPrivateMember(symbol) {
        return !symbol.valueDeclaration || !(getEffectiveModifierFlags(symbol.valueDeclaration) & 8 /* Private */ );
    }
    function addMissingDeclarations(context, implementedTypeNode, sourceFile, classDeclaration, changeTracker, preferences) {
        const checker = context.program.getTypeChecker();
        const maybeHeritageClauseSymbol = getHeritageClauseSymbolTable(classDeclaration, checker);
        const implementedType = checker.getTypeAtLocation(implementedTypeNode);
        const implementedTypeSymbols = checker.getPropertiesOfType(implementedType);
        const nonPrivateAndNotExistedInHeritageClauseMembers = implementedTypeSymbols.filter(and(symbolPointsToNonPrivateMember, (symbol)=>!maybeHeritageClauseSymbol.has(symbol.escapedName)));
        const classType = checker.getTypeAtLocation(classDeclaration);
        const constructor = find(classDeclaration.members, (m)=>isConstructorDeclaration(m));
        if (!classType.getNumberIndexType()) createMissingIndexSignatureDeclaration(implementedType, 1 /* Number */ );
        if (!classType.getStringIndexType()) createMissingIndexSignatureDeclaration(implementedType, 0 /* String */ );
        const importAdder = createImportAdder(sourceFile, context.program, preferences, context.host);
        createMissingMemberNodes(classDeclaration, nonPrivateAndNotExistedInHeritageClauseMembers, sourceFile, context, preferences, importAdder, (member)=>insertInterfaceMemberNode(sourceFile, classDeclaration, member));
        importAdder.writeFixes(changeTracker);
        function createMissingIndexSignatureDeclaration(type, kind) {
            const indexInfoOfKind = checker.getIndexInfoOfType(type, kind);
            if (indexInfoOfKind) insertInterfaceMemberNode(sourceFile, classDeclaration, checker.indexInfoToIndexSignatureDeclaration(indexInfoOfKind, classDeclaration, /*flags*/ void 0, getNoopSymbolTrackerWithResolver(context)));
        }
        function insertInterfaceMemberNode(sourceFile2, cls, newElement) {
            if (constructor) changeTracker.insertNodeAfter(sourceFile2, constructor, newElement);
            else changeTracker.insertMemberAtStart(sourceFile2, cls, newElement);
        }
    }
    function getHeritageClauseSymbolTable(classDeclaration, checker) {
        const heritageClauseNode = getEffectiveBaseTypeNode(classDeclaration);
        if (!heritageClauseNode) return createSymbolTable();
        const heritageClauseType = checker.getTypeAtLocation(heritageClauseNode);
        const heritageClauseTypeSymbols = checker.getPropertiesOfType(heritageClauseType);
        return createSymbolTable(heritageClauseTypeSymbols.filter(symbolPointsToNonPrivateMember));
    }
    var errorCodes17, fixId16;
    var init_fixClassIncorrectlyImplementsInterface = __esm({
        "src/services/codefixes/fixClassIncorrectlyImplementsInterface.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            errorCodes17 = [
                Diagnostics.Class_0_incorrectly_implements_interface_1.code,
                Diagnostics.Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass.code
            ];
            fixId16 = "fixClassIncorrectlyImplementsInterface";
            registerCodeFix({
                errorCodes: errorCodes17,
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const classDeclaration = getClass(sourceFile, span.start);
                    return mapDefined(getEffectiveImplementsTypeNodes(classDeclaration), (implementedTypeNode)=>{
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMissingDeclarations(context, implementedTypeNode, sourceFile, classDeclaration, t, context.preferences));
                        return changes.length === 0 ? void 0 : createCodeFixAction(fixId16, changes, [
                            Diagnostics.Implement_interface_0,
                            implementedTypeNode.getText(sourceFile)
                        ], fixId16, Diagnostics.Implement_all_unimplemented_interfaces);
                    });
                },
                fixIds: [
                    fixId16
                ],
                getAllCodeActions (context) {
                    const seenClassDeclarations = /* @__PURE__ */ new Map();
                    return codeFixAll(context, errorCodes17, (changes, diag2)=>{
                        const classDeclaration = getClass(diag2.file, diag2.start);
                        if (addToSeen(seenClassDeclarations, getNodeId(classDeclaration))) for (const implementedTypeNode of getEffectiveImplementsTypeNodes(classDeclaration))addMissingDeclarations(context, implementedTypeNode, diag2.file, classDeclaration, changes, context.preferences);
                    });
                }
            });
        }
    });
    // src/services/codefixes/importFixes.ts
    function createImportAdder(sourceFile, program, preferences, host, cancellationToken) {
        return createImportAdderWorker(sourceFile, program, /*useAutoImportProvider*/ false, preferences, host, cancellationToken);
    }
    function createImportAdderWorker(sourceFile, program, useAutoImportProvider, preferences, host, cancellationToken) {
        const compilerOptions = program.getCompilerOptions();
        const addToNamespace = [];
        const importType = [];
        const addToExisting = /* @__PURE__ */ new Map();
        const newImports = /* @__PURE__ */ new Map();
        return {
            addImportFromDiagnostic: addImportFromDiagnostic,
            addImportFromExportedSymbol: addImportFromExportedSymbol,
            writeFixes: writeFixes,
            hasFixes: hasFixes
        };
        function addImportFromDiagnostic(diagnostic, context) {
            const info = getFixInfos(context, diagnostic.code, diagnostic.start, useAutoImportProvider);
            if (!info || !info.length) return;
            addImport(first(info));
        }
        function addImportFromExportedSymbol(exportedSymbol, isValidTypeOnlyUseSite) {
            const moduleSymbol = Debug.checkDefined(exportedSymbol.parent);
            const symbolName2 = getNameForExportedSymbol(exportedSymbol, getEmitScriptTarget(compilerOptions));
            const checker = program.getTypeChecker();
            const symbol = checker.getMergedSymbol(skipAlias(exportedSymbol, checker));
            const exportInfo = getAllExportInfoForSymbol(sourceFile, symbol, symbolName2, moduleSymbol, /*preferCapitalized*/ false, program, host, preferences, cancellationToken);
            const useRequire = shouldUseRequire(sourceFile, program);
            const fix = getImportFixForSymbol(sourceFile, Debug.checkDefined(exportInfo), program, /*position*/ void 0, !!isValidTypeOnlyUseSite, useRequire, host, preferences);
            if (fix) addImport({
                fix: fix,
                symbolName: symbolName2,
                errorIdentifierText: void 0
            });
        }
        function addImport(info) {
            var _a, _b;
            const { fix: fix , symbolName: symbolName2  } = info;
            switch(fix.kind){
                case 0 /* UseNamespace */ :
                    addToNamespace.push(fix);
                    break;
                case 1 /* JsdocTypeImport */ :
                    importType.push(fix);
                    break;
                case 2 /* AddToExisting */ :
                    {
                        const { importClauseOrBindingPattern: importClauseOrBindingPattern , importKind: importKind , addAsTypeOnly: addAsTypeOnly  } = fix;
                        const key = String(getNodeId(importClauseOrBindingPattern));
                        let entry = addToExisting.get(key);
                        if (!entry) addToExisting.set(key, entry = {
                            importClauseOrBindingPattern: importClauseOrBindingPattern,
                            defaultImport: void 0,
                            namedImports: /* @__PURE__ */ new Map()
                        });
                        if (importKind === 0 /* Named */ ) {
                            const prevValue = entry == null ? void 0 : entry.namedImports.get(symbolName2);
                            entry.namedImports.set(symbolName2, reduceAddAsTypeOnlyValues(prevValue, addAsTypeOnly));
                        } else {
                            Debug.assert(entry.defaultImport === void 0 || entry.defaultImport.name === symbolName2, "(Add to Existing) Default import should be missing or match symbolName");
                            entry.defaultImport = {
                                name: symbolName2,
                                addAsTypeOnly: reduceAddAsTypeOnlyValues((_a = entry.defaultImport) == null ? void 0 : _a.addAsTypeOnly, addAsTypeOnly)
                            };
                        }
                        break;
                    }
                case 3 /* AddNew */ :
                    {
                        const { moduleSpecifier: moduleSpecifier , importKind: importKind , useRequire: useRequire , addAsTypeOnly: addAsTypeOnly  } = fix;
                        const entry = getNewImportEntry(moduleSpecifier, importKind, useRequire, addAsTypeOnly);
                        Debug.assert(entry.useRequire === useRequire, "(Add new) Tried to add an `import` and a `require` for the same module");
                        switch(importKind){
                            case 1 /* Default */ :
                                Debug.assert(entry.defaultImport === void 0 || entry.defaultImport.name === symbolName2, "(Add new) Default import should be missing or match symbolName");
                                entry.defaultImport = {
                                    name: symbolName2,
                                    addAsTypeOnly: reduceAddAsTypeOnlyValues((_b = entry.defaultImport) == null ? void 0 : _b.addAsTypeOnly, addAsTypeOnly)
                                };
                                break;
                            case 0 /* Named */ :
                                const prevValue = (entry.namedImports || (entry.namedImports = /* @__PURE__ */ new Map())).get(symbolName2);
                                entry.namedImports.set(symbolName2, reduceAddAsTypeOnlyValues(prevValue, addAsTypeOnly));
                                break;
                            case 3 /* CommonJS */ :
                            case 2 /* Namespace */ :
                                Debug.assert(entry.namespaceLikeImport === void 0 || entry.namespaceLikeImport.name === symbolName2, "Namespacelike import shoudl be missing or match symbolName");
                                entry.namespaceLikeImport = {
                                    importKind: importKind,
                                    name: symbolName2,
                                    addAsTypeOnly: addAsTypeOnly
                                };
                                break;
                        }
                        break;
                    }
                case 4 /* PromoteTypeOnly */ :
                    break;
                default:
                    Debug.assertNever(fix, `fix wasn't never - got kind ${fix.kind}`);
            }
            function reduceAddAsTypeOnlyValues(prevValue, newValue) {
                return Math.max(prevValue ?? 0, newValue);
            }
            function getNewImportEntry(moduleSpecifier, importKind, useRequire, addAsTypeOnly) {
                const typeOnlyKey = newImportsKey(moduleSpecifier, /*topLevelTypeOnly*/ true);
                const nonTypeOnlyKey = newImportsKey(moduleSpecifier, /*topLevelTypeOnly*/ false);
                const typeOnlyEntry = newImports.get(typeOnlyKey);
                const nonTypeOnlyEntry = newImports.get(nonTypeOnlyKey);
                const newEntry = {
                    defaultImport: void 0,
                    namedImports: void 0,
                    namespaceLikeImport: void 0,
                    useRequire: useRequire
                };
                if (importKind === 1 /* Default */  && addAsTypeOnly === 2 /* Required */ ) {
                    if (typeOnlyEntry) return typeOnlyEntry;
                    newImports.set(typeOnlyKey, newEntry);
                    return newEntry;
                }
                if (addAsTypeOnly === 1 /* Allowed */  && (typeOnlyEntry || nonTypeOnlyEntry)) return typeOnlyEntry || nonTypeOnlyEntry;
                if (nonTypeOnlyEntry) return nonTypeOnlyEntry;
                newImports.set(nonTypeOnlyKey, newEntry);
                return newEntry;
            }
            function newImportsKey(moduleSpecifier, topLevelTypeOnly) {
                return `${topLevelTypeOnly ? 1 : 0}|${moduleSpecifier}`;
            }
        }
        function writeFixes(changeTracker) {
            const quotePreference = getQuotePreference(sourceFile, preferences);
            for (const fix of addToNamespace)addNamespaceQualifier(changeTracker, sourceFile, fix);
            for (const fix of importType)addImportType(changeTracker, sourceFile, fix, quotePreference);
            addToExisting.forEach(({ importClauseOrBindingPattern: importClauseOrBindingPattern , defaultImport: defaultImport , namedImports: namedImports  })=>{
                doAddExistingFix(changeTracker, sourceFile, importClauseOrBindingPattern, defaultImport, arrayFrom(namedImports.entries(), ([name, addAsTypeOnly])=>({
                        addAsTypeOnly: addAsTypeOnly,
                        name: name
                    })), preferences);
            });
            let newDeclarations;
            newImports.forEach(({ useRequire: useRequire , defaultImport: defaultImport , namedImports: namedImports , namespaceLikeImport: namespaceLikeImport  }, key)=>{
                const moduleSpecifier = key.slice(2);
                const getDeclarations = useRequire ? getNewRequires : getNewImports;
                const declarations = getDeclarations(moduleSpecifier, quotePreference, defaultImport, namedImports && arrayFrom(namedImports.entries(), ([name, addAsTypeOnly])=>({
                        addAsTypeOnly: addAsTypeOnly,
                        name: name
                    })), namespaceLikeImport, compilerOptions);
                newDeclarations = combine(newDeclarations, declarations);
            });
            if (newDeclarations) insertImports(changeTracker, sourceFile, newDeclarations, /*blankLineBetween*/ true, preferences);
        }
        function hasFixes() {
            return addToNamespace.length > 0 || importType.length > 0 || addToExisting.size > 0 || newImports.size > 0;
        }
    }
    function createImportSpecifierResolver(importingFile, program, host, preferences) {
        const packageJsonImportFilter = createPackageJsonImportFilter(importingFile, preferences, host);
        const importMap = createExistingImportMap(program.getTypeChecker(), importingFile, program.getCompilerOptions());
        return {
            getModuleSpecifierForBestExportInfo: getModuleSpecifierForBestExportInfo
        };
        function getModuleSpecifierForBestExportInfo(exportInfo, position, isValidTypeOnlyUseSite, fromCacheOnly) {
            const { fixes: fixes , computedWithoutCacheCount: computedWithoutCacheCount  } = getImportFixes(exportInfo, position, isValidTypeOnlyUseSite, /*useRequire*/ false, program, importingFile, host, preferences, importMap, fromCacheOnly);
            const result = getBestFix(fixes, importingFile, program, packageJsonImportFilter, host);
            return result && {
                ...result,
                computedWithoutCacheCount: computedWithoutCacheCount
            };
        }
    }
    function getImportCompletionAction(targetSymbol, moduleSymbol, exportMapKey, sourceFile, symbolName2, isJsxTagName, host, program, formatContext, position, preferences, cancellationToken) {
        const compilerOptions = program.getCompilerOptions();
        let exportInfos;
        if (exportMapKey) {
            exportInfos = getExportInfoMap(sourceFile, host, program, preferences, cancellationToken).get(sourceFile.path, exportMapKey);
            Debug.assertIsDefined(exportInfos, "Some exportInfo should match the specified exportMapKey");
        } else {
            exportInfos = pathIsBareSpecifier(stripQuotes(moduleSymbol.name)) ? [
                getSingleExportInfoForSymbol(targetSymbol, symbolName2, moduleSymbol, program, host)
            ] : getAllExportInfoForSymbol(sourceFile, targetSymbol, symbolName2, moduleSymbol, isJsxTagName, program, host, preferences, cancellationToken);
            Debug.assertIsDefined(exportInfos, "Some exportInfo should match the specified symbol / moduleSymbol");
        }
        const useRequire = shouldUseRequire(sourceFile, program);
        const isValidTypeOnlyUseSite = isValidTypeOnlyAliasUseSite(getTokenAtPosition(sourceFile, position));
        const fix = Debug.checkDefined(getImportFixForSymbol(sourceFile, exportInfos, program, position, isValidTypeOnlyUseSite, useRequire, host, preferences));
        return {
            moduleSpecifier: fix.moduleSpecifier,
            codeAction: codeFixActionToCodeAction(codeActionForFix({
                host: host,
                formatContext: formatContext,
                preferences: preferences
            }, sourceFile, symbolName2, fix, /*includeSymbolNameInDescription*/ false, compilerOptions, preferences))
        };
    }
    function getPromoteTypeOnlyCompletionAction(sourceFile, symbolToken, program, host, formatContext, preferences) {
        const compilerOptions = program.getCompilerOptions();
        const symbolName2 = single(getSymbolNamesToImport(sourceFile, program.getTypeChecker(), symbolToken, compilerOptions));
        const fix = getTypeOnlyPromotionFix(sourceFile, symbolToken, symbolName2, program);
        const includeSymbolNameInDescription = symbolName2 !== symbolToken.text;
        return fix && codeFixActionToCodeAction(codeActionForFix({
            host: host,
            formatContext: formatContext,
            preferences: preferences
        }, sourceFile, symbolName2, fix, includeSymbolNameInDescription, compilerOptions, preferences));
    }
    function getImportFixForSymbol(sourceFile, exportInfos, program, position, isValidTypeOnlyUseSite, useRequire, host, preferences) {
        const packageJsonImportFilter = createPackageJsonImportFilter(sourceFile, preferences, host);
        return getBestFix(getImportFixes(exportInfos, position, isValidTypeOnlyUseSite, useRequire, program, sourceFile, host, preferences).fixes, sourceFile, program, packageJsonImportFilter, host);
    }
    function codeFixActionToCodeAction({ description: description3 , changes: changes , commands: commands  }) {
        return {
            description: description3,
            changes: changes,
            commands: commands
        };
    }
    function getAllExportInfoForSymbol(importingFile, symbol, symbolName2, moduleSymbol, preferCapitalized, program, host, preferences, cancellationToken) {
        const getChecker = createGetChecker(program, host);
        return getExportInfoMap(importingFile, host, program, preferences, cancellationToken).search(importingFile.path, preferCapitalized, (name)=>name === symbolName2, (info)=>{
            if (skipAlias(info[0].symbol, getChecker(info[0].isFromPackageJson)) === symbol && info.some((i)=>i.moduleSymbol === moduleSymbol || i.symbol.parent === moduleSymbol)) return info;
        });
    }
    function getSingleExportInfoForSymbol(symbol, symbolName2, moduleSymbol, program, host) {
        var _a, _b;
        const compilerOptions = program.getCompilerOptions();
        const mainProgramInfo = getInfoWithChecker(program.getTypeChecker(), /*isFromPackageJson*/ false);
        if (mainProgramInfo) return mainProgramInfo;
        const autoImportProvider = (_b = (_a = host.getPackageJsonAutoImportProvider) == null ? void 0 : _a.call(host)) == null ? void 0 : _b.getTypeChecker();
        return Debug.checkDefined(autoImportProvider && getInfoWithChecker(autoImportProvider, /*isFromPackageJson*/ true), `Could not find symbol in specified module for code actions`);
        function getInfoWithChecker(checker, isFromPackageJson) {
            const defaultInfo = getDefaultLikeExportInfo(moduleSymbol, checker, compilerOptions);
            if (defaultInfo && skipAlias(defaultInfo.symbol, checker) === symbol) return {
                symbol: defaultInfo.symbol,
                moduleSymbol: moduleSymbol,
                moduleFileName: void 0,
                exportKind: defaultInfo.exportKind,
                targetFlags: skipAlias(symbol, checker).flags,
                isFromPackageJson: isFromPackageJson
            };
            const named = checker.tryGetMemberInModuleExportsAndProperties(symbolName2, moduleSymbol);
            if (named && skipAlias(named, checker) === symbol) return {
                symbol: named,
                moduleSymbol: moduleSymbol,
                moduleFileName: void 0,
                exportKind: 0 /* Named */ ,
                targetFlags: skipAlias(symbol, checker).flags,
                isFromPackageJson: isFromPackageJson
            };
        }
    }
    function getImportFixes(exportInfos, usagePosition, isValidTypeOnlyUseSite, useRequire, program, sourceFile, host, preferences, importMap = createExistingImportMap(program.getTypeChecker(), sourceFile, program.getCompilerOptions()), fromCacheOnly) {
        const checker = program.getTypeChecker();
        const existingImports = flatMap(exportInfos, importMap.getImportsForExportInfo);
        const useNamespace = usagePosition !== void 0 && tryUseExistingNamespaceImport(existingImports, usagePosition);
        const addToExisting = tryAddToExistingImport(existingImports, isValidTypeOnlyUseSite, checker, program.getCompilerOptions());
        if (addToExisting) return {
            computedWithoutCacheCount: 0,
            fixes: [
                ...useNamespace ? [
                    useNamespace
                ] : emptyArray,
                addToExisting
            ]
        };
        const { fixes: fixes , computedWithoutCacheCount: computedWithoutCacheCount = 0  } = getFixesForAddImport(exportInfos, existingImports, program, sourceFile, usagePosition, isValidTypeOnlyUseSite, useRequire, host, preferences, fromCacheOnly);
        return {
            computedWithoutCacheCount: computedWithoutCacheCount,
            fixes: [
                ...useNamespace ? [
                    useNamespace
                ] : emptyArray,
                ...fixes
            ]
        };
    }
    function tryUseExistingNamespaceImport(existingImports, position) {
        return firstDefined(existingImports, ({ declaration: declaration , importKind: importKind  })=>{
            var _a;
            if (importKind !== 0 /* Named */ ) return void 0;
            const namespacePrefix = getNamespaceLikeImportText(declaration);
            const moduleSpecifier = namespacePrefix && ((_a = tryGetModuleSpecifierFromDeclaration(declaration)) == null ? void 0 : _a.text);
            if (moduleSpecifier) return {
                kind: 0 /* UseNamespace */ ,
                namespacePrefix: namespacePrefix,
                usagePosition: position,
                moduleSpecifier: moduleSpecifier
            };
        });
    }
    function getNamespaceLikeImportText(declaration) {
        var _a, _b, _c;
        switch(declaration.kind){
            case 259 /* VariableDeclaration */ :
                return (_a = tryCast(declaration.name, isIdentifier)) == null ? void 0 : _a.text;
            case 270 /* ImportEqualsDeclaration */ :
                return declaration.name.text;
            case 271 /* ImportDeclaration */ :
                return (_c = tryCast((_b = declaration.importClause) == null ? void 0 : _b.namedBindings, isNamespaceImport)) == null ? void 0 : _c.name.text;
            default:
                return Debug.assertNever(declaration);
        }
    }
    function getAddAsTypeOnly(isValidTypeOnlyUseSite, isForNewImportDeclaration, symbol, targetFlags, checker, compilerOptions) {
        if (!isValidTypeOnlyUseSite) return 4 /* NotAllowed */ ;
        if (isForNewImportDeclaration && compilerOptions.importsNotUsedAsValues === 2 /* Error */ ) return 2 /* Required */ ;
        if (importNameElisionDisabled(compilerOptions) && (!(targetFlags & 111551 /* Value */ ) || !!checker.getTypeOnlyAliasDeclaration(symbol))) return 2 /* Required */ ;
        return 1 /* Allowed */ ;
    }
    function tryAddToExistingImport(existingImports, isValidTypeOnlyUseSite, checker, compilerOptions) {
        let best;
        for (const existingImport of existingImports){
            const fix = getAddToExistingImportFix(existingImport);
            if (!fix) continue;
            const isTypeOnly = isTypeOnlyImportDeclaration(fix.importClauseOrBindingPattern);
            if (fix.addAsTypeOnly !== 4 /* NotAllowed */  && isTypeOnly || fix.addAsTypeOnly === 4 /* NotAllowed */  && !isTypeOnly) return fix;
            best ?? (best = fix);
        }
        return best;
        function getAddToExistingImportFix({ declaration: declaration , importKind: importKind , symbol: symbol , targetFlags: targetFlags  }) {
            if (importKind === 3 /* CommonJS */  || importKind === 2 /* Namespace */  || declaration.kind === 270 /* ImportEqualsDeclaration */ ) return void 0;
            if (declaration.kind === 259 /* VariableDeclaration */ ) return (importKind === 0 /* Named */  || importKind === 1 /* Default */ ) && declaration.name.kind === 205 /* ObjectBindingPattern */  ? {
                kind: 2 /* AddToExisting */ ,
                importClauseOrBindingPattern: declaration.name,
                importKind: importKind,
                moduleSpecifier: declaration.initializer.arguments[0].text,
                addAsTypeOnly: 4 /* NotAllowed */ 
            } : void 0;
            const { importClause: importClause  } = declaration;
            if (!importClause || !isStringLiteralLike(declaration.moduleSpecifier)) return void 0;
            const { name: name , namedBindings: namedBindings  } = importClause;
            if (importClause.isTypeOnly && !(importKind === 0 /* Named */  && namedBindings)) return void 0;
            const addAsTypeOnly = getAddAsTypeOnly(isValidTypeOnlyUseSite, /*isForNewImportDeclaration*/ false, symbol, targetFlags, checker, compilerOptions);
            if (importKind === 1 /* Default */  && (name || // Cannot add a default import to a declaration that already has one
            addAsTypeOnly === 2 /* Required */  && namedBindings)) return void 0;
            if (importKind === 0 /* Named */  && (namedBindings == null ? void 0 : namedBindings.kind) === 273 /* NamespaceImport */ ) return void 0;
            return {
                kind: 2 /* AddToExisting */ ,
                importClauseOrBindingPattern: importClause,
                importKind: importKind,
                moduleSpecifier: declaration.moduleSpecifier.text,
                addAsTypeOnly: addAsTypeOnly
            };
        }
    }
    function createExistingImportMap(checker, importingFile, compilerOptions) {
        let importMap;
        for (const moduleSpecifier of importingFile.imports){
            const i = importFromModuleSpecifier(moduleSpecifier);
            if (isVariableDeclarationInitializedToRequire(i.parent)) {
                const moduleSymbol = checker.resolveExternalModuleName(moduleSpecifier);
                if (moduleSymbol) (importMap || (importMap = createMultiMap())).add(getSymbolId(moduleSymbol), i.parent);
            } else if (i.kind === 271 /* ImportDeclaration */  || i.kind === 270 /* ImportEqualsDeclaration */ ) {
                const moduleSymbol = checker.getSymbolAtLocation(moduleSpecifier);
                if (moduleSymbol) (importMap || (importMap = createMultiMap())).add(getSymbolId(moduleSymbol), i);
            }
        }
        return {
            getImportsForExportInfo: ({ moduleSymbol: moduleSymbol , exportKind: exportKind , targetFlags: targetFlags , symbol: symbol  })=>{
                if (!(targetFlags & 111551 /* Value */ ) && isSourceFileJS(importingFile)) return emptyArray;
                const matchingDeclarations = importMap == null ? void 0 : importMap.get(getSymbolId(moduleSymbol));
                if (!matchingDeclarations) return emptyArray;
                const importKind = getImportKind(importingFile, exportKind, compilerOptions);
                return matchingDeclarations.map((declaration)=>({
                        declaration: declaration,
                        importKind: importKind,
                        symbol: symbol,
                        targetFlags: targetFlags
                    }));
            }
        };
    }
    function shouldUseRequire(sourceFile, program) {
        if (!isSourceFileJS(sourceFile)) return false;
        if (sourceFile.commonJsModuleIndicator && !sourceFile.externalModuleIndicator) return true;
        if (sourceFile.externalModuleIndicator && !sourceFile.commonJsModuleIndicator) return false;
        const compilerOptions = program.getCompilerOptions();
        if (compilerOptions.configFile) return getEmitModuleKind(compilerOptions) < 5 /* ES2015 */ ;
        for (const otherFile of program.getSourceFiles()){
            if (otherFile === sourceFile || !isSourceFileJS(otherFile) || program.isSourceFileFromExternalLibrary(otherFile)) continue;
            if (otherFile.commonJsModuleIndicator && !otherFile.externalModuleIndicator) return true;
            if (otherFile.externalModuleIndicator && !otherFile.commonJsModuleIndicator) return false;
        }
        return true;
    }
    function createGetChecker(program, host) {
        return memoizeOne((isFromPackageJson)=>isFromPackageJson ? host.getPackageJsonAutoImportProvider().getTypeChecker() : program.getTypeChecker());
    }
    function getNewImportFixes(program, sourceFile, usagePosition, isValidTypeOnlyUseSite, useRequire, exportInfo, host, preferences, fromCacheOnly) {
        const isJs = isSourceFileJS(sourceFile);
        const compilerOptions = program.getCompilerOptions();
        const moduleSpecifierResolutionHost = createModuleSpecifierResolutionHost(program, host);
        const getChecker = createGetChecker(program, host);
        const moduleResolution = getEmitModuleResolutionKind(compilerOptions);
        const rejectNodeModulesRelativePaths = moduleResolutionUsesNodeModules(moduleResolution);
        const getModuleSpecifiers2 = fromCacheOnly ? (moduleSymbol)=>({
                moduleSpecifiers: ts_moduleSpecifiers_exports.tryGetModuleSpecifiersFromCache(moduleSymbol, sourceFile, moduleSpecifierResolutionHost, preferences),
                computedWithoutCache: false
            }) : (moduleSymbol, checker)=>ts_moduleSpecifiers_exports.getModuleSpecifiersWithCacheInfo(moduleSymbol, checker, compilerOptions, sourceFile, moduleSpecifierResolutionHost, preferences);
        let computedWithoutCacheCount = 0;
        const fixes = flatMap(exportInfo, (exportInfo2, i)=>{
            const checker = getChecker(exportInfo2.isFromPackageJson);
            const { computedWithoutCache: computedWithoutCache , moduleSpecifiers: moduleSpecifiers  } = getModuleSpecifiers2(exportInfo2.moduleSymbol, checker);
            const importedSymbolHasValueMeaning = !!(exportInfo2.targetFlags & 111551 /* Value */ );
            const addAsTypeOnly = getAddAsTypeOnly(isValidTypeOnlyUseSite, /*isForNewImportDeclaration*/ true, exportInfo2.symbol, exportInfo2.targetFlags, checker, compilerOptions);
            computedWithoutCacheCount += computedWithoutCache ? 1 : 0;
            return mapDefined(moduleSpecifiers, (moduleSpecifier)=>{
                var _a;
                if (rejectNodeModulesRelativePaths && pathContainsNodeModules(moduleSpecifier)) return void 0;
                if (!importedSymbolHasValueMeaning && isJs && usagePosition !== void 0) return {
                    kind: 1 /* JsdocTypeImport */ ,
                    moduleSpecifier: moduleSpecifier,
                    usagePosition: usagePosition,
                    exportInfo: exportInfo2,
                    isReExport: i > 0
                };
                const importKind = getImportKind(sourceFile, exportInfo2.exportKind, compilerOptions);
                let qualification;
                if (usagePosition !== void 0 && importKind === 3 /* CommonJS */  && exportInfo2.exportKind === 0 /* Named */ ) {
                    const exportEquals = checker.resolveExternalModuleSymbol(exportInfo2.moduleSymbol);
                    let namespacePrefix;
                    if (exportEquals !== exportInfo2.moduleSymbol) namespacePrefix = (_a = getDefaultExportInfoWorker(exportEquals, checker, compilerOptions)) == null ? void 0 : _a.name;
                    namespacePrefix || (namespacePrefix = moduleSymbolToValidIdentifier(exportInfo2.moduleSymbol, getEmitScriptTarget(compilerOptions), /*forceCapitalize*/ false));
                    qualification = {
                        namespacePrefix: namespacePrefix,
                        usagePosition: usagePosition
                    };
                }
                return {
                    kind: 3 /* AddNew */ ,
                    moduleSpecifier: moduleSpecifier,
                    importKind: importKind,
                    useRequire: useRequire,
                    addAsTypeOnly: addAsTypeOnly,
                    exportInfo: exportInfo2,
                    isReExport: i > 0,
                    qualification: qualification
                };
            });
        });
        return {
            computedWithoutCacheCount: computedWithoutCacheCount,
            fixes: fixes
        };
    }
    function getFixesForAddImport(exportInfos, existingImports, program, sourceFile, usagePosition, isValidTypeOnlyUseSite, useRequire, host, preferences, fromCacheOnly) {
        const existingDeclaration = firstDefined(existingImports, (info)=>newImportInfoFromExistingSpecifier(info, isValidTypeOnlyUseSite, useRequire, program.getTypeChecker(), program.getCompilerOptions()));
        return existingDeclaration ? {
            fixes: [
                existingDeclaration
            ]
        } : getNewImportFixes(program, sourceFile, usagePosition, isValidTypeOnlyUseSite, useRequire, exportInfos, host, preferences, fromCacheOnly);
    }
    function newImportInfoFromExistingSpecifier({ declaration: declaration , importKind: importKind , symbol: symbol , targetFlags: targetFlags  }, isValidTypeOnlyUseSite, useRequire, checker, compilerOptions) {
        var _a;
        const moduleSpecifier = (_a = tryGetModuleSpecifierFromDeclaration(declaration)) == null ? void 0 : _a.text;
        if (moduleSpecifier) {
            const addAsTypeOnly = useRequire ? 4 /* NotAllowed */  : getAddAsTypeOnly(isValidTypeOnlyUseSite, /*isForNewImportDeclaration*/ true, symbol, targetFlags, checker, compilerOptions);
            return {
                kind: 3 /* AddNew */ ,
                moduleSpecifier: moduleSpecifier,
                importKind: importKind,
                addAsTypeOnly: addAsTypeOnly,
                useRequire: useRequire
            };
        }
    }
    function getFixInfos(context, errorCode, pos, useAutoImportProvider) {
        const symbolToken = getTokenAtPosition(context.sourceFile, pos);
        let info;
        if (errorCode === Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead.code) info = getFixesInfoForUMDImport(context, symbolToken);
        else if (!isIdentifier(symbolToken)) return void 0;
        else if (errorCode === Diagnostics._0_cannot_be_used_as_a_value_because_it_was_imported_using_import_type.code) {
            const symbolName2 = single(getSymbolNamesToImport(context.sourceFile, context.program.getTypeChecker(), symbolToken, context.program.getCompilerOptions()));
            const fix = getTypeOnlyPromotionFix(context.sourceFile, symbolToken, symbolName2, context.program);
            return fix && [
                {
                    fix: fix,
                    symbolName: symbolName2,
                    errorIdentifierText: symbolToken.text
                }
            ];
        } else info = getFixesInfoForNonUMDImport(context, symbolToken, useAutoImportProvider);
        const packageJsonImportFilter = createPackageJsonImportFilter(context.sourceFile, context.preferences, context.host);
        return info && sortFixInfo(info, context.sourceFile, context.program, packageJsonImportFilter, context.host);
    }
    function sortFixInfo(fixes, sourceFile, program, packageJsonImportFilter, host) {
        const _toPath = (fileName)=>toPath(fileName, host.getCurrentDirectory(), hostGetCanonicalFileName(host));
        return sort(fixes, (a, b)=>compareBooleans(!!a.isJsxNamespaceFix, !!b.isJsxNamespaceFix) || compareValues(a.fix.kind, b.fix.kind) || compareModuleSpecifiers(a.fix, b.fix, sourceFile, program, packageJsonImportFilter.allowsImportingSpecifier, _toPath));
    }
    function getBestFix(fixes, sourceFile, program, packageJsonImportFilter, host) {
        if (!some(fixes)) return;
        if (fixes[0].kind === 0 /* UseNamespace */  || fixes[0].kind === 2 /* AddToExisting */ ) return fixes[0];
        return fixes.reduce((best, fix)=>// Takes true branch of conditional if `fix` is better than `best`
            compareModuleSpecifiers(fix, best, sourceFile, program, packageJsonImportFilter.allowsImportingSpecifier, (fileName)=>toPath(fileName, host.getCurrentDirectory(), hostGetCanonicalFileName(host))) === -1 /* LessThan */  ? fix : best);
    }
    function compareModuleSpecifiers(a, b, importingFile, program, allowsImportingSpecifier, toPath3) {
        if (a.kind !== 0 /* UseNamespace */  && b.kind !== 0 /* UseNamespace */ ) return compareBooleans(allowsImportingSpecifier(b.moduleSpecifier), allowsImportingSpecifier(a.moduleSpecifier)) || compareNodeCoreModuleSpecifiers(a.moduleSpecifier, b.moduleSpecifier, importingFile, program) || compareBooleans(isFixPossiblyReExportingImportingFile(a, importingFile, program.getCompilerOptions(), toPath3), isFixPossiblyReExportingImportingFile(b, importingFile, program.getCompilerOptions(), toPath3)) || compareNumberOfDirectorySeparators(a.moduleSpecifier, b.moduleSpecifier);
        return 0 /* EqualTo */ ;
    }
    function isFixPossiblyReExportingImportingFile(fix, importingFile, compilerOptions, toPath3) {
        var _a;
        if (fix.isReExport && ((_a = fix.exportInfo) == null ? void 0 : _a.moduleFileName) && getEmitModuleResolutionKind(compilerOptions) === 2 /* Node10 */  && isIndexFileName(fix.exportInfo.moduleFileName)) {
            const reExportDir = toPath3(getDirectoryPath(fix.exportInfo.moduleFileName));
            return startsWith(importingFile.path, reExportDir);
        }
        return false;
    }
    function isIndexFileName(fileName) {
        return getBaseFileName(fileName, [
            ".js",
            ".jsx",
            ".d.ts",
            ".ts",
            ".tsx"
        ], /*ignoreCase*/ true) === "index";
    }
    function compareNodeCoreModuleSpecifiers(a, b, importingFile, program) {
        if (startsWith(a, "node:") && !startsWith(b, "node:")) return shouldUseUriStyleNodeCoreModules(importingFile, program) ? -1 /* LessThan */  : 1 /* GreaterThan */ ;
        if (startsWith(b, "node:") && !startsWith(a, "node:")) return shouldUseUriStyleNodeCoreModules(importingFile, program) ? 1 /* GreaterThan */  : -1 /* LessThan */ ;
        return 0 /* EqualTo */ ;
    }
    function getFixesInfoForUMDImport({ sourceFile: sourceFile , program: program , host: host , preferences: preferences  }, token) {
        const checker = program.getTypeChecker();
        const umdSymbol = getUmdSymbol(token, checker);
        if (!umdSymbol) return void 0;
        const symbol = checker.getAliasedSymbol(umdSymbol);
        const symbolName2 = umdSymbol.name;
        const exportInfo = [
            {
                symbol: umdSymbol,
                moduleSymbol: symbol,
                moduleFileName: void 0,
                exportKind: 3 /* UMD */ ,
                targetFlags: symbol.flags,
                isFromPackageJson: false
            }
        ];
        const useRequire = shouldUseRequire(sourceFile, program);
        const fixes = getImportFixes(exportInfo, /*usagePosition*/ void 0, /*isValidTypeOnlyUseSite*/ false, useRequire, program, sourceFile, host, preferences).fixes;
        return fixes.map((fix)=>{
            var _a;
            return {
                fix: fix,
                symbolName: symbolName2,
                errorIdentifierText: (_a = tryCast(token, isIdentifier)) == null ? void 0 : _a.text
            };
        });
    }
    function getUmdSymbol(token, checker) {
        const umdSymbol = isIdentifier(token) ? checker.getSymbolAtLocation(token) : void 0;
        if (isUMDExportSymbol(umdSymbol)) return umdSymbol;
        const { parent: parent2  } = token;
        if (isJsxOpeningLikeElement(parent2) && parent2.tagName === token || isJsxOpeningFragment(parent2)) {
            const parentSymbol = checker.resolveName(checker.getJsxNamespace(parent2), isJsxOpeningLikeElement(parent2) ? token : parent2, 111551 /* Value */ , /*excludeGlobals*/ false);
            if (isUMDExportSymbol(parentSymbol)) return parentSymbol;
        }
        return void 0;
    }
    function getImportKind(importingFile, exportKind, compilerOptions, forceImportKeyword) {
        if (compilerOptions.verbatimModuleSyntax && (getEmitModuleKind(compilerOptions) === 1 /* CommonJS */  || importingFile.impliedNodeFormat === 1 /* CommonJS */ )) return 3 /* CommonJS */ ;
        switch(exportKind){
            case 0 /* Named */ :
                return 0 /* Named */ ;
            case 1 /* Default */ :
                return 1 /* Default */ ;
            case 2 /* ExportEquals */ :
                return getExportEqualsImportKind(importingFile, compilerOptions, !!forceImportKeyword);
            case 3 /* UMD */ :
                return getUmdImportKind(importingFile, compilerOptions, !!forceImportKeyword);
            default:
                return Debug.assertNever(exportKind);
        }
    }
    function getUmdImportKind(importingFile, compilerOptions, forceImportKeyword) {
        if (getAllowSyntheticDefaultImports(compilerOptions)) return 1 /* Default */ ;
        const moduleKind = getEmitModuleKind(compilerOptions);
        switch(moduleKind){
            case 2 /* AMD */ :
            case 1 /* CommonJS */ :
            case 3 /* UMD */ :
                if (isInJSFile(importingFile)) return isExternalModule(importingFile) || forceImportKeyword ? 2 /* Namespace */  : 3 /* CommonJS */ ;
                return 3 /* CommonJS */ ;
            case 4 /* System */ :
            case 5 /* ES2015 */ :
            case 6 /* ES2020 */ :
            case 7 /* ES2022 */ :
            case 99 /* ESNext */ :
            case 0 /* None */ :
                return 2 /* Namespace */ ;
            case 100 /* Node16 */ :
            case 199 /* NodeNext */ :
                return importingFile.impliedNodeFormat === 99 /* ESNext */  ? 2 /* Namespace */  : 3 /* CommonJS */ ;
            default:
                return Debug.assertNever(moduleKind, `Unexpected moduleKind ${moduleKind}`);
        }
    }
    function getFixesInfoForNonUMDImport({ sourceFile: sourceFile , program: program , cancellationToken: cancellationToken , host: host , preferences: preferences  }, symbolToken, useAutoImportProvider) {
        const checker = program.getTypeChecker();
        const compilerOptions = program.getCompilerOptions();
        return flatMap(getSymbolNamesToImport(sourceFile, checker, symbolToken, compilerOptions), (symbolName2)=>{
            if (symbolName2 === "default" /* Default */ ) return void 0;
            const isValidTypeOnlyUseSite = isValidTypeOnlyAliasUseSite(symbolToken);
            const useRequire = shouldUseRequire(sourceFile, program);
            const exportInfo = getExportInfos(symbolName2, isJSXTagName(symbolToken), getMeaningFromLocation(symbolToken), cancellationToken, sourceFile, program, useAutoImportProvider, host, preferences);
            return arrayFrom(flatMapIterator(exportInfo.values(), (exportInfos)=>getImportFixes(exportInfos, symbolToken.getStart(sourceFile), isValidTypeOnlyUseSite, useRequire, program, sourceFile, host, preferences).fixes), (fix)=>({
                    fix: fix,
                    symbolName: symbolName2,
                    errorIdentifierText: symbolToken.text,
                    isJsxNamespaceFix: symbolName2 !== symbolToken.text
                }));
        });
    }
    function getTypeOnlyPromotionFix(sourceFile, symbolToken, symbolName2, program) {
        const checker = program.getTypeChecker();
        const symbol = checker.resolveName(symbolName2, symbolToken, 111551 /* Value */ , /*excludeGlobals*/ true);
        if (!symbol) return void 0;
        const typeOnlyAliasDeclaration = checker.getTypeOnlyAliasDeclaration(symbol);
        if (!typeOnlyAliasDeclaration || getSourceFileOfNode(typeOnlyAliasDeclaration) !== sourceFile) return void 0;
        return {
            kind: 4 /* PromoteTypeOnly */ ,
            typeOnlyAliasDeclaration: typeOnlyAliasDeclaration
        };
    }
    function getSymbolNamesToImport(sourceFile, checker, symbolToken, compilerOptions) {
        const parent2 = symbolToken.parent;
        if ((isJsxOpeningLikeElement(parent2) || isJsxClosingElement(parent2)) && parent2.tagName === symbolToken && jsxModeNeedsExplicitImport(compilerOptions.jsx)) {
            const jsxNamespace = checker.getJsxNamespace(sourceFile);
            if (needsJsxNamespaceFix(jsxNamespace, symbolToken, checker)) {
                const needsComponentNameFix = !isIntrinsicJsxName(symbolToken.text) && !checker.resolveName(symbolToken.text, symbolToken, 111551 /* Value */ , /*excludeGlobals*/ false);
                return needsComponentNameFix ? [
                    symbolToken.text,
                    jsxNamespace
                ] : [
                    jsxNamespace
                ];
            }
        }
        return [
            symbolToken.text
        ];
    }
    function needsJsxNamespaceFix(jsxNamespace, symbolToken, checker) {
        if (isIntrinsicJsxName(symbolToken.text)) return true;
        const namespaceSymbol = checker.resolveName(jsxNamespace, symbolToken, 111551 /* Value */ , /*excludeGlobals*/ true);
        return !namespaceSymbol || some(namespaceSymbol.declarations, isTypeOnlyImportOrExportDeclaration) && !(namespaceSymbol.flags & 111551 /* Value */ );
    }
    function getExportInfos(symbolName2, isJsxTagName, currentTokenMeaning, cancellationToken, fromFile, program, useAutoImportProvider, host, preferences) {
        var _a;
        const originalSymbolToExportInfos = createMultiMap();
        const packageJsonFilter = createPackageJsonImportFilter(fromFile, preferences, host);
        const moduleSpecifierCache = (_a = host.getModuleSpecifierCache) == null ? void 0 : _a.call(host);
        const getModuleSpecifierResolutionHost = memoizeOne((isFromPackageJson)=>{
            return createModuleSpecifierResolutionHost(isFromPackageJson ? host.getPackageJsonAutoImportProvider() : program, host);
        });
        function addSymbol(moduleSymbol, toFile, exportedSymbol, exportKind, program2, isFromPackageJson) {
            const moduleSpecifierResolutionHost = getModuleSpecifierResolutionHost(isFromPackageJson);
            if (toFile && isImportableFile(program2, fromFile, toFile, preferences, packageJsonFilter, moduleSpecifierResolutionHost, moduleSpecifierCache) || !toFile && packageJsonFilter.allowsImportingAmbientModule(moduleSymbol, moduleSpecifierResolutionHost)) {
                const checker = program2.getTypeChecker();
                originalSymbolToExportInfos.add(getUniqueSymbolId(exportedSymbol, checker).toString(), {
                    symbol: exportedSymbol,
                    moduleSymbol: moduleSymbol,
                    moduleFileName: toFile == null ? void 0 : toFile.fileName,
                    exportKind: exportKind,
                    targetFlags: skipAlias(exportedSymbol, checker).flags,
                    isFromPackageJson: isFromPackageJson
                });
            }
        }
        forEachExternalModuleToImportFrom(program, host, preferences, useAutoImportProvider, (moduleSymbol, sourceFile, program2, isFromPackageJson)=>{
            const checker = program2.getTypeChecker();
            cancellationToken.throwIfCancellationRequested();
            const compilerOptions = program2.getCompilerOptions();
            const defaultInfo = getDefaultLikeExportInfo(moduleSymbol, checker, compilerOptions);
            if (defaultInfo && (defaultInfo.name === symbolName2 || moduleSymbolToValidIdentifier(moduleSymbol, getEmitScriptTarget(compilerOptions), isJsxTagName) === symbolName2) && symbolHasMeaning(defaultInfo.resolvedSymbol, currentTokenMeaning)) addSymbol(moduleSymbol, sourceFile, defaultInfo.symbol, defaultInfo.exportKind, program2, isFromPackageJson);
            const exportSymbolWithIdenticalName = checker.tryGetMemberInModuleExportsAndProperties(symbolName2, moduleSymbol);
            if (exportSymbolWithIdenticalName && symbolHasMeaning(exportSymbolWithIdenticalName, currentTokenMeaning)) addSymbol(moduleSymbol, sourceFile, exportSymbolWithIdenticalName, 0 /* Named */ , program2, isFromPackageJson);
        });
        return originalSymbolToExportInfos;
    }
    function getExportEqualsImportKind(importingFile, compilerOptions, forceImportKeyword) {
        const allowSyntheticDefaults = getAllowSyntheticDefaultImports(compilerOptions);
        const isJS = isInJSFile(importingFile);
        if (!isJS && getEmitModuleKind(compilerOptions) >= 5 /* ES2015 */ ) return allowSyntheticDefaults ? 1 /* Default */  : 2 /* Namespace */ ;
        if (isJS) return isExternalModule(importingFile) || forceImportKeyword ? allowSyntheticDefaults ? 1 /* Default */  : 2 /* Namespace */  : 3 /* CommonJS */ ;
        for (const statement of importingFile.statements){
            if (isImportEqualsDeclaration(statement) && !nodeIsMissing(statement.moduleReference)) return 3 /* CommonJS */ ;
        }
        return allowSyntheticDefaults ? 1 /* Default */  : 3 /* CommonJS */ ;
    }
    function codeActionForFix(context, sourceFile, symbolName2, fix, includeSymbolNameInDescription, compilerOptions, preferences) {
        let diag2;
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (tracker)=>{
            diag2 = codeActionForFixWorker(tracker, sourceFile, symbolName2, fix, includeSymbolNameInDescription, compilerOptions, preferences);
        });
        return createCodeFixAction(importFixName, changes, diag2, importFixId, Diagnostics.Add_all_missing_imports);
    }
    function codeActionForFixWorker(changes, sourceFile, symbolName2, fix, includeSymbolNameInDescription, compilerOptions, preferences) {
        const quotePreference = getQuotePreference(sourceFile, preferences);
        switch(fix.kind){
            case 0 /* UseNamespace */ :
                addNamespaceQualifier(changes, sourceFile, fix);
                return [
                    Diagnostics.Change_0_to_1,
                    symbolName2,
                    `${fix.namespacePrefix}.${symbolName2}`
                ];
            case 1 /* JsdocTypeImport */ :
                addImportType(changes, sourceFile, fix, quotePreference);
                return [
                    Diagnostics.Change_0_to_1,
                    symbolName2,
                    getImportTypePrefix(fix.moduleSpecifier, quotePreference) + symbolName2
                ];
            case 2 /* AddToExisting */ :
                {
                    const { importClauseOrBindingPattern: importClauseOrBindingPattern , importKind: importKind , addAsTypeOnly: addAsTypeOnly , moduleSpecifier: moduleSpecifier  } = fix;
                    doAddExistingFix(changes, sourceFile, importClauseOrBindingPattern, importKind === 1 /* Default */  ? {
                        name: symbolName2,
                        addAsTypeOnly: addAsTypeOnly
                    } : void 0, importKind === 0 /* Named */  ? [
                        {
                            name: symbolName2,
                            addAsTypeOnly: addAsTypeOnly
                        }
                    ] : emptyArray, preferences);
                    const moduleSpecifierWithoutQuotes = stripQuotes(moduleSpecifier);
                    return includeSymbolNameInDescription ? [
                        Diagnostics.Import_0_from_1,
                        symbolName2,
                        moduleSpecifierWithoutQuotes
                    ] : [
                        Diagnostics.Update_import_from_0,
                        moduleSpecifierWithoutQuotes
                    ];
                }
            case 3 /* AddNew */ :
                {
                    const { importKind: importKind , moduleSpecifier: moduleSpecifier , addAsTypeOnly: addAsTypeOnly , useRequire: useRequire , qualification: qualification  } = fix;
                    const getDeclarations = useRequire ? getNewRequires : getNewImports;
                    const defaultImport = importKind === 1 /* Default */  ? {
                        name: symbolName2,
                        addAsTypeOnly: addAsTypeOnly
                    } : void 0;
                    const namedImports = importKind === 0 /* Named */  ? [
                        {
                            name: symbolName2,
                            addAsTypeOnly: addAsTypeOnly
                        }
                    ] : void 0;
                    const namespaceLikeImport = importKind === 2 /* Namespace */  || importKind === 3 /* CommonJS */  ? {
                        importKind: importKind,
                        name: (qualification == null ? void 0 : qualification.namespacePrefix) || symbolName2,
                        addAsTypeOnly: addAsTypeOnly
                    } : void 0;
                    insertImports(changes, sourceFile, getDeclarations(moduleSpecifier, quotePreference, defaultImport, namedImports, namespaceLikeImport, compilerOptions), /*blankLineBetween*/ true, preferences);
                    if (qualification) addNamespaceQualifier(changes, sourceFile, qualification);
                    return includeSymbolNameInDescription ? [
                        Diagnostics.Import_0_from_1,
                        symbolName2,
                        moduleSpecifier
                    ] : [
                        Diagnostics.Add_import_from_0,
                        moduleSpecifier
                    ];
                }
            case 4 /* PromoteTypeOnly */ :
                {
                    const { typeOnlyAliasDeclaration: typeOnlyAliasDeclaration  } = fix;
                    const promotedDeclaration = promoteFromTypeOnly(changes, typeOnlyAliasDeclaration, compilerOptions, sourceFile, preferences);
                    return promotedDeclaration.kind === 275 /* ImportSpecifier */  ? [
                        Diagnostics.Remove_type_from_import_of_0_from_1,
                        symbolName2,
                        getModuleSpecifierText(promotedDeclaration.parent.parent)
                    ] : [
                        Diagnostics.Remove_type_from_import_declaration_from_0,
                        getModuleSpecifierText(promotedDeclaration)
                    ];
                }
            default:
                return Debug.assertNever(fix, `Unexpected fix kind ${fix.kind}`);
        }
    }
    function getModuleSpecifierText(promotedDeclaration) {
        var _a, _b;
        return promotedDeclaration.kind === 270 /* ImportEqualsDeclaration */  ? ((_b = tryCast((_a = tryCast(promotedDeclaration.moduleReference, isExternalModuleReference)) == null ? void 0 : _a.expression, isStringLiteralLike)) == null ? void 0 : _b.text) || promotedDeclaration.moduleReference.getText() : cast(promotedDeclaration.parent.moduleSpecifier, isStringLiteral).text;
    }
    function promoteFromTypeOnly(changes, aliasDeclaration, compilerOptions, sourceFile, preferences) {
        const convertExistingToTypeOnly = importNameElisionDisabled(compilerOptions);
        switch(aliasDeclaration.kind){
            case 275 /* ImportSpecifier */ :
                if (aliasDeclaration.isTypeOnly) {
                    const sortKind = ts_OrganizeImports_exports.detectImportSpecifierSorting(aliasDeclaration.parent.elements, preferences);
                    if (aliasDeclaration.parent.elements.length > 1 && sortKind) {
                        changes.delete(sourceFile, aliasDeclaration);
                        const newSpecifier = factory.updateImportSpecifier(aliasDeclaration, /*isTypeOnly*/ false, aliasDeclaration.propertyName, aliasDeclaration.name);
                        const comparer = ts_OrganizeImports_exports.getOrganizeImportsComparer(preferences, sortKind === 2 /* CaseInsensitive */ );
                        const insertionIndex = ts_OrganizeImports_exports.getImportSpecifierInsertionIndex(aliasDeclaration.parent.elements, newSpecifier, comparer);
                        changes.insertImportSpecifierAtIndex(sourceFile, newSpecifier, aliasDeclaration.parent, insertionIndex);
                    } else changes.deleteRange(sourceFile, aliasDeclaration.getFirstToken());
                    return aliasDeclaration;
                } else {
                    Debug.assert(aliasDeclaration.parent.parent.isTypeOnly);
                    promoteImportClause(aliasDeclaration.parent.parent);
                    return aliasDeclaration.parent.parent;
                }
            case 272 /* ImportClause */ :
                promoteImportClause(aliasDeclaration);
                return aliasDeclaration;
            case 273 /* NamespaceImport */ :
                promoteImportClause(aliasDeclaration.parent);
                return aliasDeclaration.parent;
            case 270 /* ImportEqualsDeclaration */ :
                changes.deleteRange(sourceFile, aliasDeclaration.getChildAt(1));
                return aliasDeclaration;
            default:
                Debug.failBadSyntaxKind(aliasDeclaration);
        }
        function promoteImportClause(importClause) {
            changes.delete(sourceFile, getTypeKeywordOfTypeOnlyImport(importClause, sourceFile));
            if (convertExistingToTypeOnly) {
                const namedImports = tryCast(importClause.namedBindings, isNamedImports);
                if (namedImports && namedImports.elements.length > 1) {
                    if (ts_OrganizeImports_exports.detectImportSpecifierSorting(namedImports.elements, preferences) && aliasDeclaration.kind === 275 /* ImportSpecifier */  && namedImports.elements.indexOf(aliasDeclaration) !== 0) {
                        changes.delete(sourceFile, aliasDeclaration);
                        changes.insertImportSpecifierAtIndex(sourceFile, aliasDeclaration, namedImports, 0);
                    }
                    for (const element of namedImports.elements)if (element !== aliasDeclaration && !element.isTypeOnly) changes.insertModifierBefore(sourceFile, 156 /* TypeKeyword */ , element);
                }
            }
        }
    }
    function doAddExistingFix(changes, sourceFile, clause, defaultImport, namedImports, preferences) {
        var _a;
        if (clause.kind === 205 /* ObjectBindingPattern */ ) {
            if (defaultImport) addElementToBindingPattern(clause, defaultImport.name, "default");
            for (const specifier of namedImports)addElementToBindingPattern(clause, specifier.name, /*propertyName*/ void 0);
            return;
        }
        const promoteFromTypeOnly2 = clause.isTypeOnly && some([
            defaultImport,
            ...namedImports
        ], (i)=>(i == null ? void 0 : i.addAsTypeOnly) === 4 /* NotAllowed */ );
        const existingSpecifiers = clause.namedBindings && ((_a = tryCast(clause.namedBindings, isNamedImports)) == null ? void 0 : _a.elements);
        if (defaultImport) {
            Debug.assert(!clause.name, "Cannot add a default import to an import clause that already has one");
            changes.insertNodeAt(sourceFile, clause.getStart(sourceFile), factory.createIdentifier(defaultImport.name), {
                suffix: ", "
            });
        }
        if (namedImports.length) {
            let ignoreCaseForSorting;
            if (typeof preferences.organizeImportsIgnoreCase === "boolean") ignoreCaseForSorting = preferences.organizeImportsIgnoreCase;
            else if (existingSpecifiers) {
                const targetImportSorting = ts_OrganizeImports_exports.detectImportSpecifierSorting(existingSpecifiers, preferences);
                if (targetImportSorting !== 3 /* Both */ ) ignoreCaseForSorting = targetImportSorting === 2 /* CaseInsensitive */ ;
            }
            if (ignoreCaseForSorting === void 0) ignoreCaseForSorting = ts_OrganizeImports_exports.detectSorting(sourceFile, preferences) === 2 /* CaseInsensitive */ ;
            const comparer = ts_OrganizeImports_exports.getOrganizeImportsComparer(preferences, ignoreCaseForSorting);
            const newSpecifiers = stableSort(namedImports.map((namedImport)=>factory.createImportSpecifier((!clause.isTypeOnly || promoteFromTypeOnly2) && needsTypeOnly(namedImport), /*propertyName*/ void 0, factory.createIdentifier(namedImport.name))), (s1, s2)=>ts_OrganizeImports_exports.compareImportOrExportSpecifiers(s1, s2, comparer));
            const specifierSort = (existingSpecifiers == null ? void 0 : existingSpecifiers.length) && ts_OrganizeImports_exports.detectImportSpecifierSorting(existingSpecifiers, preferences);
            if (specifierSort && !(ignoreCaseForSorting && specifierSort === 1 /* CaseSensitive */ )) for (const spec of newSpecifiers){
                const insertionIndex = promoteFromTypeOnly2 && !spec.isTypeOnly ? 0 : ts_OrganizeImports_exports.getImportSpecifierInsertionIndex(existingSpecifiers, spec, comparer);
                changes.insertImportSpecifierAtIndex(sourceFile, spec, clause.namedBindings, insertionIndex);
            }
            else if (existingSpecifiers == null ? void 0 : existingSpecifiers.length) for (const spec of newSpecifiers)changes.insertNodeInListAfter(sourceFile, last(existingSpecifiers), spec, existingSpecifiers);
            else if (newSpecifiers.length) {
                const namedImports2 = factory.createNamedImports(newSpecifiers);
                if (clause.namedBindings) changes.replaceNode(sourceFile, clause.namedBindings, namedImports2);
                else changes.insertNodeAfter(sourceFile, Debug.checkDefined(clause.name, "Import clause must have either named imports or a default import"), namedImports2);
            }
        }
        if (promoteFromTypeOnly2) {
            changes.delete(sourceFile, getTypeKeywordOfTypeOnlyImport(clause, sourceFile));
            if (existingSpecifiers) for (const specifier of existingSpecifiers)changes.insertModifierBefore(sourceFile, 156 /* TypeKeyword */ , specifier);
        }
        function addElementToBindingPattern(bindingPattern, name, propertyName) {
            const element = factory.createBindingElement(/*dotDotDotToken*/ void 0, propertyName, name);
            if (bindingPattern.elements.length) changes.insertNodeInListAfter(sourceFile, last(bindingPattern.elements), element);
            else changes.replaceNode(sourceFile, bindingPattern, factory.createObjectBindingPattern([
                element
            ]));
        }
    }
    function addNamespaceQualifier(changes, sourceFile, { namespacePrefix: namespacePrefix , usagePosition: usagePosition  }) {
        changes.insertText(sourceFile, usagePosition, namespacePrefix + ".");
    }
    function addImportType(changes, sourceFile, { moduleSpecifier: moduleSpecifier , usagePosition: position  }, quotePreference) {
        changes.insertText(sourceFile, position, getImportTypePrefix(moduleSpecifier, quotePreference));
    }
    function getImportTypePrefix(moduleSpecifier, quotePreference) {
        const quote2 = getQuoteFromPreference(quotePreference);
        return `import(${quote2}${moduleSpecifier}${quote2}).`;
    }
    function needsTypeOnly({ addAsTypeOnly: addAsTypeOnly  }) {
        return addAsTypeOnly === 2 /* Required */ ;
    }
    function getNewImports(moduleSpecifier, quotePreference, defaultImport, namedImports, namespaceLikeImport, compilerOptions) {
        const quotedModuleSpecifier = makeStringLiteral(moduleSpecifier, quotePreference);
        let statements;
        if (defaultImport !== void 0 || (namedImports == null ? void 0 : namedImports.length)) {
            const topLevelTypeOnly = (!defaultImport || needsTypeOnly(defaultImport)) && every(namedImports, needsTypeOnly) || compilerOptions.verbatimModuleSyntax && (defaultImport == null ? void 0 : defaultImport.addAsTypeOnly) !== 4 /* NotAllowed */  && !some(namedImports, (i)=>i.addAsTypeOnly === 4 /* NotAllowed */ );
            statements = combine(statements, makeImport(defaultImport && factory.createIdentifier(defaultImport.name), namedImports == null ? void 0 : namedImports.map(({ addAsTypeOnly: addAsTypeOnly , name: name  })=>factory.createImportSpecifier(!topLevelTypeOnly && addAsTypeOnly === 2 /* Required */ , /*propertyName*/ void 0, factory.createIdentifier(name))), moduleSpecifier, quotePreference, topLevelTypeOnly));
        }
        if (namespaceLikeImport) {
            const declaration = namespaceLikeImport.importKind === 3 /* CommonJS */  ? factory.createImportEqualsDeclaration(/*modifiers*/ void 0, needsTypeOnly(namespaceLikeImport), factory.createIdentifier(namespaceLikeImport.name), factory.createExternalModuleReference(quotedModuleSpecifier)) : factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(needsTypeOnly(namespaceLikeImport), /*name*/ void 0, factory.createNamespaceImport(factory.createIdentifier(namespaceLikeImport.name))), quotedModuleSpecifier, /*assertClause*/ void 0);
            statements = combine(statements, declaration);
        }
        return Debug.checkDefined(statements);
    }
    function getNewRequires(moduleSpecifier, quotePreference, defaultImport, namedImports, namespaceLikeImport) {
        const quotedModuleSpecifier = makeStringLiteral(moduleSpecifier, quotePreference);
        let statements;
        if (defaultImport || (namedImports == null ? void 0 : namedImports.length)) {
            const bindingElements = (namedImports == null ? void 0 : namedImports.map(({ name: name  })=>factory.createBindingElement(/*dotDotDotToken*/ void 0, /*propertyName*/ void 0, name))) || [];
            if (defaultImport) bindingElements.unshift(factory.createBindingElement(/*dotDotDotToken*/ void 0, "default", defaultImport.name));
            const declaration = createConstEqualsRequireDeclaration(factory.createObjectBindingPattern(bindingElements), quotedModuleSpecifier);
            statements = combine(statements, declaration);
        }
        if (namespaceLikeImport) {
            const declaration = createConstEqualsRequireDeclaration(namespaceLikeImport.name, quotedModuleSpecifier);
            statements = combine(statements, declaration);
        }
        return Debug.checkDefined(statements);
    }
    function createConstEqualsRequireDeclaration(name, quotedModuleSpecifier) {
        return factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(typeof name === "string" ? factory.createIdentifier(name) : name, /*exclamationToken*/ void 0, /*type*/ void 0, factory.createCallExpression(factory.createIdentifier("require"), /*typeArguments*/ void 0, [
                quotedModuleSpecifier
            ]))
        ], 2 /* Const */ ));
    }
    function symbolHasMeaning({ declarations: declarations  }, meaning) {
        return some(declarations, (decl)=>!!(getMeaningFromDeclaration(decl) & meaning));
    }
    function moduleSymbolToValidIdentifier(moduleSymbol, target, forceCapitalize) {
        return moduleSpecifierToValidIdentifier(removeFileExtension(stripQuotes(moduleSymbol.name)), target, forceCapitalize);
    }
    function moduleSpecifierToValidIdentifier(moduleSpecifier, target, forceCapitalize) {
        const baseName = getBaseFileName(removeSuffix(moduleSpecifier, "/index"));
        let res = "";
        let lastCharWasValid = true;
        const firstCharCode = baseName.charCodeAt(0);
        if (isIdentifierStart(firstCharCode, target)) {
            res += String.fromCharCode(firstCharCode);
            if (forceCapitalize) res = res.toUpperCase();
        } else lastCharWasValid = false;
        for(let i = 1; i < baseName.length; i++){
            const ch = baseName.charCodeAt(i);
            const isValid = isIdentifierPart(ch, target);
            if (isValid) {
                let char = String.fromCharCode(ch);
                if (!lastCharWasValid) char = char.toUpperCase();
                res += char;
            }
            lastCharWasValid = isValid;
        }
        return !isStringANonContextualKeyword(res) ? res || "_" : `_${res}`;
    }
    var importFixName, importFixId, errorCodes18;
    var init_importFixes = __esm({
        "src/services/codefixes/importFixes.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            importFixName = "import";
            importFixId = "fixMissingImport";
            errorCodes18 = [
                Diagnostics.Cannot_find_name_0.code,
                Diagnostics.Cannot_find_name_0_Did_you_mean_1.code,
                Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0.code,
                Diagnostics.Cannot_find_name_0_Did_you_mean_the_static_member_1_0.code,
                Diagnostics.Cannot_find_namespace_0.code,
                Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead.code,
                Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here.code,
                Diagnostics.No_value_exists_in_scope_for_the_shorthand_property_0_Either_declare_one_or_provide_an_initializer.code,
                Diagnostics._0_cannot_be_used_as_a_value_because_it_was_imported_using_import_type.code
            ];
            registerCodeFix({
                errorCodes: errorCodes18,
                getCodeActions (context) {
                    const { errorCode: errorCode , preferences: preferences , sourceFile: sourceFile , span: span , program: program  } = context;
                    const info = getFixInfos(context, errorCode, span.start, /*useAutoImportProvider*/ true);
                    if (!info) return void 0;
                    return info.map(({ fix: fix , symbolName: symbolName2 , errorIdentifierText: errorIdentifierText  })=>codeActionForFix(context, sourceFile, symbolName2, fix, /*includeSymbolNameInDescription*/ symbolName2 !== errorIdentifierText, program.getCompilerOptions(), preferences));
                },
                fixIds: [
                    importFixId
                ],
                getAllCodeActions: (context)=>{
                    const { sourceFile: sourceFile , program: program , preferences: preferences , host: host , cancellationToken: cancellationToken  } = context;
                    const importAdder = createImportAdderWorker(sourceFile, program, /*useAutoImportProvider*/ true, preferences, host, cancellationToken);
                    eachDiagnostic(context, errorCodes18, (diag2)=>importAdder.addImportFromDiagnostic(diag2, context));
                    return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, importAdder.writeFixes));
                }
            });
        }
    });
    // src/services/codefixes/fixAddMissingConstraint.ts
    function getInfo6(program, sourceFile, span) {
        const diag2 = find(program.getSemanticDiagnostics(sourceFile), (diag3)=>diag3.start === span.start && diag3.length === span.length);
        if (diag2 === void 0 || diag2.relatedInformation === void 0) return;
        const related = find(diag2.relatedInformation, (related2)=>related2.code === Diagnostics.This_type_parameter_might_need_an_extends_0_constraint.code);
        if (related === void 0 || related.file === void 0 || related.start === void 0 || related.length === void 0) return;
        let declaration = findAncestorMatchingSpan(related.file, createTextSpan(related.start, related.length));
        if (declaration === void 0) return;
        if (isIdentifier(declaration) && isTypeParameterDeclaration(declaration.parent)) declaration = declaration.parent;
        if (isTypeParameterDeclaration(declaration)) {
            if (isMappedTypeNode(declaration.parent)) return;
            const token = getTokenAtPosition(sourceFile, span.start);
            const checker = program.getTypeChecker();
            const constraint = tryGetConstraintType(checker, token) || tryGetConstraintFromDiagnosticMessage(related.messageText);
            return {
                constraint: constraint,
                declaration: declaration,
                token: token
            };
        }
        return void 0;
    }
    function addMissingConstraint(changes, program, preferences, host, sourceFile, info) {
        const { declaration: declaration , constraint: constraint  } = info;
        const checker = program.getTypeChecker();
        if (isString(constraint)) changes.insertText(sourceFile, declaration.name.end, ` extends ${constraint}`);
        else {
            const scriptTarget = getEmitScriptTarget(program.getCompilerOptions());
            const tracker = getNoopSymbolTrackerWithResolver({
                program: program,
                host: host
            });
            const importAdder = createImportAdder(sourceFile, program, preferences, host);
            const typeNode = typeToAutoImportableTypeNode(checker, importAdder, constraint, /*contextNode*/ void 0, scriptTarget, /*flags*/ void 0, tracker);
            if (typeNode) {
                changes.replaceNode(sourceFile, declaration, factory.updateTypeParameterDeclaration(declaration, /*modifiers*/ void 0, declaration.name, typeNode, declaration.default));
                importAdder.writeFixes(changes);
            }
        }
    }
    function tryGetConstraintFromDiagnosticMessage(messageText) {
        const [_, constraint] = flattenDiagnosticMessageText(messageText, "\n", 0).match(/`extends (.*)`/) || [];
        return constraint;
    }
    function tryGetConstraintType(checker, node) {
        if (isTypeNode(node.parent)) return checker.getTypeArgumentConstraint(node.parent);
        const contextualType = isExpression(node) ? checker.getContextualType(node) : void 0;
        return contextualType || checker.getTypeAtLocation(node);
    }
    var fixId17, errorCodes19;
    var init_fixAddMissingConstraint = __esm({
        "src/services/codefixes/fixAddMissingConstraint.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId17 = "addMissingConstraint";
            errorCodes19 = [
                // We want errors this could be attached to:
                // Diagnostics.This_type_parameter_probably_needs_an_extends_0_constraint
                Diagnostics.Type_0_is_not_comparable_to_type_1.code,
                Diagnostics.Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated.code,
                Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties.code,
                Diagnostics.Type_0_is_not_assignable_to_type_1.code,
                Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties.code,
                Diagnostics.Property_0_is_incompatible_with_index_signature.code,
                Diagnostics.Property_0_in_type_1_is_not_assignable_to_type_2.code,
                Diagnostics.Type_0_does_not_satisfy_the_constraint_1.code
            ];
            registerCodeFix({
                errorCodes: errorCodes19,
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: span , program: program , preferences: preferences , host: host  } = context;
                    const info = getInfo6(program, sourceFile, span);
                    if (info === void 0) return;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMissingConstraint(t, program, preferences, host, sourceFile, info));
                    return [
                        createCodeFixAction(fixId17, changes, Diagnostics.Add_extends_constraint, fixId17, Diagnostics.Add_extends_constraint_to_all_type_parameters)
                    ];
                },
                fixIds: [
                    fixId17
                ],
                getAllCodeActions: (context)=>{
                    const { program: program , preferences: preferences , host: host  } = context;
                    const seen = /* @__PURE__ */ new Map();
                    return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                        eachDiagnostic(context, errorCodes19, (diag2)=>{
                            const info = getInfo6(program, diag2.file, createTextSpan(diag2.start, diag2.length));
                            if (info) {
                                if (addToSeen(seen, getNodeId(info.declaration))) return addMissingConstraint(changes, program, preferences, host, diag2.file, info);
                            }
                            return void 0;
                        });
                    }));
                }
            });
        }
    });
    // src/services/codefixes/fixOverrideModifier.ts
    function dispatchChanges(changeTracker, context, errorCode, pos) {
        switch(errorCode){
            case Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0.code:
            case Diagnostics.This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code:
            case Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared_in_the_base_class_0.code:
            case Diagnostics.This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0.code:
            case Diagnostics.This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code:
                return doAddOverrideModifierChange(changeTracker, context.sourceFile, pos);
            case Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0.code:
            case Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0.code:
            case Diagnostics.This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another_class.code:
            case Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_extend_another_class.code:
                return doRemoveOverrideModifierChange(changeTracker, context.sourceFile, pos);
            default:
                Debug.fail("Unexpected error code: " + errorCode);
        }
    }
    function doAddOverrideModifierChange(changeTracker, sourceFile, pos) {
        const classElement = findContainerClassElementLike(sourceFile, pos);
        if (isSourceFileJS(sourceFile)) {
            changeTracker.addJSDocTags(sourceFile, classElement, [
                factory.createJSDocOverrideTag(factory.createIdentifier("override"))
            ]);
            return;
        }
        const modifiers = classElement.modifiers || emptyArray;
        const staticModifier = find(modifiers, isStaticModifier);
        const abstractModifier = find(modifiers, isAbstractModifier);
        const accessibilityModifier = find(modifiers, (m)=>isAccessibilityModifier(m.kind));
        const lastDecorator = findLast(modifiers, isDecorator);
        const modifierPos = abstractModifier ? abstractModifier.end : staticModifier ? staticModifier.end : accessibilityModifier ? accessibilityModifier.end : lastDecorator ? skipTrivia(sourceFile.text, lastDecorator.end) : classElement.getStart(sourceFile);
        const options = accessibilityModifier || staticModifier || abstractModifier ? {
            prefix: " "
        } : {
            suffix: " "
        };
        changeTracker.insertModifierAt(sourceFile, modifierPos, 163 /* OverrideKeyword */ , options);
    }
    function doRemoveOverrideModifierChange(changeTracker, sourceFile, pos) {
        const classElement = findContainerClassElementLike(sourceFile, pos);
        if (isSourceFileJS(sourceFile)) {
            changeTracker.filterJSDocTags(sourceFile, classElement, not(isJSDocOverrideTag));
            return;
        }
        const overrideModifier = find(classElement.modifiers, isOverrideModifier);
        Debug.assertIsDefined(overrideModifier);
        changeTracker.deleteModifier(sourceFile, overrideModifier);
    }
    function isClassElementLikeHasJSDoc(node) {
        switch(node.kind){
            case 175 /* Constructor */ :
            case 171 /* PropertyDeclaration */ :
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
                return true;
            case 168 /* Parameter */ :
                return isParameterPropertyDeclaration(node, node.parent);
            default:
                return false;
        }
    }
    function findContainerClassElementLike(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        const classElement = findAncestor(token, (node)=>{
            if (isClassLike(node)) return "quit";
            return isClassElementLikeHasJSDoc(node);
        });
        Debug.assert(classElement && isClassElementLikeHasJSDoc(classElement));
        return classElement;
    }
    var fixName, fixAddOverrideId, fixRemoveOverrideId, errorCodes20, errorCodeFixIdMap;
    var init_fixOverrideModifier = __esm({
        "src/services/codefixes/fixOverrideModifier.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixName = "fixOverrideModifier";
            fixAddOverrideId = "fixAddOverrideModifier";
            fixRemoveOverrideId = "fixRemoveOverrideModifier";
            errorCodes20 = [
                Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0.code,
                Diagnostics.This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another_class.code,
                Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared_in_the_base_class_0.code,
                Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0.code,
                Diagnostics.This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0.code,
                Diagnostics.This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code,
                Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_extend_another_class.code,
                Diagnostics.This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code,
                Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0.code
            ];
            errorCodeFixIdMap = {
                // case #1:
                [Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0.code]: {
                    descriptions: Diagnostics.Add_override_modifier,
                    fixId: fixAddOverrideId,
                    fixAllDescriptions: Diagnostics.Add_all_missing_override_modifiers
                },
                [Diagnostics.This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code]: {
                    descriptions: Diagnostics.Add_override_modifier,
                    fixId: fixAddOverrideId,
                    fixAllDescriptions: Diagnostics.Add_all_missing_override_modifiers
                },
                // case #2:
                [Diagnostics.This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another_class.code]: {
                    descriptions: Diagnostics.Remove_override_modifier,
                    fixId: fixRemoveOverrideId,
                    fixAllDescriptions: Diagnostics.Remove_all_unnecessary_override_modifiers
                },
                [Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_extend_another_class.code]: {
                    descriptions: Diagnostics.Remove_override_modifier,
                    fixId: fixRemoveOverrideId,
                    fixAllDescriptions: Diagnostics.Remove_override_modifier
                },
                // case #3:
                [Diagnostics.This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0.code]: {
                    descriptions: Diagnostics.Add_override_modifier,
                    fixId: fixAddOverrideId,
                    fixAllDescriptions: Diagnostics.Add_all_missing_override_modifiers
                },
                [Diagnostics.This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code]: {
                    descriptions: Diagnostics.Add_override_modifier,
                    fixId: fixAddOverrideId,
                    fixAllDescriptions: Diagnostics.Add_all_missing_override_modifiers
                },
                // case #4:
                [Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared_in_the_base_class_0.code]: {
                    descriptions: Diagnostics.Add_override_modifier,
                    fixId: fixAddOverrideId,
                    fixAllDescriptions: Diagnostics.Remove_all_unnecessary_override_modifiers
                },
                // case #5:
                [Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0.code]: {
                    descriptions: Diagnostics.Remove_override_modifier,
                    fixId: fixRemoveOverrideId,
                    fixAllDescriptions: Diagnostics.Remove_all_unnecessary_override_modifiers
                },
                [Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0.code]: {
                    descriptions: Diagnostics.Remove_override_modifier,
                    fixId: fixRemoveOverrideId,
                    fixAllDescriptions: Diagnostics.Remove_all_unnecessary_override_modifiers
                }
            };
            registerCodeFix({
                errorCodes: errorCodes20,
                getCodeActions: function getCodeActionsToFixOverrideModifierIssues(context) {
                    const { errorCode: errorCode , span: span  } = context;
                    const info = errorCodeFixIdMap[errorCode];
                    if (!info) return emptyArray;
                    const { descriptions: descriptions , fixId: fixId52 , fixAllDescriptions: fixAllDescriptions  } = info;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (changes2)=>dispatchChanges(changes2, context, errorCode, span.start));
                    return [
                        createCodeFixActionMaybeFixAll(fixName, changes, descriptions, fixId52, fixAllDescriptions)
                    ];
                },
                fixIds: [
                    fixName,
                    fixAddOverrideId,
                    fixRemoveOverrideId
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes20, (changes, diag2)=>{
                        const { code: code , start: start  } = diag2;
                        const info = errorCodeFixIdMap[code];
                        if (!info || info.fixId !== context.fixId) return;
                        dispatchChanges(changes, context, code, start);
                    })
            });
        }
    });
    // src/services/codefixes/fixNoPropertyAccessFromIndexSignature.ts
    function doChange14(changes, sourceFile, node, preferences) {
        const quotePreference = getQuotePreference(sourceFile, preferences);
        const argumentsExpression = factory.createStringLiteral(node.name.text, quotePreference === 0 /* Single */ );
        changes.replaceNode(sourceFile, node, isPropertyAccessChain(node) ? factory.createElementAccessChain(node.expression, node.questionDotToken, argumentsExpression) : factory.createElementAccessExpression(node.expression, argumentsExpression));
    }
    function getPropertyAccessExpression(sourceFile, pos) {
        return cast(getTokenAtPosition(sourceFile, pos).parent, isPropertyAccessExpression);
    }
    var fixId18, errorCodes21;
    var init_fixNoPropertyAccessFromIndexSignature = __esm({
        "src/services/codefixes/fixNoPropertyAccessFromIndexSignature.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId18 = "fixNoPropertyAccessFromIndexSignature";
            errorCodes21 = [
                Diagnostics.Property_0_comes_from_an_index_signature_so_it_must_be_accessed_with_0.code
            ];
            registerCodeFix({
                errorCodes: errorCodes21,
                fixIds: [
                    fixId18
                ],
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: span , preferences: preferences  } = context;
                    const property = getPropertyAccessExpression(sourceFile, span.start);
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange14(t, context.sourceFile, property, preferences));
                    return [
                        createCodeFixAction(fixId18, changes, [
                            Diagnostics.Use_element_access_for_0,
                            property.name.text
                        ], fixId18, Diagnostics.Use_element_access_for_all_undeclared_properties)
                    ];
                },
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes21, (changes, diag2)=>doChange14(changes, diag2.file, getPropertyAccessExpression(diag2.file, diag2.start), context.preferences))
            });
        }
    });
    // src/services/codefixes/fixImplicitThis.ts
    function doChange15(changes, sourceFile, pos, checker) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (!isThis(token)) return void 0;
        const fn = getThisContainer(token, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
        if (!isFunctionDeclaration(fn) && !isFunctionExpression(fn)) return void 0;
        if (!isSourceFile(getThisContainer(fn, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false))) {
            const fnKeyword = Debug.checkDefined(findChildOfKind(fn, 100 /* FunctionKeyword */ , sourceFile));
            const { name: name  } = fn;
            const body = Debug.checkDefined(fn.body);
            if (isFunctionExpression(fn)) {
                if (name && ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(name, checker, sourceFile, body)) return void 0;
                changes.delete(sourceFile, fnKeyword);
                if (name) changes.delete(sourceFile, name);
                changes.insertText(sourceFile, body.pos, " =>");
                return [
                    Diagnostics.Convert_function_expression_0_to_arrow_function,
                    name ? name.text : ANONYMOUS
                ];
            } else {
                changes.replaceNode(sourceFile, fnKeyword, factory.createToken(87 /* ConstKeyword */ ));
                changes.insertText(sourceFile, name.end, " = ");
                changes.insertText(sourceFile, body.pos, " =>");
                return [
                    Diagnostics.Convert_function_declaration_0_to_arrow_function,
                    name.text
                ];
            }
        }
    }
    var fixId19, errorCodes22;
    var init_fixImplicitThis = __esm({
        "src/services/codefixes/fixImplicitThis.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId19 = "fixImplicitThis";
            errorCodes22 = [
                Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation.code
            ];
            registerCodeFix({
                errorCodes: errorCodes22,
                getCodeActions: function getCodeActionsToFixImplicitThis(context) {
                    const { sourceFile: sourceFile , program: program , span: span  } = context;
                    let diagnostic;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
                        diagnostic = doChange15(t, sourceFile, span.start, program.getTypeChecker());
                    });
                    return diagnostic ? [
                        createCodeFixAction(fixId19, changes, diagnostic, fixId19, Diagnostics.Fix_all_implicit_this_errors)
                    ] : emptyArray;
                },
                fixIds: [
                    fixId19
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes22, (changes, diag2)=>{
                        doChange15(changes, diag2.file, diag2.start, context.program.getTypeChecker());
                    })
            });
        }
    });
    // src/services/codefixes/fixImportNonExportedMember.ts
    function getInfo7(sourceFile, pos, program) {
        var _a;
        const token = getTokenAtPosition(sourceFile, pos);
        if (isIdentifier(token)) {
            const importDeclaration = findAncestor(token, isImportDeclaration);
            if (importDeclaration === void 0) return void 0;
            const moduleSpecifier = isStringLiteral(importDeclaration.moduleSpecifier) ? importDeclaration.moduleSpecifier.text : void 0;
            if (moduleSpecifier === void 0) return void 0;
            const resolvedModule = getResolvedModule(sourceFile, moduleSpecifier, /*mode*/ void 0);
            if (resolvedModule === void 0) return void 0;
            const moduleSourceFile = program.getSourceFile(resolvedModule.resolvedFileName);
            if (moduleSourceFile === void 0 || isSourceFileFromLibrary(program, moduleSourceFile)) return void 0;
            const moduleSymbol = moduleSourceFile.symbol;
            const locals = (_a = tryCast(moduleSymbol.valueDeclaration, canHaveLocals)) == null ? void 0 : _a.locals;
            if (locals === void 0) return void 0;
            const localSymbol = locals.get(token.escapedText);
            if (localSymbol === void 0) return void 0;
            const node = getNodeOfSymbol(localSymbol);
            if (node === void 0) return void 0;
            const exportName = {
                node: token,
                isTypeOnly: isTypeDeclaration(node)
            };
            return {
                exportName: exportName,
                node: node,
                moduleSourceFile: moduleSourceFile,
                moduleSpecifier: moduleSpecifier
            };
        }
        return void 0;
    }
    function doChange16(changes, program, { exportName: exportName , node: node , moduleSourceFile: moduleSourceFile  }) {
        const exportDeclaration = tryGetExportDeclaration(moduleSourceFile, exportName.isTypeOnly);
        if (exportDeclaration) updateExport(changes, program, moduleSourceFile, exportDeclaration, [
            exportName
        ]);
        else if (canHaveExportModifier(node)) changes.insertExportModifier(moduleSourceFile, node);
        else createExport(changes, program, moduleSourceFile, [
            exportName
        ]);
    }
    function doChanges(changes, program, sourceFile, moduleExports, node) {
        if (length(moduleExports)) {
            if (node) updateExport(changes, program, sourceFile, node, moduleExports);
            else createExport(changes, program, sourceFile, moduleExports);
        }
    }
    function tryGetExportDeclaration(sourceFile, isTypeOnly) {
        const predicate = (node)=>isExportDeclaration(node) && (isTypeOnly && node.isTypeOnly || !node.isTypeOnly);
        return findLast(sourceFile.statements, predicate);
    }
    function updateExport(changes, program, sourceFile, node, names) {
        const namedExports = node.exportClause && isNamedExports(node.exportClause) ? node.exportClause.elements : factory.createNodeArray([]);
        const allowTypeModifier = !node.isTypeOnly && !!(getIsolatedModules(program.getCompilerOptions()) || find(namedExports, (e)=>e.isTypeOnly));
        changes.replaceNode(sourceFile, node, factory.updateExportDeclaration(node, node.modifiers, node.isTypeOnly, factory.createNamedExports(factory.createNodeArray([
            ...namedExports,
            ...createExportSpecifiers(names, allowTypeModifier)
        ], /*hasTrailingComma*/ namedExports.hasTrailingComma)), node.moduleSpecifier, node.assertClause));
    }
    function createExport(changes, program, sourceFile, names) {
        changes.insertNodeAtEndOfScope(sourceFile, sourceFile, factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports(createExportSpecifiers(names, /*allowTypeModifier*/ getIsolatedModules(program.getCompilerOptions()))), /*moduleSpecifier*/ void 0, /*assertClause*/ void 0));
    }
    function createExportSpecifiers(names, allowTypeModifier) {
        return factory.createNodeArray(map(names, (n)=>factory.createExportSpecifier(allowTypeModifier && n.isTypeOnly, /*propertyName*/ void 0, n.node)));
    }
    function getNodeOfSymbol(symbol) {
        if (symbol.valueDeclaration === void 0) return firstOrUndefined(symbol.declarations);
        const declaration = symbol.valueDeclaration;
        const variableStatement = isVariableDeclaration(declaration) ? tryCast(declaration.parent.parent, isVariableStatement) : void 0;
        return variableStatement && length(variableStatement.declarationList.declarations) === 1 ? variableStatement : declaration;
    }
    var fixId20, errorCodes23;
    var init_fixImportNonExportedMember = __esm({
        "src/services/codefixes/fixImportNonExportedMember.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId20 = "fixImportNonExportedMember";
            errorCodes23 = [
                Diagnostics.Module_0_declares_1_locally_but_it_is_not_exported.code
            ];
            registerCodeFix({
                errorCodes: errorCodes23,
                fixIds: [
                    fixId20
                ],
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: span , program: program  } = context;
                    const info = getInfo7(sourceFile, span.start, program);
                    if (info === void 0) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange16(t, program, info));
                    return [
                        createCodeFixAction(fixId20, changes, [
                            Diagnostics.Export_0_from_module_1,
                            info.exportName.node.text,
                            info.moduleSpecifier
                        ], fixId20, Diagnostics.Export_all_referenced_locals)
                    ];
                },
                getAllCodeActions (context) {
                    const { program: program  } = context;
                    return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                        const exports = /* @__PURE__ */ new Map();
                        eachDiagnostic(context, errorCodes23, (diag2)=>{
                            const info = getInfo7(diag2.file, diag2.start, program);
                            if (info === void 0) return void 0;
                            const { exportName: exportName , node: node , moduleSourceFile: moduleSourceFile  } = info;
                            if (tryGetExportDeclaration(moduleSourceFile, exportName.isTypeOnly) === void 0 && canHaveExportModifier(node)) changes.insertExportModifier(moduleSourceFile, node);
                            else {
                                const moduleExports = exports.get(moduleSourceFile) || {
                                    typeOnlyExports: [],
                                    exports: []
                                };
                                if (exportName.isTypeOnly) moduleExports.typeOnlyExports.push(exportName);
                                else moduleExports.exports.push(exportName);
                                exports.set(moduleSourceFile, moduleExports);
                            }
                        });
                        exports.forEach((moduleExports, moduleSourceFile)=>{
                            const exportDeclaration = tryGetExportDeclaration(moduleSourceFile, /*isTypeOnly*/ true);
                            if (exportDeclaration && exportDeclaration.isTypeOnly) {
                                doChanges(changes, program, moduleSourceFile, moduleExports.typeOnlyExports, exportDeclaration);
                                doChanges(changes, program, moduleSourceFile, moduleExports.exports, tryGetExportDeclaration(moduleSourceFile, /*isTypeOnly*/ false));
                            } else doChanges(changes, program, moduleSourceFile, [
                                ...moduleExports.exports,
                                ...moduleExports.typeOnlyExports
                            ], exportDeclaration);
                        });
                    }));
                }
            });
        }
    });
    // src/services/codefixes/fixIncorrectNamedTupleSyntax.ts
    function getNamedTupleMember(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        return findAncestor(token, (t)=>t.kind === 201 /* NamedTupleMember */ );
    }
    function doChange17(changes, sourceFile, namedTupleMember) {
        if (!namedTupleMember) return;
        let unwrappedType = namedTupleMember.type;
        let sawOptional = false;
        let sawRest = false;
        while(unwrappedType.kind === 189 /* OptionalType */  || unwrappedType.kind === 190 /* RestType */  || unwrappedType.kind === 195 /* ParenthesizedType */ ){
            if (unwrappedType.kind === 189 /* OptionalType */ ) sawOptional = true;
            else if (unwrappedType.kind === 190 /* RestType */ ) sawRest = true;
            unwrappedType = unwrappedType.type;
        }
        const updated = factory.updateNamedTupleMember(namedTupleMember, namedTupleMember.dotDotDotToken || (sawRest ? factory.createToken(26 /* DotDotDotToken */ ) : void 0), namedTupleMember.name, namedTupleMember.questionToken || (sawOptional ? factory.createToken(58 /* QuestionToken */ ) : void 0), unwrappedType);
        if (updated === namedTupleMember) return;
        changes.replaceNode(sourceFile, namedTupleMember, updated);
    }
    var fixId21, errorCodes24;
    var init_fixIncorrectNamedTupleSyntax = __esm({
        "src/services/codefixes/fixIncorrectNamedTupleSyntax.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId21 = "fixIncorrectNamedTupleSyntax";
            errorCodes24 = [
                Diagnostics.A_labeled_tuple_element_is_declared_as_optional_with_a_question_mark_after_the_name_and_before_the_colon_rather_than_after_the_type.code,
                Diagnostics.A_labeled_tuple_element_is_declared_as_rest_with_a_before_the_name_rather_than_before_the_type.code
            ];
            registerCodeFix({
                errorCodes: errorCodes24,
                getCodeActions: function getCodeActionsToFixIncorrectNamedTupleSyntax(context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const namedTupleMember = getNamedTupleMember(sourceFile, span.start);
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange17(t, sourceFile, namedTupleMember));
                    return [
                        createCodeFixAction(fixId21, changes, Diagnostics.Move_labeled_tuple_element_modifiers_to_labels, fixId21, Diagnostics.Move_labeled_tuple_element_modifiers_to_labels)
                    ];
                },
                fixIds: [
                    fixId21
                ]
            });
        }
    });
    // src/services/codefixes/fixSpelling.ts
    function getInfo8(sourceFile, pos, context, errorCode) {
        const node = getTokenAtPosition(sourceFile, pos);
        const parent2 = node.parent;
        if ((errorCode === Diagnostics.No_overload_matches_this_call.code || errorCode === Diagnostics.Type_0_is_not_assignable_to_type_1.code) && !isJsxAttribute(parent2)) return void 0;
        const checker = context.program.getTypeChecker();
        let suggestedSymbol;
        if (isPropertyAccessExpression(parent2) && parent2.name === node) {
            Debug.assert(isMemberName(node), "Expected an identifier for spelling (property access)");
            let containingType = checker.getTypeAtLocation(parent2.expression);
            if (parent2.flags & 32 /* OptionalChain */ ) containingType = checker.getNonNullableType(containingType);
            suggestedSymbol = checker.getSuggestedSymbolForNonexistentProperty(node, containingType);
        } else if (isBinaryExpression(parent2) && parent2.operatorToken.kind === 103 /* InKeyword */  && parent2.left === node && isPrivateIdentifier(node)) {
            const receiverType = checker.getTypeAtLocation(parent2.right);
            suggestedSymbol = checker.getSuggestedSymbolForNonexistentProperty(node, receiverType);
        } else if (isQualifiedName(parent2) && parent2.right === node) {
            const symbol = checker.getSymbolAtLocation(parent2.left);
            if (symbol && symbol.flags & 1536 /* Module */ ) suggestedSymbol = checker.getSuggestedSymbolForNonexistentModule(parent2.right, symbol);
        } else if (isImportSpecifier(parent2) && parent2.name === node) {
            Debug.assertNode(node, isIdentifier, "Expected an identifier for spelling (import)");
            const importDeclaration = findAncestor(node, isImportDeclaration);
            const resolvedSourceFile = getResolvedSourceFileFromImportDeclaration(sourceFile, context, importDeclaration);
            if (resolvedSourceFile && resolvedSourceFile.symbol) suggestedSymbol = checker.getSuggestedSymbolForNonexistentModule(node, resolvedSourceFile.symbol);
        } else if (isJsxAttribute(parent2) && parent2.name === node) {
            Debug.assertNode(node, isIdentifier, "Expected an identifier for JSX attribute");
            const tag = findAncestor(node, isJsxOpeningLikeElement);
            const props = checker.getContextualTypeForArgumentAtIndex(tag, 0);
            suggestedSymbol = checker.getSuggestedSymbolForNonexistentJSXAttribute(node, props);
        } else if (hasSyntacticModifier(parent2, 16384 /* Override */ ) && isClassElement(parent2) && parent2.name === node) {
            const baseDeclaration = findAncestor(node, isClassLike);
            const baseTypeNode = baseDeclaration ? getEffectiveBaseTypeNode(baseDeclaration) : void 0;
            const baseType = baseTypeNode ? checker.getTypeAtLocation(baseTypeNode) : void 0;
            if (baseType) suggestedSymbol = checker.getSuggestedSymbolForNonexistentClassMember(getTextOfNode(node), baseType);
        } else {
            const meaning = getMeaningFromLocation(node);
            const name = getTextOfNode(node);
            Debug.assert(name !== void 0, "name should be defined");
            suggestedSymbol = checker.getSuggestedSymbolForNonexistentSymbol(node, name, convertSemanticMeaningToSymbolFlags(meaning));
        }
        return suggestedSymbol === void 0 ? void 0 : {
            node: node,
            suggestedSymbol: suggestedSymbol
        };
    }
    function doChange18(changes, sourceFile, node, suggestedSymbol, target) {
        const suggestion = symbolName(suggestedSymbol);
        if (!isIdentifierText(suggestion, target) && isPropertyAccessExpression(node.parent)) {
            const valDecl = suggestedSymbol.valueDeclaration;
            if (valDecl && isNamedDeclaration(valDecl) && isPrivateIdentifier(valDecl.name)) changes.replaceNode(sourceFile, node, factory.createIdentifier(suggestion));
            else changes.replaceNode(sourceFile, node.parent, factory.createElementAccessExpression(node.parent.expression, factory.createStringLiteral(suggestion)));
        } else changes.replaceNode(sourceFile, node, factory.createIdentifier(suggestion));
    }
    function convertSemanticMeaningToSymbolFlags(meaning) {
        let flags = 0;
        if (meaning & 4 /* Namespace */ ) flags |= 1920 /* Namespace */ ;
        if (meaning & 2 /* Type */ ) flags |= 788968 /* Type */ ;
        if (meaning & 1 /* Value */ ) flags |= 111551 /* Value */ ;
        return flags;
    }
    function getResolvedSourceFileFromImportDeclaration(sourceFile, context, importDeclaration) {
        if (!importDeclaration || !isStringLiteralLike(importDeclaration.moduleSpecifier)) return void 0;
        const resolvedModule = getResolvedModule(sourceFile, importDeclaration.moduleSpecifier.text, getModeForUsageLocation(sourceFile, importDeclaration.moduleSpecifier));
        if (!resolvedModule) return void 0;
        return context.program.getSourceFile(resolvedModule.resolvedFileName);
    }
    var fixId22, errorCodes25;
    var init_fixSpelling = __esm({
        "src/services/codefixes/fixSpelling.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId22 = "fixSpelling";
            errorCodes25 = [
                Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2.code,
                Diagnostics.Property_0_may_not_exist_on_type_1_Did_you_mean_2.code,
                Diagnostics.Cannot_find_name_0_Did_you_mean_1.code,
                Diagnostics.Could_not_find_name_0_Did_you_mean_1.code,
                Diagnostics.Cannot_find_namespace_0_Did_you_mean_1.code,
                Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0.code,
                Diagnostics.Cannot_find_name_0_Did_you_mean_the_static_member_1_0.code,
                Diagnostics._0_has_no_exported_member_named_1_Did_you_mean_2.code,
                Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1.code,
                Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1.code,
                // for JSX class components
                Diagnostics.No_overload_matches_this_call.code,
                // for JSX FC
                Diagnostics.Type_0_is_not_assignable_to_type_1.code
            ];
            registerCodeFix({
                errorCodes: errorCodes25,
                getCodeActions (context) {
                    const { sourceFile: sourceFile , errorCode: errorCode  } = context;
                    const info = getInfo8(sourceFile, context.span.start, context, errorCode);
                    if (!info) return void 0;
                    const { node: node , suggestedSymbol: suggestedSymbol  } = info;
                    const target = getEmitScriptTarget(context.host.getCompilationSettings());
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange18(t, sourceFile, node, suggestedSymbol, target));
                    return [
                        createCodeFixAction("spelling", changes, [
                            Diagnostics.Change_spelling_to_0,
                            symbolName(suggestedSymbol)
                        ], fixId22, Diagnostics.Fix_all_detected_spelling_errors)
                    ];
                },
                fixIds: [
                    fixId22
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes25, (changes, diag2)=>{
                        const info = getInfo8(diag2.file, diag2.start, context, diag2.code);
                        const target = getEmitScriptTarget(context.host.getCompilationSettings());
                        if (info) doChange18(changes, context.sourceFile, info.node, info.suggestedSymbol, target);
                    })
            });
        }
    });
    // src/services/codefixes/returnValueCorrect.ts
    function createObjectTypeFromLabeledExpression(checker, label, expression) {
        const member = checker.createSymbol(4 /* Property */ , label.escapedText);
        member.links.type = checker.getTypeAtLocation(expression);
        const members = createSymbolTable([
            member
        ]);
        return checker.createAnonymousType(/*symbol*/ void 0, members, [], [], []);
    }
    function getFixInfo(checker, declaration, expectType, isFunctionType) {
        if (!declaration.body || !isBlock(declaration.body) || length(declaration.body.statements) !== 1) return void 0;
        const firstStatement = first(declaration.body.statements);
        if (isExpressionStatement(firstStatement) && checkFixedAssignableTo(checker, declaration, checker.getTypeAtLocation(firstStatement.expression), expectType, isFunctionType)) return {
            declaration: declaration,
            kind: 0 /* MissingReturnStatement */ ,
            expression: firstStatement.expression,
            statement: firstStatement,
            commentSource: firstStatement.expression
        };
        else if (isLabeledStatement(firstStatement) && isExpressionStatement(firstStatement.statement)) {
            const node = factory.createObjectLiteralExpression([
                factory.createPropertyAssignment(firstStatement.label, firstStatement.statement.expression)
            ]);
            const nodeType = createObjectTypeFromLabeledExpression(checker, firstStatement.label, firstStatement.statement.expression);
            if (checkFixedAssignableTo(checker, declaration, nodeType, expectType, isFunctionType)) return isArrowFunction(declaration) ? {
                declaration: declaration,
                kind: 1 /* MissingParentheses */ ,
                expression: node,
                statement: firstStatement,
                commentSource: firstStatement.statement.expression
            } : {
                declaration: declaration,
                kind: 0 /* MissingReturnStatement */ ,
                expression: node,
                statement: firstStatement,
                commentSource: firstStatement.statement.expression
            };
        } else if (isBlock(firstStatement) && length(firstStatement.statements) === 1) {
            const firstBlockStatement = first(firstStatement.statements);
            if (isLabeledStatement(firstBlockStatement) && isExpressionStatement(firstBlockStatement.statement)) {
                const node = factory.createObjectLiteralExpression([
                    factory.createPropertyAssignment(firstBlockStatement.label, firstBlockStatement.statement.expression)
                ]);
                const nodeType = createObjectTypeFromLabeledExpression(checker, firstBlockStatement.label, firstBlockStatement.statement.expression);
                if (checkFixedAssignableTo(checker, declaration, nodeType, expectType, isFunctionType)) return {
                    declaration: declaration,
                    kind: 0 /* MissingReturnStatement */ ,
                    expression: node,
                    statement: firstStatement,
                    commentSource: firstBlockStatement
                };
            }
        }
        return void 0;
    }
    function checkFixedAssignableTo(checker, declaration, exprType, type, isFunctionType) {
        if (isFunctionType) {
            const sig = checker.getSignatureFromDeclaration(declaration);
            if (sig) {
                if (hasSyntacticModifier(declaration, 512 /* Async */ )) exprType = checker.createPromiseType(exprType);
                const newSig = checker.createSignature(declaration, sig.typeParameters, sig.thisParameter, sig.parameters, exprType, /*typePredicate*/ void 0, sig.minArgumentCount, sig.flags);
                exprType = checker.createAnonymousType(/*symbol*/ void 0, createSymbolTable(), [
                    newSig
                ], [], []);
            } else exprType = checker.getAnyType();
        }
        return checker.isTypeAssignableTo(exprType, type);
    }
    function getInfo9(checker, sourceFile, position, errorCode) {
        const node = getTokenAtPosition(sourceFile, position);
        if (!node.parent) return void 0;
        const declaration = findAncestor(node.parent, isFunctionLikeDeclaration);
        switch(errorCode){
            case Diagnostics.A_function_whose_declared_type_is_neither_undefined_void_nor_any_must_return_a_value.code:
                if (!declaration || !declaration.body || !declaration.type || !rangeContainsRange(declaration.type, node)) return void 0;
                return getFixInfo(checker, declaration, checker.getTypeFromTypeNode(declaration.type), /*isFunctionType*/ false);
            case Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code:
                if (!declaration || !isCallExpression(declaration.parent) || !declaration.body) return void 0;
                const pos = declaration.parent.arguments.indexOf(declaration);
                const type = checker.getContextualTypeForArgumentAtIndex(declaration.parent, pos);
                if (!type) return void 0;
                return getFixInfo(checker, declaration, type, /*isFunctionType*/ true);
            case Diagnostics.Type_0_is_not_assignable_to_type_1.code:
                if (!isDeclarationName(node) || !isVariableLike(node.parent) && !isJsxAttribute(node.parent)) return void 0;
                const initializer = getVariableLikeInitializer(node.parent);
                if (!initializer || !isFunctionLikeDeclaration(initializer) || !initializer.body) return void 0;
                return getFixInfo(checker, initializer, checker.getTypeAtLocation(node.parent), /*isFunctionType*/ true);
        }
        return void 0;
    }
    function getVariableLikeInitializer(declaration) {
        switch(declaration.kind){
            case 259 /* VariableDeclaration */ :
            case 168 /* Parameter */ :
            case 207 /* BindingElement */ :
            case 171 /* PropertyDeclaration */ :
            case 302 /* PropertyAssignment */ :
                return declaration.initializer;
            case 290 /* JsxAttribute */ :
                return declaration.initializer && (isJsxExpression(declaration.initializer) ? declaration.initializer.expression : void 0);
            case 303 /* ShorthandPropertyAssignment */ :
            case 170 /* PropertySignature */ :
            case 305 /* EnumMember */ :
            case 354 /* JSDocPropertyTag */ :
            case 347 /* JSDocParameterTag */ :
                return void 0;
        }
    }
    function addReturnStatement(changes, sourceFile, expression, statement) {
        suppressLeadingAndTrailingTrivia(expression);
        const probablyNeedSemi = probablyUsesSemicolons(sourceFile);
        changes.replaceNode(sourceFile, statement, factory.createReturnStatement(expression), {
            leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
            trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Exclude,
            suffix: probablyNeedSemi ? ";" : void 0
        });
    }
    function removeBlockBodyBrace(changes, sourceFile, declaration, expression, commentSource, withParen) {
        const newBody = withParen || needsParentheses(expression) ? factory.createParenthesizedExpression(expression) : expression;
        suppressLeadingAndTrailingTrivia(commentSource);
        copyComments(commentSource, newBody);
        changes.replaceNode(sourceFile, declaration.body, newBody);
    }
    function wrapBlockWithParen(changes, sourceFile, declaration, expression) {
        changes.replaceNode(sourceFile, declaration.body, factory.createParenthesizedExpression(expression));
    }
    function getActionForfixAddReturnStatement(context, expression, statement) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addReturnStatement(t, context.sourceFile, expression, statement));
        return createCodeFixAction(fixId23, changes, Diagnostics.Add_a_return_statement, fixIdAddReturnStatement, Diagnostics.Add_all_missing_return_statement);
    }
    function getActionForFixRemoveBracesFromArrowFunctionBody(context, declaration, expression, commentSource) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>removeBlockBodyBrace(t, context.sourceFile, declaration, expression, commentSource, /*withParen*/ false));
        return createCodeFixAction(fixId23, changes, Diagnostics.Remove_braces_from_arrow_function_body, fixRemoveBracesFromArrowFunctionBody, Diagnostics.Remove_braces_from_all_arrow_function_bodies_with_relevant_issues);
    }
    function getActionForfixWrapTheBlockWithParen(context, declaration, expression) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>wrapBlockWithParen(t, context.sourceFile, declaration, expression));
        return createCodeFixAction(fixId23, changes, Diagnostics.Wrap_the_following_body_with_parentheses_which_should_be_an_object_literal, fixIdWrapTheBlockWithParen, Diagnostics.Wrap_all_object_literal_with_parentheses);
    }
    var fixId23, fixIdAddReturnStatement, fixRemoveBracesFromArrowFunctionBody, fixIdWrapTheBlockWithParen, errorCodes26;
    var init_returnValueCorrect = __esm({
        "src/services/codefixes/returnValueCorrect.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId23 = "returnValueCorrect";
            fixIdAddReturnStatement = "fixAddReturnStatement";
            fixRemoveBracesFromArrowFunctionBody = "fixRemoveBracesFromArrowFunctionBody";
            fixIdWrapTheBlockWithParen = "fixWrapTheBlockWithParen";
            errorCodes26 = [
                Diagnostics.A_function_whose_declared_type_is_neither_undefined_void_nor_any_must_return_a_value.code,
                Diagnostics.Type_0_is_not_assignable_to_type_1.code,
                Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code
            ];
            registerCodeFix({
                errorCodes: errorCodes26,
                fixIds: [
                    fixIdAddReturnStatement,
                    fixRemoveBracesFromArrowFunctionBody,
                    fixIdWrapTheBlockWithParen
                ],
                getCodeActions: function getCodeActionsToCorrectReturnValue(context) {
                    const { program: program , sourceFile: sourceFile , span: { start: start  } , errorCode: errorCode  } = context;
                    const info = getInfo9(program.getTypeChecker(), sourceFile, start, errorCode);
                    if (!info) return void 0;
                    if (info.kind === 0 /* MissingReturnStatement */ ) return append([
                        getActionForfixAddReturnStatement(context, info.expression, info.statement)
                    ], isArrowFunction(info.declaration) ? getActionForFixRemoveBracesFromArrowFunctionBody(context, info.declaration, info.expression, info.commentSource) : void 0);
                    else return [
                        getActionForfixWrapTheBlockWithParen(context, info.declaration, info.expression)
                    ];
                },
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes26, (changes, diag2)=>{
                        const info = getInfo9(context.program.getTypeChecker(), diag2.file, diag2.start, diag2.code);
                        if (!info) return void 0;
                        switch(context.fixId){
                            case fixIdAddReturnStatement:
                                addReturnStatement(changes, diag2.file, info.expression, info.statement);
                                break;
                            case fixRemoveBracesFromArrowFunctionBody:
                                if (!isArrowFunction(info.declaration)) return void 0;
                                removeBlockBodyBrace(changes, diag2.file, info.declaration, info.expression, info.commentSource, /*withParen*/ false);
                                break;
                            case fixIdWrapTheBlockWithParen:
                                if (!isArrowFunction(info.declaration)) return void 0;
                                wrapBlockWithParen(changes, diag2.file, info.declaration, info.expression);
                                break;
                            default:
                                Debug.fail(JSON.stringify(context.fixId));
                        }
                    })
            });
        }
    });
    // src/services/codefixes/fixAddMissingMember.ts
    function getInfo10(sourceFile, tokenPos, errorCode, checker, program) {
        var _a;
        const token = getTokenAtPosition(sourceFile, tokenPos);
        const parent2 = token.parent;
        if (errorCode === Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code) {
            if (!(token.kind === 19 /* OpenBraceToken */  && isObjectLiteralExpression(parent2) && isCallExpression(parent2.parent))) return void 0;
            const argIndex = findIndex(parent2.parent.arguments, (arg)=>arg === parent2);
            if (argIndex < 0) return void 0;
            const signature = checker.getResolvedSignature(parent2.parent);
            if (!(signature && signature.declaration && signature.parameters[argIndex])) return void 0;
            const param = signature.parameters[argIndex].valueDeclaration;
            if (!(param && isParameter(param) && isIdentifier(param.name))) return void 0;
            const properties = arrayFrom(checker.getUnmatchedProperties(checker.getTypeAtLocation(parent2), checker.getParameterType(signature, argIndex), /*requireOptionalProperties*/ false, /*matchDiscriminantProperties*/ false));
            if (!length(properties)) return void 0;
            return {
                kind: 3 /* ObjectLiteral */ ,
                token: param.name,
                properties: properties,
                parentDeclaration: parent2
            };
        }
        if (!isMemberName(token)) return void 0;
        if (isIdentifier(token) && hasInitializer(parent2) && parent2.initializer && isObjectLiteralExpression(parent2.initializer)) {
            const targetType = checker.getContextualType(token) || checker.getTypeAtLocation(token);
            const properties = arrayFrom(checker.getUnmatchedProperties(checker.getTypeAtLocation(parent2.initializer), targetType, /*requireOptionalProperties*/ false, /*matchDiscriminantProperties*/ false));
            if (!length(properties)) return void 0;
            return {
                kind: 3 /* ObjectLiteral */ ,
                token: token,
                properties: properties,
                parentDeclaration: parent2.initializer
            };
        }
        if (isIdentifier(token) && isJsxOpeningLikeElement(token.parent)) {
            const target = getEmitScriptTarget(program.getCompilerOptions());
            const attributes = getUnmatchedAttributes(checker, target, token.parent);
            if (!length(attributes)) return void 0;
            return {
                kind: 4 /* JsxAttributes */ ,
                token: token,
                attributes: attributes,
                parentDeclaration: token.parent
            };
        }
        if (isIdentifier(token)) {
            const type = (_a = checker.getContextualType(token)) == null ? void 0 : _a.getNonNullableType();
            if (type && getObjectFlags(type) & 16 /* Anonymous */ ) {
                const signature = firstOrUndefined(checker.getSignaturesOfType(type, 0 /* Call */ ));
                if (signature === void 0) return void 0;
                return {
                    kind: 5 /* Signature */ ,
                    token: token,
                    signature: signature,
                    sourceFile: sourceFile,
                    parentDeclaration: findScope(token)
                };
            }
            if (isCallExpression(parent2) && parent2.expression === token) return {
                kind: 2 /* Function */ ,
                token: token,
                call: parent2,
                sourceFile: sourceFile,
                modifierFlags: 0 /* None */ ,
                parentDeclaration: findScope(token)
            };
        }
        if (!isPropertyAccessExpression(parent2)) return void 0;
        const leftExpressionType = skipConstraint(checker.getTypeAtLocation(parent2.expression));
        const symbol = leftExpressionType.symbol;
        if (!symbol || !symbol.declarations) return void 0;
        if (isIdentifier(token) && isCallExpression(parent2.parent)) {
            const moduleDeclaration = find(symbol.declarations, isModuleDeclaration);
            const moduleDeclarationSourceFile = moduleDeclaration == null ? void 0 : moduleDeclaration.getSourceFile();
            if (moduleDeclaration && moduleDeclarationSourceFile && !isSourceFileFromLibrary(program, moduleDeclarationSourceFile)) return {
                kind: 2 /* Function */ ,
                token: token,
                call: parent2.parent,
                sourceFile: sourceFile,
                modifierFlags: 1 /* Export */ ,
                parentDeclaration: moduleDeclaration
            };
            const moduleSourceFile = find(symbol.declarations, isSourceFile);
            if (sourceFile.commonJsModuleIndicator) return void 0;
            if (moduleSourceFile && !isSourceFileFromLibrary(program, moduleSourceFile)) return {
                kind: 2 /* Function */ ,
                token: token,
                call: parent2.parent,
                sourceFile: moduleSourceFile,
                modifierFlags: 1 /* Export */ ,
                parentDeclaration: moduleSourceFile
            };
        }
        const classDeclaration = find(symbol.declarations, isClassLike);
        if (!classDeclaration && isPrivateIdentifier(token)) return void 0;
        const declaration = classDeclaration || find(symbol.declarations, (d)=>isInterfaceDeclaration(d) || isTypeLiteralNode(d));
        if (declaration && !isSourceFileFromLibrary(program, declaration.getSourceFile())) {
            const makeStatic = !isTypeLiteralNode(declaration) && (leftExpressionType.target || leftExpressionType) !== checker.getDeclaredTypeOfSymbol(symbol);
            if (makeStatic && (isPrivateIdentifier(token) || isInterfaceDeclaration(declaration))) return void 0;
            const declSourceFile = declaration.getSourceFile();
            const modifierFlags = isTypeLiteralNode(declaration) ? 0 /* None */  : (makeStatic ? 32 /* Static */  : 0 /* None */ ) | (startsWithUnderscore(token.text) ? 8 /* Private */  : 0 /* None */ );
            const isJSFile = isSourceFileJS(declSourceFile);
            const call = tryCast(parent2.parent, isCallExpression);
            return {
                kind: 0 /* TypeLikeDeclaration */ ,
                token: token,
                call: call,
                modifierFlags: modifierFlags,
                parentDeclaration: declaration,
                declSourceFile: declSourceFile,
                isJSFile: isJSFile
            };
        }
        const enumDeclaration = find(symbol.declarations, isEnumDeclaration);
        if (enumDeclaration && !(leftExpressionType.flags & 1056 /* EnumLike */ ) && !isPrivateIdentifier(token) && !isSourceFileFromLibrary(program, enumDeclaration.getSourceFile())) return {
            kind: 1 /* Enum */ ,
            token: token,
            parentDeclaration: enumDeclaration
        };
        return void 0;
    }
    function getActionsForMissingMemberDeclaration(context, info) {
        return info.isJSFile ? singleElementArray(createActionForAddMissingMemberInJavascriptFile(context, info)) : createActionsForAddMissingMemberInTypeScriptFile(context, info);
    }
    function createActionForAddMissingMemberInJavascriptFile(context, { parentDeclaration: parentDeclaration , declSourceFile: declSourceFile , modifierFlags: modifierFlags , token: token  }) {
        if (isInterfaceDeclaration(parentDeclaration) || isTypeLiteralNode(parentDeclaration)) return void 0;
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMissingMemberInJs(t, declSourceFile, parentDeclaration, token, !!(modifierFlags & 32 /* Static */ )));
        if (changes.length === 0) return void 0;
        const diagnostic = modifierFlags & 32 /* Static */  ? Diagnostics.Initialize_static_property_0 : isPrivateIdentifier(token) ? Diagnostics.Declare_a_private_field_named_0 : Diagnostics.Initialize_property_0_in_the_constructor;
        return createCodeFixAction(fixMissingMember, changes, [
            diagnostic,
            token.text
        ], fixMissingMember, Diagnostics.Add_all_missing_members);
    }
    function addMissingMemberInJs(changeTracker, sourceFile, classDeclaration, token, makeStatic) {
        const tokenName = token.text;
        if (makeStatic) {
            if (classDeclaration.kind === 230 /* ClassExpression */ ) return;
            const className = classDeclaration.name.getText();
            const staticInitialization = initializePropertyToUndefined(factory.createIdentifier(className), tokenName);
            changeTracker.insertNodeAfter(sourceFile, classDeclaration, staticInitialization);
        } else if (isPrivateIdentifier(token)) {
            const property = factory.createPropertyDeclaration(/*modifiers*/ void 0, tokenName, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
            const lastProp = getNodeToInsertPropertyAfter(classDeclaration);
            if (lastProp) changeTracker.insertNodeAfter(sourceFile, lastProp, property);
            else changeTracker.insertMemberAtStart(sourceFile, classDeclaration, property);
        } else {
            const classConstructor = getFirstConstructorWithBody(classDeclaration);
            if (!classConstructor) return;
            const propertyInitialization = initializePropertyToUndefined(factory.createThis(), tokenName);
            changeTracker.insertNodeAtConstructorEnd(sourceFile, classConstructor, propertyInitialization);
        }
    }
    function initializePropertyToUndefined(obj, propertyName) {
        return factory.createExpressionStatement(factory.createAssignment(factory.createPropertyAccessExpression(obj, propertyName), createUndefined()));
    }
    function createActionsForAddMissingMemberInTypeScriptFile(context, { parentDeclaration: parentDeclaration , declSourceFile: declSourceFile , modifierFlags: modifierFlags , token: token  }) {
        const memberName = token.text;
        const isStatic2 = modifierFlags & 32 /* Static */ ;
        const typeNode = getTypeNode2(context.program.getTypeChecker(), parentDeclaration, token);
        const addPropertyDeclarationChanges = (modifierFlags2)=>ts_textChanges_exports.ChangeTracker.with(context, (t)=>addPropertyDeclaration(t, declSourceFile, parentDeclaration, memberName, typeNode, modifierFlags2));
        const actions2 = [
            createCodeFixAction(fixMissingMember, addPropertyDeclarationChanges(modifierFlags & 32 /* Static */ ), [
                isStatic2 ? Diagnostics.Declare_static_property_0 : Diagnostics.Declare_property_0,
                memberName
            ], fixMissingMember, Diagnostics.Add_all_missing_members)
        ];
        if (isStatic2 || isPrivateIdentifier(token)) return actions2;
        if (modifierFlags & 8 /* Private */ ) actions2.unshift(createCodeFixActionWithoutFixAll(fixMissingMember, addPropertyDeclarationChanges(8 /* Private */ ), [
            Diagnostics.Declare_private_property_0,
            memberName
        ]));
        actions2.push(createAddIndexSignatureAction(context, declSourceFile, parentDeclaration, token.text, typeNode));
        return actions2;
    }
    function getTypeNode2(checker, node, token) {
        let typeNode;
        if (token.parent.parent.kind === 225 /* BinaryExpression */ ) {
            const binaryExpression = token.parent.parent;
            const otherExpression = token.parent === binaryExpression.left ? binaryExpression.right : binaryExpression.left;
            const widenedType = checker.getWidenedType(checker.getBaseTypeOfLiteralType(checker.getTypeAtLocation(otherExpression)));
            typeNode = checker.typeToTypeNode(widenedType, node, 1 /* NoTruncation */ );
        } else {
            const contextualType = checker.getContextualType(token.parent);
            typeNode = contextualType ? checker.typeToTypeNode(contextualType, /*enclosingDeclaration*/ void 0, 1 /* NoTruncation */ ) : void 0;
        }
        return typeNode || factory.createKeywordTypeNode(133 /* AnyKeyword */ );
    }
    function addPropertyDeclaration(changeTracker, sourceFile, node, tokenName, typeNode, modifierFlags) {
        const modifiers = modifierFlags ? factory.createNodeArray(factory.createModifiersFromModifierFlags(modifierFlags)) : void 0;
        const property = isClassLike(node) ? factory.createPropertyDeclaration(modifiers, tokenName, /*questionOrExclamationToken*/ void 0, typeNode, /*initializer*/ void 0) : factory.createPropertySignature(/*modifiers*/ void 0, tokenName, /*questionToken*/ void 0, typeNode);
        const lastProp = getNodeToInsertPropertyAfter(node);
        if (lastProp) changeTracker.insertNodeAfter(sourceFile, lastProp, property);
        else changeTracker.insertMemberAtStart(sourceFile, node, property);
    }
    function getNodeToInsertPropertyAfter(node) {
        let res;
        for (const member of node.members){
            if (!isPropertyDeclaration(member)) break;
            res = member;
        }
        return res;
    }
    function createAddIndexSignatureAction(context, sourceFile, node, tokenName, typeNode) {
        const stringTypeNode = factory.createKeywordTypeNode(154 /* StringKeyword */ );
        const indexingParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "x", /*questionToken*/ void 0, stringTypeNode, /*initializer*/ void 0);
        const indexSignature = factory.createIndexSignature(/*modifiers*/ void 0, [
            indexingParameter
        ], typeNode);
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.insertMemberAtStart(sourceFile, node, indexSignature));
        return createCodeFixActionWithoutFixAll(fixMissingMember, changes, [
            Diagnostics.Add_index_signature_for_property_0,
            tokenName
        ]);
    }
    function getActionsForMissingMethodDeclaration(context, info) {
        const { parentDeclaration: parentDeclaration , declSourceFile: declSourceFile , modifierFlags: modifierFlags , token: token , call: call  } = info;
        if (call === void 0) return void 0;
        if (isPrivateIdentifier(token)) return void 0;
        const methodName = token.text;
        const addMethodDeclarationChanges = (modifierFlags2)=>ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMethodDeclaration(context, t, call, token, modifierFlags2, parentDeclaration, declSourceFile));
        const actions2 = [
            createCodeFixAction(fixMissingMember, addMethodDeclarationChanges(modifierFlags & 32 /* Static */ ), [
                modifierFlags & 32 /* Static */  ? Diagnostics.Declare_static_method_0 : Diagnostics.Declare_method_0,
                methodName
            ], fixMissingMember, Diagnostics.Add_all_missing_members)
        ];
        if (modifierFlags & 8 /* Private */ ) actions2.unshift(createCodeFixActionWithoutFixAll(fixMissingMember, addMethodDeclarationChanges(8 /* Private */ ), [
            Diagnostics.Declare_private_method_0,
            methodName
        ]));
        return actions2;
    }
    function addMethodDeclaration(context, changes, callExpression, name, modifierFlags, parentDeclaration, sourceFile) {
        const importAdder = createImportAdder(sourceFile, context.program, context.preferences, context.host);
        const kind = isClassLike(parentDeclaration) ? 173 /* MethodDeclaration */  : 172 /* MethodSignature */ ;
        const signatureDeclaration = createSignatureDeclarationFromCallExpression(kind, context, importAdder, callExpression, name, modifierFlags, parentDeclaration);
        const containingMethodDeclaration = tryGetContainingMethodDeclaration(parentDeclaration, callExpression);
        if (containingMethodDeclaration) changes.insertNodeAfter(sourceFile, containingMethodDeclaration, signatureDeclaration);
        else changes.insertMemberAtStart(sourceFile, parentDeclaration, signatureDeclaration);
        importAdder.writeFixes(changes);
    }
    function addEnumMemberDeclaration(changes, checker, { token: token , parentDeclaration: parentDeclaration  }) {
        const hasStringInitializer = some(parentDeclaration.members, (member)=>{
            const type = checker.getTypeAtLocation(member);
            return !!(type && type.flags & 402653316 /* StringLike */ );
        });
        const enumMember = factory.createEnumMember(token, hasStringInitializer ? factory.createStringLiteral(token.text) : void 0);
        changes.replaceNode(parentDeclaration.getSourceFile(), parentDeclaration, factory.updateEnumDeclaration(parentDeclaration, parentDeclaration.modifiers, parentDeclaration.name, concatenate(parentDeclaration.members, singleElementArray(enumMember))), {
            leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.IncludeAll,
            trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Exclude
        });
    }
    function addFunctionDeclaration(changes, context, info) {
        const quotePreference = getQuotePreference(context.sourceFile, context.preferences);
        const importAdder = createImportAdder(context.sourceFile, context.program, context.preferences, context.host);
        const functionDeclaration = info.kind === 2 /* Function */  ? createSignatureDeclarationFromCallExpression(261 /* FunctionDeclaration */ , context, importAdder, info.call, idText(info.token), info.modifierFlags, info.parentDeclaration) : createSignatureDeclarationFromSignature(261 /* FunctionDeclaration */ , context, quotePreference, info.signature, createStubbedBody(Diagnostics.Function_not_implemented.message, quotePreference), info.token, /*modifiers*/ void 0, /*optional*/ void 0, /*enclosingDeclaration*/ void 0, importAdder);
        if (functionDeclaration === void 0) Debug.fail("fixMissingFunctionDeclaration codefix got unexpected error.");
        isReturnStatement(info.parentDeclaration) ? changes.insertNodeBefore(info.sourceFile, info.parentDeclaration, functionDeclaration, /*blankLineBetween*/ true) : changes.insertNodeAtEndOfScope(info.sourceFile, info.parentDeclaration, functionDeclaration);
        importAdder.writeFixes(changes);
    }
    function addJsxAttributes(changes, context, info) {
        const importAdder = createImportAdder(context.sourceFile, context.program, context.preferences, context.host);
        const quotePreference = getQuotePreference(context.sourceFile, context.preferences);
        const checker = context.program.getTypeChecker();
        const jsxAttributesNode = info.parentDeclaration.attributes;
        const hasSpreadAttribute = some(jsxAttributesNode.properties, isJsxSpreadAttribute);
        const attrs = map(info.attributes, (attr)=>{
            const value1 = tryGetValueFromType(context, checker, importAdder, quotePreference, checker.getTypeOfSymbol(attr), info.parentDeclaration);
            const name = factory.createIdentifier(attr.name);
            const jsxAttribute = factory.createJsxAttribute(name, factory.createJsxExpression(/*dotDotDotToken*/ void 0, value1));
            setParent(name, jsxAttribute);
            return jsxAttribute;
        });
        const jsxAttributes = factory.createJsxAttributes(hasSpreadAttribute ? [
            ...attrs,
            ...jsxAttributesNode.properties
        ] : [
            ...jsxAttributesNode.properties,
            ...attrs
        ]);
        const options = {
            prefix: jsxAttributesNode.pos === jsxAttributesNode.end ? " " : void 0
        };
        changes.replaceNode(context.sourceFile, jsxAttributesNode, jsxAttributes, options);
        importAdder.writeFixes(changes);
    }
    function addObjectLiteralProperties(changes, context, info) {
        const importAdder = createImportAdder(context.sourceFile, context.program, context.preferences, context.host);
        const quotePreference = getQuotePreference(context.sourceFile, context.preferences);
        const target = getEmitScriptTarget(context.program.getCompilerOptions());
        const checker = context.program.getTypeChecker();
        const props = map(info.properties, (prop)=>{
            const initializer = tryGetValueFromType(context, checker, importAdder, quotePreference, checker.getTypeOfSymbol(prop), info.parentDeclaration);
            return factory.createPropertyAssignment(createPropertyNameFromSymbol(prop, target, quotePreference, checker), initializer);
        });
        const options = {
            leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
            trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Exclude,
            indentation: info.indentation
        };
        changes.replaceNode(context.sourceFile, info.parentDeclaration, factory.createObjectLiteralExpression([
            ...info.parentDeclaration.properties,
            ...props
        ], /*multiLine*/ true), options);
        importAdder.writeFixes(changes);
    }
    function tryGetValueFromType(context, checker, importAdder, quotePreference, type, enclosingDeclaration) {
        if (type.flags & 3 /* AnyOrUnknown */ ) return createUndefined();
        if (type.flags & 134217732 /* TemplateLiteral */ ) return factory.createStringLiteral("", /* isSingleQuote */ quotePreference === 0 /* Single */ );
        if (type.flags & 8 /* Number */ ) return factory.createNumericLiteral(0);
        if (type.flags & 64 /* BigInt */ ) return factory.createBigIntLiteral("0n");
        if (type.flags & 16 /* Boolean */ ) return factory.createFalse();
        if (type.flags & 1056 /* EnumLike */ ) {
            const enumMember = type.symbol.exports ? firstOrUndefinedIterator(type.symbol.exports.values()) : type.symbol;
            const name = checker.symbolToExpression(type.symbol.parent ? type.symbol.parent : type.symbol, 111551 /* Value */ , /*enclosingDeclaration*/ void 0, /*flags*/ void 0);
            return enumMember === void 0 || name === void 0 ? factory.createNumericLiteral(0) : factory.createPropertyAccessExpression(name, checker.symbolToString(enumMember));
        }
        if (type.flags & 256 /* NumberLiteral */ ) return factory.createNumericLiteral(type.value);
        if (type.flags & 2048 /* BigIntLiteral */ ) return factory.createBigIntLiteral(type.value);
        if (type.flags & 128 /* StringLiteral */ ) return factory.createStringLiteral(type.value, /* isSingleQuote */ quotePreference === 0 /* Single */ );
        if (type.flags & 512 /* BooleanLiteral */ ) return type === checker.getFalseType() || type === checker.getFalseType(/*fresh*/ true) ? factory.createFalse() : factory.createTrue();
        if (type.flags & 65536 /* Null */ ) return factory.createNull();
        if (type.flags & 1048576 /* Union */ ) {
            const expression = firstDefined(type.types, (t)=>tryGetValueFromType(context, checker, importAdder, quotePreference, t, enclosingDeclaration));
            return expression ?? createUndefined();
        }
        if (checker.isArrayLikeType(type)) return factory.createArrayLiteralExpression();
        if (isObjectLiteralType(type)) {
            const props = map(checker.getPropertiesOfType(type), (prop)=>{
                const initializer = tryGetValueFromType(context, checker, importAdder, quotePreference, checker.getTypeOfSymbol(prop), enclosingDeclaration);
                return factory.createPropertyAssignment(prop.name, initializer);
            });
            return factory.createObjectLiteralExpression(props, /*multiLine*/ true);
        }
        if (getObjectFlags(type) & 16 /* Anonymous */ ) {
            const decl = find(type.symbol.declarations || emptyArray, or(isFunctionTypeNode, isMethodSignature, isMethodDeclaration));
            if (decl === void 0) return createUndefined();
            const signature = checker.getSignaturesOfType(type, 0 /* Call */ );
            if (signature === void 0) return createUndefined();
            const func = createSignatureDeclarationFromSignature(217 /* FunctionExpression */ , context, quotePreference, signature[0], createStubbedBody(Diagnostics.Function_not_implemented.message, quotePreference), /*name*/ void 0, /*modifiers*/ void 0, /*optional*/ void 0, /*enclosingDeclaration*/ enclosingDeclaration, importAdder);
            return func ?? createUndefined();
        }
        if (getObjectFlags(type) & 1 /* Class */ ) {
            const classDeclaration = getClassLikeDeclarationOfSymbol(type.symbol);
            if (classDeclaration === void 0 || hasAbstractModifier(classDeclaration)) return createUndefined();
            const constructorDeclaration = getFirstConstructorWithBody(classDeclaration);
            if (constructorDeclaration && length(constructorDeclaration.parameters)) return createUndefined();
            return factory.createNewExpression(factory.createIdentifier(type.symbol.name), /*typeArguments*/ void 0, /*argumentsArray*/ void 0);
        }
        return createUndefined();
    }
    function createUndefined() {
        return factory.createIdentifier("undefined");
    }
    function isObjectLiteralType(type) {
        return type.flags & 524288 /* Object */  && (getObjectFlags(type) & 128 /* ObjectLiteral */  || type.symbol && tryCast(singleOrUndefined(type.symbol.declarations), isTypeLiteralNode));
    }
    function getUnmatchedAttributes(checker, target, source) {
        const attrsType = checker.getContextualType(source.attributes);
        if (attrsType === void 0) return emptyArray;
        const targetProps = attrsType.getProperties();
        if (!length(targetProps)) return emptyArray;
        const seenNames = /* @__PURE__ */ new Set();
        for (const sourceProp of source.attributes.properties){
            if (isJsxAttribute(sourceProp)) seenNames.add(getEscapedTextOfJsxAttributeName(sourceProp.name));
            if (isJsxSpreadAttribute(sourceProp)) {
                const type = checker.getTypeAtLocation(sourceProp.expression);
                for (const prop of type.getProperties())seenNames.add(prop.escapedName);
            }
        }
        return filter(targetProps, (targetProp)=>isIdentifierText(targetProp.name, target, 1 /* JSX */ ) && !(targetProp.flags & 16777216 /* Optional */  || getCheckFlags(targetProp) & 48 /* Partial */  || seenNames.has(targetProp.escapedName)));
    }
    function tryGetContainingMethodDeclaration(node, callExpression) {
        if (isTypeLiteralNode(node)) return void 0;
        const declaration = findAncestor(callExpression, (n)=>isMethodDeclaration(n) || isConstructorDeclaration(n));
        return declaration && declaration.parent === node ? declaration : void 0;
    }
    function createPropertyNameFromSymbol(symbol, target, quotePreference, checker) {
        if (isTransientSymbol(symbol)) {
            const prop = checker.symbolToNode(symbol, 111551 /* Value */ , /*enclosingDeclaration*/ void 0, 1073741824 /* WriteComputedProps */ );
            if (prop && isComputedPropertyName(prop)) return prop;
        }
        return createPropertyNameNodeForIdentifierOrLiteral(symbol.name, target, quotePreference === 0 /* Single */ );
    }
    function findScope(node) {
        if (findAncestor(node, isJsxExpression)) {
            const returnStatement = findAncestor(node.parent, isReturnStatement);
            if (returnStatement) return returnStatement;
        }
        return getSourceFileOfNode(node);
    }
    var fixMissingMember, fixMissingProperties, fixMissingAttributes, fixMissingFunctionDeclaration, errorCodes27;
    var init_fixAddMissingMember = __esm({
        "src/services/codefixes/fixAddMissingMember.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixMissingMember = "fixMissingMember";
            fixMissingProperties = "fixMissingProperties";
            fixMissingAttributes = "fixMissingAttributes";
            fixMissingFunctionDeclaration = "fixMissingFunctionDeclaration";
            errorCodes27 = [
                Diagnostics.Property_0_does_not_exist_on_type_1.code,
                Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2.code,
                Diagnostics.Property_0_is_missing_in_type_1_but_required_in_type_2.code,
                Diagnostics.Type_0_is_missing_the_following_properties_from_type_1_Colon_2.code,
                Diagnostics.Type_0_is_missing_the_following_properties_from_type_1_Colon_2_and_3_more.code,
                Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code,
                Diagnostics.Cannot_find_name_0.code
            ];
            registerCodeFix({
                errorCodes: errorCodes27,
                getCodeActions (context) {
                    const typeChecker = context.program.getTypeChecker();
                    const info = getInfo10(context.sourceFile, context.span.start, context.errorCode, typeChecker, context.program);
                    if (!info) return void 0;
                    if (info.kind === 3 /* ObjectLiteral */ ) {
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addObjectLiteralProperties(t, context, info));
                        return [
                            createCodeFixAction(fixMissingProperties, changes, Diagnostics.Add_missing_properties, fixMissingProperties, Diagnostics.Add_all_missing_properties)
                        ];
                    }
                    if (info.kind === 4 /* JsxAttributes */ ) {
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addJsxAttributes(t, context, info));
                        return [
                            createCodeFixAction(fixMissingAttributes, changes, Diagnostics.Add_missing_attributes, fixMissingAttributes, Diagnostics.Add_all_missing_attributes)
                        ];
                    }
                    if (info.kind === 2 /* Function */  || info.kind === 5 /* Signature */ ) {
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addFunctionDeclaration(t, context, info));
                        return [
                            createCodeFixAction(fixMissingFunctionDeclaration, changes, [
                                Diagnostics.Add_missing_function_declaration_0,
                                info.token.text
                            ], fixMissingFunctionDeclaration, Diagnostics.Add_all_missing_function_declarations)
                        ];
                    }
                    if (info.kind === 1 /* Enum */ ) {
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addEnumMemberDeclaration(t, context.program.getTypeChecker(), info));
                        return [
                            createCodeFixAction(fixMissingMember, changes, [
                                Diagnostics.Add_missing_enum_member_0,
                                info.token.text
                            ], fixMissingMember, Diagnostics.Add_all_missing_members)
                        ];
                    }
                    return concatenate(getActionsForMissingMethodDeclaration(context, info), getActionsForMissingMemberDeclaration(context, info));
                },
                fixIds: [
                    fixMissingMember,
                    fixMissingFunctionDeclaration,
                    fixMissingProperties,
                    fixMissingAttributes
                ],
                getAllCodeActions: (context)=>{
                    const { program: program , fixId: fixId52  } = context;
                    const checker = program.getTypeChecker();
                    const seen = /* @__PURE__ */ new Map();
                    const typeDeclToMembers = /* @__PURE__ */ new Map();
                    return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                        eachDiagnostic(context, errorCodes27, (diag2)=>{
                            const info = getInfo10(diag2.file, diag2.start, diag2.code, checker, context.program);
                            if (!info || !addToSeen(seen, getNodeId(info.parentDeclaration) + "#" + info.token.text)) return;
                            if (fixId52 === fixMissingFunctionDeclaration && (info.kind === 2 /* Function */  || info.kind === 5 /* Signature */ )) addFunctionDeclaration(changes, context, info);
                            else if (fixId52 === fixMissingProperties && info.kind === 3 /* ObjectLiteral */ ) addObjectLiteralProperties(changes, context, info);
                            else if (fixId52 === fixMissingAttributes && info.kind === 4 /* JsxAttributes */ ) addJsxAttributes(changes, context, info);
                            else {
                                if (info.kind === 1 /* Enum */ ) addEnumMemberDeclaration(changes, checker, info);
                                if (info.kind === 0 /* TypeLikeDeclaration */ ) {
                                    const { parentDeclaration: parentDeclaration , token: token  } = info;
                                    const infos = getOrUpdate(typeDeclToMembers, parentDeclaration, ()=>[]);
                                    if (!infos.some((i)=>i.token.text === token.text)) infos.push(info);
                                }
                            }
                        });
                        typeDeclToMembers.forEach((infos, declaration)=>{
                            const supers = isTypeLiteralNode(declaration) ? void 0 : getAllSupers(declaration, checker);
                            for (const info of infos){
                                if (supers == null ? void 0 : supers.some((superClassOrInterface)=>{
                                    const superInfos = typeDeclToMembers.get(superClassOrInterface);
                                    return !!superInfos && superInfos.some(({ token: token2  })=>token2.text === info.token.text);
                                })) continue;
                                const { parentDeclaration: parentDeclaration , declSourceFile: declSourceFile , modifierFlags: modifierFlags , token: token , call: call , isJSFile: isJSFile  } = info;
                                if (call && !isPrivateIdentifier(token)) addMethodDeclaration(context, changes, call, token, modifierFlags & 32 /* Static */ , parentDeclaration, declSourceFile);
                                else if (isJSFile && !isInterfaceDeclaration(parentDeclaration) && !isTypeLiteralNode(parentDeclaration)) addMissingMemberInJs(changes, declSourceFile, parentDeclaration, token, !!(modifierFlags & 32 /* Static */ ));
                                else {
                                    const typeNode = getTypeNode2(checker, parentDeclaration, token);
                                    addPropertyDeclaration(changes, declSourceFile, parentDeclaration, token.text, typeNode, modifierFlags & 32 /* Static */ );
                                }
                            }
                        });
                    }));
                }
            });
        }
    });
    // src/services/codefixes/fixAddMissingNewOperator.ts
    function addMissingNewOperator(changes, sourceFile, span) {
        const call = cast(findAncestorMatchingSpan2(sourceFile, span), isCallExpression);
        const newExpression = factory.createNewExpression(call.expression, call.typeArguments, call.arguments);
        changes.replaceNode(sourceFile, call, newExpression);
    }
    function findAncestorMatchingSpan2(sourceFile, span) {
        let token = getTokenAtPosition(sourceFile, span.start);
        const end = textSpanEnd(span);
        while(token.end < end)token = token.parent;
        return token;
    }
    var fixId24, errorCodes28;
    var init_fixAddMissingNewOperator = __esm({
        "src/services/codefixes/fixAddMissingNewOperator.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId24 = "addMissingNewOperator";
            errorCodes28 = [
                Diagnostics.Value_of_type_0_is_not_callable_Did_you_mean_to_include_new.code
            ];
            registerCodeFix({
                errorCodes: errorCodes28,
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMissingNewOperator(t, sourceFile, span));
                    return [
                        createCodeFixAction(fixId24, changes, Diagnostics.Add_missing_new_operator_to_call, fixId24, Diagnostics.Add_missing_new_operator_to_all_calls)
                    ];
                },
                fixIds: [
                    fixId24
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes28, (changes, diag2)=>addMissingNewOperator(changes, context.sourceFile, diag2))
            });
        }
    });
    // src/services/codefixes/fixCannotFindModule.ts
    function getInstallCommand(fileName, packageName) {
        return {
            type: "install package",
            file: fileName,
            packageName: packageName
        };
    }
    function tryGetImportedPackageName(sourceFile, pos) {
        const moduleSpecifierText = tryCast(getTokenAtPosition(sourceFile, pos), isStringLiteral);
        if (!moduleSpecifierText) return void 0;
        const moduleName = moduleSpecifierText.text;
        const { packageName: packageName  } = parsePackageName(moduleName);
        return isExternalModuleNameRelative(packageName) ? void 0 : packageName;
    }
    function getTypesPackageNameToInstall(packageName, host, diagCode) {
        var _a;
        return diagCode === errorCodeCannotFindModule ? ts_JsTyping_exports.nodeCoreModules.has(packageName) ? "@types/node" : void 0 : ((_a = host.isKnownTypesPackageName) == null ? void 0 : _a.call(host, packageName)) ? getTypesPackageName(packageName) : void 0;
    }
    var fixName2, fixIdInstallTypesPackage, errorCodeCannotFindModule, errorCodes29;
    var init_fixCannotFindModule = __esm({
        "src/services/codefixes/fixCannotFindModule.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixName2 = "fixCannotFindModule";
            fixIdInstallTypesPackage = "installTypesPackage";
            errorCodeCannotFindModule = Diagnostics.Cannot_find_module_0_or_its_corresponding_type_declarations.code;
            errorCodes29 = [
                errorCodeCannotFindModule,
                Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type.code
            ];
            registerCodeFix({
                errorCodes: errorCodes29,
                getCodeActions: function getCodeActionsToFixNotFoundModule(context) {
                    const { host: host , sourceFile: sourceFile , span: { start: start  }  } = context;
                    const packageName = tryGetImportedPackageName(sourceFile, start);
                    if (packageName === void 0) return void 0;
                    const typesPackageName = getTypesPackageNameToInstall(packageName, host, context.errorCode);
                    return typesPackageName === void 0 ? [] : [
                        createCodeFixAction(fixName2, /*changes*/ [], [
                            Diagnostics.Install_0,
                            typesPackageName
                        ], fixIdInstallTypesPackage, Diagnostics.Install_all_missing_types_packages, getInstallCommand(sourceFile.fileName, typesPackageName))
                    ];
                },
                fixIds: [
                    fixIdInstallTypesPackage
                ],
                getAllCodeActions: (context)=>{
                    return codeFixAll(context, errorCodes29, (_changes, diag2, commands)=>{
                        const packageName = tryGetImportedPackageName(diag2.file, diag2.start);
                        if (packageName === void 0) return void 0;
                        switch(context.fixId){
                            case fixIdInstallTypesPackage:
                                {
                                    const pkg = getTypesPackageNameToInstall(packageName, context.host, diag2.code);
                                    if (pkg) commands.push(getInstallCommand(diag2.file.fileName, pkg));
                                    break;
                                }
                            default:
                                Debug.fail(`Bad fixId: ${context.fixId}`);
                        }
                    });
                }
            });
        }
    });
    // src/services/codefixes/fixClassDoesntImplementInheritedAbstractMember.ts
    function getClass2(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        return cast(token.parent, isClassLike);
    }
    function addMissingMembers(classDeclaration, sourceFile, context, changeTracker, preferences) {
        const extendsNode = getEffectiveBaseTypeNode(classDeclaration);
        const checker = context.program.getTypeChecker();
        const instantiatedExtendsType = checker.getTypeAtLocation(extendsNode);
        const abstractAndNonPrivateExtendsSymbols = checker.getPropertiesOfType(instantiatedExtendsType).filter(symbolPointsToNonPrivateAndAbstractMember);
        const importAdder = createImportAdder(sourceFile, context.program, preferences, context.host);
        createMissingMemberNodes(classDeclaration, abstractAndNonPrivateExtendsSymbols, sourceFile, context, preferences, importAdder, (member)=>changeTracker.insertMemberAtStart(sourceFile, classDeclaration, member));
        importAdder.writeFixes(changeTracker);
    }
    function symbolPointsToNonPrivateAndAbstractMember(symbol) {
        const flags = getSyntacticModifierFlags(first(symbol.getDeclarations()));
        return !(flags & 8 /* Private */ ) && !!(flags & 256 /* Abstract */ );
    }
    var errorCodes30, fixId25;
    var init_fixClassDoesntImplementInheritedAbstractMember = __esm({
        "src/services/codefixes/fixClassDoesntImplementInheritedAbstractMember.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            errorCodes30 = [
                Diagnostics.Non_abstract_class_0_does_not_implement_all_abstract_members_of_1.code
            ];
            fixId25 = "fixClassDoesntImplementInheritedAbstractMember";
            registerCodeFix({
                errorCodes: errorCodes30,
                getCodeActions: function getCodeActionsToFixClassNotImplementingInheritedMembers(context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMissingMembers(getClass2(sourceFile, span.start), sourceFile, context, t, context.preferences));
                    return changes.length === 0 ? void 0 : [
                        createCodeFixAction(fixId25, changes, Diagnostics.Implement_inherited_abstract_class, fixId25, Diagnostics.Implement_all_inherited_abstract_classes)
                    ];
                },
                fixIds: [
                    fixId25
                ],
                getAllCodeActions: function getAllCodeActionsToFixClassDoesntImplementInheritedAbstractMember(context) {
                    const seenClassDeclarations = /* @__PURE__ */ new Map();
                    return codeFixAll(context, errorCodes30, (changes, diag2)=>{
                        const classDeclaration = getClass2(diag2.file, diag2.start);
                        if (addToSeen(seenClassDeclarations, getNodeId(classDeclaration))) addMissingMembers(classDeclaration, context.sourceFile, context, changes, context.preferences);
                    });
                }
            });
        }
    });
    // src/services/codefixes/fixClassSuperMustPrecedeThisAccess.ts
    function doChange19(changes, sourceFile, constructor, superCall) {
        changes.insertNodeAtConstructorStart(sourceFile, constructor, superCall);
        changes.delete(sourceFile, superCall);
    }
    function getNodes(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (token.kind !== 110 /* ThisKeyword */ ) return void 0;
        const constructor = getContainingFunction(token);
        const superCall = findSuperCall(constructor.body);
        return superCall && !superCall.expression.arguments.some((arg)=>isPropertyAccessExpression(arg) && arg.expression === token) ? {
            constructor: constructor,
            superCall: superCall
        } : void 0;
    }
    function findSuperCall(n) {
        return isExpressionStatement(n) && isSuperCall(n.expression) ? n : isFunctionLike(n) ? void 0 : forEachChild(n, findSuperCall);
    }
    var fixId26, errorCodes31;
    var init_fixClassSuperMustPrecedeThisAccess = __esm({
        "src/services/codefixes/fixClassSuperMustPrecedeThisAccess.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId26 = "classSuperMustPrecedeThisAccess";
            errorCodes31 = [
                Diagnostics.super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class.code
            ];
            registerCodeFix({
                errorCodes: errorCodes31,
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const nodes = getNodes(sourceFile, span.start);
                    if (!nodes) return void 0;
                    const { constructor: constructor , superCall: superCall  } = nodes;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange19(t, sourceFile, constructor, superCall));
                    return [
                        createCodeFixAction(fixId26, changes, Diagnostics.Make_super_call_the_first_statement_in_the_constructor, fixId26, Diagnostics.Make_all_super_calls_the_first_statement_in_their_constructor)
                    ];
                },
                fixIds: [
                    fixId26
                ],
                getAllCodeActions (context) {
                    const { sourceFile: sourceFile  } = context;
                    const seenClasses = /* @__PURE__ */ new Map();
                    return codeFixAll(context, errorCodes31, (changes, diag2)=>{
                        const nodes = getNodes(diag2.file, diag2.start);
                        if (!nodes) return;
                        const { constructor: constructor , superCall: superCall  } = nodes;
                        if (addToSeen(seenClasses, getNodeId(constructor.parent))) doChange19(changes, sourceFile, constructor, superCall);
                    });
                }
            });
        }
    });
    // src/services/codefixes/fixConstructorForDerivedNeedSuperCall.ts
    function getNode(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        Debug.assert(isConstructorDeclaration(token.parent), "token should be at the constructor declaration");
        return token.parent;
    }
    function doChange20(changes, sourceFile, ctr) {
        const superCall = factory.createExpressionStatement(factory.createCallExpression(factory.createSuper(), /*typeArguments*/ void 0, /*argumentsArray*/ emptyArray));
        changes.insertNodeAtConstructorStart(sourceFile, ctr, superCall);
    }
    var fixId27, errorCodes32;
    var init_fixConstructorForDerivedNeedSuperCall = __esm({
        "src/services/codefixes/fixConstructorForDerivedNeedSuperCall.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId27 = "constructorForDerivedNeedSuperCall";
            errorCodes32 = [
                Diagnostics.Constructors_for_derived_classes_must_contain_a_super_call.code
            ];
            registerCodeFix({
                errorCodes: errorCodes32,
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const ctr = getNode(sourceFile, span.start);
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange20(t, sourceFile, ctr));
                    return [
                        createCodeFixAction(fixId27, changes, Diagnostics.Add_missing_super_call, fixId27, Diagnostics.Add_all_missing_super_calls)
                    ];
                },
                fixIds: [
                    fixId27
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes32, (changes, diag2)=>doChange20(changes, context.sourceFile, getNode(diag2.file, diag2.start)))
            });
        }
    });
    // src/services/codefixes/fixEnableJsxFlag.ts
    function doChange21(changeTracker, configFile) {
        setJsonCompilerOptionValue(changeTracker, configFile, "jsx", factory.createStringLiteral("react"));
    }
    var fixID, errorCodes33;
    var init_fixEnableJsxFlag = __esm({
        "src/services/codefixes/fixEnableJsxFlag.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixID = "fixEnableJsxFlag";
            errorCodes33 = [
                Diagnostics.Cannot_use_JSX_unless_the_jsx_flag_is_provided.code
            ];
            registerCodeFix({
                errorCodes: errorCodes33,
                getCodeActions: function getCodeActionsToFixEnableJsxFlag(context) {
                    const { configFile: configFile  } = context.program.getCompilerOptions();
                    if (configFile === void 0) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (changeTracker)=>doChange21(changeTracker, configFile));
                    return [
                        createCodeFixActionWithoutFixAll(fixID, changes, Diagnostics.Enable_the_jsx_flag_in_your_configuration_file)
                    ];
                },
                fixIds: [
                    fixID
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes33, (changes)=>{
                        const { configFile: configFile  } = context.program.getCompilerOptions();
                        if (configFile === void 0) return void 0;
                        doChange21(changes, configFile);
                    })
            });
        }
    });
    // src/services/codefixes/fixNaNEquality.ts
    function getInfo11(program, sourceFile, span) {
        const diag2 = find(program.getSemanticDiagnostics(sourceFile), (diag3)=>diag3.start === span.start && diag3.length === span.length);
        if (diag2 === void 0 || diag2.relatedInformation === void 0) return;
        const related = find(diag2.relatedInformation, (related2)=>related2.code === Diagnostics.Did_you_mean_0.code);
        if (related === void 0 || related.file === void 0 || related.start === void 0 || related.length === void 0) return;
        const token = findAncestorMatchingSpan(related.file, createTextSpan(related.start, related.length));
        if (token === void 0) return;
        if (isExpression(token) && isBinaryExpression(token.parent)) return {
            suggestion: getSuggestion(related.messageText),
            expression: token.parent,
            arg: token
        };
        return void 0;
    }
    function doChange22(changes, sourceFile, arg, expression) {
        const callExpression = factory.createCallExpression(factory.createPropertyAccessExpression(factory.createIdentifier("Number"), factory.createIdentifier("isNaN")), /*typeArguments*/ void 0, [
            arg
        ]);
        const operator = expression.operatorToken.kind;
        changes.replaceNode(sourceFile, expression, operator === 38 /* ExclamationEqualsEqualsToken */  || operator === 36 /* ExclamationEqualsToken */  ? factory.createPrefixUnaryExpression(54 /* ExclamationToken */ , callExpression) : callExpression);
    }
    function getSuggestion(messageText) {
        const [_, suggestion] = flattenDiagnosticMessageText(messageText, "\n", 0).match(/\'(.*)\'/) || [];
        return suggestion;
    }
    var fixId28, errorCodes34;
    var init_fixNaNEquality = __esm({
        "src/services/codefixes/fixNaNEquality.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId28 = "fixNaNEquality";
            errorCodes34 = [
                Diagnostics.This_condition_will_always_return_0.code
            ];
            registerCodeFix({
                errorCodes: errorCodes34,
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: span , program: program  } = context;
                    const info = getInfo11(program, sourceFile, span);
                    if (info === void 0) return;
                    const { suggestion: suggestion , expression: expression , arg: arg  } = info;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange22(t, sourceFile, arg, expression));
                    return [
                        createCodeFixAction(fixId28, changes, [
                            Diagnostics.Use_0,
                            suggestion
                        ], fixId28, Diagnostics.Use_Number_isNaN_in_all_conditions)
                    ];
                },
                fixIds: [
                    fixId28
                ],
                getAllCodeActions: (context)=>{
                    return codeFixAll(context, errorCodes34, (changes, diag2)=>{
                        const info = getInfo11(context.program, diag2.file, createTextSpan(diag2.start, diag2.length));
                        if (info) doChange22(changes, diag2.file, info.arg, info.expression);
                    });
                }
            });
        }
    });
    // src/services/codefixes/fixModuleAndTargetOptions.ts
    var init_fixModuleAndTargetOptions = __esm({
        "src/services/codefixes/fixModuleAndTargetOptions.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            registerCodeFix({
                errorCodes: [
                    Diagnostics.Top_level_await_expressions_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_or_nodenext_and_the_target_option_is_set_to_es2017_or_higher.code,
                    Diagnostics.Top_level_for_await_loops_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_or_nodenext_and_the_target_option_is_set_to_es2017_or_higher.code
                ],
                getCodeActions: function getCodeActionsToFixModuleAndTarget(context) {
                    const compilerOptions = context.program.getCompilerOptions();
                    const { configFile: configFile  } = compilerOptions;
                    if (configFile === void 0) return void 0;
                    const codeFixes = [];
                    const moduleKind = getEmitModuleKind(compilerOptions);
                    const moduleOutOfRange = moduleKind >= 5 /* ES2015 */  && moduleKind < 99 /* ESNext */ ;
                    if (moduleOutOfRange) {
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (changes2)=>{
                            setJsonCompilerOptionValue(changes2, configFile, "module", factory.createStringLiteral("esnext"));
                        });
                        codeFixes.push(createCodeFixActionWithoutFixAll("fixModuleOption", changes, [
                            Diagnostics.Set_the_module_option_in_your_configuration_file_to_0,
                            "esnext"
                        ]));
                    }
                    const target = getEmitScriptTarget(compilerOptions);
                    const targetOutOfRange = target < 4 /* ES2017 */  || target > 99 /* ESNext */ ;
                    if (targetOutOfRange) {
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (tracker)=>{
                            const configObject = getTsConfigObjectLiteralExpression(configFile);
                            if (!configObject) return;
                            const options = [
                                [
                                    "target",
                                    factory.createStringLiteral("es2017")
                                ]
                            ];
                            if (moduleKind === 1 /* CommonJS */ ) options.push([
                                "module",
                                factory.createStringLiteral("commonjs")
                            ]);
                            setJsonCompilerOptionValues(tracker, configFile, options);
                        });
                        codeFixes.push(createCodeFixActionWithoutFixAll("fixTargetOption", changes, [
                            Diagnostics.Set_the_target_option_in_your_configuration_file_to_0,
                            "es2017"
                        ]));
                    }
                    return codeFixes.length ? codeFixes : void 0;
                }
            });
        }
    });
    // src/services/codefixes/fixPropertyAssignment.ts
    function doChange23(changes, sourceFile, node) {
        changes.replaceNode(sourceFile, node, factory.createPropertyAssignment(node.name, node.objectAssignmentInitializer));
    }
    function getProperty2(sourceFile, pos) {
        return cast(getTokenAtPosition(sourceFile, pos).parent, isShorthandPropertyAssignment);
    }
    var fixId29, errorCodes35;
    var init_fixPropertyAssignment = __esm({
        "src/services/codefixes/fixPropertyAssignment.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId29 = "fixPropertyAssignment";
            errorCodes35 = [
                Diagnostics.Did_you_mean_to_use_a_Colon_An_can_only_follow_a_property_name_when_the_containing_object_literal_is_part_of_a_destructuring_pattern.code
            ];
            registerCodeFix({
                errorCodes: errorCodes35,
                fixIds: [
                    fixId29
                ],
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const property = getProperty2(sourceFile, span.start);
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange23(t, context.sourceFile, property));
                    return [
                        createCodeFixAction(fixId29, changes, [
                            Diagnostics.Change_0_to_1,
                            "=",
                            ":"
                        ], fixId29, [
                            Diagnostics.Switch_each_misused_0_to_1,
                            "=",
                            ":"
                        ])
                    ];
                },
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes35, (changes, diag2)=>doChange23(changes, diag2.file, getProperty2(diag2.file, diag2.start)))
            });
        }
    });
    // src/services/codefixes/fixExtendsInterfaceBecomesImplements.ts
    function getNodes2(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        const heritageClauses = getContainingClass(token).heritageClauses;
        const extendsToken = heritageClauses[0].getFirstToken();
        return extendsToken.kind === 96 /* ExtendsKeyword */  ? {
            extendsToken: extendsToken,
            heritageClauses: heritageClauses
        } : void 0;
    }
    function doChanges2(changes, sourceFile, extendsToken, heritageClauses) {
        changes.replaceNode(sourceFile, extendsToken, factory.createToken(119 /* ImplementsKeyword */ ));
        if (heritageClauses.length === 2 && heritageClauses[0].token === 96 /* ExtendsKeyword */  && heritageClauses[1].token === 119 /* ImplementsKeyword */ ) {
            const implementsToken = heritageClauses[1].getFirstToken();
            const implementsFullStart = implementsToken.getFullStart();
            changes.replaceRange(sourceFile, {
                pos: implementsFullStart,
                end: implementsFullStart
            }, factory.createToken(28 /* CommaToken */ ));
            const text = sourceFile.text;
            let end = implementsToken.end;
            while(end < text.length && isWhiteSpaceSingleLine(text.charCodeAt(end)))end++;
            changes.deleteRange(sourceFile, {
                pos: implementsToken.getStart(),
                end: end
            });
        }
    }
    var fixId30, errorCodes36;
    var init_fixExtendsInterfaceBecomesImplements = __esm({
        "src/services/codefixes/fixExtendsInterfaceBecomesImplements.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId30 = "extendsInterfaceBecomesImplements";
            errorCodes36 = [
                Diagnostics.Cannot_extend_an_interface_0_Did_you_mean_implements.code
            ];
            registerCodeFix({
                errorCodes: errorCodes36,
                getCodeActions (context) {
                    const { sourceFile: sourceFile  } = context;
                    const nodes = getNodes2(sourceFile, context.span.start);
                    if (!nodes) return void 0;
                    const { extendsToken: extendsToken , heritageClauses: heritageClauses  } = nodes;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChanges2(t, sourceFile, extendsToken, heritageClauses));
                    return [
                        createCodeFixAction(fixId30, changes, Diagnostics.Change_extends_to_implements, fixId30, Diagnostics.Change_all_extended_interfaces_to_implements)
                    ];
                },
                fixIds: [
                    fixId30
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes36, (changes, diag2)=>{
                        const nodes = getNodes2(diag2.file, diag2.start);
                        if (nodes) doChanges2(changes, diag2.file, nodes.extendsToken, nodes.heritageClauses);
                    })
            });
        }
    });
    // src/services/codefixes/fixForgottenThisPropertyAccess.ts
    function getInfo12(sourceFile, pos, diagCode) {
        const node = getTokenAtPosition(sourceFile, pos);
        if (isIdentifier(node) || isPrivateIdentifier(node)) return {
            node: node,
            className: diagCode === didYouMeanStaticMemberCode ? getContainingClass(node).name.text : void 0
        };
    }
    function doChange24(changes, sourceFile, { node: node , className: className  }) {
        suppressLeadingAndTrailingTrivia(node);
        changes.replaceNode(sourceFile, node, factory.createPropertyAccessExpression(className ? factory.createIdentifier(className) : factory.createThis(), node));
    }
    var fixId31, didYouMeanStaticMemberCode, errorCodes37;
    var init_fixForgottenThisPropertyAccess = __esm({
        "src/services/codefixes/fixForgottenThisPropertyAccess.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId31 = "forgottenThisPropertyAccess";
            didYouMeanStaticMemberCode = Diagnostics.Cannot_find_name_0_Did_you_mean_the_static_member_1_0.code;
            errorCodes37 = [
                Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0.code,
                Diagnostics.Private_identifiers_are_only_allowed_in_class_bodies_and_may_only_be_used_as_part_of_a_class_member_declaration_property_access_or_on_the_left_hand_side_of_an_in_expression.code,
                didYouMeanStaticMemberCode
            ];
            registerCodeFix({
                errorCodes: errorCodes37,
                getCodeActions (context) {
                    const { sourceFile: sourceFile  } = context;
                    const info = getInfo12(sourceFile, context.span.start, context.errorCode);
                    if (!info) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange24(t, sourceFile, info));
                    return [
                        createCodeFixAction(fixId31, changes, [
                            Diagnostics.Add_0_to_unresolved_variable,
                            info.className || "this"
                        ], fixId31, Diagnostics.Add_qualifier_to_all_unresolved_variables_matching_a_member_name)
                    ];
                },
                fixIds: [
                    fixId31
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes37, (changes, diag2)=>{
                        const info = getInfo12(diag2.file, diag2.start, diag2.code);
                        if (info) doChange24(changes, context.sourceFile, info);
                    })
            });
        }
    });
    // src/services/codefixes/fixInvalidJsxCharacters.ts
    function isValidCharacter(character) {
        return hasProperty(htmlEntity, character);
    }
    function doChange25(changes, preferences, sourceFile, start, useHtmlEntity) {
        const character = sourceFile.getText()[start];
        if (!isValidCharacter(character)) return;
        const replacement = useHtmlEntity ? htmlEntity[character] : `{${quote(sourceFile, preferences, character)}}`;
        changes.replaceRangeWithText(sourceFile, {
            pos: start,
            end: start + 1
        }, replacement);
    }
    var fixIdExpression, fixIdHtmlEntity, errorCodes38, htmlEntity;
    var init_fixInvalidJsxCharacters = __esm({
        "src/services/codefixes/fixInvalidJsxCharacters.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixIdExpression = "fixInvalidJsxCharacters_expression";
            fixIdHtmlEntity = "fixInvalidJsxCharacters_htmlEntity";
            errorCodes38 = [
                Diagnostics.Unexpected_token_Did_you_mean_or_gt.code,
                Diagnostics.Unexpected_token_Did_you_mean_or_rbrace.code
            ];
            registerCodeFix({
                errorCodes: errorCodes38,
                fixIds: [
                    fixIdExpression,
                    fixIdHtmlEntity
                ],
                getCodeActions (context) {
                    const { sourceFile: sourceFile , preferences: preferences , span: span  } = context;
                    const changeToExpression = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange25(t, preferences, sourceFile, span.start, /*useHtmlEntity*/ false));
                    const changeToHtmlEntity = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange25(t, preferences, sourceFile, span.start, /*useHtmlEntity*/ true));
                    return [
                        createCodeFixAction(fixIdExpression, changeToExpression, Diagnostics.Wrap_invalid_character_in_an_expression_container, fixIdExpression, Diagnostics.Wrap_all_invalid_characters_in_an_expression_container),
                        createCodeFixAction(fixIdHtmlEntity, changeToHtmlEntity, Diagnostics.Convert_invalid_character_to_its_html_entity_code, fixIdHtmlEntity, Diagnostics.Convert_all_invalid_characters_to_HTML_entity_code)
                    ];
                },
                getAllCodeActions (context) {
                    return codeFixAll(context, errorCodes38, (changes, diagnostic)=>doChange25(changes, context.preferences, diagnostic.file, diagnostic.start, context.fixId === fixIdHtmlEntity));
                }
            });
            htmlEntity = {
                ">": "&gt;",
                "}": "&rbrace;"
            };
        }
    });
    // src/services/codefixes/fixUnmatchedParameter.ts
    function getDeleteAction(context, { name: name , jsDocHost: jsDocHost , jsDocParameterTag: jsDocParameterTag  }) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (changeTracker)=>changeTracker.filterJSDocTags(context.sourceFile, jsDocHost, (t)=>t !== jsDocParameterTag));
        return createCodeFixAction(deleteUnmatchedParameter, changes, [
            Diagnostics.Delete_unused_param_tag_0,
            name.getText(context.sourceFile)
        ], deleteUnmatchedParameter, Diagnostics.Delete_all_unused_param_tags);
    }
    function getRenameAction(context, { name: name , jsDocHost: jsDocHost , signature: signature , jsDocParameterTag: jsDocParameterTag  }) {
        if (!length(signature.parameters)) return void 0;
        const sourceFile = context.sourceFile;
        const tags = getJSDocTags(signature);
        const names = /* @__PURE__ */ new Set();
        for (const tag of tags)if (isJSDocParameterTag(tag) && isIdentifier(tag.name)) names.add(tag.name.escapedText);
        const parameterName = firstDefined(signature.parameters, (p)=>isIdentifier(p.name) && !names.has(p.name.escapedText) ? p.name.getText(sourceFile) : void 0);
        if (parameterName === void 0) return void 0;
        const newJSDocParameterTag = factory.updateJSDocParameterTag(jsDocParameterTag, jsDocParameterTag.tagName, factory.createIdentifier(parameterName), jsDocParameterTag.isBracketed, jsDocParameterTag.typeExpression, jsDocParameterTag.isNameFirst, jsDocParameterTag.comment);
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (changeTracker)=>changeTracker.replaceJSDocComment(sourceFile, jsDocHost, map(tags, (t)=>t === jsDocParameterTag ? newJSDocParameterTag : t)));
        return createCodeFixActionWithoutFixAll(renameUnmatchedParameter, changes, [
            Diagnostics.Rename_param_tag_name_0_to_1,
            name.getText(sourceFile),
            parameterName
        ]);
    }
    function getInfo13(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (token.parent && isJSDocParameterTag(token.parent) && isIdentifier(token.parent.name)) {
            const jsDocParameterTag = token.parent;
            const jsDocHost = getJSDocHost(jsDocParameterTag);
            const signature = getHostSignatureFromJSDoc(jsDocParameterTag);
            if (jsDocHost && signature) return {
                jsDocHost: jsDocHost,
                signature: signature,
                name: token.parent.name,
                jsDocParameterTag: jsDocParameterTag
            };
        }
        return void 0;
    }
    var deleteUnmatchedParameter, renameUnmatchedParameter, errorCodes39;
    var init_fixUnmatchedParameter = __esm({
        "src/services/codefixes/fixUnmatchedParameter.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            deleteUnmatchedParameter = "deleteUnmatchedParameter";
            renameUnmatchedParameter = "renameUnmatchedParameter";
            errorCodes39 = [
                Diagnostics.JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name.code
            ];
            registerCodeFix({
                fixIds: [
                    deleteUnmatchedParameter,
                    renameUnmatchedParameter
                ],
                errorCodes: errorCodes39,
                getCodeActions: function getCodeActionsToFixUnmatchedParameter(context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const actions2 = [];
                    const info = getInfo13(sourceFile, span.start);
                    if (info) {
                        append(actions2, getDeleteAction(context, info));
                        append(actions2, getRenameAction(context, info));
                        return actions2;
                    }
                    return void 0;
                },
                getAllCodeActions: function getAllCodeActionsToFixUnmatchedParameter(context) {
                    const tagsToSignature = /* @__PURE__ */ new Map();
                    return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                        eachDiagnostic(context, errorCodes39, ({ file: file , start: start  })=>{
                            const info = getInfo13(file, start);
                            if (info) tagsToSignature.set(info.signature, append(tagsToSignature.get(info.signature), info.jsDocParameterTag));
                        });
                        tagsToSignature.forEach((tags, signature)=>{
                            if (context.fixId === deleteUnmatchedParameter) {
                                const tagsSet = new Set(tags);
                                changes.filterJSDocTags(signature.getSourceFile(), signature, (t)=>!tagsSet.has(t));
                            }
                        });
                    }));
                }
            });
        }
    });
    // src/services/codefixes/fixUnreferenceableDecoratorMetadata.ts
    function getImportDeclaration(sourceFile, program, start) {
        const identifier = tryCast(getTokenAtPosition(sourceFile, start), isIdentifier);
        if (!identifier || identifier.parent.kind !== 182 /* TypeReference */ ) return;
        const checker = program.getTypeChecker();
        const symbol = checker.getSymbolAtLocation(identifier);
        return find((symbol == null ? void 0 : symbol.declarations) || emptyArray, or(isImportClause, isImportSpecifier, isImportEqualsDeclaration));
    }
    function doTypeOnlyImportChange(changes, sourceFile, importDeclaration, program) {
        if (importDeclaration.kind === 270 /* ImportEqualsDeclaration */ ) {
            changes.insertModifierBefore(sourceFile, 156 /* TypeKeyword */ , importDeclaration.name);
            return;
        }
        const importClause = importDeclaration.kind === 272 /* ImportClause */  ? importDeclaration : importDeclaration.parent.parent;
        if (importClause.name && importClause.namedBindings) return;
        const checker = program.getTypeChecker();
        const importsValue = !!forEachImportClauseDeclaration(importClause, (decl)=>{
            if (skipAlias(decl.symbol, checker).flags & 111551 /* Value */ ) return true;
        });
        if (importsValue) return;
        changes.insertModifierBefore(sourceFile, 156 /* TypeKeyword */ , importClause);
    }
    function doNamespaceImportChange(changes, sourceFile, importDeclaration, program) {
        ts_refactor_exports.doChangeNamedToNamespaceOrDefault(sourceFile, program, changes, importDeclaration.parent);
    }
    var fixId32, errorCodes40;
    var init_fixUnreferenceableDecoratorMetadata = __esm({
        "src/services/codefixes/fixUnreferenceableDecoratorMetadata.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId32 = "fixUnreferenceableDecoratorMetadata";
            errorCodes40 = [
                Diagnostics.A_type_referenced_in_a_decorated_signature_must_be_imported_with_import_type_or_a_namespace_import_when_isolatedModules_and_emitDecoratorMetadata_are_enabled.code
            ];
            registerCodeFix({
                errorCodes: errorCodes40,
                getCodeActions: (context)=>{
                    const importDeclaration = getImportDeclaration(context.sourceFile, context.program, context.span.start);
                    if (!importDeclaration) return;
                    const namespaceChanges = ts_textChanges_exports.ChangeTracker.with(context, (t)=>importDeclaration.kind === 275 /* ImportSpecifier */  && doNamespaceImportChange(t, context.sourceFile, importDeclaration, context.program));
                    const typeOnlyChanges = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doTypeOnlyImportChange(t, context.sourceFile, importDeclaration, context.program));
                    let actions2;
                    if (namespaceChanges.length) actions2 = append(actions2, createCodeFixActionWithoutFixAll(fixId32, namespaceChanges, Diagnostics.Convert_named_imports_to_namespace_import));
                    if (typeOnlyChanges.length) actions2 = append(actions2, createCodeFixActionWithoutFixAll(fixId32, typeOnlyChanges, Diagnostics.Convert_to_type_only_import));
                    return actions2;
                },
                fixIds: [
                    fixId32
                ]
            });
        }
    });
    // src/services/codefixes/fixUnusedIdentifier.ts
    function changeInferToUnknown(changes, sourceFile, token) {
        changes.replaceNode(sourceFile, token.parent, factory.createKeywordTypeNode(159 /* UnknownKeyword */ ));
    }
    function createDeleteFix(changes, diag2) {
        return createCodeFixAction(fixName3, changes, diag2, fixIdDelete, Diagnostics.Delete_all_unused_declarations);
    }
    function deleteTypeParameters(changes, sourceFile, token) {
        changes.delete(sourceFile, Debug.checkDefined(cast(token.parent, isDeclarationWithTypeParameterChildren).typeParameters, "The type parameter to delete should exist"));
    }
    function isImport(token) {
        return token.kind === 102 /* ImportKeyword */  || token.kind === 80 /* Identifier */  && (token.parent.kind === 275 /* ImportSpecifier */  || token.parent.kind === 272 /* ImportClause */ );
    }
    function tryGetFullImport(token) {
        return token.kind === 102 /* ImportKeyword */  ? tryCast(token.parent, isImportDeclaration) : void 0;
    }
    function canDeleteEntireVariableStatement(sourceFile, token) {
        return isVariableDeclarationList(token.parent) && first(token.parent.getChildren(sourceFile)) === token;
    }
    function deleteEntireVariableStatement(changes, sourceFile, node) {
        changes.delete(sourceFile, node.parent.kind === 242 /* VariableStatement */  ? node.parent : node);
    }
    function deleteDestructuringElements(changes, sourceFile, node) {
        forEach(node.elements, (n)=>changes.delete(sourceFile, n));
    }
    function deleteDestructuring(context, changes, sourceFile, { parent: parent2  }) {
        if (isVariableDeclaration(parent2) && parent2.initializer && isCallLikeExpression(parent2.initializer)) {
            if (isVariableDeclarationList(parent2.parent) && length(parent2.parent.declarations) > 1) {
                const varStatement = parent2.parent.parent;
                const pos = varStatement.getStart(sourceFile);
                const end = varStatement.end;
                changes.delete(sourceFile, parent2);
                changes.insertNodeAt(sourceFile, end, parent2.initializer, {
                    prefix: getNewLineOrDefaultFromHost(context.host, context.formatContext.options) + sourceFile.text.slice(getPrecedingNonSpaceCharacterPosition(sourceFile.text, pos - 1), pos),
                    suffix: probablyUsesSemicolons(sourceFile) ? ";" : ""
                });
            } else changes.replaceNode(sourceFile, parent2.parent, parent2.initializer);
        } else changes.delete(sourceFile, parent2);
    }
    function tryPrefixDeclaration(changes, errorCode, sourceFile, token) {
        if (errorCode === Diagnostics.Property_0_is_declared_but_its_value_is_never_read.code) return;
        if (token.kind === 140 /* InferKeyword */ ) token = cast(token.parent, isInferTypeNode).typeParameter.name;
        if (isIdentifier(token) && canPrefix(token)) {
            changes.replaceNode(sourceFile, token, factory.createIdentifier(`_${token.text}`));
            if (isParameter(token.parent)) getJSDocParameterTags(token.parent).forEach((tag)=>{
                if (isIdentifier(tag.name)) changes.replaceNode(sourceFile, tag.name, factory.createIdentifier(`_${tag.name.text}`));
            });
        }
    }
    function canPrefix(token) {
        switch(token.parent.kind){
            case 168 /* Parameter */ :
            case 167 /* TypeParameter */ :
                return true;
            case 259 /* VariableDeclaration */ :
                {
                    const varDecl = token.parent;
                    switch(varDecl.parent.parent.kind){
                        case 249 /* ForOfStatement */ :
                        case 248 /* ForInStatement */ :
                            return true;
                    }
                }
        }
        return false;
    }
    function tryDeleteDeclaration(sourceFile, token, changes, checker, sourceFiles, program, cancellationToken, isFixAll) {
        tryDeleteDeclarationWorker(token, changes, sourceFile, checker, sourceFiles, program, cancellationToken, isFixAll);
        if (isIdentifier(token)) ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(token, checker, sourceFile, (ref)=>{
            if (isPropertyAccessExpression(ref.parent) && ref.parent.name === ref) ref = ref.parent;
            if (!isFixAll && mayDeleteExpression(ref)) changes.delete(sourceFile, ref.parent.parent);
        });
    }
    function tryDeleteDeclarationWorker(token, changes, sourceFile, checker, sourceFiles, program, cancellationToken, isFixAll) {
        const { parent: parent2  } = token;
        if (isParameter(parent2)) tryDeleteParameter(changes, sourceFile, parent2, checker, sourceFiles, program, cancellationToken, isFixAll);
        else if (!(isFixAll && isIdentifier(token) && ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(token, checker, sourceFile))) {
            const node = isImportClause(parent2) ? token : isComputedPropertyName(parent2) ? parent2.parent : parent2;
            Debug.assert(node !== sourceFile, "should not delete whole source file");
            changes.delete(sourceFile, node);
        }
    }
    function tryDeleteParameter(changes, sourceFile, parameter, checker, sourceFiles, program, cancellationToken, isFixAll = false) {
        if (mayDeleteParameter(checker, sourceFile, parameter, sourceFiles, program, cancellationToken, isFixAll)) {
            if (parameter.modifiers && parameter.modifiers.length > 0 && (!isIdentifier(parameter.name) || ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(parameter.name, checker, sourceFile))) {
                for (const modifier of parameter.modifiers)if (isModifier(modifier)) changes.deleteModifier(sourceFile, modifier);
            } else if (!parameter.initializer && isNotProvidedArguments(parameter, checker, sourceFiles)) changes.delete(sourceFile, parameter);
        }
    }
    function isNotProvidedArguments(parameter, checker, sourceFiles) {
        const index = parameter.parent.parameters.indexOf(parameter);
        return !ts_FindAllReferences_exports.Core.someSignatureUsage(parameter.parent, sourceFiles, checker, (_, call)=>!call || call.arguments.length > index);
    }
    function mayDeleteParameter(checker, sourceFile, parameter, sourceFiles, program, cancellationToken, isFixAll) {
        const { parent: parent2  } = parameter;
        switch(parent2.kind){
            case 173 /* MethodDeclaration */ :
            case 175 /* Constructor */ :
                const index = parent2.parameters.indexOf(parameter);
                const referent = isMethodDeclaration(parent2) ? parent2.name : parent2;
                const entries = ts_FindAllReferences_exports.Core.getReferencedSymbolsForNode(parent2.pos, referent, program, sourceFiles, cancellationToken);
                if (entries) for (const entry of entries){
                    for (const reference of entry.references)if (reference.kind === ts_FindAllReferences_exports.EntryKind.Node) {
                        const isSuperCall2 = isSuperKeyword(reference.node) && isCallExpression(reference.node.parent) && reference.node.parent.arguments.length > index;
                        const isSuperMethodCall = isPropertyAccessExpression(reference.node.parent) && isSuperKeyword(reference.node.parent.expression) && isCallExpression(reference.node.parent.parent) && reference.node.parent.parent.arguments.length > index;
                        const isOverriddenMethod = (isMethodDeclaration(reference.node.parent) || isMethodSignature(reference.node.parent)) && reference.node.parent !== parameter.parent && reference.node.parent.parameters.length > index;
                        if (isSuperCall2 || isSuperMethodCall || isOverriddenMethod) return false;
                    }
                }
                return true;
            case 261 /* FunctionDeclaration */ :
                if (parent2.name && isCallbackLike(checker, sourceFile, parent2.name)) return isLastParameter(parent2, parameter, isFixAll);
                return true;
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
                return isLastParameter(parent2, parameter, isFixAll);
            case 177 /* SetAccessor */ :
                return false;
            case 176 /* GetAccessor */ :
                return true;
            default:
                return Debug.failBadSyntaxKind(parent2);
        }
    }
    function isCallbackLike(checker, sourceFile, name) {
        return !!ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(name, checker, sourceFile, (reference)=>isIdentifier(reference) && isCallExpression(reference.parent) && reference.parent.arguments.indexOf(reference) >= 0);
    }
    function isLastParameter(func, parameter, isFixAll) {
        const parameters = func.parameters;
        const index = parameters.indexOf(parameter);
        Debug.assert(index !== -1, "The parameter should already be in the list");
        return isFixAll ? parameters.slice(index + 1).every((p)=>isIdentifier(p.name) && !p.symbol.isReferenced) : index === parameters.length - 1;
    }
    function mayDeleteExpression(node) {
        return (isBinaryExpression(node.parent) && node.parent.left === node || (isPostfixUnaryExpression(node.parent) || isPrefixUnaryExpression(node.parent)) && node.parent.operand === node) && isExpressionStatement(node.parent.parent);
    }
    var fixName3, fixIdPrefix, fixIdDelete, fixIdDeleteImports, fixIdInfer, errorCodes41;
    var init_fixUnusedIdentifier = __esm({
        "src/services/codefixes/fixUnusedIdentifier.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixName3 = "unusedIdentifier";
            fixIdPrefix = "unusedIdentifier_prefix";
            fixIdDelete = "unusedIdentifier_delete";
            fixIdDeleteImports = "unusedIdentifier_deleteImports";
            fixIdInfer = "unusedIdentifier_infer";
            errorCodes41 = [
                Diagnostics._0_is_declared_but_its_value_is_never_read.code,
                Diagnostics._0_is_declared_but_never_used.code,
                Diagnostics.Property_0_is_declared_but_its_value_is_never_read.code,
                Diagnostics.All_imports_in_import_declaration_are_unused.code,
                Diagnostics.All_destructured_elements_are_unused.code,
                Diagnostics.All_variables_are_unused.code,
                Diagnostics.All_type_parameters_are_unused.code
            ];
            registerCodeFix({
                errorCodes: errorCodes41,
                getCodeActions (context) {
                    const { errorCode: errorCode , sourceFile: sourceFile , program: program , cancellationToken: cancellationToken  } = context;
                    const checker = program.getTypeChecker();
                    const sourceFiles = program.getSourceFiles();
                    const token = getTokenAtPosition(sourceFile, context.span.start);
                    if (isJSDocTemplateTag(token)) return [
                        createDeleteFix(ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.delete(sourceFile, token)), Diagnostics.Remove_template_tag)
                    ];
                    if (token.kind === 30 /* LessThanToken */ ) {
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>deleteTypeParameters(t, sourceFile, token));
                        return [
                            createDeleteFix(changes, Diagnostics.Remove_type_parameters)
                        ];
                    }
                    const importDecl = tryGetFullImport(token);
                    if (importDecl) {
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.delete(sourceFile, importDecl));
                        return [
                            createCodeFixAction(fixName3, changes, [
                                Diagnostics.Remove_import_from_0,
                                showModuleSpecifier(importDecl)
                            ], fixIdDeleteImports, Diagnostics.Delete_all_unused_imports)
                        ];
                    } else if (isImport(token)) {
                        const deletion = ts_textChanges_exports.ChangeTracker.with(context, (t)=>tryDeleteDeclaration(sourceFile, token, t, checker, sourceFiles, program, cancellationToken, /*isFixAll*/ false));
                        if (deletion.length) return [
                            createCodeFixAction(fixName3, deletion, [
                                Diagnostics.Remove_unused_declaration_for_Colon_0,
                                token.getText(sourceFile)
                            ], fixIdDeleteImports, Diagnostics.Delete_all_unused_imports)
                        ];
                    }
                    if (isObjectBindingPattern(token.parent) || isArrayBindingPattern(token.parent)) {
                        if (isParameter(token.parent.parent)) {
                            const elements = token.parent.elements;
                            const diagnostic = [
                                elements.length > 1 ? Diagnostics.Remove_unused_declarations_for_Colon_0 : Diagnostics.Remove_unused_declaration_for_Colon_0,
                                map(elements, (e)=>e.getText(sourceFile)).join(", ")
                            ];
                            return [
                                createDeleteFix(ts_textChanges_exports.ChangeTracker.with(context, (t)=>deleteDestructuringElements(t, sourceFile, token.parent)), diagnostic)
                            ];
                        }
                        return [
                            createDeleteFix(ts_textChanges_exports.ChangeTracker.with(context, (t)=>deleteDestructuring(context, t, sourceFile, token.parent)), Diagnostics.Remove_unused_destructuring_declaration)
                        ];
                    }
                    if (canDeleteEntireVariableStatement(sourceFile, token)) return [
                        createDeleteFix(ts_textChanges_exports.ChangeTracker.with(context, (t)=>deleteEntireVariableStatement(t, sourceFile, token.parent)), Diagnostics.Remove_variable_statement)
                    ];
                    const result = [];
                    if (token.kind === 140 /* InferKeyword */ ) {
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>changeInferToUnknown(t, sourceFile, token));
                        const name = cast(token.parent, isInferTypeNode).typeParameter.name.text;
                        result.push(createCodeFixAction(fixName3, changes, [
                            Diagnostics.Replace_infer_0_with_unknown,
                            name
                        ], fixIdInfer, Diagnostics.Replace_all_unused_infer_with_unknown));
                    } else {
                        const deletion = ts_textChanges_exports.ChangeTracker.with(context, (t)=>tryDeleteDeclaration(sourceFile, token, t, checker, sourceFiles, program, cancellationToken, /*isFixAll*/ false));
                        if (deletion.length) {
                            const name = isComputedPropertyName(token.parent) ? token.parent : token;
                            result.push(createDeleteFix(deletion, [
                                Diagnostics.Remove_unused_declaration_for_Colon_0,
                                name.getText(sourceFile)
                            ]));
                        }
                    }
                    const prefix = ts_textChanges_exports.ChangeTracker.with(context, (t)=>tryPrefixDeclaration(t, errorCode, sourceFile, token));
                    if (prefix.length) result.push(createCodeFixAction(fixName3, prefix, [
                        Diagnostics.Prefix_0_with_an_underscore,
                        token.getText(sourceFile)
                    ], fixIdPrefix, Diagnostics.Prefix_all_unused_declarations_with_where_possible));
                    return result;
                },
                fixIds: [
                    fixIdPrefix,
                    fixIdDelete,
                    fixIdDeleteImports,
                    fixIdInfer
                ],
                getAllCodeActions: (context)=>{
                    const { sourceFile: sourceFile , program: program , cancellationToken: cancellationToken  } = context;
                    const checker = program.getTypeChecker();
                    const sourceFiles = program.getSourceFiles();
                    return codeFixAll(context, errorCodes41, (changes, diag2)=>{
                        const token = getTokenAtPosition(sourceFile, diag2.start);
                        switch(context.fixId){
                            case fixIdPrefix:
                                tryPrefixDeclaration(changes, diag2.code, sourceFile, token);
                                break;
                            case fixIdDeleteImports:
                                {
                                    const importDecl = tryGetFullImport(token);
                                    if (importDecl) changes.delete(sourceFile, importDecl);
                                    else if (isImport(token)) tryDeleteDeclaration(sourceFile, token, changes, checker, sourceFiles, program, cancellationToken, /*isFixAll*/ true);
                                    break;
                                }
                            case fixIdDelete:
                                if (token.kind === 140 /* InferKeyword */  || isImport(token)) break;
                                else if (isJSDocTemplateTag(token)) changes.delete(sourceFile, token);
                                else if (token.kind === 30 /* LessThanToken */ ) deleteTypeParameters(changes, sourceFile, token);
                                else if (isObjectBindingPattern(token.parent)) {
                                    if (token.parent.parent.initializer) break;
                                    else if (!isParameter(token.parent.parent) || isNotProvidedArguments(token.parent.parent, checker, sourceFiles)) changes.delete(sourceFile, token.parent.parent);
                                } else if (isArrayBindingPattern(token.parent.parent) && token.parent.parent.parent.initializer) break;
                                else if (canDeleteEntireVariableStatement(sourceFile, token)) deleteEntireVariableStatement(changes, sourceFile, token.parent);
                                else tryDeleteDeclaration(sourceFile, token, changes, checker, sourceFiles, program, cancellationToken, /*isFixAll*/ true);
                                break;
                            case fixIdInfer:
                                if (token.kind === 140 /* InferKeyword */ ) changeInferToUnknown(changes, sourceFile, token);
                                break;
                            default:
                                Debug.fail(JSON.stringify(context.fixId));
                        }
                    });
                }
            });
        }
    });
    // src/services/codefixes/fixUnreachableCode.ts
    function doChange26(changes, sourceFile, start, length2, errorCode) {
        const token = getTokenAtPosition(sourceFile, start);
        const statement = findAncestor(token, isStatement);
        if (statement.getStart(sourceFile) !== token.getStart(sourceFile)) {
            const logData = JSON.stringify({
                statementKind: Debug.formatSyntaxKind(statement.kind),
                tokenKind: Debug.formatSyntaxKind(token.kind),
                errorCode: errorCode,
                start: start,
                length: length2
            });
            Debug.fail("Token and statement should start at the same point. " + logData);
        }
        const container = (isBlock(statement.parent) ? statement.parent : statement).parent;
        if (!isBlock(statement.parent) || statement === first(statement.parent.statements)) switch(container.kind){
            case 244 /* IfStatement */ :
                if (container.elseStatement) {
                    if (isBlock(statement.parent)) break;
                    else changes.replaceNode(sourceFile, statement, factory.createBlock(emptyArray));
                    return;
                }
            case 246 /* WhileStatement */ :
            case 247 /* ForStatement */ :
                changes.delete(sourceFile, container);
                return;
        }
        if (isBlock(statement.parent)) {
            const end = start + length2;
            const lastStatement = Debug.checkDefined(lastWhere(sliceAfter(statement.parent.statements, statement), (s)=>s.pos < end), "Some statement should be last");
            changes.deleteNodeRange(sourceFile, statement, lastStatement);
        } else changes.delete(sourceFile, statement);
    }
    function lastWhere(a, pred) {
        let last2;
        for (const value1 of a){
            if (!pred(value1)) break;
            last2 = value1;
        }
        return last2;
    }
    var fixId33, errorCodes42;
    var init_fixUnreachableCode = __esm({
        "src/services/codefixes/fixUnreachableCode.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId33 = "fixUnreachableCode";
            errorCodes42 = [
                Diagnostics.Unreachable_code_detected.code
            ];
            registerCodeFix({
                errorCodes: errorCodes42,
                getCodeActions (context) {
                    const syntacticDiagnostics = context.program.getSyntacticDiagnostics(context.sourceFile, context.cancellationToken);
                    if (syntacticDiagnostics.length) return;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange26(t, context.sourceFile, context.span.start, context.span.length, context.errorCode));
                    return [
                        createCodeFixAction(fixId33, changes, Diagnostics.Remove_unreachable_code, fixId33, Diagnostics.Remove_all_unreachable_code)
                    ];
                },
                fixIds: [
                    fixId33
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes42, (changes, diag2)=>doChange26(changes, diag2.file, diag2.start, diag2.length, diag2.code))
            });
        }
    });
    // src/services/codefixes/fixUnusedLabel.ts
    function doChange27(changes, sourceFile, start) {
        const token = getTokenAtPosition(sourceFile, start);
        const labeledStatement = cast(token.parent, isLabeledStatement);
        const pos = token.getStart(sourceFile);
        const statementPos = labeledStatement.statement.getStart(sourceFile);
        const end = positionsAreOnSameLine(pos, statementPos, sourceFile) ? statementPos : skipTrivia(sourceFile.text, findChildOfKind(labeledStatement, 59 /* ColonToken */ , sourceFile).end, /*stopAfterLineBreak*/ true);
        changes.deleteRange(sourceFile, {
            pos: pos,
            end: end
        });
    }
    var fixId34, errorCodes43;
    var init_fixUnusedLabel = __esm({
        "src/services/codefixes/fixUnusedLabel.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId34 = "fixUnusedLabel";
            errorCodes43 = [
                Diagnostics.Unused_label.code
            ];
            registerCodeFix({
                errorCodes: errorCodes43,
                getCodeActions (context) {
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange27(t, context.sourceFile, context.span.start));
                    return [
                        createCodeFixAction(fixId34, changes, Diagnostics.Remove_unused_label, fixId34, Diagnostics.Remove_all_unused_labels)
                    ];
                },
                fixIds: [
                    fixId34
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes43, (changes, diag2)=>doChange27(changes, diag2.file, diag2.start))
            });
        }
    });
    // src/services/codefixes/fixJSDocTypes.ts
    function doChange28(changes, sourceFile, oldTypeNode, newType, checker) {
        changes.replaceNode(sourceFile, oldTypeNode, checker.typeToTypeNode(newType, /*enclosingDeclaration*/ oldTypeNode, /*flags*/ void 0));
    }
    function getInfo14(sourceFile, pos, checker) {
        const decl = findAncestor(getTokenAtPosition(sourceFile, pos), isTypeContainer);
        const typeNode = decl && decl.type;
        return typeNode && {
            typeNode: typeNode,
            type: getType(checker, typeNode)
        };
    }
    function isTypeContainer(node) {
        switch(node.kind){
            case 233 /* AsExpression */ :
            case 178 /* CallSignature */ :
            case 179 /* ConstructSignature */ :
            case 261 /* FunctionDeclaration */ :
            case 176 /* GetAccessor */ :
            case 180 /* IndexSignature */ :
            case 199 /* MappedType */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 168 /* Parameter */ :
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
            case 177 /* SetAccessor */ :
            case 264 /* TypeAliasDeclaration */ :
            case 215 /* TypeAssertionExpression */ :
            case 259 /* VariableDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function getType(checker, node) {
        if (isJSDocNullableType(node)) {
            const type = checker.getTypeFromTypeNode(node.type);
            if (type === checker.getNeverType() || type === checker.getVoidType()) return type;
            return checker.getUnionType(append([
                type,
                checker.getUndefinedType()
            ], node.postfix ? void 0 : checker.getNullType()));
        }
        return checker.getTypeFromTypeNode(node);
    }
    var fixIdPlain, fixIdNullable, errorCodes44;
    var init_fixJSDocTypes = __esm({
        "src/services/codefixes/fixJSDocTypes.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixIdPlain = "fixJSDocTypes_plain";
            fixIdNullable = "fixJSDocTypes_nullable";
            errorCodes44 = [
                Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments.code,
                Diagnostics._0_at_the_end_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1.code,
                Diagnostics._0_at_the_start_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1.code
            ];
            registerCodeFix({
                errorCodes: errorCodes44,
                getCodeActions (context) {
                    const { sourceFile: sourceFile  } = context;
                    const checker = context.program.getTypeChecker();
                    const info = getInfo14(sourceFile, context.span.start, checker);
                    if (!info) return void 0;
                    const { typeNode: typeNode , type: type  } = info;
                    const original = typeNode.getText(sourceFile);
                    const actions2 = [
                        fix(type, fixIdPlain, Diagnostics.Change_all_jsdoc_style_types_to_TypeScript)
                    ];
                    if (typeNode.kind === 320 /* JSDocNullableType */ ) actions2.push(fix(type, fixIdNullable, Diagnostics.Change_all_jsdoc_style_types_to_TypeScript_and_add_undefined_to_nullable_types));
                    return actions2;
                    function fix(type2, fixId52, fixAllDescription) {
                        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange28(t, sourceFile, typeNode, type2, checker));
                        return createCodeFixAction("jdocTypes", changes, [
                            Diagnostics.Change_0_to_1,
                            original,
                            checker.typeToString(type2)
                        ], fixId52, fixAllDescription);
                    }
                },
                fixIds: [
                    fixIdPlain,
                    fixIdNullable
                ],
                getAllCodeActions (context) {
                    const { fixId: fixId52 , program: program , sourceFile: sourceFile  } = context;
                    const checker = program.getTypeChecker();
                    return codeFixAll(context, errorCodes44, (changes, err)=>{
                        const info = getInfo14(err.file, err.start, checker);
                        if (!info) return;
                        const { typeNode: typeNode , type: type  } = info;
                        const fixedType = typeNode.kind === 320 /* JSDocNullableType */  && fixId52 === fixIdNullable ? checker.getNullableType(type, 32768 /* Undefined */ ) : type;
                        doChange28(changes, sourceFile, typeNode, fixedType, checker);
                    });
                }
            });
        }
    });
    // src/services/codefixes/fixMissingCallParentheses.ts
    function doChange29(changes, sourceFile, name) {
        changes.replaceNodeWithText(sourceFile, name, `${name.text}()`);
    }
    function getCallName(sourceFile, start) {
        const token = getTokenAtPosition(sourceFile, start);
        if (isPropertyAccessExpression(token.parent)) {
            let current = token.parent;
            while(isPropertyAccessExpression(current.parent))current = current.parent;
            return current.name;
        }
        if (isIdentifier(token)) return token;
        return void 0;
    }
    var fixId35, errorCodes45;
    var init_fixMissingCallParentheses = __esm({
        "src/services/codefixes/fixMissingCallParentheses.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId35 = "fixMissingCallParentheses";
            errorCodes45 = [
                Diagnostics.This_condition_will_always_return_true_since_this_function_is_always_defined_Did_you_mean_to_call_it_instead.code
            ];
            registerCodeFix({
                errorCodes: errorCodes45,
                fixIds: [
                    fixId35
                ],
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const callName = getCallName(sourceFile, span.start);
                    if (!callName) return;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange29(t, context.sourceFile, callName));
                    return [
                        createCodeFixAction(fixId35, changes, Diagnostics.Add_missing_call_parentheses, fixId35, Diagnostics.Add_all_missing_call_parentheses)
                    ];
                },
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes45, (changes, diag2)=>{
                        const callName = getCallName(diag2.file, diag2.start);
                        if (callName) doChange29(changes, diag2.file, callName);
                    })
            });
        }
    });
    // src/services/codefixes/fixAwaitInSyncFunction.ts
    function getReturnType(expr) {
        if (expr.type) return expr.type;
        if (isVariableDeclaration(expr.parent) && expr.parent.type && isFunctionTypeNode(expr.parent.type)) return expr.parent.type.type;
    }
    function getNodes3(sourceFile, start) {
        const token = getTokenAtPosition(sourceFile, start);
        const containingFunction = getContainingFunction(token);
        if (!containingFunction) return;
        let insertBefore;
        switch(containingFunction.kind){
            case 173 /* MethodDeclaration */ :
                insertBefore = containingFunction.name;
                break;
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
                insertBefore = findChildOfKind(containingFunction, 100 /* FunctionKeyword */ , sourceFile);
                break;
            case 218 /* ArrowFunction */ :
                const kind = containingFunction.typeParameters ? 30 /* LessThanToken */  : 21 /* OpenParenToken */ ;
                insertBefore = findChildOfKind(containingFunction, kind, sourceFile) || first(containingFunction.parameters);
                break;
            default:
                return;
        }
        return insertBefore && {
            insertBefore: insertBefore,
            returnType: getReturnType(containingFunction)
        };
    }
    function doChange30(changes, sourceFile, { insertBefore: insertBefore , returnType: returnType  }) {
        if (returnType) {
            const entityName = getEntityNameFromTypeNode(returnType);
            if (!entityName || entityName.kind !== 80 /* Identifier */  || entityName.text !== "Promise") changes.replaceNode(sourceFile, returnType, factory.createTypeReferenceNode("Promise", factory.createNodeArray([
                returnType
            ])));
        }
        changes.insertModifierBefore(sourceFile, 134 /* AsyncKeyword */ , insertBefore);
    }
    var fixId36, errorCodes46;
    var init_fixAwaitInSyncFunction = __esm({
        "src/services/codefixes/fixAwaitInSyncFunction.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId36 = "fixAwaitInSyncFunction";
            errorCodes46 = [
                Diagnostics.await_expressions_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules.code,
                Diagnostics.for_await_loops_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules.code,
                Diagnostics.Cannot_find_name_0_Did_you_mean_to_write_this_in_an_async_function.code
            ];
            registerCodeFix({
                errorCodes: errorCodes46,
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const nodes = getNodes3(sourceFile, span.start);
                    if (!nodes) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange30(t, sourceFile, nodes));
                    return [
                        createCodeFixAction(fixId36, changes, Diagnostics.Add_async_modifier_to_containing_function, fixId36, Diagnostics.Add_all_missing_async_modifiers)
                    ];
                },
                fixIds: [
                    fixId36
                ],
                getAllCodeActions: function getAllCodeActionsToFixAwaitInSyncFunction(context) {
                    const seen = /* @__PURE__ */ new Map();
                    return codeFixAll(context, errorCodes46, (changes, diag2)=>{
                        const nodes = getNodes3(diag2.file, diag2.start);
                        if (!nodes || !addToSeen(seen, getNodeId(nodes.insertBefore))) return;
                        doChange30(changes, context.sourceFile, nodes);
                    });
                }
            });
        }
    });
    // src/services/codefixes/fixPropertyOverrideAccessor.ts
    function doChange31(file, start, length2, code, context) {
        let startPosition;
        let endPosition;
        if (code === Diagnostics._0_is_defined_as_an_accessor_in_class_1_but_is_overridden_here_in_2_as_an_instance_property.code) {
            startPosition = start;
            endPosition = start + length2;
        } else if (code === Diagnostics._0_is_defined_as_a_property_in_class_1_but_is_overridden_here_in_2_as_an_accessor.code) {
            const checker = context.program.getTypeChecker();
            const node = getTokenAtPosition(file, start).parent;
            Debug.assert(isAccessor(node), "error span of fixPropertyOverrideAccessor should only be on an accessor");
            const containingClass = node.parent;
            Debug.assert(isClassLike(containingClass), "erroneous accessors should only be inside classes");
            const base = singleOrUndefined(getAllSupers(containingClass, checker));
            if (!base) return [];
            const name = unescapeLeadingUnderscores(getTextOfPropertyName(node.name));
            const baseProp = checker.getPropertyOfType(checker.getTypeAtLocation(base), name);
            if (!baseProp || !baseProp.valueDeclaration) return [];
            startPosition = baseProp.valueDeclaration.pos;
            endPosition = baseProp.valueDeclaration.end;
            file = getSourceFileOfNode(baseProp.valueDeclaration);
        } else Debug.fail("fixPropertyOverrideAccessor codefix got unexpected error code " + code);
        return generateAccessorFromProperty(file, context.program, startPosition, endPosition, context, Diagnostics.Generate_get_and_set_accessors.message);
    }
    var errorCodes47, fixId37;
    var init_fixPropertyOverrideAccessor = __esm({
        "src/services/codefixes/fixPropertyOverrideAccessor.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            errorCodes47 = [
                Diagnostics._0_is_defined_as_an_accessor_in_class_1_but_is_overridden_here_in_2_as_an_instance_property.code,
                Diagnostics._0_is_defined_as_a_property_in_class_1_but_is_overridden_here_in_2_as_an_accessor.code
            ];
            fixId37 = "fixPropertyOverrideAccessor";
            registerCodeFix({
                errorCodes: errorCodes47,
                getCodeActions (context) {
                    const edits = doChange31(context.sourceFile, context.span.start, context.span.length, context.errorCode, context);
                    if (edits) return [
                        createCodeFixAction(fixId37, edits, Diagnostics.Generate_get_and_set_accessors, fixId37, Diagnostics.Generate_get_and_set_accessors_for_all_overriding_properties)
                    ];
                },
                fixIds: [
                    fixId37
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes47, (changes, diag2)=>{
                        const edits = doChange31(diag2.file, diag2.start, diag2.length, diag2.code, context);
                        if (edits) for (const edit of edits)changes.pushRaw(context.sourceFile, edit);
                    })
            });
        }
    });
    // src/services/codefixes/inferFromUsage.ts
    function getDiagnostic(errorCode, token) {
        switch(errorCode){
            case Diagnostics.Parameter_0_implicitly_has_an_1_type.code:
            case Diagnostics.Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code:
                return isSetAccessorDeclaration(getContainingFunction(token)) ? Diagnostics.Infer_type_of_0_from_usage : Diagnostics.Infer_parameter_types_from_usage;
            case Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code:
            case Diagnostics.Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Infer_parameter_types_from_usage;
            case Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation.code:
                return Diagnostics.Infer_this_type_of_0_from_usage;
            default:
                return Diagnostics.Infer_type_of_0_from_usage;
        }
    }
    function mapSuggestionDiagnostic(errorCode) {
        switch(errorCode){
            case Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined.code;
            case Diagnostics.Variable_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Variable_0_implicitly_has_an_1_type.code;
            case Diagnostics.Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Parameter_0_implicitly_has_an_1_type.code;
            case Diagnostics.Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code;
            case Diagnostics.Property_0_implicitly_has_type_any_but_a_better_type_for_its_get_accessor_may_be_inferred_from_usage.code:
                return Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation.code;
            case Diagnostics._0_implicitly_has_an_1_return_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type.code;
            case Diagnostics.Property_0_implicitly_has_type_any_but_a_better_type_for_its_set_accessor_may_be_inferred_from_usage.code:
                return Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation.code;
            case Diagnostics.Member_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Member_0_implicitly_has_an_1_type.code;
        }
        return errorCode;
    }
    function doChange32(changes, sourceFile, token, errorCode, program, cancellationToken, markSeen, host, preferences) {
        if (!isParameterPropertyModifier(token.kind) && token.kind !== 80 /* Identifier */  && token.kind !== 26 /* DotDotDotToken */  && token.kind !== 110 /* ThisKeyword */ ) return void 0;
        const { parent: parent2  } = token;
        const importAdder = createImportAdder(sourceFile, program, preferences, host);
        errorCode = mapSuggestionDiagnostic(errorCode);
        switch(errorCode){
            case Diagnostics.Member_0_implicitly_has_an_1_type.code:
            case Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined.code:
                if (isVariableDeclaration(parent2) && markSeen(parent2) || isPropertyDeclaration(parent2) || isPropertySignature(parent2)) {
                    annotateVariableDeclaration(changes, importAdder, sourceFile, parent2, program, host, cancellationToken);
                    importAdder.writeFixes(changes);
                    return parent2;
                }
                if (isPropertyAccessExpression(parent2)) {
                    const type = inferTypeForVariableFromUsage(parent2.name, program, cancellationToken);
                    const typeNode = getTypeNodeIfAccessible(type, parent2, program, host);
                    if (typeNode) {
                        const typeTag = factory.createJSDocTypeTag(/*tagName*/ void 0, factory.createJSDocTypeExpression(typeNode), /*comment*/ void 0);
                        changes.addJSDocTags(sourceFile, cast(parent2.parent.parent, isExpressionStatement), [
                            typeTag
                        ]);
                    }
                    importAdder.writeFixes(changes);
                    return parent2;
                }
                return void 0;
            case Diagnostics.Variable_0_implicitly_has_an_1_type.code:
                {
                    const symbol = program.getTypeChecker().getSymbolAtLocation(token);
                    if (symbol && symbol.valueDeclaration && isVariableDeclaration(symbol.valueDeclaration) && markSeen(symbol.valueDeclaration)) {
                        annotateVariableDeclaration(changes, importAdder, getSourceFileOfNode(symbol.valueDeclaration), symbol.valueDeclaration, program, host, cancellationToken);
                        importAdder.writeFixes(changes);
                        return symbol.valueDeclaration;
                    }
                    return void 0;
                }
        }
        const containingFunction = getContainingFunction(token);
        if (containingFunction === void 0) return void 0;
        let declaration;
        switch(errorCode){
            case Diagnostics.Parameter_0_implicitly_has_an_1_type.code:
                if (isSetAccessorDeclaration(containingFunction)) {
                    annotateSetAccessor(changes, importAdder, sourceFile, containingFunction, program, host, cancellationToken);
                    declaration = containingFunction;
                    break;
                }
            case Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code:
                if (markSeen(containingFunction)) {
                    const param = cast(parent2, isParameter);
                    annotateParameters(changes, importAdder, sourceFile, param, containingFunction, program, host, cancellationToken);
                    declaration = param;
                }
                break;
            case Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation.code:
            case Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type.code:
                if (isGetAccessorDeclaration(containingFunction) && isIdentifier(containingFunction.name)) {
                    annotate(changes, importAdder, sourceFile, containingFunction, inferTypeForVariableFromUsage(containingFunction.name, program, cancellationToken), program, host);
                    declaration = containingFunction;
                }
                break;
            case Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation.code:
                if (isSetAccessorDeclaration(containingFunction)) {
                    annotateSetAccessor(changes, importAdder, sourceFile, containingFunction, program, host, cancellationToken);
                    declaration = containingFunction;
                }
                break;
            case Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation.code:
                if (ts_textChanges_exports.isThisTypeAnnotatable(containingFunction) && markSeen(containingFunction)) {
                    annotateThis(changes, sourceFile, containingFunction, program, host, cancellationToken);
                    declaration = containingFunction;
                }
                break;
            default:
                return Debug.fail(String(errorCode));
        }
        importAdder.writeFixes(changes);
        return declaration;
    }
    function annotateVariableDeclaration(changes, importAdder, sourceFile, declaration, program, host, cancellationToken) {
        if (isIdentifier(declaration.name)) annotate(changes, importAdder, sourceFile, declaration, inferTypeForVariableFromUsage(declaration.name, program, cancellationToken), program, host);
    }
    function annotateParameters(changes, importAdder, sourceFile, parameterDeclaration, containingFunction, program, host, cancellationToken) {
        if (!isIdentifier(parameterDeclaration.name)) return;
        const parameterInferences = inferTypeForParametersFromUsage(containingFunction, sourceFile, program, cancellationToken);
        Debug.assert(containingFunction.parameters.length === parameterInferences.length, "Parameter count and inference count should match");
        if (isInJSFile(containingFunction)) annotateJSDocParameters(changes, sourceFile, parameterInferences, program, host);
        else {
            const needParens = isArrowFunction(containingFunction) && !findChildOfKind(containingFunction, 21 /* OpenParenToken */ , sourceFile);
            if (needParens) changes.insertNodeBefore(sourceFile, first(containingFunction.parameters), factory.createToken(21 /* OpenParenToken */ ));
            for (const { declaration: declaration , type: type  } of parameterInferences)if (declaration && !declaration.type && !declaration.initializer) annotate(changes, importAdder, sourceFile, declaration, type, program, host);
            if (needParens) changes.insertNodeAfter(sourceFile, last(containingFunction.parameters), factory.createToken(22 /* CloseParenToken */ ));
        }
    }
    function annotateThis(changes, sourceFile, containingFunction, program, host, cancellationToken) {
        const references = getFunctionReferences(containingFunction, sourceFile, program, cancellationToken);
        if (!references || !references.length) return;
        const thisInference = inferTypeFromReferences(program, references, cancellationToken).thisParameter();
        const typeNode = getTypeNodeIfAccessible(thisInference, containingFunction, program, host);
        if (!typeNode) return;
        if (isInJSFile(containingFunction)) annotateJSDocThis(changes, sourceFile, containingFunction, typeNode);
        else changes.tryInsertThisTypeAnnotation(sourceFile, containingFunction, typeNode);
    }
    function annotateJSDocThis(changes, sourceFile, containingFunction, typeNode) {
        changes.addJSDocTags(sourceFile, containingFunction, [
            factory.createJSDocThisTag(/*tagName*/ void 0, factory.createJSDocTypeExpression(typeNode))
        ]);
    }
    function annotateSetAccessor(changes, importAdder, sourceFile, setAccessorDeclaration, program, host, cancellationToken) {
        const param = firstOrUndefined(setAccessorDeclaration.parameters);
        if (param && isIdentifier(setAccessorDeclaration.name) && isIdentifier(param.name)) {
            let type = inferTypeForVariableFromUsage(setAccessorDeclaration.name, program, cancellationToken);
            if (type === program.getTypeChecker().getAnyType()) type = inferTypeForVariableFromUsage(param.name, program, cancellationToken);
            if (isInJSFile(setAccessorDeclaration)) annotateJSDocParameters(changes, sourceFile, [
                {
                    declaration: param,
                    type: type
                }
            ], program, host);
            else annotate(changes, importAdder, sourceFile, param, type, program, host);
        }
    }
    function annotate(changes, importAdder, sourceFile, declaration, type, program, host) {
        const typeNode = getTypeNodeIfAccessible(type, declaration, program, host);
        if (typeNode) {
            if (isInJSFile(sourceFile) && declaration.kind !== 170 /* PropertySignature */ ) {
                const parent2 = isVariableDeclaration(declaration) ? tryCast(declaration.parent.parent, isVariableStatement) : declaration;
                if (!parent2) return;
                const typeExpression = factory.createJSDocTypeExpression(typeNode);
                const typeTag = isGetAccessorDeclaration(declaration) ? factory.createJSDocReturnTag(/*tagName*/ void 0, typeExpression, /*comment*/ void 0) : factory.createJSDocTypeTag(/*tagName*/ void 0, typeExpression, /*comment*/ void 0);
                changes.addJSDocTags(sourceFile, parent2, [
                    typeTag
                ]);
            } else if (!tryReplaceImportTypeNodeWithAutoImport(typeNode, declaration, sourceFile, changes, importAdder, getEmitScriptTarget(program.getCompilerOptions()))) changes.tryInsertTypeAnnotation(sourceFile, declaration, typeNode);
        }
    }
    function tryReplaceImportTypeNodeWithAutoImport(typeNode, declaration, sourceFile, changes, importAdder, scriptTarget) {
        const importableReference = tryGetAutoImportableReferenceFromTypeNode(typeNode, scriptTarget);
        if (importableReference && changes.tryInsertTypeAnnotation(sourceFile, declaration, importableReference.typeNode)) {
            forEach(importableReference.symbols, (s)=>importAdder.addImportFromExportedSymbol(s, /*isValidTypeOnlyUseSite*/ true));
            return true;
        }
        return false;
    }
    function annotateJSDocParameters(changes, sourceFile, parameterInferences, program, host) {
        const signature = parameterInferences.length && parameterInferences[0].declaration.parent;
        if (!signature) return;
        const inferences = mapDefined(parameterInferences, (inference)=>{
            const param = inference.declaration;
            if (param.initializer || getJSDocType(param) || !isIdentifier(param.name)) return;
            const typeNode = inference.type && getTypeNodeIfAccessible(inference.type, param, program, host);
            if (typeNode) {
                const name = factory.cloneNode(param.name);
                setEmitFlags(name, 7168 /* NoNestedComments */ );
                return {
                    name: factory.cloneNode(param.name),
                    param: param,
                    isOptional: !!inference.isOptional,
                    typeNode: typeNode
                };
            }
        });
        if (!inferences.length) return;
        if (isArrowFunction(signature) || isFunctionExpression(signature)) {
            const needParens = isArrowFunction(signature) && !findChildOfKind(signature, 21 /* OpenParenToken */ , sourceFile);
            if (needParens) changes.insertNodeBefore(sourceFile, first(signature.parameters), factory.createToken(21 /* OpenParenToken */ ));
            forEach(inferences, ({ typeNode: typeNode , param: param  })=>{
                const typeTag = factory.createJSDocTypeTag(/*tagName*/ void 0, factory.createJSDocTypeExpression(typeNode));
                const jsDoc = factory.createJSDocComment(/*comment*/ void 0, [
                    typeTag
                ]);
                changes.insertNodeAt(sourceFile, param.getStart(sourceFile), jsDoc, {
                    suffix: " "
                });
            });
            if (needParens) changes.insertNodeAfter(sourceFile, last(signature.parameters), factory.createToken(22 /* CloseParenToken */ ));
        } else {
            const paramTags = map(inferences, ({ name: name , typeNode: typeNode , isOptional: isOptional  })=>factory.createJSDocParameterTag(/*tagName*/ void 0, name, /*isBracketed*/ !!isOptional, factory.createJSDocTypeExpression(typeNode), /*isNameFirst*/ false, /*comment*/ void 0));
            changes.addJSDocTags(sourceFile, signature, paramTags);
        }
    }
    function getReferences(token, program, cancellationToken) {
        return mapDefined(ts_FindAllReferences_exports.getReferenceEntriesForNode(-1, token, program, program.getSourceFiles(), cancellationToken), (entry)=>entry.kind !== ts_FindAllReferences_exports.EntryKind.Span ? tryCast(entry.node, isIdentifier) : void 0);
    }
    function inferTypeForVariableFromUsage(token, program, cancellationToken) {
        const references = getReferences(token, program, cancellationToken);
        return inferTypeFromReferences(program, references, cancellationToken).single();
    }
    function inferTypeForParametersFromUsage(func, sourceFile, program, cancellationToken) {
        const references = getFunctionReferences(func, sourceFile, program, cancellationToken);
        return references && inferTypeFromReferences(program, references, cancellationToken).parameters(func) || func.parameters.map((p)=>({
                declaration: p,
                type: isIdentifier(p.name) ? inferTypeForVariableFromUsage(p.name, program, cancellationToken) : program.getTypeChecker().getAnyType()
            }));
    }
    function getFunctionReferences(containingFunction, sourceFile, program, cancellationToken) {
        let searchToken;
        switch(containingFunction.kind){
            case 175 /* Constructor */ :
                searchToken = findChildOfKind(containingFunction, 137 /* ConstructorKeyword */ , sourceFile);
                break;
            case 218 /* ArrowFunction */ :
            case 217 /* FunctionExpression */ :
                const parent2 = containingFunction.parent;
                searchToken = (isVariableDeclaration(parent2) || isPropertyDeclaration(parent2)) && isIdentifier(parent2.name) ? parent2.name : containingFunction.name;
                break;
            case 261 /* FunctionDeclaration */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
                searchToken = containingFunction.name;
                break;
        }
        if (!searchToken) return void 0;
        return getReferences(searchToken, program, cancellationToken);
    }
    function inferTypeFromReferences(program, references, cancellationToken) {
        const checker = program.getTypeChecker();
        const builtinConstructors = {
            string: ()=>checker.getStringType(),
            number: ()=>checker.getNumberType(),
            Array: (t)=>checker.createArrayType(t),
            Promise: (t)=>checker.createPromiseType(t)
        };
        const builtins = [
            checker.getStringType(),
            checker.getNumberType(),
            checker.createArrayType(checker.getAnyType()),
            checker.createPromiseType(checker.getAnyType())
        ];
        return {
            single: single2,
            parameters: parameters,
            thisParameter: thisParameter
        };
        function createEmptyUsage() {
            return {
                isNumber: void 0,
                isString: void 0,
                isNumberOrString: void 0,
                candidateTypes: void 0,
                properties: void 0,
                calls: void 0,
                constructs: void 0,
                numberIndex: void 0,
                stringIndex: void 0,
                candidateThisTypes: void 0,
                inferredTypes: void 0
            };
        }
        function combineUsages(usages) {
            const combinedProperties = /* @__PURE__ */ new Map();
            for (const u of usages)if (u.properties) u.properties.forEach((p, name)=>{
                if (!combinedProperties.has(name)) combinedProperties.set(name, []);
                combinedProperties.get(name).push(p);
            });
            const properties = /* @__PURE__ */ new Map();
            combinedProperties.forEach((ps, name)=>{
                properties.set(name, combineUsages(ps));
            });
            return {
                isNumber: usages.some((u)=>u.isNumber),
                isString: usages.some((u)=>u.isString),
                isNumberOrString: usages.some((u)=>u.isNumberOrString),
                candidateTypes: flatMap(usages, (u)=>u.candidateTypes),
                properties: properties,
                calls: flatMap(usages, (u)=>u.calls),
                constructs: flatMap(usages, (u)=>u.constructs),
                numberIndex: forEach(usages, (u)=>u.numberIndex),
                stringIndex: forEach(usages, (u)=>u.stringIndex),
                candidateThisTypes: flatMap(usages, (u)=>u.candidateThisTypes),
                inferredTypes: void 0
            };
        }
        function single2() {
            return combineTypes(inferTypesFromReferencesSingle(references));
        }
        function parameters(declaration) {
            if (references.length === 0 || !declaration.parameters) return void 0;
            const usage = createEmptyUsage();
            for (const reference of references){
                cancellationToken.throwIfCancellationRequested();
                calculateUsageOfNode(reference, usage);
            }
            const calls = [
                ...usage.constructs || [],
                ...usage.calls || []
            ];
            return declaration.parameters.map((parameter, parameterIndex)=>{
                const types = [];
                const isRest = isRestParameter(parameter);
                let isOptional = false;
                for (const call of calls){
                    if (call.argumentTypes.length <= parameterIndex) {
                        isOptional = isInJSFile(declaration);
                        types.push(checker.getUndefinedType());
                    } else if (isRest) for(let i = parameterIndex; i < call.argumentTypes.length; i++)types.push(checker.getBaseTypeOfLiteralType(call.argumentTypes[i]));
                    else types.push(checker.getBaseTypeOfLiteralType(call.argumentTypes[parameterIndex]));
                }
                if (isIdentifier(parameter.name)) {
                    const inferred = inferTypesFromReferencesSingle(getReferences(parameter.name, program, cancellationToken));
                    types.push(...isRest ? mapDefined(inferred, checker.getElementTypeOfArrayType) : inferred);
                }
                const type = combineTypes(types);
                return {
                    type: isRest ? checker.createArrayType(type) : type,
                    isOptional: isOptional && !isRest,
                    declaration: parameter
                };
            });
        }
        function thisParameter() {
            const usage = createEmptyUsage();
            for (const reference of references){
                cancellationToken.throwIfCancellationRequested();
                calculateUsageOfNode(reference, usage);
            }
            return combineTypes(usage.candidateThisTypes || emptyArray);
        }
        function inferTypesFromReferencesSingle(references2) {
            const usage = createEmptyUsage();
            for (const reference of references2){
                cancellationToken.throwIfCancellationRequested();
                calculateUsageOfNode(reference, usage);
            }
            return inferTypes(usage);
        }
        function calculateUsageOfNode(node, usage) {
            while(isRightSideOfQualifiedNameOrPropertyAccess(node))node = node.parent;
            switch(node.parent.kind){
                case 243 /* ExpressionStatement */ :
                    inferTypeFromExpressionStatement(node, usage);
                    break;
                case 224 /* PostfixUnaryExpression */ :
                    usage.isNumber = true;
                    break;
                case 223 /* PrefixUnaryExpression */ :
                    inferTypeFromPrefixUnaryExpression(node.parent, usage);
                    break;
                case 225 /* BinaryExpression */ :
                    inferTypeFromBinaryExpression(node, node.parent, usage);
                    break;
                case 295 /* CaseClause */ :
                case 296 /* DefaultClause */ :
                    inferTypeFromSwitchStatementLabel(node.parent, usage);
                    break;
                case 212 /* CallExpression */ :
                case 213 /* NewExpression */ :
                    if (node.parent.expression === node) inferTypeFromCallExpression(node.parent, usage);
                    else inferTypeFromContextualType(node, usage);
                    break;
                case 210 /* PropertyAccessExpression */ :
                    inferTypeFromPropertyAccessExpression(node.parent, usage);
                    break;
                case 211 /* ElementAccessExpression */ :
                    inferTypeFromPropertyElementExpression(node.parent, node, usage);
                    break;
                case 302 /* PropertyAssignment */ :
                case 303 /* ShorthandPropertyAssignment */ :
                    inferTypeFromPropertyAssignment(node.parent, usage);
                    break;
                case 171 /* PropertyDeclaration */ :
                    inferTypeFromPropertyDeclaration(node.parent, usage);
                    break;
                case 259 /* VariableDeclaration */ :
                    {
                        const { name: name , initializer: initializer  } = node.parent;
                        if (node === name) {
                            if (initializer) addCandidateType(usage, checker.getTypeAtLocation(initializer));
                            break;
                        }
                    }
                default:
                    return inferTypeFromContextualType(node, usage);
            }
        }
        function inferTypeFromContextualType(node, usage) {
            if (isExpressionNode(node)) addCandidateType(usage, checker.getContextualType(node));
        }
        function inferTypeFromExpressionStatement(node, usage) {
            addCandidateType(usage, isCallExpression(node) ? checker.getVoidType() : checker.getAnyType());
        }
        function inferTypeFromPrefixUnaryExpression(node, usage) {
            switch(node.operator){
                case 46 /* PlusPlusToken */ :
                case 47 /* MinusMinusToken */ :
                case 41 /* MinusToken */ :
                case 55 /* TildeToken */ :
                    usage.isNumber = true;
                    break;
                case 40 /* PlusToken */ :
                    usage.isNumberOrString = true;
                    break;
            }
        }
        function inferTypeFromBinaryExpression(node, parent2, usage) {
            switch(parent2.operatorToken.kind){
                case 43 /* AsteriskAsteriskToken */ :
                case 42 /* AsteriskToken */ :
                case 44 /* SlashToken */ :
                case 45 /* PercentToken */ :
                case 48 /* LessThanLessThanToken */ :
                case 49 /* GreaterThanGreaterThanToken */ :
                case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                case 51 /* AmpersandToken */ :
                case 52 /* BarToken */ :
                case 53 /* CaretToken */ :
                case 66 /* MinusEqualsToken */ :
                case 68 /* AsteriskAsteriskEqualsToken */ :
                case 67 /* AsteriskEqualsToken */ :
                case 69 /* SlashEqualsToken */ :
                case 70 /* PercentEqualsToken */ :
                case 74 /* AmpersandEqualsToken */ :
                case 75 /* BarEqualsToken */ :
                case 79 /* CaretEqualsToken */ :
                case 71 /* LessThanLessThanEqualsToken */ :
                case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                case 72 /* GreaterThanGreaterThanEqualsToken */ :
                case 41 /* MinusToken */ :
                case 30 /* LessThanToken */ :
                case 33 /* LessThanEqualsToken */ :
                case 32 /* GreaterThanToken */ :
                case 34 /* GreaterThanEqualsToken */ :
                    const operandType = checker.getTypeAtLocation(parent2.left === node ? parent2.right : parent2.left);
                    if (operandType.flags & 1056 /* EnumLike */ ) addCandidateType(usage, operandType);
                    else usage.isNumber = true;
                    break;
                case 65 /* PlusEqualsToken */ :
                case 40 /* PlusToken */ :
                    const otherOperandType = checker.getTypeAtLocation(parent2.left === node ? parent2.right : parent2.left);
                    if (otherOperandType.flags & 1056 /* EnumLike */ ) addCandidateType(usage, otherOperandType);
                    else if (otherOperandType.flags & 296 /* NumberLike */ ) usage.isNumber = true;
                    else if (otherOperandType.flags & 402653316 /* StringLike */ ) usage.isString = true;
                    else if (otherOperandType.flags & 1 /* Any */ ) ;
                    else usage.isNumberOrString = true;
                    break;
                case 64 /* EqualsToken */ :
                case 35 /* EqualsEqualsToken */ :
                case 37 /* EqualsEqualsEqualsToken */ :
                case 38 /* ExclamationEqualsEqualsToken */ :
                case 36 /* ExclamationEqualsToken */ :
                case 77 /* AmpersandAmpersandEqualsToken */ :
                case 78 /* QuestionQuestionEqualsToken */ :
                case 76 /* BarBarEqualsToken */ :
                    addCandidateType(usage, checker.getTypeAtLocation(parent2.left === node ? parent2.right : parent2.left));
                    break;
                case 103 /* InKeyword */ :
                    if (node === parent2.left) usage.isString = true;
                    break;
                case 57 /* BarBarToken */ :
                case 61 /* QuestionQuestionToken */ :
                    if (node === parent2.left && (node.parent.parent.kind === 259 /* VariableDeclaration */  || isAssignmentExpression(node.parent.parent, /*excludeCompoundAssignment*/ true))) addCandidateType(usage, checker.getTypeAtLocation(parent2.right));
                    break;
                case 56 /* AmpersandAmpersandToken */ :
                case 28 /* CommaToken */ :
                case 104 /* InstanceOfKeyword */ :
                    break;
            }
        }
        function inferTypeFromSwitchStatementLabel(parent2, usage) {
            addCandidateType(usage, checker.getTypeAtLocation(parent2.parent.parent.expression));
        }
        function inferTypeFromCallExpression(parent2, usage) {
            const call = {
                argumentTypes: [],
                return_: createEmptyUsage()
            };
            if (parent2.arguments) for (const argument of parent2.arguments)call.argumentTypes.push(checker.getTypeAtLocation(argument));
            calculateUsageOfNode(parent2, call.return_);
            if (parent2.kind === 212 /* CallExpression */ ) (usage.calls || (usage.calls = [])).push(call);
            else (usage.constructs || (usage.constructs = [])).push(call);
        }
        function inferTypeFromPropertyAccessExpression(parent2, usage) {
            const name = escapeLeadingUnderscores(parent2.name.text);
            if (!usage.properties) usage.properties = /* @__PURE__ */ new Map();
            const propertyUsage = usage.properties.get(name) || createEmptyUsage();
            calculateUsageOfNode(parent2, propertyUsage);
            usage.properties.set(name, propertyUsage);
        }
        function inferTypeFromPropertyElementExpression(parent2, node, usage) {
            if (node === parent2.argumentExpression) {
                usage.isNumberOrString = true;
                return;
            } else {
                const indexType = checker.getTypeAtLocation(parent2.argumentExpression);
                const indexUsage = createEmptyUsage();
                calculateUsageOfNode(parent2, indexUsage);
                if (indexType.flags & 296 /* NumberLike */ ) usage.numberIndex = indexUsage;
                else usage.stringIndex = indexUsage;
            }
        }
        function inferTypeFromPropertyAssignment(assignment, usage) {
            const nodeWithRealType = isVariableDeclaration(assignment.parent.parent) ? assignment.parent.parent : assignment.parent;
            addCandidateThisType(usage, checker.getTypeAtLocation(nodeWithRealType));
        }
        function inferTypeFromPropertyDeclaration(declaration, usage) {
            addCandidateThisType(usage, checker.getTypeAtLocation(declaration.parent));
        }
        function removeLowPriorityInferences(inferences, priorities) {
            const toRemove = [];
            for (const i of inferences){
                for (const { high: high , low: low  } of priorities)if (high(i)) {
                    Debug.assert(!low(i), "Priority can't have both low and high");
                    toRemove.push(low);
                }
            }
            return inferences.filter((i)=>toRemove.every((f)=>!f(i)));
        }
        function combineFromUsage(usage) {
            return combineTypes(inferTypes(usage));
        }
        function combineTypes(inferences) {
            if (!inferences.length) return checker.getAnyType();
            const stringNumber = checker.getUnionType([
                checker.getStringType(),
                checker.getNumberType()
            ]);
            const priorities = [
                {
                    high: (t)=>t === checker.getStringType() || t === checker.getNumberType(),
                    low: (t)=>t === stringNumber
                },
                {
                    high: (t)=>!(t.flags & 16385 /* Void */ ),
                    low: (t)=>!!(t.flags & 16385 /* Void */ )
                },
                {
                    high: (t)=>!(t.flags & 114689 /* Void */ ) && !(getObjectFlags(t) & 16 /* Anonymous */ ),
                    low: (t)=>!!(getObjectFlags(t) & 16 /* Anonymous */ )
                }
            ];
            let good = removeLowPriorityInferences(inferences, priorities);
            const anons = good.filter((i)=>getObjectFlags(i) & 16 /* Anonymous */ );
            if (anons.length) {
                good = good.filter((i)=>!(getObjectFlags(i) & 16 /* Anonymous */ ));
                good.push(combineAnonymousTypes(anons));
            }
            return checker.getWidenedType(checker.getUnionType(good.map(checker.getBaseTypeOfLiteralType), 2 /* Subtype */ ));
        }
        function combineAnonymousTypes(anons) {
            if (anons.length === 1) return anons[0];
            const calls = [];
            const constructs = [];
            const stringIndices = [];
            const numberIndices = [];
            let stringIndexReadonly = false;
            let numberIndexReadonly = false;
            const props = createMultiMap();
            for (const anon2 of anons){
                for (const p of checker.getPropertiesOfType(anon2))props.add(p.escapedName, p.valueDeclaration ? checker.getTypeOfSymbolAtLocation(p, p.valueDeclaration) : checker.getAnyType());
                calls.push(...checker.getSignaturesOfType(anon2, 0 /* Call */ ));
                constructs.push(...checker.getSignaturesOfType(anon2, 1 /* Construct */ ));
                const stringIndexInfo = checker.getIndexInfoOfType(anon2, 0 /* String */ );
                if (stringIndexInfo) {
                    stringIndices.push(stringIndexInfo.type);
                    stringIndexReadonly = stringIndexReadonly || stringIndexInfo.isReadonly;
                }
                const numberIndexInfo = checker.getIndexInfoOfType(anon2, 1 /* Number */ );
                if (numberIndexInfo) {
                    numberIndices.push(numberIndexInfo.type);
                    numberIndexReadonly = numberIndexReadonly || numberIndexInfo.isReadonly;
                }
            }
            const members = mapEntries(props, (name, types)=>{
                const isOptional = types.length < anons.length ? 16777216 /* Optional */  : 0;
                const s = checker.createSymbol(4 /* Property */  | isOptional, name);
                s.links.type = checker.getUnionType(types);
                return [
                    name,
                    s
                ];
            });
            const indexInfos = [];
            if (stringIndices.length) indexInfos.push(checker.createIndexInfo(checker.getStringType(), checker.getUnionType(stringIndices), stringIndexReadonly));
            if (numberIndices.length) indexInfos.push(checker.createIndexInfo(checker.getNumberType(), checker.getUnionType(numberIndices), numberIndexReadonly));
            return checker.createAnonymousType(anons[0].symbol, members, calls, constructs, indexInfos);
        }
        function inferTypes(usage) {
            var _a, _b, _c;
            const types = [];
            if (usage.isNumber) types.push(checker.getNumberType());
            if (usage.isString) types.push(checker.getStringType());
            if (usage.isNumberOrString) types.push(checker.getUnionType([
                checker.getStringType(),
                checker.getNumberType()
            ]));
            if (usage.numberIndex) types.push(checker.createArrayType(combineFromUsage(usage.numberIndex)));
            if (((_a = usage.properties) == null ? void 0 : _a.size) || ((_b = usage.constructs) == null ? void 0 : _b.length) || usage.stringIndex) types.push(inferStructuralType(usage));
            const candidateTypes = (usage.candidateTypes || []).map((t)=>checker.getBaseTypeOfLiteralType(t));
            const callsType = ((_c = usage.calls) == null ? void 0 : _c.length) ? inferStructuralType(usage) : void 0;
            if (callsType && candidateTypes) types.push(checker.getUnionType([
                callsType,
                ...candidateTypes
            ], 2 /* Subtype */ ));
            else {
                if (callsType) types.push(callsType);
                if (length(candidateTypes)) types.push(...candidateTypes);
            }
            types.push(...inferNamedTypesFromProperties(usage));
            return types;
        }
        function inferStructuralType(usage) {
            const members = /* @__PURE__ */ new Map();
            if (usage.properties) usage.properties.forEach((u, name)=>{
                const symbol = checker.createSymbol(4 /* Property */ , name);
                symbol.links.type = combineFromUsage(u);
                members.set(name, symbol);
            });
            const callSignatures = usage.calls ? [
                getSignatureFromCalls(usage.calls)
            ] : [];
            const constructSignatures = usage.constructs ? [
                getSignatureFromCalls(usage.constructs)
            ] : [];
            const indexInfos = usage.stringIndex ? [
                checker.createIndexInfo(checker.getStringType(), combineFromUsage(usage.stringIndex), /*isReadonly*/ false)
            ] : [];
            return checker.createAnonymousType(/*symbol*/ void 0, members, callSignatures, constructSignatures, indexInfos);
        }
        function inferNamedTypesFromProperties(usage) {
            if (!usage.properties || !usage.properties.size) return [];
            const types = builtins.filter((t)=>allPropertiesAreAssignableToUsage(t, usage));
            if (0 < types.length && types.length < 3) return types.map((t)=>inferInstantiationFromUsage(t, usage));
            return [];
        }
        function allPropertiesAreAssignableToUsage(type, usage) {
            if (!usage.properties) return false;
            return !forEachEntry(usage.properties, (propUsage, name)=>{
                const source = checker.getTypeOfPropertyOfType(type, name);
                if (!source) return true;
                if (propUsage.calls) {
                    const sigs = checker.getSignaturesOfType(source, 0 /* Call */ );
                    return !sigs.length || !checker.isTypeAssignableTo(source, getFunctionFromCalls(propUsage.calls));
                } else return !checker.isTypeAssignableTo(source, combineFromUsage(propUsage));
            });
        }
        function inferInstantiationFromUsage(type, usage) {
            if (!(getObjectFlags(type) & 4 /* Reference */ ) || !usage.properties) return type;
            const generic = type.target;
            const singleTypeParameter = singleOrUndefined(generic.typeParameters);
            if (!singleTypeParameter) return type;
            const types = [];
            usage.properties.forEach((propUsage, name)=>{
                const genericPropertyType = checker.getTypeOfPropertyOfType(generic, name);
                Debug.assert(!!genericPropertyType, "generic should have all the properties of its reference.");
                types.push(...inferTypeParameters(genericPropertyType, combineFromUsage(propUsage), singleTypeParameter));
            });
            return builtinConstructors[type.symbol.escapedName](combineTypes(types));
        }
        function inferTypeParameters(genericType, usageType, typeParameter) {
            if (genericType === typeParameter) return [
                usageType
            ];
            else if (genericType.flags & 3145728 /* UnionOrIntersection */ ) return flatMap(genericType.types, (t)=>inferTypeParameters(t, usageType, typeParameter));
            else if (getObjectFlags(genericType) & 4 /* Reference */  && getObjectFlags(usageType) & 4 /* Reference */ ) {
                const genericArgs = checker.getTypeArguments(genericType);
                const usageArgs = checker.getTypeArguments(usageType);
                const types = [];
                if (genericArgs && usageArgs) {
                    for(let i = 0; i < genericArgs.length; i++)if (usageArgs[i]) types.push(...inferTypeParameters(genericArgs[i], usageArgs[i], typeParameter));
                }
                return types;
            }
            const genericSigs = checker.getSignaturesOfType(genericType, 0 /* Call */ );
            const usageSigs = checker.getSignaturesOfType(usageType, 0 /* Call */ );
            if (genericSigs.length === 1 && usageSigs.length === 1) return inferFromSignatures(genericSigs[0], usageSigs[0], typeParameter);
            return [];
        }
        function inferFromSignatures(genericSig, usageSig, typeParameter) {
            var _a;
            const types = [];
            for(let i = 0; i < genericSig.parameters.length; i++){
                const genericParam = genericSig.parameters[i];
                const usageParam = usageSig.parameters[i];
                const isRest = genericSig.declaration && isRestParameter(genericSig.declaration.parameters[i]);
                if (!usageParam) break;
                let genericParamType = genericParam.valueDeclaration ? checker.getTypeOfSymbolAtLocation(genericParam, genericParam.valueDeclaration) : checker.getAnyType();
                const elementType = isRest && checker.getElementTypeOfArrayType(genericParamType);
                if (elementType) genericParamType = elementType;
                const targetType = ((_a = tryCast(usageParam, isTransientSymbol)) == null ? void 0 : _a.links.type) || (usageParam.valueDeclaration ? checker.getTypeOfSymbolAtLocation(usageParam, usageParam.valueDeclaration) : checker.getAnyType());
                types.push(...inferTypeParameters(genericParamType, targetType, typeParameter));
            }
            const genericReturn = checker.getReturnTypeOfSignature(genericSig);
            const usageReturn = checker.getReturnTypeOfSignature(usageSig);
            types.push(...inferTypeParameters(genericReturn, usageReturn, typeParameter));
            return types;
        }
        function getFunctionFromCalls(calls) {
            return checker.createAnonymousType(/*symbol*/ void 0, createSymbolTable(), [
                getSignatureFromCalls(calls)
            ], emptyArray, emptyArray);
        }
        function getSignatureFromCalls(calls) {
            const parameters2 = [];
            const length2 = Math.max(...calls.map((c)=>c.argumentTypes.length));
            for(let i = 0; i < length2; i++){
                const symbol = checker.createSymbol(1 /* FunctionScopedVariable */ , escapeLeadingUnderscores(`arg${i}`));
                symbol.links.type = combineTypes(calls.map((call)=>call.argumentTypes[i] || checker.getUndefinedType()));
                if (calls.some((call)=>call.argumentTypes[i] === void 0)) symbol.flags |= 16777216 /* Optional */ ;
                parameters2.push(symbol);
            }
            const returnType = combineFromUsage(combineUsages(calls.map((call)=>call.return_)));
            return checker.createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, parameters2, returnType, /*typePredicate*/ void 0, length2, 0 /* None */ );
        }
        function addCandidateType(usage, type) {
            if (type && !(type.flags & 1 /* Any */ ) && !(type.flags & 131072 /* Never */ )) (usage.candidateTypes || (usage.candidateTypes = [])).push(type);
        }
        function addCandidateThisType(usage, type) {
            if (type && !(type.flags & 1 /* Any */ ) && !(type.flags & 131072 /* Never */ )) (usage.candidateThisTypes || (usage.candidateThisTypes = [])).push(type);
        }
    }
    var fixId38, errorCodes48;
    var init_inferFromUsage = __esm({
        "src/services/codefixes/inferFromUsage.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId38 = "inferFromUsage";
            errorCodes48 = [
                // Variable declarations
                Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined.code,
                // Variable uses
                Diagnostics.Variable_0_implicitly_has_an_1_type.code,
                // Parameter declarations
                Diagnostics.Parameter_0_implicitly_has_an_1_type.code,
                Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code,
                // Get Accessor declarations
                Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation.code,
                Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type.code,
                // Set Accessor declarations
                Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation.code,
                // Property declarations
                Diagnostics.Member_0_implicitly_has_an_1_type.code,
                //// Suggestions
                // Variable declarations
                Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_but_a_better_type_may_be_inferred_from_usage.code,
                // Variable uses
                Diagnostics.Variable_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code,
                // Parameter declarations
                Diagnostics.Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code,
                Diagnostics.Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage.code,
                // Get Accessor declarations
                Diagnostics.Property_0_implicitly_has_type_any_but_a_better_type_for_its_get_accessor_may_be_inferred_from_usage.code,
                Diagnostics._0_implicitly_has_an_1_return_type_but_a_better_type_may_be_inferred_from_usage.code,
                // Set Accessor declarations
                Diagnostics.Property_0_implicitly_has_type_any_but_a_better_type_for_its_set_accessor_may_be_inferred_from_usage.code,
                // Property declarations
                Diagnostics.Member_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code,
                // Function expressions and declarations
                Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation.code
            ];
            registerCodeFix({
                errorCodes: errorCodes48,
                getCodeActions (context) {
                    const { sourceFile: sourceFile , program: program , span: { start: start  } , errorCode: errorCode , cancellationToken: cancellationToken , host: host , preferences: preferences  } = context;
                    const token = getTokenAtPosition(sourceFile, start);
                    let declaration;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (changes2)=>{
                        declaration = doChange32(changes2, sourceFile, token, errorCode, program, cancellationToken, /*markSeen*/ returnTrue, host, preferences);
                    });
                    const name = declaration && getNameOfDeclaration(declaration);
                    return !name || changes.length === 0 ? void 0 : [
                        createCodeFixAction(fixId38, changes, [
                            getDiagnostic(errorCode, token),
                            getTextOfNode(name)
                        ], fixId38, Diagnostics.Infer_all_types_from_usage)
                    ];
                },
                fixIds: [
                    fixId38
                ],
                getAllCodeActions (context) {
                    const { sourceFile: sourceFile , program: program , cancellationToken: cancellationToken , host: host , preferences: preferences  } = context;
                    const markSeen = nodeSeenTracker();
                    return codeFixAll(context, errorCodes48, (changes, err)=>{
                        doChange32(changes, sourceFile, getTokenAtPosition(err.file, err.start), err.code, program, cancellationToken, markSeen, host, preferences);
                    });
                }
            });
        }
    });
    // src/services/codefixes/fixReturnTypeInAsyncFunction.ts
    function getInfo15(sourceFile, checker, pos) {
        if (isInJSFile(sourceFile)) return void 0;
        const token = getTokenAtPosition(sourceFile, pos);
        const func = findAncestor(token, isFunctionLikeDeclaration);
        const returnTypeNode = func == null ? void 0 : func.type;
        if (!returnTypeNode) return void 0;
        const returnType = checker.getTypeFromTypeNode(returnTypeNode);
        const promisedType = checker.getAwaitedType(returnType) || checker.getVoidType();
        const promisedTypeNode = checker.typeToTypeNode(promisedType, /*enclosingDeclaration*/ returnTypeNode, /*flags*/ void 0);
        if (promisedTypeNode) return {
            returnTypeNode: returnTypeNode,
            returnType: returnType,
            promisedTypeNode: promisedTypeNode,
            promisedType: promisedType
        };
    }
    function doChange33(changes, sourceFile, returnTypeNode, promisedTypeNode) {
        changes.replaceNode(sourceFile, returnTypeNode, factory.createTypeReferenceNode("Promise", [
            promisedTypeNode
        ]));
    }
    var fixId39, errorCodes49;
    var init_fixReturnTypeInAsyncFunction = __esm({
        "src/services/codefixes/fixReturnTypeInAsyncFunction.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId39 = "fixReturnTypeInAsyncFunction";
            errorCodes49 = [
                Diagnostics.The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type_Did_you_mean_to_write_Promise_0.code
            ];
            registerCodeFix({
                errorCodes: errorCodes49,
                fixIds: [
                    fixId39
                ],
                getCodeActions: function getCodeActionsToFixReturnTypeInAsyncFunction(context) {
                    const { sourceFile: sourceFile , program: program , span: span  } = context;
                    const checker = program.getTypeChecker();
                    const info = getInfo15(sourceFile, program.getTypeChecker(), span.start);
                    if (!info) return void 0;
                    const { returnTypeNode: returnTypeNode , returnType: returnType , promisedTypeNode: promisedTypeNode , promisedType: promisedType  } = info;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange33(t, sourceFile, returnTypeNode, promisedTypeNode));
                    return [
                        createCodeFixAction(fixId39, changes, [
                            Diagnostics.Replace_0_with_Promise_1,
                            checker.typeToString(returnType),
                            checker.typeToString(promisedType)
                        ], fixId39, Diagnostics.Fix_all_incorrect_return_type_of_an_async_functions)
                    ];
                },
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes49, (changes, diag2)=>{
                        const info = getInfo15(diag2.file, context.program.getTypeChecker(), diag2.start);
                        if (info) doChange33(changes, diag2.file, info.returnTypeNode, info.promisedTypeNode);
                    })
            });
        }
    });
    // src/services/codefixes/disableJsDiagnostics.ts
    function makeChange8(changes, sourceFile, position, seenLines) {
        const { line: lineNumber  } = getLineAndCharacterOfPosition(sourceFile, position);
        if (!seenLines || tryAddToSet(seenLines, lineNumber)) changes.insertCommentBeforeLine(sourceFile, lineNumber, position, " @ts-ignore");
    }
    var fixName4, fixId40, errorCodes50;
    var init_disableJsDiagnostics = __esm({
        "src/services/codefixes/disableJsDiagnostics.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixName4 = "disableJsDiagnostics";
            fixId40 = "disableJsDiagnostics";
            errorCodes50 = mapDefined(Object.keys(Diagnostics), (key)=>{
                const diag2 = Diagnostics[key];
                return diag2.category === 1 /* Error */  ? diag2.code : void 0;
            });
            registerCodeFix({
                errorCodes: errorCodes50,
                getCodeActions: function getCodeActionsToDisableJsDiagnostics(context) {
                    const { sourceFile: sourceFile , program: program , span: span , host: host , formatContext: formatContext  } = context;
                    if (!isInJSFile(sourceFile) || !isCheckJsEnabledForFile(sourceFile, program.getCompilerOptions())) return void 0;
                    const newLineCharacter = sourceFile.checkJsDirective ? "" : getNewLineOrDefaultFromHost(host, formatContext.options);
                    const fixes = [
                        // fixId unnecessary because adding `// @ts-nocheck` even once will ignore every error in the file.
                        createCodeFixActionWithoutFixAll(fixName4, [
                            createFileTextChanges(sourceFile.fileName, [
                                createTextChange(sourceFile.checkJsDirective ? createTextSpanFromBounds(sourceFile.checkJsDirective.pos, sourceFile.checkJsDirective.end) : createTextSpan(0, 0), `// @ts-nocheck${newLineCharacter}`)
                            ])
                        ], Diagnostics.Disable_checking_for_this_file)
                    ];
                    if (ts_textChanges_exports.isValidLocationToAddComment(sourceFile, span.start)) fixes.unshift(createCodeFixAction(fixName4, ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange8(t, sourceFile, span.start)), Diagnostics.Ignore_this_error_message, fixId40, Diagnostics.Add_ts_ignore_to_all_error_messages));
                    return fixes;
                },
                fixIds: [
                    fixId40
                ],
                getAllCodeActions: (context)=>{
                    const seenLines = /* @__PURE__ */ new Set();
                    return codeFixAll(context, errorCodes50, (changes, diag2)=>{
                        if (ts_textChanges_exports.isValidLocationToAddComment(diag2.file, diag2.start)) makeChange8(changes, diag2.file, diag2.start, seenLines);
                    });
                }
            });
        }
    });
    // src/services/codefixes/helpers.ts
    function createMissingMemberNodes(classDeclaration, possiblyMissingSymbols, sourceFile, context, preferences, importAdder, addClassElement) {
        const classMembers = classDeclaration.symbol.members;
        for (const symbol of possiblyMissingSymbols)if (!classMembers.has(symbol.escapedName)) addNewNodeForMemberSymbol(symbol, classDeclaration, sourceFile, context, preferences, importAdder, addClassElement, /*body*/ void 0);
    }
    function getNoopSymbolTrackerWithResolver(context) {
        return {
            trackSymbol: ()=>false,
            moduleResolverHost: getModuleSpecifierResolverHost(context.program, context.host)
        };
    }
    function addNewNodeForMemberSymbol(symbol, enclosingDeclaration, sourceFile, context, preferences, importAdder, addClassElement, body, preserveOptional = 3 /* All */ , isAmbient = false) {
        const declarations = symbol.getDeclarations();
        const declaration = declarations == null ? void 0 : declarations[0];
        const checker = context.program.getTypeChecker();
        const scriptTarget = getEmitScriptTarget(context.program.getCompilerOptions());
        const kind = (declaration == null ? void 0 : declaration.kind) ?? 170 /* PropertySignature */ ;
        const declarationName = getSynthesizedDeepClone(getNameOfDeclaration(declaration), /*includeTrivia*/ false);
        const effectiveModifierFlags = declaration ? getEffectiveModifierFlags(declaration) : 0 /* None */ ;
        let modifierFlags = effectiveModifierFlags & 4 /* Public */  ? 4 /* Public */  : effectiveModifierFlags & 16 /* Protected */  ? 16 /* Protected */  : 0 /* None */ ;
        if (declaration && isAutoAccessorPropertyDeclaration(declaration)) modifierFlags |= 128 /* Accessor */ ;
        const modifiers = createModifiers();
        const type = checker.getWidenedType(checker.getTypeOfSymbolAtLocation(symbol, enclosingDeclaration));
        const optional = !!(symbol.flags & 16777216 /* Optional */ );
        const ambient = !!(enclosingDeclaration.flags & 16777216 /* Ambient */ ) || isAmbient;
        const quotePreference = getQuotePreference(sourceFile, preferences);
        switch(kind){
            case 170 /* PropertySignature */ :
            case 171 /* PropertyDeclaration */ :
                const flags = quotePreference === 0 /* Single */  ? 268435456 /* UseSingleQuotesForStringLiteralType */  : void 0;
                let typeNode = checker.typeToTypeNode(type, enclosingDeclaration, flags, getNoopSymbolTrackerWithResolver(context));
                if (importAdder) {
                    const importableReference = tryGetAutoImportableReferenceFromTypeNode(typeNode, scriptTarget);
                    if (importableReference) {
                        typeNode = importableReference.typeNode;
                        importSymbols(importAdder, importableReference.symbols);
                    }
                }
                addClassElement(factory.createPropertyDeclaration(modifiers, declaration ? createName(declarationName) : symbol.getName(), optional && preserveOptional & 2 /* Property */  ? factory.createToken(58 /* QuestionToken */ ) : void 0, typeNode, /*initializer*/ void 0));
                break;
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
                {
                    Debug.assertIsDefined(declarations);
                    let typeNode2 = checker.typeToTypeNode(type, enclosingDeclaration, /*flags*/ void 0, getNoopSymbolTrackerWithResolver(context));
                    const allAccessors = getAllAccessorDeclarations(declarations, declaration);
                    const orderedAccessors = allAccessors.secondAccessor ? [
                        allAccessors.firstAccessor,
                        allAccessors.secondAccessor
                    ] : [
                        allAccessors.firstAccessor
                    ];
                    if (importAdder) {
                        const importableReference = tryGetAutoImportableReferenceFromTypeNode(typeNode2, scriptTarget);
                        if (importableReference) {
                            typeNode2 = importableReference.typeNode;
                            importSymbols(importAdder, importableReference.symbols);
                        }
                    }
                    for (const accessor of orderedAccessors)if (isGetAccessorDeclaration(accessor)) addClassElement(factory.createGetAccessorDeclaration(modifiers, createName(declarationName), emptyArray, createTypeNode(typeNode2), createBody(body, quotePreference, ambient)));
                    else {
                        Debug.assertNode(accessor, isSetAccessorDeclaration, "The counterpart to a getter should be a setter");
                        const parameter = getSetAccessorValueParameter(accessor);
                        const parameterName = parameter && isIdentifier(parameter.name) ? idText(parameter.name) : void 0;
                        addClassElement(factory.createSetAccessorDeclaration(modifiers, createName(declarationName), createDummyParameters(1, [
                            parameterName
                        ], [
                            createTypeNode(typeNode2)
                        ], 1, /*inJs*/ false), createBody(body, quotePreference, ambient)));
                    }
                    break;
                }
            case 172 /* MethodSignature */ :
            case 173 /* MethodDeclaration */ :
                Debug.assertIsDefined(declarations);
                const signatures = type.isUnion() ? flatMap(type.types, (t)=>t.getCallSignatures()) : type.getCallSignatures();
                if (!some(signatures)) break;
                if (declarations.length === 1) {
                    Debug.assert(signatures.length === 1, "One declaration implies one signature");
                    const signature = signatures[0];
                    outputMethod(quotePreference, signature, modifiers, createName(declarationName), createBody(body, quotePreference, ambient));
                    break;
                }
                for (const signature of signatures)outputMethod(quotePreference, signature, modifiers, createName(declarationName));
                if (!ambient) {
                    if (declarations.length > signatures.length) {
                        const signature = checker.getSignatureFromDeclaration(declarations[declarations.length - 1]);
                        outputMethod(quotePreference, signature, modifiers, createName(declarationName), createBody(body, quotePreference));
                    } else {
                        Debug.assert(declarations.length === signatures.length, "Declarations and signatures should match count");
                        addClassElement(createMethodImplementingSignatures(checker, context, enclosingDeclaration, signatures, createName(declarationName), optional && !!(preserveOptional & 1 /* Method */ ), modifiers, quotePreference, body));
                    }
                }
                break;
        }
        function outputMethod(quotePreference2, signature, modifiers2, name, body2) {
            const method = createSignatureDeclarationFromSignature(173 /* MethodDeclaration */ , context, quotePreference2, signature, body2, name, modifiers2, optional && !!(preserveOptional & 1 /* Method */ ), enclosingDeclaration, importAdder);
            if (method) addClassElement(method);
        }
        function createModifiers() {
            let modifiers2;
            if (modifierFlags) modifiers2 = combine(modifiers2, factory.createModifiersFromModifierFlags(modifierFlags));
            if (shouldAddOverrideKeyword()) modifiers2 = append(modifiers2, factory.createToken(163 /* OverrideKeyword */ ));
            return modifiers2 && factory.createNodeArray(modifiers2);
        }
        function shouldAddOverrideKeyword() {
            return !!(context.program.getCompilerOptions().noImplicitOverride && declaration && hasAbstractModifier(declaration));
        }
        function createName(node) {
            if (isIdentifier(node) && node.escapedText === "constructor") return factory.createComputedPropertyName(factory.createStringLiteral(idText(node), quotePreference === 0 /* Single */ ));
            return getSynthesizedDeepClone(node, /*includeTrivia*/ false);
        }
        function createBody(block, quotePreference2, ambient2) {
            return ambient2 ? void 0 : getSynthesizedDeepClone(block, /*includeTrivia*/ false) || createStubbedMethodBody(quotePreference2);
        }
        function createTypeNode(typeNode) {
            return getSynthesizedDeepClone(typeNode, /*includeTrivia*/ false);
        }
    }
    function createSignatureDeclarationFromSignature(kind, context, quotePreference, signature, body, name, modifiers, optional, enclosingDeclaration, importAdder) {
        const program = context.program;
        const checker = program.getTypeChecker();
        const scriptTarget = getEmitScriptTarget(program.getCompilerOptions());
        const isJs = isInJSFile(enclosingDeclaration);
        const flags = 524545 /* AllowEmptyTuple */  | (quotePreference === 0 /* Single */  ? 268435456 /* UseSingleQuotesForStringLiteralType */  : 0 /* None */ );
        const signatureDeclaration = checker.signatureToSignatureDeclaration(signature, kind, enclosingDeclaration, flags, getNoopSymbolTrackerWithResolver(context));
        if (!signatureDeclaration) return void 0;
        let typeParameters = isJs ? void 0 : signatureDeclaration.typeParameters;
        let parameters = signatureDeclaration.parameters;
        let type = isJs ? void 0 : signatureDeclaration.type;
        if (importAdder) {
            if (typeParameters) {
                const newTypeParameters = sameMap(typeParameters, (typeParameterDecl)=>{
                    let constraint = typeParameterDecl.constraint;
                    let defaultType = typeParameterDecl.default;
                    if (constraint) {
                        const importableReference = tryGetAutoImportableReferenceFromTypeNode(constraint, scriptTarget);
                        if (importableReference) {
                            constraint = importableReference.typeNode;
                            importSymbols(importAdder, importableReference.symbols);
                        }
                    }
                    if (defaultType) {
                        const importableReference = tryGetAutoImportableReferenceFromTypeNode(defaultType, scriptTarget);
                        if (importableReference) {
                            defaultType = importableReference.typeNode;
                            importSymbols(importAdder, importableReference.symbols);
                        }
                    }
                    return factory.updateTypeParameterDeclaration(typeParameterDecl, typeParameterDecl.modifiers, typeParameterDecl.name, constraint, defaultType);
                });
                if (typeParameters !== newTypeParameters) typeParameters = setTextRange(factory.createNodeArray(newTypeParameters, typeParameters.hasTrailingComma), typeParameters);
            }
            const newParameters = sameMap(parameters, (parameterDecl)=>{
                let type2 = isJs ? void 0 : parameterDecl.type;
                if (type2) {
                    const importableReference = tryGetAutoImportableReferenceFromTypeNode(type2, scriptTarget);
                    if (importableReference) {
                        type2 = importableReference.typeNode;
                        importSymbols(importAdder, importableReference.symbols);
                    }
                }
                return factory.updateParameterDeclaration(parameterDecl, parameterDecl.modifiers, parameterDecl.dotDotDotToken, parameterDecl.name, isJs ? void 0 : parameterDecl.questionToken, type2, parameterDecl.initializer);
            });
            if (parameters !== newParameters) parameters = setTextRange(factory.createNodeArray(newParameters, parameters.hasTrailingComma), parameters);
            if (type) {
                const importableReference = tryGetAutoImportableReferenceFromTypeNode(type, scriptTarget);
                if (importableReference) {
                    type = importableReference.typeNode;
                    importSymbols(importAdder, importableReference.symbols);
                }
            }
        }
        const questionToken = optional ? factory.createToken(58 /* QuestionToken */ ) : void 0;
        const asteriskToken = signatureDeclaration.asteriskToken;
        if (isFunctionExpression(signatureDeclaration)) return factory.updateFunctionExpression(signatureDeclaration, modifiers, signatureDeclaration.asteriskToken, tryCast(name, isIdentifier), typeParameters, parameters, type, body ?? signatureDeclaration.body);
        if (isArrowFunction(signatureDeclaration)) return factory.updateArrowFunction(signatureDeclaration, modifiers, typeParameters, parameters, type, signatureDeclaration.equalsGreaterThanToken, body ?? signatureDeclaration.body);
        if (isMethodDeclaration(signatureDeclaration)) return factory.updateMethodDeclaration(signatureDeclaration, modifiers, asteriskToken, name ?? factory.createIdentifier(""), questionToken, typeParameters, parameters, type, body);
        if (isFunctionDeclaration(signatureDeclaration)) return factory.updateFunctionDeclaration(signatureDeclaration, modifiers, signatureDeclaration.asteriskToken, tryCast(name, isIdentifier), typeParameters, parameters, type, body ?? signatureDeclaration.body);
        return void 0;
    }
    function createSignatureDeclarationFromCallExpression(kind, context, importAdder, call, name, modifierFlags, contextNode) {
        const quotePreference = getQuotePreference(context.sourceFile, context.preferences);
        const scriptTarget = getEmitScriptTarget(context.program.getCompilerOptions());
        const tracker = getNoopSymbolTrackerWithResolver(context);
        const checker = context.program.getTypeChecker();
        const isJs = isInJSFile(contextNode);
        const { typeArguments: typeArguments , arguments: args , parent: parent2  } = call;
        const contextualType = isJs ? void 0 : checker.getContextualType(call);
        const names = map(args, (arg)=>isIdentifier(arg) ? arg.text : isPropertyAccessExpression(arg) && isIdentifier(arg.name) ? arg.name.text : void 0);
        const instanceTypes = isJs ? [] : map(args, (arg)=>checker.getTypeAtLocation(arg));
        const { argumentTypeNodes: argumentTypeNodes , argumentTypeParameters: argumentTypeParameters  } = getArgumentTypesAndTypeParameters(checker, importAdder, instanceTypes, contextNode, scriptTarget, /*flags*/ void 0, tracker);
        const modifiers = modifierFlags ? factory.createNodeArray(factory.createModifiersFromModifierFlags(modifierFlags)) : void 0;
        const asteriskToken = isYieldExpression(parent2) ? factory.createToken(42 /* AsteriskToken */ ) : void 0;
        const typeParameters = isJs ? void 0 : createTypeParametersForArguments(checker, argumentTypeParameters, typeArguments);
        const parameters = createDummyParameters(args.length, names, argumentTypeNodes, /*minArgumentCount*/ void 0, isJs);
        const type = isJs || contextualType === void 0 ? void 0 : checker.typeToTypeNode(contextualType, contextNode, /*flags*/ void 0, tracker);
        switch(kind){
            case 173 /* MethodDeclaration */ :
                return factory.createMethodDeclaration(modifiers, asteriskToken, name, /*questionToken*/ void 0, typeParameters, parameters, type, createStubbedMethodBody(quotePreference));
            case 172 /* MethodSignature */ :
                return factory.createMethodSignature(modifiers, name, /*questionToken*/ void 0, typeParameters, parameters, type === void 0 ? factory.createKeywordTypeNode(159 /* UnknownKeyword */ ) : type);
            case 261 /* FunctionDeclaration */ :
                return factory.createFunctionDeclaration(modifiers, asteriskToken, name, typeParameters, parameters, type, createStubbedBody(Diagnostics.Function_not_implemented.message, quotePreference));
            default:
                Debug.fail("Unexpected kind");
        }
    }
    function createTypeParametersForArguments(checker, argumentTypeParameters, typeArguments) {
        const usedNames = new Set(argumentTypeParameters.map((pair)=>pair[0]));
        const constraintsByName = new Map(argumentTypeParameters);
        if (typeArguments) {
            const typeArgumentsWithNewTypes = typeArguments.filter((typeArgument)=>!argumentTypeParameters.some((pair)=>{
                    var _a;
                    return checker.getTypeAtLocation(typeArgument) === ((_a = pair[1]) == null ? void 0 : _a.argumentType);
                }));
            const targetSize = usedNames.size + typeArgumentsWithNewTypes.length;
            for(let i = 0; usedNames.size < targetSize; i += 1)usedNames.add(createTypeParameterName(i));
        }
        return arrayFrom(usedNames.values(), (usedName)=>{
            var _a;
            return factory.createTypeParameterDeclaration(/*modifiers*/ void 0, usedName, (_a = constraintsByName.get(usedName)) == null ? void 0 : _a.constraint);
        });
    }
    function createTypeParameterName(index) {
        return 84 /* T */  + index <= 90 /* Z */  ? String.fromCharCode(84 /* T */  + index) : `T${index}`;
    }
    function typeToAutoImportableTypeNode(checker, importAdder, type, contextNode, scriptTarget, flags, tracker) {
        let typeNode = checker.typeToTypeNode(type, contextNode, flags, tracker);
        if (typeNode && isImportTypeNode(typeNode)) {
            const importableReference = tryGetAutoImportableReferenceFromTypeNode(typeNode, scriptTarget);
            if (importableReference) {
                importSymbols(importAdder, importableReference.symbols);
                typeNode = importableReference.typeNode;
            }
        }
        return getSynthesizedDeepClone(typeNode);
    }
    function typeContainsTypeParameter(type) {
        if (type.isUnionOrIntersection()) return type.types.some(typeContainsTypeParameter);
        return type.flags & 262144 /* TypeParameter */ ;
    }
    function getArgumentTypesAndTypeParameters(checker, importAdder, instanceTypes, contextNode, scriptTarget, flags, tracker) {
        const argumentTypeNodes = [];
        const argumentTypeParameters = /* @__PURE__ */ new Map();
        for(let i = 0; i < instanceTypes.length; i += 1){
            const instanceType = instanceTypes[i];
            if (instanceType.isUnionOrIntersection() && instanceType.types.some(typeContainsTypeParameter)) {
                const synthesizedTypeParameterName = createTypeParameterName(i);
                argumentTypeNodes.push(factory.createTypeReferenceNode(synthesizedTypeParameterName));
                argumentTypeParameters.set(synthesizedTypeParameterName, void 0);
                continue;
            }
            const widenedInstanceType = checker.getBaseTypeOfLiteralType(instanceType);
            const argumentTypeNode = typeToAutoImportableTypeNode(checker, importAdder, widenedInstanceType, contextNode, scriptTarget, flags, tracker);
            if (!argumentTypeNode) continue;
            argumentTypeNodes.push(argumentTypeNode);
            const argumentTypeParameter = getFirstTypeParameterName(instanceType);
            const instanceTypeConstraint = instanceType.isTypeParameter() && instanceType.constraint && !isAnonymousObjectConstraintType(instanceType.constraint) ? typeToAutoImportableTypeNode(checker, importAdder, instanceType.constraint, contextNode, scriptTarget, flags, tracker) : void 0;
            if (argumentTypeParameter) argumentTypeParameters.set(argumentTypeParameter, {
                argumentType: instanceType,
                constraint: instanceTypeConstraint
            });
        }
        return {
            argumentTypeNodes: argumentTypeNodes,
            argumentTypeParameters: arrayFrom(argumentTypeParameters.entries())
        };
    }
    function isAnonymousObjectConstraintType(type) {
        return type.flags & 524288 /* Object */  && type.objectFlags === 16 /* Anonymous */ ;
    }
    function getFirstTypeParameterName(type) {
        var _a;
        if (type.flags & 3145728 /* Intersection */ ) for (const subType of type.types){
            const subTypeName = getFirstTypeParameterName(subType);
            if (subTypeName) return subTypeName;
        }
        return type.flags & 262144 /* TypeParameter */  ? (_a = type.getSymbol()) == null ? void 0 : _a.getName() : void 0;
    }
    function createDummyParameters(argCount, names, types, minArgumentCount, inJs) {
        const parameters = [];
        const parameterNameCounts = /* @__PURE__ */ new Map();
        for(let i = 0; i < argCount; i++){
            const parameterName = (names == null ? void 0 : names[i]) || `arg${i}`;
            const parameterNameCount = parameterNameCounts.get(parameterName);
            parameterNameCounts.set(parameterName, (parameterNameCount || 0) + 1);
            const newParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ parameterName + (parameterNameCount || ""), /*questionToken*/ minArgumentCount !== void 0 && i >= minArgumentCount ? factory.createToken(58 /* QuestionToken */ ) : void 0, /*type*/ inJs ? void 0 : (types == null ? void 0 : types[i]) || factory.createKeywordTypeNode(159 /* UnknownKeyword */ ), /*initializer*/ void 0);
            parameters.push(newParameter);
        }
        return parameters;
    }
    function createMethodImplementingSignatures(checker, context, enclosingDeclaration, signatures, name, optional, modifiers, quotePreference, body) {
        let maxArgsSignature = signatures[0];
        let minArgumentCount = signatures[0].minArgumentCount;
        let someSigHasRestParameter = false;
        for (const sig of signatures){
            minArgumentCount = Math.min(sig.minArgumentCount, minArgumentCount);
            if (signatureHasRestParameter(sig)) someSigHasRestParameter = true;
            if (sig.parameters.length >= maxArgsSignature.parameters.length && (!signatureHasRestParameter(sig) || signatureHasRestParameter(maxArgsSignature))) maxArgsSignature = sig;
        }
        const maxNonRestArgs = maxArgsSignature.parameters.length - (signatureHasRestParameter(maxArgsSignature) ? 1 : 0);
        const maxArgsParameterSymbolNames = maxArgsSignature.parameters.map((symbol)=>symbol.name);
        const parameters = createDummyParameters(maxNonRestArgs, maxArgsParameterSymbolNames, /*types*/ void 0, minArgumentCount, /*inJs*/ false);
        if (someSigHasRestParameter) {
            const restParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, factory.createToken(26 /* DotDotDotToken */ ), maxArgsParameterSymbolNames[maxNonRestArgs] || "rest", /*questionToken*/ maxNonRestArgs >= minArgumentCount ? factory.createToken(58 /* QuestionToken */ ) : void 0, factory.createArrayTypeNode(factory.createKeywordTypeNode(159 /* UnknownKeyword */ )), /*initializer*/ void 0);
            parameters.push(restParameter);
        }
        return createStubbedMethod(modifiers, name, optional, /*typeParameters*/ void 0, parameters, getReturnTypeFromSignatures(signatures, checker, context, enclosingDeclaration), quotePreference, body);
    }
    function getReturnTypeFromSignatures(signatures, checker, context, enclosingDeclaration) {
        if (length(signatures)) {
            const type = checker.getUnionType(map(signatures, checker.getReturnTypeOfSignature));
            return checker.typeToTypeNode(type, enclosingDeclaration, 1 /* NoTruncation */ , getNoopSymbolTrackerWithResolver(context));
        }
    }
    function createStubbedMethod(modifiers, name, optional, typeParameters, parameters, returnType, quotePreference, body) {
        return factory.createMethodDeclaration(modifiers, /*asteriskToken*/ void 0, name, optional ? factory.createToken(58 /* QuestionToken */ ) : void 0, typeParameters, parameters, returnType, body || createStubbedMethodBody(quotePreference));
    }
    function createStubbedMethodBody(quotePreference) {
        return createStubbedBody(Diagnostics.Method_not_implemented.message, quotePreference);
    }
    function createStubbedBody(text, quotePreference) {
        return factory.createBlock([
            factory.createThrowStatement(factory.createNewExpression(factory.createIdentifier("Error"), /*typeArguments*/ void 0, // TODO Handle auto quote preference.
            [
                factory.createStringLiteral(text, /*isSingleQuote*/ quotePreference === 0 /* Single */ )
            ]))
        ], /*multiLine*/ true);
    }
    function setJsonCompilerOptionValues(changeTracker, configFile, options) {
        const tsconfigObjectLiteral = getTsConfigObjectLiteralExpression(configFile);
        if (!tsconfigObjectLiteral) return void 0;
        const compilerOptionsProperty = findJsonProperty(tsconfigObjectLiteral, "compilerOptions");
        if (compilerOptionsProperty === void 0) {
            changeTracker.insertNodeAtObjectStart(configFile, tsconfigObjectLiteral, createJsonPropertyAssignment("compilerOptions", factory.createObjectLiteralExpression(options.map(([optionName, optionValue])=>createJsonPropertyAssignment(optionName, optionValue)), /*multiLine*/ true)));
            return;
        }
        const compilerOptions = compilerOptionsProperty.initializer;
        if (!isObjectLiteralExpression(compilerOptions)) return;
        for (const [optionName, optionValue] of options){
            const optionProperty = findJsonProperty(compilerOptions, optionName);
            if (optionProperty === void 0) changeTracker.insertNodeAtObjectStart(configFile, compilerOptions, createJsonPropertyAssignment(optionName, optionValue));
            else changeTracker.replaceNode(configFile, optionProperty.initializer, optionValue);
        }
    }
    function setJsonCompilerOptionValue(changeTracker, configFile, optionName, optionValue) {
        setJsonCompilerOptionValues(changeTracker, configFile, [
            [
                optionName,
                optionValue
            ]
        ]);
    }
    function createJsonPropertyAssignment(name, initializer) {
        return factory.createPropertyAssignment(factory.createStringLiteral(name), initializer);
    }
    function findJsonProperty(obj, name) {
        return find(obj.properties, (p)=>isPropertyAssignment(p) && !!p.name && isStringLiteral(p.name) && p.name.text === name);
    }
    function tryGetAutoImportableReferenceFromTypeNode(importTypeNode, scriptTarget) {
        let symbols;
        const typeNode = visitNode(importTypeNode, visit, isTypeNode);
        if (symbols && typeNode) return {
            typeNode: typeNode,
            symbols: symbols
        };
        function visit(node) {
            if (isLiteralImportTypeNode(node) && node.qualifier) {
                const firstIdentifier = getFirstIdentifier(node.qualifier);
                const name = getNameForExportedSymbol(firstIdentifier.symbol, scriptTarget);
                const qualifier = name !== firstIdentifier.text ? replaceFirstIdentifierOfEntityName(node.qualifier, factory.createIdentifier(name)) : node.qualifier;
                symbols = append(symbols, firstIdentifier.symbol);
                const typeArguments = visitNodes2(node.typeArguments, visit, isTypeNode);
                return factory.createTypeReferenceNode(qualifier, typeArguments);
            }
            return visitEachChild(node, visit, nullTransformationContext);
        }
    }
    function replaceFirstIdentifierOfEntityName(name, newIdentifier) {
        if (name.kind === 80 /* Identifier */ ) return newIdentifier;
        return factory.createQualifiedName(replaceFirstIdentifierOfEntityName(name.left, newIdentifier), name.right);
    }
    function importSymbols(importAdder, symbols) {
        symbols.forEach((s)=>importAdder.addImportFromExportedSymbol(s, /*isValidTypeOnlyUseSite*/ true));
    }
    function findAncestorMatchingSpan(sourceFile, span) {
        const end = textSpanEnd(span);
        let token = getTokenAtPosition(sourceFile, span.start);
        while(token.end < end)token = token.parent;
        return token;
    }
    var PreserveOptionalFlags;
    var init_helpers2 = __esm({
        "src/services/codefixes/helpers.ts" () {
            "use strict";
            init_ts4();
            PreserveOptionalFlags = /* @__PURE__ */ ((PreserveOptionalFlags2)=>{
                PreserveOptionalFlags2[PreserveOptionalFlags2["Method"] = 1] = "Method";
                PreserveOptionalFlags2[PreserveOptionalFlags2["Property"] = 2] = "Property";
                PreserveOptionalFlags2[PreserveOptionalFlags2["All"] = 3] = "All";
                return PreserveOptionalFlags2;
            })(PreserveOptionalFlags || {});
        }
    });
    // src/services/codefixes/generateAccessors.ts
    function generateAccessorFromProperty(file, program, start, end, context, _actionName) {
        const fieldInfo = getAccessorConvertiblePropertyAtPosition(file, program, start, end);
        if (!fieldInfo || ts_refactor_exports.isRefactorErrorInfo(fieldInfo)) return void 0;
        const changeTracker = ts_textChanges_exports.ChangeTracker.fromContext(context);
        const { isStatic: isStatic2 , isReadonly: isReadonly , fieldName: fieldName , accessorName: accessorName , originalName: originalName , type: type , container: container , declaration: declaration  } = fieldInfo;
        suppressLeadingAndTrailingTrivia(fieldName);
        suppressLeadingAndTrailingTrivia(accessorName);
        suppressLeadingAndTrailingTrivia(declaration);
        suppressLeadingAndTrailingTrivia(container);
        let accessorModifiers;
        let fieldModifiers;
        if (isClassLike(container)) {
            const modifierFlags = getEffectiveModifierFlags(declaration);
            if (isSourceFileJS(file)) {
                const modifiers = factory.createModifiersFromModifierFlags(modifierFlags);
                accessorModifiers = modifiers;
                fieldModifiers = modifiers;
            } else {
                accessorModifiers = factory.createModifiersFromModifierFlags(prepareModifierFlagsForAccessor(modifierFlags));
                fieldModifiers = factory.createModifiersFromModifierFlags(prepareModifierFlagsForField(modifierFlags));
            }
            if (canHaveDecorators(declaration)) fieldModifiers = concatenate(getDecorators(declaration), fieldModifiers);
        }
        updateFieldDeclaration(changeTracker, file, declaration, type, fieldName, fieldModifiers);
        const getAccessor = generateGetAccessor(fieldName, accessorName, type, accessorModifiers, isStatic2, container);
        suppressLeadingAndTrailingTrivia(getAccessor);
        insertAccessor(changeTracker, file, getAccessor, declaration, container);
        if (isReadonly) {
            const constructor = getFirstConstructorWithBody(container);
            if (constructor) updateReadonlyPropertyInitializerStatementConstructor(changeTracker, file, constructor, fieldName.text, originalName);
        } else {
            const setAccessor = generateSetAccessor(fieldName, accessorName, type, accessorModifiers, isStatic2, container);
            suppressLeadingAndTrailingTrivia(setAccessor);
            insertAccessor(changeTracker, file, setAccessor, declaration, container);
        }
        return changeTracker.getChanges();
    }
    function isConvertibleName(name) {
        return isIdentifier(name) || isStringLiteral(name);
    }
    function isAcceptedDeclaration(node) {
        return isParameterPropertyDeclaration(node, node.parent) || isPropertyDeclaration(node) || isPropertyAssignment(node);
    }
    function createPropertyName(name, originalName) {
        return isIdentifier(originalName) ? factory.createIdentifier(name) : factory.createStringLiteral(name);
    }
    function createAccessorAccessExpression(fieldName, isStatic2, container) {
        const leftHead = isStatic2 ? container.name : factory.createThis();
        return isIdentifier(fieldName) ? factory.createPropertyAccessExpression(leftHead, fieldName) : factory.createElementAccessExpression(leftHead, factory.createStringLiteralFromNode(fieldName));
    }
    function prepareModifierFlagsForAccessor(modifierFlags) {
        modifierFlags &= -65 /* Readonly */ ;
        modifierFlags &= -9 /* Private */ ;
        if (!(modifierFlags & 16 /* Protected */ )) modifierFlags |= 4 /* Public */ ;
        return modifierFlags;
    }
    function prepareModifierFlagsForField(modifierFlags) {
        modifierFlags &= -5 /* Public */ ;
        modifierFlags &= -17 /* Protected */ ;
        modifierFlags |= 8 /* Private */ ;
        return modifierFlags;
    }
    function getAccessorConvertiblePropertyAtPosition(file, program, start, end, considerEmptySpans = true) {
        const node = getTokenAtPosition(file, start);
        const cursorRequest = start === end && considerEmptySpans;
        const declaration = findAncestor(node.parent, isAcceptedDeclaration);
        const meaning = 124 /* Readonly */ ;
        if (!declaration || !(nodeOverlapsWithStartEnd(declaration.name, file, start, end) || cursorRequest)) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_property_for_which_to_generate_accessor)
        };
        if (!isConvertibleName(declaration.name)) return {
            error: getLocaleSpecificMessage(Diagnostics.Name_is_not_valid)
        };
        if ((getEffectiveModifierFlags(declaration) & 126975 /* Modifier */  | meaning) !== meaning) return {
            error: getLocaleSpecificMessage(Diagnostics.Can_only_convert_property_with_modifier)
        };
        const name = declaration.name.text;
        const startWithUnderscore = startsWithUnderscore(name);
        const fieldName = createPropertyName(startWithUnderscore ? name : getUniqueName(`_${name}`, file), declaration.name);
        const accessorName = createPropertyName(startWithUnderscore ? getUniqueName(name.substring(1), file) : name, declaration.name);
        return {
            isStatic: hasStaticModifier(declaration),
            isReadonly: hasEffectiveReadonlyModifier(declaration),
            type: getDeclarationType(declaration, program),
            container: declaration.kind === 168 /* Parameter */  ? declaration.parent.parent : declaration.parent,
            originalName: declaration.name.text,
            declaration: declaration,
            fieldName: fieldName,
            accessorName: accessorName,
            renameAccessor: startWithUnderscore
        };
    }
    function generateGetAccessor(fieldName, accessorName, type, modifiers, isStatic2, container) {
        return factory.createGetAccessorDeclaration(modifiers, accessorName, [], type, factory.createBlock([
            factory.createReturnStatement(createAccessorAccessExpression(fieldName, isStatic2, container))
        ], /*multiLine*/ true));
    }
    function generateSetAccessor(fieldName, accessorName, type, modifiers, isStatic2, container) {
        return factory.createSetAccessorDeclaration(modifiers, accessorName, [
            factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory.createIdentifier("value"), /*questionToken*/ void 0, type)
        ], factory.createBlock([
            factory.createExpressionStatement(factory.createAssignment(createAccessorAccessExpression(fieldName, isStatic2, container), factory.createIdentifier("value")))
        ], /*multiLine*/ true));
    }
    function updatePropertyDeclaration(changeTracker, file, declaration, type, fieldName, modifiers) {
        const property = factory.updatePropertyDeclaration(declaration, modifiers, fieldName, declaration.questionToken || declaration.exclamationToken, type, declaration.initializer);
        changeTracker.replaceNode(file, declaration, property);
    }
    function updatePropertyAssignmentDeclaration(changeTracker, file, declaration, fieldName) {
        let assignment = factory.updatePropertyAssignment(declaration, fieldName, declaration.initializer);
        if (assignment.modifiers || assignment.questionToken || assignment.exclamationToken) {
            if (assignment === declaration) assignment = factory.cloneNode(assignment);
            assignment.modifiers = void 0;
            assignment.questionToken = void 0;
            assignment.exclamationToken = void 0;
        }
        changeTracker.replacePropertyAssignment(file, declaration, assignment);
    }
    function updateFieldDeclaration(changeTracker, file, declaration, type, fieldName, modifiers) {
        if (isPropertyDeclaration(declaration)) updatePropertyDeclaration(changeTracker, file, declaration, type, fieldName, modifiers);
        else if (isPropertyAssignment(declaration)) updatePropertyAssignmentDeclaration(changeTracker, file, declaration, fieldName);
        else changeTracker.replaceNode(file, declaration, factory.updateParameterDeclaration(declaration, modifiers, declaration.dotDotDotToken, cast(fieldName, isIdentifier), declaration.questionToken, declaration.type, declaration.initializer));
    }
    function insertAccessor(changeTracker, file, accessor, declaration, container) {
        isParameterPropertyDeclaration(declaration, declaration.parent) ? changeTracker.insertMemberAtStart(file, container, accessor) : isPropertyAssignment(declaration) ? changeTracker.insertNodeAfterComma(file, declaration, accessor) : changeTracker.insertNodeAfter(file, declaration, accessor);
    }
    function updateReadonlyPropertyInitializerStatementConstructor(changeTracker, file, constructor, fieldName, originalName) {
        if (!constructor.body) return;
        constructor.body.forEachChild(function recur(node) {
            if (isElementAccessExpression(node) && node.expression.kind === 110 /* ThisKeyword */  && isStringLiteral(node.argumentExpression) && node.argumentExpression.text === originalName && isWriteAccess(node)) changeTracker.replaceNode(file, node.argumentExpression, factory.createStringLiteral(fieldName));
            if (isPropertyAccessExpression(node) && node.expression.kind === 110 /* ThisKeyword */  && node.name.text === originalName && isWriteAccess(node)) changeTracker.replaceNode(file, node.name, factory.createIdentifier(fieldName));
            if (!isFunctionLike(node) && !isClassLike(node)) node.forEachChild(recur);
        });
    }
    function getDeclarationType(declaration, program) {
        const typeNode = getTypeAnnotationNode(declaration);
        if (isPropertyDeclaration(declaration) && typeNode && declaration.questionToken) {
            const typeChecker = program.getTypeChecker();
            const type = typeChecker.getTypeFromTypeNode(typeNode);
            if (!typeChecker.isTypeAssignableTo(typeChecker.getUndefinedType(), type)) {
                const types = isUnionTypeNode(typeNode) ? typeNode.types : [
                    typeNode
                ];
                return factory.createUnionTypeNode([
                    ...types,
                    factory.createKeywordTypeNode(157 /* UndefinedKeyword */ )
                ]);
            }
        }
        return typeNode;
    }
    function getAllSupers(decl, checker) {
        const res = [];
        while(decl){
            const superElement = getClassExtendsHeritageElement(decl);
            const superSymbol = superElement && checker.getSymbolAtLocation(superElement.expression);
            if (!superSymbol) break;
            const symbol = superSymbol.flags & 2097152 /* Alias */  ? checker.getAliasedSymbol(superSymbol) : superSymbol;
            const superDecl = symbol.declarations && find(symbol.declarations, isClassLike);
            if (!superDecl) break;
            res.push(superDecl);
            decl = superDecl;
        }
        return res;
    }
    var init_generateAccessors = __esm({
        "src/services/codefixes/generateAccessors.ts" () {
            "use strict";
            init_ts4();
        }
    });
    // src/services/codefixes/fixInvalidImportSyntax.ts
    function getCodeFixesForImportDeclaration(context, node) {
        const sourceFile = getSourceFileOfNode(node);
        const namespace = getNamespaceDeclarationNode(node);
        const opts = context.program.getCompilerOptions();
        const variations = [];
        variations.push(createAction(context, sourceFile, node, makeImport(namespace.name, /*namedImports*/ void 0, node.moduleSpecifier, getQuotePreference(sourceFile, context.preferences))));
        if (getEmitModuleKind(opts) === 1 /* CommonJS */ ) variations.push(createAction(context, sourceFile, node, factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, namespace.name, factory.createExternalModuleReference(node.moduleSpecifier))));
        return variations;
    }
    function createAction(context, sourceFile, node, replacement) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(sourceFile, node, replacement));
        return createCodeFixActionWithoutFixAll(fixName5, changes, [
            Diagnostics.Replace_import_with_0,
            changes[0].textChanges[0].newText
        ]);
    }
    function getActionsForUsageOfInvalidImport(context) {
        const sourceFile = context.sourceFile;
        const targetKind = Diagnostics.This_expression_is_not_callable.code === context.errorCode ? 212 /* CallExpression */  : 213 /* NewExpression */ ;
        const node = findAncestor(getTokenAtPosition(sourceFile, context.span.start), (a)=>a.kind === targetKind);
        if (!node) return [];
        const expr = node.expression;
        return getImportCodeFixesForExpression(context, expr);
    }
    function getActionsForInvalidImportLocation(context) {
        const sourceFile = context.sourceFile;
        const node = findAncestor(getTokenAtPosition(sourceFile, context.span.start), (a)=>a.getStart() === context.span.start && a.getEnd() === context.span.start + context.span.length);
        if (!node) return [];
        return getImportCodeFixesForExpression(context, node);
    }
    function getImportCodeFixesForExpression(context, expr) {
        const type = context.program.getTypeChecker().getTypeAtLocation(expr);
        if (!(type.symbol && isTransientSymbol(type.symbol) && type.symbol.links.originatingImport)) return [];
        const fixes = [];
        const relatedImport = type.symbol.links.originatingImport;
        if (!isImportCall(relatedImport)) addRange(fixes, getCodeFixesForImportDeclaration(context, relatedImport));
        if (isExpression(expr) && !(isNamedDeclaration(expr.parent) && expr.parent.name === expr)) {
            const sourceFile = context.sourceFile;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(sourceFile, expr, factory.createPropertyAccessExpression(expr, "default"), {}));
            fixes.push(createCodeFixActionWithoutFixAll(fixName5, changes, Diagnostics.Use_synthetic_default_member));
        }
        return fixes;
    }
    var fixName5;
    var init_fixInvalidImportSyntax = __esm({
        "src/services/codefixes/fixInvalidImportSyntax.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixName5 = "invalidImportSyntax";
            registerCodeFix({
                errorCodes: [
                    Diagnostics.This_expression_is_not_callable.code,
                    Diagnostics.This_expression_is_not_constructable.code
                ],
                getCodeActions: getActionsForUsageOfInvalidImport
            });
            registerCodeFix({
                errorCodes: [
                    // The following error codes cover pretty much all assignability errors that could involve an expression
                    Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code,
                    Diagnostics.Type_0_does_not_satisfy_the_constraint_1.code,
                    Diagnostics.Type_0_is_not_assignable_to_type_1.code,
                    Diagnostics.Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated.code,
                    Diagnostics.Type_predicate_0_is_not_assignable_to_1.code,
                    Diagnostics.Property_0_of_type_1_is_not_assignable_to_2_index_type_3.code,
                    Diagnostics._0_index_type_1_is_not_assignable_to_2_index_type_3.code,
                    Diagnostics.Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2.code,
                    Diagnostics.Property_0_in_type_1_is_not_assignable_to_type_2.code,
                    Diagnostics.Property_0_of_JSX_spread_attribute_is_not_assignable_to_target_property.code,
                    Diagnostics.The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1.code
                ],
                getCodeActions: getActionsForInvalidImportLocation
            });
        }
    });
    // src/services/codefixes/fixStrictClassInitialization.ts
    function getInfo16(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (isIdentifier(token) && isPropertyDeclaration(token.parent)) {
            const type = getEffectiveTypeAnnotationNode(token.parent);
            if (type) return {
                type: type,
                prop: token.parent,
                isJs: isInJSFile(token.parent)
            };
        }
        return void 0;
    }
    function getActionForAddMissingDefiniteAssignmentAssertion(context, info) {
        if (info.isJs) return void 0;
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addDefiniteAssignmentAssertion(t, context.sourceFile, info.prop));
        return createCodeFixAction(fixName6, changes, [
            Diagnostics.Add_definite_assignment_assertion_to_property_0,
            info.prop.getText()
        ], fixIdAddDefiniteAssignmentAssertions, Diagnostics.Add_definite_assignment_assertions_to_all_uninitialized_properties);
    }
    function addDefiniteAssignmentAssertion(changeTracker, propertyDeclarationSourceFile, propertyDeclaration) {
        suppressLeadingAndTrailingTrivia(propertyDeclaration);
        const property = factory.updatePropertyDeclaration(propertyDeclaration, propertyDeclaration.modifiers, propertyDeclaration.name, factory.createToken(54 /* ExclamationToken */ ), propertyDeclaration.type, propertyDeclaration.initializer);
        changeTracker.replaceNode(propertyDeclarationSourceFile, propertyDeclaration, property);
    }
    function getActionForAddMissingUndefinedType(context, info) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addUndefinedType(t, context.sourceFile, info));
        return createCodeFixAction(fixName6, changes, [
            Diagnostics.Add_undefined_type_to_property_0,
            info.prop.name.getText()
        ], fixIdAddUndefinedType, Diagnostics.Add_undefined_type_to_all_uninitialized_properties);
    }
    function addUndefinedType(changeTracker, sourceFile, info) {
        const undefinedTypeNode = factory.createKeywordTypeNode(157 /* UndefinedKeyword */ );
        const types = isUnionTypeNode(info.type) ? info.type.types.concat(undefinedTypeNode) : [
            info.type,
            undefinedTypeNode
        ];
        const unionTypeNode = factory.createUnionTypeNode(types);
        if (info.isJs) changeTracker.addJSDocTags(sourceFile, info.prop, [
            factory.createJSDocTypeTag(/*tagName*/ void 0, factory.createJSDocTypeExpression(unionTypeNode))
        ]);
        else changeTracker.replaceNode(sourceFile, info.type, unionTypeNode);
    }
    function getActionForAddMissingInitializer(context, info) {
        if (info.isJs) return void 0;
        const checker = context.program.getTypeChecker();
        const initializer = getInitializer(checker, info.prop);
        if (!initializer) return void 0;
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addInitializer(t, context.sourceFile, info.prop, initializer));
        return createCodeFixAction(fixName6, changes, [
            Diagnostics.Add_initializer_to_property_0,
            info.prop.name.getText()
        ], fixIdAddInitializer, Diagnostics.Add_initializers_to_all_uninitialized_properties);
    }
    function addInitializer(changeTracker, propertyDeclarationSourceFile, propertyDeclaration, initializer) {
        suppressLeadingAndTrailingTrivia(propertyDeclaration);
        const property = factory.updatePropertyDeclaration(propertyDeclaration, propertyDeclaration.modifiers, propertyDeclaration.name, propertyDeclaration.questionToken, propertyDeclaration.type, initializer);
        changeTracker.replaceNode(propertyDeclarationSourceFile, propertyDeclaration, property);
    }
    function getInitializer(checker, propertyDeclaration) {
        return getDefaultValueFromType(checker, checker.getTypeFromTypeNode(propertyDeclaration.type));
    }
    function getDefaultValueFromType(checker, type) {
        if (type.flags & 512 /* BooleanLiteral */ ) return type === checker.getFalseType() || type === checker.getFalseType(/*fresh*/ true) ? factory.createFalse() : factory.createTrue();
        else if (type.isStringLiteral()) return factory.createStringLiteral(type.value);
        else if (type.isNumberLiteral()) return factory.createNumericLiteral(type.value);
        else if (type.flags & 2048 /* BigIntLiteral */ ) return factory.createBigIntLiteral(type.value);
        else if (type.isUnion()) return firstDefined(type.types, (t)=>getDefaultValueFromType(checker, t));
        else if (type.isClass()) {
            const classDeclaration = getClassLikeDeclarationOfSymbol(type.symbol);
            if (!classDeclaration || hasSyntacticModifier(classDeclaration, 256 /* Abstract */ )) return void 0;
            const constructorDeclaration = getFirstConstructorWithBody(classDeclaration);
            if (constructorDeclaration && constructorDeclaration.parameters.length) return void 0;
            return factory.createNewExpression(factory.createIdentifier(type.symbol.name), /*typeArguments*/ void 0, /*argumentsArray*/ void 0);
        } else if (checker.isArrayLikeType(type)) return factory.createArrayLiteralExpression();
        return void 0;
    }
    var fixName6, fixIdAddDefiniteAssignmentAssertions, fixIdAddUndefinedType, fixIdAddInitializer, errorCodes51;
    var init_fixStrictClassInitialization = __esm({
        "src/services/codefixes/fixStrictClassInitialization.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixName6 = "strictClassInitialization";
            fixIdAddDefiniteAssignmentAssertions = "addMissingPropertyDefiniteAssignmentAssertions";
            fixIdAddUndefinedType = "addMissingPropertyUndefinedType";
            fixIdAddInitializer = "addMissingPropertyInitializer";
            errorCodes51 = [
                Diagnostics.Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor.code
            ];
            registerCodeFix({
                errorCodes: errorCodes51,
                getCodeActions: function getCodeActionsForStrictClassInitializationErrors(context) {
                    const info = getInfo16(context.sourceFile, context.span.start);
                    if (!info) return;
                    const result = [];
                    append(result, getActionForAddMissingUndefinedType(context, info));
                    append(result, getActionForAddMissingDefiniteAssignmentAssertion(context, info));
                    append(result, getActionForAddMissingInitializer(context, info));
                    return result;
                },
                fixIds: [
                    fixIdAddDefiniteAssignmentAssertions,
                    fixIdAddUndefinedType,
                    fixIdAddInitializer
                ],
                getAllCodeActions: (context)=>{
                    return codeFixAll(context, errorCodes51, (changes, diag2)=>{
                        const info = getInfo16(diag2.file, diag2.start);
                        if (!info) return;
                        switch(context.fixId){
                            case fixIdAddDefiniteAssignmentAssertions:
                                addDefiniteAssignmentAssertion(changes, diag2.file, info.prop);
                                break;
                            case fixIdAddUndefinedType:
                                addUndefinedType(changes, diag2.file, info);
                                break;
                            case fixIdAddInitializer:
                                const checker = context.program.getTypeChecker();
                                const initializer = getInitializer(checker, info.prop);
                                if (!initializer) return;
                                addInitializer(changes, diag2.file, info.prop, initializer);
                                break;
                            default:
                                Debug.fail(JSON.stringify(context.fixId));
                        }
                    });
                }
            });
        }
    });
    // src/services/codefixes/requireInTs.ts
    function doChange34(changes, sourceFile, info) {
        const { allowSyntheticDefaults: allowSyntheticDefaults , defaultImportName: defaultImportName , namedImports: namedImports , statement: statement , required: required  } = info;
        changes.replaceNode(sourceFile, statement, defaultImportName && !allowSyntheticDefaults ? factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, defaultImportName, factory.createExternalModuleReference(required)) : factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/*isTypeOnly*/ false, defaultImportName, namedImports), required, /*assertClause*/ void 0));
    }
    function getInfo17(sourceFile, program, pos) {
        const { parent: parent2  } = getTokenAtPosition(sourceFile, pos);
        if (!isRequireCall(parent2, /*requireStringLiteralLikeArgument*/ true)) Debug.failBadSyntaxKind(parent2);
        const decl = cast(parent2.parent, isVariableDeclaration);
        const defaultImportName = tryCast(decl.name, isIdentifier);
        const namedImports = isObjectBindingPattern(decl.name) ? tryCreateNamedImportsFromObjectBindingPattern(decl.name) : void 0;
        if (defaultImportName || namedImports) return {
            allowSyntheticDefaults: getAllowSyntheticDefaultImports(program.getCompilerOptions()),
            defaultImportName: defaultImportName,
            namedImports: namedImports,
            statement: cast(decl.parent.parent, isVariableStatement),
            required: first(parent2.arguments)
        };
    }
    function tryCreateNamedImportsFromObjectBindingPattern(node) {
        const importSpecifiers = [];
        for (const element of node.elements){
            if (!isIdentifier(element.name) || element.initializer) return void 0;
            importSpecifiers.push(factory.createImportSpecifier(/*isTypeOnly*/ false, tryCast(element.propertyName, isIdentifier), element.name));
        }
        if (importSpecifiers.length) return factory.createNamedImports(importSpecifiers);
    }
    var fixId41, errorCodes52;
    var init_requireInTs = __esm({
        "src/services/codefixes/requireInTs.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId41 = "requireInTs";
            errorCodes52 = [
                Diagnostics.require_call_may_be_converted_to_an_import.code
            ];
            registerCodeFix({
                errorCodes: errorCodes52,
                getCodeActions (context) {
                    const info = getInfo17(context.sourceFile, context.program, context.span.start);
                    if (!info) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange34(t, context.sourceFile, info));
                    return [
                        createCodeFixAction(fixId41, changes, Diagnostics.Convert_require_to_import, fixId41, Diagnostics.Convert_all_require_to_import)
                    ];
                },
                fixIds: [
                    fixId41
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes52, (changes, diag2)=>{
                        const info = getInfo17(diag2.file, context.program, diag2.start);
                        if (info) doChange34(changes, context.sourceFile, info);
                    })
            });
        }
    });
    // src/services/codefixes/useDefaultImport.ts
    function getInfo18(sourceFile, pos) {
        const name = getTokenAtPosition(sourceFile, pos);
        if (!isIdentifier(name)) return void 0;
        const { parent: parent2  } = name;
        if (isImportEqualsDeclaration(parent2) && isExternalModuleReference(parent2.moduleReference)) return {
            importNode: parent2,
            name: name,
            moduleSpecifier: parent2.moduleReference.expression
        };
        else if (isNamespaceImport(parent2)) {
            const importNode = parent2.parent.parent;
            return {
                importNode: importNode,
                name: name,
                moduleSpecifier: importNode.moduleSpecifier
            };
        }
    }
    function doChange35(changes, sourceFile, info, preferences) {
        changes.replaceNode(sourceFile, info.importNode, makeImport(info.name, /*namedImports*/ void 0, info.moduleSpecifier, getQuotePreference(sourceFile, preferences)));
    }
    var fixId42, errorCodes53;
    var init_useDefaultImport = __esm({
        "src/services/codefixes/useDefaultImport.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId42 = "useDefaultImport";
            errorCodes53 = [
                Diagnostics.Import_may_be_converted_to_a_default_import.code
            ];
            registerCodeFix({
                errorCodes: errorCodes53,
                getCodeActions (context) {
                    const { sourceFile: sourceFile , span: { start: start  }  } = context;
                    const info = getInfo18(sourceFile, start);
                    if (!info) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange35(t, sourceFile, info, context.preferences));
                    return [
                        createCodeFixAction(fixId42, changes, Diagnostics.Convert_to_default_import, fixId42, Diagnostics.Convert_all_to_default_imports)
                    ];
                },
                fixIds: [
                    fixId42
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes53, (changes, diag2)=>{
                        const info = getInfo18(diag2.file, diag2.start);
                        if (info) doChange35(changes, diag2.file, info, context.preferences);
                    })
            });
        }
    });
    // src/services/codefixes/useBigintLiteral.ts
    function makeChange9(changeTracker, sourceFile, span) {
        const numericLiteral = tryCast(getTokenAtPosition(sourceFile, span.start), isNumericLiteral);
        if (!numericLiteral) return;
        const newText = numericLiteral.getText(sourceFile) + "n";
        changeTracker.replaceNode(sourceFile, numericLiteral, factory.createBigIntLiteral(newText));
    }
    var fixId43, errorCodes54;
    var init_useBigintLiteral = __esm({
        "src/services/codefixes/useBigintLiteral.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId43 = "useBigintLiteral";
            errorCodes54 = [
                Diagnostics.Numeric_literals_with_absolute_values_equal_to_2_53_or_greater_are_too_large_to_be_represented_accurately_as_integers.code
            ];
            registerCodeFix({
                errorCodes: errorCodes54,
                getCodeActions: function getCodeActionsToUseBigintLiteral(context) {
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange9(t, context.sourceFile, context.span));
                    if (changes.length > 0) return [
                        createCodeFixAction(fixId43, changes, Diagnostics.Convert_to_a_bigint_numeric_literal, fixId43, Diagnostics.Convert_all_to_bigint_numeric_literals)
                    ];
                },
                fixIds: [
                    fixId43
                ],
                getAllCodeActions: (context)=>{
                    return codeFixAll(context, errorCodes54, (changes, diag2)=>makeChange9(changes, diag2.file, diag2));
                }
            });
        }
    });
    // src/services/codefixes/fixAddModuleReferTypeMissingTypeof.ts
    function getImportTypeNode(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        Debug.assert(token.kind === 102 /* ImportKeyword */ , "This token should be an ImportKeyword");
        Debug.assert(token.parent.kind === 204 /* ImportType */ , "Token parent should be an ImportType");
        return token.parent;
    }
    function doChange36(changes, sourceFile, importType) {
        const newTypeNode = factory.updateImportTypeNode(importType, importType.argument, importType.assertions, importType.qualifier, importType.typeArguments, /*isTypeOf*/ true);
        changes.replaceNode(sourceFile, importType, newTypeNode);
    }
    var fixIdAddMissingTypeof, fixId44, errorCodes55;
    var init_fixAddModuleReferTypeMissingTypeof = __esm({
        "src/services/codefixes/fixAddModuleReferTypeMissingTypeof.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixIdAddMissingTypeof = "fixAddModuleReferTypeMissingTypeof";
            fixId44 = fixIdAddMissingTypeof;
            errorCodes55 = [
                Diagnostics.Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here_Did_you_mean_typeof_import_0.code
            ];
            registerCodeFix({
                errorCodes: errorCodes55,
                getCodeActions: function getCodeActionsToAddMissingTypeof(context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const importType = getImportTypeNode(sourceFile, span.start);
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange36(t, sourceFile, importType));
                    return [
                        createCodeFixAction(fixId44, changes, Diagnostics.Add_missing_typeof, fixId44, Diagnostics.Add_missing_typeof)
                    ];
                },
                fixIds: [
                    fixId44
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes55, (changes, diag2)=>doChange36(changes, context.sourceFile, getImportTypeNode(diag2.file, diag2.start)))
            });
        }
    });
    // src/services/codefixes/wrapJsxInFragment.ts
    function findNodeToFix(sourceFile, pos) {
        const lessThanToken = getTokenAtPosition(sourceFile, pos);
        const firstJsxElementOrOpenElement = lessThanToken.parent;
        let binaryExpr = firstJsxElementOrOpenElement.parent;
        if (!isBinaryExpression(binaryExpr)) {
            binaryExpr = binaryExpr.parent;
            if (!isBinaryExpression(binaryExpr)) return void 0;
        }
        if (!nodeIsMissing(binaryExpr.operatorToken)) return void 0;
        return binaryExpr;
    }
    function doChange37(changeTracker, sf, node) {
        const jsx = flattenInvalidBinaryExpr(node);
        if (jsx) changeTracker.replaceNode(sf, node, factory.createJsxFragment(factory.createJsxOpeningFragment(), jsx, factory.createJsxJsxClosingFragment()));
    }
    function flattenInvalidBinaryExpr(node) {
        const children = [];
        let current = node;
        while(true){
            if (isBinaryExpression(current) && nodeIsMissing(current.operatorToken) && current.operatorToken.kind === 28 /* CommaToken */ ) {
                children.push(current.left);
                if (isJsxChild(current.right)) {
                    children.push(current.right);
                    return children;
                } else if (isBinaryExpression(current.right)) {
                    current = current.right;
                    continue;
                } else return void 0;
            } else return void 0;
        }
    }
    var fixID2, errorCodes56;
    var init_wrapJsxInFragment = __esm({
        "src/services/codefixes/wrapJsxInFragment.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixID2 = "wrapJsxInFragment";
            errorCodes56 = [
                Diagnostics.JSX_expressions_must_have_one_parent_element.code
            ];
            registerCodeFix({
                errorCodes: errorCodes56,
                getCodeActions: function getCodeActionsToWrapJsxInFragment(context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const node = findNodeToFix(sourceFile, span.start);
                    if (!node) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange37(t, sourceFile, node));
                    return [
                        createCodeFixAction(fixID2, changes, Diagnostics.Wrap_in_JSX_fragment, fixID2, Diagnostics.Wrap_all_unparented_JSX_in_JSX_fragment)
                    ];
                },
                fixIds: [
                    fixID2
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes56, (changes, diag2)=>{
                        const node = findNodeToFix(context.sourceFile, diag2.start);
                        if (!node) return void 0;
                        doChange37(changes, context.sourceFile, node);
                    })
            });
        }
    });
    // src/services/codefixes/convertToMappedObjectType.ts
    function getInfo19(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        const indexSignature = tryCast(token.parent.parent, isIndexSignatureDeclaration);
        if (!indexSignature) return void 0;
        const container = isInterfaceDeclaration(indexSignature.parent) ? indexSignature.parent : tryCast(indexSignature.parent.parent, isTypeAliasDeclaration);
        if (!container) return void 0;
        return {
            indexSignature: indexSignature,
            container: container
        };
    }
    function createTypeAliasFromInterface(declaration, type) {
        return factory.createTypeAliasDeclaration(declaration.modifiers, declaration.name, declaration.typeParameters, type);
    }
    function doChange38(changes, sourceFile, { indexSignature: indexSignature , container: container  }) {
        const members = isInterfaceDeclaration(container) ? container.members : container.type.members;
        const otherMembers = members.filter((member)=>!isIndexSignatureDeclaration(member));
        const parameter = first(indexSignature.parameters);
        const mappedTypeParameter = factory.createTypeParameterDeclaration(/*modifiers*/ void 0, cast(parameter.name, isIdentifier), parameter.type);
        const mappedIntersectionType = factory.createMappedTypeNode(hasEffectiveReadonlyModifier(indexSignature) ? factory.createModifier(148 /* ReadonlyKeyword */ ) : void 0, mappedTypeParameter, /*nameType*/ void 0, indexSignature.questionToken, indexSignature.type, /*members*/ void 0);
        const intersectionType = factory.createIntersectionTypeNode([
            ...getAllSuperTypeNodes(container),
            mappedIntersectionType,
            ...otherMembers.length ? [
                factory.createTypeLiteralNode(otherMembers)
            ] : emptyArray
        ]);
        changes.replaceNode(sourceFile, container, createTypeAliasFromInterface(container, intersectionType));
    }
    var fixId45, errorCodes57;
    var init_convertToMappedObjectType = __esm({
        "src/services/codefixes/convertToMappedObjectType.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId45 = "fixConvertToMappedObjectType";
            errorCodes57 = [
                Diagnostics.An_index_signature_parameter_type_cannot_be_a_literal_type_or_generic_type_Consider_using_a_mapped_object_type_instead.code
            ];
            registerCodeFix({
                errorCodes: errorCodes57,
                getCodeActions: function getCodeActionsToConvertToMappedTypeObject(context) {
                    const { sourceFile: sourceFile , span: span  } = context;
                    const info = getInfo19(sourceFile, span.start);
                    if (!info) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange38(t, sourceFile, info));
                    const name = idText(info.container.name);
                    return [
                        createCodeFixAction(fixId45, changes, [
                            Diagnostics.Convert_0_to_mapped_object_type,
                            name
                        ], fixId45, [
                            Diagnostics.Convert_0_to_mapped_object_type,
                            name
                        ])
                    ];
                },
                fixIds: [
                    fixId45
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes57, (changes, diag2)=>{
                        const info = getInfo19(diag2.file, diag2.start);
                        if (info) doChange38(changes, diag2.file, info);
                    })
            });
        }
    });
    // src/services/codefixes/removeAccidentalCallParentheses.ts
    var fixId46, errorCodes58;
    var init_removeAccidentalCallParentheses = __esm({
        "src/services/codefixes/removeAccidentalCallParentheses.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId46 = "removeAccidentalCallParentheses";
            errorCodes58 = [
                Diagnostics.This_expression_is_not_callable_because_it_is_a_get_accessor_Did_you_mean_to_use_it_without.code
            ];
            registerCodeFix({
                errorCodes: errorCodes58,
                getCodeActions (context) {
                    const callExpression = findAncestor(getTokenAtPosition(context.sourceFile, context.span.start), isCallExpression);
                    if (!callExpression) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
                        t.deleteRange(context.sourceFile, {
                            pos: callExpression.expression.end,
                            end: callExpression.end
                        });
                    });
                    return [
                        createCodeFixActionWithoutFixAll(fixId46, changes, Diagnostics.Remove_parentheses)
                    ];
                },
                fixIds: [
                    fixId46
                ]
            });
        }
    });
    // src/services/codefixes/removeUnnecessaryAwait.ts
    function makeChange10(changeTracker, sourceFile, span) {
        const awaitKeyword = tryCast(getTokenAtPosition(sourceFile, span.start), (node)=>node.kind === 135 /* AwaitKeyword */ );
        const awaitExpression = awaitKeyword && tryCast(awaitKeyword.parent, isAwaitExpression);
        if (!awaitExpression) return;
        let expressionToReplace = awaitExpression;
        const hasSurroundingParens = isParenthesizedExpression(awaitExpression.parent);
        if (hasSurroundingParens) {
            const leftMostExpression = getLeftmostExpression(awaitExpression.expression, /*stopAtCallExpressions*/ false);
            if (isIdentifier(leftMostExpression)) {
                const precedingToken = findPrecedingToken(awaitExpression.parent.pos, sourceFile);
                if (precedingToken && precedingToken.kind !== 105 /* NewKeyword */ ) expressionToReplace = awaitExpression.parent;
            }
        }
        changeTracker.replaceNode(sourceFile, expressionToReplace, awaitExpression.expression);
    }
    var fixId47, errorCodes59;
    var init_removeUnnecessaryAwait = __esm({
        "src/services/codefixes/removeUnnecessaryAwait.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId47 = "removeUnnecessaryAwait";
            errorCodes59 = [
                Diagnostics.await_has_no_effect_on_the_type_of_this_expression.code
            ];
            registerCodeFix({
                errorCodes: errorCodes59,
                getCodeActions: function getCodeActionsToRemoveUnnecessaryAwait(context) {
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange10(t, context.sourceFile, context.span));
                    if (changes.length > 0) return [
                        createCodeFixAction(fixId47, changes, Diagnostics.Remove_unnecessary_await, fixId47, Diagnostics.Remove_all_unnecessary_uses_of_await)
                    ];
                },
                fixIds: [
                    fixId47
                ],
                getAllCodeActions: (context)=>{
                    return codeFixAll(context, errorCodes59, (changes, diag2)=>makeChange10(changes, diag2.file, diag2));
                }
            });
        }
    });
    // src/services/codefixes/splitTypeOnlyImport.ts
    function getImportDeclaration2(sourceFile, span) {
        return findAncestor(getTokenAtPosition(sourceFile, span.start), isImportDeclaration);
    }
    function splitTypeOnlyImport(changes, importDeclaration, context) {
        if (!importDeclaration) return;
        const importClause = Debug.checkDefined(importDeclaration.importClause);
        changes.replaceNode(context.sourceFile, importDeclaration, factory.updateImportDeclaration(importDeclaration, importDeclaration.modifiers, factory.updateImportClause(importClause, importClause.isTypeOnly, importClause.name, /*namedBindings*/ void 0), importDeclaration.moduleSpecifier, importDeclaration.assertClause));
        changes.insertNodeAfter(context.sourceFile, importDeclaration, factory.createImportDeclaration(/*modifiers*/ void 0, factory.updateImportClause(importClause, importClause.isTypeOnly, /*name*/ void 0, importClause.namedBindings), importDeclaration.moduleSpecifier, importDeclaration.assertClause));
    }
    var errorCodes60, fixId48;
    var init_splitTypeOnlyImport = __esm({
        "src/services/codefixes/splitTypeOnlyImport.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            errorCodes60 = [
                Diagnostics.A_type_only_import_can_specify_a_default_import_or_named_bindings_but_not_both.code
            ];
            fixId48 = "splitTypeOnlyImport";
            registerCodeFix({
                errorCodes: errorCodes60,
                fixIds: [
                    fixId48
                ],
                getCodeActions: function getCodeActionsToSplitTypeOnlyImport(context) {
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
                        return splitTypeOnlyImport(t, getImportDeclaration2(context.sourceFile, context.span), context);
                    });
                    if (changes.length) return [
                        createCodeFixAction(fixId48, changes, Diagnostics.Split_into_two_separate_import_declarations, fixId48, Diagnostics.Split_all_invalid_type_only_imports)
                    ];
                },
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes60, (changes, error)=>{
                        splitTypeOnlyImport(changes, getImportDeclaration2(context.sourceFile, error), context);
                    })
            });
        }
    });
    // src/services/codefixes/convertConstToLet.ts
    function getInfo20(sourceFile, pos, program) {
        var _a;
        const checker = program.getTypeChecker();
        const symbol = checker.getSymbolAtLocation(getTokenAtPosition(sourceFile, pos));
        if (symbol === void 0) return;
        const declaration = tryCast((_a = symbol == null ? void 0 : symbol.valueDeclaration) == null ? void 0 : _a.parent, isVariableDeclarationList);
        if (declaration === void 0) return;
        const constToken = findChildOfKind(declaration, 87 /* ConstKeyword */ , sourceFile);
        if (constToken === void 0) return;
        return {
            symbol: symbol,
            token: constToken
        };
    }
    function doChange39(changes, sourceFile, token) {
        changes.replaceNode(sourceFile, token, factory.createToken(121 /* LetKeyword */ ));
    }
    var fixId49, errorCodes61;
    var init_convertConstToLet = __esm({
        "src/services/codefixes/convertConstToLet.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId49 = "fixConvertConstToLet";
            errorCodes61 = [
                Diagnostics.Cannot_assign_to_0_because_it_is_a_constant.code
            ];
            registerCodeFix({
                errorCodes: errorCodes61,
                getCodeActions: function getCodeActionsToConvertConstToLet(context) {
                    const { sourceFile: sourceFile , span: span , program: program  } = context;
                    const info = getInfo20(sourceFile, span.start, program);
                    if (info === void 0) return;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange39(t, sourceFile, info.token));
                    return [
                        createCodeFixActionMaybeFixAll(fixId49, changes, Diagnostics.Convert_const_to_let, fixId49, Diagnostics.Convert_all_const_to_let)
                    ];
                },
                getAllCodeActions: (context)=>{
                    const { program: program  } = context;
                    const seen = /* @__PURE__ */ new Map();
                    return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                        eachDiagnostic(context, errorCodes61, (diag2)=>{
                            const info = getInfo20(diag2.file, diag2.start, program);
                            if (info) {
                                if (addToSeen(seen, getSymbolId(info.symbol))) return doChange39(changes, diag2.file, info.token);
                            }
                            return void 0;
                        });
                    }));
                },
                fixIds: [
                    fixId49
                ]
            });
        }
    });
    // src/services/codefixes/fixExpectedComma.ts
    function getInfo21(sourceFile, pos, _) {
        const node = getTokenAtPosition(sourceFile, pos);
        return node.kind === 27 /* SemicolonToken */  && node.parent && (isObjectLiteralExpression(node.parent) || isArrayLiteralExpression(node.parent)) ? {
            node: node
        } : void 0;
    }
    function doChange40(changes, sourceFile, { node: node  }) {
        const newNode = factory.createToken(28 /* CommaToken */ );
        changes.replaceNode(sourceFile, node, newNode);
    }
    var fixId50, expectedErrorCode, errorCodes62;
    var init_fixExpectedComma = __esm({
        "src/services/codefixes/fixExpectedComma.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixId50 = "fixExpectedComma";
            expectedErrorCode = Diagnostics._0_expected.code;
            errorCodes62 = [
                expectedErrorCode
            ];
            registerCodeFix({
                errorCodes: errorCodes62,
                getCodeActions (context) {
                    const { sourceFile: sourceFile  } = context;
                    const info = getInfo21(sourceFile, context.span.start, context.errorCode);
                    if (!info) return void 0;
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange40(t, sourceFile, info));
                    return [
                        createCodeFixAction(fixId50, changes, [
                            Diagnostics.Change_0_to_1,
                            ";",
                            ","
                        ], fixId50, [
                            Diagnostics.Change_0_to_1,
                            ";",
                            ","
                        ])
                    ];
                },
                fixIds: [
                    fixId50
                ],
                getAllCodeActions: (context)=>codeFixAll(context, errorCodes62, (changes, diag2)=>{
                        const info = getInfo21(diag2.file, diag2.start, diag2.code);
                        if (info) doChange40(changes, context.sourceFile, info);
                    })
            });
        }
    });
    // src/services/codefixes/fixAddVoidToPromise.ts
    function makeChange11(changes, sourceFile, span, program, seen) {
        const node = getTokenAtPosition(sourceFile, span.start);
        if (!isIdentifier(node) || !isCallExpression(node.parent) || node.parent.expression !== node || node.parent.arguments.length !== 0) return;
        const checker = program.getTypeChecker();
        const symbol = checker.getSymbolAtLocation(node);
        const decl = symbol == null ? void 0 : symbol.valueDeclaration;
        if (!decl || !isParameter(decl) || !isNewExpression(decl.parent.parent)) return;
        if (seen == null ? void 0 : seen.has(decl)) return;
        seen == null || seen.add(decl);
        const typeArguments = getEffectiveTypeArguments(decl.parent.parent);
        if (some(typeArguments)) {
            const typeArgument = typeArguments[0];
            const needsParens = !isUnionTypeNode(typeArgument) && !isParenthesizedTypeNode(typeArgument) && isParenthesizedTypeNode(factory.createUnionTypeNode([
                typeArgument,
                factory.createKeywordTypeNode(116 /* VoidKeyword */ )
            ]).types[0]);
            if (needsParens) changes.insertText(sourceFile, typeArgument.pos, "(");
            changes.insertText(sourceFile, typeArgument.end, needsParens ? ") | void" : " | void");
        } else {
            const signature = checker.getResolvedSignature(node.parent);
            const parameter = signature == null ? void 0 : signature.parameters[0];
            const parameterType = parameter && checker.getTypeOfSymbolAtLocation(parameter, decl.parent.parent);
            if (isInJSFile(decl)) {
                if (!parameterType || parameterType.flags & 3 /* AnyOrUnknown */ ) {
                    changes.insertText(sourceFile, decl.parent.parent.end, `)`);
                    changes.insertText(sourceFile, skipTrivia(sourceFile.text, decl.parent.parent.pos), `/** @type {Promise<void>} */(`);
                }
            } else if (!parameterType || parameterType.flags & 2 /* Unknown */ ) changes.insertText(sourceFile, decl.parent.parent.expression.end, "<void>");
        }
    }
    function getEffectiveTypeArguments(node) {
        var _a;
        if (isInJSFile(node)) {
            if (isParenthesizedExpression(node.parent)) {
                const jsDocType = (_a = getJSDocTypeTag(node.parent)) == null ? void 0 : _a.typeExpression.type;
                if (jsDocType && isTypeReferenceNode(jsDocType) && isIdentifier(jsDocType.typeName) && idText(jsDocType.typeName) === "Promise") return jsDocType.typeArguments;
            }
        } else return node.typeArguments;
    }
    var fixName7, fixId51, errorCodes63;
    var init_fixAddVoidToPromise = __esm({
        "src/services/codefixes/fixAddVoidToPromise.ts" () {
            "use strict";
            init_ts4();
            init_ts_codefix();
            fixName7 = "addVoidToPromise";
            fixId51 = "addVoidToPromise";
            errorCodes63 = [
                Diagnostics.Expected_1_argument_but_got_0_new_Promise_needs_a_JSDoc_hint_to_produce_a_resolve_that_can_be_called_without_arguments.code,
                Diagnostics.Expected_0_arguments_but_got_1_Did_you_forget_to_include_void_in_your_type_argument_to_Promise.code
            ];
            registerCodeFix({
                errorCodes: errorCodes63,
                fixIds: [
                    fixId51
                ],
                getCodeActions (context) {
                    const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange11(t, context.sourceFile, context.span, context.program));
                    if (changes.length > 0) return [
                        createCodeFixAction(fixName7, changes, Diagnostics.Add_void_to_Promise_resolved_without_a_value, fixId51, Diagnostics.Add_void_to_all_Promises_resolved_without_a_value)
                    ];
                },
                getAllCodeActions (context) {
                    return codeFixAll(context, errorCodes63, (changes, diag2)=>makeChange11(changes, diag2.file, diag2, context.program, /* @__PURE__ */ new Set()));
                }
            });
        }
    });
    // src/services/_namespaces/ts.codefix.ts
    var ts_codefix_exports = {};
    __export(ts_codefix_exports, {
        PreserveOptionalFlags: ()=>PreserveOptionalFlags,
        addNewNodeForMemberSymbol: ()=>addNewNodeForMemberSymbol,
        codeFixAll: ()=>codeFixAll,
        createCodeFixAction: ()=>createCodeFixAction,
        createCodeFixActionMaybeFixAll: ()=>createCodeFixActionMaybeFixAll,
        createCodeFixActionWithoutFixAll: ()=>createCodeFixActionWithoutFixAll,
        createCombinedCodeActions: ()=>createCombinedCodeActions,
        createFileTextChanges: ()=>createFileTextChanges,
        createImportAdder: ()=>createImportAdder,
        createImportSpecifierResolver: ()=>createImportSpecifierResolver,
        createJsonPropertyAssignment: ()=>createJsonPropertyAssignment,
        createMissingMemberNodes: ()=>createMissingMemberNodes,
        createSignatureDeclarationFromCallExpression: ()=>createSignatureDeclarationFromCallExpression,
        createSignatureDeclarationFromSignature: ()=>createSignatureDeclarationFromSignature,
        createStubbedBody: ()=>createStubbedBody,
        eachDiagnostic: ()=>eachDiagnostic,
        findAncestorMatchingSpan: ()=>findAncestorMatchingSpan,
        findJsonProperty: ()=>findJsonProperty,
        generateAccessorFromProperty: ()=>generateAccessorFromProperty,
        getAccessorConvertiblePropertyAtPosition: ()=>getAccessorConvertiblePropertyAtPosition,
        getAllFixes: ()=>getAllFixes,
        getAllSupers: ()=>getAllSupers,
        getArgumentTypesAndTypeParameters: ()=>getArgumentTypesAndTypeParameters,
        getFixes: ()=>getFixes,
        getImportCompletionAction: ()=>getImportCompletionAction,
        getImportKind: ()=>getImportKind,
        getJSDocTypedefNode: ()=>getJSDocTypedefNode,
        getNoopSymbolTrackerWithResolver: ()=>getNoopSymbolTrackerWithResolver,
        getPromoteTypeOnlyCompletionAction: ()=>getPromoteTypeOnlyCompletionAction,
        getSupportedErrorCodes: ()=>getSupportedErrorCodes,
        importFixName: ()=>importFixName,
        importSymbols: ()=>importSymbols,
        moduleSpecifierToValidIdentifier: ()=>moduleSpecifierToValidIdentifier,
        moduleSymbolToValidIdentifier: ()=>moduleSymbolToValidIdentifier,
        parameterShouldGetTypeFromJSDoc: ()=>parameterShouldGetTypeFromJSDoc,
        registerCodeFix: ()=>registerCodeFix,
        setJsonCompilerOptionValue: ()=>setJsonCompilerOptionValue,
        setJsonCompilerOptionValues: ()=>setJsonCompilerOptionValues,
        tryGetAutoImportableReferenceFromTypeNode: ()=>tryGetAutoImportableReferenceFromTypeNode,
        typeToAutoImportableTypeNode: ()=>typeToAutoImportableTypeNode
    });
    var init_ts_codefix = __esm({
        "src/services/_namespaces/ts.codefix.ts" () {
            "use strict";
            init_codeFixProvider();
            init_addConvertToUnknownForNonOverlappingTypes();
            init_addEmptyExportDeclaration();
            init_addMissingAsync();
            init_addMissingAwait();
            init_addMissingConst();
            init_addMissingDeclareProperty();
            init_addMissingInvocationForDecorator();
            init_addNameToNamelessParameter();
            init_addOptionalPropertyUndefined();
            init_annotateWithTypeFromJSDoc();
            init_convertFunctionToEs6Class();
            init_convertToAsyncFunction();
            init_convertToEsModule();
            init_correctQualifiedNameToIndexedAccessType();
            init_convertToTypeOnlyExport();
            init_convertToTypeOnlyImport();
            init_convertTypedefToType();
            init_convertLiteralTypeToMappedType();
            init_fixClassIncorrectlyImplementsInterface();
            init_importFixes();
            init_fixAddMissingConstraint();
            init_fixOverrideModifier();
            init_fixNoPropertyAccessFromIndexSignature();
            init_fixImplicitThis();
            init_fixImportNonExportedMember();
            init_fixIncorrectNamedTupleSyntax();
            init_fixSpelling();
            init_returnValueCorrect();
            init_fixAddMissingMember();
            init_fixAddMissingNewOperator();
            init_fixCannotFindModule();
            init_fixClassDoesntImplementInheritedAbstractMember();
            init_fixClassSuperMustPrecedeThisAccess();
            init_fixConstructorForDerivedNeedSuperCall();
            init_fixEnableJsxFlag();
            init_fixNaNEquality();
            init_fixModuleAndTargetOptions();
            init_fixPropertyAssignment();
            init_fixExtendsInterfaceBecomesImplements();
            init_fixForgottenThisPropertyAccess();
            init_fixInvalidJsxCharacters();
            init_fixUnmatchedParameter();
            init_fixUnreferenceableDecoratorMetadata();
            init_fixUnusedIdentifier();
            init_fixUnreachableCode();
            init_fixUnusedLabel();
            init_fixJSDocTypes();
            init_fixMissingCallParentheses();
            init_fixAwaitInSyncFunction();
            init_fixPropertyOverrideAccessor();
            init_inferFromUsage();
            init_fixReturnTypeInAsyncFunction();
            init_disableJsDiagnostics();
            init_helpers2();
            init_generateAccessors();
            init_fixInvalidImportSyntax();
            init_fixStrictClassInitialization();
            init_requireInTs();
            init_useDefaultImport();
            init_useBigintLiteral();
            init_fixAddModuleReferTypeMissingTypeof();
            init_wrapJsxInFragment();
            init_convertToMappedObjectType();
            init_removeAccidentalCallParentheses();
            init_removeUnnecessaryAwait();
            init_splitTypeOnlyImport();
            init_convertConstToLet();
            init_fixExpectedComma();
            init_fixAddVoidToPromise();
        }
    });
    // src/services/completions.ts
    function originIsThisType(origin) {
        return !!(origin.kind & 1 /* ThisType */ );
    }
    function originIsSymbolMember(origin) {
        return !!(origin.kind & 2 /* SymbolMember */ );
    }
    function originIsExport(origin) {
        return !!(origin && origin.kind & 4 /* Export */ );
    }
    function originIsResolvedExport(origin) {
        return !!(origin && origin.kind === 32 /* ResolvedExport */ );
    }
    function originIncludesSymbolName(origin) {
        return originIsExport(origin) || originIsResolvedExport(origin) || originIsComputedPropertyName(origin);
    }
    function originIsPackageJsonImport(origin) {
        return (originIsExport(origin) || originIsResolvedExport(origin)) && !!origin.isFromPackageJson;
    }
    function originIsPromise(origin) {
        return !!(origin.kind & 8 /* Promise */ );
    }
    function originIsNullableMember(origin) {
        return !!(origin.kind & 16 /* Nullable */ );
    }
    function originIsTypeOnlyAlias(origin) {
        return !!(origin && origin.kind & 64 /* TypeOnlyAlias */ );
    }
    function originIsObjectLiteralMethod(origin) {
        return !!(origin && origin.kind & 128 /* ObjectLiteralMethod */ );
    }
    function originIsIgnore(origin) {
        return !!(origin && origin.kind & 256 /* Ignore */ );
    }
    function originIsComputedPropertyName(origin) {
        return !!(origin && origin.kind & 512 /* ComputedPropertyName */ );
    }
    function resolvingModuleSpecifiers(logPrefix, host, resolver, program, position, preferences, isForImportStatementCompletion, isValidTypeOnlyUseSite, cb) {
        var _a, _b, _c;
        const start = timestamp();
        const needsFullResolution = isForImportStatementCompletion || moduleResolutionSupportsPackageJsonExportsAndImports(getEmitModuleResolutionKind(program.getCompilerOptions()));
        let skippedAny = false;
        let ambientCount = 0;
        let resolvedCount = 0;
        let resolvedFromCacheCount = 0;
        let cacheAttemptCount = 0;
        const result = cb({
            tryResolve: tryResolve,
            skippedAny: ()=>skippedAny,
            resolvedAny: ()=>resolvedCount > 0,
            resolvedBeyondLimit: ()=>resolvedCount > moduleSpecifierResolutionLimit
        });
        const hitRateMessage = cacheAttemptCount ? ` (${(resolvedFromCacheCount / cacheAttemptCount * 100).toFixed(1)}% hit rate)` : "";
        (_a = host.log) == null || _a.call(host, `${logPrefix}: resolved ${resolvedCount} module specifiers, plus ${ambientCount} ambient and ${resolvedFromCacheCount} from cache${hitRateMessage}`);
        (_b = host.log) == null || _b.call(host, `${logPrefix}: response is ${skippedAny ? "incomplete" : "complete"}`);
        (_c = host.log) == null || _c.call(host, `${logPrefix}: ${timestamp() - start}`);
        return result;
        function tryResolve(exportInfo, isFromAmbientModule) {
            if (isFromAmbientModule) {
                const result3 = resolver.getModuleSpecifierForBestExportInfo(exportInfo, position, isValidTypeOnlyUseSite);
                if (result3) ambientCount++;
                return result3 || "failed";
            }
            const shouldResolveModuleSpecifier = needsFullResolution || preferences.allowIncompleteCompletions && resolvedCount < moduleSpecifierResolutionLimit;
            const shouldGetModuleSpecifierFromCache = !shouldResolveModuleSpecifier && preferences.allowIncompleteCompletions && cacheAttemptCount < moduleSpecifierResolutionCacheAttemptLimit;
            const result2 = shouldResolveModuleSpecifier || shouldGetModuleSpecifierFromCache ? resolver.getModuleSpecifierForBestExportInfo(exportInfo, position, isValidTypeOnlyUseSite, shouldGetModuleSpecifierFromCache) : void 0;
            if (!shouldResolveModuleSpecifier && !shouldGetModuleSpecifierFromCache || shouldGetModuleSpecifierFromCache && !result2) skippedAny = true;
            resolvedCount += (result2 == null ? void 0 : result2.computedWithoutCacheCount) || 0;
            resolvedFromCacheCount += exportInfo.length - ((result2 == null ? void 0 : result2.computedWithoutCacheCount) || 0);
            if (shouldGetModuleSpecifierFromCache) cacheAttemptCount++;
            return result2 || (needsFullResolution ? "failed" : "skipped");
        }
    }
    function getCompletionsAtPosition(host, program, log, sourceFile, position, preferences, triggerCharacter, completionKind, cancellationToken, formatContext, includeSymbol = false) {
        var _a;
        const { previousToken: previousToken  } = getRelevantTokens(position, sourceFile);
        if (triggerCharacter && !isInString(sourceFile, position, previousToken) && !isValidTrigger(sourceFile, triggerCharacter, previousToken, position)) return void 0;
        if (triggerCharacter === " ") {
            if (preferences.includeCompletionsForImportStatements && preferences.includeCompletionsWithInsertText) return {
                isGlobalCompletion: true,
                isMemberCompletion: false,
                isNewIdentifierLocation: true,
                isIncomplete: true,
                entries: []
            };
            return void 0;
        }
        const compilerOptions = program.getCompilerOptions();
        const checker = program.getTypeChecker();
        const incompleteCompletionsCache = preferences.allowIncompleteCompletions ? (_a = host.getIncompleteCompletionsCache) == null ? void 0 : _a.call(host) : void 0;
        if (incompleteCompletionsCache && completionKind === 3 /* TriggerForIncompleteCompletions */  && previousToken && isIdentifier(previousToken)) {
            const incompleteContinuation = continuePreviousIncompleteResponse(incompleteCompletionsCache, sourceFile, previousToken, program, host, preferences, cancellationToken, position);
            if (incompleteContinuation) return incompleteContinuation;
        } else incompleteCompletionsCache == null || incompleteCompletionsCache.clear();
        const stringCompletions = ts_Completions_StringCompletions_exports.getStringLiteralCompletions(sourceFile, position, previousToken, compilerOptions, host, program, log, preferences, includeSymbol);
        if (stringCompletions) return stringCompletions;
        if (previousToken && isBreakOrContinueStatement(previousToken.parent) && (previousToken.kind === 83 /* BreakKeyword */  || previousToken.kind === 88 /* ContinueKeyword */  || previousToken.kind === 80 /* Identifier */ )) return getLabelCompletionAtPosition(previousToken.parent);
        const completionData = getCompletionData(program, log, sourceFile, compilerOptions, position, preferences, /*detailsEntryId*/ void 0, host, formatContext, cancellationToken);
        if (!completionData) return void 0;
        switch(completionData.kind){
            case 0 /* Data */ :
                const response = completionInfoFromData(sourceFile, host, program, compilerOptions, log, completionData, preferences, formatContext, position, includeSymbol);
                if (response == null ? void 0 : response.isIncomplete) incompleteCompletionsCache == null || incompleteCompletionsCache.set(response);
                return response;
            case 1 /* JsDocTagName */ :
                return jsdocCompletionInfo([
                    ...ts_JsDoc_exports.getJSDocTagNameCompletions(),
                    ...getJSDocParameterCompletions(sourceFile, position, checker, compilerOptions, preferences, /*tagNameOnly*/ true)
                ]);
            case 2 /* JsDocTag */ :
                return jsdocCompletionInfo([
                    ...ts_JsDoc_exports.getJSDocTagCompletions(),
                    ...getJSDocParameterCompletions(sourceFile, position, checker, compilerOptions, preferences, /*tagNameOnly*/ false)
                ]);
            case 3 /* JsDocParameterName */ :
                return jsdocCompletionInfo(ts_JsDoc_exports.getJSDocParameterNameCompletions(completionData.tag));
            case 4 /* Keywords */ :
                return specificKeywordCompletionInfo(completionData.keywordCompletions, completionData.isNewIdentifierLocation);
            default:
                return Debug.assertNever(completionData);
        }
    }
    function compareCompletionEntries(entryInArray, entryToInsert) {
        var _a, _b;
        let result = compareStringsCaseSensitiveUI(entryInArray.sortText, entryToInsert.sortText);
        if (result === 0 /* EqualTo */ ) result = compareStringsCaseSensitiveUI(entryInArray.name, entryToInsert.name);
        if (result === 0 /* EqualTo */  && ((_a = entryInArray.data) == null ? void 0 : _a.moduleSpecifier) && ((_b = entryToInsert.data) == null ? void 0 : _b.moduleSpecifier)) result = compareNumberOfDirectorySeparators(entryInArray.data.moduleSpecifier, entryToInsert.data.moduleSpecifier);
        if (result === 0 /* EqualTo */ ) return -1 /* LessThan */ ;
        return result;
    }
    function completionEntryDataIsResolved(data) {
        return !!(data == null ? void 0 : data.moduleSpecifier);
    }
    function continuePreviousIncompleteResponse(cache, file, location, program, host, preferences, cancellationToken, position) {
        const previousResponse = cache.get();
        if (!previousResponse) return void 0;
        const touchNode = getTouchingPropertyName(file, position);
        const lowerCaseTokenText = location.text.toLowerCase();
        const exportMap = getExportInfoMap(file, host, program, preferences, cancellationToken);
        const newEntries = resolvingModuleSpecifiers("continuePreviousIncompleteResponse", host, ts_codefix_exports.createImportSpecifierResolver(file, program, host, preferences), program, location.getStart(), preferences, /*isForImportStatementCompletion*/ false, isValidTypeOnlyAliasUseSite(location), (context)=>{
            const entries = mapDefined(previousResponse.entries, (entry)=>{
                var _a;
                if (!entry.hasAction || !entry.source || !entry.data || completionEntryDataIsResolved(entry.data)) return entry;
                if (!charactersFuzzyMatchInString(entry.name, lowerCaseTokenText)) return void 0;
                const { origin: origin  } = Debug.checkDefined(getAutoImportSymbolFromCompletionEntryData(entry.name, entry.data, program, host));
                const info = exportMap.get(file.path, entry.data.exportMapKey);
                const result = info && context.tryResolve(info, !isExternalModuleNameRelative(stripQuotes(origin.moduleSymbol.name)));
                if (result === "skipped") return entry;
                if (!result || result === "failed") {
                    (_a = host.log) == null || _a.call(host, `Unexpected failure resolving auto import for '${entry.name}' from '${entry.source}'`);
                    return void 0;
                }
                const newOrigin = {
                    ...origin,
                    kind: 32 /* ResolvedExport */ ,
                    moduleSpecifier: result.moduleSpecifier
                };
                entry.data = originToCompletionEntryData(newOrigin);
                entry.source = getSourceFromOrigin(newOrigin);
                entry.sourceDisplay = [
                    textPart(newOrigin.moduleSpecifier)
                ];
                return entry;
            });
            if (!context.skippedAny()) previousResponse.isIncomplete = void 0;
            return entries;
        });
        previousResponse.entries = newEntries;
        previousResponse.flags = (previousResponse.flags || 0) | 4 /* IsContinuation */ ;
        previousResponse.optionalReplacementSpan = getOptionalReplacementSpan(touchNode);
        return previousResponse;
    }
    function jsdocCompletionInfo(entries) {
        return {
            isGlobalCompletion: false,
            isMemberCompletion: false,
            isNewIdentifierLocation: false,
            entries: entries
        };
    }
    function getJSDocParameterCompletions(sourceFile, position, checker, options, preferences, tagNameOnly) {
        const currentToken = getTokenAtPosition(sourceFile, position);
        if (!isJSDocTag(currentToken) && !isJSDoc(currentToken)) return [];
        const jsDoc = isJSDoc(currentToken) ? currentToken : currentToken.parent;
        if (!isJSDoc(jsDoc)) return [];
        const func = jsDoc.parent;
        if (!isFunctionLike(func)) return [];
        const isJs = isSourceFileJS(sourceFile);
        const isSnippet = preferences.includeCompletionsWithSnippetText || void 0;
        const paramTagCount = countWhere(jsDoc.tags, (tag)=>isJSDocParameterTag(tag) && tag.getEnd() <= position);
        return mapDefined(func.parameters, (param)=>{
            if (getJSDocParameterTags(param).length) return void 0;
            if (isIdentifier(param.name)) {
                const tabstopCounter = {
                    tabstop: 1
                };
                const paramName = param.name.text;
                let displayText = getJSDocParamAnnotation(paramName, param.initializer, param.dotDotDotToken, isJs, /*isObject*/ false, /*isSnippet*/ false, checker, options, preferences);
                let snippetText = isSnippet ? getJSDocParamAnnotation(paramName, param.initializer, param.dotDotDotToken, isJs, /*isObject*/ false, /*isSnippet*/ true, checker, options, preferences, tabstopCounter) : void 0;
                if (tagNameOnly) {
                    displayText = displayText.slice(1);
                    if (snippetText) snippetText = snippetText.slice(1);
                }
                return {
                    name: displayText,
                    kind: "parameter" /* parameterElement */ ,
                    sortText: SortText.LocationPriority,
                    insertText: isSnippet ? snippetText : void 0,
                    isSnippet: isSnippet
                };
            } else if (param.parent.parameters.indexOf(param) === paramTagCount) {
                const paramPath = `param${paramTagCount}`;
                const displayTextResult = generateJSDocParamTagsForDestructuring(paramPath, param.name, param.initializer, param.dotDotDotToken, isJs, /*isSnippet*/ false, checker, options, preferences);
                const snippetTextResult = isSnippet ? generateJSDocParamTagsForDestructuring(paramPath, param.name, param.initializer, param.dotDotDotToken, isJs, /*isSnippet*/ true, checker, options, preferences) : void 0;
                let displayText = displayTextResult.join(getNewLineCharacter(options) + "* ");
                let snippetText = snippetTextResult == null ? void 0 : snippetTextResult.join(getNewLineCharacter(options) + "* ");
                if (tagNameOnly) {
                    displayText = displayText.slice(1);
                    if (snippetText) snippetText = snippetText.slice(1);
                }
                return {
                    name: displayText,
                    kind: "parameter" /* parameterElement */ ,
                    sortText: SortText.LocationPriority,
                    insertText: isSnippet ? snippetText : void 0,
                    isSnippet: isSnippet
                };
            }
        });
    }
    function generateJSDocParamTagsForDestructuring(path, pattern, initializer, dotDotDotToken, isJs, isSnippet, checker, options, preferences) {
        if (!isJs) return [
            getJSDocParamAnnotation(path, initializer, dotDotDotToken, isJs, /*isObject*/ false, isSnippet, checker, options, preferences, {
                tabstop: 1
            })
        ];
        return patternWorker(path, pattern, initializer, dotDotDotToken, {
            tabstop: 1
        });
        function patternWorker(path2, pattern2, initializer2, dotDotDotToken2, counter) {
            if (isObjectBindingPattern(pattern2) && !dotDotDotToken2) {
                const oldTabstop = counter.tabstop;
                const childCounter = {
                    tabstop: oldTabstop
                };
                const rootParam = getJSDocParamAnnotation(path2, initializer2, dotDotDotToken2, isJs, /*isObject*/ true, isSnippet, checker, options, preferences, childCounter);
                let childTags = [];
                for (const element of pattern2.elements){
                    const elementTags = elementWorker(path2, element, childCounter);
                    if (!elementTags) {
                        childTags = void 0;
                        break;
                    } else childTags.push(...elementTags);
                }
                if (childTags) {
                    counter.tabstop = childCounter.tabstop;
                    return [
                        rootParam,
                        ...childTags
                    ];
                }
            }
            return [
                getJSDocParamAnnotation(path2, initializer2, dotDotDotToken2, isJs, /*isObject*/ false, isSnippet, checker, options, preferences, counter)
            ];
        }
        function elementWorker(path2, element, counter) {
            if (!element.propertyName && isIdentifier(element.name) || isIdentifier(element.name)) {
                const propertyName = element.propertyName ? tryGetTextOfPropertyName(element.propertyName) : element.name.text;
                if (!propertyName) return void 0;
                const paramName = `${path2}.${propertyName}`;
                return [
                    getJSDocParamAnnotation(paramName, element.initializer, element.dotDotDotToken, isJs, /*isObject*/ false, isSnippet, checker, options, preferences, counter)
                ];
            } else if (element.propertyName) {
                const propertyName = tryGetTextOfPropertyName(element.propertyName);
                return propertyName && patternWorker(`${path2}.${propertyName}`, element.name, element.initializer, element.dotDotDotToken, counter);
            }
            return void 0;
        }
    }
    function getJSDocParamAnnotation(paramName, initializer, dotDotDotToken, isJs, isObject, isSnippet, checker, options, preferences, tabstopCounter) {
        if (isSnippet) Debug.assertIsDefined(tabstopCounter);
        if (initializer) paramName = getJSDocParamNameWithInitializer(paramName, initializer);
        if (isSnippet) paramName = escapeSnippetText(paramName);
        if (isJs) {
            let type = "*";
            if (isObject) {
                Debug.assert(!dotDotDotToken, `Cannot annotate a rest parameter with type 'Object'.`);
                type = "Object";
            } else {
                if (initializer) {
                    const inferredType = checker.getTypeAtLocation(initializer.parent);
                    if (!(inferredType.flags & 16385 /* Void */ )) {
                        const sourceFile = initializer.getSourceFile();
                        const quotePreference = getQuotePreference(sourceFile, preferences);
                        const builderFlags = quotePreference === 0 /* Single */  ? 268435456 /* UseSingleQuotesForStringLiteralType */  : 0 /* None */ ;
                        const typeNode = checker.typeToTypeNode(inferredType, findAncestor(initializer, isFunctionLike), builderFlags);
                        if (typeNode) {
                            const printer = isSnippet ? createSnippetPrinter({
                                removeComments: true,
                                module: options.module,
                                target: options.target
                            }) : createPrinter({
                                removeComments: true,
                                module: options.module,
                                target: options.target
                            });
                            setEmitFlags(typeNode, 1 /* SingleLine */ );
                            type = printer.printNode(4 /* Unspecified */ , typeNode, sourceFile);
                        }
                    }
                }
                if (isSnippet && type === "*") type = `\${${tabstopCounter.tabstop++}:${type}}`;
            }
            const dotDotDot = !isObject && dotDotDotToken ? "..." : "";
            const description3 = isSnippet ? `\${${tabstopCounter.tabstop++}}` : "";
            return `@param {${dotDotDot}${type}} ${paramName} ${description3}`;
        } else {
            const description3 = isSnippet ? `\${${tabstopCounter.tabstop++}}` : "";
            return `@param ${paramName} ${description3}`;
        }
    }
    function getJSDocParamNameWithInitializer(paramName, initializer) {
        const initializerText = initializer.getText().trim();
        if (initializerText.includes("\n") || initializerText.length > 80) return `[${paramName}]`;
        return `[${paramName}=${initializerText}]`;
    }
    function keywordToCompletionEntry(keyword) {
        return {
            name: tokenToString(keyword),
            kind: "keyword" /* keyword */ ,
            kindModifiers: "" /* none */ ,
            sortText: SortText.GlobalsOrKeywords
        };
    }
    function specificKeywordCompletionInfo(entries, isNewIdentifierLocation) {
        return {
            isGlobalCompletion: false,
            isMemberCompletion: false,
            isNewIdentifierLocation: isNewIdentifierLocation,
            entries: entries.slice()
        };
    }
    function keywordCompletionData(keywordFilters, filterOutTsOnlyKeywords, isNewIdentifierLocation) {
        return {
            kind: 4 /* Keywords */ ,
            keywordCompletions: getKeywordCompletions(keywordFilters, filterOutTsOnlyKeywords),
            isNewIdentifierLocation: isNewIdentifierLocation
        };
    }
    function keywordFiltersFromSyntaxKind(keywordCompletion) {
        switch(keywordCompletion){
            case 156 /* TypeKeyword */ :
                return 8 /* TypeKeyword */ ;
            default:
                Debug.fail("Unknown mapping from SyntaxKind to KeywordCompletionFilters");
        }
    }
    function getOptionalReplacementSpan(location) {
        return (location == null ? void 0 : location.kind) === 80 /* Identifier */  ? createTextSpanFromNode(location) : void 0;
    }
    function completionInfoFromData(sourceFile, host, program, compilerOptions, log, completionData, preferences, formatContext, position, includeSymbol) {
        const { symbols: symbols , contextToken: contextToken , completionKind: completionKind , isInSnippetScope: isInSnippetScope , isNewIdentifierLocation: isNewIdentifierLocation , location: location , propertyAccessToConvert: propertyAccessToConvert , keywordFilters: keywordFilters , symbolToOriginInfoMap: symbolToOriginInfoMap , recommendedCompletion: recommendedCompletion , isJsxInitializer: isJsxInitializer , isTypeOnlyLocation: isTypeOnlyLocation , isJsxIdentifierExpected: isJsxIdentifierExpected , isRightOfOpenTag: isRightOfOpenTag , isRightOfDotOrQuestionDot: isRightOfDotOrQuestionDot , importStatementCompletion: importStatementCompletion , insideJsDocTagTypeExpression: insideJsDocTagTypeExpression , symbolToSortTextMap: symbolToSortTextMap , hasUnresolvedAutoImports: hasUnresolvedAutoImports  } = completionData;
        let literals = completionData.literals;
        const checker = program.getTypeChecker();
        if (getLanguageVariant(sourceFile.scriptKind) === 1 /* JSX */ ) {
            const completionInfo = getJsxClosingTagCompletion(location, sourceFile);
            if (completionInfo) return completionInfo;
        }
        const caseClause = findAncestor(contextToken, isCaseClause);
        if (caseClause && (isCaseKeyword(contextToken) || isNodeDescendantOf(contextToken, caseClause.expression))) {
            const tracker = newCaseClauseTracker(checker, caseClause.parent.clauses);
            literals = literals.filter((literal)=>!tracker.hasValue(literal));
            symbols.forEach((symbol, i)=>{
                if (symbol.valueDeclaration && isEnumMember(symbol.valueDeclaration)) {
                    const value1 = checker.getConstantValue(symbol.valueDeclaration);
                    if (value1 !== void 0 && tracker.hasValue(value1)) symbolToOriginInfoMap[i] = {
                        kind: 256 /* Ignore */ 
                    };
                }
            });
        }
        const entries = createSortedArray();
        const isChecked = isCheckedFile(sourceFile, compilerOptions);
        if (isChecked && !isNewIdentifierLocation && (!symbols || symbols.length === 0) && keywordFilters === 0 /* None */ ) return void 0;
        const uniqueNames = getCompletionEntriesFromSymbols(symbols, entries, /*replacementToken*/ void 0, contextToken, location, position, sourceFile, host, program, getEmitScriptTarget(compilerOptions), log, completionKind, preferences, compilerOptions, formatContext, isTypeOnlyLocation, propertyAccessToConvert, isJsxIdentifierExpected, isJsxInitializer, importStatementCompletion, recommendedCompletion, symbolToOriginInfoMap, symbolToSortTextMap, isJsxIdentifierExpected, isRightOfOpenTag, includeSymbol);
        if (keywordFilters !== 0 /* None */ ) {
            for (const keywordEntry of getKeywordCompletions(keywordFilters, !insideJsDocTagTypeExpression && isSourceFileJS(sourceFile)))if (isTypeOnlyLocation && isTypeKeyword(stringToToken(keywordEntry.name)) || !uniqueNames.has(keywordEntry.name)) {
                uniqueNames.add(keywordEntry.name);
                insertSorted(entries, keywordEntry, compareCompletionEntries, /*allowDuplicates*/ true);
            }
        }
        for (const keywordEntry of getContextualKeywords(contextToken, position))if (!uniqueNames.has(keywordEntry.name)) {
            uniqueNames.add(keywordEntry.name);
            insertSorted(entries, keywordEntry, compareCompletionEntries, /*allowDuplicates*/ true);
        }
        for (const literal of literals){
            const literalEntry = createCompletionEntryForLiteral(sourceFile, preferences, literal);
            uniqueNames.add(literalEntry.name);
            insertSorted(entries, literalEntry, compareCompletionEntries, /*allowDuplicates*/ true);
        }
        if (!isChecked) getJSCompletionEntries(sourceFile, location.pos, uniqueNames, getEmitScriptTarget(compilerOptions), entries);
        let caseBlock;
        if (preferences.includeCompletionsWithInsertText && contextToken && !isRightOfOpenTag && !isRightOfDotOrQuestionDot && (caseBlock = findAncestor(contextToken, isCaseBlock))) {
            const cases = getExhaustiveCaseSnippets(caseBlock, sourceFile, preferences, compilerOptions, host, program, formatContext);
            if (cases) entries.push(cases.entry);
        }
        return {
            flags: completionData.flags,
            isGlobalCompletion: isInSnippetScope,
            isIncomplete: preferences.allowIncompleteCompletions && hasUnresolvedAutoImports ? true : void 0,
            isMemberCompletion: isMemberCompletionKind(completionKind),
            isNewIdentifierLocation: isNewIdentifierLocation,
            optionalReplacementSpan: getOptionalReplacementSpan(location),
            entries: entries
        };
    }
    function isCheckedFile(sourceFile, compilerOptions) {
        return !isSourceFileJS(sourceFile) || !!isCheckJsEnabledForFile(sourceFile, compilerOptions);
    }
    function getExhaustiveCaseSnippets(caseBlock, sourceFile, preferences, options, host, program, formatContext) {
        const clauses = caseBlock.clauses;
        const checker = program.getTypeChecker();
        const switchType = checker.getTypeAtLocation(caseBlock.parent.expression);
        if (switchType && switchType.isUnion() && every(switchType.types, (type)=>type.isLiteral())) {
            const tracker = newCaseClauseTracker(checker, clauses);
            const target = getEmitScriptTarget(options);
            const quotePreference = getQuotePreference(sourceFile, preferences);
            const importAdder = ts_codefix_exports.createImportAdder(sourceFile, program, preferences, host);
            const elements = [];
            for (const type of switchType.types){
                if (type.flags & 1024 /* EnumLiteral */ ) {
                    Debug.assert(type.symbol, "An enum member type should have a symbol");
                    Debug.assert(type.symbol.parent, "An enum member type should have a parent symbol (the enum symbol)");
                    const enumValue = type.symbol.valueDeclaration && checker.getConstantValue(type.symbol.valueDeclaration);
                    if (enumValue !== void 0) {
                        if (tracker.hasValue(enumValue)) continue;
                        tracker.addValue(enumValue);
                    }
                    const typeNode = ts_codefix_exports.typeToAutoImportableTypeNode(checker, importAdder, type, caseBlock, target);
                    if (!typeNode) return void 0;
                    const expr = typeNodeToExpression(typeNode, target, quotePreference);
                    if (!expr) return void 0;
                    elements.push(expr);
                } else if (!tracker.hasValue(type.value)) switch(typeof type.value){
                    case "object":
                        elements.push(type.value.negative ? factory.createPrefixUnaryExpression(41 /* MinusToken */ , factory.createBigIntLiteral({
                            negative: false,
                            base10Value: type.value.base10Value
                        })) : factory.createBigIntLiteral(type.value));
                        break;
                    case "number":
                        elements.push(type.value < 0 ? factory.createPrefixUnaryExpression(41 /* MinusToken */ , factory.createNumericLiteral(-type.value)) : factory.createNumericLiteral(type.value));
                        break;
                    case "string":
                        elements.push(factory.createStringLiteral(type.value, quotePreference === 0 /* Single */ ));
                        break;
                }
            }
            if (elements.length === 0) return void 0;
            const newClauses = map(elements, (element)=>factory.createCaseClause(element, []));
            const newLineChar = getNewLineOrDefaultFromHost(host, formatContext == null ? void 0 : formatContext.options);
            const printer = createSnippetPrinter({
                removeComments: true,
                module: options.module,
                target: options.target,
                newLine: getNewLineKind(newLineChar)
            });
            const printNode = formatContext ? (node)=>printer.printAndFormatNode(4 /* Unspecified */ , node, sourceFile, formatContext) : (node)=>printer.printNode(4 /* Unspecified */ , node, sourceFile);
            const insertText = map(newClauses, (clause, i)=>{
                if (preferences.includeCompletionsWithSnippetText) return `${printNode(clause)}$${i + 1}`;
                return `${printNode(clause)}`;
            }).join(newLineChar);
            const firstClause = printer.printNode(4 /* Unspecified */ , newClauses[0], sourceFile);
            return {
                entry: {
                    name: `${firstClause} ...`,
                    kind: "" /* unknown */ ,
                    sortText: SortText.GlobalsOrKeywords,
                    insertText: insertText,
                    hasAction: importAdder.hasFixes() || void 0,
                    source: "SwitchCases/" /* SwitchCases */ ,
                    isSnippet: preferences.includeCompletionsWithSnippetText ? true : void 0
                },
                importAdder: importAdder
            };
        }
        return void 0;
    }
    function typeNodeToExpression(typeNode, languageVersion, quotePreference) {
        switch(typeNode.kind){
            case 182 /* TypeReference */ :
                const typeName = typeNode.typeName;
                return entityNameToExpression(typeName, languageVersion, quotePreference);
            case 198 /* IndexedAccessType */ :
                const objectExpression = typeNodeToExpression(typeNode.objectType, languageVersion, quotePreference);
                const indexExpression = typeNodeToExpression(typeNode.indexType, languageVersion, quotePreference);
                return objectExpression && indexExpression && factory.createElementAccessExpression(objectExpression, indexExpression);
            case 200 /* LiteralType */ :
                const literal = typeNode.literal;
                switch(literal.kind){
                    case 11 /* StringLiteral */ :
                        return factory.createStringLiteral(literal.text, quotePreference === 0 /* Single */ );
                    case 9 /* NumericLiteral */ :
                        return factory.createNumericLiteral(literal.text, literal.numericLiteralFlags);
                }
                return void 0;
            case 195 /* ParenthesizedType */ :
                const exp = typeNodeToExpression(typeNode.type, languageVersion, quotePreference);
                return exp && (isIdentifier(exp) ? exp : factory.createParenthesizedExpression(exp));
            case 185 /* TypeQuery */ :
                return entityNameToExpression(typeNode.exprName, languageVersion, quotePreference);
            case 204 /* ImportType */ :
                Debug.fail(`We should not get an import type after calling 'codefix.typeToAutoImportableTypeNode'.`);
        }
        return void 0;
    }
    function entityNameToExpression(entityName, languageVersion, quotePreference) {
        if (isIdentifier(entityName)) return entityName;
        const unescapedName = unescapeLeadingUnderscores(entityName.right.escapedText);
        if (canUsePropertyAccess(unescapedName, languageVersion)) return factory.createPropertyAccessExpression(entityNameToExpression(entityName.left, languageVersion, quotePreference), unescapedName);
        else return factory.createElementAccessExpression(entityNameToExpression(entityName.left, languageVersion, quotePreference), factory.createStringLiteral(unescapedName, quotePreference === 0 /* Single */ ));
    }
    function isMemberCompletionKind(kind) {
        switch(kind){
            case 0 /* ObjectPropertyDeclaration */ :
            case 3 /* MemberLike */ :
            case 2 /* PropertyAccess */ :
                return true;
            default:
                return false;
        }
    }
    function getJsxClosingTagCompletion(location, sourceFile) {
        const jsxClosingElement = findAncestor(location, (node)=>{
            switch(node.kind){
                case 286 /* JsxClosingElement */ :
                    return true;
                case 44 /* SlashToken */ :
                case 32 /* GreaterThanToken */ :
                case 80 /* Identifier */ :
                case 210 /* PropertyAccessExpression */ :
                    return false;
                default:
                    return "quit";
            }
        });
        if (jsxClosingElement) {
            const hasClosingAngleBracket = !!findChildOfKind(jsxClosingElement, 32 /* GreaterThanToken */ , sourceFile);
            const tagName = jsxClosingElement.parent.openingElement.tagName;
            const closingTag = tagName.getText(sourceFile);
            const fullClosingTag = closingTag + (hasClosingAngleBracket ? "" : ">");
            const replacementSpan = createTextSpanFromNode(jsxClosingElement.tagName);
            const entry = {
                name: fullClosingTag,
                kind: "class" /* classElement */ ,
                kindModifiers: void 0,
                sortText: SortText.LocationPriority
            };
            return {
                isGlobalCompletion: false,
                isMemberCompletion: true,
                isNewIdentifierLocation: false,
                optionalReplacementSpan: replacementSpan,
                entries: [
                    entry
                ]
            };
        }
        return;
    }
    function getJSCompletionEntries(sourceFile, position, uniqueNames, target, entries) {
        getNameTable(sourceFile).forEach((pos, name)=>{
            if (pos === position) return;
            const realName = unescapeLeadingUnderscores(name);
            if (!uniqueNames.has(realName) && isIdentifierText(realName, target)) {
                uniqueNames.add(realName);
                insertSorted(entries, {
                    name: realName,
                    kind: "warning" /* warning */ ,
                    kindModifiers: "",
                    sortText: SortText.JavascriptIdentifiers,
                    isFromUncheckedFile: true
                }, compareCompletionEntries);
            }
        });
    }
    function completionNameForLiteral(sourceFile, preferences, literal) {
        return typeof literal === "object" ? pseudoBigIntToString(literal) + "n" : isString(literal) ? quote(sourceFile, preferences, literal) : JSON.stringify(literal);
    }
    function createCompletionEntryForLiteral(sourceFile, preferences, literal) {
        return {
            name: completionNameForLiteral(sourceFile, preferences, literal),
            kind: "string" /* string */ ,
            kindModifiers: "" /* none */ ,
            sortText: SortText.LocationPriority
        };
    }
    function createCompletionEntry(symbol, sortText, replacementToken, contextToken, location, position, sourceFile, host, program, name, needsConvertPropertyAccess, origin, recommendedCompletion, propertyAccessToConvert, isJsxInitializer, importStatementCompletion, useSemicolons, options, preferences, completionKind, formatContext, isJsxIdentifierExpected, isRightOfOpenTag, includeSymbol) {
        let insertText;
        let replacementSpan = getReplacementSpanForContextToken(replacementToken);
        let data;
        let isSnippet;
        let source = getSourceFromOrigin(origin);
        let sourceDisplay;
        let hasAction;
        let labelDetails;
        const typeChecker = program.getTypeChecker();
        const insertQuestionDot = origin && originIsNullableMember(origin);
        const useBraces = origin && originIsSymbolMember(origin) || needsConvertPropertyAccess;
        if (origin && originIsThisType(origin)) insertText = needsConvertPropertyAccess ? `this${insertQuestionDot ? "?." : ""}[${quotePropertyName(sourceFile, preferences, name)}]` : `this${insertQuestionDot ? "?." : "."}${name}`;
        else if ((useBraces || insertQuestionDot) && propertyAccessToConvert) {
            insertText = useBraces ? needsConvertPropertyAccess ? `[${quotePropertyName(sourceFile, preferences, name)}]` : `[${name}]` : name;
            if (insertQuestionDot || propertyAccessToConvert.questionDotToken) insertText = `?.${insertText}`;
            const dot = findChildOfKind(propertyAccessToConvert, 25 /* DotToken */ , sourceFile) || findChildOfKind(propertyAccessToConvert, 29 /* QuestionDotToken */ , sourceFile);
            if (!dot) return void 0;
            const end = startsWith(name, propertyAccessToConvert.name.text) ? propertyAccessToConvert.name.end : dot.end;
            replacementSpan = createTextSpanFromBounds(dot.getStart(sourceFile), end);
        }
        if (isJsxInitializer) {
            if (insertText === void 0) insertText = name;
            insertText = `{${insertText}}`;
            if (typeof isJsxInitializer !== "boolean") replacementSpan = createTextSpanFromNode(isJsxInitializer, sourceFile);
        }
        if (origin && originIsPromise(origin) && propertyAccessToConvert) {
            if (insertText === void 0) insertText = name;
            const precedingToken = findPrecedingToken(propertyAccessToConvert.pos, sourceFile);
            let awaitText = "";
            if (precedingToken && positionIsASICandidate(precedingToken.end, precedingToken.parent, sourceFile)) awaitText = ";";
            awaitText += `(await ${propertyAccessToConvert.expression.getText()})`;
            insertText = needsConvertPropertyAccess ? `${awaitText}${insertText}` : `${awaitText}${insertQuestionDot ? "?." : "."}${insertText}`;
            const isInAwaitExpression = tryCast(propertyAccessToConvert.parent, isAwaitExpression);
            const wrapNode = isInAwaitExpression ? propertyAccessToConvert.parent : propertyAccessToConvert.expression;
            replacementSpan = createTextSpanFromBounds(wrapNode.getStart(sourceFile), propertyAccessToConvert.end);
        }
        if (originIsResolvedExport(origin)) {
            sourceDisplay = [
                textPart(origin.moduleSpecifier)
            ];
            if (importStatementCompletion) {
                ({ insertText: insertText , replacementSpan: replacementSpan  } = getInsertTextAndReplacementSpanForImportCompletion(name, importStatementCompletion, origin, useSemicolons, sourceFile, options, preferences));
                isSnippet = preferences.includeCompletionsWithSnippetText ? true : void 0;
            }
        }
        if ((origin == null ? void 0 : origin.kind) === 64 /* TypeOnlyAlias */ ) hasAction = true;
        if (preferences.includeCompletionsWithClassMemberSnippets && preferences.includeCompletionsWithInsertText && completionKind === 3 /* MemberLike */  && isClassLikeMemberCompletion(symbol, location, sourceFile)) {
            let importAdder;
            ({ insertText: insertText , isSnippet: isSnippet , importAdder: importAdder , replacementSpan: replacementSpan  } = getEntryForMemberCompletion(host, program, options, preferences, name, symbol, location, position, contextToken, formatContext));
            sortText = SortText.ClassMemberSnippets;
            if (importAdder == null ? void 0 : importAdder.hasFixes()) {
                hasAction = true;
                source = "ClassMemberSnippet/" /* ClassMemberSnippet */ ;
            }
        }
        if (origin && originIsObjectLiteralMethod(origin)) {
            ({ insertText: insertText , isSnippet: isSnippet , labelDetails: labelDetails  } = origin);
            if (!preferences.useLabelDetailsInCompletionEntries) {
                name = name + labelDetails.detail;
                labelDetails = void 0;
            }
            source = "ObjectLiteralMethodSnippet/" /* ObjectLiteralMethodSnippet */ ;
            sortText = SortText.SortBelow(sortText);
        }
        if (isJsxIdentifierExpected && !isRightOfOpenTag && preferences.includeCompletionsWithSnippetText && preferences.jsxAttributeCompletionStyle && preferences.jsxAttributeCompletionStyle !== "none" && !(isJsxAttribute(location.parent) && location.parent.initializer)) {
            let useBraces2 = preferences.jsxAttributeCompletionStyle === "braces";
            const type = typeChecker.getTypeOfSymbolAtLocation(symbol, location);
            if (preferences.jsxAttributeCompletionStyle === "auto" && !(type.flags & 528 /* BooleanLike */ ) && !(type.flags & 1048576 /* Union */  && find(type.types, (type2)=>!!(type2.flags & 528 /* BooleanLike */ )))) {
                if (type.flags & 402653316 /* StringLike */  || type.flags & 1048576 /* Union */  && every(type.types, (type2)=>!!(type2.flags & 402686084 /* Undefined */  || isStringAndEmptyAnonymousObjectIntersection(type2)))) {
                    insertText = `${escapeSnippetText(name)}=${quote(sourceFile, preferences, "$1")}`;
                    isSnippet = true;
                } else useBraces2 = true;
            }
            if (useBraces2) {
                insertText = `${escapeSnippetText(name)}={$1}`;
                isSnippet = true;
            }
        }
        if (insertText !== void 0 && !preferences.includeCompletionsWithInsertText) return void 0;
        if (originIsExport(origin) || originIsResolvedExport(origin)) {
            data = originToCompletionEntryData(origin);
            hasAction = !importStatementCompletion;
        }
        return {
            name: name,
            kind: ts_SymbolDisplay_exports.getSymbolKind(typeChecker, symbol, location),
            kindModifiers: ts_SymbolDisplay_exports.getSymbolModifiers(typeChecker, symbol),
            sortText: sortText,
            source: source,
            hasAction: hasAction ? true : void 0,
            isRecommended: isRecommendedCompletionMatch(symbol, recommendedCompletion, typeChecker) || void 0,
            insertText: insertText,
            replacementSpan: replacementSpan,
            sourceDisplay: sourceDisplay,
            labelDetails: labelDetails,
            isSnippet: isSnippet,
            isPackageJsonImport: originIsPackageJsonImport(origin) || void 0,
            isImportStatementCompletion: !!importStatementCompletion || void 0,
            data: data,
            ...includeSymbol ? {
                symbol: symbol
            } : void 0
        };
    }
    function isClassLikeMemberCompletion(symbol, location, sourceFile) {
        if (isInJSFile(location)) return false;
        const memberFlags = 106500 /* EnumMemberExcludes */ ;
        return !!(symbol.flags & memberFlags) && (isClassLike(location) || location.parent && location.parent.parent && isClassElement(location.parent) && location === location.parent.name && location.parent.getLastToken(sourceFile) === location.parent.name && isClassLike(location.parent.parent) || location.parent && isSyntaxList(location) && isClassLike(location.parent));
    }
    function getEntryForMemberCompletion(host, program, options, preferences, name, symbol, location, position, contextToken, formatContext) {
        const classLikeDeclaration = findAncestor(location, isClassLike);
        if (!classLikeDeclaration) return {
            insertText: name
        };
        let isSnippet;
        let replacementSpan;
        let insertText = name;
        const checker = program.getTypeChecker();
        const sourceFile = location.getSourceFile();
        const printer = createSnippetPrinter({
            removeComments: true,
            module: options.module,
            target: options.target,
            omitTrailingSemicolon: false,
            newLine: getNewLineKind(getNewLineOrDefaultFromHost(host, formatContext == null ? void 0 : formatContext.options))
        });
        const importAdder = ts_codefix_exports.createImportAdder(sourceFile, program, preferences, host);
        let body;
        if (preferences.includeCompletionsWithSnippetText) {
            isSnippet = true;
            const emptyStmt = factory.createEmptyStatement();
            body = factory.createBlock([
                emptyStmt
            ], /*multiLine*/ true);
            setSnippetElement(emptyStmt, {
                kind: 0 /* TabStop */ ,
                order: 0
            });
        } else body = factory.createBlock([], /*multiLine*/ true);
        let modifiers = 0 /* None */ ;
        const { modifiers: presentModifiers , span: modifiersSpan  } = getPresentModifiers(contextToken, sourceFile, position);
        const isAbstract = !!(presentModifiers & 256 /* Abstract */ );
        const completionNodes = [];
        ts_codefix_exports.addNewNodeForMemberSymbol(symbol, classLikeDeclaration, sourceFile, {
            program: program,
            host: host
        }, preferences, importAdder, // `addNewNodeForMemberSymbol` calls this callback function for each new member node
        // it adds for the given member symbol.
        // We store these member nodes in the `completionNodes` array.
        // Note: there might be:
        //  - No nodes if `addNewNodeForMemberSymbol` cannot figure out a node for the member;
        //  - One node;
        //  - More than one node if the member is overloaded (e.g. a method with overload signatures).
        (node)=>{
            let requiredModifiers = 0 /* None */ ;
            if (isAbstract) requiredModifiers |= 256 /* Abstract */ ;
            if (isClassElement(node) && checker.getMemberOverrideModifierStatus(classLikeDeclaration, node, symbol) === 1 /* NeedsOverride */ ) requiredModifiers |= 16384 /* Override */ ;
            if (!completionNodes.length) modifiers = node.modifierFlagsCache | requiredModifiers | presentModifiers;
            node = factory.updateModifiers(node, modifiers);
            completionNodes.push(node);
        }, body, ts_codefix_exports.PreserveOptionalFlags.Property, isAbstract);
        if (completionNodes.length) {
            const format = 131073 /* NoTrailingNewLine */ ;
            replacementSpan = modifiersSpan;
            if (formatContext) insertText = printer.printAndFormatSnippetList(format, factory.createNodeArray(completionNodes), sourceFile, formatContext);
            else insertText = printer.printSnippetList(format, factory.createNodeArray(completionNodes), sourceFile);
        }
        return {
            insertText: insertText,
            isSnippet: isSnippet,
            importAdder: importAdder,
            replacementSpan: replacementSpan
        };
    }
    function getPresentModifiers(contextToken, sourceFile, position) {
        if (!contextToken || getLineAndCharacterOfPosition(sourceFile, position).line > getLineAndCharacterOfPosition(sourceFile, contextToken.getEnd()).line) return {
            modifiers: 0 /* None */ 
        };
        let modifiers = 0 /* None */ ;
        let span;
        let contextMod;
        if (contextMod = isModifierLike2(contextToken)) {
            modifiers |= modifierToFlag(contextMod);
            span = createTextSpanFromNode(contextToken);
        }
        if (isPropertyDeclaration(contextToken.parent)) {
            modifiers |= modifiersToFlags(contextToken.parent.modifiers) & 126975 /* Modifier */ ;
            span = createTextSpanFromNode(contextToken.parent);
        }
        return {
            modifiers: modifiers,
            span: span
        };
    }
    function isModifierLike2(node) {
        if (isModifier(node)) return node.kind;
        if (isIdentifier(node)) {
            const originalKeywordKind = identifierToKeywordKind(node);
            if (originalKeywordKind && isModifierKind(originalKeywordKind)) return originalKeywordKind;
        }
        return void 0;
    }
    function getEntryForObjectLiteralMethodCompletion(symbol, name, enclosingDeclaration, program, host, options, preferences, formatContext) {
        const isSnippet = preferences.includeCompletionsWithSnippetText || void 0;
        let insertText = name;
        const sourceFile = enclosingDeclaration.getSourceFile();
        const method = createObjectLiteralMethod(symbol, enclosingDeclaration, sourceFile, program, host, preferences);
        if (!method) return void 0;
        const printer = createSnippetPrinter({
            removeComments: true,
            module: options.module,
            target: options.target,
            omitTrailingSemicolon: false,
            newLine: getNewLineKind(getNewLineOrDefaultFromHost(host, formatContext == null ? void 0 : formatContext.options))
        });
        if (formatContext) insertText = printer.printAndFormatSnippetList(80 /* AllowTrailingComma */ , factory.createNodeArray([
            method
        ], /*hasTrailingComma*/ true), sourceFile, formatContext);
        else insertText = printer.printSnippetList(80 /* AllowTrailingComma */ , factory.createNodeArray([
            method
        ], /*hasTrailingComma*/ true), sourceFile);
        const signaturePrinter = createPrinter({
            removeComments: true,
            module: options.module,
            target: options.target,
            omitTrailingSemicolon: true
        });
        const methodSignature = factory.createMethodSignature(/*modifiers*/ void 0, /*name*/ "", method.questionToken, method.typeParameters, method.parameters, method.type);
        const labelDetails = {
            detail: signaturePrinter.printNode(4 /* Unspecified */ , methodSignature, sourceFile)
        };
        return {
            isSnippet: isSnippet,
            insertText: insertText,
            labelDetails: labelDetails
        };
    }
    function createObjectLiteralMethod(symbol, enclosingDeclaration, sourceFile, program, host, preferences) {
        const declarations = symbol.getDeclarations();
        if (!(declarations && declarations.length)) return void 0;
        const checker = program.getTypeChecker();
        const declaration = declarations[0];
        const name = getSynthesizedDeepClone(getNameOfDeclaration(declaration), /*includeTrivia*/ false);
        const type = checker.getWidenedType(checker.getTypeOfSymbolAtLocation(symbol, enclosingDeclaration));
        const quotePreference = getQuotePreference(sourceFile, preferences);
        const builderFlags = 33554432 /* OmitThisParameter */  | (quotePreference === 0 /* Single */  ? 268435456 /* UseSingleQuotesForStringLiteralType */  : 0 /* None */ );
        switch(declaration.kind){
            case 170 /* PropertySignature */ :
            case 171 /* PropertyDeclaration */ :
            case 172 /* MethodSignature */ :
            case 173 /* MethodDeclaration */ :
                {
                    let effectiveType = type.flags & 1048576 /* Union */  && type.types.length < 10 ? checker.getUnionType(type.types, 2 /* Subtype */ ) : type;
                    if (effectiveType.flags & 1048576 /* Union */ ) {
                        const functionTypes = filter(effectiveType.types, (type2)=>checker.getSignaturesOfType(type2, 0 /* Call */ ).length > 0);
                        if (functionTypes.length === 1) effectiveType = functionTypes[0];
                        else return void 0;
                    }
                    const signatures = checker.getSignaturesOfType(effectiveType, 0 /* Call */ );
                    if (signatures.length !== 1) return void 0;
                    const typeNode = checker.typeToTypeNode(effectiveType, enclosingDeclaration, builderFlags, ts_codefix_exports.getNoopSymbolTrackerWithResolver({
                        program: program,
                        host: host
                    }));
                    if (!typeNode || !isFunctionTypeNode(typeNode)) return void 0;
                    let body;
                    if (preferences.includeCompletionsWithSnippetText) {
                        const emptyStmt = factory.createEmptyStatement();
                        body = factory.createBlock([
                            emptyStmt
                        ], /*multiLine*/ true);
                        setSnippetElement(emptyStmt, {
                            kind: 0 /* TabStop */ ,
                            order: 0
                        });
                    } else body = factory.createBlock([], /*multiLine*/ true);
                    const parameters = typeNode.parameters.map((typedParam)=>factory.createParameterDeclaration(/*modifiers*/ void 0, typedParam.dotDotDotToken, typedParam.name, /*questionToken*/ void 0, /*type*/ void 0, typedParam.initializer));
                    return factory.createMethodDeclaration(/*modifiers*/ void 0, /*asteriskToken*/ void 0, name, /*questionToken*/ void 0, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body);
                }
            default:
                return void 0;
        }
    }
    function createSnippetPrinter(printerOptions) {
        let escapes;
        const baseWriter = ts_textChanges_exports.createWriter(getNewLineCharacter(printerOptions));
        const printer = createPrinter(printerOptions, baseWriter);
        const writer = {
            ...baseWriter,
            write: (s)=>escapingWrite(s, ()=>baseWriter.write(s)),
            nonEscapingWrite: baseWriter.write,
            writeLiteral: (s)=>escapingWrite(s, ()=>baseWriter.writeLiteral(s)),
            writeStringLiteral: (s)=>escapingWrite(s, ()=>baseWriter.writeStringLiteral(s)),
            writeSymbol: (s, symbol)=>escapingWrite(s, ()=>baseWriter.writeSymbol(s, symbol)),
            writeParameter: (s)=>escapingWrite(s, ()=>baseWriter.writeParameter(s)),
            writeComment: (s)=>escapingWrite(s, ()=>baseWriter.writeComment(s)),
            writeProperty: (s)=>escapingWrite(s, ()=>baseWriter.writeProperty(s))
        };
        return {
            printSnippetList: printSnippetList,
            printAndFormatSnippetList: printAndFormatSnippetList,
            printNode: printNode,
            printAndFormatNode: printAndFormatNode
        };
        function escapingWrite(s, write) {
            const escaped = escapeSnippetText(s);
            if (escaped !== s) {
                const start = baseWriter.getTextPos();
                write();
                const end = baseWriter.getTextPos();
                escapes = append(escapes || (escapes = []), {
                    newText: escaped,
                    span: {
                        start: start,
                        length: end - start
                    }
                });
            } else write();
        }
        function printSnippetList(format, list, sourceFile) {
            const unescaped = printUnescapedSnippetList(format, list, sourceFile);
            return escapes ? ts_textChanges_exports.applyChanges(unescaped, escapes) : unescaped;
        }
        function printUnescapedSnippetList(format, list, sourceFile) {
            escapes = void 0;
            writer.clear();
            printer.writeList(format, list, sourceFile, writer);
            return writer.getText();
        }
        function printAndFormatSnippetList(format, list, sourceFile, formatContext) {
            const syntheticFile = {
                text: printUnescapedSnippetList(format, list, sourceFile),
                getLineAndCharacterOfPosition (pos) {
                    return getLineAndCharacterOfPosition(this, pos);
                }
            };
            const formatOptions = getFormatCodeSettingsForWriting(formatContext, sourceFile);
            const changes = flatMap(list, (node)=>{
                const nodeWithPos = ts_textChanges_exports.assignPositionsToNode(node);
                return ts_formatting_exports.formatNodeGivenIndentation(nodeWithPos, syntheticFile, sourceFile.languageVariant, /* indentation */ 0, /* delta */ 0, {
                    ...formatContext,
                    options: formatOptions
                });
            });
            const allChanges = escapes ? stableSort(concatenate(changes, escapes), (a, b)=>compareTextSpans(a.span, b.span)) : changes;
            return ts_textChanges_exports.applyChanges(syntheticFile.text, allChanges);
        }
        function printNode(hint, node, sourceFile) {
            const unescaped = printUnescapedNode(hint, node, sourceFile);
            return escapes ? ts_textChanges_exports.applyChanges(unescaped, escapes) : unescaped;
        }
        function printUnescapedNode(hint, node, sourceFile) {
            escapes = void 0;
            writer.clear();
            printer.writeNode(hint, node, sourceFile, writer);
            return writer.getText();
        }
        function printAndFormatNode(hint, node, sourceFile, formatContext) {
            const syntheticFile = {
                text: printUnescapedNode(hint, node, sourceFile),
                getLineAndCharacterOfPosition (pos) {
                    return getLineAndCharacterOfPosition(this, pos);
                }
            };
            const formatOptions = getFormatCodeSettingsForWriting(formatContext, sourceFile);
            const nodeWithPos = ts_textChanges_exports.assignPositionsToNode(node);
            const changes = ts_formatting_exports.formatNodeGivenIndentation(nodeWithPos, syntheticFile, sourceFile.languageVariant, /* indentation */ 0, /* delta */ 0, {
                ...formatContext,
                options: formatOptions
            });
            const allChanges = escapes ? stableSort(concatenate(changes, escapes), (a, b)=>compareTextSpans(a.span, b.span)) : changes;
            return ts_textChanges_exports.applyChanges(syntheticFile.text, allChanges);
        }
    }
    function originToCompletionEntryData(origin) {
        const ambientModuleName = origin.fileName ? void 0 : stripQuotes(origin.moduleSymbol.name);
        const isPackageJsonImport = origin.isFromPackageJson ? true : void 0;
        if (originIsResolvedExport(origin)) {
            const resolvedData = {
                exportName: origin.exportName,
                exportMapKey: origin.exportMapKey,
                moduleSpecifier: origin.moduleSpecifier,
                ambientModuleName: ambientModuleName,
                fileName: origin.fileName,
                isPackageJsonImport: isPackageJsonImport
            };
            return resolvedData;
        }
        const unresolvedData = {
            exportName: origin.exportName,
            exportMapKey: origin.exportMapKey,
            fileName: origin.fileName,
            ambientModuleName: origin.fileName ? void 0 : stripQuotes(origin.moduleSymbol.name),
            isPackageJsonImport: origin.isFromPackageJson ? true : void 0
        };
        return unresolvedData;
    }
    function completionEntryDataToSymbolOriginInfo(data, completionName, moduleSymbol) {
        const isDefaultExport = data.exportName === "default" /* Default */ ;
        const isFromPackageJson = !!data.isPackageJsonImport;
        if (completionEntryDataIsResolved(data)) {
            const resolvedOrigin = {
                kind: 32 /* ResolvedExport */ ,
                exportName: data.exportName,
                exportMapKey: data.exportMapKey,
                moduleSpecifier: data.moduleSpecifier,
                symbolName: completionName,
                fileName: data.fileName,
                moduleSymbol: moduleSymbol,
                isDefaultExport: isDefaultExport,
                isFromPackageJson: isFromPackageJson
            };
            return resolvedOrigin;
        }
        const unresolvedOrigin = {
            kind: 4 /* Export */ ,
            exportName: data.exportName,
            exportMapKey: data.exportMapKey,
            symbolName: completionName,
            fileName: data.fileName,
            moduleSymbol: moduleSymbol,
            isDefaultExport: isDefaultExport,
            isFromPackageJson: isFromPackageJson
        };
        return unresolvedOrigin;
    }
    function getInsertTextAndReplacementSpanForImportCompletion(name, importStatementCompletion, origin, useSemicolons, sourceFile, options, preferences) {
        const replacementSpan = importStatementCompletion.replacementSpan;
        const quotedModuleSpecifier = escapeSnippetText(quote(sourceFile, preferences, origin.moduleSpecifier));
        const exportKind = origin.isDefaultExport ? 1 /* Default */  : origin.exportName === "export=" /* ExportEquals */  ? 2 /* ExportEquals */  : 0 /* Named */ ;
        const tabStop = preferences.includeCompletionsWithSnippetText ? "$1" : "";
        const importKind = ts_codefix_exports.getImportKind(sourceFile, exportKind, options, /*forceImportKeyword*/ true);
        const isImportSpecifierTypeOnly = importStatementCompletion.couldBeTypeOnlyImportSpecifier;
        const topLevelTypeOnlyText = importStatementCompletion.isTopLevelTypeOnly ? ` ${tokenToString(156 /* TypeKeyword */ )} ` : " ";
        const importSpecifierTypeOnlyText = isImportSpecifierTypeOnly ? `${tokenToString(156 /* TypeKeyword */ )} ` : "";
        const suffix = useSemicolons ? ";" : "";
        switch(importKind){
            case 3 /* CommonJS */ :
                return {
                    replacementSpan: replacementSpan,
                    insertText: `import${topLevelTypeOnlyText}${escapeSnippetText(name)}${tabStop} = require(${quotedModuleSpecifier})${suffix}`
                };
            case 1 /* Default */ :
                return {
                    replacementSpan: replacementSpan,
                    insertText: `import${topLevelTypeOnlyText}${escapeSnippetText(name)}${tabStop} from ${quotedModuleSpecifier}${suffix}`
                };
            case 2 /* Namespace */ :
                return {
                    replacementSpan: replacementSpan,
                    insertText: `import${topLevelTypeOnlyText}* as ${escapeSnippetText(name)} from ${quotedModuleSpecifier}${suffix}`
                };
            case 0 /* Named */ :
                return {
                    replacementSpan: replacementSpan,
                    insertText: `import${topLevelTypeOnlyText}{ ${importSpecifierTypeOnlyText}${escapeSnippetText(name)}${tabStop} } from ${quotedModuleSpecifier}${suffix}`
                };
        }
    }
    function quotePropertyName(sourceFile, preferences, name) {
        if (/^\d+$/.test(name)) return name;
        return quote(sourceFile, preferences, name);
    }
    function isRecommendedCompletionMatch(localSymbol, recommendedCompletion, checker) {
        return localSymbol === recommendedCompletion || !!(localSymbol.flags & 1048576 /* ExportValue */ ) && checker.getExportSymbolOfSymbol(localSymbol) === recommendedCompletion;
    }
    function getSourceFromOrigin(origin) {
        if (originIsExport(origin)) return stripQuotes(origin.moduleSymbol.name);
        if (originIsResolvedExport(origin)) return origin.moduleSpecifier;
        if ((origin == null ? void 0 : origin.kind) === 1 /* ThisType */ ) return "ThisProperty/" /* ThisProperty */ ;
        if ((origin == null ? void 0 : origin.kind) === 64 /* TypeOnlyAlias */ ) return "TypeOnlyAlias/" /* TypeOnlyAlias */ ;
    }
    function getCompletionEntriesFromSymbols(symbols, entries, replacementToken, contextToken, location, position, sourceFile, host, program, target, log, kind, preferences, compilerOptions, formatContext, isTypeOnlyLocation, propertyAccessToConvert, jsxIdentifierExpected, isJsxInitializer, importStatementCompletion, recommendedCompletion, symbolToOriginInfoMap, symbolToSortTextMap, isJsxIdentifierExpected, isRightOfOpenTag, includeSymbol = false) {
        const start = timestamp();
        const variableOrParameterDeclaration = getVariableOrParameterDeclaration(contextToken);
        const useSemicolons = probablyUsesSemicolons(sourceFile);
        const typeChecker = program.getTypeChecker();
        const uniques = /* @__PURE__ */ new Map();
        for(let i = 0; i < symbols.length; i++){
            const symbol = symbols[i];
            const origin = symbolToOriginInfoMap == null ? void 0 : symbolToOriginInfoMap[i];
            const info = getCompletionEntryDisplayNameForSymbol(symbol, target, origin, kind, !!jsxIdentifierExpected);
            if (!info || uniques.get(info.name) && (!origin || !originIsObjectLiteralMethod(origin)) || kind === 1 /* Global */  && symbolToSortTextMap && !shouldIncludeSymbol(symbol, symbolToSortTextMap)) continue;
            const { name: name , needsConvertPropertyAccess: needsConvertPropertyAccess  } = info;
            const originalSortText = (symbolToSortTextMap == null ? void 0 : symbolToSortTextMap[getSymbolId(symbol)]) ?? SortText.LocationPriority;
            const sortText = isDeprecated(symbol, typeChecker) ? SortText.Deprecated(originalSortText) : originalSortText;
            const entry = createCompletionEntry(symbol, sortText, replacementToken, contextToken, location, position, sourceFile, host, program, name, needsConvertPropertyAccess, origin, recommendedCompletion, propertyAccessToConvert, isJsxInitializer, importStatementCompletion, useSemicolons, compilerOptions, preferences, kind, formatContext, isJsxIdentifierExpected, isRightOfOpenTag, includeSymbol);
            if (!entry) continue;
            const shouldShadowLaterSymbols = (!origin || originIsTypeOnlyAlias(origin)) && !(symbol.parent === void 0 && !some(symbol.declarations, (d)=>d.getSourceFile() === location.getSourceFile()));
            uniques.set(name, shouldShadowLaterSymbols);
            insertSorted(entries, entry, compareCompletionEntries, /*allowDuplicates*/ true);
        }
        log("getCompletionsAtPosition: getCompletionEntriesFromSymbols: " + (timestamp() - start));
        return {
            has: (name)=>uniques.has(name),
            add: (name)=>uniques.set(name, true)
        };
        function shouldIncludeSymbol(symbol, symbolToSortTextMap2) {
            var _a;
            let allFlags = symbol.flags;
            if (!isSourceFile(location)) {
                if (isExportAssignment(location.parent)) return true;
                if (tryCast(variableOrParameterDeclaration, isVariableDeclaration) && symbol.valueDeclaration === variableOrParameterDeclaration) return false;
                const symbolDeclaration = symbol.valueDeclaration ?? ((_a = symbol.declarations) == null ? void 0 : _a[0]);
                if (variableOrParameterDeclaration && symbolDeclaration && (isTypeParameterDeclaration(variableOrParameterDeclaration) && isTypeParameterDeclaration(symbolDeclaration) || isParameter(variableOrParameterDeclaration) && isParameter(symbolDeclaration))) {
                    const symbolDeclarationPos = symbolDeclaration.pos;
                    const parameters = isParameter(variableOrParameterDeclaration) ? variableOrParameterDeclaration.parent.parameters : isInferTypeNode(variableOrParameterDeclaration.parent) ? void 0 : variableOrParameterDeclaration.parent.typeParameters;
                    if (symbolDeclarationPos >= variableOrParameterDeclaration.pos && parameters && symbolDeclarationPos < parameters.end) return false;
                }
                const symbolOrigin = skipAlias(symbol, typeChecker);
                if (!!sourceFile.externalModuleIndicator && !compilerOptions.allowUmdGlobalAccess && symbolToSortTextMap2[getSymbolId(symbol)] === SortText.GlobalsOrKeywords && (symbolToSortTextMap2[getSymbolId(symbolOrigin)] === SortText.AutoImportSuggestions || symbolToSortTextMap2[getSymbolId(symbolOrigin)] === SortText.LocationPriority)) return false;
                allFlags |= getCombinedLocalAndExportSymbolFlags(symbolOrigin);
                if (isInRightSideOfInternalImportEqualsDeclaration(location)) return !!(allFlags & 1920 /* Namespace */ );
                if (isTypeOnlyLocation) return symbolCanBeReferencedAtTypeLocation(symbol, typeChecker);
            }
            return !!(allFlags & 111551 /* Value */ );
        }
    }
    function getLabelCompletionAtPosition(node) {
        const entries = getLabelStatementCompletions(node);
        if (entries.length) return {
            isGlobalCompletion: false,
            isMemberCompletion: false,
            isNewIdentifierLocation: false,
            entries: entries
        };
    }
    function getLabelStatementCompletions(node) {
        const entries = [];
        const uniques = /* @__PURE__ */ new Map();
        let current = node;
        while(current){
            if (isFunctionLike(current)) break;
            if (isLabeledStatement(current)) {
                const name = current.label.text;
                if (!uniques.has(name)) {
                    uniques.set(name, true);
                    entries.push({
                        name: name,
                        kindModifiers: "" /* none */ ,
                        kind: "label" /* label */ ,
                        sortText: SortText.LocationPriority
                    });
                }
            }
            current = current.parent;
        }
        return entries;
    }
    function getSymbolCompletionFromEntryId(program, log, sourceFile, position, entryId, host, preferences) {
        if (entryId.source === "SwitchCases/" /* SwitchCases */ ) return {
            type: "cases"
        };
        if (entryId.data) {
            const autoImport = getAutoImportSymbolFromCompletionEntryData(entryId.name, entryId.data, program, host);
            if (autoImport) {
                const { contextToken: contextToken2 , previousToken: previousToken2  } = getRelevantTokens(position, sourceFile);
                return {
                    type: "symbol",
                    symbol: autoImport.symbol,
                    location: getTouchingPropertyName(sourceFile, position),
                    previousToken: previousToken2,
                    contextToken: contextToken2,
                    isJsxInitializer: false,
                    isTypeOnlyLocation: false,
                    origin: autoImport.origin
                };
            }
        }
        const compilerOptions = program.getCompilerOptions();
        const completionData = getCompletionData(program, log, sourceFile, compilerOptions, position, {
            includeCompletionsForModuleExports: true,
            includeCompletionsWithInsertText: true
        }, entryId, host, /*formatContext*/ void 0);
        if (!completionData) return {
            type: "none"
        };
        if (completionData.kind !== 0 /* Data */ ) return {
            type: "request",
            request: completionData
        };
        const { symbols: symbols , literals: literals , location: location , completionKind: completionKind , symbolToOriginInfoMap: symbolToOriginInfoMap , contextToken: contextToken , previousToken: previousToken , isJsxInitializer: isJsxInitializer , isTypeOnlyLocation: isTypeOnlyLocation  } = completionData;
        const literal = find(literals, (l)=>completionNameForLiteral(sourceFile, preferences, l) === entryId.name);
        if (literal !== void 0) return {
            type: "literal",
            literal: literal
        };
        return firstDefined(symbols, (symbol, index)=>{
            const origin = symbolToOriginInfoMap[index];
            const info = getCompletionEntryDisplayNameForSymbol(symbol, getEmitScriptTarget(compilerOptions), origin, completionKind, completionData.isJsxIdentifierExpected);
            return info && info.name === entryId.name && (entryId.source === "ClassMemberSnippet/" /* ClassMemberSnippet */  && symbol.flags & 106500 /* ClassMember */  || entryId.source === "ObjectLiteralMethodSnippet/" /* ObjectLiteralMethodSnippet */  && symbol.flags & 8196 /* Method */  || getSourceFromOrigin(origin) === entryId.source) ? {
                type: "symbol",
                symbol: symbol,
                location: location,
                origin: origin,
                contextToken: contextToken,
                previousToken: previousToken,
                isJsxInitializer: isJsxInitializer,
                isTypeOnlyLocation: isTypeOnlyLocation
            } : void 0;
        }) || {
            type: "none"
        };
    }
    function getCompletionEntryDetails(program, log, sourceFile, position, entryId, host, formatContext, preferences, cancellationToken) {
        const typeChecker = program.getTypeChecker();
        const compilerOptions = program.getCompilerOptions();
        const { name: name , source: source , data: data  } = entryId;
        const { previousToken: previousToken , contextToken: contextToken  } = getRelevantTokens(position, sourceFile);
        if (isInString(sourceFile, position, previousToken)) return ts_Completions_StringCompletions_exports.getStringLiteralCompletionDetails(name, sourceFile, position, previousToken, typeChecker, compilerOptions, host, cancellationToken, preferences);
        const symbolCompletion = getSymbolCompletionFromEntryId(program, log, sourceFile, position, entryId, host, preferences);
        switch(symbolCompletion.type){
            case "request":
                {
                    const { request: request  } = symbolCompletion;
                    switch(request.kind){
                        case 1 /* JsDocTagName */ :
                            return ts_JsDoc_exports.getJSDocTagNameCompletionDetails(name);
                        case 2 /* JsDocTag */ :
                            return ts_JsDoc_exports.getJSDocTagCompletionDetails(name);
                        case 3 /* JsDocParameterName */ :
                            return ts_JsDoc_exports.getJSDocParameterNameCompletionDetails(name);
                        case 4 /* Keywords */ :
                            return some(request.keywordCompletions, (c)=>c.name === name) ? createSimpleDetails(name, "keyword" /* keyword */ , 5 /* keyword */ ) : void 0;
                        default:
                            return Debug.assertNever(request);
                    }
                }
            case "symbol":
                {
                    const { symbol: symbol , location: location , contextToken: contextToken2 , origin: origin , previousToken: previousToken2  } = symbolCompletion;
                    const { codeActions: codeActions , sourceDisplay: sourceDisplay  } = getCompletionEntryCodeActionsAndSourceDisplay(name, location, contextToken2, origin, symbol, program, host, compilerOptions, sourceFile, position, previousToken2, formatContext, preferences, data, source, cancellationToken);
                    const symbolName2 = originIsComputedPropertyName(origin) ? origin.symbolName : symbol.name;
                    return createCompletionDetailsForSymbol(symbol, symbolName2, typeChecker, sourceFile, location, cancellationToken, codeActions, sourceDisplay);
                }
            case "literal":
                {
                    const { literal: literal  } = symbolCompletion;
                    return createSimpleDetails(completionNameForLiteral(sourceFile, preferences, literal), "string" /* string */ , typeof literal === "string" ? 8 /* stringLiteral */  : 7 /* numericLiteral */ );
                }
            case "cases":
                {
                    const { entry: entry , importAdder: importAdder  } = getExhaustiveCaseSnippets(contextToken.parent, sourceFile, preferences, program.getCompilerOptions(), host, program, /*formatContext*/ void 0);
                    if (importAdder.hasFixes()) {
                        const changes = ts_textChanges_exports.ChangeTracker.with({
                            host: host,
                            formatContext: formatContext,
                            preferences: preferences
                        }, importAdder.writeFixes);
                        return {
                            name: entry.name,
                            kind: "" /* unknown */ ,
                            kindModifiers: "",
                            displayParts: [],
                            sourceDisplay: void 0,
                            codeActions: [
                                {
                                    changes: changes,
                                    description: diagnosticToString([
                                        Diagnostics.Includes_imports_of_types_referenced_by_0,
                                        name
                                    ])
                                }
                            ]
                        };
                    }
                    return {
                        name: entry.name,
                        kind: "" /* unknown */ ,
                        kindModifiers: "",
                        displayParts: [],
                        sourceDisplay: void 0
                    };
                }
            case "none":
                return allKeywordsCompletions().some((c)=>c.name === name) ? createSimpleDetails(name, "keyword" /* keyword */ , 5 /* keyword */ ) : void 0;
            default:
                Debug.assertNever(symbolCompletion);
        }
    }
    function createSimpleDetails(name, kind, kind2) {
        return createCompletionDetails(name, "" /* none */ , kind, [
            displayPart(name, kind2)
        ]);
    }
    function createCompletionDetailsForSymbol(symbol, name, checker, sourceFile, location, cancellationToken, codeActions, sourceDisplay) {
        const { displayParts: displayParts , documentation: documentation , symbolKind: symbolKind , tags: tags  } = checker.runWithCancellationToken(cancellationToken, (checker2)=>ts_SymbolDisplay_exports.getSymbolDisplayPartsDocumentationAndSymbolKind(checker2, symbol, sourceFile, location, location, 7 /* All */ ));
        return createCompletionDetails(name, ts_SymbolDisplay_exports.getSymbolModifiers(checker, symbol), symbolKind, displayParts, documentation, tags, codeActions, sourceDisplay);
    }
    function createCompletionDetails(name, kindModifiers, kind, displayParts, documentation, tags, codeActions, source) {
        return {
            name: name,
            kindModifiers: kindModifiers,
            kind: kind,
            displayParts: displayParts,
            documentation: documentation,
            tags: tags,
            codeActions: codeActions,
            source: source,
            sourceDisplay: source
        };
    }
    function getCompletionEntryCodeActionsAndSourceDisplay(name, location, contextToken, origin, symbol, program, host, compilerOptions, sourceFile, position, previousToken, formatContext, preferences, data, source, cancellationToken) {
        if (data == null ? void 0 : data.moduleSpecifier) {
            if (previousToken && getImportStatementCompletionInfo(contextToken || previousToken).replacementSpan) return {
                codeActions: void 0,
                sourceDisplay: [
                    textPart(data.moduleSpecifier)
                ]
            };
        }
        if (source === "ClassMemberSnippet/" /* ClassMemberSnippet */ ) {
            const { importAdder: importAdder  } = getEntryForMemberCompletion(host, program, compilerOptions, preferences, name, symbol, location, position, contextToken, formatContext);
            if (importAdder) {
                const changes = ts_textChanges_exports.ChangeTracker.with({
                    host: host,
                    formatContext: formatContext,
                    preferences: preferences
                }, importAdder.writeFixes);
                return {
                    sourceDisplay: void 0,
                    codeActions: [
                        {
                            changes: changes,
                            description: diagnosticToString([
                                Diagnostics.Includes_imports_of_types_referenced_by_0,
                                name
                            ])
                        }
                    ]
                };
            }
        }
        if (originIsTypeOnlyAlias(origin)) {
            const codeAction2 = ts_codefix_exports.getPromoteTypeOnlyCompletionAction(sourceFile, origin.declaration.name, program, host, formatContext, preferences);
            Debug.assertIsDefined(codeAction2, "Expected to have a code action for promoting type-only alias");
            return {
                codeActions: [
                    codeAction2
                ],
                sourceDisplay: void 0
            };
        }
        if (!origin || !(originIsExport(origin) || originIsResolvedExport(origin))) return {
            codeActions: void 0,
            sourceDisplay: void 0
        };
        const checker = origin.isFromPackageJson ? host.getPackageJsonAutoImportProvider().getTypeChecker() : program.getTypeChecker();
        const { moduleSymbol: moduleSymbol  } = origin;
        const targetSymbol = checker.getMergedSymbol(skipAlias(symbol.exportSymbol || symbol, checker));
        const isJsxOpeningTagName = (contextToken == null ? void 0 : contextToken.kind) === 30 /* LessThanToken */  && isJsxOpeningLikeElement(contextToken.parent);
        const { moduleSpecifier: moduleSpecifier , codeAction: codeAction  } = ts_codefix_exports.getImportCompletionAction(targetSymbol, moduleSymbol, data == null ? void 0 : data.exportMapKey, sourceFile, name, isJsxOpeningTagName, host, program, formatContext, previousToken && isIdentifier(previousToken) ? previousToken.getStart(sourceFile) : position, preferences, cancellationToken);
        Debug.assert(!(data == null ? void 0 : data.moduleSpecifier) || moduleSpecifier === data.moduleSpecifier);
        return {
            sourceDisplay: [
                textPart(moduleSpecifier)
            ],
            codeActions: [
                codeAction
            ]
        };
    }
    function getCompletionEntrySymbol(program, log, sourceFile, position, entryId, host, preferences) {
        const completion = getSymbolCompletionFromEntryId(program, log, sourceFile, position, entryId, host, preferences);
        return completion.type === "symbol" ? completion.symbol : void 0;
    }
    function getRecommendedCompletion(previousToken, contextualType, checker) {
        return firstDefined(contextualType && (contextualType.isUnion() ? contextualType.types : [
            contextualType
        ]), (type)=>{
            const symbol = type && type.symbol;
            return symbol && symbol.flags & 424 /* Class */  && !isAbstractConstructorSymbol(symbol) ? getFirstSymbolInChain(symbol, previousToken, checker) : void 0;
        });
    }
    function getContextualType(previousToken, position, sourceFile, checker) {
        const { parent: parent2  } = previousToken;
        switch(previousToken.kind){
            case 80 /* Identifier */ :
                return getContextualTypeFromParent(previousToken, checker);
            case 64 /* EqualsToken */ :
                switch(parent2.kind){
                    case 259 /* VariableDeclaration */ :
                        return checker.getContextualType(parent2.initializer);
                    case 225 /* BinaryExpression */ :
                        return checker.getTypeAtLocation(parent2.left);
                    case 290 /* JsxAttribute */ :
                        return checker.getContextualTypeForJsxAttribute(parent2);
                    default:
                        return void 0;
                }
            case 105 /* NewKeyword */ :
                return checker.getContextualType(parent2);
            case 84 /* CaseKeyword */ :
                const caseClause = tryCast(parent2, isCaseClause);
                return caseClause ? getSwitchedType(caseClause, checker) : void 0;
            case 19 /* OpenBraceToken */ :
                return isJsxExpression(parent2) && !isJsxElement(parent2.parent) && !isJsxFragment(parent2.parent) ? checker.getContextualTypeForJsxAttribute(parent2.parent) : void 0;
            default:
                const argInfo = ts_SignatureHelp_exports.getArgumentInfoForCompletions(previousToken, position, sourceFile);
                return argInfo ? // At `,`, treat this as the next argument after the comma.
                checker.getContextualTypeForArgumentAtIndex(argInfo.invocation, argInfo.argumentIndex + (previousToken.kind === 28 /* CommaToken */  ? 1 : 0)) : isEqualityOperatorKind(previousToken.kind) && isBinaryExpression(parent2) && isEqualityOperatorKind(parent2.operatorToken.kind) ? // completion at `x ===/**/` should be for the right side
                checker.getTypeAtLocation(parent2.left) : checker.getContextualType(previousToken, 4 /* Completions */ ) || checker.getContextualType(previousToken);
        }
    }
    function getFirstSymbolInChain(symbol, enclosingDeclaration, checker) {
        const chain = checker.getAccessibleSymbolChain(symbol, enclosingDeclaration, /*meaning*/ 67108863 /* All */ , /*useOnlyExternalAliasing*/ false);
        if (chain) return first(chain);
        return symbol.parent && (isModuleSymbol(symbol.parent) ? symbol : getFirstSymbolInChain(symbol.parent, enclosingDeclaration, checker));
    }
    function isModuleSymbol(symbol) {
        var _a;
        return !!((_a = symbol.declarations) == null ? void 0 : _a.some((d)=>d.kind === 311 /* SourceFile */ ));
    }
    function getCompletionData(program, log, sourceFile, compilerOptions, position, preferences, detailsEntryId, host, formatContext, cancellationToken) {
        const typeChecker = program.getTypeChecker();
        const inCheckedFile = isCheckedFile(sourceFile, compilerOptions);
        let start = timestamp();
        let currentToken = getTokenAtPosition(sourceFile, position);
        log("getCompletionData: Get current token: " + (timestamp() - start));
        start = timestamp();
        const insideComment = isInComment(sourceFile, position, currentToken);
        log("getCompletionData: Is inside comment: " + (timestamp() - start));
        let insideJsDocTagTypeExpression = false;
        let isInSnippetScope = false;
        if (insideComment) {
            if (hasDocComment(sourceFile, position)) {
                if (sourceFile.text.charCodeAt(position - 1) === 64 /* at */ ) return {
                    kind: 1 /* JsDocTagName */ 
                };
                else {
                    const lineStart = getLineStartPositionForPosition(position, sourceFile);
                    if (!/[^\*|\s(/)]/.test(sourceFile.text.substring(lineStart, position))) return {
                        kind: 2 /* JsDocTag */ 
                    };
                }
            }
            const tag = getJsDocTagAtPosition(currentToken, position);
            if (tag) {
                if (tag.tagName.pos <= position && position <= tag.tagName.end) return {
                    kind: 1 /* JsDocTagName */ 
                };
                const typeExpression = tryGetTypeExpressionFromTag(tag);
                if (typeExpression) {
                    currentToken = getTokenAtPosition(sourceFile, position);
                    if (!currentToken || !isDeclarationName(currentToken) && (currentToken.parent.kind !== 354 /* JSDocPropertyTag */  || currentToken.parent.name !== currentToken)) insideJsDocTagTypeExpression = isCurrentlyEditingNode(typeExpression);
                }
                if (!insideJsDocTagTypeExpression && isJSDocParameterTag(tag) && (nodeIsMissing(tag.name) || tag.name.pos <= position && position <= tag.name.end)) return {
                    kind: 3 /* JsDocParameterName */ ,
                    tag: tag
                };
            }
            if (!insideJsDocTagTypeExpression) {
                log("Returning an empty list because completion was inside a regular comment or plain text part of a JsDoc comment.");
                return void 0;
            }
        }
        start = timestamp();
        const isJsOnlyLocation = !insideJsDocTagTypeExpression && isSourceFileJS(sourceFile);
        const tokens = getRelevantTokens(position, sourceFile);
        const previousToken = tokens.previousToken;
        let contextToken = tokens.contextToken;
        log("getCompletionData: Get previous token: " + (timestamp() - start));
        let node = currentToken;
        let propertyAccessToConvert;
        let isRightOfDot = false;
        let isRightOfQuestionDot = false;
        let isRightOfOpenTag = false;
        let isStartingCloseTag = false;
        let isJsxInitializer = false;
        let isJsxIdentifierExpected = false;
        let importStatementCompletion;
        let location = getTouchingPropertyName(sourceFile, position);
        let keywordFilters = 0 /* None */ ;
        let isNewIdentifierLocation = false;
        let flags = 0 /* None */ ;
        if (contextToken) {
            const importStatementCompletionInfo = getImportStatementCompletionInfo(contextToken);
            if (importStatementCompletionInfo.keywordCompletion) {
                if (importStatementCompletionInfo.isKeywordOnlyCompletion) return {
                    kind: 4 /* Keywords */ ,
                    keywordCompletions: [
                        keywordToCompletionEntry(importStatementCompletionInfo.keywordCompletion)
                    ],
                    isNewIdentifierLocation: importStatementCompletionInfo.isNewIdentifierLocation
                };
                keywordFilters = keywordFiltersFromSyntaxKind(importStatementCompletionInfo.keywordCompletion);
            }
            if (importStatementCompletionInfo.replacementSpan && preferences.includeCompletionsForImportStatements && preferences.includeCompletionsWithInsertText) {
                flags |= 2 /* IsImportStatementCompletion */ ;
                importStatementCompletion = importStatementCompletionInfo;
                isNewIdentifierLocation = importStatementCompletionInfo.isNewIdentifierLocation;
            }
            if (!importStatementCompletionInfo.replacementSpan && isCompletionListBlocker(contextToken)) {
                log("Returning an empty list because completion was requested in an invalid position.");
                return keywordFilters ? keywordCompletionData(keywordFilters, isJsOnlyLocation, isNewIdentifierDefinitionLocation()) : void 0;
            }
            let parent2 = contextToken.parent;
            if (contextToken.kind === 25 /* DotToken */  || contextToken.kind === 29 /* QuestionDotToken */ ) {
                isRightOfDot = contextToken.kind === 25 /* DotToken */ ;
                isRightOfQuestionDot = contextToken.kind === 29 /* QuestionDotToken */ ;
                switch(parent2.kind){
                    case 210 /* PropertyAccessExpression */ :
                        propertyAccessToConvert = parent2;
                        node = propertyAccessToConvert.expression;
                        const leftmostAccessExpression = getLeftmostAccessExpression(propertyAccessToConvert);
                        if (nodeIsMissing(leftmostAccessExpression) || (isCallExpression(node) || isFunctionLike(node)) && node.end === contextToken.pos && node.getChildCount(sourceFile) && last(node.getChildren(sourceFile)).kind !== 22 /* CloseParenToken */ ) return void 0;
                        break;
                    case 165 /* QualifiedName */ :
                        node = parent2.left;
                        break;
                    case 266 /* ModuleDeclaration */ :
                        node = parent2.name;
                        break;
                    case 204 /* ImportType */ :
                        node = parent2;
                        break;
                    case 235 /* MetaProperty */ :
                        node = parent2.getFirstToken(sourceFile);
                        Debug.assert(node.kind === 102 /* ImportKeyword */  || node.kind === 105 /* NewKeyword */ );
                        break;
                    default:
                        return void 0;
                }
            } else if (!importStatementCompletion) {
                if (parent2 && parent2.kind === 210 /* PropertyAccessExpression */ ) {
                    contextToken = parent2;
                    parent2 = parent2.parent;
                }
                if (currentToken.parent === location) switch(currentToken.kind){
                    case 32 /* GreaterThanToken */ :
                        if (currentToken.parent.kind === 283 /* JsxElement */  || currentToken.parent.kind === 285 /* JsxOpeningElement */ ) location = currentToken;
                        break;
                    case 44 /* SlashToken */ :
                        if (currentToken.parent.kind === 284 /* JsxSelfClosingElement */ ) location = currentToken;
                        break;
                }
                switch(parent2.kind){
                    case 286 /* JsxClosingElement */ :
                        if (contextToken.kind === 44 /* SlashToken */ ) {
                            isStartingCloseTag = true;
                            location = contextToken;
                        }
                        break;
                    case 225 /* BinaryExpression */ :
                        if (!binaryExpressionMayBeOpenTag(parent2)) break;
                    case 284 /* JsxSelfClosingElement */ :
                    case 283 /* JsxElement */ :
                    case 285 /* JsxOpeningElement */ :
                        isJsxIdentifierExpected = true;
                        if (contextToken.kind === 30 /* LessThanToken */ ) {
                            isRightOfOpenTag = true;
                            location = contextToken;
                        }
                        break;
                    case 293 /* JsxExpression */ :
                    case 292 /* JsxSpreadAttribute */ :
                        if (previousToken.kind === 20 /* CloseBraceToken */  || previousToken.kind === 80 /* Identifier */  && previousToken.parent.kind === 290 /* JsxAttribute */ ) isJsxIdentifierExpected = true;
                        break;
                    case 290 /* JsxAttribute */ :
                        if (parent2.initializer === previousToken && previousToken.end < position) {
                            isJsxIdentifierExpected = true;
                            break;
                        }
                        switch(previousToken.kind){
                            case 64 /* EqualsToken */ :
                                isJsxInitializer = true;
                                break;
                            case 80 /* Identifier */ :
                                isJsxIdentifierExpected = true;
                                if (parent2 !== previousToken.parent && !parent2.initializer && findChildOfKind(parent2, 64 /* EqualsToken */ , sourceFile)) isJsxInitializer = previousToken;
                        }
                        break;
                }
            }
        }
        const semanticStart = timestamp();
        let completionKind = 5 /* None */ ;
        let isNonContextualObjectLiteral = false;
        let hasUnresolvedAutoImports = false;
        let symbols = [];
        let importSpecifierResolver;
        const symbolToOriginInfoMap = [];
        const symbolToSortTextMap = [];
        const seenPropertySymbols = /* @__PURE__ */ new Map();
        const isTypeOnlyLocation = isTypeOnlyCompletion();
        const getModuleSpecifierResolutionHost = memoizeOne((isFromPackageJson)=>{
            return createModuleSpecifierResolutionHost(isFromPackageJson ? host.getPackageJsonAutoImportProvider() : program, host);
        });
        if (isRightOfDot || isRightOfQuestionDot) getTypeScriptMemberSymbols();
        else if (isRightOfOpenTag) {
            symbols = typeChecker.getJsxIntrinsicTagNamesAt(location);
            Debug.assertEachIsDefined(symbols, "getJsxIntrinsicTagNames() should all be defined");
            tryGetGlobalSymbols();
            completionKind = 1 /* Global */ ;
            keywordFilters = 0 /* None */ ;
        } else if (isStartingCloseTag) {
            const tagName = contextToken.parent.parent.openingElement.tagName;
            const tagSymbol = typeChecker.getSymbolAtLocation(tagName);
            if (tagSymbol) symbols = [
                tagSymbol
            ];
            completionKind = 1 /* Global */ ;
            keywordFilters = 0 /* None */ ;
        } else {
            if (!tryGetGlobalSymbols()) return keywordFilters ? keywordCompletionData(keywordFilters, isJsOnlyLocation, isNewIdentifierLocation) : void 0;
        }
        log("getCompletionData: Semantic work: " + (timestamp() - semanticStart));
        const contextualType = previousToken && getContextualType(previousToken, position, sourceFile, typeChecker);
        const isLiteralExpected = !tryCast(previousToken, isStringLiteralLike) && !isJsxIdentifierExpected;
        const literals = !isLiteralExpected ? [] : mapDefined(contextualType && (contextualType.isUnion() ? contextualType.types : [
            contextualType
        ]), (t)=>t.isLiteral() && !(t.flags & 1024 /* EnumLiteral */ ) ? t.value : void 0);
        const recommendedCompletion = previousToken && contextualType && getRecommendedCompletion(previousToken, contextualType, typeChecker);
        return {
            kind: 0 /* Data */ ,
            symbols: symbols,
            completionKind: completionKind,
            isInSnippetScope: isInSnippetScope,
            propertyAccessToConvert: propertyAccessToConvert,
            isNewIdentifierLocation: isNewIdentifierLocation,
            location: location,
            keywordFilters: keywordFilters,
            literals: literals,
            symbolToOriginInfoMap: symbolToOriginInfoMap,
            recommendedCompletion: recommendedCompletion,
            previousToken: previousToken,
            contextToken: contextToken,
            isJsxInitializer: isJsxInitializer,
            insideJsDocTagTypeExpression: insideJsDocTagTypeExpression,
            symbolToSortTextMap: symbolToSortTextMap,
            isTypeOnlyLocation: isTypeOnlyLocation,
            isJsxIdentifierExpected: isJsxIdentifierExpected,
            isRightOfOpenTag: isRightOfOpenTag,
            isRightOfDotOrQuestionDot: isRightOfDot || isRightOfQuestionDot,
            importStatementCompletion: importStatementCompletion,
            hasUnresolvedAutoImports: hasUnresolvedAutoImports,
            flags: flags
        };
        function isTagWithTypeExpression(tag) {
            switch(tag.kind){
                case 347 /* JSDocParameterTag */ :
                case 354 /* JSDocPropertyTag */ :
                case 348 /* JSDocReturnTag */ :
                case 350 /* JSDocTypeTag */ :
                case 352 /* JSDocTypedefTag */ :
                case 355 /* JSDocThrowsTag */ :
                case 356 /* JSDocSatisfiesTag */ :
                    return true;
                case 351 /* JSDocTemplateTag */ :
                    return !!tag.constraint;
                default:
                    return false;
            }
        }
        function tryGetTypeExpressionFromTag(tag) {
            if (isTagWithTypeExpression(tag)) {
                const typeExpression = isJSDocTemplateTag(tag) ? tag.constraint : tag.typeExpression;
                return typeExpression && typeExpression.kind === 315 /* JSDocTypeExpression */  ? typeExpression : void 0;
            }
            if (isJSDocAugmentsTag(tag) || isJSDocImplementsTag(tag)) return tag.class;
            return void 0;
        }
        function getTypeScriptMemberSymbols() {
            completionKind = 2 /* PropertyAccess */ ;
            const isImportType = isLiteralImportTypeNode(node);
            const isTypeLocation = isImportType && !node.isTypeOf || isPartOfTypeNode(node.parent) || isPossiblyTypeArgumentPosition(contextToken, sourceFile, typeChecker);
            const isRhsOfImportDeclaration = isInRightSideOfInternalImportEqualsDeclaration(node);
            if (isEntityName(node) || isImportType || isPropertyAccessExpression(node)) {
                const isNamespaceName = isModuleDeclaration(node.parent);
                if (isNamespaceName) isNewIdentifierLocation = true;
                let symbol = typeChecker.getSymbolAtLocation(node);
                if (symbol) {
                    symbol = skipAlias(symbol, typeChecker);
                    if (symbol.flags & 1920 /* Enum */ ) {
                        const exportedSymbols = typeChecker.getExportsOfModule(symbol);
                        Debug.assertEachIsDefined(exportedSymbols, "getExportsOfModule() should all be defined");
                        const isValidValueAccess = (symbol2)=>typeChecker.isValidPropertyAccess(isImportType ? node : node.parent, symbol2.name);
                        const isValidTypeAccess = (symbol2)=>symbolCanBeReferencedAtTypeLocation(symbol2, typeChecker);
                        const isValidAccess = isNamespaceName ? (symbol2)=>{
                            var _a;
                            return !!(symbol2.flags & 1920 /* Namespace */ ) && !((_a = symbol2.declarations) == null ? void 0 : _a.every((d)=>d.parent === node.parent));
                        } : isRhsOfImportDeclaration ? // Any kind is allowed when dotting off namespace in internal import equals declaration
                        (symbol2)=>isValidTypeAccess(symbol2) || isValidValueAccess(symbol2) : isTypeLocation || insideJsDocTagTypeExpression ? isValidTypeAccess : isValidValueAccess;
                        for (const exportedSymbol of exportedSymbols)if (isValidAccess(exportedSymbol)) symbols.push(exportedSymbol);
                        if (!isTypeLocation && !insideJsDocTagTypeExpression && symbol.declarations && symbol.declarations.some((d)=>d.kind !== 311 /* SourceFile */  && d.kind !== 266 /* ModuleDeclaration */  && d.kind !== 265 /* EnumDeclaration */ )) {
                            let type = typeChecker.getTypeOfSymbolAtLocation(symbol, node).getNonOptionalType();
                            let insertQuestionDot = false;
                            if (type.isNullableType()) {
                                const canCorrectToQuestionDot = isRightOfDot && !isRightOfQuestionDot && preferences.includeAutomaticOptionalChainCompletions !== false;
                                if (canCorrectToQuestionDot || isRightOfQuestionDot) {
                                    type = type.getNonNullableType();
                                    if (canCorrectToQuestionDot) insertQuestionDot = true;
                                }
                            }
                            addTypeProperties(type, !!(node.flags & 32768 /* AwaitContext */ ), insertQuestionDot);
                        }
                        return;
                    }
                }
            }
            if (!isTypeLocation) {
                typeChecker.tryGetThisTypeAt(node, /*includeGlobalThis*/ false);
                let type = typeChecker.getTypeAtLocation(node).getNonOptionalType();
                let insertQuestionDot = false;
                if (type.isNullableType()) {
                    const canCorrectToQuestionDot = isRightOfDot && !isRightOfQuestionDot && preferences.includeAutomaticOptionalChainCompletions !== false;
                    if (canCorrectToQuestionDot || isRightOfQuestionDot) {
                        type = type.getNonNullableType();
                        if (canCorrectToQuestionDot) insertQuestionDot = true;
                    }
                }
                addTypeProperties(type, !!(node.flags & 32768 /* AwaitContext */ ), insertQuestionDot);
            }
        }
        function addTypeProperties(type, insertAwait, insertQuestionDot) {
            isNewIdentifierLocation = !!type.getStringIndexType();
            if (isRightOfQuestionDot && some(type.getCallSignatures())) isNewIdentifierLocation = true;
            const propertyAccess = node.kind === 204 /* ImportType */  ? node : node.parent;
            if (inCheckedFile) {
                for (const symbol of type.getApparentProperties())if (typeChecker.isValidPropertyAccessForCompletions(propertyAccess, type, symbol)) addPropertySymbol(symbol, /*insertAwait*/ false, insertQuestionDot);
            } else symbols.push(...filter(getPropertiesForCompletion(type, typeChecker), (s)=>typeChecker.isValidPropertyAccessForCompletions(propertyAccess, type, s)));
            if (insertAwait && preferences.includeCompletionsWithInsertText) {
                const promiseType = typeChecker.getPromisedTypeOfPromise(type);
                if (promiseType) {
                    for (const symbol of promiseType.getApparentProperties())if (typeChecker.isValidPropertyAccessForCompletions(propertyAccess, promiseType, symbol)) addPropertySymbol(symbol, /*insertAwait*/ true, insertQuestionDot);
                }
            }
        }
        function addPropertySymbol(symbol, insertAwait, insertQuestionDot) {
            var _a;
            const computedPropertyName = firstDefined(symbol.declarations, (decl)=>tryCast(getNameOfDeclaration(decl), isComputedPropertyName));
            if (computedPropertyName) {
                const leftMostName = getLeftMostName(computedPropertyName.expression);
                const nameSymbol = leftMostName && typeChecker.getSymbolAtLocation(leftMostName);
                const firstAccessibleSymbol = nameSymbol && getFirstSymbolInChain(nameSymbol, contextToken, typeChecker);
                if (firstAccessibleSymbol && addToSeen(seenPropertySymbols, getSymbolId(firstAccessibleSymbol))) {
                    const index = symbols.length;
                    symbols.push(firstAccessibleSymbol);
                    const moduleSymbol = firstAccessibleSymbol.parent;
                    if (!moduleSymbol || !isExternalModuleSymbol(moduleSymbol) || typeChecker.tryGetMemberInModuleExportsAndProperties(firstAccessibleSymbol.name, moduleSymbol) !== firstAccessibleSymbol) symbolToOriginInfoMap[index] = {
                        kind: getNullableSymbolOriginInfoKind(2 /* SymbolMemberNoExport */ )
                    };
                    else {
                        const fileName = isExternalModuleNameRelative(stripQuotes(moduleSymbol.name)) ? (_a = getSourceFileOfModule(moduleSymbol)) == null ? void 0 : _a.fileName : void 0;
                        const { moduleSpecifier: moduleSpecifier  } = (importSpecifierResolver || (importSpecifierResolver = ts_codefix_exports.createImportSpecifierResolver(sourceFile, program, host, preferences))).getModuleSpecifierForBestExportInfo([
                            {
                                exportKind: 0 /* Named */ ,
                                moduleFileName: fileName,
                                isFromPackageJson: false,
                                moduleSymbol: moduleSymbol,
                                symbol: firstAccessibleSymbol,
                                targetFlags: skipAlias(firstAccessibleSymbol, typeChecker).flags
                            }
                        ], position, isValidTypeOnlyAliasUseSite(location)) || {};
                        if (moduleSpecifier) {
                            const origin = {
                                kind: getNullableSymbolOriginInfoKind(6 /* SymbolMemberExport */ ),
                                moduleSymbol: moduleSymbol,
                                isDefaultExport: false,
                                symbolName: firstAccessibleSymbol.name,
                                exportName: firstAccessibleSymbol.name,
                                fileName: fileName,
                                moduleSpecifier: moduleSpecifier
                            };
                            symbolToOriginInfoMap[index] = origin;
                        }
                    }
                } else if (preferences.includeCompletionsWithInsertText) {
                    addSymbolOriginInfo(symbol);
                    addSymbolSortInfo(symbol);
                    symbols.push(symbol);
                }
            } else {
                addSymbolOriginInfo(symbol);
                addSymbolSortInfo(symbol);
                symbols.push(symbol);
            }
            function addSymbolSortInfo(symbol2) {
                if (isStaticProperty(symbol2)) symbolToSortTextMap[getSymbolId(symbol2)] = SortText.LocalDeclarationPriority;
            }
            function addSymbolOriginInfo(symbol2) {
                if (preferences.includeCompletionsWithInsertText) {
                    if (insertAwait && addToSeen(seenPropertySymbols, getSymbolId(symbol2))) symbolToOriginInfoMap[symbols.length] = {
                        kind: getNullableSymbolOriginInfoKind(8 /* Promise */ )
                    };
                    else if (insertQuestionDot) symbolToOriginInfoMap[symbols.length] = {
                        kind: 16 /* Nullable */ 
                    };
                }
            }
            function getNullableSymbolOriginInfoKind(kind) {
                return insertQuestionDot ? kind | 16 /* Nullable */  : kind;
            }
        }
        function getLeftMostName(e) {
            return isIdentifier(e) ? e : isPropertyAccessExpression(e) ? getLeftMostName(e.expression) : void 0;
        }
        function tryGetGlobalSymbols() {
            const result = tryGetObjectTypeLiteralInTypeArgumentCompletionSymbols() || tryGetObjectLikeCompletionSymbols() || tryGetImportCompletionSymbols() || tryGetImportOrExportClauseCompletionSymbols() || tryGetLocalNamedExportCompletionSymbols() || tryGetConstructorCompletion() || tryGetClassLikeCompletionSymbols() || tryGetJsxCompletionSymbols() || (getGlobalCompletions(), 1 /* Success */ );
            return result === 1 /* Success */ ;
        }
        function tryGetConstructorCompletion() {
            if (!tryGetConstructorLikeCompletionContainer(contextToken)) return 0 /* Continue */ ;
            completionKind = 5 /* None */ ;
            isNewIdentifierLocation = true;
            keywordFilters = 4 /* ConstructorParameterKeywords */ ;
            return 1 /* Success */ ;
        }
        function tryGetJsxCompletionSymbols() {
            const jsxContainer = tryGetContainingJsxElement(contextToken);
            const attrsType = jsxContainer && typeChecker.getContextualType(jsxContainer.attributes);
            if (!attrsType) return 0 /* Continue */ ;
            const completionsType = jsxContainer && typeChecker.getContextualType(jsxContainer.attributes, 4 /* Completions */ );
            symbols = concatenate(symbols, filterJsxAttributes(getPropertiesForObjectExpression(attrsType, completionsType, jsxContainer.attributes, typeChecker), jsxContainer.attributes.properties));
            setSortTextToOptionalMember();
            completionKind = 3 /* MemberLike */ ;
            isNewIdentifierLocation = false;
            return 1 /* Success */ ;
        }
        function tryGetImportCompletionSymbols() {
            if (!importStatementCompletion) return 0 /* Continue */ ;
            isNewIdentifierLocation = true;
            collectAutoImports();
            return 1 /* Success */ ;
        }
        function getGlobalCompletions() {
            keywordFilters = tryGetFunctionLikeBodyCompletionContainer(contextToken) ? 5 /* FunctionLikeBodyKeywords */  : 1 /* All */ ;
            completionKind = 1 /* Global */ ;
            isNewIdentifierLocation = isNewIdentifierDefinitionLocation();
            if (previousToken !== contextToken) Debug.assert(!!previousToken, "Expected 'contextToken' to be defined when different from 'previousToken'.");
            const adjustedPosition = previousToken !== contextToken ? previousToken.getStart() : position;
            const scopeNode = getScopeNode(contextToken, adjustedPosition, sourceFile) || sourceFile;
            isInSnippetScope = isSnippetScope(scopeNode);
            const symbolMeanings = (isTypeOnlyLocation ? 0 /* None */  : 111551 /* Value */ ) | 2887656 /* Alias */ ;
            const typeOnlyAliasNeedsPromotion = previousToken && !isValidTypeOnlyAliasUseSite(previousToken);
            symbols = concatenate(symbols, typeChecker.getSymbolsInScope(scopeNode, symbolMeanings));
            Debug.assertEachIsDefined(symbols, "getSymbolsInScope() should all be defined");
            for(let i = 0; i < symbols.length; i++){
                const symbol = symbols[i];
                if (!typeChecker.isArgumentsSymbol(symbol) && !some(symbol.declarations, (d)=>d.getSourceFile() === sourceFile)) symbolToSortTextMap[getSymbolId(symbol)] = SortText.GlobalsOrKeywords;
                if (typeOnlyAliasNeedsPromotion && !(symbol.flags & 111551 /* Value */ )) {
                    const typeOnlyAliasDeclaration = symbol.declarations && find(symbol.declarations, isTypeOnlyImportDeclaration);
                    if (typeOnlyAliasDeclaration) {
                        const origin = {
                            kind: 64 /* TypeOnlyAlias */ ,
                            declaration: typeOnlyAliasDeclaration
                        };
                        symbolToOriginInfoMap[i] = origin;
                    }
                }
            }
            if (preferences.includeCompletionsWithInsertText && scopeNode.kind !== 311 /* SourceFile */ ) {
                const thisType = typeChecker.tryGetThisTypeAt(scopeNode, /*includeGlobalThis*/ false, isClassLike(scopeNode.parent) ? scopeNode : void 0);
                if (thisType && !isProbablyGlobalType(thisType, sourceFile, typeChecker)) for (const symbol of getPropertiesForCompletion(thisType, typeChecker)){
                    symbolToOriginInfoMap[symbols.length] = {
                        kind: 1 /* ThisType */ 
                    };
                    symbols.push(symbol);
                    symbolToSortTextMap[getSymbolId(symbol)] = SortText.SuggestedClassMembers;
                }
            }
            collectAutoImports();
            if (isTypeOnlyLocation) keywordFilters = contextToken && isAssertionExpression(contextToken.parent) ? 6 /* TypeAssertionKeywords */  : 7 /* TypeKeywords */ ;
        }
        function shouldOfferImportCompletions() {
            if (importStatementCompletion) return true;
            if (isNonContextualObjectLiteral) return false;
            if (!preferences.includeCompletionsForModuleExports) return false;
            if (sourceFile.externalModuleIndicator || sourceFile.commonJsModuleIndicator) return true;
            if (compilerOptionsIndicateEsModules(program.getCompilerOptions())) return true;
            return programContainsModules(program);
        }
        function isSnippetScope(scopeNode) {
            switch(scopeNode.kind){
                case 311 /* SourceFile */ :
                case 227 /* TemplateExpression */ :
                case 293 /* JsxExpression */ :
                case 240 /* Block */ :
                    return true;
                default:
                    return isStatement(scopeNode);
            }
        }
        function isTypeOnlyCompletion() {
            return insideJsDocTagTypeExpression || !!importStatementCompletion && isTypeOnlyImportOrExportDeclaration(location.parent) || !isContextTokenValueLocation(contextToken) && (isPossiblyTypeArgumentPosition(contextToken, sourceFile, typeChecker) || isPartOfTypeNode(location) || isContextTokenTypeLocation(contextToken));
        }
        function isContextTokenValueLocation(contextToken2) {
            return contextToken2 && (contextToken2.kind === 114 /* TypeOfKeyword */  && (contextToken2.parent.kind === 185 /* TypeQuery */  || isTypeOfExpression(contextToken2.parent)) || contextToken2.kind === 131 /* AssertsKeyword */  && contextToken2.parent.kind === 181 /* TypePredicate */ );
        }
        function isContextTokenTypeLocation(contextToken2) {
            if (contextToken2) {
                const parentKind = contextToken2.parent.kind;
                switch(contextToken2.kind){
                    case 59 /* ColonToken */ :
                        return parentKind === 171 /* PropertyDeclaration */  || parentKind === 170 /* PropertySignature */  || parentKind === 168 /* Parameter */  || parentKind === 259 /* VariableDeclaration */  || isFunctionLikeKind(parentKind);
                    case 64 /* EqualsToken */ :
                        return parentKind === 264 /* TypeAliasDeclaration */ ;
                    case 130 /* AsKeyword */ :
                        return parentKind === 233 /* AsExpression */ ;
                    case 30 /* LessThanToken */ :
                        return parentKind === 182 /* TypeReference */  || parentKind === 215 /* TypeAssertionExpression */ ;
                    case 96 /* ExtendsKeyword */ :
                        return parentKind === 167 /* TypeParameter */ ;
                    case 152 /* SatisfiesKeyword */ :
                        return parentKind === 237 /* SatisfiesExpression */ ;
                }
            }
            return false;
        }
        function collectAutoImports() {
            var _a, _b;
            if (!shouldOfferImportCompletions()) return;
            Debug.assert(!(detailsEntryId == null ? void 0 : detailsEntryId.data), "Should not run 'collectAutoImports' when faster path is available via `data`");
            if (detailsEntryId && !detailsEntryId.source) return;
            flags |= 1 /* MayIncludeAutoImports */ ;
            const isAfterTypeOnlyImportSpecifierModifier = previousToken === contextToken && importStatementCompletion;
            const lowerCaseTokenText = isAfterTypeOnlyImportSpecifierModifier ? "" : previousToken && isIdentifier(previousToken) ? previousToken.text.toLowerCase() : "";
            const moduleSpecifierCache = (_a = host.getModuleSpecifierCache) == null ? void 0 : _a.call(host);
            const exportInfo = getExportInfoMap(sourceFile, host, program, preferences, cancellationToken);
            const packageJsonAutoImportProvider = (_b = host.getPackageJsonAutoImportProvider) == null ? void 0 : _b.call(host);
            const packageJsonFilter = detailsEntryId ? void 0 : createPackageJsonImportFilter(sourceFile, preferences, host);
            resolvingModuleSpecifiers("collectAutoImports", host, importSpecifierResolver || (importSpecifierResolver = ts_codefix_exports.createImportSpecifierResolver(sourceFile, program, host, preferences)), program, position, preferences, !!importStatementCompletion, isValidTypeOnlyAliasUseSite(location), (context)=>{
                exportInfo.search(sourceFile.path, /*preferCapitalized*/ isRightOfOpenTag, (symbolName2, targetFlags)=>{
                    if (!isIdentifierText(symbolName2, getEmitScriptTarget(host.getCompilationSettings()))) return false;
                    if (!detailsEntryId && isStringANonContextualKeyword(symbolName2)) return false;
                    if (!isTypeOnlyLocation && !importStatementCompletion && !(targetFlags & 111551 /* Value */ )) return false;
                    if (isTypeOnlyLocation && !(targetFlags & 790504 /* Type */ )) return false;
                    const firstChar = symbolName2.charCodeAt(0);
                    if (isRightOfOpenTag && (firstChar < 65 /* A */  || firstChar > 90 /* Z */ )) return false;
                    if (detailsEntryId) return true;
                    return charactersFuzzyMatchInString(symbolName2, lowerCaseTokenText);
                }, (info, symbolName2, isFromAmbientModule, exportMapKey)=>{
                    if (detailsEntryId && !some(info, (i)=>detailsEntryId.source === stripQuotes(i.moduleSymbol.name))) return;
                    info = filter(info, isImportableExportInfo);
                    if (!info.length) return;
                    const result = context.tryResolve(info, isFromAmbientModule) || {};
                    if (result === "failed") return;
                    let exportInfo2 = info[0], moduleSpecifier;
                    if (result !== "skipped") ({ exportInfo: exportInfo2 = info[0] , moduleSpecifier: moduleSpecifier  } = result);
                    const isDefaultExport = exportInfo2.exportKind === 1 /* Default */ ;
                    const symbol = isDefaultExport && getLocalSymbolForExportDefault(exportInfo2.symbol) || exportInfo2.symbol;
                    pushAutoImportSymbol(symbol, {
                        kind: moduleSpecifier ? 32 /* ResolvedExport */  : 4 /* Export */ ,
                        moduleSpecifier: moduleSpecifier,
                        symbolName: symbolName2,
                        exportMapKey: exportMapKey,
                        exportName: exportInfo2.exportKind === 2 /* ExportEquals */  ? "export=" /* ExportEquals */  : exportInfo2.symbol.name,
                        fileName: exportInfo2.moduleFileName,
                        isDefaultExport: isDefaultExport,
                        moduleSymbol: exportInfo2.moduleSymbol,
                        isFromPackageJson: exportInfo2.isFromPackageJson
                    });
                });
                hasUnresolvedAutoImports = context.skippedAny();
                flags |= context.resolvedAny() ? 8 /* ResolvedModuleSpecifiers */  : 0;
                flags |= context.resolvedBeyondLimit() ? 16 /* ResolvedModuleSpecifiersBeyondLimit */  : 0;
            });
            function isImportableExportInfo(info) {
                const moduleFile = tryCast(info.moduleSymbol.valueDeclaration, isSourceFile);
                if (!moduleFile) {
                    const moduleName = stripQuotes(info.moduleSymbol.name);
                    if (ts_JsTyping_exports.nodeCoreModules.has(moduleName) && startsWith(moduleName, "node:") !== shouldUseUriStyleNodeCoreModules(sourceFile, program)) return false;
                    return packageJsonFilter ? packageJsonFilter.allowsImportingAmbientModule(info.moduleSymbol, getModuleSpecifierResolutionHost(info.isFromPackageJson)) : true;
                }
                return isImportableFile(info.isFromPackageJson ? packageJsonAutoImportProvider : program, sourceFile, moduleFile, preferences, packageJsonFilter, getModuleSpecifierResolutionHost(info.isFromPackageJson), moduleSpecifierCache);
            }
        }
        function pushAutoImportSymbol(symbol, origin) {
            const symbolId = getSymbolId(symbol);
            if (symbolToSortTextMap[symbolId] === SortText.GlobalsOrKeywords) return;
            symbolToOriginInfoMap[symbols.length] = origin;
            symbolToSortTextMap[symbolId] = importStatementCompletion ? SortText.LocationPriority : SortText.AutoImportSuggestions;
            symbols.push(symbol);
        }
        function collectObjectLiteralMethodSymbols(members, enclosingDeclaration) {
            if (isInJSFile(location)) return;
            members.forEach((member)=>{
                if (!isObjectLiteralMethodSymbol(member)) return;
                const displayName = getCompletionEntryDisplayNameForSymbol(member, getEmitScriptTarget(compilerOptions), /*origin*/ void 0, 0 /* ObjectPropertyDeclaration */ , /*jsxIdentifierExpected*/ false);
                if (!displayName) return;
                const { name: name  } = displayName;
                const entryProps = getEntryForObjectLiteralMethodCompletion(member, name, enclosingDeclaration, program, host, compilerOptions, preferences, formatContext);
                if (!entryProps) return;
                const origin = {
                    kind: 128 /* ObjectLiteralMethod */ ,
                    ...entryProps
                };
                flags |= 32 /* MayIncludeMethodSnippets */ ;
                symbolToOriginInfoMap[symbols.length] = origin;
                symbols.push(member);
            });
        }
        function isObjectLiteralMethodSymbol(symbol) {
            if (!(symbol.flags & 8196 /* Method */ )) return false;
            return true;
        }
        function getScopeNode(initialToken, position2, sourceFile2) {
            let scope = initialToken;
            while(scope && !positionBelongsToNode(scope, position2, sourceFile2))scope = scope.parent;
            return scope;
        }
        function isCompletionListBlocker(contextToken2) {
            const start2 = timestamp();
            const result = isInStringOrRegularExpressionOrTemplateLiteral(contextToken2) || isSolelyIdentifierDefinitionLocation(contextToken2) || isDotOfNumericLiteral(contextToken2) || isInJsxText(contextToken2) || isBigIntLiteral(contextToken2);
            log("getCompletionsAtPosition: isCompletionListBlocker: " + (timestamp() - start2));
            return result;
        }
        function isInJsxText(contextToken2) {
            if (contextToken2.kind === 12 /* JsxText */ ) return true;
            if (contextToken2.kind === 32 /* GreaterThanToken */  && contextToken2.parent) {
                if (location === contextToken2.parent && (location.kind === 285 /* JsxOpeningElement */  || location.kind === 284 /* JsxSelfClosingElement */ )) return false;
                if (contextToken2.parent.kind === 285 /* JsxOpeningElement */ ) return location.parent.kind !== 285 /* JsxOpeningElement */ ;
                if (contextToken2.parent.kind === 286 /* JsxClosingElement */  || contextToken2.parent.kind === 284 /* JsxSelfClosingElement */ ) return !!contextToken2.parent.parent && contextToken2.parent.parent.kind === 283 /* JsxElement */ ;
            }
            return false;
        }
        function isNewIdentifierDefinitionLocation() {
            if (contextToken) {
                const containingNodeKind = contextToken.parent.kind;
                const tokenKind = keywordForNode(contextToken);
                switch(tokenKind){
                    case 28 /* CommaToken */ :
                        return containingNodeKind === 212 /* CallExpression */  || containingNodeKind === 175 /* Constructor */  || containingNodeKind === 213 /* NewExpression */  || containingNodeKind === 208 /* ArrayLiteralExpression */  || containingNodeKind === 225 /* BinaryExpression */  || containingNodeKind === 183 /* FunctionType */  || containingNodeKind === 209 /* ObjectLiteralExpression */ ;
                    case 21 /* OpenParenToken */ :
                        return containingNodeKind === 212 /* CallExpression */  || containingNodeKind === 175 /* Constructor */  || containingNodeKind === 213 /* NewExpression */  || containingNodeKind === 216 /* ParenthesizedExpression */  || containingNodeKind === 195 /* ParenthesizedType */ ;
                    case 23 /* OpenBracketToken */ :
                        return containingNodeKind === 208 /* ArrayLiteralExpression */  || containingNodeKind === 180 /* IndexSignature */  || containingNodeKind === 166 /* ComputedPropertyName */ ;
                    case 144 /* ModuleKeyword */ :
                    case 145 /* NamespaceKeyword */ :
                    case 102 /* ImportKeyword */ :
                        return true;
                    case 25 /* DotToken */ :
                        return containingNodeKind === 266 /* ModuleDeclaration */ ;
                    case 19 /* OpenBraceToken */ :
                        return containingNodeKind === 262 /* ClassDeclaration */  || containingNodeKind === 209 /* ObjectLiteralExpression */ ;
                    case 64 /* EqualsToken */ :
                        return containingNodeKind === 259 /* VariableDeclaration */  || containingNodeKind === 225 /* BinaryExpression */ ;
                    case 16 /* TemplateHead */ :
                        return containingNodeKind === 227 /* TemplateExpression */ ;
                    case 17 /* TemplateMiddle */ :
                        return containingNodeKind === 238 /* TemplateSpan */ ;
                    case 134 /* AsyncKeyword */ :
                        return containingNodeKind === 173 /* MethodDeclaration */  || containingNodeKind === 303 /* ShorthandPropertyAssignment */ ;
                    case 42 /* AsteriskToken */ :
                        return containingNodeKind === 173 /* MethodDeclaration */ ;
                }
                if (isClassMemberCompletionKeyword(tokenKind)) return true;
            }
            return false;
        }
        function isInStringOrRegularExpressionOrTemplateLiteral(contextToken2) {
            return (isRegularExpressionLiteral(contextToken2) || isStringTextContainingNode(contextToken2)) && (rangeContainsPositionExclusive(contextToken2, position) || position === contextToken2.end && (!!contextToken2.isUnterminated || isRegularExpressionLiteral(contextToken2)));
        }
        function tryGetObjectTypeLiteralInTypeArgumentCompletionSymbols() {
            const typeLiteralNode = tryGetTypeLiteralNode(contextToken);
            if (!typeLiteralNode) return 0 /* Continue */ ;
            const intersectionTypeNode = isIntersectionTypeNode(typeLiteralNode.parent) ? typeLiteralNode.parent : void 0;
            const containerTypeNode = intersectionTypeNode || typeLiteralNode;
            const containerExpectedType = getConstraintOfTypeArgumentProperty(containerTypeNode, typeChecker);
            if (!containerExpectedType) return 0 /* Continue */ ;
            const containerActualType = typeChecker.getTypeFromTypeNode(containerTypeNode);
            const members = getPropertiesForCompletion(containerExpectedType, typeChecker);
            const existingMembers = getPropertiesForCompletion(containerActualType, typeChecker);
            const existingMemberEscapedNames = /* @__PURE__ */ new Set();
            existingMembers.forEach((s)=>existingMemberEscapedNames.add(s.escapedName));
            symbols = concatenate(symbols, filter(members, (s)=>!existingMemberEscapedNames.has(s.escapedName)));
            completionKind = 0 /* ObjectPropertyDeclaration */ ;
            isNewIdentifierLocation = true;
            return 1 /* Success */ ;
        }
        function tryGetObjectLikeCompletionSymbols() {
            const symbolsStartIndex = symbols.length;
            const objectLikeContainer = tryGetObjectLikeCompletionContainer(contextToken);
            if (!objectLikeContainer) return 0 /* Continue */ ;
            completionKind = 0 /* ObjectPropertyDeclaration */ ;
            let typeMembers;
            let existingMembers;
            if (objectLikeContainer.kind === 209 /* ObjectLiteralExpression */ ) {
                const instantiatedType = tryGetObjectLiteralContextualType(objectLikeContainer, typeChecker);
                if (instantiatedType === void 0) {
                    if (objectLikeContainer.flags & 33554432 /* InWithStatement */ ) return 2 /* Fail */ ;
                    isNonContextualObjectLiteral = true;
                    return 0 /* Continue */ ;
                }
                const completionsType = typeChecker.getContextualType(objectLikeContainer, 4 /* Completions */ );
                const hasStringIndexType = (completionsType || instantiatedType).getStringIndexType();
                const hasNumberIndextype = (completionsType || instantiatedType).getNumberIndexType();
                isNewIdentifierLocation = !!hasStringIndexType || !!hasNumberIndextype;
                typeMembers = getPropertiesForObjectExpression(instantiatedType, completionsType, objectLikeContainer, typeChecker);
                existingMembers = objectLikeContainer.properties;
                if (typeMembers.length === 0) {
                    if (!hasNumberIndextype) {
                        isNonContextualObjectLiteral = true;
                        return 0 /* Continue */ ;
                    }
                }
            } else {
                Debug.assert(objectLikeContainer.kind === 205 /* ObjectBindingPattern */ );
                isNewIdentifierLocation = false;
                const rootDeclaration = getRootDeclaration(objectLikeContainer.parent);
                if (!isVariableLike(rootDeclaration)) return Debug.fail("Root declaration is not variable-like.");
                let canGetType = hasInitializer(rootDeclaration) || !!getEffectiveTypeAnnotationNode(rootDeclaration) || rootDeclaration.parent.parent.kind === 249 /* ForOfStatement */ ;
                if (!canGetType && rootDeclaration.kind === 168 /* Parameter */ ) {
                    if (isExpression(rootDeclaration.parent)) canGetType = !!typeChecker.getContextualType(rootDeclaration.parent);
                    else if (rootDeclaration.parent.kind === 173 /* MethodDeclaration */  || rootDeclaration.parent.kind === 177 /* SetAccessor */ ) canGetType = isExpression(rootDeclaration.parent.parent) && !!typeChecker.getContextualType(rootDeclaration.parent.parent);
                }
                if (canGetType) {
                    const typeForObject = typeChecker.getTypeAtLocation(objectLikeContainer);
                    if (!typeForObject) return 2 /* Fail */ ;
                    typeMembers = typeChecker.getPropertiesOfType(typeForObject).filter((propertySymbol)=>{
                        return typeChecker.isPropertyAccessible(objectLikeContainer, /*isSuper*/ false, /*isWrite*/ false, typeForObject, propertySymbol);
                    });
                    existingMembers = objectLikeContainer.elements;
                }
            }
            if (typeMembers && typeMembers.length > 0) {
                const filteredMembers = filterObjectMembersList(typeMembers, Debug.checkDefined(existingMembers));
                symbols = concatenate(symbols, filteredMembers);
                setSortTextToOptionalMember();
                if (objectLikeContainer.kind === 209 /* ObjectLiteralExpression */  && preferences.includeCompletionsWithObjectLiteralMethodSnippets && preferences.includeCompletionsWithInsertText) {
                    transformObjectLiteralMembersSortText(symbolsStartIndex);
                    collectObjectLiteralMethodSymbols(filteredMembers, objectLikeContainer);
                }
            }
            return 1 /* Success */ ;
        }
        function tryGetImportOrExportClauseCompletionSymbols() {
            if (!contextToken) return 0 /* Continue */ ;
            const namedImportsOrExports = contextToken.kind === 19 /* OpenBraceToken */  || contextToken.kind === 28 /* CommaToken */  ? tryCast(contextToken.parent, isNamedImportsOrExports) : isTypeKeywordTokenOrIdentifier(contextToken) ? tryCast(contextToken.parent.parent, isNamedImportsOrExports) : void 0;
            if (!namedImportsOrExports) return 0 /* Continue */ ;
            if (!isTypeKeywordTokenOrIdentifier(contextToken)) keywordFilters = 8 /* TypeKeyword */ ;
            const { moduleSpecifier: moduleSpecifier  } = namedImportsOrExports.kind === 274 /* NamedImports */  ? namedImportsOrExports.parent.parent : namedImportsOrExports.parent;
            if (!moduleSpecifier) {
                isNewIdentifierLocation = true;
                return namedImportsOrExports.kind === 274 /* NamedImports */  ? 2 /* Fail */  : 0 /* Continue */ ;
            }
            const moduleSpecifierSymbol = typeChecker.getSymbolAtLocation(moduleSpecifier);
            if (!moduleSpecifierSymbol) {
                isNewIdentifierLocation = true;
                return 2 /* Fail */ ;
            }
            completionKind = 3 /* MemberLike */ ;
            isNewIdentifierLocation = false;
            const exports = typeChecker.getExportsAndPropertiesOfModule(moduleSpecifierSymbol);
            const existing = new Set(namedImportsOrExports.elements.filter((n)=>!isCurrentlyEditingNode(n)).map((n)=>(n.propertyName || n.name).escapedText));
            const uniques = exports.filter((e)=>e.escapedName !== "default" /* Default */  && !existing.has(e.escapedName));
            symbols = concatenate(symbols, uniques);
            if (!uniques.length) keywordFilters = 0 /* None */ ;
            return 1 /* Success */ ;
        }
        function tryGetLocalNamedExportCompletionSymbols() {
            var _a;
            const namedExports = contextToken && (contextToken.kind === 19 /* OpenBraceToken */  || contextToken.kind === 28 /* CommaToken */ ) ? tryCast(contextToken.parent, isNamedExports) : void 0;
            if (!namedExports) return 0 /* Continue */ ;
            const localsContainer = findAncestor(namedExports, or(isSourceFile, isModuleDeclaration));
            completionKind = 5 /* None */ ;
            isNewIdentifierLocation = false;
            (_a = localsContainer.locals) == null || _a.forEach((symbol, name)=>{
                var _a2, _b;
                symbols.push(symbol);
                if ((_b = (_a2 = localsContainer.symbol) == null ? void 0 : _a2.exports) == null ? void 0 : _b.has(name)) symbolToSortTextMap[getSymbolId(symbol)] = SortText.OptionalMember;
            });
            return 1 /* Success */ ;
        }
        function tryGetClassLikeCompletionSymbols() {
            const decl = tryGetObjectTypeDeclarationCompletionContainer(sourceFile, contextToken, location, position);
            if (!decl) return 0 /* Continue */ ;
            completionKind = 3 /* MemberLike */ ;
            isNewIdentifierLocation = true;
            keywordFilters = contextToken.kind === 42 /* AsteriskToken */  ? 0 /* None */  : isClassLike(decl) ? 2 /* ClassElementKeywords */  : 3 /* InterfaceElementKeywords */ ;
            if (!isClassLike(decl)) return 1 /* Success */ ;
            const classElement = contextToken.kind === 27 /* SemicolonToken */  ? contextToken.parent.parent : contextToken.parent;
            let classElementModifierFlags = isClassElement(classElement) ? getEffectiveModifierFlags(classElement) : 0 /* None */ ;
            if (contextToken.kind === 80 /* Identifier */  && !isCurrentlyEditingNode(contextToken)) switch(contextToken.getText()){
                case "private":
                    classElementModifierFlags = classElementModifierFlags | 8 /* Private */ ;
                    break;
                case "static":
                    classElementModifierFlags = classElementModifierFlags | 32 /* Static */ ;
                    break;
                case "override":
                    classElementModifierFlags = classElementModifierFlags | 16384 /* Override */ ;
                    break;
            }
            if (isClassStaticBlockDeclaration(classElement)) classElementModifierFlags |= 32 /* Static */ ;
            if (!(classElementModifierFlags & 8 /* Private */ )) {
                const baseTypeNodes = isClassLike(decl) && classElementModifierFlags & 16384 /* Override */  ? singleElementArray(getEffectiveBaseTypeNode(decl)) : getAllSuperTypeNodes(decl);
                const baseSymbols = flatMap(baseTypeNodes, (baseTypeNode)=>{
                    const type = typeChecker.getTypeAtLocation(baseTypeNode);
                    return classElementModifierFlags & 32 /* Static */  ? (type == null ? void 0 : type.symbol) && typeChecker.getPropertiesOfType(typeChecker.getTypeOfSymbolAtLocation(type.symbol, decl)) : type && typeChecker.getPropertiesOfType(type);
                });
                symbols = concatenate(symbols, filterClassMembersList(baseSymbols, decl.members, classElementModifierFlags));
                forEach(symbols, (symbol, index)=>{
                    const declaration = symbol == null ? void 0 : symbol.valueDeclaration;
                    if (declaration && isClassElement(declaration) && declaration.name && isComputedPropertyName(declaration.name)) {
                        const origin = {
                            kind: 512 /* ComputedPropertyName */ ,
                            symbolName: typeChecker.symbolToString(symbol)
                        };
                        symbolToOriginInfoMap[index] = origin;
                    }
                });
            }
            return 1 /* Success */ ;
        }
        function isConstructorParameterCompletion(node2) {
            return !!node2.parent && isParameter(node2.parent) && isConstructorDeclaration(node2.parent.parent) && (isParameterPropertyModifier(node2.kind) || isDeclarationName(node2));
        }
        function tryGetConstructorLikeCompletionContainer(contextToken2) {
            if (contextToken2) {
                const parent2 = contextToken2.parent;
                switch(contextToken2.kind){
                    case 21 /* OpenParenToken */ :
                    case 28 /* CommaToken */ :
                        return isConstructorDeclaration(contextToken2.parent) ? contextToken2.parent : void 0;
                    default:
                        if (isConstructorParameterCompletion(contextToken2)) return parent2.parent;
                }
            }
            return void 0;
        }
        function tryGetFunctionLikeBodyCompletionContainer(contextToken2) {
            if (contextToken2) {
                let prev;
                const container = findAncestor(contextToken2.parent, (node2)=>{
                    if (isClassLike(node2)) return "quit";
                    if (isFunctionLikeDeclaration(node2) && prev === node2.body) return true;
                    prev = node2;
                    return false;
                });
                return container && container;
            }
        }
        function tryGetContainingJsxElement(contextToken2) {
            if (contextToken2) {
                const parent2 = contextToken2.parent;
                switch(contextToken2.kind){
                    case 32 /* GreaterThanToken */ :
                    case 31 /* LessThanSlashToken */ :
                    case 44 /* SlashToken */ :
                    case 80 /* Identifier */ :
                    case 210 /* PropertyAccessExpression */ :
                    case 291 /* JsxAttributes */ :
                    case 290 /* JsxAttribute */ :
                    case 292 /* JsxSpreadAttribute */ :
                        if (parent2 && (parent2.kind === 284 /* JsxSelfClosingElement */  || parent2.kind === 285 /* JsxOpeningElement */ )) {
                            if (contextToken2.kind === 32 /* GreaterThanToken */ ) {
                                const precedingToken = findPrecedingToken(contextToken2.pos, sourceFile, /*startNode*/ void 0);
                                if (!parent2.typeArguments || precedingToken && precedingToken.kind === 44 /* SlashToken */ ) break;
                            }
                            return parent2;
                        } else if (parent2.kind === 290 /* JsxAttribute */ ) return parent2.parent.parent;
                        break;
                    case 11 /* StringLiteral */ :
                        if (parent2 && (parent2.kind === 290 /* JsxAttribute */  || parent2.kind === 292 /* JsxSpreadAttribute */ )) return parent2.parent.parent;
                        break;
                    case 20 /* CloseBraceToken */ :
                        if (parent2 && parent2.kind === 293 /* JsxExpression */  && parent2.parent && parent2.parent.kind === 290 /* JsxAttribute */ ) return parent2.parent.parent.parent;
                        if (parent2 && parent2.kind === 292 /* JsxSpreadAttribute */ ) return parent2.parent.parent;
                        break;
                }
            }
            return void 0;
        }
        function isSolelyIdentifierDefinitionLocation(contextToken2) {
            const parent2 = contextToken2.parent;
            const containingNodeKind = parent2.kind;
            switch(contextToken2.kind){
                case 28 /* CommaToken */ :
                    return containingNodeKind === 259 /* VariableDeclaration */  || isVariableDeclarationListButNotTypeArgument(contextToken2) || containingNodeKind === 242 /* VariableStatement */  || containingNodeKind === 265 /* EnumDeclaration */  || // enum a { foo, |
                    isFunctionLikeButNotConstructor(containingNodeKind) || containingNodeKind === 263 /* InterfaceDeclaration */  || // interface A<T, |
                    containingNodeKind === 206 /* ArrayBindingPattern */  || // var [x, y|
                    containingNodeKind === 264 /* TypeAliasDeclaration */  || // type Map, K, |
                    // class A<T, |
                    // var C = class D<T, |
                    isClassLike(parent2) && !!parent2.typeParameters && parent2.typeParameters.end >= contextToken2.pos;
                case 25 /* DotToken */ :
                    return containingNodeKind === 206 /* ArrayBindingPattern */ ;
                case 59 /* ColonToken */ :
                    return containingNodeKind === 207 /* BindingElement */ ;
                case 23 /* OpenBracketToken */ :
                    return containingNodeKind === 206 /* ArrayBindingPattern */ ;
                case 21 /* OpenParenToken */ :
                    return containingNodeKind === 298 /* CatchClause */  || isFunctionLikeButNotConstructor(containingNodeKind);
                case 19 /* OpenBraceToken */ :
                    return containingNodeKind === 265 /* EnumDeclaration */ ;
                case 30 /* LessThanToken */ :
                    return containingNodeKind === 262 /* ClassDeclaration */  || // class A< |
                    containingNodeKind === 230 /* ClassExpression */  || // var C = class D< |
                    containingNodeKind === 263 /* InterfaceDeclaration */  || // interface A< |
                    containingNodeKind === 264 /* TypeAliasDeclaration */  || // type List< |
                    isFunctionLikeKind(containingNodeKind);
                case 126 /* StaticKeyword */ :
                    return containingNodeKind === 171 /* PropertyDeclaration */  && !isClassLike(parent2.parent);
                case 26 /* DotDotDotToken */ :
                    return containingNodeKind === 168 /* Parameter */  || !!parent2.parent && parent2.parent.kind === 206 /* ArrayBindingPattern */ ;
                case 125 /* PublicKeyword */ :
                case 123 /* PrivateKeyword */ :
                case 124 /* ProtectedKeyword */ :
                    return containingNodeKind === 168 /* Parameter */  && !isConstructorDeclaration(parent2.parent);
                case 130 /* AsKeyword */ :
                    return containingNodeKind === 275 /* ImportSpecifier */  || containingNodeKind === 280 /* ExportSpecifier */  || containingNodeKind === 273 /* NamespaceImport */ ;
                case 139 /* GetKeyword */ :
                case 153 /* SetKeyword */ :
                    return !isFromObjectTypeDeclaration(contextToken2);
                case 80 /* Identifier */ :
                    if (containingNodeKind === 275 /* ImportSpecifier */  && contextToken2 === parent2.name && contextToken2.text === "type") return false;
                    break;
                case 86 /* ClassKeyword */ :
                case 94 /* EnumKeyword */ :
                case 120 /* InterfaceKeyword */ :
                case 100 /* FunctionKeyword */ :
                case 115 /* VarKeyword */ :
                case 102 /* ImportKeyword */ :
                case 121 /* LetKeyword */ :
                case 87 /* ConstKeyword */ :
                case 140 /* InferKeyword */ :
                    return true;
                case 156 /* TypeKeyword */ :
                    return containingNodeKind !== 275 /* ImportSpecifier */ ;
                case 42 /* AsteriskToken */ :
                    return isFunctionLike(contextToken2.parent) && !isMethodDeclaration(contextToken2.parent);
            }
            if (isClassMemberCompletionKeyword(keywordForNode(contextToken2)) && isFromObjectTypeDeclaration(contextToken2)) return false;
            if (isConstructorParameterCompletion(contextToken2)) {
                if (!isIdentifier(contextToken2) || isParameterPropertyModifier(keywordForNode(contextToken2)) || isCurrentlyEditingNode(contextToken2)) return false;
            }
            switch(keywordForNode(contextToken2)){
                case 128 /* AbstractKeyword */ :
                case 86 /* ClassKeyword */ :
                case 87 /* ConstKeyword */ :
                case 138 /* DeclareKeyword */ :
                case 94 /* EnumKeyword */ :
                case 100 /* FunctionKeyword */ :
                case 120 /* InterfaceKeyword */ :
                case 121 /* LetKeyword */ :
                case 123 /* PrivateKeyword */ :
                case 124 /* ProtectedKeyword */ :
                case 125 /* PublicKeyword */ :
                case 126 /* StaticKeyword */ :
                case 115 /* VarKeyword */ :
                    return true;
                case 134 /* AsyncKeyword */ :
                    return isPropertyDeclaration(contextToken2.parent);
            }
            const ancestorClassLike = findAncestor(contextToken2.parent, isClassLike);
            if (ancestorClassLike && contextToken2 === previousToken && isPreviousPropertyDeclarationTerminated(contextToken2, position)) return false;
            const ancestorPropertyDeclaraion = getAncestor(contextToken2.parent, 171 /* PropertyDeclaration */ );
            if (ancestorPropertyDeclaraion && contextToken2 !== previousToken && isClassLike(previousToken.parent.parent) && position <= previousToken.end) {
                if (isPreviousPropertyDeclarationTerminated(contextToken2, previousToken.end)) return false;
                else if (contextToken2.kind !== 64 /* EqualsToken */  && (isInitializedProperty(ancestorPropertyDeclaraion) || hasType(ancestorPropertyDeclaraion))) return true;
            }
            return isDeclarationName(contextToken2) && !isShorthandPropertyAssignment(contextToken2.parent) && !isJsxAttribute(contextToken2.parent) && !((isClassLike(contextToken2.parent) || isInterfaceDeclaration(contextToken2.parent) || isTypeParameterDeclaration(contextToken2.parent)) && (contextToken2 !== previousToken || position > previousToken.end));
        }
        function isPreviousPropertyDeclarationTerminated(contextToken2, position2) {
            return contextToken2.kind !== 64 /* EqualsToken */  && (contextToken2.kind === 27 /* SemicolonToken */  || !positionsAreOnSameLine(contextToken2.end, position2, sourceFile));
        }
        function isFunctionLikeButNotConstructor(kind) {
            return isFunctionLikeKind(kind) && kind !== 175 /* Constructor */ ;
        }
        function isDotOfNumericLiteral(contextToken2) {
            if (contextToken2.kind === 9 /* NumericLiteral */ ) {
                const text = contextToken2.getFullText();
                return text.charAt(text.length - 1) === ".";
            }
            return false;
        }
        function isVariableDeclarationListButNotTypeArgument(node2) {
            return node2.parent.kind === 260 /* VariableDeclarationList */  && !isPossiblyTypeArgumentPosition(node2, sourceFile, typeChecker);
        }
        function filterObjectMembersList(contextualMemberSymbols, existingMembers) {
            if (existingMembers.length === 0) return contextualMemberSymbols;
            const membersDeclaredBySpreadAssignment = /* @__PURE__ */ new Set();
            const existingMemberNames = /* @__PURE__ */ new Set();
            for (const m of existingMembers){
                if (m.kind !== 302 /* PropertyAssignment */  && m.kind !== 303 /* ShorthandPropertyAssignment */  && m.kind !== 207 /* BindingElement */  && m.kind !== 173 /* MethodDeclaration */  && m.kind !== 176 /* GetAccessor */  && m.kind !== 177 /* SetAccessor */  && m.kind !== 304 /* SpreadAssignment */ ) continue;
                if (isCurrentlyEditingNode(m)) continue;
                let existingName;
                if (isSpreadAssignment(m)) setMembersDeclaredBySpreadAssignment(m, membersDeclaredBySpreadAssignment);
                else if (isBindingElement(m) && m.propertyName) {
                    if (m.propertyName.kind === 80 /* Identifier */ ) existingName = m.propertyName.escapedText;
                } else {
                    const name = getNameOfDeclaration(m);
                    existingName = name && isPropertyNameLiteral(name) ? getEscapedTextOfIdentifierOrLiteral(name) : void 0;
                }
                if (existingName !== void 0) existingMemberNames.add(existingName);
            }
            const filteredSymbols = contextualMemberSymbols.filter((m)=>!existingMemberNames.has(m.escapedName));
            setSortTextToMemberDeclaredBySpreadAssignment(membersDeclaredBySpreadAssignment, filteredSymbols);
            return filteredSymbols;
        }
        function setMembersDeclaredBySpreadAssignment(declaration, membersDeclaredBySpreadAssignment) {
            const expression = declaration.expression;
            const symbol = typeChecker.getSymbolAtLocation(expression);
            const type = symbol && typeChecker.getTypeOfSymbolAtLocation(symbol, expression);
            const properties = type && type.properties;
            if (properties) properties.forEach((property)=>{
                membersDeclaredBySpreadAssignment.add(property.name);
            });
        }
        function setSortTextToOptionalMember() {
            symbols.forEach((m)=>{
                if (m.flags & 16777216 /* Optional */ ) {
                    const symbolId = getSymbolId(m);
                    symbolToSortTextMap[symbolId] = symbolToSortTextMap[symbolId] ?? SortText.OptionalMember;
                }
            });
        }
        function setSortTextToMemberDeclaredBySpreadAssignment(membersDeclaredBySpreadAssignment, contextualMemberSymbols) {
            if (membersDeclaredBySpreadAssignment.size === 0) return;
            for (const contextualMemberSymbol of contextualMemberSymbols)if (membersDeclaredBySpreadAssignment.has(contextualMemberSymbol.name)) symbolToSortTextMap[getSymbolId(contextualMemberSymbol)] = SortText.MemberDeclaredBySpreadAssignment;
        }
        function transformObjectLiteralMembersSortText(start2) {
            for(let i = start2; i < symbols.length; i++){
                const symbol = symbols[i];
                const symbolId = getSymbolId(symbol);
                const origin = symbolToOriginInfoMap == null ? void 0 : symbolToOriginInfoMap[i];
                const target = getEmitScriptTarget(compilerOptions);
                const displayName = getCompletionEntryDisplayNameForSymbol(symbol, target, origin, 0 /* ObjectPropertyDeclaration */ , /*jsxIdentifierExpected*/ false);
                if (displayName) {
                    const originalSortText = symbolToSortTextMap[symbolId] ?? SortText.LocationPriority;
                    const { name: name  } = displayName;
                    symbolToSortTextMap[symbolId] = SortText.ObjectLiteralProperty(originalSortText, name);
                }
            }
        }
        function filterClassMembersList(baseSymbols, existingMembers, currentClassElementModifierFlags) {
            const existingMemberNames = /* @__PURE__ */ new Set();
            for (const m of existingMembers){
                if (m.kind !== 171 /* PropertyDeclaration */  && m.kind !== 173 /* MethodDeclaration */  && m.kind !== 176 /* GetAccessor */  && m.kind !== 177 /* SetAccessor */ ) continue;
                if (isCurrentlyEditingNode(m)) continue;
                if (hasEffectiveModifier(m, 8 /* Private */ )) continue;
                if (isStatic(m) !== !!(currentClassElementModifierFlags & 32 /* Static */ )) continue;
                const existingName = getPropertyNameForPropertyNameNode(m.name);
                if (existingName) existingMemberNames.add(existingName);
            }
            return baseSymbols.filter((propertySymbol)=>!existingMemberNames.has(propertySymbol.escapedName) && !!propertySymbol.declarations && !(getDeclarationModifierFlagsFromSymbol(propertySymbol) & 8 /* Private */ ) && !(propertySymbol.valueDeclaration && isPrivateIdentifierClassElementDeclaration(propertySymbol.valueDeclaration)));
        }
        function filterJsxAttributes(symbols2, attributes) {
            const seenNames = /* @__PURE__ */ new Set();
            const membersDeclaredBySpreadAssignment = /* @__PURE__ */ new Set();
            for (const attr of attributes){
                if (isCurrentlyEditingNode(attr)) continue;
                if (attr.kind === 290 /* JsxAttribute */ ) seenNames.add(getEscapedTextOfJsxAttributeName(attr.name));
                else if (isJsxSpreadAttribute(attr)) setMembersDeclaredBySpreadAssignment(attr, membersDeclaredBySpreadAssignment);
            }
            const filteredSymbols = symbols2.filter((a)=>!seenNames.has(a.escapedName));
            setSortTextToMemberDeclaredBySpreadAssignment(membersDeclaredBySpreadAssignment, filteredSymbols);
            return filteredSymbols;
        }
        function isCurrentlyEditingNode(node2) {
            return node2.getStart(sourceFile) <= position && position <= node2.getEnd();
        }
    }
    function tryGetObjectLikeCompletionContainer(contextToken) {
        if (contextToken) {
            const { parent: parent2  } = contextToken;
            switch(contextToken.kind){
                case 19 /* OpenBraceToken */ :
                case 28 /* CommaToken */ :
                    if (isObjectLiteralExpression(parent2) || isObjectBindingPattern(parent2)) return parent2;
                    break;
                case 42 /* AsteriskToken */ :
                    return isMethodDeclaration(parent2) ? tryCast(parent2.parent, isObjectLiteralExpression) : void 0;
                case 134 /* AsyncKeyword */ :
                    return tryCast(parent2.parent, isObjectLiteralExpression);
                case 80 /* Identifier */ :
                    return contextToken.text === "async" && isShorthandPropertyAssignment(contextToken.parent) ? contextToken.parent.parent : void 0;
            }
        }
        return void 0;
    }
    function getRelevantTokens(position, sourceFile) {
        const previousToken = findPrecedingToken(position, sourceFile);
        if (previousToken && position <= previousToken.end && (isMemberName(previousToken) || isKeyword(previousToken.kind))) {
            const contextToken = findPrecedingToken(previousToken.getFullStart(), sourceFile, /*startNode*/ void 0);
            return {
                contextToken: contextToken,
                previousToken: previousToken
            };
        }
        return {
            contextToken: previousToken,
            previousToken: previousToken
        };
    }
    function getAutoImportSymbolFromCompletionEntryData(name, data, program, host) {
        const containingProgram = data.isPackageJsonImport ? host.getPackageJsonAutoImportProvider() : program;
        const checker = containingProgram.getTypeChecker();
        const moduleSymbol = data.ambientModuleName ? checker.tryFindAmbientModule(data.ambientModuleName) : data.fileName ? checker.getMergedSymbol(Debug.checkDefined(containingProgram.getSourceFile(data.fileName)).symbol) : void 0;
        if (!moduleSymbol) return void 0;
        let symbol = data.exportName === "export=" /* ExportEquals */  ? checker.resolveExternalModuleSymbol(moduleSymbol) : checker.tryGetMemberInModuleExportsAndProperties(data.exportName, moduleSymbol);
        if (!symbol) return void 0;
        const isDefaultExport = data.exportName === "default" /* Default */ ;
        symbol = isDefaultExport && getLocalSymbolForExportDefault(symbol) || symbol;
        return {
            symbol: symbol,
            origin: completionEntryDataToSymbolOriginInfo(data, name, moduleSymbol)
        };
    }
    function getCompletionEntryDisplayNameForSymbol(symbol, target, origin, kind, jsxIdentifierExpected) {
        if (originIsIgnore(origin)) return void 0;
        const name = originIncludesSymbolName(origin) ? origin.symbolName : symbol.name;
        if (name === void 0 || symbol.flags & 1536 /* Module */  && isSingleOrDoubleQuote(name.charCodeAt(0)) || isKnownSymbol(symbol)) return void 0;
        const validNameResult = {
            name: name,
            needsConvertPropertyAccess: false
        };
        if (isIdentifierText(name, target, jsxIdentifierExpected ? 1 /* JSX */  : 0 /* Standard */ ) || symbol.valueDeclaration && isPrivateIdentifierClassElementDeclaration(symbol.valueDeclaration)) return validNameResult;
        switch(kind){
            case 3 /* MemberLike */ :
                return originIsComputedPropertyName(origin) ? {
                    name: origin.symbolName,
                    needsConvertPropertyAccess: false
                } : void 0;
            case 0 /* ObjectPropertyDeclaration */ :
                return {
                    name: JSON.stringify(name),
                    needsConvertPropertyAccess: false
                };
            case 2 /* PropertyAccess */ :
            case 1 /* Global */ :
                return name.charCodeAt(0) === 32 /* space */  ? void 0 : {
                    name: name,
                    needsConvertPropertyAccess: true
                };
            case 5 /* None */ :
            case 4 /* String */ :
                return validNameResult;
            default:
                Debug.assertNever(kind);
        }
    }
    function getKeywordCompletions(keywordFilter, filterOutTsOnlyKeywords) {
        if (!filterOutTsOnlyKeywords) return getTypescriptKeywordCompletions(keywordFilter);
        const index = keywordFilter + 8 /* Last */  + 1;
        return _keywordCompletions[index] || (_keywordCompletions[index] = getTypescriptKeywordCompletions(keywordFilter).filter((entry)=>!isTypeScriptOnlyKeyword(stringToToken(entry.name))));
    }
    function getTypescriptKeywordCompletions(keywordFilter) {
        return _keywordCompletions[keywordFilter] || (_keywordCompletions[keywordFilter] = allKeywordsCompletions().filter((entry)=>{
            const kind = stringToToken(entry.name);
            switch(keywordFilter){
                case 0 /* None */ :
                    return false;
                case 1 /* All */ :
                    return isFunctionLikeBodyKeyword(kind) || kind === 138 /* DeclareKeyword */  || kind === 144 /* ModuleKeyword */  || kind === 156 /* TypeKeyword */  || kind === 145 /* NamespaceKeyword */  || kind === 128 /* AbstractKeyword */  || isTypeKeyword(kind) && kind !== 157 /* UndefinedKeyword */ ;
                case 5 /* FunctionLikeBodyKeywords */ :
                    return isFunctionLikeBodyKeyword(kind);
                case 2 /* ClassElementKeywords */ :
                    return isClassMemberCompletionKeyword(kind);
                case 3 /* InterfaceElementKeywords */ :
                    return isInterfaceOrTypeLiteralCompletionKeyword(kind);
                case 4 /* ConstructorParameterKeywords */ :
                    return isParameterPropertyModifier(kind);
                case 6 /* TypeAssertionKeywords */ :
                    return isTypeKeyword(kind) || kind === 87 /* ConstKeyword */ ;
                case 7 /* TypeKeywords */ :
                    return isTypeKeyword(kind);
                case 8 /* TypeKeyword */ :
                    return kind === 156 /* TypeKeyword */ ;
                default:
                    return Debug.assertNever(keywordFilter);
            }
        }));
    }
    function isTypeScriptOnlyKeyword(kind) {
        switch(kind){
            case 128 /* AbstractKeyword */ :
            case 133 /* AnyKeyword */ :
            case 162 /* BigIntKeyword */ :
            case 136 /* BooleanKeyword */ :
            case 138 /* DeclareKeyword */ :
            case 94 /* EnumKeyword */ :
            case 161 /* GlobalKeyword */ :
            case 119 /* ImplementsKeyword */ :
            case 140 /* InferKeyword */ :
            case 120 /* InterfaceKeyword */ :
            case 142 /* IsKeyword */ :
            case 143 /* KeyOfKeyword */ :
            case 144 /* ModuleKeyword */ :
            case 145 /* NamespaceKeyword */ :
            case 146 /* NeverKeyword */ :
            case 150 /* NumberKeyword */ :
            case 151 /* ObjectKeyword */ :
            case 163 /* OverrideKeyword */ :
            case 123 /* PrivateKeyword */ :
            case 124 /* ProtectedKeyword */ :
            case 125 /* PublicKeyword */ :
            case 148 /* ReadonlyKeyword */ :
            case 154 /* StringKeyword */ :
            case 155 /* SymbolKeyword */ :
            case 156 /* TypeKeyword */ :
            case 158 /* UniqueKeyword */ :
            case 159 /* UnknownKeyword */ :
                return true;
            default:
                return false;
        }
    }
    function isInterfaceOrTypeLiteralCompletionKeyword(kind) {
        return kind === 148 /* ReadonlyKeyword */ ;
    }
    function isClassMemberCompletionKeyword(kind) {
        switch(kind){
            case 128 /* AbstractKeyword */ :
            case 129 /* AccessorKeyword */ :
            case 137 /* ConstructorKeyword */ :
            case 139 /* GetKeyword */ :
            case 153 /* SetKeyword */ :
            case 134 /* AsyncKeyword */ :
            case 138 /* DeclareKeyword */ :
            case 163 /* OverrideKeyword */ :
                return true;
            default:
                return isClassMemberModifier(kind);
        }
    }
    function isFunctionLikeBodyKeyword(kind) {
        return kind === 134 /* AsyncKeyword */  || kind === 135 /* AwaitKeyword */  || kind === 130 /* AsKeyword */  || kind === 152 /* SatisfiesKeyword */  || kind === 156 /* TypeKeyword */  || !isContextualKeyword(kind) && !isClassMemberCompletionKeyword(kind);
    }
    function keywordForNode(node) {
        return isIdentifier(node) ? identifierToKeywordKind(node) ?? 0 /* Unknown */  : node.kind;
    }
    function getContextualKeywords(contextToken, position) {
        const entries = [];
        if (contextToken) {
            const file = contextToken.getSourceFile();
            const parent2 = contextToken.parent;
            const tokenLine = file.getLineAndCharacterOfPosition(contextToken.end).line;
            const currentLine = file.getLineAndCharacterOfPosition(position).line;
            if ((isImportDeclaration(parent2) || isExportDeclaration(parent2) && parent2.moduleSpecifier) && contextToken === parent2.moduleSpecifier && tokenLine === currentLine) entries.push({
                name: tokenToString(132 /* AssertKeyword */ ),
                kind: "keyword" /* keyword */ ,
                kindModifiers: "" /* none */ ,
                sortText: SortText.GlobalsOrKeywords
            });
        }
        return entries;
    }
    function getJsDocTagAtPosition(node, position) {
        return findAncestor(node, (n)=>isJSDocTag(n) && rangeContainsPosition(n, position) ? true : isJSDoc(n) ? "quit" : false);
    }
    function getPropertiesForObjectExpression(contextualType, completionsType, obj, checker) {
        const hasCompletionsType = completionsType && completionsType !== contextualType;
        const type = hasCompletionsType && !(completionsType.flags & 3 /* AnyOrUnknown */ ) ? checker.getUnionType([
            contextualType,
            completionsType
        ]) : contextualType;
        const properties = getApparentProperties(type, obj, checker);
        return type.isClass() && containsNonPublicProperties(properties) ? [] : hasCompletionsType ? filter(properties, hasDeclarationOtherThanSelf) : properties;
        function hasDeclarationOtherThanSelf(member) {
            if (!length(member.declarations)) return true;
            return some(member.declarations, (decl)=>decl.parent !== obj);
        }
    }
    function getApparentProperties(type, node, checker) {
        if (!type.isUnion()) return type.getApparentProperties();
        return checker.getAllPossiblePropertiesOfTypes(filter(type.types, (memberType)=>!(memberType.flags & 402784252 /* Primitive */  || checker.isArrayLikeType(memberType) || checker.isTypeInvalidDueToUnionDiscriminant(memberType, node) || checker.typeHasCallOrConstructSignatures(memberType) || memberType.isClass() && containsNonPublicProperties(memberType.getApparentProperties()))));
    }
    function containsNonPublicProperties(props) {
        return some(props, (p)=>!!(getDeclarationModifierFlagsFromSymbol(p) & 24 /* NonPublicAccessibilityModifier */ ));
    }
    function getPropertiesForCompletion(type, checker) {
        return type.isUnion() ? Debug.checkEachDefined(checker.getAllPossiblePropertiesOfTypes(type.types), "getAllPossiblePropertiesOfTypes() should all be defined") : Debug.checkEachDefined(type.getApparentProperties(), "getApparentProperties() should all be defined");
    }
    function tryGetObjectTypeDeclarationCompletionContainer(sourceFile, contextToken, location, position) {
        switch(location.kind){
            case 357 /* SyntaxList */ :
                return tryCast(location.parent, isObjectTypeDeclaration);
            case 1 /* EndOfFileToken */ :
                const cls = tryCast(lastOrUndefined(cast(location.parent, isSourceFile).statements), isObjectTypeDeclaration);
                if (cls && !findChildOfKind(cls, 20 /* CloseBraceToken */ , sourceFile)) return cls;
                break;
            case 80 /* Identifier */ :
                {
                    const originalKeywordKind = identifierToKeywordKind(location);
                    if (originalKeywordKind) return void 0;
                    if (isPropertyDeclaration(location.parent) && location.parent.initializer === location) return void 0;
                    if (isFromObjectTypeDeclaration(location)) return findAncestor(location, isObjectTypeDeclaration);
                }
        }
        if (!contextToken) return void 0;
        if (location.kind === 137 /* ConstructorKeyword */  || isIdentifier(contextToken) && isPropertyDeclaration(contextToken.parent) && isClassLike(location)) return findAncestor(contextToken, isClassLike);
        switch(contextToken.kind){
            case 64 /* EqualsToken */ :
                return void 0;
            case 27 /* SemicolonToken */ :
            case 20 /* CloseBraceToken */ :
                return isFromObjectTypeDeclaration(location) && location.parent.name === location ? location.parent.parent : tryCast(location, isObjectTypeDeclaration);
            case 19 /* OpenBraceToken */ :
            case 28 /* CommaToken */ :
                return tryCast(contextToken.parent, isObjectTypeDeclaration);
            default:
                if (isObjectTypeDeclaration(location)) {
                    if (getLineAndCharacterOfPosition(sourceFile, contextToken.getEnd()).line !== getLineAndCharacterOfPosition(sourceFile, position).line) return location;
                    const isValidKeyword = isClassLike(contextToken.parent.parent) ? isClassMemberCompletionKeyword : isInterfaceOrTypeLiteralCompletionKeyword;
                    return isValidKeyword(contextToken.kind) || contextToken.kind === 42 /* AsteriskToken */  || isIdentifier(contextToken) && isValidKeyword(identifierToKeywordKind(contextToken) ?? 0 /* Unknown */ ) ? contextToken.parent.parent : void 0;
                }
                return void 0;
        }
    }
    function tryGetTypeLiteralNode(node) {
        if (!node) return void 0;
        const parent2 = node.parent;
        switch(node.kind){
            case 19 /* OpenBraceToken */ :
                if (isTypeLiteralNode(parent2)) return parent2;
                break;
            case 27 /* SemicolonToken */ :
            case 28 /* CommaToken */ :
            case 80 /* Identifier */ :
                if (parent2.kind === 170 /* PropertySignature */  && isTypeLiteralNode(parent2.parent)) return parent2.parent;
                break;
        }
        return void 0;
    }
    function getConstraintOfTypeArgumentProperty(node, checker) {
        if (!node) return void 0;
        if (isTypeNode(node) && isTypeReferenceType(node.parent)) return checker.getTypeArgumentConstraint(node);
        const t = getConstraintOfTypeArgumentProperty(node.parent, checker);
        if (!t) return void 0;
        switch(node.kind){
            case 170 /* PropertySignature */ :
                return checker.getTypeOfPropertyOfContextualType(t, node.symbol.escapedName);
            case 192 /* IntersectionType */ :
            case 186 /* TypeLiteral */ :
            case 191 /* UnionType */ :
                return t;
        }
    }
    function isFromObjectTypeDeclaration(node) {
        return node.parent && isClassOrTypeElement(node.parent) && isObjectTypeDeclaration(node.parent.parent);
    }
    function isValidTrigger(sourceFile, triggerCharacter, contextToken, position) {
        switch(triggerCharacter){
            case ".":
            case "@":
                return true;
            case '"':
            case "'":
            case "`":
                return !!contextToken && isStringLiteralOrTemplate(contextToken) && position === contextToken.getStart(sourceFile) + 1;
            case "#":
                return !!contextToken && isPrivateIdentifier(contextToken) && !!getContainingClass(contextToken);
            case "<":
                return !!contextToken && contextToken.kind === 30 /* LessThanToken */  && (!isBinaryExpression(contextToken.parent) || binaryExpressionMayBeOpenTag(contextToken.parent));
            case "/":
                return !!contextToken && (isStringLiteralLike(contextToken) ? !!tryGetImportFromModuleSpecifier(contextToken) : contextToken.kind === 44 /* SlashToken */  && isJsxClosingElement(contextToken.parent));
            case " ":
                return !!contextToken && isImportKeyword(contextToken) && contextToken.parent.kind === 311 /* SourceFile */ ;
            default:
                return Debug.assertNever(triggerCharacter);
        }
    }
    function binaryExpressionMayBeOpenTag({ left: left  }) {
        return nodeIsMissing(left);
    }
    function isProbablyGlobalType(type, sourceFile, checker) {
        const selfSymbol = checker.resolveName("self", /*location*/ void 0, 111551 /* Value */ , /*excludeGlobals*/ false);
        if (selfSymbol && checker.getTypeOfSymbolAtLocation(selfSymbol, sourceFile) === type) return true;
        const globalSymbol = checker.resolveName("global", /*location*/ void 0, 111551 /* Value */ , /*excludeGlobals*/ false);
        if (globalSymbol && checker.getTypeOfSymbolAtLocation(globalSymbol, sourceFile) === type) return true;
        const globalThisSymbol = checker.resolveName("globalThis", /*location*/ void 0, 111551 /* Value */ , /*excludeGlobals*/ false);
        if (globalThisSymbol && checker.getTypeOfSymbolAtLocation(globalThisSymbol, sourceFile) === type) return true;
        return false;
    }
    function isStaticProperty(symbol) {
        return !!(symbol.valueDeclaration && getEffectiveModifierFlags(symbol.valueDeclaration) & 32 /* Static */  && isClassLike(symbol.valueDeclaration.parent));
    }
    function tryGetObjectLiteralContextualType(node, typeChecker) {
        const type = typeChecker.getContextualType(node);
        if (type) return type;
        const parent2 = walkUpParenthesizedExpressions(node.parent);
        if (isBinaryExpression(parent2) && parent2.operatorToken.kind === 64 /* EqualsToken */  && node === parent2.left) return typeChecker.getTypeAtLocation(parent2);
        if (isExpression(parent2)) return typeChecker.getContextualType(parent2);
        return void 0;
    }
    function getImportStatementCompletionInfo(contextToken) {
        var _a, _b, _c;
        let keywordCompletion;
        let isKeywordOnlyCompletion = false;
        const candidate = getCandidate();
        return {
            isKeywordOnlyCompletion: isKeywordOnlyCompletion,
            keywordCompletion: keywordCompletion,
            isNewIdentifierLocation: !!(candidate || keywordCompletion === 156 /* TypeKeyword */ ),
            isTopLevelTypeOnly: !!((_b = (_a = tryCast(candidate, isImportDeclaration)) == null ? void 0 : _a.importClause) == null ? void 0 : _b.isTypeOnly) || !!((_c = tryCast(candidate, isImportEqualsDeclaration)) == null ? void 0 : _c.isTypeOnly),
            couldBeTypeOnlyImportSpecifier: !!candidate && couldBeTypeOnlyImportSpecifier(candidate, contextToken),
            replacementSpan: getSingleLineReplacementSpanForImportCompletionNode(candidate)
        };
        function getCandidate() {
            const parent2 = contextToken.parent;
            if (isImportEqualsDeclaration(parent2)) {
                keywordCompletion = contextToken.kind === 156 /* TypeKeyword */  ? void 0 : 156 /* TypeKeyword */ ;
                return isModuleSpecifierMissingOrEmpty(parent2.moduleReference) ? parent2 : void 0;
            }
            if (couldBeTypeOnlyImportSpecifier(parent2, contextToken) && canCompleteFromNamedBindings(parent2.parent)) return parent2;
            if (isNamedImports(parent2) || isNamespaceImport(parent2)) {
                if (!parent2.parent.isTypeOnly && (contextToken.kind === 19 /* OpenBraceToken */  || contextToken.kind === 102 /* ImportKeyword */  || contextToken.kind === 28 /* CommaToken */ )) keywordCompletion = 156 /* TypeKeyword */ ;
                if (canCompleteFromNamedBindings(parent2)) {
                    if (contextToken.kind === 20 /* CloseBraceToken */  || contextToken.kind === 80 /* Identifier */ ) {
                        isKeywordOnlyCompletion = true;
                        keywordCompletion = 160 /* FromKeyword */ ;
                    } else return parent2.parent.parent;
                }
                return void 0;
            }
            if (isImportKeyword(contextToken) && isSourceFile(parent2)) {
                keywordCompletion = 156 /* TypeKeyword */ ;
                return contextToken;
            }
            if (isImportKeyword(contextToken) && isImportDeclaration(parent2)) {
                keywordCompletion = 156 /* TypeKeyword */ ;
                return isModuleSpecifierMissingOrEmpty(parent2.moduleSpecifier) ? parent2 : void 0;
            }
            return void 0;
        }
    }
    function getSingleLineReplacementSpanForImportCompletionNode(node) {
        var _a;
        if (!node) return void 0;
        const top = findAncestor(node, or(isImportDeclaration, isImportEqualsDeclaration)) ?? node;
        const sourceFile = top.getSourceFile();
        if (rangeIsOnSingleLine(top, sourceFile)) return createTextSpanFromNode(top, sourceFile);
        Debug.assert(top.kind !== 102 /* ImportKeyword */  && top.kind !== 275 /* ImportSpecifier */ );
        const potentialSplitPoint = top.kind === 271 /* ImportDeclaration */  ? getPotentiallyInvalidImportSpecifier((_a = top.importClause) == null ? void 0 : _a.namedBindings) ?? top.moduleSpecifier : top.moduleReference;
        const withoutModuleSpecifier = {
            pos: top.getFirstToken().getStart(),
            end: potentialSplitPoint.pos
        };
        if (rangeIsOnSingleLine(withoutModuleSpecifier, sourceFile)) return createTextSpanFromRange(withoutModuleSpecifier);
    }
    function getPotentiallyInvalidImportSpecifier(namedBindings) {
        var _a;
        return find((_a = tryCast(namedBindings, isNamedImports)) == null ? void 0 : _a.elements, (e)=>{
            var _a2;
            return !e.propertyName && isStringANonContextualKeyword(e.name.text) && ((_a2 = findPrecedingToken(e.name.pos, namedBindings.getSourceFile(), namedBindings)) == null ? void 0 : _a2.kind) !== 28 /* CommaToken */ ;
        });
    }
    function couldBeTypeOnlyImportSpecifier(importSpecifier, contextToken) {
        return isImportSpecifier(importSpecifier) && (importSpecifier.isTypeOnly || contextToken === importSpecifier.name && isTypeKeywordTokenOrIdentifier(contextToken));
    }
    function canCompleteFromNamedBindings(namedBindings) {
        if (!isModuleSpecifierMissingOrEmpty(namedBindings.parent.parent.moduleSpecifier) || namedBindings.parent.name) return false;
        if (isNamedImports(namedBindings)) {
            const invalidNamedImport = getPotentiallyInvalidImportSpecifier(namedBindings);
            const validImports = invalidNamedImport ? namedBindings.elements.indexOf(invalidNamedImport) : namedBindings.elements.length;
            return validImports < 2;
        }
        return true;
    }
    function isModuleSpecifierMissingOrEmpty(specifier) {
        var _a;
        if (nodeIsMissing(specifier)) return true;
        return !((_a = tryCast(isExternalModuleReference(specifier) ? specifier.expression : specifier, isStringLiteralLike)) == null ? void 0 : _a.text);
    }
    function getVariableOrParameterDeclaration(contextToken) {
        if (!contextToken) return;
        const declaration = findAncestor(contextToken, (node)=>isFunctionBlock(node) || isArrowFunctionBody(node) || isBindingPattern(node) ? "quit" : isVariableDeclaration(node) || (isParameter(node) || isTypeParameterDeclaration(node)) && !isIndexSignatureDeclaration(node.parent));
        return declaration;
    }
    function isArrowFunctionBody(node) {
        return node.parent && isArrowFunction(node.parent) && (node.parent.body === node || // const a = () => /**/;
        node.kind === 39 /* EqualsGreaterThanToken */ );
    }
    function symbolCanBeReferencedAtTypeLocation(symbol, checker, seenModules = /* @__PURE__ */ new Map()) {
        return nonAliasCanBeReferencedAtTypeLocation(symbol) || nonAliasCanBeReferencedAtTypeLocation(skipAlias(symbol.exportSymbol || symbol, checker));
        function nonAliasCanBeReferencedAtTypeLocation(symbol2) {
            return !!(symbol2.flags & 788968 /* Type */ ) || checker.isUnknownSymbol(symbol2) || !!(symbol2.flags & 1536 /* Module */ ) && addToSeen(seenModules, getSymbolId(symbol2)) && checker.getExportsOfModule(symbol2).some((e)=>symbolCanBeReferencedAtTypeLocation(e, checker, seenModules));
        }
    }
    function isDeprecated(symbol, checker) {
        const declarations = skipAlias(symbol, checker).declarations;
        return !!length(declarations) && every(declarations, isDeprecatedDeclaration);
    }
    function charactersFuzzyMatchInString(identifierString, lowercaseCharacters) {
        if (lowercaseCharacters.length === 0) return true;
        let matchedFirstCharacter = false;
        let prevChar;
        let characterIndex = 0;
        const len = identifierString.length;
        for(let strIndex = 0; strIndex < len; strIndex++){
            const strChar = identifierString.charCodeAt(strIndex);
            const testChar = lowercaseCharacters.charCodeAt(characterIndex);
            if (strChar === testChar || strChar === toUpperCharCode(testChar)) {
                matchedFirstCharacter || (matchedFirstCharacter = prevChar === void 0 || // Beginning of word
                97 /* a */  <= prevChar && prevChar <= 122 /* z */  && 65 /* A */  <= strChar && strChar <= 90 /* Z */  || // camelCase transition
                prevChar === 95 /* _ */  && strChar !== 95 /* _ */ );
                if (matchedFirstCharacter) characterIndex++;
                if (characterIndex === lowercaseCharacters.length) return true;
            }
            prevChar = strChar;
        }
        return false;
    }
    function toUpperCharCode(charCode) {
        if (97 /* a */  <= charCode && charCode <= 122 /* z */ ) return charCode - 32;
        return charCode;
    }
    var moduleSpecifierResolutionLimit, moduleSpecifierResolutionCacheAttemptLimit, SortText, CompletionSource, SymbolOriginInfoKind, CompletionKind, _keywordCompletions, allKeywordsCompletions;
    var init_completions = __esm({
        "src/services/completions.ts" () {
            "use strict";
            init_ts4();
            init_ts_Completions();
            moduleSpecifierResolutionLimit = 100;
            moduleSpecifierResolutionCacheAttemptLimit = 1e3;
            SortText = {
                // Presets
                LocalDeclarationPriority: "10",
                LocationPriority: "11",
                OptionalMember: "12",
                MemberDeclaredBySpreadAssignment: "13",
                SuggestedClassMembers: "14",
                GlobalsOrKeywords: "15",
                AutoImportSuggestions: "16",
                ClassMemberSnippets: "17",
                JavascriptIdentifiers: "18",
                // Transformations
                Deprecated (sortText) {
                    return "z" + sortText;
                },
                ObjectLiteralProperty (presetSortText, symbolDisplayName) {
                    return `${presetSortText}\0${symbolDisplayName}\0`;
                },
                SortBelow (sortText) {
                    return sortText + "1";
                }
            };
            CompletionSource = /* @__PURE__ */ ((CompletionSource2)=>{
                CompletionSource2["ThisProperty"] = "ThisProperty/";
                CompletionSource2["ClassMemberSnippet"] = "ClassMemberSnippet/";
                CompletionSource2["TypeOnlyAlias"] = "TypeOnlyAlias/";
                CompletionSource2["ObjectLiteralMethodSnippet"] = "ObjectLiteralMethodSnippet/";
                CompletionSource2["SwitchCases"] = "SwitchCases/";
                return CompletionSource2;
            })(CompletionSource || {});
            SymbolOriginInfoKind = /* @__PURE__ */ ((SymbolOriginInfoKind2)=>{
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["ThisType"] = 1] = "ThisType";
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["SymbolMember"] = 2] = "SymbolMember";
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["Export"] = 4] = "Export";
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["Promise"] = 8] = "Promise";
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["Nullable"] = 16] = "Nullable";
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["ResolvedExport"] = 32] = "ResolvedExport";
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["TypeOnlyAlias"] = 64] = "TypeOnlyAlias";
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["ObjectLiteralMethod"] = 128] = "ObjectLiteralMethod";
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["Ignore"] = 256] = "Ignore";
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["ComputedPropertyName"] = 512] = "ComputedPropertyName";
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["SymbolMemberNoExport"] = 2 /* SymbolMember */ ] = "SymbolMemberNoExport";
                SymbolOriginInfoKind2[SymbolOriginInfoKind2["SymbolMemberExport"] = 6] = "SymbolMemberExport";
                return SymbolOriginInfoKind2;
            })(SymbolOriginInfoKind || {});
            CompletionKind = /* @__PURE__ */ ((CompletionKind2)=>{
                CompletionKind2[CompletionKind2["ObjectPropertyDeclaration"] = 0] = "ObjectPropertyDeclaration";
                CompletionKind2[CompletionKind2["Global"] = 1] = "Global";
                CompletionKind2[CompletionKind2["PropertyAccess"] = 2] = "PropertyAccess";
                CompletionKind2[CompletionKind2["MemberLike"] = 3] = "MemberLike";
                CompletionKind2[CompletionKind2["String"] = 4] = "String";
                CompletionKind2[CompletionKind2["None"] = 5] = "None";
                return CompletionKind2;
            })(CompletionKind || {});
            _keywordCompletions = [];
            allKeywordsCompletions = memoize(()=>{
                const res = [];
                for(let i = 83 /* FirstKeyword */ ; i <= 164 /* LastKeyword */ ; i++)res.push({
                    name: tokenToString(i),
                    kind: "keyword" /* keyword */ ,
                    kindModifiers: "" /* none */ ,
                    sortText: SortText.GlobalsOrKeywords
                });
                return res;
            });
        }
    });
    // src/services/stringCompletions.ts
    function createNameAndKindSet() {
        const map2 = /* @__PURE__ */ new Map();
        function add(value1) {
            const existing = map2.get(value1.name);
            if (!existing || kindPrecedence[existing.kind] < kindPrecedence[value1.kind]) map2.set(value1.name, value1);
        }
        return {
            add: add,
            has: map2.has.bind(map2),
            values: map2.values.bind(map2)
        };
    }
    function getStringLiteralCompletions(sourceFile, position, contextToken, options, host, program, log, preferences, includeSymbol) {
        if (isInReferenceComment(sourceFile, position)) {
            const entries = getTripleSlashReferenceCompletion(sourceFile, position, options, host);
            return entries && convertPathCompletions(entries);
        }
        if (isInString(sourceFile, position, contextToken)) {
            if (!contextToken || !isStringLiteralLike(contextToken)) return void 0;
            const entries = getStringLiteralCompletionEntries(sourceFile, contextToken, position, program.getTypeChecker(), options, host, preferences);
            return convertStringLiteralCompletions(entries, contextToken, sourceFile, host, program, log, options, preferences, position, includeSymbol);
        }
    }
    function convertStringLiteralCompletions(completion, contextToken, sourceFile, host, program, log, options, preferences, position, includeSymbol) {
        if (completion === void 0) return void 0;
        const optionalReplacementSpan = createTextSpanFromStringLiteralLikeContent(contextToken);
        switch(completion.kind){
            case 0 /* Paths */ :
                return convertPathCompletions(completion.paths);
            case 1 /* Properties */ :
                {
                    const entries = createSortedArray();
                    getCompletionEntriesFromSymbols(completion.symbols, entries, contextToken, contextToken, sourceFile, position, sourceFile, host, program, 99 /* ESNext */ , log, 4 /* String */ , preferences, options, /*formatContext*/ void 0, /*isTypeOnlyLocation*/ void 0, /*propertyAccessToConvert*/ void 0, /*jsxIdentifierExpected*/ void 0, /*isJsxInitializer*/ void 0, /*importStatementCompletion*/ void 0, /*recommendedCompletion*/ void 0, /*symbolToOriginInfoMap*/ void 0, /*symbolToSortTextMap*/ void 0, /*isJsxIdentifierExpected*/ void 0, /*isRightOfOpenTag*/ void 0, includeSymbol);
                    return {
                        isGlobalCompletion: false,
                        isMemberCompletion: true,
                        isNewIdentifierLocation: completion.hasIndexSignature,
                        optionalReplacementSpan: optionalReplacementSpan,
                        entries: entries
                    };
                }
            case 2 /* Types */ :
                {
                    const entries = completion.types.map((type)=>({
                            name: type.value,
                            kindModifiers: "" /* none */ ,
                            kind: "string" /* string */ ,
                            sortText: SortText.LocationPriority,
                            replacementSpan: getReplacementSpanForContextToken(contextToken)
                        }));
                    return {
                        isGlobalCompletion: false,
                        isMemberCompletion: false,
                        isNewIdentifierLocation: completion.isNewIdentifier,
                        optionalReplacementSpan: optionalReplacementSpan,
                        entries: entries
                    };
                }
            default:
                return Debug.assertNever(completion);
        }
    }
    function getStringLiteralCompletionDetails(name, sourceFile, position, contextToken, checker, options, host, cancellationToken, preferences) {
        if (!contextToken || !isStringLiteralLike(contextToken)) return void 0;
        const completions = getStringLiteralCompletionEntries(sourceFile, contextToken, position, checker, options, host, preferences);
        return completions && stringLiteralCompletionDetails(name, contextToken, completions, sourceFile, checker, cancellationToken);
    }
    function stringLiteralCompletionDetails(name, location, completion, sourceFile, checker, cancellationToken) {
        switch(completion.kind){
            case 0 /* Paths */ :
                {
                    const match = find(completion.paths, (p)=>p.name === name);
                    return match && createCompletionDetails(name, kindModifiersFromExtension(match.extension), match.kind, [
                        textPart(name)
                    ]);
                }
            case 1 /* Properties */ :
                {
                    const match = find(completion.symbols, (s)=>s.name === name);
                    return match && createCompletionDetailsForSymbol(match, match.name, checker, sourceFile, location, cancellationToken);
                }
            case 2 /* Types */ :
                return find(completion.types, (t)=>t.value === name) ? createCompletionDetails(name, "" /* none */ , "string" /* string */ , [
                    textPart(name)
                ]) : void 0;
            default:
                return Debug.assertNever(completion);
        }
    }
    function convertPathCompletions(pathCompletions) {
        const isGlobalCompletion = false;
        const isNewIdentifierLocation = true;
        const entries = pathCompletions.map(({ name: name , kind: kind , span: span , extension: extension  })=>({
                name: name,
                kind: kind,
                kindModifiers: kindModifiersFromExtension(extension),
                sortText: SortText.LocationPriority,
                replacementSpan: span
            }));
        return {
            isGlobalCompletion: isGlobalCompletion,
            isMemberCompletion: false,
            isNewIdentifierLocation: isNewIdentifierLocation,
            entries: entries
        };
    }
    function kindModifiersFromExtension(extension) {
        switch(extension){
            case ".d.ts" /* Dts */ :
                return ".d.ts" /* dtsModifier */ ;
            case ".js" /* Js */ :
                return ".js" /* jsModifier */ ;
            case ".json" /* Json */ :
                return ".json" /* jsonModifier */ ;
            case ".jsx" /* Jsx */ :
                return ".jsx" /* jsxModifier */ ;
            case ".ts" /* Ts */ :
                return ".ts" /* tsModifier */ ;
            case ".tsx" /* Tsx */ :
                return ".tsx" /* tsxModifier */ ;
            case ".d.mts" /* Dmts */ :
                return ".d.mts" /* dmtsModifier */ ;
            case ".mjs" /* Mjs */ :
                return ".mjs" /* mjsModifier */ ;
            case ".mts" /* Mts */ :
                return ".mts" /* mtsModifier */ ;
            case ".d.cts" /* Dcts */ :
                return ".d.cts" /* dctsModifier */ ;
            case ".cjs" /* Cjs */ :
                return ".cjs" /* cjsModifier */ ;
            case ".cts" /* Cts */ :
                return ".cts" /* ctsModifier */ ;
            case ".tsbuildinfo" /* TsBuildInfo */ :
                return Debug.fail(`Extension ${".tsbuildinfo" /* TsBuildInfo */ } is unsupported.`);
            case void 0:
                return "" /* none */ ;
            default:
                return Debug.assertNever(extension);
        }
    }
    function getStringLiteralCompletionEntries(sourceFile, node, position, typeChecker, compilerOptions, host, preferences) {
        const parent2 = walkUpParentheses(node.parent);
        switch(parent2.kind){
            case 200 /* LiteralType */ :
                {
                    const grandParent = walkUpParentheses(parent2.parent);
                    if (grandParent.kind === 204 /* ImportType */ ) return {
                        kind: 0 /* Paths */ ,
                        paths: getStringLiteralCompletionsFromModuleNames(sourceFile, node, compilerOptions, host, typeChecker, preferences)
                    };
                    return fromUnionableLiteralType(grandParent);
                }
            case 302 /* PropertyAssignment */ :
                if (isObjectLiteralExpression(parent2.parent) && parent2.name === node) return stringLiteralCompletionsForObjectLiteral(typeChecker, parent2.parent);
                return fromContextualType() || fromContextualType(0 /* None */ );
            case 211 /* ElementAccessExpression */ :
                {
                    const { expression: expression , argumentExpression: argumentExpression  } = parent2;
                    if (node === skipParentheses(argumentExpression)) return stringLiteralCompletionsFromProperties(typeChecker.getTypeAtLocation(expression));
                    return void 0;
                }
            case 212 /* CallExpression */ :
            case 213 /* NewExpression */ :
            case 290 /* JsxAttribute */ :
                if (!isRequireCallArgument(node) && !isImportCall(parent2)) {
                    const argumentInfo = ts_SignatureHelp_exports.getArgumentInfoForCompletions(parent2.kind === 290 /* JsxAttribute */  ? parent2.parent : node, position, sourceFile);
                    return argumentInfo && getStringLiteralCompletionsFromSignature(argumentInfo.invocation, node, argumentInfo, typeChecker) || fromContextualType();
                }
            case 271 /* ImportDeclaration */ :
            case 277 /* ExportDeclaration */ :
            case 282 /* ExternalModuleReference */ :
                return {
                    kind: 0 /* Paths */ ,
                    paths: getStringLiteralCompletionsFromModuleNames(sourceFile, node, compilerOptions, host, typeChecker, preferences)
                };
            case 295 /* CaseClause */ :
                const tracker = newCaseClauseTracker(typeChecker, parent2.parent.clauses);
                const contextualTypes = fromContextualType();
                if (!contextualTypes) return;
                const literals = contextualTypes.types.filter((literal)=>!tracker.hasValue(literal.value));
                return {
                    kind: 2 /* Types */ ,
                    types: literals,
                    isNewIdentifier: false
                };
            default:
                return fromContextualType() || fromContextualType(0 /* None */ );
        }
        function fromUnionableLiteralType(grandParent) {
            switch(grandParent.kind){
                case 232 /* ExpressionWithTypeArguments */ :
                case 182 /* TypeReference */ :
                    {
                        const typeArgument = findAncestor(parent2, (n)=>n.parent === grandParent);
                        if (typeArgument) return {
                            kind: 2 /* Types */ ,
                            types: getStringLiteralTypes(typeChecker.getTypeArgumentConstraint(typeArgument)),
                            isNewIdentifier: false
                        };
                        return void 0;
                    }
                case 198 /* IndexedAccessType */ :
                    const { indexType: indexType , objectType: objectType  } = grandParent;
                    if (!rangeContainsPosition(indexType, position)) return void 0;
                    return stringLiteralCompletionsFromProperties(typeChecker.getTypeFromTypeNode(objectType));
                case 191 /* UnionType */ :
                    {
                        const result = fromUnionableLiteralType(walkUpParentheses(grandParent.parent));
                        if (!result) return void 0;
                        const alreadyUsedTypes = getAlreadyUsedTypesInStringLiteralUnion(grandParent, parent2);
                        if (result.kind === 1 /* Properties */ ) return {
                            kind: 1 /* Properties */ ,
                            symbols: result.symbols.filter((sym)=>!contains(alreadyUsedTypes, sym.name)),
                            hasIndexSignature: result.hasIndexSignature
                        };
                        return {
                            kind: 2 /* Types */ ,
                            types: result.types.filter((t)=>!contains(alreadyUsedTypes, t.value)),
                            isNewIdentifier: false
                        };
                    }
                default:
                    return void 0;
            }
        }
        function fromContextualType(contextFlags = 4 /* Completions */ ) {
            const types = getStringLiteralTypes(getContextualTypeFromParent(node, typeChecker, contextFlags));
            if (!types.length) return;
            return {
                kind: 2 /* Types */ ,
                types: types,
                isNewIdentifier: false
            };
        }
    }
    function walkUpParentheses(node) {
        switch(node.kind){
            case 195 /* ParenthesizedType */ :
                return walkUpParenthesizedTypes(node);
            case 216 /* ParenthesizedExpression */ :
                return walkUpParenthesizedExpressions(node);
            default:
                return node;
        }
    }
    function getAlreadyUsedTypesInStringLiteralUnion(union, current) {
        return mapDefined(union.types, (type)=>type !== current && isLiteralTypeNode(type) && isStringLiteral(type.literal) ? type.literal.text : void 0);
    }
    function getStringLiteralCompletionsFromSignature(call, arg, argumentInfo, checker) {
        let isNewIdentifier = false;
        const uniques = /* @__PURE__ */ new Map();
        const candidates = [];
        const editingArgument = isJsxOpeningLikeElement(call) ? Debug.checkDefined(findAncestor(arg.parent, isJsxAttribute)) : arg;
        checker.getResolvedSignatureForStringLiteralCompletions(call, editingArgument, candidates);
        const types = flatMap(candidates, (candidate)=>{
            if (!signatureHasRestParameter(candidate) && argumentInfo.argumentCount > candidate.parameters.length) return;
            let type = candidate.getTypeParameterAtPosition(argumentInfo.argumentIndex);
            if (isJsxOpeningLikeElement(call)) {
                const propType = checker.getTypeOfPropertyOfType(type, getTextOfJsxAttributeName(editingArgument.name));
                if (propType) type = propType;
            }
            isNewIdentifier = isNewIdentifier || !!(type.flags & 4 /* String */ );
            return getStringLiteralTypes(type, uniques);
        });
        return length(types) ? {
            kind: 2 /* Types */ ,
            types: types,
            isNewIdentifier: isNewIdentifier
        } : void 0;
    }
    function stringLiteralCompletionsFromProperties(type) {
        return type && {
            kind: 1 /* Properties */ ,
            symbols: filter(type.getApparentProperties(), (prop)=>!(prop.valueDeclaration && isPrivateIdentifierClassElementDeclaration(prop.valueDeclaration))),
            hasIndexSignature: hasIndexSignature(type)
        };
    }
    function stringLiteralCompletionsForObjectLiteral(checker, objectLiteralExpression) {
        const contextualType = checker.getContextualType(objectLiteralExpression);
        if (!contextualType) return void 0;
        const completionsType = checker.getContextualType(objectLiteralExpression, 4 /* Completions */ );
        const symbols = getPropertiesForObjectExpression(contextualType, completionsType, objectLiteralExpression, checker);
        return {
            kind: 1 /* Properties */ ,
            symbols: symbols,
            hasIndexSignature: hasIndexSignature(contextualType)
        };
    }
    function getStringLiteralTypes(type, uniques = /* @__PURE__ */ new Map()) {
        if (!type) return emptyArray;
        type = skipConstraint(type);
        return type.isUnion() ? flatMap(type.types, (t)=>getStringLiteralTypes(t, uniques)) : type.isStringLiteral() && !(type.flags & 1024 /* EnumLiteral */ ) && addToSeen(uniques, type.value) ? [
            type
        ] : emptyArray;
    }
    function nameAndKind(name, kind, extension) {
        return {
            name: name,
            kind: kind,
            extension: extension
        };
    }
    function directoryResult(name) {
        return nameAndKind(name, "directory" /* directory */ , /*extension*/ void 0);
    }
    function addReplacementSpans(text, textStart, names) {
        const span = getDirectoryFragmentTextSpan(text, textStart);
        const wholeSpan = text.length === 0 ? void 0 : createTextSpan(textStart, text.length);
        return names.map(({ name: name , kind: kind , extension: extension  })=>Math.max(name.indexOf(directorySeparator), name.indexOf(altDirectorySeparator)) !== -1 ? {
                name: name,
                kind: kind,
                extension: extension,
                span: wholeSpan
            } : {
                name: name,
                kind: kind,
                extension: extension,
                span: span
            });
    }
    function getStringLiteralCompletionsFromModuleNames(sourceFile, node, compilerOptions, host, typeChecker, preferences) {
        return addReplacementSpans(node.text, node.getStart(sourceFile) + 1, getStringLiteralCompletionsFromModuleNamesWorker(sourceFile, node, compilerOptions, host, typeChecker, preferences));
    }
    function getStringLiteralCompletionsFromModuleNamesWorker(sourceFile, node, compilerOptions, host, typeChecker, preferences) {
        const literalValue = normalizeSlashes(node.text);
        const mode = isStringLiteralLike(node) ? getModeForUsageLocation(sourceFile, node) : void 0;
        const scriptPath = sourceFile.path;
        const scriptDirectory = getDirectoryPath(scriptPath);
        const extensionOptions = getExtensionOptions(compilerOptions, 1 /* ModuleSpecifier */ , sourceFile, typeChecker, preferences, mode);
        return isPathRelativeToScript(literalValue) || !compilerOptions.baseUrl && !compilerOptions.paths && (isRootedDiskPath(literalValue) || isUrl(literalValue)) ? getCompletionEntriesForRelativeModules(literalValue, scriptDirectory, compilerOptions, host, scriptPath, extensionOptions) : getCompletionEntriesForNonRelativeModules(literalValue, scriptDirectory, mode, compilerOptions, host, extensionOptions, typeChecker);
    }
    function getExtensionOptions(compilerOptions, referenceKind, importingSourceFile, typeChecker, preferences, resolutionMode) {
        return {
            extensionsToSearch: flatten(getSupportedExtensionsForModuleResolution(compilerOptions, typeChecker)),
            referenceKind: referenceKind,
            importingSourceFile: importingSourceFile,
            endingPreference: preferences == null ? void 0 : preferences.importModuleSpecifierEnding,
            resolutionMode: resolutionMode
        };
    }
    function getCompletionEntriesForRelativeModules(literalValue, scriptDirectory, compilerOptions, host, scriptPath, extensionOptions) {
        if (compilerOptions.rootDirs) return getCompletionEntriesForDirectoryFragmentWithRootDirs(compilerOptions.rootDirs, literalValue, scriptDirectory, extensionOptions, compilerOptions, host, scriptPath);
        else return arrayFrom(getCompletionEntriesForDirectoryFragment(literalValue, scriptDirectory, extensionOptions, host, /*moduleSpecifierIsRelative*/ false, scriptPath).values());
    }
    function getSupportedExtensionsForModuleResolution(compilerOptions, typeChecker) {
        const ambientModulesExtensions = !typeChecker ? [] : mapDefined(typeChecker.getAmbientModules(), (module2)=>{
            const name = module2.name.slice(1, -1);
            if (!name.startsWith("*.") || name.includes("/")) return;
            return name.slice(1);
        });
        const extensions = [
            ...getSupportedExtensions(compilerOptions),
            ambientModulesExtensions
        ];
        const moduleResolution = getEmitModuleResolutionKind(compilerOptions);
        return moduleResolutionUsesNodeModules(moduleResolution) ? getSupportedExtensionsWithJsonIfResolveJsonModule(compilerOptions, extensions) : extensions;
    }
    function getBaseDirectoriesFromRootDirs(rootDirs, basePath, scriptDirectory, ignoreCase) {
        rootDirs = rootDirs.map((rootDirectory)=>normalizePath(isRootedDiskPath(rootDirectory) ? rootDirectory : combinePaths(basePath, rootDirectory)));
        const relativeDirectory = firstDefined(rootDirs, (rootDirectory)=>containsPath(rootDirectory, scriptDirectory, basePath, ignoreCase) ? scriptDirectory.substr(rootDirectory.length) : void 0);
        return deduplicate([
            ...rootDirs.map((rootDirectory)=>combinePaths(rootDirectory, relativeDirectory)),
            scriptDirectory
        ], equateStringsCaseSensitive, compareStringsCaseSensitive);
    }
    function getCompletionEntriesForDirectoryFragmentWithRootDirs(rootDirs, fragment, scriptDirectory, extensionOptions, compilerOptions, host, exclude) {
        const basePath = compilerOptions.project || host.getCurrentDirectory();
        const ignoreCase = !(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames());
        const baseDirectories = getBaseDirectoriesFromRootDirs(rootDirs, basePath, scriptDirectory, ignoreCase);
        return flatMap(baseDirectories, (baseDirectory)=>arrayFrom(getCompletionEntriesForDirectoryFragment(fragment, baseDirectory, extensionOptions, host, /*moduleSpecifierIsRelative*/ true, exclude).values()));
    }
    function getCompletionEntriesForDirectoryFragment(fragment, scriptDirectory, extensionOptions, host, moduleSpecifierIsRelative, exclude, result = createNameAndKindSet()) {
        var _a;
        if (fragment === void 0) fragment = "";
        fragment = normalizeSlashes(fragment);
        if (!hasTrailingDirectorySeparator(fragment)) fragment = getDirectoryPath(fragment);
        if (fragment === "") fragment = "." + directorySeparator;
        fragment = ensureTrailingDirectorySeparator(fragment);
        const absolutePath = resolvePath(scriptDirectory, fragment);
        const baseDirectory = hasTrailingDirectorySeparator(absolutePath) ? absolutePath : getDirectoryPath(absolutePath);
        if (!moduleSpecifierIsRelative) {
            const packageJsonPath = findPackageJson(baseDirectory, host);
            if (packageJsonPath) {
                const packageJson = readJson(packageJsonPath, host);
                const typesVersions = packageJson.typesVersions;
                if (typeof typesVersions === "object") {
                    const versionPaths = (_a = getPackageJsonTypesVersionsPaths(typesVersions)) == null ? void 0 : _a.paths;
                    if (versionPaths) {
                        const packageDirectory = getDirectoryPath(packageJsonPath);
                        const pathInPackage = absolutePath.slice(ensureTrailingDirectorySeparator(packageDirectory).length);
                        if (addCompletionEntriesFromPaths(result, pathInPackage, packageDirectory, extensionOptions, host, versionPaths)) return result;
                    }
                }
            }
        }
        const ignoreCase = !(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames());
        if (!tryDirectoryExists(host, baseDirectory)) return result;
        const files = tryReadDirectory(host, baseDirectory, extensionOptions.extensionsToSearch, /*exclude*/ void 0, /*include*/ [
            "./*"
        ]);
        if (files) for (let filePath of files){
            filePath = normalizePath(filePath);
            if (exclude && comparePaths(filePath, exclude, scriptDirectory, ignoreCase) === 0 /* EqualTo */ ) continue;
            const { name: name , extension: extension  } = getFilenameWithExtensionOption(getBaseFileName(filePath), host.getCompilationSettings(), extensionOptions);
            result.add(nameAndKind(name, "script" /* scriptElement */ , extension));
        }
        const directories = tryGetDirectories(host, baseDirectory);
        if (directories) for (const directory of directories){
            const directoryName = getBaseFileName(normalizePath(directory));
            if (directoryName !== "@types") result.add(directoryResult(directoryName));
        }
        return result;
    }
    function getFilenameWithExtensionOption(name, compilerOptions, extensionOptions) {
        const nonJsResult = ts_moduleSpecifiers_exports.tryGetRealFileNameForNonJsDeclarationFileName(name);
        if (nonJsResult) return {
            name: nonJsResult,
            extension: tryGetExtensionFromPath2(nonJsResult)
        };
        if (extensionOptions.referenceKind === 0 /* Filename */ ) return {
            name: name,
            extension: tryGetExtensionFromPath2(name)
        };
        const endingPreference = getModuleSpecifierEndingPreference(extensionOptions.endingPreference, extensionOptions.resolutionMode, compilerOptions, extensionOptions.importingSourceFile);
        if (endingPreference === 3 /* TsExtension */ ) {
            if (fileExtensionIsOneOf(name, supportedTSImplementationExtensions)) return {
                name: name,
                extension: tryGetExtensionFromPath2(name)
            };
            const outputExtension2 = ts_moduleSpecifiers_exports.tryGetJSExtensionForFile(name, compilerOptions);
            return outputExtension2 ? {
                name: changeExtension(name, outputExtension2),
                extension: outputExtension2
            } : {
                name: name,
                extension: tryGetExtensionFromPath2(name)
            };
        }
        if ((endingPreference === 0 /* Minimal */  || endingPreference === 1 /* Index */ ) && fileExtensionIsOneOf(name, [
            ".js" /* Js */ ,
            ".jsx" /* Jsx */ ,
            ".ts" /* Ts */ ,
            ".tsx" /* Tsx */ ,
            ".d.ts" /* Dts */ 
        ])) return {
            name: removeFileExtension(name),
            extension: tryGetExtensionFromPath2(name)
        };
        const outputExtension = ts_moduleSpecifiers_exports.tryGetJSExtensionForFile(name, compilerOptions);
        return outputExtension ? {
            name: changeExtension(name, outputExtension),
            extension: outputExtension
        } : {
            name: name,
            extension: tryGetExtensionFromPath2(name)
        };
    }
    function addCompletionEntriesFromPaths(result, fragment, baseDirectory, extensionOptions, host, paths) {
        const getPatternsForKey = (key)=>paths[key];
        const comparePaths2 = (a, b)=>{
            const patternA = tryParsePattern(a);
            const patternB = tryParsePattern(b);
            const lengthA = typeof patternA === "object" ? patternA.prefix.length : a.length;
            const lengthB = typeof patternB === "object" ? patternB.prefix.length : b.length;
            return compareValues(lengthB, lengthA);
        };
        return addCompletionEntriesFromPathsOrExports(result, fragment, baseDirectory, extensionOptions, host, getOwnKeys(paths), getPatternsForKey, comparePaths2);
    }
    function addCompletionEntriesFromPathsOrExports(result, fragment, baseDirectory, extensionOptions, host, keys, getPatternsForKey, comparePaths2) {
        let pathResults = [];
        let matchedPath;
        for (const key of keys){
            if (key === ".") continue;
            const keyWithoutLeadingDotSlash = key.replace(/^\.\//, "");
            const patterns = getPatternsForKey(key);
            if (patterns) {
                const pathPattern = tryParsePattern(keyWithoutLeadingDotSlash);
                if (!pathPattern) continue;
                const isMatch = typeof pathPattern === "object" && isPatternMatch(pathPattern, fragment);
                const isLongestMatch = isMatch && (matchedPath === void 0 || comparePaths2(key, matchedPath) === -1 /* LessThan */ );
                if (isLongestMatch) {
                    matchedPath = key;
                    pathResults = pathResults.filter((r)=>!r.matchedPattern);
                }
                if (typeof pathPattern === "string" || matchedPath === void 0 || comparePaths2(key, matchedPath) !== 1 /* GreaterThan */ ) pathResults.push({
                    matchedPattern: isMatch,
                    results: getCompletionsForPathMapping(keyWithoutLeadingDotSlash, patterns, fragment, baseDirectory, extensionOptions, host).map(({ name: name , kind: kind , extension: extension  })=>nameAndKind(name, kind, extension))
                });
            }
        }
        pathResults.forEach((pathResult)=>pathResult.results.forEach((r)=>result.add(r)));
        return matchedPath !== void 0;
    }
    function getCompletionEntriesForNonRelativeModules(fragment, scriptPath, mode, compilerOptions, host, extensionOptions, typeChecker) {
        const { baseUrl: baseUrl , paths: paths  } = compilerOptions;
        const result = createNameAndKindSet();
        const moduleResolution = getEmitModuleResolutionKind(compilerOptions);
        if (baseUrl) {
            const absolute = normalizePath(combinePaths(host.getCurrentDirectory(), baseUrl));
            getCompletionEntriesForDirectoryFragment(fragment, absolute, extensionOptions, host, /*moduleSpecifierIsRelative*/ false, /*exclude*/ void 0, result);
        }
        if (paths) {
            const absolute = getPathsBasePath(compilerOptions, host);
            addCompletionEntriesFromPaths(result, fragment, absolute, extensionOptions, host, paths);
        }
        const fragmentDirectory = getFragmentDirectory(fragment);
        for (const ambientName of getAmbientModuleCompletions(fragment, fragmentDirectory, typeChecker))result.add(nameAndKind(ambientName, "external module name" /* externalModuleName */ , /*extension*/ void 0));
        getCompletionEntriesFromTypings(host, compilerOptions, scriptPath, fragmentDirectory, extensionOptions, result);
        if (moduleResolutionUsesNodeModules(moduleResolution)) {
            let foundGlobal = false;
            if (fragmentDirectory === void 0) for (const moduleName of enumerateNodeModulesVisibleToScript(host, scriptPath)){
                const moduleResult = nameAndKind(moduleName, "external module name" /* externalModuleName */ , /*extension*/ void 0);
                if (!result.has(moduleResult.name)) {
                    foundGlobal = true;
                    result.add(moduleResult);
                }
            }
            if (!foundGlobal) {
                let ancestorLookup = (ancestor)=>{
                    const nodeModules = combinePaths(ancestor, "node_modules");
                    if (tryDirectoryExists(host, nodeModules)) getCompletionEntriesForDirectoryFragment(fragment, nodeModules, extensionOptions, host, /*moduleSpecifierIsRelative*/ false, /*exclude*/ void 0, result);
                };
                if (fragmentDirectory && getResolvePackageJsonExports(compilerOptions)) {
                    const nodeModulesDirectoryLookup = ancestorLookup;
                    ancestorLookup = (ancestor)=>{
                        const components = getPathComponents(fragment);
                        components.shift();
                        let packagePath = components.shift();
                        if (!packagePath) return nodeModulesDirectoryLookup(ancestor);
                        if (startsWith(packagePath, "@")) {
                            const subName = components.shift();
                            if (!subName) return nodeModulesDirectoryLookup(ancestor);
                            packagePath = combinePaths(packagePath, subName);
                        }
                        const packageDirectory = combinePaths(ancestor, "node_modules", packagePath);
                        const packageFile = combinePaths(packageDirectory, "package.json");
                        if (tryFileExists(host, packageFile)) {
                            const packageJson = readJson(packageFile, host);
                            const exports = packageJson.exports;
                            if (exports) {
                                if (typeof exports !== "object" || exports === null) return;
                                const keys = getOwnKeys(exports);
                                const fragmentSubpath = components.join("/") + (components.length && hasTrailingDirectorySeparator(fragment) ? "/" : "");
                                const conditions = mode === 99 /* ESNext */  ? [
                                    "node",
                                    "import",
                                    "types"
                                ] : [
                                    "node",
                                    "require",
                                    "types"
                                ];
                                addCompletionEntriesFromPathsOrExports(result, fragmentSubpath, packageDirectory, extensionOptions, host, keys, (key)=>singleElementArray(getPatternFromFirstMatchingCondition(exports[key], conditions)), comparePatternKeys);
                                return;
                            }
                        }
                        return nodeModulesDirectoryLookup(ancestor);
                    };
                }
                forEachAncestorDirectory(scriptPath, ancestorLookup);
            }
        }
        return arrayFrom(result.values());
    }
    function getPatternFromFirstMatchingCondition(target, conditions) {
        if (typeof target === "string") return target;
        if (target && typeof target === "object" && !isArray(target)) {
            for(const condition in target)if (condition === "default" || conditions.indexOf(condition) > -1 || isApplicableVersionedTypesKey(conditions, condition)) {
                const pattern = target[condition];
                return getPatternFromFirstMatchingCondition(pattern, conditions);
            }
        }
    }
    function getFragmentDirectory(fragment) {
        return containsSlash(fragment) ? hasTrailingDirectorySeparator(fragment) ? fragment : getDirectoryPath(fragment) : void 0;
    }
    function getCompletionsForPathMapping(path, patterns, fragment, packageDirectory, extensionOptions, host) {
        if (!endsWith(path, "*")) return !stringContains(path, "*") ? justPathMappingName(path, "script" /* scriptElement */ ) : emptyArray;
        const pathPrefix = path.slice(0, path.length - 1);
        const remainingFragment = tryRemovePrefix(fragment, pathPrefix);
        if (remainingFragment === void 0) {
            const starIsFullPathComponent = path[path.length - 2] === "/";
            return starIsFullPathComponent ? justPathMappingName(pathPrefix, "directory" /* directory */ ) : flatMap(patterns, (pattern)=>{
                var _a;
                return (_a = getModulesForPathsPattern("", packageDirectory, pattern, extensionOptions, host)) == null ? void 0 : _a.map(({ name: name , ...rest })=>({
                        name: pathPrefix + name,
                        ...rest
                    }));
            });
        }
        return flatMap(patterns, (pattern)=>getModulesForPathsPattern(remainingFragment, packageDirectory, pattern, extensionOptions, host));
        function justPathMappingName(name, kind) {
            return startsWith(name, fragment) ? [
                {
                    name: removeTrailingDirectorySeparator(name),
                    kind: kind,
                    extension: void 0
                }
            ] : emptyArray;
        }
    }
    function getModulesForPathsPattern(fragment, packageDirectory, pattern, extensionOptions, host) {
        if (!host.readDirectory) return void 0;
        const parsed = tryParsePattern(pattern);
        if (parsed === void 0 || isString(parsed)) return void 0;
        const normalizedPrefix = resolvePath(parsed.prefix);
        const normalizedPrefixDirectory = hasTrailingDirectorySeparator(parsed.prefix) ? normalizedPrefix : getDirectoryPath(normalizedPrefix);
        const normalizedPrefixBase = hasTrailingDirectorySeparator(parsed.prefix) ? "" : getBaseFileName(normalizedPrefix);
        const fragmentHasPath = containsSlash(fragment);
        const fragmentDirectory = fragmentHasPath ? hasTrailingDirectorySeparator(fragment) ? fragment : getDirectoryPath(fragment) : void 0;
        const expandedPrefixDirectory = fragmentHasPath ? combinePaths(normalizedPrefixDirectory, normalizedPrefixBase + fragmentDirectory) : normalizedPrefixDirectory;
        const normalizedSuffix = normalizePath(parsed.suffix);
        const baseDirectory = normalizePath(combinePaths(packageDirectory, expandedPrefixDirectory));
        const completePrefix = fragmentHasPath ? baseDirectory : ensureTrailingDirectorySeparator(baseDirectory) + normalizedPrefixBase;
        const includeGlob = normalizedSuffix ? "**/*" + normalizedSuffix : "./*";
        const matches = mapDefined(tryReadDirectory(host, baseDirectory, extensionOptions.extensionsToSearch, /*exclude*/ void 0, [
            includeGlob
        ]), (match)=>{
            const trimmedWithPattern = trimPrefixAndSuffix(match);
            if (trimmedWithPattern) {
                if (containsSlash(trimmedWithPattern)) return directoryResult(getPathComponents(removeLeadingDirectorySeparator(trimmedWithPattern))[1]);
                const { name: name , extension: extension  } = getFilenameWithExtensionOption(trimmedWithPattern, host.getCompilationSettings(), extensionOptions);
                return nameAndKind(name, "script" /* scriptElement */ , extension);
            }
        });
        const directories = normalizedSuffix ? emptyArray : mapDefined(tryGetDirectories(host, baseDirectory), (dir)=>dir === "node_modules" ? void 0 : directoryResult(dir));
        return [
            ...matches,
            ...directories
        ];
        function trimPrefixAndSuffix(path) {
            const inner = withoutStartAndEnd(normalizePath(path), completePrefix, normalizedSuffix);
            return inner === void 0 ? void 0 : removeLeadingDirectorySeparator(inner);
        }
    }
    function withoutStartAndEnd(s, start, end) {
        return startsWith(s, start) && endsWith(s, end) ? s.slice(start.length, s.length - end.length) : void 0;
    }
    function removeLeadingDirectorySeparator(path) {
        return path[0] === directorySeparator ? path.slice(1) : path;
    }
    function getAmbientModuleCompletions(fragment, fragmentDirectory, checker) {
        const ambientModules = checker.getAmbientModules().map((sym)=>stripQuotes(sym.name));
        const nonRelativeModuleNames = ambientModules.filter((moduleName)=>startsWith(moduleName, fragment) && moduleName.indexOf("*") < 0);
        if (fragmentDirectory !== void 0) {
            const moduleNameWithSeparator = ensureTrailingDirectorySeparator(fragmentDirectory);
            return nonRelativeModuleNames.map((nonRelativeModuleName)=>removePrefix(nonRelativeModuleName, moduleNameWithSeparator));
        }
        return nonRelativeModuleNames;
    }
    function getTripleSlashReferenceCompletion(sourceFile, position, compilerOptions, host) {
        const token = getTokenAtPosition(sourceFile, position);
        const commentRanges = getLeadingCommentRanges(sourceFile.text, token.pos);
        const range = commentRanges && find(commentRanges, (commentRange)=>position >= commentRange.pos && position <= commentRange.end);
        if (!range) return void 0;
        const text = sourceFile.text.slice(range.pos, position);
        const match = tripleSlashDirectiveFragmentRegex.exec(text);
        if (!match) return void 0;
        const [, prefix, kind, toComplete] = match;
        const scriptPath = getDirectoryPath(sourceFile.path);
        const names = kind === "path" ? getCompletionEntriesForDirectoryFragment(toComplete, scriptPath, getExtensionOptions(compilerOptions, 0 /* Filename */ , sourceFile), host, /*moduleSpecifierIsRelative*/ true, sourceFile.path) : kind === "types" ? getCompletionEntriesFromTypings(host, compilerOptions, scriptPath, getFragmentDirectory(toComplete), getExtensionOptions(compilerOptions, 1 /* ModuleSpecifier */ , sourceFile)) : Debug.fail();
        return addReplacementSpans(toComplete, range.pos + prefix.length, arrayFrom(names.values()));
    }
    function getCompletionEntriesFromTypings(host, options, scriptPath, fragmentDirectory, extensionOptions, result = createNameAndKindSet()) {
        const seen = /* @__PURE__ */ new Map();
        const typeRoots = tryAndIgnoreErrors(()=>getEffectiveTypeRoots(options, host)) || emptyArray;
        for (const root of typeRoots)getCompletionEntriesFromDirectories(root);
        for (const packageJson of findPackageJsons(scriptPath, host)){
            const typesDir = combinePaths(getDirectoryPath(packageJson), "node_modules/@types");
            getCompletionEntriesFromDirectories(typesDir);
        }
        return result;
        function getCompletionEntriesFromDirectories(directory) {
            if (!tryDirectoryExists(host, directory)) return;
            for (const typeDirectoryName of tryGetDirectories(host, directory)){
                const packageName = unmangleScopedPackageName(typeDirectoryName);
                if (options.types && !contains(options.types, packageName)) continue;
                if (fragmentDirectory === void 0) {
                    if (!seen.has(packageName)) {
                        result.add(nameAndKind(packageName, "external module name" /* externalModuleName */ , /*extension*/ void 0));
                        seen.set(packageName, true);
                    }
                } else {
                    const baseDirectory = combinePaths(directory, typeDirectoryName);
                    const remainingFragment = tryRemoveDirectoryPrefix(fragmentDirectory, packageName, hostGetCanonicalFileName(host));
                    if (remainingFragment !== void 0) getCompletionEntriesForDirectoryFragment(remainingFragment, baseDirectory, extensionOptions, host, /*moduleSpecifierIsRelative*/ false, /*exclude*/ void 0, result);
                }
            }
        }
    }
    function enumerateNodeModulesVisibleToScript(host, scriptPath) {
        if (!host.readFile || !host.fileExists) return emptyArray;
        const result = [];
        for (const packageJson of findPackageJsons(scriptPath, host)){
            const contents = readJson(packageJson, host);
            for (const key of nodeModulesDependencyKeys){
                const dependencies = contents[key];
                if (!dependencies) continue;
                for(const dep in dependencies)if (hasProperty(dependencies, dep) && !startsWith(dep, "@types/")) result.push(dep);
            }
        }
        return result;
    }
    function getDirectoryFragmentTextSpan(text, textStart) {
        const index = Math.max(text.lastIndexOf(directorySeparator), text.lastIndexOf(altDirectorySeparator));
        const offset = index !== -1 ? index + 1 : 0;
        const length2 = text.length - offset;
        return length2 === 0 || isIdentifierText(text.substr(offset, length2), 99 /* ESNext */ ) ? void 0 : createTextSpan(textStart + offset, length2);
    }
    function isPathRelativeToScript(path) {
        if (path && path.length >= 2 && path.charCodeAt(0) === 46 /* dot */ ) {
            const slashIndex = path.length >= 3 && path.charCodeAt(1) === 46 /* dot */  ? 2 : 1;
            const slashCharCode = path.charCodeAt(slashIndex);
            return slashCharCode === 47 /* slash */  || slashCharCode === 92 /* backslash */ ;
        }
        return false;
    }
    function containsSlash(fragment) {
        return stringContains(fragment, directorySeparator);
    }
    function isRequireCallArgument(node) {
        return isCallExpression(node.parent) && firstOrUndefined(node.parent.arguments) === node && isIdentifier(node.parent.expression) && node.parent.expression.escapedText === "require";
    }
    var kindPrecedence, tripleSlashDirectiveFragmentRegex, nodeModulesDependencyKeys;
    var init_stringCompletions = __esm({
        "src/services/stringCompletions.ts" () {
            "use strict";
            init_ts4();
            init_ts_Completions();
            kindPrecedence = {
                ["directory" /* directory */ ]: 0,
                ["script" /* scriptElement */ ]: 1,
                ["external module name" /* externalModuleName */ ]: 2
            };
            tripleSlashDirectiveFragmentRegex = /^(\/\/\/\s*<reference\s+(path|types)\s*=\s*(?:'|"))([^\3"]*)$/;
            nodeModulesDependencyKeys = [
                "dependencies",
                "devDependencies",
                "peerDependencies",
                "optionalDependencies"
            ];
        }
    });
    // src/services/_namespaces/ts.Completions.StringCompletions.ts
    var ts_Completions_StringCompletions_exports = {};
    __export(ts_Completions_StringCompletions_exports, {
        getStringLiteralCompletionDetails: ()=>getStringLiteralCompletionDetails,
        getStringLiteralCompletions: ()=>getStringLiteralCompletions
    });
    var init_ts_Completions_StringCompletions = __esm({
        "src/services/_namespaces/ts.Completions.StringCompletions.ts" () {
            "use strict";
            init_stringCompletions();
        }
    });
    // src/services/_namespaces/ts.Completions.ts
    var ts_Completions_exports = {};
    __export(ts_Completions_exports, {
        CompletionKind: ()=>CompletionKind,
        CompletionSource: ()=>CompletionSource,
        SortText: ()=>SortText,
        StringCompletions: ()=>ts_Completions_StringCompletions_exports,
        SymbolOriginInfoKind: ()=>SymbolOriginInfoKind,
        createCompletionDetails: ()=>createCompletionDetails,
        createCompletionDetailsForSymbol: ()=>createCompletionDetailsForSymbol,
        getCompletionEntriesFromSymbols: ()=>getCompletionEntriesFromSymbols,
        getCompletionEntryDetails: ()=>getCompletionEntryDetails,
        getCompletionEntrySymbol: ()=>getCompletionEntrySymbol,
        getCompletionsAtPosition: ()=>getCompletionsAtPosition,
        getPropertiesForObjectExpression: ()=>getPropertiesForObjectExpression,
        moduleSpecifierResolutionCacheAttemptLimit: ()=>moduleSpecifierResolutionCacheAttemptLimit,
        moduleSpecifierResolutionLimit: ()=>moduleSpecifierResolutionLimit
    });
    var init_ts_Completions = __esm({
        "src/services/_namespaces/ts.Completions.ts" () {
            "use strict";
            init_completions();
            init_ts_Completions_StringCompletions();
        }
    });
    // src/services/importTracker.ts
    function createImportTracker(sourceFiles, sourceFilesSet, checker, cancellationToken) {
        const allDirectImports = getDirectImportsMap(sourceFiles, checker, cancellationToken);
        return (exportSymbol, exportInfo, isForRename)=>{
            const { directImports: directImports , indirectUsers: indirectUsers  } = getImportersForExport(sourceFiles, sourceFilesSet, allDirectImports, exportInfo, checker, cancellationToken);
            return {
                indirectUsers: indirectUsers,
                ...getSearchesFromDirectImports(directImports, exportSymbol, exportInfo.exportKind, checker, isForRename)
            };
        };
    }
    function getImportersForExport(sourceFiles, sourceFilesSet, allDirectImports, { exportingModuleSymbol: exportingModuleSymbol , exportKind: exportKind  }, checker, cancellationToken) {
        const markSeenDirectImport = nodeSeenTracker();
        const markSeenIndirectUser = nodeSeenTracker();
        const directImports = [];
        const isAvailableThroughGlobal = !!exportingModuleSymbol.globalExports;
        const indirectUserDeclarations = isAvailableThroughGlobal ? void 0 : [];
        handleDirectImports(exportingModuleSymbol);
        return {
            directImports: directImports,
            indirectUsers: getIndirectUsers()
        };
        function getIndirectUsers() {
            if (isAvailableThroughGlobal) return sourceFiles;
            if (exportingModuleSymbol.declarations) {
                for (const decl of exportingModuleSymbol.declarations)if (isExternalModuleAugmentation(decl) && sourceFilesSet.has(decl.getSourceFile().fileName)) addIndirectUser(decl);
            }
            return indirectUserDeclarations.map(getSourceFileOfNode);
        }
        function handleDirectImports(exportingModuleSymbol2) {
            const theseDirectImports = getDirectImports(exportingModuleSymbol2);
            if (theseDirectImports) for (const direct of theseDirectImports){
                if (!markSeenDirectImport(direct)) continue;
                if (cancellationToken) cancellationToken.throwIfCancellationRequested();
                switch(direct.kind){
                    case 212 /* CallExpression */ :
                        if (isImportCall(direct)) {
                            handleImportCall(direct);
                            break;
                        }
                        if (!isAvailableThroughGlobal) {
                            const parent2 = direct.parent;
                            if (exportKind === 2 /* ExportEquals */  && parent2.kind === 259 /* VariableDeclaration */ ) {
                                const { name: name  } = parent2;
                                if (name.kind === 80 /* Identifier */ ) {
                                    directImports.push(name);
                                    break;
                                }
                            }
                        }
                        break;
                    case 80 /* Identifier */ :
                        break;
                    case 270 /* ImportEqualsDeclaration */ :
                        handleNamespaceImport(direct, direct.name, hasSyntacticModifier(direct, 1 /* Export */ ), /*alreadyAddedDirect*/ false);
                        break;
                    case 271 /* ImportDeclaration */ :
                        directImports.push(direct);
                        const namedBindings = direct.importClause && direct.importClause.namedBindings;
                        if (namedBindings && namedBindings.kind === 273 /* NamespaceImport */ ) handleNamespaceImport(direct, namedBindings.name, /*isReExport*/ false, /*alreadyAddedDirect*/ true);
                        else if (!isAvailableThroughGlobal && isDefaultImport(direct)) addIndirectUser(getSourceFileLikeForImportDeclaration(direct));
                        break;
                    case 277 /* ExportDeclaration */ :
                        if (!direct.exportClause) handleDirectImports(getContainingModuleSymbol(direct, checker));
                        else if (direct.exportClause.kind === 279 /* NamespaceExport */ ) addIndirectUser(getSourceFileLikeForImportDeclaration(direct), /*addTransitiveDependencies*/ true);
                        else directImports.push(direct);
                        break;
                    case 204 /* ImportType */ :
                        if (!isAvailableThroughGlobal && direct.isTypeOf && !direct.qualifier && isExported2(direct)) addIndirectUser(direct.getSourceFile(), /*addTransitiveDependencies*/ true);
                        directImports.push(direct);
                        break;
                    default:
                        Debug.failBadSyntaxKind(direct, "Unexpected import kind.");
                }
            }
        }
        function handleImportCall(importCall) {
            const top = findAncestor(importCall, isAmbientModuleDeclaration) || importCall.getSourceFile();
            addIndirectUser(top, /** addTransitiveDependencies */ !!isExported2(importCall, /*stopAtAmbientModule*/ true));
        }
        function isExported2(node, stopAtAmbientModule = false) {
            return findAncestor(node, (node2)=>{
                if (stopAtAmbientModule && isAmbientModuleDeclaration(node2)) return "quit";
                return canHaveModifiers(node2) && some(node2.modifiers, isExportModifier);
            });
        }
        function handleNamespaceImport(importDeclaration, name, isReExport, alreadyAddedDirect) {
            if (exportKind === 2 /* ExportEquals */ ) {
                if (!alreadyAddedDirect) directImports.push(importDeclaration);
            } else if (!isAvailableThroughGlobal) {
                const sourceFileLike = getSourceFileLikeForImportDeclaration(importDeclaration);
                Debug.assert(sourceFileLike.kind === 311 /* SourceFile */  || sourceFileLike.kind === 266 /* ModuleDeclaration */ );
                if (isReExport || findNamespaceReExports(sourceFileLike, name, checker)) addIndirectUser(sourceFileLike, /*addTransitiveDependencies*/ true);
                else addIndirectUser(sourceFileLike);
            }
        }
        function addIndirectUser(sourceFileLike, addTransitiveDependencies = false) {
            Debug.assert(!isAvailableThroughGlobal);
            const isNew = markSeenIndirectUser(sourceFileLike);
            if (!isNew) return;
            indirectUserDeclarations.push(sourceFileLike);
            if (!addTransitiveDependencies) return;
            const moduleSymbol = checker.getMergedSymbol(sourceFileLike.symbol);
            if (!moduleSymbol) return;
            Debug.assert(!!(moduleSymbol.flags & 1536 /* Module */ ));
            const directImports2 = getDirectImports(moduleSymbol);
            if (directImports2) {
                for (const directImport of directImports2)if (!isImportTypeNode(directImport)) addIndirectUser(getSourceFileLikeForImportDeclaration(directImport), /*addTransitiveDependencies*/ true);
            }
        }
        function getDirectImports(moduleSymbol) {
            return allDirectImports.get(getSymbolId(moduleSymbol).toString());
        }
    }
    function getSearchesFromDirectImports(directImports, exportSymbol, exportKind, checker, isForRename) {
        const importSearches = [];
        const singleReferences = [];
        function addSearch(location, symbol) {
            importSearches.push([
                location,
                symbol
            ]);
        }
        if (directImports) for (const decl of directImports)handleImport(decl);
        return {
            importSearches: importSearches,
            singleReferences: singleReferences
        };
        function handleImport(decl) {
            if (decl.kind === 270 /* ImportEqualsDeclaration */ ) {
                if (isExternalModuleImportEquals(decl)) handleNamespaceImportLike(decl.name);
                return;
            }
            if (decl.kind === 80 /* Identifier */ ) {
                handleNamespaceImportLike(decl);
                return;
            }
            if (decl.kind === 204 /* ImportType */ ) {
                if (decl.qualifier) {
                    const firstIdentifier = getFirstIdentifier(decl.qualifier);
                    if (firstIdentifier.escapedText === symbolName(exportSymbol)) singleReferences.push(firstIdentifier);
                } else if (exportKind === 2 /* ExportEquals */ ) singleReferences.push(decl.argument.literal);
                return;
            }
            if (decl.moduleSpecifier.kind !== 11 /* StringLiteral */ ) return;
            if (decl.kind === 277 /* ExportDeclaration */ ) {
                if (decl.exportClause && isNamedExports(decl.exportClause)) searchForNamedImport(decl.exportClause);
                return;
            }
            const { name: name , namedBindings: namedBindings  } = decl.importClause || {
                name: void 0,
                namedBindings: void 0
            };
            if (namedBindings) switch(namedBindings.kind){
                case 273 /* NamespaceImport */ :
                    handleNamespaceImportLike(namedBindings.name);
                    break;
                case 274 /* NamedImports */ :
                    if (exportKind === 0 /* Named */  || exportKind === 1 /* Default */ ) searchForNamedImport(namedBindings);
                    break;
                default:
                    Debug.assertNever(namedBindings);
            }
            if (name && (exportKind === 1 /* Default */  || exportKind === 2 /* ExportEquals */ ) && (!isForRename || name.escapedText === symbolEscapedNameNoDefault(exportSymbol))) {
                const defaultImportAlias = checker.getSymbolAtLocation(name);
                addSearch(name, defaultImportAlias);
            }
        }
        function handleNamespaceImportLike(importName) {
            if (exportKind === 2 /* ExportEquals */  && (!isForRename || isNameMatch(importName.escapedText))) addSearch(importName, checker.getSymbolAtLocation(importName));
        }
        function searchForNamedImport(namedBindings) {
            if (!namedBindings) return;
            for (const element of namedBindings.elements){
                const { name: name , propertyName: propertyName  } = element;
                if (!isNameMatch((propertyName || name).escapedText)) continue;
                if (propertyName) {
                    singleReferences.push(propertyName);
                    if (!isForRename || name.escapedText === exportSymbol.escapedName) addSearch(name, checker.getSymbolAtLocation(name));
                } else {
                    const localSymbol = element.kind === 280 /* ExportSpecifier */  && element.propertyName ? checker.getExportSpecifierLocalTargetSymbol(element) : checker.getSymbolAtLocation(name);
                    addSearch(name, localSymbol);
                }
            }
        }
        function isNameMatch(name) {
            return name === exportSymbol.escapedName || exportKind !== 0 /* Named */  && name === "default" /* Default */ ;
        }
    }
    function findNamespaceReExports(sourceFileLike, name, checker) {
        const namespaceImportSymbol = checker.getSymbolAtLocation(name);
        return !!forEachPossibleImportOrExportStatement(sourceFileLike, (statement)=>{
            if (!isExportDeclaration(statement)) return;
            const { exportClause: exportClause , moduleSpecifier: moduleSpecifier  } = statement;
            return !moduleSpecifier && exportClause && isNamedExports(exportClause) && exportClause.elements.some((element)=>checker.getExportSpecifierLocalTargetSymbol(element) === namespaceImportSymbol);
        });
    }
    function findModuleReferences(program, sourceFiles, searchModuleSymbol) {
        var _a;
        const refs = [];
        const checker = program.getTypeChecker();
        for (const referencingFile of sourceFiles){
            const searchSourceFile = searchModuleSymbol.valueDeclaration;
            if ((searchSourceFile == null ? void 0 : searchSourceFile.kind) === 311 /* SourceFile */ ) {
                for (const ref of referencingFile.referencedFiles)if (program.getSourceFileFromReference(referencingFile, ref) === searchSourceFile) refs.push({
                    kind: "reference",
                    referencingFile: referencingFile,
                    ref: ref
                });
                for (const ref of referencingFile.typeReferenceDirectives){
                    const referenced = (_a = program.getResolvedTypeReferenceDirectives().get(ref.fileName, ref.resolutionMode || referencingFile.impliedNodeFormat)) == null ? void 0 : _a.resolvedTypeReferenceDirective;
                    if (referenced !== void 0 && referenced.resolvedFileName === searchSourceFile.fileName) refs.push({
                        kind: "reference",
                        referencingFile: referencingFile,
                        ref: ref
                    });
                }
            }
            forEachImport(referencingFile, (importDecl, moduleSpecifier)=>{
                const moduleSymbol = checker.getSymbolAtLocation(moduleSpecifier);
                if (moduleSymbol === searchModuleSymbol) refs.push(nodeIsSynthesized(importDecl) ? {
                    kind: "implicit",
                    literal: moduleSpecifier,
                    referencingFile: referencingFile
                } : {
                    kind: "import",
                    literal: moduleSpecifier
                });
            });
        }
        return refs;
    }
    function getDirectImportsMap(sourceFiles, checker, cancellationToken) {
        const map2 = /* @__PURE__ */ new Map();
        for (const sourceFile of sourceFiles){
            if (cancellationToken) cancellationToken.throwIfCancellationRequested();
            forEachImport(sourceFile, (importDecl, moduleSpecifier)=>{
                const moduleSymbol = checker.getSymbolAtLocation(moduleSpecifier);
                if (moduleSymbol) {
                    const id = getSymbolId(moduleSymbol).toString();
                    let imports = map2.get(id);
                    if (!imports) map2.set(id, imports = []);
                    imports.push(importDecl);
                }
            });
        }
        return map2;
    }
    function forEachPossibleImportOrExportStatement(sourceFileLike, action) {
        return forEach(sourceFileLike.kind === 311 /* SourceFile */  ? sourceFileLike.statements : sourceFileLike.body.statements, (statement)=>// TODO: GH#18217
            action(statement) || isAmbientModuleDeclaration(statement) && forEach(statement.body && statement.body.statements, action));
    }
    function forEachImport(sourceFile, action) {
        if (sourceFile.externalModuleIndicator || sourceFile.imports !== void 0) for (const i of sourceFile.imports)action(importFromModuleSpecifier(i), i);
        else forEachPossibleImportOrExportStatement(sourceFile, (statement)=>{
            switch(statement.kind){
                case 277 /* ExportDeclaration */ :
                case 271 /* ImportDeclaration */ :
                    {
                        const decl = statement;
                        if (decl.moduleSpecifier && isStringLiteral(decl.moduleSpecifier)) action(decl, decl.moduleSpecifier);
                        break;
                    }
                case 270 /* ImportEqualsDeclaration */ :
                    {
                        const decl = statement;
                        if (isExternalModuleImportEquals(decl)) action(decl, decl.moduleReference.expression);
                        break;
                    }
            }
        });
    }
    function getImportOrExportSymbol(node, symbol, checker, comingFromExport) {
        return comingFromExport ? getExport() : getExport() || getImport();
        function getExport() {
            var _a;
            const { parent: parent2  } = node;
            const grandparent = parent2.parent;
            if (symbol.exportSymbol) {
                if (parent2.kind === 210 /* PropertyAccessExpression */ ) return ((_a = symbol.declarations) == null ? void 0 : _a.some((d)=>d === parent2)) && isBinaryExpression(grandparent) ? getSpecialPropertyExport(grandparent, /*useLhsSymbol*/ false) : void 0;
                else return exportInfo(symbol.exportSymbol, getExportKindForDeclaration(parent2));
            } else {
                const exportNode = getExportNode(parent2, node);
                if (exportNode && hasSyntacticModifier(exportNode, 1 /* Export */ )) {
                    if (isImportEqualsDeclaration(exportNode) && exportNode.moduleReference === node) {
                        if (comingFromExport) return void 0;
                        const lhsSymbol = checker.getSymbolAtLocation(exportNode.name);
                        return {
                            kind: 0 /* Import */ ,
                            symbol: lhsSymbol
                        };
                    } else return exportInfo(symbol, getExportKindForDeclaration(exportNode));
                } else if (isNamespaceExport(parent2)) return exportInfo(symbol, 0 /* Named */ );
                else if (isExportAssignment(parent2)) return getExportAssignmentExport(parent2);
                else if (isExportAssignment(grandparent)) return getExportAssignmentExport(grandparent);
                else if (isBinaryExpression(parent2)) return getSpecialPropertyExport(parent2, /*useLhsSymbol*/ true);
                else if (isBinaryExpression(grandparent)) return getSpecialPropertyExport(grandparent, /*useLhsSymbol*/ true);
                else if (isJSDocTypedefTag(parent2) || isJSDocCallbackTag(parent2)) return exportInfo(symbol, 0 /* Named */ );
            }
            function getExportAssignmentExport(ex) {
                if (!ex.symbol.parent) return void 0;
                const exportKind = ex.isExportEquals ? 2 /* ExportEquals */  : 1 /* Default */ ;
                return {
                    kind: 1 /* Export */ ,
                    symbol: symbol,
                    exportInfo: {
                        exportingModuleSymbol: ex.symbol.parent,
                        exportKind: exportKind
                    }
                };
            }
            function getSpecialPropertyExport(node2, useLhsSymbol) {
                let kind;
                switch(getAssignmentDeclarationKind(node2)){
                    case 1 /* ExportsProperty */ :
                        kind = 0 /* Named */ ;
                        break;
                    case 2 /* ModuleExports */ :
                        kind = 2 /* ExportEquals */ ;
                        break;
                    default:
                        return void 0;
                }
                const sym = useLhsSymbol ? checker.getSymbolAtLocation(getNameOfAccessExpression(cast(node2.left, isAccessExpression))) : symbol;
                return sym && exportInfo(sym, kind);
            }
        }
        function getImport() {
            const isImport3 = isNodeImport(node);
            if (!isImport3) return void 0;
            let importedSymbol = checker.getImmediateAliasedSymbol(symbol);
            if (!importedSymbol) return void 0;
            importedSymbol = skipExportSpecifierSymbol(importedSymbol, checker);
            if (importedSymbol.escapedName === "export=") {
                importedSymbol = getExportEqualsLocalSymbol(importedSymbol, checker);
                if (importedSymbol === void 0) return void 0;
            }
            const importedName = symbolEscapedNameNoDefault(importedSymbol);
            if (importedName === void 0 || importedName === "default" /* Default */  || importedName === symbol.escapedName) return {
                kind: 0 /* Import */ ,
                symbol: importedSymbol
            };
        }
        function exportInfo(symbol2, kind) {
            const exportInfo2 = getExportInfo(symbol2, kind, checker);
            return exportInfo2 && {
                kind: 1 /* Export */ ,
                symbol: symbol2,
                exportInfo: exportInfo2
            };
        }
        function getExportKindForDeclaration(node2) {
            return hasSyntacticModifier(node2, 1024 /* Default */ ) ? 1 /* Default */  : 0 /* Named */ ;
        }
    }
    function getExportEqualsLocalSymbol(importedSymbol, checker) {
        var _a, _b;
        if (importedSymbol.flags & 2097152 /* Alias */ ) return checker.getImmediateAliasedSymbol(importedSymbol);
        const decl = Debug.checkDefined(importedSymbol.valueDeclaration);
        if (isExportAssignment(decl)) return (_a = tryCast(decl.expression, canHaveSymbol)) == null ? void 0 : _a.symbol;
        else if (isBinaryExpression(decl)) return (_b = tryCast(decl.right, canHaveSymbol)) == null ? void 0 : _b.symbol;
        else if (isSourceFile(decl)) return decl.symbol;
        return void 0;
    }
    function getExportNode(parent2, node) {
        const declaration = isVariableDeclaration(parent2) ? parent2 : isBindingElement(parent2) ? walkUpBindingElementsAndPatterns(parent2) : void 0;
        if (declaration) return parent2.name !== node ? void 0 : isCatchClause(declaration.parent) ? void 0 : isVariableStatement(declaration.parent.parent) ? declaration.parent.parent : void 0;
        else return parent2;
    }
    function isNodeImport(node) {
        const { parent: parent2  } = node;
        switch(parent2.kind){
            case 270 /* ImportEqualsDeclaration */ :
                return parent2.name === node && isExternalModuleImportEquals(parent2);
            case 275 /* ImportSpecifier */ :
                return !parent2.propertyName;
            case 272 /* ImportClause */ :
            case 273 /* NamespaceImport */ :
                Debug.assert(parent2.name === node);
                return true;
            case 207 /* BindingElement */ :
                return isInJSFile(node) && isVariableDeclarationInitializedToBareOrAccessedRequire(parent2.parent.parent);
            default:
                return false;
        }
    }
    function getExportInfo(exportSymbol, exportKind, checker) {
        const moduleSymbol = exportSymbol.parent;
        if (!moduleSymbol) return void 0;
        const exportingModuleSymbol = checker.getMergedSymbol(moduleSymbol);
        return isExternalModuleSymbol(exportingModuleSymbol) ? {
            exportingModuleSymbol: exportingModuleSymbol,
            exportKind: exportKind
        } : void 0;
    }
    function skipExportSpecifierSymbol(symbol, checker) {
        if (symbol.declarations) for (const declaration of symbol.declarations){
            if (isExportSpecifier(declaration) && !declaration.propertyName && !declaration.parent.parent.moduleSpecifier) return checker.getExportSpecifierLocalTargetSymbol(declaration) || symbol;
            else if (isPropertyAccessExpression(declaration) && isModuleExportsAccessExpression(declaration.expression) && !isPrivateIdentifier(declaration.name)) return checker.getSymbolAtLocation(declaration);
            else if (isShorthandPropertyAssignment(declaration) && isBinaryExpression(declaration.parent.parent) && getAssignmentDeclarationKind(declaration.parent.parent) === 2 /* ModuleExports */ ) return checker.getExportSpecifierLocalTargetSymbol(declaration.name);
        }
        return symbol;
    }
    function getContainingModuleSymbol(importer, checker) {
        return checker.getMergedSymbol(getSourceFileLikeForImportDeclaration(importer).symbol);
    }
    function getSourceFileLikeForImportDeclaration(node) {
        if (node.kind === 212 /* CallExpression */ ) return node.getSourceFile();
        const { parent: parent2  } = node;
        if (parent2.kind === 311 /* SourceFile */ ) return parent2;
        Debug.assert(parent2.kind === 267 /* ModuleBlock */ );
        return cast(parent2.parent, isAmbientModuleDeclaration);
    }
    function isAmbientModuleDeclaration(node) {
        return node.kind === 266 /* ModuleDeclaration */  && node.name.kind === 11 /* StringLiteral */ ;
    }
    function isExternalModuleImportEquals(eq) {
        return eq.moduleReference.kind === 282 /* ExternalModuleReference */  && eq.moduleReference.expression.kind === 11 /* StringLiteral */ ;
    }
    var ExportKind2, ImportExport;
    var init_importTracker = __esm({
        "src/services/importTracker.ts" () {
            "use strict";
            init_ts4();
            ExportKind2 = /* @__PURE__ */ ((ExportKind3)=>{
                ExportKind3[ExportKind3["Named"] = 0] = "Named";
                ExportKind3[ExportKind3["Default"] = 1] = "Default";
                ExportKind3[ExportKind3["ExportEquals"] = 2] = "ExportEquals";
                return ExportKind3;
            })(ExportKind2 || {});
            ImportExport = /* @__PURE__ */ ((ImportExport2)=>{
                ImportExport2[ImportExport2["Import"] = 0] = "Import";
                ImportExport2[ImportExport2["Export"] = 1] = "Export";
                return ImportExport2;
            })(ImportExport || {});
        }
    });
    // src/services/findAllReferences.ts
    function nodeEntry(node, kind = 1 /* Node */ ) {
        return {
            kind: kind,
            node: node.name || node,
            context: getContextNodeForNodeEntry(node)
        };
    }
    function isContextWithStartAndEndNode(node) {
        return node && node.kind === void 0;
    }
    function getContextNodeForNodeEntry(node) {
        if (isDeclaration(node)) return getContextNode(node);
        if (!node.parent) return void 0;
        if (!isDeclaration(node.parent) && !isExportAssignment(node.parent)) {
            if (isInJSFile(node)) {
                const binaryExpression = isBinaryExpression(node.parent) ? node.parent : isAccessExpression(node.parent) && isBinaryExpression(node.parent.parent) && node.parent.parent.left === node.parent ? node.parent.parent : void 0;
                if (binaryExpression && getAssignmentDeclarationKind(binaryExpression) !== 0 /* None */ ) return getContextNode(binaryExpression);
            }
            if (isJsxOpeningElement(node.parent) || isJsxClosingElement(node.parent)) return node.parent.parent;
            else if (isJsxSelfClosingElement(node.parent) || isLabeledStatement(node.parent) || isBreakOrContinueStatement(node.parent)) return node.parent;
            else if (isStringLiteralLike(node)) {
                const validImport = tryGetImportFromModuleSpecifier(node);
                if (validImport) {
                    const declOrStatement = findAncestor(validImport, (node2)=>isDeclaration(node2) || isStatement(node2) || isJSDocTag(node2));
                    return isDeclaration(declOrStatement) ? getContextNode(declOrStatement) : declOrStatement;
                }
            }
            const propertyName = findAncestor(node, isComputedPropertyName);
            return propertyName ? getContextNode(propertyName.parent) : void 0;
        }
        if (node.parent.name === node || // node is name of declaration, use parent
        isConstructorDeclaration(node.parent) || isExportAssignment(node.parent) || // Property name of the import export specifier or binding pattern, use parent
        (isImportOrExportSpecifier(node.parent) || isBindingElement(node.parent)) && node.parent.propertyName === node || // Is default export
        node.kind === 90 /* DefaultKeyword */  && hasSyntacticModifier(node.parent, 1025 /* ExportDefault */ )) return getContextNode(node.parent);
        return void 0;
    }
    function getContextNode(node) {
        if (!node) return void 0;
        switch(node.kind){
            case 259 /* VariableDeclaration */ :
                return !isVariableDeclarationList(node.parent) || node.parent.declarations.length !== 1 ? node : isVariableStatement(node.parent.parent) ? node.parent.parent : isForInOrOfStatement(node.parent.parent) ? getContextNode(node.parent.parent) : node.parent;
            case 207 /* BindingElement */ :
                return getContextNode(node.parent.parent);
            case 275 /* ImportSpecifier */ :
                return node.parent.parent.parent;
            case 280 /* ExportSpecifier */ :
            case 273 /* NamespaceImport */ :
                return node.parent.parent;
            case 272 /* ImportClause */ :
            case 279 /* NamespaceExport */ :
                return node.parent;
            case 225 /* BinaryExpression */ :
                return isExpressionStatement(node.parent) ? node.parent : node;
            case 249 /* ForOfStatement */ :
            case 248 /* ForInStatement */ :
                return {
                    start: node.initializer,
                    end: node.expression
                };
            case 302 /* PropertyAssignment */ :
            case 303 /* ShorthandPropertyAssignment */ :
                return isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent) ? getContextNode(findAncestor(node.parent, (node2)=>isBinaryExpression(node2) || isForInOrOfStatement(node2))) : node;
            default:
                return node;
        }
    }
    function toContextSpan(textSpan, sourceFile, context) {
        if (!context) return void 0;
        const contextSpan = isContextWithStartAndEndNode(context) ? getTextSpan(context.start, sourceFile, context.end) : getTextSpan(context, sourceFile);
        return contextSpan.start !== textSpan.start || contextSpan.length !== textSpan.length ? {
            contextSpan: contextSpan
        } : void 0;
    }
    function findReferencedSymbols(program, cancellationToken, sourceFiles, sourceFile, position) {
        const node = getTouchingPropertyName(sourceFile, position);
        const options = {
            use: 1 /* References */ 
        };
        const referencedSymbols = Core.getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options);
        const checker = program.getTypeChecker();
        const adjustedNode = Core.getAdjustedNode(node, options);
        const symbol = isDefinitionForReference(adjustedNode) ? checker.getSymbolAtLocation(adjustedNode) : void 0;
        return !referencedSymbols || !referencedSymbols.length ? void 0 : mapDefined(referencedSymbols, ({ definition: definition , references: references  })=>// Only include referenced symbols that have a valid definition.
            definition && {
                definition: checker.runWithCancellationToken(cancellationToken, (checker2)=>definitionToReferencedSymbolDefinitionInfo(definition, checker2, node)),
                references: references.map((r)=>toReferencedSymbolEntry(r, symbol))
            });
    }
    function isDefinitionForReference(node) {
        return node.kind === 90 /* DefaultKeyword */  || !!getDeclarationFromName(node) || isLiteralComputedPropertyDeclarationName(node) || node.kind === 137 /* ConstructorKeyword */  && isConstructorDeclaration(node.parent);
    }
    function getImplementationsAtPosition(program, cancellationToken, sourceFiles, sourceFile, position) {
        const node = getTouchingPropertyName(sourceFile, position);
        let referenceEntries;
        const entries = getImplementationReferenceEntries(program, cancellationToken, sourceFiles, node, position);
        if (node.parent.kind === 210 /* PropertyAccessExpression */  || node.parent.kind === 207 /* BindingElement */  || node.parent.kind === 211 /* ElementAccessExpression */  || node.kind === 108 /* SuperKeyword */ ) referenceEntries = entries && [
            ...entries
        ];
        else if (entries) {
            const queue = createQueue(entries);
            const seenNodes = /* @__PURE__ */ new Map();
            while(!queue.isEmpty()){
                const entry = queue.dequeue();
                if (!addToSeen(seenNodes, getNodeId(entry.node))) continue;
                referenceEntries = append(referenceEntries, entry);
                const entries2 = getImplementationReferenceEntries(program, cancellationToken, sourceFiles, entry.node, entry.node.pos);
                if (entries2) queue.enqueue(...entries2);
            }
        }
        const checker = program.getTypeChecker();
        return map(referenceEntries, (entry)=>toImplementationLocation(entry, checker));
    }
    function getImplementationReferenceEntries(program, cancellationToken, sourceFiles, node, position) {
        if (node.kind === 311 /* SourceFile */ ) return void 0;
        const checker = program.getTypeChecker();
        if (node.parent.kind === 303 /* ShorthandPropertyAssignment */ ) {
            const result = [];
            Core.getReferenceEntriesForShorthandPropertyAssignment(node, checker, (node2)=>result.push(nodeEntry(node2)));
            return result;
        } else if (node.kind === 108 /* SuperKeyword */  || isSuperProperty(node.parent)) {
            const symbol = checker.getSymbolAtLocation(node);
            return symbol.valueDeclaration && [
                nodeEntry(symbol.valueDeclaration)
            ];
        } else return getReferenceEntriesForNode(position, node, program, sourceFiles, cancellationToken, {
            implementations: true,
            use: 1 /* References */ 
        });
    }
    function findReferenceOrRenameEntries(program, cancellationToken, sourceFiles, node, position, options, convertEntry) {
        return map(flattenEntries(Core.getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options)), (entry)=>convertEntry(entry, node, program.getTypeChecker()));
    }
    function getReferenceEntriesForNode(position, node, program, sourceFiles, cancellationToken, options = {}, sourceFilesSet = new Set(sourceFiles.map((f)=>f.fileName))) {
        return flattenEntries(Core.getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options, sourceFilesSet));
    }
    function flattenEntries(referenceSymbols) {
        return referenceSymbols && flatMap(referenceSymbols, (r)=>r.references);
    }
    function definitionToReferencedSymbolDefinitionInfo(def, checker, originalNode) {
        const info = (()=>{
            switch(def.type){
                case 0 /* Symbol */ :
                    {
                        const { symbol: symbol  } = def;
                        const { displayParts: displayParts2 , kind: kind2  } = getDefinitionKindAndDisplayParts(symbol, checker, originalNode);
                        const name2 = displayParts2.map((p)=>p.text).join("");
                        const declaration = symbol.declarations && firstOrUndefined(symbol.declarations);
                        const node = declaration ? getNameOfDeclaration(declaration) || declaration : originalNode;
                        return {
                            ...getFileAndTextSpanFromNode(node),
                            name: name2,
                            kind: kind2,
                            displayParts: displayParts2,
                            context: getContextNode(declaration)
                        };
                    }
                case 1 /* Label */ :
                    {
                        const { node: node  } = def;
                        return {
                            ...getFileAndTextSpanFromNode(node),
                            name: node.text,
                            kind: "label" /* label */ ,
                            displayParts: [
                                displayPart(node.text, 17 /* text */ )
                            ]
                        };
                    }
                case 2 /* Keyword */ :
                    {
                        const { node: node  } = def;
                        const name2 = tokenToString(node.kind);
                        return {
                            ...getFileAndTextSpanFromNode(node),
                            name: name2,
                            kind: "keyword" /* keyword */ ,
                            displayParts: [
                                {
                                    text: name2,
                                    kind: "keyword" /* keyword */ 
                                }
                            ]
                        };
                    }
                case 3 /* This */ :
                    {
                        const { node: node  } = def;
                        const symbol = checker.getSymbolAtLocation(node);
                        const displayParts2 = symbol && ts_SymbolDisplay_exports.getSymbolDisplayPartsDocumentationAndSymbolKind(checker, symbol, node.getSourceFile(), getContainerNode(node), node).displayParts || [
                            textPart("this")
                        ];
                        return {
                            ...getFileAndTextSpanFromNode(node),
                            name: "this",
                            kind: "var" /* variableElement */ ,
                            displayParts: displayParts2
                        };
                    }
                case 4 /* String */ :
                    {
                        const { node: node  } = def;
                        return {
                            ...getFileAndTextSpanFromNode(node),
                            name: node.text,
                            kind: "var" /* variableElement */ ,
                            displayParts: [
                                displayPart(getTextOfNode(node), 8 /* stringLiteral */ )
                            ]
                        };
                    }
                case 5 /* TripleSlashReference */ :
                    return {
                        textSpan: createTextSpanFromRange(def.reference),
                        sourceFile: def.file,
                        name: def.reference.fileName,
                        kind: "string" /* string */ ,
                        displayParts: [
                            displayPart(`"${def.reference.fileName}"`, 8 /* stringLiteral */ )
                        ]
                    };
                default:
                    return Debug.assertNever(def);
            }
        })();
        const { sourceFile: sourceFile , textSpan: textSpan , name: name , kind: kind , displayParts: displayParts , context: context  } = info;
        return {
            containerKind: "" /* unknown */ ,
            containerName: "",
            fileName: sourceFile.fileName,
            kind: kind,
            name: name,
            textSpan: textSpan,
            displayParts: displayParts,
            ...toContextSpan(textSpan, sourceFile, context)
        };
    }
    function getFileAndTextSpanFromNode(node) {
        const sourceFile = node.getSourceFile();
        return {
            sourceFile: sourceFile,
            textSpan: getTextSpan(isComputedPropertyName(node) ? node.expression : node, sourceFile)
        };
    }
    function getDefinitionKindAndDisplayParts(symbol, checker, node) {
        const meaning = Core.getIntersectingMeaningFromDeclarations(node, symbol);
        const enclosingDeclaration = symbol.declarations && firstOrUndefined(symbol.declarations) || node;
        const { displayParts: displayParts , symbolKind: symbolKind  } = ts_SymbolDisplay_exports.getSymbolDisplayPartsDocumentationAndSymbolKind(checker, symbol, enclosingDeclaration.getSourceFile(), enclosingDeclaration, enclosingDeclaration, meaning);
        return {
            displayParts: displayParts,
            kind: symbolKind
        };
    }
    function toRenameLocation(entry, originalNode, checker, providePrefixAndSuffixText, quotePreference) {
        return {
            ...entryToDocumentSpan(entry),
            ...providePrefixAndSuffixText && getPrefixAndSuffixText(entry, originalNode, checker, quotePreference)
        };
    }
    function toReferencedSymbolEntry(entry, symbol) {
        const referenceEntry = toReferenceEntry(entry);
        if (!symbol) return referenceEntry;
        return {
            ...referenceEntry,
            isDefinition: entry.kind !== 0 /* Span */  && isDeclarationOfSymbol(entry.node, symbol)
        };
    }
    function toReferenceEntry(entry) {
        const documentSpan = entryToDocumentSpan(entry);
        if (entry.kind === 0 /* Span */ ) return {
            ...documentSpan,
            isWriteAccess: false
        };
        const { kind: kind , node: node  } = entry;
        return {
            ...documentSpan,
            isWriteAccess: isWriteAccessForReference(node),
            isInString: kind === 2 /* StringLiteral */  ? true : void 0
        };
    }
    function entryToDocumentSpan(entry) {
        if (entry.kind === 0 /* Span */ ) return {
            textSpan: entry.textSpan,
            fileName: entry.fileName
        };
        else {
            const sourceFile = entry.node.getSourceFile();
            const textSpan = getTextSpan(entry.node, sourceFile);
            return {
                textSpan: textSpan,
                fileName: sourceFile.fileName,
                ...toContextSpan(textSpan, sourceFile, entry.context)
            };
        }
    }
    function getPrefixAndSuffixText(entry, originalNode, checker, quotePreference) {
        if (entry.kind !== 0 /* Span */  && isIdentifier(originalNode)) {
            const { node: node , kind: kind  } = entry;
            const parent2 = node.parent;
            const name = originalNode.text;
            const isShorthandAssignment = isShorthandPropertyAssignment(parent2);
            if (isShorthandAssignment || isObjectBindingElementWithoutPropertyName(parent2) && parent2.name === node && parent2.dotDotDotToken === void 0) {
                const prefixColon = {
                    prefixText: name + ": "
                };
                const suffixColon = {
                    suffixText: ": " + name
                };
                if (kind === 3 /* SearchedLocalFoundProperty */ ) return prefixColon;
                if (kind === 4 /* SearchedPropertyFoundLocal */ ) return suffixColon;
                if (isShorthandAssignment) {
                    const grandParent = parent2.parent;
                    if (isObjectLiteralExpression(grandParent) && isBinaryExpression(grandParent.parent) && isModuleExportsAccessExpression(grandParent.parent.left)) return prefixColon;
                    return suffixColon;
                } else return prefixColon;
            } else if (isImportSpecifier(parent2) && !parent2.propertyName) {
                const originalSymbol = isExportSpecifier(originalNode.parent) ? checker.getExportSpecifierLocalTargetSymbol(originalNode.parent) : checker.getSymbolAtLocation(originalNode);
                return contains(originalSymbol.declarations, parent2) ? {
                    prefixText: name + " as "
                } : emptyOptions;
            } else if (isExportSpecifier(parent2) && !parent2.propertyName) return originalNode === entry.node || checker.getSymbolAtLocation(originalNode) === checker.getSymbolAtLocation(entry.node) ? {
                prefixText: name + " as "
            } : {
                suffixText: " as " + name
            };
        }
        if (entry.kind !== 0 /* Span */  && isNumericLiteral(entry.node) && isAccessExpression(entry.node.parent)) {
            const quote2 = getQuoteFromPreference(quotePreference);
            return {
                prefixText: quote2,
                suffixText: quote2
            };
        }
        return emptyOptions;
    }
    function toImplementationLocation(entry, checker) {
        const documentSpan = entryToDocumentSpan(entry);
        if (entry.kind !== 0 /* Span */ ) {
            const { node: node  } = entry;
            return {
                ...documentSpan,
                ...implementationKindDisplayParts(node, checker)
            };
        } else return {
            ...documentSpan,
            kind: "" /* unknown */ ,
            displayParts: []
        };
    }
    function implementationKindDisplayParts(node, checker) {
        const symbol = checker.getSymbolAtLocation(isDeclaration(node) && node.name ? node.name : node);
        if (symbol) return getDefinitionKindAndDisplayParts(symbol, checker, node);
        else if (node.kind === 209 /* ObjectLiteralExpression */ ) return {
            kind: "interface" /* interfaceElement */ ,
            displayParts: [
                punctuationPart(21 /* OpenParenToken */ ),
                textPart("object literal"),
                punctuationPart(22 /* CloseParenToken */ )
            ]
        };
        else if (node.kind === 230 /* ClassExpression */ ) return {
            kind: "local class" /* localClassElement */ ,
            displayParts: [
                punctuationPart(21 /* OpenParenToken */ ),
                textPart("anonymous local class"),
                punctuationPart(22 /* CloseParenToken */ )
            ]
        };
        else return {
            kind: getNodeKind(node),
            displayParts: []
        };
    }
    function toHighlightSpan(entry) {
        const documentSpan = entryToDocumentSpan(entry);
        if (entry.kind === 0 /* Span */ ) return {
            fileName: documentSpan.fileName,
            span: {
                textSpan: documentSpan.textSpan,
                kind: "reference" /* reference */ 
            }
        };
        const writeAccess = isWriteAccessForReference(entry.node);
        const span = {
            textSpan: documentSpan.textSpan,
            kind: writeAccess ? "writtenReference" /* writtenReference */  : "reference" /* reference */ ,
            isInString: entry.kind === 2 /* StringLiteral */  ? true : void 0,
            ...documentSpan.contextSpan && {
                contextSpan: documentSpan.contextSpan
            }
        };
        return {
            fileName: documentSpan.fileName,
            span: span
        };
    }
    function getTextSpan(node, sourceFile, endNode2) {
        let start = node.getStart(sourceFile);
        let end = (endNode2 || node).getEnd();
        if (isStringLiteralLike(node) && end - start > 2) {
            Debug.assert(endNode2 === void 0);
            start += 1;
            end -= 1;
        }
        return createTextSpanFromBounds(start, end);
    }
    function getTextSpanOfEntry(entry) {
        return entry.kind === 0 /* Span */  ? entry.textSpan : getTextSpan(entry.node, entry.node.getSourceFile());
    }
    function isWriteAccessForReference(node) {
        const decl = getDeclarationFromName(node);
        return !!decl && declarationIsWriteAccess(decl) || node.kind === 90 /* DefaultKeyword */  || isWriteAccess(node);
    }
    function isDeclarationOfSymbol(node, target) {
        var _a;
        if (!target) return false;
        const source = getDeclarationFromName(node) || (node.kind === 90 /* DefaultKeyword */  ? node.parent : isLiteralComputedPropertyDeclarationName(node) ? node.parent.parent : node.kind === 137 /* ConstructorKeyword */  && isConstructorDeclaration(node.parent) ? node.parent.parent : void 0);
        const commonjsSource = source && isBinaryExpression(source) ? source.left : void 0;
        return !!(source && ((_a = target.declarations) == null ? void 0 : _a.some((d)=>d === source || d === commonjsSource)));
    }
    function declarationIsWriteAccess(decl) {
        if (!!(decl.flags & 16777216 /* Ambient */ )) return true;
        switch(decl.kind){
            case 225 /* BinaryExpression */ :
            case 207 /* BindingElement */ :
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
            case 90 /* DefaultKeyword */ :
            case 265 /* EnumDeclaration */ :
            case 305 /* EnumMember */ :
            case 280 /* ExportSpecifier */ :
            case 272 /* ImportClause */ :
            case 270 /* ImportEqualsDeclaration */ :
            case 275 /* ImportSpecifier */ :
            case 263 /* InterfaceDeclaration */ :
            case 344 /* JSDocCallbackTag */ :
            case 352 /* JSDocTypedefTag */ :
            case 290 /* JsxAttribute */ :
            case 266 /* ModuleDeclaration */ :
            case 269 /* NamespaceExportDeclaration */ :
            case 273 /* NamespaceImport */ :
            case 279 /* NamespaceExport */ :
            case 168 /* Parameter */ :
            case 303 /* ShorthandPropertyAssignment */ :
            case 264 /* TypeAliasDeclaration */ :
            case 167 /* TypeParameter */ :
                return true;
            case 302 /* PropertyAssignment */ :
                return !isArrayLiteralOrObjectLiteralDestructuringPattern(decl.parent);
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 175 /* Constructor */ :
            case 173 /* MethodDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
                return !!decl.body;
            case 259 /* VariableDeclaration */ :
            case 171 /* PropertyDeclaration */ :
                return !!decl.initializer || isCatchClause(decl.parent);
            case 172 /* MethodSignature */ :
            case 170 /* PropertySignature */ :
            case 354 /* JSDocPropertyTag */ :
            case 347 /* JSDocParameterTag */ :
                return false;
            default:
                return Debug.failBadSyntaxKind(decl);
        }
    }
    var DefinitionKind, EntryKind, FindReferencesUse, Core;
    var init_findAllReferences = __esm({
        "src/services/findAllReferences.ts" () {
            "use strict";
            init_ts4();
            init_ts_FindAllReferences();
            DefinitionKind = /* @__PURE__ */ ((DefinitionKind2)=>{
                DefinitionKind2[DefinitionKind2["Symbol"] = 0] = "Symbol";
                DefinitionKind2[DefinitionKind2["Label"] = 1] = "Label";
                DefinitionKind2[DefinitionKind2["Keyword"] = 2] = "Keyword";
                DefinitionKind2[DefinitionKind2["This"] = 3] = "This";
                DefinitionKind2[DefinitionKind2["String"] = 4] = "String";
                DefinitionKind2[DefinitionKind2["TripleSlashReference"] = 5] = "TripleSlashReference";
                return DefinitionKind2;
            })(DefinitionKind || {});
            EntryKind = /* @__PURE__ */ ((EntryKind2)=>{
                EntryKind2[EntryKind2["Span"] = 0] = "Span";
                EntryKind2[EntryKind2["Node"] = 1] = "Node";
                EntryKind2[EntryKind2["StringLiteral"] = 2] = "StringLiteral";
                EntryKind2[EntryKind2["SearchedLocalFoundProperty"] = 3] = "SearchedLocalFoundProperty";
                EntryKind2[EntryKind2["SearchedPropertyFoundLocal"] = 4] = "SearchedPropertyFoundLocal";
                return EntryKind2;
            })(EntryKind || {});
            FindReferencesUse = /* @__PURE__ */ ((FindReferencesUse2)=>{
                FindReferencesUse2[FindReferencesUse2["Other"] = 0] = "Other";
                FindReferencesUse2[FindReferencesUse2["References"] = 1] = "References";
                FindReferencesUse2[FindReferencesUse2["Rename"] = 2] = "Rename";
                return FindReferencesUse2;
            })(FindReferencesUse || {});
            ((Core2)=>{
                function getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options = {}, sourceFilesSet = new Set(sourceFiles.map((f)=>f.fileName))) {
                    var _a, _b, _c;
                    node = getAdjustedNode2(node, options);
                    if (isSourceFile(node)) {
                        const resolvedRef = ts_GoToDefinition_exports.getReferenceAtPosition(node, position, program);
                        if (!(resolvedRef == null ? void 0 : resolvedRef.file)) return void 0;
                        const moduleSymbol = program.getTypeChecker().getMergedSymbol(resolvedRef.file.symbol);
                        if (moduleSymbol) return getReferencedSymbolsForModule(program, moduleSymbol, /*excludeImportTypeOfExportEquals*/ false, sourceFiles, sourceFilesSet);
                        const fileIncludeReasons = program.getFileIncludeReasons();
                        if (!fileIncludeReasons) return void 0;
                        return [
                            {
                                definition: {
                                    type: 5 /* TripleSlashReference */ ,
                                    reference: resolvedRef.reference,
                                    file: node
                                },
                                references: getReferencesForNonModule(resolvedRef.file, fileIncludeReasons, program) || emptyArray
                            }
                        ];
                    }
                    if (!options.implementations) {
                        const special = getReferencedSymbolsSpecial(node, sourceFiles, cancellationToken);
                        if (special) return special;
                    }
                    const checker = program.getTypeChecker();
                    const symbol = checker.getSymbolAtLocation(isConstructorDeclaration(node) && node.parent.name || node);
                    if (!symbol) {
                        if (!options.implementations && isStringLiteralLike(node)) {
                            if (isModuleSpecifierLike(node)) {
                                const fileIncludeReasons = program.getFileIncludeReasons();
                                const referencedFileName = (_c = (_b = (_a = node.getSourceFile().resolvedModules) == null ? void 0 : _a.get(node.text, getModeForUsageLocation(node.getSourceFile(), node))) == null ? void 0 : _b.resolvedModule) == null ? void 0 : _c.resolvedFileName;
                                const referencedFile = referencedFileName ? program.getSourceFile(referencedFileName) : void 0;
                                if (referencedFile) return [
                                    {
                                        definition: {
                                            type: 4 /* String */ ,
                                            node: node
                                        },
                                        references: getReferencesForNonModule(referencedFile, fileIncludeReasons, program) || emptyArray
                                    }
                                ];
                            }
                            return getReferencesForStringLiteral(node, sourceFiles, checker, cancellationToken);
                        }
                        return void 0;
                    }
                    if (symbol.escapedName === "export=" /* ExportEquals */ ) return getReferencedSymbolsForModule(program, symbol.parent, /*excludeImportTypeOfExportEquals*/ false, sourceFiles, sourceFilesSet);
                    const moduleReferences = getReferencedSymbolsForModuleIfDeclaredBySourceFile(symbol, program, sourceFiles, cancellationToken, options, sourceFilesSet);
                    if (moduleReferences && !(symbol.flags & 33554432 /* Transient */ )) return moduleReferences;
                    const aliasedSymbol = getMergedAliasedSymbolOfNamespaceExportDeclaration(node, symbol, checker);
                    const moduleReferencesOfExportTarget = aliasedSymbol && getReferencedSymbolsForModuleIfDeclaredBySourceFile(aliasedSymbol, program, sourceFiles, cancellationToken, options, sourceFilesSet);
                    const references = getReferencedSymbolsForSymbol(symbol, node, sourceFiles, sourceFilesSet, checker, cancellationToken, options);
                    return mergeReferences(program, moduleReferences, references, moduleReferencesOfExportTarget);
                }
                Core2.getReferencedSymbolsForNode = getReferencedSymbolsForNode;
                function getAdjustedNode2(node, options) {
                    if (options.use === 1 /* References */ ) node = getAdjustedReferenceLocation(node);
                    else if (options.use === 2 /* Rename */ ) node = getAdjustedRenameLocation(node);
                    return node;
                }
                Core2.getAdjustedNode = getAdjustedNode2;
                function getReferencesForFileName(fileName, program, sourceFiles, sourceFilesSet = new Set(sourceFiles.map((f)=>f.fileName))) {
                    var _a, _b;
                    const moduleSymbol = (_a = program.getSourceFile(fileName)) == null ? void 0 : _a.symbol;
                    if (moduleSymbol) return ((_b = getReferencedSymbolsForModule(program, moduleSymbol, /*excludeImportTypeOfExportEquals*/ false, sourceFiles, sourceFilesSet)[0]) == null ? void 0 : _b.references) || emptyArray;
                    const fileIncludeReasons = program.getFileIncludeReasons();
                    const referencedFile = program.getSourceFile(fileName);
                    return referencedFile && fileIncludeReasons && getReferencesForNonModule(referencedFile, fileIncludeReasons, program) || emptyArray;
                }
                Core2.getReferencesForFileName = getReferencesForFileName;
                function getReferencesForNonModule(referencedFile, refFileMap, program) {
                    let entries;
                    const references = refFileMap.get(referencedFile.path) || emptyArray;
                    for (const ref of references)if (isReferencedFile(ref)) {
                        const referencingFile = program.getSourceFileByPath(ref.file);
                        const location = getReferencedFileLocation(program.getSourceFileByPath, ref);
                        if (isReferenceFileLocation(location)) entries = append(entries, {
                            kind: 0 /* Span */ ,
                            fileName: referencingFile.fileName,
                            textSpan: createTextSpanFromRange(location)
                        });
                    }
                    return entries;
                }
                function getMergedAliasedSymbolOfNamespaceExportDeclaration(node, symbol, checker) {
                    if (node.parent && isNamespaceExportDeclaration(node.parent)) {
                        const aliasedSymbol = checker.getAliasedSymbol(symbol);
                        const targetSymbol = checker.getMergedSymbol(aliasedSymbol);
                        if (aliasedSymbol !== targetSymbol) return targetSymbol;
                    }
                    return void 0;
                }
                function getReferencedSymbolsForModuleIfDeclaredBySourceFile(symbol, program, sourceFiles, cancellationToken, options, sourceFilesSet) {
                    const moduleSourceFile = symbol.flags & 1536 /* Module */  && symbol.declarations && find(symbol.declarations, isSourceFile);
                    if (!moduleSourceFile) return void 0;
                    const exportEquals = symbol.exports.get("export=" /* ExportEquals */ );
                    const moduleReferences = getReferencedSymbolsForModule(program, symbol, !!exportEquals, sourceFiles, sourceFilesSet);
                    if (!exportEquals || !sourceFilesSet.has(moduleSourceFile.fileName)) return moduleReferences;
                    const checker = program.getTypeChecker();
                    symbol = skipAlias(exportEquals, checker);
                    return mergeReferences(program, moduleReferences, getReferencedSymbolsForSymbol(symbol, /*node*/ void 0, sourceFiles, sourceFilesSet, checker, cancellationToken, options));
                }
                function mergeReferences(program, ...referencesToMerge) {
                    let result;
                    for (const references of referencesToMerge){
                        if (!references || !references.length) continue;
                        if (!result) {
                            result = references;
                            continue;
                        }
                        for (const entry of references){
                            if (!entry.definition || entry.definition.type !== 0 /* Symbol */ ) {
                                result.push(entry);
                                continue;
                            }
                            const symbol = entry.definition.symbol;
                            const refIndex = findIndex(result, (ref)=>!!ref.definition && ref.definition.type === 0 /* Symbol */  && ref.definition.symbol === symbol);
                            if (refIndex === -1) {
                                result.push(entry);
                                continue;
                            }
                            const reference = result[refIndex];
                            result[refIndex] = {
                                definition: reference.definition,
                                references: reference.references.concat(entry.references).sort((entry1, entry2)=>{
                                    const entry1File = getSourceFileIndexOfEntry(program, entry1);
                                    const entry2File = getSourceFileIndexOfEntry(program, entry2);
                                    if (entry1File !== entry2File) return compareValues(entry1File, entry2File);
                                    const entry1Span = getTextSpanOfEntry(entry1);
                                    const entry2Span = getTextSpanOfEntry(entry2);
                                    return entry1Span.start !== entry2Span.start ? compareValues(entry1Span.start, entry2Span.start) : compareValues(entry1Span.length, entry2Span.length);
                                })
                            };
                        }
                    }
                    return result;
                }
                function getSourceFileIndexOfEntry(program, entry) {
                    const sourceFile = entry.kind === 0 /* Span */  ? program.getSourceFile(entry.fileName) : entry.node.getSourceFile();
                    return program.getSourceFiles().indexOf(sourceFile);
                }
                function getReferencedSymbolsForModule(program, symbol, excludeImportTypeOfExportEquals, sourceFiles, sourceFilesSet) {
                    Debug.assert(!!symbol.valueDeclaration);
                    const references = mapDefined(findModuleReferences(program, sourceFiles, symbol), (reference)=>{
                        if (reference.kind === "import") {
                            const parent2 = reference.literal.parent;
                            if (isLiteralTypeNode(parent2)) {
                                const importType = cast(parent2.parent, isImportTypeNode);
                                if (excludeImportTypeOfExportEquals && !importType.qualifier) return void 0;
                            }
                            return nodeEntry(reference.literal);
                        } else if (reference.kind === "implicit") {
                            const range = reference.literal.text !== externalHelpersModuleNameText && forEachChildRecursively(reference.referencingFile, (n)=>!(n.transformFlags & 2 /* ContainsJsx */ ) ? "skip" : isJsxElement(n) || isJsxSelfClosingElement(n) || isJsxFragment(n) ? n : void 0) || reference.referencingFile.statements[0] || reference.referencingFile;
                            return nodeEntry(range);
                        } else return {
                            kind: 0 /* Span */ ,
                            fileName: reference.referencingFile.fileName,
                            textSpan: createTextSpanFromRange(reference.ref)
                        };
                    });
                    if (symbol.declarations) for (const decl of symbol.declarations)switch(decl.kind){
                        case 311 /* SourceFile */ :
                            break;
                        case 266 /* ModuleDeclaration */ :
                            if (sourceFilesSet.has(decl.getSourceFile().fileName)) references.push(nodeEntry(decl.name));
                            break;
                        default:
                            Debug.assert(!!(symbol.flags & 33554432 /* Transient */ ), "Expected a module symbol to be declared by a SourceFile or ModuleDeclaration.");
                    }
                    const exported = symbol.exports.get("export=" /* ExportEquals */ );
                    if (exported == null ? void 0 : exported.declarations) for (const decl of exported.declarations){
                        const sourceFile = decl.getSourceFile();
                        if (sourceFilesSet.has(sourceFile.fileName)) {
                            const node = isBinaryExpression(decl) && isPropertyAccessExpression(decl.left) ? decl.left.expression : isExportAssignment(decl) ? Debug.checkDefined(findChildOfKind(decl, 95 /* ExportKeyword */ , sourceFile)) : getNameOfDeclaration(decl) || decl;
                            references.push(nodeEntry(node));
                        }
                    }
                    return references.length ? [
                        {
                            definition: {
                                type: 0 /* Symbol */ ,
                                symbol: symbol
                            },
                            references: references
                        }
                    ] : emptyArray;
                }
                function isReadonlyTypeOperator(node) {
                    return node.kind === 148 /* ReadonlyKeyword */  && isTypeOperatorNode(node.parent) && node.parent.operator === 148 /* ReadonlyKeyword */ ;
                }
                function getReferencedSymbolsSpecial(node, sourceFiles, cancellationToken) {
                    if (isTypeKeyword(node.kind)) {
                        if (node.kind === 116 /* VoidKeyword */  && isVoidExpression(node.parent)) return void 0;
                        if (node.kind === 148 /* ReadonlyKeyword */  && !isReadonlyTypeOperator(node)) return void 0;
                        return getAllReferencesForKeyword(sourceFiles, node.kind, cancellationToken, node.kind === 148 /* ReadonlyKeyword */  ? isReadonlyTypeOperator : void 0);
                    }
                    if (isImportMeta(node.parent) && node.parent.name === node) return getAllReferencesForImportMeta(sourceFiles, cancellationToken);
                    if (isStaticModifier(node) && isClassStaticBlockDeclaration(node.parent)) return [
                        {
                            definition: {
                                type: 2 /* Keyword */ ,
                                node: node
                            },
                            references: [
                                nodeEntry(node)
                            ]
                        }
                    ];
                    if (isJumpStatementTarget(node)) {
                        const labelDefinition = getTargetLabel(node.parent, node.text);
                        return labelDefinition && getLabelReferencesInNode(labelDefinition.parent, labelDefinition);
                    } else if (isLabelOfLabeledStatement(node)) return getLabelReferencesInNode(node.parent, node);
                    if (isThis(node)) return getReferencesForThisKeyword(node, sourceFiles, cancellationToken);
                    if (node.kind === 108 /* SuperKeyword */ ) return getReferencesForSuperKeyword(node);
                    return void 0;
                }
                function getReferencedSymbolsForSymbol(originalSymbol, node, sourceFiles, sourceFilesSet, checker, cancellationToken, options) {
                    const symbol = node && skipPastExportOrImportSpecifierOrUnion(originalSymbol, node, checker, /*useLocalSymbolForExportSpecifier*/ !isForRenameWithPrefixAndSuffixText(options)) || originalSymbol;
                    const searchMeaning = node ? getIntersectingMeaningFromDeclarations(node, symbol) : 7 /* All */ ;
                    const result = [];
                    const state = new State(sourceFiles, sourceFilesSet, node ? getSpecialSearchKind(node) : 0 /* None */ , checker, cancellationToken, searchMeaning, options, result);
                    const exportSpecifier = !isForRenameWithPrefixAndSuffixText(options) || !symbol.declarations ? void 0 : find(symbol.declarations, isExportSpecifier);
                    if (exportSpecifier) getReferencesAtExportSpecifier(exportSpecifier.name, symbol, exportSpecifier, state.createSearch(node, originalSymbol, /*comingFrom*/ void 0), state, /*addReferencesHere*/ true, /*alwaysGetReferences*/ true);
                    else if (node && node.kind === 90 /* DefaultKeyword */  && symbol.escapedName === "default" /* Default */  && symbol.parent) {
                        addReference(node, symbol, state);
                        searchForImportsOfExport(node, symbol, {
                            exportingModuleSymbol: symbol.parent,
                            exportKind: 1 /* Default */ 
                        }, state);
                    } else {
                        const search = state.createSearch(node, symbol, /*comingFrom*/ void 0, {
                            allSearchSymbols: node ? populateSearchSymbolSet(symbol, node, checker, options.use === 2 /* Rename */ , !!options.providePrefixAndSuffixTextForRename, !!options.implementations) : [
                                symbol
                            ]
                        });
                        getReferencesInContainerOrFiles(symbol, state, search);
                    }
                    return result;
                }
                function getReferencesInContainerOrFiles(symbol, state, search) {
                    const scope = getSymbolScope(symbol);
                    if (scope) getReferencesInContainer(scope, scope.getSourceFile(), search, state, /*addReferencesHere*/ !(isSourceFile(scope) && !contains(state.sourceFiles, scope)));
                    else for (const sourceFile of state.sourceFiles){
                        state.cancellationToken.throwIfCancellationRequested();
                        searchForName(sourceFile, search, state);
                    }
                }
                function getSpecialSearchKind(node) {
                    switch(node.kind){
                        case 175 /* Constructor */ :
                        case 137 /* ConstructorKeyword */ :
                            return 1 /* Constructor */ ;
                        case 80 /* Identifier */ :
                            if (isClassLike(node.parent)) {
                                Debug.assert(node.parent.name === node);
                                return 2 /* Class */ ;
                            }
                        default:
                            return 0 /* None */ ;
                    }
                }
                function skipPastExportOrImportSpecifierOrUnion(symbol, node, checker, useLocalSymbolForExportSpecifier) {
                    const { parent: parent2  } = node;
                    if (isExportSpecifier(parent2) && useLocalSymbolForExportSpecifier) return getLocalSymbolForExportSpecifier(node, symbol, parent2, checker);
                    return firstDefined(symbol.declarations, (decl)=>{
                        if (!decl.parent) {
                            if (symbol.flags & 33554432 /* Transient */ ) return void 0;
                            Debug.fail(`Unexpected symbol at ${Debug.formatSyntaxKind(node.kind)}: ${Debug.formatSymbol(symbol)}`);
                        }
                        return isTypeLiteralNode(decl.parent) && isUnionTypeNode(decl.parent.parent) ? checker.getPropertyOfType(checker.getTypeFromTypeNode(decl.parent.parent), symbol.name) : void 0;
                    });
                }
                let SpecialSearchKind;
                ((SpecialSearchKind2)=>{
                    SpecialSearchKind2[SpecialSearchKind2["None"] = 0] = "None";
                    SpecialSearchKind2[SpecialSearchKind2["Constructor"] = 1] = "Constructor";
                    SpecialSearchKind2[SpecialSearchKind2["Class"] = 2] = "Class";
                })(SpecialSearchKind || (SpecialSearchKind = {}));
                function getNonModuleSymbolOfMergedModuleSymbol(symbol) {
                    if (!(symbol.flags & 33555968 /* Transient */ )) return void 0;
                    const decl = symbol.declarations && find(symbol.declarations, (d)=>!isSourceFile(d) && !isModuleDeclaration(d));
                    return decl && decl.symbol;
                }
                class State {
                    constructor(sourceFiles, sourceFilesSet, specialSearchKind, checker, cancellationToken, searchMeaning, options, result){
                        this.sourceFiles = sourceFiles;
                        this.sourceFilesSet = sourceFilesSet;
                        this.specialSearchKind = specialSearchKind;
                        this.checker = checker;
                        this.cancellationToken = cancellationToken;
                        this.searchMeaning = searchMeaning;
                        this.options = options;
                        this.result = result;
                        /** Cache for `explicitlyinheritsFrom`. */ this.inheritsFromCache = /* @__PURE__ */ new Map();
                        /**
             * Type nodes can contain multiple references to the same type. For example:
             *      let x: Foo & (Foo & Bar) = ...
             * Because we are returning the implementation locations and not the identifier locations,
             * duplicate entries would be returned here as each of the type references is part of
             * the same implementation. For that reason, check before we add a new entry.
             */ this.markSeenContainingTypeReference = nodeSeenTracker();
                        /**
             * It's possible that we will encounter the right side of `export { foo as bar } from "x";` more than once.
             * For example:
             *     // b.ts
             *     export { foo as bar } from "./a";
             *     import { bar } from "./b";
             *
             * Normally at `foo as bar` we directly add `foo` and do not locally search for it (since it doesn't declare a local).
             * But another reference to it may appear in the same source file.
             * See `tests/cases/fourslash/transitiveExportImports3.ts`.
             */ this.markSeenReExportRHS = nodeSeenTracker();
                        this.symbolIdToReferences = [];
                        // Source file ID -> symbol ID -> Whether the symbol has been searched for in the source file.
                        this.sourceFileToSeenSymbols = [];
                    }
                    includesSourceFile(sourceFile) {
                        return this.sourceFilesSet.has(sourceFile.fileName);
                    }
                    /** Gets every place to look for references of an exported symbols. See `ImportsResult` in `importTracker.ts` for more documentation. */ getImportSearches(exportSymbol, exportInfo) {
                        if (!this.importTracker) this.importTracker = createImportTracker(this.sourceFiles, this.sourceFilesSet, this.checker, this.cancellationToken);
                        return this.importTracker(exportSymbol, exportInfo, this.options.use === 2 /* Rename */ );
                    }
                    /** @param allSearchSymbols set of additional symbols for use by `includes`. */ createSearch(location, symbol, comingFrom, searchOptions = {}) {
                        const { text: text = stripQuotes(symbolName(getLocalSymbolForExportDefault(symbol) || getNonModuleSymbolOfMergedModuleSymbol(symbol) || symbol)) , allSearchSymbols: allSearchSymbols = [
                            symbol
                        ]  } = searchOptions;
                        const escapedText = escapeLeadingUnderscores(text);
                        const parents = this.options.implementations && location ? getParentSymbolsOfPropertyAccess(location, symbol, this.checker) : void 0;
                        return {
                            symbol: symbol,
                            comingFrom: comingFrom,
                            text: text,
                            escapedText: escapedText,
                            parents: parents,
                            allSearchSymbols: allSearchSymbols,
                            includes: (sym)=>contains(allSearchSymbols, sym)
                        };
                    }
                    /**
           * Callback to add references for a particular searched symbol.
           * This initializes a reference group, so only call this if you will add at least one reference.
           */ referenceAdder(searchSymbol) {
                        const symbolId = getSymbolId(searchSymbol);
                        let references = this.symbolIdToReferences[symbolId];
                        if (!references) {
                            references = this.symbolIdToReferences[symbolId] = [];
                            this.result.push({
                                definition: {
                                    type: 0 /* Symbol */ ,
                                    symbol: searchSymbol
                                },
                                references: references
                            });
                        }
                        return (node, kind)=>references.push(nodeEntry(node, kind));
                    }
                    /** Add a reference with no associated definition. */ addStringOrCommentReference(fileName, textSpan) {
                        this.result.push({
                            definition: void 0,
                            references: [
                                {
                                    kind: 0 /* Span */ ,
                                    fileName: fileName,
                                    textSpan: textSpan
                                }
                            ]
                        });
                    }
                    /** Returns `true` the first time we search for a symbol in a file and `false` afterwards. */ markSearchedSymbols(sourceFile, symbols) {
                        const sourceId = getNodeId(sourceFile);
                        const seenSymbols = this.sourceFileToSeenSymbols[sourceId] || (this.sourceFileToSeenSymbols[sourceId] = /* @__PURE__ */ new Set());
                        let anyNewSymbols = false;
                        for (const sym of symbols)anyNewSymbols = tryAddToSet(seenSymbols, getSymbolId(sym)) || anyNewSymbols;
                        return anyNewSymbols;
                    }
                }
                function searchForImportsOfExport(exportLocation, exportSymbol, exportInfo, state) {
                    const { importSearches: importSearches , singleReferences: singleReferences , indirectUsers: indirectUsers  } = state.getImportSearches(exportSymbol, exportInfo);
                    if (singleReferences.length) {
                        const addRef = state.referenceAdder(exportSymbol);
                        for (const singleRef of singleReferences)if (shouldAddSingleReference(singleRef, state)) addRef(singleRef);
                    }
                    for (const [importLocation, importSymbol] of importSearches)getReferencesInSourceFile(importLocation.getSourceFile(), state.createSearch(importLocation, importSymbol, 1 /* Export */ ), state);
                    if (indirectUsers.length) {
                        let indirectSearch;
                        switch(exportInfo.exportKind){
                            case 0 /* Named */ :
                                indirectSearch = state.createSearch(exportLocation, exportSymbol, 1 /* Export */ );
                                break;
                            case 1 /* Default */ :
                                indirectSearch = state.options.use === 2 /* Rename */  ? void 0 : state.createSearch(exportLocation, exportSymbol, 1 /* Export */ , {
                                    text: "default"
                                });
                                break;
                            case 2 /* ExportEquals */ :
                                break;
                        }
                        if (indirectSearch) for (const indirectUser of indirectUsers)searchForName(indirectUser, indirectSearch, state);
                    }
                }
                function eachExportReference(sourceFiles, checker, cancellationToken, exportSymbol, exportingModuleSymbol, exportName, isDefaultExport, cb) {
                    const importTracker = createImportTracker(sourceFiles, new Set(sourceFiles.map((f)=>f.fileName)), checker, cancellationToken);
                    const { importSearches: importSearches , indirectUsers: indirectUsers , singleReferences: singleReferences  } = importTracker(exportSymbol, {
                        exportKind: isDefaultExport ? 1 /* Default */  : 0 /* Named */ ,
                        exportingModuleSymbol: exportingModuleSymbol
                    }, /*isForRename*/ false);
                    for (const [importLocation] of importSearches)cb(importLocation);
                    for (const singleReference of singleReferences)if (isIdentifier(singleReference) && isImportTypeNode(singleReference.parent)) cb(singleReference);
                    for (const indirectUser of indirectUsers)for (const node of getPossibleSymbolReferenceNodes(indirectUser, isDefaultExport ? "default" : exportName)){
                        const symbol = checker.getSymbolAtLocation(node);
                        const hasExportAssignmentDeclaration = some(symbol == null ? void 0 : symbol.declarations, (d)=>tryCast(d, isExportAssignment) ? true : false);
                        if (isIdentifier(node) && !isImportOrExportSpecifier(node.parent) && (symbol === exportSymbol || hasExportAssignmentDeclaration)) cb(node);
                    }
                }
                Core2.eachExportReference = eachExportReference;
                function shouldAddSingleReference(singleRef, state) {
                    if (!hasMatchingMeaning(singleRef, state)) return false;
                    if (state.options.use !== 2 /* Rename */ ) return true;
                    if (!isIdentifier(singleRef)) return false;
                    return !(isImportOrExportSpecifier(singleRef.parent) && singleRef.escapedText === "default" /* Default */ );
                }
                function searchForImportedSymbol(symbol, state) {
                    if (!symbol.declarations) return;
                    for (const declaration of symbol.declarations){
                        const exportingFile = declaration.getSourceFile();
                        getReferencesInSourceFile(exportingFile, state.createSearch(declaration, symbol, 0 /* Import */ ), state, state.includesSourceFile(exportingFile));
                    }
                }
                function searchForName(sourceFile, search, state) {
                    if (getNameTable(sourceFile).get(search.escapedText) !== void 0) getReferencesInSourceFile(sourceFile, search, state);
                }
                function getPropertySymbolOfDestructuringAssignment(location, checker) {
                    return isArrayLiteralOrObjectLiteralDestructuringPattern(location.parent.parent) ? checker.getPropertySymbolOfDestructuringAssignment(location) : void 0;
                }
                function getSymbolScope(symbol) {
                    const { declarations: declarations , flags: flags , parent: parent2 , valueDeclaration: valueDeclaration  } = symbol;
                    if (valueDeclaration && (valueDeclaration.kind === 217 /* FunctionExpression */  || valueDeclaration.kind === 230 /* ClassExpression */ )) return valueDeclaration;
                    if (!declarations) return void 0;
                    if (flags & 8196 /* Method */ ) {
                        const privateDeclaration = find(declarations, (d)=>hasEffectiveModifier(d, 8 /* Private */ ) || isPrivateIdentifierClassElementDeclaration(d));
                        if (privateDeclaration) return getAncestor(privateDeclaration, 262 /* ClassDeclaration */ );
                        return void 0;
                    }
                    if (declarations.some(isObjectBindingElementWithoutPropertyName)) return void 0;
                    const exposedByParent = parent2 && !(symbol.flags & 262144 /* TypeParameter */ );
                    if (exposedByParent && !(isExternalModuleSymbol(parent2) && !parent2.globalExports)) return void 0;
                    let scope;
                    for (const declaration of declarations){
                        const container = getContainerNode(declaration);
                        if (scope && scope !== container) return void 0;
                        if (!container || container.kind === 311 /* SourceFile */  && !isExternalOrCommonJsModule(container)) return void 0;
                        scope = container;
                        if (isFunctionExpression(scope)) {
                            let next;
                            while(next = getNextJSDocCommentLocation(scope))scope = next;
                        }
                    }
                    return exposedByParent ? scope.getSourceFile() : scope;
                }
                function isSymbolReferencedInFile(definition, checker, sourceFile, searchContainer = sourceFile) {
                    return eachSymbolReferenceInFile(definition, checker, sourceFile, ()=>true, searchContainer) || false;
                }
                Core2.isSymbolReferencedInFile = isSymbolReferencedInFile;
                function eachSymbolReferenceInFile(definition, checker, sourceFile, cb, searchContainer = sourceFile) {
                    const symbol = isParameterPropertyDeclaration(definition.parent, definition.parent.parent) ? first(checker.getSymbolsOfParameterPropertyDeclaration(definition.parent, definition.text)) : checker.getSymbolAtLocation(definition);
                    if (!symbol) return void 0;
                    for (const token of getPossibleSymbolReferenceNodes(sourceFile, symbol.name, searchContainer)){
                        if (!isIdentifier(token) || token === definition || token.escapedText !== definition.escapedText) continue;
                        const referenceSymbol = checker.getSymbolAtLocation(token);
                        if (referenceSymbol === symbol || checker.getShorthandAssignmentValueSymbol(token.parent) === symbol || isExportSpecifier(token.parent) && getLocalSymbolForExportSpecifier(token, referenceSymbol, token.parent, checker) === symbol) {
                            const res = cb(token);
                            if (res) return res;
                        }
                    }
                }
                Core2.eachSymbolReferenceInFile = eachSymbolReferenceInFile;
                function getTopMostDeclarationNamesInFile(declarationName, sourceFile) {
                    const candidates = filter(getPossibleSymbolReferenceNodes(sourceFile, declarationName), (name)=>!!getDeclarationFromName(name));
                    return candidates.reduce((topMost, decl)=>{
                        const depth = getDepth(decl);
                        if (!some(topMost.declarationNames) || depth === topMost.depth) {
                            topMost.declarationNames.push(decl);
                            topMost.depth = depth;
                        } else if (depth < topMost.depth) {
                            topMost.declarationNames = [
                                decl
                            ];
                            topMost.depth = depth;
                        }
                        return topMost;
                    }, {
                        depth: Infinity,
                        declarationNames: []
                    }).declarationNames;
                    function getDepth(declaration) {
                        let depth = 0;
                        while(declaration){
                            declaration = getContainerNode(declaration);
                            depth++;
                        }
                        return depth;
                    }
                }
                Core2.getTopMostDeclarationNamesInFile = getTopMostDeclarationNamesInFile;
                function someSignatureUsage(signature, sourceFiles, checker, cb) {
                    if (!signature.name || !isIdentifier(signature.name)) return false;
                    const symbol = Debug.checkDefined(checker.getSymbolAtLocation(signature.name));
                    for (const sourceFile of sourceFiles)for (const name of getPossibleSymbolReferenceNodes(sourceFile, symbol.name)){
                        if (!isIdentifier(name) || name === signature.name || name.escapedText !== signature.name.escapedText) continue;
                        const called = climbPastPropertyAccess(name);
                        const call = isCallExpression(called.parent) && called.parent.expression === called ? called.parent : void 0;
                        const referenceSymbol = checker.getSymbolAtLocation(name);
                        if (referenceSymbol && checker.getRootSymbols(referenceSymbol).some((s)=>s === symbol)) {
                            if (cb(name, call)) return true;
                        }
                    }
                    return false;
                }
                Core2.someSignatureUsage = someSignatureUsage;
                function getPossibleSymbolReferenceNodes(sourceFile, symbolName2, container = sourceFile) {
                    return getPossibleSymbolReferencePositions(sourceFile, symbolName2, container).map((pos)=>getTouchingPropertyName(sourceFile, pos));
                }
                function getPossibleSymbolReferencePositions(sourceFile, symbolName2, container = sourceFile) {
                    const positions = [];
                    if (!symbolName2 || !symbolName2.length) return positions;
                    const text = sourceFile.text;
                    const sourceLength = text.length;
                    const symbolNameLength = symbolName2.length;
                    let position = text.indexOf(symbolName2, container.pos);
                    while(position >= 0){
                        if (position > container.end) break;
                        const endPosition = position + symbolNameLength;
                        if ((position === 0 || !isIdentifierPart(text.charCodeAt(position - 1), 99 /* Latest */ )) && (endPosition === sourceLength || !isIdentifierPart(text.charCodeAt(endPosition), 99 /* Latest */ ))) positions.push(position);
                        position = text.indexOf(symbolName2, position + symbolNameLength + 1);
                    }
                    return positions;
                }
                function getLabelReferencesInNode(container, targetLabel) {
                    const sourceFile = container.getSourceFile();
                    const labelName = targetLabel.text;
                    const references = mapDefined(getPossibleSymbolReferenceNodes(sourceFile, labelName, container), (node)=>// Only pick labels that are either the target label, or have a target that is the target label
                        node === targetLabel || isJumpStatementTarget(node) && getTargetLabel(node, labelName) === targetLabel ? nodeEntry(node) : void 0);
                    return [
                        {
                            definition: {
                                type: 1 /* Label */ ,
                                node: targetLabel
                            },
                            references: references
                        }
                    ];
                }
                function isValidReferencePosition(node, searchSymbolName) {
                    switch(node.kind){
                        case 81 /* PrivateIdentifier */ :
                            if (isJSDocMemberName(node.parent)) return true;
                        case 80 /* Identifier */ :
                            return node.text.length === searchSymbolName.length;
                        case 15 /* NoSubstitutionTemplateLiteral */ :
                        case 11 /* StringLiteral */ :
                            {
                                const str = node;
                                return (isLiteralNameOfPropertyDeclarationOrIndexAccess(str) || isNameOfModuleDeclaration(node) || isExpressionOfExternalModuleImportEqualsDeclaration(node) || isCallExpression(node.parent) && isBindableObjectDefinePropertyCall(node.parent) && node.parent.arguments[1] === node) && str.text.length === searchSymbolName.length;
                            }
                        case 9 /* NumericLiteral */ :
                            return isLiteralNameOfPropertyDeclarationOrIndexAccess(node) && node.text.length === searchSymbolName.length;
                        case 90 /* DefaultKeyword */ :
                            return 7 === searchSymbolName.length;
                        default:
                            return false;
                    }
                }
                function getAllReferencesForImportMeta(sourceFiles, cancellationToken) {
                    const references = flatMap(sourceFiles, (sourceFile)=>{
                        cancellationToken.throwIfCancellationRequested();
                        return mapDefined(getPossibleSymbolReferenceNodes(sourceFile, "meta", sourceFile), (node)=>{
                            const parent2 = node.parent;
                            if (isImportMeta(parent2)) return nodeEntry(parent2);
                        });
                    });
                    return references.length ? [
                        {
                            definition: {
                                type: 2 /* Keyword */ ,
                                node: references[0].node
                            },
                            references: references
                        }
                    ] : void 0;
                }
                function getAllReferencesForKeyword(sourceFiles, keywordKind, cancellationToken, filter2) {
                    const references = flatMap(sourceFiles, (sourceFile)=>{
                        cancellationToken.throwIfCancellationRequested();
                        return mapDefined(getPossibleSymbolReferenceNodes(sourceFile, tokenToString(keywordKind), sourceFile), (referenceLocation)=>{
                            if (referenceLocation.kind === keywordKind && (!filter2 || filter2(referenceLocation))) return nodeEntry(referenceLocation);
                        });
                    });
                    return references.length ? [
                        {
                            definition: {
                                type: 2 /* Keyword */ ,
                                node: references[0].node
                            },
                            references: references
                        }
                    ] : void 0;
                }
                function getReferencesInSourceFile(sourceFile, search, state, addReferencesHere = true) {
                    state.cancellationToken.throwIfCancellationRequested();
                    return getReferencesInContainer(sourceFile, sourceFile, search, state, addReferencesHere);
                }
                function getReferencesInContainer(container, sourceFile, search, state, addReferencesHere) {
                    if (!state.markSearchedSymbols(sourceFile, search.allSearchSymbols)) return;
                    for (const position of getPossibleSymbolReferencePositions(sourceFile, search.text, container))getReferencesAtLocation(sourceFile, position, search, state, addReferencesHere);
                }
                function hasMatchingMeaning(referenceLocation, state) {
                    return !!(getMeaningFromLocation(referenceLocation) & state.searchMeaning);
                }
                function getReferencesAtLocation(sourceFile, position, search, state, addReferencesHere) {
                    const referenceLocation = getTouchingPropertyName(sourceFile, position);
                    if (!isValidReferencePosition(referenceLocation, search.text)) {
                        if (!state.options.implementations && (state.options.findInStrings && isInString(sourceFile, position) || state.options.findInComments && isInNonReferenceComment(sourceFile, position))) state.addStringOrCommentReference(sourceFile.fileName, createTextSpan(position, search.text.length));
                        return;
                    }
                    if (!hasMatchingMeaning(referenceLocation, state)) return;
                    let referenceSymbol = state.checker.getSymbolAtLocation(referenceLocation);
                    if (!referenceSymbol) return;
                    const parent2 = referenceLocation.parent;
                    if (isImportSpecifier(parent2) && parent2.propertyName === referenceLocation) return;
                    if (isExportSpecifier(parent2)) {
                        Debug.assert(referenceLocation.kind === 80 /* Identifier */ );
                        getReferencesAtExportSpecifier(referenceLocation, referenceSymbol, parent2, search, state, addReferencesHere);
                        return;
                    }
                    const relatedSymbol = getRelatedSymbol(search, referenceSymbol, referenceLocation, state);
                    if (!relatedSymbol) {
                        getReferenceForShorthandProperty(referenceSymbol, search, state);
                        return;
                    }
                    switch(state.specialSearchKind){
                        case 0 /* None */ :
                            if (addReferencesHere) addReference(referenceLocation, relatedSymbol, state);
                            break;
                        case 1 /* Constructor */ :
                            addConstructorReferences(referenceLocation, sourceFile, search, state);
                            break;
                        case 2 /* Class */ :
                            addClassStaticThisReferences(referenceLocation, search, state);
                            break;
                        default:
                            Debug.assertNever(state.specialSearchKind);
                    }
                    if (isInJSFile(referenceLocation) && isBindingElement(referenceLocation.parent) && isVariableDeclarationInitializedToBareOrAccessedRequire(referenceLocation.parent.parent.parent)) {
                        referenceSymbol = referenceLocation.parent.symbol;
                        if (!referenceSymbol) return;
                    }
                    getImportOrExportReferences(referenceLocation, referenceSymbol, search, state);
                }
                function getReferencesAtExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, search, state, addReferencesHere, alwaysGetReferences) {
                    Debug.assert(!alwaysGetReferences || !!state.options.providePrefixAndSuffixTextForRename, "If alwaysGetReferences is true, then prefix/suffix text must be enabled");
                    const { parent: parent2 , propertyName: propertyName , name: name  } = exportSpecifier;
                    const exportDeclaration = parent2.parent;
                    const localSymbol = getLocalSymbolForExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, state.checker);
                    if (!alwaysGetReferences && !search.includes(localSymbol)) return;
                    if (!propertyName) {
                        if (!(state.options.use === 2 /* Rename */  && name.escapedText === "default" /* Default */ )) addRef();
                    } else if (referenceLocation === propertyName) {
                        if (!exportDeclaration.moduleSpecifier) addRef();
                        if (addReferencesHere && state.options.use !== 2 /* Rename */  && state.markSeenReExportRHS(name)) addReference(name, Debug.checkDefined(exportSpecifier.symbol), state);
                    } else if (state.markSeenReExportRHS(referenceLocation)) addRef();
                    if (!isForRenameWithPrefixAndSuffixText(state.options) || alwaysGetReferences) {
                        const isDefaultExport = referenceLocation.escapedText === "default" || exportSpecifier.name.escapedText === "default";
                        const exportKind = isDefaultExport ? 1 /* Default */  : 0 /* Named */ ;
                        const exportSymbol = Debug.checkDefined(exportSpecifier.symbol);
                        const exportInfo = getExportInfo(exportSymbol, exportKind, state.checker);
                        if (exportInfo) searchForImportsOfExport(referenceLocation, exportSymbol, exportInfo, state);
                    }
                    if (search.comingFrom !== 1 /* Export */  && exportDeclaration.moduleSpecifier && !propertyName && !isForRenameWithPrefixAndSuffixText(state.options)) {
                        const imported = state.checker.getExportSpecifierLocalTargetSymbol(exportSpecifier);
                        if (imported) searchForImportedSymbol(imported, state);
                    }
                    function addRef() {
                        if (addReferencesHere) addReference(referenceLocation, localSymbol, state);
                    }
                }
                function getLocalSymbolForExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, checker) {
                    return isExportSpecifierAlias(referenceLocation, exportSpecifier) && checker.getExportSpecifierLocalTargetSymbol(exportSpecifier) || referenceSymbol;
                }
                function isExportSpecifierAlias(referenceLocation, exportSpecifier) {
                    const { parent: parent2 , propertyName: propertyName , name: name  } = exportSpecifier;
                    Debug.assert(propertyName === referenceLocation || name === referenceLocation);
                    if (propertyName) return propertyName === referenceLocation;
                    else return !parent2.parent.moduleSpecifier;
                }
                function getImportOrExportReferences(referenceLocation, referenceSymbol, search, state) {
                    const importOrExport = getImportOrExportSymbol(referenceLocation, referenceSymbol, state.checker, search.comingFrom === 1 /* Export */ );
                    if (!importOrExport) return;
                    const { symbol: symbol  } = importOrExport;
                    if (importOrExport.kind === 0 /* Import */ ) {
                        if (!isForRenameWithPrefixAndSuffixText(state.options)) searchForImportedSymbol(symbol, state);
                    } else searchForImportsOfExport(referenceLocation, symbol, importOrExport.exportInfo, state);
                }
                function getReferenceForShorthandProperty({ flags: flags , valueDeclaration: valueDeclaration  }, search, state) {
                    const shorthandValueSymbol = state.checker.getShorthandAssignmentValueSymbol(valueDeclaration);
                    const name = valueDeclaration && getNameOfDeclaration(valueDeclaration);
                    if (!(flags & 33554432 /* Transient */ ) && name && search.includes(shorthandValueSymbol)) addReference(name, shorthandValueSymbol, state);
                }
                function addReference(referenceLocation, relatedSymbol, state) {
                    const { kind: kind , symbol: symbol  } = "kind" in relatedSymbol ? relatedSymbol : {
                        kind: void 0,
                        symbol: relatedSymbol
                    };
                    if (state.options.use === 2 /* Rename */  && referenceLocation.kind === 90 /* DefaultKeyword */ ) return;
                    const addRef = state.referenceAdder(symbol);
                    if (state.options.implementations) addImplementationReferences(referenceLocation, addRef, state);
                    else addRef(referenceLocation, kind);
                }
                function addConstructorReferences(referenceLocation, sourceFile, search, state) {
                    if (isNewExpressionTarget(referenceLocation)) addReference(referenceLocation, search.symbol, state);
                    const pusher = ()=>state.referenceAdder(search.symbol);
                    if (isClassLike(referenceLocation.parent)) {
                        Debug.assert(referenceLocation.kind === 90 /* DefaultKeyword */  || referenceLocation.parent.name === referenceLocation);
                        findOwnConstructorReferences(search.symbol, sourceFile, pusher());
                    } else {
                        const classExtending = tryGetClassByExtendingIdentifier(referenceLocation);
                        if (classExtending) {
                            findSuperConstructorAccesses(classExtending, pusher());
                            findInheritedConstructorReferences(classExtending, state);
                        }
                    }
                }
                function addClassStaticThisReferences(referenceLocation, search, state) {
                    addReference(referenceLocation, search.symbol, state);
                    const classLike = referenceLocation.parent;
                    if (state.options.use === 2 /* Rename */  || !isClassLike(classLike)) return;
                    Debug.assert(classLike.name === referenceLocation);
                    const addRef = state.referenceAdder(search.symbol);
                    for (const member of classLike.members){
                        if (!(isMethodOrAccessor(member) && isStatic(member))) continue;
                        if (member.body) member.body.forEachChild(function cb(node) {
                            if (node.kind === 110 /* ThisKeyword */ ) addRef(node);
                            else if (!isFunctionLike(node) && !isClassLike(node)) node.forEachChild(cb);
                        });
                    }
                }
                function findOwnConstructorReferences(classSymbol, sourceFile, addNode) {
                    const constructorSymbol = getClassConstructorSymbol(classSymbol);
                    if (constructorSymbol && constructorSymbol.declarations) for (const decl of constructorSymbol.declarations){
                        const ctrKeyword = findChildOfKind(decl, 137 /* ConstructorKeyword */ , sourceFile);
                        Debug.assert(decl.kind === 175 /* Constructor */  && !!ctrKeyword);
                        addNode(ctrKeyword);
                    }
                    if (classSymbol.exports) classSymbol.exports.forEach((member)=>{
                        const decl = member.valueDeclaration;
                        if (decl && decl.kind === 173 /* MethodDeclaration */ ) {
                            const body = decl.body;
                            if (body) forEachDescendantOfKind(body, 110 /* ThisKeyword */ , (thisKeyword)=>{
                                if (isNewExpressionTarget(thisKeyword)) addNode(thisKeyword);
                            });
                        }
                    });
                }
                function getClassConstructorSymbol(classSymbol) {
                    return classSymbol.members && classSymbol.members.get("__constructor" /* Constructor */ );
                }
                function findSuperConstructorAccesses(classDeclaration, addNode) {
                    const constructor = getClassConstructorSymbol(classDeclaration.symbol);
                    if (!(constructor && constructor.declarations)) return;
                    for (const decl of constructor.declarations){
                        Debug.assert(decl.kind === 175 /* Constructor */ );
                        const body = decl.body;
                        if (body) forEachDescendantOfKind(body, 108 /* SuperKeyword */ , (node)=>{
                            if (isCallExpressionTarget(node)) addNode(node);
                        });
                    }
                }
                function hasOwnConstructor(classDeclaration) {
                    return !!getClassConstructorSymbol(classDeclaration.symbol);
                }
                function findInheritedConstructorReferences(classDeclaration, state) {
                    if (hasOwnConstructor(classDeclaration)) return;
                    const classSymbol = classDeclaration.symbol;
                    const search = state.createSearch(/*location*/ void 0, classSymbol, /*comingFrom*/ void 0);
                    getReferencesInContainerOrFiles(classSymbol, state, search);
                }
                function addImplementationReferences(refNode, addReference2, state) {
                    if (isDeclarationName(refNode) && isImplementation(refNode.parent)) {
                        addReference2(refNode);
                        return;
                    }
                    if (refNode.kind !== 80 /* Identifier */ ) return;
                    if (refNode.parent.kind === 303 /* ShorthandPropertyAssignment */ ) getReferenceEntriesForShorthandPropertyAssignment(refNode, state.checker, addReference2);
                    const containingClass = getContainingClassIfInHeritageClause(refNode);
                    if (containingClass) {
                        addReference2(containingClass);
                        return;
                    }
                    const typeNode = findAncestor(refNode, (a)=>!isQualifiedName(a.parent) && !isTypeNode(a.parent) && !isTypeElement(a.parent));
                    const typeHavingNode = typeNode.parent;
                    if (hasType(typeHavingNode) && typeHavingNode.type === typeNode && state.markSeenContainingTypeReference(typeHavingNode)) {
                        if (hasInitializer(typeHavingNode)) addIfImplementation(typeHavingNode.initializer);
                        else if (isFunctionLike(typeHavingNode) && typeHavingNode.body) {
                            const body = typeHavingNode.body;
                            if (body.kind === 240 /* Block */ ) forEachReturnStatement(body, (returnStatement)=>{
                                if (returnStatement.expression) addIfImplementation(returnStatement.expression);
                            });
                            else addIfImplementation(body);
                        } else if (isAssertionExpression(typeHavingNode)) addIfImplementation(typeHavingNode.expression);
                    }
                    function addIfImplementation(e) {
                        if (isImplementationExpression(e)) addReference2(e);
                    }
                }
                function getContainingClassIfInHeritageClause(node) {
                    return isIdentifier(node) || isPropertyAccessExpression(node) ? getContainingClassIfInHeritageClause(node.parent) : isExpressionWithTypeArguments(node) ? tryCast(node.parent.parent, isClassLike) : void 0;
                }
                function isImplementationExpression(node) {
                    switch(node.kind){
                        case 216 /* ParenthesizedExpression */ :
                            return isImplementationExpression(node.expression);
                        case 218 /* ArrowFunction */ :
                        case 217 /* FunctionExpression */ :
                        case 209 /* ObjectLiteralExpression */ :
                        case 230 /* ClassExpression */ :
                        case 208 /* ArrayLiteralExpression */ :
                            return true;
                        default:
                            return false;
                    }
                }
                function explicitlyInheritsFrom(symbol, parent2, cachedResults, checker) {
                    if (symbol === parent2) return true;
                    const key = getSymbolId(symbol) + "," + getSymbolId(parent2);
                    const cached = cachedResults.get(key);
                    if (cached !== void 0) return cached;
                    cachedResults.set(key, false);
                    const inherits = !!symbol.declarations && symbol.declarations.some((declaration)=>getAllSuperTypeNodes(declaration).some((typeReference)=>{
                            const type = checker.getTypeAtLocation(typeReference);
                            return !!type && !!type.symbol && explicitlyInheritsFrom(type.symbol, parent2, cachedResults, checker);
                        }));
                    cachedResults.set(key, inherits);
                    return inherits;
                }
                function getReferencesForSuperKeyword(superKeyword) {
                    let searchSpaceNode = getSuperContainer(superKeyword, /*stopOnFunctions*/ false);
                    if (!searchSpaceNode) return void 0;
                    let staticFlag = 32 /* Static */ ;
                    switch(searchSpaceNode.kind){
                        case 171 /* PropertyDeclaration */ :
                        case 170 /* PropertySignature */ :
                        case 173 /* MethodDeclaration */ :
                        case 172 /* MethodSignature */ :
                        case 175 /* Constructor */ :
                        case 176 /* GetAccessor */ :
                        case 177 /* SetAccessor */ :
                            staticFlag &= getSyntacticModifierFlags(searchSpaceNode);
                            searchSpaceNode = searchSpaceNode.parent;
                            break;
                        default:
                            return void 0;
                    }
                    const sourceFile = searchSpaceNode.getSourceFile();
                    const references = mapDefined(getPossibleSymbolReferenceNodes(sourceFile, "super", searchSpaceNode), (node)=>{
                        if (node.kind !== 108 /* SuperKeyword */ ) return;
                        const container = getSuperContainer(node, /*stopOnFunctions*/ false);
                        return container && isStatic(container) === !!staticFlag && container.parent.symbol === searchSpaceNode.symbol ? nodeEntry(node) : void 0;
                    });
                    return [
                        {
                            definition: {
                                type: 0 /* Symbol */ ,
                                symbol: searchSpaceNode.symbol
                            },
                            references: references
                        }
                    ];
                }
                function isParameterName(node) {
                    return node.kind === 80 /* Identifier */  && node.parent.kind === 168 /* Parameter */  && node.parent.name === node;
                }
                function getReferencesForThisKeyword(thisOrSuperKeyword, sourceFiles, cancellationToken) {
                    let searchSpaceNode = getThisContainer(thisOrSuperKeyword, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                    let staticFlag = 32 /* Static */ ;
                    switch(searchSpaceNode.kind){
                        case 173 /* MethodDeclaration */ :
                        case 172 /* MethodSignature */ :
                            if (isObjectLiteralMethod(searchSpaceNode)) {
                                staticFlag &= getSyntacticModifierFlags(searchSpaceNode);
                                searchSpaceNode = searchSpaceNode.parent;
                                break;
                            }
                        case 171 /* PropertyDeclaration */ :
                        case 170 /* PropertySignature */ :
                        case 175 /* Constructor */ :
                        case 176 /* GetAccessor */ :
                        case 177 /* SetAccessor */ :
                            staticFlag &= getSyntacticModifierFlags(searchSpaceNode);
                            searchSpaceNode = searchSpaceNode.parent;
                            break;
                        case 311 /* SourceFile */ :
                            if (isExternalModule(searchSpaceNode) || isParameterName(thisOrSuperKeyword)) return void 0;
                        case 261 /* FunctionDeclaration */ :
                        case 217 /* FunctionExpression */ :
                            break;
                        default:
                            return void 0;
                    }
                    const references = flatMap(searchSpaceNode.kind === 311 /* SourceFile */  ? sourceFiles : [
                        searchSpaceNode.getSourceFile()
                    ], (sourceFile)=>{
                        cancellationToken.throwIfCancellationRequested();
                        return getPossibleSymbolReferenceNodes(sourceFile, "this", isSourceFile(searchSpaceNode) ? sourceFile : searchSpaceNode).filter((node)=>{
                            if (!isThis(node)) return false;
                            const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                            if (!canHaveSymbol(container)) return false;
                            switch(searchSpaceNode.kind){
                                case 217 /* FunctionExpression */ :
                                case 261 /* FunctionDeclaration */ :
                                    return searchSpaceNode.symbol === container.symbol;
                                case 173 /* MethodDeclaration */ :
                                case 172 /* MethodSignature */ :
                                    return isObjectLiteralMethod(searchSpaceNode) && searchSpaceNode.symbol === container.symbol;
                                case 230 /* ClassExpression */ :
                                case 262 /* ClassDeclaration */ :
                                case 209 /* ObjectLiteralExpression */ :
                                    return container.parent && canHaveSymbol(container.parent) && searchSpaceNode.symbol === container.parent.symbol && isStatic(container) === !!staticFlag;
                                case 311 /* SourceFile */ :
                                    return container.kind === 311 /* SourceFile */  && !isExternalModule(container) && !isParameterName(node);
                            }
                        });
                    }).map((n)=>nodeEntry(n));
                    const thisParameter = firstDefined(references, (r)=>isParameter(r.node.parent) ? r.node : void 0);
                    return [
                        {
                            definition: {
                                type: 3 /* This */ ,
                                node: thisParameter || thisOrSuperKeyword
                            },
                            references: references
                        }
                    ];
                }
                function getReferencesForStringLiteral(node, sourceFiles, checker, cancellationToken) {
                    const type = getContextualTypeFromParentOrAncestorTypeNode(node, checker);
                    const references = flatMap(sourceFiles, (sourceFile)=>{
                        cancellationToken.throwIfCancellationRequested();
                        return mapDefined(getPossibleSymbolReferenceNodes(sourceFile, node.text), (ref)=>{
                            if (isStringLiteralLike(ref) && ref.text === node.text) {
                                if (type) {
                                    const refType = getContextualTypeFromParentOrAncestorTypeNode(ref, checker);
                                    if (type !== checker.getStringType() && type === refType) return nodeEntry(ref, 2 /* StringLiteral */ );
                                } else return isNoSubstitutionTemplateLiteral(ref) && !rangeIsOnSingleLine(ref, sourceFile) ? void 0 : nodeEntry(ref, 2 /* StringLiteral */ );
                            }
                        });
                    });
                    return [
                        {
                            definition: {
                                type: 4 /* String */ ,
                                node: node
                            },
                            references: references
                        }
                    ];
                }
                function populateSearchSymbolSet(symbol, location, checker, isForRename, providePrefixAndSuffixText, implementations) {
                    const result = [];
                    forEachRelatedSymbol(symbol, location, checker, isForRename, !(isForRename && providePrefixAndSuffixText), (sym, root, base)=>{
                        if (base) {
                            if (isStaticSymbol(symbol) !== isStaticSymbol(base)) base = void 0;
                        }
                        result.push(base || root || sym);
                    }, // when try to find implementation, implementations is true, and not allowed to find base class
                    /*allowBaseTypes*/ ()=>!implementations);
                    return result;
                }
                function forEachRelatedSymbol(symbol, location, checker, isForRenamePopulateSearchSymbolSet, onlyIncludeBindingElementAtReferenceLocation, cbSymbol, allowBaseTypes) {
                    const containingObjectLiteralElement = getContainingObjectLiteralElement(location);
                    if (containingObjectLiteralElement) {
                        const shorthandValueSymbol = checker.getShorthandAssignmentValueSymbol(location.parent);
                        if (shorthandValueSymbol && isForRenamePopulateSearchSymbolSet) return cbSymbol(shorthandValueSymbol, /*rootSymbol*/ void 0, /*baseSymbol*/ void 0, 3 /* SearchedLocalFoundProperty */ );
                        const contextualType = checker.getContextualType(containingObjectLiteralElement.parent);
                        const res2 = contextualType && firstDefined(getPropertySymbolsFromContextualType(containingObjectLiteralElement, checker, contextualType, /*unionSymbolOk*/ true), (sym)=>fromRoot(sym, 4 /* SearchedPropertyFoundLocal */ ));
                        if (res2) return res2;
                        const propertySymbol = getPropertySymbolOfDestructuringAssignment(location, checker);
                        const res1 = propertySymbol && cbSymbol(propertySymbol, /*rootSymbol*/ void 0, /*baseSymbol*/ void 0, 4 /* SearchedPropertyFoundLocal */ );
                        if (res1) return res1;
                        const res22 = shorthandValueSymbol && cbSymbol(shorthandValueSymbol, /*rootSymbol*/ void 0, /*baseSymbol*/ void 0, 3 /* SearchedLocalFoundProperty */ );
                        if (res22) return res22;
                    }
                    const aliasedSymbol = getMergedAliasedSymbolOfNamespaceExportDeclaration(location, symbol, checker);
                    if (aliasedSymbol) {
                        const res2 = cbSymbol(aliasedSymbol, /*rootSymbol*/ void 0, /*baseSymbol*/ void 0, 1 /* Node */ );
                        if (res2) return res2;
                    }
                    const res = fromRoot(symbol);
                    if (res) return res;
                    if (symbol.valueDeclaration && isParameterPropertyDeclaration(symbol.valueDeclaration, symbol.valueDeclaration.parent)) {
                        const paramProps = checker.getSymbolsOfParameterPropertyDeclaration(cast(symbol.valueDeclaration, isParameter), symbol.name);
                        Debug.assert(paramProps.length === 2 && !!(paramProps[0].flags & 1 /* FunctionScopedVariable */ ) && !!(paramProps[1].flags & 4 /* Property */ ));
                        return fromRoot(symbol.flags & 1 /* FunctionScopedVariable */  ? paramProps[1] : paramProps[0]);
                    }
                    const exportSpecifier = getDeclarationOfKind(symbol, 280 /* ExportSpecifier */ );
                    if (!isForRenamePopulateSearchSymbolSet || exportSpecifier && !exportSpecifier.propertyName) {
                        const localSymbol = exportSpecifier && checker.getExportSpecifierLocalTargetSymbol(exportSpecifier);
                        if (localSymbol) {
                            const res2 = cbSymbol(localSymbol, /*rootSymbol*/ void 0, /*baseSymbol*/ void 0, 1 /* Node */ );
                            if (res2) return res2;
                        }
                    }
                    if (!isForRenamePopulateSearchSymbolSet) {
                        let bindingElementPropertySymbol;
                        if (onlyIncludeBindingElementAtReferenceLocation) bindingElementPropertySymbol = isObjectBindingElementWithoutPropertyName(location.parent) ? getPropertySymbolFromBindingElement(checker, location.parent) : void 0;
                        else bindingElementPropertySymbol = getPropertySymbolOfObjectBindingPatternWithoutPropertyName(symbol, checker);
                        return bindingElementPropertySymbol && fromRoot(bindingElementPropertySymbol, 4 /* SearchedPropertyFoundLocal */ );
                    }
                    Debug.assert(isForRenamePopulateSearchSymbolSet);
                    const includeOriginalSymbolOfBindingElement = onlyIncludeBindingElementAtReferenceLocation;
                    if (includeOriginalSymbolOfBindingElement) {
                        const bindingElementPropertySymbol = getPropertySymbolOfObjectBindingPatternWithoutPropertyName(symbol, checker);
                        return bindingElementPropertySymbol && fromRoot(bindingElementPropertySymbol, 4 /* SearchedPropertyFoundLocal */ );
                    }
                    function fromRoot(sym, kind) {
                        return firstDefined(checker.getRootSymbols(sym), (rootSymbol)=>cbSymbol(sym, rootSymbol, /*baseSymbol*/ void 0, kind) || (rootSymbol.parent && rootSymbol.parent.flags & 96 /* Interface */  && allowBaseTypes(rootSymbol) ? getPropertySymbolsFromBaseTypes(rootSymbol.parent, rootSymbol.name, checker, (base)=>cbSymbol(sym, rootSymbol, base, kind)) : void 0));
                    }
                    function getPropertySymbolOfObjectBindingPatternWithoutPropertyName(symbol2, checker2) {
                        const bindingElement = getDeclarationOfKind(symbol2, 207 /* BindingElement */ );
                        if (bindingElement && isObjectBindingElementWithoutPropertyName(bindingElement)) return getPropertySymbolFromBindingElement(checker2, bindingElement);
                    }
                }
                function getPropertySymbolsFromBaseTypes(symbol, propertyName, checker, cb) {
                    const seen = /* @__PURE__ */ new Map();
                    return recur(symbol);
                    function recur(symbol2) {
                        if (!(symbol2.flags & 96 /* Interface */ ) || !addToSeen(seen, getSymbolId(symbol2))) return;
                        return firstDefined(symbol2.declarations, (declaration)=>firstDefined(getAllSuperTypeNodes(declaration), (typeReference)=>{
                                const type = checker.getTypeAtLocation(typeReference);
                                const propertySymbol = type && type.symbol && checker.getPropertyOfType(type, propertyName);
                                return type && propertySymbol && (firstDefined(checker.getRootSymbols(propertySymbol), cb) || recur(type.symbol));
                            }));
                    }
                }
                function isStaticSymbol(symbol) {
                    if (!symbol.valueDeclaration) return false;
                    const modifierFlags = getEffectiveModifierFlags(symbol.valueDeclaration);
                    return !!(modifierFlags & 32 /* Static */ );
                }
                function getRelatedSymbol(search, referenceSymbol, referenceLocation, state) {
                    const { checker: checker  } = state;
                    return forEachRelatedSymbol(referenceSymbol, referenceLocation, checker, /*isForRenamePopulateSearchSymbolSet*/ false, /*onlyIncludeBindingElementAtReferenceLocation*/ state.options.use !== 2 /* Rename */  || !!state.options.providePrefixAndSuffixTextForRename, (sym, rootSymbol, baseSymbol, kind)=>{
                        if (baseSymbol) {
                            if (isStaticSymbol(referenceSymbol) !== isStaticSymbol(baseSymbol)) baseSymbol = void 0;
                        }
                        return search.includes(baseSymbol || rootSymbol || sym) ? {
                            symbol: rootSymbol && !(getCheckFlags(sym) & 6 /* Synthetic */ ) ? rootSymbol : sym,
                            kind: kind
                        } : void 0;
                    }, /*allowBaseTypes*/ (rootSymbol)=>!(search.parents && !search.parents.some((parent2)=>explicitlyInheritsFrom(rootSymbol.parent, parent2, state.inheritsFromCache, checker))));
                }
                function getIntersectingMeaningFromDeclarations(node, symbol) {
                    let meaning = getMeaningFromLocation(node);
                    const { declarations: declarations  } = symbol;
                    if (declarations) {
                        let lastIterationMeaning;
                        do {
                            lastIterationMeaning = meaning;
                            for (const declaration of declarations){
                                const declarationMeaning = getMeaningFromDeclaration(declaration);
                                if (declarationMeaning & meaning) meaning |= declarationMeaning;
                            }
                        }while (meaning !== lastIterationMeaning);
                    }
                    return meaning;
                }
                Core2.getIntersectingMeaningFromDeclarations = getIntersectingMeaningFromDeclarations;
                function isImplementation(node) {
                    return !!(node.flags & 16777216 /* Ambient */ ) ? !(isInterfaceDeclaration(node) || isTypeAliasDeclaration(node)) : isVariableLike(node) ? hasInitializer(node) : isFunctionLikeDeclaration(node) ? !!node.body : isClassLike(node) || isModuleOrEnumDeclaration(node);
                }
                function getReferenceEntriesForShorthandPropertyAssignment(node, checker, addReference2) {
                    const refSymbol = checker.getSymbolAtLocation(node);
                    const shorthandSymbol = checker.getShorthandAssignmentValueSymbol(refSymbol.valueDeclaration);
                    if (shorthandSymbol) {
                        for (const declaration of shorthandSymbol.getDeclarations())if (getMeaningFromDeclaration(declaration) & 1 /* Value */ ) addReference2(declaration);
                    }
                }
                Core2.getReferenceEntriesForShorthandPropertyAssignment = getReferenceEntriesForShorthandPropertyAssignment;
                function forEachDescendantOfKind(node, kind, action) {
                    forEachChild(node, (child)=>{
                        if (child.kind === kind) action(child);
                        forEachDescendantOfKind(child, kind, action);
                    });
                }
                function tryGetClassByExtendingIdentifier(node) {
                    return tryGetClassExtendingExpressionWithTypeArguments(climbPastPropertyAccess(node).parent);
                }
                function getParentSymbolsOfPropertyAccess(location, symbol, checker) {
                    const propertyAccessExpression = isRightSideOfPropertyAccess(location) ? location.parent : void 0;
                    const lhsType = propertyAccessExpression && checker.getTypeAtLocation(propertyAccessExpression.expression);
                    const res = mapDefined(lhsType && (lhsType.isUnionOrIntersection() ? lhsType.types : lhsType.symbol === symbol.parent ? void 0 : [
                        lhsType
                    ]), (t)=>t.symbol && t.symbol.flags & 96 /* Interface */  ? t.symbol : void 0);
                    return res.length === 0 ? void 0 : res;
                }
                function isForRenameWithPrefixAndSuffixText(options) {
                    return options.use === 2 /* Rename */  && options.providePrefixAndSuffixTextForRename;
                }
            })(Core || (Core = {}));
        }
    });
    // src/services/_namespaces/ts.FindAllReferences.ts
    var ts_FindAllReferences_exports = {};
    __export(ts_FindAllReferences_exports, {
        Core: ()=>Core,
        DefinitionKind: ()=>DefinitionKind,
        EntryKind: ()=>EntryKind,
        ExportKind: ()=>ExportKind2,
        FindReferencesUse: ()=>FindReferencesUse,
        ImportExport: ()=>ImportExport,
        createImportTracker: ()=>createImportTracker,
        findModuleReferences: ()=>findModuleReferences,
        findReferenceOrRenameEntries: ()=>findReferenceOrRenameEntries,
        findReferencedSymbols: ()=>findReferencedSymbols,
        getContextNode: ()=>getContextNode,
        getExportInfo: ()=>getExportInfo,
        getImplementationsAtPosition: ()=>getImplementationsAtPosition,
        getImportOrExportSymbol: ()=>getImportOrExportSymbol,
        getReferenceEntriesForNode: ()=>getReferenceEntriesForNode,
        getTextSpanOfEntry: ()=>getTextSpanOfEntry,
        isContextWithStartAndEndNode: ()=>isContextWithStartAndEndNode,
        isDeclarationOfSymbol: ()=>isDeclarationOfSymbol,
        nodeEntry: ()=>nodeEntry,
        toContextSpan: ()=>toContextSpan,
        toHighlightSpan: ()=>toHighlightSpan,
        toReferenceEntry: ()=>toReferenceEntry,
        toRenameLocation: ()=>toRenameLocation
    });
    var init_ts_FindAllReferences = __esm({
        "src/services/_namespaces/ts.FindAllReferences.ts" () {
            "use strict";
            init_importTracker();
            init_findAllReferences();
        }
    });
    // src/services/goToDefinition.ts
    function getDefinitionAtPosition(program, sourceFile, position, searchOtherFilesOnly, stopAtAlias) {
        var _a, _b;
        const resolvedRef = getReferenceAtPosition(sourceFile, position, program);
        const fileReferenceDefinition = resolvedRef && [
            getDefinitionInfoForFileReference(resolvedRef.reference.fileName, resolvedRef.fileName, resolvedRef.unverified)
        ] || emptyArray;
        if (resolvedRef == null ? void 0 : resolvedRef.file) return fileReferenceDefinition;
        const node = getTouchingPropertyName(sourceFile, position);
        if (node === sourceFile) return void 0;
        const { parent: parent2  } = node;
        const typeChecker = program.getTypeChecker();
        if (node.kind === 163 /* OverrideKeyword */  || isIdentifier(node) && isJSDocOverrideTag(parent2) && parent2.tagName === node) return getDefinitionFromOverriddenMember(typeChecker, node) || emptyArray;
        if (isJumpStatementTarget(node)) {
            const label = getTargetLabel(node.parent, node.text);
            return label ? [
                createDefinitionInfoFromName(typeChecker, label, "label" /* label */ , node.text, /*containerName*/ void 0)
            ] : void 0;
        }
        if (node.kind === 107 /* ReturnKeyword */ ) {
            const functionDeclaration = findAncestor(node.parent, (n)=>isClassStaticBlockDeclaration(n) ? "quit" : isFunctionLikeDeclaration(n));
            return functionDeclaration ? [
                createDefinitionFromSignatureDeclaration(typeChecker, functionDeclaration)
            ] : void 0;
        }
        if (node.kind === 135 /* AwaitKeyword */ ) {
            const functionDeclaration = findAncestor(node, (n)=>isFunctionLikeDeclaration(n));
            const isAsyncFunction2 = functionDeclaration && some(functionDeclaration.modifiers, (node2)=>node2.kind === 134 /* AsyncKeyword */ );
            return isAsyncFunction2 ? [
                createDefinitionFromSignatureDeclaration(typeChecker, functionDeclaration)
            ] : void 0;
        }
        if (node.kind === 127 /* YieldKeyword */ ) {
            const functionDeclaration = findAncestor(node, (n)=>isFunctionLikeDeclaration(n));
            const isGeneratorFunction = functionDeclaration && functionDeclaration.asteriskToken;
            return isGeneratorFunction ? [
                createDefinitionFromSignatureDeclaration(typeChecker, functionDeclaration)
            ] : void 0;
        }
        if (isStaticModifier(node) && isClassStaticBlockDeclaration(node.parent)) {
            const classDecl = node.parent.parent;
            const { symbol: symbol2 , failedAliasResolution: failedAliasResolution2  } = getSymbol(classDecl, typeChecker, stopAtAlias);
            const staticBlocks = filter(classDecl.members, isClassStaticBlockDeclaration);
            const containerName = symbol2 ? typeChecker.symbolToString(symbol2, classDecl) : "";
            const sourceFile2 = node.getSourceFile();
            return map(staticBlocks, (staticBlock)=>{
                let { pos: pos  } = moveRangePastModifiers(staticBlock);
                pos = skipTrivia(sourceFile2.text, pos);
                return createDefinitionInfoFromName(typeChecker, staticBlock, "constructor" /* constructorImplementationElement */ , "static {}", containerName, /*unverified*/ false, failedAliasResolution2, {
                    start: pos,
                    length: 6
                });
            });
        }
        let { symbol: symbol , failedAliasResolution: failedAliasResolution  } = getSymbol(node, typeChecker, stopAtAlias);
        let fallbackNode = node;
        if (searchOtherFilesOnly && failedAliasResolution) {
            const importDeclaration = forEach([
                node,
                ...(symbol == null ? void 0 : symbol.declarations) || emptyArray
            ], (n)=>findAncestor(n, isAnyImportOrBareOrAccessedRequire));
            const moduleSpecifier = importDeclaration && tryGetModuleSpecifierFromDeclaration(importDeclaration);
            if (moduleSpecifier) {
                ({ symbol: symbol , failedAliasResolution: failedAliasResolution  } = getSymbol(moduleSpecifier, typeChecker, stopAtAlias));
                fallbackNode = moduleSpecifier;
            }
        }
        if (!symbol && isModuleSpecifierLike(fallbackNode)) {
            const ref = (_b = (_a = sourceFile.resolvedModules) == null ? void 0 : _a.get(fallbackNode.text, getModeForUsageLocation(sourceFile, fallbackNode))) == null ? void 0 : _b.resolvedModule;
            if (ref) return [
                {
                    name: fallbackNode.text,
                    fileName: ref.resolvedFileName,
                    containerName: void 0,
                    containerKind: void 0,
                    kind: "script" /* scriptElement */ ,
                    textSpan: createTextSpan(0, 0),
                    failedAliasResolution: failedAliasResolution,
                    isAmbient: isDeclarationFileName(ref.resolvedFileName),
                    unverified: fallbackNode !== node
                }
            ];
        }
        if (!symbol) return concatenate(fileReferenceDefinition, getDefinitionInfoForIndexSignatures(node, typeChecker));
        if (searchOtherFilesOnly && every(symbol.declarations, (d)=>d.getSourceFile().fileName === sourceFile.fileName)) return void 0;
        const calledDeclaration = tryGetSignatureDeclaration(typeChecker, node);
        if (calledDeclaration && !(isJsxOpeningLikeElement(node.parent) && isConstructorLike(calledDeclaration))) {
            const sigInfo = createDefinitionFromSignatureDeclaration(typeChecker, calledDeclaration, failedAliasResolution);
            if (typeChecker.getRootSymbols(symbol).some((s)=>symbolMatchesSignature(s, calledDeclaration))) return [
                sigInfo
            ];
            else {
                const defs = getDefinitionFromSymbol(typeChecker, symbol, node, failedAliasResolution, calledDeclaration) || emptyArray;
                return node.kind === 108 /* SuperKeyword */  ? [
                    sigInfo,
                    ...defs
                ] : [
                    ...defs,
                    sigInfo
                ];
            }
        }
        if (node.parent.kind === 303 /* ShorthandPropertyAssignment */ ) {
            const shorthandSymbol = typeChecker.getShorthandAssignmentValueSymbol(symbol.valueDeclaration);
            const definitions = (shorthandSymbol == null ? void 0 : shorthandSymbol.declarations) ? shorthandSymbol.declarations.map((decl)=>createDefinitionInfo(decl, typeChecker, shorthandSymbol, node, /*unverified*/ false, failedAliasResolution)) : emptyArray;
            return concatenate(definitions, getDefinitionFromObjectLiteralElement(typeChecker, node));
        }
        if (isPropertyName(node) && isBindingElement(parent2) && isObjectBindingPattern(parent2.parent) && node === (parent2.propertyName || parent2.name)) {
            const name = getNameFromPropertyName(node);
            const type = typeChecker.getTypeAtLocation(parent2.parent);
            return name === void 0 ? emptyArray : flatMap(type.isUnion() ? type.types : [
                type
            ], (t)=>{
                const prop = t.getProperty(name);
                return prop && getDefinitionFromSymbol(typeChecker, prop, node);
            });
        }
        const objectLiteralElementDefinition = getDefinitionFromObjectLiteralElement(typeChecker, node);
        return concatenate(fileReferenceDefinition, objectLiteralElementDefinition.length ? objectLiteralElementDefinition : getDefinitionFromSymbol(typeChecker, symbol, node, failedAliasResolution));
    }
    function symbolMatchesSignature(s, calledDeclaration) {
        var _a;
        return s === calledDeclaration.symbol || s === calledDeclaration.symbol.parent || isAssignmentExpression(calledDeclaration.parent) || !isCallLikeExpression(calledDeclaration.parent) && s === ((_a = tryCast(calledDeclaration.parent, canHaveSymbol)) == null ? void 0 : _a.symbol);
    }
    function getDefinitionFromObjectLiteralElement(typeChecker, node) {
        const element = getContainingObjectLiteralElement(node);
        if (element) {
            const contextualType = element && typeChecker.getContextualType(element.parent);
            if (contextualType) return flatMap(getPropertySymbolsFromContextualType(element, typeChecker, contextualType, /*unionSymbolOk*/ false), (propertySymbol)=>getDefinitionFromSymbol(typeChecker, propertySymbol, node));
        }
        return emptyArray;
    }
    function getDefinitionFromOverriddenMember(typeChecker, node) {
        const classElement = findAncestor(node, isClassElement);
        if (!(classElement && classElement.name)) return;
        const baseDeclaration = findAncestor(classElement, isClassLike);
        if (!baseDeclaration) return;
        const baseTypeNode = getEffectiveBaseTypeNode(baseDeclaration);
        if (!baseTypeNode) return;
        const expression = skipParentheses(baseTypeNode.expression);
        const base = isClassExpression(expression) ? expression.symbol : typeChecker.getSymbolAtLocation(expression);
        if (!base) return;
        const name = unescapeLeadingUnderscores(getTextOfPropertyName(classElement.name));
        const symbol = hasStaticModifier(classElement) ? typeChecker.getPropertyOfType(typeChecker.getTypeOfSymbol(base), name) : typeChecker.getPropertyOfType(typeChecker.getDeclaredTypeOfSymbol(base), name);
        if (!symbol) return;
        return getDefinitionFromSymbol(typeChecker, symbol, node);
    }
    function getReferenceAtPosition(sourceFile, position, program) {
        var _a, _b, _c, _d;
        const referencePath = findReferenceInPosition(sourceFile.referencedFiles, position);
        if (referencePath) {
            const file = program.getSourceFileFromReference(sourceFile, referencePath);
            return file && {
                reference: referencePath,
                fileName: file.fileName,
                file: file,
                unverified: false
            };
        }
        const typeReferenceDirective = findReferenceInPosition(sourceFile.typeReferenceDirectives, position);
        if (typeReferenceDirective) {
            const reference = (_a = program.getResolvedTypeReferenceDirectives().get(typeReferenceDirective.fileName, typeReferenceDirective.resolutionMode || sourceFile.impliedNodeFormat)) == null ? void 0 : _a.resolvedTypeReferenceDirective;
            const file = reference && program.getSourceFile(reference.resolvedFileName);
            return file && {
                reference: typeReferenceDirective,
                fileName: file.fileName,
                file: file,
                unverified: false
            };
        }
        const libReferenceDirective = findReferenceInPosition(sourceFile.libReferenceDirectives, position);
        if (libReferenceDirective) {
            const file = program.getLibFileFromReference(libReferenceDirective);
            return file && {
                reference: libReferenceDirective,
                fileName: file.fileName,
                file: file,
                unverified: false
            };
        }
        if ((_b = sourceFile.resolvedModules) == null ? void 0 : _b.size()) {
            const node = getTouchingToken(sourceFile, position);
            if (isModuleSpecifierLike(node) && isExternalModuleNameRelative(node.text) && sourceFile.resolvedModules.has(node.text, getModeForUsageLocation(sourceFile, node))) {
                const verifiedFileName = (_d = (_c = sourceFile.resolvedModules.get(node.text, getModeForUsageLocation(sourceFile, node))) == null ? void 0 : _c.resolvedModule) == null ? void 0 : _d.resolvedFileName;
                const fileName = verifiedFileName || resolvePath(getDirectoryPath(sourceFile.fileName), node.text);
                return {
                    file: program.getSourceFile(fileName),
                    fileName: fileName,
                    reference: {
                        pos: node.getStart(),
                        end: node.getEnd(),
                        fileName: node.text
                    },
                    unverified: !verifiedFileName
                };
            }
        }
        return void 0;
    }
    function getTypeDefinitionAtPosition(typeChecker, sourceFile, position) {
        const node = getTouchingPropertyName(sourceFile, position);
        if (node === sourceFile) return void 0;
        if (isImportMeta(node.parent) && node.parent.name === node) return definitionFromType(typeChecker.getTypeAtLocation(node.parent), typeChecker, node.parent, /*failedAliasResolution*/ false);
        const { symbol: symbol , failedAliasResolution: failedAliasResolution  } = getSymbol(node, typeChecker, /*stopAtAlias*/ false);
        if (!symbol) return void 0;
        const typeAtLocation = typeChecker.getTypeOfSymbolAtLocation(symbol, node);
        const returnType = tryGetReturnTypeOfFunction(symbol, typeAtLocation, typeChecker);
        const fromReturnType = returnType && definitionFromType(returnType, typeChecker, node, failedAliasResolution);
        const typeDefinitions = fromReturnType && fromReturnType.length !== 0 ? fromReturnType : definitionFromType(typeAtLocation, typeChecker, node, failedAliasResolution);
        return typeDefinitions.length ? typeDefinitions : !(symbol.flags & 111551 /* Value */ ) && symbol.flags & 788968 /* Type */  ? getDefinitionFromSymbol(typeChecker, skipAlias(symbol, typeChecker), node, failedAliasResolution) : void 0;
    }
    function definitionFromType(type, checker, node, failedAliasResolution) {
        return flatMap(type.isUnion() && !(type.flags & 32 /* Enum */ ) ? type.types : [
            type
        ], (t)=>t.symbol && getDefinitionFromSymbol(checker, t.symbol, node, failedAliasResolution));
    }
    function tryGetReturnTypeOfFunction(symbol, type, checker) {
        if (type.symbol === symbol || // At `const f = () => {}`, the symbol is `f` and the type symbol is at `() => {}`
        symbol.valueDeclaration && type.symbol && isVariableDeclaration(symbol.valueDeclaration) && symbol.valueDeclaration.initializer === type.symbol.valueDeclaration) {
            const sigs = type.getCallSignatures();
            if (sigs.length === 1) return checker.getReturnTypeOfSignature(first(sigs));
        }
        return void 0;
    }
    function getDefinitionAndBoundSpan(program, sourceFile, position) {
        const definitions = getDefinitionAtPosition(program, sourceFile, position);
        if (!definitions || definitions.length === 0) return void 0;
        const comment = findReferenceInPosition(sourceFile.referencedFiles, position) || findReferenceInPosition(sourceFile.typeReferenceDirectives, position) || findReferenceInPosition(sourceFile.libReferenceDirectives, position);
        if (comment) return {
            definitions: definitions,
            textSpan: createTextSpanFromRange(comment)
        };
        const node = getTouchingPropertyName(sourceFile, position);
        const textSpan = createTextSpan(node.getStart(), node.getWidth());
        return {
            definitions: definitions,
            textSpan: textSpan
        };
    }
    function getDefinitionInfoForIndexSignatures(node, checker) {
        return mapDefined(checker.getIndexInfosAtLocation(node), (info)=>info.declaration && createDefinitionFromSignatureDeclaration(checker, info.declaration));
    }
    function getSymbol(node, checker, stopAtAlias) {
        const symbol = checker.getSymbolAtLocation(node);
        let failedAliasResolution = false;
        if ((symbol == null ? void 0 : symbol.declarations) && symbol.flags & 2097152 /* Alias */  && !stopAtAlias && shouldSkipAlias(node, symbol.declarations[0])) {
            const aliased = checker.getAliasedSymbol(symbol);
            if (aliased.declarations) return {
                symbol: aliased
            };
            else failedAliasResolution = true;
        }
        return {
            symbol: symbol,
            failedAliasResolution: failedAliasResolution
        };
    }
    function shouldSkipAlias(node, declaration) {
        if (node.kind !== 80 /* Identifier */ ) return false;
        if (node.parent === declaration) return true;
        if (declaration.kind === 273 /* NamespaceImport */ ) return false;
        return true;
    }
    function isExpandoDeclaration(node) {
        if (!isAssignmentDeclaration(node)) return false;
        const containingAssignment = findAncestor(node, (p)=>{
            if (isAssignmentExpression(p)) return true;
            if (!isAssignmentDeclaration(p)) return "quit";
            return false;
        });
        return !!containingAssignment && getAssignmentDeclarationKind(containingAssignment) === 5 /* Property */ ;
    }
    function getDefinitionFromSymbol(typeChecker, symbol, node, failedAliasResolution, excludeDeclaration) {
        const filteredDeclarations = filter(symbol.declarations, (d)=>d !== excludeDeclaration);
        const withoutExpandos = filter(filteredDeclarations, (d)=>!isExpandoDeclaration(d));
        const results = some(withoutExpandos) ? withoutExpandos : filteredDeclarations;
        return getConstructSignatureDefinition() || getCallSignatureDefinition() || map(results, (declaration)=>createDefinitionInfo(declaration, typeChecker, symbol, node, /*unverified*/ false, failedAliasResolution));
        function getConstructSignatureDefinition() {
            if (symbol.flags & 32 /* Class */  && !(symbol.flags & 19 /* Variable */ ) && (isNewExpressionTarget(node) || node.kind === 137 /* ConstructorKeyword */ )) {
                const cls = find(filteredDeclarations, isClassLike) || Debug.fail("Expected declaration to have at least one class-like declaration");
                return getSignatureDefinition(cls.members, /*selectConstructors*/ true);
            }
        }
        function getCallSignatureDefinition() {
            return isCallOrNewExpressionTarget(node) || isNameOfFunctionDeclaration(node) ? getSignatureDefinition(filteredDeclarations, /*selectConstructors*/ false) : void 0;
        }
        function getSignatureDefinition(signatureDeclarations, selectConstructors) {
            if (!signatureDeclarations) return void 0;
            const declarations = signatureDeclarations.filter(selectConstructors ? isConstructorDeclaration : isFunctionLike);
            const declarationsWithBody = declarations.filter((d)=>!!d.body);
            return declarations.length ? declarationsWithBody.length !== 0 ? declarationsWithBody.map((x)=>createDefinitionInfo(x, typeChecker, symbol, node)) : [
                createDefinitionInfo(last(declarations), typeChecker, symbol, node, /*unverified*/ false, failedAliasResolution)
            ] : void 0;
        }
    }
    function createDefinitionInfo(declaration, checker, symbol, node, unverified, failedAliasResolution) {
        const symbolName2 = checker.symbolToString(symbol);
        const symbolKind = ts_SymbolDisplay_exports.getSymbolKind(checker, symbol, node);
        const containerName = symbol.parent ? checker.symbolToString(symbol.parent, node) : "";
        return createDefinitionInfoFromName(checker, declaration, symbolKind, symbolName2, containerName, unverified, failedAliasResolution);
    }
    function createDefinitionInfoFromName(checker, declaration, symbolKind, symbolName2, containerName, unverified, failedAliasResolution, textSpan) {
        const sourceFile = declaration.getSourceFile();
        if (!textSpan) {
            const name = getNameOfDeclaration(declaration) || declaration;
            textSpan = createTextSpanFromNode(name, sourceFile);
        }
        return {
            fileName: sourceFile.fileName,
            textSpan: textSpan,
            kind: symbolKind,
            name: symbolName2,
            containerKind: void 0,
            containerName: // TODO: GH#18217
            containerName,
            ...ts_FindAllReferences_exports.toContextSpan(textSpan, sourceFile, ts_FindAllReferences_exports.getContextNode(declaration)),
            isLocal: !isDefinitionVisible(checker, declaration),
            isAmbient: !!(declaration.flags & 16777216 /* Ambient */ ),
            unverified: unverified,
            failedAliasResolution: failedAliasResolution
        };
    }
    function isDefinitionVisible(checker, declaration) {
        if (checker.isDeclarationVisible(declaration)) return true;
        if (!declaration.parent) return false;
        if (hasInitializer(declaration.parent) && declaration.parent.initializer === declaration) return isDefinitionVisible(checker, declaration.parent);
        switch(declaration.kind){
            case 171 /* PropertyDeclaration */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 173 /* MethodDeclaration */ :
                if (hasEffectiveModifier(declaration, 8 /* Private */ )) return false;
            case 175 /* Constructor */ :
            case 302 /* PropertyAssignment */ :
            case 303 /* ShorthandPropertyAssignment */ :
            case 209 /* ObjectLiteralExpression */ :
            case 230 /* ClassExpression */ :
            case 218 /* ArrowFunction */ :
            case 217 /* FunctionExpression */ :
                return isDefinitionVisible(checker, declaration.parent);
            default:
                return false;
        }
    }
    function createDefinitionFromSignatureDeclaration(typeChecker, decl, failedAliasResolution) {
        return createDefinitionInfo(decl, typeChecker, decl.symbol, decl, /*unverified*/ false, failedAliasResolution);
    }
    function findReferenceInPosition(refs, pos) {
        return find(refs, (ref)=>textRangeContainsPositionInclusive(ref, pos));
    }
    function getDefinitionInfoForFileReference(name, targetFileName, unverified) {
        return {
            fileName: targetFileName,
            textSpan: createTextSpanFromBounds(0, 0),
            kind: "script" /* scriptElement */ ,
            name: name,
            containerName: void 0,
            containerKind: void 0,
            unverified: // TODO: GH#18217
            unverified
        };
    }
    function getAncestorCallLikeExpression(node) {
        const target = findAncestor(node, (n)=>!isRightSideOfPropertyAccess(n));
        const callLike = target == null ? void 0 : target.parent;
        return callLike && isCallLikeExpression(callLike) && getInvokedExpression(callLike) === target ? callLike : void 0;
    }
    function tryGetSignatureDeclaration(typeChecker, node) {
        const callLike = getAncestorCallLikeExpression(node);
        const signature = callLike && typeChecker.getResolvedSignature(callLike);
        return tryCast(signature && signature.declaration, (d)=>isFunctionLike(d) && !isFunctionTypeNode(d));
    }
    function isConstructorLike(node) {
        switch(node.kind){
            case 175 /* Constructor */ :
            case 184 /* ConstructorType */ :
            case 179 /* ConstructSignature */ :
                return true;
            default:
                return false;
        }
    }
    var init_goToDefinition = __esm({
        "src/services/goToDefinition.ts" () {
            "use strict";
            init_ts4();
        }
    });
    // src/services/_namespaces/ts.GoToDefinition.ts
    var ts_GoToDefinition_exports = {};
    __export(ts_GoToDefinition_exports, {
        createDefinitionInfo: ()=>createDefinitionInfo,
        findReferenceInPosition: ()=>findReferenceInPosition,
        getDefinitionAndBoundSpan: ()=>getDefinitionAndBoundSpan,
        getDefinitionAtPosition: ()=>getDefinitionAtPosition,
        getReferenceAtPosition: ()=>getReferenceAtPosition,
        getTypeDefinitionAtPosition: ()=>getTypeDefinitionAtPosition
    });
    var init_ts_GoToDefinition = __esm({
        "src/services/_namespaces/ts.GoToDefinition.ts" () {
            "use strict";
            init_goToDefinition();
        }
    });
    // src/services/inlayHints.ts
    function shouldShowParameterNameHints(preferences) {
        return preferences.includeInlayParameterNameHints === "literals" || preferences.includeInlayParameterNameHints === "all";
    }
    function shouldShowLiteralParameterNameHintsOnly(preferences) {
        return preferences.includeInlayParameterNameHints === "literals";
    }
    function provideInlayHints(context) {
        const { file: file , program: program , span: span , cancellationToken: cancellationToken , preferences: preferences  } = context;
        const sourceFileText = file.text;
        const compilerOptions = program.getCompilerOptions();
        const checker = program.getTypeChecker();
        const result = [];
        visitor(file);
        return result;
        function visitor(node) {
            if (!node || node.getFullWidth() === 0) return;
            switch(node.kind){
                case 266 /* ModuleDeclaration */ :
                case 262 /* ClassDeclaration */ :
                case 263 /* InterfaceDeclaration */ :
                case 261 /* FunctionDeclaration */ :
                case 230 /* ClassExpression */ :
                case 217 /* FunctionExpression */ :
                case 173 /* MethodDeclaration */ :
                case 218 /* ArrowFunction */ :
                    cancellationToken.throwIfCancellationRequested();
            }
            if (!textSpanIntersectsWith(span, node.pos, node.getFullWidth())) return;
            if (isTypeNode(node) && !isExpressionWithTypeArguments(node)) return;
            if (preferences.includeInlayVariableTypeHints && isVariableDeclaration(node)) visitVariableLikeDeclaration(node);
            else if (preferences.includeInlayPropertyDeclarationTypeHints && isPropertyDeclaration(node)) visitVariableLikeDeclaration(node);
            else if (preferences.includeInlayEnumMemberValueHints && isEnumMember(node)) visitEnumMember(node);
            else if (shouldShowParameterNameHints(preferences) && (isCallExpression(node) || isNewExpression(node))) visitCallOrNewExpression(node);
            else {
                if (preferences.includeInlayFunctionParameterTypeHints && isFunctionLikeDeclaration(node) && hasContextSensitiveParameters(node)) visitFunctionLikeForParameterType(node);
                if (preferences.includeInlayFunctionLikeReturnTypeHints && isSignatureSupportingReturnAnnotation(node)) visitFunctionDeclarationLikeForReturnType(node);
            }
            return forEachChild(node, visitor);
        }
        function isSignatureSupportingReturnAnnotation(node) {
            return isArrowFunction(node) || isFunctionExpression(node) || isFunctionDeclaration(node) || isMethodDeclaration(node) || isGetAccessorDeclaration(node);
        }
        function addParameterHints(text, position, isFirstVariadicArgument) {
            result.push({
                text: `${isFirstVariadicArgument ? "..." : ""}${truncation(text, maxHintsLength)}:`,
                position: position,
                kind: "Parameter" /* Parameter */ ,
                whitespaceAfter: true
            });
        }
        function addTypeHints(text, position) {
            result.push({
                text: `: ${truncation(text, maxHintsLength)}`,
                position: position,
                kind: "Type" /* Type */ ,
                whitespaceBefore: true
            });
        }
        function addEnumMemberValueHints(text, position) {
            result.push({
                text: `= ${truncation(text, maxHintsLength)}`,
                position: position,
                kind: "Enum" /* Enum */ ,
                whitespaceBefore: true
            });
        }
        function visitEnumMember(member) {
            if (member.initializer) return;
            const enumValue = checker.getConstantValue(member);
            if (enumValue !== void 0) addEnumMemberValueHints(enumValue.toString(), member.end);
        }
        function isModuleReferenceType(type) {
            return type.symbol && type.symbol.flags & 1536 /* Module */ ;
        }
        function visitVariableLikeDeclaration(decl) {
            if (!decl.initializer || isBindingPattern(decl.name) || isVariableDeclaration(decl) && !isHintableDeclaration(decl)) return;
            const effectiveTypeAnnotation = getEffectiveTypeAnnotationNode(decl);
            if (effectiveTypeAnnotation) return;
            const declarationType = checker.getTypeAtLocation(decl);
            if (isModuleReferenceType(declarationType)) return;
            const typeDisplayString = printTypeInSingleLine(declarationType);
            if (typeDisplayString) {
                const isVariableNameMatchesType = preferences.includeInlayVariableTypeHintsWhenTypeMatchesName === false && equateStringsCaseInsensitive(decl.name.getText(), typeDisplayString);
                if (isVariableNameMatchesType) return;
                addTypeHints(typeDisplayString, decl.name.end);
            }
        }
        function visitCallOrNewExpression(expr) {
            const args = expr.arguments;
            if (!args || !args.length) return;
            const candidates = [];
            const signature = checker.getResolvedSignatureForSignatureHelp(expr, candidates);
            if (!signature || !candidates.length) return;
            for(let i = 0; i < args.length; ++i){
                const originalArg = args[i];
                const arg = skipParentheses(originalArg);
                if (shouldShowLiteralParameterNameHintsOnly(preferences) && !isHintableLiteral(arg)) continue;
                const identifierNameInfo = checker.getParameterIdentifierNameAtPosition(signature, i);
                if (identifierNameInfo) {
                    const [parameterName, isFirstVariadicArgument] = identifierNameInfo;
                    const isParameterNameNotSameAsArgument = preferences.includeInlayParameterNameHintsWhenArgumentMatchesName || !identifierOrAccessExpressionPostfixMatchesParameterName(arg, parameterName);
                    if (!isParameterNameNotSameAsArgument && !isFirstVariadicArgument) continue;
                    const name = unescapeLeadingUnderscores(parameterName);
                    if (leadingCommentsContainsParameterName(arg, name)) continue;
                    addParameterHints(name, originalArg.getStart(), isFirstVariadicArgument);
                }
            }
        }
        function identifierOrAccessExpressionPostfixMatchesParameterName(expr, parameterName) {
            if (isIdentifier(expr)) return expr.text === parameterName;
            if (isPropertyAccessExpression(expr)) return expr.name.text === parameterName;
            return false;
        }
        function leadingCommentsContainsParameterName(node, name) {
            if (!isIdentifierText(name, compilerOptions.target, getLanguageVariant(file.scriptKind))) return false;
            const ranges = getLeadingCommentRanges(sourceFileText, node.pos);
            if (!(ranges == null ? void 0 : ranges.length)) return false;
            const regex = leadingParameterNameCommentRegexFactory(name);
            return some(ranges, (range)=>regex.test(sourceFileText.substring(range.pos, range.end)));
        }
        function isHintableLiteral(node) {
            switch(node.kind){
                case 223 /* PrefixUnaryExpression */ :
                    {
                        const operand = node.operand;
                        return isLiteralExpression(operand) || isIdentifier(operand) && isInfinityOrNaNString(operand.escapedText);
                    }
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 106 /* NullKeyword */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 227 /* TemplateExpression */ :
                    return true;
                case 80 /* Identifier */ :
                    {
                        const name = node.escapedText;
                        return isUndefined(name) || isInfinityOrNaNString(name);
                    }
            }
            return isLiteralExpression(node);
        }
        function visitFunctionDeclarationLikeForReturnType(decl) {
            if (isArrowFunction(decl)) {
                if (!findChildOfKind(decl, 21 /* OpenParenToken */ , file)) return;
            }
            const effectiveTypeAnnotation = getEffectiveReturnTypeNode(decl);
            if (effectiveTypeAnnotation || !decl.body) return;
            const signature = checker.getSignatureFromDeclaration(decl);
            if (!signature) return;
            const returnType = checker.getReturnTypeOfSignature(signature);
            if (isModuleReferenceType(returnType)) return;
            const typeDisplayString = printTypeInSingleLine(returnType);
            if (!typeDisplayString) return;
            addTypeHints(typeDisplayString, getTypeAnnotationPosition(decl));
        }
        function getTypeAnnotationPosition(decl) {
            const closeParenToken = findChildOfKind(decl, 22 /* CloseParenToken */ , file);
            if (closeParenToken) return closeParenToken.end;
            return decl.parameters.end;
        }
        function visitFunctionLikeForParameterType(node) {
            const signature = checker.getSignatureFromDeclaration(node);
            if (!signature) return;
            for(let i = 0; i < node.parameters.length && i < signature.parameters.length; ++i){
                const param = node.parameters[i];
                if (!isHintableDeclaration(param)) continue;
                const effectiveTypeAnnotation = getEffectiveTypeAnnotationNode(param);
                if (effectiveTypeAnnotation) continue;
                const typeDisplayString = getParameterDeclarationTypeDisplayString(signature.parameters[i]);
                if (!typeDisplayString) continue;
                addTypeHints(typeDisplayString, param.questionToken ? param.questionToken.end : param.name.end);
            }
        }
        function getParameterDeclarationTypeDisplayString(symbol) {
            const valueDeclaration = symbol.valueDeclaration;
            if (!valueDeclaration || !isParameter(valueDeclaration)) return void 0;
            const signatureParamType = checker.getTypeOfSymbolAtLocation(symbol, valueDeclaration);
            if (isModuleReferenceType(signatureParamType)) return void 0;
            return printTypeInSingleLine(signatureParamType);
        }
        function truncation(text, maxLength2) {
            if (text.length > maxLength2) return text.substr(0, maxLength2 - 3) + "...";
            return text;
        }
        function printTypeInSingleLine(type) {
            const flags = 71286784 /* UseAliasDefinedOutsideCurrentScope */ ;
            const printer = createPrinterWithRemoveComments();
            return usingSingleLineStringWriter((writer)=>{
                const typeNode = checker.typeToTypeNode(type, /*enclosingDeclaration*/ void 0, flags);
                Debug.assertIsDefined(typeNode, "should always get typenode");
                printer.writeNode(4 /* Unspecified */ , typeNode, /*sourceFile*/ file, writer);
            });
        }
        function isUndefined(name) {
            return name === "undefined";
        }
        function isHintableDeclaration(node) {
            if ((isParameterDeclaration(node) || isVariableDeclaration(node) && isVarConst(node)) && node.initializer) {
                const initializer = skipParentheses(node.initializer);
                return !(isHintableLiteral(initializer) || isNewExpression(initializer) || isObjectLiteralExpression(initializer) || isAssertionExpression(initializer));
            }
            return true;
        }
    }
    var maxHintsLength, leadingParameterNameCommentRegexFactory;
    var init_inlayHints = __esm({
        "src/services/inlayHints.ts" () {
            "use strict";
            init_ts4();
            maxHintsLength = 30;
            leadingParameterNameCommentRegexFactory = (name)=>{
                return new RegExp(`^\\s?/\\*\\*?\\s?${name}\\s?\\*\\/\\s?$`);
            };
        }
    });
    // src/services/_namespaces/ts.InlayHints.ts
    var ts_InlayHints_exports = {};
    __export(ts_InlayHints_exports, {
        provideInlayHints: ()=>provideInlayHints
    });
    var init_ts_InlayHints = __esm({
        "src/services/_namespaces/ts.InlayHints.ts" () {
            "use strict";
            init_inlayHints();
        }
    });
    // src/services/jsDoc.ts
    function getJsDocCommentsFromDeclarations(declarations, checker) {
        const parts = [];
        forEachUnique(declarations, (declaration)=>{
            for (const jsdoc of getCommentHavingNodes(declaration)){
                const inheritDoc = isJSDoc(jsdoc) && jsdoc.tags && find(jsdoc.tags, (t)=>t.kind === 333 /* JSDocTag */  && (t.tagName.escapedText === "inheritDoc" || t.tagName.escapedText === "inheritdoc"));
                if (jsdoc.comment === void 0 && !inheritDoc || isJSDoc(jsdoc) && declaration.kind !== 352 /* JSDocTypedefTag */  && declaration.kind !== 344 /* JSDocCallbackTag */  && jsdoc.tags && jsdoc.tags.some((t)=>t.kind === 352 /* JSDocTypedefTag */  || t.kind === 344 /* JSDocCallbackTag */ ) && !jsdoc.tags.some((t)=>t.kind === 347 /* JSDocParameterTag */  || t.kind === 348 /* JSDocReturnTag */ )) continue;
                let newparts = jsdoc.comment ? getDisplayPartsFromComment(jsdoc.comment, checker) : [];
                if (inheritDoc && inheritDoc.comment) newparts = newparts.concat(getDisplayPartsFromComment(inheritDoc.comment, checker));
                if (!contains(parts, newparts, isIdenticalListOfDisplayParts)) parts.push(newparts);
            }
        });
        return flatten(intersperse(parts, [
            lineBreakPart()
        ]));
    }
    function isIdenticalListOfDisplayParts(parts1, parts2) {
        return arraysEqual(parts1, parts2, (p1, p2)=>p1.kind === p2.kind && p1.text === p2.text);
    }
    function getCommentHavingNodes(declaration) {
        switch(declaration.kind){
            case 347 /* JSDocParameterTag */ :
            case 354 /* JSDocPropertyTag */ :
                return [
                    declaration
                ];
            case 344 /* JSDocCallbackTag */ :
            case 352 /* JSDocTypedefTag */ :
                return [
                    declaration,
                    declaration.parent
                ];
            default:
                return getJSDocCommentsAndTags(declaration);
        }
    }
    function getJsDocTagsFromDeclarations(declarations, checker) {
        const infos = [];
        forEachUnique(declarations, (declaration)=>{
            const tags = getJSDocTags(declaration);
            if (tags.some((t)=>t.kind === 352 /* JSDocTypedefTag */  || t.kind === 344 /* JSDocCallbackTag */ ) && !tags.some((t)=>t.kind === 347 /* JSDocParameterTag */  || t.kind === 348 /* JSDocReturnTag */ )) return;
            for (const tag of tags)infos.push({
                name: tag.tagName.text,
                text: getCommentDisplayParts(tag, checker)
            });
        });
        return infos;
    }
    function getDisplayPartsFromComment(comment, checker) {
        if (typeof comment === "string") return [
            textPart(comment)
        ];
        return flatMap(comment, (node)=>node.kind === 327 /* JSDocText */  ? [
                textPart(node.text)
            ] : buildLinkParts(node, checker));
    }
    function getCommentDisplayParts(tag, checker) {
        const { comment: comment , kind: kind  } = tag;
        const namePart = getTagNameDisplayPart(kind);
        switch(kind){
            case 355 /* JSDocThrowsTag */ :
                const typeExpression = tag.typeExpression;
                return typeExpression ? withNode(typeExpression) : comment === void 0 ? void 0 : getDisplayPartsFromComment(comment, checker);
            case 335 /* JSDocImplementsTag */ :
                return withNode(tag.class);
            case 334 /* JSDocAugmentsTag */ :
                return withNode(tag.class);
            case 351 /* JSDocTemplateTag */ :
                const templateTag = tag;
                const displayParts = [];
                if (templateTag.constraint) displayParts.push(textPart(templateTag.constraint.getText()));
                if (length(templateTag.typeParameters)) {
                    if (length(displayParts)) displayParts.push(spacePart());
                    const lastTypeParameter = templateTag.typeParameters[templateTag.typeParameters.length - 1];
                    forEach(templateTag.typeParameters, (tp)=>{
                        displayParts.push(namePart(tp.getText()));
                        if (lastTypeParameter !== tp) displayParts.push(...[
                            punctuationPart(28 /* CommaToken */ ),
                            spacePart()
                        ]);
                    });
                }
                if (comment) displayParts.push(...[
                    spacePart(),
                    ...getDisplayPartsFromComment(comment, checker)
                ]);
                return displayParts;
            case 350 /* JSDocTypeTag */ :
            case 356 /* JSDocSatisfiesTag */ :
                return withNode(tag.typeExpression);
            case 352 /* JSDocTypedefTag */ :
            case 344 /* JSDocCallbackTag */ :
            case 354 /* JSDocPropertyTag */ :
            case 347 /* JSDocParameterTag */ :
            case 353 /* JSDocSeeTag */ :
                const { name: name  } = tag;
                return name ? withNode(name) : comment === void 0 ? void 0 : getDisplayPartsFromComment(comment, checker);
            default:
                return comment === void 0 ? void 0 : getDisplayPartsFromComment(comment, checker);
        }
        function withNode(node) {
            return addComment(node.getText());
        }
        function addComment(s) {
            if (comment) {
                if (s.match(/^https?$/)) return [
                    textPart(s),
                    ...getDisplayPartsFromComment(comment, checker)
                ];
                else return [
                    namePart(s),
                    spacePart(),
                    ...getDisplayPartsFromComment(comment, checker)
                ];
            } else return [
                textPart(s)
            ];
        }
    }
    function getTagNameDisplayPart(kind) {
        switch(kind){
            case 347 /* JSDocParameterTag */ :
                return parameterNamePart;
            case 354 /* JSDocPropertyTag */ :
                return propertyNamePart;
            case 351 /* JSDocTemplateTag */ :
                return typeParameterNamePart;
            case 352 /* JSDocTypedefTag */ :
            case 344 /* JSDocCallbackTag */ :
                return typeAliasNamePart;
            default:
                return textPart;
        }
    }
    function getJSDocTagNameCompletions() {
        return jsDocTagNameCompletionEntries || (jsDocTagNameCompletionEntries = map(jsDocTagNames, (tagName)=>{
            return {
                name: tagName,
                kind: "keyword" /* keyword */ ,
                kindModifiers: "",
                sortText: ts_Completions_exports.SortText.LocationPriority
            };
        }));
    }
    function getJSDocTagCompletions() {
        return jsDocTagCompletionEntries || (jsDocTagCompletionEntries = map(jsDocTagNames, (tagName)=>{
            return {
                name: `@${tagName}`,
                kind: "keyword" /* keyword */ ,
                kindModifiers: "",
                sortText: ts_Completions_exports.SortText.LocationPriority
            };
        }));
    }
    function getJSDocTagCompletionDetails(name) {
        return {
            name: name,
            kind: "" /* unknown */ ,
            // TODO: should have its own kind?
            kindModifiers: "",
            displayParts: [
                textPart(name)
            ],
            documentation: emptyArray,
            tags: void 0,
            codeActions: void 0
        };
    }
    function getJSDocParameterNameCompletions(tag) {
        if (!isIdentifier(tag.name)) return emptyArray;
        const nameThusFar = tag.name.text;
        const jsdoc = tag.parent;
        const fn = jsdoc.parent;
        if (!isFunctionLike(fn)) return [];
        return mapDefined(fn.parameters, (param)=>{
            if (!isIdentifier(param.name)) return void 0;
            const name = param.name.text;
            if (jsdoc.tags.some((t)=>t !== tag && isJSDocParameterTag(t) && isIdentifier(t.name) && t.name.escapedText === name) || nameThusFar !== void 0 && !startsWith(name, nameThusFar)) return void 0;
            return {
                name: name,
                kind: "parameter" /* parameterElement */ ,
                kindModifiers: "",
                sortText: ts_Completions_exports.SortText.LocationPriority
            };
        });
    }
    function getJSDocParameterNameCompletionDetails(name) {
        return {
            name: name,
            kind: "parameter" /* parameterElement */ ,
            kindModifiers: "",
            displayParts: [
                textPart(name)
            ],
            documentation: emptyArray,
            tags: void 0,
            codeActions: void 0
        };
    }
    function getDocCommentTemplateAtPosition(newLine, sourceFile, position, options) {
        const tokenAtPos = getTokenAtPosition(sourceFile, position);
        const existingDocComment = findAncestor(tokenAtPos, isJSDoc);
        if (existingDocComment && (existingDocComment.comment !== void 0 || length(existingDocComment.tags))) return void 0;
        const tokenStart = tokenAtPos.getStart(sourceFile);
        if (!existingDocComment && tokenStart < position) return void 0;
        const commentOwnerInfo = getCommentOwnerInfo(tokenAtPos, options);
        if (!commentOwnerInfo) return void 0;
        const { commentOwner: commentOwner , parameters: parameters , hasReturn: hasReturn2  } = commentOwnerInfo;
        const commentOwnerJsDoc = hasJSDocNodes(commentOwner) && commentOwner.jsDoc ? commentOwner.jsDoc : void 0;
        const lastJsDoc = lastOrUndefined(commentOwnerJsDoc);
        if (commentOwner.getStart(sourceFile) < position || lastJsDoc && existingDocComment && lastJsDoc !== existingDocComment) return void 0;
        const indentationStr = getIndentationStringAtPosition(sourceFile, position);
        const isJavaScriptFile = hasJSFileExtension(sourceFile.fileName);
        const tags = (parameters ? parameterDocComments(parameters || [], isJavaScriptFile, indentationStr, newLine) : "") + (hasReturn2 ? returnsDocComment(indentationStr, newLine) : "");
        const openComment = "/**";
        const closeComment = " */";
        const hasTag = (commentOwnerJsDoc || []).some((jsDoc)=>!!jsDoc.tags);
        if (tags && !hasTag) {
            const preamble = openComment + newLine + indentationStr + " * ";
            const endLine = tokenStart === position ? newLine + indentationStr : "";
            const result = preamble + newLine + tags + indentationStr + closeComment + endLine;
            return {
                newText: result,
                caretOffset: preamble.length
            };
        }
        return {
            newText: openComment + closeComment,
            caretOffset: 3
        };
    }
    function getIndentationStringAtPosition(sourceFile, position) {
        const { text: text  } = sourceFile;
        const lineStart = getLineStartPositionForPosition(position, sourceFile);
        let pos = lineStart;
        for(; pos <= position && isWhiteSpaceSingleLine(text.charCodeAt(pos)); pos++);
        return text.slice(lineStart, pos);
    }
    function parameterDocComments(parameters, isJavaScriptFile, indentationStr, newLine) {
        return parameters.map(({ name: name , dotDotDotToken: dotDotDotToken  }, i)=>{
            const paramName = name.kind === 80 /* Identifier */  ? name.text : "param" + i;
            const type = isJavaScriptFile ? dotDotDotToken ? "{...any} " : "{any} " : "";
            return `${indentationStr} * @param ${type}${paramName}${newLine}`;
        }).join("");
    }
    function returnsDocComment(indentationStr, newLine) {
        return `${indentationStr} * @returns${newLine}`;
    }
    function getCommentOwnerInfo(tokenAtPos, options) {
        return forEachAncestor(tokenAtPos, (n)=>getCommentOwnerInfoWorker(n, options));
    }
    function getCommentOwnerInfoWorker(commentOwner, options) {
        switch(commentOwner.kind){
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 173 /* MethodDeclaration */ :
            case 175 /* Constructor */ :
            case 172 /* MethodSignature */ :
            case 218 /* ArrowFunction */ :
                const host = commentOwner;
                return {
                    commentOwner: commentOwner,
                    parameters: host.parameters,
                    hasReturn: hasReturn(host, options)
                };
            case 302 /* PropertyAssignment */ :
                return getCommentOwnerInfoWorker(commentOwner.initializer, options);
            case 262 /* ClassDeclaration */ :
            case 263 /* InterfaceDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 305 /* EnumMember */ :
            case 264 /* TypeAliasDeclaration */ :
                return {
                    commentOwner: commentOwner
                };
            case 170 /* PropertySignature */ :
                {
                    const host2 = commentOwner;
                    return host2.type && isFunctionTypeNode(host2.type) ? {
                        commentOwner: commentOwner,
                        parameters: host2.type.parameters,
                        hasReturn: hasReturn(host2.type, options)
                    } : {
                        commentOwner: commentOwner
                    };
                }
            case 242 /* VariableStatement */ :
                {
                    const varStatement = commentOwner;
                    const varDeclarations = varStatement.declarationList.declarations;
                    const host2 = varDeclarations.length === 1 && varDeclarations[0].initializer ? getRightHandSideOfAssignment(varDeclarations[0].initializer) : void 0;
                    return host2 ? {
                        commentOwner: commentOwner,
                        parameters: host2.parameters,
                        hasReturn: hasReturn(host2, options)
                    } : {
                        commentOwner: commentOwner
                    };
                }
            case 311 /* SourceFile */ :
                return "quit";
            case 266 /* ModuleDeclaration */ :
                return commentOwner.parent.kind === 266 /* ModuleDeclaration */  ? void 0 : {
                    commentOwner: commentOwner
                };
            case 243 /* ExpressionStatement */ :
                return getCommentOwnerInfoWorker(commentOwner.expression, options);
            case 225 /* BinaryExpression */ :
                {
                    const be = commentOwner;
                    if (getAssignmentDeclarationKind(be) === 0 /* None */ ) return "quit";
                    return isFunctionLike(be.right) ? {
                        commentOwner: commentOwner,
                        parameters: be.right.parameters,
                        hasReturn: hasReturn(be.right, options)
                    } : {
                        commentOwner: commentOwner
                    };
                }
            case 171 /* PropertyDeclaration */ :
                const init = commentOwner.initializer;
                if (init && (isFunctionExpression(init) || isArrowFunction(init))) return {
                    commentOwner: commentOwner,
                    parameters: init.parameters,
                    hasReturn: hasReturn(init, options)
                };
        }
    }
    function hasReturn(node, options) {
        return !!(options == null ? void 0 : options.generateReturnInDocTemplate) && (isFunctionTypeNode(node) || isArrowFunction(node) && isExpression(node.body) || isFunctionLikeDeclaration(node) && node.body && isBlock(node.body) && !!forEachReturnStatement(node.body, (n)=>n));
    }
    function getRightHandSideOfAssignment(rightHandSide) {
        while(rightHandSide.kind === 216 /* ParenthesizedExpression */ )rightHandSide = rightHandSide.expression;
        switch(rightHandSide.kind){
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
                return rightHandSide;
            case 230 /* ClassExpression */ :
                return find(rightHandSide.members, isConstructorDeclaration);
        }
    }
    var jsDocTagNames, jsDocTagNameCompletionEntries, jsDocTagCompletionEntries, getJSDocTagNameCompletionDetails;
    var init_jsDoc = __esm({
        "src/services/jsDoc.ts" () {
            "use strict";
            init_ts4();
            jsDocTagNames = [
                "abstract",
                "access",
                "alias",
                "argument",
                "async",
                "augments",
                "author",
                "borrows",
                "callback",
                "class",
                "classdesc",
                "constant",
                "constructor",
                "constructs",
                "copyright",
                "default",
                "deprecated",
                "description",
                "emits",
                "enum",
                "event",
                "example",
                "exports",
                "extends",
                "external",
                "field",
                "file",
                "fileoverview",
                "fires",
                "function",
                "generator",
                "global",
                "hideconstructor",
                "host",
                "ignore",
                "implements",
                "inheritdoc",
                "inner",
                "instance",
                "interface",
                "kind",
                "lends",
                "license",
                "link",
                "linkcode",
                "linkplain",
                "listens",
                "member",
                "memberof",
                "method",
                "mixes",
                "module",
                "name",
                "namespace",
                "overload",
                "override",
                "package",
                "param",
                "private",
                "prop",
                "property",
                "protected",
                "public",
                "readonly",
                "requires",
                "returns",
                "satisfies",
                "see",
                "since",
                "static",
                "summary",
                "template",
                "this",
                "throws",
                "todo",
                "tutorial",
                "type",
                "typedef",
                "var",
                "variation",
                "version",
                "virtual",
                "yields"
            ];
            getJSDocTagNameCompletionDetails = getJSDocTagCompletionDetails;
        }
    });
    // src/services/_namespaces/ts.JsDoc.ts
    var ts_JsDoc_exports = {};
    __export(ts_JsDoc_exports, {
        getDocCommentTemplateAtPosition: ()=>getDocCommentTemplateAtPosition,
        getJSDocParameterNameCompletionDetails: ()=>getJSDocParameterNameCompletionDetails,
        getJSDocParameterNameCompletions: ()=>getJSDocParameterNameCompletions,
        getJSDocTagCompletionDetails: ()=>getJSDocTagCompletionDetails,
        getJSDocTagCompletions: ()=>getJSDocTagCompletions,
        getJSDocTagNameCompletionDetails: ()=>getJSDocTagNameCompletionDetails,
        getJSDocTagNameCompletions: ()=>getJSDocTagNameCompletions,
        getJsDocCommentsFromDeclarations: ()=>getJsDocCommentsFromDeclarations,
        getJsDocTagsFromDeclarations: ()=>getJsDocTagsFromDeclarations
    });
    var init_ts_JsDoc = __esm({
        "src/services/_namespaces/ts.JsDoc.ts" () {
            "use strict";
            init_jsDoc();
        }
    });
    // src/services/organizeImports.ts
    function organizeImports(sourceFile, formatContext, host, program, preferences, mode) {
        const changeTracker = ts_textChanges_exports.ChangeTracker.fromContext({
            host: host,
            formatContext: formatContext,
            preferences: preferences
        });
        const shouldSort = mode === "SortAndCombine" /* SortAndCombine */  || mode === "All" /* All */ ;
        const shouldCombine = shouldSort;
        const shouldRemove = mode === "RemoveUnused" /* RemoveUnused */  || mode === "All" /* All */ ;
        const topLevelImportGroupDecls = groupByNewlineContiguous(sourceFile, sourceFile.statements.filter(isImportDeclaration));
        const comparer = getOrganizeImportsComparerWithDetection(preferences, shouldSort ? ()=>detectSortingWorker(topLevelImportGroupDecls, preferences) === 2 /* CaseInsensitive */  : void 0);
        const processImportsOfSameModuleSpecifier = (importGroup)=>{
            if (shouldRemove) importGroup = removeUnusedImports(importGroup, sourceFile, program);
            if (shouldCombine) importGroup = coalesceImportsWorker(importGroup, comparer, sourceFile);
            if (shouldSort) importGroup = stableSort(importGroup, (s1, s2)=>compareImportsOrRequireStatements(s1, s2, comparer));
            return importGroup;
        };
        topLevelImportGroupDecls.forEach((importGroupDecl)=>organizeImportsWorker(importGroupDecl, processImportsOfSameModuleSpecifier));
        if (mode !== "RemoveUnused" /* RemoveUnused */ ) getTopLevelExportGroups(sourceFile).forEach((exportGroupDecl)=>organizeImportsWorker(exportGroupDecl, (group2)=>coalesceExportsWorker(group2, comparer)));
        for (const ambientModule of sourceFile.statements.filter(isAmbientModule)){
            if (!ambientModule.body) continue;
            const ambientModuleImportGroupDecls = groupByNewlineContiguous(sourceFile, ambientModule.body.statements.filter(isImportDeclaration));
            ambientModuleImportGroupDecls.forEach((importGroupDecl)=>organizeImportsWorker(importGroupDecl, processImportsOfSameModuleSpecifier));
            if (mode !== "RemoveUnused" /* RemoveUnused */ ) {
                const ambientModuleExportDecls = ambientModule.body.statements.filter(isExportDeclaration);
                organizeImportsWorker(ambientModuleExportDecls, (group2)=>coalesceExportsWorker(group2, comparer));
            }
        }
        return changeTracker.getChanges();
        function organizeImportsWorker(oldImportDecls, coalesce) {
            if (length(oldImportDecls) === 0) return;
            suppressLeadingTrivia(oldImportDecls[0]);
            const oldImportGroups = shouldCombine ? group(oldImportDecls, (importDecl)=>getExternalModuleName2(importDecl.moduleSpecifier)) : [
                oldImportDecls
            ];
            const sortedImportGroups = shouldSort ? stableSort(oldImportGroups, (group1, group2)=>compareModuleSpecifiersWorker(group1[0].moduleSpecifier, group2[0].moduleSpecifier, comparer)) : oldImportGroups;
            const newImportDecls = flatMap(sortedImportGroups, (importGroup)=>getExternalModuleName2(importGroup[0].moduleSpecifier) || importGroup[0].moduleSpecifier === void 0 ? coalesce(importGroup) : importGroup);
            if (newImportDecls.length === 0) changeTracker.deleteNodes(sourceFile, oldImportDecls, {
                leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
                trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Include
            }, /*hasTrailingComment*/ true);
            else {
                const replaceOptions = {
                    leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
                    // Leave header comment in place
                    trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Include,
                    suffix: getNewLineOrDefaultFromHost(host, formatContext.options)
                };
                changeTracker.replaceNodeWithNodes(sourceFile, oldImportDecls[0], newImportDecls, replaceOptions);
                const hasTrailingComment = changeTracker.nodeHasTrailingComment(sourceFile, oldImportDecls[0], replaceOptions);
                changeTracker.deleteNodes(sourceFile, oldImportDecls.slice(1), {
                    trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Include
                }, hasTrailingComment);
            }
        }
    }
    function groupByNewlineContiguous(sourceFile, decls) {
        const scanner2 = createScanner(sourceFile.languageVersion, /*skipTrivia*/ false, sourceFile.languageVariant);
        const group2 = [];
        let groupIndex = 0;
        for (const decl of decls){
            if (group2[groupIndex] && isNewGroup(sourceFile, decl, scanner2)) groupIndex++;
            if (!group2[groupIndex]) group2[groupIndex] = [];
            group2[groupIndex].push(decl);
        }
        return group2;
    }
    function isNewGroup(sourceFile, decl, scanner2) {
        const startPos = decl.getFullStart();
        const endPos = decl.getStart();
        scanner2.setText(sourceFile.text, startPos, endPos - startPos);
        let numberOfNewLines = 0;
        while(scanner2.getTokenStart() < endPos){
            const tokenKind = scanner2.scan();
            if (tokenKind === 4 /* NewLineTrivia */ ) {
                numberOfNewLines++;
                if (numberOfNewLines >= 2) return true;
            }
        }
        return false;
    }
    function removeUnusedImports(oldImports, sourceFile, program) {
        const typeChecker = program.getTypeChecker();
        const compilerOptions = program.getCompilerOptions();
        const jsxNamespace = typeChecker.getJsxNamespace(sourceFile);
        const jsxFragmentFactory = typeChecker.getJsxFragmentFactory(sourceFile);
        const jsxElementsPresent = !!(sourceFile.transformFlags & 2 /* ContainsJsx */ );
        const usedImports = [];
        for (const importDecl of oldImports){
            const { importClause: importClause , moduleSpecifier: moduleSpecifier  } = importDecl;
            if (!importClause) {
                usedImports.push(importDecl);
                continue;
            }
            let { name: name , namedBindings: namedBindings  } = importClause;
            if (name && !isDeclarationUsed(name)) name = void 0;
            if (namedBindings) {
                if (isNamespaceImport(namedBindings)) {
                    if (!isDeclarationUsed(namedBindings.name)) namedBindings = void 0;
                } else {
                    const newElements = namedBindings.elements.filter((e)=>isDeclarationUsed(e.name));
                    if (newElements.length < namedBindings.elements.length) namedBindings = newElements.length ? factory.updateNamedImports(namedBindings, newElements) : void 0;
                }
            }
            if (name || namedBindings) usedImports.push(updateImportDeclarationAndClause(importDecl, name, namedBindings));
            else if (hasModuleDeclarationMatchingSpecifier(sourceFile, moduleSpecifier)) {
                if (sourceFile.isDeclarationFile) usedImports.push(factory.createImportDeclaration(importDecl.modifiers, /*importClause*/ void 0, moduleSpecifier, /*assertClause*/ void 0));
                else usedImports.push(importDecl);
            }
        }
        return usedImports;
        function isDeclarationUsed(identifier) {
            return jsxElementsPresent && (identifier.text === jsxNamespace || jsxFragmentFactory && identifier.text === jsxFragmentFactory) && jsxModeNeedsExplicitImport(compilerOptions.jsx) || ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(identifier, typeChecker, sourceFile);
        }
    }
    function hasModuleDeclarationMatchingSpecifier(sourceFile, moduleSpecifier) {
        const moduleSpecifierText = isStringLiteral(moduleSpecifier) && moduleSpecifier.text;
        return isString(moduleSpecifierText) && some(sourceFile.moduleAugmentations, (moduleName)=>isStringLiteral(moduleName) && moduleName.text === moduleSpecifierText);
    }
    function getExternalModuleName2(specifier) {
        return specifier !== void 0 && isStringLiteralLike(specifier) ? specifier.text : void 0;
    }
    function coalesceImports(importGroup, ignoreCase, sourceFile) {
        const comparer = getOrganizeImportsOrdinalStringComparer(ignoreCase);
        return coalesceImportsWorker(importGroup, comparer, sourceFile);
    }
    function coalesceImportsWorker(importGroup, comparer, sourceFile) {
        if (importGroup.length === 0) return importGroup;
        const { importWithoutClause: importWithoutClause , typeOnlyImports: typeOnlyImports , regularImports: regularImports  } = getCategorizedImports(importGroup);
        const coalescedImports = [];
        if (importWithoutClause) coalescedImports.push(importWithoutClause);
        for (const group2 of [
            regularImports,
            typeOnlyImports
        ]){
            const isTypeOnly = group2 === typeOnlyImports;
            const { defaultImports: defaultImports , namespaceImports: namespaceImports , namedImports: namedImports  } = group2;
            if (!isTypeOnly && defaultImports.length === 1 && namespaceImports.length === 1 && namedImports.length === 0) {
                const defaultImport = defaultImports[0];
                coalescedImports.push(updateImportDeclarationAndClause(defaultImport, defaultImport.importClause.name, namespaceImports[0].importClause.namedBindings));
                continue;
            }
            const sortedNamespaceImports = stableSort(namespaceImports, (i1, i2)=>comparer(i1.importClause.namedBindings.name.text, i2.importClause.namedBindings.name.text));
            for (const namespaceImport of sortedNamespaceImports)coalescedImports.push(updateImportDeclarationAndClause(namespaceImport, /*name*/ void 0, namespaceImport.importClause.namedBindings));
            const firstDefaultImport = firstOrUndefined(defaultImports);
            const firstNamedImport = firstOrUndefined(namedImports);
            const importDecl = firstDefaultImport ?? firstNamedImport;
            if (!importDecl) continue;
            let newDefaultImport;
            const newImportSpecifiers = [];
            if (defaultImports.length === 1) newDefaultImport = defaultImports[0].importClause.name;
            else for (const defaultImport of defaultImports)newImportSpecifiers.push(factory.createImportSpecifier(/*isTypeOnly*/ false, factory.createIdentifier("default"), defaultImport.importClause.name));
            newImportSpecifiers.push(...getNewImportSpecifiers(namedImports));
            const sortedImportSpecifiers = factory.createNodeArray(sortSpecifiers(newImportSpecifiers, comparer), firstNamedImport == null ? void 0 : firstNamedImport.importClause.namedBindings.elements.hasTrailingComma);
            const newNamedImports = sortedImportSpecifiers.length === 0 ? newDefaultImport ? void 0 : factory.createNamedImports(emptyArray) : firstNamedImport ? factory.updateNamedImports(firstNamedImport.importClause.namedBindings, sortedImportSpecifiers) : factory.createNamedImports(sortedImportSpecifiers);
            if (sourceFile && newNamedImports && (firstNamedImport == null ? void 0 : firstNamedImport.importClause.namedBindings) && !rangeIsOnSingleLine(firstNamedImport.importClause.namedBindings, sourceFile)) setEmitFlags(newNamedImports, 2 /* MultiLine */ );
            if (isTypeOnly && newDefaultImport && newNamedImports) {
                coalescedImports.push(updateImportDeclarationAndClause(importDecl, newDefaultImport, /*namedBindings*/ void 0));
                coalescedImports.push(updateImportDeclarationAndClause(firstNamedImport ?? importDecl, /*name*/ void 0, newNamedImports));
            } else coalescedImports.push(updateImportDeclarationAndClause(importDecl, newDefaultImport, newNamedImports));
        }
        return coalescedImports;
    }
    function getCategorizedImports(importGroup) {
        let importWithoutClause;
        const typeOnlyImports = {
            defaultImports: [],
            namespaceImports: [],
            namedImports: []
        };
        const regularImports = {
            defaultImports: [],
            namespaceImports: [],
            namedImports: []
        };
        for (const importDeclaration of importGroup){
            if (importDeclaration.importClause === void 0) {
                importWithoutClause = importWithoutClause || importDeclaration;
                continue;
            }
            const group2 = importDeclaration.importClause.isTypeOnly ? typeOnlyImports : regularImports;
            const { name: name , namedBindings: namedBindings  } = importDeclaration.importClause;
            if (name) group2.defaultImports.push(importDeclaration);
            if (namedBindings) {
                if (isNamespaceImport(namedBindings)) group2.namespaceImports.push(importDeclaration);
                else group2.namedImports.push(importDeclaration);
            }
        }
        return {
            importWithoutClause: importWithoutClause,
            typeOnlyImports: typeOnlyImports,
            regularImports: regularImports
        };
    }
    function coalesceExports(exportGroup, ignoreCase) {
        const comparer = getOrganizeImportsOrdinalStringComparer(ignoreCase);
        return coalesceExportsWorker(exportGroup, comparer);
    }
    function coalesceExportsWorker(exportGroup, comparer) {
        if (exportGroup.length === 0) return exportGroup;
        const { exportWithoutClause: exportWithoutClause , namedExports: namedExports , typeOnlyExports: typeOnlyExports  } = getCategorizedExports(exportGroup);
        const coalescedExports = [];
        if (exportWithoutClause) coalescedExports.push(exportWithoutClause);
        for (const exportGroup2 of [
            namedExports,
            typeOnlyExports
        ]){
            if (exportGroup2.length === 0) continue;
            const newExportSpecifiers = [];
            newExportSpecifiers.push(...flatMap(exportGroup2, (i)=>i.exportClause && isNamedExports(i.exportClause) ? i.exportClause.elements : emptyArray));
            const sortedExportSpecifiers = sortSpecifiers(newExportSpecifiers, comparer);
            const exportDecl = exportGroup2[0];
            coalescedExports.push(factory.updateExportDeclaration(exportDecl, exportDecl.modifiers, exportDecl.isTypeOnly, exportDecl.exportClause && (isNamedExports(exportDecl.exportClause) ? factory.updateNamedExports(exportDecl.exportClause, sortedExportSpecifiers) : factory.updateNamespaceExport(exportDecl.exportClause, exportDecl.exportClause.name)), exportDecl.moduleSpecifier, exportDecl.assertClause));
        }
        return coalescedExports;
        function getCategorizedExports(exportGroup2) {
            let exportWithoutClause2;
            const namedExports2 = [];
            const typeOnlyExports2 = [];
            for (const exportDeclaration of exportGroup2){
                if (exportDeclaration.exportClause === void 0) exportWithoutClause2 = exportWithoutClause2 || exportDeclaration;
                else if (exportDeclaration.isTypeOnly) typeOnlyExports2.push(exportDeclaration);
                else namedExports2.push(exportDeclaration);
            }
            return {
                exportWithoutClause: exportWithoutClause2,
                namedExports: namedExports2,
                typeOnlyExports: typeOnlyExports2
            };
        }
    }
    function updateImportDeclarationAndClause(importDeclaration, name, namedBindings) {
        return factory.updateImportDeclaration(importDeclaration, importDeclaration.modifiers, factory.updateImportClause(importDeclaration.importClause, importDeclaration.importClause.isTypeOnly, name, namedBindings), // TODO: GH#18217
        importDeclaration.moduleSpecifier, importDeclaration.assertClause);
    }
    function sortSpecifiers(specifiers, comparer) {
        return stableSort(specifiers, (s1, s2)=>compareImportOrExportSpecifiers(s1, s2, comparer));
    }
    function compareImportOrExportSpecifiers(s1, s2, comparer) {
        return compareBooleans(s1.isTypeOnly, s2.isTypeOnly) || comparer(s1.name.text, s2.name.text);
    }
    function compareModuleSpecifiers2(m1, m2, ignoreCase) {
        const comparer = getOrganizeImportsOrdinalStringComparer(!!ignoreCase);
        return compareModuleSpecifiersWorker(m1, m2, comparer);
    }
    function compareModuleSpecifiersWorker(m1, m2, comparer) {
        const name1 = m1 === void 0 ? void 0 : getExternalModuleName2(m1);
        const name2 = m2 === void 0 ? void 0 : getExternalModuleName2(m2);
        return compareBooleans(name1 === void 0, name2 === void 0) || compareBooleans(isExternalModuleNameRelative(name1), isExternalModuleNameRelative(name2)) || comparer(name1, name2);
    }
    function getModuleSpecifierExpression(declaration) {
        var _a;
        switch(declaration.kind){
            case 270 /* ImportEqualsDeclaration */ :
                return (_a = tryCast(declaration.moduleReference, isExternalModuleReference)) == null ? void 0 : _a.expression;
            case 271 /* ImportDeclaration */ :
                return declaration.moduleSpecifier;
            case 242 /* VariableStatement */ :
                return declaration.declarationList.declarations[0].initializer.arguments[0];
        }
    }
    function detectSorting(sourceFile, preferences) {
        return detectSortingWorker(groupByNewlineContiguous(sourceFile, sourceFile.statements.filter(isImportDeclaration)), preferences);
    }
    function detectSortingWorker(importGroups, preferences) {
        const collateCaseSensitive = getOrganizeImportsComparer(preferences, /*ignoreCase*/ false);
        const collateCaseInsensitive = getOrganizeImportsComparer(preferences, /*ignoreCase*/ true);
        let sortState = 3 /* Both */ ;
        let seenUnsortedGroup = false;
        for (const importGroup of importGroups){
            if (importGroup.length > 1) {
                const moduleSpecifierSort = detectSortCaseSensitivity(importGroup, (i)=>{
                    var _a;
                    return ((_a = tryCast(i.moduleSpecifier, isStringLiteral)) == null ? void 0 : _a.text) ?? "";
                }, collateCaseSensitive, collateCaseInsensitive);
                if (moduleSpecifierSort) {
                    sortState &= moduleSpecifierSort;
                    seenUnsortedGroup = true;
                }
                if (!sortState) return sortState;
            }
            const declarationWithNamedImports = find(importGroup, (i)=>{
                var _a, _b;
                return ((_b = tryCast((_a = i.importClause) == null ? void 0 : _a.namedBindings, isNamedImports)) == null ? void 0 : _b.elements.length) > 1;
            });
            if (declarationWithNamedImports) {
                const namedImportSort = detectImportSpecifierSorting(declarationWithNamedImports.importClause.namedBindings.elements, preferences);
                if (namedImportSort) {
                    sortState &= namedImportSort;
                    seenUnsortedGroup = true;
                }
                if (!sortState) return sortState;
            }
            if (sortState !== 3 /* Both */ ) return sortState;
        }
        return seenUnsortedGroup ? 0 /* None */  : sortState;
    }
    function detectImportDeclarationSorting(imports, preferences) {
        const collateCaseSensitive = getOrganizeImportsComparer(preferences, /*ignoreCase*/ false);
        const collateCaseInsensitive = getOrganizeImportsComparer(preferences, /*ignoreCase*/ true);
        return detectSortCaseSensitivity(imports, (s)=>getExternalModuleName2(getModuleSpecifierExpression(s)) || "", collateCaseSensitive, collateCaseInsensitive);
    }
    function getImportDeclarationInsertionIndex(sortedImports, newImport, comparer) {
        const index = binarySearch(sortedImports, newImport, identity, (a, b)=>compareImportsOrRequireStatements(a, b, comparer));
        return index < 0 ? ~index : index;
    }
    function getImportSpecifierInsertionIndex(sortedImports, newImport, comparer) {
        const index = binarySearch(sortedImports, newImport, identity, (s1, s2)=>compareImportOrExportSpecifiers(s1, s2, comparer));
        return index < 0 ? ~index : index;
    }
    function compareImportsOrRequireStatements(s1, s2, comparer) {
        return compareModuleSpecifiersWorker(getModuleSpecifierExpression(s1), getModuleSpecifierExpression(s2), comparer) || compareImportKind(s1, s2);
    }
    function compareImportKind(s1, s2) {
        return compareValues(getImportKindOrder(s1), getImportKindOrder(s2));
    }
    function getImportKindOrder(s1) {
        var _a;
        switch(s1.kind){
            case 271 /* ImportDeclaration */ :
                if (!s1.importClause) return 0;
                if (s1.importClause.isTypeOnly) return 1;
                if (((_a = s1.importClause.namedBindings) == null ? void 0 : _a.kind) === 273 /* NamespaceImport */ ) return 2;
                if (s1.importClause.name) return 3;
                return 4;
            case 270 /* ImportEqualsDeclaration */ :
                return 5;
            case 242 /* VariableStatement */ :
                return 6;
        }
    }
    function getNewImportSpecifiers(namedImports) {
        return flatMap(namedImports, (namedImport)=>map(tryGetNamedBindingElements(namedImport), (importSpecifier)=>importSpecifier.name && importSpecifier.propertyName && importSpecifier.name.escapedText === importSpecifier.propertyName.escapedText ? factory.updateImportSpecifier(importSpecifier, importSpecifier.isTypeOnly, /*propertyName*/ void 0, importSpecifier.name) : importSpecifier));
    }
    function tryGetNamedBindingElements(namedImport) {
        var _a;
        return ((_a = namedImport.importClause) == null ? void 0 : _a.namedBindings) && isNamedImports(namedImport.importClause.namedBindings) ? namedImport.importClause.namedBindings.elements : void 0;
    }
    function getOrganizeImportsOrdinalStringComparer(ignoreCase) {
        return ignoreCase ? compareStringsCaseInsensitiveEslintCompatible : compareStringsCaseSensitive;
    }
    function getOrganizeImportsUnicodeStringComparer(ignoreCase, preferences) {
        const resolvedLocale = getOrganizeImportsLocale(preferences);
        const caseFirst = preferences.organizeImportsCaseFirst ?? false;
        const numeric = preferences.organizeImportsNumericCollation ?? false;
        const accents = preferences.organizeImportsAccentCollation ?? true;
        const sensitivity = ignoreCase ? accents ? "accent" : "base" : accents ? "variant" : "case";
        const collator = new Intl.Collator(resolvedLocale, {
            usage: "sort",
            caseFirst: caseFirst || "false",
            sensitivity: sensitivity,
            numeric: numeric
        });
        return collator.compare;
    }
    function getOrganizeImportsLocale(preferences) {
        let locale = preferences.organizeImportsLocale;
        if (locale === "auto") locale = getUILocale();
        if (locale === void 0) locale = "en";
        const supportedLocales = Intl.Collator.supportedLocalesOf(locale);
        const resolvedLocale = supportedLocales.length ? supportedLocales[0] : "en";
        return resolvedLocale;
    }
    function getOrganizeImportsComparer(preferences, ignoreCase) {
        const collation = preferences.organizeImportsCollation ?? "ordinal";
        return collation === "unicode" ? getOrganizeImportsUnicodeStringComparer(ignoreCase, preferences) : getOrganizeImportsOrdinalStringComparer(ignoreCase);
    }
    function getOrganizeImportsComparerWithDetection(preferences, detectIgnoreCase) {
        const ignoreCase = typeof preferences.organizeImportsIgnoreCase === "boolean" ? preferences.organizeImportsIgnoreCase : (detectIgnoreCase == null ? void 0 : detectIgnoreCase()) ?? false;
        return getOrganizeImportsComparer(preferences, ignoreCase);
    }
    function getTopLevelExportGroups(sourceFile) {
        const topLevelExportGroups = [];
        const statements = sourceFile.statements;
        const len = length(statements);
        let i = 0;
        let groupIndex = 0;
        while(i < len)if (isExportDeclaration(statements[i])) {
            if (topLevelExportGroups[groupIndex] === void 0) topLevelExportGroups[groupIndex] = [];
            const exportDecl = statements[i];
            if (exportDecl.moduleSpecifier) {
                topLevelExportGroups[groupIndex].push(exportDecl);
                i++;
            } else {
                while(i < len && isExportDeclaration(statements[i]))topLevelExportGroups[groupIndex].push(statements[i++]);
                groupIndex++;
            }
        } else i++;
        return flatMap(topLevelExportGroups, (exportGroupDecls)=>groupByNewlineContiguous(sourceFile, exportGroupDecls));
    }
    var ImportSpecifierSortingCache, detectImportSpecifierSorting;
    var init_organizeImports = __esm({
        "src/services/organizeImports.ts" () {
            "use strict";
            init_ts4();
            ImportSpecifierSortingCache = class {
                has([specifiers, preferences]) {
                    if (this._lastPreferences !== preferences || !this._cache) return false;
                    return this._cache.has(specifiers);
                }
                get([specifiers, preferences]) {
                    if (this._lastPreferences !== preferences || !this._cache) return void 0;
                    return this._cache.get(specifiers);
                }
                set([specifiers, preferences], value1) {
                    if (this._lastPreferences !== preferences) {
                        this._lastPreferences = preferences;
                        this._cache = void 0;
                    }
                    this._cache ?? (this._cache = /* @__PURE__ */ new WeakMap());
                    this._cache.set(specifiers, value1);
                }
            };
            detectImportSpecifierSorting = memoizeCached((specifiers, preferences)=>{
                if (!arrayIsSorted(specifiers, (s1, s2)=>compareBooleans(s1.isTypeOnly, s2.isTypeOnly))) return 0 /* None */ ;
                const collateCaseSensitive = getOrganizeImportsComparer(preferences, /*ignoreCase*/ false);
                const collateCaseInsensitive = getOrganizeImportsComparer(preferences, /*ignoreCase*/ true);
                return detectSortCaseSensitivity(specifiers, (specifier)=>specifier.name.text, collateCaseSensitive, collateCaseInsensitive);
            }, new ImportSpecifierSortingCache());
        }
    });
    // src/services/_namespaces/ts.OrganizeImports.ts
    var ts_OrganizeImports_exports = {};
    __export(ts_OrganizeImports_exports, {
        coalesceExports: ()=>coalesceExports,
        coalesceImports: ()=>coalesceImports,
        compareImportOrExportSpecifiers: ()=>compareImportOrExportSpecifiers,
        compareImportsOrRequireStatements: ()=>compareImportsOrRequireStatements,
        compareModuleSpecifiers: ()=>compareModuleSpecifiers2,
        detectImportDeclarationSorting: ()=>detectImportDeclarationSorting,
        detectImportSpecifierSorting: ()=>detectImportSpecifierSorting,
        detectSorting: ()=>detectSorting,
        getImportDeclarationInsertionIndex: ()=>getImportDeclarationInsertionIndex,
        getImportSpecifierInsertionIndex: ()=>getImportSpecifierInsertionIndex,
        getOrganizeImportsComparer: ()=>getOrganizeImportsComparer,
        organizeImports: ()=>organizeImports
    });
    var init_ts_OrganizeImports = __esm({
        "src/services/_namespaces/ts.OrganizeImports.ts" () {
            "use strict";
            init_organizeImports();
        }
    });
    // src/services/outliningElementsCollector.ts
    function collectElements(sourceFile, cancellationToken) {
        const res = [];
        addNodeOutliningSpans(sourceFile, cancellationToken, res);
        addRegionOutliningSpans(sourceFile, res);
        return res.sort((span1, span2)=>span1.textSpan.start - span2.textSpan.start);
    }
    function addNodeOutliningSpans(sourceFile, cancellationToken, out) {
        let depthRemaining = 40;
        let current = 0;
        const statements = [
            ...sourceFile.statements,
            sourceFile.endOfFileToken
        ];
        const n = statements.length;
        while(current < n){
            while(current < n && !isAnyImportSyntax(statements[current])){
                visitNode3(statements[current]);
                current++;
            }
            if (current === n) break;
            const firstImport = current;
            while(current < n && isAnyImportSyntax(statements[current])){
                visitNode3(statements[current]);
                current++;
            }
            const lastImport = current - 1;
            if (lastImport !== firstImport) out.push(createOutliningSpanFromBounds(findChildOfKind(statements[firstImport], 102 /* ImportKeyword */ , sourceFile).getStart(sourceFile), statements[lastImport].getEnd(), "imports" /* Imports */ ));
        }
        function visitNode3(n2) {
            var _a;
            if (depthRemaining === 0) return;
            cancellationToken.throwIfCancellationRequested();
            if (isDeclaration(n2) || isVariableStatement(n2) || isReturnStatement(n2) || isCallOrNewExpression(n2) || n2.kind === 1 /* EndOfFileToken */ ) addOutliningForLeadingCommentsForNode(n2, sourceFile, cancellationToken, out);
            if (isFunctionLike(n2) && isBinaryExpression(n2.parent) && isPropertyAccessExpression(n2.parent.left)) addOutliningForLeadingCommentsForNode(n2.parent.left, sourceFile, cancellationToken, out);
            if (isBlock(n2) || isModuleBlock(n2)) addOutliningForLeadingCommentsForPos(n2.statements.end, sourceFile, cancellationToken, out);
            if (isClassLike(n2) || isInterfaceDeclaration(n2)) addOutliningForLeadingCommentsForPos(n2.members.end, sourceFile, cancellationToken, out);
            const span = getOutliningSpanForNode(n2, sourceFile);
            if (span) out.push(span);
            depthRemaining--;
            if (isCallExpression(n2)) {
                depthRemaining++;
                visitNode3(n2.expression);
                depthRemaining--;
                n2.arguments.forEach(visitNode3);
                (_a = n2.typeArguments) == null || _a.forEach(visitNode3);
            } else if (isIfStatement(n2) && n2.elseStatement && isIfStatement(n2.elseStatement)) {
                visitNode3(n2.expression);
                visitNode3(n2.thenStatement);
                depthRemaining++;
                visitNode3(n2.elseStatement);
                depthRemaining--;
            } else n2.forEachChild(visitNode3);
            depthRemaining++;
        }
    }
    function addRegionOutliningSpans(sourceFile, out) {
        const regions = [];
        const lineStarts = sourceFile.getLineStarts();
        for (const currentLineStart of lineStarts){
            const lineEnd = sourceFile.getLineEndOfPosition(currentLineStart);
            const lineText = sourceFile.text.substring(currentLineStart, lineEnd);
            const result = isRegionDelimiter(lineText);
            if (!result || isInComment(sourceFile, currentLineStart)) continue;
            if (!result[1]) {
                const span = createTextSpanFromBounds(sourceFile.text.indexOf("//", currentLineStart), lineEnd);
                regions.push(createOutliningSpan(span, "region" /* Region */ , span, /*autoCollapse*/ false, result[2] || "#region"));
            } else {
                const region = regions.pop();
                if (region) {
                    region.textSpan.length = lineEnd - region.textSpan.start;
                    region.hintSpan.length = lineEnd - region.textSpan.start;
                    out.push(region);
                }
            }
        }
    }
    function isRegionDelimiter(lineText) {
        lineText = trimStringStart(lineText);
        if (!startsWith(lineText, "//")) return null;
        lineText = trimString(lineText.slice(2));
        return regionDelimiterRegExp.exec(lineText);
    }
    function addOutliningForLeadingCommentsForPos(pos, sourceFile, cancellationToken, out) {
        const comments = getLeadingCommentRanges(sourceFile.text, pos);
        if (!comments) return;
        let firstSingleLineCommentStart = -1;
        let lastSingleLineCommentEnd = -1;
        let singleLineCommentCount = 0;
        const sourceText = sourceFile.getFullText();
        for (const { kind: kind , pos: pos2 , end: end  } of comments){
            cancellationToken.throwIfCancellationRequested();
            switch(kind){
                case 2 /* SingleLineCommentTrivia */ :
                    const commentText = sourceText.slice(pos2, end);
                    if (isRegionDelimiter(commentText)) {
                        combineAndAddMultipleSingleLineComments();
                        singleLineCommentCount = 0;
                        break;
                    }
                    if (singleLineCommentCount === 0) firstSingleLineCommentStart = pos2;
                    lastSingleLineCommentEnd = end;
                    singleLineCommentCount++;
                    break;
                case 3 /* MultiLineCommentTrivia */ :
                    combineAndAddMultipleSingleLineComments();
                    out.push(createOutliningSpanFromBounds(pos2, end, "comment" /* Comment */ ));
                    singleLineCommentCount = 0;
                    break;
                default:
                    Debug.assertNever(kind);
            }
        }
        combineAndAddMultipleSingleLineComments();
        function combineAndAddMultipleSingleLineComments() {
            if (singleLineCommentCount > 1) out.push(createOutliningSpanFromBounds(firstSingleLineCommentStart, lastSingleLineCommentEnd, "comment" /* Comment */ ));
        }
    }
    function addOutliningForLeadingCommentsForNode(n, sourceFile, cancellationToken, out) {
        if (isJsxText(n)) return;
        addOutliningForLeadingCommentsForPos(n.pos, sourceFile, cancellationToken, out);
    }
    function createOutliningSpanFromBounds(pos, end, kind) {
        return createOutliningSpan(createTextSpanFromBounds(pos, end), kind);
    }
    function getOutliningSpanForNode(n, sourceFile) {
        switch(n.kind){
            case 240 /* Block */ :
                if (isFunctionLike(n.parent)) return functionSpan(n.parent, n, sourceFile);
                switch(n.parent.kind){
                    case 245 /* DoStatement */ :
                    case 248 /* ForInStatement */ :
                    case 249 /* ForOfStatement */ :
                    case 247 /* ForStatement */ :
                    case 244 /* IfStatement */ :
                    case 246 /* WhileStatement */ :
                    case 253 /* WithStatement */ :
                    case 298 /* CatchClause */ :
                        return spanForNode(n.parent);
                    case 257 /* TryStatement */ :
                        const tryStatement = n.parent;
                        if (tryStatement.tryBlock === n) return spanForNode(n.parent);
                        else if (tryStatement.finallyBlock === n) {
                            const node = findChildOfKind(tryStatement, 98 /* FinallyKeyword */ , sourceFile);
                            if (node) return spanForNode(node);
                        }
                    default:
                        return createOutliningSpan(createTextSpanFromNode(n, sourceFile), "code" /* Code */ );
                }
            case 267 /* ModuleBlock */ :
                return spanForNode(n.parent);
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
            case 263 /* InterfaceDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 268 /* CaseBlock */ :
            case 186 /* TypeLiteral */ :
            case 205 /* ObjectBindingPattern */ :
                return spanForNode(n);
            case 188 /* TupleType */ :
                return spanForNode(n, /*autoCollapse*/ false, /*useFullStart*/ !isTupleTypeNode(n.parent), 23 /* OpenBracketToken */ );
            case 295 /* CaseClause */ :
            case 296 /* DefaultClause */ :
                return spanForNodeArray(n.statements);
            case 209 /* ObjectLiteralExpression */ :
                return spanForObjectOrArrayLiteral(n);
            case 208 /* ArrayLiteralExpression */ :
                return spanForObjectOrArrayLiteral(n, 23 /* OpenBracketToken */ );
            case 283 /* JsxElement */ :
                return spanForJSXElement(n);
            case 287 /* JsxFragment */ :
                return spanForJSXFragment(n);
            case 284 /* JsxSelfClosingElement */ :
            case 285 /* JsxOpeningElement */ :
                return spanForJSXAttributes(n.attributes);
            case 227 /* TemplateExpression */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
                return spanForTemplateLiteral(n);
            case 206 /* ArrayBindingPattern */ :
                return spanForNode(n, /*autoCollapse*/ false, /*useFullStart*/ !isBindingElement(n.parent), 23 /* OpenBracketToken */ );
            case 218 /* ArrowFunction */ :
                return spanForArrowFunction(n);
            case 212 /* CallExpression */ :
                return spanForCallExpression(n);
            case 216 /* ParenthesizedExpression */ :
                return spanForParenthesizedExpression(n);
            case 274 /* NamedImports */ :
            case 278 /* NamedExports */ :
            case 299 /* AssertClause */ :
                return spanForNamedImportsOrExportsOrAssertClause(n);
        }
        function spanForNamedImportsOrExportsOrAssertClause(node) {
            if (!node.elements.length) return void 0;
            const openToken = findChildOfKind(node, 19 /* OpenBraceToken */ , sourceFile);
            const closeToken = findChildOfKind(node, 20 /* CloseBraceToken */ , sourceFile);
            if (!openToken || !closeToken || positionsAreOnSameLine(openToken.pos, closeToken.pos, sourceFile)) return void 0;
            return spanBetweenTokens(openToken, closeToken, node, sourceFile, /*autoCollapse*/ false, /*useFullStart*/ false);
        }
        function spanForCallExpression(node) {
            if (!node.arguments.length) return void 0;
            const openToken = findChildOfKind(node, 21 /* OpenParenToken */ , sourceFile);
            const closeToken = findChildOfKind(node, 22 /* CloseParenToken */ , sourceFile);
            if (!openToken || !closeToken || positionsAreOnSameLine(openToken.pos, closeToken.pos, sourceFile)) return void 0;
            return spanBetweenTokens(openToken, closeToken, node, sourceFile, /*autoCollapse*/ false, /*useFullStart*/ true);
        }
        function spanForArrowFunction(node) {
            if (isBlock(node.body) || isParenthesizedExpression(node.body) || positionsAreOnSameLine(node.body.getFullStart(), node.body.getEnd(), sourceFile)) return void 0;
            const textSpan = createTextSpanFromBounds(node.body.getFullStart(), node.body.getEnd());
            return createOutliningSpan(textSpan, "code" /* Code */ , createTextSpanFromNode(node));
        }
        function spanForJSXElement(node) {
            const textSpan = createTextSpanFromBounds(node.openingElement.getStart(sourceFile), node.closingElement.getEnd());
            const tagName = node.openingElement.tagName.getText(sourceFile);
            const bannerText = "<" + tagName + ">...</" + tagName + ">";
            return createOutliningSpan(textSpan, "code" /* Code */ , textSpan, /*autoCollapse*/ false, bannerText);
        }
        function spanForJSXFragment(node) {
            const textSpan = createTextSpanFromBounds(node.openingFragment.getStart(sourceFile), node.closingFragment.getEnd());
            const bannerText = "<>...</>";
            return createOutliningSpan(textSpan, "code" /* Code */ , textSpan, /*autoCollapse*/ false, bannerText);
        }
        function spanForJSXAttributes(node) {
            if (node.properties.length === 0) return void 0;
            return createOutliningSpanFromBounds(node.getStart(sourceFile), node.getEnd(), "code" /* Code */ );
        }
        function spanForTemplateLiteral(node) {
            if (node.kind === 15 /* NoSubstitutionTemplateLiteral */  && node.text.length === 0) return void 0;
            return createOutliningSpanFromBounds(node.getStart(sourceFile), node.getEnd(), "code" /* Code */ );
        }
        function spanForObjectOrArrayLiteral(node, open = 19 /* OpenBraceToken */ ) {
            return spanForNode(node, /*autoCollapse*/ false, /*useFullStart*/ !isArrayLiteralExpression(node.parent) && !isCallExpression(node.parent), open);
        }
        function spanForNode(hintSpanNode, autoCollapse = false, useFullStart = true, open = 19 /* OpenBraceToken */ , close = open === 19 /* OpenBraceToken */  ? 20 /* CloseBraceToken */  : 24 /* CloseBracketToken */ ) {
            const openToken = findChildOfKind(n, open, sourceFile);
            const closeToken = findChildOfKind(n, close, sourceFile);
            return openToken && closeToken && spanBetweenTokens(openToken, closeToken, hintSpanNode, sourceFile, autoCollapse, useFullStart);
        }
        function spanForNodeArray(nodeArray) {
            return nodeArray.length ? createOutliningSpan(createTextSpanFromRange(nodeArray), "code" /* Code */ ) : void 0;
        }
        function spanForParenthesizedExpression(node) {
            if (positionsAreOnSameLine(node.getStart(), node.getEnd(), sourceFile)) return void 0;
            const textSpan = createTextSpanFromBounds(node.getStart(), node.getEnd());
            return createOutliningSpan(textSpan, "code" /* Code */ , createTextSpanFromNode(node));
        }
    }
    function functionSpan(node, body, sourceFile) {
        const openToken = tryGetFunctionOpenToken(node, body, sourceFile);
        const closeToken = findChildOfKind(body, 20 /* CloseBraceToken */ , sourceFile);
        return openToken && closeToken && spanBetweenTokens(openToken, closeToken, node, sourceFile, /*autoCollapse*/ node.kind !== 218 /* ArrowFunction */ );
    }
    function spanBetweenTokens(openToken, closeToken, hintSpanNode, sourceFile, autoCollapse = false, useFullStart = true) {
        const textSpan = createTextSpanFromBounds(useFullStart ? openToken.getFullStart() : openToken.getStart(sourceFile), closeToken.getEnd());
        return createOutliningSpan(textSpan, "code" /* Code */ , createTextSpanFromNode(hintSpanNode, sourceFile), autoCollapse);
    }
    function createOutliningSpan(textSpan, kind, hintSpan = textSpan, autoCollapse = false, bannerText = "...") {
        return {
            textSpan: textSpan,
            kind: kind,
            hintSpan: hintSpan,
            bannerText: bannerText,
            autoCollapse: autoCollapse
        };
    }
    function tryGetFunctionOpenToken(node, body, sourceFile) {
        if (isNodeArrayMultiLine(node.parameters, sourceFile)) {
            const openParenToken = findChildOfKind(node, 21 /* OpenParenToken */ , sourceFile);
            if (openParenToken) return openParenToken;
        }
        return findChildOfKind(body, 19 /* OpenBraceToken */ , sourceFile);
    }
    var regionDelimiterRegExp;
    var init_outliningElementsCollector = __esm({
        "src/services/outliningElementsCollector.ts" () {
            "use strict";
            init_ts4();
            regionDelimiterRegExp = /^#(end)?region(?:\s+(.*))?(?:\r)?$/;
        }
    });
    // src/services/_namespaces/ts.OutliningElementsCollector.ts
    var ts_OutliningElementsCollector_exports = {};
    __export(ts_OutliningElementsCollector_exports, {
        collectElements: ()=>collectElements
    });
    var init_ts_OutliningElementsCollector = __esm({
        "src/services/_namespaces/ts.OutliningElementsCollector.ts" () {
            "use strict";
            init_outliningElementsCollector();
        }
    });
    // src/services/rename.ts
    function getRenameInfo(program, sourceFile, position, preferences) {
        const node = getAdjustedRenameLocation(getTouchingPropertyName(sourceFile, position));
        if (nodeIsEligibleForRename(node)) {
            const renameInfo = getRenameInfoForNode(node, program.getTypeChecker(), sourceFile, program, preferences);
            if (renameInfo) return renameInfo;
        }
        return getRenameInfoError(Diagnostics.You_cannot_rename_this_element);
    }
    function getRenameInfoForNode(node, typeChecker, sourceFile, program, preferences) {
        const symbol = typeChecker.getSymbolAtLocation(node);
        if (!symbol) {
            if (isStringLiteralLike(node)) {
                const type = getContextualTypeFromParentOrAncestorTypeNode(node, typeChecker);
                if (type && (type.flags & 128 /* StringLiteral */  || type.flags & 1048576 /* Union */  && every(type.types, (type2)=>!!(type2.flags & 128 /* StringLiteral */ )))) return getRenameInfoSuccess(node.text, node.text, "string" /* string */ , "", node, sourceFile);
            } else if (isLabelName(node)) {
                const name = getTextOfNode(node);
                return getRenameInfoSuccess(name, name, "label" /* label */ , "" /* none */ , node, sourceFile);
            }
            return void 0;
        }
        const { declarations: declarations  } = symbol;
        if (!declarations || declarations.length === 0) return;
        if (declarations.some((declaration)=>isDefinedInLibraryFile(program, declaration))) return getRenameInfoError(Diagnostics.You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library);
        if (isIdentifier(node) && node.escapedText === "default" && symbol.parent && symbol.parent.flags & 1536 /* Module */ ) return void 0;
        if (isStringLiteralLike(node) && tryGetImportFromModuleSpecifier(node)) return preferences.allowRenameOfImportPath ? getRenameInfoForModule(node, sourceFile, symbol) : void 0;
        const wouldRenameNodeModules = wouldRenameInOtherNodeModules(sourceFile, symbol, typeChecker, preferences);
        if (wouldRenameNodeModules) return getRenameInfoError(wouldRenameNodeModules);
        const kind = ts_SymbolDisplay_exports.getSymbolKind(typeChecker, symbol, node);
        const specifierName = isImportOrExportSpecifierName(node) || isStringOrNumericLiteralLike(node) && node.parent.kind === 166 /* ComputedPropertyName */  ? stripQuotes(getTextOfIdentifierOrLiteral(node)) : void 0;
        const displayName = specifierName || typeChecker.symbolToString(symbol);
        const fullDisplayName = specifierName || typeChecker.getFullyQualifiedName(symbol);
        return getRenameInfoSuccess(displayName, fullDisplayName, kind, ts_SymbolDisplay_exports.getSymbolModifiers(typeChecker, symbol), node, sourceFile);
    }
    function isDefinedInLibraryFile(program, declaration) {
        const sourceFile = declaration.getSourceFile();
        return program.isSourceFileDefaultLibrary(sourceFile) && fileExtensionIs(sourceFile.fileName, ".d.ts" /* Dts */ );
    }
    function wouldRenameInOtherNodeModules(originalFile, symbol, checker, preferences) {
        if (!preferences.providePrefixAndSuffixTextForRename && symbol.flags & 2097152 /* Alias */ ) {
            const importSpecifier = symbol.declarations && find(symbol.declarations, (decl)=>isImportSpecifier(decl));
            if (importSpecifier && !importSpecifier.propertyName) symbol = checker.getAliasedSymbol(symbol);
        }
        const { declarations: declarations  } = symbol;
        if (!declarations) return void 0;
        const originalPackage = getPackagePathComponents(originalFile.path);
        if (originalPackage === void 0) {
            if (some(declarations, (declaration)=>isInsideNodeModules(declaration.getSourceFile().path))) return Diagnostics.You_cannot_rename_elements_that_are_defined_in_a_node_modules_folder;
            else return void 0;
        }
        for (const declaration of declarations){
            const declPackage = getPackagePathComponents(declaration.getSourceFile().path);
            if (declPackage) {
                const length2 = Math.min(originalPackage.length, declPackage.length);
                for(let i = 0; i <= length2; i++){
                    if (compareStringsCaseSensitive(originalPackage[i], declPackage[i]) !== 0 /* EqualTo */ ) return Diagnostics.You_cannot_rename_elements_that_are_defined_in_another_node_modules_folder;
                }
            }
        }
        return void 0;
    }
    function getPackagePathComponents(filePath) {
        const components = getPathComponents(filePath);
        const nodeModulesIdx = components.lastIndexOf("node_modules");
        if (nodeModulesIdx === -1) return void 0;
        return components.slice(0, nodeModulesIdx + 2);
    }
    function getRenameInfoForModule(node, sourceFile, moduleSymbol) {
        if (!isExternalModuleNameRelative(node.text)) return getRenameInfoError(Diagnostics.You_cannot_rename_a_module_via_a_global_import);
        const moduleSourceFile = moduleSymbol.declarations && find(moduleSymbol.declarations, isSourceFile);
        if (!moduleSourceFile) return void 0;
        const withoutIndex = endsWith(node.text, "/index") || endsWith(node.text, "/index.js") ? void 0 : tryRemoveSuffix(removeFileExtension(moduleSourceFile.fileName), "/index");
        const name = withoutIndex === void 0 ? moduleSourceFile.fileName : withoutIndex;
        const kind = withoutIndex === void 0 ? "module" /* moduleElement */  : "directory" /* directory */ ;
        const indexAfterLastSlash = node.text.lastIndexOf("/") + 1;
        const triggerSpan = createTextSpan(node.getStart(sourceFile) + 1 + indexAfterLastSlash, node.text.length - indexAfterLastSlash);
        return {
            canRename: true,
            fileToRename: name,
            kind: kind,
            displayName: name,
            fullDisplayName: name,
            kindModifiers: "" /* none */ ,
            triggerSpan: triggerSpan
        };
    }
    function getRenameInfoSuccess(displayName, fullDisplayName, kind, kindModifiers, node, sourceFile) {
        return {
            canRename: true,
            fileToRename: void 0,
            kind: kind,
            displayName: displayName,
            fullDisplayName: fullDisplayName,
            kindModifiers: kindModifiers,
            triggerSpan: createTriggerSpanForNode(node, sourceFile)
        };
    }
    function getRenameInfoError(diagnostic) {
        return {
            canRename: false,
            localizedErrorMessage: getLocaleSpecificMessage(diagnostic)
        };
    }
    function createTriggerSpanForNode(node, sourceFile) {
        let start = node.getStart(sourceFile);
        let width = node.getWidth(sourceFile);
        if (isStringLiteralLike(node)) {
            start += 1;
            width -= 2;
        }
        return createTextSpan(start, width);
    }
    function nodeIsEligibleForRename(node) {
        switch(node.kind){
            case 80 /* Identifier */ :
            case 81 /* PrivateIdentifier */ :
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 110 /* ThisKeyword */ :
                return true;
            case 9 /* NumericLiteral */ :
                return isLiteralNameOfPropertyDeclarationOrIndexAccess(node);
            default:
                return false;
        }
    }
    var init_rename = __esm({
        "src/services/rename.ts" () {
            "use strict";
            init_ts4();
        }
    });
    // src/services/_namespaces/ts.Rename.ts
    var ts_Rename_exports = {};
    __export(ts_Rename_exports, {
        getRenameInfo: ()=>getRenameInfo,
        nodeIsEligibleForRename: ()=>nodeIsEligibleForRename
    });
    var init_ts_Rename = __esm({
        "src/services/_namespaces/ts.Rename.ts" () {
            "use strict";
            init_rename();
        }
    });
    // src/services/signatureHelp.ts
    function getSignatureHelpItems(program, sourceFile, position, triggerReason, cancellationToken) {
        const typeChecker = program.getTypeChecker();
        const startingToken = findTokenOnLeftOfPosition(sourceFile, position);
        if (!startingToken) return void 0;
        const onlyUseSyntacticOwners = !!triggerReason && triggerReason.kind === "characterTyped";
        if (onlyUseSyntacticOwners && (isInString(sourceFile, position, startingToken) || isInComment(sourceFile, position))) return void 0;
        const isManuallyInvoked = !!triggerReason && triggerReason.kind === "invoked";
        const argumentInfo = getContainingArgumentInfo(startingToken, position, sourceFile, typeChecker, isManuallyInvoked);
        if (!argumentInfo) return void 0;
        cancellationToken.throwIfCancellationRequested();
        const candidateInfo = getCandidateOrTypeInfo(argumentInfo, typeChecker, sourceFile, startingToken, onlyUseSyntacticOwners);
        cancellationToken.throwIfCancellationRequested();
        if (!candidateInfo) return isSourceFileJS(sourceFile) ? createJSSignatureHelpItems(argumentInfo, program, cancellationToken) : void 0;
        return typeChecker.runWithCancellationToken(cancellationToken, (typeChecker2)=>candidateInfo.kind === 0 /* Candidate */  ? createSignatureHelpItems(candidateInfo.candidates, candidateInfo.resolvedSignature, argumentInfo, sourceFile, typeChecker2) : createTypeHelpItems(candidateInfo.symbol, argumentInfo, sourceFile, typeChecker2));
    }
    function getCandidateOrTypeInfo({ invocation: invocation , argumentCount: argumentCount  }, checker, sourceFile, startingToken, onlyUseSyntacticOwners) {
        switch(invocation.kind){
            case 0 /* Call */ :
                {
                    if (onlyUseSyntacticOwners && !isSyntacticOwner(startingToken, invocation.node, sourceFile)) return void 0;
                    const candidates = [];
                    const resolvedSignature = checker.getResolvedSignatureForSignatureHelp(invocation.node, candidates, argumentCount);
                    return candidates.length === 0 ? void 0 : {
                        kind: 0 /* Candidate */ ,
                        candidates: candidates,
                        resolvedSignature: resolvedSignature
                    };
                }
            case 1 /* TypeArgs */ :
                {
                    const { called: called  } = invocation;
                    if (onlyUseSyntacticOwners && !containsPrecedingToken(startingToken, sourceFile, isIdentifier(called) ? called.parent : called)) return void 0;
                    const candidates = getPossibleGenericSignatures(called, argumentCount, checker);
                    if (candidates.length !== 0) return {
                        kind: 0 /* Candidate */ ,
                        candidates: candidates,
                        resolvedSignature: first(candidates)
                    };
                    const symbol = checker.getSymbolAtLocation(called);
                    return symbol && {
                        kind: 1 /* Type */ ,
                        symbol: symbol
                    };
                }
            case 2 /* Contextual */ :
                return {
                    kind: 0 /* Candidate */ ,
                    candidates: [
                        invocation.signature
                    ],
                    resolvedSignature: invocation.signature
                };
            default:
                return Debug.assertNever(invocation);
        }
    }
    function isSyntacticOwner(startingToken, node, sourceFile) {
        if (!isCallOrNewExpression(node)) return false;
        const invocationChildren = node.getChildren(sourceFile);
        switch(startingToken.kind){
            case 21 /* OpenParenToken */ :
                return contains(invocationChildren, startingToken);
            case 28 /* CommaToken */ :
                {
                    const containingList = findContainingList(startingToken);
                    return !!containingList && contains(invocationChildren, containingList);
                }
            case 30 /* LessThanToken */ :
                return containsPrecedingToken(startingToken, sourceFile, node.expression);
            default:
                return false;
        }
    }
    function createJSSignatureHelpItems(argumentInfo, program, cancellationToken) {
        if (argumentInfo.invocation.kind === 2 /* Contextual */ ) return void 0;
        const expression = getExpressionFromInvocation(argumentInfo.invocation);
        const name = isPropertyAccessExpression(expression) ? expression.name.text : void 0;
        const typeChecker = program.getTypeChecker();
        return name === void 0 ? void 0 : firstDefined(program.getSourceFiles(), (sourceFile)=>firstDefined(sourceFile.getNamedDeclarations().get(name), (declaration)=>{
                const type = declaration.symbol && typeChecker.getTypeOfSymbolAtLocation(declaration.symbol, declaration);
                const callSignatures = type && type.getCallSignatures();
                if (callSignatures && callSignatures.length) return typeChecker.runWithCancellationToken(cancellationToken, (typeChecker2)=>createSignatureHelpItems(callSignatures, callSignatures[0], argumentInfo, sourceFile, typeChecker2, /*useFullPrefix*/ true));
            }));
    }
    function containsPrecedingToken(startingToken, sourceFile, container) {
        const pos = startingToken.getFullStart();
        let currentParent = startingToken.parent;
        while(currentParent){
            const precedingToken = findPrecedingToken(pos, sourceFile, currentParent, /*excludeJsdoc*/ true);
            if (precedingToken) return rangeContainsRange(container, precedingToken);
            currentParent = currentParent.parent;
        }
        return Debug.fail("Could not find preceding token");
    }
    function getArgumentInfoForCompletions(node, position, sourceFile) {
        const info = getImmediatelyContainingArgumentInfo(node, position, sourceFile);
        return !info || info.isTypeParameterList || info.invocation.kind !== 0 /* Call */  ? void 0 : {
            invocation: info.invocation.node,
            argumentCount: info.argumentCount,
            argumentIndex: info.argumentIndex
        };
    }
    function getArgumentOrParameterListInfo(node, position, sourceFile) {
        const info = getArgumentOrParameterListAndIndex(node, sourceFile);
        if (!info) return void 0;
        const { list: list , argumentIndex: argumentIndex  } = info;
        const argumentCount = getArgumentCount(list, /*ignoreTrailingComma*/ isInString(sourceFile, position, node));
        if (argumentIndex !== 0) Debug.assertLessThan(argumentIndex, argumentCount);
        const argumentsSpan = getApplicableSpanForArguments(list, sourceFile);
        return {
            list: list,
            argumentIndex: argumentIndex,
            argumentCount: argumentCount,
            argumentsSpan: argumentsSpan
        };
    }
    function getArgumentOrParameterListAndIndex(node, sourceFile) {
        if (node.kind === 30 /* LessThanToken */  || node.kind === 21 /* OpenParenToken */ ) return {
            list: getChildListThatStartsWithOpenerToken(node.parent, node, sourceFile),
            argumentIndex: 0
        };
        else {
            const list = findContainingList(node);
            return list && {
                list: list,
                argumentIndex: getArgumentIndex(list, node)
            };
        }
    }
    function getImmediatelyContainingArgumentInfo(node, position, sourceFile) {
        const { parent: parent2  } = node;
        if (isCallOrNewExpression(parent2)) {
            const invocation = parent2;
            const info = getArgumentOrParameterListInfo(node, position, sourceFile);
            if (!info) return void 0;
            const { list: list , argumentIndex: argumentIndex , argumentCount: argumentCount , argumentsSpan: argumentsSpan  } = info;
            const isTypeParameterList = !!parent2.typeArguments && parent2.typeArguments.pos === list.pos;
            return {
                isTypeParameterList: isTypeParameterList,
                invocation: {
                    kind: 0 /* Call */ ,
                    node: invocation
                },
                argumentsSpan: argumentsSpan,
                argumentIndex: argumentIndex,
                argumentCount: argumentCount
            };
        } else if (isNoSubstitutionTemplateLiteral(node) && isTaggedTemplateExpression(parent2)) {
            if (isInsideTemplateLiteral(node, position, sourceFile)) return getArgumentListInfoForTemplate(parent2, /*argumentIndex*/ 0, sourceFile);
            return void 0;
        } else if (isTemplateHead(node) && parent2.parent.kind === 214 /* TaggedTemplateExpression */ ) {
            const templateExpression = parent2;
            const tagExpression = templateExpression.parent;
            Debug.assert(templateExpression.kind === 227 /* TemplateExpression */ );
            const argumentIndex = isInsideTemplateLiteral(node, position, sourceFile) ? 0 : 1;
            return getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile);
        } else if (isTemplateSpan(parent2) && isTaggedTemplateExpression(parent2.parent.parent)) {
            const templateSpan = parent2;
            const tagExpression = parent2.parent.parent;
            if (isTemplateTail(node) && !isInsideTemplateLiteral(node, position, sourceFile)) return void 0;
            const spanIndex = templateSpan.parent.templateSpans.indexOf(templateSpan);
            const argumentIndex = getArgumentIndexForTemplatePiece(spanIndex, node, position, sourceFile);
            return getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile);
        } else if (isJsxOpeningLikeElement(parent2)) {
            const attributeSpanStart = parent2.attributes.pos;
            const attributeSpanEnd = skipTrivia(sourceFile.text, parent2.attributes.end, /*stopAfterLineBreak*/ false);
            return {
                isTypeParameterList: false,
                invocation: {
                    kind: 0 /* Call */ ,
                    node: parent2
                },
                argumentsSpan: createTextSpan(attributeSpanStart, attributeSpanEnd - attributeSpanStart),
                argumentIndex: 0,
                argumentCount: 1
            };
        } else {
            const typeArgInfo = getPossibleTypeArgumentsInfo(node, sourceFile);
            if (typeArgInfo) {
                const { called: called , nTypeArguments: nTypeArguments  } = typeArgInfo;
                const invocation = {
                    kind: 1 /* TypeArgs */ ,
                    called: called
                };
                const argumentsSpan = createTextSpanFromBounds(called.getStart(sourceFile), node.end);
                return {
                    isTypeParameterList: true,
                    invocation: invocation,
                    argumentsSpan: argumentsSpan,
                    argumentIndex: nTypeArguments,
                    argumentCount: nTypeArguments + 1
                };
            }
            return void 0;
        }
    }
    function getImmediatelyContainingArgumentOrContextualParameterInfo(node, position, sourceFile, checker) {
        return tryGetParameterInfo(node, position, sourceFile, checker) || getImmediatelyContainingArgumentInfo(node, position, sourceFile);
    }
    function getHighestBinary(b) {
        return isBinaryExpression(b.parent) ? getHighestBinary(b.parent) : b;
    }
    function countBinaryExpressionParameters(b) {
        return isBinaryExpression(b.left) ? countBinaryExpressionParameters(b.left) + 1 : 2;
    }
    function tryGetParameterInfo(startingToken, position, sourceFile, checker) {
        const node = getAdjustedNode(startingToken);
        if (node === void 0) return void 0;
        const info = getContextualSignatureLocationInfo(node, sourceFile, position, checker);
        if (info === void 0) return void 0;
        const { contextualType: contextualType , argumentIndex: argumentIndex , argumentCount: argumentCount , argumentsSpan: argumentsSpan  } = info;
        const nonNullableContextualType = contextualType.getNonNullableType();
        const symbol = nonNullableContextualType.symbol;
        if (symbol === void 0) return void 0;
        const signature = lastOrUndefined(nonNullableContextualType.getCallSignatures());
        if (signature === void 0) return void 0;
        const invocation = {
            kind: 2 /* Contextual */ ,
            signature: signature,
            node: startingToken,
            symbol: chooseBetterSymbol(symbol)
        };
        return {
            isTypeParameterList: false,
            invocation: invocation,
            argumentsSpan: argumentsSpan,
            argumentIndex: argumentIndex,
            argumentCount: argumentCount
        };
    }
    function getAdjustedNode(node) {
        switch(node.kind){
            case 21 /* OpenParenToken */ :
            case 28 /* CommaToken */ :
                return node;
            default:
                return findAncestor(node.parent, (n)=>isParameter(n) ? true : isBindingElement(n) || isObjectBindingPattern(n) || isArrayBindingPattern(n) ? false : "quit");
        }
    }
    function getContextualSignatureLocationInfo(node, sourceFile, position, checker) {
        const { parent: parent2  } = node;
        switch(parent2.kind){
            case 216 /* ParenthesizedExpression */ :
            case 173 /* MethodDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
                const info = getArgumentOrParameterListInfo(node, position, sourceFile);
                if (!info) return void 0;
                const { argumentIndex: argumentIndex , argumentCount: argumentCount , argumentsSpan: argumentsSpan  } = info;
                const contextualType = isMethodDeclaration(parent2) ? checker.getContextualTypeForObjectLiteralElement(parent2) : checker.getContextualType(parent2);
                return contextualType && {
                    contextualType: contextualType,
                    argumentIndex: argumentIndex,
                    argumentCount: argumentCount,
                    argumentsSpan: argumentsSpan
                };
            case 225 /* BinaryExpression */ :
                {
                    const highestBinary = getHighestBinary(parent2);
                    const contextualType2 = checker.getContextualType(highestBinary);
                    const argumentIndex2 = node.kind === 21 /* OpenParenToken */  ? 0 : countBinaryExpressionParameters(parent2) - 1;
                    const argumentCount2 = countBinaryExpressionParameters(highestBinary);
                    return contextualType2 && {
                        contextualType: contextualType2,
                        argumentIndex: argumentIndex2,
                        argumentCount: argumentCount2,
                        argumentsSpan: createTextSpanFromNode(parent2)
                    };
                }
            default:
                return void 0;
        }
    }
    function chooseBetterSymbol(s) {
        return s.name === "__type" /* Type */  ? firstDefined(s.declarations, (d)=>{
            var _a;
            return isFunctionTypeNode(d) ? (_a = tryCast(d.parent, canHaveSymbol)) == null ? void 0 : _a.symbol : void 0;
        }) || s : s;
    }
    function getArgumentIndex(argumentsList, node) {
        let argumentIndex = 0;
        for (const child of argumentsList.getChildren()){
            if (child === node) break;
            if (child.kind !== 28 /* CommaToken */ ) argumentIndex++;
        }
        return argumentIndex;
    }
    function getArgumentCount(argumentsList, ignoreTrailingComma) {
        const listChildren = argumentsList.getChildren();
        let argumentCount = countWhere(listChildren, (arg)=>arg.kind !== 28 /* CommaToken */ );
        if (!ignoreTrailingComma && listChildren.length > 0 && last(listChildren).kind === 28 /* CommaToken */ ) argumentCount++;
        return argumentCount;
    }
    function getArgumentIndexForTemplatePiece(spanIndex, node, position, sourceFile) {
        Debug.assert(position >= node.getStart(), "Assumed 'position' could not occur before node.");
        if (isTemplateLiteralToken(node)) {
            if (isInsideTemplateLiteral(node, position, sourceFile)) return 0;
            return spanIndex + 2;
        }
        return spanIndex + 1;
    }
    function getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile) {
        const argumentCount = isNoSubstitutionTemplateLiteral(tagExpression.template) ? 1 : tagExpression.template.templateSpans.length + 1;
        if (argumentIndex !== 0) Debug.assertLessThan(argumentIndex, argumentCount);
        return {
            isTypeParameterList: false,
            invocation: {
                kind: 0 /* Call */ ,
                node: tagExpression
            },
            argumentsSpan: getApplicableSpanForTaggedTemplate(tagExpression, sourceFile),
            argumentIndex: argumentIndex,
            argumentCount: argumentCount
        };
    }
    function getApplicableSpanForArguments(argumentsList, sourceFile) {
        const applicableSpanStart = argumentsList.getFullStart();
        const applicableSpanEnd = skipTrivia(sourceFile.text, argumentsList.getEnd(), /*stopAfterLineBreak*/ false);
        return createTextSpan(applicableSpanStart, applicableSpanEnd - applicableSpanStart);
    }
    function getApplicableSpanForTaggedTemplate(taggedTemplate, sourceFile) {
        const template = taggedTemplate.template;
        const applicableSpanStart = template.getStart();
        let applicableSpanEnd = template.getEnd();
        if (template.kind === 227 /* TemplateExpression */ ) {
            const lastSpan = last(template.templateSpans);
            if (lastSpan.literal.getFullWidth() === 0) applicableSpanEnd = skipTrivia(sourceFile.text, applicableSpanEnd, /*stopAfterLineBreak*/ false);
        }
        return createTextSpan(applicableSpanStart, applicableSpanEnd - applicableSpanStart);
    }
    function getContainingArgumentInfo(node, position, sourceFile, checker, isManuallyInvoked) {
        for(let n = node; !isSourceFile(n) && (isManuallyInvoked || !isBlock(n)); n = n.parent){
            Debug.assert(rangeContainsRange(n.parent, n), "Not a subspan", ()=>`Child: ${Debug.formatSyntaxKind(n.kind)}, parent: ${Debug.formatSyntaxKind(n.parent.kind)}`);
            const argumentInfo = getImmediatelyContainingArgumentOrContextualParameterInfo(n, position, sourceFile, checker);
            if (argumentInfo) return argumentInfo;
        }
        return void 0;
    }
    function getChildListThatStartsWithOpenerToken(parent2, openerToken, sourceFile) {
        const children = parent2.getChildren(sourceFile);
        const indexOfOpenerToken = children.indexOf(openerToken);
        Debug.assert(indexOfOpenerToken >= 0 && children.length > indexOfOpenerToken + 1);
        return children[indexOfOpenerToken + 1];
    }
    function getExpressionFromInvocation(invocation) {
        return invocation.kind === 0 /* Call */  ? getInvokedExpression(invocation.node) : invocation.called;
    }
    function getEnclosingDeclarationFromInvocation(invocation) {
        return invocation.kind === 0 /* Call */  ? invocation.node : invocation.kind === 1 /* TypeArgs */  ? invocation.called : invocation.node;
    }
    function createSignatureHelpItems(candidates, resolvedSignature, { isTypeParameterList: isTypeParameterList , argumentCount: argumentCount , argumentsSpan: applicableSpan , invocation: invocation , argumentIndex: argumentIndex  }, sourceFile, typeChecker, useFullPrefix) {
        var _a;
        const enclosingDeclaration = getEnclosingDeclarationFromInvocation(invocation);
        const callTargetSymbol = invocation.kind === 2 /* Contextual */  ? invocation.symbol : typeChecker.getSymbolAtLocation(getExpressionFromInvocation(invocation)) || useFullPrefix && ((_a = resolvedSignature.declaration) == null ? void 0 : _a.symbol);
        const callTargetDisplayParts = callTargetSymbol ? symbolToDisplayParts(typeChecker, callTargetSymbol, useFullPrefix ? sourceFile : void 0, /*meaning*/ void 0) : emptyArray;
        const items = map(candidates, (candidateSignature)=>getSignatureHelpItem(candidateSignature, callTargetDisplayParts, isTypeParameterList, typeChecker, enclosingDeclaration, sourceFile));
        if (argumentIndex !== 0) Debug.assertLessThan(argumentIndex, argumentCount);
        let selectedItemIndex = 0;
        let itemsSeen = 0;
        for(let i = 0; i < items.length; i++){
            const item = items[i];
            if (candidates[i] === resolvedSignature) {
                selectedItemIndex = itemsSeen;
                if (item.length > 1) {
                    let count = 0;
                    for (const i2 of item){
                        if (i2.isVariadic || i2.parameters.length >= argumentCount) {
                            selectedItemIndex = itemsSeen + count;
                            break;
                        }
                        count++;
                    }
                }
            }
            itemsSeen += item.length;
        }
        Debug.assert(selectedItemIndex !== -1);
        const help = {
            items: flatMapToMutable(items, identity),
            applicableSpan: applicableSpan,
            selectedItemIndex: selectedItemIndex,
            argumentIndex: argumentIndex,
            argumentCount: argumentCount
        };
        const selected = help.items[selectedItemIndex];
        if (selected.isVariadic) {
            const firstRest = findIndex(selected.parameters, (p)=>!!p.isRest);
            if (-1 < firstRest && firstRest < selected.parameters.length - 1) help.argumentIndex = selected.parameters.length;
            else help.argumentIndex = Math.min(help.argumentIndex, selected.parameters.length - 1);
        }
        return help;
    }
    function createTypeHelpItems(symbol, { argumentCount: argumentCount , argumentsSpan: applicableSpan , invocation: invocation , argumentIndex: argumentIndex  }, sourceFile, checker) {
        const typeParameters = checker.getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
        if (!typeParameters) return void 0;
        const items = [
            getTypeHelpItem(symbol, typeParameters, checker, getEnclosingDeclarationFromInvocation(invocation), sourceFile)
        ];
        return {
            items: items,
            applicableSpan: applicableSpan,
            selectedItemIndex: 0,
            argumentIndex: argumentIndex,
            argumentCount: argumentCount
        };
    }
    function getTypeHelpItem(symbol, typeParameters, checker, enclosingDeclaration, sourceFile) {
        const typeSymbolDisplay = symbolToDisplayParts(checker, symbol);
        const printer = createPrinterWithRemoveComments();
        const parameters = typeParameters.map((t)=>createSignatureHelpParameterForTypeParameter(t, checker, enclosingDeclaration, sourceFile, printer));
        const documentation = symbol.getDocumentationComment(checker);
        const tags = symbol.getJsDocTags(checker);
        const prefixDisplayParts = [
            ...typeSymbolDisplay,
            punctuationPart(30 /* LessThanToken */ )
        ];
        return {
            isVariadic: false,
            prefixDisplayParts: prefixDisplayParts,
            suffixDisplayParts: [
                punctuationPart(32 /* GreaterThanToken */ )
            ],
            separatorDisplayParts: separatorDisplayParts,
            parameters: parameters,
            documentation: documentation,
            tags: tags
        };
    }
    function getSignatureHelpItem(candidateSignature, callTargetDisplayParts, isTypeParameterList, checker, enclosingDeclaration, sourceFile) {
        const infos = (isTypeParameterList ? itemInfoForTypeParameters : itemInfoForParameters)(candidateSignature, checker, enclosingDeclaration, sourceFile);
        return map(infos, ({ isVariadic: isVariadic , parameters: parameters , prefix: prefix , suffix: suffix  })=>{
            const prefixDisplayParts = [
                ...callTargetDisplayParts,
                ...prefix
            ];
            const suffixDisplayParts = [
                ...suffix,
                ...returnTypeToDisplayParts(candidateSignature, enclosingDeclaration, checker)
            ];
            const documentation = candidateSignature.getDocumentationComment(checker);
            const tags = candidateSignature.getJsDocTags();
            return {
                isVariadic: isVariadic,
                prefixDisplayParts: prefixDisplayParts,
                suffixDisplayParts: suffixDisplayParts,
                separatorDisplayParts: separatorDisplayParts,
                parameters: parameters,
                documentation: documentation,
                tags: tags
            };
        });
    }
    function returnTypeToDisplayParts(candidateSignature, enclosingDeclaration, checker) {
        return mapToDisplayParts((writer)=>{
            writer.writePunctuation(":");
            writer.writeSpace(" ");
            const predicate = checker.getTypePredicateOfSignature(candidateSignature);
            if (predicate) checker.writeTypePredicate(predicate, enclosingDeclaration, /*flags*/ void 0, writer);
            else checker.writeType(checker.getReturnTypeOfSignature(candidateSignature), enclosingDeclaration, /*flags*/ void 0, writer);
        });
    }
    function itemInfoForTypeParameters(candidateSignature, checker, enclosingDeclaration, sourceFile) {
        const typeParameters = (candidateSignature.target || candidateSignature).typeParameters;
        const printer = createPrinterWithRemoveComments();
        const parameters = (typeParameters || emptyArray).map((t)=>createSignatureHelpParameterForTypeParameter(t, checker, enclosingDeclaration, sourceFile, printer));
        const thisParameter = candidateSignature.thisParameter ? [
            checker.symbolToParameterDeclaration(candidateSignature.thisParameter, enclosingDeclaration, signatureHelpNodeBuilderFlags)
        ] : [];
        return checker.getExpandedParameters(candidateSignature).map((paramList)=>{
            const params = factory.createNodeArray([
                ...thisParameter,
                ...map(paramList, (param)=>checker.symbolToParameterDeclaration(param, enclosingDeclaration, signatureHelpNodeBuilderFlags))
            ]);
            const parameterParts = mapToDisplayParts((writer)=>{
                printer.writeList(2576 /* CallExpressionArguments */ , params, sourceFile, writer);
            });
            return {
                isVariadic: false,
                parameters: parameters,
                prefix: [
                    punctuationPart(30 /* LessThanToken */ )
                ],
                suffix: [
                    punctuationPart(32 /* GreaterThanToken */ ),
                    ...parameterParts
                ]
            };
        });
    }
    function itemInfoForParameters(candidateSignature, checker, enclosingDeclaration, sourceFile) {
        const printer = createPrinterWithRemoveComments();
        const typeParameterParts = mapToDisplayParts((writer)=>{
            if (candidateSignature.typeParameters && candidateSignature.typeParameters.length) {
                const args = factory.createNodeArray(candidateSignature.typeParameters.map((p)=>checker.typeParameterToDeclaration(p, enclosingDeclaration, signatureHelpNodeBuilderFlags)));
                printer.writeList(53776 /* TypeParameters */ , args, sourceFile, writer);
            }
        });
        const lists = checker.getExpandedParameters(candidateSignature);
        const isVariadic = !checker.hasEffectiveRestParameter(candidateSignature) ? (_)=>false : lists.length === 1 ? (_)=>true : (pList)=>{
            var _a;
            return !!(pList.length && ((_a = tryCast(pList[pList.length - 1], isTransientSymbol)) == null ? void 0 : _a.links.checkFlags) & 32768 /* RestParameter */ );
        };
        return lists.map((parameterList)=>({
                isVariadic: isVariadic(parameterList),
                parameters: parameterList.map((p)=>createSignatureHelpParameterForParameter(p, checker, enclosingDeclaration, sourceFile, printer)),
                prefix: [
                    ...typeParameterParts,
                    punctuationPart(21 /* OpenParenToken */ )
                ],
                suffix: [
                    punctuationPart(22 /* CloseParenToken */ )
                ]
            }));
    }
    function createSignatureHelpParameterForParameter(parameter, checker, enclosingDeclaration, sourceFile, printer) {
        const displayParts = mapToDisplayParts((writer)=>{
            const param = checker.symbolToParameterDeclaration(parameter, enclosingDeclaration, signatureHelpNodeBuilderFlags);
            printer.writeNode(4 /* Unspecified */ , param, sourceFile, writer);
        });
        const isOptional = checker.isOptionalParameter(parameter.valueDeclaration);
        const isRest = isTransientSymbol(parameter) && !!(parameter.links.checkFlags & 32768 /* RestParameter */ );
        return {
            name: parameter.name,
            documentation: parameter.getDocumentationComment(checker),
            displayParts: displayParts,
            isOptional: isOptional,
            isRest: isRest
        };
    }
    function createSignatureHelpParameterForTypeParameter(typeParameter, checker, enclosingDeclaration, sourceFile, printer) {
        const displayParts = mapToDisplayParts((writer)=>{
            const param = checker.typeParameterToDeclaration(typeParameter, enclosingDeclaration, signatureHelpNodeBuilderFlags);
            printer.writeNode(4 /* Unspecified */ , param, sourceFile, writer);
        });
        return {
            name: typeParameter.symbol.name,
            documentation: typeParameter.symbol.getDocumentationComment(checker),
            displayParts: displayParts,
            isOptional: false,
            isRest: false
        };
    }
    var signatureHelpNodeBuilderFlags, separatorDisplayParts;
    var init_signatureHelp = __esm({
        "src/services/signatureHelp.ts" () {
            "use strict";
            init_ts4();
            signatureHelpNodeBuilderFlags = 70246400 /* UseAliasDefinedOutsideCurrentScope */ ;
            separatorDisplayParts = [
                punctuationPart(28 /* CommaToken */ ),
                spacePart()
            ];
        }
    });
    // src/services/_namespaces/ts.SignatureHelp.ts
    var ts_SignatureHelp_exports = {};
    __export(ts_SignatureHelp_exports, {
        getArgumentInfoForCompletions: ()=>getArgumentInfoForCompletions,
        getSignatureHelpItems: ()=>getSignatureHelpItems
    });
    var init_ts_SignatureHelp = __esm({
        "src/services/_namespaces/ts.SignatureHelp.ts" () {
            "use strict";
            init_signatureHelp();
        }
    });
    // src/services/smartSelection.ts
    function getSmartSelectionRange(pos, sourceFile) {
        var _a, _b;
        let selectionRange = {
            textSpan: createTextSpanFromBounds(sourceFile.getFullStart(), sourceFile.getEnd())
        };
        let parentNode = sourceFile;
        outer: while(true){
            const children = getSelectionChildren(parentNode);
            if (!children.length) break;
            for(let i = 0; i < children.length; i++){
                const prevNode = children[i - 1];
                const node = children[i];
                const nextNode = children[i + 1];
                if (getTokenPosOfNode(node, sourceFile, /*includeJsDoc*/ true) > pos) break outer;
                const comment = singleOrUndefined(getTrailingCommentRanges(sourceFile.text, node.end));
                if (comment && comment.kind === 2 /* SingleLineCommentTrivia */ ) pushSelectionCommentRange(comment.pos, comment.end);
                if (positionShouldSnapToNode(sourceFile, pos, node)) {
                    if (isFunctionBody(node) && isFunctionLikeDeclaration(parentNode) && !positionsAreOnSameLine(node.getStart(sourceFile), node.getEnd(), sourceFile)) pushSelectionRange(node.getStart(sourceFile), node.getEnd());
                    if (isBlock(node) || isTemplateSpan(node) || isTemplateHead(node) || isTemplateTail(node) || prevNode && isTemplateHead(prevNode) || isVariableDeclarationList(node) && isVariableStatement(parentNode) || isSyntaxList(node) && isVariableDeclarationList(parentNode) || isVariableDeclaration(node) && isSyntaxList(parentNode) && children.length === 1 || isJSDocTypeExpression(node) || isJSDocSignature(node) || isJSDocTypeLiteral(node)) {
                        parentNode = node;
                        break;
                    }
                    if (isTemplateSpan(parentNode) && nextNode && isTemplateMiddleOrTemplateTail(nextNode)) {
                        const start2 = node.getFullStart() - 2;
                        const end2 = nextNode.getStart() + 1;
                        pushSelectionRange(start2, end2);
                    }
                    const isBetweenMultiLineBookends = isSyntaxList(node) && isListOpener(prevNode) && isListCloser(nextNode) && !positionsAreOnSameLine(prevNode.getStart(), nextNode.getStart(), sourceFile);
                    let start = isBetweenMultiLineBookends ? prevNode.getEnd() : node.getStart();
                    const end = isBetweenMultiLineBookends ? nextNode.getStart() : getEndPos(sourceFile, node);
                    if (hasJSDocNodes(node) && ((_a = node.jsDoc) == null ? void 0 : _a.length)) pushSelectionRange(first(node.jsDoc).getStart(), end);
                    if (isSyntaxList(node)) {
                        const firstChild = node.getChildren()[0];
                        if (firstChild && hasJSDocNodes(firstChild) && ((_b = firstChild.jsDoc) == null ? void 0 : _b.length) && firstChild.getStart() !== node.pos) start = Math.min(start, first(firstChild.jsDoc).getStart());
                    }
                    pushSelectionRange(start, end);
                    if (isStringLiteral(node) || isTemplateLiteral(node)) pushSelectionRange(start + 1, end - 1);
                    parentNode = node;
                    break;
                }
                if (i === children.length - 1) break outer;
            }
        }
        return selectionRange;
        function pushSelectionRange(start, end) {
            if (start !== end) {
                const textSpan = createTextSpanFromBounds(start, end);
                if (!selectionRange || // Skip ranges that are identical to the parent
                !textSpansEqual(textSpan, selectionRange.textSpan) && // Skip ranges that don't contain the original position
                textSpanIntersectsWithPosition(textSpan, pos)) selectionRange = {
                    textSpan: textSpan,
                    ...selectionRange && {
                        parent: selectionRange
                    }
                };
            }
        }
        function pushSelectionCommentRange(start, end) {
            pushSelectionRange(start, end);
            let pos2 = start;
            while(sourceFile.text.charCodeAt(pos2) === 47 /* slash */ )pos2++;
            pushSelectionRange(pos2, end);
        }
    }
    function positionShouldSnapToNode(sourceFile, pos, node) {
        Debug.assert(node.pos <= pos);
        if (pos < node.end) return true;
        const nodeEnd = node.getEnd();
        if (nodeEnd === pos) return getTouchingPropertyName(sourceFile, pos).pos < node.end;
        return false;
    }
    function getSelectionChildren(node) {
        var _a;
        if (isSourceFile(node)) return groupChildren(node.getChildAt(0).getChildren(), isImport2);
        if (isMappedTypeNode(node)) {
            const [openBraceToken, ...children] = node.getChildren();
            const closeBraceToken = Debug.checkDefined(children.pop());
            Debug.assertEqual(openBraceToken.kind, 19 /* OpenBraceToken */ );
            Debug.assertEqual(closeBraceToken.kind, 20 /* CloseBraceToken */ );
            const groupedWithPlusMinusTokens = groupChildren(children, (child)=>child === node.readonlyToken || child.kind === 148 /* ReadonlyKeyword */  || child === node.questionToken || child.kind === 58 /* QuestionToken */ );
            const groupedWithBrackets = groupChildren(groupedWithPlusMinusTokens, ({ kind: kind  })=>kind === 23 /* OpenBracketToken */  || kind === 167 /* TypeParameter */  || kind === 24 /* CloseBracketToken */ );
            return [
                openBraceToken,
                // Pivot on `:`
                createSyntaxList2(splitChildren(groupedWithBrackets, ({ kind: kind  })=>kind === 59 /* ColonToken */ )),
                closeBraceToken
            ];
        }
        if (isPropertySignature(node)) {
            const children = groupChildren(node.getChildren(), (child)=>child === node.name || contains(node.modifiers, child));
            const firstJSDocChild = ((_a = children[0]) == null ? void 0 : _a.kind) === 326 /* JSDoc */  ? children[0] : void 0;
            const withJSDocSeparated = firstJSDocChild ? children.slice(1) : children;
            const splittedChildren = splitChildren(withJSDocSeparated, ({ kind: kind  })=>kind === 59 /* ColonToken */ );
            return firstJSDocChild ? [
                firstJSDocChild,
                createSyntaxList2(splittedChildren)
            ] : splittedChildren;
        }
        if (isParameter(node)) {
            const groupedDotDotDotAndName = groupChildren(node.getChildren(), (child)=>child === node.dotDotDotToken || child === node.name);
            const groupedWithQuestionToken = groupChildren(groupedDotDotDotAndName, (child)=>child === groupedDotDotDotAndName[0] || child === node.questionToken);
            return splitChildren(groupedWithQuestionToken, ({ kind: kind  })=>kind === 64 /* EqualsToken */ );
        }
        if (isBindingElement(node)) return splitChildren(node.getChildren(), ({ kind: kind  })=>kind === 64 /* EqualsToken */ );
        return node.getChildren();
    }
    function groupChildren(children, groupOn) {
        const result = [];
        let group2;
        for (const child of children)if (groupOn(child)) {
            group2 = group2 || [];
            group2.push(child);
        } else {
            if (group2) {
                result.push(createSyntaxList2(group2));
                group2 = void 0;
            }
            result.push(child);
        }
        if (group2) result.push(createSyntaxList2(group2));
        return result;
    }
    function splitChildren(children, pivotOn, separateTrailingSemicolon = true) {
        if (children.length < 2) return children;
        const splitTokenIndex = findIndex(children, pivotOn);
        if (splitTokenIndex === -1) return children;
        const leftChildren = children.slice(0, splitTokenIndex);
        const splitToken = children[splitTokenIndex];
        const lastToken = last(children);
        const separateLastToken = separateTrailingSemicolon && lastToken.kind === 27 /* SemicolonToken */ ;
        const rightChildren = children.slice(splitTokenIndex + 1, separateLastToken ? children.length - 1 : void 0);
        const result = compact([
            leftChildren.length ? createSyntaxList2(leftChildren) : void 0,
            splitToken,
            rightChildren.length ? createSyntaxList2(rightChildren) : void 0
        ]);
        return separateLastToken ? result.concat(lastToken) : result;
    }
    function createSyntaxList2(children) {
        Debug.assertGreaterThanOrEqual(children.length, 1);
        return setTextRangePosEnd(parseNodeFactory.createSyntaxList(children), children[0].pos, last(children).end);
    }
    function isListOpener(token) {
        const kind = token && token.kind;
        return kind === 19 /* OpenBraceToken */  || kind === 23 /* OpenBracketToken */  || kind === 21 /* OpenParenToken */  || kind === 285 /* JsxOpeningElement */ ;
    }
    function isListCloser(token) {
        const kind = token && token.kind;
        return kind === 20 /* CloseBraceToken */  || kind === 24 /* CloseBracketToken */  || kind === 22 /* CloseParenToken */  || kind === 286 /* JsxClosingElement */ ;
    }
    function getEndPos(sourceFile, node) {
        switch(node.kind){
            case 347 /* JSDocParameterTag */ :
            case 344 /* JSDocCallbackTag */ :
            case 354 /* JSDocPropertyTag */ :
            case 352 /* JSDocTypedefTag */ :
            case 349 /* JSDocThisTag */ :
                return sourceFile.getLineEndOfPosition(node.getStart());
            default:
                return node.getEnd();
        }
    }
    var isImport2;
    var init_smartSelection = __esm({
        "src/services/smartSelection.ts" () {
            "use strict";
            init_ts4();
            isImport2 = or(isImportDeclaration, isImportEqualsDeclaration);
        }
    });
    // src/services/_namespaces/ts.SmartSelectionRange.ts
    var ts_SmartSelectionRange_exports = {};
    __export(ts_SmartSelectionRange_exports, {
        getSmartSelectionRange: ()=>getSmartSelectionRange
    });
    var init_ts_SmartSelectionRange = __esm({
        "src/services/_namespaces/ts.SmartSelectionRange.ts" () {
            "use strict";
            init_smartSelection();
        }
    });
    // src/services/symbolDisplay.ts
    function getSymbolKind(typeChecker, symbol, location) {
        const result = getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location);
        if (result !== "" /* unknown */ ) return result;
        const flags = getCombinedLocalAndExportSymbolFlags(symbol);
        if (flags & 32 /* Class */ ) return getDeclarationOfKind(symbol, 230 /* ClassExpression */ ) ? "local class" /* localClassElement */  : "class" /* classElement */ ;
        if (flags & 384 /* Enum */ ) return "enum" /* enumElement */ ;
        if (flags & 524288 /* TypeAlias */ ) return "type" /* typeElement */ ;
        if (flags & 64 /* Interface */ ) return "interface" /* interfaceElement */ ;
        if (flags & 262144 /* TypeParameter */ ) return "type parameter" /* typeParameterElement */ ;
        if (flags & 8 /* EnumMember */ ) return "enum member" /* enumMemberElement */ ;
        if (flags & 2097152 /* Alias */ ) return "alias" /* alias */ ;
        if (flags & 1536 /* Module */ ) return "module" /* moduleElement */ ;
        return result;
    }
    function getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location) {
        const roots = typeChecker.getRootSymbols(symbol);
        if (roots.length === 1 && first(roots).flags & 8192 /* Method */  && typeChecker.getTypeOfSymbolAtLocation(symbol, location).getNonNullableType().getCallSignatures().length !== 0) return "method" /* memberFunctionElement */ ;
        if (typeChecker.isUndefinedSymbol(symbol)) return "var" /* variableElement */ ;
        if (typeChecker.isArgumentsSymbol(symbol)) return "local var" /* localVariableElement */ ;
        if (location.kind === 110 /* ThisKeyword */  && isExpression(location) || isThisInTypeQuery(location)) return "parameter" /* parameterElement */ ;
        const flags = getCombinedLocalAndExportSymbolFlags(symbol);
        if (flags & 3 /* Variable */ ) {
            if (isFirstDeclarationOfSymbolParameter(symbol)) return "parameter" /* parameterElement */ ;
            else if (symbol.valueDeclaration && isVarConst(symbol.valueDeclaration)) return "const" /* constElement */ ;
            else if (forEach(symbol.declarations, isLet)) return "let" /* letElement */ ;
            return isLocalVariableOrFunction(symbol) ? "local var" /* localVariableElement */  : "var" /* variableElement */ ;
        }
        if (flags & 16 /* Function */ ) return isLocalVariableOrFunction(symbol) ? "local function" /* localFunctionElement */  : "function" /* functionElement */ ;
        if (flags & 32768 /* GetAccessor */ ) return "getter" /* memberGetAccessorElement */ ;
        if (flags & 65536 /* SetAccessor */ ) return "setter" /* memberSetAccessorElement */ ;
        if (flags & 8192 /* Method */ ) return "method" /* memberFunctionElement */ ;
        if (flags & 16384 /* Constructor */ ) return "constructor" /* constructorImplementationElement */ ;
        if (flags & 131072 /* Signature */ ) return "index" /* indexSignatureElement */ ;
        if (flags & 4 /* Property */ ) {
            if (flags & 33554432 /* Transient */  && symbol.links.checkFlags & 6 /* Synthetic */ ) {
                const unionPropertyKind = forEach(typeChecker.getRootSymbols(symbol), (rootSymbol)=>{
                    const rootSymbolFlags = rootSymbol.getFlags();
                    if (rootSymbolFlags & 98311 /* Variable */ ) return "property" /* memberVariableElement */ ;
                });
                if (!unionPropertyKind) {
                    const typeOfUnionProperty = typeChecker.getTypeOfSymbolAtLocation(symbol, location);
                    if (typeOfUnionProperty.getCallSignatures().length) return "method" /* memberFunctionElement */ ;
                    return "property" /* memberVariableElement */ ;
                }
                return unionPropertyKind;
            }
            return "property" /* memberVariableElement */ ;
        }
        return "" /* unknown */ ;
    }
    function getNormalizedSymbolModifiers(symbol) {
        if (symbol.declarations && symbol.declarations.length) {
            const [declaration, ...declarations] = symbol.declarations;
            const excludeFlags = length(declarations) && isDeprecatedDeclaration(declaration) && some(declarations, (d)=>!isDeprecatedDeclaration(d)) ? 8192 /* Deprecated */  : 0 /* None */ ;
            const modifiers = getNodeModifiers(declaration, excludeFlags);
            if (modifiers) return modifiers.split(",");
        }
        return [];
    }
    function getSymbolModifiers(typeChecker, symbol) {
        if (!symbol) return "" /* none */ ;
        const modifiers = new Set(getNormalizedSymbolModifiers(symbol));
        if (symbol.flags & 2097152 /* Alias */ ) {
            const resolvedSymbol = typeChecker.getAliasedSymbol(symbol);
            if (resolvedSymbol !== symbol) forEach(getNormalizedSymbolModifiers(resolvedSymbol), (modifier)=>{
                modifiers.add(modifier);
            });
        }
        if (symbol.flags & 16777216 /* Optional */ ) modifiers.add("optional" /* optionalModifier */ );
        return modifiers.size > 0 ? arrayFrom(modifiers.values()).join(",") : "" /* none */ ;
    }
    function getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker, symbol, sourceFile, enclosingDeclaration, location, semanticMeaning = getMeaningFromLocation(location), alias) {
        var _a;
        const displayParts = [];
        let documentation = [];
        let tags = [];
        const symbolFlags = getCombinedLocalAndExportSymbolFlags(symbol);
        let symbolKind = semanticMeaning & 1 /* Value */  ? getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location) : "" /* unknown */ ;
        let hasAddedSymbolInfo = false;
        const isThisExpression = location.kind === 110 /* ThisKeyword */  && isInExpressionContext(location) || isThisInTypeQuery(location);
        let type;
        let documentationFromAlias;
        let tagsFromAlias;
        let hasMultipleSignatures = false;
        if (location.kind === 110 /* ThisKeyword */  && !isThisExpression) return {
            displayParts: [
                keywordPart(110 /* ThisKeyword */ )
            ],
            documentation: [],
            symbolKind: "primitive type" /* primitiveType */ ,
            tags: void 0
        };
        if (symbolKind !== "" /* unknown */  || symbolFlags & 32 /* Class */  || symbolFlags & 2097152 /* Alias */ ) {
            if (symbolKind === "getter" /* memberGetAccessorElement */  || symbolKind === "setter" /* memberSetAccessorElement */ ) {
                const declaration = find(symbol.declarations, (declaration2)=>declaration2.name === location);
                if (declaration) switch(declaration.kind){
                    case 176 /* GetAccessor */ :
                        symbolKind = "getter" /* memberGetAccessorElement */ ;
                        break;
                    case 177 /* SetAccessor */ :
                        symbolKind = "setter" /* memberSetAccessorElement */ ;
                        break;
                    case 171 /* PropertyDeclaration */ :
                        symbolKind = "accessor" /* memberAccessorVariableElement */ ;
                        break;
                    default:
                        Debug.assertNever(declaration);
                }
                else symbolKind = "property" /* memberVariableElement */ ;
            }
            let signature;
            type = isThisExpression ? typeChecker.getTypeAtLocation(location) : typeChecker.getTypeOfSymbolAtLocation(symbol, location);
            if (location.parent && location.parent.kind === 210 /* PropertyAccessExpression */ ) {
                const right = location.parent.name;
                if (right === location || right && right.getFullWidth() === 0) location = location.parent;
            }
            let callExpressionLike;
            if (isCallOrNewExpression(location)) callExpressionLike = location;
            else if (isCallExpressionTarget(location) || isNewExpressionTarget(location)) callExpressionLike = location.parent;
            else if (location.parent && (isJsxOpeningLikeElement(location.parent) || isTaggedTemplateExpression(location.parent)) && isFunctionLike(symbol.valueDeclaration)) callExpressionLike = location.parent;
            if (callExpressionLike) {
                signature = typeChecker.getResolvedSignature(callExpressionLike);
                const useConstructSignatures = callExpressionLike.kind === 213 /* NewExpression */  || isCallExpression(callExpressionLike) && callExpressionLike.expression.kind === 108 /* SuperKeyword */ ;
                const allSignatures = useConstructSignatures ? type.getConstructSignatures() : type.getCallSignatures();
                if (signature && !contains(allSignatures, signature.target) && !contains(allSignatures, signature)) signature = allSignatures.length ? allSignatures[0] : void 0;
                if (signature) {
                    if (useConstructSignatures && symbolFlags & 32 /* Class */ ) {
                        symbolKind = "constructor" /* constructorImplementationElement */ ;
                        addPrefixForAnyFunctionOrVar(type.symbol, symbolKind);
                    } else if (symbolFlags & 2097152 /* Alias */ ) {
                        symbolKind = "alias" /* alias */ ;
                        pushSymbolKind(symbolKind);
                        displayParts.push(spacePart());
                        if (useConstructSignatures) {
                            if (signature.flags & 4 /* Abstract */ ) {
                                displayParts.push(keywordPart(128 /* AbstractKeyword */ ));
                                displayParts.push(spacePart());
                            }
                            displayParts.push(keywordPart(105 /* NewKeyword */ ));
                            displayParts.push(spacePart());
                        }
                        addFullSymbolName(symbol);
                    } else addPrefixForAnyFunctionOrVar(symbol, symbolKind);
                    switch(symbolKind){
                        case "JSX attribute" /* jsxAttribute */ :
                        case "property" /* memberVariableElement */ :
                        case "var" /* variableElement */ :
                        case "const" /* constElement */ :
                        case "let" /* letElement */ :
                        case "parameter" /* parameterElement */ :
                        case "local var" /* localVariableElement */ :
                            displayParts.push(punctuationPart(59 /* ColonToken */ ));
                            displayParts.push(spacePart());
                            if (!(getObjectFlags(type) & 16 /* Anonymous */ ) && type.symbol) {
                                addRange(displayParts, symbolToDisplayParts(typeChecker, type.symbol, enclosingDeclaration, /*meaning*/ void 0, 5 /* WriteTypeParametersOrArguments */ ));
                                displayParts.push(lineBreakPart());
                            }
                            if (useConstructSignatures) {
                                if (signature.flags & 4 /* Abstract */ ) {
                                    displayParts.push(keywordPart(128 /* AbstractKeyword */ ));
                                    displayParts.push(spacePart());
                                }
                                displayParts.push(keywordPart(105 /* NewKeyword */ ));
                                displayParts.push(spacePart());
                            }
                            addSignatureDisplayParts(signature, allSignatures, 262144 /* WriteArrowStyleSignature */ );
                            break;
                        default:
                            addSignatureDisplayParts(signature, allSignatures);
                    }
                    hasAddedSymbolInfo = true;
                    hasMultipleSignatures = allSignatures.length > 1;
                }
            } else if (isNameOfFunctionDeclaration(location) && !(symbolFlags & 98304 /* Accessor */ ) || // name of function declaration
            location.kind === 137 /* ConstructorKeyword */  && location.parent.kind === 175 /* Constructor */ ) {
                const functionDeclaration = location.parent;
                const locationIsSymbolDeclaration = symbol.declarations && find(symbol.declarations, (declaration)=>declaration === (location.kind === 137 /* ConstructorKeyword */  ? functionDeclaration.parent : functionDeclaration));
                if (locationIsSymbolDeclaration) {
                    const allSignatures = functionDeclaration.kind === 175 /* Constructor */  ? type.getNonNullableType().getConstructSignatures() : type.getNonNullableType().getCallSignatures();
                    if (!typeChecker.isImplementationOfOverload(functionDeclaration)) signature = typeChecker.getSignatureFromDeclaration(functionDeclaration);
                    else signature = allSignatures[0];
                    if (functionDeclaration.kind === 175 /* Constructor */ ) {
                        symbolKind = "constructor" /* constructorImplementationElement */ ;
                        addPrefixForAnyFunctionOrVar(type.symbol, symbolKind);
                    } else addPrefixForAnyFunctionOrVar(functionDeclaration.kind === 178 /* CallSignature */  && !(type.symbol.flags & 2048 /* TypeLiteral */  || type.symbol.flags & 4096 /* ObjectLiteral */ ) ? type.symbol : symbol, symbolKind);
                    if (signature) addSignatureDisplayParts(signature, allSignatures);
                    hasAddedSymbolInfo = true;
                    hasMultipleSignatures = allSignatures.length > 1;
                }
            }
        }
        if (symbolFlags & 32 /* Class */  && !hasAddedSymbolInfo && !isThisExpression) {
            addAliasPrefixIfNecessary();
            if (getDeclarationOfKind(symbol, 230 /* ClassExpression */ )) pushSymbolKind("local class" /* localClassElement */ );
            else displayParts.push(keywordPart(86 /* ClassKeyword */ ));
            displayParts.push(spacePart());
            addFullSymbolName(symbol);
            writeTypeParametersOfSymbol(symbol, sourceFile);
        }
        if (symbolFlags & 64 /* Interface */  && semanticMeaning & 2 /* Type */ ) {
            prefixNextMeaning();
            displayParts.push(keywordPart(120 /* InterfaceKeyword */ ));
            displayParts.push(spacePart());
            addFullSymbolName(symbol);
            writeTypeParametersOfSymbol(symbol, sourceFile);
        }
        if (symbolFlags & 524288 /* TypeAlias */  && semanticMeaning & 2 /* Type */ ) {
            prefixNextMeaning();
            displayParts.push(keywordPart(156 /* TypeKeyword */ ));
            displayParts.push(spacePart());
            addFullSymbolName(symbol);
            writeTypeParametersOfSymbol(symbol, sourceFile);
            displayParts.push(spacePart());
            displayParts.push(operatorPart(64 /* EqualsToken */ ));
            displayParts.push(spacePart());
            addRange(displayParts, typeToDisplayParts(typeChecker, location.parent && isConstTypeReference(location.parent) ? typeChecker.getTypeAtLocation(location.parent) : typeChecker.getDeclaredTypeOfSymbol(symbol), enclosingDeclaration, 8388608 /* InTypeAlias */ ));
        }
        if (symbolFlags & 384 /* Enum */ ) {
            prefixNextMeaning();
            if (some(symbol.declarations, (d)=>isEnumDeclaration(d) && isEnumConst(d))) {
                displayParts.push(keywordPart(87 /* ConstKeyword */ ));
                displayParts.push(spacePart());
            }
            displayParts.push(keywordPart(94 /* EnumKeyword */ ));
            displayParts.push(spacePart());
            addFullSymbolName(symbol);
        }
        if (symbolFlags & 1536 /* Module */  && !isThisExpression) {
            prefixNextMeaning();
            const declaration = getDeclarationOfKind(symbol, 266 /* ModuleDeclaration */ );
            const isNamespace = declaration && declaration.name && declaration.name.kind === 80 /* Identifier */ ;
            displayParts.push(keywordPart(isNamespace ? 145 /* NamespaceKeyword */  : 144 /* ModuleKeyword */ ));
            displayParts.push(spacePart());
            addFullSymbolName(symbol);
        }
        if (symbolFlags & 262144 /* TypeParameter */  && semanticMeaning & 2 /* Type */ ) {
            prefixNextMeaning();
            displayParts.push(punctuationPart(21 /* OpenParenToken */ ));
            displayParts.push(textPart("type parameter"));
            displayParts.push(punctuationPart(22 /* CloseParenToken */ ));
            displayParts.push(spacePart());
            addFullSymbolName(symbol);
            if (symbol.parent) {
                addInPrefix();
                addFullSymbolName(symbol.parent, enclosingDeclaration);
                writeTypeParametersOfSymbol(symbol.parent, enclosingDeclaration);
            } else {
                const decl = getDeclarationOfKind(symbol, 167 /* TypeParameter */ );
                if (decl === void 0) return Debug.fail();
                const declaration = decl.parent;
                if (declaration) {
                    if (isFunctionLike(declaration)) {
                        addInPrefix();
                        const signature = typeChecker.getSignatureFromDeclaration(declaration);
                        if (declaration.kind === 179 /* ConstructSignature */ ) {
                            displayParts.push(keywordPart(105 /* NewKeyword */ ));
                            displayParts.push(spacePart());
                        } else if (declaration.kind !== 178 /* CallSignature */  && declaration.name) addFullSymbolName(declaration.symbol);
                        addRange(displayParts, signatureToDisplayParts(typeChecker, signature, sourceFile, 32 /* WriteTypeArgumentsOfSignature */ ));
                    } else if (isTypeAliasDeclaration(declaration)) {
                        addInPrefix();
                        displayParts.push(keywordPart(156 /* TypeKeyword */ ));
                        displayParts.push(spacePart());
                        addFullSymbolName(declaration.symbol);
                        writeTypeParametersOfSymbol(declaration.symbol, sourceFile);
                    }
                }
            }
        }
        if (symbolFlags & 8 /* EnumMember */ ) {
            symbolKind = "enum member" /* enumMemberElement */ ;
            addPrefixForAnyFunctionOrVar(symbol, "enum member");
            const declaration = (_a = symbol.declarations) == null ? void 0 : _a[0];
            if ((declaration == null ? void 0 : declaration.kind) === 305 /* EnumMember */ ) {
                const constantValue = typeChecker.getConstantValue(declaration);
                if (constantValue !== void 0) {
                    displayParts.push(spacePart());
                    displayParts.push(operatorPart(64 /* EqualsToken */ ));
                    displayParts.push(spacePart());
                    displayParts.push(displayPart(getTextOfConstantValue(constantValue), typeof constantValue === "number" ? 7 /* numericLiteral */  : 8 /* stringLiteral */ ));
                }
            }
        }
        if (symbol.flags & 2097152 /* Alias */ ) {
            prefixNextMeaning();
            if (!hasAddedSymbolInfo || documentation.length === 0 && tags.length === 0) {
                const resolvedSymbol = typeChecker.getAliasedSymbol(symbol);
                if (resolvedSymbol !== symbol && resolvedSymbol.declarations && resolvedSymbol.declarations.length > 0) {
                    const resolvedNode = resolvedSymbol.declarations[0];
                    const declarationName = getNameOfDeclaration(resolvedNode);
                    if (declarationName && !hasAddedSymbolInfo) {
                        const isExternalModuleDeclaration = isModuleWithStringLiteralName(resolvedNode) && hasSyntacticModifier(resolvedNode, 2 /* Ambient */ );
                        const shouldUseAliasName = symbol.name !== "default" && !isExternalModuleDeclaration;
                        const resolvedInfo = getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker, resolvedSymbol, getSourceFileOfNode(resolvedNode), resolvedNode, declarationName, semanticMeaning, shouldUseAliasName ? symbol : resolvedSymbol);
                        displayParts.push(...resolvedInfo.displayParts);
                        displayParts.push(lineBreakPart());
                        documentationFromAlias = resolvedInfo.documentation;
                        tagsFromAlias = resolvedInfo.tags;
                    } else {
                        documentationFromAlias = resolvedSymbol.getContextualDocumentationComment(resolvedNode, typeChecker);
                        tagsFromAlias = resolvedSymbol.getJsDocTags(typeChecker);
                    }
                }
            }
            if (symbol.declarations) switch(symbol.declarations[0].kind){
                case 269 /* NamespaceExportDeclaration */ :
                    displayParts.push(keywordPart(95 /* ExportKeyword */ ));
                    displayParts.push(spacePart());
                    displayParts.push(keywordPart(145 /* NamespaceKeyword */ ));
                    break;
                case 276 /* ExportAssignment */ :
                    displayParts.push(keywordPart(95 /* ExportKeyword */ ));
                    displayParts.push(spacePart());
                    displayParts.push(keywordPart(symbol.declarations[0].isExportEquals ? 64 /* EqualsToken */  : 90 /* DefaultKeyword */ ));
                    break;
                case 280 /* ExportSpecifier */ :
                    displayParts.push(keywordPart(95 /* ExportKeyword */ ));
                    break;
                default:
                    displayParts.push(keywordPart(102 /* ImportKeyword */ ));
            }
            displayParts.push(spacePart());
            addFullSymbolName(symbol);
            forEach(symbol.declarations, (declaration)=>{
                if (declaration.kind === 270 /* ImportEqualsDeclaration */ ) {
                    const importEqualsDeclaration = declaration;
                    if (isExternalModuleImportEqualsDeclaration(importEqualsDeclaration)) {
                        displayParts.push(spacePart());
                        displayParts.push(operatorPart(64 /* EqualsToken */ ));
                        displayParts.push(spacePart());
                        displayParts.push(keywordPart(149 /* RequireKeyword */ ));
                        displayParts.push(punctuationPart(21 /* OpenParenToken */ ));
                        displayParts.push(displayPart(getTextOfNode(getExternalModuleImportEqualsDeclarationExpression(importEqualsDeclaration)), 8 /* stringLiteral */ ));
                        displayParts.push(punctuationPart(22 /* CloseParenToken */ ));
                    } else {
                        const internalAliasSymbol = typeChecker.getSymbolAtLocation(importEqualsDeclaration.moduleReference);
                        if (internalAliasSymbol) {
                            displayParts.push(spacePart());
                            displayParts.push(operatorPart(64 /* EqualsToken */ ));
                            displayParts.push(spacePart());
                            addFullSymbolName(internalAliasSymbol, enclosingDeclaration);
                        }
                    }
                    return true;
                }
            });
        }
        if (!hasAddedSymbolInfo) {
            if (symbolKind !== "" /* unknown */ ) {
                if (type) {
                    if (isThisExpression) {
                        prefixNextMeaning();
                        displayParts.push(keywordPart(110 /* ThisKeyword */ ));
                    } else addPrefixForAnyFunctionOrVar(symbol, symbolKind);
                    if (symbolKind === "property" /* memberVariableElement */  || symbolKind === "accessor" /* memberAccessorVariableElement */  || symbolKind === "getter" /* memberGetAccessorElement */  || symbolKind === "setter" /* memberSetAccessorElement */  || symbolKind === "JSX attribute" /* jsxAttribute */  || symbolFlags & 3 /* Variable */  || symbolKind === "local var" /* localVariableElement */  || symbolKind === "index" /* indexSignatureElement */  || isThisExpression) {
                        displayParts.push(punctuationPart(59 /* ColonToken */ ));
                        displayParts.push(spacePart());
                        if (type.symbol && type.symbol.flags & 262144 /* TypeParameter */  && symbolKind !== "index" /* indexSignatureElement */ ) {
                            const typeParameterParts = mapToDisplayParts((writer)=>{
                                const param = typeChecker.typeParameterToDeclaration(type, enclosingDeclaration, symbolDisplayNodeBuilderFlags);
                                getPrinter().writeNode(4 /* Unspecified */ , param, getSourceFileOfNode(getParseTreeNode(enclosingDeclaration)), writer);
                            });
                            addRange(displayParts, typeParameterParts);
                        } else addRange(displayParts, typeToDisplayParts(typeChecker, type, enclosingDeclaration));
                        if (isTransientSymbol(symbol) && symbol.links.target && isTransientSymbol(symbol.links.target) && symbol.links.target.links.tupleLabelDeclaration) {
                            const labelDecl = symbol.links.target.links.tupleLabelDeclaration;
                            Debug.assertNode(labelDecl.name, isIdentifier);
                            displayParts.push(spacePart());
                            displayParts.push(punctuationPart(21 /* OpenParenToken */ ));
                            displayParts.push(textPart(idText(labelDecl.name)));
                            displayParts.push(punctuationPart(22 /* CloseParenToken */ ));
                        }
                    } else if (symbolFlags & 16 /* Function */  || symbolFlags & 8192 /* Method */  || symbolFlags & 16384 /* Constructor */  || symbolFlags & 131072 /* Signature */  || symbolFlags & 98304 /* Accessor */  || symbolKind === "method" /* memberFunctionElement */ ) {
                        const allSignatures = type.getNonNullableType().getCallSignatures();
                        if (allSignatures.length) {
                            addSignatureDisplayParts(allSignatures[0], allSignatures);
                            hasMultipleSignatures = allSignatures.length > 1;
                        }
                    }
                }
            } else symbolKind = getSymbolKind(typeChecker, symbol, location);
        }
        if (documentation.length === 0 && !hasMultipleSignatures) documentation = symbol.getContextualDocumentationComment(enclosingDeclaration, typeChecker);
        if (documentation.length === 0 && symbolFlags & 4 /* Property */ ) {
            if (symbol.parent && symbol.declarations && forEach(symbol.parent.declarations, (declaration)=>declaration.kind === 311 /* SourceFile */ )) for (const declaration of symbol.declarations){
                if (!declaration.parent || declaration.parent.kind !== 225 /* BinaryExpression */ ) continue;
                const rhsSymbol = typeChecker.getSymbolAtLocation(declaration.parent.right);
                if (!rhsSymbol) continue;
                documentation = rhsSymbol.getDocumentationComment(typeChecker);
                tags = rhsSymbol.getJsDocTags(typeChecker);
                if (documentation.length > 0) break;
            }
        }
        if (documentation.length === 0 && isIdentifier(location) && symbol.valueDeclaration && isBindingElement(symbol.valueDeclaration)) {
            const declaration = symbol.valueDeclaration;
            const parent2 = declaration.parent;
            if (isIdentifier(declaration.name) && isObjectBindingPattern(parent2)) {
                const name = getTextOfIdentifierOrLiteral(declaration.name);
                const objectType = typeChecker.getTypeAtLocation(parent2);
                documentation = firstDefined(objectType.isUnion() ? objectType.types : [
                    objectType
                ], (t)=>{
                    const prop = t.getProperty(name);
                    return prop ? prop.getDocumentationComment(typeChecker) : void 0;
                }) || emptyArray;
            }
        }
        if (tags.length === 0 && !hasMultipleSignatures) tags = symbol.getContextualJsDocTags(enclosingDeclaration, typeChecker);
        if (documentation.length === 0 && documentationFromAlias) documentation = documentationFromAlias;
        if (tags.length === 0 && tagsFromAlias) tags = tagsFromAlias;
        return {
            displayParts: displayParts,
            documentation: documentation,
            symbolKind: symbolKind,
            tags: tags.length === 0 ? void 0 : tags
        };
        function getPrinter() {
            return createPrinterWithRemoveComments();
        }
        function prefixNextMeaning() {
            if (displayParts.length) displayParts.push(lineBreakPart());
            addAliasPrefixIfNecessary();
        }
        function addAliasPrefixIfNecessary() {
            if (alias) {
                pushSymbolKind("alias" /* alias */ );
                displayParts.push(spacePart());
            }
        }
        function addInPrefix() {
            displayParts.push(spacePart());
            displayParts.push(keywordPart(103 /* InKeyword */ ));
            displayParts.push(spacePart());
        }
        function addFullSymbolName(symbolToDisplay, enclosingDeclaration2) {
            let indexInfos;
            if (alias && symbolToDisplay === symbol) symbolToDisplay = alias;
            if (symbolKind === "index" /* indexSignatureElement */ ) indexInfos = typeChecker.getIndexInfosOfIndexSymbol(symbolToDisplay);
            let fullSymbolDisplayParts = [];
            if (symbolToDisplay.flags & 131072 /* Signature */  && indexInfos) {
                if (symbolToDisplay.parent) fullSymbolDisplayParts = symbolToDisplayParts(typeChecker, symbolToDisplay.parent);
                fullSymbolDisplayParts.push(punctuationPart(23 /* OpenBracketToken */ ));
                indexInfos.forEach((info, i)=>{
                    fullSymbolDisplayParts.push(...typeToDisplayParts(typeChecker, info.keyType));
                    if (i !== indexInfos.length - 1) {
                        fullSymbolDisplayParts.push(spacePart());
                        fullSymbolDisplayParts.push(punctuationPart(52 /* BarToken */ ));
                        fullSymbolDisplayParts.push(spacePart());
                    }
                });
                fullSymbolDisplayParts.push(punctuationPart(24 /* CloseBracketToken */ ));
            } else fullSymbolDisplayParts = symbolToDisplayParts(typeChecker, symbolToDisplay, enclosingDeclaration2 || sourceFile, /*meaning*/ void 0, 7 /* AllowAnyNodeKind */ );
            addRange(displayParts, fullSymbolDisplayParts);
            if (symbol.flags & 16777216 /* Optional */ ) displayParts.push(punctuationPart(58 /* QuestionToken */ ));
        }
        function addPrefixForAnyFunctionOrVar(symbol2, symbolKind2) {
            prefixNextMeaning();
            if (symbolKind2) {
                pushSymbolKind(symbolKind2);
                if (symbol2 && !some(symbol2.declarations, (d)=>isArrowFunction(d) || (isFunctionExpression(d) || isClassExpression(d)) && !d.name)) {
                    displayParts.push(spacePart());
                    addFullSymbolName(symbol2);
                }
            }
        }
        function pushSymbolKind(symbolKind2) {
            switch(symbolKind2){
                case "var" /* variableElement */ :
                case "function" /* functionElement */ :
                case "let" /* letElement */ :
                case "const" /* constElement */ :
                case "constructor" /* constructorImplementationElement */ :
                    displayParts.push(textOrKeywordPart(symbolKind2));
                    return;
                default:
                    displayParts.push(punctuationPart(21 /* OpenParenToken */ ));
                    displayParts.push(textOrKeywordPart(symbolKind2));
                    displayParts.push(punctuationPart(22 /* CloseParenToken */ ));
                    return;
            }
        }
        function addSignatureDisplayParts(signature, allSignatures, flags = 0 /* None */ ) {
            addRange(displayParts, signatureToDisplayParts(typeChecker, signature, enclosingDeclaration, flags | 32 /* WriteTypeArgumentsOfSignature */ ));
            if (allSignatures.length > 1) {
                displayParts.push(spacePart());
                displayParts.push(punctuationPart(21 /* OpenParenToken */ ));
                displayParts.push(operatorPart(40 /* PlusToken */ ));
                displayParts.push(displayPart((allSignatures.length - 1).toString(), 7 /* numericLiteral */ ));
                displayParts.push(spacePart());
                displayParts.push(textPart(allSignatures.length === 2 ? "overload" : "overloads"));
                displayParts.push(punctuationPart(22 /* CloseParenToken */ ));
            }
            documentation = signature.getDocumentationComment(typeChecker);
            tags = signature.getJsDocTags();
            if (allSignatures.length > 1 && documentation.length === 0 && tags.length === 0) {
                documentation = allSignatures[0].getDocumentationComment(typeChecker);
                tags = allSignatures[0].getJsDocTags().filter((tag)=>tag.name !== "deprecated");
            }
        }
        function writeTypeParametersOfSymbol(symbol2, enclosingDeclaration2) {
            const typeParameterParts = mapToDisplayParts((writer)=>{
                const params = typeChecker.symbolToTypeParameterDeclarations(symbol2, enclosingDeclaration2, symbolDisplayNodeBuilderFlags);
                getPrinter().writeList(53776 /* TypeParameters */ , params, getSourceFileOfNode(getParseTreeNode(enclosingDeclaration2)), writer);
            });
            addRange(displayParts, typeParameterParts);
        }
    }
    function isLocalVariableOrFunction(symbol) {
        if (symbol.parent) return false;
        return forEach(symbol.declarations, (declaration)=>{
            if (declaration.kind === 217 /* FunctionExpression */ ) return true;
            if (declaration.kind !== 259 /* VariableDeclaration */  && declaration.kind !== 261 /* FunctionDeclaration */ ) return false;
            for(let parent2 = declaration.parent; !isFunctionBlock(parent2); parent2 = parent2.parent){
                if (parent2.kind === 311 /* SourceFile */  || parent2.kind === 267 /* ModuleBlock */ ) return false;
            }
            return true;
        });
    }
    var symbolDisplayNodeBuilderFlags;
    var init_symbolDisplay = __esm({
        "src/services/symbolDisplay.ts" () {
            "use strict";
            init_ts4();
            symbolDisplayNodeBuilderFlags = 70246400 /* UseAliasDefinedOutsideCurrentScope */ ;
        }
    });
    // src/services/_namespaces/ts.SymbolDisplay.ts
    var ts_SymbolDisplay_exports = {};
    __export(ts_SymbolDisplay_exports, {
        getSymbolDisplayPartsDocumentationAndSymbolKind: ()=>getSymbolDisplayPartsDocumentationAndSymbolKind,
        getSymbolKind: ()=>getSymbolKind,
        getSymbolModifiers: ()=>getSymbolModifiers
    });
    var init_ts_SymbolDisplay = __esm({
        "src/services/_namespaces/ts.SymbolDisplay.ts" () {
            "use strict";
            init_symbolDisplay();
        }
    });
    // src/services/textChanges.ts
    function getPos2(n) {
        const result = n.__pos;
        Debug.assert(typeof result === "number");
        return result;
    }
    function setPos(n, pos) {
        Debug.assert(typeof pos === "number");
        n.__pos = pos;
    }
    function getEnd(n) {
        const result = n.__end;
        Debug.assert(typeof result === "number");
        return result;
    }
    function setEnd(n, end) {
        Debug.assert(typeof end === "number");
        n.__end = end;
    }
    function skipWhitespacesAndLineBreaks(text, start) {
        return skipTrivia(text, start, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
    }
    function hasCommentsBeforeLineBreak(text, start) {
        let i = start;
        while(i < text.length){
            const ch = text.charCodeAt(i);
            if (isWhiteSpaceSingleLine(ch)) {
                i++;
                continue;
            }
            return ch === 47 /* slash */ ;
        }
        return false;
    }
    function getAdjustedRange(sourceFile, startNode2, endNode2, options) {
        return {
            pos: getAdjustedStartPosition(sourceFile, startNode2, options),
            end: getAdjustedEndPosition(sourceFile, endNode2, options)
        };
    }
    function getAdjustedStartPosition(sourceFile, node, options, hasTrailingComment = false) {
        var _a, _b;
        const { leadingTriviaOption: leadingTriviaOption  } = options;
        if (leadingTriviaOption === 0 /* Exclude */ ) return node.getStart(sourceFile);
        if (leadingTriviaOption === 3 /* StartLine */ ) {
            const startPos = node.getStart(sourceFile);
            const pos = getLineStartPositionForPosition(startPos, sourceFile);
            return rangeContainsPosition(node, pos) ? pos : startPos;
        }
        if (leadingTriviaOption === 2 /* JSDoc */ ) {
            const JSDocComments = getJSDocCommentRanges(node, sourceFile.text);
            if (JSDocComments == null ? void 0 : JSDocComments.length) return getLineStartPositionForPosition(JSDocComments[0].pos, sourceFile);
        }
        const fullStart = node.getFullStart();
        const start = node.getStart(sourceFile);
        if (fullStart === start) return start;
        const fullStartLine = getLineStartPositionForPosition(fullStart, sourceFile);
        const startLine = getLineStartPositionForPosition(start, sourceFile);
        if (startLine === fullStartLine) return leadingTriviaOption === 1 /* IncludeAll */  ? fullStart : start;
        if (hasTrailingComment) {
            const comment = ((_a = getLeadingCommentRanges(sourceFile.text, fullStart)) == null ? void 0 : _a[0]) || ((_b = getTrailingCommentRanges(sourceFile.text, fullStart)) == null ? void 0 : _b[0]);
            if (comment) return skipTrivia(sourceFile.text, comment.end, /*stopAfterLineBreak*/ true, /*stopAtComments*/ true);
        }
        const nextLineStart = fullStart > 0 ? 1 : 0;
        let adjustedStartPosition = getStartPositionOfLine(getLineOfLocalPosition(sourceFile, fullStartLine) + nextLineStart, sourceFile);
        adjustedStartPosition = skipWhitespacesAndLineBreaks(sourceFile.text, adjustedStartPosition);
        return getStartPositionOfLine(getLineOfLocalPosition(sourceFile, adjustedStartPosition), sourceFile);
    }
    function getEndPositionOfMultilineTrailingComment(sourceFile, node, options) {
        const { end: end  } = node;
        const { trailingTriviaOption: trailingTriviaOption  } = options;
        if (trailingTriviaOption === 2 /* Include */ ) {
            const comments = getTrailingCommentRanges(sourceFile.text, end);
            if (comments) {
                const nodeEndLine = getLineOfLocalPosition(sourceFile, node.end);
                for (const comment of comments){
                    if (comment.kind === 2 /* SingleLineCommentTrivia */  || getLineOfLocalPosition(sourceFile, comment.pos) > nodeEndLine) break;
                    const commentEndLine = getLineOfLocalPosition(sourceFile, comment.end);
                    if (commentEndLine > nodeEndLine) return skipTrivia(sourceFile.text, comment.end, /*stopAfterLineBreak*/ true, /*stopAtComments*/ true);
                }
            }
        }
        return void 0;
    }
    function getAdjustedEndPosition(sourceFile, node, options) {
        var _a;
        const { end: end  } = node;
        const { trailingTriviaOption: trailingTriviaOption  } = options;
        if (trailingTriviaOption === 0 /* Exclude */ ) return end;
        if (trailingTriviaOption === 1 /* ExcludeWhitespace */ ) {
            const comments = concatenate(getTrailingCommentRanges(sourceFile.text, end), getLeadingCommentRanges(sourceFile.text, end));
            const realEnd = (_a = comments == null ? void 0 : comments[comments.length - 1]) == null ? void 0 : _a.end;
            if (realEnd) return realEnd;
            return end;
        }
        const multilineEndPosition = getEndPositionOfMultilineTrailingComment(sourceFile, node, options);
        if (multilineEndPosition) return multilineEndPosition;
        const newEnd = skipTrivia(sourceFile.text, end, /*stopAfterLineBreak*/ true);
        return newEnd !== end && (trailingTriviaOption === 2 /* Include */  || isLineBreak(sourceFile.text.charCodeAt(newEnd - 1))) ? newEnd : end;
    }
    function isSeparator(node, candidate) {
        return !!candidate && !!node.parent && (candidate.kind === 28 /* CommaToken */  || candidate.kind === 27 /* SemicolonToken */  && node.parent.kind === 209 /* ObjectLiteralExpression */ );
    }
    function isThisTypeAnnotatable(containingFunction) {
        return isFunctionExpression(containingFunction) || isFunctionDeclaration(containingFunction);
    }
    function updateJSDocHost(parent2) {
        if (parent2.kind !== 218 /* ArrowFunction */ ) return parent2;
        const jsDocNode = parent2.parent.kind === 171 /* PropertyDeclaration */  ? parent2.parent : parent2.parent.parent;
        jsDocNode.jsDoc = parent2.jsDoc;
        return jsDocNode;
    }
    function tryMergeJsdocTags(oldTag, newTag) {
        if (oldTag.kind !== newTag.kind) return void 0;
        switch(oldTag.kind){
            case 347 /* JSDocParameterTag */ :
                {
                    const oldParam = oldTag;
                    const newParam = newTag;
                    return isIdentifier(oldParam.name) && isIdentifier(newParam.name) && oldParam.name.escapedText === newParam.name.escapedText ? factory.createJSDocParameterTag(/*tagName*/ void 0, newParam.name, /*isBracketed*/ false, newParam.typeExpression, newParam.isNameFirst, oldParam.comment) : void 0;
                }
            case 348 /* JSDocReturnTag */ :
                return factory.createJSDocReturnTag(/*tagName*/ void 0, newTag.typeExpression, oldTag.comment);
            case 350 /* JSDocTypeTag */ :
                return factory.createJSDocTypeTag(/*tagName*/ void 0, newTag.typeExpression, oldTag.comment);
        }
    }
    function startPositionToDeleteNodeInList(sourceFile, node) {
        return skipTrivia(sourceFile.text, getAdjustedStartPosition(sourceFile, node, {
            leadingTriviaOption: 1 /* IncludeAll */ 
        }), /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
    }
    function endPositionToDeleteNodeInList(sourceFile, node, prevNode, nextNode) {
        const end = startPositionToDeleteNodeInList(sourceFile, nextNode);
        if (prevNode === void 0 || positionsAreOnSameLine(getAdjustedEndPosition(sourceFile, node, {}), end, sourceFile)) return end;
        const token = findPrecedingToken(nextNode.getStart(sourceFile), sourceFile);
        if (isSeparator(node, token)) {
            const prevToken = findPrecedingToken(node.getStart(sourceFile), sourceFile);
            if (isSeparator(prevNode, prevToken)) {
                const pos = skipTrivia(sourceFile.text, token.getEnd(), /*stopAfterLineBreak*/ true, /*stopAtComments*/ true);
                if (positionsAreOnSameLine(prevToken.getStart(sourceFile), token.getStart(sourceFile), sourceFile)) return isLineBreak(sourceFile.text.charCodeAt(pos - 1)) ? pos - 1 : pos;
                if (isLineBreak(sourceFile.text.charCodeAt(pos))) return pos;
            }
        }
        return end;
    }
    function getClassOrObjectBraceEnds(cls, sourceFile) {
        const open = findChildOfKind(cls, 19 /* OpenBraceToken */ , sourceFile);
        const close = findChildOfKind(cls, 20 /* CloseBraceToken */ , sourceFile);
        return [
            open == null ? void 0 : open.end,
            close == null ? void 0 : close.end
        ];
    }
    function getMembersOrProperties(node) {
        return isObjectLiteralExpression(node) ? node.properties : node.members;
    }
    function applyChanges(text, changes) {
        for(let i = changes.length - 1; i >= 0; i--){
            const { span: span , newText: newText  } = changes[i];
            text = `${text.substring(0, span.start)}${newText}${text.substring(textSpanEnd(span))}`;
        }
        return text;
    }
    function isTrivia2(s) {
        return skipTrivia(s, 0) === s.length;
    }
    function assignPositionsToNode(node) {
        const visited = visitEachChild(node, assignPositionsToNode, textChangesTransformationContext, assignPositionsToNodeArray, assignPositionsToNode);
        const newNode = nodeIsSynthesized(visited) ? visited : Object.create(visited);
        setTextRangePosEnd(newNode, getPos2(node), getEnd(node));
        return newNode;
    }
    function assignPositionsToNodeArray(nodes, visitor, test, start, count) {
        const visited = visitNodes2(nodes, visitor, test, start, count);
        if (!visited) return visited;
        Debug.assert(nodes);
        const nodeArray = visited === nodes ? factory.createNodeArray(visited.slice(0)) : visited;
        setTextRangePosEnd(nodeArray, getPos2(nodes), getEnd(nodes));
        return nodeArray;
    }
    function createWriter(newLine) {
        let lastNonTriviaPosition = 0;
        const writer = createTextWriter(newLine);
        const onBeforeEmitNode = (node)=>{
            if (node) setPos(node, lastNonTriviaPosition);
        };
        const onAfterEmitNode = (node)=>{
            if (node) setEnd(node, lastNonTriviaPosition);
        };
        const onBeforeEmitNodeArray = (nodes)=>{
            if (nodes) setPos(nodes, lastNonTriviaPosition);
        };
        const onAfterEmitNodeArray = (nodes)=>{
            if (nodes) setEnd(nodes, lastNonTriviaPosition);
        };
        const onBeforeEmitToken = (node)=>{
            if (node) setPos(node, lastNonTriviaPosition);
        };
        const onAfterEmitToken = (node)=>{
            if (node) setEnd(node, lastNonTriviaPosition);
        };
        function setLastNonTriviaPosition(s, force) {
            if (force || !isTrivia2(s)) {
                lastNonTriviaPosition = writer.getTextPos();
                let i = 0;
                while(isWhiteSpaceLike(s.charCodeAt(s.length - i - 1)))i++;
                lastNonTriviaPosition -= i;
            }
        }
        function write(s) {
            writer.write(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeComment(s) {
            writer.writeComment(s);
        }
        function writeKeyword(s) {
            writer.writeKeyword(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeOperator(s) {
            writer.writeOperator(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writePunctuation(s) {
            writer.writePunctuation(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeTrailingSemicolon(s) {
            writer.writeTrailingSemicolon(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeParameter(s) {
            writer.writeParameter(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeProperty(s) {
            writer.writeProperty(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeSpace(s) {
            writer.writeSpace(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeStringLiteral(s) {
            writer.writeStringLiteral(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeSymbol(s, sym) {
            writer.writeSymbol(s, sym);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeLine(force) {
            writer.writeLine(force);
        }
        function increaseIndent() {
            writer.increaseIndent();
        }
        function decreaseIndent() {
            writer.decreaseIndent();
        }
        function getText() {
            return writer.getText();
        }
        function rawWrite(s) {
            writer.rawWrite(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeLiteral(s) {
            writer.writeLiteral(s);
            setLastNonTriviaPosition(s, /*force*/ true);
        }
        function getTextPos() {
            return writer.getTextPos();
        }
        function getLine() {
            return writer.getLine();
        }
        function getColumn() {
            return writer.getColumn();
        }
        function getIndent() {
            return writer.getIndent();
        }
        function isAtStartOfLine() {
            return writer.isAtStartOfLine();
        }
        function clear2() {
            writer.clear();
            lastNonTriviaPosition = 0;
        }
        return {
            onBeforeEmitNode: onBeforeEmitNode,
            onAfterEmitNode: onAfterEmitNode,
            onBeforeEmitNodeArray: onBeforeEmitNodeArray,
            onAfterEmitNodeArray: onAfterEmitNodeArray,
            onBeforeEmitToken: onBeforeEmitToken,
            onAfterEmitToken: onAfterEmitToken,
            write: write,
            writeComment: writeComment,
            writeKeyword: writeKeyword,
            writeOperator: writeOperator,
            writePunctuation: writePunctuation,
            writeTrailingSemicolon: writeTrailingSemicolon,
            writeParameter: writeParameter,
            writeProperty: writeProperty,
            writeSpace: writeSpace,
            writeStringLiteral: writeStringLiteral,
            writeSymbol: writeSymbol,
            writeLine: writeLine,
            increaseIndent: increaseIndent,
            decreaseIndent: decreaseIndent,
            getText: getText,
            rawWrite: rawWrite,
            writeLiteral: writeLiteral,
            getTextPos: getTextPos,
            getLine: getLine,
            getColumn: getColumn,
            getIndent: getIndent,
            isAtStartOfLine: isAtStartOfLine,
            hasTrailingComment: ()=>writer.hasTrailingComment(),
            hasTrailingWhitespace: ()=>writer.hasTrailingWhitespace(),
            clear: clear2
        };
    }
    function getInsertionPositionAtSourceFileTop(sourceFile) {
        let lastPrologue;
        for (const node of sourceFile.statements){
            if (isPrologueDirective(node)) lastPrologue = node;
            else break;
        }
        let position = 0;
        const text = sourceFile.text;
        if (lastPrologue) {
            position = lastPrologue.end;
            advancePastLineBreak();
            return position;
        }
        const shebang = getShebang(text);
        if (shebang !== void 0) {
            position = shebang.length;
            advancePastLineBreak();
        }
        const ranges = getLeadingCommentRanges(text, position);
        if (!ranges) return position;
        let lastComment;
        let firstNodeLine;
        for (const range of ranges){
            if (range.kind === 3 /* MultiLineCommentTrivia */ ) {
                if (isPinnedComment(text, range.pos)) {
                    lastComment = {
                        range: range,
                        pinnedOrTripleSlash: true
                    };
                    continue;
                }
            } else if (isRecognizedTripleSlashComment(text, range.pos, range.end)) {
                lastComment = {
                    range: range,
                    pinnedOrTripleSlash: true
                };
                continue;
            }
            if (lastComment) {
                if (lastComment.pinnedOrTripleSlash) break;
                const commentLine = sourceFile.getLineAndCharacterOfPosition(range.pos).line;
                const lastCommentEndLine = sourceFile.getLineAndCharacterOfPosition(lastComment.range.end).line;
                if (commentLine >= lastCommentEndLine + 2) break;
            }
            if (sourceFile.statements.length) {
                if (firstNodeLine === void 0) firstNodeLine = sourceFile.getLineAndCharacterOfPosition(sourceFile.statements[0].getStart()).line;
                const commentEndLine = sourceFile.getLineAndCharacterOfPosition(range.end).line;
                if (firstNodeLine < commentEndLine + 2) break;
            }
            lastComment = {
                range: range,
                pinnedOrTripleSlash: false
            };
        }
        if (lastComment) {
            position = lastComment.range.end;
            advancePastLineBreak();
        }
        return position;
        function advancePastLineBreak() {
            if (position < text.length) {
                const charCode = text.charCodeAt(position);
                if (isLineBreak(charCode)) {
                    position++;
                    if (position < text.length && charCode === 13 /* carriageReturn */  && text.charCodeAt(position) === 10 /* lineFeed */ ) position++;
                }
            }
        }
    }
    function isValidLocationToAddComment(sourceFile, position) {
        return !isInComment(sourceFile, position) && !isInString(sourceFile, position) && !isInTemplateString(sourceFile, position) && !isInJSXText(sourceFile, position);
    }
    function needSemicolonBetween(a, b) {
        return (isPropertySignature(a) || isPropertyDeclaration(a)) && isClassOrTypeElement(b) && b.name.kind === 166 /* ComputedPropertyName */  || isStatementButNotDeclaration(a) && isStatementButNotDeclaration(b);
    }
    function deleteNode(changes, sourceFile, node, options = {
        leadingTriviaOption: 1 /* IncludeAll */ 
    }) {
        const startPosition = getAdjustedStartPosition(sourceFile, node, options);
        const endPosition = getAdjustedEndPosition(sourceFile, node, options);
        changes.deleteRange(sourceFile, {
            pos: startPosition,
            end: endPosition
        });
    }
    function deleteNodeInList(changes, deletedNodesInLists, sourceFile, node) {
        const containingList = Debug.checkDefined(ts_formatting_exports.SmartIndenter.getContainingList(node, sourceFile));
        const index = indexOfNode(containingList, node);
        Debug.assert(index !== -1);
        if (containingList.length === 1) {
            deleteNode(changes, sourceFile, node);
            return;
        }
        Debug.assert(!deletedNodesInLists.has(node), "Deleting a node twice");
        deletedNodesInLists.add(node);
        changes.deleteRange(sourceFile, {
            pos: startPositionToDeleteNodeInList(sourceFile, node),
            end: index === containingList.length - 1 ? getAdjustedEndPosition(sourceFile, node, {}) : endPositionToDeleteNodeInList(sourceFile, node, containingList[index - 1], containingList[index + 1])
        });
    }
    var LeadingTriviaOption, TrailingTriviaOption, useNonAdjustedPositions, ChangeTracker, changesToText, textChangesTransformationContext, deleteDeclaration;
    var init_textChanges = __esm({
        "src/services/textChanges.ts" () {
            "use strict";
            init_ts4();
            LeadingTriviaOption = /* @__PURE__ */ ((LeadingTriviaOption2)=>{
                LeadingTriviaOption2[LeadingTriviaOption2["Exclude"] = 0] = "Exclude";
                LeadingTriviaOption2[LeadingTriviaOption2["IncludeAll"] = 1] = "IncludeAll";
                LeadingTriviaOption2[LeadingTriviaOption2["JSDoc"] = 2] = "JSDoc";
                LeadingTriviaOption2[LeadingTriviaOption2["StartLine"] = 3] = "StartLine";
                return LeadingTriviaOption2;
            })(LeadingTriviaOption || {});
            TrailingTriviaOption = /* @__PURE__ */ ((TrailingTriviaOption2)=>{
                TrailingTriviaOption2[TrailingTriviaOption2["Exclude"] = 0] = "Exclude";
                TrailingTriviaOption2[TrailingTriviaOption2["ExcludeWhitespace"] = 1] = "ExcludeWhitespace";
                TrailingTriviaOption2[TrailingTriviaOption2["Include"] = 2] = "Include";
                return TrailingTriviaOption2;
            })(TrailingTriviaOption || {});
            useNonAdjustedPositions = {
                leadingTriviaOption: 0 /* Exclude */ ,
                trailingTriviaOption: 0 /* Exclude */ 
            };
            ChangeTracker = class {
                /** Public for tests only. Other callers should use `ChangeTracker.with`. */ constructor(newLineCharacter, formatContext){
                    this.newLineCharacter = newLineCharacter;
                    this.formatContext = formatContext;
                    this.changes = [];
                    this.classesWithNodesInsertedAtStart = /* @__PURE__ */ new Map();
                    // Set<ClassDeclaration> implemented as Map<node id, ClassDeclaration>
                    this.deletedNodes = [];
                }
                static fromContext(context) {
                    return new ChangeTracker(getNewLineOrDefaultFromHost(context.host, context.formatContext.options), context.formatContext);
                }
                static with(context, cb) {
                    const tracker = ChangeTracker.fromContext(context);
                    cb(tracker);
                    return tracker.getChanges();
                }
                pushRaw(sourceFile, change) {
                    Debug.assertEqual(sourceFile.fileName, change.fileName);
                    for (const c of change.textChanges)this.changes.push({
                        kind: 3 /* Text */ ,
                        sourceFile: sourceFile,
                        text: c.newText,
                        range: createTextRangeFromSpan(c.span)
                    });
                }
                deleteRange(sourceFile, range) {
                    this.changes.push({
                        kind: 0 /* Remove */ ,
                        sourceFile: sourceFile,
                        range: range
                    });
                }
                delete(sourceFile, node) {
                    this.deletedNodes.push({
                        sourceFile: sourceFile,
                        node: node
                    });
                }
                /** Stop! Consider using `delete` instead, which has logic for deleting nodes from delimited lists. */ deleteNode(sourceFile, node, options = {
                    leadingTriviaOption: 1 /* IncludeAll */ 
                }) {
                    this.deleteRange(sourceFile, getAdjustedRange(sourceFile, node, node, options));
                }
                deleteNodes(sourceFile, nodes, options = {
                    leadingTriviaOption: 1 /* IncludeAll */ 
                }, hasTrailingComment) {
                    for (const node of nodes){
                        const pos = getAdjustedStartPosition(sourceFile, node, options, hasTrailingComment);
                        const end = getAdjustedEndPosition(sourceFile, node, options);
                        this.deleteRange(sourceFile, {
                            pos: pos,
                            end: end
                        });
                        hasTrailingComment = !!getEndPositionOfMultilineTrailingComment(sourceFile, node, options);
                    }
                }
                deleteModifier(sourceFile, modifier) {
                    this.deleteRange(sourceFile, {
                        pos: modifier.getStart(sourceFile),
                        end: skipTrivia(sourceFile.text, modifier.end, /*stopAfterLineBreak*/ true)
                    });
                }
                deleteNodeRange(sourceFile, startNode2, endNode2, options = {
                    leadingTriviaOption: 1 /* IncludeAll */ 
                }) {
                    const startPosition = getAdjustedStartPosition(sourceFile, startNode2, options);
                    const endPosition = getAdjustedEndPosition(sourceFile, endNode2, options);
                    this.deleteRange(sourceFile, {
                        pos: startPosition,
                        end: endPosition
                    });
                }
                deleteNodeRangeExcludingEnd(sourceFile, startNode2, afterEndNode, options = {
                    leadingTriviaOption: 1 /* IncludeAll */ 
                }) {
                    const startPosition = getAdjustedStartPosition(sourceFile, startNode2, options);
                    const endPosition = afterEndNode === void 0 ? sourceFile.text.length : getAdjustedStartPosition(sourceFile, afterEndNode, options);
                    this.deleteRange(sourceFile, {
                        pos: startPosition,
                        end: endPosition
                    });
                }
                replaceRange(sourceFile, range, newNode, options = {}) {
                    this.changes.push({
                        kind: 1 /* ReplaceWithSingleNode */ ,
                        sourceFile: sourceFile,
                        range: range,
                        options: options,
                        node: newNode
                    });
                }
                replaceNode(sourceFile, oldNode, newNode, options = useNonAdjustedPositions) {
                    this.replaceRange(sourceFile, getAdjustedRange(sourceFile, oldNode, oldNode, options), newNode, options);
                }
                replaceNodeRange(sourceFile, startNode2, endNode2, newNode, options = useNonAdjustedPositions) {
                    this.replaceRange(sourceFile, getAdjustedRange(sourceFile, startNode2, endNode2, options), newNode, options);
                }
                replaceRangeWithNodes(sourceFile, range, newNodes, options = {}) {
                    this.changes.push({
                        kind: 2 /* ReplaceWithMultipleNodes */ ,
                        sourceFile: sourceFile,
                        range: range,
                        options: options,
                        nodes: newNodes
                    });
                }
                replaceNodeWithNodes(sourceFile, oldNode, newNodes, options = useNonAdjustedPositions) {
                    this.replaceRangeWithNodes(sourceFile, getAdjustedRange(sourceFile, oldNode, oldNode, options), newNodes, options);
                }
                replaceNodeWithText(sourceFile, oldNode, text) {
                    this.replaceRangeWithText(sourceFile, getAdjustedRange(sourceFile, oldNode, oldNode, useNonAdjustedPositions), text);
                }
                replaceNodeRangeWithNodes(sourceFile, startNode2, endNode2, newNodes, options = useNonAdjustedPositions) {
                    this.replaceRangeWithNodes(sourceFile, getAdjustedRange(sourceFile, startNode2, endNode2, options), newNodes, options);
                }
                nodeHasTrailingComment(sourceFile, oldNode, configurableEnd = useNonAdjustedPositions) {
                    return !!getEndPositionOfMultilineTrailingComment(sourceFile, oldNode, configurableEnd);
                }
                nextCommaToken(sourceFile, node) {
                    const next = findNextToken(node, node.parent, sourceFile);
                    return next && next.kind === 28 /* CommaToken */  ? next : void 0;
                }
                replacePropertyAssignment(sourceFile, oldNode, newNode) {
                    const suffix = this.nextCommaToken(sourceFile, oldNode) ? "" : "," + this.newLineCharacter;
                    this.replaceNode(sourceFile, oldNode, newNode, {
                        suffix: suffix
                    });
                }
                insertNodeAt(sourceFile, pos, newNode, options = {}) {
                    this.replaceRange(sourceFile, createRange(pos), newNode, options);
                }
                insertNodesAt(sourceFile, pos, newNodes, options = {}) {
                    this.replaceRangeWithNodes(sourceFile, createRange(pos), newNodes, options);
                }
                insertNodeAtTopOfFile(sourceFile, newNode, blankLineBetween) {
                    this.insertAtTopOfFile(sourceFile, newNode, blankLineBetween);
                }
                insertNodesAtTopOfFile(sourceFile, newNodes, blankLineBetween) {
                    this.insertAtTopOfFile(sourceFile, newNodes, blankLineBetween);
                }
                insertAtTopOfFile(sourceFile, insert, blankLineBetween) {
                    const pos = getInsertionPositionAtSourceFileTop(sourceFile);
                    const options = {
                        prefix: pos === 0 ? void 0 : this.newLineCharacter,
                        suffix: (isLineBreak(sourceFile.text.charCodeAt(pos)) ? "" : this.newLineCharacter) + (blankLineBetween ? this.newLineCharacter : "")
                    };
                    if (isArray(insert)) this.insertNodesAt(sourceFile, pos, insert, options);
                    else this.insertNodeAt(sourceFile, pos, insert, options);
                }
                insertNodesAtEndOfFile(sourceFile, newNodes, blankLineBetween) {
                    this.insertAtEndOfFile(sourceFile, newNodes, blankLineBetween);
                }
                insertAtEndOfFile(sourceFile, insert, blankLineBetween) {
                    const pos = sourceFile.end + 1;
                    const options = {
                        prefix: this.newLineCharacter,
                        suffix: this.newLineCharacter + (blankLineBetween ? this.newLineCharacter : "")
                    };
                    this.insertNodesAt(sourceFile, pos, insert, options);
                }
                insertStatementsInNewFile(fileName, statements, oldFile) {
                    if (!this.newFileChanges) this.newFileChanges = createMultiMap();
                    this.newFileChanges.add(fileName, {
                        oldFile: oldFile,
                        statements: statements
                    });
                }
                insertFirstParameter(sourceFile, parameters, newParam) {
                    const p0 = firstOrUndefined(parameters);
                    if (p0) this.insertNodeBefore(sourceFile, p0, newParam);
                    else this.insertNodeAt(sourceFile, parameters.pos, newParam);
                }
                insertNodeBefore(sourceFile, before, newNode, blankLineBetween = false, options = {}) {
                    this.insertNodeAt(sourceFile, getAdjustedStartPosition(sourceFile, before, options), newNode, this.getOptionsForInsertNodeBefore(before, newNode, blankLineBetween));
                }
                insertModifierAt(sourceFile, pos, modifier, options = {}) {
                    this.insertNodeAt(sourceFile, pos, factory.createToken(modifier), options);
                }
                insertModifierBefore(sourceFile, modifier, before) {
                    return this.insertModifierAt(sourceFile, before.getStart(sourceFile), modifier, {
                        suffix: " "
                    });
                }
                insertCommentBeforeLine(sourceFile, lineNumber, position, commentText) {
                    const lineStartPosition = getStartPositionOfLine(lineNumber, sourceFile);
                    const startPosition = getFirstNonSpaceCharacterPosition(sourceFile.text, lineStartPosition);
                    const insertAtLineStart = isValidLocationToAddComment(sourceFile, startPosition);
                    const token = getTouchingToken(sourceFile, insertAtLineStart ? startPosition : position);
                    const indent2 = sourceFile.text.slice(lineStartPosition, startPosition);
                    const text = `${insertAtLineStart ? "" : this.newLineCharacter}//${commentText}${this.newLineCharacter}${indent2}`;
                    this.insertText(sourceFile, token.getStart(sourceFile), text);
                }
                insertJsdocCommentBefore(sourceFile, node, tag) {
                    const fnStart = node.getStart(sourceFile);
                    if (node.jsDoc) for (const jsdoc of node.jsDoc)this.deleteRange(sourceFile, {
                        pos: getLineStartPositionForPosition(jsdoc.getStart(sourceFile), sourceFile),
                        end: getAdjustedEndPosition(sourceFile, jsdoc, /*options*/ {})
                    });
                    const startPosition = getPrecedingNonSpaceCharacterPosition(sourceFile.text, fnStart - 1);
                    const indent2 = sourceFile.text.slice(startPosition, fnStart);
                    this.insertNodeAt(sourceFile, fnStart, tag, {
                        suffix: this.newLineCharacter + indent2
                    });
                }
                createJSDocText(sourceFile, node) {
                    const comments = flatMap(node.jsDoc, (jsDoc2)=>isString(jsDoc2.comment) ? factory.createJSDocText(jsDoc2.comment) : jsDoc2.comment);
                    const jsDoc = singleOrUndefined(node.jsDoc);
                    return jsDoc && positionsAreOnSameLine(jsDoc.pos, jsDoc.end, sourceFile) && length(comments) === 0 ? void 0 : factory.createNodeArray(intersperse(comments, factory.createJSDocText("\n")));
                }
                replaceJSDocComment(sourceFile, node, tags) {
                    this.insertJsdocCommentBefore(sourceFile, updateJSDocHost(node), factory.createJSDocComment(this.createJSDocText(sourceFile, node), factory.createNodeArray(tags)));
                }
                addJSDocTags(sourceFile, parent2, newTags) {
                    const oldTags = flatMapToMutable(parent2.jsDoc, (j)=>j.tags);
                    const unmergedNewTags = newTags.filter((newTag)=>!oldTags.some((tag, i)=>{
                            const merged = tryMergeJsdocTags(tag, newTag);
                            if (merged) oldTags[i] = merged;
                            return !!merged;
                        }));
                    this.replaceJSDocComment(sourceFile, parent2, [
                        ...oldTags,
                        ...unmergedNewTags
                    ]);
                }
                filterJSDocTags(sourceFile, parent2, predicate) {
                    this.replaceJSDocComment(sourceFile, parent2, filter(flatMapToMutable(parent2.jsDoc, (j)=>j.tags), predicate));
                }
                replaceRangeWithText(sourceFile, range, text) {
                    this.changes.push({
                        kind: 3 /* Text */ ,
                        sourceFile: sourceFile,
                        range: range,
                        text: text
                    });
                }
                insertText(sourceFile, pos, text) {
                    this.replaceRangeWithText(sourceFile, createRange(pos), text);
                }
                /** Prefer this over replacing a node with another that has a type annotation, as it avoids reformatting the other parts of the node. */ tryInsertTypeAnnotation(sourceFile, node, type) {
                    let endNode2;
                    if (isFunctionLike(node)) {
                        endNode2 = findChildOfKind(node, 22 /* CloseParenToken */ , sourceFile);
                        if (!endNode2) {
                            if (!isArrowFunction(node)) return false;
                            endNode2 = first(node.parameters);
                        }
                    } else endNode2 = (node.kind === 259 /* VariableDeclaration */  ? node.exclamationToken : node.questionToken) ?? node.name;
                    this.insertNodeAt(sourceFile, endNode2.end, type, {
                        prefix: ": "
                    });
                    return true;
                }
                tryInsertThisTypeAnnotation(sourceFile, node, type) {
                    const start = findChildOfKind(node, 21 /* OpenParenToken */ , sourceFile).getStart(sourceFile) + 1;
                    const suffix = node.parameters.length ? ", " : "";
                    this.insertNodeAt(sourceFile, start, type, {
                        prefix: "this: ",
                        suffix: suffix
                    });
                }
                insertTypeParameters(sourceFile, node, typeParameters) {
                    const start = (findChildOfKind(node, 21 /* OpenParenToken */ , sourceFile) || first(node.parameters)).getStart(sourceFile);
                    this.insertNodesAt(sourceFile, start, typeParameters, {
                        prefix: "<",
                        suffix: ">",
                        joiner: ", "
                    });
                }
                getOptionsForInsertNodeBefore(before, inserted, blankLineBetween) {
                    if (isStatement(before) || isClassElement(before)) return {
                        suffix: blankLineBetween ? this.newLineCharacter + this.newLineCharacter : this.newLineCharacter
                    };
                    else if (isVariableDeclaration(before)) return {
                        suffix: ", "
                    };
                    else if (isParameter(before)) return isParameter(inserted) ? {
                        suffix: ", "
                    } : {};
                    else if (isStringLiteral(before) && isImportDeclaration(before.parent) || isNamedImports(before)) return {
                        suffix: ", "
                    };
                    else if (isImportSpecifier(before)) return {
                        suffix: "," + (blankLineBetween ? this.newLineCharacter : " ")
                    };
                    return Debug.failBadSyntaxKind(before);
                }
                insertNodeAtConstructorStart(sourceFile, ctr, newStatement) {
                    const firstStatement = firstOrUndefined(ctr.body.statements);
                    if (!firstStatement || !ctr.body.multiLine) this.replaceConstructorBody(sourceFile, ctr, [
                        newStatement,
                        ...ctr.body.statements
                    ]);
                    else this.insertNodeBefore(sourceFile, firstStatement, newStatement);
                }
                insertNodeAtConstructorStartAfterSuperCall(sourceFile, ctr, newStatement) {
                    const superCallStatement = find(ctr.body.statements, (stmt)=>isExpressionStatement(stmt) && isSuperCall(stmt.expression));
                    if (!superCallStatement || !ctr.body.multiLine) this.replaceConstructorBody(sourceFile, ctr, [
                        ...ctr.body.statements,
                        newStatement
                    ]);
                    else this.insertNodeAfter(sourceFile, superCallStatement, newStatement);
                }
                insertNodeAtConstructorEnd(sourceFile, ctr, newStatement) {
                    const lastStatement = lastOrUndefined(ctr.body.statements);
                    if (!lastStatement || !ctr.body.multiLine) this.replaceConstructorBody(sourceFile, ctr, [
                        ...ctr.body.statements,
                        newStatement
                    ]);
                    else this.insertNodeAfter(sourceFile, lastStatement, newStatement);
                }
                replaceConstructorBody(sourceFile, ctr, statements) {
                    this.replaceNode(sourceFile, ctr.body, factory.createBlock(statements, /*multiLine*/ true));
                }
                insertNodeAtEndOfScope(sourceFile, scope, newNode) {
                    const pos = getAdjustedStartPosition(sourceFile, scope.getLastToken(), {});
                    this.insertNodeAt(sourceFile, pos, newNode, {
                        prefix: isLineBreak(sourceFile.text.charCodeAt(scope.getLastToken().pos)) ? this.newLineCharacter : this.newLineCharacter + this.newLineCharacter,
                        suffix: this.newLineCharacter
                    });
                }
                insertMemberAtStart(sourceFile, node, newElement) {
                    this.insertNodeAtStartWorker(sourceFile, node, newElement);
                }
                insertNodeAtObjectStart(sourceFile, obj, newElement) {
                    this.insertNodeAtStartWorker(sourceFile, obj, newElement);
                }
                insertNodeAtStartWorker(sourceFile, node, newElement) {
                    const indentation = this.guessIndentationFromExistingMembers(sourceFile, node) ?? this.computeIndentationForNewMember(sourceFile, node);
                    this.insertNodeAt(sourceFile, getMembersOrProperties(node).pos, newElement, this.getInsertNodeAtStartInsertOptions(sourceFile, node, indentation));
                }
                /**
         * Tries to guess the indentation from the existing members of a class/interface/object. All members must be on
         * new lines and must share the same indentation.
         */ guessIndentationFromExistingMembers(sourceFile, node) {
                    let indentation;
                    let lastRange = node;
                    for (const member of getMembersOrProperties(node)){
                        if (rangeStartPositionsAreOnSameLine(lastRange, member, sourceFile)) return void 0;
                        const memberStart = member.getStart(sourceFile);
                        const memberIndentation = ts_formatting_exports.SmartIndenter.findFirstNonWhitespaceColumn(getLineStartPositionForPosition(memberStart, sourceFile), memberStart, sourceFile, this.formatContext.options);
                        if (indentation === void 0) indentation = memberIndentation;
                        else if (memberIndentation !== indentation) return void 0;
                        lastRange = member;
                    }
                    return indentation;
                }
                computeIndentationForNewMember(sourceFile, node) {
                    const nodeStart = node.getStart(sourceFile);
                    return ts_formatting_exports.SmartIndenter.findFirstNonWhitespaceColumn(getLineStartPositionForPosition(nodeStart, sourceFile), nodeStart, sourceFile, this.formatContext.options) + (this.formatContext.options.indentSize ?? 4);
                }
                getInsertNodeAtStartInsertOptions(sourceFile, node, indentation) {
                    const members = getMembersOrProperties(node);
                    const isEmpty = members.length === 0;
                    const isFirstInsertion = addToSeen(this.classesWithNodesInsertedAtStart, getNodeId(node), {
                        node: node,
                        sourceFile: sourceFile
                    });
                    const insertTrailingComma = isObjectLiteralExpression(node) && (!isJsonSourceFile(sourceFile) || !isEmpty);
                    const insertLeadingComma = isObjectLiteralExpression(node) && isJsonSourceFile(sourceFile) && isEmpty && !isFirstInsertion;
                    return {
                        indentation: indentation,
                        prefix: (insertLeadingComma ? "," : "") + this.newLineCharacter,
                        suffix: insertTrailingComma ? "," : isInterfaceDeclaration(node) && isEmpty ? ";" : ""
                    };
                }
                insertNodeAfterComma(sourceFile, after, newNode) {
                    const endPosition = this.insertNodeAfterWorker(sourceFile, this.nextCommaToken(sourceFile, after) || after, newNode);
                    this.insertNodeAt(sourceFile, endPosition, newNode, this.getInsertNodeAfterOptions(sourceFile, after));
                }
                insertNodeAfter(sourceFile, after, newNode) {
                    const endPosition = this.insertNodeAfterWorker(sourceFile, after, newNode);
                    this.insertNodeAt(sourceFile, endPosition, newNode, this.getInsertNodeAfterOptions(sourceFile, after));
                }
                insertNodeAtEndOfList(sourceFile, list, newNode) {
                    this.insertNodeAt(sourceFile, list.end, newNode, {
                        prefix: ", "
                    });
                }
                insertNodesAfter(sourceFile, after, newNodes) {
                    const endPosition = this.insertNodeAfterWorker(sourceFile, after, first(newNodes));
                    this.insertNodesAt(sourceFile, endPosition, newNodes, this.getInsertNodeAfterOptions(sourceFile, after));
                }
                insertNodeAfterWorker(sourceFile, after, newNode) {
                    if (needSemicolonBetween(after, newNode)) {
                        if (sourceFile.text.charCodeAt(after.end - 1) !== 59 /* semicolon */ ) this.replaceRange(sourceFile, createRange(after.end), factory.createToken(27 /* SemicolonToken */ ));
                    }
                    const endPosition = getAdjustedEndPosition(sourceFile, after, {});
                    return endPosition;
                }
                getInsertNodeAfterOptions(sourceFile, after) {
                    const options = this.getInsertNodeAfterOptionsWorker(after);
                    return {
                        ...options,
                        prefix: after.end === sourceFile.end && isStatement(after) ? options.prefix ? `
${options.prefix}` : "\n" : options.prefix
                    };
                }
                getInsertNodeAfterOptionsWorker(node) {
                    switch(node.kind){
                        case 262 /* ClassDeclaration */ :
                        case 266 /* ModuleDeclaration */ :
                            return {
                                prefix: this.newLineCharacter,
                                suffix: this.newLineCharacter
                            };
                        case 259 /* VariableDeclaration */ :
                        case 11 /* StringLiteral */ :
                        case 80 /* Identifier */ :
                            return {
                                prefix: ", "
                            };
                        case 302 /* PropertyAssignment */ :
                            return {
                                suffix: "," + this.newLineCharacter
                            };
                        case 95 /* ExportKeyword */ :
                            return {
                                prefix: " "
                            };
                        case 168 /* Parameter */ :
                            return {};
                        default:
                            Debug.assert(isStatement(node) || isClassOrTypeElement(node));
                            return {
                                suffix: this.newLineCharacter
                            };
                    }
                }
                insertName(sourceFile, node, name) {
                    Debug.assert(!node.name);
                    if (node.kind === 218 /* ArrowFunction */ ) {
                        const arrow = findChildOfKind(node, 39 /* EqualsGreaterThanToken */ , sourceFile);
                        const lparen = findChildOfKind(node, 21 /* OpenParenToken */ , sourceFile);
                        if (lparen) {
                            this.insertNodesAt(sourceFile, lparen.getStart(sourceFile), [
                                factory.createToken(100 /* FunctionKeyword */ ),
                                factory.createIdentifier(name)
                            ], {
                                joiner: " "
                            });
                            deleteNode(this, sourceFile, arrow);
                        } else {
                            this.insertText(sourceFile, first(node.parameters).getStart(sourceFile), `function ${name}(`);
                            this.replaceRange(sourceFile, arrow, factory.createToken(22 /* CloseParenToken */ ));
                        }
                        if (node.body.kind !== 240 /* Block */ ) {
                            this.insertNodesAt(sourceFile, node.body.getStart(sourceFile), [
                                factory.createToken(19 /* OpenBraceToken */ ),
                                factory.createToken(107 /* ReturnKeyword */ )
                            ], {
                                joiner: " ",
                                suffix: " "
                            });
                            this.insertNodesAt(sourceFile, node.body.end, [
                                factory.createToken(27 /* SemicolonToken */ ),
                                factory.createToken(20 /* CloseBraceToken */ )
                            ], {
                                joiner: " "
                            });
                        }
                    } else {
                        const pos = findChildOfKind(node, node.kind === 217 /* FunctionExpression */  ? 100 /* FunctionKeyword */  : 86 /* ClassKeyword */ , sourceFile).end;
                        this.insertNodeAt(sourceFile, pos, factory.createIdentifier(name), {
                            prefix: " "
                        });
                    }
                }
                insertExportModifier(sourceFile, node) {
                    this.insertText(sourceFile, node.getStart(sourceFile), "export ");
                }
                insertImportSpecifierAtIndex(sourceFile, importSpecifier, namedImports, index) {
                    const prevSpecifier = namedImports.elements[index - 1];
                    if (prevSpecifier) this.insertNodeInListAfter(sourceFile, prevSpecifier, importSpecifier);
                    else this.insertNodeBefore(sourceFile, namedImports.elements[0], importSpecifier, !positionsAreOnSameLine(namedImports.elements[0].getStart(), namedImports.parent.parent.getStart(), sourceFile));
                }
                /**
         * This function should be used to insert nodes in lists when nodes don't carry separators as the part of the node range,
         * i.e. arguments in arguments lists, parameters in parameter lists etc.
         * Note that separators are part of the node in statements and class elements.
         */ insertNodeInListAfter(sourceFile, after, newNode, containingList = ts_formatting_exports.SmartIndenter.getContainingList(after, sourceFile)) {
                    if (!containingList) {
                        Debug.fail("node is not a list element");
                        return;
                    }
                    const index = indexOfNode(containingList, after);
                    if (index < 0) return;
                    const end = after.getEnd();
                    if (index !== containingList.length - 1) {
                        const nextToken = getTokenAtPosition(sourceFile, after.end);
                        if (nextToken && isSeparator(after, nextToken)) {
                            const nextNode = containingList[index + 1];
                            const startPos = skipWhitespacesAndLineBreaks(sourceFile.text, nextNode.getFullStart());
                            const suffix = `${tokenToString(nextToken.kind)}${sourceFile.text.substring(nextToken.end, startPos)}`;
                            this.insertNodesAt(sourceFile, startPos, [
                                newNode
                            ], {
                                suffix: suffix
                            });
                        }
                    } else {
                        const afterStart = after.getStart(sourceFile);
                        const afterStartLinePosition = getLineStartPositionForPosition(afterStart, sourceFile);
                        let separator;
                        let multilineList = false;
                        if (containingList.length === 1) separator = 28 /* CommaToken */ ;
                        else {
                            const tokenBeforeInsertPosition = findPrecedingToken(after.pos, sourceFile);
                            separator = isSeparator(after, tokenBeforeInsertPosition) ? tokenBeforeInsertPosition.kind : 28 /* CommaToken */ ;
                            const afterMinusOneStartLinePosition = getLineStartPositionForPosition(containingList[index - 1].getStart(sourceFile), sourceFile);
                            multilineList = afterMinusOneStartLinePosition !== afterStartLinePosition;
                        }
                        if (hasCommentsBeforeLineBreak(sourceFile.text, after.end)) multilineList = true;
                        if (multilineList) {
                            this.replaceRange(sourceFile, createRange(end), factory.createToken(separator));
                            const indentation = ts_formatting_exports.SmartIndenter.findFirstNonWhitespaceColumn(afterStartLinePosition, afterStart, sourceFile, this.formatContext.options);
                            let insertPos = skipTrivia(sourceFile.text, end, /*stopAfterLineBreak*/ true, /*stopAtComments*/ false);
                            while(insertPos !== end && isLineBreak(sourceFile.text.charCodeAt(insertPos - 1)))insertPos--;
                            this.replaceRange(sourceFile, createRange(insertPos), newNode, {
                                indentation: indentation,
                                prefix: this.newLineCharacter
                            });
                        } else this.replaceRange(sourceFile, createRange(end), newNode, {
                            prefix: `${tokenToString(separator)} `
                        });
                    }
                }
                parenthesizeExpression(sourceFile, expression) {
                    this.replaceRange(sourceFile, rangeOfNode(expression), factory.createParenthesizedExpression(expression));
                }
                finishClassesWithNodesInsertedAtStart() {
                    this.classesWithNodesInsertedAtStart.forEach(({ node: node , sourceFile: sourceFile  })=>{
                        const [openBraceEnd, closeBraceEnd] = getClassOrObjectBraceEnds(node, sourceFile);
                        if (openBraceEnd !== void 0 && closeBraceEnd !== void 0) {
                            const isEmpty = getMembersOrProperties(node).length === 0;
                            const isSingleLine = positionsAreOnSameLine(openBraceEnd, closeBraceEnd, sourceFile);
                            if (isEmpty && isSingleLine && openBraceEnd !== closeBraceEnd - 1) this.deleteRange(sourceFile, createRange(openBraceEnd, closeBraceEnd - 1));
                            if (isSingleLine) this.insertText(sourceFile, closeBraceEnd - 1, this.newLineCharacter);
                        }
                    });
                }
                finishDeleteDeclarations() {
                    const deletedNodesInLists = /* @__PURE__ */ new Set();
                    for (const { sourceFile: sourceFile , node: node  } of this.deletedNodes)if (!this.deletedNodes.some((d)=>d.sourceFile === sourceFile && rangeContainsRangeExclusive(d.node, node))) {
                        if (isArray(node)) this.deleteRange(sourceFile, rangeOfTypeParameters(sourceFile, node));
                        else deleteDeclaration.deleteDeclaration(this, deletedNodesInLists, sourceFile, node);
                    }
                    deletedNodesInLists.forEach((node)=>{
                        const sourceFile = node.getSourceFile();
                        const list = ts_formatting_exports.SmartIndenter.getContainingList(node, sourceFile);
                        if (node !== last(list)) return;
                        const lastNonDeletedIndex = findLastIndex(list, (n)=>!deletedNodesInLists.has(n), list.length - 2);
                        if (lastNonDeletedIndex !== -1) this.deleteRange(sourceFile, {
                            pos: list[lastNonDeletedIndex].end,
                            end: startPositionToDeleteNodeInList(sourceFile, list[lastNonDeletedIndex + 1])
                        });
                    });
                }
                /**
         * Note: after calling this, the TextChanges object must be discarded!
         * @param validate only for tests
         *    The reason we must validate as part of this method is that `getNonFormattedText` changes the node's positions,
         *    so we can only call this once and can't get the non-formatted text separately.
         */ getChanges(validate) {
                    this.finishDeleteDeclarations();
                    this.finishClassesWithNodesInsertedAtStart();
                    const changes = changesToText.getTextChangesFromChanges(this.changes, this.newLineCharacter, this.formatContext, validate);
                    if (this.newFileChanges) this.newFileChanges.forEach((insertions, fileName)=>{
                        changes.push(changesToText.newFileChanges(fileName, insertions, this.newLineCharacter, this.formatContext));
                    });
                    return changes;
                }
                createNewFile(oldFile, fileName, statements) {
                    this.insertStatementsInNewFile(fileName, statements, oldFile);
                }
            };
            ((changesToText2)=>{
                function getTextChangesFromChanges(changes, newLineCharacter, formatContext, validate) {
                    return mapDefined(group(changes, (c)=>c.sourceFile.path), (changesInFile)=>{
                        const sourceFile = changesInFile[0].sourceFile;
                        const normalized = stableSort(changesInFile, (a, b)=>a.range.pos - b.range.pos || a.range.end - b.range.end);
                        for(let i = 0; i < normalized.length - 1; i++)Debug.assert(normalized[i].range.end <= normalized[i + 1].range.pos, "Changes overlap", ()=>`${JSON.stringify(normalized[i].range)} and ${JSON.stringify(normalized[i + 1].range)}`);
                        const textChanges2 = mapDefined(normalized, (c)=>{
                            const span = createTextSpanFromRange(c.range);
                            const targetSourceFile = c.kind === 1 /* ReplaceWithSingleNode */  ? getSourceFileOfNode(getOriginalNode(c.node)) ?? c.sourceFile : c.kind === 2 /* ReplaceWithMultipleNodes */  ? getSourceFileOfNode(getOriginalNode(c.nodes[0])) ?? c.sourceFile : c.sourceFile;
                            const newText = computeNewText(c, targetSourceFile, sourceFile, newLineCharacter, formatContext, validate);
                            if (span.length === newText.length && stringContainsAt(targetSourceFile.text, newText, span.start)) return void 0;
                            return createTextChange(span, newText);
                        });
                        return textChanges2.length > 0 ? {
                            fileName: sourceFile.fileName,
                            textChanges: textChanges2
                        } : void 0;
                    });
                }
                changesToText2.getTextChangesFromChanges = getTextChangesFromChanges;
                function newFileChanges(fileName, insertions, newLineCharacter, formatContext) {
                    const text = newFileChangesWorker(getScriptKindFromFileName(fileName), insertions, newLineCharacter, formatContext);
                    return {
                        fileName: fileName,
                        textChanges: [
                            createTextChange(createTextSpan(0, 0), text)
                        ],
                        isNewFile: true
                    };
                }
                changesToText2.newFileChanges = newFileChanges;
                function newFileChangesWorker(scriptKind, insertions, newLineCharacter, formatContext) {
                    const nonFormattedText = flatMap(insertions, (insertion)=>insertion.statements.map((s)=>s === 4 /* NewLineTrivia */  ? "" : getNonformattedText(s, insertion.oldFile, newLineCharacter).text)).join(newLineCharacter);
                    const sourceFile = createSourceFile("any file name", nonFormattedText, 99 /* ESNext */ , /*setParentNodes*/ true, scriptKind);
                    const changes = ts_formatting_exports.formatDocument(sourceFile, formatContext);
                    return applyChanges(nonFormattedText, changes) + newLineCharacter;
                }
                changesToText2.newFileChangesWorker = newFileChangesWorker;
                function computeNewText(change, targetSourceFile, sourceFile, newLineCharacter, formatContext, validate) {
                    var _a;
                    if (change.kind === 0 /* Remove */ ) return "";
                    if (change.kind === 3 /* Text */ ) return change.text;
                    const { options: options = {} , range: { pos: pos  }  } = change;
                    const format = (n)=>getFormattedTextOfNode(n, targetSourceFile, sourceFile, pos, options, newLineCharacter, formatContext, validate);
                    const text = change.kind === 2 /* ReplaceWithMultipleNodes */  ? change.nodes.map((n)=>removeSuffix(format(n), newLineCharacter)).join(((_a = change.options) == null ? void 0 : _a.joiner) || newLineCharacter) : format(change.node);
                    const noIndent = options.indentation !== void 0 || getLineStartPositionForPosition(pos, targetSourceFile) === pos ? text : text.replace(/^\s+/, "");
                    return (options.prefix || "") + noIndent + (!options.suffix || endsWith(noIndent, options.suffix) ? "" : options.suffix);
                }
                function getFormattedTextOfNode(nodeIn, targetSourceFile, sourceFile, pos, { indentation: indentation , prefix: prefix , delta: delta  }, newLineCharacter, formatContext, validate) {
                    const { node: node , text: text  } = getNonformattedText(nodeIn, targetSourceFile, newLineCharacter);
                    if (validate) validate(node, text);
                    const formatOptions = getFormatCodeSettingsForWriting(formatContext, targetSourceFile);
                    const initialIndentation = indentation !== void 0 ? indentation : ts_formatting_exports.SmartIndenter.getIndentation(pos, sourceFile, formatOptions, prefix === newLineCharacter || getLineStartPositionForPosition(pos, targetSourceFile) === pos);
                    if (delta === void 0) delta = ts_formatting_exports.SmartIndenter.shouldIndentChildNode(formatOptions, nodeIn) ? formatOptions.indentSize || 0 : 0;
                    const file = {
                        text: text,
                        getLineAndCharacterOfPosition (pos2) {
                            return getLineAndCharacterOfPosition(this, pos2);
                        }
                    };
                    const changes = ts_formatting_exports.formatNodeGivenIndentation(node, file, targetSourceFile.languageVariant, initialIndentation, delta, {
                        ...formatContext,
                        options: formatOptions
                    });
                    return applyChanges(text, changes);
                }
                function getNonformattedText(node, sourceFile, newLineCharacter) {
                    const writer = createWriter(newLineCharacter);
                    const newLine = getNewLineKind(newLineCharacter);
                    createPrinter({
                        newLine: newLine,
                        neverAsciiEscape: true,
                        preserveSourceNewlines: true,
                        terminateUnterminatedLiterals: true
                    }, writer).writeNode(4 /* Unspecified */ , node, sourceFile, writer);
                    return {
                        text: writer.getText(),
                        node: assignPositionsToNode(node)
                    };
                }
                changesToText2.getNonformattedText = getNonformattedText;
            })(changesToText || (changesToText = {}));
            textChangesTransformationContext = {
                ...nullTransformationContext,
                factory: createNodeFactory(nullTransformationContext.factory.flags | 1 /* NoParenthesizerRules */ , nullTransformationContext.factory.baseFactory)
            };
            ((_deleteDeclaration)=>{
                function deleteDeclaration2(changes, deletedNodesInLists, sourceFile, node) {
                    switch(node.kind){
                        case 168 /* Parameter */ :
                            {
                                const oldFunction = node.parent;
                                if (isArrowFunction(oldFunction) && oldFunction.parameters.length === 1 && !findChildOfKind(oldFunction, 21 /* OpenParenToken */ , sourceFile)) changes.replaceNodeWithText(sourceFile, node, "()");
                                else deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                                break;
                            }
                        case 271 /* ImportDeclaration */ :
                        case 270 /* ImportEqualsDeclaration */ :
                            const isFirstImport = sourceFile.imports.length && node === first(sourceFile.imports).parent || node === find(sourceFile.statements, isAnyImportSyntax);
                            deleteNode(changes, sourceFile, node, {
                                leadingTriviaOption: isFirstImport ? 0 /* Exclude */  : hasJSDocNodes(node) ? 2 /* JSDoc */  : 3 /* StartLine */ 
                            });
                            break;
                        case 207 /* BindingElement */ :
                            const pattern = node.parent;
                            const preserveComma = pattern.kind === 206 /* ArrayBindingPattern */  && node !== last(pattern.elements);
                            if (preserveComma) deleteNode(changes, sourceFile, node);
                            else deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                            break;
                        case 259 /* VariableDeclaration */ :
                            deleteVariableDeclaration(changes, deletedNodesInLists, sourceFile, node);
                            break;
                        case 167 /* TypeParameter */ :
                            deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                            break;
                        case 275 /* ImportSpecifier */ :
                            const namedImports = node.parent;
                            if (namedImports.elements.length === 1) deleteImportBinding(changes, sourceFile, namedImports);
                            else deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                            break;
                        case 273 /* NamespaceImport */ :
                            deleteImportBinding(changes, sourceFile, node);
                            break;
                        case 27 /* SemicolonToken */ :
                            deleteNode(changes, sourceFile, node, {
                                trailingTriviaOption: 0 /* Exclude */ 
                            });
                            break;
                        case 100 /* FunctionKeyword */ :
                            deleteNode(changes, sourceFile, node, {
                                leadingTriviaOption: 0 /* Exclude */ 
                            });
                            break;
                        case 262 /* ClassDeclaration */ :
                        case 261 /* FunctionDeclaration */ :
                            deleteNode(changes, sourceFile, node, {
                                leadingTriviaOption: hasJSDocNodes(node) ? 2 /* JSDoc */  : 3 /* StartLine */ 
                            });
                            break;
                        default:
                            if (!node.parent) deleteNode(changes, sourceFile, node);
                            else if (isImportClause(node.parent) && node.parent.name === node) deleteDefaultImport(changes, sourceFile, node.parent);
                            else if (isCallExpression(node.parent) && contains(node.parent.arguments, node)) deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                            else deleteNode(changes, sourceFile, node);
                    }
                }
                _deleteDeclaration.deleteDeclaration = deleteDeclaration2;
                function deleteDefaultImport(changes, sourceFile, importClause) {
                    if (!importClause.namedBindings) deleteNode(changes, sourceFile, importClause.parent);
                    else {
                        const start = importClause.name.getStart(sourceFile);
                        const nextToken = getTokenAtPosition(sourceFile, importClause.name.end);
                        if (nextToken && nextToken.kind === 28 /* CommaToken */ ) {
                            const end = skipTrivia(sourceFile.text, nextToken.end, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
                            changes.deleteRange(sourceFile, {
                                pos: start,
                                end: end
                            });
                        } else deleteNode(changes, sourceFile, importClause.name);
                    }
                }
                function deleteImportBinding(changes, sourceFile, node) {
                    if (node.parent.name) {
                        const previousToken = Debug.checkDefined(getTokenAtPosition(sourceFile, node.pos - 1));
                        changes.deleteRange(sourceFile, {
                            pos: previousToken.getStart(sourceFile),
                            end: node.end
                        });
                    } else {
                        const importDecl = getAncestor(node, 271 /* ImportDeclaration */ );
                        deleteNode(changes, sourceFile, importDecl);
                    }
                }
                function deleteVariableDeclaration(changes, deletedNodesInLists, sourceFile, node) {
                    const { parent: parent2  } = node;
                    if (parent2.kind === 298 /* CatchClause */ ) {
                        changes.deleteNodeRange(sourceFile, findChildOfKind(parent2, 21 /* OpenParenToken */ , sourceFile), findChildOfKind(parent2, 22 /* CloseParenToken */ , sourceFile));
                        return;
                    }
                    if (parent2.declarations.length !== 1) {
                        deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                        return;
                    }
                    const gp = parent2.parent;
                    switch(gp.kind){
                        case 249 /* ForOfStatement */ :
                        case 248 /* ForInStatement */ :
                            changes.replaceNode(sourceFile, node, factory.createObjectLiteralExpression());
                            break;
                        case 247 /* ForStatement */ :
                            deleteNode(changes, sourceFile, parent2);
                            break;
                        case 242 /* VariableStatement */ :
                            deleteNode(changes, sourceFile, gp, {
                                leadingTriviaOption: hasJSDocNodes(gp) ? 2 /* JSDoc */  : 3 /* StartLine */ 
                            });
                            break;
                        default:
                            Debug.assertNever(gp);
                    }
                }
            })(deleteDeclaration || (deleteDeclaration = {}));
        }
    });
    // src/services/_namespaces/ts.textChanges.ts
    var ts_textChanges_exports = {};
    __export(ts_textChanges_exports, {
        ChangeTracker: ()=>ChangeTracker,
        LeadingTriviaOption: ()=>LeadingTriviaOption,
        TrailingTriviaOption: ()=>TrailingTriviaOption,
        applyChanges: ()=>applyChanges,
        assignPositionsToNode: ()=>assignPositionsToNode,
        createWriter: ()=>createWriter,
        deleteNode: ()=>deleteNode,
        isThisTypeAnnotatable: ()=>isThisTypeAnnotatable,
        isValidLocationToAddComment: ()=>isValidLocationToAddComment
    });
    var init_ts_textChanges = __esm({
        "src/services/_namespaces/ts.textChanges.ts" () {
            "use strict";
            init_textChanges();
        }
    });
    // src/services/formatting/formattingContext.ts
    var FormattingRequestKind, FormattingContext;
    var init_formattingContext = __esm({
        "src/services/formatting/formattingContext.ts" () {
            "use strict";
            init_ts4();
            FormattingRequestKind = /* @__PURE__ */ ((FormattingRequestKind2)=>{
                FormattingRequestKind2[FormattingRequestKind2["FormatDocument"] = 0] = "FormatDocument";
                FormattingRequestKind2[FormattingRequestKind2["FormatSelection"] = 1] = "FormatSelection";
                FormattingRequestKind2[FormattingRequestKind2["FormatOnEnter"] = 2] = "FormatOnEnter";
                FormattingRequestKind2[FormattingRequestKind2["FormatOnSemicolon"] = 3] = "FormatOnSemicolon";
                FormattingRequestKind2[FormattingRequestKind2["FormatOnOpeningCurlyBrace"] = 4] = "FormatOnOpeningCurlyBrace";
                FormattingRequestKind2[FormattingRequestKind2["FormatOnClosingCurlyBrace"] = 5] = "FormatOnClosingCurlyBrace";
                return FormattingRequestKind2;
            })(FormattingRequestKind || {});
            FormattingContext = class {
                constructor(sourceFile, formattingRequestKind, options){
                    this.sourceFile = sourceFile;
                    this.formattingRequestKind = formattingRequestKind;
                    this.options = options;
                }
                updateContext(currentRange, currentTokenParent, nextRange, nextTokenParent, commonParent) {
                    this.currentTokenSpan = Debug.checkDefined(currentRange);
                    this.currentTokenParent = Debug.checkDefined(currentTokenParent);
                    this.nextTokenSpan = Debug.checkDefined(nextRange);
                    this.nextTokenParent = Debug.checkDefined(nextTokenParent);
                    this.contextNode = Debug.checkDefined(commonParent);
                    this.contextNodeAllOnSameLine = void 0;
                    this.nextNodeAllOnSameLine = void 0;
                    this.tokensAreOnSameLine = void 0;
                    this.contextNodeBlockIsOnOneLine = void 0;
                    this.nextNodeBlockIsOnOneLine = void 0;
                }
                ContextNodeAllOnSameLine() {
                    if (this.contextNodeAllOnSameLine === void 0) this.contextNodeAllOnSameLine = this.NodeIsOnOneLine(this.contextNode);
                    return this.contextNodeAllOnSameLine;
                }
                NextNodeAllOnSameLine() {
                    if (this.nextNodeAllOnSameLine === void 0) this.nextNodeAllOnSameLine = this.NodeIsOnOneLine(this.nextTokenParent);
                    return this.nextNodeAllOnSameLine;
                }
                TokensAreOnSameLine() {
                    if (this.tokensAreOnSameLine === void 0) {
                        const startLine = this.sourceFile.getLineAndCharacterOfPosition(this.currentTokenSpan.pos).line;
                        const endLine = this.sourceFile.getLineAndCharacterOfPosition(this.nextTokenSpan.pos).line;
                        this.tokensAreOnSameLine = startLine === endLine;
                    }
                    return this.tokensAreOnSameLine;
                }
                ContextNodeBlockIsOnOneLine() {
                    if (this.contextNodeBlockIsOnOneLine === void 0) this.contextNodeBlockIsOnOneLine = this.BlockIsOnOneLine(this.contextNode);
                    return this.contextNodeBlockIsOnOneLine;
                }
                NextNodeBlockIsOnOneLine() {
                    if (this.nextNodeBlockIsOnOneLine === void 0) this.nextNodeBlockIsOnOneLine = this.BlockIsOnOneLine(this.nextTokenParent);
                    return this.nextNodeBlockIsOnOneLine;
                }
                NodeIsOnOneLine(node) {
                    const startLine = this.sourceFile.getLineAndCharacterOfPosition(node.getStart(this.sourceFile)).line;
                    const endLine = this.sourceFile.getLineAndCharacterOfPosition(node.getEnd()).line;
                    return startLine === endLine;
                }
                BlockIsOnOneLine(node) {
                    const openBrace = findChildOfKind(node, 19 /* OpenBraceToken */ , this.sourceFile);
                    const closeBrace = findChildOfKind(node, 20 /* CloseBraceToken */ , this.sourceFile);
                    if (openBrace && closeBrace) {
                        const startLine = this.sourceFile.getLineAndCharacterOfPosition(openBrace.getEnd()).line;
                        const endLine = this.sourceFile.getLineAndCharacterOfPosition(closeBrace.getStart(this.sourceFile)).line;
                        return startLine === endLine;
                    }
                    return false;
                }
            };
        }
    });
    // src/services/formatting/formattingScanner.ts
    function getFormattingScanner(text, languageVariant, startPos, endPos, cb) {
        const scanner2 = languageVariant === 1 /* JSX */  ? jsxScanner : standardScanner;
        scanner2.setText(text);
        scanner2.resetTokenState(startPos);
        let wasNewLine = true;
        let leadingTrivia;
        let trailingTrivia;
        let savedPos;
        let lastScanAction;
        let lastTokenInfo;
        const res = cb({
            advance: advance,
            readTokenInfo: readTokenInfo,
            readEOFTokenRange: readEOFTokenRange,
            isOnToken: isOnToken,
            isOnEOF: isOnEOF,
            getCurrentLeadingTrivia: ()=>leadingTrivia,
            lastTrailingTriviaWasNewLine: ()=>wasNewLine,
            skipToEndOf: skipToEndOf,
            skipToStartOf: skipToStartOf,
            getTokenFullStart: ()=>(lastTokenInfo == null ? void 0 : lastTokenInfo.token.pos) ?? scanner2.getTokenStart(),
            getStartPos: ()=>(lastTokenInfo == null ? void 0 : lastTokenInfo.token.pos) ?? scanner2.getTokenStart()
        });
        lastTokenInfo = void 0;
        scanner2.setText(void 0);
        return res;
        function advance() {
            lastTokenInfo = void 0;
            const isStarted = scanner2.getTokenFullStart() !== startPos;
            if (isStarted) wasNewLine = !!trailingTrivia && last(trailingTrivia).kind === 4 /* NewLineTrivia */ ;
            else scanner2.scan();
            leadingTrivia = void 0;
            trailingTrivia = void 0;
            let pos = scanner2.getTokenFullStart();
            while(pos < endPos){
                const t = scanner2.getToken();
                if (!isTrivia(t)) break;
                scanner2.scan();
                const item = {
                    pos: pos,
                    end: scanner2.getTokenFullStart(),
                    kind: t
                };
                pos = scanner2.getTokenFullStart();
                leadingTrivia = append(leadingTrivia, item);
            }
            savedPos = scanner2.getTokenFullStart();
        }
        function shouldRescanGreaterThanToken(node) {
            switch(node.kind){
                case 34 /* GreaterThanEqualsToken */ :
                case 72 /* GreaterThanGreaterThanEqualsToken */ :
                case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                case 49 /* GreaterThanGreaterThanToken */ :
                    return true;
            }
            return false;
        }
        function shouldRescanJsxIdentifier(node) {
            if (node.parent) switch(node.parent.kind){
                case 290 /* JsxAttribute */ :
                case 285 /* JsxOpeningElement */ :
                case 286 /* JsxClosingElement */ :
                case 284 /* JsxSelfClosingElement */ :
                    return isKeyword(node.kind) || node.kind === 80 /* Identifier */ ;
            }
            return false;
        }
        function shouldRescanJsxText(node) {
            return isJsxText(node) || isJsxElement(node) && (lastTokenInfo == null ? void 0 : lastTokenInfo.token.kind) === 12 /* JsxText */ ;
        }
        function shouldRescanSlashToken(container) {
            return container.kind === 14 /* RegularExpressionLiteral */ ;
        }
        function shouldRescanTemplateToken(container) {
            return container.kind === 17 /* TemplateMiddle */  || container.kind === 18 /* TemplateTail */ ;
        }
        function shouldRescanJsxAttributeValue(node) {
            return node.parent && isJsxAttribute(node.parent) && node.parent.initializer === node;
        }
        function startsWithSlashToken(t) {
            return t === 44 /* SlashToken */  || t === 69 /* SlashEqualsToken */ ;
        }
        function readTokenInfo(n) {
            Debug.assert(isOnToken());
            const expectedScanAction = shouldRescanGreaterThanToken(n) ? 1 /* RescanGreaterThanToken */  : shouldRescanSlashToken(n) ? 2 /* RescanSlashToken */  : shouldRescanTemplateToken(n) ? 3 /* RescanTemplateToken */  : shouldRescanJsxIdentifier(n) ? 4 /* RescanJsxIdentifier */  : shouldRescanJsxText(n) ? 5 /* RescanJsxText */  : shouldRescanJsxAttributeValue(n) ? 6 /* RescanJsxAttributeValue */  : 0 /* Scan */ ;
            if (lastTokenInfo && expectedScanAction === lastScanAction) return fixTokenKind(lastTokenInfo, n);
            if (scanner2.getTokenFullStart() !== savedPos) {
                Debug.assert(lastTokenInfo !== void 0);
                scanner2.resetTokenState(savedPos);
                scanner2.scan();
            }
            let currentToken = getNextToken(n, expectedScanAction);
            const token = createTextRangeWithKind(scanner2.getTokenFullStart(), scanner2.getTokenEnd(), currentToken);
            if (trailingTrivia) trailingTrivia = void 0;
            while(scanner2.getTokenFullStart() < endPos){
                currentToken = scanner2.scan();
                if (!isTrivia(currentToken)) break;
                const trivia = createTextRangeWithKind(scanner2.getTokenFullStart(), scanner2.getTokenEnd(), currentToken);
                if (!trailingTrivia) trailingTrivia = [];
                trailingTrivia.push(trivia);
                if (currentToken === 4 /* NewLineTrivia */ ) {
                    scanner2.scan();
                    break;
                }
            }
            lastTokenInfo = {
                leadingTrivia: leadingTrivia,
                trailingTrivia: trailingTrivia,
                token: token
            };
            return fixTokenKind(lastTokenInfo, n);
        }
        function getNextToken(n, expectedScanAction) {
            const token = scanner2.getToken();
            lastScanAction = 0 /* Scan */ ;
            switch(expectedScanAction){
                case 1 /* RescanGreaterThanToken */ :
                    if (token === 32 /* GreaterThanToken */ ) {
                        lastScanAction = 1 /* RescanGreaterThanToken */ ;
                        const newToken = scanner2.reScanGreaterToken();
                        Debug.assert(n.kind === newToken);
                        return newToken;
                    }
                    break;
                case 2 /* RescanSlashToken */ :
                    if (startsWithSlashToken(token)) {
                        lastScanAction = 2 /* RescanSlashToken */ ;
                        const newToken = scanner2.reScanSlashToken();
                        Debug.assert(n.kind === newToken);
                        return newToken;
                    }
                    break;
                case 3 /* RescanTemplateToken */ :
                    if (token === 20 /* CloseBraceToken */ ) {
                        lastScanAction = 3 /* RescanTemplateToken */ ;
                        return scanner2.reScanTemplateToken(/*isTaggedTemplate*/ false);
                    }
                    break;
                case 4 /* RescanJsxIdentifier */ :
                    lastScanAction = 4 /* RescanJsxIdentifier */ ;
                    return scanner2.scanJsxIdentifier();
                case 5 /* RescanJsxText */ :
                    lastScanAction = 5 /* RescanJsxText */ ;
                    return scanner2.reScanJsxToken(/*allowMultilineJsxText*/ false);
                case 6 /* RescanJsxAttributeValue */ :
                    lastScanAction = 6 /* RescanJsxAttributeValue */ ;
                    return scanner2.reScanJsxAttributeValue();
                case 0 /* Scan */ :
                    break;
                default:
                    Debug.assertNever(expectedScanAction);
            }
            return token;
        }
        function readEOFTokenRange() {
            Debug.assert(isOnEOF());
            return createTextRangeWithKind(scanner2.getTokenFullStart(), scanner2.getTokenEnd(), 1 /* EndOfFileToken */ );
        }
        function isOnToken() {
            const current = lastTokenInfo ? lastTokenInfo.token.kind : scanner2.getToken();
            return current !== 1 /* EndOfFileToken */  && !isTrivia(current);
        }
        function isOnEOF() {
            const current = lastTokenInfo ? lastTokenInfo.token.kind : scanner2.getToken();
            return current === 1 /* EndOfFileToken */ ;
        }
        function fixTokenKind(tokenInfo, container) {
            if (isToken(container) && tokenInfo.token.kind !== container.kind) tokenInfo.token.kind = container.kind;
            return tokenInfo;
        }
        function skipToEndOf(node) {
            scanner2.resetTokenState(node.end);
            savedPos = scanner2.getTokenFullStart();
            lastScanAction = void 0;
            lastTokenInfo = void 0;
            wasNewLine = false;
            leadingTrivia = void 0;
            trailingTrivia = void 0;
        }
        function skipToStartOf(node) {
            scanner2.resetTokenState(node.pos);
            savedPos = scanner2.getTokenFullStart();
            lastScanAction = void 0;
            lastTokenInfo = void 0;
            wasNewLine = false;
            leadingTrivia = void 0;
            trailingTrivia = void 0;
        }
    }
    var standardScanner, jsxScanner;
    var init_formattingScanner = __esm({
        "src/services/formatting/formattingScanner.ts" () {
            "use strict";
            init_ts4();
            init_ts_formatting();
            standardScanner = createScanner(99 /* Latest */ , /*skipTrivia*/ false, 0 /* Standard */ );
            jsxScanner = createScanner(99 /* Latest */ , /*skipTrivia*/ false, 1 /* JSX */ );
        }
    });
    // src/services/formatting/rule.ts
    var anyContext, RuleAction, RuleFlags;
    var init_rule = __esm({
        "src/services/formatting/rule.ts" () {
            "use strict";
            init_ts4();
            anyContext = emptyArray;
            RuleAction = /* @__PURE__ */ ((RuleAction2)=>{
                RuleAction2[RuleAction2["None"] = 0] = "None";
                RuleAction2[RuleAction2["StopProcessingSpaceActions"] = 1] = "StopProcessingSpaceActions";
                RuleAction2[RuleAction2["StopProcessingTokenActions"] = 2] = "StopProcessingTokenActions";
                RuleAction2[RuleAction2["InsertSpace"] = 4] = "InsertSpace";
                RuleAction2[RuleAction2["InsertNewLine"] = 8] = "InsertNewLine";
                RuleAction2[RuleAction2["DeleteSpace"] = 16] = "DeleteSpace";
                RuleAction2[RuleAction2["DeleteToken"] = 32] = "DeleteToken";
                RuleAction2[RuleAction2["InsertTrailingSemicolon"] = 64] = "InsertTrailingSemicolon";
                RuleAction2[RuleAction2["StopAction"] = 3] = "StopAction";
                RuleAction2[RuleAction2["ModifySpaceAction"] = 28] = "ModifySpaceAction";
                RuleAction2[RuleAction2["ModifyTokenAction"] = 96] = "ModifyTokenAction";
                return RuleAction2;
            })(RuleAction || {});
            RuleFlags = /* @__PURE__ */ ((RuleFlags2)=>{
                RuleFlags2[RuleFlags2["None"] = 0] = "None";
                RuleFlags2[RuleFlags2["CanDeleteNewLines"] = 1] = "CanDeleteNewLines";
                return RuleFlags2;
            })(RuleFlags || {});
        }
    });
    // src/services/formatting/rules.ts
    function getAllRules() {
        const allTokens = [];
        for(let token = 0 /* FirstToken */ ; token <= 164 /* LastToken */ ; token++)if (token !== 1 /* EndOfFileToken */ ) allTokens.push(token);
        function anyTokenExcept(...tokens) {
            return {
                tokens: allTokens.filter((t)=>!tokens.some((t2)=>t2 === t)),
                isSpecific: false
            };
        }
        const anyToken = {
            tokens: allTokens,
            isSpecific: false
        };
        const anyTokenIncludingMultilineComments = tokenRangeFrom([
            ...allTokens,
            3 /* MultiLineCommentTrivia */ 
        ]);
        const anyTokenIncludingEOF = tokenRangeFrom([
            ...allTokens,
            1 /* EndOfFileToken */ 
        ]);
        const keywords = tokenRangeFromRange(83 /* FirstKeyword */ , 164 /* LastKeyword */ );
        const binaryOperators = tokenRangeFromRange(30 /* FirstBinaryOperator */ , 79 /* LastBinaryOperator */ );
        const binaryKeywordOperators = [
            103 /* InKeyword */ ,
            104 /* InstanceOfKeyword */ ,
            164 /* OfKeyword */ ,
            130 /* AsKeyword */ ,
            142 /* IsKeyword */ ,
            152 /* SatisfiesKeyword */ 
        ];
        const unaryPrefixOperators = [
            46 /* PlusPlusToken */ ,
            47 /* MinusMinusToken */ ,
            55 /* TildeToken */ ,
            54 /* ExclamationToken */ 
        ];
        const unaryPrefixExpressions = [
            9 /* NumericLiteral */ ,
            10 /* BigIntLiteral */ ,
            80 /* Identifier */ ,
            21 /* OpenParenToken */ ,
            23 /* OpenBracketToken */ ,
            19 /* OpenBraceToken */ ,
            110 /* ThisKeyword */ ,
            105 /* NewKeyword */ 
        ];
        const unaryPreincrementExpressions = [
            80 /* Identifier */ ,
            21 /* OpenParenToken */ ,
            110 /* ThisKeyword */ ,
            105 /* NewKeyword */ 
        ];
        const unaryPostincrementExpressions = [
            80 /* Identifier */ ,
            22 /* CloseParenToken */ ,
            24 /* CloseBracketToken */ ,
            105 /* NewKeyword */ 
        ];
        const unaryPredecrementExpressions = [
            80 /* Identifier */ ,
            21 /* OpenParenToken */ ,
            110 /* ThisKeyword */ ,
            105 /* NewKeyword */ 
        ];
        const unaryPostdecrementExpressions = [
            80 /* Identifier */ ,
            22 /* CloseParenToken */ ,
            24 /* CloseBracketToken */ ,
            105 /* NewKeyword */ 
        ];
        const comments = [
            2 /* SingleLineCommentTrivia */ ,
            3 /* MultiLineCommentTrivia */ 
        ];
        const typeNames = [
            80 /* Identifier */ ,
            ...typeKeywords
        ];
        const functionOpenBraceLeftTokenRange = anyTokenIncludingMultilineComments;
        const typeScriptOpenBraceLeftTokenRange = tokenRangeFrom([
            80 /* Identifier */ ,
            3 /* MultiLineCommentTrivia */ ,
            86 /* ClassKeyword */ ,
            95 /* ExportKeyword */ ,
            102 /* ImportKeyword */ 
        ]);
        const controlOpenBraceLeftTokenRange = tokenRangeFrom([
            22 /* CloseParenToken */ ,
            3 /* MultiLineCommentTrivia */ ,
            92 /* DoKeyword */ ,
            113 /* TryKeyword */ ,
            98 /* FinallyKeyword */ ,
            93 /* ElseKeyword */ 
        ]);
        const highPriorityCommonRules = [
            // Leave comments alone
            rule("IgnoreBeforeComment", anyToken, comments, anyContext, 1 /* StopProcessingSpaceActions */ ),
            rule("IgnoreAfterLineComment", 2 /* SingleLineCommentTrivia */ , anyToken, anyContext, 1 /* StopProcessingSpaceActions */ ),
            rule("NotSpaceBeforeColon", anyToken, 59 /* ColonToken */ , [
                isNonJsxSameLineTokenContext,
                isNotBinaryOpContext,
                isNotTypeAnnotationContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceAfterColon", 59 /* ColonToken */ , anyToken, [
                isNonJsxSameLineTokenContext,
                isNotBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeQuestionMark", anyToken, 58 /* QuestionToken */ , [
                isNonJsxSameLineTokenContext,
                isNotBinaryOpContext,
                isNotTypeAnnotationContext
            ], 16 /* DeleteSpace */ ),
            // insert space after '?' only when it is used in conditional operator
            rule("SpaceAfterQuestionMarkInConditionalOperator", 58 /* QuestionToken */ , anyToken, [
                isNonJsxSameLineTokenContext,
                isConditionalOperatorContext
            ], 4 /* InsertSpace */ ),
            // in other cases there should be no space between '?' and next token
            rule("NoSpaceAfterQuestionMark", 58 /* QuestionToken */ , anyToken, [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeDot", anyToken, [
                25 /* DotToken */ ,
                29 /* QuestionDotToken */ 
            ], [
                isNonJsxSameLineTokenContext,
                isNotPropertyAccessOnIntegerLiteral
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterDot", [
                25 /* DotToken */ ,
                29 /* QuestionDotToken */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBetweenImportParenInImportType", 102 /* ImportKeyword */ , 21 /* OpenParenToken */ , [
                isNonJsxSameLineTokenContext,
                isImportTypeContext
            ], 16 /* DeleteSpace */ ),
            // Special handling of unary operators.
            // Prefix operators generally shouldn't have a space between
            // them and their target unary expression.
            rule("NoSpaceAfterUnaryPrefixOperator", unaryPrefixOperators, unaryPrefixExpressions, [
                isNonJsxSameLineTokenContext,
                isNotBinaryOpContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterUnaryPreincrementOperator", 46 /* PlusPlusToken */ , unaryPreincrementExpressions, [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterUnaryPredecrementOperator", 47 /* MinusMinusToken */ , unaryPredecrementExpressions, [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeUnaryPostincrementOperator", unaryPostincrementExpressions, 46 /* PlusPlusToken */ , [
                isNonJsxSameLineTokenContext,
                isNotStatementConditionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeUnaryPostdecrementOperator", unaryPostdecrementExpressions, 47 /* MinusMinusToken */ , [
                isNonJsxSameLineTokenContext,
                isNotStatementConditionContext
            ], 16 /* DeleteSpace */ ),
            // More unary operator special-casing.
            // DevDiv 181814: Be careful when removing leading whitespace
            // around unary operators.  Examples:
            //      1 - -2  --X--> 1--2
            //      a + ++b --X--> a+++b
            rule("SpaceAfterPostincrementWhenFollowedByAdd", 46 /* PlusPlusToken */ , 40 /* PlusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterAddWhenFollowedByUnaryPlus", 40 /* PlusToken */ , 40 /* PlusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterAddWhenFollowedByPreincrement", 40 /* PlusToken */ , 46 /* PlusPlusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterPostdecrementWhenFollowedBySubtract", 47 /* MinusMinusToken */ , 41 /* MinusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterSubtractWhenFollowedByUnaryMinus", 41 /* MinusToken */ , 41 /* MinusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterSubtractWhenFollowedByPredecrement", 41 /* MinusToken */ , 47 /* MinusMinusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterCloseBrace", 20 /* CloseBraceToken */ , [
                28 /* CommaToken */ ,
                27 /* SemicolonToken */ 
            ], [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // For functions and control block place } on a new line [multi-line rule]
            rule("NewLineBeforeCloseBraceInBlockContext", anyTokenIncludingMultilineComments, 20 /* CloseBraceToken */ , [
                isMultilineBlockContext
            ], 8 /* InsertNewLine */ ),
            // Space/new line after }.
            rule("SpaceAfterCloseBrace", 20 /* CloseBraceToken */ , anyTokenExcept(22 /* CloseParenToken */ ), [
                isNonJsxSameLineTokenContext,
                isAfterCodeBlockContext
            ], 4 /* InsertSpace */ ),
            // Special case for (}, else) and (}, while) since else & while tokens are not part of the tree which makes SpaceAfterCloseBrace rule not applied
            // Also should not apply to })
            rule("SpaceBetweenCloseBraceAndElse", 20 /* CloseBraceToken */ , 93 /* ElseKeyword */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBetweenCloseBraceAndWhile", 20 /* CloseBraceToken */ , 117 /* WhileKeyword */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenEmptyBraceBrackets", 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , [
                isNonJsxSameLineTokenContext,
                isObjectContext
            ], 16 /* DeleteSpace */ ),
            // Add a space after control dec context if the next character is an open bracket ex: 'if (false)[a, b] = [1, 2];' -> 'if (false) [a, b] = [1, 2];'
            rule("SpaceAfterConditionalClosingParen", 22 /* CloseParenToken */ , 23 /* OpenBracketToken */ , [
                isControlDeclContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenFunctionKeywordAndStar", 100 /* FunctionKeyword */ , 42 /* AsteriskToken */ , [
                isFunctionDeclarationOrFunctionExpressionContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceAfterStarInGeneratorDeclaration", 42 /* AsteriskToken */ , 80 /* Identifier */ , [
                isFunctionDeclarationOrFunctionExpressionContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterFunctionInFuncDecl", 100 /* FunctionKeyword */ , anyToken, [
                isFunctionDeclContext
            ], 4 /* InsertSpace */ ),
            // Insert new line after { and before } in multi-line contexts.
            rule("NewLineAfterOpenBraceInBlockContext", 19 /* OpenBraceToken */ , anyToken, [
                isMultilineBlockContext
            ], 8 /* InsertNewLine */ ),
            // For get/set members, we check for (identifier,identifier) since get/set don't have tokens and they are represented as just an identifier token.
            // Though, we do extra check on the context to make sure we are dealing with get/set node. Example:
            //      get x() {}
            //      set x(val) {}
            rule("SpaceAfterGetSetInMember", [
                139 /* GetKeyword */ ,
                153 /* SetKeyword */ 
            ], 80 /* Identifier */ , [
                isFunctionDeclContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenYieldKeywordAndStar", 127 /* YieldKeyword */ , 42 /* AsteriskToken */ , [
                isNonJsxSameLineTokenContext,
                isYieldOrYieldStarWithOperand
            ], 16 /* DeleteSpace */ ),
            rule("SpaceBetweenYieldOrYieldStarAndOperand", [
                127 /* YieldKeyword */ ,
                42 /* AsteriskToken */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext,
                isYieldOrYieldStarWithOperand
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenReturnAndSemicolon", 107 /* ReturnKeyword */ , 27 /* SemicolonToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceAfterCertainKeywords", [
                115 /* VarKeyword */ ,
                111 /* ThrowKeyword */ ,
                105 /* NewKeyword */ ,
                91 /* DeleteKeyword */ ,
                107 /* ReturnKeyword */ ,
                114 /* TypeOfKeyword */ ,
                135 /* AwaitKeyword */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterLetConstInVariableDeclaration", [
                121 /* LetKeyword */ ,
                87 /* ConstKeyword */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext,
                isStartOfVariableDeclarationList
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeOpenParenInFuncCall", anyToken, 21 /* OpenParenToken */ , [
                isNonJsxSameLineTokenContext,
                isFunctionCallOrNewContext,
                isPreviousTokenNotComma
            ], 16 /* DeleteSpace */ ),
            // Special case for binary operators (that are keywords). For these we have to add a space and shouldn't follow any user options.
            rule("SpaceBeforeBinaryKeywordOperator", anyToken, binaryKeywordOperators, [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterBinaryKeywordOperator", binaryKeywordOperators, anyToken, [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterVoidOperator", 116 /* VoidKeyword */ , anyToken, [
                isNonJsxSameLineTokenContext,
                isVoidOpContext
            ], 4 /* InsertSpace */ ),
            // Async-await
            rule("SpaceBetweenAsyncAndOpenParen", 134 /* AsyncKeyword */ , 21 /* OpenParenToken */ , [
                isArrowFunctionContext,
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBetweenAsyncAndFunctionKeyword", 134 /* AsyncKeyword */ , [
                100 /* FunctionKeyword */ ,
                80 /* Identifier */ 
            ], [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            // Template string
            rule("NoSpaceBetweenTagAndTemplateString", [
                80 /* Identifier */ ,
                22 /* CloseParenToken */ 
            ], [
                15 /* NoSubstitutionTemplateLiteral */ ,
                16 /* TemplateHead */ 
            ], [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // JSX opening elements
            rule("SpaceBeforeJsxAttribute", anyToken, 80 /* Identifier */ , [
                isNextTokenParentJsxAttribute,
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeSlashInJsxOpeningElement", anyToken, 44 /* SlashToken */ , [
                isJsxSelfClosingElementContext,
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeGreaterThanTokenInJsxOpeningElement", 44 /* SlashToken */ , 32 /* GreaterThanToken */ , [
                isJsxSelfClosingElementContext,
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeEqualInJsxAttribute", anyToken, 64 /* EqualsToken */ , [
                isJsxAttributeContext,
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterEqualInJsxAttribute", 64 /* EqualsToken */ , anyToken, [
                isJsxAttributeContext,
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // TypeScript-specific rules
            // Use of module as a function call. e.g.: import m2 = module("m2");
            rule("NoSpaceAfterModuleImport", [
                144 /* ModuleKeyword */ ,
                149 /* RequireKeyword */ 
            ], 21 /* OpenParenToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Add a space around certain TypeScript keywords
            rule("SpaceAfterCertainTypeScriptKeywords", [
                128 /* AbstractKeyword */ ,
                129 /* AccessorKeyword */ ,
                86 /* ClassKeyword */ ,
                138 /* DeclareKeyword */ ,
                90 /* DefaultKeyword */ ,
                94 /* EnumKeyword */ ,
                95 /* ExportKeyword */ ,
                96 /* ExtendsKeyword */ ,
                139 /* GetKeyword */ ,
                119 /* ImplementsKeyword */ ,
                102 /* ImportKeyword */ ,
                120 /* InterfaceKeyword */ ,
                144 /* ModuleKeyword */ ,
                145 /* NamespaceKeyword */ ,
                123 /* PrivateKeyword */ ,
                125 /* PublicKeyword */ ,
                124 /* ProtectedKeyword */ ,
                148 /* ReadonlyKeyword */ ,
                153 /* SetKeyword */ ,
                126 /* StaticKeyword */ ,
                156 /* TypeKeyword */ ,
                160 /* FromKeyword */ ,
                143 /* KeyOfKeyword */ ,
                140 /* InferKeyword */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeCertainTypeScriptKeywords", anyToken, [
                96 /* ExtendsKeyword */ ,
                119 /* ImplementsKeyword */ ,
                160 /* FromKeyword */ 
            ], [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            // Treat string literals in module names as identifiers, and add a space between the literal and the opening Brace braces, e.g.: module "m2" {
            rule("SpaceAfterModuleName", 11 /* StringLiteral */ , 19 /* OpenBraceToken */ , [
                isModuleDeclContext
            ], 4 /* InsertSpace */ ),
            // Lambda expressions
            rule("SpaceBeforeArrow", anyToken, 39 /* EqualsGreaterThanToken */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterArrow", 39 /* EqualsGreaterThanToken */ , anyToken, [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            // Optional parameters and let args
            rule("NoSpaceAfterEllipsis", 26 /* DotDotDotToken */ , 80 /* Identifier */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterOptionalParameters", 58 /* QuestionToken */ , [
                22 /* CloseParenToken */ ,
                28 /* CommaToken */ 
            ], [
                isNonJsxSameLineTokenContext,
                isNotBinaryOpContext
            ], 16 /* DeleteSpace */ ),
            // Remove spaces in empty interface literals. e.g.: x: {}
            rule("NoSpaceBetweenEmptyInterfaceBraceBrackets", 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , [
                isNonJsxSameLineTokenContext,
                isObjectTypeContext
            ], 16 /* DeleteSpace */ ),
            // generics and type assertions
            rule("NoSpaceBeforeOpenAngularBracket", typeNames, 30 /* LessThanToken */ , [
                isNonJsxSameLineTokenContext,
                isTypeArgumentOrParameterOrAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBetweenCloseParenAndAngularBracket", 22 /* CloseParenToken */ , 30 /* LessThanToken */ , [
                isNonJsxSameLineTokenContext,
                isTypeArgumentOrParameterOrAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterOpenAngularBracket", 30 /* LessThanToken */ , anyToken, [
                isNonJsxSameLineTokenContext,
                isTypeArgumentOrParameterOrAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeCloseAngularBracket", anyToken, 32 /* GreaterThanToken */ , [
                isNonJsxSameLineTokenContext,
                isTypeArgumentOrParameterOrAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterCloseAngularBracket", 32 /* GreaterThanToken */ , [
                21 /* OpenParenToken */ ,
                23 /* OpenBracketToken */ ,
                32 /* GreaterThanToken */ ,
                28 /* CommaToken */ 
            ], [
                isNonJsxSameLineTokenContext,
                isTypeArgumentOrParameterOrAssertionContext,
                isNotFunctionDeclContext,
                isNonTypeAssertionContext
            ], 16 /* DeleteSpace */ ),
            // decorators
            rule("SpaceBeforeAt", [
                22 /* CloseParenToken */ ,
                80 /* Identifier */ 
            ], 60 /* AtToken */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterAt", 60 /* AtToken */ , anyToken, [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after @ in decorator
            rule("SpaceAfterDecorator", anyToken, [
                128 /* AbstractKeyword */ ,
                80 /* Identifier */ ,
                95 /* ExportKeyword */ ,
                90 /* DefaultKeyword */ ,
                86 /* ClassKeyword */ ,
                126 /* StaticKeyword */ ,
                125 /* PublicKeyword */ ,
                123 /* PrivateKeyword */ ,
                124 /* ProtectedKeyword */ ,
                139 /* GetKeyword */ ,
                153 /* SetKeyword */ ,
                23 /* OpenBracketToken */ ,
                42 /* AsteriskToken */ 
            ], [
                isEndOfDecoratorContextOnSameLine
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeNonNullAssertionOperator", anyToken, 54 /* ExclamationToken */ , [
                isNonJsxSameLineTokenContext,
                isNonNullAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterNewKeywordOnConstructorSignature", 105 /* NewKeyword */ , 21 /* OpenParenToken */ , [
                isNonJsxSameLineTokenContext,
                isConstructorSignatureContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceLessThanAndNonJSXTypeAnnotation", 30 /* LessThanToken */ , 30 /* LessThanToken */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ )
        ];
        const userConfigurableRules = [
            // Treat constructor as an identifier in a function declaration, and remove spaces between constructor and following left parentheses
            rule("SpaceAfterConstructor", 137 /* ConstructorKeyword */ , 21 /* OpenParenToken */ , [
                isOptionEnabled("insertSpaceAfterConstructor"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterConstructor", 137 /* ConstructorKeyword */ , 21 /* OpenParenToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterConstructor"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceAfterComma", 28 /* CommaToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterCommaDelimiter"),
                isNonJsxSameLineTokenContext,
                isNonJsxElementOrFragmentContext,
                isNextTokenNotCloseBracket,
                isNextTokenNotCloseParen
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterComma", 28 /* CommaToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterCommaDelimiter"),
                isNonJsxSameLineTokenContext,
                isNonJsxElementOrFragmentContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after function keyword for anonymous functions
            rule("SpaceAfterAnonymousFunctionKeyword", [
                100 /* FunctionKeyword */ ,
                42 /* AsteriskToken */ 
            ], 21 /* OpenParenToken */ , [
                isOptionEnabled("insertSpaceAfterFunctionKeywordForAnonymousFunctions"),
                isFunctionDeclContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterAnonymousFunctionKeyword", [
                100 /* FunctionKeyword */ ,
                42 /* AsteriskToken */ 
            ], 21 /* OpenParenToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterFunctionKeywordForAnonymousFunctions"),
                isFunctionDeclContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after keywords in control flow statements
            rule("SpaceAfterKeywordInControl", keywords, 21 /* OpenParenToken */ , [
                isOptionEnabled("insertSpaceAfterKeywordsInControlFlowStatements"),
                isControlDeclContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterKeywordInControl", keywords, 21 /* OpenParenToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterKeywordsInControlFlowStatements"),
                isControlDeclContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after opening and before closing nonempty parenthesis
            rule("SpaceAfterOpenParen", 21 /* OpenParenToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeCloseParen", anyToken, 22 /* CloseParenToken */ , [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBetweenOpenParens", 21 /* OpenParenToken */ , 21 /* OpenParenToken */ , [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenParens", 21 /* OpenParenToken */ , 22 /* CloseParenToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterOpenParen", 21 /* OpenParenToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeCloseParen", anyToken, 22 /* CloseParenToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after opening and before closing nonempty brackets
            rule("SpaceAfterOpenBracket", 23 /* OpenBracketToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeCloseBracket", anyToken, 24 /* CloseBracketToken */ , [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenBrackets", 23 /* OpenBracketToken */ , 24 /* CloseBracketToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterOpenBracket", 23 /* OpenBracketToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeCloseBracket", anyToken, 24 /* CloseBracketToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Insert a space after { and before } in single-line contexts, but remove space from empty object literals {}.
            rule("SpaceAfterOpenBrace", 19 /* OpenBraceToken */ , anyToken, [
                isOptionEnabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"),
                isBraceWrappedContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeCloseBrace", anyToken, 20 /* CloseBraceToken */ , [
                isOptionEnabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"),
                isBraceWrappedContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenEmptyBraceBrackets", 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , [
                isNonJsxSameLineTokenContext,
                isObjectContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterOpenBrace", 19 /* OpenBraceToken */ , anyToken, [
                isOptionDisabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeCloseBrace", anyToken, 20 /* CloseBraceToken */ , [
                isOptionDisabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Insert a space after opening and before closing empty brace brackets
            rule("SpaceBetweenEmptyBraceBrackets", 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingEmptyBraces")
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenEmptyBraceBrackets", 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , [
                isOptionDisabled("insertSpaceAfterOpeningAndBeforeClosingEmptyBraces"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after opening and before closing template string braces
            rule("SpaceAfterTemplateHeadAndMiddle", [
                16 /* TemplateHead */ ,
                17 /* TemplateMiddle */ 
            ], anyToken, [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"),
                isNonJsxTextContext
            ], 4 /* InsertSpace */ , 1 /* CanDeleteNewLines */ ),
            rule("SpaceBeforeTemplateMiddleAndTail", anyToken, [
                17 /* TemplateMiddle */ ,
                18 /* TemplateTail */ 
            ], [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterTemplateHeadAndMiddle", [
                16 /* TemplateHead */ ,
                17 /* TemplateMiddle */ 
            ], anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"),
                isNonJsxTextContext
            ], 16 /* DeleteSpace */ , 1 /* CanDeleteNewLines */ ),
            rule("NoSpaceBeforeTemplateMiddleAndTail", anyToken, [
                17 /* TemplateMiddle */ ,
                18 /* TemplateTail */ 
            ], [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // No space after { and before } in JSX expression
            rule("SpaceAfterOpenBraceInJsxExpression", 19 /* OpenBraceToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"),
                isNonJsxSameLineTokenContext,
                isJsxExpressionContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeCloseBraceInJsxExpression", anyToken, 20 /* CloseBraceToken */ , [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"),
                isNonJsxSameLineTokenContext,
                isJsxExpressionContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterOpenBraceInJsxExpression", 19 /* OpenBraceToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"),
                isNonJsxSameLineTokenContext,
                isJsxExpressionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeCloseBraceInJsxExpression", anyToken, 20 /* CloseBraceToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"),
                isNonJsxSameLineTokenContext,
                isJsxExpressionContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after semicolon in for statement
            rule("SpaceAfterSemicolonInFor", 27 /* SemicolonToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterSemicolonInForStatements"),
                isNonJsxSameLineTokenContext,
                isForContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterSemicolonInFor", 27 /* SemicolonToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterSemicolonInForStatements"),
                isNonJsxSameLineTokenContext,
                isForContext
            ], 16 /* DeleteSpace */ ),
            // Insert space before and after binary operators
            rule("SpaceBeforeBinaryOperator", anyToken, binaryOperators, [
                isOptionEnabled("insertSpaceBeforeAndAfterBinaryOperators"),
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterBinaryOperator", binaryOperators, anyToken, [
                isOptionEnabled("insertSpaceBeforeAndAfterBinaryOperators"),
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeBinaryOperator", anyToken, binaryOperators, [
                isOptionDisabledOrUndefined("insertSpaceBeforeAndAfterBinaryOperators"),
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterBinaryOperator", binaryOperators, anyToken, [
                isOptionDisabledOrUndefined("insertSpaceBeforeAndAfterBinaryOperators"),
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceBeforeOpenParenInFuncDecl", anyToken, 21 /* OpenParenToken */ , [
                isOptionEnabled("insertSpaceBeforeFunctionParenthesis"),
                isNonJsxSameLineTokenContext,
                isFunctionDeclContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeOpenParenInFuncDecl", anyToken, 21 /* OpenParenToken */ , [
                isOptionDisabledOrUndefined("insertSpaceBeforeFunctionParenthesis"),
                isNonJsxSameLineTokenContext,
                isFunctionDeclContext
            ], 16 /* DeleteSpace */ ),
            // Open Brace braces after control block
            rule("NewLineBeforeOpenBraceInControl", controlOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionEnabled("placeOpenBraceOnNewLineForControlBlocks"),
                isControlDeclContext,
                isBeforeMultilineBlockContext
            ], 8 /* InsertNewLine */ , 1 /* CanDeleteNewLines */ ),
            // Open Brace braces after function
            // TypeScript: Function can have return types, which can be made of tons of different token kinds
            rule("NewLineBeforeOpenBraceInFunction", functionOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionEnabled("placeOpenBraceOnNewLineForFunctions"),
                isFunctionDeclContext,
                isBeforeMultilineBlockContext
            ], 8 /* InsertNewLine */ , 1 /* CanDeleteNewLines */ ),
            // Open Brace braces after TypeScript module/class/interface
            rule("NewLineBeforeOpenBraceInTypeScriptDeclWithBlock", typeScriptOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionEnabled("placeOpenBraceOnNewLineForFunctions"),
                isTypeScriptDeclWithBlockContext,
                isBeforeMultilineBlockContext
            ], 8 /* InsertNewLine */ , 1 /* CanDeleteNewLines */ ),
            rule("SpaceAfterTypeAssertion", 32 /* GreaterThanToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterTypeAssertion"),
                isNonJsxSameLineTokenContext,
                isTypeAssertionContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterTypeAssertion", 32 /* GreaterThanToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterTypeAssertion"),
                isNonJsxSameLineTokenContext,
                isTypeAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceBeforeTypeAnnotation", anyToken, [
                58 /* QuestionToken */ ,
                59 /* ColonToken */ 
            ], [
                isOptionEnabled("insertSpaceBeforeTypeAnnotation"),
                isNonJsxSameLineTokenContext,
                isTypeAnnotationContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeTypeAnnotation", anyToken, [
                58 /* QuestionToken */ ,
                59 /* ColonToken */ 
            ], [
                isOptionDisabledOrUndefined("insertSpaceBeforeTypeAnnotation"),
                isNonJsxSameLineTokenContext,
                isTypeAnnotationContext
            ], 16 /* DeleteSpace */ ),
            rule("NoOptionalSemicolon", 27 /* SemicolonToken */ , anyTokenIncludingEOF, [
                optionEquals("semicolons", "remove" /* Remove */ ),
                isSemicolonDeletionContext
            ], 32 /* DeleteToken */ ),
            rule("OptionalSemicolon", anyToken, anyTokenIncludingEOF, [
                optionEquals("semicolons", "insert" /* Insert */ ),
                isSemicolonInsertionContext
            ], 64 /* InsertTrailingSemicolon */ )
        ];
        const lowPriorityCommonRules = [
            // Space after keyword but not before ; or : or ?
            rule("NoSpaceBeforeSemicolon", anyToken, 27 /* SemicolonToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceBeforeOpenBraceInControl", controlOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForControlBlocks"),
                isControlDeclContext,
                isNotFormatOnEnter,
                isSameLineTokenOrBeforeBlockContext
            ], 4 /* InsertSpace */ , 1 /* CanDeleteNewLines */ ),
            rule("SpaceBeforeOpenBraceInFunction", functionOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForFunctions"),
                isFunctionDeclContext,
                isBeforeBlockContext,
                isNotFormatOnEnter,
                isSameLineTokenOrBeforeBlockContext
            ], 4 /* InsertSpace */ , 1 /* CanDeleteNewLines */ ),
            rule("SpaceBeforeOpenBraceInTypeScriptDeclWithBlock", typeScriptOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForFunctions"),
                isTypeScriptDeclWithBlockContext,
                isNotFormatOnEnter,
                isSameLineTokenOrBeforeBlockContext
            ], 4 /* InsertSpace */ , 1 /* CanDeleteNewLines */ ),
            rule("NoSpaceBeforeComma", anyToken, 28 /* CommaToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // No space before and after indexer `x[]`
            rule("NoSpaceBeforeOpenBracket", anyTokenExcept(134 /* AsyncKeyword */ , 84 /* CaseKeyword */ ), 23 /* OpenBracketToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterCloseBracket", 24 /* CloseBracketToken */ , anyToken, [
                isNonJsxSameLineTokenContext,
                isNotBeforeBlockInFunctionDeclarationContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceAfterSemicolon", 27 /* SemicolonToken */ , anyToken, [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            // Remove extra space between for and await
            rule("SpaceBetweenForAndAwaitKeyword", 99 /* ForKeyword */ , 135 /* AwaitKeyword */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            // Add a space between statements. All keywords except (do,else,case) has open/close parens after them.
            // So, we have a rule to add a space for [),Any], [do,Any], [else,Any], and [case,Any]
            rule("SpaceBetweenStatements", [
                22 /* CloseParenToken */ ,
                92 /* DoKeyword */ ,
                93 /* ElseKeyword */ ,
                84 /* CaseKeyword */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext,
                isNonJsxElementOrFragmentContext,
                isNotForContext
            ], 4 /* InsertSpace */ ),
            // This low-pri rule takes care of "try {", "catch {" and "finally {" in case the rule SpaceBeforeOpenBraceInControl didn't execute on FormatOnEnter.
            rule("SpaceAfterTryCatchFinally", [
                113 /* TryKeyword */ ,
                85 /* CatchKeyword */ ,
                98 /* FinallyKeyword */ 
            ], 19 /* OpenBraceToken */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ )
        ];
        return [
            ...highPriorityCommonRules,
            ...userConfigurableRules,
            ...lowPriorityCommonRules
        ];
    }
    function rule(debugName, left, right, context, action, flags = 0 /* None */ ) {
        return {
            leftTokenRange: toTokenRange(left),
            rightTokenRange: toTokenRange(right),
            rule: {
                debugName: debugName,
                context: context,
                action: action,
                flags: flags
            }
        };
    }
    function tokenRangeFrom(tokens) {
        return {
            tokens: tokens,
            isSpecific: true
        };
    }
    function toTokenRange(arg) {
        return typeof arg === "number" ? tokenRangeFrom([
            arg
        ]) : isArray(arg) ? tokenRangeFrom(arg) : arg;
    }
    function tokenRangeFromRange(from, to, except = []) {
        const tokens = [];
        for(let token = from; token <= to; token++)if (!contains(except, token)) tokens.push(token);
        return tokenRangeFrom(tokens);
    }
    function optionEquals(optionName, optionValue) {
        return (context)=>context.options && context.options[optionName] === optionValue;
    }
    function isOptionEnabled(optionName) {
        return (context)=>context.options && hasProperty(context.options, optionName) && !!context.options[optionName];
    }
    function isOptionDisabled(optionName) {
        return (context)=>context.options && hasProperty(context.options, optionName) && !context.options[optionName];
    }
    function isOptionDisabledOrUndefined(optionName) {
        return (context)=>!context.options || !hasProperty(context.options, optionName) || !context.options[optionName];
    }
    function isOptionDisabledOrUndefinedOrTokensOnSameLine(optionName) {
        return (context)=>!context.options || !hasProperty(context.options, optionName) || !context.options[optionName] || context.TokensAreOnSameLine();
    }
    function isOptionEnabledOrUndefined(optionName) {
        return (context)=>!context.options || !hasProperty(context.options, optionName) || !!context.options[optionName];
    }
    function isForContext(context) {
        return context.contextNode.kind === 247 /* ForStatement */ ;
    }
    function isNotForContext(context) {
        return !isForContext(context);
    }
    function isBinaryOpContext(context) {
        switch(context.contextNode.kind){
            case 225 /* BinaryExpression */ :
                return context.contextNode.operatorToken.kind !== 28 /* CommaToken */ ;
            case 226 /* ConditionalExpression */ :
            case 193 /* ConditionalType */ :
            case 233 /* AsExpression */ :
            case 280 /* ExportSpecifier */ :
            case 275 /* ImportSpecifier */ :
            case 181 /* TypePredicate */ :
            case 191 /* UnionType */ :
            case 192 /* IntersectionType */ :
            case 237 /* SatisfiesExpression */ :
                return true;
            case 207 /* BindingElement */ :
            case 264 /* TypeAliasDeclaration */ :
            case 270 /* ImportEqualsDeclaration */ :
            case 276 /* ExportAssignment */ :
            case 259 /* VariableDeclaration */ :
            case 168 /* Parameter */ :
            case 305 /* EnumMember */ :
            case 171 /* PropertyDeclaration */ :
            case 170 /* PropertySignature */ :
                return context.currentTokenSpan.kind === 64 /* EqualsToken */  || context.nextTokenSpan.kind === 64 /* EqualsToken */ ;
            case 248 /* ForInStatement */ :
            case 167 /* TypeParameter */ :
                return context.currentTokenSpan.kind === 103 /* InKeyword */  || context.nextTokenSpan.kind === 103 /* InKeyword */  || context.currentTokenSpan.kind === 64 /* EqualsToken */  || context.nextTokenSpan.kind === 64 /* EqualsToken */ ;
            case 249 /* ForOfStatement */ :
                return context.currentTokenSpan.kind === 164 /* OfKeyword */  || context.nextTokenSpan.kind === 164 /* OfKeyword */ ;
        }
        return false;
    }
    function isNotBinaryOpContext(context) {
        return !isBinaryOpContext(context);
    }
    function isNotTypeAnnotationContext(context) {
        return !isTypeAnnotationContext(context);
    }
    function isTypeAnnotationContext(context) {
        const contextKind = context.contextNode.kind;
        return contextKind === 171 /* PropertyDeclaration */  || contextKind === 170 /* PropertySignature */  || contextKind === 168 /* Parameter */  || contextKind === 259 /* VariableDeclaration */  || isFunctionLikeKind(contextKind);
    }
    function isConditionalOperatorContext(context) {
        return context.contextNode.kind === 226 /* ConditionalExpression */  || context.contextNode.kind === 193 /* ConditionalType */ ;
    }
    function isSameLineTokenOrBeforeBlockContext(context) {
        return context.TokensAreOnSameLine() || isBeforeBlockContext(context);
    }
    function isBraceWrappedContext(context) {
        return context.contextNode.kind === 205 /* ObjectBindingPattern */  || context.contextNode.kind === 199 /* MappedType */  || isSingleLineBlockContext(context);
    }
    function isBeforeMultilineBlockContext(context) {
        return isBeforeBlockContext(context) && !(context.NextNodeAllOnSameLine() || context.NextNodeBlockIsOnOneLine());
    }
    function isMultilineBlockContext(context) {
        return isBlockContext(context) && !(context.ContextNodeAllOnSameLine() || context.ContextNodeBlockIsOnOneLine());
    }
    function isSingleLineBlockContext(context) {
        return isBlockContext(context) && (context.ContextNodeAllOnSameLine() || context.ContextNodeBlockIsOnOneLine());
    }
    function isBlockContext(context) {
        return nodeIsBlockContext(context.contextNode);
    }
    function isBeforeBlockContext(context) {
        return nodeIsBlockContext(context.nextTokenParent);
    }
    function nodeIsBlockContext(node) {
        if (nodeIsTypeScriptDeclWithBlockContext(node)) return true;
        switch(node.kind){
            case 240 /* Block */ :
            case 268 /* CaseBlock */ :
            case 209 /* ObjectLiteralExpression */ :
            case 267 /* ModuleBlock */ :
                return true;
        }
        return false;
    }
    function isFunctionDeclContext(context) {
        switch(context.contextNode.kind){
            case 261 /* FunctionDeclaration */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
            case 178 /* CallSignature */ :
            case 217 /* FunctionExpression */ :
            case 175 /* Constructor */ :
            case 218 /* ArrowFunction */ :
            case 263 /* InterfaceDeclaration */ :
                return true;
        }
        return false;
    }
    function isNotFunctionDeclContext(context) {
        return !isFunctionDeclContext(context);
    }
    function isFunctionDeclarationOrFunctionExpressionContext(context) {
        return context.contextNode.kind === 261 /* FunctionDeclaration */  || context.contextNode.kind === 217 /* FunctionExpression */ ;
    }
    function isTypeScriptDeclWithBlockContext(context) {
        return nodeIsTypeScriptDeclWithBlockContext(context.contextNode);
    }
    function nodeIsTypeScriptDeclWithBlockContext(node) {
        switch(node.kind){
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
            case 263 /* InterfaceDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 186 /* TypeLiteral */ :
            case 266 /* ModuleDeclaration */ :
            case 277 /* ExportDeclaration */ :
            case 278 /* NamedExports */ :
            case 271 /* ImportDeclaration */ :
            case 274 /* NamedImports */ :
                return true;
        }
        return false;
    }
    function isAfterCodeBlockContext(context) {
        switch(context.currentTokenParent.kind){
            case 262 /* ClassDeclaration */ :
            case 266 /* ModuleDeclaration */ :
            case 265 /* EnumDeclaration */ :
            case 298 /* CatchClause */ :
            case 267 /* ModuleBlock */ :
            case 254 /* SwitchStatement */ :
                return true;
            case 240 /* Block */ :
                {
                    const blockParent = context.currentTokenParent.parent;
                    if (!blockParent || blockParent.kind !== 218 /* ArrowFunction */  && blockParent.kind !== 217 /* FunctionExpression */ ) return true;
                }
        }
        return false;
    }
    function isControlDeclContext(context) {
        switch(context.contextNode.kind){
            case 244 /* IfStatement */ :
            case 254 /* SwitchStatement */ :
            case 247 /* ForStatement */ :
            case 248 /* ForInStatement */ :
            case 249 /* ForOfStatement */ :
            case 246 /* WhileStatement */ :
            case 257 /* TryStatement */ :
            case 245 /* DoStatement */ :
            case 253 /* WithStatement */ :
            case 298 /* CatchClause */ :
                return true;
            default:
                return false;
        }
    }
    function isObjectContext(context) {
        return context.contextNode.kind === 209 /* ObjectLiteralExpression */ ;
    }
    function isFunctionCallContext(context) {
        return context.contextNode.kind === 212 /* CallExpression */ ;
    }
    function isNewContext(context) {
        return context.contextNode.kind === 213 /* NewExpression */ ;
    }
    function isFunctionCallOrNewContext(context) {
        return isFunctionCallContext(context) || isNewContext(context);
    }
    function isPreviousTokenNotComma(context) {
        return context.currentTokenSpan.kind !== 28 /* CommaToken */ ;
    }
    function isNextTokenNotCloseBracket(context) {
        return context.nextTokenSpan.kind !== 24 /* CloseBracketToken */ ;
    }
    function isNextTokenNotCloseParen(context) {
        return context.nextTokenSpan.kind !== 22 /* CloseParenToken */ ;
    }
    function isArrowFunctionContext(context) {
        return context.contextNode.kind === 218 /* ArrowFunction */ ;
    }
    function isImportTypeContext(context) {
        return context.contextNode.kind === 204 /* ImportType */ ;
    }
    function isNonJsxSameLineTokenContext(context) {
        return context.TokensAreOnSameLine() && context.contextNode.kind !== 12 /* JsxText */ ;
    }
    function isNonJsxTextContext(context) {
        return context.contextNode.kind !== 12 /* JsxText */ ;
    }
    function isNonJsxElementOrFragmentContext(context) {
        return context.contextNode.kind !== 283 /* JsxElement */  && context.contextNode.kind !== 287 /* JsxFragment */ ;
    }
    function isJsxExpressionContext(context) {
        return context.contextNode.kind === 293 /* JsxExpression */  || context.contextNode.kind === 292 /* JsxSpreadAttribute */ ;
    }
    function isNextTokenParentJsxAttribute(context) {
        return context.nextTokenParent.kind === 290 /* JsxAttribute */ ;
    }
    function isJsxAttributeContext(context) {
        return context.contextNode.kind === 290 /* JsxAttribute */ ;
    }
    function isJsxSelfClosingElementContext(context) {
        return context.contextNode.kind === 284 /* JsxSelfClosingElement */ ;
    }
    function isNotBeforeBlockInFunctionDeclarationContext(context) {
        return !isFunctionDeclContext(context) && !isBeforeBlockContext(context);
    }
    function isEndOfDecoratorContextOnSameLine(context) {
        return context.TokensAreOnSameLine() && hasDecorators(context.contextNode) && nodeIsInDecoratorContext(context.currentTokenParent) && !nodeIsInDecoratorContext(context.nextTokenParent);
    }
    function nodeIsInDecoratorContext(node) {
        while(node && isExpression(node))node = node.parent;
        return node && node.kind === 169 /* Decorator */ ;
    }
    function isStartOfVariableDeclarationList(context) {
        return context.currentTokenParent.kind === 260 /* VariableDeclarationList */  && context.currentTokenParent.getStart(context.sourceFile) === context.currentTokenSpan.pos;
    }
    function isNotFormatOnEnter(context) {
        return context.formattingRequestKind !== 2 /* FormatOnEnter */ ;
    }
    function isModuleDeclContext(context) {
        return context.contextNode.kind === 266 /* ModuleDeclaration */ ;
    }
    function isObjectTypeContext(context) {
        return context.contextNode.kind === 186 /* TypeLiteral */ ;
    }
    function isConstructorSignatureContext(context) {
        return context.contextNode.kind === 179 /* ConstructSignature */ ;
    }
    function isTypeArgumentOrParameterOrAssertion(token, parent2) {
        if (token.kind !== 30 /* LessThanToken */  && token.kind !== 32 /* GreaterThanToken */ ) return false;
        switch(parent2.kind){
            case 182 /* TypeReference */ :
            case 215 /* TypeAssertionExpression */ :
            case 264 /* TypeAliasDeclaration */ :
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
            case 263 /* InterfaceDeclaration */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 218 /* ArrowFunction */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 178 /* CallSignature */ :
            case 179 /* ConstructSignature */ :
            case 212 /* CallExpression */ :
            case 213 /* NewExpression */ :
            case 232 /* ExpressionWithTypeArguments */ :
                return true;
            default:
                return false;
        }
    }
    function isTypeArgumentOrParameterOrAssertionContext(context) {
        return isTypeArgumentOrParameterOrAssertion(context.currentTokenSpan, context.currentTokenParent) || isTypeArgumentOrParameterOrAssertion(context.nextTokenSpan, context.nextTokenParent);
    }
    function isTypeAssertionContext(context) {
        return context.contextNode.kind === 215 /* TypeAssertionExpression */ ;
    }
    function isNonTypeAssertionContext(context) {
        return !isTypeAssertionContext(context);
    }
    function isVoidOpContext(context) {
        return context.currentTokenSpan.kind === 116 /* VoidKeyword */  && context.currentTokenParent.kind === 221 /* VoidExpression */ ;
    }
    function isYieldOrYieldStarWithOperand(context) {
        return context.contextNode.kind === 228 /* YieldExpression */  && context.contextNode.expression !== void 0;
    }
    function isNonNullAssertionContext(context) {
        return context.contextNode.kind === 234 /* NonNullExpression */ ;
    }
    function isNotStatementConditionContext(context) {
        return !isStatementConditionContext(context);
    }
    function isStatementConditionContext(context) {
        switch(context.contextNode.kind){
            case 244 /* IfStatement */ :
            case 247 /* ForStatement */ :
            case 248 /* ForInStatement */ :
            case 249 /* ForOfStatement */ :
            case 245 /* DoStatement */ :
            case 246 /* WhileStatement */ :
                return true;
            default:
                return false;
        }
    }
    function isSemicolonDeletionContext(context) {
        let nextTokenKind = context.nextTokenSpan.kind;
        let nextTokenStart = context.nextTokenSpan.pos;
        if (isTrivia(nextTokenKind)) {
            const nextRealToken = context.nextTokenParent === context.currentTokenParent ? findNextToken(context.currentTokenParent, findAncestor(context.currentTokenParent, (a)=>!a.parent), context.sourceFile) : context.nextTokenParent.getFirstToken(context.sourceFile);
            if (!nextRealToken) return true;
            nextTokenKind = nextRealToken.kind;
            nextTokenStart = nextRealToken.getStart(context.sourceFile);
        }
        const startLine = context.sourceFile.getLineAndCharacterOfPosition(context.currentTokenSpan.pos).line;
        const endLine = context.sourceFile.getLineAndCharacterOfPosition(nextTokenStart).line;
        if (startLine === endLine) return nextTokenKind === 20 /* CloseBraceToken */  || nextTokenKind === 1 /* EndOfFileToken */ ;
        if (nextTokenKind === 239 /* SemicolonClassElement */  || nextTokenKind === 27 /* SemicolonToken */ ) return false;
        if (context.contextNode.kind === 263 /* InterfaceDeclaration */  || context.contextNode.kind === 264 /* TypeAliasDeclaration */ ) return !isPropertySignature(context.currentTokenParent) || !!context.currentTokenParent.type || nextTokenKind !== 21 /* OpenParenToken */ ;
        if (isPropertyDeclaration(context.currentTokenParent)) return !context.currentTokenParent.initializer;
        return context.currentTokenParent.kind !== 247 /* ForStatement */  && context.currentTokenParent.kind !== 241 /* EmptyStatement */  && context.currentTokenParent.kind !== 239 /* SemicolonClassElement */  && nextTokenKind !== 23 /* OpenBracketToken */  && nextTokenKind !== 21 /* OpenParenToken */  && nextTokenKind !== 40 /* PlusToken */  && nextTokenKind !== 41 /* MinusToken */  && nextTokenKind !== 44 /* SlashToken */  && nextTokenKind !== 14 /* RegularExpressionLiteral */  && nextTokenKind !== 28 /* CommaToken */  && nextTokenKind !== 227 /* TemplateExpression */  && nextTokenKind !== 16 /* TemplateHead */  && nextTokenKind !== 15 /* NoSubstitutionTemplateLiteral */  && nextTokenKind !== 25 /* DotToken */ ;
    }
    function isSemicolonInsertionContext(context) {
        return positionIsASICandidate(context.currentTokenSpan.end, context.currentTokenParent, context.sourceFile);
    }
    function isNotPropertyAccessOnIntegerLiteral(context) {
        return !isPropertyAccessExpression(context.contextNode) || !isNumericLiteral(context.contextNode.expression) || context.contextNode.expression.getText().indexOf(".") !== -1;
    }
    var init_rules = __esm({
        "src/services/formatting/rules.ts" () {
            "use strict";
            init_ts4();
            init_ts_formatting();
        }
    });
    // src/services/formatting/rulesMap.ts
    function getFormatContext(options, host) {
        return {
            options: options,
            getRules: getRulesMap(),
            host: host
        };
    }
    function getRulesMap() {
        if (rulesMapCache === void 0) rulesMapCache = createRulesMap(getAllRules());
        return rulesMapCache;
    }
    function getRuleActionExclusion(ruleAction) {
        let mask2 = 0 /* None */ ;
        if (ruleAction & 1 /* StopProcessingSpaceActions */ ) mask2 |= 28 /* ModifySpaceAction */ ;
        if (ruleAction & 2 /* StopProcessingTokenActions */ ) mask2 |= 96 /* ModifyTokenAction */ ;
        if (ruleAction & 28 /* ModifySpaceAction */ ) mask2 |= 28 /* ModifySpaceAction */ ;
        if (ruleAction & 96 /* ModifyTokenAction */ ) mask2 |= 96 /* ModifyTokenAction */ ;
        return mask2;
    }
    function createRulesMap(rules) {
        const map2 = buildMap(rules);
        return (context)=>{
            const bucket = map2[getRuleBucketIndex(context.currentTokenSpan.kind, context.nextTokenSpan.kind)];
            if (bucket) {
                const rules2 = [];
                let ruleActionMask = 0;
                for (const rule2 of bucket){
                    const acceptRuleActions = ~getRuleActionExclusion(ruleActionMask);
                    if (rule2.action & acceptRuleActions && every(rule2.context, (c)=>c(context))) {
                        rules2.push(rule2);
                        ruleActionMask |= rule2.action;
                    }
                }
                if (rules2.length) return rules2;
            }
        };
    }
    function buildMap(rules) {
        const map2 = new Array(mapRowLength * mapRowLength);
        const rulesBucketConstructionStateList = new Array(map2.length);
        for (const rule2 of rules){
            const specificRule = rule2.leftTokenRange.isSpecific && rule2.rightTokenRange.isSpecific;
            for (const left of rule2.leftTokenRange.tokens)for (const right of rule2.rightTokenRange.tokens){
                const index = getRuleBucketIndex(left, right);
                let rulesBucket = map2[index];
                if (rulesBucket === void 0) rulesBucket = map2[index] = [];
                addRule(rulesBucket, rule2.rule, specificRule, rulesBucketConstructionStateList, index);
            }
        }
        return map2;
    }
    function getRuleBucketIndex(row, column) {
        Debug.assert(row <= 164 /* LastKeyword */  && column <= 164 /* LastKeyword */ , "Must compute formatting context from tokens");
        return row * mapRowLength + column;
    }
    function addRule(rules, rule2, specificTokens, constructionState, rulesBucketIndex) {
        const position = rule2.action & 3 /* StopAction */  ? specificTokens ? 0 /* StopRulesSpecific */  : RulesPosition.StopRulesAny : rule2.context !== anyContext ? specificTokens ? RulesPosition.ContextRulesSpecific : RulesPosition.ContextRulesAny : specificTokens ? RulesPosition.NoContextRulesSpecific : RulesPosition.NoContextRulesAny;
        const state = constructionState[rulesBucketIndex] || 0;
        rules.splice(getInsertionIndex(state, position), 0, rule2);
        constructionState[rulesBucketIndex] = increaseInsertionIndex(state, position);
    }
    function getInsertionIndex(indexBitmap, maskPosition) {
        let index = 0;
        for(let pos = 0; pos <= maskPosition; pos += maskBitSize){
            index += indexBitmap & mask;
            indexBitmap >>= maskBitSize;
        }
        return index;
    }
    function increaseInsertionIndex(indexBitmap, maskPosition) {
        const value1 = (indexBitmap >> maskPosition & mask) + 1;
        Debug.assert((value1 & mask) === value1, "Adding more rules into the sub-bucket than allowed. Maximum allowed is 32 rules.");
        return indexBitmap & ~(mask << maskPosition) | value1 << maskPosition;
    }
    var rulesMapCache, maskBitSize, mask, mapRowLength, RulesPosition;
    var init_rulesMap = __esm({
        "src/services/formatting/rulesMap.ts" () {
            "use strict";
            init_ts4();
            init_ts_formatting();
            maskBitSize = 5;
            mask = 31;
            mapRowLength = 165;
            RulesPosition = ((RulesPosition2)=>{
                RulesPosition2[RulesPosition2["StopRulesSpecific"] = 0] = "StopRulesSpecific";
                RulesPosition2[RulesPosition2["StopRulesAny"] = maskBitSize * 1] = "StopRulesAny";
                RulesPosition2[RulesPosition2["ContextRulesSpecific"] = maskBitSize * 2] = "ContextRulesSpecific";
                RulesPosition2[RulesPosition2["ContextRulesAny"] = maskBitSize * 3] = "ContextRulesAny";
                RulesPosition2[RulesPosition2["NoContextRulesSpecific"] = maskBitSize * 4] = "NoContextRulesSpecific";
                RulesPosition2[RulesPosition2["NoContextRulesAny"] = maskBitSize * 5] = "NoContextRulesAny";
                return RulesPosition2;
            })(RulesPosition || {});
        }
    });
    // src/services/formatting/formatting.ts
    function createTextRangeWithKind(pos, end, kind) {
        const textRangeWithKind = {
            pos: pos,
            end: end,
            kind: kind
        };
        if (Debug.isDebugging) Object.defineProperty(textRangeWithKind, "__debugKind", {
            get: ()=>Debug.formatSyntaxKind(kind)
        });
        return textRangeWithKind;
    }
    function formatOnEnter(position, sourceFile, formatContext) {
        const line = sourceFile.getLineAndCharacterOfPosition(position).line;
        if (line === 0) return [];
        let endOfFormatSpan = getEndLinePosition(line, sourceFile);
        while(isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(endOfFormatSpan)))endOfFormatSpan--;
        if (isLineBreak(sourceFile.text.charCodeAt(endOfFormatSpan))) endOfFormatSpan--;
        const span = {
            // get start position for the previous line
            pos: getStartPositionOfLine(line - 1, sourceFile),
            // end value is exclusive so add 1 to the result
            end: endOfFormatSpan + 1
        };
        return formatSpan(span, sourceFile, formatContext, 2 /* FormatOnEnter */ );
    }
    function formatOnSemicolon(position, sourceFile, formatContext) {
        const semicolon = findImmediatelyPrecedingTokenOfKind(position, 27 /* SemicolonToken */ , sourceFile);
        return formatNodeLines(findOutermostNodeWithinListLevel(semicolon), sourceFile, formatContext, 3 /* FormatOnSemicolon */ );
    }
    function formatOnOpeningCurly(position, sourceFile, formatContext) {
        const openingCurly = findImmediatelyPrecedingTokenOfKind(position, 19 /* OpenBraceToken */ , sourceFile);
        if (!openingCurly) return [];
        const curlyBraceRange = openingCurly.parent;
        const outermostNode = findOutermostNodeWithinListLevel(curlyBraceRange);
        const textRange = {
            pos: getLineStartPositionForPosition(outermostNode.getStart(sourceFile), sourceFile),
            // TODO: GH#18217
            end: position
        };
        return formatSpan(textRange, sourceFile, formatContext, 4 /* FormatOnOpeningCurlyBrace */ );
    }
    function formatOnClosingCurly(position, sourceFile, formatContext) {
        const precedingToken = findImmediatelyPrecedingTokenOfKind(position, 20 /* CloseBraceToken */ , sourceFile);
        return formatNodeLines(findOutermostNodeWithinListLevel(precedingToken), sourceFile, formatContext, 5 /* FormatOnClosingCurlyBrace */ );
    }
    function formatDocument(sourceFile, formatContext) {
        const span = {
            pos: 0,
            end: sourceFile.text.length
        };
        return formatSpan(span, sourceFile, formatContext, 0 /* FormatDocument */ );
    }
    function formatSelection(start, end, sourceFile, formatContext) {
        const span = {
            pos: getLineStartPositionForPosition(start, sourceFile),
            end: end
        };
        return formatSpan(span, sourceFile, formatContext, 1 /* FormatSelection */ );
    }
    function findImmediatelyPrecedingTokenOfKind(end, expectedTokenKind, sourceFile) {
        const precedingToken = findPrecedingToken(end, sourceFile);
        return precedingToken && precedingToken.kind === expectedTokenKind && end === precedingToken.getEnd() ? precedingToken : void 0;
    }
    function findOutermostNodeWithinListLevel(node) {
        let current = node;
        while(current && current.parent && current.parent.end === node.end && !isListElement(current.parent, current))current = current.parent;
        return current;
    }
    function isListElement(parent2, node) {
        switch(parent2.kind){
            case 262 /* ClassDeclaration */ :
            case 263 /* InterfaceDeclaration */ :
                return rangeContainsRange(parent2.members, node);
            case 266 /* ModuleDeclaration */ :
                const body = parent2.body;
                return !!body && body.kind === 267 /* ModuleBlock */  && rangeContainsRange(body.statements, node);
            case 311 /* SourceFile */ :
            case 240 /* Block */ :
            case 267 /* ModuleBlock */ :
                return rangeContainsRange(parent2.statements, node);
            case 298 /* CatchClause */ :
                return rangeContainsRange(parent2.block.statements, node);
        }
        return false;
    }
    function findEnclosingNode(range, sourceFile) {
        return find2(sourceFile);
        function find2(n) {
            const candidate = forEachChild(n, (c)=>startEndContainsRange(c.getStart(sourceFile), c.end, range) && c);
            if (candidate) {
                const result = find2(candidate);
                if (result) return result;
            }
            return n;
        }
    }
    function prepareRangeContainsErrorFunction(errors, originalRange) {
        if (!errors.length) return rangeHasNoErrors;
        const sorted = errors.filter((d)=>rangeOverlapsWithStartEnd(originalRange, d.start, d.start + d.length)).sort((e1, e2)=>e1.start - e2.start);
        if (!sorted.length) return rangeHasNoErrors;
        let index = 0;
        return (r)=>{
            while(true){
                if (index >= sorted.length) return false;
                const error = sorted[index];
                if (r.end <= error.start) return false;
                if (startEndOverlapsWithStartEnd(r.pos, r.end, error.start, error.start + error.length)) return true;
                index++;
            }
        };
        function rangeHasNoErrors() {
            return false;
        }
    }
    function getScanStartPosition(enclosingNode, originalRange, sourceFile) {
        const start = enclosingNode.getStart(sourceFile);
        if (start === originalRange.pos && enclosingNode.end === originalRange.end) return start;
        const precedingToken = findPrecedingToken(originalRange.pos, sourceFile);
        if (!precedingToken) return enclosingNode.pos;
        if (precedingToken.end >= originalRange.pos) return enclosingNode.pos;
        return precedingToken.end;
    }
    function getOwnOrInheritedDelta(n, options, sourceFile) {
        let previousLine = -1 /* Unknown */ ;
        let child;
        while(n){
            const line = sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile)).line;
            if (previousLine !== -1 /* Unknown */  && line !== previousLine) break;
            if (SmartIndenter.shouldIndentChildNode(options, n, child, sourceFile)) return options.indentSize;
            previousLine = line;
            child = n;
            n = n.parent;
        }
        return 0;
    }
    function formatNodeGivenIndentation(node, sourceFileLike, languageVariant, initialIndentation, delta, formatContext) {
        const range = {
            pos: node.pos,
            end: node.end
        };
        return getFormattingScanner(sourceFileLike.text, languageVariant, range.pos, range.end, (scanner2)=>formatSpanWorker(range, node, initialIndentation, delta, scanner2, formatContext, 1 /* FormatSelection */ , (_)=>false, // assume that node does not have any errors
            sourceFileLike));
    }
    function formatNodeLines(node, sourceFile, formatContext, requestKind) {
        if (!node) return [];
        const span = {
            pos: getLineStartPositionForPosition(node.getStart(sourceFile), sourceFile),
            end: node.end
        };
        return formatSpan(span, sourceFile, formatContext, requestKind);
    }
    function formatSpan(originalRange, sourceFile, formatContext, requestKind) {
        const enclosingNode = findEnclosingNode(originalRange, sourceFile);
        return getFormattingScanner(sourceFile.text, sourceFile.languageVariant, getScanStartPosition(enclosingNode, originalRange, sourceFile), originalRange.end, (scanner2)=>formatSpanWorker(originalRange, enclosingNode, SmartIndenter.getIndentationForNode(enclosingNode, originalRange, sourceFile, formatContext.options), getOwnOrInheritedDelta(enclosingNode, formatContext.options, sourceFile), scanner2, formatContext, requestKind, prepareRangeContainsErrorFunction(sourceFile.parseDiagnostics, originalRange), sourceFile));
    }
    function formatSpanWorker(originalRange, enclosingNode, initialIndentation, delta, formattingScanner, { options: options , getRules: getRules , host: host  }, requestKind, rangeContainsError, sourceFile) {
        var _a;
        const formattingContext = new FormattingContext(sourceFile, requestKind, options);
        let previousRangeTriviaEnd;
        let previousRange;
        let previousParent;
        let previousRangeStartLine;
        let lastIndentedLine;
        let indentationOnLastIndentedLine = -1 /* Unknown */ ;
        const edits = [];
        formattingScanner.advance();
        if (formattingScanner.isOnToken()) {
            const startLine = sourceFile.getLineAndCharacterOfPosition(enclosingNode.getStart(sourceFile)).line;
            let undecoratedStartLine = startLine;
            if (hasDecorators(enclosingNode)) undecoratedStartLine = sourceFile.getLineAndCharacterOfPosition(getNonDecoratorTokenPosOfNode(enclosingNode, sourceFile)).line;
            processNode(enclosingNode, enclosingNode, startLine, undecoratedStartLine, initialIndentation, delta);
        }
        if (!formattingScanner.isOnToken()) {
            const indentation = SmartIndenter.nodeWillIndentChild(options, enclosingNode, /*child*/ void 0, sourceFile, /*indentByDefault*/ false) ? initialIndentation + options.indentSize : initialIndentation;
            const leadingTrivia = formattingScanner.getCurrentLeadingTrivia();
            if (leadingTrivia) {
                indentTriviaItems(leadingTrivia, indentation, /*indentNextTokenOrTrivia*/ false, (item)=>processRange(item, sourceFile.getLineAndCharacterOfPosition(item.pos), enclosingNode, enclosingNode, /*dynamicIndentation*/ void 0));
                if (options.trimTrailingWhitespace !== false) trimTrailingWhitespacesForRemainingRange(leadingTrivia);
            }
        }
        if (previousRange && formattingScanner.getTokenFullStart() >= originalRange.end) {
            const tokenInfo = formattingScanner.isOnEOF() ? formattingScanner.readEOFTokenRange() : formattingScanner.isOnToken() ? formattingScanner.readTokenInfo(enclosingNode).token : void 0;
            if (tokenInfo && tokenInfo.pos === previousRangeTriviaEnd) {
                const parent2 = ((_a = findPrecedingToken(tokenInfo.end, sourceFile, enclosingNode)) == null ? void 0 : _a.parent) || previousParent;
                processPair(tokenInfo, sourceFile.getLineAndCharacterOfPosition(tokenInfo.pos).line, parent2, previousRange, previousRangeStartLine, previousParent, parent2, /*dynamicIndentation*/ void 0);
            }
        }
        return edits;
        function tryComputeIndentationForListItem(startPos, endPos, parentStartLine, range, inheritedIndentation) {
            if (rangeOverlapsWithStartEnd(range, startPos, endPos) || rangeContainsStartEnd(range, startPos, endPos)) {
                if (inheritedIndentation !== -1 /* Unknown */ ) return inheritedIndentation;
            } else {
                const startLine = sourceFile.getLineAndCharacterOfPosition(startPos).line;
                const startLinePosition = getLineStartPositionForPosition(startPos, sourceFile);
                const column = SmartIndenter.findFirstNonWhitespaceColumn(startLinePosition, startPos, sourceFile, options);
                if (startLine !== parentStartLine || startPos === column) {
                    const baseIndentSize = SmartIndenter.getBaseIndentation(options);
                    return baseIndentSize > column ? baseIndentSize : column;
                }
            }
            return -1 /* Unknown */ ;
        }
        function computeIndentation(node, startLine, inheritedIndentation, parent2, parentDynamicIndentation, effectiveParentStartLine) {
            const delta2 = SmartIndenter.shouldIndentChildNode(options, node) ? options.indentSize : 0;
            if (effectiveParentStartLine === startLine) return {
                indentation: startLine === lastIndentedLine ? indentationOnLastIndentedLine : parentDynamicIndentation.getIndentation(),
                delta: Math.min(options.indentSize, parentDynamicIndentation.getDelta(node) + delta2)
            };
            else if (inheritedIndentation === -1 /* Unknown */ ) {
                if (node.kind === 21 /* OpenParenToken */  && startLine === lastIndentedLine) return {
                    indentation: indentationOnLastIndentedLine,
                    delta: parentDynamicIndentation.getDelta(node)
                };
                else if (SmartIndenter.childStartsOnTheSameLineWithElseInIfStatement(parent2, node, startLine, sourceFile) || SmartIndenter.childIsUnindentedBranchOfConditionalExpression(parent2, node, startLine, sourceFile) || SmartIndenter.argumentStartsOnSameLineAsPreviousArgument(parent2, node, startLine, sourceFile)) return {
                    indentation: parentDynamicIndentation.getIndentation(),
                    delta: delta2
                };
                else return {
                    indentation: parentDynamicIndentation.getIndentation() + parentDynamicIndentation.getDelta(node),
                    delta: delta2
                };
            } else return {
                indentation: inheritedIndentation,
                delta: delta2
            };
        }
        function getFirstNonDecoratorTokenOfNode(node) {
            if (canHaveModifiers(node)) {
                const modifier = find(node.modifiers, isModifier, findIndex(node.modifiers, isDecorator));
                if (modifier) return modifier.kind;
            }
            switch(node.kind){
                case 262 /* ClassDeclaration */ :
                    return 86 /* ClassKeyword */ ;
                case 263 /* InterfaceDeclaration */ :
                    return 120 /* InterfaceKeyword */ ;
                case 261 /* FunctionDeclaration */ :
                    return 100 /* FunctionKeyword */ ;
                case 265 /* EnumDeclaration */ :
                    return 265 /* EnumDeclaration */ ;
                case 176 /* GetAccessor */ :
                    return 139 /* GetKeyword */ ;
                case 177 /* SetAccessor */ :
                    return 153 /* SetKeyword */ ;
                case 173 /* MethodDeclaration */ :
                    if (node.asteriskToken) return 42 /* AsteriskToken */ ;
                case 171 /* PropertyDeclaration */ :
                case 168 /* Parameter */ :
                    const name = getNameOfDeclaration(node);
                    if (name) return name.kind;
            }
        }
        function getDynamicIndentation(node, nodeStartLine, indentation, delta2) {
            return {
                getIndentationForComment: (kind, tokenIndentation, container)=>{
                    switch(kind){
                        case 20 /* CloseBraceToken */ :
                        case 24 /* CloseBracketToken */ :
                        case 22 /* CloseParenToken */ :
                            return indentation + getDelta(container);
                    }
                    return tokenIndentation !== -1 /* Unknown */  ? tokenIndentation : indentation;
                },
                // if list end token is LessThanToken '>' then its delta should be explicitly suppressed
                // so that LessThanToken as a binary operator can still be indented.
                // foo.then
                //     <
                //         number,
                //         string,
                //     >();
                // vs
                // var a = xValue
                //     > yValue;
                getIndentationForToken: (line, kind, container, suppressDelta)=>!suppressDelta && shouldAddDelta(line, kind, container) ? indentation + getDelta(container) : indentation,
                getIndentation: ()=>indentation,
                getDelta: getDelta,
                recomputeIndentation: (lineAdded, parent2)=>{
                    if (SmartIndenter.shouldIndentChildNode(options, parent2, node, sourceFile)) {
                        indentation += lineAdded ? options.indentSize : -options.indentSize;
                        delta2 = SmartIndenter.shouldIndentChildNode(options, node) ? options.indentSize : 0;
                    }
                }
            };
            function shouldAddDelta(line, kind, container) {
                switch(kind){
                    case 19 /* OpenBraceToken */ :
                    case 20 /* CloseBraceToken */ :
                    case 22 /* CloseParenToken */ :
                    case 93 /* ElseKeyword */ :
                    case 117 /* WhileKeyword */ :
                    case 60 /* AtToken */ :
                        return false;
                    case 44 /* SlashToken */ :
                    case 32 /* GreaterThanToken */ :
                        switch(container.kind){
                            case 285 /* JsxOpeningElement */ :
                            case 286 /* JsxClosingElement */ :
                            case 284 /* JsxSelfClosingElement */ :
                                return false;
                        }
                        break;
                    case 23 /* OpenBracketToken */ :
                    case 24 /* CloseBracketToken */ :
                        if (container.kind !== 199 /* MappedType */ ) return false;
                        break;
                }
                return nodeStartLine !== line && !(hasDecorators(node) && kind === getFirstNonDecoratorTokenOfNode(node));
            }
            function getDelta(child) {
                return SmartIndenter.nodeWillIndentChild(options, node, child, sourceFile, /*indentByDefault*/ true) ? delta2 : 0;
            }
        }
        function processNode(node, contextNode, nodeStartLine, undecoratedNodeStartLine, indentation, delta2) {
            if (!rangeOverlapsWithStartEnd(originalRange, node.getStart(sourceFile), node.getEnd())) return;
            const nodeDynamicIndentation = getDynamicIndentation(node, nodeStartLine, indentation, delta2);
            let childContextNode = contextNode;
            forEachChild(node, (child)=>{
                processChildNode(child, /*inheritedIndentation*/ -1 /* Unknown */ , node, nodeDynamicIndentation, nodeStartLine, undecoratedNodeStartLine, /*isListItem*/ false);
            }, (nodes)=>{
                processChildNodes(nodes, node, nodeStartLine, nodeDynamicIndentation);
            });
            while(formattingScanner.isOnToken() && formattingScanner.getTokenFullStart() < originalRange.end){
                const tokenInfo = formattingScanner.readTokenInfo(node);
                if (tokenInfo.token.end > Math.min(node.end, originalRange.end)) break;
                consumeTokenAndAdvanceScanner(tokenInfo, node, nodeDynamicIndentation, node);
            }
            function processChildNode(child, inheritedIndentation, parent2, parentDynamicIndentation, parentStartLine, undecoratedParentStartLine, isListItem, isFirstListItem) {
                Debug.assert(!nodeIsSynthesized(child));
                if (nodeIsMissing(child) || isGrammarError(parent2, child)) return inheritedIndentation;
                const childStartPos = child.getStart(sourceFile);
                const childStartLine = sourceFile.getLineAndCharacterOfPosition(childStartPos).line;
                let undecoratedChildStartLine = childStartLine;
                if (hasDecorators(child)) undecoratedChildStartLine = sourceFile.getLineAndCharacterOfPosition(getNonDecoratorTokenPosOfNode(child, sourceFile)).line;
                let childIndentationAmount = -1 /* Unknown */ ;
                if (isListItem && rangeContainsRange(originalRange, parent2)) {
                    childIndentationAmount = tryComputeIndentationForListItem(childStartPos, child.end, parentStartLine, originalRange, inheritedIndentation);
                    if (childIndentationAmount !== -1 /* Unknown */ ) inheritedIndentation = childIndentationAmount;
                }
                if (!rangeOverlapsWithStartEnd(originalRange, child.pos, child.end)) {
                    if (child.end < originalRange.pos) formattingScanner.skipToEndOf(child);
                    return inheritedIndentation;
                }
                if (child.getFullWidth() === 0) return inheritedIndentation;
                while(formattingScanner.isOnToken() && formattingScanner.getTokenFullStart() < originalRange.end){
                    const tokenInfo = formattingScanner.readTokenInfo(node);
                    if (tokenInfo.token.end > originalRange.end) return inheritedIndentation;
                    if (tokenInfo.token.end > childStartPos) {
                        if (tokenInfo.token.pos > childStartPos) formattingScanner.skipToStartOf(child);
                        break;
                    }
                    consumeTokenAndAdvanceScanner(tokenInfo, node, parentDynamicIndentation, node);
                }
                if (!formattingScanner.isOnToken() || formattingScanner.getTokenFullStart() >= originalRange.end) return inheritedIndentation;
                if (isToken(child)) {
                    const tokenInfo = formattingScanner.readTokenInfo(child);
                    if (child.kind !== 12 /* JsxText */ ) {
                        Debug.assert(tokenInfo.token.end === child.end, "Token end is child end");
                        consumeTokenAndAdvanceScanner(tokenInfo, node, parentDynamicIndentation, child);
                        return inheritedIndentation;
                    }
                }
                const effectiveParentStartLine = child.kind === 169 /* Decorator */  ? childStartLine : undecoratedParentStartLine;
                const childIndentation = computeIndentation(child, childStartLine, childIndentationAmount, node, parentDynamicIndentation, effectiveParentStartLine);
                processNode(child, childContextNode, childStartLine, undecoratedChildStartLine, childIndentation.indentation, childIndentation.delta);
                childContextNode = node;
                if (isFirstListItem && parent2.kind === 208 /* ArrayLiteralExpression */  && inheritedIndentation === -1 /* Unknown */ ) inheritedIndentation = childIndentation.indentation;
                return inheritedIndentation;
            }
            function processChildNodes(nodes, parent2, parentStartLine, parentDynamicIndentation) {
                Debug.assert(isNodeArray(nodes));
                Debug.assert(!nodeIsSynthesized(nodes));
                const listStartToken = getOpenTokenForList(parent2, nodes);
                let listDynamicIndentation = parentDynamicIndentation;
                let startLine = parentStartLine;
                if (!rangeOverlapsWithStartEnd(originalRange, nodes.pos, nodes.end)) {
                    if (nodes.end < originalRange.pos) formattingScanner.skipToEndOf(nodes);
                    return;
                }
                if (listStartToken !== 0 /* Unknown */ ) while(formattingScanner.isOnToken() && formattingScanner.getTokenFullStart() < originalRange.end){
                    const tokenInfo = formattingScanner.readTokenInfo(parent2);
                    if (tokenInfo.token.end > nodes.pos) break;
                    else if (tokenInfo.token.kind === listStartToken) {
                        startLine = sourceFile.getLineAndCharacterOfPosition(tokenInfo.token.pos).line;
                        consumeTokenAndAdvanceScanner(tokenInfo, parent2, parentDynamicIndentation, parent2);
                        let indentationOnListStartToken;
                        if (indentationOnLastIndentedLine !== -1 /* Unknown */ ) indentationOnListStartToken = indentationOnLastIndentedLine;
                        else {
                            const startLinePosition = getLineStartPositionForPosition(tokenInfo.token.pos, sourceFile);
                            indentationOnListStartToken = SmartIndenter.findFirstNonWhitespaceColumn(startLinePosition, tokenInfo.token.pos, sourceFile, options);
                        }
                        listDynamicIndentation = getDynamicIndentation(parent2, parentStartLine, indentationOnListStartToken, options.indentSize);
                    } else consumeTokenAndAdvanceScanner(tokenInfo, parent2, parentDynamicIndentation, parent2);
                }
                let inheritedIndentation = -1 /* Unknown */ ;
                for(let i = 0; i < nodes.length; i++){
                    const child = nodes[i];
                    inheritedIndentation = processChildNode(child, inheritedIndentation, node, listDynamicIndentation, startLine, startLine, /*isListItem*/ true, /*isFirstListItem*/ i === 0);
                }
                const listEndToken = getCloseTokenForOpenToken(listStartToken);
                if (listEndToken !== 0 /* Unknown */  && formattingScanner.isOnToken() && formattingScanner.getTokenFullStart() < originalRange.end) {
                    let tokenInfo = formattingScanner.readTokenInfo(parent2);
                    if (tokenInfo.token.kind === 28 /* CommaToken */ ) {
                        consumeTokenAndAdvanceScanner(tokenInfo, parent2, listDynamicIndentation, parent2);
                        tokenInfo = formattingScanner.isOnToken() ? formattingScanner.readTokenInfo(parent2) : void 0;
                    }
                    if (tokenInfo && tokenInfo.token.kind === listEndToken && rangeContainsRange(parent2, tokenInfo.token)) consumeTokenAndAdvanceScanner(tokenInfo, parent2, listDynamicIndentation, parent2, /*isListEndToken*/ true);
                }
            }
            function consumeTokenAndAdvanceScanner(currentTokenInfo, parent2, dynamicIndentation, container, isListEndToken) {
                Debug.assert(rangeContainsRange(parent2, currentTokenInfo.token));
                const lastTriviaWasNewLine = formattingScanner.lastTrailingTriviaWasNewLine();
                let indentToken = false;
                if (currentTokenInfo.leadingTrivia) processTrivia(currentTokenInfo.leadingTrivia, parent2, childContextNode, dynamicIndentation);
                let lineAction = 0 /* None */ ;
                const isTokenInRange = rangeContainsRange(originalRange, currentTokenInfo.token);
                const tokenStart = sourceFile.getLineAndCharacterOfPosition(currentTokenInfo.token.pos);
                if (isTokenInRange) {
                    const rangeHasError = rangeContainsError(currentTokenInfo.token);
                    const savePreviousRange = previousRange;
                    lineAction = processRange(currentTokenInfo.token, tokenStart, parent2, childContextNode, dynamicIndentation);
                    if (!rangeHasError) {
                        if (lineAction === 0 /* None */ ) {
                            const prevEndLine = savePreviousRange && sourceFile.getLineAndCharacterOfPosition(savePreviousRange.end).line;
                            indentToken = lastTriviaWasNewLine && tokenStart.line !== prevEndLine;
                        } else indentToken = lineAction === 1 /* LineAdded */ ;
                    }
                }
                if (currentTokenInfo.trailingTrivia) {
                    previousRangeTriviaEnd = last(currentTokenInfo.trailingTrivia).end;
                    processTrivia(currentTokenInfo.trailingTrivia, parent2, childContextNode, dynamicIndentation);
                }
                if (indentToken) {
                    const tokenIndentation = isTokenInRange && !rangeContainsError(currentTokenInfo.token) ? dynamicIndentation.getIndentationForToken(tokenStart.line, currentTokenInfo.token.kind, container, !!isListEndToken) : -1 /* Unknown */ ;
                    let indentNextTokenOrTrivia = true;
                    if (currentTokenInfo.leadingTrivia) {
                        const commentIndentation = dynamicIndentation.getIndentationForComment(currentTokenInfo.token.kind, tokenIndentation, container);
                        indentNextTokenOrTrivia = indentTriviaItems(currentTokenInfo.leadingTrivia, commentIndentation, indentNextTokenOrTrivia, (item)=>insertIndentation(item.pos, commentIndentation, /*lineAdded*/ false));
                    }
                    if (tokenIndentation !== -1 /* Unknown */  && indentNextTokenOrTrivia) {
                        insertIndentation(currentTokenInfo.token.pos, tokenIndentation, lineAction === 1 /* LineAdded */ );
                        lastIndentedLine = tokenStart.line;
                        indentationOnLastIndentedLine = tokenIndentation;
                    }
                }
                formattingScanner.advance();
                childContextNode = parent2;
            }
        }
        function indentTriviaItems(trivia, commentIndentation, indentNextTokenOrTrivia, indentSingleLine) {
            for (const triviaItem of trivia){
                const triviaInRange = rangeContainsRange(originalRange, triviaItem);
                switch(triviaItem.kind){
                    case 3 /* MultiLineCommentTrivia */ :
                        if (triviaInRange) indentMultilineComment(triviaItem, commentIndentation, /*firstLineIsIndented*/ !indentNextTokenOrTrivia);
                        indentNextTokenOrTrivia = false;
                        break;
                    case 2 /* SingleLineCommentTrivia */ :
                        if (indentNextTokenOrTrivia && triviaInRange) indentSingleLine(triviaItem);
                        indentNextTokenOrTrivia = false;
                        break;
                    case 4 /* NewLineTrivia */ :
                        indentNextTokenOrTrivia = true;
                        break;
                }
            }
            return indentNextTokenOrTrivia;
        }
        function processTrivia(trivia, parent2, contextNode, dynamicIndentation) {
            for (const triviaItem of trivia)if (isComment(triviaItem.kind) && rangeContainsRange(originalRange, triviaItem)) {
                const triviaItemStart = sourceFile.getLineAndCharacterOfPosition(triviaItem.pos);
                processRange(triviaItem, triviaItemStart, parent2, contextNode, dynamicIndentation);
            }
        }
        function processRange(range, rangeStart, parent2, contextNode, dynamicIndentation) {
            const rangeHasError = rangeContainsError(range);
            let lineAction = 0 /* None */ ;
            if (!rangeHasError) {
                if (!previousRange) {
                    const originalStart = sourceFile.getLineAndCharacterOfPosition(originalRange.pos);
                    trimTrailingWhitespacesForLines(originalStart.line, rangeStart.line);
                } else lineAction = processPair(range, rangeStart.line, parent2, previousRange, previousRangeStartLine, previousParent, contextNode, dynamicIndentation);
            }
            previousRange = range;
            previousRangeTriviaEnd = range.end;
            previousParent = parent2;
            previousRangeStartLine = rangeStart.line;
            return lineAction;
        }
        function processPair(currentItem, currentStartLine, currentParent, previousItem, previousStartLine, previousParent2, contextNode, dynamicIndentation) {
            formattingContext.updateContext(previousItem, previousParent2, currentItem, currentParent, contextNode);
            const rules = getRules(formattingContext);
            let trimTrailingWhitespaces = formattingContext.options.trimTrailingWhitespace !== false;
            let lineAction = 0 /* None */ ;
            if (rules) forEachRight(rules, (rule2)=>{
                lineAction = applyRuleEdits(rule2, previousItem, previousStartLine, currentItem, currentStartLine);
                if (dynamicIndentation) switch(lineAction){
                    case 2 /* LineRemoved */ :
                        if (currentParent.getStart(sourceFile) === currentItem.pos) dynamicIndentation.recomputeIndentation(/*lineAddedByFormatting*/ false, contextNode);
                        break;
                    case 1 /* LineAdded */ :
                        if (currentParent.getStart(sourceFile) === currentItem.pos) dynamicIndentation.recomputeIndentation(/*lineAddedByFormatting*/ true, contextNode);
                        break;
                    default:
                        Debug.assert(lineAction === 0 /* None */ );
                }
                trimTrailingWhitespaces = trimTrailingWhitespaces && !(rule2.action & 16 /* DeleteSpace */ ) && rule2.flags !== 1 /* CanDeleteNewLines */ ;
            });
            else trimTrailingWhitespaces = trimTrailingWhitespaces && currentItem.kind !== 1 /* EndOfFileToken */ ;
            if (currentStartLine !== previousStartLine && trimTrailingWhitespaces) trimTrailingWhitespacesForLines(previousStartLine, currentStartLine, previousItem);
            return lineAction;
        }
        function insertIndentation(pos, indentation, lineAdded) {
            const indentationString = getIndentationString(indentation, options);
            if (lineAdded) recordReplace(pos, 0, indentationString);
            else {
                const tokenStart = sourceFile.getLineAndCharacterOfPosition(pos);
                const startLinePosition = getStartPositionOfLine(tokenStart.line, sourceFile);
                if (indentation !== characterToColumn(startLinePosition, tokenStart.character) || indentationIsDifferent(indentationString, startLinePosition)) recordReplace(startLinePosition, tokenStart.character, indentationString);
            }
        }
        function characterToColumn(startLinePosition, characterInLine) {
            let column = 0;
            for(let i = 0; i < characterInLine; i++)if (sourceFile.text.charCodeAt(startLinePosition + i) === 9 /* tab */ ) column += options.tabSize - column % options.tabSize;
            else column++;
            return column;
        }
        function indentationIsDifferent(indentationString, startLinePosition) {
            return indentationString !== sourceFile.text.substr(startLinePosition, indentationString.length);
        }
        function indentMultilineComment(commentRange, indentation, firstLineIsIndented, indentFinalLine = true) {
            let startLine = sourceFile.getLineAndCharacterOfPosition(commentRange.pos).line;
            const endLine = sourceFile.getLineAndCharacterOfPosition(commentRange.end).line;
            if (startLine === endLine) {
                if (!firstLineIsIndented) insertIndentation(commentRange.pos, indentation, /*lineAdded*/ false);
                return;
            }
            const parts = [];
            let startPos = commentRange.pos;
            for(let line = startLine; line < endLine; line++){
                const endOfLine = getEndLinePosition(line, sourceFile);
                parts.push({
                    pos: startPos,
                    end: endOfLine
                });
                startPos = getStartPositionOfLine(line + 1, sourceFile);
            }
            if (indentFinalLine) parts.push({
                pos: startPos,
                end: commentRange.end
            });
            if (parts.length === 0) return;
            const startLinePos = getStartPositionOfLine(startLine, sourceFile);
            const nonWhitespaceColumnInFirstPart = SmartIndenter.findFirstNonWhitespaceCharacterAndColumn(startLinePos, parts[0].pos, sourceFile, options);
            let startIndex = 0;
            if (firstLineIsIndented) {
                startIndex = 1;
                startLine++;
            }
            const delta2 = indentation - nonWhitespaceColumnInFirstPart.column;
            for(let i = startIndex; i < parts.length; i++, startLine++){
                const startLinePos2 = getStartPositionOfLine(startLine, sourceFile);
                const nonWhitespaceCharacterAndColumn = i === 0 ? nonWhitespaceColumnInFirstPart : SmartIndenter.findFirstNonWhitespaceCharacterAndColumn(parts[i].pos, parts[i].end, sourceFile, options);
                const newIndentation = nonWhitespaceCharacterAndColumn.column + delta2;
                if (newIndentation > 0) {
                    const indentationString = getIndentationString(newIndentation, options);
                    recordReplace(startLinePos2, nonWhitespaceCharacterAndColumn.character, indentationString);
                } else recordDelete(startLinePos2, nonWhitespaceCharacterAndColumn.character);
            }
        }
        function trimTrailingWhitespacesForLines(line1, line2, range) {
            for(let line = line1; line < line2; line++){
                const lineStartPosition = getStartPositionOfLine(line, sourceFile);
                const lineEndPosition = getEndLinePosition(line, sourceFile);
                if (range && (isComment(range.kind) || isStringOrRegularExpressionOrTemplateLiteral(range.kind)) && range.pos <= lineEndPosition && range.end > lineEndPosition) continue;
                const whitespaceStart = getTrailingWhitespaceStartPosition(lineStartPosition, lineEndPosition);
                if (whitespaceStart !== -1) {
                    Debug.assert(whitespaceStart === lineStartPosition || !isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(whitespaceStart - 1)));
                    recordDelete(whitespaceStart, lineEndPosition + 1 - whitespaceStart);
                }
            }
        }
        function getTrailingWhitespaceStartPosition(start, end) {
            let pos = end;
            while(pos >= start && isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(pos)))pos--;
            if (pos !== end) return pos + 1;
            return -1;
        }
        function trimTrailingWhitespacesForRemainingRange(trivias) {
            let startPos = previousRange ? previousRange.end : originalRange.pos;
            for (const trivia of trivias)if (isComment(trivia.kind)) {
                if (startPos < trivia.pos) trimTrailingWitespacesForPositions(startPos, trivia.pos - 1, previousRange);
                startPos = trivia.end + 1;
            }
            if (startPos < originalRange.end) trimTrailingWitespacesForPositions(startPos, originalRange.end, previousRange);
        }
        function trimTrailingWitespacesForPositions(startPos, endPos, previousRange2) {
            const startLine = sourceFile.getLineAndCharacterOfPosition(startPos).line;
            const endLine = sourceFile.getLineAndCharacterOfPosition(endPos).line;
            trimTrailingWhitespacesForLines(startLine, endLine + 1, previousRange2);
        }
        function recordDelete(start, len) {
            if (len) edits.push(createTextChangeFromStartLength(start, len, ""));
        }
        function recordReplace(start, len, newText) {
            if (len || newText) edits.push(createTextChangeFromStartLength(start, len, newText));
        }
        function recordInsert(start, text) {
            if (text) edits.push(createTextChangeFromStartLength(start, 0, text));
        }
        function applyRuleEdits(rule2, previousRange2, previousStartLine, currentRange, currentStartLine) {
            const onLaterLine = currentStartLine !== previousStartLine;
            switch(rule2.action){
                case 1 /* StopProcessingSpaceActions */ :
                    return 0 /* None */ ;
                case 16 /* DeleteSpace */ :
                    if (previousRange2.end !== currentRange.pos) {
                        recordDelete(previousRange2.end, currentRange.pos - previousRange2.end);
                        return onLaterLine ? 2 /* LineRemoved */  : 0 /* None */ ;
                    }
                    break;
                case 32 /* DeleteToken */ :
                    recordDelete(previousRange2.pos, previousRange2.end - previousRange2.pos);
                    break;
                case 8 /* InsertNewLine */ :
                    if (rule2.flags !== 1 /* CanDeleteNewLines */  && previousStartLine !== currentStartLine) return 0 /* None */ ;
                    const lineDelta = currentStartLine - previousStartLine;
                    if (lineDelta !== 1) {
                        recordReplace(previousRange2.end, currentRange.pos - previousRange2.end, getNewLineOrDefaultFromHost(host, options));
                        return onLaterLine ? 0 /* None */  : 1 /* LineAdded */ ;
                    }
                    break;
                case 4 /* InsertSpace */ :
                    if (rule2.flags !== 1 /* CanDeleteNewLines */  && previousStartLine !== currentStartLine) return 0 /* None */ ;
                    const posDelta = currentRange.pos - previousRange2.end;
                    if (posDelta !== 1 || sourceFile.text.charCodeAt(previousRange2.end) !== 32 /* space */ ) {
                        recordReplace(previousRange2.end, currentRange.pos - previousRange2.end, " ");
                        return onLaterLine ? 2 /* LineRemoved */  : 0 /* None */ ;
                    }
                    break;
                case 64 /* InsertTrailingSemicolon */ :
                    recordInsert(previousRange2.end, ";");
            }
            return 0 /* None */ ;
        }
    }
    function getRangeOfEnclosingComment(sourceFile, position, precedingToken, tokenAtPosition = getTokenAtPosition(sourceFile, position)) {
        const jsdoc = findAncestor(tokenAtPosition, isJSDoc);
        if (jsdoc) tokenAtPosition = jsdoc.parent;
        const tokenStart = tokenAtPosition.getStart(sourceFile);
        if (tokenStart <= position && position < tokenAtPosition.getEnd()) return void 0;
        precedingToken = precedingToken === null ? void 0 : precedingToken === void 0 ? findPrecedingToken(position, sourceFile) : precedingToken;
        const trailingRangesOfPreviousToken = precedingToken && getTrailingCommentRanges(sourceFile.text, precedingToken.end);
        const leadingCommentRangesOfNextToken = getLeadingCommentRangesOfNode(tokenAtPosition, sourceFile);
        const commentRanges = concatenate(trailingRangesOfPreviousToken, leadingCommentRangesOfNextToken);
        return commentRanges && find(commentRanges, (range)=>rangeContainsPositionExclusive(range, position) || // The end marker of a single-line comment does not include the newline character.
            // With caret at `^`, in the following case, we are inside a comment (^ denotes the cursor position):
            //
            //    // asdf   ^\n
            //
            // But for closed multi-line comments, we don't want to be inside the comment in the following case:
            //
            //    /* asdf */^
            //
            // However, unterminated multi-line comments *do* contain their end.
            //
            // Internally, we represent the end of the comment at the newline and closing '/', respectively.
            //
            position === range.end && (range.kind === 2 /* SingleLineCommentTrivia */  || position === sourceFile.getFullWidth()));
    }
    function getOpenTokenForList(node, list) {
        switch(node.kind){
            case 175 /* Constructor */ :
            case 261 /* FunctionDeclaration */ :
            case 217 /* FunctionExpression */ :
            case 173 /* MethodDeclaration */ :
            case 172 /* MethodSignature */ :
            case 218 /* ArrowFunction */ :
            case 178 /* CallSignature */ :
            case 179 /* ConstructSignature */ :
            case 183 /* FunctionType */ :
            case 184 /* ConstructorType */ :
            case 176 /* GetAccessor */ :
            case 177 /* SetAccessor */ :
                if (node.typeParameters === list) return 30 /* LessThanToken */ ;
                else if (node.parameters === list) return 21 /* OpenParenToken */ ;
                break;
            case 212 /* CallExpression */ :
            case 213 /* NewExpression */ :
                if (node.typeArguments === list) return 30 /* LessThanToken */ ;
                else if (node.arguments === list) return 21 /* OpenParenToken */ ;
                break;
            case 262 /* ClassDeclaration */ :
            case 230 /* ClassExpression */ :
            case 263 /* InterfaceDeclaration */ :
            case 264 /* TypeAliasDeclaration */ :
                if (node.typeParameters === list) return 30 /* LessThanToken */ ;
                break;
            case 182 /* TypeReference */ :
            case 214 /* TaggedTemplateExpression */ :
            case 185 /* TypeQuery */ :
            case 232 /* ExpressionWithTypeArguments */ :
            case 204 /* ImportType */ :
                if (node.typeArguments === list) return 30 /* LessThanToken */ ;
                break;
            case 186 /* TypeLiteral */ :
                return 19 /* OpenBraceToken */ ;
        }
        return 0 /* Unknown */ ;
    }
    function getCloseTokenForOpenToken(kind) {
        switch(kind){
            case 21 /* OpenParenToken */ :
                return 22 /* CloseParenToken */ ;
            case 30 /* LessThanToken */ :
                return 32 /* GreaterThanToken */ ;
            case 19 /* OpenBraceToken */ :
                return 20 /* CloseBraceToken */ ;
        }
        return 0 /* Unknown */ ;
    }
    function getIndentationString(indentation, options) {
        const resetInternedStrings = !internedSizes || internedSizes.tabSize !== options.tabSize || internedSizes.indentSize !== options.indentSize;
        if (resetInternedStrings) {
            internedSizes = {
                tabSize: options.tabSize,
                indentSize: options.indentSize
            };
            internedTabsIndentation = internedSpacesIndentation = void 0;
        }
        if (!options.convertTabsToSpaces) {
            const tabs = Math.floor(indentation / options.tabSize);
            const spaces = indentation - tabs * options.tabSize;
            let tabString;
            if (!internedTabsIndentation) internedTabsIndentation = [];
            if (internedTabsIndentation[tabs] === void 0) internedTabsIndentation[tabs] = tabString = repeatString("	", tabs);
            else tabString = internedTabsIndentation[tabs];
            return spaces ? tabString + repeatString(" ", spaces) : tabString;
        } else {
            let spacesString;
            const quotient = Math.floor(indentation / options.indentSize);
            const remainder = indentation % options.indentSize;
            if (!internedSpacesIndentation) internedSpacesIndentation = [];
            if (internedSpacesIndentation[quotient] === void 0) {
                spacesString = repeatString(" ", options.indentSize * quotient);
                internedSpacesIndentation[quotient] = spacesString;
            } else spacesString = internedSpacesIndentation[quotient];
            return remainder ? spacesString + repeatString(" ", remainder) : spacesString;
        }
    }
    var internedSizes, internedTabsIndentation, internedSpacesIndentation;
    var init_formatting = __esm({
        "src/services/formatting/formatting.ts" () {
            "use strict";
            init_ts4();
            init_ts_formatting();
        }
    });
    // src/services/formatting/smartIndenter.ts
    var SmartIndenter;
    var init_smartIndenter = __esm({
        "src/services/formatting/smartIndenter.ts" () {
            "use strict";
            init_ts4();
            init_ts_formatting();
            ((SmartIndenter2)=>{
                let Value;
                ((Value2)=>{
                    Value2[Value2["Unknown"] = -1] = "Unknown";
                })(Value || (Value = {}));
                function getIndentation(position, sourceFile, options, assumeNewLineBeforeCloseBrace = false) {
                    if (position > sourceFile.text.length) return getBaseIndentation(options);
                    if (options.indentStyle === 0 /* None */ ) return 0;
                    const precedingToken = findPrecedingToken(position, sourceFile, /*startNode*/ void 0, /*excludeJsdoc*/ true);
                    const enclosingCommentRange = getRangeOfEnclosingComment(sourceFile, position, precedingToken || null);
                    if (enclosingCommentRange && enclosingCommentRange.kind === 3 /* MultiLineCommentTrivia */ ) return getCommentIndent(sourceFile, position, options, enclosingCommentRange);
                    if (!precedingToken) return getBaseIndentation(options);
                    const precedingTokenIsLiteral = isStringOrRegularExpressionOrTemplateLiteral(precedingToken.kind);
                    if (precedingTokenIsLiteral && precedingToken.getStart(sourceFile) <= position && position < precedingToken.end) return 0;
                    const lineAtPosition = sourceFile.getLineAndCharacterOfPosition(position).line;
                    const currentToken = getTokenAtPosition(sourceFile, position);
                    const isObjectLiteral = currentToken.kind === 19 /* OpenBraceToken */  && currentToken.parent.kind === 209 /* ObjectLiteralExpression */ ;
                    if (options.indentStyle === 1 /* Block */  || isObjectLiteral) return getBlockIndent(sourceFile, position, options);
                    if (precedingToken.kind === 28 /* CommaToken */  && precedingToken.parent.kind !== 225 /* BinaryExpression */ ) {
                        const actualIndentation = getActualIndentationForListItemBeforeComma(precedingToken, sourceFile, options);
                        if (actualIndentation !== -1 /* Unknown */ ) return actualIndentation;
                    }
                    const containerList = getListByPosition(position, precedingToken.parent, sourceFile);
                    if (containerList && !rangeContainsRange(containerList, precedingToken)) {
                        const useTheSameBaseIndentation = [
                            217 /* FunctionExpression */ ,
                            218 /* ArrowFunction */ 
                        ].indexOf(currentToken.parent.kind) !== -1;
                        const indentSize = useTheSameBaseIndentation ? 0 : options.indentSize;
                        return getActualIndentationForListStartLine(containerList, sourceFile, options) + indentSize;
                    }
                    return getSmartIndent(sourceFile, position, precedingToken, lineAtPosition, assumeNewLineBeforeCloseBrace, options);
                }
                SmartIndenter2.getIndentation = getIndentation;
                function getCommentIndent(sourceFile, position, options, enclosingCommentRange) {
                    const previousLine = getLineAndCharacterOfPosition(sourceFile, position).line - 1;
                    const commentStartLine = getLineAndCharacterOfPosition(sourceFile, enclosingCommentRange.pos).line;
                    Debug.assert(commentStartLine >= 0);
                    if (previousLine <= commentStartLine) return findFirstNonWhitespaceColumn(getStartPositionOfLine(commentStartLine, sourceFile), position, sourceFile, options);
                    const startPositionOfLine = getStartPositionOfLine(previousLine, sourceFile);
                    const { column: column , character: character  } = findFirstNonWhitespaceCharacterAndColumn(startPositionOfLine, position, sourceFile, options);
                    if (column === 0) return column;
                    const firstNonWhitespaceCharacterCode = sourceFile.text.charCodeAt(startPositionOfLine + character);
                    return firstNonWhitespaceCharacterCode === 42 /* asterisk */  ? column - 1 : column;
                }
                function getBlockIndent(sourceFile, position, options) {
                    let current = position;
                    while(current > 0){
                        const char = sourceFile.text.charCodeAt(current);
                        if (!isWhiteSpaceLike(char)) break;
                        current--;
                    }
                    const lineStart = getLineStartPositionForPosition(current, sourceFile);
                    return findFirstNonWhitespaceColumn(lineStart, current, sourceFile, options);
                }
                function getSmartIndent(sourceFile, position, precedingToken, lineAtPosition, assumeNewLineBeforeCloseBrace, options) {
                    let previous;
                    let current = precedingToken;
                    while(current){
                        if (positionBelongsToNode(current, position, sourceFile) && shouldIndentChildNode(options, current, previous, sourceFile, /*isNextChild*/ true)) {
                            const currentStart = getStartLineAndCharacterForNode(current, sourceFile);
                            const nextTokenKind = nextTokenIsCurlyBraceOnSameLineAsCursor(precedingToken, current, lineAtPosition, sourceFile);
                            const indentationDelta = nextTokenKind !== 0 /* Unknown */  ? assumeNewLineBeforeCloseBrace && nextTokenKind === 2 /* CloseBrace */  ? options.indentSize : 0 : lineAtPosition !== currentStart.line ? options.indentSize : 0;
                            return getIndentationForNodeWorker(current, currentStart, /*ignoreActualIndentationRange*/ void 0, indentationDelta, sourceFile, /*isNextChild*/ true, options);
                        }
                        const actualIndentation = getActualIndentationForListItem(current, sourceFile, options, /*listIndentsChild*/ true);
                        if (actualIndentation !== -1 /* Unknown */ ) return actualIndentation;
                        previous = current;
                        current = current.parent;
                    }
                    return getBaseIndentation(options);
                }
                function getIndentationForNode(n, ignoreActualIndentationRange, sourceFile, options) {
                    const start = sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile));
                    return getIndentationForNodeWorker(n, start, ignoreActualIndentationRange, /*indentationDelta*/ 0, sourceFile, /*isNextChild*/ false, options);
                }
                SmartIndenter2.getIndentationForNode = getIndentationForNode;
                function getBaseIndentation(options) {
                    return options.baseIndentSize || 0;
                }
                SmartIndenter2.getBaseIndentation = getBaseIndentation;
                function getIndentationForNodeWorker(current, currentStart, ignoreActualIndentationRange, indentationDelta, sourceFile, isNextChild, options) {
                    var _a;
                    let parent2 = current.parent;
                    while(parent2){
                        let useActualIndentation = true;
                        if (ignoreActualIndentationRange) {
                            const start = current.getStart(sourceFile);
                            useActualIndentation = start < ignoreActualIndentationRange.pos || start > ignoreActualIndentationRange.end;
                        }
                        const containingListOrParentStart = getContainingListOrParentStart(parent2, current, sourceFile);
                        const parentAndChildShareLine = containingListOrParentStart.line === currentStart.line || childStartsOnTheSameLineWithElseInIfStatement(parent2, current, currentStart.line, sourceFile);
                        if (useActualIndentation) {
                            const firstListChild = (_a = getContainingList(current, sourceFile)) == null ? void 0 : _a[0];
                            const listIndentsChild = !!firstListChild && getStartLineAndCharacterForNode(firstListChild, sourceFile).line > containingListOrParentStart.line;
                            let actualIndentation = getActualIndentationForListItem(current, sourceFile, options, listIndentsChild);
                            if (actualIndentation !== -1 /* Unknown */ ) return actualIndentation + indentationDelta;
                            actualIndentation = getActualIndentationForNode(current, parent2, currentStart, parentAndChildShareLine, sourceFile, options);
                            if (actualIndentation !== -1 /* Unknown */ ) return actualIndentation + indentationDelta;
                        }
                        if (shouldIndentChildNode(options, parent2, current, sourceFile, isNextChild) && !parentAndChildShareLine) indentationDelta += options.indentSize;
                        const useTrueStart = isArgumentAndStartLineOverlapsExpressionBeingCalled(parent2, current, currentStart.line, sourceFile);
                        current = parent2;
                        parent2 = current.parent;
                        currentStart = useTrueStart ? sourceFile.getLineAndCharacterOfPosition(current.getStart(sourceFile)) : containingListOrParentStart;
                    }
                    return indentationDelta + getBaseIndentation(options);
                }
                function getContainingListOrParentStart(parent2, child, sourceFile) {
                    const containingList = getContainingList(child, sourceFile);
                    const startPos = containingList ? containingList.pos : parent2.getStart(sourceFile);
                    return sourceFile.getLineAndCharacterOfPosition(startPos);
                }
                function getActualIndentationForListItemBeforeComma(commaToken, sourceFile, options) {
                    const commaItemInfo = findListItemInfo(commaToken);
                    if (commaItemInfo && commaItemInfo.listItemIndex > 0) return deriveActualIndentationFromList(commaItemInfo.list.getChildren(), commaItemInfo.listItemIndex - 1, sourceFile, options);
                    else return -1 /* Unknown */ ;
                }
                function getActualIndentationForNode(current, parent2, currentLineAndChar, parentAndChildShareLine, sourceFile, options) {
                    const useActualIndentation = (isDeclaration(current) || isStatementButNotDeclaration(current)) && (parent2.kind === 311 /* SourceFile */  || !parentAndChildShareLine);
                    if (!useActualIndentation) return -1 /* Unknown */ ;
                    return findColumnForFirstNonWhitespaceCharacterInLine(currentLineAndChar, sourceFile, options);
                }
                let NextTokenKind;
                ((NextTokenKind2)=>{
                    NextTokenKind2[NextTokenKind2["Unknown"] = 0] = "Unknown";
                    NextTokenKind2[NextTokenKind2["OpenBrace"] = 1] = "OpenBrace";
                    NextTokenKind2[NextTokenKind2["CloseBrace"] = 2] = "CloseBrace";
                })(NextTokenKind || (NextTokenKind = {}));
                function nextTokenIsCurlyBraceOnSameLineAsCursor(precedingToken, current, lineAtPosition, sourceFile) {
                    const nextToken = findNextToken(precedingToken, current, sourceFile);
                    if (!nextToken) return 0 /* Unknown */ ;
                    if (nextToken.kind === 19 /* OpenBraceToken */ ) return 1 /* OpenBrace */ ;
                    else if (nextToken.kind === 20 /* CloseBraceToken */ ) {
                        const nextTokenStartLine = getStartLineAndCharacterForNode(nextToken, sourceFile).line;
                        return lineAtPosition === nextTokenStartLine ? 2 /* CloseBrace */  : 0 /* Unknown */ ;
                    }
                    return 0 /* Unknown */ ;
                }
                function getStartLineAndCharacterForNode(n, sourceFile) {
                    return sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile));
                }
                function isArgumentAndStartLineOverlapsExpressionBeingCalled(parent2, child, childStartLine, sourceFile) {
                    if (!(isCallExpression(parent2) && contains(parent2.arguments, child))) return false;
                    const expressionOfCallExpressionEnd = parent2.expression.getEnd();
                    const expressionOfCallExpressionEndLine = getLineAndCharacterOfPosition(sourceFile, expressionOfCallExpressionEnd).line;
                    return expressionOfCallExpressionEndLine === childStartLine;
                }
                SmartIndenter2.isArgumentAndStartLineOverlapsExpressionBeingCalled = isArgumentAndStartLineOverlapsExpressionBeingCalled;
                function childStartsOnTheSameLineWithElseInIfStatement(parent2, child, childStartLine, sourceFile) {
                    if (parent2.kind === 244 /* IfStatement */  && parent2.elseStatement === child) {
                        const elseKeyword = findChildOfKind(parent2, 93 /* ElseKeyword */ , sourceFile);
                        Debug.assert(elseKeyword !== void 0);
                        const elseKeywordStartLine = getStartLineAndCharacterForNode(elseKeyword, sourceFile).line;
                        return elseKeywordStartLine === childStartLine;
                    }
                    return false;
                }
                SmartIndenter2.childStartsOnTheSameLineWithElseInIfStatement = childStartsOnTheSameLineWithElseInIfStatement;
                function childIsUnindentedBranchOfConditionalExpression(parent2, child, childStartLine, sourceFile) {
                    if (isConditionalExpression(parent2) && (child === parent2.whenTrue || child === parent2.whenFalse)) {
                        const conditionEndLine = getLineAndCharacterOfPosition(sourceFile, parent2.condition.end).line;
                        if (child === parent2.whenTrue) return childStartLine === conditionEndLine;
                        else {
                            const trueStartLine = getStartLineAndCharacterForNode(parent2.whenTrue, sourceFile).line;
                            const trueEndLine = getLineAndCharacterOfPosition(sourceFile, parent2.whenTrue.end).line;
                            return conditionEndLine === trueStartLine && trueEndLine === childStartLine;
                        }
                    }
                    return false;
                }
                SmartIndenter2.childIsUnindentedBranchOfConditionalExpression = childIsUnindentedBranchOfConditionalExpression;
                function argumentStartsOnSameLineAsPreviousArgument(parent2, child, childStartLine, sourceFile) {
                    if (isCallOrNewExpression(parent2)) {
                        if (!parent2.arguments) return false;
                        const currentNode = find(parent2.arguments, (arg)=>arg.pos === child.pos);
                        if (!currentNode) return false;
                        const currentIndex = parent2.arguments.indexOf(currentNode);
                        if (currentIndex === 0) return false;
                        const previousNode = parent2.arguments[currentIndex - 1];
                        const lineOfPreviousNode = getLineAndCharacterOfPosition(sourceFile, previousNode.getEnd()).line;
                        if (childStartLine === lineOfPreviousNode) return true;
                    }
                    return false;
                }
                SmartIndenter2.argumentStartsOnSameLineAsPreviousArgument = argumentStartsOnSameLineAsPreviousArgument;
                function getContainingList(node, sourceFile) {
                    return node.parent && getListByRange(node.getStart(sourceFile), node.getEnd(), node.parent, sourceFile);
                }
                SmartIndenter2.getContainingList = getContainingList;
                function getListByPosition(pos, node, sourceFile) {
                    return node && getListByRange(pos, pos, node, sourceFile);
                }
                function getListByRange(start, end, node, sourceFile) {
                    switch(node.kind){
                        case 182 /* TypeReference */ :
                            return getList(node.typeArguments);
                        case 209 /* ObjectLiteralExpression */ :
                            return getList(node.properties);
                        case 208 /* ArrayLiteralExpression */ :
                            return getList(node.elements);
                        case 186 /* TypeLiteral */ :
                            return getList(node.members);
                        case 261 /* FunctionDeclaration */ :
                        case 217 /* FunctionExpression */ :
                        case 218 /* ArrowFunction */ :
                        case 173 /* MethodDeclaration */ :
                        case 172 /* MethodSignature */ :
                        case 178 /* CallSignature */ :
                        case 175 /* Constructor */ :
                        case 184 /* ConstructorType */ :
                        case 179 /* ConstructSignature */ :
                            return getList(node.typeParameters) || getList(node.parameters);
                        case 176 /* GetAccessor */ :
                            return getList(node.parameters);
                        case 262 /* ClassDeclaration */ :
                        case 230 /* ClassExpression */ :
                        case 263 /* InterfaceDeclaration */ :
                        case 264 /* TypeAliasDeclaration */ :
                        case 351 /* JSDocTemplateTag */ :
                            return getList(node.typeParameters);
                        case 213 /* NewExpression */ :
                        case 212 /* CallExpression */ :
                            return getList(node.typeArguments) || getList(node.arguments);
                        case 260 /* VariableDeclarationList */ :
                            return getList(node.declarations);
                        case 274 /* NamedImports */ :
                        case 278 /* NamedExports */ :
                            return getList(node.elements);
                        case 205 /* ObjectBindingPattern */ :
                        case 206 /* ArrayBindingPattern */ :
                            return getList(node.elements);
                    }
                    function getList(list) {
                        return list && rangeContainsStartEnd(getVisualListRange(node, list, sourceFile), start, end) ? list : void 0;
                    }
                }
                function getVisualListRange(node, list, sourceFile) {
                    const children = node.getChildren(sourceFile);
                    for(let i = 1; i < children.length - 1; i++){
                        if (children[i].pos === list.pos && children[i].end === list.end) return {
                            pos: children[i - 1].end,
                            end: children[i + 1].getStart(sourceFile)
                        };
                    }
                    return list;
                }
                function getActualIndentationForListStartLine(list, sourceFile, options) {
                    if (!list) return -1 /* Unknown */ ;
                    return findColumnForFirstNonWhitespaceCharacterInLine(sourceFile.getLineAndCharacterOfPosition(list.pos), sourceFile, options);
                }
                function getActualIndentationForListItem(node, sourceFile, options, listIndentsChild) {
                    if (node.parent && node.parent.kind === 260 /* VariableDeclarationList */ ) return -1 /* Unknown */ ;
                    const containingList = getContainingList(node, sourceFile);
                    if (containingList) {
                        const index = containingList.indexOf(node);
                        if (index !== -1) {
                            const result = deriveActualIndentationFromList(containingList, index, sourceFile, options);
                            if (result !== -1 /* Unknown */ ) return result;
                        }
                        return getActualIndentationForListStartLine(containingList, sourceFile, options) + (listIndentsChild ? options.indentSize : 0);
                    }
                    return -1 /* Unknown */ ;
                }
                function deriveActualIndentationFromList(list, index, sourceFile, options) {
                    Debug.assert(index >= 0 && index < list.length);
                    const node = list[index];
                    let lineAndCharacter = getStartLineAndCharacterForNode(node, sourceFile);
                    for(let i = index - 1; i >= 0; i--){
                        if (list[i].kind === 28 /* CommaToken */ ) continue;
                        const prevEndLine = sourceFile.getLineAndCharacterOfPosition(list[i].end).line;
                        if (prevEndLine !== lineAndCharacter.line) return findColumnForFirstNonWhitespaceCharacterInLine(lineAndCharacter, sourceFile, options);
                        lineAndCharacter = getStartLineAndCharacterForNode(list[i], sourceFile);
                    }
                    return -1 /* Unknown */ ;
                }
                function findColumnForFirstNonWhitespaceCharacterInLine(lineAndCharacter, sourceFile, options) {
                    const lineStart = sourceFile.getPositionOfLineAndCharacter(lineAndCharacter.line, 0);
                    return findFirstNonWhitespaceColumn(lineStart, lineStart + lineAndCharacter.character, sourceFile, options);
                }
                function findFirstNonWhitespaceCharacterAndColumn(startPos, endPos, sourceFile, options) {
                    let character = 0;
                    let column = 0;
                    for(let pos = startPos; pos < endPos; pos++){
                        const ch = sourceFile.text.charCodeAt(pos);
                        if (!isWhiteSpaceSingleLine(ch)) break;
                        if (ch === 9 /* tab */ ) column += options.tabSize + column % options.tabSize;
                        else column++;
                        character++;
                    }
                    return {
                        column: column,
                        character: character
                    };
                }
                SmartIndenter2.findFirstNonWhitespaceCharacterAndColumn = findFirstNonWhitespaceCharacterAndColumn;
                function findFirstNonWhitespaceColumn(startPos, endPos, sourceFile, options) {
                    return findFirstNonWhitespaceCharacterAndColumn(startPos, endPos, sourceFile, options).column;
                }
                SmartIndenter2.findFirstNonWhitespaceColumn = findFirstNonWhitespaceColumn;
                function nodeWillIndentChild(settings, parent2, child, sourceFile, indentByDefault) {
                    const childKind = child ? child.kind : 0 /* Unknown */ ;
                    switch(parent2.kind){
                        case 243 /* ExpressionStatement */ :
                        case 262 /* ClassDeclaration */ :
                        case 230 /* ClassExpression */ :
                        case 263 /* InterfaceDeclaration */ :
                        case 265 /* EnumDeclaration */ :
                        case 264 /* TypeAliasDeclaration */ :
                        case 208 /* ArrayLiteralExpression */ :
                        case 240 /* Block */ :
                        case 267 /* ModuleBlock */ :
                        case 209 /* ObjectLiteralExpression */ :
                        case 186 /* TypeLiteral */ :
                        case 199 /* MappedType */ :
                        case 188 /* TupleType */ :
                        case 216 /* ParenthesizedExpression */ :
                        case 210 /* PropertyAccessExpression */ :
                        case 212 /* CallExpression */ :
                        case 213 /* NewExpression */ :
                        case 242 /* VariableStatement */ :
                        case 276 /* ExportAssignment */ :
                        case 252 /* ReturnStatement */ :
                        case 226 /* ConditionalExpression */ :
                        case 206 /* ArrayBindingPattern */ :
                        case 205 /* ObjectBindingPattern */ :
                        case 285 /* JsxOpeningElement */ :
                        case 288 /* JsxOpeningFragment */ :
                        case 284 /* JsxSelfClosingElement */ :
                        case 293 /* JsxExpression */ :
                        case 172 /* MethodSignature */ :
                        case 178 /* CallSignature */ :
                        case 179 /* ConstructSignature */ :
                        case 168 /* Parameter */ :
                        case 183 /* FunctionType */ :
                        case 184 /* ConstructorType */ :
                        case 195 /* ParenthesizedType */ :
                        case 214 /* TaggedTemplateExpression */ :
                        case 222 /* AwaitExpression */ :
                        case 278 /* NamedExports */ :
                        case 274 /* NamedImports */ :
                        case 280 /* ExportSpecifier */ :
                        case 275 /* ImportSpecifier */ :
                        case 171 /* PropertyDeclaration */ :
                        case 295 /* CaseClause */ :
                        case 296 /* DefaultClause */ :
                            return true;
                        case 268 /* CaseBlock */ :
                            return settings.indentSwitchCase ?? true;
                        case 259 /* VariableDeclaration */ :
                        case 302 /* PropertyAssignment */ :
                        case 225 /* BinaryExpression */ :
                            if (!settings.indentMultiLineObjectLiteralBeginningOnBlankLine && sourceFile && childKind === 209 /* ObjectLiteralExpression */ ) return rangeIsOnOneLine(sourceFile, child);
                            if (parent2.kind === 225 /* BinaryExpression */  && sourceFile && child && childKind === 283 /* JsxElement */ ) {
                                const parentStartLine = sourceFile.getLineAndCharacterOfPosition(skipTrivia(sourceFile.text, parent2.pos)).line;
                                const childStartLine = sourceFile.getLineAndCharacterOfPosition(skipTrivia(sourceFile.text, child.pos)).line;
                                return parentStartLine !== childStartLine;
                            }
                            if (parent2.kind !== 225 /* BinaryExpression */ ) return true;
                            break;
                        case 245 /* DoStatement */ :
                        case 246 /* WhileStatement */ :
                        case 248 /* ForInStatement */ :
                        case 249 /* ForOfStatement */ :
                        case 247 /* ForStatement */ :
                        case 244 /* IfStatement */ :
                        case 261 /* FunctionDeclaration */ :
                        case 217 /* FunctionExpression */ :
                        case 173 /* MethodDeclaration */ :
                        case 175 /* Constructor */ :
                        case 176 /* GetAccessor */ :
                        case 177 /* SetAccessor */ :
                            return childKind !== 240 /* Block */ ;
                        case 218 /* ArrowFunction */ :
                            if (sourceFile && childKind === 216 /* ParenthesizedExpression */ ) return rangeIsOnOneLine(sourceFile, child);
                            return childKind !== 240 /* Block */ ;
                        case 277 /* ExportDeclaration */ :
                            return childKind !== 278 /* NamedExports */ ;
                        case 271 /* ImportDeclaration */ :
                            return childKind !== 272 /* ImportClause */  || !!child.namedBindings && child.namedBindings.kind !== 274 /* NamedImports */ ;
                        case 283 /* JsxElement */ :
                            return childKind !== 286 /* JsxClosingElement */ ;
                        case 287 /* JsxFragment */ :
                            return childKind !== 289 /* JsxClosingFragment */ ;
                        case 192 /* IntersectionType */ :
                        case 191 /* UnionType */ :
                            if (childKind === 186 /* TypeLiteral */  || childKind === 188 /* TupleType */ ) return false;
                            break;
                    }
                    return indentByDefault;
                }
                SmartIndenter2.nodeWillIndentChild = nodeWillIndentChild;
                function isControlFlowEndingStatement(kind, parent2) {
                    switch(kind){
                        case 252 /* ReturnStatement */ :
                        case 256 /* ThrowStatement */ :
                        case 250 /* ContinueStatement */ :
                        case 251 /* BreakStatement */ :
                            return parent2.kind !== 240 /* Block */ ;
                        default:
                            return false;
                    }
                }
                function shouldIndentChildNode(settings, parent2, child, sourceFile, isNextChild = false) {
                    return nodeWillIndentChild(settings, parent2, child, sourceFile, /*indentByDefault*/ false) && !(isNextChild && child && isControlFlowEndingStatement(child.kind, parent2));
                }
                SmartIndenter2.shouldIndentChildNode = shouldIndentChildNode;
                function rangeIsOnOneLine(sourceFile, range) {
                    const rangeStart = skipTrivia(sourceFile.text, range.pos);
                    const startLine = sourceFile.getLineAndCharacterOfPosition(rangeStart).line;
                    const endLine = sourceFile.getLineAndCharacterOfPosition(range.end).line;
                    return startLine === endLine;
                }
            })(SmartIndenter || (SmartIndenter = {}));
        }
    });
    // src/services/_namespaces/ts.formatting.ts
    var ts_formatting_exports = {};
    __export(ts_formatting_exports, {
        FormattingContext: ()=>FormattingContext,
        FormattingRequestKind: ()=>FormattingRequestKind,
        RuleAction: ()=>RuleAction,
        RuleFlags: ()=>RuleFlags,
        SmartIndenter: ()=>SmartIndenter,
        anyContext: ()=>anyContext,
        createTextRangeWithKind: ()=>createTextRangeWithKind,
        formatDocument: ()=>formatDocument,
        formatNodeGivenIndentation: ()=>formatNodeGivenIndentation,
        formatOnClosingCurly: ()=>formatOnClosingCurly,
        formatOnEnter: ()=>formatOnEnter,
        formatOnOpeningCurly: ()=>formatOnOpeningCurly,
        formatOnSemicolon: ()=>formatOnSemicolon,
        formatSelection: ()=>formatSelection,
        getAllRules: ()=>getAllRules,
        getFormatContext: ()=>getFormatContext,
        getFormattingScanner: ()=>getFormattingScanner,
        getIndentationString: ()=>getIndentationString,
        getRangeOfEnclosingComment: ()=>getRangeOfEnclosingComment
    });
    var init_ts_formatting = __esm({
        "src/services/_namespaces/ts.formatting.ts" () {
            "use strict";
            init_formattingContext();
            init_formattingScanner();
            init_rule();
            init_rules();
            init_rulesMap();
            init_formatting();
            init_smartIndenter();
        }
    });
    // src/services/_namespaces/ts.ts
    var init_ts4 = __esm({
        "src/services/_namespaces/ts.ts" () {
            "use strict";
            init_ts2();
            init_ts3();
            init_types3();
            init_utilities4();
            init_exportInfoMap();
            init_classifier();
            init_documentHighlights();
            init_documentRegistry();
            init_getEditsForFileRename();
            init_patternMatcher();
            init_preProcess();
            init_sourcemaps();
            init_suggestionDiagnostics();
            init_transpile();
            init_services();
            init_transform();
            init_shims();
            init_ts_BreakpointResolver();
            init_ts_CallHierarchy();
            init_ts_classifier();
            init_ts_codefix();
            init_ts_Completions();
            init_ts_FindAllReferences();
            init_ts_GoToDefinition();
            init_ts_InlayHints();
            init_ts_JsDoc();
            init_ts_NavigateTo();
            init_ts_NavigationBar();
            init_ts_OrganizeImports();
            init_ts_OutliningElementsCollector();
            init_ts_refactor();
            init_ts_Rename();
            init_ts_SignatureHelp();
            init_ts_SmartSelectionRange();
            init_ts_SymbolDisplay();
            init_ts_textChanges();
            init_ts_formatting();
        }
    });
    // src/deprecatedCompat/deprecate.ts
    function getTypeScriptVersion() {
        return typeScriptVersion2 ?? (typeScriptVersion2 = new Version(version));
    }
    function formatDeprecationMessage(name, error, errorAfter, since, message) {
        let deprecationMessage = error ? "DeprecationError: " : "DeprecationWarning: ";
        deprecationMessage += `'${name}' `;
        deprecationMessage += since ? `has been deprecated since v${since}` : "is deprecated";
        deprecationMessage += error ? " and can no longer be used." : errorAfter ? ` and will no longer be usable after v${errorAfter}.` : ".";
        deprecationMessage += message ? ` ${formatStringFromArgs(message, [
            name
        ], 0)}` : "";
        return deprecationMessage;
    }
    function createErrorDeprecation(name, errorAfter, since, message) {
        const deprecationMessage = formatDeprecationMessage(name, /*error*/ true, errorAfter, since, message);
        return ()=>{
            throw new TypeError(deprecationMessage);
        };
    }
    function createWarningDeprecation(name, errorAfter, since, message) {
        let hasWrittenDeprecation = false;
        return ()=>{
            if (enableDeprecationWarnings && !hasWrittenDeprecation) {
                Debug.log.warn(formatDeprecationMessage(name, /*error*/ false, errorAfter, since, message));
                hasWrittenDeprecation = true;
            }
        };
    }
    function createDeprecation(name, options = {}) {
        const version2 = typeof options.typeScriptVersion === "string" ? new Version(options.typeScriptVersion) : options.typeScriptVersion ?? getTypeScriptVersion();
        const errorAfter = typeof options.errorAfter === "string" ? new Version(options.errorAfter) : options.errorAfter;
        const warnAfter = typeof options.warnAfter === "string" ? new Version(options.warnAfter) : options.warnAfter;
        const since = typeof options.since === "string" ? new Version(options.since) : options.since ?? warnAfter;
        const error = options.error || errorAfter && version2.compareTo(errorAfter) >= 0;
        const warn = !warnAfter || version2.compareTo(warnAfter) >= 0;
        return error ? createErrorDeprecation(name, errorAfter, since, options.message) : warn ? createWarningDeprecation(name, errorAfter, since, options.message) : noop;
    }
    function wrapFunction(deprecation, func) {
        return function() {
            deprecation();
            return func.apply(this, arguments);
        };
    }
    function deprecate(func, options) {
        const deprecation = createDeprecation((options == null ? void 0 : options.name) ?? Debug.getFunctionName(func), options);
        return wrapFunction(deprecation, func);
    }
    var enableDeprecationWarnings, typeScriptVersion2;
    var init_deprecate = __esm({
        "src/deprecatedCompat/deprecate.ts" () {
            "use strict";
            init_ts5();
            enableDeprecationWarnings = true;
        }
    });
    // src/deprecatedCompat/deprecations.ts
    function createOverload(name, overloads, binder2, deprecations) {
        Object.defineProperty(call, "name", {
            ...Object.getOwnPropertyDescriptor(call, "name"),
            value: name
        });
        if (deprecations) for (const key of Object.keys(deprecations)){
            const index = +key;
            if (!isNaN(index) && hasProperty(overloads, `${index}`)) overloads[index] = deprecate(overloads[index], {
                ...deprecations[index],
                name: name
            });
        }
        const bind = createBinder2(overloads, binder2);
        return call;
        function call(...args) {
            const index = bind(args);
            const fn = index !== void 0 ? overloads[index] : void 0;
            if (typeof fn === "function") return fn(...args);
            throw new TypeError("Invalid arguments");
        }
    }
    function createBinder2(overloads, binder2) {
        return (args)=>{
            for(let i = 0; hasProperty(overloads, `${i}`) && hasProperty(binder2, `${i}`); i++){
                const fn = binder2[i];
                if (fn(args)) return i;
            }
        };
    }
    function buildOverload(name) {
        return {
            overload: (overloads)=>({
                    bind: (binder2)=>({
                            finish: ()=>createOverload(name, overloads, binder2),
                            deprecate: (deprecations)=>({
                                    finish: ()=>createOverload(name, overloads, binder2, deprecations)
                                })
                        })
                })
        };
    }
    var init_deprecations = __esm({
        "src/deprecatedCompat/deprecations.ts" () {
            "use strict";
            init_ts5();
            init_deprecate();
        }
    });
    // src/deprecatedCompat/5.0/identifierProperties.ts
    var init_identifierProperties = __esm({
        "src/deprecatedCompat/5.0/identifierProperties.ts" () {
            "use strict";
            init_ts5();
            init_deprecate();
            addObjectAllocatorPatcher((objectAllocator2)=>{
                const Identifier74 = objectAllocator2.getIdentifierConstructor();
                if (!hasProperty(Identifier74.prototype, "originalKeywordKind")) Object.defineProperty(Identifier74.prototype, "originalKeywordKind", {
                    get: deprecate(function() {
                        return identifierToKeywordKind(this);
                    }, {
                        name: "originalKeywordKind",
                        since: "5.0",
                        warnAfter: "5.1",
                        errorAfter: "5.2",
                        message: "Use 'identifierToKeywordKind(identifier)' instead."
                    })
                });
                if (!hasProperty(Identifier74.prototype, "isInJSDocNamespace")) Object.defineProperty(Identifier74.prototype, "isInJSDocNamespace", {
                    get: deprecate(function() {
                        return this.flags & 2048 /* IdentifierIsInJSDocNamespace */  ? true : void 0;
                    }, {
                        name: "isInJSDocNamespace",
                        since: "5.0",
                        warnAfter: "5.1",
                        errorAfter: "5.2",
                        message: "Use '.parent' or the surrounding context to determine this instead."
                    })
                });
            });
        }
    });
    // src/deprecatedCompat/_namespaces/ts.ts
    var init_ts5 = __esm({
        "src/deprecatedCompat/_namespaces/ts.ts" () {
            "use strict";
            init_ts2();
            init_deprecations();
            init_identifierProperties();
        }
    });
    // src/typescript/_namespaces/ts.ts
    var ts_exports2 = {};
    __export(ts_exports2, {
        ANONYMOUS: ()=>ANONYMOUS,
        AccessFlags: ()=>AccessFlags,
        AssertionLevel: ()=>AssertionLevel,
        AssignmentDeclarationKind: ()=>AssignmentDeclarationKind,
        AssignmentKind: ()=>AssignmentKind,
        Associativity: ()=>Associativity,
        BreakpointResolver: ()=>ts_BreakpointResolver_exports,
        BuilderFileEmit: ()=>BuilderFileEmit,
        BuilderProgramKind: ()=>BuilderProgramKind,
        BuilderState: ()=>BuilderState,
        BundleFileSectionKind: ()=>BundleFileSectionKind,
        CallHierarchy: ()=>ts_CallHierarchy_exports,
        CharacterCodes: ()=>CharacterCodes,
        CheckFlags: ()=>CheckFlags,
        CheckMode: ()=>CheckMode,
        ClassificationType: ()=>ClassificationType,
        ClassificationTypeNames: ()=>ClassificationTypeNames,
        CommentDirectiveType: ()=>CommentDirectiveType,
        Comparison: ()=>Comparison,
        CompletionInfoFlags: ()=>CompletionInfoFlags,
        CompletionTriggerKind: ()=>CompletionTriggerKind,
        Completions: ()=>ts_Completions_exports,
        ConfigFileProgramReloadLevel: ()=>ConfigFileProgramReloadLevel,
        ContextFlags: ()=>ContextFlags,
        CoreServicesShimHostAdapter: ()=>CoreServicesShimHostAdapter,
        Debug: ()=>Debug,
        DiagnosticCategory: ()=>DiagnosticCategory,
        Diagnostics: ()=>Diagnostics,
        DocumentHighlights: ()=>DocumentHighlights,
        ElementFlags: ()=>ElementFlags,
        EmitFlags: ()=>EmitFlags,
        EmitHint: ()=>EmitHint,
        EmitOnly: ()=>EmitOnly,
        EndOfLineState: ()=>EndOfLineState,
        EnumKind: ()=>EnumKind,
        ExitStatus: ()=>ExitStatus,
        ExportKind: ()=>ExportKind,
        Extension: ()=>Extension,
        ExternalEmitHelpers: ()=>ExternalEmitHelpers,
        FileIncludeKind: ()=>FileIncludeKind,
        FilePreprocessingDiagnosticsKind: ()=>FilePreprocessingDiagnosticsKind,
        FileSystemEntryKind: ()=>FileSystemEntryKind,
        FileWatcherEventKind: ()=>FileWatcherEventKind,
        FindAllReferences: ()=>ts_FindAllReferences_exports,
        FlattenLevel: ()=>FlattenLevel,
        FlowFlags: ()=>FlowFlags,
        ForegroundColorEscapeSequences: ()=>ForegroundColorEscapeSequences,
        FunctionFlags: ()=>FunctionFlags,
        GeneratedIdentifierFlags: ()=>GeneratedIdentifierFlags,
        GetLiteralTextFlags: ()=>GetLiteralTextFlags,
        GoToDefinition: ()=>ts_GoToDefinition_exports,
        HighlightSpanKind: ()=>HighlightSpanKind,
        ImportKind: ()=>ImportKind,
        ImportsNotUsedAsValues: ()=>ImportsNotUsedAsValues,
        IndentStyle: ()=>IndentStyle,
        IndexFlags: ()=>IndexFlags,
        IndexKind: ()=>IndexKind,
        InferenceFlags: ()=>InferenceFlags,
        InferencePriority: ()=>InferencePriority,
        InlayHintKind: ()=>InlayHintKind,
        InlayHints: ()=>ts_InlayHints_exports,
        InternalEmitFlags: ()=>InternalEmitFlags,
        InternalSymbolName: ()=>InternalSymbolName,
        InvalidatedProjectKind: ()=>InvalidatedProjectKind,
        JsDoc: ()=>ts_JsDoc_exports,
        JsTyping: ()=>ts_JsTyping_exports,
        JsxEmit: ()=>JsxEmit,
        JsxFlags: ()=>JsxFlags,
        JsxReferenceKind: ()=>JsxReferenceKind,
        LanguageServiceMode: ()=>LanguageServiceMode,
        LanguageServiceShimHostAdapter: ()=>LanguageServiceShimHostAdapter,
        LanguageVariant: ()=>LanguageVariant,
        LexicalEnvironmentFlags: ()=>LexicalEnvironmentFlags,
        ListFormat: ()=>ListFormat,
        LogLevel: ()=>LogLevel,
        MemberOverrideStatus: ()=>MemberOverrideStatus,
        ModifierFlags: ()=>ModifierFlags,
        ModuleDetectionKind: ()=>ModuleDetectionKind,
        ModuleInstanceState: ()=>ModuleInstanceState,
        ModuleKind: ()=>ModuleKind,
        ModuleResolutionKind: ()=>ModuleResolutionKind,
        ModuleSpecifierEnding: ()=>ModuleSpecifierEnding,
        NavigateTo: ()=>ts_NavigateTo_exports,
        NavigationBar: ()=>ts_NavigationBar_exports,
        NewLineKind: ()=>NewLineKind,
        NodeBuilderFlags: ()=>NodeBuilderFlags,
        NodeCheckFlags: ()=>NodeCheckFlags,
        NodeFactoryFlags: ()=>NodeFactoryFlags,
        NodeFlags: ()=>NodeFlags,
        NodeResolutionFeatures: ()=>NodeResolutionFeatures,
        ObjectFlags: ()=>ObjectFlags,
        OperationCanceledException: ()=>OperationCanceledException,
        OperatorPrecedence: ()=>OperatorPrecedence,
        OrganizeImports: ()=>ts_OrganizeImports_exports,
        OrganizeImportsMode: ()=>OrganizeImportsMode,
        OuterExpressionKinds: ()=>OuterExpressionKinds,
        OutliningElementsCollector: ()=>ts_OutliningElementsCollector_exports,
        OutliningSpanKind: ()=>OutliningSpanKind,
        OutputFileType: ()=>OutputFileType,
        PackageJsonAutoImportPreference: ()=>PackageJsonAutoImportPreference,
        PackageJsonDependencyGroup: ()=>PackageJsonDependencyGroup,
        PatternMatchKind: ()=>PatternMatchKind,
        PollingInterval: ()=>PollingInterval,
        PollingWatchKind: ()=>PollingWatchKind,
        PragmaKindFlags: ()=>PragmaKindFlags,
        PrivateIdentifierKind: ()=>PrivateIdentifierKind,
        ProcessLevel: ()=>ProcessLevel,
        QuotePreference: ()=>QuotePreference,
        RelationComparisonResult: ()=>RelationComparisonResult,
        Rename: ()=>ts_Rename_exports,
        ScriptElementKind: ()=>ScriptElementKind,
        ScriptElementKindModifier: ()=>ScriptElementKindModifier,
        ScriptKind: ()=>ScriptKind,
        ScriptSnapshot: ()=>ScriptSnapshot,
        ScriptTarget: ()=>ScriptTarget,
        SemanticClassificationFormat: ()=>SemanticClassificationFormat,
        SemanticMeaning: ()=>SemanticMeaning,
        SemicolonPreference: ()=>SemicolonPreference,
        SignatureCheckMode: ()=>SignatureCheckMode,
        SignatureFlags: ()=>SignatureFlags,
        SignatureHelp: ()=>ts_SignatureHelp_exports,
        SignatureKind: ()=>SignatureKind,
        SmartSelectionRange: ()=>ts_SmartSelectionRange_exports,
        SnippetKind: ()=>SnippetKind,
        SortKind: ()=>SortKind,
        StructureIsReused: ()=>StructureIsReused,
        SymbolAccessibility: ()=>SymbolAccessibility,
        SymbolDisplay: ()=>ts_SymbolDisplay_exports,
        SymbolDisplayPartKind: ()=>SymbolDisplayPartKind,
        SymbolFlags: ()=>SymbolFlags,
        SymbolFormatFlags: ()=>SymbolFormatFlags,
        SyntaxKind: ()=>SyntaxKind,
        SyntheticSymbolKind: ()=>SyntheticSymbolKind,
        Ternary: ()=>Ternary,
        ThrottledCancellationToken: ()=>ThrottledCancellationToken,
        TokenClass: ()=>TokenClass,
        TokenFlags: ()=>TokenFlags,
        TransformFlags: ()=>TransformFlags,
        TypeFacts: ()=>TypeFacts,
        TypeFlags: ()=>TypeFlags,
        TypeFormatFlags: ()=>TypeFormatFlags,
        TypeMapKind: ()=>TypeMapKind,
        TypePredicateKind: ()=>TypePredicateKind,
        TypeReferenceSerializationKind: ()=>TypeReferenceSerializationKind,
        TypeScriptServicesFactory: ()=>TypeScriptServicesFactory,
        UnionReduction: ()=>UnionReduction,
        UpToDateStatusType: ()=>UpToDateStatusType,
        VarianceFlags: ()=>VarianceFlags,
        Version: ()=>Version,
        VersionRange: ()=>VersionRange,
        WatchDirectoryFlags: ()=>WatchDirectoryFlags,
        WatchDirectoryKind: ()=>WatchDirectoryKind,
        WatchFileKind: ()=>WatchFileKind,
        WatchLogLevel: ()=>WatchLogLevel,
        WatchType: ()=>WatchType,
        accessPrivateIdentifier: ()=>accessPrivateIdentifier,
        addEmitFlags: ()=>addEmitFlags,
        addEmitHelper: ()=>addEmitHelper,
        addEmitHelpers: ()=>addEmitHelpers,
        addInternalEmitFlags: ()=>addInternalEmitFlags,
        addNodeFactoryPatcher: ()=>addNodeFactoryPatcher,
        addObjectAllocatorPatcher: ()=>addObjectAllocatorPatcher,
        addRange: ()=>addRange,
        addRelatedInfo: ()=>addRelatedInfo,
        addSyntheticLeadingComment: ()=>addSyntheticLeadingComment,
        addSyntheticTrailingComment: ()=>addSyntheticTrailingComment,
        addToSeen: ()=>addToSeen,
        advancedAsyncSuperHelper: ()=>advancedAsyncSuperHelper,
        affectsDeclarationPathOptionDeclarations: ()=>affectsDeclarationPathOptionDeclarations,
        affectsEmitOptionDeclarations: ()=>affectsEmitOptionDeclarations,
        allKeysStartWithDot: ()=>allKeysStartWithDot,
        altDirectorySeparator: ()=>altDirectorySeparator,
        and: ()=>and,
        append: ()=>append,
        appendIfUnique: ()=>appendIfUnique,
        arrayFrom: ()=>arrayFrom,
        arrayIsEqualTo: ()=>arrayIsEqualTo,
        arrayIsHomogeneous: ()=>arrayIsHomogeneous,
        arrayIsSorted: ()=>arrayIsSorted,
        arrayOf: ()=>arrayOf,
        arrayReverseIterator: ()=>arrayReverseIterator,
        arrayToMap: ()=>arrayToMap,
        arrayToMultiMap: ()=>arrayToMultiMap,
        arrayToNumericMap: ()=>arrayToNumericMap,
        arraysEqual: ()=>arraysEqual,
        assertType: ()=>assertType,
        assign: ()=>assign,
        assignHelper: ()=>assignHelper,
        asyncDelegator: ()=>asyncDelegator,
        asyncGeneratorHelper: ()=>asyncGeneratorHelper,
        asyncSuperHelper: ()=>asyncSuperHelper,
        asyncValues: ()=>asyncValues,
        attachFileToDiagnostics: ()=>attachFileToDiagnostics,
        awaitHelper: ()=>awaitHelper,
        awaiterHelper: ()=>awaiterHelper,
        base64decode: ()=>base64decode,
        base64encode: ()=>base64encode,
        binarySearch: ()=>binarySearch,
        binarySearchKey: ()=>binarySearchKey,
        bindSourceFile: ()=>bindSourceFile,
        breakIntoCharacterSpans: ()=>breakIntoCharacterSpans,
        breakIntoWordSpans: ()=>breakIntoWordSpans,
        buildLinkParts: ()=>buildLinkParts,
        buildOpts: ()=>buildOpts,
        buildOverload: ()=>buildOverload,
        bundlerModuleNameResolver: ()=>bundlerModuleNameResolver,
        canBeConvertedToAsync: ()=>canBeConvertedToAsync,
        canHaveDecorators: ()=>canHaveDecorators,
        canHaveExportModifier: ()=>canHaveExportModifier,
        canHaveFlowNode: ()=>canHaveFlowNode,
        canHaveIllegalDecorators: ()=>canHaveIllegalDecorators,
        canHaveIllegalModifiers: ()=>canHaveIllegalModifiers,
        canHaveIllegalType: ()=>canHaveIllegalType,
        canHaveIllegalTypeParameters: ()=>canHaveIllegalTypeParameters,
        canHaveJSDoc: ()=>canHaveJSDoc,
        canHaveLocals: ()=>canHaveLocals,
        canHaveModifiers: ()=>canHaveModifiers,
        canHaveSymbol: ()=>canHaveSymbol,
        canJsonReportNoInputFiles: ()=>canJsonReportNoInputFiles,
        canProduceDiagnostics: ()=>canProduceDiagnostics,
        canUsePropertyAccess: ()=>canUsePropertyAccess,
        canWatchAffectingLocation: ()=>canWatchAffectingLocation,
        canWatchAtTypes: ()=>canWatchAtTypes,
        canWatchDirectoryOrFile: ()=>canWatchDirectoryOrFile,
        cartesianProduct: ()=>cartesianProduct,
        cast: ()=>cast,
        chainBundle: ()=>chainBundle,
        chainDiagnosticMessages: ()=>chainDiagnosticMessages,
        changeAnyExtension: ()=>changeAnyExtension,
        changeCompilerHostLikeToUseCache: ()=>changeCompilerHostLikeToUseCache,
        changeExtension: ()=>changeExtension,
        changesAffectModuleResolution: ()=>changesAffectModuleResolution,
        changesAffectingProgramStructure: ()=>changesAffectingProgramStructure,
        childIsDecorated: ()=>childIsDecorated,
        classElementOrClassElementParameterIsDecorated: ()=>classElementOrClassElementParameterIsDecorated,
        classOrConstructorParameterIsDecorated: ()=>classOrConstructorParameterIsDecorated,
        classPrivateFieldGetHelper: ()=>classPrivateFieldGetHelper,
        classPrivateFieldInHelper: ()=>classPrivateFieldInHelper,
        classPrivateFieldSetHelper: ()=>classPrivateFieldSetHelper,
        classicNameResolver: ()=>classicNameResolver,
        classifier: ()=>ts_classifier_exports,
        cleanExtendedConfigCache: ()=>cleanExtendedConfigCache,
        clear: ()=>clear,
        clearMap: ()=>clearMap,
        clearSharedExtendedConfigFileWatcher: ()=>clearSharedExtendedConfigFileWatcher,
        climbPastPropertyAccess: ()=>climbPastPropertyAccess,
        climbPastPropertyOrElementAccess: ()=>climbPastPropertyOrElementAccess,
        clone: ()=>clone,
        cloneCompilerOptions: ()=>cloneCompilerOptions,
        closeFileWatcher: ()=>closeFileWatcher,
        closeFileWatcherOf: ()=>closeFileWatcherOf,
        codefix: ()=>ts_codefix_exports,
        collapseTextChangeRangesAcrossMultipleVersions: ()=>collapseTextChangeRangesAcrossMultipleVersions,
        collectExternalModuleInfo: ()=>collectExternalModuleInfo,
        combine: ()=>combine,
        combinePaths: ()=>combinePaths,
        commentPragmas: ()=>commentPragmas,
        commonOptionsWithBuild: ()=>commonOptionsWithBuild,
        commonPackageFolders: ()=>commonPackageFolders,
        compact: ()=>compact,
        compareBooleans: ()=>compareBooleans,
        compareDataObjects: ()=>compareDataObjects,
        compareDiagnostics: ()=>compareDiagnostics,
        compareDiagnosticsSkipRelatedInformation: ()=>compareDiagnosticsSkipRelatedInformation,
        compareEmitHelpers: ()=>compareEmitHelpers,
        compareNumberOfDirectorySeparators: ()=>compareNumberOfDirectorySeparators,
        comparePaths: ()=>comparePaths,
        comparePathsCaseInsensitive: ()=>comparePathsCaseInsensitive,
        comparePathsCaseSensitive: ()=>comparePathsCaseSensitive,
        comparePatternKeys: ()=>comparePatternKeys,
        compareProperties: ()=>compareProperties,
        compareStringsCaseInsensitive: ()=>compareStringsCaseInsensitive,
        compareStringsCaseInsensitiveEslintCompatible: ()=>compareStringsCaseInsensitiveEslintCompatible,
        compareStringsCaseSensitive: ()=>compareStringsCaseSensitive,
        compareStringsCaseSensitiveUI: ()=>compareStringsCaseSensitiveUI,
        compareTextSpans: ()=>compareTextSpans,
        compareValues: ()=>compareValues,
        compileOnSaveCommandLineOption: ()=>compileOnSaveCommandLineOption,
        compilerOptionsAffectDeclarationPath: ()=>compilerOptionsAffectDeclarationPath,
        compilerOptionsAffectEmit: ()=>compilerOptionsAffectEmit,
        compilerOptionsAffectSemanticDiagnostics: ()=>compilerOptionsAffectSemanticDiagnostics,
        compilerOptionsDidYouMeanDiagnostics: ()=>compilerOptionsDidYouMeanDiagnostics,
        compilerOptionsIndicateEsModules: ()=>compilerOptionsIndicateEsModules,
        compose: ()=>compose,
        computeCommonSourceDirectoryOfFilenames: ()=>computeCommonSourceDirectoryOfFilenames,
        computeLineAndCharacterOfPosition: ()=>computeLineAndCharacterOfPosition,
        computeLineOfPosition: ()=>computeLineOfPosition,
        computeLineStarts: ()=>computeLineStarts,
        computePositionOfLineAndCharacter: ()=>computePositionOfLineAndCharacter,
        computeSignature: ()=>computeSignature,
        computeSignatureWithDiagnostics: ()=>computeSignatureWithDiagnostics,
        computeSuggestionDiagnostics: ()=>computeSuggestionDiagnostics,
        concatenate: ()=>concatenate,
        concatenateDiagnosticMessageChains: ()=>concatenateDiagnosticMessageChains,
        consumesNodeCoreModules: ()=>consumesNodeCoreModules,
        contains: ()=>contains,
        containsIgnoredPath: ()=>containsIgnoredPath,
        containsObjectRestOrSpread: ()=>containsObjectRestOrSpread,
        containsParseError: ()=>containsParseError,
        containsPath: ()=>containsPath,
        convertCompilerOptionsForTelemetry: ()=>convertCompilerOptionsForTelemetry,
        convertCompilerOptionsFromJson: ()=>convertCompilerOptionsFromJson,
        convertJsonOption: ()=>convertJsonOption,
        convertToBase64: ()=>convertToBase64,
        convertToJson: ()=>convertToJson,
        convertToObject: ()=>convertToObject,
        convertToOptionsWithAbsolutePaths: ()=>convertToOptionsWithAbsolutePaths,
        convertToRelativePath: ()=>convertToRelativePath,
        convertToTSConfig: ()=>convertToTSConfig,
        convertTypeAcquisitionFromJson: ()=>convertTypeAcquisitionFromJson,
        copyComments: ()=>copyComments,
        copyEntries: ()=>copyEntries,
        copyLeadingComments: ()=>copyLeadingComments,
        copyProperties: ()=>copyProperties,
        copyTrailingAsLeadingComments: ()=>copyTrailingAsLeadingComments,
        copyTrailingComments: ()=>copyTrailingComments,
        couldStartTrivia: ()=>couldStartTrivia,
        countWhere: ()=>countWhere,
        createAbstractBuilder: ()=>createAbstractBuilder,
        createAccessorPropertyBackingField: ()=>createAccessorPropertyBackingField,
        createAccessorPropertyGetRedirector: ()=>createAccessorPropertyGetRedirector,
        createAccessorPropertySetRedirector: ()=>createAccessorPropertySetRedirector,
        createBaseNodeFactory: ()=>createBaseNodeFactory,
        createBinaryExpressionTrampoline: ()=>createBinaryExpressionTrampoline,
        createBindingHelper: ()=>createBindingHelper,
        createBuildInfo: ()=>createBuildInfo,
        createBuilderProgram: ()=>createBuilderProgram,
        createBuilderProgramUsingProgramBuildInfo: ()=>createBuilderProgramUsingProgramBuildInfo,
        createBuilderStatusReporter: ()=>createBuilderStatusReporter,
        createCacheWithRedirects: ()=>createCacheWithRedirects,
        createCacheableExportInfoMap: ()=>createCacheableExportInfoMap,
        createCachedDirectoryStructureHost: ()=>createCachedDirectoryStructureHost,
        createClassifier: ()=>createClassifier,
        createCommentDirectivesMap: ()=>createCommentDirectivesMap,
        createCompilerDiagnostic: ()=>createCompilerDiagnostic,
        createCompilerDiagnosticForInvalidCustomType: ()=>createCompilerDiagnosticForInvalidCustomType,
        createCompilerDiagnosticFromMessageChain: ()=>createCompilerDiagnosticFromMessageChain,
        createCompilerHost: ()=>createCompilerHost,
        createCompilerHostFromProgramHost: ()=>createCompilerHostFromProgramHost,
        createCompilerHostWorker: ()=>createCompilerHostWorker,
        createDetachedDiagnostic: ()=>createDetachedDiagnostic,
        createDiagnosticCollection: ()=>createDiagnosticCollection,
        createDiagnosticForFileFromMessageChain: ()=>createDiagnosticForFileFromMessageChain,
        createDiagnosticForNode: ()=>createDiagnosticForNode,
        createDiagnosticForNodeArray: ()=>createDiagnosticForNodeArray,
        createDiagnosticForNodeArrayFromMessageChain: ()=>createDiagnosticForNodeArrayFromMessageChain,
        createDiagnosticForNodeFromMessageChain: ()=>createDiagnosticForNodeFromMessageChain,
        createDiagnosticForNodeInSourceFile: ()=>createDiagnosticForNodeInSourceFile,
        createDiagnosticForRange: ()=>createDiagnosticForRange,
        createDiagnosticMessageChainFromDiagnostic: ()=>createDiagnosticMessageChainFromDiagnostic,
        createDiagnosticReporter: ()=>createDiagnosticReporter,
        createDocumentPositionMapper: ()=>createDocumentPositionMapper,
        createDocumentRegistry: ()=>createDocumentRegistry,
        createDocumentRegistryInternal: ()=>createDocumentRegistryInternal,
        createEmitAndSemanticDiagnosticsBuilderProgram: ()=>createEmitAndSemanticDiagnosticsBuilderProgram,
        createEmitHelperFactory: ()=>createEmitHelperFactory,
        createEmptyExports: ()=>createEmptyExports,
        createExpressionForJsxElement: ()=>createExpressionForJsxElement,
        createExpressionForJsxFragment: ()=>createExpressionForJsxFragment,
        createExpressionForObjectLiteralElementLike: ()=>createExpressionForObjectLiteralElementLike,
        createExpressionForPropertyName: ()=>createExpressionForPropertyName,
        createExpressionFromEntityName: ()=>createExpressionFromEntityName,
        createExternalHelpersImportDeclarationIfNeeded: ()=>createExternalHelpersImportDeclarationIfNeeded,
        createFileDiagnostic: ()=>createFileDiagnostic,
        createFileDiagnosticFromMessageChain: ()=>createFileDiagnosticFromMessageChain,
        createForOfBindingStatement: ()=>createForOfBindingStatement,
        createGetCanonicalFileName: ()=>createGetCanonicalFileName,
        createGetSourceFile: ()=>createGetSourceFile,
        createGetSymbolAccessibilityDiagnosticForNode: ()=>createGetSymbolAccessibilityDiagnosticForNode,
        createGetSymbolAccessibilityDiagnosticForNodeName: ()=>createGetSymbolAccessibilityDiagnosticForNodeName,
        createGetSymbolWalker: ()=>createGetSymbolWalker,
        createIncrementalCompilerHost: ()=>createIncrementalCompilerHost,
        createIncrementalProgram: ()=>createIncrementalProgram,
        createInputFiles: ()=>createInputFiles,
        createInputFilesWithFilePaths: ()=>createInputFilesWithFilePaths,
        createInputFilesWithFileTexts: ()=>createInputFilesWithFileTexts,
        createJsxFactoryExpression: ()=>createJsxFactoryExpression,
        createLanguageService: ()=>createLanguageService,
        createLanguageServiceSourceFile: ()=>createLanguageServiceSourceFile,
        createMemberAccessForPropertyName: ()=>createMemberAccessForPropertyName,
        createModeAwareCache: ()=>createModeAwareCache,
        createModeAwareCacheKey: ()=>createModeAwareCacheKey,
        createModuleNotFoundChain: ()=>createModuleNotFoundChain,
        createModuleResolutionCache: ()=>createModuleResolutionCache,
        createModuleResolutionLoader: ()=>createModuleResolutionLoader,
        createModuleSpecifierResolutionHost: ()=>createModuleSpecifierResolutionHost,
        createMultiMap: ()=>createMultiMap,
        createNodeConverters: ()=>createNodeConverters,
        createNodeFactory: ()=>createNodeFactory,
        createOptionNameMap: ()=>createOptionNameMap,
        createOverload: ()=>createOverload,
        createPackageJsonImportFilter: ()=>createPackageJsonImportFilter,
        createPackageJsonInfo: ()=>createPackageJsonInfo,
        createParenthesizerRules: ()=>createParenthesizerRules,
        createPatternMatcher: ()=>createPatternMatcher,
        createPrependNodes: ()=>createPrependNodes,
        createPrinter: ()=>createPrinter,
        createPrinterWithDefaults: ()=>createPrinterWithDefaults,
        createPrinterWithRemoveComments: ()=>createPrinterWithRemoveComments,
        createPrinterWithRemoveCommentsNeverAsciiEscape: ()=>createPrinterWithRemoveCommentsNeverAsciiEscape,
        createPrinterWithRemoveCommentsOmitTrailingSemicolon: ()=>createPrinterWithRemoveCommentsOmitTrailingSemicolon,
        createProgram: ()=>createProgram,
        createProgramHost: ()=>createProgramHost,
        createPropertyNameNodeForIdentifierOrLiteral: ()=>createPropertyNameNodeForIdentifierOrLiteral,
        createQueue: ()=>createQueue,
        createRange: ()=>createRange,
        createRedirectedBuilderProgram: ()=>createRedirectedBuilderProgram,
        createResolutionCache: ()=>createResolutionCache,
        createRuntimeTypeSerializer: ()=>createRuntimeTypeSerializer,
        createScanner: ()=>createScanner,
        createSemanticDiagnosticsBuilderProgram: ()=>createSemanticDiagnosticsBuilderProgram,
        createSet: ()=>createSet,
        createSolutionBuilder: ()=>createSolutionBuilder,
        createSolutionBuilderHost: ()=>createSolutionBuilderHost,
        createSolutionBuilderWithWatch: ()=>createSolutionBuilderWithWatch,
        createSolutionBuilderWithWatchHost: ()=>createSolutionBuilderWithWatchHost,
        createSortedArray: ()=>createSortedArray,
        createSourceFile: ()=>createSourceFile,
        createSourceMapGenerator: ()=>createSourceMapGenerator,
        createSourceMapSource: ()=>createSourceMapSource,
        createSuperAccessVariableStatement: ()=>createSuperAccessVariableStatement,
        createSymbolTable: ()=>createSymbolTable,
        createSymlinkCache: ()=>createSymlinkCache,
        createSystemWatchFunctions: ()=>createSystemWatchFunctions,
        createTextChange: ()=>createTextChange,
        createTextChangeFromStartLength: ()=>createTextChangeFromStartLength,
        createTextChangeRange: ()=>createTextChangeRange,
        createTextRangeFromNode: ()=>createTextRangeFromNode,
        createTextRangeFromSpan: ()=>createTextRangeFromSpan,
        createTextSpan: ()=>createTextSpan,
        createTextSpanFromBounds: ()=>createTextSpanFromBounds,
        createTextSpanFromNode: ()=>createTextSpanFromNode,
        createTextSpanFromRange: ()=>createTextSpanFromRange,
        createTextSpanFromStringLiteralLikeContent: ()=>createTextSpanFromStringLiteralLikeContent,
        createTextWriter: ()=>createTextWriter,
        createTokenRange: ()=>createTokenRange,
        createTypeChecker: ()=>createTypeChecker,
        createTypeReferenceDirectiveResolutionCache: ()=>createTypeReferenceDirectiveResolutionCache,
        createTypeReferenceResolutionLoader: ()=>createTypeReferenceResolutionLoader,
        createUnparsedSourceFile: ()=>createUnparsedSourceFile,
        createWatchCompilerHost: ()=>createWatchCompilerHost2,
        createWatchCompilerHostOfConfigFile: ()=>createWatchCompilerHostOfConfigFile,
        createWatchCompilerHostOfFilesAndCompilerOptions: ()=>createWatchCompilerHostOfFilesAndCompilerOptions,
        createWatchFactory: ()=>createWatchFactory,
        createWatchHost: ()=>createWatchHost,
        createWatchProgram: ()=>createWatchProgram,
        createWatchStatusReporter: ()=>createWatchStatusReporter,
        createWriteFileMeasuringIO: ()=>createWriteFileMeasuringIO,
        declarationNameToString: ()=>declarationNameToString,
        decodeMappings: ()=>decodeMappings,
        decodedTextSpanIntersectsWith: ()=>decodedTextSpanIntersectsWith,
        decorateHelper: ()=>decorateHelper,
        deduplicate: ()=>deduplicate,
        defaultIncludeSpec: ()=>defaultIncludeSpec,
        defaultInitCompilerOptions: ()=>defaultInitCompilerOptions,
        defaultMaximumTruncationLength: ()=>defaultMaximumTruncationLength,
        detectSortCaseSensitivity: ()=>detectSortCaseSensitivity,
        diagnosticCategoryName: ()=>diagnosticCategoryName,
        diagnosticToString: ()=>diagnosticToString,
        directoryProbablyExists: ()=>directoryProbablyExists,
        directorySeparator: ()=>directorySeparator,
        displayPart: ()=>displayPart,
        displayPartsToString: ()=>displayPartsToString,
        disposeEmitNodes: ()=>disposeEmitNodes,
        documentSpansEqual: ()=>documentSpansEqual,
        dumpTracingLegend: ()=>dumpTracingLegend,
        elementAt: ()=>elementAt,
        elideNodes: ()=>elideNodes,
        emitComments: ()=>emitComments,
        emitDetachedComments: ()=>emitDetachedComments,
        emitFiles: ()=>emitFiles,
        emitFilesAndReportErrors: ()=>emitFilesAndReportErrors,
        emitFilesAndReportErrorsAndGetExitStatus: ()=>emitFilesAndReportErrorsAndGetExitStatus,
        emitModuleKindIsNonNodeESM: ()=>emitModuleKindIsNonNodeESM,
        emitNewLineBeforeLeadingCommentOfPosition: ()=>emitNewLineBeforeLeadingCommentOfPosition,
        emitNewLineBeforeLeadingComments: ()=>emitNewLineBeforeLeadingComments,
        emitNewLineBeforeLeadingCommentsOfPosition: ()=>emitNewLineBeforeLeadingCommentsOfPosition,
        emitSkippedWithNoDiagnostics: ()=>emitSkippedWithNoDiagnostics,
        emitUsingBuildInfo: ()=>emitUsingBuildInfo,
        emptyArray: ()=>emptyArray,
        emptyFileSystemEntries: ()=>emptyFileSystemEntries,
        emptyMap: ()=>emptyMap,
        emptyOptions: ()=>emptyOptions,
        emptySet: ()=>emptySet,
        endsWith: ()=>endsWith,
        ensurePathIsNonModuleName: ()=>ensurePathIsNonModuleName,
        ensureScriptKind: ()=>ensureScriptKind,
        ensureTrailingDirectorySeparator: ()=>ensureTrailingDirectorySeparator,
        entityNameToString: ()=>entityNameToString,
        enumerateInsertsAndDeletes: ()=>enumerateInsertsAndDeletes,
        equalOwnProperties: ()=>equalOwnProperties,
        equateStringsCaseInsensitive: ()=>equateStringsCaseInsensitive,
        equateStringsCaseSensitive: ()=>equateStringsCaseSensitive,
        equateValues: ()=>equateValues,
        esDecorateHelper: ()=>esDecorateHelper,
        escapeJsxAttributeString: ()=>escapeJsxAttributeString,
        escapeLeadingUnderscores: ()=>escapeLeadingUnderscores,
        escapeNonAsciiString: ()=>escapeNonAsciiString,
        escapeSnippetText: ()=>escapeSnippetText,
        escapeString: ()=>escapeString,
        every: ()=>every,
        expandPreOrPostfixIncrementOrDecrementExpression: ()=>expandPreOrPostfixIncrementOrDecrementExpression,
        explainFiles: ()=>explainFiles,
        explainIfFileIsRedirectAndImpliedFormat: ()=>explainIfFileIsRedirectAndImpliedFormat,
        exportAssignmentIsAlias: ()=>exportAssignmentIsAlias,
        exportStarHelper: ()=>exportStarHelper,
        expressionResultIsUnused: ()=>expressionResultIsUnused,
        extend: ()=>extend,
        extendsHelper: ()=>extendsHelper,
        extensionFromPath: ()=>extensionFromPath,
        extensionIsTS: ()=>extensionIsTS,
        extensionsNotSupportingExtensionlessResolution: ()=>extensionsNotSupportingExtensionlessResolution,
        externalHelpersModuleNameText: ()=>externalHelpersModuleNameText,
        factory: ()=>factory,
        fileExtensionIs: ()=>fileExtensionIs,
        fileExtensionIsOneOf: ()=>fileExtensionIsOneOf,
        fileIncludeReasonToDiagnostics: ()=>fileIncludeReasonToDiagnostics,
        fileShouldUseJavaScriptRequire: ()=>fileShouldUseJavaScriptRequire,
        filter: ()=>filter,
        filterMutate: ()=>filterMutate,
        filterSemanticDiagnostics: ()=>filterSemanticDiagnostics,
        find: ()=>find,
        findAncestor: ()=>findAncestor,
        findBestPatternMatch: ()=>findBestPatternMatch,
        findChildOfKind: ()=>findChildOfKind,
        findComputedPropertyNameCacheAssignment: ()=>findComputedPropertyNameCacheAssignment,
        findConfigFile: ()=>findConfigFile,
        findContainingList: ()=>findContainingList,
        findDiagnosticForNode: ()=>findDiagnosticForNode,
        findFirstNonJsxWhitespaceToken: ()=>findFirstNonJsxWhitespaceToken,
        findIndex: ()=>findIndex,
        findLast: ()=>findLast,
        findLastIndex: ()=>findLastIndex,
        findListItemInfo: ()=>findListItemInfo,
        findMap: ()=>findMap,
        findModifier: ()=>findModifier,
        findNextToken: ()=>findNextToken,
        findPackageJson: ()=>findPackageJson,
        findPackageJsons: ()=>findPackageJsons,
        findPrecedingMatchingToken: ()=>findPrecedingMatchingToken,
        findPrecedingToken: ()=>findPrecedingToken,
        findSuperStatementIndex: ()=>findSuperStatementIndex,
        findTokenOnLeftOfPosition: ()=>findTokenOnLeftOfPosition,
        findUseStrictPrologue: ()=>findUseStrictPrologue,
        first: ()=>first,
        firstDefined: ()=>firstDefined,
        firstDefinedIterator: ()=>firstDefinedIterator,
        firstIterator: ()=>firstIterator,
        firstOrOnly: ()=>firstOrOnly,
        firstOrUndefined: ()=>firstOrUndefined,
        firstOrUndefinedIterator: ()=>firstOrUndefinedIterator,
        fixupCompilerOptions: ()=>fixupCompilerOptions,
        flatMap: ()=>flatMap,
        flatMapIterator: ()=>flatMapIterator,
        flatMapToMutable: ()=>flatMapToMutable,
        flatten: ()=>flatten,
        flattenCommaList: ()=>flattenCommaList,
        flattenDestructuringAssignment: ()=>flattenDestructuringAssignment,
        flattenDestructuringBinding: ()=>flattenDestructuringBinding,
        flattenDiagnosticMessageText: ()=>flattenDiagnosticMessageText,
        forEach: ()=>forEach,
        forEachAncestor: ()=>forEachAncestor,
        forEachAncestorDirectory: ()=>forEachAncestorDirectory,
        forEachChild: ()=>forEachChild,
        forEachChildRecursively: ()=>forEachChildRecursively,
        forEachEmittedFile: ()=>forEachEmittedFile,
        forEachEnclosingBlockScopeContainer: ()=>forEachEnclosingBlockScopeContainer,
        forEachEntry: ()=>forEachEntry,
        forEachExternalModuleToImportFrom: ()=>forEachExternalModuleToImportFrom,
        forEachImportClauseDeclaration: ()=>forEachImportClauseDeclaration,
        forEachKey: ()=>forEachKey,
        forEachLeadingCommentRange: ()=>forEachLeadingCommentRange,
        forEachNameInAccessChainWalkingLeft: ()=>forEachNameInAccessChainWalkingLeft,
        forEachPropertyAssignment: ()=>forEachPropertyAssignment,
        forEachResolvedProjectReference: ()=>forEachResolvedProjectReference,
        forEachReturnStatement: ()=>forEachReturnStatement,
        forEachRight: ()=>forEachRight,
        forEachTrailingCommentRange: ()=>forEachTrailingCommentRange,
        forEachTsConfigPropArray: ()=>forEachTsConfigPropArray,
        forEachUnique: ()=>forEachUnique,
        forEachYieldExpression: ()=>forEachYieldExpression,
        forSomeAncestorDirectory: ()=>forSomeAncestorDirectory,
        formatColorAndReset: ()=>formatColorAndReset,
        formatDiagnostic: ()=>formatDiagnostic,
        formatDiagnostics: ()=>formatDiagnostics,
        formatDiagnosticsWithColorAndContext: ()=>formatDiagnosticsWithColorAndContext,
        formatGeneratedName: ()=>formatGeneratedName,
        formatGeneratedNamePart: ()=>formatGeneratedNamePart,
        formatLocation: ()=>formatLocation,
        formatMessage: ()=>formatMessage,
        formatStringFromArgs: ()=>formatStringFromArgs,
        formatting: ()=>ts_formatting_exports,
        fullTripleSlashAMDReferencePathRegEx: ()=>fullTripleSlashAMDReferencePathRegEx,
        fullTripleSlashReferencePathRegEx: ()=>fullTripleSlashReferencePathRegEx,
        generateDjb2Hash: ()=>generateDjb2Hash,
        generateTSConfig: ()=>generateTSConfig,
        generatorHelper: ()=>generatorHelper,
        getAdjustedReferenceLocation: ()=>getAdjustedReferenceLocation,
        getAdjustedRenameLocation: ()=>getAdjustedRenameLocation,
        getAliasDeclarationFromName: ()=>getAliasDeclarationFromName,
        getAllAccessorDeclarations: ()=>getAllAccessorDeclarations,
        getAllDecoratorsOfClass: ()=>getAllDecoratorsOfClass,
        getAllDecoratorsOfClassElement: ()=>getAllDecoratorsOfClassElement,
        getAllJSDocTags: ()=>getAllJSDocTags,
        getAllJSDocTagsOfKind: ()=>getAllJSDocTagsOfKind,
        getAllKeys: ()=>getAllKeys,
        getAllProjectOutputs: ()=>getAllProjectOutputs,
        getAllSuperTypeNodes: ()=>getAllSuperTypeNodes,
        getAllUnscopedEmitHelpers: ()=>getAllUnscopedEmitHelpers,
        getAllowJSCompilerOption: ()=>getAllowJSCompilerOption,
        getAllowSyntheticDefaultImports: ()=>getAllowSyntheticDefaultImports,
        getAncestor: ()=>getAncestor,
        getAnyExtensionFromPath: ()=>getAnyExtensionFromPath,
        getAreDeclarationMapsEnabled: ()=>getAreDeclarationMapsEnabled,
        getAssignedExpandoInitializer: ()=>getAssignedExpandoInitializer,
        getAssignedName: ()=>getAssignedName,
        getAssignmentDeclarationKind: ()=>getAssignmentDeclarationKind,
        getAssignmentDeclarationPropertyAccessKind: ()=>getAssignmentDeclarationPropertyAccessKind,
        getAssignmentTargetKind: ()=>getAssignmentTargetKind,
        getAutomaticTypeDirectiveNames: ()=>getAutomaticTypeDirectiveNames,
        getBaseFileName: ()=>getBaseFileName,
        getBinaryOperatorPrecedence: ()=>getBinaryOperatorPrecedence,
        getBuildInfo: ()=>getBuildInfo,
        getBuildInfoFileVersionMap: ()=>getBuildInfoFileVersionMap,
        getBuildInfoText: ()=>getBuildInfoText,
        getBuildOrderFromAnyBuildOrder: ()=>getBuildOrderFromAnyBuildOrder,
        getBuilderCreationParameters: ()=>getBuilderCreationParameters,
        getBuilderFileEmit: ()=>getBuilderFileEmit,
        getCheckFlags: ()=>getCheckFlags,
        getClassExtendsHeritageElement: ()=>getClassExtendsHeritageElement,
        getClassLikeDeclarationOfSymbol: ()=>getClassLikeDeclarationOfSymbol,
        getCombinedLocalAndExportSymbolFlags: ()=>getCombinedLocalAndExportSymbolFlags,
        getCombinedModifierFlags: ()=>getCombinedModifierFlags,
        getCombinedNodeFlags: ()=>getCombinedNodeFlags,
        getCombinedNodeFlagsAlwaysIncludeJSDoc: ()=>getCombinedNodeFlagsAlwaysIncludeJSDoc,
        getCommentRange: ()=>getCommentRange,
        getCommonSourceDirectory: ()=>getCommonSourceDirectory,
        getCommonSourceDirectoryOfConfig: ()=>getCommonSourceDirectoryOfConfig,
        getCompilerOptionValue: ()=>getCompilerOptionValue,
        getCompilerOptionsDiffValue: ()=>getCompilerOptionsDiffValue,
        getConditions: ()=>getConditions,
        getConfigFileParsingDiagnostics: ()=>getConfigFileParsingDiagnostics,
        getConstantValue: ()=>getConstantValue,
        getContainerNode: ()=>getContainerNode,
        getContainingClass: ()=>getContainingClass,
        getContainingClassStaticBlock: ()=>getContainingClassStaticBlock,
        getContainingFunction: ()=>getContainingFunction,
        getContainingFunctionDeclaration: ()=>getContainingFunctionDeclaration,
        getContainingFunctionOrClassStaticBlock: ()=>getContainingFunctionOrClassStaticBlock,
        getContainingNodeArray: ()=>getContainingNodeArray,
        getContainingObjectLiteralElement: ()=>getContainingObjectLiteralElement,
        getContextualTypeFromParent: ()=>getContextualTypeFromParent,
        getContextualTypeFromParentOrAncestorTypeNode: ()=>getContextualTypeFromParentOrAncestorTypeNode,
        getCurrentTime: ()=>getCurrentTime,
        getDeclarationDiagnostics: ()=>getDeclarationDiagnostics,
        getDeclarationEmitExtensionForPath: ()=>getDeclarationEmitExtensionForPath,
        getDeclarationEmitOutputFilePath: ()=>getDeclarationEmitOutputFilePath,
        getDeclarationEmitOutputFilePathWorker: ()=>getDeclarationEmitOutputFilePathWorker,
        getDeclarationFromName: ()=>getDeclarationFromName,
        getDeclarationModifierFlagsFromSymbol: ()=>getDeclarationModifierFlagsFromSymbol,
        getDeclarationOfKind: ()=>getDeclarationOfKind,
        getDeclarationsOfKind: ()=>getDeclarationsOfKind,
        getDeclaredExpandoInitializer: ()=>getDeclaredExpandoInitializer,
        getDecorators: ()=>getDecorators,
        getDefaultCompilerOptions: ()=>getDefaultCompilerOptions2,
        getDefaultExportInfoWorker: ()=>getDefaultExportInfoWorker,
        getDefaultFormatCodeSettings: ()=>getDefaultFormatCodeSettings,
        getDefaultLibFileName: ()=>getDefaultLibFileName,
        getDefaultLibFilePath: ()=>getDefaultLibFilePath,
        getDefaultLikeExportInfo: ()=>getDefaultLikeExportInfo,
        getDiagnosticText: ()=>getDiagnosticText,
        getDiagnosticsWithinSpan: ()=>getDiagnosticsWithinSpan,
        getDirectoryPath: ()=>getDirectoryPath,
        getDirectoryToWatchFailedLookupLocation: ()=>getDirectoryToWatchFailedLookupLocation,
        getDirectoryToWatchFailedLookupLocationFromTypeRoot: ()=>getDirectoryToWatchFailedLookupLocationFromTypeRoot,
        getDocumentPositionMapper: ()=>getDocumentPositionMapper,
        getESModuleInterop: ()=>getESModuleInterop,
        getEditsForFileRename: ()=>getEditsForFileRename,
        getEffectiveBaseTypeNode: ()=>getEffectiveBaseTypeNode,
        getEffectiveConstraintOfTypeParameter: ()=>getEffectiveConstraintOfTypeParameter,
        getEffectiveContainerForJSDocTemplateTag: ()=>getEffectiveContainerForJSDocTemplateTag,
        getEffectiveImplementsTypeNodes: ()=>getEffectiveImplementsTypeNodes,
        getEffectiveInitializer: ()=>getEffectiveInitializer,
        getEffectiveJSDocHost: ()=>getEffectiveJSDocHost,
        getEffectiveModifierFlags: ()=>getEffectiveModifierFlags,
        getEffectiveModifierFlagsAlwaysIncludeJSDoc: ()=>getEffectiveModifierFlagsAlwaysIncludeJSDoc,
        getEffectiveModifierFlagsNoCache: ()=>getEffectiveModifierFlagsNoCache,
        getEffectiveReturnTypeNode: ()=>getEffectiveReturnTypeNode,
        getEffectiveSetAccessorTypeAnnotationNode: ()=>getEffectiveSetAccessorTypeAnnotationNode,
        getEffectiveTypeAnnotationNode: ()=>getEffectiveTypeAnnotationNode,
        getEffectiveTypeParameterDeclarations: ()=>getEffectiveTypeParameterDeclarations,
        getEffectiveTypeRoots: ()=>getEffectiveTypeRoots,
        getElementOrPropertyAccessArgumentExpressionOrName: ()=>getElementOrPropertyAccessArgumentExpressionOrName,
        getElementOrPropertyAccessName: ()=>getElementOrPropertyAccessName,
        getElementsOfBindingOrAssignmentPattern: ()=>getElementsOfBindingOrAssignmentPattern,
        getEmitDeclarations: ()=>getEmitDeclarations,
        getEmitFlags: ()=>getEmitFlags,
        getEmitHelpers: ()=>getEmitHelpers,
        getEmitModuleDetectionKind: ()=>getEmitModuleDetectionKind,
        getEmitModuleKind: ()=>getEmitModuleKind,
        getEmitModuleResolutionKind: ()=>getEmitModuleResolutionKind,
        getEmitScriptTarget: ()=>getEmitScriptTarget,
        getEnclosingBlockScopeContainer: ()=>getEnclosingBlockScopeContainer,
        getEncodedSemanticClassifications: ()=>getEncodedSemanticClassifications,
        getEncodedSyntacticClassifications: ()=>getEncodedSyntacticClassifications,
        getEndLinePosition: ()=>getEndLinePosition,
        getEntityNameFromTypeNode: ()=>getEntityNameFromTypeNode,
        getEntrypointsFromPackageJsonInfo: ()=>getEntrypointsFromPackageJsonInfo,
        getErrorCountForSummary: ()=>getErrorCountForSummary,
        getErrorSpanForNode: ()=>getErrorSpanForNode,
        getErrorSummaryText: ()=>getErrorSummaryText,
        getEscapedTextOfIdentifierOrLiteral: ()=>getEscapedTextOfIdentifierOrLiteral,
        getEscapedTextOfJsxAttributeName: ()=>getEscapedTextOfJsxAttributeName,
        getEscapedTextOfJsxNamespacedName: ()=>getEscapedTextOfJsxNamespacedName,
        getExpandoInitializer: ()=>getExpandoInitializer,
        getExportAssignmentExpression: ()=>getExportAssignmentExpression,
        getExportInfoMap: ()=>getExportInfoMap,
        getExportNeedsImportStarHelper: ()=>getExportNeedsImportStarHelper,
        getExpressionAssociativity: ()=>getExpressionAssociativity,
        getExpressionPrecedence: ()=>getExpressionPrecedence,
        getExternalHelpersModuleName: ()=>getExternalHelpersModuleName,
        getExternalModuleImportEqualsDeclarationExpression: ()=>getExternalModuleImportEqualsDeclarationExpression,
        getExternalModuleName: ()=>getExternalModuleName,
        getExternalModuleNameFromDeclaration: ()=>getExternalModuleNameFromDeclaration,
        getExternalModuleNameFromPath: ()=>getExternalModuleNameFromPath,
        getExternalModuleNameLiteral: ()=>getExternalModuleNameLiteral,
        getExternalModuleRequireArgument: ()=>getExternalModuleRequireArgument,
        getFallbackOptions: ()=>getFallbackOptions,
        getFileEmitOutput: ()=>getFileEmitOutput,
        getFileMatcherPatterns: ()=>getFileMatcherPatterns,
        getFileNamesFromConfigSpecs: ()=>getFileNamesFromConfigSpecs,
        getFileWatcherEventKind: ()=>getFileWatcherEventKind,
        getFilesInErrorForSummary: ()=>getFilesInErrorForSummary,
        getFirstConstructorWithBody: ()=>getFirstConstructorWithBody,
        getFirstIdentifier: ()=>getFirstIdentifier,
        getFirstNonSpaceCharacterPosition: ()=>getFirstNonSpaceCharacterPosition,
        getFirstProjectOutput: ()=>getFirstProjectOutput,
        getFixableErrorSpanExpression: ()=>getFixableErrorSpanExpression,
        getFormatCodeSettingsForWriting: ()=>getFormatCodeSettingsForWriting,
        getFullWidth: ()=>getFullWidth,
        getFunctionFlags: ()=>getFunctionFlags,
        getHeritageClause: ()=>getHeritageClause,
        getHostSignatureFromJSDoc: ()=>getHostSignatureFromJSDoc,
        getIdentifierAutoGenerate: ()=>getIdentifierAutoGenerate,
        getIdentifierGeneratedImportReference: ()=>getIdentifierGeneratedImportReference,
        getIdentifierTypeArguments: ()=>getIdentifierTypeArguments,
        getImmediatelyInvokedFunctionExpression: ()=>getImmediatelyInvokedFunctionExpression,
        getImpliedNodeFormatForFile: ()=>getImpliedNodeFormatForFile,
        getImpliedNodeFormatForFileWorker: ()=>getImpliedNodeFormatForFileWorker,
        getImportNeedsImportDefaultHelper: ()=>getImportNeedsImportDefaultHelper,
        getImportNeedsImportStarHelper: ()=>getImportNeedsImportStarHelper,
        getIndentSize: ()=>getIndentSize,
        getIndentString: ()=>getIndentString,
        getInferredLibraryNameResolveFrom: ()=>getInferredLibraryNameResolveFrom,
        getInitializedVariables: ()=>getInitializedVariables,
        getInitializerOfBinaryExpression: ()=>getInitializerOfBinaryExpression,
        getInitializerOfBindingOrAssignmentElement: ()=>getInitializerOfBindingOrAssignmentElement,
        getInterfaceBaseTypeNodes: ()=>getInterfaceBaseTypeNodes,
        getInternalEmitFlags: ()=>getInternalEmitFlags,
        getInvokedExpression: ()=>getInvokedExpression,
        getIsolatedModules: ()=>getIsolatedModules,
        getJSDocAugmentsTag: ()=>getJSDocAugmentsTag,
        getJSDocClassTag: ()=>getJSDocClassTag,
        getJSDocCommentRanges: ()=>getJSDocCommentRanges,
        getJSDocCommentsAndTags: ()=>getJSDocCommentsAndTags,
        getJSDocDeprecatedTag: ()=>getJSDocDeprecatedTag,
        getJSDocDeprecatedTagNoCache: ()=>getJSDocDeprecatedTagNoCache,
        getJSDocEnumTag: ()=>getJSDocEnumTag,
        getJSDocHost: ()=>getJSDocHost,
        getJSDocImplementsTags: ()=>getJSDocImplementsTags,
        getJSDocOverrideTagNoCache: ()=>getJSDocOverrideTagNoCache,
        getJSDocParameterTags: ()=>getJSDocParameterTags,
        getJSDocParameterTagsNoCache: ()=>getJSDocParameterTagsNoCache,
        getJSDocPrivateTag: ()=>getJSDocPrivateTag,
        getJSDocPrivateTagNoCache: ()=>getJSDocPrivateTagNoCache,
        getJSDocProtectedTag: ()=>getJSDocProtectedTag,
        getJSDocProtectedTagNoCache: ()=>getJSDocProtectedTagNoCache,
        getJSDocPublicTag: ()=>getJSDocPublicTag,
        getJSDocPublicTagNoCache: ()=>getJSDocPublicTagNoCache,
        getJSDocReadonlyTag: ()=>getJSDocReadonlyTag,
        getJSDocReadonlyTagNoCache: ()=>getJSDocReadonlyTagNoCache,
        getJSDocReturnTag: ()=>getJSDocReturnTag,
        getJSDocReturnType: ()=>getJSDocReturnType,
        getJSDocRoot: ()=>getJSDocRoot,
        getJSDocSatisfiesExpressionType: ()=>getJSDocSatisfiesExpressionType,
        getJSDocSatisfiesTag: ()=>getJSDocSatisfiesTag,
        getJSDocTags: ()=>getJSDocTags,
        getJSDocTagsNoCache: ()=>getJSDocTagsNoCache,
        getJSDocTemplateTag: ()=>getJSDocTemplateTag,
        getJSDocThisTag: ()=>getJSDocThisTag,
        getJSDocType: ()=>getJSDocType,
        getJSDocTypeAliasName: ()=>getJSDocTypeAliasName,
        getJSDocTypeAssertionType: ()=>getJSDocTypeAssertionType,
        getJSDocTypeParameterDeclarations: ()=>getJSDocTypeParameterDeclarations,
        getJSDocTypeParameterTags: ()=>getJSDocTypeParameterTags,
        getJSDocTypeParameterTagsNoCache: ()=>getJSDocTypeParameterTagsNoCache,
        getJSDocTypeTag: ()=>getJSDocTypeTag,
        getJSXImplicitImportBase: ()=>getJSXImplicitImportBase,
        getJSXRuntimeImport: ()=>getJSXRuntimeImport,
        getJSXTransformEnabled: ()=>getJSXTransformEnabled,
        getKeyForCompilerOptions: ()=>getKeyForCompilerOptions,
        getLanguageVariant: ()=>getLanguageVariant,
        getLastChild: ()=>getLastChild,
        getLeadingCommentRanges: ()=>getLeadingCommentRanges,
        getLeadingCommentRangesOfNode: ()=>getLeadingCommentRangesOfNode,
        getLeftmostAccessExpression: ()=>getLeftmostAccessExpression,
        getLeftmostExpression: ()=>getLeftmostExpression,
        getLineAndCharacterOfPosition: ()=>getLineAndCharacterOfPosition,
        getLineInfo: ()=>getLineInfo,
        getLineOfLocalPosition: ()=>getLineOfLocalPosition,
        getLineOfLocalPositionFromLineMap: ()=>getLineOfLocalPositionFromLineMap,
        getLineStartPositionForPosition: ()=>getLineStartPositionForPosition,
        getLineStarts: ()=>getLineStarts,
        getLinesBetweenPositionAndNextNonWhitespaceCharacter: ()=>getLinesBetweenPositionAndNextNonWhitespaceCharacter,
        getLinesBetweenPositionAndPrecedingNonWhitespaceCharacter: ()=>getLinesBetweenPositionAndPrecedingNonWhitespaceCharacter,
        getLinesBetweenPositions: ()=>getLinesBetweenPositions,
        getLinesBetweenRangeEndAndRangeStart: ()=>getLinesBetweenRangeEndAndRangeStart,
        getLinesBetweenRangeEndPositions: ()=>getLinesBetweenRangeEndPositions,
        getLiteralText: ()=>getLiteralText,
        getLocalNameForExternalImport: ()=>getLocalNameForExternalImport,
        getLocalSymbolForExportDefault: ()=>getLocalSymbolForExportDefault,
        getLocaleSpecificMessage: ()=>getLocaleSpecificMessage,
        getLocaleTimeString: ()=>getLocaleTimeString,
        getMappedContextSpan: ()=>getMappedContextSpan,
        getMappedDocumentSpan: ()=>getMappedDocumentSpan,
        getMappedLocation: ()=>getMappedLocation,
        getMatchedFileSpec: ()=>getMatchedFileSpec,
        getMatchedIncludeSpec: ()=>getMatchedIncludeSpec,
        getMeaningFromDeclaration: ()=>getMeaningFromDeclaration,
        getMeaningFromLocation: ()=>getMeaningFromLocation,
        getMembersOfDeclaration: ()=>getMembersOfDeclaration,
        getModeForFileReference: ()=>getModeForFileReference,
        getModeForResolutionAtIndex: ()=>getModeForResolutionAtIndex,
        getModeForUsageLocation: ()=>getModeForUsageLocation,
        getModifiedTime: ()=>getModifiedTime,
        getModifiers: ()=>getModifiers,
        getModuleInstanceState: ()=>getModuleInstanceState,
        getModuleNameStringLiteralAt: ()=>getModuleNameStringLiteralAt,
        getModuleSpecifierEndingPreference: ()=>getModuleSpecifierEndingPreference,
        getModuleSpecifierResolverHost: ()=>getModuleSpecifierResolverHost,
        getNameForExportedSymbol: ()=>getNameForExportedSymbol,
        getNameFromIndexInfo: ()=>getNameFromIndexInfo,
        getNameFromPropertyName: ()=>getNameFromPropertyName,
        getNameOfAccessExpression: ()=>getNameOfAccessExpression,
        getNameOfCompilerOptionValue: ()=>getNameOfCompilerOptionValue,
        getNameOfDeclaration: ()=>getNameOfDeclaration,
        getNameOfExpando: ()=>getNameOfExpando,
        getNameOfJSDocTypedef: ()=>getNameOfJSDocTypedef,
        getNameOrArgument: ()=>getNameOrArgument,
        getNameTable: ()=>getNameTable,
        getNamesForExportedSymbol: ()=>getNamesForExportedSymbol,
        getNamespaceDeclarationNode: ()=>getNamespaceDeclarationNode,
        getNewLineCharacter: ()=>getNewLineCharacter,
        getNewLineKind: ()=>getNewLineKind,
        getNewLineOrDefaultFromHost: ()=>getNewLineOrDefaultFromHost,
        getNewTargetContainer: ()=>getNewTargetContainer,
        getNextJSDocCommentLocation: ()=>getNextJSDocCommentLocation,
        getNodeForGeneratedName: ()=>getNodeForGeneratedName,
        getNodeId: ()=>getNodeId,
        getNodeKind: ()=>getNodeKind,
        getNodeModifiers: ()=>getNodeModifiers,
        getNodeModulePathParts: ()=>getNodeModulePathParts,
        getNonAssignedNameOfDeclaration: ()=>getNonAssignedNameOfDeclaration,
        getNonAssignmentOperatorForCompoundAssignment: ()=>getNonAssignmentOperatorForCompoundAssignment,
        getNonAugmentationDeclaration: ()=>getNonAugmentationDeclaration,
        getNonDecoratorTokenPosOfNode: ()=>getNonDecoratorTokenPosOfNode,
        getNormalizedAbsolutePath: ()=>getNormalizedAbsolutePath,
        getNormalizedAbsolutePathWithoutRoot: ()=>getNormalizedAbsolutePathWithoutRoot,
        getNormalizedPathComponents: ()=>getNormalizedPathComponents,
        getObjectFlags: ()=>getObjectFlags,
        getOperator: ()=>getOperator,
        getOperatorAssociativity: ()=>getOperatorAssociativity,
        getOperatorPrecedence: ()=>getOperatorPrecedence,
        getOptionFromName: ()=>getOptionFromName,
        getOptionsForLibraryResolution: ()=>getOptionsForLibraryResolution,
        getOptionsNameMap: ()=>getOptionsNameMap,
        getOrCreateEmitNode: ()=>getOrCreateEmitNode,
        getOrCreateExternalHelpersModuleNameIfNeeded: ()=>getOrCreateExternalHelpersModuleNameIfNeeded,
        getOrUpdate: ()=>getOrUpdate,
        getOriginalNode: ()=>getOriginalNode,
        getOriginalNodeId: ()=>getOriginalNodeId,
        getOriginalSourceFile: ()=>getOriginalSourceFile,
        getOutputDeclarationFileName: ()=>getOutputDeclarationFileName,
        getOutputExtension: ()=>getOutputExtension,
        getOutputFileNames: ()=>getOutputFileNames,
        getOutputPathsFor: ()=>getOutputPathsFor,
        getOutputPathsForBundle: ()=>getOutputPathsForBundle,
        getOwnEmitOutputFilePath: ()=>getOwnEmitOutputFilePath,
        getOwnKeys: ()=>getOwnKeys,
        getOwnValues: ()=>getOwnValues,
        getPackageJsonInfo: ()=>getPackageJsonInfo,
        getPackageJsonTypesVersionsPaths: ()=>getPackageJsonTypesVersionsPaths,
        getPackageJsonsVisibleToFile: ()=>getPackageJsonsVisibleToFile,
        getPackageNameFromTypesPackageName: ()=>getPackageNameFromTypesPackageName,
        getPackageScopeForPath: ()=>getPackageScopeForPath,
        getParameterSymbolFromJSDoc: ()=>getParameterSymbolFromJSDoc,
        getParameterTypeNode: ()=>getParameterTypeNode,
        getParentNodeInSpan: ()=>getParentNodeInSpan,
        getParseTreeNode: ()=>getParseTreeNode,
        getParsedCommandLineOfConfigFile: ()=>getParsedCommandLineOfConfigFile,
        getPathComponents: ()=>getPathComponents,
        getPathComponentsRelativeTo: ()=>getPathComponentsRelativeTo,
        getPathFromPathComponents: ()=>getPathFromPathComponents,
        getPathUpdater: ()=>getPathUpdater,
        getPathsBasePath: ()=>getPathsBasePath,
        getPatternFromSpec: ()=>getPatternFromSpec,
        getPendingEmitKind: ()=>getPendingEmitKind,
        getPositionOfLineAndCharacter: ()=>getPositionOfLineAndCharacter,
        getPossibleGenericSignatures: ()=>getPossibleGenericSignatures,
        getPossibleOriginalInputExtensionForExtension: ()=>getPossibleOriginalInputExtensionForExtension,
        getPossibleTypeArgumentsInfo: ()=>getPossibleTypeArgumentsInfo,
        getPreEmitDiagnostics: ()=>getPreEmitDiagnostics,
        getPrecedingNonSpaceCharacterPosition: ()=>getPrecedingNonSpaceCharacterPosition,
        getPrivateIdentifier: ()=>getPrivateIdentifier,
        getProperties: ()=>getProperties,
        getProperty: ()=>getProperty,
        getPropertyArrayElementValue: ()=>getPropertyArrayElementValue,
        getPropertyAssignmentAliasLikeExpression: ()=>getPropertyAssignmentAliasLikeExpression,
        getPropertyNameForPropertyNameNode: ()=>getPropertyNameForPropertyNameNode,
        getPropertyNameForUniqueESSymbol: ()=>getPropertyNameForUniqueESSymbol,
        getPropertyNameOfBindingOrAssignmentElement: ()=>getPropertyNameOfBindingOrAssignmentElement,
        getPropertySymbolFromBindingElement: ()=>getPropertySymbolFromBindingElement,
        getPropertySymbolsFromContextualType: ()=>getPropertySymbolsFromContextualType,
        getQuoteFromPreference: ()=>getQuoteFromPreference,
        getQuotePreference: ()=>getQuotePreference,
        getRangesWhere: ()=>getRangesWhere,
        getRefactorContextSpan: ()=>getRefactorContextSpan,
        getReferencedFileLocation: ()=>getReferencedFileLocation,
        getRegexFromPattern: ()=>getRegexFromPattern,
        getRegularExpressionForWildcard: ()=>getRegularExpressionForWildcard,
        getRegularExpressionsForWildcards: ()=>getRegularExpressionsForWildcards,
        getRelativePathFromDirectory: ()=>getRelativePathFromDirectory,
        getRelativePathFromFile: ()=>getRelativePathFromFile,
        getRelativePathToDirectoryOrUrl: ()=>getRelativePathToDirectoryOrUrl,
        getRenameLocation: ()=>getRenameLocation,
        getReplacementSpanForContextToken: ()=>getReplacementSpanForContextToken,
        getResolutionDiagnostic: ()=>getResolutionDiagnostic,
        getResolutionModeOverrideForClause: ()=>getResolutionModeOverrideForClause,
        getResolveJsonModule: ()=>getResolveJsonModule,
        getResolvePackageJsonExports: ()=>getResolvePackageJsonExports,
        getResolvePackageJsonImports: ()=>getResolvePackageJsonImports,
        getResolvedExternalModuleName: ()=>getResolvedExternalModuleName,
        getResolvedModule: ()=>getResolvedModule,
        getResolvedTypeReferenceDirective: ()=>getResolvedTypeReferenceDirective,
        getRestIndicatorOfBindingOrAssignmentElement: ()=>getRestIndicatorOfBindingOrAssignmentElement,
        getRestParameterElementType: ()=>getRestParameterElementType,
        getRightMostAssignedExpression: ()=>getRightMostAssignedExpression,
        getRootDeclaration: ()=>getRootDeclaration,
        getRootDirectoryOfResolutionCache: ()=>getRootDirectoryOfResolutionCache,
        getRootLength: ()=>getRootLength,
        getRootPathSplitLength: ()=>getRootPathSplitLength,
        getScriptKind: ()=>getScriptKind,
        getScriptKindFromFileName: ()=>getScriptKindFromFileName,
        getScriptTargetFeatures: ()=>getScriptTargetFeatures,
        getSelectedEffectiveModifierFlags: ()=>getSelectedEffectiveModifierFlags,
        getSelectedSyntacticModifierFlags: ()=>getSelectedSyntacticModifierFlags,
        getSemanticClassifications: ()=>getSemanticClassifications,
        getSemanticJsxChildren: ()=>getSemanticJsxChildren,
        getSetAccessorTypeAnnotationNode: ()=>getSetAccessorTypeAnnotationNode,
        getSetAccessorValueParameter: ()=>getSetAccessorValueParameter,
        getSetExternalModuleIndicator: ()=>getSetExternalModuleIndicator,
        getShebang: ()=>getShebang,
        getSingleInitializerOfVariableStatementOrPropertyDeclaration: ()=>getSingleInitializerOfVariableStatementOrPropertyDeclaration,
        getSingleVariableOfVariableStatement: ()=>getSingleVariableOfVariableStatement,
        getSnapshotText: ()=>getSnapshotText,
        getSnippetElement: ()=>getSnippetElement,
        getSourceFileOfModule: ()=>getSourceFileOfModule,
        getSourceFileOfNode: ()=>getSourceFileOfNode,
        getSourceFilePathInNewDir: ()=>getSourceFilePathInNewDir,
        getSourceFilePathInNewDirWorker: ()=>getSourceFilePathInNewDirWorker,
        getSourceFileVersionAsHashFromText: ()=>getSourceFileVersionAsHashFromText,
        getSourceFilesToEmit: ()=>getSourceFilesToEmit,
        getSourceMapRange: ()=>getSourceMapRange,
        getSourceMapper: ()=>getSourceMapper,
        getSourceTextOfNodeFromSourceFile: ()=>getSourceTextOfNodeFromSourceFile,
        getSpanOfTokenAtPosition: ()=>getSpanOfTokenAtPosition,
        getSpellingSuggestion: ()=>getSpellingSuggestion,
        getStartPositionOfLine: ()=>getStartPositionOfLine,
        getStartPositionOfRange: ()=>getStartPositionOfRange,
        getStartsOnNewLine: ()=>getStartsOnNewLine,
        getStaticPropertiesAndClassStaticBlock: ()=>getStaticPropertiesAndClassStaticBlock,
        getStrictOptionValue: ()=>getStrictOptionValue,
        getStringComparer: ()=>getStringComparer,
        getSuperCallFromStatement: ()=>getSuperCallFromStatement,
        getSuperContainer: ()=>getSuperContainer,
        getSupportedCodeFixes: ()=>getSupportedCodeFixes,
        getSupportedExtensions: ()=>getSupportedExtensions,
        getSupportedExtensionsWithJsonIfResolveJsonModule: ()=>getSupportedExtensionsWithJsonIfResolveJsonModule,
        getSwitchedType: ()=>getSwitchedType,
        getSymbolId: ()=>getSymbolId,
        getSymbolNameForPrivateIdentifier: ()=>getSymbolNameForPrivateIdentifier,
        getSymbolTarget: ()=>getSymbolTarget,
        getSyntacticClassifications: ()=>getSyntacticClassifications,
        getSyntacticModifierFlags: ()=>getSyntacticModifierFlags,
        getSyntacticModifierFlagsNoCache: ()=>getSyntacticModifierFlagsNoCache,
        getSynthesizedDeepClone: ()=>getSynthesizedDeepClone,
        getSynthesizedDeepCloneWithReplacements: ()=>getSynthesizedDeepCloneWithReplacements,
        getSynthesizedDeepClones: ()=>getSynthesizedDeepClones,
        getSynthesizedDeepClonesWithReplacements: ()=>getSynthesizedDeepClonesWithReplacements,
        getSyntheticLeadingComments: ()=>getSyntheticLeadingComments,
        getSyntheticTrailingComments: ()=>getSyntheticTrailingComments,
        getTargetLabel: ()=>getTargetLabel,
        getTargetOfBindingOrAssignmentElement: ()=>getTargetOfBindingOrAssignmentElement,
        getTemporaryModuleResolutionState: ()=>getTemporaryModuleResolutionState,
        getTextOfConstantValue: ()=>getTextOfConstantValue,
        getTextOfIdentifierOrLiteral: ()=>getTextOfIdentifierOrLiteral,
        getTextOfJSDocComment: ()=>getTextOfJSDocComment,
        getTextOfJsxAttributeName: ()=>getTextOfJsxAttributeName,
        getTextOfJsxNamespacedName: ()=>getTextOfJsxNamespacedName,
        getTextOfNode: ()=>getTextOfNode,
        getTextOfNodeFromSourceText: ()=>getTextOfNodeFromSourceText,
        getTextOfPropertyName: ()=>getTextOfPropertyName,
        getThisContainer: ()=>getThisContainer,
        getThisParameter: ()=>getThisParameter,
        getTokenAtPosition: ()=>getTokenAtPosition,
        getTokenPosOfNode: ()=>getTokenPosOfNode,
        getTokenSourceMapRange: ()=>getTokenSourceMapRange,
        getTouchingPropertyName: ()=>getTouchingPropertyName,
        getTouchingToken: ()=>getTouchingToken,
        getTrailingCommentRanges: ()=>getTrailingCommentRanges,
        getTrailingSemicolonDeferringWriter: ()=>getTrailingSemicolonDeferringWriter,
        getTransformFlagsSubtreeExclusions: ()=>getTransformFlagsSubtreeExclusions,
        getTransformers: ()=>getTransformers,
        getTsBuildInfoEmitOutputFilePath: ()=>getTsBuildInfoEmitOutputFilePath,
        getTsConfigObjectLiteralExpression: ()=>getTsConfigObjectLiteralExpression,
        getTsConfigPropArrayElementValue: ()=>getTsConfigPropArrayElementValue,
        getTypeAnnotationNode: ()=>getTypeAnnotationNode,
        getTypeArgumentOrTypeParameterList: ()=>getTypeArgumentOrTypeParameterList,
        getTypeKeywordOfTypeOnlyImport: ()=>getTypeKeywordOfTypeOnlyImport,
        getTypeNode: ()=>getTypeNode,
        getTypeNodeIfAccessible: ()=>getTypeNodeIfAccessible,
        getTypeParameterFromJsDoc: ()=>getTypeParameterFromJsDoc,
        getTypeParameterOwner: ()=>getTypeParameterOwner,
        getTypesPackageName: ()=>getTypesPackageName,
        getUILocale: ()=>getUILocale,
        getUniqueName: ()=>getUniqueName,
        getUniqueSymbolId: ()=>getUniqueSymbolId,
        getUseDefineForClassFields: ()=>getUseDefineForClassFields,
        getWatchErrorSummaryDiagnosticMessage: ()=>getWatchErrorSummaryDiagnosticMessage,
        getWatchFactory: ()=>getWatchFactory,
        group: ()=>group,
        groupBy: ()=>groupBy,
        guessIndentation: ()=>guessIndentation,
        handleNoEmitOptions: ()=>handleNoEmitOptions,
        hasAbstractModifier: ()=>hasAbstractModifier,
        hasAccessorModifier: ()=>hasAccessorModifier,
        hasAmbientModifier: ()=>hasAmbientModifier,
        hasChangesInResolutions: ()=>hasChangesInResolutions,
        hasChildOfKind: ()=>hasChildOfKind,
        hasContextSensitiveParameters: ()=>hasContextSensitiveParameters,
        hasDecorators: ()=>hasDecorators,
        hasDocComment: ()=>hasDocComment,
        hasDynamicName: ()=>hasDynamicName,
        hasEffectiveModifier: ()=>hasEffectiveModifier,
        hasEffectiveModifiers: ()=>hasEffectiveModifiers,
        hasEffectiveReadonlyModifier: ()=>hasEffectiveReadonlyModifier,
        hasExtension: ()=>hasExtension,
        hasIndexSignature: ()=>hasIndexSignature,
        hasInitializer: ()=>hasInitializer,
        hasInvalidEscape: ()=>hasInvalidEscape,
        hasJSDocNodes: ()=>hasJSDocNodes,
        hasJSDocParameterTags: ()=>hasJSDocParameterTags,
        hasJSFileExtension: ()=>hasJSFileExtension,
        hasJsonModuleEmitEnabled: ()=>hasJsonModuleEmitEnabled,
        hasOnlyExpressionInitializer: ()=>hasOnlyExpressionInitializer,
        hasOverrideModifier: ()=>hasOverrideModifier,
        hasPossibleExternalModuleReference: ()=>hasPossibleExternalModuleReference,
        hasProperty: ()=>hasProperty,
        hasPropertyAccessExpressionWithName: ()=>hasPropertyAccessExpressionWithName,
        hasQuestionToken: ()=>hasQuestionToken,
        hasRecordedExternalHelpers: ()=>hasRecordedExternalHelpers,
        hasRestParameter: ()=>hasRestParameter,
        hasScopeMarker: ()=>hasScopeMarker,
        hasStaticModifier: ()=>hasStaticModifier,
        hasSyntacticModifier: ()=>hasSyntacticModifier,
        hasSyntacticModifiers: ()=>hasSyntacticModifiers,
        hasTSFileExtension: ()=>hasTSFileExtension,
        hasTabstop: ()=>hasTabstop,
        hasTrailingDirectorySeparator: ()=>hasTrailingDirectorySeparator,
        hasType: ()=>hasType,
        hasTypeArguments: ()=>hasTypeArguments,
        hasZeroOrOneAsteriskCharacter: ()=>hasZeroOrOneAsteriskCharacter,
        helperString: ()=>helperString,
        hostGetCanonicalFileName: ()=>hostGetCanonicalFileName,
        hostUsesCaseSensitiveFileNames: ()=>hostUsesCaseSensitiveFileNames,
        idText: ()=>idText,
        identifierIsThisKeyword: ()=>identifierIsThisKeyword,
        identifierToKeywordKind: ()=>identifierToKeywordKind,
        identity: ()=>identity,
        identitySourceMapConsumer: ()=>identitySourceMapConsumer,
        ignoreSourceNewlines: ()=>ignoreSourceNewlines,
        ignoredPaths: ()=>ignoredPaths,
        importDefaultHelper: ()=>importDefaultHelper,
        importFromModuleSpecifier: ()=>importFromModuleSpecifier,
        importNameElisionDisabled: ()=>importNameElisionDisabled,
        importStarHelper: ()=>importStarHelper,
        indexOfAnyCharCode: ()=>indexOfAnyCharCode,
        indexOfNode: ()=>indexOfNode,
        indicesOf: ()=>indicesOf,
        inferredTypesContainingFile: ()=>inferredTypesContainingFile,
        insertImports: ()=>insertImports,
        insertLeadingStatement: ()=>insertLeadingStatement,
        insertSorted: ()=>insertSorted,
        insertStatementAfterCustomPrologue: ()=>insertStatementAfterCustomPrologue,
        insertStatementAfterStandardPrologue: ()=>insertStatementAfterStandardPrologue,
        insertStatementsAfterCustomPrologue: ()=>insertStatementsAfterCustomPrologue,
        insertStatementsAfterStandardPrologue: ()=>insertStatementsAfterStandardPrologue,
        intersperse: ()=>intersperse,
        intrinsicTagNameToString: ()=>intrinsicTagNameToString,
        introducesArgumentsExoticObject: ()=>introducesArgumentsExoticObject,
        inverseJsxOptionMap: ()=>inverseJsxOptionMap,
        isAbstractConstructorSymbol: ()=>isAbstractConstructorSymbol,
        isAbstractModifier: ()=>isAbstractModifier,
        isAccessExpression: ()=>isAccessExpression,
        isAccessibilityModifier: ()=>isAccessibilityModifier,
        isAccessor: ()=>isAccessor,
        isAccessorModifier: ()=>isAccessorModifier,
        isAliasSymbolDeclaration: ()=>isAliasSymbolDeclaration,
        isAliasableExpression: ()=>isAliasableExpression,
        isAmbientModule: ()=>isAmbientModule,
        isAmbientPropertyDeclaration: ()=>isAmbientPropertyDeclaration,
        isAnonymousFunctionDefinition: ()=>isAnonymousFunctionDefinition,
        isAnyDirectorySeparator: ()=>isAnyDirectorySeparator,
        isAnyImportOrBareOrAccessedRequire: ()=>isAnyImportOrBareOrAccessedRequire,
        isAnyImportOrReExport: ()=>isAnyImportOrReExport,
        isAnyImportSyntax: ()=>isAnyImportSyntax,
        isAnySupportedFileExtension: ()=>isAnySupportedFileExtension,
        isApplicableVersionedTypesKey: ()=>isApplicableVersionedTypesKey,
        isArgumentExpressionOfElementAccess: ()=>isArgumentExpressionOfElementAccess,
        isArray: ()=>isArray,
        isArrayBindingElement: ()=>isArrayBindingElement,
        isArrayBindingOrAssignmentElement: ()=>isArrayBindingOrAssignmentElement,
        isArrayBindingOrAssignmentPattern: ()=>isArrayBindingOrAssignmentPattern,
        isArrayBindingPattern: ()=>isArrayBindingPattern,
        isArrayLiteralExpression: ()=>isArrayLiteralExpression,
        isArrayLiteralOrObjectLiteralDestructuringPattern: ()=>isArrayLiteralOrObjectLiteralDestructuringPattern,
        isArrayTypeNode: ()=>isArrayTypeNode,
        isArrowFunction: ()=>isArrowFunction,
        isAsExpression: ()=>isAsExpression,
        isAssertClause: ()=>isAssertClause,
        isAssertEntry: ()=>isAssertEntry,
        isAssertionExpression: ()=>isAssertionExpression,
        isAssertionKey: ()=>isAssertionKey,
        isAssertsKeyword: ()=>isAssertsKeyword,
        isAssignmentDeclaration: ()=>isAssignmentDeclaration,
        isAssignmentExpression: ()=>isAssignmentExpression,
        isAssignmentOperator: ()=>isAssignmentOperator,
        isAssignmentPattern: ()=>isAssignmentPattern,
        isAssignmentTarget: ()=>isAssignmentTarget,
        isAsteriskToken: ()=>isAsteriskToken,
        isAsyncFunction: ()=>isAsyncFunction,
        isAsyncModifier: ()=>isAsyncModifier,
        isAutoAccessorPropertyDeclaration: ()=>isAutoAccessorPropertyDeclaration,
        isAwaitExpression: ()=>isAwaitExpression,
        isAwaitKeyword: ()=>isAwaitKeyword,
        isBigIntLiteral: ()=>isBigIntLiteral,
        isBinaryExpression: ()=>isBinaryExpression,
        isBinaryOperatorToken: ()=>isBinaryOperatorToken,
        isBindableObjectDefinePropertyCall: ()=>isBindableObjectDefinePropertyCall,
        isBindableStaticAccessExpression: ()=>isBindableStaticAccessExpression,
        isBindableStaticElementAccessExpression: ()=>isBindableStaticElementAccessExpression,
        isBindableStaticNameExpression: ()=>isBindableStaticNameExpression,
        isBindingElement: ()=>isBindingElement,
        isBindingElementOfBareOrAccessedRequire: ()=>isBindingElementOfBareOrAccessedRequire,
        isBindingName: ()=>isBindingName,
        isBindingOrAssignmentElement: ()=>isBindingOrAssignmentElement,
        isBindingOrAssignmentPattern: ()=>isBindingOrAssignmentPattern,
        isBindingPattern: ()=>isBindingPattern,
        isBlock: ()=>isBlock,
        isBlockOrCatchScoped: ()=>isBlockOrCatchScoped,
        isBlockScope: ()=>isBlockScope,
        isBlockScopedContainerTopLevel: ()=>isBlockScopedContainerTopLevel,
        isBooleanLiteral: ()=>isBooleanLiteral,
        isBreakOrContinueStatement: ()=>isBreakOrContinueStatement,
        isBreakStatement: ()=>isBreakStatement,
        isBuildInfoFile: ()=>isBuildInfoFile,
        isBuilderProgram: ()=>isBuilderProgram2,
        isBundle: ()=>isBundle,
        isBundleFileTextLike: ()=>isBundleFileTextLike,
        isCallChain: ()=>isCallChain,
        isCallExpression: ()=>isCallExpression,
        isCallExpressionTarget: ()=>isCallExpressionTarget,
        isCallLikeExpression: ()=>isCallLikeExpression,
        isCallOrNewExpression: ()=>isCallOrNewExpression,
        isCallOrNewExpressionTarget: ()=>isCallOrNewExpressionTarget,
        isCallSignatureDeclaration: ()=>isCallSignatureDeclaration,
        isCallToHelper: ()=>isCallToHelper,
        isCaseBlock: ()=>isCaseBlock,
        isCaseClause: ()=>isCaseClause,
        isCaseKeyword: ()=>isCaseKeyword,
        isCaseOrDefaultClause: ()=>isCaseOrDefaultClause,
        isCatchClause: ()=>isCatchClause,
        isCatchClauseVariableDeclaration: ()=>isCatchClauseVariableDeclaration,
        isCatchClauseVariableDeclarationOrBindingElement: ()=>isCatchClauseVariableDeclarationOrBindingElement,
        isCheckJsEnabledForFile: ()=>isCheckJsEnabledForFile,
        isChildOfNodeWithKind: ()=>isChildOfNodeWithKind,
        isCircularBuildOrder: ()=>isCircularBuildOrder,
        isClassDeclaration: ()=>isClassDeclaration,
        isClassElement: ()=>isClassElement,
        isClassExpression: ()=>isClassExpression,
        isClassLike: ()=>isClassLike,
        isClassMemberModifier: ()=>isClassMemberModifier,
        isClassOrTypeElement: ()=>isClassOrTypeElement,
        isClassStaticBlockDeclaration: ()=>isClassStaticBlockDeclaration,
        isCollapsedRange: ()=>isCollapsedRange,
        isColonToken: ()=>isColonToken,
        isCommaExpression: ()=>isCommaExpression,
        isCommaListExpression: ()=>isCommaListExpression,
        isCommaSequence: ()=>isCommaSequence,
        isCommaToken: ()=>isCommaToken,
        isComment: ()=>isComment,
        isCommonJsExportPropertyAssignment: ()=>isCommonJsExportPropertyAssignment,
        isCommonJsExportedExpression: ()=>isCommonJsExportedExpression,
        isCompoundAssignment: ()=>isCompoundAssignment,
        isComputedNonLiteralName: ()=>isComputedNonLiteralName,
        isComputedPropertyName: ()=>isComputedPropertyName,
        isConciseBody: ()=>isConciseBody,
        isConditionalExpression: ()=>isConditionalExpression,
        isConditionalTypeNode: ()=>isConditionalTypeNode,
        isConstTypeReference: ()=>isConstTypeReference,
        isConstructSignatureDeclaration: ()=>isConstructSignatureDeclaration,
        isConstructorDeclaration: ()=>isConstructorDeclaration,
        isConstructorTypeNode: ()=>isConstructorTypeNode,
        isContextualKeyword: ()=>isContextualKeyword,
        isContinueStatement: ()=>isContinueStatement,
        isCustomPrologue: ()=>isCustomPrologue,
        isDebuggerStatement: ()=>isDebuggerStatement,
        isDeclaration: ()=>isDeclaration,
        isDeclarationBindingElement: ()=>isDeclarationBindingElement,
        isDeclarationFileName: ()=>isDeclarationFileName,
        isDeclarationName: ()=>isDeclarationName,
        isDeclarationNameOfEnumOrNamespace: ()=>isDeclarationNameOfEnumOrNamespace,
        isDeclarationReadonly: ()=>isDeclarationReadonly,
        isDeclarationStatement: ()=>isDeclarationStatement,
        isDeclarationWithTypeParameterChildren: ()=>isDeclarationWithTypeParameterChildren,
        isDeclarationWithTypeParameters: ()=>isDeclarationWithTypeParameters,
        isDecorator: ()=>isDecorator,
        isDecoratorTarget: ()=>isDecoratorTarget,
        isDefaultClause: ()=>isDefaultClause,
        isDefaultImport: ()=>isDefaultImport,
        isDefaultModifier: ()=>isDefaultModifier,
        isDefaultedExpandoInitializer: ()=>isDefaultedExpandoInitializer,
        isDeleteExpression: ()=>isDeleteExpression,
        isDeleteTarget: ()=>isDeleteTarget,
        isDeprecatedDeclaration: ()=>isDeprecatedDeclaration,
        isDestructuringAssignment: ()=>isDestructuringAssignment,
        isDiagnosticWithLocation: ()=>isDiagnosticWithLocation,
        isDiskPathRoot: ()=>isDiskPathRoot,
        isDoStatement: ()=>isDoStatement,
        isDotDotDotToken: ()=>isDotDotDotToken,
        isDottedName: ()=>isDottedName,
        isDynamicName: ()=>isDynamicName,
        isESSymbolIdentifier: ()=>isESSymbolIdentifier,
        isEffectiveExternalModule: ()=>isEffectiveExternalModule,
        isEffectiveModuleDeclaration: ()=>isEffectiveModuleDeclaration,
        isEffectiveStrictModeSourceFile: ()=>isEffectiveStrictModeSourceFile,
        isElementAccessChain: ()=>isElementAccessChain,
        isElementAccessExpression: ()=>isElementAccessExpression,
        isEmittedFileOfProgram: ()=>isEmittedFileOfProgram,
        isEmptyArrayLiteral: ()=>isEmptyArrayLiteral,
        isEmptyBindingElement: ()=>isEmptyBindingElement,
        isEmptyBindingPattern: ()=>isEmptyBindingPattern,
        isEmptyObjectLiteral: ()=>isEmptyObjectLiteral,
        isEmptyStatement: ()=>isEmptyStatement,
        isEmptyStringLiteral: ()=>isEmptyStringLiteral,
        isEntityName: ()=>isEntityName,
        isEntityNameExpression: ()=>isEntityNameExpression,
        isEnumConst: ()=>isEnumConst,
        isEnumDeclaration: ()=>isEnumDeclaration,
        isEnumMember: ()=>isEnumMember,
        isEqualityOperatorKind: ()=>isEqualityOperatorKind,
        isEqualsGreaterThanToken: ()=>isEqualsGreaterThanToken,
        isExclamationToken: ()=>isExclamationToken,
        isExcludedFile: ()=>isExcludedFile,
        isExclusivelyTypeOnlyImportOrExport: ()=>isExclusivelyTypeOnlyImportOrExport,
        isExportAssignment: ()=>isExportAssignment,
        isExportDeclaration: ()=>isExportDeclaration,
        isExportModifier: ()=>isExportModifier,
        isExportName: ()=>isExportName,
        isExportNamespaceAsDefaultDeclaration: ()=>isExportNamespaceAsDefaultDeclaration,
        isExportOrDefaultModifier: ()=>isExportOrDefaultModifier,
        isExportSpecifier: ()=>isExportSpecifier,
        isExportsIdentifier: ()=>isExportsIdentifier,
        isExportsOrModuleExportsOrAlias: ()=>isExportsOrModuleExportsOrAlias,
        isExpression: ()=>isExpression,
        isExpressionNode: ()=>isExpressionNode,
        isExpressionOfExternalModuleImportEqualsDeclaration: ()=>isExpressionOfExternalModuleImportEqualsDeclaration,
        isExpressionOfOptionalChainRoot: ()=>isExpressionOfOptionalChainRoot,
        isExpressionStatement: ()=>isExpressionStatement,
        isExpressionWithTypeArguments: ()=>isExpressionWithTypeArguments,
        isExpressionWithTypeArgumentsInClassExtendsClause: ()=>isExpressionWithTypeArgumentsInClassExtendsClause,
        isExternalModule: ()=>isExternalModule,
        isExternalModuleAugmentation: ()=>isExternalModuleAugmentation,
        isExternalModuleImportEqualsDeclaration: ()=>isExternalModuleImportEqualsDeclaration,
        isExternalModuleIndicator: ()=>isExternalModuleIndicator,
        isExternalModuleNameRelative: ()=>isExternalModuleNameRelative,
        isExternalModuleReference: ()=>isExternalModuleReference,
        isExternalModuleSymbol: ()=>isExternalModuleSymbol,
        isExternalOrCommonJsModule: ()=>isExternalOrCommonJsModule,
        isFileLevelUniqueName: ()=>isFileLevelUniqueName,
        isFileProbablyExternalModule: ()=>isFileProbablyExternalModule,
        isFirstDeclarationOfSymbolParameter: ()=>isFirstDeclarationOfSymbolParameter,
        isFixablePromiseHandler: ()=>isFixablePromiseHandler,
        isForInOrOfStatement: ()=>isForInOrOfStatement,
        isForInStatement: ()=>isForInStatement,
        isForInitializer: ()=>isForInitializer,
        isForOfStatement: ()=>isForOfStatement,
        isForStatement: ()=>isForStatement,
        isFunctionBlock: ()=>isFunctionBlock,
        isFunctionBody: ()=>isFunctionBody,
        isFunctionDeclaration: ()=>isFunctionDeclaration,
        isFunctionExpression: ()=>isFunctionExpression,
        isFunctionExpressionOrArrowFunction: ()=>isFunctionExpressionOrArrowFunction,
        isFunctionLike: ()=>isFunctionLike,
        isFunctionLikeDeclaration: ()=>isFunctionLikeDeclaration,
        isFunctionLikeKind: ()=>isFunctionLikeKind,
        isFunctionLikeOrClassStaticBlockDeclaration: ()=>isFunctionLikeOrClassStaticBlockDeclaration,
        isFunctionOrConstructorTypeNode: ()=>isFunctionOrConstructorTypeNode,
        isFunctionOrModuleBlock: ()=>isFunctionOrModuleBlock,
        isFunctionSymbol: ()=>isFunctionSymbol,
        isFunctionTypeNode: ()=>isFunctionTypeNode,
        isFutureReservedKeyword: ()=>isFutureReservedKeyword,
        isGeneratedIdentifier: ()=>isGeneratedIdentifier,
        isGeneratedPrivateIdentifier: ()=>isGeneratedPrivateIdentifier,
        isGetAccessor: ()=>isGetAccessor,
        isGetAccessorDeclaration: ()=>isGetAccessorDeclaration,
        isGetOrSetAccessorDeclaration: ()=>isGetOrSetAccessorDeclaration,
        isGlobalDeclaration: ()=>isGlobalDeclaration,
        isGlobalScopeAugmentation: ()=>isGlobalScopeAugmentation,
        isGrammarError: ()=>isGrammarError,
        isHeritageClause: ()=>isHeritageClause,
        isHoistedFunction: ()=>isHoistedFunction,
        isHoistedVariableStatement: ()=>isHoistedVariableStatement,
        isIdentifier: ()=>isIdentifier,
        isIdentifierANonContextualKeyword: ()=>isIdentifierANonContextualKeyword,
        isIdentifierName: ()=>isIdentifierName,
        isIdentifierOrThisTypeNode: ()=>isIdentifierOrThisTypeNode,
        isIdentifierPart: ()=>isIdentifierPart,
        isIdentifierStart: ()=>isIdentifierStart,
        isIdentifierText: ()=>isIdentifierText,
        isIdentifierTypePredicate: ()=>isIdentifierTypePredicate,
        isIdentifierTypeReference: ()=>isIdentifierTypeReference,
        isIfStatement: ()=>isIfStatement,
        isIgnoredFileFromWildCardWatching: ()=>isIgnoredFileFromWildCardWatching,
        isImplicitGlob: ()=>isImplicitGlob,
        isImportCall: ()=>isImportCall,
        isImportClause: ()=>isImportClause,
        isImportDeclaration: ()=>isImportDeclaration,
        isImportEqualsDeclaration: ()=>isImportEqualsDeclaration,
        isImportKeyword: ()=>isImportKeyword,
        isImportMeta: ()=>isImportMeta,
        isImportOrExportSpecifier: ()=>isImportOrExportSpecifier,
        isImportOrExportSpecifierName: ()=>isImportOrExportSpecifierName,
        isImportSpecifier: ()=>isImportSpecifier,
        isImportTypeAssertionContainer: ()=>isImportTypeAssertionContainer,
        isImportTypeNode: ()=>isImportTypeNode,
        isImportableFile: ()=>isImportableFile,
        isInComment: ()=>isInComment,
        isInExpressionContext: ()=>isInExpressionContext,
        isInJSDoc: ()=>isInJSDoc,
        isInJSFile: ()=>isInJSFile,
        isInJSXText: ()=>isInJSXText,
        isInJsonFile: ()=>isInJsonFile,
        isInNonReferenceComment: ()=>isInNonReferenceComment,
        isInReferenceComment: ()=>isInReferenceComment,
        isInRightSideOfInternalImportEqualsDeclaration: ()=>isInRightSideOfInternalImportEqualsDeclaration,
        isInString: ()=>isInString,
        isInTemplateString: ()=>isInTemplateString,
        isInTopLevelContext: ()=>isInTopLevelContext,
        isIncrementalCompilation: ()=>isIncrementalCompilation,
        isIndexSignatureDeclaration: ()=>isIndexSignatureDeclaration,
        isIndexedAccessTypeNode: ()=>isIndexedAccessTypeNode,
        isInferTypeNode: ()=>isInferTypeNode,
        isInfinityOrNaNString: ()=>isInfinityOrNaNString,
        isInitializedProperty: ()=>isInitializedProperty,
        isInitializedVariable: ()=>isInitializedVariable,
        isInsideJsxElement: ()=>isInsideJsxElement,
        isInsideJsxElementOrAttribute: ()=>isInsideJsxElementOrAttribute,
        isInsideNodeModules: ()=>isInsideNodeModules,
        isInsideTemplateLiteral: ()=>isInsideTemplateLiteral,
        isInstantiatedModule: ()=>isInstantiatedModule,
        isInterfaceDeclaration: ()=>isInterfaceDeclaration,
        isInternalDeclaration: ()=>isInternalDeclaration,
        isInternalModuleImportEqualsDeclaration: ()=>isInternalModuleImportEqualsDeclaration,
        isInternalName: ()=>isInternalName,
        isIntersectionTypeNode: ()=>isIntersectionTypeNode,
        isIntrinsicJsxName: ()=>isIntrinsicJsxName,
        isIterationStatement: ()=>isIterationStatement,
        isJSDoc: ()=>isJSDoc,
        isJSDocAllType: ()=>isJSDocAllType,
        isJSDocAugmentsTag: ()=>isJSDocAugmentsTag,
        isJSDocAuthorTag: ()=>isJSDocAuthorTag,
        isJSDocCallbackTag: ()=>isJSDocCallbackTag,
        isJSDocClassTag: ()=>isJSDocClassTag,
        isJSDocCommentContainingNode: ()=>isJSDocCommentContainingNode,
        isJSDocConstructSignature: ()=>isJSDocConstructSignature,
        isJSDocDeprecatedTag: ()=>isJSDocDeprecatedTag,
        isJSDocEnumTag: ()=>isJSDocEnumTag,
        isJSDocFunctionType: ()=>isJSDocFunctionType,
        isJSDocImplementsTag: ()=>isJSDocImplementsTag,
        isJSDocIndexSignature: ()=>isJSDocIndexSignature,
        isJSDocLikeText: ()=>isJSDocLikeText,
        isJSDocLink: ()=>isJSDocLink,
        isJSDocLinkCode: ()=>isJSDocLinkCode,
        isJSDocLinkLike: ()=>isJSDocLinkLike,
        isJSDocLinkPlain: ()=>isJSDocLinkPlain,
        isJSDocMemberName: ()=>isJSDocMemberName,
        isJSDocNameReference: ()=>isJSDocNameReference,
        isJSDocNamepathType: ()=>isJSDocNamepathType,
        isJSDocNamespaceBody: ()=>isJSDocNamespaceBody,
        isJSDocNode: ()=>isJSDocNode,
        isJSDocNonNullableType: ()=>isJSDocNonNullableType,
        isJSDocNullableType: ()=>isJSDocNullableType,
        isJSDocOptionalParameter: ()=>isJSDocOptionalParameter,
        isJSDocOptionalType: ()=>isJSDocOptionalType,
        isJSDocOverloadTag: ()=>isJSDocOverloadTag,
        isJSDocOverrideTag: ()=>isJSDocOverrideTag,
        isJSDocParameterTag: ()=>isJSDocParameterTag,
        isJSDocPrivateTag: ()=>isJSDocPrivateTag,
        isJSDocPropertyLikeTag: ()=>isJSDocPropertyLikeTag,
        isJSDocPropertyTag: ()=>isJSDocPropertyTag,
        isJSDocProtectedTag: ()=>isJSDocProtectedTag,
        isJSDocPublicTag: ()=>isJSDocPublicTag,
        isJSDocReadonlyTag: ()=>isJSDocReadonlyTag,
        isJSDocReturnTag: ()=>isJSDocReturnTag,
        isJSDocSatisfiesExpression: ()=>isJSDocSatisfiesExpression,
        isJSDocSatisfiesTag: ()=>isJSDocSatisfiesTag,
        isJSDocSeeTag: ()=>isJSDocSeeTag,
        isJSDocSignature: ()=>isJSDocSignature,
        isJSDocTag: ()=>isJSDocTag,
        isJSDocTemplateTag: ()=>isJSDocTemplateTag,
        isJSDocThisTag: ()=>isJSDocThisTag,
        isJSDocThrowsTag: ()=>isJSDocThrowsTag,
        isJSDocTypeAlias: ()=>isJSDocTypeAlias,
        isJSDocTypeAssertion: ()=>isJSDocTypeAssertion,
        isJSDocTypeExpression: ()=>isJSDocTypeExpression,
        isJSDocTypeLiteral: ()=>isJSDocTypeLiteral,
        isJSDocTypeTag: ()=>isJSDocTypeTag,
        isJSDocTypedefTag: ()=>isJSDocTypedefTag,
        isJSDocUnknownTag: ()=>isJSDocUnknownTag,
        isJSDocUnknownType: ()=>isJSDocUnknownType,
        isJSDocVariadicType: ()=>isJSDocVariadicType,
        isJSXTagName: ()=>isJSXTagName,
        isJsonEqual: ()=>isJsonEqual,
        isJsonSourceFile: ()=>isJsonSourceFile,
        isJsxAttribute: ()=>isJsxAttribute,
        isJsxAttributeLike: ()=>isJsxAttributeLike,
        isJsxAttributeName: ()=>isJsxAttributeName,
        isJsxAttributes: ()=>isJsxAttributes,
        isJsxChild: ()=>isJsxChild,
        isJsxClosingElement: ()=>isJsxClosingElement,
        isJsxClosingFragment: ()=>isJsxClosingFragment,
        isJsxElement: ()=>isJsxElement,
        isJsxExpression: ()=>isJsxExpression,
        isJsxFragment: ()=>isJsxFragment,
        isJsxNamespacedName: ()=>isJsxNamespacedName,
        isJsxOpeningElement: ()=>isJsxOpeningElement,
        isJsxOpeningFragment: ()=>isJsxOpeningFragment,
        isJsxOpeningLikeElement: ()=>isJsxOpeningLikeElement,
        isJsxOpeningLikeElementTagName: ()=>isJsxOpeningLikeElementTagName,
        isJsxSelfClosingElement: ()=>isJsxSelfClosingElement,
        isJsxSpreadAttribute: ()=>isJsxSpreadAttribute,
        isJsxTagNameExpression: ()=>isJsxTagNameExpression,
        isJsxText: ()=>isJsxText,
        isJumpStatementTarget: ()=>isJumpStatementTarget,
        isKeyword: ()=>isKeyword,
        isKeywordOrPunctuation: ()=>isKeywordOrPunctuation,
        isKnownSymbol: ()=>isKnownSymbol,
        isLabelName: ()=>isLabelName,
        isLabelOfLabeledStatement: ()=>isLabelOfLabeledStatement,
        isLabeledStatement: ()=>isLabeledStatement,
        isLateVisibilityPaintedStatement: ()=>isLateVisibilityPaintedStatement,
        isLeftHandSideExpression: ()=>isLeftHandSideExpression,
        isLeftHandSideOfAssignment: ()=>isLeftHandSideOfAssignment,
        isLet: ()=>isLet,
        isLineBreak: ()=>isLineBreak,
        isLiteralComputedPropertyDeclarationName: ()=>isLiteralComputedPropertyDeclarationName,
        isLiteralExpression: ()=>isLiteralExpression,
        isLiteralExpressionOfObject: ()=>isLiteralExpressionOfObject,
        isLiteralImportTypeNode: ()=>isLiteralImportTypeNode,
        isLiteralKind: ()=>isLiteralKind,
        isLiteralLikeAccess: ()=>isLiteralLikeAccess,
        isLiteralLikeElementAccess: ()=>isLiteralLikeElementAccess,
        isLiteralNameOfPropertyDeclarationOrIndexAccess: ()=>isLiteralNameOfPropertyDeclarationOrIndexAccess,
        isLiteralTypeLikeExpression: ()=>isLiteralTypeLikeExpression,
        isLiteralTypeLiteral: ()=>isLiteralTypeLiteral,
        isLiteralTypeNode: ()=>isLiteralTypeNode,
        isLocalName: ()=>isLocalName,
        isLogicalOperator: ()=>isLogicalOperator,
        isLogicalOrCoalescingAssignmentExpression: ()=>isLogicalOrCoalescingAssignmentExpression,
        isLogicalOrCoalescingAssignmentOperator: ()=>isLogicalOrCoalescingAssignmentOperator,
        isLogicalOrCoalescingBinaryExpression: ()=>isLogicalOrCoalescingBinaryExpression,
        isLogicalOrCoalescingBinaryOperator: ()=>isLogicalOrCoalescingBinaryOperator,
        isMappedTypeNode: ()=>isMappedTypeNode,
        isMemberName: ()=>isMemberName,
        isMetaProperty: ()=>isMetaProperty,
        isMethodDeclaration: ()=>isMethodDeclaration,
        isMethodOrAccessor: ()=>isMethodOrAccessor,
        isMethodSignature: ()=>isMethodSignature,
        isMinusToken: ()=>isMinusToken,
        isMissingDeclaration: ()=>isMissingDeclaration,
        isModifier: ()=>isModifier,
        isModifierKind: ()=>isModifierKind,
        isModifierLike: ()=>isModifierLike,
        isModuleAugmentationExternal: ()=>isModuleAugmentationExternal,
        isModuleBlock: ()=>isModuleBlock,
        isModuleBody: ()=>isModuleBody,
        isModuleDeclaration: ()=>isModuleDeclaration,
        isModuleExportsAccessExpression: ()=>isModuleExportsAccessExpression,
        isModuleIdentifier: ()=>isModuleIdentifier,
        isModuleName: ()=>isModuleName,
        isModuleOrEnumDeclaration: ()=>isModuleOrEnumDeclaration,
        isModuleReference: ()=>isModuleReference,
        isModuleSpecifierLike: ()=>isModuleSpecifierLike,
        isModuleWithStringLiteralName: ()=>isModuleWithStringLiteralName,
        isNameOfFunctionDeclaration: ()=>isNameOfFunctionDeclaration,
        isNameOfModuleDeclaration: ()=>isNameOfModuleDeclaration,
        isNamedClassElement: ()=>isNamedClassElement,
        isNamedDeclaration: ()=>isNamedDeclaration,
        isNamedEvaluation: ()=>isNamedEvaluation,
        isNamedEvaluationSource: ()=>isNamedEvaluationSource,
        isNamedExportBindings: ()=>isNamedExportBindings,
        isNamedExports: ()=>isNamedExports,
        isNamedImportBindings: ()=>isNamedImportBindings,
        isNamedImports: ()=>isNamedImports,
        isNamedImportsOrExports: ()=>isNamedImportsOrExports,
        isNamedTupleMember: ()=>isNamedTupleMember,
        isNamespaceBody: ()=>isNamespaceBody,
        isNamespaceExport: ()=>isNamespaceExport,
        isNamespaceExportDeclaration: ()=>isNamespaceExportDeclaration,
        isNamespaceImport: ()=>isNamespaceImport,
        isNamespaceReexportDeclaration: ()=>isNamespaceReexportDeclaration,
        isNewExpression: ()=>isNewExpression,
        isNewExpressionTarget: ()=>isNewExpressionTarget,
        isNightly: ()=>isNightly,
        isNoSubstitutionTemplateLiteral: ()=>isNoSubstitutionTemplateLiteral,
        isNode: ()=>isNode,
        isNodeArray: ()=>isNodeArray,
        isNodeArrayMultiLine: ()=>isNodeArrayMultiLine,
        isNodeDescendantOf: ()=>isNodeDescendantOf,
        isNodeKind: ()=>isNodeKind,
        isNodeLikeSystem: ()=>isNodeLikeSystem,
        isNodeModulesDirectory: ()=>isNodeModulesDirectory,
        isNodeWithPossibleHoistedDeclaration: ()=>isNodeWithPossibleHoistedDeclaration,
        isNonContextualKeyword: ()=>isNonContextualKeyword,
        isNonExportDefaultModifier: ()=>isNonExportDefaultModifier,
        isNonGlobalAmbientModule: ()=>isNonGlobalAmbientModule,
        isNonGlobalDeclaration: ()=>isNonGlobalDeclaration,
        isNonNullAccess: ()=>isNonNullAccess,
        isNonNullChain: ()=>isNonNullChain,
        isNonNullExpression: ()=>isNonNullExpression,
        isNonStaticMethodOrAccessorWithPrivateName: ()=>isNonStaticMethodOrAccessorWithPrivateName,
        isNotEmittedOrPartiallyEmittedNode: ()=>isNotEmittedOrPartiallyEmittedNode,
        isNotEmittedStatement: ()=>isNotEmittedStatement,
        isNullishCoalesce: ()=>isNullishCoalesce,
        isNumber: ()=>isNumber,
        isNumericLiteral: ()=>isNumericLiteral,
        isNumericLiteralName: ()=>isNumericLiteralName,
        isObjectBindingElementWithoutPropertyName: ()=>isObjectBindingElementWithoutPropertyName,
        isObjectBindingOrAssignmentElement: ()=>isObjectBindingOrAssignmentElement,
        isObjectBindingOrAssignmentPattern: ()=>isObjectBindingOrAssignmentPattern,
        isObjectBindingPattern: ()=>isObjectBindingPattern,
        isObjectLiteralElement: ()=>isObjectLiteralElement,
        isObjectLiteralElementLike: ()=>isObjectLiteralElementLike,
        isObjectLiteralExpression: ()=>isObjectLiteralExpression,
        isObjectLiteralMethod: ()=>isObjectLiteralMethod,
        isObjectLiteralOrClassExpressionMethodOrAccessor: ()=>isObjectLiteralOrClassExpressionMethodOrAccessor,
        isObjectTypeDeclaration: ()=>isObjectTypeDeclaration,
        isOctalDigit: ()=>isOctalDigit,
        isOmittedExpression: ()=>isOmittedExpression,
        isOptionalChain: ()=>isOptionalChain,
        isOptionalChainRoot: ()=>isOptionalChainRoot,
        isOptionalDeclaration: ()=>isOptionalDeclaration,
        isOptionalJSDocPropertyLikeTag: ()=>isOptionalJSDocPropertyLikeTag,
        isOptionalTypeNode: ()=>isOptionalTypeNode,
        isOuterExpression: ()=>isOuterExpression,
        isOutermostOptionalChain: ()=>isOutermostOptionalChain,
        isOverrideModifier: ()=>isOverrideModifier,
        isPackedArrayLiteral: ()=>isPackedArrayLiteral,
        isParameter: ()=>isParameter,
        isParameterDeclaration: ()=>isParameterDeclaration,
        isParameterOrCatchClauseVariable: ()=>isParameterOrCatchClauseVariable,
        isParameterPropertyDeclaration: ()=>isParameterPropertyDeclaration,
        isParameterPropertyModifier: ()=>isParameterPropertyModifier,
        isParenthesizedExpression: ()=>isParenthesizedExpression,
        isParenthesizedTypeNode: ()=>isParenthesizedTypeNode,
        isParseTreeNode: ()=>isParseTreeNode,
        isPartOfTypeNode: ()=>isPartOfTypeNode,
        isPartOfTypeQuery: ()=>isPartOfTypeQuery,
        isPartiallyEmittedExpression: ()=>isPartiallyEmittedExpression,
        isPatternMatch: ()=>isPatternMatch,
        isPinnedComment: ()=>isPinnedComment,
        isPlainJsFile: ()=>isPlainJsFile,
        isPlusToken: ()=>isPlusToken,
        isPossiblyTypeArgumentPosition: ()=>isPossiblyTypeArgumentPosition,
        isPostfixUnaryExpression: ()=>isPostfixUnaryExpression,
        isPrefixUnaryExpression: ()=>isPrefixUnaryExpression,
        isPrivateIdentifier: ()=>isPrivateIdentifier,
        isPrivateIdentifierClassElementDeclaration: ()=>isPrivateIdentifierClassElementDeclaration,
        isPrivateIdentifierPropertyAccessExpression: ()=>isPrivateIdentifierPropertyAccessExpression,
        isPrivateIdentifierSymbol: ()=>isPrivateIdentifierSymbol,
        isProgramBundleEmitBuildInfo: ()=>isProgramBundleEmitBuildInfo,
        isProgramUptoDate: ()=>isProgramUptoDate,
        isPrologueDirective: ()=>isPrologueDirective,
        isPropertyAccessChain: ()=>isPropertyAccessChain,
        isPropertyAccessEntityNameExpression: ()=>isPropertyAccessEntityNameExpression,
        isPropertyAccessExpression: ()=>isPropertyAccessExpression,
        isPropertyAccessOrQualifiedName: ()=>isPropertyAccessOrQualifiedName,
        isPropertyAccessOrQualifiedNameOrImportTypeNode: ()=>isPropertyAccessOrQualifiedNameOrImportTypeNode,
        isPropertyAssignment: ()=>isPropertyAssignment,
        isPropertyDeclaration: ()=>isPropertyDeclaration,
        isPropertyName: ()=>isPropertyName,
        isPropertyNameLiteral: ()=>isPropertyNameLiteral,
        isPropertySignature: ()=>isPropertySignature,
        isProtoSetter: ()=>isProtoSetter,
        isPrototypeAccess: ()=>isPrototypeAccess,
        isPrototypePropertyAssignment: ()=>isPrototypePropertyAssignment,
        isPunctuation: ()=>isPunctuation,
        isPushOrUnshiftIdentifier: ()=>isPushOrUnshiftIdentifier,
        isQualifiedName: ()=>isQualifiedName,
        isQuestionDotToken: ()=>isQuestionDotToken,
        isQuestionOrExclamationToken: ()=>isQuestionOrExclamationToken,
        isQuestionOrPlusOrMinusToken: ()=>isQuestionOrPlusOrMinusToken,
        isQuestionToken: ()=>isQuestionToken,
        isRawSourceMap: ()=>isRawSourceMap,
        isReadonlyKeyword: ()=>isReadonlyKeyword,
        isReadonlyKeywordOrPlusOrMinusToken: ()=>isReadonlyKeywordOrPlusOrMinusToken,
        isRecognizedTripleSlashComment: ()=>isRecognizedTripleSlashComment,
        isReferenceFileLocation: ()=>isReferenceFileLocation,
        isReferencedFile: ()=>isReferencedFile,
        isRegularExpressionLiteral: ()=>isRegularExpressionLiteral,
        isRequireCall: ()=>isRequireCall,
        isRequireVariableStatement: ()=>isRequireVariableStatement,
        isRestParameter: ()=>isRestParameter,
        isRestTypeNode: ()=>isRestTypeNode,
        isReturnStatement: ()=>isReturnStatement,
        isReturnStatementWithFixablePromiseHandler: ()=>isReturnStatementWithFixablePromiseHandler,
        isRightSideOfAccessExpression: ()=>isRightSideOfAccessExpression,
        isRightSideOfPropertyAccess: ()=>isRightSideOfPropertyAccess,
        isRightSideOfQualifiedName: ()=>isRightSideOfQualifiedName,
        isRightSideOfQualifiedNameOrPropertyAccess: ()=>isRightSideOfQualifiedNameOrPropertyAccess,
        isRightSideOfQualifiedNameOrPropertyAccessOrJSDocMemberName: ()=>isRightSideOfQualifiedNameOrPropertyAccessOrJSDocMemberName,
        isRootedDiskPath: ()=>isRootedDiskPath,
        isSameEntityName: ()=>isSameEntityName,
        isSatisfiesExpression: ()=>isSatisfiesExpression,
        isScopeMarker: ()=>isScopeMarker,
        isSemicolonClassElement: ()=>isSemicolonClassElement,
        isSetAccessor: ()=>isSetAccessor,
        isSetAccessorDeclaration: ()=>isSetAccessorDeclaration,
        isShebangTrivia: ()=>isShebangTrivia,
        isShorthandAmbientModuleSymbol: ()=>isShorthandAmbientModuleSymbol,
        isShorthandPropertyAssignment: ()=>isShorthandPropertyAssignment,
        isSignedNumericLiteral: ()=>isSignedNumericLiteral,
        isSimpleCopiableExpression: ()=>isSimpleCopiableExpression,
        isSimpleInlineableExpression: ()=>isSimpleInlineableExpression,
        isSingleOrDoubleQuote: ()=>isSingleOrDoubleQuote,
        isSourceFile: ()=>isSourceFile,
        isSourceFileFromLibrary: ()=>isSourceFileFromLibrary,
        isSourceFileJS: ()=>isSourceFileJS,
        isSourceFileNotJS: ()=>isSourceFileNotJS,
        isSourceFileNotJson: ()=>isSourceFileNotJson,
        isSourceMapping: ()=>isSourceMapping,
        isSpecialPropertyDeclaration: ()=>isSpecialPropertyDeclaration,
        isSpreadAssignment: ()=>isSpreadAssignment,
        isSpreadElement: ()=>isSpreadElement,
        isStatement: ()=>isStatement,
        isStatementButNotDeclaration: ()=>isStatementButNotDeclaration,
        isStatementOrBlock: ()=>isStatementOrBlock,
        isStatementWithLocals: ()=>isStatementWithLocals,
        isStatic: ()=>isStatic,
        isStaticModifier: ()=>isStaticModifier,
        isString: ()=>isString,
        isStringAKeyword: ()=>isStringAKeyword,
        isStringANonContextualKeyword: ()=>isStringANonContextualKeyword,
        isStringAndEmptyAnonymousObjectIntersection: ()=>isStringAndEmptyAnonymousObjectIntersection,
        isStringDoubleQuoted: ()=>isStringDoubleQuoted,
        isStringLiteral: ()=>isStringLiteral,
        isStringLiteralLike: ()=>isStringLiteralLike,
        isStringLiteralOrJsxExpression: ()=>isStringLiteralOrJsxExpression,
        isStringLiteralOrTemplate: ()=>isStringLiteralOrTemplate,
        isStringOrNumericLiteralLike: ()=>isStringOrNumericLiteralLike,
        isStringOrRegularExpressionOrTemplateLiteral: ()=>isStringOrRegularExpressionOrTemplateLiteral,
        isStringTextContainingNode: ()=>isStringTextContainingNode,
        isSuperCall: ()=>isSuperCall,
        isSuperKeyword: ()=>isSuperKeyword,
        isSuperOrSuperProperty: ()=>isSuperOrSuperProperty,
        isSuperProperty: ()=>isSuperProperty,
        isSupportedSourceFileName: ()=>isSupportedSourceFileName,
        isSwitchStatement: ()=>isSwitchStatement,
        isSyntaxList: ()=>isSyntaxList,
        isSyntheticExpression: ()=>isSyntheticExpression,
        isSyntheticReference: ()=>isSyntheticReference,
        isTagName: ()=>isTagName,
        isTaggedTemplateExpression: ()=>isTaggedTemplateExpression,
        isTaggedTemplateTag: ()=>isTaggedTemplateTag,
        isTemplateExpression: ()=>isTemplateExpression,
        isTemplateHead: ()=>isTemplateHead,
        isTemplateLiteral: ()=>isTemplateLiteral,
        isTemplateLiteralKind: ()=>isTemplateLiteralKind,
        isTemplateLiteralToken: ()=>isTemplateLiteralToken,
        isTemplateLiteralTypeNode: ()=>isTemplateLiteralTypeNode,
        isTemplateLiteralTypeSpan: ()=>isTemplateLiteralTypeSpan,
        isTemplateMiddle: ()=>isTemplateMiddle,
        isTemplateMiddleOrTemplateTail: ()=>isTemplateMiddleOrTemplateTail,
        isTemplateSpan: ()=>isTemplateSpan,
        isTemplateTail: ()=>isTemplateTail,
        isTextWhiteSpaceLike: ()=>isTextWhiteSpaceLike,
        isThis: ()=>isThis,
        isThisContainerOrFunctionBlock: ()=>isThisContainerOrFunctionBlock,
        isThisIdentifier: ()=>isThisIdentifier,
        isThisInTypeQuery: ()=>isThisInTypeQuery,
        isThisInitializedDeclaration: ()=>isThisInitializedDeclaration,
        isThisInitializedObjectBindingExpression: ()=>isThisInitializedObjectBindingExpression,
        isThisProperty: ()=>isThisProperty,
        isThisTypeNode: ()=>isThisTypeNode,
        isThisTypeParameter: ()=>isThisTypeParameter,
        isThisTypePredicate: ()=>isThisTypePredicate,
        isThrowStatement: ()=>isThrowStatement,
        isToken: ()=>isToken,
        isTokenKind: ()=>isTokenKind,
        isTraceEnabled: ()=>isTraceEnabled,
        isTransientSymbol: ()=>isTransientSymbol,
        isTrivia: ()=>isTrivia,
        isTryStatement: ()=>isTryStatement,
        isTupleTypeNode: ()=>isTupleTypeNode,
        isTypeAlias: ()=>isTypeAlias,
        isTypeAliasDeclaration: ()=>isTypeAliasDeclaration,
        isTypeAssertionExpression: ()=>isTypeAssertionExpression,
        isTypeDeclaration: ()=>isTypeDeclaration,
        isTypeElement: ()=>isTypeElement,
        isTypeKeyword: ()=>isTypeKeyword,
        isTypeKeywordToken: ()=>isTypeKeywordToken,
        isTypeKeywordTokenOrIdentifier: ()=>isTypeKeywordTokenOrIdentifier,
        isTypeLiteralNode: ()=>isTypeLiteralNode,
        isTypeNode: ()=>isTypeNode,
        isTypeNodeKind: ()=>isTypeNodeKind,
        isTypeOfExpression: ()=>isTypeOfExpression,
        isTypeOnlyExportDeclaration: ()=>isTypeOnlyExportDeclaration,
        isTypeOnlyImportDeclaration: ()=>isTypeOnlyImportDeclaration,
        isTypeOnlyImportOrExportDeclaration: ()=>isTypeOnlyImportOrExportDeclaration,
        isTypeOperatorNode: ()=>isTypeOperatorNode,
        isTypeParameterDeclaration: ()=>isTypeParameterDeclaration,
        isTypePredicateNode: ()=>isTypePredicateNode,
        isTypeQueryNode: ()=>isTypeQueryNode,
        isTypeReferenceNode: ()=>isTypeReferenceNode,
        isTypeReferenceType: ()=>isTypeReferenceType,
        isUMDExportSymbol: ()=>isUMDExportSymbol,
        isUnaryExpression: ()=>isUnaryExpression,
        isUnaryExpressionWithWrite: ()=>isUnaryExpressionWithWrite,
        isUnicodeIdentifierStart: ()=>isUnicodeIdentifierStart,
        isUnionTypeNode: ()=>isUnionTypeNode,
        isUnparsedNode: ()=>isUnparsedNode,
        isUnparsedPrepend: ()=>isUnparsedPrepend,
        isUnparsedSource: ()=>isUnparsedSource,
        isUnparsedTextLike: ()=>isUnparsedTextLike,
        isUrl: ()=>isUrl,
        isValidBigIntString: ()=>isValidBigIntString,
        isValidESSymbolDeclaration: ()=>isValidESSymbolDeclaration,
        isValidTypeOnlyAliasUseSite: ()=>isValidTypeOnlyAliasUseSite,
        isValueSignatureDeclaration: ()=>isValueSignatureDeclaration,
        isVarConst: ()=>isVarConst,
        isVariableDeclaration: ()=>isVariableDeclaration,
        isVariableDeclarationInVariableStatement: ()=>isVariableDeclarationInVariableStatement,
        isVariableDeclarationInitializedToBareOrAccessedRequire: ()=>isVariableDeclarationInitializedToBareOrAccessedRequire,
        isVariableDeclarationInitializedToRequire: ()=>isVariableDeclarationInitializedToRequire,
        isVariableDeclarationList: ()=>isVariableDeclarationList,
        isVariableLike: ()=>isVariableLike,
        isVariableLikeOrAccessor: ()=>isVariableLikeOrAccessor,
        isVariableStatement: ()=>isVariableStatement,
        isVoidExpression: ()=>isVoidExpression,
        isWatchSet: ()=>isWatchSet,
        isWhileStatement: ()=>isWhileStatement,
        isWhiteSpaceLike: ()=>isWhiteSpaceLike,
        isWhiteSpaceSingleLine: ()=>isWhiteSpaceSingleLine,
        isWithStatement: ()=>isWithStatement,
        isWriteAccess: ()=>isWriteAccess,
        isWriteOnlyAccess: ()=>isWriteOnlyAccess,
        isYieldExpression: ()=>isYieldExpression,
        jsxModeNeedsExplicitImport: ()=>jsxModeNeedsExplicitImport,
        keywordPart: ()=>keywordPart,
        last: ()=>last,
        lastOrUndefined: ()=>lastOrUndefined,
        length: ()=>length,
        libMap: ()=>libMap,
        libs: ()=>libs,
        lineBreakPart: ()=>lineBreakPart,
        linkNamePart: ()=>linkNamePart,
        linkPart: ()=>linkPart,
        linkTextPart: ()=>linkTextPart,
        listFiles: ()=>listFiles,
        loadModuleFromGlobalCache: ()=>loadModuleFromGlobalCache,
        loadWithModeAwareCache: ()=>loadWithModeAwareCache,
        makeIdentifierFromModuleName: ()=>makeIdentifierFromModuleName,
        makeImport: ()=>makeImport,
        makeImportIfNecessary: ()=>makeImportIfNecessary,
        makeStringLiteral: ()=>makeStringLiteral,
        mangleScopedPackageName: ()=>mangleScopedPackageName,
        map: ()=>map,
        mapAllOrFail: ()=>mapAllOrFail,
        mapDefined: ()=>mapDefined,
        mapDefinedEntries: ()=>mapDefinedEntries,
        mapDefinedIterator: ()=>mapDefinedIterator,
        mapEntries: ()=>mapEntries,
        mapIterator: ()=>mapIterator,
        mapOneOrMany: ()=>mapOneOrMany,
        mapToDisplayParts: ()=>mapToDisplayParts,
        matchFiles: ()=>matchFiles,
        matchPatternOrExact: ()=>matchPatternOrExact,
        matchedText: ()=>matchedText,
        matchesExclude: ()=>matchesExclude,
        maybeBind: ()=>maybeBind,
        maybeSetLocalizedDiagnosticMessages: ()=>maybeSetLocalizedDiagnosticMessages,
        memoize: ()=>memoize,
        memoizeCached: ()=>memoizeCached,
        memoizeOne: ()=>memoizeOne,
        memoizeWeak: ()=>memoizeWeak,
        metadataHelper: ()=>metadataHelper,
        min: ()=>min,
        minAndMax: ()=>minAndMax,
        missingFileModifiedTime: ()=>missingFileModifiedTime,
        modifierToFlag: ()=>modifierToFlag,
        modifiersToFlags: ()=>modifiersToFlags,
        moduleOptionDeclaration: ()=>moduleOptionDeclaration,
        moduleResolutionIsEqualTo: ()=>moduleResolutionIsEqualTo,
        moduleResolutionNameAndModeGetter: ()=>moduleResolutionNameAndModeGetter,
        moduleResolutionOptionDeclarations: ()=>moduleResolutionOptionDeclarations,
        moduleResolutionSupportsPackageJsonExportsAndImports: ()=>moduleResolutionSupportsPackageJsonExportsAndImports,
        moduleResolutionUsesNodeModules: ()=>moduleResolutionUsesNodeModules,
        moduleSpecifiers: ()=>ts_moduleSpecifiers_exports,
        moveEmitHelpers: ()=>moveEmitHelpers,
        moveRangeEnd: ()=>moveRangeEnd,
        moveRangePastDecorators: ()=>moveRangePastDecorators,
        moveRangePastModifiers: ()=>moveRangePastModifiers,
        moveRangePos: ()=>moveRangePos,
        moveSyntheticComments: ()=>moveSyntheticComments,
        mutateMap: ()=>mutateMap,
        mutateMapSkippingNewValues: ()=>mutateMapSkippingNewValues,
        needsParentheses: ()=>needsParentheses,
        needsScopeMarker: ()=>needsScopeMarker,
        newCaseClauseTracker: ()=>newCaseClauseTracker,
        newPrivateEnvironment: ()=>newPrivateEnvironment,
        noEmitNotification: ()=>noEmitNotification,
        noEmitSubstitution: ()=>noEmitSubstitution,
        noTransformers: ()=>noTransformers,
        noTruncationMaximumTruncationLength: ()=>noTruncationMaximumTruncationLength,
        nodeCanBeDecorated: ()=>nodeCanBeDecorated,
        nodeHasName: ()=>nodeHasName,
        nodeIsDecorated: ()=>nodeIsDecorated,
        nodeIsMissing: ()=>nodeIsMissing,
        nodeIsPresent: ()=>nodeIsPresent,
        nodeIsSynthesized: ()=>nodeIsSynthesized,
        nodeModuleNameResolver: ()=>nodeModuleNameResolver,
        nodeModulesPathPart: ()=>nodeModulesPathPart,
        nodeNextJsonConfigResolver: ()=>nodeNextJsonConfigResolver,
        nodeOrChildIsDecorated: ()=>nodeOrChildIsDecorated,
        nodeOverlapsWithStartEnd: ()=>nodeOverlapsWithStartEnd,
        nodePosToString: ()=>nodePosToString,
        nodeSeenTracker: ()=>nodeSeenTracker,
        nodeStartsNewLexicalEnvironment: ()=>nodeStartsNewLexicalEnvironment,
        nodeToDisplayParts: ()=>nodeToDisplayParts,
        noop: ()=>noop,
        noopFileWatcher: ()=>noopFileWatcher,
        normalizePath: ()=>normalizePath,
        normalizeSlashes: ()=>normalizeSlashes,
        not: ()=>not,
        notImplemented: ()=>notImplemented,
        notImplementedResolver: ()=>notImplementedResolver,
        nullNodeConverters: ()=>nullNodeConverters,
        nullParenthesizerRules: ()=>nullParenthesizerRules,
        nullTransformationContext: ()=>nullTransformationContext,
        objectAllocator: ()=>objectAllocator,
        operatorPart: ()=>operatorPart,
        optionDeclarations: ()=>optionDeclarations,
        optionMapToObject: ()=>optionMapToObject,
        optionsAffectingProgramStructure: ()=>optionsAffectingProgramStructure,
        optionsForBuild: ()=>optionsForBuild,
        optionsForWatch: ()=>optionsForWatch,
        optionsHaveChanges: ()=>optionsHaveChanges,
        optionsHaveModuleResolutionChanges: ()=>optionsHaveModuleResolutionChanges,
        or: ()=>or,
        orderedRemoveItem: ()=>orderedRemoveItem,
        orderedRemoveItemAt: ()=>orderedRemoveItemAt,
        outFile: ()=>outFile,
        packageIdToPackageName: ()=>packageIdToPackageName,
        packageIdToString: ()=>packageIdToString,
        padLeft: ()=>padLeft,
        padRight: ()=>padRight,
        paramHelper: ()=>paramHelper,
        parameterIsThisKeyword: ()=>parameterIsThisKeyword,
        parameterNamePart: ()=>parameterNamePart,
        parseBaseNodeFactory: ()=>parseBaseNodeFactory,
        parseBigInt: ()=>parseBigInt,
        parseBuildCommand: ()=>parseBuildCommand,
        parseCommandLine: ()=>parseCommandLine,
        parseCommandLineWorker: ()=>parseCommandLineWorker,
        parseConfigFileTextToJson: ()=>parseConfigFileTextToJson,
        parseConfigFileWithSystem: ()=>parseConfigFileWithSystem,
        parseConfigHostFromCompilerHostLike: ()=>parseConfigHostFromCompilerHostLike,
        parseCustomTypeOption: ()=>parseCustomTypeOption,
        parseIsolatedEntityName: ()=>parseIsolatedEntityName,
        parseIsolatedJSDocComment: ()=>parseIsolatedJSDocComment,
        parseJSDocTypeExpressionForTests: ()=>parseJSDocTypeExpressionForTests,
        parseJsonConfigFileContent: ()=>parseJsonConfigFileContent,
        parseJsonSourceFileConfigFileContent: ()=>parseJsonSourceFileConfigFileContent,
        parseJsonText: ()=>parseJsonText,
        parseListTypeOption: ()=>parseListTypeOption,
        parseNodeFactory: ()=>parseNodeFactory,
        parseNodeModuleFromPath: ()=>parseNodeModuleFromPath,
        parsePackageName: ()=>parsePackageName,
        parsePseudoBigInt: ()=>parsePseudoBigInt,
        parseValidBigInt: ()=>parseValidBigInt,
        patchWriteFileEnsuringDirectory: ()=>patchWriteFileEnsuringDirectory,
        pathContainsNodeModules: ()=>pathContainsNodeModules,
        pathIsAbsolute: ()=>pathIsAbsolute,
        pathIsBareSpecifier: ()=>pathIsBareSpecifier,
        pathIsRelative: ()=>pathIsRelative,
        patternText: ()=>patternText,
        perfLogger: ()=>perfLogger,
        performIncrementalCompilation: ()=>performIncrementalCompilation,
        performance: ()=>ts_performance_exports,
        plainJSErrors: ()=>plainJSErrors,
        positionBelongsToNode: ()=>positionBelongsToNode,
        positionIsASICandidate: ()=>positionIsASICandidate,
        positionIsSynthesized: ()=>positionIsSynthesized,
        positionsAreOnSameLine: ()=>positionsAreOnSameLine,
        preProcessFile: ()=>preProcessFile,
        probablyUsesSemicolons: ()=>probablyUsesSemicolons,
        processCommentPragmas: ()=>processCommentPragmas,
        processPragmasIntoFields: ()=>processPragmasIntoFields,
        processTaggedTemplateExpression: ()=>processTaggedTemplateExpression,
        programContainsEsModules: ()=>programContainsEsModules,
        programContainsModules: ()=>programContainsModules,
        projectReferenceIsEqualTo: ()=>projectReferenceIsEqualTo,
        propKeyHelper: ()=>propKeyHelper,
        propertyNamePart: ()=>propertyNamePart,
        pseudoBigIntToString: ()=>pseudoBigIntToString,
        punctuationPart: ()=>punctuationPart,
        pushIfUnique: ()=>pushIfUnique,
        quote: ()=>quote,
        quotePreferenceFromString: ()=>quotePreferenceFromString,
        rangeContainsPosition: ()=>rangeContainsPosition,
        rangeContainsPositionExclusive: ()=>rangeContainsPositionExclusive,
        rangeContainsRange: ()=>rangeContainsRange,
        rangeContainsRangeExclusive: ()=>rangeContainsRangeExclusive,
        rangeContainsStartEnd: ()=>rangeContainsStartEnd,
        rangeEndIsOnSameLineAsRangeStart: ()=>rangeEndIsOnSameLineAsRangeStart,
        rangeEndPositionsAreOnSameLine: ()=>rangeEndPositionsAreOnSameLine,
        rangeEquals: ()=>rangeEquals,
        rangeIsOnSingleLine: ()=>rangeIsOnSingleLine,
        rangeOfNode: ()=>rangeOfNode,
        rangeOfTypeParameters: ()=>rangeOfTypeParameters,
        rangeOverlapsWithStartEnd: ()=>rangeOverlapsWithStartEnd,
        rangeStartIsOnSameLineAsRangeEnd: ()=>rangeStartIsOnSameLineAsRangeEnd,
        rangeStartPositionsAreOnSameLine: ()=>rangeStartPositionsAreOnSameLine,
        readBuilderProgram: ()=>readBuilderProgram,
        readConfigFile: ()=>readConfigFile,
        readHelper: ()=>readHelper,
        readJson: ()=>readJson,
        readJsonConfigFile: ()=>readJsonConfigFile,
        readJsonOrUndefined: ()=>readJsonOrUndefined,
        realizeDiagnostics: ()=>realizeDiagnostics,
        reduceEachLeadingCommentRange: ()=>reduceEachLeadingCommentRange,
        reduceEachTrailingCommentRange: ()=>reduceEachTrailingCommentRange,
        reduceLeft: ()=>reduceLeft,
        reduceLeftIterator: ()=>reduceLeftIterator,
        reducePathComponents: ()=>reducePathComponents,
        refactor: ()=>ts_refactor_exports,
        regExpEscape: ()=>regExpEscape,
        relativeComplement: ()=>relativeComplement,
        removeAllComments: ()=>removeAllComments,
        removeEmitHelper: ()=>removeEmitHelper,
        removeExtension: ()=>removeExtension,
        removeFileExtension: ()=>removeFileExtension,
        removeIgnoredPath: ()=>removeIgnoredPath,
        removeMinAndVersionNumbers: ()=>removeMinAndVersionNumbers,
        removeOptionality: ()=>removeOptionality,
        removePrefix: ()=>removePrefix,
        removeSuffix: ()=>removeSuffix,
        removeTrailingDirectorySeparator: ()=>removeTrailingDirectorySeparator,
        repeatString: ()=>repeatString,
        replaceElement: ()=>replaceElement,
        resolutionExtensionIsTSOrJson: ()=>resolutionExtensionIsTSOrJson,
        resolveConfigFileProjectName: ()=>resolveConfigFileProjectName,
        resolveJSModule: ()=>resolveJSModule,
        resolveLibrary: ()=>resolveLibrary,
        resolveModuleName: ()=>resolveModuleName,
        resolveModuleNameFromCache: ()=>resolveModuleNameFromCache,
        resolvePackageNameToPackageJson: ()=>resolvePackageNameToPackageJson,
        resolvePath: ()=>resolvePath,
        resolveProjectReferencePath: ()=>resolveProjectReferencePath,
        resolveTripleslashReference: ()=>resolveTripleslashReference,
        resolveTypeReferenceDirective: ()=>resolveTypeReferenceDirective,
        resolvingEmptyArray: ()=>resolvingEmptyArray,
        restHelper: ()=>restHelper,
        returnFalse: ()=>returnFalse,
        returnNoopFileWatcher: ()=>returnNoopFileWatcher,
        returnTrue: ()=>returnTrue,
        returnUndefined: ()=>returnUndefined,
        returnsPromise: ()=>returnsPromise,
        runInitializersHelper: ()=>runInitializersHelper,
        sameFlatMap: ()=>sameFlatMap,
        sameMap: ()=>sameMap,
        sameMapping: ()=>sameMapping,
        scanShebangTrivia: ()=>scanShebangTrivia,
        scanTokenAtPosition: ()=>scanTokenAtPosition,
        scanner: ()=>scanner,
        screenStartingMessageCodes: ()=>screenStartingMessageCodes,
        semanticDiagnosticsOptionDeclarations: ()=>semanticDiagnosticsOptionDeclarations,
        serializeCompilerOptions: ()=>serializeCompilerOptions,
        server: ()=>ts_server_exports,
        servicesVersion: ()=>servicesVersion,
        setCommentRange: ()=>setCommentRange,
        setConfigFileInOptions: ()=>setConfigFileInOptions,
        setConstantValue: ()=>setConstantValue,
        setEachParent: ()=>setEachParent,
        setEmitFlags: ()=>setEmitFlags,
        setFunctionNameHelper: ()=>setFunctionNameHelper,
        setGetSourceFileAsHashVersioned: ()=>setGetSourceFileAsHashVersioned,
        setIdentifierAutoGenerate: ()=>setIdentifierAutoGenerate,
        setIdentifierGeneratedImportReference: ()=>setIdentifierGeneratedImportReference,
        setIdentifierTypeArguments: ()=>setIdentifierTypeArguments,
        setInternalEmitFlags: ()=>setInternalEmitFlags,
        setLocalizedDiagnosticMessages: ()=>setLocalizedDiagnosticMessages,
        setModuleDefaultHelper: ()=>setModuleDefaultHelper,
        setNodeFlags: ()=>setNodeFlags,
        setObjectAllocator: ()=>setObjectAllocator,
        setOriginalNode: ()=>setOriginalNode,
        setParent: ()=>setParent,
        setParentRecursive: ()=>setParentRecursive,
        setPrivateIdentifier: ()=>setPrivateIdentifier,
        setResolvedModule: ()=>setResolvedModule,
        setResolvedTypeReferenceDirective: ()=>setResolvedTypeReferenceDirective,
        setSnippetElement: ()=>setSnippetElement,
        setSourceMapRange: ()=>setSourceMapRange,
        setStackTraceLimit: ()=>setStackTraceLimit,
        setStartsOnNewLine: ()=>setStartsOnNewLine,
        setSyntheticLeadingComments: ()=>setSyntheticLeadingComments,
        setSyntheticTrailingComments: ()=>setSyntheticTrailingComments,
        setSys: ()=>setSys,
        setSysLog: ()=>setSysLog,
        setTextRange: ()=>setTextRange,
        setTextRangeEnd: ()=>setTextRangeEnd,
        setTextRangePos: ()=>setTextRangePos,
        setTextRangePosEnd: ()=>setTextRangePosEnd,
        setTextRangePosWidth: ()=>setTextRangePosWidth,
        setTokenSourceMapRange: ()=>setTokenSourceMapRange,
        setTypeNode: ()=>setTypeNode,
        setUILocale: ()=>setUILocale,
        setValueDeclaration: ()=>setValueDeclaration,
        shouldAllowImportingTsExtension: ()=>shouldAllowImportingTsExtension,
        shouldPreserveConstEnums: ()=>shouldPreserveConstEnums,
        shouldResolveJsRequire: ()=>shouldResolveJsRequire,
        shouldUseUriStyleNodeCoreModules: ()=>shouldUseUriStyleNodeCoreModules,
        showModuleSpecifier: ()=>showModuleSpecifier,
        signatureHasLiteralTypes: ()=>signatureHasLiteralTypes,
        signatureHasRestParameter: ()=>signatureHasRestParameter,
        signatureToDisplayParts: ()=>signatureToDisplayParts,
        single: ()=>single,
        singleElementArray: ()=>singleElementArray,
        singleIterator: ()=>singleIterator,
        singleOrMany: ()=>singleOrMany,
        singleOrUndefined: ()=>singleOrUndefined,
        skipAlias: ()=>skipAlias,
        skipAssertions: ()=>skipAssertions,
        skipConstraint: ()=>skipConstraint,
        skipOuterExpressions: ()=>skipOuterExpressions,
        skipParentheses: ()=>skipParentheses,
        skipPartiallyEmittedExpressions: ()=>skipPartiallyEmittedExpressions,
        skipTrivia: ()=>skipTrivia,
        skipTypeChecking: ()=>skipTypeChecking,
        skipTypeParentheses: ()=>skipTypeParentheses,
        skipWhile: ()=>skipWhile,
        sliceAfter: ()=>sliceAfter,
        some: ()=>some,
        sort: ()=>sort,
        sortAndDeduplicate: ()=>sortAndDeduplicate,
        sortAndDeduplicateDiagnostics: ()=>sortAndDeduplicateDiagnostics,
        sourceFileAffectingCompilerOptions: ()=>sourceFileAffectingCompilerOptions,
        sourceFileMayBeEmitted: ()=>sourceFileMayBeEmitted,
        sourceMapCommentRegExp: ()=>sourceMapCommentRegExp,
        sourceMapCommentRegExpDontCareLineStart: ()=>sourceMapCommentRegExpDontCareLineStart,
        spacePart: ()=>spacePart,
        spanMap: ()=>spanMap,
        spreadArrayHelper: ()=>spreadArrayHelper,
        stableSort: ()=>stableSort,
        startEndContainsRange: ()=>startEndContainsRange,
        startEndOverlapsWithStartEnd: ()=>startEndOverlapsWithStartEnd,
        startOnNewLine: ()=>startOnNewLine,
        startTracing: ()=>startTracing,
        startsWith: ()=>startsWith,
        startsWithDirectory: ()=>startsWithDirectory,
        startsWithUnderscore: ()=>startsWithUnderscore,
        startsWithUseStrict: ()=>startsWithUseStrict,
        stringContains: ()=>stringContains,
        stringContainsAt: ()=>stringContainsAt,
        stringToToken: ()=>stringToToken,
        stripQuotes: ()=>stripQuotes,
        supportedDeclarationExtensions: ()=>supportedDeclarationExtensions,
        supportedJSExtensions: ()=>supportedJSExtensions,
        supportedJSExtensionsFlat: ()=>supportedJSExtensionsFlat,
        supportedLocaleDirectories: ()=>supportedLocaleDirectories,
        supportedTSExtensions: ()=>supportedTSExtensions,
        supportedTSExtensionsFlat: ()=>supportedTSExtensionsFlat,
        supportedTSImplementationExtensions: ()=>supportedTSImplementationExtensions,
        suppressLeadingAndTrailingTrivia: ()=>suppressLeadingAndTrailingTrivia,
        suppressLeadingTrivia: ()=>suppressLeadingTrivia,
        suppressTrailingTrivia: ()=>suppressTrailingTrivia,
        symbolEscapedNameNoDefault: ()=>symbolEscapedNameNoDefault,
        symbolName: ()=>symbolName,
        symbolNameNoDefault: ()=>symbolNameNoDefault,
        symbolPart: ()=>symbolPart,
        symbolToDisplayParts: ()=>symbolToDisplayParts,
        syntaxMayBeASICandidate: ()=>syntaxMayBeASICandidate,
        syntaxRequiresTrailingSemicolonOrASI: ()=>syntaxRequiresTrailingSemicolonOrASI,
        sys: ()=>sys,
        sysLog: ()=>sysLog,
        tagNamesAreEquivalent: ()=>tagNamesAreEquivalent,
        takeWhile: ()=>takeWhile,
        targetOptionDeclaration: ()=>targetOptionDeclaration,
        templateObjectHelper: ()=>templateObjectHelper,
        testFormatSettings: ()=>testFormatSettings,
        textChangeRangeIsUnchanged: ()=>textChangeRangeIsUnchanged,
        textChangeRangeNewSpan: ()=>textChangeRangeNewSpan,
        textChanges: ()=>ts_textChanges_exports,
        textOrKeywordPart: ()=>textOrKeywordPart,
        textPart: ()=>textPart,
        textRangeContainsPositionInclusive: ()=>textRangeContainsPositionInclusive,
        textSpanContainsPosition: ()=>textSpanContainsPosition,
        textSpanContainsTextSpan: ()=>textSpanContainsTextSpan,
        textSpanEnd: ()=>textSpanEnd,
        textSpanIntersection: ()=>textSpanIntersection,
        textSpanIntersectsWith: ()=>textSpanIntersectsWith,
        textSpanIntersectsWithPosition: ()=>textSpanIntersectsWithPosition,
        textSpanIntersectsWithTextSpan: ()=>textSpanIntersectsWithTextSpan,
        textSpanIsEmpty: ()=>textSpanIsEmpty,
        textSpanOverlap: ()=>textSpanOverlap,
        textSpanOverlapsWith: ()=>textSpanOverlapsWith,
        textSpansEqual: ()=>textSpansEqual,
        textToKeywordObj: ()=>textToKeywordObj,
        timestamp: ()=>timestamp,
        toArray: ()=>toArray,
        toBuilderFileEmit: ()=>toBuilderFileEmit,
        toBuilderStateFileInfoForMultiEmit: ()=>toBuilderStateFileInfoForMultiEmit,
        toEditorSettings: ()=>toEditorSettings,
        toFileNameLowerCase: ()=>toFileNameLowerCase,
        toLowerCase: ()=>toLowerCase,
        toPath: ()=>toPath,
        toProgramEmitPending: ()=>toProgramEmitPending,
        tokenIsIdentifierOrKeyword: ()=>tokenIsIdentifierOrKeyword,
        tokenIsIdentifierOrKeywordOrGreaterThan: ()=>tokenIsIdentifierOrKeywordOrGreaterThan,
        tokenToString: ()=>tokenToString,
        trace: ()=>trace,
        tracing: ()=>tracing,
        tracingEnabled: ()=>tracingEnabled,
        transform: ()=>transform,
        transformClassFields: ()=>transformClassFields,
        transformDeclarations: ()=>transformDeclarations,
        transformECMAScriptModule: ()=>transformECMAScriptModule,
        transformES2015: ()=>transformES2015,
        transformES2016: ()=>transformES2016,
        transformES2017: ()=>transformES2017,
        transformES2018: ()=>transformES2018,
        transformES2019: ()=>transformES2019,
        transformES2020: ()=>transformES2020,
        transformES2021: ()=>transformES2021,
        transformES5: ()=>transformES5,
        transformESDecorators: ()=>transformESDecorators,
        transformESNext: ()=>transformESNext,
        transformGenerators: ()=>transformGenerators,
        transformJsx: ()=>transformJsx,
        transformLegacyDecorators: ()=>transformLegacyDecorators,
        transformModule: ()=>transformModule,
        transformNodeModule: ()=>transformNodeModule,
        transformNodes: ()=>transformNodes,
        transformSystemModule: ()=>transformSystemModule,
        transformTypeScript: ()=>transformTypeScript,
        transpile: ()=>transpile,
        transpileModule: ()=>transpileModule,
        transpileOptionValueCompilerOptions: ()=>transpileOptionValueCompilerOptions,
        trimString: ()=>trimString,
        trimStringEnd: ()=>trimStringEnd,
        trimStringStart: ()=>trimStringStart,
        tryAddToSet: ()=>tryAddToSet,
        tryAndIgnoreErrors: ()=>tryAndIgnoreErrors,
        tryCast: ()=>tryCast,
        tryDirectoryExists: ()=>tryDirectoryExists,
        tryExtractTSExtension: ()=>tryExtractTSExtension,
        tryFileExists: ()=>tryFileExists,
        tryGetClassExtendingExpressionWithTypeArguments: ()=>tryGetClassExtendingExpressionWithTypeArguments,
        tryGetClassImplementingOrExtendingExpressionWithTypeArguments: ()=>tryGetClassImplementingOrExtendingExpressionWithTypeArguments,
        tryGetDirectories: ()=>tryGetDirectories,
        tryGetExtensionFromPath: ()=>tryGetExtensionFromPath2,
        tryGetImportFromModuleSpecifier: ()=>tryGetImportFromModuleSpecifier,
        tryGetJSDocSatisfiesTypeNode: ()=>tryGetJSDocSatisfiesTypeNode,
        tryGetModuleNameFromFile: ()=>tryGetModuleNameFromFile,
        tryGetModuleSpecifierFromDeclaration: ()=>tryGetModuleSpecifierFromDeclaration,
        tryGetNativePerformanceHooks: ()=>tryGetNativePerformanceHooks,
        tryGetPropertyAccessOrIdentifierToString: ()=>tryGetPropertyAccessOrIdentifierToString,
        tryGetPropertyNameOfBindingOrAssignmentElement: ()=>tryGetPropertyNameOfBindingOrAssignmentElement,
        tryGetSourceMappingURL: ()=>tryGetSourceMappingURL,
        tryGetTextOfPropertyName: ()=>tryGetTextOfPropertyName,
        tryIOAndConsumeErrors: ()=>tryIOAndConsumeErrors,
        tryParsePattern: ()=>tryParsePattern,
        tryParsePatterns: ()=>tryParsePatterns,
        tryParseRawSourceMap: ()=>tryParseRawSourceMap,
        tryReadDirectory: ()=>tryReadDirectory,
        tryReadFile: ()=>tryReadFile,
        tryRemoveDirectoryPrefix: ()=>tryRemoveDirectoryPrefix,
        tryRemoveExtension: ()=>tryRemoveExtension,
        tryRemovePrefix: ()=>tryRemovePrefix,
        tryRemoveSuffix: ()=>tryRemoveSuffix,
        typeAcquisitionDeclarations: ()=>typeAcquisitionDeclarations,
        typeAliasNamePart: ()=>typeAliasNamePart,
        typeDirectiveIsEqualTo: ()=>typeDirectiveIsEqualTo,
        typeKeywords: ()=>typeKeywords,
        typeParameterNamePart: ()=>typeParameterNamePart,
        typeReferenceResolutionNameAndModeGetter: ()=>typeReferenceResolutionNameAndModeGetter,
        typeToDisplayParts: ()=>typeToDisplayParts,
        unchangedPollThresholds: ()=>unchangedPollThresholds,
        unchangedTextChangeRange: ()=>unchangedTextChangeRange,
        unescapeLeadingUnderscores: ()=>unescapeLeadingUnderscores,
        unmangleScopedPackageName: ()=>unmangleScopedPackageName,
        unorderedRemoveItem: ()=>unorderedRemoveItem,
        unorderedRemoveItemAt: ()=>unorderedRemoveItemAt,
        unreachableCodeIsError: ()=>unreachableCodeIsError,
        unusedLabelIsError: ()=>unusedLabelIsError,
        unwrapInnermostStatementOfLabel: ()=>unwrapInnermostStatementOfLabel,
        updateErrorForNoInputFiles: ()=>updateErrorForNoInputFiles,
        updateLanguageServiceSourceFile: ()=>updateLanguageServiceSourceFile,
        updateMissingFilePathsWatch: ()=>updateMissingFilePathsWatch,
        updatePackageJsonWatch: ()=>updatePackageJsonWatch,
        updateResolutionField: ()=>updateResolutionField,
        updateSharedExtendedConfigFileWatcher: ()=>updateSharedExtendedConfigFileWatcher,
        updateSourceFile: ()=>updateSourceFile,
        updateWatchingWildcardDirectories: ()=>updateWatchingWildcardDirectories,
        usesExtensionsOnImports: ()=>usesExtensionsOnImports,
        usingSingleLineStringWriter: ()=>usingSingleLineStringWriter,
        utf16EncodeAsString: ()=>utf16EncodeAsString,
        validateLocaleAndSetLanguage: ()=>validateLocaleAndSetLanguage,
        valuesHelper: ()=>valuesHelper,
        version: ()=>version,
        versionMajorMinor: ()=>versionMajorMinor,
        visitArray: ()=>visitArray,
        visitCommaListElements: ()=>visitCommaListElements,
        visitEachChild: ()=>visitEachChild,
        visitFunctionBody: ()=>visitFunctionBody,
        visitIterationBody: ()=>visitIterationBody,
        visitLexicalEnvironment: ()=>visitLexicalEnvironment,
        visitNode: ()=>visitNode,
        visitNodes: ()=>visitNodes2,
        visitParameterList: ()=>visitParameterList,
        walkUpBindingElementsAndPatterns: ()=>walkUpBindingElementsAndPatterns,
        walkUpLexicalEnvironments: ()=>walkUpLexicalEnvironments,
        walkUpOuterExpressions: ()=>walkUpOuterExpressions,
        walkUpParenthesizedExpressions: ()=>walkUpParenthesizedExpressions,
        walkUpParenthesizedTypes: ()=>walkUpParenthesizedTypes,
        walkUpParenthesizedTypesAndGetParentAndChild: ()=>walkUpParenthesizedTypesAndGetParentAndChild,
        whitespaceOrMapCommentRegExp: ()=>whitespaceOrMapCommentRegExp,
        writeCommentRange: ()=>writeCommentRange,
        writeFile: ()=>writeFile,
        writeFileEnsuringDirectories: ()=>writeFileEnsuringDirectories,
        zipToModeAwareCache: ()=>zipToModeAwareCache,
        zipWith: ()=>zipWith
    });
    var init_ts6 = __esm({
        "src/typescript/_namespaces/ts.ts" () {
            "use strict";
            init_ts2();
            init_ts3();
            init_ts4();
            init_ts5();
        }
    });
    // src/typescript/typescript.ts
    var require_typescript = __commonJS({
        "src/typescript/typescript.ts" (exports, module2) {
            init_ts6();
            init_ts6();
            if (typeof console !== "undefined") Debug.loggingHost = {
                log (level, s) {
                    switch(level){
                        case 1 /* Error */ :
                            return console.error(s);
                        case 2 /* Warning */ :
                            return console.warn(s);
                        case 3 /* Info */ :
                            return console.log(s);
                        case 4 /* Verbose */ :
                            return console.log(s);
                    }
                }
            };
            module2.exports = ts_exports2;
        }
    });
    return require_typescript();
})();
if (0, $10339b5de87e77e2$exports) $10339b5de87e77e2$exports = $10339b5de87e77e2$var$ts;
 //# sourceMappingURL=typescript.js.map


const $7c840cbf87483d1a$var$SUPPORTED_TYPE_REFERENCE_FEATURES = {
    PICK: "Pick",
    OMIT: "Omit"
};
const $7c840cbf87483d1a$var$TYPE_HANDLING_MAP = {
    [(0, $10339b5de87e77e2$exports.SyntaxKind).TypeLiteral]: (name, typeNode, { parentName: parentName , namespace: namespace  } = {})=>{
        const content = [];
        typeNode.forEachChild((tLChild)=>{
            if (tLChild.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).PropertySignature) {
                let identifier = "", subTypeNode, optional = false, readonly = false;
                tLChild.forEachChild((pSChild)=>{
                    if (pSChild.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).ReadonlyKeyword) readonly = true;
                    else if (pSChild.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).Identifier) identifier = pSChild.getText();
                    else if (pSChild.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).QuestionToken) optional = true;
                    else subTypeNode = pSChild;
                });
                if (subTypeNode) {
                    const fullParentName = parentName ? `${parentName}.${name}` : name;
                    content.push({
                        ...$7c840cbf87483d1a$var$parseType(identifier, subTypeNode, {
                            parentName: fullParentName,
                            namespace: namespace
                        }),
                        optional: optional,
                        readonly: readonly
                    });
                }
            }
        });
        return {
            namespace: namespace,
            name: name,
            type: parentName ? `${parentName}.${name}` : name,
            literal: true,
            content: content
        };
    },
    [(0, $10339b5de87e77e2$exports.SyntaxKind).UnionType]: (name, typeNode, { parentName: parentName , namespace: namespace  } = {})=>{
        const { types: types = []  } = typeNode;
        return {
            namespace: namespace,
            name: name,
            type: parentName ? `${parentName}.${name}` : name,
            varietyType: true,
            content: types.map((t)=>$7c840cbf87483d1a$var$parseType(name, t, {
                    parentName: parentName,
                    namespace: namespace
                }))
        };
    },
    [(0, $10339b5de87e77e2$exports.SyntaxKind).IntersectionType]: (name, typeNode, { parentName: parentName , namespace: namespace  } = {})=>{
        const { types: types = []  } = typeNode;
        return {
            namespace: namespace,
            name: name,
            type: parentName ? `${parentName}.${name}` : name,
            comboType: true,
            content: types.map((t)=>$7c840cbf87483d1a$var$parseType(name, t, {
                    parentName: parentName,
                    namespace: namespace
                }))
        };
    },
    [(0, $10339b5de87e77e2$exports.SyntaxKind).ArrayType]: (name, typeNode, { parentName: parentName , namespace: namespace  } = {})=>{
        const { elementType: elementType  } = typeNode;
        const extendedTS = $7c840cbf87483d1a$var$parseType(name, elementType, {
            parentName: parentName,
            namespace: namespace
        });
        const { multiple: extendedMultiple = false  } = extendedTS;
        return {
            ...extendedTS,
            multiple: typeof extendedMultiple === "number" ? extendedMultiple + 1 : 1
        };
    },
    [(0, $10339b5de87e77e2$exports.SyntaxKind).TypeReference]: (name, typeNode, { parentName: _parentName , namespace: namespace  } = {})=>{
        let identifier = "";
        let referencedTypeName = "";
        let contentNamesString = "";
        typeNode.forEachChild((n)=>{
            if (n.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).Identifier) identifier = n.getText();
            if (n.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).TypeReference) referencedTypeName = n.getText();
            if (n.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).LiteralType || n.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).UnionType) contentNamesString = n.getText();
        });
        if (identifier && referencedTypeName && contentNamesString) {
            const baseTS = {
                namespace: namespace,
                name: name,
                type: referencedTypeName
            };
            const contentNames = contentNamesString.replace(/[\s'"]/gim, ()=>"").split("|");
            if (identifier === $7c840cbf87483d1a$var$SUPPORTED_TYPE_REFERENCE_FEATURES.PICK) return {
                ...baseTS,
                contentNames: {
                    allowed: contentNames
                }
            };
            else if (identifier === $7c840cbf87483d1a$var$SUPPORTED_TYPE_REFERENCE_FEATURES.OMIT) return {
                ...baseTS,
                contentNames: {
                    disallowed: contentNames
                }
            };
        }
        return {
            namespace: namespace,
            name: name,
            type: typeNode.getText()
        };
    }
};
const $7c840cbf87483d1a$var$parseType = (name, typeNode, { parentName: parentName , namespace: namespace  } = {})=>{
    const typeHandling = $7c840cbf87483d1a$var$TYPE_HANDLING_MAP[typeNode.kind];
    const comments = [];
    const tags = {};
    if ((typeNode?.parent)?.jsDoc) typeNode.parent.jsDoc.forEach((doc)=>{
        if (typeof doc.comment === "string") comments.push(doc.comment);
        else doc.comment?.forEach((c)=>{
            comments.push(c.getText());
        });
        if (doc?.tags) doc.tags.forEach((tag)=>{
            const tagName = tag.tagName.getText();
            const tagType = tag.typeExpression?.type?.getText();
            const tagValue = !tag.comment && !tagType ? true : typeof tag.comment === "string" ? tag.comment : undefined;
            tags[tagName] = {
                type: tagType,
                value: tagValue
            };
        });
    });
    if (typeHandling) {
        const { comments: handledComments = [] , tags: handledTags = {} , ...otherHandledTypeProps } = typeHandling(name, typeNode, {
            parentName: parentName,
            namespace: namespace
        }) || {};
        return {
            comments: [
                ...comments,
                ...handledComments
            ],
            tags: {
                ...tags,
                ...handledTags
            },
            ...otherHandledTypeProps
        };
    } else return {
        namespace: namespace,
        name: name,
        type: typeNode.getText(),
        literal: true,
        comments: comments,
        tags: tags
    };
};
const $7c840cbf87483d1a$var$getTypeMap = (typeNode, namespace)=>{
    let map = {};
    typeNode.forEachChild((n)=>{
        if (n.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).ModuleDeclaration) {
            const { name: name  } = n;
            const newNamespace = namespace ? `${namespace}.${name.getText()}` : name.getText();
            n.forEachChild((cN)=>{
                map = {
                    ...map,
                    ...$7c840cbf87483d1a$var$getTypeMap(cN, newNamespace)
                };
            });
        } else if (n.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).TypeAliasDeclaration) {
            let identifier = "", isExport = false, nNode;
            n.forEachChild((n2)=>{
                if (n2.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).ExportKeyword) isExport = true;
                else if (n2.kind === (0, $10339b5de87e77e2$exports.SyntaxKind).Identifier) identifier = n2.getText();
                else nNode = n2;
            });
            if (isExport && nNode) {
                const mapKey = namespace ? `${namespace}.${identifier}` : identifier;
                map[mapKey] = $7c840cbf87483d1a$var$parseType(identifier, nNode, {
                    namespace: namespace
                });
            }
        }
    });
    return map;
};
const $7c840cbf87483d1a$export$e2bd4b8ca669449c = (typeScriptText)=>{
    const typeScriptNode = (0, $10339b5de87e77e2$exports.createSourceFile)("x.ts", typeScriptText, (0, $10339b5de87e77e2$exports.ScriptTarget).Latest, true);
    return $7c840cbf87483d1a$var$getTypeMap(typeScriptNode);
};



const $23ddcd9d8c50ffa9$export$14faa19a0f3bbeb2 = (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)`
  /* Violet color for light color scheme (Default) */
  /* Can be forced with data-theme="light" */

  [data-theme=light],
  :root:not([data-theme=dark]) {
    --pico-text-selection-color: rgba(167, 128, 212, 0.25);
    --pico-primary: #8352c5;
    --pico-primary-background: #7540bf;
    --pico-primary-underline: rgba(131, 82, 197, 0.5);
    --pico-primary-hover: #6935b3;
    --pico-primary-hover-background: #6935b3;
    --pico-primary-focus: rgba(167, 128, 212, 0.25);
    --pico-primary-inverse: #fff;
  }

  /* Violet color for dark color scheme (Auto) */
  /* Automatically enabled if user has Dark mode enabled */
  @media only screen and (prefers-color-scheme: dark) {
    :root:not([data-theme]) {
      --pico-text-selection-color: rgba(178, 144, 217, 0.1875);
      --pico-primary: #b290d9;
      --pico-primary-background: #7540bf;
      --pico-primary-underline: rgba(178, 144, 217, 0.5);
      --pico-primary-hover: #c9afe4;
      --pico-primary-hover-background: #8352c5;
      --pico-primary-focus: rgba(178, 144, 217, 0.25);
      --pico-primary-inverse: #fff;
    }
  }

  /* Violet color for dark color scheme (Forced) */
  /* Enabled if forced with data-theme="dark" */

  [data-theme=dark] {
    --pico-text-selection-color: rgba(178, 144, 217, 0.1875);
    --pico-primary: #b290d9;
    --pico-primary-background: #7540bf;
    --pico-primary-underline: rgba(178, 144, 217, 0.5);
    --pico-primary-hover: #c9afe4;
    --pico-primary-hover-background: #8352c5;
    --pico-primary-focus: rgba(178, 144, 217, 0.25);
    --pico-primary-inverse: #fff;
  }

  /* Violet (Common styles) */

  :root {
    --form-element-active-border-color: var(--primary);
    --form-element-focus-color: var(--primary-focus);
    --switch-color: var(--primary-inverse);
    --switch-checked-background-color: var(--primary);
  }
`;


var $8001679a17388a1f$exports = {};
$8001679a17388a1f$exports = "export type Time = `${number}:${number}:${number}.${number}Z`;\n\nexport type DateTime = `${number}-${number}-${number}T${number}:${number}:${number}.${number}Z`;\n\nexport type LongText = string;\n\nexport type Rating = number;\n\nexport type Color = string;\n\nexport type TelephoneNumber = string;\n\nexport type EmailAddress = string;\n\nexport type File = string;\n\nexport type Hidden = string;\n\nexport type Image = string;\n\nexport type Month = string;\n\nexport type Password = string;\n\nexport type Radio = string;\n\nexport type Range = string;\n\nexport type Search = string;\n\nexport type URL = string;\n\nexport type Week = string;\n\nexport const DataTypeMap = {\n  string: 'text',\n  number: 'number',\n  boolean: 'checkbox',\n  Date: 'date',\n  Time: 'time',\n  DateTime: 'datetime-local',\n  LongText: 'textarea',\n  Rating: 'number',\n  Color: 'color',\n  TelephoneNumber: 'tel',\n  EmailAddress: 'email',\n  File: 'file',\n  Hidden: 'hidden',\n  Image: 'image',\n  Month: 'month',\n  Password: 'password',\n  Radio: 'radio',\n  Range: 'range',\n  Search: 'search',\n  URL: 'url',\n  Week: 'week',\n  any: 'text',\n};\n";




var $acw62 = parcelRequire("acw62");
var $6d44855cf5e6d843$exports = {};
"use strict";
Object.defineProperty($6d44855cf5e6d843$exports, "__esModule", {
    value: true
});
$6d44855cf5e6d843$exports.diff = $6d44855cf5e6d843$exports.split = void 0;
var $4cb8d279e2475fd3$exports = {};
"use strict";
var $4cb8d279e2475fd3$var$__extends = $4cb8d279e2475fd3$exports && $4cb8d279e2475fd3$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4cb8d279e2475fd3$var$__assign = $4cb8d279e2475fd3$exports && $4cb8d279e2475fd3$exports.__assign || function() {
    $4cb8d279e2475fd3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4cb8d279e2475fd3$var$__assign.apply(this, arguments);
};
Object.defineProperty($4cb8d279e2475fd3$exports, "__esModule", {
    value: true
});

var $jevmL = parcelRequire("jevmL");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();



var $acw62 = parcelRequire("acw62");

var $6cqMT = parcelRequire("6cqMT");
var $f17e1925ce597b79$exports = {};
"use strict";
Object.defineProperty($f17e1925ce597b79$exports, "__esModule", {
    value: true
});
$f17e1925ce597b79$exports.getAceInstance = $f17e1925ce597b79$exports.debounce = $f17e1925ce597b79$exports.editorEvents = $f17e1925ce597b79$exports.editorOptions = void 0;
var $f17e1925ce597b79$var$editorOptions = [
    "minLines",
    "maxLines",
    "readOnly",
    "highlightActiveLine",
    "tabSize",
    "enableBasicAutocompletion",
    "enableLiveAutocompletion",
    "enableSnippets"
];
$f17e1925ce597b79$exports.editorOptions = $f17e1925ce597b79$var$editorOptions;
var $f17e1925ce597b79$var$editorEvents = [
    "onChange",
    "onFocus",
    "onInput",
    "onBlur",
    "onCopy",
    "onPaste",
    "onSelectionChange",
    "onCursorChange",
    "onScroll",
    "handleOptions",
    "updateRef"
];
$f17e1925ce597b79$exports.editorEvents = $f17e1925ce597b79$var$editorEvents;


var $f17e1925ce597b79$var$getAceInstance = function() {
    var ace;
    if (typeof window === "undefined") {
        // ace-builds just needs some window object to attach ace to.
        // During SSR even just an empty object will work.
        $parcel$global.window = {};
        ace = (parcelRequire("jevmL"));
        // And it can be discarded immediately afterward to avoid confusing
        // other libraries that might detect SSR the same way we did.
        delete $parcel$global.window;
    } else if (window.ace) {
        // Fallback for ace.require when vanilla ACE is hosted over a CDN
        ace = window.ace;
        ace.acequire = window.ace.require || window.ace.acequire;
    } else ace = (parcelRequire("jevmL"));
    return ace;
};
$f17e1925ce597b79$exports.getAceInstance = $f17e1925ce597b79$var$getAceInstance;
var $f17e1925ce597b79$var$debounce = function(fn, delay) {
    var timer = null;
    // tslint:disable-next-line
    return function() {
        var context = this;
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(context, args);
        }, delay);
    };
};
$f17e1925ce597b79$exports.debounce = $f17e1925ce597b79$var$debounce;


var $4cb8d279e2475fd3$var$ace = (0, $f17e1925ce597b79$exports.getAceInstance)();
var $4cb8d279e2475fd3$var$ReactAce = /** @class */ function(_super) {
    $4cb8d279e2475fd3$var$__extends(ReactAce, _super);
    function ReactAce(props) {
        var _this = _super.call(this, props) || this;
        $f17e1925ce597b79$exports.editorEvents.forEach(function(method) {
            _this[method] = _this[method].bind(_this);
        });
        _this.debounce = $f17e1925ce597b79$exports.debounce;
        return _this;
    }
    ReactAce.prototype.isInShadow = function(node) {
        var parent = node && node.parentNode;
        while(parent){
            if (parent.toString() === "[object ShadowRoot]") return true;
            parent = parent.parentNode;
        }
        return false;
    };
    ReactAce.prototype.componentDidMount = function() {
        var _this = this;
        var _a = this.props, className = _a.className, onBeforeLoad = _a.onBeforeLoad, onValidate = _a.onValidate, mode = _a.mode, focus = _a.focus, theme = _a.theme, fontSize = _a.fontSize, value = _a.value, defaultValue = _a.defaultValue, showGutter = _a.showGutter, wrapEnabled = _a.wrapEnabled, showPrintMargin = _a.showPrintMargin, _b = _a.scrollMargin, scrollMargin = _b === void 0 ? [
            0,
            0,
            0,
            0
        ] : _b, keyboardHandler = _a.keyboardHandler, onLoad = _a.onLoad, commands = _a.commands, annotations = _a.annotations, markers = _a.markers, placeholder = _a.placeholder;
        this.editor = $4cb8d279e2475fd3$var$ace.edit(this.refEditor);
        if (onBeforeLoad) onBeforeLoad($4cb8d279e2475fd3$var$ace);
        var editorProps = Object.keys(this.props.editorProps);
        for(var i = 0; i < editorProps.length; i++)this.editor[editorProps[i]] = this.props.editorProps[editorProps[i]];
        if (this.props.debounceChangePeriod) this.onChange = this.debounce(this.onChange, this.props.debounceChangePeriod);
        this.editor.renderer.setScrollMargin(scrollMargin[0], scrollMargin[1], scrollMargin[2], scrollMargin[3]);
        if (this.isInShadow(this.refEditor)) this.editor.renderer.attachToShadowRoot();
        this.editor.getSession().setMode(typeof mode === "string" ? "ace/mode/".concat(mode) : mode);
        if (theme && theme !== "") this.editor.setTheme("ace/theme/".concat(theme));
        this.editor.setFontSize(typeof fontSize === "number" ? "".concat(fontSize, "px") : fontSize);
        this.editor.getSession().setValue(!defaultValue ? value || "" : defaultValue);
        if (this.props.navigateToFileEnd) this.editor.navigateFileEnd();
        this.editor.renderer.setShowGutter(showGutter);
        this.editor.getSession().setUseWrapMode(wrapEnabled);
        this.editor.setShowPrintMargin(showPrintMargin);
        this.editor.on("focus", this.onFocus);
        this.editor.on("blur", this.onBlur);
        this.editor.on("copy", this.onCopy);
        this.editor.on("paste", this.onPaste);
        this.editor.on("change", this.onChange);
        this.editor.on("input", this.onInput);
        if (placeholder) this.updatePlaceholder();
        this.editor.getSession().selection.on("changeSelection", this.onSelectionChange);
        this.editor.getSession().selection.on("changeCursor", this.onCursorChange);
        if (onValidate) // @ts-ignore types don't include
        this.editor.getSession().on("changeAnnotation", function() {
            // tslint:disable-next-line:no-shadowed-variable
            var annotations = _this.editor.getSession().getAnnotations();
            _this.props.onValidate(annotations);
        });
        this.editor.session.on("changeScrollTop", this.onScroll);
        this.editor.getSession().setAnnotations(annotations || []);
        if (markers && markers.length > 0) this.handleMarkers(markers);
        // get a list of possible options to avoid 'misspelled option errors'
        var availableOptions = this.editor.$options;
        $f17e1925ce597b79$exports.editorOptions.forEach(function(option) {
            if (availableOptions.hasOwnProperty(option)) // @ts-ignore
            _this.editor.setOption(option, _this.props[option]);
            else if (_this.props[option]) console.warn("ReactAce: editor option ".concat(option, " was activated but not found. Did you need to import a related tool or did you possibly mispell the option?"));
        });
        this.handleOptions(this.props);
        if (Array.isArray(commands)) commands.forEach(function(command) {
            if (typeof command.exec === "string") _this.editor.commands.bindKey(command.bindKey, command.exec);
            else _this.editor.commands.addCommand(command);
        });
        if (keyboardHandler) this.editor.setKeyboardHandler("ace/keyboard/" + keyboardHandler);
        if (className) this.refEditor.className += " " + className;
        if (onLoad) onLoad(this.editor);
        this.editor.resize();
        if (focus) this.editor.focus();
    };
    ReactAce.prototype.componentDidUpdate = function(prevProps) {
        var oldProps = prevProps;
        var nextProps = this.props;
        for(var i = 0; i < $f17e1925ce597b79$exports.editorOptions.length; i++){
            var option = $f17e1925ce597b79$exports.editorOptions[i];
            if (nextProps[option] !== oldProps[option]) // @ts-ignore
            this.editor.setOption(option, nextProps[option]);
        }
        if (nextProps.className !== oldProps.className) {
            var appliedClasses = this.refEditor.className;
            var appliedClassesArray_1 = appliedClasses.trim().split(" ");
            var oldClassesArray = oldProps.className.trim().split(" ");
            oldClassesArray.forEach(function(oldClass) {
                var index = appliedClassesArray_1.indexOf(oldClass);
                appliedClassesArray_1.splice(index, 1);
            });
            this.refEditor.className = " " + nextProps.className + " " + appliedClassesArray_1.join(" ");
        }
        // First process editor value, as it may create a new session (see issue #300)
        var valueChanged = this.editor && nextProps.value != null && this.editor.getValue() !== nextProps.value;
        if (valueChanged) {
            // editor.setValue is a synchronous function call, change event is emitted before setValue return.
            this.silent = true;
            var pos = this.editor.session.selection.toJSON();
            this.editor.setValue(nextProps.value, nextProps.cursorStart);
            this.editor.session.selection.fromJSON(pos);
            this.silent = false;
        }
        if (nextProps.placeholder !== oldProps.placeholder) this.updatePlaceholder();
        if (nextProps.mode !== oldProps.mode) this.editor.getSession().setMode(typeof nextProps.mode === "string" ? "ace/mode/".concat(nextProps.mode) : nextProps.mode);
        if (nextProps.theme !== oldProps.theme) this.editor.setTheme("ace/theme/" + nextProps.theme);
        if (nextProps.keyboardHandler !== oldProps.keyboardHandler) {
            if (nextProps.keyboardHandler) this.editor.setKeyboardHandler("ace/keyboard/" + nextProps.keyboardHandler);
            else this.editor.setKeyboardHandler(null);
        }
        if (nextProps.fontSize !== oldProps.fontSize) this.editor.setFontSize(typeof nextProps.fontSize === "number" ? "".concat(nextProps.fontSize, "px") : nextProps.fontSize);
        if (nextProps.wrapEnabled !== oldProps.wrapEnabled) this.editor.getSession().setUseWrapMode(nextProps.wrapEnabled);
        if (nextProps.showPrintMargin !== oldProps.showPrintMargin) this.editor.setShowPrintMargin(nextProps.showPrintMargin);
        if (nextProps.showGutter !== oldProps.showGutter) this.editor.renderer.setShowGutter(nextProps.showGutter);
        if (!$6cqMT(nextProps.setOptions, oldProps.setOptions)) this.handleOptions(nextProps);
        // if the value or annotations changed, set the annotations
        // changing the value may create create a new session which will require annotations to be re-set
        if (valueChanged || !$6cqMT(nextProps.annotations, oldProps.annotations)) this.editor.getSession().setAnnotations(nextProps.annotations || []);
        if (!$6cqMT(nextProps.markers, oldProps.markers) && Array.isArray(nextProps.markers)) this.handleMarkers(nextProps.markers);
        // this doesn't look like it works at all....
        if (!$6cqMT(nextProps.scrollMargin, oldProps.scrollMargin)) this.handleScrollMargins(nextProps.scrollMargin);
        if (prevProps.height !== this.props.height || prevProps.width !== this.props.width) this.editor.resize();
        if (this.props.focus && !prevProps.focus) this.editor.focus();
    };
    ReactAce.prototype.handleScrollMargins = function(margins) {
        if (margins === void 0) margins = [
            0,
            0,
            0,
            0
        ];
        this.editor.renderer.setScrollMargin(margins[0], margins[1], margins[2], margins[3]);
    };
    ReactAce.prototype.componentWillUnmount = function() {
        if (this.editor) {
            this.editor.destroy();
            this.editor = null;
        }
    };
    ReactAce.prototype.onChange = function(event) {
        if (this.props.onChange && !this.silent) {
            var value = this.editor.getValue();
            this.props.onChange(value, event);
        }
    };
    ReactAce.prototype.onSelectionChange = function(event) {
        if (this.props.onSelectionChange) {
            var value = this.editor.getSelection();
            this.props.onSelectionChange(value, event);
        }
    };
    ReactAce.prototype.onCursorChange = function(event) {
        if (this.props.onCursorChange) {
            var value = this.editor.getSelection();
            this.props.onCursorChange(value, event);
        }
    };
    ReactAce.prototype.onInput = function(event) {
        if (this.props.onInput) this.props.onInput(event);
        if (this.props.placeholder) this.updatePlaceholder();
    };
    ReactAce.prototype.onFocus = function(event) {
        if (this.props.onFocus) this.props.onFocus(event, this.editor);
    };
    ReactAce.prototype.onBlur = function(event) {
        if (this.props.onBlur) this.props.onBlur(event, this.editor);
    };
    ReactAce.prototype.onCopy = function(_a) {
        var text = _a.text;
        if (this.props.onCopy) this.props.onCopy(text);
    };
    ReactAce.prototype.onPaste = function(_a) {
        var text = _a.text;
        if (this.props.onPaste) this.props.onPaste(text);
    };
    ReactAce.prototype.onScroll = function() {
        if (this.props.onScroll) this.props.onScroll(this.editor);
    };
    ReactAce.prototype.handleOptions = function(props) {
        var setOptions = Object.keys(props.setOptions);
        for(var y = 0; y < setOptions.length; y++)// @ts-ignore
        this.editor.setOption(setOptions[y], props.setOptions[setOptions[y]]);
    };
    ReactAce.prototype.handleMarkers = function(markers) {
        var _this = this;
        // remove foreground markers
        var currentMarkers = this.editor.getSession().getMarkers(true);
        for(var i in currentMarkers)if (currentMarkers.hasOwnProperty(i)) this.editor.getSession().removeMarker(currentMarkers[i].id);
        // remove background markers except active line marker and selected word marker
        currentMarkers = this.editor.getSession().getMarkers(false);
        for(var i in currentMarkers)if (currentMarkers.hasOwnProperty(i) && currentMarkers[i].clazz !== "ace_active-line" && currentMarkers[i].clazz !== "ace_selected-word") this.editor.getSession().removeMarker(currentMarkers[i].id);
        // add new markers
        markers.forEach(function(_a) {
            var startRow = _a.startRow, startCol = _a.startCol, endRow = _a.endRow, endCol = _a.endCol, className = _a.className, type = _a.type, _b = _a.inFront, inFront = _b === void 0 ? false : _b;
            var range = new $jevmL.Range(startRow, startCol, endRow, endCol);
            _this.editor.getSession().addMarker(range, className, type, inFront);
        });
    };
    ReactAce.prototype.updatePlaceholder = function() {
        // Adapted from https://stackoverflow.com/questions/26695708/how-can-i-add-placeholder-text-when-the-editor-is-empty
        var editor = this.editor;
        var placeholder = this.props.placeholder;
        var showPlaceholder = !editor.session.getValue().length;
        var node = editor.renderer.placeholderNode;
        if (!showPlaceholder && node) {
            editor.renderer.scroller.removeChild(editor.renderer.placeholderNode);
            editor.renderer.placeholderNode = null;
        } else if (showPlaceholder && !node) {
            node = editor.renderer.placeholderNode = document.createElement("div");
            node.textContent = placeholder || "";
            node.className = "ace_comment ace_placeholder";
            node.style.padding = "0 9px";
            node.style.position = "absolute";
            node.style.zIndex = "3";
            editor.renderer.scroller.appendChild(node);
        } else if (showPlaceholder && node) node.textContent = placeholder;
    };
    ReactAce.prototype.updateRef = function(item) {
        this.refEditor = item;
    };
    ReactAce.prototype.render = function() {
        var _a = this.props, name = _a.name, width = _a.width, height = _a.height, style = _a.style;
        var divStyle = $4cb8d279e2475fd3$var$__assign({
            width: width,
            height: height
        }, style);
        return $acw62.createElement("div", {
            ref: this.updateRef,
            id: name,
            style: divStyle
        });
    };
    ReactAce.propTypes = {
        mode: $8da5bfbbed271cd7$exports.oneOfType([
            $8da5bfbbed271cd7$exports.string,
            $8da5bfbbed271cd7$exports.object
        ]),
        focus: $8da5bfbbed271cd7$exports.bool,
        theme: $8da5bfbbed271cd7$exports.string,
        name: $8da5bfbbed271cd7$exports.string,
        className: $8da5bfbbed271cd7$exports.string,
        height: $8da5bfbbed271cd7$exports.string,
        width: $8da5bfbbed271cd7$exports.string,
        fontSize: $8da5bfbbed271cd7$exports.oneOfType([
            $8da5bfbbed271cd7$exports.number,
            $8da5bfbbed271cd7$exports.string
        ]),
        showGutter: $8da5bfbbed271cd7$exports.bool,
        onChange: $8da5bfbbed271cd7$exports.func,
        onCopy: $8da5bfbbed271cd7$exports.func,
        onPaste: $8da5bfbbed271cd7$exports.func,
        onFocus: $8da5bfbbed271cd7$exports.func,
        onInput: $8da5bfbbed271cd7$exports.func,
        onBlur: $8da5bfbbed271cd7$exports.func,
        onScroll: $8da5bfbbed271cd7$exports.func,
        value: $8da5bfbbed271cd7$exports.string,
        defaultValue: $8da5bfbbed271cd7$exports.string,
        onLoad: $8da5bfbbed271cd7$exports.func,
        onSelectionChange: $8da5bfbbed271cd7$exports.func,
        onCursorChange: $8da5bfbbed271cd7$exports.func,
        onBeforeLoad: $8da5bfbbed271cd7$exports.func,
        onValidate: $8da5bfbbed271cd7$exports.func,
        minLines: $8da5bfbbed271cd7$exports.number,
        maxLines: $8da5bfbbed271cd7$exports.number,
        readOnly: $8da5bfbbed271cd7$exports.bool,
        highlightActiveLine: $8da5bfbbed271cd7$exports.bool,
        tabSize: $8da5bfbbed271cd7$exports.number,
        showPrintMargin: $8da5bfbbed271cd7$exports.bool,
        cursorStart: $8da5bfbbed271cd7$exports.number,
        debounceChangePeriod: $8da5bfbbed271cd7$exports.number,
        editorProps: $8da5bfbbed271cd7$exports.object,
        setOptions: $8da5bfbbed271cd7$exports.object,
        style: $8da5bfbbed271cd7$exports.object,
        scrollMargin: $8da5bfbbed271cd7$exports.array,
        annotations: $8da5bfbbed271cd7$exports.array,
        markers: $8da5bfbbed271cd7$exports.array,
        keyboardHandler: $8da5bfbbed271cd7$exports.string,
        wrapEnabled: $8da5bfbbed271cd7$exports.bool,
        enableSnippets: $8da5bfbbed271cd7$exports.bool,
        enableBasicAutocompletion: $8da5bfbbed271cd7$exports.oneOfType([
            $8da5bfbbed271cd7$exports.bool,
            $8da5bfbbed271cd7$exports.array
        ]),
        enableLiveAutocompletion: $8da5bfbbed271cd7$exports.oneOfType([
            $8da5bfbbed271cd7$exports.bool,
            $8da5bfbbed271cd7$exports.array
        ]),
        navigateToFileEnd: $8da5bfbbed271cd7$exports.bool,
        commands: $8da5bfbbed271cd7$exports.array,
        placeholder: $8da5bfbbed271cd7$exports.string
    };
    ReactAce.defaultProps = {
        name: "ace-editor",
        focus: false,
        mode: "",
        theme: "",
        height: "500px",
        width: "500px",
        fontSize: 12,
        enableSnippets: false,
        showGutter: true,
        onChange: null,
        onPaste: null,
        onLoad: null,
        onScroll: null,
        minLines: null,
        maxLines: null,
        readOnly: false,
        highlightActiveLine: true,
        showPrintMargin: true,
        tabSize: 4,
        cursorStart: 1,
        editorProps: {},
        style: {},
        scrollMargin: [
            0,
            0,
            0,
            0
        ],
        setOptions: {},
        wrapEnabled: false,
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        placeholder: null,
        navigateToFileEnd: true
    };
    return ReactAce;
}($acw62.Component);
$4cb8d279e2475fd3$exports.default = $4cb8d279e2475fd3$var$ReactAce;


var $32c89919e477b311$exports = {};
"use strict";
var $32c89919e477b311$var$__extends = $32c89919e477b311$exports && $32c89919e477b311$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($32c89919e477b311$exports, "__esModule", {
    value: true
});


var $acw62 = parcelRequire("acw62");
var $5841f702271ba066$exports = {};
"use strict";
var $5841f702271ba066$var$__extends = $5841f702271ba066$exports && $5841f702271ba066$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5841f702271ba066$var$__assign = $5841f702271ba066$exports && $5841f702271ba066$exports.__assign || function() {
    $5841f702271ba066$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5841f702271ba066$var$__assign.apply(this, arguments);
};
Object.defineProperty($5841f702271ba066$exports, "__esModule", {
    value: true
});

var $5841f702271ba066$var$ace = (0, $f17e1925ce597b79$exports.getAceInstance)();

var $jevmL = parcelRequire("jevmL");

var $3vplU = parcelRequire("3vplU");


var $acw62 = parcelRequire("acw62");

var $6cqMT = parcelRequire("6cqMT");
var $d0bbe9b61988891b$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $d0bbe9b61988891b$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var $d0bbe9b61988891b$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used as references for various `Number` constants. */ var $d0bbe9b61988891b$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $d0bbe9b61988891b$var$funcTag = "[object Function]", $d0bbe9b61988891b$var$genTag = "[object GeneratorFunction]", $d0bbe9b61988891b$var$symbolTag = "[object Symbol]";
/** Used to match property names within property paths. */ var $d0bbe9b61988891b$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $d0bbe9b61988891b$var$reIsPlainProp = /^\w*$/, $d0bbe9b61988891b$var$reLeadingDot = /^\./, $d0bbe9b61988891b$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $d0bbe9b61988891b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var $d0bbe9b61988891b$var$reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var $d0bbe9b61988891b$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $d0bbe9b61988891b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $d0bbe9b61988891b$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $d0bbe9b61988891b$var$root = $d0bbe9b61988891b$var$freeGlobal || $d0bbe9b61988891b$var$freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d0bbe9b61988891b$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $d0bbe9b61988891b$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $d0bbe9b61988891b$var$arrayProto = Array.prototype, $d0bbe9b61988891b$var$funcProto = Function.prototype, $d0bbe9b61988891b$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $d0bbe9b61988891b$var$coreJsData = $d0bbe9b61988891b$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $d0bbe9b61988891b$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($d0bbe9b61988891b$var$coreJsData && $d0bbe9b61988891b$var$coreJsData.keys && $d0bbe9b61988891b$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $d0bbe9b61988891b$var$funcToString = $d0bbe9b61988891b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d0bbe9b61988891b$var$hasOwnProperty = $d0bbe9b61988891b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d0bbe9b61988891b$var$objectToString = $d0bbe9b61988891b$var$objectProto.toString;
/** Used to detect if a method is native. */ var $d0bbe9b61988891b$var$reIsNative = RegExp("^" + $d0bbe9b61988891b$var$funcToString.call($d0bbe9b61988891b$var$hasOwnProperty).replace($d0bbe9b61988891b$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $d0bbe9b61988891b$var$Symbol = $d0bbe9b61988891b$var$root.Symbol, $d0bbe9b61988891b$var$splice = $d0bbe9b61988891b$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $d0bbe9b61988891b$var$Map = $d0bbe9b61988891b$var$getNative($d0bbe9b61988891b$var$root, "Map"), $d0bbe9b61988891b$var$nativeCreate = $d0bbe9b61988891b$var$getNative(Object, "create");
/** Used to convert symbols to primitives and strings. */ var $d0bbe9b61988891b$var$symbolProto = $d0bbe9b61988891b$var$Symbol ? $d0bbe9b61988891b$var$Symbol.prototype : undefined, $d0bbe9b61988891b$var$symbolToString = $d0bbe9b61988891b$var$symbolProto ? $d0bbe9b61988891b$var$symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d0bbe9b61988891b$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $d0bbe9b61988891b$var$hashClear() {
    this.__data__ = $d0bbe9b61988891b$var$nativeCreate ? $d0bbe9b61988891b$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d0bbe9b61988891b$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d0bbe9b61988891b$var$hashGet(key) {
    var data = this.__data__;
    if ($d0bbe9b61988891b$var$nativeCreate) {
        var result = data[key];
        return result === $d0bbe9b61988891b$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d0bbe9b61988891b$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d0bbe9b61988891b$var$hashHas(key) {
    var data = this.__data__;
    return $d0bbe9b61988891b$var$nativeCreate ? data[key] !== undefined : $d0bbe9b61988891b$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d0bbe9b61988891b$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $d0bbe9b61988891b$var$nativeCreate && value === undefined ? $d0bbe9b61988891b$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$d0bbe9b61988891b$var$Hash.prototype.clear = $d0bbe9b61988891b$var$hashClear;
$d0bbe9b61988891b$var$Hash.prototype["delete"] = $d0bbe9b61988891b$var$hashDelete;
$d0bbe9b61988891b$var$Hash.prototype.get = $d0bbe9b61988891b$var$hashGet;
$d0bbe9b61988891b$var$Hash.prototype.has = $d0bbe9b61988891b$var$hashHas;
$d0bbe9b61988891b$var$Hash.prototype.set = $d0bbe9b61988891b$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d0bbe9b61988891b$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $d0bbe9b61988891b$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d0bbe9b61988891b$var$listCacheDelete(key) {
    var data = this.__data__, index = $d0bbe9b61988891b$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d0bbe9b61988891b$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d0bbe9b61988891b$var$listCacheGet(key) {
    var data = this.__data__, index = $d0bbe9b61988891b$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d0bbe9b61988891b$var$listCacheHas(key) {
    return $d0bbe9b61988891b$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $d0bbe9b61988891b$var$listCacheSet(key, value) {
    var data = this.__data__, index = $d0bbe9b61988891b$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$d0bbe9b61988891b$var$ListCache.prototype.clear = $d0bbe9b61988891b$var$listCacheClear;
$d0bbe9b61988891b$var$ListCache.prototype["delete"] = $d0bbe9b61988891b$var$listCacheDelete;
$d0bbe9b61988891b$var$ListCache.prototype.get = $d0bbe9b61988891b$var$listCacheGet;
$d0bbe9b61988891b$var$ListCache.prototype.has = $d0bbe9b61988891b$var$listCacheHas;
$d0bbe9b61988891b$var$ListCache.prototype.set = $d0bbe9b61988891b$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d0bbe9b61988891b$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $d0bbe9b61988891b$var$mapCacheClear() {
    this.__data__ = {
        "hash": new $d0bbe9b61988891b$var$Hash,
        "map": new ($d0bbe9b61988891b$var$Map || $d0bbe9b61988891b$var$ListCache),
        "string": new $d0bbe9b61988891b$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d0bbe9b61988891b$var$mapCacheDelete(key) {
    return $d0bbe9b61988891b$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d0bbe9b61988891b$var$mapCacheGet(key) {
    return $d0bbe9b61988891b$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d0bbe9b61988891b$var$mapCacheHas(key) {
    return $d0bbe9b61988891b$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $d0bbe9b61988891b$var$mapCacheSet(key, value) {
    $d0bbe9b61988891b$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$d0bbe9b61988891b$var$MapCache.prototype.clear = $d0bbe9b61988891b$var$mapCacheClear;
$d0bbe9b61988891b$var$MapCache.prototype["delete"] = $d0bbe9b61988891b$var$mapCacheDelete;
$d0bbe9b61988891b$var$MapCache.prototype.get = $d0bbe9b61988891b$var$mapCacheGet;
$d0bbe9b61988891b$var$MapCache.prototype.has = $d0bbe9b61988891b$var$mapCacheHas;
$d0bbe9b61988891b$var$MapCache.prototype.set = $d0bbe9b61988891b$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d0bbe9b61988891b$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($d0bbe9b61988891b$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $d0bbe9b61988891b$var$baseGet(object, path) {
    path = $d0bbe9b61988891b$var$isKey(path, object) ? [
        path
    ] : $d0bbe9b61988891b$var$castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$d0bbe9b61988891b$var$toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $d0bbe9b61988891b$var$baseIsNative(value) {
    if (!$d0bbe9b61988891b$var$isObject(value) || $d0bbe9b61988891b$var$isMasked(value)) return false;
    var pattern = $d0bbe9b61988891b$var$isFunction(value) || $d0bbe9b61988891b$var$isHostObject(value) ? $d0bbe9b61988891b$var$reIsNative : $d0bbe9b61988891b$var$reIsHostCtor;
    return pattern.test($d0bbe9b61988891b$var$toSource(value));
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $d0bbe9b61988891b$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($d0bbe9b61988891b$var$isSymbol(value)) return $d0bbe9b61988891b$var$symbolToString ? $d0bbe9b61988891b$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$d0bbe9b61988891b$var$INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function $d0bbe9b61988891b$var$castPath(value) {
    return $d0bbe9b61988891b$var$isArray(value) ? value : $d0bbe9b61988891b$var$stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $d0bbe9b61988891b$var$getMapData(map, key) {
    var data = map.__data__;
    return $d0bbe9b61988891b$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $d0bbe9b61988891b$var$getNative(object, key) {
    var value = $d0bbe9b61988891b$var$getValue(object, key);
    return $d0bbe9b61988891b$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $d0bbe9b61988891b$var$isKey(value, object) {
    if ($d0bbe9b61988891b$var$isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $d0bbe9b61988891b$var$isSymbol(value)) return true;
    return $d0bbe9b61988891b$var$reIsPlainProp.test(value) || !$d0bbe9b61988891b$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $d0bbe9b61988891b$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $d0bbe9b61988891b$var$isMasked(func) {
    return !!$d0bbe9b61988891b$var$maskSrcKey && $d0bbe9b61988891b$var$maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $d0bbe9b61988891b$var$stringToPath = $d0bbe9b61988891b$var$memoize(function(string) {
    string = $d0bbe9b61988891b$var$toString(string);
    var result = [];
    if ($d0bbe9b61988891b$var$reLeadingDot.test(string)) result.push("");
    string.replace($d0bbe9b61988891b$var$rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace($d0bbe9b61988891b$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $d0bbe9b61988891b$var$toKey(value) {
    if (typeof value == "string" || $d0bbe9b61988891b$var$isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$d0bbe9b61988891b$var$INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $d0bbe9b61988891b$var$toSource(func) {
    if (func != null) {
        try {
            return $d0bbe9b61988891b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $d0bbe9b61988891b$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError($d0bbe9b61988891b$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($d0bbe9b61988891b$var$memoize.Cache || $d0bbe9b61988891b$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$d0bbe9b61988891b$var$memoize.Cache = $d0bbe9b61988891b$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $d0bbe9b61988891b$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d0bbe9b61988891b$var$isArray = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $d0bbe9b61988891b$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $d0bbe9b61988891b$var$isObject(value) ? $d0bbe9b61988891b$var$objectToString.call(value) : "";
    return tag == $d0bbe9b61988891b$var$funcTag || tag == $d0bbe9b61988891b$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $d0bbe9b61988891b$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $d0bbe9b61988891b$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $d0bbe9b61988891b$var$isSymbol(value) {
    return typeof value == "symbol" || $d0bbe9b61988891b$var$isObjectLike(value) && $d0bbe9b61988891b$var$objectToString.call(value) == $d0bbe9b61988891b$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $d0bbe9b61988891b$var$toString(value) {
    return value == null ? "" : $d0bbe9b61988891b$var$baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d0bbe9b61988891b$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $d0bbe9b61988891b$var$baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
$d0bbe9b61988891b$exports = $d0bbe9b61988891b$var$get;


var $5841f702271ba066$var$SplitComponent = /** @class */ function(_super) {
    $5841f702271ba066$var$__extends(SplitComponent, _super);
    function SplitComponent(props) {
        var _this = _super.call(this, props) || this;
        $f17e1925ce597b79$exports.editorEvents.forEach(function(method) {
            _this[method] = _this[method].bind(_this);
        });
        _this.debounce = $f17e1925ce597b79$exports.debounce;
        return _this;
    }
    SplitComponent.prototype.isInShadow = function(node) {
        var parent = node && node.parentNode;
        while(parent){
            if (parent.toString() === "[object ShadowRoot]") return true;
            parent = parent.parentNode;
        }
        return false;
    };
    SplitComponent.prototype.componentDidMount = function() {
        var _this = this;
        var _a = this.props, className = _a.className, onBeforeLoad = _a.onBeforeLoad, mode = _a.mode, focus = _a.focus, theme = _a.theme, fontSize = _a.fontSize, value = _a.value, defaultValue = _a.defaultValue, cursorStart = _a.cursorStart, showGutter = _a.showGutter, wrapEnabled = _a.wrapEnabled, showPrintMargin = _a.showPrintMargin, _b = _a.scrollMargin, scrollMargin = _b === void 0 ? [
            0,
            0,
            0,
            0
        ] : _b, keyboardHandler = _a.keyboardHandler, onLoad = _a.onLoad, commands = _a.commands, annotations = _a.annotations, markers = _a.markers, splits = _a.splits;
        this.editor = $5841f702271ba066$var$ace.edit(this.refEditor);
        if (this.isInShadow(this.refEditor)) this.editor.renderer.attachToShadowRoot();
        this.editor.setTheme("ace/theme/".concat(theme));
        if (onBeforeLoad) onBeforeLoad($5841f702271ba066$var$ace);
        var editorProps = Object.keys(this.props.editorProps);
        var split = new $3vplU.Split(this.editor.container, "ace/theme/".concat(theme), splits);
        this.editor.env.split = split;
        this.splitEditor = split.getEditor(0);
        this.split = split;
        // in a split scenario we don't want a print margin for the entire application
        this.editor.setShowPrintMargin(false);
        this.editor.renderer.setShowGutter(false);
        // get a list of possible options to avoid 'misspelled option errors'
        var availableOptions = this.splitEditor.$options;
        if (this.props.debounceChangePeriod) this.onChange = this.debounce(this.onChange, this.props.debounceChangePeriod);
        split.forEach(function(editor, index) {
            for(var i = 0; i < editorProps.length; i++)editor[editorProps[i]] = _this.props.editorProps[editorProps[i]];
            var defaultValueForEditor = $d0bbe9b61988891b$exports(defaultValue, index);
            var valueForEditor = $d0bbe9b61988891b$exports(value, index, "");
            editor.session.setUndoManager(new $5841f702271ba066$var$ace.UndoManager());
            editor.setTheme("ace/theme/".concat(theme));
            editor.renderer.setScrollMargin(scrollMargin[0], scrollMargin[1], scrollMargin[2], scrollMargin[3]);
            editor.getSession().setMode("ace/mode/".concat(mode));
            editor.setFontSize(fontSize);
            editor.renderer.setShowGutter(showGutter);
            editor.getSession().setUseWrapMode(wrapEnabled);
            editor.setShowPrintMargin(showPrintMargin);
            editor.on("focus", _this.onFocus);
            editor.on("blur", _this.onBlur);
            editor.on("input", _this.onInput);
            editor.on("copy", _this.onCopy);
            editor.on("paste", _this.onPaste);
            editor.on("change", _this.onChange);
            editor.getSession().selection.on("changeSelection", _this.onSelectionChange);
            editor.getSession().selection.on("changeCursor", _this.onCursorChange);
            editor.session.on("changeScrollTop", _this.onScroll);
            editor.setValue(defaultValueForEditor === undefined ? valueForEditor : defaultValueForEditor, cursorStart);
            var newAnnotations = $d0bbe9b61988891b$exports(annotations, index, []);
            var newMarkers = $d0bbe9b61988891b$exports(markers, index, []);
            editor.getSession().setAnnotations(newAnnotations);
            if (newMarkers && newMarkers.length > 0) _this.handleMarkers(newMarkers, editor);
            for(var i = 0; i < $f17e1925ce597b79$exports.editorOptions.length; i++){
                var option = $f17e1925ce597b79$exports.editorOptions[i];
                if (availableOptions.hasOwnProperty(option)) editor.setOption(option, _this.props[option]);
                else if (_this.props[option]) console.warn("ReaceAce: editor option ".concat(option, " was activated but not found. Did you need to import a related tool or did you possibly mispell the option?"));
            }
            _this.handleOptions(_this.props, editor);
            if (Array.isArray(commands)) commands.forEach(function(command) {
                if (typeof command.exec === "string") editor.commands.bindKey(command.bindKey, command.exec);
                else editor.commands.addCommand(command);
            });
            if (keyboardHandler) editor.setKeyboardHandler("ace/keyboard/" + keyboardHandler);
        });
        if (className) this.refEditor.className += " " + className;
        if (focus) this.splitEditor.focus();
        var sp = this.editor.env.split;
        sp.setOrientation(this.props.orientation === "below" ? sp.BELOW : sp.BESIDE);
        sp.resize(true);
        if (onLoad) onLoad(sp);
    };
    SplitComponent.prototype.componentDidUpdate = function(prevProps) {
        var _this = this;
        var oldProps = prevProps;
        var nextProps = this.props;
        var split = this.editor.env.split;
        if (nextProps.splits !== oldProps.splits) split.setSplits(nextProps.splits);
        if (nextProps.orientation !== oldProps.orientation) split.setOrientation(nextProps.orientation === "below" ? split.BELOW : split.BESIDE);
        split.forEach(function(editor, index) {
            if (nextProps.mode !== oldProps.mode) editor.getSession().setMode("ace/mode/" + nextProps.mode);
            if (nextProps.keyboardHandler !== oldProps.keyboardHandler) {
                if (nextProps.keyboardHandler) editor.setKeyboardHandler("ace/keyboard/" + nextProps.keyboardHandler);
                else editor.setKeyboardHandler(null);
            }
            if (nextProps.fontSize !== oldProps.fontSize) editor.setFontSize(nextProps.fontSize);
            if (nextProps.wrapEnabled !== oldProps.wrapEnabled) editor.getSession().setUseWrapMode(nextProps.wrapEnabled);
            if (nextProps.showPrintMargin !== oldProps.showPrintMargin) editor.setShowPrintMargin(nextProps.showPrintMargin);
            if (nextProps.showGutter !== oldProps.showGutter) editor.renderer.setShowGutter(nextProps.showGutter);
            for(var i = 0; i < $f17e1925ce597b79$exports.editorOptions.length; i++){
                var option = $f17e1925ce597b79$exports.editorOptions[i];
                if (nextProps[option] !== oldProps[option]) editor.setOption(option, nextProps[option]);
            }
            if (!$6cqMT(nextProps.setOptions, oldProps.setOptions)) _this.handleOptions(nextProps, editor);
            var nextValue = $d0bbe9b61988891b$exports(nextProps.value, index, "");
            if (editor.getValue() !== nextValue) {
                // editor.setValue is a synchronous function call, change event is emitted before setValue return.
                _this.silent = true;
                var pos = editor.session.selection.toJSON();
                editor.setValue(nextValue, nextProps.cursorStart);
                editor.session.selection.fromJSON(pos);
                _this.silent = false;
            }
            var newAnnotations = $d0bbe9b61988891b$exports(nextProps.annotations, index, []);
            var oldAnnotations = $d0bbe9b61988891b$exports(oldProps.annotations, index, []);
            if (!$6cqMT(newAnnotations, oldAnnotations)) editor.getSession().setAnnotations(newAnnotations);
            var newMarkers = $d0bbe9b61988891b$exports(nextProps.markers, index, []);
            var oldMarkers = $d0bbe9b61988891b$exports(oldProps.markers, index, []);
            if (!$6cqMT(newMarkers, oldMarkers) && Array.isArray(newMarkers)) _this.handleMarkers(newMarkers, editor);
        });
        if (nextProps.className !== oldProps.className) {
            var appliedClasses = this.refEditor.className;
            var appliedClassesArray_1 = appliedClasses.trim().split(" ");
            var oldClassesArray = oldProps.className.trim().split(" ");
            oldClassesArray.forEach(function(oldClass) {
                var index = appliedClassesArray_1.indexOf(oldClass);
                appliedClassesArray_1.splice(index, 1);
            });
            this.refEditor.className = " " + nextProps.className + " " + appliedClassesArray_1.join(" ");
        }
        if (nextProps.theme !== oldProps.theme) split.setTheme("ace/theme/" + nextProps.theme);
        if (nextProps.focus && !oldProps.focus) this.splitEditor.focus();
        if (nextProps.height !== this.props.height || nextProps.width !== this.props.width) this.editor.resize();
    };
    SplitComponent.prototype.componentWillUnmount = function() {
        this.editor.destroy();
        this.editor = null;
    };
    SplitComponent.prototype.onChange = function(event) {
        if (this.props.onChange && !this.silent) {
            var value_1 = [];
            this.editor.env.split.forEach(function(editor) {
                value_1.push(editor.getValue());
            });
            this.props.onChange(value_1, event);
        }
    };
    SplitComponent.prototype.onSelectionChange = function(event) {
        if (this.props.onSelectionChange) {
            var value_2 = [];
            this.editor.env.split.forEach(function(editor) {
                value_2.push(editor.getSelection());
            });
            this.props.onSelectionChange(value_2, event);
        }
    };
    SplitComponent.prototype.onCursorChange = function(event) {
        if (this.props.onCursorChange) {
            var value_3 = [];
            this.editor.env.split.forEach(function(editor) {
                value_3.push(editor.getSelection());
            });
            this.props.onCursorChange(value_3, event);
        }
    };
    SplitComponent.prototype.onFocus = function(event) {
        if (this.props.onFocus) this.props.onFocus(event);
    };
    SplitComponent.prototype.onInput = function(event) {
        if (this.props.onInput) this.props.onInput(event);
    };
    SplitComponent.prototype.onBlur = function(event) {
        if (this.props.onBlur) this.props.onBlur(event);
    };
    SplitComponent.prototype.onCopy = function(text) {
        if (this.props.onCopy) this.props.onCopy(text);
    };
    SplitComponent.prototype.onPaste = function(text) {
        if (this.props.onPaste) this.props.onPaste(text);
    };
    SplitComponent.prototype.onScroll = function() {
        if (this.props.onScroll) this.props.onScroll(this.editor);
    };
    SplitComponent.prototype.handleOptions = function(props, editor) {
        var setOptions = Object.keys(props.setOptions);
        for(var y = 0; y < setOptions.length; y++)editor.setOption(setOptions[y], props.setOptions[setOptions[y]]);
    };
    SplitComponent.prototype.handleMarkers = function(markers, editor) {
        // remove foreground markers
        var currentMarkers = editor.getSession().getMarkers(true);
        for(var i in currentMarkers)if (currentMarkers.hasOwnProperty(i)) editor.getSession().removeMarker(currentMarkers[i].id);
        // remove background markers
        currentMarkers = editor.getSession().getMarkers(false);
        for(var i in currentMarkers)if (currentMarkers.hasOwnProperty(i)) editor.getSession().removeMarker(currentMarkers[i].id);
        // add new markers
        markers.forEach(function(_a) {
            var startRow = _a.startRow, startCol = _a.startCol, endRow = _a.endRow, endCol = _a.endCol, className = _a.className, type = _a.type, _b = _a.inFront, inFront = _b === void 0 ? false : _b;
            var range = new $jevmL.Range(startRow, startCol, endRow, endCol);
            editor.getSession().addMarker(range, className, type, inFront);
        });
    };
    SplitComponent.prototype.updateRef = function(item) {
        this.refEditor = item;
    };
    SplitComponent.prototype.render = function() {
        var _a = this.props, name = _a.name, width = _a.width, height = _a.height, style = _a.style;
        var divStyle = $5841f702271ba066$var$__assign({
            width: width,
            height: height
        }, style);
        return $acw62.createElement("div", {
            ref: this.updateRef,
            id: name,
            style: divStyle
        });
    };
    SplitComponent.propTypes = {
        className: $8da5bfbbed271cd7$exports.string,
        debounceChangePeriod: $8da5bfbbed271cd7$exports.number,
        defaultValue: $8da5bfbbed271cd7$exports.arrayOf($8da5bfbbed271cd7$exports.string),
        focus: $8da5bfbbed271cd7$exports.bool,
        fontSize: $8da5bfbbed271cd7$exports.oneOfType([
            $8da5bfbbed271cd7$exports.number,
            $8da5bfbbed271cd7$exports.string
        ]),
        height: $8da5bfbbed271cd7$exports.string,
        mode: $8da5bfbbed271cd7$exports.string,
        name: $8da5bfbbed271cd7$exports.string,
        onBlur: $8da5bfbbed271cd7$exports.func,
        onChange: $8da5bfbbed271cd7$exports.func,
        onCopy: $8da5bfbbed271cd7$exports.func,
        onFocus: $8da5bfbbed271cd7$exports.func,
        onInput: $8da5bfbbed271cd7$exports.func,
        onLoad: $8da5bfbbed271cd7$exports.func,
        onPaste: $8da5bfbbed271cd7$exports.func,
        onScroll: $8da5bfbbed271cd7$exports.func,
        orientation: $8da5bfbbed271cd7$exports.string,
        showGutter: $8da5bfbbed271cd7$exports.bool,
        splits: $8da5bfbbed271cd7$exports.number,
        theme: $8da5bfbbed271cd7$exports.string,
        value: $8da5bfbbed271cd7$exports.arrayOf($8da5bfbbed271cd7$exports.string),
        width: $8da5bfbbed271cd7$exports.string,
        onSelectionChange: $8da5bfbbed271cd7$exports.func,
        onCursorChange: $8da5bfbbed271cd7$exports.func,
        onBeforeLoad: $8da5bfbbed271cd7$exports.func,
        minLines: $8da5bfbbed271cd7$exports.number,
        maxLines: $8da5bfbbed271cd7$exports.number,
        readOnly: $8da5bfbbed271cd7$exports.bool,
        highlightActiveLine: $8da5bfbbed271cd7$exports.bool,
        tabSize: $8da5bfbbed271cd7$exports.number,
        showPrintMargin: $8da5bfbbed271cd7$exports.bool,
        cursorStart: $8da5bfbbed271cd7$exports.number,
        editorProps: $8da5bfbbed271cd7$exports.object,
        setOptions: $8da5bfbbed271cd7$exports.object,
        style: $8da5bfbbed271cd7$exports.object,
        scrollMargin: $8da5bfbbed271cd7$exports.array,
        annotations: $8da5bfbbed271cd7$exports.array,
        markers: $8da5bfbbed271cd7$exports.array,
        keyboardHandler: $8da5bfbbed271cd7$exports.string,
        wrapEnabled: $8da5bfbbed271cd7$exports.bool,
        enableBasicAutocompletion: $8da5bfbbed271cd7$exports.oneOfType([
            $8da5bfbbed271cd7$exports.bool,
            $8da5bfbbed271cd7$exports.array
        ]),
        enableLiveAutocompletion: $8da5bfbbed271cd7$exports.oneOfType([
            $8da5bfbbed271cd7$exports.bool,
            $8da5bfbbed271cd7$exports.array
        ]),
        commands: $8da5bfbbed271cd7$exports.array
    };
    SplitComponent.defaultProps = {
        name: "ace-editor",
        focus: false,
        orientation: "beside",
        splits: 2,
        mode: "",
        theme: "",
        height: "500px",
        width: "500px",
        value: [],
        fontSize: 12,
        showGutter: true,
        onChange: null,
        onPaste: null,
        onLoad: null,
        onScroll: null,
        minLines: null,
        maxLines: null,
        readOnly: false,
        highlightActiveLine: true,
        showPrintMargin: true,
        tabSize: 4,
        cursorStart: 1,
        editorProps: {},
        style: {},
        scrollMargin: [
            0,
            0,
            0,
            0
        ],
        setOptions: {},
        wrapEnabled: false,
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false
    };
    return SplitComponent;
}($acw62.Component);
$5841f702271ba066$exports.default = $5841f702271ba066$var$SplitComponent;


var $20f03067c3b20090$exports = {};
/**
 * Diff Match and Patch
 * Copyright 2018 The diff-match-patch Authors.
 * https://github.com/google/diff-match-patch
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Computes the difference between two texts to create a patch.
 * Applies the patch onto another text, allowing for errors.
 * @author fraser@google.com (Neil Fraser)
 */ /**
 * Class containing the diff, match and patch methods.
 * @constructor
 */ var $20f03067c3b20090$var$diff_match_patch = function() {
    // Defaults.
    // Redefine these in your program to override the defaults.
    // Number of seconds to map a diff before giving up (0 for infinity).
    this.Diff_Timeout = 1.0;
    // Cost of an empty edit operation in terms of edit characters.
    this.Diff_EditCost = 4;
    // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
    this.Match_Threshold = 0.5;
    // How far to search for a match (0 = exact location, 1000+ = broad match).
    // A match this many characters away from the expected location will add
    // 1.0 to the score (0.0 is a perfect match).
    this.Match_Distance = 1000;
    // When deleting a large block of text (over ~64 characters), how close do
    // the contents have to be to match the expected contents. (0.0 = perfection,
    // 1.0 = very loose).  Note that Match_Threshold controls how closely the
    // end points of a delete need to match.
    this.Patch_DeleteThreshold = 0.5;
    // Chunk size for context length.
    this.Patch_Margin = 4;
    // The number of bits in an int.
    this.Match_MaxBits = 32;
};
//  DIFF FUNCTIONS
/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $20f03067c3b20090$var$DIFF_DELETE = -1;
var $20f03067c3b20090$var$DIFF_INSERT = 1;
var $20f03067c3b20090$var$DIFF_EQUAL = 0;
/**
 * Class representing one diff tuple.
 * ~Attempts to look like a two-element array (which is what this used to be).~
 * Constructor returns an actual two-element array, to allow destructing @JackuB
 * See https://github.com/JackuB/diff-match-patch/issues/14 for details
 * @param {number} op Operation, one of: DIFF_DELETE, DIFF_INSERT, DIFF_EQUAL.
 * @param {string} text Text to be deleted, inserted, or retained.
 * @constructor
 */ $20f03067c3b20090$var$diff_match_patch.Diff = function(op, text) {
    return [
        op,
        text
    ];
};
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
 *     then don't run a line-level diff first to identify the changed areas.
 *     Defaults to true, which does a faster, slightly less optimal diff.
 * @param {number=} opt_deadline Optional time when the diff should be complete
 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
 *     instead.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_main = function(text1, text2, opt_checklines, opt_deadline) {
    // Set a deadline by which time the diff must be complete.
    if (typeof opt_deadline == "undefined") {
        if (this.Diff_Timeout <= 0) opt_deadline = Number.MAX_VALUE;
        else opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
    }
    var deadline = opt_deadline;
    // Check for null inputs.
    if (text1 == null || text2 == null) throw new Error("Null input. (diff_main)");
    // Check for equality (speedup).
    if (text1 == text2) {
        if (text1) return [
            new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, text1)
        ];
        return [];
    }
    if (typeof opt_checklines == "undefined") opt_checklines = true;
    var checklines = opt_checklines;
    // Trim off common prefix (speedup).
    var commonlength = this.diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = this.diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = this.diff_compute_(text1, text2, checklines, deadline);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, commonprefix));
    if (commonsuffix) diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, commonsuffix));
    this.diff_cleanupMerge(diffs);
    return diffs;
};
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean} checklines Speedup flag.  If false, then don't run a
 *     line-level diff first to identify the changed areas.
 *     If true, then run a faster, slightly less optimal diff.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_compute_ = function(text1, text2, checklines, deadline) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_INSERT, text2)
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_DELETE, text1)
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i != -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_INSERT, longtext.substring(0, i)),
            new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, shorttext),
            new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_INSERT, longtext.substring(i + shorttext.length))
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $20f03067c3b20090$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length == 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_DELETE, text1),
        new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_INSERT, text2)
    ];
    // Check to see if the problem can be split in two.
    var hm = this.diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
        var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
        // Merge the results.
        return diffs_a.concat([
            new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, mid_common)
        ], diffs_b);
    }
    if (checklines && text1.length > 100 && text2.length > 100) return this.diff_lineMode_(text1, text2, deadline);
    return this.diff_bisect_(text1, text2, deadline);
};
/**
 * Do a quick line-level diff on both strings, then rediff the parts for
 * greater accuracy.
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_lineMode_ = function(text1, text2, deadline) {
    // Scan the text on a line-by-line basis first.
    var a = this.diff_linesToChars_(text1, text2);
    text1 = a.chars1;
    text2 = a.chars2;
    var linearray = a.lineArray;
    var diffs = this.diff_main(text1, text2, false, deadline);
    // Convert the diff back to original text.
    this.diff_charsToLines_(diffs, linearray);
    // Eliminate freak matches (e.g. blank lines)
    this.diff_cleanupSemantic(diffs);
    // Rediff any replacement blocks, this time character-by-character.
    // Add a dummy entry at the end.
    diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, ""));
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    while(pointer < diffs.length){
        switch(diffs[pointer][0]){
            case $20f03067c3b20090$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                break;
            case $20f03067c3b20090$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                break;
            case $20f03067c3b20090$var$DIFF_EQUAL:
                // Upon reaching an equality, check for prior redundancies.
                if (count_delete >= 1 && count_insert >= 1) {
                    // Delete the offending records and add the merged ones.
                    diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert);
                    pointer = pointer - count_delete - count_insert;
                    var subDiff = this.diff_main(text_delete, text_insert, false, deadline);
                    for(var j = subDiff.length - 1; j >= 0; j--)diffs.splice(pointer, 0, subDiff[j]);
                    pointer = pointer + subDiff.length;
                }
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
        pointer++;
    }
    diffs.pop(); // Remove the dummy entry at the end.
    return diffs;
};
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_bisect_ = function(text1, text2, deadline) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 != 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Bail out if deadline is reached.
        if (new Date().getTime() > deadline) break;
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_DELETE, text1),
        new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_INSERT, text2)
    ];
};
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_bisectSplit_ = function(text1, text2, x, y, deadline) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = this.diff_main(text1a, text2a, false, deadline);
    var diffsb = this.diff_main(text1b, text2b, false, deadline);
    return diffs.concat(diffsb);
};
/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 * @private
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_linesToChars_ = function(text1, text2) {
    var lineArray = []; // e.g. lineArray[4] == 'Hello\n'
    var lineHash = {}; // e.g. lineHash['Hello\n'] == 4
    // '\x00' is a valid character, but various debuggers don't like it.
    // So we'll insert a junk entry to avoid generating a null character.
    lineArray[0] = "";
    /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   * @param {string} text String to encode.
   * @return {string} Encoded string.
   * @private
   */ function diff_linesToCharsMunge_(text) {
        var chars = "";
        // Walk the text, pulling out a substring for each line.
        // text.split('\n') would would temporarily double our memory footprint.
        // Modifying text would create many large strings to garbage collect.
        var lineStart = 0;
        var lineEnd = -1;
        // Keeping our own length variable is faster than looking it up.
        var lineArrayLength = lineArray.length;
        while(lineEnd < text.length - 1){
            lineEnd = text.indexOf("\n", lineStart);
            if (lineEnd == -1) lineEnd = text.length - 1;
            var line = text.substring(lineStart, lineEnd + 1);
            if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) : lineHash[line] !== undefined) chars += String.fromCharCode(lineHash[line]);
            else {
                if (lineArrayLength == maxLines) {
                    // Bail out at 65535 because
                    // String.fromCharCode(65536) == String.fromCharCode(0)
                    line = text.substring(lineStart);
                    lineEnd = text.length;
                }
                chars += String.fromCharCode(lineArrayLength);
                lineHash[line] = lineArrayLength;
                lineArray[lineArrayLength++] = line;
            }
            lineStart = lineEnd + 1;
        }
        return chars;
    }
    // Allocate 2/3rds of the space for text1, the rest for text2.
    var maxLines = 40000;
    var chars1 = diff_linesToCharsMunge_(text1);
    maxLines = 65535;
    var chars2 = diff_linesToCharsMunge_(text2);
    return {
        chars1: chars1,
        chars2: chars2,
        lineArray: lineArray
    };
};
/**
 * Rehydrate the text in a diff from a string of line hashes to real lines of
 * text.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {!Array.<string>} lineArray Array of unique strings.
 * @private
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_charsToLines_ = function(diffs, lineArray) {
    for(var i = 0; i < diffs.length; i++){
        var chars = diffs[i][1];
        var text = [];
        for(var j = 0; j < chars.length; j++)text[j] = lineArray[chars.charCodeAt(j)];
        diffs[i][1] = text.join("");
    }
};
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_commonPrefix = function(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: https://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    return pointermid;
};
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_commonSuffix = function(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) return 0;
    // Binary search.
    // Performance analysis: https://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    return pointermid;
};
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_commonOverlap_ = function(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: https://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
};
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 * @private
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_halfMatch_ = function(text1, text2) {
    if (this.Diff_Timeout <= 0) // Don't risk returning a non-optimal diff if we have unlimited time.
    return null;
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    var dmp = this; // 'this' becomes 'window' in a closure.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) != -1){
            var prefixLength = dmp.diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
};
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_cleanupSemantic = function(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastEquality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $20f03067c3b20090$var$DIFF_EQUAL) {
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastEquality = diffs[pointer][1];
        } else {
            if (diffs[pointer][0] == $20f03067c3b20090$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastEquality && lastEquality.length <= Math.max(length_insertions1, length_deletions1) && lastEquality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_DELETE, lastEquality));
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $20f03067c3b20090$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastEquality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) this.diff_cleanupMerge(diffs);
    this.diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $20f03067c3b20090$var$DIFF_DELETE && diffs[pointer][0] == $20f03067c3b20090$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, insertion.substring(0, overlap_length1)));
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, deletion.substring(0, overlap_length2)));
                diffs[pointer - 1][0] = $20f03067c3b20090$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $20f03067c3b20090$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
};
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_cleanupSemanticLossless = function(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($20f03067c3b20090$var$diff_match_patch.nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($20f03067c3b20090$var$diff_match_patch.nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($20f03067c3b20090$var$diff_match_patch.whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($20f03067c3b20090$var$diff_match_patch.whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($20f03067c3b20090$var$diff_match_patch.linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($20f03067c3b20090$var$diff_match_patch.linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($20f03067c3b20090$var$diff_match_patch.blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($20f03067c3b20090$var$diff_match_patch.blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $20f03067c3b20090$var$DIFF_EQUAL && diffs[pointer + 1][0] == $20f03067c3b20090$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = this.diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
};
// Define some regex patterns for matching boundaries.
$20f03067c3b20090$var$diff_match_patch.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
$20f03067c3b20090$var$diff_match_patch.whitespaceRegex_ = /\s/;
$20f03067c3b20090$var$diff_match_patch.linebreakRegex_ = /[\r\n]/;
$20f03067c3b20090$var$diff_match_patch.blanklineEndRegex_ = /\n\r?\n$/;
$20f03067c3b20090$var$diff_match_patch.blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Reduce the number of edits by eliminating operationally trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_cleanupEfficiency = function(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastEquality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Is there an insertion operation before the last equality.
    var pre_ins = false;
    // Is there a deletion operation before the last equality.
    var pre_del = false;
    // Is there an insertion operation after the last equality.
    var post_ins = false;
    // Is there a deletion operation after the last equality.
    var post_del = false;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $20f03067c3b20090$var$DIFF_EQUAL) {
            if (diffs[pointer][1].length < this.Diff_EditCost && (post_ins || post_del)) {
                // Candidate found.
                equalities[equalitiesLength++] = pointer;
                pre_ins = post_ins;
                pre_del = post_del;
                lastEquality = diffs[pointer][1];
            } else {
                // Not a candidate, and can never become one.
                equalitiesLength = 0;
                lastEquality = null;
            }
            post_ins = post_del = false;
        } else {
            if (diffs[pointer][0] == $20f03067c3b20090$var$DIFF_DELETE) post_del = true;
            else post_ins = true;
            /*
       * Five types to be split:
       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
       * <ins>A</ins>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<ins>C</ins>
       * <ins>A</del>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<del>C</del>
       */ if (lastEquality && (pre_ins && pre_del && post_ins && post_del || lastEquality.length < this.Diff_EditCost / 2 && pre_ins + pre_del + post_ins + post_del == 3)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_DELETE, lastEquality));
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $20f03067c3b20090$var$DIFF_INSERT;
                equalitiesLength--; // Throw away the equality we just deleted;
                lastEquality = null;
                if (pre_ins && pre_del) {
                    // No changes made which could affect previous entry, keep going.
                    post_ins = post_del = true;
                    equalitiesLength = 0;
                } else {
                    equalitiesLength--; // Throw away the previous equality.
                    pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                    post_ins = post_del = false;
                }
                changes = true;
            }
        }
        pointer++;
    }
    if (changes) this.diff_cleanupMerge(diffs);
};
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_cleanupMerge = function(diffs) {
    // Add a dummy entry at the end.
    diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, ""));
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length)switch(diffs[pointer][0]){
        case $20f03067c3b20090$var$DIFF_INSERT:
            count_insert++;
            text_insert += diffs[pointer][1];
            pointer++;
            break;
        case $20f03067c3b20090$var$DIFF_DELETE:
            count_delete++;
            text_delete += diffs[pointer][1];
            pointer++;
            break;
        case $20f03067c3b20090$var$DIFF_EQUAL:
            // Upon reaching an equality, check for prior redundancies.
            if (count_delete + count_insert > 1) {
                if (count_delete !== 0 && count_insert !== 0) {
                    // Factor out any common prefixies.
                    commonlength = this.diff_commonPrefix(text_insert, text_delete);
                    if (commonlength !== 0) {
                        if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == $20f03067c3b20090$var$DIFF_EQUAL) diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                        else {
                            diffs.splice(0, 0, new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, text_insert.substring(0, commonlength)));
                            pointer++;
                        }
                        text_insert = text_insert.substring(commonlength);
                        text_delete = text_delete.substring(commonlength);
                    }
                    // Factor out any common suffixies.
                    commonlength = this.diff_commonSuffix(text_insert, text_delete);
                    if (commonlength !== 0) {
                        diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                        text_insert = text_insert.substring(0, text_insert.length - commonlength);
                        text_delete = text_delete.substring(0, text_delete.length - commonlength);
                    }
                }
                // Delete the offending records and add the merged ones.
                pointer -= count_delete + count_insert;
                diffs.splice(pointer, count_delete + count_insert);
                if (text_delete.length) {
                    diffs.splice(pointer, 0, new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_DELETE, text_delete));
                    pointer++;
                }
                if (text_insert.length) {
                    diffs.splice(pointer, 0, new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_INSERT, text_insert));
                    pointer++;
                }
                pointer++;
            } else if (pointer !== 0 && diffs[pointer - 1][0] == $20f03067c3b20090$var$DIFF_EQUAL) {
                // Merge this equality with the previous one.
                diffs[pointer - 1][1] += diffs[pointer][1];
                diffs.splice(pointer, 1);
            } else pointer++;
            count_insert = 0;
            count_delete = 0;
            text_delete = "";
            text_insert = "";
            break;
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $20f03067c3b20090$var$DIFF_EQUAL && diffs[pointer + 1][0] == $20f03067c3b20090$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) this.diff_cleanupMerge(diffs);
};
/**
 * loc is a location in text1, compute and return the equivalent location in
 * text2.
 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {number} loc Location within text1.
 * @return {number} Location within text2.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_xIndex = function(diffs, loc) {
    var chars1 = 0;
    var chars2 = 0;
    var last_chars1 = 0;
    var last_chars2 = 0;
    var x;
    for(x = 0; x < diffs.length; x++){
        if (diffs[x][0] !== $20f03067c3b20090$var$DIFF_INSERT) chars1 += diffs[x][1].length;
        if (diffs[x][0] !== $20f03067c3b20090$var$DIFF_DELETE) chars2 += diffs[x][1].length;
        if (chars1 > loc) break;
        last_chars1 = chars1;
        last_chars2 = chars2;
    }
    // Was the location was deleted?
    if (diffs.length != x && diffs[x][0] === $20f03067c3b20090$var$DIFF_DELETE) return last_chars2;
    // Add the remaining character length.
    return last_chars2 + (loc - last_chars1);
};
/**
 * Convert a diff array into a pretty HTML report.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} HTML representation.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_prettyHtml = function(diffs) {
    var html = [];
    var pattern_amp = /&/g;
    var pattern_lt = /</g;
    var pattern_gt = />/g;
    var pattern_para = /\n/g;
    for(var x = 0; x < diffs.length; x++){
        var op = diffs[x][0]; // Operation (insert, delete, equal)
        var data = diffs[x][1]; // Text of change.
        var text = data.replace(pattern_amp, "&amp;").replace(pattern_lt, "&lt;").replace(pattern_gt, "&gt;").replace(pattern_para, "&para;<br>");
        switch(op){
            case $20f03067c3b20090$var$DIFF_INSERT:
                html[x] = '<ins style="background:#e6ffe6;">' + text + "</ins>";
                break;
            case $20f03067c3b20090$var$DIFF_DELETE:
                html[x] = '<del style="background:#ffe6e6;">' + text + "</del>";
                break;
            case $20f03067c3b20090$var$DIFF_EQUAL:
                html[x] = "<span>" + text + "</span>";
                break;
        }
    }
    return html.join("");
};
/**
 * Compute and return the source text (all equalities and deletions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Source text.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_text1 = function(diffs) {
    var text = [];
    for(var x = 0; x < diffs.length; x++)if (diffs[x][0] !== $20f03067c3b20090$var$DIFF_INSERT) text[x] = diffs[x][1];
    return text.join("");
};
/**
 * Compute and return the destination text (all equalities and insertions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Destination text.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_text2 = function(diffs) {
    var text = [];
    for(var x = 0; x < diffs.length; x++)if (diffs[x][0] !== $20f03067c3b20090$var$DIFF_DELETE) text[x] = diffs[x][1];
    return text.join("");
};
/**
 * Compute the Levenshtein distance; the number of inserted, deleted or
 * substituted characters.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {number} Number of changes.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_levenshtein = function(diffs) {
    var levenshtein = 0;
    var insertions = 0;
    var deletions = 0;
    for(var x = 0; x < diffs.length; x++){
        var op = diffs[x][0];
        var data = diffs[x][1];
        switch(op){
            case $20f03067c3b20090$var$DIFF_INSERT:
                insertions += data.length;
                break;
            case $20f03067c3b20090$var$DIFF_DELETE:
                deletions += data.length;
                break;
            case $20f03067c3b20090$var$DIFF_EQUAL:
                // A deletion and an insertion is one substitution.
                levenshtein += Math.max(insertions, deletions);
                insertions = 0;
                deletions = 0;
                break;
        }
    }
    levenshtein += Math.max(insertions, deletions);
    return levenshtein;
};
/**
 * Crush the diff into an encoded string which describes the operations
 * required to transform text1 into text2.
 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Delta text.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_toDelta = function(diffs) {
    var text = [];
    for(var x = 0; x < diffs.length; x++)switch(diffs[x][0]){
        case $20f03067c3b20090$var$DIFF_INSERT:
            text[x] = "+" + encodeURI(diffs[x][1]);
            break;
        case $20f03067c3b20090$var$DIFF_DELETE:
            text[x] = "-" + diffs[x][1].length;
            break;
        case $20f03067c3b20090$var$DIFF_EQUAL:
            text[x] = "=" + diffs[x][1].length;
            break;
    }
    return text.join("	").replace(/%20/g, " ");
};
/**
 * Given the original text1, and an encoded string which describes the
 * operations required to transform text1 into text2, compute the full diff.
 * @param {string} text1 Source string for the diff.
 * @param {string} delta Delta text.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @throws {!Error} If invalid input.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.diff_fromDelta = function(text1, delta) {
    var diffs = [];
    var diffsLength = 0; // Keeping our own length var is faster in JS.
    var pointer = 0; // Cursor in text1
    var tokens = delta.split(/\t/g);
    for(var x = 0; x < tokens.length; x++){
        // Each token begins with a one character parameter which specifies the
        // operation of this token (delete, insert, equality).
        var param = tokens[x].substring(1);
        switch(tokens[x].charAt(0)){
            case "+":
                try {
                    diffs[diffsLength++] = new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_INSERT, decodeURI(param));
                } catch (ex) {
                    // Malformed URI sequence.
                    throw new Error("Illegal escape in diff_fromDelta: " + param);
                }
                break;
            case "-":
            // Fall through.
            case "=":
                var n = parseInt(param, 10);
                if (isNaN(n) || n < 0) throw new Error("Invalid number in diff_fromDelta: " + param);
                var text = text1.substring(pointer, pointer += n);
                if (tokens[x].charAt(0) == "=") diffs[diffsLength++] = new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, text);
                else diffs[diffsLength++] = new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_DELETE, text);
                break;
            default:
                // Blank tokens are ok (from a trailing \t).
                // Anything else is an error.
                if (tokens[x]) throw new Error("Invalid diff operation in diff_fromDelta: " + tokens[x]);
        }
    }
    if (pointer != text1.length) throw new Error("Delta length (" + pointer + ") does not equal source text length (" + text1.length + ").");
    return diffs;
};
//  MATCH FUNCTIONS
/**
 * Locate the best instance of 'pattern' in 'text' near 'loc'.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.match_main = function(text, pattern, loc) {
    // Check for null inputs.
    if (text == null || pattern == null || loc == null) throw new Error("Null input. (match_main)");
    loc = Math.max(0, Math.min(loc, text.length));
    if (text == pattern) // Shortcut (potentially not guaranteed by the algorithm)
    return 0;
    else if (!text.length) // Nothing to match.
    return -1;
    else if (text.substring(loc, loc + pattern.length) == pattern) // Perfect match at the perfect spot!  (Includes case of null pattern)
    return loc;
    else // Do a fuzzy compare.
    return this.match_bitap_(text, pattern, loc);
};
/**
 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
 * Bitap algorithm.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 * @private
 */ $20f03067c3b20090$var$diff_match_patch.prototype.match_bitap_ = function(text, pattern, loc) {
    if (pattern.length > this.Match_MaxBits) throw new Error("Pattern too long for this browser.");
    // Initialise the alphabet.
    var s = this.match_alphabet_(pattern);
    var dmp = this; // 'this' becomes 'window' in a closure.
    /**
   * Compute and return the score for a match with e errors and x location.
   * Accesses loc and pattern through being a closure.
   * @param {number} e Number of errors in match.
   * @param {number} x Location of match.
   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
   * @private
   */ function match_bitapScore_(e, x) {
        var accuracy = e / pattern.length;
        var proximity = Math.abs(loc - x);
        if (!dmp.Match_Distance) // Dodge divide by zero error.
        return proximity ? 1.0 : accuracy;
        return accuracy + proximity / dmp.Match_Distance;
    }
    // Highest score beyond which we give up.
    var score_threshold = this.Match_Threshold;
    // Is there a nearby exact match? (speedup)
    var best_loc = text.indexOf(pattern, loc);
    if (best_loc != -1) {
        score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
        // What about in the other direction? (speedup)
        best_loc = text.lastIndexOf(pattern, loc + pattern.length);
        if (best_loc != -1) score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
    }
    // Initialise the bit arrays.
    var matchmask = 1 << pattern.length - 1;
    best_loc = -1;
    var bin_min, bin_mid;
    var bin_max = pattern.length + text.length;
    var last_rd;
    for(var d = 0; d < pattern.length; d++){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from 'loc' we can stray at this
        // error level.
        bin_min = 0;
        bin_mid = bin_max;
        while(bin_min < bin_mid){
            if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) bin_min = bin_mid;
            else bin_max = bin_mid;
            bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
        }
        // Use the result from this iteration as the maximum for the next.
        bin_max = bin_mid;
        var start = Math.max(1, loc - bin_mid + 1);
        var finish = Math.min(loc + bin_mid, text.length) + pattern.length;
        var rd = Array(finish + 2);
        rd[finish + 1] = (1 << d) - 1;
        for(var j = finish; j >= start; j--){
            // The alphabet (s) is a sparse hash, so the following line generates
            // warnings.
            var charMatch = s[text.charAt(j - 1)];
            if (d === 0) rd[j] = (rd[j + 1] << 1 | 1) & charMatch;
            else rd[j] = (rd[j + 1] << 1 | 1) & charMatch | ((last_rd[j + 1] | last_rd[j]) << 1 | 1) | last_rd[j + 1];
            if (rd[j] & matchmask) {
                var score = match_bitapScore_(d, j - 1);
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (score <= score_threshold) {
                    // Told you so.
                    score_threshold = score;
                    best_loc = j - 1;
                    if (best_loc > loc) // When passing loc, don't exceed our current distance from loc.
                    start = Math.max(1, 2 * loc - best_loc);
                    else break;
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        if (match_bitapScore_(d + 1, loc) > score_threshold) break;
        last_rd = rd;
    }
    return best_loc;
};
/**
 * Initialise the alphabet for the Bitap algorithm.
 * @param {string} pattern The text to encode.
 * @return {!Object} Hash of character locations.
 * @private
 */ $20f03067c3b20090$var$diff_match_patch.prototype.match_alphabet_ = function(pattern) {
    var s = {};
    for(var i = 0; i < pattern.length; i++)s[pattern.charAt(i)] = 0;
    for(var i = 0; i < pattern.length; i++)s[pattern.charAt(i)] |= 1 << pattern.length - i - 1;
    return s;
};
//  PATCH FUNCTIONS
/**
 * Increase the context until it is unique,
 * but don't let the pattern expand beyond Match_MaxBits.
 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
 * @param {string} text Source text.
 * @private
 */ $20f03067c3b20090$var$diff_match_patch.prototype.patch_addContext_ = function(patch, text) {
    if (text.length == 0) return;
    if (patch.start2 === null) throw Error("patch not initialized");
    var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
    var padding = 0;
    // Look for the first and last matches of pattern in text.  If two different
    // matches are found, increase the pattern length.
    while(text.indexOf(pattern) != text.lastIndexOf(pattern) && pattern.length < this.Match_MaxBits - this.Patch_Margin - this.Patch_Margin){
        padding += this.Patch_Margin;
        pattern = text.substring(patch.start2 - padding, patch.start2 + patch.length1 + padding);
    }
    // Add one chunk for good luck.
    padding += this.Patch_Margin;
    // Add the prefix.
    var prefix = text.substring(patch.start2 - padding, patch.start2);
    if (prefix) patch.diffs.unshift(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, prefix));
    // Add the suffix.
    var suffix = text.substring(patch.start2 + patch.length1, patch.start2 + patch.length1 + padding);
    if (suffix) patch.diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, suffix));
    // Roll back the start points.
    patch.start1 -= prefix.length;
    patch.start2 -= prefix.length;
    // Extend the lengths.
    patch.length1 += prefix.length + suffix.length;
    patch.length2 += prefix.length + suffix.length;
};
/**
 * Compute a list of patches to turn text1 into text2.
 * Use diffs if provided, otherwise compute it ourselves.
 * There are four ways to call this function, depending on what data is
 * available to the caller:
 * Method 1:
 * a = text1, b = text2
 * Method 2:
 * a = diffs
 * Method 3 (optimal):
 * a = text1, b = diffs
 * Method 4 (deprecated, use method 3):
 * a = text1, b = text2, c = diffs
 *
 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
 * Array of diff tuples for text1 to text2 (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_b text2 (methods 1,4) or
 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_c Array of diff tuples
 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.patch_make = function(a, opt_b, opt_c) {
    var text1, diffs;
    if (typeof a == "string" && typeof opt_b == "string" && typeof opt_c == "undefined") {
        // Method 1: text1, text2
        // Compute diffs from text1 and text2.
        text1 = /** @type {string} */ a;
        diffs = this.diff_main(text1, /** @type {string} */ opt_b, true);
        if (diffs.length > 2) {
            this.diff_cleanupSemantic(diffs);
            this.diff_cleanupEfficiency(diffs);
        }
    } else if (a && typeof a == "object" && typeof opt_b == "undefined" && typeof opt_c == "undefined") {
        // Method 2: diffs
        // Compute text1 from diffs.
        diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ a;
        text1 = this.diff_text1(diffs);
    } else if (typeof a == "string" && opt_b && typeof opt_b == "object" && typeof opt_c == "undefined") {
        // Method 3: text1, diffs
        text1 = /** @type {string} */ a;
        diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ opt_b;
    } else if (typeof a == "string" && typeof opt_b == "string" && opt_c && typeof opt_c == "object") {
        // Method 4: text1, text2, diffs
        // text2 is not used.
        text1 = /** @type {string} */ a;
        diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ opt_c;
    } else throw new Error("Unknown call format to patch_make.");
    if (diffs.length === 0) return []; // Get rid of the null case.
    var patches = [];
    var patch = new $20f03067c3b20090$var$diff_match_patch.patch_obj();
    var patchDiffLength = 0; // Keeping our own length var is faster in JS.
    var char_count1 = 0; // Number of characters into the text1 string.
    var char_count2 = 0; // Number of characters into the text2 string.
    // Start with text1 (prepatch_text) and apply the diffs until we arrive at
    // text2 (postpatch_text).  We recreate the patches one by one to determine
    // context info.
    var prepatch_text = text1;
    var postpatch_text = text1;
    for(var x = 0; x < diffs.length; x++){
        var diff_type = diffs[x][0];
        var diff_text = diffs[x][1];
        if (!patchDiffLength && diff_type !== $20f03067c3b20090$var$DIFF_EQUAL) {
            // A new patch starts here.
            patch.start1 = char_count1;
            patch.start2 = char_count2;
        }
        switch(diff_type){
            case $20f03067c3b20090$var$DIFF_INSERT:
                patch.diffs[patchDiffLength++] = diffs[x];
                patch.length2 += diff_text.length;
                postpatch_text = postpatch_text.substring(0, char_count2) + diff_text + postpatch_text.substring(char_count2);
                break;
            case $20f03067c3b20090$var$DIFF_DELETE:
                patch.length1 += diff_text.length;
                patch.diffs[patchDiffLength++] = diffs[x];
                postpatch_text = postpatch_text.substring(0, char_count2) + postpatch_text.substring(char_count2 + diff_text.length);
                break;
            case $20f03067c3b20090$var$DIFF_EQUAL:
                if (diff_text.length <= 2 * this.Patch_Margin && patchDiffLength && diffs.length != x + 1) {
                    // Small equality inside a patch.
                    patch.diffs[patchDiffLength++] = diffs[x];
                    patch.length1 += diff_text.length;
                    patch.length2 += diff_text.length;
                } else if (diff_text.length >= 2 * this.Patch_Margin) // Time for a new patch.
                {
                    if (patchDiffLength) {
                        this.patch_addContext_(patch, prepatch_text);
                        patches.push(patch);
                        patch = new $20f03067c3b20090$var$diff_match_patch.patch_obj();
                        patchDiffLength = 0;
                        // Unlike Unidiff, our patch lists have a rolling context.
                        // https://github.com/google/diff-match-patch/wiki/Unidiff
                        // Update prepatch text & pos to reflect the application of the
                        // just completed patch.
                        prepatch_text = postpatch_text;
                        char_count1 = char_count2;
                    }
                }
                break;
        }
        // Update the current character count.
        if (diff_type !== $20f03067c3b20090$var$DIFF_INSERT) char_count1 += diff_text.length;
        if (diff_type !== $20f03067c3b20090$var$DIFF_DELETE) char_count2 += diff_text.length;
    }
    // Pick up the leftover patch if not empty.
    if (patchDiffLength) {
        this.patch_addContext_(patch, prepatch_text);
        patches.push(patch);
    }
    return patches;
};
/**
 * Given an array of patches, return another array that is identical.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.patch_deepCopy = function(patches) {
    // Making deep copies is hard in JavaScript.
    var patchesCopy = [];
    for(var x = 0; x < patches.length; x++){
        var patch = patches[x];
        var patchCopy = new $20f03067c3b20090$var$diff_match_patch.patch_obj();
        patchCopy.diffs = [];
        for(var y = 0; y < patch.diffs.length; y++)patchCopy.diffs[y] = new $20f03067c3b20090$var$diff_match_patch.Diff(patch.diffs[y][0], patch.diffs[y][1]);
        patchCopy.start1 = patch.start1;
        patchCopy.start2 = patch.start2;
        patchCopy.length1 = patch.length1;
        patchCopy.length2 = patch.length2;
        patchesCopy[x] = patchCopy;
    }
    return patchesCopy;
};
/**
 * Merge a set of patches onto the text.  Return a patched text, as well
 * as a list of true/false values indicating which patches were applied.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @param {string} text Old text.
 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
 *      new text and an array of boolean values.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.patch_apply = function(patches, text) {
    if (patches.length == 0) return [
        text,
        []
    ];
    // Deep copy the patches so that no changes are made to originals.
    patches = this.patch_deepCopy(patches);
    var nullPadding = this.patch_addPadding(patches);
    text = nullPadding + text + nullPadding;
    this.patch_splitMax(patches);
    // delta keeps track of the offset between the expected and actual location
    // of the previous patch.  If there are patches expected at positions 10 and
    // 20, but the first patch was found at 12, delta is 2 and the second patch
    // has an effective expected position of 22.
    var delta = 0;
    var results = [];
    for(var x = 0; x < patches.length; x++){
        var expected_loc = patches[x].start2 + delta;
        var text1 = this.diff_text1(patches[x].diffs);
        var start_loc;
        var end_loc = -1;
        if (text1.length > this.Match_MaxBits) {
            // patch_splitMax will only provide an oversized pattern in the case of
            // a monster delete.
            start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits), expected_loc);
            if (start_loc != -1) {
                end_loc = this.match_main(text, text1.substring(text1.length - this.Match_MaxBits), expected_loc + text1.length - this.Match_MaxBits);
                if (end_loc == -1 || start_loc >= end_loc) // Can't find valid trailing context.  Drop this patch.
                start_loc = -1;
            }
        } else start_loc = this.match_main(text, text1, expected_loc);
        if (start_loc == -1) {
            // No match found.  :(
            results[x] = false;
            // Subtract the delta for this failed patch from subsequent patches.
            delta -= patches[x].length2 - patches[x].length1;
        } else {
            // Found a match.  :)
            results[x] = true;
            delta = start_loc - expected_loc;
            var text2;
            if (end_loc == -1) text2 = text.substring(start_loc, start_loc + text1.length);
            else text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
            if (text1 == text2) // Perfect match, just shove the replacement text in.
            text = text.substring(0, start_loc) + this.diff_text2(patches[x].diffs) + text.substring(start_loc + text1.length);
            else {
                // Imperfect match.  Run a diff to get a framework of equivalent
                // indices.
                var diffs = this.diff_main(text1, text2, false);
                if (text1.length > this.Match_MaxBits && this.diff_levenshtein(diffs) / text1.length > this.Patch_DeleteThreshold) // The end points match, but the content is unacceptably bad.
                results[x] = false;
                else {
                    this.diff_cleanupSemanticLossless(diffs);
                    var index1 = 0;
                    var index2;
                    for(var y = 0; y < patches[x].diffs.length; y++){
                        var mod = patches[x].diffs[y];
                        if (mod[0] !== $20f03067c3b20090$var$DIFF_EQUAL) index2 = this.diff_xIndex(diffs, index1);
                        if (mod[0] === $20f03067c3b20090$var$DIFF_INSERT) text = text.substring(0, start_loc + index2) + mod[1] + text.substring(start_loc + index2);
                        else if (mod[0] === $20f03067c3b20090$var$DIFF_DELETE) text = text.substring(0, start_loc + index2) + text.substring(start_loc + this.diff_xIndex(diffs, index1 + mod[1].length));
                        if (mod[0] !== $20f03067c3b20090$var$DIFF_DELETE) index1 += mod[1].length;
                    }
                }
            }
        }
    }
    // Strip the padding off.
    text = text.substring(nullPadding.length, text.length - nullPadding.length);
    return [
        text,
        results
    ];
};
/**
 * Add some padding on text start and end so that edges can match something.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} The padding string added to each side.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.patch_addPadding = function(patches) {
    var paddingLength = this.Patch_Margin;
    var nullPadding = "";
    for(var x = 1; x <= paddingLength; x++)nullPadding += String.fromCharCode(x);
    // Bump all the patches forward.
    for(var x = 0; x < patches.length; x++){
        patches[x].start1 += paddingLength;
        patches[x].start2 += paddingLength;
    }
    // Add some padding on start of first diff.
    var patch = patches[0];
    var diffs = patch.diffs;
    if (diffs.length == 0 || diffs[0][0] != $20f03067c3b20090$var$DIFF_EQUAL) {
        // Add nullPadding equality.
        diffs.unshift(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, nullPadding));
        patch.start1 -= paddingLength; // Should be 0.
        patch.start2 -= paddingLength; // Should be 0.
        patch.length1 += paddingLength;
        patch.length2 += paddingLength;
    } else if (paddingLength > diffs[0][1].length) {
        // Grow first equality.
        var extraLength = paddingLength - diffs[0][1].length;
        diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
        patch.start1 -= extraLength;
        patch.start2 -= extraLength;
        patch.length1 += extraLength;
        patch.length2 += extraLength;
    }
    // Add some padding on end of last diff.
    patch = patches[patches.length - 1];
    diffs = patch.diffs;
    if (diffs.length == 0 || diffs[diffs.length - 1][0] != $20f03067c3b20090$var$DIFF_EQUAL) {
        // Add nullPadding equality.
        diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, nullPadding));
        patch.length1 += paddingLength;
        patch.length2 += paddingLength;
    } else if (paddingLength > diffs[diffs.length - 1][1].length) {
        // Grow last equality.
        var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
        diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
        patch.length1 += extraLength;
        patch.length2 += extraLength;
    }
    return nullPadding;
};
/**
 * Look through the patches and break up any which are longer than the maximum
 * limit of the match algorithm.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.patch_splitMax = function(patches) {
    var patch_size = this.Match_MaxBits;
    for(var x = 0; x < patches.length; x++){
        if (patches[x].length1 <= patch_size) continue;
        var bigpatch = patches[x];
        // Remove the big old patch.
        patches.splice(x--, 1);
        var start1 = bigpatch.start1;
        var start2 = bigpatch.start2;
        var precontext = "";
        while(bigpatch.diffs.length !== 0){
            // Create one of several smaller patches.
            var patch = new $20f03067c3b20090$var$diff_match_patch.patch_obj();
            var empty = true;
            patch.start1 = start1 - precontext.length;
            patch.start2 = start2 - precontext.length;
            if (precontext !== "") {
                patch.length1 = patch.length2 = precontext.length;
                patch.diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, precontext));
            }
            while(bigpatch.diffs.length !== 0 && patch.length1 < patch_size - this.Patch_Margin){
                var diff_type = bigpatch.diffs[0][0];
                var diff_text = bigpatch.diffs[0][1];
                if (diff_type === $20f03067c3b20090$var$DIFF_INSERT) {
                    // Insertions are harmless.
                    patch.length2 += diff_text.length;
                    start2 += diff_text.length;
                    patch.diffs.push(bigpatch.diffs.shift());
                    empty = false;
                } else if (diff_type === $20f03067c3b20090$var$DIFF_DELETE && patch.diffs.length == 1 && patch.diffs[0][0] == $20f03067c3b20090$var$DIFF_EQUAL && diff_text.length > 2 * patch_size) {
                    // This is a large deletion.  Let it pass in one chunk.
                    patch.length1 += diff_text.length;
                    start1 += diff_text.length;
                    empty = false;
                    patch.diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff(diff_type, diff_text));
                    bigpatch.diffs.shift();
                } else {
                    // Deletion or equality.  Only take as much as we can stomach.
                    diff_text = diff_text.substring(0, patch_size - patch.length1 - this.Patch_Margin);
                    patch.length1 += diff_text.length;
                    start1 += diff_text.length;
                    if (diff_type === $20f03067c3b20090$var$DIFF_EQUAL) {
                        patch.length2 += diff_text.length;
                        start2 += diff_text.length;
                    } else empty = false;
                    patch.diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff(diff_type, diff_text));
                    if (diff_text == bigpatch.diffs[0][1]) bigpatch.diffs.shift();
                    else bigpatch.diffs[0][1] = bigpatch.diffs[0][1].substring(diff_text.length);
                }
            }
            // Compute the head context for the next patch.
            precontext = this.diff_text2(patch.diffs);
            precontext = precontext.substring(precontext.length - this.Patch_Margin);
            // Append the end context for this patch.
            var postcontext = this.diff_text1(bigpatch.diffs).substring(0, this.Patch_Margin);
            if (postcontext !== "") {
                patch.length1 += postcontext.length;
                patch.length2 += postcontext.length;
                if (patch.diffs.length !== 0 && patch.diffs[patch.diffs.length - 1][0] === $20f03067c3b20090$var$DIFF_EQUAL) patch.diffs[patch.diffs.length - 1][1] += postcontext;
                else patch.diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, postcontext));
            }
            if (!empty) patches.splice(++x, 0, patch);
        }
    }
};
/**
 * Take a list of patches and return a textual representation.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} Text representation of patches.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.patch_toText = function(patches) {
    var text = [];
    for(var x = 0; x < patches.length; x++)text[x] = patches[x];
    return text.join("");
};
/**
 * Parse a textual representation of patches and return a list of Patch objects.
 * @param {string} textline Text representation of patches.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 * @throws {!Error} If invalid input.
 */ $20f03067c3b20090$var$diff_match_patch.prototype.patch_fromText = function(textline) {
    var patches = [];
    if (!textline) return patches;
    var text = textline.split("\n");
    var textPointer = 0;
    var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
    while(textPointer < text.length){
        var m = text[textPointer].match(patchHeader);
        if (!m) throw new Error("Invalid patch string: " + text[textPointer]);
        var patch = new $20f03067c3b20090$var$diff_match_patch.patch_obj();
        patches.push(patch);
        patch.start1 = parseInt(m[1], 10);
        if (m[2] === "") {
            patch.start1--;
            patch.length1 = 1;
        } else if (m[2] == "0") patch.length1 = 0;
        else {
            patch.start1--;
            patch.length1 = parseInt(m[2], 10);
        }
        patch.start2 = parseInt(m[3], 10);
        if (m[4] === "") {
            patch.start2--;
            patch.length2 = 1;
        } else if (m[4] == "0") patch.length2 = 0;
        else {
            patch.start2--;
            patch.length2 = parseInt(m[4], 10);
        }
        textPointer++;
        while(textPointer < text.length){
            var sign = text[textPointer].charAt(0);
            try {
                var line = decodeURI(text[textPointer].substring(1));
            } catch (ex) {
                // Malformed URI sequence.
                throw new Error("Illegal escape in patch_fromText: " + line);
            }
            if (sign == "-") // Deletion.
            patch.diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_DELETE, line));
            else if (sign == "+") // Insertion.
            patch.diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_INSERT, line));
            else if (sign == " ") // Minor equality.
            patch.diffs.push(new $20f03067c3b20090$var$diff_match_patch.Diff($20f03067c3b20090$var$DIFF_EQUAL, line));
            else if (sign == "@") break;
            else if (sign === "") ;
            else // WTF?
            throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
            textPointer++;
        }
    }
    return patches;
};
/**
 * Class representing one patch operation.
 * @constructor
 */ $20f03067c3b20090$var$diff_match_patch.patch_obj = function() {
    /** @type {!Array.<!diff_match_patch.Diff>} */ this.diffs = [];
    /** @type {?number} */ this.start1 = null;
    /** @type {?number} */ this.start2 = null;
    /** @type {number} */ this.length1 = 0;
    /** @type {number} */ this.length2 = 0;
};
/**
 * Emulate GNU diff's format.
 * Header: @@ -382,8 +481,9 @@
 * Indices are printed as 1-based, not 0-based.
 * @return {string} The GNU diff string.
 */ $20f03067c3b20090$var$diff_match_patch.patch_obj.prototype.toString = function() {
    var coords1, coords2;
    if (this.length1 === 0) coords1 = this.start1 + ",0";
    else if (this.length1 == 1) coords1 = this.start1 + 1;
    else coords1 = this.start1 + 1 + "," + this.length1;
    if (this.length2 === 0) coords2 = this.start2 + ",0";
    else if (this.length2 == 1) coords2 = this.start2 + 1;
    else coords2 = this.start2 + 1 + "," + this.length2;
    var text = [
        "@@ -" + coords1 + " +" + coords2 + " @@\n"
    ];
    var op;
    // Escape the body of the patch with %xx notation.
    for(var x = 0; x < this.diffs.length; x++){
        switch(this.diffs[x][0]){
            case $20f03067c3b20090$var$DIFF_INSERT:
                op = "+";
                break;
            case $20f03067c3b20090$var$DIFF_DELETE:
                op = "-";
                break;
            case $20f03067c3b20090$var$DIFF_EQUAL:
                op = " ";
                break;
        }
        text[x + 1] = op + encodeURI(this.diffs[x][1]) + "\n";
    }
    return text.join("").replace(/%20/g, " ");
};
// The following export code was added by @ForbesLindesay
$20f03067c3b20090$exports = $20f03067c3b20090$var$diff_match_patch;
$20f03067c3b20090$exports["diff_match_patch"] = $20f03067c3b20090$var$diff_match_patch;
$20f03067c3b20090$exports["DIFF_DELETE"] = $20f03067c3b20090$var$DIFF_DELETE;
$20f03067c3b20090$exports["DIFF_INSERT"] = $20f03067c3b20090$var$DIFF_INSERT;
$20f03067c3b20090$exports["DIFF_EQUAL"] = $20f03067c3b20090$var$DIFF_EQUAL;


var $32c89919e477b311$var$DiffComponent = /** @class */ function(_super) {
    $32c89919e477b311$var$__extends(DiffComponent, _super);
    function DiffComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: _this.props.value
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.diff = _this.diff.bind(_this);
        return _this;
    }
    DiffComponent.prototype.componentDidUpdate = function() {
        var value = this.props.value;
        if (value !== this.state.value) this.setState({
            value: value
        });
    };
    DiffComponent.prototype.onChange = function(value) {
        this.setState({
            value: value
        });
        if (this.props.onChange) this.props.onChange(value);
    };
    DiffComponent.prototype.diff = function() {
        var dmp = new $20f03067c3b20090$exports();
        var lhString = this.state.value[0];
        var rhString = this.state.value[1];
        if (lhString.length === 0 && rhString.length === 0) return [];
        var diff = dmp.diff_main(lhString, rhString);
        dmp.diff_cleanupSemantic(diff);
        var diffedLines = this.generateDiffedLines(diff);
        var codeEditorSettings = this.setCodeMarkers(diffedLines);
        return codeEditorSettings;
    };
    DiffComponent.prototype.generateDiffedLines = function(diff) {
        var C = {
            DIFF_EQUAL: 0,
            DIFF_DELETE: -1,
            DIFF_INSERT: 1
        };
        var diffedLines = {
            left: [],
            right: []
        };
        var cursor = {
            left: 1,
            right: 1
        };
        diff.forEach(function(chunk) {
            var chunkType = chunk[0];
            var text = chunk[1];
            var lines = text.split("\n").length - 1;
            // diff-match-patch sometimes returns empty strings at random
            if (text.length === 0) return;
            var firstChar = text[0];
            var lastChar = text[text.length - 1];
            var linesToHighlight = 0;
            switch(chunkType){
                case C.DIFF_EQUAL:
                    cursor.left += lines;
                    cursor.right += lines;
                    break;
                case C.DIFF_DELETE:
                    // If the deletion starts with a newline, push the cursor down to that line
                    if (firstChar === "\n") {
                        cursor.left++;
                        lines--;
                    }
                    linesToHighlight = lines;
                    // If the deletion does not include a newline, highlight the same line on the right
                    if (linesToHighlight === 0) diffedLines.right.push({
                        startLine: cursor.right,
                        endLine: cursor.right
                    });
                    // If the last character is a newline, we don't want to highlight that line
                    if (lastChar === "\n") linesToHighlight -= 1;
                    diffedLines.left.push({
                        startLine: cursor.left,
                        endLine: cursor.left + linesToHighlight
                    });
                    cursor.left += lines;
                    break;
                case C.DIFF_INSERT:
                    // If the insertion starts with a newline, push the cursor down to that line
                    if (firstChar === "\n") {
                        cursor.right++;
                        lines--;
                    }
                    linesToHighlight = lines;
                    // If the insertion does not include a newline, highlight the same line on the left
                    if (linesToHighlight === 0) diffedLines.left.push({
                        startLine: cursor.left,
                        endLine: cursor.left
                    });
                    // If the last character is a newline, we don't want to highlight that line
                    if (lastChar === "\n") linesToHighlight -= 1;
                    diffedLines.right.push({
                        startLine: cursor.right,
                        endLine: cursor.right + linesToHighlight
                    });
                    cursor.right += lines;
                    break;
                default:
                    throw new Error("Diff type was not defined.");
            }
        });
        return diffedLines;
    };
    // Receives a collection of line numbers and iterates through them to highlight appropriately
    // Returns an object that tells the render() method how to display the code editors
    DiffComponent.prototype.setCodeMarkers = function(diffedLines) {
        if (diffedLines === void 0) diffedLines = {
            left: [],
            right: []
        };
        var codeEditorSettings = [];
        var newMarkerSet = {
            left: [],
            right: []
        };
        for(var i = 0; i < diffedLines.left.length; i++){
            var markerObj = {
                startRow: diffedLines.left[i].startLine - 1,
                endRow: diffedLines.left[i].endLine,
                type: "text",
                className: "codeMarker"
            };
            newMarkerSet.left.push(markerObj);
        }
        for(var i = 0; i < diffedLines.right.length; i++){
            var markerObj = {
                startRow: diffedLines.right[i].startLine - 1,
                endRow: diffedLines.right[i].endLine,
                type: "text",
                className: "codeMarker"
            };
            newMarkerSet.right.push(markerObj);
        }
        codeEditorSettings[0] = newMarkerSet.left;
        codeEditorSettings[1] = newMarkerSet.right;
        return codeEditorSettings;
    };
    DiffComponent.prototype.render = function() {
        var markers = this.diff();
        return $acw62.createElement($5841f702271ba066$exports.default, {
            name: this.props.name,
            className: this.props.className,
            focus: this.props.focus,
            orientation: this.props.orientation,
            splits: this.props.splits,
            mode: this.props.mode,
            theme: this.props.theme,
            height: this.props.height,
            width: this.props.width,
            fontSize: this.props.fontSize,
            showGutter: this.props.showGutter,
            onChange: this.onChange,
            onPaste: this.props.onPaste,
            onLoad: this.props.onLoad,
            onScroll: this.props.onScroll,
            minLines: this.props.minLines,
            maxLines: this.props.maxLines,
            readOnly: this.props.readOnly,
            highlightActiveLine: this.props.highlightActiveLine,
            showPrintMargin: this.props.showPrintMargin,
            tabSize: this.props.tabSize,
            cursorStart: this.props.cursorStart,
            editorProps: this.props.editorProps,
            style: this.props.style,
            scrollMargin: this.props.scrollMargin,
            setOptions: this.props.setOptions,
            wrapEnabled: this.props.wrapEnabled,
            enableBasicAutocompletion: this.props.enableBasicAutocompletion,
            enableLiveAutocompletion: this.props.enableLiveAutocompletion,
            value: this.state.value,
            markers: markers
        });
    };
    DiffComponent.propTypes = {
        cursorStart: $8da5bfbbed271cd7$exports.number,
        editorProps: $8da5bfbbed271cd7$exports.object,
        enableBasicAutocompletion: $8da5bfbbed271cd7$exports.bool,
        enableLiveAutocompletion: $8da5bfbbed271cd7$exports.bool,
        focus: $8da5bfbbed271cd7$exports.bool,
        fontSize: $8da5bfbbed271cd7$exports.number,
        height: $8da5bfbbed271cd7$exports.string,
        highlightActiveLine: $8da5bfbbed271cd7$exports.bool,
        maxLines: $8da5bfbbed271cd7$exports.number,
        minLines: $8da5bfbbed271cd7$exports.number,
        mode: $8da5bfbbed271cd7$exports.string,
        name: $8da5bfbbed271cd7$exports.string,
        className: $8da5bfbbed271cd7$exports.string,
        onLoad: $8da5bfbbed271cd7$exports.func,
        onPaste: $8da5bfbbed271cd7$exports.func,
        onScroll: $8da5bfbbed271cd7$exports.func,
        onChange: $8da5bfbbed271cd7$exports.func,
        orientation: $8da5bfbbed271cd7$exports.string,
        readOnly: $8da5bfbbed271cd7$exports.bool,
        scrollMargin: $8da5bfbbed271cd7$exports.array,
        setOptions: $8da5bfbbed271cd7$exports.object,
        showGutter: $8da5bfbbed271cd7$exports.bool,
        showPrintMargin: $8da5bfbbed271cd7$exports.bool,
        splits: $8da5bfbbed271cd7$exports.number,
        style: $8da5bfbbed271cd7$exports.object,
        tabSize: $8da5bfbbed271cd7$exports.number,
        theme: $8da5bfbbed271cd7$exports.string,
        value: $8da5bfbbed271cd7$exports.array,
        width: $8da5bfbbed271cd7$exports.string,
        wrapEnabled: $8da5bfbbed271cd7$exports.bool
    };
    DiffComponent.defaultProps = {
        cursorStart: 1,
        editorProps: {},
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        focus: false,
        fontSize: 12,
        height: "500px",
        highlightActiveLine: true,
        maxLines: null,
        minLines: null,
        mode: "",
        name: "ace-editor",
        onLoad: null,
        onScroll: null,
        onPaste: null,
        onChange: null,
        orientation: "beside",
        readOnly: false,
        scrollMargin: [
            0,
            0,
            0,
            0
        ],
        setOptions: {},
        showGutter: true,
        showPrintMargin: true,
        splits: 2,
        style: {},
        tabSize: 4,
        theme: "github",
        value: [
            "",
            ""
        ],
        width: "500px",
        wrapEnabled: true
    };
    return DiffComponent;
}($acw62.Component);
$32c89919e477b311$exports.default = $32c89919e477b311$var$DiffComponent;


$6d44855cf5e6d843$exports.diff = $32c89919e477b311$exports.default;

$6d44855cf5e6d843$exports.split = $5841f702271ba066$exports.default;
$6d44855cf5e6d843$exports.default = $4cb8d279e2475fd3$exports.default;


parcelRequire("9ZTTk");
parcelRequire("6838E");
parcelRequire("7OnGR");
const $cabde9ceb3c50af9$export$7cda8d932e2f33c0 = ({ value: value , onChange: onChange , readOnly: readOnly = false  })=>{
    const [theme, setTheme] = (0, $acw62.useState)("github"); // Default to light theme
    const [bgColor, setBgColor] = (0, $acw62.useState)("white"); // Default to light theme
    (0, $acw62.useEffect)(()=>{
        // Check the user's preference
        const prefersDarkMode = window.matchMedia("(prefers-color-scheme: dark)");
        // Set the theme based on the preference
        setTheme(prefersDarkMode.matches ? "monokai" : "github");
        setBgColor(prefersDarkMode.matches ? "#222222" : "white");
        // Add an event listener to update the theme if the preference changes
        const handleChange = (e)=>{
            setTheme(e.matches ? "monokai" : "github");
            setBgColor(e.matches ? "#222222" : "white");
        };
        prefersDarkMode.addEventListener("change", handleChange);
        // Clean up the event listener on unmount
        return ()=>{
            prefersDarkMode.removeEventListener("change", handleChange);
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6d44855cf5e6d843$exports))), {
        mode: "typescript",
        theme: theme,
        name: "editor",
        value: value,
        onChange: readOnly ? undefined : onChange,
        fontSize: 18,
        width: "100%",
        height: "100%",
        readOnly: readOnly,
        setOptions: {
            enableBasicAutocompletion: !readOnly,
            enableLiveAutocompletion: !readOnly,
            enableSnippets: !readOnly,
            showLineNumbers: true,
            tabSize: 2
        },
        style: {
            flex: "1 0 auto",
            width: "auto",
            height: "auto",
            backgroundColor: bgColor
        }
    });
};



const $cd93687958c8007e$var$CODE_STORE = (0, $35d1461156b98374$export$d0f8f2aad94d6297)("CODE_STORE");
const $cd93687958c8007e$var$FORM_CODE = $cd93687958c8007e$var$CODE_STORE.read("FORM_CODE");
const $cd93687958c8007e$var$TYPE_SELECTION = $cd93687958c8007e$var$CODE_STORE.read("TYPE_SELECTION");
const $cd93687958c8007e$var$FORM_VALUE = $cd93687958c8007e$var$CODE_STORE.read("FORM_VALUE");
const $cd93687958c8007e$var$HelperTypeMap = (0, $7c840cbf87483d1a$export$e2bd4b8ca669449c)((0, (/*@__PURE__*/$parcel$interopDefault($8001679a17388a1f$exports))));
const $cd93687958c8007e$var$HelperTypeList = Object.keys($cd93687958c8007e$var$HelperTypeMap);
const $cd93687958c8007e$var$LogoImage = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).img`
  flex: 0 0 auto;
  height: 3em;
  border-radius: var(--border-radius);
`;
const $cd93687958c8007e$var$GlobalStyle = (0, $f8dbcd8598db1f0b$export$f0f03736edb61697)`
  html,
  body {
    margin: 0;
    width: 100vw;
    height: 100vh;
  }

  input,
  label,
  button {
    margin-bottom: 0;
  }

  input[type="checkbox"] {
    margin-bottom: -0.5em;
  }
`;
const $cd93687958c8007e$var$AppBase = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  gap: 1em;

  width: 100vw;
  height: 100vh;

  box-sizing: border-box;
  padding: 1em;

  overflow: hidden;

  ${(0, $23ddcd9d8c50ffa9$export$14faa19a0f3bbeb2)}
`;
const $cd93687958c8007e$var$HeaderBox = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: center;
  gap: 1em;
`;
const $cd93687958c8007e$var$AppBody = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 1 1 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: stretch;
  align-items: stretch;
  box-sizing: border-box;
  gap: 1em;
  overflow: hidden;
`;
const $cd93687958c8007e$var$StackBox = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  gap: 1em;
  overflow: auto;
  width: auto;
  height: auto;
`;
const $cd93687958c8007e$var$TopStackBox = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($cd93687958c8007e$var$StackBox)`
  justify-content: flex-start;
`;
const $cd93687958c8007e$var$StackBoxRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($cd93687958c8007e$var$StackBox)`
  flex-direction: row;
`;
const $cd93687958c8007e$var$StackBoxControls = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($cd93687958c8007e$var$StackBoxRow)`
  flex: 0 0 auto;
`;
const $cd93687958c8007e$var$ControlButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  flex: 1 0 auto;
  padding: 0.25em;
`;
const $cd93687958c8007e$export$86fbec116b87613f = ()=>{
    const [value, setValueInternal] = (0, $acw62.useState)($cd93687958c8007e$var$FORM_VALUE);
    const setValue = (0, $acw62.useCallback)((newValue)=>{
        $cd93687958c8007e$var$CODE_STORE.create("FORM_VALUE", newValue);
        setValueInternal(newValue);
    }, []);
    const [typeScript, setTypeScriptInternal] = (0, $acw62.useState)($cd93687958c8007e$var$FORM_CODE);
    const setTypeScript = (0, $acw62.useCallback)((newValue)=>{
        $cd93687958c8007e$var$CODE_STORE.create("FORM_CODE", newValue);
        setTypeScriptInternal(newValue);
    }, []);
    const typeStructureMap = (0, $acw62.useMemo)(()=>{
        try {
            return (0, $7c840cbf87483d1a$export$e2bd4b8ca669449c)(`
        ${(0, (/*@__PURE__*/$parcel$interopDefault($8001679a17388a1f$exports)))}
        
        ${typeScript}
      `);
        } catch (e) {
            return {};
        }
    }, [
        typeScript
    ]);
    const [showingHelperTypes, setShowingHelperTypes] = (0, $acw62.useState)(false);
    const onShowHelperTypes = (0, $acw62.useCallback)(()=>{
        setShowingHelperTypes(true);
    }, []);
    const onHideHelperTypes = (0, $acw62.useCallback)(()=>{
        setShowingHelperTypes(false);
    }, []);
    const typeList = (0, $acw62.useMemo)(()=>Object.keys(typeStructureMap), [
        typeStructureMap
    ]);
    const userOnlyTypes = (0, $acw62.useMemo)(()=>typeList.filter((type)=>!$cd93687958c8007e$var$HelperTypeList.includes(type)), [
        typeList
    ]);
    const [selectedType, setSelectedTypeInternal] = (0, $acw62.useState)($cd93687958c8007e$var$TYPE_SELECTION);
    const setSelectedType = (0, $acw62.useCallback)((newValue)=>{
        $cd93687958c8007e$var$CODE_STORE.create("TYPE_SELECTION", newValue);
        setSelectedTypeInternal(newValue);
    }, []);
    const hasSelectedType = (0, $acw62.useMemo)(()=>typeList.length > 0 && !!selectedType && typeList.includes(selectedType), [
        typeList,
        selectedType
    ]);
    const onSelectedTypeChange = (0, $acw62.useCallback)(({ target: { value: newValue = ""  }  })=>{
        setSelectedType(newValue);
        setValue(undefined);
    }, [
        setSelectedType,
        setValue
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cd93687958c8007e$var$AppBase, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$GlobalStyle, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$HeaderBox, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$LogoImage, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9f7fbaa73a3474ff$exports))),
                    title: "Voltra"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cd93687958c8007e$var$AppBody, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cd93687958c8007e$var$StackBox, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                children: [
                                    "IMPORTANT: Only types with the ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                        children: "export"
                                    }),
                                    " keyword are available for selection."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cd93687958c8007e$var$StackBox, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cd93687958c8007e$var$StackBoxControls, {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$ControlButton, {
                                                className: !showingHelperTypes ? "outline" : "secondary outline",
                                                onClick: onHideHelperTypes,
                                                children: "Code"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$ControlButton, {
                                                className: showingHelperTypes ? "outline" : "secondary outline",
                                                onClick: onShowHelperTypes,
                                                children: "Available Helper Types"
                                            })
                                        ]
                                    }),
                                    !showingHelperTypes ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cabde9ceb3c50af9$export$7cda8d932e2f33c0), {
                                        value: typeScript,
                                        onChange: setTypeScript
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cabde9ceb3c50af9$export$7cda8d932e2f33c0), {
                                        value: (0, (/*@__PURE__*/$parcel$interopDefault($8001679a17388a1f$exports))),
                                        readOnly: true
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($cd93687958c8007e$var$TopStackBox, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: selectedType,
                                onChange: onSelectedTypeChange,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "",
                                        children: "Select a type"
                                    }),
                                    userOnlyTypes.map((type)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: type,
                                            onClick: ()=>setSelectedType(type),
                                            children: type
                                        }, type))
                                ]
                            }),
                            hasSelectedType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f15f48eca4c2f0$export$16975c34e60e1e61), {
                                typeStructureMap: typeStructureMap,
                                value: value,
                                entryType: selectedType,
                                onChange: setValue
                            }) : undefined
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                            children: JSON.stringify(value, null, 2)
                        })
                    })
                ]
            })
        ]
    });
};


const $70fc9a727fa662ae$var$reactRoot = document.getElementById("react-root");
if ($70fc9a727fa662ae$var$reactRoot) (0, $7e96a608cb33bf79$export$882461b6382ed46c)($70fc9a727fa662ae$var$reactRoot).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.353c423b.js.map
